var v8 = Object.defineProperty;
var B8 = (r, e, s) => e in r ? v8(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s;
var Qt = (r, e, s) => (B8(r, typeof e != "symbol" ? e + "" : e, s), s);
import require$$0$3, { forwardRef, useState, useEffect, useImperativeHandle, useRef } from "react";
class Draw2D {
  constructor(e) {
    Qt(this, "canvas");
    Qt(this, "surface");
    Qt(this, "drawables");
    Qt(this, "imageCache");
    this.canvas = e, this.surface = this.canvas.getContext("2d"), this.drawables = /* @__PURE__ */ new Set(), this.imageCache = /* @__PURE__ */ new Map();
  }
  /**
   * Draw a rectangle
   *
   * @param rect
   */
  drawRect(e) {
    if (this.surface === null)
      return;
    const { color: s, opacity: o, position: a, dimensions: l, fill: u, center: c, radius: E } = e;
    this.surface.fillStyle = `#${s.getHexString()}`, this.surface.strokeStyle = `#${s.getHexString()}`, this.surface.globalAlpha = o;
    const d = a.clone();
    c && d.sub(l.clone().divideScalar(2)), E ? (this.surface.beginPath(), this.surface.moveTo(d.x, d.y), this.surface.arcTo(
      d.x + l.x,
      d.y,
      d.x + l.x,
      d.y + l.y,
      E
    ), this.surface.arcTo(
      d.x + l.x,
      d.y + l.y,
      d.x,
      d.y + l.y,
      E
    ), this.surface.arcTo(d.x, d.y + l.y, d.x, d.y, E), this.surface.arcTo(d.x, d.y, d.x + l.x, d.y, E), u ? this.surface.fill() : this.surface.stroke()) : u ? this.surface.fillRect(d.x, d.y, l.x, l.y) : this.surface.strokeRect(d.x, d.y, l.x, l.y);
  }
  /**
   * Draw a circle
   *
   * @param circle
   */
  drawCircle(e) {
    if (this.surface === null)
      return;
    const { position: s, color: o, opacity: a, radius: l, fill: u } = e;
    this.surface.fillStyle = `#${o.getHexString()}`, this.surface.strokeStyle = `#${o.getHexString()}`, this.surface.globalAlpha = a, this.surface.beginPath(), this.surface.arc(s.x, s.y, l, 0, 2 * Math.PI), u ? this.surface.fill() : this.surface.stroke();
  }
  /**
   * Draw a polygon
   *
   * @param polygon
   */
  drawPolygon(e) {
    if (this.surface === null)
      return;
    const { color: s, vertices: o, opacity: a, fill: l, border: u } = e;
    this.surface.beginPath();
    for (let c = 0; c < o.length; c++) {
      const { x: E, y: d } = o[c];
      c === 0 ? this.surface.moveTo(E, d) : this.surface.lineTo(E, d);
    }
    this.surface.closePath(), this.surface.globalAlpha = a, l ? (this.surface.fillStyle = `#${s.getHexString()}`, this.surface.fill()) : (this.surface.strokeStyle = `#${s.getHexString()}`, this.surface.lineWidth = u ?? 1, this.surface.stroke());
  }
  /**
   * Draw a line
   *
   * @param line
   */
  drawLine(e) {
    if (this.surface === null)
      return;
    const { color: s, opacity: o, width: a, start: l, end: u } = e;
    this.surface.strokeStyle = `#${s.getHexString()}`, this.surface.globalAlpha = o, this.surface.lineWidth = a, this.surface.beginPath(), this.surface.moveTo(l.x, l.y), this.surface.lineTo(u.x, u.y), this.surface.stroke();
  }
  /**
   * Draw some text
   *
   * @param text
   */
  drawText(e) {
    if (this.surface === null)
      return;
    const { position: s, size: o, color: a, opacity: l, string: u, font: c, center: E, fill: d } = e;
    this.surface.font = `${o}px ${c}`, this.surface.textBaseline = "top", this.surface.fillStyle = `#${a.getHexString()}`, this.surface.strokeStyle = `#${a.getHexString()}`, this.surface.globalAlpha = l, E ? (this.surface.textAlign = "center", this.surface.textBaseline = "middle") : (this.surface.textAlign = "left", this.surface.textBaseline = "top"), d ? this.surface.fillText(u, s.x, s.y) : this.surface.strokeText(u, s.x, s.y);
  }
  /**
   * Draw an image from a URL
   *
   * @param image
   */
  drawImage(e) {
    const { src: s, position: o, opacity: a, destinationSize: l } = e, u = (c) => {
      this.surface !== null && (this.surface.globalAlpha = a, this.surface.imageSmoothingEnabled = !1, l ? this.surface.drawImage(c, o.x, o.y, l.x, l.y) : this.surface.drawImage(c, o.x, o.y));
    };
    if (s.imageType === "url") {
      let c = this.imageCache.get(s.url);
      c === void 0 ? (c = new Image(), c.src = s.url, this.imageCache.set(s.url, c), c.addEventListener("load", () => {
        c !== void 0 && u(c);
      })) : u(c);
    } else
      u(s.blob);
  }
  /**
   * Handle each Drawable type
   *
   * @param drawable
   */
  draw(e) {
    switch (e.type) {
      case "rect":
        this.drawRect(e);
        break;
      case "circle":
        this.drawCircle(e);
        break;
      case "polygon":
        this.drawPolygon(e);
        break;
      case "line":
        this.drawLine(e);
        break;
      case "text":
        this.drawText(e);
        break;
      case "image":
        this.drawImage(e);
        break;
    }
  }
  /**
   * Get the HTML canvas
   *
   * @returns
   */
  getCanvas() {
    return this.canvas;
  }
  /**
   * Set the size of the canvas
   *
   * @param size
   */
  setSize(e) {
    this.canvas.width = e.x, this.canvas.height = e.y;
  }
  /**
   * Add a drawable
   *
   * @param drawable
   */
  addDrawable(e) {
    this.drawables.add(e);
  }
  /**
   * Remove a drawable, if it exists
   *
   * @param drawable
   */
  removeDrawable(e) {
    this.drawables.delete(e);
  }
  /**
   * Calculate the width in pixels of a string of text when
   * drawn with a given font and size
   *
   * @param text String of text
   * @param font Font type
   * @param size Size of the font
   * @returns
   */
  textWidth(e, s, o) {
    return this.surface === null ? 0 : (this.surface.font = `${o}px ${s}`, this.surface.measureText(e).width);
  }
  /**
   * Calculate the height in pixels of the drawn text given the size of a font
   *
   * @param size
   * @returns
   */
  textHeight(e) {
    return e * 16 / 12;
  }
  /**
   * Render a single frame of the canvas.
   *
   *
   * Do not call this within the application run time.
   * Run this in an infinite loop on initialization.
   */
  render() {
    var s;
    (s = this.surface) == null || s.clearRect(0, 0, this.canvas.width, this.canvas.height);
    const e = [...this.drawables];
    e.sort((o, a) => {
      const l = o.zIndex ?? 0, u = a.zIndex ?? 0;
      return l - u;
    });
    for (const o of e)
      this.draw(o);
  }
}
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION$1 = "154", CullFaceNone = 0, CullFaceBack = 1, CullFaceFront = 2, PCFShadowMap = 1, PCFSoftShadowMap = 2, VSMShadowMap = 3, FrontSide = 0, BackSide = 1, DoubleSide = 2, NoBlending = 0, NormalBlending = 1, AdditiveBlending = 2, SubtractiveBlending = 3, MultiplyBlending = 4, CustomBlending = 5, AddEquation = 100, SubtractEquation = 101, ReverseSubtractEquation = 102, MinEquation = 103, MaxEquation = 104, ZeroFactor = 200, OneFactor = 201, SrcColorFactor = 202, OneMinusSrcColorFactor = 203, SrcAlphaFactor = 204, OneMinusSrcAlphaFactor = 205, DstAlphaFactor = 206, OneMinusDstAlphaFactor = 207, DstColorFactor = 208, OneMinusDstColorFactor = 209, SrcAlphaSaturateFactor = 210, NeverDepth = 0, AlwaysDepth = 1, LessDepth = 2, LessEqualDepth = 3, EqualDepth = 4, GreaterEqualDepth = 5, GreaterDepth = 6, NotEqualDepth = 7, MultiplyOperation = 0, MixOperation = 1, AddOperation = 2, NoToneMapping = 0, LinearToneMapping = 1, ReinhardToneMapping = 2, CineonToneMapping = 3, ACESFilmicToneMapping = 4, CustomToneMapping = 5, UVMapping = 300, CubeReflectionMapping = 301, CubeRefractionMapping = 302, EquirectangularReflectionMapping = 303, EquirectangularRefractionMapping = 304, CubeUVReflectionMapping = 306, RepeatWrapping = 1e3, ClampToEdgeWrapping = 1001, MirroredRepeatWrapping = 1002, NearestFilter = 1003, NearestMipmapNearestFilter = 1004, NearestMipMapNearestFilter = 1004, NearestMipmapLinearFilter = 1005, NearestMipMapLinearFilter = 1005, LinearFilter = 1006, LinearMipmapNearestFilter = 1007, LinearMipMapNearestFilter = 1007, LinearMipmapLinearFilter = 1008, LinearMipMapLinearFilter = 1008, UnsignedByteType = 1009, ByteType = 1010, ShortType = 1011, UnsignedShortType = 1012, IntType = 1013, UnsignedIntType = 1014, FloatType = 1015, HalfFloatType = 1016, UnsignedShort4444Type = 1017, UnsignedShort5551Type = 1018, UnsignedInt248Type = 1020, AlphaFormat = 1021, RGBAFormat = 1023, LuminanceFormat = 1024, LuminanceAlphaFormat = 1025, DepthFormat = 1026, DepthStencilFormat = 1027, RedFormat = 1028, RedIntegerFormat = 1029, RGFormat = 1030, RGIntegerFormat = 1031, RGBAIntegerFormat = 1033, RGB_S3TC_DXT1_Format = 33776, RGBA_S3TC_DXT1_Format = 33777, RGBA_S3TC_DXT3_Format = 33778, RGBA_S3TC_DXT5_Format = 33779, RGB_PVRTC_4BPPV1_Format = 35840, RGB_PVRTC_2BPPV1_Format = 35841, RGBA_PVRTC_4BPPV1_Format = 35842, RGBA_PVRTC_2BPPV1_Format = 35843, RGB_ETC1_Format = 36196, RGB_ETC2_Format = 37492, RGBA_ETC2_EAC_Format = 37496, RGBA_ASTC_4x4_Format = 37808, RGBA_ASTC_5x4_Format = 37809, RGBA_ASTC_5x5_Format = 37810, RGBA_ASTC_6x5_Format = 37811, RGBA_ASTC_6x6_Format = 37812, RGBA_ASTC_8x5_Format = 37813, RGBA_ASTC_8x6_Format = 37814, RGBA_ASTC_8x8_Format = 37815, RGBA_ASTC_10x5_Format = 37816, RGBA_ASTC_10x6_Format = 37817, RGBA_ASTC_10x8_Format = 37818, RGBA_ASTC_10x10_Format = 37819, RGBA_ASTC_12x10_Format = 37820, RGBA_ASTC_12x12_Format = 37821, RGBA_BPTC_Format = 36492, RED_RGTC1_Format = 36283, SIGNED_RED_RGTC1_Format = 36284, RED_GREEN_RGTC2_Format = 36285, SIGNED_RED_GREEN_RGTC2_Format = 36286, InterpolateDiscrete = 2300, InterpolateLinear = 2301, InterpolateSmooth = 2302, ZeroCurvatureEnding = 2400, ZeroSlopeEnding = 2401, WrapAroundEnding = 2402, NormalAnimationBlendMode = 2500, AdditiveAnimationBlendMode = 2501, TrianglesDrawMode = 0, TriangleStripDrawMode = 1, TriangleFanDrawMode = 2, LinearEncoding = 3e3, sRGBEncoding = 3001, BasicDepthPacking = 3200, RGBADepthPacking = 3201, TangentSpaceNormalMap = 0, ObjectSpaceNormalMap = 1, NoColorSpace = "", SRGBColorSpace = "srgb", LinearSRGBColorSpace = "srgb-linear", DisplayP3ColorSpace = "display-p3", KeepStencilOp = 7680, AlwaysStencilFunc = 519, NeverCompare = 512, LessCompare = 513, EqualCompare = 514, LessEqualCompare = 515, GreaterCompare = 516, NotEqualCompare = 517, GreaterEqualCompare = 518, AlwaysCompare = 519, StaticDrawUsage = 35044, GLSL3 = "300 es", _SRGBAFormat = 1035, WebGLCoordinateSystem = 2e3, WebGPUCoordinateSystem = 2001;
class EventDispatcher {
  addEventListener(e, s) {
    this._listeners === void 0 && (this._listeners = {});
    const o = this._listeners;
    o[e] === void 0 && (o[e] = []), o[e].indexOf(s) === -1 && o[e].push(s);
  }
  hasEventListener(e, s) {
    if (this._listeners === void 0)
      return !1;
    const o = this._listeners;
    return o[e] !== void 0 && o[e].indexOf(s) !== -1;
  }
  removeEventListener(e, s) {
    if (this._listeners === void 0)
      return;
    const a = this._listeners[e];
    if (a !== void 0) {
      const l = a.indexOf(s);
      l !== -1 && a.splice(l, 1);
    }
  }
  dispatchEvent(e) {
    if (this._listeners === void 0)
      return;
    const o = this._listeners[e.type];
    if (o !== void 0) {
      e.target = this;
      const a = o.slice(0);
      for (let l = 0, u = a.length; l < u; l++)
        a[l].call(this, e);
      e.target = null;
    }
  }
}
const _lut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let _seed = 1234567;
const DEG2RAD = Math.PI / 180, RAD2DEG = 180 / Math.PI;
function generateUUID$1() {
  const r = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, s = Math.random() * 4294967295 | 0, o = Math.random() * 4294967295 | 0;
  return (_lut[r & 255] + _lut[r >> 8 & 255] + _lut[r >> 16 & 255] + _lut[r >> 24 & 255] + "-" + _lut[e & 255] + _lut[e >> 8 & 255] + "-" + _lut[e >> 16 & 15 | 64] + _lut[e >> 24 & 255] + "-" + _lut[s & 63 | 128] + _lut[s >> 8 & 255] + "-" + _lut[s >> 16 & 255] + _lut[s >> 24 & 255] + _lut[o & 255] + _lut[o >> 8 & 255] + _lut[o >> 16 & 255] + _lut[o >> 24 & 255]).toLowerCase();
}
function clamp$2(r, e, s) {
  return Math.max(e, Math.min(s, r));
}
function euclideanModulo(r, e) {
  return (r % e + e) % e;
}
function mapLinear(r, e, s, o, a) {
  return o + (r - e) * (a - o) / (s - e);
}
function inverseLerp(r, e, s) {
  return r !== e ? (s - r) / (e - r) : 0;
}
function lerp(r, e, s) {
  return (1 - s) * r + s * e;
}
function damp(r, e, s, o) {
  return lerp(r, e, 1 - Math.exp(-s * o));
}
function pingpong(r, e = 1) {
  return e - Math.abs(euclideanModulo(r, e * 2) - e);
}
function smoothstep(r, e, s) {
  return r <= e ? 0 : r >= s ? 1 : (r = (r - e) / (s - e), r * r * (3 - 2 * r));
}
function smootherstep(r, e, s) {
  return r <= e ? 0 : r >= s ? 1 : (r = (r - e) / (s - e), r * r * r * (r * (r * 6 - 15) + 10));
}
function randInt(r, e) {
  return r + Math.floor(Math.random() * (e - r + 1));
}
function randFloat(r, e) {
  return r + Math.random() * (e - r);
}
function randFloatSpread(r) {
  return r * (0.5 - Math.random());
}
function seededRandom(r) {
  r !== void 0 && (_seed = r);
  let e = _seed += 1831565813;
  return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
}
function degToRad$1(r) {
  return r * DEG2RAD;
}
function radToDeg$1(r) {
  return r * RAD2DEG;
}
function isPowerOfTwo(r) {
  return (r & r - 1) === 0 && r !== 0;
}
function ceilPowerOfTwo(r) {
  return Math.pow(2, Math.ceil(Math.log(r) / Math.LN2));
}
function floorPowerOfTwo(r) {
  return Math.pow(2, Math.floor(Math.log(r) / Math.LN2));
}
function setQuaternionFromProperEuler(r, e, s, o, a) {
  const l = Math.cos, u = Math.sin, c = l(s / 2), E = u(s / 2), d = l((e + o) / 2), f = u((e + o) / 2), h = l((e - o) / 2), S = u((e - o) / 2), R = l((o - e) / 2), _ = u((o - e) / 2);
  switch (a) {
    case "XYX":
      r.set(c * f, E * h, E * S, c * d);
      break;
    case "YZY":
      r.set(E * S, c * f, E * h, c * d);
      break;
    case "ZXZ":
      r.set(E * h, E * S, c * f, c * d);
      break;
    case "XZX":
      r.set(c * f, E * _, E * R, c * d);
      break;
    case "YXY":
      r.set(E * R, c * f, E * _, c * d);
      break;
    case "ZYZ":
      r.set(E * _, E * R, c * f, c * d);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + a);
  }
}
function denormalize(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return r / 4294967295;
    case Uint16Array:
      return r / 65535;
    case Uint8Array:
      return r / 255;
    case Int32Array:
      return Math.max(r / 2147483647, -1);
    case Int16Array:
      return Math.max(r / 32767, -1);
    case Int8Array:
      return Math.max(r / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize(r, e) {
  switch (e.constructor) {
    case Float32Array:
      return r;
    case Uint32Array:
      return Math.round(r * 4294967295);
    case Uint16Array:
      return Math.round(r * 65535);
    case Uint8Array:
      return Math.round(r * 255);
    case Int32Array:
      return Math.round(r * 2147483647);
    case Int16Array:
      return Math.round(r * 32767);
    case Int8Array:
      return Math.round(r * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const MathUtils$1 = {
  DEG2RAD,
  RAD2DEG,
  generateUUID: generateUUID$1,
  clamp: clamp$2,
  euclideanModulo,
  mapLinear,
  inverseLerp,
  lerp,
  damp,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad: degToRad$1,
  radToDeg: radToDeg$1,
  isPowerOfTwo,
  ceilPowerOfTwo,
  floorPowerOfTwo,
  setQuaternionFromProperEuler,
  normalize,
  denormalize
};
class Vector2 {
  constructor(e = 0, s = 0) {
    Vector2.prototype.isVector2 = !0, this.x = e, this.y = s;
  }
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  set(e, s) {
    return this.x = e, this.y = s, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setComponent(e, s) {
    switch (e) {
      case 0:
        this.x = s;
        break;
      case 1:
        this.y = s;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  addVectors(e, s) {
    return this.x = e.x + s.x, this.y = e.y + s.y, this;
  }
  addScaledVector(e, s) {
    return this.x += e.x * s, this.y += e.y * s, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  subVectors(e, s) {
    return this.x = e.x - s.x, this.y = e.y - s.y, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  applyMatrix3(e) {
    const s = this.x, o = this.y, a = e.elements;
    return this.x = a[0] * s + a[3] * o + a[6], this.y = a[1] * s + a[4] * o + a[7], this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  clamp(e, s) {
    return this.x = Math.max(e.x, Math.min(s.x, this.x)), this.y = Math.max(e.y, Math.min(s.y, this.y)), this;
  }
  clampScalar(e, s) {
    return this.x = Math.max(e, Math.min(s, this.x)), this.y = Math.max(e, Math.min(s, this.y)), this;
  }
  clampLength(e, s) {
    const o = this.length();
    return this.divideScalar(o || 1).multiplyScalar(Math.max(e, Math.min(s, o)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(e) {
    const s = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (s === 0)
      return Math.PI / 2;
    const o = this.dot(e) / s;
    return Math.acos(clamp$2(o, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const s = this.x - e.x, o = this.y - e.y;
    return s * s + o * o;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, s) {
    return this.x += (e.x - this.x) * s, this.y += (e.y - this.y) * s, this;
  }
  lerpVectors(e, s, o) {
    return this.x = e.x + (s.x - e.x) * o, this.y = e.y + (s.y - e.y) * o, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  fromArray(e, s = 0) {
    return this.x = e[s], this.y = e[s + 1], this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this.x, e[s + 1] = this.y, e;
  }
  fromBufferAttribute(e, s) {
    return this.x = e.getX(s), this.y = e.getY(s), this;
  }
  rotateAround(e, s) {
    const o = Math.cos(s), a = Math.sin(s), l = this.x - e.x, u = this.y - e.y;
    return this.x = l * o - u * a + e.x, this.y = l * a + u * o + e.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
let Matrix3$1 = class wd {
  constructor(e, s, o, a, l, u, c, E, d) {
    wd.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, s, o, a, l, u, c, E, d);
  }
  set(e, s, o, a, l, u, c, E, d) {
    const f = this.elements;
    return f[0] = e, f[1] = a, f[2] = c, f[3] = s, f[4] = l, f[5] = E, f[6] = o, f[7] = u, f[8] = d, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(e) {
    const s = this.elements, o = e.elements;
    return s[0] = o[0], s[1] = o[1], s[2] = o[2], s[3] = o[3], s[4] = o[4], s[5] = o[5], s[6] = o[6], s[7] = o[7], s[8] = o[8], this;
  }
  extractBasis(e, s, o) {
    return e.setFromMatrix3Column(this, 0), s.setFromMatrix3Column(this, 1), o.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(e) {
    const s = e.elements;
    return this.set(
      s[0],
      s[4],
      s[8],
      s[1],
      s[5],
      s[9],
      s[2],
      s[6],
      s[10]
    ), this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, s) {
    const o = e.elements, a = s.elements, l = this.elements, u = o[0], c = o[3], E = o[6], d = o[1], f = o[4], h = o[7], S = o[2], R = o[5], _ = o[8], m = a[0], L = a[3], F = a[6], W = a[1], G = a[4], q = a[7], fe = a[2], _e = a[5], Le = a[8];
    return l[0] = u * m + c * W + E * fe, l[3] = u * L + c * G + E * _e, l[6] = u * F + c * q + E * Le, l[1] = d * m + f * W + h * fe, l[4] = d * L + f * G + h * _e, l[7] = d * F + f * q + h * Le, l[2] = S * m + R * W + _ * fe, l[5] = S * L + R * G + _ * _e, l[8] = S * F + R * q + _ * Le, this;
  }
  multiplyScalar(e) {
    const s = this.elements;
    return s[0] *= e, s[3] *= e, s[6] *= e, s[1] *= e, s[4] *= e, s[7] *= e, s[2] *= e, s[5] *= e, s[8] *= e, this;
  }
  determinant() {
    const e = this.elements, s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], E = e[6], d = e[7], f = e[8];
    return s * u * f - s * c * d - o * l * f + o * c * E + a * l * d - a * u * E;
  }
  invert() {
    const e = this.elements, s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], E = e[6], d = e[7], f = e[8], h = f * u - c * d, S = c * E - f * l, R = d * l - u * E, _ = s * h + o * S + a * R;
    if (_ === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const m = 1 / _;
    return e[0] = h * m, e[1] = (a * d - f * o) * m, e[2] = (c * o - a * u) * m, e[3] = S * m, e[4] = (f * s - a * E) * m, e[5] = (a * l - c * s) * m, e[6] = R * m, e[7] = (o * E - d * s) * m, e[8] = (u * s - o * l) * m, this;
  }
  transpose() {
    let e;
    const s = this.elements;
    return e = s[1], s[1] = s[3], s[3] = e, e = s[2], s[2] = s[6], s[6] = e, e = s[5], s[5] = s[7], s[7] = e, this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    const s = this.elements;
    return e[0] = s[0], e[1] = s[3], e[2] = s[6], e[3] = s[1], e[4] = s[4], e[5] = s[7], e[6] = s[2], e[7] = s[5], e[8] = s[8], this;
  }
  setUvTransform(e, s, o, a, l, u, c) {
    const E = Math.cos(l), d = Math.sin(l);
    return this.set(
      o * E,
      o * d,
      -o * (E * u + d * c) + u + e,
      -a * d,
      a * E,
      -a * (-d * u + E * c) + c + s,
      0,
      0,
      1
    ), this;
  }
  //
  scale(e, s) {
    return this.premultiply(_m3$1.makeScale(e, s)), this;
  }
  rotate(e) {
    return this.premultiply(_m3$1.makeRotation(-e)), this;
  }
  translate(e, s) {
    return this.premultiply(_m3$1.makeTranslation(e, s)), this;
  }
  // for 2D Transforms
  makeTranslation(e, s) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      s,
      0,
      0,
      1
    ), this;
  }
  makeRotation(e) {
    const s = Math.cos(e), o = Math.sin(e);
    return this.set(
      s,
      -o,
      0,
      o,
      s,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, s) {
    return this.set(
      e,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      1
    ), this;
  }
  //
  equals(e) {
    const s = this.elements, o = e.elements;
    for (let a = 0; a < 9; a++)
      if (s[a] !== o[a])
        return !1;
    return !0;
  }
  fromArray(e, s = 0) {
    for (let o = 0; o < 9; o++)
      this.elements[o] = e[o + s];
    return this;
  }
  toArray(e = [], s = 0) {
    const o = this.elements;
    return e[s] = o[0], e[s + 1] = o[1], e[s + 2] = o[2], e[s + 3] = o[3], e[s + 4] = o[4], e[s + 5] = o[5], e[s + 6] = o[6], e[s + 7] = o[7], e[s + 8] = o[8], e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
const _m3$1 = /* @__PURE__ */ new Matrix3$1();
function arrayNeedsUint32(r) {
  for (let e = r.length - 1; e >= 0; --e)
    if (r[e] >= 65535)
      return !0;
  return !1;
}
function createElementNS(r) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", r);
}
const _cache = {};
function warnOnce(r) {
  r in _cache || (_cache[r] = !0, console.warn(r));
}
function SRGBToLinear(r) {
  return r < 0.04045 ? r * 0.0773993808 : Math.pow(r * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(r) {
  return r < 31308e-7 ? r * 12.92 : 1.055 * Math.pow(r, 0.41666) - 0.055;
}
const LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /* @__PURE__ */ new Matrix3$1().fromArray([
  0.8224621,
  0.0331941,
  0.0170827,
  0.177538,
  0.9668058,
  0.0723974,
  -1e-7,
  1e-7,
  0.9105199
]), LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /* @__PURE__ */ new Matrix3$1().fromArray([
  1.2249401,
  -0.0420569,
  -0.0196376,
  -0.2249404,
  1.0420571,
  -0.0786361,
  1e-7,
  0,
  1.0982735
]);
function DisplayP3ToLinearSRGB(r) {
  return r.convertSRGBToLinear().applyMatrix3(LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function LinearSRGBToDisplayP3(r) {
  return r.applyMatrix3(LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
const TO_LINEAR = {
  [LinearSRGBColorSpace]: (r) => r,
  [SRGBColorSpace]: (r) => r.convertSRGBToLinear(),
  [DisplayP3ColorSpace]: DisplayP3ToLinearSRGB
}, FROM_LINEAR = {
  [LinearSRGBColorSpace]: (r) => r,
  [SRGBColorSpace]: (r) => r.convertLinearToSRGB(),
  [DisplayP3ColorSpace]: LinearSRGBToDisplayP3
}, ColorManagement = {
  enabled: !0,
  get legacyMode() {
    return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
  },
  set legacyMode(r) {
    console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !r;
  },
  get workingColorSpace() {
    return LinearSRGBColorSpace;
  },
  set workingColorSpace(r) {
    console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
  },
  convert: function(r, e, s) {
    if (this.enabled === !1 || e === s || !e || !s)
      return r;
    const o = TO_LINEAR[e], a = FROM_LINEAR[s];
    if (o === void 0 || a === void 0)
      throw new Error(`Unsupported color space conversion, "${e}" to "${s}".`);
    return a(o(r));
  },
  fromWorkingColorSpace: function(r, e) {
    return this.convert(r, this.workingColorSpace, e);
  },
  toWorkingColorSpace: function(r, e) {
    return this.convert(r, e, this.workingColorSpace);
  }
};
let _canvas;
class ImageUtils {
  static getDataURL(e) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let s;
    if (e instanceof HTMLCanvasElement)
      s = e;
    else {
      _canvas === void 0 && (_canvas = createElementNS("canvas")), _canvas.width = e.width, _canvas.height = e.height;
      const o = _canvas.getContext("2d");
      e instanceof ImageData ? o.putImageData(e, 0, 0) : o.drawImage(e, 0, 0, e.width, e.height), s = _canvas;
    }
    return s.width > 2048 || s.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e), s.toDataURL("image/jpeg", 0.6)) : s.toDataURL("image/png");
  }
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const s = createElementNS("canvas");
      s.width = e.width, s.height = e.height;
      const o = s.getContext("2d");
      o.drawImage(e, 0, 0, e.width, e.height);
      const a = o.getImageData(0, 0, e.width, e.height), l = a.data;
      for (let u = 0; u < l.length; u++)
        l[u] = SRGBToLinear(l[u] / 255) * 255;
      return o.putImageData(a, 0, 0), s;
    } else if (e.data) {
      const s = e.data.slice(0);
      for (let o = 0; o < s.length; o++)
        s instanceof Uint8Array || s instanceof Uint8ClampedArray ? s[o] = Math.floor(SRGBToLinear(s[o] / 255) * 255) : s[o] = SRGBToLinear(s[o]);
      return {
        data: s,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
let sourceId = 0;
class Source {
  constructor(e = null) {
    this.isSource = !0, Object.defineProperty(this, "id", { value: sourceId++ }), this.uuid = generateUUID$1(), this.data = e, this.version = 0;
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  toJSON(e) {
    const s = e === void 0 || typeof e == "string";
    if (!s && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const o = {
      uuid: this.uuid,
      url: ""
    }, a = this.data;
    if (a !== null) {
      let l;
      if (Array.isArray(a)) {
        l = [];
        for (let u = 0, c = a.length; u < c; u++)
          a[u].isDataTexture ? l.push(serializeImage(a[u].image)) : l.push(serializeImage(a[u]));
      } else
        l = serializeImage(a);
      o.url = l;
    }
    return s || (e.images[this.uuid] = o), o;
  }
}
function serializeImage(r) {
  return typeof HTMLImageElement < "u" && r instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r instanceof ImageBitmap ? ImageUtils.getDataURL(r) : r.data ? {
    data: Array.from(r.data),
    width: r.width,
    height: r.height,
    type: r.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let textureId = 0;
class Texture extends EventDispatcher {
  constructor(e = Texture.DEFAULT_IMAGE, s = Texture.DEFAULT_MAPPING, o = ClampToEdgeWrapping, a = ClampToEdgeWrapping, l = LinearFilter, u = LinearMipmapLinearFilter, c = RGBAFormat, E = UnsignedByteType, d = Texture.DEFAULT_ANISOTROPY, f = NoColorSpace) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: textureId++ }), this.uuid = generateUUID$1(), this.name = "", this.source = new Source(e), this.mipmaps = [], this.mapping = s, this.channel = 0, this.wrapS = o, this.wrapT = a, this.magFilter = l, this.minFilter = u, this.anisotropy = d, this.format = c, this.internalFormat = null, this.type = E, this.offset = new Vector2(0, 0), this.repeat = new Vector2(1, 1), this.center = new Vector2(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Matrix3$1(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, typeof f == "string" ? this.colorSpace = f : (warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = f === sRGBEncoding ? SRGBColorSpace : NoColorSpace), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
  }
  get image() {
    return this.source.data;
  }
  set image(e = null) {
    this.source.data = e;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.channel = e.channel, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.colorSpace = e.colorSpace, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  toJSON(e) {
    const s = e === void 0 || typeof e == "string";
    if (!s && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const o = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return Object.keys(this.userData).length > 0 && (o.userData = this.userData), s || (e.textures[this.uuid] = o), o;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(e) {
    if (this.mapping !== UVMapping)
      return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case RepeatWrapping:
          e.x = e.x - Math.floor(e.x);
          break;
        case ClampToEdgeWrapping:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case RepeatWrapping:
          e.y = e.y - Math.floor(e.y);
          break;
        case ClampToEdgeWrapping:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
  get encoding() {
    return warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === SRGBColorSpace ? sRGBEncoding : LinearEncoding;
  }
  set encoding(e) {
    warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e === sRGBEncoding ? SRGBColorSpace : NoColorSpace;
  }
}
Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;
class Vector4 {
  constructor(e = 0, s = 0, o = 0, a = 1) {
    Vector4.prototype.isVector4 = !0, this.x = e, this.y = s, this.z = o, this.w = a;
  }
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  set(e, s, o, a) {
    return this.x = e, this.y = s, this.z = o, this.w = a, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setW(e) {
    return this.w = e, this;
  }
  setComponent(e, s) {
    switch (e) {
      case 0:
        this.x = s;
        break;
      case 1:
        this.y = s;
        break;
      case 2:
        this.z = s;
        break;
      case 3:
        this.w = s;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  addVectors(e, s) {
    return this.x = e.x + s.x, this.y = e.y + s.y, this.z = e.z + s.z, this.w = e.w + s.w, this;
  }
  addScaledVector(e, s) {
    return this.x += e.x * s, this.y += e.y * s, this.z += e.z * s, this.w += e.w * s, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  subVectors(e, s) {
    return this.x = e.x - s.x, this.y = e.y - s.y, this.z = e.z - s.z, this.w = e.w - s.w, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  applyMatrix4(e) {
    const s = this.x, o = this.y, a = this.z, l = this.w, u = e.elements;
    return this.x = u[0] * s + u[4] * o + u[8] * a + u[12] * l, this.y = u[1] * s + u[5] * o + u[9] * a + u[13] * l, this.z = u[2] * s + u[6] * o + u[10] * a + u[14] * l, this.w = u[3] * s + u[7] * o + u[11] * a + u[15] * l, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const s = Math.sqrt(1 - e.w * e.w);
    return s < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / s, this.y = e.y / s, this.z = e.z / s), this;
  }
  setAxisAngleFromRotationMatrix(e) {
    let s, o, a, l;
    const E = e.elements, d = E[0], f = E[4], h = E[8], S = E[1], R = E[5], _ = E[9], m = E[2], L = E[6], F = E[10];
    if (Math.abs(f - S) < 0.01 && Math.abs(h - m) < 0.01 && Math.abs(_ - L) < 0.01) {
      if (Math.abs(f + S) < 0.1 && Math.abs(h + m) < 0.1 && Math.abs(_ + L) < 0.1 && Math.abs(d + R + F - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      s = Math.PI;
      const G = (d + 1) / 2, q = (R + 1) / 2, fe = (F + 1) / 2, _e = (f + S) / 4, Le = (h + m) / 4, Fe = (_ + L) / 4;
      return G > q && G > fe ? G < 0.01 ? (o = 0, a = 0.707106781, l = 0.707106781) : (o = Math.sqrt(G), a = _e / o, l = Le / o) : q > fe ? q < 0.01 ? (o = 0.707106781, a = 0, l = 0.707106781) : (a = Math.sqrt(q), o = _e / a, l = Fe / a) : fe < 0.01 ? (o = 0.707106781, a = 0.707106781, l = 0) : (l = Math.sqrt(fe), o = Le / l, a = Fe / l), this.set(o, a, l, s), this;
    }
    let W = Math.sqrt((L - _) * (L - _) + (h - m) * (h - m) + (S - f) * (S - f));
    return Math.abs(W) < 1e-3 && (W = 1), this.x = (L - _) / W, this.y = (h - m) / W, this.z = (S - f) / W, this.w = Math.acos((d + R + F - 1) / 2), this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  clamp(e, s) {
    return this.x = Math.max(e.x, Math.min(s.x, this.x)), this.y = Math.max(e.y, Math.min(s.y, this.y)), this.z = Math.max(e.z, Math.min(s.z, this.z)), this.w = Math.max(e.w, Math.min(s.w, this.w)), this;
  }
  clampScalar(e, s) {
    return this.x = Math.max(e, Math.min(s, this.x)), this.y = Math.max(e, Math.min(s, this.y)), this.z = Math.max(e, Math.min(s, this.z)), this.w = Math.max(e, Math.min(s, this.w)), this;
  }
  clampLength(e, s) {
    const o = this.length();
    return this.divideScalar(o || 1).multiplyScalar(Math.max(e, Math.min(s, o)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, s) {
    return this.x += (e.x - this.x) * s, this.y += (e.y - this.y) * s, this.z += (e.z - this.z) * s, this.w += (e.w - this.w) * s, this;
  }
  lerpVectors(e, s, o) {
    return this.x = e.x + (s.x - e.x) * o, this.y = e.y + (s.y - e.y) * o, this.z = e.z + (s.z - e.z) * o, this.w = e.w + (s.w - e.w) * o, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  fromArray(e, s = 0) {
    return this.x = e[s], this.y = e[s + 1], this.z = e[s + 2], this.w = e[s + 3], this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this.x, e[s + 1] = this.y, e[s + 2] = this.z, e[s + 3] = this.w, e;
  }
  fromBufferAttribute(e, s) {
    return this.x = e.getX(s), this.y = e.getY(s), this.z = e.getZ(s), this.w = e.getW(s), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class WebGLRenderTarget extends EventDispatcher {
  constructor(e = 1, s = 1, o = {}) {
    super(), this.isWebGLRenderTarget = !0, this.width = e, this.height = s, this.depth = 1, this.scissor = new Vector4(0, 0, e, s), this.scissorTest = !1, this.viewport = new Vector4(0, 0, e, s);
    const a = { width: e, height: s, depth: 1 };
    o.encoding !== void 0 && (warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), o.colorSpace = o.encoding === sRGBEncoding ? SRGBColorSpace : NoColorSpace), this.texture = new Texture(a, o.mapping, o.wrapS, o.wrapT, o.magFilter, o.minFilter, o.format, o.type, o.anisotropy, o.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = o.generateMipmaps !== void 0 ? o.generateMipmaps : !1, this.texture.internalFormat = o.internalFormat !== void 0 ? o.internalFormat : null, this.texture.minFilter = o.minFilter !== void 0 ? o.minFilter : LinearFilter, this.depthBuffer = o.depthBuffer !== void 0 ? o.depthBuffer : !0, this.stencilBuffer = o.stencilBuffer !== void 0 ? o.stencilBuffer : !1, this.depthTexture = o.depthTexture !== void 0 ? o.depthTexture : null, this.samples = o.samples !== void 0 ? o.samples : 0;
  }
  setSize(e, s, o = 1) {
    (this.width !== e || this.height !== s || this.depth !== o) && (this.width = e, this.height = s, this.depth = o, this.texture.image.width = e, this.texture.image.height = s, this.texture.image.depth = o, this.dispose()), this.viewport.set(0, 0, e, s), this.scissor.set(0, 0, e, s);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.texture.isRenderTargetTexture = !0;
    const s = Object.assign({}, e.texture.image);
    return this.texture.source = new Source(s), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class DataArrayTexture extends Texture {
  constructor(e = null, s = 1, o = 1, a = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: s, height: o, depth: a }, this.magFilter = NearestFilter, this.minFilter = NearestFilter, this.wrapR = ClampToEdgeWrapping, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Data3DTexture extends Texture {
  constructor(e = null, s = 1, o = 1, a = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: s, height: o, depth: a }, this.magFilter = NearestFilter, this.minFilter = NearestFilter, this.wrapR = ClampToEdgeWrapping, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class WebGLMultipleRenderTargets extends WebGLRenderTarget {
  constructor(e = 1, s = 1, o = 1, a = {}) {
    super(e, s, a), this.isWebGLMultipleRenderTargets = !0;
    const l = this.texture;
    this.texture = [];
    for (let u = 0; u < o; u++)
      this.texture[u] = l.clone(), this.texture[u].isRenderTargetTexture = !0;
  }
  setSize(e, s, o = 1) {
    if (this.width !== e || this.height !== s || this.depth !== o) {
      this.width = e, this.height = s, this.depth = o;
      for (let a = 0, l = this.texture.length; a < l; a++)
        this.texture[a].image.width = e, this.texture[a].image.height = s, this.texture[a].image.depth = o;
      this.dispose();
    }
    return this.viewport.set(0, 0, e, s), this.scissor.set(0, 0, e, s), this;
  }
  copy(e) {
    this.dispose(), this.width = e.width, this.height = e.height, this.depth = e.depth, this.scissor.copy(e.scissor), this.scissorTest = e.scissorTest, this.viewport.copy(e.viewport), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.texture.length = 0;
    for (let s = 0, o = e.texture.length; s < o; s++)
      this.texture[s] = e.texture[s].clone(), this.texture[s].isRenderTargetTexture = !0;
    return this;
  }
}
let Quaternion$1 = class {
  constructor(e = 0, s = 0, o = 0, a = 1) {
    this.isQuaternion = !0, this._x = e, this._y = s, this._z = o, this._w = a;
  }
  static slerpFlat(e, s, o, a, l, u, c) {
    let E = o[a + 0], d = o[a + 1], f = o[a + 2], h = o[a + 3];
    const S = l[u + 0], R = l[u + 1], _ = l[u + 2], m = l[u + 3];
    if (c === 0) {
      e[s + 0] = E, e[s + 1] = d, e[s + 2] = f, e[s + 3] = h;
      return;
    }
    if (c === 1) {
      e[s + 0] = S, e[s + 1] = R, e[s + 2] = _, e[s + 3] = m;
      return;
    }
    if (h !== m || E !== S || d !== R || f !== _) {
      let L = 1 - c;
      const F = E * S + d * R + f * _ + h * m, W = F >= 0 ? 1 : -1, G = 1 - F * F;
      if (G > Number.EPSILON) {
        const fe = Math.sqrt(G), _e = Math.atan2(fe, F * W);
        L = Math.sin(L * _e) / fe, c = Math.sin(c * _e) / fe;
      }
      const q = c * W;
      if (E = E * L + S * q, d = d * L + R * q, f = f * L + _ * q, h = h * L + m * q, L === 1 - c) {
        const fe = 1 / Math.sqrt(E * E + d * d + f * f + h * h);
        E *= fe, d *= fe, f *= fe, h *= fe;
      }
    }
    e[s] = E, e[s + 1] = d, e[s + 2] = f, e[s + 3] = h;
  }
  static multiplyQuaternionsFlat(e, s, o, a, l, u) {
    const c = o[a], E = o[a + 1], d = o[a + 2], f = o[a + 3], h = l[u], S = l[u + 1], R = l[u + 2], _ = l[u + 3];
    return e[s] = c * _ + f * h + E * R - d * S, e[s + 1] = E * _ + f * S + d * h - c * R, e[s + 2] = d * _ + f * R + c * S - E * h, e[s + 3] = f * _ - c * h - E * S - d * R, e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  set(e, s, o, a) {
    return this._x = e, this._y = s, this._z = o, this._w = a, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  setFromEuler(e, s) {
    const o = e._x, a = e._y, l = e._z, u = e._order, c = Math.cos, E = Math.sin, d = c(o / 2), f = c(a / 2), h = c(l / 2), S = E(o / 2), R = E(a / 2), _ = E(l / 2);
    switch (u) {
      case "XYZ":
        this._x = S * f * h + d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "YXZ":
        this._x = S * f * h + d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h + S * R * _;
        break;
      case "ZXY":
        this._x = S * f * h - d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "ZYX":
        this._x = S * f * h - d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h + S * R * _;
        break;
      case "YZX":
        this._x = S * f * h + d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "XZY":
        this._x = S * f * h - d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h + S * R * _;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + u);
    }
    return s !== !1 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(e, s) {
    const o = s / 2, a = Math.sin(o);
    return this._x = e.x * a, this._y = e.y * a, this._z = e.z * a, this._w = Math.cos(o), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e) {
    const s = e.elements, o = s[0], a = s[4], l = s[8], u = s[1], c = s[5], E = s[9], d = s[2], f = s[6], h = s[10], S = o + c + h;
    if (S > 0) {
      const R = 0.5 / Math.sqrt(S + 1);
      this._w = 0.25 / R, this._x = (f - E) * R, this._y = (l - d) * R, this._z = (u - a) * R;
    } else if (o > c && o > h) {
      const R = 2 * Math.sqrt(1 + o - c - h);
      this._w = (f - E) / R, this._x = 0.25 * R, this._y = (a + u) / R, this._z = (l + d) / R;
    } else if (c > h) {
      const R = 2 * Math.sqrt(1 + c - o - h);
      this._w = (l - d) / R, this._x = (a + u) / R, this._y = 0.25 * R, this._z = (E + f) / R;
    } else {
      const R = 2 * Math.sqrt(1 + h - o - c);
      this._w = (u - a) / R, this._x = (l + d) / R, this._y = (E + f) / R, this._z = 0.25 * R;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(e, s) {
    let o = e.dot(s) + 1;
    return o < Number.EPSILON ? (o = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = o) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = o)) : (this._x = e.y * s.z - e.z * s.y, this._y = e.z * s.x - e.x * s.z, this._z = e.x * s.y - e.y * s.x, this._w = o), this.normalize();
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(clamp$2(this.dot(e), -1, 1)));
  }
  rotateTowards(e, s) {
    const o = this.angleTo(e);
    if (o === 0)
      return this;
    const a = Math.min(1, s / o);
    return this.slerp(e, a), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, s) {
    const o = e._x, a = e._y, l = e._z, u = e._w, c = s._x, E = s._y, d = s._z, f = s._w;
    return this._x = o * f + u * c + a * d - l * E, this._y = a * f + u * E + l * c - o * d, this._z = l * f + u * d + o * E - a * c, this._w = u * f - o * c - a * E - l * d, this._onChangeCallback(), this;
  }
  slerp(e, s) {
    if (s === 0)
      return this;
    if (s === 1)
      return this.copy(e);
    const o = this._x, a = this._y, l = this._z, u = this._w;
    let c = u * e._w + o * e._x + a * e._y + l * e._z;
    if (c < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, c = -c) : this.copy(e), c >= 1)
      return this._w = u, this._x = o, this._y = a, this._z = l, this;
    const E = 1 - c * c;
    if (E <= Number.EPSILON) {
      const R = 1 - s;
      return this._w = R * u + s * this._w, this._x = R * o + s * this._x, this._y = R * a + s * this._y, this._z = R * l + s * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    const d = Math.sqrt(E), f = Math.atan2(d, c), h = Math.sin((1 - s) * f) / d, S = Math.sin(s * f) / d;
    return this._w = u * h + this._w * S, this._x = o * h + this._x * S, this._y = a * h + this._y * S, this._z = l * h + this._z * S, this._onChangeCallback(), this;
  }
  slerpQuaternions(e, s, o) {
    return this.copy(e).slerp(s, o);
  }
  random() {
    const e = Math.random(), s = Math.sqrt(1 - e), o = Math.sqrt(e), a = 2 * Math.PI * Math.random(), l = 2 * Math.PI * Math.random();
    return this.set(
      s * Math.cos(a),
      o * Math.sin(l),
      o * Math.cos(l),
      s * Math.sin(a)
    );
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, s = 0) {
    return this._x = e[s], this._y = e[s + 1], this._z = e[s + 2], this._w = e[s + 3], this._onChangeCallback(), this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this._x, e[s + 1] = this._y, e[s + 2] = this._z, e[s + 3] = this._w, e;
  }
  fromBufferAttribute(e, s) {
    return this._x = e.getX(s), this._y = e.getY(s), this._z = e.getZ(s), this._w = e.getW(s), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}, Vector3$1 = class Dd {
  constructor(e = 0, s = 0, o = 0) {
    Dd.prototype.isVector3 = !0, this.x = e, this.y = s, this.z = o;
  }
  set(e, s, o) {
    return o === void 0 && (o = this.z), this.x = e, this.y = s, this.z = o, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setComponent(e, s) {
    switch (e) {
      case 0:
        this.x = s;
        break;
      case 1:
        this.y = s;
        break;
      case 2:
        this.z = s;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  addVectors(e, s) {
    return this.x = e.x + s.x, this.y = e.y + s.y, this.z = e.z + s.z, this;
  }
  addScaledVector(e, s) {
    return this.x += e.x * s, this.y += e.y * s, this.z += e.z * s, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  subVectors(e, s) {
    return this.x = e.x - s.x, this.y = e.y - s.y, this.z = e.z - s.z, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  multiplyVectors(e, s) {
    return this.x = e.x * s.x, this.y = e.y * s.y, this.z = e.z * s.z, this;
  }
  applyEuler(e) {
    return this.applyQuaternion(_quaternion$4$1.setFromEuler(e));
  }
  applyAxisAngle(e, s) {
    return this.applyQuaternion(_quaternion$4$1.setFromAxisAngle(e, s));
  }
  applyMatrix3(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements;
    return this.x = l[0] * s + l[3] * o + l[6] * a, this.y = l[1] * s + l[4] * o + l[7] * a, this.z = l[2] * s + l[5] * o + l[8] * a, this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements, u = 1 / (l[3] * s + l[7] * o + l[11] * a + l[15]);
    return this.x = (l[0] * s + l[4] * o + l[8] * a + l[12]) * u, this.y = (l[1] * s + l[5] * o + l[9] * a + l[13]) * u, this.z = (l[2] * s + l[6] * o + l[10] * a + l[14]) * u, this;
  }
  applyQuaternion(e) {
    const s = this.x, o = this.y, a = this.z, l = e.x, u = e.y, c = e.z, E = e.w, d = E * s + u * a - c * o, f = E * o + c * s - l * a, h = E * a + l * o - u * s, S = -l * s - u * o - c * a;
    return this.x = d * E + S * -l + f * -c - h * -u, this.y = f * E + S * -u + h * -l - d * -c, this.z = h * E + S * -c + d * -u - f * -l, this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements;
    return this.x = l[0] * s + l[4] * o + l[8] * a, this.y = l[1] * s + l[5] * o + l[9] * a, this.z = l[2] * s + l[6] * o + l[10] * a, this.normalize();
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  clamp(e, s) {
    return this.x = Math.max(e.x, Math.min(s.x, this.x)), this.y = Math.max(e.y, Math.min(s.y, this.y)), this.z = Math.max(e.z, Math.min(s.z, this.z)), this;
  }
  clampScalar(e, s) {
    return this.x = Math.max(e, Math.min(s, this.x)), this.y = Math.max(e, Math.min(s, this.y)), this.z = Math.max(e, Math.min(s, this.z)), this;
  }
  clampLength(e, s) {
    const o = this.length();
    return this.divideScalar(o || 1).multiplyScalar(Math.max(e, Math.min(s, o)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, s) {
    return this.x += (e.x - this.x) * s, this.y += (e.y - this.y) * s, this.z += (e.z - this.z) * s, this;
  }
  lerpVectors(e, s, o) {
    return this.x = e.x + (s.x - e.x) * o, this.y = e.y + (s.y - e.y) * o, this.z = e.z + (s.z - e.z) * o, this;
  }
  cross(e) {
    return this.crossVectors(this, e);
  }
  crossVectors(e, s) {
    const o = e.x, a = e.y, l = e.z, u = s.x, c = s.y, E = s.z;
    return this.x = a * E - l * c, this.y = l * u - o * E, this.z = o * c - a * u, this;
  }
  projectOnVector(e) {
    const s = e.lengthSq();
    if (s === 0)
      return this.set(0, 0, 0);
    const o = e.dot(this) / s;
    return this.copy(e).multiplyScalar(o);
  }
  projectOnPlane(e) {
    return _vector$b$1.copy(this).projectOnVector(e), this.sub(_vector$b$1);
  }
  reflect(e) {
    return this.sub(_vector$b$1.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  angleTo(e) {
    const s = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (s === 0)
      return Math.PI / 2;
    const o = this.dot(e) / s;
    return Math.acos(clamp$2(o, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const s = this.x - e.x, o = this.y - e.y, a = this.z - e.z;
    return s * s + o * o + a * a;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, s, o) {
    const a = Math.sin(s) * e;
    return this.x = a * Math.sin(o), this.y = Math.cos(s) * e, this.z = a * Math.cos(o), this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, s, o) {
    return this.x = e * Math.sin(s), this.y = o, this.z = e * Math.cos(s), this;
  }
  setFromMatrixPosition(e) {
    const s = e.elements;
    return this.x = s[12], this.y = s[13], this.z = s[14], this;
  }
  setFromMatrixScale(e) {
    const s = this.setFromMatrixColumn(e, 0).length(), o = this.setFromMatrixColumn(e, 1).length(), a = this.setFromMatrixColumn(e, 2).length();
    return this.x = s, this.y = o, this.z = a, this;
  }
  setFromMatrixColumn(e, s) {
    return this.fromArray(e.elements, s * 4);
  }
  setFromMatrix3Column(e, s) {
    return this.fromArray(e.elements, s * 3);
  }
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, s = 0) {
    return this.x = e[s], this.y = e[s + 1], this.z = e[s + 2], this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this.x, e[s + 1] = this.y, e[s + 2] = this.z, e;
  }
  fromBufferAttribute(e, s) {
    return this.x = e.getX(s), this.y = e.getY(s), this.z = e.getZ(s), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const e = (Math.random() - 0.5) * 2, s = Math.random() * Math.PI * 2, o = Math.sqrt(1 - e ** 2);
    return this.x = o * Math.cos(s), this.y = o * Math.sin(s), this.z = e, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
};
const _vector$b$1 = /* @__PURE__ */ new Vector3$1(), _quaternion$4$1 = /* @__PURE__ */ new Quaternion$1();
let Box3$1 = class {
  constructor(e = new Vector3$1(1 / 0, 1 / 0, 1 / 0), s = new Vector3$1(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = s;
  }
  set(e, s) {
    return this.min.copy(e), this.max.copy(s), this;
  }
  setFromArray(e) {
    this.makeEmpty();
    for (let s = 0, o = e.length; s < o; s += 3)
      this.expandByPoint(_vector$a$1.fromArray(e, s));
    return this;
  }
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let s = 0, o = e.count; s < o; s++)
      this.expandByPoint(_vector$a$1.fromBufferAttribute(e, s));
    return this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let s = 0, o = e.length; s < o; s++)
      this.expandByPoint(e[s]);
    return this;
  }
  setFromCenterAndSize(e, s) {
    const o = _vector$a$1.copy(s).multiplyScalar(0.5);
    return this.min.copy(e).sub(o), this.max.copy(e).add(o), this;
  }
  setFromObject(e, s = !1) {
    return this.makeEmpty(), this.expandByObject(e, s);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  expandByObject(e, s = !1) {
    if (e.updateWorldMatrix(!1, !1), e.boundingBox !== void 0)
      e.boundingBox === null && e.computeBoundingBox(), _box$3$1.copy(e.boundingBox), _box$3$1.applyMatrix4(e.matrixWorld), this.union(_box$3$1);
    else {
      const a = e.geometry;
      if (a !== void 0)
        if (s && a.attributes !== void 0 && a.attributes.position !== void 0) {
          const l = a.attributes.position;
          for (let u = 0, c = l.count; u < c; u++)
            _vector$a$1.fromBufferAttribute(l, u).applyMatrix4(e.matrixWorld), this.expandByPoint(_vector$a$1);
        } else
          a.boundingBox === null && a.computeBoundingBox(), _box$3$1.copy(a.boundingBox), _box$3$1.applyMatrix4(e.matrixWorld), this.union(_box$3$1);
    }
    const o = e.children;
    for (let a = 0, l = o.length; a < l; a++)
      this.expandByObject(o[a], s);
    return this;
  }
  containsPoint(e) {
    return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, s) {
    return s.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(e) {
    return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
  }
  intersectsSphere(e) {
    return this.clampPoint(e.center, _vector$a$1), _vector$a$1.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let s, o;
    return e.normal.x > 0 ? (s = e.normal.x * this.min.x, o = e.normal.x * this.max.x) : (s = e.normal.x * this.max.x, o = e.normal.x * this.min.x), e.normal.y > 0 ? (s += e.normal.y * this.min.y, o += e.normal.y * this.max.y) : (s += e.normal.y * this.max.y, o += e.normal.y * this.min.y), e.normal.z > 0 ? (s += e.normal.z * this.min.z, o += e.normal.z * this.max.z) : (s += e.normal.z * this.max.z, o += e.normal.z * this.min.z), s <= -e.constant && o >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(_center$1), _extents$1.subVectors(this.max, _center$1), _v0$2$1.subVectors(e.a, _center$1), _v1$7$1.subVectors(e.b, _center$1), _v2$4$1.subVectors(e.c, _center$1), _f0$1.subVectors(_v1$7$1, _v0$2$1), _f1$1.subVectors(_v2$4$1, _v1$7$1), _f2$1.subVectors(_v0$2$1, _v2$4$1);
    let s = [
      0,
      -_f0$1.z,
      _f0$1.y,
      0,
      -_f1$1.z,
      _f1$1.y,
      0,
      -_f2$1.z,
      _f2$1.y,
      _f0$1.z,
      0,
      -_f0$1.x,
      _f1$1.z,
      0,
      -_f1$1.x,
      _f2$1.z,
      0,
      -_f2$1.x,
      -_f0$1.y,
      _f0$1.x,
      0,
      -_f1$1.y,
      _f1$1.x,
      0,
      -_f2$1.y,
      _f2$1.x,
      0
    ];
    return !satForAxes$1(s, _v0$2$1, _v1$7$1, _v2$4$1, _extents$1) || (s = [1, 0, 0, 0, 1, 0, 0, 0, 1], !satForAxes$1(s, _v0$2$1, _v1$7$1, _v2$4$1, _extents$1)) ? !1 : (_triangleNormal$1.crossVectors(_f0$1, _f1$1), s = [_triangleNormal$1.x, _triangleNormal$1.y, _triangleNormal$1.z], satForAxes$1(s, _v0$2$1, _v1$7$1, _v2$4$1, _extents$1));
  }
  clampPoint(e, s) {
    return s.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return this.clampPoint(e, _vector$a$1).distanceTo(e);
  }
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(_vector$a$1).length() * 0.5), e;
  }
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  applyMatrix4(e) {
    return this.isEmpty() ? this : (_points$1[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), _points$1[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), _points$1[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), _points$1[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), _points$1[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), _points$1[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), _points$1[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), _points$1[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(_points$1), this);
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
};
const _points$1 = [
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1()
], _vector$a$1 = /* @__PURE__ */ new Vector3$1(), _box$3$1 = /* @__PURE__ */ new Box3$1(), _v0$2$1 = /* @__PURE__ */ new Vector3$1(), _v1$7$1 = /* @__PURE__ */ new Vector3$1(), _v2$4$1 = /* @__PURE__ */ new Vector3$1(), _f0$1 = /* @__PURE__ */ new Vector3$1(), _f1$1 = /* @__PURE__ */ new Vector3$1(), _f2$1 = /* @__PURE__ */ new Vector3$1(), _center$1 = /* @__PURE__ */ new Vector3$1(), _extents$1 = /* @__PURE__ */ new Vector3$1(), _triangleNormal$1 = /* @__PURE__ */ new Vector3$1(), _testAxis$1 = /* @__PURE__ */ new Vector3$1();
function satForAxes$1(r, e, s, o, a) {
  for (let l = 0, u = r.length - 3; l <= u; l += 3) {
    _testAxis$1.fromArray(r, l);
    const c = a.x * Math.abs(_testAxis$1.x) + a.y * Math.abs(_testAxis$1.y) + a.z * Math.abs(_testAxis$1.z), E = e.dot(_testAxis$1), d = s.dot(_testAxis$1), f = o.dot(_testAxis$1);
    if (Math.max(-Math.max(E, d, f), Math.min(E, d, f)) > c)
      return !1;
  }
  return !0;
}
const _box$2$1 = /* @__PURE__ */ new Box3$1(), _v1$6$1 = /* @__PURE__ */ new Vector3$1(), _v2$3$1 = /* @__PURE__ */ new Vector3$1();
let Sphere$1 = class {
  constructor(e = new Vector3$1(), s = -1) {
    this.center = e, this.radius = s;
  }
  set(e, s) {
    return this.center.copy(e), this.radius = s, this;
  }
  setFromPoints(e, s) {
    const o = this.center;
    s !== void 0 ? o.copy(s) : _box$2$1.setFromPoints(e).getCenter(o);
    let a = 0;
    for (let l = 0, u = e.length; l < u; l++)
      a = Math.max(a, o.distanceToSquared(e[l]));
    return this.radius = Math.sqrt(a), this;
  }
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    const s = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= s * s;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, s) {
    const o = this.center.distanceToSquared(e);
    return s.copy(e), o > this.radius * this.radius && (s.sub(this.center).normalize(), s.multiplyScalar(this.radius).add(this.center)), s;
  }
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  translate(e) {
    return this.center.add(e), this;
  }
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    _v1$6$1.subVectors(e, this.center);
    const s = _v1$6$1.lengthSq();
    if (s > this.radius * this.radius) {
      const o = Math.sqrt(s), a = (o - this.radius) * 0.5;
      this.center.addScaledVector(_v1$6$1, a / o), this.radius += a;
    }
    return this;
  }
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (_v2$3$1.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(_v1$6$1.copy(e.center).add(_v2$3$1)), this.expandByPoint(_v1$6$1.copy(e.center).sub(_v2$3$1))), this);
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
const _vector$9 = /* @__PURE__ */ new Vector3$1(), _segCenter = /* @__PURE__ */ new Vector3$1(), _segDir = /* @__PURE__ */ new Vector3$1(), _diff = /* @__PURE__ */ new Vector3$1(), _edge1 = /* @__PURE__ */ new Vector3$1(), _edge2 = /* @__PURE__ */ new Vector3$1(), _normal$1 = /* @__PURE__ */ new Vector3$1();
class Ray {
  constructor(e = new Vector3$1(), s = new Vector3$1(0, 0, -1)) {
    this.origin = e, this.direction = s;
  }
  set(e, s) {
    return this.origin.copy(e), this.direction.copy(s), this;
  }
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  at(e, s) {
    return s.copy(this.origin).addScaledVector(this.direction, e);
  }
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  recast(e) {
    return this.origin.copy(this.at(e, _vector$9)), this;
  }
  closestPointToPoint(e, s) {
    s.subVectors(e, this.origin);
    const o = s.dot(this.direction);
    return o < 0 ? s.copy(this.origin) : s.copy(this.origin).addScaledVector(this.direction, o);
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  distanceSqToPoint(e) {
    const s = _vector$9.subVectors(e, this.origin).dot(this.direction);
    return s < 0 ? this.origin.distanceToSquared(e) : (_vector$9.copy(this.origin).addScaledVector(this.direction, s), _vector$9.distanceToSquared(e));
  }
  distanceSqToSegment(e, s, o, a) {
    _segCenter.copy(e).add(s).multiplyScalar(0.5), _segDir.copy(s).sub(e).normalize(), _diff.copy(this.origin).sub(_segCenter);
    const l = e.distanceTo(s) * 0.5, u = -this.direction.dot(_segDir), c = _diff.dot(this.direction), E = -_diff.dot(_segDir), d = _diff.lengthSq(), f = Math.abs(1 - u * u);
    let h, S, R, _;
    if (f > 0)
      if (h = u * E - c, S = u * c - E, _ = l * f, h >= 0)
        if (S >= -_)
          if (S <= _) {
            const m = 1 / f;
            h *= m, S *= m, R = h * (h + u * S + 2 * c) + S * (u * h + S + 2 * E) + d;
          } else
            S = l, h = Math.max(0, -(u * S + c)), R = -h * h + S * (S + 2 * E) + d;
        else
          S = -l, h = Math.max(0, -(u * S + c)), R = -h * h + S * (S + 2 * E) + d;
      else
        S <= -_ ? (h = Math.max(0, -(-u * l + c)), S = h > 0 ? -l : Math.min(Math.max(-l, -E), l), R = -h * h + S * (S + 2 * E) + d) : S <= _ ? (h = 0, S = Math.min(Math.max(-l, -E), l), R = S * (S + 2 * E) + d) : (h = Math.max(0, -(u * l + c)), S = h > 0 ? l : Math.min(Math.max(-l, -E), l), R = -h * h + S * (S + 2 * E) + d);
    else
      S = u > 0 ? -l : l, h = Math.max(0, -(u * S + c)), R = -h * h + S * (S + 2 * E) + d;
    return o && o.copy(this.origin).addScaledVector(this.direction, h), a && a.copy(_segCenter).addScaledVector(_segDir, S), R;
  }
  intersectSphere(e, s) {
    _vector$9.subVectors(e.center, this.origin);
    const o = _vector$9.dot(this.direction), a = _vector$9.dot(_vector$9) - o * o, l = e.radius * e.radius;
    if (a > l)
      return null;
    const u = Math.sqrt(l - a), c = o - u, E = o + u;
    return E < 0 ? null : c < 0 ? this.at(E, s) : this.at(c, s);
  }
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  distanceToPlane(e) {
    const s = e.normal.dot(this.direction);
    if (s === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const o = -(this.origin.dot(e.normal) + e.constant) / s;
    return o >= 0 ? o : null;
  }
  intersectPlane(e, s) {
    const o = this.distanceToPlane(e);
    return o === null ? null : this.at(o, s);
  }
  intersectsPlane(e) {
    const s = e.distanceToPoint(this.origin);
    return s === 0 || e.normal.dot(this.direction) * s < 0;
  }
  intersectBox(e, s) {
    let o, a, l, u, c, E;
    const d = 1 / this.direction.x, f = 1 / this.direction.y, h = 1 / this.direction.z, S = this.origin;
    return d >= 0 ? (o = (e.min.x - S.x) * d, a = (e.max.x - S.x) * d) : (o = (e.max.x - S.x) * d, a = (e.min.x - S.x) * d), f >= 0 ? (l = (e.min.y - S.y) * f, u = (e.max.y - S.y) * f) : (l = (e.max.y - S.y) * f, u = (e.min.y - S.y) * f), o > u || l > a || ((l > o || isNaN(o)) && (o = l), (u < a || isNaN(a)) && (a = u), h >= 0 ? (c = (e.min.z - S.z) * h, E = (e.max.z - S.z) * h) : (c = (e.max.z - S.z) * h, E = (e.min.z - S.z) * h), o > E || c > a) || ((c > o || o !== o) && (o = c), (E < a || a !== a) && (a = E), a < 0) ? null : this.at(o >= 0 ? o : a, s);
  }
  intersectsBox(e) {
    return this.intersectBox(e, _vector$9) !== null;
  }
  intersectTriangle(e, s, o, a, l) {
    _edge1.subVectors(s, e), _edge2.subVectors(o, e), _normal$1.crossVectors(_edge1, _edge2);
    let u = this.direction.dot(_normal$1), c;
    if (u > 0) {
      if (a)
        return null;
      c = 1;
    } else if (u < 0)
      c = -1, u = -u;
    else
      return null;
    _diff.subVectors(this.origin, e);
    const E = c * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (E < 0)
      return null;
    const d = c * this.direction.dot(_edge1.cross(_diff));
    if (d < 0 || E + d > u)
      return null;
    const f = -c * _diff.dot(_normal$1);
    return f < 0 ? null : this.at(f / u, l);
  }
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix4 {
  constructor(e, s, o, a, l, u, c, E, d, f, h, S, R, _, m, L) {
    Matrix4.prototype.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, s, o, a, l, u, c, E, d, f, h, S, R, _, m, L);
  }
  set(e, s, o, a, l, u, c, E, d, f, h, S, R, _, m, L) {
    const F = this.elements;
    return F[0] = e, F[4] = s, F[8] = o, F[12] = a, F[1] = l, F[5] = u, F[9] = c, F[13] = E, F[2] = d, F[6] = f, F[10] = h, F[14] = S, F[3] = R, F[7] = _, F[11] = m, F[15] = L, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  copy(e) {
    const s = this.elements, o = e.elements;
    return s[0] = o[0], s[1] = o[1], s[2] = o[2], s[3] = o[3], s[4] = o[4], s[5] = o[5], s[6] = o[6], s[7] = o[7], s[8] = o[8], s[9] = o[9], s[10] = o[10], s[11] = o[11], s[12] = o[12], s[13] = o[13], s[14] = o[14], s[15] = o[15], this;
  }
  copyPosition(e) {
    const s = this.elements, o = e.elements;
    return s[12] = o[12], s[13] = o[13], s[14] = o[14], this;
  }
  setFromMatrix3(e) {
    const s = e.elements;
    return this.set(
      s[0],
      s[3],
      s[6],
      0,
      s[1],
      s[4],
      s[7],
      0,
      s[2],
      s[5],
      s[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(e, s, o) {
    return e.setFromMatrixColumn(this, 0), s.setFromMatrixColumn(this, 1), o.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(e, s, o) {
    return this.set(
      e.x,
      s.x,
      o.x,
      0,
      e.y,
      s.y,
      o.y,
      0,
      e.z,
      s.z,
      o.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(e) {
    const s = this.elements, o = e.elements, a = 1 / _v1$5.setFromMatrixColumn(e, 0).length(), l = 1 / _v1$5.setFromMatrixColumn(e, 1).length(), u = 1 / _v1$5.setFromMatrixColumn(e, 2).length();
    return s[0] = o[0] * a, s[1] = o[1] * a, s[2] = o[2] * a, s[3] = 0, s[4] = o[4] * l, s[5] = o[5] * l, s[6] = o[6] * l, s[7] = 0, s[8] = o[8] * u, s[9] = o[9] * u, s[10] = o[10] * u, s[11] = 0, s[12] = 0, s[13] = 0, s[14] = 0, s[15] = 1, this;
  }
  makeRotationFromEuler(e) {
    const s = this.elements, o = e.x, a = e.y, l = e.z, u = Math.cos(o), c = Math.sin(o), E = Math.cos(a), d = Math.sin(a), f = Math.cos(l), h = Math.sin(l);
    if (e.order === "XYZ") {
      const S = u * f, R = u * h, _ = c * f, m = c * h;
      s[0] = E * f, s[4] = -E * h, s[8] = d, s[1] = R + _ * d, s[5] = S - m * d, s[9] = -c * E, s[2] = m - S * d, s[6] = _ + R * d, s[10] = u * E;
    } else if (e.order === "YXZ") {
      const S = E * f, R = E * h, _ = d * f, m = d * h;
      s[0] = S + m * c, s[4] = _ * c - R, s[8] = u * d, s[1] = u * h, s[5] = u * f, s[9] = -c, s[2] = R * c - _, s[6] = m + S * c, s[10] = u * E;
    } else if (e.order === "ZXY") {
      const S = E * f, R = E * h, _ = d * f, m = d * h;
      s[0] = S - m * c, s[4] = -u * h, s[8] = _ + R * c, s[1] = R + _ * c, s[5] = u * f, s[9] = m - S * c, s[2] = -u * d, s[6] = c, s[10] = u * E;
    } else if (e.order === "ZYX") {
      const S = u * f, R = u * h, _ = c * f, m = c * h;
      s[0] = E * f, s[4] = _ * d - R, s[8] = S * d + m, s[1] = E * h, s[5] = m * d + S, s[9] = R * d - _, s[2] = -d, s[6] = c * E, s[10] = u * E;
    } else if (e.order === "YZX") {
      const S = u * E, R = u * d, _ = c * E, m = c * d;
      s[0] = E * f, s[4] = m - S * h, s[8] = _ * h + R, s[1] = h, s[5] = u * f, s[9] = -c * f, s[2] = -d * f, s[6] = R * h + _, s[10] = S - m * h;
    } else if (e.order === "XZY") {
      const S = u * E, R = u * d, _ = c * E, m = c * d;
      s[0] = E * f, s[4] = -h, s[8] = d * f, s[1] = S * h + m, s[5] = u * f, s[9] = R * h - _, s[2] = _ * h - R, s[6] = c * f, s[10] = m * h + S;
    }
    return s[3] = 0, s[7] = 0, s[11] = 0, s[12] = 0, s[13] = 0, s[14] = 0, s[15] = 1, this;
  }
  makeRotationFromQuaternion(e) {
    return this.compose(_zero, e, _one);
  }
  lookAt(e, s, o) {
    const a = this.elements;
    return _z.subVectors(e, s), _z.lengthSq() === 0 && (_z.z = 1), _z.normalize(), _x.crossVectors(o, _z), _x.lengthSq() === 0 && (Math.abs(o.z) === 1 ? _z.x += 1e-4 : _z.z += 1e-4, _z.normalize(), _x.crossVectors(o, _z)), _x.normalize(), _y.crossVectors(_z, _x), a[0] = _x.x, a[4] = _y.x, a[8] = _z.x, a[1] = _x.y, a[5] = _y.y, a[9] = _z.y, a[2] = _x.z, a[6] = _y.z, a[10] = _z.z, this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, s) {
    const o = e.elements, a = s.elements, l = this.elements, u = o[0], c = o[4], E = o[8], d = o[12], f = o[1], h = o[5], S = o[9], R = o[13], _ = o[2], m = o[6], L = o[10], F = o[14], W = o[3], G = o[7], q = o[11], fe = o[15], _e = a[0], Le = a[4], Fe = a[8], Ee = a[12], Ge = a[1], ve = a[5], te = a[9], ae = a[13], v = a[2], Te = a[6], De = a[10], be = a[14], ze = a[3], ke = a[7], Be = a[11], Me = a[15];
    return l[0] = u * _e + c * Ge + E * v + d * ze, l[4] = u * Le + c * ve + E * Te + d * ke, l[8] = u * Fe + c * te + E * De + d * Be, l[12] = u * Ee + c * ae + E * be + d * Me, l[1] = f * _e + h * Ge + S * v + R * ze, l[5] = f * Le + h * ve + S * Te + R * ke, l[9] = f * Fe + h * te + S * De + R * Be, l[13] = f * Ee + h * ae + S * be + R * Me, l[2] = _ * _e + m * Ge + L * v + F * ze, l[6] = _ * Le + m * ve + L * Te + F * ke, l[10] = _ * Fe + m * te + L * De + F * Be, l[14] = _ * Ee + m * ae + L * be + F * Me, l[3] = W * _e + G * Ge + q * v + fe * ze, l[7] = W * Le + G * ve + q * Te + fe * ke, l[11] = W * Fe + G * te + q * De + fe * Be, l[15] = W * Ee + G * ae + q * be + fe * Me, this;
  }
  multiplyScalar(e) {
    const s = this.elements;
    return s[0] *= e, s[4] *= e, s[8] *= e, s[12] *= e, s[1] *= e, s[5] *= e, s[9] *= e, s[13] *= e, s[2] *= e, s[6] *= e, s[10] *= e, s[14] *= e, s[3] *= e, s[7] *= e, s[11] *= e, s[15] *= e, this;
  }
  determinant() {
    const e = this.elements, s = e[0], o = e[4], a = e[8], l = e[12], u = e[1], c = e[5], E = e[9], d = e[13], f = e[2], h = e[6], S = e[10], R = e[14], _ = e[3], m = e[7], L = e[11], F = e[15];
    return _ * (+l * E * h - a * d * h - l * c * S + o * d * S + a * c * R - o * E * R) + m * (+s * E * R - s * d * S + l * u * S - a * u * R + a * d * f - l * E * f) + L * (+s * d * h - s * c * R - l * u * h + o * u * R + l * c * f - o * d * f) + F * (-a * c * f - s * E * h + s * c * S + a * u * h - o * u * S + o * E * f);
  }
  transpose() {
    const e = this.elements;
    let s;
    return s = e[1], e[1] = e[4], e[4] = s, s = e[2], e[2] = e[8], e[8] = s, s = e[6], e[6] = e[9], e[9] = s, s = e[3], e[3] = e[12], e[12] = s, s = e[7], e[7] = e[13], e[13] = s, s = e[11], e[11] = e[14], e[14] = s, this;
  }
  setPosition(e, s, o) {
    const a = this.elements;
    return e.isVector3 ? (a[12] = e.x, a[13] = e.y, a[14] = e.z) : (a[12] = e, a[13] = s, a[14] = o), this;
  }
  invert() {
    const e = this.elements, s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], E = e[6], d = e[7], f = e[8], h = e[9], S = e[10], R = e[11], _ = e[12], m = e[13], L = e[14], F = e[15], W = h * L * d - m * S * d + m * E * R - c * L * R - h * E * F + c * S * F, G = _ * S * d - f * L * d - _ * E * R + u * L * R + f * E * F - u * S * F, q = f * m * d - _ * h * d + _ * c * R - u * m * R - f * c * F + u * h * F, fe = _ * h * E - f * m * E - _ * c * S + u * m * S + f * c * L - u * h * L, _e = s * W + o * G + a * q + l * fe;
    if (_e === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const Le = 1 / _e;
    return e[0] = W * Le, e[1] = (m * S * l - h * L * l - m * a * R + o * L * R + h * a * F - o * S * F) * Le, e[2] = (c * L * l - m * E * l + m * a * d - o * L * d - c * a * F + o * E * F) * Le, e[3] = (h * E * l - c * S * l - h * a * d + o * S * d + c * a * R - o * E * R) * Le, e[4] = G * Le, e[5] = (f * L * l - _ * S * l + _ * a * R - s * L * R - f * a * F + s * S * F) * Le, e[6] = (_ * E * l - u * L * l - _ * a * d + s * L * d + u * a * F - s * E * F) * Le, e[7] = (u * S * l - f * E * l + f * a * d - s * S * d - u * a * R + s * E * R) * Le, e[8] = q * Le, e[9] = (_ * h * l - f * m * l - _ * o * R + s * m * R + f * o * F - s * h * F) * Le, e[10] = (u * m * l - _ * c * l + _ * o * d - s * m * d - u * o * F + s * c * F) * Le, e[11] = (f * c * l - u * h * l - f * o * d + s * h * d + u * o * R - s * c * R) * Le, e[12] = fe * Le, e[13] = (f * m * a - _ * h * a + _ * o * S - s * m * S - f * o * L + s * h * L) * Le, e[14] = (_ * c * a - u * m * a - _ * o * E + s * m * E + u * o * L - s * c * L) * Le, e[15] = (u * h * a - f * c * a + f * o * E - s * h * E - u * o * S + s * c * S) * Le, this;
  }
  scale(e) {
    const s = this.elements, o = e.x, a = e.y, l = e.z;
    return s[0] *= o, s[4] *= a, s[8] *= l, s[1] *= o, s[5] *= a, s[9] *= l, s[2] *= o, s[6] *= a, s[10] *= l, s[3] *= o, s[7] *= a, s[11] *= l, this;
  }
  getMaxScaleOnAxis() {
    const e = this.elements, s = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], o = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], a = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(s, o, a));
  }
  makeTranslation(e, s, o) {
    return e.isVector3 ? this.set(
      1,
      0,
      0,
      e.x,
      0,
      1,
      0,
      e.y,
      0,
      0,
      1,
      e.z,
      0,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      s,
      0,
      0,
      1,
      o,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(e) {
    const s = Math.cos(e), o = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      s,
      -o,
      0,
      0,
      o,
      s,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(e) {
    const s = Math.cos(e), o = Math.sin(e);
    return this.set(
      s,
      0,
      o,
      0,
      0,
      1,
      0,
      0,
      -o,
      0,
      s,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(e) {
    const s = Math.cos(e), o = Math.sin(e);
    return this.set(
      s,
      -o,
      0,
      0,
      o,
      s,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(e, s) {
    const o = Math.cos(s), a = Math.sin(s), l = 1 - o, u = e.x, c = e.y, E = e.z, d = l * u, f = l * c;
    return this.set(
      d * u + o,
      d * c - a * E,
      d * E + a * c,
      0,
      d * c + a * E,
      f * c + o,
      f * E - a * u,
      0,
      d * E - a * c,
      f * E + a * u,
      l * E * E + o,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, s, o) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      0,
      o,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(e, s, o, a, l, u) {
    return this.set(
      1,
      o,
      l,
      0,
      e,
      1,
      u,
      0,
      s,
      a,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(e, s, o) {
    const a = this.elements, l = s._x, u = s._y, c = s._z, E = s._w, d = l + l, f = u + u, h = c + c, S = l * d, R = l * f, _ = l * h, m = u * f, L = u * h, F = c * h, W = E * d, G = E * f, q = E * h, fe = o.x, _e = o.y, Le = o.z;
    return a[0] = (1 - (m + F)) * fe, a[1] = (R + q) * fe, a[2] = (_ - G) * fe, a[3] = 0, a[4] = (R - q) * _e, a[5] = (1 - (S + F)) * _e, a[6] = (L + W) * _e, a[7] = 0, a[8] = (_ + G) * Le, a[9] = (L - W) * Le, a[10] = (1 - (S + m)) * Le, a[11] = 0, a[12] = e.x, a[13] = e.y, a[14] = e.z, a[15] = 1, this;
  }
  decompose(e, s, o) {
    const a = this.elements;
    let l = _v1$5.set(a[0], a[1], a[2]).length();
    const u = _v1$5.set(a[4], a[5], a[6]).length(), c = _v1$5.set(a[8], a[9], a[10]).length();
    this.determinant() < 0 && (l = -l), e.x = a[12], e.y = a[13], e.z = a[14], _m1$2.copy(this);
    const d = 1 / l, f = 1 / u, h = 1 / c;
    return _m1$2.elements[0] *= d, _m1$2.elements[1] *= d, _m1$2.elements[2] *= d, _m1$2.elements[4] *= f, _m1$2.elements[5] *= f, _m1$2.elements[6] *= f, _m1$2.elements[8] *= h, _m1$2.elements[9] *= h, _m1$2.elements[10] *= h, s.setFromRotationMatrix(_m1$2), o.x = l, o.y = u, o.z = c, this;
  }
  makePerspective(e, s, o, a, l, u, c = WebGLCoordinateSystem) {
    const E = this.elements, d = 2 * l / (s - e), f = 2 * l / (o - a), h = (s + e) / (s - e), S = (o + a) / (o - a);
    let R, _;
    if (c === WebGLCoordinateSystem)
      R = -(u + l) / (u - l), _ = -2 * u * l / (u - l);
    else if (c === WebGPUCoordinateSystem)
      R = -u / (u - l), _ = -u * l / (u - l);
    else
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + c);
    return E[0] = d, E[4] = 0, E[8] = h, E[12] = 0, E[1] = 0, E[5] = f, E[9] = S, E[13] = 0, E[2] = 0, E[6] = 0, E[10] = R, E[14] = _, E[3] = 0, E[7] = 0, E[11] = -1, E[15] = 0, this;
  }
  makeOrthographic(e, s, o, a, l, u, c = WebGLCoordinateSystem) {
    const E = this.elements, d = 1 / (s - e), f = 1 / (o - a), h = 1 / (u - l), S = (s + e) * d, R = (o + a) * f;
    let _, m;
    if (c === WebGLCoordinateSystem)
      _ = (u + l) * h, m = -2 * h;
    else if (c === WebGPUCoordinateSystem)
      _ = l * h, m = -1 * h;
    else
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + c);
    return E[0] = 2 * d, E[4] = 0, E[8] = 0, E[12] = -S, E[1] = 0, E[5] = 2 * f, E[9] = 0, E[13] = -R, E[2] = 0, E[6] = 0, E[10] = m, E[14] = -_, E[3] = 0, E[7] = 0, E[11] = 0, E[15] = 1, this;
  }
  equals(e) {
    const s = this.elements, o = e.elements;
    for (let a = 0; a < 16; a++)
      if (s[a] !== o[a])
        return !1;
    return !0;
  }
  fromArray(e, s = 0) {
    for (let o = 0; o < 16; o++)
      this.elements[o] = e[o + s];
    return this;
  }
  toArray(e = [], s = 0) {
    const o = this.elements;
    return e[s] = o[0], e[s + 1] = o[1], e[s + 2] = o[2], e[s + 3] = o[3], e[s + 4] = o[4], e[s + 5] = o[5], e[s + 6] = o[6], e[s + 7] = o[7], e[s + 8] = o[8], e[s + 9] = o[9], e[s + 10] = o[10], e[s + 11] = o[11], e[s + 12] = o[12], e[s + 13] = o[13], e[s + 14] = o[14], e[s + 15] = o[15], e;
  }
}
const _v1$5 = /* @__PURE__ */ new Vector3$1(), _m1$2 = /* @__PURE__ */ new Matrix4(), _zero = /* @__PURE__ */ new Vector3$1(0, 0, 0), _one = /* @__PURE__ */ new Vector3$1(1, 1, 1), _x = /* @__PURE__ */ new Vector3$1(), _y = /* @__PURE__ */ new Vector3$1(), _z = /* @__PURE__ */ new Vector3$1(), _matrix = /* @__PURE__ */ new Matrix4(), _quaternion$3 = /* @__PURE__ */ new Quaternion$1();
class Euler {
  constructor(e = 0, s = 0, o = 0, a = Euler.DEFAULT_ORDER) {
    this.isEuler = !0, this._x = e, this._y = s, this._z = o, this._order = a;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  set(e, s, o, a = this._order) {
    return this._x = e, this._y = s, this._z = o, this._order = a, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e, s = this._order, o = !0) {
    const a = e.elements, l = a[0], u = a[4], c = a[8], E = a[1], d = a[5], f = a[9], h = a[2], S = a[6], R = a[10];
    switch (s) {
      case "XYZ":
        this._y = Math.asin(clamp$2(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(-f, R), this._z = Math.atan2(-u, l)) : (this._x = Math.atan2(S, d), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$2(f, -1, 1)), Math.abs(f) < 0.9999999 ? (this._y = Math.atan2(c, R), this._z = Math.atan2(E, d)) : (this._y = Math.atan2(-h, l), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(clamp$2(S, -1, 1)), Math.abs(S) < 0.9999999 ? (this._y = Math.atan2(-h, R), this._z = Math.atan2(-u, d)) : (this._y = 0, this._z = Math.atan2(E, l));
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$2(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(S, R), this._z = Math.atan2(E, l)) : (this._x = 0, this._z = Math.atan2(-u, d));
        break;
      case "YZX":
        this._z = Math.asin(clamp$2(E, -1, 1)), Math.abs(E) < 0.9999999 ? (this._x = Math.atan2(-f, d), this._y = Math.atan2(-h, l)) : (this._x = 0, this._y = Math.atan2(c, R));
        break;
      case "XZY":
        this._z = Math.asin(-clamp$2(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._x = Math.atan2(S, d), this._y = Math.atan2(c, l)) : (this._x = Math.atan2(-f, R), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + s);
    }
    return this._order = s, o === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(e, s, o) {
    return _matrix.makeRotationFromQuaternion(e), this.setFromRotationMatrix(_matrix, s, o);
  }
  setFromVector3(e, s = this._order) {
    return this.set(e.x, e.y, e.z, s);
  }
  reorder(e) {
    return _quaternion$3.setFromEuler(this), this.setFromQuaternion(_quaternion$3, e);
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this._x, e[s + 1] = this._y, e[s + 2] = this._z, e[s + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
}
Euler.DEFAULT_ORDER = "XYZ";
class Layers {
  constructor() {
    this.mask = 1;
  }
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3$1(), _q1 = /* @__PURE__ */ new Quaternion$1(), _m1$1 = /* @__PURE__ */ new Matrix4(), _target = /* @__PURE__ */ new Vector3$1(), _position$3 = /* @__PURE__ */ new Vector3$1(), _scale$2 = /* @__PURE__ */ new Vector3$1(), _quaternion$2 = /* @__PURE__ */ new Quaternion$1(), _xAxis = /* @__PURE__ */ new Vector3$1(1, 0, 0), _yAxis = /* @__PURE__ */ new Vector3$1(0, 1, 0), _zAxis = /* @__PURE__ */ new Vector3$1(0, 0, 1), _addedEvent = { type: "added" }, _removedEvent = { type: "removed" };
class Object3D extends EventDispatcher {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: _object3DId++ }), this.uuid = generateUUID$1(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Object3D.DEFAULT_UP.clone();
    const e = new Vector3$1(), s = new Euler(), o = new Quaternion$1(), a = new Vector3$1(1, 1, 1);
    function l() {
      o.setFromEuler(s, !1);
    }
    function u() {
      s.setFromQuaternion(o, void 0, !1);
    }
    s._onChange(l), o._onChange(u), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: s
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: o
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: a
      },
      modelViewMatrix: {
        value: new Matrix4()
      },
      normalMatrix: {
        value: new Matrix3$1()
      }
    }), this.matrix = new Matrix4(), this.matrixWorld = new Matrix4(), this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new Layers(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  setRotationFromAxisAngle(e, s) {
    this.quaternion.setFromAxisAngle(e, s);
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  rotateOnAxis(e, s) {
    return _q1.setFromAxisAngle(e, s), this.quaternion.multiply(_q1), this;
  }
  rotateOnWorldAxis(e, s) {
    return _q1.setFromAxisAngle(e, s), this.quaternion.premultiply(_q1), this;
  }
  rotateX(e) {
    return this.rotateOnAxis(_xAxis, e);
  }
  rotateY(e) {
    return this.rotateOnAxis(_yAxis, e);
  }
  rotateZ(e) {
    return this.rotateOnAxis(_zAxis, e);
  }
  translateOnAxis(e, s) {
    return _v1$4.copy(e).applyQuaternion(this.quaternion), this.position.add(_v1$4.multiplyScalar(s)), this;
  }
  translateX(e) {
    return this.translateOnAxis(_xAxis, e);
  }
  translateY(e) {
    return this.translateOnAxis(_yAxis, e);
  }
  translateZ(e) {
    return this.translateOnAxis(_zAxis, e);
  }
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  lookAt(e, s, o) {
    e.isVector3 ? _target.copy(e) : _target.set(e, s, o);
    const a = this.parent;
    this.updateWorldMatrix(!0, !1), _position$3.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? _m1$1.lookAt(_position$3, _target, this.up) : _m1$1.lookAt(_target, _position$3, this.up), this.quaternion.setFromRotationMatrix(_m1$1), a && (_m1$1.extractRotation(a.matrixWorld), _q1.setFromRotationMatrix(_m1$1), this.quaternion.premultiply(_q1.invert()));
  }
  add(e) {
    if (arguments.length > 1) {
      for (let s = 0; s < arguments.length; s++)
        this.add(arguments[s]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.parent !== null && e.parent.remove(e), e.parent = this, this.children.push(e), e.dispatchEvent(_addedEvent)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let o = 0; o < arguments.length; o++)
        this.remove(arguments[o]);
      return this;
    }
    const s = this.children.indexOf(e);
    return s !== -1 && (e.parent = null, this.children.splice(s, 1), e.dispatchEvent(_removedEvent)), this;
  }
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  clear() {
    for (let e = 0; e < this.children.length; e++) {
      const s = this.children[e];
      s.parent = null, s.dispatchEvent(_removedEvent);
    }
    return this.children.length = 0, this;
  }
  attach(e) {
    return this.updateWorldMatrix(!0, !1), _m1$1.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), _m1$1.multiply(e.parent.matrixWorld)), e.applyMatrix4(_m1$1), this.add(e), e.updateWorldMatrix(!1, !0), this;
  }
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  getObjectByProperty(e, s) {
    if (this[e] === s)
      return this;
    for (let o = 0, a = this.children.length; o < a; o++) {
      const u = this.children[o].getObjectByProperty(e, s);
      if (u !== void 0)
        return u;
    }
  }
  getObjectsByProperty(e, s) {
    let o = [];
    this[e] === s && o.push(this);
    for (let a = 0, l = this.children.length; a < l; a++) {
      const u = this.children[a].getObjectsByProperty(e, s);
      u.length > 0 && (o = o.concat(u));
    }
    return o;
  }
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(_position$3, e, _scale$2), e;
  }
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(_position$3, _quaternion$2, e), e;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const s = this.matrixWorld.elements;
    return e.set(s[8], s[9], s[10]).normalize();
  }
  raycast() {
  }
  traverse(e) {
    e(this);
    const s = this.children;
    for (let o = 0, a = s.length; o < a; o++)
      s[o].traverse(e);
  }
  traverseVisible(e) {
    if (this.visible === !1)
      return;
    e(this);
    const s = this.children;
    for (let o = 0, a = s.length; o < a; o++)
      s[o].traverseVisible(e);
  }
  traverseAncestors(e) {
    const s = this.parent;
    s !== null && (e(s), s.traverseAncestors(e));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e = !0);
    const s = this.children;
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      (l.matrixWorldAutoUpdate === !0 || e === !0) && l.updateMatrixWorld(e);
    }
  }
  updateWorldMatrix(e, s) {
    const o = this.parent;
    if (e === !0 && o !== null && o.matrixWorldAutoUpdate === !0 && o.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), s === !0) {
      const a = this.children;
      for (let l = 0, u = a.length; l < u; l++) {
        const c = a[l];
        c.matrixWorldAutoUpdate === !0 && c.updateWorldMatrix(!1, !0);
      }
    }
  }
  toJSON(e) {
    const s = e === void 0 || typeof e == "string", o = {};
    s && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, o.metadata = {
      version: 4.6,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const a = {};
    a.uuid = this.uuid, a.type = this.type, this.name !== "" && (a.name = this.name), this.castShadow === !0 && (a.castShadow = !0), this.receiveShadow === !0 && (a.receiveShadow = !0), this.visible === !1 && (a.visible = !1), this.frustumCulled === !1 && (a.frustumCulled = !1), this.renderOrder !== 0 && (a.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (a.userData = this.userData), a.layers = this.layers.mask, a.matrix = this.matrix.toArray(), a.up = this.up.toArray(), this.matrixAutoUpdate === !1 && (a.matrixAutoUpdate = !1), this.isInstancedMesh && (a.type = "InstancedMesh", a.count = this.count, a.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (a.instanceColor = this.instanceColor.toJSON()));
    function l(c, E) {
      return c[E.uuid] === void 0 && (c[E.uuid] = E.toJSON(e)), E.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? a.background = this.background.toJSON() : this.background.isTexture && (a.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (a.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      a.geometry = l(e.geometries, this.geometry);
      const c = this.geometry.parameters;
      if (c !== void 0 && c.shapes !== void 0) {
        const E = c.shapes;
        if (Array.isArray(E))
          for (let d = 0, f = E.length; d < f; d++) {
            const h = E[d];
            l(e.shapes, h);
          }
        else
          l(e.shapes, E);
      }
    }
    if (this.isSkinnedMesh && (a.bindMode = this.bindMode, a.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (l(e.skeletons, this.skeleton), a.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const c = [];
        for (let E = 0, d = this.material.length; E < d; E++)
          c.push(l(e.materials, this.material[E]));
        a.material = c;
      } else
        a.material = l(e.materials, this.material);
    if (this.children.length > 0) {
      a.children = [];
      for (let c = 0; c < this.children.length; c++)
        a.children.push(this.children[c].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      a.animations = [];
      for (let c = 0; c < this.animations.length; c++) {
        const E = this.animations[c];
        a.animations.push(l(e.animations, E));
      }
    }
    if (s) {
      const c = u(e.geometries), E = u(e.materials), d = u(e.textures), f = u(e.images), h = u(e.shapes), S = u(e.skeletons), R = u(e.animations), _ = u(e.nodes);
      c.length > 0 && (o.geometries = c), E.length > 0 && (o.materials = E), d.length > 0 && (o.textures = d), f.length > 0 && (o.images = f), h.length > 0 && (o.shapes = h), S.length > 0 && (o.skeletons = S), R.length > 0 && (o.animations = R), _.length > 0 && (o.nodes = _);
    }
    return o.object = a, o;
    function u(c) {
      const E = [];
      for (const d in c) {
        const f = c[d];
        delete f.metadata, E.push(f);
      }
      return E;
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  copy(e, s = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.animations = e.animations, this.userData = JSON.parse(JSON.stringify(e.userData)), s === !0)
      for (let o = 0; o < e.children.length; o++) {
        const a = e.children[o];
        this.add(a.clone());
      }
    return this;
  }
}
Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3$1(0, 1, 0);
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = !0;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
const _v0$1 = /* @__PURE__ */ new Vector3$1(), _v1$3 = /* @__PURE__ */ new Vector3$1(), _v2$2 = /* @__PURE__ */ new Vector3$1(), _v3$1 = /* @__PURE__ */ new Vector3$1(), _vab = /* @__PURE__ */ new Vector3$1(), _vac = /* @__PURE__ */ new Vector3$1(), _vbc = /* @__PURE__ */ new Vector3$1(), _vap = /* @__PURE__ */ new Vector3$1(), _vbp = /* @__PURE__ */ new Vector3$1(), _vcp = /* @__PURE__ */ new Vector3$1();
let warnedGetUV = !1;
class Triangle {
  constructor(e = new Vector3$1(), s = new Vector3$1(), o = new Vector3$1()) {
    this.a = e, this.b = s, this.c = o;
  }
  static getNormal(e, s, o, a) {
    a.subVectors(o, s), _v0$1.subVectors(e, s), a.cross(_v0$1);
    const l = a.lengthSq();
    return l > 0 ? a.multiplyScalar(1 / Math.sqrt(l)) : a.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(e, s, o, a, l) {
    _v0$1.subVectors(a, s), _v1$3.subVectors(o, s), _v2$2.subVectors(e, s);
    const u = _v0$1.dot(_v0$1), c = _v0$1.dot(_v1$3), E = _v0$1.dot(_v2$2), d = _v1$3.dot(_v1$3), f = _v1$3.dot(_v2$2), h = u * d - c * c;
    if (h === 0)
      return l.set(-2, -1, -1);
    const S = 1 / h, R = (d * E - c * f) * S, _ = (u * f - c * E) * S;
    return l.set(1 - R - _, _, R);
  }
  static containsPoint(e, s, o, a) {
    return this.getBarycoord(e, s, o, a, _v3$1), _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
  }
  static getUV(e, s, o, a, l, u, c, E) {
    return warnedGetUV === !1 && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), warnedGetUV = !0), this.getInterpolation(e, s, o, a, l, u, c, E);
  }
  static getInterpolation(e, s, o, a, l, u, c, E) {
    return this.getBarycoord(e, s, o, a, _v3$1), E.setScalar(0), E.addScaledVector(l, _v3$1.x), E.addScaledVector(u, _v3$1.y), E.addScaledVector(c, _v3$1.z), E;
  }
  static isFrontFacing(e, s, o, a) {
    return _v0$1.subVectors(o, s), _v1$3.subVectors(e, s), _v0$1.cross(_v1$3).dot(a) < 0;
  }
  set(e, s, o) {
    return this.a.copy(e), this.b.copy(s), this.c.copy(o), this;
  }
  setFromPointsAndIndices(e, s, o, a) {
    return this.a.copy(e[s]), this.b.copy(e[o]), this.c.copy(e[a]), this;
  }
  setFromAttributeAndIndices(e, s, o, a) {
    return this.a.fromBufferAttribute(e, s), this.b.fromBufferAttribute(e, o), this.c.fromBufferAttribute(e, a), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  getArea() {
    return _v0$1.subVectors(this.c, this.b), _v1$3.subVectors(this.a, this.b), _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(e) {
    return Triangle.getNormal(this.a, this.b, this.c, e);
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(e, s) {
    return Triangle.getBarycoord(e, this.a, this.b, this.c, s);
  }
  getUV(e, s, o, a, l) {
    return warnedGetUV === !1 && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), warnedGetUV = !0), Triangle.getInterpolation(e, this.a, this.b, this.c, s, o, a, l);
  }
  getInterpolation(e, s, o, a, l) {
    return Triangle.getInterpolation(e, this.a, this.b, this.c, s, o, a, l);
  }
  containsPoint(e) {
    return Triangle.containsPoint(e, this.a, this.b, this.c);
  }
  isFrontFacing(e) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, e);
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  closestPointToPoint(e, s) {
    const o = this.a, a = this.b, l = this.c;
    let u, c;
    _vab.subVectors(a, o), _vac.subVectors(l, o), _vap.subVectors(e, o);
    const E = _vab.dot(_vap), d = _vac.dot(_vap);
    if (E <= 0 && d <= 0)
      return s.copy(o);
    _vbp.subVectors(e, a);
    const f = _vab.dot(_vbp), h = _vac.dot(_vbp);
    if (f >= 0 && h <= f)
      return s.copy(a);
    const S = E * h - f * d;
    if (S <= 0 && E >= 0 && f <= 0)
      return u = E / (E - f), s.copy(o).addScaledVector(_vab, u);
    _vcp.subVectors(e, l);
    const R = _vab.dot(_vcp), _ = _vac.dot(_vcp);
    if (_ >= 0 && R <= _)
      return s.copy(l);
    const m = R * d - E * _;
    if (m <= 0 && d >= 0 && _ <= 0)
      return c = d / (d - _), s.copy(o).addScaledVector(_vac, c);
    const L = f * _ - R * h;
    if (L <= 0 && h - f >= 0 && R - _ >= 0)
      return _vbc.subVectors(l, a), c = (h - f) / (h - f + (R - _)), s.copy(a).addScaledVector(_vbc, c);
    const F = 1 / (L + m + S);
    return u = m * F, c = S * F, s.copy(o).addScaledVector(_vab, u).addScaledVector(_vac, c);
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
let materialId = 0;
class Material extends EventDispatcher {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: materialId++ }), this.uuid = generateUUID$1(), this.name = "", this.type = "Material", this.blending = NormalBlending, this.side = FrontSide, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = SrcAlphaFactor, this.blendDst = OneMinusSrcAlphaFactor, this.blendEquation = AddEquation, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = LessEqualDepth, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = AlwaysStencilFunc, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = KeepStencilOp, this.stencilZFail = KeepStencilOp, this.stencilZPass = KeepStencilOp, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  onBuild() {
  }
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(e) {
    if (e !== void 0)
      for (const s in e) {
        const o = e[s];
        if (o === void 0) {
          console.warn(`THREE.Material: parameter '${s}' has value of undefined.`);
          continue;
        }
        const a = this[s];
        if (a === void 0) {
          console.warn(`THREE.Material: '${s}' is not a property of THREE.${this.type}.`);
          continue;
        }
        a && a.isColor ? a.set(o) : a && a.isVector3 && o && o.isVector3 ? a.copy(o) : this[s] = o;
      }
  }
  toJSON(e) {
    const s = e === void 0 || typeof e == "string";
    s && (e = {
      textures: {},
      images: {}
    });
    const o = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    o.uuid = this.uuid, o.type = this.type, this.name !== "" && (o.name = this.name), this.color && this.color.isColor && (o.color = this.color.getHex()), this.roughness !== void 0 && (o.roughness = this.roughness), this.metalness !== void 0 && (o.metalness = this.metalness), this.sheen !== void 0 && (o.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (o.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (o.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (o.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (o.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (o.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (o.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (o.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (o.shininess = this.shininess), this.clearcoat !== void 0 && (o.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (o.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (o.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (o.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (o.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, o.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (o.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (o.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (o.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (o.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (o.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.anisotropy !== void 0 && (o.anisotropy = this.anisotropy), this.anisotropyRotation !== void 0 && (o.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (o.anisotropyMap = this.anisotropyMap.toJSON(e).uuid), this.map && this.map.isTexture && (o.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (o.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (o.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (o.lightMap = this.lightMap.toJSON(e).uuid, o.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (o.aoMap = this.aoMap.toJSON(e).uuid, o.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (o.bumpMap = this.bumpMap.toJSON(e).uuid, o.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (o.normalMap = this.normalMap.toJSON(e).uuid, o.normalMapType = this.normalMapType, o.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (o.displacementMap = this.displacementMap.toJSON(e).uuid, o.displacementScale = this.displacementScale, o.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (o.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (o.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (o.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (o.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (o.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (o.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (o.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (o.combine = this.combine)), this.envMapIntensity !== void 0 && (o.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (o.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (o.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (o.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (o.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (o.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (o.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (o.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (o.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (o.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (o.size = this.size), this.shadowSide !== null && (o.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (o.sizeAttenuation = this.sizeAttenuation), this.blending !== NormalBlending && (o.blending = this.blending), this.side !== FrontSide && (o.side = this.side), this.vertexColors && (o.vertexColors = !0), this.opacity < 1 && (o.opacity = this.opacity), this.transparent === !0 && (o.transparent = this.transparent), o.depthFunc = this.depthFunc, o.depthTest = this.depthTest, o.depthWrite = this.depthWrite, o.colorWrite = this.colorWrite, o.stencilWrite = this.stencilWrite, o.stencilWriteMask = this.stencilWriteMask, o.stencilFunc = this.stencilFunc, o.stencilRef = this.stencilRef, o.stencilFuncMask = this.stencilFuncMask, o.stencilFail = this.stencilFail, o.stencilZFail = this.stencilZFail, o.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (o.rotation = this.rotation), this.polygonOffset === !0 && (o.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (o.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (o.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (o.linewidth = this.linewidth), this.dashSize !== void 0 && (o.dashSize = this.dashSize), this.gapSize !== void 0 && (o.gapSize = this.gapSize), this.scale !== void 0 && (o.scale = this.scale), this.dithering === !0 && (o.dithering = !0), this.alphaTest > 0 && (o.alphaTest = this.alphaTest), this.alphaHash === !0 && (o.alphaHash = this.alphaHash), this.alphaToCoverage === !0 && (o.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (o.premultipliedAlpha = this.premultipliedAlpha), this.forceSinglePass === !0 && (o.forceSinglePass = this.forceSinglePass), this.wireframe === !0 && (o.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (o.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (o.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (o.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (o.flatShading = this.flatShading), this.visible === !1 && (o.visible = !1), this.toneMapped === !1 && (o.toneMapped = !1), this.fog === !1 && (o.fog = !1), Object.keys(this.userData).length > 0 && (o.userData = this.userData);
    function a(l) {
      const u = [];
      for (const c in l) {
        const E = l[c];
        delete E.metadata, u.push(E);
      }
      return u;
    }
    if (s) {
      const l = a(e.textures), u = a(e.images);
      l.length > 0 && (o.textures = l), u.length > 0 && (o.images = u);
    }
    return o;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const s = e.clippingPlanes;
    let o = null;
    if (s !== null) {
      const a = s.length;
      o = new Array(a);
      for (let l = 0; l !== a; ++l)
        o[l] = s[l].clone();
    }
    return this.clippingPlanes = o, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaHash = e.alphaHash, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.forceSinglePass = e.forceSinglePass, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
}
const _colorKeywords = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, _hslA = { h: 0, s: 0, l: 0 }, _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb(r, e, s) {
  return s < 0 && (s += 1), s > 1 && (s -= 1), s < 1 / 6 ? r + (e - r) * 6 * s : s < 1 / 2 ? e : s < 2 / 3 ? r + (e - r) * 6 * (2 / 3 - s) : r;
}
class Color {
  constructor(e, s, o) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e, s, o);
  }
  set(e, s, o) {
    if (s === void 0 && o === void 0) {
      const a = e;
      a && a.isColor ? this.copy(a) : typeof a == "number" ? this.setHex(a) : typeof a == "string" && this.setStyle(a);
    } else
      this.setRGB(e, s, o);
    return this;
  }
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  setHex(e, s = SRGBColorSpace) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, ColorManagement.toWorkingColorSpace(this, s), this;
  }
  setRGB(e, s, o, a = ColorManagement.workingColorSpace) {
    return this.r = e, this.g = s, this.b = o, ColorManagement.toWorkingColorSpace(this, a), this;
  }
  setHSL(e, s, o, a = ColorManagement.workingColorSpace) {
    if (e = euclideanModulo(e, 1), s = clamp$2(s, 0, 1), o = clamp$2(o, 0, 1), s === 0)
      this.r = this.g = this.b = o;
    else {
      const l = o <= 0.5 ? o * (1 + s) : o + s - o * s, u = 2 * o - l;
      this.r = hue2rgb(u, l, e + 1 / 3), this.g = hue2rgb(u, l, e), this.b = hue2rgb(u, l, e - 1 / 3);
    }
    return ColorManagement.toWorkingColorSpace(this, a), this;
  }
  setStyle(e, s = SRGBColorSpace) {
    function o(l) {
      l !== void 0 && parseFloat(l) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let a;
    if (a = /^(\w+)\(([^\)]*)\)/.exec(e)) {
      let l;
      const u = a[1], c = a[2];
      switch (u) {
        case "rgb":
        case "rgba":
          if (l = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return o(l[4]), this.setRGB(
              Math.min(255, parseInt(l[1], 10)) / 255,
              Math.min(255, parseInt(l[2], 10)) / 255,
              Math.min(255, parseInt(l[3], 10)) / 255,
              s
            );
          if (l = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return o(l[4]), this.setRGB(
              Math.min(100, parseInt(l[1], 10)) / 100,
              Math.min(100, parseInt(l[2], 10)) / 100,
              Math.min(100, parseInt(l[3], 10)) / 100,
              s
            );
          break;
        case "hsl":
        case "hsla":
          if (l = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(c))
            return o(l[4]), this.setHSL(
              parseFloat(l[1]) / 360,
              parseFloat(l[2]) / 100,
              parseFloat(l[3]) / 100,
              s
            );
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + e);
      }
    } else if (a = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const l = a[1], u = l.length;
      if (u === 3)
        return this.setRGB(
          parseInt(l.charAt(0), 16) / 15,
          parseInt(l.charAt(1), 16) / 15,
          parseInt(l.charAt(2), 16) / 15,
          s
        );
      if (u === 6)
        return this.setHex(parseInt(l, 16), s);
      console.warn("THREE.Color: Invalid hex color " + e);
    } else if (e && e.length > 0)
      return this.setColorName(e, s);
    return this;
  }
  setColorName(e, s = SRGBColorSpace) {
    const o = _colorKeywords[e.toLowerCase()];
    return o !== void 0 ? this.setHex(o, s) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  copySRGBToLinear(e) {
    return this.r = SRGBToLinear(e.r), this.g = SRGBToLinear(e.g), this.b = SRGBToLinear(e.b), this;
  }
  copyLinearToSRGB(e) {
    return this.r = LinearToSRGB(e.r), this.g = LinearToSRGB(e.g), this.b = LinearToSRGB(e.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(e = SRGBColorSpace) {
    return ColorManagement.fromWorkingColorSpace(_color$1.copy(this), e), Math.round(clamp$2(_color$1.r * 255, 0, 255)) * 65536 + Math.round(clamp$2(_color$1.g * 255, 0, 255)) * 256 + Math.round(clamp$2(_color$1.b * 255, 0, 255));
  }
  getHexString(e = SRGBColorSpace) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  getHSL(e, s = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), s);
    const o = _color$1.r, a = _color$1.g, l = _color$1.b, u = Math.max(o, a, l), c = Math.min(o, a, l);
    let E, d;
    const f = (c + u) / 2;
    if (c === u)
      E = 0, d = 0;
    else {
      const h = u - c;
      switch (d = f <= 0.5 ? h / (u + c) : h / (2 - u - c), u) {
        case o:
          E = (a - l) / h + (a < l ? 6 : 0);
          break;
        case a:
          E = (l - o) / h + 2;
          break;
        case l:
          E = (o - a) / h + 4;
          break;
      }
      E /= 6;
    }
    return e.h = E, e.s = d, e.l = f, e;
  }
  getRGB(e, s = ColorManagement.workingColorSpace) {
    return ColorManagement.fromWorkingColorSpace(_color$1.copy(this), s), e.r = _color$1.r, e.g = _color$1.g, e.b = _color$1.b, e;
  }
  getStyle(e = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), e);
    const s = _color$1.r, o = _color$1.g, a = _color$1.b;
    return e !== SRGBColorSpace ? `color(${e} ${s.toFixed(3)} ${o.toFixed(3)} ${a.toFixed(3)})` : `rgb(${Math.round(s * 255)},${Math.round(o * 255)},${Math.round(a * 255)})`;
  }
  offsetHSL(e, s, o) {
    return this.getHSL(_hslA), _hslA.h += e, _hslA.s += s, _hslA.l += o, this.setHSL(_hslA.h, _hslA.s, _hslA.l), this;
  }
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  addColors(e, s) {
    return this.r = e.r + s.r, this.g = e.g + s.g, this.b = e.b + s.b, this;
  }
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  lerp(e, s) {
    return this.r += (e.r - this.r) * s, this.g += (e.g - this.g) * s, this.b += (e.b - this.b) * s, this;
  }
  lerpColors(e, s, o) {
    return this.r = e.r + (s.r - e.r) * o, this.g = e.g + (s.g - e.g) * o, this.b = e.b + (s.b - e.b) * o, this;
  }
  lerpHSL(e, s) {
    this.getHSL(_hslA), e.getHSL(_hslB);
    const o = lerp(_hslA.h, _hslB.h, s), a = lerp(_hslA.s, _hslB.s, s), l = lerp(_hslA.l, _hslB.l, s);
    return this.setHSL(o, a, l), this;
  }
  setFromVector3(e) {
    return this.r = e.x, this.g = e.y, this.b = e.z, this;
  }
  applyMatrix3(e) {
    const s = this.r, o = this.g, a = this.b, l = e.elements;
    return this.r = l[0] * s + l[3] * o + l[6] * a, this.g = l[1] * s + l[4] * o + l[7] * a, this.b = l[2] * s + l[5] * o + l[8] * a, this;
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  fromArray(e, s = 0) {
    return this.r = e[s], this.g = e[s + 1], this.b = e[s + 2], this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this.r, e[s + 1] = this.g, e[s + 2] = this.b, e;
  }
  fromBufferAttribute(e, s) {
    return this.r = e.getX(s), this.g = e.getY(s), this.b = e.getZ(s), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
const _color$1 = /* @__PURE__ */ new Color();
Color.NAMES = _colorKeywords;
class MeshBasicMaterial extends Material {
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Color(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = MultiplyOperation, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const _vector$8 = /* @__PURE__ */ new Vector3$1(), _vector2$1 = /* @__PURE__ */ new Vector2();
class BufferAttribute {
  constructor(e, s, o = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = e, this.itemSize = s, this.count = e !== void 0 ? e.length / s : 0, this.normalized = o, this.usage = StaticDrawUsage, this.updateRange = { offset: 0, count: -1 }, this.gpuType = FloatType, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this.gpuType = e.gpuType, this;
  }
  copyAt(e, s, o) {
    e *= this.itemSize, o *= s.itemSize;
    for (let a = 0, l = this.itemSize; a < l; a++)
      this.array[e + a] = s.array[o + a];
    return this;
  }
  copyArray(e) {
    return this.array.set(e), this;
  }
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let s = 0, o = this.count; s < o; s++)
        _vector2$1.fromBufferAttribute(this, s), _vector2$1.applyMatrix3(e), this.setXY(s, _vector2$1.x, _vector2$1.y);
    else if (this.itemSize === 3)
      for (let s = 0, o = this.count; s < o; s++)
        _vector$8.fromBufferAttribute(this, s), _vector$8.applyMatrix3(e), this.setXYZ(s, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  applyMatrix4(e) {
    for (let s = 0, o = this.count; s < o; s++)
      _vector$8.fromBufferAttribute(this, s), _vector$8.applyMatrix4(e), this.setXYZ(s, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let s = 0, o = this.count; s < o; s++)
      _vector$8.fromBufferAttribute(this, s), _vector$8.applyNormalMatrix(e), this.setXYZ(s, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  transformDirection(e) {
    for (let s = 0, o = this.count; s < o; s++)
      _vector$8.fromBufferAttribute(this, s), _vector$8.transformDirection(e), this.setXYZ(s, _vector$8.x, _vector$8.y, _vector$8.z);
    return this;
  }
  set(e, s = 0) {
    return this.array.set(e, s), this;
  }
  getX(e) {
    let s = this.array[e * this.itemSize];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  setX(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.array[e * this.itemSize] = s, this;
  }
  getY(e) {
    let s = this.array[e * this.itemSize + 1];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  setY(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.array[e * this.itemSize + 1] = s, this;
  }
  getZ(e) {
    let s = this.array[e * this.itemSize + 2];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  setZ(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.array[e * this.itemSize + 2] = s, this;
  }
  getW(e) {
    let s = this.array[e * this.itemSize + 3];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  setW(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.array[e * this.itemSize + 3] = s, this;
  }
  setXY(e, s, o) {
    return e *= this.itemSize, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array)), this.array[e + 0] = s, this.array[e + 1] = o, this;
  }
  setXYZ(e, s, o, a) {
    return e *= this.itemSize, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array), a = normalize(a, this.array)), this.array[e + 0] = s, this.array[e + 1] = o, this.array[e + 2] = a, this;
  }
  setXYZW(e, s, o, a, l) {
    return e *= this.itemSize, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array), a = normalize(a, this.array), l = normalize(l, this.array)), this.array[e + 0] = s, this.array[e + 1] = o, this.array[e + 2] = a, this.array[e + 3] = l, this;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== StaticDrawUsage && (e.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (e.updateRange = this.updateRange), e;
  }
}
class Int8BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Int8Array(e), s, o);
  }
}
class Uint8BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Uint8Array(e), s, o);
  }
}
class Int16BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Int16Array(e), s, o);
  }
}
class Uint16BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Uint16Array(e), s, o);
  }
}
class Int32BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Int32Array(e), s, o);
  }
}
class Uint32BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Uint32Array(e), s, o);
  }
}
class Float32BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Float32Array(e), s, o);
  }
}
class Float64BufferAttribute extends BufferAttribute {
  constructor(e, s, o) {
    super(new Float64Array(e), s, o);
  }
}
let _id$1 = 0;
const _m1 = /* @__PURE__ */ new Matrix4(), _obj = /* @__PURE__ */ new Object3D(), _offset = /* @__PURE__ */ new Vector3$1(), _box$1$1 = /* @__PURE__ */ new Box3$1(), _boxMorphTargets = /* @__PURE__ */ new Box3$1(), _vector$7 = /* @__PURE__ */ new Vector3$1();
class BufferGeometry extends EventDispatcher {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: _id$1++ }), this.uuid = generateUUID$1(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (arrayNeedsUint32(e) ? Uint32BufferAttribute : Uint16BufferAttribute)(e, 1) : this.index = e, this;
  }
  getAttribute(e) {
    return this.attributes[e];
  }
  setAttribute(e, s) {
    return this.attributes[e] = s, this;
  }
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  addGroup(e, s, o = 0) {
    this.groups.push({
      start: e,
      count: s,
      materialIndex: o
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(e, s) {
    this.drawRange.start = e, this.drawRange.count = s;
  }
  applyMatrix4(e) {
    const s = this.attributes.position;
    s !== void 0 && (s.applyMatrix4(e), s.needsUpdate = !0);
    const o = this.attributes.normal;
    if (o !== void 0) {
      const l = new Matrix3$1().getNormalMatrix(e);
      o.applyNormalMatrix(l), o.needsUpdate = !0;
    }
    const a = this.attributes.tangent;
    return a !== void 0 && (a.transformDirection(e), a.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(e) {
    return _m1.makeRotationFromQuaternion(e), this.applyMatrix4(_m1), this;
  }
  rotateX(e) {
    return _m1.makeRotationX(e), this.applyMatrix4(_m1), this;
  }
  rotateY(e) {
    return _m1.makeRotationY(e), this.applyMatrix4(_m1), this;
  }
  rotateZ(e) {
    return _m1.makeRotationZ(e), this.applyMatrix4(_m1), this;
  }
  translate(e, s, o) {
    return _m1.makeTranslation(e, s, o), this.applyMatrix4(_m1), this;
  }
  scale(e, s, o) {
    return _m1.makeScale(e, s, o), this.applyMatrix4(_m1), this;
  }
  lookAt(e) {
    return _obj.lookAt(e), _obj.updateMatrix(), this.applyMatrix4(_obj.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(_offset).negate(), this.translate(_offset.x, _offset.y, _offset.z), this;
  }
  setFromPoints(e) {
    const s = [];
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o];
      s.push(l.x, l.y, l.z || 0);
    }
    return this.setAttribute("position", new Float32BufferAttribute(s, 3)), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Box3$1());
    const e = this.attributes.position, s = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(
        new Vector3$1(-1 / 0, -1 / 0, -1 / 0),
        new Vector3$1(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), s)
        for (let o = 0, a = s.length; o < a; o++) {
          const l = s[o];
          _box$1$1.setFromBufferAttribute(l), this.morphTargetsRelative ? (_vector$7.addVectors(this.boundingBox.min, _box$1$1.min), this.boundingBox.expandByPoint(_vector$7), _vector$7.addVectors(this.boundingBox.max, _box$1$1.max), this.boundingBox.expandByPoint(_vector$7)) : (this.boundingBox.expandByPoint(_box$1$1.min), this.boundingBox.expandByPoint(_box$1$1.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Sphere$1());
    const e = this.attributes.position, s = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new Vector3$1(), 1 / 0);
      return;
    }
    if (e) {
      const o = this.boundingSphere.center;
      if (_box$1$1.setFromBufferAttribute(e), s)
        for (let l = 0, u = s.length; l < u; l++) {
          const c = s[l];
          _boxMorphTargets.setFromBufferAttribute(c), this.morphTargetsRelative ? (_vector$7.addVectors(_box$1$1.min, _boxMorphTargets.min), _box$1$1.expandByPoint(_vector$7), _vector$7.addVectors(_box$1$1.max, _boxMorphTargets.max), _box$1$1.expandByPoint(_vector$7)) : (_box$1$1.expandByPoint(_boxMorphTargets.min), _box$1$1.expandByPoint(_boxMorphTargets.max));
        }
      _box$1$1.getCenter(o);
      let a = 0;
      for (let l = 0, u = e.count; l < u; l++)
        _vector$7.fromBufferAttribute(e, l), a = Math.max(a, o.distanceToSquared(_vector$7));
      if (s)
        for (let l = 0, u = s.length; l < u; l++) {
          const c = s[l], E = this.morphTargetsRelative;
          for (let d = 0, f = c.count; d < f; d++)
            _vector$7.fromBufferAttribute(c, d), E && (_offset.fromBufferAttribute(e, d), _vector$7.add(_offset)), a = Math.max(a, o.distanceToSquared(_vector$7));
        }
      this.boundingSphere.radius = Math.sqrt(a), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const e = this.index, s = this.attributes;
    if (e === null || s.position === void 0 || s.normal === void 0 || s.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const o = e.array, a = s.position.array, l = s.normal.array, u = s.uv.array, c = a.length / 3;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * c), 4));
    const E = this.getAttribute("tangent").array, d = [], f = [];
    for (let Ge = 0; Ge < c; Ge++)
      d[Ge] = new Vector3$1(), f[Ge] = new Vector3$1();
    const h = new Vector3$1(), S = new Vector3$1(), R = new Vector3$1(), _ = new Vector2(), m = new Vector2(), L = new Vector2(), F = new Vector3$1(), W = new Vector3$1();
    function G(Ge, ve, te) {
      h.fromArray(a, Ge * 3), S.fromArray(a, ve * 3), R.fromArray(a, te * 3), _.fromArray(u, Ge * 2), m.fromArray(u, ve * 2), L.fromArray(u, te * 2), S.sub(h), R.sub(h), m.sub(_), L.sub(_);
      const ae = 1 / (m.x * L.y - L.x * m.y);
      isFinite(ae) && (F.copy(S).multiplyScalar(L.y).addScaledVector(R, -m.y).multiplyScalar(ae), W.copy(R).multiplyScalar(m.x).addScaledVector(S, -L.x).multiplyScalar(ae), d[Ge].add(F), d[ve].add(F), d[te].add(F), f[Ge].add(W), f[ve].add(W), f[te].add(W));
    }
    let q = this.groups;
    q.length === 0 && (q = [{
      start: 0,
      count: o.length
    }]);
    for (let Ge = 0, ve = q.length; Ge < ve; ++Ge) {
      const te = q[Ge], ae = te.start, v = te.count;
      for (let Te = ae, De = ae + v; Te < De; Te += 3)
        G(
          o[Te + 0],
          o[Te + 1],
          o[Te + 2]
        );
    }
    const fe = new Vector3$1(), _e = new Vector3$1(), Le = new Vector3$1(), Fe = new Vector3$1();
    function Ee(Ge) {
      Le.fromArray(l, Ge * 3), Fe.copy(Le);
      const ve = d[Ge];
      fe.copy(ve), fe.sub(Le.multiplyScalar(Le.dot(ve))).normalize(), _e.crossVectors(Fe, ve);
      const ae = _e.dot(f[Ge]) < 0 ? -1 : 1;
      E[Ge * 4] = fe.x, E[Ge * 4 + 1] = fe.y, E[Ge * 4 + 2] = fe.z, E[Ge * 4 + 3] = ae;
    }
    for (let Ge = 0, ve = q.length; Ge < ve; ++Ge) {
      const te = q[Ge], ae = te.start, v = te.count;
      for (let Te = ae, De = ae + v; Te < De; Te += 3)
        Ee(o[Te + 0]), Ee(o[Te + 1]), Ee(o[Te + 2]);
    }
  }
  computeVertexNormals() {
    const e = this.index, s = this.getAttribute("position");
    if (s !== void 0) {
      let o = this.getAttribute("normal");
      if (o === void 0)
        o = new BufferAttribute(new Float32Array(s.count * 3), 3), this.setAttribute("normal", o);
      else
        for (let S = 0, R = o.count; S < R; S++)
          o.setXYZ(S, 0, 0, 0);
      const a = new Vector3$1(), l = new Vector3$1(), u = new Vector3$1(), c = new Vector3$1(), E = new Vector3$1(), d = new Vector3$1(), f = new Vector3$1(), h = new Vector3$1();
      if (e)
        for (let S = 0, R = e.count; S < R; S += 3) {
          const _ = e.getX(S + 0), m = e.getX(S + 1), L = e.getX(S + 2);
          a.fromBufferAttribute(s, _), l.fromBufferAttribute(s, m), u.fromBufferAttribute(s, L), f.subVectors(u, l), h.subVectors(a, l), f.cross(h), c.fromBufferAttribute(o, _), E.fromBufferAttribute(o, m), d.fromBufferAttribute(o, L), c.add(f), E.add(f), d.add(f), o.setXYZ(_, c.x, c.y, c.z), o.setXYZ(m, E.x, E.y, E.z), o.setXYZ(L, d.x, d.y, d.z);
        }
      else
        for (let S = 0, R = s.count; S < R; S += 3)
          a.fromBufferAttribute(s, S + 0), l.fromBufferAttribute(s, S + 1), u.fromBufferAttribute(s, S + 2), f.subVectors(u, l), h.subVectors(a, l), f.cross(h), o.setXYZ(S + 0, f.x, f.y, f.z), o.setXYZ(S + 1, f.x, f.y, f.z), o.setXYZ(S + 2, f.x, f.y, f.z);
      this.normalizeNormals(), o.needsUpdate = !0;
    }
  }
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let s = 0, o = e.count; s < o; s++)
      _vector$7.fromBufferAttribute(e, s), _vector$7.normalize(), e.setXYZ(s, _vector$7.x, _vector$7.y, _vector$7.z);
  }
  toNonIndexed() {
    function e(c, E) {
      const d = c.array, f = c.itemSize, h = c.normalized, S = new d.constructor(E.length * f);
      let R = 0, _ = 0;
      for (let m = 0, L = E.length; m < L; m++) {
        c.isInterleavedBufferAttribute ? R = E[m] * c.data.stride + c.offset : R = E[m] * f;
        for (let F = 0; F < f; F++)
          S[_++] = d[R++];
      }
      return new BufferAttribute(S, f, h);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const s = new BufferGeometry(), o = this.index.array, a = this.attributes;
    for (const c in a) {
      const E = a[c], d = e(E, o);
      s.setAttribute(c, d);
    }
    const l = this.morphAttributes;
    for (const c in l) {
      const E = [], d = l[c];
      for (let f = 0, h = d.length; f < h; f++) {
        const S = d[f], R = e(S, o);
        E.push(R);
      }
      s.morphAttributes[c] = E;
    }
    s.morphTargetsRelative = this.morphTargetsRelative;
    const u = this.groups;
    for (let c = 0, E = u.length; c < E; c++) {
      const d = u[c];
      s.addGroup(d.start, d.count, d.materialIndex);
    }
    return s;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const E = this.parameters;
      for (const d in E)
        E[d] !== void 0 && (e[d] = E[d]);
      return e;
    }
    e.data = { attributes: {} };
    const s = this.index;
    s !== null && (e.data.index = {
      type: s.array.constructor.name,
      array: Array.prototype.slice.call(s.array)
    });
    const o = this.attributes;
    for (const E in o) {
      const d = o[E];
      e.data.attributes[E] = d.toJSON(e.data);
    }
    const a = {};
    let l = !1;
    for (const E in this.morphAttributes) {
      const d = this.morphAttributes[E], f = [];
      for (let h = 0, S = d.length; h < S; h++) {
        const R = d[h];
        f.push(R.toJSON(e.data));
      }
      f.length > 0 && (a[E] = f, l = !0);
    }
    l && (e.data.morphAttributes = a, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const u = this.groups;
    u.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(u)));
    const c = this.boundingSphere;
    return c !== null && (e.data.boundingSphere = {
      center: c.center.toArray(),
      radius: c.radius
    }), e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const s = {};
    this.name = e.name;
    const o = e.index;
    o !== null && this.setIndex(o.clone(s));
    const a = e.attributes;
    for (const d in a) {
      const f = a[d];
      this.setAttribute(d, f.clone(s));
    }
    const l = e.morphAttributes;
    for (const d in l) {
      const f = [], h = l[d];
      for (let S = 0, R = h.length; S < R; S++)
        f.push(h[S].clone(s));
      this.morphAttributes[d] = f;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const u = e.groups;
    for (let d = 0, f = u.length; d < f; d++) {
      const h = u[d];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const c = e.boundingBox;
    c !== null && (this.boundingBox = c.clone());
    const E = e.boundingSphere;
    return E !== null && (this.boundingSphere = E.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const _inverseMatrix$3 = /* @__PURE__ */ new Matrix4(), _ray$3 = /* @__PURE__ */ new Ray(), _sphere$5 = /* @__PURE__ */ new Sphere$1(), _sphereHitAt = /* @__PURE__ */ new Vector3$1(), _vA$1$1 = /* @__PURE__ */ new Vector3$1(), _vB$1$1 = /* @__PURE__ */ new Vector3$1(), _vC$1$1 = /* @__PURE__ */ new Vector3$1(), _tempA = /* @__PURE__ */ new Vector3$1(), _morphA = /* @__PURE__ */ new Vector3$1(), _uvA$1 = /* @__PURE__ */ new Vector2(), _uvB$1 = /* @__PURE__ */ new Vector2(), _uvC$1 = /* @__PURE__ */ new Vector2(), _normalA$1 = /* @__PURE__ */ new Vector3$1(), _normalB$1 = /* @__PURE__ */ new Vector3$1(), _normalC$1 = /* @__PURE__ */ new Vector3$1(), _intersectionPoint$1 = /* @__PURE__ */ new Vector3$1(), _intersectionPointWorld = /* @__PURE__ */ new Vector3$1();
class Mesh extends Object3D {
  constructor(e = new BufferGeometry(), s = new MeshBasicMaterial()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = s, this.updateMorphTargets();
  }
  copy(e, s) {
    return super.copy(e, s), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = e.material, this.geometry = e.geometry, this;
  }
  updateMorphTargets() {
    const s = this.geometry.morphAttributes, o = Object.keys(s);
    if (o.length > 0) {
      const a = s[o[0]];
      if (a !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let l = 0, u = a.length; l < u; l++) {
          const c = a[l].name || String(l);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = l;
        }
      }
    }
  }
  getVertexPosition(e, s) {
    const o = this.geometry, a = o.attributes.position, l = o.morphAttributes.position, u = o.morphTargetsRelative;
    s.fromBufferAttribute(a, e);
    const c = this.morphTargetInfluences;
    if (l && c) {
      _morphA.set(0, 0, 0);
      for (let E = 0, d = l.length; E < d; E++) {
        const f = c[E], h = l[E];
        f !== 0 && (_tempA.fromBufferAttribute(h, e), u ? _morphA.addScaledVector(_tempA, f) : _morphA.addScaledVector(_tempA.sub(s), f));
      }
      s.add(_morphA);
    }
    return s;
  }
  raycast(e, s) {
    const o = this.geometry, a = this.material, l = this.matrixWorld;
    a !== void 0 && (o.boundingSphere === null && o.computeBoundingSphere(), _sphere$5.copy(o.boundingSphere), _sphere$5.applyMatrix4(l), _ray$3.copy(e.ray).recast(e.near), !(_sphere$5.containsPoint(_ray$3.origin) === !1 && (_ray$3.intersectSphere(_sphere$5, _sphereHitAt) === null || _ray$3.origin.distanceToSquared(_sphereHitAt) > (e.far - e.near) ** 2)) && (_inverseMatrix$3.copy(l).invert(), _ray$3.copy(e.ray).applyMatrix4(_inverseMatrix$3), !(o.boundingBox !== null && _ray$3.intersectsBox(o.boundingBox) === !1) && this._computeIntersections(e, s, _ray$3)));
  }
  _computeIntersections(e, s, o) {
    let a;
    const l = this.geometry, u = this.material, c = l.index, E = l.attributes.position, d = l.attributes.uv, f = l.attributes.uv1, h = l.attributes.normal, S = l.groups, R = l.drawRange;
    if (c !== null)
      if (Array.isArray(u))
        for (let _ = 0, m = S.length; _ < m; _++) {
          const L = S[_], F = u[L.materialIndex], W = Math.max(L.start, R.start), G = Math.min(c.count, Math.min(L.start + L.count, R.start + R.count));
          for (let q = W, fe = G; q < fe; q += 3) {
            const _e = c.getX(q), Le = c.getX(q + 1), Fe = c.getX(q + 2);
            a = checkGeometryIntersection(this, F, e, o, d, f, h, _e, Le, Fe), a && (a.faceIndex = Math.floor(q / 3), a.face.materialIndex = L.materialIndex, s.push(a));
          }
        }
      else {
        const _ = Math.max(0, R.start), m = Math.min(c.count, R.start + R.count);
        for (let L = _, F = m; L < F; L += 3) {
          const W = c.getX(L), G = c.getX(L + 1), q = c.getX(L + 2);
          a = checkGeometryIntersection(this, u, e, o, d, f, h, W, G, q), a && (a.faceIndex = Math.floor(L / 3), s.push(a));
        }
      }
    else if (E !== void 0)
      if (Array.isArray(u))
        for (let _ = 0, m = S.length; _ < m; _++) {
          const L = S[_], F = u[L.materialIndex], W = Math.max(L.start, R.start), G = Math.min(E.count, Math.min(L.start + L.count, R.start + R.count));
          for (let q = W, fe = G; q < fe; q += 3) {
            const _e = q, Le = q + 1, Fe = q + 2;
            a = checkGeometryIntersection(this, F, e, o, d, f, h, _e, Le, Fe), a && (a.faceIndex = Math.floor(q / 3), a.face.materialIndex = L.materialIndex, s.push(a));
          }
        }
      else {
        const _ = Math.max(0, R.start), m = Math.min(E.count, R.start + R.count);
        for (let L = _, F = m; L < F; L += 3) {
          const W = L, G = L + 1, q = L + 2;
          a = checkGeometryIntersection(this, u, e, o, d, f, h, W, G, q), a && (a.faceIndex = Math.floor(L / 3), s.push(a));
        }
      }
  }
}
function checkIntersection$1(r, e, s, o, a, l, u, c) {
  let E;
  if (e.side === BackSide ? E = o.intersectTriangle(u, l, a, !0, c) : E = o.intersectTriangle(a, l, u, e.side === FrontSide, c), E === null)
    return null;
  _intersectionPointWorld.copy(c), _intersectionPointWorld.applyMatrix4(r.matrixWorld);
  const d = s.ray.origin.distanceTo(_intersectionPointWorld);
  return d < s.near || d > s.far ? null : {
    distance: d,
    point: _intersectionPointWorld.clone(),
    object: r
  };
}
function checkGeometryIntersection(r, e, s, o, a, l, u, c, E, d) {
  r.getVertexPosition(c, _vA$1$1), r.getVertexPosition(E, _vB$1$1), r.getVertexPosition(d, _vC$1$1);
  const f = checkIntersection$1(r, e, s, o, _vA$1$1, _vB$1$1, _vC$1$1, _intersectionPoint$1);
  if (f) {
    a && (_uvA$1.fromBufferAttribute(a, c), _uvB$1.fromBufferAttribute(a, E), _uvC$1.fromBufferAttribute(a, d), f.uv = Triangle.getInterpolation(_intersectionPoint$1, _vA$1$1, _vB$1$1, _vC$1$1, _uvA$1, _uvB$1, _uvC$1, new Vector2())), l && (_uvA$1.fromBufferAttribute(l, c), _uvB$1.fromBufferAttribute(l, E), _uvC$1.fromBufferAttribute(l, d), f.uv1 = Triangle.getInterpolation(_intersectionPoint$1, _vA$1$1, _vB$1$1, _vC$1$1, _uvA$1, _uvB$1, _uvC$1, new Vector2()), f.uv2 = f.uv1), u && (_normalA$1.fromBufferAttribute(u, c), _normalB$1.fromBufferAttribute(u, E), _normalC$1.fromBufferAttribute(u, d), f.normal = Triangle.getInterpolation(_intersectionPoint$1, _vA$1$1, _vB$1$1, _vC$1$1, _normalA$1, _normalB$1, _normalC$1, new Vector3$1()), f.normal.dot(o.direction) > 0 && f.normal.multiplyScalar(-1));
    const h = {
      a: c,
      b: E,
      c: d,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1$1, _vB$1$1, _vC$1$1, h.normal), f.face = h;
  }
  return f;
}
class BoxGeometry extends BufferGeometry {
  constructor(e = 1, s = 1, o = 1, a = 1, l = 1, u = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: s,
      depth: o,
      widthSegments: a,
      heightSegments: l,
      depthSegments: u
    };
    const c = this;
    a = Math.floor(a), l = Math.floor(l), u = Math.floor(u);
    const E = [], d = [], f = [], h = [];
    let S = 0, R = 0;
    _("z", "y", "x", -1, -1, o, s, e, u, l, 0), _("z", "y", "x", 1, -1, o, s, -e, u, l, 1), _("x", "z", "y", 1, 1, e, o, s, a, u, 2), _("x", "z", "y", 1, -1, e, o, -s, a, u, 3), _("x", "y", "z", 1, -1, e, s, o, a, l, 4), _("x", "y", "z", -1, -1, e, s, -o, a, l, 5), this.setIndex(E), this.setAttribute("position", new Float32BufferAttribute(d, 3)), this.setAttribute("normal", new Float32BufferAttribute(f, 3)), this.setAttribute("uv", new Float32BufferAttribute(h, 2));
    function _(m, L, F, W, G, q, fe, _e, Le, Fe, Ee) {
      const Ge = q / Le, ve = fe / Fe, te = q / 2, ae = fe / 2, v = _e / 2, Te = Le + 1, De = Fe + 1;
      let be = 0, ze = 0;
      const ke = new Vector3$1();
      for (let Be = 0; Be < De; Be++) {
        const Me = Be * ve - ae;
        for (let me = 0; me < Te; me++) {
          const Se = me * Ge - te;
          ke[m] = Se * W, ke[L] = Me * G, ke[F] = v, d.push(ke.x, ke.y, ke.z), ke[m] = 0, ke[L] = 0, ke[F] = _e > 0 ? 1 : -1, f.push(ke.x, ke.y, ke.z), h.push(me / Le), h.push(1 - Be / Fe), be += 1;
        }
      }
      for (let Be = 0; Be < Fe; Be++)
        for (let Me = 0; Me < Le; Me++) {
          const me = S + Me + Te * Be, Se = S + Me + Te * (Be + 1), xt = S + (Me + 1) + Te * (Be + 1), Ht = S + (Me + 1) + Te * Be;
          E.push(me, Se, Ht), E.push(Se, xt, Ht), ze += 6;
        }
      c.addGroup(R, ze, Ee), R += ze, S += be;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new BoxGeometry(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function cloneUniforms(r) {
  const e = {};
  for (const s in r) {
    e[s] = {};
    for (const o in r[s]) {
      const a = r[s][o];
      a && (a.isColor || a.isMatrix3 || a.isMatrix4 || a.isVector2 || a.isVector3 || a.isVector4 || a.isTexture || a.isQuaternion) ? a.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), e[s][o] = null) : e[s][o] = a.clone() : Array.isArray(a) ? e[s][o] = a.slice() : e[s][o] = a;
    }
  }
  return e;
}
function mergeUniforms(r) {
  const e = {};
  for (let s = 0; s < r.length; s++) {
    const o = cloneUniforms(r[s]);
    for (const a in o)
      e[a] = o[a];
  }
  return e;
}
function cloneUniformsGroups(r) {
  const e = [];
  for (let s = 0; s < r.length; s++)
    e.push(r[s].clone());
  return e;
}
function getUnlitUniformColorSpace(r) {
  return r.getRenderTarget() === null ? r.outputColorSpace : LinearSRGBColorSpace;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, default_fragment = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class ShaderMaterial extends Material {
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = default_vertex, this.fragmentShader = default_fragment, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
      derivatives: !1,
      // set to use derivatives
      fragDepth: !1,
      // set to use fragment depth values
      drawBuffers: !1,
      // set to use draw buffers
      shaderTextureLOD: !1
      // set to use shader texture LOD
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv1: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = cloneUniforms(e.uniforms), this.uniformsGroups = cloneUniformsGroups(e.uniformsGroups), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const s = super.toJSON(e);
    s.glslVersion = this.glslVersion, s.uniforms = {};
    for (const a in this.uniforms) {
      const u = this.uniforms[a].value;
      u && u.isTexture ? s.uniforms[a] = {
        type: "t",
        value: u.toJSON(e).uuid
      } : u && u.isColor ? s.uniforms[a] = {
        type: "c",
        value: u.getHex()
      } : u && u.isVector2 ? s.uniforms[a] = {
        type: "v2",
        value: u.toArray()
      } : u && u.isVector3 ? s.uniforms[a] = {
        type: "v3",
        value: u.toArray()
      } : u && u.isVector4 ? s.uniforms[a] = {
        type: "v4",
        value: u.toArray()
      } : u && u.isMatrix3 ? s.uniforms[a] = {
        type: "m3",
        value: u.toArray()
      } : u && u.isMatrix4 ? s.uniforms[a] = {
        type: "m4",
        value: u.toArray()
      } : s.uniforms[a] = {
        value: u
      };
    }
    Object.keys(this.defines).length > 0 && (s.defines = this.defines), s.vertexShader = this.vertexShader, s.fragmentShader = this.fragmentShader, s.lights = this.lights, s.clipping = this.clipping;
    const o = {};
    for (const a in this.extensions)
      this.extensions[a] === !0 && (o[a] = !0);
    return Object.keys(o).length > 0 && (s.extensions = o), s;
  }
}
class Camera extends Object3D {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Matrix4(), this.projectionMatrix = new Matrix4(), this.projectionMatrixInverse = new Matrix4(), this.coordinateSystem = WebGLCoordinateSystem;
  }
  copy(e, s) {
    return super.copy(e, s), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this.coordinateSystem = e.coordinateSystem, this;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const s = this.matrixWorld.elements;
    return e.set(-s[8], -s[9], -s[10]).normalize();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, s) {
    super.updateWorldMatrix(e, s), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
let PerspectiveCamera$1 = class extends Camera {
  constructor(e = 50, s = 1, o = 0.1, a = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = o, this.far = a, this.focus = 10, this.aspect = s, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, s) {
    return super.copy(e, s), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(e) {
    const s = 0.5 * this.getFilmHeight() / e;
    this.fov = RAD2DEG * 2 * Math.atan(s), this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const e = Math.tan(DEG2RAD * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(e, s, o, a, l, u) {
    this.aspect = e / s, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = s, this.view.offsetX = o, this.view.offsetY = a, this.view.width = l, this.view.height = u, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = this.near;
    let s = e * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom, o = 2 * s, a = this.aspect * o, l = -0.5 * a;
    const u = this.view;
    if (this.view !== null && this.view.enabled) {
      const E = u.fullWidth, d = u.fullHeight;
      l += u.offsetX * a / E, s -= u.offsetY * o / d, a *= u.width / E, o *= u.height / d;
    }
    const c = this.filmOffset;
    c !== 0 && (l += e * c / this.getFilmWidth()), this.projectionMatrix.makePerspective(l, l + a, s, s - o, e, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return s.object.fov = this.fov, s.object.zoom = this.zoom, s.object.near = this.near, s.object.far = this.far, s.object.focus = this.focus, s.object.aspect = this.aspect, this.view !== null && (s.object.view = Object.assign({}, this.view)), s.object.filmGauge = this.filmGauge, s.object.filmOffset = this.filmOffset, s;
  }
};
const fov = -90, aspect = 1;
class CubeCamera extends Object3D {
  constructor(e, s, o) {
    super(), this.type = "CubeCamera", this.renderTarget = o, this.coordinateSystem = null;
    const a = new PerspectiveCamera$1(fov, aspect, e, s);
    a.layers = this.layers, this.add(a);
    const l = new PerspectiveCamera$1(fov, aspect, e, s);
    l.layers = this.layers, this.add(l);
    const u = new PerspectiveCamera$1(fov, aspect, e, s);
    u.layers = this.layers, this.add(u);
    const c = new PerspectiveCamera$1(fov, aspect, e, s);
    c.layers = this.layers, this.add(c);
    const E = new PerspectiveCamera$1(fov, aspect, e, s);
    E.layers = this.layers, this.add(E);
    const d = new PerspectiveCamera$1(fov, aspect, e, s);
    d.layers = this.layers, this.add(d);
  }
  updateCoordinateSystem() {
    const e = this.coordinateSystem, s = this.children.concat(), [o, a, l, u, c, E] = s;
    for (const d of s)
      this.remove(d);
    if (e === WebGLCoordinateSystem)
      o.up.set(0, 1, 0), o.lookAt(1, 0, 0), a.up.set(0, 1, 0), a.lookAt(-1, 0, 0), l.up.set(0, 0, -1), l.lookAt(0, 1, 0), u.up.set(0, 0, 1), u.lookAt(0, -1, 0), c.up.set(0, 1, 0), c.lookAt(0, 0, 1), E.up.set(0, 1, 0), E.lookAt(0, 0, -1);
    else if (e === WebGPUCoordinateSystem)
      o.up.set(0, -1, 0), o.lookAt(-1, 0, 0), a.up.set(0, -1, 0), a.lookAt(1, 0, 0), l.up.set(0, 0, 1), l.lookAt(0, 1, 0), u.up.set(0, 0, -1), u.lookAt(0, -1, 0), c.up.set(0, -1, 0), c.lookAt(0, 0, 1), E.up.set(0, -1, 0), E.lookAt(0, 0, -1);
    else
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
    for (const d of s)
      this.add(d), d.updateMatrixWorld();
  }
  update(e, s) {
    this.parent === null && this.updateMatrixWorld();
    const o = this.renderTarget;
    this.coordinateSystem !== e.coordinateSystem && (this.coordinateSystem = e.coordinateSystem, this.updateCoordinateSystem());
    const [a, l, u, c, E, d] = this.children, f = e.getRenderTarget(), h = e.toneMapping, S = e.xr.enabled;
    e.toneMapping = NoToneMapping, e.xr.enabled = !1;
    const R = o.texture.generateMipmaps;
    o.texture.generateMipmaps = !1, e.setRenderTarget(o, 0), e.render(s, a), e.setRenderTarget(o, 1), e.render(s, l), e.setRenderTarget(o, 2), e.render(s, u), e.setRenderTarget(o, 3), e.render(s, c), e.setRenderTarget(o, 4), e.render(s, E), o.texture.generateMipmaps = R, e.setRenderTarget(o, 5), e.render(s, d), e.setRenderTarget(f), e.toneMapping = h, e.xr.enabled = S, o.texture.needsPMREMUpdate = !0;
  }
}
class CubeTexture extends Texture {
  constructor(e, s, o, a, l, u, c, E, d, f) {
    e = e !== void 0 ? e : [], s = s !== void 0 ? s : CubeReflectionMapping, super(e, s, o, a, l, u, c, E, d, f), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class WebGLCubeRenderTarget extends WebGLRenderTarget {
  constructor(e = 1, s = {}) {
    super(e, e, s), this.isWebGLCubeRenderTarget = !0;
    const o = { width: e, height: e, depth: 1 }, a = [o, o, o, o, o, o];
    s.encoding !== void 0 && (warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), s.colorSpace = s.encoding === sRGBEncoding ? SRGBColorSpace : NoColorSpace), this.texture = new CubeTexture(a, s.mapping, s.wrapS, s.wrapT, s.magFilter, s.minFilter, s.format, s.type, s.anisotropy, s.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = s.generateMipmaps !== void 0 ? s.generateMipmaps : !1, this.texture.minFilter = s.minFilter !== void 0 ? s.minFilter : LinearFilter;
  }
  fromEquirectangularTexture(e, s) {
    this.texture.type = s.type, this.texture.colorSpace = s.colorSpace, this.texture.generateMipmaps = s.generateMipmaps, this.texture.minFilter = s.minFilter, this.texture.magFilter = s.magFilter;
    const o = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    }, a = new BoxGeometry(5, 5, 5), l = new ShaderMaterial({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(o.uniforms),
      vertexShader: o.vertexShader,
      fragmentShader: o.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    l.uniforms.tEquirect.value = s;
    const u = new Mesh(a, l), c = s.minFilter;
    return s.minFilter === LinearMipmapLinearFilter && (s.minFilter = LinearFilter), new CubeCamera(1, 10, this).update(e, u), s.minFilter = c, u.geometry.dispose(), u.material.dispose(), this;
  }
  clear(e, s, o, a) {
    const l = e.getRenderTarget();
    for (let u = 0; u < 6; u++)
      e.setRenderTarget(this, u), e.clear(s, o, a);
    e.setRenderTarget(l);
  }
}
const _vector1 = /* @__PURE__ */ new Vector3$1(), _vector2 = /* @__PURE__ */ new Vector3$1(), _normalMatrix = /* @__PURE__ */ new Matrix3$1();
class Plane {
  constructor(e = new Vector3$1(1, 0, 0), s = 0) {
    this.isPlane = !0, this.normal = e, this.constant = s;
  }
  set(e, s) {
    return this.normal.copy(e), this.constant = s, this;
  }
  setComponents(e, s, o, a) {
    return this.normal.set(e, s, o), this.constant = a, this;
  }
  setFromNormalAndCoplanarPoint(e, s) {
    return this.normal.copy(e), this.constant = -s.dot(this.normal), this;
  }
  setFromCoplanarPoints(e, s, o) {
    const a = _vector1.subVectors(o, s).cross(_vector2.subVectors(e, s)).normalize();
    return this.setFromNormalAndCoplanarPoint(a, e), this;
  }
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  projectPoint(e, s) {
    return s.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
  }
  intersectLine(e, s) {
    const o = e.delta(_vector1), a = this.normal.dot(o);
    if (a === 0)
      return this.distanceToPoint(e.start) === 0 ? s.copy(e.start) : null;
    const l = -(e.start.dot(this.normal) + this.constant) / a;
    return l < 0 || l > 1 ? null : s.copy(e.start).addScaledVector(o, l);
  }
  intersectsLine(e) {
    const s = this.distanceToPoint(e.start), o = this.distanceToPoint(e.end);
    return s < 0 && o > 0 || o < 0 && s > 0;
  }
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(e, s) {
    const o = s || _normalMatrix.getNormalMatrix(e), a = this.coplanarPoint(_vector1).applyMatrix4(e), l = this.normal.applyMatrix3(o).normalize();
    return this.constant = -a.dot(l), this;
  }
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _sphere$4 = /* @__PURE__ */ new Sphere$1(), _vector$6 = /* @__PURE__ */ new Vector3$1();
class Frustum {
  constructor(e = new Plane(), s = new Plane(), o = new Plane(), a = new Plane(), l = new Plane(), u = new Plane()) {
    this.planes = [e, s, o, a, l, u];
  }
  set(e, s, o, a, l, u) {
    const c = this.planes;
    return c[0].copy(e), c[1].copy(s), c[2].copy(o), c[3].copy(a), c[4].copy(l), c[5].copy(u), this;
  }
  copy(e) {
    const s = this.planes;
    for (let o = 0; o < 6; o++)
      s[o].copy(e.planes[o]);
    return this;
  }
  setFromProjectionMatrix(e, s = WebGLCoordinateSystem) {
    const o = this.planes, a = e.elements, l = a[0], u = a[1], c = a[2], E = a[3], d = a[4], f = a[5], h = a[6], S = a[7], R = a[8], _ = a[9], m = a[10], L = a[11], F = a[12], W = a[13], G = a[14], q = a[15];
    if (o[0].setComponents(E - l, S - d, L - R, q - F).normalize(), o[1].setComponents(E + l, S + d, L + R, q + F).normalize(), o[2].setComponents(E + u, S + f, L + _, q + W).normalize(), o[3].setComponents(E - u, S - f, L - _, q - W).normalize(), o[4].setComponents(E - c, S - h, L - m, q - G).normalize(), s === WebGLCoordinateSystem)
      o[5].setComponents(E + c, S + h, L + m, q + G).normalize();
    else if (s === WebGPUCoordinateSystem)
      o[5].setComponents(c, h, m, G).normalize();
    else
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + s);
    return this;
  }
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(), _sphere$4.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
    else {
      const s = e.geometry;
      s.boundingSphere === null && s.computeBoundingSphere(), _sphere$4.copy(s.boundingSphere).applyMatrix4(e.matrixWorld);
    }
    return this.intersectsSphere(_sphere$4);
  }
  intersectsSprite(e) {
    return _sphere$4.center.set(0, 0, 0), _sphere$4.radius = 0.7071067811865476, _sphere$4.applyMatrix4(e.matrixWorld), this.intersectsSphere(_sphere$4);
  }
  intersectsSphere(e) {
    const s = this.planes, o = e.center, a = -e.radius;
    for (let l = 0; l < 6; l++)
      if (s[l].distanceToPoint(o) < a)
        return !1;
    return !0;
  }
  intersectsBox(e) {
    const s = this.planes;
    for (let o = 0; o < 6; o++) {
      const a = s[o];
      if (_vector$6.x = a.normal.x > 0 ? e.max.x : e.min.x, _vector$6.y = a.normal.y > 0 ? e.max.y : e.min.y, _vector$6.z = a.normal.z > 0 ? e.max.z : e.min.z, a.distanceToPoint(_vector$6) < 0)
        return !1;
    }
    return !0;
  }
  containsPoint(e) {
    const s = this.planes;
    for (let o = 0; o < 6; o++)
      if (s[o].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function WebGLAnimation() {
  let r = null, e = !1, s = null, o = null;
  function a(l, u) {
    s(l, u), o = r.requestAnimationFrame(a);
  }
  return {
    start: function() {
      e !== !0 && s !== null && (o = r.requestAnimationFrame(a), e = !0);
    },
    stop: function() {
      r.cancelAnimationFrame(o), e = !1;
    },
    setAnimationLoop: function(l) {
      s = l;
    },
    setContext: function(l) {
      r = l;
    }
  };
}
function WebGLAttributes(r, e) {
  const s = e.isWebGL2, o = /* @__PURE__ */ new WeakMap();
  function a(d, f) {
    const h = d.array, S = d.usage, R = r.createBuffer();
    r.bindBuffer(f, R), r.bufferData(f, h, S), d.onUploadCallback();
    let _;
    if (h instanceof Float32Array)
      _ = r.FLOAT;
    else if (h instanceof Uint16Array)
      if (d.isFloat16BufferAttribute)
        if (s)
          _ = r.HALF_FLOAT;
        else
          throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
      else
        _ = r.UNSIGNED_SHORT;
    else if (h instanceof Int16Array)
      _ = r.SHORT;
    else if (h instanceof Uint32Array)
      _ = r.UNSIGNED_INT;
    else if (h instanceof Int32Array)
      _ = r.INT;
    else if (h instanceof Int8Array)
      _ = r.BYTE;
    else if (h instanceof Uint8Array)
      _ = r.UNSIGNED_BYTE;
    else if (h instanceof Uint8ClampedArray)
      _ = r.UNSIGNED_BYTE;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
    return {
      buffer: R,
      type: _,
      bytesPerElement: h.BYTES_PER_ELEMENT,
      version: d.version
    };
  }
  function l(d, f, h) {
    const S = f.array, R = f.updateRange;
    r.bindBuffer(h, d), R.count === -1 ? r.bufferSubData(h, 0, S) : (s ? r.bufferSubData(
      h,
      R.offset * S.BYTES_PER_ELEMENT,
      S,
      R.offset,
      R.count
    ) : r.bufferSubData(
      h,
      R.offset * S.BYTES_PER_ELEMENT,
      S.subarray(R.offset, R.offset + R.count)
    ), R.count = -1), f.onUploadCallback();
  }
  function u(d) {
    return d.isInterleavedBufferAttribute && (d = d.data), o.get(d);
  }
  function c(d) {
    d.isInterleavedBufferAttribute && (d = d.data);
    const f = o.get(d);
    f && (r.deleteBuffer(f.buffer), o.delete(d));
  }
  function E(d, f) {
    if (d.isGLBufferAttribute) {
      const S = o.get(d);
      (!S || S.version < d.version) && o.set(d, {
        buffer: d.buffer,
        type: d.type,
        bytesPerElement: d.elementSize,
        version: d.version
      });
      return;
    }
    d.isInterleavedBufferAttribute && (d = d.data);
    const h = o.get(d);
    h === void 0 ? o.set(d, a(d, f)) : h.version < d.version && (l(h.buffer, d, f), h.version = d.version);
  }
  return {
    get: u,
    remove: c,
    update: E
  };
}
class PlaneGeometry extends BufferGeometry {
  constructor(e = 1, s = 1, o = 1, a = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: s,
      widthSegments: o,
      heightSegments: a
    };
    const l = e / 2, u = s / 2, c = Math.floor(o), E = Math.floor(a), d = c + 1, f = E + 1, h = e / c, S = s / E, R = [], _ = [], m = [], L = [];
    for (let F = 0; F < f; F++) {
      const W = F * S - u;
      for (let G = 0; G < d; G++) {
        const q = G * h - l;
        _.push(q, -W, 0), m.push(0, 0, 1), L.push(G / c), L.push(1 - F / E);
      }
    }
    for (let F = 0; F < E; F++)
      for (let W = 0; W < c; W++) {
        const G = W + d * F, q = W + d * (F + 1), fe = W + 1 + d * (F + 1), _e = W + 1 + d * F;
        R.push(G, q, _e), R.push(q, fe, _e);
      }
    this.setIndex(R), this.setAttribute("position", new Float32BufferAttribute(_, 3)), this.setAttribute("normal", new Float32BufferAttribute(m, 3)), this.setAttribute("uv", new Float32BufferAttribute(L, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new PlaneGeometry(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
var alphahash_fragment = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`, alphahash_pars_fragment = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`, alphamap_fragment = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`, alphamap_pars_fragment = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, alphatest_fragment = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, alphatest_pars_fragment = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, aomap_fragment = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, aomap_pars_fragment = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, begin_vertex = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`, beginnormal_vertex = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, bsdfs = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`, iridescence_fragment = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, bumpmap_pars_fragment = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, clipping_planes_fragment = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, clipping_planes_pars_fragment = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, clipping_planes_pars_vertex = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, clipping_planes_vertex = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, color_fragment = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, color_pars_fragment = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, color_pars_vertex = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, color_vertex = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, common$3 = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`, cube_uv_reflection_fragment = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, defaultnormal_vertex = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, displacementmap_pars_vertex = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, displacementmap_vertex = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`, emissivemap_fragment = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, emissivemap_pars_fragment = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );", colorspace_pars_fragment = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, envmap_fragment = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, envmap_common_pars_fragment = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, envmap_pars_fragment = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, envmap_pars_vertex = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, envmap_vertex = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, fog_vertex = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, fog_pars_vertex = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, fog_fragment = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, fog_pars_fragment = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, gradientmap_pars_fragment = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, lightmap_fragment = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, lightmap_pars_fragment = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, lights_lambert_fragment = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, lights_lambert_pars_fragment = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, lights_pars_begin = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( LEGACY_LIGHTS )
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#else
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, envmap_physical_pars_fragment = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`, lights_toon_fragment = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, lights_toon_pars_fragment = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, lights_phong_fragment = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, lights_phong_pars_fragment = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, lights_physical_fragment = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	anisotropyV /= material.anisotropy;
	material.anisotropy = saturate( material.anisotropy );
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;
#endif`, lights_physical_pars_fragment = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, lights_fragment_begin = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, lights_fragment_maps = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, lights_fragment_end = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, logdepthbuf_fragment = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, logdepthbuf_pars_fragment = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, logdepthbuf_pars_vertex = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, logdepthbuf_vertex = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, map_fragment = `#ifdef USE_MAP
	diffuseColor *= texture2D( map, vMapUv );
#endif`, map_pars_fragment = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, map_particle_fragment = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, map_particle_pars_fragment = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, metalnessmap_fragment = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`, metalnessmap_pars_fragment = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, morphcolor_vertex = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, morphnormal_vertex = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, morphtarget_pars_vertex = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, morphtarget_vertex = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, normal_fragment_begin = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 geometryNormal = normal;`, normal_fragment_maps = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, normal_pars_fragment = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, normal_pars_vertex = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, normal_vertex = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, normalmap_pars_fragment = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`, clearcoat_normal_fragment_begin = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, clearcoat_normal_fragment_maps = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`, clearcoat_pars_fragment = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`, iridescence_pars_fragment = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, opaque_fragment = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, packing = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`, premultiplied_alpha_fragment = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, project_vertex = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, dithering_fragment = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, dithering_pars_fragment = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, roughnessmap_fragment = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`, roughnessmap_pars_fragment = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, shadowmap_pars_fragment = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, shadowmap_pars_vertex = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, shadowmap_vertex = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, shadowmask_pars_fragment = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, skinbase_vertex = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, skinning_pars_vertex = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, skinning_vertex = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, skinnormal_vertex = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, specularmap_fragment = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, specularmap_pars_fragment = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, tonemapping_fragment = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, tonemapping_pars_fragment = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, transmission_fragment = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`, transmission_pars_fragment = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`, uv_pars_fragment = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, uv_pars_vertex = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`, uv_vertex = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`, worldpos_vertex = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const vertex$h = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, fragment$h = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$g = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, fragment$g = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$f = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, fragment$f = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$e = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, fragment$e = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, vertex$d = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, fragment$d = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, vertex$c = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, fragment$c = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`, vertex$b = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, fragment$b = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, vertex$a = `#include <common>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, fragment$a = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$9 = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$9 = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$8 = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, fragment$8 = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$7 = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`, fragment$7 = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, vertex$6 = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$6 = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$5 = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, fragment$5 = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$4 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$4 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, vertex$3 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, fragment$3 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, vertex$2 = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, fragment$2 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, vertex$1 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, fragment$1 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`, ShaderChunk = {
  alphahash_fragment,
  alphahash_pars_fragment,
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  alphatest_pars_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  iridescence_fragment,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common: common$3,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  colorspace_fragment,
  colorspace_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_fragment,
  lightmap_pars_fragment,
  lights_lambert_fragment,
  lights_lambert_pars_fragment,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphcolor_vertex,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normal_pars_fragment,
  normal_pars_vertex,
  normal_vertex,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  iridescence_pars_fragment,
  opaque_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  worldpos_vertex,
  background_vert: vertex$h,
  background_frag: fragment$h,
  backgroundCube_vert: vertex$g,
  backgroundCube_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
}, UniformsLib = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    normalScale: { value: /* @__PURE__ */ new Vector2(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Color(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Color(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Vector2(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 }
  }
}, ShaderLib = {
  basic: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        specular: { value: /* @__PURE__ */ new Color(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
        // temporary
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk.backgroundCube_vert,
    fragmentShader: ShaderChunk.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new Vector3$1() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: /* @__PURE__ */ new Color(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: /* @__PURE__ */ mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Color(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Color(0) },
      specularColor: { value: /* @__PURE__ */ new Color(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      anisotropyVector: { value: /* @__PURE__ */ new Vector2() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
const _rgb = { r: 0, b: 0, g: 0 };
function WebGLBackground(r, e, s, o, a, l, u) {
  const c = new Color(0);
  let E = l === !0 ? 0 : 1, d, f, h = null, S = 0, R = null;
  function _(L, F) {
    let W = !1, G = F.isScene === !0 ? F.background : null;
    switch (G && G.isTexture && (G = (F.backgroundBlurriness > 0 ? s : e).get(G)), G === null ? m(c, E) : G && G.isColor && (m(G, 1), W = !0), r.xr.getEnvironmentBlendMode()) {
      case "opaque":
        W = !0;
        break;
      case "additive":
        o.buffers.color.setClear(0, 0, 0, 1, u), W = !0;
        break;
      case "alpha-blend":
        o.buffers.color.setClear(0, 0, 0, 0, u), W = !0;
        break;
    }
    (r.autoClear || W) && r.clear(r.autoClearColor, r.autoClearDepth, r.autoClearStencil), G && (G.isCubeTexture || G.mapping === CubeUVReflectionMapping) ? (f === void 0 && (f = new Mesh(
      new BoxGeometry(1, 1, 1),
      new ShaderMaterial({
        name: "BackgroundCubeMaterial",
        uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
        vertexShader: ShaderLib.backgroundCube.vertexShader,
        fragmentShader: ShaderLib.backgroundCube.fragmentShader,
        side: BackSide,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), f.geometry.deleteAttribute("normal"), f.geometry.deleteAttribute("uv"), f.onBeforeRender = function(_e, Le, Fe) {
      this.matrixWorld.copyPosition(Fe.matrixWorld);
    }, Object.defineProperty(f.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), a.update(f)), f.material.uniforms.envMap.value = G, f.material.uniforms.flipEnvMap.value = G.isCubeTexture && G.isRenderTargetTexture === !1 ? -1 : 1, f.material.uniforms.backgroundBlurriness.value = F.backgroundBlurriness, f.material.uniforms.backgroundIntensity.value = F.backgroundIntensity, f.material.toneMapped = G.colorSpace !== SRGBColorSpace, (h !== G || S !== G.version || R !== r.toneMapping) && (f.material.needsUpdate = !0, h = G, S = G.version, R = r.toneMapping), f.layers.enableAll(), L.unshift(f, f.geometry, f.material, 0, 0, null)) : G && G.isTexture && (d === void 0 && (d = new Mesh(
      new PlaneGeometry(2, 2),
      new ShaderMaterial({
        name: "BackgroundMaterial",
        uniforms: cloneUniforms(ShaderLib.background.uniforms),
        vertexShader: ShaderLib.background.vertexShader,
        fragmentShader: ShaderLib.background.fragmentShader,
        side: FrontSide,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), d.geometry.deleteAttribute("normal"), Object.defineProperty(d.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), a.update(d)), d.material.uniforms.t2D.value = G, d.material.uniforms.backgroundIntensity.value = F.backgroundIntensity, d.material.toneMapped = G.colorSpace !== SRGBColorSpace, G.matrixAutoUpdate === !0 && G.updateMatrix(), d.material.uniforms.uvTransform.value.copy(G.matrix), (h !== G || S !== G.version || R !== r.toneMapping) && (d.material.needsUpdate = !0, h = G, S = G.version, R = r.toneMapping), d.layers.enableAll(), L.unshift(d, d.geometry, d.material, 0, 0, null));
  }
  function m(L, F) {
    L.getRGB(_rgb, getUnlitUniformColorSpace(r)), o.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, F, u);
  }
  return {
    getClearColor: function() {
      return c;
    },
    setClearColor: function(L, F = 1) {
      c.set(L), E = F, m(c, E);
    },
    getClearAlpha: function() {
      return E;
    },
    setClearAlpha: function(L) {
      E = L, m(c, E);
    },
    render: _
  };
}
function WebGLBindingStates(r, e, s, o) {
  const a = r.getParameter(r.MAX_VERTEX_ATTRIBS), l = o.isWebGL2 ? null : e.get("OES_vertex_array_object"), u = o.isWebGL2 || l !== null, c = {}, E = L(null);
  let d = E, f = !1;
  function h(v, Te, De, be, ze) {
    let ke = !1;
    if (u) {
      const Be = m(be, De, Te);
      d !== Be && (d = Be, R(d.object)), ke = F(v, be, De, ze), ke && W(v, be, De, ze);
    } else {
      const Be = Te.wireframe === !0;
      (d.geometry !== be.id || d.program !== De.id || d.wireframe !== Be) && (d.geometry = be.id, d.program = De.id, d.wireframe = Be, ke = !0);
    }
    ze !== null && s.update(ze, r.ELEMENT_ARRAY_BUFFER), (ke || f) && (f = !1, Fe(v, Te, De, be), ze !== null && r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, s.get(ze).buffer));
  }
  function S() {
    return o.isWebGL2 ? r.createVertexArray() : l.createVertexArrayOES();
  }
  function R(v) {
    return o.isWebGL2 ? r.bindVertexArray(v) : l.bindVertexArrayOES(v);
  }
  function _(v) {
    return o.isWebGL2 ? r.deleteVertexArray(v) : l.deleteVertexArrayOES(v);
  }
  function m(v, Te, De) {
    const be = De.wireframe === !0;
    let ze = c[v.id];
    ze === void 0 && (ze = {}, c[v.id] = ze);
    let ke = ze[Te.id];
    ke === void 0 && (ke = {}, ze[Te.id] = ke);
    let Be = ke[be];
    return Be === void 0 && (Be = L(S()), ke[be] = Be), Be;
  }
  function L(v) {
    const Te = [], De = [], be = [];
    for (let ze = 0; ze < a; ze++)
      Te[ze] = 0, De[ze] = 0, be[ze] = 0;
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: Te,
      enabledAttributes: De,
      attributeDivisors: be,
      object: v,
      attributes: {},
      index: null
    };
  }
  function F(v, Te, De, be) {
    const ze = d.attributes, ke = Te.attributes;
    let Be = 0;
    const Me = De.getAttributes();
    for (const me in Me)
      if (Me[me].location >= 0) {
        const xt = ze[me];
        let Ht = ke[me];
        if (Ht === void 0 && (me === "instanceMatrix" && v.instanceMatrix && (Ht = v.instanceMatrix), me === "instanceColor" && v.instanceColor && (Ht = v.instanceColor)), xt === void 0 || xt.attribute !== Ht || Ht && xt.data !== Ht.data)
          return !0;
        Be++;
      }
    return d.attributesNum !== Be || d.index !== be;
  }
  function W(v, Te, De, be) {
    const ze = {}, ke = Te.attributes;
    let Be = 0;
    const Me = De.getAttributes();
    for (const me in Me)
      if (Me[me].location >= 0) {
        let xt = ke[me];
        xt === void 0 && (me === "instanceMatrix" && v.instanceMatrix && (xt = v.instanceMatrix), me === "instanceColor" && v.instanceColor && (xt = v.instanceColor));
        const Ht = {};
        Ht.attribute = xt, xt && xt.data && (Ht.data = xt.data), ze[me] = Ht, Be++;
      }
    d.attributes = ze, d.attributesNum = Be, d.index = be;
  }
  function G() {
    const v = d.newAttributes;
    for (let Te = 0, De = v.length; Te < De; Te++)
      v[Te] = 0;
  }
  function q(v) {
    fe(v, 0);
  }
  function fe(v, Te) {
    const De = d.newAttributes, be = d.enabledAttributes, ze = d.attributeDivisors;
    De[v] = 1, be[v] === 0 && (r.enableVertexAttribArray(v), be[v] = 1), ze[v] !== Te && ((o.isWebGL2 ? r : e.get("ANGLE_instanced_arrays"))[o.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](v, Te), ze[v] = Te);
  }
  function _e() {
    const v = d.newAttributes, Te = d.enabledAttributes;
    for (let De = 0, be = Te.length; De < be; De++)
      Te[De] !== v[De] && (r.disableVertexAttribArray(De), Te[De] = 0);
  }
  function Le(v, Te, De, be, ze, ke, Be) {
    Be === !0 ? r.vertexAttribIPointer(v, Te, De, ze, ke) : r.vertexAttribPointer(v, Te, De, be, ze, ke);
  }
  function Fe(v, Te, De, be) {
    if (o.isWebGL2 === !1 && (v.isInstancedMesh || be.isInstancedBufferGeometry) && e.get("ANGLE_instanced_arrays") === null)
      return;
    G();
    const ze = be.attributes, ke = De.getAttributes(), Be = Te.defaultAttributeValues;
    for (const Me in ke) {
      const me = ke[Me];
      if (me.location >= 0) {
        let Se = ze[Me];
        if (Se === void 0 && (Me === "instanceMatrix" && v.instanceMatrix && (Se = v.instanceMatrix), Me === "instanceColor" && v.instanceColor && (Se = v.instanceColor)), Se !== void 0) {
          const xt = Se.normalized, Ht = Se.itemSize, Bt = s.get(Se);
          if (Bt === void 0)
            continue;
          const ut = Bt.buffer, Tt = Bt.type, Yt = Bt.bytesPerElement, an = o.isWebGL2 === !0 && (Tt === r.INT || Tt === r.UNSIGNED_INT || Se.gpuType === IntType);
          if (Se.isInterleavedBufferAttribute) {
            const Ct = Se.data, st = Ct.stride, jt = Se.offset;
            if (Ct.isInstancedInterleavedBuffer) {
              for (let lt = 0; lt < me.locationSize; lt++)
                fe(me.location + lt, Ct.meshPerAttribute);
              v.isInstancedMesh !== !0 && be._maxInstanceCount === void 0 && (be._maxInstanceCount = Ct.meshPerAttribute * Ct.count);
            } else
              for (let lt = 0; lt < me.locationSize; lt++)
                q(me.location + lt);
            r.bindBuffer(r.ARRAY_BUFFER, ut);
            for (let lt = 0; lt < me.locationSize; lt++)
              Le(
                me.location + lt,
                Ht / me.locationSize,
                Tt,
                xt,
                st * Yt,
                (jt + Ht / me.locationSize * lt) * Yt,
                an
              );
          } else {
            if (Se.isInstancedBufferAttribute) {
              for (let Ct = 0; Ct < me.locationSize; Ct++)
                fe(me.location + Ct, Se.meshPerAttribute);
              v.isInstancedMesh !== !0 && be._maxInstanceCount === void 0 && (be._maxInstanceCount = Se.meshPerAttribute * Se.count);
            } else
              for (let Ct = 0; Ct < me.locationSize; Ct++)
                q(me.location + Ct);
            r.bindBuffer(r.ARRAY_BUFFER, ut);
            for (let Ct = 0; Ct < me.locationSize; Ct++)
              Le(
                me.location + Ct,
                Ht / me.locationSize,
                Tt,
                xt,
                Ht * Yt,
                Ht / me.locationSize * Ct * Yt,
                an
              );
          }
        } else if (Be !== void 0) {
          const xt = Be[Me];
          if (xt !== void 0)
            switch (xt.length) {
              case 2:
                r.vertexAttrib2fv(me.location, xt);
                break;
              case 3:
                r.vertexAttrib3fv(me.location, xt);
                break;
              case 4:
                r.vertexAttrib4fv(me.location, xt);
                break;
              default:
                r.vertexAttrib1fv(me.location, xt);
            }
        }
      }
    }
    _e();
  }
  function Ee() {
    te();
    for (const v in c) {
      const Te = c[v];
      for (const De in Te) {
        const be = Te[De];
        for (const ze in be)
          _(be[ze].object), delete be[ze];
        delete Te[De];
      }
      delete c[v];
    }
  }
  function Ge(v) {
    if (c[v.id] === void 0)
      return;
    const Te = c[v.id];
    for (const De in Te) {
      const be = Te[De];
      for (const ze in be)
        _(be[ze].object), delete be[ze];
      delete Te[De];
    }
    delete c[v.id];
  }
  function ve(v) {
    for (const Te in c) {
      const De = c[Te];
      if (De[v.id] === void 0)
        continue;
      const be = De[v.id];
      for (const ze in be)
        _(be[ze].object), delete be[ze];
      delete De[v.id];
    }
  }
  function te() {
    ae(), f = !0, d !== E && (d = E, R(d.object));
  }
  function ae() {
    E.geometry = null, E.program = null, E.wireframe = !1;
  }
  return {
    setup: h,
    reset: te,
    resetDefaultState: ae,
    dispose: Ee,
    releaseStatesOfGeometry: Ge,
    releaseStatesOfProgram: ve,
    initAttributes: G,
    enableAttribute: q,
    disableUnusedAttributes: _e
  };
}
function WebGLBufferRenderer(r, e, s, o) {
  const a = o.isWebGL2;
  let l;
  function u(d) {
    l = d;
  }
  function c(d, f) {
    r.drawArrays(l, d, f), s.update(f, l, 1);
  }
  function E(d, f, h) {
    if (h === 0)
      return;
    let S, R;
    if (a)
      S = r, R = "drawArraysInstanced";
    else if (S = e.get("ANGLE_instanced_arrays"), R = "drawArraysInstancedANGLE", S === null) {
      console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    S[R](l, d, f, h), s.update(f, l, h);
  }
  this.setMode = u, this.render = c, this.renderInstances = E;
}
function WebGLCapabilities(r, e, s) {
  let o;
  function a() {
    if (o !== void 0)
      return o;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const Le = e.get("EXT_texture_filter_anisotropic");
      o = r.getParameter(Le.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      o = 0;
    return o;
  }
  function l(Le) {
    if (Le === "highp") {
      if (r.getShaderPrecisionFormat(r.VERTEX_SHADER, r.HIGH_FLOAT).precision > 0 && r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.HIGH_FLOAT).precision > 0)
        return "highp";
      Le = "mediump";
    }
    return Le === "mediump" && r.getShaderPrecisionFormat(r.VERTEX_SHADER, r.MEDIUM_FLOAT).precision > 0 && r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
  }
  const u = typeof WebGL2RenderingContext < "u" && r.constructor.name === "WebGL2RenderingContext";
  let c = s.precision !== void 0 ? s.precision : "highp";
  const E = l(c);
  E !== c && (console.warn("THREE.WebGLRenderer:", c, "not supported, using", E, "instead."), c = E);
  const d = u || e.has("WEBGL_draw_buffers"), f = s.logarithmicDepthBuffer === !0, h = r.getParameter(r.MAX_TEXTURE_IMAGE_UNITS), S = r.getParameter(r.MAX_VERTEX_TEXTURE_IMAGE_UNITS), R = r.getParameter(r.MAX_TEXTURE_SIZE), _ = r.getParameter(r.MAX_CUBE_MAP_TEXTURE_SIZE), m = r.getParameter(r.MAX_VERTEX_ATTRIBS), L = r.getParameter(r.MAX_VERTEX_UNIFORM_VECTORS), F = r.getParameter(r.MAX_VARYING_VECTORS), W = r.getParameter(r.MAX_FRAGMENT_UNIFORM_VECTORS), G = S > 0, q = u || e.has("OES_texture_float"), fe = G && q, _e = u ? r.getParameter(r.MAX_SAMPLES) : 0;
  return {
    isWebGL2: u,
    drawBuffers: d,
    getMaxAnisotropy: a,
    getMaxPrecision: l,
    precision: c,
    logarithmicDepthBuffer: f,
    maxTextures: h,
    maxVertexTextures: S,
    maxTextureSize: R,
    maxCubemapSize: _,
    maxAttributes: m,
    maxVertexUniforms: L,
    maxVaryings: F,
    maxFragmentUniforms: W,
    vertexTextures: G,
    floatFragmentTextures: q,
    floatVertexTextures: fe,
    maxSamples: _e
  };
}
function WebGLClipping(r) {
  const e = this;
  let s = null, o = 0, a = !1, l = !1;
  const u = new Plane(), c = new Matrix3$1(), E = { value: null, needsUpdate: !1 };
  this.uniform = E, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, S) {
    const R = h.length !== 0 || S || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    o !== 0 || a;
    return a = S, o = h.length, R;
  }, this.beginShadows = function() {
    l = !0, f(null);
  }, this.endShadows = function() {
    l = !1;
  }, this.setGlobalState = function(h, S) {
    s = f(h, S, 0);
  }, this.setState = function(h, S, R) {
    const _ = h.clippingPlanes, m = h.clipIntersection, L = h.clipShadows, F = r.get(h);
    if (!a || _ === null || _.length === 0 || l && !L)
      l ? f(null) : d();
    else {
      const W = l ? 0 : o, G = W * 4;
      let q = F.clippingState || null;
      E.value = q, q = f(_, S, G, R);
      for (let fe = 0; fe !== G; ++fe)
        q[fe] = s[fe];
      F.clippingState = q, this.numIntersection = m ? this.numPlanes : 0, this.numPlanes += W;
    }
  };
  function d() {
    E.value !== s && (E.value = s, E.needsUpdate = o > 0), e.numPlanes = o, e.numIntersection = 0;
  }
  function f(h, S, R, _) {
    const m = h !== null ? h.length : 0;
    let L = null;
    if (m !== 0) {
      if (L = E.value, _ !== !0 || L === null) {
        const F = R + m * 4, W = S.matrixWorldInverse;
        c.getNormalMatrix(W), (L === null || L.length < F) && (L = new Float32Array(F));
        for (let G = 0, q = R; G !== m; ++G, q += 4)
          u.copy(h[G]).applyMatrix4(W, c), u.normal.toArray(L, q), L[q + 3] = u.constant;
      }
      E.value = L, E.needsUpdate = !0;
    }
    return e.numPlanes = m, e.numIntersection = 0, L;
  }
}
function WebGLCubeMaps(r) {
  let e = /* @__PURE__ */ new WeakMap();
  function s(u, c) {
    return c === EquirectangularReflectionMapping ? u.mapping = CubeReflectionMapping : c === EquirectangularRefractionMapping && (u.mapping = CubeRefractionMapping), u;
  }
  function o(u) {
    if (u && u.isTexture && u.isRenderTargetTexture === !1) {
      const c = u.mapping;
      if (c === EquirectangularReflectionMapping || c === EquirectangularRefractionMapping)
        if (e.has(u)) {
          const E = e.get(u).texture;
          return s(E, u.mapping);
        } else {
          const E = u.image;
          if (E && E.height > 0) {
            const d = new WebGLCubeRenderTarget(E.height / 2);
            return d.fromEquirectangularTexture(r, u), e.set(u, d), u.addEventListener("dispose", a), s(d.texture, u.mapping);
          } else
            return null;
        }
    }
    return u;
  }
  function a(u) {
    const c = u.target;
    c.removeEventListener("dispose", a);
    const E = e.get(c);
    E !== void 0 && (e.delete(c), E.dispose());
  }
  function l() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: o,
    dispose: l
  };
}
let OrthographicCamera$1 = class extends Camera {
  constructor(e = -1, s = 1, o = 1, a = -1, l = 0.1, u = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = s, this.top = o, this.bottom = a, this.near = l, this.far = u, this.updateProjectionMatrix();
  }
  copy(e, s) {
    return super.copy(e, s), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  setViewOffset(e, s, o, a, l, u) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = s, this.view.offsetX = o, this.view.offsetY = a, this.view.width = l, this.view.height = u, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), s = (this.top - this.bottom) / (2 * this.zoom), o = (this.right + this.left) / 2, a = (this.top + this.bottom) / 2;
    let l = o - e, u = o + e, c = a + s, E = a - s;
    if (this.view !== null && this.view.enabled) {
      const d = (this.right - this.left) / this.view.fullWidth / this.zoom, f = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      l += d * this.view.offsetX, u = l + d * this.view.width, c -= f * this.view.offsetY, E = c - f * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(l, u, c, E, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return s.object.zoom = this.zoom, s.object.left = this.left, s.object.right = this.right, s.object.top = this.top, s.object.bottom = this.bottom, s.object.near = this.near, s.object.far = this.far, this.view !== null && (s.object.view = Object.assign({}, this.view)), s;
  }
};
const LOD_MIN = 4, EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], MAX_SAMPLES = 20, _flatCamera = /* @__PURE__ */ new OrthographicCamera$1(), _clearColor = /* @__PURE__ */ new Color();
let _oldTarget = null;
const PHI = (1 + Math.sqrt(5)) / 2, INV_PHI = 1 / PHI, _axisDirections = [
  /* @__PURE__ */ new Vector3$1(1, 1, 1),
  /* @__PURE__ */ new Vector3$1(-1, 1, 1),
  /* @__PURE__ */ new Vector3$1(1, 1, -1),
  /* @__PURE__ */ new Vector3$1(-1, 1, -1),
  /* @__PURE__ */ new Vector3$1(0, PHI, INV_PHI),
  /* @__PURE__ */ new Vector3$1(0, PHI, -INV_PHI),
  /* @__PURE__ */ new Vector3$1(INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3$1(-INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3$1(PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector3$1(-PHI, INV_PHI, 0)
];
class PMREMGenerator {
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(e, s = 0, o = 0.1, a = 100) {
    _oldTarget = this._renderer.getRenderTarget(), this._setSize(256);
    const l = this._allocateTargets();
    return l.depthBuffer = !0, this._sceneToCubeUV(e, o, a, l), s > 0 && this._blur(l, 0, 0, s), this._applyPMREM(l), this._cleanup(l), l;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromEquirectangular(e, s = null) {
    return this._fromTexture(e, s);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromCubemap(e, s = null) {
    return this._fromTexture(e, s);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = _getCubemapMaterial(), this._compileMaterial(this._cubemapMaterial));
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = _getEquirectMaterial(), this._compileMaterial(this._equirectMaterial));
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(_oldTarget), e.scissorTest = !1, _setViewport(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, s) {
    e.mapping === CubeReflectionMapping || e.mapping === CubeRefractionMapping ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), _oldTarget = this._renderer.getRenderTarget();
    const o = s || this._allocateTargets();
    return this._textureToCubeUV(e, o), this._applyPMREM(o), this._cleanup(o), o;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), s = 4 * this._cubeSize, o = {
      magFilter: LinearFilter,
      minFilter: LinearFilter,
      generateMipmaps: !1,
      type: HalfFloatType,
      format: RGBAFormat,
      colorSpace: LinearSRGBColorSpace,
      depthBuffer: !1
    }, a = _createRenderTarget(e, s, o);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e || this._pingPongRenderTarget.height !== s) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = _createRenderTarget(e, s, o);
      const { _lodMax: l } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(l)), this._blurMaterial = _getBlurShader(l, e, s);
    }
    return a;
  }
  _compileMaterial(e) {
    const s = new Mesh(this._lodPlanes[0], e);
    this._renderer.compile(s, _flatCamera);
  }
  _sceneToCubeUV(e, s, o, a) {
    const c = new PerspectiveCamera$1(90, 1, s, o), E = [1, -1, 1, 1, 1, 1], d = [1, 1, 1, -1, -1, -1], f = this._renderer, h = f.autoClear, S = f.toneMapping;
    f.getClearColor(_clearColor), f.toneMapping = NoToneMapping, f.autoClear = !1;
    const R = new MeshBasicMaterial({
      name: "PMREM.Background",
      side: BackSide,
      depthWrite: !1,
      depthTest: !1
    }), _ = new Mesh(new BoxGeometry(), R);
    let m = !1;
    const L = e.background;
    L ? L.isColor && (R.color.copy(L), e.background = null, m = !0) : (R.color.copy(_clearColor), m = !0);
    for (let F = 0; F < 6; F++) {
      const W = F % 3;
      W === 0 ? (c.up.set(0, E[F], 0), c.lookAt(d[F], 0, 0)) : W === 1 ? (c.up.set(0, 0, E[F]), c.lookAt(0, d[F], 0)) : (c.up.set(0, E[F], 0), c.lookAt(0, 0, d[F]));
      const G = this._cubeSize;
      _setViewport(a, W * G, F > 2 ? G : 0, G, G), f.setRenderTarget(a), m && f.render(_, c), f.render(e, c);
    }
    _.geometry.dispose(), _.material.dispose(), f.toneMapping = S, f.autoClear = h, e.background = L;
  }
  _textureToCubeUV(e, s) {
    const o = this._renderer, a = e.mapping === CubeReflectionMapping || e.mapping === CubeRefractionMapping;
    a ? (this._cubemapMaterial === null && (this._cubemapMaterial = _getCubemapMaterial()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = _getEquirectMaterial());
    const l = a ? this._cubemapMaterial : this._equirectMaterial, u = new Mesh(this._lodPlanes[0], l), c = l.uniforms;
    c.envMap.value = e;
    const E = this._cubeSize;
    _setViewport(s, 0, 0, 3 * E, 2 * E), o.setRenderTarget(s), o.render(u, _flatCamera);
  }
  _applyPMREM(e) {
    const s = this._renderer, o = s.autoClear;
    s.autoClear = !1;
    for (let a = 1; a < this._lodPlanes.length; a++) {
      const l = Math.sqrt(this._sigmas[a] * this._sigmas[a] - this._sigmas[a - 1] * this._sigmas[a - 1]), u = _axisDirections[(a - 1) % _axisDirections.length];
      this._blur(e, a - 1, a, l, u);
    }
    s.autoClear = o;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(e, s, o, a, l) {
    const u = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      u,
      s,
      o,
      a,
      "latitudinal",
      l
    ), this._halfBlur(
      u,
      e,
      o,
      o,
      a,
      "longitudinal",
      l
    );
  }
  _halfBlur(e, s, o, a, l, u, c) {
    const E = this._renderer, d = this._blurMaterial;
    u !== "latitudinal" && u !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const f = 3, h = new Mesh(this._lodPlanes[a], d), S = d.uniforms, R = this._sizeLods[o] - 1, _ = isFinite(l) ? Math.PI / (2 * R) : 2 * Math.PI / (2 * MAX_SAMPLES - 1), m = l / _, L = isFinite(l) ? 1 + Math.floor(f * m) : MAX_SAMPLES;
    L > MAX_SAMPLES && console.warn(`sigmaRadians, ${l}, is too large and will clip, as it requested ${L} samples when the maximum is set to ${MAX_SAMPLES}`);
    const F = [];
    let W = 0;
    for (let Le = 0; Le < MAX_SAMPLES; ++Le) {
      const Fe = Le / m, Ee = Math.exp(-Fe * Fe / 2);
      F.push(Ee), Le === 0 ? W += Ee : Le < L && (W += 2 * Ee);
    }
    for (let Le = 0; Le < F.length; Le++)
      F[Le] = F[Le] / W;
    S.envMap.value = e.texture, S.samples.value = L, S.weights.value = F, S.latitudinal.value = u === "latitudinal", c && (S.poleAxis.value = c);
    const { _lodMax: G } = this;
    S.dTheta.value = _, S.mipInt.value = G - o;
    const q = this._sizeLods[a], fe = 3 * q * (a > G - LOD_MIN ? a - G + LOD_MIN : 0), _e = 4 * (this._cubeSize - q);
    _setViewport(s, fe, _e, 3 * q, 2 * q), E.setRenderTarget(s), E.render(h, _flatCamera);
  }
}
function _createPlanes(r) {
  const e = [], s = [], o = [];
  let a = r;
  const l = r - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
  for (let u = 0; u < l; u++) {
    const c = Math.pow(2, a);
    s.push(c);
    let E = 1 / c;
    u > r - LOD_MIN ? E = EXTRA_LOD_SIGMA[u - r + LOD_MIN - 1] : u === 0 && (E = 0), o.push(E);
    const d = 1 / (c - 2), f = -d, h = 1 + d, S = [f, f, h, f, h, h, f, f, h, h, f, h], R = 6, _ = 6, m = 3, L = 2, F = 1, W = new Float32Array(m * _ * R), G = new Float32Array(L * _ * R), q = new Float32Array(F * _ * R);
    for (let _e = 0; _e < R; _e++) {
      const Le = _e % 3 * 2 / 3 - 1, Fe = _e > 2 ? 0 : -1, Ee = [
        Le,
        Fe,
        0,
        Le + 2 / 3,
        Fe,
        0,
        Le + 2 / 3,
        Fe + 1,
        0,
        Le,
        Fe,
        0,
        Le + 2 / 3,
        Fe + 1,
        0,
        Le,
        Fe + 1,
        0
      ];
      W.set(Ee, m * _ * _e), G.set(S, L * _ * _e);
      const Ge = [_e, _e, _e, _e, _e, _e];
      q.set(Ge, F * _ * _e);
    }
    const fe = new BufferGeometry();
    fe.setAttribute("position", new BufferAttribute(W, m)), fe.setAttribute("uv", new BufferAttribute(G, L)), fe.setAttribute("faceIndex", new BufferAttribute(q, F)), e.push(fe), a > LOD_MIN && a--;
  }
  return { lodPlanes: e, sizeLods: s, sigmas: o };
}
function _createRenderTarget(r, e, s) {
  const o = new WebGLRenderTarget(r, e, s);
  return o.texture.mapping = CubeUVReflectionMapping, o.texture.name = "PMREM.cubeUv", o.scissorTest = !0, o;
}
function _setViewport(r, e, s, o, a) {
  r.viewport.set(e, s, o, a), r.scissor.set(e, s, o, a);
}
function _getBlurShader(r, e, s) {
  const o = new Float32Array(MAX_SAMPLES), a = new Vector3$1(0, 1, 0);
  return new ShaderMaterial({
    name: "SphericalGaussianBlur",
    defines: {
      n: MAX_SAMPLES,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / s,
      CUBEUV_MAX_MIP: `${r}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: o },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: a }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending,
    depthTest: !1,
    depthWrite: !1
  });
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps(r) {
  let e = /* @__PURE__ */ new WeakMap(), s = null;
  function o(c) {
    if (c && c.isTexture) {
      const E = c.mapping, d = E === EquirectangularReflectionMapping || E === EquirectangularRefractionMapping, f = E === CubeReflectionMapping || E === CubeRefractionMapping;
      if (d || f)
        if (c.isRenderTargetTexture && c.needsPMREMUpdate === !0) {
          c.needsPMREMUpdate = !1;
          let h = e.get(c);
          return s === null && (s = new PMREMGenerator(r)), h = d ? s.fromEquirectangular(c, h) : s.fromCubemap(c, h), e.set(c, h), h.texture;
        } else {
          if (e.has(c))
            return e.get(c).texture;
          {
            const h = c.image;
            if (d && h && h.height > 0 || f && h && a(h)) {
              s === null && (s = new PMREMGenerator(r));
              const S = d ? s.fromEquirectangular(c) : s.fromCubemap(c);
              return e.set(c, S), c.addEventListener("dispose", l), S.texture;
            } else
              return null;
          }
        }
    }
    return c;
  }
  function a(c) {
    let E = 0;
    const d = 6;
    for (let f = 0; f < d; f++)
      c[f] !== void 0 && E++;
    return E === d;
  }
  function l(c) {
    const E = c.target;
    E.removeEventListener("dispose", l);
    const d = e.get(E);
    d !== void 0 && (e.delete(E), d.dispose());
  }
  function u() {
    e = /* @__PURE__ */ new WeakMap(), s !== null && (s.dispose(), s = null);
  }
  return {
    get: o,
    dispose: u
  };
}
function WebGLExtensions(r) {
  const e = {};
  function s(o) {
    if (e[o] !== void 0)
      return e[o];
    let a;
    switch (o) {
      case "WEBGL_depth_texture":
        a = r.getExtension("WEBGL_depth_texture") || r.getExtension("MOZ_WEBGL_depth_texture") || r.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        a = r.getExtension("EXT_texture_filter_anisotropic") || r.getExtension("MOZ_EXT_texture_filter_anisotropic") || r.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        a = r.getExtension("WEBGL_compressed_texture_s3tc") || r.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || r.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        a = r.getExtension("WEBGL_compressed_texture_pvrtc") || r.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        a = r.getExtension(o);
    }
    return e[o] = a, a;
  }
  return {
    has: function(o) {
      return s(o) !== null;
    },
    init: function(o) {
      o.isWebGL2 ? s("EXT_color_buffer_float") : (s("WEBGL_depth_texture"), s("OES_texture_float"), s("OES_texture_half_float"), s("OES_texture_half_float_linear"), s("OES_standard_derivatives"), s("OES_element_index_uint"), s("OES_vertex_array_object"), s("ANGLE_instanced_arrays")), s("OES_texture_float_linear"), s("EXT_color_buffer_half_float"), s("WEBGL_multisampled_render_to_texture");
    },
    get: function(o) {
      const a = s(o);
      return a === null && console.warn("THREE.WebGLRenderer: " + o + " extension not supported."), a;
    }
  };
}
function WebGLGeometries(r, e, s, o) {
  const a = {}, l = /* @__PURE__ */ new WeakMap();
  function u(h) {
    const S = h.target;
    S.index !== null && e.remove(S.index);
    for (const _ in S.attributes)
      e.remove(S.attributes[_]);
    for (const _ in S.morphAttributes) {
      const m = S.morphAttributes[_];
      for (let L = 0, F = m.length; L < F; L++)
        e.remove(m[L]);
    }
    S.removeEventListener("dispose", u), delete a[S.id];
    const R = l.get(S);
    R && (e.remove(R), l.delete(S)), o.releaseStatesOfGeometry(S), S.isInstancedBufferGeometry === !0 && delete S._maxInstanceCount, s.memory.geometries--;
  }
  function c(h, S) {
    return a[S.id] === !0 || (S.addEventListener("dispose", u), a[S.id] = !0, s.memory.geometries++), S;
  }
  function E(h) {
    const S = h.attributes;
    for (const _ in S)
      e.update(S[_], r.ARRAY_BUFFER);
    const R = h.morphAttributes;
    for (const _ in R) {
      const m = R[_];
      for (let L = 0, F = m.length; L < F; L++)
        e.update(m[L], r.ARRAY_BUFFER);
    }
  }
  function d(h) {
    const S = [], R = h.index, _ = h.attributes.position;
    let m = 0;
    if (R !== null) {
      const W = R.array;
      m = R.version;
      for (let G = 0, q = W.length; G < q; G += 3) {
        const fe = W[G + 0], _e = W[G + 1], Le = W[G + 2];
        S.push(fe, _e, _e, Le, Le, fe);
      }
    } else {
      const W = _.array;
      m = _.version;
      for (let G = 0, q = W.length / 3 - 1; G < q; G += 3) {
        const fe = G + 0, _e = G + 1, Le = G + 2;
        S.push(fe, _e, _e, Le, Le, fe);
      }
    }
    const L = new (arrayNeedsUint32(S) ? Uint32BufferAttribute : Uint16BufferAttribute)(S, 1);
    L.version = m;
    const F = l.get(h);
    F && e.remove(F), l.set(h, L);
  }
  function f(h) {
    const S = l.get(h);
    if (S) {
      const R = h.index;
      R !== null && S.version < R.version && d(h);
    } else
      d(h);
    return l.get(h);
  }
  return {
    get: c,
    update: E,
    getWireframeAttribute: f
  };
}
function WebGLIndexedBufferRenderer(r, e, s, o) {
  const a = o.isWebGL2;
  let l;
  function u(S) {
    l = S;
  }
  let c, E;
  function d(S) {
    c = S.type, E = S.bytesPerElement;
  }
  function f(S, R) {
    r.drawElements(l, R, c, S * E), s.update(R, l, 1);
  }
  function h(S, R, _) {
    if (_ === 0)
      return;
    let m, L;
    if (a)
      m = r, L = "drawElementsInstanced";
    else if (m = e.get("ANGLE_instanced_arrays"), L = "drawElementsInstancedANGLE", m === null) {
      console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    m[L](l, R, c, S * E, _), s.update(R, l, _);
  }
  this.setMode = u, this.setIndex = d, this.render = f, this.renderInstances = h;
}
function WebGLInfo(r) {
  const e = {
    geometries: 0,
    textures: 0
  }, s = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function o(l, u, c) {
    switch (s.calls++, u) {
      case r.TRIANGLES:
        s.triangles += c * (l / 3);
        break;
      case r.LINES:
        s.lines += c * (l / 2);
        break;
      case r.LINE_STRIP:
        s.lines += c * (l - 1);
        break;
      case r.LINE_LOOP:
        s.lines += c * l;
        break;
      case r.POINTS:
        s.points += c * l;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", u);
        break;
    }
  }
  function a() {
    s.calls = 0, s.triangles = 0, s.points = 0, s.lines = 0;
  }
  return {
    memory: e,
    render: s,
    programs: null,
    autoReset: !0,
    reset: a,
    update: o
  };
}
function numericalSort(r, e) {
  return r[0] - e[0];
}
function absNumericalSort(r, e) {
  return Math.abs(e[1]) - Math.abs(r[1]);
}
function WebGLMorphtargets(r, e, s) {
  const o = {}, a = new Float32Array(8), l = /* @__PURE__ */ new WeakMap(), u = new Vector4(), c = [];
  for (let d = 0; d < 8; d++)
    c[d] = [d, 0];
  function E(d, f, h) {
    const S = d.morphTargetInfluences;
    if (e.isWebGL2 === !0) {
      const R = f.morphAttributes.position || f.morphAttributes.normal || f.morphAttributes.color, _ = R !== void 0 ? R.length : 0;
      let m = l.get(f);
      if (m === void 0 || m.count !== _) {
        let v = function() {
          te.dispose(), l.delete(f), f.removeEventListener("dispose", v);
        };
        m !== void 0 && m.texture.dispose();
        const W = f.morphAttributes.position !== void 0, G = f.morphAttributes.normal !== void 0, q = f.morphAttributes.color !== void 0, fe = f.morphAttributes.position || [], _e = f.morphAttributes.normal || [], Le = f.morphAttributes.color || [];
        let Fe = 0;
        W === !0 && (Fe = 1), G === !0 && (Fe = 2), q === !0 && (Fe = 3);
        let Ee = f.attributes.position.count * Fe, Ge = 1;
        Ee > e.maxTextureSize && (Ge = Math.ceil(Ee / e.maxTextureSize), Ee = e.maxTextureSize);
        const ve = new Float32Array(Ee * Ge * 4 * _), te = new DataArrayTexture(ve, Ee, Ge, _);
        te.type = FloatType, te.needsUpdate = !0;
        const ae = Fe * 4;
        for (let Te = 0; Te < _; Te++) {
          const De = fe[Te], be = _e[Te], ze = Le[Te], ke = Ee * Ge * 4 * Te;
          for (let Be = 0; Be < De.count; Be++) {
            const Me = Be * ae;
            W === !0 && (u.fromBufferAttribute(De, Be), ve[ke + Me + 0] = u.x, ve[ke + Me + 1] = u.y, ve[ke + Me + 2] = u.z, ve[ke + Me + 3] = 0), G === !0 && (u.fromBufferAttribute(be, Be), ve[ke + Me + 4] = u.x, ve[ke + Me + 5] = u.y, ve[ke + Me + 6] = u.z, ve[ke + Me + 7] = 0), q === !0 && (u.fromBufferAttribute(ze, Be), ve[ke + Me + 8] = u.x, ve[ke + Me + 9] = u.y, ve[ke + Me + 10] = u.z, ve[ke + Me + 11] = ze.itemSize === 4 ? u.w : 1);
          }
        }
        m = {
          count: _,
          texture: te,
          size: new Vector2(Ee, Ge)
        }, l.set(f, m), f.addEventListener("dispose", v);
      }
      let L = 0;
      for (let W = 0; W < S.length; W++)
        L += S[W];
      const F = f.morphTargetsRelative ? 1 : 1 - L;
      h.getUniforms().setValue(r, "morphTargetBaseInfluence", F), h.getUniforms().setValue(r, "morphTargetInfluences", S), h.getUniforms().setValue(r, "morphTargetsTexture", m.texture, s), h.getUniforms().setValue(r, "morphTargetsTextureSize", m.size);
    } else {
      const R = S === void 0 ? 0 : S.length;
      let _ = o[f.id];
      if (_ === void 0 || _.length !== R) {
        _ = [];
        for (let G = 0; G < R; G++)
          _[G] = [G, 0];
        o[f.id] = _;
      }
      for (let G = 0; G < R; G++) {
        const q = _[G];
        q[0] = G, q[1] = S[G];
      }
      _.sort(absNumericalSort);
      for (let G = 0; G < 8; G++)
        G < R && _[G][1] ? (c[G][0] = _[G][0], c[G][1] = _[G][1]) : (c[G][0] = Number.MAX_SAFE_INTEGER, c[G][1] = 0);
      c.sort(numericalSort);
      const m = f.morphAttributes.position, L = f.morphAttributes.normal;
      let F = 0;
      for (let G = 0; G < 8; G++) {
        const q = c[G], fe = q[0], _e = q[1];
        fe !== Number.MAX_SAFE_INTEGER && _e ? (m && f.getAttribute("morphTarget" + G) !== m[fe] && f.setAttribute("morphTarget" + G, m[fe]), L && f.getAttribute("morphNormal" + G) !== L[fe] && f.setAttribute("morphNormal" + G, L[fe]), a[G] = _e, F += _e) : (m && f.hasAttribute("morphTarget" + G) === !0 && f.deleteAttribute("morphTarget" + G), L && f.hasAttribute("morphNormal" + G) === !0 && f.deleteAttribute("morphNormal" + G), a[G] = 0);
      }
      const W = f.morphTargetsRelative ? 1 : 1 - F;
      h.getUniforms().setValue(r, "morphTargetBaseInfluence", W), h.getUniforms().setValue(r, "morphTargetInfluences", a);
    }
  }
  return {
    update: E
  };
}
function WebGLObjects(r, e, s, o) {
  let a = /* @__PURE__ */ new WeakMap();
  function l(E) {
    const d = o.render.frame, f = E.geometry, h = e.get(E, f);
    if (a.get(h) !== d && (e.update(h), a.set(h, d)), E.isInstancedMesh && (E.hasEventListener("dispose", c) === !1 && E.addEventListener("dispose", c), a.get(E) !== d && (s.update(E.instanceMatrix, r.ARRAY_BUFFER), E.instanceColor !== null && s.update(E.instanceColor, r.ARRAY_BUFFER), a.set(E, d))), E.isSkinnedMesh) {
      const S = E.skeleton;
      a.get(S) !== d && (S.update(), a.set(S, d));
    }
    return h;
  }
  function u() {
    a = /* @__PURE__ */ new WeakMap();
  }
  function c(E) {
    const d = E.target;
    d.removeEventListener("dispose", c), s.remove(d.instanceMatrix), d.instanceColor !== null && s.remove(d.instanceColor);
  }
  return {
    update: l,
    dispose: u
  };
}
const emptyTexture = /* @__PURE__ */ new Texture(), emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture(), empty3dTexture = /* @__PURE__ */ new Data3DTexture(), emptyCubeTexture = /* @__PURE__ */ new CubeTexture(), arrayCacheF32 = [], arrayCacheI32 = [], mat4array = new Float32Array(16), mat3array = new Float32Array(9), mat2array = new Float32Array(4);
function flatten$2(r, e, s) {
  const o = r[0];
  if (o <= 0 || o > 0)
    return r;
  const a = e * s;
  let l = arrayCacheF32[a];
  if (l === void 0 && (l = new Float32Array(a), arrayCacheF32[a] = l), e !== 0) {
    o.toArray(l, 0);
    for (let u = 1, c = 0; u !== e; ++u)
      c += s, r[u].toArray(l, c);
  }
  return l;
}
function arraysEqual(r, e) {
  if (r.length !== e.length)
    return !1;
  for (let s = 0, o = r.length; s < o; s++)
    if (r[s] !== e[s])
      return !1;
  return !0;
}
function copyArray$1(r, e) {
  for (let s = 0, o = e.length; s < o; s++)
    r[s] = e[s];
}
function allocTexUnits(r, e) {
  let s = arrayCacheI32[e];
  s === void 0 && (s = new Int32Array(e), arrayCacheI32[e] = s);
  for (let o = 0; o !== e; ++o)
    s[o] = r.allocateTextureUnit();
  return s;
}
function setValueV1f(r, e) {
  const s = this.cache;
  s[0] !== e && (r.uniform1f(this.addr, e), s[0] = e);
}
function setValueV2f(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y) && (r.uniform2f(this.addr, e.x, e.y), s[0] = e.x, s[1] = e.y);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform2fv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV3f(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z) && (r.uniform3f(this.addr, e.x, e.y, e.z), s[0] = e.x, s[1] = e.y, s[2] = e.z);
  else if (e.r !== void 0)
    (s[0] !== e.r || s[1] !== e.g || s[2] !== e.b) && (r.uniform3f(this.addr, e.r, e.g, e.b), s[0] = e.r, s[1] = e.g, s[2] = e.b);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform3fv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV4f(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z || s[3] !== e.w) && (r.uniform4f(this.addr, e.x, e.y, e.z, e.w), s[0] = e.x, s[1] = e.y, s[2] = e.z, s[3] = e.w);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform4fv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueM2(r, e) {
  const s = this.cache, o = e.elements;
  if (o === void 0) {
    if (arraysEqual(s, e))
      return;
    r.uniformMatrix2fv(this.addr, !1, e), copyArray$1(s, e);
  } else {
    if (arraysEqual(s, o))
      return;
    mat2array.set(o), r.uniformMatrix2fv(this.addr, !1, mat2array), copyArray$1(s, o);
  }
}
function setValueM3(r, e) {
  const s = this.cache, o = e.elements;
  if (o === void 0) {
    if (arraysEqual(s, e))
      return;
    r.uniformMatrix3fv(this.addr, !1, e), copyArray$1(s, e);
  } else {
    if (arraysEqual(s, o))
      return;
    mat3array.set(o), r.uniformMatrix3fv(this.addr, !1, mat3array), copyArray$1(s, o);
  }
}
function setValueM4(r, e) {
  const s = this.cache, o = e.elements;
  if (o === void 0) {
    if (arraysEqual(s, e))
      return;
    r.uniformMatrix4fv(this.addr, !1, e), copyArray$1(s, e);
  } else {
    if (arraysEqual(s, o))
      return;
    mat4array.set(o), r.uniformMatrix4fv(this.addr, !1, mat4array), copyArray$1(s, o);
  }
}
function setValueV1i(r, e) {
  const s = this.cache;
  s[0] !== e && (r.uniform1i(this.addr, e), s[0] = e);
}
function setValueV2i(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y) && (r.uniform2i(this.addr, e.x, e.y), s[0] = e.x, s[1] = e.y);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform2iv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV3i(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z) && (r.uniform3i(this.addr, e.x, e.y, e.z), s[0] = e.x, s[1] = e.y, s[2] = e.z);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform3iv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV4i(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z || s[3] !== e.w) && (r.uniform4i(this.addr, e.x, e.y, e.z, e.w), s[0] = e.x, s[1] = e.y, s[2] = e.z, s[3] = e.w);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform4iv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV1ui(r, e) {
  const s = this.cache;
  s[0] !== e && (r.uniform1ui(this.addr, e), s[0] = e);
}
function setValueV2ui(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y) && (r.uniform2ui(this.addr, e.x, e.y), s[0] = e.x, s[1] = e.y);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform2uiv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV3ui(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z) && (r.uniform3ui(this.addr, e.x, e.y, e.z), s[0] = e.x, s[1] = e.y, s[2] = e.z);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform3uiv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueV4ui(r, e) {
  const s = this.cache;
  if (e.x !== void 0)
    (s[0] !== e.x || s[1] !== e.y || s[2] !== e.z || s[3] !== e.w) && (r.uniform4ui(this.addr, e.x, e.y, e.z, e.w), s[0] = e.x, s[1] = e.y, s[2] = e.z, s[3] = e.w);
  else {
    if (arraysEqual(s, e))
      return;
    r.uniform4uiv(this.addr, e), copyArray$1(s, e);
  }
}
function setValueT1(r, e, s) {
  const o = this.cache, a = s.allocateTextureUnit();
  o[0] !== a && (r.uniform1i(this.addr, a), o[0] = a), s.setTexture2D(e || emptyTexture, a);
}
function setValueT3D1(r, e, s) {
  const o = this.cache, a = s.allocateTextureUnit();
  o[0] !== a && (r.uniform1i(this.addr, a), o[0] = a), s.setTexture3D(e || empty3dTexture, a);
}
function setValueT6(r, e, s) {
  const o = this.cache, a = s.allocateTextureUnit();
  o[0] !== a && (r.uniform1i(this.addr, a), o[0] = a), s.setTextureCube(e || emptyCubeTexture, a);
}
function setValueT2DArray1(r, e, s) {
  const o = this.cache, a = s.allocateTextureUnit();
  o[0] !== a && (r.uniform1i(this.addr, a), o[0] = a), s.setTexture2DArray(e || emptyArrayTexture, a);
}
function getSingularSetter(r) {
  switch (r) {
    case 5126:
      return setValueV1f;
    case 35664:
      return setValueV2f;
    case 35665:
      return setValueV3f;
    case 35666:
      return setValueV4f;
    case 35674:
      return setValueM2;
    case 35675:
      return setValueM3;
    case 35676:
      return setValueM4;
    case 5124:
    case 35670:
      return setValueV1i;
    case 35667:
    case 35671:
      return setValueV2i;
    case 35668:
    case 35672:
      return setValueV3i;
    case 35669:
    case 35673:
      return setValueV4i;
    case 5125:
      return setValueV1ui;
    case 36294:
      return setValueV2ui;
    case 36295:
      return setValueV3ui;
    case 36296:
      return setValueV4ui;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(r, e) {
  r.uniform1fv(this.addr, e);
}
function setValueV2fArray(r, e) {
  const s = flatten$2(e, this.size, 2);
  r.uniform2fv(this.addr, s);
}
function setValueV3fArray(r, e) {
  const s = flatten$2(e, this.size, 3);
  r.uniform3fv(this.addr, s);
}
function setValueV4fArray(r, e) {
  const s = flatten$2(e, this.size, 4);
  r.uniform4fv(this.addr, s);
}
function setValueM2Array(r, e) {
  const s = flatten$2(e, this.size, 4);
  r.uniformMatrix2fv(this.addr, !1, s);
}
function setValueM3Array(r, e) {
  const s = flatten$2(e, this.size, 9);
  r.uniformMatrix3fv(this.addr, !1, s);
}
function setValueM4Array(r, e) {
  const s = flatten$2(e, this.size, 16);
  r.uniformMatrix4fv(this.addr, !1, s);
}
function setValueV1iArray(r, e) {
  r.uniform1iv(this.addr, e);
}
function setValueV2iArray(r, e) {
  r.uniform2iv(this.addr, e);
}
function setValueV3iArray(r, e) {
  r.uniform3iv(this.addr, e);
}
function setValueV4iArray(r, e) {
  r.uniform4iv(this.addr, e);
}
function setValueV1uiArray(r, e) {
  r.uniform1uiv(this.addr, e);
}
function setValueV2uiArray(r, e) {
  r.uniform2uiv(this.addr, e);
}
function setValueV3uiArray(r, e) {
  r.uniform3uiv(this.addr, e);
}
function setValueV4uiArray(r, e) {
  r.uniform4uiv(this.addr, e);
}
function setValueT1Array(r, e, s) {
  const o = this.cache, a = e.length, l = allocTexUnits(s, a);
  arraysEqual(o, l) || (r.uniform1iv(this.addr, l), copyArray$1(o, l));
  for (let u = 0; u !== a; ++u)
    s.setTexture2D(e[u] || emptyTexture, l[u]);
}
function setValueT3DArray(r, e, s) {
  const o = this.cache, a = e.length, l = allocTexUnits(s, a);
  arraysEqual(o, l) || (r.uniform1iv(this.addr, l), copyArray$1(o, l));
  for (let u = 0; u !== a; ++u)
    s.setTexture3D(e[u] || empty3dTexture, l[u]);
}
function setValueT6Array(r, e, s) {
  const o = this.cache, a = e.length, l = allocTexUnits(s, a);
  arraysEqual(o, l) || (r.uniform1iv(this.addr, l), copyArray$1(o, l));
  for (let u = 0; u !== a; ++u)
    s.setTextureCube(e[u] || emptyCubeTexture, l[u]);
}
function setValueT2DArrayArray(r, e, s) {
  const o = this.cache, a = e.length, l = allocTexUnits(s, a);
  arraysEqual(o, l) || (r.uniform1iv(this.addr, l), copyArray$1(o, l));
  for (let u = 0; u !== a; ++u)
    s.setTexture2DArray(e[u] || emptyArrayTexture, l[u]);
}
function getPureArraySetter(r) {
  switch (r) {
    case 5126:
      return setValueV1fArray;
    case 35664:
      return setValueV2fArray;
    case 35665:
      return setValueV3fArray;
    case 35666:
      return setValueV4fArray;
    case 35674:
      return setValueM2Array;
    case 35675:
      return setValueM3Array;
    case 35676:
      return setValueM4Array;
    case 5124:
    case 35670:
      return setValueV1iArray;
    case 35667:
    case 35671:
      return setValueV2iArray;
    case 35668:
    case 35672:
      return setValueV3iArray;
    case 35669:
    case 35673:
      return setValueV4iArray;
    case 5125:
      return setValueV1uiArray;
    case 36294:
      return setValueV2uiArray;
    case 36295:
      return setValueV3uiArray;
    case 36296:
      return setValueV4uiArray;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3DArray;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArrayArray;
  }
}
class SingleUniform {
  constructor(e, s, o) {
    this.id = e, this.addr = o, this.cache = [], this.setValue = getSingularSetter(s.type);
  }
}
class PureArrayUniform {
  constructor(e, s, o) {
    this.id = e, this.addr = o, this.cache = [], this.size = s.size, this.setValue = getPureArraySetter(s.type);
  }
}
class StructuredUniform {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, s, o) {
    const a = this.seq;
    for (let l = 0, u = a.length; l !== u; ++l) {
      const c = a[l];
      c.setValue(e, s[c.id], o);
    }
  }
}
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(r, e) {
  r.seq.push(e), r.map[e.id] = e;
}
function parseUniform(r, e, s) {
  const o = r.name, a = o.length;
  for (RePathPart.lastIndex = 0; ; ) {
    const l = RePathPart.exec(o), u = RePathPart.lastIndex;
    let c = l[1];
    const E = l[2] === "]", d = l[3];
    if (E && (c = c | 0), d === void 0 || d === "[" && u + 2 === a) {
      addUniform(s, d === void 0 ? new SingleUniform(c, r, e) : new PureArrayUniform(c, r, e));
      break;
    } else {
      let h = s.map[c];
      h === void 0 && (h = new StructuredUniform(c), addUniform(s, h)), s = h;
    }
  }
}
class WebGLUniforms {
  constructor(e, s) {
    this.seq = [], this.map = {};
    const o = e.getProgramParameter(s, e.ACTIVE_UNIFORMS);
    for (let a = 0; a < o; ++a) {
      const l = e.getActiveUniform(s, a), u = e.getUniformLocation(s, l.name);
      parseUniform(l, u, this);
    }
  }
  setValue(e, s, o, a) {
    const l = this.map[s];
    l !== void 0 && l.setValue(e, o, a);
  }
  setOptional(e, s, o) {
    const a = s[o];
    a !== void 0 && this.setValue(e, o, a);
  }
  static upload(e, s, o, a) {
    for (let l = 0, u = s.length; l !== u; ++l) {
      const c = s[l], E = o[c.id];
      E.needsUpdate !== !1 && c.setValue(e, E.value, a);
    }
  }
  static seqWithValue(e, s) {
    const o = [];
    for (let a = 0, l = e.length; a !== l; ++a) {
      const u = e[a];
      u.id in s && o.push(u);
    }
    return o;
  }
}
function WebGLShader(r, e, s) {
  const o = r.createShader(e);
  return r.shaderSource(o, s), r.compileShader(o), o;
}
let programIdCount = 0;
function handleSource(r, e) {
  const s = r.split(`
`), o = [], a = Math.max(e - 6, 0), l = Math.min(e + 6, s.length);
  for (let u = a; u < l; u++) {
    const c = u + 1;
    o.push(`${c === e ? ">" : " "} ${c}: ${s[u]}`);
  }
  return o.join(`
`);
}
function getEncodingComponents(r) {
  switch (r) {
    case LinearSRGBColorSpace:
      return ["Linear", "( value )"];
    case SRGBColorSpace:
      return ["sRGB", "( value )"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported color space:", r), ["Linear", "( value )"];
  }
}
function getShaderErrors(r, e, s) {
  const o = r.getShaderParameter(e, r.COMPILE_STATUS), a = r.getShaderInfoLog(e).trim();
  if (o && a === "")
    return "";
  const l = /ERROR: 0:(\d+)/.exec(a);
  if (l) {
    const u = parseInt(l[1]);
    return s.toUpperCase() + `

` + a + `

` + handleSource(r.getShaderSource(e), u);
  } else
    return a;
}
function getTexelEncodingFunction(r, e) {
  const s = getEncodingComponents(e);
  return "vec4 " + r + "( vec4 value ) { return LinearTo" + s[0] + s[1] + "; }";
}
function getToneMappingFunction(r, e) {
  let s;
  switch (e) {
    case LinearToneMapping:
      s = "Linear";
      break;
    case ReinhardToneMapping:
      s = "Reinhard";
      break;
    case CineonToneMapping:
      s = "OptimizedCineon";
      break;
    case ACESFilmicToneMapping:
      s = "ACESFilmic";
      break;
    case CustomToneMapping:
      s = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), s = "Linear";
  }
  return "vec3 " + r + "( vec3 color ) { return " + s + "ToneMapping( color ); }";
}
function generateExtensions(r) {
  return [
    r.extensionDerivatives || r.envMapCubeUVHeight || r.bumpMap || r.normalMapTangentSpace || r.clearcoatNormalMap || r.flatShading || r.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (r.extensionFragDepth || r.logarithmicDepthBuffer) && r.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    r.extensionDrawBuffers && r.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (r.extensionShaderTextureLOD || r.envMap || r.transmission) && r.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ].filter(filterEmptyLine).join(`
`);
}
function generateDefines(r) {
  const e = [];
  for (const s in r) {
    const o = r[s];
    o !== !1 && e.push("#define " + s + " " + o);
  }
  return e.join(`
`);
}
function fetchAttributeLocations(r, e) {
  const s = {}, o = r.getProgramParameter(e, r.ACTIVE_ATTRIBUTES);
  for (let a = 0; a < o; a++) {
    const l = r.getActiveAttrib(e, a), u = l.name;
    let c = 1;
    l.type === r.FLOAT_MAT2 && (c = 2), l.type === r.FLOAT_MAT3 && (c = 3), l.type === r.FLOAT_MAT4 && (c = 4), s[u] = {
      type: l.type,
      location: r.getAttribLocation(e, u),
      locationSize: c
    };
  }
  return s;
}
function filterEmptyLine(r) {
  return r !== "";
}
function replaceLightNums(r, e) {
  const s = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
  return r.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, s).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function replaceClippingPlaneNums(r, e) {
  return r.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(r) {
  return r.replace(includePattern, includeReplacer);
}
const shaderChunkMap = /* @__PURE__ */ new Map([
  ["encodings_fragment", "colorspace_fragment"],
  // @deprecated, r154
  ["encodings_pars_fragment", "colorspace_pars_fragment"],
  // @deprecated, r154
  ["output_fragment", "opaque_fragment"]
  // @deprecated, r154
]);
function includeReplacer(r, e) {
  let s = ShaderChunk[e];
  if (s === void 0) {
    const o = shaderChunkMap.get(e);
    if (o !== void 0)
      s = ShaderChunk[o], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, o);
    else
      throw new Error("Can not resolve #include <" + e + ">");
  }
  return resolveIncludes(s);
}
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(r) {
  return r.replace(unrollLoopPattern, loopReplacer);
}
function loopReplacer(r, e, s, o) {
  let a = "";
  for (let l = parseInt(e); l < parseInt(s); l++)
    a += o.replace(/\[\s*i\s*\]/g, "[ " + l + " ]").replace(/UNROLLED_LOOP_INDEX/g, l);
  return a;
}
function generatePrecision(r) {
  let e = "precision " + r.precision + ` float;
precision ` + r.precision + " int;";
  return r.precision === "highp" ? e += `
#define HIGH_PRECISION` : r.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : r.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function generateShadowMapTypeDefine(r) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return r.shadowMapType === PCFShadowMap ? e = "SHADOWMAP_TYPE_PCF" : r.shadowMapType === PCFSoftShadowMap ? e = "SHADOWMAP_TYPE_PCF_SOFT" : r.shadowMapType === VSMShadowMap && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function generateEnvMapTypeDefine(r) {
  let e = "ENVMAP_TYPE_CUBE";
  if (r.envMap)
    switch (r.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function generateEnvMapModeDefine(r) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (r.envMap)
    switch (r.envMapMode) {
      case CubeRefractionMapping:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function generateEnvMapBlendingDefine(r) {
  let e = "ENVMAP_BLENDING_NONE";
  if (r.envMap)
    switch (r.combine) {
      case MultiplyOperation:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function generateCubeUVSize(r) {
  const e = r.envMapCubeUVHeight;
  if (e === null)
    return null;
  const s = Math.log2(e) - 2, o = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, s), 7 * 16)), texelHeight: o, maxMip: s };
}
function WebGLProgram(r, e, s, o) {
  const a = r.getContext(), l = s.defines;
  let u = s.vertexShader, c = s.fragmentShader;
  const E = generateShadowMapTypeDefine(s), d = generateEnvMapTypeDefine(s), f = generateEnvMapModeDefine(s), h = generateEnvMapBlendingDefine(s), S = generateCubeUVSize(s), R = s.isWebGL2 ? "" : generateExtensions(s), _ = generateDefines(l), m = a.createProgram();
  let L, F, W = s.glslVersion ? "#version " + s.glslVersion + `
` : "";
  s.isRawShaderMaterial ? (L = [
    "#define SHADER_TYPE " + s.shaderType,
    "#define SHADER_NAME " + s.shaderName,
    _
  ].filter(filterEmptyLine).join(`
`), L.length > 0 && (L += `
`), F = [
    R,
    "#define SHADER_TYPE " + s.shaderType,
    "#define SHADER_NAME " + s.shaderName,
    _
  ].filter(filterEmptyLine).join(`
`), F.length > 0 && (F += `
`)) : (L = [
    generatePrecision(s),
    "#define SHADER_TYPE " + s.shaderType,
    "#define SHADER_NAME " + s.shaderName,
    _,
    s.instancing ? "#define USE_INSTANCING" : "",
    s.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    s.useFog && s.fog ? "#define USE_FOG" : "",
    s.useFog && s.fogExp2 ? "#define FOG_EXP2" : "",
    s.map ? "#define USE_MAP" : "",
    s.envMap ? "#define USE_ENVMAP" : "",
    s.envMap ? "#define " + f : "",
    s.lightMap ? "#define USE_LIGHTMAP" : "",
    s.aoMap ? "#define USE_AOMAP" : "",
    s.bumpMap ? "#define USE_BUMPMAP" : "",
    s.normalMap ? "#define USE_NORMALMAP" : "",
    s.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    s.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    s.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
    s.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    s.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    s.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    s.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    s.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    s.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    s.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    s.specularMap ? "#define USE_SPECULARMAP" : "",
    s.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    s.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    s.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    s.metalnessMap ? "#define USE_METALNESSMAP" : "",
    s.alphaMap ? "#define USE_ALPHAMAP" : "",
    s.alphaHash ? "#define USE_ALPHAHASH" : "",
    s.transmission ? "#define USE_TRANSMISSION" : "",
    s.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    s.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    s.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    s.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    //
    s.mapUv ? "#define MAP_UV " + s.mapUv : "",
    s.alphaMapUv ? "#define ALPHAMAP_UV " + s.alphaMapUv : "",
    s.lightMapUv ? "#define LIGHTMAP_UV " + s.lightMapUv : "",
    s.aoMapUv ? "#define AOMAP_UV " + s.aoMapUv : "",
    s.emissiveMapUv ? "#define EMISSIVEMAP_UV " + s.emissiveMapUv : "",
    s.bumpMapUv ? "#define BUMPMAP_UV " + s.bumpMapUv : "",
    s.normalMapUv ? "#define NORMALMAP_UV " + s.normalMapUv : "",
    s.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + s.displacementMapUv : "",
    s.metalnessMapUv ? "#define METALNESSMAP_UV " + s.metalnessMapUv : "",
    s.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + s.roughnessMapUv : "",
    s.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + s.anisotropyMapUv : "",
    s.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + s.clearcoatMapUv : "",
    s.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + s.clearcoatNormalMapUv : "",
    s.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + s.clearcoatRoughnessMapUv : "",
    s.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + s.iridescenceMapUv : "",
    s.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + s.iridescenceThicknessMapUv : "",
    s.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + s.sheenColorMapUv : "",
    s.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + s.sheenRoughnessMapUv : "",
    s.specularMapUv ? "#define SPECULARMAP_UV " + s.specularMapUv : "",
    s.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + s.specularColorMapUv : "",
    s.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + s.specularIntensityMapUv : "",
    s.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + s.transmissionMapUv : "",
    s.thicknessMapUv ? "#define THICKNESSMAP_UV " + s.thicknessMapUv : "",
    //
    s.vertexTangents && s.flatShading === !1 ? "#define USE_TANGENT" : "",
    s.vertexColors ? "#define USE_COLOR" : "",
    s.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    s.vertexUv1s ? "#define USE_UV1" : "",
    s.vertexUv2s ? "#define USE_UV2" : "",
    s.vertexUv3s ? "#define USE_UV3" : "",
    s.pointsUvs ? "#define USE_POINTS_UV" : "",
    s.flatShading ? "#define FLAT_SHADED" : "",
    s.skinning ? "#define USE_SKINNING" : "",
    s.morphTargets ? "#define USE_MORPHTARGETS" : "",
    s.morphNormals && s.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    s.morphColors && s.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
    s.morphTargetsCount > 0 && s.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
    s.morphTargetsCount > 0 && s.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + s.morphTextureStride : "",
    s.morphTargetsCount > 0 && s.isWebGL2 ? "#define MORPHTARGETS_COUNT " + s.morphTargetsCount : "",
    s.doubleSided ? "#define DOUBLE_SIDED" : "",
    s.flipSided ? "#define FLIP_SIDED" : "",
    s.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    s.shadowMapEnabled ? "#define " + E : "",
    s.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    s.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
    s.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    s.logarithmicDepthBuffer && s.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_UV1",
    "	attribute vec2 uv1;",
    "#endif",
    "#ifdef USE_UV2",
    "	attribute vec2 uv2;",
    "#endif",
    "#ifdef USE_UV3",
    "	attribute vec2 uv3;",
    "#endif",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
    "	attribute vec3 morphTarget0;",
    "	attribute vec3 morphTarget1;",
    "	attribute vec3 morphTarget2;",
    "	attribute vec3 morphTarget3;",
    "	#ifdef USE_MORPHNORMALS",
    "		attribute vec3 morphNormal0;",
    "		attribute vec3 morphNormal1;",
    "		attribute vec3 morphNormal2;",
    "		attribute vec3 morphNormal3;",
    "	#else",
    "		attribute vec3 morphTarget4;",
    "		attribute vec3 morphTarget5;",
    "		attribute vec3 morphTarget6;",
    "		attribute vec3 morphTarget7;",
    "	#endif",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(filterEmptyLine).join(`
`), F = [
    R,
    generatePrecision(s),
    "#define SHADER_TYPE " + s.shaderType,
    "#define SHADER_NAME " + s.shaderName,
    _,
    s.useFog && s.fog ? "#define USE_FOG" : "",
    s.useFog && s.fogExp2 ? "#define FOG_EXP2" : "",
    s.map ? "#define USE_MAP" : "",
    s.matcap ? "#define USE_MATCAP" : "",
    s.envMap ? "#define USE_ENVMAP" : "",
    s.envMap ? "#define " + d : "",
    s.envMap ? "#define " + f : "",
    s.envMap ? "#define " + h : "",
    S ? "#define CUBEUV_TEXEL_WIDTH " + S.texelWidth : "",
    S ? "#define CUBEUV_TEXEL_HEIGHT " + S.texelHeight : "",
    S ? "#define CUBEUV_MAX_MIP " + S.maxMip + ".0" : "",
    s.lightMap ? "#define USE_LIGHTMAP" : "",
    s.aoMap ? "#define USE_AOMAP" : "",
    s.bumpMap ? "#define USE_BUMPMAP" : "",
    s.normalMap ? "#define USE_NORMALMAP" : "",
    s.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
    s.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
    s.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    s.anisotropy ? "#define USE_ANISOTROPY" : "",
    s.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
    s.clearcoat ? "#define USE_CLEARCOAT" : "",
    s.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    s.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    s.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    s.iridescence ? "#define USE_IRIDESCENCE" : "",
    s.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    s.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    s.specularMap ? "#define USE_SPECULARMAP" : "",
    s.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
    s.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
    s.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    s.metalnessMap ? "#define USE_METALNESSMAP" : "",
    s.alphaMap ? "#define USE_ALPHAMAP" : "",
    s.alphaTest ? "#define USE_ALPHATEST" : "",
    s.alphaHash ? "#define USE_ALPHAHASH" : "",
    s.sheen ? "#define USE_SHEEN" : "",
    s.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
    s.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
    s.transmission ? "#define USE_TRANSMISSION" : "",
    s.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    s.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    s.vertexTangents && s.flatShading === !1 ? "#define USE_TANGENT" : "",
    s.vertexColors || s.instancingColor ? "#define USE_COLOR" : "",
    s.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    s.vertexUv1s ? "#define USE_UV1" : "",
    s.vertexUv2s ? "#define USE_UV2" : "",
    s.vertexUv3s ? "#define USE_UV3" : "",
    s.pointsUvs ? "#define USE_POINTS_UV" : "",
    s.gradientMap ? "#define USE_GRADIENTMAP" : "",
    s.flatShading ? "#define FLAT_SHADED" : "",
    s.doubleSided ? "#define DOUBLE_SIDED" : "",
    s.flipSided ? "#define FLIP_SIDED" : "",
    s.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    s.shadowMapEnabled ? "#define " + E : "",
    s.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    s.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
    s.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    s.logarithmicDepthBuffer && s.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    s.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
    s.toneMapping !== NoToneMapping ? ShaderChunk.tonemapping_pars_fragment : "",
    // this code is required here because it is used by the toneMapping() function defined below
    s.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", s.toneMapping) : "",
    s.dithering ? "#define DITHERING" : "",
    s.opaque ? "#define OPAQUE" : "",
    ShaderChunk.colorspace_pars_fragment,
    // this code is required here because it is used by the various encoding/decoding function defined below
    getTexelEncodingFunction("linearToOutputTexel", s.outputColorSpace),
    s.useDepthPacking ? "#define DEPTH_PACKING " + s.depthPacking : "",
    `
`
  ].filter(filterEmptyLine).join(`
`)), u = resolveIncludes(u), u = replaceLightNums(u, s), u = replaceClippingPlaneNums(u, s), c = resolveIncludes(c), c = replaceLightNums(c, s), c = replaceClippingPlaneNums(c, s), u = unrollLoops(u), c = unrollLoops(c), s.isWebGL2 && s.isRawShaderMaterial !== !0 && (W = `#version 300 es
`, L = [
    "precision mediump sampler2DArray;",
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + L, F = [
    "#define varying in",
    s.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    s.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + F);
  const G = W + L + u, q = W + F + c, fe = WebGLShader(a, a.VERTEX_SHADER, G), _e = WebGLShader(a, a.FRAGMENT_SHADER, q);
  if (a.attachShader(m, fe), a.attachShader(m, _e), s.index0AttributeName !== void 0 ? a.bindAttribLocation(m, 0, s.index0AttributeName) : s.morphTargets === !0 && a.bindAttribLocation(m, 0, "position"), a.linkProgram(m), r.debug.checkShaderErrors) {
    const Ee = a.getProgramInfoLog(m).trim(), Ge = a.getShaderInfoLog(fe).trim(), ve = a.getShaderInfoLog(_e).trim();
    let te = !0, ae = !0;
    if (a.getProgramParameter(m, a.LINK_STATUS) === !1)
      if (te = !1, typeof r.debug.onShaderError == "function")
        r.debug.onShaderError(a, m, fe, _e);
      else {
        const v = getShaderErrors(a, fe, "vertex"), Te = getShaderErrors(a, _e, "fragment");
        console.error(
          "THREE.WebGLProgram: Shader Error " + a.getError() + " - VALIDATE_STATUS " + a.getProgramParameter(m, a.VALIDATE_STATUS) + `

Program Info Log: ` + Ee + `
` + v + `
` + Te
        );
      }
    else
      Ee !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", Ee) : (Ge === "" || ve === "") && (ae = !1);
    ae && (this.diagnostics = {
      runnable: te,
      programLog: Ee,
      vertexShader: {
        log: Ge,
        prefix: L
      },
      fragmentShader: {
        log: ve,
        prefix: F
      }
    });
  }
  a.deleteShader(fe), a.deleteShader(_e);
  let Le;
  this.getUniforms = function() {
    return Le === void 0 && (Le = new WebGLUniforms(a, m)), Le;
  };
  let Fe;
  return this.getAttributes = function() {
    return Fe === void 0 && (Fe = fetchAttributeLocations(a, m)), Fe;
  }, this.destroy = function() {
    o.releaseStatesOfProgram(this), a.deleteProgram(m), this.program = void 0;
  }, this.type = s.shaderType, this.name = s.shaderName, this.id = programIdCount++, this.cacheKey = e, this.usedTimes = 1, this.program = m, this.vertexShader = fe, this.fragmentShader = _e, this;
}
let _id = 0;
class WebGLShaderCache {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const s = e.vertexShader, o = e.fragmentShader, a = this._getShaderStage(s), l = this._getShaderStage(o), u = this._getShaderCacheForMaterial(e);
    return u.has(a) === !1 && (u.add(a), a.usedTimes++), u.has(l) === !1 && (u.add(l), l.usedTimes++), this;
  }
  remove(e) {
    const s = this.materialCache.get(e);
    for (const o of s)
      o.usedTimes--, o.usedTimes === 0 && this.shaderCache.delete(o.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const s = this.materialCache;
    let o = s.get(e);
    return o === void 0 && (o = /* @__PURE__ */ new Set(), s.set(e, o)), o;
  }
  _getShaderStage(e) {
    const s = this.shaderCache;
    let o = s.get(e);
    return o === void 0 && (o = new WebGLShaderStage(e), s.set(e, o)), o;
  }
}
class WebGLShaderStage {
  constructor(e) {
    this.id = _id++, this.code = e, this.usedTimes = 0;
  }
}
function WebGLPrograms(r, e, s, o, a, l, u) {
  const c = new Layers(), E = new WebGLShaderCache(), d = [], f = a.isWebGL2, h = a.logarithmicDepthBuffer, S = a.vertexTextures;
  let R = a.precision;
  const _ = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function m(Ee) {
    return Ee === 0 ? "uv" : `uv${Ee}`;
  }
  function L(Ee, Ge, ve, te, ae) {
    const v = te.fog, Te = ae.geometry, De = Ee.isMeshStandardMaterial ? te.environment : null, be = (Ee.isMeshStandardMaterial ? s : e).get(Ee.envMap || De), ze = be && be.mapping === CubeUVReflectionMapping ? be.image.height : null, ke = _[Ee.type];
    Ee.precision !== null && (R = a.getMaxPrecision(Ee.precision), R !== Ee.precision && console.warn("THREE.WebGLProgram.getParameters:", Ee.precision, "not supported, using", R, "instead."));
    const Be = Te.morphAttributes.position || Te.morphAttributes.normal || Te.morphAttributes.color, Me = Be !== void 0 ? Be.length : 0;
    let me = 0;
    Te.morphAttributes.position !== void 0 && (me = 1), Te.morphAttributes.normal !== void 0 && (me = 2), Te.morphAttributes.color !== void 0 && (me = 3);
    let Se, xt, Ht, Bt;
    if (ke) {
      const ls = ShaderLib[ke];
      Se = ls.vertexShader, xt = ls.fragmentShader;
    } else
      Se = Ee.vertexShader, xt = Ee.fragmentShader, E.update(Ee), Ht = E.getVertexShaderID(Ee), Bt = E.getFragmentShaderID(Ee);
    const ut = r.getRenderTarget(), Tt = ae.isInstancedMesh === !0, Yt = !!Ee.map, an = !!Ee.matcap, Ct = !!be, st = !!Ee.aoMap, jt = !!Ee.lightMap, lt = !!Ee.bumpMap, Zt = !!Ee.normalMap, Et = !!Ee.displacementMap, Ke = !!Ee.emissiveMap, $e = !!Ee.metalnessMap, pt = !!Ee.roughnessMap, Jt = Ee.anisotropy > 0, In = Ee.clearcoat > 0, Cn = Ee.iridescence > 0, It = Ee.sheen > 0, ht = Ee.transmission > 0, Wt = Jt && !!Ee.anisotropyMap, hn = In && !!Ee.clearcoatMap, Vt = In && !!Ee.clearcoatNormalMap, Tn = In && !!Ee.clearcoatRoughnessMap, Rn = Cn && !!Ee.iridescenceMap, Nn = Cn && !!Ee.iridescenceThicknessMap, Dn = It && !!Ee.sheenColorMap, xn = It && !!Ee.sheenRoughnessMap, $n = !!Ee.specularMap, Kn = !!Ee.specularColorMap, ir = !!Ee.specularIntensityMap, er = ht && !!Ee.transmissionMap, br = ht && !!Ee.thicknessMap, cs = !!Ee.gradientMap, Gn = !!Ee.alphaMap, Jn = Ee.alphaTest > 0, Xn = !!Ee.alphaHash, rr = !!Ee.extensions, _r = !!Te.attributes.uv1, Ss = !!Te.attributes.uv2, is = !!Te.attributes.uv3;
    return {
      isWebGL2: f,
      shaderID: ke,
      shaderType: Ee.type,
      shaderName: Ee.name,
      vertexShader: Se,
      fragmentShader: xt,
      defines: Ee.defines,
      customVertexShaderID: Ht,
      customFragmentShaderID: Bt,
      isRawShaderMaterial: Ee.isRawShaderMaterial === !0,
      glslVersion: Ee.glslVersion,
      precision: R,
      instancing: Tt,
      instancingColor: Tt && ae.instanceColor !== null,
      supportsVertexTextures: S,
      outputColorSpace: ut === null ? r.outputColorSpace : ut.isXRRenderTarget === !0 ? ut.texture.colorSpace : LinearSRGBColorSpace,
      map: Yt,
      matcap: an,
      envMap: Ct,
      envMapMode: Ct && be.mapping,
      envMapCubeUVHeight: ze,
      aoMap: st,
      lightMap: jt,
      bumpMap: lt,
      normalMap: Zt,
      displacementMap: S && Et,
      emissiveMap: Ke,
      normalMapObjectSpace: Zt && Ee.normalMapType === ObjectSpaceNormalMap,
      normalMapTangentSpace: Zt && Ee.normalMapType === TangentSpaceNormalMap,
      metalnessMap: $e,
      roughnessMap: pt,
      anisotropy: Jt,
      anisotropyMap: Wt,
      clearcoat: In,
      clearcoatMap: hn,
      clearcoatNormalMap: Vt,
      clearcoatRoughnessMap: Tn,
      iridescence: Cn,
      iridescenceMap: Rn,
      iridescenceThicknessMap: Nn,
      sheen: It,
      sheenColorMap: Dn,
      sheenRoughnessMap: xn,
      specularMap: $n,
      specularColorMap: Kn,
      specularIntensityMap: ir,
      transmission: ht,
      transmissionMap: er,
      thicknessMap: br,
      gradientMap: cs,
      opaque: Ee.transparent === !1 && Ee.blending === NormalBlending,
      alphaMap: Gn,
      alphaTest: Jn,
      alphaHash: Xn,
      combine: Ee.combine,
      //
      mapUv: Yt && m(Ee.map.channel),
      aoMapUv: st && m(Ee.aoMap.channel),
      lightMapUv: jt && m(Ee.lightMap.channel),
      bumpMapUv: lt && m(Ee.bumpMap.channel),
      normalMapUv: Zt && m(Ee.normalMap.channel),
      displacementMapUv: Et && m(Ee.displacementMap.channel),
      emissiveMapUv: Ke && m(Ee.emissiveMap.channel),
      metalnessMapUv: $e && m(Ee.metalnessMap.channel),
      roughnessMapUv: pt && m(Ee.roughnessMap.channel),
      anisotropyMapUv: Wt && m(Ee.anisotropyMap.channel),
      clearcoatMapUv: hn && m(Ee.clearcoatMap.channel),
      clearcoatNormalMapUv: Vt && m(Ee.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: Tn && m(Ee.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Rn && m(Ee.iridescenceMap.channel),
      iridescenceThicknessMapUv: Nn && m(Ee.iridescenceThicknessMap.channel),
      sheenColorMapUv: Dn && m(Ee.sheenColorMap.channel),
      sheenRoughnessMapUv: xn && m(Ee.sheenRoughnessMap.channel),
      specularMapUv: $n && m(Ee.specularMap.channel),
      specularColorMapUv: Kn && m(Ee.specularColorMap.channel),
      specularIntensityMapUv: ir && m(Ee.specularIntensityMap.channel),
      transmissionMapUv: er && m(Ee.transmissionMap.channel),
      thicknessMapUv: br && m(Ee.thicknessMap.channel),
      alphaMapUv: Gn && m(Ee.alphaMap.channel),
      //
      vertexTangents: !!Te.attributes.tangent && (Zt || Jt),
      vertexColors: Ee.vertexColors,
      vertexAlphas: Ee.vertexColors === !0 && !!Te.attributes.color && Te.attributes.color.itemSize === 4,
      vertexUv1s: _r,
      vertexUv2s: Ss,
      vertexUv3s: is,
      pointsUvs: ae.isPoints === !0 && !!Te.attributes.uv && (Yt || Gn),
      fog: !!v,
      useFog: Ee.fog === !0,
      fogExp2: v && v.isFogExp2,
      flatShading: Ee.flatShading === !0,
      sizeAttenuation: Ee.sizeAttenuation === !0,
      logarithmicDepthBuffer: h,
      skinning: ae.isSkinnedMesh === !0,
      morphTargets: Te.morphAttributes.position !== void 0,
      morphNormals: Te.morphAttributes.normal !== void 0,
      morphColors: Te.morphAttributes.color !== void 0,
      morphTargetsCount: Me,
      morphTextureStride: me,
      numDirLights: Ge.directional.length,
      numPointLights: Ge.point.length,
      numSpotLights: Ge.spot.length,
      numSpotLightMaps: Ge.spotLightMap.length,
      numRectAreaLights: Ge.rectArea.length,
      numHemiLights: Ge.hemi.length,
      numDirLightShadows: Ge.directionalShadowMap.length,
      numPointLightShadows: Ge.pointShadowMap.length,
      numSpotLightShadows: Ge.spotShadowMap.length,
      numSpotLightShadowsWithMaps: Ge.numSpotLightShadowsWithMaps,
      numClippingPlanes: u.numPlanes,
      numClipIntersection: u.numIntersection,
      dithering: Ee.dithering,
      shadowMapEnabled: r.shadowMap.enabled && ve.length > 0,
      shadowMapType: r.shadowMap.type,
      toneMapping: Ee.toneMapped ? r.toneMapping : NoToneMapping,
      useLegacyLights: r.useLegacyLights,
      premultipliedAlpha: Ee.premultipliedAlpha,
      doubleSided: Ee.side === DoubleSide,
      flipSided: Ee.side === BackSide,
      useDepthPacking: Ee.depthPacking >= 0,
      depthPacking: Ee.depthPacking || 0,
      index0AttributeName: Ee.index0AttributeName,
      extensionDerivatives: rr && Ee.extensions.derivatives === !0,
      extensionFragDepth: rr && Ee.extensions.fragDepth === !0,
      extensionDrawBuffers: rr && Ee.extensions.drawBuffers === !0,
      extensionShaderTextureLOD: rr && Ee.extensions.shaderTextureLOD === !0,
      rendererExtensionFragDepth: f || o.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: f || o.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: f || o.has("EXT_shader_texture_lod"),
      customProgramCacheKey: Ee.customProgramCacheKey()
    };
  }
  function F(Ee) {
    const Ge = [];
    if (Ee.shaderID ? Ge.push(Ee.shaderID) : (Ge.push(Ee.customVertexShaderID), Ge.push(Ee.customFragmentShaderID)), Ee.defines !== void 0)
      for (const ve in Ee.defines)
        Ge.push(ve), Ge.push(Ee.defines[ve]);
    return Ee.isRawShaderMaterial === !1 && (W(Ge, Ee), G(Ge, Ee), Ge.push(r.outputColorSpace)), Ge.push(Ee.customProgramCacheKey), Ge.join();
  }
  function W(Ee, Ge) {
    Ee.push(Ge.precision), Ee.push(Ge.outputColorSpace), Ee.push(Ge.envMapMode), Ee.push(Ge.envMapCubeUVHeight), Ee.push(Ge.mapUv), Ee.push(Ge.alphaMapUv), Ee.push(Ge.lightMapUv), Ee.push(Ge.aoMapUv), Ee.push(Ge.bumpMapUv), Ee.push(Ge.normalMapUv), Ee.push(Ge.displacementMapUv), Ee.push(Ge.emissiveMapUv), Ee.push(Ge.metalnessMapUv), Ee.push(Ge.roughnessMapUv), Ee.push(Ge.anisotropyMapUv), Ee.push(Ge.clearcoatMapUv), Ee.push(Ge.clearcoatNormalMapUv), Ee.push(Ge.clearcoatRoughnessMapUv), Ee.push(Ge.iridescenceMapUv), Ee.push(Ge.iridescenceThicknessMapUv), Ee.push(Ge.sheenColorMapUv), Ee.push(Ge.sheenRoughnessMapUv), Ee.push(Ge.specularMapUv), Ee.push(Ge.specularColorMapUv), Ee.push(Ge.specularIntensityMapUv), Ee.push(Ge.transmissionMapUv), Ee.push(Ge.thicknessMapUv), Ee.push(Ge.combine), Ee.push(Ge.fogExp2), Ee.push(Ge.sizeAttenuation), Ee.push(Ge.morphTargetsCount), Ee.push(Ge.morphAttributeCount), Ee.push(Ge.numDirLights), Ee.push(Ge.numPointLights), Ee.push(Ge.numSpotLights), Ee.push(Ge.numSpotLightMaps), Ee.push(Ge.numHemiLights), Ee.push(Ge.numRectAreaLights), Ee.push(Ge.numDirLightShadows), Ee.push(Ge.numPointLightShadows), Ee.push(Ge.numSpotLightShadows), Ee.push(Ge.numSpotLightShadowsWithMaps), Ee.push(Ge.shadowMapType), Ee.push(Ge.toneMapping), Ee.push(Ge.numClippingPlanes), Ee.push(Ge.numClipIntersection), Ee.push(Ge.depthPacking);
  }
  function G(Ee, Ge) {
    c.disableAll(), Ge.isWebGL2 && c.enable(0), Ge.supportsVertexTextures && c.enable(1), Ge.instancing && c.enable(2), Ge.instancingColor && c.enable(3), Ge.matcap && c.enable(4), Ge.envMap && c.enable(5), Ge.normalMapObjectSpace && c.enable(6), Ge.normalMapTangentSpace && c.enable(7), Ge.clearcoat && c.enable(8), Ge.iridescence && c.enable(9), Ge.alphaTest && c.enable(10), Ge.vertexColors && c.enable(11), Ge.vertexAlphas && c.enable(12), Ge.vertexUv1s && c.enable(13), Ge.vertexUv2s && c.enable(14), Ge.vertexUv3s && c.enable(15), Ge.vertexTangents && c.enable(16), Ge.anisotropy && c.enable(17), Ee.push(c.mask), c.disableAll(), Ge.fog && c.enable(0), Ge.useFog && c.enable(1), Ge.flatShading && c.enable(2), Ge.logarithmicDepthBuffer && c.enable(3), Ge.skinning && c.enable(4), Ge.morphTargets && c.enable(5), Ge.morphNormals && c.enable(6), Ge.morphColors && c.enable(7), Ge.premultipliedAlpha && c.enable(8), Ge.shadowMapEnabled && c.enable(9), Ge.useLegacyLights && c.enable(10), Ge.doubleSided && c.enable(11), Ge.flipSided && c.enable(12), Ge.useDepthPacking && c.enable(13), Ge.dithering && c.enable(14), Ge.transmission && c.enable(15), Ge.sheen && c.enable(16), Ge.opaque && c.enable(17), Ge.pointsUvs && c.enable(18), Ee.push(c.mask);
  }
  function q(Ee) {
    const Ge = _[Ee.type];
    let ve;
    if (Ge) {
      const te = ShaderLib[Ge];
      ve = UniformsUtils.clone(te.uniforms);
    } else
      ve = Ee.uniforms;
    return ve;
  }
  function fe(Ee, Ge) {
    let ve;
    for (let te = 0, ae = d.length; te < ae; te++) {
      const v = d[te];
      if (v.cacheKey === Ge) {
        ve = v, ++ve.usedTimes;
        break;
      }
    }
    return ve === void 0 && (ve = new WebGLProgram(r, Ge, Ee, l), d.push(ve)), ve;
  }
  function _e(Ee) {
    if (--Ee.usedTimes === 0) {
      const Ge = d.indexOf(Ee);
      d[Ge] = d[d.length - 1], d.pop(), Ee.destroy();
    }
  }
  function Le(Ee) {
    E.remove(Ee);
  }
  function Fe() {
    E.dispose();
  }
  return {
    getParameters: L,
    getProgramCacheKey: F,
    getUniforms: q,
    acquireProgram: fe,
    releaseProgram: _e,
    releaseShaderCache: Le,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: d,
    dispose: Fe
  };
}
function WebGLProperties() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(l) {
    let u = r.get(l);
    return u === void 0 && (u = {}, r.set(l, u)), u;
  }
  function s(l) {
    r.delete(l);
  }
  function o(l, u, c) {
    r.get(l)[u] = c;
  }
  function a() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    remove: s,
    update: o,
    dispose: a
  };
}
function painterSortStable(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.material.id !== e.material.id ? r.material.id - e.material.id : r.z !== e.z ? r.z - e.z : r.id - e.id;
}
function reversePainterSortStable(r, e) {
  return r.groupOrder !== e.groupOrder ? r.groupOrder - e.groupOrder : r.renderOrder !== e.renderOrder ? r.renderOrder - e.renderOrder : r.z !== e.z ? e.z - r.z : r.id - e.id;
}
function WebGLRenderList() {
  const r = [];
  let e = 0;
  const s = [], o = [], a = [];
  function l() {
    e = 0, s.length = 0, o.length = 0, a.length = 0;
  }
  function u(h, S, R, _, m, L) {
    let F = r[e];
    return F === void 0 ? (F = {
      id: h.id,
      object: h,
      geometry: S,
      material: R,
      groupOrder: _,
      renderOrder: h.renderOrder,
      z: m,
      group: L
    }, r[e] = F) : (F.id = h.id, F.object = h, F.geometry = S, F.material = R, F.groupOrder = _, F.renderOrder = h.renderOrder, F.z = m, F.group = L), e++, F;
  }
  function c(h, S, R, _, m, L) {
    const F = u(h, S, R, _, m, L);
    R.transmission > 0 ? o.push(F) : R.transparent === !0 ? a.push(F) : s.push(F);
  }
  function E(h, S, R, _, m, L) {
    const F = u(h, S, R, _, m, L);
    R.transmission > 0 ? o.unshift(F) : R.transparent === !0 ? a.unshift(F) : s.unshift(F);
  }
  function d(h, S) {
    s.length > 1 && s.sort(h || painterSortStable), o.length > 1 && o.sort(S || reversePainterSortStable), a.length > 1 && a.sort(S || reversePainterSortStable);
  }
  function f() {
    for (let h = e, S = r.length; h < S; h++) {
      const R = r[h];
      if (R.id === null)
        break;
      R.id = null, R.object = null, R.geometry = null, R.material = null, R.group = null;
    }
  }
  return {
    opaque: s,
    transmissive: o,
    transparent: a,
    init: l,
    push: c,
    unshift: E,
    finish: f,
    sort: d
  };
}
function WebGLRenderLists() {
  let r = /* @__PURE__ */ new WeakMap();
  function e(o, a) {
    const l = r.get(o);
    let u;
    return l === void 0 ? (u = new WebGLRenderList(), r.set(o, [u])) : a >= l.length ? (u = new WebGLRenderList(), l.push(u)) : u = l[a], u;
  }
  function s() {
    r = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: s
  };
}
function UniformsCache() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let s;
      switch (e.type) {
        case "DirectionalLight":
          s = {
            direction: new Vector3$1(),
            color: new Color()
          };
          break;
        case "SpotLight":
          s = {
            position: new Vector3$1(),
            direction: new Vector3$1(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          s = {
            position: new Vector3$1(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          s = {
            direction: new Vector3$1(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          s = {
            color: new Color(),
            position: new Vector3$1(),
            halfWidth: new Vector3$1(),
            halfHeight: new Vector3$1()
          };
          break;
      }
      return r[e.id] = s, s;
    }
  };
}
function ShadowUniformsCache() {
  const r = {};
  return {
    get: function(e) {
      if (r[e.id] !== void 0)
        return r[e.id];
      let s;
      switch (e.type) {
        case "DirectionalLight":
          s = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "SpotLight":
          s = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;
        case "PointLight":
          s = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return r[e.id] = s, s;
    }
  };
}
let nextVersion = 0;
function shadowCastingAndTexturingLightsFirst(r, e) {
  return (e.castShadow ? 2 : 0) - (r.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (r.map ? 1 : 0);
}
function WebGLLights(r, e) {
  const s = new UniformsCache(), o = ShadowUniformsCache(), a = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0
  };
  for (let f = 0; f < 9; f++)
    a.probe.push(new Vector3$1());
  const l = new Vector3$1(), u = new Matrix4(), c = new Matrix4();
  function E(f, h) {
    let S = 0, R = 0, _ = 0;
    for (let ve = 0; ve < 9; ve++)
      a.probe[ve].set(0, 0, 0);
    let m = 0, L = 0, F = 0, W = 0, G = 0, q = 0, fe = 0, _e = 0, Le = 0, Fe = 0;
    f.sort(shadowCastingAndTexturingLightsFirst);
    const Ee = h === !0 ? Math.PI : 1;
    for (let ve = 0, te = f.length; ve < te; ve++) {
      const ae = f[ve], v = ae.color, Te = ae.intensity, De = ae.distance, be = ae.shadow && ae.shadow.map ? ae.shadow.map.texture : null;
      if (ae.isAmbientLight)
        S += v.r * Te * Ee, R += v.g * Te * Ee, _ += v.b * Te * Ee;
      else if (ae.isLightProbe)
        for (let ze = 0; ze < 9; ze++)
          a.probe[ze].addScaledVector(ae.sh.coefficients[ze], Te);
      else if (ae.isDirectionalLight) {
        const ze = s.get(ae);
        if (ze.color.copy(ae.color).multiplyScalar(ae.intensity * Ee), ae.castShadow) {
          const ke = ae.shadow, Be = o.get(ae);
          Be.shadowBias = ke.bias, Be.shadowNormalBias = ke.normalBias, Be.shadowRadius = ke.radius, Be.shadowMapSize = ke.mapSize, a.directionalShadow[m] = Be, a.directionalShadowMap[m] = be, a.directionalShadowMatrix[m] = ae.shadow.matrix, q++;
        }
        a.directional[m] = ze, m++;
      } else if (ae.isSpotLight) {
        const ze = s.get(ae);
        ze.position.setFromMatrixPosition(ae.matrixWorld), ze.color.copy(v).multiplyScalar(Te * Ee), ze.distance = De, ze.coneCos = Math.cos(ae.angle), ze.penumbraCos = Math.cos(ae.angle * (1 - ae.penumbra)), ze.decay = ae.decay, a.spot[F] = ze;
        const ke = ae.shadow;
        if (ae.map && (a.spotLightMap[Le] = ae.map, Le++, ke.updateMatrices(ae), ae.castShadow && Fe++), a.spotLightMatrix[F] = ke.matrix, ae.castShadow) {
          const Be = o.get(ae);
          Be.shadowBias = ke.bias, Be.shadowNormalBias = ke.normalBias, Be.shadowRadius = ke.radius, Be.shadowMapSize = ke.mapSize, a.spotShadow[F] = Be, a.spotShadowMap[F] = be, _e++;
        }
        F++;
      } else if (ae.isRectAreaLight) {
        const ze = s.get(ae);
        ze.color.copy(v).multiplyScalar(Te), ze.halfWidth.set(ae.width * 0.5, 0, 0), ze.halfHeight.set(0, ae.height * 0.5, 0), a.rectArea[W] = ze, W++;
      } else if (ae.isPointLight) {
        const ze = s.get(ae);
        if (ze.color.copy(ae.color).multiplyScalar(ae.intensity * Ee), ze.distance = ae.distance, ze.decay = ae.decay, ae.castShadow) {
          const ke = ae.shadow, Be = o.get(ae);
          Be.shadowBias = ke.bias, Be.shadowNormalBias = ke.normalBias, Be.shadowRadius = ke.radius, Be.shadowMapSize = ke.mapSize, Be.shadowCameraNear = ke.camera.near, Be.shadowCameraFar = ke.camera.far, a.pointShadow[L] = Be, a.pointShadowMap[L] = be, a.pointShadowMatrix[L] = ae.shadow.matrix, fe++;
        }
        a.point[L] = ze, L++;
      } else if (ae.isHemisphereLight) {
        const ze = s.get(ae);
        ze.skyColor.copy(ae.color).multiplyScalar(Te * Ee), ze.groundColor.copy(ae.groundColor).multiplyScalar(Te * Ee), a.hemi[G] = ze, G++;
      }
    }
    W > 0 && (e.isWebGL2 || r.has("OES_texture_float_linear") === !0 ? (a.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1, a.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2) : r.has("OES_texture_half_float_linear") === !0 ? (a.rectAreaLTC1 = UniformsLib.LTC_HALF_1, a.rectAreaLTC2 = UniformsLib.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), a.ambient[0] = S, a.ambient[1] = R, a.ambient[2] = _;
    const Ge = a.hash;
    (Ge.directionalLength !== m || Ge.pointLength !== L || Ge.spotLength !== F || Ge.rectAreaLength !== W || Ge.hemiLength !== G || Ge.numDirectionalShadows !== q || Ge.numPointShadows !== fe || Ge.numSpotShadows !== _e || Ge.numSpotMaps !== Le) && (a.directional.length = m, a.spot.length = F, a.rectArea.length = W, a.point.length = L, a.hemi.length = G, a.directionalShadow.length = q, a.directionalShadowMap.length = q, a.pointShadow.length = fe, a.pointShadowMap.length = fe, a.spotShadow.length = _e, a.spotShadowMap.length = _e, a.directionalShadowMatrix.length = q, a.pointShadowMatrix.length = fe, a.spotLightMatrix.length = _e + Le - Fe, a.spotLightMap.length = Le, a.numSpotLightShadowsWithMaps = Fe, Ge.directionalLength = m, Ge.pointLength = L, Ge.spotLength = F, Ge.rectAreaLength = W, Ge.hemiLength = G, Ge.numDirectionalShadows = q, Ge.numPointShadows = fe, Ge.numSpotShadows = _e, Ge.numSpotMaps = Le, a.version = nextVersion++);
  }
  function d(f, h) {
    let S = 0, R = 0, _ = 0, m = 0, L = 0;
    const F = h.matrixWorldInverse;
    for (let W = 0, G = f.length; W < G; W++) {
      const q = f[W];
      if (q.isDirectionalLight) {
        const fe = a.directional[S];
        fe.direction.setFromMatrixPosition(q.matrixWorld), l.setFromMatrixPosition(q.target.matrixWorld), fe.direction.sub(l), fe.direction.transformDirection(F), S++;
      } else if (q.isSpotLight) {
        const fe = a.spot[_];
        fe.position.setFromMatrixPosition(q.matrixWorld), fe.position.applyMatrix4(F), fe.direction.setFromMatrixPosition(q.matrixWorld), l.setFromMatrixPosition(q.target.matrixWorld), fe.direction.sub(l), fe.direction.transformDirection(F), _++;
      } else if (q.isRectAreaLight) {
        const fe = a.rectArea[m];
        fe.position.setFromMatrixPosition(q.matrixWorld), fe.position.applyMatrix4(F), c.identity(), u.copy(q.matrixWorld), u.premultiply(F), c.extractRotation(u), fe.halfWidth.set(q.width * 0.5, 0, 0), fe.halfHeight.set(0, q.height * 0.5, 0), fe.halfWidth.applyMatrix4(c), fe.halfHeight.applyMatrix4(c), m++;
      } else if (q.isPointLight) {
        const fe = a.point[R];
        fe.position.setFromMatrixPosition(q.matrixWorld), fe.position.applyMatrix4(F), R++;
      } else if (q.isHemisphereLight) {
        const fe = a.hemi[L];
        fe.direction.setFromMatrixPosition(q.matrixWorld), fe.direction.transformDirection(F), L++;
      }
    }
  }
  return {
    setup: E,
    setupView: d,
    state: a
  };
}
function WebGLRenderState(r, e) {
  const s = new WebGLLights(r, e), o = [], a = [];
  function l() {
    o.length = 0, a.length = 0;
  }
  function u(h) {
    o.push(h);
  }
  function c(h) {
    a.push(h);
  }
  function E(h) {
    s.setup(o, h);
  }
  function d(h) {
    s.setupView(o, h);
  }
  return {
    init: l,
    state: {
      lightsArray: o,
      shadowsArray: a,
      lights: s
    },
    setupLights: E,
    setupLightsView: d,
    pushLight: u,
    pushShadow: c
  };
}
function WebGLRenderStates(r, e) {
  let s = /* @__PURE__ */ new WeakMap();
  function o(l, u = 0) {
    const c = s.get(l);
    let E;
    return c === void 0 ? (E = new WebGLRenderState(r, e), s.set(l, [E])) : u >= c.length ? (E = new WebGLRenderState(r, e), c.push(E)) : E = c[u], E;
  }
  function a() {
    s = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: o,
    dispose: a
  };
}
class MeshDepthMaterial extends Material {
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = BasicDepthPacking, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class MeshDistanceMaterial extends Material {
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const vertex = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, fragment = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function WebGLShadowMap(r, e, s) {
  let o = new Frustum();
  const a = new Vector2(), l = new Vector2(), u = new Vector4(), c = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), E = new MeshDistanceMaterial(), d = {}, f = s.maxTextureSize, h = { [FrontSide]: BackSide, [BackSide]: FrontSide, [DoubleSide]: DoubleSide }, S = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  }), R = S.clone();
  R.defines.HORIZONTAL_PASS = 1;
  const _ = new BufferGeometry();
  _.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const m = new Mesh(_, S), L = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = PCFShadowMap;
  let F = this.type;
  this.render = function(fe, _e, Le) {
    if (L.enabled === !1 || L.autoUpdate === !1 && L.needsUpdate === !1 || fe.length === 0)
      return;
    const Fe = r.getRenderTarget(), Ee = r.getActiveCubeFace(), Ge = r.getActiveMipmapLevel(), ve = r.state;
    ve.setBlending(NoBlending), ve.buffers.color.setClear(1, 1, 1, 1), ve.buffers.depth.setTest(!0), ve.setScissorTest(!1);
    const te = F !== VSMShadowMap && this.type === VSMShadowMap, ae = F === VSMShadowMap && this.type !== VSMShadowMap;
    for (let v = 0, Te = fe.length; v < Te; v++) {
      const De = fe[v], be = De.shadow;
      if (be === void 0) {
        console.warn("THREE.WebGLShadowMap:", De, "has no shadow.");
        continue;
      }
      if (be.autoUpdate === !1 && be.needsUpdate === !1)
        continue;
      a.copy(be.mapSize);
      const ze = be.getFrameExtents();
      if (a.multiply(ze), l.copy(be.mapSize), (a.x > f || a.y > f) && (a.x > f && (l.x = Math.floor(f / ze.x), a.x = l.x * ze.x, be.mapSize.x = l.x), a.y > f && (l.y = Math.floor(f / ze.y), a.y = l.y * ze.y, be.mapSize.y = l.y)), be.map === null || te === !0 || ae === !0) {
        const Be = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};
        be.map !== null && be.map.dispose(), be.map = new WebGLRenderTarget(a.x, a.y, Be), be.map.texture.name = De.name + ".shadowMap", be.camera.updateProjectionMatrix();
      }
      r.setRenderTarget(be.map), r.clear();
      const ke = be.getViewportCount();
      for (let Be = 0; Be < ke; Be++) {
        const Me = be.getViewport(Be);
        u.set(
          l.x * Me.x,
          l.y * Me.y,
          l.x * Me.z,
          l.y * Me.w
        ), ve.viewport(u), be.updateMatrices(De, Be), o = be.getFrustum(), q(_e, Le, be.camera, De, this.type);
      }
      be.isPointLightShadow !== !0 && this.type === VSMShadowMap && W(be, Le), be.needsUpdate = !1;
    }
    F = this.type, L.needsUpdate = !1, r.setRenderTarget(Fe, Ee, Ge);
  };
  function W(fe, _e) {
    const Le = e.update(m);
    S.defines.VSM_SAMPLES !== fe.blurSamples && (S.defines.VSM_SAMPLES = fe.blurSamples, R.defines.VSM_SAMPLES = fe.blurSamples, S.needsUpdate = !0, R.needsUpdate = !0), fe.mapPass === null && (fe.mapPass = new WebGLRenderTarget(a.x, a.y)), S.uniforms.shadow_pass.value = fe.map.texture, S.uniforms.resolution.value = fe.mapSize, S.uniforms.radius.value = fe.radius, r.setRenderTarget(fe.mapPass), r.clear(), r.renderBufferDirect(_e, null, Le, S, m, null), R.uniforms.shadow_pass.value = fe.mapPass.texture, R.uniforms.resolution.value = fe.mapSize, R.uniforms.radius.value = fe.radius, r.setRenderTarget(fe.map), r.clear(), r.renderBufferDirect(_e, null, Le, R, m, null);
  }
  function G(fe, _e, Le, Fe) {
    let Ee = null;
    const Ge = Le.isPointLight === !0 ? fe.customDistanceMaterial : fe.customDepthMaterial;
    if (Ge !== void 0)
      Ee = Ge;
    else if (Ee = Le.isPointLight === !0 ? E : c, r.localClippingEnabled && _e.clipShadows === !0 && Array.isArray(_e.clippingPlanes) && _e.clippingPlanes.length !== 0 || _e.displacementMap && _e.displacementScale !== 0 || _e.alphaMap && _e.alphaTest > 0 || _e.map && _e.alphaTest > 0) {
      const ve = Ee.uuid, te = _e.uuid;
      let ae = d[ve];
      ae === void 0 && (ae = {}, d[ve] = ae);
      let v = ae[te];
      v === void 0 && (v = Ee.clone(), ae[te] = v), Ee = v;
    }
    if (Ee.visible = _e.visible, Ee.wireframe = _e.wireframe, Fe === VSMShadowMap ? Ee.side = _e.shadowSide !== null ? _e.shadowSide : _e.side : Ee.side = _e.shadowSide !== null ? _e.shadowSide : h[_e.side], Ee.alphaMap = _e.alphaMap, Ee.alphaTest = _e.alphaTest, Ee.map = _e.map, Ee.clipShadows = _e.clipShadows, Ee.clippingPlanes = _e.clippingPlanes, Ee.clipIntersection = _e.clipIntersection, Ee.displacementMap = _e.displacementMap, Ee.displacementScale = _e.displacementScale, Ee.displacementBias = _e.displacementBias, Ee.wireframeLinewidth = _e.wireframeLinewidth, Ee.linewidth = _e.linewidth, Le.isPointLight === !0 && Ee.isMeshDistanceMaterial === !0) {
      const ve = r.properties.get(Ee);
      ve.light = Le;
    }
    return Ee;
  }
  function q(fe, _e, Le, Fe, Ee) {
    if (fe.visible === !1)
      return;
    if (fe.layers.test(_e.layers) && (fe.isMesh || fe.isLine || fe.isPoints) && (fe.castShadow || fe.receiveShadow && Ee === VSMShadowMap) && (!fe.frustumCulled || o.intersectsObject(fe))) {
      fe.modelViewMatrix.multiplyMatrices(Le.matrixWorldInverse, fe.matrixWorld);
      const te = e.update(fe), ae = fe.material;
      if (Array.isArray(ae)) {
        const v = te.groups;
        for (let Te = 0, De = v.length; Te < De; Te++) {
          const be = v[Te], ze = ae[be.materialIndex];
          if (ze && ze.visible) {
            const ke = G(fe, ze, Fe, Ee);
            r.renderBufferDirect(Le, null, te, ke, fe, be);
          }
        }
      } else if (ae.visible) {
        const v = G(fe, ae, Fe, Ee);
        r.renderBufferDirect(Le, null, te, v, fe, null);
      }
    }
    const ve = fe.children;
    for (let te = 0, ae = ve.length; te < ae; te++)
      q(ve[te], _e, Le, Fe, Ee);
  }
}
function WebGLState(r, e, s) {
  const o = s.isWebGL2;
  function a() {
    let Gn = !1;
    const Jn = new Vector4();
    let Xn = null;
    const rr = new Vector4(0, 0, 0, 0);
    return {
      setMask: function(_r) {
        Xn !== _r && !Gn && (r.colorMask(_r, _r, _r, _r), Xn = _r);
      },
      setLocked: function(_r) {
        Gn = _r;
      },
      setClear: function(_r, Ss, is, Ms, ls) {
        ls === !0 && (_r *= Ms, Ss *= Ms, is *= Ms), Jn.set(_r, Ss, is, Ms), rr.equals(Jn) === !1 && (r.clearColor(_r, Ss, is, Ms), rr.copy(Jn));
      },
      reset: function() {
        Gn = !1, Xn = null, rr.set(-1, 0, 0, 0);
      }
    };
  }
  function l() {
    let Gn = !1, Jn = null, Xn = null, rr = null;
    return {
      setTest: function(_r) {
        _r ? ut(r.DEPTH_TEST) : Tt(r.DEPTH_TEST);
      },
      setMask: function(_r) {
        Jn !== _r && !Gn && (r.depthMask(_r), Jn = _r);
      },
      setFunc: function(_r) {
        if (Xn !== _r) {
          switch (_r) {
            case NeverDepth:
              r.depthFunc(r.NEVER);
              break;
            case AlwaysDepth:
              r.depthFunc(r.ALWAYS);
              break;
            case LessDepth:
              r.depthFunc(r.LESS);
              break;
            case LessEqualDepth:
              r.depthFunc(r.LEQUAL);
              break;
            case EqualDepth:
              r.depthFunc(r.EQUAL);
              break;
            case GreaterEqualDepth:
              r.depthFunc(r.GEQUAL);
              break;
            case GreaterDepth:
              r.depthFunc(r.GREATER);
              break;
            case NotEqualDepth:
              r.depthFunc(r.NOTEQUAL);
              break;
            default:
              r.depthFunc(r.LEQUAL);
          }
          Xn = _r;
        }
      },
      setLocked: function(_r) {
        Gn = _r;
      },
      setClear: function(_r) {
        rr !== _r && (r.clearDepth(_r), rr = _r);
      },
      reset: function() {
        Gn = !1, Jn = null, Xn = null, rr = null;
      }
    };
  }
  function u() {
    let Gn = !1, Jn = null, Xn = null, rr = null, _r = null, Ss = null, is = null, Ms = null, ls = null;
    return {
      setTest: function(Ur) {
        Gn || (Ur ? ut(r.STENCIL_TEST) : Tt(r.STENCIL_TEST));
      },
      setMask: function(Ur) {
        Jn !== Ur && !Gn && (r.stencilMask(Ur), Jn = Ur);
      },
      setFunc: function(Ur, Qr, Fr) {
        (Xn !== Ur || rr !== Qr || _r !== Fr) && (r.stencilFunc(Ur, Qr, Fr), Xn = Ur, rr = Qr, _r = Fr);
      },
      setOp: function(Ur, Qr, Fr) {
        (Ss !== Ur || is !== Qr || Ms !== Fr) && (r.stencilOp(Ur, Qr, Fr), Ss = Ur, is = Qr, Ms = Fr);
      },
      setLocked: function(Ur) {
        Gn = Ur;
      },
      setClear: function(Ur) {
        ls !== Ur && (r.clearStencil(Ur), ls = Ur);
      },
      reset: function() {
        Gn = !1, Jn = null, Xn = null, rr = null, _r = null, Ss = null, is = null, Ms = null, ls = null;
      }
    };
  }
  const c = new a(), E = new l(), d = new u(), f = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
  let S = {}, R = {}, _ = /* @__PURE__ */ new WeakMap(), m = [], L = null, F = !1, W = null, G = null, q = null, fe = null, _e = null, Le = null, Fe = null, Ee = !1, Ge = null, ve = null, te = null, ae = null, v = null;
  const Te = r.getParameter(r.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let De = !1, be = 0;
  const ze = r.getParameter(r.VERSION);
  ze.indexOf("WebGL") !== -1 ? (be = parseFloat(/^WebGL (\d)/.exec(ze)[1]), De = be >= 1) : ze.indexOf("OpenGL ES") !== -1 && (be = parseFloat(/^OpenGL ES (\d)/.exec(ze)[1]), De = be >= 2);
  let ke = null, Be = {};
  const Me = r.getParameter(r.SCISSOR_BOX), me = r.getParameter(r.VIEWPORT), Se = new Vector4().fromArray(Me), xt = new Vector4().fromArray(me);
  function Ht(Gn, Jn, Xn, rr) {
    const _r = new Uint8Array(4), Ss = r.createTexture();
    r.bindTexture(Gn, Ss), r.texParameteri(Gn, r.TEXTURE_MIN_FILTER, r.NEAREST), r.texParameteri(Gn, r.TEXTURE_MAG_FILTER, r.NEAREST);
    for (let is = 0; is < Xn; is++)
      o && (Gn === r.TEXTURE_3D || Gn === r.TEXTURE_2D_ARRAY) ? r.texImage3D(Jn, 0, r.RGBA, 1, 1, rr, 0, r.RGBA, r.UNSIGNED_BYTE, _r) : r.texImage2D(Jn + is, 0, r.RGBA, 1, 1, 0, r.RGBA, r.UNSIGNED_BYTE, _r);
    return Ss;
  }
  const Bt = {};
  Bt[r.TEXTURE_2D] = Ht(r.TEXTURE_2D, r.TEXTURE_2D, 1), Bt[r.TEXTURE_CUBE_MAP] = Ht(r.TEXTURE_CUBE_MAP, r.TEXTURE_CUBE_MAP_POSITIVE_X, 6), o && (Bt[r.TEXTURE_2D_ARRAY] = Ht(r.TEXTURE_2D_ARRAY, r.TEXTURE_2D_ARRAY, 1, 1), Bt[r.TEXTURE_3D] = Ht(r.TEXTURE_3D, r.TEXTURE_3D, 1, 1)), c.setClear(0, 0, 0, 1), E.setClear(1), d.setClear(0), ut(r.DEPTH_TEST), E.setFunc(LessEqualDepth), Et(!1), Ke(CullFaceBack), ut(r.CULL_FACE), lt(NoBlending);
  function ut(Gn) {
    S[Gn] !== !0 && (r.enable(Gn), S[Gn] = !0);
  }
  function Tt(Gn) {
    S[Gn] !== !1 && (r.disable(Gn), S[Gn] = !1);
  }
  function Yt(Gn, Jn) {
    return R[Gn] !== Jn ? (r.bindFramebuffer(Gn, Jn), R[Gn] = Jn, o && (Gn === r.DRAW_FRAMEBUFFER && (R[r.FRAMEBUFFER] = Jn), Gn === r.FRAMEBUFFER && (R[r.DRAW_FRAMEBUFFER] = Jn)), !0) : !1;
  }
  function an(Gn, Jn) {
    let Xn = m, rr = !1;
    if (Gn)
      if (Xn = _.get(Jn), Xn === void 0 && (Xn = [], _.set(Jn, Xn)), Gn.isWebGLMultipleRenderTargets) {
        const _r = Gn.texture;
        if (Xn.length !== _r.length || Xn[0] !== r.COLOR_ATTACHMENT0) {
          for (let Ss = 0, is = _r.length; Ss < is; Ss++)
            Xn[Ss] = r.COLOR_ATTACHMENT0 + Ss;
          Xn.length = _r.length, rr = !0;
        }
      } else
        Xn[0] !== r.COLOR_ATTACHMENT0 && (Xn[0] = r.COLOR_ATTACHMENT0, rr = !0);
    else
      Xn[0] !== r.BACK && (Xn[0] = r.BACK, rr = !0);
    rr && (s.isWebGL2 ? r.drawBuffers(Xn) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(Xn));
  }
  function Ct(Gn) {
    return L !== Gn ? (r.useProgram(Gn), L = Gn, !0) : !1;
  }
  const st = {
    [AddEquation]: r.FUNC_ADD,
    [SubtractEquation]: r.FUNC_SUBTRACT,
    [ReverseSubtractEquation]: r.FUNC_REVERSE_SUBTRACT
  };
  if (o)
    st[MinEquation] = r.MIN, st[MaxEquation] = r.MAX;
  else {
    const Gn = e.get("EXT_blend_minmax");
    Gn !== null && (st[MinEquation] = Gn.MIN_EXT, st[MaxEquation] = Gn.MAX_EXT);
  }
  const jt = {
    [ZeroFactor]: r.ZERO,
    [OneFactor]: r.ONE,
    [SrcColorFactor]: r.SRC_COLOR,
    [SrcAlphaFactor]: r.SRC_ALPHA,
    [SrcAlphaSaturateFactor]: r.SRC_ALPHA_SATURATE,
    [DstColorFactor]: r.DST_COLOR,
    [DstAlphaFactor]: r.DST_ALPHA,
    [OneMinusSrcColorFactor]: r.ONE_MINUS_SRC_COLOR,
    [OneMinusSrcAlphaFactor]: r.ONE_MINUS_SRC_ALPHA,
    [OneMinusDstColorFactor]: r.ONE_MINUS_DST_COLOR,
    [OneMinusDstAlphaFactor]: r.ONE_MINUS_DST_ALPHA
  };
  function lt(Gn, Jn, Xn, rr, _r, Ss, is, Ms) {
    if (Gn === NoBlending) {
      F === !0 && (Tt(r.BLEND), F = !1);
      return;
    }
    if (F === !1 && (ut(r.BLEND), F = !0), Gn !== CustomBlending) {
      if (Gn !== W || Ms !== Ee) {
        if ((G !== AddEquation || _e !== AddEquation) && (r.blendEquation(r.FUNC_ADD), G = AddEquation, _e = AddEquation), Ms)
          switch (Gn) {
            case NormalBlending:
              r.blendFuncSeparate(r.ONE, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              r.blendFunc(r.ONE, r.ONE);
              break;
            case SubtractiveBlending:
              r.blendFuncSeparate(r.ZERO, r.ONE_MINUS_SRC_COLOR, r.ZERO, r.ONE);
              break;
            case MultiplyBlending:
              r.blendFuncSeparate(r.ZERO, r.SRC_COLOR, r.ZERO, r.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", Gn);
              break;
          }
        else
          switch (Gn) {
            case NormalBlending:
              r.blendFuncSeparate(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending:
              r.blendFunc(r.SRC_ALPHA, r.ONE);
              break;
            case SubtractiveBlending:
              r.blendFuncSeparate(r.ZERO, r.ONE_MINUS_SRC_COLOR, r.ZERO, r.ONE);
              break;
            case MultiplyBlending:
              r.blendFunc(r.ZERO, r.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", Gn);
              break;
          }
        q = null, fe = null, Le = null, Fe = null, W = Gn, Ee = Ms;
      }
      return;
    }
    _r = _r || Jn, Ss = Ss || Xn, is = is || rr, (Jn !== G || _r !== _e) && (r.blendEquationSeparate(st[Jn], st[_r]), G = Jn, _e = _r), (Xn !== q || rr !== fe || Ss !== Le || is !== Fe) && (r.blendFuncSeparate(jt[Xn], jt[rr], jt[Ss], jt[is]), q = Xn, fe = rr, Le = Ss, Fe = is), W = Gn, Ee = !1;
  }
  function Zt(Gn, Jn) {
    Gn.side === DoubleSide ? Tt(r.CULL_FACE) : ut(r.CULL_FACE);
    let Xn = Gn.side === BackSide;
    Jn && (Xn = !Xn), Et(Xn), Gn.blending === NormalBlending && Gn.transparent === !1 ? lt(NoBlending) : lt(Gn.blending, Gn.blendEquation, Gn.blendSrc, Gn.blendDst, Gn.blendEquationAlpha, Gn.blendSrcAlpha, Gn.blendDstAlpha, Gn.premultipliedAlpha), E.setFunc(Gn.depthFunc), E.setTest(Gn.depthTest), E.setMask(Gn.depthWrite), c.setMask(Gn.colorWrite);
    const rr = Gn.stencilWrite;
    d.setTest(rr), rr && (d.setMask(Gn.stencilWriteMask), d.setFunc(Gn.stencilFunc, Gn.stencilRef, Gn.stencilFuncMask), d.setOp(Gn.stencilFail, Gn.stencilZFail, Gn.stencilZPass)), pt(Gn.polygonOffset, Gn.polygonOffsetFactor, Gn.polygonOffsetUnits), Gn.alphaToCoverage === !0 ? ut(r.SAMPLE_ALPHA_TO_COVERAGE) : Tt(r.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function Et(Gn) {
    Ge !== Gn && (Gn ? r.frontFace(r.CW) : r.frontFace(r.CCW), Ge = Gn);
  }
  function Ke(Gn) {
    Gn !== CullFaceNone ? (ut(r.CULL_FACE), Gn !== ve && (Gn === CullFaceBack ? r.cullFace(r.BACK) : Gn === CullFaceFront ? r.cullFace(r.FRONT) : r.cullFace(r.FRONT_AND_BACK))) : Tt(r.CULL_FACE), ve = Gn;
  }
  function $e(Gn) {
    Gn !== te && (De && r.lineWidth(Gn), te = Gn);
  }
  function pt(Gn, Jn, Xn) {
    Gn ? (ut(r.POLYGON_OFFSET_FILL), (ae !== Jn || v !== Xn) && (r.polygonOffset(Jn, Xn), ae = Jn, v = Xn)) : Tt(r.POLYGON_OFFSET_FILL);
  }
  function Jt(Gn) {
    Gn ? ut(r.SCISSOR_TEST) : Tt(r.SCISSOR_TEST);
  }
  function In(Gn) {
    Gn === void 0 && (Gn = r.TEXTURE0 + Te - 1), ke !== Gn && (r.activeTexture(Gn), ke = Gn);
  }
  function Cn(Gn, Jn, Xn) {
    Xn === void 0 && (ke === null ? Xn = r.TEXTURE0 + Te - 1 : Xn = ke);
    let rr = Be[Xn];
    rr === void 0 && (rr = { type: void 0, texture: void 0 }, Be[Xn] = rr), (rr.type !== Gn || rr.texture !== Jn) && (ke !== Xn && (r.activeTexture(Xn), ke = Xn), r.bindTexture(Gn, Jn || Bt[Gn]), rr.type = Gn, rr.texture = Jn);
  }
  function It() {
    const Gn = Be[ke];
    Gn !== void 0 && Gn.type !== void 0 && (r.bindTexture(Gn.type, null), Gn.type = void 0, Gn.texture = void 0);
  }
  function ht() {
    try {
      r.compressedTexImage2D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Wt() {
    try {
      r.compressedTexImage3D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function hn() {
    try {
      r.texSubImage2D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Vt() {
    try {
      r.texSubImage3D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Tn() {
    try {
      r.compressedTexSubImage2D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Rn() {
    try {
      r.compressedTexSubImage3D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Nn() {
    try {
      r.texStorage2D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Dn() {
    try {
      r.texStorage3D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function xn() {
    try {
      r.texImage2D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function $n() {
    try {
      r.texImage3D.apply(r, arguments);
    } catch (Gn) {
      console.error("THREE.WebGLState:", Gn);
    }
  }
  function Kn(Gn) {
    Se.equals(Gn) === !1 && (r.scissor(Gn.x, Gn.y, Gn.z, Gn.w), Se.copy(Gn));
  }
  function ir(Gn) {
    xt.equals(Gn) === !1 && (r.viewport(Gn.x, Gn.y, Gn.z, Gn.w), xt.copy(Gn));
  }
  function er(Gn, Jn) {
    let Xn = h.get(Jn);
    Xn === void 0 && (Xn = /* @__PURE__ */ new WeakMap(), h.set(Jn, Xn));
    let rr = Xn.get(Gn);
    rr === void 0 && (rr = r.getUniformBlockIndex(Jn, Gn.name), Xn.set(Gn, rr));
  }
  function br(Gn, Jn) {
    const rr = h.get(Jn).get(Gn);
    f.get(Jn) !== rr && (r.uniformBlockBinding(Jn, rr, Gn.__bindingPointIndex), f.set(Jn, rr));
  }
  function cs() {
    r.disable(r.BLEND), r.disable(r.CULL_FACE), r.disable(r.DEPTH_TEST), r.disable(r.POLYGON_OFFSET_FILL), r.disable(r.SCISSOR_TEST), r.disable(r.STENCIL_TEST), r.disable(r.SAMPLE_ALPHA_TO_COVERAGE), r.blendEquation(r.FUNC_ADD), r.blendFunc(r.ONE, r.ZERO), r.blendFuncSeparate(r.ONE, r.ZERO, r.ONE, r.ZERO), r.colorMask(!0, !0, !0, !0), r.clearColor(0, 0, 0, 0), r.depthMask(!0), r.depthFunc(r.LESS), r.clearDepth(1), r.stencilMask(4294967295), r.stencilFunc(r.ALWAYS, 0, 4294967295), r.stencilOp(r.KEEP, r.KEEP, r.KEEP), r.clearStencil(0), r.cullFace(r.BACK), r.frontFace(r.CCW), r.polygonOffset(0, 0), r.activeTexture(r.TEXTURE0), r.bindFramebuffer(r.FRAMEBUFFER, null), o === !0 && (r.bindFramebuffer(r.DRAW_FRAMEBUFFER, null), r.bindFramebuffer(r.READ_FRAMEBUFFER, null)), r.useProgram(null), r.lineWidth(1), r.scissor(0, 0, r.canvas.width, r.canvas.height), r.viewport(0, 0, r.canvas.width, r.canvas.height), S = {}, ke = null, Be = {}, R = {}, _ = /* @__PURE__ */ new WeakMap(), m = [], L = null, F = !1, W = null, G = null, q = null, fe = null, _e = null, Le = null, Fe = null, Ee = !1, Ge = null, ve = null, te = null, ae = null, v = null, Se.set(0, 0, r.canvas.width, r.canvas.height), xt.set(0, 0, r.canvas.width, r.canvas.height), c.reset(), E.reset(), d.reset();
  }
  return {
    buffers: {
      color: c,
      depth: E,
      stencil: d
    },
    enable: ut,
    disable: Tt,
    bindFramebuffer: Yt,
    drawBuffers: an,
    useProgram: Ct,
    setBlending: lt,
    setMaterial: Zt,
    setFlipSided: Et,
    setCullFace: Ke,
    setLineWidth: $e,
    setPolygonOffset: pt,
    setScissorTest: Jt,
    activeTexture: In,
    bindTexture: Cn,
    unbindTexture: It,
    compressedTexImage2D: ht,
    compressedTexImage3D: Wt,
    texImage2D: xn,
    texImage3D: $n,
    updateUBOMapping: er,
    uniformBlockBinding: br,
    texStorage2D: Nn,
    texStorage3D: Dn,
    texSubImage2D: hn,
    texSubImage3D: Vt,
    compressedTexSubImage2D: Tn,
    compressedTexSubImage3D: Rn,
    scissor: Kn,
    viewport: ir,
    reset: cs
  };
}
function WebGLTextures(r, e, s, o, a, l, u) {
  const c = a.isWebGL2, E = a.maxTextures, d = a.maxCubemapSize, f = a.maxTextureSize, h = a.maxSamples, S = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, R = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), _ = /* @__PURE__ */ new WeakMap();
  let m;
  const L = /* @__PURE__ */ new WeakMap();
  let F = !1;
  try {
    F = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function W(It, ht) {
    return F ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(It, ht)
    ) : createElementNS("canvas");
  }
  function G(It, ht, Wt, hn) {
    let Vt = 1;
    if ((It.width > hn || It.height > hn) && (Vt = hn / Math.max(It.width, It.height)), Vt < 1 || ht === !0)
      if (typeof HTMLImageElement < "u" && It instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && It instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && It instanceof ImageBitmap) {
        const Tn = ht ? floorPowerOfTwo : Math.floor, Rn = Tn(Vt * It.width), Nn = Tn(Vt * It.height);
        m === void 0 && (m = W(Rn, Nn));
        const Dn = Wt ? W(Rn, Nn) : m;
        return Dn.width = Rn, Dn.height = Nn, Dn.getContext("2d").drawImage(It, 0, 0, Rn, Nn), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + It.width + "x" + It.height + ") to (" + Rn + "x" + Nn + ")."), Dn;
      } else
        return "data" in It && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + It.width + "x" + It.height + ")."), It;
    return It;
  }
  function q(It) {
    return isPowerOfTwo(It.width) && isPowerOfTwo(It.height);
  }
  function fe(It) {
    return c ? !1 : It.wrapS !== ClampToEdgeWrapping || It.wrapT !== ClampToEdgeWrapping || It.minFilter !== NearestFilter && It.minFilter !== LinearFilter;
  }
  function _e(It, ht) {
    return It.generateMipmaps && ht && It.minFilter !== NearestFilter && It.minFilter !== LinearFilter;
  }
  function Le(It) {
    r.generateMipmap(It);
  }
  function Fe(It, ht, Wt, hn, Vt = !1) {
    if (c === !1)
      return ht;
    if (It !== null) {
      if (r[It] !== void 0)
        return r[It];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + It + "'");
    }
    let Tn = ht;
    return ht === r.RED && (Wt === r.FLOAT && (Tn = r.R32F), Wt === r.HALF_FLOAT && (Tn = r.R16F), Wt === r.UNSIGNED_BYTE && (Tn = r.R8)), ht === r.RG && (Wt === r.FLOAT && (Tn = r.RG32F), Wt === r.HALF_FLOAT && (Tn = r.RG16F), Wt === r.UNSIGNED_BYTE && (Tn = r.RG8)), ht === r.RGBA && (Wt === r.FLOAT && (Tn = r.RGBA32F), Wt === r.HALF_FLOAT && (Tn = r.RGBA16F), Wt === r.UNSIGNED_BYTE && (Tn = hn === SRGBColorSpace && Vt === !1 ? r.SRGB8_ALPHA8 : r.RGBA8), Wt === r.UNSIGNED_SHORT_4_4_4_4 && (Tn = r.RGBA4), Wt === r.UNSIGNED_SHORT_5_5_5_1 && (Tn = r.RGB5_A1)), (Tn === r.R16F || Tn === r.R32F || Tn === r.RG16F || Tn === r.RG32F || Tn === r.RGBA16F || Tn === r.RGBA32F) && e.get("EXT_color_buffer_float"), Tn;
  }
  function Ee(It, ht, Wt) {
    return _e(It, Wt) === !0 || It.isFramebufferTexture && It.minFilter !== NearestFilter && It.minFilter !== LinearFilter ? Math.log2(Math.max(ht.width, ht.height)) + 1 : It.mipmaps !== void 0 && It.mipmaps.length > 0 ? It.mipmaps.length : It.isCompressedTexture && Array.isArray(It.image) ? ht.mipmaps.length : 1;
  }
  function Ge(It) {
    return It === NearestFilter || It === NearestMipmapNearestFilter || It === NearestMipmapLinearFilter ? r.NEAREST : r.LINEAR;
  }
  function ve(It) {
    const ht = It.target;
    ht.removeEventListener("dispose", ve), ae(ht), ht.isVideoTexture && _.delete(ht);
  }
  function te(It) {
    const ht = It.target;
    ht.removeEventListener("dispose", te), Te(ht);
  }
  function ae(It) {
    const ht = o.get(It);
    if (ht.__webglInit === void 0)
      return;
    const Wt = It.source, hn = L.get(Wt);
    if (hn) {
      const Vt = hn[ht.__cacheKey];
      Vt.usedTimes--, Vt.usedTimes === 0 && v(It), Object.keys(hn).length === 0 && L.delete(Wt);
    }
    o.remove(It);
  }
  function v(It) {
    const ht = o.get(It);
    r.deleteTexture(ht.__webglTexture);
    const Wt = It.source, hn = L.get(Wt);
    delete hn[ht.__cacheKey], u.memory.textures--;
  }
  function Te(It) {
    const ht = It.texture, Wt = o.get(It), hn = o.get(ht);
    if (hn.__webglTexture !== void 0 && (r.deleteTexture(hn.__webglTexture), u.memory.textures--), It.depthTexture && It.depthTexture.dispose(), It.isWebGLCubeRenderTarget)
      for (let Vt = 0; Vt < 6; Vt++)
        r.deleteFramebuffer(Wt.__webglFramebuffer[Vt]), Wt.__webglDepthbuffer && r.deleteRenderbuffer(Wt.__webglDepthbuffer[Vt]);
    else {
      if (r.deleteFramebuffer(Wt.__webglFramebuffer), Wt.__webglDepthbuffer && r.deleteRenderbuffer(Wt.__webglDepthbuffer), Wt.__webglMultisampledFramebuffer && r.deleteFramebuffer(Wt.__webglMultisampledFramebuffer), Wt.__webglColorRenderbuffer)
        for (let Vt = 0; Vt < Wt.__webglColorRenderbuffer.length; Vt++)
          Wt.__webglColorRenderbuffer[Vt] && r.deleteRenderbuffer(Wt.__webglColorRenderbuffer[Vt]);
      Wt.__webglDepthRenderbuffer && r.deleteRenderbuffer(Wt.__webglDepthRenderbuffer);
    }
    if (It.isWebGLMultipleRenderTargets)
      for (let Vt = 0, Tn = ht.length; Vt < Tn; Vt++) {
        const Rn = o.get(ht[Vt]);
        Rn.__webglTexture && (r.deleteTexture(Rn.__webglTexture), u.memory.textures--), o.remove(ht[Vt]);
      }
    o.remove(ht), o.remove(It);
  }
  let De = 0;
  function be() {
    De = 0;
  }
  function ze() {
    const It = De;
    return It >= E && console.warn("THREE.WebGLTextures: Trying to use " + It + " texture units while this GPU supports only " + E), De += 1, It;
  }
  function ke(It) {
    const ht = [];
    return ht.push(It.wrapS), ht.push(It.wrapT), ht.push(It.wrapR || 0), ht.push(It.magFilter), ht.push(It.minFilter), ht.push(It.anisotropy), ht.push(It.internalFormat), ht.push(It.format), ht.push(It.type), ht.push(It.generateMipmaps), ht.push(It.premultiplyAlpha), ht.push(It.flipY), ht.push(It.unpackAlignment), ht.push(It.colorSpace), ht.join();
  }
  function Be(It, ht) {
    const Wt = o.get(It);
    if (It.isVideoTexture && In(It), It.isRenderTargetTexture === !1 && It.version > 0 && Wt.__version !== It.version) {
      const hn = It.image;
      if (hn === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (hn.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        Yt(Wt, It, ht);
        return;
      }
    }
    s.bindTexture(r.TEXTURE_2D, Wt.__webglTexture, r.TEXTURE0 + ht);
  }
  function Me(It, ht) {
    const Wt = o.get(It);
    if (It.version > 0 && Wt.__version !== It.version) {
      Yt(Wt, It, ht);
      return;
    }
    s.bindTexture(r.TEXTURE_2D_ARRAY, Wt.__webglTexture, r.TEXTURE0 + ht);
  }
  function me(It, ht) {
    const Wt = o.get(It);
    if (It.version > 0 && Wt.__version !== It.version) {
      Yt(Wt, It, ht);
      return;
    }
    s.bindTexture(r.TEXTURE_3D, Wt.__webglTexture, r.TEXTURE0 + ht);
  }
  function Se(It, ht) {
    const Wt = o.get(It);
    if (It.version > 0 && Wt.__version !== It.version) {
      an(Wt, It, ht);
      return;
    }
    s.bindTexture(r.TEXTURE_CUBE_MAP, Wt.__webglTexture, r.TEXTURE0 + ht);
  }
  const xt = {
    [RepeatWrapping]: r.REPEAT,
    [ClampToEdgeWrapping]: r.CLAMP_TO_EDGE,
    [MirroredRepeatWrapping]: r.MIRRORED_REPEAT
  }, Ht = {
    [NearestFilter]: r.NEAREST,
    [NearestMipmapNearestFilter]: r.NEAREST_MIPMAP_NEAREST,
    [NearestMipmapLinearFilter]: r.NEAREST_MIPMAP_LINEAR,
    [LinearFilter]: r.LINEAR,
    [LinearMipmapNearestFilter]: r.LINEAR_MIPMAP_NEAREST,
    [LinearMipmapLinearFilter]: r.LINEAR_MIPMAP_LINEAR
  }, Bt = {
    [NeverCompare]: r.NEVER,
    [AlwaysCompare]: r.ALWAYS,
    [LessCompare]: r.LESS,
    [LessEqualCompare]: r.LEQUAL,
    [EqualCompare]: r.EQUAL,
    [GreaterEqualCompare]: r.GEQUAL,
    [GreaterCompare]: r.GREATER,
    [NotEqualCompare]: r.NOTEQUAL
  };
  function ut(It, ht, Wt) {
    if (Wt ? (r.texParameteri(It, r.TEXTURE_WRAP_S, xt[ht.wrapS]), r.texParameteri(It, r.TEXTURE_WRAP_T, xt[ht.wrapT]), (It === r.TEXTURE_3D || It === r.TEXTURE_2D_ARRAY) && r.texParameteri(It, r.TEXTURE_WRAP_R, xt[ht.wrapR]), r.texParameteri(It, r.TEXTURE_MAG_FILTER, Ht[ht.magFilter]), r.texParameteri(It, r.TEXTURE_MIN_FILTER, Ht[ht.minFilter])) : (r.texParameteri(It, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(It, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), (It === r.TEXTURE_3D || It === r.TEXTURE_2D_ARRAY) && r.texParameteri(It, r.TEXTURE_WRAP_R, r.CLAMP_TO_EDGE), (ht.wrapS !== ClampToEdgeWrapping || ht.wrapT !== ClampToEdgeWrapping) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), r.texParameteri(It, r.TEXTURE_MAG_FILTER, Ge(ht.magFilter)), r.texParameteri(It, r.TEXTURE_MIN_FILTER, Ge(ht.minFilter)), ht.minFilter !== NearestFilter && ht.minFilter !== LinearFilter && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), ht.compareFunction && (r.texParameteri(It, r.TEXTURE_COMPARE_MODE, r.COMPARE_REF_TO_TEXTURE), r.texParameteri(It, r.TEXTURE_COMPARE_FUNC, Bt[ht.compareFunction])), e.has("EXT_texture_filter_anisotropic") === !0) {
      const hn = e.get("EXT_texture_filter_anisotropic");
      if (ht.magFilter === NearestFilter || ht.minFilter !== NearestMipmapLinearFilter && ht.minFilter !== LinearMipmapLinearFilter || ht.type === FloatType && e.has("OES_texture_float_linear") === !1 || c === !1 && ht.type === HalfFloatType && e.has("OES_texture_half_float_linear") === !1)
        return;
      (ht.anisotropy > 1 || o.get(ht).__currentAnisotropy) && (r.texParameterf(It, hn.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(ht.anisotropy, a.getMaxAnisotropy())), o.get(ht).__currentAnisotropy = ht.anisotropy);
    }
  }
  function Tt(It, ht) {
    let Wt = !1;
    It.__webglInit === void 0 && (It.__webglInit = !0, ht.addEventListener("dispose", ve));
    const hn = ht.source;
    let Vt = L.get(hn);
    Vt === void 0 && (Vt = {}, L.set(hn, Vt));
    const Tn = ke(ht);
    if (Tn !== It.__cacheKey) {
      Vt[Tn] === void 0 && (Vt[Tn] = {
        texture: r.createTexture(),
        usedTimes: 0
      }, u.memory.textures++, Wt = !0), Vt[Tn].usedTimes++;
      const Rn = Vt[It.__cacheKey];
      Rn !== void 0 && (Vt[It.__cacheKey].usedTimes--, Rn.usedTimes === 0 && v(ht)), It.__cacheKey = Tn, It.__webglTexture = Vt[Tn].texture;
    }
    return Wt;
  }
  function Yt(It, ht, Wt) {
    let hn = r.TEXTURE_2D;
    (ht.isDataArrayTexture || ht.isCompressedArrayTexture) && (hn = r.TEXTURE_2D_ARRAY), ht.isData3DTexture && (hn = r.TEXTURE_3D);
    const Vt = Tt(It, ht), Tn = ht.source;
    s.bindTexture(hn, It.__webglTexture, r.TEXTURE0 + Wt);
    const Rn = o.get(Tn);
    if (Tn.version !== Rn.__version || Vt === !0) {
      s.activeTexture(r.TEXTURE0 + Wt), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, ht.flipY), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, ht.premultiplyAlpha), r.pixelStorei(r.UNPACK_ALIGNMENT, ht.unpackAlignment), r.pixelStorei(r.UNPACK_COLORSPACE_CONVERSION_WEBGL, r.NONE);
      const Nn = fe(ht) && q(ht.image) === !1;
      let Dn = G(ht.image, Nn, !1, f);
      Dn = Cn(ht, Dn);
      const xn = q(Dn) || c, $n = l.convert(ht.format, ht.colorSpace);
      let Kn = l.convert(ht.type), ir = Fe(ht.internalFormat, $n, Kn, ht.colorSpace);
      ut(hn, ht, xn);
      let er;
      const br = ht.mipmaps, cs = c && ht.isVideoTexture !== !0, Gn = Rn.__version === void 0 || Vt === !0, Jn = Ee(ht, Dn, xn);
      if (ht.isDepthTexture)
        ir = r.DEPTH_COMPONENT, c ? ht.type === FloatType ? ir = r.DEPTH_COMPONENT32F : ht.type === UnsignedIntType ? ir = r.DEPTH_COMPONENT24 : ht.type === UnsignedInt248Type ? ir = r.DEPTH24_STENCIL8 : ir = r.DEPTH_COMPONENT16 : ht.type === FloatType && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), ht.format === DepthFormat && ir === r.DEPTH_COMPONENT && ht.type !== UnsignedShortType && ht.type !== UnsignedIntType && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), ht.type = UnsignedIntType, Kn = l.convert(ht.type)), ht.format === DepthStencilFormat && ir === r.DEPTH_COMPONENT && (ir = r.DEPTH_STENCIL, ht.type !== UnsignedInt248Type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), ht.type = UnsignedInt248Type, Kn = l.convert(ht.type))), Gn && (cs ? s.texStorage2D(r.TEXTURE_2D, 1, ir, Dn.width, Dn.height) : s.texImage2D(r.TEXTURE_2D, 0, ir, Dn.width, Dn.height, 0, $n, Kn, null));
      else if (ht.isDataTexture)
        if (br.length > 0 && xn) {
          cs && Gn && s.texStorage2D(r.TEXTURE_2D, Jn, ir, br[0].width, br[0].height);
          for (let Xn = 0, rr = br.length; Xn < rr; Xn++)
            er = br[Xn], cs ? s.texSubImage2D(r.TEXTURE_2D, Xn, 0, 0, er.width, er.height, $n, Kn, er.data) : s.texImage2D(r.TEXTURE_2D, Xn, ir, er.width, er.height, 0, $n, Kn, er.data);
          ht.generateMipmaps = !1;
        } else
          cs ? (Gn && s.texStorage2D(r.TEXTURE_2D, Jn, ir, Dn.width, Dn.height), s.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, Dn.width, Dn.height, $n, Kn, Dn.data)) : s.texImage2D(r.TEXTURE_2D, 0, ir, Dn.width, Dn.height, 0, $n, Kn, Dn.data);
      else if (ht.isCompressedTexture)
        if (ht.isCompressedArrayTexture) {
          cs && Gn && s.texStorage3D(r.TEXTURE_2D_ARRAY, Jn, ir, br[0].width, br[0].height, Dn.depth);
          for (let Xn = 0, rr = br.length; Xn < rr; Xn++)
            er = br[Xn], ht.format !== RGBAFormat ? $n !== null ? cs ? s.compressedTexSubImage3D(r.TEXTURE_2D_ARRAY, Xn, 0, 0, 0, er.width, er.height, Dn.depth, $n, er.data, 0, 0) : s.compressedTexImage3D(r.TEXTURE_2D_ARRAY, Xn, ir, er.width, er.height, Dn.depth, 0, er.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : cs ? s.texSubImage3D(r.TEXTURE_2D_ARRAY, Xn, 0, 0, 0, er.width, er.height, Dn.depth, $n, Kn, er.data) : s.texImage3D(r.TEXTURE_2D_ARRAY, Xn, ir, er.width, er.height, Dn.depth, 0, $n, Kn, er.data);
        } else {
          cs && Gn && s.texStorage2D(r.TEXTURE_2D, Jn, ir, br[0].width, br[0].height);
          for (let Xn = 0, rr = br.length; Xn < rr; Xn++)
            er = br[Xn], ht.format !== RGBAFormat ? $n !== null ? cs ? s.compressedTexSubImage2D(r.TEXTURE_2D, Xn, 0, 0, er.width, er.height, $n, er.data) : s.compressedTexImage2D(r.TEXTURE_2D, Xn, ir, er.width, er.height, 0, er.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : cs ? s.texSubImage2D(r.TEXTURE_2D, Xn, 0, 0, er.width, er.height, $n, Kn, er.data) : s.texImage2D(r.TEXTURE_2D, Xn, ir, er.width, er.height, 0, $n, Kn, er.data);
        }
      else if (ht.isDataArrayTexture)
        cs ? (Gn && s.texStorage3D(r.TEXTURE_2D_ARRAY, Jn, ir, Dn.width, Dn.height, Dn.depth), s.texSubImage3D(r.TEXTURE_2D_ARRAY, 0, 0, 0, 0, Dn.width, Dn.height, Dn.depth, $n, Kn, Dn.data)) : s.texImage3D(r.TEXTURE_2D_ARRAY, 0, ir, Dn.width, Dn.height, Dn.depth, 0, $n, Kn, Dn.data);
      else if (ht.isData3DTexture)
        cs ? (Gn && s.texStorage3D(r.TEXTURE_3D, Jn, ir, Dn.width, Dn.height, Dn.depth), s.texSubImage3D(r.TEXTURE_3D, 0, 0, 0, 0, Dn.width, Dn.height, Dn.depth, $n, Kn, Dn.data)) : s.texImage3D(r.TEXTURE_3D, 0, ir, Dn.width, Dn.height, Dn.depth, 0, $n, Kn, Dn.data);
      else if (ht.isFramebufferTexture) {
        if (Gn)
          if (cs)
            s.texStorage2D(r.TEXTURE_2D, Jn, ir, Dn.width, Dn.height);
          else {
            let Xn = Dn.width, rr = Dn.height;
            for (let _r = 0; _r < Jn; _r++)
              s.texImage2D(r.TEXTURE_2D, _r, ir, Xn, rr, 0, $n, Kn, null), Xn >>= 1, rr >>= 1;
          }
      } else if (br.length > 0 && xn) {
        cs && Gn && s.texStorage2D(r.TEXTURE_2D, Jn, ir, br[0].width, br[0].height);
        for (let Xn = 0, rr = br.length; Xn < rr; Xn++)
          er = br[Xn], cs ? s.texSubImage2D(r.TEXTURE_2D, Xn, 0, 0, $n, Kn, er) : s.texImage2D(r.TEXTURE_2D, Xn, ir, $n, Kn, er);
        ht.generateMipmaps = !1;
      } else
        cs ? (Gn && s.texStorage2D(r.TEXTURE_2D, Jn, ir, Dn.width, Dn.height), s.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, $n, Kn, Dn)) : s.texImage2D(r.TEXTURE_2D, 0, ir, $n, Kn, Dn);
      _e(ht, xn) && Le(hn), Rn.__version = Tn.version, ht.onUpdate && ht.onUpdate(ht);
    }
    It.__version = ht.version;
  }
  function an(It, ht, Wt) {
    if (ht.image.length !== 6)
      return;
    const hn = Tt(It, ht), Vt = ht.source;
    s.bindTexture(r.TEXTURE_CUBE_MAP, It.__webglTexture, r.TEXTURE0 + Wt);
    const Tn = o.get(Vt);
    if (Vt.version !== Tn.__version || hn === !0) {
      s.activeTexture(r.TEXTURE0 + Wt), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, ht.flipY), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, ht.premultiplyAlpha), r.pixelStorei(r.UNPACK_ALIGNMENT, ht.unpackAlignment), r.pixelStorei(r.UNPACK_COLORSPACE_CONVERSION_WEBGL, r.NONE);
      const Rn = ht.isCompressedTexture || ht.image[0].isCompressedTexture, Nn = ht.image[0] && ht.image[0].isDataTexture, Dn = [];
      for (let Xn = 0; Xn < 6; Xn++)
        !Rn && !Nn ? Dn[Xn] = G(ht.image[Xn], !1, !0, d) : Dn[Xn] = Nn ? ht.image[Xn].image : ht.image[Xn], Dn[Xn] = Cn(ht, Dn[Xn]);
      const xn = Dn[0], $n = q(xn) || c, Kn = l.convert(ht.format, ht.colorSpace), ir = l.convert(ht.type), er = Fe(ht.internalFormat, Kn, ir, ht.colorSpace), br = c && ht.isVideoTexture !== !0, cs = Tn.__version === void 0 || hn === !0;
      let Gn = Ee(ht, xn, $n);
      ut(r.TEXTURE_CUBE_MAP, ht, $n);
      let Jn;
      if (Rn) {
        br && cs && s.texStorage2D(r.TEXTURE_CUBE_MAP, Gn, er, xn.width, xn.height);
        for (let Xn = 0; Xn < 6; Xn++) {
          Jn = Dn[Xn].mipmaps;
          for (let rr = 0; rr < Jn.length; rr++) {
            const _r = Jn[rr];
            ht.format !== RGBAFormat ? Kn !== null ? br ? s.compressedTexSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr, 0, 0, _r.width, _r.height, Kn, _r.data) : s.compressedTexImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr, er, _r.width, _r.height, 0, _r.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : br ? s.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr, 0, 0, _r.width, _r.height, Kn, ir, _r.data) : s.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr, er, _r.width, _r.height, 0, Kn, ir, _r.data);
          }
        }
      } else {
        Jn = ht.mipmaps, br && cs && (Jn.length > 0 && Gn++, s.texStorage2D(r.TEXTURE_CUBE_MAP, Gn, er, Dn[0].width, Dn[0].height));
        for (let Xn = 0; Xn < 6; Xn++)
          if (Nn) {
            br ? s.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, 0, 0, 0, Dn[Xn].width, Dn[Xn].height, Kn, ir, Dn[Xn].data) : s.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, 0, er, Dn[Xn].width, Dn[Xn].height, 0, Kn, ir, Dn[Xn].data);
            for (let rr = 0; rr < Jn.length; rr++) {
              const Ss = Jn[rr].image[Xn].image;
              br ? s.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr + 1, 0, 0, Ss.width, Ss.height, Kn, ir, Ss.data) : s.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr + 1, er, Ss.width, Ss.height, 0, Kn, ir, Ss.data);
            }
          } else {
            br ? s.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, 0, 0, 0, Kn, ir, Dn[Xn]) : s.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, 0, er, Kn, ir, Dn[Xn]);
            for (let rr = 0; rr < Jn.length; rr++) {
              const _r = Jn[rr];
              br ? s.texSubImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr + 1, 0, 0, Kn, ir, _r.image[Xn]) : s.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + Xn, rr + 1, er, Kn, ir, _r.image[Xn]);
            }
          }
      }
      _e(ht, $n) && Le(r.TEXTURE_CUBE_MAP), Tn.__version = Vt.version, ht.onUpdate && ht.onUpdate(ht);
    }
    It.__version = ht.version;
  }
  function Ct(It, ht, Wt, hn, Vt) {
    const Tn = l.convert(Wt.format, Wt.colorSpace), Rn = l.convert(Wt.type), Nn = Fe(Wt.internalFormat, Tn, Rn, Wt.colorSpace);
    o.get(ht).__hasExternalTextures || (Vt === r.TEXTURE_3D || Vt === r.TEXTURE_2D_ARRAY ? s.texImage3D(Vt, 0, Nn, ht.width, ht.height, ht.depth, 0, Tn, Rn, null) : s.texImage2D(Vt, 0, Nn, ht.width, ht.height, 0, Tn, Rn, null)), s.bindFramebuffer(r.FRAMEBUFFER, It), Jt(ht) ? S.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, hn, Vt, o.get(Wt).__webglTexture, 0, pt(ht)) : (Vt === r.TEXTURE_2D || Vt >= r.TEXTURE_CUBE_MAP_POSITIVE_X && Vt <= r.TEXTURE_CUBE_MAP_NEGATIVE_Z) && r.framebufferTexture2D(r.FRAMEBUFFER, hn, Vt, o.get(Wt).__webglTexture, 0), s.bindFramebuffer(r.FRAMEBUFFER, null);
  }
  function st(It, ht, Wt) {
    if (r.bindRenderbuffer(r.RENDERBUFFER, It), ht.depthBuffer && !ht.stencilBuffer) {
      let hn = r.DEPTH_COMPONENT16;
      if (Wt || Jt(ht)) {
        const Vt = ht.depthTexture;
        Vt && Vt.isDepthTexture && (Vt.type === FloatType ? hn = r.DEPTH_COMPONENT32F : Vt.type === UnsignedIntType && (hn = r.DEPTH_COMPONENT24));
        const Tn = pt(ht);
        Jt(ht) ? S.renderbufferStorageMultisampleEXT(r.RENDERBUFFER, Tn, hn, ht.width, ht.height) : r.renderbufferStorageMultisample(r.RENDERBUFFER, Tn, hn, ht.width, ht.height);
      } else
        r.renderbufferStorage(r.RENDERBUFFER, hn, ht.width, ht.height);
      r.framebufferRenderbuffer(r.FRAMEBUFFER, r.DEPTH_ATTACHMENT, r.RENDERBUFFER, It);
    } else if (ht.depthBuffer && ht.stencilBuffer) {
      const hn = pt(ht);
      Wt && Jt(ht) === !1 ? r.renderbufferStorageMultisample(r.RENDERBUFFER, hn, r.DEPTH24_STENCIL8, ht.width, ht.height) : Jt(ht) ? S.renderbufferStorageMultisampleEXT(r.RENDERBUFFER, hn, r.DEPTH24_STENCIL8, ht.width, ht.height) : r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_STENCIL, ht.width, ht.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.DEPTH_STENCIL_ATTACHMENT, r.RENDERBUFFER, It);
    } else {
      const hn = ht.isWebGLMultipleRenderTargets === !0 ? ht.texture : [ht.texture];
      for (let Vt = 0; Vt < hn.length; Vt++) {
        const Tn = hn[Vt], Rn = l.convert(Tn.format, Tn.colorSpace), Nn = l.convert(Tn.type), Dn = Fe(Tn.internalFormat, Rn, Nn, Tn.colorSpace), xn = pt(ht);
        Wt && Jt(ht) === !1 ? r.renderbufferStorageMultisample(r.RENDERBUFFER, xn, Dn, ht.width, ht.height) : Jt(ht) ? S.renderbufferStorageMultisampleEXT(r.RENDERBUFFER, xn, Dn, ht.width, ht.height) : r.renderbufferStorage(r.RENDERBUFFER, Dn, ht.width, ht.height);
      }
    }
    r.bindRenderbuffer(r.RENDERBUFFER, null);
  }
  function jt(It, ht) {
    if (ht && ht.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported");
    if (s.bindFramebuffer(r.FRAMEBUFFER, It), !(ht.depthTexture && ht.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    (!o.get(ht.depthTexture).__webglTexture || ht.depthTexture.image.width !== ht.width || ht.depthTexture.image.height !== ht.height) && (ht.depthTexture.image.width = ht.width, ht.depthTexture.image.height = ht.height, ht.depthTexture.needsUpdate = !0), Be(ht.depthTexture, 0);
    const hn = o.get(ht.depthTexture).__webglTexture, Vt = pt(ht);
    if (ht.depthTexture.format === DepthFormat)
      Jt(ht) ? S.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, r.DEPTH_ATTACHMENT, r.TEXTURE_2D, hn, 0, Vt) : r.framebufferTexture2D(r.FRAMEBUFFER, r.DEPTH_ATTACHMENT, r.TEXTURE_2D, hn, 0);
    else if (ht.depthTexture.format === DepthStencilFormat)
      Jt(ht) ? S.framebufferTexture2DMultisampleEXT(r.FRAMEBUFFER, r.DEPTH_STENCIL_ATTACHMENT, r.TEXTURE_2D, hn, 0, Vt) : r.framebufferTexture2D(r.FRAMEBUFFER, r.DEPTH_STENCIL_ATTACHMENT, r.TEXTURE_2D, hn, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function lt(It) {
    const ht = o.get(It), Wt = It.isWebGLCubeRenderTarget === !0;
    if (It.depthTexture && !ht.__autoAllocateDepthBuffer) {
      if (Wt)
        throw new Error("target.depthTexture not supported in Cube render targets");
      jt(ht.__webglFramebuffer, It);
    } else if (Wt) {
      ht.__webglDepthbuffer = [];
      for (let hn = 0; hn < 6; hn++)
        s.bindFramebuffer(r.FRAMEBUFFER, ht.__webglFramebuffer[hn]), ht.__webglDepthbuffer[hn] = r.createRenderbuffer(), st(ht.__webglDepthbuffer[hn], It, !1);
    } else
      s.bindFramebuffer(r.FRAMEBUFFER, ht.__webglFramebuffer), ht.__webglDepthbuffer = r.createRenderbuffer(), st(ht.__webglDepthbuffer, It, !1);
    s.bindFramebuffer(r.FRAMEBUFFER, null);
  }
  function Zt(It, ht, Wt) {
    const hn = o.get(It);
    ht !== void 0 && Ct(hn.__webglFramebuffer, It, It.texture, r.COLOR_ATTACHMENT0, r.TEXTURE_2D), Wt !== void 0 && lt(It);
  }
  function Et(It) {
    const ht = It.texture, Wt = o.get(It), hn = o.get(ht);
    It.addEventListener("dispose", te), It.isWebGLMultipleRenderTargets !== !0 && (hn.__webglTexture === void 0 && (hn.__webglTexture = r.createTexture()), hn.__version = ht.version, u.memory.textures++);
    const Vt = It.isWebGLCubeRenderTarget === !0, Tn = It.isWebGLMultipleRenderTargets === !0, Rn = q(It) || c;
    if (Vt) {
      Wt.__webglFramebuffer = [];
      for (let Nn = 0; Nn < 6; Nn++)
        Wt.__webglFramebuffer[Nn] = r.createFramebuffer();
    } else {
      if (Wt.__webglFramebuffer = r.createFramebuffer(), Tn)
        if (a.drawBuffers) {
          const Nn = It.texture;
          for (let Dn = 0, xn = Nn.length; Dn < xn; Dn++) {
            const $n = o.get(Nn[Dn]);
            $n.__webglTexture === void 0 && ($n.__webglTexture = r.createTexture(), u.memory.textures++);
          }
        } else
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      if (c && It.samples > 0 && Jt(It) === !1) {
        const Nn = Tn ? ht : [ht];
        Wt.__webglMultisampledFramebuffer = r.createFramebuffer(), Wt.__webglColorRenderbuffer = [], s.bindFramebuffer(r.FRAMEBUFFER, Wt.__webglMultisampledFramebuffer);
        for (let Dn = 0; Dn < Nn.length; Dn++) {
          const xn = Nn[Dn];
          Wt.__webglColorRenderbuffer[Dn] = r.createRenderbuffer(), r.bindRenderbuffer(r.RENDERBUFFER, Wt.__webglColorRenderbuffer[Dn]);
          const $n = l.convert(xn.format, xn.colorSpace), Kn = l.convert(xn.type), ir = Fe(xn.internalFormat, $n, Kn, xn.colorSpace, It.isXRRenderTarget === !0), er = pt(It);
          r.renderbufferStorageMultisample(r.RENDERBUFFER, er, ir, It.width, It.height), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + Dn, r.RENDERBUFFER, Wt.__webglColorRenderbuffer[Dn]);
        }
        r.bindRenderbuffer(r.RENDERBUFFER, null), It.depthBuffer && (Wt.__webglDepthRenderbuffer = r.createRenderbuffer(), st(Wt.__webglDepthRenderbuffer, It, !0)), s.bindFramebuffer(r.FRAMEBUFFER, null);
      }
    }
    if (Vt) {
      s.bindTexture(r.TEXTURE_CUBE_MAP, hn.__webglTexture), ut(r.TEXTURE_CUBE_MAP, ht, Rn);
      for (let Nn = 0; Nn < 6; Nn++)
        Ct(Wt.__webglFramebuffer[Nn], It, ht, r.COLOR_ATTACHMENT0, r.TEXTURE_CUBE_MAP_POSITIVE_X + Nn);
      _e(ht, Rn) && Le(r.TEXTURE_CUBE_MAP), s.unbindTexture();
    } else if (Tn) {
      const Nn = It.texture;
      for (let Dn = 0, xn = Nn.length; Dn < xn; Dn++) {
        const $n = Nn[Dn], Kn = o.get($n);
        s.bindTexture(r.TEXTURE_2D, Kn.__webglTexture), ut(r.TEXTURE_2D, $n, Rn), Ct(Wt.__webglFramebuffer, It, $n, r.COLOR_ATTACHMENT0 + Dn, r.TEXTURE_2D), _e($n, Rn) && Le(r.TEXTURE_2D);
      }
      s.unbindTexture();
    } else {
      let Nn = r.TEXTURE_2D;
      (It.isWebGL3DRenderTarget || It.isWebGLArrayRenderTarget) && (c ? Nn = It.isWebGL3DRenderTarget ? r.TEXTURE_3D : r.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), s.bindTexture(Nn, hn.__webglTexture), ut(Nn, ht, Rn), Ct(Wt.__webglFramebuffer, It, ht, r.COLOR_ATTACHMENT0, Nn), _e(ht, Rn) && Le(Nn), s.unbindTexture();
    }
    It.depthBuffer && lt(It);
  }
  function Ke(It) {
    const ht = q(It) || c, Wt = It.isWebGLMultipleRenderTargets === !0 ? It.texture : [It.texture];
    for (let hn = 0, Vt = Wt.length; hn < Vt; hn++) {
      const Tn = Wt[hn];
      if (_e(Tn, ht)) {
        const Rn = It.isWebGLCubeRenderTarget ? r.TEXTURE_CUBE_MAP : r.TEXTURE_2D, Nn = o.get(Tn).__webglTexture;
        s.bindTexture(Rn, Nn), Le(Rn), s.unbindTexture();
      }
    }
  }
  function $e(It) {
    if (c && It.samples > 0 && Jt(It) === !1) {
      const ht = It.isWebGLMultipleRenderTargets ? It.texture : [It.texture], Wt = It.width, hn = It.height;
      let Vt = r.COLOR_BUFFER_BIT;
      const Tn = [], Rn = It.stencilBuffer ? r.DEPTH_STENCIL_ATTACHMENT : r.DEPTH_ATTACHMENT, Nn = o.get(It), Dn = It.isWebGLMultipleRenderTargets === !0;
      if (Dn)
        for (let xn = 0; xn < ht.length; xn++)
          s.bindFramebuffer(r.FRAMEBUFFER, Nn.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + xn, r.RENDERBUFFER, null), s.bindFramebuffer(r.FRAMEBUFFER, Nn.__webglFramebuffer), r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0 + xn, r.TEXTURE_2D, null, 0);
      s.bindFramebuffer(r.READ_FRAMEBUFFER, Nn.__webglMultisampledFramebuffer), s.bindFramebuffer(r.DRAW_FRAMEBUFFER, Nn.__webglFramebuffer);
      for (let xn = 0; xn < ht.length; xn++) {
        Tn.push(r.COLOR_ATTACHMENT0 + xn), It.depthBuffer && Tn.push(Rn);
        const $n = Nn.__ignoreDepthValues !== void 0 ? Nn.__ignoreDepthValues : !1;
        if ($n === !1 && (It.depthBuffer && (Vt |= r.DEPTH_BUFFER_BIT), It.stencilBuffer && (Vt |= r.STENCIL_BUFFER_BIT)), Dn && r.framebufferRenderbuffer(r.READ_FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.RENDERBUFFER, Nn.__webglColorRenderbuffer[xn]), $n === !0 && (r.invalidateFramebuffer(r.READ_FRAMEBUFFER, [Rn]), r.invalidateFramebuffer(r.DRAW_FRAMEBUFFER, [Rn])), Dn) {
          const Kn = o.get(ht[xn]).__webglTexture;
          r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, Kn, 0);
        }
        r.blitFramebuffer(0, 0, Wt, hn, 0, 0, Wt, hn, Vt, r.NEAREST), R && r.invalidateFramebuffer(r.READ_FRAMEBUFFER, Tn);
      }
      if (s.bindFramebuffer(r.READ_FRAMEBUFFER, null), s.bindFramebuffer(r.DRAW_FRAMEBUFFER, null), Dn)
        for (let xn = 0; xn < ht.length; xn++) {
          s.bindFramebuffer(r.FRAMEBUFFER, Nn.__webglMultisampledFramebuffer), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0 + xn, r.RENDERBUFFER, Nn.__webglColorRenderbuffer[xn]);
          const $n = o.get(ht[xn]).__webglTexture;
          s.bindFramebuffer(r.FRAMEBUFFER, Nn.__webglFramebuffer), r.framebufferTexture2D(r.DRAW_FRAMEBUFFER, r.COLOR_ATTACHMENT0 + xn, r.TEXTURE_2D, $n, 0);
        }
      s.bindFramebuffer(r.DRAW_FRAMEBUFFER, Nn.__webglMultisampledFramebuffer);
    }
  }
  function pt(It) {
    return Math.min(h, It.samples);
  }
  function Jt(It) {
    const ht = o.get(It);
    return c && It.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && ht.__useRenderToTexture !== !1;
  }
  function In(It) {
    const ht = u.render.frame;
    _.get(It) !== ht && (_.set(It, ht), It.update());
  }
  function Cn(It, ht) {
    const Wt = It.colorSpace, hn = It.format, Vt = It.type;
    return It.isCompressedTexture === !0 || It.format === _SRGBAFormat || Wt !== LinearSRGBColorSpace && Wt !== NoColorSpace && (Wt === SRGBColorSpace ? c === !1 ? e.has("EXT_sRGB") === !0 && hn === RGBAFormat ? (It.format = _SRGBAFormat, It.minFilter = LinearFilter, It.generateMipmaps = !1) : ht = ImageUtils.sRGBToLinear(ht) : (hn !== RGBAFormat || Vt !== UnsignedByteType) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", Wt)), ht;
  }
  this.allocateTextureUnit = ze, this.resetTextureUnits = be, this.setTexture2D = Be, this.setTexture2DArray = Me, this.setTexture3D = me, this.setTextureCube = Se, this.rebindTextures = Zt, this.setupRenderTarget = Et, this.updateRenderTargetMipmap = Ke, this.updateMultisampleRenderTarget = $e, this.setupDepthRenderbuffer = lt, this.setupFrameBufferTexture = Ct, this.useMultisampledRTT = Jt;
}
function WebGLUtils(r, e, s) {
  const o = s.isWebGL2;
  function a(l, u = NoColorSpace) {
    let c;
    if (l === UnsignedByteType)
      return r.UNSIGNED_BYTE;
    if (l === UnsignedShort4444Type)
      return r.UNSIGNED_SHORT_4_4_4_4;
    if (l === UnsignedShort5551Type)
      return r.UNSIGNED_SHORT_5_5_5_1;
    if (l === ByteType)
      return r.BYTE;
    if (l === ShortType)
      return r.SHORT;
    if (l === UnsignedShortType)
      return r.UNSIGNED_SHORT;
    if (l === IntType)
      return r.INT;
    if (l === UnsignedIntType)
      return r.UNSIGNED_INT;
    if (l === FloatType)
      return r.FLOAT;
    if (l === HalfFloatType)
      return o ? r.HALF_FLOAT : (c = e.get("OES_texture_half_float"), c !== null ? c.HALF_FLOAT_OES : null);
    if (l === AlphaFormat)
      return r.ALPHA;
    if (l === RGBAFormat)
      return r.RGBA;
    if (l === LuminanceFormat)
      return r.LUMINANCE;
    if (l === LuminanceAlphaFormat)
      return r.LUMINANCE_ALPHA;
    if (l === DepthFormat)
      return r.DEPTH_COMPONENT;
    if (l === DepthStencilFormat)
      return r.DEPTH_STENCIL;
    if (l === _SRGBAFormat)
      return c = e.get("EXT_sRGB"), c !== null ? c.SRGB_ALPHA_EXT : null;
    if (l === RedFormat)
      return r.RED;
    if (l === RedIntegerFormat)
      return r.RED_INTEGER;
    if (l === RGFormat)
      return r.RG;
    if (l === RGIntegerFormat)
      return r.RG_INTEGER;
    if (l === RGBAIntegerFormat)
      return r.RGBA_INTEGER;
    if (l === RGB_S3TC_DXT1_Format || l === RGBA_S3TC_DXT1_Format || l === RGBA_S3TC_DXT3_Format || l === RGBA_S3TC_DXT5_Format)
      if (u === SRGBColorSpace)
        if (c = e.get("WEBGL_compressed_texture_s3tc_srgb"), c !== null) {
          if (l === RGB_S3TC_DXT1_Format)
            return c.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (l === RGBA_S3TC_DXT1_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (l === RGBA_S3TC_DXT3_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (l === RGBA_S3TC_DXT5_Format)
            return c.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (c = e.get("WEBGL_compressed_texture_s3tc"), c !== null) {
        if (l === RGB_S3TC_DXT1_Format)
          return c.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (l === RGBA_S3TC_DXT1_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (l === RGBA_S3TC_DXT3_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (l === RGBA_S3TC_DXT5_Format)
          return c.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (l === RGB_PVRTC_4BPPV1_Format || l === RGB_PVRTC_2BPPV1_Format || l === RGBA_PVRTC_4BPPV1_Format || l === RGBA_PVRTC_2BPPV1_Format)
      if (c = e.get("WEBGL_compressed_texture_pvrtc"), c !== null) {
        if (l === RGB_PVRTC_4BPPV1_Format)
          return c.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (l === RGB_PVRTC_2BPPV1_Format)
          return c.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (l === RGBA_PVRTC_4BPPV1_Format)
          return c.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (l === RGBA_PVRTC_2BPPV1_Format)
          return c.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (l === RGB_ETC1_Format)
      return c = e.get("WEBGL_compressed_texture_etc1"), c !== null ? c.COMPRESSED_RGB_ETC1_WEBGL : null;
    if (l === RGB_ETC2_Format || l === RGBA_ETC2_EAC_Format)
      if (c = e.get("WEBGL_compressed_texture_etc"), c !== null) {
        if (l === RGB_ETC2_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ETC2 : c.COMPRESSED_RGB8_ETC2;
        if (l === RGBA_ETC2_EAC_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : c.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (l === RGBA_ASTC_4x4_Format || l === RGBA_ASTC_5x4_Format || l === RGBA_ASTC_5x5_Format || l === RGBA_ASTC_6x5_Format || l === RGBA_ASTC_6x6_Format || l === RGBA_ASTC_8x5_Format || l === RGBA_ASTC_8x6_Format || l === RGBA_ASTC_8x8_Format || l === RGBA_ASTC_10x5_Format || l === RGBA_ASTC_10x6_Format || l === RGBA_ASTC_10x8_Format || l === RGBA_ASTC_10x10_Format || l === RGBA_ASTC_12x10_Format || l === RGBA_ASTC_12x12_Format)
      if (c = e.get("WEBGL_compressed_texture_astc"), c !== null) {
        if (l === RGBA_ASTC_4x4_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : c.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (l === RGBA_ASTC_5x4_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : c.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (l === RGBA_ASTC_5x5_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : c.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (l === RGBA_ASTC_6x5_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : c.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (l === RGBA_ASTC_6x6_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : c.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (l === RGBA_ASTC_8x5_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : c.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (l === RGBA_ASTC_8x6_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : c.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (l === RGBA_ASTC_8x8_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : c.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (l === RGBA_ASTC_10x5_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : c.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (l === RGBA_ASTC_10x6_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : c.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (l === RGBA_ASTC_10x8_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : c.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (l === RGBA_ASTC_10x10_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : c.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (l === RGBA_ASTC_12x10_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : c.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (l === RGBA_ASTC_12x12_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : c.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (l === RGBA_BPTC_Format)
      if (c = e.get("EXT_texture_compression_bptc"), c !== null) {
        if (l === RGBA_BPTC_Format)
          return u === SRGBColorSpace ? c.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : c.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else
        return null;
    if (l === RED_RGTC1_Format || l === SIGNED_RED_RGTC1_Format || l === RED_GREEN_RGTC2_Format || l === SIGNED_RED_GREEN_RGTC2_Format)
      if (c = e.get("EXT_texture_compression_rgtc"), c !== null) {
        if (l === RGBA_BPTC_Format)
          return c.COMPRESSED_RED_RGTC1_EXT;
        if (l === SIGNED_RED_RGTC1_Format)
          return c.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (l === RED_GREEN_RGTC2_Format)
          return c.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (l === SIGNED_RED_GREEN_RGTC2_Format)
          return c.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else
        return null;
    return l === UnsignedInt248Type ? o ? r.UNSIGNED_INT_24_8 : (c = e.get("WEBGL_depth_texture"), c !== null ? c.UNSIGNED_INT_24_8_WEBGL : null) : r[l] !== void 0 ? r[l] : null;
  }
  return { convert: a };
}
class ArrayCamera extends PerspectiveCamera$1 {
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e;
  }
}
class Group extends Object3D {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const _moveEvent = { type: "move" };
class WebXRController {
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  getHandSpace() {
    return this._hand === null && (this._hand = new Group(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new Group(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Vector3$1(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Vector3$1()), this._targetRay;
  }
  getGripSpace() {
    return this._grip === null && (this._grip = new Group(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Vector3$1(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Vector3$1()), this._grip;
  }
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  connect(e) {
    if (e && e.hand) {
      const s = this._hand;
      if (s)
        for (const o of e.hand.values())
          this._getHandJoint(s, o);
    }
    return this.dispatchEvent({ type: "connected", data: e }), this;
  }
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  update(e, s, o) {
    let a = null, l = null, u = null;
    const c = this._targetRay, E = this._grip, d = this._hand;
    if (e && s.session.visibilityState !== "visible-blurred") {
      if (d && e.hand) {
        u = !0;
        for (const m of e.hand.values()) {
          const L = s.getJointPose(m, o), F = this._getHandJoint(d, m);
          L !== null && (F.matrix.fromArray(L.transform.matrix), F.matrix.decompose(F.position, F.rotation, F.scale), F.matrixWorldNeedsUpdate = !0, F.jointRadius = L.radius), F.visible = L !== null;
        }
        const f = d.joints["index-finger-tip"], h = d.joints["thumb-tip"], S = f.position.distanceTo(h.position), R = 0.02, _ = 5e-3;
        d.inputState.pinching && S > R + _ ? (d.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !d.inputState.pinching && S <= R - _ && (d.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        E !== null && e.gripSpace && (l = s.getPose(e.gripSpace, o), l !== null && (E.matrix.fromArray(l.transform.matrix), E.matrix.decompose(E.position, E.rotation, E.scale), E.matrixWorldNeedsUpdate = !0, l.linearVelocity ? (E.hasLinearVelocity = !0, E.linearVelocity.copy(l.linearVelocity)) : E.hasLinearVelocity = !1, l.angularVelocity ? (E.hasAngularVelocity = !0, E.angularVelocity.copy(l.angularVelocity)) : E.hasAngularVelocity = !1));
      c !== null && (a = s.getPose(e.targetRaySpace, o), a === null && l !== null && (a = l), a !== null && (c.matrix.fromArray(a.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), c.matrixWorldNeedsUpdate = !0, a.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(a.linearVelocity)) : c.hasLinearVelocity = !1, a.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(a.angularVelocity)) : c.hasAngularVelocity = !1, this.dispatchEvent(_moveEvent)));
    }
    return c !== null && (c.visible = a !== null), E !== null && (E.visible = l !== null), d !== null && (d.visible = u !== null), this;
  }
  // private method
  _getHandJoint(e, s) {
    if (e.joints[s.jointName] === void 0) {
      const o = new Group();
      o.matrixAutoUpdate = !1, o.visible = !1, e.joints[s.jointName] = o, e.add(o);
    }
    return e.joints[s.jointName];
  }
}
class DepthTexture extends Texture {
  constructor(e, s, o, a, l, u, c, E, d, f) {
    if (f = f !== void 0 ? f : DepthFormat, f !== DepthFormat && f !== DepthStencilFormat)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    o === void 0 && f === DepthFormat && (o = UnsignedIntType), o === void 0 && f === DepthStencilFormat && (o = UnsignedInt248Type), super(null, a, l, u, c, E, f, o, d), this.isDepthTexture = !0, this.image = { width: e, height: s }, this.magFilter = c !== void 0 ? c : NearestFilter, this.minFilter = E !== void 0 ? E : NearestFilter, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
  }
  copy(e) {
    return super.copy(e), this.compareFunction = e.compareFunction, this;
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return this.compareFunction !== null && (s.compareFunction = this.compareFunction), s;
  }
}
class WebXRManager extends EventDispatcher {
  constructor(e, s) {
    super();
    const o = this;
    let a = null, l = 1, u = null, c = "local-floor", E = 1, d = null, f = null, h = null, S = null, R = null, _ = null;
    const m = s.getContextAttributes();
    let L = null, F = null;
    const W = [], G = [], q = new PerspectiveCamera$1();
    q.layers.enable(1), q.viewport = new Vector4();
    const fe = new PerspectiveCamera$1();
    fe.layers.enable(2), fe.viewport = new Vector4();
    const _e = [q, fe], Le = new ArrayCamera();
    Le.layers.enable(1), Le.layers.enable(2);
    let Fe = null, Ee = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(Me) {
      let me = W[Me];
      return me === void 0 && (me = new WebXRController(), W[Me] = me), me.getTargetRaySpace();
    }, this.getControllerGrip = function(Me) {
      let me = W[Me];
      return me === void 0 && (me = new WebXRController(), W[Me] = me), me.getGripSpace();
    }, this.getHand = function(Me) {
      let me = W[Me];
      return me === void 0 && (me = new WebXRController(), W[Me] = me), me.getHandSpace();
    };
    function Ge(Me) {
      const me = G.indexOf(Me.inputSource);
      if (me === -1)
        return;
      const Se = W[me];
      Se !== void 0 && (Se.update(Me.inputSource, Me.frame, d || u), Se.dispatchEvent({ type: Me.type, data: Me.inputSource }));
    }
    function ve() {
      a.removeEventListener("select", Ge), a.removeEventListener("selectstart", Ge), a.removeEventListener("selectend", Ge), a.removeEventListener("squeeze", Ge), a.removeEventListener("squeezestart", Ge), a.removeEventListener("squeezeend", Ge), a.removeEventListener("end", ve), a.removeEventListener("inputsourceschange", te);
      for (let Me = 0; Me < W.length; Me++) {
        const me = G[Me];
        me !== null && (G[Me] = null, W[Me].disconnect(me));
      }
      Fe = null, Ee = null, e.setRenderTarget(L), R = null, S = null, h = null, a = null, F = null, Be.stop(), o.isPresenting = !1, o.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(Me) {
      l = Me, o.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(Me) {
      c = Me, o.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return d || u;
    }, this.setReferenceSpace = function(Me) {
      d = Me;
    }, this.getBaseLayer = function() {
      return S !== null ? S : R;
    }, this.getBinding = function() {
      return h;
    }, this.getFrame = function() {
      return _;
    }, this.getSession = function() {
      return a;
    }, this.setSession = async function(Me) {
      if (a = Me, a !== null) {
        if (L = e.getRenderTarget(), a.addEventListener("select", Ge), a.addEventListener("selectstart", Ge), a.addEventListener("selectend", Ge), a.addEventListener("squeeze", Ge), a.addEventListener("squeezestart", Ge), a.addEventListener("squeezeend", Ge), a.addEventListener("end", ve), a.addEventListener("inputsourceschange", te), m.xrCompatible !== !0 && await s.makeXRCompatible(), a.renderState.layers === void 0 || e.capabilities.isWebGL2 === !1) {
          const me = {
            antialias: a.renderState.layers === void 0 ? m.antialias : !0,
            alpha: !0,
            depth: m.depth,
            stencil: m.stencil,
            framebufferScaleFactor: l
          };
          R = new XRWebGLLayer(a, s, me), a.updateRenderState({ baseLayer: R }), F = new WebGLRenderTarget(
            R.framebufferWidth,
            R.framebufferHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              colorSpace: e.outputColorSpace,
              stencilBuffer: m.stencil
            }
          );
        } else {
          let me = null, Se = null, xt = null;
          m.depth && (xt = m.stencil ? s.DEPTH24_STENCIL8 : s.DEPTH_COMPONENT24, me = m.stencil ? DepthStencilFormat : DepthFormat, Se = m.stencil ? UnsignedInt248Type : UnsignedIntType);
          const Ht = {
            colorFormat: s.RGBA8,
            depthFormat: xt,
            scaleFactor: l
          };
          h = new XRWebGLBinding(a, s), S = h.createProjectionLayer(Ht), a.updateRenderState({ layers: [S] }), F = new WebGLRenderTarget(
            S.textureWidth,
            S.textureHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              depthTexture: new DepthTexture(S.textureWidth, S.textureHeight, Se, void 0, void 0, void 0, void 0, void 0, void 0, me),
              stencilBuffer: m.stencil,
              colorSpace: e.outputColorSpace,
              samples: m.antialias ? 4 : 0
            }
          );
          const Bt = e.properties.get(F);
          Bt.__ignoreDepthValues = S.ignoreDepthValues;
        }
        F.isXRRenderTarget = !0, this.setFoveation(E), d = null, u = await a.requestReferenceSpace(c), Be.setContext(a), Be.start(), o.isPresenting = !0, o.dispatchEvent({ type: "sessionstart" });
      }
    }, this.getEnvironmentBlendMode = function() {
      if (a !== null)
        return a.environmentBlendMode;
    };
    function te(Me) {
      for (let me = 0; me < Me.removed.length; me++) {
        const Se = Me.removed[me], xt = G.indexOf(Se);
        xt >= 0 && (G[xt] = null, W[xt].disconnect(Se));
      }
      for (let me = 0; me < Me.added.length; me++) {
        const Se = Me.added[me];
        let xt = G.indexOf(Se);
        if (xt === -1) {
          for (let Bt = 0; Bt < W.length; Bt++)
            if (Bt >= G.length) {
              G.push(Se), xt = Bt;
              break;
            } else if (G[Bt] === null) {
              G[Bt] = Se, xt = Bt;
              break;
            }
          if (xt === -1)
            break;
        }
        const Ht = W[xt];
        Ht && Ht.connect(Se);
      }
    }
    const ae = new Vector3$1(), v = new Vector3$1();
    function Te(Me, me, Se) {
      ae.setFromMatrixPosition(me.matrixWorld), v.setFromMatrixPosition(Se.matrixWorld);
      const xt = ae.distanceTo(v), Ht = me.projectionMatrix.elements, Bt = Se.projectionMatrix.elements, ut = Ht[14] / (Ht[10] - 1), Tt = Ht[14] / (Ht[10] + 1), Yt = (Ht[9] + 1) / Ht[5], an = (Ht[9] - 1) / Ht[5], Ct = (Ht[8] - 1) / Ht[0], st = (Bt[8] + 1) / Bt[0], jt = ut * Ct, lt = ut * st, Zt = xt / (-Ct + st), Et = Zt * -Ct;
      me.matrixWorld.decompose(Me.position, Me.quaternion, Me.scale), Me.translateX(Et), Me.translateZ(Zt), Me.matrixWorld.compose(Me.position, Me.quaternion, Me.scale), Me.matrixWorldInverse.copy(Me.matrixWorld).invert();
      const Ke = ut + Zt, $e = Tt + Zt, pt = jt - Et, Jt = lt + (xt - Et), In = Yt * Tt / $e * Ke, Cn = an * Tt / $e * Ke;
      Me.projectionMatrix.makePerspective(pt, Jt, In, Cn, Ke, $e), Me.projectionMatrixInverse.copy(Me.projectionMatrix).invert();
    }
    function De(Me, me) {
      me === null ? Me.matrixWorld.copy(Me.matrix) : Me.matrixWorld.multiplyMatrices(me.matrixWorld, Me.matrix), Me.matrixWorldInverse.copy(Me.matrixWorld).invert();
    }
    this.updateCamera = function(Me) {
      if (a === null)
        return;
      Le.near = fe.near = q.near = Me.near, Le.far = fe.far = q.far = Me.far, (Fe !== Le.near || Ee !== Le.far) && (a.updateRenderState({
        depthNear: Le.near,
        depthFar: Le.far
      }), Fe = Le.near, Ee = Le.far);
      const me = Me.parent, Se = Le.cameras;
      De(Le, me);
      for (let xt = 0; xt < Se.length; xt++)
        De(Se[xt], me);
      Se.length === 2 ? Te(Le, q, fe) : Le.projectionMatrix.copy(q.projectionMatrix), be(Me, Le, me);
    };
    function be(Me, me, Se) {
      Se === null ? Me.matrix.copy(me.matrixWorld) : (Me.matrix.copy(Se.matrixWorld), Me.matrix.invert(), Me.matrix.multiply(me.matrixWorld)), Me.matrix.decompose(Me.position, Me.quaternion, Me.scale), Me.updateMatrixWorld(!0);
      const xt = Me.children;
      for (let Ht = 0, Bt = xt.length; Ht < Bt; Ht++)
        xt[Ht].updateMatrixWorld(!0);
      Me.projectionMatrix.copy(me.projectionMatrix), Me.projectionMatrixInverse.copy(me.projectionMatrixInverse), Me.isPerspectiveCamera && (Me.fov = RAD2DEG * 2 * Math.atan(1 / Me.projectionMatrix.elements[5]), Me.zoom = 1);
    }
    this.getCamera = function() {
      return Le;
    }, this.getFoveation = function() {
      if (!(S === null && R === null))
        return E;
    }, this.setFoveation = function(Me) {
      E = Me, S !== null && (S.fixedFoveation = Me), R !== null && R.fixedFoveation !== void 0 && (R.fixedFoveation = Me);
    };
    let ze = null;
    function ke(Me, me) {
      if (f = me.getViewerPose(d || u), _ = me, f !== null) {
        const Se = f.views;
        R !== null && (e.setRenderTargetFramebuffer(F, R.framebuffer), e.setRenderTarget(F));
        let xt = !1;
        Se.length !== Le.cameras.length && (Le.cameras.length = 0, xt = !0);
        for (let Ht = 0; Ht < Se.length; Ht++) {
          const Bt = Se[Ht];
          let ut = null;
          if (R !== null)
            ut = R.getViewport(Bt);
          else {
            const Yt = h.getViewSubImage(S, Bt);
            ut = Yt.viewport, Ht === 0 && (e.setRenderTargetTextures(
              F,
              Yt.colorTexture,
              S.ignoreDepthValues ? void 0 : Yt.depthStencilTexture
            ), e.setRenderTarget(F));
          }
          let Tt = _e[Ht];
          Tt === void 0 && (Tt = new PerspectiveCamera$1(), Tt.layers.enable(Ht), Tt.viewport = new Vector4(), _e[Ht] = Tt), Tt.matrix.fromArray(Bt.transform.matrix), Tt.matrix.decompose(Tt.position, Tt.quaternion, Tt.scale), Tt.projectionMatrix.fromArray(Bt.projectionMatrix), Tt.projectionMatrixInverse.copy(Tt.projectionMatrix).invert(), Tt.viewport.set(ut.x, ut.y, ut.width, ut.height), Ht === 0 && (Le.matrix.copy(Tt.matrix), Le.matrix.decompose(Le.position, Le.quaternion, Le.scale)), xt === !0 && Le.cameras.push(Tt);
        }
      }
      for (let Se = 0; Se < W.length; Se++) {
        const xt = G[Se], Ht = W[Se];
        xt !== null && Ht !== void 0 && Ht.update(xt, me, d || u);
      }
      ze && ze(Me, me), me.detectedPlanes && o.dispatchEvent({ type: "planesdetected", data: me }), _ = null;
    }
    const Be = new WebGLAnimation();
    Be.setAnimationLoop(ke), this.setAnimationLoop = function(Me) {
      ze = Me;
    }, this.dispose = function() {
    };
  }
}
function WebGLMaterials(r, e) {
  function s(L, F) {
    L.matrixAutoUpdate === !0 && L.updateMatrix(), F.value.copy(L.matrix);
  }
  function o(L, F) {
    F.color.getRGB(L.fogColor.value, getUnlitUniformColorSpace(r)), F.isFog ? (L.fogNear.value = F.near, L.fogFar.value = F.far) : F.isFogExp2 && (L.fogDensity.value = F.density);
  }
  function a(L, F, W, G, q) {
    F.isMeshBasicMaterial || F.isMeshLambertMaterial ? l(L, F) : F.isMeshToonMaterial ? (l(L, F), h(L, F)) : F.isMeshPhongMaterial ? (l(L, F), f(L, F)) : F.isMeshStandardMaterial ? (l(L, F), S(L, F), F.isMeshPhysicalMaterial && R(L, F, q)) : F.isMeshMatcapMaterial ? (l(L, F), _(L, F)) : F.isMeshDepthMaterial ? l(L, F) : F.isMeshDistanceMaterial ? (l(L, F), m(L, F)) : F.isMeshNormalMaterial ? l(L, F) : F.isLineBasicMaterial ? (u(L, F), F.isLineDashedMaterial && c(L, F)) : F.isPointsMaterial ? E(L, F, W, G) : F.isSpriteMaterial ? d(L, F) : F.isShadowMaterial ? (L.color.value.copy(F.color), L.opacity.value = F.opacity) : F.isShaderMaterial && (F.uniformsNeedUpdate = !1);
  }
  function l(L, F) {
    L.opacity.value = F.opacity, F.color && L.diffuse.value.copy(F.color), F.emissive && L.emissive.value.copy(F.emissive).multiplyScalar(F.emissiveIntensity), F.map && (L.map.value = F.map, s(F.map, L.mapTransform)), F.alphaMap && (L.alphaMap.value = F.alphaMap, s(F.alphaMap, L.alphaMapTransform)), F.bumpMap && (L.bumpMap.value = F.bumpMap, s(F.bumpMap, L.bumpMapTransform), L.bumpScale.value = F.bumpScale, F.side === BackSide && (L.bumpScale.value *= -1)), F.normalMap && (L.normalMap.value = F.normalMap, s(F.normalMap, L.normalMapTransform), L.normalScale.value.copy(F.normalScale), F.side === BackSide && L.normalScale.value.negate()), F.displacementMap && (L.displacementMap.value = F.displacementMap, s(F.displacementMap, L.displacementMapTransform), L.displacementScale.value = F.displacementScale, L.displacementBias.value = F.displacementBias), F.emissiveMap && (L.emissiveMap.value = F.emissiveMap, s(F.emissiveMap, L.emissiveMapTransform)), F.specularMap && (L.specularMap.value = F.specularMap, s(F.specularMap, L.specularMapTransform)), F.alphaTest > 0 && (L.alphaTest.value = F.alphaTest);
    const W = e.get(F).envMap;
    if (W && (L.envMap.value = W, L.flipEnvMap.value = W.isCubeTexture && W.isRenderTargetTexture === !1 ? -1 : 1, L.reflectivity.value = F.reflectivity, L.ior.value = F.ior, L.refractionRatio.value = F.refractionRatio), F.lightMap) {
      L.lightMap.value = F.lightMap;
      const G = r.useLegacyLights === !0 ? Math.PI : 1;
      L.lightMapIntensity.value = F.lightMapIntensity * G, s(F.lightMap, L.lightMapTransform);
    }
    F.aoMap && (L.aoMap.value = F.aoMap, L.aoMapIntensity.value = F.aoMapIntensity, s(F.aoMap, L.aoMapTransform));
  }
  function u(L, F) {
    L.diffuse.value.copy(F.color), L.opacity.value = F.opacity, F.map && (L.map.value = F.map, s(F.map, L.mapTransform));
  }
  function c(L, F) {
    L.dashSize.value = F.dashSize, L.totalSize.value = F.dashSize + F.gapSize, L.scale.value = F.scale;
  }
  function E(L, F, W, G) {
    L.diffuse.value.copy(F.color), L.opacity.value = F.opacity, L.size.value = F.size * W, L.scale.value = G * 0.5, F.map && (L.map.value = F.map, s(F.map, L.uvTransform)), F.alphaMap && (L.alphaMap.value = F.alphaMap, s(F.alphaMap, L.alphaMapTransform)), F.alphaTest > 0 && (L.alphaTest.value = F.alphaTest);
  }
  function d(L, F) {
    L.diffuse.value.copy(F.color), L.opacity.value = F.opacity, L.rotation.value = F.rotation, F.map && (L.map.value = F.map, s(F.map, L.mapTransform)), F.alphaMap && (L.alphaMap.value = F.alphaMap, s(F.alphaMap, L.alphaMapTransform)), F.alphaTest > 0 && (L.alphaTest.value = F.alphaTest);
  }
  function f(L, F) {
    L.specular.value.copy(F.specular), L.shininess.value = Math.max(F.shininess, 1e-4);
  }
  function h(L, F) {
    F.gradientMap && (L.gradientMap.value = F.gradientMap);
  }
  function S(L, F) {
    L.metalness.value = F.metalness, F.metalnessMap && (L.metalnessMap.value = F.metalnessMap, s(F.metalnessMap, L.metalnessMapTransform)), L.roughness.value = F.roughness, F.roughnessMap && (L.roughnessMap.value = F.roughnessMap, s(F.roughnessMap, L.roughnessMapTransform)), e.get(F).envMap && (L.envMapIntensity.value = F.envMapIntensity);
  }
  function R(L, F, W) {
    L.ior.value = F.ior, F.sheen > 0 && (L.sheenColor.value.copy(F.sheenColor).multiplyScalar(F.sheen), L.sheenRoughness.value = F.sheenRoughness, F.sheenColorMap && (L.sheenColorMap.value = F.sheenColorMap, s(F.sheenColorMap, L.sheenColorMapTransform)), F.sheenRoughnessMap && (L.sheenRoughnessMap.value = F.sheenRoughnessMap, s(F.sheenRoughnessMap, L.sheenRoughnessMapTransform))), F.clearcoat > 0 && (L.clearcoat.value = F.clearcoat, L.clearcoatRoughness.value = F.clearcoatRoughness, F.clearcoatMap && (L.clearcoatMap.value = F.clearcoatMap, s(F.clearcoatMap, L.clearcoatMapTransform)), F.clearcoatRoughnessMap && (L.clearcoatRoughnessMap.value = F.clearcoatRoughnessMap, s(F.clearcoatRoughnessMap, L.clearcoatRoughnessMapTransform)), F.clearcoatNormalMap && (L.clearcoatNormalMap.value = F.clearcoatNormalMap, s(F.clearcoatNormalMap, L.clearcoatNormalMapTransform), L.clearcoatNormalScale.value.copy(F.clearcoatNormalScale), F.side === BackSide && L.clearcoatNormalScale.value.negate())), F.iridescence > 0 && (L.iridescence.value = F.iridescence, L.iridescenceIOR.value = F.iridescenceIOR, L.iridescenceThicknessMinimum.value = F.iridescenceThicknessRange[0], L.iridescenceThicknessMaximum.value = F.iridescenceThicknessRange[1], F.iridescenceMap && (L.iridescenceMap.value = F.iridescenceMap, s(F.iridescenceMap, L.iridescenceMapTransform)), F.iridescenceThicknessMap && (L.iridescenceThicknessMap.value = F.iridescenceThicknessMap, s(F.iridescenceThicknessMap, L.iridescenceThicknessMapTransform))), F.transmission > 0 && (L.transmission.value = F.transmission, L.transmissionSamplerMap.value = W.texture, L.transmissionSamplerSize.value.set(W.width, W.height), F.transmissionMap && (L.transmissionMap.value = F.transmissionMap, s(F.transmissionMap, L.transmissionMapTransform)), L.thickness.value = F.thickness, F.thicknessMap && (L.thicknessMap.value = F.thicknessMap, s(F.thicknessMap, L.thicknessMapTransform)), L.attenuationDistance.value = F.attenuationDistance, L.attenuationColor.value.copy(F.attenuationColor)), F.anisotropy > 0 && (L.anisotropyVector.value.set(F.anisotropy * Math.cos(F.anisotropyRotation), F.anisotropy * Math.sin(F.anisotropyRotation)), F.anisotropyMap && (L.anisotropyMap.value = F.anisotropyMap, s(F.anisotropyMap, L.anisotropyMapTransform))), L.specularIntensity.value = F.specularIntensity, L.specularColor.value.copy(F.specularColor), F.specularColorMap && (L.specularColorMap.value = F.specularColorMap, s(F.specularColorMap, L.specularColorMapTransform)), F.specularIntensityMap && (L.specularIntensityMap.value = F.specularIntensityMap, s(F.specularIntensityMap, L.specularIntensityMapTransform));
  }
  function _(L, F) {
    F.matcap && (L.matcap.value = F.matcap);
  }
  function m(L, F) {
    const W = e.get(F).light;
    L.referencePosition.value.setFromMatrixPosition(W.matrixWorld), L.nearDistance.value = W.shadow.camera.near, L.farDistance.value = W.shadow.camera.far;
  }
  return {
    refreshFogUniforms: o,
    refreshMaterialUniforms: a
  };
}
function WebGLUniformsGroups(r, e, s, o) {
  let a = {}, l = {}, u = [];
  const c = s.isWebGL2 ? r.getParameter(r.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  function E(W, G) {
    const q = G.program;
    o.uniformBlockBinding(W, q);
  }
  function d(W, G) {
    let q = a[W.id];
    q === void 0 && (_(W), q = f(W), a[W.id] = q, W.addEventListener("dispose", L));
    const fe = G.program;
    o.updateUBOMapping(W, fe);
    const _e = e.render.frame;
    l[W.id] !== _e && (S(W), l[W.id] = _e);
  }
  function f(W) {
    const G = h();
    W.__bindingPointIndex = G;
    const q = r.createBuffer(), fe = W.__size, _e = W.usage;
    return r.bindBuffer(r.UNIFORM_BUFFER, q), r.bufferData(r.UNIFORM_BUFFER, fe, _e), r.bindBuffer(r.UNIFORM_BUFFER, null), r.bindBufferBase(r.UNIFORM_BUFFER, G, q), q;
  }
  function h() {
    for (let W = 0; W < c; W++)
      if (u.indexOf(W) === -1)
        return u.push(W), W;
    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
  }
  function S(W) {
    const G = a[W.id], q = W.uniforms, fe = W.__cache;
    r.bindBuffer(r.UNIFORM_BUFFER, G);
    for (let _e = 0, Le = q.length; _e < Le; _e++) {
      const Fe = q[_e];
      if (R(Fe, _e, fe) === !0) {
        const Ee = Fe.__offset, Ge = Array.isArray(Fe.value) ? Fe.value : [Fe.value];
        let ve = 0;
        for (let te = 0; te < Ge.length; te++) {
          const ae = Ge[te], v = m(ae);
          typeof ae == "number" ? (Fe.__data[0] = ae, r.bufferSubData(r.UNIFORM_BUFFER, Ee + ve, Fe.__data)) : ae.isMatrix3 ? (Fe.__data[0] = ae.elements[0], Fe.__data[1] = ae.elements[1], Fe.__data[2] = ae.elements[2], Fe.__data[3] = ae.elements[0], Fe.__data[4] = ae.elements[3], Fe.__data[5] = ae.elements[4], Fe.__data[6] = ae.elements[5], Fe.__data[7] = ae.elements[0], Fe.__data[8] = ae.elements[6], Fe.__data[9] = ae.elements[7], Fe.__data[10] = ae.elements[8], Fe.__data[11] = ae.elements[0]) : (ae.toArray(Fe.__data, ve), ve += v.storage / Float32Array.BYTES_PER_ELEMENT);
        }
        r.bufferSubData(r.UNIFORM_BUFFER, Ee, Fe.__data);
      }
    }
    r.bindBuffer(r.UNIFORM_BUFFER, null);
  }
  function R(W, G, q) {
    const fe = W.value;
    if (q[G] === void 0) {
      if (typeof fe == "number")
        q[G] = fe;
      else {
        const _e = Array.isArray(fe) ? fe : [fe], Le = [];
        for (let Fe = 0; Fe < _e.length; Fe++)
          Le.push(_e[Fe].clone());
        q[G] = Le;
      }
      return !0;
    } else if (typeof fe == "number") {
      if (q[G] !== fe)
        return q[G] = fe, !0;
    } else {
      const _e = Array.isArray(q[G]) ? q[G] : [q[G]], Le = Array.isArray(fe) ? fe : [fe];
      for (let Fe = 0; Fe < _e.length; Fe++) {
        const Ee = _e[Fe];
        if (Ee.equals(Le[Fe]) === !1)
          return Ee.copy(Le[Fe]), !0;
      }
    }
    return !1;
  }
  function _(W) {
    const G = W.uniforms;
    let q = 0;
    const fe = 16;
    let _e = 0;
    for (let Le = 0, Fe = G.length; Le < Fe; Le++) {
      const Ee = G[Le], Ge = {
        boundary: 0,
        // bytes
        storage: 0
        // bytes
      }, ve = Array.isArray(Ee.value) ? Ee.value : [Ee.value];
      for (let te = 0, ae = ve.length; te < ae; te++) {
        const v = ve[te], Te = m(v);
        Ge.boundary += Te.boundary, Ge.storage += Te.storage;
      }
      if (Ee.__data = new Float32Array(Ge.storage / Float32Array.BYTES_PER_ELEMENT), Ee.__offset = q, Le > 0) {
        _e = q % fe;
        const te = fe - _e;
        _e !== 0 && te - Ge.boundary < 0 && (q += fe - _e, Ee.__offset = q);
      }
      q += Ge.storage;
    }
    return _e = q % fe, _e > 0 && (q += fe - _e), W.__size = q, W.__cache = {}, this;
  }
  function m(W) {
    const G = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    return typeof W == "number" ? (G.boundary = 4, G.storage = 4) : W.isVector2 ? (G.boundary = 8, G.storage = 8) : W.isVector3 || W.isColor ? (G.boundary = 16, G.storage = 12) : W.isVector4 ? (G.boundary = 16, G.storage = 16) : W.isMatrix3 ? (G.boundary = 48, G.storage = 48) : W.isMatrix4 ? (G.boundary = 64, G.storage = 64) : W.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", W), G;
  }
  function L(W) {
    const G = W.target;
    G.removeEventListener("dispose", L);
    const q = u.indexOf(G.__bindingPointIndex);
    u.splice(q, 1), r.deleteBuffer(a[G.id]), delete a[G.id], delete l[G.id];
  }
  function F() {
    for (const W in a)
      r.deleteBuffer(a[W]);
    u = [], a = {}, l = {};
  }
  return {
    bind: E,
    update: d,
    dispose: F
  };
}
function createCanvasElement() {
  const r = createElementNS("canvas");
  return r.style.display = "block", r;
}
class WebGLRenderer {
  constructor(e = {}) {
    const {
      canvas: s = createCanvasElement(),
      context: o = null,
      depth: a = !0,
      stencil: l = !0,
      alpha: u = !1,
      antialias: c = !1,
      premultipliedAlpha: E = !0,
      preserveDrawingBuffer: d = !1,
      powerPreference: f = "default",
      failIfMajorPerformanceCaveat: h = !1
    } = e;
    this.isWebGLRenderer = !0;
    let S;
    o !== null ? S = o.getContextAttributes().alpha : S = u;
    const R = new Uint32Array(4), _ = new Int32Array(4);
    let m = null, L = null;
    const F = [], W = [];
    this.domElement = s, this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled
       * @type {boolean}
       */
      checkShaderErrors: !0,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputColorSpace = SRGBColorSpace, this.useLegacyLights = !0, this.toneMapping = NoToneMapping, this.toneMappingExposure = 1;
    const G = this;
    let q = !1, fe = 0, _e = 0, Le = null, Fe = -1, Ee = null;
    const Ge = new Vector4(), ve = new Vector4();
    let te = null;
    const ae = new Color(0);
    let v = 0, Te = s.width, De = s.height, be = 1, ze = null, ke = null;
    const Be = new Vector4(0, 0, Te, De), Me = new Vector4(0, 0, Te, De);
    let me = !1;
    const Se = new Frustum();
    let xt = !1, Ht = !1, Bt = null;
    const ut = new Matrix4(), Tt = new Vector2(), Yt = new Vector3$1(), an = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
    function Ct() {
      return Le === null ? be : 1;
    }
    let st = o;
    function jt(En, qn) {
      for (let Wn = 0; Wn < En.length; Wn++) {
        const kn = En[Wn], zn = s.getContext(kn, qn);
        if (zn !== null)
          return zn;
      }
      return null;
    }
    try {
      const En = {
        alpha: !0,
        depth: a,
        stencil: l,
        antialias: c,
        premultipliedAlpha: E,
        preserveDrawingBuffer: d,
        powerPreference: f,
        failIfMajorPerformanceCaveat: h
      };
      if ("setAttribute" in s && s.setAttribute("data-engine", `three.js r${REVISION$1}`), s.addEventListener("webglcontextlost", Jn, !1), s.addEventListener("webglcontextrestored", Xn, !1), s.addEventListener("webglcontextcreationerror", rr, !1), st === null) {
        const qn = ["webgl2", "webgl", "experimental-webgl"];
        if (G.isWebGL1Renderer === !0 && qn.shift(), st = jt(qn, En), st === null)
          throw jt(qn) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
      }
      typeof WebGLRenderingContext < "u" && st instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), st.getShaderPrecisionFormat === void 0 && (st.getShaderPrecisionFormat = function() {
        return { rangeMin: 1, rangeMax: 1, precision: 1 };
      });
    } catch (En) {
      throw console.error("THREE.WebGLRenderer: " + En.message), En;
    }
    let lt, Zt, Et, Ke, $e, pt, Jt, In, Cn, It, ht, Wt, hn, Vt, Tn, Rn, Nn, Dn, xn, $n, Kn, ir, er, br;
    function cs() {
      lt = new WebGLExtensions(st), Zt = new WebGLCapabilities(st, lt, e), lt.init(Zt), ir = new WebGLUtils(st, lt, Zt), Et = new WebGLState(st, lt, Zt), Ke = new WebGLInfo(st), $e = new WebGLProperties(), pt = new WebGLTextures(st, lt, Et, $e, Zt, ir, Ke), Jt = new WebGLCubeMaps(G), In = new WebGLCubeUVMaps(G), Cn = new WebGLAttributes(st, Zt), er = new WebGLBindingStates(st, lt, Cn, Zt), It = new WebGLGeometries(st, Cn, Ke, er), ht = new WebGLObjects(st, It, Cn, Ke), xn = new WebGLMorphtargets(st, Zt, pt), Rn = new WebGLClipping($e), Wt = new WebGLPrograms(G, Jt, In, lt, Zt, er, Rn), hn = new WebGLMaterials(G, $e), Vt = new WebGLRenderLists(), Tn = new WebGLRenderStates(lt, Zt), Dn = new WebGLBackground(G, Jt, In, Et, ht, S, E), Nn = new WebGLShadowMap(G, ht, Zt), br = new WebGLUniformsGroups(st, Ke, Zt, Et), $n = new WebGLBufferRenderer(st, lt, Ke, Zt), Kn = new WebGLIndexedBufferRenderer(st, lt, Ke, Zt), Ke.programs = Wt.programs, G.capabilities = Zt, G.extensions = lt, G.properties = $e, G.renderLists = Vt, G.shadowMap = Nn, G.state = Et, G.info = Ke;
    }
    cs();
    const Gn = new WebXRManager(G, st);
    this.xr = Gn, this.getContext = function() {
      return st;
    }, this.getContextAttributes = function() {
      return st.getContextAttributes();
    }, this.forceContextLoss = function() {
      const En = lt.get("WEBGL_lose_context");
      En && En.loseContext();
    }, this.forceContextRestore = function() {
      const En = lt.get("WEBGL_lose_context");
      En && En.restoreContext();
    }, this.getPixelRatio = function() {
      return be;
    }, this.setPixelRatio = function(En) {
      En !== void 0 && (be = En, this.setSize(Te, De, !1));
    }, this.getSize = function(En) {
      return En.set(Te, De);
    }, this.setSize = function(En, qn, Wn = !0) {
      if (Gn.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      Te = En, De = qn, s.width = Math.floor(En * be), s.height = Math.floor(qn * be), Wn === !0 && (s.style.width = En + "px", s.style.height = qn + "px"), this.setViewport(0, 0, En, qn);
    }, this.getDrawingBufferSize = function(En) {
      return En.set(Te * be, De * be).floor();
    }, this.setDrawingBufferSize = function(En, qn, Wn) {
      Te = En, De = qn, be = Wn, s.width = Math.floor(En * Wn), s.height = Math.floor(qn * Wn), this.setViewport(0, 0, En, qn);
    }, this.getCurrentViewport = function(En) {
      return En.copy(Ge);
    }, this.getViewport = function(En) {
      return En.copy(Be);
    }, this.setViewport = function(En, qn, Wn, kn) {
      En.isVector4 ? Be.set(En.x, En.y, En.z, En.w) : Be.set(En, qn, Wn, kn), Et.viewport(Ge.copy(Be).multiplyScalar(be).floor());
    }, this.getScissor = function(En) {
      return En.copy(Me);
    }, this.setScissor = function(En, qn, Wn, kn) {
      En.isVector4 ? Me.set(En.x, En.y, En.z, En.w) : Me.set(En, qn, Wn, kn), Et.scissor(ve.copy(Me).multiplyScalar(be).floor());
    }, this.getScissorTest = function() {
      return me;
    }, this.setScissorTest = function(En) {
      Et.setScissorTest(me = En);
    }, this.setOpaqueSort = function(En) {
      ze = En;
    }, this.setTransparentSort = function(En) {
      ke = En;
    }, this.getClearColor = function(En) {
      return En.copy(Dn.getClearColor());
    }, this.setClearColor = function() {
      Dn.setClearColor.apply(Dn, arguments);
    }, this.getClearAlpha = function() {
      return Dn.getClearAlpha();
    }, this.setClearAlpha = function() {
      Dn.setClearAlpha.apply(Dn, arguments);
    }, this.clear = function(En = !0, qn = !0, Wn = !0) {
      let kn = 0;
      if (En) {
        let zn = !1;
        if (Le !== null) {
          const wr = Le.texture.format;
          zn = wr === RGBAIntegerFormat || wr === RGIntegerFormat || wr === RedIntegerFormat;
        }
        if (zn) {
          const wr = Le.texture.type, jr = wr === UnsignedByteType || wr === UnsignedIntType || wr === UnsignedShortType || wr === UnsignedInt248Type || wr === UnsignedShort4444Type || wr === UnsignedShort5551Type, Vr = Dn.getClearColor(), us = Dn.getClearAlpha(), Es = Vr.r, Dr = Vr.g, Kr = Vr.b;
          jr ? (R[0] = Es, R[1] = Dr, R[2] = Kr, R[3] = us, st.clearBufferuiv(st.COLOR, 0, R)) : (_[0] = Es, _[1] = Dr, _[2] = Kr, _[3] = us, st.clearBufferiv(st.COLOR, 0, _));
        } else
          kn |= st.COLOR_BUFFER_BIT;
      }
      qn && (kn |= st.DEPTH_BUFFER_BIT), Wn && (kn |= st.STENCIL_BUFFER_BIT), st.clear(kn);
    }, this.clearColor = function() {
      this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
      this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
      this.clear(!1, !1, !0);
    }, this.dispose = function() {
      s.removeEventListener("webglcontextlost", Jn, !1), s.removeEventListener("webglcontextrestored", Xn, !1), s.removeEventListener("webglcontextcreationerror", rr, !1), Vt.dispose(), Tn.dispose(), $e.dispose(), Jt.dispose(), In.dispose(), ht.dispose(), er.dispose(), br.dispose(), Wt.dispose(), Gn.dispose(), Gn.removeEventListener("sessionstart", Ur), Gn.removeEventListener("sessionend", Qr), Bt && (Bt.dispose(), Bt = null), Fr.stop();
    };
    function Jn(En) {
      En.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), q = !0;
    }
    function Xn() {
      console.log("THREE.WebGLRenderer: Context Restored."), q = !1;
      const En = Ke.autoReset, qn = Nn.enabled, Wn = Nn.autoUpdate, kn = Nn.needsUpdate, zn = Nn.type;
      cs(), Ke.autoReset = En, Nn.enabled = qn, Nn.autoUpdate = Wn, Nn.needsUpdate = kn, Nn.type = zn;
    }
    function rr(En) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", En.statusMessage);
    }
    function _r(En) {
      const qn = En.target;
      qn.removeEventListener("dispose", _r), Ss(qn);
    }
    function Ss(En) {
      is(En), $e.remove(En);
    }
    function is(En) {
      const qn = $e.get(En).programs;
      qn !== void 0 && (qn.forEach(function(Wn) {
        Wt.releaseProgram(Wn);
      }), En.isShaderMaterial && Wt.releaseShaderCache(En));
    }
    this.renderBufferDirect = function(En, qn, Wn, kn, zn, wr) {
      qn === null && (qn = an);
      const jr = zn.isMesh && zn.matrixWorld.determinant() < 0, Vr = jn(En, qn, Wn, kn, zn);
      Et.setMaterial(kn, jr);
      let us = Wn.index, Es = 1;
      kn.wireframe === !0 && (us = It.getWireframeAttribute(Wn), Es = 2);
      const Dr = Wn.drawRange, Kr = Wn.attributes.position;
      let Js = Dr.start * Es, io = (Dr.start + Dr.count) * Es;
      wr !== null && (Js = Math.max(Js, wr.start * Es), io = Math.min(io, (wr.start + wr.count) * Es)), us !== null ? (Js = Math.max(Js, 0), io = Math.min(io, us.count)) : Kr != null && (Js = Math.max(Js, 0), io = Math.min(io, Kr.count));
      const No = io - Js;
      if (No < 0 || No === 1 / 0)
        return;
      er.setup(zn, kn, Vr, Wn, us);
      let Ai, go = $n;
      if (us !== null && (Ai = Cn.get(us), go = Kn, go.setIndex(Ai)), zn.isMesh)
        kn.wireframe === !0 ? (Et.setLineWidth(kn.wireframeLinewidth * Ct()), go.setMode(st.LINES)) : go.setMode(st.TRIANGLES);
      else if (zn.isLine) {
        let ks = kn.linewidth;
        ks === void 0 && (ks = 1), Et.setLineWidth(ks * Ct()), zn.isLineSegments ? go.setMode(st.LINES) : zn.isLineLoop ? go.setMode(st.LINE_LOOP) : go.setMode(st.LINE_STRIP);
      } else
        zn.isPoints ? go.setMode(st.POINTS) : zn.isSprite && go.setMode(st.TRIANGLES);
      if (zn.isInstancedMesh)
        go.renderInstances(Js, No, zn.count);
      else if (Wn.isInstancedBufferGeometry) {
        const ks = Wn._maxInstanceCount !== void 0 ? Wn._maxInstanceCount : 1 / 0, Ci = Math.min(Wn.instanceCount, ks);
        go.renderInstances(Js, No, Ci);
      } else
        go.render(Js, No);
    }, this.compile = function(En, qn) {
      function Wn(kn, zn, wr) {
        kn.transparent === !0 && kn.side === DoubleSide && kn.forceSinglePass === !1 ? (kn.side = BackSide, kn.needsUpdate = !0, to(kn, zn, wr), kn.side = FrontSide, kn.needsUpdate = !0, to(kn, zn, wr), kn.side = DoubleSide) : to(kn, zn, wr);
      }
      L = Tn.get(En), L.init(), W.push(L), En.traverseVisible(function(kn) {
        kn.isLight && kn.layers.test(qn.layers) && (L.pushLight(kn), kn.castShadow && L.pushShadow(kn));
      }), L.setupLights(G.useLegacyLights), En.traverse(function(kn) {
        const zn = kn.material;
        if (zn)
          if (Array.isArray(zn))
            for (let wr = 0; wr < zn.length; wr++) {
              const jr = zn[wr];
              Wn(jr, En, kn);
            }
          else
            Wn(zn, En, kn);
      }), W.pop(), L = null;
    };
    let Ms = null;
    function ls(En) {
      Ms && Ms(En);
    }
    function Ur() {
      Fr.stop();
    }
    function Qr() {
      Fr.start();
    }
    const Fr = new WebGLAnimation();
    Fr.setAnimationLoop(ls), typeof self < "u" && Fr.setContext(self), this.setAnimationLoop = function(En) {
      Ms = En, Gn.setAnimationLoop(En), En === null ? Fr.stop() : Fr.start();
    }, Gn.addEventListener("sessionstart", Ur), Gn.addEventListener("sessionend", Qr), this.render = function(En, qn) {
      if (qn !== void 0 && qn.isCamera !== !0) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (q === !0)
        return;
      En.matrixWorldAutoUpdate === !0 && En.updateMatrixWorld(), qn.parent === null && qn.matrixWorldAutoUpdate === !0 && qn.updateMatrixWorld(), Gn.enabled === !0 && Gn.isPresenting === !0 && (Gn.cameraAutoUpdate === !0 && Gn.updateCamera(qn), qn = Gn.getCamera()), En.isScene === !0 && En.onBeforeRender(G, En, qn, Le), L = Tn.get(En, W.length), L.init(), W.push(L), ut.multiplyMatrices(qn.projectionMatrix, qn.matrixWorldInverse), Se.setFromProjectionMatrix(ut), Ht = this.localClippingEnabled, xt = Rn.init(this.clippingPlanes, Ht), m = Vt.get(En, F.length), m.init(), F.push(m), Lr(En, qn, 0, G.sortObjects), m.finish(), G.sortObjects === !0 && m.sort(ze, ke), this.info.render.frame++, xt === !0 && Rn.beginShadows();
      const Wn = L.state.shadowsArray;
      if (Nn.render(Wn, En, qn), xt === !0 && Rn.endShadows(), this.info.autoReset === !0 && this.info.reset(), Dn.render(m, En), L.setupLights(G.useLegacyLights), qn.isArrayCamera) {
        const kn = qn.cameras;
        for (let zn = 0, wr = kn.length; zn < wr; zn++) {
          const jr = kn[zn];
          Hr(m, En, jr, jr.viewport);
        }
      } else
        Hr(m, En, qn);
      Le !== null && (pt.updateMultisampleRenderTarget(Le), pt.updateRenderTargetMipmap(Le)), En.isScene === !0 && En.onAfterRender(G, En, qn), er.resetDefaultState(), Fe = -1, Ee = null, W.pop(), W.length > 0 ? L = W[W.length - 1] : L = null, F.pop(), F.length > 0 ? m = F[F.length - 1] : m = null;
    };
    function Lr(En, qn, Wn, kn) {
      if (En.visible === !1)
        return;
      if (En.layers.test(qn.layers)) {
        if (En.isGroup)
          Wn = En.renderOrder;
        else if (En.isLOD)
          En.autoUpdate === !0 && En.update(qn);
        else if (En.isLight)
          L.pushLight(En), En.castShadow && L.pushShadow(En);
        else if (En.isSprite) {
          if (!En.frustumCulled || Se.intersectsSprite(En)) {
            kn && Yt.setFromMatrixPosition(En.matrixWorld).applyMatrix4(ut);
            const jr = ht.update(En), Vr = En.material;
            Vr.visible && m.push(En, jr, Vr, Wn, Yt.z, null);
          }
        } else if ((En.isMesh || En.isLine || En.isPoints) && (!En.frustumCulled || Se.intersectsObject(En))) {
          const jr = ht.update(En), Vr = En.material;
          if (kn && (En.boundingSphere !== void 0 ? (En.boundingSphere === null && En.computeBoundingSphere(), Yt.copy(En.boundingSphere.center)) : (jr.boundingSphere === null && jr.computeBoundingSphere(), Yt.copy(jr.boundingSphere.center)), Yt.applyMatrix4(En.matrixWorld).applyMatrix4(ut)), Array.isArray(Vr)) {
            const us = jr.groups;
            for (let Es = 0, Dr = us.length; Es < Dr; Es++) {
              const Kr = us[Es], Js = Vr[Kr.materialIndex];
              Js && Js.visible && m.push(En, jr, Js, Wn, Yt.z, Kr);
            }
          } else
            Vr.visible && m.push(En, jr, Vr, Wn, Yt.z, null);
        }
      }
      const wr = En.children;
      for (let jr = 0, Vr = wr.length; jr < Vr; jr++)
        Lr(wr[jr], qn, Wn, kn);
    }
    function Hr(En, qn, Wn, kn) {
      const zn = En.opaque, wr = En.transmissive, jr = En.transparent;
      L.setupLightsView(Wn), xt === !0 && Rn.setGlobalState(G.clippingPlanes, Wn), wr.length > 0 && ns(zn, wr, qn, Wn), kn && Et.viewport(Ge.copy(kn)), zn.length > 0 && Ts(zn, qn, Wn), wr.length > 0 && Ts(wr, qn, Wn), jr.length > 0 && Ts(jr, qn, Wn), Et.buffers.depth.setTest(!0), Et.buffers.depth.setMask(!0), Et.buffers.color.setMask(!0), Et.setPolygonOffset(!1);
    }
    function ns(En, qn, Wn, kn) {
      const zn = Zt.isWebGL2;
      Bt === null && (Bt = new WebGLRenderTarget(1, 1, {
        generateMipmaps: !0,
        type: lt.has("EXT_color_buffer_half_float") ? HalfFloatType : UnsignedByteType,
        minFilter: LinearMipmapLinearFilter,
        samples: zn ? 4 : 0
      })), G.getDrawingBufferSize(Tt), zn ? Bt.setSize(Tt.x, Tt.y) : Bt.setSize(floorPowerOfTwo(Tt.x), floorPowerOfTwo(Tt.y));
      const wr = G.getRenderTarget();
      G.setRenderTarget(Bt), G.getClearColor(ae), v = G.getClearAlpha(), v < 1 && G.setClearColor(16777215, 0.5), G.clear();
      const jr = G.toneMapping;
      G.toneMapping = NoToneMapping, Ts(En, Wn, kn), pt.updateMultisampleRenderTarget(Bt), pt.updateRenderTargetMipmap(Bt);
      let Vr = !1;
      for (let us = 0, Es = qn.length; us < Es; us++) {
        const Dr = qn[us], Kr = Dr.object, Js = Dr.geometry, io = Dr.material, No = Dr.group;
        if (io.side === DoubleSide && Kr.layers.test(kn.layers)) {
          const Ai = io.side;
          io.side = BackSide, io.needsUpdate = !0, en(Kr, Wn, kn, Js, io, No), io.side = Ai, io.needsUpdate = !0, Vr = !0;
        }
      }
      Vr === !0 && (pt.updateMultisampleRenderTarget(Bt), pt.updateRenderTargetMipmap(Bt)), G.setRenderTarget(wr), G.setClearColor(ae, v), G.toneMapping = jr;
    }
    function Ts(En, qn, Wn) {
      const kn = qn.isScene === !0 ? qn.overrideMaterial : null;
      for (let zn = 0, wr = En.length; zn < wr; zn++) {
        const jr = En[zn], Vr = jr.object, us = jr.geometry, Es = kn === null ? jr.material : kn, Dr = jr.group;
        Vr.layers.test(Wn.layers) && en(Vr, qn, Wn, us, Es, Dr);
      }
    }
    function en(En, qn, Wn, kn, zn, wr) {
      En.onBeforeRender(G, qn, Wn, kn, zn, wr), En.modelViewMatrix.multiplyMatrices(Wn.matrixWorldInverse, En.matrixWorld), En.normalMatrix.getNormalMatrix(En.modelViewMatrix), zn.onBeforeRender(G, qn, Wn, kn, En, wr), zn.transparent === !0 && zn.side === DoubleSide && zn.forceSinglePass === !1 ? (zn.side = BackSide, zn.needsUpdate = !0, G.renderBufferDirect(Wn, qn, kn, zn, En, wr), zn.side = FrontSide, zn.needsUpdate = !0, G.renderBufferDirect(Wn, qn, kn, zn, En, wr), zn.side = DoubleSide) : G.renderBufferDirect(Wn, qn, kn, zn, En, wr), En.onAfterRender(G, qn, Wn, kn, zn, wr);
    }
    function to(En, qn, Wn) {
      qn.isScene !== !0 && (qn = an);
      const kn = $e.get(En), zn = L.state.lights, wr = L.state.shadowsArray, jr = zn.state.version, Vr = Wt.getParameters(En, zn.state, wr, qn, Wn), us = Wt.getProgramCacheKey(Vr);
      let Es = kn.programs;
      kn.environment = En.isMeshStandardMaterial ? qn.environment : null, kn.fog = qn.fog, kn.envMap = (En.isMeshStandardMaterial ? In : Jt).get(En.envMap || kn.environment), Es === void 0 && (En.addEventListener("dispose", _r), Es = /* @__PURE__ */ new Map(), kn.programs = Es);
      let Dr = Es.get(us);
      if (Dr !== void 0) {
        if (kn.currentProgram === Dr && kn.lightsStateVersion === jr)
          return bs(En, Vr), Dr;
      } else
        Vr.uniforms = Wt.getUniforms(En), En.onBuild(Wn, Vr, G), En.onBeforeCompile(Vr, G), Dr = Wt.acquireProgram(Vr, us), Es.set(us, Dr), kn.uniforms = Vr.uniforms;
      const Kr = kn.uniforms;
      (!En.isShaderMaterial && !En.isRawShaderMaterial || En.clipping === !0) && (Kr.clippingPlanes = Rn.uniform), bs(En, Vr), kn.needsLights = pr(En), kn.lightsStateVersion = jr, kn.needsLights && (Kr.ambientLightColor.value = zn.state.ambient, Kr.lightProbe.value = zn.state.probe, Kr.directionalLights.value = zn.state.directional, Kr.directionalLightShadows.value = zn.state.directionalShadow, Kr.spotLights.value = zn.state.spot, Kr.spotLightShadows.value = zn.state.spotShadow, Kr.rectAreaLights.value = zn.state.rectArea, Kr.ltc_1.value = zn.state.rectAreaLTC1, Kr.ltc_2.value = zn.state.rectAreaLTC2, Kr.pointLights.value = zn.state.point, Kr.pointLightShadows.value = zn.state.pointShadow, Kr.hemisphereLights.value = zn.state.hemi, Kr.directionalShadowMap.value = zn.state.directionalShadowMap, Kr.directionalShadowMatrix.value = zn.state.directionalShadowMatrix, Kr.spotShadowMap.value = zn.state.spotShadowMap, Kr.spotLightMatrix.value = zn.state.spotLightMatrix, Kr.spotLightMap.value = zn.state.spotLightMap, Kr.pointShadowMap.value = zn.state.pointShadowMap, Kr.pointShadowMatrix.value = zn.state.pointShadowMatrix);
      const Js = Dr.getUniforms(), io = WebGLUniforms.seqWithValue(Js.seq, Kr);
      return kn.currentProgram = Dr, kn.uniformsList = io, Dr;
    }
    function bs(En, qn) {
      const Wn = $e.get(En);
      Wn.outputColorSpace = qn.outputColorSpace, Wn.instancing = qn.instancing, Wn.skinning = qn.skinning, Wn.morphTargets = qn.morphTargets, Wn.morphNormals = qn.morphNormals, Wn.morphColors = qn.morphColors, Wn.morphTargetsCount = qn.morphTargetsCount, Wn.numClippingPlanes = qn.numClippingPlanes, Wn.numIntersection = qn.numClipIntersection, Wn.vertexAlphas = qn.vertexAlphas, Wn.vertexTangents = qn.vertexTangents, Wn.toneMapping = qn.toneMapping;
    }
    function jn(En, qn, Wn, kn, zn) {
      qn.isScene !== !0 && (qn = an), pt.resetTextureUnits();
      const wr = qn.fog, jr = kn.isMeshStandardMaterial ? qn.environment : null, Vr = Le === null ? G.outputColorSpace : Le.isXRRenderTarget === !0 ? Le.texture.colorSpace : LinearSRGBColorSpace, us = (kn.isMeshStandardMaterial ? In : Jt).get(kn.envMap || jr), Es = kn.vertexColors === !0 && !!Wn.attributes.color && Wn.attributes.color.itemSize === 4, Dr = !!Wn.attributes.tangent && (!!kn.normalMap || kn.anisotropy > 0), Kr = !!Wn.morphAttributes.position, Js = !!Wn.morphAttributes.normal, io = !!Wn.morphAttributes.color, No = kn.toneMapped ? G.toneMapping : NoToneMapping, Ai = Wn.morphAttributes.position || Wn.morphAttributes.normal || Wn.morphAttributes.color, go = Ai !== void 0 ? Ai.length : 0, ks = $e.get(kn), Ci = L.state.lights;
      if (xt === !0 && (Ht === !0 || En !== Ee)) {
        const Ut = En === Ee && kn.id === Fe;
        Rn.setState(kn, En, Ut);
      }
      let Io = !1;
      kn.version === ks.__version ? (ks.needsLights && ks.lightsStateVersion !== Ci.state.version || ks.outputColorSpace !== Vr || zn.isInstancedMesh && ks.instancing === !1 || !zn.isInstancedMesh && ks.instancing === !0 || zn.isSkinnedMesh && ks.skinning === !1 || !zn.isSkinnedMesh && ks.skinning === !0 || ks.envMap !== us || kn.fog === !0 && ks.fog !== wr || ks.numClippingPlanes !== void 0 && (ks.numClippingPlanes !== Rn.numPlanes || ks.numIntersection !== Rn.numIntersection) || ks.vertexAlphas !== Es || ks.vertexTangents !== Dr || ks.morphTargets !== Kr || ks.morphNormals !== Js || ks.morphColors !== io || ks.toneMapping !== No || Zt.isWebGL2 === !0 && ks.morphTargetsCount !== go) && (Io = !0) : (Io = !0, ks.__version = kn.version);
      let Oo = ks.currentProgram;
      Io === !0 && (Oo = to(kn, qn, zn));
      let Zs = !1, wt = !1, _t = !1;
      const Ve = Oo.getUniforms(), Ze = ks.uniforms;
      if (Et.useProgram(Oo.program) && (Zs = !0, wt = !0, _t = !0), kn.id !== Fe && (Fe = kn.id, wt = !0), Zs || Ee !== En) {
        if (Ve.setValue(st, "projectionMatrix", En.projectionMatrix), Zt.logarithmicDepthBuffer && Ve.setValue(
          st,
          "logDepthBufFC",
          2 / (Math.log(En.far + 1) / Math.LN2)
        ), Ee !== En && (Ee = En, wt = !0, _t = !0), kn.isShaderMaterial || kn.isMeshPhongMaterial || kn.isMeshToonMaterial || kn.isMeshStandardMaterial || kn.envMap) {
          const Ut = Ve.map.cameraPosition;
          Ut !== void 0 && Ut.setValue(
            st,
            Yt.setFromMatrixPosition(En.matrixWorld)
          );
        }
        (kn.isMeshPhongMaterial || kn.isMeshToonMaterial || kn.isMeshLambertMaterial || kn.isMeshBasicMaterial || kn.isMeshStandardMaterial || kn.isShaderMaterial) && Ve.setValue(st, "isOrthographic", En.isOrthographicCamera === !0), (kn.isMeshPhongMaterial || kn.isMeshToonMaterial || kn.isMeshLambertMaterial || kn.isMeshBasicMaterial || kn.isMeshStandardMaterial || kn.isShaderMaterial || kn.isShadowMaterial || zn.isSkinnedMesh) && Ve.setValue(st, "viewMatrix", En.matrixWorldInverse);
      }
      if (zn.isSkinnedMesh) {
        Ve.setOptional(st, zn, "bindMatrix"), Ve.setOptional(st, zn, "bindMatrixInverse");
        const Ut = zn.skeleton;
        Ut && (Zt.floatVertexTextures ? (Ut.boneTexture === null && Ut.computeBoneTexture(), Ve.setValue(st, "boneTexture", Ut.boneTexture, pt), Ve.setValue(st, "boneTextureSize", Ut.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
      }
      const bt = Wn.morphAttributes;
      if ((bt.position !== void 0 || bt.normal !== void 0 || bt.color !== void 0 && Zt.isWebGL2 === !0) && xn.update(zn, Wn, Oo), (wt || ks.receiveShadow !== zn.receiveShadow) && (ks.receiveShadow = zn.receiveShadow, Ve.setValue(st, "receiveShadow", zn.receiveShadow)), kn.isMeshGouraudMaterial && kn.envMap !== null && (Ze.envMap.value = us, Ze.flipEnvMap.value = us.isCubeTexture && us.isRenderTargetTexture === !1 ? -1 : 1), wt && (Ve.setValue(st, "toneMappingExposure", G.toneMappingExposure), ks.needsLights && lr(Ze, _t), wr && kn.fog === !0 && hn.refreshFogUniforms(Ze, wr), hn.refreshMaterialUniforms(Ze, kn, be, De, Bt), WebGLUniforms.upload(st, ks.uniformsList, Ze, pt)), kn.isShaderMaterial && kn.uniformsNeedUpdate === !0 && (WebGLUniforms.upload(st, ks.uniformsList, Ze, pt), kn.uniformsNeedUpdate = !1), kn.isSpriteMaterial && Ve.setValue(st, "center", zn.center), Ve.setValue(st, "modelViewMatrix", zn.modelViewMatrix), Ve.setValue(st, "normalMatrix", zn.normalMatrix), Ve.setValue(st, "modelMatrix", zn.matrixWorld), kn.isShaderMaterial || kn.isRawShaderMaterial) {
        const Ut = kn.uniformsGroups;
        for (let mn = 0, nn = Ut.length; mn < nn; mn++)
          if (Zt.isWebGL2) {
            const Sn = Ut[mn];
            br.update(Sn, Oo), br.bind(Sn, Oo);
          } else
            console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
      }
      return Oo;
    }
    function lr(En, qn) {
      En.ambientLightColor.needsUpdate = qn, En.lightProbe.needsUpdate = qn, En.directionalLights.needsUpdate = qn, En.directionalLightShadows.needsUpdate = qn, En.pointLights.needsUpdate = qn, En.pointLightShadows.needsUpdate = qn, En.spotLights.needsUpdate = qn, En.spotLightShadows.needsUpdate = qn, En.rectAreaLights.needsUpdate = qn, En.hemisphereLights.needsUpdate = qn;
    }
    function pr(En) {
      return En.isMeshLambertMaterial || En.isMeshToonMaterial || En.isMeshPhongMaterial || En.isMeshStandardMaterial || En.isShadowMaterial || En.isShaderMaterial && En.lights === !0;
    }
    this.getActiveCubeFace = function() {
      return fe;
    }, this.getActiveMipmapLevel = function() {
      return _e;
    }, this.getRenderTarget = function() {
      return Le;
    }, this.setRenderTargetTextures = function(En, qn, Wn) {
      $e.get(En.texture).__webglTexture = qn, $e.get(En.depthTexture).__webglTexture = Wn;
      const kn = $e.get(En);
      kn.__hasExternalTextures = !0, kn.__hasExternalTextures && (kn.__autoAllocateDepthBuffer = Wn === void 0, kn.__autoAllocateDepthBuffer || lt.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), kn.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(En, qn) {
      const Wn = $e.get(En);
      Wn.__webglFramebuffer = qn, Wn.__useDefaultFramebuffer = qn === void 0;
    }, this.setRenderTarget = function(En, qn = 0, Wn = 0) {
      Le = En, fe = qn, _e = Wn;
      let kn = !0, zn = null, wr = !1, jr = !1;
      if (En) {
        const us = $e.get(En);
        us.__useDefaultFramebuffer !== void 0 ? (Et.bindFramebuffer(st.FRAMEBUFFER, null), kn = !1) : us.__webglFramebuffer === void 0 ? pt.setupRenderTarget(En) : us.__hasExternalTextures && pt.rebindTextures(En, $e.get(En.texture).__webglTexture, $e.get(En.depthTexture).__webglTexture);
        const Es = En.texture;
        (Es.isData3DTexture || Es.isDataArrayTexture || Es.isCompressedArrayTexture) && (jr = !0);
        const Dr = $e.get(En).__webglFramebuffer;
        En.isWebGLCubeRenderTarget ? (zn = Dr[qn], wr = !0) : Zt.isWebGL2 && En.samples > 0 && pt.useMultisampledRTT(En) === !1 ? zn = $e.get(En).__webglMultisampledFramebuffer : zn = Dr, Ge.copy(En.viewport), ve.copy(En.scissor), te = En.scissorTest;
      } else
        Ge.copy(Be).multiplyScalar(be).floor(), ve.copy(Me).multiplyScalar(be).floor(), te = me;
      if (Et.bindFramebuffer(st.FRAMEBUFFER, zn) && Zt.drawBuffers && kn && Et.drawBuffers(En, zn), Et.viewport(Ge), Et.scissor(ve), Et.setScissorTest(te), wr) {
        const us = $e.get(En.texture);
        st.framebufferTexture2D(st.FRAMEBUFFER, st.COLOR_ATTACHMENT0, st.TEXTURE_CUBE_MAP_POSITIVE_X + qn, us.__webglTexture, Wn);
      } else if (jr) {
        const us = $e.get(En.texture), Es = qn || 0;
        st.framebufferTextureLayer(st.FRAMEBUFFER, st.COLOR_ATTACHMENT0, us.__webglTexture, Wn || 0, Es);
      }
      Fe = -1;
    }, this.readRenderTargetPixels = function(En, qn, Wn, kn, zn, wr, jr) {
      if (!(En && En.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let Vr = $e.get(En).__webglFramebuffer;
      if (En.isWebGLCubeRenderTarget && jr !== void 0 && (Vr = Vr[jr]), Vr) {
        Et.bindFramebuffer(st.FRAMEBUFFER, Vr);
        try {
          const us = En.texture, Es = us.format, Dr = us.type;
          if (Es !== RGBAFormat && ir.convert(Es) !== st.getParameter(st.IMPLEMENTATION_COLOR_READ_FORMAT)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          const Kr = Dr === HalfFloatType && (lt.has("EXT_color_buffer_half_float") || Zt.isWebGL2 && lt.has("EXT_color_buffer_float"));
          if (Dr !== UnsignedByteType && ir.convert(Dr) !== st.getParameter(st.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
          !(Dr === FloatType && (Zt.isWebGL2 || lt.has("OES_texture_float") || lt.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
          !Kr) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          qn >= 0 && qn <= En.width - kn && Wn >= 0 && Wn <= En.height - zn && st.readPixels(qn, Wn, kn, zn, ir.convert(Es), ir.convert(Dr), wr);
        } finally {
          const us = Le !== null ? $e.get(Le).__webglFramebuffer : null;
          Et.bindFramebuffer(st.FRAMEBUFFER, us);
        }
      }
    }, this.copyFramebufferToTexture = function(En, qn, Wn = 0) {
      const kn = Math.pow(2, -Wn), zn = Math.floor(qn.image.width * kn), wr = Math.floor(qn.image.height * kn);
      pt.setTexture2D(qn, 0), st.copyTexSubImage2D(st.TEXTURE_2D, Wn, 0, 0, En.x, En.y, zn, wr), Et.unbindTexture();
    }, this.copyTextureToTexture = function(En, qn, Wn, kn = 0) {
      const zn = qn.image.width, wr = qn.image.height, jr = ir.convert(Wn.format), Vr = ir.convert(Wn.type);
      pt.setTexture2D(Wn, 0), st.pixelStorei(st.UNPACK_FLIP_Y_WEBGL, Wn.flipY), st.pixelStorei(st.UNPACK_PREMULTIPLY_ALPHA_WEBGL, Wn.premultiplyAlpha), st.pixelStorei(st.UNPACK_ALIGNMENT, Wn.unpackAlignment), qn.isDataTexture ? st.texSubImage2D(st.TEXTURE_2D, kn, En.x, En.y, zn, wr, jr, Vr, qn.image.data) : qn.isCompressedTexture ? st.compressedTexSubImage2D(st.TEXTURE_2D, kn, En.x, En.y, qn.mipmaps[0].width, qn.mipmaps[0].height, jr, qn.mipmaps[0].data) : st.texSubImage2D(st.TEXTURE_2D, kn, En.x, En.y, jr, Vr, qn.image), kn === 0 && Wn.generateMipmaps && st.generateMipmap(st.TEXTURE_2D), Et.unbindTexture();
    }, this.copyTextureToTexture3D = function(En, qn, Wn, kn, zn = 0) {
      if (G.isWebGL1Renderer) {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
        return;
      }
      const wr = En.max.x - En.min.x + 1, jr = En.max.y - En.min.y + 1, Vr = En.max.z - En.min.z + 1, us = ir.convert(kn.format), Es = ir.convert(kn.type);
      let Dr;
      if (kn.isData3DTexture)
        pt.setTexture3D(kn, 0), Dr = st.TEXTURE_3D;
      else if (kn.isDataArrayTexture)
        pt.setTexture2DArray(kn, 0), Dr = st.TEXTURE_2D_ARRAY;
      else {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
        return;
      }
      st.pixelStorei(st.UNPACK_FLIP_Y_WEBGL, kn.flipY), st.pixelStorei(st.UNPACK_PREMULTIPLY_ALPHA_WEBGL, kn.premultiplyAlpha), st.pixelStorei(st.UNPACK_ALIGNMENT, kn.unpackAlignment);
      const Kr = st.getParameter(st.UNPACK_ROW_LENGTH), Js = st.getParameter(st.UNPACK_IMAGE_HEIGHT), io = st.getParameter(st.UNPACK_SKIP_PIXELS), No = st.getParameter(st.UNPACK_SKIP_ROWS), Ai = st.getParameter(st.UNPACK_SKIP_IMAGES), go = Wn.isCompressedTexture ? Wn.mipmaps[0] : Wn.image;
      st.pixelStorei(st.UNPACK_ROW_LENGTH, go.width), st.pixelStorei(st.UNPACK_IMAGE_HEIGHT, go.height), st.pixelStorei(st.UNPACK_SKIP_PIXELS, En.min.x), st.pixelStorei(st.UNPACK_SKIP_ROWS, En.min.y), st.pixelStorei(st.UNPACK_SKIP_IMAGES, En.min.z), Wn.isDataTexture || Wn.isData3DTexture ? st.texSubImage3D(Dr, zn, qn.x, qn.y, qn.z, wr, jr, Vr, us, Es, go.data) : Wn.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), st.compressedTexSubImage3D(Dr, zn, qn.x, qn.y, qn.z, wr, jr, Vr, us, go.data)) : st.texSubImage3D(Dr, zn, qn.x, qn.y, qn.z, wr, jr, Vr, us, Es, go), st.pixelStorei(st.UNPACK_ROW_LENGTH, Kr), st.pixelStorei(st.UNPACK_IMAGE_HEIGHT, Js), st.pixelStorei(st.UNPACK_SKIP_PIXELS, io), st.pixelStorei(st.UNPACK_SKIP_ROWS, No), st.pixelStorei(st.UNPACK_SKIP_IMAGES, Ai), zn === 0 && kn.generateMipmaps && st.generateMipmap(Dr), Et.unbindTexture();
    }, this.initTexture = function(En) {
      En.isCubeTexture ? pt.setTextureCube(En, 0) : En.isData3DTexture ? pt.setTexture3D(En, 0) : En.isDataArrayTexture || En.isCompressedArrayTexture ? pt.setTexture2DArray(En, 0) : pt.setTexture2D(En, 0), Et.unbindTexture();
    }, this.resetState = function() {
      fe = 0, _e = 0, Le = null, Et.reset(), er.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  get coordinateSystem() {
    return WebGLCoordinateSystem;
  }
  get physicallyCorrectLights() {
    return console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
  }
  set physicallyCorrectLights(e) {
    console.warn("THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !e;
  }
  get outputEncoding() {
    return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === SRGBColorSpace ? sRGBEncoding : LinearEncoding;
  }
  set outputEncoding(e) {
    console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = e === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
  }
}
class WebGL1Renderer extends WebGLRenderer {
}
WebGL1Renderer.prototype.isWebGL1Renderer = !0;
class Scene extends Object3D {
  constructor() {
    super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
  copy(e, s) {
    return super.copy(e, s), e.background !== null && (this.background = e.background.clone()), e.environment !== null && (this.environment = e.environment.clone()), e.fog !== null && (this.fog = e.fog.clone()), this.backgroundBlurriness = e.backgroundBlurriness, this.backgroundIntensity = e.backgroundIntensity, e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()), this.matrixAutoUpdate = e.matrixAutoUpdate, this;
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return this.fog !== null && (s.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (s.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (s.object.backgroundIntensity = this.backgroundIntensity), s;
  }
}
class InterleavedBuffer {
  constructor(e, s) {
    this.isInterleavedBuffer = !0, this.array = e, this.stride = s, this.count = e !== void 0 ? e.length / s : 0, this.usage = StaticDrawUsage, this.updateRange = { offset: 0, count: -1 }, this.version = 0, this.uuid = generateUUID$1();
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.usage = e.usage, this;
  }
  copyAt(e, s, o) {
    e *= this.stride, o *= s.stride;
    for (let a = 0, l = this.stride; a < l; a++)
      this.array[e + a] = s.array[o + a];
    return this;
  }
  set(e, s = 0) {
    return this.array.set(e, s), this;
  }
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = generateUUID$1()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
    const s = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]), o = new this.constructor(s, this.stride);
    return o.setUsage(this.usage), o;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  toJSON(e) {
    return e.arrayBuffers === void 0 && (e.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = generateUUID$1()), e.arrayBuffers[this.array.buffer._uuid] === void 0 && (e.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
const _vector$5 = /* @__PURE__ */ new Vector3$1();
class InterleavedBufferAttribute {
  constructor(e, s, o, a = !1) {
    this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e, this.itemSize = s, this.offset = o, this.normalized = a;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(e) {
    this.data.needsUpdate = e;
  }
  applyMatrix4(e) {
    for (let s = 0, o = this.data.count; s < o; s++)
      _vector$5.fromBufferAttribute(this, s), _vector$5.applyMatrix4(e), this.setXYZ(s, _vector$5.x, _vector$5.y, _vector$5.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let s = 0, o = this.count; s < o; s++)
      _vector$5.fromBufferAttribute(this, s), _vector$5.applyNormalMatrix(e), this.setXYZ(s, _vector$5.x, _vector$5.y, _vector$5.z);
    return this;
  }
  transformDirection(e) {
    for (let s = 0, o = this.count; s < o; s++)
      _vector$5.fromBufferAttribute(this, s), _vector$5.transformDirection(e), this.setXYZ(s, _vector$5.x, _vector$5.y, _vector$5.z);
    return this;
  }
  setX(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.data.array[e * this.data.stride + this.offset] = s, this;
  }
  setY(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.data.array[e * this.data.stride + this.offset + 1] = s, this;
  }
  setZ(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.data.array[e * this.data.stride + this.offset + 2] = s, this;
  }
  setW(e, s) {
    return this.normalized && (s = normalize(s, this.array)), this.data.array[e * this.data.stride + this.offset + 3] = s, this;
  }
  getX(e) {
    let s = this.data.array[e * this.data.stride + this.offset];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  getY(e) {
    let s = this.data.array[e * this.data.stride + this.offset + 1];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  getZ(e) {
    let s = this.data.array[e * this.data.stride + this.offset + 2];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  getW(e) {
    let s = this.data.array[e * this.data.stride + this.offset + 3];
    return this.normalized && (s = denormalize(s, this.array)), s;
  }
  setXY(e, s, o) {
    return e = e * this.data.stride + this.offset, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array)), this.data.array[e + 0] = s, this.data.array[e + 1] = o, this;
  }
  setXYZ(e, s, o, a) {
    return e = e * this.data.stride + this.offset, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array), a = normalize(a, this.array)), this.data.array[e + 0] = s, this.data.array[e + 1] = o, this.data.array[e + 2] = a, this;
  }
  setXYZW(e, s, o, a, l) {
    return e = e * this.data.stride + this.offset, this.normalized && (s = normalize(s, this.array), o = normalize(o, this.array), a = normalize(a, this.array), l = normalize(l, this.array)), this.data.array[e + 0] = s, this.data.array[e + 1] = o, this.data.array[e + 2] = a, this.data.array[e + 3] = l, this;
  }
  clone(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const s = [];
      for (let o = 0; o < this.count; o++) {
        const a = o * this.data.stride + this.offset;
        for (let l = 0; l < this.itemSize; l++)
          s.push(this.data.array[a + l]);
      }
      return new BufferAttribute(new this.array.constructor(s), this.itemSize, this.normalized);
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)), new InterleavedBufferAttribute(e.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
  }
  toJSON(e) {
    if (e === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const s = [];
      for (let o = 0; o < this.count; o++) {
        const a = o * this.data.stride + this.offset;
        for (let l = 0; l < this.itemSize; l++)
          s.push(this.data.array[a + l]);
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: s,
        normalized: this.normalized
      };
    } else
      return e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}), e.interleavedBuffers[this.data.uuid] === void 0 && (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)), {
        isInterleavedBufferAttribute: !0,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
  }
}
class SpriteMaterial extends Material {
  constructor(e) {
    super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Color(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
let _geometry;
const _intersectPoint = /* @__PURE__ */ new Vector3$1(), _worldScale = /* @__PURE__ */ new Vector3$1(), _mvPosition = /* @__PURE__ */ new Vector3$1(), _alignedPosition = /* @__PURE__ */ new Vector2(), _rotatedPosition = /* @__PURE__ */ new Vector2(), _viewWorldMatrix = /* @__PURE__ */ new Matrix4(), _vA$2 = /* @__PURE__ */ new Vector3$1(), _vB$2 = /* @__PURE__ */ new Vector3$1(), _vC$2 = /* @__PURE__ */ new Vector3$1(), _uvA$2 = /* @__PURE__ */ new Vector2(), _uvB$2 = /* @__PURE__ */ new Vector2(), _uvC$2 = /* @__PURE__ */ new Vector2();
class Sprite extends Object3D {
  constructor(e) {
    if (super(), this.isSprite = !0, this.type = "Sprite", _geometry === void 0) {
      _geometry = new BufferGeometry();
      const s = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]), o = new InterleavedBuffer(s, 5);
      _geometry.setIndex([0, 1, 2, 0, 2, 3]), _geometry.setAttribute("position", new InterleavedBufferAttribute(o, 3, 0, !1)), _geometry.setAttribute("uv", new InterleavedBufferAttribute(o, 2, 3, !1));
    }
    this.geometry = _geometry, this.material = e !== void 0 ? e : new SpriteMaterial(), this.center = new Vector2(0.5, 0.5);
  }
  raycast(e, s) {
    e.camera === null && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), _worldScale.setFromMatrixScale(this.matrixWorld), _viewWorldMatrix.copy(e.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e.camera.matrixWorldInverse, this.matrixWorld), _mvPosition.setFromMatrixPosition(this.modelViewMatrix), e.camera.isPerspectiveCamera && this.material.sizeAttenuation === !1 && _worldScale.multiplyScalar(-_mvPosition.z);
    const o = this.material.rotation;
    let a, l;
    o !== 0 && (l = Math.cos(o), a = Math.sin(o));
    const u = this.center;
    transformVertex$1(_vA$2.set(-0.5, -0.5, 0), _mvPosition, u, _worldScale, a, l), transformVertex$1(_vB$2.set(0.5, -0.5, 0), _mvPosition, u, _worldScale, a, l), transformVertex$1(_vC$2.set(0.5, 0.5, 0), _mvPosition, u, _worldScale, a, l), _uvA$2.set(0, 0), _uvB$2.set(1, 0), _uvC$2.set(1, 1);
    let c = e.ray.intersectTriangle(_vA$2, _vB$2, _vC$2, !1, _intersectPoint);
    if (c === null && (transformVertex$1(_vB$2.set(-0.5, 0.5, 0), _mvPosition, u, _worldScale, a, l), _uvB$2.set(0, 1), c = e.ray.intersectTriangle(_vA$2, _vC$2, _vB$2, !1, _intersectPoint), c === null))
      return;
    const E = e.ray.origin.distanceTo(_intersectPoint);
    E < e.near || E > e.far || s.push({
      distance: E,
      point: _intersectPoint.clone(),
      uv: Triangle.getInterpolation(_intersectPoint, _vA$2, _vB$2, _vC$2, _uvA$2, _uvB$2, _uvC$2, new Vector2()),
      face: null,
      object: this
    });
  }
  copy(e, s) {
    return super.copy(e, s), e.center !== void 0 && this.center.copy(e.center), this.material = e.material, this;
  }
}
function transformVertex$1(r, e, s, o, a, l) {
  _alignedPosition.subVectors(r, s).addScalar(0.5).multiply(o), a !== void 0 ? (_rotatedPosition.x = l * _alignedPosition.x - a * _alignedPosition.y, _rotatedPosition.y = a * _alignedPosition.x + l * _alignedPosition.y) : _rotatedPosition.copy(_alignedPosition), r.copy(e), r.x += _rotatedPosition.x, r.y += _rotatedPosition.y, r.applyMatrix4(_viewWorldMatrix);
}
const _basePosition = /* @__PURE__ */ new Vector3$1(), _skinIndex = /* @__PURE__ */ new Vector4(), _skinWeight = /* @__PURE__ */ new Vector4(), _vector3 = /* @__PURE__ */ new Vector3$1(), _matrix4 = /* @__PURE__ */ new Matrix4(), _vertex = /* @__PURE__ */ new Vector3$1(), _sphere$3 = /* @__PURE__ */ new Sphere$1(), _inverseMatrix$2 = /* @__PURE__ */ new Matrix4(), _ray$2 = /* @__PURE__ */ new Ray();
class SkinnedMesh extends Mesh {
  constructor(e, s) {
    super(e, s), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = "attached", this.bindMatrix = new Matrix4(), this.bindMatrixInverse = new Matrix4(), this.boundingBox = null, this.boundingSphere = null;
  }
  computeBoundingBox() {
    const e = this.geometry;
    this.boundingBox === null && (this.boundingBox = new Box3$1()), this.boundingBox.makeEmpty();
    const s = e.getAttribute("position");
    for (let o = 0; o < s.count; o++)
      _vertex.fromBufferAttribute(s, o), this.applyBoneTransform(o, _vertex), this.boundingBox.expandByPoint(_vertex);
  }
  computeBoundingSphere() {
    const e = this.geometry;
    this.boundingSphere === null && (this.boundingSphere = new Sphere$1()), this.boundingSphere.makeEmpty();
    const s = e.getAttribute("position");
    for (let o = 0; o < s.count; o++)
      _vertex.fromBufferAttribute(s, o), this.applyBoneTransform(o, _vertex), this.boundingSphere.expandByPoint(_vertex);
  }
  copy(e, s) {
    return super.copy(e, s), this.bindMode = e.bindMode, this.bindMatrix.copy(e.bindMatrix), this.bindMatrixInverse.copy(e.bindMatrixInverse), this.skeleton = e.skeleton, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  raycast(e, s) {
    const o = this.material, a = this.matrixWorld;
    o !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), _sphere$3.copy(this.boundingSphere), _sphere$3.applyMatrix4(a), e.ray.intersectsSphere(_sphere$3) !== !1 && (_inverseMatrix$2.copy(a).invert(), _ray$2.copy(e.ray).applyMatrix4(_inverseMatrix$2), !(this.boundingBox !== null && _ray$2.intersectsBox(this.boundingBox) === !1) && this._computeIntersections(e, s, _ray$2)));
  }
  getVertexPosition(e, s) {
    return super.getVertexPosition(e, s), this.applyBoneTransform(e, s), s;
  }
  bind(e, s) {
    this.skeleton = e, s === void 0 && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), s = this.matrixWorld), this.bindMatrix.copy(s), this.bindMatrixInverse.copy(s).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const e = new Vector4(), s = this.geometry.attributes.skinWeight;
    for (let o = 0, a = s.count; o < a; o++) {
      e.fromBufferAttribute(s, o);
      const l = 1 / e.manhattanLength();
      l !== 1 / 0 ? e.multiplyScalar(l) : e.set(1, 0, 0, 0), s.setXYZW(o, e.x, e.y, e.z, e.w);
    }
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.bindMode === "attached" ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === "detached" ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
  }
  applyBoneTransform(e, s) {
    const o = this.skeleton, a = this.geometry;
    _skinIndex.fromBufferAttribute(a.attributes.skinIndex, e), _skinWeight.fromBufferAttribute(a.attributes.skinWeight, e), _basePosition.copy(s).applyMatrix4(this.bindMatrix), s.set(0, 0, 0);
    for (let l = 0; l < 4; l++) {
      const u = _skinWeight.getComponent(l);
      if (u !== 0) {
        const c = _skinIndex.getComponent(l);
        _matrix4.multiplyMatrices(o.bones[c].matrixWorld, o.boneInverses[c]), s.addScaledVector(_vector3.copy(_basePosition).applyMatrix4(_matrix4), u);
      }
    }
    return s.applyMatrix4(this.bindMatrixInverse);
  }
  boneTransform(e, s) {
    return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(e, s);
  }
}
class Bone extends Object3D {
  constructor() {
    super(), this.isBone = !0, this.type = "Bone";
  }
}
class DataTexture extends Texture {
  constructor(e = null, s = 1, o = 1, a, l, u, c, E, d = NearestFilter, f = NearestFilter, h, S) {
    super(null, u, c, E, d, f, a, l, h, S), this.isDataTexture = !0, this.image = { data: e, width: s, height: o }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
const _offsetMatrix = /* @__PURE__ */ new Matrix4(), _identityMatrix$1 = /* @__PURE__ */ new Matrix4();
class Skeleton {
  constructor(e = [], s = []) {
    this.uuid = generateUUID$1(), this.bones = e.slice(0), this.boneInverses = s, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
  }
  init() {
    const e = this.bones, s = this.boneInverses;
    if (this.boneMatrices = new Float32Array(e.length * 16), s.length === 0)
      this.calculateInverses();
    else if (e.length !== s.length) {
      console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
      for (let o = 0, a = this.bones.length; o < a; o++)
        this.boneInverses.push(new Matrix4());
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let e = 0, s = this.bones.length; e < s; e++) {
      const o = new Matrix4();
      this.bones[e] && o.copy(this.bones[e].matrixWorld).invert(), this.boneInverses.push(o);
    }
  }
  pose() {
    for (let e = 0, s = this.bones.length; e < s; e++) {
      const o = this.bones[e];
      o && o.matrixWorld.copy(this.boneInverses[e]).invert();
    }
    for (let e = 0, s = this.bones.length; e < s; e++) {
      const o = this.bones[e];
      o && (o.parent && o.parent.isBone ? (o.matrix.copy(o.parent.matrixWorld).invert(), o.matrix.multiply(o.matrixWorld)) : o.matrix.copy(o.matrixWorld), o.matrix.decompose(o.position, o.quaternion, o.scale));
    }
  }
  update() {
    const e = this.bones, s = this.boneInverses, o = this.boneMatrices, a = this.boneTexture;
    for (let l = 0, u = e.length; l < u; l++) {
      const c = e[l] ? e[l].matrixWorld : _identityMatrix$1;
      _offsetMatrix.multiplyMatrices(c, s[l]), _offsetMatrix.toArray(o, l * 16);
    }
    a !== null && (a.needsUpdate = !0);
  }
  clone() {
    return new Skeleton(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let e = Math.sqrt(this.bones.length * 4);
    e = ceilPowerOfTwo(e), e = Math.max(e, 4);
    const s = new Float32Array(e * e * 4);
    s.set(this.boneMatrices);
    const o = new DataTexture(s, e, e, RGBAFormat, FloatType);
    return o.needsUpdate = !0, this.boneMatrices = s, this.boneTexture = o, this.boneTextureSize = e, this;
  }
  getBoneByName(e) {
    for (let s = 0, o = this.bones.length; s < o; s++) {
      const a = this.bones[s];
      if (a.name === e)
        return a;
    }
  }
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), this.boneTexture = null);
  }
  fromJSON(e, s) {
    this.uuid = e.uuid;
    for (let o = 0, a = e.bones.length; o < a; o++) {
      const l = e.bones[o];
      let u = s[l];
      u === void 0 && (console.warn("THREE.Skeleton: No bone found with UUID:", l), u = new Bone()), this.bones.push(u), this.boneInverses.push(new Matrix4().fromArray(e.boneInverses[o]));
    }
    return this.init(), this;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    e.uuid = this.uuid;
    const s = this.bones, o = this.boneInverses;
    for (let a = 0, l = s.length; a < l; a++) {
      const u = s[a];
      e.bones.push(u.uuid);
      const c = o[a];
      e.boneInverses.push(c.toArray());
    }
    return e;
  }
}
class InstancedBufferAttribute extends BufferAttribute {
  constructor(e, s, o, a = 1) {
    super(e, s, o), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = a;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.meshPerAttribute = this.meshPerAttribute, e.isInstancedBufferAttribute = !0, e;
  }
}
const _instanceLocalMatrix = /* @__PURE__ */ new Matrix4(), _instanceWorldMatrix = /* @__PURE__ */ new Matrix4(), _instanceIntersects = [], _box3 = /* @__PURE__ */ new Box3$1(), _identity = /* @__PURE__ */ new Matrix4(), _mesh = /* @__PURE__ */ new Mesh(), _sphere$2 = /* @__PURE__ */ new Sphere$1();
class InstancedMesh extends Mesh {
  constructor(e, s, o) {
    super(e, s), this.isInstancedMesh = !0, this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(o * 16), 16), this.instanceColor = null, this.count = o, this.boundingBox = null, this.boundingSphere = null;
    for (let a = 0; a < o; a++)
      this.setMatrixAt(a, _identity);
  }
  computeBoundingBox() {
    const e = this.geometry, s = this.count;
    this.boundingBox === null && (this.boundingBox = new Box3$1()), e.boundingBox === null && e.computeBoundingBox(), this.boundingBox.makeEmpty();
    for (let o = 0; o < s; o++)
      this.getMatrixAt(o, _instanceLocalMatrix), _box3.copy(e.boundingBox).applyMatrix4(_instanceLocalMatrix), this.boundingBox.union(_box3);
  }
  computeBoundingSphere() {
    const e = this.geometry, s = this.count;
    this.boundingSphere === null && (this.boundingSphere = new Sphere$1()), e.boundingSphere === null && e.computeBoundingSphere(), this.boundingSphere.makeEmpty();
    for (let o = 0; o < s; o++)
      this.getMatrixAt(o, _instanceLocalMatrix), _sphere$2.copy(e.boundingSphere).applyMatrix4(_instanceLocalMatrix), this.boundingSphere.union(_sphere$2);
  }
  copy(e, s) {
    return super.copy(e, s), this.instanceMatrix.copy(e.instanceMatrix), e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()), this.count = e.count, e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()), e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()), this;
  }
  getColorAt(e, s) {
    s.fromArray(this.instanceColor.array, e * 3);
  }
  getMatrixAt(e, s) {
    s.fromArray(this.instanceMatrix.array, e * 16);
  }
  raycast(e, s) {
    const o = this.matrixWorld, a = this.count;
    if (_mesh.geometry = this.geometry, _mesh.material = this.material, _mesh.material !== void 0 && (this.boundingSphere === null && this.computeBoundingSphere(), _sphere$2.copy(this.boundingSphere), _sphere$2.applyMatrix4(o), e.ray.intersectsSphere(_sphere$2) !== !1))
      for (let l = 0; l < a; l++) {
        this.getMatrixAt(l, _instanceLocalMatrix), _instanceWorldMatrix.multiplyMatrices(o, _instanceLocalMatrix), _mesh.matrixWorld = _instanceWorldMatrix, _mesh.raycast(e, _instanceIntersects);
        for (let u = 0, c = _instanceIntersects.length; u < c; u++) {
          const E = _instanceIntersects[u];
          E.instanceId = l, E.object = this, s.push(E);
        }
        _instanceIntersects.length = 0;
      }
  }
  setColorAt(e, s) {
    this.instanceColor === null && (this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3), 3)), s.toArray(this.instanceColor.array, e * 3);
  }
  setMatrixAt(e, s) {
    s.toArray(this.instanceMatrix.array, e * 16);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class LineBasicMaterial extends Material {
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Color(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const _start$1 = /* @__PURE__ */ new Vector3$1(), _end$1 = /* @__PURE__ */ new Vector3$1(), _inverseMatrix$1 = /* @__PURE__ */ new Matrix4(), _ray$1 = /* @__PURE__ */ new Ray(), _sphere$1 = /* @__PURE__ */ new Sphere$1();
let Line$1 = class extends Object3D {
  constructor(e = new BufferGeometry(), s = new LineBasicMaterial()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = s, this.updateMorphTargets();
  }
  copy(e, s) {
    return super.copy(e, s), this.material = e.material, this.geometry = e.geometry, this;
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const s = e.attributes.position, o = [0];
      for (let a = 1, l = s.count; a < l; a++)
        _start$1.fromBufferAttribute(s, a - 1), _end$1.fromBufferAttribute(s, a), o[a] = o[a - 1], o[a] += _start$1.distanceTo(_end$1);
      e.setAttribute("lineDistance", new Float32BufferAttribute(o, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  raycast(e, s) {
    const o = this.geometry, a = this.matrixWorld, l = e.params.Line.threshold, u = o.drawRange;
    if (o.boundingSphere === null && o.computeBoundingSphere(), _sphere$1.copy(o.boundingSphere), _sphere$1.applyMatrix4(a), _sphere$1.radius += l, e.ray.intersectsSphere(_sphere$1) === !1)
      return;
    _inverseMatrix$1.copy(a).invert(), _ray$1.copy(e.ray).applyMatrix4(_inverseMatrix$1);
    const c = l / ((this.scale.x + this.scale.y + this.scale.z) / 3), E = c * c, d = new Vector3$1(), f = new Vector3$1(), h = new Vector3$1(), S = new Vector3$1(), R = this.isLineSegments ? 2 : 1, _ = o.index, L = o.attributes.position;
    if (_ !== null) {
      const F = Math.max(0, u.start), W = Math.min(_.count, u.start + u.count);
      for (let G = F, q = W - 1; G < q; G += R) {
        const fe = _.getX(G), _e = _.getX(G + 1);
        if (d.fromBufferAttribute(L, fe), f.fromBufferAttribute(L, _e), _ray$1.distanceSqToSegment(d, f, S, h) > E)
          continue;
        S.applyMatrix4(this.matrixWorld);
        const Fe = e.ray.origin.distanceTo(S);
        Fe < e.near || Fe > e.far || s.push({
          distance: Fe,
          // What do we want? intersection point on the ray or on the segment??
          // point: raycaster.ray.at( distance ),
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: G,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    } else {
      const F = Math.max(0, u.start), W = Math.min(L.count, u.start + u.count);
      for (let G = F, q = W - 1; G < q; G += R) {
        if (d.fromBufferAttribute(L, G), f.fromBufferAttribute(L, G + 1), _ray$1.distanceSqToSegment(d, f, S, h) > E)
          continue;
        S.applyMatrix4(this.matrixWorld);
        const _e = e.ray.origin.distanceTo(S);
        _e < e.near || _e > e.far || s.push({
          distance: _e,
          // What do we want? intersection point on the ray or on the segment??
          // point: raycaster.ray.at( distance ),
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: G,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    }
  }
  updateMorphTargets() {
    const s = this.geometry.morphAttributes, o = Object.keys(s);
    if (o.length > 0) {
      const a = s[o[0]];
      if (a !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let l = 0, u = a.length; l < u; l++) {
          const c = a[l].name || String(l);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = l;
        }
      }
    }
  }
};
const _start$2 = /* @__PURE__ */ new Vector3$1(), _end$2 = /* @__PURE__ */ new Vector3$1();
class LineSegments extends Line$1 {
  constructor(e, s) {
    super(e, s), this.isLineSegments = !0, this.type = "LineSegments";
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const s = e.attributes.position, o = [];
      for (let a = 0, l = s.count; a < l; a += 2)
        _start$2.fromBufferAttribute(s, a), _end$2.fromBufferAttribute(s, a + 1), o[a] = a === 0 ? 0 : o[a - 1], o[a + 1] = o[a] + _start$2.distanceTo(_end$2);
      e.setAttribute("lineDistance", new Float32BufferAttribute(o, 1));
    } else
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
}
class LineLoop extends Line$1 {
  constructor(e, s) {
    super(e, s), this.isLineLoop = !0, this.type = "LineLoop";
  }
}
class PointsMaterial extends Material {
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Color(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
const _inverseMatrix = /* @__PURE__ */ new Matrix4(), _ray$4 = /* @__PURE__ */ new Ray(), _sphere$6 = /* @__PURE__ */ new Sphere$1(), _position$2 = /* @__PURE__ */ new Vector3$1();
class Points extends Object3D {
  constructor(e = new BufferGeometry(), s = new PointsMaterial()) {
    super(), this.isPoints = !0, this.type = "Points", this.geometry = e, this.material = s, this.updateMorphTargets();
  }
  copy(e, s) {
    return super.copy(e, s), this.material = e.material, this.geometry = e.geometry, this;
  }
  raycast(e, s) {
    const o = this.geometry, a = this.matrixWorld, l = e.params.Points.threshold, u = o.drawRange;
    if (o.boundingSphere === null && o.computeBoundingSphere(), _sphere$6.copy(o.boundingSphere), _sphere$6.applyMatrix4(a), _sphere$6.radius += l, e.ray.intersectsSphere(_sphere$6) === !1)
      return;
    _inverseMatrix.copy(a).invert(), _ray$4.copy(e.ray).applyMatrix4(_inverseMatrix);
    const c = l / ((this.scale.x + this.scale.y + this.scale.z) / 3), E = c * c, d = o.index, h = o.attributes.position;
    if (d !== null) {
      const S = Math.max(0, u.start), R = Math.min(d.count, u.start + u.count);
      for (let _ = S, m = R; _ < m; _++) {
        const L = d.getX(_);
        _position$2.fromBufferAttribute(h, L), testPoint(_position$2, L, E, a, e, s, this);
      }
    } else {
      const S = Math.max(0, u.start), R = Math.min(h.count, u.start + u.count);
      for (let _ = S, m = R; _ < m; _++)
        _position$2.fromBufferAttribute(h, _), testPoint(_position$2, _, E, a, e, s, this);
    }
  }
  updateMorphTargets() {
    const s = this.geometry.morphAttributes, o = Object.keys(s);
    if (o.length > 0) {
      const a = s[o[0]];
      if (a !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let l = 0, u = a.length; l < u; l++) {
          const c = a[l].name || String(l);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[c] = l;
        }
      }
    }
  }
}
function testPoint(r, e, s, o, a, l, u) {
  const c = _ray$4.distanceSqToPoint(r);
  if (c < s) {
    const E = new Vector3$1();
    _ray$4.closestPointToPoint(r, E), E.applyMatrix4(o);
    const d = a.ray.origin.distanceTo(E);
    if (d < a.near || d > a.far)
      return;
    l.push({
      distance: d,
      distanceToRay: Math.sqrt(c),
      point: E,
      index: e,
      face: null,
      object: u
    });
  }
}
class CompressedTexture extends Texture {
  constructor(e, s, o, a, l, u, c, E, d, f, h, S) {
    super(null, u, c, E, d, f, a, l, h, S), this.isCompressedTexture = !0, this.image = { width: s, height: o }, this.mipmaps = e, this.flipY = !1, this.generateMipmaps = !1;
  }
}
class CompressedArrayTexture extends CompressedTexture {
  constructor(e, s, o, a, l, u) {
    super(e, s, o, l, u), this.isCompressedArrayTexture = !0, this.image.depth = a, this.wrapR = ClampToEdgeWrapping;
  }
}
class CanvasTexture extends Texture {
  constructor(e, s, o, a, l, u, c, E, d) {
    super(e, s, o, a, l, u, c, E, d), this.isCanvasTexture = !0, this.needsUpdate = !0;
  }
}
class Curve {
  constructor() {
    this.type = "Curve", this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    return console.warn("THREE.Curve: .getPoint() not implemented."), null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(e, s) {
    const o = this.getUtoTmapping(e);
    return this.getPoint(o, s);
  }
  // Get sequence of points using getPoint( t )
  getPoints(e = 5) {
    const s = [];
    for (let o = 0; o <= e; o++)
      s.push(this.getPoint(o / e));
    return s;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(e = 5) {
    const s = [];
    for (let o = 0; o <= e; o++)
      s.push(this.getPointAt(o / e));
    return s;
  }
  // Get total curve arc length
  getLength() {
    const e = this.getLengths();
    return e[e.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(e = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate)
      return this.cacheArcLengths;
    this.needsUpdate = !1;
    const s = [];
    let o, a = this.getPoint(0), l = 0;
    s.push(0);
    for (let u = 1; u <= e; u++)
      o = this.getPoint(u / e), l += o.distanceTo(a), s.push(l), a = o;
    return this.cacheArcLengths = s, s;
  }
  updateArcLengths() {
    this.needsUpdate = !0, this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(e, s) {
    const o = this.getLengths();
    let a = 0;
    const l = o.length;
    let u;
    s ? u = s : u = e * o[l - 1];
    let c = 0, E = l - 1, d;
    for (; c <= E; )
      if (a = Math.floor(c + (E - c) / 2), d = o[a] - u, d < 0)
        c = a + 1;
      else if (d > 0)
        E = a - 1;
      else {
        E = a;
        break;
      }
    if (a = E, o[a] === u)
      return a / (l - 1);
    const f = o[a], S = o[a + 1] - f, R = (u - f) / S;
    return (a + R) / (l - 1);
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(e, s) {
    let a = e - 1e-4, l = e + 1e-4;
    a < 0 && (a = 0), l > 1 && (l = 1);
    const u = this.getPoint(a), c = this.getPoint(l), E = s || (u.isVector2 ? new Vector2() : new Vector3$1());
    return E.copy(c).sub(u).normalize(), E;
  }
  getTangentAt(e, s) {
    const o = this.getUtoTmapping(e);
    return this.getTangent(o, s);
  }
  computeFrenetFrames(e, s) {
    const o = new Vector3$1(), a = [], l = [], u = [], c = new Vector3$1(), E = new Matrix4();
    for (let R = 0; R <= e; R++) {
      const _ = R / e;
      a[R] = this.getTangentAt(_, new Vector3$1());
    }
    l[0] = new Vector3$1(), u[0] = new Vector3$1();
    let d = Number.MAX_VALUE;
    const f = Math.abs(a[0].x), h = Math.abs(a[0].y), S = Math.abs(a[0].z);
    f <= d && (d = f, o.set(1, 0, 0)), h <= d && (d = h, o.set(0, 1, 0)), S <= d && o.set(0, 0, 1), c.crossVectors(a[0], o).normalize(), l[0].crossVectors(a[0], c), u[0].crossVectors(a[0], l[0]);
    for (let R = 1; R <= e; R++) {
      if (l[R] = l[R - 1].clone(), u[R] = u[R - 1].clone(), c.crossVectors(a[R - 1], a[R]), c.length() > Number.EPSILON) {
        c.normalize();
        const _ = Math.acos(clamp$2(a[R - 1].dot(a[R]), -1, 1));
        l[R].applyMatrix4(E.makeRotationAxis(c, _));
      }
      u[R].crossVectors(a[R], l[R]);
    }
    if (s === !0) {
      let R = Math.acos(clamp$2(l[0].dot(l[e]), -1, 1));
      R /= e, a[0].dot(c.crossVectors(l[0], l[e])) > 0 && (R = -R);
      for (let _ = 1; _ <= e; _++)
        l[_].applyMatrix4(E.makeRotationAxis(a[_], R * _)), u[_].crossVectors(a[_], l[_]);
    }
    return {
      tangents: a,
      normals: l,
      binormals: u
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.arcLengthDivisions = e.arcLengthDivisions, this;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    return e.arcLengthDivisions = this.arcLengthDivisions, e.type = this.type, e;
  }
  fromJSON(e) {
    return this.arcLengthDivisions = e.arcLengthDivisions, this;
  }
}
class EllipseCurve extends Curve {
  constructor(e = 0, s = 0, o = 1, a = 1, l = 0, u = Math.PI * 2, c = !1, E = 0) {
    super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e, this.aY = s, this.xRadius = o, this.yRadius = a, this.aStartAngle = l, this.aEndAngle = u, this.aClockwise = c, this.aRotation = E;
  }
  getPoint(e, s) {
    const o = s || new Vector2(), a = Math.PI * 2;
    let l = this.aEndAngle - this.aStartAngle;
    const u = Math.abs(l) < Number.EPSILON;
    for (; l < 0; )
      l += a;
    for (; l > a; )
      l -= a;
    l < Number.EPSILON && (u ? l = 0 : l = a), this.aClockwise === !0 && !u && (l === a ? l = -a : l = l - a);
    const c = this.aStartAngle + e * l;
    let E = this.aX + this.xRadius * Math.cos(c), d = this.aY + this.yRadius * Math.sin(c);
    if (this.aRotation !== 0) {
      const f = Math.cos(this.aRotation), h = Math.sin(this.aRotation), S = E - this.aX, R = d - this.aY;
      E = S * f - R * h + this.aX, d = S * h + R * f + this.aY;
    }
    return o.set(E, d);
  }
  copy(e) {
    return super.copy(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.aX = this.aX, e.aY = this.aY, e.xRadius = this.xRadius, e.yRadius = this.yRadius, e.aStartAngle = this.aStartAngle, e.aEndAngle = this.aEndAngle, e.aClockwise = this.aClockwise, e.aRotation = this.aRotation, e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
  }
}
class ArcCurve extends EllipseCurve {
  constructor(e, s, o, a, l, u) {
    super(e, s, o, o, a, l, u), this.isArcCurve = !0, this.type = "ArcCurve";
  }
}
function CubicPoly() {
  let r = 0, e = 0, s = 0, o = 0;
  function a(l, u, c, E) {
    r = l, e = c, s = -3 * l + 3 * u - 2 * c - E, o = 2 * l - 2 * u + c + E;
  }
  return {
    initCatmullRom: function(l, u, c, E, d) {
      a(u, c, d * (c - l), d * (E - u));
    },
    initNonuniformCatmullRom: function(l, u, c, E, d, f, h) {
      let S = (u - l) / d - (c - l) / (d + f) + (c - u) / f, R = (c - u) / f - (E - u) / (f + h) + (E - c) / h;
      S *= f, R *= f, a(u, c, S, R);
    },
    calc: function(l) {
      const u = l * l, c = u * l;
      return r + e * l + s * u + o * c;
    }
  };
}
const tmp = /* @__PURE__ */ new Vector3$1(), px = /* @__PURE__ */ new CubicPoly(), py = /* @__PURE__ */ new CubicPoly(), pz = /* @__PURE__ */ new CubicPoly();
class CatmullRomCurve3 extends Curve {
  constructor(e = [], s = !1, o = "centripetal", a = 0.5) {
    super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = e, this.closed = s, this.curveType = o, this.tension = a;
  }
  getPoint(e, s = new Vector3$1()) {
    const o = s, a = this.points, l = a.length, u = (l - (this.closed ? 0 : 1)) * e;
    let c = Math.floor(u), E = u - c;
    this.closed ? c += c > 0 ? 0 : (Math.floor(Math.abs(c) / l) + 1) * l : E === 0 && c === l - 1 && (c = l - 2, E = 1);
    let d, f;
    this.closed || c > 0 ? d = a[(c - 1) % l] : (tmp.subVectors(a[0], a[1]).add(a[0]), d = tmp);
    const h = a[c % l], S = a[(c + 1) % l];
    if (this.closed || c + 2 < l ? f = a[(c + 2) % l] : (tmp.subVectors(a[l - 1], a[l - 2]).add(a[l - 1]), f = tmp), this.curveType === "centripetal" || this.curveType === "chordal") {
      const R = this.curveType === "chordal" ? 0.5 : 0.25;
      let _ = Math.pow(d.distanceToSquared(h), R), m = Math.pow(h.distanceToSquared(S), R), L = Math.pow(S.distanceToSquared(f), R);
      m < 1e-4 && (m = 1), _ < 1e-4 && (_ = m), L < 1e-4 && (L = m), px.initNonuniformCatmullRom(d.x, h.x, S.x, f.x, _, m, L), py.initNonuniformCatmullRom(d.y, h.y, S.y, f.y, _, m, L), pz.initNonuniformCatmullRom(d.z, h.z, S.z, f.z, _, m, L);
    } else
      this.curveType === "catmullrom" && (px.initCatmullRom(d.x, h.x, S.x, f.x, this.tension), py.initCatmullRom(d.y, h.y, S.y, f.y, this.tension), pz.initCatmullRom(d.z, h.z, S.z, f.z, this.tension));
    return o.set(
      px.calc(E),
      py.calc(E),
      pz.calc(E)
    ), o;
  }
  copy(e) {
    super.copy(e), this.points = [];
    for (let s = 0, o = e.points.length; s < o; s++) {
      const a = e.points[s];
      this.points.push(a.clone());
    }
    return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
  }
  toJSON() {
    const e = super.toJSON();
    e.points = [];
    for (let s = 0, o = this.points.length; s < o; s++) {
      const a = this.points[s];
      e.points.push(a.toArray());
    }
    return e.closed = this.closed, e.curveType = this.curveType, e.tension = this.tension, e;
  }
  fromJSON(e) {
    super.fromJSON(e), this.points = [];
    for (let s = 0, o = e.points.length; s < o; s++) {
      const a = e.points[s];
      this.points.push(new Vector3$1().fromArray(a));
    }
    return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
  }
}
function CatmullRom(r, e, s, o, a) {
  const l = (o - e) * 0.5, u = (a - s) * 0.5, c = r * r, E = r * c;
  return (2 * s - 2 * o + l + u) * E + (-3 * s + 3 * o - 2 * l - u) * c + l * r + s;
}
function QuadraticBezierP0(r, e) {
  const s = 1 - r;
  return s * s * e;
}
function QuadraticBezierP1(r, e) {
  return 2 * (1 - r) * r * e;
}
function QuadraticBezierP2(r, e) {
  return r * r * e;
}
function QuadraticBezier(r, e, s, o) {
  return QuadraticBezierP0(r, e) + QuadraticBezierP1(r, s) + QuadraticBezierP2(r, o);
}
function CubicBezierP0(r, e) {
  const s = 1 - r;
  return s * s * s * e;
}
function CubicBezierP1(r, e) {
  const s = 1 - r;
  return 3 * s * s * r * e;
}
function CubicBezierP2(r, e) {
  return 3 * (1 - r) * r * r * e;
}
function CubicBezierP3(r, e) {
  return r * r * r * e;
}
function CubicBezier(r, e, s, o, a) {
  return CubicBezierP0(r, e) + CubicBezierP1(r, s) + CubicBezierP2(r, o) + CubicBezierP3(r, a);
}
class CubicBezierCurve extends Curve {
  constructor(e = new Vector2(), s = new Vector2(), o = new Vector2(), a = new Vector2()) {
    super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = e, this.v1 = s, this.v2 = o, this.v3 = a;
  }
  getPoint(e, s = new Vector2()) {
    const o = s, a = this.v0, l = this.v1, u = this.v2, c = this.v3;
    return o.set(
      CubicBezier(e, a.x, l.x, u.x, c.x),
      CubicBezier(e, a.y, l.y, u.y, c.y)
    ), o;
  }
  copy(e) {
    return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
  }
}
class CubicBezierCurve3 extends Curve {
  constructor(e = new Vector3$1(), s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1()) {
    super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = e, this.v1 = s, this.v2 = o, this.v3 = a;
  }
  getPoint(e, s = new Vector3$1()) {
    const o = s, a = this.v0, l = this.v1, u = this.v2, c = this.v3;
    return o.set(
      CubicBezier(e, a.x, l.x, u.x, c.x),
      CubicBezier(e, a.y, l.y, u.y, c.y),
      CubicBezier(e, a.z, l.z, u.z, c.z)
    ), o;
  }
  copy(e) {
    return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
  }
}
class LineCurve extends Curve {
  constructor(e = new Vector2(), s = new Vector2()) {
    super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = e, this.v2 = s;
  }
  getPoint(e, s = new Vector2()) {
    const o = s;
    return e === 1 ? o.copy(this.v2) : (o.copy(this.v2).sub(this.v1), o.multiplyScalar(e).add(this.v1)), o;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(e, s) {
    return this.getPoint(e, s);
  }
  getTangent(e, s = new Vector2()) {
    return s.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(e, s) {
    return this.getTangent(e, s);
  }
  copy(e) {
    return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
  }
}
class LineCurve3 extends Curve {
  constructor(e = new Vector3$1(), s = new Vector3$1()) {
    super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = e, this.v2 = s;
  }
  getPoint(e, s = new Vector3$1()) {
    const o = s;
    return e === 1 ? o.copy(this.v2) : (o.copy(this.v2).sub(this.v1), o.multiplyScalar(e).add(this.v1)), o;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(e, s) {
    return this.getPoint(e, s);
  }
  getTangent(e, s = new Vector3$1()) {
    return s.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(e, s) {
    return this.getTangent(e, s);
  }
  copy(e) {
    return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
  }
}
class QuadraticBezierCurve extends Curve {
  constructor(e = new Vector2(), s = new Vector2(), o = new Vector2()) {
    super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = e, this.v1 = s, this.v2 = o;
  }
  getPoint(e, s = new Vector2()) {
    const o = s, a = this.v0, l = this.v1, u = this.v2;
    return o.set(
      QuadraticBezier(e, a.x, l.x, u.x),
      QuadraticBezier(e, a.y, l.y, u.y)
    ), o;
  }
  copy(e) {
    return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
  }
}
class QuadraticBezierCurve3 extends Curve {
  constructor(e = new Vector3$1(), s = new Vector3$1(), o = new Vector3$1()) {
    super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = e, this.v1 = s, this.v2 = o;
  }
  getPoint(e, s = new Vector3$1()) {
    const o = s, a = this.v0, l = this.v1, u = this.v2;
    return o.set(
      QuadraticBezier(e, a.x, l.x, u.x),
      QuadraticBezier(e, a.y, l.y, u.y),
      QuadraticBezier(e, a.z, l.z, u.z)
    ), o;
  }
  copy(e) {
    return super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
  }
}
class SplineCurve extends Curve {
  constructor(e = []) {
    super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = e;
  }
  getPoint(e, s = new Vector2()) {
    const o = s, a = this.points, l = (a.length - 1) * e, u = Math.floor(l), c = l - u, E = a[u === 0 ? u : u - 1], d = a[u], f = a[u > a.length - 2 ? a.length - 1 : u + 1], h = a[u > a.length - 3 ? a.length - 1 : u + 2];
    return o.set(
      CatmullRom(c, E.x, d.x, f.x, h.x),
      CatmullRom(c, E.y, d.y, f.y, h.y)
    ), o;
  }
  copy(e) {
    super.copy(e), this.points = [];
    for (let s = 0, o = e.points.length; s < o; s++) {
      const a = e.points[s];
      this.points.push(a.clone());
    }
    return this;
  }
  toJSON() {
    const e = super.toJSON();
    e.points = [];
    for (let s = 0, o = this.points.length; s < o; s++) {
      const a = this.points[s];
      e.points.push(a.toArray());
    }
    return e;
  }
  fromJSON(e) {
    super.fromJSON(e), this.points = [];
    for (let s = 0, o = e.points.length; s < o; s++) {
      const a = e.points[s];
      this.points.push(new Vector2().fromArray(a));
    }
    return this;
  }
}
var Curves = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve,
  CatmullRomCurve3,
  CubicBezierCurve,
  CubicBezierCurve3,
  EllipseCurve,
  LineCurve,
  LineCurve3,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  SplineCurve
});
class CurvePath extends Curve {
  constructor() {
    super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
  }
  add(e) {
    this.curves.push(e);
  }
  closePath() {
    const e = this.curves[0].getPoint(0), s = this.curves[this.curves.length - 1].getPoint(1);
    e.equals(s) || this.curves.push(new LineCurve(s, e));
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(e, s) {
    const o = e * this.getLength(), a = this.getCurveLengths();
    let l = 0;
    for (; l < a.length; ) {
      if (a[l] >= o) {
        const u = a[l] - o, c = this.curves[l], E = c.getLength(), d = E === 0 ? 0 : 1 - u / E;
        return c.getPointAt(d, s);
      }
      l++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const e = this.getCurveLengths();
    return e[e.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length)
      return this.cacheLengths;
    const e = [];
    let s = 0;
    for (let o = 0, a = this.curves.length; o < a; o++)
      s += this.curves[o].getLength(), e.push(s);
    return this.cacheLengths = e, e;
  }
  getSpacedPoints(e = 40) {
    const s = [];
    for (let o = 0; o <= e; o++)
      s.push(this.getPoint(o / e));
    return this.autoClose && s.push(s[0]), s;
  }
  getPoints(e = 12) {
    const s = [];
    let o;
    for (let a = 0, l = this.curves; a < l.length; a++) {
      const u = l[a], c = u.isEllipseCurve ? e * 2 : u.isLineCurve || u.isLineCurve3 ? 1 : u.isSplineCurve ? e * u.points.length : e, E = u.getPoints(c);
      for (let d = 0; d < E.length; d++) {
        const f = E[d];
        o && o.equals(f) || (s.push(f), o = f);
      }
    }
    return this.autoClose && s.length > 1 && !s[s.length - 1].equals(s[0]) && s.push(s[0]), s;
  }
  copy(e) {
    super.copy(e), this.curves = [];
    for (let s = 0, o = e.curves.length; s < o; s++) {
      const a = e.curves[s];
      this.curves.push(a.clone());
    }
    return this.autoClose = e.autoClose, this;
  }
  toJSON() {
    const e = super.toJSON();
    e.autoClose = this.autoClose, e.curves = [];
    for (let s = 0, o = this.curves.length; s < o; s++) {
      const a = this.curves[s];
      e.curves.push(a.toJSON());
    }
    return e;
  }
  fromJSON(e) {
    super.fromJSON(e), this.autoClose = e.autoClose, this.curves = [];
    for (let s = 0, o = e.curves.length; s < o; s++) {
      const a = e.curves[s];
      this.curves.push(new Curves[a.type]().fromJSON(a));
    }
    return this;
  }
}
class Path extends CurvePath {
  constructor(e) {
    super(), this.type = "Path", this.currentPoint = new Vector2(), e && this.setFromPoints(e);
  }
  setFromPoints(e) {
    this.moveTo(e[0].x, e[0].y);
    for (let s = 1, o = e.length; s < o; s++)
      this.lineTo(e[s].x, e[s].y);
    return this;
  }
  moveTo(e, s) {
    return this.currentPoint.set(e, s), this;
  }
  lineTo(e, s) {
    const o = new LineCurve(this.currentPoint.clone(), new Vector2(e, s));
    return this.curves.push(o), this.currentPoint.set(e, s), this;
  }
  quadraticCurveTo(e, s, o, a) {
    const l = new QuadraticBezierCurve(
      this.currentPoint.clone(),
      new Vector2(e, s),
      new Vector2(o, a)
    );
    return this.curves.push(l), this.currentPoint.set(o, a), this;
  }
  bezierCurveTo(e, s, o, a, l, u) {
    const c = new CubicBezierCurve(
      this.currentPoint.clone(),
      new Vector2(e, s),
      new Vector2(o, a),
      new Vector2(l, u)
    );
    return this.curves.push(c), this.currentPoint.set(l, u), this;
  }
  splineThru(e) {
    const s = [this.currentPoint.clone()].concat(e), o = new SplineCurve(s);
    return this.curves.push(o), this.currentPoint.copy(e[e.length - 1]), this;
  }
  arc(e, s, o, a, l, u) {
    const c = this.currentPoint.x, E = this.currentPoint.y;
    return this.absarc(
      e + c,
      s + E,
      o,
      a,
      l,
      u
    ), this;
  }
  absarc(e, s, o, a, l, u) {
    return this.absellipse(e, s, o, o, a, l, u), this;
  }
  ellipse(e, s, o, a, l, u, c, E) {
    const d = this.currentPoint.x, f = this.currentPoint.y;
    return this.absellipse(e + d, s + f, o, a, l, u, c, E), this;
  }
  absellipse(e, s, o, a, l, u, c, E) {
    const d = new EllipseCurve(e, s, o, a, l, u, c, E);
    if (this.curves.length > 0) {
      const h = d.getPoint(0);
      h.equals(this.currentPoint) || this.lineTo(h.x, h.y);
    }
    this.curves.push(d);
    const f = d.getPoint(1);
    return this.currentPoint.copy(f), this;
  }
  copy(e) {
    return super.copy(e), this.currentPoint.copy(e.currentPoint), this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.currentPoint = this.currentPoint.toArray(), e;
  }
  fromJSON(e) {
    return super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this;
  }
}
class CircleGeometry extends BufferGeometry {
  constructor(e = 1, s = 32, o = 0, a = Math.PI * 2) {
    super(), this.type = "CircleGeometry", this.parameters = {
      radius: e,
      segments: s,
      thetaStart: o,
      thetaLength: a
    }, s = Math.max(3, s);
    const l = [], u = [], c = [], E = [], d = new Vector3$1(), f = new Vector2();
    u.push(0, 0, 0), c.push(0, 0, 1), E.push(0.5, 0.5);
    for (let h = 0, S = 3; h <= s; h++, S += 3) {
      const R = o + h / s * a;
      d.x = e * Math.cos(R), d.y = e * Math.sin(R), u.push(d.x, d.y, d.z), c.push(0, 0, 1), f.x = (u[S] / e + 1) / 2, f.y = (u[S + 1] / e + 1) / 2, E.push(f.x, f.y);
    }
    for (let h = 1; h <= s; h++)
      l.push(h, h + 1, 0);
    this.setIndex(l), this.setAttribute("position", new Float32BufferAttribute(u, 3)), this.setAttribute("normal", new Float32BufferAttribute(c, 3)), this.setAttribute("uv", new Float32BufferAttribute(E, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new CircleGeometry(e.radius, e.segments, e.thetaStart, e.thetaLength);
  }
}
class CylinderGeometry extends BufferGeometry {
  constructor(e = 1, s = 1, o = 1, a = 32, l = 1, u = !1, c = 0, E = Math.PI * 2) {
    super(), this.type = "CylinderGeometry", this.parameters = {
      radiusTop: e,
      radiusBottom: s,
      height: o,
      radialSegments: a,
      heightSegments: l,
      openEnded: u,
      thetaStart: c,
      thetaLength: E
    };
    const d = this;
    a = Math.floor(a), l = Math.floor(l);
    const f = [], h = [], S = [], R = [];
    let _ = 0;
    const m = [], L = o / 2;
    let F = 0;
    W(), u === !1 && (e > 0 && G(!0), s > 0 && G(!1)), this.setIndex(f), this.setAttribute("position", new Float32BufferAttribute(h, 3)), this.setAttribute("normal", new Float32BufferAttribute(S, 3)), this.setAttribute("uv", new Float32BufferAttribute(R, 2));
    function W() {
      const q = new Vector3$1(), fe = new Vector3$1();
      let _e = 0;
      const Le = (s - e) / o;
      for (let Fe = 0; Fe <= l; Fe++) {
        const Ee = [], Ge = Fe / l, ve = Ge * (s - e) + e;
        for (let te = 0; te <= a; te++) {
          const ae = te / a, v = ae * E + c, Te = Math.sin(v), De = Math.cos(v);
          fe.x = ve * Te, fe.y = -Ge * o + L, fe.z = ve * De, h.push(fe.x, fe.y, fe.z), q.set(Te, Le, De).normalize(), S.push(q.x, q.y, q.z), R.push(ae, 1 - Ge), Ee.push(_++);
        }
        m.push(Ee);
      }
      for (let Fe = 0; Fe < a; Fe++)
        for (let Ee = 0; Ee < l; Ee++) {
          const Ge = m[Ee][Fe], ve = m[Ee + 1][Fe], te = m[Ee + 1][Fe + 1], ae = m[Ee][Fe + 1];
          f.push(Ge, ve, ae), f.push(ve, te, ae), _e += 6;
        }
      d.addGroup(F, _e, 0), F += _e;
    }
    function G(q) {
      const fe = _, _e = new Vector2(), Le = new Vector3$1();
      let Fe = 0;
      const Ee = q === !0 ? e : s, Ge = q === !0 ? 1 : -1;
      for (let te = 1; te <= a; te++)
        h.push(0, L * Ge, 0), S.push(0, Ge, 0), R.push(0.5, 0.5), _++;
      const ve = _;
      for (let te = 0; te <= a; te++) {
        const v = te / a * E + c, Te = Math.cos(v), De = Math.sin(v);
        Le.x = Ee * De, Le.y = L * Ge, Le.z = Ee * Te, h.push(Le.x, Le.y, Le.z), S.push(0, Ge, 0), _e.x = Te * 0.5 + 0.5, _e.y = De * 0.5 * Ge + 0.5, R.push(_e.x, _e.y), _++;
      }
      for (let te = 0; te < a; te++) {
        const ae = fe + te, v = ve + te;
        q === !0 ? f.push(v, v + 1, ae) : f.push(v + 1, v, ae), Fe += 3;
      }
      d.addGroup(F, Fe, q === !0 ? 1 : 2), F += Fe;
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new CylinderGeometry(e.radiusTop, e.radiusBottom, e.height, e.radialSegments, e.heightSegments, e.openEnded, e.thetaStart, e.thetaLength);
  }
}
class ConeGeometry extends CylinderGeometry {
  constructor(e = 1, s = 1, o = 32, a = 1, l = !1, u = 0, c = Math.PI * 2) {
    super(0, e, s, o, a, l, u, c), this.type = "ConeGeometry", this.parameters = {
      radius: e,
      height: s,
      radialSegments: o,
      heightSegments: a,
      openEnded: l,
      thetaStart: u,
      thetaLength: c
    };
  }
  static fromJSON(e) {
    return new ConeGeometry(e.radius, e.height, e.radialSegments, e.heightSegments, e.openEnded, e.thetaStart, e.thetaLength);
  }
}
const _v0 = /* @__PURE__ */ new Vector3$1(), _v1$1 = /* @__PURE__ */ new Vector3$1(), _normal = /* @__PURE__ */ new Vector3$1(), _triangle = /* @__PURE__ */ new Triangle();
class EdgesGeometry extends BufferGeometry {
  constructor(e = null, s = 1) {
    if (super(), this.type = "EdgesGeometry", this.parameters = {
      geometry: e,
      thresholdAngle: s
    }, e !== null) {
      const a = Math.pow(10, 4), l = Math.cos(DEG2RAD * s), u = e.getIndex(), c = e.getAttribute("position"), E = u ? u.count : c.count, d = [0, 0, 0], f = ["a", "b", "c"], h = new Array(3), S = {}, R = [];
      for (let _ = 0; _ < E; _ += 3) {
        u ? (d[0] = u.getX(_), d[1] = u.getX(_ + 1), d[2] = u.getX(_ + 2)) : (d[0] = _, d[1] = _ + 1, d[2] = _ + 2);
        const { a: m, b: L, c: F } = _triangle;
        if (m.fromBufferAttribute(c, d[0]), L.fromBufferAttribute(c, d[1]), F.fromBufferAttribute(c, d[2]), _triangle.getNormal(_normal), h[0] = `${Math.round(m.x * a)},${Math.round(m.y * a)},${Math.round(m.z * a)}`, h[1] = `${Math.round(L.x * a)},${Math.round(L.y * a)},${Math.round(L.z * a)}`, h[2] = `${Math.round(F.x * a)},${Math.round(F.y * a)},${Math.round(F.z * a)}`, !(h[0] === h[1] || h[1] === h[2] || h[2] === h[0]))
          for (let W = 0; W < 3; W++) {
            const G = (W + 1) % 3, q = h[W], fe = h[G], _e = _triangle[f[W]], Le = _triangle[f[G]], Fe = `${q}_${fe}`, Ee = `${fe}_${q}`;
            Ee in S && S[Ee] ? (_normal.dot(S[Ee].normal) <= l && (R.push(_e.x, _e.y, _e.z), R.push(Le.x, Le.y, Le.z)), S[Ee] = null) : Fe in S || (S[Fe] = {
              index0: d[W],
              index1: d[G],
              normal: _normal.clone()
            });
          }
      }
      for (const _ in S)
        if (S[_]) {
          const { index0: m, index1: L } = S[_];
          _v0.fromBufferAttribute(c, m), _v1$1.fromBufferAttribute(c, L), R.push(_v0.x, _v0.y, _v0.z), R.push(_v1$1.x, _v1$1.y, _v1$1.z);
        }
      this.setAttribute("position", new Float32BufferAttribute(R, 3));
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
}
class Shape extends Path {
  constructor(e) {
    super(e), this.uuid = generateUUID$1(), this.type = "Shape", this.holes = [];
  }
  getPointsHoles(e) {
    const s = [];
    for (let o = 0, a = this.holes.length; o < a; o++)
      s[o] = this.holes[o].getPoints(e);
    return s;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(e) {
    return {
      shape: this.getPoints(e),
      holes: this.getPointsHoles(e)
    };
  }
  copy(e) {
    super.copy(e), this.holes = [];
    for (let s = 0, o = e.holes.length; s < o; s++) {
      const a = e.holes[s];
      this.holes.push(a.clone());
    }
    return this;
  }
  toJSON() {
    const e = super.toJSON();
    e.uuid = this.uuid, e.holes = [];
    for (let s = 0, o = this.holes.length; s < o; s++) {
      const a = this.holes[s];
      e.holes.push(a.toJSON());
    }
    return e;
  }
  fromJSON(e) {
    super.fromJSON(e), this.uuid = e.uuid, this.holes = [];
    for (let s = 0, o = e.holes.length; s < o; s++) {
      const a = e.holes[s];
      this.holes.push(new Path().fromJSON(a));
    }
    return this;
  }
}
const Earcut = {
  triangulate: function(r, e, s = 2) {
    const o = e && e.length, a = o ? e[0] * s : r.length;
    let l = linkedList$2(r, 0, a, s, !0);
    const u = [];
    if (!l || l.next === l.prev)
      return u;
    let c, E, d, f, h, S, R;
    if (o && (l = eliminateHoles$2(r, e, l, s)), r.length > 80 * s) {
      c = d = r[0], E = f = r[1];
      for (let _ = s; _ < a; _ += s)
        h = r[_], S = r[_ + 1], h < c && (c = h), S < E && (E = S), h > d && (d = h), S > f && (f = S);
      R = Math.max(d - c, f - E), R = R !== 0 ? 32767 / R : 0;
    }
    return earcutLinked$2(l, u, s, c, E, R, 0), u;
  }
};
function linkedList$2(r, e, s, o, a) {
  let l, u;
  if (a === signedArea$2(r, e, s, o) > 0)
    for (l = e; l < s; l += o)
      u = insertNode$2(l, r[l], r[l + 1], u);
  else
    for (l = s - o; l >= e; l -= o)
      u = insertNode$2(l, r[l], r[l + 1], u);
  return u && equals$2(u, u.next) && (removeNode$2(u), u = u.next), u;
}
function filterPoints$2(r, e) {
  if (!r)
    return r;
  e || (e = r);
  let s = r, o;
  do
    if (o = !1, !s.steiner && (equals$2(s, s.next) || area$2(s.prev, s, s.next) === 0)) {
      if (removeNode$2(s), s = e = s.prev, s === s.next)
        break;
      o = !0;
    } else
      s = s.next;
  while (o || s !== e);
  return e;
}
function earcutLinked$2(r, e, s, o, a, l, u) {
  if (!r)
    return;
  !u && l && indexCurve$2(r, o, a, l);
  let c = r, E, d;
  for (; r.prev !== r.next; ) {
    if (E = r.prev, d = r.next, l ? isEarHashed$2(r, o, a, l) : isEar$2(r)) {
      e.push(E.i / s | 0), e.push(r.i / s | 0), e.push(d.i / s | 0), removeNode$2(r), r = d.next, c = d.next;
      continue;
    }
    if (r = d, r === c) {
      u ? u === 1 ? (r = cureLocalIntersections$2(filterPoints$2(r), e, s), earcutLinked$2(r, e, s, o, a, l, 2)) : u === 2 && splitEarcut$2(r, e, s, o, a, l) : earcutLinked$2(filterPoints$2(r), e, s, o, a, l, 1);
      break;
    }
  }
}
function isEar$2(r) {
  const e = r.prev, s = r, o = r.next;
  if (area$2(e, s, o) >= 0)
    return !1;
  const a = e.x, l = s.x, u = o.x, c = e.y, E = s.y, d = o.y, f = a < l ? a < u ? a : u : l < u ? l : u, h = c < E ? c < d ? c : d : E < d ? E : d, S = a > l ? a > u ? a : u : l > u ? l : u, R = c > E ? c > d ? c : d : E > d ? E : d;
  let _ = o.next;
  for (; _ !== e; ) {
    if (_.x >= f && _.x <= S && _.y >= h && _.y <= R && pointInTriangle$2(a, c, l, E, u, d, _.x, _.y) && area$2(_.prev, _, _.next) >= 0)
      return !1;
    _ = _.next;
  }
  return !0;
}
function isEarHashed$2(r, e, s, o) {
  const a = r.prev, l = r, u = r.next;
  if (area$2(a, l, u) >= 0)
    return !1;
  const c = a.x, E = l.x, d = u.x, f = a.y, h = l.y, S = u.y, R = c < E ? c < d ? c : d : E < d ? E : d, _ = f < h ? f < S ? f : S : h < S ? h : S, m = c > E ? c > d ? c : d : E > d ? E : d, L = f > h ? f > S ? f : S : h > S ? h : S, F = zOrder$2(R, _, e, s, o), W = zOrder$2(m, L, e, s, o);
  let G = r.prevZ, q = r.nextZ;
  for (; G && G.z >= F && q && q.z <= W; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangle$2(c, f, E, h, d, S, G.x, G.y) && area$2(G.prev, G, G.next) >= 0 || (G = G.prevZ, q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangle$2(c, f, E, h, d, S, q.x, q.y) && area$2(q.prev, q, q.next) >= 0))
      return !1;
    q = q.nextZ;
  }
  for (; G && G.z >= F; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangle$2(c, f, E, h, d, S, G.x, G.y) && area$2(G.prev, G, G.next) >= 0)
      return !1;
    G = G.prevZ;
  }
  for (; q && q.z <= W; ) {
    if (q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangle$2(c, f, E, h, d, S, q.x, q.y) && area$2(q.prev, q, q.next) >= 0)
      return !1;
    q = q.nextZ;
  }
  return !0;
}
function cureLocalIntersections$2(r, e, s) {
  let o = r;
  do {
    const a = o.prev, l = o.next.next;
    !equals$2(a, l) && intersects$2(a, o, o.next, l) && locallyInside$2(a, l) && locallyInside$2(l, a) && (e.push(a.i / s | 0), e.push(o.i / s | 0), e.push(l.i / s | 0), removeNode$2(o), removeNode$2(o.next), o = r = l), o = o.next;
  } while (o !== r);
  return filterPoints$2(o);
}
function splitEarcut$2(r, e, s, o, a, l) {
  let u = r;
  do {
    let c = u.next.next;
    for (; c !== u.prev; ) {
      if (u.i !== c.i && isValidDiagonal$2(u, c)) {
        let E = splitPolygon$2(u, c);
        u = filterPoints$2(u, u.next), E = filterPoints$2(E, E.next), earcutLinked$2(u, e, s, o, a, l, 0), earcutLinked$2(E, e, s, o, a, l, 0);
        return;
      }
      c = c.next;
    }
    u = u.next;
  } while (u !== r);
}
function eliminateHoles$2(r, e, s, o) {
  const a = [];
  let l, u, c, E, d;
  for (l = 0, u = e.length; l < u; l++)
    c = e[l] * o, E = l < u - 1 ? e[l + 1] * o : r.length, d = linkedList$2(r, c, E, o, !1), d === d.next && (d.steiner = !0), a.push(getLeftmost$2(d));
  for (a.sort(compareX$1), l = 0; l < a.length; l++)
    s = eliminateHole$2(a[l], s);
  return s;
}
function compareX$1(r, e) {
  return r.x - e.x;
}
function eliminateHole$2(r, e) {
  const s = findHoleBridge$2(r, e);
  if (!s)
    return e;
  const o = splitPolygon$2(s, r);
  return filterPoints$2(o, o.next), filterPoints$2(s, s.next);
}
function findHoleBridge$2(r, e) {
  let s = e, o = -1 / 0, a;
  const l = r.x, u = r.y;
  do {
    if (u <= s.y && u >= s.next.y && s.next.y !== s.y) {
      const S = s.x + (u - s.y) * (s.next.x - s.x) / (s.next.y - s.y);
      if (S <= l && S > o && (o = S, a = s.x < s.next.x ? s : s.next, S === l))
        return a;
    }
    s = s.next;
  } while (s !== e);
  if (!a)
    return null;
  const c = a, E = a.x, d = a.y;
  let f = 1 / 0, h;
  s = a;
  do
    l >= s.x && s.x >= E && l !== s.x && pointInTriangle$2(u < d ? l : o, u, E, d, u < d ? o : l, u, s.x, s.y) && (h = Math.abs(u - s.y) / (l - s.x), locallyInside$2(s, r) && (h < f || h === f && (s.x > a.x || s.x === a.x && sectorContainsSector$2(a, s))) && (a = s, f = h)), s = s.next;
  while (s !== c);
  return a;
}
function sectorContainsSector$2(r, e) {
  return area$2(r.prev, r, e.prev) < 0 && area$2(e.next, r, r.next) < 0;
}
function indexCurve$2(r, e, s, o) {
  let a = r;
  do
    a.z === 0 && (a.z = zOrder$2(a.x, a.y, e, s, o)), a.prevZ = a.prev, a.nextZ = a.next, a = a.next;
  while (a !== r);
  a.prevZ.nextZ = null, a.prevZ = null, sortLinked$2(a);
}
function sortLinked$2(r) {
  let e, s, o, a, l, u, c, E, d = 1;
  do {
    for (s = r, r = null, l = null, u = 0; s; ) {
      for (u++, o = s, c = 0, e = 0; e < d && (c++, o = o.nextZ, !!o); e++)
        ;
      for (E = d; c > 0 || E > 0 && o; )
        c !== 0 && (E === 0 || !o || s.z <= o.z) ? (a = s, s = s.nextZ, c--) : (a = o, o = o.nextZ, E--), l ? l.nextZ = a : r = a, a.prevZ = l, l = a;
      s = o;
    }
    l.nextZ = null, d *= 2;
  } while (u > 1);
  return r;
}
function zOrder$2(r, e, s, o, a) {
  return r = (r - s) * a | 0, e = (e - o) * a | 0, r = (r | r << 8) & 16711935, r = (r | r << 4) & 252645135, r = (r | r << 2) & 858993459, r = (r | r << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, r | e << 1;
}
function getLeftmost$2(r) {
  let e = r, s = r;
  do
    (e.x < s.x || e.x === s.x && e.y < s.y) && (s = e), e = e.next;
  while (e !== r);
  return s;
}
function pointInTriangle$2(r, e, s, o, a, l, u, c) {
  return (a - u) * (e - c) >= (r - u) * (l - c) && (r - u) * (o - c) >= (s - u) * (e - c) && (s - u) * (l - c) >= (a - u) * (o - c);
}
function isValidDiagonal$2(r, e) {
  return r.next.i !== e.i && r.prev.i !== e.i && !intersectsPolygon$2(r, e) && // dones't intersect other edges
  (locallyInside$2(r, e) && locallyInside$2(e, r) && middleInside$2(r, e) && // locally visible
  (area$2(r.prev, r, e.prev) || area$2(r, e.prev, e)) || // does not create opposite-facing sectors
  equals$2(r, e) && area$2(r.prev, r, r.next) > 0 && area$2(e.prev, e, e.next) > 0);
}
function area$2(r, e, s) {
  return (e.y - r.y) * (s.x - e.x) - (e.x - r.x) * (s.y - e.y);
}
function equals$2(r, e) {
  return r.x === e.x && r.y === e.y;
}
function intersects$2(r, e, s, o) {
  const a = sign$8(area$2(r, e, s)), l = sign$8(area$2(r, e, o)), u = sign$8(area$2(s, o, r)), c = sign$8(area$2(s, o, e));
  return !!(a !== l && u !== c || a === 0 && onSegment$2(r, s, e) || l === 0 && onSegment$2(r, o, e) || u === 0 && onSegment$2(s, r, o) || c === 0 && onSegment$2(s, e, o));
}
function onSegment$2(r, e, s) {
  return e.x <= Math.max(r.x, s.x) && e.x >= Math.min(r.x, s.x) && e.y <= Math.max(r.y, s.y) && e.y >= Math.min(r.y, s.y);
}
function sign$8(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}
function intersectsPolygon$2(r, e) {
  let s = r;
  do {
    if (s.i !== r.i && s.next.i !== r.i && s.i !== e.i && s.next.i !== e.i && intersects$2(s, s.next, r, e))
      return !0;
    s = s.next;
  } while (s !== r);
  return !1;
}
function locallyInside$2(r, e) {
  return area$2(r.prev, r, r.next) < 0 ? area$2(r, e, r.next) >= 0 && area$2(r, r.prev, e) >= 0 : area$2(r, e, r.prev) < 0 || area$2(r, r.next, e) < 0;
}
function middleInside$2(r, e) {
  let s = r, o = !1;
  const a = (r.x + e.x) / 2, l = (r.y + e.y) / 2;
  do
    s.y > l != s.next.y > l && s.next.y !== s.y && a < (s.next.x - s.x) * (l - s.y) / (s.next.y - s.y) + s.x && (o = !o), s = s.next;
  while (s !== r);
  return o;
}
function splitPolygon$2(r, e) {
  const s = new Node$3(r.i, r.x, r.y), o = new Node$3(e.i, e.x, e.y), a = r.next, l = e.prev;
  return r.next = e, e.prev = r, s.next = a, a.prev = s, o.next = s, s.prev = o, l.next = o, o.prev = l, o;
}
function insertNode$2(r, e, s, o) {
  const a = new Node$3(r, e, s);
  return o ? (a.next = o.next, a.prev = o, o.next.prev = a, o.next = a) : (a.prev = a, a.next = a), a;
}
function removeNode$2(r) {
  r.next.prev = r.prev, r.prev.next = r.next, r.prevZ && (r.prevZ.nextZ = r.nextZ), r.nextZ && (r.nextZ.prevZ = r.prevZ);
}
function Node$3(r, e, s) {
  this.i = r, this.x = e, this.y = s, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function signedArea$2(r, e, s, o) {
  let a = 0;
  for (let l = e, u = s - o; l < s; l += o)
    a += (r[u] - r[l]) * (r[l + 1] + r[u + 1]), u = l;
  return a;
}
class ShapeUtils {
  // calculate area of the contour polygon
  static area(e) {
    const s = e.length;
    let o = 0;
    for (let a = s - 1, l = 0; l < s; a = l++)
      o += e[a].x * e[l].y - e[l].x * e[a].y;
    return o * 0.5;
  }
  static isClockWise(e) {
    return ShapeUtils.area(e) < 0;
  }
  static triangulateShape(e, s) {
    const o = [], a = [], l = [];
    removeDupEndPts(e), addContour(o, e);
    let u = e.length;
    s.forEach(removeDupEndPts);
    for (let E = 0; E < s.length; E++)
      a.push(u), u += s[E].length, addContour(o, s[E]);
    const c = Earcut.triangulate(o, a);
    for (let E = 0; E < c.length; E += 3)
      l.push(c.slice(E, E + 3));
    return l;
  }
}
function removeDupEndPts(r) {
  const e = r.length;
  e > 2 && r[e - 1].equals(r[0]) && r.pop();
}
function addContour(r, e) {
  for (let s = 0; s < e.length; s++)
    r.push(e[s].x), r.push(e[s].y);
}
class ExtrudeGeometry extends BufferGeometry {
  constructor(e = new Shape([new Vector2(0.5, 0.5), new Vector2(-0.5, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]), s = {}) {
    super(), this.type = "ExtrudeGeometry", this.parameters = {
      shapes: e,
      options: s
    }, e = Array.isArray(e) ? e : [e];
    const o = this, a = [], l = [];
    for (let c = 0, E = e.length; c < E; c++) {
      const d = e[c];
      u(d);
    }
    this.setAttribute("position", new Float32BufferAttribute(a, 3)), this.setAttribute("uv", new Float32BufferAttribute(l, 2)), this.computeVertexNormals();
    function u(c) {
      const E = [], d = s.curveSegments !== void 0 ? s.curveSegments : 12, f = s.steps !== void 0 ? s.steps : 1, h = s.depth !== void 0 ? s.depth : 1;
      let S = s.bevelEnabled !== void 0 ? s.bevelEnabled : !0, R = s.bevelThickness !== void 0 ? s.bevelThickness : 0.2, _ = s.bevelSize !== void 0 ? s.bevelSize : R - 0.1, m = s.bevelOffset !== void 0 ? s.bevelOffset : 0, L = s.bevelSegments !== void 0 ? s.bevelSegments : 3;
      const F = s.extrudePath, W = s.UVGenerator !== void 0 ? s.UVGenerator : WorldUVGenerator;
      let G, q = !1, fe, _e, Le, Fe;
      F && (G = F.getSpacedPoints(f), q = !0, S = !1, fe = F.computeFrenetFrames(f, !1), _e = new Vector3$1(), Le = new Vector3$1(), Fe = new Vector3$1()), S || (L = 0, R = 0, _ = 0, m = 0);
      const Ee = c.extractPoints(d);
      let Ge = Ee.shape;
      const ve = Ee.holes;
      if (!ShapeUtils.isClockWise(Ge)) {
        Ge = Ge.reverse();
        for (let st = 0, jt = ve.length; st < jt; st++) {
          const lt = ve[st];
          ShapeUtils.isClockWise(lt) && (ve[st] = lt.reverse());
        }
      }
      const ae = ShapeUtils.triangulateShape(Ge, ve), v = Ge;
      for (let st = 0, jt = ve.length; st < jt; st++) {
        const lt = ve[st];
        Ge = Ge.concat(lt);
      }
      function Te(st, jt, lt) {
        return jt || console.error("THREE.ExtrudeGeometry: vec does not exist"), st.clone().addScaledVector(jt, lt);
      }
      const De = Ge.length, be = ae.length;
      function ze(st, jt, lt) {
        let Zt, Et, Ke;
        const $e = st.x - jt.x, pt = st.y - jt.y, Jt = lt.x - st.x, In = lt.y - st.y, Cn = $e * $e + pt * pt, It = $e * In - pt * Jt;
        if (Math.abs(It) > Number.EPSILON) {
          const ht = Math.sqrt(Cn), Wt = Math.sqrt(Jt * Jt + In * In), hn = jt.x - pt / ht, Vt = jt.y + $e / ht, Tn = lt.x - In / Wt, Rn = lt.y + Jt / Wt, Nn = ((Tn - hn) * In - (Rn - Vt) * Jt) / ($e * In - pt * Jt);
          Zt = hn + $e * Nn - st.x, Et = Vt + pt * Nn - st.y;
          const Dn = Zt * Zt + Et * Et;
          if (Dn <= 2)
            return new Vector2(Zt, Et);
          Ke = Math.sqrt(Dn / 2);
        } else {
          let ht = !1;
          $e > Number.EPSILON ? Jt > Number.EPSILON && (ht = !0) : $e < -Number.EPSILON ? Jt < -Number.EPSILON && (ht = !0) : Math.sign(pt) === Math.sign(In) && (ht = !0), ht ? (Zt = -pt, Et = $e, Ke = Math.sqrt(Cn)) : (Zt = $e, Et = pt, Ke = Math.sqrt(Cn / 2));
        }
        return new Vector2(Zt / Ke, Et / Ke);
      }
      const ke = [];
      for (let st = 0, jt = v.length, lt = jt - 1, Zt = st + 1; st < jt; st++, lt++, Zt++)
        lt === jt && (lt = 0), Zt === jt && (Zt = 0), ke[st] = ze(v[st], v[lt], v[Zt]);
      const Be = [];
      let Me, me = ke.concat();
      for (let st = 0, jt = ve.length; st < jt; st++) {
        const lt = ve[st];
        Me = [];
        for (let Zt = 0, Et = lt.length, Ke = Et - 1, $e = Zt + 1; Zt < Et; Zt++, Ke++, $e++)
          Ke === Et && (Ke = 0), $e === Et && ($e = 0), Me[Zt] = ze(lt[Zt], lt[Ke], lt[$e]);
        Be.push(Me), me = me.concat(Me);
      }
      for (let st = 0; st < L; st++) {
        const jt = st / L, lt = R * Math.cos(jt * Math.PI / 2), Zt = _ * Math.sin(jt * Math.PI / 2) + m;
        for (let Et = 0, Ke = v.length; Et < Ke; Et++) {
          const $e = Te(v[Et], ke[Et], Zt);
          ut($e.x, $e.y, -lt);
        }
        for (let Et = 0, Ke = ve.length; Et < Ke; Et++) {
          const $e = ve[Et];
          Me = Be[Et];
          for (let pt = 0, Jt = $e.length; pt < Jt; pt++) {
            const In = Te($e[pt], Me[pt], Zt);
            ut(In.x, In.y, -lt);
          }
        }
      }
      const Se = _ + m;
      for (let st = 0; st < De; st++) {
        const jt = S ? Te(Ge[st], me[st], Se) : Ge[st];
        q ? (Le.copy(fe.normals[0]).multiplyScalar(jt.x), _e.copy(fe.binormals[0]).multiplyScalar(jt.y), Fe.copy(G[0]).add(Le).add(_e), ut(Fe.x, Fe.y, Fe.z)) : ut(jt.x, jt.y, 0);
      }
      for (let st = 1; st <= f; st++)
        for (let jt = 0; jt < De; jt++) {
          const lt = S ? Te(Ge[jt], me[jt], Se) : Ge[jt];
          q ? (Le.copy(fe.normals[st]).multiplyScalar(lt.x), _e.copy(fe.binormals[st]).multiplyScalar(lt.y), Fe.copy(G[st]).add(Le).add(_e), ut(Fe.x, Fe.y, Fe.z)) : ut(lt.x, lt.y, h / f * st);
        }
      for (let st = L - 1; st >= 0; st--) {
        const jt = st / L, lt = R * Math.cos(jt * Math.PI / 2), Zt = _ * Math.sin(jt * Math.PI / 2) + m;
        for (let Et = 0, Ke = v.length; Et < Ke; Et++) {
          const $e = Te(v[Et], ke[Et], Zt);
          ut($e.x, $e.y, h + lt);
        }
        for (let Et = 0, Ke = ve.length; Et < Ke; Et++) {
          const $e = ve[Et];
          Me = Be[Et];
          for (let pt = 0, Jt = $e.length; pt < Jt; pt++) {
            const In = Te($e[pt], Me[pt], Zt);
            q ? ut(In.x, In.y + G[f - 1].y, G[f - 1].x + lt) : ut(In.x, In.y, h + lt);
          }
        }
      }
      xt(), Ht();
      function xt() {
        const st = a.length / 3;
        if (S) {
          let jt = 0, lt = De * jt;
          for (let Zt = 0; Zt < be; Zt++) {
            const Et = ae[Zt];
            Tt(Et[2] + lt, Et[1] + lt, Et[0] + lt);
          }
          jt = f + L * 2, lt = De * jt;
          for (let Zt = 0; Zt < be; Zt++) {
            const Et = ae[Zt];
            Tt(Et[0] + lt, Et[1] + lt, Et[2] + lt);
          }
        } else {
          for (let jt = 0; jt < be; jt++) {
            const lt = ae[jt];
            Tt(lt[2], lt[1], lt[0]);
          }
          for (let jt = 0; jt < be; jt++) {
            const lt = ae[jt];
            Tt(lt[0] + De * f, lt[1] + De * f, lt[2] + De * f);
          }
        }
        o.addGroup(st, a.length / 3 - st, 0);
      }
      function Ht() {
        const st = a.length / 3;
        let jt = 0;
        Bt(v, jt), jt += v.length;
        for (let lt = 0, Zt = ve.length; lt < Zt; lt++) {
          const Et = ve[lt];
          Bt(Et, jt), jt += Et.length;
        }
        o.addGroup(st, a.length / 3 - st, 1);
      }
      function Bt(st, jt) {
        let lt = st.length;
        for (; --lt >= 0; ) {
          const Zt = lt;
          let Et = lt - 1;
          Et < 0 && (Et = st.length - 1);
          for (let Ke = 0, $e = f + L * 2; Ke < $e; Ke++) {
            const pt = De * Ke, Jt = De * (Ke + 1), In = jt + Zt + pt, Cn = jt + Et + pt, It = jt + Et + Jt, ht = jt + Zt + Jt;
            Yt(In, Cn, It, ht);
          }
        }
      }
      function ut(st, jt, lt) {
        E.push(st), E.push(jt), E.push(lt);
      }
      function Tt(st, jt, lt) {
        an(st), an(jt), an(lt);
        const Zt = a.length / 3, Et = W.generateTopUV(o, a, Zt - 3, Zt - 2, Zt - 1);
        Ct(Et[0]), Ct(Et[1]), Ct(Et[2]);
      }
      function Yt(st, jt, lt, Zt) {
        an(st), an(jt), an(Zt), an(jt), an(lt), an(Zt);
        const Et = a.length / 3, Ke = W.generateSideWallUV(o, a, Et - 6, Et - 3, Et - 2, Et - 1);
        Ct(Ke[0]), Ct(Ke[1]), Ct(Ke[3]), Ct(Ke[1]), Ct(Ke[2]), Ct(Ke[3]);
      }
      function an(st) {
        a.push(E[st * 3 + 0]), a.push(E[st * 3 + 1]), a.push(E[st * 3 + 2]);
      }
      function Ct(st) {
        l.push(st.x), l.push(st.y);
      }
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  toJSON() {
    const e = super.toJSON(), s = this.parameters.shapes, o = this.parameters.options;
    return toJSON$1(s, o, e);
  }
  static fromJSON(e, s) {
    const o = [];
    for (let l = 0, u = e.shapes.length; l < u; l++) {
      const c = s[e.shapes[l]];
      o.push(c);
    }
    const a = e.options.extrudePath;
    return a !== void 0 && (e.options.extrudePath = new Curves[a.type]().fromJSON(a)), new ExtrudeGeometry(o, e.options);
  }
}
const WorldUVGenerator = {
  generateTopUV: function(r, e, s, o, a) {
    const l = e[s * 3], u = e[s * 3 + 1], c = e[o * 3], E = e[o * 3 + 1], d = e[a * 3], f = e[a * 3 + 1];
    return [
      new Vector2(l, u),
      new Vector2(c, E),
      new Vector2(d, f)
    ];
  },
  generateSideWallUV: function(r, e, s, o, a, l) {
    const u = e[s * 3], c = e[s * 3 + 1], E = e[s * 3 + 2], d = e[o * 3], f = e[o * 3 + 1], h = e[o * 3 + 2], S = e[a * 3], R = e[a * 3 + 1], _ = e[a * 3 + 2], m = e[l * 3], L = e[l * 3 + 1], F = e[l * 3 + 2];
    return Math.abs(c - f) < Math.abs(u - d) ? [
      new Vector2(u, 1 - E),
      new Vector2(d, 1 - h),
      new Vector2(S, 1 - _),
      new Vector2(m, 1 - F)
    ] : [
      new Vector2(c, 1 - E),
      new Vector2(f, 1 - h),
      new Vector2(R, 1 - _),
      new Vector2(L, 1 - F)
    ];
  }
};
function toJSON$1(r, e, s) {
  if (s.shapes = [], Array.isArray(r))
    for (let o = 0, a = r.length; o < a; o++) {
      const l = r[o];
      s.shapes.push(l.uuid);
    }
  else
    s.shapes.push(r.uuid);
  return s.options = Object.assign({}, e), e.extrudePath !== void 0 && (s.options.extrudePath = e.extrudePath.toJSON()), s;
}
class ShapeGeometry extends BufferGeometry {
  constructor(e = new Shape([new Vector2(0, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]), s = 12) {
    super(), this.type = "ShapeGeometry", this.parameters = {
      shapes: e,
      curveSegments: s
    };
    const o = [], a = [], l = [], u = [];
    let c = 0, E = 0;
    if (Array.isArray(e) === !1)
      d(e);
    else
      for (let f = 0; f < e.length; f++)
        d(e[f]), this.addGroup(c, E, f), c += E, E = 0;
    this.setIndex(o), this.setAttribute("position", new Float32BufferAttribute(a, 3)), this.setAttribute("normal", new Float32BufferAttribute(l, 3)), this.setAttribute("uv", new Float32BufferAttribute(u, 2));
    function d(f) {
      const h = a.length / 3, S = f.extractPoints(s);
      let R = S.shape;
      const _ = S.holes;
      ShapeUtils.isClockWise(R) === !1 && (R = R.reverse());
      for (let L = 0, F = _.length; L < F; L++) {
        const W = _[L];
        ShapeUtils.isClockWise(W) === !0 && (_[L] = W.reverse());
      }
      const m = ShapeUtils.triangulateShape(R, _);
      for (let L = 0, F = _.length; L < F; L++) {
        const W = _[L];
        R = R.concat(W);
      }
      for (let L = 0, F = R.length; L < F; L++) {
        const W = R[L];
        a.push(W.x, W.y, 0), l.push(0, 0, 1), u.push(W.x, W.y);
      }
      for (let L = 0, F = m.length; L < F; L++) {
        const W = m[L], G = W[0] + h, q = W[1] + h, fe = W[2] + h;
        o.push(G, q, fe), E += 3;
      }
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  toJSON() {
    const e = super.toJSON(), s = this.parameters.shapes;
    return toJSON(s, e);
  }
  static fromJSON(e, s) {
    const o = [];
    for (let a = 0, l = e.shapes.length; a < l; a++) {
      const u = s[e.shapes[a]];
      o.push(u);
    }
    return new ShapeGeometry(o, e.curveSegments);
  }
}
function toJSON(r, e) {
  if (e.shapes = [], Array.isArray(r))
    for (let s = 0, o = r.length; s < o; s++) {
      const a = r[s];
      e.shapes.push(a.uuid);
    }
  else
    e.shapes.push(r.uuid);
  return e;
}
class SphereGeometry extends BufferGeometry {
  constructor(e = 1, s = 32, o = 16, a = 0, l = Math.PI * 2, u = 0, c = Math.PI) {
    super(), this.type = "SphereGeometry", this.parameters = {
      radius: e,
      widthSegments: s,
      heightSegments: o,
      phiStart: a,
      phiLength: l,
      thetaStart: u,
      thetaLength: c
    }, s = Math.max(3, Math.floor(s)), o = Math.max(2, Math.floor(o));
    const E = Math.min(u + c, Math.PI);
    let d = 0;
    const f = [], h = new Vector3$1(), S = new Vector3$1(), R = [], _ = [], m = [], L = [];
    for (let F = 0; F <= o; F++) {
      const W = [], G = F / o;
      let q = 0;
      F === 0 && u === 0 ? q = 0.5 / s : F === o && E === Math.PI && (q = -0.5 / s);
      for (let fe = 0; fe <= s; fe++) {
        const _e = fe / s;
        h.x = -e * Math.cos(a + _e * l) * Math.sin(u + G * c), h.y = e * Math.cos(u + G * c), h.z = e * Math.sin(a + _e * l) * Math.sin(u + G * c), _.push(h.x, h.y, h.z), S.copy(h).normalize(), m.push(S.x, S.y, S.z), L.push(_e + q, 1 - G), W.push(d++);
      }
      f.push(W);
    }
    for (let F = 0; F < o; F++)
      for (let W = 0; W < s; W++) {
        const G = f[F][W + 1], q = f[F][W], fe = f[F + 1][W], _e = f[F + 1][W + 1];
        (F !== 0 || u > 0) && R.push(G, q, _e), (F !== o - 1 || E < Math.PI) && R.push(q, fe, _e);
      }
    this.setIndex(R), this.setAttribute("position", new Float32BufferAttribute(_, 3)), this.setAttribute("normal", new Float32BufferAttribute(m, 3)), this.setAttribute("uv", new Float32BufferAttribute(L, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new SphereGeometry(e.radius, e.widthSegments, e.heightSegments, e.phiStart, e.phiLength, e.thetaStart, e.thetaLength);
  }
}
class TorusGeometry extends BufferGeometry {
  constructor(e = 1, s = 0.4, o = 12, a = 48, l = Math.PI * 2) {
    super(), this.type = "TorusGeometry", this.parameters = {
      radius: e,
      tube: s,
      radialSegments: o,
      tubularSegments: a,
      arc: l
    }, o = Math.floor(o), a = Math.floor(a);
    const u = [], c = [], E = [], d = [], f = new Vector3$1(), h = new Vector3$1(), S = new Vector3$1();
    for (let R = 0; R <= o; R++)
      for (let _ = 0; _ <= a; _++) {
        const m = _ / a * l, L = R / o * Math.PI * 2;
        h.x = (e + s * Math.cos(L)) * Math.cos(m), h.y = (e + s * Math.cos(L)) * Math.sin(m), h.z = s * Math.sin(L), c.push(h.x, h.y, h.z), f.x = e * Math.cos(m), f.y = e * Math.sin(m), S.subVectors(h, f).normalize(), E.push(S.x, S.y, S.z), d.push(_ / a), d.push(R / o);
      }
    for (let R = 1; R <= o; R++)
      for (let _ = 1; _ <= a; _++) {
        const m = (a + 1) * R + _ - 1, L = (a + 1) * (R - 1) + _ - 1, F = (a + 1) * (R - 1) + _, W = (a + 1) * R + _;
        u.push(m, L, W), u.push(L, F, W);
      }
    this.setIndex(u), this.setAttribute("position", new Float32BufferAttribute(c, 3)), this.setAttribute("normal", new Float32BufferAttribute(E, 3)), this.setAttribute("uv", new Float32BufferAttribute(d, 2));
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
  static fromJSON(e) {
    return new TorusGeometry(e.radius, e.tube, e.radialSegments, e.tubularSegments, e.arc);
  }
}
class WireframeGeometry extends BufferGeometry {
  constructor(e = null) {
    if (super(), this.type = "WireframeGeometry", this.parameters = {
      geometry: e
    }, e !== null) {
      const s = [], o = /* @__PURE__ */ new Set(), a = new Vector3$1(), l = new Vector3$1();
      if (e.index !== null) {
        const u = e.attributes.position, c = e.index;
        let E = e.groups;
        E.length === 0 && (E = [{ start: 0, count: c.count, materialIndex: 0 }]);
        for (let d = 0, f = E.length; d < f; ++d) {
          const h = E[d], S = h.start, R = h.count;
          for (let _ = S, m = S + R; _ < m; _ += 3)
            for (let L = 0; L < 3; L++) {
              const F = c.getX(_ + L), W = c.getX(_ + (L + 1) % 3);
              a.fromBufferAttribute(u, F), l.fromBufferAttribute(u, W), isUniqueEdge(a, l, o) === !0 && (s.push(a.x, a.y, a.z), s.push(l.x, l.y, l.z));
            }
        }
      } else {
        const u = e.attributes.position;
        for (let c = 0, E = u.count / 3; c < E; c++)
          for (let d = 0; d < 3; d++) {
            const f = 3 * c + d, h = 3 * c + (d + 1) % 3;
            a.fromBufferAttribute(u, f), l.fromBufferAttribute(u, h), isUniqueEdge(a, l, o) === !0 && (s.push(a.x, a.y, a.z), s.push(l.x, l.y, l.z));
          }
      }
      this.setAttribute("position", new Float32BufferAttribute(s, 3));
    }
  }
  copy(e) {
    return super.copy(e), this.parameters = Object.assign({}, e.parameters), this;
  }
}
function isUniqueEdge(r, e, s) {
  const o = `${r.x},${r.y},${r.z}-${e.x},${e.y},${e.z}`, a = `${e.x},${e.y},${e.z}-${r.x},${r.y},${r.z}`;
  return s.has(o) === !0 || s.has(a) === !0 ? !1 : (s.add(o), s.add(a), !0);
}
class MeshStandardMaterial extends Material {
  constructor(e) {
    super(), this.isMeshStandardMaterial = !0, this.defines = { STANDARD: "" }, this.type = "MeshStandardMaterial", this.color = new Color(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Color(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = TangentSpaceNormalMap, this.normalScale = new Vector2(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class MeshPhysicalMaterial extends MeshStandardMaterial {
  constructor(e) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Vector2(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return clamp$2(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(s) {
        this.ior = (1 + 0.4 * s) / (1 - 0.4 * s);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new Color(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new Color(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Color(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e);
  }
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(e) {
    this._anisotropy > 0 != e > 0 && this.version++, this._anisotropy = e;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
  }
  copy(e) {
    return super.copy(e), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.anisotropy = e.anisotropy, this.anisotropyRotation = e.anisotropyRotation, this.anisotropyMap = e.anisotropyMap, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [...e.iridescenceThicknessRange], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
  }
}
class MeshPhongMaterial extends Material {
  constructor(e) {
    super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new Color(16777215), this.specular = new Color(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Color(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = TangentSpaceNormalMap, this.normalScale = new Vector2(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = MultiplyOperation, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class MeshLambertMaterial extends Material {
  constructor(e) {
    super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Color(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Color(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = TangentSpaceNormalMap, this.normalScale = new Vector2(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = MultiplyOperation, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
function arraySlice(r, e, s) {
  return isTypedArray$1(r) ? new r.constructor(r.subarray(e, s !== void 0 ? s : r.length)) : r.slice(e, s);
}
function convertArray(r, e, s) {
  return !r || // let 'undefined' and 'null' pass
  !s && r.constructor === e ? r : typeof e.BYTES_PER_ELEMENT == "number" ? new e(r) : Array.prototype.slice.call(r);
}
function isTypedArray$1(r) {
  return ArrayBuffer.isView(r) && !(r instanceof DataView);
}
function getKeyframeOrder(r) {
  function e(a, l) {
    return r[a] - r[l];
  }
  const s = r.length, o = new Array(s);
  for (let a = 0; a !== s; ++a)
    o[a] = a;
  return o.sort(e), o;
}
function sortedArray(r, e, s) {
  const o = r.length, a = new r.constructor(o);
  for (let l = 0, u = 0; u !== o; ++l) {
    const c = s[l] * e;
    for (let E = 0; E !== e; ++E)
      a[u++] = r[c + E];
  }
  return a;
}
function flattenJSON(r, e, s, o) {
  let a = 1, l = r[0];
  for (; l !== void 0 && l[o] === void 0; )
    l = r[a++];
  if (l === void 0)
    return;
  let u = l[o];
  if (u !== void 0)
    if (Array.isArray(u))
      do
        u = l[o], u !== void 0 && (e.push(l.time), s.push.apply(s, u)), l = r[a++];
      while (l !== void 0);
    else if (u.toArray !== void 0)
      do
        u = l[o], u !== void 0 && (e.push(l.time), u.toArray(s, s.length)), l = r[a++];
      while (l !== void 0);
    else
      do
        u = l[o], u !== void 0 && (e.push(l.time), s.push(u)), l = r[a++];
      while (l !== void 0);
}
function subclip(r, e, s, o, a = 30) {
  const l = r.clone();
  l.name = e;
  const u = [];
  for (let E = 0; E < l.tracks.length; ++E) {
    const d = l.tracks[E], f = d.getValueSize(), h = [], S = [];
    for (let R = 0; R < d.times.length; ++R) {
      const _ = d.times[R] * a;
      if (!(_ < s || _ >= o)) {
        h.push(d.times[R]);
        for (let m = 0; m < f; ++m)
          S.push(d.values[R * f + m]);
      }
    }
    h.length !== 0 && (d.times = convertArray(h, d.times.constructor), d.values = convertArray(S, d.values.constructor), u.push(d));
  }
  l.tracks = u;
  let c = 1 / 0;
  for (let E = 0; E < l.tracks.length; ++E)
    c > l.tracks[E].times[0] && (c = l.tracks[E].times[0]);
  for (let E = 0; E < l.tracks.length; ++E)
    l.tracks[E].shift(-1 * c);
  return l.resetDuration(), l;
}
function makeClipAdditive(r, e = 0, s = r, o = 30) {
  o <= 0 && (o = 30);
  const a = s.tracks.length, l = e / o;
  for (let u = 0; u < a; ++u) {
    const c = s.tracks[u], E = c.ValueTypeName;
    if (E === "bool" || E === "string")
      continue;
    const d = r.tracks.find(function(F) {
      return F.name === c.name && F.ValueTypeName === E;
    });
    if (d === void 0)
      continue;
    let f = 0;
    const h = c.getValueSize();
    c.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (f = h / 3);
    let S = 0;
    const R = d.getValueSize();
    d.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (S = R / 3);
    const _ = c.times.length - 1;
    let m;
    if (l <= c.times[0]) {
      const F = f, W = h - f;
      m = arraySlice(c.values, F, W);
    } else if (l >= c.times[_]) {
      const F = _ * h + f, W = F + h - f;
      m = arraySlice(c.values, F, W);
    } else {
      const F = c.createInterpolant(), W = f, G = h - f;
      F.evaluate(l), m = arraySlice(F.resultBuffer, W, G);
    }
    E === "quaternion" && new Quaternion$1().fromArray(m).normalize().conjugate().toArray(m);
    const L = d.times.length;
    for (let F = 0; F < L; ++F) {
      const W = F * R + S;
      if (E === "quaternion")
        Quaternion$1.multiplyQuaternionsFlat(
          d.values,
          W,
          m,
          0,
          d.values,
          W
        );
      else {
        const G = R - S * 2;
        for (let q = 0; q < G; ++q)
          d.values[W + q] -= m[q];
      }
    }
  }
  return r.blendMode = AdditiveAnimationBlendMode, r;
}
const AnimationUtils = {
  arraySlice,
  convertArray,
  isTypedArray: isTypedArray$1,
  getKeyframeOrder,
  sortedArray,
  flattenJSON,
  subclip,
  makeClipAdditive
};
class Interpolant {
  constructor(e, s, o, a) {
    this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = a !== void 0 ? a : new s.constructor(o), this.sampleValues = s, this.valueSize = o, this.settings = null, this.DefaultSettings_ = {};
  }
  evaluate(e) {
    const s = this.parameterPositions;
    let o = this._cachedIndex, a = s[o], l = s[o - 1];
    e: {
      t: {
        let u;
        n: {
          r:
            if (!(e < a)) {
              for (let c = o + 2; ; ) {
                if (a === void 0) {
                  if (e < l)
                    break r;
                  return o = s.length, this._cachedIndex = o, this.copySampleValue_(o - 1);
                }
                if (o === c)
                  break;
                if (l = a, a = s[++o], e < a)
                  break t;
              }
              u = s.length;
              break n;
            }
          if (!(e >= l)) {
            const c = s[1];
            e < c && (o = 2, l = c);
            for (let E = o - 2; ; ) {
              if (l === void 0)
                return this._cachedIndex = 0, this.copySampleValue_(0);
              if (o === E)
                break;
              if (a = l, l = s[--o - 1], e >= l)
                break t;
            }
            u = o, o = 0;
            break n;
          }
          break e;
        }
        for (; o < u; ) {
          const c = o + u >>> 1;
          e < s[c] ? u = c : o = c + 1;
        }
        if (a = s[o], l = s[o - 1], l === void 0)
          return this._cachedIndex = 0, this.copySampleValue_(0);
        if (a === void 0)
          return o = s.length, this._cachedIndex = o, this.copySampleValue_(o - 1);
      }
      this._cachedIndex = o, this.intervalChanged_(o, l, a);
    }
    return this.interpolate_(o, l, e, a);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(e) {
    const s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = e * a;
    for (let u = 0; u !== a; ++u)
      s[u] = o[l + u];
    return s;
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
class CubicInterpolant extends Interpolant {
  constructor(e, s, o, a) {
    super(e, s, o, a), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(e, s, o) {
    const a = this.parameterPositions;
    let l = e - 2, u = e + 1, c = a[l], E = a[u];
    if (c === void 0)
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          l = e, c = 2 * s - o;
          break;
        case WrapAroundEnding:
          l = a.length - 2, c = s + a[l] - a[l + 1];
          break;
        default:
          l = e, c = o;
      }
    if (E === void 0)
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          u = e, E = 2 * o - s;
          break;
        case WrapAroundEnding:
          u = 1, E = o + a[1] - a[0];
          break;
        default:
          u = e - 1, E = s;
      }
    const d = (o - s) * 0.5, f = this.valueSize;
    this._weightPrev = d / (s - c), this._weightNext = d / (E - o), this._offsetPrev = l * f, this._offsetNext = u * f;
  }
  interpolate_(e, s, o, a) {
    const l = this.resultBuffer, u = this.sampleValues, c = this.valueSize, E = e * c, d = E - c, f = this._offsetPrev, h = this._offsetNext, S = this._weightPrev, R = this._weightNext, _ = (o - s) / (a - s), m = _ * _, L = m * _, F = -S * L + 2 * S * m - S * _, W = (1 + S) * L + (-1.5 - 2 * S) * m + (-0.5 + S) * _ + 1, G = (-1 - R) * L + (1.5 + R) * m + 0.5 * _, q = R * L - R * m;
    for (let fe = 0; fe !== c; ++fe)
      l[fe] = F * u[f + fe] + W * u[d + fe] + G * u[E + fe] + q * u[h + fe];
    return l;
  }
}
class LinearInterpolant extends Interpolant {
  constructor(e, s, o, a) {
    super(e, s, o, a);
  }
  interpolate_(e, s, o, a) {
    const l = this.resultBuffer, u = this.sampleValues, c = this.valueSize, E = e * c, d = E - c, f = (o - s) / (a - s), h = 1 - f;
    for (let S = 0; S !== c; ++S)
      l[S] = u[d + S] * h + u[E + S] * f;
    return l;
  }
}
class DiscreteInterpolant extends Interpolant {
  constructor(e, s, o, a) {
    super(e, s, o, a);
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1);
  }
}
class KeyframeTrack {
  constructor(e, s, o, a) {
    if (e === void 0)
      throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (s === void 0 || s.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
    this.name = e, this.times = convertArray(s, this.TimeBufferType), this.values = convertArray(o, this.ValueBufferType), this.setInterpolation(a || this.DefaultInterpolation);
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(e) {
    const s = e.constructor;
    let o;
    if (s.toJSON !== this.toJSON)
      o = s.toJSON(e);
    else {
      o = {
        name: e.name,
        times: convertArray(e.times, Array),
        values: convertArray(e.values, Array)
      };
      const a = e.getInterpolation();
      a !== e.DefaultInterpolation && (o.interpolation = a);
    }
    return o.type = e.ValueTypeName, o;
  }
  InterpolantFactoryMethodDiscrete(e) {
    return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodLinear(e) {
    return new LinearInterpolant(this.times, this.values, this.getValueSize(), e);
  }
  InterpolantFactoryMethodSmooth(e) {
    return new CubicInterpolant(this.times, this.values, this.getValueSize(), e);
  }
  setInterpolation(e) {
    let s;
    switch (e) {
      case InterpolateDiscrete:
        s = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        s = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        s = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (s === void 0) {
      const o = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0)
        if (e !== this.DefaultInterpolation)
          this.setInterpolation(this.DefaultInterpolation);
        else
          throw new Error(o);
      return console.warn("THREE.KeyframeTrack:", o), this;
    }
    return this.createInterpolant = s, this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  // move all keyframes either forwards or backwards in time
  shift(e) {
    if (e !== 0) {
      const s = this.times;
      for (let o = 0, a = s.length; o !== a; ++o)
        s[o] += e;
    }
    return this;
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(e) {
    if (e !== 1) {
      const s = this.times;
      for (let o = 0, a = s.length; o !== a; ++o)
        s[o] *= e;
    }
    return this;
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(e, s) {
    const o = this.times, a = o.length;
    let l = 0, u = a - 1;
    for (; l !== a && o[l] < e; )
      ++l;
    for (; u !== -1 && o[u] > s; )
      --u;
    if (++u, l !== 0 || u !== a) {
      l >= u && (u = Math.max(u, 1), l = u - 1);
      const c = this.getValueSize();
      this.times = arraySlice(o, l, u), this.values = arraySlice(this.values, l * c, u * c);
    }
    return this;
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let e = !0;
    const s = this.getValueSize();
    s - Math.floor(s) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e = !1);
    const o = this.times, a = this.values, l = o.length;
    l === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), e = !1);
    let u = null;
    for (let c = 0; c !== l; c++) {
      const E = o[c];
      if (typeof E == "number" && isNaN(E)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, c, E), e = !1;
        break;
      }
      if (u !== null && u > E) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, c, E, u), e = !1;
        break;
      }
      u = E;
    }
    if (a !== void 0 && isTypedArray$1(a))
      for (let c = 0, E = a.length; c !== E; ++c) {
        const d = a[c];
        if (isNaN(d)) {
          console.error("THREE.KeyframeTrack: Value is not a valid number.", this, c, d), e = !1;
          break;
        }
      }
    return e;
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const e = arraySlice(this.times), s = arraySlice(this.values), o = this.getValueSize(), a = this.getInterpolation() === InterpolateSmooth, l = e.length - 1;
    let u = 1;
    for (let c = 1; c < l; ++c) {
      let E = !1;
      const d = e[c], f = e[c + 1];
      if (d !== f && (c !== 1 || d !== e[0]))
        if (a)
          E = !0;
        else {
          const h = c * o, S = h - o, R = h + o;
          for (let _ = 0; _ !== o; ++_) {
            const m = s[h + _];
            if (m !== s[S + _] || m !== s[R + _]) {
              E = !0;
              break;
            }
          }
        }
      if (E) {
        if (c !== u) {
          e[u] = e[c];
          const h = c * o, S = u * o;
          for (let R = 0; R !== o; ++R)
            s[S + R] = s[h + R];
        }
        ++u;
      }
    }
    if (l > 0) {
      e[u] = e[l];
      for (let c = l * o, E = u * o, d = 0; d !== o; ++d)
        s[E + d] = s[c + d];
      ++u;
    }
    return u !== e.length ? (this.times = arraySlice(e, 0, u), this.values = arraySlice(s, 0, u * o)) : (this.times = e, this.values = s), this;
  }
  clone() {
    const e = arraySlice(this.times, 0), s = arraySlice(this.values, 0), o = this.constructor, a = new o(this.name, e, s);
    return a.createInterpolant = this.createInterpolant, a;
  }
}
KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack extends KeyframeTrack {
}
BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack extends KeyframeTrack {
}
ColorKeyframeTrack.prototype.ValueTypeName = "color";
class NumberKeyframeTrack extends KeyframeTrack {
}
NumberKeyframeTrack.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant extends Interpolant {
  constructor(e, s, o, a) {
    super(e, s, o, a);
  }
  interpolate_(e, s, o, a) {
    const l = this.resultBuffer, u = this.sampleValues, c = this.valueSize, E = (o - s) / (a - s);
    let d = e * c;
    for (let f = d + c; d !== f; d += 4)
      Quaternion$1.slerpFlat(l, 0, u, d - c, u, d, E);
    return l;
  }
}
class QuaternionKeyframeTrack extends KeyframeTrack {
  InterpolantFactoryMethodLinear(e) {
    return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), e);
  }
}
QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack extends KeyframeTrack {
}
StringKeyframeTrack.prototype.ValueTypeName = "string";
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack extends KeyframeTrack {
}
VectorKeyframeTrack.prototype.ValueTypeName = "vector";
class AnimationClip {
  constructor(e, s = -1, o, a = NormalAnimationBlendMode) {
    this.name = e, this.tracks = o, this.duration = s, this.blendMode = a, this.uuid = generateUUID$1(), this.duration < 0 && this.resetDuration();
  }
  static parse(e) {
    const s = [], o = e.tracks, a = 1 / (e.fps || 1);
    for (let u = 0, c = o.length; u !== c; ++u)
      s.push(parseKeyframeTrack(o[u]).scale(a));
    const l = new this(e.name, e.duration, s, e.blendMode);
    return l.uuid = e.uuid, l;
  }
  static toJSON(e) {
    const s = [], o = e.tracks, a = {
      name: e.name,
      duration: e.duration,
      tracks: s,
      uuid: e.uuid,
      blendMode: e.blendMode
    };
    for (let l = 0, u = o.length; l !== u; ++l)
      s.push(KeyframeTrack.toJSON(o[l]));
    return a;
  }
  static CreateFromMorphTargetSequence(e, s, o, a) {
    const l = s.length, u = [];
    for (let c = 0; c < l; c++) {
      let E = [], d = [];
      E.push(
        (c + l - 1) % l,
        c,
        (c + 1) % l
      ), d.push(0, 1, 0);
      const f = getKeyframeOrder(E);
      E = sortedArray(E, 1, f), d = sortedArray(d, 1, f), !a && E[0] === 0 && (E.push(l), d.push(d[0])), u.push(
        new NumberKeyframeTrack(
          ".morphTargetInfluences[" + s[c].name + "]",
          E,
          d
        ).scale(1 / o)
      );
    }
    return new this(e, -1, u);
  }
  static findByName(e, s) {
    let o = e;
    if (!Array.isArray(e)) {
      const a = e;
      o = a.geometry && a.geometry.animations || a.animations;
    }
    for (let a = 0; a < o.length; a++)
      if (o[a].name === s)
        return o[a];
    return null;
  }
  static CreateClipsFromMorphTargetSequences(e, s, o) {
    const a = {}, l = /^([\w-]*?)([\d]+)$/;
    for (let c = 0, E = e.length; c < E; c++) {
      const d = e[c], f = d.name.match(l);
      if (f && f.length > 1) {
        const h = f[1];
        let S = a[h];
        S || (a[h] = S = []), S.push(d);
      }
    }
    const u = [];
    for (const c in a)
      u.push(this.CreateFromMorphTargetSequence(c, a[c], s, o));
    return u;
  }
  // parse the animation.hierarchy format
  static parseAnimation(e, s) {
    if (!e)
      return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
    const o = function(h, S, R, _, m) {
      if (R.length !== 0) {
        const L = [], F = [];
        flattenJSON(R, L, F, _), L.length !== 0 && m.push(new h(S, L, F));
      }
    }, a = [], l = e.name || "default", u = e.fps || 30, c = e.blendMode;
    let E = e.length || -1;
    const d = e.hierarchy || [];
    for (let h = 0; h < d.length; h++) {
      const S = d[h].keys;
      if (!(!S || S.length === 0))
        if (S[0].morphTargets) {
          const R = {};
          let _;
          for (_ = 0; _ < S.length; _++)
            if (S[_].morphTargets)
              for (let m = 0; m < S[_].morphTargets.length; m++)
                R[S[_].morphTargets[m]] = -1;
          for (const m in R) {
            const L = [], F = [];
            for (let W = 0; W !== S[_].morphTargets.length; ++W) {
              const G = S[_];
              L.push(G.time), F.push(G.morphTarget === m ? 1 : 0);
            }
            a.push(new NumberKeyframeTrack(".morphTargetInfluence[" + m + "]", L, F));
          }
          E = R.length * u;
        } else {
          const R = ".bones[" + s[h].name + "]";
          o(
            VectorKeyframeTrack,
            R + ".position",
            S,
            "pos",
            a
          ), o(
            QuaternionKeyframeTrack,
            R + ".quaternion",
            S,
            "rot",
            a
          ), o(
            VectorKeyframeTrack,
            R + ".scale",
            S,
            "scl",
            a
          );
        }
    }
    return a.length === 0 ? null : new this(l, E, a, c);
  }
  resetDuration() {
    const e = this.tracks;
    let s = 0;
    for (let o = 0, a = e.length; o !== a; ++o) {
      const l = this.tracks[o];
      s = Math.max(s, l.times[l.times.length - 1]);
    }
    return this.duration = s, this;
  }
  trim() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].trim(0, this.duration);
    return this;
  }
  validate() {
    let e = !0;
    for (let s = 0; s < this.tracks.length; s++)
      e = e && this.tracks[s].validate();
    return e;
  }
  optimize() {
    for (let e = 0; e < this.tracks.length; e++)
      this.tracks[e].optimize();
    return this;
  }
  clone() {
    const e = [];
    for (let s = 0; s < this.tracks.length; s++)
      e.push(this.tracks[s].clone());
    return new this.constructor(this.name, this.duration, e, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(r) {
  switch (r.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack;
    case "color":
      return ColorKeyframeTrack;
    case "quaternion":
      return QuaternionKeyframeTrack;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack;
    case "string":
      return StringKeyframeTrack;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + r);
}
function parseKeyframeTrack(r) {
  if (r.type === void 0)
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  const e = getTrackTypeForValueTypeName(r.type);
  if (r.times === void 0) {
    const s = [], o = [];
    flattenJSON(r.keys, s, o, "value"), r.times = s, r.values = o;
  }
  return e.parse !== void 0 ? e.parse(r) : new e(r.name, r.times, r.values, r.interpolation);
}
const Cache = {
  enabled: !1,
  files: {},
  add: function(r, e) {
    this.enabled !== !1 && (this.files[r] = e);
  },
  get: function(r) {
    if (this.enabled !== !1)
      return this.files[r];
  },
  remove: function(r) {
    delete this.files[r];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager {
  constructor(e, s, o) {
    const a = this;
    let l = !1, u = 0, c = 0, E;
    const d = [];
    this.onStart = void 0, this.onLoad = e, this.onProgress = s, this.onError = o, this.itemStart = function(f) {
      c++, l === !1 && a.onStart !== void 0 && a.onStart(f, u, c), l = !0;
    }, this.itemEnd = function(f) {
      u++, a.onProgress !== void 0 && a.onProgress(f, u, c), u === c && (l = !1, a.onLoad !== void 0 && a.onLoad());
    }, this.itemError = function(f) {
      a.onError !== void 0 && a.onError(f);
    }, this.resolveURL = function(f) {
      return E ? E(f) : f;
    }, this.setURLModifier = function(f) {
      return E = f, this;
    }, this.addHandler = function(f, h) {
      return d.push(f, h), this;
    }, this.removeHandler = function(f) {
      const h = d.indexOf(f);
      return h !== -1 && d.splice(h, 2), this;
    }, this.getHandler = function(f) {
      for (let h = 0, S = d.length; h < S; h += 2) {
        const R = d[h], _ = d[h + 1];
        if (R.global && (R.lastIndex = 0), R.test(f))
          return _;
      }
      return null;
    };
  }
}
const DefaultLoadingManager = /* @__PURE__ */ new LoadingManager();
class Loader {
  constructor(e) {
    this.manager = e !== void 0 ? e : DefaultLoadingManager, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
  }
  load() {
  }
  loadAsync(e, s) {
    const o = this;
    return new Promise(function(a, l) {
      o.load(e, a, s, l);
    });
  }
  parse() {
  }
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  setWithCredentials(e) {
    return this.withCredentials = e, this;
  }
  setPath(e) {
    return this.path = e, this;
  }
  setResourcePath(e) {
    return this.resourcePath = e, this;
  }
  setRequestHeader(e) {
    return this.requestHeader = e, this;
  }
}
Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const loading = {};
class HttpError extends Error {
  constructor(e, s) {
    super(e), this.response = s;
  }
}
let FileLoader$1 = class extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, s, o, a) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const l = Cache.get(e);
    if (l !== void 0)
      return this.manager.itemStart(e), setTimeout(() => {
        s && s(l), this.manager.itemEnd(e);
      }, 0), l;
    if (loading[e] !== void 0) {
      loading[e].push({
        onLoad: s,
        onProgress: o,
        onError: a
      });
      return;
    }
    loading[e] = [], loading[e].push({
      onLoad: s,
      onProgress: o,
      onError: a
    });
    const u = new Request(e, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    }), c = this.mimeType, E = this.responseType;
    fetch(u).then((d) => {
      if (d.status === 200 || d.status === 0) {
        if (d.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || d.body === void 0 || d.body.getReader === void 0)
          return d;
        const f = loading[e], h = d.body.getReader(), S = d.headers.get("Content-Length") || d.headers.get("X-File-Size"), R = S ? parseInt(S) : 0, _ = R !== 0;
        let m = 0;
        const L = new ReadableStream({
          start(F) {
            W();
            function W() {
              h.read().then(({ done: G, value: q }) => {
                if (G)
                  F.close();
                else {
                  m += q.byteLength;
                  const fe = new ProgressEvent("progress", { lengthComputable: _, loaded: m, total: R });
                  for (let _e = 0, Le = f.length; _e < Le; _e++) {
                    const Fe = f[_e];
                    Fe.onProgress && Fe.onProgress(fe);
                  }
                  F.enqueue(q), W();
                }
              });
            }
          }
        });
        return new Response(L);
      } else
        throw new HttpError(`fetch for "${d.url}" responded with ${d.status}: ${d.statusText}`, d);
    }).then((d) => {
      switch (E) {
        case "arraybuffer":
          return d.arrayBuffer();
        case "blob":
          return d.blob();
        case "document":
          return d.text().then((f) => new DOMParser().parseFromString(f, c));
        case "json":
          return d.json();
        default:
          if (c === void 0)
            return d.text();
          {
            const h = /charset="?([^;"\s]*)"?/i.exec(c), S = h && h[1] ? h[1].toLowerCase() : void 0, R = new TextDecoder(S);
            return d.arrayBuffer().then((_) => R.decode(_));
          }
      }
    }).then((d) => {
      Cache.add(e, d);
      const f = loading[e];
      delete loading[e];
      for (let h = 0, S = f.length; h < S; h++) {
        const R = f[h];
        R.onLoad && R.onLoad(d);
      }
    }).catch((d) => {
      const f = loading[e];
      if (f === void 0)
        throw this.manager.itemError(e), d;
      delete loading[e];
      for (let h = 0, S = f.length; h < S; h++) {
        const R = f[h];
        R.onError && R.onError(d);
      }
      this.manager.itemError(e);
    }).finally(() => {
      this.manager.itemEnd(e);
    }), this.manager.itemStart(e);
  }
  setResponseType(e) {
    return this.responseType = e, this;
  }
  setMimeType(e) {
    return this.mimeType = e, this;
  }
}, ImageLoader$1 = class extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, s, o, a) {
    this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const l = this, u = Cache.get(e);
    if (u !== void 0)
      return l.manager.itemStart(e), setTimeout(function() {
        s && s(u), l.manager.itemEnd(e);
      }, 0), u;
    const c = createElementNS("img");
    function E() {
      f(), Cache.add(e, this), s && s(this), l.manager.itemEnd(e);
    }
    function d(h) {
      f(), a && a(h), l.manager.itemError(e), l.manager.itemEnd(e);
    }
    function f() {
      c.removeEventListener("load", E, !1), c.removeEventListener("error", d, !1);
    }
    return c.addEventListener("load", E, !1), c.addEventListener("error", d, !1), e.slice(0, 5) !== "data:" && this.crossOrigin !== void 0 && (c.crossOrigin = this.crossOrigin), l.manager.itemStart(e), c.src = e, c;
  }
}, TextureLoader$1 = class extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, s, o, a) {
    const l = new Texture(), u = new ImageLoader$1(this.manager);
    return u.setCrossOrigin(this.crossOrigin), u.setPath(this.path), u.load(e, function(c) {
      l.image = c, l.needsUpdate = !0, s !== void 0 && s(l);
    }, o, a), l;
  }
};
class Light extends Object3D {
  constructor(e, s = 1) {
    super(), this.isLight = !0, this.type = "Light", this.color = new Color(e), this.intensity = s;
  }
  dispose() {
  }
  copy(e, s) {
    return super.copy(e, s), this.color.copy(e.color), this.intensity = e.intensity, this;
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return s.object.color = this.color.getHex(), s.object.intensity = this.intensity, this.groundColor !== void 0 && (s.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (s.object.distance = this.distance), this.angle !== void 0 && (s.object.angle = this.angle), this.decay !== void 0 && (s.object.decay = this.decay), this.penumbra !== void 0 && (s.object.penumbra = this.penumbra), this.shadow !== void 0 && (s.object.shadow = this.shadow.toJSON()), s;
  }
}
const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4(), _lightPositionWorld$1 = /* @__PURE__ */ new Vector3$1(), _lookTarget$1 = /* @__PURE__ */ new Vector3$1();
class LightShadow {
  constructor(e) {
    this.camera = e, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Vector2(512, 512), this.map = null, this.mapPass = null, this.matrix = new Matrix4(), this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new Frustum(), this._frameExtents = new Vector2(1, 1), this._viewportCount = 1, this._viewports = [
      new Vector4(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(e) {
    const s = this.camera, o = this.matrix;
    _lightPositionWorld$1.setFromMatrixPosition(e.matrixWorld), s.position.copy(_lightPositionWorld$1), _lookTarget$1.setFromMatrixPosition(e.target.matrixWorld), s.lookAt(_lookTarget$1), s.updateMatrixWorld(), _projScreenMatrix$1.multiplyMatrices(s.projectionMatrix, s.matrixWorldInverse), this._frustum.setFromProjectionMatrix(_projScreenMatrix$1), o.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    ), o.multiply(_projScreenMatrix$1);
  }
  getViewport(e) {
    return this._viewports[e];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
  }
  copy(e) {
    return this.camera = e.camera.clone(), this.bias = e.bias, this.radius = e.radius, this.mapSize.copy(e.mapSize), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const e = {};
    return this.bias !== 0 && (e.bias = this.bias), this.normalBias !== 0 && (e.normalBias = this.normalBias), this.radius !== 1 && (e.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
  }
}
class SpotLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera$1(50, 1, 0.5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
  }
  updateMatrices(e) {
    const s = this.camera, o = RAD2DEG * 2 * e.angle * this.focus, a = this.mapSize.width / this.mapSize.height, l = e.distance || s.far;
    (o !== s.fov || a !== s.aspect || l !== s.far) && (s.fov = o, s.aspect = a, s.far = l, s.updateProjectionMatrix()), super.updateMatrices(e);
  }
  copy(e) {
    return super.copy(e), this.focus = e.focus, this;
  }
}
class SpotLight extends Light {
  constructor(e, s, o = 0, a = Math.PI / 3, l = 0, u = 2) {
    super(e, s), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Object3D.DEFAULT_UP), this.updateMatrix(), this.target = new Object3D(), this.distance = o, this.angle = a, this.penumbra = l, this.decay = u, this.map = null, this.shadow = new SpotLightShadow();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(e) {
    this.intensity = e / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, s) {
    return super.copy(e, s), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
const _projScreenMatrix = /* @__PURE__ */ new Matrix4(), _lightPositionWorld = /* @__PURE__ */ new Vector3$1(), _lookTarget = /* @__PURE__ */ new Vector3$1();
class PointLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera$1(90, 1, 0.5, 500)), this.isPointLightShadow = !0, this._frameExtents = new Vector2(4, 2), this._viewportCount = 6, this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new Vector4(2, 1, 1, 1),
      // negative X
      new Vector4(0, 1, 1, 1),
      // positive Z
      new Vector4(3, 1, 1, 1),
      // negative Z
      new Vector4(1, 1, 1, 1),
      // positive Y
      new Vector4(3, 0, 1, 1),
      // negative Y
      new Vector4(1, 0, 1, 1)
    ], this._cubeDirections = [
      new Vector3$1(1, 0, 0),
      new Vector3$1(-1, 0, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, -1, 0)
    ], this._cubeUps = [
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1)
    ];
  }
  updateMatrices(e, s = 0) {
    const o = this.camera, a = this.matrix, l = e.distance || o.far;
    l !== o.far && (o.far = l, o.updateProjectionMatrix()), _lightPositionWorld.setFromMatrixPosition(e.matrixWorld), o.position.copy(_lightPositionWorld), _lookTarget.copy(o.position), _lookTarget.add(this._cubeDirections[s]), o.up.copy(this._cubeUps[s]), o.lookAt(_lookTarget), o.updateMatrixWorld(), a.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z), _projScreenMatrix.multiplyMatrices(o.projectionMatrix, o.matrixWorldInverse), this._frustum.setFromProjectionMatrix(_projScreenMatrix);
  }
}
class PointLight extends Light {
  constructor(e, s, o = 0, a = 2) {
    super(e, s), this.isPointLight = !0, this.type = "PointLight", this.distance = o, this.decay = a, this.shadow = new PointLightShadow();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(e) {
    this.intensity = e / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e, s) {
    return super.copy(e, s), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
  }
}
class DirectionalLightShadow extends LightShadow {
  constructor() {
    super(new OrthographicCamera$1(-5, 5, 5, -5, 0.5, 500)), this.isDirectionalLightShadow = !0;
  }
}
class DirectionalLight extends Light {
  constructor(e, s) {
    super(e, s), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Object3D.DEFAULT_UP), this.updateMatrix(), this.target = new Object3D(), this.shadow = new DirectionalLightShadow();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(e) {
    return super.copy(e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
  }
}
class AmbientLight extends Light {
  constructor(e, s) {
    super(e, s), this.isAmbientLight = !0, this.type = "AmbientLight";
  }
}
class LoaderUtils {
  static decodeText(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let s = "";
    for (let o = 0, a = e.length; o < a; o++)
      s += String.fromCharCode(e[o]);
    try {
      return decodeURIComponent(escape(s));
    } catch {
      return s;
    }
  }
  static extractUrlBase(e) {
    const s = e.lastIndexOf("/");
    return s === -1 ? "./" : e.slice(0, s + 1);
  }
  static resolveURL(e, s) {
    return typeof e != "string" || e === "" ? "" : (/^https?:\/\//i.test(s) && /^\//.test(e) && (s = s.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e) ? e : s + e);
  }
}
class InstancedBufferGeometry extends BufferGeometry {
  constructor() {
    super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
  }
  copy(e) {
    return super.copy(e), this.instanceCount = e.instanceCount, this;
  }
  toJSON() {
    const e = super.toJSON();
    return e.instanceCount = this.instanceCount, e.isInstancedBufferGeometry = !0, e;
  }
}
class ImageBitmapLoader extends Loader {
  constructor(e) {
    super(e), this.isImageBitmapLoader = !0, typeof createImageBitmap > "u" && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), typeof fetch > "u" && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = { premultiplyAlpha: "none" };
  }
  setOptions(e) {
    return this.options = e, this;
  }
  load(e, s, o, a) {
    e === void 0 && (e = ""), this.path !== void 0 && (e = this.path + e), e = this.manager.resolveURL(e);
    const l = this, u = Cache.get(e);
    if (u !== void 0)
      return l.manager.itemStart(e), setTimeout(function() {
        s && s(u), l.manager.itemEnd(e);
      }, 0), u;
    const c = {};
    c.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include", c.headers = this.requestHeader, fetch(e, c).then(function(E) {
      return E.blob();
    }).then(function(E) {
      return createImageBitmap(E, Object.assign(l.options, { colorSpaceConversion: "none" }));
    }).then(function(E) {
      Cache.add(e, E), s && s(E), l.manager.itemEnd(e);
    }).catch(function(E) {
      a && a(E), l.manager.itemError(e), l.manager.itemEnd(e);
    }), l.manager.itemStart(e);
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/", _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g"), _wordChar = "[^" + _RESERVED_CHARS_RE + "]", _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]", _directoryRe = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar), _nodeRe = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot), _objectRe = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar), _propertyRe = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar), _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
), _supportedObjectNames = ["material", "materials", "bones", "map"];
let Composite$1 = class {
  constructor(e, s, o) {
    const a = o || PropertyBinding.parseTrackName(s);
    this._targetGroup = e, this._bindings = e.subscribe_(s, a);
  }
  getValue(e, s) {
    this.bind();
    const o = this._targetGroup.nCachedObjects_, a = this._bindings[o];
    a !== void 0 && a.getValue(e, s);
  }
  setValue(e, s) {
    const o = this._bindings;
    for (let a = this._targetGroup.nCachedObjects_, l = o.length; a !== l; ++a)
      o[a].setValue(e, s);
  }
  bind() {
    const e = this._bindings;
    for (let s = this._targetGroup.nCachedObjects_, o = e.length; s !== o; ++s)
      e[s].bind();
  }
  unbind() {
    const e = this._bindings;
    for (let s = this._targetGroup.nCachedObjects_, o = e.length; s !== o; ++s)
      e[s].unbind();
  }
};
class PropertyBinding {
  constructor(e, s, o) {
    this.path = s, this.parsedPath = o || PropertyBinding.parseTrackName(s), this.node = PropertyBinding.findNode(e, this.parsedPath.nodeName), this.rootNode = e, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
  static create(e, s, o) {
    return e && e.isAnimationObjectGroup ? new PropertyBinding.Composite(e, s, o) : new PropertyBinding(e, s, o);
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  static parseTrackName(e) {
    const s = _trackRe.exec(e);
    if (s === null)
      throw new Error("PropertyBinding: Cannot parse trackName: " + e);
    const o = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: s[2],
      objectName: s[3],
      objectIndex: s[4],
      propertyName: s[5],
      // required
      propertyIndex: s[6]
    }, a = o.nodeName && o.nodeName.lastIndexOf(".");
    if (a !== void 0 && a !== -1) {
      const l = o.nodeName.substring(a + 1);
      _supportedObjectNames.indexOf(l) !== -1 && (o.nodeName = o.nodeName.substring(0, a), o.objectName = l);
    }
    if (o.propertyName === null || o.propertyName.length === 0)
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
    return o;
  }
  static findNode(e, s) {
    if (s === void 0 || s === "" || s === "." || s === -1 || s === e.name || s === e.uuid)
      return e;
    if (e.skeleton) {
      const o = e.skeleton.getBoneByName(s);
      if (o !== void 0)
        return o;
    }
    if (e.children) {
      const o = function(l) {
        for (let u = 0; u < l.length; u++) {
          const c = l[u];
          if (c.name === s || c.uuid === s)
            return c;
          const E = o(c.children);
          if (E)
            return E;
        }
        return null;
      }, a = o(e.children);
      if (a)
        return a;
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(e, s) {
    e[s] = this.targetObject[this.propertyName];
  }
  _getValue_array(e, s) {
    const o = this.resolvedProperty;
    for (let a = 0, l = o.length; a !== l; ++a)
      e[s++] = o[a];
  }
  _getValue_arrayElement(e, s) {
    e[s] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(e, s) {
    this.resolvedProperty.toArray(e, s);
  }
  // Direct
  _setValue_direct(e, s) {
    this.targetObject[this.propertyName] = e[s];
  }
  _setValue_direct_setNeedsUpdate(e, s) {
    this.targetObject[this.propertyName] = e[s], this.targetObject.needsUpdate = !0;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, s) {
    this.targetObject[this.propertyName] = e[s], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // EntireArray
  _setValue_array(e, s) {
    const o = this.resolvedProperty;
    for (let a = 0, l = o.length; a !== l; ++a)
      o[a] = e[s++];
  }
  _setValue_array_setNeedsUpdate(e, s) {
    const o = this.resolvedProperty;
    for (let a = 0, l = o.length; a !== l; ++a)
      o[a] = e[s++];
    this.targetObject.needsUpdate = !0;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, s) {
    const o = this.resolvedProperty;
    for (let a = 0, l = o.length; a !== l; ++a)
      o[a] = e[s++];
    this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // ArrayElement
  _setValue_arrayElement(e, s) {
    this.resolvedProperty[this.propertyIndex] = e[s];
  }
  _setValue_arrayElement_setNeedsUpdate(e, s) {
    this.resolvedProperty[this.propertyIndex] = e[s], this.targetObject.needsUpdate = !0;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, s) {
    this.resolvedProperty[this.propertyIndex] = e[s], this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  // HasToFromArray
  _setValue_fromArray(e, s) {
    this.resolvedProperty.fromArray(e, s);
  }
  _setValue_fromArray_setNeedsUpdate(e, s) {
    this.resolvedProperty.fromArray(e, s), this.targetObject.needsUpdate = !0;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, s) {
    this.resolvedProperty.fromArray(e, s), this.targetObject.matrixWorldNeedsUpdate = !0;
  }
  _getValue_unbound(e, s) {
    this.bind(), this.getValue(e, s);
  }
  _setValue_unbound(e, s) {
    this.bind(), this.setValue(e, s);
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let e = this.node;
    const s = this.parsedPath, o = s.objectName, a = s.propertyName;
    let l = s.propertyIndex;
    if (e || (e = PropertyBinding.findNode(this.rootNode, s.nodeName), this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) {
      console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
      return;
    }
    if (o) {
      let d = s.objectIndex;
      switch (o) {
        case "materials":
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          e = e.material.materials;
          break;
        case "bones":
          if (!e.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          e = e.skeleton.bones;
          for (let f = 0; f < e.length; f++)
            if (e[f].name === d) {
              d = f;
              break;
            }
          break;
        case "map":
          if ("map" in e) {
            e = e.map;
            break;
          }
          if (!e.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!e.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          e = e.material.map;
          break;
        default:
          if (e[o] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          e = e[o];
      }
      if (d !== void 0) {
        if (e[d] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
          return;
        }
        e = e[d];
      }
    }
    const u = e[a];
    if (u === void 0) {
      const d = s.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + d + "." + a + " but it wasn't found.", e);
      return;
    }
    let c = this.Versioning.None;
    this.targetObject = e, e.needsUpdate !== void 0 ? c = this.Versioning.NeedsUpdate : e.matrixWorldNeedsUpdate !== void 0 && (c = this.Versioning.MatrixWorldNeedsUpdate);
    let E = this.BindingType.Direct;
    if (l !== void 0) {
      if (a === "morphTargetInfluences") {
        if (!e.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!e.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        e.morphTargetDictionary[l] !== void 0 && (l = e.morphTargetDictionary[l]);
      }
      E = this.BindingType.ArrayElement, this.resolvedProperty = u, this.propertyIndex = l;
    } else
      u.fromArray !== void 0 && u.toArray !== void 0 ? (E = this.BindingType.HasFromToArray, this.resolvedProperty = u) : Array.isArray(u) ? (E = this.BindingType.EntireArray, this.resolvedProperty = u) : this.propertyName = a;
    this.getValue = this.GetterByBindingType[E], this.setValue = this.SetterByBindingTypeAndVersioning[E][c];
  }
  unbind() {
    this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
  }
}
PropertyBinding.Composite = Composite$1;
PropertyBinding.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
  PropertyBinding.prototype._getValue_direct,
  PropertyBinding.prototype._getValue_array,
  PropertyBinding.prototype._getValue_arrayElement,
  PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding.prototype._setValue_direct,
    PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding.prototype._setValue_array,
    PropertyBinding.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding.prototype._setValue_arrayElement,
    PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding.prototype._setValue_fromArray,
    PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class InstancedInterleavedBuffer extends InterleavedBuffer {
  constructor(e, s, o = 1) {
    super(e, s), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = o;
  }
  copy(e) {
    return super.copy(e), this.meshPerAttribute = e.meshPerAttribute, this;
  }
  clone(e) {
    const s = super.clone(e);
    return s.meshPerAttribute = this.meshPerAttribute, s;
  }
  toJSON(e) {
    const s = super.toJSON(e);
    return s.isInstancedInterleavedBuffer = !0, s.meshPerAttribute = this.meshPerAttribute, s;
  }
}
class Raycaster {
  constructor(e, s, o = 0, a = 1 / 0) {
    this.ray = new Ray(e, s), this.near = o, this.far = a, this.camera = null, this.layers = new Layers(), this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(e, s) {
    this.ray.set(e, s);
  }
  setFromCamera(e, s) {
    s.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(s.matrixWorld), this.ray.direction.set(e.x, e.y, 0.5).unproject(s).sub(this.ray.origin).normalize(), this.camera = s) : s.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, (s.near + s.far) / (s.near - s.far)).unproject(s), this.ray.direction.set(0, 0, -1).transformDirection(s.matrixWorld), this.camera = s) : console.error("THREE.Raycaster: Unsupported camera type: " + s.type);
  }
  intersectObject(e, s = !0, o = []) {
    return intersectObject(e, this, o, s), o.sort(ascSort), o;
  }
  intersectObjects(e, s = !0, o = []) {
    for (let a = 0, l = e.length; a < l; a++)
      intersectObject(e[a], this, o, s);
    return o.sort(ascSort), o;
  }
}
function ascSort(r, e) {
  return r.distance - e.distance;
}
function intersectObject(r, e, s, o) {
  if (r.layers.test(e.layers) && r.raycast(e, s), o === !0) {
    const a = r.children;
    for (let l = 0, u = a.length; l < u; l++)
      intersectObject(a[l], e, s, !0);
  }
}
class Spherical {
  constructor(e = 1, s = 0, o = 0) {
    return this.radius = e, this.phi = s, this.theta = o, this;
  }
  set(e, s, o) {
    return this.radius = e, this.phi = s, this.theta = o, this;
  }
  copy(e) {
    return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
  }
  // restrict phi to be between EPS and PI-EPS
  makeSafe() {
    return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
  }
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z);
  }
  setFromCartesianCoords(e, s, o) {
    return this.radius = Math.sqrt(e * e + s * s + o * o), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e, o), this.phi = Math.acos(clamp$2(s / this.radius, -1, 1))), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _startP = /* @__PURE__ */ new Vector3$1(), _startEnd = /* @__PURE__ */ new Vector3$1();
class Line3 {
  constructor(e = new Vector3$1(), s = new Vector3$1()) {
    this.start = e, this.end = s;
  }
  set(e, s) {
    return this.start.copy(e), this.end.copy(s), this;
  }
  copy(e) {
    return this.start.copy(e.start), this.end.copy(e.end), this;
  }
  getCenter(e) {
    return e.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  delta(e) {
    return e.subVectors(this.end, this.start);
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  distance() {
    return this.start.distanceTo(this.end);
  }
  at(e, s) {
    return this.delta(s).multiplyScalar(e).add(this.start);
  }
  closestPointToPointParameter(e, s) {
    _startP.subVectors(e, this.start), _startEnd.subVectors(this.end, this.start);
    const o = _startEnd.dot(_startEnd);
    let l = _startEnd.dot(_startP) / o;
    return s && (l = clamp$2(l, 0, 1)), l;
  }
  closestPointToPoint(e, s, o) {
    const a = this.closestPointToPointParameter(e, s);
    return this.delta(o).multiplyScalar(a).add(this.start);
  }
  applyMatrix4(e) {
    return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this;
  }
  equals(e) {
    return e.start.equals(this.start) && e.end.equals(this.end);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class ShapePath {
  constructor() {
    this.type = "ShapePath", this.color = new Color(), this.subPaths = [], this.currentPath = null;
  }
  moveTo(e, s) {
    return this.currentPath = new Path(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(e, s), this;
  }
  lineTo(e, s) {
    return this.currentPath.lineTo(e, s), this;
  }
  quadraticCurveTo(e, s, o, a) {
    return this.currentPath.quadraticCurveTo(e, s, o, a), this;
  }
  bezierCurveTo(e, s, o, a, l, u) {
    return this.currentPath.bezierCurveTo(e, s, o, a, l, u), this;
  }
  splineThru(e) {
    return this.currentPath.splineThru(e), this;
  }
  toShapes(e) {
    function s(F) {
      const W = [];
      for (let G = 0, q = F.length; G < q; G++) {
        const fe = F[G], _e = new Shape();
        _e.curves = fe.curves, W.push(_e);
      }
      return W;
    }
    function o(F, W) {
      const G = W.length;
      let q = !1;
      for (let fe = G - 1, _e = 0; _e < G; fe = _e++) {
        let Le = W[fe], Fe = W[_e], Ee = Fe.x - Le.x, Ge = Fe.y - Le.y;
        if (Math.abs(Ge) > Number.EPSILON) {
          if (Ge < 0 && (Le = W[_e], Ee = -Ee, Fe = W[fe], Ge = -Ge), F.y < Le.y || F.y > Fe.y)
            continue;
          if (F.y === Le.y) {
            if (F.x === Le.x)
              return !0;
          } else {
            const ve = Ge * (F.x - Le.x) - Ee * (F.y - Le.y);
            if (ve === 0)
              return !0;
            if (ve < 0)
              continue;
            q = !q;
          }
        } else {
          if (F.y !== Le.y)
            continue;
          if (Fe.x <= F.x && F.x <= Le.x || Le.x <= F.x && F.x <= Fe.x)
            return !0;
        }
      }
      return q;
    }
    const a = ShapeUtils.isClockWise, l = this.subPaths;
    if (l.length === 0)
      return [];
    let u, c, E;
    const d = [];
    if (l.length === 1)
      return c = l[0], E = new Shape(), E.curves = c.curves, d.push(E), d;
    let f = !a(l[0].getPoints());
    f = e ? !f : f;
    const h = [], S = [];
    let R = [], _ = 0, m;
    S[_] = void 0, R[_] = [];
    for (let F = 0, W = l.length; F < W; F++)
      c = l[F], m = c.getPoints(), u = a(m), u = e ? !u : u, u ? (!f && S[_] && _++, S[_] = { s: new Shape(), p: m }, S[_].s.curves = c.curves, f && _++, R[_] = []) : R[_].push({ h: c, p: m[0] });
    if (!S[0])
      return s(l);
    if (S.length > 1) {
      let F = !1, W = 0;
      for (let G = 0, q = S.length; G < q; G++)
        h[G] = [];
      for (let G = 0, q = S.length; G < q; G++) {
        const fe = R[G];
        for (let _e = 0; _e < fe.length; _e++) {
          const Le = fe[_e];
          let Fe = !0;
          for (let Ee = 0; Ee < S.length; Ee++)
            o(Le.p, S[Ee].p) && (G !== Ee && W++, Fe ? (Fe = !1, h[Ee].push(Le)) : F = !0);
          Fe && h[G].push(Le);
        }
      }
      W > 0 && F === !1 && (R = h);
    }
    let L;
    for (let F = 0, W = S.length; F < W; F++) {
      E = S[F].s, d.push(E), L = R[F];
      for (let G = 0, q = L.length; G < q; G++)
        E.holes.push(L[G].h);
    }
    return d;
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: REVISION$1
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = REVISION$1);
let Cartographic$1 = class gd {
  /**
   * @param longitude Longitude, defaults to 0
   * @param latitude Latitude, defaults to 0
   * @param height Height, defaults to 0
   */
  constructor(e = 0, s = 0, o = 0) {
    this.longitude = 0, this.latitude = 0, this.height = 0, this.longitude = e, this.latitude = s, this.height = o;
  }
  /**
   * Constructs a 'Cartographic' from the API 'Cartographic' interface
   * @param v The API 'Cartographic'
   * @param height Optional 'height' to override the value in 'v.height'
   */
  static fromApi(e, s) {
    return new gd(e.longitude, e.latitude, s ?? e.height);
  }
  /**
   * Sets all the fields of the cartographic position and returns a reference to this
   * @param longitude
   * @param latitude
   * @param height
   */
  set(e = 0, s = 0, o = 0) {
    return this.longitude = e, this.latitude = s, this.height = o, this;
  }
  /**
   * Sets the longitude of this to the provided value, returning this for chaining.
   * @param longitude Longitude in radians
   */
  setLongitude(e) {
    return this.longitude = e, this;
  }
  /**
   * Sets the latitude of this to the provided value, returning this for chaining.
   * @param latitude Geodetic latitude in radians
   */
  setLatitude(e) {
    return this.latitude = e, this;
  }
  /**
   * Sets the height of this to the provided value, returning this for chaining.
   * @param height Height in meters
   */
  setHeight(e) {
    return this.height = e, this;
  }
  /**
   * Returns true if 'this' position exactly equals the 'other' position. This uses direct floating point equals
   * comparison without any epsilon.
   * @param other
   */
  equals(e) {
    return this.longitude === e.longitude && this.latitude === e.latitude && this.height === e.height;
  }
  /**
   * Returns true if 'this' position exactly equals the 'other' position, within the given range 'epsilon'.
   *
   * Sometimes an 'epsilon' is needed in floating point comparisons as numerical error and limited precision means
   * that some operations will produce slightly incorrect results. e.g. Using strict equality for '1.1 - 0.9 == 0.2'
   * will return false under IEE754 FP64. An epsilon adds an 'allowed error' to catch these kinds of errors.
   * @param other
   * @param epsilon
   */
  equalsEpsilon(e, s) {
    return Math.abs(this.longitude - e.longitude) <= s && Math.abs(this.latitude - e.latitude) <= s && Math.abs(this.height - e.height) <= s;
  }
  /**
   * Returns a new Cartographic instance with longitude, latitude and height copied from this
   */
  clone() {
    return new gd().copy(this);
  }
  /**
   * Copies the longitude, latitude and height from the other Cartographic into this.
   *
   * Returns a reference to this for chaining.
   * @param other
   */
  copy(e) {
    return this.set(e.longitude, e.latitude, e.height);
  }
  /**
   * Sets the x, y and z coordinates on the vector to long/lat/height respectively
   * @param target
   */
  toVector3(e = new Vector3$1()) {
    return e.set(this.longitude, this.latitude, this.height);
  }
  /**
   * Sets the x and y coordinates on the vector to long/lat respectively
   * @param target
   */
  toVector2(e = new Vector2()) {
    return e.set(this.longitude, this.latitude);
  }
  /**
   * Sets the long/lat/height on this to x, y and z coordinates on the vector respectively
   * @param other
   */
  setFromVector3(e) {
    return this.set(e.x, e.y, e.z);
  }
  /**
   * Sets the x and y coordinates on the vector to long/lat respectively
   * @param other
   */
  setFromVector2(e) {
    return this.set(this.longitude, this.latitude);
  }
}, Ellipsoid$1 = class {
  /**
   * Constructs a new ellipsoid instance with the provided radii parameters
   * @param x The radius along the X-axis
   * @param y The radius along the Y-axis
   * @param z The radius along the Z-axis
   */
  constructor(e, s, o) {
    this._radii = new Vector3$1(e, s, o), this._radiiSquared = this._radii.clone().multiply(this._radii), this._oneOverRadii = new Vector3$1(1 / e, 1 / s, 1 / o), this._oneOverRadiiSquared = new Vector3$1(1 / (e * e), 1 / (s * s), 1 / (o * o)), this._radiiToTheFourth = this._radiiSquared.clone().multiply(this._radiiSquared), this._minimumRadius = Math.min(e, s, o), this._maximumRadius = Math.max(e, s, o);
  }
  /**
   * Returns the geocentric normal, given a WGS 84 position on the surface of the ellipsoid.
   * @param position WGS 84 position on the surface of the ellipsoid
   * @param result Vector to write the result into
   */
  geocentricSurfaceNormalForPosition(e, s = new Vector3$1()) {
    return s.copy(s).normalize();
  }
  /**
   * Returns the geodetic normal, given a WGS 84 position on the surface of the ellipsoid.
   * @param position WGS 84 position on the surface of the ellipsoid
   * @param result Vector to write the result into
   */
  geodeticSurfaceNormalForPosition(e, s = new Vector3$1()) {
    return s.copy(e).multiply(this._oneOverRadiiSquared).normalize();
  }
  /**
   * Returns the geodetic surface normal for the provided cartographic position
   * @param position Cartographic position to sample the normal for
   * @param result Vector to write the result into
   */
  geodeticSurfaceNormalForCartographic(e, s = new Vector3$1()) {
    const o = Math.cos(e.latitude);
    return s.set(o * Math.cos(e.longitude), o * Math.sin(e.longitude), Math.sin(e.latitude));
  }
  /**
   * Returns the cartographic position that corresponds to the provided position on the surface of the ellipsoid.
   *
   * Will not return useful results of 'position' does not lie on the surface of the ellipsoid.
   *
   * @param position Cartesian position on surface of ellipsoid to compute the cartographic position of
   * @param result Value to write the result into
   */
  cartographicForPositionOnSurface(e, s = new Cartographic$1()) {
    const o = this.geodeticSurfaceNormalForPosition(e);
    return s.longitude = Math.atan2(o.y, o.x), s.latitude = Math.asin(o.z / o.length()), s;
  }
  /**
   * Returns the cartographic position and height for the provided cartesian position.
   *
   * This uses an iterative root finding process that behaves poorly if the point is too close to the center of the ellipsoid.
   *
   * @param position
   * @param result The object onto which to store the result.
   */
  cartographicForPosition(e, s = new Cartographic$1()) {
    const o = this.scaleToGeodeticSurface(e), a = e.clone().sub(o);
    return this.cartographicForPositionOnSurface(o, s), s.height = Math.sign(a.dot(e)) * a.length(), s;
  }
  /**
   * Produces a cartesian position around the ellipsoid for the provided cartographic position
   * @param cartographic
   * @param result The object onto which to store the result.
   */
  cartesianForCartographic(e, s = new Vector3$1()) {
    const o = this.geodeticSurfaceNormalForCartographic(e), a = o.clone().multiply(this._radiiSquared), l = Math.sqrt(o.dot(a));
    return a.divideScalar(l), o.multiplyScalar(e.height), s.copy(a).add(o);
  }
  /**
   * Scales the provided Cartesian position along the geodetic surface normal so that it is on the surface of this
   * ellipsoid.
   *
   * This uses an iterative root finding process that behaves poorly if the point is too close to the center of the ellipsoid.
   *
   * @param position The position position to scale.
   * @param result The object onto which to store the result.
   *
   * @function scaleToGeodeticSurface
   */
  scaleToGeodeticSurface(e, s = new Vector3$1()) {
    const o = 1 / Math.sqrt(e.x * e.x * this._oneOverRadiiSquared.x + e.y * e.y * this._oneOverRadiiSquared.y + e.z * e.z * this._oneOverRadiiSquared.z), a = new Vector3$1(o * e.x * this._oneOverRadiiSquared.x, o * e.y * this._oneOverRadiiSquared.y, o * e.z * this._oneOverRadiiSquared.z).length();
    let l = (1 - o) * (e.length() / a);
    const u = e.x * e.x, c = e.y * e.y, E = e.z * e.z;
    let d = 0, f = 0, h = 0, S = 0, R = 1, _ = 32;
    do {
      l -= S / R, d = 1 + l * this._oneOverRadiiSquared.x, f = 1 + l * this._oneOverRadiiSquared.y, h = 1 + l * this._oneOverRadiiSquared.z;
      const m = d * d, L = f * f, F = h * h, W = d * m, G = f * L, q = h * F;
      S = u / (this._radiiSquared.x * m) + c / (this._radiiSquared.y * L) + E / (this._radiiSquared.z * F) - 1, R = -2 * (u / (this._radiiToTheFourth.x * W) + c / (this._radiiToTheFourth.y * G) + E / (this._radiiToTheFourth.z * q));
    } while (Math.abs(S) > 1e-10 && _-- >= 0);
    return s.set(e.x / d, e.y / f, e.z / h);
  }
  /**
   * Scales the cartesian position along the geocentric normal to produce a point on the surface of the ellipsoid
   * @param position The position to scale
   * @param result The value to write the result into
   */
  scaleToGeocentricSurface(e, s = new Vector3$1()) {
    const o = 1 / Math.sqrt(e.x * e.x * this._oneOverRadiiSquared.x + e.y * e.y * this._oneOverRadiiSquared.y + e.z * e.z * this._oneOverRadiiSquared.z);
    return s.copy(e).multiplyScalar(o);
  }
  /**
   * Constructs a rotational matrix from the basis vectors sampled from the surface of the ellipsoid at the provided
   * cartographic position.
   *
   * Constructs a TBN (tangent, bitangent, normal) matrix by sampling the normal and tangent analytically and
   * reconstructing the bi-tangent as the cross product of the tangent and normal to produce the full basis.
   *
   * The x axis is the tangent
   * The y axis is the normal
   * The z axis is the bitangent
   *
   * @param position
   * @param result
   * @param normal
   * @param tangent
   * @param bitangent
   */
  rotationBasisForCartographic(e, s = new Matrix3$1(), o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1()) {
    this.geodeticSurfaceNormalForCartographic(e, o);
    const u = this.geodeticSurfaceNormalForCartographic(e.clone().setLatitude(e.latitude - 0.01));
    return l.copy(o).cross(u).normalize(), a.copy(o).cross(l).normalize(), s !== null && (s.elements[0] = a.x, s.elements[1] = a.y, s.elements[2] = a.z, s.elements[3] = o.x, s.elements[4] = o.y, s.elements[5] = o.z, s.elements[6] = l.x, s.elements[7] = l.y, s.elements[8] = l.z), s;
  }
  /**
   * Checks if the given tile will be visible based on the normalized direction vector from the tile to the camera
   * that is observing the planet.
   *
   * This works by calculating the analytical surface normals of the ellipsoid at the corners of the tile and compares
   * them with the globeToCam dir to find if any of the ellipsoid patch is not back facing.
   *
   * If all the normals point away from the camera then the surface patch must be back-facing and can be culled
   * without meshing. If at least one normal points towards the camera then some non zero part of the surface may be
   * visible and so the tile must not be culled.
   * @param tileToCam The direction from the tile to the camera
   * @param min
   * @param max
   */
  regionVisibleFromViewDir(e, s, o) {
    const a = new Cartographic$1(), l = this.geodeticSurfaceNormalForCartographic(a.copy(s)), u = this.geodeticSurfaceNormalForCartographic(a.copy(o)), c = this.geodeticSurfaceNormalForCartographic(a.set(s.longitude, o.latitude)), E = this.geodeticSurfaceNormalForCartographic(a.set(o.longitude, s.latitude)), d = e.dot(l) > -0.1, f = e.dot(u) > -0.1, h = e.dot(c) > -0.1, S = e.dot(E) > -0.1;
    return d || f || h || S;
  }
  /**
   * Calculates an approximate bounding sphere for the given spheroid patch.
   *
   * The resulting bounding sphere is not guaranteed to contain the entire surface of the ellipsoid. This is only
   * because I have not yet proven that it contains the whole surface patch. Until I have this will be marked as
   * approximate.
   * @param min The minimum long/lat pair of the patch to get the bounding sphere of
   * @param max The maximum long/lat pair of the patch to get the bounding sphere of
   */
  approximateBoundingSphereForRegion(e, s) {
    const o = (e.longitude + s.longitude) / 2, a = (e.latitude + s.latitude) / 2, l = new Cartographic$1(), u = [
      this.cartesianForCartographic(l.set(e.longitude, e.latitude)),
      this.cartesianForCartographic(l.set(s.longitude, s.latitude)),
      this.cartesianForCartographic(l.set(s.longitude, e.latitude)),
      this.cartesianForCartographic(l.set(e.longitude, s.latitude)),
      this.cartesianForCartographic(l.set(o, a)),
      this.cartesianForCartographic(l.set(e.longitude, a)),
      this.cartesianForCartographic(l.set(s.longitude, a)),
      this.cartesianForCartographic(l.set(o, e.latitude)),
      this.cartesianForCartographic(l.set(o, s.latitude))
    ], c = new Vector3$1();
    for (const f of u)
      c.add(f);
    c.divideScalar(u.length);
    const E = new Vector3$1();
    let d = 0;
    for (const f of u) {
      const h = E.copy(c).sub(f).length();
      d = Math.max(d, h);
    }
    return new Sphere$1(c, d);
  }
  /**
   * Will update the given object's position so it will be placed at the specified cartographic position, rotated so
   * that the object's local up direction matches the local surface normal of the ellipsoid.
   *
   * This function allows placing objects on the surface of the ellipsoid so that up is defined relative to the
   * surface for that object.
   * @param object The object to place on the ellipsoid
   * @param cartographic The position to place the object
   */
  placeObjectFromCartographic(e, s) {
    this.cartesianForCartographic(s, e.position);
    const o = this.rotationBasisForCartographic(s);
    e.setRotationFromMatrix(new Matrix4().setFromMatrix3(o));
  }
  /**
   * Will update the given object's position so it will be placed at the specified ECEF cartesian position, rotated so
   * that the object's local up direction matches the local surface normal of the ellipsoid.
   *
   * This function allows placing objects on the surface of the ellipsoid so that up is defined relative to the
   * surface for that object.
   * @param object The object to place on the ellipsoid
   * @param position The position to place the object
   */
  placeObjectFromCartesian(e, s) {
    e.position.copy(s);
    const o = this.cartographicForPosition(s), a = this.rotationBasisForCartographic(o);
    e.setRotationFromMatrix(new Matrix4().setFromMatrix3(a));
  }
  /**
   * Returns a new Vector3 instance that contains the radii of the ellipsoid along each axis
   */
  get radii() {
    return this._radii.clone();
  }
  /**
   * Returns a new Vector3 instance that contains the radii^2 of the ellipsoid along each axis
   */
  get radiiSquared() {
    return this._radiiSquared.clone();
  }
  /**
   * Returns a new Vector3 instance that contains the 1/radii of the ellipsoid along each axis
   */
  get oneOverRadii() {
    return this._oneOverRadii.clone();
  }
  /**
   * Returns a new Vector3 instance that contains the 1/radii^2 of the ellipsoid along each axis
   */
  get oneOverRadiiSquared() {
    return this._oneOverRadiiSquared.clone();
  }
  /**
   * Returns a new Vector3 instance that contains the radii^4 of the ellipsoid along each axis
   */
  get radiiToTheFourth() {
    return this._radiiToTheFourth.clone();
  }
  /**
   * Returns the minimum of the ellipsoid
   */
  get minimumRadius() {
    return this._minimumRadius;
  }
  /**
   * Returns the maximum of the ellipsoid
   */
  get maximumRadius() {
    return this._maximumRadius;
  }
};
Ellipsoid$1.WGS_84 = new Ellipsoid$1(6378137, 6378137, 6356752314245e-6);
Ellipsoid$1.SCALED_WGS_84 = new Ellipsoid$1(1, 1, 6356752314245e-6 / 6378137);
class MathUtils {
  /**
   *
   * @param a
   * @param b
   * @param relativeEpsilon
   * @param absoluteEpsilon
   */
  static equalsEpsilon(e, s, o = 0, a = o) {
    const l = Math.abs(e - s);
    return l <= a || l <= o * Math.max(Math.abs(e), Math.abs(s));
  }
  /**
   * Project a sphere's radius with radius *r* into screen space at the given distance *d* from the camera.
   *
   * The *halfScreenHeight* parameter is multiplied with the result of the projection function to produce the
   * projected radius of the sphere in pixels. The parameter defaults to 1 which becomes an identity op (multiply by
   * one) and so leaving *halfScreenHeight* unspecified will allow getting the raw result of the projection
   *
   * @param fov The vertical FOV of the projection matrix in degrees
   * @param d The distance from the camera to the center of the sphere
   * @param r The radius of the sphere to project
   * @param halfScreenHeight The height of the screen in pixels / 2.
   */
  static computeProjectedRadiusPerspective(e, s, o, a = 1) {
    const l = e / 2 * Math.PI / 180;
    return 1 / Math.tan(l) * o / Math.sqrt(s * s - o * o) * a;
  }
  /**
   * Converts a position in screen coordinates (pixel coordinates) into NDC coordinates. This essentially just applies
   * the viewport transform to a screen coordinate. The screen coordinate is normalized into a -1 to 1 range based on
   * the screen dimensions
   * @param x
   * @param y
   * @param sizeX
   * @param sizeY
   * @param result
   */
  static screenCoordsToNDC(e, s, o, a, l) {
    return l.x = -1 + 2 * (e / o), l.y = -1 + 2 * (s / a), l;
  }
  /**
   * Decode a value sampled from the logarithmic depth buffer to retrieve the raw Z value. The returned value returns
   * the distance from the camera to the point on whichever surface was sampled to produce the depth value.
   *
   * To convert this back to a full world space position this value should be multiplied with the direction from the
   * camera's world space position to the pixel coordinate for the depth value.
   *
   * This only works for logarithmic depth buffer.
   *
   * @param depth The depth value extracted from the depth buffer
   * @param far The far clipping plane of the projection matrix
   */
  static decodeLogarithmicDepth(e, s, o) {
    const a = Math.pow(2, e * Math.log2(o + 1)) - 1, l = o / (o - s), u = o * s / (s - o);
    return l + u / a;
  }
  /**
   * Converts degrees into radians
   * @param degrees Angle in degrees
   * @returns result Angle in radians
   */
  static degreesToRadians(e) {
    return e * (Math.PI / 180);
  }
  /**
   * Converts radians into degrees
   * @param radians Angle in radians
   * @returns result Angle in degrees
   */
  static radiansToDegrees(e) {
    return e * (180 / Math.PI);
  }
  /**
   * Projects the geometric error of a tile into screen space error.
   * @param geometricError The geometric error of the tile
   * @param screenHeight The height of the screen image in pixels
   * @param distance The distance from the camera to the tile
   * @param fov The vertical fov of the camera (fovy) in radians
   */
  static projectGeometricErrorPerspective(e, s, o, a) {
    return e * s / (o * 2 * Math.tan(a / 2));
  }
  static projectGeometricErrorOrthographic(e, s, o, a, l, u, c) {
    const E = Math.max(a - l, u - c) / Math.max(s, o);
    return e / E;
  }
  /**
   * Utility function for rotating about the Z axis
   * @param v Generic vector with X and Y component to apply rotation to
   * @param angle The angle of the rotation in radians
   */
  static rotateAboutZ(e, s) {
    const o = e.x, a = e.y, l = o * Math.cos(s), u = o * Math.sin(s), c = a * Math.cos(s), E = a * Math.sin(s);
    e.x = -E + l, e.y = c + u;
  }
  /**
   * Calculate the angle between two points.
   *
   * @param p1
   * @param p2
   * @returns
   */
  static angle2(e, s) {
    const o = new Vector2(e.x, e.y), a = new Vector2(s.x, s.y);
    return a.sub(o), a.normalize(), a.y < 0 ? -Math.acos(a.x) : Math.acos(a.x);
  }
  /**
   * Compute polar coordinates.
   *
   * @param point
   * @param distance
   * @param angle
   * @returns
   */
  static polar(e, s, o) {
    return new Vector2(e.x + s * Math.cos(o), e.y + s * Math.sin(o));
  }
  /**
   * Normalize a value to a range.
   *
   * @param value
   * @param min
   * @param max
   * @returns
   */
  static normalize(e, s, o) {
    return o === s ? 0 : (e - s) / (o - s);
  }
  /**
   * Clamp a value to a range.
   *
   * @param value
   * @param min
   * @param max
   * @returns
   */
  static clamp(e, s, o) {
    return Math.max(s, Math.min(o, MathUtils.normalize(e, s, o)));
  }
}
MathUtils.EPSILON1 = 0.1;
MathUtils.EPSILON2 = 0.01;
MathUtils.EPSILON3 = 1e-3;
MathUtils.EPSILON4 = 1e-4;
MathUtils.EPSILON5 = 1e-5;
MathUtils.EPSILON6 = 1e-6;
MathUtils.EPSILON7 = 1e-7;
MathUtils.EPSILON8 = 1e-8;
MathUtils.EPSILON9 = 1e-9;
MathUtils.EPSILON10 = 1e-10;
MathUtils.EPSILON11 = 1e-11;
MathUtils.EPSILON12 = 1e-12;
MathUtils.EPSILON13 = 1e-13;
MathUtils.EPSILON14 = 1e-14;
MathUtils.EPSILON15 = 1e-15;
MathUtils.EPSILON16 = 1e-16;
MathUtils.EPSILON17 = 1e-17;
MathUtils.EPSILON18 = 1e-18;
MathUtils.EPSILON19 = 1e-19;
MathUtils.EPSILON20 = 1e-20;
MathUtils.EPSILON21 = 1e-21;
MathUtils.ZERO_2 = new Vector2(0, 0);
MathUtils.ZERO_3 = new Vector3$1(0, 0, 0);
MathUtils.X_AXIS = new Vector3$1(1, 0, 0);
MathUtils.Y_AXIS = new Vector3$1(0, 1, 0);
MathUtils.Z_AXIS = new Vector3$1(0, 0, 1);
class Rectangle {
  constructor(e = 0, s = 0, o = 0, a = 0) {
    this.west = e, this.south = s, this.east = o, this.north = a;
  }
  /**
   * Returns the width of the rectangle in radians
   */
  get width() {
    return this.east - this.west;
  }
  /**
   * Returns the height of the rectangle in radians
   */
  get height() {
    return this.north - this.south;
  }
  /**
   * Returns a 'Cartographic' that represents the southwestern-most point of the rectangle
   */
  get southwest() {
    return new Cartographic$1(this.west, this.south);
  }
  /**
   * Returns a 'Cartographic' that represents the southeastern-most point of the rectangle
   */
  get southeast() {
    return new Cartographic$1(this.east, this.south);
  }
  /**
   * Returns a 'Cartographic' that represents the northwestern-most point of the rectangle
   */
  get northwest() {
    return new Cartographic$1(this.west, this.north);
  }
  /**
   * Returns a 'Cartographic' that represents the northeastern-most point of the rectangle
   */
  get northeast() {
    return new Cartographic$1(this.east, this.north);
  }
  /**
   * Returns a 'Cartographic' that represents the center, or midpoint, of the triangle
   */
  get midpoint() {
    return new Cartographic$1((this.west + this.east) / 2, (this.south + this.north) / 2);
  }
  /**
   * Sets each value on this 'Rectangle', returning a reference to 'this'
   * @param west see Rectangle.west
   * @param south see Rectangle.south
   * @param east see Rectangle.east
   * @param north see Rectangle.north
   */
  set(e, s, o, a) {
    return this.west = e, this.south = s, this.east = o, this.north = a, this;
  }
  /**
   * Sets the values on 'this' to the provided values. The input values in degrees will be converted to radians.
   * @param west see Rectangle.west
   * @param south see Rectangle.south
   * @param east see Rectangle.east
   * @param north see Rectangle.north
   */
  fromDegrees(e, s, o, a) {
    return this.west = MathUtils.degreesToRadians(e), this.south = MathUtils.degreesToRadians(s), this.east = MathUtils.degreesToRadians(o), this.north = MathUtils.degreesToRadians(a), this;
  }
  /**
   * Set the values on 'this' to the values on 'other'. Returns a reference to 'this'
   * @param other
   */
  copy(e) {
    return this.west = e.west, this.south = e.south, this.east = e.east, this.north = e.north, this;
  }
  /**
   * Constructs a new 'Rectangle' instance with the same values as 'this'.
   */
  clone() {
    return new Rectangle().copy(this);
  }
  /**
   * Returns true if the cartographic is on or inside the rectangle, false otherwise.
   *
   * @param cartographic The cartographic to test.
   * @returns true if the provided cartographic is inside the rectangle, false otherwise.
   */
  contains(e) {
    const s = e.longitude, o = e.latitude;
    return s >= this.west && s <= this.east && o >= this.south && o <= this.north;
  }
  /**
   * Returns true if the provided rectangle intersects with this rectangle, otherwise returns false.
   * @param other The region to test.
   */
  intersects(e) {
    const s = this.west <= e.east || this.east >= e.west, o = this.south <= e.north || this.north >= e.south;
    return s && o;
  }
  /**
   * Returns the intersection of 'this' and 'other'. This returns a new rectangle that represents the area that the
   * two rectangles overlap.
   *
   * This function will produce a malformed 'Rectangle' if the two input rectangles do not intersect. It is
   * recommended to call 'Rectangle.intersects' first to ensure they do intersect. The resulting triangle will have
   * negative width or height.
   *
   * e.g: The function will return a rectangle that represents 'C' in the below image.
   *
   *     ┌────────┐
   *     │      B │
   * ┌───┼────┐   │
   * │   │ C  │   │
   * │   │    │   │
   * │   └────┼───┘
   * │ A      │
   * └────────┘
   *
   * @param other
   * @param result
   */
  intersection(e, s = new Rectangle()) {
    return s.west = Math.max(this.west, e.west), s.south = Math.max(this.south, e.south), s.east = Math.min(this.east, e.east), s.north = Math.min(this.north, e.north), s;
  }
  /**
   * Returns the union of 'this' and 'other'. This returns a new rectangle that fully contains both 'this' and 'other'
   * within itself.
   *
   * This function will produce a malformed 'Rectangle' if the two input rectangles do not intersect. It is
   * recommended to call 'Rectangle.intersects' first to ensure they do intersect. The resulting triangle will have
   * negative width or height.
   *
   * e.g: With the given input:
   *
   *     ┌────────┐
   *     │      B │
   * ┌───┼────┐   │
   * │   │    │   │
   * │   │    │   │
   * │   └────┼───┘
   * │ A      │
   * └────────┘
   * A box that fully contains A and B is returned
   * ┌───┬────────┐
   * │   │      B │
   * ├───┼────┐   │
   * │   │    │   │
   * │   │    │   │
   * │   └────┼───┤
   * │ A      │   │
   * └────────┴───┘
   * @param other
   * @param result
   */
  union(e, s = new Rectangle()) {
    return s.west = Math.min(this.west, e.west), s.south = Math.min(this.south, e.south), s.east = Math.max(this.east, e.east), s.north = Math.max(this.north, e.north), s;
  }
  /**
   * Clips a cartographic point against this rectangle. This will clamp the point's latitude and longitude so that the
   * output point is inside the rectangle being clipped against
   * @param point
   * @param result
   */
  clipPoint(e, s = new Cartographic$1()) {
    return s.longitude = Math.max(this.west, Math.min(e.longitude, this.east)), s.latitude = Math.max(this.south, Math.min(e.latitude, this.north)), s;
  }
  /**
   * Returns true if 'this' region is a superset of the 'other' region. That is, 'other' is entirely contained within
   * 'this'
   * @param other The other region to test
   */
  isSupersetOf(e) {
    const s = this.west <= e.west && this.east >= e.east, o = this.south <= e.south && this.north >= e.north;
    return s && o;
  }
  /**
   * Returns true if 'this' region is a subset of the 'other' region. That is, 'other' entire contains 'this' within
   * itself.
   * @param other
   */
  isSubsetOf(e) {
    return e.isSupersetOf(this);
  }
  /**
   * Returns true if 'this' region exactly equals the 'other' region. This uses direct floating point equals
   * comparison without any epsilon.
   * @param other
   */
  equals(e) {
    return this.west === e.west && this.east === e.east && this.south === e.south && this.north === e.north;
  }
  /**
   * Returns true if 'this' region exactly equals the 'other' region, within the given range 'epsilon'.
   *
   * Sometimes an 'epsilon' is needed in floating point comparisons as numerical error and limited precision means
   * that some operations will produce slightly incorrect results. e.g. Using strict equality for '1.1 - 0.9 == 0.2'
   * will return false under IEE754 FP64. An epsilon adds an 'allowed error' to catch these kinds of errors.
   * @param other
   * @param epsilon
   */
  equalsEpsilon(e, s) {
    return Math.abs(this.west - e.west) <= s && Math.abs(this.east - e.east) <= s && Math.abs(this.south - e.south) <= s && Math.abs(this.north - e.north) <= s;
  }
  /**
   * Returns whether this rectangle is a legally defined rectangle.
   *
   * See 'Rectangle' docs for definition of 'legal'
   *
   * @see Rectangle
   */
  isLegal() {
    const e = Math.PI / 2;
    return !(this.west > this.east || this.south > this.north || this.west < -Math.PI || this.west > Math.PI || this.east < -Math.PI || this.east > Math.PI || this.south < -e || this.south > e || this.north < -e || this.north > e);
  }
}
Rectangle.MAX = Object.freeze(new Rectangle(-Math.PI, -Math.PI / 2, Math.PI, Math.PI / 2));
class CartographicTriangle extends Triangle {
  constructor(s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1()) {
    super(s, o, a);
    Qt(this, "cartA");
    Qt(this, "cartB");
    Qt(this, "cartC");
    this.cartA = toCartographic(s), this.cartB = toCartographic(o), this.cartC = toCartographic(a);
  }
  /**
   * Compute the projected area of the triangle.
   *
   * @returns
   */
  getProjectedArea() {
    const s = toCartesian(new Cartographic$1(this.cartA.longitude, this.cartA.latitude)), o = toCartesian(new Cartographic$1(this.cartB.longitude, this.cartB.latitude)), a = toCartesian(new Cartographic$1(this.cartC.longitude, this.cartC.latitude));
    return new Triangle(s, o, a).getArea();
  }
  /**
   * Compute the projected barycoord of a point.
   *
   * @param point
   * @param target
   * @returns
   */
  getProjectedBarycoord(s, o) {
    const a = toCartesian(new Cartographic$1(this.cartA.longitude, this.cartA.latitude)), l = toCartesian(new Cartographic$1(this.cartB.longitude, this.cartB.latitude)), u = toCartesian(new Cartographic$1(this.cartC.longitude, this.cartC.latitude));
    return new Triangle(a, l, u).getBarycoord(s, o);
  }
}
class Clustering {
  constructor(e) {
    Qt(this, "clusters");
    Qt(this, "maxRadius");
    this.clusters = [], this.maxRadius = e;
  }
  /**
   * Create a new cluster.
   *
   * @param point
   * @returns
   */
  createCluster(e) {
    return this.clusters.push({
      points: [e],
      centroid: e.clone()
    }), this.clusters.length - 1;
  }
  /**
   * Add a point to an existing cluster.
   *
   * @param point
   * @param clusterID
   * @returns
   */
  updateCluster(e, s) {
    const o = this.clusters[s], a = o.points.length;
    return o.centroid.multiplyScalar(a).add(e).divideScalar(a + 1), o.points.push(e), s;
  }
  /**
   * Cluster a point and get its cluster ID.
   *
   * @param point
   * @returns
   */
  add(e) {
    const s = [];
    for (let a = 0; a < this.clusters.length; a++) {
      const l = this.clusters[a].centroid.distanceTo(e);
      l <= this.maxRadius && s.push([l, a]);
    }
    let o = s[0];
    for (let a = 1; a < s.length; a++)
      s[a][0] < o[0] && (o = s[a]);
    return s.length > 0 ? this.updateCluster(e, o[1]) : this.createCluster(e);
  }
  /**
   * Get the list of points in a cluster.
   *
   * @param clusterID
   * @returns
   */
  getCluster(e) {
    return e >= 0 && e < this.clusters.length ? this.clusters[e].points.map((s) => s.clone()) : [];
  }
  /**
   * Get the number of clusters.
   *
   * @returns
   */
  getClusterCount() {
    return this.clusters.length;
  }
  /**
   * Clear all clusters. This will invalidate existing IDs
   */
  clear() {
    this.clusters = [];
  }
}
var ViewerErrorCode = /* @__PURE__ */ ((r) => (r[r.FailedLoad = 0] = "FailedLoad", r[r.MissingIFCRoot = 1] = "MissingIFCRoot", r[r.FailedLoadPanorama = 2] = "FailedLoadPanorama", r))(ViewerErrorCode || {});
class ViewerError extends Error {
  constructor(s, o) {
    super(o);
    Qt(this, "code");
    this.code = s;
  }
}
class EventRegister {
  constructor() {
    Qt(this, "callbacks");
    this.callbacks = /* @__PURE__ */ new Map();
  }
  /**
   * Register an event callback.
   *
   * @param type
   * @param callback
   */
  register(e, s) {
    let o = this.callbacks.get(e);
    o || (o = [], this.callbacks.set(e, o)), o.push(s);
  }
  /**
   * Unregister an event callback, returning whether or not it existed in the set.
   *
   * @param type
   * @param callback
   * @returns
   */
  unregister(e, s) {
    let o = this.callbacks.get(e);
    o || (o = [], this.callbacks.set(e, o));
    const a = o.indexOf(s);
    return a >= 0 ? (o.splice(a, 1), !0) : !1;
  }
  /**
   * Unregister all event callbacks.
   */
  unregisterAll() {
    for (const [e, s] of this.callbacks)
      s.length = 0;
  }
  /**
   * Emit an event context to all listeners of the event.
   *
   * @param type
   * @param context
   */
  emit(e, s) {
    const o = this.callbacks.get(e) ?? [];
    for (const a of o)
      a(s);
  }
}
function earcut$3(r, e, s = 2) {
  const o = e && e.length, a = o ? e[0] * s : r.length;
  let l = linkedList$1(r, 0, a, s, !0);
  const u = [];
  if (!l || l.next === l.prev)
    return u;
  let c, E, d;
  if (o && (l = eliminateHoles$1(r, e, l, s)), r.length > 80 * s) {
    c = 1 / 0, E = 1 / 0;
    let f = -1 / 0, h = -1 / 0;
    for (let S = s; S < a; S += s) {
      const R = r[S], _ = r[S + 1];
      R < c && (c = R), _ < E && (E = _), R > f && (f = R), _ > h && (h = _);
    }
    d = Math.max(f - c, h - E), d = d !== 0 ? 32767 / d : 0;
  }
  return earcutLinked$1(l, u, s, c, E, d, 0), u;
}
function linkedList$1(r, e, s, o, a) {
  let l;
  if (a === signedArea$1(r, e, s, o) > 0)
    for (let u = e; u < s; u += o)
      l = insertNode$1(u / o | 0, r[u], r[u + 1], l);
  else
    for (let u = s - o; u >= e; u -= o)
      l = insertNode$1(u / o | 0, r[u], r[u + 1], l);
  return l && equals$1(l, l.next) && (removeNode$1(l), l = l.next), l;
}
function filterPoints$1(r, e) {
  if (!r)
    return r;
  e || (e = r);
  let s = r, o;
  do
    if (o = !1, !s.steiner && (equals$1(s, s.next) || area$1(s.prev, s, s.next) === 0)) {
      if (removeNode$1(s), s = e = s.prev, s === s.next)
        break;
      o = !0;
    } else
      s = s.next;
  while (o || s !== e);
  return e;
}
function earcutLinked$1(r, e, s, o, a, l, u) {
  if (!r)
    return;
  !u && l && indexCurve$1(r, o, a, l);
  let c = r;
  for (; r.prev !== r.next; ) {
    const E = r.prev, d = r.next;
    if (l ? isEarHashed$1(r, o, a, l) : isEar$1(r)) {
      e.push(E.i, r.i, d.i), removeNode$1(r), r = d.next, c = d.next;
      continue;
    }
    if (r = d, r === c) {
      u ? u === 1 ? (r = cureLocalIntersections$1(filterPoints$1(r), e), earcutLinked$1(r, e, s, o, a, l, 2)) : u === 2 && splitEarcut$1(r, e, s, o, a, l) : earcutLinked$1(filterPoints$1(r), e, s, o, a, l, 1);
      break;
    }
  }
}
function isEar$1(r) {
  const e = r.prev, s = r, o = r.next;
  if (area$1(e, s, o) >= 0)
    return !1;
  const a = e.x, l = s.x, u = o.x, c = e.y, E = s.y, d = o.y, f = Math.min(a, l, u), h = Math.min(c, E, d), S = Math.max(a, l, u), R = Math.max(c, E, d);
  let _ = o.next;
  for (; _ !== e; ) {
    if (_.x >= f && _.x <= S && _.y >= h && _.y <= R && pointInTriangleExceptFirst(a, c, l, E, u, d, _.x, _.y) && area$1(_.prev, _, _.next) >= 0)
      return !1;
    _ = _.next;
  }
  return !0;
}
function isEarHashed$1(r, e, s, o) {
  const a = r.prev, l = r, u = r.next;
  if (area$1(a, l, u) >= 0)
    return !1;
  const c = a.x, E = l.x, d = u.x, f = a.y, h = l.y, S = u.y, R = Math.min(c, E, d), _ = Math.min(f, h, S), m = Math.max(c, E, d), L = Math.max(f, h, S), F = zOrder$1(R, _, e, s, o), W = zOrder$1(m, L, e, s, o);
  let G = r.prevZ, q = r.nextZ;
  for (; G && G.z >= F && q && q.z <= W; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangleExceptFirst(c, f, E, h, d, S, G.x, G.y) && area$1(G.prev, G, G.next) >= 0 || (G = G.prevZ, q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangleExceptFirst(c, f, E, h, d, S, q.x, q.y) && area$1(q.prev, q, q.next) >= 0))
      return !1;
    q = q.nextZ;
  }
  for (; G && G.z >= F; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangleExceptFirst(c, f, E, h, d, S, G.x, G.y) && area$1(G.prev, G, G.next) >= 0)
      return !1;
    G = G.prevZ;
  }
  for (; q && q.z <= W; ) {
    if (q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangleExceptFirst(c, f, E, h, d, S, q.x, q.y) && area$1(q.prev, q, q.next) >= 0)
      return !1;
    q = q.nextZ;
  }
  return !0;
}
function cureLocalIntersections$1(r, e) {
  let s = r;
  do {
    const o = s.prev, a = s.next.next;
    !equals$1(o, a) && intersects$1(o, s, s.next, a) && locallyInside$1(o, a) && locallyInside$1(a, o) && (e.push(o.i, s.i, a.i), removeNode$1(s), removeNode$1(s.next), s = r = a), s = s.next;
  } while (s !== r);
  return filterPoints$1(s);
}
function splitEarcut$1(r, e, s, o, a, l) {
  let u = r;
  do {
    let c = u.next.next;
    for (; c !== u.prev; ) {
      if (u.i !== c.i && isValidDiagonal$1(u, c)) {
        let E = splitPolygon$1(u, c);
        u = filterPoints$1(u, u.next), E = filterPoints$1(E, E.next), earcutLinked$1(u, e, s, o, a, l, 0), earcutLinked$1(E, e, s, o, a, l, 0);
        return;
      }
      c = c.next;
    }
    u = u.next;
  } while (u !== r);
}
function eliminateHoles$1(r, e, s, o) {
  const a = [];
  for (let l = 0, u = e.length; l < u; l++) {
    const c = e[l] * o, E = l < u - 1 ? e[l + 1] * o : r.length, d = linkedList$1(r, c, E, o, !1);
    d === d.next && (d.steiner = !0), a.push(getLeftmost$1(d));
  }
  a.sort(compareXYSlope);
  for (let l = 0; l < a.length; l++)
    s = eliminateHole$1(a[l], s);
  return s;
}
function compareXYSlope(r, e) {
  let s = r.x - e.x;
  if (s === 0 && (s = r.y - e.y, s === 0)) {
    const o = (r.next.y - r.y) / (r.next.x - r.x), a = (e.next.y - e.y) / (e.next.x - e.x);
    s = o - a;
  }
  return s;
}
function eliminateHole$1(r, e) {
  const s = findHoleBridge$1(r, e);
  if (!s)
    return e;
  const o = splitPolygon$1(s, r);
  return filterPoints$1(o, o.next), filterPoints$1(s, s.next);
}
function findHoleBridge$1(r, e) {
  let s = e;
  const o = r.x, a = r.y;
  let l = -1 / 0, u;
  if (equals$1(r, s))
    return s;
  do {
    if (equals$1(r, s.next))
      return s.next;
    if (a <= s.y && a >= s.next.y && s.next.y !== s.y) {
      const h = s.x + (a - s.y) * (s.next.x - s.x) / (s.next.y - s.y);
      if (h <= o && h > l && (l = h, u = s.x < s.next.x ? s : s.next, h === o))
        return u;
    }
    s = s.next;
  } while (s !== e);
  if (!u)
    return null;
  const c = u, E = u.x, d = u.y;
  let f = 1 / 0;
  s = u;
  do {
    if (o >= s.x && s.x >= E && o !== s.x && pointInTriangle$1(a < d ? o : l, a, E, d, a < d ? l : o, a, s.x, s.y)) {
      const h = Math.abs(a - s.y) / (o - s.x);
      locallyInside$1(s, r) && (h < f || h === f && (s.x > u.x || s.x === u.x && sectorContainsSector$1(u, s))) && (u = s, f = h);
    }
    s = s.next;
  } while (s !== c);
  return u;
}
function sectorContainsSector$1(r, e) {
  return area$1(r.prev, r, e.prev) < 0 && area$1(e.next, r, r.next) < 0;
}
function indexCurve$1(r, e, s, o) {
  let a = r;
  do
    a.z === 0 && (a.z = zOrder$1(a.x, a.y, e, s, o)), a.prevZ = a.prev, a.nextZ = a.next, a = a.next;
  while (a !== r);
  a.prevZ.nextZ = null, a.prevZ = null, sortLinked$1(a);
}
function sortLinked$1(r) {
  let e, s = 1;
  do {
    let o = r, a;
    r = null;
    let l = null;
    for (e = 0; o; ) {
      e++;
      let u = o, c = 0;
      for (let d = 0; d < s && (c++, u = u.nextZ, !!u); d++)
        ;
      let E = s;
      for (; c > 0 || E > 0 && u; )
        c !== 0 && (E === 0 || !u || o.z <= u.z) ? (a = o, o = o.nextZ, c--) : (a = u, u = u.nextZ, E--), l ? l.nextZ = a : r = a, a.prevZ = l, l = a;
      o = u;
    }
    l.nextZ = null, s *= 2;
  } while (e > 1);
  return r;
}
function zOrder$1(r, e, s, o, a) {
  return r = (r - s) * a | 0, e = (e - o) * a | 0, r = (r | r << 8) & 16711935, r = (r | r << 4) & 252645135, r = (r | r << 2) & 858993459, r = (r | r << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, r | e << 1;
}
function getLeftmost$1(r) {
  let e = r, s = r;
  do
    (e.x < s.x || e.x === s.x && e.y < s.y) && (s = e), e = e.next;
  while (e !== r);
  return s;
}
function pointInTriangle$1(r, e, s, o, a, l, u, c) {
  return (a - u) * (e - c) >= (r - u) * (l - c) && (r - u) * (o - c) >= (s - u) * (e - c) && (s - u) * (l - c) >= (a - u) * (o - c);
}
function pointInTriangleExceptFirst(r, e, s, o, a, l, u, c) {
  return !(r === u && e === c) && pointInTriangle$1(r, e, s, o, a, l, u, c);
}
function isValidDiagonal$1(r, e) {
  return r.next.i !== e.i && r.prev.i !== e.i && !intersectsPolygon$1(r, e) && // dones't intersect other edges
  (locallyInside$1(r, e) && locallyInside$1(e, r) && middleInside$1(r, e) && // locally visible
  (area$1(r.prev, r, e.prev) || area$1(r, e.prev, e)) || // does not create opposite-facing sectors
  equals$1(r, e) && area$1(r.prev, r, r.next) > 0 && area$1(e.prev, e, e.next) > 0);
}
function area$1(r, e, s) {
  return (e.y - r.y) * (s.x - e.x) - (e.x - r.x) * (s.y - e.y);
}
function equals$1(r, e) {
  return r.x === e.x && r.y === e.y;
}
function intersects$1(r, e, s, o) {
  const a = sign$7(area$1(r, e, s)), l = sign$7(area$1(r, e, o)), u = sign$7(area$1(s, o, r)), c = sign$7(area$1(s, o, e));
  return !!(a !== l && u !== c || a === 0 && onSegment$1(r, s, e) || l === 0 && onSegment$1(r, o, e) || u === 0 && onSegment$1(s, r, o) || c === 0 && onSegment$1(s, e, o));
}
function onSegment$1(r, e, s) {
  return e.x <= Math.max(r.x, s.x) && e.x >= Math.min(r.x, s.x) && e.y <= Math.max(r.y, s.y) && e.y >= Math.min(r.y, s.y);
}
function sign$7(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}
function intersectsPolygon$1(r, e) {
  let s = r;
  do {
    if (s.i !== r.i && s.next.i !== r.i && s.i !== e.i && s.next.i !== e.i && intersects$1(s, s.next, r, e))
      return !0;
    s = s.next;
  } while (s !== r);
  return !1;
}
function locallyInside$1(r, e) {
  return area$1(r.prev, r, r.next) < 0 ? area$1(r, e, r.next) >= 0 && area$1(r, r.prev, e) >= 0 : area$1(r, e, r.prev) < 0 || area$1(r, r.next, e) < 0;
}
function middleInside$1(r, e) {
  let s = r, o = !1;
  const a = (r.x + e.x) / 2, l = (r.y + e.y) / 2;
  do
    s.y > l != s.next.y > l && s.next.y !== s.y && a < (s.next.x - s.x) * (l - s.y) / (s.next.y - s.y) + s.x && (o = !o), s = s.next;
  while (s !== r);
  return o;
}
function splitPolygon$1(r, e) {
  const s = createNode(r.i, r.x, r.y), o = createNode(e.i, e.x, e.y), a = r.next, l = e.prev;
  return r.next = e, e.prev = r, s.next = a, a.prev = s, o.next = s, s.prev = o, l.next = o, o.prev = l, o;
}
function insertNode$1(r, e, s, o) {
  const a = createNode(r, e, s);
  return o ? (a.next = o.next, a.prev = o, o.next.prev = a, o.next = a) : (a.prev = a, a.next = a), a;
}
function removeNode$1(r) {
  r.next.prev = r.prev, r.prev.next = r.next, r.prevZ && (r.prevZ.nextZ = r.nextZ), r.nextZ && (r.nextZ.prevZ = r.prevZ);
}
function createNode(r, e, s) {
  return {
    i: r,
    // vertex index in coordinates array
    x: e,
    y: s,
    // vertex coordinates
    prev: null,
    // previous and next vertex nodes in a polygon ring
    next: null,
    z: 0,
    // z-order curve value
    prevZ: null,
    // previous and next nodes in z-order
    nextZ: null,
    steiner: !1
    // indicates whether this is a steiner point
  };
}
function signedArea$1(r, e, s, o) {
  let a = 0;
  for (let l = e, u = s - o; l < s; l += o)
    a += (r[u] - r[l]) * (r[l + 1] + r[u + 1]), u = l;
  return a;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var s = arguments[e];
      for (var o in s)
        ({}).hasOwnProperty.call(s, o) && (r[o] = s[o]);
    }
    return r;
  }, _extends$1.apply(null, arguments);
}
var DEFAULT_CONFIG = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  relTol: 1e-12,
  // minimum absolute difference between two compared values,
  // used by all comparison functions
  absTol: 1e-15,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
  number: "number",
  // type of fallback used for config { number: 'bigint' } when a value cannot be represented
  // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
  numberFallback: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function getSafeProperty(r, e) {
  if (isSafeProperty(r, e))
    return r[e];
  throw typeof r[e] == "function" && isSafeMethod(r, e) ? new Error('Cannot access method "' + e + '" as a property') : new Error('No access to property "' + e + '"');
}
function setSafeProperty(r, e, s) {
  if (isSafeProperty(r, e))
    return r[e] = s, s;
  throw new Error('No access to property "' + e + '"');
}
function isSafeProperty(r, e) {
  return !isPlainObject(r) && !Array.isArray(r) ? !1 : hasOwnProperty(safeNativeProperties, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function isSafeMethod(r, e) {
  return r == null || typeof r[e] != "function" || hasOwnProperty(r, e) && Object.getPrototypeOf && e in Object.getPrototypeOf(r) ? !1 : hasOwnProperty(safeNativeMethods, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function isPlainObject(r) {
  return typeof r == "object" && r && r.constructor === Object;
}
var safeNativeProperties = {
  length: !0,
  name: !0
}, safeNativeMethods = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class ObjectWrappingMap {
  constructor(e) {
    this.wrappedObject = e, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((e) => this.has(e)).values();
  }
  get(e) {
    return getSafeProperty(this.wrappedObject, e);
  }
  set(e, s) {
    return setSafeProperty(this.wrappedObject, e, s), this;
  }
  has(e) {
    return isSafeProperty(this.wrappedObject, e) && e in this.wrappedObject;
  }
  entries() {
    return mapIterator(this.keys(), (e) => [e, this.get(e)]);
  }
  forEach(e) {
    for (var s of this.keys())
      e(this.get(s), s, this);
  }
  delete(e) {
    isSafeProperty(this.wrappedObject, e) && delete this.wrappedObject[e];
  }
  clear() {
    for (var e of this.keys())
      this.delete(e);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
function mapIterator(r, e) {
  return {
    next: () => {
      var s = r.next();
      return s.done ? s : {
        value: e(s.value),
        done: !1
      };
    }
  };
}
function isNumber(r) {
  return typeof r == "number";
}
function isBigNumber(r) {
  return !r || typeof r != "object" || typeof r.constructor != "function" ? !1 : r.isBigNumber === !0 && typeof r.constructor.prototype == "object" && r.constructor.prototype.isBigNumber === !0 || typeof r.constructor.isDecimal == "function" && r.constructor.isDecimal(r) === !0;
}
function isBigInt(r) {
  return typeof r == "bigint";
}
function isComplex(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isComplex === !0 || !1;
}
function isFraction(r) {
  return r && typeof r == "object" && Object.getPrototypeOf(r).isFraction === !0 || !1;
}
function isUnit(r) {
  return r && r.constructor.prototype.isUnit === !0 || !1;
}
function isString(r) {
  return typeof r == "string";
}
var isArray = Array.isArray;
function isMatrix(r) {
  return r && r.constructor.prototype.isMatrix === !0 || !1;
}
function isCollection(r) {
  return Array.isArray(r) || isMatrix(r);
}
function isDenseMatrix(r) {
  return r && r.isDenseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function isSparseMatrix(r) {
  return r && r.isSparseMatrix && r.constructor.prototype.isMatrix === !0 || !1;
}
function isRange(r) {
  return r && r.constructor.prototype.isRange === !0 || !1;
}
function isIndex(r) {
  return r && r.constructor.prototype.isIndex === !0 || !1;
}
function isBoolean(r) {
  return typeof r == "boolean";
}
function isResultSet(r) {
  return r && r.constructor.prototype.isResultSet === !0 || !1;
}
function isHelp(r) {
  return r && r.constructor.prototype.isHelp === !0 || !1;
}
function isFunction(r) {
  return typeof r == "function";
}
function isDate(r) {
  return r instanceof Date;
}
function isRegExp(r) {
  return r instanceof RegExp;
}
function isObject$2(r) {
  return !!(r && typeof r == "object" && r.constructor === Object && !isComplex(r) && !isFraction(r));
}
function isMap(r) {
  return r ? r instanceof Map || r instanceof ObjectWrappingMap || typeof r.set == "function" && typeof r.get == "function" && typeof r.keys == "function" && typeof r.has == "function" : !1;
}
function isNull(r) {
  return r === null;
}
function isUndefined(r) {
  return r === void 0;
}
function isAccessorNode(r) {
  return r && r.isAccessorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isArrayNode(r) {
  return r && r.isArrayNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isAssignmentNode(r) {
  return r && r.isAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isBlockNode(r) {
  return r && r.isBlockNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isConditionalNode(r) {
  return r && r.isConditionalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isConstantNode(r) {
  return r && r.isConstantNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isFunctionAssignmentNode(r) {
  return r && r.isFunctionAssignmentNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isFunctionNode(r) {
  return r && r.isFunctionNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isIndexNode(r) {
  return r && r.isIndexNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isNode$1(r) {
  return r && r.isNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isObjectNode(r) {
  return r && r.isObjectNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isOperatorNode(r) {
  return r && r.isOperatorNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isParenthesisNode(r) {
  return r && r.isParenthesisNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isRangeNode(r) {
  return r && r.isRangeNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isRelationalNode(r) {
  return r && r.isRelationalNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isSymbolNode(r) {
  return r && r.isSymbolNode === !0 && r.constructor.prototype.isNode === !0 || !1;
}
function isChain(r) {
  return r && r.constructor.prototype.isChain === !0 || !1;
}
function typeOf(r) {
  var e = typeof r;
  return e === "object" ? r === null ? "null" : isBigNumber(r) ? "BigNumber" : r.constructor && r.constructor.name ? r.constructor.name : "Object" : e;
}
function clone$2(r) {
  var e = typeof r;
  if (e === "number" || e === "bigint" || e === "string" || e === "boolean" || r === null || r === void 0)
    return r;
  if (typeof r.clone == "function")
    return r.clone();
  if (Array.isArray(r))
    return r.map(function(s) {
      return clone$2(s);
    });
  if (r instanceof Date)
    return new Date(r.valueOf());
  if (isBigNumber(r))
    return r;
  if (isObject$2(r))
    return mapObject(r, clone$2);
  if (e === "function")
    return r;
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(r, ")"));
}
function mapObject(r, e) {
  var s = {};
  for (var o in r)
    hasOwnProperty(r, o) && (s[o] = e(r[o]));
  return s;
}
function extend$1(r, e) {
  for (var s in e)
    hasOwnProperty(e, s) && (r[s] = e[s]);
  return r;
}
function deepStrictEqual(r, e) {
  var s, o, a;
  if (Array.isArray(r)) {
    if (!Array.isArray(e) || r.length !== e.length)
      return !1;
    for (o = 0, a = r.length; o < a; o++)
      if (!deepStrictEqual(r[o], e[o]))
        return !1;
    return !0;
  } else {
    if (typeof r == "function")
      return r === e;
    if (r instanceof Object) {
      if (Array.isArray(e) || !(e instanceof Object))
        return !1;
      for (s in r)
        if (!(s in e) || !deepStrictEqual(r[s], e[s]))
          return !1;
      for (s in e)
        if (!(s in r))
          return !1;
      return !0;
    } else
      return r === e;
  }
}
function hasOwnProperty(r, e) {
  return r && Object.hasOwnProperty.call(r, e);
}
function pickShallow(r, e) {
  for (var s = {}, o = 0; o < e.length; o++) {
    var a = e[o], l = r[a];
    l !== void 0 && (s[a] = l);
  }
  return s;
}
var MATRIX_OPTIONS = ["Matrix", "Array"], NUMBER_OPTIONS = ["number", "BigNumber", "Fraction"], config$1 = function(e) {
  if (e)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(DEFAULT_CONFIG);
};
_extends$1(config$1, DEFAULT_CONFIG, {
  MATRIX_OPTIONS,
  NUMBER_OPTIONS
});
function ok() {
  return !0;
}
function notOk() {
  return !1;
}
function undef() {
}
const NOT_TYPED_FUNCTION = "Argument is not a typed-function.";
function create() {
  function r(It) {
    return typeof It == "object" && It !== null && It.constructor === Object;
  }
  const e = [{
    name: "number",
    test: function(It) {
      return typeof It == "number";
    }
  }, {
    name: "string",
    test: function(It) {
      return typeof It == "string";
    }
  }, {
    name: "boolean",
    test: function(It) {
      return typeof It == "boolean";
    }
  }, {
    name: "Function",
    test: function(It) {
      return typeof It == "function";
    }
  }, {
    name: "Array",
    test: Array.isArray
  }, {
    name: "Date",
    test: function(It) {
      return It instanceof Date;
    }
  }, {
    name: "RegExp",
    test: function(It) {
      return It instanceof RegExp;
    }
  }, {
    name: "Object",
    test: r
  }, {
    name: "null",
    test: function(It) {
      return It === null;
    }
  }, {
    name: "undefined",
    test: function(It) {
      return It === void 0;
    }
  }], s = {
    name: "any",
    test: ok,
    isAny: !0
  };
  let o, a, l = 0, u = {
    createCount: 0
  };
  function c(It) {
    const ht = o.get(It);
    if (ht)
      return ht;
    let Wt = 'Unknown type "' + It + '"';
    const hn = It.toLowerCase();
    let Vt;
    for (Vt of a)
      if (Vt.toLowerCase() === hn) {
        Wt += '. Did you mean "' + Vt + '" ?';
        break;
      }
    throw new TypeError(Wt);
  }
  function E(It) {
    let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any";
    const Wt = ht ? c(ht).index : a.length, hn = [];
    for (let Tn = 0; Tn < It.length; ++Tn) {
      if (!It[Tn] || typeof It[Tn].name != "string" || typeof It[Tn].test != "function")
        throw new TypeError("Object with properties {name: string, test: function} expected");
      const Rn = It[Tn].name;
      if (o.has(Rn))
        throw new TypeError('Duplicate type name "' + Rn + '"');
      hn.push(Rn), o.set(Rn, {
        name: Rn,
        test: It[Tn].test,
        isAny: It[Tn].isAny,
        index: Wt + Tn,
        conversionsTo: []
        // Newly added type can't have any conversions to it
      });
    }
    const Vt = a.slice(Wt);
    a = a.slice(0, Wt).concat(hn).concat(Vt);
    for (let Tn = Wt + hn.length; Tn < a.length; ++Tn)
      o.get(a[Tn]).index = Tn;
  }
  function d() {
    o = /* @__PURE__ */ new Map(), a = [], l = 0, E([s], !1);
  }
  d(), E(e);
  function f() {
    let It;
    for (It of a)
      o.get(It).conversionsTo = [];
    l = 0;
  }
  function h(It) {
    const ht = a.filter((Wt) => {
      const hn = o.get(Wt);
      return !hn.isAny && hn.test(It);
    });
    return ht.length ? ht : ["any"];
  }
  function S(It) {
    return It && typeof It == "function" && "_typedFunctionData" in It;
  }
  function R(It, ht, Wt) {
    if (!S(It))
      throw new TypeError(NOT_TYPED_FUNCTION);
    const hn = Wt && Wt.exact, Vt = Array.isArray(ht) ? ht.join(",") : ht, Tn = q(Vt), Rn = L(Tn);
    if (!hn || Rn in It.signatures) {
      const $n = It._typedFunctionData.signatureMap.get(Rn);
      if ($n)
        return $n;
    }
    const Nn = Tn.length;
    let Dn;
    if (hn) {
      Dn = [];
      let $n;
      for ($n in It.signatures)
        Dn.push(It._typedFunctionData.signatureMap.get($n));
    } else
      Dn = It._typedFunctionData.signatures;
    for (let $n = 0; $n < Nn; ++$n) {
      const Kn = Tn[$n], ir = [];
      let er;
      for (er of Dn) {
        const br = Fe(er.params, $n);
        if (!(!br || Kn.restParam && !br.restParam)) {
          if (!br.hasAny) {
            const cs = G(br);
            if (Kn.types.some((Gn) => !cs.has(Gn.name)))
              continue;
          }
          ir.push(er);
        }
      }
      if (Dn = ir, Dn.length === 0)
        break;
    }
    let xn;
    for (xn of Dn)
      if (xn.params.length <= Nn)
        return xn;
    throw new TypeError("Signature not found (signature: " + (It.name || "unnamed") + "(" + L(Tn, ", ") + "))");
  }
  function _(It, ht, Wt) {
    return R(It, ht, Wt).implementation;
  }
  function m(It, ht) {
    const Wt = c(ht);
    if (Wt.test(It))
      return It;
    const hn = Wt.conversionsTo;
    if (hn.length === 0)
      throw new Error("There are no conversions to " + ht + " defined.");
    for (let Vt = 0; Vt < hn.length; Vt++)
      if (c(hn[Vt].from).test(It))
        return hn[Vt].convert(It);
    throw new Error("Cannot convert " + It + " to " + ht);
  }
  function L(It) {
    let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return It.map((Wt) => Wt.name).join(ht);
  }
  function F(It) {
    const ht = It.indexOf("...") === 0, hn = (ht ? It.length > 3 ? It.slice(3) : "any" : It).split("|").map((Nn) => c(Nn.trim()));
    let Vt = !1, Tn = ht ? "..." : "";
    return {
      types: hn.map(function(Nn) {
        return Vt = Nn.isAny || Vt, Tn += Nn.name + "|", {
          name: Nn.name,
          typeIndex: Nn.index,
          test: Nn.test,
          isAny: Nn.isAny,
          conversion: null,
          conversionIndex: -1
        };
      }),
      name: Tn.slice(0, -1),
      // remove trailing '|' from above
      hasAny: Vt,
      hasConversion: !1,
      restParam: ht
    };
  }
  function W(It) {
    const ht = It.types.map((Rn) => Rn.name), Wt = be(ht);
    let hn = It.hasAny, Vt = It.name;
    const Tn = Wt.map(function(Rn) {
      const Nn = c(Rn.from);
      return hn = Nn.isAny || hn, Vt += "|" + Rn.from, {
        name: Rn.from,
        typeIndex: Nn.index,
        test: Nn.test,
        isAny: Nn.isAny,
        conversion: Rn,
        conversionIndex: Rn.index
      };
    });
    return {
      types: It.types.concat(Tn),
      name: Vt,
      hasAny: hn,
      hasConversion: Tn.length > 0,
      restParam: It.restParam
    };
  }
  function G(It) {
    return It.typeSet || (It.typeSet = /* @__PURE__ */ new Set(), It.types.forEach((ht) => It.typeSet.add(ht.name))), It.typeSet;
  }
  function q(It) {
    const ht = [];
    if (typeof It != "string")
      throw new TypeError("Signatures must be strings");
    const Wt = It.trim();
    if (Wt === "")
      return ht;
    const hn = Wt.split(",");
    for (let Vt = 0; Vt < hn.length; ++Vt) {
      const Tn = F(hn[Vt].trim());
      if (Tn.restParam && Vt !== hn.length - 1)
        throw new SyntaxError('Unexpected rest parameter "' + hn[Vt] + '": only allowed for the last parameter');
      if (Tn.types.length === 0)
        return null;
      ht.push(Tn);
    }
    return ht;
  }
  function fe(It) {
    const ht = Yt(It);
    return ht ? ht.restParam : !1;
  }
  function _e(It) {
    if (!It || It.types.length === 0)
      return ok;
    if (It.types.length === 1)
      return c(It.types[0].name).test;
    if (It.types.length === 2) {
      const ht = c(It.types[0].name).test, Wt = c(It.types[1].name).test;
      return function(Vt) {
        return ht(Vt) || Wt(Vt);
      };
    } else {
      const ht = It.types.map(function(Wt) {
        return c(Wt.name).test;
      });
      return function(hn) {
        for (let Vt = 0; Vt < ht.length; Vt++)
          if (ht[Vt](hn))
            return !0;
        return !1;
      };
    }
  }
  function Le(It) {
    let ht, Wt, hn;
    if (fe(It)) {
      ht = Tt(It).map(_e);
      const Vt = ht.length, Tn = _e(Yt(It)), Rn = function(Nn) {
        for (let Dn = Vt; Dn < Nn.length; Dn++)
          if (!Tn(Nn[Dn]))
            return !1;
        return !0;
      };
      return function(Dn) {
        for (let xn = 0; xn < ht.length; xn++)
          if (!ht[xn](Dn[xn]))
            return !1;
        return Rn(Dn) && Dn.length >= Vt + 1;
      };
    } else
      return It.length === 0 ? function(Tn) {
        return Tn.length === 0;
      } : It.length === 1 ? (Wt = _e(It[0]), function(Tn) {
        return Wt(Tn[0]) && Tn.length === 1;
      }) : It.length === 2 ? (Wt = _e(It[0]), hn = _e(It[1]), function(Tn) {
        return Wt(Tn[0]) && hn(Tn[1]) && Tn.length === 2;
      }) : (ht = It.map(_e), function(Tn) {
        for (let Rn = 0; Rn < ht.length; Rn++)
          if (!ht[Rn](Tn[Rn]))
            return !1;
        return Tn.length === ht.length;
      });
  }
  function Fe(It, ht) {
    return ht < It.length ? It[ht] : fe(It) ? Yt(It) : null;
  }
  function Ee(It, ht) {
    const Wt = Fe(It, ht);
    return Wt ? G(Wt) : /* @__PURE__ */ new Set();
  }
  function Ge(It) {
    return It.conversion === null || It.conversion === void 0;
  }
  function ve(It, ht) {
    const Wt = /* @__PURE__ */ new Set();
    return It.forEach((hn) => {
      const Vt = Ee(hn.params, ht);
      let Tn;
      for (Tn of Vt)
        Wt.add(Tn);
    }), Wt.has("any") ? ["any"] : Array.from(Wt);
  }
  function te(It, ht, Wt) {
    let hn, Vt;
    const Tn = It || "unnamed";
    let Rn = Wt, Nn;
    for (Nn = 0; Nn < ht.length; Nn++) {
      const Kn = [];
      if (Rn.forEach((ir) => {
        const er = Fe(ir.params, Nn), br = _e(er);
        (Nn < ir.params.length || fe(ir.params)) && br(ht[Nn]) && Kn.push(ir);
      }), Kn.length === 0) {
        if (Vt = ve(Rn, Nn), Vt.length > 0) {
          const ir = h(ht[Nn]);
          return hn = new TypeError("Unexpected type of argument in function " + Tn + " (expected: " + Vt.join(" or ") + ", actual: " + ir.join(" | ") + ", index: " + Nn + ")"), hn.data = {
            category: "wrongType",
            fn: Tn,
            index: Nn,
            actual: ir,
            expected: Vt
          }, hn;
        }
      } else
        Rn = Kn;
    }
    const Dn = Rn.map(function(Kn) {
      return fe(Kn.params) ? 1 / 0 : Kn.params.length;
    });
    if (ht.length < Math.min.apply(null, Dn))
      return Vt = ve(Rn, Nn), hn = new TypeError("Too few arguments in function " + Tn + " (expected: " + Vt.join(" or ") + ", index: " + ht.length + ")"), hn.data = {
        category: "tooFewArgs",
        fn: Tn,
        index: ht.length,
        expected: Vt
      }, hn;
    const xn = Math.max.apply(null, Dn);
    if (ht.length > xn)
      return hn = new TypeError("Too many arguments in function " + Tn + " (expected: " + xn + ", actual: " + ht.length + ")"), hn.data = {
        category: "tooManyArgs",
        fn: Tn,
        index: ht.length,
        expectedLength: xn
      }, hn;
    const $n = [];
    for (let Kn = 0; Kn < ht.length; ++Kn)
      $n.push(h(ht[Kn]).join("|"));
    return hn = new TypeError('Arguments of type "' + $n.join(", ") + '" do not match any of the defined signatures of function ' + Tn + "."), hn.data = {
      category: "mismatch",
      actual: $n
    }, hn;
  }
  function ae(It) {
    let ht = a.length + 1;
    for (let Wt = 0; Wt < It.types.length; Wt++)
      Ge(It.types[Wt]) && (ht = Math.min(ht, It.types[Wt].typeIndex));
    return ht;
  }
  function v(It) {
    let ht = l + 1;
    for (let Wt = 0; Wt < It.types.length; Wt++)
      Ge(It.types[Wt]) || (ht = Math.min(ht, It.types[Wt].conversionIndex));
    return ht;
  }
  function Te(It, ht) {
    if (It.hasAny) {
      if (!ht.hasAny)
        return 1;
    } else if (ht.hasAny)
      return -1;
    if (It.restParam) {
      if (!ht.restParam)
        return 1;
    } else if (ht.restParam)
      return -1;
    if (It.hasConversion) {
      if (!ht.hasConversion)
        return 1;
    } else if (ht.hasConversion)
      return -1;
    const Wt = ae(It) - ae(ht);
    if (Wt < 0)
      return -1;
    if (Wt > 0)
      return 1;
    const hn = v(It) - v(ht);
    return hn < 0 ? -1 : hn > 0 ? 1 : 0;
  }
  function De(It, ht) {
    const Wt = It.params, hn = ht.params, Vt = Yt(Wt), Tn = Yt(hn), Rn = fe(Wt), Nn = fe(hn);
    if (Rn && Vt.hasAny) {
      if (!Nn || !Tn.hasAny)
        return 1;
    } else if (Nn && Tn.hasAny)
      return -1;
    let Dn = 0, xn = 0, $n;
    for ($n of Wt)
      $n.hasAny && ++Dn, $n.hasConversion && ++xn;
    let Kn = 0, ir = 0;
    for ($n of hn)
      $n.hasAny && ++Kn, $n.hasConversion && ++ir;
    if (Dn !== Kn)
      return Dn - Kn;
    if (Rn && Vt.hasConversion) {
      if (!Nn || !Tn.hasConversion)
        return 1;
    } else if (Nn && Tn.hasConversion)
      return -1;
    if (xn !== ir)
      return xn - ir;
    if (Rn) {
      if (!Nn)
        return 1;
    } else if (Nn)
      return -1;
    const er = (Wt.length - hn.length) * (Rn ? -1 : 1);
    if (er !== 0)
      return er;
    const br = [];
    let cs = 0;
    for (let Jn = 0; Jn < Wt.length; ++Jn) {
      const Xn = Te(Wt[Jn], hn[Jn]);
      br.push(Xn), cs += Xn;
    }
    if (cs !== 0)
      return cs;
    let Gn;
    for (Gn of br)
      if (Gn !== 0)
        return Gn;
    return 0;
  }
  function be(It) {
    if (It.length === 0)
      return [];
    const ht = It.map(c);
    It.length > 1 && ht.sort((Vt, Tn) => Vt.index - Tn.index);
    let Wt = ht[0].conversionsTo;
    if (It.length === 1)
      return Wt;
    Wt = Wt.concat([]);
    const hn = new Set(It);
    for (let Vt = 1; Vt < ht.length; ++Vt) {
      let Tn;
      for (Tn of ht[Vt].conversionsTo)
        hn.has(Tn.from) || (Wt.push(Tn), hn.add(Tn.from));
    }
    return Wt;
  }
  function ze(It, ht) {
    let Wt = ht;
    if (It.some((Vt) => Vt.hasConversion)) {
      const Vt = fe(It), Tn = It.map(ke);
      Wt = function() {
        const Nn = [], Dn = Vt ? arguments.length - 1 : arguments.length;
        for (let xn = 0; xn < Dn; xn++)
          Nn[xn] = Tn[xn](arguments[xn]);
        return Vt && (Nn[Dn] = arguments[Dn].map(Tn[Dn])), ht.apply(this, Nn);
      };
    }
    let hn = Wt;
    if (fe(It)) {
      const Vt = It.length - 1;
      hn = function() {
        return Wt.apply(this, an(arguments, 0, Vt).concat([an(arguments, Vt)]));
      };
    }
    return hn;
  }
  function ke(It) {
    let ht, Wt, hn, Vt;
    const Tn = [], Rn = [];
    switch (It.types.forEach(function(Nn) {
      Nn.conversion && (Tn.push(c(Nn.conversion.from).test), Rn.push(Nn.conversion.convert));
    }), Rn.length) {
      case 0:
        return function(Dn) {
          return Dn;
        };
      case 1:
        return ht = Tn[0], hn = Rn[0], function(Dn) {
          return ht(Dn) ? hn(Dn) : Dn;
        };
      case 2:
        return ht = Tn[0], Wt = Tn[1], hn = Rn[0], Vt = Rn[1], function(Dn) {
          return ht(Dn) ? hn(Dn) : Wt(Dn) ? Vt(Dn) : Dn;
        };
      default:
        return function(Dn) {
          for (let xn = 0; xn < Rn.length; xn++)
            if (Tn[xn](Dn))
              return Rn[xn](Dn);
          return Dn;
        };
    }
  }
  function Be(It) {
    function ht(Wt, hn, Vt) {
      if (hn < Wt.length) {
        const Tn = Wt[hn];
        let Rn = [];
        if (Tn.restParam) {
          const Nn = Tn.types.filter(Ge);
          Nn.length < Tn.types.length && Rn.push({
            types: Nn,
            name: "..." + Nn.map((Dn) => Dn.name).join("|"),
            hasAny: Nn.some((Dn) => Dn.isAny),
            hasConversion: !1,
            restParam: !0
          }), Rn.push(Tn);
        } else
          Rn = Tn.types.map(function(Nn) {
            return {
              types: [Nn],
              name: Nn.name,
              hasAny: Nn.isAny,
              hasConversion: Nn.conversion,
              restParam: !1
            };
          });
        return st(Rn, function(Nn) {
          return ht(Wt, hn + 1, Vt.concat([Nn]));
        });
      } else
        return [Vt];
    }
    return ht(It, 0, []);
  }
  function Me(It, ht) {
    const Wt = Math.max(It.length, ht.length);
    for (let Nn = 0; Nn < Wt; Nn++) {
      const Dn = Ee(It, Nn), xn = Ee(ht, Nn);
      let $n = !1, Kn;
      for (Kn of xn)
        if (Dn.has(Kn)) {
          $n = !0;
          break;
        }
      if (!$n)
        return !1;
    }
    const hn = It.length, Vt = ht.length, Tn = fe(It), Rn = fe(ht);
    return Tn ? Rn ? hn === Vt : Vt >= hn : Rn ? hn >= Vt : hn === Vt;
  }
  function me(It) {
    return It.map((ht) => Ke(ht) ? Zt(ht.referToSelf.callback) : Et(ht) ? lt(ht.referTo.references, ht.referTo.callback) : ht);
  }
  function Se(It, ht, Wt) {
    const hn = [];
    let Vt;
    for (Vt of It) {
      let Tn = Wt[Vt];
      if (typeof Tn != "number")
        throw new TypeError('No definition for referenced signature "' + Vt + '"');
      if (Tn = ht[Tn], typeof Tn != "function")
        return !1;
      hn.push(Tn);
    }
    return hn;
  }
  function xt(It, ht, Wt) {
    const hn = me(It), Vt = new Array(hn.length).fill(!1);
    let Tn = !0;
    for (; Tn; ) {
      Tn = !1;
      let Rn = !0;
      for (let Nn = 0; Nn < hn.length; ++Nn) {
        if (Vt[Nn])
          continue;
        const Dn = hn[Nn];
        if (Ke(Dn))
          hn[Nn] = Dn.referToSelf.callback(Wt), hn[Nn].referToSelf = Dn.referToSelf, Vt[Nn] = !0, Rn = !1;
        else if (Et(Dn)) {
          const xn = Se(Dn.referTo.references, hn, ht);
          xn ? (hn[Nn] = Dn.referTo.callback.apply(this, xn), hn[Nn].referTo = Dn.referTo, Vt[Nn] = !0, Rn = !1) : Tn = !0;
        }
      }
      if (Rn && Tn)
        throw new SyntaxError("Circular reference detected in resolving typed.referTo");
    }
    return hn;
  }
  function Ht(It) {
    const ht = /\bthis(\(|\.signatures\b)/;
    Object.keys(It).forEach((Wt) => {
      const hn = It[Wt];
      if (ht.test(hn.toString()))
        throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
    });
  }
  function Bt(It, ht) {
    if (u.createCount++, Object.keys(ht).length === 0)
      throw new SyntaxError("No signatures provided");
    u.warnAgainstDeprecatedThis && Ht(ht);
    const Wt = [], hn = [], Vt = {}, Tn = [];
    let Rn;
    for (Rn in ht) {
      if (!Object.prototype.hasOwnProperty.call(ht, Rn))
        continue;
      const Dr = q(Rn);
      if (!Dr)
        continue;
      Wt.forEach(function(No) {
        if (Me(No, Dr))
          throw new TypeError('Conflicting signatures "' + L(No) + '" and "' + L(Dr) + '".');
      }), Wt.push(Dr);
      const Kr = hn.length;
      hn.push(ht[Rn]);
      const Js = Dr.map(W);
      let io;
      for (io of Be(Js)) {
        const No = L(io);
        Tn.push({
          params: io,
          name: No,
          fn: Kr
        }), io.every((Ai) => !Ai.hasConversion) && (Vt[No] = Kr);
      }
    }
    Tn.sort(De);
    const Nn = xt(hn, Vt, Es);
    let Dn;
    for (Dn in Vt)
      Object.prototype.hasOwnProperty.call(Vt, Dn) && (Vt[Dn] = Nn[Vt[Dn]]);
    const xn = [], $n = /* @__PURE__ */ new Map();
    for (Dn of Tn)
      $n.has(Dn.name) || (Dn.fn = Nn[Dn.fn], xn.push(Dn), $n.set(Dn.name, Dn));
    const Kn = xn[0] && xn[0].params.length <= 2 && !fe(xn[0].params), ir = xn[1] && xn[1].params.length <= 2 && !fe(xn[1].params), er = xn[2] && xn[2].params.length <= 2 && !fe(xn[2].params), br = xn[3] && xn[3].params.length <= 2 && !fe(xn[3].params), cs = xn[4] && xn[4].params.length <= 2 && !fe(xn[4].params), Gn = xn[5] && xn[5].params.length <= 2 && !fe(xn[5].params), Jn = Kn && ir && er && br && cs && Gn;
    for (let Dr = 0; Dr < xn.length; ++Dr)
      xn[Dr].test = Le(xn[Dr].params);
    const Xn = Kn ? _e(xn[0].params[0]) : notOk, rr = ir ? _e(xn[1].params[0]) : notOk, _r = er ? _e(xn[2].params[0]) : notOk, Ss = br ? _e(xn[3].params[0]) : notOk, is = cs ? _e(xn[4].params[0]) : notOk, Ms = Gn ? _e(xn[5].params[0]) : notOk, ls = Kn ? _e(xn[0].params[1]) : notOk, Ur = ir ? _e(xn[1].params[1]) : notOk, Qr = er ? _e(xn[2].params[1]) : notOk, Fr = br ? _e(xn[3].params[1]) : notOk, Lr = cs ? _e(xn[4].params[1]) : notOk, Hr = Gn ? _e(xn[5].params[1]) : notOk;
    for (let Dr = 0; Dr < xn.length; ++Dr)
      xn[Dr].implementation = ze(xn[Dr].params, xn[Dr].fn);
    const ns = Kn ? xn[0].implementation : undef, Ts = ir ? xn[1].implementation : undef, en = er ? xn[2].implementation : undef, to = br ? xn[3].implementation : undef, bs = cs ? xn[4].implementation : undef, jn = Gn ? xn[5].implementation : undef, lr = Kn ? xn[0].params.length : -1, pr = ir ? xn[1].params.length : -1, En = er ? xn[2].params.length : -1, qn = br ? xn[3].params.length : -1, Wn = cs ? xn[4].params.length : -1, kn = Gn ? xn[5].params.length : -1, zn = Jn ? 6 : 0, wr = xn.length, jr = xn.map((Dr) => Dr.test), Vr = xn.map((Dr) => Dr.implementation), us = function() {
      for (let Kr = zn; Kr < wr; Kr++)
        if (jr[Kr](arguments))
          return Vr[Kr].apply(this, arguments);
      return u.onMismatch(It, arguments, xn);
    };
    function Es(Dr, Kr) {
      return arguments.length === lr && Xn(Dr) && ls(Kr) ? ns.apply(this, arguments) : arguments.length === pr && rr(Dr) && Ur(Kr) ? Ts.apply(this, arguments) : arguments.length === En && _r(Dr) && Qr(Kr) ? en.apply(this, arguments) : arguments.length === qn && Ss(Dr) && Fr(Kr) ? to.apply(this, arguments) : arguments.length === Wn && is(Dr) && Lr(Kr) ? bs.apply(this, arguments) : arguments.length === kn && Ms(Dr) && Hr(Kr) ? jn.apply(this, arguments) : us.apply(this, arguments);
    }
    try {
      Object.defineProperty(Es, "name", {
        value: It
      });
    } catch {
    }
    return Es.signatures = Vt, Es._typedFunctionData = {
      signatures: xn,
      signatureMap: $n
    }, Es;
  }
  function ut(It, ht, Wt) {
    throw te(It, ht, Wt);
  }
  function Tt(It) {
    return an(It, 0, It.length - 1);
  }
  function Yt(It) {
    return It[It.length - 1];
  }
  function an(It, ht, Wt) {
    return Array.prototype.slice.call(It, ht, Wt);
  }
  function Ct(It, ht) {
    for (let Wt = 0; Wt < It.length; Wt++)
      if (ht(It[Wt]))
        return It[Wt];
  }
  function st(It, ht) {
    return Array.prototype.concat.apply([], It.map(ht));
  }
  function jt() {
    const It = Tt(arguments).map((Wt) => L(q(Wt))), ht = Yt(arguments);
    if (typeof ht != "function")
      throw new TypeError("Callback function expected as last argument");
    return lt(It, ht);
  }
  function lt(It, ht) {
    return {
      referTo: {
        references: It,
        callback: ht
      }
    };
  }
  function Zt(It) {
    if (typeof It != "function")
      throw new TypeError("Callback function expected as first argument");
    return {
      referToSelf: {
        callback: It
      }
    };
  }
  function Et(It) {
    return It && typeof It.referTo == "object" && Array.isArray(It.referTo.references) && typeof It.referTo.callback == "function";
  }
  function Ke(It) {
    return It && typeof It.referToSelf == "object" && typeof It.referToSelf.callback == "function";
  }
  function $e(It, ht) {
    if (!It)
      return ht;
    if (ht && ht !== It) {
      const Wt = new Error("Function names do not match (expected: " + It + ", actual: " + ht + ")");
      throw Wt.data = {
        actual: ht,
        expected: It
      }, Wt;
    }
    return It;
  }
  function pt(It) {
    let ht;
    for (const Wt in It)
      Object.prototype.hasOwnProperty.call(It, Wt) && (S(It[Wt]) || typeof It[Wt].signature == "string") && (ht = $e(ht, It[Wt].name));
    return ht;
  }
  function Jt(It, ht) {
    let Wt;
    for (Wt in ht)
      if (Object.prototype.hasOwnProperty.call(ht, Wt)) {
        if (Wt in It && ht[Wt] !== It[Wt]) {
          const hn = new Error('Signature "' + Wt + '" is defined twice');
          throw hn.data = {
            signature: Wt,
            sourceFunction: ht[Wt],
            destFunction: It[Wt]
          }, hn;
        }
        It[Wt] = ht[Wt];
      }
  }
  const In = u;
  u = function(It) {
    const ht = typeof It == "string", Wt = ht ? 1 : 0;
    let hn = ht ? It : "";
    const Vt = {};
    for (let Tn = Wt; Tn < arguments.length; ++Tn) {
      const Rn = arguments[Tn];
      let Nn = {}, Dn;
      if (typeof Rn == "function" ? (Dn = Rn.name, typeof Rn.signature == "string" ? Nn[Rn.signature] = Rn : S(Rn) && (Nn = Rn.signatures)) : r(Rn) && (Nn = Rn, ht || (Dn = pt(Rn))), Object.keys(Nn).length === 0) {
        const xn = new TypeError("Argument to 'typed' at index " + Tn + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
        throw xn.data = {
          index: Tn,
          argument: Rn
        }, xn;
      }
      ht || (hn = $e(hn, Dn)), Jt(Vt, Nn);
    }
    return Bt(hn || "", Vt);
  }, u.create = create, u.createCount = In.createCount, u.onMismatch = ut, u.throwMismatchError = ut, u.createError = te, u.clear = d, u.clearConversions = f, u.addTypes = E, u._findType = c, u.referTo = jt, u.referToSelf = Zt, u.convert = m, u.findSignature = R, u.find = _, u.isTypedFunction = S, u.warnAgainstDeprecatedThis = !0, u.addType = function(It, ht) {
    let Wt = "any";
    ht !== !1 && o.has("Object") && (Wt = "Object"), u.addTypes([It], Wt);
  };
  function Cn(It) {
    if (!It || typeof It.from != "string" || typeof It.to != "string" || typeof It.convert != "function")
      throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
    if (It.to === It.from)
      throw new SyntaxError('Illegal to define conversion from "' + It.from + '" to itself.');
  }
  return u.addConversion = function(It) {
    let ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      override: !1
    };
    Cn(It);
    const Wt = c(It.to), hn = Wt.conversionsTo.find((Vt) => Vt.from === It.from);
    if (hn)
      if (ht && ht.override)
        u.removeConversion({
          from: hn.from,
          to: It.to,
          convert: hn.convert
        });
      else
        throw new Error('There is already a conversion from "' + It.from + '" to "' + Wt.name + '"');
    Wt.conversionsTo.push({
      from: It.from,
      convert: It.convert,
      index: l++
    });
  }, u.addConversions = function(It, ht) {
    It.forEach((Wt) => u.addConversion(Wt, ht));
  }, u.removeConversion = function(It) {
    Cn(It);
    const ht = c(It.to), Wt = Ct(ht.conversionsTo, (Vt) => Vt.from === It.from);
    if (!Wt)
      throw new Error("Attempt to remove nonexistent conversion from " + It.from + " to " + It.to);
    if (Wt.convert !== It.convert)
      throw new Error("Conversion to remove does not match existing conversion");
    const hn = ht.conversionsTo.indexOf(Wt);
    ht.conversionsTo.splice(hn, 1);
  }, u.resolve = function(It, ht) {
    if (!S(It))
      throw new TypeError(NOT_TYPED_FUNCTION);
    const Wt = It._typedFunctionData.signatures;
    for (let hn = 0; hn < Wt.length; ++hn)
      if (Wt[hn].test(ht))
        return Wt[hn];
    return null;
  }, u;
}
const typedFunction = create();
function factory(r, e, s, o) {
  function a(l) {
    var u = pickShallow(l, e.map(stripOptionalNotation));
    return assertDependencies(r, e, l), s(u);
  }
  return a.isFactory = !0, a.fn = r, a.dependencies = e.slice().sort(), o && (a.meta = o), a;
}
function assertDependencies(r, e, s) {
  var o = e.filter((l) => !isOptionalDependency(l)).every((l) => s[l] !== void 0);
  if (!o) {
    var a = e.filter((l) => s[l] === void 0);
    throw new Error('Cannot create function "'.concat(r, '", ') + "some dependencies are missing: ".concat(a.map((l) => '"'.concat(l, '"')).join(", "), "."));
  }
}
function isOptionalDependency(r) {
  return r && r[0] === "?";
}
function stripOptionalNotation(r) {
  return r && r[0] === "?" ? r.slice(1) : r;
}
function isInteger$1(r) {
  return typeof r == "boolean" ? !0 : isFinite(r) ? r === Math.round(r) : !1;
}
var sign$6 = Math.sign || function(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
};
function formatNumberToBase(r, e, s) {
  var o = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, a = o[e], l = "";
  if (s) {
    if (s < 1)
      throw new Error("size must be in greater than 0");
    if (!isInteger$1(s))
      throw new Error("size must be an integer");
    if (r > 2 ** (s - 1) - 1 || r < -(2 ** (s - 1)))
      throw new Error("Value must be in range [-2^".concat(s - 1, ", 2^").concat(s - 1, "-1]"));
    if (!isInteger$1(r))
      throw new Error("Value must be an integer");
    r < 0 && (r = r + 2 ** s), l = "i".concat(s);
  }
  var u = "";
  return r < 0 && (r = -r, u = "-"), "".concat(u).concat(a).concat(r.toString(e)).concat(l);
}
function format$2(r, e) {
  if (typeof e == "function")
    return e(r);
  if (r === 1 / 0)
    return "Infinity";
  if (r === -1 / 0)
    return "-Infinity";
  if (isNaN(r))
    return "NaN";
  var {
    notation: s,
    precision: o,
    wordSize: a
  } = normalizeFormatOptions(e);
  switch (s) {
    case "fixed":
      return toFixed$1(r, o);
    case "exponential":
      return toExponential$1(r, o);
    case "engineering":
      return toEngineering$1(r, o);
    case "bin":
      return formatNumberToBase(r, 2, a);
    case "oct":
      return formatNumberToBase(r, 8, a);
    case "hex":
      return formatNumberToBase(r, 16, a);
    case "auto":
      return toPrecision(r, o, e).replace(/((\.\d*?)(0+))($|e)/, function() {
        var l = arguments[2], u = arguments[4];
        return l !== "." ? l + u : u;
      });
    default:
      throw new Error('Unknown notation "' + s + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function normalizeFormatOptions(r) {
  var e = "auto", s, o;
  if (r !== void 0)
    if (isNumber(r))
      s = r;
    else if (isBigNumber(r))
      s = r.toNumber();
    else if (isObject$2(r))
      r.precision !== void 0 && (s = _toNumberOrThrow(r.precision, () => {
        throw new Error('Option "precision" must be a number or BigNumber');
      })), r.wordSize !== void 0 && (o = _toNumberOrThrow(r.wordSize, () => {
        throw new Error('Option "wordSize" must be a number or BigNumber');
      })), r.notation && (e = r.notation);
    else
      throw new Error("Unsupported type of options, number, BigNumber, or object expected");
  return {
    notation: e,
    precision: s,
    wordSize: o
  };
}
function splitNumber(r) {
  var e = String(r).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!e)
    throw new SyntaxError("Invalid number " + r);
  var s = e[1], o = e[2], a = parseFloat(e[4] || "0"), l = o.indexOf(".");
  a += l !== -1 ? l - 1 : o.length - 1;
  var u = o.replace(".", "").replace(/^0*/, function(c) {
    return a -= c.length, "";
  }).replace(/0*$/, "").split("").map(function(c) {
    return parseInt(c);
  });
  return u.length === 0 && (u.push(0), a++), {
    sign: s,
    coefficients: u,
    exponent: a
  };
}
function toEngineering$1(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var s = splitNumber(r), o = roundDigits(s, e), a = o.exponent, l = o.coefficients, u = a % 3 === 0 ? a : a < 0 ? a - 3 - a % 3 : a - a % 3;
  if (isNumber(e))
    for (; e > l.length || a - u + 1 > l.length; )
      l.push(0);
  else
    for (var c = Math.abs(a - u) - (l.length - 1), E = 0; E < c; E++)
      l.push(0);
  for (var d = Math.abs(a - u), f = 1; d > 0; )
    f++, d--;
  var h = l.slice(f).join(""), S = isNumber(e) && h.length || h.match(/[1-9]/) ? "." + h : "", R = l.slice(0, f).join("") + S + "e" + (a >= 0 ? "+" : "") + u.toString();
  return o.sign + R;
}
function toFixed$1(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var s = splitNumber(r), o = typeof e == "number" ? roundDigits(s, s.exponent + 1 + e) : s, a = o.coefficients, l = o.exponent + 1, u = l + (e || 0);
  return a.length < u && (a = a.concat(zeros$1(u - a.length))), l < 0 && (a = zeros$1(-l + 1).concat(a), l = 1), l < a.length && a.splice(l, 0, l === 0 ? "0." : "."), o.sign + a.join("");
}
function toExponential$1(r, e) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var s = splitNumber(r), o = e ? roundDigits(s, e) : s, a = o.coefficients, l = o.exponent;
  a.length < e && (a = a.concat(zeros$1(e - a.length)));
  var u = a.shift();
  return o.sign + u + (a.length > 0 ? "." + a.join("") : "") + "e" + (l >= 0 ? "+" : "") + l;
}
function toPrecision(r, e, s) {
  if (isNaN(r) || !isFinite(r))
    return String(r);
  var o = _toNumberOrDefault$1(s == null ? void 0 : s.lowerExp, -3), a = _toNumberOrDefault$1(s == null ? void 0 : s.upperExp, 5), l = splitNumber(r), u = e ? roundDigits(l, e) : l;
  if (u.exponent < o || u.exponent >= a)
    return toExponential$1(r, e);
  var c = u.coefficients, E = u.exponent;
  c.length < e && (c = c.concat(zeros$1(e - c.length))), c = c.concat(zeros$1(E - c.length + 1 + (c.length < e ? e - c.length : 0))), c = zeros$1(-E).concat(c);
  var d = E > 0 ? E : 0;
  return d < c.length - 1 && c.splice(d + 1, 0, "."), u.sign + c.join("");
}
function roundDigits(r, e) {
  for (var s = {
    sign: r.sign,
    coefficients: r.coefficients,
    exponent: r.exponent
  }, o = s.coefficients; e <= 0; )
    o.unshift(0), s.exponent++, e++;
  if (o.length > e) {
    var a = o.splice(e, o.length - e);
    if (a[0] >= 5) {
      var l = e - 1;
      for (o[l]++; o[l] === 10; )
        o.pop(), l === 0 && (o.unshift(0), s.exponent++, l++), l--, o[l]++;
    }
  }
  return s;
}
function zeros$1(r) {
  for (var e = [], s = 0; s < r; s++)
    e.push(0);
  return e;
}
function digits$1(r) {
  return r.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function nearlyEqual$1(r, e) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (s <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (o < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return isNaN(r) || isNaN(e) ? !1 : !isFinite(r) || !isFinite(e) ? r === e : r === e ? !0 : Math.abs(r - e) <= Math.max(s * Math.max(Math.abs(r), Math.abs(e)), o);
}
function _toNumberOrThrow(r, e) {
  if (isNumber(r))
    return r;
  if (isBigNumber(r))
    return r.toNumber();
  e();
}
function _toNumberOrDefault$1(r, e) {
  return isNumber(r) ? r : isBigNumber(r) ? r.toNumber() : e;
}
var _createTyped2 = function() {
  return _createTyped2 = typedFunction.create, typedFunction;
}, dependencies$16 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], createTyped = /* @__PURE__ */ factory("typed", dependencies$16, function(e) {
  var {
    BigNumber: s,
    Complex: o,
    DenseMatrix: a,
    Fraction: l
  } = e, u = _createTyped2();
  return u.clear(), u.addTypes([
    {
      name: "number",
      test: isNumber
    },
    {
      name: "Complex",
      test: isComplex
    },
    {
      name: "BigNumber",
      test: isBigNumber
    },
    {
      name: "bigint",
      test: isBigInt
    },
    {
      name: "Fraction",
      test: isFraction
    },
    {
      name: "Unit",
      test: isUnit
    },
    // The following type matches a valid variable name, i.e., an alphanumeric
    // string starting with an alphabetic character. It is used (at least)
    // in the definition of the derivative() function, as the argument telling
    // what to differentiate over must (currently) be a variable.
    // TODO: deprecate the identifier type (it's not used anymore, see https://github.com/josdejong/mathjs/issues/3253)
    {
      name: "identifier",
      test: (c) => isString && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(c)
    },
    {
      name: "string",
      test: isString
    },
    {
      name: "Chain",
      test: isChain
    },
    {
      name: "Array",
      test: isArray
    },
    {
      name: "Matrix",
      test: isMatrix
    },
    {
      name: "DenseMatrix",
      test: isDenseMatrix
    },
    {
      name: "SparseMatrix",
      test: isSparseMatrix
    },
    {
      name: "Range",
      test: isRange
    },
    {
      name: "Index",
      test: isIndex
    },
    {
      name: "boolean",
      test: isBoolean
    },
    {
      name: "ResultSet",
      test: isResultSet
    },
    {
      name: "Help",
      test: isHelp
    },
    {
      name: "function",
      test: isFunction
    },
    {
      name: "Date",
      test: isDate
    },
    {
      name: "RegExp",
      test: isRegExp
    },
    {
      name: "null",
      test: isNull
    },
    {
      name: "undefined",
      test: isUndefined
    },
    {
      name: "AccessorNode",
      test: isAccessorNode
    },
    {
      name: "ArrayNode",
      test: isArrayNode
    },
    {
      name: "AssignmentNode",
      test: isAssignmentNode
    },
    {
      name: "BlockNode",
      test: isBlockNode
    },
    {
      name: "ConditionalNode",
      test: isConditionalNode
    },
    {
      name: "ConstantNode",
      test: isConstantNode
    },
    {
      name: "FunctionNode",
      test: isFunctionNode
    },
    {
      name: "FunctionAssignmentNode",
      test: isFunctionAssignmentNode
    },
    {
      name: "IndexNode",
      test: isIndexNode
    },
    {
      name: "Node",
      test: isNode$1
    },
    {
      name: "ObjectNode",
      test: isObjectNode
    },
    {
      name: "OperatorNode",
      test: isOperatorNode
    },
    {
      name: "ParenthesisNode",
      test: isParenthesisNode
    },
    {
      name: "RangeNode",
      test: isRangeNode
    },
    {
      name: "RelationalNode",
      test: isRelationalNode
    },
    {
      name: "SymbolNode",
      test: isSymbolNode
    },
    {
      name: "Map",
      test: isMap
    },
    {
      name: "Object",
      test: isObject$2
    }
    // order 'Object' last, it matches on other classes too
  ]), u.addConversions([{
    from: "number",
    to: "BigNumber",
    convert: function(E) {
      if (s || throwNoBignumber(E), digits$1(E) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + E + "). Use function bignumber(x) to convert to BigNumber.");
      return new s(E);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(E) {
      return o || throwNoComplex(E), new o(E, 0);
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(E) {
      return o || throwNoComplex(E), new o(E.toNumber(), 0);
    }
  }, {
    from: "bigint",
    to: "number",
    convert: function(E) {
      if (E > Number.MAX_SAFE_INTEGER)
        throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + E + ")");
      return Number(E);
    }
  }, {
    from: "bigint",
    to: "BigNumber",
    convert: function(E) {
      return s || throwNoBignumber(E), new s(E.toString());
    }
  }, {
    from: "bigint",
    to: "Fraction",
    convert: function(E) {
      return l || throwNoFraction(E), new l(E);
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(E) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(E) {
      return o || throwNoComplex(E), new o(E.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(E) {
      l || throwNoFraction(E);
      var d = new l(E);
      if (d.valueOf() !== E)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + E + "). Use function fraction(x) to convert to Fraction.");
      return d;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(E) {
      var d = Number(E);
      if (isNaN(d))
        throw new Error('Cannot convert "' + E + '" to a number');
      return d;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(E) {
      s || throwNoBignumber(E);
      try {
        return new s(E);
      } catch {
        throw new Error('Cannot convert "' + E + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "bigint",
    convert: function(E) {
      try {
        return BigInt(E);
      } catch {
        throw new Error('Cannot convert "' + E + '" to BigInt');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(E) {
      l || throwNoFraction(E);
      try {
        return new l(E);
      } catch {
        throw new Error('Cannot convert "' + E + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(E) {
      o || throwNoComplex(E);
      try {
        return new o(E);
      } catch {
        throw new Error('Cannot convert "' + E + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(E) {
      return +E;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(E) {
      return s || throwNoBignumber(E), new s(+E);
    }
  }, {
    from: "boolean",
    to: "bigint",
    convert: function(E) {
      return BigInt(+E);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(E) {
      return l || throwNoFraction(E), new l(+E);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(E) {
      return String(E);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(E) {
      return a || throwNoMatrix(), new a(E);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(E) {
      return E.valueOf();
    }
  }]), u.onMismatch = (c, E, d) => {
    var f = u.createError(c, E, d);
    if (["wrongType", "mismatch"].includes(f.data.category) && E.length === 1 && isCollection(E[0]) && // check if the function can be unary:
    d.some((S) => !S.params.includes(","))) {
      var h = new TypeError("Function '".concat(c, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(c, ")'."));
      throw h.data = f.data, h;
    }
    throw f;
  }, u.onMismatch = (c, E, d) => {
    var f = u.createError(c, E, d);
    if (["wrongType", "mismatch"].includes(f.data.category) && E.length === 1 && isCollection(E[0]) && // check if the function can be unary:
    d.some((S) => !S.params.includes(","))) {
      var h = new TypeError("Function '".concat(c, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(c, ")'."));
      throw h.data = f.data, h;
    }
    throw f;
  }, u;
});
function throwNoBignumber(r) {
  throw new Error("Cannot convert value ".concat(r, " into a BigNumber: no class 'BigNumber' provided"));
}
function throwNoComplex(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Complex number: no class 'Complex' provided"));
}
function throwNoMatrix() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function throwNoFraction(r) {
  throw new Error("Cannot convert value ".concat(r, " into a Fraction, no class 'Fraction' provided."));
}
/*!
 *  decimal.js v10.5.0
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -EXP_LIMIT,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: EXP_LIMIT,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, inexact, quadrant, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary$1 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$2 = { toStringTag: tag };
P$2.absoluteValue = P$2.abs = function() {
  var r = new this.constructor(this);
  return r.s < 0 && (r.s = 1), finalise(r);
};
P$2.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
};
P$2.clampedTo = P$2.clamp = function(r, e) {
  var s, o = this, a = o.constructor;
  if (r = new a(r), e = new a(e), !r.s || !e.s)
    return new a(NaN);
  if (r.gt(e))
    throw Error(invalidArgument + e);
  return s = o.cmp(r), s < 0 ? r : o.cmp(e) > 0 ? e : new a(o);
};
P$2.comparedTo = P$2.cmp = function(r) {
  var e, s, o, a, l = this, u = l.d, c = (r = new l.constructor(r)).d, E = l.s, d = r.s;
  if (!u || !c)
    return !E || !d ? NaN : E !== d ? E : u === c ? 0 : !u ^ E < 0 ? 1 : -1;
  if (!u[0] || !c[0])
    return u[0] ? E : c[0] ? -d : 0;
  if (E !== d)
    return E;
  if (l.e !== r.e)
    return l.e > r.e ^ E < 0 ? 1 : -1;
  for (o = u.length, a = c.length, e = 0, s = o < a ? o : a; e < s; ++e)
    if (u[e] !== c[e])
      return u[e] > c[e] ^ E < 0 ? 1 : -1;
  return o === a ? 0 : o > a ^ E < 0 ? 1 : -1;
};
P$2.cosine = P$2.cos = function() {
  var r, e, s = this, o = s.constructor;
  return s.d ? s.d[0] ? (r = o.precision, e = o.rounding, o.precision = r + Math.max(s.e, s.sd()) + LOG_BASE, o.rounding = 1, s = cosine(o, toLessThanHalfPi(o, s)), o.precision = r, o.rounding = e, finalise(quadrant == 2 || quadrant == 3 ? s.neg() : s, r, e, !0)) : new o(1) : new o(NaN);
};
P$2.cubeRoot = P$2.cbrt = function() {
  var r, e, s, o, a, l, u, c, E, d, f = this, h = f.constructor;
  if (!f.isFinite() || f.isZero())
    return new h(f);
  for (external = !1, l = f.s * mathpow(f.s * f, 1 / 3), !l || Math.abs(l) == 1 / 0 ? (s = digitsToString(f.d), r = f.e, (l = (r - s.length + 1) % 3) && (s += l == 1 || l == -2 ? "0" : "00"), l = mathpow(s, 1 / 3), r = mathfloor((r + 1) / 3) - (r % 3 == (r < 0 ? -1 : 2)), l == 1 / 0 ? s = "5e" + r : (s = l.toExponential(), s = s.slice(0, s.indexOf("e") + 1) + r), o = new h(s), o.s = f.s) : o = new h(l.toString()), u = (r = h.precision) + 3; ; )
    if (c = o, E = c.times(c).times(c), d = E.plus(f), o = divide(d.plus(f).times(c), d.plus(E), u + 2, 1), digitsToString(c.d).slice(0, u) === (s = digitsToString(o.d)).slice(0, u))
      if (s = s.slice(u - 3, u + 1), s == "9999" || !a && s == "4999") {
        if (!a && (finalise(c, r + 1, 0), c.times(c).times(c).eq(f))) {
          o = c;
          break;
        }
        u += 4, a = 1;
      } else {
        (!+s || !+s.slice(1) && s.charAt(0) == "5") && (finalise(o, r + 1, 1), e = !o.times(o).times(o).eq(f));
        break;
      }
  return external = !0, finalise(o, r, h.rounding, e);
};
P$2.decimalPlaces = P$2.dp = function() {
  var r, e = this.d, s = NaN;
  if (e) {
    if (r = e.length - 1, s = (r - mathfloor(this.e / LOG_BASE)) * LOG_BASE, r = e[r], r)
      for (; r % 10 == 0; r /= 10)
        s--;
    s < 0 && (s = 0);
  }
  return s;
};
P$2.dividedBy = P$2.div = function(r) {
  return divide(this, new this.constructor(r));
};
P$2.dividedToIntegerBy = P$2.divToInt = function(r) {
  var e = this, s = e.constructor;
  return finalise(divide(e, new s(r), 0, 1, 1), s.precision, s.rounding);
};
P$2.equals = P$2.eq = function(r) {
  return this.cmp(r) === 0;
};
P$2.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
};
P$2.greaterThan = P$2.gt = function(r) {
  return this.cmp(r) > 0;
};
P$2.greaterThanOrEqualTo = P$2.gte = function(r) {
  var e = this.cmp(r);
  return e == 1 || e === 0;
};
P$2.hyperbolicCosine = P$2.cosh = function() {
  var r, e, s, o, a, l = this, u = l.constructor, c = new u(1);
  if (!l.isFinite())
    return new u(l.s ? 1 / 0 : NaN);
  if (l.isZero())
    return c;
  s = u.precision, o = u.rounding, u.precision = s + Math.max(l.e, l.sd()) + 4, u.rounding = 1, a = l.d.length, a < 32 ? (r = Math.ceil(a / 3), e = (1 / tinyPow(4, r)).toString()) : (r = 16, e = "2.3283064365386962890625e-10"), l = taylorSeries(u, 1, l.times(e), new u(1), !0);
  for (var E, d = r, f = new u(8); d--; )
    E = l.times(l), l = c.minus(E.times(f.minus(E.times(f))));
  return finalise(l, u.precision = s, u.rounding = o, !0);
};
P$2.hyperbolicSine = P$2.sinh = function() {
  var r, e, s, o, a = this, l = a.constructor;
  if (!a.isFinite() || a.isZero())
    return new l(a);
  if (e = l.precision, s = l.rounding, l.precision = e + Math.max(a.e, a.sd()) + 4, l.rounding = 1, o = a.d.length, o < 3)
    a = taylorSeries(l, 2, a, a, !0);
  else {
    r = 1.4 * Math.sqrt(o), r = r > 16 ? 16 : r | 0, a = a.times(1 / tinyPow(5, r)), a = taylorSeries(l, 2, a, a, !0);
    for (var u, c = new l(5), E = new l(16), d = new l(20); r--; )
      u = a.times(a), a = a.times(c.plus(u.times(E.times(u).plus(d))));
  }
  return l.precision = e, l.rounding = s, finalise(a, e, s, !0);
};
P$2.hyperbolicTangent = P$2.tanh = function() {
  var r, e, s = this, o = s.constructor;
  return s.isFinite() ? s.isZero() ? new o(s) : (r = o.precision, e = o.rounding, o.precision = r + 7, o.rounding = 1, divide(s.sinh(), s.cosh(), o.precision = r, o.rounding = e)) : new o(s.s);
};
P$2.inverseCosine = P$2.acos = function() {
  var r = this, e = r.constructor, s = r.abs().cmp(1), o = e.precision, a = e.rounding;
  return s !== -1 ? s === 0 ? r.isNeg() ? getPi(e, o, a) : new e(0) : new e(NaN) : r.isZero() ? getPi(e, o + 4, a).times(0.5) : (e.precision = o + 6, e.rounding = 1, r = new e(1).minus(r).div(r.plus(1)).sqrt().atan(), e.precision = o, e.rounding = a, r.times(2));
};
P$2.inverseHyperbolicCosine = P$2.acosh = function() {
  var r, e, s = this, o = s.constructor;
  return s.lte(1) ? new o(s.eq(1) ? 0 : NaN) : s.isFinite() ? (r = o.precision, e = o.rounding, o.precision = r + Math.max(Math.abs(s.e), s.sd()) + 4, o.rounding = 1, external = !1, s = s.times(s).minus(1).sqrt().plus(s), external = !0, o.precision = r, o.rounding = e, s.ln()) : new o(s);
};
P$2.inverseHyperbolicSine = P$2.asinh = function() {
  var r, e, s = this, o = s.constructor;
  return !s.isFinite() || s.isZero() ? new o(s) : (r = o.precision, e = o.rounding, o.precision = r + 2 * Math.max(Math.abs(s.e), s.sd()) + 6, o.rounding = 1, external = !1, s = s.times(s).plus(1).sqrt().plus(s), external = !0, o.precision = r, o.rounding = e, s.ln());
};
P$2.inverseHyperbolicTangent = P$2.atanh = function() {
  var r, e, s, o, a = this, l = a.constructor;
  return a.isFinite() ? a.e >= 0 ? new l(a.abs().eq(1) ? a.s / 0 : a.isZero() ? a : NaN) : (r = l.precision, e = l.rounding, o = a.sd(), Math.max(o, r) < 2 * -a.e - 1 ? finalise(new l(a), r, e, !0) : (l.precision = s = o - a.e, a = divide(a.plus(1), new l(1).minus(a), s + r, 1), l.precision = r + 4, l.rounding = 1, a = a.ln(), l.precision = r, l.rounding = e, a.times(0.5))) : new l(NaN);
};
P$2.inverseSine = P$2.asin = function() {
  var r, e, s, o, a = this, l = a.constructor;
  return a.isZero() ? new l(a) : (e = a.abs().cmp(1), s = l.precision, o = l.rounding, e !== -1 ? e === 0 ? (r = getPi(l, s + 4, o).times(0.5), r.s = a.s, r) : new l(NaN) : (l.precision = s + 6, l.rounding = 1, a = a.div(new l(1).minus(a.times(a)).sqrt().plus(1)).atan(), l.precision = s, l.rounding = o, a.times(2)));
};
P$2.inverseTangent = P$2.atan = function() {
  var r, e, s, o, a, l, u, c, E, d = this, f = d.constructor, h = f.precision, S = f.rounding;
  if (d.isFinite()) {
    if (d.isZero())
      return new f(d);
    if (d.abs().eq(1) && h + 4 <= PI_PRECISION)
      return u = getPi(f, h + 4, S).times(0.25), u.s = d.s, u;
  } else {
    if (!d.s)
      return new f(NaN);
    if (h + 4 <= PI_PRECISION)
      return u = getPi(f, h + 4, S).times(0.5), u.s = d.s, u;
  }
  for (f.precision = c = h + 10, f.rounding = 1, s = Math.min(28, c / LOG_BASE + 2 | 0), r = s; r; --r)
    d = d.div(d.times(d).plus(1).sqrt().plus(1));
  for (external = !1, e = Math.ceil(c / LOG_BASE), o = 1, E = d.times(d), u = new f(d), a = d; r !== -1; )
    if (a = a.times(E), l = u.minus(a.div(o += 2)), a = a.times(E), u = l.plus(a.div(o += 2)), u.d[e] !== void 0)
      for (r = e; u.d[r] === l.d[r] && r--; )
        ;
  return s && (u = u.times(2 << s - 1)), external = !0, finalise(u, f.precision = h, f.rounding = S, !0);
};
P$2.isFinite = function() {
  return !!this.d;
};
P$2.isInteger = P$2.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
};
P$2.isNaN = function() {
  return !this.s;
};
P$2.isNegative = P$2.isNeg = function() {
  return this.s < 0;
};
P$2.isPositive = P$2.isPos = function() {
  return this.s > 0;
};
P$2.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
P$2.lessThan = P$2.lt = function(r) {
  return this.cmp(r) < 0;
};
P$2.lessThanOrEqualTo = P$2.lte = function(r) {
  return this.cmp(r) < 1;
};
P$2.logarithm = P$2.log = function(r) {
  var e, s, o, a, l, u, c, E, d = this, f = d.constructor, h = f.precision, S = f.rounding, R = 5;
  if (r == null)
    r = new f(10), e = !0;
  else {
    if (r = new f(r), s = r.d, r.s < 0 || !s || !s[0] || r.eq(1))
      return new f(NaN);
    e = r.eq(10);
  }
  if (s = d.d, d.s < 0 || !s || !s[0] || d.eq(1))
    return new f(s && !s[0] ? -1 / 0 : d.s != 1 ? NaN : s ? 0 : 1 / 0);
  if (e)
    if (s.length > 1)
      l = !0;
    else {
      for (a = s[0]; a % 10 === 0; )
        a /= 10;
      l = a !== 1;
    }
  if (external = !1, c = h + R, u = naturalLogarithm(d, c), o = e ? getLn10(f, c + 10) : naturalLogarithm(r, c), E = divide(u, o, c, 1), checkRoundingDigits(E.d, a = h, S))
    do
      if (c += 10, u = naturalLogarithm(d, c), o = e ? getLn10(f, c + 10) : naturalLogarithm(r, c), E = divide(u, o, c, 1), !l) {
        +digitsToString(E.d).slice(a + 1, a + 15) + 1 == 1e14 && (E = finalise(E, h + 1, 0));
        break;
      }
    while (checkRoundingDigits(E.d, a += 10, S));
  return external = !0, finalise(E, h, S);
};
P$2.minus = P$2.sub = function(r) {
  var e, s, o, a, l, u, c, E, d, f, h, S, R = this, _ = R.constructor;
  if (r = new _(r), !R.d || !r.d)
    return !R.s || !r.s ? r = new _(NaN) : R.d ? r.s = -r.s : r = new _(r.d || R.s !== r.s ? R : NaN), r;
  if (R.s != r.s)
    return r.s = -r.s, R.plus(r);
  if (d = R.d, S = r.d, c = _.precision, E = _.rounding, !d[0] || !S[0]) {
    if (S[0])
      r.s = -r.s;
    else if (d[0])
      r = new _(R);
    else
      return new _(E === 3 ? -0 : 0);
    return external ? finalise(r, c, E) : r;
  }
  if (s = mathfloor(r.e / LOG_BASE), f = mathfloor(R.e / LOG_BASE), d = d.slice(), l = f - s, l) {
    for (h = l < 0, h ? (e = d, l = -l, u = S.length) : (e = S, s = f, u = d.length), o = Math.max(Math.ceil(c / LOG_BASE), u) + 2, l > o && (l = o, e.length = 1), e.reverse(), o = l; o--; )
      e.push(0);
    e.reverse();
  } else {
    for (o = d.length, u = S.length, h = o < u, h && (u = o), o = 0; o < u; o++)
      if (d[o] != S[o]) {
        h = d[o] < S[o];
        break;
      }
    l = 0;
  }
  for (h && (e = d, d = S, S = e, r.s = -r.s), u = d.length, o = S.length - u; o > 0; --o)
    d[u++] = 0;
  for (o = S.length; o > l; ) {
    if (d[--o] < S[o]) {
      for (a = o; a && d[--a] === 0; )
        d[a] = BASE - 1;
      --d[a], d[o] += BASE;
    }
    d[o] -= S[o];
  }
  for (; d[--u] === 0; )
    d.pop();
  for (; d[0] === 0; d.shift())
    --s;
  return d[0] ? (r.d = d, r.e = getBase10Exponent(d, s), external ? finalise(r, c, E) : r) : new _(E === 3 ? -0 : 0);
};
P$2.modulo = P$2.mod = function(r) {
  var e, s = this, o = s.constructor;
  return r = new o(r), !s.d || !r.s || r.d && !r.d[0] ? new o(NaN) : !r.d || s.d && !s.d[0] ? finalise(new o(s), o.precision, o.rounding) : (external = !1, o.modulo == 9 ? (e = divide(s, r.abs(), 0, 3, 1), e.s *= r.s) : e = divide(s, r, 0, o.modulo, 1), e = e.times(r), external = !0, s.minus(e));
};
P$2.naturalExponential = P$2.exp = function() {
  return naturalExponential(this);
};
P$2.naturalLogarithm = P$2.ln = function() {
  return naturalLogarithm(this);
};
P$2.negated = P$2.neg = function() {
  var r = new this.constructor(this);
  return r.s = -r.s, finalise(r);
};
P$2.plus = P$2.add = function(r) {
  var e, s, o, a, l, u, c, E, d, f, h = this, S = h.constructor;
  if (r = new S(r), !h.d || !r.d)
    return !h.s || !r.s ? r = new S(NaN) : h.d || (r = new S(r.d || h.s === r.s ? h : NaN)), r;
  if (h.s != r.s)
    return r.s = -r.s, h.minus(r);
  if (d = h.d, f = r.d, c = S.precision, E = S.rounding, !d[0] || !f[0])
    return f[0] || (r = new S(h)), external ? finalise(r, c, E) : r;
  if (l = mathfloor(h.e / LOG_BASE), o = mathfloor(r.e / LOG_BASE), d = d.slice(), a = l - o, a) {
    for (a < 0 ? (s = d, a = -a, u = f.length) : (s = f, o = l, u = d.length), l = Math.ceil(c / LOG_BASE), u = l > u ? l + 1 : u + 1, a > u && (a = u, s.length = 1), s.reverse(); a--; )
      s.push(0);
    s.reverse();
  }
  for (u = d.length, a = f.length, u - a < 0 && (a = u, s = f, f = d, d = s), e = 0; a; )
    e = (d[--a] = d[a] + f[a] + e) / BASE | 0, d[a] %= BASE;
  for (e && (d.unshift(e), ++o), u = d.length; d[--u] == 0; )
    d.pop();
  return r.d = d, r.e = getBase10Exponent(d, o), external ? finalise(r, c, E) : r;
};
P$2.precision = P$2.sd = function(r) {
  var e, s = this;
  if (r !== void 0 && r !== !!r && r !== 1 && r !== 0)
    throw Error(invalidArgument + r);
  return s.d ? (e = getPrecision(s.d), r && s.e + 1 > e && (e = s.e + 1)) : e = NaN, e;
};
P$2.round = function() {
  var r = this, e = r.constructor;
  return finalise(new e(r), r.e + 1, e.rounding);
};
P$2.sine = P$2.sin = function() {
  var r, e, s = this, o = s.constructor;
  return s.isFinite() ? s.isZero() ? new o(s) : (r = o.precision, e = o.rounding, o.precision = r + Math.max(s.e, s.sd()) + LOG_BASE, o.rounding = 1, s = sine(o, toLessThanHalfPi(o, s)), o.precision = r, o.rounding = e, finalise(quadrant > 2 ? s.neg() : s, r, e, !0)) : new o(NaN);
};
P$2.squareRoot = P$2.sqrt = function() {
  var r, e, s, o, a, l, u = this, c = u.d, E = u.e, d = u.s, f = u.constructor;
  if (d !== 1 || !c || !c[0])
    return new f(!d || d < 0 && (!c || c[0]) ? NaN : c ? u : 1 / 0);
  for (external = !1, d = Math.sqrt(+u), d == 0 || d == 1 / 0 ? (e = digitsToString(c), (e.length + E) % 2 == 0 && (e += "0"), d = Math.sqrt(e), E = mathfloor((E + 1) / 2) - (E < 0 || E % 2), d == 1 / 0 ? e = "5e" + E : (e = d.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + E), o = new f(e)) : o = new f(d.toString()), s = (E = f.precision) + 3; ; )
    if (l = o, o = l.plus(divide(u, l, s + 2, 1)).times(0.5), digitsToString(l.d).slice(0, s) === (e = digitsToString(o.d)).slice(0, s))
      if (e = e.slice(s - 3, s + 1), e == "9999" || !a && e == "4999") {
        if (!a && (finalise(l, E + 1, 0), l.times(l).eq(u))) {
          o = l;
          break;
        }
        s += 4, a = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (finalise(o, E + 1, 1), r = !o.times(o).eq(u));
        break;
      }
  return external = !0, finalise(o, E, f.rounding, r);
};
P$2.tangent = P$2.tan = function() {
  var r, e, s = this, o = s.constructor;
  return s.isFinite() ? s.isZero() ? new o(s) : (r = o.precision, e = o.rounding, o.precision = r + 10, o.rounding = 1, s = s.sin(), s.s = 1, s = divide(s, new o(1).minus(s.times(s)).sqrt(), r + 10, 0), o.precision = r, o.rounding = e, finalise(quadrant == 2 || quadrant == 4 ? s.neg() : s, r, e, !0)) : new o(NaN);
};
P$2.times = P$2.mul = function(r) {
  var e, s, o, a, l, u, c, E, d, f = this, h = f.constructor, S = f.d, R = (r = new h(r)).d;
  if (r.s *= f.s, !S || !S[0] || !R || !R[0])
    return new h(!r.s || S && !S[0] && !R || R && !R[0] && !S ? NaN : !S || !R ? r.s / 0 : r.s * 0);
  for (s = mathfloor(f.e / LOG_BASE) + mathfloor(r.e / LOG_BASE), E = S.length, d = R.length, E < d && (l = S, S = R, R = l, u = E, E = d, d = u), l = [], u = E + d, o = u; o--; )
    l.push(0);
  for (o = d; --o >= 0; ) {
    for (e = 0, a = E + o; a > o; )
      c = l[a] + R[o] * S[a - o - 1] + e, l[a--] = c % BASE | 0, e = c / BASE | 0;
    l[a] = (l[a] + e) % BASE | 0;
  }
  for (; !l[--u]; )
    l.pop();
  return e ? ++s : l.shift(), r.d = l, r.e = getBase10Exponent(l, s), external ? finalise(r, h.precision, h.rounding) : r;
};
P$2.toBinary = function(r, e) {
  return toStringBinary(this, 2, r, e);
};
P$2.toDecimalPlaces = P$2.toDP = function(r, e) {
  var s = this, o = s.constructor;
  return s = new o(s), r === void 0 ? s : (checkInt32(r, 0, MAX_DIGITS), e === void 0 ? e = o.rounding : checkInt32(e, 0, 8), finalise(s, r + s.e + 1, e));
};
P$2.toExponential = function(r, e) {
  var s, o = this, a = o.constructor;
  return r === void 0 ? s = finiteToString(o, !0) : (checkInt32(r, 0, MAX_DIGITS), e === void 0 ? e = a.rounding : checkInt32(e, 0, 8), o = finalise(new a(o), r + 1, e), s = finiteToString(o, !0, r + 1)), o.isNeg() && !o.isZero() ? "-" + s : s;
};
P$2.toFixed = function(r, e) {
  var s, o, a = this, l = a.constructor;
  return r === void 0 ? s = finiteToString(a) : (checkInt32(r, 0, MAX_DIGITS), e === void 0 ? e = l.rounding : checkInt32(e, 0, 8), o = finalise(new l(a), r + a.e + 1, e), s = finiteToString(o, !1, r + o.e + 1)), a.isNeg() && !a.isZero() ? "-" + s : s;
};
P$2.toFraction = function(r) {
  var e, s, o, a, l, u, c, E, d, f, h, S, R = this, _ = R.d, m = R.constructor;
  if (!_)
    return new m(R);
  if (d = s = new m(1), o = E = new m(0), e = new m(o), l = e.e = getPrecision(_) - R.e - 1, u = l % LOG_BASE, e.d[0] = mathpow(10, u < 0 ? LOG_BASE + u : u), r == null)
    r = l > 0 ? e : d;
  else {
    if (c = new m(r), !c.isInt() || c.lt(d))
      throw Error(invalidArgument + c);
    r = c.gt(e) ? l > 0 ? e : d : c;
  }
  for (external = !1, c = new m(digitsToString(_)), f = m.precision, m.precision = l = _.length * LOG_BASE * 2; h = divide(c, e, 0, 1, 1), a = s.plus(h.times(o)), a.cmp(r) != 1; )
    s = o, o = a, a = d, d = E.plus(h.times(a)), E = a, a = e, e = c.minus(h.times(a)), c = a;
  return a = divide(r.minus(s), o, 0, 1, 1), E = E.plus(a.times(d)), s = s.plus(a.times(o)), E.s = d.s = R.s, S = divide(d, o, l, 1).minus(R).abs().cmp(divide(E, s, l, 1).minus(R).abs()) < 1 ? [d, o] : [E, s], m.precision = f, external = !0, S;
};
P$2.toHexadecimal = P$2.toHex = function(r, e) {
  return toStringBinary(this, 16, r, e);
};
P$2.toNearest = function(r, e) {
  var s = this, o = s.constructor;
  if (s = new o(s), r == null) {
    if (!s.d)
      return s;
    r = new o(1), e = o.rounding;
  } else {
    if (r = new o(r), e === void 0 ? e = o.rounding : checkInt32(e, 0, 8), !s.d)
      return r.s ? s : r;
    if (!r.d)
      return r.s && (r.s = s.s), r;
  }
  return r.d[0] ? (external = !1, s = divide(s, r, 0, e, 1).times(r), external = !0, finalise(s)) : (r.s = s.s, s = r), s;
};
P$2.toNumber = function() {
  return +this;
};
P$2.toOctal = function(r, e) {
  return toStringBinary(this, 8, r, e);
};
P$2.toPower = P$2.pow = function(r) {
  var e, s, o, a, l, u, c = this, E = c.constructor, d = +(r = new E(r));
  if (!c.d || !r.d || !c.d[0] || !r.d[0])
    return new E(mathpow(+c, d));
  if (c = new E(c), c.eq(1))
    return c;
  if (o = E.precision, l = E.rounding, r.eq(1))
    return finalise(c, o, l);
  if (e = mathfloor(r.e / LOG_BASE), e >= r.d.length - 1 && (s = d < 0 ? -d : d) <= MAX_SAFE_INTEGER)
    return a = intPow(E, c, s, o), r.s < 0 ? new E(1).div(a) : finalise(a, o, l);
  if (u = c.s, u < 0) {
    if (e < r.d.length - 1)
      return new E(NaN);
    if (r.d[e] & 1 || (u = 1), c.e == 0 && c.d[0] == 1 && c.d.length == 1)
      return c.s = u, c;
  }
  return s = mathpow(+c, d), e = s == 0 || !isFinite(s) ? mathfloor(d * (Math.log("0." + digitsToString(c.d)) / Math.LN10 + c.e + 1)) : new E(s + "").e, e > E.maxE + 1 || e < E.minE - 1 ? new E(e > 0 ? u / 0 : 0) : (external = !1, E.rounding = c.s = 1, s = Math.min(12, (e + "").length), a = naturalExponential(r.times(naturalLogarithm(c, o + s)), o), a.d && (a = finalise(a, o + 5, 1), checkRoundingDigits(a.d, o, l) && (e = o + 10, a = finalise(naturalExponential(r.times(naturalLogarithm(c, e + s)), e), e + 5, 1), +digitsToString(a.d).slice(o + 1, o + 15) + 1 == 1e14 && (a = finalise(a, o + 1, 0)))), a.s = u, external = !0, E.rounding = l, finalise(a, o, l));
};
P$2.toPrecision = function(r, e) {
  var s, o = this, a = o.constructor;
  return r === void 0 ? s = finiteToString(o, o.e <= a.toExpNeg || o.e >= a.toExpPos) : (checkInt32(r, 1, MAX_DIGITS), e === void 0 ? e = a.rounding : checkInt32(e, 0, 8), o = finalise(new a(o), r, e), s = finiteToString(o, r <= o.e || o.e <= a.toExpNeg, r)), o.isNeg() && !o.isZero() ? "-" + s : s;
};
P$2.toSignificantDigits = P$2.toSD = function(r, e) {
  var s = this, o = s.constructor;
  return r === void 0 ? (r = o.precision, e = o.rounding) : (checkInt32(r, 1, MAX_DIGITS), e === void 0 ? e = o.rounding : checkInt32(e, 0, 8)), finalise(new o(s), r, e);
};
P$2.toString = function() {
  var r = this, e = r.constructor, s = finiteToString(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() && !r.isZero() ? "-" + s : s;
};
P$2.truncated = P$2.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
};
P$2.valueOf = P$2.toJSON = function() {
  var r = this, e = r.constructor, s = finiteToString(r, r.e <= e.toExpNeg || r.e >= e.toExpPos);
  return r.isNeg() ? "-" + s : s;
};
function digitsToString(r) {
  var e, s, o, a = r.length - 1, l = "", u = r[0];
  if (a > 0) {
    for (l += u, e = 1; e < a; e++)
      o = r[e] + "", s = LOG_BASE - o.length, s && (l += getZeroString(s)), l += o;
    u = r[e], o = u + "", s = LOG_BASE - o.length, s && (l += getZeroString(s));
  } else if (u === 0)
    return "0";
  for (; u % 10 === 0; )
    u /= 10;
  return l + u;
}
function checkInt32(r, e, s) {
  if (r !== ~~r || r < e || r > s)
    throw Error(invalidArgument + r);
}
function checkRoundingDigits(r, e, s, o) {
  var a, l, u, c;
  for (l = r[0]; l >= 10; l /= 10)
    --e;
  return --e < 0 ? (e += LOG_BASE, a = 0) : (a = Math.ceil((e + 1) / LOG_BASE), e %= LOG_BASE), l = mathpow(10, LOG_BASE - e), c = r[a] % l | 0, o == null ? e < 3 ? (e == 0 ? c = c / 100 | 0 : e == 1 && (c = c / 10 | 0), u = s < 4 && c == 99999 || s > 3 && c == 49999 || c == 5e4 || c == 0) : u = (s < 4 && c + 1 == l || s > 3 && c + 1 == l / 2) && (r[a + 1] / l / 100 | 0) == mathpow(10, e - 2) - 1 || (c == l / 2 || c == 0) && (r[a + 1] / l / 100 | 0) == 0 : e < 4 ? (e == 0 ? c = c / 1e3 | 0 : e == 1 ? c = c / 100 | 0 : e == 2 && (c = c / 10 | 0), u = (o || s < 4) && c == 9999 || !o && s > 3 && c == 4999) : u = ((o || s < 4) && c + 1 == l || !o && s > 3 && c + 1 == l / 2) && (r[a + 1] / l / 1e3 | 0) == mathpow(10, e - 3) - 1, u;
}
function convertBase(r, e, s) {
  for (var o, a = [0], l, u = 0, c = r.length; u < c; ) {
    for (l = a.length; l--; )
      a[l] *= e;
    for (a[0] += NUMERALS.indexOf(r.charAt(u++)), o = 0; o < a.length; o++)
      a[o] > s - 1 && (a[o + 1] === void 0 && (a[o + 1] = 0), a[o + 1] += a[o] / s | 0, a[o] %= s);
  }
  return a.reverse();
}
function cosine(r, e) {
  var s, o, a;
  if (e.isZero())
    return e;
  o = e.d.length, o < 32 ? (s = Math.ceil(o / 3), a = (1 / tinyPow(4, s)).toString()) : (s = 16, a = "2.3283064365386962890625e-10"), r.precision += s, e = taylorSeries(r, 1, e.times(a), new r(1));
  for (var l = s; l--; ) {
    var u = e.times(e);
    e = u.times(u).minus(u).times(8).plus(1);
  }
  return r.precision -= s, e;
}
var divide = function() {
  function r(o, a, l) {
    var u, c = 0, E = o.length;
    for (o = o.slice(); E--; )
      u = o[E] * a + c, o[E] = u % l | 0, c = u / l | 0;
    return c && o.unshift(c), o;
  }
  function e(o, a, l, u) {
    var c, E;
    if (l != u)
      E = l > u ? 1 : -1;
    else
      for (c = E = 0; c < l; c++)
        if (o[c] != a[c]) {
          E = o[c] > a[c] ? 1 : -1;
          break;
        }
    return E;
  }
  function s(o, a, l, u) {
    for (var c = 0; l--; )
      o[l] -= c, c = o[l] < a[l] ? 1 : 0, o[l] = c * u + o[l] - a[l];
    for (; !o[0] && o.length > 1; )
      o.shift();
  }
  return function(o, a, l, u, c, E) {
    var d, f, h, S, R, _, m, L, F, W, G, q, fe, _e, Le, Fe, Ee, Ge, ve, te, ae = o.constructor, v = o.s == a.s ? 1 : -1, Te = o.d, De = a.d;
    if (!Te || !Te[0] || !De || !De[0])
      return new ae(
        // Return NaN if either NaN, or both Infinity or 0.
        !o.s || !a.s || (Te ? De && Te[0] == De[0] : !De) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          Te && Te[0] == 0 || !De ? v * 0 : v / 0
        )
      );
    for (E ? (R = 1, f = o.e - a.e) : (E = BASE, R = LOG_BASE, f = mathfloor(o.e / R) - mathfloor(a.e / R)), ve = De.length, Ee = Te.length, F = new ae(v), W = F.d = [], h = 0; De[h] == (Te[h] || 0); h++)
      ;
    if (De[h] > (Te[h] || 0) && f--, l == null ? (_e = l = ae.precision, u = ae.rounding) : c ? _e = l + (o.e - a.e) + 1 : _e = l, _e < 0)
      W.push(1), _ = !0;
    else {
      if (_e = _e / R + 2 | 0, h = 0, ve == 1) {
        for (S = 0, De = De[0], _e++; (h < Ee || S) && _e--; h++)
          Le = S * E + (Te[h] || 0), W[h] = Le / De | 0, S = Le % De | 0;
        _ = S || h < Ee;
      } else {
        for (S = E / (De[0] + 1) | 0, S > 1 && (De = r(De, S, E), Te = r(Te, S, E), ve = De.length, Ee = Te.length), Fe = ve, G = Te.slice(0, ve), q = G.length; q < ve; )
          G[q++] = 0;
        te = De.slice(), te.unshift(0), Ge = De[0], De[1] >= E / 2 && ++Ge;
        do
          S = 0, d = e(De, G, ve, q), d < 0 ? (fe = G[0], ve != q && (fe = fe * E + (G[1] || 0)), S = fe / Ge | 0, S > 1 ? (S >= E && (S = E - 1), m = r(De, S, E), L = m.length, q = G.length, d = e(m, G, L, q), d == 1 && (S--, s(m, ve < L ? te : De, L, E))) : (S == 0 && (d = S = 1), m = De.slice()), L = m.length, L < q && m.unshift(0), s(G, m, q, E), d == -1 && (q = G.length, d = e(De, G, ve, q), d < 1 && (S++, s(G, ve < q ? te : De, q, E))), q = G.length) : d === 0 && (S++, G = [0]), W[h++] = S, d && G[0] ? G[q++] = Te[Fe] || 0 : (G = [Te[Fe]], q = 1);
        while ((Fe++ < Ee || G[0] !== void 0) && _e--);
        _ = G[0] !== void 0;
      }
      W[0] || W.shift();
    }
    if (R == 1)
      F.e = f, inexact = _;
    else {
      for (h = 1, S = W[0]; S >= 10; S /= 10)
        h++;
      F.e = h + f * R - 1, finalise(F, c ? l + F.e + 1 : l, u, _);
    }
    return F;
  };
}();
function finalise(r, e, s, o) {
  var a, l, u, c, E, d, f, h, S, R = r.constructor;
  e:
    if (e != null) {
      if (h = r.d, !h)
        return r;
      for (a = 1, c = h[0]; c >= 10; c /= 10)
        a++;
      if (l = e - a, l < 0)
        l += LOG_BASE, u = e, f = h[S = 0], E = f / mathpow(10, a - u - 1) % 10 | 0;
      else if (S = Math.ceil((l + 1) / LOG_BASE), c = h.length, S >= c)
        if (o) {
          for (; c++ <= S; )
            h.push(0);
          f = E = 0, a = 1, l %= LOG_BASE, u = l - LOG_BASE + 1;
        } else
          break e;
      else {
        for (f = c = h[S], a = 1; c >= 10; c /= 10)
          a++;
        l %= LOG_BASE, u = l - LOG_BASE + a, E = u < 0 ? 0 : f / mathpow(10, a - u - 1) % 10 | 0;
      }
      if (o = o || e < 0 || h[S + 1] !== void 0 || (u < 0 ? f : f % mathpow(10, a - u - 1)), d = s < 4 ? (E || o) && (s == 0 || s == (r.s < 0 ? 3 : 2)) : E > 5 || E == 5 && (s == 4 || o || s == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (l > 0 ? u > 0 ? f / mathpow(10, a - u) : 0 : h[S - 1]) % 10 & 1 || s == (r.s < 0 ? 8 : 7)), e < 1 || !h[0])
        return h.length = 0, d ? (e -= r.e + 1, h[0] = mathpow(10, (LOG_BASE - e % LOG_BASE) % LOG_BASE), r.e = -e || 0) : h[0] = r.e = 0, r;
      if (l == 0 ? (h.length = S, c = 1, S--) : (h.length = S + 1, c = mathpow(10, LOG_BASE - l), h[S] = u > 0 ? (f / mathpow(10, a - u) % mathpow(10, u) | 0) * c : 0), d)
        for (; ; )
          if (S == 0) {
            for (l = 1, u = h[0]; u >= 10; u /= 10)
              l++;
            for (u = h[0] += c, c = 1; u >= 10; u /= 10)
              c++;
            l != c && (r.e++, h[0] == BASE && (h[0] = 1));
            break;
          } else {
            if (h[S] += c, h[S] != BASE)
              break;
            h[S--] = 0, c = 1;
          }
      for (l = h.length; h[--l] === 0; )
        h.pop();
    }
  return external && (r.e > R.maxE ? (r.d = null, r.e = NaN) : r.e < R.minE && (r.e = 0, r.d = [0])), r;
}
function finiteToString(r, e, s) {
  if (!r.isFinite())
    return nonFiniteToString(r);
  var o, a = r.e, l = digitsToString(r.d), u = l.length;
  return e ? (s && (o = s - u) > 0 ? l = l.charAt(0) + "." + l.slice(1) + getZeroString(o) : u > 1 && (l = l.charAt(0) + "." + l.slice(1)), l = l + (r.e < 0 ? "e" : "e+") + r.e) : a < 0 ? (l = "0." + getZeroString(-a - 1) + l, s && (o = s - u) > 0 && (l += getZeroString(o))) : a >= u ? (l += getZeroString(a + 1 - u), s && (o = s - a - 1) > 0 && (l = l + "." + getZeroString(o))) : ((o = a + 1) < u && (l = l.slice(0, o) + "." + l.slice(o)), s && (o = s - u) > 0 && (a + 1 === u && (l += "."), l += getZeroString(o))), l;
}
function getBase10Exponent(r, e) {
  var s = r[0];
  for (e *= LOG_BASE; s >= 10; s /= 10)
    e++;
  return e;
}
function getLn10(r, e, s) {
  if (e > LN10_PRECISION)
    throw external = !0, s && (r.precision = s), Error(precisionLimitExceeded);
  return finalise(new r(LN10), e, 1, !0);
}
function getPi(r, e, s) {
  if (e > PI_PRECISION)
    throw Error(precisionLimitExceeded);
  return finalise(new r(PI), e, s, !0);
}
function getPrecision(r) {
  var e = r.length - 1, s = e * LOG_BASE + 1;
  if (e = r[e], e) {
    for (; e % 10 == 0; e /= 10)
      s--;
    for (e = r[0]; e >= 10; e /= 10)
      s++;
  }
  return s;
}
function getZeroString(r) {
  for (var e = ""; r--; )
    e += "0";
  return e;
}
function intPow(r, e, s, o) {
  var a, l = new r(1), u = Math.ceil(o / LOG_BASE + 4);
  for (external = !1; ; ) {
    if (s % 2 && (l = l.times(e), truncate(l.d, u) && (a = !0)), s = mathfloor(s / 2), s === 0) {
      s = l.d.length - 1, a && l.d[s] === 0 && ++l.d[s];
      break;
    }
    e = e.times(e), truncate(e.d, u);
  }
  return external = !0, l;
}
function isOdd(r) {
  return r.d[r.d.length - 1] & 1;
}
function maxOrMin(r, e, s) {
  for (var o, a, l = new r(e[0]), u = 0; ++u < e.length; ) {
    if (a = new r(e[u]), !a.s) {
      l = a;
      break;
    }
    o = l.cmp(a), (o === s || o === 0 && l.s === s) && (l = a);
  }
  return l;
}
function naturalExponential(r, e) {
  var s, o, a, l, u, c, E, d = 0, f = 0, h = 0, S = r.constructor, R = S.rounding, _ = S.precision;
  if (!r.d || !r.d[0] || r.e > 17)
    return new S(r.d ? r.d[0] ? r.s < 0 ? 0 : 1 / 0 : 1 : r.s ? r.s < 0 ? 0 : r : 0 / 0);
  for (e == null ? (external = !1, E = _) : E = e, c = new S(0.03125); r.e > -2; )
    r = r.times(c), h += 5;
  for (o = Math.log(mathpow(2, h)) / Math.LN10 * 2 + 5 | 0, E += o, s = l = u = new S(1), S.precision = E; ; ) {
    if (l = finalise(l.times(r), E, 1), s = s.times(++f), c = u.plus(divide(l, s, E, 1)), digitsToString(c.d).slice(0, E) === digitsToString(u.d).slice(0, E)) {
      for (a = h; a--; )
        u = finalise(u.times(u), E, 1);
      if (e == null)
        if (d < 3 && checkRoundingDigits(u.d, E - o, R, d))
          S.precision = E += 10, s = l = c = new S(1), f = 0, d++;
        else
          return finalise(u, S.precision = _, R, external = !0);
      else
        return S.precision = _, u;
    }
    u = c;
  }
}
function naturalLogarithm(r, e) {
  var s, o, a, l, u, c, E, d, f, h, S, R = 1, _ = 10, m = r, L = m.d, F = m.constructor, W = F.rounding, G = F.precision;
  if (m.s < 0 || !L || !L[0] || !m.e && L[0] == 1 && L.length == 1)
    return new F(L && !L[0] ? -1 / 0 : m.s != 1 ? NaN : L ? 0 : m);
  if (e == null ? (external = !1, f = G) : f = e, F.precision = f += _, s = digitsToString(L), o = s.charAt(0), Math.abs(l = m.e) < 15e14) {
    for (; o < 7 && o != 1 || o == 1 && s.charAt(1) > 3; )
      m = m.times(r), s = digitsToString(m.d), o = s.charAt(0), R++;
    l = m.e, o > 1 ? (m = new F("0." + s), l++) : m = new F(o + "." + s.slice(1));
  } else
    return d = getLn10(F, f + 2, G).times(l + ""), m = naturalLogarithm(new F(o + "." + s.slice(1)), f - _).plus(d), F.precision = G, e == null ? finalise(m, G, W, external = !0) : m;
  for (h = m, E = u = m = divide(m.minus(1), m.plus(1), f, 1), S = finalise(m.times(m), f, 1), a = 3; ; ) {
    if (u = finalise(u.times(S), f, 1), d = E.plus(divide(u, new F(a), f, 1)), digitsToString(d.d).slice(0, f) === digitsToString(E.d).slice(0, f))
      if (E = E.times(2), l !== 0 && (E = E.plus(getLn10(F, f + 2, G).times(l + ""))), E = divide(E, new F(R), f, 1), e == null)
        if (checkRoundingDigits(E.d, f - _, W, c))
          F.precision = f += _, d = u = m = divide(h.minus(1), h.plus(1), f, 1), S = finalise(m.times(m), f, 1), a = c = 1;
        else
          return finalise(E, F.precision = G, W, external = !0);
      else
        return F.precision = G, E;
    E = d, a += 2;
  }
}
function nonFiniteToString(r) {
  return String(r.s * r.s / 0);
}
function parseDecimal(r, e) {
  var s, o, a;
  for ((s = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (o = e.search(/e/i)) > 0 ? (s < 0 && (s = o), s += +e.slice(o + 1), e = e.substring(0, o)) : s < 0 && (s = e.length), o = 0; e.charCodeAt(o) === 48; o++)
    ;
  for (a = e.length; e.charCodeAt(a - 1) === 48; --a)
    ;
  if (e = e.slice(o, a), e) {
    if (a -= o, r.e = s = s - o - 1, r.d = [], o = (s + 1) % LOG_BASE, s < 0 && (o += LOG_BASE), o < a) {
      for (o && r.d.push(+e.slice(0, o)), a -= LOG_BASE; o < a; )
        r.d.push(+e.slice(o, o += LOG_BASE));
      e = e.slice(o), o = LOG_BASE - e.length;
    } else
      o -= a;
    for (; o--; )
      e += "0";
    r.d.push(+e), external && (r.e > r.constructor.maxE ? (r.d = null, r.e = NaN) : r.e < r.constructor.minE && (r.e = 0, r.d = [0]));
  } else
    r.e = 0, r.d = [0];
  return r;
}
function parseOther(r, e) {
  var s, o, a, l, u, c, E, d, f;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), isDecimal.test(e))
      return parseDecimal(r, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (r.s = NaN), r.e = NaN, r.d = null, r;
  if (isHex.test(e))
    s = 16, e = e.toLowerCase();
  else if (isBinary$1.test(e))
    s = 2;
  else if (isOctal.test(e))
    s = 8;
  else
    throw Error(invalidArgument + e);
  for (l = e.search(/p/i), l > 0 ? (E = +e.slice(l + 1), e = e.substring(2, l)) : e = e.slice(2), l = e.indexOf("."), u = l >= 0, o = r.constructor, u && (e = e.replace(".", ""), c = e.length, l = c - l, a = intPow(o, new o(s), l, l * 2)), d = convertBase(e, s, BASE), f = d.length - 1, l = f; d[l] === 0; --l)
    d.pop();
  return l < 0 ? new o(r.s * 0) : (r.e = getBase10Exponent(d, f), r.d = d, external = !1, u && (r = divide(r, a, c * 4)), E && (r = r.times(Math.abs(E) < 54 ? mathpow(2, E) : Decimal.pow(2, E))), external = !0, r);
}
function sine(r, e) {
  var s, o = e.d.length;
  if (o < 3)
    return e.isZero() ? e : taylorSeries(r, 2, e, e);
  s = 1.4 * Math.sqrt(o), s = s > 16 ? 16 : s | 0, e = e.times(1 / tinyPow(5, s)), e = taylorSeries(r, 2, e, e);
  for (var a, l = new r(5), u = new r(16), c = new r(20); s--; )
    a = e.times(e), e = e.times(l.plus(a.times(u.times(a).minus(c))));
  return e;
}
function taylorSeries(r, e, s, o, a) {
  var l, u, c, E, d = r.precision, f = Math.ceil(d / LOG_BASE);
  for (external = !1, E = s.times(s), c = new r(o); ; ) {
    if (u = divide(c.times(E), new r(e++ * e++), d, 1), c = a ? o.plus(u) : o.minus(u), o = divide(u.times(E), new r(e++ * e++), d, 1), u = c.plus(o), u.d[f] !== void 0) {
      for (l = f; u.d[l] === c.d[l] && l--; )
        ;
      if (l == -1)
        break;
    }
    l = c, c = o, o = u, u = l;
  }
  return external = !0, u.d.length = f + 1, u;
}
function tinyPow(r, e) {
  for (var s = r; --e; )
    s *= r;
  return s;
}
function toLessThanHalfPi(r, e) {
  var s, o = e.s < 0, a = getPi(r, r.precision, 1), l = a.times(0.5);
  if (e = e.abs(), e.lte(l))
    return quadrant = o ? 4 : 1, e;
  if (s = e.divToInt(a), s.isZero())
    quadrant = o ? 3 : 2;
  else {
    if (e = e.minus(s.times(a)), e.lte(l))
      return quadrant = isOdd(s) ? o ? 2 : 3 : o ? 4 : 1, e;
    quadrant = isOdd(s) ? o ? 1 : 4 : o ? 3 : 2;
  }
  return e.minus(a).abs();
}
function toStringBinary(r, e, s, o) {
  var a, l, u, c, E, d, f, h, S, R = r.constructor, _ = s !== void 0;
  if (_ ? (checkInt32(s, 1, MAX_DIGITS), o === void 0 ? o = R.rounding : checkInt32(o, 0, 8)) : (s = R.precision, o = R.rounding), !r.isFinite())
    f = nonFiniteToString(r);
  else {
    for (f = finiteToString(r), u = f.indexOf("."), _ ? (a = 2, e == 16 ? s = s * 4 - 3 : e == 8 && (s = s * 3 - 2)) : a = e, u >= 0 && (f = f.replace(".", ""), S = new R(1), S.e = f.length - u, S.d = convertBase(finiteToString(S), 10, a), S.e = S.d.length), h = convertBase(f, 10, a), l = E = h.length; h[--E] == 0; )
      h.pop();
    if (!h[0])
      f = _ ? "0p+0" : "0";
    else {
      if (u < 0 ? l-- : (r = new R(r), r.d = h, r.e = l, r = divide(r, S, s, o, 0, a), h = r.d, l = r.e, d = inexact), u = h[s], c = a / 2, d = d || h[s + 1] !== void 0, d = o < 4 ? (u !== void 0 || d) && (o === 0 || o === (r.s < 0 ? 3 : 2)) : u > c || u === c && (o === 4 || d || o === 6 && h[s - 1] & 1 || o === (r.s < 0 ? 8 : 7)), h.length = s, d)
        for (; ++h[--s] > a - 1; )
          h[s] = 0, s || (++l, h.unshift(1));
      for (E = h.length; !h[E - 1]; --E)
        ;
      for (u = 0, f = ""; u < E; u++)
        f += NUMERALS.charAt(h[u]);
      if (_) {
        if (E > 1)
          if (e == 16 || e == 8) {
            for (u = e == 16 ? 4 : 3, --E; E % u; E++)
              f += "0";
            for (h = convertBase(f, a, e), E = h.length; !h[E - 1]; --E)
              ;
            for (u = 1, f = "1."; u < E; u++)
              f += NUMERALS.charAt(h[u]);
          } else
            f = f.charAt(0) + "." + f.slice(1);
        f = f + (l < 0 ? "p" : "p+") + l;
      } else if (l < 0) {
        for (; ++l; )
          f = "0" + f;
        f = "0." + f;
      } else if (++l > E)
        for (l -= E; l--; )
          f += "0";
      else
        l < E && (f = f.slice(0, l) + "." + f.slice(l));
    }
    f = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + f;
  }
  return r.s < 0 ? "-" + f : f;
}
function truncate(r, e) {
  if (r.length > e)
    return r.length = e, !0;
}
function abs$2(r) {
  return new this(r).abs();
}
function acos(r) {
  return new this(r).acos();
}
function acosh(r) {
  return new this(r).acosh();
}
function add$2(r, e) {
  return new this(r).plus(e);
}
function asin(r) {
  return new this(r).asin();
}
function asinh(r) {
  return new this(r).asinh();
}
function atan$1(r) {
  return new this(r).atan();
}
function atanh(r) {
  return new this(r).atanh();
}
function atan2(r, e) {
  r = new this(r), e = new this(e);
  var s, o = this.precision, a = this.rounding, l = o + 4;
  return !r.s || !e.s ? s = new this(NaN) : !r.d && !e.d ? (s = getPi(this, l, 1).times(e.s > 0 ? 0.25 : 0.75), s.s = r.s) : !e.d || r.isZero() ? (s = e.s < 0 ? getPi(this, o, a) : new this(0), s.s = r.s) : !r.d || e.isZero() ? (s = getPi(this, l, 1).times(0.5), s.s = r.s) : e.s < 0 ? (this.precision = l, this.rounding = 1, s = this.atan(divide(r, e, l, 1)), e = getPi(this, l, 1), this.precision = o, this.rounding = a, s = r.s < 0 ? s.minus(e) : s.plus(e)) : s = this.atan(divide(r, e, l, 1)), s;
}
function cbrt(r) {
  return new this(r).cbrt();
}
function ceil(r) {
  return finalise(r = new this(r), r.e + 1, 2);
}
function clamp$1(r, e, s) {
  return new this(r).clamp(e, s);
}
function config(r) {
  if (!r || typeof r != "object")
    throw Error(decimalError + "Object expected");
  var e, s, o, a = r.defaults === !0, l = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -EXP_LIMIT,
    0,
    "toExpPos",
    0,
    EXP_LIMIT,
    "maxE",
    0,
    EXP_LIMIT,
    "minE",
    -EXP_LIMIT,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < l.length; e += 3)
    if (s = l[e], a && (this[s] = DEFAULTS[s]), (o = r[s]) !== void 0)
      if (mathfloor(o) === o && o >= l[e + 1] && o <= l[e + 2])
        this[s] = o;
      else
        throw Error(invalidArgument + s + ": " + o);
  if (s = "crypto", a && (this[s] = DEFAULTS[s]), (o = r[s]) !== void 0)
    if (o === !0 || o === !1 || o === 0 || o === 1)
      if (o)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[s] = !0;
        else
          throw Error(cryptoUnavailable);
      else
        this[s] = !1;
    else
      throw Error(invalidArgument + s + ": " + o);
  return this;
}
function cos$1(r) {
  return new this(r).cos();
}
function cosh$2(r) {
  return new this(r).cosh();
}
function clone$1(r) {
  var e, s, o;
  function a(l) {
    var u, c, E, d = this;
    if (!(d instanceof a))
      return new a(l);
    if (d.constructor = a, isDecimalInstance(l)) {
      d.s = l.s, external ? !l.d || l.e > a.maxE ? (d.e = NaN, d.d = null) : l.e < a.minE ? (d.e = 0, d.d = [0]) : (d.e = l.e, d.d = l.d.slice()) : (d.e = l.e, d.d = l.d ? l.d.slice() : l.d);
      return;
    }
    if (E = typeof l, E === "number") {
      if (l === 0) {
        d.s = 1 / l < 0 ? -1 : 1, d.e = 0, d.d = [0];
        return;
      }
      if (l < 0 ? (l = -l, d.s = -1) : d.s = 1, l === ~~l && l < 1e7) {
        for (u = 0, c = l; c >= 10; c /= 10)
          u++;
        external ? u > a.maxE ? (d.e = NaN, d.d = null) : u < a.minE ? (d.e = 0, d.d = [0]) : (d.e = u, d.d = [l]) : (d.e = u, d.d = [l]);
        return;
      }
      if (l * 0 !== 0) {
        l || (d.s = NaN), d.e = NaN, d.d = null;
        return;
      }
      return parseDecimal(d, l.toString());
    }
    if (E === "string")
      return (c = l.charCodeAt(0)) === 45 ? (l = l.slice(1), d.s = -1) : (c === 43 && (l = l.slice(1)), d.s = 1), isDecimal.test(l) ? parseDecimal(d, l) : parseOther(d, l);
    if (E === "bigint")
      return l < 0 ? (l = -l, d.s = -1) : d.s = 1, parseDecimal(d, l.toString());
    throw Error(invalidArgument + l);
  }
  if (a.prototype = P$2, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.EUCLID = 9, a.config = a.set = config, a.clone = clone$1, a.isDecimal = isDecimalInstance, a.abs = abs$2, a.acos = acos, a.acosh = acosh, a.add = add$2, a.asin = asin, a.asinh = asinh, a.atan = atan$1, a.atanh = atanh, a.atan2 = atan2, a.cbrt = cbrt, a.ceil = ceil, a.clamp = clamp$1, a.cos = cos$1, a.cosh = cosh$2, a.div = div, a.exp = exp, a.floor = floor$1, a.hypot = hypot$2, a.ln = ln, a.log = log$1, a.log10 = log10, a.log2 = log2, a.max = max$1, a.min = min$1, a.mod = mod, a.mul = mul, a.pow = pow$1, a.random = random, a.round = round$1, a.sign = sign$5, a.sin = sin$1, a.sinh = sinh$2, a.sqrt = sqrt$1, a.sub = sub, a.sum = sum, a.tan = tan, a.tanh = tanh, a.trunc = trunc$1, r === void 0 && (r = {}), r && r.defaults !== !0)
    for (o = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < o.length; )
      r.hasOwnProperty(s = o[e++]) || (r[s] = this[s]);
  return a.config(r), a;
}
function div(r, e) {
  return new this(r).div(e);
}
function exp(r) {
  return new this(r).exp();
}
function floor$1(r) {
  return finalise(r = new this(r), r.e + 1, 3);
}
function hypot$2() {
  var r, e, s = new this(0);
  for (external = !1, r = 0; r < arguments.length; )
    if (e = new this(arguments[r++]), e.d)
      s.d && (s = s.plus(e.times(e)));
    else {
      if (e.s)
        return external = !0, new this(1 / 0);
      s = e;
    }
  return external = !0, s.sqrt();
}
function isDecimalInstance(r) {
  return r instanceof Decimal || r && r.toStringTag === tag || !1;
}
function ln(r) {
  return new this(r).ln();
}
function log$1(r, e) {
  return new this(r).log(e);
}
function log2(r) {
  return new this(r).log(2);
}
function log10(r) {
  return new this(r).log(10);
}
function max$1() {
  return maxOrMin(this, arguments, -1);
}
function min$1() {
  return maxOrMin(this, arguments, 1);
}
function mod(r, e) {
  return new this(r).mod(e);
}
function mul(r, e) {
  return new this(r).mul(e);
}
function pow$1(r, e) {
  return new this(r).pow(e);
}
function random(r) {
  var e, s, o, a, l = 0, u = new this(1), c = [];
  if (r === void 0 ? r = this.precision : checkInt32(r, 1, MAX_DIGITS), o = Math.ceil(r / LOG_BASE), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(o)); l < o; )
        a = e[l], a >= 429e7 ? e[l] = crypto.getRandomValues(new Uint32Array(1))[0] : c[l++] = a % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(o *= 4); l < o; )
        a = e[l] + (e[l + 1] << 8) + (e[l + 2] << 16) + ((e[l + 3] & 127) << 24), a >= 214e7 ? crypto.randomBytes(4).copy(e, l) : (c.push(a % 1e7), l += 4);
      l = o / 4;
    } else
      throw Error(cryptoUnavailable);
  else
    for (; l < o; )
      c[l++] = Math.random() * 1e7 | 0;
  for (o = c[--l], r %= LOG_BASE, o && r && (a = mathpow(10, LOG_BASE - r), c[l] = (o / a | 0) * a); c[l] === 0; l--)
    c.pop();
  if (l < 0)
    s = 0, c = [0];
  else {
    for (s = -1; c[0] === 0; s -= LOG_BASE)
      c.shift();
    for (o = 1, a = c[0]; a >= 10; a /= 10)
      o++;
    o < LOG_BASE && (s -= LOG_BASE - o);
  }
  return u.e = s, u.d = c, u;
}
function round$1(r) {
  return finalise(r = new this(r), r.e + 1, this.rounding);
}
function sign$5(r) {
  return r = new this(r), r.d ? r.d[0] ? r.s : 0 * r.s : r.s || NaN;
}
function sin$1(r) {
  return new this(r).sin();
}
function sinh$2(r) {
  return new this(r).sinh();
}
function sqrt$1(r) {
  return new this(r).sqrt();
}
function sub(r, e) {
  return new this(r).sub(e);
}
function sum() {
  var r = 0, e = arguments, s = new this(e[r]);
  for (external = !1; s.s && ++r < e.length; )
    s = s.plus(e[r]);
  return external = !0, finalise(s, this.precision, this.rounding);
}
function tan(r) {
  return new this(r).tan();
}
function tanh(r) {
  return new this(r).tanh();
}
function trunc$1(r) {
  return finalise(r = new this(r), r.e + 1, 1);
}
P$2[Symbol.for("nodejs.util.inspect.custom")] = P$2.toString;
P$2[Symbol.toStringTag] = "Decimal";
var Decimal = P$2.constructor = clone$1(DEFAULTS);
LN10 = new Decimal(LN10);
PI = new Decimal(PI);
var name$15 = "BigNumber", dependencies$15 = ["?on", "config"], createBigNumberClass = /* @__PURE__ */ factory(name$15, dependencies$15, (r) => {
  var {
    on: e,
    config: s
  } = r, o = Decimal.clone({
    precision: s.precision,
    modulo: Decimal.EUCLID
  });
  return o.prototype = Object.create(o.prototype), o.prototype.type = "BigNumber", o.prototype.isBigNumber = !0, o.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, o.fromJSON = function(a) {
    return new o(a.value);
  }, e && e("config", function(a, l) {
    a.precision !== l.precision && o.config({
      precision: a.precision
    });
  }), o;
}, {
  isClass: !0
});
const cosh$1 = Math.cosh || function(r) {
  return Math.abs(r) < 1e-9 ? 1 - r : (Math.exp(r) + Math.exp(-r)) * 0.5;
}, sinh$1 = Math.sinh || function(r) {
  return Math.abs(r) < 1e-9 ? r : (Math.exp(r) - Math.exp(-r)) * 0.5;
}, cosm1 = function(r) {
  const e = Math.PI / 4;
  if (-e > r || r > e)
    return Math.cos(r) - 1;
  const s = r * r;
  return s * (s * (s * (s * (s * (s * (s * (s / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, hypot$1 = function(r, e) {
  return r = Math.abs(r), e = Math.abs(e), r < e && ([r, e] = [e, r]), r < 1e8 ? Math.sqrt(r * r + e * e) : (e /= r, r * Math.sqrt(1 + e * e));
}, parser_exit = function() {
  throw SyntaxError("Invalid Param");
};
function logHypot(r, e) {
  const s = Math.abs(r), o = Math.abs(e);
  return r === 0 ? Math.log(o) : e === 0 ? Math.log(s) : s < 3e3 && o < 3e3 ? Math.log(r * r + e * e) * 0.5 : (r = r * 0.5, e = e * 0.5, 0.5 * Math.log(r * r + e * e) + Math.LN2);
}
const P$1 = { re: 0, im: 0 }, parse$4 = function(r, e) {
  const s = P$1;
  if (r == null)
    s.re = s.im = 0;
  else if (e !== void 0)
    s.re = r, s.im = e;
  else
    switch (typeof r) {
      case "object":
        if ("im" in r && "re" in r)
          s.re = r.re, s.im = r.im;
        else if ("abs" in r && "arg" in r) {
          if (!isFinite(r.abs) && isFinite(r.arg))
            return Complex$1.INFINITY;
          s.re = r.abs * Math.cos(r.arg), s.im = r.abs * Math.sin(r.arg);
        } else if ("r" in r && "phi" in r) {
          if (!isFinite(r.r) && isFinite(r.phi))
            return Complex$1.INFINITY;
          s.re = r.r * Math.cos(r.phi), s.im = r.r * Math.sin(r.phi);
        } else
          r.length === 2 ? (s.re = r[0], s.im = r[1]) : parser_exit();
        break;
      case "string":
        s.im = /* void */
        s.re = 0;
        const o = r.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
        let a = 1, l = 0;
        o === null && parser_exit();
        for (let u = 0; u < o.length; u++) {
          const c = o[u];
          c === " " || c === "	" || c === `
` || (c === "+" ? a++ : c === "-" ? l++ : c === "i" || c === "I" ? (a + l === 0 && parser_exit(), o[u + 1] !== " " && !isNaN(o[u + 1]) ? (s.im += parseFloat((l % 2 ? "-" : "") + o[u + 1]), u++) : s.im += parseFloat((l % 2 ? "-" : "") + "1"), a = l = 0) : ((a + l === 0 || isNaN(c)) && parser_exit(), o[u + 1] === "i" || o[u + 1] === "I" ? (s.im += parseFloat((l % 2 ? "-" : "") + c), u++) : s.re += parseFloat((l % 2 ? "-" : "") + c), a = l = 0));
        }
        a + l > 0 && parser_exit();
        break;
      case "number":
        s.im = 0, s.re = r;
        break;
      default:
        parser_exit();
    }
  return isNaN(s.re) || isNaN(s.im), s;
};
function Complex$1(r, e) {
  if (!(this instanceof Complex$1))
    return new Complex$1(r, e);
  const s = parse$4(r, e);
  this.re = s.re, this.im = s.im;
}
Complex$1.prototype = {
  re: 0,
  im: 0,
  /**
   * Calculates the sign of a complex number, which is a normalized complex
   *
   * @returns {Complex}
   */
  sign: function() {
    const r = hypot$1(this.re, this.im);
    return new Complex$1(
      this.re / r,
      this.im / r
    );
  },
  /**
   * Adds two complex numbers
   *
   * @returns {Complex}
   */
  add: function(r, e) {
    const s = parse$4(r, e), o = this.isInfinite(), a = !(isFinite(s.re) && isFinite(s.im));
    return o || a ? o && a ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(
      this.re + s.re,
      this.im + s.im
    );
  },
  /**
   * Subtracts two complex numbers
   *
   * @returns {Complex}
   */
  sub: function(r, e) {
    const s = parse$4(r, e), o = this.isInfinite(), a = !(isFinite(s.re) && isFinite(s.im));
    return o || a ? o && a ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(
      this.re - s.re,
      this.im - s.im
    );
  },
  /**
   * Multiplies two complex numbers
   *
   * @returns {Complex}
   */
  mul: function(r, e) {
    const s = parse$4(r, e), o = this.isInfinite(), a = !(isFinite(s.re) && isFinite(s.im)), l = this.re === 0 && this.im === 0, u = s.re === 0 && s.im === 0;
    return o && u || a && l ? Complex$1.NAN : o || a ? Complex$1.INFINITY : s.im === 0 && this.im === 0 ? new Complex$1(this.re * s.re, 0) : new Complex$1(
      this.re * s.re - this.im * s.im,
      this.re * s.im + this.im * s.re
    );
  },
  /**
   * Divides two complex numbers
   *
   * @returns {Complex}
   */
  div: function(r, e) {
    const s = parse$4(r, e), o = this.isInfinite(), a = !(isFinite(s.re) && isFinite(s.im)), l = this.re === 0 && this.im === 0, u = s.re === 0 && s.im === 0;
    if (l && u || o && a)
      return Complex$1.NAN;
    if (u || o)
      return Complex$1.INFINITY;
    if (l || a)
      return Complex$1.ZERO;
    if (s.im === 0)
      return new Complex$1(this.re / s.re, this.im / s.re);
    if (Math.abs(s.re) < Math.abs(s.im)) {
      const c = s.re / s.im, E = s.re * c + s.im;
      return new Complex$1(
        (this.re * c + this.im) / E,
        (this.im * c - this.re) / E
      );
    } else {
      const c = s.im / s.re, E = s.im * c + s.re;
      return new Complex$1(
        (this.re + this.im * c) / E,
        (this.im - this.re * c) / E
      );
    }
  },
  /**
   * Calculate the power of two complex numbers
   *
   * @returns {Complex}
   */
  pow: function(r, e) {
    const s = parse$4(r, e), o = this.re === 0 && this.im === 0;
    if (s.re === 0 && s.im === 0)
      return Complex$1.ONE;
    if (s.im === 0) {
      if (this.im === 0 && this.re > 0)
        return new Complex$1(Math.pow(this.re, s.re), 0);
      if (this.re === 0)
        switch ((s.re % 4 + 4) % 4) {
          case 0:
            return new Complex$1(Math.pow(this.im, s.re), 0);
          case 1:
            return new Complex$1(0, Math.pow(this.im, s.re));
          case 2:
            return new Complex$1(-Math.pow(this.im, s.re), 0);
          case 3:
            return new Complex$1(0, -Math.pow(this.im, s.re));
        }
    }
    if (o && s.re > 0)
      return Complex$1.ZERO;
    const l = Math.atan2(this.im, this.re), u = logHypot(this.re, this.im);
    let c = Math.exp(s.re * u - s.im * l), E = s.im * u + s.re * l;
    return new Complex$1(
      c * Math.cos(E),
      c * Math.sin(E)
    );
  },
  /**
   * Calculate the complex square root
   *
   * @returns {Complex}
   */
  sqrt: function() {
    const r = this.re, e = this.im;
    if (e === 0)
      return r >= 0 ? new Complex$1(Math.sqrt(r), 0) : new Complex$1(0, Math.sqrt(-r));
    const s = hypot$1(r, e);
    let o = Math.sqrt(0.5 * (s + Math.abs(r))), a = Math.abs(e) / (2 * o);
    return r >= 0 ? new Complex$1(o, e < 0 ? -a : a) : new Complex$1(a, e < 0 ? -o : o);
  },
  /**
   * Calculate the complex exponent
   *
   * @returns {Complex}
   */
  exp: function() {
    const r = Math.exp(this.re);
    return this.im === 0 ? new Complex$1(r, 0) : new Complex$1(
      r * Math.cos(this.im),
      r * Math.sin(this.im)
    );
  },
  /**
   * Calculate the complex exponent and subtracts one.
   *
   * This may be more accurate than `Complex(x).exp().sub(1)` if
   * `x` is small.
   *
   * @returns {Complex}
   */
  expm1: function() {
    const r = this.re, e = this.im;
    return new Complex$1(
      Math.expm1(r) * Math.cos(e) + cosm1(e),
      Math.exp(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the natural log
   *
   * @returns {Complex}
   */
  log: function() {
    const r = this.re, e = this.im;
    return e === 0 && r > 0 ? new Complex$1(Math.log(r), 0) : new Complex$1(
      logHypot(r, e),
      Math.atan2(e, r)
    );
  },
  /**
   * Calculate the magnitude of the complex number
   *
   * @returns {number}
   */
  abs: function() {
    return hypot$1(this.re, this.im);
  },
  /**
   * Calculate the angle of the complex number
   *
   * @returns {number}
   */
  arg: function() {
    return Math.atan2(this.im, this.re);
  },
  /**
   * Calculate the sine of the complex number
   *
   * @returns {Complex}
   */
  sin: function() {
    const r = this.re, e = this.im;
    return new Complex$1(
      Math.sin(r) * cosh$1(e),
      Math.cos(r) * sinh$1(e)
    );
  },
  /**
   * Calculate the cosine
   *
   * @returns {Complex}
   */
  cos: function() {
    const r = this.re, e = this.im;
    return new Complex$1(
      Math.cos(r) * cosh$1(e),
      -Math.sin(r) * sinh$1(e)
    );
  },
  /**
   * Calculate the tangent
   *
   * @returns {Complex}
   */
  tan: function() {
    const r = 2 * this.re, e = 2 * this.im, s = Math.cos(r) + cosh$1(e);
    return new Complex$1(
      Math.sin(r) / s,
      sinh$1(e) / s
    );
  },
  /**
   * Calculate the cotangent
   *
   * @returns {Complex}
   */
  cot: function() {
    const r = 2 * this.re, e = 2 * this.im, s = Math.cos(r) - cosh$1(e);
    return new Complex$1(
      -Math.sin(r) / s,
      sinh$1(e) / s
    );
  },
  /**
   * Calculate the secant
   *
   * @returns {Complex}
   */
  sec: function() {
    const r = this.re, e = this.im, s = 0.5 * cosh$1(2 * e) + 0.5 * Math.cos(2 * r);
    return new Complex$1(
      Math.cos(r) * cosh$1(e) / s,
      Math.sin(r) * sinh$1(e) / s
    );
  },
  /**
   * Calculate the cosecans
   *
   * @returns {Complex}
   */
  csc: function() {
    const r = this.re, e = this.im, s = 0.5 * cosh$1(2 * e) - 0.5 * Math.cos(2 * r);
    return new Complex$1(
      Math.sin(r) * cosh$1(e) / s,
      -Math.cos(r) * sinh$1(e) / s
    );
  },
  /**
   * Calculate the complex arcus sinus
   *
   * @returns {Complex}
   */
  asin: function() {
    const r = this.re, e = this.im, s = new Complex$1(
      e * e - r * r + 1,
      -2 * r * e
    ).sqrt(), o = new Complex$1(
      s.re - e,
      s.im + r
    ).log();
    return new Complex$1(o.im, -o.re);
  },
  /**
   * Calculate the complex arcus cosinus
   *
   * @returns {Complex}
   */
  acos: function() {
    const r = this.re, e = this.im, s = new Complex$1(
      e * e - r * r + 1,
      -2 * r * e
    ).sqrt(), o = new Complex$1(
      s.re - e,
      s.im + r
    ).log();
    return new Complex$1(Math.PI / 2 - o.im, o.re);
  },
  /**
   * Calculate the complex arcus tangent
   *
   * @returns {Complex}
   */
  atan: function() {
    const r = this.re, e = this.im;
    if (r === 0) {
      if (e === 1)
        return new Complex$1(0, 1 / 0);
      if (e === -1)
        return new Complex$1(0, -1 / 0);
    }
    const s = r * r + (1 - e) * (1 - e), o = new Complex$1(
      (1 - e * e - r * r) / s,
      -2 * r / s
    ).log();
    return new Complex$1(-0.5 * o.im, 0.5 * o.re);
  },
  /**
   * Calculate the complex arcus cotangent
   *
   * @returns {Complex}
   */
  acot: function() {
    const r = this.re, e = this.im;
    if (e === 0)
      return new Complex$1(Math.atan2(1, r), 0);
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).atan() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).atan();
  },
  /**
   * Calculate the complex arcus secant
   *
   * @returns {Complex}
   */
  asec: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new Complex$1(0, 1 / 0);
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).acos() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).acos();
  },
  /**
   * Calculate the complex arcus cosecans
   *
   * @returns {Complex}
   */
  acsc: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new Complex$1(Math.PI / 2, 1 / 0);
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).asin() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).asin();
  },
  /**
   * Calculate the complex sinh
   *
   * @returns {Complex}
   */
  sinh: function() {
    const r = this.re, e = this.im;
    return new Complex$1(
      sinh$1(r) * Math.cos(e),
      cosh$1(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the complex cosh
   *
   * @returns {Complex}
   */
  cosh: function() {
    const r = this.re, e = this.im;
    return new Complex$1(
      cosh$1(r) * Math.cos(e),
      sinh$1(r) * Math.sin(e)
    );
  },
  /**
   * Calculate the complex tanh
   *
   * @returns {Complex}
   */
  tanh: function() {
    const r = 2 * this.re, e = 2 * this.im, s = cosh$1(r) + Math.cos(e);
    return new Complex$1(
      sinh$1(r) / s,
      Math.sin(e) / s
    );
  },
  /**
   * Calculate the complex coth
   *
   * @returns {Complex}
   */
  coth: function() {
    const r = 2 * this.re, e = 2 * this.im, s = cosh$1(r) - Math.cos(e);
    return new Complex$1(
      sinh$1(r) / s,
      -Math.sin(e) / s
    );
  },
  /**
   * Calculate the complex coth
   *
   * @returns {Complex}
   */
  csch: function() {
    const r = this.re, e = this.im, s = Math.cos(2 * e) - cosh$1(2 * r);
    return new Complex$1(
      -2 * sinh$1(r) * Math.cos(e) / s,
      2 * cosh$1(r) * Math.sin(e) / s
    );
  },
  /**
   * Calculate the complex sech
   *
   * @returns {Complex}
   */
  sech: function() {
    const r = this.re, e = this.im, s = Math.cos(2 * e) + cosh$1(2 * r);
    return new Complex$1(
      2 * cosh$1(r) * Math.cos(e) / s,
      -2 * sinh$1(r) * Math.sin(e) / s
    );
  },
  /**
   * Calculate the complex asinh
   *
   * @returns {Complex}
   */
  asinh: function() {
    let r = this.im;
    this.im = -this.re, this.re = r;
    const e = this.asin();
    return this.re = -this.im, this.im = r, r = e.re, e.re = -e.im, e.im = r, e;
  },
  /**
   * Calculate the complex acosh
   *
   * @returns {Complex}
   */
  acosh: function() {
    const r = this.acos();
    if (r.im <= 0) {
      const e = r.re;
      r.re = -r.im, r.im = e;
    } else {
      const e = r.im;
      r.im = -r.re, r.re = e;
    }
    return r;
  },
  /**
   * Calculate the complex atanh
   *
   * @returns {Complex}
   */
  atanh: function() {
    const r = this.re, e = this.im, s = r > 1 && e === 0, o = 1 - r, a = 1 + r, l = o * o + e * e, u = l !== 0 ? new Complex$1(
      (a * o - e * e) / l,
      (e * o + a * e) / l
    ) : new Complex$1(
      r !== -1 ? r / 0 : 0,
      e !== 0 ? e / 0 : 0
    ), c = u.re;
    return u.re = logHypot(u.re, u.im) / 2, u.im = Math.atan2(u.im, c) / 2, s && (u.im = -u.im), u;
  },
  /**
   * Calculate the complex acoth
   *
   * @returns {Complex}
   */
  acoth: function() {
    const r = this.re, e = this.im;
    if (r === 0 && e === 0)
      return new Complex$1(0, Math.PI / 2);
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).atanh() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).atanh();
  },
  /**
   * Calculate the complex acsch
   *
   * @returns {Complex}
   */
  acsch: function() {
    const r = this.re, e = this.im;
    if (e === 0)
      return new Complex$1(
        r !== 0 ? Math.log(r + Math.sqrt(r * r + 1)) : 1 / 0,
        0
      );
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).asinh() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).asinh();
  },
  /**
   * Calculate the complex asech
   *
   * @returns {Complex}
   */
  asech: function() {
    const r = this.re, e = this.im;
    if (this.isZero())
      return Complex$1.INFINITY;
    const s = r * r + e * e;
    return s !== 0 ? new Complex$1(
      r / s,
      -e / s
    ).acosh() : new Complex$1(
      r !== 0 ? r / 0 : 0,
      e !== 0 ? -e / 0 : 0
    ).acosh();
  },
  /**
   * Calculate the complex inverse 1/z
   *
   * @returns {Complex}
   */
  inverse: function() {
    if (this.isZero())
      return Complex$1.INFINITY;
    if (this.isInfinite())
      return Complex$1.ZERO;
    const r = this.re, e = this.im, s = r * r + e * e;
    return new Complex$1(r / s, -e / s);
  },
  /**
   * Returns the complex conjugate
   *
   * @returns {Complex}
   */
  conjugate: function() {
    return new Complex$1(this.re, -this.im);
  },
  /**
   * Gets the negated complex number
   *
   * @returns {Complex}
   */
  neg: function() {
    return new Complex$1(-this.re, -this.im);
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  ceil: function(r) {
    return r = Math.pow(10, r || 0), new Complex$1(
      Math.ceil(this.re * r) / r,
      Math.ceil(this.im * r) / r
    );
  },
  /**
   * Floors the actual complex number
   *
   * @returns {Complex}
   */
  floor: function(r) {
    return r = Math.pow(10, r || 0), new Complex$1(
      Math.floor(this.re * r) / r,
      Math.floor(this.im * r) / r
    );
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  round: function(r) {
    return r = Math.pow(10, r || 0), new Complex$1(
      Math.round(this.re * r) / r,
      Math.round(this.im * r) / r
    );
  },
  /**
   * Compares two complex numbers
   *
   * **Note:** new Complex(Infinity).equals(Infinity) === false
   *
   * @returns {boolean}
   */
  equals: function(r, e) {
    const s = parse$4(r, e);
    return Math.abs(s.re - this.re) <= Complex$1.EPSILON && Math.abs(s.im - this.im) <= Complex$1.EPSILON;
  },
  /**
   * Clones the actual object
   *
   * @returns {Complex}
   */
  clone: function() {
    return new Complex$1(this.re, this.im);
  },
  /**
   * Gets a string of the actual complex number
   *
   * @returns {string}
   */
  toString: function() {
    let r = this.re, e = this.im, s = "";
    return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(r) < Complex$1.EPSILON && (r = 0), Math.abs(e) < Complex$1.EPSILON && (e = 0), e === 0 ? s + r : (r !== 0 ? (s += r, s += " ", e < 0 ? (e = -e, s += "-") : s += "+", s += " ") : e < 0 && (e = -e, s += "-"), e !== 1 && (s += e), s + "i"));
  },
  /**
   * Returns the actual number as a vector
   *
   * @returns {Array}
   */
  toVector: function() {
    return [this.re, this.im];
  },
  /**
   * Returns the actual real value of the current object
   *
   * @returns {number|null}
   */
  valueOf: function() {
    return this.im === 0 ? this.re : null;
  },
  /**
   * Determines whether a complex number is not on the Riemann sphere.
   *
   * @returns {boolean}
   */
  isNaN: function() {
    return isNaN(this.re) || isNaN(this.im);
  },
  /**
   * Determines whether or not a complex number is at the zero pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isZero: function() {
    return this.im === 0 && this.re === 0;
  },
  /**
   * Determines whether a complex number is not at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isFinite: function() {
    return isFinite(this.re) && isFinite(this.im);
  },
  /**
   * Determines whether or not a complex number is at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isInfinite: function() {
    return !this.isFinite();
  }
};
Complex$1.ZERO = new Complex$1(0, 0);
Complex$1.ONE = new Complex$1(1, 0);
Complex$1.I = new Complex$1(0, 1);
Complex$1.PI = new Complex$1(Math.PI, 0);
Complex$1.E = new Complex$1(Math.E, 0);
Complex$1.INFINITY = new Complex$1(1 / 0, 1 / 0);
Complex$1.NAN = new Complex$1(NaN, NaN);
Complex$1.EPSILON = 1e-15;
var name$14 = "Complex", dependencies$14 = [], createComplexClass = /* @__PURE__ */ factory(name$14, dependencies$14, () => (Object.defineProperty(Complex$1, "name", {
  value: "Complex"
}), Complex$1.prototype.constructor = Complex$1, Complex$1.prototype.type = "Complex", Complex$1.prototype.isComplex = !0, Complex$1.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, Complex$1.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, Complex$1.prototype.format = function(r) {
  var e = "", s = this.im, o = this.re, a = format$2(this.re, r), l = format$2(this.im, r), u = isNumber(r) ? r : r ? r.precision : null;
  if (u !== null) {
    var c = Math.pow(10, -u);
    Math.abs(o / s) < c && (o = 0), Math.abs(s / o) < c && (s = 0);
  }
  return s === 0 ? e = a : o === 0 ? s === 1 ? e = "i" : s === -1 ? e = "-i" : e = l + "i" : s < 0 ? s === -1 ? e = a + " - i" : e = a + " - " + l.substring(1) + "i" : s === 1 ? e = a + " + i" : e = a + " + " + l + "i", e;
}, Complex$1.fromPolar = function(r) {
  switch (arguments.length) {
    case 1: {
      var e = arguments[0];
      if (typeof e == "object")
        return Complex$1(e);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var s = arguments[0], o = arguments[1];
      if (isNumber(s)) {
        if (isUnit(o) && o.hasBase("ANGLE") && (o = o.toNumber("rad")), isNumber(o))
          return new Complex$1({
            r: s,
            phi: o
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, Complex$1.prototype.valueOf = Complex$1.prototype.toString, Complex$1.fromJSON = function(r) {
  return new Complex$1(r);
}, Complex$1.compare = function(r, e) {
  return r.re > e.re ? 1 : r.re < e.re ? -1 : r.im > e.im ? 1 : r.im < e.im ? -1 : 0;
}, Complex$1), {
  isClass: !0
});
typeof BigInt > "u" && (BigInt = function(r) {
  if (isNaN(r))
    throw new Error("");
  return r;
});
const C_ZERO = BigInt(0), C_ONE = BigInt(1), C_TWO = BigInt(2), C_FIVE = BigInt(5), C_TEN = BigInt(10), MAX_CYCLE_LEN = 2e3, P = {
  s: C_ONE,
  n: C_ZERO,
  d: C_ONE
};
function assign(r, e) {
  try {
    r = BigInt(r);
  } catch {
    throw InvalidParameter();
  }
  return r * e;
}
function trunc(r) {
  return typeof r == "bigint" ? r : Math.floor(r);
}
function newFraction(r, e) {
  if (e === C_ZERO)
    throw DivisionByZero();
  const s = Object.create(Fraction$1.prototype);
  s.s = r < C_ZERO ? -C_ONE : C_ONE, r = r < C_ZERO ? -r : r;
  const o = gcd(r, e);
  return s.n = r / o, s.d = e / o, s;
}
function factorize(r) {
  const e = {};
  let s = r, o = C_TWO, a = C_FIVE - C_ONE;
  for (; a <= s; ) {
    for (; s % o === C_ZERO; )
      s /= o, e[o] = (e[o] || C_ZERO) + C_ONE;
    a += C_ONE + C_TWO * o++;
  }
  return s !== r ? s > 1 && (e[s] = (e[s] || C_ZERO) + C_ONE) : e[r] = (e[r] || C_ZERO) + C_ONE, e;
}
const parse$3 = function(r, e) {
  let s = C_ZERO, o = C_ONE, a = C_ONE;
  if (r != null)
    if (e !== void 0) {
      if (typeof r == "bigint")
        s = r;
      else {
        if (isNaN(r))
          throw InvalidParameter();
        if (r % 1 !== 0)
          throw NonIntegerParameter();
        s = BigInt(r);
      }
      if (typeof e == "bigint")
        o = e;
      else {
        if (isNaN(e))
          throw InvalidParameter();
        if (e % 1 !== 0)
          throw NonIntegerParameter();
        o = BigInt(e);
      }
      a = s * o;
    } else if (typeof r == "object") {
      if ("d" in r && "n" in r)
        s = BigInt(r.n), o = BigInt(r.d), "s" in r && (s *= BigInt(r.s));
      else if (0 in r)
        s = BigInt(r[0]), 1 in r && (o = BigInt(r[1]));
      else if (typeof r == "bigint")
        s = r;
      else
        throw InvalidParameter();
      a = s * o;
    } else if (typeof r == "number") {
      if (isNaN(r))
        throw InvalidParameter();
      if (r < 0 && (a = -C_ONE, r = -r), r % 1 === 0)
        s = BigInt(r);
      else {
        let l = 1, u = 0, c = 1, E = 1, d = 1, f = 1e7;
        for (r >= 1 && (l = 10 ** Math.floor(1 + Math.log10(r)), r /= l); c <= f && d <= f; ) {
          let h = (u + E) / (c + d);
          if (r === h) {
            c + d <= f ? (s = u + E, o = c + d) : d > c ? (s = E, o = d) : (s = u, o = c);
            break;
          } else
            r > h ? (u += E, c += d) : (E += u, d += c), c > f ? (s = E, o = d) : (s = u, o = c);
        }
        s = BigInt(s) * BigInt(l), o = BigInt(o);
      }
    } else if (typeof r == "string") {
      let l = 0, u = C_ZERO, c = C_ZERO, E = C_ZERO, d = C_ONE, f = C_ONE, h = r.replace(/_/g, "").match(/\d+|./g);
      if (h === null)
        throw InvalidParameter();
      if (h[l] === "-" ? (a = -C_ONE, l++) : h[l] === "+" && l++, h.length === l + 1 ? c = assign(h[l++], a) : h[l + 1] === "." || h[l] === "." ? (h[l] !== "." && (u = assign(h[l++], a)), l++, (l + 1 === h.length || h[l + 1] === "(" && h[l + 3] === ")" || h[l + 1] === "'" && h[l + 3] === "'") && (c = assign(h[l], a), d = C_TEN ** BigInt(h[l].length), l++), (h[l] === "(" && h[l + 2] === ")" || h[l] === "'" && h[l + 2] === "'") && (E = assign(h[l + 1], a), f = C_TEN ** BigInt(h[l + 1].length) - C_ONE, l += 3)) : h[l + 1] === "/" || h[l + 1] === ":" ? (c = assign(h[l], a), d = assign(h[l + 2], C_ONE), l += 3) : h[l + 3] === "/" && h[l + 1] === " " && (u = assign(h[l], a), c = assign(h[l + 2], a), d = assign(h[l + 4], C_ONE), l += 5), h.length <= l)
        o = d * f, a = /* void */
        s = E + o * u + f * c;
      else
        throw InvalidParameter();
    } else if (typeof r == "bigint")
      s = r, a = r, o = C_ONE;
    else
      throw InvalidParameter();
  if (o === C_ZERO)
    throw DivisionByZero();
  P.s = a < C_ZERO ? -C_ONE : C_ONE, P.n = s < C_ZERO ? -s : s, P.d = o < C_ZERO ? -o : o;
};
function modpow(r, e, s) {
  let o = C_ONE;
  for (; e > C_ZERO; r = r * r % s, e >>= C_ONE)
    e & C_ONE && (o = o * r % s);
  return o;
}
function cycleLen(r, e) {
  for (; e % C_TWO === C_ZERO; e /= C_TWO)
    ;
  for (; e % C_FIVE === C_ZERO; e /= C_FIVE)
    ;
  if (e === C_ONE)
    return C_ZERO;
  let s = C_TEN % e, o = 1;
  for (; s !== C_ONE; o++)
    if (s = s * C_TEN % e, o > MAX_CYCLE_LEN)
      return C_ZERO;
  return BigInt(o);
}
function cycleStart(r, e, s) {
  let o = C_ONE, a = modpow(C_TEN, s, e);
  for (let l = 0; l < 300; l++) {
    if (o === a)
      return BigInt(l);
    o = o * C_TEN % e, a = a * C_TEN % e;
  }
  return 0;
}
function gcd(r, e) {
  if (!r)
    return e;
  if (!e)
    return r;
  for (; ; ) {
    if (r %= e, !r)
      return e;
    if (e %= r, !e)
      return r;
  }
}
function Fraction$1(r, e) {
  if (parse$3(r, e), this instanceof Fraction$1)
    r = gcd(P.d, P.n), this.s = P.s, this.n = P.n / r, this.d = P.d / r;
  else
    return newFraction(P.s * P.n, P.d);
}
var DivisionByZero = function() {
  return new Error("Division by Zero");
}, InvalidParameter = function() {
  return new Error("Invalid argument");
}, NonIntegerParameter = function() {
  return new Error("Parameters must be integer");
};
Fraction$1.prototype = {
  s: C_ONE,
  n: C_ZERO,
  d: C_ONE,
  /**
   * Calculates the absolute value
   *
   * Ex: new Fraction(-4).abs() => 4
   **/
  abs: function() {
    return newFraction(this.n, this.d);
  },
  /**
   * Inverts the sign of the current fraction
   *
   * Ex: new Fraction(-4).neg() => 4
   **/
  neg: function() {
    return newFraction(-this.s * this.n, this.d);
  },
  /**
   * Adds two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
   **/
  add: function(r, e) {
    return parse$3(r, e), newFraction(
      this.s * this.n * P.d + P.s * this.d * P.n,
      this.d * P.d
    );
  },
  /**
   * Subtracts two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
   **/
  sub: function(r, e) {
    return parse$3(r, e), newFraction(
      this.s * this.n * P.d - P.s * this.d * P.n,
      this.d * P.d
    );
  },
  /**
   * Multiplies two rational numbers
   *
   * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
   **/
  mul: function(r, e) {
    return parse$3(r, e), newFraction(
      this.s * P.s * this.n * P.n,
      this.d * P.d
    );
  },
  /**
   * Divides two rational numbers
   *
   * Ex: new Fraction("-17.(345)").inverse().div(3)
   **/
  div: function(r, e) {
    return parse$3(r, e), newFraction(
      this.s * P.s * this.n * P.d,
      this.d * P.n
    );
  },
  /**
   * Clones the actual object
   *
   * Ex: new Fraction("-17.(345)").clone()
   **/
  clone: function() {
    return newFraction(this.s * this.n, this.d);
  },
  /**
   * Calculates the modulo of two rational numbers - a more precise fmod
   *
   * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
   * Ex: new Fraction(20, 10).mod().equals(0) ? "is Integer"
   **/
  mod: function(r, e) {
    if (r === void 0)
      return newFraction(this.s * this.n % this.d, C_ONE);
    if (parse$3(r, e), C_ZERO === P.n * this.d)
      throw DivisionByZero();
    return newFraction(
      this.s * (P.d * this.n) % (P.n * this.d),
      P.d * this.d
    );
  },
  /**
   * Calculates the fractional gcd of two rational numbers
   *
   * Ex: new Fraction(5,8).gcd(3,7) => 1/56
   */
  gcd: function(r, e) {
    return parse$3(r, e), newFraction(gcd(P.n, this.n) * gcd(P.d, this.d), P.d * this.d);
  },
  /**
   * Calculates the fractional lcm of two rational numbers
   *
   * Ex: new Fraction(5,8).lcm(3,7) => 15
   */
  lcm: function(r, e) {
    return parse$3(r, e), P.n === C_ZERO && this.n === C_ZERO ? newFraction(C_ZERO, C_ONE) : newFraction(P.n * this.n, gcd(P.n, this.n) * gcd(P.d, this.d));
  },
  /**
   * Gets the inverse of the fraction, means numerator and denominator are exchanged
   *
   * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
   **/
  inverse: function() {
    return newFraction(this.s * this.d, this.n);
  },
  /**
   * Calculates the fraction to some integer exponent
   *
   * Ex: new Fraction(-1,2).pow(-3) => -8
   */
  pow: function(r, e) {
    if (parse$3(r, e), P.d === C_ONE)
      return P.s < C_ZERO ? newFraction((this.s * this.d) ** P.n, this.n ** P.n) : newFraction((this.s * this.n) ** P.n, this.d ** P.n);
    if (this.s < C_ZERO)
      return null;
    let s = factorize(this.n), o = factorize(this.d), a = C_ONE, l = C_ONE;
    for (let u in s)
      if (u !== "1") {
        if (u === "0") {
          a = C_ZERO;
          break;
        }
        if (s[u] *= P.n, s[u] % P.d === C_ZERO)
          s[u] /= P.d;
        else
          return null;
        a *= BigInt(u) ** s[u];
      }
    for (let u in o)
      if (u !== "1") {
        if (o[u] *= P.n, o[u] % P.d === C_ZERO)
          o[u] /= P.d;
        else
          return null;
        l *= BigInt(u) ** o[u];
      }
    return P.s < C_ZERO ? newFraction(l, a) : newFraction(a, l);
  },
  /**
   * Calculates the logarithm of a fraction to a given rational base
   *
   * Ex: new Fraction(27, 8).log(9, 4) => 3/2
   */
  log: function(r, e) {
    if (parse$3(r, e), this.s <= C_ZERO || P.s <= C_ZERO)
      return null;
    const s = {}, o = factorize(P.n), a = factorize(P.d), l = factorize(this.n), u = factorize(this.d);
    for (const d in a)
      o[d] = (o[d] || C_ZERO) - a[d];
    for (const d in u)
      l[d] = (l[d] || C_ZERO) - u[d];
    for (const d in o)
      d !== "1" && (s[d] = !0);
    for (const d in l)
      d !== "1" && (s[d] = !0);
    let c = null, E = null;
    for (const d in s) {
      const f = o[d] || C_ZERO, h = l[d] || C_ZERO;
      if (f === C_ZERO) {
        if (h !== C_ZERO)
          return null;
        continue;
      }
      let S = h, R = f;
      const _ = gcd(S, R);
      if (S /= _, R /= _, c === null && E === null)
        c = S, E = R;
      else if (S * E !== c * R)
        return null;
    }
    return c !== null && E !== null ? newFraction(c, E) : null;
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  equals: function(r, e) {
    return parse$3(r, e), this.s * this.n * P.d === P.s * P.n * this.d;
  },
  /**
   * Check if this rational number is less than another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  lt: function(r, e) {
    return parse$3(r, e), this.s * this.n * P.d < P.s * P.n * this.d;
  },
  /**
   * Check if this rational number is less than or equal another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  lte: function(r, e) {
    return parse$3(r, e), this.s * this.n * P.d <= P.s * P.n * this.d;
  },
  /**
   * Check if this rational number is greater than another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  gt: function(r, e) {
    return parse$3(r, e), this.s * this.n * P.d > P.s * P.n * this.d;
  },
  /**
   * Check if this rational number is greater than or equal another
   *
   * Ex: new Fraction(19.6).lt([98, 5]);
   **/
  gte: function(r, e) {
    return parse$3(r, e), this.s * this.n * P.d >= P.s * P.n * this.d;
  },
  /**
   * Compare two rational numbers
   * < 0 iff this < that
   * > 0 iff this > that
   * = 0 iff this = that
   *
   * Ex: new Fraction(19.6).compare([98, 5]);
   **/
  compare: function(r, e) {
    parse$3(r, e);
    let s = this.s * this.n * P.d - P.s * P.n * this.d;
    return (C_ZERO < s) - (s < C_ZERO);
  },
  /**
   * Calculates the ceil of a rational number
   *
   * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
   **/
  ceil: function(r) {
    return r = C_TEN ** BigInt(r || 0), newFraction(
      trunc(this.s * r * this.n / this.d) + (r * this.n % this.d > C_ZERO && this.s >= C_ZERO ? C_ONE : C_ZERO),
      r
    );
  },
  /**
   * Calculates the floor of a rational number
   *
   * Ex: new Fraction('4.(3)').floor() => (4 / 1)
   **/
  floor: function(r) {
    return r = C_TEN ** BigInt(r || 0), newFraction(
      trunc(this.s * r * this.n / this.d) - (r * this.n % this.d > C_ZERO && this.s < C_ZERO ? C_ONE : C_ZERO),
      r
    );
  },
  /**
   * Rounds a rational numbers
   *
   * Ex: new Fraction('4.(3)').round() => (4 / 1)
   **/
  round: function(r) {
    return r = C_TEN ** BigInt(r || 0), newFraction(
      trunc(this.s * r * this.n / this.d) + this.s * ((this.s >= C_ZERO ? C_ONE : C_ZERO) + C_TWO * (r * this.n % this.d) > this.d ? C_ONE : C_ZERO),
      r
    );
  },
  /**
    * Rounds a rational number to a multiple of another rational number
    *
    * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
    **/
  roundTo: function(r, e) {
    parse$3(r, e);
    const s = this.n * P.d, o = this.d * P.n, a = s % o;
    let l = trunc(s / o);
    return a + a >= o && l++, newFraction(this.s * l * P.n, P.d);
  },
  /**
   * Check if two rational numbers are divisible
   *
   * Ex: new Fraction(19.6).divisible(1.5);
   */
  divisible: function(r, e) {
    return parse$3(r, e), !(!(P.n * this.d) || this.n * P.d % (P.n * this.d));
  },
  /**
   * Returns a decimal representation of the fraction
   *
   * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
   **/
  valueOf: function() {
    return Number(this.s * this.n) / Number(this.d);
  },
  /**
   * Creates a string representation of a fraction with all digits
   *
   * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
   **/
  toString: function(r) {
    let e = this.n, s = this.d;
    r = r || 15;
    let o = cycleLen(e, s), a = cycleStart(e, s, o), l = this.s < C_ZERO ? "-" : "";
    if (l += trunc(e / s), e %= s, e *= C_TEN, e && (l += "."), o) {
      for (let u = a; u--; )
        l += trunc(e / s), e %= s, e *= C_TEN;
      l += "(";
      for (let u = o; u--; )
        l += trunc(e / s), e %= s, e *= C_TEN;
      l += ")";
    } else
      for (let u = r; e && u--; )
        l += trunc(e / s), e %= s, e *= C_TEN;
    return l;
  },
  /**
   * Returns a string-fraction representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toFraction() => "4 1/3"
   **/
  toFraction: function(r) {
    let e = this.n, s = this.d, o = this.s < C_ZERO ? "-" : "";
    if (s === C_ONE)
      o += e;
    else {
      let a = trunc(e / s);
      r && a > C_ZERO && (o += a, o += " ", e %= s), o += e, o += "/", o += s;
    }
    return o;
  },
  /**
   * Returns a latex representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
   **/
  toLatex: function(r) {
    let e = this.n, s = this.d, o = this.s < C_ZERO ? "-" : "";
    if (s === C_ONE)
      o += e;
    else {
      let a = trunc(e / s);
      r && a > C_ZERO && (o += a, e %= s), o += "\\frac{", o += e, o += "}{", o += s, o += "}";
    }
    return o;
  },
  /**
   * Returns an array of continued fraction elements
   *
   * Ex: new Fraction("7/8").toContinued() => [0,1,7]
   */
  toContinued: function() {
    let r = this.n, e = this.d, s = [];
    do {
      s.push(trunc(r / e));
      let o = r % e;
      r = e, e = o;
    } while (r !== C_ONE);
    return s;
  },
  simplify: function(r) {
    const e = BigInt(1 / (r || 1e-3) | 0), s = this.abs(), o = s.toContinued();
    for (let a = 1; a < o.length; a++) {
      let l = newFraction(o[a - 1], C_ONE);
      for (let c = a - 2; c >= 0; c--)
        l = l.inverse().add(o[c]);
      let u = l.sub(s);
      if (u.n * e < u.d)
        return l.mul(this.s);
    }
    return this;
  }
};
var name$13 = "Fraction", dependencies$13 = [], createFractionClass = /* @__PURE__ */ factory(name$13, dependencies$13, () => (Object.defineProperty(Fraction$1, "name", {
  value: "Fraction"
}), Fraction$1.prototype.constructor = Fraction$1, Fraction$1.prototype.type = "Fraction", Fraction$1.prototype.isFraction = !0, Fraction$1.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: String(this.s * this.n),
    d: String(this.d)
  };
}, Fraction$1.fromJSON = function(r) {
  return new Fraction$1(r);
}, Fraction$1), {
  isClass: !0
}), name$12 = "Matrix", dependencies$12 = [], createMatrixClass = /* @__PURE__ */ factory(name$12, dependencies$12, () => {
  function r() {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return r.prototype.type = "Matrix", r.prototype.isMatrix = !0, r.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, r.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, r.prototype.create = function(e, s) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, r.prototype.subset = function(e, s, o) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, r.prototype.get = function(e) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, r.prototype.set = function(e, s, o) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, r.prototype.resize = function(e, s) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, r.prototype.reshape = function(e, s) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, r.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, r.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, r.prototype.map = function(e, s) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, r.prototype.forEach = function(e) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, r.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, r.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, r.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, r.prototype.format = function(e) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, r.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, r;
}, {
  isClass: !0
});
function formatBigNumberToBase(r, e, s) {
  var o = r.constructor, a = new o(2), l = "";
  if (s) {
    if (s < 1)
      throw new Error("size must be in greater than 0");
    if (!isInteger$1(s))
      throw new Error("size must be an integer");
    if (r.greaterThan(a.pow(s - 1).sub(1)) || r.lessThan(a.pow(s - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(s - 1, ", 2^").concat(s - 1, "-1]"));
    if (!r.isInteger())
      throw new Error("Value must be an integer");
    r.lessThan(0) && (r = r.add(a.pow(s))), l = "i".concat(s);
  }
  switch (e) {
    case 2:
      return "".concat(r.toBinary()).concat(l);
    case 8:
      return "".concat(r.toOctal()).concat(l);
    case 16:
      return "".concat(r.toHexadecimal()).concat(l);
    default:
      throw new Error("Base ".concat(e, " not supported "));
  }
}
function format$1(r, e) {
  if (typeof e == "function")
    return e(r);
  if (!r.isFinite())
    return r.isNaN() ? "NaN" : r.gt(0) ? "Infinity" : "-Infinity";
  var {
    notation: s,
    precision: o,
    wordSize: a
  } = normalizeFormatOptions(e);
  switch (s) {
    case "fixed":
      return toFixed(r, o);
    case "exponential":
      return toExponential(r, o);
    case "engineering":
      return toEngineering(r, o);
    case "bin":
      return formatBigNumberToBase(r, 2, a);
    case "oct":
      return formatBigNumberToBase(r, 8, a);
    case "hex":
      return formatBigNumberToBase(r, 16, a);
    case "auto": {
      var l = _toNumberOrDefault(e == null ? void 0 : e.lowerExp, -3), u = _toNumberOrDefault(e == null ? void 0 : e.upperExp, 5);
      if (r.isZero())
        return "0";
      var c, E = r.toSignificantDigits(o), d = E.e;
      return d >= l && d < u ? c = E.toFixed() : c = toExponential(r, o), c.replace(/((\.\d*?)(0+))($|e)/, function() {
        var f = arguments[2], h = arguments[4];
        return f !== "." ? f + h : h;
      });
    }
    default:
      throw new Error('Unknown notation "' + s + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function toEngineering(r, e) {
  var s = r.e, o = s % 3 === 0 ? s : s < 0 ? s - 3 - s % 3 : s - s % 3, a = r.mul(Math.pow(10, -o)), l = a.toPrecision(e);
  if (l.includes("e")) {
    var u = r.constructor;
    l = new u(l).toFixed();
  }
  return l + "e" + (s >= 0 ? "+" : "") + o.toString();
}
function toExponential(r, e) {
  return e !== void 0 ? r.toExponential(e - 1) : r.toExponential();
}
function toFixed(r, e) {
  return r.toFixed(e);
}
function _toNumberOrDefault(r, e) {
  return isNumber(r) ? r : isBigNumber(r) ? r.toNumber() : e;
}
function format(r, e) {
  var s = _format$1(r, e);
  return e && typeof e == "object" && "truncate" in e && s.length > e.truncate ? s.substring(0, e.truncate - 3) + "..." : s;
}
function _format$1(r, e) {
  if (typeof r == "number")
    return format$2(r, e);
  if (isBigNumber(r))
    return format$1(r, e);
  if (looksLikeFraction(r))
    return !e || e.fraction !== "decimal" ? "".concat(r.s * r.n, "/").concat(r.d) : r.toString();
  if (Array.isArray(r))
    return formatArray(r, e);
  if (isString(r))
    return stringify(r);
  if (typeof r == "function")
    return r.syntax ? String(r.syntax) : "function";
  if (r && typeof r == "object") {
    if (typeof r.format == "function")
      return r.format(e);
    if (r && r.toString(e) !== {}.toString())
      return r.toString(e);
    var s = Object.keys(r).map((o) => stringify(o) + ": " + format(r[o], e));
    return "{" + s.join(", ") + "}";
  }
  return String(r);
}
function stringify(r) {
  for (var e = String(r), s = "", o = 0; o < e.length; ) {
    var a = e.charAt(o);
    s += a in controlCharacters ? controlCharacters[a] : a, o++;
  }
  return '"' + s + '"';
}
var controlCharacters = {
  '"': '\\"',
  "\\": "\\\\",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
function formatArray(r, e) {
  if (Array.isArray(r)) {
    for (var s = "[", o = r.length, a = 0; a < o; a++)
      a !== 0 && (s += ", "), s += formatArray(r[a], e);
    return s += "]", s;
  } else
    return format(r, e);
}
function looksLikeFraction(r) {
  return r && typeof r == "object" && typeof r.s == "bigint" && typeof r.n == "bigint" && typeof r.d == "bigint" || !1;
}
function DimensionError(r, e, s) {
  if (!(this instanceof DimensionError))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = r, this.expected = e, this.relation = s, this.message = "Dimension mismatch (" + (Array.isArray(r) ? "[" + r.join(", ") + "]" : r) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = new Error().stack;
}
DimensionError.prototype = new RangeError();
DimensionError.prototype.constructor = RangeError;
DimensionError.prototype.name = "DimensionError";
DimensionError.prototype.isDimensionError = !0;
function IndexError(r, e, s) {
  if (!(this instanceof IndexError))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = r, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = s), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
IndexError.prototype = new RangeError();
IndexError.prototype.constructor = RangeError;
IndexError.prototype.name = "IndexError";
IndexError.prototype.isIndexError = !0;
function arraySize(r) {
  for (var e = []; Array.isArray(r); )
    e.push(r.length), r = r[0];
  return e;
}
function _validate(r, e, s) {
  var o, a = r.length;
  if (a !== e[s])
    throw new DimensionError(a, e[s]);
  if (s < e.length - 1) {
    var l = s + 1;
    for (o = 0; o < a; o++) {
      var u = r[o];
      if (!Array.isArray(u))
        throw new DimensionError(e.length - 1, e.length, "<");
      _validate(r[o], e, l);
    }
  } else
    for (o = 0; o < a; o++)
      if (Array.isArray(r[o]))
        throw new DimensionError(e.length + 1, e.length, ">");
}
function validate(r, e) {
  var s = e.length === 0;
  if (s) {
    if (Array.isArray(r))
      throw new DimensionError(r.length, 0);
  } else
    _validate(r, e, 0);
}
function validateIndex(r, e) {
  if (r !== void 0) {
    if (!isNumber(r) || !isInteger$1(r))
      throw new TypeError("Index must be an integer (value: " + r + ")");
    if (r < 0 || typeof e == "number" && r >= e)
      throw new IndexError(r, e);
  }
}
function resize(r, e, s) {
  if (!Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Error("Resizing to scalar is not supported");
  e.forEach(function(a) {
    if (!isNumber(a) || !isInteger$1(a) || a < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + format(e) + ")");
  }), (isNumber(r) || isBigNumber(r)) && (r = [r]);
  var o = s !== void 0 ? s : 0;
  return _resize(r, e, 0, o), r;
}
function _resize(r, e, s, o) {
  var a, l, u = r.length, c = e[s], E = Math.min(u, c);
  if (r.length = c, s < e.length - 1) {
    var d = s + 1;
    for (a = 0; a < E; a++)
      l = r[a], Array.isArray(l) || (l = [l], r[a] = l), _resize(l, e, d, o);
    for (a = E; a < c; a++)
      l = [], r[a] = l, _resize(l, e, d, o);
  } else {
    for (a = 0; a < E; a++)
      for (; Array.isArray(r[a]); )
        r[a] = r[a][0];
    for (a = E; a < c; a++)
      r[a] = o;
  }
}
function reshape$1(r, e) {
  var s = flatten$1(r, !0), o = s.length;
  if (!Array.isArray(r) || !Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new DimensionError(0, o, "!=");
  e = processSizesWildcard(e, o);
  var a = product(e);
  if (o !== a)
    throw new DimensionError(a, o, "!=");
  try {
    return _reshape(s, e);
  } catch (l) {
    throw l instanceof DimensionError ? new DimensionError(a, o, "!=") : l;
  }
}
function processSizesWildcard(r, e) {
  var s = product(r), o = r.slice(), a = -1, l = r.indexOf(a), u = r.indexOf(a, l + 1) >= 0;
  if (u)
    throw new Error("More than one wildcard in sizes");
  var c = l >= 0, E = e % s === 0;
  if (c)
    if (E)
      o[l] = -e / s;
    else
      throw new Error("Could not replace wildcard, since " + e + " is no multiple of " + -s);
  return o;
}
function product(r) {
  return r.reduce((e, s) => e * s, 1);
}
function _reshape(r, e) {
  for (var s = r, o, a = e.length - 1; a > 0; a--) {
    var l = e[a];
    o = [];
    for (var u = s.length / l, c = 0; c < u; c++)
      o.push(s.slice(c * l, (c + 1) * l));
    s = o;
  }
  return s;
}
function unsqueeze(r, e, s, o) {
  var a = o || arraySize(r);
  if (s)
    for (var l = 0; l < s; l++)
      r = [r], a.unshift(1);
  for (r = _unsqueeze(r, e, 0); a.length < e; )
    a.push(1);
  return r;
}
function _unsqueeze(r, e, s) {
  var o, a;
  if (Array.isArray(r)) {
    var l = s + 1;
    for (o = 0, a = r.length; o < a; o++)
      r[o] = _unsqueeze(r[o], e, l);
  } else
    for (var u = s; u < e; u++)
      r = [r];
  return r;
}
function flatten$1(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (!Array.isArray(r))
    return r;
  if (typeof e != "boolean")
    throw new TypeError("Boolean expected for second argument of flatten");
  var s = [];
  return e ? a(r) : o(r), s;
  function o(l) {
    for (var u = 0; u < l.length; u++) {
      var c = l[u];
      Array.isArray(c) ? o(c) : s.push(c);
    }
  }
  function a(l) {
    if (Array.isArray(l[0]))
      for (var u = 0; u < l.length; u++)
        a(l[u]);
    else
      for (var c = 0; c < l.length; c++)
        s.push(l[c]);
  }
}
function getArrayDataType(r, e) {
  for (var s, o = 0, a = 0; a < r.length; a++) {
    var l = r[a], u = Array.isArray(l);
    if (a === 0 && u && (o = l.length), u && l.length !== o)
      return;
    var c = u ? getArrayDataType(l, e) : e(l);
    if (s === void 0)
      s = c;
    else if (s !== c)
      return "mixed";
  }
  return s;
}
function concatRecursive(r, e, s, o) {
  if (o < s) {
    if (r.length !== e.length)
      throw new DimensionError(r.length, e.length);
    for (var a = [], l = 0; l < r.length; l++)
      a[l] = concatRecursive(r[l], e[l], s, o + 1);
    return a;
  } else
    return r.concat(e);
}
function concat$1() {
  var r = Array.prototype.slice.call(arguments, 0, -1), e = Array.prototype.slice.call(arguments, -1);
  if (r.length === 1)
    return r[0];
  if (r.length > 1)
    return r.slice(1).reduce(function(s, o) {
      return concatRecursive(s, o, e, 0);
    }, r[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function broadcastSizes() {
  for (var r = arguments.length, e = new Array(r), s = 0; s < r; s++)
    e[s] = arguments[s];
  for (var o = e.map((S) => S.length), a = Math.max(...o), l = new Array(a).fill(null), u = 0; u < e.length; u++)
    for (var c = e[u], E = o[u], d = 0; d < E; d++) {
      var f = a - E + d;
      c[d] > l[f] && (l[f] = c[d]);
    }
  for (var h = 0; h < e.length; h++)
    checkBroadcastingRules(e[h], l);
  return l;
}
function checkBroadcastingRules(r, e) {
  for (var s = e.length, o = r.length, a = 0; a < o; a++) {
    var l = s - o + a;
    if (r[a] < e[l] && r[a] > 1 || r[a] > e[l])
      throw new Error("shape mismatch: mismatch is found in arg with shape (".concat(r, ") not possible to broadcast dimension ").concat(o, " with size ").concat(r[a], " to size ").concat(e[l]));
  }
}
function broadcastTo(r, e) {
  var s = arraySize(r);
  if (deepStrictEqual(s, e))
    return r;
  checkBroadcastingRules(s, e);
  var o = broadcastSizes(s, e), a = o.length, l = [...Array(a - s.length).fill(1), ...s], u = clone(r);
  s.length < a && (u = reshape$1(u, l), s = arraySize(u));
  for (var c = 0; c < a; c++)
    s[c] < o[c] && (u = stretch(u, o[c], c), s = arraySize(u));
  return u;
}
function stretch(r, e, s) {
  return concat$1(...Array(e).fill(r), s);
}
function get$2(r, e) {
  if (!Array.isArray(r))
    throw new Error("Array expected");
  var s = arraySize(r);
  if (e.length !== s.length)
    throw new DimensionError(e.length, s.length);
  for (var o = 0; o < e.length; o++)
    validateIndex(e[o], s[o]);
  return e.reduce((a, l) => a[l], r);
}
function deepMap$1(r, e) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (r.length === 0)
    return [];
  if (s)
    return l(r);
  var o = [];
  return a(r, 0);
  function a(u, c) {
    if (Array.isArray(u)) {
      for (var E = u.length, d = Array(E), f = 0; f < E; f++)
        o[c] = f, d[f] = a(u[f], c + 1);
      return d;
    } else
      return e(u, o.slice(0, c), r);
  }
  function l(u) {
    if (Array.isArray(u)) {
      for (var c = u.length, E = Array(c), d = 0; d < c; d++)
        E[d] = l(u[d]);
      return E;
    } else
      return e(u);
  }
}
function clone(r) {
  return _extends$1([], r);
}
function optimizeCallback(r, e, s) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (typedFunction.isTypedFunction(r)) {
    var a;
    if (o)
      a = 1;
    else {
      var l = (e.isMatrix ? e.size() : arraySize(e)).map(() => 0), u = e.isMatrix ? e.get(l) : get$2(e, l);
      a = _findNumberOfArgumentsTyped(r, u, l, e);
    }
    var c;
    if (e.isMatrix && e.dataType !== "mixed" && e.dataType !== void 0) {
      var E = _findSingleSignatureWithArity(r, a);
      c = E !== void 0 ? E : r;
    } else
      c = r;
    return a >= 1 && a <= 3 ? {
      isUnary: a === 1,
      fn: function() {
        for (var f = arguments.length, h = new Array(f), S = 0; S < f; S++)
          h[S] = arguments[S];
        return _tryFunctionWithArgs(c, h.slice(0, a), s, r.name);
      }
    } : {
      isUnary: !1,
      fn: function() {
        for (var f = arguments.length, h = new Array(f), S = 0; S < f; S++)
          h[S] = arguments[S];
        return _tryFunctionWithArgs(c, h, s, r.name);
      }
    };
  }
  return o === void 0 ? {
    isUnary: _findIfCallbackIsUnary(r),
    fn: r
  } : {
    isUnary: o,
    fn: r
  };
}
function _findSingleSignatureWithArity(r, e) {
  var s = [];
  if (Object.entries(r.signatures).forEach((o) => {
    var [a, l] = o;
    a.split(",").length === e && s.push(l);
  }), s.length === 1)
    return s[0];
}
function _findIfCallbackIsUnary(r) {
  if (r.length !== 1)
    return !1;
  var e = r.toString();
  if (/arguments/.test(e))
    return !1;
  var s = e.match(/\(.*?\)/);
  return !/\.\.\./.test(s);
}
function _findNumberOfArgumentsTyped(r, e, s, o) {
  for (var a = [e, s, o], l = 3; l > 0; l--) {
    var u = a.slice(0, l);
    if (typedFunction.resolve(r, u) !== null)
      return l;
  }
}
function _tryFunctionWithArgs(r, e, s, o) {
  try {
    return r(...e);
  } catch (a) {
    _createCallbackError(a, e, s, o);
  }
}
function _createCallbackError(r, e, s, o) {
  var a;
  if (r instanceof TypeError && ((a = r.data) === null || a === void 0 ? void 0 : a.category) === "wrongType") {
    var l = [];
    throw l.push("value: ".concat(typeOf(e[0]))), e.length >= 2 && l.push("index: ".concat(typeOf(e[1]))), e.length >= 3 && l.push("array: ".concat(typeOf(e[2]))), new TypeError("Function ".concat(s, " cannot apply callback arguments ") + "".concat(o, "(").concat(l.join(", "), ") at index ").concat(JSON.stringify(e[1])));
  } else
    throw new TypeError("Function ".concat(s, " cannot apply callback arguments ") + "to function ".concat(o, ": ").concat(r.message));
}
var name$11 = "DenseMatrix", dependencies$11 = ["Matrix"], createDenseMatrixClass = /* @__PURE__ */ factory(name$11, dependencies$11, (r) => {
  var {
    Matrix: e
  } = r;
  function s(f, h) {
    if (!(this instanceof s))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (h && !isString(h))
      throw new Error("Invalid datatype: " + h);
    if (isMatrix(f))
      f.type === "DenseMatrix" ? (this._data = clone$2(f._data), this._size = clone$2(f._size), this._datatype = h || f._datatype) : (this._data = f.toArray(), this._size = f.size(), this._datatype = h || f._datatype);
    else if (f && isArray(f.data) && isArray(f.size))
      this._data = f.data, this._size = f.size, validate(this._data, this._size), this._datatype = h || f.datatype;
    else if (isArray(f))
      this._data = d(f), this._size = arraySize(this._data), validate(this._data, this._size), this._datatype = h;
    else {
      if (f)
        throw new TypeError("Unsupported type of data (" + typeOf(f) + ")");
      this._data = [], this._size = [0], this._datatype = h;
    }
  }
  s.prototype = new e(), s.prototype.createDenseMatrix = function(f, h) {
    return new s(f, h);
  }, Object.defineProperty(s, "name", {
    value: "DenseMatrix"
  }), s.prototype.constructor = s, s.prototype.type = "DenseMatrix", s.prototype.isDenseMatrix = !0, s.prototype.getDataType = function() {
    return getArrayDataType(this._data, typeOf);
  }, s.prototype.storage = function() {
    return "dense";
  }, s.prototype.datatype = function() {
    return this._datatype;
  }, s.prototype.create = function(f, h) {
    return new s(f, h);
  }, s.prototype.subset = function(f, h, S) {
    switch (arguments.length) {
      case 1:
        return o(this, f);
      case 2:
      case 3:
        return l(this, f, h, S);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, s.prototype.get = function(f) {
    return get$2(this._data, f);
  }, s.prototype.set = function(f, h, S) {
    if (!isArray(f))
      throw new TypeError("Array expected");
    if (f.length < this._size.length)
      throw new DimensionError(f.length, this._size.length, "<");
    var R, _, m, L = f.map(function(W) {
      return W + 1;
    });
    E(this, L, S);
    var F = this._data;
    for (R = 0, _ = f.length - 1; R < _; R++)
      m = f[R], validateIndex(m, F.length), F = F[m];
    return m = f[f.length - 1], validateIndex(m, F.length), F[m] = h, this;
  };
  function o(f, h) {
    if (!isIndex(h))
      throw new TypeError("Invalid index");
    var S = h.isScalar();
    if (S)
      return f.get(h.min());
    var R = h.size();
    if (R.length !== f._size.length)
      throw new DimensionError(R.length, f._size.length);
    for (var _ = h.min(), m = h.max(), L = 0, F = f._size.length; L < F; L++)
      validateIndex(_[L], f._size[L]), validateIndex(m[L], f._size[L]);
    var W = new s([]), G = a(f._data, h);
    return W._size = G.size, W._datatype = f._datatype, W._data = G.data, W;
  }
  function a(f, h) {
    var S = h.size().length - 1, R = Array(S);
    return {
      data: _(f),
      size: R
    };
    function _(m) {
      var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, F = h.dimension(L);
      return R[L] = F.size()[0], L < S ? F.map((W) => (validateIndex(W, m.length), _(m[W], L + 1))).valueOf() : F.map((W) => (validateIndex(W, m.length), m[W])).valueOf();
    }
  }
  function l(f, h, S, R) {
    if (!h || h.isIndex !== !0)
      throw new TypeError("Invalid index");
    var _ = h.size(), m = h.isScalar(), L;
    if (isMatrix(S) ? (L = S.size(), S = S.valueOf()) : L = arraySize(S), m) {
      if (L.length !== 0)
        throw new TypeError("Scalar expected");
      f.set(h.min(), S, R);
    } else {
      if (!deepStrictEqual(L, _))
        try {
          L.length === 0 ? S = broadcastTo([S], _) : S = broadcastTo(S, _), L = arraySize(S);
        } catch {
        }
      if (_.length < f._size.length)
        throw new DimensionError(_.length, f._size.length, "<");
      if (L.length < _.length) {
        for (var F = 0, W = 0; _[F] === 1 && L[F] === 1; )
          F++;
        for (; _[F] === 1; )
          W++, F++;
        S = unsqueeze(S, _.length, W, L);
      }
      if (!deepStrictEqual(_, L))
        throw new DimensionError(_, L, ">");
      var G = h.max().map(function(q) {
        return q + 1;
      });
      E(f, G, R), u(f._data, h, S);
    }
    return f;
  }
  function u(f, h, S) {
    var R = h.size().length - 1;
    _(f, S);
    function _(m, L) {
      var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, W = h.dimension(F);
      F < R ? W.forEach((G, q) => {
        validateIndex(G, m.length), _(m[G], L[q[0]], F + 1);
      }) : W.forEach((G, q) => {
        validateIndex(G, m.length), m[G] = L[q[0]];
      });
    }
  }
  s.prototype.resize = function(f, h, S) {
    if (!isCollection(f))
      throw new TypeError("Array or Matrix expected");
    var R = f.valueOf().map((m) => Array.isArray(m) && m.length === 1 ? m[0] : m), _ = S ? this.clone() : this;
    return c(_, R, h);
  };
  function c(f, h, S) {
    if (h.length === 0) {
      for (var R = f._data; isArray(R); )
        R = R[0];
      return R;
    }
    return f._size = h.slice(0), f._data = resize(f._data, f._size, S), f;
  }
  s.prototype.reshape = function(f, h) {
    var S = h ? this.clone() : this;
    S._data = reshape$1(S._data, f);
    var R = S._size.reduce((_, m) => _ * m);
    return S._size = processSizesWildcard(f, R), S;
  };
  function E(f, h, S) {
    for (var R = f._size.slice(0), _ = !1; R.length < h.length; )
      R.push(0), _ = !0;
    for (var m = 0, L = h.length; m < L; m++)
      h[m] > R[m] && (R[m] = h[m], _ = !0);
    _ && c(f, R, S);
  }
  s.prototype.clone = function() {
    var f = new s({
      data: clone$2(this._data),
      size: clone$2(this._size),
      datatype: this._datatype
    });
    return f;
  }, s.prototype.size = function() {
    return this._size.slice(0);
  }, s.prototype.map = function(f) {
    var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, S = this, R = S._size.length - 1;
    if (R < 0)
      return S.clone();
    var _ = optimizeCallback(f, S, "map", h), m = _.fn, L = S.create(void 0, S._datatype);
    if (L._size = S._size, h || _.isUnary)
      return L._data = _e(S._data), L;
    if (R === 0) {
      for (var F = S.valueOf(), W = Array(F.length), G = 0; G < F.length; G++)
        W[G] = m(F[G], [G], S);
      return L._data = W, L;
    }
    var q = [];
    return L._data = fe(S._data), L;
    function fe(Le) {
      var Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Ee = Array(Le.length);
      if (Fe < R)
        for (var Ge = 0; Ge < Le.length; Ge++)
          q[Fe] = Ge, Ee[Ge] = fe(Le[Ge], Fe + 1);
      else
        for (var ve = 0; ve < Le.length; ve++)
          q[Fe] = ve, Ee[ve] = m(Le[ve], q.slice(), S);
      return Ee;
    }
    function _e(Le) {
      var Fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Ee = Array(Le.length);
      if (Fe < R)
        for (var Ge = 0; Ge < Le.length; Ge++)
          Ee[Ge] = _e(Le[Ge], Fe + 1);
      else
        for (var ve = 0; ve < Le.length; ve++)
          Ee[ve] = m(Le[ve]);
      return Ee;
    }
  }, s.prototype.forEach = function(f) {
    var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, S = this, R = S._size.length - 1;
    if (R < 0)
      return;
    var _ = optimizeCallback(f, S, "map", h), m = _.fn;
    if (h || _.isUnary) {
      G(S._data);
      return;
    }
    if (R === 0) {
      for (var L = 0; L < S._data.length; L++)
        m(S._data[L], [L], S);
      return;
    }
    var F = [];
    W(S._data);
    function W(q) {
      var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (fe < R)
        for (var _e = 0; _e < q.length; _e++)
          F[fe] = _e, W(q[_e], fe + 1);
      else
        for (var Le = 0; Le < q.length; Le++)
          F[fe] = Le, m(q[Le], F.slice(), S);
    }
    function G(q) {
      var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (fe < R)
        for (var _e = 0; _e < q.length; _e++)
          G(q[_e], fe + 1);
      else
        for (var Le = 0; Le < q.length; Le++)
          m(q[Le]);
    }
  }, s.prototype[Symbol.iterator] = function* () {
    var f = this._size.length - 1;
    if (!(f < 0)) {
      if (f === 0) {
        for (var h = 0; h < this._data.length; h++)
          yield {
            value: this._data[h],
            index: [h]
          };
        return;
      }
      var S = [], R = function* (m, L) {
        if (L < f)
          for (var F = 0; F < m.length; F++)
            S[L] = F, yield* R(m[F], L + 1);
        else
          for (var W = 0; W < m.length; W++)
            S[L] = W, yield {
              value: m[W],
              index: S.slice()
            };
      };
      yield* R(this._data, 0);
    }
  }, s.prototype.rows = function() {
    var f = [], h = this.size();
    if (h.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var S = this._data;
    for (var R of S)
      f.push(new s([R], this._datatype));
    return f;
  }, s.prototype.columns = function() {
    var f = this, h = [], S = this.size();
    if (S.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var R = this._data, _ = function(F) {
      var W = R.map((G) => [G[F]]);
      h.push(new s(W, f._datatype));
    }, m = 0; m < S[1]; m++)
      _(m);
    return h;
  }, s.prototype.toArray = function() {
    return clone$2(this._data);
  }, s.prototype.valueOf = function() {
    return this._data;
  }, s.prototype.format = function(f) {
    return format(this._data, f);
  }, s.prototype.toString = function() {
    return format(this._data);
  }, s.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, s.prototype.diagonal = function(f) {
    if (f) {
      if (isBigNumber(f) && (f = f.toNumber()), !isNumber(f) || !isInteger$1(f))
        throw new TypeError("The parameter k must be an integer number");
    } else
      f = 0;
    for (var h = f > 0 ? f : 0, S = f < 0 ? -f : 0, R = this._size[0], _ = this._size[1], m = Math.min(R - S, _ - h), L = [], F = 0; F < m; F++)
      L[F] = this._data[F + S][F + h];
    return new s({
      data: L,
      size: [m],
      datatype: this._datatype
    });
  }, s.diagonal = function(f, h, S, R) {
    if (!isArray(f))
      throw new TypeError("Array expected, size parameter");
    if (f.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (f = f.map(function(Le) {
      if (isBigNumber(Le) && (Le = Le.toNumber()), !isNumber(Le) || !isInteger$1(Le) || Le < 1)
        throw new Error("Size values must be positive integers");
      return Le;
    }), S) {
      if (isBigNumber(S) && (S = S.toNumber()), !isNumber(S) || !isInteger$1(S))
        throw new TypeError("The parameter k must be an integer number");
    } else
      S = 0;
    var _ = S > 0 ? S : 0, m = S < 0 ? -S : 0, L = f[0], F = f[1], W = Math.min(L - m, F - _), G;
    if (isArray(h)) {
      if (h.length !== W)
        throw new Error("Invalid value array length");
      G = function(Fe) {
        return h[Fe];
      };
    } else if (isMatrix(h)) {
      var q = h.size();
      if (q.length !== 1 || q[0] !== W)
        throw new Error("Invalid matrix length");
      G = function(Fe) {
        return h.get([Fe]);
      };
    } else
      G = function() {
        return h;
      };
    R || (R = isBigNumber(G(0)) ? G(0).mul(0) : 0);
    var fe = [];
    if (f.length > 0) {
      fe = resize(fe, f, R);
      for (var _e = 0; _e < W; _e++)
        fe[_e + m][_e + _] = G(_e);
    }
    return new s({
      data: fe,
      size: [L, F]
    });
  }, s.fromJSON = function(f) {
    return new s(f);
  }, s.prototype.swapRows = function(f, h) {
    if (!isNumber(f) || !isInteger$1(f) || !isNumber(h) || !isInteger$1(h))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return validateIndex(f, this._size[0]), validateIndex(h, this._size[0]), s._swapRows(f, h, this._data), this;
  }, s._swapRows = function(f, h, S) {
    var R = S[f];
    S[f] = S[h], S[h] = R;
  };
  function d(f) {
    return isMatrix(f) ? d(f.valueOf()) : isArray(f) ? f.map(d) : f;
  }
  return s;
}, {
  isClass: !0
});
function deepMap(r, e, s) {
  if (!s)
    return isMatrix(r) ? r.map((a) => e(a), !1, !0) : deepMap$1(r, e, !0);
  var o = (a) => a === 0 ? a : e(a);
  return isMatrix(r) ? r.map((a) => o(a), !1, !0) : deepMap$1(r, o, !0);
}
var name$10 = "isInteger", dependencies$10 = ["typed"], createIsInteger = /* @__PURE__ */ factory(name$10, dependencies$10, (r) => {
  var {
    typed: e
  } = r;
  return e(name$10, {
    number: isInteger$1,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(o) {
      return o.isInt();
    },
    bigint: function(o) {
      return !0;
    },
    Fraction: function(o) {
      return o.d === 1n;
    },
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s))
  });
}), n1$1 = "number", n2 = "number, number";
function absNumber(r) {
  return Math.abs(r);
}
absNumber.signature = n1$1;
function addNumber(r, e) {
  return r + e;
}
addNumber.signature = n2;
function subtractNumber(r, e) {
  return r - e;
}
subtractNumber.signature = n2;
function multiplyNumber(r, e) {
  return r * e;
}
multiplyNumber.signature = n2;
function unaryMinusNumber(r) {
  return -r;
}
unaryMinusNumber.signature = n1$1;
function signNumber(r) {
  return sign$6(r);
}
signNumber.signature = n1$1;
var n1 = "number";
function isPositiveNumber(r) {
  return r > 0;
}
isPositiveNumber.signature = n1;
function nearlyEqual(r, e) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (s <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (o < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return r.isNaN() || e.isNaN() ? !1 : !r.isFinite() || !e.isFinite() ? r.eq(e) : r.eq(e) ? !0 : r.minus(e).abs().lte(r.constructor.max(r.constructor.max(r.abs(), e.abs()).mul(s), o));
}
var name$$ = "isPositive", dependencies$$ = ["typed", "config"], createIsPositive = /* @__PURE__ */ factory(name$$, dependencies$$, (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$$, {
    number: (o) => nearlyEqual$1(o, 0, s.relTol, s.absTol) ? !1 : isPositiveNumber(o),
    BigNumber: (o) => nearlyEqual(o, new o.constructor(0), s.relTol, s.absTol) ? !1 : !o.isNeg() && !o.isZero() && !o.isNaN(),
    bigint: (o) => o > 0n,
    Fraction: (o) => o.s > 0n && o.n > 0n,
    Unit: e.referToSelf((o) => (a) => e.find(o, a.valueType())(a.value)),
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
}), name$_ = "isZero", dependencies$_ = ["typed", "equalScalar"], createIsZero = /* @__PURE__ */ factory(name$_, dependencies$_, (r) => {
  var {
    typed: e,
    equalScalar: s
  } = r;
  return e(name$_, {
    "number | BigNumber | Complex | Fraction": (o) => s(o, 0),
    bigint: (o) => o === 0n,
    Unit: e.referToSelf((o) => (a) => e.find(o, a.valueType())(a.value)),
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
});
function complexEquals(r, e, s, o) {
  return nearlyEqual$1(r.re, e.re, s, o) && nearlyEqual$1(r.im, e.im, s, o);
}
var createCompareUnits = /* @__PURE__ */ factory("compareUnits", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    "Unit, Unit": e.referToSelf((s) => (o, a) => {
      if (!o.equalBase(a))
        throw new Error("Cannot compare units with different base");
      return e.find(s, [o.valueType(), a.valueType()])(o.value, a.value);
    })
  };
}), name$Z = "equalScalar", dependencies$Z = ["typed", "config"], createEqualScalar = /* @__PURE__ */ factory(name$Z, dependencies$Z, (r) => {
  var {
    typed: e,
    config: s
  } = r, o = createCompareUnits({
    typed: e
  });
  return e(name$Z, {
    "boolean, boolean": function(l, u) {
      return l === u;
    },
    "number, number": function(l, u) {
      return nearlyEqual$1(l, u, s.relTol, s.absTol);
    },
    "BigNumber, BigNumber": function(l, u) {
      return l.eq(u) || nearlyEqual(l, u, s.relTol, s.absTol);
    },
    "bigint, bigint": function(l, u) {
      return l === u;
    },
    "Fraction, Fraction": function(l, u) {
      return l.equals(u);
    },
    "Complex, Complex": function(l, u) {
      return complexEquals(l, u, s.relTol, s.absTol);
    }
  }, o);
});
factory(name$Z, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$Z, {
    "number, number": function(a, l) {
      return nearlyEqual$1(a, l, s.relTol, s.absTol);
    }
  });
});
var name$Y = "SparseMatrix", dependencies$Y = ["typed", "equalScalar", "Matrix"], createSparseMatrixClass = /* @__PURE__ */ factory(name$Y, dependencies$Y, (r) => {
  var {
    typed: e,
    equalScalar: s,
    Matrix: o
  } = r;
  function a(m, L) {
    if (!(this instanceof a))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (L && !isString(L))
      throw new Error("Invalid datatype: " + L);
    if (isMatrix(m))
      l(this, m, L);
    else if (m && isArray(m.index) && isArray(m.ptr) && isArray(m.size))
      this._values = m.values, this._index = m.index, this._ptr = m.ptr, this._size = m.size, this._datatype = L || m.datatype;
    else if (isArray(m))
      u(this, m, L);
    else {
      if (m)
        throw new TypeError("Unsupported type of data (" + typeOf(m) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = L;
    }
  }
  function l(m, L, F) {
    L.type === "SparseMatrix" ? (m._values = L._values ? clone$2(L._values) : void 0, m._index = clone$2(L._index), m._ptr = clone$2(L._ptr), m._size = clone$2(L._size), m._datatype = F || L._datatype) : u(m, L.valueOf(), F || L._datatype);
  }
  function u(m, L, F) {
    m._values = [], m._index = [], m._ptr = [], m._datatype = F;
    var W = L.length, G = 0, q = s, fe = 0;
    if (isString(F) && (q = e.find(s, [F, F]) || s, fe = e.convert(0, F)), W > 0) {
      var _e = 0;
      do {
        m._ptr.push(m._index.length);
        for (var Le = 0; Le < W; Le++) {
          var Fe = L[Le];
          if (isArray(Fe)) {
            if (_e === 0 && G < Fe.length && (G = Fe.length), _e < Fe.length) {
              var Ee = Fe[_e];
              q(Ee, fe) || (m._values.push(Ee), m._index.push(Le));
            }
          } else
            _e === 0 && G < 1 && (G = 1), q(Fe, fe) || (m._values.push(Fe), m._index.push(Le));
        }
        _e++;
      } while (_e < G);
    }
    m._ptr.push(m._index.length), m._size = [W, G];
  }
  a.prototype = new o(), a.prototype.createSparseMatrix = function(m, L) {
    return new a(m, L);
  }, Object.defineProperty(a, "name", {
    value: "SparseMatrix"
  }), a.prototype.constructor = a, a.prototype.type = "SparseMatrix", a.prototype.isSparseMatrix = !0, a.prototype.getDataType = function() {
    return getArrayDataType(this._values, typeOf);
  }, a.prototype.storage = function() {
    return "sparse";
  }, a.prototype.datatype = function() {
    return this._datatype;
  }, a.prototype.create = function(m, L) {
    return new a(m, L);
  }, a.prototype.density = function() {
    var m = this._size[0], L = this._size[1];
    return m !== 0 && L !== 0 ? this._index.length / (m * L) : 0;
  }, a.prototype.subset = function(m, L, F) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return c(this, m);
      case 2:
      case 3:
        return E(this, m, L, F);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function c(m, L) {
    if (!isIndex(L))
      throw new TypeError("Invalid index");
    var F = L.isScalar();
    if (F)
      return m.get(L.min());
    var W = L.size();
    if (W.length !== m._size.length)
      throw new DimensionError(W.length, m._size.length);
    var G, q, fe, _e, Le = L.min(), Fe = L.max();
    for (G = 0, q = m._size.length; G < q; G++)
      validateIndex(Le[G], m._size[G]), validateIndex(Fe[G], m._size[G]);
    var Ee = m._values, Ge = m._index, ve = m._ptr, te = L.dimension(0), ae = L.dimension(1), v = [], Te = [];
    te.forEach(function(ke, Be) {
      Te[ke] = Be[0], v[ke] = !0;
    });
    var De = Ee ? [] : void 0, be = [], ze = [];
    return ae.forEach(function(ke) {
      for (ze.push(be.length), fe = ve[ke], _e = ve[ke + 1]; fe < _e; fe++)
        G = Ge[fe], v[G] === !0 && (be.push(Te[G]), De && De.push(Ee[fe]));
    }), ze.push(be.length), new a({
      values: De,
      index: be,
      ptr: ze,
      size: W,
      datatype: m._datatype
    });
  }
  function E(m, L, F, W) {
    if (!L || L.isIndex !== !0)
      throw new TypeError("Invalid index");
    var G = L.size(), q = L.isScalar(), fe;
    if (isMatrix(F) ? (fe = F.size(), F = F.toArray()) : fe = arraySize(F), q) {
      if (fe.length !== 0)
        throw new TypeError("Scalar expected");
      m.set(L.min(), F, W);
    } else {
      if (G.length !== 1 && G.length !== 2)
        throw new DimensionError(G.length, m._size.length, "<");
      if (fe.length < G.length) {
        for (var _e = 0, Le = 0; G[_e] === 1 && fe[_e] === 1; )
          _e++;
        for (; G[_e] === 1; )
          Le++, _e++;
        F = unsqueeze(F, G.length, Le, fe);
      }
      if (!deepStrictEqual(G, fe))
        throw new DimensionError(G, fe, ">");
      if (G.length === 1) {
        var Fe = L.dimension(0);
        Fe.forEach(function(ve, te) {
          validateIndex(ve), m.set([ve, 0], F[te[0]], W);
        });
      } else {
        var Ee = L.dimension(0), Ge = L.dimension(1);
        Ee.forEach(function(ve, te) {
          validateIndex(ve), Ge.forEach(function(ae, v) {
            validateIndex(ae), m.set([ve, ae], F[te[0]][v[0]], W);
          });
        });
      }
    }
    return m;
  }
  a.prototype.get = function(m) {
    if (!isArray(m))
      throw new TypeError("Array expected");
    if (m.length !== this._size.length)
      throw new DimensionError(m.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var L = m[0], F = m[1];
    validateIndex(L, this._size[0]), validateIndex(F, this._size[1]);
    var W = d(L, this._ptr[F], this._ptr[F + 1], this._index);
    return W < this._ptr[F + 1] && this._index[W] === L ? this._values[W] : 0;
  }, a.prototype.set = function(m, L, F) {
    if (!isArray(m))
      throw new TypeError("Array expected");
    if (m.length !== this._size.length)
      throw new DimensionError(m.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var W = m[0], G = m[1], q = this._size[0], fe = this._size[1], _e = s, Le = 0;
    isString(this._datatype) && (_e = e.find(s, [this._datatype, this._datatype]) || s, Le = e.convert(0, this._datatype)), (W > q - 1 || G > fe - 1) && (S(this, Math.max(W + 1, q), Math.max(G + 1, fe), F), q = this._size[0], fe = this._size[1]), validateIndex(W, q), validateIndex(G, fe);
    var Fe = d(W, this._ptr[G], this._ptr[G + 1], this._index);
    return Fe < this._ptr[G + 1] && this._index[Fe] === W ? _e(L, Le) ? f(Fe, G, this._values, this._index, this._ptr) : this._values[Fe] = L : _e(L, Le) || h(Fe, W, G, L, this._values, this._index, this._ptr), this;
  };
  function d(m, L, F, W) {
    if (F - L === 0)
      return F;
    for (var G = L; G < F; G++)
      if (W[G] === m)
        return G;
    return L;
  }
  function f(m, L, F, W, G) {
    F.splice(m, 1), W.splice(m, 1);
    for (var q = L + 1; q < G.length; q++)
      G[q]--;
  }
  function h(m, L, F, W, G, q, fe) {
    G.splice(m, 0, W), q.splice(m, 0, L);
    for (var _e = F + 1; _e < fe.length; _e++)
      fe[_e]++;
  }
  a.prototype.resize = function(m, L, F) {
    if (!isCollection(m))
      throw new TypeError("Array or Matrix expected");
    var W = m.valueOf().map((q) => Array.isArray(q) && q.length === 1 ? q[0] : q);
    if (W.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    W.forEach(function(q) {
      if (!isNumber(q) || !isInteger$1(q) || q < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + format(W) + ")");
    });
    var G = F ? this.clone() : this;
    return S(G, W[0], W[1], L);
  };
  function S(m, L, F, W) {
    var G = W || 0, q = s, fe = 0;
    isString(m._datatype) && (q = e.find(s, [m._datatype, m._datatype]) || s, fe = e.convert(0, m._datatype), G = e.convert(G, m._datatype));
    var _e = !q(G, fe), Le = m._size[0], Fe = m._size[1], Ee, Ge, ve;
    if (F > Fe) {
      for (Ge = Fe; Ge < F; Ge++)
        if (m._ptr[Ge] = m._values.length, _e)
          for (Ee = 0; Ee < Le; Ee++)
            m._values.push(G), m._index.push(Ee);
      m._ptr[F] = m._values.length;
    } else
      F < Fe && (m._ptr.splice(F + 1, Fe - F), m._values.splice(m._ptr[F], m._values.length), m._index.splice(m._ptr[F], m._index.length));
    if (Fe = F, L > Le) {
      if (_e) {
        var te = 0;
        for (Ge = 0; Ge < Fe; Ge++) {
          m._ptr[Ge] = m._ptr[Ge] + te, ve = m._ptr[Ge + 1] + te;
          var ae = 0;
          for (Ee = Le; Ee < L; Ee++, ae++)
            m._values.splice(ve + ae, 0, G), m._index.splice(ve + ae, 0, Ee), te++;
        }
        m._ptr[Fe] = m._values.length;
      }
    } else if (L < Le) {
      var v = 0;
      for (Ge = 0; Ge < Fe; Ge++) {
        m._ptr[Ge] = m._ptr[Ge] - v;
        var Te = m._ptr[Ge], De = m._ptr[Ge + 1] - v;
        for (ve = Te; ve < De; ve++)
          Ee = m._index[ve], Ee > L - 1 && (m._values.splice(ve, 1), m._index.splice(ve, 1), v++);
      }
      m._ptr[Ge] = m._values.length;
    }
    return m._size[0] = L, m._size[1] = F, m;
  }
  a.prototype.reshape = function(m, L) {
    if (!isArray(m))
      throw new TypeError("Array expected");
    if (m.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    m.forEach(function(ke) {
      if (!isNumber(ke) || !isInteger$1(ke) || ke <= -2 || ke === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + format(m) + ")");
    });
    var F = this._size[0] * this._size[1];
    m = processSizesWildcard(m, F);
    var W = m[0] * m[1];
    if (F !== W)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var G = L ? this.clone() : this;
    if (this._size[0] === m[0] && this._size[1] === m[1])
      return G;
    for (var q = [], fe = 0; fe < G._ptr.length; fe++)
      for (var _e = 0; _e < G._ptr[fe + 1] - G._ptr[fe]; _e++)
        q.push(fe);
    for (var Le = G._values.slice(), Fe = G._index.slice(), Ee = 0; Ee < G._index.length; Ee++) {
      var Ge = Fe[Ee], ve = q[Ee], te = Ge * G._size[1] + ve;
      q[Ee] = te % m[1], Fe[Ee] = Math.floor(te / m[1]);
    }
    G._values.length = 0, G._index.length = 0, G._ptr.length = m[1] + 1, G._size = m.slice();
    for (var ae = 0; ae < G._ptr.length; ae++)
      G._ptr[ae] = 0;
    for (var v = 0; v < Le.length; v++) {
      var Te = Fe[v], De = q[v], be = Le[v], ze = d(Te, G._ptr[De], G._ptr[De + 1], G._index);
      h(ze, Te, De, be, G._values, G._index, G._ptr);
    }
    return G;
  }, a.prototype.clone = function() {
    var m = new a({
      values: this._values ? clone$2(this._values) : void 0,
      index: clone$2(this._index),
      ptr: clone$2(this._ptr),
      size: clone$2(this._size),
      datatype: this._datatype
    });
    return m;
  }, a.prototype.size = function() {
    return this._size.slice(0);
  }, a.prototype.map = function(m, L) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var F = this, W = this._size[0], G = this._size[1], q = optimizeCallback(m, F, "map"), fe = function(Le, Fe, Ee) {
      return q.fn(Le, [Fe, Ee], F);
    };
    return R(this, 0, W - 1, 0, G - 1, fe, L);
  };
  function R(m, L, F, W, G, q, fe) {
    var _e = [], Le = [], Fe = [], Ee = s, Ge = 0;
    isString(m._datatype) && (Ee = e.find(s, [m._datatype, m._datatype]) || s, Ge = e.convert(0, m._datatype));
    for (var ve = function(Se, xt, Ht) {
      var Bt = q(Se, xt, Ht);
      Ee(Bt, Ge) || (_e.push(Bt), Le.push(xt));
    }, te = W; te <= G; te++) {
      Fe.push(_e.length);
      var ae = m._ptr[te], v = m._ptr[te + 1];
      if (fe)
        for (var Te = ae; Te < v; Te++) {
          var De = m._index[Te];
          De >= L && De <= F && ve(m._values[Te], De - L, te - W);
        }
      else {
        for (var be = {}, ze = ae; ze < v; ze++) {
          var ke = m._index[ze];
          be[ke] = m._values[ze];
        }
        for (var Be = L; Be <= F; Be++) {
          var Me = Be in be ? be[Be] : 0;
          ve(Me, Be - L, te - W);
        }
      }
    }
    return Fe.push(_e.length), new a({
      values: _e,
      index: Le,
      ptr: Fe,
      size: [F - L + 1, G - W + 1]
    });
  }
  a.prototype.forEach = function(m, L) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var F = this, W = this._size[0], G = this._size[1], q = optimizeCallback(m, F, "forEach"), fe = 0; fe < G; fe++) {
      var _e = this._ptr[fe], Le = this._ptr[fe + 1];
      if (L)
        for (var Fe = _e; Fe < Le; Fe++) {
          var Ee = this._index[Fe];
          q.fn(this._values[Fe], [Ee, fe], F);
        }
      else {
        for (var Ge = {}, ve = _e; ve < Le; ve++) {
          var te = this._index[ve];
          Ge[te] = this._values[ve];
        }
        for (var ae = 0; ae < W; ae++) {
          var v = ae in Ge ? Ge[ae] : 0;
          q.fn(v, [ae, fe], F);
        }
      }
    }
  }, a.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var m = this._size[1], L = 0; L < m; L++)
      for (var F = this._ptr[L], W = this._ptr[L + 1], G = F; G < W; G++) {
        var q = this._index[G];
        yield {
          value: this._values[G],
          index: [q, L]
        };
      }
  }, a.prototype.toArray = function() {
    return _(this._values, this._index, this._ptr, this._size, !0);
  }, a.prototype.valueOf = function() {
    return _(this._values, this._index, this._ptr, this._size, !1);
  };
  function _(m, L, F, W, G) {
    var q = W[0], fe = W[1], _e = [], Le, Fe;
    for (Le = 0; Le < q; Le++)
      for (_e[Le] = [], Fe = 0; Fe < fe; Fe++)
        _e[Le][Fe] = 0;
    for (Fe = 0; Fe < fe; Fe++)
      for (var Ee = F[Fe], Ge = F[Fe + 1], ve = Ee; ve < Ge; ve++)
        Le = L[ve], _e[Le][Fe] = m ? G ? clone$2(m[ve]) : m[ve] : 1;
    return _e;
  }
  return a.prototype.format = function(m) {
    for (var L = this._size[0], F = this._size[1], W = this.density(), G = "Sparse Matrix [" + format(L, m) + " x " + format(F, m) + "] density: " + format(W, m) + `
`, q = 0; q < F; q++)
      for (var fe = this._ptr[q], _e = this._ptr[q + 1], Le = fe; Le < _e; Le++) {
        var Fe = this._index[Le];
        G += `
    (` + format(Fe, m) + ", " + format(q, m) + ") ==> " + (this._values ? format(this._values[Le], m) : "X");
      }
    return G;
  }, a.prototype.toString = function() {
    return format(this.toArray());
  }, a.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, a.prototype.diagonal = function(m) {
    if (m) {
      if (isBigNumber(m) && (m = m.toNumber()), !isNumber(m) || !isInteger$1(m))
        throw new TypeError("The parameter k must be an integer number");
    } else
      m = 0;
    var L = m > 0 ? m : 0, F = m < 0 ? -m : 0, W = this._size[0], G = this._size[1], q = Math.min(W - F, G - L), fe = [], _e = [], Le = [];
    Le[0] = 0;
    for (var Fe = L; Fe < G && fe.length < q; Fe++)
      for (var Ee = this._ptr[Fe], Ge = this._ptr[Fe + 1], ve = Ee; ve < Ge; ve++) {
        var te = this._index[ve];
        if (te === Fe - L + F) {
          fe.push(this._values[ve]), _e[fe.length - 1] = te - F;
          break;
        }
      }
    return Le.push(fe.length), new a({
      values: fe,
      index: _e,
      ptr: Le,
      size: [q, 1]
    });
  }, a.fromJSON = function(m) {
    return new a(m);
  }, a.diagonal = function(m, L, F, W, G) {
    if (!isArray(m))
      throw new TypeError("Array expected, size parameter");
    if (m.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (m = m.map(function(ke) {
      if (isBigNumber(ke) && (ke = ke.toNumber()), !isNumber(ke) || !isInteger$1(ke) || ke < 1)
        throw new Error("Size values must be positive integers");
      return ke;
    }), F) {
      if (isBigNumber(F) && (F = F.toNumber()), !isNumber(F) || !isInteger$1(F))
        throw new TypeError("The parameter k must be an integer number");
    } else
      F = 0;
    var q = s, fe = 0;
    isString(G) && (q = e.find(s, [G, G]) || s, fe = e.convert(0, G));
    var _e = F > 0 ? F : 0, Le = F < 0 ? -F : 0, Fe = m[0], Ee = m[1], Ge = Math.min(Fe - Le, Ee - _e), ve;
    if (isArray(L)) {
      if (L.length !== Ge)
        throw new Error("Invalid value array length");
      ve = function(Be) {
        return L[Be];
      };
    } else if (isMatrix(L)) {
      var te = L.size();
      if (te.length !== 1 || te[0] !== Ge)
        throw new Error("Invalid matrix length");
      ve = function(Be) {
        return L.get([Be]);
      };
    } else
      ve = function() {
        return L;
      };
    for (var ae = [], v = [], Te = [], De = 0; De < Ee; De++) {
      Te.push(ae.length);
      var be = De - _e;
      if (be >= 0 && be < Ge) {
        var ze = ve(be);
        q(ze, fe) || (v.push(be + Le), ae.push(ze));
      }
    }
    return Te.push(ae.length), new a({
      values: ae,
      index: v,
      ptr: Te,
      size: [Fe, Ee]
    });
  }, a.prototype.swapRows = function(m, L) {
    if (!isNumber(m) || !isInteger$1(m) || !isNumber(L) || !isInteger$1(L))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return validateIndex(m, this._size[0]), validateIndex(L, this._size[0]), a._swapRows(m, L, this._size[1], this._values, this._index, this._ptr), this;
  }, a._forEachRow = function(m, L, F, W, G) {
    for (var q = W[m], fe = W[m + 1], _e = q; _e < fe; _e++)
      G(F[_e], L[_e]);
  }, a._swapRows = function(m, L, F, W, G, q) {
    for (var fe = 0; fe < F; fe++) {
      var _e = q[fe], Le = q[fe + 1], Fe = d(m, _e, Le, G), Ee = d(L, _e, Le, G);
      if (Fe < Le && Ee < Le && G[Fe] === m && G[Ee] === L) {
        if (W) {
          var Ge = W[Fe];
          W[Fe] = W[Ee], W[Ee] = Ge;
        }
        continue;
      }
      if (Fe < Le && G[Fe] === m && (Ee >= Le || G[Ee] !== L)) {
        var ve = W ? W[Fe] : void 0;
        G.splice(Ee, 0, L), W && W.splice(Ee, 0, ve), G.splice(Ee <= Fe ? Fe + 1 : Fe, 1), W && W.splice(Ee <= Fe ? Fe + 1 : Fe, 1);
        continue;
      }
      if (Ee < Le && G[Ee] === L && (Fe >= Le || G[Fe] !== m)) {
        var te = W ? W[Ee] : void 0;
        G.splice(Fe, 0, m), W && W.splice(Fe, 0, te), G.splice(Fe <= Ee ? Ee + 1 : Ee, 1), W && W.splice(Fe <= Ee ? Ee + 1 : Ee, 1);
      }
    }
  }, a;
}, {
  isClass: !0
}), name$X = "number", dependencies$X = ["typed"];
function getNonDecimalNumberParts(r) {
  var e = r.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (e) {
    var s = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[e[1]], o = e[2], a = e[3];
    return {
      input: r,
      radix: s,
      integerPart: o,
      fractionalPart: a
    };
  } else
    return null;
}
function makeNumberFromNonDecimalParts(r) {
  for (var e = parseInt(r.integerPart, r.radix), s = 0, o = 0; o < r.fractionalPart.length; o++) {
    var a = parseInt(r.fractionalPart[o], r.radix);
    s += a / Math.pow(r.radix, o + 1);
  }
  var l = e + s;
  if (isNaN(l))
    throw new SyntaxError('String "' + r.input + '" is not a valid number');
  return l;
}
var createNumber = /* @__PURE__ */ factory(name$X, dependencies$X, (r) => {
  var {
    typed: e
  } = r, s = e("number", {
    "": function() {
      return 0;
    },
    number: function(a) {
      return a;
    },
    string: function(a) {
      if (a === "NaN")
        return NaN;
      var l = getNonDecimalNumberParts(a);
      if (l)
        return makeNumberFromNonDecimalParts(l);
      var u = 0, c = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      c && (u = Number(c[2]), a = c[1]);
      var E = Number(a);
      if (isNaN(E))
        throw new SyntaxError('String "' + a + '" is not a valid number');
      if (c) {
        if (E > 2 ** u - 1)
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        E >= 2 ** (u - 1) && (E = E - 2 ** u);
      }
      return E;
    },
    BigNumber: function(a) {
      return a.toNumber();
    },
    bigint: function(a) {
      return Number(a);
    },
    Fraction: function(a) {
      return a.valueOf();
    },
    Unit: e.referToSelf((o) => (a) => {
      var l = a.clone();
      return l.value = o(a.value), l;
    }),
    null: function(a) {
      return 0;
    },
    "Unit, string | Unit": function(a, l) {
      return a.toNumber(l);
    },
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
  return s.fromJSON = function(o) {
    return parseFloat(o.value);
  }, s;
}), name$W = "bignumber", dependencies$W = ["typed", "BigNumber"], createBignumber = /* @__PURE__ */ factory(name$W, dependencies$W, (r) => {
  var {
    typed: e,
    BigNumber: s
  } = r;
  return e("bignumber", {
    "": function() {
      return new s(0);
    },
    number: function(a) {
      return new s(a + "");
    },
    string: function(a) {
      var l = a.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (l) {
        var u = l[2], c = s(l[1]), E = new s(2).pow(Number(u));
        if (c.gt(E.sub(1)))
          throw new SyntaxError('String "'.concat(a, '" is out of range'));
        var d = new s(2).pow(Number(u) - 1);
        return c.gte(d) ? c.sub(E) : c;
      }
      return new s(a);
    },
    BigNumber: function(a) {
      return a;
    },
    bigint: function(a) {
      return new s(a.toString());
    },
    Unit: e.referToSelf((o) => (a) => {
      var l = a.clone();
      return l.value = o(a.value), l;
    }),
    Fraction: function(a) {
      return new s(String(a.n)).div(String(a.d)).times(String(a.s));
    },
    null: function(a) {
      return new s(0);
    },
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
}), name$V = "complex", dependencies$V = ["typed", "Complex"], createComplex = /* @__PURE__ */ factory(name$V, dependencies$V, (r) => {
  var {
    typed: e,
    Complex: s
  } = r;
  return e("complex", {
    "": function() {
      return s.ZERO;
    },
    number: function(a) {
      return new s(a, 0);
    },
    "number, number": function(a, l) {
      return new s(a, l);
    },
    // TODO: this signature should be redundant
    "BigNumber, BigNumber": function(a, l) {
      return new s(a.toNumber(), l.toNumber());
    },
    Fraction: function(a) {
      return new s(a.valueOf(), 0);
    },
    Complex: function(a) {
      return a.clone();
    },
    string: function(a) {
      return s(a);
    },
    null: function(a) {
      return s(0);
    },
    Object: function(a) {
      if ("re" in a && "im" in a)
        return new s(a.re, a.im);
      if ("r" in a && "phi" in a || "abs" in a && "arg" in a)
        return new s(a);
      throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
    },
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
}), name$U = "fraction", dependencies$U = ["typed", "Fraction"], createFraction = /* @__PURE__ */ factory(name$U, dependencies$U, (r) => {
  var {
    typed: e,
    Fraction: s
  } = r;
  return e("fraction", {
    number: function(a) {
      if (!isFinite(a) || isNaN(a))
        throw new Error(a + " cannot be represented as a fraction");
      return new s(a);
    },
    string: function(a) {
      return new s(a);
    },
    "number, number": function(a, l) {
      return new s(a, l);
    },
    "bigint, bigint": function(a, l) {
      return new s(a, l);
    },
    null: function(a) {
      return new s(0);
    },
    BigNumber: function(a) {
      return new s(a.toString());
    },
    bigint: function(a) {
      return new s(a.toString());
    },
    Fraction: function(a) {
      return a;
    },
    Unit: e.referToSelf((o) => (a) => {
      var l = a.clone();
      return l.value = o(a.value), l;
    }),
    Object: function(a) {
      return new s(a);
    },
    "Array | Matrix": e.referToSelf((o) => (a) => deepMap(a, o))
  });
}), name$T = "matrix", dependencies$T = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], createMatrix = /* @__PURE__ */ factory(name$T, dependencies$T, (r) => {
  var {
    typed: e,
    Matrix: s,
    DenseMatrix: o,
    SparseMatrix: a
  } = r;
  return e(name$T, {
    "": function() {
      return l([]);
    },
    string: function(c) {
      return l([], c);
    },
    "string, string": function(c, E) {
      return l([], c, E);
    },
    Array: function(c) {
      return l(c);
    },
    Matrix: function(c) {
      return l(c, c.storage());
    },
    "Array | Matrix, string": l,
    "Array | Matrix, string, string": l
  });
  function l(u, c, E) {
    if (c === "dense" || c === "default" || c === void 0)
      return new o(u, E);
    if (c === "sparse")
      return new a(u, E);
    throw new TypeError("Unknown matrix type " + JSON.stringify(c) + ".");
  }
}), name$S = "matrixFromColumns", dependencies$S = ["typed", "matrix", "flatten", "size"], createMatrixFromColumns = /* @__PURE__ */ factory(name$S, dependencies$S, (r) => {
  var {
    typed: e,
    matrix: s,
    flatten: o,
    size: a
  } = r;
  return e(name$S, {
    "...Array": function(E) {
      return l(E);
    },
    "...Matrix": function(E) {
      return s(l(E.map((d) => d.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function l(c) {
    if (c.length === 0)
      throw new TypeError("At least one column is needed to construct a matrix.");
    for (var E = u(c[0]), d = [], f = 0; f < E; f++)
      d[f] = [];
    for (var h of c) {
      var S = u(h);
      if (S !== E)
        throw new TypeError("The vectors had different length: " + (E | 0) + " ≠ " + (S | 0));
      for (var R = o(h), _ = 0; _ < E; _++)
        d[_].push(R[_]);
    }
    return d;
  }
  function u(c) {
    var E = a(c);
    if (E.length === 1)
      return E[0];
    if (E.length === 2) {
      if (E[0] === 1)
        return E[1];
      if (E[1] === 1)
        return E[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), name$R = "unaryMinus", dependencies$R = ["typed"], createUnaryMinus = /* @__PURE__ */ factory(name$R, dependencies$R, (r) => {
  var {
    typed: e
  } = r;
  return e(name$R, {
    number: unaryMinusNumber,
    "Complex | BigNumber | Fraction": (s) => s.neg(),
    bigint: (s) => -s,
    Unit: e.referToSelf((s) => (o) => {
      var a = o.clone();
      return a.value = e.find(s, a.valueType())(o.value), a;
    }),
    // deep map collection, skip zeros since unaryMinus(0) = 0
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s, !0))
    // TODO: add support for string
  });
}), name$Q = "abs", dependencies$Q = ["typed"], createAbs = /* @__PURE__ */ factory(name$Q, dependencies$Q, (r) => {
  var {
    typed: e
  } = r;
  return e(name$Q, {
    number: absNumber,
    "Complex | BigNumber | Fraction | Unit": (s) => s.abs(),
    bigint: (s) => s < 0n ? -s : s,
    // deep map collection, skip zeros since abs(0) = 0
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s, !0))
  });
}), name$P = "addScalar", dependencies$P = ["typed"], createAddScalar = /* @__PURE__ */ factory(name$P, dependencies$P, (r) => {
  var {
    typed: e
  } = r;
  return e(name$P, {
    "number, number": addNumber,
    "Complex, Complex": function(o, a) {
      return o.add(a);
    },
    "BigNumber, BigNumber": function(o, a) {
      return o.plus(a);
    },
    "bigint, bigint": function(o, a) {
      return o + a;
    },
    "Fraction, Fraction": function(o, a) {
      return o.add(a);
    },
    "Unit, Unit": e.referToSelf((s) => (o, a) => {
      if (o.value === null || o.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!o.equalBase(a))
        throw new Error("Units do not match");
      var l = o.clone();
      return l.value = e.find(s, [l.valueType(), a.valueType()])(l.value, a.value), l.fixPrefix = !1, l;
    })
  });
}), name$O = "subtractScalar", dependencies$O = ["typed"], createSubtractScalar = /* @__PURE__ */ factory(name$O, dependencies$O, (r) => {
  var {
    typed: e
  } = r;
  return e(name$O, {
    "number, number": subtractNumber,
    "Complex, Complex": function(o, a) {
      return o.sub(a);
    },
    "BigNumber, BigNumber": function(o, a) {
      return o.minus(a);
    },
    "bigint, bigint": function(o, a) {
      return o - a;
    },
    "Fraction, Fraction": function(o, a) {
      return o.sub(a);
    },
    "Unit, Unit": e.referToSelf((s) => (o, a) => {
      if (o.value === null || o.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (a.value === null || a.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!o.equalBase(a))
        throw new Error("Units do not match");
      var l = o.clone();
      return l.value = e.find(s, [l.valueType(), a.valueType()])(l.value, a.value), l.fixPrefix = !1, l;
    })
  });
}), name$N = "matAlgo11xS0s", dependencies$N = ["typed", "equalScalar"], createMatAlgo11xS0s = /* @__PURE__ */ factory(name$N, dependencies$N, (r) => {
  var {
    typed: e,
    equalScalar: s
  } = r;
  return function(a, l, u, c) {
    var E = a._values, d = a._index, f = a._ptr, h = a._size, S = a._datatype;
    if (!E)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var R = h[0], _ = h[1], m, L = s, F = 0, W = u;
    typeof S == "string" && (m = S, L = e.find(s, [m, m]), F = e.convert(0, m), l = e.convert(l, m), W = e.find(u, [m, m]));
    for (var G = [], q = [], fe = [], _e = 0; _e < _; _e++) {
      fe[_e] = q.length;
      for (var Le = f[_e], Fe = f[_e + 1], Ee = Le; Ee < Fe; Ee++) {
        var Ge = d[Ee], ve = c ? W(l, E[Ee]) : W(E[Ee], l);
        L(ve, F) || (q.push(Ge), G.push(ve));
      }
    }
    return fe[_] = q.length, a.createSparseMatrix({
      values: G,
      index: q,
      ptr: fe,
      size: [R, _],
      datatype: m
    });
  };
}), name$M = "matAlgo12xSfs", dependencies$M = ["typed", "DenseMatrix"], createMatAlgo12xSfs = /* @__PURE__ */ factory(name$M, dependencies$M, (r) => {
  var {
    typed: e,
    DenseMatrix: s
  } = r;
  return function(a, l, u, c) {
    var E = a._values, d = a._index, f = a._ptr, h = a._size, S = a._datatype;
    if (!E)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var R = h[0], _ = h[1], m, L = u;
    typeof S == "string" && (m = S, l = e.convert(l, m), L = e.find(u, [m, m]));
    for (var F = [], W = [], G = [], q = 0; q < _; q++) {
      for (var fe = q + 1, _e = f[q], Le = f[q + 1], Fe = _e; Fe < Le; Fe++) {
        var Ee = d[Fe];
        W[Ee] = E[Fe], G[Ee] = fe;
      }
      for (var Ge = 0; Ge < R; Ge++)
        q === 0 && (F[Ge] = []), G[Ge] === fe ? F[Ge][q] = c ? L(l, W[Ge]) : L(W[Ge], l) : F[Ge][q] = c ? L(l, 0) : L(0, l);
    }
    return new s({
      data: F,
      size: [R, _],
      datatype: m
    });
  };
}), name$L = "matAlgo14xDs", dependencies$L = ["typed"], createMatAlgo14xDs = /* @__PURE__ */ factory(name$L, dependencies$L, (r) => {
  var {
    typed: e
  } = r;
  return function(a, l, u, c) {
    var E = a._data, d = a._size, f = a._datatype, h, S = u;
    typeof f == "string" && (h = f, l = e.convert(l, h), S = e.find(u, [h, h]));
    var R = d.length > 0 ? s(S, 0, d, d[0], E, l, c) : [];
    return a.createDenseMatrix({
      data: R,
      size: clone$2(d),
      datatype: h
    });
  };
  function s(o, a, l, u, c, E, d) {
    var f = [];
    if (a === l.length - 1)
      for (var h = 0; h < u; h++)
        f[h] = d ? o(E, c[h]) : o(c[h], E);
    else
      for (var S = 0; S < u; S++)
        f[S] = s(o, a + 1, l, l[a + 1], c[S], E, d);
    return f;
  }
}), name$K = "matAlgo03xDSf", dependencies$K = ["typed"], createMatAlgo03xDSf = /* @__PURE__ */ factory(name$K, dependencies$K, (r) => {
  var {
    typed: e
  } = r;
  return function(o, a, l, u) {
    var c = o._data, E = o._size, d = o._datatype || o.getDataType(), f = a._values, h = a._index, S = a._ptr, R = a._size, _ = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (E.length !== R.length)
      throw new DimensionError(E.length, R.length);
    if (E[0] !== R[0] || E[1] !== R[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + E + ") must match Matrix B (" + R + ")");
    if (!f)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m = E[0], L = E[1], F, W = 0, G = l;
    typeof d == "string" && d === _ && d !== "mixed" && (F = d, W = e.convert(0, F), G = e.find(l, [F, F]));
    for (var q = [], fe = 0; fe < m; fe++)
      q[fe] = [];
    for (var _e = [], Le = [], Fe = 0; Fe < L; Fe++) {
      for (var Ee = Fe + 1, Ge = S[Fe], ve = S[Fe + 1], te = Ge; te < ve; te++) {
        var ae = h[te];
        _e[ae] = u ? G(f[te], c[ae][Fe]) : G(c[ae][Fe], f[te]), Le[ae] = Ee;
      }
      for (var v = 0; v < m; v++)
        Le[v] === Ee ? q[v][Fe] = _e[v] : q[v][Fe] = u ? G(W, c[v][Fe]) : G(c[v][Fe], W);
    }
    return o.createDenseMatrix({
      data: q,
      size: [m, L],
      datatype: d === o._datatype && _ === a._datatype ? F : void 0
    });
  };
}), name$J = "matAlgo05xSfSf", dependencies$J = ["typed", "equalScalar"], createMatAlgo05xSfSf = /* @__PURE__ */ factory(name$J, dependencies$J, (r) => {
  var {
    typed: e,
    equalScalar: s
  } = r;
  return function(a, l, u) {
    var c = a._values, E = a._index, d = a._ptr, f = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), S = l._values, R = l._index, _ = l._ptr, m = l._size, L = l._datatype || l._data === void 0 ? l._datatype : l.getDataType();
    if (f.length !== m.length)
      throw new DimensionError(f.length, m.length);
    if (f[0] !== m[0] || f[1] !== m[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + m + ")");
    var F = f[0], W = f[1], G, q = s, fe = 0, _e = u;
    typeof h == "string" && h === L && h !== "mixed" && (G = h, q = e.find(s, [G, G]), fe = e.convert(0, G), _e = e.find(u, [G, G]));
    var Le = c && S ? [] : void 0, Fe = [], Ee = [], Ge = Le ? [] : void 0, ve = Le ? [] : void 0, te = [], ae = [], v, Te, De, be;
    for (Te = 0; Te < W; Te++) {
      Ee[Te] = Fe.length;
      var ze = Te + 1;
      for (De = d[Te], be = d[Te + 1]; De < be; De++)
        v = E[De], Fe.push(v), te[v] = ze, Ge && (Ge[v] = c[De]);
      for (De = _[Te], be = _[Te + 1]; De < be; De++)
        v = R[De], te[v] !== ze && Fe.push(v), ae[v] = ze, ve && (ve[v] = S[De]);
      if (Le)
        for (De = Ee[Te]; De < Fe.length; ) {
          v = Fe[De];
          var ke = te[v], Be = ae[v];
          if (ke === ze || Be === ze) {
            var Me = ke === ze ? Ge[v] : fe, me = Be === ze ? ve[v] : fe, Se = _e(Me, me);
            q(Se, fe) ? Fe.splice(De, 1) : (Le.push(Se), De++);
          }
        }
    }
    return Ee[W] = Fe.length, a.createSparseMatrix({
      values: Le,
      index: Fe,
      ptr: Ee,
      size: [F, W],
      datatype: h === a._datatype && L === l._datatype ? G : void 0
    });
  };
}), name$I = "matAlgo13xDD", dependencies$I = ["typed"], createMatAlgo13xDD = /* @__PURE__ */ factory(name$I, dependencies$I, (r) => {
  var {
    typed: e
  } = r;
  return function(a, l, u) {
    var c = a._data, E = a._size, d = a._datatype, f = l._data, h = l._size, S = l._datatype, R = [];
    if (E.length !== h.length)
      throw new DimensionError(E.length, h.length);
    for (var _ = 0; _ < E.length; _++) {
      if (E[_] !== h[_])
        throw new RangeError("Dimension mismatch. Matrix A (" + E + ") must match Matrix B (" + h + ")");
      R[_] = E[_];
    }
    var m, L = u;
    typeof d == "string" && d === S && (m = d, L = e.find(u, [m, m]));
    var F = R.length > 0 ? s(L, 0, R, R[0], c, f) : [];
    return a.createDenseMatrix({
      data: F,
      size: R,
      datatype: m
    });
  };
  function s(o, a, l, u, c, E) {
    var d = [];
    if (a === l.length - 1)
      for (var f = 0; f < u; f++)
        d[f] = o(c[f], E[f]);
    else
      for (var h = 0; h < u; h++)
        d[h] = s(o, a + 1, l, l[a + 1], c[h], E[h]);
    return d;
  }
});
function broadcast(r, e) {
  if (deepStrictEqual(r.size(), e.size()))
    return [r, e];
  var s = broadcastSizes(r.size(), e.size());
  return [r, e].map((o) => _broadcastTo(o, s));
}
function _broadcastTo(r, e) {
  return deepStrictEqual(r.size(), e) ? r : r.create(broadcastTo(r.valueOf(), e), r.datatype());
}
var name$H = "matrixAlgorithmSuite", dependencies$H = ["typed", "matrix"], createMatrixAlgorithmSuite = /* @__PURE__ */ factory(name$H, dependencies$H, (r) => {
  var {
    typed: e,
    matrix: s
  } = r, o = createMatAlgo13xDD({
    typed: e
  }), a = createMatAlgo14xDs({
    typed: e
  });
  return function(u) {
    var c = u.elop, E = u.SD || u.DS, d;
    c ? (d = {
      "DenseMatrix, DenseMatrix": (R, _) => o(...broadcast(R, _), c),
      "Array, Array": (R, _) => o(...broadcast(s(R), s(_)), c).valueOf(),
      "Array, DenseMatrix": (R, _) => o(...broadcast(s(R), _), c),
      "DenseMatrix, Array": (R, _) => o(...broadcast(R, s(_)), c)
    }, u.SS && (d["SparseMatrix, SparseMatrix"] = (R, _) => u.SS(...broadcast(R, _), c, !1)), u.DS && (d["DenseMatrix, SparseMatrix"] = (R, _) => u.DS(...broadcast(R, _), c, !1), d["Array, SparseMatrix"] = (R, _) => u.DS(...broadcast(s(R), _), c, !1)), E && (d["SparseMatrix, DenseMatrix"] = (R, _) => E(...broadcast(_, R), c, !0), d["SparseMatrix, Array"] = (R, _) => E(...broadcast(s(_), R), c, !0))) : (d = {
      "DenseMatrix, DenseMatrix": e.referToSelf((R) => (_, m) => o(...broadcast(_, m), R)),
      "Array, Array": e.referToSelf((R) => (_, m) => o(...broadcast(s(_), s(m)), R).valueOf()),
      "Array, DenseMatrix": e.referToSelf((R) => (_, m) => o(...broadcast(s(_), m), R)),
      "DenseMatrix, Array": e.referToSelf((R) => (_, m) => o(...broadcast(_, s(m)), R))
    }, u.SS && (d["SparseMatrix, SparseMatrix"] = e.referToSelf((R) => (_, m) => u.SS(...broadcast(_, m), R, !1))), u.DS && (d["DenseMatrix, SparseMatrix"] = e.referToSelf((R) => (_, m) => u.DS(...broadcast(_, m), R, !1)), d["Array, SparseMatrix"] = e.referToSelf((R) => (_, m) => u.DS(...broadcast(s(_), m), R, !1))), E && (d["SparseMatrix, DenseMatrix"] = e.referToSelf((R) => (_, m) => E(...broadcast(m, _), R, !0)), d["SparseMatrix, Array"] = e.referToSelf((R) => (_, m) => E(...broadcast(s(m), _), R, !0))));
    var f = u.scalar || "any", h = u.Ds || u.Ss;
    h && (c ? (d["DenseMatrix," + f] = (R, _) => a(R, _, c, !1), d[f + ", DenseMatrix"] = (R, _) => a(_, R, c, !0), d["Array," + f] = (R, _) => a(s(R), _, c, !1).valueOf(), d[f + ", Array"] = (R, _) => a(s(_), R, c, !0).valueOf()) : (d["DenseMatrix," + f] = e.referToSelf((R) => (_, m) => a(_, m, R, !1)), d[f + ", DenseMatrix"] = e.referToSelf((R) => (_, m) => a(m, _, R, !0)), d["Array," + f] = e.referToSelf((R) => (_, m) => a(s(_), m, R, !1).valueOf()), d[f + ", Array"] = e.referToSelf((R) => (_, m) => a(s(m), _, R, !0).valueOf())));
    var S = u.sS !== void 0 ? u.sS : u.Ss;
    return c ? (u.Ss && (d["SparseMatrix," + f] = (R, _) => u.Ss(R, _, c, !1)), S && (d[f + ", SparseMatrix"] = (R, _) => S(_, R, c, !0))) : (u.Ss && (d["SparseMatrix," + f] = e.referToSelf((R) => (_, m) => u.Ss(_, m, R, !1))), S && (d[f + ", SparseMatrix"] = e.referToSelf((R) => (_, m) => S(m, _, R, !0)))), c && c.signatures && extend$1(d, c.signatures), d;
  };
}), name$G = "matAlgo01xDSid", dependencies$G = ["typed"], createMatAlgo01xDSid = /* @__PURE__ */ factory(name$G, dependencies$G, (r) => {
  var {
    typed: e
  } = r;
  return function(o, a, l, u) {
    var c = o._data, E = o._size, d = o._datatype || o.getDataType(), f = a._values, h = a._index, S = a._ptr, R = a._size, _ = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (E.length !== R.length)
      throw new DimensionError(E.length, R.length);
    if (E[0] !== R[0] || E[1] !== R[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + E + ") must match Matrix B (" + R + ")");
    if (!f)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m = E[0], L = E[1], F = typeof d == "string" && d !== "mixed" && d === _ ? d : void 0, W = F ? e.find(l, [F, F]) : l, G, q, fe = [];
    for (G = 0; G < m; G++)
      fe[G] = [];
    var _e = [], Le = [];
    for (q = 0; q < L; q++) {
      for (var Fe = q + 1, Ee = S[q], Ge = S[q + 1], ve = Ee; ve < Ge; ve++)
        G = h[ve], _e[G] = u ? W(f[ve], c[G][q]) : W(c[G][q], f[ve]), Le[G] = Fe;
      for (G = 0; G < m; G++)
        Le[G] === Fe ? fe[G][q] = _e[G] : fe[G][q] = c[G][q];
    }
    return o.createDenseMatrix({
      data: fe,
      size: [m, L],
      datatype: d === o._datatype && _ === a._datatype ? F : void 0
    });
  };
}), name$F = "matAlgo04xSidSid", dependencies$F = ["typed", "equalScalar"], createMatAlgo04xSidSid = /* @__PURE__ */ factory(name$F, dependencies$F, (r) => {
  var {
    typed: e,
    equalScalar: s
  } = r;
  return function(a, l, u) {
    var c = a._values, E = a._index, d = a._ptr, f = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), S = l._values, R = l._index, _ = l._ptr, m = l._size, L = l._datatype || l._data === void 0 ? l._datatype : l.getDataType();
    if (f.length !== m.length)
      throw new DimensionError(f.length, m.length);
    if (f[0] !== m[0] || f[1] !== m[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + m + ")");
    var F = f[0], W = f[1], G, q = s, fe = 0, _e = u;
    typeof h == "string" && h === L && h !== "mixed" && (G = h, q = e.find(s, [G, G]), fe = e.convert(0, G), _e = e.find(u, [G, G]));
    var Le = c && S ? [] : void 0, Fe = [], Ee = [], Ge = c && S ? [] : void 0, ve = c && S ? [] : void 0, te = [], ae = [], v, Te, De, be, ze;
    for (Te = 0; Te < W; Te++) {
      Ee[Te] = Fe.length;
      var ke = Te + 1;
      for (be = d[Te], ze = d[Te + 1], De = be; De < ze; De++)
        v = E[De], Fe.push(v), te[v] = ke, Ge && (Ge[v] = c[De]);
      for (be = _[Te], ze = _[Te + 1], De = be; De < ze; De++)
        if (v = R[De], te[v] === ke) {
          if (Ge) {
            var Be = _e(Ge[v], S[De]);
            q(Be, fe) ? te[v] = null : Ge[v] = Be;
          }
        } else
          Fe.push(v), ae[v] = ke, ve && (ve[v] = S[De]);
      if (Ge && ve)
        for (De = Ee[Te]; De < Fe.length; )
          v = Fe[De], te[v] === ke ? (Le[De] = Ge[v], De++) : ae[v] === ke ? (Le[De] = ve[v], De++) : Fe.splice(De, 1);
    }
    return Ee[W] = Fe.length, a.createSparseMatrix({
      values: Le,
      index: Fe,
      ptr: Ee,
      size: [F, W],
      datatype: h === a._datatype && L === l._datatype ? G : void 0
    });
  };
}), name$E = "matAlgo10xSids", dependencies$E = ["typed", "DenseMatrix"], createMatAlgo10xSids = /* @__PURE__ */ factory(name$E, dependencies$E, (r) => {
  var {
    typed: e,
    DenseMatrix: s
  } = r;
  return function(a, l, u, c) {
    var E = a._values, d = a._index, f = a._ptr, h = a._size, S = a._datatype;
    if (!E)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var R = h[0], _ = h[1], m, L = u;
    typeof S == "string" && (m = S, l = e.convert(l, m), L = e.find(u, [m, m]));
    for (var F = [], W = [], G = [], q = 0; q < _; q++) {
      for (var fe = q + 1, _e = f[q], Le = f[q + 1], Fe = _e; Fe < Le; Fe++) {
        var Ee = d[Fe];
        W[Ee] = E[Fe], G[Ee] = fe;
      }
      for (var Ge = 0; Ge < R; Ge++)
        q === 0 && (F[Ge] = []), G[Ge] === fe ? F[Ge][q] = c ? L(l, W[Ge]) : L(W[Ge], l) : F[Ge][q] = l;
    }
    return new s({
      data: F,
      size: [R, _],
      datatype: m
    });
  };
}), name$D = "multiplyScalar", dependencies$D = ["typed"], createMultiplyScalar = /* @__PURE__ */ factory(name$D, dependencies$D, (r) => {
  var {
    typed: e
  } = r;
  return e("multiplyScalar", {
    "number, number": multiplyNumber,
    "Complex, Complex": function(o, a) {
      return o.mul(a);
    },
    "BigNumber, BigNumber": function(o, a) {
      return o.times(a);
    },
    "bigint, bigint": function(o, a) {
      return o * a;
    },
    "Fraction, Fraction": function(o, a) {
      return o.mul(a);
    },
    "number | Fraction | BigNumber | Complex, Unit": (s, o) => o.multiply(s),
    "Unit, number | Fraction | BigNumber | Complex | Unit": (s, o) => s.multiply(o)
  });
}), name$C = "multiply", dependencies$C = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], createMultiply = /* @__PURE__ */ factory(name$C, dependencies$C, (r) => {
  var {
    typed: e,
    matrix: s,
    addScalar: o,
    multiplyScalar: a,
    equalScalar: l,
    dot: u
  } = r, c = createMatAlgo11xS0s({
    typed: e,
    equalScalar: l
  }), E = createMatAlgo14xDs({
    typed: e
  });
  function d(fe, _e) {
    switch (fe.length) {
      case 1:
        switch (_e.length) {
          case 1:
            if (fe[0] !== _e[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (fe[0] !== _e[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + fe[0] + ") must match Matrix rows (" + _e[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + _e.length + " dimensions)");
        }
        break;
      case 2:
        switch (_e.length) {
          case 1:
            if (fe[1] !== _e[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + fe[1] + ") must match Vector length (" + _e[0] + ")");
            break;
          case 2:
            if (fe[1] !== _e[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + fe[1] + ") must match Matrix B rows (" + _e[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + _e.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + fe.length + " dimensions)");
    }
  }
  function f(fe, _e, Le) {
    if (Le === 0)
      throw new Error("Cannot multiply two empty vectors");
    return u(fe, _e);
  }
  function h(fe, _e) {
    if (_e.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return S(fe, _e);
  }
  function S(fe, _e) {
    var Le = fe._data, Fe = fe._size, Ee = fe._datatype || fe.getDataType(), Ge = _e._data, ve = _e._size, te = _e._datatype || _e.getDataType(), ae = Fe[0], v = ve[1], Te, De = o, be = a;
    Ee && te && Ee === te && typeof Ee == "string" && Ee !== "mixed" && (Te = Ee, De = e.find(o, [Te, Te]), be = e.find(a, [Te, Te]));
    for (var ze = [], ke = 0; ke < v; ke++) {
      for (var Be = be(Le[0], Ge[0][ke]), Me = 1; Me < ae; Me++)
        Be = De(Be, be(Le[Me], Ge[Me][ke]));
      ze[ke] = Be;
    }
    return fe.createDenseMatrix({
      data: ze,
      size: [v],
      datatype: Ee === fe._datatype && te === _e._datatype ? Te : void 0
    });
  }
  var R = e("_multiplyMatrixVector", {
    "DenseMatrix, any": m,
    "SparseMatrix, any": W
  }), _ = e("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": L,
    "DenseMatrix, SparseMatrix": F,
    "SparseMatrix, DenseMatrix": G,
    "SparseMatrix, SparseMatrix": q
  });
  function m(fe, _e) {
    var Le = fe._data, Fe = fe._size, Ee = fe._datatype || fe.getDataType(), Ge = _e._data, ve = _e._datatype || _e.getDataType(), te = Fe[0], ae = Fe[1], v, Te = o, De = a;
    Ee && ve && Ee === ve && typeof Ee == "string" && Ee !== "mixed" && (v = Ee, Te = e.find(o, [v, v]), De = e.find(a, [v, v]));
    for (var be = [], ze = 0; ze < te; ze++) {
      for (var ke = Le[ze], Be = De(ke[0], Ge[0]), Me = 1; Me < ae; Me++)
        Be = Te(Be, De(ke[Me], Ge[Me]));
      be[ze] = Be;
    }
    return fe.createDenseMatrix({
      data: be,
      size: [te],
      datatype: Ee === fe._datatype && ve === _e._datatype ? v : void 0
    });
  }
  function L(fe, _e) {
    var Le = fe._data, Fe = fe._size, Ee = fe._datatype || fe.getDataType(), Ge = _e._data, ve = _e._size, te = _e._datatype || _e.getDataType(), ae = Fe[0], v = Fe[1], Te = ve[1], De, be = o, ze = a;
    Ee && te && Ee === te && typeof Ee == "string" && Ee !== "mixed" && Ee !== "mixed" && (De = Ee, be = e.find(o, [De, De]), ze = e.find(a, [De, De]));
    for (var ke = [], Be = 0; Be < ae; Be++) {
      var Me = Le[Be];
      ke[Be] = [];
      for (var me = 0; me < Te; me++) {
        for (var Se = ze(Me[0], Ge[0][me]), xt = 1; xt < v; xt++)
          Se = be(Se, ze(Me[xt], Ge[xt][me]));
        ke[Be][me] = Se;
      }
    }
    return fe.createDenseMatrix({
      data: ke,
      size: [ae, Te],
      datatype: Ee === fe._datatype && te === _e._datatype ? De : void 0
    });
  }
  function F(fe, _e) {
    var Le = fe._data, Fe = fe._size, Ee = fe._datatype || fe.getDataType(), Ge = _e._values, ve = _e._index, te = _e._ptr, ae = _e._size, v = _e._datatype || _e._data === void 0 ? _e._datatype : _e.getDataType();
    if (!Ge)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var Te = Fe[0], De = ae[1], be, ze = o, ke = a, Be = l, Me = 0;
    Ee && v && Ee === v && typeof Ee == "string" && Ee !== "mixed" && (be = Ee, ze = e.find(o, [be, be]), ke = e.find(a, [be, be]), Be = e.find(l, [be, be]), Me = e.convert(0, be));
    for (var me = [], Se = [], xt = [], Ht = _e.createSparseMatrix({
      values: me,
      index: Se,
      ptr: xt,
      size: [Te, De],
      datatype: Ee === fe._datatype && v === _e._datatype ? be : void 0
    }), Bt = 0; Bt < De; Bt++) {
      xt[Bt] = Se.length;
      var ut = te[Bt], Tt = te[Bt + 1];
      if (Tt > ut)
        for (var Yt = 0, an = 0; an < Te; an++) {
          for (var Ct = an + 1, st = void 0, jt = ut; jt < Tt; jt++) {
            var lt = ve[jt];
            Yt !== Ct ? (st = ke(Le[an][lt], Ge[jt]), Yt = Ct) : st = ze(st, ke(Le[an][lt], Ge[jt]));
          }
          Yt === Ct && !Be(st, Me) && (Se.push(an), me.push(st));
        }
    }
    return xt[De] = Se.length, Ht;
  }
  function W(fe, _e) {
    var Le = fe._values, Fe = fe._index, Ee = fe._ptr, Ge = fe._datatype || fe._data === void 0 ? fe._datatype : fe.getDataType();
    if (!Le)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var ve = _e._data, te = _e._datatype || _e.getDataType(), ae = fe._size[0], v = _e._size[0], Te = [], De = [], be = [], ze, ke = o, Be = a, Me = l, me = 0;
    Ge && te && Ge === te && typeof Ge == "string" && Ge !== "mixed" && (ze = Ge, ke = e.find(o, [ze, ze]), Be = e.find(a, [ze, ze]), Me = e.find(l, [ze, ze]), me = e.convert(0, ze));
    var Se = [], xt = [];
    be[0] = 0;
    for (var Ht = 0; Ht < v; Ht++) {
      var Bt = ve[Ht];
      if (!Me(Bt, me))
        for (var ut = Ee[Ht], Tt = Ee[Ht + 1], Yt = ut; Yt < Tt; Yt++) {
          var an = Fe[Yt];
          xt[an] ? Se[an] = ke(Se[an], Be(Bt, Le[Yt])) : (xt[an] = !0, De.push(an), Se[an] = Be(Bt, Le[Yt]));
        }
    }
    for (var Ct = De.length, st = 0; st < Ct; st++) {
      var jt = De[st];
      Te[st] = Se[jt];
    }
    return be[1] = De.length, fe.createSparseMatrix({
      values: Te,
      index: De,
      ptr: be,
      size: [ae, 1],
      datatype: Ge === fe._datatype && te === _e._datatype ? ze : void 0
    });
  }
  function G(fe, _e) {
    var Le = fe._values, Fe = fe._index, Ee = fe._ptr, Ge = fe._datatype || fe._data === void 0 ? fe._datatype : fe.getDataType();
    if (!Le)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var ve = _e._data, te = _e._datatype || _e.getDataType(), ae = fe._size[0], v = _e._size[0], Te = _e._size[1], De, be = o, ze = a, ke = l, Be = 0;
    Ge && te && Ge === te && typeof Ge == "string" && Ge !== "mixed" && (De = Ge, be = e.find(o, [De, De]), ze = e.find(a, [De, De]), ke = e.find(l, [De, De]), Be = e.convert(0, De));
    for (var Me = [], me = [], Se = [], xt = fe.createSparseMatrix({
      values: Me,
      index: me,
      ptr: Se,
      size: [ae, Te],
      datatype: Ge === fe._datatype && te === _e._datatype ? De : void 0
    }), Ht = [], Bt = [], ut = 0; ut < Te; ut++) {
      Se[ut] = me.length;
      for (var Tt = ut + 1, Yt = 0; Yt < v; Yt++) {
        var an = ve[Yt][ut];
        if (!ke(an, Be))
          for (var Ct = Ee[Yt], st = Ee[Yt + 1], jt = Ct; jt < st; jt++) {
            var lt = Fe[jt];
            Bt[lt] !== Tt ? (Bt[lt] = Tt, me.push(lt), Ht[lt] = ze(an, Le[jt])) : Ht[lt] = be(Ht[lt], ze(an, Le[jt]));
          }
      }
      for (var Zt = Se[ut], Et = me.length, Ke = Zt; Ke < Et; Ke++) {
        var $e = me[Ke];
        Me[Ke] = Ht[$e];
      }
    }
    return Se[Te] = me.length, xt;
  }
  function q(fe, _e) {
    var Le = fe._values, Fe = fe._index, Ee = fe._ptr, Ge = fe._datatype || fe._data === void 0 ? fe._datatype : fe.getDataType(), ve = _e._values, te = _e._index, ae = _e._ptr, v = _e._datatype || _e._data === void 0 ? _e._datatype : _e.getDataType(), Te = fe._size[0], De = _e._size[1], be = Le && ve, ze, ke = o, Be = a;
    Ge && v && Ge === v && typeof Ge == "string" && Ge !== "mixed" && (ze = Ge, ke = e.find(o, [ze, ze]), Be = e.find(a, [ze, ze]));
    for (var Me = be ? [] : void 0, me = [], Se = [], xt = fe.createSparseMatrix({
      values: Me,
      index: me,
      ptr: Se,
      size: [Te, De],
      datatype: Ge === fe._datatype && v === _e._datatype ? ze : void 0
    }), Ht = be ? [] : void 0, Bt = [], ut, Tt, Yt, an, Ct, st, jt, lt, Zt = 0; Zt < De; Zt++) {
      Se[Zt] = me.length;
      var Et = Zt + 1;
      for (Ct = ae[Zt], st = ae[Zt + 1], an = Ct; an < st; an++)
        if (lt = te[an], be)
          for (Tt = Ee[lt], Yt = Ee[lt + 1], ut = Tt; ut < Yt; ut++)
            jt = Fe[ut], Bt[jt] !== Et ? (Bt[jt] = Et, me.push(jt), Ht[jt] = Be(ve[an], Le[ut])) : Ht[jt] = ke(Ht[jt], Be(ve[an], Le[ut]));
        else
          for (Tt = Ee[lt], Yt = Ee[lt + 1], ut = Tt; ut < Yt; ut++)
            jt = Fe[ut], Bt[jt] !== Et && (Bt[jt] = Et, me.push(jt));
      if (be)
        for (var Ke = Se[Zt], $e = me.length, pt = Ke; pt < $e; pt++) {
          var Jt = me[pt];
          Me[pt] = Ht[Jt];
        }
    }
    return Se[De] = me.length, xt;
  }
  return e(name$C, a, {
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": e.referTo("Matrix, Matrix", (fe) => (_e, Le) => {
      d(arraySize(_e), arraySize(Le));
      var Fe = fe(s(_e), s(Le));
      return isMatrix(Fe) ? Fe.valueOf() : Fe;
    }),
    "Matrix, Matrix": function(_e, Le) {
      var Fe = _e.size(), Ee = Le.size();
      return d(Fe, Ee), Fe.length === 1 ? Ee.length === 1 ? f(_e, Le, Fe[0]) : h(_e, Le) : Ee.length === 1 ? R(_e, Le) : _(_e, Le);
    },
    "Matrix, Array": e.referTo("Matrix,Matrix", (fe) => (_e, Le) => fe(_e, s(Le))),
    "Array, Matrix": e.referToSelf((fe) => (_e, Le) => fe(s(_e, Le.storage()), Le)),
    "SparseMatrix, any": function(_e, Le) {
      return c(_e, Le, a, !1);
    },
    "DenseMatrix, any": function(_e, Le) {
      return E(_e, Le, a, !1);
    },
    "any, SparseMatrix": function(_e, Le) {
      return c(Le, _e, a, !0);
    },
    "any, DenseMatrix": function(_e, Le) {
      return E(Le, _e, a, !0);
    },
    "Array, any": function(_e, Le) {
      return E(s(_e), Le, a, !1).valueOf();
    },
    "any, Array": function(_e, Le) {
      return E(s(Le), _e, a, !0).valueOf();
    },
    "any, any": a,
    "any, any, ...any": e.referToSelf((fe) => (_e, Le, Fe) => {
      for (var Ee = fe(_e, Le), Ge = 0; Ge < Fe.length; Ge++)
        Ee = fe(Ee, Fe[Ge]);
      return Ee;
    })
  });
}), name$B = "sign", dependencies$B = ["typed", "BigNumber", "Fraction", "complex"], createSign = /* @__PURE__ */ factory(name$B, dependencies$B, (r) => {
  var {
    typed: e,
    BigNumber: s,
    complex: o,
    Fraction: a
  } = r;
  return e(name$B, {
    number: signNumber,
    Complex: function(u) {
      return u.im === 0 ? o(signNumber(u.re)) : u.sign();
    },
    BigNumber: function(u) {
      return new s(u.cmp(0));
    },
    bigint: function(u) {
      return u > 0n ? 1n : u < 0n ? -1n : 0n;
    },
    Fraction: function(u) {
      return new a(u.s);
    },
    // deep map collection, skip zeros since sign(0) = 0
    "Array | Matrix": e.referToSelf((l) => (u) => deepMap(u, l, !0)),
    Unit: e.referToSelf((l) => (u) => {
      if (!u._isDerived() && u.units[0].unit.offset !== 0)
        throw new TypeError("sign is ambiguous for units with offset");
      return e.find(l, u.valueType())(u.value);
    })
  });
}), name$A = "sqrt", dependencies$A = ["config", "typed", "Complex"], createSqrt = /* @__PURE__ */ factory(name$A, dependencies$A, (r) => {
  var {
    config: e,
    typed: s,
    Complex: o
  } = r;
  return s("sqrt", {
    number: a,
    Complex: function(u) {
      return u.sqrt();
    },
    BigNumber: function(u) {
      return !u.isNegative() || e.predictable ? u.sqrt() : a(u.toNumber());
    },
    Unit: function(u) {
      return u.pow(0.5);
    }
  });
  function a(l) {
    return isNaN(l) ? NaN : l >= 0 || e.predictable ? Math.sqrt(l) : new o(l, 0).sqrt();
  }
}), name$z = "subtract", dependencies$z = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], createSubtract = /* @__PURE__ */ factory(name$z, dependencies$z, (r) => {
  var {
    typed: e,
    matrix: s,
    equalScalar: o,
    subtractScalar: a,
    unaryMinus: l,
    DenseMatrix: u,
    concat: c
  } = r, E = createMatAlgo01xDSid({
    typed: e
  }), d = createMatAlgo03xDSf({
    typed: e
  }), f = createMatAlgo05xSfSf({
    typed: e,
    equalScalar: o
  }), h = createMatAlgo10xSids({
    typed: e,
    DenseMatrix: u
  }), S = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: u
  }), R = createMatrixAlgorithmSuite({
    typed: e,
    matrix: s,
    concat: c
  });
  return e(name$z, {
    "any, any": a
  }, R({
    elop: a,
    SS: f,
    DS: E,
    SD: d,
    Ss: S,
    sS: h
  }));
}), name$y = "matAlgo07xSSf", dependencies$y = ["typed", "SparseMatrix"], createMatAlgo07xSSf = /* @__PURE__ */ factory(name$y, dependencies$y, (r) => {
  var {
    typed: e,
    SparseMatrix: s
  } = r;
  return function(l, u, c) {
    var E = l._size, d = l._datatype || l._data === void 0 ? l._datatype : l.getDataType(), f = u._size, h = u._datatype || u._data === void 0 ? u._datatype : u.getDataType();
    if (E.length !== f.length)
      throw new DimensionError(E.length, f.length);
    if (E[0] !== f[0] || E[1] !== f[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + E + ") must match Matrix B (" + f + ")");
    var S = E[0], R = E[1], _, m = 0, L = c;
    typeof d == "string" && d === h && d !== "mixed" && (_ = d, m = e.convert(0, _), L = e.find(c, [_, _]));
    for (var F = [], W = [], G = new Array(R + 1).fill(0), q = [], fe = [], _e = [], Le = [], Fe = 0; Fe < R; Fe++) {
      var Ee = Fe + 1, Ge = 0;
      o(l, Fe, _e, q, Ee), o(u, Fe, Le, fe, Ee);
      for (var ve = 0; ve < S; ve++) {
        var te = _e[ve] === Ee ? q[ve] : m, ae = Le[ve] === Ee ? fe[ve] : m, v = L(te, ae);
        v !== 0 && v !== !1 && (W.push(ve), F.push(v), Ge++);
      }
      G[Fe + 1] = G[Fe] + Ge;
    }
    return new s({
      values: F,
      index: W,
      ptr: G,
      size: [S, R],
      datatype: d === l._datatype && h === u._datatype ? _ : void 0
    });
  };
  function o(a, l, u, c, E) {
    for (var d = a._values, f = a._index, h = a._ptr, S = h[l], R = h[l + 1]; S < R; S++) {
      var _ = f[S];
      u[_] = E, c[_] = d[S];
    }
  }
}), name$x = "conj", dependencies$x = ["typed"], createConj = /* @__PURE__ */ factory(name$x, dependencies$x, (r) => {
  var {
    typed: e
  } = r;
  return e(name$x, {
    "number | BigNumber | Fraction": (s) => s,
    Complex: (s) => s.conjugate(),
    Unit: e.referToSelf((s) => (o) => new o.constructor(s(o.toNumeric()), o.formatUnits())),
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s))
  });
}), name$w = "im", dependencies$w = ["typed"], createIm = /* @__PURE__ */ factory(name$w, dependencies$w, (r) => {
  var {
    typed: e
  } = r;
  return e(name$w, {
    number: () => 0,
    "BigNumber | Fraction": (s) => s.mul(0),
    Complex: (s) => s.im,
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s))
  });
}), name$v = "re", dependencies$v = ["typed"], createRe = /* @__PURE__ */ factory(name$v, dependencies$v, (r) => {
  var {
    typed: e
  } = r;
  return e(name$v, {
    "number | BigNumber | Fraction": (s) => s,
    Complex: (s) => s.re,
    "Array | Matrix": e.referToSelf((s) => (o) => deepMap(o, s))
  });
}), name$u = "concat", dependencies$u = ["typed", "matrix", "isInteger"], createConcat = /* @__PURE__ */ factory(name$u, dependencies$u, (r) => {
  var {
    typed: e,
    matrix: s,
    isInteger: o
  } = r;
  return e(name$u, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(l) {
      var u, c = l.length, E = -1, d, f = !1, h = [];
      for (u = 0; u < c; u++) {
        var S = l[u];
        if (isMatrix(S) && (f = !0), isNumber(S) || isBigNumber(S)) {
          if (u !== c - 1)
            throw new Error("Dimension must be specified as last argument");
          if (d = E, E = S.valueOf(), !o(E))
            throw new TypeError("Integer number expected for dimension");
          if (E < 0 || u > 0 && E > d)
            throw new IndexError(E, d + 1);
        } else {
          var R = clone$2(S).valueOf(), _ = arraySize(R);
          if (h[u] = R, d = E, E = _.length - 1, u > 0 && E !== d)
            throw new DimensionError(d + 1, E + 1);
        }
      }
      if (h.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var m = h.shift(); h.length; )
        m = concat$1(m, h.shift(), E);
      return f ? s(m) : m;
    },
    "...string": function(l) {
      return l.join("");
    }
  });
}), name$t = "column", dependencies$t = ["typed", "Index", "matrix", "range"], createColumn = /* @__PURE__ */ factory(name$t, dependencies$t, (r) => {
  var {
    typed: e,
    Index: s,
    matrix: o,
    range: a
  } = r;
  return e(name$t, {
    "Matrix, number": l,
    "Array, number": function(c, E) {
      return l(o(clone$2(c)), E).valueOf();
    }
  });
  function l(u, c) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    validateIndex(c, u.size()[1]);
    var E = a(0, u.size()[0]), d = new s(E, c), f = u.subset(d);
    return isMatrix(f) ? f : o([[f]]);
  }
}), name$s = "diag", dependencies$s = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], createDiag = /* @__PURE__ */ factory(name$s, dependencies$s, (r) => {
  var {
    typed: e,
    matrix: s,
    DenseMatrix: o,
    SparseMatrix: a
  } = r;
  return e(name$s, {
    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
    Array: function(d) {
      return l(d, 0, arraySize(d), null);
    },
    "Array, number": function(d, f) {
      return l(d, f, arraySize(d), null);
    },
    "Array, BigNumber": function(d, f) {
      return l(d, f.toNumber(), arraySize(d), null);
    },
    "Array, string": function(d, f) {
      return l(d, 0, arraySize(d), f);
    },
    "Array, number, string": function(d, f, h) {
      return l(d, f, arraySize(d), h);
    },
    "Array, BigNumber, string": function(d, f, h) {
      return l(d, f.toNumber(), arraySize(d), h);
    },
    Matrix: function(d) {
      return l(d, 0, d.size(), d.storage());
    },
    "Matrix, number": function(d, f) {
      return l(d, f, d.size(), d.storage());
    },
    "Matrix, BigNumber": function(d, f) {
      return l(d, f.toNumber(), d.size(), d.storage());
    },
    "Matrix, string": function(d, f) {
      return l(d, 0, d.size(), f);
    },
    "Matrix, number, string": function(d, f, h) {
      return l(d, f, d.size(), h);
    },
    "Matrix, BigNumber, string": function(d, f, h) {
      return l(d, f.toNumber(), d.size(), h);
    }
  });
  function l(E, d, f, h) {
    if (!isInteger$1(d))
      throw new TypeError("Second parameter in function diag must be an integer");
    var S = d > 0 ? d : 0, R = d < 0 ? -d : 0;
    switch (f.length) {
      case 1:
        return u(E, d, h, f[0], R, S);
      case 2:
        return c(E, d, h, f, R, S);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
  function u(E, d, f, h, S, R) {
    var _ = [h + S, h + R];
    if (f && f !== "sparse" && f !== "dense")
      throw new TypeError("Unknown matrix type ".concat(f, '"'));
    var m = f === "sparse" ? a.diagonal(_, E, d) : o.diagonal(_, E, d);
    return f !== null ? m : m.valueOf();
  }
  function c(E, d, f, h, S, R) {
    if (isMatrix(E)) {
      var _ = E.diagonal(d);
      return f !== null ? f !== _.storage() ? s(_, f) : _ : _.valueOf();
    }
    for (var m = Math.min(h[0] - S, h[1] - R), L = [], F = 0; F < m; F++)
      L[F] = E[F + S][F + R];
    return f !== null ? s(L) : L;
  }
}), name$r = "flatten", dependencies$r = ["typed"], createFlatten = /* @__PURE__ */ factory(name$r, dependencies$r, (r) => {
  var {
    typed: e
  } = r;
  return e(name$r, {
    Array: function(o) {
      return flatten$1(o);
    },
    Matrix: function(o) {
      return o.create(flatten$1(o.valueOf(), !0), o.datatype());
    }
  });
}), name$q = "getMatrixDataType", dependencies$q = ["typed"], createGetMatrixDataType = /* @__PURE__ */ factory(name$q, dependencies$q, (r) => {
  var {
    typed: e
  } = r;
  return e(name$q, {
    Array: function(o) {
      return getArrayDataType(o, typeOf);
    },
    Matrix: function(o) {
      return o.getDataType();
    }
  });
}), name$p = "identity", dependencies$p = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], createIdentity = /* @__PURE__ */ factory(name$p, dependencies$p, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o,
    BigNumber: a,
    DenseMatrix: l,
    SparseMatrix: u
  } = r;
  return e(name$p, {
    "": function() {
      return s.matrix === "Matrix" ? o([]) : [];
    },
    string: function(f) {
      return o(f);
    },
    "number | BigNumber": function(f) {
      return E(f, f, s.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(f, h) {
      return E(f, f, h);
    },
    "number | BigNumber, number | BigNumber": function(f, h) {
      return E(f, h, s.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(f, h, S) {
      return E(f, h, S);
    },
    Array: function(f) {
      return c(f);
    },
    "Array, string": function(f, h) {
      return c(f, h);
    },
    Matrix: function(f) {
      return c(f.valueOf(), f.storage());
    },
    "Matrix, string": function(f, h) {
      return c(f.valueOf(), h);
    }
  });
  function c(d, f) {
    switch (d.length) {
      case 0:
        return f ? o(f) : [];
      case 1:
        return E(d[0], d[0], f);
      case 2:
        return E(d[0], d[1], f);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function E(d, f, h) {
    var S = isBigNumber(d) || isBigNumber(f) ? a : null;
    if (isBigNumber(d) && (d = d.toNumber()), isBigNumber(f) && (f = f.toNumber()), !isInteger$1(d) || d < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!isInteger$1(f) || f < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var R = S ? new a(1) : 1, _ = S ? new S(0) : 0, m = [d, f];
    if (h) {
      if (h === "sparse")
        return u.diagonal(m, R, 0, _);
      if (h === "dense")
        return l.diagonal(m, R, 0, _);
      throw new TypeError('Unknown matrix type "'.concat(h, '"'));
    }
    for (var L = resize([], m, _), F = d < f ? d : f, W = 0; W < F; W++)
      L[W][W] = R;
    return L;
  }
});
function noBignumber() {
  throw new Error('No "bignumber" implementation available');
}
function noFraction() {
  throw new Error('No "fraction" implementation available');
}
function noMatrix() {
  throw new Error('No "matrix" implementation available');
}
var name$o = "range", dependencies$o = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], createRange = /* @__PURE__ */ factory(name$o, dependencies$o, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o,
    bignumber: a,
    smaller: l,
    smallerEq: u,
    larger: c,
    largerEq: E,
    add: d,
    isPositive: f
  } = r;
  return e(name$o, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    string: S,
    "string, boolean": S,
    number: function(L) {
      throw new TypeError("Too few arguments to function range(): ".concat(L));
    },
    boolean: function(L) {
      throw new TypeError("Unexpected type of argument 1 to function range(): ".concat(L, ", number|bigint|BigNumber|Fraction"));
    },
    "number, number": function(L, F) {
      return h(R(L, F, 1, !1));
    },
    "number, number, number": function(L, F, W) {
      return h(R(L, F, W, !1));
    },
    "number, number, boolean": function(L, F, W) {
      return h(R(L, F, 1, W));
    },
    "number, number, number, boolean": function(L, F, W, G) {
      return h(R(L, F, W, G));
    },
    // Handle bigints; if either limit is bigint, range should be too
    "bigint, bigint|number": function(L, F) {
      return h(R(L, F, 1n, !1));
    },
    "number, bigint": function(L, F) {
      return h(R(BigInt(L), F, 1n, !1));
    },
    "bigint, bigint|number, bigint|number": function(L, F, W) {
      return h(R(L, F, BigInt(W), !1));
    },
    "number, bigint, bigint|number": function(L, F, W) {
      return h(R(BigInt(L), F, BigInt(W), !1));
    },
    "bigint, bigint|number, boolean": function(L, F, W) {
      return h(R(L, F, 1n, W));
    },
    "number, bigint, boolean": function(L, F, W) {
      return h(R(BigInt(L), F, 1n, W));
    },
    "bigint, bigint|number, bigint|number, boolean": function(L, F, W, G) {
      return h(R(L, F, BigInt(W), G));
    },
    "number, bigint, bigint|number, boolean": function(L, F, W, G) {
      return h(R(BigInt(L), F, BigInt(W), G));
    },
    "BigNumber, BigNumber": function(L, F) {
      var W = L.constructor;
      return h(R(L, F, new W(1), !1));
    },
    "BigNumber, BigNumber, BigNumber": function(L, F, W) {
      return h(R(L, F, W, !1));
    },
    "BigNumber, BigNumber, boolean": function(L, F, W) {
      var G = L.constructor;
      return h(R(L, F, new G(1), W));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(L, F, W, G) {
      return h(R(L, F, W, G));
    },
    "Fraction, Fraction": function(L, F) {
      return h(R(L, F, 1, !1));
    },
    "Fraction, Fraction, Fraction": function(L, F, W) {
      return h(R(L, F, W, !1));
    },
    "Fraction, Fraction, boolean": function(L, F, W) {
      return h(R(L, F, 1, W));
    },
    "Fraction, Fraction, Fraction, boolean": function(L, F, W, G) {
      return h(R(L, F, W, G));
    },
    "Unit, Unit, Unit": function(L, F, W) {
      return h(R(L, F, W, !1));
    },
    "Unit, Unit, Unit, boolean": function(L, F, W, G) {
      return h(R(L, F, W, G));
    }
  });
  function h(m) {
    return s.matrix === "Matrix" ? o ? o(m) : noMatrix() : m;
  }
  function S(m, L) {
    var F = _(m);
    if (!F)
      throw new SyntaxError('String "' + m + '" is no valid range');
    return s.number === "BigNumber" ? (a === void 0 && noBignumber(), h(R(a(F.start), a(F.end), a(F.step)))) : h(R(F.start, F.end, F.step, L));
  }
  function R(m, L, F, W) {
    for (var G = [], q = f(F) ? W ? u : l : W ? E : c, fe = m; q(fe, L); )
      G.push(fe), fe = d(fe, F);
    return G;
  }
  function _(m) {
    var L = m.split(":"), F = L.map(function(G) {
      return Number(G);
    }), W = F.some(function(G) {
      return isNaN(G);
    });
    if (W)
      return null;
    switch (F.length) {
      case 2:
        return {
          start: F[0],
          end: F[1],
          step: 1
        };
      case 3:
        return {
          start: F[0],
          end: F[2],
          step: F[1]
        };
      default:
        return null;
    }
  }
}), name$n = "reshape", dependencies$n = ["typed", "isInteger", "matrix"], createReshape = /* @__PURE__ */ factory(name$n, dependencies$n, (r) => {
  var {
    typed: e,
    isInteger: s
  } = r;
  return e(name$n, {
    "Matrix, Array": function(a, l) {
      return a.reshape(l, !0);
    },
    "Array, Array": function(a, l) {
      return l.forEach(function(u) {
        if (!s(u))
          throw new TypeError("Invalid size for dimension: " + u);
      }), reshape$1(a, l);
    }
  });
}), name$m = "size", dependencies$m = ["typed", "config", "?matrix"], createSize = /* @__PURE__ */ factory(name$m, dependencies$m, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o
  } = r;
  return e(name$m, {
    Matrix: function(l) {
      return l.create(l.size(), "number");
    },
    Array: arraySize,
    string: function(l) {
      return s.matrix === "Array" ? [l.length] : o([l.length], "dense", "number");
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(l) {
      return s.matrix === "Array" ? [] : o ? o([], "dense", "number") : noMatrix();
    }
  });
}), name$l = "zeros", dependencies$l = ["typed", "config", "matrix", "BigNumber"], createZeros = /* @__PURE__ */ factory(name$l, dependencies$l, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o,
    BigNumber: a
  } = r;
  return e(name$l, {
    "": function() {
      return s.matrix === "Array" ? l([]) : l([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(d) {
      var f = d[d.length - 1];
      if (typeof f == "string") {
        var h = d.pop();
        return l(d, h);
      } else
        return s.matrix === "Array" ? l(d) : l(d, "default");
    },
    Array: l,
    Matrix: function(d) {
      var f = d.storage();
      return l(d.valueOf(), f);
    },
    "Array | Matrix, string": function(d, f) {
      return l(d.valueOf(), f);
    }
  });
  function l(E, d) {
    var f = u(E), h = f ? new a(0) : 0;
    if (c(E), d) {
      var S = o(d);
      return E.length > 0 ? S.resize(E, h) : S;
    } else {
      var R = [];
      return E.length > 0 ? resize(R, E, h) : R;
    }
  }
  function u(E) {
    var d = !1;
    return E.forEach(function(f, h, S) {
      isBigNumber(f) && (d = !0, S[h] = f.toNumber());
    }), d;
  }
  function c(E) {
    E.forEach(function(d) {
      if (typeof d != "number" || !isInteger$1(d) || d < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
}), name$k = "numeric", dependencies$k = ["number", "?bignumber", "?fraction"], createNumeric = /* @__PURE__ */ factory(name$k, dependencies$k, (r) => {
  var {
    number: e,
    bignumber: s,
    fraction: o
  } = r, a = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, l = {
    number: (u) => e(u),
    BigNumber: s ? (u) => s(u) : noBignumber,
    bigint: (u) => BigInt(u),
    Fraction: o ? (u) => o(u) : noFraction
  };
  return function(c) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number", d = arguments.length > 2 ? arguments[2] : void 0;
    if (d !== void 0)
      throw new SyntaxError("numeric() takes one or two arguments");
    var f = typeOf(c);
    if (!(f in a))
      throw new TypeError("Cannot convert " + c + ' of type "' + f + '"; valid input types are ' + Object.keys(a).join(", "));
    if (!(E in l))
      throw new TypeError("Cannot convert " + c + ' to type "' + E + '"; valid output types are ' + Object.keys(l).join(", "));
    return E === f ? c : l[E](c);
  };
}), name$j = "divideScalar", dependencies$j = ["typed", "numeric"], createDivideScalar = /* @__PURE__ */ factory(name$j, dependencies$j, (r) => {
  var {
    typed: e,
    numeric: s
  } = r;
  return e(name$j, {
    "number, number": function(a, l) {
      return a / l;
    },
    "Complex, Complex": function(a, l) {
      return a.div(l);
    },
    "BigNumber, BigNumber": function(a, l) {
      return a.div(l);
    },
    "bigint, bigint": function(a, l) {
      return a / l;
    },
    "Fraction, Fraction": function(a, l) {
      return a.div(l);
    },
    "Unit, number | Complex | Fraction | BigNumber | Unit": (o, a) => o.divide(a),
    "number | Fraction | Complex | BigNumber, Unit": (o, a) => a.divideInto(o)
  });
});
function createSolveValidation(r) {
  var {
    DenseMatrix: e
  } = r;
  return function(o, a, l) {
    var u = o.size();
    if (u.length !== 2)
      throw new RangeError("Matrix must be two dimensional (size: " + format(u) + ")");
    var c = u[0], E = u[1];
    if (c !== E)
      throw new RangeError("Matrix must be square (size: " + format(u) + ")");
    var d = [];
    if (isMatrix(a)) {
      var f = a.size(), h = a._data;
      if (f.length === 1) {
        if (f[0] !== c)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var S = 0; S < c; S++)
          d[S] = [h[S]];
        return new e({
          data: d,
          size: [c, 1],
          datatype: a._datatype
        });
      }
      if (f.length === 2) {
        if (f[0] !== c || f[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (isDenseMatrix(a)) {
          if (l) {
            d = [];
            for (var R = 0; R < c; R++)
              d[R] = [h[R][0]];
            return new e({
              data: d,
              size: [c, 1],
              datatype: a._datatype
            });
          }
          return a;
        }
        if (isSparseMatrix(a)) {
          for (var _ = 0; _ < c; _++)
            d[_] = [0];
          for (var m = a._values, L = a._index, F = a._ptr, W = F[1], G = F[0]; G < W; G++) {
            var q = L[G];
            d[q][0] = m[G];
          }
          return new e({
            data: d,
            size: [c, 1],
            datatype: a._datatype
          });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (isArray(a)) {
      var fe = arraySize(a);
      if (fe.length === 1) {
        if (fe[0] !== c)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var _e = 0; _e < c; _e++)
          d[_e] = [a[_e]];
        return new e({
          data: d,
          size: [c, 1]
        });
      }
      if (fe.length === 2) {
        if (fe[0] !== c || fe[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var Le = 0; Le < c; Le++)
          d[Le] = [a[Le][0]];
        return new e({
          data: d,
          size: [c, 1]
        });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var name$i = "usolve", dependencies$i = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolve = /* @__PURE__ */ factory(name$i, dependencies$i, (r) => {
  var {
    typed: e,
    matrix: s,
    divideScalar: o,
    multiplyScalar: a,
    subtractScalar: l,
    equalScalar: u,
    DenseMatrix: c
  } = r, E = createSolveValidation({
    DenseMatrix: c
  });
  return e(name$i, {
    "SparseMatrix, Array | Matrix": function(S, R) {
      return f(S, R);
    },
    "DenseMatrix, Array | Matrix": function(S, R) {
      return d(S, R);
    },
    "Array, Array | Matrix": function(S, R) {
      var _ = s(S), m = d(_, R);
      return m.valueOf();
    }
  });
  function d(h, S) {
    S = E(h, S, !0);
    for (var R = S._data, _ = h._size[0], m = h._size[1], L = [], F = h._data, W = m - 1; W >= 0; W--) {
      var G = R[W][0] || 0, q = void 0;
      if (u(G, 0))
        q = 0;
      else {
        var fe = F[W][W];
        if (u(fe, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        q = o(G, fe);
        for (var _e = W - 1; _e >= 0; _e--)
          R[_e] = [l(R[_e][0] || 0, a(q, F[_e][W]))];
      }
      L[W] = [q];
    }
    return new c({
      data: L,
      size: [_, 1]
    });
  }
  function f(h, S) {
    S = E(h, S, !0);
    for (var R = S._data, _ = h._size[0], m = h._size[1], L = h._values, F = h._index, W = h._ptr, G = [], q = m - 1; q >= 0; q--) {
      var fe = R[q][0] || 0;
      if (u(fe, 0))
        G[q] = [0];
      else {
        for (var _e = 0, Le = [], Fe = [], Ee = W[q], Ge = W[q + 1], ve = Ge - 1; ve >= Ee; ve--) {
          var te = F[ve];
          te === q ? _e = L[ve] : te < q && (Le.push(L[ve]), Fe.push(te));
        }
        if (u(_e, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var ae = o(fe, _e), v = 0, Te = Fe.length; v < Te; v++) {
          var De = Fe[v];
          R[De] = [l(R[De][0], a(ae, Le[v]))];
        }
        G[q] = [ae];
      }
    }
    return new c({
      data: G,
      size: [_, 1]
    });
  }
}), name$h = "usolveAll", dependencies$h = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolveAll = /* @__PURE__ */ factory(name$h, dependencies$h, (r) => {
  var {
    typed: e,
    matrix: s,
    divideScalar: o,
    multiplyScalar: a,
    subtractScalar: l,
    equalScalar: u,
    DenseMatrix: c
  } = r, E = createSolveValidation({
    DenseMatrix: c
  });
  return e(name$h, {
    "SparseMatrix, Array | Matrix": function(S, R) {
      return f(S, R);
    },
    "DenseMatrix, Array | Matrix": function(S, R) {
      return d(S, R);
    },
    "Array, Array | Matrix": function(S, R) {
      var _ = s(S), m = d(_, R);
      return m.map((L) => L.valueOf());
    }
  });
  function d(h, S) {
    for (var R = [E(h, S, !0)._data.map((Fe) => Fe[0])], _ = h._data, m = h._size[0], L = h._size[1], F = L - 1; F >= 0; F--)
      for (var W = R.length, G = 0; G < W; G++) {
        var q = R[G];
        if (u(_[F][F], 0))
          if (u(q[F], 0)) {
            if (G === 0) {
              var _e = [...q];
              _e[F] = 1;
              for (var Le = F - 1; Le >= 0; Le--)
                _e[Le] = l(_e[Le], _[Le][F]);
              R.push(_e);
            }
          } else {
            if (G === 0)
              return [];
            R.splice(G, 1), G -= 1, W -= 1;
          }
        else {
          q[F] = o(q[F], _[F][F]);
          for (var fe = F - 1; fe >= 0; fe--)
            q[fe] = l(q[fe], a(q[F], _[fe][F]));
        }
      }
    return R.map((Fe) => new c({
      data: Fe.map((Ee) => [Ee]),
      size: [m, 1]
    }));
  }
  function f(h, S) {
    for (var R = [E(h, S, !0)._data.map((Me) => Me[0])], _ = h._size[0], m = h._size[1], L = h._values, F = h._index, W = h._ptr, G = m - 1; G >= 0; G--)
      for (var q = R.length, fe = 0; fe < q; fe++) {
        for (var _e = R[fe], Le = [], Fe = [], Ee = W[G], Ge = W[G + 1], ve = 0, te = Ge - 1; te >= Ee; te--) {
          var ae = F[te];
          ae === G ? ve = L[te] : ae < G && (Le.push(L[te]), Fe.push(ae));
        }
        if (u(ve, 0))
          if (u(_e[G], 0)) {
            if (fe === 0) {
              var be = [..._e];
              be[G] = 1;
              for (var ze = 0, ke = Fe.length; ze < ke; ze++) {
                var Be = Fe[ze];
                be[Be] = l(be[Be], Le[ze]);
              }
              R.push(be);
            }
          } else {
            if (fe === 0)
              return [];
            R.splice(fe, 1), fe -= 1, q -= 1;
          }
        else {
          _e[G] = o(_e[G], ve);
          for (var v = 0, Te = Fe.length; v < Te; v++) {
            var De = Fe[v];
            _e[De] = l(_e[De], a(_e[G], Le[v]));
          }
        }
      }
    return R.map((Me) => new c({
      data: Me.map((me) => [me]),
      size: [_, 1]
    }));
  }
}), commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function getAugmentedNamespace(r) {
  if (r.__esModule)
    return r;
  var e = r.default;
  if (typeof e == "function") {
    var s = function o() {
      return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    s.prototype = e.prototype;
  } else
    s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(r).forEach(function(o) {
    var a = Object.getOwnPropertyDescriptor(r, o);
    Object.defineProperty(s, o, a.get ? a : {
      enumerable: !0,
      get: function() {
        return r[o];
      }
    });
  }), s;
}
var name$g = "equal", dependencies$g = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat", "SparseMatrix"], createEqual = /* @__PURE__ */ factory(name$g, dependencies$g, (r) => {
  var {
    typed: e,
    matrix: s,
    equalScalar: o,
    DenseMatrix: a,
    concat: l,
    SparseMatrix: u
  } = r, c = createMatAlgo03xDSf({
    typed: e
  }), E = createMatAlgo07xSSf({
    typed: e,
    SparseMatrix: u
  }), d = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: a
  }), f = createMatrixAlgorithmSuite({
    typed: e,
    matrix: s,
    concat: l
  });
  return e(name$g, createEqualNumber({
    typed: e,
    equalScalar: o
  }), f({
    elop: o,
    SS: E,
    DS: c,
    Ss: d
  }));
}), createEqualNumber = factory(name$g, ["typed", "equalScalar"], (r) => {
  var {
    typed: e,
    equalScalar: s
  } = r;
  return e(name$g, {
    "any, any": function(a, l) {
      return a === null ? l === null : l === null ? a === null : a === void 0 ? l === void 0 : l === void 0 ? a === void 0 : s(a, l);
    }
  });
}), name$f = "smaller", dependencies$f = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmaller = /* @__PURE__ */ factory(name$f, dependencies$f, (r) => {
  var {
    typed: e,
    config: s,
    bignumber: o,
    matrix: a,
    DenseMatrix: l,
    concat: u,
    SparseMatrix: c
  } = r, E = createMatAlgo03xDSf({
    typed: e
  }), d = createMatAlgo07xSSf({
    typed: e,
    SparseMatrix: c
  }), f = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: l
  }), h = createMatrixAlgorithmSuite({
    typed: e,
    matrix: a,
    concat: u
  }), S = createCompareUnits({
    typed: e
  });
  function R(_, m) {
    return _.lt(m) && !nearlyEqual(_, m, s.relTol, s.absTol);
  }
  return e(name$f, createSmallerNumber({
    typed: e,
    config: s
  }), {
    "boolean, boolean": (_, m) => _ < m,
    "BigNumber, BigNumber": R,
    "bigint, bigint": (_, m) => _ < m,
    "Fraction, Fraction": (_, m) => _.compare(m) === -1,
    "Fraction, BigNumber": function(m, L) {
      return R(o(m), L);
    },
    "BigNumber, Fraction": function(m, L) {
      return R(m, o(L));
    },
    "Complex, Complex": function(m, L) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, S, h({
    SS: d,
    DS: E,
    Ss: f
  }));
}), createSmallerNumber = /* @__PURE__ */ factory(name$f, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$f, {
    "number, number": function(a, l) {
      return a < l && !nearlyEqual$1(a, l, s.relTol, s.absTol);
    }
  });
}), name$e = "smallerEq", dependencies$e = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmallerEq = /* @__PURE__ */ factory(name$e, dependencies$e, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o,
    DenseMatrix: a,
    concat: l,
    SparseMatrix: u
  } = r, c = createMatAlgo03xDSf({
    typed: e
  }), E = createMatAlgo07xSSf({
    typed: e,
    SparseMatrix: u
  }), d = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: a
  }), f = createMatrixAlgorithmSuite({
    typed: e,
    matrix: o,
    concat: l
  }), h = createCompareUnits({
    typed: e
  });
  return e(name$e, createSmallerEqNumber({
    typed: e,
    config: s
  }), {
    "boolean, boolean": (S, R) => S <= R,
    "BigNumber, BigNumber": function(R, _) {
      return R.lte(_) || nearlyEqual(R, _, s.relTol, s.absTol);
    },
    "bigint, bigint": (S, R) => S <= R,
    "Fraction, Fraction": (S, R) => S.compare(R) !== 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, h, f({
    SS: E,
    DS: c,
    Ss: d
  }));
}), createSmallerEqNumber = /* @__PURE__ */ factory(name$e, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$e, {
    "number, number": function(a, l) {
      return a <= l || nearlyEqual$1(a, l, s.relTol, s.absTol);
    }
  });
}), name$d = "larger", dependencies$d = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLarger = /* @__PURE__ */ factory(name$d, dependencies$d, (r) => {
  var {
    typed: e,
    config: s,
    bignumber: o,
    matrix: a,
    DenseMatrix: l,
    concat: u,
    SparseMatrix: c
  } = r, E = createMatAlgo03xDSf({
    typed: e
  }), d = createMatAlgo07xSSf({
    typed: e,
    SparseMatrix: c
  }), f = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: l
  }), h = createMatrixAlgorithmSuite({
    typed: e,
    matrix: a,
    concat: u
  }), S = createCompareUnits({
    typed: e
  });
  function R(_, m) {
    return _.gt(m) && !nearlyEqual(_, m, s.relTol, s.absTol);
  }
  return e(name$d, createLargerNumber({
    typed: e,
    config: s
  }), {
    "boolean, boolean": (_, m) => _ > m,
    "BigNumber, BigNumber": R,
    "bigint, bigint": (_, m) => _ > m,
    "Fraction, Fraction": (_, m) => _.compare(m) === 1,
    "Fraction, BigNumber": function(m, L) {
      return R(o(m), L);
    },
    "BigNumber, Fraction": function(m, L) {
      return R(m, o(L));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, S, h({
    SS: d,
    DS: E,
    Ss: f
  }));
}), createLargerNumber = /* @__PURE__ */ factory(name$d, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$d, {
    "number, number": function(a, l) {
      return a > l && !nearlyEqual$1(a, l, s.relTol, s.absTol);
    }
  });
}), name$c = "largerEq", dependencies$c = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLargerEq = /* @__PURE__ */ factory(name$c, dependencies$c, (r) => {
  var {
    typed: e,
    config: s,
    matrix: o,
    DenseMatrix: a,
    concat: l,
    SparseMatrix: u
  } = r, c = createMatAlgo03xDSf({
    typed: e
  }), E = createMatAlgo07xSSf({
    typed: e,
    SparseMatrix: u
  }), d = createMatAlgo12xSfs({
    typed: e,
    DenseMatrix: a
  }), f = createMatrixAlgorithmSuite({
    typed: e,
    matrix: o,
    concat: l
  }), h = createCompareUnits({
    typed: e
  });
  return e(name$c, createLargerEqNumber({
    typed: e,
    config: s
  }), {
    "boolean, boolean": (S, R) => S >= R,
    "BigNumber, BigNumber": function(R, _) {
      return R.gte(_) || nearlyEqual(R, _, s.relTol, s.absTol);
    },
    "bigint, bigint": function(R, _) {
      return R >= _;
    },
    "Fraction, Fraction": (S, R) => S.compare(R) !== -1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, h, f({
    SS: E,
    DS: c,
    Ss: d
  }));
}), createLargerEqNumber = /* @__PURE__ */ factory(name$c, ["typed", "config"], (r) => {
  var {
    typed: e,
    config: s
  } = r;
  return e(name$c, {
    "number, number": function(a, l) {
      return a >= l || nearlyEqual$1(a, l, s.relTol, s.absTol);
    }
  });
}), name$b = "ImmutableDenseMatrix", dependencies$b = ["smaller", "DenseMatrix"], createImmutableDenseMatrixClass = /* @__PURE__ */ factory(name$b, dependencies$b, (r) => {
  var {
    smaller: e,
    DenseMatrix: s
  } = r;
  function o(a, l) {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (l && !isString(l))
      throw new Error("Invalid datatype: " + l);
    if (isMatrix(a) || isArray(a)) {
      var u = new s(a, l);
      this._data = u._data, this._size = u._size, this._datatype = u._datatype, this._min = null, this._max = null;
    } else if (a && isArray(a.data) && isArray(a.size))
      this._data = a.data, this._size = a.size, this._datatype = a.datatype, this._min = typeof a.min < "u" ? a.min : null, this._max = typeof a.max < "u" ? a.max : null;
    else {
      if (a)
        throw new TypeError("Unsupported type of data (" + typeOf(a) + ")");
      this._data = [], this._size = [0], this._datatype = l, this._min = null, this._max = null;
    }
  }
  return o.prototype = new s(), o.prototype.type = "ImmutableDenseMatrix", o.prototype.isImmutableDenseMatrix = !0, o.prototype.subset = function(a) {
    switch (arguments.length) {
      case 1: {
        var l = s.prototype.subset.call(this, a);
        return isMatrix(l) ? new o({
          data: l._data,
          size: l._size,
          datatype: l._datatype
        }) : l;
      }
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, o.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, o.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, o.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, o.prototype.clone = function() {
    return new o({
      data: clone$2(this._data),
      size: clone$2(this._size),
      datatype: this._datatype
    });
  }, o.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, o.fromJSON = function(a) {
    return new o(a);
  }, o.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, o.prototype.min = function() {
    if (this._min === null) {
      var a = null;
      this.forEach(function(l) {
        (a === null || e(l, a)) && (a = l);
      }), this._min = a !== null ? a : void 0;
    }
    return this._min;
  }, o.prototype.max = function() {
    if (this._max === null) {
      var a = null;
      this.forEach(function(l) {
        (a === null || e(a, l)) && (a = l);
      }), this._max = a !== null ? a : void 0;
    }
    return this._max;
  }, o;
}, {
  isClass: !0
}), name$a = "Index", dependencies$a = ["ImmutableDenseMatrix", "getMatrixDataType"], createIndexClass = /* @__PURE__ */ factory(name$a, dependencies$a, (r) => {
  var {
    ImmutableDenseMatrix: e,
    getMatrixDataType: s
  } = r;
  function o(l) {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var u = 0, c = arguments.length; u < c; u++) {
      var E = arguments[u], d = isArray(E), f = isMatrix(E), h = typeof E, S = null;
      if (isRange(E))
        this._dimensions.push(E), this._isScalar = !1;
      else if (d || f) {
        var R = void 0;
        s(E) === "boolean" ? (d && (R = a(_booleansArrayToNumbersForIndex(E).valueOf())), f && (R = a(_booleansArrayToNumbersForIndex(E._data).valueOf())), S = E.valueOf().length) : R = a(E.valueOf()), this._dimensions.push(R);
        var _ = R.size();
        (_.length !== 1 || _[0] !== 1 || S !== null) && (this._isScalar = !1);
      } else if (h === "number")
        this._dimensions.push(a([E]));
      else if (h === "bigint")
        this._dimensions.push(a([Number(E)]));
      else if (h === "string")
        this._dimensions.push(E);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      this._sourceSize.push(S);
    }
  }
  o.prototype.type = "Index", o.prototype.isIndex = !0;
  function a(l) {
    for (var u = 0, c = l.length; u < c; u++)
      if (typeof l[u] != "number" || !isInteger$1(l[u]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new e(l);
  }
  return o.prototype.clone = function() {
    var l = new o();
    return l._dimensions = clone$2(this._dimensions), l._isScalar = this._isScalar, l._sourceSize = this._sourceSize, l;
  }, o.create = function(l) {
    var u = new o();
    return o.apply(u, l), u;
  }, o.prototype.size = function() {
    for (var l = [], u = 0, c = this._dimensions.length; u < c; u++) {
      var E = this._dimensions[u];
      l[u] = typeof E == "string" ? 1 : E.size()[0];
    }
    return l;
  }, o.prototype.max = function() {
    for (var l = [], u = 0, c = this._dimensions.length; u < c; u++) {
      var E = this._dimensions[u];
      l[u] = typeof E == "string" ? E : E.max();
    }
    return l;
  }, o.prototype.min = function() {
    for (var l = [], u = 0, c = this._dimensions.length; u < c; u++) {
      var E = this._dimensions[u];
      l[u] = typeof E == "string" ? E : E.min();
    }
    return l;
  }, o.prototype.forEach = function(l) {
    for (var u = 0, c = this._dimensions.length; u < c; u++)
      l(this._dimensions[u], u, this);
  }, o.prototype.dimension = function(l) {
    return typeof l != "number" ? null : this._dimensions[l] || null;
  }, o.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, o.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, o.prototype.isScalar = function() {
    return this._isScalar;
  }, o.prototype.toArray = function() {
    for (var l = [], u = 0, c = this._dimensions.length; u < c; u++) {
      var E = this._dimensions[u];
      l.push(typeof E == "string" ? E : E.toArray());
    }
    return l;
  }, o.prototype.valueOf = o.prototype.toArray, o.prototype.toString = function() {
    for (var l = [], u = 0, c = this._dimensions.length; u < c; u++) {
      var E = this._dimensions[u];
      typeof E == "string" ? l.push(JSON.stringify(E)) : l.push(E.toString());
    }
    return "[" + l.join(", ") + "]";
  }, o.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, o.fromJSON = function(l) {
    return o.create(l.dimensions);
  }, o;
}, {
  isClass: !0
});
function _booleansArrayToNumbersForIndex(r) {
  var e = [];
  return r.forEach((s, o) => {
    s && e.push(o);
  }), e;
}
var name$9 = "atan", dependencies$9 = ["typed"], createAtan = /* @__PURE__ */ factory(name$9, dependencies$9, (r) => {
  var {
    typed: e
  } = r;
  return e("atan", {
    number: function(o) {
      return Math.atan(o);
    },
    Complex: function(o) {
      return o.atan();
    },
    BigNumber: function(o) {
      return o.atan();
    }
  });
}), createTrigUnit = /* @__PURE__ */ factory("trigUnit", ["typed"], (r) => {
  var {
    typed: e
  } = r;
  return {
    Unit: e.referToSelf((s) => (o) => {
      if (!o.hasBase(o.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cot is no angle");
      return e.find(s, o.valueType())(o.value);
    })
  };
}), name$8 = "cos", dependencies$8 = ["typed"], createCos = /* @__PURE__ */ factory(name$8, dependencies$8, (r) => {
  var {
    typed: e
  } = r, s = createTrigUnit({
    typed: e
  });
  return e(name$8, {
    number: Math.cos,
    "Complex | BigNumber": (o) => o.cos()
  }, s);
}), name$7 = "sin", dependencies$7 = ["typed"], createSin = /* @__PURE__ */ factory(name$7, dependencies$7, (r) => {
  var {
    typed: e
  } = r, s = createTrigUnit({
    typed: e
  });
  return e(name$7, {
    number: Math.sin,
    "Complex | BigNumber": (o) => o.sin()
  }, s);
}), name$6 = "add", dependencies$6 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], createAdd = /* @__PURE__ */ factory(name$6, dependencies$6, (r) => {
  var {
    typed: e,
    matrix: s,
    addScalar: o,
    equalScalar: a,
    DenseMatrix: l,
    SparseMatrix: u,
    concat: c
  } = r, E = createMatAlgo01xDSid({
    typed: e
  }), d = createMatAlgo04xSidSid({
    typed: e,
    equalScalar: a
  }), f = createMatAlgo10xSids({
    typed: e,
    DenseMatrix: l
  }), h = createMatrixAlgorithmSuite({
    typed: e,
    matrix: s,
    concat: c
  });
  return e(name$6, {
    "any, any": o,
    "any, any, ...any": e.referToSelf((S) => (R, _, m) => {
      for (var L = S(R, _), F = 0; F < m.length; F++)
        L = S(L, m[F]);
      return L;
    })
  }, h({
    elop: o,
    DS: E,
    SS: d,
    Ss: f
  }));
}), name$5 = "dot", dependencies$5 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], createDot = /* @__PURE__ */ factory(name$5, dependencies$5, (r) => {
  var {
    typed: e,
    addScalar: s,
    multiplyScalar: o,
    conj: a,
    size: l
  } = r;
  return e(name$5, {
    "Array | DenseMatrix, Array | DenseMatrix": c,
    "SparseMatrix, SparseMatrix": E
  });
  function u(f, h) {
    var S = d(f), R = d(h), _, m;
    if (S.length === 1)
      _ = S[0];
    else if (S.length === 2 && S[1] === 1)
      _ = S[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + S.join(", ") + ")");
    if (R.length === 1)
      m = R[0];
    else if (R.length === 2 && R[1] === 1)
      m = R[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + R.join(", ") + ")");
    if (_ !== m)
      throw new RangeError("Vectors must have equal length (" + _ + " != " + m + ")");
    if (_ === 0)
      throw new RangeError("Cannot calculate the dot product of empty vectors");
    return _;
  }
  function c(f, h) {
    var S = u(f, h), R = isMatrix(f) ? f._data : f, _ = isMatrix(f) ? f._datatype || f.getDataType() : void 0, m = isMatrix(h) ? h._data : h, L = isMatrix(h) ? h._datatype || h.getDataType() : void 0, F = d(f).length === 2, W = d(h).length === 2, G = s, q = o;
    if (_ && L && _ === L && typeof _ == "string" && _ !== "mixed") {
      var fe = _;
      G = e.find(s, [fe, fe]), q = e.find(o, [fe, fe]);
    }
    if (!F && !W) {
      for (var _e = q(a(R[0]), m[0]), Le = 1; Le < S; Le++)
        _e = G(_e, q(a(R[Le]), m[Le]));
      return _e;
    }
    if (!F && W) {
      for (var Fe = q(a(R[0]), m[0][0]), Ee = 1; Ee < S; Ee++)
        Fe = G(Fe, q(a(R[Ee]), m[Ee][0]));
      return Fe;
    }
    if (F && !W) {
      for (var Ge = q(a(R[0][0]), m[0]), ve = 1; ve < S; ve++)
        Ge = G(Ge, q(a(R[ve][0]), m[ve]));
      return Ge;
    }
    if (F && W) {
      for (var te = q(a(R[0][0]), m[0][0]), ae = 1; ae < S; ae++)
        te = G(te, q(a(R[ae][0]), m[ae][0]));
      return te;
    }
  }
  function E(f, h) {
    u(f, h);
    for (var S = f._index, R = f._values, _ = h._index, m = h._values, L = 0, F = s, W = o, G = 0, q = 0; G < S.length && q < _.length; ) {
      var fe = S[G], _e = _[q];
      if (fe < _e) {
        G++;
        continue;
      }
      if (fe > _e) {
        q++;
        continue;
      }
      fe === _e && (L = F(L, W(R[G], m[q])), G++, q++);
    }
    return L;
  }
  function d(f) {
    return isMatrix(f) ? f.size() : l(f);
  }
}), name$4 = "qr", dependencies$4 = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], createQr = /* @__PURE__ */ factory(name$4, dependencies$4, (r) => {
  var {
    typed: e,
    matrix: s,
    zeros: o,
    identity: a,
    isZero: l,
    equal: u,
    sign: c,
    sqrt: E,
    conj: d,
    unaryMinus: f,
    addScalar: h,
    divideScalar: S,
    multiplyScalar: R,
    subtractScalar: _,
    complex: m
  } = r;
  return _extends$1(e(name$4, {
    DenseMatrix: function(q) {
      return F(q);
    },
    SparseMatrix: function(q) {
      return W();
    },
    Array: function(q) {
      var fe = s(q), _e = F(fe);
      return {
        Q: _e.Q.valueOf(),
        R: _e.R.valueOf()
      };
    }
  }), {
    _denseQRimpl: L
  });
  function L(G) {
    var q = G._size[0], fe = G._size[1], _e = a([q], "dense"), Le = _e._data, Fe = G.clone(), Ee = Fe._data, Ge, ve, te, ae = o([q], "");
    for (te = 0; te < Math.min(fe, q); ++te) {
      var v = Ee[te][te], Te = f(u(v, 0) ? 1 : c(v)), De = d(Te), be = 0;
      for (Ge = te; Ge < q; Ge++)
        be = h(be, R(Ee[Ge][te], d(Ee[Ge][te])));
      var ze = R(Te, E(be));
      if (!l(ze)) {
        var ke = _(v, ze);
        for (ae[te] = 1, Ge = te + 1; Ge < q; Ge++)
          ae[Ge] = S(Ee[Ge][te], ke);
        var Be = f(d(S(ke, ze))), Me = void 0;
        for (ve = te; ve < fe; ve++) {
          for (Me = 0, Ge = te; Ge < q; Ge++)
            Me = h(Me, R(d(ae[Ge]), Ee[Ge][ve]));
          for (Me = R(Me, Be), Ge = te; Ge < q; Ge++)
            Ee[Ge][ve] = R(_(Ee[Ge][ve], R(ae[Ge], Me)), De);
        }
        for (Ge = 0; Ge < q; Ge++) {
          for (Me = 0, ve = te; ve < q; ve++)
            Me = h(Me, R(Le[Ge][ve], ae[ve]));
          for (Me = R(Me, Be), ve = te; ve < q; ++ve)
            Le[Ge][ve] = S(_(Le[Ge][ve], R(Me, d(ae[ve]))), De);
        }
      }
    }
    return {
      Q: _e,
      R: Fe,
      toString: function() {
        return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
      }
    };
  }
  function F(G) {
    var q = L(G), fe = q.R._data;
    if (G._data.length > 0)
      for (var _e = fe[0][0].type === "Complex" ? m(0) : 0, Le = 0; Le < fe.length; ++Le)
        for (var Fe = 0; Fe < Le && Fe < (fe[0] || []).length; ++Fe)
          fe[Le][Fe] = _e;
    return q;
  }
  function W(G) {
    throw new Error("qr not implemented for sparse matrices yet");
  }
}), name$3 = "det", dependencies$3 = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], createDet = /* @__PURE__ */ factory(name$3, dependencies$3, (r) => {
  var {
    typed: e,
    matrix: s,
    subtractScalar: o,
    multiply: a,
    divideScalar: l,
    isZero: u,
    unaryMinus: c
  } = r;
  return e(name$3, {
    any: function(f) {
      return clone$2(f);
    },
    "Array | Matrix": function(f) {
      var h;
      switch (isMatrix(f) ? h = f.size() : Array.isArray(f) ? (f = s(f), h = f.size()) : h = [], h.length) {
        case 0:
          return clone$2(f);
        case 1:
          if (h[0] === 1)
            return clone$2(f.valueOf()[0]);
          if (h[0] === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + format(h) + ")");
        case 2: {
          var S = h[0], R = h[1];
          if (S === R)
            return E(f.clone().valueOf(), S);
          if (R === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + format(h) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + format(h) + ")");
      }
    }
  });
  function E(d, f, h) {
    if (f === 1)
      return clone$2(d[0][0]);
    if (f === 2)
      return o(a(d[0][0], d[1][1]), a(d[1][0], d[0][1]));
    for (var S = !1, R = new Array(f).fill(0).map((Le, Fe) => Fe), _ = 0; _ < f; _++) {
      var m = R[_];
      if (u(d[m][_])) {
        var L = void 0;
        for (L = _ + 1; L < f; L++)
          if (!u(d[R[L]][_])) {
            m = R[L], R[L] = R[_], R[_] = m, S = !S;
            break;
          }
        if (L === f)
          return d[m][_];
      }
      for (var F = d[m][_], W = _ === 0 ? 1 : d[R[_ - 1]][_ - 1], G = _ + 1; G < f; G++)
        for (var q = R[G], fe = _ + 1; fe < f; fe++)
          d[q][fe] = l(o(a(d[q][fe], F), a(d[q][_], d[m][fe])), W);
    }
    var _e = d[R[f - 1]][f - 1];
    return S ? c(_e) : _e;
  }
}), name$2 = "inv", dependencies$2 = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], createInv = /* @__PURE__ */ factory(name$2, dependencies$2, (r) => {
  var {
    typed: e,
    matrix: s,
    divideScalar: o,
    addScalar: a,
    multiply: l,
    unaryMinus: u,
    det: c,
    identity: E,
    abs: d
  } = r;
  return e(name$2, {
    "Array | Matrix": function(S) {
      var R = isMatrix(S) ? S.size() : arraySize(S);
      switch (R.length) {
        case 1:
          if (R[0] === 1)
            return isMatrix(S) ? s([o(1, S.valueOf()[0])]) : [o(1, S[0])];
          throw new RangeError("Matrix must be square (size: " + format(R) + ")");
        case 2: {
          var _ = R[0], m = R[1];
          if (_ === m)
            return isMatrix(S) ? s(f(S.valueOf(), _, m), S.storage()) : f(S, _, m);
          throw new RangeError("Matrix must be square (size: " + format(R) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + format(R) + ")");
      }
    },
    any: function(S) {
      return o(1, S);
    }
  });
  function f(h, S, R) {
    var _, m, L, F, W;
    if (S === 1) {
      if (F = h[0][0], F === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[o(1, F)]];
    } else if (S === 2) {
      var G = c(h);
      if (G === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[o(h[1][1], G), o(u(h[0][1]), G)], [o(u(h[1][0]), G), o(h[0][0], G)]];
    } else {
      var q = h.concat();
      for (_ = 0; _ < S; _++)
        q[_] = q[_].concat();
      for (var fe = E(S).valueOf(), _e = 0; _e < R; _e++) {
        var Le = d(q[_e][_e]), Fe = _e;
        for (_ = _e + 1; _ < S; )
          d(q[_][_e]) > Le && (Le = d(q[_][_e]), Fe = _), _++;
        if (Le === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        _ = Fe, _ !== _e && (W = q[_e], q[_e] = q[_], q[_] = W, W = fe[_e], fe[_e] = fe[_], fe[_] = W);
        var Ee = q[_e], Ge = fe[_e];
        for (_ = 0; _ < S; _++) {
          var ve = q[_], te = fe[_];
          if (_ !== _e) {
            if (ve[_e] !== 0) {
              for (L = o(u(ve[_e]), Ee[_e]), m = _e; m < R; m++)
                ve[m] = a(ve[m], l(L, Ee[m]));
              for (m = 0; m < R; m++)
                te[m] = a(te[m], l(L, Ge[m]));
            }
          } else {
            for (L = Ee[_e], m = _e; m < R; m++)
              ve[m] = o(ve[m], L);
            for (m = 0; m < R; m++)
              te[m] = o(te[m], L);
          }
        }
      }
      return fe;
    }
  }
});
function createComplexEigs(r) {
  var {
    addScalar: e,
    subtract: s,
    flatten: o,
    multiply: a,
    multiplyScalar: l,
    divideScalar: u,
    sqrt: c,
    abs: E,
    bignumber: d,
    diag: f,
    size: h,
    reshape: S,
    inv: R,
    qr: _,
    usolve: m,
    usolveAll: L,
    equal: F,
    complex: W,
    larger: G,
    smaller: q,
    matrixFromColumns: fe,
    dot: _e
  } = r;
  function Le(me, Se, xt, Ht) {
    var Bt = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, ut = Fe(me, Se, xt, Ht, Bt);
    Ee(me, Se, xt, Ht, Bt, ut);
    var {
      values: Tt,
      C: Yt
    } = Ge(me, Se, xt, Ht, Bt);
    if (Bt) {
      var an = ve(me, Se, Yt, ut, Tt, xt, Ht);
      return {
        values: Tt,
        eigenvectors: an
      };
    }
    return {
      values: Tt
    };
  }
  function Fe(me, Se, xt, Ht, Bt) {
    var ut = Ht === "BigNumber", Tt = Ht === "Complex", Yt = ut ? d(0) : 0, an = ut ? d(1) : Tt ? W(1) : 1, Ct = ut ? d(1) : 1, st = ut ? d(10) : 2, jt = l(st, st), lt;
    Bt && (lt = Array(Se).fill(an));
    for (var Zt = !1; !Zt; ) {
      Zt = !0;
      for (var Et = 0; Et < Se; Et++) {
        for (var Ke = Yt, $e = Yt, pt = 0; pt < Se; pt++)
          Et !== pt && (Ke = e(Ke, E(me[pt][Et])), $e = e($e, E(me[Et][pt])));
        if (!F(Ke, 0) && !F($e, 0)) {
          for (var Jt = Ct, In = Ke, Cn = u($e, st), It = l($e, st); q(In, Cn); )
            In = l(In, jt), Jt = l(Jt, st);
          for (; G(In, It); )
            In = u(In, jt), Jt = u(Jt, st);
          var ht = q(u(e(In, $e), Jt), l(e(Ke, $e), 0.95));
          if (ht) {
            Zt = !1;
            for (var Wt = u(1, Jt), hn = 0; hn < Se; hn++)
              Et !== hn && (me[Et][hn] = l(me[Et][hn], Wt), me[hn][Et] = l(me[hn][Et], Jt));
            Bt && (lt[Et] = l(lt[Et], Wt));
          }
        }
      }
    }
    return Bt ? f(lt) : null;
  }
  function Ee(me, Se, xt, Ht, Bt, ut) {
    var Tt = Ht === "BigNumber", Yt = Ht === "Complex", an = Tt ? d(0) : Yt ? W(0) : 0;
    Tt && (xt = d(xt));
    for (var Ct = 0; Ct < Se - 2; Ct++) {
      for (var st = 0, jt = an, lt = Ct + 1; lt < Se; lt++) {
        var Zt = me[lt][Ct];
        q(E(jt), E(Zt)) && (jt = Zt, st = lt);
      }
      if (!q(E(jt), xt)) {
        if (st !== Ct + 1) {
          var Et = me[st];
          me[st] = me[Ct + 1], me[Ct + 1] = Et;
          for (var Ke = 0; Ke < Se; Ke++) {
            var $e = me[Ke][st];
            me[Ke][st] = me[Ke][Ct + 1], me[Ke][Ct + 1] = $e;
          }
          if (Bt) {
            var pt = ut[st];
            ut[st] = ut[Ct + 1], ut[Ct + 1] = pt;
          }
        }
        for (var Jt = Ct + 2; Jt < Se; Jt++) {
          var In = u(me[Jt][Ct], jt);
          if (In !== 0) {
            for (var Cn = 0; Cn < Se; Cn++)
              me[Jt][Cn] = s(me[Jt][Cn], l(In, me[Ct + 1][Cn]));
            for (var It = 0; It < Se; It++)
              me[It][Ct + 1] = e(me[It][Ct + 1], l(In, me[It][Jt]));
            if (Bt)
              for (var ht = 0; ht < Se; ht++)
                ut[Jt][ht] = s(ut[Jt][ht], l(In, ut[Ct + 1][ht]));
          }
        }
      }
    }
    return ut;
  }
  function Ge(me, Se, xt, Ht, Bt) {
    var ut = Ht === "BigNumber", Tt = Ht === "Complex", Yt = ut ? d(1) : Tt ? W(1) : 1;
    ut && (xt = d(xt));
    for (var an = clone$2(me), Ct = [], st = Se, jt = [], lt = Bt ? f(Array(Se).fill(Yt)) : void 0, Zt = Bt ? f(Array(st).fill(Yt)) : void 0, Et = 0; Et <= 100; ) {
      Et += 1;
      for (var Ke = an[st - 1][st - 1], $e = 0; $e < st; $e++)
        an[$e][$e] = s(an[$e][$e], Ke);
      var {
        Q: pt,
        R: Jt
      } = _(an);
      an = a(Jt, pt);
      for (var In = 0; In < st; In++)
        an[In][In] = e(an[In][In], Ke);
      if (Bt && (Zt = a(Zt, pt)), st === 1 || q(E(an[st - 1][st - 2]), xt)) {
        Et = 0, Ct.push(an[st - 1][st - 1]), Bt && (jt.unshift([[1]]), v(Zt, Se), lt = a(lt, Zt), st > 1 && (Zt = f(Array(st - 1).fill(Yt)))), st -= 1, an.pop();
        for (var Cn = 0; Cn < st; Cn++)
          an[Cn].pop();
      } else if (st === 2 || q(E(an[st - 2][st - 3]), xt)) {
        Et = 0;
        var It = te(an[st - 2][st - 2], an[st - 2][st - 1], an[st - 1][st - 2], an[st - 1][st - 1]);
        Ct.push(...It), Bt && (jt.unshift(ae(an[st - 2][st - 2], an[st - 2][st - 1], an[st - 1][st - 2], an[st - 1][st - 1], It[0], It[1], xt, Ht)), v(Zt, Se), lt = a(lt, Zt), st > 2 && (Zt = f(Array(st - 2).fill(Yt)))), st -= 2, an.pop(), an.pop();
        for (var ht = 0; ht < st; ht++)
          an[ht].pop(), an[ht].pop();
      }
      if (st === 0)
        break;
    }
    if (Ct.sort((Vt, Tn) => +s(E(Vt), E(Tn))), Et > 100) {
      var Wt = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + Ct.join(", "));
      throw Wt.values = Ct, Wt.vectors = [], Wt;
    }
    var hn = Bt ? a(lt, Te(jt, Se)) : void 0;
    return {
      values: Ct,
      C: hn
    };
  }
  function ve(me, Se, xt, Ht, Bt, ut, Tt) {
    var Yt = R(xt), an = a(Yt, me, xt), Ct = Tt === "BigNumber", st = Tt === "Complex", jt = Ct ? d(0) : st ? W(0) : 0, lt = Ct ? d(1) : st ? W(1) : 1, Zt = [], Et = [];
    for (var Ke of Bt) {
      var $e = De(Zt, Ke, F);
      $e === -1 ? (Zt.push(Ke), Et.push(1)) : Et[$e] += 1;
    }
    for (var pt = [], Jt = Zt.length, In = Array(Se).fill(jt), Cn = f(Array(Se).fill(lt)), It = function() {
      var hn = Zt[ht], Vt = s(an, a(hn, Cn)), Tn = L(Vt, In);
      for (Tn.shift(); Tn.length < Et[ht]; ) {
        var Rn = be(Vt, Se, Tn, ut, Tt);
        if (Rn === null)
          break;
        Tn.push(Rn);
      }
      var Nn = a(R(Ht), xt);
      Tn = Tn.map((Dn) => a(Nn, Dn)), pt.push(...Tn.map((Dn) => ({
        value: hn,
        vector: o(Dn)
      })));
    }, ht = 0; ht < Jt; ht++)
      It();
    return pt;
  }
  function te(me, Se, xt, Ht) {
    var Bt = e(me, Ht), ut = s(l(me, Ht), l(Se, xt)), Tt = l(Bt, 0.5), Yt = l(c(s(l(Bt, Bt), l(4, ut))), 0.5);
    return [e(Tt, Yt), s(Tt, Yt)];
  }
  function ae(me, Se, xt, Ht, Bt, ut, Tt, Yt) {
    var an = Yt === "BigNumber", Ct = Yt === "Complex", st = an ? d(0) : Ct ? W(0) : 0, jt = an ? d(1) : Ct ? W(1) : 1;
    if (q(E(xt), Tt))
      return [[jt, st], [st, jt]];
    if (G(E(s(Bt, ut)), Tt))
      return [[s(Bt, Ht), s(ut, Ht)], [xt, xt]];
    var lt = s(me, Bt), Zt = s(Ht, Bt);
    return q(E(Se), Tt) && q(E(Zt), Tt) ? [[lt, jt], [xt, st]] : [[Se, st], [Zt, jt]];
  }
  function v(me, Se) {
    for (var xt = 0; xt < me.length; xt++)
      me[xt].push(...Array(Se - me[xt].length).fill(0));
    for (var Ht = me.length; Ht < Se; Ht++)
      me.push(Array(Se).fill(0)), me[Ht][Ht] = 1;
    return me;
  }
  function Te(me, Se) {
    for (var xt = [], Ht = 0; Ht < Se; Ht++)
      xt[Ht] = Array(Se).fill(0);
    var Bt = 0;
    for (var ut of me) {
      for (var Tt = ut.length, Yt = 0; Yt < Tt; Yt++)
        for (var an = 0; an < Tt; an++)
          xt[Bt + Yt][Bt + an] = ut[Yt][an];
      Bt += Tt;
    }
    return xt;
  }
  function De(me, Se, xt) {
    for (var Ht = 0; Ht < me.length; Ht++)
      if (xt(me[Ht], Se))
        return Ht;
    return -1;
  }
  function be(me, Se, xt, Ht, Bt) {
    for (var ut = Bt === "BigNumber" ? d(1e3) : 1e3, Tt, Yt = 0; Yt < 5; ++Yt) {
      Tt = ze(Se, xt, Bt);
      try {
        Tt = m(me, Tt);
      } catch {
        continue;
      }
      if (G(Be(Tt), ut))
        break;
    }
    if (Yt >= 5)
      return null;
    for (Yt = 0; ; ) {
      var an = m(me, Tt);
      if (q(Be(ke(Tt, [an])), Ht))
        break;
      if (++Yt >= 10)
        return null;
      Tt = Me(an);
    }
    return Tt;
  }
  function ze(me, Se, xt) {
    var Ht = xt === "BigNumber", Bt = xt === "Complex", ut = Array(me).fill(0).map((Tt) => 2 * Math.random() - 1);
    return Ht && (ut = ut.map((Tt) => d(Tt))), Bt && (ut = ut.map((Tt) => W(Tt))), ut = ke(ut, Se), Me(ut, xt);
  }
  function ke(me, Se) {
    var xt = h(me);
    for (var Ht of Se)
      Ht = S(Ht, xt), me = s(me, a(u(_e(Ht, me), _e(Ht, Ht)), Ht));
    return me;
  }
  function Be(me) {
    return E(c(_e(me, me)));
  }
  function Me(me, Se) {
    var xt = Se === "BigNumber", Ht = Se === "Complex", Bt = xt ? d(1) : Ht ? W(1) : 1;
    return a(u(Bt, Be(me)), me);
  }
  return Le;
}
function createRealSymmetric(r) {
  var {
    config: e,
    addScalar: s,
    subtract: o,
    abs: a,
    atan: l,
    cos: u,
    sin: c,
    multiplyScalar: E,
    inv: d,
    bignumber: f,
    multiply: h,
    add: S
  } = r;
  function R(Ee, Ge) {
    var ve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.relTol, te = arguments.length > 3 ? arguments[3] : void 0, ae = arguments.length > 4 ? arguments[4] : void 0;
    if (te === "number")
      return _(Ee, ve, ae);
    if (te === "BigNumber")
      return m(Ee, ve, ae);
    throw TypeError("Unsupported data type: " + te);
  }
  function _(Ee, Ge, ve) {
    var te = Ee.length, ae = Math.abs(Ge / te), v, Te;
    if (ve) {
      Te = new Array(te);
      for (var De = 0; De < te; De++)
        Te[De] = Array(te).fill(0), Te[De][De] = 1;
    }
    for (var be = _e(Ee); Math.abs(be[1]) >= Math.abs(ae); ) {
      var ze = be[0][0], ke = be[0][1];
      v = L(Ee[ze][ze], Ee[ke][ke], Ee[ze][ke]), Ee = fe(Ee, v, ze, ke), ve && (Te = W(Te, v, ze, ke)), be = _e(Ee);
    }
    for (var Be = Array(te).fill(0), Me = 0; Me < te; Me++)
      Be[Me] = Ee[Me][Me];
    return Fe(clone$2(Be), Te, ve);
  }
  function m(Ee, Ge, ve) {
    var te = Ee.length, ae = a(Ge / te), v, Te;
    if (ve) {
      Te = new Array(te);
      for (var De = 0; De < te; De++)
        Te[De] = Array(te).fill(0), Te[De][De] = 1;
    }
    for (var be = Le(Ee); a(be[1]) >= a(ae); ) {
      var ze = be[0][0], ke = be[0][1];
      v = F(Ee[ze][ze], Ee[ke][ke], Ee[ze][ke]), Ee = q(Ee, v, ze, ke), ve && (Te = G(Te, v, ze, ke)), be = Le(Ee);
    }
    for (var Be = Array(te).fill(0), Me = 0; Me < te; Me++)
      Be[Me] = Ee[Me][Me];
    return Fe(clone$2(Be), Te, ve);
  }
  function L(Ee, Ge, ve) {
    var te = Ge - Ee;
    return Math.abs(te) <= e.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * ve / (Ge - Ee));
  }
  function F(Ee, Ge, ve) {
    var te = o(Ge, Ee);
    return a(te) <= e.relTol ? f(-1).acos().div(4) : E(0.5, l(h(2, ve, d(te))));
  }
  function W(Ee, Ge, ve, te) {
    for (var ae = Ee.length, v = Math.cos(Ge), Te = Math.sin(Ge), De = Array(ae).fill(0), be = Array(ae).fill(0), ze = 0; ze < ae; ze++)
      De[ze] = v * Ee[ze][ve] - Te * Ee[ze][te], be[ze] = Te * Ee[ze][ve] + v * Ee[ze][te];
    for (var ke = 0; ke < ae; ke++)
      Ee[ke][ve] = De[ke], Ee[ke][te] = be[ke];
    return Ee;
  }
  function G(Ee, Ge, ve, te) {
    for (var ae = Ee.length, v = u(Ge), Te = c(Ge), De = Array(ae).fill(f(0)), be = Array(ae).fill(f(0)), ze = 0; ze < ae; ze++)
      De[ze] = o(E(v, Ee[ze][ve]), E(Te, Ee[ze][te])), be[ze] = s(E(Te, Ee[ze][ve]), E(v, Ee[ze][te]));
    for (var ke = 0; ke < ae; ke++)
      Ee[ke][ve] = De[ke], Ee[ke][te] = be[ke];
    return Ee;
  }
  function q(Ee, Ge, ve, te) {
    for (var ae = Ee.length, v = f(u(Ge)), Te = f(c(Ge)), De = E(v, v), be = E(Te, Te), ze = Array(ae).fill(f(0)), ke = Array(ae).fill(f(0)), Be = h(f(2), v, Te, Ee[ve][te]), Me = s(o(E(De, Ee[ve][ve]), Be), E(be, Ee[te][te])), me = S(E(be, Ee[ve][ve]), Be, E(De, Ee[te][te])), Se = 0; Se < ae; Se++)
      ze[Se] = o(E(v, Ee[ve][Se]), E(Te, Ee[te][Se])), ke[Se] = s(E(Te, Ee[ve][Se]), E(v, Ee[te][Se]));
    Ee[ve][ve] = Me, Ee[te][te] = me, Ee[ve][te] = f(0), Ee[te][ve] = f(0);
    for (var xt = 0; xt < ae; xt++)
      xt !== ve && xt !== te && (Ee[ve][xt] = ze[xt], Ee[xt][ve] = ze[xt], Ee[te][xt] = ke[xt], Ee[xt][te] = ke[xt]);
    return Ee;
  }
  function fe(Ee, Ge, ve, te) {
    for (var ae = Ee.length, v = Math.cos(Ge), Te = Math.sin(Ge), De = v * v, be = Te * Te, ze = Array(ae).fill(0), ke = Array(ae).fill(0), Be = De * Ee[ve][ve] - 2 * v * Te * Ee[ve][te] + be * Ee[te][te], Me = be * Ee[ve][ve] + 2 * v * Te * Ee[ve][te] + De * Ee[te][te], me = 0; me < ae; me++)
      ze[me] = v * Ee[ve][me] - Te * Ee[te][me], ke[me] = Te * Ee[ve][me] + v * Ee[te][me];
    Ee[ve][ve] = Be, Ee[te][te] = Me, Ee[ve][te] = 0, Ee[te][ve] = 0;
    for (var Se = 0; Se < ae; Se++)
      Se !== ve && Se !== te && (Ee[ve][Se] = ze[Se], Ee[Se][ve] = ze[Se], Ee[te][Se] = ke[Se], Ee[Se][te] = ke[Se]);
    return Ee;
  }
  function _e(Ee) {
    for (var Ge = Ee.length, ve = 0, te = [0, 1], ae = 0; ae < Ge; ae++)
      for (var v = ae + 1; v < Ge; v++)
        Math.abs(ve) < Math.abs(Ee[ae][v]) && (ve = Math.abs(Ee[ae][v]), te = [ae, v]);
    return [te, ve];
  }
  function Le(Ee) {
    for (var Ge = Ee.length, ve = 0, te = [0, 1], ae = 0; ae < Ge; ae++)
      for (var v = ae + 1; v < Ge; v++)
        a(ve) < a(Ee[ae][v]) && (ve = a(Ee[ae][v]), te = [ae, v]);
    return [te, ve];
  }
  function Fe(Ee, Ge, ve) {
    var te = Ee.length, ae = Array(te), v;
    if (ve) {
      v = Array(te);
      for (var Te = 0; Te < te; Te++)
        v[Te] = Array(te);
    }
    for (var De = 0; De < te; De++) {
      for (var be = 0, ze = Ee[0], ke = 0; ke < Ee.length; ke++)
        a(Ee[ke]) < a(ze) && (be = ke, ze = Ee[be]);
      if (ae[De] = Ee.splice(be, 1)[0], ve)
        for (var Be = 0; Be < te; Be++)
          v[De][Be] = Ge[Be][be], Ge[Be].splice(be, 1);
    }
    if (!ve)
      return {
        values: ae
      };
    var Me = v.map((me, Se) => ({
      value: ae[Se],
      vector: me
    }));
    return {
      values: ae,
      eigenvectors: Me
    };
  }
  return R;
}
var name$1 = "eigs", dependencies$1 = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], createEigs = /* @__PURE__ */ factory(name$1, dependencies$1, (r) => {
  var {
    config: e,
    typed: s,
    matrix: o,
    addScalar: a,
    subtract: l,
    equal: u,
    abs: c,
    atan: E,
    cos: d,
    sin: f,
    multiplyScalar: h,
    divideScalar: S,
    inv: R,
    bignumber: _,
    multiply: m,
    add: L,
    larger: F,
    column: W,
    flatten: G,
    number: q,
    complex: fe,
    sqrt: _e,
    diag: Le,
    size: Fe,
    reshape: Ee,
    qr: Ge,
    usolve: ve,
    usolveAll: te,
    im: ae,
    re: v,
    smaller: Te,
    matrixFromColumns: De,
    dot: be
  } = r, ze = createRealSymmetric({
    config: e,
    addScalar: a,
    subtract: l,
    column: W,
    flatten: G,
    equal: u,
    abs: c,
    atan: E,
    cos: d,
    sin: f,
    multiplyScalar: h,
    inv: R,
    bignumber: _,
    complex: fe,
    multiply: m,
    add: L
  }), ke = createComplexEigs({
    config: e,
    addScalar: a,
    subtract: l,
    multiply: m,
    multiplyScalar: h,
    flatten: G,
    divideScalar: S,
    sqrt: _e,
    abs: c,
    bignumber: _,
    diag: Le,
    size: Fe,
    reshape: Ee,
    qr: Ge,
    inv: R,
    usolve: ve,
    usolveAll: te,
    equal: u,
    complex: fe,
    larger: F,
    smaller: Te,
    matrixFromColumns: De,
    dot: be
  });
  return s("eigs", {
    // The conversion to matrix in the first two implementations,
    // just to convert back to an array right away in
    // computeValuesAndVectors, is unfortunate, and should perhaps be
    // streamlined. It is done because the Matrix object carries some
    // type information about its entries, and so constructing the matrix
    // is a roundabout way of doing type detection.
    Array: function(ut) {
      return Be(o(ut));
    },
    "Array, number|BigNumber": function(ut, Tt) {
      return Be(o(ut), {
        precision: Tt
      });
    },
    "Array, Object"(Bt, ut) {
      return Be(o(Bt), ut);
    },
    Matrix: function(ut) {
      return Be(ut, {
        matricize: !0
      });
    },
    "Matrix, number|BigNumber": function(ut, Tt) {
      return Be(ut, {
        precision: Tt,
        matricize: !0
      });
    },
    "Matrix, Object": function(ut, Tt) {
      var Yt = {
        matricize: !0
      };
      return _extends$1(Yt, Tt), Be(ut, Yt);
    }
  });
  function Be(Bt) {
    var ut, Tt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Yt = "eigenvectors" in Tt ? Tt.eigenvectors : !0, an = (ut = Tt.precision) !== null && ut !== void 0 ? ut : e.relTol, Ct = Me(Bt, an, Yt);
    return Tt.matricize && (Ct.values = o(Ct.values), Yt && (Ct.eigenvectors = Ct.eigenvectors.map((st) => {
      var {
        value: jt,
        vector: lt
      } = st;
      return {
        value: jt,
        vector: o(lt)
      };
    }))), Yt && Object.defineProperty(Ct, "vectors", {
      enumerable: !1,
      // to make sure that the eigenvectors can still be
      // converted to string.
      get: () => {
        throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
      }
    }), Ct;
  }
  function Me(Bt, ut, Tt) {
    var Yt = Bt.toArray(), an = Bt.size();
    if (an.length !== 2 || an[0] !== an[1])
      throw new RangeError("Matrix must be square (size: ".concat(format(an), ")"));
    var Ct = an[0];
    if (Se(Yt, Ct, ut) && (xt(Yt, Ct), me(Yt, Ct, ut))) {
      var st = Ht(Bt, Yt, Ct);
      return ze(Yt, Ct, ut, st, Tt);
    }
    var jt = Ht(Bt, Yt, Ct);
    return ke(Yt, Ct, ut, jt, Tt);
  }
  function me(Bt, ut, Tt) {
    for (var Yt = 0; Yt < ut; Yt++)
      for (var an = Yt; an < ut; an++)
        if (F(_(c(l(Bt[Yt][an], Bt[an][Yt]))), Tt))
          return !1;
    return !0;
  }
  function Se(Bt, ut, Tt) {
    for (var Yt = 0; Yt < ut; Yt++)
      for (var an = 0; an < ut; an++)
        if (F(_(c(ae(Bt[Yt][an]))), Tt))
          return !1;
    return !0;
  }
  function xt(Bt, ut) {
    for (var Tt = 0; Tt < ut; Tt++)
      for (var Yt = 0; Yt < ut; Yt++)
        Bt[Tt][Yt] = v(Bt[Tt][Yt]);
  }
  function Ht(Bt, ut, Tt) {
    var Yt = Bt.datatype();
    if (Yt === "number" || Yt === "BigNumber" || Yt === "Complex")
      return Yt;
    for (var an = !1, Ct = !1, st = !1, jt = 0; jt < Tt; jt++)
      for (var lt = 0; lt < Tt; lt++) {
        var Zt = ut[jt][lt];
        if (isNumber(Zt) || isFraction(Zt))
          an = !0;
        else if (isBigNumber(Zt))
          Ct = !0;
        else if (isComplex(Zt))
          st = !0;
        else
          throw TypeError("Unsupported type in Matrix: " + typeOf(Zt));
      }
    if (Ct && st && console.warn("Complex BigNumbers not supported, this operation will lose precission."), st) {
      for (var Et = 0; Et < Tt; Et++)
        for (var Ke = 0; Ke < Tt; Ke++)
          ut[Et][Ke] = fe(ut[Et][Ke]);
      return "Complex";
    }
    if (Ct) {
      for (var $e = 0; $e < Tt; $e++)
        for (var pt = 0; pt < Tt; pt++)
          ut[$e][pt] = _(ut[$e][pt]);
      return "BigNumber";
    }
    if (an) {
      for (var Jt = 0; Jt < Tt; Jt++)
        for (var In = 0; In < Tt; In++)
          ut[Jt][In] = q(ut[Jt][In]);
      return "number";
    } else
      throw TypeError("Matrix contains unsupported types only.");
  }
}), cryptoBrowserify = {}, buffer$1 = {}, base64Js = {};
base64Js.byteLength = byteLength$1;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup$2 = [], revLookup = [], Arr = typeof Uint8Array < "u" ? Uint8Array : Array, code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i)
  lookup$2[i] = code[i], revLookup[code.charCodeAt(i)] = i;
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(r) {
  var e = r.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var s = r.indexOf("=");
  s === -1 && (s = e);
  var o = s === e ? 0 : 4 - s % 4;
  return [s, o];
}
function byteLength$1(r) {
  var e = getLens(r), s = e[0], o = e[1];
  return (s + o) * 3 / 4 - o;
}
function _byteLength(r, e, s) {
  return (e + s) * 3 / 4 - s;
}
function toByteArray(r) {
  var e, s = getLens(r), o = s[0], a = s[1], l = new Arr(_byteLength(r, o, a)), u = 0, c = a > 0 ? o - 4 : o, E;
  for (E = 0; E < c; E += 4)
    e = revLookup[r.charCodeAt(E)] << 18 | revLookup[r.charCodeAt(E + 1)] << 12 | revLookup[r.charCodeAt(E + 2)] << 6 | revLookup[r.charCodeAt(E + 3)], l[u++] = e >> 16 & 255, l[u++] = e >> 8 & 255, l[u++] = e & 255;
  return a === 2 && (e = revLookup[r.charCodeAt(E)] << 2 | revLookup[r.charCodeAt(E + 1)] >> 4, l[u++] = e & 255), a === 1 && (e = revLookup[r.charCodeAt(E)] << 10 | revLookup[r.charCodeAt(E + 1)] << 4 | revLookup[r.charCodeAt(E + 2)] >> 2, l[u++] = e >> 8 & 255, l[u++] = e & 255), l;
}
function tripletToBase64(r) {
  return lookup$2[r >> 18 & 63] + lookup$2[r >> 12 & 63] + lookup$2[r >> 6 & 63] + lookup$2[r & 63];
}
function encodeChunk(r, e, s) {
  for (var o, a = [], l = e; l < s; l += 3)
    o = (r[l] << 16 & 16711680) + (r[l + 1] << 8 & 65280) + (r[l + 2] & 255), a.push(tripletToBase64(o));
  return a.join("");
}
function fromByteArray(r) {
  for (var e, s = r.length, o = s % 3, a = [], l = 16383, u = 0, c = s - o; u < c; u += l)
    a.push(encodeChunk(r, u, u + l > c ? c : u + l));
  return o === 1 ? (e = r[s - 1], a.push(
    lookup$2[e >> 2] + lookup$2[e << 4 & 63] + "=="
  )) : o === 2 && (e = (r[s - 2] << 8) + r[s - 1], a.push(
    lookup$2[e >> 10] + lookup$2[e >> 4 & 63] + lookup$2[e << 2 & 63] + "="
  )), a.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(r, e, s, o, a) {
  var l, u, c = a * 8 - o - 1, E = (1 << c) - 1, d = E >> 1, f = -7, h = s ? a - 1 : 0, S = s ? -1 : 1, R = r[e + h];
  for (h += S, l = R & (1 << -f) - 1, R >>= -f, f += c; f > 0; l = l * 256 + r[e + h], h += S, f -= 8)
    ;
  for (u = l & (1 << -f) - 1, l >>= -f, f += o; f > 0; u = u * 256 + r[e + h], h += S, f -= 8)
    ;
  if (l === 0)
    l = 1 - d;
  else {
    if (l === E)
      return u ? NaN : (R ? -1 : 1) * (1 / 0);
    u = u + Math.pow(2, o), l = l - d;
  }
  return (R ? -1 : 1) * u * Math.pow(2, l - o);
};
ieee754.write = function(r, e, s, o, a, l) {
  var u, c, E, d = l * 8 - a - 1, f = (1 << d) - 1, h = f >> 1, S = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, R = o ? 0 : l - 1, _ = o ? 1 : -1, m = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (c = isNaN(e) ? 1 : 0, u = f) : (u = Math.floor(Math.log(e) / Math.LN2), e * (E = Math.pow(2, -u)) < 1 && (u--, E *= 2), u + h >= 1 ? e += S / E : e += S * Math.pow(2, 1 - h), e * E >= 2 && (u++, E /= 2), u + h >= f ? (c = 0, u = f) : u + h >= 1 ? (c = (e * E - 1) * Math.pow(2, a), u = u + h) : (c = e * Math.pow(2, h - 1) * Math.pow(2, a), u = 0)); a >= 8; r[s + R] = c & 255, R += _, c /= 256, a -= 8)
    ;
  for (u = u << a | c, d += a; d > 0; r[s + R] = u & 255, R += _, u /= 256, d -= 8)
    ;
  r[s + R - _] |= m * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(r) {
  var e = base64Js, s = ieee754, o = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  r.Buffer = c, r.SlowBuffer = W, r.INSPECT_MAX_BYTES = 50;
  var a = 2147483647;
  r.kMaxLength = a, c.TYPED_ARRAY_SUPPORT = l(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function l() {
    try {
      var Et = new Uint8Array(1), Ke = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(Ke, Uint8Array.prototype), Object.setPrototypeOf(Et, Ke), Et.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(c.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(c.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.byteOffset;
    }
  });
  function u(Et) {
    if (Et > a)
      throw new RangeError('The value "' + Et + '" is invalid for option "size"');
    var Ke = new Uint8Array(Et);
    return Object.setPrototypeOf(Ke, c.prototype), Ke;
  }
  function c(Et, Ke, $e) {
    if (typeof Et == "number") {
      if (typeof Ke == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return h(Et);
    }
    return E(Et, Ke, $e);
  }
  c.poolSize = 8192;
  function E(Et, Ke, $e) {
    if (typeof Et == "string")
      return S(Et, Ke);
    if (ArrayBuffer.isView(Et))
      return _(Et);
    if (Et == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Et
      );
    if (jt(Et, ArrayBuffer) || Et && jt(Et.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (jt(Et, SharedArrayBuffer) || Et && jt(Et.buffer, SharedArrayBuffer)))
      return m(Et, Ke, $e);
    if (typeof Et == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    var pt = Et.valueOf && Et.valueOf();
    if (pt != null && pt !== Et)
      return c.from(pt, Ke, $e);
    var Jt = L(Et);
    if (Jt)
      return Jt;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof Et[Symbol.toPrimitive] == "function")
      return c.from(
        Et[Symbol.toPrimitive]("string"),
        Ke,
        $e
      );
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof Et
    );
  }
  c.from = function(Et, Ke, $e) {
    return E(Et, Ke, $e);
  }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
  function d(Et) {
    if (typeof Et != "number")
      throw new TypeError('"size" argument must be of type number');
    if (Et < 0)
      throw new RangeError('The value "' + Et + '" is invalid for option "size"');
  }
  function f(Et, Ke, $e) {
    return d(Et), Et <= 0 ? u(Et) : Ke !== void 0 ? typeof $e == "string" ? u(Et).fill(Ke, $e) : u(Et).fill(Ke) : u(Et);
  }
  c.alloc = function(Et, Ke, $e) {
    return f(Et, Ke, $e);
  };
  function h(Et) {
    return d(Et), u(Et < 0 ? 0 : F(Et) | 0);
  }
  c.allocUnsafe = function(Et) {
    return h(Et);
  }, c.allocUnsafeSlow = function(Et) {
    return h(Et);
  };
  function S(Et, Ke) {
    if ((typeof Ke != "string" || Ke === "") && (Ke = "utf8"), !c.isEncoding(Ke))
      throw new TypeError("Unknown encoding: " + Ke);
    var $e = G(Et, Ke) | 0, pt = u($e), Jt = pt.write(Et, Ke);
    return Jt !== $e && (pt = pt.slice(0, Jt)), pt;
  }
  function R(Et) {
    for (var Ke = Et.length < 0 ? 0 : F(Et.length) | 0, $e = u(Ke), pt = 0; pt < Ke; pt += 1)
      $e[pt] = Et[pt] & 255;
    return $e;
  }
  function _(Et) {
    if (jt(Et, Uint8Array)) {
      var Ke = new Uint8Array(Et);
      return m(Ke.buffer, Ke.byteOffset, Ke.byteLength);
    }
    return R(Et);
  }
  function m(Et, Ke, $e) {
    if (Ke < 0 || Et.byteLength < Ke)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (Et.byteLength < Ke + ($e || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var pt;
    return Ke === void 0 && $e === void 0 ? pt = new Uint8Array(Et) : $e === void 0 ? pt = new Uint8Array(Et, Ke) : pt = new Uint8Array(Et, Ke, $e), Object.setPrototypeOf(pt, c.prototype), pt;
  }
  function L(Et) {
    if (c.isBuffer(Et)) {
      var Ke = F(Et.length) | 0, $e = u(Ke);
      return $e.length === 0 || Et.copy($e, 0, 0, Ke), $e;
    }
    if (Et.length !== void 0)
      return typeof Et.length != "number" || lt(Et.length) ? u(0) : R(Et);
    if (Et.type === "Buffer" && Array.isArray(Et.data))
      return R(Et.data);
  }
  function F(Et) {
    if (Et >= a)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
    return Et | 0;
  }
  function W(Et) {
    return +Et != Et && (Et = 0), c.alloc(+Et);
  }
  c.isBuffer = function(Ke) {
    return Ke != null && Ke._isBuffer === !0 && Ke !== c.prototype;
  }, c.compare = function(Ke, $e) {
    if (jt(Ke, Uint8Array) && (Ke = c.from(Ke, Ke.offset, Ke.byteLength)), jt($e, Uint8Array) && ($e = c.from($e, $e.offset, $e.byteLength)), !c.isBuffer(Ke) || !c.isBuffer($e))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (Ke === $e)
      return 0;
    for (var pt = Ke.length, Jt = $e.length, In = 0, Cn = Math.min(pt, Jt); In < Cn; ++In)
      if (Ke[In] !== $e[In]) {
        pt = Ke[In], Jt = $e[In];
        break;
      }
    return pt < Jt ? -1 : Jt < pt ? 1 : 0;
  }, c.isEncoding = function(Ke) {
    switch (String(Ke).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, c.concat = function(Ke, $e) {
    if (!Array.isArray(Ke))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (Ke.length === 0)
      return c.alloc(0);
    var pt;
    if ($e === void 0)
      for ($e = 0, pt = 0; pt < Ke.length; ++pt)
        $e += Ke[pt].length;
    var Jt = c.allocUnsafe($e), In = 0;
    for (pt = 0; pt < Ke.length; ++pt) {
      var Cn = Ke[pt];
      if (jt(Cn, Uint8Array))
        In + Cn.length > Jt.length ? c.from(Cn).copy(Jt, In) : Uint8Array.prototype.set.call(
          Jt,
          Cn,
          In
        );
      else if (c.isBuffer(Cn))
        Cn.copy(Jt, In);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      In += Cn.length;
    }
    return Jt;
  };
  function G(Et, Ke) {
    if (c.isBuffer(Et))
      return Et.length;
    if (ArrayBuffer.isView(Et) || jt(Et, ArrayBuffer))
      return Et.byteLength;
    if (typeof Et != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof Et
      );
    var $e = Et.length, pt = arguments.length > 2 && arguments[2] === !0;
    if (!pt && $e === 0)
      return 0;
    for (var Jt = !1; ; )
      switch (Ke) {
        case "ascii":
        case "latin1":
        case "binary":
          return $e;
        case "utf8":
        case "utf-8":
          return Tt(Et).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return $e * 2;
        case "hex":
          return $e >>> 1;
        case "base64":
          return Ct(Et).length;
        default:
          if (Jt)
            return pt ? -1 : Tt(Et).length;
          Ke = ("" + Ke).toLowerCase(), Jt = !0;
      }
  }
  c.byteLength = G;
  function q(Et, Ke, $e) {
    var pt = !1;
    if ((Ke === void 0 || Ke < 0) && (Ke = 0), Ke > this.length || (($e === void 0 || $e > this.length) && ($e = this.length), $e <= 0) || ($e >>>= 0, Ke >>>= 0, $e <= Ke))
      return "";
    for (Et || (Et = "utf8"); ; )
      switch (Et) {
        case "hex":
          return ke(this, Ke, $e);
        case "utf8":
        case "utf-8":
          return v(this, Ke, $e);
        case "ascii":
          return be(this, Ke, $e);
        case "latin1":
        case "binary":
          return ze(this, Ke, $e);
        case "base64":
          return ae(this, Ke, $e);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Be(this, Ke, $e);
        default:
          if (pt)
            throw new TypeError("Unknown encoding: " + Et);
          Et = (Et + "").toLowerCase(), pt = !0;
      }
  }
  c.prototype._isBuffer = !0;
  function fe(Et, Ke, $e) {
    var pt = Et[Ke];
    Et[Ke] = Et[$e], Et[$e] = pt;
  }
  c.prototype.swap16 = function() {
    var Ke = this.length;
    if (Ke % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var $e = 0; $e < Ke; $e += 2)
      fe(this, $e, $e + 1);
    return this;
  }, c.prototype.swap32 = function() {
    var Ke = this.length;
    if (Ke % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var $e = 0; $e < Ke; $e += 4)
      fe(this, $e, $e + 3), fe(this, $e + 1, $e + 2);
    return this;
  }, c.prototype.swap64 = function() {
    var Ke = this.length;
    if (Ke % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var $e = 0; $e < Ke; $e += 8)
      fe(this, $e, $e + 7), fe(this, $e + 1, $e + 6), fe(this, $e + 2, $e + 5), fe(this, $e + 3, $e + 4);
    return this;
  }, c.prototype.toString = function() {
    var Ke = this.length;
    return Ke === 0 ? "" : arguments.length === 0 ? v(this, 0, Ke) : q.apply(this, arguments);
  }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(Ke) {
    if (!c.isBuffer(Ke))
      throw new TypeError("Argument must be a Buffer");
    return this === Ke ? !0 : c.compare(this, Ke) === 0;
  }, c.prototype.inspect = function() {
    var Ke = "", $e = r.INSPECT_MAX_BYTES;
    return Ke = this.toString("hex", 0, $e).replace(/(.{2})/g, "$1 ").trim(), this.length > $e && (Ke += " ... "), "<Buffer " + Ke + ">";
  }, o && (c.prototype[o] = c.prototype.inspect), c.prototype.compare = function(Ke, $e, pt, Jt, In) {
    if (jt(Ke, Uint8Array) && (Ke = c.from(Ke, Ke.offset, Ke.byteLength)), !c.isBuffer(Ke))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof Ke
      );
    if ($e === void 0 && ($e = 0), pt === void 0 && (pt = Ke ? Ke.length : 0), Jt === void 0 && (Jt = 0), In === void 0 && (In = this.length), $e < 0 || pt > Ke.length || Jt < 0 || In > this.length)
      throw new RangeError("out of range index");
    if (Jt >= In && $e >= pt)
      return 0;
    if (Jt >= In)
      return -1;
    if ($e >= pt)
      return 1;
    if ($e >>>= 0, pt >>>= 0, Jt >>>= 0, In >>>= 0, this === Ke)
      return 0;
    for (var Cn = In - Jt, It = pt - $e, ht = Math.min(Cn, It), Wt = this.slice(Jt, In), hn = Ke.slice($e, pt), Vt = 0; Vt < ht; ++Vt)
      if (Wt[Vt] !== hn[Vt]) {
        Cn = Wt[Vt], It = hn[Vt];
        break;
      }
    return Cn < It ? -1 : It < Cn ? 1 : 0;
  };
  function _e(Et, Ke, $e, pt, Jt) {
    if (Et.length === 0)
      return -1;
    if (typeof $e == "string" ? (pt = $e, $e = 0) : $e > 2147483647 ? $e = 2147483647 : $e < -2147483648 && ($e = -2147483648), $e = +$e, lt($e) && ($e = Jt ? 0 : Et.length - 1), $e < 0 && ($e = Et.length + $e), $e >= Et.length) {
      if (Jt)
        return -1;
      $e = Et.length - 1;
    } else if ($e < 0)
      if (Jt)
        $e = 0;
      else
        return -1;
    if (typeof Ke == "string" && (Ke = c.from(Ke, pt)), c.isBuffer(Ke))
      return Ke.length === 0 ? -1 : Le(Et, Ke, $e, pt, Jt);
    if (typeof Ke == "number")
      return Ke = Ke & 255, typeof Uint8Array.prototype.indexOf == "function" ? Jt ? Uint8Array.prototype.indexOf.call(Et, Ke, $e) : Uint8Array.prototype.lastIndexOf.call(Et, Ke, $e) : Le(Et, [Ke], $e, pt, Jt);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Le(Et, Ke, $e, pt, Jt) {
    var In = 1, Cn = Et.length, It = Ke.length;
    if (pt !== void 0 && (pt = String(pt).toLowerCase(), pt === "ucs2" || pt === "ucs-2" || pt === "utf16le" || pt === "utf-16le")) {
      if (Et.length < 2 || Ke.length < 2)
        return -1;
      In = 2, Cn /= 2, It /= 2, $e /= 2;
    }
    function ht(Rn, Nn) {
      return In === 1 ? Rn[Nn] : Rn.readUInt16BE(Nn * In);
    }
    var Wt;
    if (Jt) {
      var hn = -1;
      for (Wt = $e; Wt < Cn; Wt++)
        if (ht(Et, Wt) === ht(Ke, hn === -1 ? 0 : Wt - hn)) {
          if (hn === -1 && (hn = Wt), Wt - hn + 1 === It)
            return hn * In;
        } else
          hn !== -1 && (Wt -= Wt - hn), hn = -1;
    } else
      for ($e + It > Cn && ($e = Cn - It), Wt = $e; Wt >= 0; Wt--) {
        for (var Vt = !0, Tn = 0; Tn < It; Tn++)
          if (ht(Et, Wt + Tn) !== ht(Ke, Tn)) {
            Vt = !1;
            break;
          }
        if (Vt)
          return Wt;
      }
    return -1;
  }
  c.prototype.includes = function(Ke, $e, pt) {
    return this.indexOf(Ke, $e, pt) !== -1;
  }, c.prototype.indexOf = function(Ke, $e, pt) {
    return _e(this, Ke, $e, pt, !0);
  }, c.prototype.lastIndexOf = function(Ke, $e, pt) {
    return _e(this, Ke, $e, pt, !1);
  };
  function Fe(Et, Ke, $e, pt) {
    $e = Number($e) || 0;
    var Jt = Et.length - $e;
    pt ? (pt = Number(pt), pt > Jt && (pt = Jt)) : pt = Jt;
    var In = Ke.length;
    pt > In / 2 && (pt = In / 2);
    for (var Cn = 0; Cn < pt; ++Cn) {
      var It = parseInt(Ke.substr(Cn * 2, 2), 16);
      if (lt(It))
        return Cn;
      Et[$e + Cn] = It;
    }
    return Cn;
  }
  function Ee(Et, Ke, $e, pt) {
    return st(Tt(Ke, Et.length - $e), Et, $e, pt);
  }
  function Ge(Et, Ke, $e, pt) {
    return st(Yt(Ke), Et, $e, pt);
  }
  function ve(Et, Ke, $e, pt) {
    return st(Ct(Ke), Et, $e, pt);
  }
  function te(Et, Ke, $e, pt) {
    return st(an(Ke, Et.length - $e), Et, $e, pt);
  }
  c.prototype.write = function(Ke, $e, pt, Jt) {
    if ($e === void 0)
      Jt = "utf8", pt = this.length, $e = 0;
    else if (pt === void 0 && typeof $e == "string")
      Jt = $e, pt = this.length, $e = 0;
    else if (isFinite($e))
      $e = $e >>> 0, isFinite(pt) ? (pt = pt >>> 0, Jt === void 0 && (Jt = "utf8")) : (Jt = pt, pt = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var In = this.length - $e;
    if ((pt === void 0 || pt > In) && (pt = In), Ke.length > 0 && (pt < 0 || $e < 0) || $e > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Jt || (Jt = "utf8");
    for (var Cn = !1; ; )
      switch (Jt) {
        case "hex":
          return Fe(this, Ke, $e, pt);
        case "utf8":
        case "utf-8":
          return Ee(this, Ke, $e, pt);
        case "ascii":
        case "latin1":
        case "binary":
          return Ge(this, Ke, $e, pt);
        case "base64":
          return ve(this, Ke, $e, pt);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return te(this, Ke, $e, pt);
        default:
          if (Cn)
            throw new TypeError("Unknown encoding: " + Jt);
          Jt = ("" + Jt).toLowerCase(), Cn = !0;
      }
  }, c.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ae(Et, Ke, $e) {
    return Ke === 0 && $e === Et.length ? e.fromByteArray(Et) : e.fromByteArray(Et.slice(Ke, $e));
  }
  function v(Et, Ke, $e) {
    $e = Math.min(Et.length, $e);
    for (var pt = [], Jt = Ke; Jt < $e; ) {
      var In = Et[Jt], Cn = null, It = In > 239 ? 4 : In > 223 ? 3 : In > 191 ? 2 : 1;
      if (Jt + It <= $e) {
        var ht, Wt, hn, Vt;
        switch (It) {
          case 1:
            In < 128 && (Cn = In);
            break;
          case 2:
            ht = Et[Jt + 1], (ht & 192) === 128 && (Vt = (In & 31) << 6 | ht & 63, Vt > 127 && (Cn = Vt));
            break;
          case 3:
            ht = Et[Jt + 1], Wt = Et[Jt + 2], (ht & 192) === 128 && (Wt & 192) === 128 && (Vt = (In & 15) << 12 | (ht & 63) << 6 | Wt & 63, Vt > 2047 && (Vt < 55296 || Vt > 57343) && (Cn = Vt));
            break;
          case 4:
            ht = Et[Jt + 1], Wt = Et[Jt + 2], hn = Et[Jt + 3], (ht & 192) === 128 && (Wt & 192) === 128 && (hn & 192) === 128 && (Vt = (In & 15) << 18 | (ht & 63) << 12 | (Wt & 63) << 6 | hn & 63, Vt > 65535 && Vt < 1114112 && (Cn = Vt));
        }
      }
      Cn === null ? (Cn = 65533, It = 1) : Cn > 65535 && (Cn -= 65536, pt.push(Cn >>> 10 & 1023 | 55296), Cn = 56320 | Cn & 1023), pt.push(Cn), Jt += It;
    }
    return De(pt);
  }
  var Te = 4096;
  function De(Et) {
    var Ke = Et.length;
    if (Ke <= Te)
      return String.fromCharCode.apply(String, Et);
    for (var $e = "", pt = 0; pt < Ke; )
      $e += String.fromCharCode.apply(
        String,
        Et.slice(pt, pt += Te)
      );
    return $e;
  }
  function be(Et, Ke, $e) {
    var pt = "";
    $e = Math.min(Et.length, $e);
    for (var Jt = Ke; Jt < $e; ++Jt)
      pt += String.fromCharCode(Et[Jt] & 127);
    return pt;
  }
  function ze(Et, Ke, $e) {
    var pt = "";
    $e = Math.min(Et.length, $e);
    for (var Jt = Ke; Jt < $e; ++Jt)
      pt += String.fromCharCode(Et[Jt]);
    return pt;
  }
  function ke(Et, Ke, $e) {
    var pt = Et.length;
    (!Ke || Ke < 0) && (Ke = 0), (!$e || $e < 0 || $e > pt) && ($e = pt);
    for (var Jt = "", In = Ke; In < $e; ++In)
      Jt += Zt[Et[In]];
    return Jt;
  }
  function Be(Et, Ke, $e) {
    for (var pt = Et.slice(Ke, $e), Jt = "", In = 0; In < pt.length - 1; In += 2)
      Jt += String.fromCharCode(pt[In] + pt[In + 1] * 256);
    return Jt;
  }
  c.prototype.slice = function(Ke, $e) {
    var pt = this.length;
    Ke = ~~Ke, $e = $e === void 0 ? pt : ~~$e, Ke < 0 ? (Ke += pt, Ke < 0 && (Ke = 0)) : Ke > pt && (Ke = pt), $e < 0 ? ($e += pt, $e < 0 && ($e = 0)) : $e > pt && ($e = pt), $e < Ke && ($e = Ke);
    var Jt = this.subarray(Ke, $e);
    return Object.setPrototypeOf(Jt, c.prototype), Jt;
  };
  function Me(Et, Ke, $e) {
    if (Et % 1 !== 0 || Et < 0)
      throw new RangeError("offset is not uint");
    if (Et + Ke > $e)
      throw new RangeError("Trying to access beyond buffer length");
  }
  c.prototype.readUintLE = c.prototype.readUIntLE = function(Ke, $e, pt) {
    Ke = Ke >>> 0, $e = $e >>> 0, pt || Me(Ke, $e, this.length);
    for (var Jt = this[Ke], In = 1, Cn = 0; ++Cn < $e && (In *= 256); )
      Jt += this[Ke + Cn] * In;
    return Jt;
  }, c.prototype.readUintBE = c.prototype.readUIntBE = function(Ke, $e, pt) {
    Ke = Ke >>> 0, $e = $e >>> 0, pt || Me(Ke, $e, this.length);
    for (var Jt = this[Ke + --$e], In = 1; $e > 0 && (In *= 256); )
      Jt += this[Ke + --$e] * In;
    return Jt;
  }, c.prototype.readUint8 = c.prototype.readUInt8 = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 1, this.length), this[Ke];
  }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 2, this.length), this[Ke] | this[Ke + 1] << 8;
  }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 2, this.length), this[Ke] << 8 | this[Ke + 1];
  }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), (this[Ke] | this[Ke + 1] << 8 | this[Ke + 2] << 16) + this[Ke + 3] * 16777216;
  }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), this[Ke] * 16777216 + (this[Ke + 1] << 16 | this[Ke + 2] << 8 | this[Ke + 3]);
  }, c.prototype.readIntLE = function(Ke, $e, pt) {
    Ke = Ke >>> 0, $e = $e >>> 0, pt || Me(Ke, $e, this.length);
    for (var Jt = this[Ke], In = 1, Cn = 0; ++Cn < $e && (In *= 256); )
      Jt += this[Ke + Cn] * In;
    return In *= 128, Jt >= In && (Jt -= Math.pow(2, 8 * $e)), Jt;
  }, c.prototype.readIntBE = function(Ke, $e, pt) {
    Ke = Ke >>> 0, $e = $e >>> 0, pt || Me(Ke, $e, this.length);
    for (var Jt = $e, In = 1, Cn = this[Ke + --Jt]; Jt > 0 && (In *= 256); )
      Cn += this[Ke + --Jt] * In;
    return In *= 128, Cn >= In && (Cn -= Math.pow(2, 8 * $e)), Cn;
  }, c.prototype.readInt8 = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 1, this.length), this[Ke] & 128 ? (255 - this[Ke] + 1) * -1 : this[Ke];
  }, c.prototype.readInt16LE = function(Ke, $e) {
    Ke = Ke >>> 0, $e || Me(Ke, 2, this.length);
    var pt = this[Ke] | this[Ke + 1] << 8;
    return pt & 32768 ? pt | 4294901760 : pt;
  }, c.prototype.readInt16BE = function(Ke, $e) {
    Ke = Ke >>> 0, $e || Me(Ke, 2, this.length);
    var pt = this[Ke + 1] | this[Ke] << 8;
    return pt & 32768 ? pt | 4294901760 : pt;
  }, c.prototype.readInt32LE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), this[Ke] | this[Ke + 1] << 8 | this[Ke + 2] << 16 | this[Ke + 3] << 24;
  }, c.prototype.readInt32BE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), this[Ke] << 24 | this[Ke + 1] << 16 | this[Ke + 2] << 8 | this[Ke + 3];
  }, c.prototype.readFloatLE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), s.read(this, Ke, !0, 23, 4);
  }, c.prototype.readFloatBE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 4, this.length), s.read(this, Ke, !1, 23, 4);
  }, c.prototype.readDoubleLE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 8, this.length), s.read(this, Ke, !0, 52, 8);
  }, c.prototype.readDoubleBE = function(Ke, $e) {
    return Ke = Ke >>> 0, $e || Me(Ke, 8, this.length), s.read(this, Ke, !1, 52, 8);
  };
  function me(Et, Ke, $e, pt, Jt, In) {
    if (!c.isBuffer(Et))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (Ke > Jt || Ke < In)
      throw new RangeError('"value" argument is out of bounds');
    if ($e + pt > Et.length)
      throw new RangeError("Index out of range");
  }
  c.prototype.writeUintLE = c.prototype.writeUIntLE = function(Ke, $e, pt, Jt) {
    if (Ke = +Ke, $e = $e >>> 0, pt = pt >>> 0, !Jt) {
      var In = Math.pow(2, 8 * pt) - 1;
      me(this, Ke, $e, pt, In, 0);
    }
    var Cn = 1, It = 0;
    for (this[$e] = Ke & 255; ++It < pt && (Cn *= 256); )
      this[$e + It] = Ke / Cn & 255;
    return $e + pt;
  }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(Ke, $e, pt, Jt) {
    if (Ke = +Ke, $e = $e >>> 0, pt = pt >>> 0, !Jt) {
      var In = Math.pow(2, 8 * pt) - 1;
      me(this, Ke, $e, pt, In, 0);
    }
    var Cn = pt - 1, It = 1;
    for (this[$e + Cn] = Ke & 255; --Cn >= 0 && (It *= 256); )
      this[$e + Cn] = Ke / It & 255;
    return $e + pt;
  }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 1, 255, 0), this[$e] = Ke & 255, $e + 1;
  }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 2, 65535, 0), this[$e] = Ke & 255, this[$e + 1] = Ke >>> 8, $e + 2;
  }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 2, 65535, 0), this[$e] = Ke >>> 8, this[$e + 1] = Ke & 255, $e + 2;
  }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 4, 4294967295, 0), this[$e + 3] = Ke >>> 24, this[$e + 2] = Ke >>> 16, this[$e + 1] = Ke >>> 8, this[$e] = Ke & 255, $e + 4;
  }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 4, 4294967295, 0), this[$e] = Ke >>> 24, this[$e + 1] = Ke >>> 16, this[$e + 2] = Ke >>> 8, this[$e + 3] = Ke & 255, $e + 4;
  }, c.prototype.writeIntLE = function(Ke, $e, pt, Jt) {
    if (Ke = +Ke, $e = $e >>> 0, !Jt) {
      var In = Math.pow(2, 8 * pt - 1);
      me(this, Ke, $e, pt, In - 1, -In);
    }
    var Cn = 0, It = 1, ht = 0;
    for (this[$e] = Ke & 255; ++Cn < pt && (It *= 256); )
      Ke < 0 && ht === 0 && this[$e + Cn - 1] !== 0 && (ht = 1), this[$e + Cn] = (Ke / It >> 0) - ht & 255;
    return $e + pt;
  }, c.prototype.writeIntBE = function(Ke, $e, pt, Jt) {
    if (Ke = +Ke, $e = $e >>> 0, !Jt) {
      var In = Math.pow(2, 8 * pt - 1);
      me(this, Ke, $e, pt, In - 1, -In);
    }
    var Cn = pt - 1, It = 1, ht = 0;
    for (this[$e + Cn] = Ke & 255; --Cn >= 0 && (It *= 256); )
      Ke < 0 && ht === 0 && this[$e + Cn + 1] !== 0 && (ht = 1), this[$e + Cn] = (Ke / It >> 0) - ht & 255;
    return $e + pt;
  }, c.prototype.writeInt8 = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 1, 127, -128), Ke < 0 && (Ke = 255 + Ke + 1), this[$e] = Ke & 255, $e + 1;
  }, c.prototype.writeInt16LE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 2, 32767, -32768), this[$e] = Ke & 255, this[$e + 1] = Ke >>> 8, $e + 2;
  }, c.prototype.writeInt16BE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 2, 32767, -32768), this[$e] = Ke >>> 8, this[$e + 1] = Ke & 255, $e + 2;
  }, c.prototype.writeInt32LE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 4, 2147483647, -2147483648), this[$e] = Ke & 255, this[$e + 1] = Ke >>> 8, this[$e + 2] = Ke >>> 16, this[$e + 3] = Ke >>> 24, $e + 4;
  }, c.prototype.writeInt32BE = function(Ke, $e, pt) {
    return Ke = +Ke, $e = $e >>> 0, pt || me(this, Ke, $e, 4, 2147483647, -2147483648), Ke < 0 && (Ke = 4294967295 + Ke + 1), this[$e] = Ke >>> 24, this[$e + 1] = Ke >>> 16, this[$e + 2] = Ke >>> 8, this[$e + 3] = Ke & 255, $e + 4;
  };
  function Se(Et, Ke, $e, pt, Jt, In) {
    if ($e + pt > Et.length)
      throw new RangeError("Index out of range");
    if ($e < 0)
      throw new RangeError("Index out of range");
  }
  function xt(Et, Ke, $e, pt, Jt) {
    return Ke = +Ke, $e = $e >>> 0, Jt || Se(Et, Ke, $e, 4), s.write(Et, Ke, $e, pt, 23, 4), $e + 4;
  }
  c.prototype.writeFloatLE = function(Ke, $e, pt) {
    return xt(this, Ke, $e, !0, pt);
  }, c.prototype.writeFloatBE = function(Ke, $e, pt) {
    return xt(this, Ke, $e, !1, pt);
  };
  function Ht(Et, Ke, $e, pt, Jt) {
    return Ke = +Ke, $e = $e >>> 0, Jt || Se(Et, Ke, $e, 8), s.write(Et, Ke, $e, pt, 52, 8), $e + 8;
  }
  c.prototype.writeDoubleLE = function(Ke, $e, pt) {
    return Ht(this, Ke, $e, !0, pt);
  }, c.prototype.writeDoubleBE = function(Ke, $e, pt) {
    return Ht(this, Ke, $e, !1, pt);
  }, c.prototype.copy = function(Ke, $e, pt, Jt) {
    if (!c.isBuffer(Ke))
      throw new TypeError("argument should be a Buffer");
    if (pt || (pt = 0), !Jt && Jt !== 0 && (Jt = this.length), $e >= Ke.length && ($e = Ke.length), $e || ($e = 0), Jt > 0 && Jt < pt && (Jt = pt), Jt === pt || Ke.length === 0 || this.length === 0)
      return 0;
    if ($e < 0)
      throw new RangeError("targetStart out of bounds");
    if (pt < 0 || pt >= this.length)
      throw new RangeError("Index out of range");
    if (Jt < 0)
      throw new RangeError("sourceEnd out of bounds");
    Jt > this.length && (Jt = this.length), Ke.length - $e < Jt - pt && (Jt = Ke.length - $e + pt);
    var In = Jt - pt;
    return this === Ke && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin($e, pt, Jt) : Uint8Array.prototype.set.call(
      Ke,
      this.subarray(pt, Jt),
      $e
    ), In;
  }, c.prototype.fill = function(Ke, $e, pt, Jt) {
    if (typeof Ke == "string") {
      if (typeof $e == "string" ? (Jt = $e, $e = 0, pt = this.length) : typeof pt == "string" && (Jt = pt, pt = this.length), Jt !== void 0 && typeof Jt != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Jt == "string" && !c.isEncoding(Jt))
        throw new TypeError("Unknown encoding: " + Jt);
      if (Ke.length === 1) {
        var In = Ke.charCodeAt(0);
        (Jt === "utf8" && In < 128 || Jt === "latin1") && (Ke = In);
      }
    } else
      typeof Ke == "number" ? Ke = Ke & 255 : typeof Ke == "boolean" && (Ke = Number(Ke));
    if ($e < 0 || this.length < $e || this.length < pt)
      throw new RangeError("Out of range index");
    if (pt <= $e)
      return this;
    $e = $e >>> 0, pt = pt === void 0 ? this.length : pt >>> 0, Ke || (Ke = 0);
    var Cn;
    if (typeof Ke == "number")
      for (Cn = $e; Cn < pt; ++Cn)
        this[Cn] = Ke;
    else {
      var It = c.isBuffer(Ke) ? Ke : c.from(Ke, Jt), ht = It.length;
      if (ht === 0)
        throw new TypeError('The value "' + Ke + '" is invalid for argument "value"');
      for (Cn = 0; Cn < pt - $e; ++Cn)
        this[Cn + $e] = It[Cn % ht];
    }
    return this;
  };
  var Bt = /[^+/0-9A-Za-z-_]/g;
  function ut(Et) {
    if (Et = Et.split("=")[0], Et = Et.trim().replace(Bt, ""), Et.length < 2)
      return "";
    for (; Et.length % 4 !== 0; )
      Et = Et + "=";
    return Et;
  }
  function Tt(Et, Ke) {
    Ke = Ke || 1 / 0;
    for (var $e, pt = Et.length, Jt = null, In = [], Cn = 0; Cn < pt; ++Cn) {
      if ($e = Et.charCodeAt(Cn), $e > 55295 && $e < 57344) {
        if (!Jt) {
          if ($e > 56319) {
            (Ke -= 3) > -1 && In.push(239, 191, 189);
            continue;
          } else if (Cn + 1 === pt) {
            (Ke -= 3) > -1 && In.push(239, 191, 189);
            continue;
          }
          Jt = $e;
          continue;
        }
        if ($e < 56320) {
          (Ke -= 3) > -1 && In.push(239, 191, 189), Jt = $e;
          continue;
        }
        $e = (Jt - 55296 << 10 | $e - 56320) + 65536;
      } else
        Jt && (Ke -= 3) > -1 && In.push(239, 191, 189);
      if (Jt = null, $e < 128) {
        if ((Ke -= 1) < 0)
          break;
        In.push($e);
      } else if ($e < 2048) {
        if ((Ke -= 2) < 0)
          break;
        In.push(
          $e >> 6 | 192,
          $e & 63 | 128
        );
      } else if ($e < 65536) {
        if ((Ke -= 3) < 0)
          break;
        In.push(
          $e >> 12 | 224,
          $e >> 6 & 63 | 128,
          $e & 63 | 128
        );
      } else if ($e < 1114112) {
        if ((Ke -= 4) < 0)
          break;
        In.push(
          $e >> 18 | 240,
          $e >> 12 & 63 | 128,
          $e >> 6 & 63 | 128,
          $e & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return In;
  }
  function Yt(Et) {
    for (var Ke = [], $e = 0; $e < Et.length; ++$e)
      Ke.push(Et.charCodeAt($e) & 255);
    return Ke;
  }
  function an(Et, Ke) {
    for (var $e, pt, Jt, In = [], Cn = 0; Cn < Et.length && !((Ke -= 2) < 0); ++Cn)
      $e = Et.charCodeAt(Cn), pt = $e >> 8, Jt = $e % 256, In.push(Jt), In.push(pt);
    return In;
  }
  function Ct(Et) {
    return e.toByteArray(ut(Et));
  }
  function st(Et, Ke, $e, pt) {
    for (var Jt = 0; Jt < pt && !(Jt + $e >= Ke.length || Jt >= Et.length); ++Jt)
      Ke[Jt + $e] = Et[Jt];
    return Jt;
  }
  function jt(Et, Ke) {
    return Et instanceof Ke || Et != null && Et.constructor != null && Et.constructor.name != null && Et.constructor.name === Ke.name;
  }
  function lt(Et) {
    return Et !== Et;
  }
  var Zt = function() {
    for (var Et = "0123456789abcdef", Ke = new Array(256), $e = 0; $e < 16; ++$e)
      for (var pt = $e * 16, Jt = 0; Jt < 16; ++Jt)
        Ke[pt + Jt] = Et[$e] + Et[Jt];
    return Ke;
  }();
})(buffer$1);
var browser$1$1 = { exports: {} }, process = browser$1$1.exports = {}, cachedSetTimeout, cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? cachedSetTimeout = setTimeout : cachedSetTimeout = defaultSetTimout;
  } catch {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    typeof clearTimeout == "function" ? cachedClearTimeout = clearTimeout : cachedClearTimeout = defaultClearTimeout;
  } catch {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(r) {
  if (cachedSetTimeout === setTimeout)
    return setTimeout(r, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout)
    return cachedSetTimeout = setTimeout, setTimeout(r, 0);
  try {
    return cachedSetTimeout(r, 0);
  } catch {
    try {
      return cachedSetTimeout.call(null, r, 0);
    } catch {
      return cachedSetTimeout.call(this, r, 0);
    }
  }
}
function runClearTimeout(r) {
  if (cachedClearTimeout === clearTimeout)
    return clearTimeout(r);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout)
    return cachedClearTimeout = clearTimeout, clearTimeout(r);
  try {
    return cachedClearTimeout(r);
  } catch {
    try {
      return cachedClearTimeout.call(null, r);
    } catch {
      return cachedClearTimeout.call(this, r);
    }
  }
}
var queue = [], draining = !1, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  !draining || !currentQueue || (draining = !1, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var r = runTimeout(cleanUpNextTick);
    draining = !0;
    for (var e = queue.length; e; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < e; )
        currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, e = queue.length;
    }
    currentQueue = null, draining = !1, runClearTimeout(r);
  }
}
process.nextTick = function(r) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var s = 1; s < arguments.length; s++)
      e[s - 1] = arguments[s];
  queue.push(new Item(r, e)), queue.length === 1 && !draining && runTimeout(drainQueue);
};
function Item(r, e) {
  this.fun = r, this.array = e;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = !0;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$1() {
}
process.on = noop$1;
process.addListener = noop$1;
process.once = noop$1;
process.off = noop$1;
process.removeListener = noop$1;
process.removeAllListeners = noop$1;
process.emit = noop$1;
process.prependListener = noop$1;
process.prependOnceListener = noop$1;
process.listeners = function(r) {
  return [];
};
process.binding = function(r) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(r) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
function noop() {
}
var browser$c = (
  /** @type {boolean} */
  browser$1$1.exports.browser
), emitWarning = noop, binding = (
  /** @type {Function} */
  browser$1$1.exports.binding
), exit = noop, pid = 1, features = {}, kill = noop, dlopen = noop, uptime = noop, memoryUsage = noop, uvCounters = noop, platform = "browser", arch = "browser", execPath = "browser", execArgv = (
  /** @type {string[]} */
  []
), api$1 = {
  nextTick: browser$1$1.exports.nextTick,
  title: browser$1$1.exports.title,
  browser: browser$c,
  env: browser$1$1.exports.env,
  argv: browser$1$1.exports.argv,
  version: browser$1$1.exports.version,
  versions: browser$1$1.exports.versions,
  on: browser$1$1.exports.on,
  addListener: browser$1$1.exports.addListener,
  once: browser$1$1.exports.once,
  off: browser$1$1.exports.off,
  removeListener: browser$1$1.exports.removeListener,
  removeAllListeners: browser$1$1.exports.removeAllListeners,
  emit: browser$1$1.exports.emit,
  emitWarning,
  prependListener: browser$1$1.exports.prependListener,
  prependOnceListener: browser$1$1.exports.prependOnceListener,
  listeners: browser$1$1.exports.listeners,
  binding,
  cwd: browser$1$1.exports.cwd,
  chdir: browser$1$1.exports.chdir,
  umask: browser$1$1.exports.umask,
  exit,
  pid,
  features,
  kill,
  dlopen,
  uptime,
  memoryUsage,
  uvCounters,
  platform,
  arch,
  execPath,
  execArgv
};
browser$1$1.exports.addListener;
browser$1$1.exports.argv;
browser$1$1.exports.chdir;
browser$1$1.exports.cwd;
browser$1$1.exports.emit;
browser$1$1.exports.env;
browser$1$1.exports.listeners;
browser$1$1.exports.nextTick;
browser$1$1.exports.off;
browser$1$1.exports.on;
browser$1$1.exports.once;
browser$1$1.exports.prependListener;
browser$1$1.exports.prependOnceListener;
browser$1$1.exports.removeAllListeners;
browser$1$1.exports.removeListener;
browser$1$1.exports.title;
browser$1$1.exports.umask;
browser$1$1.exports.version;
browser$1$1.exports.versions;
var _globalThis = function(r) {
  function e() {
    var o = this || self;
    return delete r.prototype.__magic__, o;
  }
  if (typeof globalThis == "object")
    return globalThis;
  if (this)
    return e();
  r.defineProperty(r.prototype, "__magic__", {
    configurable: !0,
    get: e
  });
  var s = __magic__;
  return s;
}(Object), _global = _globalThis, browser$b = { exports: {} }, safeBuffer$1 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hasRequiredSafeBuffer$1;
function requireSafeBuffer$1() {
  return hasRequiredSafeBuffer$1 || (hasRequiredSafeBuffer$1 = 1, function(r, e) {
    var s = buffer$1, o = s.Buffer;
    function a(u, c) {
      for (var E in u)
        c[E] = u[E];
    }
    o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? r.exports = s : (a(s, e), e.Buffer = l);
    function l(u, c, E) {
      return o(u, c, E);
    }
    l.prototype = Object.create(o.prototype), a(o, l), l.from = function(u, c, E) {
      if (typeof u == "number")
        throw new TypeError("Argument must not be a number");
      return o(u, c, E);
    }, l.alloc = function(u, c, E) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      var d = o(u);
      return c !== void 0 ? typeof E == "string" ? d.fill(c, E) : d.fill(c) : d.fill(0), d;
    }, l.allocUnsafe = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return o(u);
    }, l.allocUnsafeSlow = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return s.SlowBuffer(u);
    };
  }(safeBuffer$1, safeBuffer$1.exports)), safeBuffer$1.exports;
}
var hasRequiredBrowser$b;
function requireBrowser$b() {
  if (hasRequiredBrowser$b)
    return browser$b.exports;
  hasRequiredBrowser$b = 1;
  var r = 65536, e = 4294967295;
  function s() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var o = requireSafeBuffer$1().Buffer, a = commonjsGlobal.crypto || commonjsGlobal.msCrypto;
  a && a.getRandomValues ? browser$b.exports = l : browser$b.exports = s;
  function l(u, c) {
    if (u > e)
      throw new RangeError("requested too many random bytes");
    var E = o.allocUnsafe(u);
    if (u > 0)
      if (u > r)
        for (var d = 0; d < u; d += r)
          a.getRandomValues(E.slice(d, d + r));
      else
        a.getRandomValues(E);
    return typeof c == "function" ? api$1.nextTick(function() {
      c(null, E);
    }) : E;
  }
  return browser$b.exports;
}
var inherits_browser = { exports: {} }, hasRequiredInherits_browser;
function requireInherits_browser() {
  return hasRequiredInherits_browser || (hasRequiredInherits_browser = 1, typeof Object.create == "function" ? inherits_browser.exports = function(e, s) {
    s && (e.super_ = s, e.prototype = Object.create(s.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : inherits_browser.exports = function(e, s) {
    if (s) {
      e.super_ = s;
      var o = function() {
      };
      o.prototype = s.prototype, e.prototype = new o(), e.prototype.constructor = e;
    }
  }), inherits_browser.exports;
}
var events = { exports: {} }, hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents)
    return events.exports;
  hasRequiredEvents = 1;
  var r = typeof Reflect == "object" ? Reflect : null, e = r && typeof r.apply == "function" ? r.apply : function(fe, _e, Le) {
    return Function.prototype.apply.call(fe, _e, Le);
  }, s;
  r && typeof r.ownKeys == "function" ? s = r.ownKeys : Object.getOwnPropertySymbols ? s = function(fe) {
    return Object.getOwnPropertyNames(fe).concat(Object.getOwnPropertySymbols(fe));
  } : s = function(fe) {
    return Object.getOwnPropertyNames(fe);
  };
  function o(q) {
    console && console.warn && console.warn(q);
  }
  var a = Number.isNaN || function(fe) {
    return fe !== fe;
  };
  function l() {
    l.init.call(this);
  }
  events.exports = l, events.exports.once = F, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
  var u = 10;
  function c(q) {
    if (typeof q != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof q);
  }
  Object.defineProperty(l, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return u;
    },
    set: function(q) {
      if (typeof q != "number" || q < 0 || a(q))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + q + ".");
      u = q;
    }
  }), l.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, l.prototype.setMaxListeners = function(fe) {
    if (typeof fe != "number" || fe < 0 || a(fe))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + fe + ".");
    return this._maxListeners = fe, this;
  };
  function E(q) {
    return q._maxListeners === void 0 ? l.defaultMaxListeners : q._maxListeners;
  }
  l.prototype.getMaxListeners = function() {
    return E(this);
  }, l.prototype.emit = function(fe) {
    for (var _e = [], Le = 1; Le < arguments.length; Le++)
      _e.push(arguments[Le]);
    var Fe = fe === "error", Ee = this._events;
    if (Ee !== void 0)
      Fe = Fe && Ee.error === void 0;
    else if (!Fe)
      return !1;
    if (Fe) {
      var Ge;
      if (_e.length > 0 && (Ge = _e[0]), Ge instanceof Error)
        throw Ge;
      var ve = new Error("Unhandled error." + (Ge ? " (" + Ge.message + ")" : ""));
      throw ve.context = Ge, ve;
    }
    var te = Ee[fe];
    if (te === void 0)
      return !1;
    if (typeof te == "function")
      e(te, this, _e);
    else
      for (var ae = te.length, v = _(te, ae), Le = 0; Le < ae; ++Le)
        e(v[Le], this, _e);
    return !0;
  };
  function d(q, fe, _e, Le) {
    var Fe, Ee, Ge;
    if (c(_e), Ee = q._events, Ee === void 0 ? (Ee = q._events = /* @__PURE__ */ Object.create(null), q._eventsCount = 0) : (Ee.newListener !== void 0 && (q.emit(
      "newListener",
      fe,
      _e.listener ? _e.listener : _e
    ), Ee = q._events), Ge = Ee[fe]), Ge === void 0)
      Ge = Ee[fe] = _e, ++q._eventsCount;
    else if (typeof Ge == "function" ? Ge = Ee[fe] = Le ? [_e, Ge] : [Ge, _e] : Le ? Ge.unshift(_e) : Ge.push(_e), Fe = E(q), Fe > 0 && Ge.length > Fe && !Ge.warned) {
      Ge.warned = !0;
      var ve = new Error("Possible EventEmitter memory leak detected. " + Ge.length + " " + String(fe) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ve.name = "MaxListenersExceededWarning", ve.emitter = q, ve.type = fe, ve.count = Ge.length, o(ve);
    }
    return q;
  }
  l.prototype.addListener = function(fe, _e) {
    return d(this, fe, _e, !1);
  }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function(fe, _e) {
    return d(this, fe, _e, !0);
  };
  function f() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function h(q, fe, _e) {
    var Le = { fired: !1, wrapFn: void 0, target: q, type: fe, listener: _e }, Fe = f.bind(Le);
    return Fe.listener = _e, Le.wrapFn = Fe, Fe;
  }
  l.prototype.once = function(fe, _e) {
    return c(_e), this.on(fe, h(this, fe, _e)), this;
  }, l.prototype.prependOnceListener = function(fe, _e) {
    return c(_e), this.prependListener(fe, h(this, fe, _e)), this;
  }, l.prototype.removeListener = function(fe, _e) {
    var Le, Fe, Ee, Ge, ve;
    if (c(_e), Fe = this._events, Fe === void 0)
      return this;
    if (Le = Fe[fe], Le === void 0)
      return this;
    if (Le === _e || Le.listener === _e)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Fe[fe], Fe.removeListener && this.emit("removeListener", fe, Le.listener || _e));
    else if (typeof Le != "function") {
      for (Ee = -1, Ge = Le.length - 1; Ge >= 0; Ge--)
        if (Le[Ge] === _e || Le[Ge].listener === _e) {
          ve = Le[Ge].listener, Ee = Ge;
          break;
        }
      if (Ee < 0)
        return this;
      Ee === 0 ? Le.shift() : m(Le, Ee), Le.length === 1 && (Fe[fe] = Le[0]), Fe.removeListener !== void 0 && this.emit("removeListener", fe, ve || _e);
    }
    return this;
  }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function(fe) {
    var _e, Le, Fe;
    if (Le = this._events, Le === void 0)
      return this;
    if (Le.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Le[fe] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Le[fe]), this;
    if (arguments.length === 0) {
      var Ee = Object.keys(Le), Ge;
      for (Fe = 0; Fe < Ee.length; ++Fe)
        Ge = Ee[Fe], Ge !== "removeListener" && this.removeAllListeners(Ge);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (_e = Le[fe], typeof _e == "function")
      this.removeListener(fe, _e);
    else if (_e !== void 0)
      for (Fe = _e.length - 1; Fe >= 0; Fe--)
        this.removeListener(fe, _e[Fe]);
    return this;
  };
  function S(q, fe, _e) {
    var Le = q._events;
    if (Le === void 0)
      return [];
    var Fe = Le[fe];
    return Fe === void 0 ? [] : typeof Fe == "function" ? _e ? [Fe.listener || Fe] : [Fe] : _e ? L(Fe) : _(Fe, Fe.length);
  }
  l.prototype.listeners = function(fe) {
    return S(this, fe, !0);
  }, l.prototype.rawListeners = function(fe) {
    return S(this, fe, !1);
  }, l.listenerCount = function(q, fe) {
    return typeof q.listenerCount == "function" ? q.listenerCount(fe) : R.call(q, fe);
  }, l.prototype.listenerCount = R;
  function R(q) {
    var fe = this._events;
    if (fe !== void 0) {
      var _e = fe[q];
      if (typeof _e == "function")
        return 1;
      if (_e !== void 0)
        return _e.length;
    }
    return 0;
  }
  l.prototype.eventNames = function() {
    return this._eventsCount > 0 ? s(this._events) : [];
  };
  function _(q, fe) {
    for (var _e = new Array(fe), Le = 0; Le < fe; ++Le)
      _e[Le] = q[Le];
    return _e;
  }
  function m(q, fe) {
    for (; fe + 1 < q.length; fe++)
      q[fe] = q[fe + 1];
    q.pop();
  }
  function L(q) {
    for (var fe = new Array(q.length), _e = 0; _e < fe.length; ++_e)
      fe[_e] = q[_e].listener || q[_e];
    return fe;
  }
  function F(q, fe) {
    return new Promise(function(_e, Le) {
      function Fe(Ge) {
        q.removeListener(fe, Ee), Le(Ge);
      }
      function Ee() {
        typeof q.removeListener == "function" && q.removeListener("error", Fe), _e([].slice.call(arguments));
      }
      G(q, fe, Ee, { once: !0 }), fe !== "error" && W(q, Fe, { once: !0 });
    });
  }
  function W(q, fe, _e) {
    typeof q.on == "function" && G(q, "error", fe, _e);
  }
  function G(q, fe, _e, Le) {
    if (typeof q.on == "function")
      Le.once ? q.once(fe, _e) : q.on(fe, _e);
    else if (typeof q.addEventListener == "function")
      q.addEventListener(fe, function Fe(Ee) {
        Le.once && q.removeEventListener(fe, Fe), _e(Ee);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof q);
  }
  return events.exports;
}
var streamBrowser$1, hasRequiredStreamBrowser$1;
function requireStreamBrowser$1() {
  return hasRequiredStreamBrowser$1 || (hasRequiredStreamBrowser$1 = 1, streamBrowser$1 = requireEvents().EventEmitter), streamBrowser$1;
}
var util$3 = {}, types = {}, shams$1, hasRequiredShams$1;
function requireShams$1() {
  return hasRequiredShams$1 || (hasRequiredShams$1 = 1, shams$1 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, s = Symbol("test"), o = Object(s);
    if (typeof s == "string" || Object.prototype.toString.call(s) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var a = 42;
    e[s] = a;
    for (var l in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var u = Object.getOwnPropertySymbols(e);
    if (u.length !== 1 || u[0] !== s || !Object.prototype.propertyIsEnumerable.call(e, s))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var c = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, s)
      );
      if (c.value !== a || c.enumerable !== !0)
        return !1;
    }
    return !0;
  }), shams$1;
}
var shams, hasRequiredShams;
function requireShams() {
  if (hasRequiredShams)
    return shams;
  hasRequiredShams = 1;
  var r = requireShams$1();
  return shams = function() {
    return r() && !!Symbol.toStringTag;
  }, shams;
}
var esObjectAtoms, hasRequiredEsObjectAtoms;
function requireEsObjectAtoms() {
  return hasRequiredEsObjectAtoms || (hasRequiredEsObjectAtoms = 1, esObjectAtoms = Object), esObjectAtoms;
}
var esErrors, hasRequiredEsErrors;
function requireEsErrors() {
  return hasRequiredEsErrors || (hasRequiredEsErrors = 1, esErrors = Error), esErrors;
}
var _eval, hasRequired_eval;
function require_eval() {
  return hasRequired_eval || (hasRequired_eval = 1, _eval = EvalError), _eval;
}
var range$1, hasRequiredRange;
function requireRange() {
  return hasRequiredRange || (hasRequiredRange = 1, range$1 = RangeError), range$1;
}
var ref, hasRequiredRef;
function requireRef() {
  return hasRequiredRef || (hasRequiredRef = 1, ref = ReferenceError), ref;
}
var syntax, hasRequiredSyntax;
function requireSyntax() {
  return hasRequiredSyntax || (hasRequiredSyntax = 1, syntax = SyntaxError), syntax;
}
var type, hasRequiredType;
function requireType() {
  return hasRequiredType || (hasRequiredType = 1, type = TypeError), type;
}
var uri, hasRequiredUri;
function requireUri() {
  return hasRequiredUri || (hasRequiredUri = 1, uri = URIError), uri;
}
var abs$1, hasRequiredAbs;
function requireAbs() {
  return hasRequiredAbs || (hasRequiredAbs = 1, abs$1 = Math.abs), abs$1;
}
var floor, hasRequiredFloor;
function requireFloor() {
  return hasRequiredFloor || (hasRequiredFloor = 1, floor = Math.floor), floor;
}
var max, hasRequiredMax;
function requireMax() {
  return hasRequiredMax || (hasRequiredMax = 1, max = Math.max), max;
}
var min, hasRequiredMin;
function requireMin() {
  return hasRequiredMin || (hasRequiredMin = 1, min = Math.min), min;
}
var pow, hasRequiredPow;
function requirePow() {
  return hasRequiredPow || (hasRequiredPow = 1, pow = Math.pow), pow;
}
var round, hasRequiredRound;
function requireRound() {
  return hasRequiredRound || (hasRequiredRound = 1, round = Math.round), round;
}
var _isNaN, hasRequired_isNaN;
function require_isNaN() {
  return hasRequired_isNaN || (hasRequired_isNaN = 1, _isNaN = Number.isNaN || function(e) {
    return e !== e;
  }), _isNaN;
}
var sign$4, hasRequiredSign$1;
function requireSign$1() {
  if (hasRequiredSign$1)
    return sign$4;
  hasRequiredSign$1 = 1;
  var r = require_isNaN();
  return sign$4 = function(s) {
    return r(s) || s === 0 ? s : s < 0 ? -1 : 1;
  }, sign$4;
}
var gOPD, hasRequiredGOPD;
function requireGOPD() {
  return hasRequiredGOPD || (hasRequiredGOPD = 1, gOPD = Object.getOwnPropertyDescriptor), gOPD;
}
var gopd, hasRequiredGopd;
function requireGopd() {
  if (hasRequiredGopd)
    return gopd;
  hasRequiredGopd = 1;
  var r = requireGOPD();
  if (r)
    try {
      r([], "length");
    } catch {
      r = null;
    }
  return gopd = r, gopd;
}
var esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty)
    return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var r = Object.defineProperty || !1;
  if (r)
    try {
      r({}, "a", { value: 1 });
    } catch {
      r = !1;
    }
  return esDefineProperty = r, esDefineProperty;
}
var hasSymbols, hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols)
    return hasSymbols;
  hasRequiredHasSymbols = 1;
  var r = typeof Symbol < "u" && Symbol, e = requireShams$1();
  return hasSymbols = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, hasSymbols;
}
var Reflect_getPrototypeOf, hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  return hasRequiredReflect_getPrototypeOf || (hasRequiredReflect_getPrototypeOf = 1, Reflect_getPrototypeOf = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Reflect_getPrototypeOf;
}
var Object_getPrototypeOf, hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf)
    return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var r = requireEsObjectAtoms();
  return Object_getPrototypeOf = r.getPrototypeOf || null, Object_getPrototypeOf;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation)
    return implementation;
  hasRequiredImplementation = 1;
  var r = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, s = Math.max, o = "[object Function]", a = function(E, d) {
    for (var f = [], h = 0; h < E.length; h += 1)
      f[h] = E[h];
    for (var S = 0; S < d.length; S += 1)
      f[S + E.length] = d[S];
    return f;
  }, l = function(E, d) {
    for (var f = [], h = d || 0, S = 0; h < E.length; h += 1, S += 1)
      f[S] = E[h];
    return f;
  }, u = function(c, E) {
    for (var d = "", f = 0; f < c.length; f += 1)
      d += c[f], f + 1 < c.length && (d += E);
    return d;
  };
  return implementation = function(E) {
    var d = this;
    if (typeof d != "function" || e.apply(d) !== o)
      throw new TypeError(r + d);
    for (var f = l(arguments, 1), h, S = function() {
      if (this instanceof h) {
        var F = d.apply(
          this,
          a(f, arguments)
        );
        return Object(F) === F ? F : this;
      }
      return d.apply(
        E,
        a(f, arguments)
      );
    }, R = s(0, d.length - f.length), _ = [], m = 0; m < R; m++)
      _[m] = "$" + m;
    if (h = Function("binder", "return function (" + u(_, ",") + "){ return binder.apply(this,arguments); }")(S), d.prototype) {
      var L = function() {
      };
      L.prototype = d.prototype, h.prototype = new L(), L.prototype = null;
    }
    return h;
  }, implementation;
}
var functionBind, hasRequiredFunctionBind;
function requireFunctionBind() {
  if (hasRequiredFunctionBind)
    return functionBind;
  hasRequiredFunctionBind = 1;
  var r = requireImplementation();
  return functionBind = Function.prototype.bind || r, functionBind;
}
var functionCall, hasRequiredFunctionCall;
function requireFunctionCall() {
  return hasRequiredFunctionCall || (hasRequiredFunctionCall = 1, functionCall = Function.prototype.call), functionCall;
}
var functionApply, hasRequiredFunctionApply;
function requireFunctionApply() {
  return hasRequiredFunctionApply || (hasRequiredFunctionApply = 1, functionApply = Function.prototype.apply), functionApply;
}
var reflectApply, hasRequiredReflectApply;
function requireReflectApply() {
  return hasRequiredReflectApply || (hasRequiredReflectApply = 1, reflectApply = typeof Reflect < "u" && Reflect && Reflect.apply), reflectApply;
}
var actualApply, hasRequiredActualApply;
function requireActualApply() {
  if (hasRequiredActualApply)
    return actualApply;
  hasRequiredActualApply = 1;
  var r = requireFunctionBind(), e = requireFunctionApply(), s = requireFunctionCall(), o = requireReflectApply();
  return actualApply = o || r.call(s, e), actualApply;
}
var callBindApplyHelpers, hasRequiredCallBindApplyHelpers;
function requireCallBindApplyHelpers() {
  if (hasRequiredCallBindApplyHelpers)
    return callBindApplyHelpers;
  hasRequiredCallBindApplyHelpers = 1;
  var r = requireFunctionBind(), e = requireType(), s = requireFunctionCall(), o = requireActualApply();
  return callBindApplyHelpers = function(l) {
    if (l.length < 1 || typeof l[0] != "function")
      throw new e("a function is required");
    return o(r, s, l);
  }, callBindApplyHelpers;
}
var get$1, hasRequiredGet;
function requireGet() {
  if (hasRequiredGet)
    return get$1;
  hasRequiredGet = 1;
  var r = requireCallBindApplyHelpers(), e = requireGopd(), s;
  try {
    s = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (u) {
    if (!u || typeof u != "object" || !("code" in u) || u.code !== "ERR_PROTO_ACCESS")
      throw u;
  }
  var o = !!s && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, l = a.getPrototypeOf;
  return get$1 = o && typeof o.get == "function" ? r([o.get]) : typeof l == "function" ? (
    /** @type {import('./get')} */
    function(c) {
      return l(c == null ? c : a(c));
    }
  ) : !1, get$1;
}
var getProto, hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto)
    return getProto;
  hasRequiredGetProto = 1;
  var r = requireReflect_getPrototypeOf(), e = requireObject_getPrototypeOf(), s = requireGet();
  return getProto = r ? function(a) {
    return r(a);
  } : e ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return e(a);
  } : s ? function(a) {
    return s(a);
  } : null, getProto;
}
var hasown, hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown)
    return hasown;
  hasRequiredHasown = 1;
  var r = Function.prototype.call, e = Object.prototype.hasOwnProperty, s = requireFunctionBind();
  return hasown = s.call(r, e), hasown;
}
var getIntrinsic, hasRequiredGetIntrinsic;
function requireGetIntrinsic() {
  if (hasRequiredGetIntrinsic)
    return getIntrinsic;
  hasRequiredGetIntrinsic = 1;
  var r, e = requireEsObjectAtoms(), s = requireEsErrors(), o = require_eval(), a = requireRange(), l = requireRef(), u = requireSyntax(), c = requireType(), E = requireUri(), d = requireAbs(), f = requireFloor(), h = requireMax(), S = requireMin(), R = requirePow(), _ = requireRound(), m = requireSign$1(), L = Function, F = function(Yt) {
    try {
      return L('"use strict"; return (' + Yt + ").constructor;")();
    } catch {
    }
  }, W = requireGopd(), G = requireEsDefineProperty(), q = function() {
    throw new c();
  }, fe = W ? function() {
    try {
      return arguments.callee, q;
    } catch {
      try {
        return W(arguments, "callee").get;
      } catch {
        return q;
      }
    }
  }() : q, _e = requireHasSymbols()(), Le = requireGetProto(), Fe = requireObject_getPrototypeOf(), Ee = requireReflect_getPrototypeOf(), Ge = requireFunctionApply(), ve = requireFunctionCall(), te = {}, ae = typeof Uint8Array > "u" || !Le ? r : Le(Uint8Array), v = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? r : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? r : ArrayBuffer,
    "%ArrayIteratorPrototype%": _e && Le ? Le([][Symbol.iterator]()) : r,
    "%AsyncFromSyncIteratorPrototype%": r,
    "%AsyncFunction%": te,
    "%AsyncGenerator%": te,
    "%AsyncGeneratorFunction%": te,
    "%AsyncIteratorPrototype%": te,
    "%Atomics%": typeof Atomics > "u" ? r : Atomics,
    "%BigInt%": typeof BigInt > "u" ? r : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? r : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? r : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? r : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": s,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": o,
    "%Float16Array%": typeof Float16Array > "u" ? r : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? r : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? r : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? r : FinalizationRegistry,
    "%Function%": L,
    "%GeneratorFunction%": te,
    "%Int8Array%": typeof Int8Array > "u" ? r : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? r : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? r : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": _e && Le ? Le(Le([][Symbol.iterator]())) : r,
    "%JSON%": typeof JSON == "object" ? JSON : r,
    "%Map%": typeof Map > "u" ? r : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !_e || !Le ? r : Le((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": W,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? r : Promise,
    "%Proxy%": typeof Proxy > "u" ? r : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": l,
    "%Reflect%": typeof Reflect > "u" ? r : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? r : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !_e || !Le ? r : Le((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? r : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": _e && Le ? Le(""[Symbol.iterator]()) : r,
    "%Symbol%": _e ? Symbol : r,
    "%SyntaxError%": u,
    "%ThrowTypeError%": fe,
    "%TypedArray%": ae,
    "%TypeError%": c,
    "%Uint8Array%": typeof Uint8Array > "u" ? r : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? r : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? r : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? r : Uint32Array,
    "%URIError%": E,
    "%WeakMap%": typeof WeakMap > "u" ? r : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? r : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? r : WeakSet,
    "%Function.prototype.call%": ve,
    "%Function.prototype.apply%": Ge,
    "%Object.defineProperty%": G,
    "%Object.getPrototypeOf%": Fe,
    "%Math.abs%": d,
    "%Math.floor%": f,
    "%Math.max%": h,
    "%Math.min%": S,
    "%Math.pow%": R,
    "%Math.round%": _,
    "%Math.sign%": m,
    "%Reflect.getPrototypeOf%": Ee
  };
  if (Le)
    try {
      null.error;
    } catch (Yt) {
      var Te = Le(Le(Yt));
      v["%Error.prototype%"] = Te;
    }
  var De = function Yt(an) {
    var Ct;
    if (an === "%AsyncFunction%")
      Ct = F("async function () {}");
    else if (an === "%GeneratorFunction%")
      Ct = F("function* () {}");
    else if (an === "%AsyncGeneratorFunction%")
      Ct = F("async function* () {}");
    else if (an === "%AsyncGenerator%") {
      var st = Yt("%AsyncGeneratorFunction%");
      st && (Ct = st.prototype);
    } else if (an === "%AsyncIteratorPrototype%") {
      var jt = Yt("%AsyncGenerator%");
      jt && Le && (Ct = Le(jt.prototype));
    }
    return v[an] = Ct, Ct;
  }, be = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, ze = requireFunctionBind(), ke = requireHasown(), Be = ze.call(ve, Array.prototype.concat), Me = ze.call(Ge, Array.prototype.splice), me = ze.call(ve, String.prototype.replace), Se = ze.call(ve, String.prototype.slice), xt = ze.call(ve, RegExp.prototype.exec), Ht = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Bt = /\\(\\)?/g, ut = function(an) {
    var Ct = Se(an, 0, 1), st = Se(an, -1);
    if (Ct === "%" && st !== "%")
      throw new u("invalid intrinsic syntax, expected closing `%`");
    if (st === "%" && Ct !== "%")
      throw new u("invalid intrinsic syntax, expected opening `%`");
    var jt = [];
    return me(an, Ht, function(lt, Zt, Et, Ke) {
      jt[jt.length] = Et ? me(Ke, Bt, "$1") : Zt || lt;
    }), jt;
  }, Tt = function(an, Ct) {
    var st = an, jt;
    if (ke(be, st) && (jt = be[st], st = "%" + jt[0] + "%"), ke(v, st)) {
      var lt = v[st];
      if (lt === te && (lt = De(st)), typeof lt > "u" && !Ct)
        throw new c("intrinsic " + an + " exists, but is not available. Please file an issue!");
      return {
        alias: jt,
        name: st,
        value: lt
      };
    }
    throw new u("intrinsic " + an + " does not exist!");
  };
  return getIntrinsic = function(an, Ct) {
    if (typeof an != "string" || an.length === 0)
      throw new c("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Ct != "boolean")
      throw new c('"allowMissing" argument must be a boolean');
    if (xt(/^%?[^%]*%?$/, an) === null)
      throw new u("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var st = ut(an), jt = st.length > 0 ? st[0] : "", lt = Tt("%" + jt + "%", Ct), Zt = lt.name, Et = lt.value, Ke = !1, $e = lt.alias;
    $e && (jt = $e[0], Me(st, Be([0, 1], $e)));
    for (var pt = 1, Jt = !0; pt < st.length; pt += 1) {
      var In = st[pt], Cn = Se(In, 0, 1), It = Se(In, -1);
      if ((Cn === '"' || Cn === "'" || Cn === "`" || It === '"' || It === "'" || It === "`") && Cn !== It)
        throw new u("property names with quotes must have matching quotes");
      if ((In === "constructor" || !Jt) && (Ke = !0), jt += "." + In, Zt = "%" + jt + "%", ke(v, Zt))
        Et = v[Zt];
      else if (Et != null) {
        if (!(In in Et)) {
          if (!Ct)
            throw new c("base intrinsic for " + an + " exists, but the property is not available.");
          return;
        }
        if (W && pt + 1 >= st.length) {
          var ht = W(Et, In);
          Jt = !!ht, Jt && "get" in ht && !("originalValue" in ht.get) ? Et = ht.get : Et = Et[In];
        } else
          Jt = ke(Et, In), Et = Et[In];
        Jt && !Ke && (v[Zt] = Et);
      }
    }
    return Et;
  }, getIntrinsic;
}
var callBound, hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound)
    return callBound;
  hasRequiredCallBound = 1;
  var r = requireGetIntrinsic(), e = requireCallBindApplyHelpers(), s = e([r("%String.prototype.indexOf%")]);
  return callBound = function(a, l) {
    var u = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      r(a, !!l)
    );
    return typeof u == "function" && s(a, ".prototype.") > -1 ? e(
      /** @type {const} */
      [u]
    ) : u;
  }, callBound;
}
var isArguments, hasRequiredIsArguments;
function requireIsArguments() {
  if (hasRequiredIsArguments)
    return isArguments;
  hasRequiredIsArguments = 1;
  var r = requireShams()(), e = requireCallBound(), s = e("Object.prototype.toString"), o = function(c) {
    return r && c && typeof c == "object" && Symbol.toStringTag in c ? !1 : s(c) === "[object Arguments]";
  }, a = function(c) {
    return o(c) ? !0 : c !== null && typeof c == "object" && "length" in c && typeof c.length == "number" && c.length >= 0 && s(c) !== "[object Array]" && "callee" in c && s(c.callee) === "[object Function]";
  }, l = function() {
    return o(arguments);
  }();
  return o.isLegacyArguments = a, isArguments = l ? o : a, isArguments;
}
var isRegex, hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex)
    return isRegex;
  hasRequiredIsRegex = 1;
  var r = requireCallBound(), e = requireShams()(), s = requireHasown(), o = requireGopd(), a;
  if (e) {
    var l = r("RegExp.prototype.exec"), u = {}, c = function() {
      throw u;
    }, E = {
      toString: c,
      valueOf: c
    };
    typeof Symbol.toPrimitive == "symbol" && (E[Symbol.toPrimitive] = c), a = function(S) {
      if (!S || typeof S != "object")
        return !1;
      var R = (
        /** @type {NonNullable<typeof gOPD>} */
        o(
          /** @type {{ lastIndex?: unknown }} */
          S,
          "lastIndex"
        )
      ), _ = R && s(R, "value");
      if (!_)
        return !1;
      try {
        l(
          S,
          /** @type {string} */
          /** @type {unknown} */
          E
        );
      } catch (m) {
        return m === u;
      }
    };
  } else {
    var d = r("Object.prototype.toString"), f = "[object RegExp]";
    a = function(S) {
      return !S || typeof S != "object" && typeof S != "function" ? !1 : d(S) === f;
    };
  }
  return isRegex = a, isRegex;
}
var safeRegexTest, hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest)
    return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var r = requireCallBound(), e = requireIsRegex(), s = r("RegExp.prototype.exec"), o = requireType();
  return safeRegexTest = function(l) {
    if (!e(l))
      throw new o("`regex` must be a RegExp");
    return function(c) {
      return s(l, c) !== null;
    };
  }, safeRegexTest;
}
var isGeneratorFunction, hasRequiredIsGeneratorFunction;
function requireIsGeneratorFunction() {
  if (hasRequiredIsGeneratorFunction)
    return isGeneratorFunction;
  hasRequiredIsGeneratorFunction = 1;
  var r = requireCallBound(), e = requireSafeRegexTest(), s = e(/^\s*(?:function)?\*/), o = requireShams()(), a = requireGetProto(), l = r("Object.prototype.toString"), u = r("Function.prototype.toString"), c = function() {
    if (!o)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, E;
  return isGeneratorFunction = function(f) {
    if (typeof f != "function")
      return !1;
    if (s(u(f)))
      return !0;
    if (!o) {
      var h = l(f);
      return h === "[object GeneratorFunction]";
    }
    if (!a)
      return !1;
    if (typeof E > "u") {
      var S = c();
      E = S ? (
        /** @type {GeneratorFunctionConstructor} */
        a(S)
      ) : !1;
    }
    return a(f) === E;
  }, isGeneratorFunction;
}
var isCallable, hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable)
    return isCallable;
  hasRequiredIsCallable = 1;
  var r = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, s, o;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      s = Object.defineProperty({}, "length", {
        get: function() {
          throw o;
        }
      }), o = {}, e(function() {
        throw 42;
      }, null, s);
    } catch (W) {
      W !== o && (e = null);
    }
  else
    e = null;
  var a = /^\s*class\b/, l = function(G) {
    try {
      var q = r.call(G);
      return a.test(q);
    } catch {
      return !1;
    }
  }, u = function(G) {
    try {
      return l(G) ? !1 : (r.call(G), !0);
    } catch {
      return !1;
    }
  }, c = Object.prototype.toString, E = "[object Object]", d = "[object Function]", f = "[object GeneratorFunction]", h = "[object HTMLAllCollection]", S = "[object HTML document.all class]", R = "[object HTMLCollection]", _ = typeof Symbol == "function" && !!Symbol.toStringTag, m = !(0 in [,]), L = function() {
    return !1;
  };
  if (typeof document == "object") {
    var F = document.all;
    c.call(F) === c.call(document.all) && (L = function(G) {
      if ((m || !G) && (typeof G > "u" || typeof G == "object"))
        try {
          var q = c.call(G);
          return (q === h || q === S || q === R || q === E) && G("") == null;
        } catch {
        }
      return !1;
    });
  }
  return isCallable = e ? function(G) {
    if (L(G))
      return !0;
    if (!G || typeof G != "function" && typeof G != "object")
      return !1;
    try {
      e(G, null, s);
    } catch (q) {
      if (q !== o)
        return !1;
    }
    return !l(G) && u(G);
  } : function(G) {
    if (L(G))
      return !0;
    if (!G || typeof G != "function" && typeof G != "object")
      return !1;
    if (_)
      return u(G);
    if (l(G))
      return !1;
    var q = c.call(G);
    return q !== d && q !== f && !/^\[object HTML/.test(q) ? !1 : u(G);
  }, isCallable;
}
var forEach, hasRequiredForEach;
function requireForEach() {
  if (hasRequiredForEach)
    return forEach;
  hasRequiredForEach = 1;
  var r = requireIsCallable(), e = Object.prototype.toString, s = Object.prototype.hasOwnProperty, o = function(E, d, f) {
    for (var h = 0, S = E.length; h < S; h++)
      s.call(E, h) && (f == null ? d(E[h], h, E) : d.call(f, E[h], h, E));
  }, a = function(E, d, f) {
    for (var h = 0, S = E.length; h < S; h++)
      f == null ? d(E.charAt(h), h, E) : d.call(f, E.charAt(h), h, E);
  }, l = function(E, d, f) {
    for (var h in E)
      s.call(E, h) && (f == null ? d(E[h], h, E) : d.call(f, E[h], h, E));
  };
  function u(c) {
    return e.call(c) === "[object Array]";
  }
  return forEach = function(E, d, f) {
    if (!r(d))
      throw new TypeError("iterator must be a function");
    var h;
    arguments.length >= 3 && (h = f), u(E) ? o(E, d, h) : typeof E == "string" ? a(E, d, h) : l(E, d, h);
  }, forEach;
}
var possibleTypedArrayNames, hasRequiredPossibleTypedArrayNames;
function requirePossibleTypedArrayNames() {
  return hasRequiredPossibleTypedArrayNames || (hasRequiredPossibleTypedArrayNames = 1, possibleTypedArrayNames = [
    "Float16Array",
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), possibleTypedArrayNames;
}
var availableTypedArrays, hasRequiredAvailableTypedArrays;
function requireAvailableTypedArrays() {
  if (hasRequiredAvailableTypedArrays)
    return availableTypedArrays;
  hasRequiredAvailableTypedArrays = 1;
  var r = requirePossibleTypedArrayNames(), e = typeof globalThis > "u" ? commonjsGlobal : globalThis;
  return availableTypedArrays = function() {
    for (var o = [], a = 0; a < r.length; a++)
      typeof e[r[a]] == "function" && (o[o.length] = r[a]);
    return o;
  }, availableTypedArrays;
}
var callBind = { exports: {} }, defineDataProperty, hasRequiredDefineDataProperty;
function requireDefineDataProperty() {
  if (hasRequiredDefineDataProperty)
    return defineDataProperty;
  hasRequiredDefineDataProperty = 1;
  var r = requireEsDefineProperty(), e = requireSyntax(), s = requireType(), o = requireGopd();
  return defineDataProperty = function(l, u, c) {
    if (!l || typeof l != "object" && typeof l != "function")
      throw new s("`obj` must be an object or a function`");
    if (typeof u != "string" && typeof u != "symbol")
      throw new s("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new s("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new s("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new s("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new s("`loose`, if provided, must be a boolean");
    var E = arguments.length > 3 ? arguments[3] : null, d = arguments.length > 4 ? arguments[4] : null, f = arguments.length > 5 ? arguments[5] : null, h = arguments.length > 6 ? arguments[6] : !1, S = !!o && o(l, u);
    if (r)
      r(l, u, {
        configurable: f === null && S ? S.configurable : !f,
        enumerable: E === null && S ? S.enumerable : !E,
        value: c,
        writable: d === null && S ? S.writable : !d
      });
    else if (h || !E && !d && !f)
      l[u] = c;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, defineDataProperty;
}
var hasPropertyDescriptors_1, hasRequiredHasPropertyDescriptors;
function requireHasPropertyDescriptors() {
  if (hasRequiredHasPropertyDescriptors)
    return hasPropertyDescriptors_1;
  hasRequiredHasPropertyDescriptors = 1;
  var r = requireEsDefineProperty(), e = function() {
    return !!r;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!r)
      return null;
    try {
      return r([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, hasPropertyDescriptors_1 = e, hasPropertyDescriptors_1;
}
var setFunctionLength, hasRequiredSetFunctionLength;
function requireSetFunctionLength() {
  if (hasRequiredSetFunctionLength)
    return setFunctionLength;
  hasRequiredSetFunctionLength = 1;
  var r = requireGetIntrinsic(), e = requireDefineDataProperty(), s = requireHasPropertyDescriptors()(), o = requireGopd(), a = requireType(), l = r("%Math.floor%");
  return setFunctionLength = function(c, E) {
    if (typeof c != "function")
      throw new a("`fn` is not a function");
    if (typeof E != "number" || E < 0 || E > 4294967295 || l(E) !== E)
      throw new a("`length` must be a positive 32-bit integer");
    var d = arguments.length > 2 && !!arguments[2], f = !0, h = !0;
    if ("length" in c && o) {
      var S = o(c, "length");
      S && !S.configurable && (f = !1), S && !S.writable && (h = !1);
    }
    return (f || h || !d) && (s ? e(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      E,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      c,
      "length",
      E
    )), c;
  }, setFunctionLength;
}
var applyBind, hasRequiredApplyBind;
function requireApplyBind() {
  if (hasRequiredApplyBind)
    return applyBind;
  hasRequiredApplyBind = 1;
  var r = requireFunctionBind(), e = requireFunctionApply(), s = requireActualApply();
  return applyBind = function() {
    return s(r, e, arguments);
  }, applyBind;
}
var hasRequiredCallBind;
function requireCallBind() {
  return hasRequiredCallBind || (hasRequiredCallBind = 1, function(r) {
    var e = requireSetFunctionLength(), s = requireEsDefineProperty(), o = requireCallBindApplyHelpers(), a = requireApplyBind();
    r.exports = function(u) {
      var c = o(arguments), E = u.length - (arguments.length - 1);
      return e(
        c,
        1 + (E > 0 ? E : 0),
        !0
      );
    }, s ? s(r.exports, "apply", { value: a }) : r.exports.apply = a;
  }(callBind)), callBind.exports;
}
var whichTypedArray, hasRequiredWhichTypedArray;
function requireWhichTypedArray() {
  if (hasRequiredWhichTypedArray)
    return whichTypedArray;
  hasRequiredWhichTypedArray = 1;
  var r = requireForEach(), e = requireAvailableTypedArrays(), s = requireCallBind(), o = requireCallBound(), a = requireGopd(), l = requireGetProto(), u = o("Object.prototype.toString"), c = requireShams()(), E = typeof globalThis > "u" ? commonjsGlobal : globalThis, d = e(), f = o("String.prototype.slice"), h = o("Array.prototype.indexOf", !0) || function(L, F) {
    for (var W = 0; W < L.length; W += 1)
      if (L[W] === F)
        return W;
    return -1;
  }, S = { __proto__: null };
  c && a && l ? r(d, function(m) {
    var L = new E[m]();
    if (Symbol.toStringTag in L && l) {
      var F = l(L), W = a(F, Symbol.toStringTag);
      if (!W && F) {
        var G = l(F);
        W = a(G, Symbol.toStringTag);
      }
      S["$" + m] = s(W.get);
    }
  }) : r(d, function(m) {
    var L = new E[m](), F = L.slice || L.set;
    F && (S[
      /** @type {`$${import('.').TypedArrayName}`} */
      "$" + m
    ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
    // @ts-expect-error TODO FIXME
    s(F));
  });
  var R = function(L) {
    var F = !1;
    return r(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      S,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(W, G) {
        if (!F)
          try {
            "$" + W(L) === G && (F = /** @type {import('.').TypedArrayName} */
            f(G, 1));
          } catch {
          }
      }
    ), F;
  }, _ = function(L) {
    var F = !1;
    return r(
      /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
      S,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(W, G) {
        if (!F)
          try {
            W(L), F = /** @type {import('.').TypedArrayName} */
            f(G, 1);
          } catch {
          }
      }
    ), F;
  };
  return whichTypedArray = function(L) {
    if (!L || typeof L != "object")
      return !1;
    if (!c) {
      var F = f(u(L), 8, -1);
      return h(d, F) > -1 ? F : F !== "Object" ? !1 : _(L);
    }
    return a ? R(L) : null;
  }, whichTypedArray;
}
var isTypedArray, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  if (hasRequiredIsTypedArray)
    return isTypedArray;
  hasRequiredIsTypedArray = 1;
  var r = requireWhichTypedArray();
  return isTypedArray = function(s) {
    return !!r(s);
  }, isTypedArray;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, function(r) {
    var e = requireIsArguments(), s = requireIsGeneratorFunction(), o = requireWhichTypedArray(), a = requireIsTypedArray();
    function l(pt) {
      return pt.call.bind(pt);
    }
    var u = typeof BigInt < "u", c = typeof Symbol < "u", E = l(Object.prototype.toString), d = l(Number.prototype.valueOf), f = l(String.prototype.valueOf), h = l(Boolean.prototype.valueOf);
    if (u)
      var S = l(BigInt.prototype.valueOf);
    if (c)
      var R = l(Symbol.prototype.valueOf);
    function _(pt, Jt) {
      if (typeof pt != "object")
        return !1;
      try {
        return Jt(pt), !0;
      } catch {
        return !1;
      }
    }
    r.isArgumentsObject = e, r.isGeneratorFunction = s, r.isTypedArray = a;
    function m(pt) {
      return typeof Promise < "u" && pt instanceof Promise || pt !== null && typeof pt == "object" && typeof pt.then == "function" && typeof pt.catch == "function";
    }
    r.isPromise = m;
    function L(pt) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(pt) : a(pt) || Se(pt);
    }
    r.isArrayBufferView = L;
    function F(pt) {
      return o(pt) === "Uint8Array";
    }
    r.isUint8Array = F;
    function W(pt) {
      return o(pt) === "Uint8ClampedArray";
    }
    r.isUint8ClampedArray = W;
    function G(pt) {
      return o(pt) === "Uint16Array";
    }
    r.isUint16Array = G;
    function q(pt) {
      return o(pt) === "Uint32Array";
    }
    r.isUint32Array = q;
    function fe(pt) {
      return o(pt) === "Int8Array";
    }
    r.isInt8Array = fe;
    function _e(pt) {
      return o(pt) === "Int16Array";
    }
    r.isInt16Array = _e;
    function Le(pt) {
      return o(pt) === "Int32Array";
    }
    r.isInt32Array = Le;
    function Fe(pt) {
      return o(pt) === "Float32Array";
    }
    r.isFloat32Array = Fe;
    function Ee(pt) {
      return o(pt) === "Float64Array";
    }
    r.isFloat64Array = Ee;
    function Ge(pt) {
      return o(pt) === "BigInt64Array";
    }
    r.isBigInt64Array = Ge;
    function ve(pt) {
      return o(pt) === "BigUint64Array";
    }
    r.isBigUint64Array = ve;
    function te(pt) {
      return E(pt) === "[object Map]";
    }
    te.working = typeof Map < "u" && te(/* @__PURE__ */ new Map());
    function ae(pt) {
      return typeof Map > "u" ? !1 : te.working ? te(pt) : pt instanceof Map;
    }
    r.isMap = ae;
    function v(pt) {
      return E(pt) === "[object Set]";
    }
    v.working = typeof Set < "u" && v(/* @__PURE__ */ new Set());
    function Te(pt) {
      return typeof Set > "u" ? !1 : v.working ? v(pt) : pt instanceof Set;
    }
    r.isSet = Te;
    function De(pt) {
      return E(pt) === "[object WeakMap]";
    }
    De.working = typeof WeakMap < "u" && De(/* @__PURE__ */ new WeakMap());
    function be(pt) {
      return typeof WeakMap > "u" ? !1 : De.working ? De(pt) : pt instanceof WeakMap;
    }
    r.isWeakMap = be;
    function ze(pt) {
      return E(pt) === "[object WeakSet]";
    }
    ze.working = typeof WeakSet < "u" && ze(/* @__PURE__ */ new WeakSet());
    function ke(pt) {
      return ze(pt);
    }
    r.isWeakSet = ke;
    function Be(pt) {
      return E(pt) === "[object ArrayBuffer]";
    }
    Be.working = typeof ArrayBuffer < "u" && Be(new ArrayBuffer());
    function Me(pt) {
      return typeof ArrayBuffer > "u" ? !1 : Be.working ? Be(pt) : pt instanceof ArrayBuffer;
    }
    r.isArrayBuffer = Me;
    function me(pt) {
      return E(pt) === "[object DataView]";
    }
    me.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && me(new DataView(new ArrayBuffer(1), 0, 1));
    function Se(pt) {
      return typeof DataView > "u" ? !1 : me.working ? me(pt) : pt instanceof DataView;
    }
    r.isDataView = Se;
    var xt = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function Ht(pt) {
      return E(pt) === "[object SharedArrayBuffer]";
    }
    function Bt(pt) {
      return typeof xt > "u" ? !1 : (typeof Ht.working > "u" && (Ht.working = Ht(new xt())), Ht.working ? Ht(pt) : pt instanceof xt);
    }
    r.isSharedArrayBuffer = Bt;
    function ut(pt) {
      return E(pt) === "[object AsyncFunction]";
    }
    r.isAsyncFunction = ut;
    function Tt(pt) {
      return E(pt) === "[object Map Iterator]";
    }
    r.isMapIterator = Tt;
    function Yt(pt) {
      return E(pt) === "[object Set Iterator]";
    }
    r.isSetIterator = Yt;
    function an(pt) {
      return E(pt) === "[object Generator]";
    }
    r.isGeneratorObject = an;
    function Ct(pt) {
      return E(pt) === "[object WebAssembly.Module]";
    }
    r.isWebAssemblyCompiledModule = Ct;
    function st(pt) {
      return _(pt, d);
    }
    r.isNumberObject = st;
    function jt(pt) {
      return _(pt, f);
    }
    r.isStringObject = jt;
    function lt(pt) {
      return _(pt, h);
    }
    r.isBooleanObject = lt;
    function Zt(pt) {
      return u && _(pt, S);
    }
    r.isBigIntObject = Zt;
    function Et(pt) {
      return c && _(pt, R);
    }
    r.isSymbolObject = Et;
    function Ke(pt) {
      return st(pt) || jt(pt) || lt(pt) || Zt(pt) || Et(pt);
    }
    r.isBoxedPrimitive = Ke;
    function $e(pt) {
      return typeof Uint8Array < "u" && (Me(pt) || Bt(pt));
    }
    r.isAnyArrayBuffer = $e, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(pt) {
      Object.defineProperty(r, pt, {
        enumerable: !1,
        value: function() {
          throw new Error(pt + " is not supported in userland");
        }
      });
    });
  }(types)), types;
}
var isBufferBrowser, hasRequiredIsBufferBrowser;
function requireIsBufferBrowser() {
  return hasRequiredIsBufferBrowser || (hasRequiredIsBufferBrowser = 1, isBufferBrowser = function(e) {
    return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
  }), isBufferBrowser;
}
var hasRequiredUtil$1;
function requireUtil$1() {
  return hasRequiredUtil$1 || (hasRequiredUtil$1 = 1, function(r) {
    var e = Object.getOwnPropertyDescriptors || function(Se) {
      for (var xt = Object.keys(Se), Ht = {}, Bt = 0; Bt < xt.length; Bt++)
        Ht[xt[Bt]] = Object.getOwnPropertyDescriptor(Se, xt[Bt]);
      return Ht;
    }, s = /%[sdj%]/g;
    r.format = function(me) {
      if (!fe(me)) {
        for (var Se = [], xt = 0; xt < arguments.length; xt++)
          Se.push(u(arguments[xt]));
        return Se.join(" ");
      }
      for (var xt = 1, Ht = arguments, Bt = Ht.length, ut = String(me).replace(s, function(Yt) {
        if (Yt === "%%")
          return "%";
        if (xt >= Bt)
          return Yt;
        switch (Yt) {
          case "%s":
            return String(Ht[xt++]);
          case "%d":
            return Number(Ht[xt++]);
          case "%j":
            try {
              return JSON.stringify(Ht[xt++]);
            } catch {
              return "[Circular]";
            }
          default:
            return Yt;
        }
      }), Tt = Ht[xt]; xt < Bt; Tt = Ht[++xt])
        W(Tt) || !Ee(Tt) ? ut += " " + Tt : ut += " " + u(Tt);
      return ut;
    }, r.deprecate = function(me, Se) {
      if (typeof api$1 < "u" && api$1.noDeprecation === !0)
        return me;
      if (typeof api$1 > "u")
        return function() {
          return r.deprecate(me, Se).apply(this, arguments);
        };
      var xt = !1;
      function Ht() {
        if (!xt) {
          if (api$1.throwDeprecation)
            throw new Error(Se);
          api$1.traceDeprecation ? console.trace(Se) : console.error(Se), xt = !0;
        }
        return me.apply(this, arguments);
      }
      return Ht;
    };
    var o = {}, a = /^$/;
    if (api$1.env.NODE_DEBUG) {
      var l = api$1.env.NODE_DEBUG;
      l = l.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + l + "$", "i");
    }
    r.debuglog = function(me) {
      if (me = me.toUpperCase(), !o[me])
        if (a.test(me)) {
          var Se = api$1.pid;
          o[me] = function() {
            var xt = r.format.apply(r, arguments);
            console.error("%s %d: %s", me, Se, xt);
          };
        } else
          o[me] = function() {
          };
      return o[me];
    };
    function u(me, Se) {
      var xt = {
        seen: [],
        stylize: E
      };
      return arguments.length >= 3 && (xt.depth = arguments[2]), arguments.length >= 4 && (xt.colors = arguments[3]), F(Se) ? xt.showHidden = Se : Se && r._extend(xt, Se), Le(xt.showHidden) && (xt.showHidden = !1), Le(xt.depth) && (xt.depth = 2), Le(xt.colors) && (xt.colors = !1), Le(xt.customInspect) && (xt.customInspect = !0), xt.colors && (xt.stylize = c), f(xt, me, xt.depth);
    }
    r.inspect = u, u.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, u.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function c(me, Se) {
      var xt = u.styles[Se];
      return xt ? "\x1B[" + u.colors[xt][0] + "m" + me + "\x1B[" + u.colors[xt][1] + "m" : me;
    }
    function E(me, Se) {
      return me;
    }
    function d(me) {
      var Se = {};
      return me.forEach(function(xt, Ht) {
        Se[xt] = !0;
      }), Se;
    }
    function f(me, Se, xt) {
      if (me.customInspect && Se && te(Se.inspect) && // Filter out the util module, it's inspect function is special
      Se.inspect !== r.inspect && // Also filter out any prototype objects using the circular check.
      !(Se.constructor && Se.constructor.prototype === Se)) {
        var Ht = Se.inspect(xt, me);
        return fe(Ht) || (Ht = f(me, Ht, xt)), Ht;
      }
      var Bt = h(me, Se);
      if (Bt)
        return Bt;
      var ut = Object.keys(Se), Tt = d(ut);
      if (me.showHidden && (ut = Object.getOwnPropertyNames(Se)), ve(Se) && (ut.indexOf("message") >= 0 || ut.indexOf("description") >= 0))
        return S(Se);
      if (ut.length === 0) {
        if (te(Se)) {
          var Yt = Se.name ? ": " + Se.name : "";
          return me.stylize("[Function" + Yt + "]", "special");
        }
        if (Fe(Se))
          return me.stylize(RegExp.prototype.toString.call(Se), "regexp");
        if (Ge(Se))
          return me.stylize(Date.prototype.toString.call(Se), "date");
        if (ve(Se))
          return S(Se);
      }
      var an = "", Ct = !1, st = ["{", "}"];
      if (L(Se) && (Ct = !0, st = ["[", "]"]), te(Se)) {
        var jt = Se.name ? ": " + Se.name : "";
        an = " [Function" + jt + "]";
      }
      if (Fe(Se) && (an = " " + RegExp.prototype.toString.call(Se)), Ge(Se) && (an = " " + Date.prototype.toUTCString.call(Se)), ve(Se) && (an = " " + S(Se)), ut.length === 0 && (!Ct || Se.length == 0))
        return st[0] + an + st[1];
      if (xt < 0)
        return Fe(Se) ? me.stylize(RegExp.prototype.toString.call(Se), "regexp") : me.stylize("[Object]", "special");
      me.seen.push(Se);
      var lt;
      return Ct ? lt = R(me, Se, xt, Tt, ut) : lt = ut.map(function(Zt) {
        return _(me, Se, xt, Tt, Zt, Ct);
      }), me.seen.pop(), m(lt, an, st);
    }
    function h(me, Se) {
      if (Le(Se))
        return me.stylize("undefined", "undefined");
      if (fe(Se)) {
        var xt = "'" + JSON.stringify(Se).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return me.stylize(xt, "string");
      }
      if (q(Se))
        return me.stylize("" + Se, "number");
      if (F(Se))
        return me.stylize("" + Se, "boolean");
      if (W(Se))
        return me.stylize("null", "null");
    }
    function S(me) {
      return "[" + Error.prototype.toString.call(me) + "]";
    }
    function R(me, Se, xt, Ht, Bt) {
      for (var ut = [], Tt = 0, Yt = Se.length; Tt < Yt; ++Tt)
        ze(Se, String(Tt)) ? ut.push(_(
          me,
          Se,
          xt,
          Ht,
          String(Tt),
          !0
        )) : ut.push("");
      return Bt.forEach(function(an) {
        an.match(/^\d+$/) || ut.push(_(
          me,
          Se,
          xt,
          Ht,
          an,
          !0
        ));
      }), ut;
    }
    function _(me, Se, xt, Ht, Bt, ut) {
      var Tt, Yt, an;
      if (an = Object.getOwnPropertyDescriptor(Se, Bt) || { value: Se[Bt] }, an.get ? an.set ? Yt = me.stylize("[Getter/Setter]", "special") : Yt = me.stylize("[Getter]", "special") : an.set && (Yt = me.stylize("[Setter]", "special")), ze(Ht, Bt) || (Tt = "[" + Bt + "]"), Yt || (me.seen.indexOf(an.value) < 0 ? (W(xt) ? Yt = f(me, an.value, null) : Yt = f(me, an.value, xt - 1), Yt.indexOf(`
`) > -1 && (ut ? Yt = Yt.split(`
`).map(function(Ct) {
        return "  " + Ct;
      }).join(`
`).slice(2) : Yt = `
` + Yt.split(`
`).map(function(Ct) {
        return "   " + Ct;
      }).join(`
`))) : Yt = me.stylize("[Circular]", "special")), Le(Tt)) {
        if (ut && Bt.match(/^\d+$/))
          return Yt;
        Tt = JSON.stringify("" + Bt), Tt.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Tt = Tt.slice(1, -1), Tt = me.stylize(Tt, "name")) : (Tt = Tt.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Tt = me.stylize(Tt, "string"));
      }
      return Tt + ": " + Yt;
    }
    function m(me, Se, xt) {
      var Ht = me.reduce(function(Bt, ut) {
        return ut.indexOf(`
`) >= 0, Bt + ut.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return Ht > 60 ? xt[0] + (Se === "" ? "" : Se + `
 `) + " " + me.join(`,
  `) + " " + xt[1] : xt[0] + Se + " " + me.join(", ") + " " + xt[1];
    }
    r.types = requireTypes();
    function L(me) {
      return Array.isArray(me);
    }
    r.isArray = L;
    function F(me) {
      return typeof me == "boolean";
    }
    r.isBoolean = F;
    function W(me) {
      return me === null;
    }
    r.isNull = W;
    function G(me) {
      return me == null;
    }
    r.isNullOrUndefined = G;
    function q(me) {
      return typeof me == "number";
    }
    r.isNumber = q;
    function fe(me) {
      return typeof me == "string";
    }
    r.isString = fe;
    function _e(me) {
      return typeof me == "symbol";
    }
    r.isSymbol = _e;
    function Le(me) {
      return me === void 0;
    }
    r.isUndefined = Le;
    function Fe(me) {
      return Ee(me) && v(me) === "[object RegExp]";
    }
    r.isRegExp = Fe, r.types.isRegExp = Fe;
    function Ee(me) {
      return typeof me == "object" && me !== null;
    }
    r.isObject = Ee;
    function Ge(me) {
      return Ee(me) && v(me) === "[object Date]";
    }
    r.isDate = Ge, r.types.isDate = Ge;
    function ve(me) {
      return Ee(me) && (v(me) === "[object Error]" || me instanceof Error);
    }
    r.isError = ve, r.types.isNativeError = ve;
    function te(me) {
      return typeof me == "function";
    }
    r.isFunction = te;
    function ae(me) {
      return me === null || typeof me == "boolean" || typeof me == "number" || typeof me == "string" || typeof me == "symbol" || // ES6 symbol
      typeof me > "u";
    }
    r.isPrimitive = ae, r.isBuffer = requireIsBufferBrowser();
    function v(me) {
      return Object.prototype.toString.call(me);
    }
    function Te(me) {
      return me < 10 ? "0" + me.toString(10) : me.toString(10);
    }
    var De = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function be() {
      var me = /* @__PURE__ */ new Date(), Se = [
        Te(me.getHours()),
        Te(me.getMinutes()),
        Te(me.getSeconds())
      ].join(":");
      return [me.getDate(), De[me.getMonth()], Se].join(" ");
    }
    r.log = function() {
      console.log("%s - %s", be(), r.format.apply(r, arguments));
    }, r.inherits = requireInherits_browser(), r._extend = function(me, Se) {
      if (!Se || !Ee(Se))
        return me;
      for (var xt = Object.keys(Se), Ht = xt.length; Ht--; )
        me[xt[Ht]] = Se[xt[Ht]];
      return me;
    };
    function ze(me, Se) {
      return Object.prototype.hasOwnProperty.call(me, Se);
    }
    var ke = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    r.promisify = function(Se) {
      if (typeof Se != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (ke && Se[ke]) {
        var xt = Se[ke];
        if (typeof xt != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(xt, ke, {
          value: xt,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), xt;
      }
      function xt() {
        for (var Ht, Bt, ut = new Promise(function(an, Ct) {
          Ht = an, Bt = Ct;
        }), Tt = [], Yt = 0; Yt < arguments.length; Yt++)
          Tt.push(arguments[Yt]);
        Tt.push(function(an, Ct) {
          an ? Bt(an) : Ht(Ct);
        });
        try {
          Se.apply(this, Tt);
        } catch (an) {
          Bt(an);
        }
        return ut;
      }
      return Object.setPrototypeOf(xt, Object.getPrototypeOf(Se)), ke && Object.defineProperty(xt, ke, {
        value: xt,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        xt,
        e(Se)
      );
    }, r.promisify.custom = ke;
    function Be(me, Se) {
      if (!me) {
        var xt = new Error("Promise was rejected with a falsy value");
        xt.reason = me, me = xt;
      }
      return Se(me);
    }
    function Me(me) {
      if (typeof me != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function Se() {
        for (var xt = [], Ht = 0; Ht < arguments.length; Ht++)
          xt.push(arguments[Ht]);
        var Bt = xt.pop();
        if (typeof Bt != "function")
          throw new TypeError("The last argument must be of type Function");
        var ut = this, Tt = function() {
          return Bt.apply(ut, arguments);
        };
        me.apply(this, xt).then(
          function(Yt) {
            api$1.nextTick(Tt.bind(null, null, Yt));
          },
          function(Yt) {
            api$1.nextTick(Be.bind(null, Yt, Tt));
          }
        );
      }
      return Object.setPrototypeOf(Se, Object.getPrototypeOf(me)), Object.defineProperties(
        Se,
        e(me)
      ), Se;
    }
    r.callbackify = Me;
  }(util$3)), util$3;
}
var buffer_list, hasRequiredBuffer_list;
function requireBuffer_list() {
  if (hasRequiredBuffer_list)
    return buffer_list;
  hasRequiredBuffer_list = 1;
  function r(_, m) {
    var L = Object.keys(_);
    if (Object.getOwnPropertySymbols) {
      var F = Object.getOwnPropertySymbols(_);
      m && (F = F.filter(function(W) {
        return Object.getOwnPropertyDescriptor(_, W).enumerable;
      })), L.push.apply(L, F);
    }
    return L;
  }
  function e(_) {
    for (var m = 1; m < arguments.length; m++) {
      var L = arguments[m] != null ? arguments[m] : {};
      m % 2 ? r(Object(L), !0).forEach(function(F) {
        s(_, F, L[F]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_, Object.getOwnPropertyDescriptors(L)) : r(Object(L)).forEach(function(F) {
        Object.defineProperty(_, F, Object.getOwnPropertyDescriptor(L, F));
      });
    }
    return _;
  }
  function s(_, m, L) {
    return m = u(m), m in _ ? Object.defineProperty(_, m, { value: L, enumerable: !0, configurable: !0, writable: !0 }) : _[m] = L, _;
  }
  function o(_, m) {
    if (!(_ instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(_, m) {
    for (var L = 0; L < m.length; L++) {
      var F = m[L];
      F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(_, u(F.key), F);
    }
  }
  function l(_, m, L) {
    return m && a(_.prototype, m), L && a(_, L), Object.defineProperty(_, "prototype", { writable: !1 }), _;
  }
  function u(_) {
    var m = c(_, "string");
    return typeof m == "symbol" ? m : String(m);
  }
  function c(_, m) {
    if (typeof _ != "object" || _ === null)
      return _;
    var L = _[Symbol.toPrimitive];
    if (L !== void 0) {
      var F = L.call(_, m || "default");
      if (typeof F != "object")
        return F;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (m === "string" ? String : Number)(_);
  }
  var E = buffer$1, d = E.Buffer, f = requireUtil$1(), h = f.inspect, S = h && h.custom || "inspect";
  function R(_, m, L) {
    d.prototype.copy.call(_, m, L);
  }
  return buffer_list = /* @__PURE__ */ function() {
    function _() {
      o(this, _), this.head = null, this.tail = null, this.length = 0;
    }
    return l(_, [{
      key: "push",
      value: function(L) {
        var F = {
          data: L,
          next: null
        };
        this.length > 0 ? this.tail.next = F : this.head = F, this.tail = F, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(L) {
        var F = {
          data: L,
          next: this.head
        };
        this.length === 0 && (this.tail = F), this.head = F, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var L = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, L;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(L) {
        if (this.length === 0)
          return "";
        for (var F = this.head, W = "" + F.data; F = F.next; )
          W += L + F.data;
        return W;
      }
    }, {
      key: "concat",
      value: function(L) {
        if (this.length === 0)
          return d.alloc(0);
        for (var F = d.allocUnsafe(L >>> 0), W = this.head, G = 0; W; )
          R(W.data, F, G), G += W.data.length, W = W.next;
        return F;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(L, F) {
        var W;
        return L < this.head.data.length ? (W = this.head.data.slice(0, L), this.head.data = this.head.data.slice(L)) : L === this.head.data.length ? W = this.shift() : W = F ? this._getString(L) : this._getBuffer(L), W;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(L) {
        var F = this.head, W = 1, G = F.data;
        for (L -= G.length; F = F.next; ) {
          var q = F.data, fe = L > q.length ? q.length : L;
          if (fe === q.length ? G += q : G += q.slice(0, L), L -= fe, L === 0) {
            fe === q.length ? (++W, F.next ? this.head = F.next : this.head = this.tail = null) : (this.head = F, F.data = q.slice(fe));
            break;
          }
          ++W;
        }
        return this.length -= W, G;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(L) {
        var F = d.allocUnsafe(L), W = this.head, G = 1;
        for (W.data.copy(F), L -= W.data.length; W = W.next; ) {
          var q = W.data, fe = L > q.length ? q.length : L;
          if (q.copy(F, F.length - L, 0, fe), L -= fe, L === 0) {
            fe === q.length ? (++G, W.next ? this.head = W.next : this.head = this.tail = null) : (this.head = W, W.data = q.slice(fe));
            break;
          }
          ++G;
        }
        return this.length -= G, F;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: S,
      value: function(L, F) {
        return h(this, e(e({}, F), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), _;
  }(), buffer_list;
}
var destroy_1$1, hasRequiredDestroy$1;
function requireDestroy$1() {
  if (hasRequiredDestroy$1)
    return destroy_1$1;
  hasRequiredDestroy$1 = 1;
  function r(u, c) {
    var E = this, d = this._readableState && this._readableState.destroyed, f = this._writableState && this._writableState.destroyed;
    return d || f ? (c ? c(u) : u && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, api$1.nextTick(a, this, u)) : api$1.nextTick(a, this, u)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(u || null, function(h) {
      !c && h ? E._writableState ? E._writableState.errorEmitted ? api$1.nextTick(s, E) : (E._writableState.errorEmitted = !0, api$1.nextTick(e, E, h)) : api$1.nextTick(e, E, h) : c ? (api$1.nextTick(s, E), c(h)) : api$1.nextTick(s, E);
    }), this);
  }
  function e(u, c) {
    a(u, c), s(u);
  }
  function s(u) {
    u._writableState && !u._writableState.emitClose || u._readableState && !u._readableState.emitClose || u.emit("close");
  }
  function o() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function a(u, c) {
    u.emit("error", c);
  }
  function l(u, c) {
    var E = u._readableState, d = u._writableState;
    E && E.autoDestroy || d && d.autoDestroy ? u.destroy(c) : u.emit("error", c);
  }
  return destroy_1$1 = {
    destroy: r,
    undestroy: o,
    errorOrDestroy: l
  }, destroy_1$1;
}
var errorsBrowser = {}, hasRequiredErrorsBrowser;
function requireErrorsBrowser() {
  if (hasRequiredErrorsBrowser)
    return errorsBrowser;
  hasRequiredErrorsBrowser = 1;
  function r(c, E) {
    c.prototype = Object.create(E.prototype), c.prototype.constructor = c, c.__proto__ = E;
  }
  var e = {};
  function s(c, E, d) {
    d || (d = Error);
    function f(S, R, _) {
      return typeof E == "string" ? E : E(S, R, _);
    }
    var h = /* @__PURE__ */ function(S) {
      r(R, S);
      function R(_, m, L) {
        return S.call(this, f(_, m, L)) || this;
      }
      return R;
    }(d);
    h.prototype.name = d.name, h.prototype.code = c, e[c] = h;
  }
  function o(c, E) {
    if (Array.isArray(c)) {
      var d = c.length;
      return c = c.map(function(f) {
        return String(f);
      }), d > 2 ? "one of ".concat(E, " ").concat(c.slice(0, d - 1).join(", "), ", or ") + c[d - 1] : d === 2 ? "one of ".concat(E, " ").concat(c[0], " or ").concat(c[1]) : "of ".concat(E, " ").concat(c[0]);
    } else
      return "of ".concat(E, " ").concat(String(c));
  }
  function a(c, E, d) {
    return c.substr(!d || d < 0 ? 0 : +d, E.length) === E;
  }
  function l(c, E, d) {
    return (d === void 0 || d > c.length) && (d = c.length), c.substring(d - E.length, d) === E;
  }
  function u(c, E, d) {
    return typeof d != "number" && (d = 0), d + E.length > c.length ? !1 : c.indexOf(E, d) !== -1;
  }
  return s("ERR_INVALID_OPT_VALUE", function(c, E) {
    return 'The value "' + E + '" is invalid for option "' + c + '"';
  }, TypeError), s("ERR_INVALID_ARG_TYPE", function(c, E, d) {
    var f;
    typeof E == "string" && a(E, "not ") ? (f = "must not be", E = E.replace(/^not /, "")) : f = "must be";
    var h;
    if (l(c, " argument"))
      h = "The ".concat(c, " ").concat(f, " ").concat(o(E, "type"));
    else {
      var S = u(c, ".") ? "property" : "argument";
      h = 'The "'.concat(c, '" ').concat(S, " ").concat(f, " ").concat(o(E, "type"));
    }
    return h += ". Received type ".concat(typeof d), h;
  }, TypeError), s("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), s("ERR_METHOD_NOT_IMPLEMENTED", function(c) {
    return "The " + c + " method is not implemented";
  }), s("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), s("ERR_STREAM_DESTROYED", function(c) {
    return "Cannot call " + c + " after a stream was destroyed";
  }), s("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), s("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), s("ERR_STREAM_WRITE_AFTER_END", "write after end"), s("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), s("ERR_UNKNOWN_ENCODING", function(c) {
    return "Unknown encoding: " + c;
  }, TypeError), s("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), errorsBrowser.codes = e, errorsBrowser;
}
var state, hasRequiredState;
function requireState() {
  if (hasRequiredState)
    return state;
  hasRequiredState = 1;
  var r = requireErrorsBrowser().codes.ERR_INVALID_OPT_VALUE;
  function e(o, a, l) {
    return o.highWaterMark != null ? o.highWaterMark : a ? o[l] : null;
  }
  function s(o, a, l, u) {
    var c = e(a, u, l);
    if (c != null) {
      if (!(isFinite(c) && Math.floor(c) === c) || c < 0) {
        var E = u ? l : "highWaterMark";
        throw new r(E, c);
      }
      return Math.floor(c);
    }
    return o.objectMode ? 16 : 16 * 1024;
  }
  return state = {
    getHighWaterMark: s
  }, state;
}
var browser$a, hasRequiredBrowser$a;
function requireBrowser$a() {
  if (hasRequiredBrowser$a)
    return browser$a;
  hasRequiredBrowser$a = 1, browser$a = r;
  function r(s, o) {
    if (e("noDeprecation"))
      return s;
    var a = !1;
    function l() {
      if (!a) {
        if (e("throwDeprecation"))
          throw new Error(o);
        e("traceDeprecation") ? console.trace(o) : console.warn(o), a = !0;
      }
      return s.apply(this, arguments);
    }
    return l;
  }
  function e(s) {
    try {
      if (!commonjsGlobal.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var o = commonjsGlobal.localStorage[s];
    return o == null ? !1 : String(o).toLowerCase() === "true";
  }
  return browser$a;
}
var _stream_writable$1, hasRequired_stream_writable$1;
function require_stream_writable$1() {
  if (hasRequired_stream_writable$1)
    return _stream_writable$1;
  hasRequired_stream_writable$1 = 1, _stream_writable$1 = Fe;
  function r(Bt) {
    var ut = this;
    this.next = null, this.entry = null, this.finish = function() {
      Ht(ut, Bt);
    };
  }
  var e;
  Fe.WritableState = _e;
  var s = {
    deprecate: requireBrowser$a()
  }, o = requireStreamBrowser$1(), a = buffer$1.Buffer, l = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function u(Bt) {
    return a.from(Bt);
  }
  function c(Bt) {
    return a.isBuffer(Bt) || Bt instanceof l;
  }
  var E = requireDestroy$1(), d = requireState(), f = d.getHighWaterMark, h = requireErrorsBrowser().codes, S = h.ERR_INVALID_ARG_TYPE, R = h.ERR_METHOD_NOT_IMPLEMENTED, _ = h.ERR_MULTIPLE_CALLBACK, m = h.ERR_STREAM_CANNOT_PIPE, L = h.ERR_STREAM_DESTROYED, F = h.ERR_STREAM_NULL_VALUES, W = h.ERR_STREAM_WRITE_AFTER_END, G = h.ERR_UNKNOWN_ENCODING, q = E.errorOrDestroy;
  requireInherits_browser()(Fe, o);
  function fe() {
  }
  function _e(Bt, ut, Tt) {
    e = e || require_stream_duplex$1(), Bt = Bt || {}, typeof Tt != "boolean" && (Tt = ut instanceof e), this.objectMode = !!Bt.objectMode, Tt && (this.objectMode = this.objectMode || !!Bt.writableObjectMode), this.highWaterMark = f(this, Bt, "writableHighWaterMark", Tt), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Yt = Bt.decodeStrings === !1;
    this.decodeStrings = !Yt, this.defaultEncoding = Bt.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(an) {
      De(ut, an);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Bt.emitClose !== !1, this.autoDestroy = !!Bt.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new r(this);
  }
  _e.prototype.getBuffer = function() {
    for (var ut = this.bufferedRequest, Tt = []; ut; )
      Tt.push(ut), ut = ut.next;
    return Tt;
  }, function() {
    try {
      Object.defineProperty(_e.prototype, "buffer", {
        get: s.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var Le;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (Le = Function.prototype[Symbol.hasInstance], Object.defineProperty(Fe, Symbol.hasInstance, {
    value: function(ut) {
      return Le.call(this, ut) ? !0 : this !== Fe ? !1 : ut && ut._writableState instanceof _e;
    }
  })) : Le = function(ut) {
    return ut instanceof this;
  };
  function Fe(Bt) {
    e = e || require_stream_duplex$1();
    var ut = this instanceof e;
    if (!ut && !Le.call(Fe, this))
      return new Fe(Bt);
    this._writableState = new _e(Bt, this, ut), this.writable = !0, Bt && (typeof Bt.write == "function" && (this._write = Bt.write), typeof Bt.writev == "function" && (this._writev = Bt.writev), typeof Bt.destroy == "function" && (this._destroy = Bt.destroy), typeof Bt.final == "function" && (this._final = Bt.final)), o.call(this);
  }
  Fe.prototype.pipe = function() {
    q(this, new m());
  };
  function Ee(Bt, ut) {
    var Tt = new W();
    q(Bt, Tt), api$1.nextTick(ut, Tt);
  }
  function Ge(Bt, ut, Tt, Yt) {
    var an;
    return Tt === null ? an = new F() : typeof Tt != "string" && !ut.objectMode && (an = new S("chunk", ["string", "Buffer"], Tt)), an ? (q(Bt, an), api$1.nextTick(Yt, an), !1) : !0;
  }
  Fe.prototype.write = function(Bt, ut, Tt) {
    var Yt = this._writableState, an = !1, Ct = !Yt.objectMode && c(Bt);
    return Ct && !a.isBuffer(Bt) && (Bt = u(Bt)), typeof ut == "function" && (Tt = ut, ut = null), Ct ? ut = "buffer" : ut || (ut = Yt.defaultEncoding), typeof Tt != "function" && (Tt = fe), Yt.ending ? Ee(this, Tt) : (Ct || Ge(this, Yt, Bt, Tt)) && (Yt.pendingcb++, an = te(this, Yt, Ct, Bt, ut, Tt)), an;
  }, Fe.prototype.cork = function() {
    this._writableState.corked++;
  }, Fe.prototype.uncork = function() {
    var Bt = this._writableState;
    Bt.corked && (Bt.corked--, !Bt.writing && !Bt.corked && !Bt.bufferProcessing && Bt.bufferedRequest && ke(this, Bt));
  }, Fe.prototype.setDefaultEncoding = function(ut) {
    if (typeof ut == "string" && (ut = ut.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ut + "").toLowerCase()) > -1))
      throw new G(ut);
    return this._writableState.defaultEncoding = ut, this;
  }, Object.defineProperty(Fe.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function ve(Bt, ut, Tt) {
    return !Bt.objectMode && Bt.decodeStrings !== !1 && typeof ut == "string" && (ut = a.from(ut, Tt)), ut;
  }
  Object.defineProperty(Fe.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function te(Bt, ut, Tt, Yt, an, Ct) {
    if (!Tt) {
      var st = ve(ut, Yt, an);
      Yt !== st && (Tt = !0, an = "buffer", Yt = st);
    }
    var jt = ut.objectMode ? 1 : Yt.length;
    ut.length += jt;
    var lt = ut.length < ut.highWaterMark;
    if (lt || (ut.needDrain = !0), ut.writing || ut.corked) {
      var Zt = ut.lastBufferedRequest;
      ut.lastBufferedRequest = {
        chunk: Yt,
        encoding: an,
        isBuf: Tt,
        callback: Ct,
        next: null
      }, Zt ? Zt.next = ut.lastBufferedRequest : ut.bufferedRequest = ut.lastBufferedRequest, ut.bufferedRequestCount += 1;
    } else
      ae(Bt, ut, !1, jt, Yt, an, Ct);
    return lt;
  }
  function ae(Bt, ut, Tt, Yt, an, Ct, st) {
    ut.writelen = Yt, ut.writecb = st, ut.writing = !0, ut.sync = !0, ut.destroyed ? ut.onwrite(new L("write")) : Tt ? Bt._writev(an, ut.onwrite) : Bt._write(an, Ct, ut.onwrite), ut.sync = !1;
  }
  function v(Bt, ut, Tt, Yt, an) {
    --ut.pendingcb, Tt ? (api$1.nextTick(an, Yt), api$1.nextTick(Se, Bt, ut), Bt._writableState.errorEmitted = !0, q(Bt, Yt)) : (an(Yt), Bt._writableState.errorEmitted = !0, q(Bt, Yt), Se(Bt, ut));
  }
  function Te(Bt) {
    Bt.writing = !1, Bt.writecb = null, Bt.length -= Bt.writelen, Bt.writelen = 0;
  }
  function De(Bt, ut) {
    var Tt = Bt._writableState, Yt = Tt.sync, an = Tt.writecb;
    if (typeof an != "function")
      throw new _();
    if (Te(Tt), ut)
      v(Bt, Tt, Yt, ut, an);
    else {
      var Ct = Be(Tt) || Bt.destroyed;
      !Ct && !Tt.corked && !Tt.bufferProcessing && Tt.bufferedRequest && ke(Bt, Tt), Yt ? api$1.nextTick(be, Bt, Tt, Ct, an) : be(Bt, Tt, Ct, an);
    }
  }
  function be(Bt, ut, Tt, Yt) {
    Tt || ze(Bt, ut), ut.pendingcb--, Yt(), Se(Bt, ut);
  }
  function ze(Bt, ut) {
    ut.length === 0 && ut.needDrain && (ut.needDrain = !1, Bt.emit("drain"));
  }
  function ke(Bt, ut) {
    ut.bufferProcessing = !0;
    var Tt = ut.bufferedRequest;
    if (Bt._writev && Tt && Tt.next) {
      var Yt = ut.bufferedRequestCount, an = new Array(Yt), Ct = ut.corkedRequestsFree;
      Ct.entry = Tt;
      for (var st = 0, jt = !0; Tt; )
        an[st] = Tt, Tt.isBuf || (jt = !1), Tt = Tt.next, st += 1;
      an.allBuffers = jt, ae(Bt, ut, !0, ut.length, an, "", Ct.finish), ut.pendingcb++, ut.lastBufferedRequest = null, Ct.next ? (ut.corkedRequestsFree = Ct.next, Ct.next = null) : ut.corkedRequestsFree = new r(ut), ut.bufferedRequestCount = 0;
    } else {
      for (; Tt; ) {
        var lt = Tt.chunk, Zt = Tt.encoding, Et = Tt.callback, Ke = ut.objectMode ? 1 : lt.length;
        if (ae(Bt, ut, !1, Ke, lt, Zt, Et), Tt = Tt.next, ut.bufferedRequestCount--, ut.writing)
          break;
      }
      Tt === null && (ut.lastBufferedRequest = null);
    }
    ut.bufferedRequest = Tt, ut.bufferProcessing = !1;
  }
  Fe.prototype._write = function(Bt, ut, Tt) {
    Tt(new R("_write()"));
  }, Fe.prototype._writev = null, Fe.prototype.end = function(Bt, ut, Tt) {
    var Yt = this._writableState;
    return typeof Bt == "function" ? (Tt = Bt, Bt = null, ut = null) : typeof ut == "function" && (Tt = ut, ut = null), Bt != null && this.write(Bt, ut), Yt.corked && (Yt.corked = 1, this.uncork()), Yt.ending || xt(this, Yt, Tt), this;
  }, Object.defineProperty(Fe.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function Be(Bt) {
    return Bt.ending && Bt.length === 0 && Bt.bufferedRequest === null && !Bt.finished && !Bt.writing;
  }
  function Me(Bt, ut) {
    Bt._final(function(Tt) {
      ut.pendingcb--, Tt && q(Bt, Tt), ut.prefinished = !0, Bt.emit("prefinish"), Se(Bt, ut);
    });
  }
  function me(Bt, ut) {
    !ut.prefinished && !ut.finalCalled && (typeof Bt._final == "function" && !ut.destroyed ? (ut.pendingcb++, ut.finalCalled = !0, api$1.nextTick(Me, Bt, ut)) : (ut.prefinished = !0, Bt.emit("prefinish")));
  }
  function Se(Bt, ut) {
    var Tt = Be(ut);
    if (Tt && (me(Bt, ut), ut.pendingcb === 0 && (ut.finished = !0, Bt.emit("finish"), ut.autoDestroy))) {
      var Yt = Bt._readableState;
      (!Yt || Yt.autoDestroy && Yt.endEmitted) && Bt.destroy();
    }
    return Tt;
  }
  function xt(Bt, ut, Tt) {
    ut.ending = !0, Se(Bt, ut), Tt && (ut.finished ? api$1.nextTick(Tt) : Bt.once("finish", Tt)), ut.ended = !0, Bt.writable = !1;
  }
  function Ht(Bt, ut, Tt) {
    var Yt = Bt.entry;
    for (Bt.entry = null; Yt; ) {
      var an = Yt.callback;
      ut.pendingcb--, an(Tt), Yt = Yt.next;
    }
    ut.corkedRequestsFree.next = Bt;
  }
  return Object.defineProperty(Fe.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(ut) {
      this._writableState && (this._writableState.destroyed = ut);
    }
  }), Fe.prototype.destroy = E.destroy, Fe.prototype._undestroy = E.undestroy, Fe.prototype._destroy = function(Bt, ut) {
    ut(Bt);
  }, _stream_writable$1;
}
var _stream_duplex$1, hasRequired_stream_duplex$1;
function require_stream_duplex$1() {
  if (hasRequired_stream_duplex$1)
    return _stream_duplex$1;
  hasRequired_stream_duplex$1 = 1;
  var r = Object.keys || function(d) {
    var f = [];
    for (var h in d)
      f.push(h);
    return f;
  };
  _stream_duplex$1 = u;
  var e = require_stream_readable$1(), s = require_stream_writable$1();
  requireInherits_browser()(u, e);
  for (var o = r(s.prototype), a = 0; a < o.length; a++) {
    var l = o[a];
    u.prototype[l] || (u.prototype[l] = s.prototype[l]);
  }
  function u(d) {
    if (!(this instanceof u))
      return new u(d);
    e.call(this, d), s.call(this, d), this.allowHalfOpen = !0, d && (d.readable === !1 && (this.readable = !1), d.writable === !1 && (this.writable = !1), d.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", c)));
  }
  Object.defineProperty(u.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(u.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(u.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function c() {
    this._writableState.ended || api$1.nextTick(E, this);
  }
  function E(d) {
    d.end();
  }
  return Object.defineProperty(u.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(f) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = f, this._writableState.destroyed = f);
    }
  }), _stream_duplex$1;
}
var string_decoder = {}, hasRequiredString_decoder;
function requireString_decoder() {
  if (hasRequiredString_decoder)
    return string_decoder;
  hasRequiredString_decoder = 1;
  var r = requireSafeBuffer$1().Buffer, e = r.isEncoding || function(F) {
    switch (F = "" + F, F && F.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function s(F) {
    if (!F)
      return "utf8";
    for (var W; ; )
      switch (F) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return F;
        default:
          if (W)
            return;
          F = ("" + F).toLowerCase(), W = !0;
      }
  }
  function o(F) {
    var W = s(F);
    if (typeof W != "string" && (r.isEncoding === e || !e(F)))
      throw new Error("Unknown encoding: " + F);
    return W || F;
  }
  string_decoder.StringDecoder = a;
  function a(F) {
    this.encoding = o(F);
    var W;
    switch (this.encoding) {
      case "utf16le":
        this.text = h, this.end = S, W = 4;
        break;
      case "utf8":
        this.fillLast = E, W = 4;
        break;
      case "base64":
        this.text = R, this.end = _, W = 3;
        break;
      default:
        this.write = m, this.end = L;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(W);
  }
  a.prototype.write = function(F) {
    if (F.length === 0)
      return "";
    var W, G;
    if (this.lastNeed) {
      if (W = this.fillLast(F), W === void 0)
        return "";
      G = this.lastNeed, this.lastNeed = 0;
    } else
      G = 0;
    return G < F.length ? W ? W + this.text(F, G) : this.text(F, G) : W || "";
  }, a.prototype.end = f, a.prototype.text = d, a.prototype.fillLast = function(F) {
    if (this.lastNeed <= F.length)
      return F.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    F.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, F.length), this.lastNeed -= F.length;
  };
  function l(F) {
    return F <= 127 ? 0 : F >> 5 === 6 ? 2 : F >> 4 === 14 ? 3 : F >> 3 === 30 ? 4 : F >> 6 === 2 ? -1 : -2;
  }
  function u(F, W, G) {
    var q = W.length - 1;
    if (q < G)
      return 0;
    var fe = l(W[q]);
    return fe >= 0 ? (fe > 0 && (F.lastNeed = fe - 1), fe) : --q < G || fe === -2 ? 0 : (fe = l(W[q]), fe >= 0 ? (fe > 0 && (F.lastNeed = fe - 2), fe) : --q < G || fe === -2 ? 0 : (fe = l(W[q]), fe >= 0 ? (fe > 0 && (fe === 2 ? fe = 0 : F.lastNeed = fe - 3), fe) : 0));
  }
  function c(F, W, G) {
    if ((W[0] & 192) !== 128)
      return F.lastNeed = 0, "�";
    if (F.lastNeed > 1 && W.length > 1) {
      if ((W[1] & 192) !== 128)
        return F.lastNeed = 1, "�";
      if (F.lastNeed > 2 && W.length > 2 && (W[2] & 192) !== 128)
        return F.lastNeed = 2, "�";
    }
  }
  function E(F) {
    var W = this.lastTotal - this.lastNeed, G = c(this, F);
    if (G !== void 0)
      return G;
    if (this.lastNeed <= F.length)
      return F.copy(this.lastChar, W, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    F.copy(this.lastChar, W, 0, F.length), this.lastNeed -= F.length;
  }
  function d(F, W) {
    var G = u(this, F, W);
    if (!this.lastNeed)
      return F.toString("utf8", W);
    this.lastTotal = G;
    var q = F.length - (G - this.lastNeed);
    return F.copy(this.lastChar, 0, q), F.toString("utf8", W, q);
  }
  function f(F) {
    var W = F && F.length ? this.write(F) : "";
    return this.lastNeed ? W + "�" : W;
  }
  function h(F, W) {
    if ((F.length - W) % 2 === 0) {
      var G = F.toString("utf16le", W);
      if (G) {
        var q = G.charCodeAt(G.length - 1);
        if (q >= 55296 && q <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = F[F.length - 2], this.lastChar[1] = F[F.length - 1], G.slice(0, -1);
      }
      return G;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = F[F.length - 1], F.toString("utf16le", W, F.length - 1);
  }
  function S(F) {
    var W = F && F.length ? this.write(F) : "";
    if (this.lastNeed) {
      var G = this.lastTotal - this.lastNeed;
      return W + this.lastChar.toString("utf16le", 0, G);
    }
    return W;
  }
  function R(F, W) {
    var G = (F.length - W) % 3;
    return G === 0 ? F.toString("base64", W) : (this.lastNeed = 3 - G, this.lastTotal = 3, G === 1 ? this.lastChar[0] = F[F.length - 1] : (this.lastChar[0] = F[F.length - 2], this.lastChar[1] = F[F.length - 1]), F.toString("base64", W, F.length - G));
  }
  function _(F) {
    var W = F && F.length ? this.write(F) : "";
    return this.lastNeed ? W + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : W;
  }
  function m(F) {
    return F.toString(this.encoding);
  }
  function L(F) {
    return F && F.length ? this.write(F) : "";
  }
  return string_decoder;
}
var endOfStream, hasRequiredEndOfStream;
function requireEndOfStream() {
  if (hasRequiredEndOfStream)
    return endOfStream;
  hasRequiredEndOfStream = 1;
  var r = requireErrorsBrowser().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(l) {
    var u = !1;
    return function() {
      if (!u) {
        u = !0;
        for (var c = arguments.length, E = new Array(c), d = 0; d < c; d++)
          E[d] = arguments[d];
        l.apply(this, E);
      }
    };
  }
  function s() {
  }
  function o(l) {
    return l.setHeader && typeof l.abort == "function";
  }
  function a(l, u, c) {
    if (typeof u == "function")
      return a(l, null, u);
    u || (u = {}), c = e(c || s);
    var E = u.readable || u.readable !== !1 && l.readable, d = u.writable || u.writable !== !1 && l.writable, f = function() {
      l.writable || S();
    }, h = l._writableState && l._writableState.finished, S = function() {
      d = !1, h = !0, E || c.call(l);
    }, R = l._readableState && l._readableState.endEmitted, _ = function() {
      E = !1, R = !0, d || c.call(l);
    }, m = function(G) {
      c.call(l, G);
    }, L = function() {
      var G;
      if (E && !R)
        return (!l._readableState || !l._readableState.ended) && (G = new r()), c.call(l, G);
      if (d && !h)
        return (!l._writableState || !l._writableState.ended) && (G = new r()), c.call(l, G);
    }, F = function() {
      l.req.on("finish", S);
    };
    return o(l) ? (l.on("complete", S), l.on("abort", L), l.req ? F() : l.on("request", F)) : d && !l._writableState && (l.on("end", f), l.on("close", f)), l.on("end", _), l.on("finish", S), u.error !== !1 && l.on("error", m), l.on("close", L), function() {
      l.removeListener("complete", S), l.removeListener("abort", L), l.removeListener("request", F), l.req && l.req.removeListener("finish", S), l.removeListener("end", f), l.removeListener("close", f), l.removeListener("finish", S), l.removeListener("end", _), l.removeListener("error", m), l.removeListener("close", L);
    };
  }
  return endOfStream = a, endOfStream;
}
var async_iterator, hasRequiredAsync_iterator;
function requireAsync_iterator() {
  if (hasRequiredAsync_iterator)
    return async_iterator;
  hasRequiredAsync_iterator = 1;
  var r;
  function e(G, q, fe) {
    return q = s(q), q in G ? Object.defineProperty(G, q, { value: fe, enumerable: !0, configurable: !0, writable: !0 }) : G[q] = fe, G;
  }
  function s(G) {
    var q = o(G, "string");
    return typeof q == "symbol" ? q : String(q);
  }
  function o(G, q) {
    if (typeof G != "object" || G === null)
      return G;
    var fe = G[Symbol.toPrimitive];
    if (fe !== void 0) {
      var _e = fe.call(G, q || "default");
      if (typeof _e != "object")
        return _e;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (q === "string" ? String : Number)(G);
  }
  var a = requireEndOfStream(), l = Symbol("lastResolve"), u = Symbol("lastReject"), c = Symbol("error"), E = Symbol("ended"), d = Symbol("lastPromise"), f = Symbol("handlePromise"), h = Symbol("stream");
  function S(G, q) {
    return {
      value: G,
      done: q
    };
  }
  function R(G) {
    var q = G[l];
    if (q !== null) {
      var fe = G[h].read();
      fe !== null && (G[d] = null, G[l] = null, G[u] = null, q(S(fe, !1)));
    }
  }
  function _(G) {
    api$1.nextTick(R, G);
  }
  function m(G, q) {
    return function(fe, _e) {
      G.then(function() {
        if (q[E]) {
          fe(S(void 0, !0));
          return;
        }
        q[f](fe, _e);
      }, _e);
    };
  }
  var L = Object.getPrototypeOf(function() {
  }), F = Object.setPrototypeOf((r = {
    get stream() {
      return this[h];
    },
    next: function() {
      var q = this, fe = this[c];
      if (fe !== null)
        return Promise.reject(fe);
      if (this[E])
        return Promise.resolve(S(void 0, !0));
      if (this[h].destroyed)
        return new Promise(function(Ee, Ge) {
          api$1.nextTick(function() {
            q[c] ? Ge(q[c]) : Ee(S(void 0, !0));
          });
        });
      var _e = this[d], Le;
      if (_e)
        Le = new Promise(m(_e, this));
      else {
        var Fe = this[h].read();
        if (Fe !== null)
          return Promise.resolve(S(Fe, !1));
        Le = new Promise(this[f]);
      }
      return this[d] = Le, Le;
    }
  }, e(r, Symbol.asyncIterator, function() {
    return this;
  }), e(r, "return", function() {
    var q = this;
    return new Promise(function(fe, _e) {
      q[h].destroy(null, function(Le) {
        if (Le) {
          _e(Le);
          return;
        }
        fe(S(void 0, !0));
      });
    });
  }), r), L), W = function(q) {
    var fe, _e = Object.create(F, (fe = {}, e(fe, h, {
      value: q,
      writable: !0
    }), e(fe, l, {
      value: null,
      writable: !0
    }), e(fe, u, {
      value: null,
      writable: !0
    }), e(fe, c, {
      value: null,
      writable: !0
    }), e(fe, E, {
      value: q._readableState.endEmitted,
      writable: !0
    }), e(fe, f, {
      value: function(Fe, Ee) {
        var Ge = _e[h].read();
        Ge ? (_e[d] = null, _e[l] = null, _e[u] = null, Fe(S(Ge, !1))) : (_e[l] = Fe, _e[u] = Ee);
      },
      writable: !0
    }), fe));
    return _e[d] = null, a(q, function(Le) {
      if (Le && Le.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var Fe = _e[u];
        Fe !== null && (_e[d] = null, _e[l] = null, _e[u] = null, Fe(Le)), _e[c] = Le;
        return;
      }
      var Ee = _e[l];
      Ee !== null && (_e[d] = null, _e[l] = null, _e[u] = null, Ee(S(void 0, !0))), _e[E] = !0;
    }), q.on("readable", _.bind(null, _e)), _e;
  };
  return async_iterator = W, async_iterator;
}
var fromBrowser, hasRequiredFromBrowser;
function requireFromBrowser() {
  return hasRequiredFromBrowser || (hasRequiredFromBrowser = 1, fromBrowser = function() {
    throw new Error("Readable.from is not available in the browser");
  }), fromBrowser;
}
var _stream_readable$1, hasRequired_stream_readable$1;
function require_stream_readable$1() {
  if (hasRequired_stream_readable$1)
    return _stream_readable$1;
  hasRequired_stream_readable$1 = 1, _stream_readable$1 = Ee;
  var r;
  Ee.ReadableState = Fe, requireEvents().EventEmitter;
  var e = function(st, jt) {
    return st.listeners(jt).length;
  }, s = requireStreamBrowser$1(), o = buffer$1.Buffer, a = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function l(Ct) {
    return o.from(Ct);
  }
  function u(Ct) {
    return o.isBuffer(Ct) || Ct instanceof a;
  }
  var c = requireUtil$1(), E;
  c && c.debuglog ? E = c.debuglog("stream") : E = function() {
  };
  var d = requireBuffer_list(), f = requireDestroy$1(), h = requireState(), S = h.getHighWaterMark, R = requireErrorsBrowser().codes, _ = R.ERR_INVALID_ARG_TYPE, m = R.ERR_STREAM_PUSH_AFTER_EOF, L = R.ERR_METHOD_NOT_IMPLEMENTED, F = R.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, W, G, q;
  requireInherits_browser()(Ee, s);
  var fe = f.errorOrDestroy, _e = ["error", "close", "destroy", "pause", "resume"];
  function Le(Ct, st, jt) {
    if (typeof Ct.prependListener == "function")
      return Ct.prependListener(st, jt);
    !Ct._events || !Ct._events[st] ? Ct.on(st, jt) : Array.isArray(Ct._events[st]) ? Ct._events[st].unshift(jt) : Ct._events[st] = [jt, Ct._events[st]];
  }
  function Fe(Ct, st, jt) {
    r = r || require_stream_duplex$1(), Ct = Ct || {}, typeof jt != "boolean" && (jt = st instanceof r), this.objectMode = !!Ct.objectMode, jt && (this.objectMode = this.objectMode || !!Ct.readableObjectMode), this.highWaterMark = S(this, Ct, "readableHighWaterMark", jt), this.buffer = new d(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = Ct.emitClose !== !1, this.autoDestroy = !!Ct.autoDestroy, this.destroyed = !1, this.defaultEncoding = Ct.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, Ct.encoding && (W || (W = requireString_decoder().StringDecoder), this.decoder = new W(Ct.encoding), this.encoding = Ct.encoding);
  }
  function Ee(Ct) {
    if (r = r || require_stream_duplex$1(), !(this instanceof Ee))
      return new Ee(Ct);
    var st = this instanceof r;
    this._readableState = new Fe(Ct, this, st), this.readable = !0, Ct && (typeof Ct.read == "function" && (this._read = Ct.read), typeof Ct.destroy == "function" && (this._destroy = Ct.destroy)), s.call(this);
  }
  Object.defineProperty(Ee.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(st) {
      this._readableState && (this._readableState.destroyed = st);
    }
  }), Ee.prototype.destroy = f.destroy, Ee.prototype._undestroy = f.undestroy, Ee.prototype._destroy = function(Ct, st) {
    st(Ct);
  }, Ee.prototype.push = function(Ct, st) {
    var jt = this._readableState, lt;
    return jt.objectMode ? lt = !0 : typeof Ct == "string" && (st = st || jt.defaultEncoding, st !== jt.encoding && (Ct = o.from(Ct, st), st = ""), lt = !0), Ge(this, Ct, st, !1, lt);
  }, Ee.prototype.unshift = function(Ct) {
    return Ge(this, Ct, null, !0, !1);
  };
  function Ge(Ct, st, jt, lt, Zt) {
    E("readableAddChunk", st);
    var Et = Ct._readableState;
    if (st === null)
      Et.reading = !1, De(Ct, Et);
    else {
      var Ke;
      if (Zt || (Ke = te(Et, st)), Ke)
        fe(Ct, Ke);
      else if (Et.objectMode || st && st.length > 0)
        if (typeof st != "string" && !Et.objectMode && Object.getPrototypeOf(st) !== o.prototype && (st = l(st)), lt)
          Et.endEmitted ? fe(Ct, new F()) : ve(Ct, Et, st, !0);
        else if (Et.ended)
          fe(Ct, new m());
        else {
          if (Et.destroyed)
            return !1;
          Et.reading = !1, Et.decoder && !jt ? (st = Et.decoder.write(st), Et.objectMode || st.length !== 0 ? ve(Ct, Et, st, !1) : ke(Ct, Et)) : ve(Ct, Et, st, !1);
        }
      else
        lt || (Et.reading = !1, ke(Ct, Et));
    }
    return !Et.ended && (Et.length < Et.highWaterMark || Et.length === 0);
  }
  function ve(Ct, st, jt, lt) {
    st.flowing && st.length === 0 && !st.sync ? (st.awaitDrain = 0, Ct.emit("data", jt)) : (st.length += st.objectMode ? 1 : jt.length, lt ? st.buffer.unshift(jt) : st.buffer.push(jt), st.needReadable && be(Ct)), ke(Ct, st);
  }
  function te(Ct, st) {
    var jt;
    return !u(st) && typeof st != "string" && st !== void 0 && !Ct.objectMode && (jt = new _("chunk", ["string", "Buffer", "Uint8Array"], st)), jt;
  }
  Ee.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, Ee.prototype.setEncoding = function(Ct) {
    W || (W = requireString_decoder().StringDecoder);
    var st = new W(Ct);
    this._readableState.decoder = st, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var jt = this._readableState.buffer.head, lt = ""; jt !== null; )
      lt += st.write(jt.data), jt = jt.next;
    return this._readableState.buffer.clear(), lt !== "" && this._readableState.buffer.push(lt), this._readableState.length = lt.length, this;
  };
  var ae = 1073741824;
  function v(Ct) {
    return Ct >= ae ? Ct = ae : (Ct--, Ct |= Ct >>> 1, Ct |= Ct >>> 2, Ct |= Ct >>> 4, Ct |= Ct >>> 8, Ct |= Ct >>> 16, Ct++), Ct;
  }
  function Te(Ct, st) {
    return Ct <= 0 || st.length === 0 && st.ended ? 0 : st.objectMode ? 1 : Ct !== Ct ? st.flowing && st.length ? st.buffer.head.data.length : st.length : (Ct > st.highWaterMark && (st.highWaterMark = v(Ct)), Ct <= st.length ? Ct : st.ended ? st.length : (st.needReadable = !0, 0));
  }
  Ee.prototype.read = function(Ct) {
    E("read", Ct), Ct = parseInt(Ct, 10);
    var st = this._readableState, jt = Ct;
    if (Ct !== 0 && (st.emittedReadable = !1), Ct === 0 && st.needReadable && ((st.highWaterMark !== 0 ? st.length >= st.highWaterMark : st.length > 0) || st.ended))
      return E("read: emitReadable", st.length, st.ended), st.length === 0 && st.ended ? Tt(this) : be(this), null;
    if (Ct = Te(Ct, st), Ct === 0 && st.ended)
      return st.length === 0 && Tt(this), null;
    var lt = st.needReadable;
    E("need readable", lt), (st.length === 0 || st.length - Ct < st.highWaterMark) && (lt = !0, E("length less than watermark", lt)), st.ended || st.reading ? (lt = !1, E("reading or ended", lt)) : lt && (E("do read"), st.reading = !0, st.sync = !0, st.length === 0 && (st.needReadable = !0), this._read(st.highWaterMark), st.sync = !1, st.reading || (Ct = Te(jt, st)));
    var Zt;
    return Ct > 0 ? Zt = ut(Ct, st) : Zt = null, Zt === null ? (st.needReadable = st.length <= st.highWaterMark, Ct = 0) : (st.length -= Ct, st.awaitDrain = 0), st.length === 0 && (st.ended || (st.needReadable = !0), jt !== Ct && st.ended && Tt(this)), Zt !== null && this.emit("data", Zt), Zt;
  };
  function De(Ct, st) {
    if (E("onEofChunk"), !st.ended) {
      if (st.decoder) {
        var jt = st.decoder.end();
        jt && jt.length && (st.buffer.push(jt), st.length += st.objectMode ? 1 : jt.length);
      }
      st.ended = !0, st.sync ? be(Ct) : (st.needReadable = !1, st.emittedReadable || (st.emittedReadable = !0, ze(Ct)));
    }
  }
  function be(Ct) {
    var st = Ct._readableState;
    E("emitReadable", st.needReadable, st.emittedReadable), st.needReadable = !1, st.emittedReadable || (E("emitReadable", st.flowing), st.emittedReadable = !0, api$1.nextTick(ze, Ct));
  }
  function ze(Ct) {
    var st = Ct._readableState;
    E("emitReadable_", st.destroyed, st.length, st.ended), !st.destroyed && (st.length || st.ended) && (Ct.emit("readable"), st.emittedReadable = !1), st.needReadable = !st.flowing && !st.ended && st.length <= st.highWaterMark, Bt(Ct);
  }
  function ke(Ct, st) {
    st.readingMore || (st.readingMore = !0, api$1.nextTick(Be, Ct, st));
  }
  function Be(Ct, st) {
    for (; !st.reading && !st.ended && (st.length < st.highWaterMark || st.flowing && st.length === 0); ) {
      var jt = st.length;
      if (E("maybeReadMore read 0"), Ct.read(0), jt === st.length)
        break;
    }
    st.readingMore = !1;
  }
  Ee.prototype._read = function(Ct) {
    fe(this, new L("_read()"));
  }, Ee.prototype.pipe = function(Ct, st) {
    var jt = this, lt = this._readableState;
    switch (lt.pipesCount) {
      case 0:
        lt.pipes = Ct;
        break;
      case 1:
        lt.pipes = [lt.pipes, Ct];
        break;
      default:
        lt.pipes.push(Ct);
        break;
    }
    lt.pipesCount += 1, E("pipe count=%d opts=%j", lt.pipesCount, st);
    var Zt = (!st || st.end !== !1) && Ct !== api$1.stdout && Ct !== api$1.stderr, Et = Zt ? $e : hn;
    lt.endEmitted ? api$1.nextTick(Et) : jt.once("end", Et), Ct.on("unpipe", Ke);
    function Ke(Vt, Tn) {
      E("onunpipe"), Vt === jt && Tn && Tn.hasUnpiped === !1 && (Tn.hasUnpiped = !0, In());
    }
    function $e() {
      E("onend"), Ct.end();
    }
    var pt = Me(jt);
    Ct.on("drain", pt);
    var Jt = !1;
    function In() {
      E("cleanup"), Ct.removeListener("close", ht), Ct.removeListener("finish", Wt), Ct.removeListener("drain", pt), Ct.removeListener("error", It), Ct.removeListener("unpipe", Ke), jt.removeListener("end", $e), jt.removeListener("end", hn), jt.removeListener("data", Cn), Jt = !0, lt.awaitDrain && (!Ct._writableState || Ct._writableState.needDrain) && pt();
    }
    jt.on("data", Cn);
    function Cn(Vt) {
      E("ondata");
      var Tn = Ct.write(Vt);
      E("dest.write", Tn), Tn === !1 && ((lt.pipesCount === 1 && lt.pipes === Ct || lt.pipesCount > 1 && an(lt.pipes, Ct) !== -1) && !Jt && (E("false write response, pause", lt.awaitDrain), lt.awaitDrain++), jt.pause());
    }
    function It(Vt) {
      E("onerror", Vt), hn(), Ct.removeListener("error", It), e(Ct, "error") === 0 && fe(Ct, Vt);
    }
    Le(Ct, "error", It);
    function ht() {
      Ct.removeListener("finish", Wt), hn();
    }
    Ct.once("close", ht);
    function Wt() {
      E("onfinish"), Ct.removeListener("close", ht), hn();
    }
    Ct.once("finish", Wt);
    function hn() {
      E("unpipe"), jt.unpipe(Ct);
    }
    return Ct.emit("pipe", jt), lt.flowing || (E("pipe resume"), jt.resume()), Ct;
  };
  function Me(Ct) {
    return function() {
      var jt = Ct._readableState;
      E("pipeOnDrain", jt.awaitDrain), jt.awaitDrain && jt.awaitDrain--, jt.awaitDrain === 0 && e(Ct, "data") && (jt.flowing = !0, Bt(Ct));
    };
  }
  Ee.prototype.unpipe = function(Ct) {
    var st = this._readableState, jt = {
      hasUnpiped: !1
    };
    if (st.pipesCount === 0)
      return this;
    if (st.pipesCount === 1)
      return Ct && Ct !== st.pipes ? this : (Ct || (Ct = st.pipes), st.pipes = null, st.pipesCount = 0, st.flowing = !1, Ct && Ct.emit("unpipe", this, jt), this);
    if (!Ct) {
      var lt = st.pipes, Zt = st.pipesCount;
      st.pipes = null, st.pipesCount = 0, st.flowing = !1;
      for (var Et = 0; Et < Zt; Et++)
        lt[Et].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var Ke = an(st.pipes, Ct);
    return Ke === -1 ? this : (st.pipes.splice(Ke, 1), st.pipesCount -= 1, st.pipesCount === 1 && (st.pipes = st.pipes[0]), Ct.emit("unpipe", this, jt), this);
  }, Ee.prototype.on = function(Ct, st) {
    var jt = s.prototype.on.call(this, Ct, st), lt = this._readableState;
    return Ct === "data" ? (lt.readableListening = this.listenerCount("readable") > 0, lt.flowing !== !1 && this.resume()) : Ct === "readable" && !lt.endEmitted && !lt.readableListening && (lt.readableListening = lt.needReadable = !0, lt.flowing = !1, lt.emittedReadable = !1, E("on readable", lt.length, lt.reading), lt.length ? be(this) : lt.reading || api$1.nextTick(Se, this)), jt;
  }, Ee.prototype.addListener = Ee.prototype.on, Ee.prototype.removeListener = function(Ct, st) {
    var jt = s.prototype.removeListener.call(this, Ct, st);
    return Ct === "readable" && api$1.nextTick(me, this), jt;
  }, Ee.prototype.removeAllListeners = function(Ct) {
    var st = s.prototype.removeAllListeners.apply(this, arguments);
    return (Ct === "readable" || Ct === void 0) && api$1.nextTick(me, this), st;
  };
  function me(Ct) {
    var st = Ct._readableState;
    st.readableListening = Ct.listenerCount("readable") > 0, st.resumeScheduled && !st.paused ? st.flowing = !0 : Ct.listenerCount("data") > 0 && Ct.resume();
  }
  function Se(Ct) {
    E("readable nexttick read 0"), Ct.read(0);
  }
  Ee.prototype.resume = function() {
    var Ct = this._readableState;
    return Ct.flowing || (E("resume"), Ct.flowing = !Ct.readableListening, xt(this, Ct)), Ct.paused = !1, this;
  };
  function xt(Ct, st) {
    st.resumeScheduled || (st.resumeScheduled = !0, api$1.nextTick(Ht, Ct, st));
  }
  function Ht(Ct, st) {
    E("resume", st.reading), st.reading || Ct.read(0), st.resumeScheduled = !1, Ct.emit("resume"), Bt(Ct), st.flowing && !st.reading && Ct.read(0);
  }
  Ee.prototype.pause = function() {
    return E("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (E("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Bt(Ct) {
    var st = Ct._readableState;
    for (E("flow", st.flowing); st.flowing && Ct.read() !== null; )
      ;
  }
  Ee.prototype.wrap = function(Ct) {
    var st = this, jt = this._readableState, lt = !1;
    Ct.on("end", function() {
      if (E("wrapped end"), jt.decoder && !jt.ended) {
        var Ke = jt.decoder.end();
        Ke && Ke.length && st.push(Ke);
      }
      st.push(null);
    }), Ct.on("data", function(Ke) {
      if (E("wrapped data"), jt.decoder && (Ke = jt.decoder.write(Ke)), !(jt.objectMode && Ke == null) && !(!jt.objectMode && (!Ke || !Ke.length))) {
        var $e = st.push(Ke);
        $e || (lt = !0, Ct.pause());
      }
    });
    for (var Zt in Ct)
      this[Zt] === void 0 && typeof Ct[Zt] == "function" && (this[Zt] = function($e) {
        return function() {
          return Ct[$e].apply(Ct, arguments);
        };
      }(Zt));
    for (var Et = 0; Et < _e.length; Et++)
      Ct.on(_e[Et], this.emit.bind(this, _e[Et]));
    return this._read = function(Ke) {
      E("wrapped _read", Ke), lt && (lt = !1, Ct.resume());
    }, this;
  }, typeof Symbol == "function" && (Ee.prototype[Symbol.asyncIterator] = function() {
    return G === void 0 && (G = requireAsync_iterator()), G(this);
  }), Object.defineProperty(Ee.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(Ee.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(Ee.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(st) {
      this._readableState && (this._readableState.flowing = st);
    }
  }), Ee._fromList = ut, Object.defineProperty(Ee.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function ut(Ct, st) {
    if (st.length === 0)
      return null;
    var jt;
    return st.objectMode ? jt = st.buffer.shift() : !Ct || Ct >= st.length ? (st.decoder ? jt = st.buffer.join("") : st.buffer.length === 1 ? jt = st.buffer.first() : jt = st.buffer.concat(st.length), st.buffer.clear()) : jt = st.buffer.consume(Ct, st.decoder), jt;
  }
  function Tt(Ct) {
    var st = Ct._readableState;
    E("endReadable", st.endEmitted), st.endEmitted || (st.ended = !0, api$1.nextTick(Yt, st, Ct));
  }
  function Yt(Ct, st) {
    if (E("endReadableNT", Ct.endEmitted, Ct.length), !Ct.endEmitted && Ct.length === 0 && (Ct.endEmitted = !0, st.readable = !1, st.emit("end"), Ct.autoDestroy)) {
      var jt = st._writableState;
      (!jt || jt.autoDestroy && jt.finished) && st.destroy();
    }
  }
  typeof Symbol == "function" && (Ee.from = function(Ct, st) {
    return q === void 0 && (q = requireFromBrowser()), q(Ee, Ct, st);
  });
  function an(Ct, st) {
    for (var jt = 0, lt = Ct.length; jt < lt; jt++)
      if (Ct[jt] === st)
        return jt;
    return -1;
  }
  return _stream_readable$1;
}
var _stream_transform$1, hasRequired_stream_transform$1;
function require_stream_transform$1() {
  if (hasRequired_stream_transform$1)
    return _stream_transform$1;
  hasRequired_stream_transform$1 = 1, _stream_transform$1 = c;
  var r = requireErrorsBrowser().codes, e = r.ERR_METHOD_NOT_IMPLEMENTED, s = r.ERR_MULTIPLE_CALLBACK, o = r.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = r.ERR_TRANSFORM_WITH_LENGTH_0, l = require_stream_duplex$1();
  requireInherits_browser()(c, l);
  function u(f, h) {
    var S = this._transformState;
    S.transforming = !1;
    var R = S.writecb;
    if (R === null)
      return this.emit("error", new s());
    S.writechunk = null, S.writecb = null, h != null && this.push(h), R(f);
    var _ = this._readableState;
    _.reading = !1, (_.needReadable || _.length < _.highWaterMark) && this._read(_.highWaterMark);
  }
  function c(f) {
    if (!(this instanceof c))
      return new c(f);
    l.call(this, f), this._transformState = {
      afterTransform: u.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, f && (typeof f.transform == "function" && (this._transform = f.transform), typeof f.flush == "function" && (this._flush = f.flush)), this.on("prefinish", E);
  }
  function E() {
    var f = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(h, S) {
      d(f, h, S);
    }) : d(this, null, null);
  }
  c.prototype.push = function(f, h) {
    return this._transformState.needTransform = !1, l.prototype.push.call(this, f, h);
  }, c.prototype._transform = function(f, h, S) {
    S(new e("_transform()"));
  }, c.prototype._write = function(f, h, S) {
    var R = this._transformState;
    if (R.writecb = S, R.writechunk = f, R.writeencoding = h, !R.transforming) {
      var _ = this._readableState;
      (R.needTransform || _.needReadable || _.length < _.highWaterMark) && this._read(_.highWaterMark);
    }
  }, c.prototype._read = function(f) {
    var h = this._transformState;
    h.writechunk !== null && !h.transforming ? (h.transforming = !0, this._transform(h.writechunk, h.writeencoding, h.afterTransform)) : h.needTransform = !0;
  }, c.prototype._destroy = function(f, h) {
    l.prototype._destroy.call(this, f, function(S) {
      h(S);
    });
  };
  function d(f, h, S) {
    if (h)
      return f.emit("error", h);
    if (S != null && f.push(S), f._writableState.length)
      throw new a();
    if (f._transformState.transforming)
      throw new o();
    return f.push(null);
  }
  return _stream_transform$1;
}
var _stream_passthrough$1, hasRequired_stream_passthrough$1;
function require_stream_passthrough$1() {
  if (hasRequired_stream_passthrough$1)
    return _stream_passthrough$1;
  hasRequired_stream_passthrough$1 = 1, _stream_passthrough$1 = e;
  var r = require_stream_transform$1();
  requireInherits_browser()(e, r);
  function e(s) {
    if (!(this instanceof e))
      return new e(s);
    r.call(this, s);
  }
  return e.prototype._transform = function(s, o, a) {
    a(null, s);
  }, _stream_passthrough$1;
}
var pipeline_1, hasRequiredPipeline;
function requirePipeline() {
  if (hasRequiredPipeline)
    return pipeline_1;
  hasRequiredPipeline = 1;
  var r;
  function e(S) {
    var R = !1;
    return function() {
      R || (R = !0, S.apply(void 0, arguments));
    };
  }
  var s = requireErrorsBrowser().codes, o = s.ERR_MISSING_ARGS, a = s.ERR_STREAM_DESTROYED;
  function l(S) {
    if (S)
      throw S;
  }
  function u(S) {
    return S.setHeader && typeof S.abort == "function";
  }
  function c(S, R, _, m) {
    m = e(m);
    var L = !1;
    S.on("close", function() {
      L = !0;
    }), r === void 0 && (r = requireEndOfStream()), r(S, {
      readable: R,
      writable: _
    }, function(W) {
      if (W)
        return m(W);
      L = !0, m();
    });
    var F = !1;
    return function(W) {
      if (!L && !F) {
        if (F = !0, u(S))
          return S.abort();
        if (typeof S.destroy == "function")
          return S.destroy();
        m(W || new a("pipe"));
      }
    };
  }
  function E(S) {
    S();
  }
  function d(S, R) {
    return S.pipe(R);
  }
  function f(S) {
    return !S.length || typeof S[S.length - 1] != "function" ? l : S.pop();
  }
  function h() {
    for (var S = arguments.length, R = new Array(S), _ = 0; _ < S; _++)
      R[_] = arguments[_];
    var m = f(R);
    if (Array.isArray(R[0]) && (R = R[0]), R.length < 2)
      throw new o("streams");
    var L, F = R.map(function(W, G) {
      var q = G < R.length - 1, fe = G > 0;
      return c(W, q, fe, function(_e) {
        L || (L = _e), _e && F.forEach(E), !q && (F.forEach(E), m(L));
      });
    });
    return R.reduce(d);
  }
  return pipeline_1 = h, pipeline_1;
}
var streamBrowserify, hasRequiredStreamBrowserify;
function requireStreamBrowserify() {
  if (hasRequiredStreamBrowserify)
    return streamBrowserify;
  hasRequiredStreamBrowserify = 1, streamBrowserify = s;
  var r = requireEvents().EventEmitter, e = requireInherits_browser();
  e(s, r), s.Readable = require_stream_readable$1(), s.Writable = require_stream_writable$1(), s.Duplex = require_stream_duplex$1(), s.Transform = require_stream_transform$1(), s.PassThrough = require_stream_passthrough$1(), s.finished = requireEndOfStream(), s.pipeline = requirePipeline(), s.Stream = s;
  function s() {
    r.call(this);
  }
  return s.prototype.pipe = function(o, a) {
    var l = this;
    function u(R) {
      o.writable && o.write(R) === !1 && l.pause && l.pause();
    }
    l.on("data", u);
    function c() {
      l.readable && l.resume && l.resume();
    }
    o.on("drain", c), !o._isStdio && (!a || a.end !== !1) && (l.on("end", d), l.on("close", f));
    var E = !1;
    function d() {
      E || (E = !0, o.end());
    }
    function f() {
      E || (E = !0, typeof o.destroy == "function" && o.destroy());
    }
    function h(R) {
      if (S(), r.listenerCount(this, "error") === 0)
        throw R;
    }
    l.on("error", h), o.on("error", h);
    function S() {
      l.removeListener("data", u), o.removeListener("drain", c), l.removeListener("end", d), l.removeListener("close", f), l.removeListener("error", h), o.removeListener("error", h), l.removeListener("end", S), l.removeListener("close", S), o.removeListener("close", S);
    }
    return l.on("end", S), l.on("close", S), o.on("close", S), o.emit("pipe", l), o;
  }, streamBrowserify;
}
var hashBase$1, hasRequiredHashBase$1;
function requireHashBase$1() {
  if (hasRequiredHashBase$1)
    return hashBase$1;
  hasRequiredHashBase$1 = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireStreamBrowserify().Transform, s = requireInherits_browser();
  function o(c) {
    e.call(this), this._block = r.allocUnsafe(c), this._blockSize = c, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  s(o, e), o.prototype._transform = function(c, E, d) {
    var f = null;
    try {
      this.update(c, E);
    } catch (h) {
      f = h;
    }
    d(f);
  }, o.prototype._flush = function(c) {
    var E = null;
    try {
      this.push(this.digest());
    } catch (d) {
      E = d;
    }
    c(E);
  };
  var a = typeof Uint8Array < "u", l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (r.prototype instanceof Uint8Array || r.TYPED_ARRAY_SUPPORT);
  function u(c, E) {
    if (c instanceof r)
      return c;
    if (typeof c == "string")
      return r.from(c, E);
    if (l && ArrayBuffer.isView(c)) {
      if (c.byteLength === 0)
        return r.alloc(0);
      var d = r.from(c.buffer, c.byteOffset, c.byteLength);
      if (d.byteLength === c.byteLength)
        return d;
    }
    if (a && c instanceof Uint8Array || r.isBuffer(c) && c.constructor && typeof c.constructor.isBuffer == "function" && c.constructor.isBuffer(c))
      return r.from(c);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return o.prototype.update = function(c, E) {
    if (this._finalized)
      throw new Error("Digest already called");
    c = u(c, E);
    for (var d = this._block, f = 0; this._blockOffset + c.length - f >= this._blockSize; ) {
      for (var h = this._blockOffset; h < this._blockSize; )
        d[h++] = c[f++];
      this._update(), this._blockOffset = 0;
    }
    for (; f < c.length; )
      d[this._blockOffset++] = c[f++];
    for (var S = 0, R = c.length * 8; R > 0; ++S)
      this._length[S] += R, R = this._length[S] / 4294967296 | 0, R > 0 && (this._length[S] -= 4294967296 * R);
    return this;
  }, o.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, o.prototype.digest = function(c) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var E = this._digest();
    c !== void 0 && (E = E.toString(c)), this._block.fill(0), this._blockOffset = 0;
    for (var d = 0; d < 4; ++d)
      this._length[d] = 0;
    return E;
  }, o.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase$1 = o, hashBase$1;
}
var md5_js, hasRequiredMd5_js;
function requireMd5_js() {
  if (hasRequiredMd5_js)
    return md5_js;
  hasRequiredMd5_js = 1;
  var r = requireInherits_browser(), e = requireHashBase$1(), s = requireSafeBuffer$1().Buffer, o = new Array(16);
  function a() {
    e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  r(a, e), a.prototype._update = function() {
    for (var f = o, h = 0; h < 16; ++h)
      f[h] = this._block.readInt32LE(h * 4);
    var S = this._a, R = this._b, _ = this._c, m = this._d;
    S = u(S, R, _, m, f[0], 3614090360, 7), m = u(m, S, R, _, f[1], 3905402710, 12), _ = u(_, m, S, R, f[2], 606105819, 17), R = u(R, _, m, S, f[3], 3250441966, 22), S = u(S, R, _, m, f[4], 4118548399, 7), m = u(m, S, R, _, f[5], 1200080426, 12), _ = u(_, m, S, R, f[6], 2821735955, 17), R = u(R, _, m, S, f[7], 4249261313, 22), S = u(S, R, _, m, f[8], 1770035416, 7), m = u(m, S, R, _, f[9], 2336552879, 12), _ = u(_, m, S, R, f[10], 4294925233, 17), R = u(R, _, m, S, f[11], 2304563134, 22), S = u(S, R, _, m, f[12], 1804603682, 7), m = u(m, S, R, _, f[13], 4254626195, 12), _ = u(_, m, S, R, f[14], 2792965006, 17), R = u(R, _, m, S, f[15], 1236535329, 22), S = c(S, R, _, m, f[1], 4129170786, 5), m = c(m, S, R, _, f[6], 3225465664, 9), _ = c(_, m, S, R, f[11], 643717713, 14), R = c(R, _, m, S, f[0], 3921069994, 20), S = c(S, R, _, m, f[5], 3593408605, 5), m = c(m, S, R, _, f[10], 38016083, 9), _ = c(_, m, S, R, f[15], 3634488961, 14), R = c(R, _, m, S, f[4], 3889429448, 20), S = c(S, R, _, m, f[9], 568446438, 5), m = c(m, S, R, _, f[14], 3275163606, 9), _ = c(_, m, S, R, f[3], 4107603335, 14), R = c(R, _, m, S, f[8], 1163531501, 20), S = c(S, R, _, m, f[13], 2850285829, 5), m = c(m, S, R, _, f[2], 4243563512, 9), _ = c(_, m, S, R, f[7], 1735328473, 14), R = c(R, _, m, S, f[12], 2368359562, 20), S = E(S, R, _, m, f[5], 4294588738, 4), m = E(m, S, R, _, f[8], 2272392833, 11), _ = E(_, m, S, R, f[11], 1839030562, 16), R = E(R, _, m, S, f[14], 4259657740, 23), S = E(S, R, _, m, f[1], 2763975236, 4), m = E(m, S, R, _, f[4], 1272893353, 11), _ = E(_, m, S, R, f[7], 4139469664, 16), R = E(R, _, m, S, f[10], 3200236656, 23), S = E(S, R, _, m, f[13], 681279174, 4), m = E(m, S, R, _, f[0], 3936430074, 11), _ = E(_, m, S, R, f[3], 3572445317, 16), R = E(R, _, m, S, f[6], 76029189, 23), S = E(S, R, _, m, f[9], 3654602809, 4), m = E(m, S, R, _, f[12], 3873151461, 11), _ = E(_, m, S, R, f[15], 530742520, 16), R = E(R, _, m, S, f[2], 3299628645, 23), S = d(S, R, _, m, f[0], 4096336452, 6), m = d(m, S, R, _, f[7], 1126891415, 10), _ = d(_, m, S, R, f[14], 2878612391, 15), R = d(R, _, m, S, f[5], 4237533241, 21), S = d(S, R, _, m, f[12], 1700485571, 6), m = d(m, S, R, _, f[3], 2399980690, 10), _ = d(_, m, S, R, f[10], 4293915773, 15), R = d(R, _, m, S, f[1], 2240044497, 21), S = d(S, R, _, m, f[8], 1873313359, 6), m = d(m, S, R, _, f[15], 4264355552, 10), _ = d(_, m, S, R, f[6], 2734768916, 15), R = d(R, _, m, S, f[13], 1309151649, 21), S = d(S, R, _, m, f[4], 4149444226, 6), m = d(m, S, R, _, f[11], 3174756917, 10), _ = d(_, m, S, R, f[2], 718787259, 15), R = d(R, _, m, S, f[9], 3951481745, 21), this._a = this._a + S | 0, this._b = this._b + R | 0, this._c = this._c + _ | 0, this._d = this._d + m | 0;
  }, a.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var f = s.allocUnsafe(16);
    return f.writeInt32LE(this._a, 0), f.writeInt32LE(this._b, 4), f.writeInt32LE(this._c, 8), f.writeInt32LE(this._d, 12), f;
  };
  function l(f, h) {
    return f << h | f >>> 32 - h;
  }
  function u(f, h, S, R, _, m, L) {
    return l(f + (h & S | ~h & R) + _ + m | 0, L) + h | 0;
  }
  function c(f, h, S, R, _, m, L) {
    return l(f + (h & R | S & ~R) + _ + m | 0, L) + h | 0;
  }
  function E(f, h, S, R, _, m, L) {
    return l(f + (h ^ S ^ R) + _ + m | 0, L) + h | 0;
  }
  function d(f, h, S, R, _, m, L) {
    return l(f + (S ^ (h | ~R)) + _ + m | 0, L) + h | 0;
  }
  return md5_js = a, md5_js;
}
var ripemd160$1, hasRequiredRipemd160$1;
function requireRipemd160$1() {
  if (hasRequiredRipemd160$1)
    return ripemd160$1;
  hasRequiredRipemd160$1 = 1;
  var r = buffer$1.Buffer, e = requireInherits_browser(), s = requireHashBase$1(), o = new Array(16), a = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], l = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], u = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], c = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], E = [0, 1518500249, 1859775393, 2400959708, 2840853838], d = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function f() {
    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  e(f, s), f.prototype._update = function() {
    for (var F = o, W = 0; W < 16; ++W)
      F[W] = this._block.readInt32LE(W * 4);
    for (var G = this._a | 0, q = this._b | 0, fe = this._c | 0, _e = this._d | 0, Le = this._e | 0, Fe = this._a | 0, Ee = this._b | 0, Ge = this._c | 0, ve = this._d | 0, te = this._e | 0, ae = 0; ae < 80; ae += 1) {
      var v, Te;
      ae < 16 ? (v = S(G, q, fe, _e, Le, F[a[ae]], E[0], u[ae]), Te = L(Fe, Ee, Ge, ve, te, F[l[ae]], d[0], c[ae])) : ae < 32 ? (v = R(G, q, fe, _e, Le, F[a[ae]], E[1], u[ae]), Te = m(Fe, Ee, Ge, ve, te, F[l[ae]], d[1], c[ae])) : ae < 48 ? (v = _(G, q, fe, _e, Le, F[a[ae]], E[2], u[ae]), Te = _(Fe, Ee, Ge, ve, te, F[l[ae]], d[2], c[ae])) : ae < 64 ? (v = m(G, q, fe, _e, Le, F[a[ae]], E[3], u[ae]), Te = R(Fe, Ee, Ge, ve, te, F[l[ae]], d[3], c[ae])) : (v = L(G, q, fe, _e, Le, F[a[ae]], E[4], u[ae]), Te = S(Fe, Ee, Ge, ve, te, F[l[ae]], d[4], c[ae])), G = Le, Le = _e, _e = h(fe, 10), fe = q, q = v, Fe = te, te = ve, ve = h(Ge, 10), Ge = Ee, Ee = Te;
    }
    var De = this._b + fe + ve | 0;
    this._b = this._c + _e + te | 0, this._c = this._d + Le + Fe | 0, this._d = this._e + G + Ee | 0, this._e = this._a + q + Ge | 0, this._a = De;
  }, f.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var F = r.alloc ? r.alloc(20) : new r(20);
    return F.writeInt32LE(this._a, 0), F.writeInt32LE(this._b, 4), F.writeInt32LE(this._c, 8), F.writeInt32LE(this._d, 12), F.writeInt32LE(this._e, 16), F;
  };
  function h(F, W) {
    return F << W | F >>> 32 - W;
  }
  function S(F, W, G, q, fe, _e, Le, Fe) {
    return h(F + (W ^ G ^ q) + _e + Le | 0, Fe) + fe | 0;
  }
  function R(F, W, G, q, fe, _e, Le, Fe) {
    return h(F + (W & G | ~W & q) + _e + Le | 0, Fe) + fe | 0;
  }
  function _(F, W, G, q, fe, _e, Le, Fe) {
    return h(F + ((W | ~G) ^ q) + _e + Le | 0, Fe) + fe | 0;
  }
  function m(F, W, G, q, fe, _e, Le, Fe) {
    return h(F + (W & q | G & ~q) + _e + Le | 0, Fe) + fe | 0;
  }
  function L(F, W, G, q, fe, _e, Le, Fe) {
    return h(F + (W ^ (G | ~q)) + _e + Le | 0, Fe) + fe | 0;
  }
  return ripemd160$1 = f, ripemd160$1;
}
var sha_js = { exports: {} }, hash$1, hasRequiredHash$1;
function requireHash$1() {
  if (hasRequiredHash$1)
    return hash$1;
  hasRequiredHash$1 = 1;
  var r = requireSafeBuffer$1().Buffer;
  function e(s, o) {
    this._block = r.alloc(s), this._finalSize = o, this._blockSize = s, this._len = 0;
  }
  return e.prototype.update = function(s, o) {
    typeof s == "string" && (o = o || "utf8", s = r.from(s, o));
    for (var a = this._block, l = this._blockSize, u = s.length, c = this._len, E = 0; E < u; ) {
      for (var d = c % l, f = Math.min(u - E, l - d), h = 0; h < f; h++)
        a[d + h] = s[E + h];
      c += f, E += f, c % l === 0 && this._update(a);
    }
    return this._len += u, this;
  }, e.prototype.digest = function(s) {
    var o = this._len % this._blockSize;
    this._block[o] = 128, this._block.fill(0, o + 1), o >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var a = this._len * 8;
    if (a <= 4294967295)
      this._block.writeUInt32BE(a, this._blockSize - 4);
    else {
      var l = (a & 4294967295) >>> 0, u = (a - l) / 4294967296;
      this._block.writeUInt32BE(u, this._blockSize - 8), this._block.writeUInt32BE(l, this._blockSize - 4);
    }
    this._update(this._block);
    var c = this._hash();
    return s ? c.toString(s) : c;
  }, e.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, hash$1 = e, hash$1;
}
var sha$1, hasRequiredSha$1;
function requireSha$1() {
  if (hasRequiredSha$1)
    return sha$1;
  hasRequiredSha$1 = 1;
  var r = requireInherits_browser(), e = requireHash$1(), s = requireSafeBuffer$1().Buffer, o = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], a = new Array(80);
  function l() {
    this.init(), this._w = a, e.call(this, 64, 56);
  }
  r(l, e), l.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function u(d) {
    return d << 5 | d >>> 27;
  }
  function c(d) {
    return d << 30 | d >>> 2;
  }
  function E(d, f, h, S) {
    return d === 0 ? f & h | ~f & S : d === 2 ? f & h | f & S | h & S : f ^ h ^ S;
  }
  return l.prototype._update = function(d) {
    for (var f = this._w, h = this._a | 0, S = this._b | 0, R = this._c | 0, _ = this._d | 0, m = this._e | 0, L = 0; L < 16; ++L)
      f[L] = d.readInt32BE(L * 4);
    for (; L < 80; ++L)
      f[L] = f[L - 3] ^ f[L - 8] ^ f[L - 14] ^ f[L - 16];
    for (var F = 0; F < 80; ++F) {
      var W = ~~(F / 20), G = u(h) + E(W, S, R, _) + m + f[F] + o[W] | 0;
      m = _, _ = R, R = c(S), S = h, h = G;
    }
    this._a = h + this._a | 0, this._b = S + this._b | 0, this._c = R + this._c | 0, this._d = _ + this._d | 0, this._e = m + this._e | 0;
  }, l.prototype._hash = function() {
    var d = s.allocUnsafe(20);
    return d.writeInt32BE(this._a | 0, 0), d.writeInt32BE(this._b | 0, 4), d.writeInt32BE(this._c | 0, 8), d.writeInt32BE(this._d | 0, 12), d.writeInt32BE(this._e | 0, 16), d;
  }, sha$1 = l, sha$1;
}
var sha1, hasRequiredSha1;
function requireSha1() {
  if (hasRequiredSha1)
    return sha1;
  hasRequiredSha1 = 1;
  var r = requireInherits_browser(), e = requireHash$1(), s = requireSafeBuffer$1().Buffer, o = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], a = new Array(80);
  function l() {
    this.init(), this._w = a, e.call(this, 64, 56);
  }
  r(l, e), l.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function u(f) {
    return f << 1 | f >>> 31;
  }
  function c(f) {
    return f << 5 | f >>> 27;
  }
  function E(f) {
    return f << 30 | f >>> 2;
  }
  function d(f, h, S, R) {
    return f === 0 ? h & S | ~h & R : f === 2 ? h & S | h & R | S & R : h ^ S ^ R;
  }
  return l.prototype._update = function(f) {
    for (var h = this._w, S = this._a | 0, R = this._b | 0, _ = this._c | 0, m = this._d | 0, L = this._e | 0, F = 0; F < 16; ++F)
      h[F] = f.readInt32BE(F * 4);
    for (; F < 80; ++F)
      h[F] = u(h[F - 3] ^ h[F - 8] ^ h[F - 14] ^ h[F - 16]);
    for (var W = 0; W < 80; ++W) {
      var G = ~~(W / 20), q = c(S) + d(G, R, _, m) + L + h[W] + o[G] | 0;
      L = m, m = _, _ = E(R), R = S, S = q;
    }
    this._a = S + this._a | 0, this._b = R + this._b | 0, this._c = _ + this._c | 0, this._d = m + this._d | 0, this._e = L + this._e | 0;
  }, l.prototype._hash = function() {
    var f = s.allocUnsafe(20);
    return f.writeInt32BE(this._a | 0, 0), f.writeInt32BE(this._b | 0, 4), f.writeInt32BE(this._c | 0, 8), f.writeInt32BE(this._d | 0, 12), f.writeInt32BE(this._e | 0, 16), f;
  }, sha1 = l, sha1;
}
var sha256$1, hasRequiredSha256;
function requireSha256() {
  if (hasRequiredSha256)
    return sha256$1;
  hasRequiredSha256 = 1;
  var r = requireInherits_browser(), e = requireHash$1(), s = requireSafeBuffer$1().Buffer, o = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], a = new Array(64);
  function l() {
    this.init(), this._w = a, e.call(this, 64, 56);
  }
  r(l, e), l.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function u(S, R, _) {
    return _ ^ S & (R ^ _);
  }
  function c(S, R, _) {
    return S & R | _ & (S | R);
  }
  function E(S) {
    return (S >>> 2 | S << 30) ^ (S >>> 13 | S << 19) ^ (S >>> 22 | S << 10);
  }
  function d(S) {
    return (S >>> 6 | S << 26) ^ (S >>> 11 | S << 21) ^ (S >>> 25 | S << 7);
  }
  function f(S) {
    return (S >>> 7 | S << 25) ^ (S >>> 18 | S << 14) ^ S >>> 3;
  }
  function h(S) {
    return (S >>> 17 | S << 15) ^ (S >>> 19 | S << 13) ^ S >>> 10;
  }
  return l.prototype._update = function(S) {
    for (var R = this._w, _ = this._a | 0, m = this._b | 0, L = this._c | 0, F = this._d | 0, W = this._e | 0, G = this._f | 0, q = this._g | 0, fe = this._h | 0, _e = 0; _e < 16; ++_e)
      R[_e] = S.readInt32BE(_e * 4);
    for (; _e < 64; ++_e)
      R[_e] = h(R[_e - 2]) + R[_e - 7] + f(R[_e - 15]) + R[_e - 16] | 0;
    for (var Le = 0; Le < 64; ++Le) {
      var Fe = fe + d(W) + u(W, G, q) + o[Le] + R[Le] | 0, Ee = E(_) + c(_, m, L) | 0;
      fe = q, q = G, G = W, W = F + Fe | 0, F = L, L = m, m = _, _ = Fe + Ee | 0;
    }
    this._a = _ + this._a | 0, this._b = m + this._b | 0, this._c = L + this._c | 0, this._d = F + this._d | 0, this._e = W + this._e | 0, this._f = G + this._f | 0, this._g = q + this._g | 0, this._h = fe + this._h | 0;
  }, l.prototype._hash = function() {
    var S = s.allocUnsafe(32);
    return S.writeInt32BE(this._a, 0), S.writeInt32BE(this._b, 4), S.writeInt32BE(this._c, 8), S.writeInt32BE(this._d, 12), S.writeInt32BE(this._e, 16), S.writeInt32BE(this._f, 20), S.writeInt32BE(this._g, 24), S.writeInt32BE(this._h, 28), S;
  }, sha256$1 = l, sha256$1;
}
var sha224$1, hasRequiredSha224;
function requireSha224() {
  if (hasRequiredSha224)
    return sha224$1;
  hasRequiredSha224 = 1;
  var r = requireInherits_browser(), e = requireSha256(), s = requireHash$1(), o = requireSafeBuffer$1().Buffer, a = new Array(64);
  function l() {
    this.init(), this._w = a, s.call(this, 64, 56);
  }
  return r(l, e), l.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, l.prototype._hash = function() {
    var u = o.allocUnsafe(28);
    return u.writeInt32BE(this._a, 0), u.writeInt32BE(this._b, 4), u.writeInt32BE(this._c, 8), u.writeInt32BE(this._d, 12), u.writeInt32BE(this._e, 16), u.writeInt32BE(this._f, 20), u.writeInt32BE(this._g, 24), u;
  }, sha224$1 = l, sha224$1;
}
var sha512$1, hasRequiredSha512;
function requireSha512() {
  if (hasRequiredSha512)
    return sha512$1;
  hasRequiredSha512 = 1;
  var r = requireInherits_browser(), e = requireHash$1(), s = requireSafeBuffer$1().Buffer, o = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], a = new Array(160);
  function l() {
    this.init(), this._w = a, e.call(this, 128, 112);
  }
  r(l, e), l.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function u(m, L, F) {
    return F ^ m & (L ^ F);
  }
  function c(m, L, F) {
    return m & L | F & (m | L);
  }
  function E(m, L) {
    return (m >>> 28 | L << 4) ^ (L >>> 2 | m << 30) ^ (L >>> 7 | m << 25);
  }
  function d(m, L) {
    return (m >>> 14 | L << 18) ^ (m >>> 18 | L << 14) ^ (L >>> 9 | m << 23);
  }
  function f(m, L) {
    return (m >>> 1 | L << 31) ^ (m >>> 8 | L << 24) ^ m >>> 7;
  }
  function h(m, L) {
    return (m >>> 1 | L << 31) ^ (m >>> 8 | L << 24) ^ (m >>> 7 | L << 25);
  }
  function S(m, L) {
    return (m >>> 19 | L << 13) ^ (L >>> 29 | m << 3) ^ m >>> 6;
  }
  function R(m, L) {
    return (m >>> 19 | L << 13) ^ (L >>> 29 | m << 3) ^ (m >>> 6 | L << 26);
  }
  function _(m, L) {
    return m >>> 0 < L >>> 0 ? 1 : 0;
  }
  return l.prototype._update = function(m) {
    for (var L = this._w, F = this._ah | 0, W = this._bh | 0, G = this._ch | 0, q = this._dh | 0, fe = this._eh | 0, _e = this._fh | 0, Le = this._gh | 0, Fe = this._hh | 0, Ee = this._al | 0, Ge = this._bl | 0, ve = this._cl | 0, te = this._dl | 0, ae = this._el | 0, v = this._fl | 0, Te = this._gl | 0, De = this._hl | 0, be = 0; be < 32; be += 2)
      L[be] = m.readInt32BE(be * 4), L[be + 1] = m.readInt32BE(be * 4 + 4);
    for (; be < 160; be += 2) {
      var ze = L[be - 30], ke = L[be - 15 * 2 + 1], Be = f(ze, ke), Me = h(ke, ze);
      ze = L[be - 2 * 2], ke = L[be - 2 * 2 + 1];
      var me = S(ze, ke), Se = R(ke, ze), xt = L[be - 7 * 2], Ht = L[be - 7 * 2 + 1], Bt = L[be - 16 * 2], ut = L[be - 16 * 2 + 1], Tt = Me + Ht | 0, Yt = Be + xt + _(Tt, Me) | 0;
      Tt = Tt + Se | 0, Yt = Yt + me + _(Tt, Se) | 0, Tt = Tt + ut | 0, Yt = Yt + Bt + _(Tt, ut) | 0, L[be] = Yt, L[be + 1] = Tt;
    }
    for (var an = 0; an < 160; an += 2) {
      Yt = L[an], Tt = L[an + 1];
      var Ct = c(F, W, G), st = c(Ee, Ge, ve), jt = E(F, Ee), lt = E(Ee, F), Zt = d(fe, ae), Et = d(ae, fe), Ke = o[an], $e = o[an + 1], pt = u(fe, _e, Le), Jt = u(ae, v, Te), In = De + Et | 0, Cn = Fe + Zt + _(In, De) | 0;
      In = In + Jt | 0, Cn = Cn + pt + _(In, Jt) | 0, In = In + $e | 0, Cn = Cn + Ke + _(In, $e) | 0, In = In + Tt | 0, Cn = Cn + Yt + _(In, Tt) | 0;
      var It = lt + st | 0, ht = jt + Ct + _(It, lt) | 0;
      Fe = Le, De = Te, Le = _e, Te = v, _e = fe, v = ae, ae = te + In | 0, fe = q + Cn + _(ae, te) | 0, q = G, te = ve, G = W, ve = Ge, W = F, Ge = Ee, Ee = In + It | 0, F = Cn + ht + _(Ee, In) | 0;
    }
    this._al = this._al + Ee | 0, this._bl = this._bl + Ge | 0, this._cl = this._cl + ve | 0, this._dl = this._dl + te | 0, this._el = this._el + ae | 0, this._fl = this._fl + v | 0, this._gl = this._gl + Te | 0, this._hl = this._hl + De | 0, this._ah = this._ah + F + _(this._al, Ee) | 0, this._bh = this._bh + W + _(this._bl, Ge) | 0, this._ch = this._ch + G + _(this._cl, ve) | 0, this._dh = this._dh + q + _(this._dl, te) | 0, this._eh = this._eh + fe + _(this._el, ae) | 0, this._fh = this._fh + _e + _(this._fl, v) | 0, this._gh = this._gh + Le + _(this._gl, Te) | 0, this._hh = this._hh + Fe + _(this._hl, De) | 0;
  }, l.prototype._hash = function() {
    var m = s.allocUnsafe(64);
    function L(F, W, G) {
      m.writeInt32BE(F, G), m.writeInt32BE(W, G + 4);
    }
    return L(this._ah, this._al, 0), L(this._bh, this._bl, 8), L(this._ch, this._cl, 16), L(this._dh, this._dl, 24), L(this._eh, this._el, 32), L(this._fh, this._fl, 40), L(this._gh, this._gl, 48), L(this._hh, this._hl, 56), m;
  }, sha512$1 = l, sha512$1;
}
var sha384$1, hasRequiredSha384;
function requireSha384() {
  if (hasRequiredSha384)
    return sha384$1;
  hasRequiredSha384 = 1;
  var r = requireInherits_browser(), e = requireSha512(), s = requireHash$1(), o = requireSafeBuffer$1().Buffer, a = new Array(160);
  function l() {
    this.init(), this._w = a, s.call(this, 128, 112);
  }
  return r(l, e), l.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, l.prototype._hash = function() {
    var u = o.allocUnsafe(48);
    function c(E, d, f) {
      u.writeInt32BE(E, f), u.writeInt32BE(d, f + 4);
    }
    return c(this._ah, this._al, 0), c(this._bh, this._bl, 8), c(this._ch, this._cl, 16), c(this._dh, this._dl, 24), c(this._eh, this._el, 32), c(this._fh, this._fl, 40), u;
  }, sha384$1 = l, sha384$1;
}
var hasRequiredSha_js;
function requireSha_js() {
  if (hasRequiredSha_js)
    return sha_js.exports;
  hasRequiredSha_js = 1;
  var r = sha_js.exports = function(s) {
    s = s.toLowerCase();
    var o = r[s];
    if (!o)
      throw new Error(s + " is not supported (we accept pull requests)");
    return new o();
  };
  return r.sha = requireSha$1(), r.sha1 = requireSha1(), r.sha224 = requireSha224(), r.sha256 = requireSha256(), r.sha384 = requireSha384(), r.sha512 = requireSha512(), sha_js.exports;
}
var cipherBase, hasRequiredCipherBase;
function requireCipherBase() {
  if (hasRequiredCipherBase)
    return cipherBase;
  hasRequiredCipherBase = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireStreamBrowserify().Transform, s = requireString_decoder().StringDecoder, o = requireInherits_browser();
  function a(E) {
    e.call(this), this.hashMode = typeof E == "string", this.hashMode ? this[E] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  o(a, e);
  var l = typeof Uint8Array < "u", u = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (r.prototype instanceof Uint8Array || r.TYPED_ARRAY_SUPPORT);
  function c(E, d) {
    if (E instanceof r)
      return E;
    if (typeof E == "string")
      return r.from(E, d);
    if (u && ArrayBuffer.isView(E)) {
      if (E.byteLength === 0)
        return r.alloc(0);
      var f = r.from(E.buffer, E.byteOffset, E.byteLength);
      if (f.byteLength === E.byteLength)
        return f;
    }
    if (l && E instanceof Uint8Array || r.isBuffer(E) && E.constructor && typeof E.constructor.isBuffer == "function" && E.constructor.isBuffer(E))
      return r.from(E);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return a.prototype.update = function(E, d, f) {
    var h = c(E, d), S = this._update(h);
    return this.hashMode ? this : (f && (S = this._toString(S, f)), S);
  }, a.prototype.setAutoPadding = function() {
  }, a.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, a.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, a.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, a.prototype._transform = function(E, d, f) {
    var h;
    try {
      this.hashMode ? this._update(E) : this.push(this._update(E));
    } catch (S) {
      h = S;
    } finally {
      f(h);
    }
  }, a.prototype._flush = function(E) {
    var d;
    try {
      this.push(this.__final());
    } catch (f) {
      d = f;
    }
    E(d);
  }, a.prototype._finalOrDigest = function(E) {
    var d = this.__final() || r.alloc(0);
    return E && (d = this._toString(d, E, !0)), d;
  }, a.prototype._toString = function(E, d, f) {
    if (this._decoder || (this._decoder = new s(d), this._encoding = d), this._encoding !== d)
      throw new Error("can’t switch encodings");
    var h = this._decoder.write(E);
    return f && (h += this._decoder.end()), h;
  }, cipherBase = a, cipherBase;
}
var browser$9, hasRequiredBrowser$9;
function requireBrowser$9() {
  if (hasRequiredBrowser$9)
    return browser$9;
  hasRequiredBrowser$9 = 1;
  var r = requireInherits_browser(), e = requireMd5_js(), s = requireRipemd160$1(), o = requireSha_js(), a = requireCipherBase();
  function l(u) {
    a.call(this, "digest"), this._hash = u;
  }
  return r(l, a), l.prototype._update = function(u) {
    this._hash.update(u);
  }, l.prototype._final = function() {
    return this._hash.digest();
  }, browser$9 = function(c) {
    return c = c.toLowerCase(), c === "md5" ? new e() : c === "rmd160" || c === "ripemd160" ? new s() : new l(o(c));
  }, browser$9;
}
var legacy, hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy)
    return legacy;
  hasRequiredLegacy = 1;
  var r = requireInherits_browser(), e = requireSafeBuffer$1().Buffer, s = requireCipherBase(), o = e.alloc(128), a = 64;
  function l(u, c) {
    s.call(this, "digest"), typeof c == "string" && (c = e.from(c)), this._alg = u, this._key = c, c.length > a ? c = u(c) : c.length < a && (c = e.concat([c, o], a));
    for (var E = this._ipad = e.allocUnsafe(a), d = this._opad = e.allocUnsafe(a), f = 0; f < a; f++)
      E[f] = c[f] ^ 54, d[f] = c[f] ^ 92;
    this._hash = [E];
  }
  return r(l, s), l.prototype._update = function(u) {
    this._hash.push(u);
  }, l.prototype._final = function() {
    var u = this._alg(e.concat(this._hash));
    return this._alg(e.concat([this._opad, u]));
  }, legacy = l, legacy;
}
var md5$1, hasRequiredMd5$1;
function requireMd5$1() {
  if (hasRequiredMd5$1)
    return md5$1;
  hasRequiredMd5$1 = 1;
  var r = requireMd5_js();
  return md5$1 = function(e) {
    return new r().update(e).digest();
  }, md5$1;
}
var browser$8, hasRequiredBrowser$8;
function requireBrowser$8() {
  if (hasRequiredBrowser$8)
    return browser$8;
  hasRequiredBrowser$8 = 1;
  var r = requireInherits_browser(), e = requireLegacy(), s = requireCipherBase(), o = requireSafeBuffer$1().Buffer, a = requireMd5$1(), l = requireRipemd160$1(), u = requireSha_js(), c = o.alloc(128);
  function E(d, f) {
    s.call(this, "digest"), typeof f == "string" && (f = o.from(f));
    var h = d === "sha512" || d === "sha384" ? 128 : 64;
    if (this._alg = d, this._key = f, f.length > h) {
      var S = d === "rmd160" ? new l() : u(d);
      f = S.update(f).digest();
    } else
      f.length < h && (f = o.concat([f, c], h));
    for (var R = this._ipad = o.allocUnsafe(h), _ = this._opad = o.allocUnsafe(h), m = 0; m < h; m++)
      R[m] = f[m] ^ 54, _[m] = f[m] ^ 92;
    this._hash = d === "rmd160" ? new l() : u(d), this._hash.update(R);
  }
  return r(E, s), E.prototype._update = function(d) {
    this._hash.update(d);
  }, E.prototype._final = function() {
    var d = this._hash.digest(), f = this._alg === "rmd160" ? new l() : u(this._alg);
    return f.update(this._opad).update(d).digest();
  }, browser$8 = function(f, h) {
    return f = f.toLowerCase(), f === "rmd160" || f === "ripemd160" ? new E("rmd160", h) : f === "md5" ? new e(a, h) : new E(f, h);
  }, browser$8;
}
const sha224WithRSAEncryption = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, sha256WithRSAEncryption = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, sha384WithRSAEncryption = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, sha512WithRSAEncryption = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, sha256 = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, sha224 = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, sha384 = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, sha512 = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, DSA = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, ripemd160WithRSA = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, md5WithRSAEncryption = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, require$$6 = {
  sha224WithRSAEncryption,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256,
  sha224,
  sha384,
  sha512,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var algos, hasRequiredAlgos;
function requireAlgos() {
  return hasRequiredAlgos || (hasRequiredAlgos = 1, algos = require$$6), algos;
}
var browser$7 = {}, precondition, hasRequiredPrecondition;
function requirePrecondition() {
  if (hasRequiredPrecondition)
    return precondition;
  hasRequiredPrecondition = 1;
  var r = Math.pow(2, 30) - 1;
  return precondition = function(e, s) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof s != "number")
      throw new TypeError("Key length not a number");
    if (s < 0 || s > r || s !== s)
      throw new TypeError("Bad key length");
  }, precondition;
}
var defaultEncoding_1, hasRequiredDefaultEncoding;
function requireDefaultEncoding() {
  if (hasRequiredDefaultEncoding)
    return defaultEncoding_1;
  hasRequiredDefaultEncoding = 1;
  var r;
  if (commonjsGlobal.process && commonjsGlobal.process.browser)
    r = "utf-8";
  else if (commonjsGlobal.process && commonjsGlobal.process.version) {
    var e = parseInt(api$1.version.split(".")[0].slice(1), 10);
    r = e >= 6 ? "utf-8" : "binary";
  } else
    r = "utf-8";
  return defaultEncoding_1 = r, defaultEncoding_1;
}
var makeHash, hasRequiredMakeHash;
function requireMakeHash() {
  if (hasRequiredMakeHash)
    return makeHash;
  hasRequiredMakeHash = 1;
  var r = 4, e = new buffer$1.Buffer(r);
  e.fill(0);
  var s = 8, o = 16;
  function a(l) {
    if (l.length % r !== 0) {
      var u = l.length + (r - l.length % r);
      l = buffer$1.Buffer.concat([l, e], u);
    }
    for (var c = new Array(l.length >>> 2), E = 0, d = 0; E < l.length; E += r, d++)
      c[d] = l.readInt32LE(E);
    return c;
  }
  return makeHash = function(u, c) {
    var E = c(a(u), u.length * s);
    u = new buffer$1.Buffer(o);
    for (var d = 0; d < E.length; d++)
      u.writeInt32LE(E[d], d << 2, !0);
    return u;
  }, makeHash;
}
var md5, hasRequiredMd5;
function requireMd5() {
  if (hasRequiredMd5)
    return md5;
  hasRequiredMd5 = 1;
  var r = requireMakeHash();
  function e(d, f) {
    d[f >> 5] |= 128 << f % 32, d[(f + 64 >>> 9 << 4) + 14] = f;
    for (var h = 1732584193, S = -271733879, R = -1732584194, _ = 271733878, m = 0; m < d.length; m += 16) {
      var L = h, F = S, W = R, G = _;
      h = o(h, S, R, _, d[m + 0], 7, -680876936), _ = o(_, h, S, R, d[m + 1], 12, -389564586), R = o(R, _, h, S, d[m + 2], 17, 606105819), S = o(S, R, _, h, d[m + 3], 22, -1044525330), h = o(h, S, R, _, d[m + 4], 7, -176418897), _ = o(_, h, S, R, d[m + 5], 12, 1200080426), R = o(R, _, h, S, d[m + 6], 17, -1473231341), S = o(S, R, _, h, d[m + 7], 22, -45705983), h = o(h, S, R, _, d[m + 8], 7, 1770035416), _ = o(_, h, S, R, d[m + 9], 12, -1958414417), R = o(R, _, h, S, d[m + 10], 17, -42063), S = o(S, R, _, h, d[m + 11], 22, -1990404162), h = o(h, S, R, _, d[m + 12], 7, 1804603682), _ = o(_, h, S, R, d[m + 13], 12, -40341101), R = o(R, _, h, S, d[m + 14], 17, -1502002290), S = o(S, R, _, h, d[m + 15], 22, 1236535329), h = a(h, S, R, _, d[m + 1], 5, -165796510), _ = a(_, h, S, R, d[m + 6], 9, -1069501632), R = a(R, _, h, S, d[m + 11], 14, 643717713), S = a(S, R, _, h, d[m + 0], 20, -373897302), h = a(h, S, R, _, d[m + 5], 5, -701558691), _ = a(_, h, S, R, d[m + 10], 9, 38016083), R = a(R, _, h, S, d[m + 15], 14, -660478335), S = a(S, R, _, h, d[m + 4], 20, -405537848), h = a(h, S, R, _, d[m + 9], 5, 568446438), _ = a(_, h, S, R, d[m + 14], 9, -1019803690), R = a(R, _, h, S, d[m + 3], 14, -187363961), S = a(S, R, _, h, d[m + 8], 20, 1163531501), h = a(h, S, R, _, d[m + 13], 5, -1444681467), _ = a(_, h, S, R, d[m + 2], 9, -51403784), R = a(R, _, h, S, d[m + 7], 14, 1735328473), S = a(S, R, _, h, d[m + 12], 20, -1926607734), h = l(h, S, R, _, d[m + 5], 4, -378558), _ = l(_, h, S, R, d[m + 8], 11, -2022574463), R = l(R, _, h, S, d[m + 11], 16, 1839030562), S = l(S, R, _, h, d[m + 14], 23, -35309556), h = l(h, S, R, _, d[m + 1], 4, -1530992060), _ = l(_, h, S, R, d[m + 4], 11, 1272893353), R = l(R, _, h, S, d[m + 7], 16, -155497632), S = l(S, R, _, h, d[m + 10], 23, -1094730640), h = l(h, S, R, _, d[m + 13], 4, 681279174), _ = l(_, h, S, R, d[m + 0], 11, -358537222), R = l(R, _, h, S, d[m + 3], 16, -722521979), S = l(S, R, _, h, d[m + 6], 23, 76029189), h = l(h, S, R, _, d[m + 9], 4, -640364487), _ = l(_, h, S, R, d[m + 12], 11, -421815835), R = l(R, _, h, S, d[m + 15], 16, 530742520), S = l(S, R, _, h, d[m + 2], 23, -995338651), h = u(h, S, R, _, d[m + 0], 6, -198630844), _ = u(_, h, S, R, d[m + 7], 10, 1126891415), R = u(R, _, h, S, d[m + 14], 15, -1416354905), S = u(S, R, _, h, d[m + 5], 21, -57434055), h = u(h, S, R, _, d[m + 12], 6, 1700485571), _ = u(_, h, S, R, d[m + 3], 10, -1894986606), R = u(R, _, h, S, d[m + 10], 15, -1051523), S = u(S, R, _, h, d[m + 1], 21, -2054922799), h = u(h, S, R, _, d[m + 8], 6, 1873313359), _ = u(_, h, S, R, d[m + 15], 10, -30611744), R = u(R, _, h, S, d[m + 6], 15, -1560198380), S = u(S, R, _, h, d[m + 13], 21, 1309151649), h = u(h, S, R, _, d[m + 4], 6, -145523070), _ = u(_, h, S, R, d[m + 11], 10, -1120210379), R = u(R, _, h, S, d[m + 2], 15, 718787259), S = u(S, R, _, h, d[m + 9], 21, -343485551), h = c(h, L), S = c(S, F), R = c(R, W), _ = c(_, G);
    }
    return [h, S, R, _];
  }
  function s(d, f, h, S, R, _) {
    return c(E(c(c(f, d), c(S, _)), R), h);
  }
  function o(d, f, h, S, R, _, m) {
    return s(f & h | ~f & S, d, f, R, _, m);
  }
  function a(d, f, h, S, R, _, m) {
    return s(f & S | h & ~S, d, f, R, _, m);
  }
  function l(d, f, h, S, R, _, m) {
    return s(f ^ h ^ S, d, f, R, _, m);
  }
  function u(d, f, h, S, R, _, m) {
    return s(h ^ (f | ~S), d, f, R, _, m);
  }
  function c(d, f) {
    var h = (d & 65535) + (f & 65535), S = (d >> 16) + (f >> 16) + (h >> 16);
    return S << 16 | h & 65535;
  }
  function E(d, f) {
    return d << f | d >>> 32 - f;
  }
  return md5 = function(f) {
    return r(f, e);
  }, md5;
}
var hashBase, hasRequiredHashBase;
function requireHashBase() {
  if (hasRequiredHashBase)
    return hashBase;
  hasRequiredHashBase = 1;
  var r = requireStreamBrowserify().Transform, e = requireInherits_browser();
  function s(o) {
    r.call(this), this._block = new buffer$1.Buffer(o), this._blockSize = o, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return e(s, r), s.prototype._transform = function(o, a, l) {
    var u = null;
    try {
      a !== "buffer" && (o = new buffer$1.Buffer(o, a)), this.update(o);
    } catch (c) {
      u = c;
    }
    l(u);
  }, s.prototype._flush = function(o) {
    var a = null;
    try {
      this.push(this._digest());
    } catch (l) {
      a = l;
    }
    o(a);
  }, s.prototype.update = function(o, a) {
    if (!buffer$1.Buffer.isBuffer(o) && typeof o != "string")
      throw new TypeError("Data must be a string or a buffer");
    if (this._finalized)
      throw new Error("Digest already called");
    buffer$1.Buffer.isBuffer(o) || (o = new buffer$1.Buffer(o, a || "binary"));
    for (var l = this._block, u = 0; this._blockOffset + o.length - u >= this._blockSize; ) {
      for (var c = this._blockOffset; c < this._blockSize; )
        l[c++] = o[u++];
      this._update(), this._blockOffset = 0;
    }
    for (; u < o.length; )
      l[this._blockOffset++] = o[u++];
    for (var E = 0, d = o.length * 8; d > 0; ++E)
      this._length[E] += d, d = this._length[E] / 4294967296 | 0, d > 0 && (this._length[E] -= 4294967296 * d);
    return this;
  }, s.prototype._update = function(o) {
    throw new Error("_update is not implemented");
  }, s.prototype.digest = function(o) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var a = this._digest();
    return o !== void 0 && (a = a.toString(o)), a;
  }, s.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, hashBase = s, hashBase;
}
var ripemd160, hasRequiredRipemd160;
function requireRipemd160() {
  if (hasRequiredRipemd160)
    return ripemd160;
  hasRequiredRipemd160 = 1;
  var r = requireInherits_browser(), e = requireHashBase();
  function s() {
    e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  r(s, e), s.prototype._update = function() {
    for (var d = new Array(16), f = 0; f < 16; ++f)
      d[f] = this._block.readInt32LE(f * 4);
    var h = this._a, S = this._b, R = this._c, _ = this._d, m = this._e;
    h = a(h, S, R, _, m, d[0], 0, 11), R = o(R, 10), m = a(m, h, S, R, _, d[1], 0, 14), S = o(S, 10), _ = a(_, m, h, S, R, d[2], 0, 15), h = o(h, 10), R = a(R, _, m, h, S, d[3], 0, 12), m = o(m, 10), S = a(S, R, _, m, h, d[4], 0, 5), _ = o(_, 10), h = a(h, S, R, _, m, d[5], 0, 8), R = o(R, 10), m = a(m, h, S, R, _, d[6], 0, 7), S = o(S, 10), _ = a(_, m, h, S, R, d[7], 0, 9), h = o(h, 10), R = a(R, _, m, h, S, d[8], 0, 11), m = o(m, 10), S = a(S, R, _, m, h, d[9], 0, 13), _ = o(_, 10), h = a(h, S, R, _, m, d[10], 0, 14), R = o(R, 10), m = a(m, h, S, R, _, d[11], 0, 15), S = o(S, 10), _ = a(_, m, h, S, R, d[12], 0, 6), h = o(h, 10), R = a(R, _, m, h, S, d[13], 0, 7), m = o(m, 10), S = a(S, R, _, m, h, d[14], 0, 9), _ = o(_, 10), h = a(h, S, R, _, m, d[15], 0, 8), R = o(R, 10), m = l(m, h, S, R, _, d[7], 1518500249, 7), S = o(S, 10), _ = l(_, m, h, S, R, d[4], 1518500249, 6), h = o(h, 10), R = l(R, _, m, h, S, d[13], 1518500249, 8), m = o(m, 10), S = l(S, R, _, m, h, d[1], 1518500249, 13), _ = o(_, 10), h = l(h, S, R, _, m, d[10], 1518500249, 11), R = o(R, 10), m = l(m, h, S, R, _, d[6], 1518500249, 9), S = o(S, 10), _ = l(_, m, h, S, R, d[15], 1518500249, 7), h = o(h, 10), R = l(R, _, m, h, S, d[3], 1518500249, 15), m = o(m, 10), S = l(S, R, _, m, h, d[12], 1518500249, 7), _ = o(_, 10), h = l(h, S, R, _, m, d[0], 1518500249, 12), R = o(R, 10), m = l(m, h, S, R, _, d[9], 1518500249, 15), S = o(S, 10), _ = l(_, m, h, S, R, d[5], 1518500249, 9), h = o(h, 10), R = l(R, _, m, h, S, d[2], 1518500249, 11), m = o(m, 10), S = l(S, R, _, m, h, d[14], 1518500249, 7), _ = o(_, 10), h = l(h, S, R, _, m, d[11], 1518500249, 13), R = o(R, 10), m = l(m, h, S, R, _, d[8], 1518500249, 12), S = o(S, 10), _ = u(_, m, h, S, R, d[3], 1859775393, 11), h = o(h, 10), R = u(R, _, m, h, S, d[10], 1859775393, 13), m = o(m, 10), S = u(S, R, _, m, h, d[14], 1859775393, 6), _ = o(_, 10), h = u(h, S, R, _, m, d[4], 1859775393, 7), R = o(R, 10), m = u(m, h, S, R, _, d[9], 1859775393, 14), S = o(S, 10), _ = u(_, m, h, S, R, d[15], 1859775393, 9), h = o(h, 10), R = u(R, _, m, h, S, d[8], 1859775393, 13), m = o(m, 10), S = u(S, R, _, m, h, d[1], 1859775393, 15), _ = o(_, 10), h = u(h, S, R, _, m, d[2], 1859775393, 14), R = o(R, 10), m = u(m, h, S, R, _, d[7], 1859775393, 8), S = o(S, 10), _ = u(_, m, h, S, R, d[0], 1859775393, 13), h = o(h, 10), R = u(R, _, m, h, S, d[6], 1859775393, 6), m = o(m, 10), S = u(S, R, _, m, h, d[13], 1859775393, 5), _ = o(_, 10), h = u(h, S, R, _, m, d[11], 1859775393, 12), R = o(R, 10), m = u(m, h, S, R, _, d[5], 1859775393, 7), S = o(S, 10), _ = u(_, m, h, S, R, d[12], 1859775393, 5), h = o(h, 10), R = c(R, _, m, h, S, d[1], 2400959708, 11), m = o(m, 10), S = c(S, R, _, m, h, d[9], 2400959708, 12), _ = o(_, 10), h = c(h, S, R, _, m, d[11], 2400959708, 14), R = o(R, 10), m = c(m, h, S, R, _, d[10], 2400959708, 15), S = o(S, 10), _ = c(_, m, h, S, R, d[0], 2400959708, 14), h = o(h, 10), R = c(R, _, m, h, S, d[8], 2400959708, 15), m = o(m, 10), S = c(S, R, _, m, h, d[12], 2400959708, 9), _ = o(_, 10), h = c(h, S, R, _, m, d[4], 2400959708, 8), R = o(R, 10), m = c(m, h, S, R, _, d[13], 2400959708, 9), S = o(S, 10), _ = c(_, m, h, S, R, d[3], 2400959708, 14), h = o(h, 10), R = c(R, _, m, h, S, d[7], 2400959708, 5), m = o(m, 10), S = c(S, R, _, m, h, d[15], 2400959708, 6), _ = o(_, 10), h = c(h, S, R, _, m, d[14], 2400959708, 8), R = o(R, 10), m = c(m, h, S, R, _, d[5], 2400959708, 6), S = o(S, 10), _ = c(_, m, h, S, R, d[6], 2400959708, 5), h = o(h, 10), R = c(R, _, m, h, S, d[2], 2400959708, 12), m = o(m, 10), S = E(S, R, _, m, h, d[4], 2840853838, 9), _ = o(_, 10), h = E(h, S, R, _, m, d[0], 2840853838, 15), R = o(R, 10), m = E(m, h, S, R, _, d[5], 2840853838, 5), S = o(S, 10), _ = E(_, m, h, S, R, d[9], 2840853838, 11), h = o(h, 10), R = E(R, _, m, h, S, d[7], 2840853838, 6), m = o(m, 10), S = E(S, R, _, m, h, d[12], 2840853838, 8), _ = o(_, 10), h = E(h, S, R, _, m, d[2], 2840853838, 13), R = o(R, 10), m = E(m, h, S, R, _, d[10], 2840853838, 12), S = o(S, 10), _ = E(_, m, h, S, R, d[14], 2840853838, 5), h = o(h, 10), R = E(R, _, m, h, S, d[1], 2840853838, 12), m = o(m, 10), S = E(S, R, _, m, h, d[3], 2840853838, 13), _ = o(_, 10), h = E(h, S, R, _, m, d[8], 2840853838, 14), R = o(R, 10), m = E(m, h, S, R, _, d[11], 2840853838, 11), S = o(S, 10), _ = E(_, m, h, S, R, d[6], 2840853838, 8), h = o(h, 10), R = E(R, _, m, h, S, d[15], 2840853838, 5), m = o(m, 10), S = E(S, R, _, m, h, d[13], 2840853838, 6), _ = o(_, 10);
    var L = this._a, F = this._b, W = this._c, G = this._d, q = this._e;
    L = E(L, F, W, G, q, d[5], 1352829926, 8), W = o(W, 10), q = E(q, L, F, W, G, d[14], 1352829926, 9), F = o(F, 10), G = E(G, q, L, F, W, d[7], 1352829926, 9), L = o(L, 10), W = E(W, G, q, L, F, d[0], 1352829926, 11), q = o(q, 10), F = E(F, W, G, q, L, d[9], 1352829926, 13), G = o(G, 10), L = E(L, F, W, G, q, d[2], 1352829926, 15), W = o(W, 10), q = E(q, L, F, W, G, d[11], 1352829926, 15), F = o(F, 10), G = E(G, q, L, F, W, d[4], 1352829926, 5), L = o(L, 10), W = E(W, G, q, L, F, d[13], 1352829926, 7), q = o(q, 10), F = E(F, W, G, q, L, d[6], 1352829926, 7), G = o(G, 10), L = E(L, F, W, G, q, d[15], 1352829926, 8), W = o(W, 10), q = E(q, L, F, W, G, d[8], 1352829926, 11), F = o(F, 10), G = E(G, q, L, F, W, d[1], 1352829926, 14), L = o(L, 10), W = E(W, G, q, L, F, d[10], 1352829926, 14), q = o(q, 10), F = E(F, W, G, q, L, d[3], 1352829926, 12), G = o(G, 10), L = E(L, F, W, G, q, d[12], 1352829926, 6), W = o(W, 10), q = c(q, L, F, W, G, d[6], 1548603684, 9), F = o(F, 10), G = c(G, q, L, F, W, d[11], 1548603684, 13), L = o(L, 10), W = c(W, G, q, L, F, d[3], 1548603684, 15), q = o(q, 10), F = c(F, W, G, q, L, d[7], 1548603684, 7), G = o(G, 10), L = c(L, F, W, G, q, d[0], 1548603684, 12), W = o(W, 10), q = c(q, L, F, W, G, d[13], 1548603684, 8), F = o(F, 10), G = c(G, q, L, F, W, d[5], 1548603684, 9), L = o(L, 10), W = c(W, G, q, L, F, d[10], 1548603684, 11), q = o(q, 10), F = c(F, W, G, q, L, d[14], 1548603684, 7), G = o(G, 10), L = c(L, F, W, G, q, d[15], 1548603684, 7), W = o(W, 10), q = c(q, L, F, W, G, d[8], 1548603684, 12), F = o(F, 10), G = c(G, q, L, F, W, d[12], 1548603684, 7), L = o(L, 10), W = c(W, G, q, L, F, d[4], 1548603684, 6), q = o(q, 10), F = c(F, W, G, q, L, d[9], 1548603684, 15), G = o(G, 10), L = c(L, F, W, G, q, d[1], 1548603684, 13), W = o(W, 10), q = c(q, L, F, W, G, d[2], 1548603684, 11), F = o(F, 10), G = u(G, q, L, F, W, d[15], 1836072691, 9), L = o(L, 10), W = u(W, G, q, L, F, d[5], 1836072691, 7), q = o(q, 10), F = u(F, W, G, q, L, d[1], 1836072691, 15), G = o(G, 10), L = u(L, F, W, G, q, d[3], 1836072691, 11), W = o(W, 10), q = u(q, L, F, W, G, d[7], 1836072691, 8), F = o(F, 10), G = u(G, q, L, F, W, d[14], 1836072691, 6), L = o(L, 10), W = u(W, G, q, L, F, d[6], 1836072691, 6), q = o(q, 10), F = u(F, W, G, q, L, d[9], 1836072691, 14), G = o(G, 10), L = u(L, F, W, G, q, d[11], 1836072691, 12), W = o(W, 10), q = u(q, L, F, W, G, d[8], 1836072691, 13), F = o(F, 10), G = u(G, q, L, F, W, d[12], 1836072691, 5), L = o(L, 10), W = u(W, G, q, L, F, d[2], 1836072691, 14), q = o(q, 10), F = u(F, W, G, q, L, d[10], 1836072691, 13), G = o(G, 10), L = u(L, F, W, G, q, d[0], 1836072691, 13), W = o(W, 10), q = u(q, L, F, W, G, d[4], 1836072691, 7), F = o(F, 10), G = u(G, q, L, F, W, d[13], 1836072691, 5), L = o(L, 10), W = l(W, G, q, L, F, d[8], 2053994217, 15), q = o(q, 10), F = l(F, W, G, q, L, d[6], 2053994217, 5), G = o(G, 10), L = l(L, F, W, G, q, d[4], 2053994217, 8), W = o(W, 10), q = l(q, L, F, W, G, d[1], 2053994217, 11), F = o(F, 10), G = l(G, q, L, F, W, d[3], 2053994217, 14), L = o(L, 10), W = l(W, G, q, L, F, d[11], 2053994217, 14), q = o(q, 10), F = l(F, W, G, q, L, d[15], 2053994217, 6), G = o(G, 10), L = l(L, F, W, G, q, d[0], 2053994217, 14), W = o(W, 10), q = l(q, L, F, W, G, d[5], 2053994217, 6), F = o(F, 10), G = l(G, q, L, F, W, d[12], 2053994217, 9), L = o(L, 10), W = l(W, G, q, L, F, d[2], 2053994217, 12), q = o(q, 10), F = l(F, W, G, q, L, d[13], 2053994217, 9), G = o(G, 10), L = l(L, F, W, G, q, d[9], 2053994217, 12), W = o(W, 10), q = l(q, L, F, W, G, d[7], 2053994217, 5), F = o(F, 10), G = l(G, q, L, F, W, d[10], 2053994217, 15), L = o(L, 10), W = l(W, G, q, L, F, d[14], 2053994217, 8), q = o(q, 10), F = a(F, W, G, q, L, d[12], 0, 8), G = o(G, 10), L = a(L, F, W, G, q, d[15], 0, 5), W = o(W, 10), q = a(q, L, F, W, G, d[10], 0, 12), F = o(F, 10), G = a(G, q, L, F, W, d[4], 0, 9), L = o(L, 10), W = a(W, G, q, L, F, d[1], 0, 12), q = o(q, 10), F = a(F, W, G, q, L, d[5], 0, 5), G = o(G, 10), L = a(L, F, W, G, q, d[8], 0, 14), W = o(W, 10), q = a(q, L, F, W, G, d[7], 0, 6), F = o(F, 10), G = a(G, q, L, F, W, d[6], 0, 8), L = o(L, 10), W = a(W, G, q, L, F, d[2], 0, 13), q = o(q, 10), F = a(F, W, G, q, L, d[13], 0, 6), G = o(G, 10), L = a(L, F, W, G, q, d[14], 0, 5), W = o(W, 10), q = a(q, L, F, W, G, d[0], 0, 15), F = o(F, 10), G = a(G, q, L, F, W, d[3], 0, 13), L = o(L, 10), W = a(W, G, q, L, F, d[9], 0, 11), q = o(q, 10), F = a(F, W, G, q, L, d[11], 0, 11), G = o(G, 10);
    var fe = this._b + R + G | 0;
    this._b = this._c + _ + q | 0, this._c = this._d + m + L | 0, this._d = this._e + h + F | 0, this._e = this._a + S + W | 0, this._a = fe;
  }, s.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var d = new buffer$1.Buffer(20);
    return d.writeInt32LE(this._a, 0), d.writeInt32LE(this._b, 4), d.writeInt32LE(this._c, 8), d.writeInt32LE(this._d, 12), d.writeInt32LE(this._e, 16), d;
  };
  function o(d, f) {
    return d << f | d >>> 32 - f;
  }
  function a(d, f, h, S, R, _, m, L) {
    return o(d + (f ^ h ^ S) + _ + m | 0, L) + R | 0;
  }
  function l(d, f, h, S, R, _, m, L) {
    return o(d + (f & h | ~f & S) + _ + m | 0, L) + R | 0;
  }
  function u(d, f, h, S, R, _, m, L) {
    return o(d + ((f | ~h) ^ S) + _ + m | 0, L) + R | 0;
  }
  function c(d, f, h, S, R, _, m, L) {
    return o(d + (f & S | h & ~S) + _ + m | 0, L) + R | 0;
  }
  function E(d, f, h, S, R, _, m, L) {
    return o(d + (f ^ (h | ~S)) + _ + m | 0, L) + R | 0;
  }
  return ripemd160 = s, ripemd160;
}
var isarray$1, hasRequiredIsarray$1;
function requireIsarray$1() {
  if (hasRequiredIsarray$1)
    return isarray$1;
  hasRequiredIsarray$1 = 1;
  var r = {}.toString;
  return isarray$1 = Array.isArray || function(e) {
    return r.call(e) == "[object Array]";
  }, isarray$1;
}
var typedArrayBuffer, hasRequiredTypedArrayBuffer;
function requireTypedArrayBuffer() {
  if (hasRequiredTypedArrayBuffer)
    return typedArrayBuffer;
  hasRequiredTypedArrayBuffer = 1;
  var r = requireType(), e = requireCallBound(), s = e("TypedArray.prototype.buffer", !0), o = requireIsTypedArray();
  return typedArrayBuffer = s || function(l) {
    if (!o(l))
      throw new r("Not a Typed Array");
    return l.buffer;
  }, typedArrayBuffer;
}
var toBuffer, hasRequiredToBuffer$1;
function requireToBuffer$1() {
  if (hasRequiredToBuffer$1)
    return toBuffer;
  hasRequiredToBuffer$1 = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireIsarray$1(), s = requireTypedArrayBuffer(), o = ArrayBuffer.isView || function(E) {
    try {
      return s(E), !0;
    } catch {
      return !1;
    }
  }, a = typeof Uint8Array < "u", l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", u = l && (r.prototype instanceof Uint8Array || r.TYPED_ARRAY_SUPPORT);
  return toBuffer = function(E, d) {
    if (E instanceof r)
      return E;
    if (typeof E == "string")
      return r.from(E, d);
    if (l && o(E)) {
      if (E.byteLength === 0)
        return r.alloc(0);
      if (u) {
        var f = r.from(E.buffer, E.byteOffset, E.byteLength);
        if (f.byteLength === E.byteLength)
          return f;
      }
      var h = E instanceof Uint8Array ? E : new Uint8Array(E.buffer, E.byteOffset, E.byteLength), S = r.from(h);
      if (S.length === E.byteLength)
        return S;
    }
    if (a && E instanceof Uint8Array)
      return r.from(E);
    var R = e(E);
    if (R)
      for (var _ = 0; _ < E.length; _ += 1) {
        var m = E[_];
        if (typeof m != "number" || m < 0 || m > 255 || ~~m !== m)
          throw new RangeError("Array items must be numbers in the range 0-255.");
      }
    if (R || r.isBuffer(E) && E.constructor && typeof E.constructor.isBuffer == "function" && E.constructor.isBuffer(E))
      return r.from(E);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
  }, toBuffer;
}
var toBuffer_1, hasRequiredToBuffer;
function requireToBuffer() {
  if (hasRequiredToBuffer)
    return toBuffer_1;
  hasRequiredToBuffer = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireToBuffer$1(), s = typeof Uint8Array < "u", o = s && typeof ArrayBuffer < "u", a = o && ArrayBuffer.isView;
  return toBuffer_1 = function(l, u, c) {
    if (typeof l == "string" || r.isBuffer(l) || s && l instanceof Uint8Array || a && a(l))
      return e(l, u);
    throw new TypeError(c + " must be a string, a Buffer, a Uint8Array, or a DataView");
  }, toBuffer_1;
}
var syncBrowser, hasRequiredSyncBrowser;
function requireSyncBrowser() {
  if (hasRequiredSyncBrowser)
    return syncBrowser;
  hasRequiredSyncBrowser = 1;
  var r = requireMd5(), e = requireRipemd160(), s = requireSha_js(), o = requireSafeBuffer$1().Buffer, a = requirePrecondition(), l = requireDefaultEncoding(), u = requireToBuffer(), c = o.alloc(128), E = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    "sha512-256": 32,
    ripemd160: 20,
    rmd160: 20
  }, d = {
    __proto__: null,
    "sha-1": "sha1",
    "sha-224": "sha224",
    "sha-256": "sha256",
    "sha-384": "sha384",
    "sha-512": "sha512",
    "ripemd-160": "ripemd160"
  };
  function f(_) {
    return new e().update(_).digest();
  }
  function h(_) {
    function m(L) {
      return s(_).update(L).digest();
    }
    return _ === "rmd160" || _ === "ripemd160" ? f : _ === "md5" ? r : m;
  }
  function S(_, m, L) {
    var F = h(_), W = _ === "sha512" || _ === "sha384" ? 128 : 64;
    m.length > W ? m = F(m) : m.length < W && (m = o.concat([m, c], W));
    for (var G = o.allocUnsafe(W + E[_]), q = o.allocUnsafe(W + E[_]), fe = 0; fe < W; fe++)
      G[fe] = m[fe] ^ 54, q[fe] = m[fe] ^ 92;
    var _e = o.allocUnsafe(W + L + 4);
    G.copy(_e, 0, 0, W), this.ipad1 = _e, this.ipad2 = G, this.opad = q, this.alg = _, this.blocksize = W, this.hash = F, this.size = E[_];
  }
  S.prototype.run = function(_, m) {
    _.copy(m, this.blocksize);
    var L = this.hash(m);
    return L.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function R(_, m, L, F, W) {
    a(L, F), _ = u(_, l, "Password"), m = u(m, l, "Salt");
    var G = (W || "sha1").toLowerCase(), q = d[G] || G, fe = E[q];
    if (typeof fe != "number" || !fe)
      throw new TypeError("Digest algorithm not supported: " + W);
    var _e = new S(q, _, m.length), Le = o.allocUnsafe(F), Fe = o.allocUnsafe(m.length + 4);
    m.copy(Fe, 0, 0, m.length);
    for (var Ee = 0, Ge = fe, ve = Math.ceil(F / Ge), te = 1; te <= ve; te++) {
      Fe.writeUInt32BE(te, m.length);
      for (var ae = _e.run(Fe, _e.ipad1), v = ae, Te = 1; Te < L; Te++) {
        v = _e.run(v, _e.ipad2);
        for (var De = 0; De < Ge; De++)
          ae[De] ^= v[De];
      }
      ae.copy(Le, Ee), Ee += Ge;
    }
    return Le;
  }
  return syncBrowser = R, syncBrowser;
}
var async, hasRequiredAsync;
function requireAsync() {
  if (hasRequiredAsync)
    return async;
  hasRequiredAsync = 1;
  var r = requireSafeBuffer$1().Buffer, e = requirePrecondition(), s = requireDefaultEncoding(), o = requireSyncBrowser(), a = requireToBuffer(), l, u = commonjsGlobal.crypto && commonjsGlobal.crypto.subtle, c = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, E = [], d;
  function f() {
    return d || (commonjsGlobal.process && commonjsGlobal.process.nextTick ? d = commonjsGlobal.process.nextTick : commonjsGlobal.queueMicrotask ? d = commonjsGlobal.queueMicrotask : commonjsGlobal.setImmediate ? d = commonjsGlobal.setImmediate : d = commonjsGlobal.setTimeout, d);
  }
  function h(_, m, L, F, W) {
    return u.importKey("raw", _, { name: "PBKDF2" }, !1, ["deriveBits"]).then(function(G) {
      return u.deriveBits({
        name: "PBKDF2",
        salt: m,
        iterations: L,
        hash: {
          name: W
        }
      }, G, F << 3);
    }).then(function(G) {
      return r.from(G);
    });
  }
  function S(_) {
    if (commonjsGlobal.process && !commonjsGlobal.process.browser || !u || !u.importKey || !u.deriveBits)
      return Promise.resolve(!1);
    if (E[_] !== void 0)
      return E[_];
    l = l || r.alloc(8);
    var m = h(l, l, 10, 128, _).then(
      function() {
        return !0;
      },
      function() {
        return !1;
      }
    );
    return E[_] = m, m;
  }
  function R(_, m) {
    _.then(function(L) {
      f()(function() {
        m(null, L);
      });
    }, function(L) {
      f()(function() {
        m(L);
      });
    });
  }
  return async = function(_, m, L, F, W, G) {
    typeof W == "function" && (G = W, W = void 0), W = W || "sha1";
    var q = c[W.toLowerCase()];
    if (!q || typeof commonjsGlobal.Promise != "function") {
      f()(function() {
        var fe;
        try {
          fe = o(_, m, L, F, W);
        } catch (_e) {
          G(_e);
          return;
        }
        G(null, fe);
      });
      return;
    }
    if (e(L, F), _ = a(_, s, "Password"), m = a(m, s, "Salt"), typeof G != "function")
      throw new Error("No callback provided to pbkdf2");
    R(S(q).then(function(fe) {
      return fe ? h(_, m, L, F, q) : o(_, m, L, F, W);
    }), G);
  }, async;
}
var hasRequiredBrowser$7;
function requireBrowser$7() {
  return hasRequiredBrowser$7 || (hasRequiredBrowser$7 = 1, browser$7.pbkdf2 = requireAsync(), browser$7.pbkdf2Sync = requireSyncBrowser()), browser$7;
}
var browser$6 = {}, des$1 = {}, utils$3 = {}, hasRequiredUtils$3;
function requireUtils$3() {
  if (hasRequiredUtils$3)
    return utils$3;
  hasRequiredUtils$3 = 1, utils$3.readUInt32BE = function(a, l) {
    var u = a[0 + l] << 24 | a[1 + l] << 16 | a[2 + l] << 8 | a[3 + l];
    return u >>> 0;
  }, utils$3.writeUInt32BE = function(a, l, u) {
    a[0 + u] = l >>> 24, a[1 + u] = l >>> 16 & 255, a[2 + u] = l >>> 8 & 255, a[3 + u] = l & 255;
  }, utils$3.ip = function(a, l, u, c) {
    for (var E = 0, d = 0, f = 6; f >= 0; f -= 2) {
      for (var h = 0; h <= 24; h += 8)
        E <<= 1, E |= l >>> h + f & 1;
      for (var h = 0; h <= 24; h += 8)
        E <<= 1, E |= a >>> h + f & 1;
    }
    for (var f = 6; f >= 0; f -= 2) {
      for (var h = 1; h <= 25; h += 8)
        d <<= 1, d |= l >>> h + f & 1;
      for (var h = 1; h <= 25; h += 8)
        d <<= 1, d |= a >>> h + f & 1;
    }
    u[c + 0] = E >>> 0, u[c + 1] = d >>> 0;
  }, utils$3.rip = function(a, l, u, c) {
    for (var E = 0, d = 0, f = 0; f < 4; f++)
      for (var h = 24; h >= 0; h -= 8)
        E <<= 1, E |= l >>> h + f & 1, E <<= 1, E |= a >>> h + f & 1;
    for (var f = 4; f < 8; f++)
      for (var h = 24; h >= 0; h -= 8)
        d <<= 1, d |= l >>> h + f & 1, d <<= 1, d |= a >>> h + f & 1;
    u[c + 0] = E >>> 0, u[c + 1] = d >>> 0;
  }, utils$3.pc1 = function(a, l, u, c) {
    for (var E = 0, d = 0, f = 7; f >= 5; f--) {
      for (var h = 0; h <= 24; h += 8)
        E <<= 1, E |= l >> h + f & 1;
      for (var h = 0; h <= 24; h += 8)
        E <<= 1, E |= a >> h + f & 1;
    }
    for (var h = 0; h <= 24; h += 8)
      E <<= 1, E |= l >> h + f & 1;
    for (var f = 1; f <= 3; f++) {
      for (var h = 0; h <= 24; h += 8)
        d <<= 1, d |= l >> h + f & 1;
      for (var h = 0; h <= 24; h += 8)
        d <<= 1, d |= a >> h + f & 1;
    }
    for (var h = 0; h <= 24; h += 8)
      d <<= 1, d |= a >> h + f & 1;
    u[c + 0] = E >>> 0, u[c + 1] = d >>> 0;
  }, utils$3.r28shl = function(a, l) {
    return a << l & 268435455 | a >>> 28 - l;
  };
  var r = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  utils$3.pc2 = function(a, l, u, c) {
    for (var E = 0, d = 0, f = r.length >>> 1, h = 0; h < f; h++)
      E <<= 1, E |= a >>> r[h] & 1;
    for (var h = f; h < r.length; h++)
      d <<= 1, d |= l >>> r[h] & 1;
    u[c + 0] = E >>> 0, u[c + 1] = d >>> 0;
  }, utils$3.expand = function(a, l, u) {
    var c = 0, E = 0;
    c = (a & 1) << 5 | a >>> 27;
    for (var d = 23; d >= 15; d -= 4)
      c <<= 6, c |= a >>> d & 63;
    for (var d = 11; d >= 3; d -= 4)
      E |= a >>> d & 63, E <<= 6;
    E |= (a & 31) << 1 | a >>> 31, l[u + 0] = c >>> 0, l[u + 1] = E >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  utils$3.substitute = function(a, l) {
    for (var u = 0, c = 0; c < 4; c++) {
      var E = a >>> 18 - c * 6 & 63, d = e[c * 64 + E];
      u <<= 4, u |= d;
    }
    for (var c = 0; c < 4; c++) {
      var E = l >>> 18 - c * 6 & 63, d = e[4 * 64 + c * 64 + E];
      u <<= 4, u |= d;
    }
    return u >>> 0;
  };
  var s = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return utils$3.permute = function(a) {
    for (var l = 0, u = 0; u < s.length; u++)
      l <<= 1, l |= a >>> s[u] & 1;
    return l >>> 0;
  }, utils$3.padSplit = function(a, l, u) {
    for (var c = a.toString(2); c.length < l; )
      c = "0" + c;
    for (var E = [], d = 0; d < l; d += u)
      E.push(c.slice(d, d + u));
    return E.join(" ");
  }, utils$3;
}
var minimalisticAssert, hasRequiredMinimalisticAssert;
function requireMinimalisticAssert() {
  if (hasRequiredMinimalisticAssert)
    return minimalisticAssert;
  hasRequiredMinimalisticAssert = 1, minimalisticAssert = r;
  function r(e, s) {
    if (!e)
      throw new Error(s || "Assertion failed");
  }
  return r.equal = function(s, o, a) {
    if (s != o)
      throw new Error(a || "Assertion failed: " + s + " != " + o);
  }, minimalisticAssert;
}
var cipher, hasRequiredCipher;
function requireCipher() {
  if (hasRequiredCipher)
    return cipher;
  hasRequiredCipher = 1;
  var r = requireMinimalisticAssert();
  function e(s) {
    this.options = s, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = s.padding !== !1;
  }
  return cipher = e, e.prototype._init = function() {
  }, e.prototype.update = function(o) {
    return o.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(o) : this._updateEncrypt(o);
  }, e.prototype._buffer = function(o, a) {
    for (var l = Math.min(this.buffer.length - this.bufferOff, o.length - a), u = 0; u < l; u++)
      this.buffer[this.bufferOff + u] = o[a + u];
    return this.bufferOff += l, l;
  }, e.prototype._flushBuffer = function(o, a) {
    return this._update(this.buffer, 0, o, a), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function(o) {
    var a = 0, l = 0, u = (this.bufferOff + o.length) / this.blockSize | 0, c = new Array(u * this.blockSize);
    this.bufferOff !== 0 && (a += this._buffer(o, a), this.bufferOff === this.buffer.length && (l += this._flushBuffer(c, l)));
    for (var E = o.length - (o.length - a) % this.blockSize; a < E; a += this.blockSize)
      this._update(o, a, c, l), l += this.blockSize;
    for (; a < o.length; a++, this.bufferOff++)
      this.buffer[this.bufferOff] = o[a];
    return c;
  }, e.prototype._updateDecrypt = function(o) {
    for (var a = 0, l = 0, u = Math.ceil((this.bufferOff + o.length) / this.blockSize) - 1, c = new Array(u * this.blockSize); u > 0; u--)
      a += this._buffer(o, a), l += this._flushBuffer(c, l);
    return a += this._buffer(o, a), c;
  }, e.prototype.final = function(o) {
    var a;
    o && (a = this.update(o));
    var l;
    return this.type === "encrypt" ? l = this._finalEncrypt() : l = this._finalDecrypt(), a ? a.concat(l) : l;
  }, e.prototype._pad = function(o, a) {
    if (a === 0)
      return !1;
    for (; a < o.length; )
      o[a++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var o = new Array(this.blockSize);
    return this._update(this.buffer, 0, o, 0), o;
  }, e.prototype._unpad = function(o) {
    return o;
  }, e.prototype._finalDecrypt = function() {
    r.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var o = new Array(this.blockSize);
    return this._flushBuffer(o, 0), this._unpad(o);
  }, cipher;
}
var des, hasRequiredDes$1;
function requireDes$1() {
  if (hasRequiredDes$1)
    return des;
  hasRequiredDes$1 = 1;
  var r = requireMinimalisticAssert(), e = requireInherits_browser(), s = requireUtils$3(), o = requireCipher();
  function a() {
    this.tmp = new Array(2), this.keys = null;
  }
  function l(c) {
    o.call(this, c);
    var E = new a();
    this._desState = E, this.deriveKeys(E, c.key);
  }
  e(l, o), des = l, l.create = function(E) {
    return new l(E);
  };
  var u = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return l.prototype.deriveKeys = function(E, d) {
    E.keys = new Array(16 * 2), r.equal(d.length, this.blockSize, "Invalid key length");
    var f = s.readUInt32BE(d, 0), h = s.readUInt32BE(d, 4);
    s.pc1(f, h, E.tmp, 0), f = E.tmp[0], h = E.tmp[1];
    for (var S = 0; S < E.keys.length; S += 2) {
      var R = u[S >>> 1];
      f = s.r28shl(f, R), h = s.r28shl(h, R), s.pc2(f, h, E.keys, S);
    }
  }, l.prototype._update = function(E, d, f, h) {
    var S = this._desState, R = s.readUInt32BE(E, d), _ = s.readUInt32BE(E, d + 4);
    s.ip(R, _, S.tmp, 0), R = S.tmp[0], _ = S.tmp[1], this.type === "encrypt" ? this._encrypt(S, R, _, S.tmp, 0) : this._decrypt(S, R, _, S.tmp, 0), R = S.tmp[0], _ = S.tmp[1], s.writeUInt32BE(f, R, h), s.writeUInt32BE(f, _, h + 4);
  }, l.prototype._pad = function(E, d) {
    if (this.padding === !1)
      return !1;
    for (var f = E.length - d, h = d; h < E.length; h++)
      E[h] = f;
    return !0;
  }, l.prototype._unpad = function(E) {
    if (this.padding === !1)
      return E;
    for (var d = E[E.length - 1], f = E.length - d; f < E.length; f++)
      r.equal(E[f], d);
    return E.slice(0, E.length - d);
  }, l.prototype._encrypt = function(E, d, f, h, S) {
    for (var R = d, _ = f, m = 0; m < E.keys.length; m += 2) {
      var L = E.keys[m], F = E.keys[m + 1];
      s.expand(_, E.tmp, 0), L ^= E.tmp[0], F ^= E.tmp[1];
      var W = s.substitute(L, F), G = s.permute(W), q = _;
      _ = (R ^ G) >>> 0, R = q;
    }
    s.rip(_, R, h, S);
  }, l.prototype._decrypt = function(E, d, f, h, S) {
    for (var R = f, _ = d, m = E.keys.length - 2; m >= 0; m -= 2) {
      var L = E.keys[m], F = E.keys[m + 1];
      s.expand(R, E.tmp, 0), L ^= E.tmp[0], F ^= E.tmp[1];
      var W = s.substitute(L, F), G = s.permute(W), q = R;
      R = (_ ^ G) >>> 0, _ = q;
    }
    s.rip(R, _, h, S);
  }, des;
}
var cbc$1 = {}, hasRequiredCbc$1;
function requireCbc$1() {
  if (hasRequiredCbc$1)
    return cbc$1;
  hasRequiredCbc$1 = 1;
  var r = requireMinimalisticAssert(), e = requireInherits_browser(), s = {};
  function o(l) {
    r.equal(l.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var u = 0; u < this.iv.length; u++)
      this.iv[u] = l[u];
  }
  function a(l) {
    function u(f) {
      l.call(this, f), this._cbcInit();
    }
    e(u, l);
    for (var c = Object.keys(s), E = 0; E < c.length; E++) {
      var d = c[E];
      u.prototype[d] = s[d];
    }
    return u.create = function(h) {
      return new u(h);
    }, u;
  }
  return cbc$1.instantiate = a, s._cbcInit = function() {
    var u = new o(this.options.iv);
    this._cbcState = u;
  }, s._update = function(u, c, E, d) {
    var f = this._cbcState, h = this.constructor.super_.prototype, S = f.iv;
    if (this.type === "encrypt") {
      for (var R = 0; R < this.blockSize; R++)
        S[R] ^= u[c + R];
      h._update.call(this, S, 0, E, d);
      for (var R = 0; R < this.blockSize; R++)
        S[R] = E[d + R];
    } else {
      h._update.call(this, u, c, E, d);
      for (var R = 0; R < this.blockSize; R++)
        E[d + R] ^= S[R];
      for (var R = 0; R < this.blockSize; R++)
        S[R] = u[c + R];
    }
  }, cbc$1;
}
var ede, hasRequiredEde;
function requireEde() {
  if (hasRequiredEde)
    return ede;
  hasRequiredEde = 1;
  var r = requireMinimalisticAssert(), e = requireInherits_browser(), s = requireCipher(), o = requireDes$1();
  function a(u, c) {
    r.equal(c.length, 24, "Invalid key length");
    var E = c.slice(0, 8), d = c.slice(8, 16), f = c.slice(16, 24);
    u === "encrypt" ? this.ciphers = [
      o.create({ type: "encrypt", key: E }),
      o.create({ type: "decrypt", key: d }),
      o.create({ type: "encrypt", key: f })
    ] : this.ciphers = [
      o.create({ type: "decrypt", key: f }),
      o.create({ type: "encrypt", key: d }),
      o.create({ type: "decrypt", key: E })
    ];
  }
  function l(u) {
    s.call(this, u);
    var c = new a(this.type, this.options.key);
    this._edeState = c;
  }
  return e(l, s), ede = l, l.create = function(c) {
    return new l(c);
  }, l.prototype._update = function(c, E, d, f) {
    var h = this._edeState;
    h.ciphers[0]._update(c, E, d, f), h.ciphers[1]._update(d, f, d, f), h.ciphers[2]._update(d, f, d, f);
  }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad, ede;
}
var hasRequiredDes;
function requireDes() {
  return hasRequiredDes || (hasRequiredDes = 1, des$1.utils = requireUtils$3(), des$1.Cipher = requireCipher(), des$1.DES = requireDes$1(), des$1.CBC = requireCbc$1(), des$1.EDE = requireEde()), des$1;
}
var browserifyDes, hasRequiredBrowserifyDes;
function requireBrowserifyDes() {
  if (hasRequiredBrowserifyDes)
    return browserifyDes;
  hasRequiredBrowserifyDes = 1;
  var r = requireCipherBase(), e = requireDes(), s = requireInherits_browser(), o = requireSafeBuffer$1().Buffer, a = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], browserifyDes = l, s(l, r);
  function l(u) {
    r.call(this);
    var c = u.mode.toLowerCase(), E = a[c], d;
    u.decrypt ? d = "decrypt" : d = "encrypt";
    var f = u.key;
    o.isBuffer(f) || (f = o.from(f)), (c === "des-ede" || c === "des-ede-cbc") && (f = o.concat([f, f.slice(0, 8)]));
    var h = u.iv;
    o.isBuffer(h) || (h = o.from(h)), this._des = E.create({
      key: f,
      iv: h,
      type: d
    });
  }
  return l.prototype._update = function(u) {
    return o.from(this._des.update(u));
  }, l.prototype._final = function() {
    return o.from(this._des.final());
  }, browserifyDes;
}
var browser$5 = {}, encrypter = {}, ecb = {}, hasRequiredEcb;
function requireEcb() {
  return hasRequiredEcb || (hasRequiredEcb = 1, ecb.encrypt = function(r, e) {
    return r._cipher.encryptBlock(e);
  }, ecb.decrypt = function(r, e) {
    return r._cipher.decryptBlock(e);
  }), ecb;
}
var cbc = {}, bufferXor, hasRequiredBufferXor;
function requireBufferXor() {
  return hasRequiredBufferXor || (hasRequiredBufferXor = 1, bufferXor = function(e, s) {
    for (var o = Math.min(e.length, s.length), a = new buffer$1.Buffer(o), l = 0; l < o; ++l)
      a[l] = e[l] ^ s[l];
    return a;
  }), bufferXor;
}
var hasRequiredCbc;
function requireCbc() {
  if (hasRequiredCbc)
    return cbc;
  hasRequiredCbc = 1;
  var r = requireBufferXor();
  return cbc.encrypt = function(e, s) {
    var o = r(s, e._prev);
    return e._prev = e._cipher.encryptBlock(o), e._prev;
  }, cbc.decrypt = function(e, s) {
    var o = e._prev;
    e._prev = s;
    var a = e._cipher.decryptBlock(s);
    return r(a, o);
  }, cbc;
}
var cfb = {}, hasRequiredCfb;
function requireCfb() {
  if (hasRequiredCfb)
    return cfb;
  hasRequiredCfb = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireBufferXor();
  function s(o, a, l) {
    var u = a.length, c = e(a, o._cache);
    return o._cache = o._cache.slice(u), o._prev = r.concat([o._prev, l ? a : c]), c;
  }
  return cfb.encrypt = function(o, a, l) {
    for (var u = r.allocUnsafe(0), c; a.length; )
      if (o._cache.length === 0 && (o._cache = o._cipher.encryptBlock(o._prev), o._prev = r.allocUnsafe(0)), o._cache.length <= a.length)
        c = o._cache.length, u = r.concat([u, s(o, a.slice(0, c), l)]), a = a.slice(c);
      else {
        u = r.concat([u, s(o, a, l)]);
        break;
      }
    return u;
  }, cfb;
}
var cfb8 = {}, hasRequiredCfb8;
function requireCfb8() {
  if (hasRequiredCfb8)
    return cfb8;
  hasRequiredCfb8 = 1;
  var r = requireSafeBuffer$1().Buffer;
  function e(s, o, a) {
    var l = s._cipher.encryptBlock(s._prev), u = l[0] ^ o;
    return s._prev = r.concat([
      s._prev.slice(1),
      r.from([a ? o : u])
    ]), u;
  }
  return cfb8.encrypt = function(s, o, a) {
    for (var l = o.length, u = r.allocUnsafe(l), c = -1; ++c < l; )
      u[c] = e(s, o[c], a);
    return u;
  }, cfb8;
}
var cfb1 = {}, hasRequiredCfb1;
function requireCfb1() {
  if (hasRequiredCfb1)
    return cfb1;
  hasRequiredCfb1 = 1;
  var r = requireSafeBuffer$1().Buffer;
  function e(o, a, l) {
    for (var u, c = -1, E = 8, d = 0, f, h; ++c < E; )
      u = o._cipher.encryptBlock(o._prev), f = a & 1 << 7 - c ? 128 : 0, h = u[0] ^ f, d += (h & 128) >> c % 8, o._prev = s(o._prev, l ? f : h);
    return d;
  }
  function s(o, a) {
    var l = o.length, u = -1, c = r.allocUnsafe(o.length);
    for (o = r.concat([o, r.from([a])]); ++u < l; )
      c[u] = o[u] << 1 | o[u + 1] >> 7;
    return c;
  }
  return cfb1.encrypt = function(o, a, l) {
    for (var u = a.length, c = r.allocUnsafe(u), E = -1; ++E < u; )
      c[E] = e(o, a[E], l);
    return c;
  }, cfb1;
}
var ofb = {}, hasRequiredOfb;
function requireOfb() {
  if (hasRequiredOfb)
    return ofb;
  hasRequiredOfb = 1;
  var r = requireBufferXor();
  function e(s) {
    return s._prev = s._cipher.encryptBlock(s._prev), s._prev;
  }
  return ofb.encrypt = function(s, o) {
    for (; s._cache.length < o.length; )
      s._cache = buffer$1.Buffer.concat([s._cache, e(s)]);
    var a = s._cache.slice(0, o.length);
    return s._cache = s._cache.slice(o.length), r(o, a);
  }, ofb;
}
var ctr = {}, incr32_1, hasRequiredIncr32;
function requireIncr32() {
  if (hasRequiredIncr32)
    return incr32_1;
  hasRequiredIncr32 = 1;
  function r(e) {
    for (var s = e.length, o; s--; )
      if (o = e.readUInt8(s), o === 255)
        e.writeUInt8(0, s);
      else {
        o++, e.writeUInt8(o, s);
        break;
      }
  }
  return incr32_1 = r, incr32_1;
}
var hasRequiredCtr;
function requireCtr() {
  if (hasRequiredCtr)
    return ctr;
  hasRequiredCtr = 1;
  var r = requireBufferXor(), e = requireSafeBuffer$1().Buffer, s = requireIncr32();
  function o(l) {
    var u = l._cipher.encryptBlockRaw(l._prev);
    return s(l._prev), u;
  }
  var a = 16;
  return ctr.encrypt = function(l, u) {
    var c = Math.ceil(u.length / a), E = l._cache.length;
    l._cache = e.concat([
      l._cache,
      e.allocUnsafe(c * a)
    ]);
    for (var d = 0; d < c; d++) {
      var f = o(l), h = E + d * a;
      l._cache.writeUInt32BE(f[0], h + 0), l._cache.writeUInt32BE(f[1], h + 4), l._cache.writeUInt32BE(f[2], h + 8), l._cache.writeUInt32BE(f[3], h + 12);
    }
    var S = l._cache.slice(0, u.length);
    return l._cache = l._cache.slice(u.length), r(u, S);
  }, ctr;
}
const aes128 = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes192 = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aes256 = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, require$$2 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128,
  aes192,
  aes256,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var modes_1, hasRequiredModes$1;
function requireModes$1() {
  if (hasRequiredModes$1)
    return modes_1;
  hasRequiredModes$1 = 1;
  var r = {
    ECB: requireEcb(),
    CBC: requireCbc(),
    CFB: requireCfb(),
    CFB8: requireCfb8(),
    CFB1: requireCfb1(),
    OFB: requireOfb(),
    CTR: requireCtr(),
    GCM: requireCtr()
  }, e = require$$2;
  for (var s in e)
    e[s].module = r[e[s].mode];
  return modes_1 = e, modes_1;
}
var aes = {}, hasRequiredAes;
function requireAes() {
  if (hasRequiredAes)
    return aes;
  hasRequiredAes = 1;
  var r = requireSafeBuffer$1().Buffer;
  function e(c) {
    r.isBuffer(c) || (c = r.from(c));
    for (var E = c.length / 4 | 0, d = new Array(E), f = 0; f < E; f++)
      d[f] = c.readUInt32BE(f * 4);
    return d;
  }
  function s(c) {
    for (var E = 0; E < c.length; c++)
      c[E] = 0;
  }
  function o(c, E, d, f, h) {
    for (var S = d[0], R = d[1], _ = d[2], m = d[3], L = c[0] ^ E[0], F = c[1] ^ E[1], W = c[2] ^ E[2], G = c[3] ^ E[3], q, fe, _e, Le, Fe = 4, Ee = 1; Ee < h; Ee++)
      q = S[L >>> 24] ^ R[F >>> 16 & 255] ^ _[W >>> 8 & 255] ^ m[G & 255] ^ E[Fe++], fe = S[F >>> 24] ^ R[W >>> 16 & 255] ^ _[G >>> 8 & 255] ^ m[L & 255] ^ E[Fe++], _e = S[W >>> 24] ^ R[G >>> 16 & 255] ^ _[L >>> 8 & 255] ^ m[F & 255] ^ E[Fe++], Le = S[G >>> 24] ^ R[L >>> 16 & 255] ^ _[F >>> 8 & 255] ^ m[W & 255] ^ E[Fe++], L = q, F = fe, W = _e, G = Le;
    return q = (f[L >>> 24] << 24 | f[F >>> 16 & 255] << 16 | f[W >>> 8 & 255] << 8 | f[G & 255]) ^ E[Fe++], fe = (f[F >>> 24] << 24 | f[W >>> 16 & 255] << 16 | f[G >>> 8 & 255] << 8 | f[L & 255]) ^ E[Fe++], _e = (f[W >>> 24] << 24 | f[G >>> 16 & 255] << 16 | f[L >>> 8 & 255] << 8 | f[F & 255]) ^ E[Fe++], Le = (f[G >>> 24] << 24 | f[L >>> 16 & 255] << 16 | f[F >>> 8 & 255] << 8 | f[W & 255]) ^ E[Fe++], q = q >>> 0, fe = fe >>> 0, _e = _e >>> 0, Le = Le >>> 0, [q, fe, _e, Le];
  }
  var a = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], l = function() {
    for (var c = new Array(256), E = 0; E < 256; E++)
      E < 128 ? c[E] = E << 1 : c[E] = E << 1 ^ 283;
    for (var d = [], f = [], h = [[], [], [], []], S = [[], [], [], []], R = 0, _ = 0, m = 0; m < 256; ++m) {
      var L = _ ^ _ << 1 ^ _ << 2 ^ _ << 3 ^ _ << 4;
      L = L >>> 8 ^ L & 255 ^ 99, d[R] = L, f[L] = R;
      var F = c[R], W = c[F], G = c[W], q = c[L] * 257 ^ L * 16843008;
      h[0][R] = q << 24 | q >>> 8, h[1][R] = q << 16 | q >>> 16, h[2][R] = q << 8 | q >>> 24, h[3][R] = q, q = G * 16843009 ^ W * 65537 ^ F * 257 ^ R * 16843008, S[0][L] = q << 24 | q >>> 8, S[1][L] = q << 16 | q >>> 16, S[2][L] = q << 8 | q >>> 24, S[3][L] = q, R === 0 ? R = _ = 1 : (R = F ^ c[c[c[G ^ F]]], _ ^= c[c[_]]);
    }
    return {
      SBOX: d,
      INV_SBOX: f,
      SUB_MIX: h,
      INV_SUB_MIX: S
    };
  }();
  function u(c) {
    this._key = e(c), this._reset();
  }
  return u.blockSize = 4 * 4, u.keySize = 256 / 8, u.prototype.blockSize = u.blockSize, u.prototype.keySize = u.keySize, u.prototype._reset = function() {
    for (var c = this._key, E = c.length, d = E + 6, f = (d + 1) * 4, h = [], S = 0; S < E; S++)
      h[S] = c[S];
    for (S = E; S < f; S++) {
      var R = h[S - 1];
      S % E === 0 ? (R = R << 8 | R >>> 24, R = l.SBOX[R >>> 24] << 24 | l.SBOX[R >>> 16 & 255] << 16 | l.SBOX[R >>> 8 & 255] << 8 | l.SBOX[R & 255], R ^= a[S / E | 0] << 24) : E > 6 && S % E === 4 && (R = l.SBOX[R >>> 24] << 24 | l.SBOX[R >>> 16 & 255] << 16 | l.SBOX[R >>> 8 & 255] << 8 | l.SBOX[R & 255]), h[S] = h[S - E] ^ R;
    }
    for (var _ = [], m = 0; m < f; m++) {
      var L = f - m, F = h[L - (m % 4 ? 0 : 4)];
      m < 4 || L <= 4 ? _[m] = F : _[m] = l.INV_SUB_MIX[0][l.SBOX[F >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[F >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[F >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[F & 255]];
    }
    this._nRounds = d, this._keySchedule = h, this._invKeySchedule = _;
  }, u.prototype.encryptBlockRaw = function(c) {
    return c = e(c), o(c, this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
  }, u.prototype.encryptBlock = function(c) {
    var E = this.encryptBlockRaw(c), d = r.allocUnsafe(16);
    return d.writeUInt32BE(E[0], 0), d.writeUInt32BE(E[1], 4), d.writeUInt32BE(E[2], 8), d.writeUInt32BE(E[3], 12), d;
  }, u.prototype.decryptBlock = function(c) {
    c = e(c);
    var E = c[1];
    c[1] = c[3], c[3] = E;
    var d = o(c, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), f = r.allocUnsafe(16);
    return f.writeUInt32BE(d[0], 0), f.writeUInt32BE(d[3], 4), f.writeUInt32BE(d[2], 8), f.writeUInt32BE(d[1], 12), f;
  }, u.prototype.scrub = function() {
    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
  }, aes.AES = u, aes;
}
var ghash, hasRequiredGhash;
function requireGhash() {
  if (hasRequiredGhash)
    return ghash;
  hasRequiredGhash = 1;
  var r = requireSafeBuffer$1().Buffer, e = r.alloc(16, 0);
  function s(l) {
    return [
      l.readUInt32BE(0),
      l.readUInt32BE(4),
      l.readUInt32BE(8),
      l.readUInt32BE(12)
    ];
  }
  function o(l) {
    var u = r.allocUnsafe(16);
    return u.writeUInt32BE(l[0] >>> 0, 0), u.writeUInt32BE(l[1] >>> 0, 4), u.writeUInt32BE(l[2] >>> 0, 8), u.writeUInt32BE(l[3] >>> 0, 12), u;
  }
  function a(l) {
    this.h = l, this.state = r.alloc(16, 0), this.cache = r.allocUnsafe(0);
  }
  return a.prototype.ghash = function(l) {
    for (var u = -1; ++u < l.length; )
      this.state[u] ^= l[u];
    this._multiply();
  }, a.prototype._multiply = function() {
    for (var l = s(this.h), u = [0, 0, 0, 0], c, E, d, f = -1; ++f < 128; ) {
      for (E = (this.state[~~(f / 8)] & 1 << 7 - f % 8) !== 0, E && (u[0] ^= l[0], u[1] ^= l[1], u[2] ^= l[2], u[3] ^= l[3]), d = (l[3] & 1) !== 0, c = 3; c > 0; c--)
        l[c] = l[c] >>> 1 | (l[c - 1] & 1) << 31;
      l[0] = l[0] >>> 1, d && (l[0] = l[0] ^ 225 << 24);
    }
    this.state = o(u);
  }, a.prototype.update = function(l) {
    this.cache = r.concat([this.cache, l]);
    for (var u; this.cache.length >= 16; )
      u = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(u);
  }, a.prototype.final = function(l, u) {
    return this.cache.length && this.ghash(r.concat([this.cache, e], 16)), this.ghash(o([0, l, 0, u])), this.state;
  }, ghash = a, ghash;
}
var authCipher, hasRequiredAuthCipher;
function requireAuthCipher() {
  if (hasRequiredAuthCipher)
    return authCipher;
  hasRequiredAuthCipher = 1;
  var r = requireAes(), e = requireSafeBuffer$1().Buffer, s = requireCipherBase(), o = requireInherits_browser(), a = requireGhash(), l = requireBufferXor(), u = requireIncr32();
  function c(f, h) {
    var S = 0;
    f.length !== h.length && S++;
    for (var R = Math.min(f.length, h.length), _ = 0; _ < R; ++_)
      S += f[_] ^ h[_];
    return S;
  }
  function E(f, h, S) {
    if (h.length === 12)
      return f._finID = e.concat([h, e.from([0, 0, 0, 1])]), e.concat([h, e.from([0, 0, 0, 2])]);
    var R = new a(S), _ = h.length, m = _ % 16;
    R.update(h), m && (m = 16 - m, R.update(e.alloc(m, 0))), R.update(e.alloc(8, 0));
    var L = _ * 8, F = e.alloc(8);
    F.writeUIntBE(L, 0, 8), R.update(F), f._finID = R.state;
    var W = e.from(f._finID);
    return u(W), W;
  }
  function d(f, h, S, R) {
    s.call(this);
    var _ = e.alloc(4, 0);
    this._cipher = new r.AES(h);
    var m = this._cipher.encryptBlock(_);
    this._ghash = new a(m), S = E(this, S, m), this._prev = e.from(S), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = R, this._alen = 0, this._len = 0, this._mode = f, this._authTag = null, this._called = !1;
  }
  return o(d, s), d.prototype._update = function(f) {
    if (!this._called && this._alen) {
      var h = 16 - this._alen % 16;
      h < 16 && (h = e.alloc(h, 0), this._ghash.update(h));
    }
    this._called = !0;
    var S = this._mode.encrypt(this, f);
    return this._decrypt ? this._ghash.update(f) : this._ghash.update(S), this._len += f.length, S;
  }, d.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var f = l(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && c(f, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = f, this._cipher.scrub();
  }, d.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, d.prototype.setAuthTag = function(h) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = h;
  }, d.prototype.setAAD = function(h) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(h), this._alen += h.length;
  }, authCipher = d, authCipher;
}
var streamCipher, hasRequiredStreamCipher;
function requireStreamCipher() {
  if (hasRequiredStreamCipher)
    return streamCipher;
  hasRequiredStreamCipher = 1;
  var r = requireAes(), e = requireSafeBuffer$1().Buffer, s = requireCipherBase(), o = requireInherits_browser();
  function a(l, u, c, E) {
    s.call(this), this._cipher = new r.AES(u), this._prev = e.from(c), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = E, this._mode = l;
  }
  return o(a, s), a.prototype._update = function(l) {
    return this._mode.encrypt(this, l, this._decrypt);
  }, a.prototype._final = function() {
    this._cipher.scrub();
  }, streamCipher = a, streamCipher;
}
var evp_bytestokey, hasRequiredEvp_bytestokey;
function requireEvp_bytestokey() {
  if (hasRequiredEvp_bytestokey)
    return evp_bytestokey;
  hasRequiredEvp_bytestokey = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireMd5_js();
  function s(o, a, l, u) {
    if (r.isBuffer(o) || (o = r.from(o, "binary")), a && (r.isBuffer(a) || (a = r.from(a, "binary")), a.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var c = l / 8, E = r.alloc(c), d = r.alloc(u || 0), f = r.alloc(0); c > 0 || u > 0; ) {
      var h = new e();
      h.update(f), h.update(o), a && h.update(a), f = h.digest();
      var S = 0;
      if (c > 0) {
        var R = E.length - c;
        S = Math.min(c, f.length), f.copy(E, R, 0, S), c -= S;
      }
      if (S < f.length && u > 0) {
        var _ = d.length - u, m = Math.min(u, f.length - S);
        f.copy(d, _, S, S + m), u -= m;
      }
    }
    return f.fill(0), { key: E, iv: d };
  }
  return evp_bytestokey = s, evp_bytestokey;
}
var hasRequiredEncrypter;
function requireEncrypter() {
  if (hasRequiredEncrypter)
    return encrypter;
  hasRequiredEncrypter = 1;
  var r = requireModes$1(), e = requireAuthCipher(), s = requireSafeBuffer$1().Buffer, o = requireStreamCipher(), a = requireCipherBase(), l = requireAes(), u = requireEvp_bytestokey(), c = requireInherits_browser();
  function E(R, _, m) {
    a.call(this), this._cache = new f(), this._cipher = new l.AES(_), this._prev = s.from(m), this._mode = R, this._autopadding = !0;
  }
  c(E, a), E.prototype._update = function(R) {
    this._cache.add(R);
    for (var _, m, L = []; _ = this._cache.get(); )
      m = this._mode.encrypt(this, _), L.push(m);
    return s.concat(L);
  };
  var d = s.alloc(16, 16);
  E.prototype._final = function() {
    var R = this._cache.flush();
    if (this._autopadding)
      return R = this._mode.encrypt(this, R), this._cipher.scrub(), R;
    if (!R.equals(d))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, E.prototype.setAutoPadding = function(R) {
    return this._autopadding = !!R, this;
  };
  function f() {
    this.cache = s.allocUnsafe(0);
  }
  f.prototype.add = function(R) {
    this.cache = s.concat([this.cache, R]);
  }, f.prototype.get = function() {
    if (this.cache.length > 15) {
      var R = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), R;
    }
    return null;
  }, f.prototype.flush = function() {
    for (var R = 16 - this.cache.length, _ = s.allocUnsafe(R), m = -1; ++m < R; )
      _.writeUInt8(R, m);
    return s.concat([this.cache, _]);
  };
  function h(R, _, m) {
    var L = r[R.toLowerCase()];
    if (!L)
      throw new TypeError("invalid suite type");
    if (typeof _ == "string" && (_ = s.from(_)), _.length !== L.key / 8)
      throw new TypeError("invalid key length " + _.length);
    if (typeof m == "string" && (m = s.from(m)), L.mode !== "GCM" && m.length !== L.iv)
      throw new TypeError("invalid iv length " + m.length);
    return L.type === "stream" ? new o(L.module, _, m) : L.type === "auth" ? new e(L.module, _, m) : new E(L.module, _, m);
  }
  function S(R, _) {
    var m = r[R.toLowerCase()];
    if (!m)
      throw new TypeError("invalid suite type");
    var L = u(_, !1, m.key, m.iv);
    return h(R, L.key, L.iv);
  }
  return encrypter.createCipheriv = h, encrypter.createCipher = S, encrypter;
}
var decrypter = {}, hasRequiredDecrypter;
function requireDecrypter() {
  if (hasRequiredDecrypter)
    return decrypter;
  hasRequiredDecrypter = 1;
  var r = requireAuthCipher(), e = requireSafeBuffer$1().Buffer, s = requireModes$1(), o = requireStreamCipher(), a = requireCipherBase(), l = requireAes(), u = requireEvp_bytestokey(), c = requireInherits_browser();
  function E(R, _, m) {
    a.call(this), this._cache = new d(), this._last = void 0, this._cipher = new l.AES(_), this._prev = e.from(m), this._mode = R, this._autopadding = !0;
  }
  c(E, a), E.prototype._update = function(R) {
    this._cache.add(R);
    for (var _, m, L = []; _ = this._cache.get(this._autopadding); )
      m = this._mode.decrypt(this, _), L.push(m);
    return e.concat(L);
  }, E.prototype._final = function() {
    var R = this._cache.flush();
    if (this._autopadding)
      return f(this._mode.decrypt(this, R));
    if (R)
      throw new Error("data not multiple of block length");
  }, E.prototype.setAutoPadding = function(R) {
    return this._autopadding = !!R, this;
  };
  function d() {
    this.cache = e.allocUnsafe(0);
  }
  d.prototype.add = function(R) {
    this.cache = e.concat([this.cache, R]);
  }, d.prototype.get = function(R) {
    var _;
    if (R) {
      if (this.cache.length > 16)
        return _ = this.cache.slice(0, 16), this.cache = this.cache.slice(16), _;
    } else if (this.cache.length >= 16)
      return _ = this.cache.slice(0, 16), this.cache = this.cache.slice(16), _;
    return null;
  }, d.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function f(R) {
    var _ = R[15];
    if (_ < 1 || _ > 16)
      throw new Error("unable to decrypt data");
    for (var m = -1; ++m < _; )
      if (R[m + (16 - _)] !== _)
        throw new Error("unable to decrypt data");
    if (_ !== 16)
      return R.slice(0, 16 - _);
  }
  function h(R, _, m) {
    var L = s[R.toLowerCase()];
    if (!L)
      throw new TypeError("invalid suite type");
    if (typeof m == "string" && (m = e.from(m)), L.mode !== "GCM" && m.length !== L.iv)
      throw new TypeError("invalid iv length " + m.length);
    if (typeof _ == "string" && (_ = e.from(_)), _.length !== L.key / 8)
      throw new TypeError("invalid key length " + _.length);
    return L.type === "stream" ? new o(L.module, _, m, !0) : L.type === "auth" ? new r(L.module, _, m, !0) : new E(L.module, _, m);
  }
  function S(R, _) {
    var m = s[R.toLowerCase()];
    if (!m)
      throw new TypeError("invalid suite type");
    var L = u(_, !1, m.key, m.iv);
    return h(R, L.key, L.iv);
  }
  return decrypter.createDecipher = S, decrypter.createDecipheriv = h, decrypter;
}
var hasRequiredBrowser$6;
function requireBrowser$6() {
  if (hasRequiredBrowser$6)
    return browser$5;
  hasRequiredBrowser$6 = 1;
  var r = requireEncrypter(), e = requireDecrypter(), s = require$$2;
  function o() {
    return Object.keys(s);
  }
  return browser$5.createCipher = browser$5.Cipher = r.createCipher, browser$5.createCipheriv = browser$5.Cipheriv = r.createCipheriv, browser$5.createDecipher = browser$5.Decipher = e.createDecipher, browser$5.createDecipheriv = browser$5.Decipheriv = e.createDecipheriv, browser$5.listCiphers = browser$5.getCiphers = o, browser$5;
}
var modes = {}, hasRequiredModes;
function requireModes() {
  return hasRequiredModes || (hasRequiredModes = 1, function(r) {
    r["des-ecb"] = {
      key: 8,
      iv: 0
    }, r["des-cbc"] = r.des = {
      key: 8,
      iv: 8
    }, r["des-ede3-cbc"] = r.des3 = {
      key: 24,
      iv: 8
    }, r["des-ede3"] = {
      key: 24,
      iv: 0
    }, r["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, r["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(modes)), modes;
}
var hasRequiredBrowser$5;
function requireBrowser$5() {
  if (hasRequiredBrowser$5)
    return browser$6;
  hasRequiredBrowser$5 = 1;
  var r = requireBrowserifyDes(), e = requireBrowser$6(), s = requireModes$1(), o = requireModes(), a = requireEvp_bytestokey();
  function l(f, h) {
    f = f.toLowerCase();
    var S, R;
    if (s[f])
      S = s[f].key, R = s[f].iv;
    else if (o[f])
      S = o[f].key * 8, R = o[f].iv;
    else
      throw new TypeError("invalid suite type");
    var _ = a(h, !1, S, R);
    return c(f, _.key, _.iv);
  }
  function u(f, h) {
    f = f.toLowerCase();
    var S, R;
    if (s[f])
      S = s[f].key, R = s[f].iv;
    else if (o[f])
      S = o[f].key * 8, R = o[f].iv;
    else
      throw new TypeError("invalid suite type");
    var _ = a(h, !1, S, R);
    return E(f, _.key, _.iv);
  }
  function c(f, h, S) {
    if (f = f.toLowerCase(), s[f])
      return e.createCipheriv(f, h, S);
    if (o[f])
      return new r({ key: h, iv: S, mode: f });
    throw new TypeError("invalid suite type");
  }
  function E(f, h, S) {
    if (f = f.toLowerCase(), s[f])
      return e.createDecipheriv(f, h, S);
    if (o[f])
      return new r({ key: h, iv: S, mode: f, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function d() {
    return Object.keys(o).concat(e.getCiphers());
  }
  return browser$6.createCipher = browser$6.Cipher = l, browser$6.createCipheriv = browser$6.Cipheriv = c, browser$6.createDecipher = browser$6.Decipher = u, browser$6.createDecipheriv = browser$6.Decipheriv = E, browser$6.listCiphers = browser$6.getCiphers = d, browser$6;
}
var browser$4 = {}, bn$1 = { exports: {} };
bn$1.exports;
var hasRequiredBn$1;
function requireBn$1() {
  return hasRequiredBn$1 || (hasRequiredBn$1 = 1, function(r) {
    (function(e, s) {
      function o(ve, te) {
        if (!ve)
          throw new Error(te || "Assertion failed");
      }
      function a(ve, te) {
        ve.super_ = te;
        var ae = function() {
        };
        ae.prototype = te.prototype, ve.prototype = new ae(), ve.prototype.constructor = ve;
      }
      function l(ve, te, ae) {
        if (l.isBN(ve))
          return ve;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ve !== null && ((te === "le" || te === "be") && (ae = te, te = 10), this._init(ve || 0, te || 10, ae || "be"));
      }
      typeof e == "object" ? e.exports = l : s.BN = l, l.BN = l, l.wordSize = 26;
      var u;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? u = window.Buffer : u = buffer$1.Buffer;
      } catch {
      }
      l.isBN = function(te) {
        return te instanceof l ? !0 : te !== null && typeof te == "object" && te.constructor.wordSize === l.wordSize && Array.isArray(te.words);
      }, l.max = function(te, ae) {
        return te.cmp(ae) > 0 ? te : ae;
      }, l.min = function(te, ae) {
        return te.cmp(ae) < 0 ? te : ae;
      }, l.prototype._init = function(te, ae, v) {
        if (typeof te == "number")
          return this._initNumber(te, ae, v);
        if (typeof te == "object")
          return this._initArray(te, ae, v);
        ae === "hex" && (ae = 16), o(ae === (ae | 0) && ae >= 2 && ae <= 36), te = te.toString().replace(/\s+/g, "");
        var Te = 0;
        te[0] === "-" && (Te++, this.negative = 1), Te < te.length && (ae === 16 ? this._parseHex(te, Te, v) : (this._parseBase(te, ae, Te), v === "le" && this._initArray(this.toArray(), ae, v)));
      }, l.prototype._initNumber = function(te, ae, v) {
        te < 0 && (this.negative = 1, te = -te), te < 67108864 ? (this.words = [te & 67108863], this.length = 1) : te < 4503599627370496 ? (this.words = [
          te & 67108863,
          te / 67108864 & 67108863
        ], this.length = 2) : (o(te < 9007199254740992), this.words = [
          te & 67108863,
          te / 67108864 & 67108863,
          1
        ], this.length = 3), v === "le" && this._initArray(this.toArray(), ae, v);
      }, l.prototype._initArray = function(te, ae, v) {
        if (o(typeof te.length == "number"), te.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(te.length / 3), this.words = new Array(this.length);
        for (var Te = 0; Te < this.length; Te++)
          this.words[Te] = 0;
        var De, be, ze = 0;
        if (v === "be")
          for (Te = te.length - 1, De = 0; Te >= 0; Te -= 3)
            be = te[Te] | te[Te - 1] << 8 | te[Te - 2] << 16, this.words[De] |= be << ze & 67108863, this.words[De + 1] = be >>> 26 - ze & 67108863, ze += 24, ze >= 26 && (ze -= 26, De++);
        else if (v === "le")
          for (Te = 0, De = 0; Te < te.length; Te += 3)
            be = te[Te] | te[Te + 1] << 8 | te[Te + 2] << 16, this.words[De] |= be << ze & 67108863, this.words[De + 1] = be >>> 26 - ze & 67108863, ze += 24, ze >= 26 && (ze -= 26, De++);
        return this.strip();
      };
      function c(ve, te) {
        var ae = ve.charCodeAt(te);
        return ae >= 65 && ae <= 70 ? ae - 55 : ae >= 97 && ae <= 102 ? ae - 87 : ae - 48 & 15;
      }
      function E(ve, te, ae) {
        var v = c(ve, ae);
        return ae - 1 >= te && (v |= c(ve, ae - 1) << 4), v;
      }
      l.prototype._parseHex = function(te, ae, v) {
        this.length = Math.ceil((te.length - ae) / 6), this.words = new Array(this.length);
        for (var Te = 0; Te < this.length; Te++)
          this.words[Te] = 0;
        var De = 0, be = 0, ze;
        if (v === "be")
          for (Te = te.length - 1; Te >= ae; Te -= 2)
            ze = E(te, ae, Te) << De, this.words[be] |= ze & 67108863, De >= 18 ? (De -= 18, be += 1, this.words[be] |= ze >>> 26) : De += 8;
        else {
          var ke = te.length - ae;
          for (Te = ke % 2 === 0 ? ae + 1 : ae; Te < te.length; Te += 2)
            ze = E(te, ae, Te) << De, this.words[be] |= ze & 67108863, De >= 18 ? (De -= 18, be += 1, this.words[be] |= ze >>> 26) : De += 8;
        }
        this.strip();
      };
      function d(ve, te, ae, v) {
        for (var Te = 0, De = Math.min(ve.length, ae), be = te; be < De; be++) {
          var ze = ve.charCodeAt(be) - 48;
          Te *= v, ze >= 49 ? Te += ze - 49 + 10 : ze >= 17 ? Te += ze - 17 + 10 : Te += ze;
        }
        return Te;
      }
      l.prototype._parseBase = function(te, ae, v) {
        this.words = [0], this.length = 1;
        for (var Te = 0, De = 1; De <= 67108863; De *= ae)
          Te++;
        Te--, De = De / ae | 0;
        for (var be = te.length - v, ze = be % Te, ke = Math.min(be, be - ze) + v, Be = 0, Me = v; Me < ke; Me += Te)
          Be = d(te, Me, Me + Te, ae), this.imuln(De), this.words[0] + Be < 67108864 ? this.words[0] += Be : this._iaddn(Be);
        if (ze !== 0) {
          var me = 1;
          for (Be = d(te, Me, te.length, ae), Me = 0; Me < ze; Me++)
            me *= ae;
          this.imuln(me), this.words[0] + Be < 67108864 ? this.words[0] += Be : this._iaddn(Be);
        }
        this.strip();
      }, l.prototype.copy = function(te) {
        te.words = new Array(this.length);
        for (var ae = 0; ae < this.length; ae++)
          te.words[ae] = this.words[ae];
        te.length = this.length, te.negative = this.negative, te.red = this.red;
      }, l.prototype.clone = function() {
        var te = new l(null);
        return this.copy(te), te;
      }, l.prototype._expand = function(te) {
        for (; this.length < te; )
          this.words[this.length++] = 0;
        return this;
      }, l.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, l.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, l.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var f = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], h = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], S = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      l.prototype.toString = function(te, ae) {
        te = te || 10, ae = ae | 0 || 1;
        var v;
        if (te === 16 || te === "hex") {
          v = "";
          for (var Te = 0, De = 0, be = 0; be < this.length; be++) {
            var ze = this.words[be], ke = ((ze << Te | De) & 16777215).toString(16);
            De = ze >>> 24 - Te & 16777215, Te += 2, Te >= 26 && (Te -= 26, be--), De !== 0 || be !== this.length - 1 ? v = f[6 - ke.length] + ke + v : v = ke + v;
          }
          for (De !== 0 && (v = De.toString(16) + v); v.length % ae !== 0; )
            v = "0" + v;
          return this.negative !== 0 && (v = "-" + v), v;
        }
        if (te === (te | 0) && te >= 2 && te <= 36) {
          var Be = h[te], Me = S[te];
          v = "";
          var me = this.clone();
          for (me.negative = 0; !me.isZero(); ) {
            var Se = me.modn(Me).toString(te);
            me = me.idivn(Me), me.isZero() ? v = Se + v : v = f[Be - Se.length] + Se + v;
          }
          for (this.isZero() && (v = "0" + v); v.length % ae !== 0; )
            v = "0" + v;
          return this.negative !== 0 && (v = "-" + v), v;
        }
        o(!1, "Base should be between 2 and 36");
      }, l.prototype.toNumber = function() {
        var te = this.words[0];
        return this.length === 2 ? te += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? te += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && o(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -te : te;
      }, l.prototype.toJSON = function() {
        return this.toString(16);
      }, l.prototype.toBuffer = function(te, ae) {
        return o(typeof u < "u"), this.toArrayLike(u, te, ae);
      }, l.prototype.toArray = function(te, ae) {
        return this.toArrayLike(Array, te, ae);
      }, l.prototype.toArrayLike = function(te, ae, v) {
        var Te = this.byteLength(), De = v || Math.max(1, Te);
        o(Te <= De, "byte array longer than desired length"), o(De > 0, "Requested array length <= 0"), this.strip();
        var be = ae === "le", ze = new te(De), ke, Be, Me = this.clone();
        if (be) {
          for (Be = 0; !Me.isZero(); Be++)
            ke = Me.andln(255), Me.iushrn(8), ze[Be] = ke;
          for (; Be < De; Be++)
            ze[Be] = 0;
        } else {
          for (Be = 0; Be < De - Te; Be++)
            ze[Be] = 0;
          for (Be = 0; !Me.isZero(); Be++)
            ke = Me.andln(255), Me.iushrn(8), ze[De - Be - 1] = ke;
        }
        return ze;
      }, Math.clz32 ? l.prototype._countBits = function(te) {
        return 32 - Math.clz32(te);
      } : l.prototype._countBits = function(te) {
        var ae = te, v = 0;
        return ae >= 4096 && (v += 13, ae >>>= 13), ae >= 64 && (v += 7, ae >>>= 7), ae >= 8 && (v += 4, ae >>>= 4), ae >= 2 && (v += 2, ae >>>= 2), v + ae;
      }, l.prototype._zeroBits = function(te) {
        if (te === 0)
          return 26;
        var ae = te, v = 0;
        return ae & 8191 || (v += 13, ae >>>= 13), ae & 127 || (v += 7, ae >>>= 7), ae & 15 || (v += 4, ae >>>= 4), ae & 3 || (v += 2, ae >>>= 2), ae & 1 || v++, v;
      }, l.prototype.bitLength = function() {
        var te = this.words[this.length - 1], ae = this._countBits(te);
        return (this.length - 1) * 26 + ae;
      };
      function R(ve) {
        for (var te = new Array(ve.bitLength()), ae = 0; ae < te.length; ae++) {
          var v = ae / 26 | 0, Te = ae % 26;
          te[ae] = (ve.words[v] & 1 << Te) >>> Te;
        }
        return te;
      }
      l.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var te = 0, ae = 0; ae < this.length; ae++) {
          var v = this._zeroBits(this.words[ae]);
          if (te += v, v !== 26)
            break;
        }
        return te;
      }, l.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, l.prototype.toTwos = function(te) {
        return this.negative !== 0 ? this.abs().inotn(te).iaddn(1) : this.clone();
      }, l.prototype.fromTwos = function(te) {
        return this.testn(te - 1) ? this.notn(te).iaddn(1).ineg() : this.clone();
      }, l.prototype.isNeg = function() {
        return this.negative !== 0;
      }, l.prototype.neg = function() {
        return this.clone().ineg();
      }, l.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, l.prototype.iuor = function(te) {
        for (; this.length < te.length; )
          this.words[this.length++] = 0;
        for (var ae = 0; ae < te.length; ae++)
          this.words[ae] = this.words[ae] | te.words[ae];
        return this.strip();
      }, l.prototype.ior = function(te) {
        return o((this.negative | te.negative) === 0), this.iuor(te);
      }, l.prototype.or = function(te) {
        return this.length > te.length ? this.clone().ior(te) : te.clone().ior(this);
      }, l.prototype.uor = function(te) {
        return this.length > te.length ? this.clone().iuor(te) : te.clone().iuor(this);
      }, l.prototype.iuand = function(te) {
        var ae;
        this.length > te.length ? ae = te : ae = this;
        for (var v = 0; v < ae.length; v++)
          this.words[v] = this.words[v] & te.words[v];
        return this.length = ae.length, this.strip();
      }, l.prototype.iand = function(te) {
        return o((this.negative | te.negative) === 0), this.iuand(te);
      }, l.prototype.and = function(te) {
        return this.length > te.length ? this.clone().iand(te) : te.clone().iand(this);
      }, l.prototype.uand = function(te) {
        return this.length > te.length ? this.clone().iuand(te) : te.clone().iuand(this);
      }, l.prototype.iuxor = function(te) {
        var ae, v;
        this.length > te.length ? (ae = this, v = te) : (ae = te, v = this);
        for (var Te = 0; Te < v.length; Te++)
          this.words[Te] = ae.words[Te] ^ v.words[Te];
        if (this !== ae)
          for (; Te < ae.length; Te++)
            this.words[Te] = ae.words[Te];
        return this.length = ae.length, this.strip();
      }, l.prototype.ixor = function(te) {
        return o((this.negative | te.negative) === 0), this.iuxor(te);
      }, l.prototype.xor = function(te) {
        return this.length > te.length ? this.clone().ixor(te) : te.clone().ixor(this);
      }, l.prototype.uxor = function(te) {
        return this.length > te.length ? this.clone().iuxor(te) : te.clone().iuxor(this);
      }, l.prototype.inotn = function(te) {
        o(typeof te == "number" && te >= 0);
        var ae = Math.ceil(te / 26) | 0, v = te % 26;
        this._expand(ae), v > 0 && ae--;
        for (var Te = 0; Te < ae; Te++)
          this.words[Te] = ~this.words[Te] & 67108863;
        return v > 0 && (this.words[Te] = ~this.words[Te] & 67108863 >> 26 - v), this.strip();
      }, l.prototype.notn = function(te) {
        return this.clone().inotn(te);
      }, l.prototype.setn = function(te, ae) {
        o(typeof te == "number" && te >= 0);
        var v = te / 26 | 0, Te = te % 26;
        return this._expand(v + 1), ae ? this.words[v] = this.words[v] | 1 << Te : this.words[v] = this.words[v] & ~(1 << Te), this.strip();
      }, l.prototype.iadd = function(te) {
        var ae;
        if (this.negative !== 0 && te.negative === 0)
          return this.negative = 0, ae = this.isub(te), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && te.negative !== 0)
          return te.negative = 0, ae = this.isub(te), te.negative = 1, ae._normSign();
        var v, Te;
        this.length > te.length ? (v = this, Te = te) : (v = te, Te = this);
        for (var De = 0, be = 0; be < Te.length; be++)
          ae = (v.words[be] | 0) + (Te.words[be] | 0) + De, this.words[be] = ae & 67108863, De = ae >>> 26;
        for (; De !== 0 && be < v.length; be++)
          ae = (v.words[be] | 0) + De, this.words[be] = ae & 67108863, De = ae >>> 26;
        if (this.length = v.length, De !== 0)
          this.words[this.length] = De, this.length++;
        else if (v !== this)
          for (; be < v.length; be++)
            this.words[be] = v.words[be];
        return this;
      }, l.prototype.add = function(te) {
        var ae;
        return te.negative !== 0 && this.negative === 0 ? (te.negative = 0, ae = this.sub(te), te.negative ^= 1, ae) : te.negative === 0 && this.negative !== 0 ? (this.negative = 0, ae = te.sub(this), this.negative = 1, ae) : this.length > te.length ? this.clone().iadd(te) : te.clone().iadd(this);
      }, l.prototype.isub = function(te) {
        if (te.negative !== 0) {
          te.negative = 0;
          var ae = this.iadd(te);
          return te.negative = 1, ae._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(te), this.negative = 1, this._normSign();
        var v = this.cmp(te);
        if (v === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var Te, De;
        v > 0 ? (Te = this, De = te) : (Te = te, De = this);
        for (var be = 0, ze = 0; ze < De.length; ze++)
          ae = (Te.words[ze] | 0) - (De.words[ze] | 0) + be, be = ae >> 26, this.words[ze] = ae & 67108863;
        for (; be !== 0 && ze < Te.length; ze++)
          ae = (Te.words[ze] | 0) + be, be = ae >> 26, this.words[ze] = ae & 67108863;
        if (be === 0 && ze < Te.length && Te !== this)
          for (; ze < Te.length; ze++)
            this.words[ze] = Te.words[ze];
        return this.length = Math.max(this.length, ze), Te !== this && (this.negative = 1), this.strip();
      }, l.prototype.sub = function(te) {
        return this.clone().isub(te);
      };
      function _(ve, te, ae) {
        ae.negative = te.negative ^ ve.negative;
        var v = ve.length + te.length | 0;
        ae.length = v, v = v - 1 | 0;
        var Te = ve.words[0] | 0, De = te.words[0] | 0, be = Te * De, ze = be & 67108863, ke = be / 67108864 | 0;
        ae.words[0] = ze;
        for (var Be = 1; Be < v; Be++) {
          for (var Me = ke >>> 26, me = ke & 67108863, Se = Math.min(Be, te.length - 1), xt = Math.max(0, Be - ve.length + 1); xt <= Se; xt++) {
            var Ht = Be - xt | 0;
            Te = ve.words[Ht] | 0, De = te.words[xt] | 0, be = Te * De + me, Me += be / 67108864 | 0, me = be & 67108863;
          }
          ae.words[Be] = me | 0, ke = Me | 0;
        }
        return ke !== 0 ? ae.words[Be] = ke | 0 : ae.length--, ae.strip();
      }
      var m = function(te, ae, v) {
        var Te = te.words, De = ae.words, be = v.words, ze = 0, ke, Be, Me, me = Te[0] | 0, Se = me & 8191, xt = me >>> 13, Ht = Te[1] | 0, Bt = Ht & 8191, ut = Ht >>> 13, Tt = Te[2] | 0, Yt = Tt & 8191, an = Tt >>> 13, Ct = Te[3] | 0, st = Ct & 8191, jt = Ct >>> 13, lt = Te[4] | 0, Zt = lt & 8191, Et = lt >>> 13, Ke = Te[5] | 0, $e = Ke & 8191, pt = Ke >>> 13, Jt = Te[6] | 0, In = Jt & 8191, Cn = Jt >>> 13, It = Te[7] | 0, ht = It & 8191, Wt = It >>> 13, hn = Te[8] | 0, Vt = hn & 8191, Tn = hn >>> 13, Rn = Te[9] | 0, Nn = Rn & 8191, Dn = Rn >>> 13, xn = De[0] | 0, $n = xn & 8191, Kn = xn >>> 13, ir = De[1] | 0, er = ir & 8191, br = ir >>> 13, cs = De[2] | 0, Gn = cs & 8191, Jn = cs >>> 13, Xn = De[3] | 0, rr = Xn & 8191, _r = Xn >>> 13, Ss = De[4] | 0, is = Ss & 8191, Ms = Ss >>> 13, ls = De[5] | 0, Ur = ls & 8191, Qr = ls >>> 13, Fr = De[6] | 0, Lr = Fr & 8191, Hr = Fr >>> 13, ns = De[7] | 0, Ts = ns & 8191, en = ns >>> 13, to = De[8] | 0, bs = to & 8191, jn = to >>> 13, lr = De[9] | 0, pr = lr & 8191, En = lr >>> 13;
        v.negative = te.negative ^ ae.negative, v.length = 19, ke = Math.imul(Se, $n), Be = Math.imul(Se, Kn), Be = Be + Math.imul(xt, $n) | 0, Me = Math.imul(xt, Kn);
        var qn = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (qn >>> 26) | 0, qn &= 67108863, ke = Math.imul(Bt, $n), Be = Math.imul(Bt, Kn), Be = Be + Math.imul(ut, $n) | 0, Me = Math.imul(ut, Kn), ke = ke + Math.imul(Se, er) | 0, Be = Be + Math.imul(Se, br) | 0, Be = Be + Math.imul(xt, er) | 0, Me = Me + Math.imul(xt, br) | 0;
        var Wn = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Wn >>> 26) | 0, Wn &= 67108863, ke = Math.imul(Yt, $n), Be = Math.imul(Yt, Kn), Be = Be + Math.imul(an, $n) | 0, Me = Math.imul(an, Kn), ke = ke + Math.imul(Bt, er) | 0, Be = Be + Math.imul(Bt, br) | 0, Be = Be + Math.imul(ut, er) | 0, Me = Me + Math.imul(ut, br) | 0, ke = ke + Math.imul(Se, Gn) | 0, Be = Be + Math.imul(Se, Jn) | 0, Be = Be + Math.imul(xt, Gn) | 0, Me = Me + Math.imul(xt, Jn) | 0;
        var kn = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (kn >>> 26) | 0, kn &= 67108863, ke = Math.imul(st, $n), Be = Math.imul(st, Kn), Be = Be + Math.imul(jt, $n) | 0, Me = Math.imul(jt, Kn), ke = ke + Math.imul(Yt, er) | 0, Be = Be + Math.imul(Yt, br) | 0, Be = Be + Math.imul(an, er) | 0, Me = Me + Math.imul(an, br) | 0, ke = ke + Math.imul(Bt, Gn) | 0, Be = Be + Math.imul(Bt, Jn) | 0, Be = Be + Math.imul(ut, Gn) | 0, Me = Me + Math.imul(ut, Jn) | 0, ke = ke + Math.imul(Se, rr) | 0, Be = Be + Math.imul(Se, _r) | 0, Be = Be + Math.imul(xt, rr) | 0, Me = Me + Math.imul(xt, _r) | 0;
        var zn = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, ke = Math.imul(Zt, $n), Be = Math.imul(Zt, Kn), Be = Be + Math.imul(Et, $n) | 0, Me = Math.imul(Et, Kn), ke = ke + Math.imul(st, er) | 0, Be = Be + Math.imul(st, br) | 0, Be = Be + Math.imul(jt, er) | 0, Me = Me + Math.imul(jt, br) | 0, ke = ke + Math.imul(Yt, Gn) | 0, Be = Be + Math.imul(Yt, Jn) | 0, Be = Be + Math.imul(an, Gn) | 0, Me = Me + Math.imul(an, Jn) | 0, ke = ke + Math.imul(Bt, rr) | 0, Be = Be + Math.imul(Bt, _r) | 0, Be = Be + Math.imul(ut, rr) | 0, Me = Me + Math.imul(ut, _r) | 0, ke = ke + Math.imul(Se, is) | 0, Be = Be + Math.imul(Se, Ms) | 0, Be = Be + Math.imul(xt, is) | 0, Me = Me + Math.imul(xt, Ms) | 0;
        var wr = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, ke = Math.imul($e, $n), Be = Math.imul($e, Kn), Be = Be + Math.imul(pt, $n) | 0, Me = Math.imul(pt, Kn), ke = ke + Math.imul(Zt, er) | 0, Be = Be + Math.imul(Zt, br) | 0, Be = Be + Math.imul(Et, er) | 0, Me = Me + Math.imul(Et, br) | 0, ke = ke + Math.imul(st, Gn) | 0, Be = Be + Math.imul(st, Jn) | 0, Be = Be + Math.imul(jt, Gn) | 0, Me = Me + Math.imul(jt, Jn) | 0, ke = ke + Math.imul(Yt, rr) | 0, Be = Be + Math.imul(Yt, _r) | 0, Be = Be + Math.imul(an, rr) | 0, Me = Me + Math.imul(an, _r) | 0, ke = ke + Math.imul(Bt, is) | 0, Be = Be + Math.imul(Bt, Ms) | 0, Be = Be + Math.imul(ut, is) | 0, Me = Me + Math.imul(ut, Ms) | 0, ke = ke + Math.imul(Se, Ur) | 0, Be = Be + Math.imul(Se, Qr) | 0, Be = Be + Math.imul(xt, Ur) | 0, Me = Me + Math.imul(xt, Qr) | 0;
        var jr = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (jr >>> 26) | 0, jr &= 67108863, ke = Math.imul(In, $n), Be = Math.imul(In, Kn), Be = Be + Math.imul(Cn, $n) | 0, Me = Math.imul(Cn, Kn), ke = ke + Math.imul($e, er) | 0, Be = Be + Math.imul($e, br) | 0, Be = Be + Math.imul(pt, er) | 0, Me = Me + Math.imul(pt, br) | 0, ke = ke + Math.imul(Zt, Gn) | 0, Be = Be + Math.imul(Zt, Jn) | 0, Be = Be + Math.imul(Et, Gn) | 0, Me = Me + Math.imul(Et, Jn) | 0, ke = ke + Math.imul(st, rr) | 0, Be = Be + Math.imul(st, _r) | 0, Be = Be + Math.imul(jt, rr) | 0, Me = Me + Math.imul(jt, _r) | 0, ke = ke + Math.imul(Yt, is) | 0, Be = Be + Math.imul(Yt, Ms) | 0, Be = Be + Math.imul(an, is) | 0, Me = Me + Math.imul(an, Ms) | 0, ke = ke + Math.imul(Bt, Ur) | 0, Be = Be + Math.imul(Bt, Qr) | 0, Be = Be + Math.imul(ut, Ur) | 0, Me = Me + Math.imul(ut, Qr) | 0, ke = ke + Math.imul(Se, Lr) | 0, Be = Be + Math.imul(Se, Hr) | 0, Be = Be + Math.imul(xt, Lr) | 0, Me = Me + Math.imul(xt, Hr) | 0;
        var Vr = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, ke = Math.imul(ht, $n), Be = Math.imul(ht, Kn), Be = Be + Math.imul(Wt, $n) | 0, Me = Math.imul(Wt, Kn), ke = ke + Math.imul(In, er) | 0, Be = Be + Math.imul(In, br) | 0, Be = Be + Math.imul(Cn, er) | 0, Me = Me + Math.imul(Cn, br) | 0, ke = ke + Math.imul($e, Gn) | 0, Be = Be + Math.imul($e, Jn) | 0, Be = Be + Math.imul(pt, Gn) | 0, Me = Me + Math.imul(pt, Jn) | 0, ke = ke + Math.imul(Zt, rr) | 0, Be = Be + Math.imul(Zt, _r) | 0, Be = Be + Math.imul(Et, rr) | 0, Me = Me + Math.imul(Et, _r) | 0, ke = ke + Math.imul(st, is) | 0, Be = Be + Math.imul(st, Ms) | 0, Be = Be + Math.imul(jt, is) | 0, Me = Me + Math.imul(jt, Ms) | 0, ke = ke + Math.imul(Yt, Ur) | 0, Be = Be + Math.imul(Yt, Qr) | 0, Be = Be + Math.imul(an, Ur) | 0, Me = Me + Math.imul(an, Qr) | 0, ke = ke + Math.imul(Bt, Lr) | 0, Be = Be + Math.imul(Bt, Hr) | 0, Be = Be + Math.imul(ut, Lr) | 0, Me = Me + Math.imul(ut, Hr) | 0, ke = ke + Math.imul(Se, Ts) | 0, Be = Be + Math.imul(Se, en) | 0, Be = Be + Math.imul(xt, Ts) | 0, Me = Me + Math.imul(xt, en) | 0;
        var us = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, ke = Math.imul(Vt, $n), Be = Math.imul(Vt, Kn), Be = Be + Math.imul(Tn, $n) | 0, Me = Math.imul(Tn, Kn), ke = ke + Math.imul(ht, er) | 0, Be = Be + Math.imul(ht, br) | 0, Be = Be + Math.imul(Wt, er) | 0, Me = Me + Math.imul(Wt, br) | 0, ke = ke + Math.imul(In, Gn) | 0, Be = Be + Math.imul(In, Jn) | 0, Be = Be + Math.imul(Cn, Gn) | 0, Me = Me + Math.imul(Cn, Jn) | 0, ke = ke + Math.imul($e, rr) | 0, Be = Be + Math.imul($e, _r) | 0, Be = Be + Math.imul(pt, rr) | 0, Me = Me + Math.imul(pt, _r) | 0, ke = ke + Math.imul(Zt, is) | 0, Be = Be + Math.imul(Zt, Ms) | 0, Be = Be + Math.imul(Et, is) | 0, Me = Me + Math.imul(Et, Ms) | 0, ke = ke + Math.imul(st, Ur) | 0, Be = Be + Math.imul(st, Qr) | 0, Be = Be + Math.imul(jt, Ur) | 0, Me = Me + Math.imul(jt, Qr) | 0, ke = ke + Math.imul(Yt, Lr) | 0, Be = Be + Math.imul(Yt, Hr) | 0, Be = Be + Math.imul(an, Lr) | 0, Me = Me + Math.imul(an, Hr) | 0, ke = ke + Math.imul(Bt, Ts) | 0, Be = Be + Math.imul(Bt, en) | 0, Be = Be + Math.imul(ut, Ts) | 0, Me = Me + Math.imul(ut, en) | 0, ke = ke + Math.imul(Se, bs) | 0, Be = Be + Math.imul(Se, jn) | 0, Be = Be + Math.imul(xt, bs) | 0, Me = Me + Math.imul(xt, jn) | 0;
        var Es = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Es >>> 26) | 0, Es &= 67108863, ke = Math.imul(Nn, $n), Be = Math.imul(Nn, Kn), Be = Be + Math.imul(Dn, $n) | 0, Me = Math.imul(Dn, Kn), ke = ke + Math.imul(Vt, er) | 0, Be = Be + Math.imul(Vt, br) | 0, Be = Be + Math.imul(Tn, er) | 0, Me = Me + Math.imul(Tn, br) | 0, ke = ke + Math.imul(ht, Gn) | 0, Be = Be + Math.imul(ht, Jn) | 0, Be = Be + Math.imul(Wt, Gn) | 0, Me = Me + Math.imul(Wt, Jn) | 0, ke = ke + Math.imul(In, rr) | 0, Be = Be + Math.imul(In, _r) | 0, Be = Be + Math.imul(Cn, rr) | 0, Me = Me + Math.imul(Cn, _r) | 0, ke = ke + Math.imul($e, is) | 0, Be = Be + Math.imul($e, Ms) | 0, Be = Be + Math.imul(pt, is) | 0, Me = Me + Math.imul(pt, Ms) | 0, ke = ke + Math.imul(Zt, Ur) | 0, Be = Be + Math.imul(Zt, Qr) | 0, Be = Be + Math.imul(Et, Ur) | 0, Me = Me + Math.imul(Et, Qr) | 0, ke = ke + Math.imul(st, Lr) | 0, Be = Be + Math.imul(st, Hr) | 0, Be = Be + Math.imul(jt, Lr) | 0, Me = Me + Math.imul(jt, Hr) | 0, ke = ke + Math.imul(Yt, Ts) | 0, Be = Be + Math.imul(Yt, en) | 0, Be = Be + Math.imul(an, Ts) | 0, Me = Me + Math.imul(an, en) | 0, ke = ke + Math.imul(Bt, bs) | 0, Be = Be + Math.imul(Bt, jn) | 0, Be = Be + Math.imul(ut, bs) | 0, Me = Me + Math.imul(ut, jn) | 0, ke = ke + Math.imul(Se, pr) | 0, Be = Be + Math.imul(Se, En) | 0, Be = Be + Math.imul(xt, pr) | 0, Me = Me + Math.imul(xt, En) | 0;
        var Dr = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, ke = Math.imul(Nn, er), Be = Math.imul(Nn, br), Be = Be + Math.imul(Dn, er) | 0, Me = Math.imul(Dn, br), ke = ke + Math.imul(Vt, Gn) | 0, Be = Be + Math.imul(Vt, Jn) | 0, Be = Be + Math.imul(Tn, Gn) | 0, Me = Me + Math.imul(Tn, Jn) | 0, ke = ke + Math.imul(ht, rr) | 0, Be = Be + Math.imul(ht, _r) | 0, Be = Be + Math.imul(Wt, rr) | 0, Me = Me + Math.imul(Wt, _r) | 0, ke = ke + Math.imul(In, is) | 0, Be = Be + Math.imul(In, Ms) | 0, Be = Be + Math.imul(Cn, is) | 0, Me = Me + Math.imul(Cn, Ms) | 0, ke = ke + Math.imul($e, Ur) | 0, Be = Be + Math.imul($e, Qr) | 0, Be = Be + Math.imul(pt, Ur) | 0, Me = Me + Math.imul(pt, Qr) | 0, ke = ke + Math.imul(Zt, Lr) | 0, Be = Be + Math.imul(Zt, Hr) | 0, Be = Be + Math.imul(Et, Lr) | 0, Me = Me + Math.imul(Et, Hr) | 0, ke = ke + Math.imul(st, Ts) | 0, Be = Be + Math.imul(st, en) | 0, Be = Be + Math.imul(jt, Ts) | 0, Me = Me + Math.imul(jt, en) | 0, ke = ke + Math.imul(Yt, bs) | 0, Be = Be + Math.imul(Yt, jn) | 0, Be = Be + Math.imul(an, bs) | 0, Me = Me + Math.imul(an, jn) | 0, ke = ke + Math.imul(Bt, pr) | 0, Be = Be + Math.imul(Bt, En) | 0, Be = Be + Math.imul(ut, pr) | 0, Me = Me + Math.imul(ut, En) | 0;
        var Kr = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Kr >>> 26) | 0, Kr &= 67108863, ke = Math.imul(Nn, Gn), Be = Math.imul(Nn, Jn), Be = Be + Math.imul(Dn, Gn) | 0, Me = Math.imul(Dn, Jn), ke = ke + Math.imul(Vt, rr) | 0, Be = Be + Math.imul(Vt, _r) | 0, Be = Be + Math.imul(Tn, rr) | 0, Me = Me + Math.imul(Tn, _r) | 0, ke = ke + Math.imul(ht, is) | 0, Be = Be + Math.imul(ht, Ms) | 0, Be = Be + Math.imul(Wt, is) | 0, Me = Me + Math.imul(Wt, Ms) | 0, ke = ke + Math.imul(In, Ur) | 0, Be = Be + Math.imul(In, Qr) | 0, Be = Be + Math.imul(Cn, Ur) | 0, Me = Me + Math.imul(Cn, Qr) | 0, ke = ke + Math.imul($e, Lr) | 0, Be = Be + Math.imul($e, Hr) | 0, Be = Be + Math.imul(pt, Lr) | 0, Me = Me + Math.imul(pt, Hr) | 0, ke = ke + Math.imul(Zt, Ts) | 0, Be = Be + Math.imul(Zt, en) | 0, Be = Be + Math.imul(Et, Ts) | 0, Me = Me + Math.imul(Et, en) | 0, ke = ke + Math.imul(st, bs) | 0, Be = Be + Math.imul(st, jn) | 0, Be = Be + Math.imul(jt, bs) | 0, Me = Me + Math.imul(jt, jn) | 0, ke = ke + Math.imul(Yt, pr) | 0, Be = Be + Math.imul(Yt, En) | 0, Be = Be + Math.imul(an, pr) | 0, Me = Me + Math.imul(an, En) | 0;
        var Js = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Js >>> 26) | 0, Js &= 67108863, ke = Math.imul(Nn, rr), Be = Math.imul(Nn, _r), Be = Be + Math.imul(Dn, rr) | 0, Me = Math.imul(Dn, _r), ke = ke + Math.imul(Vt, is) | 0, Be = Be + Math.imul(Vt, Ms) | 0, Be = Be + Math.imul(Tn, is) | 0, Me = Me + Math.imul(Tn, Ms) | 0, ke = ke + Math.imul(ht, Ur) | 0, Be = Be + Math.imul(ht, Qr) | 0, Be = Be + Math.imul(Wt, Ur) | 0, Me = Me + Math.imul(Wt, Qr) | 0, ke = ke + Math.imul(In, Lr) | 0, Be = Be + Math.imul(In, Hr) | 0, Be = Be + Math.imul(Cn, Lr) | 0, Me = Me + Math.imul(Cn, Hr) | 0, ke = ke + Math.imul($e, Ts) | 0, Be = Be + Math.imul($e, en) | 0, Be = Be + Math.imul(pt, Ts) | 0, Me = Me + Math.imul(pt, en) | 0, ke = ke + Math.imul(Zt, bs) | 0, Be = Be + Math.imul(Zt, jn) | 0, Be = Be + Math.imul(Et, bs) | 0, Me = Me + Math.imul(Et, jn) | 0, ke = ke + Math.imul(st, pr) | 0, Be = Be + Math.imul(st, En) | 0, Be = Be + Math.imul(jt, pr) | 0, Me = Me + Math.imul(jt, En) | 0;
        var io = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (io >>> 26) | 0, io &= 67108863, ke = Math.imul(Nn, is), Be = Math.imul(Nn, Ms), Be = Be + Math.imul(Dn, is) | 0, Me = Math.imul(Dn, Ms), ke = ke + Math.imul(Vt, Ur) | 0, Be = Be + Math.imul(Vt, Qr) | 0, Be = Be + Math.imul(Tn, Ur) | 0, Me = Me + Math.imul(Tn, Qr) | 0, ke = ke + Math.imul(ht, Lr) | 0, Be = Be + Math.imul(ht, Hr) | 0, Be = Be + Math.imul(Wt, Lr) | 0, Me = Me + Math.imul(Wt, Hr) | 0, ke = ke + Math.imul(In, Ts) | 0, Be = Be + Math.imul(In, en) | 0, Be = Be + Math.imul(Cn, Ts) | 0, Me = Me + Math.imul(Cn, en) | 0, ke = ke + Math.imul($e, bs) | 0, Be = Be + Math.imul($e, jn) | 0, Be = Be + Math.imul(pt, bs) | 0, Me = Me + Math.imul(pt, jn) | 0, ke = ke + Math.imul(Zt, pr) | 0, Be = Be + Math.imul(Zt, En) | 0, Be = Be + Math.imul(Et, pr) | 0, Me = Me + Math.imul(Et, En) | 0;
        var No = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, ke = Math.imul(Nn, Ur), Be = Math.imul(Nn, Qr), Be = Be + Math.imul(Dn, Ur) | 0, Me = Math.imul(Dn, Qr), ke = ke + Math.imul(Vt, Lr) | 0, Be = Be + Math.imul(Vt, Hr) | 0, Be = Be + Math.imul(Tn, Lr) | 0, Me = Me + Math.imul(Tn, Hr) | 0, ke = ke + Math.imul(ht, Ts) | 0, Be = Be + Math.imul(ht, en) | 0, Be = Be + Math.imul(Wt, Ts) | 0, Me = Me + Math.imul(Wt, en) | 0, ke = ke + Math.imul(In, bs) | 0, Be = Be + Math.imul(In, jn) | 0, Be = Be + Math.imul(Cn, bs) | 0, Me = Me + Math.imul(Cn, jn) | 0, ke = ke + Math.imul($e, pr) | 0, Be = Be + Math.imul($e, En) | 0, Be = Be + Math.imul(pt, pr) | 0, Me = Me + Math.imul(pt, En) | 0;
        var Ai = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, ke = Math.imul(Nn, Lr), Be = Math.imul(Nn, Hr), Be = Be + Math.imul(Dn, Lr) | 0, Me = Math.imul(Dn, Hr), ke = ke + Math.imul(Vt, Ts) | 0, Be = Be + Math.imul(Vt, en) | 0, Be = Be + Math.imul(Tn, Ts) | 0, Me = Me + Math.imul(Tn, en) | 0, ke = ke + Math.imul(ht, bs) | 0, Be = Be + Math.imul(ht, jn) | 0, Be = Be + Math.imul(Wt, bs) | 0, Me = Me + Math.imul(Wt, jn) | 0, ke = ke + Math.imul(In, pr) | 0, Be = Be + Math.imul(In, En) | 0, Be = Be + Math.imul(Cn, pr) | 0, Me = Me + Math.imul(Cn, En) | 0;
        var go = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (go >>> 26) | 0, go &= 67108863, ke = Math.imul(Nn, Ts), Be = Math.imul(Nn, en), Be = Be + Math.imul(Dn, Ts) | 0, Me = Math.imul(Dn, en), ke = ke + Math.imul(Vt, bs) | 0, Be = Be + Math.imul(Vt, jn) | 0, Be = Be + Math.imul(Tn, bs) | 0, Me = Me + Math.imul(Tn, jn) | 0, ke = ke + Math.imul(ht, pr) | 0, Be = Be + Math.imul(ht, En) | 0, Be = Be + Math.imul(Wt, pr) | 0, Me = Me + Math.imul(Wt, En) | 0;
        var ks = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (ks >>> 26) | 0, ks &= 67108863, ke = Math.imul(Nn, bs), Be = Math.imul(Nn, jn), Be = Be + Math.imul(Dn, bs) | 0, Me = Math.imul(Dn, jn), ke = ke + Math.imul(Vt, pr) | 0, Be = Be + Math.imul(Vt, En) | 0, Be = Be + Math.imul(Tn, pr) | 0, Me = Me + Math.imul(Tn, En) | 0;
        var Ci = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        ze = (Me + (Be >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, ke = Math.imul(Nn, pr), Be = Math.imul(Nn, En), Be = Be + Math.imul(Dn, pr) | 0, Me = Math.imul(Dn, En);
        var Io = (ze + ke | 0) + ((Be & 8191) << 13) | 0;
        return ze = (Me + (Be >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, be[0] = qn, be[1] = Wn, be[2] = kn, be[3] = zn, be[4] = wr, be[5] = jr, be[6] = Vr, be[7] = us, be[8] = Es, be[9] = Dr, be[10] = Kr, be[11] = Js, be[12] = io, be[13] = No, be[14] = Ai, be[15] = go, be[16] = ks, be[17] = Ci, be[18] = Io, ze !== 0 && (be[19] = ze, v.length++), v;
      };
      Math.imul || (m = _);
      function L(ve, te, ae) {
        ae.negative = te.negative ^ ve.negative, ae.length = ve.length + te.length;
        for (var v = 0, Te = 0, De = 0; De < ae.length - 1; De++) {
          var be = Te;
          Te = 0;
          for (var ze = v & 67108863, ke = Math.min(De, te.length - 1), Be = Math.max(0, De - ve.length + 1); Be <= ke; Be++) {
            var Me = De - Be, me = ve.words[Me] | 0, Se = te.words[Be] | 0, xt = me * Se, Ht = xt & 67108863;
            be = be + (xt / 67108864 | 0) | 0, Ht = Ht + ze | 0, ze = Ht & 67108863, be = be + (Ht >>> 26) | 0, Te += be >>> 26, be &= 67108863;
          }
          ae.words[De] = ze, v = be, be = Te;
        }
        return v !== 0 ? ae.words[De] = v : ae.length--, ae.strip();
      }
      function F(ve, te, ae) {
        var v = new W();
        return v.mulp(ve, te, ae);
      }
      l.prototype.mulTo = function(te, ae) {
        var v, Te = this.length + te.length;
        return this.length === 10 && te.length === 10 ? v = m(this, te, ae) : Te < 63 ? v = _(this, te, ae) : Te < 1024 ? v = L(this, te, ae) : v = F(this, te, ae), v;
      };
      function W(ve, te) {
        this.x = ve, this.y = te;
      }
      W.prototype.makeRBT = function(te) {
        for (var ae = new Array(te), v = l.prototype._countBits(te) - 1, Te = 0; Te < te; Te++)
          ae[Te] = this.revBin(Te, v, te);
        return ae;
      }, W.prototype.revBin = function(te, ae, v) {
        if (te === 0 || te === v - 1)
          return te;
        for (var Te = 0, De = 0; De < ae; De++)
          Te |= (te & 1) << ae - De - 1, te >>= 1;
        return Te;
      }, W.prototype.permute = function(te, ae, v, Te, De, be) {
        for (var ze = 0; ze < be; ze++)
          Te[ze] = ae[te[ze]], De[ze] = v[te[ze]];
      }, W.prototype.transform = function(te, ae, v, Te, De, be) {
        this.permute(be, te, ae, v, Te, De);
        for (var ze = 1; ze < De; ze <<= 1)
          for (var ke = ze << 1, Be = Math.cos(2 * Math.PI / ke), Me = Math.sin(2 * Math.PI / ke), me = 0; me < De; me += ke)
            for (var Se = Be, xt = Me, Ht = 0; Ht < ze; Ht++) {
              var Bt = v[me + Ht], ut = Te[me + Ht], Tt = v[me + Ht + ze], Yt = Te[me + Ht + ze], an = Se * Tt - xt * Yt;
              Yt = Se * Yt + xt * Tt, Tt = an, v[me + Ht] = Bt + Tt, Te[me + Ht] = ut + Yt, v[me + Ht + ze] = Bt - Tt, Te[me + Ht + ze] = ut - Yt, Ht !== ke && (an = Be * Se - Me * xt, xt = Be * xt + Me * Se, Se = an);
            }
      }, W.prototype.guessLen13b = function(te, ae) {
        var v = Math.max(ae, te) | 1, Te = v & 1, De = 0;
        for (v = v / 2 | 0; v; v = v >>> 1)
          De++;
        return 1 << De + 1 + Te;
      }, W.prototype.conjugate = function(te, ae, v) {
        if (!(v <= 1))
          for (var Te = 0; Te < v / 2; Te++) {
            var De = te[Te];
            te[Te] = te[v - Te - 1], te[v - Te - 1] = De, De = ae[Te], ae[Te] = -ae[v - Te - 1], ae[v - Te - 1] = -De;
          }
      }, W.prototype.normalize13b = function(te, ae) {
        for (var v = 0, Te = 0; Te < ae / 2; Te++) {
          var De = Math.round(te[2 * Te + 1] / ae) * 8192 + Math.round(te[2 * Te] / ae) + v;
          te[Te] = De & 67108863, De < 67108864 ? v = 0 : v = De / 67108864 | 0;
        }
        return te;
      }, W.prototype.convert13b = function(te, ae, v, Te) {
        for (var De = 0, be = 0; be < ae; be++)
          De = De + (te[be] | 0), v[2 * be] = De & 8191, De = De >>> 13, v[2 * be + 1] = De & 8191, De = De >>> 13;
        for (be = 2 * ae; be < Te; ++be)
          v[be] = 0;
        o(De === 0), o((De & -8192) === 0);
      }, W.prototype.stub = function(te) {
        for (var ae = new Array(te), v = 0; v < te; v++)
          ae[v] = 0;
        return ae;
      }, W.prototype.mulp = function(te, ae, v) {
        var Te = 2 * this.guessLen13b(te.length, ae.length), De = this.makeRBT(Te), be = this.stub(Te), ze = new Array(Te), ke = new Array(Te), Be = new Array(Te), Me = new Array(Te), me = new Array(Te), Se = new Array(Te), xt = v.words;
        xt.length = Te, this.convert13b(te.words, te.length, ze, Te), this.convert13b(ae.words, ae.length, Me, Te), this.transform(ze, be, ke, Be, Te, De), this.transform(Me, be, me, Se, Te, De);
        for (var Ht = 0; Ht < Te; Ht++) {
          var Bt = ke[Ht] * me[Ht] - Be[Ht] * Se[Ht];
          Be[Ht] = ke[Ht] * Se[Ht] + Be[Ht] * me[Ht], ke[Ht] = Bt;
        }
        return this.conjugate(ke, Be, Te), this.transform(ke, Be, xt, be, Te, De), this.conjugate(xt, be, Te), this.normalize13b(xt, Te), v.negative = te.negative ^ ae.negative, v.length = te.length + ae.length, v.strip();
      }, l.prototype.mul = function(te) {
        var ae = new l(null);
        return ae.words = new Array(this.length + te.length), this.mulTo(te, ae);
      }, l.prototype.mulf = function(te) {
        var ae = new l(null);
        return ae.words = new Array(this.length + te.length), F(this, te, ae);
      }, l.prototype.imul = function(te) {
        return this.clone().mulTo(te, this);
      }, l.prototype.imuln = function(te) {
        o(typeof te == "number"), o(te < 67108864);
        for (var ae = 0, v = 0; v < this.length; v++) {
          var Te = (this.words[v] | 0) * te, De = (Te & 67108863) + (ae & 67108863);
          ae >>= 26, ae += Te / 67108864 | 0, ae += De >>> 26, this.words[v] = De & 67108863;
        }
        return ae !== 0 && (this.words[v] = ae, this.length++), this.length = te === 0 ? 1 : this.length, this;
      }, l.prototype.muln = function(te) {
        return this.clone().imuln(te);
      }, l.prototype.sqr = function() {
        return this.mul(this);
      }, l.prototype.isqr = function() {
        return this.imul(this.clone());
      }, l.prototype.pow = function(te) {
        var ae = R(te);
        if (ae.length === 0)
          return new l(1);
        for (var v = this, Te = 0; Te < ae.length && ae[Te] === 0; Te++, v = v.sqr())
          ;
        if (++Te < ae.length)
          for (var De = v.sqr(); Te < ae.length; Te++, De = De.sqr())
            ae[Te] !== 0 && (v = v.mul(De));
        return v;
      }, l.prototype.iushln = function(te) {
        o(typeof te == "number" && te >= 0);
        var ae = te % 26, v = (te - ae) / 26, Te = 67108863 >>> 26 - ae << 26 - ae, De;
        if (ae !== 0) {
          var be = 0;
          for (De = 0; De < this.length; De++) {
            var ze = this.words[De] & Te, ke = (this.words[De] | 0) - ze << ae;
            this.words[De] = ke | be, be = ze >>> 26 - ae;
          }
          be && (this.words[De] = be, this.length++);
        }
        if (v !== 0) {
          for (De = this.length - 1; De >= 0; De--)
            this.words[De + v] = this.words[De];
          for (De = 0; De < v; De++)
            this.words[De] = 0;
          this.length += v;
        }
        return this.strip();
      }, l.prototype.ishln = function(te) {
        return o(this.negative === 0), this.iushln(te);
      }, l.prototype.iushrn = function(te, ae, v) {
        o(typeof te == "number" && te >= 0);
        var Te;
        ae ? Te = (ae - ae % 26) / 26 : Te = 0;
        var De = te % 26, be = Math.min((te - De) / 26, this.length), ze = 67108863 ^ 67108863 >>> De << De, ke = v;
        if (Te -= be, Te = Math.max(0, Te), ke) {
          for (var Be = 0; Be < be; Be++)
            ke.words[Be] = this.words[Be];
          ke.length = be;
        }
        if (be !== 0)
          if (this.length > be)
            for (this.length -= be, Be = 0; Be < this.length; Be++)
              this.words[Be] = this.words[Be + be];
          else
            this.words[0] = 0, this.length = 1;
        var Me = 0;
        for (Be = this.length - 1; Be >= 0 && (Me !== 0 || Be >= Te); Be--) {
          var me = this.words[Be] | 0;
          this.words[Be] = Me << 26 - De | me >>> De, Me = me & ze;
        }
        return ke && Me !== 0 && (ke.words[ke.length++] = Me), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, l.prototype.ishrn = function(te, ae, v) {
        return o(this.negative === 0), this.iushrn(te, ae, v);
      }, l.prototype.shln = function(te) {
        return this.clone().ishln(te);
      }, l.prototype.ushln = function(te) {
        return this.clone().iushln(te);
      }, l.prototype.shrn = function(te) {
        return this.clone().ishrn(te);
      }, l.prototype.ushrn = function(te) {
        return this.clone().iushrn(te);
      }, l.prototype.testn = function(te) {
        o(typeof te == "number" && te >= 0);
        var ae = te % 26, v = (te - ae) / 26, Te = 1 << ae;
        if (this.length <= v)
          return !1;
        var De = this.words[v];
        return !!(De & Te);
      }, l.prototype.imaskn = function(te) {
        o(typeof te == "number" && te >= 0);
        var ae = te % 26, v = (te - ae) / 26;
        if (o(this.negative === 0, "imaskn works only with positive numbers"), this.length <= v)
          return this;
        if (ae !== 0 && v++, this.length = Math.min(v, this.length), ae !== 0) {
          var Te = 67108863 ^ 67108863 >>> ae << ae;
          this.words[this.length - 1] &= Te;
        }
        return this.strip();
      }, l.prototype.maskn = function(te) {
        return this.clone().imaskn(te);
      }, l.prototype.iaddn = function(te) {
        return o(typeof te == "number"), o(te < 67108864), te < 0 ? this.isubn(-te) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < te ? (this.words[0] = te - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(te), this.negative = 1, this) : this._iaddn(te);
      }, l.prototype._iaddn = function(te) {
        this.words[0] += te;
        for (var ae = 0; ae < this.length && this.words[ae] >= 67108864; ae++)
          this.words[ae] -= 67108864, ae === this.length - 1 ? this.words[ae + 1] = 1 : this.words[ae + 1]++;
        return this.length = Math.max(this.length, ae + 1), this;
      }, l.prototype.isubn = function(te) {
        if (o(typeof te == "number"), o(te < 67108864), te < 0)
          return this.iaddn(-te);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(te), this.negative = 1, this;
        if (this.words[0] -= te, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var ae = 0; ae < this.length && this.words[ae] < 0; ae++)
            this.words[ae] += 67108864, this.words[ae + 1] -= 1;
        return this.strip();
      }, l.prototype.addn = function(te) {
        return this.clone().iaddn(te);
      }, l.prototype.subn = function(te) {
        return this.clone().isubn(te);
      }, l.prototype.iabs = function() {
        return this.negative = 0, this;
      }, l.prototype.abs = function() {
        return this.clone().iabs();
      }, l.prototype._ishlnsubmul = function(te, ae, v) {
        var Te = te.length + v, De;
        this._expand(Te);
        var be, ze = 0;
        for (De = 0; De < te.length; De++) {
          be = (this.words[De + v] | 0) + ze;
          var ke = (te.words[De] | 0) * ae;
          be -= ke & 67108863, ze = (be >> 26) - (ke / 67108864 | 0), this.words[De + v] = be & 67108863;
        }
        for (; De < this.length - v; De++)
          be = (this.words[De + v] | 0) + ze, ze = be >> 26, this.words[De + v] = be & 67108863;
        if (ze === 0)
          return this.strip();
        for (o(ze === -1), ze = 0, De = 0; De < this.length; De++)
          be = -(this.words[De] | 0) + ze, ze = be >> 26, this.words[De] = be & 67108863;
        return this.negative = 1, this.strip();
      }, l.prototype._wordDiv = function(te, ae) {
        var v = this.length - te.length, Te = this.clone(), De = te, be = De.words[De.length - 1] | 0, ze = this._countBits(be);
        v = 26 - ze, v !== 0 && (De = De.ushln(v), Te.iushln(v), be = De.words[De.length - 1] | 0);
        var ke = Te.length - De.length, Be;
        if (ae !== "mod") {
          Be = new l(null), Be.length = ke + 1, Be.words = new Array(Be.length);
          for (var Me = 0; Me < Be.length; Me++)
            Be.words[Me] = 0;
        }
        var me = Te.clone()._ishlnsubmul(De, 1, ke);
        me.negative === 0 && (Te = me, Be && (Be.words[ke] = 1));
        for (var Se = ke - 1; Se >= 0; Se--) {
          var xt = (Te.words[De.length + Se] | 0) * 67108864 + (Te.words[De.length + Se - 1] | 0);
          for (xt = Math.min(xt / be | 0, 67108863), Te._ishlnsubmul(De, xt, Se); Te.negative !== 0; )
            xt--, Te.negative = 0, Te._ishlnsubmul(De, 1, Se), Te.isZero() || (Te.negative ^= 1);
          Be && (Be.words[Se] = xt);
        }
        return Be && Be.strip(), Te.strip(), ae !== "div" && v !== 0 && Te.iushrn(v), {
          div: Be || null,
          mod: Te
        };
      }, l.prototype.divmod = function(te, ae, v) {
        if (o(!te.isZero()), this.isZero())
          return {
            div: new l(0),
            mod: new l(0)
          };
        var Te, De, be;
        return this.negative !== 0 && te.negative === 0 ? (be = this.neg().divmod(te, ae), ae !== "mod" && (Te = be.div.neg()), ae !== "div" && (De = be.mod.neg(), v && De.negative !== 0 && De.iadd(te)), {
          div: Te,
          mod: De
        }) : this.negative === 0 && te.negative !== 0 ? (be = this.divmod(te.neg(), ae), ae !== "mod" && (Te = be.div.neg()), {
          div: Te,
          mod: be.mod
        }) : this.negative & te.negative ? (be = this.neg().divmod(te.neg(), ae), ae !== "div" && (De = be.mod.neg(), v && De.negative !== 0 && De.isub(te)), {
          div: be.div,
          mod: De
        }) : te.length > this.length || this.cmp(te) < 0 ? {
          div: new l(0),
          mod: this
        } : te.length === 1 ? ae === "div" ? {
          div: this.divn(te.words[0]),
          mod: null
        } : ae === "mod" ? {
          div: null,
          mod: new l(this.modn(te.words[0]))
        } : {
          div: this.divn(te.words[0]),
          mod: new l(this.modn(te.words[0]))
        } : this._wordDiv(te, ae);
      }, l.prototype.div = function(te) {
        return this.divmod(te, "div", !1).div;
      }, l.prototype.mod = function(te) {
        return this.divmod(te, "mod", !1).mod;
      }, l.prototype.umod = function(te) {
        return this.divmod(te, "mod", !0).mod;
      }, l.prototype.divRound = function(te) {
        var ae = this.divmod(te);
        if (ae.mod.isZero())
          return ae.div;
        var v = ae.div.negative !== 0 ? ae.mod.isub(te) : ae.mod, Te = te.ushrn(1), De = te.andln(1), be = v.cmp(Te);
        return be < 0 || De === 1 && be === 0 ? ae.div : ae.div.negative !== 0 ? ae.div.isubn(1) : ae.div.iaddn(1);
      }, l.prototype.modn = function(te) {
        o(te <= 67108863);
        for (var ae = (1 << 26) % te, v = 0, Te = this.length - 1; Te >= 0; Te--)
          v = (ae * v + (this.words[Te] | 0)) % te;
        return v;
      }, l.prototype.idivn = function(te) {
        o(te <= 67108863);
        for (var ae = 0, v = this.length - 1; v >= 0; v--) {
          var Te = (this.words[v] | 0) + ae * 67108864;
          this.words[v] = Te / te | 0, ae = Te % te;
        }
        return this.strip();
      }, l.prototype.divn = function(te) {
        return this.clone().idivn(te);
      }, l.prototype.egcd = function(te) {
        o(te.negative === 0), o(!te.isZero());
        var ae = this, v = te.clone();
        ae.negative !== 0 ? ae = ae.umod(te) : ae = ae.clone();
        for (var Te = new l(1), De = new l(0), be = new l(0), ze = new l(1), ke = 0; ae.isEven() && v.isEven(); )
          ae.iushrn(1), v.iushrn(1), ++ke;
        for (var Be = v.clone(), Me = ae.clone(); !ae.isZero(); ) {
          for (var me = 0, Se = 1; !(ae.words[0] & Se) && me < 26; ++me, Se <<= 1)
            ;
          if (me > 0)
            for (ae.iushrn(me); me-- > 0; )
              (Te.isOdd() || De.isOdd()) && (Te.iadd(Be), De.isub(Me)), Te.iushrn(1), De.iushrn(1);
          for (var xt = 0, Ht = 1; !(v.words[0] & Ht) && xt < 26; ++xt, Ht <<= 1)
            ;
          if (xt > 0)
            for (v.iushrn(xt); xt-- > 0; )
              (be.isOdd() || ze.isOdd()) && (be.iadd(Be), ze.isub(Me)), be.iushrn(1), ze.iushrn(1);
          ae.cmp(v) >= 0 ? (ae.isub(v), Te.isub(be), De.isub(ze)) : (v.isub(ae), be.isub(Te), ze.isub(De));
        }
        return {
          a: be,
          b: ze,
          gcd: v.iushln(ke)
        };
      }, l.prototype._invmp = function(te) {
        o(te.negative === 0), o(!te.isZero());
        var ae = this, v = te.clone();
        ae.negative !== 0 ? ae = ae.umod(te) : ae = ae.clone();
        for (var Te = new l(1), De = new l(0), be = v.clone(); ae.cmpn(1) > 0 && v.cmpn(1) > 0; ) {
          for (var ze = 0, ke = 1; !(ae.words[0] & ke) && ze < 26; ++ze, ke <<= 1)
            ;
          if (ze > 0)
            for (ae.iushrn(ze); ze-- > 0; )
              Te.isOdd() && Te.iadd(be), Te.iushrn(1);
          for (var Be = 0, Me = 1; !(v.words[0] & Me) && Be < 26; ++Be, Me <<= 1)
            ;
          if (Be > 0)
            for (v.iushrn(Be); Be-- > 0; )
              De.isOdd() && De.iadd(be), De.iushrn(1);
          ae.cmp(v) >= 0 ? (ae.isub(v), Te.isub(De)) : (v.isub(ae), De.isub(Te));
        }
        var me;
        return ae.cmpn(1) === 0 ? me = Te : me = De, me.cmpn(0) < 0 && me.iadd(te), me;
      }, l.prototype.gcd = function(te) {
        if (this.isZero())
          return te.abs();
        if (te.isZero())
          return this.abs();
        var ae = this.clone(), v = te.clone();
        ae.negative = 0, v.negative = 0;
        for (var Te = 0; ae.isEven() && v.isEven(); Te++)
          ae.iushrn(1), v.iushrn(1);
        do {
          for (; ae.isEven(); )
            ae.iushrn(1);
          for (; v.isEven(); )
            v.iushrn(1);
          var De = ae.cmp(v);
          if (De < 0) {
            var be = ae;
            ae = v, v = be;
          } else if (De === 0 || v.cmpn(1) === 0)
            break;
          ae.isub(v);
        } while (!0);
        return v.iushln(Te);
      }, l.prototype.invm = function(te) {
        return this.egcd(te).a.umod(te);
      }, l.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, l.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, l.prototype.andln = function(te) {
        return this.words[0] & te;
      }, l.prototype.bincn = function(te) {
        o(typeof te == "number");
        var ae = te % 26, v = (te - ae) / 26, Te = 1 << ae;
        if (this.length <= v)
          return this._expand(v + 1), this.words[v] |= Te, this;
        for (var De = Te, be = v; De !== 0 && be < this.length; be++) {
          var ze = this.words[be] | 0;
          ze += De, De = ze >>> 26, ze &= 67108863, this.words[be] = ze;
        }
        return De !== 0 && (this.words[be] = De, this.length++), this;
      }, l.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, l.prototype.cmpn = function(te) {
        var ae = te < 0;
        if (this.negative !== 0 && !ae)
          return -1;
        if (this.negative === 0 && ae)
          return 1;
        this.strip();
        var v;
        if (this.length > 1)
          v = 1;
        else {
          ae && (te = -te), o(te <= 67108863, "Number is too big");
          var Te = this.words[0] | 0;
          v = Te === te ? 0 : Te < te ? -1 : 1;
        }
        return this.negative !== 0 ? -v | 0 : v;
      }, l.prototype.cmp = function(te) {
        if (this.negative !== 0 && te.negative === 0)
          return -1;
        if (this.negative === 0 && te.negative !== 0)
          return 1;
        var ae = this.ucmp(te);
        return this.negative !== 0 ? -ae | 0 : ae;
      }, l.prototype.ucmp = function(te) {
        if (this.length > te.length)
          return 1;
        if (this.length < te.length)
          return -1;
        for (var ae = 0, v = this.length - 1; v >= 0; v--) {
          var Te = this.words[v] | 0, De = te.words[v] | 0;
          if (Te !== De) {
            Te < De ? ae = -1 : Te > De && (ae = 1);
            break;
          }
        }
        return ae;
      }, l.prototype.gtn = function(te) {
        return this.cmpn(te) === 1;
      }, l.prototype.gt = function(te) {
        return this.cmp(te) === 1;
      }, l.prototype.gten = function(te) {
        return this.cmpn(te) >= 0;
      }, l.prototype.gte = function(te) {
        return this.cmp(te) >= 0;
      }, l.prototype.ltn = function(te) {
        return this.cmpn(te) === -1;
      }, l.prototype.lt = function(te) {
        return this.cmp(te) === -1;
      }, l.prototype.lten = function(te) {
        return this.cmpn(te) <= 0;
      }, l.prototype.lte = function(te) {
        return this.cmp(te) <= 0;
      }, l.prototype.eqn = function(te) {
        return this.cmpn(te) === 0;
      }, l.prototype.eq = function(te) {
        return this.cmp(te) === 0;
      }, l.red = function(te) {
        return new Ee(te);
      }, l.prototype.toRed = function(te) {
        return o(!this.red, "Already a number in reduction context"), o(this.negative === 0, "red works only with positives"), te.convertTo(this)._forceRed(te);
      }, l.prototype.fromRed = function() {
        return o(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, l.prototype._forceRed = function(te) {
        return this.red = te, this;
      }, l.prototype.forceRed = function(te) {
        return o(!this.red, "Already a number in reduction context"), this._forceRed(te);
      }, l.prototype.redAdd = function(te) {
        return o(this.red, "redAdd works only with red numbers"), this.red.add(this, te);
      }, l.prototype.redIAdd = function(te) {
        return o(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, te);
      }, l.prototype.redSub = function(te) {
        return o(this.red, "redSub works only with red numbers"), this.red.sub(this, te);
      }, l.prototype.redISub = function(te) {
        return o(this.red, "redISub works only with red numbers"), this.red.isub(this, te);
      }, l.prototype.redShl = function(te) {
        return o(this.red, "redShl works only with red numbers"), this.red.shl(this, te);
      }, l.prototype.redMul = function(te) {
        return o(this.red, "redMul works only with red numbers"), this.red._verify2(this, te), this.red.mul(this, te);
      }, l.prototype.redIMul = function(te) {
        return o(this.red, "redMul works only with red numbers"), this.red._verify2(this, te), this.red.imul(this, te);
      }, l.prototype.redSqr = function() {
        return o(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, l.prototype.redISqr = function() {
        return o(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, l.prototype.redSqrt = function() {
        return o(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, l.prototype.redInvm = function() {
        return o(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, l.prototype.redNeg = function() {
        return o(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, l.prototype.redPow = function(te) {
        return o(this.red && !te.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, te);
      };
      var G = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function q(ve, te) {
        this.name = ve, this.p = new l(te, 16), this.n = this.p.bitLength(), this.k = new l(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      q.prototype._tmp = function() {
        var te = new l(null);
        return te.words = new Array(Math.ceil(this.n / 13)), te;
      }, q.prototype.ireduce = function(te) {
        var ae = te, v;
        do
          this.split(ae, this.tmp), ae = this.imulK(ae), ae = ae.iadd(this.tmp), v = ae.bitLength();
        while (v > this.n);
        var Te = v < this.n ? -1 : ae.ucmp(this.p);
        return Te === 0 ? (ae.words[0] = 0, ae.length = 1) : Te > 0 ? ae.isub(this.p) : ae.strip !== void 0 ? ae.strip() : ae._strip(), ae;
      }, q.prototype.split = function(te, ae) {
        te.iushrn(this.n, 0, ae);
      }, q.prototype.imulK = function(te) {
        return te.imul(this.k);
      };
      function fe() {
        q.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(fe, q), fe.prototype.split = function(te, ae) {
        for (var v = 4194303, Te = Math.min(te.length, 9), De = 0; De < Te; De++)
          ae.words[De] = te.words[De];
        if (ae.length = Te, te.length <= 9) {
          te.words[0] = 0, te.length = 1;
          return;
        }
        var be = te.words[9];
        for (ae.words[ae.length++] = be & v, De = 10; De < te.length; De++) {
          var ze = te.words[De] | 0;
          te.words[De - 10] = (ze & v) << 4 | be >>> 22, be = ze;
        }
        be >>>= 22, te.words[De - 10] = be, be === 0 && te.length > 10 ? te.length -= 10 : te.length -= 9;
      }, fe.prototype.imulK = function(te) {
        te.words[te.length] = 0, te.words[te.length + 1] = 0, te.length += 2;
        for (var ae = 0, v = 0; v < te.length; v++) {
          var Te = te.words[v] | 0;
          ae += Te * 977, te.words[v] = ae & 67108863, ae = Te * 64 + (ae / 67108864 | 0);
        }
        return te.words[te.length - 1] === 0 && (te.length--, te.words[te.length - 1] === 0 && te.length--), te;
      };
      function _e() {
        q.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(_e, q);
      function Le() {
        q.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Le, q);
      function Fe() {
        q.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(Fe, q), Fe.prototype.imulK = function(te) {
        for (var ae = 0, v = 0; v < te.length; v++) {
          var Te = (te.words[v] | 0) * 19 + ae, De = Te & 67108863;
          Te >>>= 26, te.words[v] = De, ae = Te;
        }
        return ae !== 0 && (te.words[te.length++] = ae), te;
      }, l._prime = function(te) {
        if (G[te])
          return G[te];
        var ae;
        if (te === "k256")
          ae = new fe();
        else if (te === "p224")
          ae = new _e();
        else if (te === "p192")
          ae = new Le();
        else if (te === "p25519")
          ae = new Fe();
        else
          throw new Error("Unknown prime " + te);
        return G[te] = ae, ae;
      };
      function Ee(ve) {
        if (typeof ve == "string") {
          var te = l._prime(ve);
          this.m = te.p, this.prime = te;
        } else
          o(ve.gtn(1), "modulus must be greater than 1"), this.m = ve, this.prime = null;
      }
      Ee.prototype._verify1 = function(te) {
        o(te.negative === 0, "red works only with positives"), o(te.red, "red works only with red numbers");
      }, Ee.prototype._verify2 = function(te, ae) {
        o((te.negative | ae.negative) === 0, "red works only with positives"), o(
          te.red && te.red === ae.red,
          "red works only with red numbers"
        );
      }, Ee.prototype.imod = function(te) {
        return this.prime ? this.prime.ireduce(te)._forceRed(this) : te.umod(this.m)._forceRed(this);
      }, Ee.prototype.neg = function(te) {
        return te.isZero() ? te.clone() : this.m.sub(te)._forceRed(this);
      }, Ee.prototype.add = function(te, ae) {
        this._verify2(te, ae);
        var v = te.add(ae);
        return v.cmp(this.m) >= 0 && v.isub(this.m), v._forceRed(this);
      }, Ee.prototype.iadd = function(te, ae) {
        this._verify2(te, ae);
        var v = te.iadd(ae);
        return v.cmp(this.m) >= 0 && v.isub(this.m), v;
      }, Ee.prototype.sub = function(te, ae) {
        this._verify2(te, ae);
        var v = te.sub(ae);
        return v.cmpn(0) < 0 && v.iadd(this.m), v._forceRed(this);
      }, Ee.prototype.isub = function(te, ae) {
        this._verify2(te, ae);
        var v = te.isub(ae);
        return v.cmpn(0) < 0 && v.iadd(this.m), v;
      }, Ee.prototype.shl = function(te, ae) {
        return this._verify1(te), this.imod(te.ushln(ae));
      }, Ee.prototype.imul = function(te, ae) {
        return this._verify2(te, ae), this.imod(te.imul(ae));
      }, Ee.prototype.mul = function(te, ae) {
        return this._verify2(te, ae), this.imod(te.mul(ae));
      }, Ee.prototype.isqr = function(te) {
        return this.imul(te, te.clone());
      }, Ee.prototype.sqr = function(te) {
        return this.mul(te, te);
      }, Ee.prototype.sqrt = function(te) {
        if (te.isZero())
          return te.clone();
        var ae = this.m.andln(3);
        if (o(ae % 2 === 1), ae === 3) {
          var v = this.m.add(new l(1)).iushrn(2);
          return this.pow(te, v);
        }
        for (var Te = this.m.subn(1), De = 0; !Te.isZero() && Te.andln(1) === 0; )
          De++, Te.iushrn(1);
        o(!Te.isZero());
        var be = new l(1).toRed(this), ze = be.redNeg(), ke = this.m.subn(1).iushrn(1), Be = this.m.bitLength();
        for (Be = new l(2 * Be * Be).toRed(this); this.pow(Be, ke).cmp(ze) !== 0; )
          Be.redIAdd(ze);
        for (var Me = this.pow(Be, Te), me = this.pow(te, Te.addn(1).iushrn(1)), Se = this.pow(te, Te), xt = De; Se.cmp(be) !== 0; ) {
          for (var Ht = Se, Bt = 0; Ht.cmp(be) !== 0; Bt++)
            Ht = Ht.redSqr();
          o(Bt < xt);
          var ut = this.pow(Me, new l(1).iushln(xt - Bt - 1));
          me = me.redMul(ut), Me = ut.redSqr(), Se = Se.redMul(Me), xt = Bt;
        }
        return me;
      }, Ee.prototype.invm = function(te) {
        var ae = te._invmp(this.m);
        return ae.negative !== 0 ? (ae.negative = 0, this.imod(ae).redNeg()) : this.imod(ae);
      }, Ee.prototype.pow = function(te, ae) {
        if (ae.isZero())
          return new l(1).toRed(this);
        if (ae.cmpn(1) === 0)
          return te.clone();
        var v = 4, Te = new Array(1 << v);
        Te[0] = new l(1).toRed(this), Te[1] = te;
        for (var De = 2; De < Te.length; De++)
          Te[De] = this.mul(Te[De - 1], te);
        var be = Te[0], ze = 0, ke = 0, Be = ae.bitLength() % 26;
        for (Be === 0 && (Be = 26), De = ae.length - 1; De >= 0; De--) {
          for (var Me = ae.words[De], me = Be - 1; me >= 0; me--) {
            var Se = Me >> me & 1;
            if (be !== Te[0] && (be = this.sqr(be)), Se === 0 && ze === 0) {
              ke = 0;
              continue;
            }
            ze <<= 1, ze |= Se, ke++, !(ke !== v && (De !== 0 || me !== 0)) && (be = this.mul(be, Te[ze]), ke = 0, ze = 0);
          }
          Be = 26;
        }
        return be;
      }, Ee.prototype.convertTo = function(te) {
        var ae = te.umod(this.m);
        return ae === te ? ae.clone() : ae;
      }, Ee.prototype.convertFrom = function(te) {
        var ae = te.clone();
        return ae.red = null, ae;
      }, l.mont = function(te) {
        return new Ge(te);
      };
      function Ge(ve) {
        Ee.call(this, ve), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new l(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(Ge, Ee), Ge.prototype.convertTo = function(te) {
        return this.imod(te.ushln(this.shift));
      }, Ge.prototype.convertFrom = function(te) {
        var ae = this.imod(te.mul(this.rinv));
        return ae.red = null, ae;
      }, Ge.prototype.imul = function(te, ae) {
        if (te.isZero() || ae.isZero())
          return te.words[0] = 0, te.length = 1, te;
        var v = te.imul(ae), Te = v.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), De = v.isub(Te).iushrn(this.shift), be = De;
        return De.cmp(this.m) >= 0 ? be = De.isub(this.m) : De.cmpn(0) < 0 && (be = De.iadd(this.m)), be._forceRed(this);
      }, Ge.prototype.mul = function(te, ae) {
        if (te.isZero() || ae.isZero())
          return new l(0)._forceRed(this);
        var v = te.mul(ae), Te = v.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), De = v.isub(Te).iushrn(this.shift), be = De;
        return De.cmp(this.m) >= 0 ? be = De.isub(this.m) : De.cmpn(0) < 0 && (be = De.iadd(this.m)), be._forceRed(this);
      }, Ge.prototype.invm = function(te) {
        var ae = this.imod(te._invmp(this.m).mul(this.r2));
        return ae._forceRed(this);
      };
    })(r, commonjsGlobal);
  }(bn$1)), bn$1.exports;
}
var brorand = { exports: {} }, hasRequiredBrorand;
function requireBrorand() {
  if (hasRequiredBrorand)
    return brorand.exports;
  hasRequiredBrorand = 1;
  var r;
  brorand.exports = function(a) {
    return r || (r = new e(null)), r.generate(a);
  };
  function e(o) {
    this.rand = o;
  }
  if (brorand.exports.Rand = e, e.prototype.generate = function(a) {
    return this._rand(a);
  }, e.prototype._rand = function(a) {
    if (this.rand.getBytes)
      return this.rand.getBytes(a);
    for (var l = new Uint8Array(a), u = 0; u < l.length; u++)
      l[u] = this.rand.getByte();
    return l;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(a) {
      var l = new Uint8Array(a);
      return self.crypto.getRandomValues(l), l;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(a) {
      var l = new Uint8Array(a);
      return self.msCrypto.getRandomValues(l), l;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var s = requireCryptoBrowserify();
      if (typeof s.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(a) {
        return s.randomBytes(a);
      };
    } catch {
    }
  return brorand.exports;
}
var mr, hasRequiredMr;
function requireMr() {
  if (hasRequiredMr)
    return mr;
  hasRequiredMr = 1;
  var r = requireBn$1(), e = requireBrorand();
  function s(o) {
    this.rand = o || new e.Rand();
  }
  return mr = s, s.create = function(a) {
    return new s(a);
  }, s.prototype._randbelow = function(a) {
    var l = a.bitLength(), u = Math.ceil(l / 8);
    do
      var c = new r(this.rand.generate(u));
    while (c.cmp(a) >= 0);
    return c;
  }, s.prototype._randrange = function(a, l) {
    var u = l.sub(a);
    return a.add(this._randbelow(u));
  }, s.prototype.test = function(a, l, u) {
    var c = a.bitLength(), E = r.mont(a), d = new r(1).toRed(E);
    l || (l = Math.max(1, c / 48 | 0));
    for (var f = a.subn(1), h = 0; !f.testn(h); h++)
      ;
    for (var S = a.shrn(h), R = f.toRed(E), _ = !0; l > 0; l--) {
      var m = this._randrange(new r(2), f);
      u && u(m);
      var L = m.toRed(E).redPow(S);
      if (!(L.cmp(d) === 0 || L.cmp(R) === 0)) {
        for (var F = 1; F < h; F++) {
          if (L = L.redSqr(), L.cmp(d) === 0)
            return !1;
          if (L.cmp(R) === 0)
            break;
        }
        if (F === h)
          return !1;
      }
    }
    return _;
  }, s.prototype.getDivisor = function(a, l) {
    var u = a.bitLength(), c = r.mont(a), E = new r(1).toRed(c);
    l || (l = Math.max(1, u / 48 | 0));
    for (var d = a.subn(1), f = 0; !d.testn(f); f++)
      ;
    for (var h = a.shrn(f), S = d.toRed(c); l > 0; l--) {
      var R = this._randrange(new r(2), d), _ = a.gcd(R);
      if (_.cmpn(1) !== 0)
        return _;
      var m = R.toRed(c).redPow(h);
      if (!(m.cmp(E) === 0 || m.cmp(S) === 0)) {
        for (var L = 1; L < f; L++) {
          if (m = m.redSqr(), m.cmp(E) === 0)
            return m.fromRed().subn(1).gcd(a);
          if (m.cmp(S) === 0)
            break;
        }
        if (L === f)
          return m = m.redSqr(), m.fromRed().subn(1).gcd(a);
      }
    }
    return !1;
  }, mr;
}
var generatePrime, hasRequiredGeneratePrime;
function requireGeneratePrime() {
  if (hasRequiredGeneratePrime)
    return generatePrime;
  hasRequiredGeneratePrime = 1;
  var r = requireBrowser$b();
  generatePrime = L, L.simpleSieve = _, L.fermatTest = m;
  var e = requireBn$1(), s = new e(24), o = requireMr(), a = new o(), l = new e(1), u = new e(2), c = new e(5);
  new e(16), new e(8);
  var E = new e(10), d = new e(3);
  new e(7);
  var f = new e(11), h = new e(4);
  new e(12);
  var S = null;
  function R() {
    if (S !== null)
      return S;
    var F = 1048576, W = [];
    W[0] = 2;
    for (var G = 1, q = 3; q < F; q += 2) {
      for (var fe = Math.ceil(Math.sqrt(q)), _e = 0; _e < G && W[_e] <= fe && q % W[_e] !== 0; _e++)
        ;
      G !== _e && W[_e] <= fe || (W[G++] = q);
    }
    return S = W, W;
  }
  function _(F) {
    for (var W = R(), G = 0; G < W.length; G++)
      if (F.modn(W[G]) === 0)
        return F.cmpn(W[G]) === 0;
    return !0;
  }
  function m(F) {
    var W = e.mont(F);
    return u.toRed(W).redPow(F.subn(1)).fromRed().cmpn(1) === 0;
  }
  function L(F, W) {
    if (F < 16)
      return W === 2 || W === 5 ? new e([140, 123]) : new e([140, 39]);
    W = new e(W);
    for (var G, q; ; ) {
      for (G = new e(r(Math.ceil(F / 8))); G.bitLength() > F; )
        G.ishrn(1);
      if (G.isEven() && G.iadd(l), G.testn(1) || G.iadd(u), W.cmp(u)) {
        if (!W.cmp(c))
          for (; G.mod(E).cmp(d); )
            G.iadd(h);
      } else
        for (; G.mod(s).cmp(f); )
          G.iadd(h);
      if (q = G.shrn(1), _(q) && _(G) && m(q) && m(G) && a.test(q) && a.test(G))
        return G;
    }
  }
  return generatePrime;
}
const modp1 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, modp2 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, modp5 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, modp14 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, modp15 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, modp16 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, modp17 = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, modp18 = {
  gen: "02",
  prime: "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"
}, require$$1$1 = {
  modp1,
  modp2,
  modp5,
  modp14,
  modp15,
  modp16,
  modp17,
  modp18
};
var dh, hasRequiredDh;
function requireDh() {
  if (hasRequiredDh)
    return dh;
  hasRequiredDh = 1;
  var r = requireBn$1(), e = requireMr(), s = new e(), o = new r(24), a = new r(11), l = new r(10), u = new r(3), c = new r(7), E = requireGeneratePrime(), d = requireBrowser$b();
  dh = _;
  function f(L, F) {
    return F = F || "utf8", buffer$1.Buffer.isBuffer(L) || (L = new buffer$1.Buffer(L, F)), this._pub = new r(L), this;
  }
  function h(L, F) {
    return F = F || "utf8", buffer$1.Buffer.isBuffer(L) || (L = new buffer$1.Buffer(L, F)), this._priv = new r(L), this;
  }
  var S = {};
  function R(L, F) {
    var W = F.toString("hex"), G = [W, L.toString(16)].join("_");
    if (G in S)
      return S[G];
    var q = 0;
    if (L.isEven() || !E.simpleSieve || !E.fermatTest(L) || !s.test(L))
      return q += 1, W === "02" || W === "05" ? q += 8 : q += 4, S[G] = q, q;
    s.test(L.shrn(1)) || (q += 2);
    var fe;
    switch (W) {
      case "02":
        L.mod(o).cmp(a) && (q += 8);
        break;
      case "05":
        fe = L.mod(l), fe.cmp(u) && fe.cmp(c) && (q += 8);
        break;
      default:
        q += 4;
    }
    return S[G] = q, q;
  }
  function _(L, F, W) {
    this.setGenerator(F), this.__prime = new r(L), this._prime = r.mont(this.__prime), this._primeLen = L.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, W ? (this.setPublicKey = f, this.setPrivateKey = h) : this._primeCode = 8;
  }
  Object.defineProperty(_.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = R(this.__prime, this.__gen)), this._primeCode;
    }
  }), _.prototype.generateKeys = function() {
    return this._priv || (this._priv = new r(d(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, _.prototype.computeSecret = function(L) {
    L = new r(L), L = L.toRed(this._prime);
    var F = L.redPow(this._priv).fromRed(), W = new buffer$1.Buffer(F.toArray()), G = this.getPrime();
    if (W.length < G.length) {
      var q = new buffer$1.Buffer(G.length - W.length);
      q.fill(0), W = buffer$1.Buffer.concat([q, W]);
    }
    return W;
  }, _.prototype.getPublicKey = function(F) {
    return m(this._pub, F);
  }, _.prototype.getPrivateKey = function(F) {
    return m(this._priv, F);
  }, _.prototype.getPrime = function(L) {
    return m(this.__prime, L);
  }, _.prototype.getGenerator = function(L) {
    return m(this._gen, L);
  }, _.prototype.setGenerator = function(L, F) {
    return F = F || "utf8", buffer$1.Buffer.isBuffer(L) || (L = new buffer$1.Buffer(L, F)), this.__gen = L, this._gen = new r(L), this;
  };
  function m(L, F) {
    var W = new buffer$1.Buffer(L.toArray());
    return F ? W.toString(F) : W;
  }
  return dh;
}
var hasRequiredBrowser$4;
function requireBrowser$4() {
  if (hasRequiredBrowser$4)
    return browser$4;
  hasRequiredBrowser$4 = 1;
  var r = requireGeneratePrime(), e = require$$1$1, s = requireDh();
  function o(u) {
    var c = new buffer$1.Buffer(e[u].prime, "hex"), E = new buffer$1.Buffer(e[u].gen, "hex");
    return new s(c, E);
  }
  var a = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function l(u, c, E, d) {
    return buffer$1.Buffer.isBuffer(c) || a[c] === void 0 ? l(u, "binary", c, E) : (c = c || "binary", d = d || "binary", E = E || new buffer$1.Buffer([2]), buffer$1.Buffer.isBuffer(E) || (E = new buffer$1.Buffer(E, d)), typeof u == "number" ? new s(r(u, E), E, !0) : (buffer$1.Buffer.isBuffer(u) || (u = new buffer$1.Buffer(u, c)), new s(u, E, !0)));
  }
  return browser$4.DiffieHellmanGroup = browser$4.createDiffieHellmanGroup = browser$4.getDiffieHellman = o, browser$4.createDiffieHellman = browser$4.DiffieHellman = l, browser$4;
}
var readableBrowser = { exports: {} }, processNextickArgs = { exports: {} }, hasRequiredProcessNextickArgs;
function requireProcessNextickArgs() {
  if (hasRequiredProcessNextickArgs)
    return processNextickArgs.exports;
  hasRequiredProcessNextickArgs = 1, typeof api$1 > "u" || !api$1.version || api$1.version.indexOf("v0.") === 0 || api$1.version.indexOf("v1.") === 0 && api$1.version.indexOf("v1.8.") !== 0 ? processNextickArgs.exports = { nextTick: r } : processNextickArgs.exports = api$1;
  function r(e, s, o, a) {
    if (typeof e != "function")
      throw new TypeError('"callback" argument must be a function');
    var l = arguments.length, u, c;
    switch (l) {
      case 0:
      case 1:
        return api$1.nextTick(e);
      case 2:
        return api$1.nextTick(function() {
          e.call(null, s);
        });
      case 3:
        return api$1.nextTick(function() {
          e.call(null, s, o);
        });
      case 4:
        return api$1.nextTick(function() {
          e.call(null, s, o, a);
        });
      default:
        for (u = new Array(l - 1), c = 0; c < u.length; )
          u[c++] = arguments[c];
        return api$1.nextTick(function() {
          e.apply(null, u);
        });
    }
  }
  return processNextickArgs.exports;
}
var isarray, hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray)
    return isarray;
  hasRequiredIsarray = 1;
  var r = {}.toString;
  return isarray = Array.isArray || function(e) {
    return r.call(e) == "[object Array]";
  }, isarray;
}
var streamBrowser, hasRequiredStreamBrowser;
function requireStreamBrowser() {
  return hasRequiredStreamBrowser || (hasRequiredStreamBrowser = 1, streamBrowser = requireEvents().EventEmitter), streamBrowser;
}
var safeBuffer = { exports: {} }, hasRequiredSafeBuffer;
function requireSafeBuffer() {
  return hasRequiredSafeBuffer || (hasRequiredSafeBuffer = 1, function(r, e) {
    var s = buffer$1, o = s.Buffer;
    function a(u, c) {
      for (var E in u)
        c[E] = u[E];
    }
    o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? r.exports = s : (a(s, e), e.Buffer = l);
    function l(u, c, E) {
      return o(u, c, E);
    }
    a(o, l), l.from = function(u, c, E) {
      if (typeof u == "number")
        throw new TypeError("Argument must not be a number");
      return o(u, c, E);
    }, l.alloc = function(u, c, E) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      var d = o(u);
      return c !== void 0 ? typeof E == "string" ? d.fill(c, E) : d.fill(c) : d.fill(0), d;
    }, l.allocUnsafe = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return o(u);
    }, l.allocUnsafeSlow = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return s.SlowBuffer(u);
    };
  }(safeBuffer, safeBuffer.exports)), safeBuffer.exports;
}
var util$2 = {}, hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil)
    return util$2;
  hasRequiredUtil = 1;
  function r(m) {
    return Array.isArray ? Array.isArray(m) : _(m) === "[object Array]";
  }
  util$2.isArray = r;
  function e(m) {
    return typeof m == "boolean";
  }
  util$2.isBoolean = e;
  function s(m) {
    return m === null;
  }
  util$2.isNull = s;
  function o(m) {
    return m == null;
  }
  util$2.isNullOrUndefined = o;
  function a(m) {
    return typeof m == "number";
  }
  util$2.isNumber = a;
  function l(m) {
    return typeof m == "string";
  }
  util$2.isString = l;
  function u(m) {
    return typeof m == "symbol";
  }
  util$2.isSymbol = u;
  function c(m) {
    return m === void 0;
  }
  util$2.isUndefined = c;
  function E(m) {
    return _(m) === "[object RegExp]";
  }
  util$2.isRegExp = E;
  function d(m) {
    return typeof m == "object" && m !== null;
  }
  util$2.isObject = d;
  function f(m) {
    return _(m) === "[object Date]";
  }
  util$2.isDate = f;
  function h(m) {
    return _(m) === "[object Error]" || m instanceof Error;
  }
  util$2.isError = h;
  function S(m) {
    return typeof m == "function";
  }
  util$2.isFunction = S;
  function R(m) {
    return m === null || typeof m == "boolean" || typeof m == "number" || typeof m == "string" || typeof m == "symbol" || // ES6 symbol
    typeof m > "u";
  }
  util$2.isPrimitive = R, util$2.isBuffer = buffer$1.Buffer.isBuffer;
  function _(m) {
    return Object.prototype.toString.call(m);
  }
  return util$2;
}
var BufferList = { exports: {} }, hasRequiredBufferList;
function requireBufferList() {
  return hasRequiredBufferList || (hasRequiredBufferList = 1, function(r) {
    function e(l, u) {
      if (!(l instanceof u))
        throw new TypeError("Cannot call a class as a function");
    }
    var s = requireSafeBuffer().Buffer, o = requireUtil$1();
    function a(l, u, c) {
      l.copy(u, c);
    }
    r.exports = function() {
      function l() {
        e(this, l), this.head = null, this.tail = null, this.length = 0;
      }
      return l.prototype.push = function(c) {
        var E = { data: c, next: null };
        this.length > 0 ? this.tail.next = E : this.head = E, this.tail = E, ++this.length;
      }, l.prototype.unshift = function(c) {
        var E = { data: c, next: this.head };
        this.length === 0 && (this.tail = E), this.head = E, ++this.length;
      }, l.prototype.shift = function() {
        if (this.length !== 0) {
          var c = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, c;
        }
      }, l.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, l.prototype.join = function(c) {
        if (this.length === 0)
          return "";
        for (var E = this.head, d = "" + E.data; E = E.next; )
          d += c + E.data;
        return d;
      }, l.prototype.concat = function(c) {
        if (this.length === 0)
          return s.alloc(0);
        for (var E = s.allocUnsafe(c >>> 0), d = this.head, f = 0; d; )
          a(d.data, E, f), f += d.data.length, d = d.next;
        return E;
      }, l;
    }(), o && o.inspect && o.inspect.custom && (r.exports.prototype[o.inspect.custom] = function() {
      var l = o.inspect({ length: this.length });
      return this.constructor.name + " " + l;
    });
  }(BufferList)), BufferList.exports;
}
var destroy_1, hasRequiredDestroy;
function requireDestroy() {
  if (hasRequiredDestroy)
    return destroy_1;
  hasRequiredDestroy = 1;
  var r = requireProcessNextickArgs();
  function e(a, l) {
    var u = this, c = this._readableState && this._readableState.destroyed, E = this._writableState && this._writableState.destroyed;
    return c || E ? (l ? l(a) : a && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, r.nextTick(o, this, a)) : r.nextTick(o, this, a)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(a || null, function(d) {
      !l && d ? u._writableState ? u._writableState.errorEmitted || (u._writableState.errorEmitted = !0, r.nextTick(o, u, d)) : r.nextTick(o, u, d) : l && l(d);
    }), this);
  }
  function s() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function o(a, l) {
    a.emit("error", l);
  }
  return destroy_1 = {
    destroy: e,
    undestroy: s
  }, destroy_1;
}
var _stream_writable, hasRequired_stream_writable;
function require_stream_writable() {
  if (hasRequired_stream_writable)
    return _stream_writable;
  hasRequired_stream_writable = 1;
  var r = requireProcessNextickArgs();
  _stream_writable = m;
  function e(be) {
    var ze = this;
    this.next = null, this.entry = null, this.finish = function() {
      De(ze, be);
    };
  }
  var s = !api$1.browser && ["v0.10", "v0.9."].indexOf(api$1.version.slice(0, 5)) > -1 ? setImmediate : r.nextTick, o;
  m.WritableState = R;
  var a = Object.create(requireUtil());
  a.inherits = requireInherits_browser();
  var l = {
    deprecate: requireBrowser$a()
  }, u = requireStreamBrowser(), c = requireSafeBuffer().Buffer, E = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function d(be) {
    return c.from(be);
  }
  function f(be) {
    return c.isBuffer(be) || be instanceof E;
  }
  var h = requireDestroy();
  a.inherits(m, u);
  function S() {
  }
  function R(be, ze) {
    o = o || require_stream_duplex(), be = be || {};
    var ke = ze instanceof o;
    this.objectMode = !!be.objectMode, ke && (this.objectMode = this.objectMode || !!be.writableObjectMode);
    var Be = be.highWaterMark, Me = be.writableHighWaterMark, me = this.objectMode ? 16 : 16 * 1024;
    Be || Be === 0 ? this.highWaterMark = Be : ke && (Me || Me === 0) ? this.highWaterMark = Me : this.highWaterMark = me, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Se = be.decodeStrings === !1;
    this.decodeStrings = !Se, this.defaultEncoding = be.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(xt) {
      Le(ze, xt);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  R.prototype.getBuffer = function() {
    for (var ze = this.bufferedRequest, ke = []; ze; )
      ke.push(ze), ze = ze.next;
    return ke;
  }, function() {
    try {
      Object.defineProperty(R.prototype, "buffer", {
        get: l.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var _;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (_ = Function.prototype[Symbol.hasInstance], Object.defineProperty(m, Symbol.hasInstance, {
    value: function(be) {
      return _.call(this, be) ? !0 : this !== m ? !1 : be && be._writableState instanceof R;
    }
  })) : _ = function(be) {
    return be instanceof this;
  };
  function m(be) {
    if (o = o || require_stream_duplex(), !_.call(m, this) && !(this instanceof o))
      return new m(be);
    this._writableState = new R(be, this), this.writable = !0, be && (typeof be.write == "function" && (this._write = be.write), typeof be.writev == "function" && (this._writev = be.writev), typeof be.destroy == "function" && (this._destroy = be.destroy), typeof be.final == "function" && (this._final = be.final)), u.call(this);
  }
  m.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function L(be, ze) {
    var ke = new Error("write after end");
    be.emit("error", ke), r.nextTick(ze, ke);
  }
  function F(be, ze, ke, Be) {
    var Me = !0, me = !1;
    return ke === null ? me = new TypeError("May not write null values to stream") : typeof ke != "string" && ke !== void 0 && !ze.objectMode && (me = new TypeError("Invalid non-string/buffer chunk")), me && (be.emit("error", me), r.nextTick(Be, me), Me = !1), Me;
  }
  m.prototype.write = function(be, ze, ke) {
    var Be = this._writableState, Me = !1, me = !Be.objectMode && f(be);
    return me && !c.isBuffer(be) && (be = d(be)), typeof ze == "function" && (ke = ze, ze = null), me ? ze = "buffer" : ze || (ze = Be.defaultEncoding), typeof ke != "function" && (ke = S), Be.ended ? L(this, ke) : (me || F(this, Be, be, ke)) && (Be.pendingcb++, Me = G(this, Be, me, be, ze, ke)), Me;
  }, m.prototype.cork = function() {
    var be = this._writableState;
    be.corked++;
  }, m.prototype.uncork = function() {
    var be = this._writableState;
    be.corked && (be.corked--, !be.writing && !be.corked && !be.bufferProcessing && be.bufferedRequest && Ge(this, be));
  }, m.prototype.setDefaultEncoding = function(ze) {
    if (typeof ze == "string" && (ze = ze.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((ze + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + ze);
    return this._writableState.defaultEncoding = ze, this;
  };
  function W(be, ze, ke) {
    return !be.objectMode && be.decodeStrings !== !1 && typeof ze == "string" && (ze = c.from(ze, ke)), ze;
  }
  Object.defineProperty(m.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function G(be, ze, ke, Be, Me, me) {
    if (!ke) {
      var Se = W(ze, Be, Me);
      Be !== Se && (ke = !0, Me = "buffer", Be = Se);
    }
    var xt = ze.objectMode ? 1 : Be.length;
    ze.length += xt;
    var Ht = ze.length < ze.highWaterMark;
    if (Ht || (ze.needDrain = !0), ze.writing || ze.corked) {
      var Bt = ze.lastBufferedRequest;
      ze.lastBufferedRequest = {
        chunk: Be,
        encoding: Me,
        isBuf: ke,
        callback: me,
        next: null
      }, Bt ? Bt.next = ze.lastBufferedRequest : ze.bufferedRequest = ze.lastBufferedRequest, ze.bufferedRequestCount += 1;
    } else
      q(be, ze, !1, xt, Be, Me, me);
    return Ht;
  }
  function q(be, ze, ke, Be, Me, me, Se) {
    ze.writelen = Be, ze.writecb = Se, ze.writing = !0, ze.sync = !0, ke ? be._writev(Me, ze.onwrite) : be._write(Me, me, ze.onwrite), ze.sync = !1;
  }
  function fe(be, ze, ke, Be, Me) {
    --ze.pendingcb, ke ? (r.nextTick(Me, Be), r.nextTick(v, be, ze), be._writableState.errorEmitted = !0, be.emit("error", Be)) : (Me(Be), be._writableState.errorEmitted = !0, be.emit("error", Be), v(be, ze));
  }
  function _e(be) {
    be.writing = !1, be.writecb = null, be.length -= be.writelen, be.writelen = 0;
  }
  function Le(be, ze) {
    var ke = be._writableState, Be = ke.sync, Me = ke.writecb;
    if (_e(ke), ze)
      fe(be, ke, Be, ze, Me);
    else {
      var me = ve(ke);
      !me && !ke.corked && !ke.bufferProcessing && ke.bufferedRequest && Ge(be, ke), Be ? s(Fe, be, ke, me, Me) : Fe(be, ke, me, Me);
    }
  }
  function Fe(be, ze, ke, Be) {
    ke || Ee(be, ze), ze.pendingcb--, Be(), v(be, ze);
  }
  function Ee(be, ze) {
    ze.length === 0 && ze.needDrain && (ze.needDrain = !1, be.emit("drain"));
  }
  function Ge(be, ze) {
    ze.bufferProcessing = !0;
    var ke = ze.bufferedRequest;
    if (be._writev && ke && ke.next) {
      var Be = ze.bufferedRequestCount, Me = new Array(Be), me = ze.corkedRequestsFree;
      me.entry = ke;
      for (var Se = 0, xt = !0; ke; )
        Me[Se] = ke, ke.isBuf || (xt = !1), ke = ke.next, Se += 1;
      Me.allBuffers = xt, q(be, ze, !0, ze.length, Me, "", me.finish), ze.pendingcb++, ze.lastBufferedRequest = null, me.next ? (ze.corkedRequestsFree = me.next, me.next = null) : ze.corkedRequestsFree = new e(ze), ze.bufferedRequestCount = 0;
    } else {
      for (; ke; ) {
        var Ht = ke.chunk, Bt = ke.encoding, ut = ke.callback, Tt = ze.objectMode ? 1 : Ht.length;
        if (q(be, ze, !1, Tt, Ht, Bt, ut), ke = ke.next, ze.bufferedRequestCount--, ze.writing)
          break;
      }
      ke === null && (ze.lastBufferedRequest = null);
    }
    ze.bufferedRequest = ke, ze.bufferProcessing = !1;
  }
  m.prototype._write = function(be, ze, ke) {
    ke(new Error("_write() is not implemented"));
  }, m.prototype._writev = null, m.prototype.end = function(be, ze, ke) {
    var Be = this._writableState;
    typeof be == "function" ? (ke = be, be = null, ze = null) : typeof ze == "function" && (ke = ze, ze = null), be != null && this.write(be, ze), Be.corked && (Be.corked = 1, this.uncork()), Be.ending || Te(this, Be, ke);
  };
  function ve(be) {
    return be.ending && be.length === 0 && be.bufferedRequest === null && !be.finished && !be.writing;
  }
  function te(be, ze) {
    be._final(function(ke) {
      ze.pendingcb--, ke && be.emit("error", ke), ze.prefinished = !0, be.emit("prefinish"), v(be, ze);
    });
  }
  function ae(be, ze) {
    !ze.prefinished && !ze.finalCalled && (typeof be._final == "function" ? (ze.pendingcb++, ze.finalCalled = !0, r.nextTick(te, be, ze)) : (ze.prefinished = !0, be.emit("prefinish")));
  }
  function v(be, ze) {
    var ke = ve(ze);
    return ke && (ae(be, ze), ze.pendingcb === 0 && (ze.finished = !0, be.emit("finish"))), ke;
  }
  function Te(be, ze, ke) {
    ze.ending = !0, v(be, ze), ke && (ze.finished ? r.nextTick(ke) : be.once("finish", ke)), ze.ended = !0, be.writable = !1;
  }
  function De(be, ze, ke) {
    var Be = be.entry;
    for (be.entry = null; Be; ) {
      var Me = Be.callback;
      ze.pendingcb--, Me(ke), Be = Be.next;
    }
    ze.corkedRequestsFree.next = be;
  }
  return Object.defineProperty(m.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(be) {
      this._writableState && (this._writableState.destroyed = be);
    }
  }), m.prototype.destroy = h.destroy, m.prototype._undestroy = h.undestroy, m.prototype._destroy = function(be, ze) {
    this.end(), ze(be);
  }, _stream_writable;
}
var _stream_duplex, hasRequired_stream_duplex;
function require_stream_duplex() {
  if (hasRequired_stream_duplex)
    return _stream_duplex;
  hasRequired_stream_duplex = 1;
  var r = requireProcessNextickArgs(), e = Object.keys || function(h) {
    var S = [];
    for (var R in h)
      S.push(R);
    return S;
  };
  _stream_duplex = E;
  var s = Object.create(requireUtil());
  s.inherits = requireInherits_browser();
  var o = require_stream_readable(), a = require_stream_writable();
  s.inherits(E, o);
  for (var l = e(a.prototype), u = 0; u < l.length; u++) {
    var c = l[u];
    E.prototype[c] || (E.prototype[c] = a.prototype[c]);
  }
  function E(h) {
    if (!(this instanceof E))
      return new E(h);
    o.call(this, h), a.call(this, h), h && h.readable === !1 && (this.readable = !1), h && h.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, h && h.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", d);
  }
  Object.defineProperty(E.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function d() {
    this.allowHalfOpen || this._writableState.ended || r.nextTick(f, this);
  }
  function f(h) {
    h.end();
  }
  return Object.defineProperty(E.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(h) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = h, this._writableState.destroyed = h);
    }
  }), E.prototype._destroy = function(h, S) {
    this.push(null), this.end(), r.nextTick(S, h);
  }, _stream_duplex;
}
var _stream_readable, hasRequired_stream_readable;
function require_stream_readable() {
  if (hasRequired_stream_readable)
    return _stream_readable;
  hasRequired_stream_readable = 1;
  var r = requireProcessNextickArgs();
  _stream_readable = W;
  var e = requireIsarray(), s;
  W.ReadableState = F, requireEvents().EventEmitter;
  var o = function(ut, Tt) {
    return ut.listeners(Tt).length;
  }, a = requireStreamBrowser(), l = requireSafeBuffer().Buffer, u = (typeof commonjsGlobal < "u" ? commonjsGlobal : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function c(ut) {
    return l.from(ut);
  }
  function E(ut) {
    return l.isBuffer(ut) || ut instanceof u;
  }
  var d = Object.create(requireUtil());
  d.inherits = requireInherits_browser();
  var f = requireUtil$1(), h = void 0;
  f && f.debuglog ? h = f.debuglog("stream") : h = function() {
  };
  var S = requireBufferList(), R = requireDestroy(), _;
  d.inherits(W, a);
  var m = ["error", "close", "destroy", "pause", "resume"];
  function L(ut, Tt, Yt) {
    if (typeof ut.prependListener == "function")
      return ut.prependListener(Tt, Yt);
    !ut._events || !ut._events[Tt] ? ut.on(Tt, Yt) : e(ut._events[Tt]) ? ut._events[Tt].unshift(Yt) : ut._events[Tt] = [Yt, ut._events[Tt]];
  }
  function F(ut, Tt) {
    s = s || require_stream_duplex(), ut = ut || {};
    var Yt = Tt instanceof s;
    this.objectMode = !!ut.objectMode, Yt && (this.objectMode = this.objectMode || !!ut.readableObjectMode);
    var an = ut.highWaterMark, Ct = ut.readableHighWaterMark, st = this.objectMode ? 16 : 16 * 1024;
    an || an === 0 ? this.highWaterMark = an : Yt && (Ct || Ct === 0) ? this.highWaterMark = Ct : this.highWaterMark = st, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new S(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = ut.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, ut.encoding && (_ || (_ = requireString_decoder().StringDecoder), this.decoder = new _(ut.encoding), this.encoding = ut.encoding);
  }
  function W(ut) {
    if (s = s || require_stream_duplex(), !(this instanceof W))
      return new W(ut);
    this._readableState = new F(ut, this), this.readable = !0, ut && (typeof ut.read == "function" && (this._read = ut.read), typeof ut.destroy == "function" && (this._destroy = ut.destroy)), a.call(this);
  }
  Object.defineProperty(W.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(ut) {
      this._readableState && (this._readableState.destroyed = ut);
    }
  }), W.prototype.destroy = R.destroy, W.prototype._undestroy = R.undestroy, W.prototype._destroy = function(ut, Tt) {
    this.push(null), Tt(ut);
  }, W.prototype.push = function(ut, Tt) {
    var Yt = this._readableState, an;
    return Yt.objectMode ? an = !0 : typeof ut == "string" && (Tt = Tt || Yt.defaultEncoding, Tt !== Yt.encoding && (ut = l.from(ut, Tt), Tt = ""), an = !0), G(this, ut, Tt, !1, an);
  }, W.prototype.unshift = function(ut) {
    return G(this, ut, null, !0, !1);
  };
  function G(ut, Tt, Yt, an, Ct) {
    var st = ut._readableState;
    if (Tt === null)
      st.reading = !1, Ge(ut, st);
    else {
      var jt;
      Ct || (jt = fe(st, Tt)), jt ? ut.emit("error", jt) : st.objectMode || Tt && Tt.length > 0 ? (typeof Tt != "string" && !st.objectMode && Object.getPrototypeOf(Tt) !== l.prototype && (Tt = c(Tt)), an ? st.endEmitted ? ut.emit("error", new Error("stream.unshift() after end event")) : q(ut, st, Tt, !0) : st.ended ? ut.emit("error", new Error("stream.push() after EOF")) : (st.reading = !1, st.decoder && !Yt ? (Tt = st.decoder.write(Tt), st.objectMode || Tt.length !== 0 ? q(ut, st, Tt, !1) : ae(ut, st)) : q(ut, st, Tt, !1))) : an || (st.reading = !1);
    }
    return _e(st);
  }
  function q(ut, Tt, Yt, an) {
    Tt.flowing && Tt.length === 0 && !Tt.sync ? (ut.emit("data", Yt), ut.read(0)) : (Tt.length += Tt.objectMode ? 1 : Yt.length, an ? Tt.buffer.unshift(Yt) : Tt.buffer.push(Yt), Tt.needReadable && ve(ut)), ae(ut, Tt);
  }
  function fe(ut, Tt) {
    var Yt;
    return !E(Tt) && typeof Tt != "string" && Tt !== void 0 && !ut.objectMode && (Yt = new TypeError("Invalid non-string/buffer chunk")), Yt;
  }
  function _e(ut) {
    return !ut.ended && (ut.needReadable || ut.length < ut.highWaterMark || ut.length === 0);
  }
  W.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, W.prototype.setEncoding = function(ut) {
    return _ || (_ = requireString_decoder().StringDecoder), this._readableState.decoder = new _(ut), this._readableState.encoding = ut, this;
  };
  var Le = 8388608;
  function Fe(ut) {
    return ut >= Le ? ut = Le : (ut--, ut |= ut >>> 1, ut |= ut >>> 2, ut |= ut >>> 4, ut |= ut >>> 8, ut |= ut >>> 16, ut++), ut;
  }
  function Ee(ut, Tt) {
    return ut <= 0 || Tt.length === 0 && Tt.ended ? 0 : Tt.objectMode ? 1 : ut !== ut ? Tt.flowing && Tt.length ? Tt.buffer.head.data.length : Tt.length : (ut > Tt.highWaterMark && (Tt.highWaterMark = Fe(ut)), ut <= Tt.length ? ut : Tt.ended ? Tt.length : (Tt.needReadable = !0, 0));
  }
  W.prototype.read = function(ut) {
    h("read", ut), ut = parseInt(ut, 10);
    var Tt = this._readableState, Yt = ut;
    if (ut !== 0 && (Tt.emittedReadable = !1), ut === 0 && Tt.needReadable && (Tt.length >= Tt.highWaterMark || Tt.ended))
      return h("read: emitReadable", Tt.length, Tt.ended), Tt.length === 0 && Tt.ended ? xt(this) : ve(this), null;
    if (ut = Ee(ut, Tt), ut === 0 && Tt.ended)
      return Tt.length === 0 && xt(this), null;
    var an = Tt.needReadable;
    h("need readable", an), (Tt.length === 0 || Tt.length - ut < Tt.highWaterMark) && (an = !0, h("length less than watermark", an)), Tt.ended || Tt.reading ? (an = !1, h("reading or ended", an)) : an && (h("do read"), Tt.reading = !0, Tt.sync = !0, Tt.length === 0 && (Tt.needReadable = !0), this._read(Tt.highWaterMark), Tt.sync = !1, Tt.reading || (ut = Ee(Yt, Tt)));
    var Ct;
    return ut > 0 ? Ct = Be(ut, Tt) : Ct = null, Ct === null ? (Tt.needReadable = !0, ut = 0) : Tt.length -= ut, Tt.length === 0 && (Tt.ended || (Tt.needReadable = !0), Yt !== ut && Tt.ended && xt(this)), Ct !== null && this.emit("data", Ct), Ct;
  };
  function Ge(ut, Tt) {
    if (!Tt.ended) {
      if (Tt.decoder) {
        var Yt = Tt.decoder.end();
        Yt && Yt.length && (Tt.buffer.push(Yt), Tt.length += Tt.objectMode ? 1 : Yt.length);
      }
      Tt.ended = !0, ve(ut);
    }
  }
  function ve(ut) {
    var Tt = ut._readableState;
    Tt.needReadable = !1, Tt.emittedReadable || (h("emitReadable", Tt.flowing), Tt.emittedReadable = !0, Tt.sync ? r.nextTick(te, ut) : te(ut));
  }
  function te(ut) {
    h("emit readable"), ut.emit("readable"), ke(ut);
  }
  function ae(ut, Tt) {
    Tt.readingMore || (Tt.readingMore = !0, r.nextTick(v, ut, Tt));
  }
  function v(ut, Tt) {
    for (var Yt = Tt.length; !Tt.reading && !Tt.flowing && !Tt.ended && Tt.length < Tt.highWaterMark && (h("maybeReadMore read 0"), ut.read(0), Yt !== Tt.length); )
      Yt = Tt.length;
    Tt.readingMore = !1;
  }
  W.prototype._read = function(ut) {
    this.emit("error", new Error("_read() is not implemented"));
  }, W.prototype.pipe = function(ut, Tt) {
    var Yt = this, an = this._readableState;
    switch (an.pipesCount) {
      case 0:
        an.pipes = ut;
        break;
      case 1:
        an.pipes = [an.pipes, ut];
        break;
      default:
        an.pipes.push(ut);
        break;
    }
    an.pipesCount += 1, h("pipe count=%d opts=%j", an.pipesCount, Tt);
    var Ct = (!Tt || Tt.end !== !1) && ut !== api$1.stdout && ut !== api$1.stderr, st = Ct ? lt : It;
    an.endEmitted ? r.nextTick(st) : Yt.once("end", st), ut.on("unpipe", jt);
    function jt(ht, Wt) {
      h("onunpipe"), ht === Yt && Wt && Wt.hasUnpiped === !1 && (Wt.hasUnpiped = !0, Ke());
    }
    function lt() {
      h("onend"), ut.end();
    }
    var Zt = Te(Yt);
    ut.on("drain", Zt);
    var Et = !1;
    function Ke() {
      h("cleanup"), ut.removeListener("close", In), ut.removeListener("finish", Cn), ut.removeListener("drain", Zt), ut.removeListener("error", Jt), ut.removeListener("unpipe", jt), Yt.removeListener("end", lt), Yt.removeListener("end", It), Yt.removeListener("data", pt), Et = !0, an.awaitDrain && (!ut._writableState || ut._writableState.needDrain) && Zt();
    }
    var $e = !1;
    Yt.on("data", pt);
    function pt(ht) {
      h("ondata"), $e = !1;
      var Wt = ut.write(ht);
      Wt === !1 && !$e && ((an.pipesCount === 1 && an.pipes === ut || an.pipesCount > 1 && Bt(an.pipes, ut) !== -1) && !Et && (h("false write response, pause", an.awaitDrain), an.awaitDrain++, $e = !0), Yt.pause());
    }
    function Jt(ht) {
      h("onerror", ht), It(), ut.removeListener("error", Jt), o(ut, "error") === 0 && ut.emit("error", ht);
    }
    L(ut, "error", Jt);
    function In() {
      ut.removeListener("finish", Cn), It();
    }
    ut.once("close", In);
    function Cn() {
      h("onfinish"), ut.removeListener("close", In), It();
    }
    ut.once("finish", Cn);
    function It() {
      h("unpipe"), Yt.unpipe(ut);
    }
    return ut.emit("pipe", Yt), an.flowing || (h("pipe resume"), Yt.resume()), ut;
  };
  function Te(ut) {
    return function() {
      var Tt = ut._readableState;
      h("pipeOnDrain", Tt.awaitDrain), Tt.awaitDrain && Tt.awaitDrain--, Tt.awaitDrain === 0 && o(ut, "data") && (Tt.flowing = !0, ke(ut));
    };
  }
  W.prototype.unpipe = function(ut) {
    var Tt = this._readableState, Yt = { hasUnpiped: !1 };
    if (Tt.pipesCount === 0)
      return this;
    if (Tt.pipesCount === 1)
      return ut && ut !== Tt.pipes ? this : (ut || (ut = Tt.pipes), Tt.pipes = null, Tt.pipesCount = 0, Tt.flowing = !1, ut && ut.emit("unpipe", this, Yt), this);
    if (!ut) {
      var an = Tt.pipes, Ct = Tt.pipesCount;
      Tt.pipes = null, Tt.pipesCount = 0, Tt.flowing = !1;
      for (var st = 0; st < Ct; st++)
        an[st].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var jt = Bt(Tt.pipes, ut);
    return jt === -1 ? this : (Tt.pipes.splice(jt, 1), Tt.pipesCount -= 1, Tt.pipesCount === 1 && (Tt.pipes = Tt.pipes[0]), ut.emit("unpipe", this, Yt), this);
  }, W.prototype.on = function(ut, Tt) {
    var Yt = a.prototype.on.call(this, ut, Tt);
    if (ut === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (ut === "readable") {
      var an = this._readableState;
      !an.endEmitted && !an.readableListening && (an.readableListening = an.needReadable = !0, an.emittedReadable = !1, an.reading ? an.length && ve(this) : r.nextTick(De, this));
    }
    return Yt;
  }, W.prototype.addListener = W.prototype.on;
  function De(ut) {
    h("readable nexttick read 0"), ut.read(0);
  }
  W.prototype.resume = function() {
    var ut = this._readableState;
    return ut.flowing || (h("resume"), ut.flowing = !0, be(this, ut)), this;
  };
  function be(ut, Tt) {
    Tt.resumeScheduled || (Tt.resumeScheduled = !0, r.nextTick(ze, ut, Tt));
  }
  function ze(ut, Tt) {
    Tt.reading || (h("resume read 0"), ut.read(0)), Tt.resumeScheduled = !1, Tt.awaitDrain = 0, ut.emit("resume"), ke(ut), Tt.flowing && !Tt.reading && ut.read(0);
  }
  W.prototype.pause = function() {
    return h("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function ke(ut) {
    var Tt = ut._readableState;
    for (h("flow", Tt.flowing); Tt.flowing && ut.read() !== null; )
      ;
  }
  W.prototype.wrap = function(ut) {
    var Tt = this, Yt = this._readableState, an = !1;
    ut.on("end", function() {
      if (h("wrapped end"), Yt.decoder && !Yt.ended) {
        var jt = Yt.decoder.end();
        jt && jt.length && Tt.push(jt);
      }
      Tt.push(null);
    }), ut.on("data", function(jt) {
      if (h("wrapped data"), Yt.decoder && (jt = Yt.decoder.write(jt)), !(Yt.objectMode && jt == null) && !(!Yt.objectMode && (!jt || !jt.length))) {
        var lt = Tt.push(jt);
        lt || (an = !0, ut.pause());
      }
    });
    for (var Ct in ut)
      this[Ct] === void 0 && typeof ut[Ct] == "function" && (this[Ct] = function(jt) {
        return function() {
          return ut[jt].apply(ut, arguments);
        };
      }(Ct));
    for (var st = 0; st < m.length; st++)
      ut.on(m[st], this.emit.bind(this, m[st]));
    return this._read = function(jt) {
      h("wrapped _read", jt), an && (an = !1, ut.resume());
    }, this;
  }, Object.defineProperty(W.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), W._fromList = Be;
  function Be(ut, Tt) {
    if (Tt.length === 0)
      return null;
    var Yt;
    return Tt.objectMode ? Yt = Tt.buffer.shift() : !ut || ut >= Tt.length ? (Tt.decoder ? Yt = Tt.buffer.join("") : Tt.buffer.length === 1 ? Yt = Tt.buffer.head.data : Yt = Tt.buffer.concat(Tt.length), Tt.buffer.clear()) : Yt = Me(ut, Tt.buffer, Tt.decoder), Yt;
  }
  function Me(ut, Tt, Yt) {
    var an;
    return ut < Tt.head.data.length ? (an = Tt.head.data.slice(0, ut), Tt.head.data = Tt.head.data.slice(ut)) : ut === Tt.head.data.length ? an = Tt.shift() : an = Yt ? me(ut, Tt) : Se(ut, Tt), an;
  }
  function me(ut, Tt) {
    var Yt = Tt.head, an = 1, Ct = Yt.data;
    for (ut -= Ct.length; Yt = Yt.next; ) {
      var st = Yt.data, jt = ut > st.length ? st.length : ut;
      if (jt === st.length ? Ct += st : Ct += st.slice(0, ut), ut -= jt, ut === 0) {
        jt === st.length ? (++an, Yt.next ? Tt.head = Yt.next : Tt.head = Tt.tail = null) : (Tt.head = Yt, Yt.data = st.slice(jt));
        break;
      }
      ++an;
    }
    return Tt.length -= an, Ct;
  }
  function Se(ut, Tt) {
    var Yt = l.allocUnsafe(ut), an = Tt.head, Ct = 1;
    for (an.data.copy(Yt), ut -= an.data.length; an = an.next; ) {
      var st = an.data, jt = ut > st.length ? st.length : ut;
      if (st.copy(Yt, Yt.length - ut, 0, jt), ut -= jt, ut === 0) {
        jt === st.length ? (++Ct, an.next ? Tt.head = an.next : Tt.head = Tt.tail = null) : (Tt.head = an, an.data = st.slice(jt));
        break;
      }
      ++Ct;
    }
    return Tt.length -= Ct, Yt;
  }
  function xt(ut) {
    var Tt = ut._readableState;
    if (Tt.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    Tt.endEmitted || (Tt.ended = !0, r.nextTick(Ht, Tt, ut));
  }
  function Ht(ut, Tt) {
    !ut.endEmitted && ut.length === 0 && (ut.endEmitted = !0, Tt.readable = !1, Tt.emit("end"));
  }
  function Bt(ut, Tt) {
    for (var Yt = 0, an = ut.length; Yt < an; Yt++)
      if (ut[Yt] === Tt)
        return Yt;
    return -1;
  }
  return _stream_readable;
}
var _stream_transform, hasRequired_stream_transform;
function require_stream_transform() {
  if (hasRequired_stream_transform)
    return _stream_transform;
  hasRequired_stream_transform = 1, _stream_transform = o;
  var r = require_stream_duplex(), e = Object.create(requireUtil());
  e.inherits = requireInherits_browser(), e.inherits(o, r);
  function s(u, c) {
    var E = this._transformState;
    E.transforming = !1;
    var d = E.writecb;
    if (!d)
      return this.emit("error", new Error("write callback called multiple times"));
    E.writechunk = null, E.writecb = null, c != null && this.push(c), d(u);
    var f = this._readableState;
    f.reading = !1, (f.needReadable || f.length < f.highWaterMark) && this._read(f.highWaterMark);
  }
  function o(u) {
    if (!(this instanceof o))
      return new o(u);
    r.call(this, u), this._transformState = {
      afterTransform: s.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, u && (typeof u.transform == "function" && (this._transform = u.transform), typeof u.flush == "function" && (this._flush = u.flush)), this.on("prefinish", a);
  }
  function a() {
    var u = this;
    typeof this._flush == "function" ? this._flush(function(c, E) {
      l(u, c, E);
    }) : l(this, null, null);
  }
  o.prototype.push = function(u, c) {
    return this._transformState.needTransform = !1, r.prototype.push.call(this, u, c);
  }, o.prototype._transform = function(u, c, E) {
    throw new Error("_transform() is not implemented");
  }, o.prototype._write = function(u, c, E) {
    var d = this._transformState;
    if (d.writecb = E, d.writechunk = u, d.writeencoding = c, !d.transforming) {
      var f = this._readableState;
      (d.needTransform || f.needReadable || f.length < f.highWaterMark) && this._read(f.highWaterMark);
    }
  }, o.prototype._read = function(u) {
    var c = this._transformState;
    c.writechunk !== null && c.writecb && !c.transforming ? (c.transforming = !0, this._transform(c.writechunk, c.writeencoding, c.afterTransform)) : c.needTransform = !0;
  }, o.prototype._destroy = function(u, c) {
    var E = this;
    r.prototype._destroy.call(this, u, function(d) {
      c(d), E.emit("close");
    });
  };
  function l(u, c, E) {
    if (c)
      return u.emit("error", c);
    if (E != null && u.push(E), u._writableState.length)
      throw new Error("Calling transform done when ws.length != 0");
    if (u._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return u.push(null);
  }
  return _stream_transform;
}
var _stream_passthrough, hasRequired_stream_passthrough;
function require_stream_passthrough() {
  if (hasRequired_stream_passthrough)
    return _stream_passthrough;
  hasRequired_stream_passthrough = 1, _stream_passthrough = s;
  var r = require_stream_transform(), e = Object.create(requireUtil());
  e.inherits = requireInherits_browser(), e.inherits(s, r);
  function s(o) {
    if (!(this instanceof s))
      return new s(o);
    r.call(this, o);
  }
  return s.prototype._transform = function(o, a, l) {
    l(null, o);
  }, _stream_passthrough;
}
var hasRequiredReadableBrowser;
function requireReadableBrowser() {
  return hasRequiredReadableBrowser || (hasRequiredReadableBrowser = 1, function(r, e) {
    e = r.exports = require_stream_readable(), e.Stream = e, e.Readable = e, e.Writable = require_stream_writable(), e.Duplex = require_stream_duplex(), e.Transform = require_stream_transform(), e.PassThrough = require_stream_passthrough();
  }(readableBrowser, readableBrowser.exports)), readableBrowser.exports;
}
var sign$3 = { exports: {} }, bn = { exports: {} };
bn.exports;
var hasRequiredBn;
function requireBn() {
  return hasRequiredBn || (hasRequiredBn = 1, function(r) {
    (function(e, s) {
      function o(ae, v) {
        if (!ae)
          throw new Error(v || "Assertion failed");
      }
      function a(ae, v) {
        ae.super_ = v;
        var Te = function() {
        };
        Te.prototype = v.prototype, ae.prototype = new Te(), ae.prototype.constructor = ae;
      }
      function l(ae, v, Te) {
        if (l.isBN(ae))
          return ae;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, ae !== null && ((v === "le" || v === "be") && (Te = v, v = 10), this._init(ae || 0, v || 10, Te || "be"));
      }
      typeof e == "object" ? e.exports = l : s.BN = l, l.BN = l, l.wordSize = 26;
      var u;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? u = window.Buffer : u = buffer$1.Buffer;
      } catch {
      }
      l.isBN = function(v) {
        return v instanceof l ? !0 : v !== null && typeof v == "object" && v.constructor.wordSize === l.wordSize && Array.isArray(v.words);
      }, l.max = function(v, Te) {
        return v.cmp(Te) > 0 ? v : Te;
      }, l.min = function(v, Te) {
        return v.cmp(Te) < 0 ? v : Te;
      }, l.prototype._init = function(v, Te, De) {
        if (typeof v == "number")
          return this._initNumber(v, Te, De);
        if (typeof v == "object")
          return this._initArray(v, Te, De);
        Te === "hex" && (Te = 16), o(Te === (Te | 0) && Te >= 2 && Te <= 36), v = v.toString().replace(/\s+/g, "");
        var be = 0;
        v[0] === "-" && (be++, this.negative = 1), be < v.length && (Te === 16 ? this._parseHex(v, be, De) : (this._parseBase(v, Te, be), De === "le" && this._initArray(this.toArray(), Te, De)));
      }, l.prototype._initNumber = function(v, Te, De) {
        v < 0 && (this.negative = 1, v = -v), v < 67108864 ? (this.words = [v & 67108863], this.length = 1) : v < 4503599627370496 ? (this.words = [
          v & 67108863,
          v / 67108864 & 67108863
        ], this.length = 2) : (o(v < 9007199254740992), this.words = [
          v & 67108863,
          v / 67108864 & 67108863,
          1
        ], this.length = 3), De === "le" && this._initArray(this.toArray(), Te, De);
      }, l.prototype._initArray = function(v, Te, De) {
        if (o(typeof v.length == "number"), v.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(v.length / 3), this.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          this.words[be] = 0;
        var ze, ke, Be = 0;
        if (De === "be")
          for (be = v.length - 1, ze = 0; be >= 0; be -= 3)
            ke = v[be] | v[be - 1] << 8 | v[be - 2] << 16, this.words[ze] |= ke << Be & 67108863, this.words[ze + 1] = ke >>> 26 - Be & 67108863, Be += 24, Be >= 26 && (Be -= 26, ze++);
        else if (De === "le")
          for (be = 0, ze = 0; be < v.length; be += 3)
            ke = v[be] | v[be + 1] << 8 | v[be + 2] << 16, this.words[ze] |= ke << Be & 67108863, this.words[ze + 1] = ke >>> 26 - Be & 67108863, Be += 24, Be >= 26 && (Be -= 26, ze++);
        return this._strip();
      };
      function c(ae, v) {
        var Te = ae.charCodeAt(v);
        if (Te >= 48 && Te <= 57)
          return Te - 48;
        if (Te >= 65 && Te <= 70)
          return Te - 55;
        if (Te >= 97 && Te <= 102)
          return Te - 87;
        o(!1, "Invalid character in " + ae);
      }
      function E(ae, v, Te) {
        var De = c(ae, Te);
        return Te - 1 >= v && (De |= c(ae, Te - 1) << 4), De;
      }
      l.prototype._parseHex = function(v, Te, De) {
        this.length = Math.ceil((v.length - Te) / 6), this.words = new Array(this.length);
        for (var be = 0; be < this.length; be++)
          this.words[be] = 0;
        var ze = 0, ke = 0, Be;
        if (De === "be")
          for (be = v.length - 1; be >= Te; be -= 2)
            Be = E(v, Te, be) << ze, this.words[ke] |= Be & 67108863, ze >= 18 ? (ze -= 18, ke += 1, this.words[ke] |= Be >>> 26) : ze += 8;
        else {
          var Me = v.length - Te;
          for (be = Me % 2 === 0 ? Te + 1 : Te; be < v.length; be += 2)
            Be = E(v, Te, be) << ze, this.words[ke] |= Be & 67108863, ze >= 18 ? (ze -= 18, ke += 1, this.words[ke] |= Be >>> 26) : ze += 8;
        }
        this._strip();
      };
      function d(ae, v, Te, De) {
        for (var be = 0, ze = 0, ke = Math.min(ae.length, Te), Be = v; Be < ke; Be++) {
          var Me = ae.charCodeAt(Be) - 48;
          be *= De, Me >= 49 ? ze = Me - 49 + 10 : Me >= 17 ? ze = Me - 17 + 10 : ze = Me, o(Me >= 0 && ze < De, "Invalid character"), be += ze;
        }
        return be;
      }
      l.prototype._parseBase = function(v, Te, De) {
        this.words = [0], this.length = 1;
        for (var be = 0, ze = 1; ze <= 67108863; ze *= Te)
          be++;
        be--, ze = ze / Te | 0;
        for (var ke = v.length - De, Be = ke % be, Me = Math.min(ke, ke - Be) + De, me = 0, Se = De; Se < Me; Se += be)
          me = d(v, Se, Se + be, Te), this.imuln(ze), this.words[0] + me < 67108864 ? this.words[0] += me : this._iaddn(me);
        if (Be !== 0) {
          var xt = 1;
          for (me = d(v, Se, v.length, Te), Se = 0; Se < Be; Se++)
            xt *= Te;
          this.imuln(xt), this.words[0] + me < 67108864 ? this.words[0] += me : this._iaddn(me);
        }
        this._strip();
      }, l.prototype.copy = function(v) {
        v.words = new Array(this.length);
        for (var Te = 0; Te < this.length; Te++)
          v.words[Te] = this.words[Te];
        v.length = this.length, v.negative = this.negative, v.red = this.red;
      };
      function f(ae, v) {
        ae.words = v.words, ae.length = v.length, ae.negative = v.negative, ae.red = v.red;
      }
      if (l.prototype._move = function(v) {
        f(v, this);
      }, l.prototype.clone = function() {
        var v = new l(null);
        return this.copy(v), v;
      }, l.prototype._expand = function(v) {
        for (; this.length < v; )
          this.words[this.length++] = 0;
        return this;
      }, l.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, l.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          l.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
        } catch {
          l.prototype.inspect = h;
        }
      else
        l.prototype.inspect = h;
      function h() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var S = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], R = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], _ = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      l.prototype.toString = function(v, Te) {
        v = v || 10, Te = Te | 0 || 1;
        var De;
        if (v === 16 || v === "hex") {
          De = "";
          for (var be = 0, ze = 0, ke = 0; ke < this.length; ke++) {
            var Be = this.words[ke], Me = ((Be << be | ze) & 16777215).toString(16);
            ze = Be >>> 24 - be & 16777215, be += 2, be >= 26 && (be -= 26, ke--), ze !== 0 || ke !== this.length - 1 ? De = S[6 - Me.length] + Me + De : De = Me + De;
          }
          for (ze !== 0 && (De = ze.toString(16) + De); De.length % Te !== 0; )
            De = "0" + De;
          return this.negative !== 0 && (De = "-" + De), De;
        }
        if (v === (v | 0) && v >= 2 && v <= 36) {
          var me = R[v], Se = _[v];
          De = "";
          var xt = this.clone();
          for (xt.negative = 0; !xt.isZero(); ) {
            var Ht = xt.modrn(Se).toString(v);
            xt = xt.idivn(Se), xt.isZero() ? De = Ht + De : De = S[me - Ht.length] + Ht + De;
          }
          for (this.isZero() && (De = "0" + De); De.length % Te !== 0; )
            De = "0" + De;
          return this.negative !== 0 && (De = "-" + De), De;
        }
        o(!1, "Base should be between 2 and 36");
      }, l.prototype.toNumber = function() {
        var v = this.words[0];
        return this.length === 2 ? v += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? v += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && o(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -v : v;
      }, l.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, u && (l.prototype.toBuffer = function(v, Te) {
        return this.toArrayLike(u, v, Te);
      }), l.prototype.toArray = function(v, Te) {
        return this.toArrayLike(Array, v, Te);
      };
      var m = function(v, Te) {
        return v.allocUnsafe ? v.allocUnsafe(Te) : new v(Te);
      };
      l.prototype.toArrayLike = function(v, Te, De) {
        this._strip();
        var be = this.byteLength(), ze = De || Math.max(1, be);
        o(be <= ze, "byte array longer than desired length"), o(ze > 0, "Requested array length <= 0");
        var ke = m(v, ze), Be = Te === "le" ? "LE" : "BE";
        return this["_toArrayLike" + Be](ke, be), ke;
      }, l.prototype._toArrayLikeLE = function(v, Te) {
        for (var De = 0, be = 0, ze = 0, ke = 0; ze < this.length; ze++) {
          var Be = this.words[ze] << ke | be;
          v[De++] = Be & 255, De < v.length && (v[De++] = Be >> 8 & 255), De < v.length && (v[De++] = Be >> 16 & 255), ke === 6 ? (De < v.length && (v[De++] = Be >> 24 & 255), be = 0, ke = 0) : (be = Be >>> 24, ke += 2);
        }
        if (De < v.length)
          for (v[De++] = be; De < v.length; )
            v[De++] = 0;
      }, l.prototype._toArrayLikeBE = function(v, Te) {
        for (var De = v.length - 1, be = 0, ze = 0, ke = 0; ze < this.length; ze++) {
          var Be = this.words[ze] << ke | be;
          v[De--] = Be & 255, De >= 0 && (v[De--] = Be >> 8 & 255), De >= 0 && (v[De--] = Be >> 16 & 255), ke === 6 ? (De >= 0 && (v[De--] = Be >> 24 & 255), be = 0, ke = 0) : (be = Be >>> 24, ke += 2);
        }
        if (De >= 0)
          for (v[De--] = be; De >= 0; )
            v[De--] = 0;
      }, Math.clz32 ? l.prototype._countBits = function(v) {
        return 32 - Math.clz32(v);
      } : l.prototype._countBits = function(v) {
        var Te = v, De = 0;
        return Te >= 4096 && (De += 13, Te >>>= 13), Te >= 64 && (De += 7, Te >>>= 7), Te >= 8 && (De += 4, Te >>>= 4), Te >= 2 && (De += 2, Te >>>= 2), De + Te;
      }, l.prototype._zeroBits = function(v) {
        if (v === 0)
          return 26;
        var Te = v, De = 0;
        return Te & 8191 || (De += 13, Te >>>= 13), Te & 127 || (De += 7, Te >>>= 7), Te & 15 || (De += 4, Te >>>= 4), Te & 3 || (De += 2, Te >>>= 2), Te & 1 || De++, De;
      }, l.prototype.bitLength = function() {
        var v = this.words[this.length - 1], Te = this._countBits(v);
        return (this.length - 1) * 26 + Te;
      };
      function L(ae) {
        for (var v = new Array(ae.bitLength()), Te = 0; Te < v.length; Te++) {
          var De = Te / 26 | 0, be = Te % 26;
          v[Te] = ae.words[De] >>> be & 1;
        }
        return v;
      }
      l.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var v = 0, Te = 0; Te < this.length; Te++) {
          var De = this._zeroBits(this.words[Te]);
          if (v += De, De !== 26)
            break;
        }
        return v;
      }, l.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, l.prototype.toTwos = function(v) {
        return this.negative !== 0 ? this.abs().inotn(v).iaddn(1) : this.clone();
      }, l.prototype.fromTwos = function(v) {
        return this.testn(v - 1) ? this.notn(v).iaddn(1).ineg() : this.clone();
      }, l.prototype.isNeg = function() {
        return this.negative !== 0;
      }, l.prototype.neg = function() {
        return this.clone().ineg();
      }, l.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, l.prototype.iuor = function(v) {
        for (; this.length < v.length; )
          this.words[this.length++] = 0;
        for (var Te = 0; Te < v.length; Te++)
          this.words[Te] = this.words[Te] | v.words[Te];
        return this._strip();
      }, l.prototype.ior = function(v) {
        return o((this.negative | v.negative) === 0), this.iuor(v);
      }, l.prototype.or = function(v) {
        return this.length > v.length ? this.clone().ior(v) : v.clone().ior(this);
      }, l.prototype.uor = function(v) {
        return this.length > v.length ? this.clone().iuor(v) : v.clone().iuor(this);
      }, l.prototype.iuand = function(v) {
        var Te;
        this.length > v.length ? Te = v : Te = this;
        for (var De = 0; De < Te.length; De++)
          this.words[De] = this.words[De] & v.words[De];
        return this.length = Te.length, this._strip();
      }, l.prototype.iand = function(v) {
        return o((this.negative | v.negative) === 0), this.iuand(v);
      }, l.prototype.and = function(v) {
        return this.length > v.length ? this.clone().iand(v) : v.clone().iand(this);
      }, l.prototype.uand = function(v) {
        return this.length > v.length ? this.clone().iuand(v) : v.clone().iuand(this);
      }, l.prototype.iuxor = function(v) {
        var Te, De;
        this.length > v.length ? (Te = this, De = v) : (Te = v, De = this);
        for (var be = 0; be < De.length; be++)
          this.words[be] = Te.words[be] ^ De.words[be];
        if (this !== Te)
          for (; be < Te.length; be++)
            this.words[be] = Te.words[be];
        return this.length = Te.length, this._strip();
      }, l.prototype.ixor = function(v) {
        return o((this.negative | v.negative) === 0), this.iuxor(v);
      }, l.prototype.xor = function(v) {
        return this.length > v.length ? this.clone().ixor(v) : v.clone().ixor(this);
      }, l.prototype.uxor = function(v) {
        return this.length > v.length ? this.clone().iuxor(v) : v.clone().iuxor(this);
      }, l.prototype.inotn = function(v) {
        o(typeof v == "number" && v >= 0);
        var Te = Math.ceil(v / 26) | 0, De = v % 26;
        this._expand(Te), De > 0 && Te--;
        for (var be = 0; be < Te; be++)
          this.words[be] = ~this.words[be] & 67108863;
        return De > 0 && (this.words[be] = ~this.words[be] & 67108863 >> 26 - De), this._strip();
      }, l.prototype.notn = function(v) {
        return this.clone().inotn(v);
      }, l.prototype.setn = function(v, Te) {
        o(typeof v == "number" && v >= 0);
        var De = v / 26 | 0, be = v % 26;
        return this._expand(De + 1), Te ? this.words[De] = this.words[De] | 1 << be : this.words[De] = this.words[De] & ~(1 << be), this._strip();
      }, l.prototype.iadd = function(v) {
        var Te;
        if (this.negative !== 0 && v.negative === 0)
          return this.negative = 0, Te = this.isub(v), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && v.negative !== 0)
          return v.negative = 0, Te = this.isub(v), v.negative = 1, Te._normSign();
        var De, be;
        this.length > v.length ? (De = this, be = v) : (De = v, be = this);
        for (var ze = 0, ke = 0; ke < be.length; ke++)
          Te = (De.words[ke] | 0) + (be.words[ke] | 0) + ze, this.words[ke] = Te & 67108863, ze = Te >>> 26;
        for (; ze !== 0 && ke < De.length; ke++)
          Te = (De.words[ke] | 0) + ze, this.words[ke] = Te & 67108863, ze = Te >>> 26;
        if (this.length = De.length, ze !== 0)
          this.words[this.length] = ze, this.length++;
        else if (De !== this)
          for (; ke < De.length; ke++)
            this.words[ke] = De.words[ke];
        return this;
      }, l.prototype.add = function(v) {
        var Te;
        return v.negative !== 0 && this.negative === 0 ? (v.negative = 0, Te = this.sub(v), v.negative ^= 1, Te) : v.negative === 0 && this.negative !== 0 ? (this.negative = 0, Te = v.sub(this), this.negative = 1, Te) : this.length > v.length ? this.clone().iadd(v) : v.clone().iadd(this);
      }, l.prototype.isub = function(v) {
        if (v.negative !== 0) {
          v.negative = 0;
          var Te = this.iadd(v);
          return v.negative = 1, Te._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(v), this.negative = 1, this._normSign();
        var De = this.cmp(v);
        if (De === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var be, ze;
        De > 0 ? (be = this, ze = v) : (be = v, ze = this);
        for (var ke = 0, Be = 0; Be < ze.length; Be++)
          Te = (be.words[Be] | 0) - (ze.words[Be] | 0) + ke, ke = Te >> 26, this.words[Be] = Te & 67108863;
        for (; ke !== 0 && Be < be.length; Be++)
          Te = (be.words[Be] | 0) + ke, ke = Te >> 26, this.words[Be] = Te & 67108863;
        if (ke === 0 && Be < be.length && be !== this)
          for (; Be < be.length; Be++)
            this.words[Be] = be.words[Be];
        return this.length = Math.max(this.length, Be), be !== this && (this.negative = 1), this._strip();
      }, l.prototype.sub = function(v) {
        return this.clone().isub(v);
      };
      function F(ae, v, Te) {
        Te.negative = v.negative ^ ae.negative;
        var De = ae.length + v.length | 0;
        Te.length = De, De = De - 1 | 0;
        var be = ae.words[0] | 0, ze = v.words[0] | 0, ke = be * ze, Be = ke & 67108863, Me = ke / 67108864 | 0;
        Te.words[0] = Be;
        for (var me = 1; me < De; me++) {
          for (var Se = Me >>> 26, xt = Me & 67108863, Ht = Math.min(me, v.length - 1), Bt = Math.max(0, me - ae.length + 1); Bt <= Ht; Bt++) {
            var ut = me - Bt | 0;
            be = ae.words[ut] | 0, ze = v.words[Bt] | 0, ke = be * ze + xt, Se += ke / 67108864 | 0, xt = ke & 67108863;
          }
          Te.words[me] = xt | 0, Me = Se | 0;
        }
        return Me !== 0 ? Te.words[me] = Me | 0 : Te.length--, Te._strip();
      }
      var W = function(v, Te, De) {
        var be = v.words, ze = Te.words, ke = De.words, Be = 0, Me, me, Se, xt = be[0] | 0, Ht = xt & 8191, Bt = xt >>> 13, ut = be[1] | 0, Tt = ut & 8191, Yt = ut >>> 13, an = be[2] | 0, Ct = an & 8191, st = an >>> 13, jt = be[3] | 0, lt = jt & 8191, Zt = jt >>> 13, Et = be[4] | 0, Ke = Et & 8191, $e = Et >>> 13, pt = be[5] | 0, Jt = pt & 8191, In = pt >>> 13, Cn = be[6] | 0, It = Cn & 8191, ht = Cn >>> 13, Wt = be[7] | 0, hn = Wt & 8191, Vt = Wt >>> 13, Tn = be[8] | 0, Rn = Tn & 8191, Nn = Tn >>> 13, Dn = be[9] | 0, xn = Dn & 8191, $n = Dn >>> 13, Kn = ze[0] | 0, ir = Kn & 8191, er = Kn >>> 13, br = ze[1] | 0, cs = br & 8191, Gn = br >>> 13, Jn = ze[2] | 0, Xn = Jn & 8191, rr = Jn >>> 13, _r = ze[3] | 0, Ss = _r & 8191, is = _r >>> 13, Ms = ze[4] | 0, ls = Ms & 8191, Ur = Ms >>> 13, Qr = ze[5] | 0, Fr = Qr & 8191, Lr = Qr >>> 13, Hr = ze[6] | 0, ns = Hr & 8191, Ts = Hr >>> 13, en = ze[7] | 0, to = en & 8191, bs = en >>> 13, jn = ze[8] | 0, lr = jn & 8191, pr = jn >>> 13, En = ze[9] | 0, qn = En & 8191, Wn = En >>> 13;
        De.negative = v.negative ^ Te.negative, De.length = 19, Me = Math.imul(Ht, ir), me = Math.imul(Ht, er), me = me + Math.imul(Bt, ir) | 0, Se = Math.imul(Bt, er);
        var kn = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (kn >>> 26) | 0, kn &= 67108863, Me = Math.imul(Tt, ir), me = Math.imul(Tt, er), me = me + Math.imul(Yt, ir) | 0, Se = Math.imul(Yt, er), Me = Me + Math.imul(Ht, cs) | 0, me = me + Math.imul(Ht, Gn) | 0, me = me + Math.imul(Bt, cs) | 0, Se = Se + Math.imul(Bt, Gn) | 0;
        var zn = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (zn >>> 26) | 0, zn &= 67108863, Me = Math.imul(Ct, ir), me = Math.imul(Ct, er), me = me + Math.imul(st, ir) | 0, Se = Math.imul(st, er), Me = Me + Math.imul(Tt, cs) | 0, me = me + Math.imul(Tt, Gn) | 0, me = me + Math.imul(Yt, cs) | 0, Se = Se + Math.imul(Yt, Gn) | 0, Me = Me + Math.imul(Ht, Xn) | 0, me = me + Math.imul(Ht, rr) | 0, me = me + Math.imul(Bt, Xn) | 0, Se = Se + Math.imul(Bt, rr) | 0;
        var wr = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (wr >>> 26) | 0, wr &= 67108863, Me = Math.imul(lt, ir), me = Math.imul(lt, er), me = me + Math.imul(Zt, ir) | 0, Se = Math.imul(Zt, er), Me = Me + Math.imul(Ct, cs) | 0, me = me + Math.imul(Ct, Gn) | 0, me = me + Math.imul(st, cs) | 0, Se = Se + Math.imul(st, Gn) | 0, Me = Me + Math.imul(Tt, Xn) | 0, me = me + Math.imul(Tt, rr) | 0, me = me + Math.imul(Yt, Xn) | 0, Se = Se + Math.imul(Yt, rr) | 0, Me = Me + Math.imul(Ht, Ss) | 0, me = me + Math.imul(Ht, is) | 0, me = me + Math.imul(Bt, Ss) | 0, Se = Se + Math.imul(Bt, is) | 0;
        var jr = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (jr >>> 26) | 0, jr &= 67108863, Me = Math.imul(Ke, ir), me = Math.imul(Ke, er), me = me + Math.imul($e, ir) | 0, Se = Math.imul($e, er), Me = Me + Math.imul(lt, cs) | 0, me = me + Math.imul(lt, Gn) | 0, me = me + Math.imul(Zt, cs) | 0, Se = Se + Math.imul(Zt, Gn) | 0, Me = Me + Math.imul(Ct, Xn) | 0, me = me + Math.imul(Ct, rr) | 0, me = me + Math.imul(st, Xn) | 0, Se = Se + Math.imul(st, rr) | 0, Me = Me + Math.imul(Tt, Ss) | 0, me = me + Math.imul(Tt, is) | 0, me = me + Math.imul(Yt, Ss) | 0, Se = Se + Math.imul(Yt, is) | 0, Me = Me + Math.imul(Ht, ls) | 0, me = me + Math.imul(Ht, Ur) | 0, me = me + Math.imul(Bt, ls) | 0, Se = Se + Math.imul(Bt, Ur) | 0;
        var Vr = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, Me = Math.imul(Jt, ir), me = Math.imul(Jt, er), me = me + Math.imul(In, ir) | 0, Se = Math.imul(In, er), Me = Me + Math.imul(Ke, cs) | 0, me = me + Math.imul(Ke, Gn) | 0, me = me + Math.imul($e, cs) | 0, Se = Se + Math.imul($e, Gn) | 0, Me = Me + Math.imul(lt, Xn) | 0, me = me + Math.imul(lt, rr) | 0, me = me + Math.imul(Zt, Xn) | 0, Se = Se + Math.imul(Zt, rr) | 0, Me = Me + Math.imul(Ct, Ss) | 0, me = me + Math.imul(Ct, is) | 0, me = me + Math.imul(st, Ss) | 0, Se = Se + Math.imul(st, is) | 0, Me = Me + Math.imul(Tt, ls) | 0, me = me + Math.imul(Tt, Ur) | 0, me = me + Math.imul(Yt, ls) | 0, Se = Se + Math.imul(Yt, Ur) | 0, Me = Me + Math.imul(Ht, Fr) | 0, me = me + Math.imul(Ht, Lr) | 0, me = me + Math.imul(Bt, Fr) | 0, Se = Se + Math.imul(Bt, Lr) | 0;
        var us = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (us >>> 26) | 0, us &= 67108863, Me = Math.imul(It, ir), me = Math.imul(It, er), me = me + Math.imul(ht, ir) | 0, Se = Math.imul(ht, er), Me = Me + Math.imul(Jt, cs) | 0, me = me + Math.imul(Jt, Gn) | 0, me = me + Math.imul(In, cs) | 0, Se = Se + Math.imul(In, Gn) | 0, Me = Me + Math.imul(Ke, Xn) | 0, me = me + Math.imul(Ke, rr) | 0, me = me + Math.imul($e, Xn) | 0, Se = Se + Math.imul($e, rr) | 0, Me = Me + Math.imul(lt, Ss) | 0, me = me + Math.imul(lt, is) | 0, me = me + Math.imul(Zt, Ss) | 0, Se = Se + Math.imul(Zt, is) | 0, Me = Me + Math.imul(Ct, ls) | 0, me = me + Math.imul(Ct, Ur) | 0, me = me + Math.imul(st, ls) | 0, Se = Se + Math.imul(st, Ur) | 0, Me = Me + Math.imul(Tt, Fr) | 0, me = me + Math.imul(Tt, Lr) | 0, me = me + Math.imul(Yt, Fr) | 0, Se = Se + Math.imul(Yt, Lr) | 0, Me = Me + Math.imul(Ht, ns) | 0, me = me + Math.imul(Ht, Ts) | 0, me = me + Math.imul(Bt, ns) | 0, Se = Se + Math.imul(Bt, Ts) | 0;
        var Es = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Es >>> 26) | 0, Es &= 67108863, Me = Math.imul(hn, ir), me = Math.imul(hn, er), me = me + Math.imul(Vt, ir) | 0, Se = Math.imul(Vt, er), Me = Me + Math.imul(It, cs) | 0, me = me + Math.imul(It, Gn) | 0, me = me + Math.imul(ht, cs) | 0, Se = Se + Math.imul(ht, Gn) | 0, Me = Me + Math.imul(Jt, Xn) | 0, me = me + Math.imul(Jt, rr) | 0, me = me + Math.imul(In, Xn) | 0, Se = Se + Math.imul(In, rr) | 0, Me = Me + Math.imul(Ke, Ss) | 0, me = me + Math.imul(Ke, is) | 0, me = me + Math.imul($e, Ss) | 0, Se = Se + Math.imul($e, is) | 0, Me = Me + Math.imul(lt, ls) | 0, me = me + Math.imul(lt, Ur) | 0, me = me + Math.imul(Zt, ls) | 0, Se = Se + Math.imul(Zt, Ur) | 0, Me = Me + Math.imul(Ct, Fr) | 0, me = me + Math.imul(Ct, Lr) | 0, me = me + Math.imul(st, Fr) | 0, Se = Se + Math.imul(st, Lr) | 0, Me = Me + Math.imul(Tt, ns) | 0, me = me + Math.imul(Tt, Ts) | 0, me = me + Math.imul(Yt, ns) | 0, Se = Se + Math.imul(Yt, Ts) | 0, Me = Me + Math.imul(Ht, to) | 0, me = me + Math.imul(Ht, bs) | 0, me = me + Math.imul(Bt, to) | 0, Se = Se + Math.imul(Bt, bs) | 0;
        var Dr = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, Me = Math.imul(Rn, ir), me = Math.imul(Rn, er), me = me + Math.imul(Nn, ir) | 0, Se = Math.imul(Nn, er), Me = Me + Math.imul(hn, cs) | 0, me = me + Math.imul(hn, Gn) | 0, me = me + Math.imul(Vt, cs) | 0, Se = Se + Math.imul(Vt, Gn) | 0, Me = Me + Math.imul(It, Xn) | 0, me = me + Math.imul(It, rr) | 0, me = me + Math.imul(ht, Xn) | 0, Se = Se + Math.imul(ht, rr) | 0, Me = Me + Math.imul(Jt, Ss) | 0, me = me + Math.imul(Jt, is) | 0, me = me + Math.imul(In, Ss) | 0, Se = Se + Math.imul(In, is) | 0, Me = Me + Math.imul(Ke, ls) | 0, me = me + Math.imul(Ke, Ur) | 0, me = me + Math.imul($e, ls) | 0, Se = Se + Math.imul($e, Ur) | 0, Me = Me + Math.imul(lt, Fr) | 0, me = me + Math.imul(lt, Lr) | 0, me = me + Math.imul(Zt, Fr) | 0, Se = Se + Math.imul(Zt, Lr) | 0, Me = Me + Math.imul(Ct, ns) | 0, me = me + Math.imul(Ct, Ts) | 0, me = me + Math.imul(st, ns) | 0, Se = Se + Math.imul(st, Ts) | 0, Me = Me + Math.imul(Tt, to) | 0, me = me + Math.imul(Tt, bs) | 0, me = me + Math.imul(Yt, to) | 0, Se = Se + Math.imul(Yt, bs) | 0, Me = Me + Math.imul(Ht, lr) | 0, me = me + Math.imul(Ht, pr) | 0, me = me + Math.imul(Bt, lr) | 0, Se = Se + Math.imul(Bt, pr) | 0;
        var Kr = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Kr >>> 26) | 0, Kr &= 67108863, Me = Math.imul(xn, ir), me = Math.imul(xn, er), me = me + Math.imul($n, ir) | 0, Se = Math.imul($n, er), Me = Me + Math.imul(Rn, cs) | 0, me = me + Math.imul(Rn, Gn) | 0, me = me + Math.imul(Nn, cs) | 0, Se = Se + Math.imul(Nn, Gn) | 0, Me = Me + Math.imul(hn, Xn) | 0, me = me + Math.imul(hn, rr) | 0, me = me + Math.imul(Vt, Xn) | 0, Se = Se + Math.imul(Vt, rr) | 0, Me = Me + Math.imul(It, Ss) | 0, me = me + Math.imul(It, is) | 0, me = me + Math.imul(ht, Ss) | 0, Se = Se + Math.imul(ht, is) | 0, Me = Me + Math.imul(Jt, ls) | 0, me = me + Math.imul(Jt, Ur) | 0, me = me + Math.imul(In, ls) | 0, Se = Se + Math.imul(In, Ur) | 0, Me = Me + Math.imul(Ke, Fr) | 0, me = me + Math.imul(Ke, Lr) | 0, me = me + Math.imul($e, Fr) | 0, Se = Se + Math.imul($e, Lr) | 0, Me = Me + Math.imul(lt, ns) | 0, me = me + Math.imul(lt, Ts) | 0, me = me + Math.imul(Zt, ns) | 0, Se = Se + Math.imul(Zt, Ts) | 0, Me = Me + Math.imul(Ct, to) | 0, me = me + Math.imul(Ct, bs) | 0, me = me + Math.imul(st, to) | 0, Se = Se + Math.imul(st, bs) | 0, Me = Me + Math.imul(Tt, lr) | 0, me = me + Math.imul(Tt, pr) | 0, me = me + Math.imul(Yt, lr) | 0, Se = Se + Math.imul(Yt, pr) | 0, Me = Me + Math.imul(Ht, qn) | 0, me = me + Math.imul(Ht, Wn) | 0, me = me + Math.imul(Bt, qn) | 0, Se = Se + Math.imul(Bt, Wn) | 0;
        var Js = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Js >>> 26) | 0, Js &= 67108863, Me = Math.imul(xn, cs), me = Math.imul(xn, Gn), me = me + Math.imul($n, cs) | 0, Se = Math.imul($n, Gn), Me = Me + Math.imul(Rn, Xn) | 0, me = me + Math.imul(Rn, rr) | 0, me = me + Math.imul(Nn, Xn) | 0, Se = Se + Math.imul(Nn, rr) | 0, Me = Me + Math.imul(hn, Ss) | 0, me = me + Math.imul(hn, is) | 0, me = me + Math.imul(Vt, Ss) | 0, Se = Se + Math.imul(Vt, is) | 0, Me = Me + Math.imul(It, ls) | 0, me = me + Math.imul(It, Ur) | 0, me = me + Math.imul(ht, ls) | 0, Se = Se + Math.imul(ht, Ur) | 0, Me = Me + Math.imul(Jt, Fr) | 0, me = me + Math.imul(Jt, Lr) | 0, me = me + Math.imul(In, Fr) | 0, Se = Se + Math.imul(In, Lr) | 0, Me = Me + Math.imul(Ke, ns) | 0, me = me + Math.imul(Ke, Ts) | 0, me = me + Math.imul($e, ns) | 0, Se = Se + Math.imul($e, Ts) | 0, Me = Me + Math.imul(lt, to) | 0, me = me + Math.imul(lt, bs) | 0, me = me + Math.imul(Zt, to) | 0, Se = Se + Math.imul(Zt, bs) | 0, Me = Me + Math.imul(Ct, lr) | 0, me = me + Math.imul(Ct, pr) | 0, me = me + Math.imul(st, lr) | 0, Se = Se + Math.imul(st, pr) | 0, Me = Me + Math.imul(Tt, qn) | 0, me = me + Math.imul(Tt, Wn) | 0, me = me + Math.imul(Yt, qn) | 0, Se = Se + Math.imul(Yt, Wn) | 0;
        var io = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (io >>> 26) | 0, io &= 67108863, Me = Math.imul(xn, Xn), me = Math.imul(xn, rr), me = me + Math.imul($n, Xn) | 0, Se = Math.imul($n, rr), Me = Me + Math.imul(Rn, Ss) | 0, me = me + Math.imul(Rn, is) | 0, me = me + Math.imul(Nn, Ss) | 0, Se = Se + Math.imul(Nn, is) | 0, Me = Me + Math.imul(hn, ls) | 0, me = me + Math.imul(hn, Ur) | 0, me = me + Math.imul(Vt, ls) | 0, Se = Se + Math.imul(Vt, Ur) | 0, Me = Me + Math.imul(It, Fr) | 0, me = me + Math.imul(It, Lr) | 0, me = me + Math.imul(ht, Fr) | 0, Se = Se + Math.imul(ht, Lr) | 0, Me = Me + Math.imul(Jt, ns) | 0, me = me + Math.imul(Jt, Ts) | 0, me = me + Math.imul(In, ns) | 0, Se = Se + Math.imul(In, Ts) | 0, Me = Me + Math.imul(Ke, to) | 0, me = me + Math.imul(Ke, bs) | 0, me = me + Math.imul($e, to) | 0, Se = Se + Math.imul($e, bs) | 0, Me = Me + Math.imul(lt, lr) | 0, me = me + Math.imul(lt, pr) | 0, me = me + Math.imul(Zt, lr) | 0, Se = Se + Math.imul(Zt, pr) | 0, Me = Me + Math.imul(Ct, qn) | 0, me = me + Math.imul(Ct, Wn) | 0, me = me + Math.imul(st, qn) | 0, Se = Se + Math.imul(st, Wn) | 0;
        var No = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (No >>> 26) | 0, No &= 67108863, Me = Math.imul(xn, Ss), me = Math.imul(xn, is), me = me + Math.imul($n, Ss) | 0, Se = Math.imul($n, is), Me = Me + Math.imul(Rn, ls) | 0, me = me + Math.imul(Rn, Ur) | 0, me = me + Math.imul(Nn, ls) | 0, Se = Se + Math.imul(Nn, Ur) | 0, Me = Me + Math.imul(hn, Fr) | 0, me = me + Math.imul(hn, Lr) | 0, me = me + Math.imul(Vt, Fr) | 0, Se = Se + Math.imul(Vt, Lr) | 0, Me = Me + Math.imul(It, ns) | 0, me = me + Math.imul(It, Ts) | 0, me = me + Math.imul(ht, ns) | 0, Se = Se + Math.imul(ht, Ts) | 0, Me = Me + Math.imul(Jt, to) | 0, me = me + Math.imul(Jt, bs) | 0, me = me + Math.imul(In, to) | 0, Se = Se + Math.imul(In, bs) | 0, Me = Me + Math.imul(Ke, lr) | 0, me = me + Math.imul(Ke, pr) | 0, me = me + Math.imul($e, lr) | 0, Se = Se + Math.imul($e, pr) | 0, Me = Me + Math.imul(lt, qn) | 0, me = me + Math.imul(lt, Wn) | 0, me = me + Math.imul(Zt, qn) | 0, Se = Se + Math.imul(Zt, Wn) | 0;
        var Ai = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Ai >>> 26) | 0, Ai &= 67108863, Me = Math.imul(xn, ls), me = Math.imul(xn, Ur), me = me + Math.imul($n, ls) | 0, Se = Math.imul($n, Ur), Me = Me + Math.imul(Rn, Fr) | 0, me = me + Math.imul(Rn, Lr) | 0, me = me + Math.imul(Nn, Fr) | 0, Se = Se + Math.imul(Nn, Lr) | 0, Me = Me + Math.imul(hn, ns) | 0, me = me + Math.imul(hn, Ts) | 0, me = me + Math.imul(Vt, ns) | 0, Se = Se + Math.imul(Vt, Ts) | 0, Me = Me + Math.imul(It, to) | 0, me = me + Math.imul(It, bs) | 0, me = me + Math.imul(ht, to) | 0, Se = Se + Math.imul(ht, bs) | 0, Me = Me + Math.imul(Jt, lr) | 0, me = me + Math.imul(Jt, pr) | 0, me = me + Math.imul(In, lr) | 0, Se = Se + Math.imul(In, pr) | 0, Me = Me + Math.imul(Ke, qn) | 0, me = me + Math.imul(Ke, Wn) | 0, me = me + Math.imul($e, qn) | 0, Se = Se + Math.imul($e, Wn) | 0;
        var go = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (go >>> 26) | 0, go &= 67108863, Me = Math.imul(xn, Fr), me = Math.imul(xn, Lr), me = me + Math.imul($n, Fr) | 0, Se = Math.imul($n, Lr), Me = Me + Math.imul(Rn, ns) | 0, me = me + Math.imul(Rn, Ts) | 0, me = me + Math.imul(Nn, ns) | 0, Se = Se + Math.imul(Nn, Ts) | 0, Me = Me + Math.imul(hn, to) | 0, me = me + Math.imul(hn, bs) | 0, me = me + Math.imul(Vt, to) | 0, Se = Se + Math.imul(Vt, bs) | 0, Me = Me + Math.imul(It, lr) | 0, me = me + Math.imul(It, pr) | 0, me = me + Math.imul(ht, lr) | 0, Se = Se + Math.imul(ht, pr) | 0, Me = Me + Math.imul(Jt, qn) | 0, me = me + Math.imul(Jt, Wn) | 0, me = me + Math.imul(In, qn) | 0, Se = Se + Math.imul(In, Wn) | 0;
        var ks = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (ks >>> 26) | 0, ks &= 67108863, Me = Math.imul(xn, ns), me = Math.imul(xn, Ts), me = me + Math.imul($n, ns) | 0, Se = Math.imul($n, Ts), Me = Me + Math.imul(Rn, to) | 0, me = me + Math.imul(Rn, bs) | 0, me = me + Math.imul(Nn, to) | 0, Se = Se + Math.imul(Nn, bs) | 0, Me = Me + Math.imul(hn, lr) | 0, me = me + Math.imul(hn, pr) | 0, me = me + Math.imul(Vt, lr) | 0, Se = Se + Math.imul(Vt, pr) | 0, Me = Me + Math.imul(It, qn) | 0, me = me + Math.imul(It, Wn) | 0, me = me + Math.imul(ht, qn) | 0, Se = Se + Math.imul(ht, Wn) | 0;
        var Ci = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Ci >>> 26) | 0, Ci &= 67108863, Me = Math.imul(xn, to), me = Math.imul(xn, bs), me = me + Math.imul($n, to) | 0, Se = Math.imul($n, bs), Me = Me + Math.imul(Rn, lr) | 0, me = me + Math.imul(Rn, pr) | 0, me = me + Math.imul(Nn, lr) | 0, Se = Se + Math.imul(Nn, pr) | 0, Me = Me + Math.imul(hn, qn) | 0, me = me + Math.imul(hn, Wn) | 0, me = me + Math.imul(Vt, qn) | 0, Se = Se + Math.imul(Vt, Wn) | 0;
        var Io = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Io >>> 26) | 0, Io &= 67108863, Me = Math.imul(xn, lr), me = Math.imul(xn, pr), me = me + Math.imul($n, lr) | 0, Se = Math.imul($n, pr), Me = Me + Math.imul(Rn, qn) | 0, me = me + Math.imul(Rn, Wn) | 0, me = me + Math.imul(Nn, qn) | 0, Se = Se + Math.imul(Nn, Wn) | 0;
        var Oo = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        Be = (Se + (me >>> 13) | 0) + (Oo >>> 26) | 0, Oo &= 67108863, Me = Math.imul(xn, qn), me = Math.imul(xn, Wn), me = me + Math.imul($n, qn) | 0, Se = Math.imul($n, Wn);
        var Zs = (Be + Me | 0) + ((me & 8191) << 13) | 0;
        return Be = (Se + (me >>> 13) | 0) + (Zs >>> 26) | 0, Zs &= 67108863, ke[0] = kn, ke[1] = zn, ke[2] = wr, ke[3] = jr, ke[4] = Vr, ke[5] = us, ke[6] = Es, ke[7] = Dr, ke[8] = Kr, ke[9] = Js, ke[10] = io, ke[11] = No, ke[12] = Ai, ke[13] = go, ke[14] = ks, ke[15] = Ci, ke[16] = Io, ke[17] = Oo, ke[18] = Zs, Be !== 0 && (ke[19] = Be, De.length++), De;
      };
      Math.imul || (W = F);
      function G(ae, v, Te) {
        Te.negative = v.negative ^ ae.negative, Te.length = ae.length + v.length;
        for (var De = 0, be = 0, ze = 0; ze < Te.length - 1; ze++) {
          var ke = be;
          be = 0;
          for (var Be = De & 67108863, Me = Math.min(ze, v.length - 1), me = Math.max(0, ze - ae.length + 1); me <= Me; me++) {
            var Se = ze - me, xt = ae.words[Se] | 0, Ht = v.words[me] | 0, Bt = xt * Ht, ut = Bt & 67108863;
            ke = ke + (Bt / 67108864 | 0) | 0, ut = ut + Be | 0, Be = ut & 67108863, ke = ke + (ut >>> 26) | 0, be += ke >>> 26, ke &= 67108863;
          }
          Te.words[ze] = Be, De = ke, ke = be;
        }
        return De !== 0 ? Te.words[ze] = De : Te.length--, Te._strip();
      }
      function q(ae, v, Te) {
        return G(ae, v, Te);
      }
      l.prototype.mulTo = function(v, Te) {
        var De, be = this.length + v.length;
        return this.length === 10 && v.length === 10 ? De = W(this, v, Te) : be < 63 ? De = F(this, v, Te) : be < 1024 ? De = G(this, v, Te) : De = q(this, v, Te), De;
      }, l.prototype.mul = function(v) {
        var Te = new l(null);
        return Te.words = new Array(this.length + v.length), this.mulTo(v, Te);
      }, l.prototype.mulf = function(v) {
        var Te = new l(null);
        return Te.words = new Array(this.length + v.length), q(this, v, Te);
      }, l.prototype.imul = function(v) {
        return this.clone().mulTo(v, this);
      }, l.prototype.imuln = function(v) {
        var Te = v < 0;
        Te && (v = -v), o(typeof v == "number"), o(v < 67108864);
        for (var De = 0, be = 0; be < this.length; be++) {
          var ze = (this.words[be] | 0) * v, ke = (ze & 67108863) + (De & 67108863);
          De >>= 26, De += ze / 67108864 | 0, De += ke >>> 26, this.words[be] = ke & 67108863;
        }
        return De !== 0 && (this.words[be] = De, this.length++), this.length = v === 0 ? 1 : this.length, Te ? this.ineg() : this;
      }, l.prototype.muln = function(v) {
        return this.clone().imuln(v);
      }, l.prototype.sqr = function() {
        return this.mul(this);
      }, l.prototype.isqr = function() {
        return this.imul(this.clone());
      }, l.prototype.pow = function(v) {
        var Te = L(v);
        if (Te.length === 0)
          return new l(1);
        for (var De = this, be = 0; be < Te.length && Te[be] === 0; be++, De = De.sqr())
          ;
        if (++be < Te.length)
          for (var ze = De.sqr(); be < Te.length; be++, ze = ze.sqr())
            Te[be] !== 0 && (De = De.mul(ze));
        return De;
      }, l.prototype.iushln = function(v) {
        o(typeof v == "number" && v >= 0);
        var Te = v % 26, De = (v - Te) / 26, be = 67108863 >>> 26 - Te << 26 - Te, ze;
        if (Te !== 0) {
          var ke = 0;
          for (ze = 0; ze < this.length; ze++) {
            var Be = this.words[ze] & be, Me = (this.words[ze] | 0) - Be << Te;
            this.words[ze] = Me | ke, ke = Be >>> 26 - Te;
          }
          ke && (this.words[ze] = ke, this.length++);
        }
        if (De !== 0) {
          for (ze = this.length - 1; ze >= 0; ze--)
            this.words[ze + De] = this.words[ze];
          for (ze = 0; ze < De; ze++)
            this.words[ze] = 0;
          this.length += De;
        }
        return this._strip();
      }, l.prototype.ishln = function(v) {
        return o(this.negative === 0), this.iushln(v);
      }, l.prototype.iushrn = function(v, Te, De) {
        o(typeof v == "number" && v >= 0);
        var be;
        Te ? be = (Te - Te % 26) / 26 : be = 0;
        var ze = v % 26, ke = Math.min((v - ze) / 26, this.length), Be = 67108863 ^ 67108863 >>> ze << ze, Me = De;
        if (be -= ke, be = Math.max(0, be), Me) {
          for (var me = 0; me < ke; me++)
            Me.words[me] = this.words[me];
          Me.length = ke;
        }
        if (ke !== 0)
          if (this.length > ke)
            for (this.length -= ke, me = 0; me < this.length; me++)
              this.words[me] = this.words[me + ke];
          else
            this.words[0] = 0, this.length = 1;
        var Se = 0;
        for (me = this.length - 1; me >= 0 && (Se !== 0 || me >= be); me--) {
          var xt = this.words[me] | 0;
          this.words[me] = Se << 26 - ze | xt >>> ze, Se = xt & Be;
        }
        return Me && Se !== 0 && (Me.words[Me.length++] = Se), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, l.prototype.ishrn = function(v, Te, De) {
        return o(this.negative === 0), this.iushrn(v, Te, De);
      }, l.prototype.shln = function(v) {
        return this.clone().ishln(v);
      }, l.prototype.ushln = function(v) {
        return this.clone().iushln(v);
      }, l.prototype.shrn = function(v) {
        return this.clone().ishrn(v);
      }, l.prototype.ushrn = function(v) {
        return this.clone().iushrn(v);
      }, l.prototype.testn = function(v) {
        o(typeof v == "number" && v >= 0);
        var Te = v % 26, De = (v - Te) / 26, be = 1 << Te;
        if (this.length <= De)
          return !1;
        var ze = this.words[De];
        return !!(ze & be);
      }, l.prototype.imaskn = function(v) {
        o(typeof v == "number" && v >= 0);
        var Te = v % 26, De = (v - Te) / 26;
        if (o(this.negative === 0, "imaskn works only with positive numbers"), this.length <= De)
          return this;
        if (Te !== 0 && De++, this.length = Math.min(De, this.length), Te !== 0) {
          var be = 67108863 ^ 67108863 >>> Te << Te;
          this.words[this.length - 1] &= be;
        }
        return this._strip();
      }, l.prototype.maskn = function(v) {
        return this.clone().imaskn(v);
      }, l.prototype.iaddn = function(v) {
        return o(typeof v == "number"), o(v < 67108864), v < 0 ? this.isubn(-v) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= v ? (this.words[0] = v - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(v), this.negative = 1, this) : this._iaddn(v);
      }, l.prototype._iaddn = function(v) {
        this.words[0] += v;
        for (var Te = 0; Te < this.length && this.words[Te] >= 67108864; Te++)
          this.words[Te] -= 67108864, Te === this.length - 1 ? this.words[Te + 1] = 1 : this.words[Te + 1]++;
        return this.length = Math.max(this.length, Te + 1), this;
      }, l.prototype.isubn = function(v) {
        if (o(typeof v == "number"), o(v < 67108864), v < 0)
          return this.iaddn(-v);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(v), this.negative = 1, this;
        if (this.words[0] -= v, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var Te = 0; Te < this.length && this.words[Te] < 0; Te++)
            this.words[Te] += 67108864, this.words[Te + 1] -= 1;
        return this._strip();
      }, l.prototype.addn = function(v) {
        return this.clone().iaddn(v);
      }, l.prototype.subn = function(v) {
        return this.clone().isubn(v);
      }, l.prototype.iabs = function() {
        return this.negative = 0, this;
      }, l.prototype.abs = function() {
        return this.clone().iabs();
      }, l.prototype._ishlnsubmul = function(v, Te, De) {
        var be = v.length + De, ze;
        this._expand(be);
        var ke, Be = 0;
        for (ze = 0; ze < v.length; ze++) {
          ke = (this.words[ze + De] | 0) + Be;
          var Me = (v.words[ze] | 0) * Te;
          ke -= Me & 67108863, Be = (ke >> 26) - (Me / 67108864 | 0), this.words[ze + De] = ke & 67108863;
        }
        for (; ze < this.length - De; ze++)
          ke = (this.words[ze + De] | 0) + Be, Be = ke >> 26, this.words[ze + De] = ke & 67108863;
        if (Be === 0)
          return this._strip();
        for (o(Be === -1), Be = 0, ze = 0; ze < this.length; ze++)
          ke = -(this.words[ze] | 0) + Be, Be = ke >> 26, this.words[ze] = ke & 67108863;
        return this.negative = 1, this._strip();
      }, l.prototype._wordDiv = function(v, Te) {
        var De = this.length - v.length, be = this.clone(), ze = v, ke = ze.words[ze.length - 1] | 0, Be = this._countBits(ke);
        De = 26 - Be, De !== 0 && (ze = ze.ushln(De), be.iushln(De), ke = ze.words[ze.length - 1] | 0);
        var Me = be.length - ze.length, me;
        if (Te !== "mod") {
          me = new l(null), me.length = Me + 1, me.words = new Array(me.length);
          for (var Se = 0; Se < me.length; Se++)
            me.words[Se] = 0;
        }
        var xt = be.clone()._ishlnsubmul(ze, 1, Me);
        xt.negative === 0 && (be = xt, me && (me.words[Me] = 1));
        for (var Ht = Me - 1; Ht >= 0; Ht--) {
          var Bt = (be.words[ze.length + Ht] | 0) * 67108864 + (be.words[ze.length + Ht - 1] | 0);
          for (Bt = Math.min(Bt / ke | 0, 67108863), be._ishlnsubmul(ze, Bt, Ht); be.negative !== 0; )
            Bt--, be.negative = 0, be._ishlnsubmul(ze, 1, Ht), be.isZero() || (be.negative ^= 1);
          me && (me.words[Ht] = Bt);
        }
        return me && me._strip(), be._strip(), Te !== "div" && De !== 0 && be.iushrn(De), {
          div: me || null,
          mod: be
        };
      }, l.prototype.divmod = function(v, Te, De) {
        if (o(!v.isZero()), this.isZero())
          return {
            div: new l(0),
            mod: new l(0)
          };
        var be, ze, ke;
        return this.negative !== 0 && v.negative === 0 ? (ke = this.neg().divmod(v, Te), Te !== "mod" && (be = ke.div.neg()), Te !== "div" && (ze = ke.mod.neg(), De && ze.negative !== 0 && ze.iadd(v)), {
          div: be,
          mod: ze
        }) : this.negative === 0 && v.negative !== 0 ? (ke = this.divmod(v.neg(), Te), Te !== "mod" && (be = ke.div.neg()), {
          div: be,
          mod: ke.mod
        }) : this.negative & v.negative ? (ke = this.neg().divmod(v.neg(), Te), Te !== "div" && (ze = ke.mod.neg(), De && ze.negative !== 0 && ze.isub(v)), {
          div: ke.div,
          mod: ze
        }) : v.length > this.length || this.cmp(v) < 0 ? {
          div: new l(0),
          mod: this
        } : v.length === 1 ? Te === "div" ? {
          div: this.divn(v.words[0]),
          mod: null
        } : Te === "mod" ? {
          div: null,
          mod: new l(this.modrn(v.words[0]))
        } : {
          div: this.divn(v.words[0]),
          mod: new l(this.modrn(v.words[0]))
        } : this._wordDiv(v, Te);
      }, l.prototype.div = function(v) {
        return this.divmod(v, "div", !1).div;
      }, l.prototype.mod = function(v) {
        return this.divmod(v, "mod", !1).mod;
      }, l.prototype.umod = function(v) {
        return this.divmod(v, "mod", !0).mod;
      }, l.prototype.divRound = function(v) {
        var Te = this.divmod(v);
        if (Te.mod.isZero())
          return Te.div;
        var De = Te.div.negative !== 0 ? Te.mod.isub(v) : Te.mod, be = v.ushrn(1), ze = v.andln(1), ke = De.cmp(be);
        return ke < 0 || ze === 1 && ke === 0 ? Te.div : Te.div.negative !== 0 ? Te.div.isubn(1) : Te.div.iaddn(1);
      }, l.prototype.modrn = function(v) {
        var Te = v < 0;
        Te && (v = -v), o(v <= 67108863);
        for (var De = (1 << 26) % v, be = 0, ze = this.length - 1; ze >= 0; ze--)
          be = (De * be + (this.words[ze] | 0)) % v;
        return Te ? -be : be;
      }, l.prototype.modn = function(v) {
        return this.modrn(v);
      }, l.prototype.idivn = function(v) {
        var Te = v < 0;
        Te && (v = -v), o(v <= 67108863);
        for (var De = 0, be = this.length - 1; be >= 0; be--) {
          var ze = (this.words[be] | 0) + De * 67108864;
          this.words[be] = ze / v | 0, De = ze % v;
        }
        return this._strip(), Te ? this.ineg() : this;
      }, l.prototype.divn = function(v) {
        return this.clone().idivn(v);
      }, l.prototype.egcd = function(v) {
        o(v.negative === 0), o(!v.isZero());
        var Te = this, De = v.clone();
        Te.negative !== 0 ? Te = Te.umod(v) : Te = Te.clone();
        for (var be = new l(1), ze = new l(0), ke = new l(0), Be = new l(1), Me = 0; Te.isEven() && De.isEven(); )
          Te.iushrn(1), De.iushrn(1), ++Me;
        for (var me = De.clone(), Se = Te.clone(); !Te.isZero(); ) {
          for (var xt = 0, Ht = 1; !(Te.words[0] & Ht) && xt < 26; ++xt, Ht <<= 1)
            ;
          if (xt > 0)
            for (Te.iushrn(xt); xt-- > 0; )
              (be.isOdd() || ze.isOdd()) && (be.iadd(me), ze.isub(Se)), be.iushrn(1), ze.iushrn(1);
          for (var Bt = 0, ut = 1; !(De.words[0] & ut) && Bt < 26; ++Bt, ut <<= 1)
            ;
          if (Bt > 0)
            for (De.iushrn(Bt); Bt-- > 0; )
              (ke.isOdd() || Be.isOdd()) && (ke.iadd(me), Be.isub(Se)), ke.iushrn(1), Be.iushrn(1);
          Te.cmp(De) >= 0 ? (Te.isub(De), be.isub(ke), ze.isub(Be)) : (De.isub(Te), ke.isub(be), Be.isub(ze));
        }
        return {
          a: ke,
          b: Be,
          gcd: De.iushln(Me)
        };
      }, l.prototype._invmp = function(v) {
        o(v.negative === 0), o(!v.isZero());
        var Te = this, De = v.clone();
        Te.negative !== 0 ? Te = Te.umod(v) : Te = Te.clone();
        for (var be = new l(1), ze = new l(0), ke = De.clone(); Te.cmpn(1) > 0 && De.cmpn(1) > 0; ) {
          for (var Be = 0, Me = 1; !(Te.words[0] & Me) && Be < 26; ++Be, Me <<= 1)
            ;
          if (Be > 0)
            for (Te.iushrn(Be); Be-- > 0; )
              be.isOdd() && be.iadd(ke), be.iushrn(1);
          for (var me = 0, Se = 1; !(De.words[0] & Se) && me < 26; ++me, Se <<= 1)
            ;
          if (me > 0)
            for (De.iushrn(me); me-- > 0; )
              ze.isOdd() && ze.iadd(ke), ze.iushrn(1);
          Te.cmp(De) >= 0 ? (Te.isub(De), be.isub(ze)) : (De.isub(Te), ze.isub(be));
        }
        var xt;
        return Te.cmpn(1) === 0 ? xt = be : xt = ze, xt.cmpn(0) < 0 && xt.iadd(v), xt;
      }, l.prototype.gcd = function(v) {
        if (this.isZero())
          return v.abs();
        if (v.isZero())
          return this.abs();
        var Te = this.clone(), De = v.clone();
        Te.negative = 0, De.negative = 0;
        for (var be = 0; Te.isEven() && De.isEven(); be++)
          Te.iushrn(1), De.iushrn(1);
        do {
          for (; Te.isEven(); )
            Te.iushrn(1);
          for (; De.isEven(); )
            De.iushrn(1);
          var ze = Te.cmp(De);
          if (ze < 0) {
            var ke = Te;
            Te = De, De = ke;
          } else if (ze === 0 || De.cmpn(1) === 0)
            break;
          Te.isub(De);
        } while (!0);
        return De.iushln(be);
      }, l.prototype.invm = function(v) {
        return this.egcd(v).a.umod(v);
      }, l.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, l.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, l.prototype.andln = function(v) {
        return this.words[0] & v;
      }, l.prototype.bincn = function(v) {
        o(typeof v == "number");
        var Te = v % 26, De = (v - Te) / 26, be = 1 << Te;
        if (this.length <= De)
          return this._expand(De + 1), this.words[De] |= be, this;
        for (var ze = be, ke = De; ze !== 0 && ke < this.length; ke++) {
          var Be = this.words[ke] | 0;
          Be += ze, ze = Be >>> 26, Be &= 67108863, this.words[ke] = Be;
        }
        return ze !== 0 && (this.words[ke] = ze, this.length++), this;
      }, l.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, l.prototype.cmpn = function(v) {
        var Te = v < 0;
        if (this.negative !== 0 && !Te)
          return -1;
        if (this.negative === 0 && Te)
          return 1;
        this._strip();
        var De;
        if (this.length > 1)
          De = 1;
        else {
          Te && (v = -v), o(v <= 67108863, "Number is too big");
          var be = this.words[0] | 0;
          De = be === v ? 0 : be < v ? -1 : 1;
        }
        return this.negative !== 0 ? -De | 0 : De;
      }, l.prototype.cmp = function(v) {
        if (this.negative !== 0 && v.negative === 0)
          return -1;
        if (this.negative === 0 && v.negative !== 0)
          return 1;
        var Te = this.ucmp(v);
        return this.negative !== 0 ? -Te | 0 : Te;
      }, l.prototype.ucmp = function(v) {
        if (this.length > v.length)
          return 1;
        if (this.length < v.length)
          return -1;
        for (var Te = 0, De = this.length - 1; De >= 0; De--) {
          var be = this.words[De] | 0, ze = v.words[De] | 0;
          if (be !== ze) {
            be < ze ? Te = -1 : be > ze && (Te = 1);
            break;
          }
        }
        return Te;
      }, l.prototype.gtn = function(v) {
        return this.cmpn(v) === 1;
      }, l.prototype.gt = function(v) {
        return this.cmp(v) === 1;
      }, l.prototype.gten = function(v) {
        return this.cmpn(v) >= 0;
      }, l.prototype.gte = function(v) {
        return this.cmp(v) >= 0;
      }, l.prototype.ltn = function(v) {
        return this.cmpn(v) === -1;
      }, l.prototype.lt = function(v) {
        return this.cmp(v) === -1;
      }, l.prototype.lten = function(v) {
        return this.cmpn(v) <= 0;
      }, l.prototype.lte = function(v) {
        return this.cmp(v) <= 0;
      }, l.prototype.eqn = function(v) {
        return this.cmpn(v) === 0;
      }, l.prototype.eq = function(v) {
        return this.cmp(v) === 0;
      }, l.red = function(v) {
        return new ve(v);
      }, l.prototype.toRed = function(v) {
        return o(!this.red, "Already a number in reduction context"), o(this.negative === 0, "red works only with positives"), v.convertTo(this)._forceRed(v);
      }, l.prototype.fromRed = function() {
        return o(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, l.prototype._forceRed = function(v) {
        return this.red = v, this;
      }, l.prototype.forceRed = function(v) {
        return o(!this.red, "Already a number in reduction context"), this._forceRed(v);
      }, l.prototype.redAdd = function(v) {
        return o(this.red, "redAdd works only with red numbers"), this.red.add(this, v);
      }, l.prototype.redIAdd = function(v) {
        return o(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, v);
      }, l.prototype.redSub = function(v) {
        return o(this.red, "redSub works only with red numbers"), this.red.sub(this, v);
      }, l.prototype.redISub = function(v) {
        return o(this.red, "redISub works only with red numbers"), this.red.isub(this, v);
      }, l.prototype.redShl = function(v) {
        return o(this.red, "redShl works only with red numbers"), this.red.shl(this, v);
      }, l.prototype.redMul = function(v) {
        return o(this.red, "redMul works only with red numbers"), this.red._verify2(this, v), this.red.mul(this, v);
      }, l.prototype.redIMul = function(v) {
        return o(this.red, "redMul works only with red numbers"), this.red._verify2(this, v), this.red.imul(this, v);
      }, l.prototype.redSqr = function() {
        return o(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, l.prototype.redISqr = function() {
        return o(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, l.prototype.redSqrt = function() {
        return o(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, l.prototype.redInvm = function() {
        return o(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, l.prototype.redNeg = function() {
        return o(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, l.prototype.redPow = function(v) {
        return o(this.red && !v.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, v);
      };
      var fe = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function _e(ae, v) {
        this.name = ae, this.p = new l(v, 16), this.n = this.p.bitLength(), this.k = new l(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      _e.prototype._tmp = function() {
        var v = new l(null);
        return v.words = new Array(Math.ceil(this.n / 13)), v;
      }, _e.prototype.ireduce = function(v) {
        var Te = v, De;
        do
          this.split(Te, this.tmp), Te = this.imulK(Te), Te = Te.iadd(this.tmp), De = Te.bitLength();
        while (De > this.n);
        var be = De < this.n ? -1 : Te.ucmp(this.p);
        return be === 0 ? (Te.words[0] = 0, Te.length = 1) : be > 0 ? Te.isub(this.p) : Te.strip !== void 0 ? Te.strip() : Te._strip(), Te;
      }, _e.prototype.split = function(v, Te) {
        v.iushrn(this.n, 0, Te);
      }, _e.prototype.imulK = function(v) {
        return v.imul(this.k);
      };
      function Le() {
        _e.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      a(Le, _e), Le.prototype.split = function(v, Te) {
        for (var De = 4194303, be = Math.min(v.length, 9), ze = 0; ze < be; ze++)
          Te.words[ze] = v.words[ze];
        if (Te.length = be, v.length <= 9) {
          v.words[0] = 0, v.length = 1;
          return;
        }
        var ke = v.words[9];
        for (Te.words[Te.length++] = ke & De, ze = 10; ze < v.length; ze++) {
          var Be = v.words[ze] | 0;
          v.words[ze - 10] = (Be & De) << 4 | ke >>> 22, ke = Be;
        }
        ke >>>= 22, v.words[ze - 10] = ke, ke === 0 && v.length > 10 ? v.length -= 10 : v.length -= 9;
      }, Le.prototype.imulK = function(v) {
        v.words[v.length] = 0, v.words[v.length + 1] = 0, v.length += 2;
        for (var Te = 0, De = 0; De < v.length; De++) {
          var be = v.words[De] | 0;
          Te += be * 977, v.words[De] = Te & 67108863, Te = be * 64 + (Te / 67108864 | 0);
        }
        return v.words[v.length - 1] === 0 && (v.length--, v.words[v.length - 1] === 0 && v.length--), v;
      };
      function Fe() {
        _e.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      a(Fe, _e);
      function Ee() {
        _e.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      a(Ee, _e);
      function Ge() {
        _e.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      a(Ge, _e), Ge.prototype.imulK = function(v) {
        for (var Te = 0, De = 0; De < v.length; De++) {
          var be = (v.words[De] | 0) * 19 + Te, ze = be & 67108863;
          be >>>= 26, v.words[De] = ze, Te = be;
        }
        return Te !== 0 && (v.words[v.length++] = Te), v;
      }, l._prime = function(v) {
        if (fe[v])
          return fe[v];
        var Te;
        if (v === "k256")
          Te = new Le();
        else if (v === "p224")
          Te = new Fe();
        else if (v === "p192")
          Te = new Ee();
        else if (v === "p25519")
          Te = new Ge();
        else
          throw new Error("Unknown prime " + v);
        return fe[v] = Te, Te;
      };
      function ve(ae) {
        if (typeof ae == "string") {
          var v = l._prime(ae);
          this.m = v.p, this.prime = v;
        } else
          o(ae.gtn(1), "modulus must be greater than 1"), this.m = ae, this.prime = null;
      }
      ve.prototype._verify1 = function(v) {
        o(v.negative === 0, "red works only with positives"), o(v.red, "red works only with red numbers");
      }, ve.prototype._verify2 = function(v, Te) {
        o((v.negative | Te.negative) === 0, "red works only with positives"), o(
          v.red && v.red === Te.red,
          "red works only with red numbers"
        );
      }, ve.prototype.imod = function(v) {
        return this.prime ? this.prime.ireduce(v)._forceRed(this) : (f(v, v.umod(this.m)._forceRed(this)), v);
      }, ve.prototype.neg = function(v) {
        return v.isZero() ? v.clone() : this.m.sub(v)._forceRed(this);
      }, ve.prototype.add = function(v, Te) {
        this._verify2(v, Te);
        var De = v.add(Te);
        return De.cmp(this.m) >= 0 && De.isub(this.m), De._forceRed(this);
      }, ve.prototype.iadd = function(v, Te) {
        this._verify2(v, Te);
        var De = v.iadd(Te);
        return De.cmp(this.m) >= 0 && De.isub(this.m), De;
      }, ve.prototype.sub = function(v, Te) {
        this._verify2(v, Te);
        var De = v.sub(Te);
        return De.cmpn(0) < 0 && De.iadd(this.m), De._forceRed(this);
      }, ve.prototype.isub = function(v, Te) {
        this._verify2(v, Te);
        var De = v.isub(Te);
        return De.cmpn(0) < 0 && De.iadd(this.m), De;
      }, ve.prototype.shl = function(v, Te) {
        return this._verify1(v), this.imod(v.ushln(Te));
      }, ve.prototype.imul = function(v, Te) {
        return this._verify2(v, Te), this.imod(v.imul(Te));
      }, ve.prototype.mul = function(v, Te) {
        return this._verify2(v, Te), this.imod(v.mul(Te));
      }, ve.prototype.isqr = function(v) {
        return this.imul(v, v.clone());
      }, ve.prototype.sqr = function(v) {
        return this.mul(v, v);
      }, ve.prototype.sqrt = function(v) {
        if (v.isZero())
          return v.clone();
        var Te = this.m.andln(3);
        if (o(Te % 2 === 1), Te === 3) {
          var De = this.m.add(new l(1)).iushrn(2);
          return this.pow(v, De);
        }
        for (var be = this.m.subn(1), ze = 0; !be.isZero() && be.andln(1) === 0; )
          ze++, be.iushrn(1);
        o(!be.isZero());
        var ke = new l(1).toRed(this), Be = ke.redNeg(), Me = this.m.subn(1).iushrn(1), me = this.m.bitLength();
        for (me = new l(2 * me * me).toRed(this); this.pow(me, Me).cmp(Be) !== 0; )
          me.redIAdd(Be);
        for (var Se = this.pow(me, be), xt = this.pow(v, be.addn(1).iushrn(1)), Ht = this.pow(v, be), Bt = ze; Ht.cmp(ke) !== 0; ) {
          for (var ut = Ht, Tt = 0; ut.cmp(ke) !== 0; Tt++)
            ut = ut.redSqr();
          o(Tt < Bt);
          var Yt = this.pow(Se, new l(1).iushln(Bt - Tt - 1));
          xt = xt.redMul(Yt), Se = Yt.redSqr(), Ht = Ht.redMul(Se), Bt = Tt;
        }
        return xt;
      }, ve.prototype.invm = function(v) {
        var Te = v._invmp(this.m);
        return Te.negative !== 0 ? (Te.negative = 0, this.imod(Te).redNeg()) : this.imod(Te);
      }, ve.prototype.pow = function(v, Te) {
        if (Te.isZero())
          return new l(1).toRed(this);
        if (Te.cmpn(1) === 0)
          return v.clone();
        var De = 4, be = new Array(1 << De);
        be[0] = new l(1).toRed(this), be[1] = v;
        for (var ze = 2; ze < be.length; ze++)
          be[ze] = this.mul(be[ze - 1], v);
        var ke = be[0], Be = 0, Me = 0, me = Te.bitLength() % 26;
        for (me === 0 && (me = 26), ze = Te.length - 1; ze >= 0; ze--) {
          for (var Se = Te.words[ze], xt = me - 1; xt >= 0; xt--) {
            var Ht = Se >> xt & 1;
            if (ke !== be[0] && (ke = this.sqr(ke)), Ht === 0 && Be === 0) {
              Me = 0;
              continue;
            }
            Be <<= 1, Be |= Ht, Me++, !(Me !== De && (ze !== 0 || xt !== 0)) && (ke = this.mul(ke, be[Be]), Me = 0, Be = 0);
          }
          me = 26;
        }
        return ke;
      }, ve.prototype.convertTo = function(v) {
        var Te = v.umod(this.m);
        return Te === v ? Te.clone() : Te;
      }, ve.prototype.convertFrom = function(v) {
        var Te = v.clone();
        return Te.red = null, Te;
      }, l.mont = function(v) {
        return new te(v);
      };
      function te(ae) {
        ve.call(this, ae), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new l(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      a(te, ve), te.prototype.convertTo = function(v) {
        return this.imod(v.ushln(this.shift));
      }, te.prototype.convertFrom = function(v) {
        var Te = this.imod(v.mul(this.rinv));
        return Te.red = null, Te;
      }, te.prototype.imul = function(v, Te) {
        if (v.isZero() || Te.isZero())
          return v.words[0] = 0, v.length = 1, v;
        var De = v.imul(Te), be = De.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ze = De.isub(be).iushrn(this.shift), ke = ze;
        return ze.cmp(this.m) >= 0 ? ke = ze.isub(this.m) : ze.cmpn(0) < 0 && (ke = ze.iadd(this.m)), ke._forceRed(this);
      }, te.prototype.mul = function(v, Te) {
        if (v.isZero() || Te.isZero())
          return new l(0)._forceRed(this);
        var De = v.mul(Te), be = De.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), ze = De.isub(be).iushrn(this.shift), ke = ze;
        return ze.cmp(this.m) >= 0 ? ke = ze.isub(this.m) : ze.cmpn(0) < 0 && (ke = ze.iadd(this.m)), ke._forceRed(this);
      }, te.prototype.invm = function(v) {
        var Te = this.imod(v._invmp(this.m).mul(this.r2));
        return Te._forceRed(this);
      };
    })(r, commonjsGlobal);
  }(bn)), bn.exports;
}
var browserifyRsa, hasRequiredBrowserifyRsa;
function requireBrowserifyRsa() {
  if (hasRequiredBrowserifyRsa)
    return browserifyRsa;
  hasRequiredBrowserifyRsa = 1;
  var r = requireBn(), e = requireBrowser$b(), s = requireSafeBuffer$1().Buffer;
  function o(u) {
    var c = u.modulus.byteLength(), E;
    do
      E = new r(e(c));
    while (E.cmp(u.modulus) >= 0 || !E.umod(u.prime1) || !E.umod(u.prime2));
    return E;
  }
  function a(u) {
    var c = o(u), E = c.toRed(r.mont(u.modulus)).redPow(new r(u.publicExponent)).fromRed();
    return { blinder: E, unblinder: c.invm(u.modulus) };
  }
  function l(u, c) {
    var E = a(c), d = c.modulus.byteLength(), f = new r(u).mul(E.blinder).umod(c.modulus), h = f.toRed(r.mont(c.prime1)), S = f.toRed(r.mont(c.prime2)), R = c.coefficient, _ = c.prime1, m = c.prime2, L = h.redPow(c.exponent1).fromRed(), F = S.redPow(c.exponent2).fromRed(), W = L.isub(F).imul(R).umod(_).imul(m);
    return F.iadd(W).imul(E.unblinder).umod(c.modulus).toArrayLike(s, "be", d);
  }
  return l.getr = o, browserifyRsa = l, browserifyRsa;
}
var elliptic = {};
const name = "elliptic", version = "6.6.1", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0$2 = {
  name,
  version,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$2 = {}, utils$1 = {}, hasRequiredUtils$2;
function requireUtils$2() {
  return hasRequiredUtils$2 || (hasRequiredUtils$2 = 1, function(r) {
    var e = r;
    function s(l, u) {
      if (Array.isArray(l))
        return l.slice();
      if (!l)
        return [];
      var c = [];
      if (typeof l != "string") {
        for (var E = 0; E < l.length; E++)
          c[E] = l[E] | 0;
        return c;
      }
      if (u === "hex") {
        l = l.replace(/[^a-z0-9]+/ig, ""), l.length % 2 !== 0 && (l = "0" + l);
        for (var E = 0; E < l.length; E += 2)
          c.push(parseInt(l[E] + l[E + 1], 16));
      } else
        for (var E = 0; E < l.length; E++) {
          var d = l.charCodeAt(E), f = d >> 8, h = d & 255;
          f ? c.push(f, h) : c.push(h);
        }
      return c;
    }
    e.toArray = s;
    function o(l) {
      return l.length === 1 ? "0" + l : l;
    }
    e.zero2 = o;
    function a(l) {
      for (var u = "", c = 0; c < l.length; c++)
        u += o(l[c].toString(16));
      return u;
    }
    e.toHex = a, e.encode = function(u, c) {
      return c === "hex" ? a(u) : u;
    };
  }(utils$1)), utils$1;
}
var hasRequiredUtils$1;
function requireUtils$1() {
  return hasRequiredUtils$1 || (hasRequiredUtils$1 = 1, function(r) {
    var e = r, s = requireBn$1(), o = requireMinimalisticAssert(), a = requireUtils$2();
    e.assert = o, e.toArray = a.toArray, e.zero2 = a.zero2, e.toHex = a.toHex, e.encode = a.encode;
    function l(f, h, S) {
      var R = new Array(Math.max(f.bitLength(), S) + 1), _;
      for (_ = 0; _ < R.length; _ += 1)
        R[_] = 0;
      var m = 1 << h + 1, L = f.clone();
      for (_ = 0; _ < R.length; _++) {
        var F, W = L.andln(m - 1);
        L.isOdd() ? (W > (m >> 1) - 1 ? F = (m >> 1) - W : F = W, L.isubn(F)) : F = 0, R[_] = F, L.iushrn(1);
      }
      return R;
    }
    e.getNAF = l;
    function u(f, h) {
      var S = [
        [],
        []
      ];
      f = f.clone(), h = h.clone();
      for (var R = 0, _ = 0, m; f.cmpn(-R) > 0 || h.cmpn(-_) > 0; ) {
        var L = f.andln(3) + R & 3, F = h.andln(3) + _ & 3;
        L === 3 && (L = -1), F === 3 && (F = -1);
        var W;
        L & 1 ? (m = f.andln(7) + R & 7, (m === 3 || m === 5) && F === 2 ? W = -L : W = L) : W = 0, S[0].push(W);
        var G;
        F & 1 ? (m = h.andln(7) + _ & 7, (m === 3 || m === 5) && L === 2 ? G = -F : G = F) : G = 0, S[1].push(G), 2 * R === W + 1 && (R = 1 - R), 2 * _ === G + 1 && (_ = 1 - _), f.iushrn(1), h.iushrn(1);
      }
      return S;
    }
    e.getJSF = u;
    function c(f, h, S) {
      var R = "_" + h;
      f.prototype[h] = function() {
        return this[R] !== void 0 ? this[R] : this[R] = S.call(this);
      };
    }
    e.cachedProperty = c;
    function E(f) {
      return typeof f == "string" ? e.toArray(f, "hex") : f;
    }
    e.parseBytes = E;
    function d(f) {
      return new s(f, "hex", "le");
    }
    e.intFromLE = d;
  }(utils$2)), utils$2;
}
var curve = {}, base$1, hasRequiredBase$1;
function requireBase$1() {
  if (hasRequiredBase$1)
    return base$1;
  hasRequiredBase$1 = 1;
  var r = requireBn$1(), e = requireUtils$1(), s = e.getNAF, o = e.getJSF, a = e.assert;
  function l(c, E) {
    this.type = c, this.p = new r(E.p, 16), this.red = E.prime ? r.red(E.prime) : r.mont(this.p), this.zero = new r(0).toRed(this.red), this.one = new r(1).toRed(this.red), this.two = new r(2).toRed(this.red), this.n = E.n && new r(E.n, 16), this.g = E.g && this.pointFromJSON(E.g, E.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var d = this.n && this.p.div(this.n);
    !d || d.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  base$1 = l, l.prototype.point = function() {
    throw new Error("Not implemented");
  }, l.prototype.validate = function() {
    throw new Error("Not implemented");
  }, l.prototype._fixedNafMul = function(E, d) {
    a(E.precomputed);
    var f = E._getDoubles(), h = s(d, 1, this._bitLength), S = (1 << f.step + 1) - (f.step % 2 === 0 ? 2 : 1);
    S /= 3;
    var R = [], _, m;
    for (_ = 0; _ < h.length; _ += f.step) {
      m = 0;
      for (var L = _ + f.step - 1; L >= _; L--)
        m = (m << 1) + h[L];
      R.push(m);
    }
    for (var F = this.jpoint(null, null, null), W = this.jpoint(null, null, null), G = S; G > 0; G--) {
      for (_ = 0; _ < R.length; _++)
        m = R[_], m === G ? W = W.mixedAdd(f.points[_]) : m === -G && (W = W.mixedAdd(f.points[_].neg()));
      F = F.add(W);
    }
    return F.toP();
  }, l.prototype._wnafMul = function(E, d) {
    var f = 4, h = E._getNAFPoints(f);
    f = h.wnd;
    for (var S = h.points, R = s(d, f, this._bitLength), _ = this.jpoint(null, null, null), m = R.length - 1; m >= 0; m--) {
      for (var L = 0; m >= 0 && R[m] === 0; m--)
        L++;
      if (m >= 0 && L++, _ = _.dblp(L), m < 0)
        break;
      var F = R[m];
      a(F !== 0), E.type === "affine" ? F > 0 ? _ = _.mixedAdd(S[F - 1 >> 1]) : _ = _.mixedAdd(S[-F - 1 >> 1].neg()) : F > 0 ? _ = _.add(S[F - 1 >> 1]) : _ = _.add(S[-F - 1 >> 1].neg());
    }
    return E.type === "affine" ? _.toP() : _;
  }, l.prototype._wnafMulAdd = function(E, d, f, h, S) {
    var R = this._wnafT1, _ = this._wnafT2, m = this._wnafT3, L = 0, F, W, G;
    for (F = 0; F < h; F++) {
      G = d[F];
      var q = G._getNAFPoints(E);
      R[F] = q.wnd, _[F] = q.points;
    }
    for (F = h - 1; F >= 1; F -= 2) {
      var fe = F - 1, _e = F;
      if (R[fe] !== 1 || R[_e] !== 1) {
        m[fe] = s(f[fe], R[fe], this._bitLength), m[_e] = s(f[_e], R[_e], this._bitLength), L = Math.max(m[fe].length, L), L = Math.max(m[_e].length, L);
        continue;
      }
      var Le = [
        d[fe],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        d[_e]
        /* 7 */
      ];
      d[fe].y.cmp(d[_e].y) === 0 ? (Le[1] = d[fe].add(d[_e]), Le[2] = d[fe].toJ().mixedAdd(d[_e].neg())) : d[fe].y.cmp(d[_e].y.redNeg()) === 0 ? (Le[1] = d[fe].toJ().mixedAdd(d[_e]), Le[2] = d[fe].add(d[_e].neg())) : (Le[1] = d[fe].toJ().mixedAdd(d[_e]), Le[2] = d[fe].toJ().mixedAdd(d[_e].neg()));
      var Fe = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], Ee = o(f[fe], f[_e]);
      for (L = Math.max(Ee[0].length, L), m[fe] = new Array(L), m[_e] = new Array(L), W = 0; W < L; W++) {
        var Ge = Ee[0][W] | 0, ve = Ee[1][W] | 0;
        m[fe][W] = Fe[(Ge + 1) * 3 + (ve + 1)], m[_e][W] = 0, _[fe] = Le;
      }
    }
    var te = this.jpoint(null, null, null), ae = this._wnafT4;
    for (F = L; F >= 0; F--) {
      for (var v = 0; F >= 0; ) {
        var Te = !0;
        for (W = 0; W < h; W++)
          ae[W] = m[W][F] | 0, ae[W] !== 0 && (Te = !1);
        if (!Te)
          break;
        v++, F--;
      }
      if (F >= 0 && v++, te = te.dblp(v), F < 0)
        break;
      for (W = 0; W < h; W++) {
        var De = ae[W];
        De !== 0 && (De > 0 ? G = _[W][De - 1 >> 1] : De < 0 && (G = _[W][-De - 1 >> 1].neg()), G.type === "affine" ? te = te.mixedAdd(G) : te = te.add(G));
      }
    }
    for (F = 0; F < h; F++)
      _[F] = null;
    return S ? te : te.toP();
  };
  function u(c, E) {
    this.curve = c, this.type = E, this.precomputed = null;
  }
  return l.BasePoint = u, u.prototype.eq = function() {
    throw new Error("Not implemented");
  }, u.prototype.validate = function() {
    return this.curve.validate(this);
  }, l.prototype.decodePoint = function(E, d) {
    E = e.toArray(E, d);
    var f = this.p.byteLength();
    if ((E[0] === 4 || E[0] === 6 || E[0] === 7) && E.length - 1 === 2 * f) {
      E[0] === 6 ? a(E[E.length - 1] % 2 === 0) : E[0] === 7 && a(E[E.length - 1] % 2 === 1);
      var h = this.point(
        E.slice(1, 1 + f),
        E.slice(1 + f, 1 + 2 * f)
      );
      return h;
    } else if ((E[0] === 2 || E[0] === 3) && E.length - 1 === f)
      return this.pointFromX(E.slice(1, 1 + f), E[0] === 3);
    throw new Error("Unknown point format");
  }, u.prototype.encodeCompressed = function(E) {
    return this.encode(E, !0);
  }, u.prototype._encode = function(E) {
    var d = this.curve.p.byteLength(), f = this.getX().toArray("be", d);
    return E ? [this.getY().isEven() ? 2 : 3].concat(f) : [4].concat(f, this.getY().toArray("be", d));
  }, u.prototype.encode = function(E, d) {
    return e.encode(this._encode(d), E);
  }, u.prototype.precompute = function(E) {
    if (this.precomputed)
      return this;
    var d = {
      doubles: null,
      naf: null,
      beta: null
    };
    return d.naf = this._getNAFPoints(8), d.doubles = this._getDoubles(4, E), d.beta = this._getBeta(), this.precomputed = d, this;
  }, u.prototype._hasDoubles = function(E) {
    if (!this.precomputed)
      return !1;
    var d = this.precomputed.doubles;
    return d ? d.points.length >= Math.ceil((E.bitLength() + 1) / d.step) : !1;
  }, u.prototype._getDoubles = function(E, d) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var f = [this], h = this, S = 0; S < d; S += E) {
      for (var R = 0; R < E; R++)
        h = h.dbl();
      f.push(h);
    }
    return {
      step: E,
      points: f
    };
  }, u.prototype._getNAFPoints = function(E) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var d = [this], f = (1 << E) - 1, h = f === 1 ? null : this.dbl(), S = 1; S < f; S++)
      d[S] = d[S - 1].add(h);
    return {
      wnd: E,
      points: d
    };
  }, u.prototype._getBeta = function() {
    return null;
  }, u.prototype.dblp = function(E) {
    for (var d = this, f = 0; f < E; f++)
      d = d.dbl();
    return d;
  }, base$1;
}
var short, hasRequiredShort;
function requireShort() {
  if (hasRequiredShort)
    return short;
  hasRequiredShort = 1;
  var r = requireUtils$1(), e = requireBn$1(), s = requireInherits_browser(), o = requireBase$1(), a = r.assert;
  function l(E) {
    o.call(this, "short", E), this.a = new e(E.a, 16).toRed(this.red), this.b = new e(E.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(E), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  s(l, o), short = l, l.prototype._getEndomorphism = function(d) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var f, h;
      if (d.beta)
        f = new e(d.beta, 16).toRed(this.red);
      else {
        var S = this._getEndoRoots(this.p);
        f = S[0].cmp(S[1]) < 0 ? S[0] : S[1], f = f.toRed(this.red);
      }
      if (d.lambda)
        h = new e(d.lambda, 16);
      else {
        var R = this._getEndoRoots(this.n);
        this.g.mul(R[0]).x.cmp(this.g.x.redMul(f)) === 0 ? h = R[0] : (h = R[1], a(this.g.mul(h).x.cmp(this.g.x.redMul(f)) === 0));
      }
      var _;
      return d.basis ? _ = d.basis.map(function(m) {
        return {
          a: new e(m.a, 16),
          b: new e(m.b, 16)
        };
      }) : _ = this._getEndoBasis(h), {
        beta: f,
        lambda: h,
        basis: _
      };
    }
  }, l.prototype._getEndoRoots = function(d) {
    var f = d === this.p ? this.red : e.mont(d), h = new e(2).toRed(f).redInvm(), S = h.redNeg(), R = new e(3).toRed(f).redNeg().redSqrt().redMul(h), _ = S.redAdd(R).fromRed(), m = S.redSub(R).fromRed();
    return [_, m];
  }, l.prototype._getEndoBasis = function(d) {
    for (var f = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = d, S = this.n.clone(), R = new e(1), _ = new e(0), m = new e(0), L = new e(1), F, W, G, q, fe, _e, Le, Fe = 0, Ee, Ge; h.cmpn(0) !== 0; ) {
      var ve = S.div(h);
      Ee = S.sub(ve.mul(h)), Ge = m.sub(ve.mul(R));
      var te = L.sub(ve.mul(_));
      if (!G && Ee.cmp(f) < 0)
        F = Le.neg(), W = R, G = Ee.neg(), q = Ge;
      else if (G && ++Fe === 2)
        break;
      Le = Ee, S = h, h = Ee, m = R, R = Ge, L = _, _ = te;
    }
    fe = Ee.neg(), _e = Ge;
    var ae = G.sqr().add(q.sqr()), v = fe.sqr().add(_e.sqr());
    return v.cmp(ae) >= 0 && (fe = F, _e = W), G.negative && (G = G.neg(), q = q.neg()), fe.negative && (fe = fe.neg(), _e = _e.neg()), [
      { a: G, b: q },
      { a: fe, b: _e }
    ];
  }, l.prototype._endoSplit = function(d) {
    var f = this.endo.basis, h = f[0], S = f[1], R = S.b.mul(d).divRound(this.n), _ = h.b.neg().mul(d).divRound(this.n), m = R.mul(h.a), L = _.mul(S.a), F = R.mul(h.b), W = _.mul(S.b), G = d.sub(m).sub(L), q = F.add(W).neg();
    return { k1: G, k2: q };
  }, l.prototype.pointFromX = function(d, f) {
    d = new e(d, 16), d.red || (d = d.toRed(this.red));
    var h = d.redSqr().redMul(d).redIAdd(d.redMul(this.a)).redIAdd(this.b), S = h.redSqrt();
    if (S.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var R = S.fromRed().isOdd();
    return (f && !R || !f && R) && (S = S.redNeg()), this.point(d, S);
  }, l.prototype.validate = function(d) {
    if (d.inf)
      return !0;
    var f = d.x, h = d.y, S = this.a.redMul(f), R = f.redSqr().redMul(f).redIAdd(S).redIAdd(this.b);
    return h.redSqr().redISub(R).cmpn(0) === 0;
  }, l.prototype._endoWnafMulAdd = function(d, f, h) {
    for (var S = this._endoWnafT1, R = this._endoWnafT2, _ = 0; _ < d.length; _++) {
      var m = this._endoSplit(f[_]), L = d[_], F = L._getBeta();
      m.k1.negative && (m.k1.ineg(), L = L.neg(!0)), m.k2.negative && (m.k2.ineg(), F = F.neg(!0)), S[_ * 2] = L, S[_ * 2 + 1] = F, R[_ * 2] = m.k1, R[_ * 2 + 1] = m.k2;
    }
    for (var W = this._wnafMulAdd(1, S, R, _ * 2, h), G = 0; G < _ * 2; G++)
      S[G] = null, R[G] = null;
    return W;
  };
  function u(E, d, f, h) {
    o.BasePoint.call(this, E, "affine"), d === null && f === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(d, 16), this.y = new e(f, 16), h && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  s(u, o.BasePoint), l.prototype.point = function(d, f, h) {
    return new u(this, d, f, h);
  }, l.prototype.pointFromJSON = function(d, f) {
    return u.fromJSON(this, d, f);
  }, u.prototype._getBeta = function() {
    if (this.curve.endo) {
      var d = this.precomputed;
      if (d && d.beta)
        return d.beta;
      var f = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (d) {
        var h = this.curve, S = function(R) {
          return h.point(R.x.redMul(h.endo.beta), R.y);
        };
        d.beta = f, f.precomputed = {
          beta: null,
          naf: d.naf && {
            wnd: d.naf.wnd,
            points: d.naf.points.map(S)
          },
          doubles: d.doubles && {
            step: d.doubles.step,
            points: d.doubles.points.map(S)
          }
        };
      }
      return f;
    }
  }, u.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, u.fromJSON = function(d, f, h) {
    typeof f == "string" && (f = JSON.parse(f));
    var S = d.point(f[0], f[1], h);
    if (!f[2])
      return S;
    function R(m) {
      return d.point(m[0], m[1], h);
    }
    var _ = f[2];
    return S.precomputed = {
      beta: null,
      doubles: _.doubles && {
        step: _.doubles.step,
        points: [S].concat(_.doubles.points.map(R))
      },
      naf: _.naf && {
        wnd: _.naf.wnd,
        points: [S].concat(_.naf.points.map(R))
      }
    }, S;
  }, u.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function() {
    return this.inf;
  }, u.prototype.add = function(d) {
    if (this.inf)
      return d;
    if (d.inf)
      return this;
    if (this.eq(d))
      return this.dbl();
    if (this.neg().eq(d))
      return this.curve.point(null, null);
    if (this.x.cmp(d.x) === 0)
      return this.curve.point(null, null);
    var f = this.y.redSub(d.y);
    f.cmpn(0) !== 0 && (f = f.redMul(this.x.redSub(d.x).redInvm()));
    var h = f.redSqr().redISub(this.x).redISub(d.x), S = f.redMul(this.x.redSub(h)).redISub(this.y);
    return this.curve.point(h, S);
  }, u.prototype.dbl = function() {
    if (this.inf)
      return this;
    var d = this.y.redAdd(this.y);
    if (d.cmpn(0) === 0)
      return this.curve.point(null, null);
    var f = this.curve.a, h = this.x.redSqr(), S = d.redInvm(), R = h.redAdd(h).redIAdd(h).redIAdd(f).redMul(S), _ = R.redSqr().redISub(this.x.redAdd(this.x)), m = R.redMul(this.x.redSub(_)).redISub(this.y);
    return this.curve.point(_, m);
  }, u.prototype.getX = function() {
    return this.x.fromRed();
  }, u.prototype.getY = function() {
    return this.y.fromRed();
  }, u.prototype.mul = function(d) {
    return d = new e(d, 16), this.isInfinity() ? this : this._hasDoubles(d) ? this.curve._fixedNafMul(this, d) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [d]) : this.curve._wnafMul(this, d);
  }, u.prototype.mulAdd = function(d, f, h) {
    var S = [this, f], R = [d, h];
    return this.curve.endo ? this.curve._endoWnafMulAdd(S, R) : this.curve._wnafMulAdd(1, S, R, 2);
  }, u.prototype.jmulAdd = function(d, f, h) {
    var S = [this, f], R = [d, h];
    return this.curve.endo ? this.curve._endoWnafMulAdd(S, R, !0) : this.curve._wnafMulAdd(1, S, R, 2, !0);
  }, u.prototype.eq = function(d) {
    return this === d || this.inf === d.inf && (this.inf || this.x.cmp(d.x) === 0 && this.y.cmp(d.y) === 0);
  }, u.prototype.neg = function(d) {
    if (this.inf)
      return this;
    var f = this.curve.point(this.x, this.y.redNeg());
    if (d && this.precomputed) {
      var h = this.precomputed, S = function(R) {
        return R.neg();
      };
      f.precomputed = {
        naf: h.naf && {
          wnd: h.naf.wnd,
          points: h.naf.points.map(S)
        },
        doubles: h.doubles && {
          step: h.doubles.step,
          points: h.doubles.points.map(S)
        }
      };
    }
    return f;
  }, u.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var d = this.curve.jpoint(this.x, this.y, this.curve.one);
    return d;
  };
  function c(E, d, f, h) {
    o.BasePoint.call(this, E, "jacobian"), d === null && f === null && h === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(d, 16), this.y = new e(f, 16), this.z = new e(h, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return s(c, o.BasePoint), l.prototype.jpoint = function(d, f, h) {
    return new c(this, d, f, h);
  }, c.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var d = this.z.redInvm(), f = d.redSqr(), h = this.x.redMul(f), S = this.y.redMul(f).redMul(d);
    return this.curve.point(h, S);
  }, c.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, c.prototype.add = function(d) {
    if (this.isInfinity())
      return d;
    if (d.isInfinity())
      return this;
    var f = d.z.redSqr(), h = this.z.redSqr(), S = this.x.redMul(f), R = d.x.redMul(h), _ = this.y.redMul(f.redMul(d.z)), m = d.y.redMul(h.redMul(this.z)), L = S.redSub(R), F = _.redSub(m);
    if (L.cmpn(0) === 0)
      return F.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var W = L.redSqr(), G = W.redMul(L), q = S.redMul(W), fe = F.redSqr().redIAdd(G).redISub(q).redISub(q), _e = F.redMul(q.redISub(fe)).redISub(_.redMul(G)), Le = this.z.redMul(d.z).redMul(L);
    return this.curve.jpoint(fe, _e, Le);
  }, c.prototype.mixedAdd = function(d) {
    if (this.isInfinity())
      return d.toJ();
    if (d.isInfinity())
      return this;
    var f = this.z.redSqr(), h = this.x, S = d.x.redMul(f), R = this.y, _ = d.y.redMul(f).redMul(this.z), m = h.redSub(S), L = R.redSub(_);
    if (m.cmpn(0) === 0)
      return L.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var F = m.redSqr(), W = F.redMul(m), G = h.redMul(F), q = L.redSqr().redIAdd(W).redISub(G).redISub(G), fe = L.redMul(G.redISub(q)).redISub(R.redMul(W)), _e = this.z.redMul(m);
    return this.curve.jpoint(q, fe, _e);
  }, c.prototype.dblp = function(d) {
    if (d === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!d)
      return this.dbl();
    var f;
    if (this.curve.zeroA || this.curve.threeA) {
      var h = this;
      for (f = 0; f < d; f++)
        h = h.dbl();
      return h;
    }
    var S = this.curve.a, R = this.curve.tinv, _ = this.x, m = this.y, L = this.z, F = L.redSqr().redSqr(), W = m.redAdd(m);
    for (f = 0; f < d; f++) {
      var G = _.redSqr(), q = W.redSqr(), fe = q.redSqr(), _e = G.redAdd(G).redIAdd(G).redIAdd(S.redMul(F)), Le = _.redMul(q), Fe = _e.redSqr().redISub(Le.redAdd(Le)), Ee = Le.redISub(Fe), Ge = _e.redMul(Ee);
      Ge = Ge.redIAdd(Ge).redISub(fe);
      var ve = W.redMul(L);
      f + 1 < d && (F = F.redMul(fe)), _ = Fe, L = ve, W = Ge;
    }
    return this.curve.jpoint(_, W.redMul(R), L);
  }, c.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, c.prototype._zeroDbl = function() {
    var d, f, h;
    if (this.zOne) {
      var S = this.x.redSqr(), R = this.y.redSqr(), _ = R.redSqr(), m = this.x.redAdd(R).redSqr().redISub(S).redISub(_);
      m = m.redIAdd(m);
      var L = S.redAdd(S).redIAdd(S), F = L.redSqr().redISub(m).redISub(m), W = _.redIAdd(_);
      W = W.redIAdd(W), W = W.redIAdd(W), d = F, f = L.redMul(m.redISub(F)).redISub(W), h = this.y.redAdd(this.y);
    } else {
      var G = this.x.redSqr(), q = this.y.redSqr(), fe = q.redSqr(), _e = this.x.redAdd(q).redSqr().redISub(G).redISub(fe);
      _e = _e.redIAdd(_e);
      var Le = G.redAdd(G).redIAdd(G), Fe = Le.redSqr(), Ee = fe.redIAdd(fe);
      Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), d = Fe.redISub(_e).redISub(_e), f = Le.redMul(_e.redISub(d)).redISub(Ee), h = this.y.redMul(this.z), h = h.redIAdd(h);
    }
    return this.curve.jpoint(d, f, h);
  }, c.prototype._threeDbl = function() {
    var d, f, h;
    if (this.zOne) {
      var S = this.x.redSqr(), R = this.y.redSqr(), _ = R.redSqr(), m = this.x.redAdd(R).redSqr().redISub(S).redISub(_);
      m = m.redIAdd(m);
      var L = S.redAdd(S).redIAdd(S).redIAdd(this.curve.a), F = L.redSqr().redISub(m).redISub(m);
      d = F;
      var W = _.redIAdd(_);
      W = W.redIAdd(W), W = W.redIAdd(W), f = L.redMul(m.redISub(F)).redISub(W), h = this.y.redAdd(this.y);
    } else {
      var G = this.z.redSqr(), q = this.y.redSqr(), fe = this.x.redMul(q), _e = this.x.redSub(G).redMul(this.x.redAdd(G));
      _e = _e.redAdd(_e).redIAdd(_e);
      var Le = fe.redIAdd(fe);
      Le = Le.redIAdd(Le);
      var Fe = Le.redAdd(Le);
      d = _e.redSqr().redISub(Fe), h = this.y.redAdd(this.z).redSqr().redISub(q).redISub(G);
      var Ee = q.redSqr();
      Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), Ee = Ee.redIAdd(Ee), f = _e.redMul(Le.redISub(d)).redISub(Ee);
    }
    return this.curve.jpoint(d, f, h);
  }, c.prototype._dbl = function() {
    var d = this.curve.a, f = this.x, h = this.y, S = this.z, R = S.redSqr().redSqr(), _ = f.redSqr(), m = h.redSqr(), L = _.redAdd(_).redIAdd(_).redIAdd(d.redMul(R)), F = f.redAdd(f);
    F = F.redIAdd(F);
    var W = F.redMul(m), G = L.redSqr().redISub(W.redAdd(W)), q = W.redISub(G), fe = m.redSqr();
    fe = fe.redIAdd(fe), fe = fe.redIAdd(fe), fe = fe.redIAdd(fe);
    var _e = L.redMul(q).redISub(fe), Le = h.redAdd(h).redMul(S);
    return this.curve.jpoint(G, _e, Le);
  }, c.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var d = this.x.redSqr(), f = this.y.redSqr(), h = this.z.redSqr(), S = f.redSqr(), R = d.redAdd(d).redIAdd(d), _ = R.redSqr(), m = this.x.redAdd(f).redSqr().redISub(d).redISub(S);
    m = m.redIAdd(m), m = m.redAdd(m).redIAdd(m), m = m.redISub(_);
    var L = m.redSqr(), F = S.redIAdd(S);
    F = F.redIAdd(F), F = F.redIAdd(F), F = F.redIAdd(F);
    var W = R.redIAdd(m).redSqr().redISub(_).redISub(L).redISub(F), G = f.redMul(W);
    G = G.redIAdd(G), G = G.redIAdd(G);
    var q = this.x.redMul(L).redISub(G);
    q = q.redIAdd(q), q = q.redIAdd(q);
    var fe = this.y.redMul(W.redMul(F.redISub(W)).redISub(m.redMul(L)));
    fe = fe.redIAdd(fe), fe = fe.redIAdd(fe), fe = fe.redIAdd(fe);
    var _e = this.z.redAdd(m).redSqr().redISub(h).redISub(L);
    return this.curve.jpoint(q, fe, _e);
  }, c.prototype.mul = function(d, f) {
    return d = new e(d, f), this.curve._wnafMul(this, d);
  }, c.prototype.eq = function(d) {
    if (d.type === "affine")
      return this.eq(d.toJ());
    if (this === d)
      return !0;
    var f = this.z.redSqr(), h = d.z.redSqr();
    if (this.x.redMul(h).redISub(d.x.redMul(f)).cmpn(0) !== 0)
      return !1;
    var S = f.redMul(this.z), R = h.redMul(d.z);
    return this.y.redMul(R).redISub(d.y.redMul(S)).cmpn(0) === 0;
  }, c.prototype.eqXToP = function(d) {
    var f = this.z.redSqr(), h = d.toRed(this.curve.red).redMul(f);
    if (this.x.cmp(h) === 0)
      return !0;
    for (var S = d.clone(), R = this.curve.redN.redMul(f); ; ) {
      if (S.iadd(this.curve.n), S.cmp(this.curve.p) >= 0)
        return !1;
      if (h.redIAdd(R), this.x.cmp(h) === 0)
        return !0;
    }
  }, c.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, c.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, short;
}
var mont, hasRequiredMont;
function requireMont() {
  if (hasRequiredMont)
    return mont;
  hasRequiredMont = 1;
  var r = requireBn$1(), e = requireInherits_browser(), s = requireBase$1(), o = requireUtils$1();
  function a(u) {
    s.call(this, "mont", u), this.a = new r(u.a, 16).toRed(this.red), this.b = new r(u.b, 16).toRed(this.red), this.i4 = new r(4).toRed(this.red).redInvm(), this.two = new r(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(a, s), mont = a, a.prototype.validate = function(c) {
    var E = c.normalize().x, d = E.redSqr(), f = d.redMul(E).redAdd(d.redMul(this.a)).redAdd(E), h = f.redSqrt();
    return h.redSqr().cmp(f) === 0;
  };
  function l(u, c, E) {
    s.BasePoint.call(this, u, "projective"), c === null && E === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new r(c, 16), this.z = new r(E, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(l, s.BasePoint), a.prototype.decodePoint = function(c, E) {
    return this.point(o.toArray(c, E), 1);
  }, a.prototype.point = function(c, E) {
    return new l(this, c, E);
  }, a.prototype.pointFromJSON = function(c) {
    return l.fromJSON(this, c);
  }, l.prototype.precompute = function() {
  }, l.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, l.fromJSON = function(c, E) {
    return new l(c, E[0], E[1] || c.one);
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, l.prototype.dbl = function() {
    var c = this.x.redAdd(this.z), E = c.redSqr(), d = this.x.redSub(this.z), f = d.redSqr(), h = E.redSub(f), S = E.redMul(f), R = h.redMul(f.redAdd(this.curve.a24.redMul(h)));
    return this.curve.point(S, R);
  }, l.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.diffAdd = function(c, E) {
    var d = this.x.redAdd(this.z), f = this.x.redSub(this.z), h = c.x.redAdd(c.z), S = c.x.redSub(c.z), R = S.redMul(d), _ = h.redMul(f), m = E.z.redMul(R.redAdd(_).redSqr()), L = E.x.redMul(R.redISub(_).redSqr());
    return this.curve.point(m, L);
  }, l.prototype.mul = function(c) {
    for (var E = c.clone(), d = this, f = this.curve.point(null, null), h = this, S = []; E.cmpn(0) !== 0; E.iushrn(1))
      S.push(E.andln(1));
    for (var R = S.length - 1; R >= 0; R--)
      S[R] === 0 ? (d = d.diffAdd(f, h), f = f.dbl()) : (f = d.diffAdd(f, h), d = d.dbl());
    return f;
  }, l.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, l.prototype.eq = function(c) {
    return this.getX().cmp(c.getX()) === 0;
  }, l.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, l.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, mont;
}
var edwards, hasRequiredEdwards;
function requireEdwards() {
  if (hasRequiredEdwards)
    return edwards;
  hasRequiredEdwards = 1;
  var r = requireUtils$1(), e = requireBn$1(), s = requireInherits_browser(), o = requireBase$1(), a = r.assert;
  function l(c) {
    this.twisted = (c.a | 0) !== 1, this.mOneA = this.twisted && (c.a | 0) === -1, this.extended = this.mOneA, o.call(this, "edwards", c), this.a = new e(c.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(c.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(c.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (c.c | 0) === 1;
  }
  s(l, o), edwards = l, l.prototype._mulA = function(E) {
    return this.mOneA ? E.redNeg() : this.a.redMul(E);
  }, l.prototype._mulC = function(E) {
    return this.oneC ? E : this.c.redMul(E);
  }, l.prototype.jpoint = function(E, d, f, h) {
    return this.point(E, d, f, h);
  }, l.prototype.pointFromX = function(E, d) {
    E = new e(E, 16), E.red || (E = E.toRed(this.red));
    var f = E.redSqr(), h = this.c2.redSub(this.a.redMul(f)), S = this.one.redSub(this.c2.redMul(this.d).redMul(f)), R = h.redMul(S.redInvm()), _ = R.redSqrt();
    if (_.redSqr().redSub(R).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var m = _.fromRed().isOdd();
    return (d && !m || !d && m) && (_ = _.redNeg()), this.point(E, _);
  }, l.prototype.pointFromY = function(E, d) {
    E = new e(E, 16), E.red || (E = E.toRed(this.red));
    var f = E.redSqr(), h = f.redSub(this.c2), S = f.redMul(this.d).redMul(this.c2).redSub(this.a), R = h.redMul(S.redInvm());
    if (R.cmp(this.zero) === 0) {
      if (d)
        throw new Error("invalid point");
      return this.point(this.zero, E);
    }
    var _ = R.redSqrt();
    if (_.redSqr().redSub(R).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return _.fromRed().isOdd() !== d && (_ = _.redNeg()), this.point(_, E);
  }, l.prototype.validate = function(E) {
    if (E.isInfinity())
      return !0;
    E.normalize();
    var d = E.x.redSqr(), f = E.y.redSqr(), h = d.redMul(this.a).redAdd(f), S = this.c2.redMul(this.one.redAdd(this.d.redMul(d).redMul(f)));
    return h.cmp(S) === 0;
  };
  function u(c, E, d, f, h) {
    o.BasePoint.call(this, c, "projective"), E === null && d === null && f === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(E, 16), this.y = new e(d, 16), this.z = f ? new e(f, 16) : this.curve.one, this.t = h && new e(h, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return s(u, o.BasePoint), l.prototype.pointFromJSON = function(E) {
    return u.fromJSON(this, E);
  }, l.prototype.point = function(E, d, f, h) {
    return new u(this, E, d, f, h);
  }, u.fromJSON = function(E, d) {
    return new u(E, d[0], d[1], d[2]);
  }, u.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, u.prototype._extDbl = function() {
    var E = this.x.redSqr(), d = this.y.redSqr(), f = this.z.redSqr();
    f = f.redIAdd(f);
    var h = this.curve._mulA(E), S = this.x.redAdd(this.y).redSqr().redISub(E).redISub(d), R = h.redAdd(d), _ = R.redSub(f), m = h.redSub(d), L = S.redMul(_), F = R.redMul(m), W = S.redMul(m), G = _.redMul(R);
    return this.curve.point(L, F, G, W);
  }, u.prototype._projDbl = function() {
    var E = this.x.redAdd(this.y).redSqr(), d = this.x.redSqr(), f = this.y.redSqr(), h, S, R, _, m, L;
    if (this.curve.twisted) {
      _ = this.curve._mulA(d);
      var F = _.redAdd(f);
      this.zOne ? (h = E.redSub(d).redSub(f).redMul(F.redSub(this.curve.two)), S = F.redMul(_.redSub(f)), R = F.redSqr().redSub(F).redSub(F)) : (m = this.z.redSqr(), L = F.redSub(m).redISub(m), h = E.redSub(d).redISub(f).redMul(L), S = F.redMul(_.redSub(f)), R = F.redMul(L));
    } else
      _ = d.redAdd(f), m = this.curve._mulC(this.z).redSqr(), L = _.redSub(m).redSub(m), h = this.curve._mulC(E.redISub(_)).redMul(L), S = this.curve._mulC(_).redMul(d.redISub(f)), R = _.redMul(L);
    return this.curve.point(h, S, R);
  }, u.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, u.prototype._extAdd = function(E) {
    var d = this.y.redSub(this.x).redMul(E.y.redSub(E.x)), f = this.y.redAdd(this.x).redMul(E.y.redAdd(E.x)), h = this.t.redMul(this.curve.dd).redMul(E.t), S = this.z.redMul(E.z.redAdd(E.z)), R = f.redSub(d), _ = S.redSub(h), m = S.redAdd(h), L = f.redAdd(d), F = R.redMul(_), W = m.redMul(L), G = R.redMul(L), q = _.redMul(m);
    return this.curve.point(F, W, q, G);
  }, u.prototype._projAdd = function(E) {
    var d = this.z.redMul(E.z), f = d.redSqr(), h = this.x.redMul(E.x), S = this.y.redMul(E.y), R = this.curve.d.redMul(h).redMul(S), _ = f.redSub(R), m = f.redAdd(R), L = this.x.redAdd(this.y).redMul(E.x.redAdd(E.y)).redISub(h).redISub(S), F = d.redMul(_).redMul(L), W, G;
    return this.curve.twisted ? (W = d.redMul(m).redMul(S.redSub(this.curve._mulA(h))), G = _.redMul(m)) : (W = d.redMul(m).redMul(S.redSub(h)), G = this.curve._mulC(_).redMul(m)), this.curve.point(F, W, G);
  }, u.prototype.add = function(E) {
    return this.isInfinity() ? E : E.isInfinity() ? this : this.curve.extended ? this._extAdd(E) : this._projAdd(E);
  }, u.prototype.mul = function(E) {
    return this._hasDoubles(E) ? this.curve._fixedNafMul(this, E) : this.curve._wnafMul(this, E);
  }, u.prototype.mulAdd = function(E, d, f) {
    return this.curve._wnafMulAdd(1, [this, d], [E, f], 2, !1);
  }, u.prototype.jmulAdd = function(E, d, f) {
    return this.curve._wnafMulAdd(1, [this, d], [E, f], 2, !0);
  }, u.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var E = this.z.redInvm();
    return this.x = this.x.redMul(E), this.y = this.y.redMul(E), this.t && (this.t = this.t.redMul(E)), this.z = this.curve.one, this.zOne = !0, this;
  }, u.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, u.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, u.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, u.prototype.eq = function(E) {
    return this === E || this.getX().cmp(E.getX()) === 0 && this.getY().cmp(E.getY()) === 0;
  }, u.prototype.eqXToP = function(E) {
    var d = E.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(d) === 0)
      return !0;
    for (var f = E.clone(), h = this.curve.redN.redMul(this.z); ; ) {
      if (f.iadd(this.curve.n), f.cmp(this.curve.p) >= 0)
        return !1;
      if (d.redIAdd(h), this.x.cmp(d) === 0)
        return !0;
    }
  }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add, edwards;
}
var hasRequiredCurve;
function requireCurve() {
  return hasRequiredCurve || (hasRequiredCurve = 1, function(r) {
    var e = r;
    e.base = requireBase$1(), e.short = requireShort(), e.mont = requireMont(), e.edwards = requireEdwards();
  }(curve)), curve;
}
var curves = {}, hash = {}, utils = {}, hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils)
    return utils;
  hasRequiredUtils = 1;
  var r = requireMinimalisticAssert(), e = requireInherits_browser();
  utils.inherits = e;
  function s(te, ae) {
    return (te.charCodeAt(ae) & 64512) !== 55296 || ae < 0 || ae + 1 >= te.length ? !1 : (te.charCodeAt(ae + 1) & 64512) === 56320;
  }
  function o(te, ae) {
    if (Array.isArray(te))
      return te.slice();
    if (!te)
      return [];
    var v = [];
    if (typeof te == "string")
      if (ae) {
        if (ae === "hex")
          for (te = te.replace(/[^a-z0-9]+/ig, ""), te.length % 2 !== 0 && (te = "0" + te), De = 0; De < te.length; De += 2)
            v.push(parseInt(te[De] + te[De + 1], 16));
      } else
        for (var Te = 0, De = 0; De < te.length; De++) {
          var be = te.charCodeAt(De);
          be < 128 ? v[Te++] = be : be < 2048 ? (v[Te++] = be >> 6 | 192, v[Te++] = be & 63 | 128) : s(te, De) ? (be = 65536 + ((be & 1023) << 10) + (te.charCodeAt(++De) & 1023), v[Te++] = be >> 18 | 240, v[Te++] = be >> 12 & 63 | 128, v[Te++] = be >> 6 & 63 | 128, v[Te++] = be & 63 | 128) : (v[Te++] = be >> 12 | 224, v[Te++] = be >> 6 & 63 | 128, v[Te++] = be & 63 | 128);
        }
    else
      for (De = 0; De < te.length; De++)
        v[De] = te[De] | 0;
    return v;
  }
  utils.toArray = o;
  function a(te) {
    for (var ae = "", v = 0; v < te.length; v++)
      ae += c(te[v].toString(16));
    return ae;
  }
  utils.toHex = a;
  function l(te) {
    var ae = te >>> 24 | te >>> 8 & 65280 | te << 8 & 16711680 | (te & 255) << 24;
    return ae >>> 0;
  }
  utils.htonl = l;
  function u(te, ae) {
    for (var v = "", Te = 0; Te < te.length; Te++) {
      var De = te[Te];
      ae === "little" && (De = l(De)), v += E(De.toString(16));
    }
    return v;
  }
  utils.toHex32 = u;
  function c(te) {
    return te.length === 1 ? "0" + te : te;
  }
  utils.zero2 = c;
  function E(te) {
    return te.length === 7 ? "0" + te : te.length === 6 ? "00" + te : te.length === 5 ? "000" + te : te.length === 4 ? "0000" + te : te.length === 3 ? "00000" + te : te.length === 2 ? "000000" + te : te.length === 1 ? "0000000" + te : te;
  }
  utils.zero8 = E;
  function d(te, ae, v, Te) {
    var De = v - ae;
    r(De % 4 === 0);
    for (var be = new Array(De / 4), ze = 0, ke = ae; ze < be.length; ze++, ke += 4) {
      var Be;
      Te === "big" ? Be = te[ke] << 24 | te[ke + 1] << 16 | te[ke + 2] << 8 | te[ke + 3] : Be = te[ke + 3] << 24 | te[ke + 2] << 16 | te[ke + 1] << 8 | te[ke], be[ze] = Be >>> 0;
    }
    return be;
  }
  utils.join32 = d;
  function f(te, ae) {
    for (var v = new Array(te.length * 4), Te = 0, De = 0; Te < te.length; Te++, De += 4) {
      var be = te[Te];
      ae === "big" ? (v[De] = be >>> 24, v[De + 1] = be >>> 16 & 255, v[De + 2] = be >>> 8 & 255, v[De + 3] = be & 255) : (v[De + 3] = be >>> 24, v[De + 2] = be >>> 16 & 255, v[De + 1] = be >>> 8 & 255, v[De] = be & 255);
    }
    return v;
  }
  utils.split32 = f;
  function h(te, ae) {
    return te >>> ae | te << 32 - ae;
  }
  utils.rotr32 = h;
  function S(te, ae) {
    return te << ae | te >>> 32 - ae;
  }
  utils.rotl32 = S;
  function R(te, ae) {
    return te + ae >>> 0;
  }
  utils.sum32 = R;
  function _(te, ae, v) {
    return te + ae + v >>> 0;
  }
  utils.sum32_3 = _;
  function m(te, ae, v, Te) {
    return te + ae + v + Te >>> 0;
  }
  utils.sum32_4 = m;
  function L(te, ae, v, Te, De) {
    return te + ae + v + Te + De >>> 0;
  }
  utils.sum32_5 = L;
  function F(te, ae, v, Te) {
    var De = te[ae], be = te[ae + 1], ze = Te + be >>> 0, ke = (ze < Te ? 1 : 0) + v + De;
    te[ae] = ke >>> 0, te[ae + 1] = ze;
  }
  utils.sum64 = F;
  function W(te, ae, v, Te) {
    var De = ae + Te >>> 0, be = (De < ae ? 1 : 0) + te + v;
    return be >>> 0;
  }
  utils.sum64_hi = W;
  function G(te, ae, v, Te) {
    var De = ae + Te;
    return De >>> 0;
  }
  utils.sum64_lo = G;
  function q(te, ae, v, Te, De, be, ze, ke) {
    var Be = 0, Me = ae;
    Me = Me + Te >>> 0, Be += Me < ae ? 1 : 0, Me = Me + be >>> 0, Be += Me < be ? 1 : 0, Me = Me + ke >>> 0, Be += Me < ke ? 1 : 0;
    var me = te + v + De + ze + Be;
    return me >>> 0;
  }
  utils.sum64_4_hi = q;
  function fe(te, ae, v, Te, De, be, ze, ke) {
    var Be = ae + Te + be + ke;
    return Be >>> 0;
  }
  utils.sum64_4_lo = fe;
  function _e(te, ae, v, Te, De, be, ze, ke, Be, Me) {
    var me = 0, Se = ae;
    Se = Se + Te >>> 0, me += Se < ae ? 1 : 0, Se = Se + be >>> 0, me += Se < be ? 1 : 0, Se = Se + ke >>> 0, me += Se < ke ? 1 : 0, Se = Se + Me >>> 0, me += Se < Me ? 1 : 0;
    var xt = te + v + De + ze + Be + me;
    return xt >>> 0;
  }
  utils.sum64_5_hi = _e;
  function Le(te, ae, v, Te, De, be, ze, ke, Be, Me) {
    var me = ae + Te + be + ke + Me;
    return me >>> 0;
  }
  utils.sum64_5_lo = Le;
  function Fe(te, ae, v) {
    var Te = ae << 32 - v | te >>> v;
    return Te >>> 0;
  }
  utils.rotr64_hi = Fe;
  function Ee(te, ae, v) {
    var Te = te << 32 - v | ae >>> v;
    return Te >>> 0;
  }
  utils.rotr64_lo = Ee;
  function Ge(te, ae, v) {
    return te >>> v;
  }
  utils.shr64_hi = Ge;
  function ve(te, ae, v) {
    var Te = te << 32 - v | ae >>> v;
    return Te >>> 0;
  }
  return utils.shr64_lo = ve, utils;
}
var common$2 = {}, hasRequiredCommon$1;
function requireCommon$1() {
  if (hasRequiredCommon$1)
    return common$2;
  hasRequiredCommon$1 = 1;
  var r = requireUtils(), e = requireMinimalisticAssert();
  function s() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return common$2.BlockHash = s, s.prototype.update = function(a, l) {
    if (a = r.toArray(a, l), this.pending ? this.pending = this.pending.concat(a) : this.pending = a, this.pendingTotal += a.length, this.pending.length >= this._delta8) {
      a = this.pending;
      var u = a.length % this._delta8;
      this.pending = a.slice(a.length - u, a.length), this.pending.length === 0 && (this.pending = null), a = r.join32(a, 0, a.length - u, this.endian);
      for (var c = 0; c < a.length; c += this._delta32)
        this._update(a, c, c + this._delta32);
    }
    return this;
  }, s.prototype.digest = function(a) {
    return this.update(this._pad()), e(this.pending === null), this._digest(a);
  }, s.prototype._pad = function() {
    var a = this.pendingTotal, l = this._delta8, u = l - (a + this.padLength) % l, c = new Array(u + this.padLength);
    c[0] = 128;
    for (var E = 1; E < u; E++)
      c[E] = 0;
    if (a <<= 3, this.endian === "big") {
      for (var d = 8; d < this.padLength; d++)
        c[E++] = 0;
      c[E++] = 0, c[E++] = 0, c[E++] = 0, c[E++] = 0, c[E++] = a >>> 24 & 255, c[E++] = a >>> 16 & 255, c[E++] = a >>> 8 & 255, c[E++] = a & 255;
    } else
      for (c[E++] = a & 255, c[E++] = a >>> 8 & 255, c[E++] = a >>> 16 & 255, c[E++] = a >>> 24 & 255, c[E++] = 0, c[E++] = 0, c[E++] = 0, c[E++] = 0, d = 8; d < this.padLength; d++)
        c[E++] = 0;
    return c;
  }, common$2;
}
var sha = {}, common$1 = {}, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon)
    return common$1;
  hasRequiredCommon = 1;
  var r = requireUtils(), e = r.rotr32;
  function s(f, h, S, R) {
    if (f === 0)
      return o(h, S, R);
    if (f === 1 || f === 3)
      return l(h, S, R);
    if (f === 2)
      return a(h, S, R);
  }
  common$1.ft_1 = s;
  function o(f, h, S) {
    return f & h ^ ~f & S;
  }
  common$1.ch32 = o;
  function a(f, h, S) {
    return f & h ^ f & S ^ h & S;
  }
  common$1.maj32 = a;
  function l(f, h, S) {
    return f ^ h ^ S;
  }
  common$1.p32 = l;
  function u(f) {
    return e(f, 2) ^ e(f, 13) ^ e(f, 22);
  }
  common$1.s0_256 = u;
  function c(f) {
    return e(f, 6) ^ e(f, 11) ^ e(f, 25);
  }
  common$1.s1_256 = c;
  function E(f) {
    return e(f, 7) ^ e(f, 18) ^ f >>> 3;
  }
  common$1.g0_256 = E;
  function d(f) {
    return e(f, 17) ^ e(f, 19) ^ f >>> 10;
  }
  return common$1.g1_256 = d, common$1;
}
var _1, hasRequired_1;
function require_1() {
  if (hasRequired_1)
    return _1;
  hasRequired_1 = 1;
  var r = requireUtils(), e = requireCommon$1(), s = requireCommon(), o = r.rotl32, a = r.sum32, l = r.sum32_5, u = s.ft_1, c = e.BlockHash, E = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function d() {
    if (!(this instanceof d))
      return new d();
    c.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return r.inherits(d, c), _1 = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 80, d.padLength = 64, d.prototype._update = function(h, S) {
    for (var R = this.W, _ = 0; _ < 16; _++)
      R[_] = h[S + _];
    for (; _ < R.length; _++)
      R[_] = o(R[_ - 3] ^ R[_ - 8] ^ R[_ - 14] ^ R[_ - 16], 1);
    var m = this.h[0], L = this.h[1], F = this.h[2], W = this.h[3], G = this.h[4];
    for (_ = 0; _ < R.length; _++) {
      var q = ~~(_ / 20), fe = l(o(m, 5), u(q, L, F, W), G, R[_], E[q]);
      G = W, W = F, F = o(L, 30), L = m, m = fe;
    }
    this.h[0] = a(this.h[0], m), this.h[1] = a(this.h[1], L), this.h[2] = a(this.h[2], F), this.h[3] = a(this.h[3], W), this.h[4] = a(this.h[4], G);
  }, d.prototype._digest = function(h) {
    return h === "hex" ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  }, _1;
}
var _256, hasRequired_256;
function require_256() {
  if (hasRequired_256)
    return _256;
  hasRequired_256 = 1;
  var r = requireUtils(), e = requireCommon$1(), s = requireCommon(), o = requireMinimalisticAssert(), a = r.sum32, l = r.sum32_4, u = r.sum32_5, c = s.ch32, E = s.maj32, d = s.s0_256, f = s.s1_256, h = s.g0_256, S = s.g1_256, R = e.BlockHash, _ = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function m() {
    if (!(this instanceof m))
      return new m();
    R.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = _, this.W = new Array(64);
  }
  return r.inherits(m, R), _256 = m, m.blockSize = 512, m.outSize = 256, m.hmacStrength = 192, m.padLength = 64, m.prototype._update = function(F, W) {
    for (var G = this.W, q = 0; q < 16; q++)
      G[q] = F[W + q];
    for (; q < G.length; q++)
      G[q] = l(S(G[q - 2]), G[q - 7], h(G[q - 15]), G[q - 16]);
    var fe = this.h[0], _e = this.h[1], Le = this.h[2], Fe = this.h[3], Ee = this.h[4], Ge = this.h[5], ve = this.h[6], te = this.h[7];
    for (o(this.k.length === G.length), q = 0; q < G.length; q++) {
      var ae = u(te, f(Ee), c(Ee, Ge, ve), this.k[q], G[q]), v = a(d(fe), E(fe, _e, Le));
      te = ve, ve = Ge, Ge = Ee, Ee = a(Fe, ae), Fe = Le, Le = _e, _e = fe, fe = a(ae, v);
    }
    this.h[0] = a(this.h[0], fe), this.h[1] = a(this.h[1], _e), this.h[2] = a(this.h[2], Le), this.h[3] = a(this.h[3], Fe), this.h[4] = a(this.h[4], Ee), this.h[5] = a(this.h[5], Ge), this.h[6] = a(this.h[6], ve), this.h[7] = a(this.h[7], te);
  }, m.prototype._digest = function(F) {
    return F === "hex" ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  }, _256;
}
var _224, hasRequired_224;
function require_224() {
  if (hasRequired_224)
    return _224;
  hasRequired_224 = 1;
  var r = requireUtils(), e = require_256();
  function s() {
    if (!(this instanceof s))
      return new s();
    e.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return r.inherits(s, e), _224 = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(a) {
    return a === "hex" ? r.toHex32(this.h.slice(0, 7), "big") : r.split32(this.h.slice(0, 7), "big");
  }, _224;
}
var _512, hasRequired_512;
function require_512() {
  if (hasRequired_512)
    return _512;
  hasRequired_512 = 1;
  var r = requireUtils(), e = requireCommon$1(), s = requireMinimalisticAssert(), o = r.rotr64_hi, a = r.rotr64_lo, l = r.shr64_hi, u = r.shr64_lo, c = r.sum64, E = r.sum64_hi, d = r.sum64_lo, f = r.sum64_4_hi, h = r.sum64_4_lo, S = r.sum64_5_hi, R = r.sum64_5_lo, _ = e.BlockHash, m = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function L() {
    if (!(this instanceof L))
      return new L();
    _.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = m, this.W = new Array(160);
  }
  r.inherits(L, _), _512 = L, L.blockSize = 1024, L.outSize = 512, L.hmacStrength = 192, L.padLength = 128, L.prototype._prepareBlock = function(v, Te) {
    for (var De = this.W, be = 0; be < 32; be++)
      De[be] = v[Te + be];
    for (; be < De.length; be += 2) {
      var ze = ve(De[be - 4], De[be - 3]), ke = te(De[be - 4], De[be - 3]), Be = De[be - 14], Me = De[be - 13], me = Ee(De[be - 30], De[be - 29]), Se = Ge(De[be - 30], De[be - 29]), xt = De[be - 32], Ht = De[be - 31];
      De[be] = f(
        ze,
        ke,
        Be,
        Me,
        me,
        Se,
        xt,
        Ht
      ), De[be + 1] = h(
        ze,
        ke,
        Be,
        Me,
        me,
        Se,
        xt,
        Ht
      );
    }
  }, L.prototype._update = function(v, Te) {
    this._prepareBlock(v, Te);
    var De = this.W, be = this.h[0], ze = this.h[1], ke = this.h[2], Be = this.h[3], Me = this.h[4], me = this.h[5], Se = this.h[6], xt = this.h[7], Ht = this.h[8], Bt = this.h[9], ut = this.h[10], Tt = this.h[11], Yt = this.h[12], an = this.h[13], Ct = this.h[14], st = this.h[15];
    s(this.k.length === De.length);
    for (var jt = 0; jt < De.length; jt += 2) {
      var lt = Ct, Zt = st, Et = Le(Ht, Bt), Ke = Fe(Ht, Bt), $e = F(Ht, Bt, ut, Tt, Yt), pt = W(Ht, Bt, ut, Tt, Yt, an), Jt = this.k[jt], In = this.k[jt + 1], Cn = De[jt], It = De[jt + 1], ht = S(
        lt,
        Zt,
        Et,
        Ke,
        $e,
        pt,
        Jt,
        In,
        Cn,
        It
      ), Wt = R(
        lt,
        Zt,
        Et,
        Ke,
        $e,
        pt,
        Jt,
        In,
        Cn,
        It
      );
      lt = fe(be, ze), Zt = _e(be, ze), Et = G(be, ze, ke, Be, Me), Ke = q(be, ze, ke, Be, Me, me);
      var hn = E(lt, Zt, Et, Ke), Vt = d(lt, Zt, Et, Ke);
      Ct = Yt, st = an, Yt = ut, an = Tt, ut = Ht, Tt = Bt, Ht = E(Se, xt, ht, Wt), Bt = d(xt, xt, ht, Wt), Se = Me, xt = me, Me = ke, me = Be, ke = be, Be = ze, be = E(ht, Wt, hn, Vt), ze = d(ht, Wt, hn, Vt);
    }
    c(this.h, 0, be, ze), c(this.h, 2, ke, Be), c(this.h, 4, Me, me), c(this.h, 6, Se, xt), c(this.h, 8, Ht, Bt), c(this.h, 10, ut, Tt), c(this.h, 12, Yt, an), c(this.h, 14, Ct, st);
  }, L.prototype._digest = function(v) {
    return v === "hex" ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
  function F(ae, v, Te, De, be) {
    var ze = ae & Te ^ ~ae & be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function W(ae, v, Te, De, be, ze) {
    var ke = v & De ^ ~v & ze;
    return ke < 0 && (ke += 4294967296), ke;
  }
  function G(ae, v, Te, De, be) {
    var ze = ae & Te ^ ae & be ^ Te & be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function q(ae, v, Te, De, be, ze) {
    var ke = v & De ^ v & ze ^ De & ze;
    return ke < 0 && (ke += 4294967296), ke;
  }
  function fe(ae, v) {
    var Te = o(ae, v, 28), De = o(v, ae, 2), be = o(v, ae, 7), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function _e(ae, v) {
    var Te = a(ae, v, 28), De = a(v, ae, 2), be = a(v, ae, 7), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function Le(ae, v) {
    var Te = o(ae, v, 14), De = o(ae, v, 18), be = o(v, ae, 9), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function Fe(ae, v) {
    var Te = a(ae, v, 14), De = a(ae, v, 18), be = a(v, ae, 9), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function Ee(ae, v) {
    var Te = o(ae, v, 1), De = o(ae, v, 8), be = l(ae, v, 7), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function Ge(ae, v) {
    var Te = a(ae, v, 1), De = a(ae, v, 8), be = u(ae, v, 7), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function ve(ae, v) {
    var Te = o(ae, v, 19), De = o(v, ae, 29), be = l(ae, v, 6), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  function te(ae, v) {
    var Te = a(ae, v, 19), De = a(v, ae, 29), be = u(ae, v, 6), ze = Te ^ De ^ be;
    return ze < 0 && (ze += 4294967296), ze;
  }
  return _512;
}
var _384, hasRequired_384;
function require_384() {
  if (hasRequired_384)
    return _384;
  hasRequired_384 = 1;
  var r = requireUtils(), e = require_512();
  function s() {
    if (!(this instanceof s))
      return new s();
    e.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return r.inherits(s, e), _384 = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(a) {
    return a === "hex" ? r.toHex32(this.h.slice(0, 12), "big") : r.split32(this.h.slice(0, 12), "big");
  }, _384;
}
var hasRequiredSha;
function requireSha() {
  return hasRequiredSha || (hasRequiredSha = 1, sha.sha1 = require_1(), sha.sha224 = require_224(), sha.sha256 = require_256(), sha.sha384 = require_384(), sha.sha512 = require_512()), sha;
}
var ripemd = {}, hasRequiredRipemd;
function requireRipemd() {
  if (hasRequiredRipemd)
    return ripemd;
  hasRequiredRipemd = 1;
  var r = requireUtils(), e = requireCommon$1(), s = r.rotl32, o = r.sum32, a = r.sum32_3, l = r.sum32_4, u = e.BlockHash;
  function c() {
    if (!(this instanceof c))
      return new c();
    u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  r.inherits(c, u), ripemd.ripemd160 = c, c.blockSize = 512, c.outSize = 160, c.hmacStrength = 192, c.padLength = 64, c.prototype._update = function(L, F) {
    for (var W = this.h[0], G = this.h[1], q = this.h[2], fe = this.h[3], _e = this.h[4], Le = W, Fe = G, Ee = q, Ge = fe, ve = _e, te = 0; te < 80; te++) {
      var ae = o(
        s(
          l(W, E(te, G, q, fe), L[h[te] + F], d(te)),
          R[te]
        ),
        _e
      );
      W = _e, _e = fe, fe = s(q, 10), q = G, G = ae, ae = o(
        s(
          l(Le, E(79 - te, Fe, Ee, Ge), L[S[te] + F], f(te)),
          _[te]
        ),
        ve
      ), Le = ve, ve = Ge, Ge = s(Ee, 10), Ee = Fe, Fe = ae;
    }
    ae = a(this.h[1], q, Ge), this.h[1] = a(this.h[2], fe, ve), this.h[2] = a(this.h[3], _e, Le), this.h[3] = a(this.h[4], W, Fe), this.h[4] = a(this.h[0], G, Ee), this.h[0] = ae;
  }, c.prototype._digest = function(L) {
    return L === "hex" ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
  };
  function E(m, L, F, W) {
    return m <= 15 ? L ^ F ^ W : m <= 31 ? L & F | ~L & W : m <= 47 ? (L | ~F) ^ W : m <= 63 ? L & W | F & ~W : L ^ (F | ~W);
  }
  function d(m) {
    return m <= 15 ? 0 : m <= 31 ? 1518500249 : m <= 47 ? 1859775393 : m <= 63 ? 2400959708 : 2840853838;
  }
  function f(m) {
    return m <= 15 ? 1352829926 : m <= 31 ? 1548603684 : m <= 47 ? 1836072691 : m <= 63 ? 2053994217 : 0;
  }
  var h = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], S = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], R = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], _ = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return ripemd;
}
var hmac, hasRequiredHmac;
function requireHmac() {
  if (hasRequiredHmac)
    return hmac;
  hasRequiredHmac = 1;
  var r = requireUtils(), e = requireMinimalisticAssert();
  function s(o, a, l) {
    if (!(this instanceof s))
      return new s(o, a, l);
    this.Hash = o, this.blockSize = o.blockSize / 8, this.outSize = o.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(a, l));
  }
  return hmac = s, s.prototype._init = function(a) {
    a.length > this.blockSize && (a = new this.Hash().update(a).digest()), e(a.length <= this.blockSize);
    for (var l = a.length; l < this.blockSize; l++)
      a.push(0);
    for (l = 0; l < a.length; l++)
      a[l] ^= 54;
    for (this.inner = new this.Hash().update(a), l = 0; l < a.length; l++)
      a[l] ^= 106;
    this.outer = new this.Hash().update(a);
  }, s.prototype.update = function(a, l) {
    return this.inner.update(a, l), this;
  }, s.prototype.digest = function(a) {
    return this.outer.update(this.inner.digest()), this.outer.digest(a);
  }, hmac;
}
var hasRequiredHash;
function requireHash() {
  return hasRequiredHash || (hasRequiredHash = 1, function(r) {
    var e = r;
    e.utils = requireUtils(), e.common = requireCommon$1(), e.sha = requireSha(), e.ripemd = requireRipemd(), e.hmac = requireHmac(), e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
  }(hash)), hash;
}
var secp256k1, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1;
}
var hasRequiredCurves;
function requireCurves() {
  return hasRequiredCurves || (hasRequiredCurves = 1, function(r) {
    var e = r, s = requireHash(), o = requireCurve(), a = requireUtils$1(), l = a.assert;
    function u(d) {
      d.type === "short" ? this.curve = new o.short(d) : d.type === "edwards" ? this.curve = new o.edwards(d) : this.curve = new o.mont(d), this.g = this.curve.g, this.n = this.curve.n, this.hash = d.hash, l(this.g.validate(), "Invalid curve"), l(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = u;
    function c(d, f) {
      Object.defineProperty(e, d, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var h = new u(f);
          return Object.defineProperty(e, d, {
            configurable: !0,
            enumerable: !0,
            value: h
          }), h;
        }
      });
    }
    c("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: s.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), c("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: s.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), c("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: s.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), c("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: s.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), c("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: s.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), c("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: s.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), c("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: s.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var E;
    try {
      E = requireSecp256k1();
    } catch {
      E = void 0;
    }
    c("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: s.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        E
      ]
    });
  }(curves)), curves;
}
var hmacDrbg, hasRequiredHmacDrbg;
function requireHmacDrbg() {
  if (hasRequiredHmacDrbg)
    return hmacDrbg;
  hasRequiredHmacDrbg = 1;
  var r = requireHash(), e = requireUtils$2(), s = requireMinimalisticAssert();
  function o(a) {
    if (!(this instanceof o))
      return new o(a);
    this.hash = a.hash, this.predResist = !!a.predResist, this.outLen = this.hash.outSize, this.minEntropy = a.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var l = e.toArray(a.entropy, a.entropyEnc || "hex"), u = e.toArray(a.nonce, a.nonceEnc || "hex"), c = e.toArray(a.pers, a.persEnc || "hex");
    s(
      l.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(l, u, c);
  }
  return hmacDrbg = o, o.prototype._init = function(l, u, c) {
    var E = l.concat(u).concat(c);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var d = 0; d < this.V.length; d++)
      this.K[d] = 0, this.V[d] = 1;
    this._update(E), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, o.prototype._hmac = function() {
    return new r.hmac(this.hash, this.K);
  }, o.prototype._update = function(l) {
    var u = this._hmac().update(this.V).update([0]);
    l && (u = u.update(l)), this.K = u.digest(), this.V = this._hmac().update(this.V).digest(), l && (this.K = this._hmac().update(this.V).update([1]).update(l).digest(), this.V = this._hmac().update(this.V).digest());
  }, o.prototype.reseed = function(l, u, c, E) {
    typeof u != "string" && (E = c, c = u, u = null), l = e.toArray(l, u), c = e.toArray(c, E), s(
      l.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(l.concat(c || [])), this._reseed = 1;
  }, o.prototype.generate = function(l, u, c, E) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof u != "string" && (E = c, c = u, u = null), c && (c = e.toArray(c, E || "hex"), this._update(c));
    for (var d = []; d.length < l; )
      this.V = this._hmac().update(this.V).digest(), d = d.concat(this.V);
    var f = d.slice(0, l);
    return this._update(c), this._reseed++, e.encode(f, u);
  }, hmacDrbg;
}
var key$2, hasRequiredKey$1;
function requireKey$1() {
  if (hasRequiredKey$1)
    return key$2;
  hasRequiredKey$1 = 1;
  var r = requireBn$1(), e = requireUtils$1(), s = e.assert;
  function o(a, l) {
    this.ec = a, this.priv = null, this.pub = null, l.priv && this._importPrivate(l.priv, l.privEnc), l.pub && this._importPublic(l.pub, l.pubEnc);
  }
  return key$2 = o, o.fromPublic = function(l, u, c) {
    return u instanceof o ? u : new o(l, {
      pub: u,
      pubEnc: c
    });
  }, o.fromPrivate = function(l, u, c) {
    return u instanceof o ? u : new o(l, {
      priv: u,
      privEnc: c
    });
  }, o.prototype.validate = function() {
    var l = this.getPublic();
    return l.isInfinity() ? { result: !1, reason: "Invalid public key" } : l.validate() ? l.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, o.prototype.getPublic = function(l, u) {
    return typeof l == "string" && (u = l, l = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), u ? this.pub.encode(u, l) : this.pub;
  }, o.prototype.getPrivate = function(l) {
    return l === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, o.prototype._importPrivate = function(l, u) {
    this.priv = new r(l, u || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, o.prototype._importPublic = function(l, u) {
    if (l.x || l.y) {
      this.ec.curve.type === "mont" ? s(l.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && s(l.x && l.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(l.x, l.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(l, u);
  }, o.prototype.derive = function(l) {
    return l.validate() || s(l.validate(), "public point not validated"), l.mul(this.priv).getX();
  }, o.prototype.sign = function(l, u, c) {
    return this.ec.sign(l, this, u, c);
  }, o.prototype.verify = function(l, u, c) {
    return this.ec.verify(l, u, this, void 0, c);
  }, o.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, key$2;
}
var signature$1, hasRequiredSignature$1;
function requireSignature$1() {
  if (hasRequiredSignature$1)
    return signature$1;
  hasRequiredSignature$1 = 1;
  var r = requireBn$1(), e = requireUtils$1(), s = e.assert;
  function o(E, d) {
    if (E instanceof o)
      return E;
    this._importDER(E, d) || (s(E.r && E.s, "Signature without r or s"), this.r = new r(E.r, 16), this.s = new r(E.s, 16), E.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = E.recoveryParam);
  }
  signature$1 = o;
  function a() {
    this.place = 0;
  }
  function l(E, d) {
    var f = E[d.place++];
    if (!(f & 128))
      return f;
    var h = f & 15;
    if (h === 0 || h > 4 || E[d.place] === 0)
      return !1;
    for (var S = 0, R = 0, _ = d.place; R < h; R++, _++)
      S <<= 8, S |= E[_], S >>>= 0;
    return S <= 127 ? !1 : (d.place = _, S);
  }
  function u(E) {
    for (var d = 0, f = E.length - 1; !E[d] && !(E[d + 1] & 128) && d < f; )
      d++;
    return d === 0 ? E : E.slice(d);
  }
  o.prototype._importDER = function(d, f) {
    d = e.toArray(d, f);
    var h = new a();
    if (d[h.place++] !== 48)
      return !1;
    var S = l(d, h);
    if (S === !1 || S + h.place !== d.length || d[h.place++] !== 2)
      return !1;
    var R = l(d, h);
    if (R === !1 || d[h.place] & 128)
      return !1;
    var _ = d.slice(h.place, R + h.place);
    if (h.place += R, d[h.place++] !== 2)
      return !1;
    var m = l(d, h);
    if (m === !1 || d.length !== m + h.place || d[h.place] & 128)
      return !1;
    var L = d.slice(h.place, m + h.place);
    if (_[0] === 0)
      if (_[1] & 128)
        _ = _.slice(1);
      else
        return !1;
    if (L[0] === 0)
      if (L[1] & 128)
        L = L.slice(1);
      else
        return !1;
    return this.r = new r(_), this.s = new r(L), this.recoveryParam = null, !0;
  };
  function c(E, d) {
    if (d < 128) {
      E.push(d);
      return;
    }
    var f = 1 + (Math.log(d) / Math.LN2 >>> 3);
    for (E.push(f | 128); --f; )
      E.push(d >>> (f << 3) & 255);
    E.push(d);
  }
  return o.prototype.toDER = function(d) {
    var f = this.r.toArray(), h = this.s.toArray();
    for (f[0] & 128 && (f = [0].concat(f)), h[0] & 128 && (h = [0].concat(h)), f = u(f), h = u(h); !h[0] && !(h[1] & 128); )
      h = h.slice(1);
    var S = [2];
    c(S, f.length), S = S.concat(f), S.push(2), c(S, h.length);
    var R = S.concat(h), _ = [48];
    return c(_, R.length), _ = _.concat(R), e.encode(_, d);
  }, signature$1;
}
var ec, hasRequiredEc;
function requireEc() {
  if (hasRequiredEc)
    return ec;
  hasRequiredEc = 1;
  var r = requireBn$1(), e = requireHmacDrbg(), s = requireUtils$1(), o = requireCurves(), a = requireBrorand(), l = s.assert, u = requireKey$1(), c = requireSignature$1();
  function E(d) {
    if (!(this instanceof E))
      return new E(d);
    typeof d == "string" && (l(
      Object.prototype.hasOwnProperty.call(o, d),
      "Unknown curve " + d
    ), d = o[d]), d instanceof o.PresetCurve && (d = { curve: d }), this.curve = d.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = d.curve.g, this.g.precompute(d.curve.n.bitLength() + 1), this.hash = d.hash || d.curve.hash;
  }
  return ec = E, E.prototype.keyPair = function(f) {
    return new u(this, f);
  }, E.prototype.keyFromPrivate = function(f, h) {
    return u.fromPrivate(this, f, h);
  }, E.prototype.keyFromPublic = function(f, h) {
    return u.fromPublic(this, f, h);
  }, E.prototype.genKeyPair = function(f) {
    f || (f = {});
    for (var h = new e({
      hash: this.hash,
      pers: f.pers,
      persEnc: f.persEnc || "utf8",
      entropy: f.entropy || a(this.hash.hmacStrength),
      entropyEnc: f.entropy && f.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), S = this.n.byteLength(), R = this.n.sub(new r(2)); ; ) {
      var _ = new r(h.generate(S));
      if (!(_.cmp(R) > 0))
        return _.iaddn(1), this.keyFromPrivate(_);
    }
  }, E.prototype._truncateToN = function(f, h, S) {
    var R;
    if (r.isBN(f) || typeof f == "number")
      f = new r(f, 16), R = f.byteLength();
    else if (typeof f == "object")
      R = f.length, f = new r(f, 16);
    else {
      var _ = f.toString();
      R = _.length + 1 >>> 1, f = new r(_, 16);
    }
    typeof S != "number" && (S = R * 8);
    var m = S - this.n.bitLength();
    return m > 0 && (f = f.ushrn(m)), !h && f.cmp(this.n) >= 0 ? f.sub(this.n) : f;
  }, E.prototype.sign = function(f, h, S, R) {
    if (typeof S == "object" && (R = S, S = null), R || (R = {}), typeof f != "string" && typeof f != "number" && !r.isBN(f)) {
      l(
        typeof f == "object" && f && typeof f.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), l(f.length >>> 0 === f.length);
      for (var _ = 0; _ < f.length; _++)
        l((f[_] & 255) === f[_]);
    }
    h = this.keyFromPrivate(h, S), f = this._truncateToN(f, !1, R.msgBitLength), l(!f.isNeg(), "Can not sign a negative message");
    var m = this.n.byteLength(), L = h.getPrivate().toArray("be", m), F = f.toArray("be", m);
    l(new r(F).eq(f), "Can not sign message");
    for (var W = new e({
      hash: this.hash,
      entropy: L,
      nonce: F,
      pers: R.pers,
      persEnc: R.persEnc || "utf8"
    }), G = this.n.sub(new r(1)), q = 0; ; q++) {
      var fe = R.k ? R.k(q) : new r(W.generate(this.n.byteLength()));
      if (fe = this._truncateToN(fe, !0), !(fe.cmpn(1) <= 0 || fe.cmp(G) >= 0)) {
        var _e = this.g.mul(fe);
        if (!_e.isInfinity()) {
          var Le = _e.getX(), Fe = Le.umod(this.n);
          if (Fe.cmpn(0) !== 0) {
            var Ee = fe.invm(this.n).mul(Fe.mul(h.getPrivate()).iadd(f));
            if (Ee = Ee.umod(this.n), Ee.cmpn(0) !== 0) {
              var Ge = (_e.getY().isOdd() ? 1 : 0) | (Le.cmp(Fe) !== 0 ? 2 : 0);
              return R.canonical && Ee.cmp(this.nh) > 0 && (Ee = this.n.sub(Ee), Ge ^= 1), new c({ r: Fe, s: Ee, recoveryParam: Ge });
            }
          }
        }
      }
    }
  }, E.prototype.verify = function(f, h, S, R, _) {
    _ || (_ = {}), f = this._truncateToN(f, !1, _.msgBitLength), S = this.keyFromPublic(S, R), h = new c(h, "hex");
    var m = h.r, L = h.s;
    if (m.cmpn(1) < 0 || m.cmp(this.n) >= 0 || L.cmpn(1) < 0 || L.cmp(this.n) >= 0)
      return !1;
    var F = L.invm(this.n), W = F.mul(f).umod(this.n), G = F.mul(m).umod(this.n), q;
    return this.curve._maxwellTrick ? (q = this.g.jmulAdd(W, S.getPublic(), G), q.isInfinity() ? !1 : q.eqXToP(m)) : (q = this.g.mulAdd(W, S.getPublic(), G), q.isInfinity() ? !1 : q.getX().umod(this.n).cmp(m) === 0);
  }, E.prototype.recoverPubKey = function(d, f, h, S) {
    l((3 & h) === h, "The recovery param is more than two bits"), f = new c(f, S);
    var R = this.n, _ = new r(d), m = f.r, L = f.s, F = h & 1, W = h >> 1;
    if (m.cmp(this.curve.p.umod(this.curve.n)) >= 0 && W)
      throw new Error("Unable to find sencond key candinate");
    W ? m = this.curve.pointFromX(m.add(this.curve.n), F) : m = this.curve.pointFromX(m, F);
    var G = f.r.invm(R), q = R.sub(_).mul(G).umod(R), fe = L.mul(G).umod(R);
    return this.g.mulAdd(q, m, fe);
  }, E.prototype.getKeyRecoveryParam = function(d, f, h, S) {
    if (f = new c(f, S), f.recoveryParam !== null)
      return f.recoveryParam;
    for (var R = 0; R < 4; R++) {
      var _;
      try {
        _ = this.recoverPubKey(d, f, R);
      } catch {
        continue;
      }
      if (_.eq(h))
        return R;
    }
    throw new Error("Unable to find valid recovery factor");
  }, ec;
}
var key$1, hasRequiredKey;
function requireKey() {
  if (hasRequiredKey)
    return key$1;
  hasRequiredKey = 1;
  var r = requireUtils$1(), e = r.assert, s = r.parseBytes, o = r.cachedProperty;
  function a(l, u) {
    this.eddsa = l, this._secret = s(u.secret), l.isPoint(u.pub) ? this._pub = u.pub : this._pubBytes = s(u.pub);
  }
  return a.fromPublic = function(u, c) {
    return c instanceof a ? c : new a(u, { pub: c });
  }, a.fromSecret = function(u, c) {
    return c instanceof a ? c : new a(u, { secret: c });
  }, a.prototype.secret = function() {
    return this._secret;
  }, o(a, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), o(a, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), o(a, "privBytes", function() {
    var u = this.eddsa, c = this.hash(), E = u.encodingLength - 1, d = c.slice(0, u.encodingLength);
    return d[0] &= 248, d[E] &= 127, d[E] |= 64, d;
  }), o(a, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), o(a, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), o(a, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), a.prototype.sign = function(u) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(u, this);
  }, a.prototype.verify = function(u, c) {
    return this.eddsa.verify(u, c, this);
  }, a.prototype.getSecret = function(u) {
    return e(this._secret, "KeyPair is public only"), r.encode(this.secret(), u);
  }, a.prototype.getPublic = function(u) {
    return r.encode(this.pubBytes(), u);
  }, key$1 = a, key$1;
}
var signature, hasRequiredSignature;
function requireSignature() {
  if (hasRequiredSignature)
    return signature;
  hasRequiredSignature = 1;
  var r = requireBn$1(), e = requireUtils$1(), s = e.assert, o = e.cachedProperty, a = e.parseBytes;
  function l(u, c) {
    this.eddsa = u, typeof c != "object" && (c = a(c)), Array.isArray(c) && (s(c.length === u.encodingLength * 2, "Signature has invalid size"), c = {
      R: c.slice(0, u.encodingLength),
      S: c.slice(u.encodingLength)
    }), s(c.R && c.S, "Signature without R or S"), u.isPoint(c.R) && (this._R = c.R), c.S instanceof r && (this._S = c.S), this._Rencoded = Array.isArray(c.R) ? c.R : c.Rencoded, this._Sencoded = Array.isArray(c.S) ? c.S : c.Sencoded;
  }
  return o(l, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), o(l, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), o(l, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), o(l, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), l.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, l.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, signature = l, signature;
}
var eddsa, hasRequiredEddsa;
function requireEddsa() {
  if (hasRequiredEddsa)
    return eddsa;
  hasRequiredEddsa = 1;
  var r = requireHash(), e = requireCurves(), s = requireUtils$1(), o = s.assert, a = s.parseBytes, l = requireKey(), u = requireSignature();
  function c(E) {
    if (o(E === "ed25519", "only tested with ed25519 so far"), !(this instanceof c))
      return new c(E);
    E = e[E].curve, this.curve = E, this.g = E.g, this.g.precompute(E.n.bitLength() + 1), this.pointClass = E.point().constructor, this.encodingLength = Math.ceil(E.n.bitLength() / 8), this.hash = r.sha512;
  }
  return eddsa = c, c.prototype.sign = function(d, f) {
    d = a(d);
    var h = this.keyFromSecret(f), S = this.hashInt(h.messagePrefix(), d), R = this.g.mul(S), _ = this.encodePoint(R), m = this.hashInt(_, h.pubBytes(), d).mul(h.priv()), L = S.add(m).umod(this.curve.n);
    return this.makeSignature({ R, S: L, Rencoded: _ });
  }, c.prototype.verify = function(d, f, h) {
    if (d = a(d), f = this.makeSignature(f), f.S().gte(f.eddsa.curve.n) || f.S().isNeg())
      return !1;
    var S = this.keyFromPublic(h), R = this.hashInt(f.Rencoded(), S.pubBytes(), d), _ = this.g.mul(f.S()), m = f.R().add(S.pub().mul(R));
    return m.eq(_);
  }, c.prototype.hashInt = function() {
    for (var d = this.hash(), f = 0; f < arguments.length; f++)
      d.update(arguments[f]);
    return s.intFromLE(d.digest()).umod(this.curve.n);
  }, c.prototype.keyFromPublic = function(d) {
    return l.fromPublic(this, d);
  }, c.prototype.keyFromSecret = function(d) {
    return l.fromSecret(this, d);
  }, c.prototype.makeSignature = function(d) {
    return d instanceof u ? d : new u(this, d);
  }, c.prototype.encodePoint = function(d) {
    var f = d.getY().toArray("le", this.encodingLength);
    return f[this.encodingLength - 1] |= d.getX().isOdd() ? 128 : 0, f;
  }, c.prototype.decodePoint = function(d) {
    d = s.parseBytes(d);
    var f = d.length - 1, h = d.slice(0, f).concat(d[f] & -129), S = (d[f] & 128) !== 0, R = s.intFromLE(h);
    return this.curve.pointFromY(R, S);
  }, c.prototype.encodeInt = function(d) {
    return d.toArray("le", this.encodingLength);
  }, c.prototype.decodeInt = function(d) {
    return s.intFromLE(d);
  }, c.prototype.isPoint = function(d) {
    return d instanceof this.pointClass;
  }, eddsa;
}
var hasRequiredElliptic;
function requireElliptic() {
  return hasRequiredElliptic || (hasRequiredElliptic = 1, function(r) {
    var e = r;
    e.version = require$$0$2.version, e.utils = requireUtils$1(), e.rand = requireBrorand(), e.curve = requireCurve(), e.curves = requireCurves(), e.ec = requireEc(), e.eddsa = requireEddsa();
  }(elliptic)), elliptic;
}
var asn1$1 = {}, asn1 = {}, api = {}, vmBrowserify = {}, hasRequiredVmBrowserify;
function requireVmBrowserify() {
  return hasRequiredVmBrowserify || (hasRequiredVmBrowserify = 1, function(exports) {
    var indexOf = function(r, e) {
      if (r.indexOf)
        return r.indexOf(e);
      for (var s = 0; s < r.length; s++)
        if (r[s] === e)
          return s;
      return -1;
    }, Object_keys = function(r) {
      if (Object.keys)
        return Object.keys(r);
      var e = [];
      for (var s in r)
        e.push(s);
      return e;
    }, forEach = function(r, e) {
      if (r.forEach)
        return r.forEach(e);
      for (var s = 0; s < r.length; s++)
        e(r[s], s, r);
    }, defineProp = function() {
      try {
        return Object.defineProperty({}, "_", {}), function(r, e, s) {
          Object.defineProperty(r, e, {
            writable: !0,
            enumerable: !1,
            configurable: !0,
            value: s
          });
        };
      } catch {
        return function(e, s, o) {
          e[s] = o;
        };
      }
    }(), globals = [
      "Array",
      "Boolean",
      "Date",
      "Error",
      "EvalError",
      "Function",
      "Infinity",
      "JSON",
      "Math",
      "NaN",
      "Number",
      "Object",
      "RangeError",
      "ReferenceError",
      "RegExp",
      "String",
      "SyntaxError",
      "TypeError",
      "URIError",
      "decodeURI",
      "decodeURIComponent",
      "encodeURI",
      "encodeURIComponent",
      "escape",
      "eval",
      "isFinite",
      "isNaN",
      "parseFloat",
      "parseInt",
      "undefined",
      "unescape"
    ];
    function Context() {
    }
    Context.prototype = {};
    var Script = exports.Script = function(e) {
      if (!(this instanceof Script))
        return new Script(e);
      this.code = e;
    };
    Script.prototype.runInContext = function(r) {
      if (!(r instanceof Context))
        throw new TypeError("needs a 'context' argument.");
      var e = document.createElement("iframe");
      e.style || (e.style = {}), e.style.display = "none", document.body.appendChild(e);
      var s = e.contentWindow, o = s.eval, a = s.execScript;
      !o && a && (a.call(s, "null"), o = s.eval), forEach(Object_keys(r), function(c) {
        s[c] = r[c];
      }), forEach(globals, function(c) {
        r[c] && (s[c] = r[c]);
      });
      var l = Object_keys(s), u = o.call(s, this.code);
      return forEach(Object_keys(s), function(c) {
        (c in r || indexOf(l, c) === -1) && (r[c] = s[c]);
      }), forEach(globals, function(c) {
        c in r || defineProp(r, c, s[c]);
      }), document.body.removeChild(e), u;
    }, Script.prototype.runInThisContext = function() {
      return eval(this.code);
    }, Script.prototype.runInNewContext = function(r) {
      var e = Script.createContext(r), s = this.runInContext(e);
      return r && forEach(Object_keys(e), function(o) {
        r[o] = e[o];
      }), s;
    }, forEach(Object_keys(Script.prototype), function(r) {
      exports[r] = Script[r] = function(e) {
        var s = Script(e);
        return s[r].apply(s, [].slice.call(arguments, 1));
      };
    }), exports.isContext = function(r) {
      return r instanceof Context;
    }, exports.createScript = function(r) {
      return exports.Script(r);
    }, exports.createContext = Script.createContext = function(r) {
      var e = new Context();
      return typeof r == "object" && forEach(Object_keys(r), function(s) {
        e[s] = r[s];
      }), e;
    };
  }(vmBrowserify)), vmBrowserify;
}
var hasRequiredApi;
function requireApi() {
  return hasRequiredApi || (hasRequiredApi = 1, function(r) {
    var e = requireAsn1$1(), s = requireInherits_browser(), o = r;
    o.define = function(u, c) {
      return new a(u, c);
    };
    function a(l, u) {
      this.name = l, this.body = u, this.decoders = {}, this.encoders = {};
    }
    a.prototype._createNamed = function(u) {
      var c;
      try {
        c = requireVmBrowserify().runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        c = function(d) {
          this._initNamed(d);
        };
      }
      return s(c, u), c.prototype._initNamed = function(d) {
        u.call(this, d);
      }, new c(this);
    }, a.prototype._getDecoder = function(u) {
      return u = u || "der", this.decoders.hasOwnProperty(u) || (this.decoders[u] = this._createNamed(e.decoders[u])), this.decoders[u];
    }, a.prototype.decode = function(u, c, E) {
      return this._getDecoder(c).decode(u, E);
    }, a.prototype._getEncoder = function(u) {
      return u = u || "der", this.encoders.hasOwnProperty(u) || (this.encoders[u] = this._createNamed(e.encoders[u])), this.encoders[u];
    }, a.prototype.encode = function(u, c, E) {
      return this._getEncoder(c).encode(u, E);
    };
  }(api)), api;
}
var base = {}, reporter = {}, hasRequiredReporter;
function requireReporter() {
  if (hasRequiredReporter)
    return reporter;
  hasRequiredReporter = 1;
  var r = requireInherits_browser();
  function e(o) {
    this._reporterState = {
      obj: null,
      path: [],
      options: o || {},
      errors: []
    };
  }
  reporter.Reporter = e, e.prototype.isError = function(a) {
    return a instanceof s;
  }, e.prototype.save = function() {
    var a = this._reporterState;
    return { obj: a.obj, pathLen: a.path.length };
  }, e.prototype.restore = function(a) {
    var l = this._reporterState;
    l.obj = a.obj, l.path = l.path.slice(0, a.pathLen);
  }, e.prototype.enterKey = function(a) {
    return this._reporterState.path.push(a);
  }, e.prototype.exitKey = function(a) {
    var l = this._reporterState;
    l.path = l.path.slice(0, a - 1);
  }, e.prototype.leaveKey = function(a, l, u) {
    var c = this._reporterState;
    this.exitKey(a), c.obj !== null && (c.obj[l] = u);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    var a = this._reporterState, l = a.obj;
    return a.obj = {}, l;
  }, e.prototype.leaveObject = function(a) {
    var l = this._reporterState, u = l.obj;
    return l.obj = a, u;
  }, e.prototype.error = function(a) {
    var l, u = this._reporterState, c = a instanceof s;
    if (c ? l = a : l = new s(u.path.map(function(E) {
      return "[" + JSON.stringify(E) + "]";
    }).join(""), a.message || a, a.stack), !u.options.partial)
      throw l;
    return c || u.errors.push(l), l;
  }, e.prototype.wrapResult = function(a) {
    var l = this._reporterState;
    return l.options.partial ? {
      result: this.isError(a) ? null : a,
      errors: l.errors
    } : a;
  };
  function s(o, a) {
    this.path = o, this.rethrow(a);
  }
  return r(s, Error), s.prototype.rethrow = function(a) {
    if (this.message = a + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack)
      try {
        throw new Error(this.message);
      } catch (l) {
        this.stack = l.stack;
      }
    return this;
  }, reporter;
}
var buffer = {}, hasRequiredBuffer;
function requireBuffer() {
  if (hasRequiredBuffer)
    return buffer;
  hasRequiredBuffer = 1;
  var r = requireInherits_browser(), e = requireBase().Reporter, s = buffer$1.Buffer;
  function o(l, u) {
    if (e.call(this, u), !s.isBuffer(l)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = l, this.offset = 0, this.length = l.length;
  }
  r(o, e), buffer.DecoderBuffer = o, o.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, o.prototype.restore = function(u) {
    var c = new o(this.base);
    return c.offset = u.offset, c.length = this.offset, this.offset = u.offset, e.prototype.restore.call(this, u.reporter), c;
  }, o.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, o.prototype.readUInt8 = function(u) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(u || "DecoderBuffer overrun");
  }, o.prototype.skip = function(u, c) {
    if (!(this.offset + u <= this.length))
      return this.error(c || "DecoderBuffer overrun");
    var E = new o(this.base);
    return E._reporterState = this._reporterState, E.offset = this.offset, E.length = this.offset + u, this.offset += u, E;
  }, o.prototype.raw = function(u) {
    return this.base.slice(u ? u.offset : this.offset, this.length);
  };
  function a(l, u) {
    if (Array.isArray(l))
      this.length = 0, this.value = l.map(function(c) {
        return c instanceof a || (c = new a(c, u)), this.length += c.length, c;
      }, this);
    else if (typeof l == "number") {
      if (!(0 <= l && l <= 255))
        return u.error("non-byte EncoderBuffer value");
      this.value = l, this.length = 1;
    } else if (typeof l == "string")
      this.value = l, this.length = s.byteLength(l);
    else if (s.isBuffer(l))
      this.value = l, this.length = l.length;
    else
      return u.error("Unsupported type: " + typeof l);
  }
  return buffer.EncoderBuffer = a, a.prototype.join = function(u, c) {
    return u || (u = new s(this.length)), c || (c = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(E) {
      E.join(u, c), c += E.length;
    }) : (typeof this.value == "number" ? u[c] = this.value : typeof this.value == "string" ? u.write(this.value, c) : s.isBuffer(this.value) && this.value.copy(u, c), c += this.length)), u;
  }, buffer;
}
var node$1, hasRequiredNode;
function requireNode() {
  if (hasRequiredNode)
    return node$1;
  hasRequiredNode = 1;
  var r = requireBase().Reporter, e = requireBase().EncoderBuffer, s = requireBase().DecoderBuffer, o = requireMinimalisticAssert(), a = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], l = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(a), u = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function c(d, f) {
    var h = {};
    this._baseState = h, h.enc = d, h.parent = f || null, h.children = null, h.tag = null, h.args = null, h.reverseArgs = null, h.choice = null, h.optional = !1, h.any = !1, h.obj = !1, h.use = null, h.useDecoder = null, h.key = null, h.default = null, h.explicit = null, h.implicit = null, h.contains = null, h.parent || (h.children = [], this._wrap());
  }
  node$1 = c;
  var E = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return c.prototype.clone = function() {
    var f = this._baseState, h = {};
    E.forEach(function(R) {
      h[R] = f[R];
    });
    var S = new this.constructor(h.parent);
    return S._baseState = h, S;
  }, c.prototype._wrap = function() {
    var f = this._baseState;
    l.forEach(function(h) {
      this[h] = function() {
        var R = new this.constructor(this);
        return f.children.push(R), R[h].apply(R, arguments);
      };
    }, this);
  }, c.prototype._init = function(f) {
    var h = this._baseState;
    o(h.parent === null), f.call(this), h.children = h.children.filter(function(S) {
      return S._baseState.parent === this;
    }, this), o.equal(h.children.length, 1, "Root node can have only one child");
  }, c.prototype._useArgs = function(f) {
    var h = this._baseState, S = f.filter(function(R) {
      return R instanceof this.constructor;
    }, this);
    f = f.filter(function(R) {
      return !(R instanceof this.constructor);
    }, this), S.length !== 0 && (o(h.children === null), h.children = S, S.forEach(function(R) {
      R._baseState.parent = this;
    }, this)), f.length !== 0 && (o(h.args === null), h.args = f, h.reverseArgs = f.map(function(R) {
      if (typeof R != "object" || R.constructor !== Object)
        return R;
      var _ = {};
      return Object.keys(R).forEach(function(m) {
        m == (m | 0) && (m |= 0);
        var L = R[m];
        _[L] = m;
      }), _;
    }));
  }, u.forEach(function(d) {
    c.prototype[d] = function() {
      var h = this._baseState;
      throw new Error(d + " not implemented for encoding: " + h.enc);
    };
  }), a.forEach(function(d) {
    c.prototype[d] = function() {
      var h = this._baseState, S = Array.prototype.slice.call(arguments);
      return o(h.tag === null), h.tag = d, this._useArgs(S), this;
    };
  }), c.prototype.use = function(f) {
    o(f);
    var h = this._baseState;
    return o(h.use === null), h.use = f, this;
  }, c.prototype.optional = function() {
    var f = this._baseState;
    return f.optional = !0, this;
  }, c.prototype.def = function(f) {
    var h = this._baseState;
    return o(h.default === null), h.default = f, h.optional = !0, this;
  }, c.prototype.explicit = function(f) {
    var h = this._baseState;
    return o(h.explicit === null && h.implicit === null), h.explicit = f, this;
  }, c.prototype.implicit = function(f) {
    var h = this._baseState;
    return o(h.explicit === null && h.implicit === null), h.implicit = f, this;
  }, c.prototype.obj = function() {
    var f = this._baseState, h = Array.prototype.slice.call(arguments);
    return f.obj = !0, h.length !== 0 && this._useArgs(h), this;
  }, c.prototype.key = function(f) {
    var h = this._baseState;
    return o(h.key === null), h.key = f, this;
  }, c.prototype.any = function() {
    var f = this._baseState;
    return f.any = !0, this;
  }, c.prototype.choice = function(f) {
    var h = this._baseState;
    return o(h.choice === null), h.choice = f, this._useArgs(Object.keys(f).map(function(S) {
      return f[S];
    })), this;
  }, c.prototype.contains = function(f) {
    var h = this._baseState;
    return o(h.use === null), h.contains = f, this;
  }, c.prototype._decode = function(f, h) {
    var S = this._baseState;
    if (S.parent === null)
      return f.wrapResult(S.children[0]._decode(f, h));
    var R = S.default, _ = !0, m = null;
    if (S.key !== null && (m = f.enterKey(S.key)), S.optional) {
      var L = null;
      if (S.explicit !== null ? L = S.explicit : S.implicit !== null ? L = S.implicit : S.tag !== null && (L = S.tag), L === null && !S.any) {
        var F = f.save();
        try {
          S.choice === null ? this._decodeGeneric(S.tag, f, h) : this._decodeChoice(f, h), _ = !0;
        } catch {
          _ = !1;
        }
        f.restore(F);
      } else if (_ = this._peekTag(f, L, S.any), f.isError(_))
        return _;
    }
    var W;
    if (S.obj && _ && (W = f.enterObject()), _) {
      if (S.explicit !== null) {
        var G = this._decodeTag(f, S.explicit);
        if (f.isError(G))
          return G;
        f = G;
      }
      var q = f.offset;
      if (S.use === null && S.choice === null) {
        if (S.any)
          var F = f.save();
        var fe = this._decodeTag(
          f,
          S.implicit !== null ? S.implicit : S.tag,
          S.any
        );
        if (f.isError(fe))
          return fe;
        S.any ? R = f.raw(F) : f = fe;
      }
      if (h && h.track && S.tag !== null && h.track(f.path(), q, f.length, "tagged"), h && h.track && S.tag !== null && h.track(f.path(), f.offset, f.length, "content"), S.any ? R = R : S.choice === null ? R = this._decodeGeneric(S.tag, f, h) : R = this._decodeChoice(f, h), f.isError(R))
        return R;
      if (!S.any && S.choice === null && S.children !== null && S.children.forEach(function(Fe) {
        Fe._decode(f, h);
      }), S.contains && (S.tag === "octstr" || S.tag === "bitstr")) {
        var _e = new s(R);
        R = this._getUse(S.contains, f._reporterState.obj)._decode(_e, h);
      }
    }
    return S.obj && _ && (R = f.leaveObject(W)), S.key !== null && (R !== null || _ === !0) ? f.leaveKey(m, S.key, R) : m !== null && f.exitKey(m), R;
  }, c.prototype._decodeGeneric = function(f, h, S) {
    var R = this._baseState;
    return f === "seq" || f === "set" ? null : f === "seqof" || f === "setof" ? this._decodeList(h, f, R.args[0], S) : /str$/.test(f) ? this._decodeStr(h, f, S) : f === "objid" && R.args ? this._decodeObjid(h, R.args[0], R.args[1], S) : f === "objid" ? this._decodeObjid(h, null, null, S) : f === "gentime" || f === "utctime" ? this._decodeTime(h, f, S) : f === "null_" ? this._decodeNull(h, S) : f === "bool" ? this._decodeBool(h, S) : f === "objDesc" ? this._decodeStr(h, f, S) : f === "int" || f === "enum" ? this._decodeInt(h, R.args && R.args[0], S) : R.use !== null ? this._getUse(R.use, h._reporterState.obj)._decode(h, S) : h.error("unknown tag: " + f);
  }, c.prototype._getUse = function(f, h) {
    var S = this._baseState;
    return S.useDecoder = this._use(f, h), o(S.useDecoder._baseState.parent === null), S.useDecoder = S.useDecoder._baseState.children[0], S.implicit !== S.useDecoder._baseState.implicit && (S.useDecoder = S.useDecoder.clone(), S.useDecoder._baseState.implicit = S.implicit), S.useDecoder;
  }, c.prototype._decodeChoice = function(f, h) {
    var S = this._baseState, R = null, _ = !1;
    return Object.keys(S.choice).some(function(m) {
      var L = f.save(), F = S.choice[m];
      try {
        var W = F._decode(f, h);
        if (f.isError(W))
          return !1;
        R = { type: m, value: W }, _ = !0;
      } catch {
        return f.restore(L), !1;
      }
      return !0;
    }, this), _ ? R : f.error("Choice not matched");
  }, c.prototype._createEncoderBuffer = function(f) {
    return new e(f, this.reporter);
  }, c.prototype._encode = function(f, h, S) {
    var R = this._baseState;
    if (!(R.default !== null && R.default === f)) {
      var _ = this._encodeValue(f, h, S);
      if (_ !== void 0 && !this._skipDefault(_, h, S))
        return _;
    }
  }, c.prototype._encodeValue = function(f, h, S) {
    var R = this._baseState;
    if (R.parent === null)
      return R.children[0]._encode(f, h || new r());
    var F = null;
    if (this.reporter = h, R.optional && f === void 0)
      if (R.default !== null)
        f = R.default;
      else
        return;
    var _ = null, m = !1;
    if (R.any)
      F = this._createEncoderBuffer(f);
    else if (R.choice)
      F = this._encodeChoice(f, h);
    else if (R.contains)
      _ = this._getUse(R.contains, S)._encode(f, h), m = !0;
    else if (R.children)
      _ = R.children.map(function(q) {
        if (q._baseState.tag === "null_")
          return q._encode(null, h, f);
        if (q._baseState.key === null)
          return h.error("Child should have a key");
        var fe = h.enterKey(q._baseState.key);
        if (typeof f != "object")
          return h.error("Child expected, but input is not object");
        var _e = q._encode(f[q._baseState.key], h, f);
        return h.leaveKey(fe), _e;
      }, this).filter(function(q) {
        return q;
      }), _ = this._createEncoderBuffer(_);
    else if (R.tag === "seqof" || R.tag === "setof") {
      if (!(R.args && R.args.length === 1))
        return h.error("Too many args for : " + R.tag);
      if (!Array.isArray(f))
        return h.error("seqof/setof, but data is not Array");
      var L = this.clone();
      L._baseState.implicit = null, _ = this._createEncoderBuffer(f.map(function(q) {
        var fe = this._baseState;
        return this._getUse(fe.args[0], f)._encode(q, h);
      }, L));
    } else
      R.use !== null ? F = this._getUse(R.use, S)._encode(f, h) : (_ = this._encodePrimitive(R.tag, f), m = !0);
    var F;
    if (!R.any && R.choice === null) {
      var W = R.implicit !== null ? R.implicit : R.tag, G = R.implicit === null ? "universal" : "context";
      W === null ? R.use === null && h.error("Tag could be omitted only for .use()") : R.use === null && (F = this._encodeComposite(W, m, G, _));
    }
    return R.explicit !== null && (F = this._encodeComposite(R.explicit, !1, "context", F)), F;
  }, c.prototype._encodeChoice = function(f, h) {
    var S = this._baseState, R = S.choice[f.type];
    return R || o(
      !1,
      f.type + " not found in " + JSON.stringify(Object.keys(S.choice))
    ), R._encode(f.value, h);
  }, c.prototype._encodePrimitive = function(f, h) {
    var S = this._baseState;
    if (/str$/.test(f))
      return this._encodeStr(h, f);
    if (f === "objid" && S.args)
      return this._encodeObjid(h, S.reverseArgs[0], S.args[1]);
    if (f === "objid")
      return this._encodeObjid(h, null, null);
    if (f === "gentime" || f === "utctime")
      return this._encodeTime(h, f);
    if (f === "null_")
      return this._encodeNull();
    if (f === "int" || f === "enum")
      return this._encodeInt(h, S.args && S.reverseArgs[0]);
    if (f === "bool")
      return this._encodeBool(h);
    if (f === "objDesc")
      return this._encodeStr(h, f);
    throw new Error("Unsupported tag: " + f);
  }, c.prototype._isNumstr = function(f) {
    return /^[0-9 ]*$/.test(f);
  }, c.prototype._isPrintstr = function(f) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(f);
  }, node$1;
}
var hasRequiredBase;
function requireBase() {
  return hasRequiredBase || (hasRequiredBase = 1, function(r) {
    var e = r;
    e.Reporter = requireReporter().Reporter, e.DecoderBuffer = requireBuffer().DecoderBuffer, e.EncoderBuffer = requireBuffer().EncoderBuffer, e.Node = requireNode();
  }(base)), base;
}
var constants = {}, der = {}, hasRequiredDer$2;
function requireDer$2() {
  return hasRequiredDer$2 || (hasRequiredDer$2 = 1, function(r) {
    var e = requireConstants();
    r.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, r.tagClassByName = e._reverse(r.tagClass), r.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, r.tagByName = e._reverse(r.tag);
  }(der)), der;
}
var hasRequiredConstants;
function requireConstants() {
  return hasRequiredConstants || (hasRequiredConstants = 1, function(r) {
    var e = r;
    e._reverse = function(o) {
      var a = {};
      return Object.keys(o).forEach(function(l) {
        (l | 0) == l && (l = l | 0);
        var u = o[l];
        a[u] = l;
      }), a;
    }, e.der = requireDer$2();
  }(constants)), constants;
}
var decoders = {}, der_1$1, hasRequiredDer$1;
function requireDer$1() {
  if (hasRequiredDer$1)
    return der_1$1;
  hasRequiredDer$1 = 1;
  var r = requireInherits_browser(), e = requireAsn1$1(), s = e.base, o = e.bignum, a = e.constants.der;
  function l(d) {
    this.enc = "der", this.name = d.name, this.entity = d, this.tree = new u(), this.tree._init(d.body);
  }
  der_1$1 = l, l.prototype.decode = function(f, h) {
    return f instanceof s.DecoderBuffer || (f = new s.DecoderBuffer(f, h)), this.tree._decode(f, h);
  };
  function u(d) {
    s.Node.call(this, "der", d);
  }
  r(u, s.Node), u.prototype._peekTag = function(f, h, S) {
    if (f.isEmpty())
      return !1;
    var R = f.save(), _ = c(f, 'Failed to peek tag: "' + h + '"');
    return f.isError(_) ? _ : (f.restore(R), _.tag === h || _.tagStr === h || _.tagStr + "of" === h || S);
  }, u.prototype._decodeTag = function(f, h, S) {
    var R = c(
      f,
      'Failed to decode tag of "' + h + '"'
    );
    if (f.isError(R))
      return R;
    var _ = E(
      f,
      R.primitive,
      'Failed to get length of "' + h + '"'
    );
    if (f.isError(_))
      return _;
    if (!S && R.tag !== h && R.tagStr !== h && R.tagStr + "of" !== h)
      return f.error('Failed to match tag: "' + h + '"');
    if (R.primitive || _ !== null)
      return f.skip(_, 'Failed to match body of: "' + h + '"');
    var m = f.save(), L = this._skipUntilEnd(
      f,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return f.isError(L) ? L : (_ = f.offset - m.offset, f.restore(m), f.skip(_, 'Failed to match body of: "' + h + '"'));
  }, u.prototype._skipUntilEnd = function(f, h) {
    for (; ; ) {
      var S = c(f, h);
      if (f.isError(S))
        return S;
      var R = E(f, S.primitive, h);
      if (f.isError(R))
        return R;
      var _;
      if (S.primitive || R !== null ? _ = f.skip(R) : _ = this._skipUntilEnd(f, h), f.isError(_))
        return _;
      if (S.tagStr === "end")
        break;
    }
  }, u.prototype._decodeList = function(f, h, S, R) {
    for (var _ = []; !f.isEmpty(); ) {
      var m = this._peekTag(f, "end");
      if (f.isError(m))
        return m;
      var L = S.decode(f, "der", R);
      if (f.isError(L) && m)
        break;
      _.push(L);
    }
    return _;
  }, u.prototype._decodeStr = function(f, h) {
    if (h === "bitstr") {
      var S = f.readUInt8();
      return f.isError(S) ? S : { unused: S, data: f.raw() };
    } else if (h === "bmpstr") {
      var R = f.raw();
      if (R.length % 2 === 1)
        return f.error("Decoding of string type: bmpstr length mismatch");
      for (var _ = "", m = 0; m < R.length / 2; m++)
        _ += String.fromCharCode(R.readUInt16BE(m * 2));
      return _;
    } else if (h === "numstr") {
      var L = f.raw().toString("ascii");
      return this._isNumstr(L) ? L : f.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (h === "octstr")
        return f.raw();
      if (h === "objDesc")
        return f.raw();
      if (h === "printstr") {
        var F = f.raw().toString("ascii");
        return this._isPrintstr(F) ? F : f.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(h) ? f.raw().toString() : f.error("Decoding of string type: " + h + " unsupported");
    }
  }, u.prototype._decodeObjid = function(f, h, S) {
    for (var R, _ = [], m = 0; !f.isEmpty(); ) {
      var L = f.readUInt8();
      m <<= 7, m |= L & 127, L & 128 || (_.push(m), m = 0);
    }
    L & 128 && _.push(m);
    var F = _[0] / 40 | 0, W = _[0] % 40;
    if (S ? R = _ : R = [F, W].concat(_.slice(1)), h) {
      var G = h[R.join(" ")];
      G === void 0 && (G = h[R.join(".")]), G !== void 0 && (R = G);
    }
    return R;
  }, u.prototype._decodeTime = function(f, h) {
    var S = f.raw().toString();
    if (h === "gentime")
      var R = S.slice(0, 4) | 0, _ = S.slice(4, 6) | 0, m = S.slice(6, 8) | 0, L = S.slice(8, 10) | 0, F = S.slice(10, 12) | 0, W = S.slice(12, 14) | 0;
    else if (h === "utctime") {
      var R = S.slice(0, 2) | 0, _ = S.slice(2, 4) | 0, m = S.slice(4, 6) | 0, L = S.slice(6, 8) | 0, F = S.slice(8, 10) | 0, W = S.slice(10, 12) | 0;
      R < 70 ? R = 2e3 + R : R = 1900 + R;
    } else
      return f.error("Decoding " + h + " time is not supported yet");
    return Date.UTC(R, _ - 1, m, L, F, W, 0);
  }, u.prototype._decodeNull = function(f) {
    return null;
  }, u.prototype._decodeBool = function(f) {
    var h = f.readUInt8();
    return f.isError(h) ? h : h !== 0;
  }, u.prototype._decodeInt = function(f, h) {
    var S = f.raw(), R = new o(S);
    return h && (R = h[R.toString(10)] || R), R;
  }, u.prototype._use = function(f, h) {
    return typeof f == "function" && (f = f(h)), f._getDecoder("der").tree;
  };
  function c(d, f) {
    var h = d.readUInt8(f);
    if (d.isError(h))
      return h;
    var S = a.tagClass[h >> 6], R = (h & 32) === 0;
    if ((h & 31) === 31) {
      var _ = h;
      for (h = 0; (_ & 128) === 128; ) {
        if (_ = d.readUInt8(f), d.isError(_))
          return _;
        h <<= 7, h |= _ & 127;
      }
    } else
      h &= 31;
    var m = a.tag[h];
    return {
      cls: S,
      primitive: R,
      tag: h,
      tagStr: m
    };
  }
  function E(d, f, h) {
    var S = d.readUInt8(h);
    if (d.isError(S))
      return S;
    if (!f && S === 128)
      return null;
    if (!(S & 128))
      return S;
    var R = S & 127;
    if (R > 4)
      return d.error("length octect is too long");
    S = 0;
    for (var _ = 0; _ < R; _++) {
      S <<= 8;
      var m = d.readUInt8(h);
      if (d.isError(m))
        return m;
      S |= m;
    }
    return S;
  }
  return der_1$1;
}
var pem$1, hasRequiredPem$1;
function requirePem$1() {
  if (hasRequiredPem$1)
    return pem$1;
  hasRequiredPem$1 = 1;
  var r = requireInherits_browser(), e = buffer$1.Buffer, s = requireDer$1();
  function o(a) {
    s.call(this, a), this.enc = "pem";
  }
  return r(o, s), pem$1 = o, o.prototype.decode = function(l, u) {
    for (var c = l.toString().split(/[\r\n]+/g), E = u.label.toUpperCase(), d = /^-----(BEGIN|END) ([^-]+)-----$/, f = -1, h = -1, S = 0; S < c.length; S++) {
      var R = c[S].match(d);
      if (R !== null && R[2] === E)
        if (f === -1) {
          if (R[1] !== "BEGIN")
            break;
          f = S;
        } else {
          if (R[1] !== "END")
            break;
          h = S;
          break;
        }
    }
    if (f === -1 || h === -1)
      throw new Error("PEM section not found for: " + E);
    var _ = c.slice(f + 1, h).join("");
    _.replace(/[^a-z0-9\+\/=]+/gi, "");
    var m = new e(_, "base64");
    return s.prototype.decode.call(this, m, u);
  }, pem$1;
}
var hasRequiredDecoders;
function requireDecoders() {
  return hasRequiredDecoders || (hasRequiredDecoders = 1, function(r) {
    var e = r;
    e.der = requireDer$1(), e.pem = requirePem$1();
  }(decoders)), decoders;
}
var encoders = {}, der_1, hasRequiredDer;
function requireDer() {
  if (hasRequiredDer)
    return der_1;
  hasRequiredDer = 1;
  var r = requireInherits_browser(), e = buffer$1.Buffer, s = requireAsn1$1(), o = s.base, a = s.constants.der;
  function l(d) {
    this.enc = "der", this.name = d.name, this.entity = d, this.tree = new u(), this.tree._init(d.body);
  }
  der_1 = l, l.prototype.encode = function(f, h) {
    return this.tree._encode(f, h).join();
  };
  function u(d) {
    o.Node.call(this, "der", d);
  }
  r(u, o.Node), u.prototype._encodeComposite = function(f, h, S, R) {
    var _ = E(f, h, S, this.reporter);
    if (R.length < 128) {
      var F = new e(2);
      return F[0] = _, F[1] = R.length, this._createEncoderBuffer([F, R]);
    }
    for (var m = 1, L = R.length; L >= 256; L >>= 8)
      m++;
    var F = new e(1 + 1 + m);
    F[0] = _, F[1] = 128 | m;
    for (var L = 1 + m, W = R.length; W > 0; L--, W >>= 8)
      F[L] = W & 255;
    return this._createEncoderBuffer([F, R]);
  }, u.prototype._encodeStr = function(f, h) {
    if (h === "bitstr")
      return this._createEncoderBuffer([f.unused | 0, f.data]);
    if (h === "bmpstr") {
      for (var S = new e(f.length * 2), R = 0; R < f.length; R++)
        S.writeUInt16BE(f.charCodeAt(R), R * 2);
      return this._createEncoderBuffer(S);
    } else
      return h === "numstr" ? this._isNumstr(f) ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : h === "printstr" ? this._isPrintstr(f) ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(h) ? this._createEncoderBuffer(f) : h === "objDesc" ? this._createEncoderBuffer(f) : this.reporter.error("Encoding of string type: " + h + " unsupported");
  }, u.prototype._encodeObjid = function(f, h, S) {
    if (typeof f == "string") {
      if (!h)
        return this.reporter.error("string objid given, but no values map found");
      if (!h.hasOwnProperty(f))
        return this.reporter.error("objid not found in values map");
      f = h[f].split(/[\s\.]+/g);
      for (var R = 0; R < f.length; R++)
        f[R] |= 0;
    } else if (Array.isArray(f)) {
      f = f.slice();
      for (var R = 0; R < f.length; R++)
        f[R] |= 0;
    }
    if (!Array.isArray(f))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(f));
    if (!S) {
      if (f[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      f.splice(0, 2, f[0] * 40 + f[1]);
    }
    for (var _ = 0, R = 0; R < f.length; R++) {
      var m = f[R];
      for (_++; m >= 128; m >>= 7)
        _++;
    }
    for (var L = new e(_), F = L.length - 1, R = f.length - 1; R >= 0; R--) {
      var m = f[R];
      for (L[F--] = m & 127; (m >>= 7) > 0; )
        L[F--] = 128 | m & 127;
    }
    return this._createEncoderBuffer(L);
  };
  function c(d) {
    return d < 10 ? "0" + d : d;
  }
  u.prototype._encodeTime = function(f, h) {
    var S, R = new Date(f);
    return h === "gentime" ? S = [
      c(R.getFullYear()),
      c(R.getUTCMonth() + 1),
      c(R.getUTCDate()),
      c(R.getUTCHours()),
      c(R.getUTCMinutes()),
      c(R.getUTCSeconds()),
      "Z"
    ].join("") : h === "utctime" ? S = [
      c(R.getFullYear() % 100),
      c(R.getUTCMonth() + 1),
      c(R.getUTCDate()),
      c(R.getUTCHours()),
      c(R.getUTCMinutes()),
      c(R.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + h + " time is not supported yet"), this._encodeStr(S, "octstr");
  }, u.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, u.prototype._encodeInt = function(f, h) {
    if (typeof f == "string") {
      if (!h)
        return this.reporter.error("String int or enum given, but no values map");
      if (!h.hasOwnProperty(f))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(f));
      f = h[f];
    }
    if (typeof f != "number" && !e.isBuffer(f)) {
      var S = f.toArray();
      !f.sign && S[0] & 128 && S.unshift(0), f = new e(S);
    }
    if (e.isBuffer(f)) {
      var R = f.length;
      f.length === 0 && R++;
      var m = new e(R);
      return f.copy(m), f.length === 0 && (m[0] = 0), this._createEncoderBuffer(m);
    }
    if (f < 128)
      return this._createEncoderBuffer(f);
    if (f < 256)
      return this._createEncoderBuffer([0, f]);
    for (var R = 1, _ = f; _ >= 256; _ >>= 8)
      R++;
    for (var m = new Array(R), _ = m.length - 1; _ >= 0; _--)
      m[_] = f & 255, f >>= 8;
    return m[0] & 128 && m.unshift(0), this._createEncoderBuffer(new e(m));
  }, u.prototype._encodeBool = function(f) {
    return this._createEncoderBuffer(f ? 255 : 0);
  }, u.prototype._use = function(f, h) {
    return typeof f == "function" && (f = f(h)), f._getEncoder("der").tree;
  }, u.prototype._skipDefault = function(f, h, S) {
    var R = this._baseState, _;
    if (R.default === null)
      return !1;
    var m = f.join();
    if (R.defaultBuffer === void 0 && (R.defaultBuffer = this._encodeValue(R.default, h, S).join()), m.length !== R.defaultBuffer.length)
      return !1;
    for (_ = 0; _ < m.length; _++)
      if (m[_] !== R.defaultBuffer[_])
        return !1;
    return !0;
  };
  function E(d, f, h, S) {
    var R;
    if (d === "seqof" ? d = "seq" : d === "setof" && (d = "set"), a.tagByName.hasOwnProperty(d))
      R = a.tagByName[d];
    else if (typeof d == "number" && (d | 0) === d)
      R = d;
    else
      return S.error("Unknown tag: " + d);
    return R >= 31 ? S.error("Multi-octet tag encoding unsupported") : (f || (R |= 32), R |= a.tagClassByName[h || "universal"] << 6, R);
  }
  return der_1;
}
var pem, hasRequiredPem;
function requirePem() {
  if (hasRequiredPem)
    return pem;
  hasRequiredPem = 1;
  var r = requireInherits_browser(), e = requireDer();
  function s(o) {
    e.call(this, o), this.enc = "pem";
  }
  return r(s, e), pem = s, s.prototype.encode = function(a, l) {
    for (var u = e.prototype.encode.call(this, a), c = u.toString("base64"), E = ["-----BEGIN " + l.label + "-----"], d = 0; d < c.length; d += 64)
      E.push(c.slice(d, d + 64));
    return E.push("-----END " + l.label + "-----"), E.join(`
`);
  }, pem;
}
var hasRequiredEncoders;
function requireEncoders() {
  return hasRequiredEncoders || (hasRequiredEncoders = 1, function(r) {
    var e = r;
    e.der = requireDer(), e.pem = requirePem();
  }(encoders)), encoders;
}
var hasRequiredAsn1$1;
function requireAsn1$1() {
  return hasRequiredAsn1$1 || (hasRequiredAsn1$1 = 1, function(r) {
    var e = r;
    e.bignum = requireBn$1(), e.define = requireApi().define, e.base = requireBase(), e.constants = requireConstants(), e.decoders = requireDecoders(), e.encoders = requireEncoders();
  }(asn1)), asn1;
}
var certificate, hasRequiredCertificate;
function requireCertificate() {
  if (hasRequiredCertificate)
    return certificate;
  hasRequiredCertificate = 1;
  var r = requireAsn1$1(), e = r.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), s = r.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), o = r.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), a = r.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(o),
      this.key("subjectPublicKey").bitstr()
    );
  }), l = r.define("RelativeDistinguishedName", function() {
    this.setof(s);
  }), u = r.define("RDNSequence", function() {
    this.seqof(l);
  }), c = r.define("Name", function() {
    this.choice({
      rdnSequence: this.use(u)
    });
  }), E = r.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), d = r.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), f = r.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(o),
      this.key("issuer").use(c),
      this.key("validity").use(E),
      this.key("subject").use(c),
      this.key("subjectPublicKeyInfo").use(a),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(d).optional()
    );
  }), h = r.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(f),
      this.key("signatureAlgorithm").use(o),
      this.key("signatureValue").bitstr()
    );
  });
  return certificate = h, certificate;
}
var hasRequiredAsn1;
function requireAsn1() {
  if (hasRequiredAsn1)
    return asn1$1;
  hasRequiredAsn1 = 1;
  var r = requireAsn1$1();
  asn1$1.certificate = requireCertificate();
  var e = r.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  asn1$1.RSAPrivateKey = e;
  var s = r.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  asn1$1.RSAPublicKey = s;
  var o = r.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), a = r.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(o),
      this.key("subjectPublicKey").bitstr()
    );
  });
  asn1$1.PublicKey = a;
  var l = r.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(o),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.PrivateKey = l;
  var u = r.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  asn1$1.EncryptedPrivateKey = u;
  var c = r.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  asn1$1.DSAPrivateKey = c, asn1$1.DSAparam = r.define("DSAparam", function() {
    this.int();
  });
  var E = r.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), d = r.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(E),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return asn1$1.ECPrivateKey = d, asn1$1.signature = r.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), asn1$1;
}
const require$$1 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var fixProc, hasRequiredFixProc;
function requireFixProc() {
  if (hasRequiredFixProc)
    return fixProc;
  hasRequiredFixProc = 1;
  var r = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = requireEvp_bytestokey(), a = requireBrowser$6(), l = requireSafeBuffer$1().Buffer;
  return fixProc = function(u, c) {
    var E = u.toString(), d = E.match(r), f;
    if (d) {
      var S = "aes" + d[1], R = l.from(d[2], "hex"), _ = l.from(d[3].replace(/[\r\n]/g, ""), "base64"), m = o(c, R.slice(0, 8), parseInt(d[1], 10)).key, L = [], F = a.createDecipheriv(S, m, R);
      L.push(F.update(_)), L.push(F.final()), f = l.concat(L);
    } else {
      var h = E.match(s);
      f = l.from(h[2].replace(/[\r\n]/g, ""), "base64");
    }
    var W = E.match(e)[1];
    return {
      tag: W,
      data: f
    };
  }, fixProc;
}
var parseAsn1, hasRequiredParseAsn1;
function requireParseAsn1() {
  if (hasRequiredParseAsn1)
    return parseAsn1;
  hasRequiredParseAsn1 = 1;
  var r = requireAsn1(), e = require$$1, s = requireFixProc(), o = requireBrowser$6(), a = requireBrowser$7(), l = requireSafeBuffer$1().Buffer;
  function u(E, d) {
    var f = E.algorithm.decrypt.kde.kdeparams.salt, h = parseInt(E.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), S = e[E.algorithm.decrypt.cipher.algo.join(".")], R = E.algorithm.decrypt.cipher.iv, _ = E.subjectPrivateKey, m = parseInt(S.split("-")[1], 10) / 8, L = a.pbkdf2Sync(d, f, h, m, "sha1"), F = o.createDecipheriv(S, L, R), W = [];
    return W.push(F.update(_)), W.push(F.final()), l.concat(W);
  }
  function c(E) {
    var d;
    typeof E == "object" && !l.isBuffer(E) && (d = E.passphrase, E = E.key), typeof E == "string" && (E = l.from(E));
    var f = s(E, d), h = f.tag, S = f.data, R, _;
    switch (h) {
      case "CERTIFICATE":
        _ = r.certificate.decode(S, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (_ || (_ = r.PublicKey.decode(S, "der")), R = _.algorithm.algorithm.join("."), R) {
          case "1.2.840.113549.1.1.1":
            return r.RSAPublicKey.decode(_.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return _.subjectPrivateKey = _.subjectPublicKey, {
              type: "ec",
              data: _
            };
          case "1.2.840.10040.4.1":
            return _.algorithm.params.pub_key = r.DSAparam.decode(_.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: _.algorithm.params
            };
          default:
            throw new Error("unknown key id " + R);
        }
      case "ENCRYPTED PRIVATE KEY":
        S = r.EncryptedPrivateKey.decode(S, "der"), S = u(S, d);
      case "PRIVATE KEY":
        switch (_ = r.PrivateKey.decode(S, "der"), R = _.algorithm.algorithm.join("."), R) {
          case "1.2.840.113549.1.1.1":
            return r.RSAPrivateKey.decode(_.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: _.algorithm.curve,
              privateKey: r.ECPrivateKey.decode(_.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return _.algorithm.params.priv_key = r.DSAparam.decode(_.subjectPrivateKey, "der"), {
              type: "dsa",
              params: _.algorithm.params
            };
          default:
            throw new Error("unknown key id " + R);
        }
      case "RSA PUBLIC KEY":
        return r.RSAPublicKey.decode(S, "der");
      case "RSA PRIVATE KEY":
        return r.RSAPrivateKey.decode(S, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: r.DSAPrivateKey.decode(S, "der")
        };
      case "EC PRIVATE KEY":
        return S = r.ECPrivateKey.decode(S, "der"), {
          curve: S.parameters.value,
          privateKey: S.privateKey
        };
      default:
        throw new Error("unknown key type " + h);
    }
  }
  return c.signature = r.signature, parseAsn1 = c, parseAsn1;
}
const require$$4 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var hasRequiredSign;
function requireSign() {
  if (hasRequiredSign)
    return sign$3.exports;
  hasRequiredSign = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireBrowser$8(), s = requireBrowserifyRsa(), o = requireElliptic().ec, a = requireBn(), l = requireParseAsn1(), u = require$$4, c = 1;
  function E(F, W, G, q, fe) {
    var _e = l(W);
    if (_e.curve) {
      if (q !== "ecdsa" && q !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return d(F, _e);
    } else if (_e.type === "dsa") {
      if (q !== "dsa")
        throw new Error("wrong private key type");
      return f(F, _e, G);
    }
    if (q !== "rsa" && q !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (W.padding !== void 0 && W.padding !== c)
      throw new Error("illegal or unsupported padding mode");
    F = r.concat([fe, F]);
    for (var Le = _e.modulus.byteLength(), Fe = [0, 1]; F.length + Fe.length + 1 < Le; )
      Fe.push(255);
    Fe.push(0);
    for (var Ee = -1; ++Ee < F.length; )
      Fe.push(F[Ee]);
    var Ge = s(Fe, _e);
    return Ge;
  }
  function d(F, W) {
    var G = u[W.curve.join(".")];
    if (!G)
      throw new Error("unknown curve " + W.curve.join("."));
    var q = new o(G), fe = q.keyFromPrivate(W.privateKey), _e = fe.sign(F);
    return r.from(_e.toDER());
  }
  function f(F, W, G) {
    for (var q = W.params.priv_key, fe = W.params.p, _e = W.params.q, Le = W.params.g, Fe = new a(0), Ee, Ge = R(F, _e).mod(_e), ve = !1, te = S(q, _e, F, G); ve === !1; )
      Ee = m(_e, te, G), Fe = L(Le, Ee, fe, _e), ve = Ee.invm(_e).imul(Ge.add(q.mul(Fe))).mod(_e), ve.cmpn(0) === 0 && (ve = !1, Fe = new a(0));
    return h(Fe, ve);
  }
  function h(F, W) {
    F = F.toArray(), W = W.toArray(), F[0] & 128 && (F = [0].concat(F)), W[0] & 128 && (W = [0].concat(W));
    var G = F.length + W.length + 4, q = [
      48,
      G,
      2,
      F.length
    ];
    return q = q.concat(F, [2, W.length], W), r.from(q);
  }
  function S(F, W, G, q) {
    if (F = r.from(F.toArray()), F.length < W.byteLength()) {
      var fe = r.alloc(W.byteLength() - F.length);
      F = r.concat([fe, F]);
    }
    var _e = G.length, Le = _(G, W), Fe = r.alloc(_e);
    Fe.fill(1);
    var Ee = r.alloc(_e);
    return Ee = e(q, Ee).update(Fe).update(r.from([0])).update(F).update(Le).digest(), Fe = e(q, Ee).update(Fe).digest(), Ee = e(q, Ee).update(Fe).update(r.from([1])).update(F).update(Le).digest(), Fe = e(q, Ee).update(Fe).digest(), { k: Ee, v: Fe };
  }
  function R(F, W) {
    var G = new a(F), q = (F.length << 3) - W.bitLength();
    return q > 0 && G.ishrn(q), G;
  }
  function _(F, W) {
    F = R(F, W), F = F.mod(W);
    var G = r.from(F.toArray());
    if (G.length < W.byteLength()) {
      var q = r.alloc(W.byteLength() - G.length);
      G = r.concat([q, G]);
    }
    return G;
  }
  function m(F, W, G) {
    var q, fe;
    do {
      for (q = r.alloc(0); q.length * 8 < F.bitLength(); )
        W.v = e(G, W.k).update(W.v).digest(), q = r.concat([q, W.v]);
      fe = R(q, F), W.k = e(G, W.k).update(W.v).update(r.from([0])).digest(), W.v = e(G, W.k).update(W.v).digest();
    } while (fe.cmp(F) !== -1);
    return fe;
  }
  function L(F, W, G, q) {
    return F.toRed(a.mont(G)).redPow(W).fromRed().mod(q);
  }
  return sign$3.exports = E, sign$3.exports.getKey = S, sign$3.exports.makeKey = m, sign$3.exports;
}
var verify_1, hasRequiredVerify;
function requireVerify() {
  if (hasRequiredVerify)
    return verify_1;
  hasRequiredVerify = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireBn(), s = requireElliptic().ec, o = requireParseAsn1(), a = require$$4;
  function l(d, f, h, S, R) {
    var _ = o(h);
    if (_.type === "ec") {
      if (S !== "ecdsa" && S !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return u(d, f, _);
    } else if (_.type === "dsa") {
      if (S !== "dsa")
        throw new Error("wrong public key type");
      return c(d, f, _);
    }
    if (S !== "rsa" && S !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    f = r.concat([R, f]);
    for (var m = _.modulus.byteLength(), L = [1], F = 0; f.length + L.length + 2 < m; )
      L.push(255), F += 1;
    L.push(0);
    for (var W = -1; ++W < f.length; )
      L.push(f[W]);
    L = r.from(L);
    var G = e.mont(_.modulus);
    d = new e(d).toRed(G), d = d.redPow(new e(_.publicExponent)), d = r.from(d.fromRed().toArray());
    var q = F < 8 ? 1 : 0;
    for (m = Math.min(d.length, L.length), d.length !== L.length && (q = 1), W = -1; ++W < m; )
      q |= d[W] ^ L[W];
    return q === 0;
  }
  function u(d, f, h) {
    var S = a[h.data.algorithm.curve.join(".")];
    if (!S)
      throw new Error("unknown curve " + h.data.algorithm.curve.join("."));
    var R = new s(S), _ = h.data.subjectPrivateKey.data;
    return R.verify(f, d, _);
  }
  function c(d, f, h) {
    var S = h.data.p, R = h.data.q, _ = h.data.g, m = h.data.pub_key, L = o.signature.decode(d, "der"), F = L.s, W = L.r;
    E(F, R), E(W, R);
    var G = e.mont(S), q = F.invm(R), fe = _.toRed(G).redPow(new e(f).mul(q).mod(R)).fromRed().mul(m.toRed(G).redPow(W.mul(q).mod(R)).fromRed()).mod(S).mod(R);
    return fe.cmp(W) === 0;
  }
  function E(d, f) {
    if (d.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (d.cmp(f) >= 0)
      throw new Error("invalid sig");
  }
  return verify_1 = l, verify_1;
}
var browser$3, hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3)
    return browser$3;
  hasRequiredBrowser$3 = 1;
  var r = requireSafeBuffer$1().Buffer, e = requireBrowser$9(), s = requireReadableBrowser(), o = requireInherits_browser(), a = requireSign(), l = requireVerify(), u = require$$6;
  Object.keys(u).forEach(function(h) {
    u[h].id = r.from(u[h].id, "hex"), u[h.toLowerCase()] = u[h];
  });
  function c(h) {
    s.Writable.call(this);
    var S = u[h];
    if (!S)
      throw new Error("Unknown message digest");
    this._hashType = S.hash, this._hash = e(S.hash), this._tag = S.id, this._signType = S.sign;
  }
  o(c, s.Writable), c.prototype._write = function(S, R, _) {
    this._hash.update(S), _();
  }, c.prototype.update = function(S, R) {
    return this._hash.update(typeof S == "string" ? r.from(S, R) : S), this;
  }, c.prototype.sign = function(S, R) {
    this.end();
    var _ = this._hash.digest(), m = a(_, S, this._hashType, this._signType, this._tag);
    return R ? m.toString(R) : m;
  };
  function E(h) {
    s.Writable.call(this);
    var S = u[h];
    if (!S)
      throw new Error("Unknown message digest");
    this._hash = e(S.hash), this._tag = S.id, this._signType = S.sign;
  }
  o(E, s.Writable), E.prototype._write = function(S, R, _) {
    this._hash.update(S), _();
  }, E.prototype.update = function(S, R) {
    return this._hash.update(typeof S == "string" ? r.from(S, R) : S), this;
  }, E.prototype.verify = function(S, R, _) {
    var m = typeof R == "string" ? r.from(R, _) : R;
    this.end();
    var L = this._hash.digest();
    return l(m, L, S, this._signType, this._tag);
  };
  function d(h) {
    return new c(h);
  }
  function f(h) {
    return new E(h);
  }
  return browser$3 = {
    Sign: d,
    Verify: f,
    createSign: d,
    createVerify: f
  }, browser$3;
}
var browser$2, hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2)
    return browser$2;
  hasRequiredBrowser$2 = 1;
  var r = requireElliptic(), e = requireBn$1();
  browser$2 = function(u) {
    return new o(u);
  };
  var s = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1;
  function o(l) {
    this.curveType = s[l], this.curveType || (this.curveType = {
      name: l
    }), this.curve = new r.ec(this.curveType.name), this.keys = void 0;
  }
  o.prototype.generateKeys = function(l, u) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(l, u);
  }, o.prototype.computeSecret = function(l, u, c) {
    u = u || "utf8", buffer$1.Buffer.isBuffer(l) || (l = new buffer$1.Buffer(l, u));
    var E = this.curve.keyFromPublic(l).getPublic(), d = E.mul(this.keys.getPrivate()).getX();
    return a(d, c, this.curveType.byteLength);
  }, o.prototype.getPublicKey = function(l, u) {
    var c = this.keys.getPublic(u === "compressed", !0);
    return u === "hybrid" && (c[c.length - 1] % 2 ? c[0] = 7 : c[0] = 6), a(c, l);
  }, o.prototype.getPrivateKey = function(l) {
    return a(this.keys.getPrivate(), l);
  }, o.prototype.setPublicKey = function(l, u) {
    return u = u || "utf8", buffer$1.Buffer.isBuffer(l) || (l = new buffer$1.Buffer(l, u)), this.keys._importPublic(l), this;
  }, o.prototype.setPrivateKey = function(l, u) {
    u = u || "utf8", buffer$1.Buffer.isBuffer(l) || (l = new buffer$1.Buffer(l, u));
    var c = new e(l);
    return c = c.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(c), this;
  };
  function a(l, u, c) {
    Array.isArray(l) || (l = l.toArray());
    var E = new buffer$1.Buffer(l);
    if (c && E.length < c) {
      var d = new buffer$1.Buffer(c - E.length);
      d.fill(0), E = buffer$1.Buffer.concat([d, E]);
    }
    return u ? E.toString(u) : E;
  }
  return browser$2;
}
var browser$1 = {}, mgf, hasRequiredMgf;
function requireMgf() {
  if (hasRequiredMgf)
    return mgf;
  hasRequiredMgf = 1;
  var r = requireBrowser$9(), e = requireSafeBuffer$1().Buffer;
  mgf = function(o, a) {
    for (var l = e.alloc(0), u = 0, c; l.length < a; )
      c = s(u++), l = e.concat([l, r("sha1").update(o).update(c).digest()]);
    return l.slice(0, a);
  };
  function s(o) {
    var a = e.allocUnsafe(4);
    return a.writeUInt32BE(o, 0), a;
  }
  return mgf;
}
var xor, hasRequiredXor;
function requireXor() {
  return hasRequiredXor || (hasRequiredXor = 1, xor = function(e, s) {
    for (var o = e.length, a = -1; ++a < o; )
      e[a] ^= s[a];
    return e;
  }), xor;
}
var withPublic_1, hasRequiredWithPublic;
function requireWithPublic() {
  if (hasRequiredWithPublic)
    return withPublic_1;
  hasRequiredWithPublic = 1;
  var r = requireBn$1(), e = requireSafeBuffer$1().Buffer;
  function s(o, a) {
    return e.from(o.toRed(r.mont(a.modulus)).redPow(new r(a.publicExponent)).fromRed().toArray());
  }
  return withPublic_1 = s, withPublic_1;
}
var publicEncrypt, hasRequiredPublicEncrypt;
function requirePublicEncrypt() {
  if (hasRequiredPublicEncrypt)
    return publicEncrypt;
  hasRequiredPublicEncrypt = 1;
  var r = requireParseAsn1(), e = requireBrowser$b(), s = requireBrowser$9(), o = requireMgf(), a = requireXor(), l = requireBn$1(), u = requireWithPublic(), c = requireBrowserifyRsa(), E = requireSafeBuffer$1().Buffer;
  publicEncrypt = function(R, _, m) {
    var L;
    R.padding ? L = R.padding : m ? L = 1 : L = 4;
    var F = r(R), W;
    if (L === 4)
      W = d(F, _);
    else if (L === 1)
      W = f(F, _, m);
    else if (L === 3) {
      if (W = new l(_), W.cmp(F.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return m ? c(W, F) : u(W, F);
  };
  function d(S, R) {
    var _ = S.modulus.byteLength(), m = R.length, L = s("sha1").update(E.alloc(0)).digest(), F = L.length, W = 2 * F;
    if (m > _ - W - 2)
      throw new Error("message too long");
    var G = E.alloc(_ - m - W - 2), q = _ - F - 1, fe = e(F), _e = a(E.concat([L, G, E.alloc(1, 1), R], q), o(fe, q)), Le = a(fe, o(_e, F));
    return new l(E.concat([E.alloc(1), Le, _e], _));
  }
  function f(S, R, _) {
    var m = R.length, L = S.modulus.byteLength();
    if (m > L - 11)
      throw new Error("message too long");
    var F;
    return _ ? F = E.alloc(L - m - 3, 255) : F = h(L - m - 3), new l(E.concat([E.from([0, _ ? 1 : 2]), F, E.alloc(1), R], L));
  }
  function h(S) {
    for (var R = E.allocUnsafe(S), _ = 0, m = e(S * 2), L = 0, F; _ < S; )
      L === m.length && (m = e(S * 2), L = 0), F = m[L++], F && (R[_++] = F);
    return R;
  }
  return publicEncrypt;
}
var privateDecrypt, hasRequiredPrivateDecrypt;
function requirePrivateDecrypt() {
  if (hasRequiredPrivateDecrypt)
    return privateDecrypt;
  hasRequiredPrivateDecrypt = 1;
  var r = requireParseAsn1(), e = requireMgf(), s = requireXor(), o = requireBn$1(), a = requireBrowserifyRsa(), l = requireBrowser$9(), u = requireWithPublic(), c = requireSafeBuffer$1().Buffer;
  privateDecrypt = function(S, R, _) {
    var m;
    S.padding ? m = S.padding : _ ? m = 1 : m = 4;
    var L = r(S), F = L.modulus.byteLength();
    if (R.length > F || new o(R).cmp(L.modulus) >= 0)
      throw new Error("decryption error");
    var W;
    _ ? W = u(new o(R), L) : W = a(R, L);
    var G = c.alloc(F - W.length);
    if (W = c.concat([G, W], F), m === 4)
      return E(L, W);
    if (m === 1)
      return d(L, W, _);
    if (m === 3)
      return W;
    throw new Error("unknown padding");
  };
  function E(h, S) {
    var R = h.modulus.byteLength(), _ = l("sha1").update(c.alloc(0)).digest(), m = _.length;
    if (S[0] !== 0)
      throw new Error("decryption error");
    var L = S.slice(1, m + 1), F = S.slice(m + 1), W = s(L, e(F, m)), G = s(F, e(W, R - m - 1));
    if (f(_, G.slice(0, m)))
      throw new Error("decryption error");
    for (var q = m; G[q] === 0; )
      q++;
    if (G[q++] !== 1)
      throw new Error("decryption error");
    return G.slice(q);
  }
  function d(h, S, R) {
    for (var _ = S.slice(0, 2), m = 2, L = 0; S[m++] !== 0; )
      if (m >= S.length) {
        L++;
        break;
      }
    var F = S.slice(2, m - 1);
    if ((_.toString("hex") !== "0002" && !R || _.toString("hex") !== "0001" && R) && L++, F.length < 8 && L++, L)
      throw new Error("decryption error");
    return S.slice(m);
  }
  function f(h, S) {
    h = c.from(h), S = c.from(S);
    var R = 0, _ = h.length;
    h.length !== S.length && (R++, _ = Math.min(h.length, S.length));
    for (var m = -1; ++m < _; )
      R += h[m] ^ S[m];
    return R;
  }
  return privateDecrypt;
}
var hasRequiredBrowser$1;
function requireBrowser$1() {
  return hasRequiredBrowser$1 || (hasRequiredBrowser$1 = 1, function(r) {
    r.publicEncrypt = requirePublicEncrypt(), r.privateDecrypt = requirePrivateDecrypt(), r.privateEncrypt = function(s, o) {
      return r.publicEncrypt(s, o, !0);
    }, r.publicDecrypt = function(s, o) {
      return r.privateDecrypt(s, o, !0);
    };
  }(browser$1)), browser$1;
}
var browser = {}, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser)
    return browser;
  hasRequiredBrowser = 1;
  function r() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = requireSafeBuffer$1(), s = requireBrowser$b(), o = e.Buffer, a = e.kMaxLength, l = commonjsGlobal.crypto || commonjsGlobal.msCrypto, u = Math.pow(2, 32) - 1;
  function c(S, R) {
    if (typeof S != "number" || S !== S)
      throw new TypeError("offset must be a number");
    if (S > u || S < 0)
      throw new TypeError("offset must be a uint32");
    if (S > a || S > R)
      throw new RangeError("offset out of range");
  }
  function E(S, R, _) {
    if (typeof S != "number" || S !== S)
      throw new TypeError("size must be a number");
    if (S > u || S < 0)
      throw new TypeError("size must be a uint32");
    if (S + R > _ || S > a)
      throw new RangeError("buffer too small");
  }
  l && l.getRandomValues || !api$1.browser ? (browser.randomFill = d, browser.randomFillSync = h) : (browser.randomFill = r, browser.randomFillSync = r);
  function d(S, R, _, m) {
    if (!o.isBuffer(S) && !(S instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof R == "function")
      m = R, R = 0, _ = S.length;
    else if (typeof _ == "function")
      m = _, _ = S.length - R;
    else if (typeof m != "function")
      throw new TypeError('"cb" argument must be a function');
    return c(R, S.length), E(_, R, S.length), f(S, R, _, m);
  }
  function f(S, R, _, m) {
    if (api$1.browser) {
      var L = S.buffer, F = new Uint8Array(L, R, _);
      if (l.getRandomValues(F), m) {
        api$1.nextTick(function() {
          m(null, S);
        });
        return;
      }
      return S;
    }
    if (m) {
      s(_, function(G, q) {
        if (G)
          return m(G);
        q.copy(S, R), m(null, S);
      });
      return;
    }
    var W = s(_);
    return W.copy(S, R), S;
  }
  function h(S, R, _) {
    if (typeof R > "u" && (R = 0), !o.isBuffer(S) && !(S instanceof commonjsGlobal.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return c(R, S.length), _ === void 0 && (_ = S.length - R), E(_, R, S.length), f(S, R, _);
  }
  return browser;
}
var hasRequiredCryptoBrowserify;
function requireCryptoBrowserify() {
  if (hasRequiredCryptoBrowserify)
    return cryptoBrowserify;
  hasRequiredCryptoBrowserify = 1, cryptoBrowserify.randomBytes = cryptoBrowserify.rng = cryptoBrowserify.pseudoRandomBytes = cryptoBrowserify.prng = requireBrowser$b(), cryptoBrowserify.createHash = cryptoBrowserify.Hash = requireBrowser$9(), cryptoBrowserify.createHmac = cryptoBrowserify.Hmac = requireBrowser$8();
  var r = requireAlgos(), e = Object.keys(r), s = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(e);
  cryptoBrowserify.getHashes = function() {
    return s;
  };
  var o = requireBrowser$7();
  cryptoBrowserify.pbkdf2 = o.pbkdf2, cryptoBrowserify.pbkdf2Sync = o.pbkdf2Sync;
  var a = requireBrowser$5();
  cryptoBrowserify.Cipher = a.Cipher, cryptoBrowserify.createCipher = a.createCipher, cryptoBrowserify.Cipheriv = a.Cipheriv, cryptoBrowserify.createCipheriv = a.createCipheriv, cryptoBrowserify.Decipher = a.Decipher, cryptoBrowserify.createDecipher = a.createDecipher, cryptoBrowserify.Decipheriv = a.Decipheriv, cryptoBrowserify.createDecipheriv = a.createDecipheriv, cryptoBrowserify.getCiphers = a.getCiphers, cryptoBrowserify.listCiphers = a.listCiphers;
  var l = requireBrowser$4();
  cryptoBrowserify.DiffieHellmanGroup = l.DiffieHellmanGroup, cryptoBrowserify.createDiffieHellmanGroup = l.createDiffieHellmanGroup, cryptoBrowserify.getDiffieHellman = l.getDiffieHellman, cryptoBrowserify.createDiffieHellman = l.createDiffieHellman, cryptoBrowserify.DiffieHellman = l.DiffieHellman;
  var u = requireBrowser$3();
  cryptoBrowserify.createSign = u.createSign, cryptoBrowserify.Sign = u.Sign, cryptoBrowserify.createVerify = u.createVerify, cryptoBrowserify.Verify = u.Verify, cryptoBrowserify.createECDH = requireBrowser$2();
  var c = requireBrowser$1();
  cryptoBrowserify.publicEncrypt = c.publicEncrypt, cryptoBrowserify.privateEncrypt = c.privateEncrypt, cryptoBrowserify.publicDecrypt = c.publicDecrypt, cryptoBrowserify.privateDecrypt = c.privateDecrypt;
  var E = requireBrowser();
  return cryptoBrowserify.randomFill = E.randomFill, cryptoBrowserify.randomFillSync = E.randomFillSync, cryptoBrowserify.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, cryptoBrowserify.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, cryptoBrowserify;
}
var BigNumber = /* @__PURE__ */ createBigNumberClass({
  config: config$1
}), Complex = /* @__PURE__ */ createComplexClass({}), Fraction = /* @__PURE__ */ createFractionClass({}), Matrix = /* @__PURE__ */ createMatrixClass({}), DenseMatrix = /* @__PURE__ */ createDenseMatrixClass({
  Matrix
}), typed = /* @__PURE__ */ createTyped({
  BigNumber,
  Complex,
  DenseMatrix,
  Fraction
}), abs = /* @__PURE__ */ createAbs({
  typed
}), addScalar = /* @__PURE__ */ createAddScalar({
  typed
}), atan = /* @__PURE__ */ createAtan({
  typed
}), complex = /* @__PURE__ */ createComplex({
  Complex,
  typed
}), conj = /* @__PURE__ */ createConj({
  typed
}), cos = /* @__PURE__ */ createCos({
  typed
}), equalScalar = /* @__PURE__ */ createEqualScalar({
  config: config$1,
  typed
}), flatten = /* @__PURE__ */ createFlatten({
  typed
}), getMatrixDataType = /* @__PURE__ */ createGetMatrixDataType({
  typed
}), im = /* @__PURE__ */ createIm({
  typed
}), isInteger = /* @__PURE__ */ createIsInteger({
  typed
}), isPositive = /* @__PURE__ */ createIsPositive({
  config: config$1,
  typed
}), isZero = /* @__PURE__ */ createIsZero({
  equalScalar,
  typed
}), multiplyScalar = /* @__PURE__ */ createMultiplyScalar({
  typed
}), number = /* @__PURE__ */ createNumber({
  typed
}), re$1 = /* @__PURE__ */ createRe({
  typed
}), sign$2 = /* @__PURE__ */ createSign({
  BigNumber,
  Fraction,
  complex,
  typed
}), sin = /* @__PURE__ */ createSin({
  typed
}), SparseMatrix = /* @__PURE__ */ createSparseMatrixClass({
  Matrix,
  equalScalar,
  typed
}), subtractScalar = /* @__PURE__ */ createSubtractScalar({
  typed
}), bignumber = /* @__PURE__ */ createBignumber({
  BigNumber,
  typed
}), matrix = /* @__PURE__ */ createMatrix({
  DenseMatrix,
  Matrix,
  SparseMatrix,
  typed
}), reshape = /* @__PURE__ */ createReshape({
  isInteger,
  matrix,
  typed
}), sqrt = /* @__PURE__ */ createSqrt({
  Complex,
  config: config$1,
  typed
}), zeros = /* @__PURE__ */ createZeros({
  BigNumber,
  config: config$1,
  matrix,
  typed
}), concat = /* @__PURE__ */ createConcat({
  isInteger,
  matrix,
  typed
}), diag = /* @__PURE__ */ createDiag({
  DenseMatrix,
  SparseMatrix,
  matrix,
  typed
}), equal = /* @__PURE__ */ createEqual({
  DenseMatrix,
  SparseMatrix,
  concat,
  equalScalar,
  matrix,
  typed
}), fraction = /* @__PURE__ */ createFraction({
  Fraction,
  typed
}), identity$1 = /* @__PURE__ */ createIdentity({
  BigNumber,
  DenseMatrix,
  SparseMatrix,
  config: config$1,
  matrix,
  typed
}), largerEq = /* @__PURE__ */ createLargerEq({
  DenseMatrix,
  SparseMatrix,
  concat,
  config: config$1,
  matrix,
  typed
}), numeric = /* @__PURE__ */ createNumeric({
  bignumber,
  fraction,
  number
}), size = /* @__PURE__ */ createSize({
  matrix,
  config: config$1,
  typed
}), smaller = /* @__PURE__ */ createSmaller({
  DenseMatrix,
  SparseMatrix,
  bignumber,
  concat,
  config: config$1,
  matrix,
  typed
}), unaryMinus = /* @__PURE__ */ createUnaryMinus({
  typed
}), add$1 = /* @__PURE__ */ createAdd({
  DenseMatrix,
  SparseMatrix,
  addScalar,
  concat,
  equalScalar,
  matrix,
  typed
}), divideScalar = /* @__PURE__ */ createDivideScalar({
  numeric,
  typed
}), ImmutableDenseMatrix = /* @__PURE__ */ createImmutableDenseMatrixClass({
  DenseMatrix,
  smaller
}), Index = /* @__PURE__ */ createIndexClass({
  ImmutableDenseMatrix,
  getMatrixDataType
}), larger = /* @__PURE__ */ createLarger({
  DenseMatrix,
  SparseMatrix,
  bignumber,
  concat,
  config: config$1,
  matrix,
  typed
}), matrixFromColumns = /* @__PURE__ */ createMatrixFromColumns({
  flatten,
  matrix,
  size,
  typed
}), qr = /* @__PURE__ */ createQr({
  addScalar,
  complex,
  conj,
  divideScalar,
  equal,
  identity: identity$1,
  isZero,
  matrix,
  multiplyScalar,
  sign: sign$2,
  sqrt,
  subtractScalar,
  typed,
  unaryMinus,
  zeros
}), smallerEq = /* @__PURE__ */ createSmallerEq({
  DenseMatrix,
  SparseMatrix,
  concat,
  config: config$1,
  matrix,
  typed
}), subtract = /* @__PURE__ */ createSubtract({
  DenseMatrix,
  concat,
  equalScalar,
  matrix,
  subtractScalar,
  typed,
  unaryMinus
}), usolve = /* @__PURE__ */ createUsolve({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtractScalar,
  typed
}), dot = /* @__PURE__ */ createDot({
  addScalar,
  conj,
  multiplyScalar,
  size,
  typed
}), multiply = /* @__PURE__ */ createMultiply({
  addScalar,
  dot,
  equalScalar,
  matrix,
  multiplyScalar,
  typed
}), range = /* @__PURE__ */ createRange({
  bignumber,
  matrix,
  add: add$1,
  config: config$1,
  isPositive,
  larger,
  largerEq,
  smaller,
  smallerEq,
  typed
}), usolveAll = /* @__PURE__ */ createUsolveAll({
  DenseMatrix,
  divideScalar,
  equalScalar,
  matrix,
  multiplyScalar,
  subtractScalar,
  typed
}), column = /* @__PURE__ */ createColumn({
  Index,
  matrix,
  range,
  typed
}), det = /* @__PURE__ */ createDet({
  divideScalar,
  isZero,
  matrix,
  multiply,
  subtractScalar,
  typed,
  unaryMinus
}), inv = /* @__PURE__ */ createInv({
  abs,
  addScalar,
  det,
  divideScalar,
  identity: identity$1,
  matrix,
  multiply,
  typed,
  unaryMinus
}), eigs = /* @__PURE__ */ createEigs({
  abs,
  add: add$1,
  addScalar,
  atan,
  bignumber,
  column,
  complex,
  config: config$1,
  cos,
  diag,
  divideScalar,
  dot,
  equal,
  flatten,
  im,
  inv,
  larger,
  matrix,
  matrixFromColumns,
  multiply,
  multiplyScalar,
  number,
  qr,
  re: re$1,
  reshape,
  sin,
  size,
  smaller,
  sqrt,
  subtract,
  typed,
  usolve,
  usolveAll
});
function toDigits(r, e) {
  const s = Math.pow(10, e);
  return Math.round(r * s) / s;
}
function toDegrees(r) {
  return r * 180 / Math.PI;
}
function toRadians(r) {
  return r * Math.PI / 180;
}
function toCartographic(r) {
  return Ellipsoid$1.WGS_84.cartographicForPosition(r);
}
function toCartesian(r) {
  return Ellipsoid$1.WGS_84.cartesianForCartographic(r);
}
function toEuler(r, e) {
  const s = [new Vector3$1(), new Vector3$1(), new Vector3$1()];
  Ellipsoid$1.WGS_84.rotationBasisForCartographic(r, null, s[2], s[1], s[0]);
  const o = new Matrix4().makeRotationFromQuaternion(e), a = new Matrix4().makeBasis(s[0], s[1], s[2]), u = a.clone().invert().multiply(o).multiply(a);
  return new Euler().setFromRotationMatrix(u);
}
function toQuaternion(r, e) {
  const s = [new Vector3$1(), new Vector3$1(), new Vector3$1()];
  Ellipsoid$1.WGS_84.rotationBasisForCartographic(r, null, s[2], s[1], s[0]);
  const o = new Matrix4().makeRotationFromEuler(e), a = new Matrix4().makeBasis(s[0], s[1], s[2]), l = a.clone().invert(), u = a.multiply(o).multiply(l);
  return new Quaternion$1().setFromRotationMatrix(u);
}
function calculateCartographicBasis(r, e, s, o) {
  Ellipsoid$1.WGS_84.rotationBasisForCartographic(r, null, e, s, o);
}
function calculateCartographicQuaternion(r) {
  const e = new Matrix3$1();
  Ellipsoid$1.WGS_84.rotationBasisForCartographic(r, e);
  const s = new Matrix4().setFromMatrix3(e);
  return new Quaternion$1().setFromRotationMatrix(s);
}
function calculateHVLengths(r, e) {
  const s = new Vector2(), o = r.clone().add(e).divideScalar(2), a = new Vector3$1(), l = new Vector3$1();
  calculateCartographicBasis(
    toCartographic(o),
    a,
    l,
    new Vector3$1()
  );
  const u = r.clone().projectOnPlane(a), c = e.clone().projectOnPlane(a);
  s.x = u.distanceTo(c);
  const E = r.distanceTo(u), d = e.distanceTo(c);
  return s.y = Math.abs(E - d), s;
}
function calculateAngle(r, e, s) {
  const o = r.clone().sub(e), a = s.clone().sub(e);
  return toDegrees(o.angleTo(a));
}
function calculateElevation(r, e) {
  const s = toCartographic(r), o = toCartographic(e);
  return Math.abs(s.height - o.height);
}
function calculateEdgeLengths(r, e) {
  const s = [], o = r.slice();
  e && o.push(o[0]);
  for (let a = 0; a < o.length - 1; a++)
    s.push(o[a].distanceTo(o[a + 1]));
  return s;
}
function calculateEdgeHVLengths(r, e) {
  const s = [], o = r.slice();
  e && o.push(o[0]);
  for (let a = 0; a < o.length - 1; a++)
    s.push(calculateHVLengths(o[a], o[a + 1]));
  return s;
}
function calculateCornerAngles(r, e) {
  const s = [], o = r.slice();
  if (e) {
    const a = o[0], l = o[o.length - 1];
    o.unshift(l), o.push(a);
  }
  for (let a = 0; a < o.length - 2; a++)
    s.push(calculateAngle(o[a], o[a + 1], o[a + 2]));
  return e ? s : [0, ...s, 0];
}
function calculateVertexElevations(r) {
  const e = [];
  for (let s = 0; s < r.length; s++)
    e.push(calculateElevation(r[0], r[s]));
  return e;
}
function calculateBestFitPlane(r) {
  const e = calculateCentroid$1(r), s = [];
  for (const L of r)
    s.push(L.clone().sub(e));
  let o = 0, a = 0, l = 0, u = 0, c = 0, E = 0;
  for (const L of s)
    o += L.x * L.x, a += L.x * L.y, l += L.x * L.z, u += L.y * L.y, c += L.y * L.z, E += L.z * L.z;
  const d = r.length, f = [
    [o / d, a / d, l / d],
    [a / d, u / d, c / d],
    [l / d, c / d, E / d]
  ], h = eigs(f), S = h.eigenvectors.map((L) => L.vector), R = h.eigenvectors.map((L) => L.value);
  let _ = 0;
  for (let L = 1; L < 3; L++)
    R[L] < R[_] && (_ = L);
  const m = new Vector3$1(
    S[_][0],
    S[_][1],
    S[_][2]
  ).normalize();
  return new Plane().setFromNormalAndCoplanarPoint(m, e);
}
function triangulate$1(r) {
  const e = calculateBestFitPlane(r), s = new Vector3$1(), o = new Vector3$1();
  Math.abs(e.normal.x) < 0.5 ? o.x = 1 : Math.abs(e.normal.y) < 0.5 ? o.y = 1 : o.z = 1;
  const a = e.normal, l = o.addScaledVector(a, -a.dot(o)).normalize(), u = new Vector3$1().crossVectors(l, a).normalize(), c = [];
  for (const d of r)
    e.projectPoint(d, s), c.push(s.dot(l)), c.push(s.dot(u));
  const E = earcut$3(c, [], 2);
  for (let d = 0; d < E.length - 2; d += 3) {
    const f = [E[d], E[d + 1], E[d + 2]];
    f.sort((h, S) => S - h), E[d] = f[0], E[d + 1] = f[1], E[d + 2] = f[2];
  }
  return E;
}
function calculatePolygonArea(r) {
  const e = triangulate$1(r);
  let s = 0;
  for (let o = 0; o < e.length - 2; o += 3) {
    const a = r[e[o]], l = r[e[o + 1]], u = r[e[o + 2]];
    s += new Triangle(a, l, u).getArea();
  }
  return s;
}
function calculateCentroid$1(r) {
  const e = new Vector3$1();
  for (const s of r)
    e.add(s);
  return e.divideScalar(r.length), e;
}
function calculateCameraTargetPosition(r, e, s) {
  const o = e / Math.tan(s / 2), a = toCartographic(r);
  return a.height += o, toCartesian(a);
}
function calculateNadirOrientation(r) {
  const e = toCartographic(r), s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1();
  calculateCartographicBasis(e, a, o, s);
  const l = new Matrix4().makeBasis(s, o, a);
  return new Quaternion$1().setFromRotationMatrix(l);
}
function calculateLookAtRotation(r, e) {
  const s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1(), l = toCartographic(r);
  calculateCartographicBasis(l, s, o, a);
  const u = e.clone().sub(r).normalize().negate(), c = s.clone().cross(u).normalize(), E = u.clone().cross(c).normalize(), d = new Matrix4().makeBasis(c, E, u);
  return new Quaternion$1().setFromRotationMatrix(d);
}
function calculateLookAtFov(r, e, s) {
  const o = r.distanceTo(e);
  return toDegrees(Math.atan(s / o));
}
function calculateContainerSphere(r) {
  let e = 0;
  const s = calculateCentroid$1(r.map((o) => o.center));
  for (const o of r) {
    const a = s.distanceTo(o.center) + o.radius;
    e = Math.max(e, a);
  }
  return new Sphere$1(s, e);
}
function isTriangleValid(r) {
  const e = r.a.distanceTo(r.b), s = r.a.distanceTo(r.c), o = r.b.distanceTo(r.c);
  return e + s > o && e + o > s && s + o > e;
}
function isIntersectingSegments(r, e, s, o) {
  return (o.y - r.y) * (s.x - r.x) > (s.y - r.y) * (o.x - r.x) != (o.y - e.y) * (s.x - e.x) > (s.y - e.y) * (o.x - e.x) && (s.y - r.y) * (e.x - r.x) > (e.y - r.y) * (s.x - r.x) != (o.y - r.y) * (e.x - r.x) > (e.y - r.y) * (o.x - r.x);
}
function projectToScreen(r, e, s) {
  const o = new Matrix4();
  r.getWorldMatrix(o), o.invert();
  const a = new Matrix4();
  r.getProjectionMatrix(a);
  const l = new Matrix4();
  l.multiplyMatrices(a, o);
  const u = s.clone().applyMatrix4(l);
  return new Vector2(
    e.x * (u.x + 1) / 2,
    e.y * (1 - (u.y + 1) / 2)
  );
}
function isCameraVisible(r, e) {
  const s = new Vector3$1();
  r.getPositionECEF(s);
  const o = new Matrix4();
  r.getLocalMatrix(o);
  const a = new Vector3$1();
  o.extractBasis(new Vector3$1(), new Vector3$1(), a), a.negate().normalize();
  const l = e.clone().sub(s).normalize();
  return a.dot(l) > 0;
}
function computePickNormal(r, e) {
  const s = [new Vector2(1, 0), new Vector2(-1, 0), new Vector2(0, 1)], o = [new Vector3$1(), new Vector3$1(), new Vector3$1()];
  for (let d = 0; d < 3; d++) {
    const f = e.clone().add(s[d]), h = r.pickScreenWorldSpace(f);
    o[d].set(h.position.x, h.position.y, h.position.z);
  }
  const [a, l, u] = o, c = l.sub(a), E = u.sub(a);
  return c.cross(E).normalize();
}
function computePick(r, e) {
  const s = r.pickScreenWorldSpaceSnapping(e), o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = computePickNormal(r, e);
  return o.add(a.multiplyScalar(0.015));
}
function undistortImagePoint(r, e, s = 7, o = 1e-7) {
  const { k1: a, k2: l, k3: u, p1: c, p2: E } = e.distortion, d = e.principalPoint.x, f = e.principalPoint.y, h = e.imageSize.x / 2, S = e.imageSize.y / 2, R = Math.max(e.imageSize.x, e.imageSize.y), _ = e.focalLength * R / e.sensorSize, m = e.skew, L = (r.x + h - d) / _, F = (r.y - S + f) / _;
  let W = L, G = F;
  for (let q = 0; q < s; q++) {
    const fe = W * W, _e = G * G, Le = W * G, Fe = fe + _e, Ee = Fe * Fe, Ge = Ee * Fe, ve = 1 + a * Fe + l * Ee + u * Ge, te = W * ve, ae = G * ve, v = 2 * c * Le + E * (Fe + 2 * fe), Te = 2 * E * Le + c * (Fe + 2 * _e), De = L - (te + v), be = F - (ae + Te);
    if (W += De, G += be, Math.abs(De) < o && Math.abs(be) < o)
      break;
  }
  return r.set(_ * W + m * G, _ * G);
}
function isPointInCircle(r, e, s) {
  return e.distanceToSquared(r) <= s * s;
}
function clipTriangle$1(r, e) {
  const s = [r.a, r.b, r.c], o = s.map((l) => e.distanceToPoint(l)), a = o.filter((l) => l >= 0).length;
  if (a === 0)
    return [];
  if (a === 3)
    return [r];
  if (a === 1) {
    const l = o.findIndex((h) => h >= 0), u = s[l], c = s[(l + 1) % 3], E = s[(l + 2) % 3], d = new Vector3$1(), f = new Vector3$1();
    return e.intersectLine(new Line3(u, c), d), e.intersectLine(new Line3(u, E), f), [new Triangle(u, d, f)];
  } else {
    const l = o.findIndex((h) => h < 0), u = s[l], c = s[(l + 1) % 3], E = s[(l + 2) % 3], d = new Vector3$1(), f = new Vector3$1();
    return e.intersectLine(new Line3(c, u), d), e.intersectLine(new Line3(E, u), f), [new Triangle(c, E, d), new Triangle(d, E, f)];
  }
}
function buildTriangles(r, e) {
  const s = r.getAttribute("position"), o = r.getIndex(), a = [];
  if (o)
    for (let l = 0; l < o.count; l += 3) {
      const u = new Vector3$1().fromBufferAttribute(s, o.array[l]).applyMatrix4(e), c = new Vector3$1().fromBufferAttribute(s, o.array[l + 1]).applyMatrix4(e), E = new Vector3$1().fromBufferAttribute(s, o.array[l + 2]).applyMatrix4(e);
      a.push(new CartographicTriangle(u, c, E));
    }
  else
    for (let l = 0; l < s.count; l += 3) {
      const u = new Vector3$1().fromBufferAttribute(s, l).applyMatrix4(e), c = new Vector3$1().fromBufferAttribute(s, l + 1).applyMatrix4(e), E = new Vector3$1().fromBufferAttribute(s, l + 2).applyMatrix4(e);
      a.push(new CartographicTriangle(u, c, E));
    }
  return a;
}
function subdivideTriangleMidpoint(r) {
  const e = new Vector3$1().addVectors(r.a, r.b).multiplyScalar(0.5), s = new Vector3$1().addVectors(r.b, r.c).multiplyScalar(0.5), o = new Vector3$1().addVectors(r.c, r.a).multiplyScalar(0.5);
  return [
    new Triangle(r.a, e, o),
    new Triangle(e, r.b, s),
    new Triangle(o, s, r.c),
    new Triangle(e, s, o)
  ];
}
function subdivideTriangleBisection(r) {
  const e = r.a.distanceTo(r.b), s = r.b.distanceTo(r.c), o = r.c.distanceTo(r.a);
  if (e >= s && e >= o) {
    const a = new Vector3$1().addVectors(r.a, r.b).multiplyScalar(0.5);
    return [new Triangle(r.a, a, r.c), new Triangle(r.b, a, r.c)];
  } else if (s >= e && s >= o) {
    const a = new Vector3$1().addVectors(r.b, r.c).multiplyScalar(0.5);
    return [new Triangle(r.b, a, r.a), new Triangle(r.c, a, r.a)];
  } else {
    const a = new Vector3$1().addVectors(r.c, r.a).multiplyScalar(0.5);
    return [new Triangle(r.c, a, r.b), new Triangle(r.a, a, r.b)];
  }
}
function subdivideTriangleRecursively(r, e, s) {
  if (s(r))
    return [r];
  const o = [];
  for (const a of e(r)) {
    const l = subdivideTriangleRecursively(a, e, s);
    for (const u of l)
      o.push(u);
  }
  return o;
}
function buildIndexedTriangles(r) {
  const e = [], s = [], o = /* @__PURE__ */ new Map();
  for (const a of r)
    for (const l of [a.a, a.b, a.c]) {
      const u = `${l.x} ${l.y} ${l.z}`;
      let c = o.get(u);
      c === void 0 && (c = e.length, o.set(u, c), e.push(l)), s.push(c);
    }
  return { vertices: e, indices: s };
}
class OBB {
  constructor(e = new Vector3$1(), s = new Matrix4()) {
    Qt(this, "isOBB");
    Qt(this, "center");
    Qt(this, "halfAxes");
    this.isOBB = !0, this.center = e, this.halfAxes = s;
  }
  /**
   * Create a new oriented bounding box with the same internal values
   */
  clone() {
    return new OBB(this.center.clone(), this.halfAxes.clone());
  }
  /**
   * Copy another OBB into this one
   */
  copy(e) {
    this.center.copy(e.center), this.halfAxes.copy(e.halfAxes);
  }
  /**
   * Create a new OBB from a set of face center positions
   *
   * Assumes that every 2 consecutive faces are opposite each other
   */
  setFromFaceCenters(e) {
    const s = [];
    this.center.set(0, 0, 0);
    for (let o = 0; o < e.length; o += 2) {
      const a = e[o], l = e[o + 1];
      this.center.add(a), this.center.add(l);
      const u = l.clone().sub(a).divideScalar(2);
      s.push(u);
    }
    return this.center.divideScalar(6), this.halfAxes.makeBasis(s[0], s[1], s[2]), this;
  }
  /**
   * Create a new OBB from a geolocated sphere.
   *
   * @param sphere
   */
  setFromGeoSphere(e) {
    const s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1();
    calculateCartographicBasis(toCartographic(e.center), o, s, a), s.multiplyScalar(e.radius), o.multiplyScalar(e.radius), a.multiplyScalar(e.radius);
    const l = new Matrix4().makeBasis(s, o, a);
    return this.center.copy(e.center), this.halfAxes.copy(l), this;
  }
  /**
   * Rotate the oriented bounding box
   */
  rotate(e) {
    const s = new Matrix4();
    s.makeRotationFromQuaternion(e), this.halfAxes.multiplyMatrices(s, this.halfAxes);
  }
  /**
   * Get the inward planes from the faces of the bounding volumes
   *
   * Opposing planes are listed consecutively in the returned array
   */
  getInwardPlanes() {
    const e = [new Vector3$1(), new Vector3$1(), new Vector3$1()];
    this.halfAxes.extractBasis(e[0], e[1], e[2]);
    const s = [];
    for (const a of e)
      s.push(a), s.push(a.clone().negate());
    return s.map((a) => {
      const l = this.center.clone().add(a), u = this.center.clone().sub(l).normalize();
      return { position: l, normal: u };
    });
  }
  /**
   * Calculate the corners of the OBB to generate a triangle mesh
   */
  getTriangleMeshVertexArray() {
    const e = new Vector3$1(), s = new Vector3$1(), o = new Vector3$1();
    return this.halfAxes.extractBasis(e, s, o), { vertices: [
      this.center.clone().sub(e).sub(s).add(o),
      this.center.clone().add(e).sub(s).add(o),
      this.center.clone().sub(e).add(s).add(o),
      this.center.clone().add(e).add(s).add(o),
      this.center.clone().sub(e).sub(s).sub(o),
      this.center.clone().add(e).sub(s).sub(o),
      this.center.clone().sub(e).add(s).sub(o),
      this.center.clone().add(e).add(s).sub(o)
    ], indices: [
      //Top
      2,
      6,
      7,
      7,
      3,
      2,
      //Bottom
      5,
      4,
      0,
      0,
      1,
      5,
      //Left
      6,
      2,
      0,
      0,
      4,
      6,
      //Right
      1,
      3,
      7,
      7,
      5,
      1,
      //Front
      0,
      2,
      3,
      3,
      1,
      0,
      //Back
      7,
      6,
      4,
      4,
      5,
      7
    ] };
  }
}
const ft = 3.28084, usFt = 3937 / 1200;
function lengthToString(r, e, s = 2) {
  switch (e) {
    case "imperial":
      return `${(r * ft).toFixed(s)} ft`;
    case "us imperial":
      return `${(r * usFt).toFixed(s)} ft (US)`;
    case "metric":
      return `${r.toFixed(s)} m`;
  }
}
function areaToString(r, e, s = 2) {
  switch (e) {
    case "imperial":
      return `${(r * (ft * ft)).toFixed(s)} sq. ft`;
    case "us imperial":
      return `${(r * (usFt * usFt)).toFixed(s)} sq. ft (US)`;
    case "metric":
      return `${r.toFixed(s)} sq. m`;
  }
}
function volumeToString(r, e, s = 2) {
  switch (e) {
    case "imperial":
      return `${(r * (ft * ft * ft)).toFixed(s)} cub. ft`;
    case "us imperial":
      return `${(r * (usFt * usFt * usFt)).toFixed(s)} cub. ft (US)`;
    case "metric":
      return `${r.toFixed(s)} cub. m`;
  }
}
function serializeCartographic(r) {
  return {
    type: "Cartographic",
    values: [r.longitude, r.latitude, r.height]
  };
}
function serializeVector3(r) {
  return { type: "Vector3", values: r.toArray() };
}
function serializeMatrix4(r) {
  return { type: "Matrix4", values: r.toArray() };
}
function serializeTriangle(r) {
  return {
    type: "Triangle",
    values: [
      serializeVector3(r.a),
      serializeVector3(r.b),
      serializeVector3(r.c)
    ]
  };
}
function serializeBufferAttribute(r) {
  return {
    type: "BufferAttribute",
    array: r.array,
    itemSize: r.itemSize,
    normalized: r.normalized
  };
}
function serializeInterleavedAttribute(r) {
  return {
    type: "InterleavedBufferAttribute",
    array: r.array,
    itemSize: r.itemSize,
    normalized: r.normalized,
    stride: r.data.stride,
    offset: r.offset
  };
}
function serializeGeometry(r) {
  const e = {};
  for (const [a, l] of Object.entries(r.attributes))
    "isInterleavedBufferAttribute" in l ? e[a] = serializeInterleavedAttribute(l) : e[a] = serializeBufferAttribute(l);
  const s = r.getIndex(), o = s ? serializeBufferAttribute(s) : null;
  return { type: "BufferGeometry", attributes: e, index: o };
}
function deserializeCartographic(r) {
  return new Cartographic$1(...r.values);
}
function deserializeVector3(r) {
  return new Vector3$1(...r.values);
}
function deserializeMatrix4(r) {
  return new Matrix4().fromArray(r.values);
}
function deserializeTriangle(r) {
  return new Triangle(
    deserializeVector3(r.values[0]),
    deserializeVector3(r.values[1]),
    deserializeVector3(r.values[2])
  );
}
function deserializeBufferAttribute(r) {
  return new BufferAttribute(r.array, r.itemSize, r.normalized);
}
function deserializeInterleavedAttribute(r) {
  const e = new InterleavedBuffer(r.array, r.stride);
  return new InterleavedBufferAttribute(
    e,
    r.itemSize,
    r.offset,
    r.normalized
  );
}
function deserializeGeometry(r) {
  const e = new BufferGeometry();
  for (const [s, o] of Object.entries(r.attributes))
    o.type === "InterleavedBufferAttribute" ? e.setAttribute(s, deserializeInterleavedAttribute(o)) : e.setAttribute(s, deserializeBufferAttribute(o));
  return r.index && e.setIndex(deserializeBufferAttribute(r.index)), e;
}
class PointerState {
  constructor(e) {
    /**
     * Set of all unique pointers
     */
    Qt(this, "pointers");
    /**
     * Is the Ctrl key pressed?
     */
    Qt(this, "ctrlKey");
    /**
     * Currently pressed pointer button
     */
    Qt(this, "button");
    /**
     * Current position of the hovering pointer
     */
    Qt(this, "hoverPosition");
    /**
     * Previous position of the hovering pointer
     */
    Qt(this, "prevHoverPosition");
    /**
     * Last removed pointer position
     */
    Qt(this, "removedPosition");
    /**
     * Velocity of the pointer
     */
    Qt(this, "hoverVelocity");
    this.pointers = /* @__PURE__ */ new Map(), this.ctrlKey = !1, this.button = 0, this.hoverPosition = new Vector2(), this.prevHoverPosition = new Vector2(), this.removedPosition = new Vector2(), this.hoverVelocity = new Vector2(), e.addEventListener("mousedown", (s) => {
      s.preventDefault(), e.focus();
      const { target: o, x: a, y: l, ctrlKey: u, button: c } = s, E = o;
      let { left: d, top: f, width: h, height: S } = E.getBoundingClientRect();
      d = Math.floor(d), f = Math.floor(f), h = Math.ceil(h), S = Math.ceil(S), this.addPointer(
        -1,
        Math.max(1, Math.min(h - 1, a - d)),
        Math.max(1, Math.min(S - 1, l - f)),
        u,
        c
      );
    }), e.addEventListener("mousemove", (s) => {
      s.preventDefault();
      const { target: o, x: a, y: l, ctrlKey: u, movementX: c, movementY: E } = s, d = o;
      let { left: f, top: h, width: S, height: R } = d.getBoundingClientRect();
      f = Math.floor(f), h = Math.floor(h), S = Math.ceil(S), R = Math.ceil(R), this.updatePointer(
        -1,
        Math.max(1, Math.min(S - 1, a - f)),
        Math.max(1, Math.min(R - 1, l - h)),
        c,
        E,
        u
      );
    }), e.addEventListener("mouseup", (s) => {
      s.preventDefault();
      const { target: o, x: a, y: l } = s, u = o;
      let { left: c, top: E, width: d, height: f } = u.getBoundingClientRect();
      c = Math.floor(c), E = Math.floor(E), d = Math.ceil(d), f = Math.ceil(f), this.removePointer(
        -1,
        Math.max(1, Math.min(d - 1, a - c)),
        Math.max(1, Math.min(f - 1, l - E))
      );
    }), e.addEventListener("mouseleave", (s) => {
      s.preventDefault();
      const { target: o, x: a, y: l } = s, u = o;
      let { left: c, top: E, width: d, height: f } = u.getBoundingClientRect();
      c = Math.floor(c), E = Math.floor(E), d = Math.ceil(d), f = Math.ceil(f), this.removePointer(
        -1,
        Math.max(1, Math.min(d - 1, a - c)),
        Math.max(1, Math.min(f - 1, l - E))
      );
    }), e.addEventListener("touchstart", (s) => {
      s.preventDefault(), e.focus();
      const { changedTouches: o, target: a, ctrlKey: l } = s, u = a;
      let { left: c, top: E, width: d, height: f } = u.getBoundingClientRect();
      c = Math.floor(c), E = Math.floor(E), d = Math.ceil(d), f = Math.ceil(f);
      for (const h of o) {
        const { identifier: S, clientX: R, clientY: _ } = h;
        this.addPointer(
          S,
          Math.max(1, Math.min(d - 1, R - c)),
          Math.max(1, Math.min(f - 1, _ - E)),
          l,
          0
        );
      }
    }), e.addEventListener("touchmove", (s) => {
      s.preventDefault();
      const { changedTouches: o, target: a, ctrlKey: l } = s, u = a;
      let { left: c, top: E, width: d, height: f } = u.getBoundingClientRect();
      c = Math.floor(c), E = Math.floor(E), d = Math.ceil(d), f = Math.ceil(f);
      for (const h of o) {
        const { identifier: S, clientX: R, clientY: _ } = h;
        this.updatePointer(
          S,
          Math.max(1, Math.min(d - 1, R - c)),
          Math.max(1, Math.min(f - 1, _ - E)),
          0,
          // movementX/Y is not available for touch pointers
          0,
          l
        );
      }
    }), e.addEventListener("touchcancel", (s) => {
      s.preventDefault();
      const { changedTouches: o, target: a } = s, l = a;
      let { left: u, top: c, width: E, height: d } = l.getBoundingClientRect();
      u = Math.floor(u), c = Math.floor(c), E = Math.ceil(E), d = Math.ceil(d);
      for (const f of o) {
        const { identifier: h, clientX: S, clientY: R } = f;
        this.removePointer(
          h,
          Math.max(1, Math.min(E - 1, S - u)),
          Math.max(1, Math.min(d - 1, R - c))
        );
      }
    }), e.addEventListener("touchend", (s) => {
      s.preventDefault();
      const { changedTouches: o, target: a } = s, l = a;
      let { left: u, top: c, width: E, height: d } = l.getBoundingClientRect();
      u = Math.floor(u), c = Math.floor(c), E = Math.ceil(E), d = Math.ceil(d);
      for (const f of o) {
        const { identifier: h, clientX: S, clientY: R } = f;
        this.removePointer(
          h,
          Math.max(1, Math.min(E - 1, S - u)),
          Math.max(1, Math.min(d - 1, R - c))
        );
      }
    });
  }
  /**
   * Add a new pointer
   *
   * @param id
   * @param x
   * @param y
   * @param ctrlKey
   * @param button
   */
  addPointer(e, s, o, a, l) {
    this.pointers.set(e, {
      id: e,
      current: new Vector2(s, o),
      previous: new Vector2(s, o)
    }), this.prevHoverPosition.copy(this.hoverPosition), this.hoverPosition.x = s, this.hoverPosition.y = o, this.ctrlKey = a, this.button = l;
  }
  /**
   * Update a pointer by id
   *
   * @param id
   * @param x
   * @param y
   * @param vx
   * @param vy
   * @param ctrlKey
   */
  updatePointer(e, s, o, a, l, u) {
    const c = this.pointers.get(e);
    c && (c.previous.x = c.current.x, c.previous.y = c.current.y, c.current.x = s, c.current.y = o), this.ctrlKey = u, this.prevHoverPosition.copy(this.hoverPosition), this.hoverPosition.x = s, this.hoverPosition.y = o, this.hoverVelocity.x = a, this.hoverVelocity.y = l;
  }
  /**
   * Remove a pointer
   *
   * @param id
   * @param x
   * @param y
   */
  removePointer(e, s, o) {
    this.prevHoverPosition.copy(this.hoverPosition), this.hoverPosition.x = s, this.hoverPosition.y = o, this.removedPosition.x = s, this.removedPosition.y = o, this.pointers.delete(e), this.button = -1;
  }
  /**
   * Get the list of all active pointers
   *
   * @returns
   */
  getPointers() {
    return [...this.pointers.values()];
  }
  /**
   * Primarily applicable for mouse, get the current button pressed
   *
   * @returns
   */
  getButton() {
    return this.button;
  }
  /**
   * Test if the ctrl key is currently being pressed
   *
   * @returns
   */
  getCtrlKey() {
    return this.ctrlKey;
  }
  /**
   * Get the position of the last removed pointer
   *
   * @returns
   */
  getLastRemoved() {
    return this.removedPosition;
  }
  /**
   * Get the hover position of the pointer
   *
   * This position exists regardless of whether the pointer is pressed
   *
   * @returns
   */
  getHoverPosition() {
    return this.hoverPosition;
  }
  /**
   * Get the previous position of the hovering pointer
   *
   * @returns
   */
  getPreviousHoverPosition() {
    return this.prevHoverPosition;
  }
  /**
   * Get the velocity of the hovering pointer
   *
   * @returns
   */
  getHoverVelocity() {
    return this.hoverVelocity;
  }
}
const DBL_CLICK_MS = 350, HOVER_THROTTLE_MS = 64;
class GestureControl extends EventRegister {
  constructor(s) {
    super();
    Qt(this, "canvas");
    Qt(this, "pointerState");
    Qt(this, "lastTapTime");
    Qt(this, "lastHoverTime");
    this.canvas = s, this.pointerState = new PointerState(s), this.lastTapTime = (/* @__PURE__ */ new Date()).getTime(), this.lastHoverTime = (/* @__PURE__ */ new Date()).getTime(), this.canvas.addEventListener("contextmenu", (o) => {
      o.preventDefault();
    }), this.canvas.setAttribute("tabindex", "0"), this.registerKeyTap(), this.registerKeyRelease(), this.registerTap(), this.registerRelease(), this.registerSwipe(), this.registerHover(), this.registerZoom();
  }
  /**
   * Handle key press gestures.
   */
  registerKeyTap() {
    const s = (o) => {
      this.emit("keytap", o);
    };
    this.canvas.addEventListener("keydown", s);
  }
  /**
   * Handle key release gestures.
   */
  registerKeyRelease() {
    const s = (o) => {
      this.emit("keyrelease", o);
    };
    this.canvas.addEventListener("keyup", s);
  }
  /**
   * Handle tap gestures.
   */
  registerTap() {
    const s = () => {
      const a = this.pointerState.getPointers();
      if (a.length > 0) {
        const l = (/* @__PURE__ */ new Date()).getTime(), u = l - this.lastTapTime < DBL_CLICK_MS;
        this.lastTapTime = l, this.emit(u ? "doubletap" : "tap", {
          position: a[0].current,
          prevPosition: a[0].previous,
          ctrlKey: this.pointerState.getCtrlKey(),
          button: this.pointerState.getButton()
        });
      }
    }, o = () => {
      const a = this.pointerState.getPointers();
      if (a.length > 0) {
        const l = new Vector2(), u = new Vector2();
        for (const d of a)
          l.add(d.current), u.add(d.previous);
        l.divideScalar(a.length), u.divideScalar(a.length);
        const c = (/* @__PURE__ */ new Date()).getTime(), E = c - this.lastTapTime < DBL_CLICK_MS;
        this.lastTapTime = c, this.emit(E ? "doubletap" : "tap", {
          position: l,
          prevPosition: u,
          ctrlKey: this.pointerState.getCtrlKey(),
          button: a.length === 2 ? 2 : 0
        });
      }
    };
    this.canvas.addEventListener("mousedown", s), this.canvas.addEventListener("touchstart", o);
  }
  /**
   * Handle release gestures.
   */
  registerRelease() {
    const s = () => {
      this.emit("release", {
        position: this.pointerState.getLastRemoved(),
        prevPosition: this.pointerState.getLastRemoved(),
        ctrlKey: this.pointerState.getCtrlKey(),
        button: this.pointerState.getButton()
      });
    };
    this.canvas.addEventListener("mouseup", s), this.canvas.addEventListener("touchend", s);
  }
  /**
   * Handle swipe gestures.
   */
  registerSwipe() {
    const s = () => {
      const a = this.pointerState.getPointers();
      a.length > 0 && this.emit("swipe", {
        position: a[0].current,
        prevPosition: a[0].previous,
        ctrlKey: this.pointerState.getCtrlKey(),
        button: this.pointerState.getButton()
      });
    }, o = () => {
      const a = this.pointerState.getPointers();
      if (a.length > 0) {
        const l = new Vector2(), u = new Vector2();
        for (const d of a)
          l.add(d.current), u.add(d.previous);
        l.divideScalar(a.length), u.divideScalar(a.length);
        let c = 1, E = 1;
        if (a.length >= 2) {
          const d = a[0].current.clone().sub(a[0].previous), f = a[1].current.clone().sub(a[1].previous);
          E = (d.length() + f.length()) / 2, c = f.normalize().dot(d.normalize());
        }
        c >= 0.05 && E >= 0.05 && this.emit("swipe", {
          position: l,
          prevPosition: u,
          ctrlKey: this.pointerState.getCtrlKey(),
          button: a.length === 2 ? 2 : 0
        });
      }
    };
    this.canvas.addEventListener("mousemove", s), this.canvas.addEventListener("touchmove", o);
  }
  /**
   * Handle hover gestures.
   */
  registerHover() {
    const s = () => {
      const o = Date.now();
      o - this.lastHoverTime >= HOVER_THROTTLE_MS && (this.lastHoverTime = o, this.emit("hover", {
        position: this.pointerState.getHoverPosition(),
        prevPosition: this.pointerState.getPreviousHoverPosition(),
        velocity: this.pointerState.getHoverVelocity()
      }));
    };
    this.canvas.addEventListener("mousemove", s), this.canvas.addEventListener("touchmove", s);
  }
  /**
   * Handle zoom gestures.
   */
  registerZoom() {
    const s = (a) => {
      a.preventDefault(), this.canvas.focus();
      const { target: l, x: u, y: c, deltaX: E, deltaY: d } = a, f = l;
      let { left: h, top: S } = f.getBoundingClientRect();
      h = Math.floor(h), S = Math.floor(S), this.emit("zoom", {
        position: new Vector2(u - h, c - S),
        direction: new Vector2(E, d)
      });
    }, o = () => {
      const a = this.pointerState.getPointers();
      if (a.length >= 2) {
        const l = a[0].current.clone().sub(a[0].previous).normalize(), u = a[1].current.clone().sub(a[1].previous).normalize(), c = a[0].previous.clone().sub(a[1].previous).length(), E = a[0].current.clone().sub(a[1].current).length(), d = c - E;
        u.dot(l) < 0 && Math.abs(d) > 1.5 && this.emit("zoom", {
          position: new Vector2().addVectors(a[0].current, a[1].current).multiplyScalar(0.5),
          direction: new Vector2(d, d).normalize()
        });
      }
    };
    this.canvas.addEventListener("wheel", s), this.canvas.addEventListener("touchmove", o);
  }
  /**
   * Set the cursor icon.
   *
   * @param style Icon url or preset style
   */
  setCursor(s) {
    this.canvas.style.cursor = s;
  }
  /**
   * Lock the cursor.
   */
  lockCursor() {
    this.canvas.requestPointerLock();
  }
  /**
   * Unlock the cursor.
   */
  unlockCursor() {
    document.exitPointerLock();
  }
  /**
   * Set the input handlers to focus on the viewer's canvas element.
   */
  focus() {
    this.canvas.focus();
  }
}
class LabelManager {
  constructor(e, s) {
    Qt(this, "camera");
    Qt(this, "draw2D");
    Qt(this, "labels");
    this.camera = e.getWorld().getCamera(), this.draw2D = s, this.labels = /* @__PURE__ */ new Map();
  }
  /**
   * Create a new text label to be drawn, returning a reference to the
   * modifiable properties of the label
   *
   * @param string
   * @param position
   * @param center
   * @param screenOffset
   * @returns Label reference
   */
  add(e, s, o = !1, a = new Vector2(), l = new Color(0, 0, 0)) {
    const u = "Helvetica", { width: E, height: d } = this.draw2D.getCanvas(), f = new Vector2(E, d), h = projectToScreen(this.camera, f, s);
    h.x += a.x, h.y += a.y;
    const S = new Vector2(
      this.draw2D.textWidth(e, u, 13),
      this.draw2D.textHeight(13)
    ), R = isCameraVisible(this.camera, s) ? 1 : 0, _ = {
      type: "text",
      position: h,
      font: "Helvetica",
      string: e,
      size: 13,
      color: new Color(1, 1, 1),
      opacity: R,
      fill: !0,
      center: o
    }, m = new Vector2(1.2, 1.1).multiply(S), L = o ? h : h.clone().sub(new Vector2(0.1, 0.05).multiply(S)), F = {
      type: "rect",
      dimensions: m,
      position: L,
      color: l,
      opacity: R * 0.75,
      fill: !0,
      center: o,
      radius: S.y * 0.15
    }, W = {
      position: s,
      screenOffset: a,
      opacity: 1
    };
    return this.labels.set(W, { text: _, background: F }), this.draw2D.addDrawable(F), this.draw2D.addDrawable(_), W;
  }
  /**
   * Remove a label, if it exists
   *
   * @param label
   */
  remove(e) {
    const s = this.labels.get(e);
    if (s) {
      const { text: o, background: a } = s;
      this.draw2D.removeDrawable(o), this.draw2D.removeDrawable(a), this.labels.delete(e);
    }
  }
  /**
   * Main update loop to test if the label should be rendered or not
   */
  update() {
    for (const [e, s] of this.labels) {
      const { text: o, background: a } = s, { position: l, screenOffset: u, opacity: c } = e, { center: E } = a, { width: d, height: f } = this.draw2D.getCanvas(), h = new Vector2(d, f), S = projectToScreen(this.camera, h, l);
      S.add(u);
      const R = new Vector2(
        this.draw2D.textWidth(o.string, o.font, o.size),
        this.draw2D.textHeight(o.size)
      );
      o.position = S, a.position = E ? S : S.clone().sub(new Vector2(0.1, 0.05).multiply(R)), isCameraVisible(this.camera, l) ? (o.opacity = c, a.opacity = c * 0.75) : (o.opacity = 0, a.opacity = 0);
    }
  }
}
function transformVertex(r, e, s) {
  return r.clone().applyQuaternion(s).add(e);
}
function recenterObject(r, e) {
  const s = calculateCentroid$1(e.map((o) => new Vector3$1(o.x, o.y, o.z)));
  for (const o of e)
    o.x -= s.x, o.y -= s.y, o.z -= s.z;
  r.setPositionECEF(s);
}
function isInBatch(r, e) {
  return r.material.type === e.material.type && r.material.pointSize === e.material.pointSize && r.material.faceCulling === e.material.faceCulling && r.material.wireframe === e.material.wireframe && r.material.vertexColors === e.material.vertexColors && r.scale.x === e.scale.x && r.scale.y === e.scale.y && r.scale.z === e.scale.z && r.renderLayer === e.renderLayer;
}
function createBatchKey(r, e) {
  return {
    mesh: e,
    material: structuredClone(r.material),
    scale: r.scale.clone(),
    renderLayer: r.renderLayer
  };
}
function createBatchObject(r, e, s) {
  const o = r.getObjectFactory().createRawMeshObject({
    mesh: s,
    position: {
      ecef: { x: 0, y: 0, z: 0 }
    },
    scale: e.scale,
    material: e.material
  });
  return o.setRenderLayer(e.renderLayer), o;
}
class BatchCore {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "pickingMap");
    Qt(this, "members");
    Qt(this, "pointBatches");
    Qt(this, "lineBatches");
    Qt(this, "stripBatches");
    Qt(this, "polygonBatches");
    this.renderer = e, this.pickingMap = s, this.members = [], this.pointBatches = /* @__PURE__ */ new Map(), this.lineBatches = /* @__PURE__ */ new Map(), this.stripBatches = /* @__PURE__ */ new Map(), this.polygonBatches = /* @__PURE__ */ new Map();
  }
  /**
   * Recenter for all batched objects to their centroids.
   */
  recenter() {
    for (const [e, s] of this.pointBatches)
      recenterObject(s, e.mesh.points);
    for (const [e, s] of this.lineBatches)
      recenterObject(s, e.mesh.vertices);
    for (const [e, s] of this.polygonBatches)
      recenterObject(s, e.mesh.vertices);
    for (const [e, s] of this.stripBatches)
      recenterObject(s, e.mesh.vertices);
  }
  /**
   * Append a new point mesh.
   *
   * @param batchable
   */
  appendPoints(e) {
    var l, u;
    let s = null;
    for (const [c, E] of this.pointBatches)
      isInBatch(e, c) && (s = c);
    if (s === null) {
      const c = this.renderer.createPointMesh();
      c.color = [], c.pickingUserId = [], s = createBatchKey(e, c);
      const E = createBatchObject(this.renderer, e, c);
      this.pointBatches.set(s, E);
    }
    const o = s.mesh, a = this.pickingMap.get(e);
    if (a !== void 0) {
      for (const c of e.vertices) {
        const E = transformVertex(c, e.position, e.rotation);
        o.points.push(E), (l = o.pickingUserId) == null || l.push(a);
      }
      for (const c of e.colors)
        (u = o.color) == null || u.push(c);
    }
  }
  /**
   * Append a new line mesh.
   *
   * @param batchable
   */
  appendLines(e) {
    var l, u;
    let s = null;
    for (const [c, E] of this.lineBatches)
      isInBatch(e, c) && (s = c);
    if (s === null) {
      const c = this.renderer.createLineMesh();
      c.color = [], c.pickingUserId = [], s = createBatchKey(e, c);
      const E = createBatchObject(this.renderer, e, c);
      this.lineBatches.set(s, E);
    }
    const o = s.mesh, a = this.pickingMap.get(e);
    if (a !== void 0) {
      for (const c of e.vertices) {
        const E = transformVertex(c, e.position, e.rotation);
        o.vertices.push(E), (l = o.pickingUserId) == null || l.push(a);
      }
      for (const c of e.colors)
        (u = o.color) == null || u.push(c);
    }
  }
  /**
   * Append a new line strip mesh.
   *
   * @param batchable
   */
  appendStrip(e) {
    var l, u;
    let s = null;
    for (const [c, E] of this.stripBatches)
      isInBatch(e, c) && (s = c);
    if (s === null) {
      const c = this.renderer.createLineStripMesh();
      c.color = [], c.pickingUserId = [], s = createBatchKey(e, c);
      const E = createBatchObject(this.renderer, e, c);
      this.stripBatches.set(s, E);
    }
    const o = s.mesh, a = this.pickingMap.get(e);
    if (a !== void 0) {
      for (const c of e.vertices) {
        const E = transformVertex(c, e.position, e.rotation);
        o.vertices.push(E), (l = o.pickingUserId) == null || l.push(a);
      }
      for (const c of e.colors)
        (u = o.color) == null || u.push(c);
    }
  }
  /**
   * Append a new polygon mesh.
   *
   * @param batchable
   */
  appendPolygon(e) {
    var l, u;
    let s = null;
    for (const [c, E] of this.polygonBatches)
      isInBatch(e, c) && (s = c);
    if (s === null) {
      const c = this.renderer.createIndexedTriangleMesh();
      c.color = [], c.pickingUserId = [], s = createBatchKey(e, c);
      const E = createBatchObject(this.renderer, e, c);
      this.polygonBatches.set(s, E);
    }
    const o = s.mesh, a = this.pickingMap.get(e);
    if (a !== void 0) {
      const c = o.vertices.length;
      for (const E of e.indices)
        o.indices.push(E + c);
      for (const E of e.vertices) {
        const d = transformVertex(E, e.position, e.rotation);
        o.vertices.push(d), (l = o.pickingUserId) == null || l.push(a);
      }
      for (const E of e.colors)
        (u = o.color) == null || u.push(E);
    }
  }
  /**
   * Render the world objects.
   */
  renderObjects() {
    for (const [e, s] of this.pointBatches)
      this.renderer.getWorld().addObject(s);
    for (const [e, s] of this.lineBatches)
      this.renderer.getWorld().addObject(s);
    for (const [e, s] of this.polygonBatches)
      this.renderer.getWorld().addObject(s);
    for (const [e, s] of this.stripBatches)
      this.renderer.getWorld().addObject(s);
  }
  /**
   * Add a batchable to this batch.
   *
   * @param batchable
   */
  add(e) {
    this.members.push(e);
  }
  /**
   * Build the actual batch geometries.
   */
  build() {
    for (const e of this.members)
      switch (e.type) {
        case "points":
          this.appendPoints(e);
          break;
        case "lines":
          this.appendLines(e);
          break;
        case "strip":
          this.appendStrip(e);
          break;
        case "polygon":
          this.appendPolygon(e);
          break;
      }
    this.recenter();
    for (const [e, s] of this.pointBatches)
      e.mesh.resolve();
    for (const [e, s] of this.lineBatches)
      e.mesh.resolve();
    for (const [e, s] of this.stripBatches)
      e.mesh.resolve();
    for (const [e, s] of this.polygonBatches)
      e.mesh.resolve();
    this.renderObjects();
  }
  /**
   * Clear existing mesh batches.
   */
  clear() {
    this.members = [];
    for (const [e, s] of this.pointBatches)
      e.mesh.points = [], e.mesh.color = [], e.mesh.pickingUserId = [];
    for (const [e, s] of this.lineBatches)
      e.mesh.vertices = [], e.mesh.color = [], e.mesh.pickingUserId = [];
    for (const [e, s] of this.stripBatches)
      e.mesh.vertices = [], e.mesh.color = [], e.mesh.pickingUserId = [];
    for (const [e, s] of this.polygonBatches)
      e.mesh.vertices = [], e.mesh.indices = [], e.mesh.color = [], e.mesh.pickingUserId = [];
  }
}
class MeshBatch {
  constructor(e) {
    Qt(this, "renderer");
    Qt(this, "clusterer");
    Qt(this, "batchables");
    Qt(this, "batches");
    Qt(this, "pickingMap");
    this.renderer = e, this.clusterer = new Clustering(1e5), this.batchables = /* @__PURE__ */ new Set(), this.batches = [], this.pickingMap = /* @__PURE__ */ new Map();
  }
  /**
   * Compute the cluster point of a batchable.
   *
   * @param batchable
   */
  computeClusterPoint(e) {
    const s = new Matrix4().compose(
      e.position,
      e.rotation,
      e.scale
    );
    return calculateCentroid$1(e.vertices).applyMatrix4(s);
  }
  /**
   * Get the batchID of a batchable.
   *
   * @param batchable
   * @returns
   */
  getBatchID(e) {
    const s = this.computeClusterPoint(e), o = this.clusterer.add(s);
    return o === this.batches.length && this.batches.push(new BatchCore(this.renderer, this.pickingMap)), o;
  }
  /**
   * Add a mesh object to be batched. If the mesh is already batched, it will still refresh the batches.
   *
   * This should be called whenever a batchable mesh is updated (e.g., new material).
   *
   * Updates are not propagated until `refresh()` is invoked.
   *
   * @param batchable
   */
  addMesh(e) {
    const s = this.renderer.pickingManager;
    this.batchables.has(e) || (this.batchables.add(e), this.pickingMap.set(e, s.newId()));
  }
  /**
   * Remove a batched mesh object.
   *
   * Updates are not propagated until `refresh()` is invoked.
   *
   * @param batchable
   */
  removeMesh(e) {
    this.batchables.delete(e), this.pickingMap.delete(e);
  }
  /**
   * This will regenerate the batch objects and recenter using the updated mesh list.
   *
   * Dot NOT call this in a runtime loop.
   */
  refresh() {
    this.clusterer.clear();
    for (const e of this.batches)
      e.clear();
    for (const e of this.batchables) {
      const s = this.getBatchID(e);
      this.batches[s].add(e);
    }
    for (const e of this.batches)
      e.build();
  }
  /**
   * Get the picking ID of a batchable.
   *
   * @param batchable
   * @returns
   */
  getPickingId(e) {
    return this.pickingMap.get(e);
  }
}
var ComponentType$1;
(function(r) {
  r.U8 = "U8", r.U16 = "U16", r.U32 = "U32", r.U64 = "U64", r.I8 = "I8", r.I16 = "I16", r.I32 = "I32", r.I64 = "I64", r.F32 = "F32", r.F64 = "F64";
})(ComponentType$1 || (ComponentType$1 = {}));
var TileDebugColorMode;
(function(r) {
  r[r.None = 0] = "None", r[r.Refinement = 1] = "Refinement";
})(TileDebugColorMode || (TileDebugColorMode = {}));
var CameraProjection;
(function(r) {
  r[r.Perspective = 0] = "Perspective", r[r.Orthographic = 1] = "Orthographic";
})(CameraProjection || (CameraProjection = {}));
class IFontAsset {
}
var PointCloudStyle;
(function(r) {
  r[r.None = 0] = "None", r[r.IntensityColoring = 1] = "IntensityColoring", r[r.ClassificationColoring = 2] = "ClassificationColoring", r[r.GradientColoring = 3] = "GradientColoring";
})(PointCloudStyle || (PointCloudStyle = {}));
var PointShape;
(function(r) {
  r[r.Circle = 0] = "Circle", r[r.Square = 1] = "Square";
})(PointShape || (PointShape = {}));
var FaceCullingMode;
(function(r) {
  r[r.BackFace = 0] = "BackFace", r[r.FrontFace = 1] = "FrontFace", r[r.None = 2] = "None";
})(FaceCullingMode || (FaceCullingMode = {}));
var RenderLayer;
(function(r) {
  r[r.Main = 0] = "Main", r[r.AfterPanorama = 1] = "AfterPanorama", r[r.UIOverlay = 2] = "UIOverlay";
})(RenderLayer || (RenderLayer = {}));
var WorldObjectType;
(function(r) {
  r[r.BoxObject = 0] = "BoxObject", r[r.SphereObject = 1] = "SphereObject", r[r.PointObject = 2] = "PointObject", r[r.LineObject = 3] = "LineObject", r[r.LineSegmentObject = 4] = "LineSegmentObject", r[r.MeshObject = 5] = "MeshObject", r[r.TilesetObject = 6] = "TilesetObject", r[r.CameraObject = 7] = "CameraObject", r[r.ObjObject = 8] = "ObjObject", r[r.IfcObject = 9] = "IfcObject", r[r.KmlObject = 10] = "KmlObject", r[r.DxfObject = 11] = "DxfObject", r[r.SpriteObject = 12] = "SpriteObject", r[r.LabelCollection = 13] = "LabelCollection", r[r.InstancedMesh = 14] = "InstancedMesh", r[r.GaussianSplat = 15] = "GaussianSplat";
})(WorldObjectType || (WorldObjectType = {}));
const baseVertex$6 = (r) => (
  /* glsl */
  `
#define PHONG

varying vec3 vViewPosition;

#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

${r ? "attribute uint pickingUserId;" : ""}
${r ? "flat varying uint vPickingUserId;" : ""}

void main() {

    #include <uv_vertex>
    #include <color_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>
    #include <skinbase_vertex>
    #include <skinnormal_vertex>
    #include <defaultnormal_vertex>
    #include <normal_vertex>

    #include <begin_vertex>
    #include <morphtarget_vertex>
    #include <skinning_vertex>
    #include <displacementmap_vertex>
    #include <project_vertex>
    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>

    vViewPosition = - mvPosition.xyz;
    ${r ? "vPickingUserId = pickingUserId;" : ""}

    #include <worldpos_vertex>
    #include <envmap_vertex>
    #include <shadowmap_vertex>
    #include <fog_vertex>
}
`
), baseFragment$6 = (r) => (
  /* glsl */
  `
#define PHONG

layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;
uniform bool unlit;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

${r ? "flat varying uint vPickingUserId;" : ""}

void main() {

    #include <clipping_planes_fragment>

    vec4 diffuseColor = vec4( diffuse, opacity );
    ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
    vec3 totalEmissiveRadiance = emissive;

    #include <logdepthbuf_fragment>
    #include <map_fragment>
    #include <color_fragment>
    #include <alphamap_fragment>
    #include <alphatest_fragment>
    #include <specularmap_fragment>
    #include <normal_fragment_begin>
    #include <normal_fragment_maps>
    #include <emissivemap_fragment>

    // accumulation
    #include <lights_phong_fragment>
    #include <lights_fragment_begin>
    #include <lights_fragment_maps>
    #include <lights_fragment_end>

    // modulation
    #include <aomap_fragment>

    vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;

    #include <envmap_fragment>
    #include <opaque_fragment>
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    #include <fog_fragment>
    #include <premultiplied_alpha_fragment>
    #include <dithering_fragment>
    
    if (unlit) {
        gl_FragColor.rgb = diffuseColor.rgb;
    }

    uint finalExtraId = uint(0);
    ${r ? "finalExtraId = vPickingUserId;" : "finalExtraId = extraId;"}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), baseVertex$5 = (r, e = !1) => (
  /* glsl */
  `
#include <common>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

${r ? "attribute uint pickingUserId;" : ""}
${r ? "flat varying uint vPickingUserId;" : ""}

${e ? "flat varying int vgl_InstanceID;" : ""}

void main() {

	#include <uv_vertex>
	#include <color_vertex>

	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>

	#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	
	${r ? "vPickingUserId = pickingUserId;" : ""}
	${e ? "vgl_InstanceID = gl_InstanceID;" : ""}

	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}
`
), baseFragment$5 = (r, e = !1) => (
  /* glsl */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

uniform vec3 diffuse;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

#endif

#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

${r ? "flat varying uint vPickingUserId;" : ""}
${e ? "flat varying int vgl_InstanceID;" : ""}

void main() {

	#include <clipping_planes_fragment>

	vec4 diffuseColor = vec4( diffuse, opacity );

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>

	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );

	// accumulation (baked indirect lighting only)
	#ifdef USE_LIGHTMAP

		vec4 lightMapTexel= texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;

	#else

		reflectedLight.indirectDiffuse += vec3( 1.0 );

	#endif

	// modulation
	#include <aomap_fragment>

	reflectedLight.indirectDiffuse *= diffuseColor.rgb;

	vec3 outgoingLight = reflectedLight.indirectDiffuse;

	#include <envmap_fragment>

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>

    uint finalExtraId = extraId;
    ${r ? "finalExtraId = vPickingUserId;" : ""}
    ${e ? "finalExtraId = uint(vgl_InstanceID);" : ""}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), baseVertex$4 = (r, e = !1) => (
  /* glsl */
  `
#define STANDARD

varying vec3 vViewPosition;

#ifdef USE_TRANSMISSION

    varying vec3 vWorldPosition;

#endif

#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

${r ? "attribute uint pickingUserId;" : ""}
${r ? "flat varying uint vPickingUserId;" : ""}

${e ? "flat varying int vgl_InstanceID;" : ""}

void main() {

    #include <uv_vertex>
    #include <color_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>
    #include <skinbase_vertex>
    #include <skinnormal_vertex>
    #include <defaultnormal_vertex>
    #include <normal_vertex>

    #include <begin_vertex>
    #include <morphtarget_vertex>
    #include <skinning_vertex>
    #include <displacementmap_vertex>
    #include <project_vertex>
    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>

    vViewPosition = - mvPosition.xyz;
    ${r ? "vPickingUserId = pickingUserId;" : ""}
    ${e ? "vgl_InstanceID = gl_InstanceID;" : ""}

    #include <worldpos_vertex>
    #include <shadowmap_vertex>
    #include <fog_vertex>

#ifdef USE_TRANSMISSION

    vWorldPosition = worldPosition.xyz;

#endif
}
`
), baseFragment$4 = (r, e = !1) => (
  /* glsl */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

#define STANDARD

#ifdef PHYSICAL
    #define IOR
    #define SPECULAR
#endif

uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;
uniform bool unlit;

#ifdef IOR
    uniform float ior;
#endif

#ifdef SPECULAR
    uniform float specularIntensity;
    uniform vec3 specularTint;

    #ifdef USE_SPECULARINTENSITYMAP
        uniform sampler2D specularIntensityMap;
    #endif

    #ifdef USE_SPECULARTINTMAP
        uniform sampler2D specularTintMap;
    #endif
#endif

#ifdef USE_CLEARCOAT
    uniform float clearcoat;
    uniform float clearcoatRoughness;
#endif

#ifdef USE_SHEEN
    uniform vec3 sheenTint;
    uniform float sheenRoughness;
#endif

varying vec3 vViewPosition;

#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

${r ? "flat varying uint vPickingUserId;" : ""}
${e ? "flat varying int vgl_InstanceID;" : ""}

void main() {

    #include <clipping_planes_fragment>

    vec4 diffuseColor = vec4( diffuse, opacity );
    ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
    vec3 totalEmissiveRadiance = emissive;

    #include <logdepthbuf_fragment>
    #include <map_fragment>
    #include <color_fragment>
    #include <alphamap_fragment>
    #include <alphatest_fragment>
    #include <roughnessmap_fragment>
    #include <metalnessmap_fragment>
    #include <normal_fragment_begin>
    #include <normal_fragment_maps>
    #include <clearcoat_normal_fragment_begin>
    #include <clearcoat_normal_fragment_maps>
    #include <emissivemap_fragment>

    // accumulation
    #include <lights_physical_fragment>
    #include <lights_fragment_begin>
    #include <lights_fragment_maps>
    #include <lights_fragment_end>

    // modulation
    #include <aomap_fragment>

    vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
    vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;

    #include <transmission_fragment>

    vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;

    #ifdef USE_CLEARCOAT

        float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );

        vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );

        outgoingLight = outgoingLight * ( 1.0 - clearcoat * Fcc ) + clearcoatSpecular * clearcoat;

    #endif

    #include <opaque_fragment>
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    #include <fog_fragment>
    #include <premultiplied_alpha_fragment>
    #include <dithering_fragment>

    if (unlit) {
        gl_FragColor.rgb = diffuseColor.rgb;
    }

    uint finalExtraId = extraId;
    ${r ? "finalExtraId = vPickingUserId;" : ""}
    ${e ? "finalExtraId = uint(vgl_InstanceID);" : ""}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), baseVertex$3 = (
  /* glsl */
  (r, e, s, o) => `
uniform float size;
uniform float scale;
uniform float orthoZoom;

${r ? "attribute float Intensity;" : ""}
${e ? "attribute float Classification;" : ""}

${r ? "varying float IntensityV;" : ""}
${e ? "varying float ClassificationV;" : ""}
${s ? "varying vec3 PositionV;" : ""}

${o ? "attribute uint pickingUserId;" : ""}
${o ? "flat varying uint vPickingUserId;" : ""}

#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

/*
    If size attenuation is enabled and we're using a perspective projection,
    point size specifies the desired size at this distance to the camera.
    Closer points will be larger and more distant points smaller.
*/
#define SCALE_PERSPECTIVE 10.0

#define SCALE_ORTHO 15.0

void main() {

    #include <color_vertex>
    #include <begin_vertex>
    #include <morphtarget_vertex>
    #include <project_vertex>

    gl_PointSize = size;
    
    ${r ? "IntensityV = Intensity;" : ""}
    ${e ? "ClassificationV = Classification;" : ""}
    ${s ? "PositionV = mvPosition.xyz;" : ""};
    ${o ? "vPickingUserId = pickingUserId;" : ""}

    #ifdef USE_SIZEATTENUATION

        bool isPerspective = isPerspectiveMatrix( projectionMatrix );

        // Have to do this here to make sure uniform isn't optimized away
        // by some drivers, causing an error when we try and set it.
        float orthoZoom_ = orthoZoom;

        if ( isPerspective ) {
            gl_PointSize *= ( SCALE_PERSPECTIVE / - mvPosition.z );
        } else {
            gl_PointSize *= ( SCALE_ORTHO / orthoZoom_ );
        }

    #endif

    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>
    #include <worldpos_vertex>
    #include <fog_vertex>
}
`
), baseFragment$3 = (r) => (
  /* glsl */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

#define gl_FragColor pc_fragColor

uniform vec3 diffuse;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;
uniform float brightness;
uniform float contrast;
uniform float gamma;
uniform bool useCircularPoints;

${r ? "flat varying uint vPickingUserId;" : ""}

#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

float squaredDistance(vec2 from, vec2 to) {
    vec2 delta = to - from;
    return dot(delta, delta);
}

void main() {
    // Render point as circle instead of square
    float sqDist = squaredDistance(gl_PointCoord, vec2(0.5, 0.5));
    if (useCircularPoints) {
        if (sqDist > 0.25)
           discard;
    }

    #include <clipping_planes_fragment>

    vec3 outgoingLight = vec3( 0.0 );
    vec4 diffuseColor = vec4( diffuse, opacity );

    #include <logdepthbuf_fragment>
    #include <map_particle_fragment>
    #include <color_fragment>
    #include <alphatest_fragment>

    // Apply brightness, contrast, and gamma correction
    vec3 color = contrast * diffuseColor.rgb + brightness;
    outgoingLight = vec3(
        clamp(pow(color.r, gamma), 0.0, 1.0),
        clamp(pow(color.g, gamma), 0.0, 1.0),
        clamp(pow(color.b, gamma), 0.0, 1.0)
    );
    
    #include <opaque_fragment>
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    #include <fog_fragment>
    #include <premultiplied_alpha_fragment>

    uint finalExtraId = uint(0);
    ${r ? "finalExtraId = vPickingUserId;" : "finalExtraId = extraId;"}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), intensityFragment = (
  /* glsl */
  (r, e) => {
    let s = "";
    for (let o = 0; o < r.length - 1; o++) {
      const a = r[o], l = r[o + 1], u = (o / (r.length - 1)).toFixed(20), c = ((o + 1) / (r.length - 1)).toFixed(20);
      s += `
        if (gradient >= ${u} && gradient <= ${c}) {
            float a = (gradient - ${u}) / (${c} - ${u});
            color = mix(vec3(${a.r}, ${a.g}, ${a.b}),
                        vec3(${l.r}, ${l.g}, ${l.b}),
                        a);
        }
        `;
    }
    return `
    layout(location = 1) out highp vec4 pc_pickingBuffer1;
    layout(location = 2) out highp vec4 pc_pickingBuffer2;
    layout(location = 3) out highp vec2 pc_fragCoordBuffer;
    layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

    uniform vec3 diffuse;
    uniform float opacity;
    uniform uint objectId;
    uniform uint extraId;
    uniform bool useCircularPoints;

    varying float IntensityV;
    ${e ? "flat varying uint vPickingUserId;" : ""}

    #include <common>
    #include <color_pars_fragment>
    #include <map_particle_pars_fragment>
    #include <alphatest_pars_fragment>
    #include <fog_pars_fragment>
    #include <logdepthbuf_pars_fragment>
    #include <clipping_planes_pars_fragment>

    float squaredDistance(vec2 from, vec2 to) {
        vec2 delta = to - from;
        return dot(delta, delta);
    }

    void main() {
        // Render point as circle instead of square
        float sqDist = squaredDistance(gl_PointCoord, vec2(0.5, 0.5));
        if (useCircularPoints) {
            if (sqDist > 0.25)
               discard;
        }

        #include <clipping_planes_fragment>

        vec3 outgoingLight = vec3( 0.0 );
        vec4 diffuseColor = vec4( diffuse, opacity );
        
        #include <logdepthbuf_fragment>
        #include <map_particle_fragment>
        #include <color_fragment>
        #include <alphatest_fragment>

        float gradient = IntensityV / 65535.0;
        vec3 color = vec3( 0.3, 0.3, 0.3 );
        ${s}
        outgoingLight = color;

        #include <opaque_fragment>
        #include <tonemapping_fragment>
        #include <colorspace_fragment>
        #include <fog_fragment>
        #include <premultiplied_alpha_fragment>

        uint finalExtraId = uint(0);
        ${e ? "finalExtraId = vPickingUserId;" : "finalExtraId = extraId;"}
        pc_pickingBuffer1 = vec4(
            float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
            float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
            float(objectId >> uint(16) & uint(0xFF)) / 255.0,
            float(objectId >> uint(24) & uint(0xFF)) / 255.0
        );
        pc_pickingBuffer2 = vec4(
            float(extraId >> uint(0)  & uint(0xFF)) / 255.0,
            float(extraId >> uint(8)  & uint(0xFF)) / 255.0,
            float(extraId >> uint(16) & uint(0xFF)) / 255.0,
            float(extraId >> uint(24) & uint(0xFF)) / 255.0
        );
        pc_fragCoordBuffer = gl_FragCoord.zw;
        pc_fragCoordBufferEDL = gl_FragCoord.zw;
    }
    `;
  }
), classificationFragment = (r, e) => (
  /* prettier-ignore */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

#define gl_FragColor pc_fragColor

uniform float opacity;
uniform uint objectId;
uniform uint extraId;
uniform bool useCircularPoints;

varying float ClassificationV;

#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

float squaredDistance(vec2 from, vec2 to) {
    vec2 delta = to - from;
    return dot(delta, delta);
}

void main() {
    // Render point as circle instead of square
    float sqDist = squaredDistance(gl_PointCoord, vec2(0.5, 0.5));
    if (useCircularPoints) {
        if (sqDist > 0.25)
           discard;
    }

    #include <clipping_planes_fragment>

    vec3 outgoingLight = vec3( 0.0 );
    vec4 diffuseColor = vec4( 0.0 );
    int c = int(ClassificationV);
    if (c == 0 && ${r[0].show}) diffuseColor = vec4( ${r[0].base.r}, ${r[0].base.g}, ${r[0].base.b}, opacity );
    else if (c == 1 && ${r[1].show}) diffuseColor = vec4( ${r[1].base.r}, ${r[1].base.g}, ${r[1].base.b}, opacity );
    else if (c == 2 && ${r[2].show}) diffuseColor = vec4( ${r[2].base.r}, ${r[2].base.g}, ${r[2].base.b}, opacity );
    else if (c == 3 && ${r[3].show}) diffuseColor = vec4( ${r[3].base.r}, ${r[3].base.g}, ${r[3].base.b}, opacity );
    else if (c == 4 && ${r[4].show}) diffuseColor = vec4( ${r[4].base.r}, ${r[4].base.g}, ${r[4].base.b}, opacity );
    else if (c == 5 && ${r[5].show}) diffuseColor = vec4( ${r[5].base.r}, ${r[5].base.g}, ${r[5].base.b}, opacity );
    else if (c == 6 && ${r[6].show}) diffuseColor = vec4( ${r[6].base.r}, ${r[6].base.g}, ${r[6].base.b}, opacity );
    else if (c == 7 && ${r[7].show}) diffuseColor = vec4( ${r[7].base.r}, ${r[7].base.g}, ${r[7].base.b}, opacity );
    else if (c == 8 && ${r[8].show}) diffuseColor = vec4( ${r[8].base.r}, ${r[8].base.g}, ${r[8].base.b}, opacity );
    else if (c == 9 && ${r[9].show}) diffuseColor = vec4( ${r[9].base.r}, ${r[9].base.g}, ${r[9].base.b}, opacity );
    else if (c == 10 && ${r[10].show}) diffuseColor = vec4( ${r[10].base.r}, ${r[10].base.g}, ${r[10].base.b}, opacity );
    else if (c == 11 && ${r[11].show}) diffuseColor = vec4( ${r[11].base.r}, ${r[11].base.g}, ${r[11].base.b}, opacity );
    else if (c == 12 && ${r[12].show}) diffuseColor = vec4( ${r[12].base.r}, ${r[12].base.g}, ${r[12].base.b}, opacity );
    else if (c == 13 && ${r[13].show}) diffuseColor = vec4( ${r[13].base.r}, ${r[13].base.g}, ${r[13].base.b}, opacity );
    else if (c == 14 && ${r[14].show}) diffuseColor = vec4( ${r[14].base.r}, ${r[14].base.g}, ${r[14].base.b}, opacity );
    else if (c == 15 && ${r[15].show}) diffuseColor = vec4( ${r[15].base.r}, ${r[15].base.g}, ${r[15].base.b}, opacity );
    else if (c == 16 && ${r[16].show}) diffuseColor = vec4( ${r[16].base.r}, ${r[16].base.g}, ${r[16].base.b}, opacity );
    else if (c == 17 && ${r[17].show}) diffuseColor = vec4( ${r[17].base.r}, ${r[17].base.g}, ${r[17].base.b}, opacity );
    else if (c == 18 && ${r[18].show}) diffuseColor = vec4( ${r[18].base.r}, ${r[18].base.g}, ${r[18].base.b}, opacity );
    else discard;

    #include <logdepthbuf_fragment>
    #include <map_particle_fragment>
    #include <alphatest_fragment>

    outgoingLight = diffuseColor.rgb;

    #include <opaque_fragment>
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    #include <fog_fragment>
    #include <premultiplied_alpha_fragment>

    uint finalExtraId = uint(0);
    ${e ? "finalExtraId = vPickingUserId;" : "finalExtraId = extraId;"}
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
        float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), gradientFragment = (
  /* glsl */
  (r, e) => {
    let s = "";
    for (let o = 0; o < r.length - 1; o++) {
      const a = r[o], l = r[o + 1], u = (o / (r.length - 1)).toFixed(20), c = ((o + 1) / (r.length - 1)).toFixed(20);
      s += `
        if (gradient >= ${u} && gradient <= ${c}) {
            float a = (gradient - ${u}) / (${c} - ${u});
            color = mix(vec3(${a.r}, ${a.g}, ${a.b}),
                        vec3(${l.r}, ${l.g}, ${l.b}),
                        a);
        }
        `;
    }
    return `
    layout(location = 1) out highp vec4 pc_pickingBuffer1;
    layout(location = 2) out highp vec4 pc_pickingBuffer2;
    layout(location = 3) out highp vec2 pc_fragCoordBuffer;
    layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;
    
    #define gl_FragColor pc_fragColor
    
    uniform float opacity;
    uniform uint objectId;
    uniform uint extraId;
    uniform vec3 minGradient;
    uniform vec3 maxGradient;
    uniform bool useCircularPoints;
    
    varying vec3 PositionV;
    
    #include <common>
    #include <color_pars_fragment>
    #include <map_particle_pars_fragment>
    #include <alphatest_pars_fragment>
    #include <fog_pars_fragment>
    #include <logdepthbuf_pars_fragment>
    #include <clipping_planes_pars_fragment>
    
    float squaredDistance(vec2 from, vec2 to) {
        vec2 delta = to - from;
        return dot(delta, delta);
    }
    
    void main() {
        // Render point as circle instead of square
        float sqDist = squaredDistance(gl_PointCoord, vec2(0.5, 0.5));
        if (useCircularPoints) {
            if (sqDist > 0.25)
               discard;
        }

        #include <clipping_planes_fragment>
    
        vec3 outgoingLight = vec3( 0.0 );
    
        vec3 u = PositionV - minGradient;
        vec3 v = maxGradient - minGradient;
        float scalarProjection = dot( u, normalize( v ) );
        float gradient = scalarProjection / length( v );
        vec3 color = vec3( 0.3, 0.3, 0.3 );
        ${s}
        vec4 diffuseColor = vec4( color, opacity );
    
        #include <logdepthbuf_fragment>
        #include <map_particle_fragment>
        #include <alphatest_fragment>
    
        outgoingLight = diffuseColor.rgb;
    
        #include <opaque_fragment>
        #include <tonemapping_fragment>
        #include <colorspace_fragment>
        #include <fog_fragment>
        #include <premultiplied_alpha_fragment>
    
        uint finalExtraId = uint(0);
        ${e ? "finalExtraId = vPickingUserId;" : "finalExtraId = extraId;"}
        pc_pickingBuffer1 = vec4(
            float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
            float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
            float(objectId >> uint(16) & uint(0xFF)) / 255.0,
            float(objectId >> uint(24) & uint(0xFF)) / 255.0
        );
        pc_pickingBuffer2 = vec4(
            float(finalExtraId >> uint(0)  & uint(0xFF)) / 255.0,
            float(finalExtraId >> uint(8)  & uint(0xFF)) / 255.0,
            float(finalExtraId >> uint(16) & uint(0xFF)) / 255.0,
            float(finalExtraId >> uint(24) & uint(0xFF)) / 255.0
        );
        pc_fragCoordBuffer = gl_FragCoord.zw;
        pc_fragCoordBufferEDL = gl_FragCoord.zw;
    }
    `;
  }
), baseVertex$2 = (
  /* glsl */
  `
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

uniform float linewidth;
uniform vec2 resolution;

attribute vec3 instanceStart;
attribute vec3 instanceEnd;

attribute vec3 instanceColorStart;
attribute vec3 instanceColorEnd;

varying vec2 vUv;
varying vec4 worldPos;
varying vec3 worldStart;
varying vec3 worldEnd;

#ifdef USE_DASH

    uniform float dashScale;
    attribute float instanceDistanceStart;
    attribute float instanceDistanceEnd;
    varying float vLineDistance;

#endif

void trimSegment( const in vec4 start, inout vec4 end ) {

    // trim end segment so it terminates between the camera plane and the near plane

    // conservative estimate of the near plane
    float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
    float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
    float nearEstimate = - 0.5 * b / a;

    float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

    end.xyz = mix( start.xyz, end.xyz, alpha );

}

float extractAspectFromProjection() {
    vec4 minPoint = projectionMatrix * vec4(-1, -1, 1, 1);
    vec4 maxPoint = projectionMatrix * vec4( 1,  1, 1, 1);
    
    float width = maxPoint.x - minPoint.x;
    float height = maxPoint.y - minPoint.y;
    
    return height / width;
}

void main() {

    #ifdef USE_COLOR

        vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

    #endif

    #ifdef USE_DASH

        vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;

    #endif

    float aspect = extractAspectFromProjection(); // resolution.x / resolution.y;

    vUv = uv;

    // camera space
    vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
    vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

    worldStart = start.xyz;
    worldEnd = end.xyz;

    // special case for perspective projection, and segments that terminate either in, or behind, the camera plane
    // clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
    // but we need to perform ndc-space calculations in the shader, so we must address this issue directly
    // perhaps there is a more elegant solution -- WestLangley

    bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

    if ( perspective ) {

        if ( start.z < 0.0 && end.z >= 0.0 ) {

            trimSegment( start, end );

        } else if ( end.z < 0.0 && start.z >= 0.0 ) {

            trimSegment( end, start );

        }

    }

    // clip space
    vec4 clipStart = projectionMatrix * start;
    vec4 clipEnd = projectionMatrix * end;

    // ndc space
    vec3 ndcStart = clipStart.xyz / clipStart.w;
    vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

    // direction
    vec2 dir = ndcEnd.xy - ndcStart.xy;

    // account for clip-space aspect ratio
    dir.x *= aspect;
    dir = normalize( dir );

    #ifdef WORLD_UNITS

        // get the offset direction as perpendicular to the view vector
        vec3 worldDir = normalize( end.xyz - start.xyz );
        vec3 offset;
        if ( position.y < 0.5 ) {

            offset = normalize( cross( start.xyz, worldDir ) );

        } else {

            offset = normalize( cross( end.xyz, worldDir ) );

        }

        // sign flip
        if ( position.x < 0.0 ) offset *= - 1.0;

        float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

        // don't extend the line if we're rendering dashes because we
        // won't be rendering the endcaps
        #ifndef USE_DASH

            // extend the line bounds to encompass  endcaps
            start.xyz += - worldDir * linewidth * 0.5;
            end.xyz += worldDir * linewidth * 0.5;

            // shift the position of the quad so it hugs the forward edge of the line
            offset.xy -= dir * forwardOffset;
            offset.z += 0.5;

        #endif

        // endcaps
        if ( position.y > 1.0 || position.y < 0.0 ) {

            offset.xy += dir * 2.0 * forwardOffset;

        }

        // adjust for linewidth
        offset *= linewidth * 0.5;

        // set the world position
        worldPos = ( position.y < 0.5 ) ? start : end;
        worldPos.xyz += offset;

        // project the worldpos
        vec4 clip = projectionMatrix * worldPos;

        // shift the depth of the projected points so the line
        // segements overlap neatly
        vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
        clip.z = clipPose.z * clip.w;

    #else

        vec2 offset = vec2( dir.y, - dir.x );
        // undo aspect ratio adjustment
        dir.x /= aspect;
        offset.x /= aspect;

        // sign flip
        if ( position.x < 0.0 ) offset *= - 1.0;

        // endcaps
        if ( position.y < 0.0 ) {

            offset += - dir;

        } else if ( position.y > 1.0 ) {

            offset += dir;

        }

        // adjust for linewidth
        offset *= linewidth;

        // adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
        offset /= resolution.y;

        // select end
        vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

        // back to clip space
        offset *= clip.w;

        clip.xy += offset;

    #endif

    gl_Position = clip;

    vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>
    #include <fog_vertex>

}
`
), baseFragment$2 = (
  /* glsl */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

uniform vec3 diffuse;
uniform float opacity;
uniform float linewidth;
uniform uint objectId;
uniform uint extraId;

#ifdef USE_DASH

    uniform float dashSize;
    uniform float gapSize;

#endif

varying float vLineDistance;
varying vec4 worldPos;
varying vec3 worldStart;
varying vec3 worldEnd;

#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

varying vec2 vUv;

vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

    float mua;
    float mub;

    vec3 p13 = p1 - p3;
    vec3 p43 = p4 - p3;

    vec3 p21 = p2 - p1;

    float d1343 = dot( p13, p43 );
    float d4321 = dot( p43, p21 );
    float d1321 = dot( p13, p21 );
    float d4343 = dot( p43, p43 );
    float d2121 = dot( p21, p21 );

    float denom = d2121 * d4343 - d4321 * d4321;

    float numer = d1343 * d4321 - d1321 * d4343;

    mua = numer / denom;
    mua = clamp( mua, 0.0, 1.0 );
    mub = ( d1343 + d4321 * ( mua ) ) / d4343;
    mub = clamp( mub, 0.0, 1.0 );

    return vec2( mua, mub );

}

void main() {

    #include <clipping_planes_fragment>

    #ifdef USE_DASH

        if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

        if ( mod( vLineDistance, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

    #endif

    float alpha = opacity;

    #ifdef WORLD_UNITS

        // Find the closest points on the view ray and the line segment
        vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
        vec3 lineDir = worldEnd - worldStart;
        vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

        vec3 p1 = worldStart + lineDir * params.x;
        vec3 p2 = rayEnd * params.y;
        vec3 delta = p1 - p2;
        float len = length( delta );
        float norm = len / linewidth;

        #ifndef USE_DASH

            #ifdef ALPHA_TO_COVERAGE

                float dnorm = fwidth( norm );
                alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

            #else

                if ( norm > 0.5 ) {

                    discard;

                }

            #endif

        #endif

    #else

        #ifdef ALPHA_TO_COVERAGE

            // artifacts appear on some hardware if a derivative is taken within a conditional
            float a = vUv.x;
            float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
            float len2 = a * a + b * b;
            float dlen = fwidth( len2 );

            if ( abs( vUv.y ) > 1.0 ) {

                alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

            }

        #else

            if ( abs( vUv.y ) > 1.0 ) {

                float a = vUv.x;
                float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
                float len2 = a * a + b * b;

                if ( len2 > 1.0 ) discard;

            }

        #endif

    #endif

    vec4 diffuseColor = vec4( diffuse, alpha );

    #include <logdepthbuf_fragment>
    #include <color_fragment>

    gl_FragColor = vec4( diffuseColor.rgb, alpha );

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
    #include <fog_fragment>
    #include <premultiplied_alpha_fragment>
    
    pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(extraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(extraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(extraId >> uint(16) & uint(0xFF)) / 255.0,
        float(extraId >> uint(24) & uint(0xFF)) / 255.0
    );

    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
}
`
), baseVertex$1 = (
  /* glsl */
  `
uniform float rotation;
uniform vec2 center;

#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

void main() {

	#include <uv_vertex>

	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );

	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );

	#ifndef USE_SIZEATTENUATION

		bool isPerspective = isPerspectiveMatrix( projectionMatrix );

		if ( isPerspective ) {
		
			float half_fov = atan(1.0 / projectionMatrix[1][1]);
			scale *= 2.0 * tan(half_fov) * (- mvPosition.z);
		
		} else {
			
			float orthoZoom = 2.0 * (1.0 / projectionMatrix[1][1]);
			scale *= orthoZoom;

		}

	#endif

	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;

	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;

	mvPosition.xy += rotatedPosition;

	gl_Position = projectionMatrix * mvPosition;

	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}
`
), baseFragment$1 = (
  /* glsl */
  `
layout(location = 1) out highp vec4 pc_pickingBuffer1;
layout(location = 2) out highp vec4 pc_pickingBuffer2;
layout(location = 3) out highp vec2 pc_fragCoordBuffer;
layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;

uniform vec3 diffuse;
uniform float opacity;
uniform uint objectId;
uniform uint extraId;

#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>

void main() {

	#include <clipping_planes_fragment>

	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );

	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>

	outgoingLight = diffuseColor.rgb;

	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	
	pc_pickingBuffer1 = vec4(
        float(objectId >> uint(0)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(8)  & uint(0xFF)) / 255.0,
        float(objectId >> uint(16) & uint(0xFF)) / 255.0,
        float(objectId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_pickingBuffer2 = vec4(
        float(extraId >> uint(0)  & uint(0xFF)) / 255.0,
        float(extraId >> uint(8)  & uint(0xFF)) / 255.0,
        float(extraId >> uint(16) & uint(0xFF)) / 255.0,
        float(extraId >> uint(24) & uint(0xFF)) / 255.0
    );
    pc_fragCoordBuffer = gl_FragCoord.zw;
    pc_fragCoordBufferEDL = gl_FragCoord.zw;
    
}
`
), baseVertex = (
  /* glsl */
  `
uniform sampler2D skGlyphTransformAtlas;
uniform float skGlyphScale;

attribute vec4 skGlyphBoundingBox;
attribute vec4 skGlyphTexCoords;
attribute float skGlyphLabelIndex;

varying vec2 vUv;
varying vec4 vGlyphBoundingBox;

#include <common>
#include <clipping_planes_pars_vertex>

float extractAspectFromProjection() {
  vec4 minPoint = projectionMatrix * vec4(-1, -1, 1, 1);
  vec4 maxPoint = projectionMatrix * vec4( 1,  1, 1, 1);
  
  float width = maxPoint.x - minPoint.x;
  float height = maxPoint.y - minPoint.y;
  
  return width / height;
}

void main() {

	{
	    // Compute the four corners over the UV area unconditionally
	    float uvX = skGlyphTexCoords.x;
	    float uvY = skGlyphTexCoords.y;
	    float uvW = skGlyphTexCoords.z;
	    float uvH = skGlyphTexCoords.w;
	    vec2 p0 = vec2(uvX, uvY);
	    vec2 p1 = vec2(uvX + uvW, uvY);
	    vec2 p2 = vec2(uvX + uvW, uvY + uvH);
	    vec2 p3 = vec2(uvX, uvY + uvH);
	    
	    // Initialize to a default and then conditionally move one of the corners into the output
	    vUv = vec2(0,0);
	    if (gl_VertexID == 0) {
	        vUv = p0;
	    } else if (gl_VertexID == 1) {
	        vUv = p1;
	    } else if (gl_VertexID == 2) {
	        vUv = p2;
	    } else if (gl_VertexID == 3) {
	        vUv = p3;
	    }
	}
	
	// Pass through attributes to fragment shader
	vGlyphBoundingBox = skGlyphBoundingBox;
	
	// Get the size of the texture, always using the highest detail mip (this texture will never have mips)
	vec2 transformAtlasSize = vec2(textureSize(skGlyphTransformAtlas, 0));
	
	// Convert the label index into a position inside the atlas. This needs the width of the texture
	float transformU = trunc(mod(skGlyphLabelIndex, transformAtlasSize.x));
	float transformV = trunc(skGlyphLabelIndex / transformAtlasSize.x);
	
	// The local-space position of the label. 'Local' is defined as relative to the parent label collection. The model
	// view matrix will contain the transform of the label collection.
	//
	// labelPosition will define the anchor position of the label, which will get projected into screen space so we can
	// place the glyph vertices relative to the anchor in screen space.
	vec4 labelPosition = texelFetch(skGlyphTransformAtlas, ivec2(transformU, transformV), 0);
	labelPosition.w = 1.0; // This needs to be one for use with the matrix multiply

    // Get our 3D anchor in view space
	vec4 mvPosition = modelViewMatrix * labelPosition;

    float aspect = extractAspectFromProjection();
    vec2 aspectCorrectedPosition = vec2(position.x * aspect, position.y);
    vec2 aspectCorrectedOffset = vec2(skGlyphBoundingBox.x * aspect, skGlyphBoundingBox.y);
	vec2 quadVertexPosition = (aspectCorrectedPosition * skGlyphBoundingBox.zw * skGlyphScale) + (aspectCorrectedOffset * skGlyphScale); 

	gl_Position = projectionMatrix * mvPosition;
	
	gl_Position.xy += quadVertexPosition * gl_Position.w;
	
	#include <clipping_planes_vertex>

}
`
), baseFragment = (
  /* glsl */
  `

#include <common>
#include <map_pars_fragment>
#include <clipping_planes_pars_fragment>

uniform float opacity;

// Picking buffer uniforms
uniform uint objectId;
uniform uint extraId;

// Fragment shader payload
varying vec2 vUv;
varying vec4 vGlyphBoundingBox;

uniform float uSkSDFExponent;

uniform vec4 uSkFillColor;
uniform vec4 uSkStrokeColor;
uniform float uSkStrokeWidth;

float skSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  float maxDimension = max(vGlyphBoundingBox.z, vGlyphBoundingBox.w);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uSkSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float skGetAADist() {
  return vGlyphBoundingBox.z / 32.0;
}

float skGetFragDistValue() {
  return skSdfValueToSignedDistance(texture2D(map, vUv).r);
}

float skGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );

  return alpha;
}

void main() {

	#include <clipping_planes_fragment>
    
	float aaDist = skGetAADist();
    float fragDistance = skGetFragDistValue();
    float edgeAlpha = skGetEdgeAlpha(fragDistance, 0.0, aaDist);

    vec4 fillRGBA = uSkFillColor;

    vec4 strokeRGBA = uSkStrokeWidth == 0.0 ? fillRGBA : uSkStrokeColor;
    
    if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;

    gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
        -uSkStrokeWidth - aaDist,
        -uSkStrokeWidth + aaDist,
        fragDistance
    ));
    gl_FragColor.a *= edgeAlpha;

    if (edgeAlpha == 0.0) {
        discard;
    }
    
    gl_FragColor.a *= opacity;
    
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
    
}
`
), Shaders = {
  pointCloud: {
    vertex: baseVertex$3,
    fragment: baseFragment$3
  },
  pointCloudIntensity: {
    vertex: baseVertex$3,
    fragment: intensityFragment
  },
  pointCloudClassification: {
    vertex: baseVertex$3,
    fragment: classificationFragment
  },
  pointCloudGradient: {
    vertex: baseVertex$3,
    fragment: gradientFragment
  },
  meshPhong: {
    vertex: baseVertex$6,
    fragment: baseFragment$6
  },
  meshBasic: {
    vertex: baseVertex$5,
    fragment: baseFragment$5
  },
  meshStandard: {
    vertex: baseVertex$4,
    fragment: baseFragment$4
  },
  line: {
    vertex: baseVertex$2,
    fragment: baseFragment$2
  },
  sprite: {
    vertex: baseVertex$1,
    fragment: baseFragment$1
  },
  glyph: {
    vertex: baseVertex,
    fragment: baseFragment
  }
};
class LabelCollectionMaterial extends SpriteMaterial {
  constructor(e) {
    var s, o, a, l, u, c, E;
    super(e), this.glyphScale = (s = e.glyphScale) !== null && s !== void 0 ? s : 1e-3, this.sdfExponent = (o = e.sdfExponent) !== null && o !== void 0 ? o : 9, this.fillColor = (l = (a = e.fillColor) === null || a === void 0 ? void 0 : a.clone()) !== null && l !== void 0 ? l : new Vector4(1, 1, 1, 1), this.strokeColor = (c = (u = e.strokeColor) === null || u === void 0 ? void 0 : u.clone()) !== null && c !== void 0 ? c : new Vector4(0, 0, 0, 1), this.strokeWidth = (E = e.strokeWidth) !== null && E !== void 0 ? E : 0, this.transformAtlas = e == null ? void 0 : e.transformAtlas;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof LabelCollectionMaterial && (this.glyphScale = e.glyphScale, this.sdfExponent = e.sdfExponent, this.fillColor = e.fillColor, this.strokeColor = e.strokeColor, this.strokeWidth = e.strokeWidth, this.transformAtlas = e.transformAtlas), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.glyph.vertex, e.fragmentShader = Shaders.glyph.fragment, e.uniforms.skGlyphScale = {
      value: this.glyphScale
    }, e.uniforms.skGlyphTransformAtlas = {
      value: this.transformAtlas
    }, e.uniforms.uSkSDFExponent = {
      value: this.sdfExponent
    }, e.uniforms.uSkFillColor = {
      value: this.fillColor
    }, e.uniforms.uSkStrokeColor = {
      value: this.strokeColor
    }, e.uniforms.uSkStrokeWidth = {
      value: this.strokeWidth
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        `;
  }
}
class PickingLineBasicMaterial extends LineBasicMaterial {
  constructor(e) {
    var s, o, a;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingLineBasicMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.meshBasic.vertex(this.userIdChannel), e.fragmentShader = Shaders.meshBasic.fragment(this.userIdChannel), e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        ${this.userIdChannel}
        `;
  }
}
UniformsLib.line = {
  worldUnits: { value: 1 },
  linewidth: { value: 1 },
  resolution: { value: new Vector2(1, 1) },
  dashOffset: { value: 0 },
  dashScale: { value: 1 },
  dashSize: { value: 1 },
  gapSize: { value: 1 }
  // todo FIX - maybe change to totalSize
};
ShaderLib.line = {
  uniforms: UniformsUtils.merge([
    UniformsLib.common,
    UniformsLib.fog,
    UniformsLib.line
  ]),
  vertexShader: (
    /* glsl */
    `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				// get the offset direction as perpendicular to the view vector
				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 offset;
				if ( position.y < 0.5 ) {

					offset = normalize( cross( start.xyz, worldDir ) );

				} else {

					offset = normalize( cross( end.xyz, worldDir ) );

				}

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// extend the line bounds to encompass  endcaps
					start.xyz += - worldDir * linewidth * 0.5;
					end.xyz += worldDir * linewidth * 0.5;

					// shift the position of the quad so it hugs the forward edge of the line
					offset.xy -= dir * forwardOffset;
					offset.z += 0.5;

				#endif

				// endcaps
				if ( position.y > 1.0 || position.y < 0.0 ) {

					offset.xy += dir * 2.0 * forwardOffset;

				}

				// adjust for linewidth
				offset *= linewidth * 0.5;

				// set the world position
				worldPos = ( position.y < 0.5 ) ? start : end;
				worldPos.xyz += offset;

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`
  ),
  fragmentShader: (
    /* glsl */
    `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <colorspace_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
  )
};
class LineMaterial extends ShaderMaterial {
  constructor(e) {
    super({
      type: "LineMaterial",
      uniforms: UniformsUtils.clone(ShaderLib.line.uniforms),
      vertexShader: ShaderLib.line.vertexShader,
      fragmentShader: ShaderLib.line.fragmentShader,
      clipping: !0
      // required for clipping support
    }), this.isLineMaterial = !0, Object.defineProperties(this, {
      color: {
        enumerable: !0,
        get: function() {
          return this.uniforms.diffuse.value;
        },
        set: function(s) {
          this.uniforms.diffuse.value = s;
        }
      },
      worldUnits: {
        enumerable: !0,
        get: function() {
          return "WORLD_UNITS" in this.defines;
        },
        set: function(s) {
          s === !0 ? this.defines.WORLD_UNITS = "" : delete this.defines.WORLD_UNITS;
        }
      },
      linewidth: {
        enumerable: !0,
        get: function() {
          return this.uniforms.linewidth.value;
        },
        set: function(s) {
          this.uniforms.linewidth.value = s;
        }
      },
      dashed: {
        enumerable: !0,
        get: function() {
          return "USE_DASH" in this.defines;
        },
        set(s) {
          !!s != "USE_DASH" in this.defines && (this.needsUpdate = !0), s === !0 ? this.defines.USE_DASH = "" : delete this.defines.USE_DASH;
        }
      },
      dashScale: {
        enumerable: !0,
        get: function() {
          return this.uniforms.dashScale.value;
        },
        set: function(s) {
          this.uniforms.dashScale.value = s;
        }
      },
      dashSize: {
        enumerable: !0,
        get: function() {
          return this.uniforms.dashSize.value;
        },
        set: function(s) {
          this.uniforms.dashSize.value = s;
        }
      },
      dashOffset: {
        enumerable: !0,
        get: function() {
          return this.uniforms.dashOffset.value;
        },
        set: function(s) {
          this.uniforms.dashOffset.value = s;
        }
      },
      gapSize: {
        enumerable: !0,
        get: function() {
          return this.uniforms.gapSize.value;
        },
        set: function(s) {
          this.uniforms.gapSize.value = s;
        }
      },
      opacity: {
        enumerable: !0,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(s) {
          this.uniforms.opacity.value = s;
        }
      },
      resolution: {
        enumerable: !0,
        get: function() {
          return this.uniforms.resolution.value;
        },
        set: function(s) {
          this.uniforms.resolution.value.copy(s);
        }
      },
      alphaToCoverage: {
        enumerable: !0,
        get: function() {
          return "USE_ALPHA_TO_COVERAGE" in this.defines;
        },
        set: function(s) {
          !!s != "USE_ALPHA_TO_COVERAGE" in this.defines && (this.needsUpdate = !0), s === !0 ? (this.defines.USE_ALPHA_TO_COVERAGE = "", this.extensions.derivatives = !0) : (delete this.defines.USE_ALPHA_TO_COVERAGE, this.extensions.derivatives = !1);
        }
      }
    }), this.setValues(e);
  }
}
class PickingLineMaterial extends LineMaterial {
  constructor(e) {
    var s, o;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingLineMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.line.vertex, e.fragmentShader = Shaders.line.fragment, e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        `;
  }
}
class PickingMeshBasicMaterial extends MeshBasicMaterial {
  constructor(e) {
    var s, o, a, l;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1, this.instanceIdAsExtraId = (l = e == null ? void 0 : e.instanceIdAsExtraId) !== null && l !== void 0 ? l : !1;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingMeshBasicMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.meshBasic.vertex(this.userIdChannel, this.instanceIdAsExtraId), e.fragmentShader = Shaders.meshBasic.fragment(this.userIdChannel, this.instanceIdAsExtraId), e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    }, this.instanceIdAsExtraId && (e.isWebGL2 = !0);
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        ${this.userIdChannel}
        ${this.instanceIdAsExtraId}
        `;
  }
}
class PickingMeshPhongMaterial extends MeshPhongMaterial {
  constructor(e) {
    var s, o, a;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingMeshPhongMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.meshPhong.vertex(this.userIdChannel), e.fragmentShader = Shaders.meshPhong.fragment(this.userIdChannel), e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    }, e.uniforms.unlit = {
      value: !1
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        ${this.userIdChannel}
        `;
  }
}
class PickingMeshPhysicalMaterial extends MeshPhysicalMaterial {
  constructor(e) {
    var s, o, a;
    super(e), this.objectId = 0, this.extraId = 0, this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingMeshPhysicalMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.meshStandard.vertex(this.userIdChannel), e.fragmentShader = Shaders.meshStandard.fragment(this.userIdChannel), e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    }, e.uniforms.unlit = {
      value: !1
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        ${this.userIdChannel}
        `;
  }
}
class PickingMeshStandardMaterial extends MeshStandardMaterial {
  constructor(e) {
    var s, o, a, l;
    super(e), this.objectId = 0, this.extraId = 0, this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1, this.instanceIdAsExtraId = (l = e == null ? void 0 : e.instanceIdAsExtraId) !== null && l !== void 0 ? l : !1;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingMeshStandardMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.meshStandard.vertex(this.userIdChannel, this.instanceIdAsExtraId), e.fragmentShader = Shaders.meshStandard.fragment(this.userIdChannel, this.instanceIdAsExtraId), e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    }, e.uniforms.unlit = {
      value: !1
    }, this.instanceIdAsExtraId && (e.isWebGL2 = !0);
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        ${this.userIdChannel}
        ${this.instanceIdAsExtraId}
        `;
  }
}
class PickingPointsMaterial extends PointsMaterial {
  constructor(e) {
    var s, o, a, l, u, c, E, d, f, h, S;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0, this.userIdChannel = (a = e == null ? void 0 : e.userIdChannel) !== null && a !== void 0 ? a : !1, this.style = (l = e == null ? void 0 : e.style) !== null && l !== void 0 ? l : PointCloudStyle.None, this.shape = (u = e == null ? void 0 : e.shape) !== null && u !== void 0 ? u : PointShape.Circle, this.classificationColors = (c = e == null ? void 0 : e.classificationColors) !== null && c !== void 0 ? c : {}, this.intensityColors = (E = e == null ? void 0 : e.intensityColors) !== null && E !== void 0 ? E : [
      { r: 0, g: 0, b: 0 },
      { r: 1, g: 1, b: 1 }
    ], this.gradientColors = (d = e == null ? void 0 : e.gradientColors) !== null && d !== void 0 ? d : [
      { r: 1, g: 0, b: 0 },
      { r: 0, g: 1, b: 0 }
    ], this.minGradient = { x: 0, y: 0, z: 0 }, this.maxGradient = { x: 0, y: 0, z: 0 }, this.minGradientViewSpace = { x: 0, y: 0, z: 0 }, this.maxGradientViewSpace = { x: 0, y: 0, z: 0 }, this.brightness = (f = e == null ? void 0 : e.brightness) !== null && f !== void 0 ? f : 0, this.contrast = (h = e == null ? void 0 : e.contrast) !== null && h !== void 0 ? h : 1, this.gamma = (S = e == null ? void 0 : e.gamma) !== null && S !== void 0 ? S : 1, this.fillClassificationColors();
  }
  fillClassificationColors() {
    for (let e = 0; e <= 18; e++)
      this.classificationColors[e] === void 0 && (this.classificationColors[e] = {
        base: { r: 1, g: 1, b: 1 },
        show: !0
      });
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingPointsMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    switch (super.onBeforeCompile(e, s), this.style) {
      case PointCloudStyle.None:
        e.vertexShader = Shaders.pointCloud.vertex(!1, !1, !1, this.userIdChannel), e.fragmentShader = Shaders.pointCloud.fragment(this.userIdChannel);
        break;
      case PointCloudStyle.IntensityColoring:
        e.vertexShader = Shaders.pointCloudIntensity.vertex(!0, !1, !1, this.userIdChannel), e.fragmentShader = Shaders.pointCloudIntensity.fragment(this.intensityColors, this.userIdChannel);
        break;
      case PointCloudStyle.ClassificationColoring:
        e.vertexShader = Shaders.pointCloudClassification.vertex(!1, !0, !1, this.userIdChannel), e.fragmentShader = Shaders.pointCloudClassification.fragment(this.classificationColors, this.userIdChannel);
        break;
      case PointCloudStyle.GradientColoring:
        e.vertexShader = Shaders.pointCloudGradient.vertex(!1, !1, !0, this.userIdChannel), e.fragmentShader = Shaders.pointCloudGradient.fragment(this.gradientColors, this.userIdChannel);
        break;
    }
    e.uniforms.useCircularPoints = {
      value: this.shape === PointShape.Circle
    }, e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    }, e.uniforms.minGradient = {
      value: this.minGradientViewSpace
    }, e.uniforms.maxGradient = {
      value: this.maxGradientViewSpace
    }, e.uniforms.brightness = {
      value: this.brightness
    }, e.uniforms.contrast = {
      value: this.contrast
    }, e.uniforms.gamma = {
      value: this.gamma
    };
    const a = s.userData.getWorld().getCamera().getOrthographic();
    e.uniforms.orthoZoom = {
      value: a.getFrustumTop() - a.getFrustumBottom()
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.style}
        ${this.shape}
        ${this.style === PointCloudStyle.ClassificationColoring ? JSON.stringify(this.classificationColors) : ""}
        ${this.style === PointCloudStyle.GradientColoring ? JSON.stringify(this.gradientColors) : ""}
        ${this.style === PointCloudStyle.IntensityColoring ? JSON.stringify(this.intensityColors) : ""}
        ${this.version}
        ${this.userIdChannel}
        `;
  }
}
class PickingSpriteMaterial extends SpriteMaterial {
  constructor(e) {
    var s, o;
    super(e), this.objectId = (s = e == null ? void 0 : e.objectId) !== null && s !== void 0 ? s : 0, this.extraId = (o = e == null ? void 0 : e.extraId) !== null && o !== void 0 ? o : 0;
  }
  setValues(e) {
    return mySetValuesImpl(this, e);
  }
  copy(e) {
    return super.copy(e), e instanceof PickingSpriteMaterial && (this.objectId = e.objectId, this.extraId = e.extraId), this;
  }
  onBeforeCompile(e, s) {
    super.onBeforeCompile(e, s), e.vertexShader = Shaders.sprite.vertex, e.fragmentShader = Shaders.sprite.fragment, e.uniforms.objectId = {
      value: this.objectId
    }, e.uniforms.extraId = {
      value: this.extraId
    };
  }
  customProgramCacheKey() {
    return `:
        ${this.version}
        `;
  }
}
function mySetValuesImpl(r, e) {
  if (e !== void 0)
    for (const s in e) {
      const o = e[s];
      if (o === void 0)
        continue;
      const a = r[s];
      a !== void 0 && (a && a.isColor ? a.set(o) : a && a.isVector3 && o && o.isVector3 ? a.copy(o) : r[s] = o);
    }
}
class BaseObject {
  constructor(e) {
    this.object = e;
  }
  prepare(e, s, o) {
  }
  getPositionCartographic(e) {
    if (typeof e < "u") {
      const s = Ellipsoid$1.WGS_84.cartographicForPosition(this.object.position, new Cartographic$1());
      return e.longitude = s.longitude, e.latitude = s.latitude, e.height = s.height, e;
    } else
      return Ellipsoid$1.WGS_84.cartographicForPosition(this.object.position, new Cartographic$1());
  }
  setPositionCartographic(e) {
    Ellipsoid$1.WGS_84.cartesianForCartographic(new Cartographic$1(e.longitude, e.latitude, e.height), this.object.position);
  }
  getPositionECEF(e) {
    return typeof e > "u" ? {
      x: this.object.position.x,
      y: this.object.position.y,
      z: this.object.position.z
    } : (e.x = this.object.position.x, e.y = this.object.position.y, e.z = this.object.position.z, e);
  }
  setPositionECEF(e) {
    Array.isArray(e) ? (this.object.position.x = e[0], this.object.position.y = e[1], this.object.position.z = e[2]) : (this.object.position.x = e.x, this.object.position.y = e.y, this.object.position.z = e.z);
  }
  getRotation(e) {
    return typeof e > "u" ? {
      x: this.object.quaternion.x,
      y: this.object.quaternion.y,
      z: this.object.quaternion.z,
      w: this.object.quaternion.w
    } : (e.x = this.object.quaternion.x, e.y = this.object.quaternion.y, e.z = this.object.quaternion.z, e.w = this.object.quaternion.w, e);
  }
  setRotation(e) {
    this.object.quaternion.x = e.x, this.object.quaternion.y = e.y, this.object.quaternion.z = e.z, this.object.quaternion.w = e.w;
  }
  static setObjectRotationCartographic(e, s, o) {
    const a = new Cartographic$1(s.longitude, s.latitude, s.height), l = new Quaternion$1().setFromAxisAngle(MathUtils.Y_AXIS.clone().negate(), o ?? 0), u = new Matrix3$1(), c = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(a, u, c);
    const E = new Matrix4().setFromMatrix3(u), d = new Quaternion$1().setFromRotationMatrix(E);
    e.setRotation(d.multiply(l));
  }
  setRotationCartographic(e, s) {
    BaseObject.setObjectRotationCartographic(this, e, s);
  }
  lookAt(e) {
    this.object.lookAt(new Vector3$1(e.x, e.y, e.z));
  }
  setUpVector(e) {
    this.object.up.x = e.x, this.object.up.y = e.y, this.object.up.z = e.z;
  }
  getUpVector(e) {
    return typeof e < "u" ? (e.x = this.object.up.x, e.y = this.object.up.y, e.z = this.object.up.z, e) : {
      x: this.object.up.x,
      y: this.object.up.y,
      z: this.object.up.z
    };
  }
  getEstimatedCenter(e) {
    return this.getPositionECEF(e);
  }
  getBoundingVolume() {
    throw new Error("Method not implemented.");
  }
  getObjectType() {
    throw new Error("Method not implemented.");
  }
  setClippingPlanes(e) {
    if (this.object instanceof Mesh)
      if (this.object.material instanceof Material)
        this.object.material.clippingPlanes = e, this.object.material.needsUpdate = !0;
      else
        throw new Error("Unreachable");
  }
  invalidateMaterials() {
    if (this.object instanceof Mesh)
      if (this.object.material instanceof Material) {
        if (this.object.material.needsUpdate = !0, "map" in this.object.material) {
          const e = this.object.material.map;
          e.needsUpdate = !0;
        }
      } else
        throw new Error("Unreachable");
  }
  get isTransparent() {
    return !1;
  }
  asCameraObject() {
    return null;
  }
  asDrawableObject() {
    return null;
  }
  asMaterialObject() {
    return null;
  }
  asScalableObject() {
    return null;
  }
  asStylableObject() {
    return null;
  }
  asBlendableObject() {
    return null;
  }
  asTileset() {
    return null;
  }
  asIfc() {
    return null;
  }
}
function constructMeshThreeMaterial(r, e, s, o, a, l) {
  var u, c, E, d, f, h, S, R;
  switch (r.type) {
    case "basicOpaque":
      return new PickingMeshBasicMaterial({
        color: new Color(r.color.r, r.color.g, r.color.b),
        vertexColors: (u = r.vertexColors) !== null && u !== void 0 ? u : !1,
        wireframe: (c = r.wireframe) !== null && c !== void 0 ? c : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        objectId: s,
        clippingPlanes: e,
        userIdChannel: o,
        instanceIdAsExtraId: a,
        map: l
      });
    case "basicAlpha":
      return new PickingMeshBasicMaterial({
        color: new Color(r.color.r, r.color.g, r.color.b),
        opacity: r.alpha,
        vertexColors: (E = r.vertexColors) !== null && E !== void 0 ? E : !1,
        wireframe: (d = r.wireframe) !== null && d !== void 0 ? d : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        objectId: s,
        clippingPlanes: e,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        userIdChannel: o,
        instanceIdAsExtraId: a,
        map: l
      });
    case "physicalOpaque":
      return new PickingMeshStandardMaterial({
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        metalness: r.metallic,
        roughness: r.roughness,
        vertexColors: (f = r.vertexColors) !== null && f !== void 0 ? f : !1,
        wireframe: (h = r.wireframe) !== null && h !== void 0 ? h : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        objectId: s,
        clippingPlanes: e,
        userIdChannel: o,
        instanceIdAsExtraId: a,
        map: l
      });
    case "physicalAlpha":
      return new PickingMeshStandardMaterial({
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        opacity: r.alpha,
        metalness: r.metallic,
        roughness: r.roughness,
        vertexColors: (S = r.vertexColors) !== null && S !== void 0 ? S : !1,
        wireframe: (R = r.wireframe) !== null && R !== void 0 ? R : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        objectId: s,
        clippingPlanes: e,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        userIdChannel: o,
        instanceIdAsExtraId: a,
        map: l
      });
    default:
      throw new Error("unreachable");
  }
}
function constructPointsThreeMaterial(r, e, s, o) {
  var a, l, u, c, E, d, f, h;
  switch (r.type) {
    case "basicOpaque":
      return new PickingPointsMaterial({
        color: new Color(r.color.r, r.color.g, r.color.b),
        size: (a = r.pointSize) !== null && a !== void 0 ? a : 1,
        vertexColors: (l = r.vertexColors) !== null && l !== void 0 ? l : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        sizeAttenuation: !1,
        userIdChannel: o
      });
    case "basicAlpha":
      return new PickingPointsMaterial({
        color: new Color(r.color.r, r.color.g, r.color.b),
        opacity: r.alpha,
        size: (u = r.pointSize) !== null && u !== void 0 ? u : 1,
        vertexColors: (c = r.vertexColors) !== null && c !== void 0 ? c : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        sizeAttenuation: !1,
        userIdChannel: o
      });
    case "physicalOpaque":
      return new PickingPointsMaterial({
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        size: (E = r.pointSize) !== null && E !== void 0 ? E : 1,
        vertexColors: (d = r.vertexColors) !== null && d !== void 0 ? d : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        sizeAttenuation: !1,
        userIdChannel: o
      });
    case "physicalAlpha":
      return new PickingPointsMaterial({
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        opacity: r.alpha,
        size: (f = r.pointSize) !== null && f !== void 0 ? f : 1,
        vertexColors: (h = r.vertexColors) !== null && h !== void 0 ? h : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        sizeAttenuation: !1,
        userIdChannel: o
      });
    default:
      throw new Error("unreachable");
  }
}
function constructLineMaterial(r, e, s, o) {
  var a, l, u, c, E, d, f, h;
  switch (r.type) {
    case "basicOpaque":
      return new PickingLineBasicMaterial({
        // @ts-ignore
        color: new Color(r.color.r, r.color.g, r.color.b),
        vertexColors: (a = r.vertexColors) !== null && a !== void 0 ? a : !1,
        wireframe: (l = r.wireframe) !== null && l !== void 0 ? l : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        userIdChannel: o
      });
    case "basicAlpha":
      return new PickingLineBasicMaterial({
        // @ts-ignore
        color: new Color(r.color.r, r.color.g, r.color.b),
        opacity: r.alpha,
        vertexColors: (u = r.vertexColors) !== null && u !== void 0 ? u : !1,
        wireframe: (c = r.wireframe) !== null && c !== void 0 ? c : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        userIdChannel: o
      });
    case "physicalOpaque":
      return new PickingLineBasicMaterial({
        // @ts-ignore
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        vertexColors: (E = r.vertexColors) !== null && E !== void 0 ? E : !1,
        wireframe: (d = r.wireframe) !== null && d !== void 0 ? d : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        userIdChannel: o
      });
    case "physicalAlpha":
      return new PickingLineBasicMaterial({
        // @ts-ignore
        color: new Color(r.baseColor.r, r.baseColor.g, r.baseColor.b),
        opacity: r.alpha,
        vertexColors: (f = r.vertexColors) !== null && f !== void 0 ? f : !1,
        wireframe: (h = r.wireframe) !== null && h !== void 0 ? h : !1,
        side: ourCullingToThreeCulling(r.faceCulling),
        clippingPlanes: e,
        objectId: s,
        transparent: !0,
        forceSinglePass: !0,
        depthWrite: !1,
        userIdChannel: o
      });
    default:
      throw new Error("unreachable");
  }
}
function ourCullingToThreeCulling(r) {
  if (r === void 0)
    return FrontSide;
  switch (r) {
    case FaceCullingMode.BackFace:
      return FrontSide;
    case FaceCullingMode.FrontFace:
      return BackSide;
    case FaceCullingMode.None:
      return DoubleSide;
  }
}
class DrawableObject extends BaseObject {
  constructor() {
    super(...arguments), this.visible = !0, this.pickable = !0, this.renderLayer = RenderLayer.Main;
  }
  getVisible() {
    return this.visible;
  }
  setVisible(e) {
    this.visible = e;
  }
  getPickable() {
    return this.pickable;
  }
  setPickable(e) {
    this.pickable = e;
  }
  asDrawableObject() {
    return this;
  }
  getRenderLayer() {
    return this.renderLayer;
  }
  setRenderLayer(e) {
    this.renderLayer = e;
  }
  dispose() {
    this.object.traverse((e) => {
      (e instanceof Mesh || e instanceof Points || e instanceof LineSegments || e instanceof Sprite) && (e.geometry && e.geometry.dispose(), e.material && (e.material.map && e.material.map.dispose(), e.material.lightMap && e.material.lightMap.dispose(), e.material.bumpMap && e.material.bumpMap.dispose(), e.material.normalMap && e.material.normalMap.dispose(), e.material.specularMap && e.material.specularMap.dispose(), e.material.envMap && e.material.envMap.dispose(), e.material.alphaMap && e.material.alphaMap.dispose(), e.material.aoMap && e.material.aoMap.dispose(), e.material.displacementMap && e.material.displacementMap.dispose(), e.material.emissiveMap && e.material.emissiveMap.dispose(), e.material.gradientMap && e.material.gradientMap.dispose(), e.material.metalnessMap && e.material.metalnessMap.dispose(), e.material.roughnessMap && e.material.roughnessMap.dispose(), e.material.dispose()));
    });
  }
}
class PrimitiveObject extends DrawableObject {
  constructMaterial(e) {
  }
  applyMaterial(e) {
    this.constructMaterial(e);
  }
  getScale(e) {
    return typeof e > "u" ? {
      x: this.object.scale.x,
      y: this.object.scale.y,
      z: this.object.scale.z
    } : (e.x = this.object.scale.x, e.y = this.object.scale.y, e.z = this.object.scale.z, e);
  }
  setScale(e) {
    this.object.scale.x = e.x, this.object.scale.y = e.y, this.object.scale.z = e.z;
  }
  asScalableObject() {
    return this;
  }
  asMaterialObject() {
    return this;
  }
}
class MeshObject extends PrimitiveObject {
  constructor(e, s, o, a, l) {
    super(e), this.object = e, this.type = s, this.id = o, this.mesh = a, this.texture = l;
  }
  getBoundingVolume() {
    if (this.object.updateMatrix(), this.object.geometry.boundingSphere === null)
      throw new Error("Mesh bounding sphere not generated. This is an internal bug.");
    const e = this.object.geometry.boundingSphere.clone().applyMatrix4(this.object.matrix);
    return [e.center.x, e.center.y, e.center.z, e.radius];
  }
  constructMaterial(e) {
    const s = this.object.material, o = this.mesh !== void 0 && this.mesh.pickingUserId !== void 0;
    this.object instanceof Points ? this.object.material = constructPointsThreeMaterial(e, s.clippingPlanes, this.id, o) : this.object instanceof LineSegments || this.object instanceof Line$1 ? this.object.material = constructLineMaterial(e, s.clippingPlanes, this.id, o) : this.object.material = constructMeshThreeMaterial(e, s.clippingPlanes, this.id, o, !1, this.texture);
  }
  getObjectType() {
    return this.type;
  }
  get isTransparent() {
    return this.object.material instanceof Material ? this.object.material.opacity < 1 && this.object.material.transparent : !1;
  }
}
class ObjObject extends DrawableObject {
  constructor(e, s) {
    super(e), this.object = e, this.id = s;
  }
  applyMaterial(e) {
    this.object.traverse((s) => {
      var o;
      if (s instanceof Mesh) {
        const a = s.material;
        a.needsUpdate = !0, a.side = ourCullingToThreeCulling(e.faceCulling), a.wireframe = (o = e.wireframe) !== null && o !== void 0 ? o : !1, e.type === "basicAlpha" || e.type === "physicalAlpha" ? a.opacity = e.alpha : a.opacity = 1, a.opacity < 1 ? a.transparent = !0 : a.transparent = !1;
      }
    });
  }
  getScale(e) {
    return typeof e > "u" ? {
      x: this.object.scale.x,
      y: this.object.scale.y,
      z: this.object.scale.z
    } : (e.x = this.object.scale.x, e.y = this.object.scale.y, e.z = this.object.scale.z, e);
  }
  setScale(e) {
    this.object.scale.x = e.x, this.object.scale.y = e.y, this.object.scale.z = e.z;
  }
  setClippingPlanes(e) {
    this.object.traverse((s) => {
      if (s instanceof Mesh)
        if (Array.isArray(s.material))
          for (const o of s.material)
            o.clippingPlanes = e, o.needsUpdate = !0;
        else
          s.material.clippingPlanes = e, s.material.needsUpdate = !0;
    });
  }
  invalidateMaterials() {
    this.object.traverse((e) => {
      if (e instanceof Mesh)
        if (Array.isArray(e.material))
          for (const s of e.material)
            s.needsUpdate = !0;
        else
          e.material.needsUpdate = !0;
    });
  }
  getEstimatedCenter(e) {
    const s = this.getBoundingVolume();
    return e !== void 0 ? (e.x = s[0], e.y = s[1], e.z = s[2], e) : {
      x: s[0],
      y: s[1],
      z: s[2]
    };
  }
  getBoundingVolume() {
    const e = new Box3$1().setFromObject(this.object), s = new Sphere$1();
    return e.getBoundingSphere(s), [s.center.x, s.center.y, s.center.z, s.radius];
  }
  asMaterialObject() {
    return this;
  }
  getObjectType() {
    return WorldObjectType.ObjObject;
  }
  asScalableObject() {
    return this;
  }
}
class IfcObject extends DrawableObject {
  constructor(e, s) {
    super(e), this.object = e, this.id = s;
  }
  getPhysicalElementIds() {
    return this.object.getPhysicalElementIds();
  }
  getRootElementId() {
    return this.object.getRootElementId();
  }
  getElementIdsOfType(e) {
    return this.object.getElementIdsOfType(e);
  }
  getElementProperties(e) {
    return this.object.getElementProperties(e);
  }
  applyGroupMaterial(e, s) {
    for (const o of e)
      this.object.elementMaterials.set(o, s);
    this.object.refreshGroups();
  }
  resetGroupMaterial(e) {
    for (const s of e)
      this.object.elementMaterials.delete(s);
    this.object.refreshGroups();
  }
  hideGroup(e) {
    for (const s of e)
      this.object.elementMaterials.set(s, null);
    this.object.refreshGroups();
  }
  resetMaterials() {
    this.object.elementMaterials.clear(), this.object.refreshGroups();
  }
  applyMaterial(e) {
    this.object.setGlobalMaterial(e);
  }
  setClippingPlanes(e) {
    this.object.traverse((s) => {
      if (s instanceof Mesh)
        if (Array.isArray(s.material))
          for (const o of s.material)
            o.clippingPlanes = e, o.needsUpdate = !0;
        else
          s.material.clippingPlanes = e, s.material.needsUpdate = !0;
    });
  }
  invalidateMaterials() {
    this.object.traverse((e) => {
      if (e instanceof Mesh)
        if (Array.isArray(e.material))
          for (const s of e.material)
            s.needsUpdate = !0;
        else
          e.material.needsUpdate = !0;
    });
  }
  getEstimatedCenter(e) {
    const s = this.getBoundingVolume();
    return e !== void 0 ? (e.x = s[0], e.y = s[1], e.z = s[2], e) : {
      x: s[0],
      y: s[1],
      z: s[2]
    };
  }
  getBoundingVolume() {
    const e = this.object.getBoundingSphere();
    return [e.center.x, e.center.y, e.center.z, e.radius];
  }
  getObjectType() {
    return WorldObjectType.IfcObject;
  }
  asIfc() {
    return this;
  }
}
class PanoramaObject extends BaseObject {
  constructor(e) {
    super(e), this.visible = !0, this.object = e;
  }
  getOpacity() {
    return this.object.material.uniforms.opacity.value;
  }
  setOpacity(e) {
    const s = this.object.material;
    s.transparent = e < 1, s.uniforms.opacity.value = e;
  }
  getPriority() {
    return this.object.renderOrder;
  }
  setPriority(e) {
    this.object.renderOrder = e;
  }
  getVisible() {
    return this.visible;
  }
  setVisible(e) {
    this.visible = e;
  }
  dispose() {
    this.object.traverse((e) => {
      (e instanceof Mesh || e instanceof Points || e instanceof LineSegments || e instanceof Sprite) && (e.geometry && e.geometry.dispose(), e.material && (e.material.map && e.material.map.dispose(), e.material.lightMap && e.material.lightMap.dispose(), e.material.bumpMap && e.material.bumpMap.dispose(), e.material.normalMap && e.material.normalMap.dispose(), e.material.specularMap && e.material.specularMap.dispose(), e.material.envMap && e.material.envMap.dispose(), e.material.alphaMap && e.material.alphaMap.dispose(), e.material.aoMap && e.material.aoMap.dispose(), e.material.displacementMap && e.material.displacementMap.dispose(), e.material.emissiveMap && e.material.emissiveMap.dispose(), e.material.gradientMap && e.material.gradientMap.dispose(), e.material.metalnessMap && e.material.metalnessMap.dispose(), e.material.roughnessMap && e.material.roughnessMap.dispose(), e.material.dispose()));
    });
  }
}
PanoramaObject.GEOMETRY = geomInit();
function geomInit() {
  const r = new SphereGeometry(500, 60, 40);
  return r.scale(-1, 1, 1), r;
}
class TilesetObject extends DrawableObject {
  constructor(e) {
    super(e), this.object = e;
  }
  get isFrozen() {
    return this.object.isFrozen;
  }
  set isFrozen(e) {
    this.object.isFrozen = e;
  }
  get statistics() {
    return this.object.statistics;
  }
  get attributions() {
    return this.object.attributions;
  }
  get pointChannels() {
    var e, s;
    return (s = (e = this.skandMetadata) === null || e === void 0 ? void 0 : e.pointsExtraChannels) !== null && s !== void 0 ? s : {};
  }
  get maximumScreenSpaceError() {
    return this.object.maximumScreenSpaceError;
  }
  set maximumScreenSpaceError(e) {
    this.object.maximumScreenSpaceError = e;
  }
  get memoryBudget() {
    return this.object.memoryBudget;
  }
  set memoryBudget(e) {
    this.object.memoryBudget = e;
  }
  get pointBudget() {
    return this.object.pointBudget;
  }
  set pointBudget(e) {
    this.object.pointBudget = e;
  }
  applyStyle(e) {
    this.object.applyStyle(e);
  }
  setClippingPlanes(e) {
    this.object.setClippingPlanes(e);
  }
  invalidateMaterials() {
    this.object.invalidateMaterials();
  }
  getBoundingVolume() {
    this.object.updateMatrix();
    const e = this.object.tileset.root.extras.transform, s = new Sphere$1(new Vector3$1(this.object.tileset.root.boundingVolume.sphere[0], this.object.tileset.root.boundingVolume.sphere[1], this.object.tileset.root.boundingVolume.sphere[2]), this.object.tileset.root.boundingVolume.sphere[3]).applyMatrix4(e).applyMatrix4(this.object.matrix);
    return [s.center.x, s.center.y, s.center.z, s.radius];
  }
  getEstimatedCenter(e) {
    var s;
    this.object.updateMatrix();
    const o = this.object.tileset.root.extras.transform;
    let a;
    const l = (s = this.object.tileset.extensions) === null || s === void 0 ? void 0 : s.SKAND_tileset_metadata;
    if (l !== void 0) {
      const u = l;
      u.boundingBox !== void 0 && (a = new Vector3$1(u.boundingBox[0], u.boundingBox[1], u.boundingBox[2]).applyMatrix4(o).applyMatrix4(this.object.matrix));
    }
    if (a === void 0) {
      const u = this.object.tileset.root.boundingVolume.sphere;
      a = new Vector3$1(u[0], u[1], u[2]).applyMatrix4(o).applyMatrix4(this.object.matrix);
    }
    return e !== void 0 ? (e.x = a.x, e.y = a.y, e.z = a.z, e) : a;
  }
  get isTransparent() {
    return this.object.styledTransparent;
  }
  getObjectType() {
    return WorldObjectType.TilesetObject;
  }
  asStylableObject() {
    return this;
  }
  asTileset() {
    return this;
  }
  get skandMetadata() {
    var e;
    const s = (e = this.object.tileset.asset.extensions) === null || e === void 0 ? void 0 : e.SKAND_tileset_metadata;
    if (s !== void 0)
      return s;
  }
}
class OrthographicCamera extends OrthographicCamera$1 {
  constructor(e, s, o, a, l, u, c) {
    super(s, o, a, l, u, c), this._left = -1, this._right = 1, this._bottom = -1, this._top = 1, this.aspect = 1, this._zoom = 1, this.composite = e;
  }
  getProjectionMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.projectionMatrix.elements[s];
      return e;
    } else
      return this.projectionMatrix.clone();
  }
  getInverseProjectionMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.projectionMatrixInverse.elements[s];
      return e;
    } else
      return this.projectionMatrixInverse.clone();
  }
  setZoom(e) {
    this._left /= e, this._right /= e, this._top /= e, this._bottom /= e, this.updateFrustum(), this.updateProjectionMatrix();
  }
  getZoom() {
    return this._zoom;
  }
  getFrustumLeft() {
    return this.left;
  }
  getFrustumRight() {
    return this.right;
  }
  getFrustumTop() {
    return this.top;
  }
  getFrustumBottom() {
    return this.bottom;
  }
  getNearPlaneClipping() {
    return this.near === -this.far;
  }
  setNearPlaneClipping(e) {
    e ? this.near = this.composite.perspective.near : this.near = -this.far, this.updateProjectionMatrix();
  }
  setAspectRatio(e) {
    this.aspect = e, this.updateFrustum(), this.updateProjectionMatrix();
  }
  updateFrustum() {
    this.bottom = this._bottom / this._zoom, this.top = this._top / this._zoom, this.left = this._left * this.aspect / this._zoom, this.right = this._right * this.aspect / this._zoom;
  }
}
class PerspectiveCamera extends PerspectiveCamera$1 {
  constructor(e, s, o, a, l) {
    super(s, o, a, l), this.composite = e;
  }
  getProjectionMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.projectionMatrix.elements[s];
      return e;
    } else
      return this.projectionMatrix.clone();
  }
  getInverseProjectionMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.projectionMatrixInverse.elements[s];
      return e;
    } else
      return this.projectionMatrixInverse.clone();
  }
  setFieldOfView(e) {
    this.fov = e, this.updateProjectionMatrix();
  }
  getFieldOfView() {
    return this.fov;
  }
  setAspectRatio(e) {
    this.aspect = e, this.updateProjectionMatrix();
  }
}
class CompositeCamera extends Camera {
  constructor(e, s, o, a, l) {
    super(), this.focusPoint = new Vector3$1(), this.focusPointInitialized = !1, this.renderer = l, this.perspective = new PerspectiveCamera(this, e, s, o, a), this.orthographic = new OrthographicCamera(this, -1, 1, 1, -1, -Math.min(a, CompositeCamera.ORTHOGRAPHIC_MAX_FAR), Math.min(a, CompositeCamera.ORTHOGRAPHIC_MAX_FAR)), this.currentCamera = this.perspective, this.orthographic.setAspectRatio(s), this.add(this.perspective), this.add(this.orthographic);
  }
  setAspectRatio(e) {
    this.perspective.setAspectRatio(e), this.orthographic.setAspectRatio(e);
  }
  setFocusPoint(e) {
    this.focusPoint.copy(e), this.focusPointInitialized = !0;
  }
  setFocusPointUsingGPUPicking(e) {
    const { position: s, isVoid: o } = this.renderer.pickScreenWorldSpace(e);
    o ? this.setFocusPoint(this.position.clone().add(this.getWorldDirection(new Vector3$1()).multiplyScalar(10))) : this.setFocusPoint(new Vector3$1(s.x, s.y, s.z));
  }
  setFocusPointUsingGPUPickingAroundScreenCenter() {
    const [e, s] = this.renderer.pickClosestNearScreenCenter();
    s < 1 ? this.setFocusPoint(e) : this.setFocusPoint(this.position.clone().add(this.getWorldDirection(new Vector3$1()).multiplyScalar(10)));
  }
  setFocusPointUsingRaycastingBoundingVolumesFromScreenCenter() {
    const e = this.renderer.getSize(), s = this.renderer.raycastScreenBoundingVolumes(new Vector2(e.x / 2, e.y / 2));
    s ? this.setFocusPoint(s) : this.setFocusPoint(this.position.clone().add(this.getWorldDirection(new Vector3$1()).multiplyScalar(10)));
  }
  getFocusPoint() {
    return this.focusPoint.clone();
  }
  recalculatePositionBasedOnZoom() {
    const e = new Plane(), s = new Vector3$1();
    this.getWorldDirection(s), s.negate(), e.setFromNormalAndCoplanarPoint(s, this.focusPoint);
    const o = this.perspective.fov * MathUtils$1.DEG2RAD, l = this.orthographic.getFrustumTop() / Math.tan(o / 2), u = e.projectPoint(this.position, new Vector3$1());
    this.position.copy(u.add(s.multiplyScalar(l)));
  }
  recalculateZoomBasedOnPosition() {
    const e = new Plane(), s = new Vector3$1();
    this.getWorldDirection(s), s.negate(), e.setFromNormalAndCoplanarPoint(s, this.focusPoint);
    const o = this.perspective.fov * MathUtils$1.DEG2RAD, l = e.distanceToPoint(this.position) * Math.tan(o / 2), u = -l, c = u, E = l;
    this.orthographic._left = c, this.orthographic._right = E, this.orthographic._top = l, this.orthographic._bottom = u, this.orthographic._zoom = 1, this.orthographic.updateFrustum(), this.orthographic.updateProjectionMatrix();
  }
  toggleProjectionMode(e) {
    this.getProjectionMode() === CameraProjection.Orthographic ? this.setProjectionMode(CameraProjection.Perspective, e) : this.setProjectionMode(CameraProjection.Orthographic, e);
  }
  setProjectionMode(e, s) {
    this.focusPointInitialized || this.setFocusPointUsingGPUPickingAroundScreenCenter(), e === CameraProjection.Orthographic ? this.currentCamera === this.perspective && (this.recalculateZoomBasedOnPosition(), this.currentCamera = this.orthographic) : this.currentCamera === this.orthographic && (this.recalculatePositionBasedOnZoom(), this.currentCamera = this.perspective);
  }
  getProjectionMode() {
    return this.currentCamera === this.orthographic ? CameraProjection.Orthographic : CameraProjection.Perspective;
  }
  getCurrentCamera() {
    return this.currentCamera;
  }
}
CompositeCamera.ORTHOGRAPHIC_MAX_FAR = 5e4;
class CameraObject extends BaseObject {
  constructor(e, s, o, a, l) {
    const u = new CompositeCamera(e, s, o, a, l);
    super(u), this.object = u;
  }
  load({ position: e, rotation: s, mode: o, left: a, right: l, top: u, bottom: c, zoom: E }) {
    this.setPositionECEF(e), this.setRotation(s), E && (this.object.orthographic._zoom = E), a && (this.object.orthographic._left = a), l && (this.object.orthographic._right = l), u && (this.object.orthographic._top = u), c && (this.object.orthographic._bottom = c), o === CameraProjection.Orthographic ? (this.object.currentCamera = this.object.orthographic, this.object.currentCamera.updateFrustum()) : this.object.currentCamera = this.object.perspective, this.object.currentCamera.updateProjectionMatrix();
  }
  save(e) {
    return e || (e = {}), e.position || (e.position = new Vector3$1()), e.rotation || (e.rotation = new Quaternion$1()), this.getPositionECEF(e.position), this.getRotation(e.rotation), e.mode = this.getProjectionMode(), e.left = this.object.orthographic._left, e.right = this.object.orthographic._right, e.top = this.object.orthographic._top, e.bottom = this.object.orthographic._bottom, e.zoom = this.object.orthographic._zoom, e;
  }
  setProjectionMode(e) {
    this.object.setProjectionMode(e);
  }
  getProjectionMode() {
    return this.object.getProjectionMode();
  }
  getPerspective() {
    return this.object.perspective;
  }
  getOrthographic() {
    return this.object.orthographic;
  }
  setAspectRatio(e) {
    this.object.setAspectRatio(e);
  }
  getAspectRatio() {
    return this.object.perspective.aspect;
  }
  getFarPlane() {
    return this.object.getCurrentCamera().far;
  }
  getNearPlane() {
    return this.object.getCurrentCamera().near;
  }
  getForwardVector(e) {
    const s = new Vector3$1();
    return this.object.getWorldDirection(s), typeof e < "u" ? (e.x = s.x, e.y = s.y, e.z = s.z, e) : {
      x: s.x,
      y: s.y,
      z: s.z
    };
  }
  getProjectionMatrix(e) {
    return this.object.getCurrentCamera().getProjectionMatrix(e);
  }
  getInverseProjectionMatrix(e) {
    return this.object.getCurrentCamera().getInverseProjectionMatrix(e);
  }
  getWorldMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.object.matrixWorld.elements[s];
      return e;
    } else
      return this.object.matrixWorld.clone();
  }
  getLocalMatrix(e) {
    if (typeof e < "u") {
      e.elements.length = 16;
      for (let s = 0; s < e.elements.length; s += 1)
        e.elements[s] = this.object.matrix.elements[s];
      return e;
    } else
      return this.object.matrix.clone();
  }
  getObjectType() {
    return WorldObjectType.CameraObject;
  }
  asCameraObject() {
    return this;
  }
}
function initExtras(r, e, s) {
  var o;
  const a = r;
  a.extras.owner = s;
  const l = [[a.root, ((o = e == null ? void 0 : e.extras.depth) !== null && o !== void 0 ? o : -1) + 1]];
  for (; l.length > 0; ) {
    const [u, c] = l.pop(), E = {
      // The tileset will be the correct type once this function returns
      owner: a,
      // Default to identity matrix
      transform: new Matrix4(),
      // World bounding sphere
      boundingSphere: new Sphere$1(),
      // Live screen space error
      screenSpaceError: 0,
      // Cost to render and keep tile in memory
      cost: {
        geometrySizeInBytes: 0,
        textureSizeInBytes: 0,
        pointCount: 0,
        triangleCount: 0
      },
      // Default to empty content
      content: {},
      // Compute depth in the tree
      depth: c,
      culled: !1,
      cameraDistance: 1 / 0,
      screenCenterDistance: 1 / 0,
      sortKey: 1 / 0,
      terminal: !1
    };
    if (u.extras = E, typeof u.children < "u" && u.children !== null)
      for (const d of u.children)
        l.push([d, c + 1]);
  }
  return r;
}
function isTileset(r) {
  if (r === null || typeof r != "object" || !isAsset(r.asset))
    return !1;
  if (typeof r.properties < "u" && r.properties !== null) {
    if (typeof r.properties != "object")
      return !1;
    for (const e of Object.values(r.properties))
      if (!isProperty(e))
        return !1;
  }
  if (typeof r.geometricError != "number" || !isTile(r.root))
    return !1;
  if (typeof r.extensionsUsed < "u" && r.extensionsUsed !== null) {
    if (!Array.isArray(r.extensionsUsed))
      return !1;
    for (const e of r.extensionsUsed)
      if (typeof e != "string")
        return !1;
  }
  if (typeof r.extensionsRequired < "u" && r.extensionsRequired !== null) {
    if (!Array.isArray(r.extensionsRequired))
      return !1;
    for (const e of r.extensionsRequired)
      if (typeof e != "string")
        return !1;
  }
  return !(typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions) || typeof r.impl < "u" && !isImpl(r.impl));
}
var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.arrayIteratorImpl = function(r) {
  var e = 0;
  return function() {
    return e < r.length ? { done: !1, value: r[e++] } : { done: !0 };
  };
};
$jscomp.arrayIterator = function(r) {
  return { next: $jscomp.arrayIteratorImpl(r) };
};
$jscomp.makeIterator = function(r) {
  var e = typeof Symbol < "u" && Symbol.iterator && r[Symbol.iterator];
  return e ? e.call(r) : $jscomp.arrayIterator(r);
};
$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.ISOLATE_POLYFILLS = !1;
$jscomp.FORCE_POLYFILL_PROMISE = !1;
$jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
$jscomp.getGlobal = function(r) {
  r = [
    typeof globalThis == "object" && globalThis,
    r,
    typeof window == "object" && window,
    typeof self == "object" && self,
    typeof _global == "object" && _global
  ];
  for (var e = 0; e < r.length; ++e) {
    var s = r[e];
    if (s && s.Math == Math)
      return s;
  }
  throw Error("Cannot find global object");
};
$jscomp.global = $jscomp.getGlobal(globalThis);
$jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(r, e, s) {
  return r == Array.prototype || r == Object.prototype || (r[e] = s.value), r;
};
$jscomp.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof Symbol("x") == "symbol";
$jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
$jscomp.polyfills = {};
$jscomp.propertyToPolyfillSymbol = {};
$jscomp.POLYFILL_PREFIX = "$jscp$";
$jscomp.polyfill = function(r, e, s, o) {
  e && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(r, e, s, o) : $jscomp.polyfillUnisolated(r, e, s, o));
};
$jscomp.polyfillUnisolated = function(r, e, s, o) {
  for (s = $jscomp.global, r = r.split("."), o = 0; o < r.length - 1; o++) {
    var a = r[o];
    if (!(a in s))
      return;
    s = s[a];
  }
  r = r[r.length - 1], o = s[r], e = e(o), e != o && e != null && $jscomp.defineProperty(s, r, { configurable: !0, writable: !0, value: e });
};
$jscomp.polyfillIsolated = function(r, e, s, o) {
  var a = r.split(".");
  r = a.length === 1, o = a[0], o = !r && o in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
  for (var l = 0; l < a.length - 1; l++) {
    var u = a[l];
    if (!(u in o))
      return;
    o = o[u];
  }
  a = a[a.length - 1], s = $jscomp.IS_SYMBOL_NATIVE && s === "es6" ? o[a] : null, e = e(s), e != null && (r ? $jscomp.defineProperty($jscomp.polyfills, a, { configurable: !0, writable: !0, value: e }) : e !== s && ($jscomp.propertyToPolyfillSymbol[a] === void 0 && (s = 1e9 * Math.random() >>> 0, $jscomp.propertyToPolyfillSymbol[a] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(a) : $jscomp.POLYFILL_PREFIX + s + "$" + a), $jscomp.defineProperty(o, $jscomp.propertyToPolyfillSymbol[a], {
    configurable: !0,
    writable: !0,
    value: e
  })));
};
$jscomp.polyfill("Promise", function(r) {
  function e() {
    this.batch_ = null;
  }
  function s(u) {
    return u instanceof a ? u : new a(function(c, E) {
      c(u);
    });
  }
  if (r && (!($jscomp.FORCE_POLYFILL_PROMISE || $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION && typeof $jscomp.global.PromiseRejectionEvent > "u") || !$jscomp.global.Promise || $jscomp.global.Promise.toString().indexOf("[native code]") === -1))
    return r;
  e.prototype.asyncExecute = function(u) {
    if (this.batch_ == null) {
      this.batch_ = [];
      var c = this;
      this.asyncExecuteFunction(function() {
        c.executeBatch_();
      });
    }
    this.batch_.push(u);
  };
  var o = $jscomp.global.setTimeout;
  e.prototype.asyncExecuteFunction = function(u) {
    o(u, 0);
  }, e.prototype.executeBatch_ = function() {
    for (; this.batch_ && this.batch_.length; ) {
      var u = this.batch_;
      this.batch_ = [];
      for (var c = 0; c < u.length; ++c) {
        var E = u[c];
        u[c] = null;
        try {
          E();
        } catch (d) {
          this.asyncThrow_(d);
        }
      }
    }
    this.batch_ = null;
  }, e.prototype.asyncThrow_ = function(u) {
    this.asyncExecuteFunction(function() {
      throw u;
    });
  };
  var a = function(u) {
    this.state_ = 0, this.result_ = void 0, this.onSettledCallbacks_ = [], this.isRejectionHandled_ = !1;
    var c = this.createResolveAndReject_();
    try {
      u(c.resolve, c.reject);
    } catch (E) {
      c.reject(E);
    }
  };
  a.prototype.createResolveAndReject_ = function() {
    function u(d) {
      return function(f) {
        E || (E = !0, d.call(c, f));
      };
    }
    var c = this, E = !1;
    return { resolve: u(this.resolveTo_), reject: u(this.reject_) };
  }, a.prototype.resolveTo_ = function(u) {
    if (u === this)
      this.reject_(new TypeError("A Promise cannot resolve to itself"));
    else if (u instanceof a)
      this.settleSameAsPromise_(u);
    else {
      e:
        switch (typeof u) {
          case "object":
            var c = u != null;
            break e;
          case "function":
            c = !0;
            break e;
          default:
            c = !1;
        }
      c ? this.resolveToNonPromiseObj_(u) : this.fulfill_(u);
    }
  }, a.prototype.resolveToNonPromiseObj_ = function(u) {
    var c = void 0;
    try {
      c = u.then;
    } catch (E) {
      this.reject_(E);
      return;
    }
    typeof c == "function" ? this.settleSameAsThenable_(c, u) : this.fulfill_(u);
  }, a.prototype.reject_ = function(u) {
    this.settle_(2, u);
  }, a.prototype.fulfill_ = function(u) {
    this.settle_(1, u);
  }, a.prototype.settle_ = function(u, c) {
    if (this.state_ != 0)
      throw Error("Cannot settle(" + u + ", " + c + "): Promise already settled in state" + this.state_);
    this.state_ = u, this.result_ = c, this.state_ === 2 && this.scheduleUnhandledRejectionCheck_(), this.executeOnSettledCallbacks_();
  }, a.prototype.scheduleUnhandledRejectionCheck_ = function() {
    var u = this;
    o(function() {
      if (u.notifyUnhandledRejection_()) {
        var c = $jscomp.global.console;
        typeof c < "u" && c.error(u.result_);
      }
    }, 1);
  }, a.prototype.notifyUnhandledRejection_ = function() {
    if (this.isRejectionHandled_)
      return !1;
    var u = $jscomp.global.CustomEvent, c = $jscomp.global.Event, E = $jscomp.global.dispatchEvent;
    return typeof E > "u" ? !0 : (typeof u == "function" ? u = new u("unhandledrejection", { cancelable: !0 }) : typeof c == "function" ? u = new c("unhandledrejection", { cancelable: !0 }) : (u = $jscomp.global.document.createEvent("CustomEvent"), u.initCustomEvent("unhandledrejection", !1, !0, u)), u.promise = this, u.reason = this.result_, E(u));
  }, a.prototype.executeOnSettledCallbacks_ = function() {
    if (this.onSettledCallbacks_ != null) {
      for (var u = 0; u < this.onSettledCallbacks_.length; ++u)
        l.asyncExecute(this.onSettledCallbacks_[u]);
      this.onSettledCallbacks_ = null;
    }
  };
  var l = new e();
  return a.prototype.settleSameAsPromise_ = function(u) {
    var c = this.createResolveAndReject_();
    u.callWhenSettled_(c.resolve, c.reject);
  }, a.prototype.settleSameAsThenable_ = function(u, c) {
    var E = this.createResolveAndReject_();
    try {
      u.call(c, E.resolve, E.reject);
    } catch (d) {
      E.reject(d);
    }
  }, a.prototype.then = function(u, c) {
    function E(S, R) {
      return typeof S == "function" ? function(_) {
        try {
          d(S(_));
        } catch (m) {
          f(m);
        }
      } : R;
    }
    var d, f, h = new a(function(S, R) {
      d = S, f = R;
    });
    return this.callWhenSettled_(E(u, d), E(c, f)), h;
  }, a.prototype.catch = function(u) {
    return this.then(void 0, u);
  }, a.prototype.callWhenSettled_ = function(u, c) {
    function E() {
      switch (d.state_) {
        case 1:
          u(d.result_);
          break;
        case 2:
          c(d.result_);
          break;
        default:
          throw Error("Unexpected state: " + d.state_);
      }
    }
    var d = this;
    this.onSettledCallbacks_ == null ? l.asyncExecute(E) : this.onSettledCallbacks_.push(E), this.isRejectionHandled_ = !0;
  }, a.resolve = s, a.reject = function(u) {
    return new a(function(c, E) {
      E(u);
    });
  }, a.race = function(u) {
    return new a(function(c, E) {
      for (var d = $jscomp.makeIterator(u), f = d.next(); !f.done; f = d.next())
        s(f.value).callWhenSettled_(c, E);
    });
  }, a.all = function(u) {
    var c = $jscomp.makeIterator(u), E = c.next();
    return E.done ? s([]) : new a(function(d, f) {
      function h(_) {
        return function(m) {
          S[_] = m, R--, R == 0 && d(S);
        };
      }
      var S = [], R = 0;
      do
        S.push(void 0), R++, s(E.value).callWhenSettled_(h(S.length - 1), f), E = c.next();
      while (!E.done);
    });
  }, a;
}, "es6", "es3");
$jscomp.checkStringArgs = function(r, e, s) {
  if (r == null)
    throw new TypeError("The 'this' value for String.prototype." + s + " must not be null or undefined");
  if (e instanceof RegExp)
    throw new TypeError("First argument to String.prototype." + s + " must not be a regular expression");
  return r + "";
};
$jscomp.polyfill("String.prototype.startsWith", function(r) {
  return r || function(e, s) {
    var o = $jscomp.checkStringArgs(this, e, "startsWith");
    e += "";
    var a = o.length, l = e.length;
    s = Math.max(0, Math.min(s | 0, o.length));
    for (var u = 0; u < l && s < a; )
      if (o[s++] != e[u++])
        return !1;
    return u >= l;
  };
}, "es6", "es3");
$jscomp.polyfill("Array.prototype.copyWithin", function(r) {
  function e(s) {
    return s = Number(s), s === 1 / 0 || s === -1 / 0 ? s : s | 0;
  }
  return r || function(s, o, a) {
    var l = this.length;
    if (s = e(s), o = e(o), a = a === void 0 ? l : e(a), s = 0 > s ? Math.max(l + s, 0) : Math.min(s, l), o = 0 > o ? Math.max(l + o, 0) : Math.min(o, l), a = 0 > a ? Math.max(l + a, 0) : Math.min(a, l), s < o)
      for (; o < a; )
        o in this ? this[s++] = this[o++] : (delete this[s++], o++);
    else
      for (a = Math.min(a, l + o - s), s += a - o; a > o; )
        --a in this ? this[--s] = this[a] : delete this[--s];
    return this;
  };
}, "es6", "es3");
$jscomp.typedArrayCopyWithin = function(r) {
  return r || Array.prototype.copyWithin;
};
$jscomp.polyfill("Int8Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Uint8Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Uint8ClampedArray.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Int16Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Uint16Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Int32Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Uint32Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Float32Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
$jscomp.polyfill("Float64Array.prototype.copyWithin", $jscomp.typedArrayCopyWithin, "es6", "es5");
let DracoDecoderModule$1 = function() {
  var r = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (r = r || __filename), function(e) {
    function s(zt) {
      return Se.locateFile ? Se.locateFile(zt, st) : st + zt;
    }
    function o(zt, fn) {
      zt || c("Assertion failed: " + fn);
    }
    function a(zt, fn, Bn) {
      var or = fn + Bn;
      for (Bn = fn; zt[Bn] && !(Bn >= or); )
        ++Bn;
      if (16 < Bn - fn && zt.subarray && It)
        return It.decode(zt.subarray(fn, Bn));
      for (or = ""; fn < Bn; ) {
        var ss = zt[fn++];
        if (ss & 128) {
          var Xs = zt[fn++] & 63;
          if ((ss & 224) == 192)
            or += String.fromCharCode((ss & 31) << 6 | Xs);
          else {
            var Fo = zt[fn++] & 63;
            ss = (ss & 240) == 224 ? (ss & 15) << 12 | Xs << 6 | Fo : (ss & 7) << 18 | Xs << 12 | Fo << 6 | zt[fn++] & 63, 65536 > ss ? or += String.fromCharCode(ss) : (ss -= 65536, or += String.fromCharCode(55296 | ss >> 10, 56320 | ss & 1023));
          }
        } else
          or += String.fromCharCode(ss);
      }
      return or;
    }
    function l(zt, fn) {
      return zt ? a(hn, zt, fn) : "";
    }
    function u(zt) {
      ht = zt, Se.HEAP8 = Wt = new Int8Array(zt), Se.HEAP16 = new Int16Array(zt), Se.HEAP32 = Vt = new Int32Array(zt), Se.HEAPU8 = hn = new Uint8Array(zt), Se.HEAPU16 = new Uint16Array(zt), Se.HEAPU32 = new Uint32Array(zt), Se.HEAPF32 = new Float32Array(zt), Se.HEAPF64 = new Float64Array(zt);
    }
    function c(zt) {
      throw Se.onAbort && Se.onAbort(zt), zt = "Aborted(" + zt + ")", pt(zt), Cn = !0, zt = new WebAssembly.RuntimeError(zt + ". Build with -s ASSERTIONS=1 for more info."), Ht(zt), zt;
    }
    function E(zt) {
      try {
        if (zt == ir && Jt)
          return new Uint8Array(Jt);
        if (Et)
          return Et(zt);
        throw "both async and sync fetching of the wasm failed";
      } catch (fn) {
        c(fn);
      }
    }
    function d() {
      if (!Jt && (an || Ct)) {
        if (typeof fetch == "function" && !ir.startsWith("file://"))
          return fetch(ir, { credentials: "same-origin" }).then(function(zt) {
            if (!zt.ok)
              throw "failed to load wasm binary file at '" + ir + "'";
            return zt.arrayBuffer();
          }).catch(function() {
            return E(ir);
          });
        if (Ke)
          return new Promise(function(zt, fn) {
            Ke(ir, function(Bn) {
              zt(new Uint8Array(Bn));
            }, fn);
          });
      }
      return Promise.resolve().then(function() {
        return E(ir);
      });
    }
    function f(zt) {
      for (; 0 < zt.length; ) {
        var fn = zt.shift();
        if (typeof fn == "function")
          fn(Se);
        else {
          var Bn = fn.func;
          typeof Bn == "number" ? fn.arg === void 0 ? h(Bn)() : h(Bn)(fn.arg) : Bn(fn.arg === void 0 ? null : fn.arg);
        }
      }
    }
    function h(zt) {
      var fn = er[zt];
      return fn || (zt >= er.length && (er.length = zt + 1), er[zt] = fn = Tn.get(zt)), fn;
    }
    function S(zt) {
      this.excPtr = zt, this.ptr = zt - 16, this.set_type = function(fn) {
        Vt[this.ptr + 4 >> 2] = fn;
      }, this.get_type = function() {
        return Vt[this.ptr + 4 >> 2];
      }, this.set_destructor = function(fn) {
        Vt[this.ptr + 8 >> 2] = fn;
      }, this.get_destructor = function() {
        return Vt[this.ptr + 8 >> 2];
      }, this.set_refcount = function(fn) {
        Vt[this.ptr >> 2] = fn;
      }, this.set_caught = function(fn) {
        Wt[this.ptr + 12 >> 0] = fn ? 1 : 0;
      }, this.get_caught = function() {
        return Wt[this.ptr + 12 >> 0] != 0;
      }, this.set_rethrown = function(fn) {
        Wt[this.ptr + 13 >> 0] = fn ? 1 : 0;
      }, this.get_rethrown = function() {
        return Wt[this.ptr + 13 >> 0] != 0;
      }, this.init = function(fn, Bn) {
        this.set_type(fn), this.set_destructor(Bn), this.set_refcount(0), this.set_caught(!1), this.set_rethrown(!1);
      }, this.add_ref = function() {
        Vt[this.ptr >> 2] += 1;
      }, this.release_ref = function() {
        var fn = Vt[this.ptr >> 2];
        return Vt[this.ptr >> 2] = fn - 1, fn === 1;
      };
    }
    function R(zt) {
      function fn() {
        if (!Ri && (Ri = !0, Se.calledRun = !0, !Cn)) {
          if (xn = !0, f(Nn), xt(Se), Se.onRuntimeInitialized && Se.onRuntimeInitialized(), Se.postRun)
            for (typeof Se.postRun == "function" && (Se.postRun = [Se.postRun]); Se.postRun.length; )
              Dn.unshift(Se.postRun.shift());
          f(Dn);
        }
      }
      if (!(0 < $n)) {
        if (Se.preRun)
          for (typeof Se.preRun == "function" && (Se.preRun = [Se.preRun]); Se.preRun.length; )
            Rn.unshift(Se.preRun.shift());
        f(Rn), 0 < $n || (Se.setStatus ? (Se.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            Se.setStatus("");
          }, 1), fn();
        }, 1)) : fn());
      }
    }
    function _() {
    }
    function m(zt) {
      return (zt || _).__cache__;
    }
    function L(zt, fn) {
      var Bn = m(fn), or = Bn[zt];
      return or || (or = Object.create((fn || _).prototype), or.ptr = zt, Bn[zt] = or);
    }
    function F(zt) {
      if (typeof zt == "string") {
        for (var fn = 0, Bn = 0; Bn < zt.length; ++Bn) {
          var or = zt.charCodeAt(Bn);
          55296 <= or && 57343 >= or && (or = 65536 + ((or & 1023) << 10) | zt.charCodeAt(++Bn) & 1023), 127 >= or ? ++fn : fn = 2047 >= or ? fn + 2 : 65535 >= or ? fn + 3 : fn + 4;
        }
        if (fn = Array(fn + 1), Bn = 0, or = fn.length, 0 < or) {
          or = Bn + or - 1;
          for (var ss = 0; ss < zt.length; ++ss) {
            var Xs = zt.charCodeAt(ss);
            if (55296 <= Xs && 57343 >= Xs) {
              var Fo = zt.charCodeAt(++ss);
              Xs = 65536 + ((Xs & 1023) << 10) | Fo & 1023;
            }
            if (127 >= Xs) {
              if (Bn >= or)
                break;
              fn[Bn++] = Xs;
            } else {
              if (2047 >= Xs) {
                if (Bn + 1 >= or)
                  break;
                fn[Bn++] = 192 | Xs >> 6;
              } else {
                if (65535 >= Xs) {
                  if (Bn + 2 >= or)
                    break;
                  fn[Bn++] = 224 | Xs >> 12;
                } else {
                  if (Bn + 3 >= or)
                    break;
                  fn[Bn++] = 240 | Xs >> 18, fn[Bn++] = 128 | Xs >> 12 & 63;
                }
                fn[Bn++] = 128 | Xs >> 6 & 63;
              }
              fn[Bn++] = 128 | Xs & 63;
            }
          }
          fn[Bn] = 0;
        }
        return zt = ms.alloc(fn, Wt), ms.copy(fn, Wt, zt), zt;
      }
      return zt;
    }
    function W(zt) {
      if (typeof zt == "object") {
        var fn = ms.alloc(zt, Wt);
        return ms.copy(zt, Wt, fn), fn;
      }
      return zt;
    }
    function G() {
      throw "cannot construct a VoidPtr, no constructor in IDL";
    }
    function q() {
      this.ptr = Jn(), m(q)[this.ptr] = this;
    }
    function fe() {
      this.ptr = _r(), m(fe)[this.ptr] = this;
    }
    function _e() {
      this.ptr = Ms(), m(_e)[this.ptr] = this;
    }
    function Le() {
      this.ptr = Ur(), m(Le)[this.ptr] = this;
    }
    function Fe() {
      this.ptr = lr(), m(Fe)[this.ptr] = this;
    }
    function Ee() {
      this.ptr = zn(), m(Ee)[this.ptr] = this;
    }
    function Ge() {
      this.ptr = us(), m(Ge)[this.ptr] = this;
    }
    function ve() {
      this.ptr = Js(), m(ve)[this.ptr] = this;
    }
    function te() {
      this.ptr = ks(), m(te)[this.ptr] = this;
    }
    function ae() {
      throw "cannot construct a Status, no constructor in IDL";
    }
    function v() {
      this.ptr = _t(), m(v)[this.ptr] = this;
    }
    function Te() {
      this.ptr = Ut(), m(Te)[this.ptr] = this;
    }
    function De() {
      this.ptr = Mn(), m(De)[this.ptr] = this;
    }
    function be() {
      this.ptr = Lt(), m(be)[this.ptr] = this;
    }
    function ze() {
      this.ptr = Rr(), m(ze)[this.ptr] = this;
    }
    function ke() {
      this.ptr = jo(), m(ke)[this.ptr] = this;
    }
    function Be() {
      this.ptr = Ps(), m(Be)[this.ptr] = this;
    }
    function Me() {
      this.ptr = xs(), m(Me)[this.ptr] = this;
    }
    function me() {
      this.ptr = Rs(), m(me)[this.ptr] = this;
    }
    e = e || {};
    var Se = typeof e < "u" ? e : {}, xt, Ht;
    Se.ready = new Promise(function(zt, fn) {
      xt = zt, Ht = fn;
    });
    var Bt = !1, ut = !1;
    Se.onRuntimeInitialized = function() {
      Bt = !0, ut && typeof Se.onModuleLoaded == "function" && Se.onModuleLoaded(Se);
    }, Se.onModuleParsed = function() {
      ut = !0, Bt && typeof Se.onModuleLoaded == "function" && Se.onModuleLoaded(Se);
    }, Se.isVersionSupported = function(zt) {
      return typeof zt != "string" ? !1 : (zt = zt.split("."), 2 > zt.length || 3 < zt.length ? !1 : zt[0] == 1 && 0 <= zt[1] && 5 >= zt[1] ? !0 : !(zt[0] != 0 || 10 < zt[1]));
    };
    var Tt = {}, Yt;
    for (Yt in Se)
      Se.hasOwnProperty(Yt) && (Tt[Yt] = Se[Yt]);
    var an = typeof window == "object", Ct = typeof importScripts == "function", st = "", jt, lt;
    if (typeof api$1 == "object" && typeof api$1.versions == "object" && typeof api$1.versions.node == "string") {
      st = Ct ? require("path").dirname(st) + "/" : __dirname + "/";
      var Zt = function(zt, fn) {
        return jt || (jt = require("fs")), lt || (lt = require("path")), zt = lt.normalize(zt), jt.readFileSync(zt, fn ? null : "utf8");
      }, Et = function(zt) {
        return zt = Zt(zt, !0), zt.buffer || (zt = new Uint8Array(zt)), o(zt.buffer), zt;
      }, Ke = function(zt, fn, Bn) {
        jt || (jt = require("fs")), lt || (lt = require("path")), zt = lt.normalize(zt), jt.readFile(zt, function(or, ss) {
          or ? Bn(or) : fn(ss.buffer);
        });
      };
      1 < api$1.argv.length && api$1.argv[1].replace(/\\/g, "/"), api$1.argv.slice(2), Se.inspect = function() {
        return "[Emscripten Module object]";
      };
    } else
      (an || Ct) && (Ct ? st = self.location.href : typeof document < "u" && document.currentScript && (st = document.currentScript.src), r && (st = r), st = st.indexOf("blob:") !== 0 ? st.substr(0, st.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", Zt = function(zt) {
        var fn = new XMLHttpRequest();
        return fn.open("GET", zt, !1), fn.send(null), fn.responseText;
      }, Ct && (Et = function(zt) {
        var fn = new XMLHttpRequest();
        return fn.open("GET", zt, !1), fn.responseType = "arraybuffer", fn.send(null), new Uint8Array(fn.response);
      }), Ke = function(zt, fn, Bn) {
        var or = new XMLHttpRequest();
        or.open("GET", zt, !0), or.responseType = "arraybuffer", or.onload = function() {
          or.status == 200 || or.status == 0 && or.response ? fn(or.response) : Bn();
        }, or.onerror = Bn, or.send(null);
      });
    var $e = Se.print || console.log.bind(console), pt = Se.printErr || console.warn.bind(console);
    for (Yt in Tt)
      Tt.hasOwnProperty(Yt) && (Se[Yt] = Tt[Yt]);
    Tt = null;
    var Jt;
    Se.wasmBinary && (Jt = Se.wasmBinary), typeof WebAssembly != "object" && c("no native wasm support detected");
    var In, Cn = !1, It = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, ht, Wt, hn, Vt, Tn, Rn = [], Nn = [], Dn = [], xn = !1, $n = 0, Kn = null;
    Se.preloadedImages = {}, Se.preloadedAudios = {};
    var ir = "draco_decoder.wasm";
    ir.startsWith("data:application/octet-stream;base64,") || (ir = s(ir));
    var er = [], br = {
      mappings: {},
      buffers: [null, [], []],
      printChar: function(zt, fn) {
        var Bn = br.buffers[zt];
        fn === 0 || fn === 10 ? ((zt === 1 ? $e : pt)(a(Bn, 0)), Bn.length = 0) : Bn.push(fn);
      },
      varargs: void 0,
      get: function() {
        return br.varargs += 4, Vt[br.varargs - 4 >> 2];
      },
      getStr: function(zt) {
        return l(zt);
      },
      get64: function(zt, fn) {
        return zt;
      }
    }, cs = {
      h: function(zt) {
        return ci(zt + 16) + 16;
      },
      g: function(zt, fn, Bn) {
        throw new S(zt).init(fn, Bn), zt;
      },
      a: function() {
        c("");
      },
      d: function(zt, fn, Bn) {
        hn.copyWithin(zt, fn, fn + Bn);
      },
      e: function(zt) {
        var fn = hn.length;
        if (zt >>>= 0, 2147483648 < zt)
          return !1;
        for (var Bn = 1; 4 >= Bn; Bn *= 2) {
          var or = fn * (1 + 0.2 / Bn);
          or = Math.min(or, zt + 100663296);
          var ss = Math, Xs = ss.min;
          or = Math.max(zt, or), 0 < or % 65536 && (or += 65536 - or % 65536), ss = Xs.call(ss, 2147483648, or);
          e: {
            try {
              In.grow(ss - ht.byteLength + 65535 >>> 16), u(In.buffer);
              var Fo = 1;
              break e;
            } catch {
            }
            Fo = void 0;
          }
          if (Fo)
            return !0;
        }
        return !1;
      },
      f: function(zt) {
        return 0;
      },
      c: function(zt, fn, Bn, or, ss) {
      },
      b: function(zt, fn, Bn, or) {
        for (var ss = 0, Xs = 0; Xs < Bn; Xs++) {
          var Fo = Vt[fn >> 2], ji = Vt[fn + 4 >> 2];
          fn += 8;
          for (var zo = 0; zo < ji; zo++)
            br.printChar(zt, hn[Fo + zo]);
          ss += ji;
        }
        return Vt[or >> 2] = ss, 0;
      }
    };
    (function() {
      function zt(ss, Xs) {
        Se.asm = ss.exports, In = Se.asm.i, u(In.buffer), Tn = Se.asm.k, Nn.unshift(Se.asm.j), $n--, Se.monitorRunDependencies && Se.monitorRunDependencies($n), $n == 0 && Kn && (ss = Kn, Kn = null, ss());
      }
      function fn(ss) {
        zt(ss.instance);
      }
      function Bn(ss) {
        return d().then(function(Xs) {
          return WebAssembly.instantiate(Xs, or);
        }).then(function(Xs) {
          return Xs;
        }).then(ss, function(Xs) {
          pt("failed to asynchronously prepare wasm: " + Xs), c(Xs);
        });
      }
      var or = { a: cs };
      if ($n++, Se.monitorRunDependencies && Se.monitorRunDependencies($n), Se.instantiateWasm)
        try {
          return Se.instantiateWasm(or, zt);
        } catch (ss) {
          return pt("Module.instantiateWasm callback failed with error: " + ss), !1;
        }
      return function() {
        return Jt || typeof WebAssembly.instantiateStreaming != "function" || ir.startsWith("data:application/octet-stream;base64,") || ir.startsWith("file://") || typeof fetch != "function" ? Bn(fn) : fetch(ir, { credentials: "same-origin" }).then(function(ss) {
          return WebAssembly.instantiateStreaming(ss, or).then(fn, function(Xs) {
            return pt("wasm streaming compile failed: " + Xs), pt("falling back to ArrayBuffer instantiation"), Bn(fn);
          });
        });
      }().catch(Ht), {};
    })(), Se.___wasm_call_ctors = function() {
      return (Se.___wasm_call_ctors = Se.asm.j).apply(null, arguments);
    };
    var Gn = Se._emscripten_bind_VoidPtr___destroy___0 = function() {
      return (Gn = Se._emscripten_bind_VoidPtr___destroy___0 = Se.asm.l).apply(null, arguments);
    }, Jn = Se._emscripten_bind_DecoderBuffer_DecoderBuffer_0 = function() {
      return (Jn = Se._emscripten_bind_DecoderBuffer_DecoderBuffer_0 = Se.asm.m).apply(null, arguments);
    }, Xn = Se._emscripten_bind_DecoderBuffer_Init_2 = function() {
      return (Xn = Se._emscripten_bind_DecoderBuffer_Init_2 = Se.asm.n).apply(null, arguments);
    }, rr = Se._emscripten_bind_DecoderBuffer___destroy___0 = function() {
      return (rr = Se._emscripten_bind_DecoderBuffer___destroy___0 = Se.asm.o).apply(null, arguments);
    }, _r = Se._emscripten_bind_AttributeTransformData_AttributeTransformData_0 = function() {
      return (_r = Se._emscripten_bind_AttributeTransformData_AttributeTransformData_0 = Se.asm.p).apply(null, arguments);
    }, Ss = Se._emscripten_bind_AttributeTransformData_transform_type_0 = function() {
      return (Ss = Se._emscripten_bind_AttributeTransformData_transform_type_0 = Se.asm.q).apply(null, arguments);
    }, is = Se._emscripten_bind_AttributeTransformData___destroy___0 = function() {
      return (is = Se._emscripten_bind_AttributeTransformData___destroy___0 = Se.asm.r).apply(null, arguments);
    }, Ms = Se._emscripten_bind_GeometryAttribute_GeometryAttribute_0 = function() {
      return (Ms = Se._emscripten_bind_GeometryAttribute_GeometryAttribute_0 = Se.asm.s).apply(null, arguments);
    }, ls = Se._emscripten_bind_GeometryAttribute___destroy___0 = function() {
      return (ls = Se._emscripten_bind_GeometryAttribute___destroy___0 = Se.asm.t).apply(null, arguments);
    }, Ur = Se._emscripten_bind_PointAttribute_PointAttribute_0 = function() {
      return (Ur = Se._emscripten_bind_PointAttribute_PointAttribute_0 = Se.asm.u).apply(null, arguments);
    }, Qr = Se._emscripten_bind_PointAttribute_size_0 = function() {
      return (Qr = Se._emscripten_bind_PointAttribute_size_0 = Se.asm.v).apply(null, arguments);
    }, Fr = Se._emscripten_bind_PointAttribute_GetAttributeTransformData_0 = function() {
      return (Fr = Se._emscripten_bind_PointAttribute_GetAttributeTransformData_0 = Se.asm.w).apply(null, arguments);
    }, Lr = Se._emscripten_bind_PointAttribute_attribute_type_0 = function() {
      return (Lr = Se._emscripten_bind_PointAttribute_attribute_type_0 = Se.asm.x).apply(null, arguments);
    }, Hr = Se._emscripten_bind_PointAttribute_data_type_0 = function() {
      return (Hr = Se._emscripten_bind_PointAttribute_data_type_0 = Se.asm.y).apply(null, arguments);
    }, ns = Se._emscripten_bind_PointAttribute_num_components_0 = function() {
      return (ns = Se._emscripten_bind_PointAttribute_num_components_0 = Se.asm.z).apply(null, arguments);
    }, Ts = Se._emscripten_bind_PointAttribute_normalized_0 = function() {
      return (Ts = Se._emscripten_bind_PointAttribute_normalized_0 = Se.asm.A).apply(null, arguments);
    }, en = Se._emscripten_bind_PointAttribute_byte_stride_0 = function() {
      return (en = Se._emscripten_bind_PointAttribute_byte_stride_0 = Se.asm.B).apply(null, arguments);
    }, to = Se._emscripten_bind_PointAttribute_byte_offset_0 = function() {
      return (to = Se._emscripten_bind_PointAttribute_byte_offset_0 = Se.asm.C).apply(null, arguments);
    }, bs = Se._emscripten_bind_PointAttribute_unique_id_0 = function() {
      return (bs = Se._emscripten_bind_PointAttribute_unique_id_0 = Se.asm.D).apply(null, arguments);
    }, jn = Se._emscripten_bind_PointAttribute___destroy___0 = function() {
      return (jn = Se._emscripten_bind_PointAttribute___destroy___0 = Se.asm.E).apply(null, arguments);
    }, lr = Se._emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0 = function() {
      return (lr = Se._emscripten_bind_AttributeQuantizationTransform_AttributeQuantizationTransform_0 = Se.asm.F).apply(null, arguments);
    }, pr = Se._emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1 = function() {
      return (pr = Se._emscripten_bind_AttributeQuantizationTransform_InitFromAttribute_1 = Se.asm.G).apply(null, arguments);
    }, En = Se._emscripten_bind_AttributeQuantizationTransform_quantization_bits_0 = function() {
      return (En = Se._emscripten_bind_AttributeQuantizationTransform_quantization_bits_0 = Se.asm.H).apply(null, arguments);
    }, qn = Se._emscripten_bind_AttributeQuantizationTransform_min_value_1 = function() {
      return (qn = Se._emscripten_bind_AttributeQuantizationTransform_min_value_1 = Se.asm.I).apply(null, arguments);
    }, Wn = Se._emscripten_bind_AttributeQuantizationTransform_range_0 = function() {
      return (Wn = Se._emscripten_bind_AttributeQuantizationTransform_range_0 = Se.asm.J).apply(null, arguments);
    }, kn = Se._emscripten_bind_AttributeQuantizationTransform___destroy___0 = function() {
      return (kn = Se._emscripten_bind_AttributeQuantizationTransform___destroy___0 = Se.asm.K).apply(null, arguments);
    }, zn = Se._emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0 = function() {
      return (zn = Se._emscripten_bind_AttributeOctahedronTransform_AttributeOctahedronTransform_0 = Se.asm.L).apply(null, arguments);
    }, wr = Se._emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1 = function() {
      return (wr = Se._emscripten_bind_AttributeOctahedronTransform_InitFromAttribute_1 = Se.asm.M).apply(null, arguments);
    }, jr = Se._emscripten_bind_AttributeOctahedronTransform_quantization_bits_0 = function() {
      return (jr = Se._emscripten_bind_AttributeOctahedronTransform_quantization_bits_0 = Se.asm.N).apply(null, arguments);
    }, Vr = Se._emscripten_bind_AttributeOctahedronTransform___destroy___0 = function() {
      return (Vr = Se._emscripten_bind_AttributeOctahedronTransform___destroy___0 = Se.asm.O).apply(null, arguments);
    }, us = Se._emscripten_bind_PointCloud_PointCloud_0 = function() {
      return (us = Se._emscripten_bind_PointCloud_PointCloud_0 = Se.asm.P).apply(null, arguments);
    }, Es = Se._emscripten_bind_PointCloud_num_attributes_0 = function() {
      return (Es = Se._emscripten_bind_PointCloud_num_attributes_0 = Se.asm.Q).apply(null, arguments);
    }, Dr = Se._emscripten_bind_PointCloud_num_points_0 = function() {
      return (Dr = Se._emscripten_bind_PointCloud_num_points_0 = Se.asm.R).apply(null, arguments);
    }, Kr = Se._emscripten_bind_PointCloud___destroy___0 = function() {
      return (Kr = Se._emscripten_bind_PointCloud___destroy___0 = Se.asm.S).apply(null, arguments);
    }, Js = Se._emscripten_bind_Mesh_Mesh_0 = function() {
      return (Js = Se._emscripten_bind_Mesh_Mesh_0 = Se.asm.T).apply(null, arguments);
    }, io = Se._emscripten_bind_Mesh_num_faces_0 = function() {
      return (io = Se._emscripten_bind_Mesh_num_faces_0 = Se.asm.U).apply(null, arguments);
    }, No = Se._emscripten_bind_Mesh_num_attributes_0 = function() {
      return (No = Se._emscripten_bind_Mesh_num_attributes_0 = Se.asm.V).apply(null, arguments);
    }, Ai = Se._emscripten_bind_Mesh_num_points_0 = function() {
      return (Ai = Se._emscripten_bind_Mesh_num_points_0 = Se.asm.W).apply(null, arguments);
    }, go = Se._emscripten_bind_Mesh___destroy___0 = function() {
      return (go = Se._emscripten_bind_Mesh___destroy___0 = Se.asm.X).apply(null, arguments);
    }, ks = Se._emscripten_bind_Metadata_Metadata_0 = function() {
      return (ks = Se._emscripten_bind_Metadata_Metadata_0 = Se.asm.Y).apply(null, arguments);
    }, Ci = Se._emscripten_bind_Metadata___destroy___0 = function() {
      return (Ci = Se._emscripten_bind_Metadata___destroy___0 = Se.asm.Z).apply(null, arguments);
    }, Io = Se._emscripten_bind_Status_code_0 = function() {
      return (Io = Se._emscripten_bind_Status_code_0 = Se.asm._).apply(null, arguments);
    }, Oo = Se._emscripten_bind_Status_ok_0 = function() {
      return (Oo = Se._emscripten_bind_Status_ok_0 = Se.asm.$).apply(null, arguments);
    }, Zs = Se._emscripten_bind_Status_error_msg_0 = function() {
      return (Zs = Se._emscripten_bind_Status_error_msg_0 = Se.asm.aa).apply(null, arguments);
    }, wt = Se._emscripten_bind_Status___destroy___0 = function() {
      return (wt = Se._emscripten_bind_Status___destroy___0 = Se.asm.ba).apply(null, arguments);
    }, _t = Se._emscripten_bind_DracoFloat32Array_DracoFloat32Array_0 = function() {
      return (_t = Se._emscripten_bind_DracoFloat32Array_DracoFloat32Array_0 = Se.asm.ca).apply(null, arguments);
    }, Ve = Se._emscripten_bind_DracoFloat32Array_GetValue_1 = function() {
      return (Ve = Se._emscripten_bind_DracoFloat32Array_GetValue_1 = Se.asm.da).apply(null, arguments);
    }, Ze = Se._emscripten_bind_DracoFloat32Array_size_0 = function() {
      return (Ze = Se._emscripten_bind_DracoFloat32Array_size_0 = Se.asm.ea).apply(null, arguments);
    }, bt = Se._emscripten_bind_DracoFloat32Array___destroy___0 = function() {
      return (bt = Se._emscripten_bind_DracoFloat32Array___destroy___0 = Se.asm.fa).apply(null, arguments);
    }, Ut = Se._emscripten_bind_DracoInt8Array_DracoInt8Array_0 = function() {
      return (Ut = Se._emscripten_bind_DracoInt8Array_DracoInt8Array_0 = Se.asm.ga).apply(null, arguments);
    }, mn = Se._emscripten_bind_DracoInt8Array_GetValue_1 = function() {
      return (mn = Se._emscripten_bind_DracoInt8Array_GetValue_1 = Se.asm.ha).apply(null, arguments);
    }, nn = Se._emscripten_bind_DracoInt8Array_size_0 = function() {
      return (nn = Se._emscripten_bind_DracoInt8Array_size_0 = Se.asm.ia).apply(null, arguments);
    }, Sn = Se._emscripten_bind_DracoInt8Array___destroy___0 = function() {
      return (Sn = Se._emscripten_bind_DracoInt8Array___destroy___0 = Se.asm.ja).apply(null, arguments);
    }, Mn = Se._emscripten_bind_DracoUInt8Array_DracoUInt8Array_0 = function() {
      return (Mn = Se._emscripten_bind_DracoUInt8Array_DracoUInt8Array_0 = Se.asm.ka).apply(null, arguments);
    }, yn = Se._emscripten_bind_DracoUInt8Array_GetValue_1 = function() {
      return (yn = Se._emscripten_bind_DracoUInt8Array_GetValue_1 = Se.asm.la).apply(null, arguments);
    }, Pt = Se._emscripten_bind_DracoUInt8Array_size_0 = function() {
      return (Pt = Se._emscripten_bind_DracoUInt8Array_size_0 = Se.asm.ma).apply(null, arguments);
    }, tr = Se._emscripten_bind_DracoUInt8Array___destroy___0 = function() {
      return (tr = Se._emscripten_bind_DracoUInt8Array___destroy___0 = Se.asm.na).apply(null, arguments);
    }, Lt = Se._emscripten_bind_DracoInt16Array_DracoInt16Array_0 = function() {
      return (Lt = Se._emscripten_bind_DracoInt16Array_DracoInt16Array_0 = Se.asm.oa).apply(null, arguments);
    }, dr = Se._emscripten_bind_DracoInt16Array_GetValue_1 = function() {
      return (dr = Se._emscripten_bind_DracoInt16Array_GetValue_1 = Se.asm.pa).apply(null, arguments);
    }, ur = Se._emscripten_bind_DracoInt16Array_size_0 = function() {
      return (ur = Se._emscripten_bind_DracoInt16Array_size_0 = Se.asm.qa).apply(null, arguments);
    }, gr = Se._emscripten_bind_DracoInt16Array___destroy___0 = function() {
      return (gr = Se._emscripten_bind_DracoInt16Array___destroy___0 = Se.asm.ra).apply(null, arguments);
    }, Rr = Se._emscripten_bind_DracoUInt16Array_DracoUInt16Array_0 = function() {
      return (Rr = Se._emscripten_bind_DracoUInt16Array_DracoUInt16Array_0 = Se.asm.sa).apply(null, arguments);
    }, as = Se._emscripten_bind_DracoUInt16Array_GetValue_1 = function() {
      return (as = Se._emscripten_bind_DracoUInt16Array_GetValue_1 = Se.asm.ta).apply(null, arguments);
    }, hs = Se._emscripten_bind_DracoUInt16Array_size_0 = function() {
      return (hs = Se._emscripten_bind_DracoUInt16Array_size_0 = Se.asm.ua).apply(null, arguments);
    }, Os = Se._emscripten_bind_DracoUInt16Array___destroy___0 = function() {
      return (Os = Se._emscripten_bind_DracoUInt16Array___destroy___0 = Se.asm.va).apply(null, arguments);
    }, jo = Se._emscripten_bind_DracoInt32Array_DracoInt32Array_0 = function() {
      return (jo = Se._emscripten_bind_DracoInt32Array_DracoInt32Array_0 = Se.asm.wa).apply(null, arguments);
    }, po = Se._emscripten_bind_DracoInt32Array_GetValue_1 = function() {
      return (po = Se._emscripten_bind_DracoInt32Array_GetValue_1 = Se.asm.xa).apply(null, arguments);
    }, So = Se._emscripten_bind_DracoInt32Array_size_0 = function() {
      return (So = Se._emscripten_bind_DracoInt32Array_size_0 = Se.asm.ya).apply(null, arguments);
    }, Eo = Se._emscripten_bind_DracoInt32Array___destroy___0 = function() {
      return (Eo = Se._emscripten_bind_DracoInt32Array___destroy___0 = Se.asm.za).apply(null, arguments);
    }, Ps = Se._emscripten_bind_DracoUInt32Array_DracoUInt32Array_0 = function() {
      return (Ps = Se._emscripten_bind_DracoUInt32Array_DracoUInt32Array_0 = Se.asm.Aa).apply(null, arguments);
    }, no = Se._emscripten_bind_DracoUInt32Array_GetValue_1 = function() {
      return (no = Se._emscripten_bind_DracoUInt32Array_GetValue_1 = Se.asm.Ba).apply(null, arguments);
    }, gs = Se._emscripten_bind_DracoUInt32Array_size_0 = function() {
      return (gs = Se._emscripten_bind_DracoUInt32Array_size_0 = Se.asm.Ca).apply(null, arguments);
    }, fo = Se._emscripten_bind_DracoUInt32Array___destroy___0 = function() {
      return (fo = Se._emscripten_bind_DracoUInt32Array___destroy___0 = Se.asm.Da).apply(null, arguments);
    }, xs = Se._emscripten_bind_MetadataQuerier_MetadataQuerier_0 = function() {
      return (xs = Se._emscripten_bind_MetadataQuerier_MetadataQuerier_0 = Se.asm.Ea).apply(null, arguments);
    }, Ir = Se._emscripten_bind_MetadataQuerier_HasEntry_2 = function() {
      return (Ir = Se._emscripten_bind_MetadataQuerier_HasEntry_2 = Se.asm.Fa).apply(null, arguments);
    }, ws = Se._emscripten_bind_MetadataQuerier_GetIntEntry_2 = function() {
      return (ws = Se._emscripten_bind_MetadataQuerier_GetIntEntry_2 = Se.asm.Ga).apply(null, arguments);
    }, fr = Se._emscripten_bind_MetadataQuerier_GetIntEntryArray_3 = function() {
      return (fr = Se._emscripten_bind_MetadataQuerier_GetIntEntryArray_3 = Se.asm.Ha).apply(null, arguments);
    }, Mr = Se._emscripten_bind_MetadataQuerier_GetDoubleEntry_2 = function() {
      return (Mr = Se._emscripten_bind_MetadataQuerier_GetDoubleEntry_2 = Se.asm.Ia).apply(null, arguments);
    }, Nr = Se._emscripten_bind_MetadataQuerier_GetStringEntry_2 = function() {
      return (Nr = Se._emscripten_bind_MetadataQuerier_GetStringEntry_2 = Se.asm.Ja).apply(null, arguments);
    }, ii = Se._emscripten_bind_MetadataQuerier_NumEntries_1 = function() {
      return (ii = Se._emscripten_bind_MetadataQuerier_NumEntries_1 = Se.asm.Ka).apply(null, arguments);
    }, Ro = Se._emscripten_bind_MetadataQuerier_GetEntryName_2 = function() {
      return (Ro = Se._emscripten_bind_MetadataQuerier_GetEntryName_2 = Se.asm.La).apply(null, arguments);
    }, Bo = Se._emscripten_bind_MetadataQuerier___destroy___0 = function() {
      return (Bo = Se._emscripten_bind_MetadataQuerier___destroy___0 = Se.asm.Ma).apply(null, arguments);
    }, Rs = Se._emscripten_bind_Decoder_Decoder_0 = function() {
      return (Rs = Se._emscripten_bind_Decoder_Decoder_0 = Se.asm.Na).apply(null, arguments);
    }, Uo = Se._emscripten_bind_Decoder_DecodeArrayToPointCloud_3 = function() {
      return (Uo = Se._emscripten_bind_Decoder_DecodeArrayToPointCloud_3 = Se.asm.Oa).apply(null, arguments);
    }, xi = Se._emscripten_bind_Decoder_DecodeArrayToMesh_3 = function() {
      return (xi = Se._emscripten_bind_Decoder_DecodeArrayToMesh_3 = Se.asm.Pa).apply(null, arguments);
    }, Vo = Se._emscripten_bind_Decoder_GetAttributeId_2 = function() {
      return (Vo = Se._emscripten_bind_Decoder_GetAttributeId_2 = Se.asm.Qa).apply(null, arguments);
    }, oa = Se._emscripten_bind_Decoder_GetAttributeIdByName_2 = function() {
      return (oa = Se._emscripten_bind_Decoder_GetAttributeIdByName_2 = Se.asm.Ra).apply(null, arguments);
    }, ti = Se._emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3 = function() {
      return (ti = Se._emscripten_bind_Decoder_GetAttributeIdByMetadataEntry_3 = Se.asm.Sa).apply(null, arguments);
    }, Po = Se._emscripten_bind_Decoder_GetAttribute_2 = function() {
      return (Po = Se._emscripten_bind_Decoder_GetAttribute_2 = Se.asm.Ta).apply(null, arguments);
    }, ai = Se._emscripten_bind_Decoder_GetAttributeByUniqueId_2 = function() {
      return (ai = Se._emscripten_bind_Decoder_GetAttributeByUniqueId_2 = Se.asm.Ua).apply(null, arguments);
    }, Wo = Se._emscripten_bind_Decoder_GetMetadata_1 = function() {
      return (Wo = Se._emscripten_bind_Decoder_GetMetadata_1 = Se.asm.Va).apply(null, arguments);
    }, As = Se._emscripten_bind_Decoder_GetAttributeMetadata_2 = function() {
      return (As = Se._emscripten_bind_Decoder_GetAttributeMetadata_2 = Se.asm.Wa).apply(null, arguments);
    }, ro = Se._emscripten_bind_Decoder_GetFaceFromMesh_3 = function() {
      return (ro = Se._emscripten_bind_Decoder_GetFaceFromMesh_3 = Se.asm.Xa).apply(null, arguments);
    }, Mo = Se._emscripten_bind_Decoder_GetTriangleStripsFromMesh_2 = function() {
      return (Mo = Se._emscripten_bind_Decoder_GetTriangleStripsFromMesh_2 = Se.asm.Ya).apply(null, arguments);
    }, vr = Se._emscripten_bind_Decoder_GetTrianglesUInt16Array_3 = function() {
      return (vr = Se._emscripten_bind_Decoder_GetTrianglesUInt16Array_3 = Se.asm.Za).apply(null, arguments);
    }, ts = Se._emscripten_bind_Decoder_GetTrianglesUInt32Array_3 = function() {
      return (ts = Se._emscripten_bind_Decoder_GetTrianglesUInt32Array_3 = Se.asm._a).apply(null, arguments);
    }, kr = Se._emscripten_bind_Decoder_GetAttributeFloat_3 = function() {
      return (kr = Se._emscripten_bind_Decoder_GetAttributeFloat_3 = Se.asm.$a).apply(null, arguments);
    }, Us = Se._emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3 = function() {
      return (Us = Se._emscripten_bind_Decoder_GetAttributeFloatForAllPoints_3 = Se.asm.ab).apply(null, arguments);
    }, ri = Se._emscripten_bind_Decoder_GetAttributeIntForAllPoints_3 = function() {
      return (ri = Se._emscripten_bind_Decoder_GetAttributeIntForAllPoints_3 = Se.asm.bb).apply(null, arguments);
    }, Wi = Se._emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3 = function() {
      return (Wi = Se._emscripten_bind_Decoder_GetAttributeInt8ForAllPoints_3 = Se.asm.cb).apply(null, arguments);
    }, To = Se._emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3 = function() {
      return (To = Se._emscripten_bind_Decoder_GetAttributeUInt8ForAllPoints_3 = Se.asm.db).apply(null, arguments);
    }, ia = Se._emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3 = function() {
      return (ia = Se._emscripten_bind_Decoder_GetAttributeInt16ForAllPoints_3 = Se.asm.eb).apply(null, arguments);
    }, bo = Se._emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3 = function() {
      return (bo = Se._emscripten_bind_Decoder_GetAttributeUInt16ForAllPoints_3 = Se.asm.fb).apply(null, arguments);
    }, Ys = Se._emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3 = function() {
      return (Ys = Se._emscripten_bind_Decoder_GetAttributeInt32ForAllPoints_3 = Se.asm.gb).apply(null, arguments);
    }, Di = Se._emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3 = function() {
      return (Di = Se._emscripten_bind_Decoder_GetAttributeUInt32ForAllPoints_3 = Se.asm.hb).apply(null, arguments);
    }, Yn = Se._emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5 = function() {
      return (Yn = Se._emscripten_bind_Decoder_GetAttributeDataArrayForAllPoints_5 = Se.asm.ib).apply(null, arguments);
    }, Lo = Se._emscripten_bind_Decoder_SkipAttributeTransform_1 = function() {
      return (Lo = Se._emscripten_bind_Decoder_SkipAttributeTransform_1 = Se.asm.jb).apply(null, arguments);
    }, Un = Se._emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1 = function() {
      return (Un = Se._emscripten_bind_Decoder_GetEncodedGeometryType_Deprecated_1 = Se.asm.kb).apply(null, arguments);
    }, so = Se._emscripten_bind_Decoder_DecodeBufferToPointCloud_2 = function() {
      return (so = Se._emscripten_bind_Decoder_DecodeBufferToPointCloud_2 = Se.asm.lb).apply(null, arguments);
    }, rs = Se._emscripten_bind_Decoder_DecodeBufferToMesh_2 = function() {
      return (rs = Se._emscripten_bind_Decoder_DecodeBufferToMesh_2 = Se.asm.mb).apply(null, arguments);
    }, hi = Se._emscripten_bind_Decoder___destroy___0 = function() {
      return (hi = Se._emscripten_bind_Decoder___destroy___0 = Se.asm.nb).apply(null, arguments);
    }, Zo = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM = function() {
      return (Zo = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_INVALID_TRANSFORM = Se.asm.ob).apply(null, arguments);
    }, li = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM = function() {
      return (li = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_NO_TRANSFORM = Se.asm.pb).apply(null, arguments);
    }, ei = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM = function() {
      return (ei = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_QUANTIZATION_TRANSFORM = Se.asm.qb).apply(null, arguments);
    }, Or = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM = function() {
      return (Or = Se._emscripten_enum_draco_AttributeTransformType_ATTRIBUTE_OCTAHEDRON_TRANSFORM = Se.asm.rb).apply(null, arguments);
    }, ui = Se._emscripten_enum_draco_GeometryAttribute_Type_INVALID = function() {
      return (ui = Se._emscripten_enum_draco_GeometryAttribute_Type_INVALID = Se.asm.sb).apply(null, arguments);
    }, _s = Se._emscripten_enum_draco_GeometryAttribute_Type_POSITION = function() {
      return (_s = Se._emscripten_enum_draco_GeometryAttribute_Type_POSITION = Se.asm.tb).apply(null, arguments);
    }, xo = Se._emscripten_enum_draco_GeometryAttribute_Type_NORMAL = function() {
      return (xo = Se._emscripten_enum_draco_GeometryAttribute_Type_NORMAL = Se.asm.ub).apply(null, arguments);
    }, aa = Se._emscripten_enum_draco_GeometryAttribute_Type_COLOR = function() {
      return (aa = Se._emscripten_enum_draco_GeometryAttribute_Type_COLOR = Se.asm.vb).apply(null, arguments);
    }, oo = Se._emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD = function() {
      return (oo = Se._emscripten_enum_draco_GeometryAttribute_Type_TEX_COORD = Se.asm.wb).apply(null, arguments);
    }, vs = Se._emscripten_enum_draco_GeometryAttribute_Type_GENERIC = function() {
      return (vs = Se._emscripten_enum_draco_GeometryAttribute_Type_GENERIC = Se.asm.xb).apply(null, arguments);
    }, yi = Se._emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE = function() {
      return (yi = Se._emscripten_enum_draco_EncodedGeometryType_INVALID_GEOMETRY_TYPE = Se.asm.yb).apply(null, arguments);
    }, $r = Se._emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD = function() {
      return ($r = Se._emscripten_enum_draco_EncodedGeometryType_POINT_CLOUD = Se.asm.zb).apply(null, arguments);
    }, ki = Se._emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH = function() {
      return (ki = Se._emscripten_enum_draco_EncodedGeometryType_TRIANGULAR_MESH = Se.asm.Ab).apply(null, arguments);
    }, ds = Se._emscripten_enum_draco_DataType_DT_INVALID = function() {
      return (ds = Se._emscripten_enum_draco_DataType_DT_INVALID = Se.asm.Bb).apply(null, arguments);
    }, Ls = Se._emscripten_enum_draco_DataType_DT_INT8 = function() {
      return (Ls = Se._emscripten_enum_draco_DataType_DT_INT8 = Se.asm.Cb).apply(null, arguments);
    }, Co = Se._emscripten_enum_draco_DataType_DT_UINT8 = function() {
      return (Co = Se._emscripten_enum_draco_DataType_DT_UINT8 = Se.asm.Db).apply(null, arguments);
    }, ps = Se._emscripten_enum_draco_DataType_DT_INT16 = function() {
      return (ps = Se._emscripten_enum_draco_DataType_DT_INT16 = Se.asm.Eb).apply(null, arguments);
    }, Tr = Se._emscripten_enum_draco_DataType_DT_UINT16 = function() {
      return (Tr = Se._emscripten_enum_draco_DataType_DT_UINT16 = Se.asm.Fb).apply(null, arguments);
    }, ao = Se._emscripten_enum_draco_DataType_DT_INT32 = function() {
      return (ao = Se._emscripten_enum_draco_DataType_DT_INT32 = Se.asm.Gb).apply(null, arguments);
    }, Gt = Se._emscripten_enum_draco_DataType_DT_UINT32 = function() {
      return (Gt = Se._emscripten_enum_draco_DataType_DT_UINT32 = Se.asm.Hb).apply(null, arguments);
    }, sr = Se._emscripten_enum_draco_DataType_DT_INT64 = function() {
      return (sr = Se._emscripten_enum_draco_DataType_DT_INT64 = Se.asm.Ib).apply(null, arguments);
    }, vt = Se._emscripten_enum_draco_DataType_DT_UINT64 = function() {
      return (vt = Se._emscripten_enum_draco_DataType_DT_UINT64 = Se.asm.Jb).apply(null, arguments);
    }, Jr = Se._emscripten_enum_draco_DataType_DT_FLOAT32 = function() {
      return (Jr = Se._emscripten_enum_draco_DataType_DT_FLOAT32 = Se.asm.Kb).apply(null, arguments);
    }, Qs = Se._emscripten_enum_draco_DataType_DT_FLOAT64 = function() {
      return (Qs = Se._emscripten_enum_draco_DataType_DT_FLOAT64 = Se.asm.Lb).apply(null, arguments);
    }, Ds = Se._emscripten_enum_draco_DataType_DT_BOOL = function() {
      return (Ds = Se._emscripten_enum_draco_DataType_DT_BOOL = Se.asm.Mb).apply(null, arguments);
    }, Hs = Se._emscripten_enum_draco_DataType_DT_TYPES_COUNT = function() {
      return (Hs = Se._emscripten_enum_draco_DataType_DT_TYPES_COUNT = Se.asm.Nb).apply(null, arguments);
    }, Xr = Se._emscripten_enum_draco_StatusCode_OK = function() {
      return (Xr = Se._emscripten_enum_draco_StatusCode_OK = Se.asm.Ob).apply(null, arguments);
    }, bi = Se._emscripten_enum_draco_StatusCode_DRACO_ERROR = function() {
      return (bi = Se._emscripten_enum_draco_StatusCode_DRACO_ERROR = Se.asm.Pb).apply(null, arguments);
    }, rn = Se._emscripten_enum_draco_StatusCode_IO_ERROR = function() {
      return (rn = Se._emscripten_enum_draco_StatusCode_IO_ERROR = Se.asm.Qb).apply(null, arguments);
    }, mo = Se._emscripten_enum_draco_StatusCode_INVALID_PARAMETER = function() {
      return (mo = Se._emscripten_enum_draco_StatusCode_INVALID_PARAMETER = Se.asm.Rb).apply(null, arguments);
    }, Gi = Se._emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION = function() {
      return (Gi = Se._emscripten_enum_draco_StatusCode_UNSUPPORTED_VERSION = Se.asm.Sb).apply(null, arguments);
    }, yo = Se._emscripten_enum_draco_StatusCode_UNKNOWN_VERSION = function() {
      return (yo = Se._emscripten_enum_draco_StatusCode_UNKNOWN_VERSION = Se.asm.Tb).apply(null, arguments);
    }, ci = Se._malloc = function() {
      return (ci = Se._malloc = Se.asm.Ub).apply(null, arguments);
    };
    Se._free = function() {
      return (Se._free = Se.asm.Vb).apply(null, arguments);
    };
    var Ri;
    if (Kn = function zt() {
      Ri || R(), Ri || (Kn = zt);
    }, Se.run = R, Se.preInit)
      for (typeof Se.preInit == "function" && (Se.preInit = [Se.preInit]); 0 < Se.preInit.length; )
        Se.preInit.pop()();
    R(), _.prototype = Object.create(_.prototype), _.prototype.constructor = _, _.prototype.__class__ = _, _.__cache__ = {}, Se.WrapperObject = _, Se.getCache = m, Se.wrapPointer = L, Se.castObject = function(zt, fn) {
      return L(zt.ptr, fn);
    }, Se.NULL = L(0), Se.destroy = function(zt) {
      if (!zt.__destroy__)
        throw "Error: Cannot destroy object. (Did you create it yourself?)";
      zt.__destroy__(), delete m(zt.__class__)[zt.ptr];
    }, Se.compare = function(zt, fn) {
      return zt.ptr === fn.ptr;
    }, Se.getPointer = function(zt) {
      return zt.ptr;
    }, Se.getClass = function(zt) {
      return zt.__class__;
    };
    var ms = {
      buffer: 0,
      size: 0,
      pos: 0,
      temps: [],
      needed: 0,
      prepare: function() {
        if (ms.needed) {
          for (var zt = 0; zt < ms.temps.length; zt++)
            Se._free(ms.temps[zt]);
          ms.temps.length = 0, Se._free(ms.buffer), ms.buffer = 0, ms.size += ms.needed, ms.needed = 0;
        }
        ms.buffer || (ms.size += 128, ms.buffer = Se._malloc(ms.size), o(ms.buffer)), ms.pos = 0;
      },
      alloc: function(zt, fn) {
        return o(ms.buffer), zt = zt.length * fn.BYTES_PER_ELEMENT, zt = zt + 7 & -8, ms.pos + zt >= ms.size ? (o(0 < zt), ms.needed += zt, fn = Se._malloc(zt), ms.temps.push(fn)) : (fn = ms.buffer + ms.pos, ms.pos += zt), fn;
      },
      copy: function(zt, fn, Bn) {
        switch (Bn >>>= 0, fn.BYTES_PER_ELEMENT) {
          case 2:
            Bn >>>= 1;
            break;
          case 4:
            Bn >>>= 2;
            break;
          case 8:
            Bn >>>= 3;
        }
        for (var or = 0; or < zt.length; or++)
          fn[Bn + or] = zt[or];
      }
    };
    return G.prototype = Object.create(_.prototype), G.prototype.constructor = G, G.prototype.__class__ = G, G.__cache__ = {}, Se.VoidPtr = G, G.prototype.__destroy__ = G.prototype.__destroy__ = function() {
      Gn(this.ptr);
    }, q.prototype = Object.create(_.prototype), q.prototype.constructor = q, q.prototype.__class__ = q, q.__cache__ = {}, Se.DecoderBuffer = q, q.prototype.Init = q.prototype.Init = function(zt, fn) {
      var Bn = this.ptr;
      ms.prepare(), typeof zt == "object" && (zt = W(zt)), fn && typeof fn == "object" && (fn = fn.ptr), Xn(Bn, zt, fn);
    }, q.prototype.__destroy__ = q.prototype.__destroy__ = function() {
      rr(this.ptr);
    }, fe.prototype = Object.create(_.prototype), fe.prototype.constructor = fe, fe.prototype.__class__ = fe, fe.__cache__ = {}, Se.AttributeTransformData = fe, fe.prototype.transform_type = fe.prototype.transform_type = function() {
      return Ss(this.ptr);
    }, fe.prototype.__destroy__ = fe.prototype.__destroy__ = function() {
      is(this.ptr);
    }, _e.prototype = Object.create(_.prototype), _e.prototype.constructor = _e, _e.prototype.__class__ = _e, _e.__cache__ = {}, Se.GeometryAttribute = _e, _e.prototype.__destroy__ = _e.prototype.__destroy__ = function() {
      ls(this.ptr);
    }, Le.prototype = Object.create(_.prototype), Le.prototype.constructor = Le, Le.prototype.__class__ = Le, Le.__cache__ = {}, Se.PointAttribute = Le, Le.prototype.size = Le.prototype.size = function() {
      return Qr(this.ptr);
    }, Le.prototype.GetAttributeTransformData = Le.prototype.GetAttributeTransformData = function() {
      return L(Fr(this.ptr), fe);
    }, Le.prototype.attribute_type = Le.prototype.attribute_type = function() {
      return Lr(this.ptr);
    }, Le.prototype.data_type = Le.prototype.data_type = function() {
      return Hr(this.ptr);
    }, Le.prototype.num_components = Le.prototype.num_components = function() {
      return ns(this.ptr);
    }, Le.prototype.normalized = Le.prototype.normalized = function() {
      return !!Ts(this.ptr);
    }, Le.prototype.byte_stride = Le.prototype.byte_stride = function() {
      return en(this.ptr);
    }, Le.prototype.byte_offset = Le.prototype.byte_offset = function() {
      return to(this.ptr);
    }, Le.prototype.unique_id = Le.prototype.unique_id = function() {
      return bs(this.ptr);
    }, Le.prototype.__destroy__ = Le.prototype.__destroy__ = function() {
      jn(this.ptr);
    }, Fe.prototype = Object.create(_.prototype), Fe.prototype.constructor = Fe, Fe.prototype.__class__ = Fe, Fe.__cache__ = {}, Se.AttributeQuantizationTransform = Fe, Fe.prototype.InitFromAttribute = Fe.prototype.InitFromAttribute = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), !!pr(fn, zt);
    }, Fe.prototype.quantization_bits = Fe.prototype.quantization_bits = function() {
      return En(this.ptr);
    }, Fe.prototype.min_value = Fe.prototype.min_value = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), qn(fn, zt);
    }, Fe.prototype.range = Fe.prototype.range = function() {
      return Wn(this.ptr);
    }, Fe.prototype.__destroy__ = Fe.prototype.__destroy__ = function() {
      kn(this.ptr);
    }, Ee.prototype = Object.create(_.prototype), Ee.prototype.constructor = Ee, Ee.prototype.__class__ = Ee, Ee.__cache__ = {}, Se.AttributeOctahedronTransform = Ee, Ee.prototype.InitFromAttribute = Ee.prototype.InitFromAttribute = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), !!wr(fn, zt);
    }, Ee.prototype.quantization_bits = Ee.prototype.quantization_bits = function() {
      return jr(this.ptr);
    }, Ee.prototype.__destroy__ = Ee.prototype.__destroy__ = function() {
      Vr(this.ptr);
    }, Ge.prototype = Object.create(_.prototype), Ge.prototype.constructor = Ge, Ge.prototype.__class__ = Ge, Ge.__cache__ = {}, Se.PointCloud = Ge, Ge.prototype.num_attributes = Ge.prototype.num_attributes = function() {
      return Es(this.ptr);
    }, Ge.prototype.num_points = Ge.prototype.num_points = function() {
      return Dr(this.ptr);
    }, Ge.prototype.__destroy__ = Ge.prototype.__destroy__ = function() {
      Kr(this.ptr);
    }, ve.prototype = Object.create(_.prototype), ve.prototype.constructor = ve, ve.prototype.__class__ = ve, ve.__cache__ = {}, Se.Mesh = ve, ve.prototype.num_faces = ve.prototype.num_faces = function() {
      return io(this.ptr);
    }, ve.prototype.num_attributes = ve.prototype.num_attributes = function() {
      return No(this.ptr);
    }, ve.prototype.num_points = ve.prototype.num_points = function() {
      return Ai(this.ptr);
    }, ve.prototype.__destroy__ = ve.prototype.__destroy__ = function() {
      go(this.ptr);
    }, te.prototype = Object.create(_.prototype), te.prototype.constructor = te, te.prototype.__class__ = te, te.__cache__ = {}, Se.Metadata = te, te.prototype.__destroy__ = te.prototype.__destroy__ = function() {
      Ci(this.ptr);
    }, ae.prototype = Object.create(_.prototype), ae.prototype.constructor = ae, ae.prototype.__class__ = ae, ae.__cache__ = {}, Se.Status = ae, ae.prototype.code = ae.prototype.code = function() {
      return Io(this.ptr);
    }, ae.prototype.ok = ae.prototype.ok = function() {
      return !!Oo(this.ptr);
    }, ae.prototype.error_msg = ae.prototype.error_msg = function() {
      return l(Zs(this.ptr));
    }, ae.prototype.__destroy__ = ae.prototype.__destroy__ = function() {
      wt(this.ptr);
    }, v.prototype = Object.create(_.prototype), v.prototype.constructor = v, v.prototype.__class__ = v, v.__cache__ = {}, Se.DracoFloat32Array = v, v.prototype.GetValue = v.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), Ve(fn, zt);
    }, v.prototype.size = v.prototype.size = function() {
      return Ze(this.ptr);
    }, v.prototype.__destroy__ = v.prototype.__destroy__ = function() {
      bt(this.ptr);
    }, Te.prototype = Object.create(_.prototype), Te.prototype.constructor = Te, Te.prototype.__class__ = Te, Te.__cache__ = {}, Se.DracoInt8Array = Te, Te.prototype.GetValue = Te.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), mn(fn, zt);
    }, Te.prototype.size = Te.prototype.size = function() {
      return nn(this.ptr);
    }, Te.prototype.__destroy__ = Te.prototype.__destroy__ = function() {
      Sn(this.ptr);
    }, De.prototype = Object.create(_.prototype), De.prototype.constructor = De, De.prototype.__class__ = De, De.__cache__ = {}, Se.DracoUInt8Array = De, De.prototype.GetValue = De.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), yn(fn, zt);
    }, De.prototype.size = De.prototype.size = function() {
      return Pt(this.ptr);
    }, De.prototype.__destroy__ = De.prototype.__destroy__ = function() {
      tr(this.ptr);
    }, be.prototype = Object.create(_.prototype), be.prototype.constructor = be, be.prototype.__class__ = be, be.__cache__ = {}, Se.DracoInt16Array = be, be.prototype.GetValue = be.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), dr(fn, zt);
    }, be.prototype.size = be.prototype.size = function() {
      return ur(this.ptr);
    }, be.prototype.__destroy__ = be.prototype.__destroy__ = function() {
      gr(this.ptr);
    }, ze.prototype = Object.create(_.prototype), ze.prototype.constructor = ze, ze.prototype.__class__ = ze, ze.__cache__ = {}, Se.DracoUInt16Array = ze, ze.prototype.GetValue = ze.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), as(fn, zt);
    }, ze.prototype.size = ze.prototype.size = function() {
      return hs(this.ptr);
    }, ze.prototype.__destroy__ = ze.prototype.__destroy__ = function() {
      Os(this.ptr);
    }, ke.prototype = Object.create(_.prototype), ke.prototype.constructor = ke, ke.prototype.__class__ = ke, ke.__cache__ = {}, Se.DracoInt32Array = ke, ke.prototype.GetValue = ke.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), po(fn, zt);
    }, ke.prototype.size = ke.prototype.size = function() {
      return So(this.ptr);
    }, ke.prototype.__destroy__ = ke.prototype.__destroy__ = function() {
      Eo(this.ptr);
    }, Be.prototype = Object.create(_.prototype), Be.prototype.constructor = Be, Be.prototype.__class__ = Be, Be.__cache__ = {}, Se.DracoUInt32Array = Be, Be.prototype.GetValue = Be.prototype.GetValue = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), no(fn, zt);
    }, Be.prototype.size = Be.prototype.size = function() {
      return gs(this.ptr);
    }, Be.prototype.__destroy__ = Be.prototype.__destroy__ = function() {
      fo(this.ptr);
    }, Me.prototype = Object.create(_.prototype), Me.prototype.constructor = Me, Me.prototype.__class__ = Me, Me.__cache__ = {}, Se.MetadataQuerier = Me, Me.prototype.HasEntry = Me.prototype.HasEntry = function(zt, fn) {
      var Bn = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), !!Ir(Bn, zt, fn);
    }, Me.prototype.GetIntEntry = Me.prototype.GetIntEntry = function(zt, fn) {
      var Bn = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), ws(Bn, zt, fn);
    }, Me.prototype.GetIntEntryArray = Me.prototype.GetIntEntryArray = function(zt, fn, Bn) {
      var or = this.ptr;
      ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), Bn && typeof Bn == "object" && (Bn = Bn.ptr), fr(or, zt, fn, Bn);
    }, Me.prototype.GetDoubleEntry = Me.prototype.GetDoubleEntry = function(zt, fn) {
      var Bn = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), Mr(Bn, zt, fn);
    }, Me.prototype.GetStringEntry = Me.prototype.GetStringEntry = function(zt, fn) {
      var Bn = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), l(Nr(Bn, zt, fn));
    }, Me.prototype.NumEntries = Me.prototype.NumEntries = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), ii(fn, zt);
    }, Me.prototype.GetEntryName = Me.prototype.GetEntryName = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), l(Ro(Bn, zt, fn));
    }, Me.prototype.__destroy__ = Me.prototype.__destroy__ = function() {
      Bo(this.ptr);
    }, me.prototype = Object.create(_.prototype), me.prototype.constructor = me, me.prototype.__class__ = me, me.__cache__ = {}, Se.Decoder = me, me.prototype.DecodeArrayToPointCloud = me.prototype.DecodeArrayToPointCloud = function(zt, fn, Bn) {
      var or = this.ptr;
      return ms.prepare(), typeof zt == "object" && (zt = W(zt)), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), L(Uo(or, zt, fn, Bn), ae);
    }, me.prototype.DecodeArrayToMesh = me.prototype.DecodeArrayToMesh = function(zt, fn, Bn) {
      var or = this.ptr;
      return ms.prepare(), typeof zt == "object" && (zt = W(zt)), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), L(xi(or, zt, fn, Bn), ae);
    }, me.prototype.GetAttributeId = me.prototype.GetAttributeId = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Vo(Bn, zt, fn);
    }, me.prototype.GetAttributeIdByName = me.prototype.GetAttributeIdByName = function(zt, fn) {
      var Bn = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), oa(Bn, zt, fn);
    }, me.prototype.GetAttributeIdByMetadataEntry = me.prototype.GetAttributeIdByMetadataEntry = function(zt, fn, Bn) {
      var or = this.ptr;
      return ms.prepare(), zt && typeof zt == "object" && (zt = zt.ptr), fn = fn && typeof fn == "object" ? fn.ptr : F(fn), Bn = Bn && typeof Bn == "object" ? Bn.ptr : F(Bn), ti(or, zt, fn, Bn);
    }, me.prototype.GetAttribute = me.prototype.GetAttribute = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), L(Po(Bn, zt, fn), Le);
    }, me.prototype.GetAttributeByUniqueId = me.prototype.GetAttributeByUniqueId = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), L(ai(Bn, zt, fn), Le);
    }, me.prototype.GetMetadata = me.prototype.GetMetadata = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), L(Wo(fn, zt), te);
    }, me.prototype.GetAttributeMetadata = me.prototype.GetAttributeMetadata = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), L(As(Bn, zt, fn), te);
    }, me.prototype.GetFaceFromMesh = me.prototype.GetFaceFromMesh = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!ro(or, zt, fn, Bn);
    }, me.prototype.GetTriangleStripsFromMesh = me.prototype.GetTriangleStripsFromMesh = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Mo(Bn, zt, fn);
    }, me.prototype.GetTrianglesUInt16Array = me.prototype.GetTrianglesUInt16Array = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!vr(or, zt, fn, Bn);
    }, me.prototype.GetTrianglesUInt32Array = me.prototype.GetTrianglesUInt32Array = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!ts(or, zt, fn, Bn);
    }, me.prototype.GetAttributeFloat = me.prototype.GetAttributeFloat = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!kr(or, zt, fn, Bn);
    }, me.prototype.GetAttributeFloatForAllPoints = me.prototype.GetAttributeFloatForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!Us(or, zt, fn, Bn);
    }, me.prototype.GetAttributeIntForAllPoints = me.prototype.GetAttributeIntForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!ri(or, zt, fn, Bn);
    }, me.prototype.GetAttributeInt8ForAllPoints = me.prototype.GetAttributeInt8ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!Wi(or, zt, fn, Bn);
    }, me.prototype.GetAttributeUInt8ForAllPoints = me.prototype.GetAttributeUInt8ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!To(or, zt, fn, Bn);
    }, me.prototype.GetAttributeInt16ForAllPoints = me.prototype.GetAttributeInt16ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!ia(or, zt, fn, Bn);
    }, me.prototype.GetAttributeUInt16ForAllPoints = me.prototype.GetAttributeUInt16ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!bo(or, zt, fn, Bn);
    }, me.prototype.GetAttributeInt32ForAllPoints = me.prototype.GetAttributeInt32ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!Ys(or, zt, fn, Bn);
    }, me.prototype.GetAttributeUInt32ForAllPoints = me.prototype.GetAttributeUInt32ForAllPoints = function(zt, fn, Bn) {
      var or = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), !!Di(or, zt, fn, Bn);
    }, me.prototype.GetAttributeDataArrayForAllPoints = me.prototype.GetAttributeDataArrayForAllPoints = function(zt, fn, Bn, or, ss) {
      var Xs = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), Bn && typeof Bn == "object" && (Bn = Bn.ptr), or && typeof or == "object" && (or = or.ptr), ss && typeof ss == "object" && (ss = ss.ptr), !!Yn(Xs, zt, fn, Bn, or, ss);
    }, me.prototype.SkipAttributeTransform = me.prototype.SkipAttributeTransform = function(zt) {
      var fn = this.ptr;
      zt && typeof zt == "object" && (zt = zt.ptr), Lo(fn, zt);
    }, me.prototype.GetEncodedGeometryType_Deprecated = me.prototype.GetEncodedGeometryType_Deprecated = function(zt) {
      var fn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), Un(fn, zt);
    }, me.prototype.DecodeBufferToPointCloud = me.prototype.DecodeBufferToPointCloud = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), L(so(Bn, zt, fn), ae);
    }, me.prototype.DecodeBufferToMesh = me.prototype.DecodeBufferToMesh = function(zt, fn) {
      var Bn = this.ptr;
      return zt && typeof zt == "object" && (zt = zt.ptr), fn && typeof fn == "object" && (fn = fn.ptr), L(rs(Bn, zt, fn), ae);
    }, me.prototype.__destroy__ = me.prototype.__destroy__ = function() {
      hi(this.ptr);
    }, function() {
      function zt() {
        Se.ATTRIBUTE_INVALID_TRANSFORM = Zo(), Se.ATTRIBUTE_NO_TRANSFORM = li(), Se.ATTRIBUTE_QUANTIZATION_TRANSFORM = ei(), Se.ATTRIBUTE_OCTAHEDRON_TRANSFORM = Or(), Se.INVALID = ui(), Se.POSITION = _s(), Se.NORMAL = xo(), Se.COLOR = aa(), Se.TEX_COORD = oo(), Se.GENERIC = vs(), Se.INVALID_GEOMETRY_TYPE = yi(), Se.POINT_CLOUD = $r(), Se.TRIANGULAR_MESH = ki(), Se.DT_INVALID = ds(), Se.DT_INT8 = Ls(), Se.DT_UINT8 = Co(), Se.DT_INT16 = ps(), Se.DT_UINT16 = Tr(), Se.DT_INT32 = ao(), Se.DT_UINT32 = Gt(), Se.DT_INT64 = sr(), Se.DT_UINT64 = vt(), Se.DT_FLOAT32 = Jr(), Se.DT_FLOAT64 = Qs(), Se.DT_BOOL = Ds(), Se.DT_TYPES_COUNT = Hs(), Se.OK = Xr(), Se.DRACO_ERROR = bi(), Se.IO_ERROR = rn(), Se.INVALID_PARAMETER = mo(), Se.UNSUPPORTED_VERSION = Gi(), Se.UNKNOWN_VERSION = yo();
      }
      xn ? zt() : Nn.unshift(zt);
    }(), typeof Se.onModuleParsed == "function" && Se.onModuleParsed(), Se.Decoder.prototype.GetEncodedGeometryType = function(zt) {
      if (zt.__class__ && zt.__class__ === Se.DecoderBuffer)
        return Se.Decoder.prototype.GetEncodedGeometryType_Deprecated(zt);
      if (8 > zt.byteLength)
        return Se.INVALID_GEOMETRY_TYPE;
      switch (zt[7]) {
        case 0:
          return Se.POINT_CLOUD;
        case 1:
          return Se.TRIANGULAR_MESH;
        default:
          return Se.INVALID_GEOMETRY_TYPE;
      }
    }, e.ready;
  };
}();
function assert(r, e) {
  if (!r)
    throw new Error(`Assertion failed: ${e}`);
}
function numByteSize(r) {
  switch (r) {
    case 9:
    case 7:
    case 3:
      return 8;
    case 8:
    case 6:
    case 2:
      return 4;
    case 4:
    case 0:
      return 1;
    case 5:
    case 1:
      return 2;
    default:
      throw new Error("Unknown data type");
  }
}
function createAttributeBufferFor(r, e, s, o) {
  switch (e) {
    case 3:
      throw new Error("Unsupported BufferAttributeType U64");
    case 7:
      throw new Error("Unsupported BufferAttributeType I64");
    case 0:
      return new Uint8BufferAttribute(r, s, o);
    case 1:
      return new Uint16BufferAttribute(r, s, o);
    case 2:
      return new Uint32BufferAttribute(r, s, o);
    case 4:
      return new Int8BufferAttribute(r, s, o);
    case 5:
      return new Int16BufferAttribute(r, s, o);
    case 6:
      return new Int32BufferAttribute(r, s, o);
    case 8:
      return new Float32BufferAttribute(r, s, o);
    case 9:
      return new Float64BufferAttribute(r, s, o);
  }
}
function constructBufferForNumType(r, e, s, o) {
  switch (r) {
    case 3:
      throw new Error("Unsupported TypedArray U64");
    case 7:
      throw new Error("Unsupported TypedArray I64");
    case 0:
      return new Uint8Array(e, s, o);
    case 1:
      return new Uint16Array(e, s, o);
    case 2:
      return new Uint32Array(e, s, o);
    case 4:
      return new Int8Array(e, s, o);
    case 5:
      return new Int16Array(e, s, o);
    case 6:
      return new Int32Array(e, s, o);
    case 8:
      return new Float32Array(e, s, o);
    case 9:
      return new Float64Array(e, s, o);
  }
}
function isByteOffset(r) {
  return !(typeof r != "object" || r === null || typeof r.byteOffset != "number" || typeof r.componentType < "u" && typeof r.componentType != "string");
}
function readSingleNum$1(r, e, s) {
  return typeof s > "u" || typeof s == "number" ? s : isByteOffset(s) ? readNumFromBlob$1(r, e, s.byteOffset) : s[0];
}
function readMultiNum$1(r, e, s, o) {
  if (typeof o > "u")
    return o;
  if (typeof o == "number")
    return [o];
  if (isByteOffset(o)) {
    const a = [], l = numByteSize(s);
    for (let u = 0; u < e; u += 1) {
      const c = u * l, E = readNumFromBlob$1(r, s, o.byteOffset + c);
      a.push(E);
    }
    return a;
  } else
    return o.length !== e ? void 0 : o;
}
function readNumFromBlob$1(r, e, s) {
  switch (e) {
    case 3:
      throw new Error("U64 can't be represented in a double precision floating point (number)");
    case 7:
      throw new Error("I64 can't be represented in a double precision floating point (number)");
    case 0:
      return r.getUint8(s);
    case 4:
      return r.getInt8(s);
    case 1:
      return r.getUint16(s, !0);
    case 5:
      return r.getInt16(s, !0);
    case 2:
      return r.getUint32(s, !0);
    case 6:
      return r.getInt32(s, !0);
    case 8:
      return r.getFloat32(s, !0);
    case 9:
      return r.getFloat64(s, !0);
  }
}
function readFeatureTable(r, e = 28) {
  const s = r.getUint32(12, !0), o = r.getUint32(16, !0), a = new TextDecoder("utf-8"), l = new DataView(r.buffer, r.byteOffset + e, s), u = a.decode(l), c = new DataView(r.buffer, r.byteOffset + e + s, o);
  return {
    text: u,
    data: c
  };
}
function readBatchTable(r, e = 28) {
  const s = r.getUint32(12, !0) + r.getUint32(16, !0), o = r.getUint32(20, !0), a = r.getUint32(24, !0);
  if (o === 0)
    return;
  const l = new TextDecoder("utf-8"), u = new DataView(r.buffer, r.byteOffset + e + s, o), c = l.decode(u), E = new DataView(r.buffer, r.byteOffset + e + o + s, a);
  return {
    text: c,
    data: E
  };
}
function evictMaterial(r) {
  for (const e of Object.values(r)) {
    const s = e;
    s instanceof Texture && (s.image instanceof ImageBitmap && s.image.close(), s.dispose());
  }
  r.dispose();
}
var __awaiter$W = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class DracoLoader {
  static decodePointCloudBuffer(e, s, o = new BufferGeometry()) {
    return __awaiter$W(this, void 0, void 0, function* () {
      const a = yield DracoLoader.get(), l = new Int8Array(s.buffer, s.byteOffset, s.byteLength);
      if (a.decoder.GetEncodedGeometryType(l) !== a.module.POINT_CLOUD)
        throw new Error("Attempting to read non point cloud draco data as a point cloud");
      const c = new a.module.PointCloud(), E = a.decoder.DecodeArrayToPointCloud(l, l.byteLength, c);
      if (!E.ok())
        throw new Error(`Draco decoding failed with message '${E.error_msg()}'`);
      for (const [d, f] of Object.entries(e.attributes)) {
        const h = DracoLoader.getDracoDataTypeFor(a, f.componentType), S = a.decoder.GetAttributeByUniqueId(c, f.attributeId), R = DracoLoader.decodeAttribute(a, c, h, S);
        if (f.mapperFn !== void 0) {
          const _ = new Array(f.numComponents);
          for (let m = 0; m < R.length; m += f.numComponents) {
            for (let L = 0; L < f.numComponents; L += 1)
              _[L] = R[m + L];
            f.mapperFn(_);
            for (let L = 0; L < f.numComponents; L += 1)
              R[m + L] = _[L];
          }
        }
        o.setAttribute(d, createAttributeBufferFor(R, f.componentType, f.numComponents, f.normalized));
      }
      return a.module.destroy(c), o;
    });
  }
  /**
   * Handles decoding a point cloud attribute into a TypedArray
   * @param lib
   * @param dracoGeometry
   * @param dataType
   * @param attribute
   * @private
   */
  static decodeAttribute(e, s, o, a) {
    const l = DracoLoader.getNumTypeFor(e, o), u = a.num_components(), E = s.num_points() * u, d = E * numByteSize(l), f = e.module._malloc(d);
    e.decoder.GetAttributeDataArrayForAllPoints(s, a, o, d, f);
    const h = constructBufferForNumType(l, e.module.HEAPF32.buffer, f, E).slice();
    return e.module._free(f), h;
  }
  /**
   * Converts a DracoComponentType variant into the matching draco DataType
   * @param lib
   * @param componentType
   * @private
   */
  static getDracoDataTypeFor(e, s) {
    switch (s) {
      case 3:
        return e.module.DT_UINT64;
      case 7:
        return e.module.DT_INT64;
      case 0:
        return e.module.DT_UINT8;
      case 1:
        return e.module.DT_UINT16;
      case 2:
        return e.module.DT_UINT32;
      case 4:
        return e.module.DT_INT8;
      case 5:
        return e.module.DT_INT16;
      case 6:
        return e.module.DT_INT32;
      case 8:
        return e.module.DT_FLOAT32;
      case 9:
        return e.module.DT_FLOAT64;
    }
  }
  /**
   * Converts a DracoComponentType variant into the matching draco DataType
   * @param lib
   * @param componentType
   * @private
   */
  static getNumTypeFor(e, s) {
    switch (s) {
      case e.module.DT_UINT8:
        return 0;
      case e.module.DT_UINT16:
        return 1;
      case e.module.DT_UINT32:
        return 2;
      case e.module.DT_UINT64:
        return 3;
      case e.module.DT_INT8:
        return 4;
      case e.module.DT_INT16:
        return 5;
      case e.module.DT_INT32:
        return 6;
      case e.module.DT_INT64:
        return 7;
      case e.module.DT_FLOAT32:
        return 8;
      case e.module.DT_FLOAT64:
        return 9;
      default:
        throw new Error("Unknown data type");
    }
  }
  /**
   * Initializer wrapper
   */
  static init(e) {
    return __awaiter$W(this, void 0, void 0, function* () {
      const o = yield (yield fetch(`${e || ""}draco_decoder.wasm`)).arrayBuffer(), a = yield DracoDecoderModule$1({ wasmBinary: o }), l = new a.Decoder();
      return [a, l];
    });
  }
  /**
   * Internal function for fetching the module and decoder, or throwing if they aren't initialized
   * @private
   */
  static get(e) {
    return __awaiter$W(this, void 0, void 0, function* () {
      if (DracoLoader.state.loaded !== void 0)
        return DracoLoader.state.loaded;
      {
        DracoLoader.state.inFlight === void 0 && (DracoLoader.state.inFlight = this.init(e));
        const [s, o] = yield DracoLoader.state.inFlight;
        return DracoLoader.state.loaded = {
          module: s,
          decoder: o
        }, DracoLoader.state.loaded;
      }
    });
  }
}
DracoLoader.state = {};
var lib = {}, LocalCache = {}, Utils = {}, __awaiter$V = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
Object.defineProperty(Utils, "__esModule", { value: !0 });
Utils.asyncFind = void 0;
function asyncFind(r, e) {
  return __awaiter$V(this, void 0, void 0, function* () {
    const s = r.map(e), a = (yield Promise.all(s)).findIndex((l) => l);
    return r[a];
  });
}
Utils.asyncFind = asyncFind;
var Database$1 = {};
const instanceOfAny = (r, e) => e.some((s) => r instanceof s);
let idbProxyableTypes, cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const transactionDoneMap = /* @__PURE__ */ new WeakMap(), transformCache = /* @__PURE__ */ new WeakMap(), reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(r) {
  const e = new Promise((s, o) => {
    const a = () => {
      r.removeEventListener("success", l), r.removeEventListener("error", u);
    }, l = () => {
      s(wrap$1(r.result)), a();
    }, u = () => {
      o(r.error), a();
    };
    r.addEventListener("success", l), r.addEventListener("error", u);
  });
  return reverseTransformCache.set(e, r), e;
}
function cacheDonePromiseForTransaction(r) {
  if (transactionDoneMap.has(r))
    return;
  const e = new Promise((s, o) => {
    const a = () => {
      r.removeEventListener("complete", l), r.removeEventListener("error", u), r.removeEventListener("abort", u);
    }, l = () => {
      s(), a();
    }, u = () => {
      o(r.error || new DOMException("AbortError", "AbortError")), a();
    };
    r.addEventListener("complete", l), r.addEventListener("error", u), r.addEventListener("abort", u);
  });
  transactionDoneMap.set(r, e);
}
let idbProxyTraps = {
  get(r, e, s) {
    if (r instanceof IDBTransaction) {
      if (e === "done")
        return transactionDoneMap.get(r);
      if (e === "store")
        return s.objectStoreNames[1] ? void 0 : s.objectStore(s.objectStoreNames[0]);
    }
    return wrap$1(r[e]);
  },
  set(r, e, s) {
    return r[e] = s, !0;
  },
  has(r, e) {
    return r instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in r;
  }
};
function replaceTraps(r) {
  idbProxyTraps = r(idbProxyTraps);
}
function wrapFunction(r) {
  return getCursorAdvanceMethods().includes(r) ? function(...e) {
    return r.apply(unwrap(this), e), wrap$1(this.request);
  } : function(...e) {
    return wrap$1(r.apply(unwrap(this), e));
  };
}
function transformCachableValue(r) {
  return typeof r == "function" ? wrapFunction(r) : (r instanceof IDBTransaction && cacheDonePromiseForTransaction(r), instanceOfAny(r, getIdbProxyableTypes()) ? new Proxy(r, idbProxyTraps) : r);
}
function wrap$1(r) {
  if (r instanceof IDBRequest)
    return promisifyRequest(r);
  if (transformCache.has(r))
    return transformCache.get(r);
  const e = transformCachableValue(r);
  return e !== r && (transformCache.set(r, e), reverseTransformCache.set(e, r)), e;
}
const unwrap = (r) => reverseTransformCache.get(r);
function openDB(r, e, { blocked: s, upgrade: o, blocking: a, terminated: l } = {}) {
  const u = indexedDB.open(r, e), c = wrap$1(u);
  return o && u.addEventListener("upgradeneeded", (E) => {
    o(wrap$1(u.result), E.oldVersion, E.newVersion, wrap$1(u.transaction), E);
  }), s && u.addEventListener("blocked", (E) => s(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    E.oldVersion,
    E.newVersion,
    E
  )), c.then((E) => {
    l && E.addEventListener("close", () => l()), a && E.addEventListener("versionchange", (d) => a(d.oldVersion, d.newVersion, d));
  }).catch(() => {
  }), c;
}
function deleteDB(r, { blocked: e } = {}) {
  const s = indexedDB.deleteDatabase(r);
  return e && s.addEventListener("blocked", (o) => e(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    o.oldVersion,
    o
  )), wrap$1(s).then(() => {
  });
}
const readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"], writeMethods = ["put", "add", "delete", "clear"], cachedMethods = /* @__PURE__ */ new Map();
function getMethod(r, e) {
  if (!(r instanceof IDBDatabase && !(e in r) && typeof e == "string"))
    return;
  if (cachedMethods.get(e))
    return cachedMethods.get(e);
  const s = e.replace(/FromIndex$/, ""), o = e !== s, a = writeMethods.includes(s);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(s in (o ? IDBIndex : IDBObjectStore).prototype) || !(a || readMethods.includes(s))
  )
    return;
  const l = async function(u, ...c) {
    const E = this.transaction(u, a ? "readwrite" : "readonly");
    let d = E.store;
    return o && (d = d.index(c.shift())), (await Promise.all([
      d[s](...c),
      a && E.done
    ]))[0];
  };
  return cachedMethods.set(e, l), l;
}
replaceTraps((r) => ({
  ...r,
  get: (e, s, o) => getMethod(e, s) || r.get(e, s, o),
  has: (e, s) => !!getMethod(e, s) || r.has(e, s)
}));
const advanceMethodProps = ["continue", "continuePrimaryKey", "advance"], methodMap = {}, advanceResults = /* @__PURE__ */ new WeakMap(), ittrProxiedCursorToOriginalProxy = /* @__PURE__ */ new WeakMap(), cursorIteratorTraps = {
  get(r, e) {
    if (!advanceMethodProps.includes(e))
      return r[e];
    let s = methodMap[e];
    return s || (s = methodMap[e] = function(...o) {
      advanceResults.set(this, ittrProxiedCursorToOriginalProxy.get(this)[e](...o));
    }), s;
  }
};
async function* iterate(...r) {
  let e = this;
  if (e instanceof IDBCursor || (e = await e.openCursor(...r)), !e)
    return;
  e = e;
  const s = new Proxy(e, cursorIteratorTraps);
  for (ittrProxiedCursorToOriginalProxy.set(s, e), reverseTransformCache.set(s, unwrap(e)); e; )
    yield s, e = await (advanceResults.get(s) || e.continue()), advanceResults.delete(s);
}
function isIteratorProp(r, e) {
  return e === Symbol.asyncIterator && instanceOfAny(r, [IDBIndex, IDBObjectStore, IDBCursor]) || e === "iterate" && instanceOfAny(r, [IDBIndex, IDBObjectStore]);
}
replaceTraps((r) => ({
  ...r,
  get(e, s, o) {
    return isIteratorProp(e, s) ? iterate : r.get(e, s, o);
  },
  has(e, s) {
    return isIteratorProp(e, s) || r.has(e, s);
  }
}));
const build = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  deleteDB,
  openDB,
  unwrap,
  wrap: wrap$1
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(build);
var __awaiter$U = commonjsGlobal && commonjsGlobal.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
}, __asyncValues = commonjsGlobal && commonjsGlobal.__asyncValues || function(r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = r[Symbol.asyncIterator], s;
  return e ? e.call(r) : (r = typeof __values == "function" ? __values(r) : r[Symbol.iterator](), s = {}, o("next"), o("throw"), o("return"), s[Symbol.asyncIterator] = function() {
    return this;
  }, s);
  function o(l) {
    s[l] = r[l] && function(u) {
      return new Promise(function(c, E) {
        u = r[l](u), a(c, E, u.done, u.value);
      });
    };
  }
  function a(l, u, c, E) {
    Promise.resolve(E).then(function(d) {
      l({ value: d, done: c });
    }, u);
  }
};
Object.defineProperty(Database$1, "__esModule", { value: !0 });
Database$1.Database = void 0;
const idb_1 = require$$0$1;
class Database {
  constructor(e, s, o = 1) {
    this.storeName = s, this.db = (0, idb_1.openDB)(e, o, {
      upgrade: (a, l, u, c) => __awaiter$U(this, void 0, void 0, function* () {
        u !== null && u > l && a.objectStoreNames.contains(s) && a.deleteObjectStore(s), a.createObjectStore(s);
      }),
      blocking: () => __awaiter$U(this, void 0, void 0, function* () {
        yield (yield this.db).close();
      })
    });
  }
  /**
   * Remove an item from the store.
   *
   * @param key
   */
  removeItem(e) {
    return __awaiter$U(this, void 0, void 0, function* () {
      yield (yield this.db).transaction(this.storeName, "readwrite").store.delete(e);
    });
  }
  /**
   * Assign an item to a key.
   *
   * @param key
   * @param value
   */
  setItem(e, s) {
    return __awaiter$U(this, void 0, void 0, function* () {
      yield (yield this.db).transaction(this.storeName, "readwrite").store.put(s, e);
    });
  }
  /**
   * Get the item associated with a key.
   *
   * @param key
   * @returns
   */
  getItem(e) {
    return __awaiter$U(this, void 0, void 0, function* () {
      const a = yield (yield this.db).transaction(this.storeName).store.get(e);
      return a || null;
    });
  }
  /**
   * Enumerate the keys in the database.
   *
   * @returns
   */
  keys() {
    return __awaiter$U(this, void 0, void 0, function* () {
      const s = (yield this.db).transaction(this.storeName), o = [];
      for (const a of yield s.store.getAllKeys())
        o.push(a);
      return o;
    });
  }
  /**
   * Clear the database.
   */
  clear() {
    return __awaiter$U(this, void 0, void 0, function* () {
      yield (yield this.db).transaction(this.storeName, "readwrite").store.clear();
    });
  }
  /**
   * Iterate over the entries in the database.
   *
   * @param cb
   */
  iterate(e) {
    var s, o, a, l;
    return __awaiter$U(this, void 0, void 0, function* () {
      const c = (yield this.db).transaction(this.storeName);
      try {
        for (var E = !0, d = __asyncValues(c.store), f; f = yield d.next(), s = f.done, !s; ) {
          l = f.value, E = !1;
          try {
            const h = l;
            e(h.value, h.key);
          } finally {
            E = !0;
          }
        }
      } catch (h) {
        o = { error: h };
      } finally {
        try {
          !E && !s && (a = d.return) && (yield a.call(d));
        } finally {
          if (o)
            throw o.error;
        }
      }
    });
  }
}
Database$1.Database = Database;
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__awaiter || function(l, u, c, E) {
    function d(f) {
      return f instanceof c ? f : new c(function(h) {
        h(f);
      });
    }
    return new (c || (c = Promise))(function(f, h) {
      function S(m) {
        try {
          _(E.next(m));
        } catch (L) {
          h(L);
        }
      }
      function R(m) {
        try {
          _(E.throw(m));
        } catch (L) {
          h(L);
        }
      }
      function _(m) {
        m.done ? f(m.value) : d(m.value).then(S, R);
      }
      _((E = E.apply(l, u || [])).next());
    });
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.LocalCache = r.LOCAL_SCHEMA_VERSION = void 0;
  const s = Utils, o = Database$1;
  r.LOCAL_SCHEMA_VERSION = 3;
  class a {
    constructor(u) {
      if (u.poolTypes.reduce((E, d) => E + d.allocationRatio, 0) > 1 || u.poolTypes.find((E) => E.allocationRatio < 0))
        throw new Error("Invalid cache allocation ratios.");
      this.settings = u, this.db = new o.Database("SkandDB", u.name, r.LOCAL_SCHEMA_VERSION);
    }
    /**
     * Register a file in the cache, evicting the not recently used entries until it fits.
     *
     * @param cacheKey
     * @param url
     * @param blob
     */
    register(u, c, E) {
      return e(this, void 0, void 0, function* () {
        const d = yield (0, s.asyncFind)(this.settings.poolTypes, (R) => e(this, void 0, void 0, function* () {
          return yield R.isMember(c, E);
        }));
        if (d === void 0)
          return;
        const f = d.allocationRatio * this.settings.capacity;
        if (E.size > f)
          return;
        const h = [];
        yield this.db.iterate((R, _) => {
          R.poolName === d.name && h.push([_, R]);
        }), h.sort((R, _) => R[1].lastUsed.getTime() - _[1].lastUsed.getTime());
        let S = h.reduce((R, [_, m]) => R + m.content.data.byteLength, 0);
        for (; h.length > 0 && S + E.size > this.settings.capacity * d.allocationRatio; ) {
          const R = h.shift();
          if (R) {
            const [_, m] = R;
            yield this.db.removeItem(_), S -= m.content.data.byteLength;
          }
        }
        yield this.db.setItem(u, {
          url: c,
          content: {
            data: yield E.arrayBuffer(),
            type: E.type
          },
          poolName: d.name,
          lastUsed: /* @__PURE__ */ new Date()
        });
      });
    }
    /**
     * Fetch a file from the cache or from the remote stream.
     *
     * @param url
     * @param options
     * @returns
     */
    fetch(u, c) {
      var E;
      return e(this, void 0, void 0, function* () {
        const d = (E = c == null ? void 0 : c.cacheKey) !== null && E !== void 0 ? E : u, f = yield this.db.getItem(d);
        if (f !== null) {
          const { content: h, poolName: S } = f;
          return yield this.db.setItem(d, {
            url: u,
            content: h,
            poolName: S,
            lastUsed: /* @__PURE__ */ new Date()
          }), new Blob([h.data], { type: h.type });
        } else {
          const h = {
            method: "GET"
          };
          c !== void 0 && c.headers !== void 0 && (h.headers = c.headers);
          const S = yield fetch(u, h);
          if (S.status === 200 || S.status === 0) {
            const R = yield S.blob();
            return yield this.register(d, u, R), R;
          } else
            throw new Error(`GET request to ${u} failed with status ${S.status}`);
        }
      });
    }
    /**
     * Evict a file from the cache, if it exists.
     *
     * @param key
     * @returns
     */
    evict(u) {
      return e(this, void 0, void 0, function* () {
        yield this.db.removeItem(u);
      });
    }
    /**
     * Clear the cache.
     *
     * @returns
     */
    clear() {
      return e(this, void 0, void 0, function* () {
        yield this.db.clear();
      });
    }
    /**
     * Get a map of cached files to their urls.
     *
     * @returns
     */
    getEntries() {
      return e(this, void 0, void 0, function* () {
        const u = /* @__PURE__ */ new Map(), c = yield this.db.keys();
        for (const E of c) {
          const d = yield this.db.getItem(E);
          if (d !== null) {
            const f = new Blob([d.content.data], {
              type: d.content.type
            });
            u.set(E, f);
          }
        }
        return u;
      });
    }
    /**
     * Get the cache settings.
     *
     * @returns
     */
    getSettings() {
      return this.settings;
    }
  }
  r.LocalCache = a;
})(LocalCache);
var CacheSettings = {};
Object.defineProperty(CacheSettings, "__esModule", { value: !0 });
(function(r) {
  var e = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, a, l, u) {
    u === void 0 && (u = l);
    var c = Object.getOwnPropertyDescriptor(a, l);
    (!c || ("get" in c ? !a.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return a[l];
    } }), Object.defineProperty(o, u, c);
  } : function(o, a, l, u) {
    u === void 0 && (u = l), o[u] = a[l];
  }), s = commonjsGlobal && commonjsGlobal.__exportStar || function(o, a) {
    for (var l in o)
      l !== "default" && !Object.prototype.hasOwnProperty.call(a, l) && e(a, o, l);
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), s(LocalCache, r), s(CacheSettings, r);
})(lib);
var __awaiter$T = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const IN_WEBWORKER = typeof WorkerGlobalScope < "u";
function isKmlFile(r, e) {
  return __awaiter$T(this, void 0, void 0, function* () {
    const s = yield e.text();
    return s.includes("<kml") || s.includes("<KML");
  });
}
function isObjFile(r, e) {
  return __awaiter$T(this, void 0, void 0, function* () {
    return r.toLowerCase().endsWith(".obj") || r.toLowerCase().endsWith(".mtl");
  });
}
function isIFCFile(r, e) {
  return __awaiter$T(this, void 0, void 0, function* () {
    return (yield e.text()).includes("ISO-10303-21;");
  });
}
class FileLoader {
  /**
   * Loads the file at the specified URL into an ArrayBuffer asynchronously
   * @param url
   * @param options
   */
  static loadArrayBuffer(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      return yield (yield this.fetchResponse(e, s)).arrayBuffer();
    });
  }
  /**
   * Loads the file at the specified URL into a Blob asynchronously
   * @param url
   * @param options
   */
  static loadBlob(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      return yield this.fetchResponse(e, s);
    });
  }
  /**
   * Loads the file at the specified URL into a string asynchronously
   * @param url
   * @param options
   */
  static loadText(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      return yield (yield this.fetchResponse(e, s)).text();
    });
  }
  /**
   * Loads the file at the specified URL and parse it as JSON asynchronously
   * @param url
   * @param options
   */
  static loadJson(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      return JSON.parse(yield this.loadText(e, s));
    });
  }
  /**
   * Loads the file at the specified URL and parse it as a Document asynchronously
   * @param url
   * @param options
   */
  static loadDocument(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      if (IN_WEBWORKER)
        throw new Error("loadDocument not supported in WebWorker");
      {
        const a = yield (yield this.fetchResponse(e, s)).text();
        return this._domParser.parseFromString(a, "text/xml");
      }
    });
  }
  static fetchResponse(e, s) {
    return __awaiter$T(this, void 0, void 0, function* () {
      if (FileLoader.CONFIGURATION.useLocalCache && (s != null && s.cache || s != null && s.cacheKey))
        try {
          return yield this._localCache.fetch(e, s);
        } catch (u) {
          console.warn(u);
        }
      const o = {
        method: "GET"
      };
      typeof s < "u" && typeof s.headers < "u" && (o.headers = s.headers), typeof s < "u" && typeof s.signal < "u" && (o.signal = s.signal);
      const a = new Request(e, o), l = yield fetch(a, { referrerPolicy: "strict-origin-when-cross-origin" });
      if (l.status === 200 || l.status === 0)
        return l.blob();
      throw new Error(`GET request failed with status ${l.status}`);
    });
  }
  static clearCache() {
    this._localCache.clear();
  }
}
FileLoader.CACHE_SIZE = 1024 * 1024 * 1024 * 4;
FileLoader._domParser = IN_WEBWORKER ? void 0 : new DOMParser();
FileLoader._localCache = new lib.LocalCache({
  name: "Renderer Cache",
  capacity: FileLoader.CACHE_SIZE,
  poolTypes: [
    {
      name: "KML",
      isMember: isKmlFile,
      allocationRatio: 0.2
    },
    {
      name: "OBJ",
      isMember: isObjFile,
      allocationRatio: 0.4
    },
    {
      name: "IFC",
      isMember: isIFCFile,
      allocationRatio: 0.4
    }
  ]
});
function mergeGeometries(r, e = !1) {
  const s = r[0].index !== null, o = new Set(Object.keys(r[0].attributes)), a = new Set(Object.keys(r[0].morphAttributes)), l = {}, u = {}, c = r[0].morphTargetsRelative, E = new BufferGeometry();
  let d = 0;
  for (let f = 0; f < r.length; ++f) {
    const h = r[f];
    let S = 0;
    if (s !== (h.index !== null))
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
    for (const R in h.attributes) {
      if (!o.has(R))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + '. All geometries must have compatible attributes; make sure "' + R + '" attribute exists among all geometries, or in none of them.'), null;
      l[R] === void 0 && (l[R] = []), l[R].push(h.attributes[R]), S++;
    }
    if (S !== o.size)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". Make sure all geometries have the same number of attributes."), null;
    if (c !== h.morphTargetsRelative)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
    for (const R in h.morphAttributes) {
      if (!a.has(R))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ".  .morphAttributes must be consistent throughout all geometries."), null;
      u[R] === void 0 && (u[R] = []), u[R].push(h.morphAttributes[R]);
    }
    if (e) {
      let R;
      if (s)
        R = h.index.count;
      else if (h.attributes.position !== void 0)
        R = h.attributes.position.count;
      else
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + f + ". The geometry must have either an index or a position attribute"), null;
      E.addGroup(d, R, f), d += R;
    }
  }
  if (s) {
    let f = 0;
    const h = [];
    for (let S = 0; S < r.length; ++S) {
      const R = r[S].index;
      for (let _ = 0; _ < R.count; ++_)
        h.push(R.getX(_) + f);
      f += r[S].attributes.position.count;
    }
    E.setIndex(h);
  }
  for (const f in l) {
    const h = mergeAttributes(l[f]);
    if (!h)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + f + " attribute."), null;
    E.setAttribute(f, h);
  }
  for (const f in u) {
    const h = u[f][0].length;
    if (h === 0)
      break;
    E.morphAttributes = E.morphAttributes || {}, E.morphAttributes[f] = [];
    for (let S = 0; S < h; ++S) {
      const R = [];
      for (let m = 0; m < u[f].length; ++m)
        R.push(u[f][m][S]);
      const _ = mergeAttributes(R);
      if (!_)
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + f + " morphAttribute."), null;
      E.morphAttributes[f].push(_);
    }
  }
  return E;
}
function mergeAttributes(r) {
  let e, s, o, a = -1, l = 0;
  for (let d = 0; d < r.length; ++d) {
    const f = r[d];
    if (f.isInterleavedBufferAttribute)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported."), null;
    if (e === void 0 && (e = f.array.constructor), e !== f.array.constructor)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
    if (s === void 0 && (s = f.itemSize), s !== f.itemSize)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
    if (o === void 0 && (o = f.normalized), o !== f.normalized)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
    if (a === -1 && (a = f.gpuType), a !== f.gpuType)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes."), null;
    l += f.array.length;
  }
  const u = new e(l);
  let c = 0;
  for (let d = 0; d < r.length; ++d)
    u.set(r[d].array, c), c += r[d].array.length;
  const E = new BufferAttribute(u, s, o);
  return a !== void 0 && (E.gpuType = a), E;
}
function estimateBytesUsed(r) {
  let e = 0;
  for (const o in r.attributes) {
    const a = r.getAttribute(o);
    e += a.count * a.itemSize * a.array.BYTES_PER_ELEMENT;
  }
  const s = r.getIndex();
  return e += s ? s.count * s.itemSize * s.array.BYTES_PER_ELEMENT : 0, e;
}
function toTrianglesDrawMode(r, e) {
  if (e === TrianglesDrawMode)
    return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), r;
  if (e === TriangleFanDrawMode || e === TriangleStripDrawMode) {
    let s = r.getIndex();
    if (s === null) {
      const u = [], c = r.getAttribute("position");
      if (c !== void 0) {
        for (let E = 0; E < c.count; E++)
          u.push(E);
        r.setIndex(u), s = r.getIndex();
      } else
        return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), r;
    }
    const o = s.count - 2, a = [];
    if (e === TriangleFanDrawMode)
      for (let u = 1; u <= o; u++)
        a.push(s.getX(0)), a.push(s.getX(u)), a.push(s.getX(u + 1));
    else
      for (let u = 0; u < o; u++)
        u % 2 === 0 ? (a.push(s.getX(u)), a.push(s.getX(u + 1)), a.push(s.getX(u + 2))) : (a.push(s.getX(u + 2)), a.push(s.getX(u + 1)), a.push(s.getX(u)));
    a.length / 3 !== o && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    const l = r.clone();
    return l.setIndex(a), l.clearGroups(), l;
  } else
    return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), r;
}
let GLTFLoader$1 = class extends Loader {
  constructor(e) {
    super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(s) {
      return new GLTFMaterialsClearcoatExtension(s);
    }), this.register(function(s) {
      return new GLTFTextureBasisUExtension(s);
    }), this.register(function(s) {
      return new GLTFTextureWebPExtension(s);
    }), this.register(function(s) {
      return new GLTFTextureAVIFExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsSheenExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsTransmissionExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsVolumeExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsIorExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsEmissiveStrengthExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsSpecularExtension(s);
    }), this.register(function(s) {
      return new GLTFMaterialsIridescenceExtension(s);
    }), this.register(function(s) {
      return new GLTFLightsExtension(s);
    }), this.register(function(s) {
      return new GLTFMeshoptCompression(s);
    }), this.register(function(s) {
      return new GLTFMeshGpuInstancing(s);
    });
  }
  load(e, s, o, a, l = {}) {
    const u = this;
    let c;
    this.resourcePath !== "" ? c = this.resourcePath : this.path !== "" ? c = this.path : c = LoaderUtils.extractUrlBase(e), this.manager.itemStart(e);
    const E = function(f) {
      a ? a(f) : console.error(f), u.manager.itemError(e), u.manager.itemEnd(e);
    }, d = new FileLoader$1(this.manager);
    d.setPath(this.path), d.setResponseType("arraybuffer"), d.setRequestHeader(this.requestHeader), d.setWithCredentials(this.withCredentials), d.load(e, function(f) {
      try {
        u.parse(f, c, function(h) {
          s(h), u.manager.itemEnd(e);
        }, E, l);
      } catch (h) {
        E(h);
      }
    }, o, E);
  }
  setDRACOLoader(e) {
    return this.dracoLoader = e, this;
  }
  setDDSLoader() {
    throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
  }
  setKTX2Loader(e) {
    return this.ktx2Loader = e, this;
  }
  setMeshoptDecoder(e) {
    return this.meshoptDecoder = e, this;
  }
  register(e) {
    return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
  }
  unregister(e) {
    return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
  }
  parse(e, s, o, a, l = {}) {
    var u, c;
    let E;
    const d = {}, f = {}, h = new TextDecoder();
    if (typeof e == "string")
      E = JSON.parse(e);
    else if (e instanceof ArrayBuffer)
      if (h.decode(new Uint8Array(e, 0, 4)) === BINARY_EXTENSION_HEADER_MAGIC) {
        try {
          d[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(e);
        } catch (_) {
          a && a(_);
          return;
        }
        E = JSON.parse(d[EXTENSIONS.KHR_BINARY_GLTF].content);
      } else
        E = JSON.parse(h.decode(e));
    else
      E = e;
    if (E.asset === void 0 || E.asset.version[0] < 2) {
      a && a(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const S = new GLTFParser(E, {
      path: s || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder,
      objectId: (u = l.objectId) !== null && u !== void 0 ? u : 0,
      clippingPlanes: (c = l.clippingPlanes) !== null && c !== void 0 ? c : []
    });
    S.fileLoader.setRequestHeader(this.requestHeader);
    for (let R = 0; R < this.pluginCallbacks.length; R++) {
      const _ = this.pluginCallbacks[R](S);
      f[_.name] = _, d[_.name] = !0;
    }
    if (E.extensionsUsed)
      for (let R = 0; R < E.extensionsUsed.length; ++R) {
        const _ = E.extensionsUsed[R], m = E.extensionsRequired || [];
        switch (_) {
          case EXTENSIONS.KHR_MATERIALS_UNLIT:
            d[_] = new GLTFMaterialsUnlitExtension();
            break;
          case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
            d[_] = new GLTFDracoMeshCompressionExtension(E, this.dracoLoader);
            break;
          case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
            d[_] = new GLTFTextureTransformExtension();
            break;
          case EXTENSIONS.KHR_MESH_QUANTIZATION:
            d[_] = new GLTFMeshQuantizationExtension();
            break;
          default:
            m.indexOf(_) >= 0 && f[_] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + _ + '".');
        }
      }
    S.setExtensions(d), S.setPlugins(f), S.parse(o, a);
  }
  parseAsync(e, s) {
    const o = this;
    return new Promise(function(a, l) {
      o.parse(e, s, a, l);
    });
  }
};
function GLTFRegistry() {
  let r = {};
  return {
    get: function(e) {
      return r[e];
    },
    add: function(e, s) {
      r[e] = s;
    },
    remove: function(e) {
      delete r[e];
    },
    removeAll: function() {
      r = {};
    }
  };
}
const EXTENSIONS = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class GLTFLightsExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL, this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const e = this.parser, s = this.parser.json.nodes || [];
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      l.extensions && l.extensions[this.name] && l.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, l.extensions[this.name].light);
    }
  }
  _loadLight(e) {
    const s = this.parser, o = "light:" + e;
    let a = s.cache.get(o);
    if (a)
      return a;
    const l = s.json, E = ((l.extensions && l.extensions[this.name] || {}).lights || [])[e];
    let d;
    const f = new Color(16777215);
    E.color !== void 0 && f.fromArray(E.color);
    const h = E.range !== void 0 ? E.range : 0;
    switch (E.type) {
      case "directional":
        d = new DirectionalLight(f), d.target.position.set(0, 0, -1), d.add(d.target);
        break;
      case "point":
        d = new PointLight(f), d.distance = h;
        break;
      case "spot":
        d = new SpotLight(f), d.distance = h, E.spot = E.spot || {}, E.spot.innerConeAngle = E.spot.innerConeAngle !== void 0 ? E.spot.innerConeAngle : 0, E.spot.outerConeAngle = E.spot.outerConeAngle !== void 0 ? E.spot.outerConeAngle : Math.PI / 4, d.angle = E.spot.outerConeAngle, d.penumbra = 1 - E.spot.innerConeAngle / E.spot.outerConeAngle, d.target.position.set(0, 0, -1), d.add(d.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + E.type);
    }
    return d.position.set(0, 0, 0), d.decay = 2, assignExtrasToUserData(d, E), E.intensity !== void 0 && (d.intensity = E.intensity), d.name = s.createUniqueName(E.name || "light_" + e), a = Promise.resolve(d), s.cache.add(o, a), a;
  }
  getDependency(e, s) {
    if (e === "light")
      return this._loadLight(s);
  }
  createNodeAttachment(e) {
    const s = this, o = this.parser, l = o.json.nodes[e], c = (l.extensions && l.extensions[this.name] || {}).light;
    return c === void 0 ? null : this._loadLight(c).then(function(E) {
      return o._getNodeRef(s.cache, c, E);
    });
  }
}
class GLTFMaterialsUnlitExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return PickingMeshBasicMaterial;
  }
  extendParams(e, s, o) {
    const a = [];
    e.color = new Color(1, 1, 1), e.opacity = 1;
    const l = s.pbrMetallicRoughness;
    if (l) {
      if (Array.isArray(l.baseColorFactor)) {
        const u = l.baseColorFactor;
        e.color.fromArray(u), e.opacity = u[3];
      }
      l.baseColorTexture !== void 0 && a.push(o.assignTexture(e, "map", l.baseColorTexture, SRGBColorSpace));
    }
    return Promise.all(a);
  }
}
class GLTFMaterialsEmissiveStrengthExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(e, s) {
    const a = this.parser.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = a.extensions[this.name].emissiveStrength;
    return l !== void 0 && (s.emissiveIntensity = l), Promise.resolve();
  }
}
class GLTFMaterialsClearcoatExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [], u = a.extensions[this.name];
    if (u.clearcoatFactor !== void 0 && (s.clearcoat = u.clearcoatFactor), u.clearcoatTexture !== void 0 && l.push(o.assignTexture(s, "clearcoatMap", u.clearcoatTexture)), u.clearcoatRoughnessFactor !== void 0 && (s.clearcoatRoughness = u.clearcoatRoughnessFactor), u.clearcoatRoughnessTexture !== void 0 && l.push(o.assignTexture(s, "clearcoatRoughnessMap", u.clearcoatRoughnessTexture)), u.clearcoatNormalTexture !== void 0 && (l.push(o.assignTexture(s, "clearcoatNormalMap", u.clearcoatNormalTexture)), u.clearcoatNormalTexture.scale !== void 0)) {
      const c = u.clearcoatNormalTexture.scale;
      s.clearcoatNormalScale = new Vector2(c, c);
    }
    return Promise.all(l);
  }
}
class GLTFMaterialsIridescenceExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [], u = a.extensions[this.name];
    return u.iridescenceFactor !== void 0 && (s.iridescence = u.iridescenceFactor), u.iridescenceTexture !== void 0 && l.push(o.assignTexture(s, "iridescenceMap", u.iridescenceTexture)), u.iridescenceIor !== void 0 && (s.iridescenceIOR = u.iridescenceIor), s.iridescenceThicknessRange === void 0 && (s.iridescenceThicknessRange = [100, 400]), u.iridescenceThicknessMinimum !== void 0 && (s.iridescenceThicknessRange[0] = u.iridescenceThicknessMinimum), u.iridescenceThicknessMaximum !== void 0 && (s.iridescenceThicknessRange[1] = u.iridescenceThicknessMaximum), u.iridescenceThicknessTexture !== void 0 && l.push(o.assignTexture(s, "iridescenceThicknessMap", u.iridescenceThicknessTexture)), Promise.all(l);
  }
}
class GLTFMaterialsSheenExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [];
    s.sheenColor = new Color(0, 0, 0), s.sheenRoughness = 0, s.sheen = 1;
    const u = a.extensions[this.name];
    return u.sheenColorFactor !== void 0 && s.sheenColor.fromArray(u.sheenColorFactor), u.sheenRoughnessFactor !== void 0 && (s.sheenRoughness = u.sheenRoughnessFactor), u.sheenColorTexture !== void 0 && l.push(o.assignTexture(s, "sheenColorMap", u.sheenColorTexture, SRGBColorSpace)), u.sheenRoughnessTexture !== void 0 && l.push(o.assignTexture(s, "sheenRoughnessMap", u.sheenRoughnessTexture)), Promise.all(l);
  }
}
class GLTFMaterialsTransmissionExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [], u = a.extensions[this.name];
    return u.transmissionFactor !== void 0 && (s.transmission = u.transmissionFactor), u.transmissionTexture !== void 0 && l.push(o.assignTexture(s, "transmissionMap", u.transmissionTexture)), Promise.all(l);
  }
}
class GLTFMaterialsVolumeExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [], u = a.extensions[this.name];
    s.thickness = u.thicknessFactor !== void 0 ? u.thicknessFactor : 0, u.thicknessTexture !== void 0 && l.push(o.assignTexture(s, "thicknessMap", u.thicknessTexture)), s.attenuationDistance = u.attenuationDistance || 1 / 0;
    const c = u.attenuationColor || [1, 1, 1];
    return s.attenuationColor = new Color(c[0], c[1], c[2]), Promise.all(l);
  }
}
class GLTFMaterialsIorExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_IOR;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const a = this.parser.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = a.extensions[this.name];
    return s.ior = l.ior !== void 0 ? l.ior : 1.5, Promise.resolve();
  }
}
class GLTFMaterialsSpecularExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(e) {
    const o = this.parser.json.materials[e];
    return !o.extensions || !o.extensions[this.name] ? null : PickingMeshPhysicalMaterial;
  }
  extendMaterialParams(e, s) {
    const o = this.parser, a = o.json.materials[e];
    if (!a.extensions || !a.extensions[this.name])
      return Promise.resolve();
    const l = [], u = a.extensions[this.name];
    s.specularIntensity = u.specularFactor !== void 0 ? u.specularFactor : 1, u.specularTexture !== void 0 && l.push(o.assignTexture(s, "specularIntensityMap", u.specularTexture));
    const c = u.specularColorFactor || [1, 1, 1];
    return s.specularColor = new Color(c[0], c[1], c[2]), u.specularColorTexture !== void 0 && l.push(o.assignTexture(s, "specularColorMap", u.specularColorTexture, SRGBColorSpace)), Promise.all(l);
  }
}
class GLTFTextureBasisUExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
  }
  loadTexture(e) {
    const s = this.parser, o = s.json, a = o.textures[e];
    if (!a.extensions || !a.extensions[this.name])
      return null;
    const l = a.extensions[this.name], u = s.options.ktx2Loader;
    if (!u) {
      if (o.extensionsRequired && o.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      return null;
    }
    return s.loadTextureImage(e, l.source, u);
  }
}
class GLTFTextureWebPExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.EXT_TEXTURE_WEBP, this.isSupported = null;
  }
  loadTexture(e) {
    const s = this.name, o = this.parser, a = o.json, l = a.textures[e];
    if (!l.extensions || !l.extensions[s])
      return null;
    const u = l.extensions[s], c = a.images[u.source];
    let E = o.textureLoader;
    if (c.uri) {
      const d = o.options.manager.getHandler(c.uri);
      d !== null && (E = d);
    }
    return this.detectSupport().then(function(d) {
      if (d)
        return o.loadTextureImage(e, u.source, E);
      if (a.extensionsRequired && a.extensionsRequired.indexOf(s) >= 0)
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      return o.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const s = new Image();
      s.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", s.onload = s.onerror = function() {
        e(s.height === 1);
      };
    })), this.isSupported;
  }
}
class GLTFTextureAVIFExtension {
  constructor(e) {
    this.parser = e, this.name = EXTENSIONS.EXT_TEXTURE_AVIF, this.isSupported = null;
  }
  loadTexture(e) {
    const s = this.name, o = this.parser, a = o.json, l = a.textures[e];
    if (!l.extensions || !l.extensions[s])
      return null;
    const u = l.extensions[s], c = a.images[u.source];
    let E = o.textureLoader;
    if (c.uri) {
      const d = o.options.manager.getHandler(c.uri);
      d !== null && (E = d);
    }
    return this.detectSupport().then(function(d) {
      if (d)
        return o.loadTextureImage(e, u.source, E);
      if (a.extensionsRequired && a.extensionsRequired.indexOf(s) >= 0)
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      return o.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const s = new Image();
      s.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", s.onload = s.onerror = function() {
        e(s.height === 1);
      };
    })), this.isSupported;
  }
}
class GLTFMeshoptCompression {
  constructor(e) {
    this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION, this.parser = e;
  }
  loadBufferView(e) {
    const s = this.parser.json, o = s.bufferViews[e];
    if (o.extensions && o.extensions[this.name]) {
      const a = o.extensions[this.name], l = this.parser.getDependency("buffer", a.buffer), u = this.parser.options.meshoptDecoder;
      if (!u || !u.supported) {
        if (s.extensionsRequired && s.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        return null;
      }
      return l.then(function(c) {
        const E = a.byteOffset || 0, d = a.byteLength || 0, f = a.count, h = a.byteStride, S = new Uint8Array(c, E, d);
        return u.decodeGltfBufferAsync ? u.decodeGltfBufferAsync(f, h, S, a.mode, a.filter).then(function(R) {
          return R.buffer;
        }) : u.ready.then(function() {
          const R = new ArrayBuffer(f * h);
          return u.decodeGltfBuffer(new Uint8Array(R), f, h, S, a.mode, a.filter), R;
        });
      });
    } else
      return null;
  }
}
class GLTFMeshGpuInstancing {
  constructor(e) {
    this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING, this.parser = e;
  }
  createNodeMesh(e) {
    const s = this.parser.json, o = s.nodes[e];
    if (!o.extensions || !o.extensions[this.name] || o.mesh === void 0)
      return null;
    const a = s.meshes[o.mesh];
    for (const d of a.primitives)
      if (d.mode !== WEBGL_CONSTANTS.TRIANGLES && d.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && d.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && d.mode !== void 0)
        return null;
    const u = o.extensions[this.name].attributes, c = [], E = {};
    for (const d in u)
      c.push(this.parser.getDependency("accessor", u[d]).then((f) => (E[d] = f, E[d])));
    return c.length < 1 ? null : (c.push(this.parser.createNodeMesh(e)), Promise.all(c).then((d) => {
      const f = d.pop(), h = f.isGroup ? f.children : [f], S = d[0].count, R = [];
      for (const _ of h) {
        const m = new Matrix4(), L = new Vector3$1(), F = new Quaternion$1(), W = new Vector3$1(1, 1, 1), G = new InstancedMesh(_.geometry, _.material, S);
        for (let q = 0; q < S; q++)
          E.TRANSLATION && L.fromBufferAttribute(E.TRANSLATION, q), E.ROTATION && F.fromBufferAttribute(E.ROTATION, q), E.SCALE && W.fromBufferAttribute(E.SCALE, q), G.setMatrixAt(q, m.compose(L, F, W));
        for (const q in E)
          q !== "TRANSLATION" && q !== "ROTATION" && q !== "SCALE" && _.geometry.setAttribute(q, E[q]);
        Object3D.prototype.copy.call(G, _), this.parser.assignFinalMaterial(G), R.push(G);
      }
      return f.isGroup ? (f.clear(), f.add(...R), f) : R[0];
    }));
  }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF", BINARY_EXTENSION_HEADER_LENGTH = 12, BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
class GLTFBinaryExtension {
  constructor(e) {
    this.name = EXTENSIONS.KHR_BINARY_GLTF, this.content = null, this.body = null;
    const s = new DataView(e, 0, BINARY_EXTENSION_HEADER_LENGTH), o = new TextDecoder();
    if (this.header = {
      magic: o.decode(new Uint8Array(e.slice(0, 4))),
      version: s.getUint32(4, !0),
      length: s.getUint32(8, !0)
    }, this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC)
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    if (this.header.version < 2)
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    const a = this.header.length - BINARY_EXTENSION_HEADER_LENGTH, l = new DataView(e, BINARY_EXTENSION_HEADER_LENGTH);
    let u = 0;
    for (; u < a; ) {
      const c = l.getUint32(u, !0);
      u += 4;
      const E = l.getUint32(u, !0);
      if (u += 4, E === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
        const d = new Uint8Array(e, BINARY_EXTENSION_HEADER_LENGTH + u, c);
        this.content = o.decode(d);
      } else if (E === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
        const d = BINARY_EXTENSION_HEADER_LENGTH + u;
        this.body = e.slice(d, d + c);
      }
      u += c;
    }
    if (this.content === null)
      throw new Error("THREE.GLTFLoader: JSON content not found.");
  }
}
class GLTFDracoMeshCompressionExtension {
  constructor(e, s) {
    if (!s)
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = s, this.dracoLoader.preload();
  }
  decodePrimitive(e, s) {
    const o = this.json, a = this.dracoLoader, l = e.extensions[this.name].bufferView, u = e.extensions[this.name].attributes, c = {}, E = {}, d = {};
    for (const f in u) {
      const h = ATTRIBUTES[f] || f.toLowerCase();
      c[h] = u[f];
    }
    for (const f in e.attributes) {
      const h = ATTRIBUTES[f] || f.toLowerCase();
      if (u[f] !== void 0) {
        const S = o.accessors[e.attributes[f]], R = WEBGL_COMPONENT_TYPES[S.componentType];
        d[h] = R.name, E[h] = S.normalized === !0;
      }
    }
    return s.getDependency("bufferView", l).then(function(f) {
      return new Promise(function(h) {
        a.decodeDracoFile(f, function(S) {
          for (const R in S.attributes) {
            const _ = S.attributes[R], m = E[R];
            m !== void 0 && (_.normalized = m);
          }
          h(S);
        }, c, d);
      });
    });
  }
}
class GLTFTextureTransformExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(e, s) {
    return (s.texCoord === void 0 || s.texCoord === e.channel) && s.offset === void 0 && s.rotation === void 0 && s.scale === void 0 || (e = e.clone(), s.texCoord !== void 0 && (e.channel = s.texCoord), s.offset !== void 0 && e.offset.fromArray(s.offset), s.rotation !== void 0 && (e.rotation = s.rotation), s.scale !== void 0 && e.repeat.fromArray(s.scale), e.needsUpdate = !0), e;
  }
}
class GLTFMeshQuantizationExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
  }
}
class GLTFCubicSplineInterpolant extends Interpolant {
  constructor(e, s, o, a) {
    super(e, s, o, a);
  }
  copySampleValue_(e) {
    const s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = e * a * 3 + a;
    for (let u = 0; u !== a; u++)
      s[u] = o[l + u];
    return s;
  }
  interpolate_(e, s, o, a) {
    const l = this.resultBuffer, u = this.sampleValues, c = this.valueSize, E = c * 2, d = c * 3, f = a - s, h = (o - s) / f, S = h * h, R = S * h, _ = e * d, m = _ - d, L = -2 * R + 3 * S, F = R - S, W = 1 - L, G = F - S + h;
    for (let q = 0; q !== c; q++) {
      const fe = u[m + q + c], _e = u[m + q + E] * f, Le = u[_ + q + c], Fe = u[_ + q] * f;
      l[q] = W * fe + G * _e + L * Le + F * Fe;
    }
    return l;
  }
}
const _q = new Quaternion$1();
class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
  interpolate_(e, s, o, a) {
    const l = super.interpolate_(e, s, o, a);
    return _q.fromArray(l).normalize().toArray(l), l;
  }
}
const WEBGL_CONSTANTS = {
  FLOAT: 5126,
  //FLOAT_MAT2: 35674,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
}, WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, WEBGL_FILTERS = {
  9728: NearestFilter,
  9729: LinearFilter,
  9984: NearestMipmapNearestFilter,
  9985: LinearMipmapNearestFilter,
  9986: NearestMipmapLinearFilter,
  9987: LinearMipmapLinearFilter
}, WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping,
  33648: MirroredRepeatWrapping,
  10497: RepeatWrapping
}, WEBGL_TYPE_SIZES = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, ATTRIBUTES = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv1",
  TEXCOORD_2: "uv2",
  TEXCOORD_3: "uv3",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
}, PATH_PROPERTIES = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
}, INTERPOLATION = {
  CUBICSPLINE: void 0,
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: InterpolateLinear,
  STEP: InterpolateDiscrete
}, ALPHA_MODES = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function createDefaultMaterial(r) {
  return r.DefaultMaterial === void 0 && (r.DefaultMaterial = new PickingMeshStandardMaterial({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: FrontSide
  })), r.DefaultMaterial;
}
function addUnknownExtensionsToUserData(r, e, s) {
  for (const o in s.extensions)
    r[o] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[o] = s.extensions[o]);
}
function assignExtrasToUserData(r, e) {
  e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(r.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function addMorphTargets(r, e, s) {
  let o = !1, a = !1, l = !1;
  for (let d = 0, f = e.length; d < f; d++) {
    const h = e[d];
    if (h.POSITION !== void 0 && (o = !0), h.NORMAL !== void 0 && (a = !0), h.COLOR_0 !== void 0 && (l = !0), o && a && l)
      break;
  }
  if (!o && !a && !l)
    return Promise.resolve(r);
  const u = [], c = [], E = [];
  for (let d = 0, f = e.length; d < f; d++) {
    const h = e[d];
    if (o) {
      const S = h.POSITION !== void 0 ? s.getDependency("accessor", h.POSITION) : r.attributes.position;
      u.push(S);
    }
    if (a) {
      const S = h.NORMAL !== void 0 ? s.getDependency("accessor", h.NORMAL) : r.attributes.normal;
      c.push(S);
    }
    if (l) {
      const S = h.COLOR_0 !== void 0 ? s.getDependency("accessor", h.COLOR_0) : r.attributes.color;
      E.push(S);
    }
  }
  return Promise.all([
    Promise.all(u),
    Promise.all(c),
    Promise.all(E)
  ]).then(function(d) {
    const f = d[0], h = d[1], S = d[2];
    return o && (r.morphAttributes.position = f), a && (r.morphAttributes.normal = h), l && (r.morphAttributes.color = S), r.morphTargetsRelative = !0, r;
  });
}
function updateMorphTargets(r, e) {
  if (r.updateMorphTargets(), e.weights !== void 0)
    for (let s = 0, o = e.weights.length; s < o; s++)
      r.morphTargetInfluences[s] = e.weights[s];
  if (e.extras && Array.isArray(e.extras.targetNames)) {
    const s = e.extras.targetNames;
    if (r.morphTargetInfluences.length === s.length) {
      r.morphTargetDictionary = {};
      for (let o = 0, a = s.length; o < a; o++)
        r.morphTargetDictionary[s[o]] = o;
    } else
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}
function createPrimitiveKey(r) {
  const e = r.extensions && r.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
  let s;
  return e ? s = "draco:" + e.bufferView + ":" + e.indices + ":" + createAttributesKey(e.attributes) : s = r.indices + ":" + createAttributesKey(r.attributes) + ":" + r.mode, s;
}
function createAttributesKey(r) {
  let e = "";
  const s = Object.keys(r).sort();
  for (let o = 0, a = s.length; o < a; o++)
    e += s[o] + ":" + r[s[o]] + ";";
  return e;
}
function getNormalizedComponentScale(r) {
  switch (r) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function getImageURIMimeType(r) {
  return r.search(/\.jpe?g($|\?)/i) > 0 || r.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : r.search(/\.webp($|\?)/i) > 0 || r.search(/^data\:image\/webp/) === 0 ? "image/webp" : "image/png";
}
const _identityMatrix = new Matrix4();
class GLTFParser {
  constructor(e = {}, s = {}) {
    this.json = e, this.extensions = {}, this.plugins = {}, this.options = s, this.cache = new GLTFRegistry(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = { refs: {}, uses: {} }, this.cameraCache = { refs: {}, uses: {} }, this.lightCache = { refs: {}, uses: {} }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
    let o = !1, a = !1, l = -1;
    typeof navigator < "u" && (o = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === !0, a = navigator.userAgent.indexOf("Firefox") > -1, l = a ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), typeof createImageBitmap > "u" || o || a && l < 98 ? this.textureLoader = new TextureLoader$1(this.options.manager) : this.textureLoader = new ImageBitmapLoader(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new FileLoader$1(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
  }
  setExtensions(e) {
    this.extensions = e;
  }
  setPlugins(e) {
    this.plugins = e;
  }
  parse(e, s) {
    const o = this, a = this.json, l = this.extensions;
    this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(u) {
      return u._markDefs && u._markDefs();
    }), Promise.all(this._invokeAll(function(u) {
      return u.beforeRoot && u.beforeRoot();
    })).then(function() {
      return Promise.all([
        o.getDependencies("scene"),
        o.getDependencies("animation"),
        o.getDependencies("camera")
      ]);
    }).then(function(u) {
      const c = {
        scene: u[0][a.scene || 0],
        scenes: u[0],
        animations: u[1],
        cameras: u[2],
        asset: a.asset,
        parser: o,
        userData: {}
      };
      addUnknownExtensionsToUserData(l, c, a), assignExtrasToUserData(c, a), Promise.all(o._invokeAll(function(E) {
        return E.afterRoot && E.afterRoot(c);
      })).then(function() {
        e(c);
      });
    }).catch(s);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const e = this.json.nodes || [], s = this.json.skins || [], o = this.json.meshes || [];
    for (let a = 0, l = s.length; a < l; a++) {
      const u = s[a].joints;
      for (let c = 0, E = u.length; c < E; c++)
        e[u[c]].isBone = !0;
    }
    for (let a = 0, l = e.length; a < l; a++) {
      const u = e[a];
      u.mesh !== void 0 && (this._addNodeRef(this.meshCache, u.mesh), u.skin !== void 0 && (o[u.mesh].isSkinnedMesh = !0)), u.camera !== void 0 && this._addNodeRef(this.cameraCache, u.camera);
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(e, s) {
    s !== void 0 && (e.refs[s] === void 0 && (e.refs[s] = e.uses[s] = 0), e.refs[s]++);
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(e, s, o) {
    if (e.refs[s] <= 1)
      return o;
    const a = o.clone(), l = (u, c) => {
      const E = this.associations.get(u);
      E != null && this.associations.set(c, E);
      for (const [d, f] of u.children.entries())
        l(f, c.children[d]);
    };
    return l(o, a), a.name += "_instance_" + e.uses[s]++, a;
  }
  _invokeOne(e) {
    const s = Object.values(this.plugins);
    s.push(this);
    for (let o = 0; o < s.length; o++) {
      const a = e(s[o]);
      if (a)
        return a;
    }
    return null;
  }
  _invokeAll(e) {
    const s = Object.values(this.plugins);
    s.unshift(this);
    const o = [];
    for (let a = 0; a < s.length; a++) {
      const l = e(s[a]);
      l && o.push(l);
    }
    return o;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(e, s) {
    const o = e + ":" + s;
    let a = this.cache.get(o);
    if (!a) {
      switch (e) {
        case "scene":
          a = this.loadScene(s);
          break;
        case "node":
          a = this._invokeOne(function(l) {
            return l.loadNode && l.loadNode(s);
          });
          break;
        case "mesh":
          a = this._invokeOne(function(l) {
            return l.loadMesh && l.loadMesh(s);
          });
          break;
        case "accessor":
          a = this.loadAccessor(s);
          break;
        case "bufferView":
          a = this._invokeOne(function(l) {
            return l.loadBufferView && l.loadBufferView(s);
          });
          break;
        case "buffer":
          a = this.loadBuffer(s);
          break;
        case "material":
          a = this._invokeOne(function(l) {
            return l.loadMaterial && l.loadMaterial(s);
          });
          break;
        case "texture":
          a = this._invokeOne(function(l) {
            return l.loadTexture && l.loadTexture(s);
          });
          break;
        case "skin":
          a = this.loadSkin(s);
          break;
        case "animation":
          a = this._invokeOne(function(l) {
            return l.loadAnimation && l.loadAnimation(s);
          });
          break;
        case "camera":
          a = this.loadCamera(s);
          break;
        default:
          if (a = this._invokeOne(function(l) {
            return l != this && l.getDependency && l.getDependency(e, s);
          }), !a)
            throw new Error("Unknown type: " + e);
          break;
      }
      this.cache.add(o, a);
    }
    return a;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(e) {
    let s = this.cache.get(e);
    if (!s) {
      const o = this, a = this.json[e + (e === "mesh" ? "es" : "s")] || [];
      s = Promise.all(a.map(function(l, u) {
        return o.getDependency(e, u);
      })), this.cache.add(e, s);
    }
    return s;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(e) {
    const s = this.json.buffers[e], o = this.fileLoader;
    if (s.type && s.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + s.type + " buffer type is not supported.");
    if (s.uri === void 0 && e === 0)
      return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
    const a = this.options;
    return new Promise(function(l, u) {
      o.load(LoaderUtils.resolveURL(s.uri, a.path), l, void 0, function() {
        u(new Error('THREE.GLTFLoader: Failed to load buffer "' + s.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(e) {
    const s = this.json.bufferViews[e];
    return this.getDependency("buffer", s.buffer).then(function(o) {
      const a = s.byteLength || 0, l = s.byteOffset || 0;
      return o.slice(l, l + a);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(e) {
    const s = this, o = this.json, a = this.json.accessors[e];
    if (a.bufferView === void 0 && a.sparse === void 0) {
      const u = WEBGL_TYPE_SIZES[a.type], c = WEBGL_COMPONENT_TYPES[a.componentType], E = a.normalized === !0, d = new c(a.count * u);
      return Promise.resolve(new BufferAttribute(d, u, E));
    }
    const l = [];
    return a.bufferView !== void 0 ? l.push(this.getDependency("bufferView", a.bufferView)) : l.push(null), a.sparse !== void 0 && (l.push(this.getDependency("bufferView", a.sparse.indices.bufferView)), l.push(this.getDependency("bufferView", a.sparse.values.bufferView))), Promise.all(l).then(function(u) {
      const c = u[0], E = WEBGL_TYPE_SIZES[a.type], d = WEBGL_COMPONENT_TYPES[a.componentType], f = d.BYTES_PER_ELEMENT, h = f * E, S = a.byteOffset || 0, R = a.bufferView !== void 0 ? o.bufferViews[a.bufferView].byteStride : void 0, _ = a.normalized === !0;
      let m, L;
      if (R && R !== h) {
        const F = Math.floor(S / R), W = "InterleavedBuffer:" + a.bufferView + ":" + a.componentType + ":" + F + ":" + a.count;
        let G = s.cache.get(W);
        G || (m = new d(c, F * R, a.count * R / f), G = new InterleavedBuffer(m, R / f), s.cache.add(W, G)), L = new InterleavedBufferAttribute(G, E, S % R / f, _);
      } else
        c === null ? m = new d(a.count * E) : m = new d(c, S, a.count * E), L = new BufferAttribute(m, E, _);
      if (a.sparse !== void 0) {
        const F = WEBGL_TYPE_SIZES.SCALAR, W = WEBGL_COMPONENT_TYPES[a.sparse.indices.componentType], G = a.sparse.indices.byteOffset || 0, q = a.sparse.values.byteOffset || 0, fe = new W(u[1], G, a.sparse.count * F), _e = new d(u[2], q, a.sparse.count * E);
        c !== null && (L = new BufferAttribute(L.array.slice(), L.itemSize, L.normalized));
        for (let Le = 0, Fe = fe.length; Le < Fe; Le++) {
          const Ee = fe[Le];
          if (L.setX(Ee, _e[Le * E]), E >= 2 && L.setY(Ee, _e[Le * E + 1]), E >= 3 && L.setZ(Ee, _e[Le * E + 2]), E >= 4 && L.setW(Ee, _e[Le * E + 3]), E >= 5)
            throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
      }
      return L;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(e) {
    const s = this.json, o = this.options, l = s.textures[e].source, u = s.images[l];
    let c = this.textureLoader;
    if (u.uri) {
      const E = o.manager.getHandler(u.uri);
      E !== null && (c = E);
    }
    return this.loadTextureImage(e, l, c);
  }
  loadTextureImage(e, s, o) {
    const a = this, l = this.json, u = l.textures[e], c = l.images[s], E = (c.uri || c.bufferView) + ":" + u.sampler;
    if (this.textureCache[E])
      return this.textureCache[E];
    const d = this.loadImageSource(s, o).then(function(f) {
      f.flipY = !1, f.name = u.name || c.name || "", f.name === "" && typeof c.uri == "string" && c.uri.startsWith("data:image/") === !1 && (f.name = c.uri);
      const S = (l.samplers || {})[u.sampler] || {};
      return f.magFilter = WEBGL_FILTERS[S.magFilter] || LinearFilter, f.minFilter = WEBGL_FILTERS[S.minFilter] || LinearMipmapLinearFilter, f.wrapS = WEBGL_WRAPPINGS[S.wrapS] || RepeatWrapping, f.wrapT = WEBGL_WRAPPINGS[S.wrapT] || RepeatWrapping, a.associations.set(f, { textures: e }), f;
    }).catch(function() {
      return null;
    });
    return this.textureCache[E] = d, d;
  }
  loadImageSource(e, s) {
    const o = this, a = this.json, l = this.options;
    if (this.sourceCache[e] !== void 0)
      return this.sourceCache[e].then((h) => h.clone());
    const u = a.images[e], c = self.URL || self.webkitURL;
    let E = u.uri || "", d = !1;
    if (u.bufferView !== void 0)
      E = o.getDependency("bufferView", u.bufferView).then(function(h) {
        d = !0;
        const S = new Blob([h], { type: u.mimeType });
        return E = c.createObjectURL(S), E;
      });
    else if (u.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
    const f = Promise.resolve(E).then(function(h) {
      return new Promise(function(S, R) {
        let _ = S;
        s.isImageBitmapLoader === !0 && (_ = function(m) {
          const L = new Texture(m);
          L.needsUpdate = !0, S(L);
        }), s.load(LoaderUtils.resolveURL(h, l.path), _, void 0, R);
      });
    }).then(function(h) {
      return d === !0 && c.revokeObjectURL(E), h.userData.mimeType = u.mimeType || getImageURIMimeType(u.uri), h;
    }).catch(function(h) {
      throw console.error("THREE.GLTFLoader: Couldn't load texture", E), h;
    });
    return this.sourceCache[e] = f, f;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(e, s, o, a) {
    const l = this;
    return this.getDependency("texture", o.index).then(function(u) {
      if (!u)
        return null;
      if (o.texCoord !== void 0 && o.texCoord > 0 && (u = u.clone(), u.channel = o.texCoord), l.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
        const c = o.extensions !== void 0 ? o.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
        if (c) {
          const E = l.associations.get(u);
          u = l.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(u, c), l.associations.set(u, E);
        }
      }
      return a !== void 0 && (u.colorSpace = a), e[s] = u, u;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(e) {
    const s = e.geometry;
    let o = e.material;
    const a = s.attributes.tangent === void 0, l = s.attributes.color !== void 0, u = s.attributes.normal === void 0;
    if (e.isPoints) {
      const c = "PickingPointsMaterial:" + o.uuid;
      let E = this.cache.get(c);
      E || (E = new PickingPointsMaterial(), Material.prototype.copy.call(E, o), E.color.copy(o.color), E.map = o.map, E.sizeAttenuation = !1, this.cache.add(c, E)), o = E;
    } else if (e.isLine) {
      const c = "PickingLineBasicMaterial:" + o.uuid;
      let E = this.cache.get(c);
      E || (E = new PickingLineBasicMaterial(), Material.prototype.copy.call(E, o), E.color.copy(o.color), E.map = o.map, this.cache.add(c, E)), o = E;
    }
    if (a || l || u) {
      let c = "ClonedMaterial:" + o.uuid + ":";
      a && (c += "derivative-tangents:"), l && (c += "vertex-colors:"), u && (c += "flat-shading:");
      let E = this.cache.get(c);
      E || (E = o.clone(), l && (E.vertexColors = !0), u && (E.flatShading = !0), a && (E.normalScale && (E.normalScale.y *= -1), E.clearcoatNormalScale && (E.clearcoatNormalScale.y *= -1)), this.cache.add(c, E), this.associations.set(E, this.associations.get(o))), o = E;
    }
    e.material = o;
  }
  getMaterialType() {
    return PickingMeshStandardMaterial;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(e) {
    var s, o;
    const a = this, l = this.json, u = this.extensions, c = l.materials[e];
    let E;
    const d = {}, f = c.extensions || {};
    d.objectId = (s = this.options.objectId) !== null && s !== void 0 ? s : 0, d.clippingPlanes = (o = this.options.clippingPlanes) !== null && o !== void 0 ? o : [];
    const h = [];
    if (f[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
      const R = u[EXTENSIONS.KHR_MATERIALS_UNLIT];
      E = R.getMaterialType(), h.push(R.extendParams(d, c, a));
    } else {
      const R = c.pbrMetallicRoughness || {};
      if (d.color = new Color(1, 1, 1), d.opacity = 1, Array.isArray(R.baseColorFactor)) {
        const _ = R.baseColorFactor;
        d.color.fromArray(_), d.opacity = _[3];
      }
      R.baseColorTexture !== void 0 && h.push(a.assignTexture(d, "map", R.baseColorTexture, SRGBColorSpace)), d.metalness = R.metallicFactor !== void 0 ? R.metallicFactor : 1, d.roughness = R.roughnessFactor !== void 0 ? R.roughnessFactor : 1, R.metallicRoughnessTexture !== void 0 && (h.push(a.assignTexture(d, "metalnessMap", R.metallicRoughnessTexture)), h.push(a.assignTexture(d, "roughnessMap", R.metallicRoughnessTexture))), E = this._invokeOne(function(_) {
        return _.getMaterialType && _.getMaterialType(e);
      }), h.push(Promise.all(this._invokeAll(function(_) {
        return _.extendMaterialParams && _.extendMaterialParams(e, d);
      })));
    }
    c.doubleSided === !0 && (d.side = DoubleSide);
    const S = c.alphaMode || ALPHA_MODES.OPAQUE;
    if (S === ALPHA_MODES.BLEND ? (d.transparent = !0, d.depthWrite = !1) : (d.transparent = !1, S === ALPHA_MODES.MASK && (d.alphaTest = c.alphaCutoff !== void 0 ? c.alphaCutoff : 0.5)), c.normalTexture !== void 0 && E !== PickingMeshBasicMaterial && (h.push(a.assignTexture(d, "normalMap", c.normalTexture)), d.normalScale = new Vector2(1, 1), c.normalTexture.scale !== void 0)) {
      const R = c.normalTexture.scale;
      d.normalScale.set(R, R);
    }
    return c.occlusionTexture !== void 0 && E !== PickingMeshBasicMaterial && (h.push(a.assignTexture(d, "aoMap", c.occlusionTexture)), c.occlusionTexture.strength !== void 0 && (d.aoMapIntensity = c.occlusionTexture.strength)), c.emissiveFactor !== void 0 && E !== PickingMeshBasicMaterial && (d.emissive = new Color().fromArray(c.emissiveFactor)), c.emissiveTexture !== void 0 && E !== PickingMeshBasicMaterial && h.push(a.assignTexture(d, "emissiveMap", c.emissiveTexture, SRGBColorSpace)), Promise.all(h).then(function() {
      const R = new E(d);
      return c.name && (R.name = c.name), assignExtrasToUserData(R, c), a.associations.set(R, { materials: e }), c.extensions && addUnknownExtensionsToUserData(u, R, c), R;
    });
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(e) {
    const s = PropertyBinding.sanitizeNodeName(e || "");
    let o = s;
    for (let a = 1; this.nodeNamesUsed[o]; ++a)
      o = s + "_" + a;
    return this.nodeNamesUsed[o] = !0, o;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(e) {
    const s = this, o = this.extensions, a = this.primitiveCache;
    function l(c) {
      return o[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(c, s).then(function(E) {
        return addPrimitiveAttributes(E, c, s);
      });
    }
    const u = [];
    for (let c = 0, E = e.length; c < E; c++) {
      const d = e[c], f = createPrimitiveKey(d), h = a[f];
      if (h)
        u.push(h.promise);
      else {
        let S;
        d.extensions && d.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION] ? S = l(d) : S = addPrimitiveAttributes(new BufferGeometry(), d, s), a[f] = { primitive: d, promise: S }, u.push(S);
      }
    }
    return Promise.all(u);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(e) {
    const s = this, o = this.json, a = this.extensions, l = o.meshes[e], u = l.primitives, c = [];
    for (let E = 0, d = u.length; E < d; E++) {
      const f = u[E].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", u[E].material);
      c.push(f);
    }
    return c.push(s.loadGeometries(u)), Promise.all(c).then(function(E) {
      const d = E.slice(0, E.length - 1), f = E[E.length - 1], h = [];
      for (let R = 0, _ = f.length; R < _; R++) {
        const m = f[R], L = u[R];
        let F;
        const W = d[R];
        if (L.mode === WEBGL_CONSTANTS.TRIANGLES || L.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || L.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || L.mode === void 0)
          F = l.isSkinnedMesh === !0 ? new SkinnedMesh(m, W) : new Mesh(m, W), F.isSkinnedMesh === !0 && F.normalizeSkinWeights(), L.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP ? F.geometry = toTrianglesDrawMode(F.geometry, TriangleStripDrawMode) : L.mode === WEBGL_CONSTANTS.TRIANGLE_FAN && (F.geometry = toTrianglesDrawMode(F.geometry, TriangleFanDrawMode));
        else if (L.mode === WEBGL_CONSTANTS.LINES)
          F = new LineSegments(m, W);
        else if (L.mode === WEBGL_CONSTANTS.LINE_STRIP)
          F = new Line$1(m, W);
        else if (L.mode === WEBGL_CONSTANTS.LINE_LOOP)
          F = new LineLoop(m, W);
        else if (L.mode === WEBGL_CONSTANTS.POINTS)
          F = new Points(m, W);
        else
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + L.mode);
        Object.keys(F.geometry.morphAttributes).length > 0 && updateMorphTargets(F, l), F.name = s.createUniqueName(l.name || "mesh_" + e), assignExtrasToUserData(F, l), L.extensions && addUnknownExtensionsToUserData(a, F, L), s.assignFinalMaterial(F), h.push(F);
      }
      for (let R = 0, _ = h.length; R < _; R++)
        s.associations.set(h[R], {
          meshes: e,
          primitives: R
        });
      if (h.length === 1)
        return h[0];
      const S = new Group();
      s.associations.set(S, { meshes: e });
      for (let R = 0, _ = h.length; R < _; R++)
        S.add(h[R]);
      return S;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(e) {
    let s;
    const o = this.json.cameras[e], a = o[o.type];
    if (!a) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    return o.type === "perspective" ? s = new PerspectiveCamera$1(MathUtils$1.radToDeg(a.yfov), a.aspectRatio || 1, a.znear || 1, a.zfar || 2e6) : o.type === "orthographic" && (s = new OrthographicCamera$1(-a.xmag, a.xmag, a.ymag, -a.ymag, a.znear, a.zfar)), o.name && (s.name = this.createUniqueName(o.name)), assignExtrasToUserData(s, o), Promise.resolve(s);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(e) {
    const s = this.json.skins[e], o = [];
    for (let a = 0, l = s.joints.length; a < l; a++)
      o.push(this._loadNodeShallow(s.joints[a]));
    return s.inverseBindMatrices !== void 0 ? o.push(this.getDependency("accessor", s.inverseBindMatrices)) : o.push(null), Promise.all(o).then(function(a) {
      const l = a.pop(), u = a, c = [], E = [];
      for (let d = 0, f = u.length; d < f; d++) {
        const h = u[d];
        if (h) {
          c.push(h);
          const S = new Matrix4();
          l !== null && S.fromArray(l.array, d * 16), E.push(S);
        } else
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', s.joints[d]);
      }
      return new Skeleton(c, E);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(e) {
    const o = this.json.animations[e], a = o.name ? o.name : "animation_" + e, l = [], u = [], c = [], E = [], d = [];
    for (let f = 0, h = o.channels.length; f < h; f++) {
      const S = o.channels[f], R = o.samplers[S.sampler], _ = S.target, m = _.node, L = o.parameters !== void 0 ? o.parameters[R.input] : R.input, F = o.parameters !== void 0 ? o.parameters[R.output] : R.output;
      _.node !== void 0 && (l.push(this.getDependency("node", m)), u.push(this.getDependency("accessor", L)), c.push(this.getDependency("accessor", F)), E.push(R), d.push(_));
    }
    return Promise.all([
      Promise.all(l),
      Promise.all(u),
      Promise.all(c),
      Promise.all(E),
      Promise.all(d)
    ]).then(function(f) {
      const h = f[0], S = f[1], R = f[2], _ = f[3], m = f[4], L = [];
      for (let F = 0, W = h.length; F < W; F++) {
        const G = h[F], q = S[F], fe = R[F], _e = _[F], Le = m[F];
        if (G === void 0)
          continue;
        G.updateMatrix();
        let Fe;
        switch (PATH_PROPERTIES[Le.path]) {
          case PATH_PROPERTIES.weights:
            Fe = NumberKeyframeTrack;
            break;
          case PATH_PROPERTIES.rotation:
            Fe = QuaternionKeyframeTrack;
            break;
          case PATH_PROPERTIES.position:
          case PATH_PROPERTIES.scale:
          default:
            Fe = VectorKeyframeTrack;
            break;
        }
        const Ee = G.name ? G.name : G.uuid, Ge = _e.interpolation !== void 0 ? INTERPOLATION[_e.interpolation] : InterpolateLinear, ve = [];
        PATH_PROPERTIES[Le.path] === PATH_PROPERTIES.weights ? G.traverse(function(ae) {
          ae.morphTargetInfluences && ve.push(ae.name ? ae.name : ae.uuid);
        }) : ve.push(Ee);
        let te = fe.array;
        if (fe.normalized) {
          const ae = getNormalizedComponentScale(te.constructor), v = new Float32Array(te.length);
          for (let Te = 0, De = te.length; Te < De; Te++)
            v[Te] = te[Te] * ae;
          te = v;
        }
        for (let ae = 0, v = ve.length; ae < v; ae++) {
          const Te = new Fe(ve[ae] + "." + PATH_PROPERTIES[Le.path], q.array, te, Ge);
          _e.interpolation === "CUBICSPLINE" && (Te.createInterpolant = function(be) {
            const ze = this instanceof QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
            return new ze(this.times, this.values, this.getValueSize() / 3, be);
          }, Te.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0), L.push(Te);
        }
      }
      return new AnimationClip(a, void 0, L);
    });
  }
  createNodeMesh(e) {
    const s = this.json, o = this, a = s.nodes[e];
    return a.mesh === void 0 ? null : o.getDependency("mesh", a.mesh).then(function(l) {
      const u = o._getNodeRef(o.meshCache, a.mesh, l);
      return a.weights !== void 0 && u.traverse(function(c) {
        if (c.isMesh)
          for (let E = 0, d = a.weights.length; E < d; E++)
            c.morphTargetInfluences[E] = a.weights[E];
      }), u;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(e) {
    const s = this.json, o = this, a = s.nodes[e], l = o._loadNodeShallow(e), u = [], c = a.children || [];
    for (let d = 0, f = c.length; d < f; d++)
      u.push(o.getDependency("node", c[d]));
    const E = a.skin === void 0 ? Promise.resolve(null) : o.getDependency("skin", a.skin);
    return Promise.all([l, Promise.all(u), E]).then(function(d) {
      const f = d[0], h = d[1], S = d[2];
      S !== null && f.traverse(function(R) {
        R.isSkinnedMesh && R.bind(S, _identityMatrix);
      });
      for (let R = 0, _ = h.length; R < _; R++)
        f.add(h[R]);
      return f;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(e) {
    const s = this.json, o = this.extensions, a = this;
    if (this.nodeCache[e] !== void 0)
      return this.nodeCache[e];
    const l = s.nodes[e], u = l.name ? a.createUniqueName(l.name) : "", c = [], E = a._invokeOne(function(d) {
      return d.createNodeMesh && d.createNodeMesh(e);
    });
    return E && c.push(E), l.camera !== void 0 && c.push(a.getDependency("camera", l.camera).then(function(d) {
      return a._getNodeRef(a.cameraCache, l.camera, d);
    })), a._invokeAll(function(d) {
      return d.createNodeAttachment && d.createNodeAttachment(e);
    }).forEach(function(d) {
      c.push(d);
    }), this.nodeCache[e] = Promise.all(c).then(function(d) {
      let f;
      if (l.isBone === !0 ? f = new Bone() : d.length > 1 ? f = new Group() : d.length === 1 ? f = d[0] : f = new Object3D(), f !== d[0])
        for (let h = 0, S = d.length; h < S; h++)
          f.add(d[h]);
      if (l.name && (f.userData.name = l.name, f.name = u), assignExtrasToUserData(f, l), l.extensions && addUnknownExtensionsToUserData(o, f, l), l.matrix !== void 0) {
        const h = new Matrix4();
        h.fromArray(l.matrix), f.applyMatrix4(h);
      } else
        l.translation !== void 0 && f.position.fromArray(l.translation), l.rotation !== void 0 && f.quaternion.fromArray(l.rotation), l.scale !== void 0 && f.scale.fromArray(l.scale);
      return a.associations.has(f) || a.associations.set(f, {}), a.associations.get(f).nodes = e, f;
    }), this.nodeCache[e];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(e) {
    const s = this.extensions, o = this.json.scenes[e], a = this, l = new Group();
    o.name && (l.name = a.createUniqueName(o.name)), assignExtrasToUserData(l, o), o.extensions && addUnknownExtensionsToUserData(s, l, o);
    const u = o.nodes || [], c = [];
    for (let E = 0, d = u.length; E < d; E++)
      c.push(a.getDependency("node", u[E]));
    return Promise.all(c).then(function(E) {
      for (let f = 0, h = E.length; f < h; f++)
        l.add(E[f]);
      const d = (f) => {
        const h = /* @__PURE__ */ new Map();
        for (const [S, R] of a.associations)
          (S instanceof Material || S instanceof Texture) && h.set(S, R);
        return f.traverse((S) => {
          const R = a.associations.get(S);
          R != null && h.set(S, R);
        }), h;
      };
      return a.associations = d(l), l;
    });
  }
}
function computeBounds(r, e, s) {
  const o = e.attributes, a = new Box3$1();
  if (o.POSITION !== void 0) {
    const c = s.json.accessors[o.POSITION], E = c.min, d = c.max;
    if (E !== void 0 && d !== void 0) {
      if (a.set(new Vector3$1(E[0], E[1], E[2]), new Vector3$1(d[0], d[1], d[2])), c.normalized) {
        const f = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[c.componentType]);
        a.min.multiplyScalar(f), a.max.multiplyScalar(f);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else
    return;
  const l = e.targets;
  if (l !== void 0) {
    const c = new Vector3$1(), E = new Vector3$1();
    for (let d = 0, f = l.length; d < f; d++) {
      const h = l[d];
      if (h.POSITION !== void 0) {
        const S = s.json.accessors[h.POSITION], R = S.min, _ = S.max;
        if (R !== void 0 && _ !== void 0) {
          if (E.setX(Math.max(Math.abs(R[0]), Math.abs(_[0]))), E.setY(Math.max(Math.abs(R[1]), Math.abs(_[1]))), E.setZ(Math.max(Math.abs(R[2]), Math.abs(_[2]))), S.normalized) {
            const m = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[S.componentType]);
            E.multiplyScalar(m);
          }
          c.max(E);
        } else
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      }
    }
    a.expandByVector(c);
  }
  r.boundingBox = a;
  const u = new Sphere$1();
  a.getCenter(u.center), u.radius = a.min.distanceTo(a.max) / 2, r.boundingSphere = u;
}
function addPrimitiveAttributes(r, e, s) {
  const o = e.attributes, a = [];
  function l(u, c) {
    return s.getDependency("accessor", u).then(function(E) {
      r.setAttribute(c, E);
    });
  }
  for (const u in o) {
    const c = ATTRIBUTES[u] || u.toLowerCase();
    c in r.attributes || a.push(l(o[u], c));
  }
  if (e.indices !== void 0 && !r.index) {
    const u = s.getDependency("accessor", e.indices).then(function(c) {
      r.setIndex(c);
    });
    a.push(u);
  }
  return assignExtrasToUserData(r, e), computeBounds(r, e, s), Promise.all(a).then(function() {
    return e.targets !== void 0 ? addMorphTargets(r, e.targets, s) : r;
  });
}
let GLTFLoader;
GLTFLoader = function() {
  function r(Le) {
    this.manager = Le !== void 0 ? Le : DefaultLoadingManager;
  }
  r.prototype = {
    constructor: r,
    load: function(Le, Fe, Ee, Ge, ve = {}) {
      var te = this, ae = this.path && typeof this.path == "string" ? this.path : Loader.prototype.extractUrlBase(Le), v = new FileLoader$1(te.manager);
      v.setResponseType("arraybuffer"), v.load(Le, function(Te) {
        te.parse(Te, Fe, ae, ve);
      }, Ee, Ge);
    },
    setCrossOrigin: function(Le) {
      this.crossOrigin = Le;
    },
    setPath: function(Le) {
      this.path = Le;
    },
    parse: function(Le, Fe, Ee, Ge = {}) {
      var ve, te = {}, ae = q(new Uint8Array(Le, 0, 4));
      ae === u.magic ? (te[o.KHR_BINARY_GLTF] = new E(Le), ve = te[o.KHR_BINARY_GLTF].content) : ve = q(new Uint8Array(Le));
      var v = JSON.parse(ve);
      v.extensionsUsed && v.extensionsUsed.indexOf(o.KHR_MATERIALS_COMMON) >= 0 && (te[o.KHR_MATERIALS_COMMON] = new a(v));
      var Te = new _e(v, te, {
        path: Ee || this.path,
        crossOrigin: this.crossOrigin,
        objectId: Ge.objectId || 0,
        clippingPlanes: Ge.clippingPlanes || []
      });
      Te.parse(function(De, be, ze, ke) {
        var Be = {
          scene: De,
          scenes: be,
          cameras: ze,
          animations: ke,
          json: v
        };
        Fe(Be);
      });
    }
  };
  function e() {
    var Le = {};
    return {
      get: function(Fe) {
        return Le[Fe];
      },
      add: function(Fe, Ee) {
        Le[Fe] = Ee;
      },
      remove: function(Fe) {
        delete Le[Fe];
      },
      removeAll: function() {
        Le = {};
      },
      update: function(Fe, Ee) {
        for (var Ge in Le) {
          var ve = Le[Ge];
          ve.update && ve.update(Fe, Ee);
        }
      }
    };
  }
  r.Shaders = {
    update: function() {
      console.warn("THREE.GLTFLoader.Shaders has been deprecated, and now updates automatically.");
    }
  };
  function s(Le, Fe) {
    var Ee = {}, Ge = Le.material.uniforms;
    for (var ve in Ge) {
      var te = Ge[ve];
      if (te.semantic) {
        var ae = te.node, v = Le;
        ae && (v = Fe[ae]), Ee[ve] = {
          semantic: te.semantic,
          sourceNode: v,
          targetNode: Le,
          uniform: te
        };
      }
    }
    this.boundUniforms = Ee, this._m4 = new Matrix4();
  }
  s.prototype.update = function(Le, Fe) {
    var Ee = this.boundUniforms;
    for (var Ge in Ee) {
      var ve = Ee[Ge];
      switch (ve.semantic) {
        case "MODELVIEW":
          var ae = ve.uniform.value;
          ae.multiplyMatrices(Fe.matrixWorldInverse, ve.sourceNode.matrixWorld);
          break;
        case "MODELVIEWINVERSETRANSPOSE":
          var te = ve.uniform.value;
          this._m4.multiplyMatrices(Fe.matrixWorldInverse, ve.sourceNode.matrixWorld), te.getNormalMatrix(this._m4);
          break;
        case "PROJECTION":
          var ae = ve.uniform.value;
          ae.copy(Fe.projectionMatrix);
          break;
        case "JOINTMATRIX":
          for (var v = ve.uniform.value, Te = 0; Te < v.length; Te++)
            v[Te].getInverse(ve.sourceNode.matrixWorld).multiply(ve.targetNode.skeleton.bones[Te].matrixWorld).multiply(ve.targetNode.skeleton.boneInverses[Te]).multiply(ve.targetNode.bindMatrix);
          break;
        default:
          console.warn("Unhandled shader semantic: " + ve.semantic);
          break;
      }
    }
  }, r.Animations = {
    update: function() {
      console.warn("THREE.GLTFLoader.Animation has been deprecated. Use THREE.AnimationMixer instead.");
    }
  };
  var o = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_MATERIALS_COMMON: "KHR_materials_common"
  };
  function a(Le) {
    this.name = o.KHR_MATERIALS_COMMON, this.lights = {};
    var Fe = Le.extensions && Le.extensions[o.KHR_MATERIALS_COMMON] || {}, Ee = Fe.lights || {};
    for (var Ge in Ee) {
      var ve = Ee[Ge], te, ae = ve[ve.type], v = new Color().fromArray(ae.color);
      switch (ve.type) {
        case "directional":
          te = new DirectionalLight(v), te.position.set(0, 0, 1);
          break;
        case "point":
          te = new PointLight(v);
          break;
        case "spot":
          te = new SpotLight(v), te.position.set(0, 0, 1);
          break;
        case "ambient":
          te = new AmbientLight(v);
          break;
      }
      te && (this.lights[Ge] = te);
    }
  }
  var l = "binary_glTF", u = { magic: "glTF", version: 1, contentFormat: 0 }, c = 20;
  function E(Le) {
    this.name = o.KHR_BINARY_GLTF;
    var Fe = new DataView(Le, 0, c), Ee = {
      magic: q(new Uint8Array(Le.slice(0, 4))),
      version: Fe.getUint32(4, !0),
      length: Fe.getUint32(8, !0),
      contentLength: Fe.getUint32(12, !0),
      contentFormat: Fe.getUint32(16, !0)
    };
    for (var Ge in u) {
      var ve = u[Ge];
      if (Ee[Ge] !== ve)
        throw new Error('Unsupported glTF-Binary header: Expected "%s" to be "%s".', Ge, ve);
    }
    var te = new Uint8Array(Le, c, Ee.contentLength);
    this.header = Ee, this.content = q(te), this.body = Le.slice(c + Ee.contentLength, Ee.length);
  }
  E.prototype.loadShader = function(Le, Fe) {
    var Ee = Fe[Le.extensions[o.KHR_BINARY_GLTF].bufferView], Ge = new Uint8Array(Ee);
    return q(Ge);
  }, E.prototype.loadTextureSourceUri = function(Le, Fe) {
    var Ee = Le.extensions[o.KHR_BINARY_GLTF], Ge = Fe[Ee.bufferView], ve = q(new Uint8Array(Ge));
    return "data:" + Ee.mimeType + ";base64," + btoa(ve);
  };
  var d = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    TRIANGLES: 4,
    LINES: 1,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123,
    VERTEX_SHADER: 35633,
    FRAGMENT_SHADER: 35632
  }, f = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
  }, h = {
    9728: NearestFilter,
    9729: LinearFilter,
    9984: NearestMipMapNearestFilter,
    9985: LinearMipMapNearestFilter,
    9986: NearestMipMapLinearFilter,
    9987: LinearMipMapLinearFilter
  }, S = {
    33071: ClampToEdgeWrapping,
    33648: MirroredRepeatWrapping,
    10497: RepeatWrapping
  }, R = {
    6406: AlphaFormat,
    6407: RGBAFormat,
    6408: RGBAFormat,
    6409: LuminanceFormat,
    6410: LuminanceAlphaFormat
  }, _ = {
    5121: UnsignedByteType,
    32819: UnsignedShort4444Type,
    32820: UnsignedShort5551Type
  }, m = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
  }, L = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion"
  }, F = {
    LINEAR: InterpolateLinear,
    STEP: InterpolateDiscrete
  };
  function W(Le, Fe, Ee) {
    if (!Le)
      return Promise.resolve();
    var Ge, ve = [];
    if (Object.prototype.toString.call(Le) === "[object Array]") {
      Ge = [];
      for (var te = Le.length, ae = 0; ae < te; ae++) {
        var v = Fe.call(Ee || this, Le[ae], ae);
        v && (ve.push(v), v instanceof Promise ? v.then((function(De, be) {
          Ge[De] = be;
        }).bind(this, ae)) : Ge[ae] = v);
      }
    } else {
      Ge = {};
      for (var Te in Le)
        if (Le.hasOwnProperty(Te)) {
          var v = Fe.call(Ee || this, Le[Te], Te);
          v && (ve.push(v), v instanceof Promise ? v.then((function(be, ze) {
            Ge[be] = ze;
          }).bind(this, Te)) : Ge[Te] = v);
        }
    }
    return Promise.all(ve).then(function() {
      return Ge;
    });
  }
  function G(Le, Fe) {
    return typeof Le != "string" || Le === "" ? "" : /^(https?:)?\/\//i.test(Le) || /^data:.*,.*$/i.test(Le) ? Le : (Fe || "") + Le;
  }
  function q(Le) {
    for (var Fe = "", Ee = 0, Ge = Le.length; Ee < Ge; Ee++)
      Fe += String.fromCharCode(Le[Ee]);
    return Fe;
  }
  function fe() {
    return new PickingMeshPhongMaterial({
      color: 0,
      emissive: 8947848,
      specular: 0,
      shininess: 0,
      transparent: !1,
      depthTest: !0,
      side: FrontSide
    });
  }
  function _e(Le, Fe, Ee) {
    this.json = Le || {}, this.extensions = Fe || {}, this.options = Ee || {}, this.cache = new e();
  }
  return _e.prototype._withDependencies = function(Le) {
    for (var Fe = {}, Ee = 0; Ee < Le.length; Ee++) {
      var Ge = Le[Ee], ve = "load" + Ge.charAt(0).toUpperCase() + Ge.slice(1), te = this.cache.get(Ge);
      if (te !== void 0)
        Fe[Ge] = te;
      else if (this[ve]) {
        var ae = this[ve]();
        this.cache.add(Ge, ae), Fe[Ge] = ae;
      }
    }
    return W(Fe, function(v) {
      return v;
    });
  }, _e.prototype.parse = function(Le) {
    var Fe = this.json;
    this.cache.removeAll(), this._withDependencies(["scenes", "cameras", "animations"]).then(function(Ee) {
      var Ge = [];
      for (var ve in Ee.scenes)
        Ge.push(Ee.scenes[ve]);
      var te = Fe.scene !== void 0 ? Ee.scenes[Fe.scene] : Ge[0], ae = [];
      for (var ve in Ee.cameras) {
        var v = Ee.cameras[ve];
        ae.push(v);
      }
      var Te = [];
      for (var ve in Ee.animations)
        Te.push(Ee.animations[ve]);
      Le(te, Ge, ae, Te);
    });
  }, _e.prototype.loadShaders = function() {
    var Le = this.json, Fe = this.extensions, Ee = this.options;
    return this._withDependencies(["bufferViews"]).then(function(Ge) {
      return W(Le.shaders, function(ve) {
        return ve.extensions && ve.extensions[o.KHR_BINARY_GLTF] ? Fe[o.KHR_BINARY_GLTF].loadShader(ve, Ge.bufferViews) : new Promise(function(te) {
          var ae = new FileLoader$1();
          ae.setResponseType("text"), ae.load(G(ve.uri, Ee.path), function(v) {
            te(v);
          });
        });
      });
    });
  }, _e.prototype.loadBuffers = function() {
    var Le = this.json, Fe = this.extensions, Ee = this.options;
    return W(Le.buffers, function(Ge, ve) {
      if (ve === l)
        return Fe[o.KHR_BINARY_GLTF].body;
      if (Ge.type === "arraybuffer" || Ge.type === void 0)
        return new Promise(function(te) {
          var ae = new FileLoader$1();
          ae.setResponseType("arraybuffer"), ae.load(G(Ge.uri, Ee.path), function(v) {
            te(v);
          });
        });
      console.warn("THREE.GLTFLoader: " + Ge.type + " buffer type is not supported");
    });
  }, _e.prototype.loadBufferViews = function() {
    var Le = this.json;
    return this._withDependencies(["buffers"]).then(function(Fe) {
      return W(Le.bufferViews, function(Ee) {
        var Ge = Fe.buffers[Ee.buffer], ve = Ee.byteLength !== void 0 ? Ee.byteLength : 0;
        return Ge.slice(Ee.byteOffset, Ee.byteOffset + ve);
      });
    });
  }, _e.prototype.loadAccessors = function() {
    var Le = this.json;
    return this._withDependencies(["bufferViews"]).then(function(Fe) {
      return W(Le.accessors, function(Ee) {
        var Ge = Fe.bufferViews[Ee.bufferView], ve = m[Ee.type], te = f[Ee.componentType], ae = te.BYTES_PER_ELEMENT, v = ae * ve;
        if (Ee.byteStride && Ee.byteStride !== v) {
          var Te = new te(Ge), De = new InterleavedBuffer(Te, Ee.byteStride / ae);
          return new InterleavedBufferAttribute(De, ve, Ee.byteOffset / ae);
        } else
          return Te = new te(Ge, Ee.byteOffset, Ee.count * ve), new BufferAttribute(Te, ve);
      });
    });
  }, _e.prototype.loadTextures = function() {
    var Le = this.json, Fe = this.extensions, Ee = this.options;
    return this._withDependencies(["bufferViews"]).then(function(Ge) {
      return W(Le.textures, function(ve) {
        if (ve.source)
          return new Promise(function(te) {
            var ae = Le.images[ve.source], v = ae.uri;
            ae.extensions && ae.extensions[o.KHR_BINARY_GLTF] && (v = Fe[o.KHR_BINARY_GLTF].loadTextureSourceUri(ae, Ge.bufferViews));
            var Te = null;
            Te === null && (Te = new TextureLoader$1()), Te.setCrossOrigin(Ee.crossOrigin), Te.load(G(v, Ee.path), function(De) {
              if (De.flipY = !1, ve.name !== void 0 && (De.name = ve.name), De.format = ve.format !== void 0 ? R[ve.format] : RGBAFormat, ve.internalFormat !== void 0 && De.format !== R[ve.internalFormat] && console.warn("THREE.GLTFLoader: Three.js doesn't support texture internalFormat which is different from texture format. internalFormat will be forced to be the same value as format."), De.type = ve.type !== void 0 ? _[ve.type] : UnsignedByteType, ve.sampler) {
                var be = Le.samplers[ve.sampler];
                De.magFilter = h[be.magFilter] || LinearFilter, De.minFilter = h[be.minFilter] || NearestMipMapLinearFilter, De.wrapS = S[be.wrapS] || RepeatWrapping, De.wrapT = S[be.wrapT] || RepeatWrapping;
              }
              te(De);
            }, void 0, function() {
              te();
            });
          });
      });
    });
  }, _e.prototype.loadMaterials = function() {
    var Le = this.json, Fe = this.options;
    return this._withDependencies(["shaders", "textures"]).then(function(Ee) {
      return W(Le.materials, function(Ge) {
        var ve, te = {}, ae = {};
        ae.objectId = Fe.objectId || 0, ae.clippingPlanes = Fe.clippingPlanes || [];
        var v;
        if (Ge.extensions && Ge.extensions[o.KHR_MATERIALS_COMMON] && (v = Ge.extensions[o.KHR_MATERIALS_COMMON]), v) {
          var Te = ["ambient", "emission", "transparent", "transparency", "doubleSided"];
          switch (v.technique) {
            case "BLINN":
            case "PHONG":
              ve = PickingMeshPhongMaterial, Te.push("diffuse", "specular", "shininess");
              break;
            case "LAMBERT":
              ve = MeshLambertMaterial, Te.push("diffuse");
              break;
            case "CONSTANT":
            default:
              ve = PickingMeshBasicMaterial;
              break;
          }
          Te.forEach(function(be) {
            v.values[be] !== void 0 && (te[be] = v.values[be]);
          }), (v.doubleSided || te.doubleSided) && (ae.side = DoubleSide), (v.transparent || te.transparent) && (ae.transparent = !0, ae.opacity = te.transparency !== void 0 ? te.transparency : 1);
        } else
          Ge.technique === void 0 ? (ve = PickingMeshPhongMaterial, Object.assign(te, Ge.values)) : (ve = PickingMeshBasicMaterial, ae.map = Ee.textures.tex_0);
        Array.isArray(te.diffuse) ? ae.color = new Color().fromArray(te.diffuse) : typeof te.diffuse == "string" && (ae.map = Ee.textures[te.diffuse]), delete ae.diffuse, typeof te.reflective == "string" && (ae.envMap = Ee.textures[te.reflective]), typeof te.bump == "string" && (ae.bumpMap = Ee.textures[te.bump]), Array.isArray(te.emission) ? ve === PickingMeshBasicMaterial ? ae.color = new Color().fromArray(te.emission) : ae.emissive = new Color().fromArray(te.emission) : typeof te.emission == "string" && (ve === PickingMeshBasicMaterial ? ae.map = Ee.textures[te.emission] : ae.emissiveMap = Ee.textures[te.emission]), Array.isArray(te.specular) ? ae.specular = new Color().fromArray(te.specular) : typeof te.specular == "string" && (ae.specularMap = Ee.textures[te.specular]), te.shininess !== void 0 && (ae.shininess = te.shininess), ae.map !== void 0 && ae.map !== null && (ae.map.colorSpace = SRGBColorSpace), ae.specularMap !== void 0 && ae.specularMap !== null && (ae.specularMap.colorSpace = SRGBColorSpace);
        var De = new ve(ae);
        return Ge.name !== void 0 && (De.name = Ge.name), De;
      });
    });
  }, _e.prototype.loadMeshes = function() {
    var Le = this.json;
    return this._withDependencies(["accessors", "materials"]).then(function(Fe) {
      return W(Le.meshes, function(Ee) {
        var Ge = new Group();
        Ee.name !== void 0 && (Ge.name = Ee.name), Ee.extras && (Ge.userData = Ee.extras);
        var ve = Ee.primitives || [];
        for (var te in ve) {
          var ae = ve[te];
          if (ae.mode === d.TRIANGLES || ae.mode === void 0) {
            var v = new BufferGeometry(), Te = ae.attributes;
            for (var De in Te) {
              var be = Te[De];
              if (!be)
                return;
              var ze = Fe.accessors[be];
              switch (De) {
                case "POSITION":
                  v.setAttribute("position", ze);
                  break;
                case "NORMAL":
                  v.setAttribute("normal", ze);
                  break;
                case "TEXCOORD_0":
                case "TEXCOORD0":
                case "TEXCOORD":
                  v.setAttribute("uv", ze);
                  break;
                case "TEXCOORD_1":
                  v.setAttribute("uv2", ze);
                  break;
                case "COLOR_0":
                case "COLOR0":
                case "COLOR":
                  v.setAttribute("color", ze);
                  break;
                case "WEIGHT":
                  v.setAttribute("skinWeight", ze);
                  break;
                case "JOINT":
                  v.setAttribute("skinIndex", ze);
                  break;
              }
            }
            ae.indices && v.setIndex(Fe.accessors[ae.indices]);
            var ke = Fe.materials !== void 0 ? Fe.materials[ae.material] : fe(), Be = new Mesh(v, ke);
            Be.castShadow = !0, Be.name = te === "0" ? Ge.name : Ge.name + te, ae.extras && (Be.userData = ae.extras), Ge.add(Be);
          } else if (ae.mode === d.LINES) {
            var v = new BufferGeometry(), Te = ae.attributes;
            for (var De in Te) {
              var be = Te[De];
              if (!be)
                return;
              var ze = Fe.accessors[be];
              switch (De) {
                case "POSITION":
                  v.setAttribute("position", ze);
                  break;
                case "COLOR_0":
                case "COLOR0":
                case "COLOR":
                  v.setAttribute("color", ze);
                  break;
              }
            }
            var ke = Fe.materials[ae.material], Be;
            ae.indices ? (v.setIndex(Fe.accessors[ae.indices]), Be = new LineSegments(v, ke)) : Be = new Line$1(v, ke), Be.name = te === "0" ? Ge.name : Ge.name + te, ae.extras && (Be.userData = ae.extras), Ge.add(Be);
          } else
            console.warn("Only triangular and line primitives are supported");
        }
        return Ge;
      });
    });
  }, _e.prototype.loadCameras = function() {
    var Le = this.json;
    return W(Le.cameras, function(Fe) {
      if (Fe.type == "perspective" && Fe.perspective) {
        var Ee = Fe.perspective.yfov, Ge = Fe.perspective.aspectRatio !== void 0 ? Fe.perspective.aspectRatio : 1, ve = Ee * Ge, te = new PerspectiveCamera$1(MathUtils$1.radToDeg(ve), Ge, Fe.perspective.znear || 1, Fe.perspective.zfar || 2e6);
        return Fe.name !== void 0 && (te.name = Fe.name), Fe.extras && (te.userData = Fe.extras), te;
      } else if (Fe.type == "orthographic" && Fe.orthographic) {
        var te = new OrthographicCamera$1(window.innerWidth / -2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / -2, Fe.orthographic.znear, Fe.orthographic.zfar);
        return Fe.name !== void 0 && (te.name = Fe.name), Fe.extras && (te.userData = Fe.extras), te;
      }
    });
  }, _e.prototype.loadSkins = function() {
    var Le = this.json;
    return this._withDependencies(["accessors"]).then(function(Fe) {
      return W(Le.skins, function(Ee) {
        var Ge = new Matrix4();
        Ee.bindShapeMatrix !== void 0 && Ge.fromArray(Ee.bindShapeMatrix);
        var ve = {
          bindShapeMatrix: Ge,
          jointNames: Ee.jointNames,
          inverseBindMatrices: Fe.accessors[Ee.inverseBindMatrices]
        };
        return ve;
      });
    });
  }, _e.prototype.loadAnimations = function() {
    var Le = this.json;
    return this._withDependencies(["accessors", "nodes"]).then(function(Fe) {
      return W(Le.animations, function(Ee, Ge) {
        var ve = [];
        for (var te in Ee.channels) {
          var ae = Ee.channels[te], v = Ee.samplers[ae.sampler];
          if (v) {
            var Te = ae.target, xt = Te.id, De = Ee.parameters !== void 0 ? Ee.parameters[v.input] : v.input, be = Ee.parameters !== void 0 ? Ee.parameters[v.output] : v.output, ze = Fe.accessors[De], ke = Fe.accessors[be], Be = Fe.nodes[xt];
            if (Be) {
              Be.updateMatrix(), Be.matrixAutoUpdate = !0;
              var Me = L[Te.path] === L.rotation ? QuaternionKeyframeTrack : VectorKeyframeTrack, me = Be.name ? Be.name : Be.uuid, Se = v.interpolation !== void 0 ? F[v.interpolation] : InterpolateLinear;
              ve.push(new Me(me + "." + L[Te.path], AnimationUtils.arraySlice(ze.array, 0), AnimationUtils.arraySlice(ke.array, 0), Se));
            }
          }
        }
        var xt = Ee.name !== void 0 ? Ee.name : "animation_" + Ge;
        return new AnimationClip(xt, void 0, ve);
      });
    });
  }, _e.prototype.loadNodes = function() {
    var Le = this.json, Fe = this.extensions, Ee = this;
    return W(Le.nodes, function(Ge) {
      var ve = new Matrix4(), te;
      return Ge.jointName ? (te = new Bone(), te.name = Ge.name !== void 0 ? Ge.name : Ge.jointName, te.jointName = Ge.jointName) : (te = new Object3D(), Ge.name !== void 0 && (te.name = Ge.name)), Ge.extras && (te.userData = Ge.extras), Ge.matrix !== void 0 ? (ve.fromArray(Ge.matrix), te.applyMatrix(ve)) : (Ge.translation !== void 0 && te.position.fromArray(Ge.translation), Ge.rotation !== void 0 && te.quaternion.fromArray(Ge.rotation), Ge.scale !== void 0 && te.scale.fromArray(Ge.scale)), te;
    }).then(function(Ge) {
      return Ee._withDependencies(["meshes", "skins", "cameras"]).then(function(ve) {
        return W(Ge, function(te, ae) {
          var v = Le.nodes[ae];
          if (v.meshes !== void 0)
            for (var Te in v.meshes) {
              var De = v.meshes[Te], be = ve.meshes[De];
              if (be === void 0) {
                console.warn(`GLTFLoader: Couldn't find node "` + De + '".');
                continue;
              }
              for (var ze in be.children) {
                var ke = be.children[ze], Be = ke.material, Me = ke.geometry, me = ke.userData, Se = ke.name, xt;
                switch (Be.isDeferredShaderMaterial ? Be = xt = Be.create() : xt = Be, ke.type) {
                  case "LineSegments":
                    ke = new LineSegments(Me, xt);
                    break;
                  case "LineLoop":
                    ke = new LineLoop(Me, xt);
                    break;
                  case "Line":
                    ke = new Line$1(Me, xt);
                    break;
                  default:
                    ke = new Mesh(Me, xt);
                }
                ke.castShadow = !0, ke.userData = me, ke.name = Se;
                var Ht;
                if (v.skin && (Ht = ve.skins[v.skin]), Ht) {
                  var Bt = function(In) {
                    for (var Cn = Object.keys(Ge), It = 0, ht = Cn.length; It < ht; It++) {
                      var Wt = Ge[Cn[It]];
                      if (Wt.jointName === In)
                        return Wt;
                    }
                    return null;
                  }, ut = Me, xt = Be;
                  xt.skinning = !0, ke = new SkinnedMesh(ut, xt, !1), ke.castShadow = !0, ke.userData = me, ke.name = Se;
                  for (var Tt = [], Yt = [], an = 0, Ct = Ht.jointNames.length; an < Ct; an++) {
                    var st = Ht.jointNames[an], jt = Bt(st);
                    if (jt) {
                      Tt.push(jt);
                      var lt = Ht.inverseBindMatrices.array, Zt = new Matrix4().fromArray(lt, an * 16);
                      Yt.push(Zt);
                    } else
                      console.warn("WARNING: joint: '" + st + "' could not be found");
                  }
                  ke.bind(new Skeleton(Tt, Yt, !1), Ht.bindShapeMatrix);
                  var Et = function(In, Cn, It) {
                    var ht = In[It];
                    if (ht !== void 0)
                      for (var Wt = 0, hn = ht.length; Wt < hn; Wt++) {
                        var Vt = ht[Wt], Tn = Ge[Vt], Rn = Le.nodes[Vt];
                        Tn !== void 0 && Tn.isBone === !0 && Rn !== void 0 && (Cn.add(Tn), Et(Rn, Tn, "children"));
                      }
                  };
                  Et(v, ke, "skeletons");
                }
                te.add(ke);
              }
            }
          if (v.camera !== void 0) {
            var Ke = ve.cameras[v.camera];
            te.add(Ke);
          }
          if (v.extensions && v.extensions[o.KHR_MATERIALS_COMMON] && v.extensions[o.KHR_MATERIALS_COMMON].light) {
            var $e = Fe[o.KHR_MATERIALS_COMMON].lights, pt = $e[v.extensions[o.KHR_MATERIALS_COMMON].light];
            te.add(pt);
          }
          return te;
        });
      });
    });
  }, _e.prototype.loadScenes = function() {
    var Le = this.json;
    function Fe(Ee, Ge, ve) {
      var te = ve[Ee];
      Ge.add(te);
      var ae = Le.nodes[Ee];
      if (ae.children)
        for (var v = ae.children, Te = 0, De = v.length; Te < De; Te++) {
          var be = v[Te];
          Fe(be, te, ve);
        }
    }
    return this._withDependencies(["nodes"]).then(function(Ee) {
      return W(Le.scenes, function(Ge) {
        var ve = new Scene();
        Ge.name !== void 0 && (ve.name = Ge.name), Ge.extras && (ve.userData = Ge.extras);
        for (var te = Ge.nodes || [], ae = 0, v = te.length; ae < v; ae++) {
          var Te = te[ae];
          Fe(Te, ve, Ee.nodes);
        }
        return ve.traverse(function(De) {
          De.material && De.material.isRawShaderMaterial && (De.gltfShader = new s(De, Ee.nodes), De.onBeforeRender = function(be, ze, ke) {
            this.gltfShader.update(ze, ke);
          });
        }), ve;
      });
    });
  }, r;
}();
const _taskCache$1 = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends Loader {
  constructor(e) {
    super(e), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    }, this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(e) {
    return this.decoderPath = e, this;
  }
  setDecoderConfig(e) {
    return this.decoderConfig = e, this;
  }
  setWorkerLimit(e) {
    return this.workerLimit = e, this;
  }
  load(e, s, o, a) {
    const l = new FileLoader$1(this.manager);
    l.setPath(this.path), l.setResponseType("arraybuffer"), l.setRequestHeader(this.requestHeader), l.setWithCredentials(this.withCredentials), l.load(e, (u) => {
      this.parse(u, s, a);
    }, o, a);
  }
  parse(e, s, o) {
    this.decodeDracoFile(e, s, null, null, SRGBColorSpace).catch(o);
  }
  decodeDracoFile(e, s, o, a, l = LinearSRGBColorSpace) {
    const u = {
      attributeIDs: o || this.defaultAttributeIDs,
      attributeTypes: a || this.defaultAttributeTypes,
      useUniqueIDs: !!o,
      vertexColorSpace: l
    };
    return this.decodeGeometry(e, u).then(s);
  }
  decodeGeometry(e, s) {
    const o = JSON.stringify(s);
    if (_taskCache$1.has(e)) {
      const E = _taskCache$1.get(e);
      if (E.key === o)
        return E.promise;
      if (e.byteLength === 0)
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
    }
    let a;
    const l = this.workerNextTaskID++, u = e.byteLength, c = this._getWorker(l, u).then((E) => (a = E, new Promise((d, f) => {
      a._callbacks[l] = { resolve: d, reject: f }, a.postMessage({ type: "decode", id: l, taskConfig: s, buffer: e }, [e]);
    }))).then((E) => this._createGeometry(E.geometry));
    return c.catch(() => !0).then(() => {
      a && l && this._releaseTask(a, l);
    }), _taskCache$1.set(e, {
      key: o,
      promise: c
    }), c;
  }
  _createGeometry(e) {
    const s = new BufferGeometry();
    e.index && s.setIndex(new BufferAttribute(e.index.array, 1));
    for (let o = 0; o < e.attributes.length; o++) {
      const a = e.attributes[o], l = a.name, u = a.array, c = a.itemSize, E = new BufferAttribute(u, c);
      l === "color" && (this._assignVertexColorSpace(E, a.vertexColorSpace), E.normalized = !(u instanceof Float32Array)), s.setAttribute(l, E);
    }
    return s;
  }
  _assignVertexColorSpace(e, s) {
    if (s !== SRGBColorSpace)
      return;
    const o = new Color();
    for (let a = 0, l = e.count; a < l; a++)
      o.fromBufferAttribute(e, a).convertSRGBToLinear(), e.setXYZ(a, o.r, o.g, o.b);
  }
  _loadLibrary(e, s) {
    const o = new FileLoader$1(this.manager);
    return o.setPath(this.decoderPath), o.setResponseType(s), o.setWithCredentials(this.withCredentials), new Promise((a, l) => {
      o.load(e, a, void 0, l);
    });
  }
  preload() {
    return this._initDecoder(), this;
  }
  _initDecoder() {
    if (this.decoderPending)
      return this.decoderPending;
    const e = typeof WebAssembly != "object" || this.decoderConfig.type === "js", s = [];
    return e ? s.push(this._loadLibrary("draco_decoder.js", "text")) : (s.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), s.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(s).then((o) => {
      const a = o[0];
      e || (this.decoderConfig.wasmBinary = o[1]);
      const l = DRACOWorker.toString(), u = [
        "/* draco decoder */",
        a,
        "",
        "/* worker */",
        l.substring(l.indexOf("{") + 1, l.lastIndexOf("}"))
      ].join(`
`);
      this.workerSourceURL = URL.createObjectURL(new Blob([u]));
    }), this.decoderPending;
  }
  _getWorker(e, s) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const a = new Worker(this.workerSourceURL);
        a._callbacks = {}, a._taskCosts = {}, a._taskLoad = 0, a.postMessage({ type: "init", decoderConfig: this.decoderConfig }), a.onmessage = function(l) {
          const u = l.data;
          switch (u.type) {
            case "decode":
              a._callbacks[u.id].resolve(u);
              break;
            case "error":
              a._callbacks[u.id].reject(u);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + u.type + '"');
          }
        }, this.workerPool.push(a);
      } else
        this.workerPool.sort(function(a, l) {
          return a._taskLoad > l._taskLoad ? -1 : 1;
        });
      const o = this.workerPool[this.workerPool.length - 1];
      return o._taskCosts[e] = s, o._taskLoad += s, o;
    });
  }
  _releaseTask(e, s) {
    e._taskLoad -= e._taskCosts[s], delete e._callbacks[s], delete e._taskCosts[s];
  }
  debug() {
    console.log("Task load: ", this.workerPool.map((e) => e._taskLoad));
  }
  dispose() {
    for (let e = 0; e < this.workerPool.length; ++e)
      this.workerPool[e].terminate();
    return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
  }
}
function DRACOWorker() {
  let r, e;
  onmessage = function(u) {
    const c = u.data;
    switch (c.type) {
      case "init":
        r = c.decoderConfig, e = new Promise(function(f) {
          r.onModuleLoaded = function(h) {
            f({ draco: h });
          }, DracoDecoderModule(r);
        });
        break;
      case "decode":
        const E = c.buffer, d = c.taskConfig;
        e.then((f) => {
          const h = f.draco, S = new h.Decoder();
          try {
            const R = s(h, S, new Int8Array(E), d), _ = R.attributes.map((m) => m.array.buffer);
            R.index && _.push(R.index.array.buffer), self.postMessage({ type: "decode", id: c.id, geometry: R }, _);
          } catch (R) {
            console.error(R), self.postMessage({ type: "error", id: c.id, error: R.message });
          } finally {
            h.destroy(S);
          }
        });
        break;
    }
  };
  function s(u, c, E, d) {
    const f = d.attributeIDs, h = d.attributeTypes;
    let S, R;
    const _ = c.GetEncodedGeometryType(E);
    if (_ === u.TRIANGULAR_MESH)
      S = new u.Mesh(), R = c.DecodeArrayToMesh(E, E.byteLength, S);
    else if (_ === u.POINT_CLOUD)
      S = new u.PointCloud(), R = c.DecodeArrayToPointCloud(E, E.byteLength, S);
    else
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    if (!R.ok() || S.ptr === 0)
      throw new Error("THREE.DRACOLoader: Decoding failed: " + R.error_msg());
    const m = { index: null, attributes: [] };
    for (const L in f) {
      const F = self[h[L]];
      let W, G;
      if (d.useUniqueIDs)
        G = f[L], W = c.GetAttributeByUniqueId(S, G);
      else {
        if (G = c.GetAttributeId(S, u[f[L]]), G === -1)
          continue;
        W = c.GetAttribute(S, G);
      }
      const q = a(u, c, S, L, F, W);
      L === "color" && (q.vertexColorSpace = d.vertexColorSpace), m.attributes.push(q);
    }
    return _ === u.TRIANGULAR_MESH && (m.index = o(u, c, S)), u.destroy(S), m;
  }
  function o(u, c, E) {
    const f = E.num_faces() * 3, h = f * 4, S = u._malloc(h);
    c.GetTrianglesUInt32Array(E, h, S);
    const R = new Uint32Array(u.HEAPF32.buffer, S, f).slice();
    return u._free(S), { array: R, itemSize: 1 };
  }
  function a(u, c, E, d, f, h) {
    const S = h.num_components(), _ = E.num_points() * S, m = _ * f.BYTES_PER_ELEMENT, L = l(u, f), F = u._malloc(m);
    c.GetAttributeDataArrayForAllPoints(E, h, L, m, F);
    const W = new f(u.HEAPF32.buffer, F, _).slice();
    return u._free(F), {
      name: d,
      array: W,
      itemSize: S
    };
  }
  function l(u, c) {
    switch (c) {
      case Float32Array:
        return u.DT_FLOAT32;
      case Int8Array:
        return u.DT_INT8;
      case Int16Array:
        return u.DT_INT16;
      case Int32Array:
        return u.DT_INT32;
      case Uint8Array:
        return u.DT_UINT8;
      case Uint16Array:
        return u.DT_UINT16;
      case Uint32Array:
        return u.DT_UINT32;
    }
  }
}
let WorkerPool$1 = class {
  constructor(e = 4) {
    this.pool = e, this.queue = [], this.workers = [], this.workersResolve = [], this.workerStatus = 0;
  }
  _initWorker(e) {
    if (!this.workers[e]) {
      const s = this.workerCreator();
      s.addEventListener("message", this._onMessage.bind(this, e)), this.workers[e] = s;
    }
  }
  _getIdleWorker() {
    for (let e = 0; e < this.pool; e++)
      if (!(this.workerStatus & 1 << e))
        return e;
    return -1;
  }
  _onMessage(e, s) {
    const o = this.workersResolve[e];
    if (o && o(s), this.queue.length) {
      const { resolve: a, msg: l, transfer: u } = this.queue.shift();
      this.workersResolve[e] = a, this.workers[e].postMessage(l, u);
    } else
      this.workerStatus ^= 1 << e;
  }
  setWorkerCreator(e) {
    this.workerCreator = e;
  }
  setWorkerLimit(e) {
    this.pool = e;
  }
  postMessage(e, s) {
    return new Promise((o) => {
      const a = this._getIdleWorker();
      a !== -1 ? (this._initWorker(a), this.workerStatus |= 1 << a, this.workersResolve[a] = o, this.workers[a].postMessage(e, s)) : this.queue.push({ resolve: o, msg: e, transfer: s });
    });
  }
  dispose() {
    this.workers.forEach((e) => e.terminate()), this.workersResolve.length = 0, this.workers.length = 0, this.queue.length = 0, this.workerStatus = 0;
  }
};
const t = 0, n = 2, p = 1, x = 2, nt = 0, ct = 9, gt = 15, yt = 16, dt = 22, Ot = 37, Ft = 43, $t = 76, se = 83, pe = 97, xe = 100, de = 103, Ae = 109;
class Si {
  constructor() {
    this.vkFormat = 0, this.typeSize = 1, this.pixelWidth = 0, this.pixelHeight = 0, this.pixelDepth = 0, this.layerCount = 0, this.faceCount = 1, this.supercompressionScheme = 0, this.levels = [], this.dataFormatDescriptor = [{ vendorId: 0, descriptorType: 0, descriptorBlockSize: 0, versionNumber: 2, colorModel: 0, colorPrimaries: 1, transferFunction: 2, flags: 0, texelBlockDimension: [0, 0, 0, 0], bytesPlane: [0, 0, 0, 0, 0, 0, 0, 0], samples: [] }], this.keyValue = {}, this.globalData = null;
  }
}
class Ii {
  constructor(e, s, o, a) {
    this._dataView = new DataView(e.buffer, e.byteOffset + s, o), this._littleEndian = a, this._offset = 0;
  }
  _nextUint8() {
    const e = this._dataView.getUint8(this._offset);
    return this._offset += 1, e;
  }
  _nextUint16() {
    const e = this._dataView.getUint16(this._offset, this._littleEndian);
    return this._offset += 2, e;
  }
  _nextUint32() {
    const e = this._dataView.getUint32(this._offset, this._littleEndian);
    return this._offset += 4, e;
  }
  _nextUint64() {
    const e = this._dataView.getUint32(this._offset, this._littleEndian) + 4294967296 * this._dataView.getUint32(this._offset + 4, this._littleEndian);
    return this._offset += 8, e;
  }
  _nextInt32() {
    const e = this._dataView.getInt32(this._offset, this._littleEndian);
    return this._offset += 4, e;
  }
  _skip(e) {
    return this._offset += e, this;
  }
  _scan(e, s = 0) {
    const o = this._offset;
    let a = 0;
    for (; this._dataView.getUint8(this._offset) !== s && a < e; )
      a++, this._offset++;
    return a < e && this._offset++, new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + o, a);
  }
}
const Ti = [171, 75, 84, 88, 32, 50, 48, 187, 13, 10, 26, 10];
function Ei(r) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(r) : buffer$1.Buffer.from(r).toString("utf8");
}
function Pi(r) {
  const e = new Uint8Array(r.buffer, r.byteOffset, Ti.length);
  if (e[0] !== Ti[0] || e[1] !== Ti[1] || e[2] !== Ti[2] || e[3] !== Ti[3] || e[4] !== Ti[4] || e[5] !== Ti[5] || e[6] !== Ti[6] || e[7] !== Ti[7] || e[8] !== Ti[8] || e[9] !== Ti[9] || e[10] !== Ti[10] || e[11] !== Ti[11])
    throw new Error("Missing KTX 2.0 identifier.");
  const s = new Si(), o = 17 * Uint32Array.BYTES_PER_ELEMENT, a = new Ii(r, Ti.length, o, !0);
  s.vkFormat = a._nextUint32(), s.typeSize = a._nextUint32(), s.pixelWidth = a._nextUint32(), s.pixelHeight = a._nextUint32(), s.pixelDepth = a._nextUint32(), s.layerCount = a._nextUint32(), s.faceCount = a._nextUint32();
  const l = a._nextUint32();
  s.supercompressionScheme = a._nextUint32();
  const u = a._nextUint32(), c = a._nextUint32(), E = a._nextUint32(), d = a._nextUint32(), f = a._nextUint64(), h = a._nextUint64(), S = new Ii(r, Ti.length + o, 3 * l * 8, !0);
  for (let be = 0; be < l; be++)
    s.levels.push({ levelData: new Uint8Array(r.buffer, r.byteOffset + S._nextUint64(), S._nextUint64()), uncompressedByteLength: S._nextUint64() });
  const R = new Ii(r, u, c, !0), _ = { vendorId: R._skip(4)._nextUint16(), descriptorType: R._nextUint16(), versionNumber: R._nextUint16(), descriptorBlockSize: R._nextUint16(), colorModel: R._nextUint8(), colorPrimaries: R._nextUint8(), transferFunction: R._nextUint8(), flags: R._nextUint8(), texelBlockDimension: [R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8()], bytesPlane: [R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8()], samples: [] }, m = (_.descriptorBlockSize / 4 - 6) / 4;
  for (let be = 0; be < m; be++) {
    const ze = { bitOffset: R._nextUint16(), bitLength: R._nextUint8(), channelType: R._nextUint8(), samplePosition: [R._nextUint8(), R._nextUint8(), R._nextUint8(), R._nextUint8()], sampleLower: -1 / 0, sampleUpper: 1 / 0 };
    64 & ze.channelType ? (ze.sampleLower = R._nextInt32(), ze.sampleUpper = R._nextInt32()) : (ze.sampleLower = R._nextUint32(), ze.sampleUpper = R._nextUint32()), _.samples[be] = ze;
  }
  s.dataFormatDescriptor.length = 0, s.dataFormatDescriptor.push(_);
  const L = new Ii(r, E, d, !0);
  for (; L._offset < d; ) {
    const be = L._nextUint32(), ze = L._scan(be), ke = Ei(ze), Be = L._scan(be - ze.byteLength);
    s.keyValue[ke] = ke.match(/^ktx/i) ? Ei(Be) : Be, L._offset % 4 && L._skip(4 - L._offset % 4);
  }
  if (h <= 0)
    return s;
  const F = new Ii(r, f, h, !0), W = F._nextUint16(), G = F._nextUint16(), q = F._nextUint32(), fe = F._nextUint32(), _e = F._nextUint32(), Le = F._nextUint32(), Fe = [];
  for (let be = 0; be < l; be++)
    Fe.push({ imageFlags: F._nextUint32(), rgbSliceByteOffset: F._nextUint32(), rgbSliceByteLength: F._nextUint32(), alphaSliceByteOffset: F._nextUint32(), alphaSliceByteLength: F._nextUint32() });
  const Ee = f + F._offset, Ge = Ee + q, ve = Ge + fe, te = ve + _e, ae = new Uint8Array(r.buffer, r.byteOffset + Ee, q), v = new Uint8Array(r.buffer, r.byteOffset + Ge, fe), Te = new Uint8Array(r.buffer, r.byteOffset + ve, _e), De = new Uint8Array(r.buffer, r.byteOffset + te, Le);
  return s.globalData = { endpointCount: W, selectorCount: G, imageDescs: Fe, endpointsData: ae, selectorsData: v, tablesData: Te, extendedData: De }, s;
}
let A$1, I$1, B;
const g = { env: { emscripten_notify_memory_growth: function(r) {
  B = new Uint8Array(I$1.exports.memory.buffer);
} } };
class Q {
  init() {
    return A$1 || (A$1 = typeof fetch < "u" ? fetch("data:application/wasm;base64," + C).then((e) => e.arrayBuffer()).then((e) => WebAssembly.instantiate(e, g)).then(this._init) : WebAssembly.instantiate(buffer$1.Buffer.from(C, "base64"), g).then(this._init), A$1);
  }
  _init(e) {
    I$1 = e.instance, g.env.emscripten_notify_memory_growth(0);
  }
  decode(e, s = 0) {
    if (!I$1)
      throw new Error("ZSTDDecoder: Await .init() before decoding.");
    const o = e.byteLength, a = I$1.exports.malloc(o);
    B.set(e, a), s = s || Number(I$1.exports.ZSTD_findDecompressedSize(a, o));
    const l = I$1.exports.malloc(s), u = I$1.exports.ZSTD_decompress(l, s, a, o), c = B.slice(l, l + u);
    return I$1.exports.free(a), I$1.exports.free(l), c;
  }
}
const C = "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", _taskCache = /* @__PURE__ */ new WeakMap();
let _activeLoaders = 0, _zstd;
class KTX2Loader extends Loader {
  constructor(e) {
    super(e), this.transcoderPath = "", this.transcoderBinary = null, this.transcoderPending = null, this.workerPool = new WorkerPool$1(), this.workerSourceURL = "", this.workerConfig = null, typeof MSC_TRANSCODER < "u" && console.warn(
      'THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.'
    );
  }
  setTranscoderPath(e) {
    return this.transcoderPath = e, this;
  }
  setWorkerLimit(e) {
    return this.workerPool.setWorkerLimit(e), this;
  }
  detectSupport(e) {
    return e.isWebGPURenderer === !0 ? this.workerConfig = {
      astcSupported: e.hasFeature("texture-compression-astc"),
      etc1Supported: !1,
      etc2Supported: e.hasFeature("texture-compression-etc2"),
      dxtSupported: e.hasFeature("texture-compression-bc"),
      bptcSupported: !1,
      pvrtcSupported: !1
    } : (this.workerConfig = {
      astcSupported: e.extensions.has("WEBGL_compressed_texture_astc"),
      etc1Supported: e.extensions.has("WEBGL_compressed_texture_etc1"),
      etc2Supported: e.extensions.has("WEBGL_compressed_texture_etc"),
      dxtSupported: e.extensions.has("WEBGL_compressed_texture_s3tc"),
      bptcSupported: e.extensions.has("EXT_texture_compression_bptc"),
      pvrtcSupported: e.extensions.has("WEBGL_compressed_texture_pvrtc") || e.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
    }, e.capabilities.isWebGL2 && (this.workerConfig.etc1Supported = !1)), this;
  }
  init() {
    if (!this.transcoderPending) {
      const e = new FileLoader$1(this.manager);
      e.setPath(this.transcoderPath), e.setWithCredentials(this.withCredentials);
      const s = e.loadAsync("basis_transcoder.js"), o = new FileLoader$1(this.manager);
      o.setPath(this.transcoderPath), o.setResponseType("arraybuffer"), o.setWithCredentials(this.withCredentials);
      const a = o.loadAsync("basis_transcoder.wasm");
      this.transcoderPending = Promise.all([s, a]).then(([l, u]) => {
        const c = KTX2Loader.BasisWorker.toString(), E = [
          "/* constants */",
          "let _EngineFormat = " + JSON.stringify(KTX2Loader.EngineFormat),
          "let _TranscoderFormat = " + JSON.stringify(KTX2Loader.TranscoderFormat),
          "let _BasisFormat = " + JSON.stringify(KTX2Loader.BasisFormat),
          "/* basis_transcoder.js */",
          l,
          "/* worker */",
          c.substring(c.indexOf("{") + 1, c.lastIndexOf("}"))
        ].join(`
`);
        this.workerSourceURL = URL.createObjectURL(new Blob([E])), this.transcoderBinary = u, this.workerPool.setWorkerCreator(() => {
          const d = new Worker(this.workerSourceURL), f = this.transcoderBinary.slice(0);
          return d.postMessage({ type: "init", config: this.workerConfig, transcoderBinary: f }, [f]), d;
        });
      }), _activeLoaders > 0 && console.warn(
        "THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues. Use a single KTX2Loader instance, or call .dispose() on old instances."
      ), _activeLoaders++;
    }
    return this.transcoderPending;
  }
  load(e, s, o, a) {
    if (this.workerConfig === null)
      throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
    const l = new FileLoader$1(this.manager);
    l.setResponseType("arraybuffer"), l.setWithCredentials(this.withCredentials), l.load(e, (u) => {
      if (_taskCache.has(u))
        return _taskCache.get(u).promise.then(s).catch(a);
      this._createTexture(u).then((c) => s ? s(c) : null).catch(a);
    }, o, a);
  }
  _createTextureFrom(e, s) {
    const { faces: o, width: a, height: l, format: u, type: c, error: E, dfdTransferFn: d, dfdFlags: f } = e;
    if (c === "error")
      return Promise.reject(E);
    let h;
    if (s.faceCount === 6)
      h = new CompressedTexture(), h.image = o, h.format = u, h.type = UnsignedByteType;
    else {
      const S = o[0].mipmaps;
      h = s.layerCount > 1 ? new CompressedArrayTexture(S, a, l, s.layerCount, u, UnsignedByteType) : new CompressedTexture(S, a, l, u, UnsignedByteType);
    }
    return h.minFilter = o[0].mipmaps.length === 1 ? LinearFilter : LinearMipmapLinearFilter, h.magFilter = LinearFilter, h.generateMipmaps = !1, h.needsUpdate = !0, h.colorSpace = d === x ? SRGBColorSpace : NoColorSpace, h.premultiplyAlpha = !!(f & p), h;
  }
  /**
   * @param {ArrayBuffer} buffer
   * @param {object?} config
   * @return {Promise<CompressedTexture|CompressedArrayTexture|DataTexture|Data3DTexture>}
   */
  async _createTexture(e, s = {}) {
    const o = Pi(new Uint8Array(e));
    if (o.vkFormat !== nt) {
      const u = [], c = [];
      for (let d = 0; d < o.levels.length; d++)
        c.push(createDataTexture(o, d).then(function(f) {
          u[d] = f;
        }));
      await Promise.all(c);
      const E = u[0];
      return E.mipmaps = u.map((d) => ({
        data: d.source.data,
        width: d.source.data.width,
        height: d.source.data.height,
        depth: d.source.data.depth
      })), E;
    }
    const a = s, l = this.init().then(() => this.workerPool.postMessage({ type: "transcode", buffer: e, taskConfig: a }, [e])).then((u) => this._createTextureFrom(u.data, o));
    return _taskCache.set(e, { promise: l }), l;
  }
  dispose() {
    return this.workerPool.dispose(), this.workerSourceURL && URL.revokeObjectURL(this.workerSourceURL), _activeLoaders--, this;
  }
}
KTX2Loader.BasisFormat = {
  ETC1S: 0,
  UASTC_4x4: 1
};
KTX2Loader.TranscoderFormat = {
  ETC1: 0,
  ETC2: 1,
  BC1: 2,
  BC3: 3,
  BC4: 4,
  BC5: 5,
  BC7_M6_OPAQUE_ONLY: 6,
  BC7_M5: 7,
  PVRTC1_4_RGB: 8,
  PVRTC1_4_RGBA: 9,
  ASTC_4x4: 10,
  ATC_RGB: 11,
  ATC_RGBA_INTERPOLATED_ALPHA: 12,
  RGBA32: 13,
  RGB565: 14,
  BGR565: 15,
  RGBA4444: 16
};
KTX2Loader.EngineFormat = {
  RGBAFormat,
  RGBA_ASTC_4x4_Format,
  RGBA_BPTC_Format,
  RGBA_ETC2_EAC_Format,
  RGBA_PVRTC_4BPPV1_Format,
  RGBA_S3TC_DXT5_Format,
  RGB_ETC1_Format,
  RGB_ETC2_Format,
  RGB_PVRTC_4BPPV1_Format,
  RGB_S3TC_DXT1_Format
};
KTX2Loader.BasisWorker = function() {
  let r, e, s;
  const o = _EngineFormat, a = _TranscoderFormat, l = _BasisFormat;
  self.addEventListener("message", function(_) {
    const m = _.data;
    switch (m.type) {
      case "init":
        r = m.config, u(m.transcoderBinary);
        break;
      case "transcode":
        e.then(() => {
          try {
            const { faces: L, buffers: F, width: W, height: G, hasAlpha: q, format: fe, dfdTransferFn: _e, dfdFlags: Le } = c(m.buffer);
            self.postMessage({ type: "transcode", id: m.id, faces: L, width: W, height: G, hasAlpha: q, format: fe, dfdTransferFn: _e, dfdFlags: Le }, F);
          } catch (L) {
            console.error(L), self.postMessage({ type: "error", id: m.id, error: L.message });
          }
        });
        break;
    }
  });
  function u(_) {
    e = new Promise((m) => {
      s = { wasmBinary: _, onRuntimeInitialized: m }, BASIS(s);
    }).then(() => {
      s.initializeBasis(), s.KTX2File === void 0 && console.warn("THREE.KTX2Loader: Please update Basis Universal transcoder.");
    });
  }
  function c(_) {
    const m = new s.KTX2File(new Uint8Array(_));
    function L() {
      m.close(), m.delete();
    }
    if (!m.isValid())
      throw L(), new Error("THREE.KTX2Loader:	Invalid or unsupported .ktx2 file");
    const F = m.isUASTC() ? l.UASTC_4x4 : l.ETC1S, W = m.getWidth(), G = m.getHeight(), q = m.getLayers() || 1, fe = m.getLevels(), _e = m.getFaces(), Le = m.getHasAlpha(), Fe = m.getDFDTransferFunc(), Ee = m.getDFDFlags(), { transcoderFormat: Ge, engineFormat: ve } = h(F, W, G, Le);
    if (!W || !G || !fe)
      throw L(), new Error("THREE.KTX2Loader:	Invalid texture");
    if (!m.startTranscoding())
      throw L(), new Error("THREE.KTX2Loader: .startTranscoding failed");
    const te = [], ae = [];
    for (let v = 0; v < _e; v++) {
      const Te = [];
      for (let De = 0; De < fe; De++) {
        const be = [];
        let ze, ke;
        for (let Me = 0; Me < q; Me++) {
          const me = m.getImageLevelInfo(De, Me, v);
          v === 0 && De === 0 && Me === 0 && (me.origWidth % 4 !== 0 || me.origHeight % 4 !== 0) && console.warn("THREE.KTX2Loader: ETC1S and UASTC textures should use multiple-of-four dimensions."), fe > 1 ? (ze = me.origWidth, ke = me.origHeight) : (ze = me.width, ke = me.height);
          const Se = new Uint8Array(m.getImageTranscodedSizeInBytes(De, Me, 0, Ge));
          if (!m.transcodeImage(Se, De, Me, v, Ge, 0, -1, -1))
            throw L(), new Error("THREE.KTX2Loader: .transcodeImage failed.");
          be.push(Se);
        }
        const Be = R(be);
        Te.push({ data: Be, width: ze, height: ke }), ae.push(Be.buffer);
      }
      te.push({ mipmaps: Te, width: W, height: G, format: ve });
    }
    return L(), { faces: te, buffers: ae, width: W, height: G, hasAlpha: Le, format: ve, dfdTransferFn: Fe, dfdFlags: Ee };
  }
  const E = [
    {
      if: "astcSupported",
      basisFormat: [l.UASTC_4x4],
      transcoderFormat: [a.ASTC_4x4, a.ASTC_4x4],
      engineFormat: [o.RGBA_ASTC_4x4_Format, o.RGBA_ASTC_4x4_Format],
      priorityETC1S: 1 / 0,
      priorityUASTC: 1,
      needsPowerOfTwo: !1
    },
    {
      if: "bptcSupported",
      basisFormat: [l.ETC1S, l.UASTC_4x4],
      transcoderFormat: [a.BC7_M5, a.BC7_M5],
      engineFormat: [o.RGBA_BPTC_Format, o.RGBA_BPTC_Format],
      priorityETC1S: 3,
      priorityUASTC: 2,
      needsPowerOfTwo: !1
    },
    {
      if: "dxtSupported",
      basisFormat: [l.ETC1S, l.UASTC_4x4],
      transcoderFormat: [a.BC1, a.BC3],
      engineFormat: [o.RGB_S3TC_DXT1_Format, o.RGBA_S3TC_DXT5_Format],
      priorityETC1S: 4,
      priorityUASTC: 5,
      needsPowerOfTwo: !1
    },
    {
      if: "etc2Supported",
      basisFormat: [l.ETC1S, l.UASTC_4x4],
      transcoderFormat: [a.ETC1, a.ETC2],
      engineFormat: [o.RGB_ETC2_Format, o.RGBA_ETC2_EAC_Format],
      priorityETC1S: 1,
      priorityUASTC: 3,
      needsPowerOfTwo: !1
    },
    {
      if: "etc1Supported",
      basisFormat: [l.ETC1S, l.UASTC_4x4],
      transcoderFormat: [a.ETC1],
      engineFormat: [o.RGB_ETC1_Format],
      priorityETC1S: 2,
      priorityUASTC: 4,
      needsPowerOfTwo: !1
    },
    {
      if: "pvrtcSupported",
      basisFormat: [l.ETC1S, l.UASTC_4x4],
      transcoderFormat: [a.PVRTC1_4_RGB, a.PVRTC1_4_RGBA],
      engineFormat: [o.RGB_PVRTC_4BPPV1_Format, o.RGBA_PVRTC_4BPPV1_Format],
      priorityETC1S: 5,
      priorityUASTC: 6,
      needsPowerOfTwo: !0
    }
  ], d = E.sort(function(_, m) {
    return _.priorityETC1S - m.priorityETC1S;
  }), f = E.sort(function(_, m) {
    return _.priorityUASTC - m.priorityUASTC;
  });
  function h(_, m, L, F) {
    let W, G;
    const q = _ === l.ETC1S ? d : f;
    for (let fe = 0; fe < q.length; fe++) {
      const _e = q[fe];
      if (r[_e.if] && _e.basisFormat.includes(_) && !(F && _e.transcoderFormat.length < 2) && !(_e.needsPowerOfTwo && !(S(m) && S(L))))
        return W = _e.transcoderFormat[F ? 1 : 0], G = _e.engineFormat[F ? 1 : 0], { transcoderFormat: W, engineFormat: G };
    }
    return console.warn("THREE.KTX2Loader: No suitable compressed texture format found. Decoding to RGBA32."), W = a.RGBA32, G = o.RGBAFormat, { transcoderFormat: W, engineFormat: G };
  }
  function S(_) {
    return _ <= 2 ? !0 : (_ & _ - 1) === 0 && _ !== 0;
  }
  function R(_) {
    if (_.length === 1)
      return _[0];
    let m = 0;
    for (let W = 0; W < _.length; W++) {
      const G = _[W];
      m += G.byteLength;
    }
    const L = new Uint8Array(m);
    let F = 0;
    for (let W = 0; W < _.length; W++) {
      const G = _[W];
      L.set(G, F), F += G.byteLength;
    }
    return L;
  }
};
const FORMAT_MAP = {
  [Ae]: RGBAFormat,
  [pe]: RGBAFormat,
  [Ot]: RGBAFormat,
  [Ft]: RGBAFormat,
  [de]: RGFormat,
  [se]: RGFormat,
  [yt]: RGFormat,
  [dt]: RGFormat,
  [xe]: RedFormat,
  [$t]: RedFormat,
  [gt]: RedFormat,
  [ct]: RedFormat
}, TYPE_MAP = {
  [Ae]: FloatType,
  [pe]: HalfFloatType,
  [Ot]: UnsignedByteType,
  [Ft]: UnsignedByteType,
  [de]: FloatType,
  [se]: HalfFloatType,
  [yt]: UnsignedByteType,
  [dt]: UnsignedByteType,
  [xe]: FloatType,
  [$t]: HalfFloatType,
  [gt]: UnsignedByteType,
  [ct]: UnsignedByteType
}, COLOR_SPACE_MAP = {
  [Ft]: SRGBColorSpace,
  [dt]: SRGBColorSpace,
  [gt]: SRGBColorSpace
};
async function createDataTexture(r, e = 0) {
  const { vkFormat: s } = r, o = Math.max(1, r.pixelWidth >> e), a = Math.max(1, r.pixelHeight >> e), l = Math.max(1, r.pixelDepth >> e);
  if (FORMAT_MAP[s] === void 0)
    throw new Error("THREE.KTX2Loader: Unsupported vkFormat.");
  const u = r.levels[e];
  let c, E;
  if (r.supercompressionScheme === t)
    c = u.levelData;
  else if (r.supercompressionScheme === n)
    _zstd || (_zstd = new Promise(async (f) => {
      const h = new Q();
      await h.init(), f(h);
    })), c = (await _zstd).decode(u.levelData, u.uncompressedByteLength);
  else
    throw new Error("THREE.KTX2Loader: Unsupported supercompressionScheme.");
  TYPE_MAP[s] === FloatType ? E = new Float32Array(
    c.buffer,
    c.byteOffset,
    c.byteLength / Float32Array.BYTES_PER_ELEMENT
  ) : TYPE_MAP[s] === HalfFloatType ? E = new Uint16Array(
    c.buffer,
    c.byteOffset,
    c.byteLength / Uint16Array.BYTES_PER_ELEMENT
  ) : E = c;
  const d = l === 0 ? new DataTexture(E, o, a) : new Data3DTexture(E, o, a, l);
  return d.type = TYPE_MAP[s], d.format = FORMAT_MAP[s], d.colorSpace = COLOR_SPACE_MAP[s] || NoColorSpace, d.needsUpdate = !0, Promise.resolve(d);
}
var __awaiter$S = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class GltfLoader {
  static parseGlb(e, s, o = {}) {
    return __awaiter$S(this, void 0, void 0, function* () {
      return yield new Promise((a, l) => {
        GltfLoader.LOADER.parse(e, s, (u) => {
          a(u);
        }, (u) => {
          try {
            GltfLoader.LOADER_OLD.parse(e, (c) => a(c), s, o);
          } catch {
            l(u);
          }
        }, o);
      });
    });
  }
  static configureLoaders(e, s, o) {
    this.LOADER = loaderInit(e, s, o);
  }
}
GltfLoader.LOADER_OLD = new GLTFLoader();
GltfLoader.LOADER = loaderInit();
function loaderInit(r, e, s) {
  const o = new DRACOLoader();
  r !== void 0 && o.setDecoderPath(r);
  const a = new KTX2Loader();
  e !== void 0 && a.setTranscoderPath(e), s !== void 0 && a.detectSupport(s);
  const l = new GLTFLoader$1();
  return l.setDRACOLoader(o), l.setKTX2Loader(a), l;
}
class ImageLoader {
  static load(e, s) {
    return new Promise((o, a) => {
      const l = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
      l.onload = () => {
        l.onload = null, URL.revokeObjectURL(l.src), o(l);
      }, l.onerror = (u) => {
        a();
      }, FileLoader.loadBlob(e, s).then((u) => {
        l.src = URL.createObjectURL(u);
      }, a);
    });
  }
}
var __awaiter$R = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class TextureLoader {
  static load(e, s) {
    return __awaiter$R(this, void 0, void 0, function* () {
      const o = yield ImageLoader.load(e, s), a = new Texture();
      return a.image = o, a.needsUpdate = !0, a;
    });
  }
}
var __defProp = Object.defineProperty, __defProps = Object.defineProperties, __getOwnPropDescs = Object.getOwnPropertyDescriptors, __getOwnPropSymbols = Object.getOwnPropertySymbols, __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable, __defNormalProp = (r, e, s) => e in r ? __defProp(r, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[e] = s, __spreadValues = (r, e) => {
  for (var s in e || (e = {}))
    __hasOwnProp.call(e, s) && __defNormalProp(r, s, e[s]);
  if (__getOwnPropSymbols)
    for (var s of __getOwnPropSymbols(e))
      __propIsEnum.call(e, s) && __defNormalProp(r, s, e[s]);
  return r;
}, __spreadProps = (r, e) => __defProps(r, __getOwnPropDescs(e)), __commonJS = (r, e) => function() {
  return e || (0, r[Object.keys(r)[0]])((e = { exports: {} }).exports, e), e.exports;
}, __async = (r, e, s) => new Promise((o, a) => {
  var l = (E) => {
    try {
      c(s.next(E));
    } catch (d) {
      a(d);
    }
  }, u = (E) => {
    try {
      c(s.throw(E));
    } catch (d) {
      a(d);
    }
  }, c = (E) => E.done ? o(E.value) : Promise.resolve(E.value).then(l, u);
  c((s = s.apply(r, e)).next());
}), require_web_ifc_mt = __commonJS({
  "dist/web-ifc-mt.js"(r, e) {
    var s = (() => {
      var o = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(a = {}) {
        function l() {
          return De.buffer != ut.buffer && Zt(), ut;
        }
        function u() {
          return De.buffer != ut.buffer && Zt(), Tt;
        }
        function c() {
          return De.buffer != ut.buffer && Zt(), Yt;
        }
        function E() {
          return De.buffer != ut.buffer && Zt(), an;
        }
        function d() {
          return De.buffer != ut.buffer && Zt(), Ct;
        }
        function f() {
          return De.buffer != ut.buffer && Zt(), st;
        }
        function h() {
          return De.buffer != ut.buffer && Zt(), jt;
        }
        function S() {
          return De.buffer != ut.buffer && Zt(), lt;
        }
        var R = typeof a < "u" ? a : {}, _, m;
        R.ready = new Promise(function(je, Je) {
          _ = je, m = Je;
        });
        var L = Object.assign({}, R), F = "./this.program", W = (je, Je) => {
          throw Je;
        }, G = typeof window == "object", q = typeof importScripts == "function", fe = typeof api$1 == "object" && typeof api$1.versions == "object" && typeof api$1.versions.node == "string", _e = R.ENVIRONMENT_IS_PTHREAD || !1, Le = "";
        function Fe(je) {
          return R.locateFile ? R.locateFile(je, Le) : Le + je;
        }
        var Ee, Ge, ve;
        (G || q) && (q ? Le = self.location.href : typeof document < "u" && document.currentScript && (Le = document.currentScript.src), o && (Le = o), Le.indexOf("blob:") !== 0 ? Le = Le.substr(0, Le.replace(/[?#].*/, "").lastIndexOf("/") + 1) : Le = "", Ee = (je) => {
          var Je = new XMLHttpRequest();
          return Je.open("GET", je, !1), Je.send(null), Je.responseText;
        }, q && (ve = (je) => {
          var Je = new XMLHttpRequest();
          return Je.open("GET", je, !1), Je.responseType = "arraybuffer", Je.send(null), new Uint8Array(Je.response);
        }), Ge = (je, Je, At) => {
          var qt = new XMLHttpRequest();
          qt.open("GET", je, !0), qt.responseType = "arraybuffer", qt.onload = () => {
            if (qt.status == 200 || qt.status == 0 && qt.response) {
              Je(qt.response);
              return;
            }
            At();
          }, qt.onerror = At, qt.send(null);
        });
        var te = R.print || console.log.bind(console), ae = R.printErr || console.warn.bind(console);
        Object.assign(R, L), L = null, R.arguments && R.arguments, R.thisProgram && (F = R.thisProgram), R.quit && (W = R.quit);
        var v;
        R.wasmBinary && (v = R.wasmBinary);
        var Te = R.noExitRuntime || !0;
        typeof WebAssembly != "object" && $n("no native wasm support detected");
        var De, be, ze = !1, ke;
        function Be(je, Je) {
          je || $n(Je);
        }
        var Me = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
        function me(je, Je, At) {
          Je >>>= 0;
          for (var qt = Je + At, un = Je; je[un] && !(un >= qt); )
            ++un;
          if (un - Je > 16 && je.buffer && Me)
            return Me.decode(je.buffer instanceof SharedArrayBuffer ? je.slice(Je, un) : je.subarray(Je, un));
          for (var An = ""; Je < un; ) {
            var Fn = je[Je++];
            if (!(Fn & 128)) {
              An += String.fromCharCode(Fn);
              continue;
            }
            var wn = je[Je++] & 63;
            if ((Fn & 224) == 192) {
              An += String.fromCharCode((Fn & 31) << 6 | wn);
              continue;
            }
            var Hn = je[Je++] & 63;
            if ((Fn & 240) == 224 ? Fn = (Fn & 15) << 12 | wn << 6 | Hn : Fn = (Fn & 7) << 18 | wn << 12 | Hn << 6 | je[Je++] & 63, Fn < 65536)
              An += String.fromCharCode(Fn);
            else {
              var Er = Fn - 65536;
              An += String.fromCharCode(55296 | Er >> 10, 56320 | Er & 1023);
            }
          }
          return An;
        }
        function Se(je, Je) {
          return je >>>= 0, je ? me(u(), je, Je) : "";
        }
        function xt(je, Je, At, qt) {
          if (At >>>= 0, !(qt > 0))
            return 0;
          for (var un = At, An = At + qt - 1, Fn = 0; Fn < je.length; ++Fn) {
            var wn = je.charCodeAt(Fn);
            if (wn >= 55296 && wn <= 57343) {
              var Hn = je.charCodeAt(++Fn);
              wn = 65536 + ((wn & 1023) << 10) | Hn & 1023;
            }
            if (wn <= 127) {
              if (At >= An)
                break;
              Je[At++ >>> 0] = wn;
            } else if (wn <= 2047) {
              if (At + 1 >= An)
                break;
              Je[At++ >>> 0] = 192 | wn >> 6, Je[At++ >>> 0] = 128 | wn & 63;
            } else if (wn <= 65535) {
              if (At + 2 >= An)
                break;
              Je[At++ >>> 0] = 224 | wn >> 12, Je[At++ >>> 0] = 128 | wn >> 6 & 63, Je[At++ >>> 0] = 128 | wn & 63;
            } else {
              if (At + 3 >= An)
                break;
              Je[At++ >>> 0] = 240 | wn >> 18, Je[At++ >>> 0] = 128 | wn >> 12 & 63, Je[At++ >>> 0] = 128 | wn >> 6 & 63, Je[At++ >>> 0] = 128 | wn & 63;
            }
          }
          return Je[At >>> 0] = 0, At - un;
        }
        function Ht(je, Je, At) {
          return xt(je, u(), Je, At);
        }
        function Bt(je) {
          for (var Je = 0, At = 0; At < je.length; ++At) {
            var qt = je.charCodeAt(At);
            qt <= 127 ? Je++ : qt <= 2047 ? Je += 2 : qt >= 55296 && qt <= 57343 ? (Je += 4, ++At) : Je += 3;
          }
          return Je;
        }
        var ut, Tt, Yt, an, Ct, st, jt, lt;
        function Zt() {
          var je = De.buffer;
          R.HEAP8 = ut = new Int8Array(je), R.HEAP16 = Yt = new Int16Array(je), R.HEAP32 = Ct = new Int32Array(je), R.HEAPU8 = Tt = new Uint8Array(je), R.HEAPU16 = an = new Uint16Array(je), R.HEAPU32 = st = new Uint32Array(je), R.HEAPF32 = jt = new Float32Array(je), R.HEAPF64 = lt = new Float64Array(je);
        }
        var Et = R.INITIAL_MEMORY || 16777216;
        if (Be(Et >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + Et + "! (STACK_SIZE=5242880)"), _e)
          De = R.wasmMemory;
        else if (R.wasmMemory)
          De = R.wasmMemory;
        else if (De = new WebAssembly.Memory({ initial: Et / 65536, maximum: 65536, shared: !0 }), !(De.buffer instanceof SharedArrayBuffer))
          throw ae("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag"), fe && ae("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)"), Error("bad memory");
        Zt(), Et = De.buffer.byteLength;
        var Ke, $e = [], pt = [], Jt = [];
        function In() {
          return Te;
        }
        function Cn() {
          if (R.preRun)
            for (typeof R.preRun == "function" && (R.preRun = [R.preRun]); R.preRun.length; )
              Wt(R.preRun.shift());
          qn($e);
        }
        function It() {
          _e || (!R.noFSInit && !en.init.initialized && en.init(), en.ignorePermissions = !1, qn(pt));
        }
        function ht() {
          if (!_e) {
            if (R.postRun)
              for (typeof R.postRun == "function" && (R.postRun = [R.postRun]); R.postRun.length; )
                Vt(R.postRun.shift());
            qn(Jt);
          }
        }
        function Wt(je) {
          $e.unshift(je);
        }
        function hn(je) {
          pt.unshift(je);
        }
        function Vt(je) {
          Jt.unshift(je);
        }
        var Tn = 0, Rn = null;
        function Nn(je) {
          return je;
        }
        function Dn(je) {
          Tn++, R.monitorRunDependencies && R.monitorRunDependencies(Tn);
        }
        function xn(je) {
          if (Tn--, R.monitorRunDependencies && R.monitorRunDependencies(Tn), Tn == 0 && Rn) {
            var Je = Rn;
            Rn = null, Je();
          }
        }
        function $n(je) {
          R.onAbort && R.onAbort(je), je = "Aborted(" + je + ")", ae(je), ze = !0, ke = 1, je += ". Build with -sASSERTIONS for more info.";
          var Je = new WebAssembly.RuntimeError(je);
          throw m(Je), Je;
        }
        var Kn = "data:application/octet-stream;base64,";
        function ir(je) {
          return je.startsWith(Kn);
        }
        var er;
        er = "web-ifc-mt.wasm", ir(er) || (er = Fe(er));
        function br(je) {
          try {
            if (je == er && v)
              return new Uint8Array(v);
            if (ve)
              return ve(je);
            throw "both async and sync fetching of the wasm failed";
          } catch (Je) {
            $n(Je);
          }
        }
        function cs() {
          return !v && (G || q) && typeof fetch == "function" ? fetch(er, { credentials: "same-origin" }).then(function(je) {
            if (!je.ok)
              throw "failed to load wasm binary file at '" + er + "'";
            return je.arrayBuffer();
          }).catch(function() {
            return br(er);
          }) : Promise.resolve().then(function() {
            return br(er);
          });
        }
        function Gn() {
          var je = { a: Ga };
          function Je(Fn, wn) {
            var Hn = Fn.exports;
            R.asm = Hn, Vr(R.asm.ka), Ke = R.asm.ia, hn(R.asm.ha), be = wn, En.loadWasmModuleToAllWorkers(() => xn());
          }
          Dn();
          function At(Fn) {
            Je(Fn.instance, Fn.module);
          }
          function qt(Fn) {
            return cs().then(function(wn) {
              return WebAssembly.instantiate(wn, je);
            }).then(function(wn) {
              return wn;
            }).then(Fn, function(wn) {
              ae("failed to asynchronously prepare wasm: " + wn), $n(wn);
            });
          }
          function un() {
            return !v && typeof WebAssembly.instantiateStreaming == "function" && !ir(er) && typeof fetch == "function" ? fetch(er, { credentials: "same-origin" }).then(function(Fn) {
              var wn = WebAssembly.instantiateStreaming(Fn, je);
              return wn.then(At, function(Hn) {
                return ae("wasm streaming compile failed: " + Hn), ae("falling back to ArrayBuffer instantiation"), qt(At);
              });
            }) : qt(At);
          }
          if (R.instantiateWasm)
            try {
              var An = R.instantiateWasm(je, Je);
              return An;
            } catch (Fn) {
              ae("Module.instantiateWasm callback failed with error: " + Fn), m(Fn);
            }
          return un().catch(m), {};
        }
        var Jn, Xn;
        function rr(je) {
          this.name = "ExitStatus", this.message = "Program terminated with exit(" + je + ")", this.status = je;
        }
        function _r(je) {
          var Je = En.pthreads[je];
          delete En.pthreads[je], Je.terminate(), za(je), En.runningWorkers.splice(En.runningWorkers.indexOf(Je), 1), Je.pthread_ptr = 0;
        }
        function Ss(je) {
          var Je = En.pthreads[je];
          Je.postMessage({ cmd: "cancel" });
        }
        function is(je) {
          var Je = En.pthreads[je];
          Be(Je), En.returnWorkerToPool(Je);
        }
        function Ms(je) {
          var Je = En.getNewWorker();
          if (!Je)
            return 6;
          En.runningWorkers.push(Je), En.pthreads[je.pthread_ptr] = Je, Je.pthread_ptr = je.pthread_ptr;
          var At = { cmd: "run", start_routine: je.startRoutine, arg: je.arg, pthread_ptr: je.pthread_ptr };
          return Je.postMessage(At, je.transferList), 0;
        }
        var ls = { isAbs: (je) => je.charAt(0) === "/", splitPath: (je) => {
          var Je = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return Je.exec(je).slice(1);
        }, normalizeArray: (je, Je) => {
          for (var At = 0, qt = je.length - 1; qt >= 0; qt--) {
            var un = je[qt];
            un === "." ? je.splice(qt, 1) : un === ".." ? (je.splice(qt, 1), At++) : At && (je.splice(qt, 1), At--);
          }
          if (Je)
            for (; At; At--)
              je.unshift("..");
          return je;
        }, normalize: (je) => {
          var Je = ls.isAbs(je), At = je.substr(-1) === "/";
          return je = ls.normalizeArray(je.split("/").filter((qt) => !!qt), !Je).join("/"), !je && !Je && (je = "."), je && At && (je += "/"), (Je ? "/" : "") + je;
        }, dirname: (je) => {
          var Je = ls.splitPath(je), At = Je[0], qt = Je[1];
          return !At && !qt ? "." : (qt && (qt = qt.substr(0, qt.length - 1)), At + qt);
        }, basename: (je) => {
          if (je === "/")
            return "/";
          je = ls.normalize(je), je = je.replace(/\/$/, "");
          var Je = je.lastIndexOf("/");
          return Je === -1 ? je : je.substr(Je + 1);
        }, join: function() {
          var je = Array.prototype.slice.call(arguments);
          return ls.normalize(je.join("/"));
        }, join2: (je, Je) => ls.normalize(je + "/" + Je) };
        function Ur() {
          if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") {
            var je = new Uint8Array(1);
            return () => (crypto.getRandomValues(je), je[0]);
          } else
            return () => $n("randomDevice");
        }
        var Qr = { resolve: function() {
          for (var je = "", Je = !1, At = arguments.length - 1; At >= -1 && !Je; At--) {
            var qt = At >= 0 ? arguments[At] : en.cwd();
            if (typeof qt != "string")
              throw new TypeError("Arguments to path.resolve must be strings");
            if (!qt)
              return "";
            je = qt + "/" + je, Je = ls.isAbs(qt);
          }
          return je = ls.normalizeArray(je.split("/").filter((un) => !!un), !Je).join("/"), (Je ? "/" : "") + je || ".";
        }, relative: (je, Je) => {
          je = Qr.resolve(je).substr(1), Je = Qr.resolve(Je).substr(1);
          function At(Er) {
            for (var Cr = 0; Cr < Er.length && Er[Cr] === ""; Cr++)
              ;
            for (var zr = Er.length - 1; zr >= 0 && Er[zr] === ""; zr--)
              ;
            return Cr > zr ? [] : Er.slice(Cr, zr - Cr + 1);
          }
          for (var qt = At(je.split("/")), un = At(Je.split("/")), An = Math.min(qt.length, un.length), Fn = An, wn = 0; wn < An; wn++)
            if (qt[wn] !== un[wn]) {
              Fn = wn;
              break;
            }
          for (var Hn = [], wn = Fn; wn < qt.length; wn++)
            Hn.push("..");
          return Hn = Hn.concat(un.slice(Fn)), Hn.join("/");
        } };
        function Fr(je, Je, At) {
          var qt = At > 0 ? At : Bt(je) + 1, un = new Array(qt), An = xt(je, un, 0, un.length);
          return Je && (un.length = An), un;
        }
        var Lr = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(je, Je) {
          Lr.ttys[je] = { input: [], output: [], ops: Je }, en.registerDevice(je, Lr.stream_ops);
        }, stream_ops: { open: function(je) {
          var Je = Lr.ttys[je.node.rdev];
          if (!Je)
            throw new en.ErrnoError(43);
          je.tty = Je, je.seekable = !1;
        }, close: function(je) {
          je.tty.ops.fsync(je.tty);
        }, fsync: function(je) {
          je.tty.ops.fsync(je.tty);
        }, read: function(je, Je, At, qt, un) {
          if (!je.tty || !je.tty.ops.get_char)
            throw new en.ErrnoError(60);
          for (var An = 0, Fn = 0; Fn < qt; Fn++) {
            var wn;
            try {
              wn = je.tty.ops.get_char(je.tty);
            } catch {
              throw new en.ErrnoError(29);
            }
            if (wn === void 0 && An === 0)
              throw new en.ErrnoError(6);
            if (wn == null)
              break;
            An++, Je[At + Fn] = wn;
          }
          return An && (je.node.timestamp = Date.now()), An;
        }, write: function(je, Je, At, qt, un) {
          if (!je.tty || !je.tty.ops.put_char)
            throw new en.ErrnoError(60);
          try {
            for (var An = 0; An < qt; An++)
              je.tty.ops.put_char(je.tty, Je[At + An]);
          } catch {
            throw new en.ErrnoError(29);
          }
          return qt && (je.node.timestamp = Date.now()), An;
        } }, default_tty_ops: { get_char: function(je) {
          if (!je.input.length) {
            var Je = null;
            if (typeof window < "u" && typeof window.prompt == "function" ? (Je = window.prompt("Input: "), Je !== null && (Je += `
`)) : typeof readline == "function" && (Je = readline(), Je !== null && (Je += `
`)), !Je)
              return null;
            je.input = Fr(Je, !0);
          }
          return je.input.shift();
        }, put_char: function(je, Je) {
          Je === null || Je === 10 ? (te(me(je.output, 0)), je.output = []) : Je != 0 && je.output.push(Je);
        }, fsync: function(je) {
          je.output && je.output.length > 0 && (te(me(je.output, 0)), je.output = []);
        } }, default_tty1_ops: { put_char: function(je, Je) {
          Je === null || Je === 10 ? (ae(me(je.output, 0)), je.output = []) : Je != 0 && je.output.push(Je);
        }, fsync: function(je) {
          je.output && je.output.length > 0 && (ae(me(je.output, 0)), je.output = []);
        } } };
        function Hr(je) {
          $n();
        }
        var ns = { ops_table: null, mount: function(je) {
          return ns.createNode(null, "/", 16895, 0);
        }, createNode: function(je, Je, At, qt) {
          if (en.isBlkdev(At) || en.isFIFO(At))
            throw new en.ErrnoError(63);
          ns.ops_table || (ns.ops_table = { dir: { node: { getattr: ns.node_ops.getattr, setattr: ns.node_ops.setattr, lookup: ns.node_ops.lookup, mknod: ns.node_ops.mknod, rename: ns.node_ops.rename, unlink: ns.node_ops.unlink, rmdir: ns.node_ops.rmdir, readdir: ns.node_ops.readdir, symlink: ns.node_ops.symlink }, stream: { llseek: ns.stream_ops.llseek } }, file: { node: { getattr: ns.node_ops.getattr, setattr: ns.node_ops.setattr }, stream: { llseek: ns.stream_ops.llseek, read: ns.stream_ops.read, write: ns.stream_ops.write, allocate: ns.stream_ops.allocate, mmap: ns.stream_ops.mmap, msync: ns.stream_ops.msync } }, link: { node: { getattr: ns.node_ops.getattr, setattr: ns.node_ops.setattr, readlink: ns.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: ns.node_ops.getattr, setattr: ns.node_ops.setattr }, stream: en.chrdev_stream_ops } });
          var un = en.createNode(je, Je, At, qt);
          return en.isDir(un.mode) ? (un.node_ops = ns.ops_table.dir.node, un.stream_ops = ns.ops_table.dir.stream, un.contents = {}) : en.isFile(un.mode) ? (un.node_ops = ns.ops_table.file.node, un.stream_ops = ns.ops_table.file.stream, un.usedBytes = 0, un.contents = null) : en.isLink(un.mode) ? (un.node_ops = ns.ops_table.link.node, un.stream_ops = ns.ops_table.link.stream) : en.isChrdev(un.mode) && (un.node_ops = ns.ops_table.chrdev.node, un.stream_ops = ns.ops_table.chrdev.stream), un.timestamp = Date.now(), je && (je.contents[Je] = un, je.timestamp = un.timestamp), un;
        }, getFileDataAsTypedArray: function(je) {
          return je.contents ? je.contents.subarray ? je.contents.subarray(0, je.usedBytes) : new Uint8Array(je.contents) : new Uint8Array(0);
        }, expandFileStorage: function(je, Je) {
          Je >>>= 0;
          var At = je.contents ? je.contents.length : 0;
          if (!(At >= Je)) {
            var qt = 1024 * 1024;
            Je = Math.max(Je, At * (At < qt ? 2 : 1.125) >>> 0), At != 0 && (Je = Math.max(Je, 256));
            var un = je.contents;
            je.contents = new Uint8Array(Je), je.usedBytes > 0 && je.contents.set(un.subarray(0, je.usedBytes), 0);
          }
        }, resizeFileStorage: function(je, Je) {
          if (Je >>>= 0, je.usedBytes != Je)
            if (Je == 0)
              je.contents = null, je.usedBytes = 0;
            else {
              var At = je.contents;
              je.contents = new Uint8Array(Je), At && je.contents.set(At.subarray(0, Math.min(Je, je.usedBytes))), je.usedBytes = Je;
            }
        }, node_ops: { getattr: function(je) {
          var Je = {};
          return Je.dev = en.isChrdev(je.mode) ? je.id : 1, Je.ino = je.id, Je.mode = je.mode, Je.nlink = 1, Je.uid = 0, Je.gid = 0, Je.rdev = je.rdev, en.isDir(je.mode) ? Je.size = 4096 : en.isFile(je.mode) ? Je.size = je.usedBytes : en.isLink(je.mode) ? Je.size = je.link.length : Je.size = 0, Je.atime = new Date(je.timestamp), Je.mtime = new Date(je.timestamp), Je.ctime = new Date(je.timestamp), Je.blksize = 4096, Je.blocks = Math.ceil(Je.size / Je.blksize), Je;
        }, setattr: function(je, Je) {
          Je.mode !== void 0 && (je.mode = Je.mode), Je.timestamp !== void 0 && (je.timestamp = Je.timestamp), Je.size !== void 0 && ns.resizeFileStorage(je, Je.size);
        }, lookup: function(je, Je) {
          throw en.genericErrors[44];
        }, mknod: function(je, Je, At, qt) {
          return ns.createNode(je, Je, At, qt);
        }, rename: function(je, Je, At) {
          if (en.isDir(je.mode)) {
            var qt;
            try {
              qt = en.lookupNode(Je, At);
            } catch {
            }
            if (qt)
              for (var un in qt.contents)
                throw new en.ErrnoError(55);
          }
          delete je.parent.contents[je.name], je.parent.timestamp = Date.now(), je.name = At, Je.contents[At] = je, Je.timestamp = je.parent.timestamp, je.parent = Je;
        }, unlink: function(je, Je) {
          delete je.contents[Je], je.timestamp = Date.now();
        }, rmdir: function(je, Je) {
          var At = en.lookupNode(je, Je);
          for (var qt in At.contents)
            throw new en.ErrnoError(55);
          delete je.contents[Je], je.timestamp = Date.now();
        }, readdir: function(je) {
          var Je = [".", ".."];
          for (var At in je.contents)
            je.contents.hasOwnProperty(At) && Je.push(At);
          return Je;
        }, symlink: function(je, Je, At) {
          var qt = ns.createNode(je, Je, 41471, 0);
          return qt.link = At, qt;
        }, readlink: function(je) {
          if (!en.isLink(je.mode))
            throw new en.ErrnoError(28);
          return je.link;
        } }, stream_ops: { read: function(je, Je, At, qt, un) {
          var An = je.node.contents;
          if (un >= je.node.usedBytes)
            return 0;
          var Fn = Math.min(je.node.usedBytes - un, qt);
          if (Fn > 8 && An.subarray)
            Je.set(An.subarray(un, un + Fn), At);
          else
            for (var wn = 0; wn < Fn; wn++)
              Je[At + wn] = An[un + wn];
          return Fn;
        }, write: function(je, Je, At, qt, un, An) {
          if (Je.buffer === l().buffer && (An = !1), !qt)
            return 0;
          var Fn = je.node;
          if (Fn.timestamp = Date.now(), Je.subarray && (!Fn.contents || Fn.contents.subarray)) {
            if (An)
              return Fn.contents = Je.subarray(At, At + qt), Fn.usedBytes = qt, qt;
            if (Fn.usedBytes === 0 && un === 0)
              return Fn.contents = Je.slice(At, At + qt), Fn.usedBytes = qt, qt;
            if (un + qt <= Fn.usedBytes)
              return Fn.contents.set(Je.subarray(At, At + qt), un), qt;
          }
          if (ns.expandFileStorage(Fn, un + qt), Fn.contents.subarray && Je.subarray)
            Fn.contents.set(Je.subarray(At, At + qt), un);
          else
            for (var wn = 0; wn < qt; wn++)
              Fn.contents[un + wn] = Je[At + wn];
          return Fn.usedBytes = Math.max(Fn.usedBytes, un + qt), qt;
        }, llseek: function(je, Je, At) {
          var qt = Je;
          if (At === 1 ? qt += je.position : At === 2 && en.isFile(je.node.mode) && (qt += je.node.usedBytes), qt < 0)
            throw new en.ErrnoError(28);
          return qt;
        }, allocate: function(je, Je, At) {
          ns.expandFileStorage(je.node, Je + At), je.node.usedBytes = Math.max(je.node.usedBytes, Je + At);
        }, mmap: function(je, Je, At, qt, un) {
          if (!en.isFile(je.node.mode))
            throw new en.ErrnoError(43);
          var An, Fn, wn = je.node.contents;
          if (!(un & 2) && wn.buffer === l().buffer)
            Fn = !1, An = wn.byteOffset;
          else {
            if ((At > 0 || At + Je < wn.length) && (wn.subarray ? wn = wn.subarray(At, At + Je) : wn = Array.prototype.slice.call(wn, At, At + Je)), Fn = !0, An = Hr(), !An)
              throw new en.ErrnoError(48);
            An >>>= 0, l().set(wn, An >>> 0);
          }
          return { ptr: An, allocated: Fn };
        }, msync: function(je, Je, At, qt, un) {
          return ns.stream_ops.write(je, Je, 0, qt, At, !1), 0;
        } } };
        function Ts(je, Je, At, qt) {
          var un = qt ? "" : "al " + je;
          Ge(je, (An) => {
            Be(An, 'Loading data file "' + je + '" failed (no arrayBuffer).'), Je(new Uint8Array(An)), un && xn();
          }, (An) => {
            if (At)
              At();
            else
              throw 'Loading data file "' + je + '" failed.';
          }), un && Dn();
        }
        var en = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (je, Je = {}) => {
          if (je = Qr.resolve(je), !je)
            return { path: "", node: null };
          var At = { follow_mount: !0, recurse_count: 0 };
          if (Je = Object.assign(At, Je), Je.recurse_count > 8)
            throw new en.ErrnoError(32);
          for (var qt = je.split("/").filter((zr) => !!zr), un = en.root, An = "/", Fn = 0; Fn < qt.length; Fn++) {
            var wn = Fn === qt.length - 1;
            if (wn && Je.parent)
              break;
            if (un = en.lookupNode(un, qt[Fn]), An = ls.join2(An, qt[Fn]), en.isMountpoint(un) && (!wn || wn && Je.follow_mount) && (un = un.mounted.root), !wn || Je.follow)
              for (var Hn = 0; en.isLink(un.mode); ) {
                var Er = en.readlink(An);
                An = Qr.resolve(ls.dirname(An), Er);
                var Cr = en.lookupPath(An, { recurse_count: Je.recurse_count + 1 });
                if (un = Cr.node, Hn++ > 40)
                  throw new en.ErrnoError(32);
              }
          }
          return { path: An, node: un };
        }, getPath: (je) => {
          for (var Je; ; ) {
            if (en.isRoot(je)) {
              var At = je.mount.mountpoint;
              return Je ? At[At.length - 1] !== "/" ? At + "/" + Je : At + Je : At;
            }
            Je = Je ? je.name + "/" + Je : je.name, je = je.parent;
          }
        }, hashName: (je, Je) => {
          for (var At = 0, qt = 0; qt < Je.length; qt++)
            At = (At << 5) - At + Je.charCodeAt(qt) | 0;
          return (je + At >>> 0) % en.nameTable.length;
        }, hashAddNode: (je) => {
          var Je = en.hashName(je.parent.id, je.name);
          je.name_next = en.nameTable[Je], en.nameTable[Je] = je;
        }, hashRemoveNode: (je) => {
          var Je = en.hashName(je.parent.id, je.name);
          if (en.nameTable[Je] === je)
            en.nameTable[Je] = je.name_next;
          else
            for (var At = en.nameTable[Je]; At; ) {
              if (At.name_next === je) {
                At.name_next = je.name_next;
                break;
              }
              At = At.name_next;
            }
        }, lookupNode: (je, Je) => {
          var At = en.mayLookup(je);
          if (At)
            throw new en.ErrnoError(At, je);
          for (var qt = en.hashName(je.id, Je), un = en.nameTable[qt]; un; un = un.name_next) {
            var An = un.name;
            if (un.parent.id === je.id && An === Je)
              return un;
          }
          return en.lookup(je, Je);
        }, createNode: (je, Je, At, qt) => {
          var un = new en.FSNode(je, Je, At, qt);
          return en.hashAddNode(un), un;
        }, destroyNode: (je) => {
          en.hashRemoveNode(je);
        }, isRoot: (je) => je === je.parent, isMountpoint: (je) => !!je.mounted, isFile: (je) => (je & 61440) === 32768, isDir: (je) => (je & 61440) === 16384, isLink: (je) => (je & 61440) === 40960, isChrdev: (je) => (je & 61440) === 8192, isBlkdev: (je) => (je & 61440) === 24576, isFIFO: (je) => (je & 61440) === 4096, isSocket: (je) => (je & 49152) === 49152, flagModes: { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, modeStringToFlags: (je) => {
          var Je = en.flagModes[je];
          if (typeof Je > "u")
            throw new Error("Unknown file open mode: " + je);
          return Je;
        }, flagsToPermissionString: (je) => {
          var Je = ["r", "w", "rw"][je & 3];
          return je & 512 && (Je += "w"), Je;
        }, nodePermissions: (je, Je) => en.ignorePermissions ? 0 : Je.includes("r") && !(je.mode & 292) || Je.includes("w") && !(je.mode & 146) || Je.includes("x") && !(je.mode & 73) ? 2 : 0, mayLookup: (je) => {
          var Je = en.nodePermissions(je, "x");
          return Je || (je.node_ops.lookup ? 0 : 2);
        }, mayCreate: (je, Je) => {
          try {
            var At = en.lookupNode(je, Je);
            return 20;
          } catch {
          }
          return en.nodePermissions(je, "wx");
        }, mayDelete: (je, Je, At) => {
          var qt;
          try {
            qt = en.lookupNode(je, Je);
          } catch (An) {
            return An.errno;
          }
          var un = en.nodePermissions(je, "wx");
          if (un)
            return un;
          if (At) {
            if (!en.isDir(qt.mode))
              return 54;
            if (en.isRoot(qt) || en.getPath(qt) === en.cwd())
              return 10;
          } else if (en.isDir(qt.mode))
            return 31;
          return 0;
        }, mayOpen: (je, Je) => je ? en.isLink(je.mode) ? 32 : en.isDir(je.mode) && (en.flagsToPermissionString(Je) !== "r" || Je & 512) ? 31 : en.nodePermissions(je, en.flagsToPermissionString(Je)) : 44, MAX_OPEN_FDS: 4096, nextfd: (je = 0, Je = en.MAX_OPEN_FDS) => {
          for (var At = je; At <= Je; At++)
            if (!en.streams[At])
              return At;
          throw new en.ErrnoError(33);
        }, getStream: (je) => en.streams[je], createStream: (je, Je, At) => {
          en.FSStream || (en.FSStream = function() {
            this.shared = {};
          }, en.FSStream.prototype = {}, Object.defineProperties(en.FSStream.prototype, { object: { get: function() {
            return this.node;
          }, set: function(un) {
            this.node = un;
          } }, isRead: { get: function() {
            return (this.flags & 2097155) !== 1;
          } }, isWrite: { get: function() {
            return (this.flags & 2097155) !== 0;
          } }, isAppend: { get: function() {
            return this.flags & 1024;
          } }, flags: { get: function() {
            return this.shared.flags;
          }, set: function(un) {
            this.shared.flags = un;
          } }, position: { get: function() {
            return this.shared.position;
          }, set: function(un) {
            this.shared.position = un;
          } } })), je = Object.assign(new en.FSStream(), je);
          var qt = en.nextfd(Je, At);
          return je.fd = qt, en.streams[qt] = je, je;
        }, closeStream: (je) => {
          en.streams[je] = null;
        }, chrdev_stream_ops: { open: (je) => {
          var Je = en.getDevice(je.node.rdev);
          je.stream_ops = Je.stream_ops, je.stream_ops.open && je.stream_ops.open(je);
        }, llseek: () => {
          throw new en.ErrnoError(70);
        } }, major: (je) => je >> 8, minor: (je) => je & 255, makedev: (je, Je) => je << 8 | Je, registerDevice: (je, Je) => {
          en.devices[je] = { stream_ops: Je };
        }, getDevice: (je) => en.devices[je], getMounts: (je) => {
          for (var Je = [], At = [je]; At.length; ) {
            var qt = At.pop();
            Je.push(qt), At.push.apply(At, qt.mounts);
          }
          return Je;
        }, syncfs: (je, Je) => {
          typeof je == "function" && (Je = je, je = !1), en.syncFSRequests++, en.syncFSRequests > 1 && ae("warning: " + en.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
          var At = en.getMounts(en.root.mount), qt = 0;
          function un(Fn) {
            return en.syncFSRequests--, Je(Fn);
          }
          function An(Fn) {
            if (Fn)
              return An.errored ? void 0 : (An.errored = !0, un(Fn));
            ++qt >= At.length && un(null);
          }
          At.forEach((Fn) => {
            if (!Fn.type.syncfs)
              return An(null);
            Fn.type.syncfs(Fn, je, An);
          });
        }, mount: (je, Je, At) => {
          var qt = At === "/", un = !At, An;
          if (qt && en.root)
            throw new en.ErrnoError(10);
          if (!qt && !un) {
            var Fn = en.lookupPath(At, { follow_mount: !1 });
            if (At = Fn.path, An = Fn.node, en.isMountpoint(An))
              throw new en.ErrnoError(10);
            if (!en.isDir(An.mode))
              throw new en.ErrnoError(54);
          }
          var wn = { type: je, opts: Je, mountpoint: At, mounts: [] }, Hn = je.mount(wn);
          return Hn.mount = wn, wn.root = Hn, qt ? en.root = Hn : An && (An.mounted = wn, An.mount && An.mount.mounts.push(wn)), Hn;
        }, unmount: (je) => {
          var Je = en.lookupPath(je, { follow_mount: !1 });
          if (!en.isMountpoint(Je.node))
            throw new en.ErrnoError(28);
          var At = Je.node, qt = At.mounted, un = en.getMounts(qt);
          Object.keys(en.nameTable).forEach((Fn) => {
            for (var wn = en.nameTable[Fn]; wn; ) {
              var Hn = wn.name_next;
              un.includes(wn.mount) && en.destroyNode(wn), wn = Hn;
            }
          }), At.mounted = null;
          var An = At.mount.mounts.indexOf(qt);
          At.mount.mounts.splice(An, 1);
        }, lookup: (je, Je) => je.node_ops.lookup(je, Je), mknod: (je, Je, At) => {
          var qt = en.lookupPath(je, { parent: !0 }), un = qt.node, An = ls.basename(je);
          if (!An || An === "." || An === "..")
            throw new en.ErrnoError(28);
          var Fn = en.mayCreate(un, An);
          if (Fn)
            throw new en.ErrnoError(Fn);
          if (!un.node_ops.mknod)
            throw new en.ErrnoError(63);
          return un.node_ops.mknod(un, An, Je, At);
        }, create: (je, Je) => (Je = Je !== void 0 ? Je : 438, Je &= 4095, Je |= 32768, en.mknod(je, Je, 0)), mkdir: (je, Je) => (Je = Je !== void 0 ? Je : 511, Je &= 1023, Je |= 16384, en.mknod(je, Je, 0)), mkdirTree: (je, Je) => {
          for (var At = je.split("/"), qt = "", un = 0; un < At.length; ++un)
            if (At[un]) {
              qt += "/" + At[un];
              try {
                en.mkdir(qt, Je);
              } catch (An) {
                if (An.errno != 20)
                  throw An;
              }
            }
        }, mkdev: (je, Je, At) => (typeof At > "u" && (At = Je, Je = 438), Je |= 8192, en.mknod(je, Je, At)), symlink: (je, Je) => {
          if (!Qr.resolve(je))
            throw new en.ErrnoError(44);
          var At = en.lookupPath(Je, { parent: !0 }), qt = At.node;
          if (!qt)
            throw new en.ErrnoError(44);
          var un = ls.basename(Je), An = en.mayCreate(qt, un);
          if (An)
            throw new en.ErrnoError(An);
          if (!qt.node_ops.symlink)
            throw new en.ErrnoError(63);
          return qt.node_ops.symlink(qt, un, je);
        }, rename: (je, Je) => {
          var At = ls.dirname(je), qt = ls.dirname(Je), un = ls.basename(je), An = ls.basename(Je), Fn, wn, Hn;
          if (Fn = en.lookupPath(je, { parent: !0 }), wn = Fn.node, Fn = en.lookupPath(Je, { parent: !0 }), Hn = Fn.node, !wn || !Hn)
            throw new en.ErrnoError(44);
          if (wn.mount !== Hn.mount)
            throw new en.ErrnoError(75);
          var Er = en.lookupNode(wn, un), Cr = Qr.relative(je, qt);
          if (Cr.charAt(0) !== ".")
            throw new en.ErrnoError(28);
          if (Cr = Qr.relative(Je, At), Cr.charAt(0) !== ".")
            throw new en.ErrnoError(55);
          var zr;
          try {
            zr = en.lookupNode(Hn, An);
          } catch {
          }
          if (Er !== zr) {
            var hr = en.isDir(Er.mode), xr = en.mayDelete(wn, un, hr);
            if (xr)
              throw new en.ErrnoError(xr);
            if (xr = zr ? en.mayDelete(Hn, An, hr) : en.mayCreate(Hn, An), xr)
              throw new en.ErrnoError(xr);
            if (!wn.node_ops.rename)
              throw new en.ErrnoError(63);
            if (en.isMountpoint(Er) || zr && en.isMountpoint(zr))
              throw new en.ErrnoError(10);
            if (Hn !== wn && (xr = en.nodePermissions(wn, "w"), xr))
              throw new en.ErrnoError(xr);
            en.hashRemoveNode(Er);
            try {
              wn.node_ops.rename(Er, Hn, An);
            } catch (Is) {
              throw Is;
            } finally {
              en.hashAddNode(Er);
            }
          }
        }, rmdir: (je) => {
          var Je = en.lookupPath(je, { parent: !0 }), At = Je.node, qt = ls.basename(je), un = en.lookupNode(At, qt), An = en.mayDelete(At, qt, !0);
          if (An)
            throw new en.ErrnoError(An);
          if (!At.node_ops.rmdir)
            throw new en.ErrnoError(63);
          if (en.isMountpoint(un))
            throw new en.ErrnoError(10);
          At.node_ops.rmdir(At, qt), en.destroyNode(un);
        }, readdir: (je) => {
          var Je = en.lookupPath(je, { follow: !0 }), At = Je.node;
          if (!At.node_ops.readdir)
            throw new en.ErrnoError(54);
          return At.node_ops.readdir(At);
        }, unlink: (je) => {
          var Je = en.lookupPath(je, { parent: !0 }), At = Je.node;
          if (!At)
            throw new en.ErrnoError(44);
          var qt = ls.basename(je), un = en.lookupNode(At, qt), An = en.mayDelete(At, qt, !1);
          if (An)
            throw new en.ErrnoError(An);
          if (!At.node_ops.unlink)
            throw new en.ErrnoError(63);
          if (en.isMountpoint(un))
            throw new en.ErrnoError(10);
          At.node_ops.unlink(At, qt), en.destroyNode(un);
        }, readlink: (je) => {
          var Je = en.lookupPath(je), At = Je.node;
          if (!At)
            throw new en.ErrnoError(44);
          if (!At.node_ops.readlink)
            throw new en.ErrnoError(28);
          return Qr.resolve(en.getPath(At.parent), At.node_ops.readlink(At));
        }, stat: (je, Je) => {
          var At = en.lookupPath(je, { follow: !Je }), qt = At.node;
          if (!qt)
            throw new en.ErrnoError(44);
          if (!qt.node_ops.getattr)
            throw new en.ErrnoError(63);
          return qt.node_ops.getattr(qt);
        }, lstat: (je) => en.stat(je, !0), chmod: (je, Je, At) => {
          var qt;
          if (typeof je == "string") {
            var un = en.lookupPath(je, { follow: !At });
            qt = un.node;
          } else
            qt = je;
          if (!qt.node_ops.setattr)
            throw new en.ErrnoError(63);
          qt.node_ops.setattr(qt, { mode: Je & 4095 | qt.mode & -4096, timestamp: Date.now() });
        }, lchmod: (je, Je) => {
          en.chmod(je, Je, !0);
        }, fchmod: (je, Je) => {
          var At = en.getStream(je);
          if (!At)
            throw new en.ErrnoError(8);
          en.chmod(At.node, Je);
        }, chown: (je, Je, At, qt) => {
          var un;
          if (typeof je == "string") {
            var An = en.lookupPath(je, { follow: !qt });
            un = An.node;
          } else
            un = je;
          if (!un.node_ops.setattr)
            throw new en.ErrnoError(63);
          un.node_ops.setattr(un, { timestamp: Date.now() });
        }, lchown: (je, Je, At) => {
          en.chown(je, Je, At, !0);
        }, fchown: (je, Je, At) => {
          var qt = en.getStream(je);
          if (!qt)
            throw new en.ErrnoError(8);
          en.chown(qt.node, Je, At);
        }, truncate: (je, Je) => {
          if (Je < 0)
            throw new en.ErrnoError(28);
          var At;
          if (typeof je == "string") {
            var qt = en.lookupPath(je, { follow: !0 });
            At = qt.node;
          } else
            At = je;
          if (!At.node_ops.setattr)
            throw new en.ErrnoError(63);
          if (en.isDir(At.mode))
            throw new en.ErrnoError(31);
          if (!en.isFile(At.mode))
            throw new en.ErrnoError(28);
          var un = en.nodePermissions(At, "w");
          if (un)
            throw new en.ErrnoError(un);
          At.node_ops.setattr(At, { size: Je, timestamp: Date.now() });
        }, ftruncate: (je, Je) => {
          var At = en.getStream(je);
          if (!At)
            throw new en.ErrnoError(8);
          if (!(At.flags & 2097155))
            throw new en.ErrnoError(28);
          en.truncate(At.node, Je);
        }, utime: (je, Je, At) => {
          var qt = en.lookupPath(je, { follow: !0 }), un = qt.node;
          un.node_ops.setattr(un, { timestamp: Math.max(Je, At) });
        }, open: (je, Je, At) => {
          if (je === "")
            throw new en.ErrnoError(44);
          Je = typeof Je == "string" ? en.modeStringToFlags(Je) : Je, At = typeof At > "u" ? 438 : At, Je & 64 ? At = At & 4095 | 32768 : At = 0;
          var qt;
          if (typeof je == "object")
            qt = je;
          else {
            je = ls.normalize(je);
            try {
              var un = en.lookupPath(je, { follow: !(Je & 131072) });
              qt = un.node;
            } catch {
            }
          }
          var An = !1;
          if (Je & 64)
            if (qt) {
              if (Je & 128)
                throw new en.ErrnoError(20);
            } else
              qt = en.mknod(je, At, 0), An = !0;
          if (!qt)
            throw new en.ErrnoError(44);
          if (en.isChrdev(qt.mode) && (Je &= -513), Je & 65536 && !en.isDir(qt.mode))
            throw new en.ErrnoError(54);
          if (!An) {
            var Fn = en.mayOpen(qt, Je);
            if (Fn)
              throw new en.ErrnoError(Fn);
          }
          Je & 512 && !An && en.truncate(qt, 0), Je &= -131713;
          var wn = en.createStream({ node: qt, path: en.getPath(qt), flags: Je, seekable: !0, position: 0, stream_ops: qt.stream_ops, ungotten: [], error: !1 });
          return wn.stream_ops.open && wn.stream_ops.open(wn), R.logReadFiles && !(Je & 1) && (en.readFiles || (en.readFiles = {}), je in en.readFiles || (en.readFiles[je] = 1)), wn;
        }, close: (je) => {
          if (en.isClosed(je))
            throw new en.ErrnoError(8);
          je.getdents && (je.getdents = null);
          try {
            je.stream_ops.close && je.stream_ops.close(je);
          } catch (Je) {
            throw Je;
          } finally {
            en.closeStream(je.fd);
          }
          je.fd = null;
        }, isClosed: (je) => je.fd === null, llseek: (je, Je, At) => {
          if (en.isClosed(je))
            throw new en.ErrnoError(8);
          if (!je.seekable || !je.stream_ops.llseek)
            throw new en.ErrnoError(70);
          if (At != 0 && At != 1 && At != 2)
            throw new en.ErrnoError(28);
          return je.position = je.stream_ops.llseek(je, Je, At), je.ungotten = [], je.position;
        }, read: (je, Je, At, qt, un) => {
          if (At >>>= 0, qt < 0 || un < 0)
            throw new en.ErrnoError(28);
          if (en.isClosed(je))
            throw new en.ErrnoError(8);
          if ((je.flags & 2097155) === 1)
            throw new en.ErrnoError(8);
          if (en.isDir(je.node.mode))
            throw new en.ErrnoError(31);
          if (!je.stream_ops.read)
            throw new en.ErrnoError(28);
          var An = typeof un < "u";
          if (!An)
            un = je.position;
          else if (!je.seekable)
            throw new en.ErrnoError(70);
          var Fn = je.stream_ops.read(je, Je, At, qt, un);
          return An || (je.position += Fn), Fn;
        }, write: (je, Je, At, qt, un, An) => {
          if (At >>>= 0, qt < 0 || un < 0)
            throw new en.ErrnoError(28);
          if (en.isClosed(je))
            throw new en.ErrnoError(8);
          if (!(je.flags & 2097155))
            throw new en.ErrnoError(8);
          if (en.isDir(je.node.mode))
            throw new en.ErrnoError(31);
          if (!je.stream_ops.write)
            throw new en.ErrnoError(28);
          je.seekable && je.flags & 1024 && en.llseek(je, 0, 2);
          var Fn = typeof un < "u";
          if (!Fn)
            un = je.position;
          else if (!je.seekable)
            throw new en.ErrnoError(70);
          var wn = je.stream_ops.write(je, Je, At, qt, un, An);
          return Fn || (je.position += wn), wn;
        }, allocate: (je, Je, At) => {
          if (en.isClosed(je))
            throw new en.ErrnoError(8);
          if (Je < 0 || At <= 0)
            throw new en.ErrnoError(28);
          if (!(je.flags & 2097155))
            throw new en.ErrnoError(8);
          if (!en.isFile(je.node.mode) && !en.isDir(je.node.mode))
            throw new en.ErrnoError(43);
          if (!je.stream_ops.allocate)
            throw new en.ErrnoError(138);
          je.stream_ops.allocate(je, Je, At);
        }, mmap: (je, Je, At, qt, un) => {
          if (qt & 2 && !(un & 2) && (je.flags & 2097155) !== 2)
            throw new en.ErrnoError(2);
          if ((je.flags & 2097155) === 1)
            throw new en.ErrnoError(2);
          if (!je.stream_ops.mmap)
            throw new en.ErrnoError(43);
          return je.stream_ops.mmap(je, Je, At, qt, un);
        }, msync: (je, Je, At, qt, un) => (At >>>= 0, je.stream_ops.msync ? je.stream_ops.msync(je, Je, At, qt, un) : 0), munmap: (je) => 0, ioctl: (je, Je, At) => {
          if (!je.stream_ops.ioctl)
            throw new en.ErrnoError(59);
          return je.stream_ops.ioctl(je, Je, At);
        }, readFile: (je, Je = {}) => {
          if (Je.flags = Je.flags || 0, Je.encoding = Je.encoding || "binary", Je.encoding !== "utf8" && Je.encoding !== "binary")
            throw new Error('Invalid encoding type "' + Je.encoding + '"');
          var At, qt = en.open(je, Je.flags), un = en.stat(je), An = un.size, Fn = new Uint8Array(An);
          return en.read(qt, Fn, 0, An, 0), Je.encoding === "utf8" ? At = me(Fn, 0) : Je.encoding === "binary" && (At = Fn), en.close(qt), At;
        }, writeFile: (je, Je, At = {}) => {
          At.flags = At.flags || 577;
          var qt = en.open(je, At.flags, At.mode);
          if (typeof Je == "string") {
            var un = new Uint8Array(Bt(Je) + 1), An = xt(Je, un, 0, un.length);
            en.write(qt, un, 0, An, void 0, At.canOwn);
          } else if (ArrayBuffer.isView(Je))
            en.write(qt, Je, 0, Je.byteLength, void 0, At.canOwn);
          else
            throw new Error("Unsupported data type");
          en.close(qt);
        }, cwd: () => en.currentPath, chdir: (je) => {
          var Je = en.lookupPath(je, { follow: !0 });
          if (Je.node === null)
            throw new en.ErrnoError(44);
          if (!en.isDir(Je.node.mode))
            throw new en.ErrnoError(54);
          var At = en.nodePermissions(Je.node, "x");
          if (At)
            throw new en.ErrnoError(At);
          en.currentPath = Je.path;
        }, createDefaultDirectories: () => {
          en.mkdir("/tmp"), en.mkdir("/home"), en.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          en.mkdir("/dev"), en.registerDevice(en.makedev(1, 3), { read: () => 0, write: (Je, At, qt, un, An) => un }), en.mkdev("/dev/null", en.makedev(1, 3)), Lr.register(en.makedev(5, 0), Lr.default_tty_ops), Lr.register(en.makedev(6, 0), Lr.default_tty1_ops), en.mkdev("/dev/tty", en.makedev(5, 0)), en.mkdev("/dev/tty1", en.makedev(6, 0));
          var je = Ur();
          en.createDevice("/dev", "random", je), en.createDevice("/dev", "urandom", je), en.mkdir("/dev/shm"), en.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          en.mkdir("/proc");
          var je = en.mkdir("/proc/self");
          en.mkdir("/proc/self/fd"), en.mount({ mount: () => {
            var Je = en.createNode(je, "fd", 16895, 73);
            return Je.node_ops = { lookup: (At, qt) => {
              var un = +qt, An = en.getStream(un);
              if (!An)
                throw new en.ErrnoError(8);
              var Fn = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => An.path } };
              return Fn.parent = Fn, Fn;
            } }, Je;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          R.stdin ? en.createDevice("/dev", "stdin", R.stdin) : en.symlink("/dev/tty", "/dev/stdin"), R.stdout ? en.createDevice("/dev", "stdout", null, R.stdout) : en.symlink("/dev/tty", "/dev/stdout"), R.stderr ? en.createDevice("/dev", "stderr", null, R.stderr) : en.symlink("/dev/tty1", "/dev/stderr"), en.open("/dev/stdin", 0), en.open("/dev/stdout", 1), en.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          en.ErrnoError || (en.ErrnoError = function(Je, At) {
            this.node = At, this.setErrno = function(qt) {
              this.errno = qt;
            }, this.setErrno(Je), this.message = "FS error";
          }, en.ErrnoError.prototype = new Error(), en.ErrnoError.prototype.constructor = en.ErrnoError, [44].forEach((je) => {
            en.genericErrors[je] = new en.ErrnoError(je), en.genericErrors[je].stack = "<generic error, no stack>";
          }));
        }, staticInit: () => {
          en.ensureErrnoError(), en.nameTable = new Array(4096), en.mount(ns, {}, "/"), en.createDefaultDirectories(), en.createDefaultDevices(), en.createSpecialDirectories(), en.filesystems = { MEMFS: ns };
        }, init: (je, Je, At) => {
          en.init.initialized = !0, en.ensureErrnoError(), R.stdin = je || R.stdin, R.stdout = Je || R.stdout, R.stderr = At || R.stderr, en.createStandardStreams();
        }, quit: () => {
          en.init.initialized = !1;
          for (var je = 0; je < en.streams.length; je++) {
            var Je = en.streams[je];
            Je && en.close(Je);
          }
        }, getMode: (je, Je) => {
          var At = 0;
          return je && (At |= 365), Je && (At |= 146), At;
        }, findObject: (je, Je) => {
          var At = en.analyzePath(je, Je);
          return At.exists ? At.object : null;
        }, analyzePath: (je, Je) => {
          try {
            var At = en.lookupPath(je, { follow: !Je });
            je = At.path;
          } catch {
          }
          var qt = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
          try {
            var At = en.lookupPath(je, { parent: !0 });
            qt.parentExists = !0, qt.parentPath = At.path, qt.parentObject = At.node, qt.name = ls.basename(je), At = en.lookupPath(je, { follow: !Je }), qt.exists = !0, qt.path = At.path, qt.object = At.node, qt.name = At.node.name, qt.isRoot = At.path === "/";
          } catch (un) {
            qt.error = un.errno;
          }
          return qt;
        }, createPath: (je, Je, At, qt) => {
          je = typeof je == "string" ? je : en.getPath(je);
          for (var un = Je.split("/").reverse(); un.length; ) {
            var An = un.pop();
            if (An) {
              var Fn = ls.join2(je, An);
              try {
                en.mkdir(Fn);
              } catch {
              }
              je = Fn;
            }
          }
          return Fn;
        }, createFile: (je, Je, At, qt, un) => {
          var An = ls.join2(typeof je == "string" ? je : en.getPath(je), Je), Fn = en.getMode(qt, un);
          return en.create(An, Fn);
        }, createDataFile: (je, Je, At, qt, un, An) => {
          var Fn = Je;
          je && (je = typeof je == "string" ? je : en.getPath(je), Fn = Je ? ls.join2(je, Je) : je);
          var wn = en.getMode(qt, un), Hn = en.create(Fn, wn);
          if (At) {
            if (typeof At == "string") {
              for (var Er = new Array(At.length), Cr = 0, zr = At.length; Cr < zr; ++Cr)
                Er[Cr] = At.charCodeAt(Cr);
              At = Er;
            }
            en.chmod(Hn, wn | 146);
            var hr = en.open(Hn, 577);
            en.write(hr, At, 0, At.length, 0, An), en.close(hr), en.chmod(Hn, wn);
          }
          return Hn;
        }, createDevice: (je, Je, At, qt) => {
          var un = ls.join2(typeof je == "string" ? je : en.getPath(je), Je), An = en.getMode(!!At, !!qt);
          en.createDevice.major || (en.createDevice.major = 64);
          var Fn = en.makedev(en.createDevice.major++, 0);
          return en.registerDevice(Fn, { open: (wn) => {
            wn.seekable = !1;
          }, close: (wn) => {
            qt && qt.buffer && qt.buffer.length && qt(10);
          }, read: (wn, Hn, Er, Cr, zr) => {
            for (var hr = 0, xr = 0; xr < Cr; xr++) {
              var Is;
              try {
                Is = At();
              } catch {
                throw new en.ErrnoError(29);
              }
              if (Is === void 0 && hr === 0)
                throw new en.ErrnoError(6);
              if (Is == null)
                break;
              hr++, Hn[Er + xr] = Is;
            }
            return hr && (wn.node.timestamp = Date.now()), hr;
          }, write: (wn, Hn, Er, Cr, zr) => {
            for (var hr = 0; hr < Cr; hr++)
              try {
                qt(Hn[Er + hr]);
              } catch {
                throw new en.ErrnoError(29);
              }
            return Cr && (wn.node.timestamp = Date.now()), hr;
          } }), en.mkdev(un, An, Fn);
        }, forceLoadFile: (je) => {
          if (je.isDevice || je.isFolder || je.link || je.contents)
            return !0;
          if (typeof XMLHttpRequest < "u")
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          if (Ee)
            try {
              je.contents = Fr(Ee(je.url), !0), je.usedBytes = je.contents.length;
            } catch {
              throw new en.ErrnoError(29);
            }
          else
            throw new Error("Cannot load without read() or XMLHttpRequest.");
        }, createLazyFile: (je, Je, At, qt, un) => {
          function An() {
            this.lengthKnown = !1, this.chunks = [];
          }
          if (An.prototype.get = function(xr) {
            if (!(xr > this.length - 1 || xr < 0)) {
              var Is = xr % this.chunkSize, fs = xr / this.chunkSize | 0;
              return this.getter(fs)[Is];
            }
          }, An.prototype.setDataGetter = function(xr) {
            this.getter = xr;
          }, An.prototype.cacheLength = function() {
            var xr = new XMLHttpRequest();
            if (xr.open("HEAD", At, !1), xr.send(null), !(xr.status >= 200 && xr.status < 300 || xr.status === 304))
              throw new Error("Couldn't load " + At + ". Status: " + xr.status);
            var Is = Number(xr.getResponseHeader("Content-length")), fs, co = (fs = xr.getResponseHeader("Accept-Ranges")) && fs === "bytes", Yo = (fs = xr.getResponseHeader("Content-Encoding")) && fs === "gzip", Qn = 1024 * 1024;
            co || (Qn = Is);
            var es = (js, Hi) => {
              if (js > Hi)
                throw new Error("invalid range (" + js + ", " + Hi + ") or no bytes requested!");
              if (Hi > Is - 1)
                throw new Error("only " + Is + " bytes available! programmer error!");
              var zs = new XMLHttpRequest();
              if (zs.open("GET", At, !1), Is !== Qn && zs.setRequestHeader("Range", "bytes=" + js + "-" + Hi), zs.responseType = "arraybuffer", zs.overrideMimeType && zs.overrideMimeType("text/plain; charset=x-user-defined"), zs.send(null), !(zs.status >= 200 && zs.status < 300 || zs.status === 304))
                throw new Error("Couldn't load " + At + ". Status: " + zs.status);
              return zs.response !== void 0 ? new Uint8Array(zs.response || []) : Fr(zs.responseText || "", !0);
            }, Jo = this;
            Jo.setDataGetter((js) => {
              var Hi = js * Qn, zs = (js + 1) * Qn - 1;
              if (zs = Math.min(zs, Is - 1), typeof Jo.chunks[js] > "u" && (Jo.chunks[js] = es(Hi, zs)), typeof Jo.chunks[js] > "u")
                throw new Error("doXHR failed!");
              return Jo.chunks[js];
            }), (Yo || !Is) && (Qn = Is = 1, Is = this.getter(0).length, Qn = Is, te("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Is, this._chunkSize = Qn, this.lengthKnown = !0;
          }, typeof XMLHttpRequest < "u") {
            if (!q)
              throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var Fn = new An();
            Object.defineProperties(Fn, { length: { get: function() {
              return this.lengthKnown || this.cacheLength(), this._length;
            } }, chunkSize: { get: function() {
              return this.lengthKnown || this.cacheLength(), this._chunkSize;
            } } });
            var wn = { isDevice: !1, contents: Fn };
          } else
            var wn = { isDevice: !1, url: At };
          var Hn = en.createFile(je, Je, wn, qt, un);
          wn.contents ? Hn.contents = wn.contents : wn.url && (Hn.contents = null, Hn.url = wn.url), Object.defineProperties(Hn, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var Er = {}, Cr = Object.keys(Hn.stream_ops);
          Cr.forEach((hr) => {
            var xr = Hn.stream_ops[hr];
            Er[hr] = function() {
              return en.forceLoadFile(Hn), xr.apply(null, arguments);
            };
          });
          function zr(hr, xr, Is, fs, co) {
            var Yo = hr.node.contents;
            if (co >= Yo.length)
              return 0;
            var Qn = Math.min(Yo.length - co, fs);
            if (Yo.slice)
              for (var es = 0; es < Qn; es++)
                xr[Is + es] = Yo[co + es];
            else
              for (var es = 0; es < Qn; es++)
                xr[Is + es] = Yo.get(co + es);
            return Qn;
          }
          return Er.read = (hr, xr, Is, fs, co) => (en.forceLoadFile(Hn), zr(hr, xr, Is, fs, co)), Er.mmap = (hr, xr, Is, fs, co) => {
            en.forceLoadFile(Hn);
            var Yo = Hr();
            if (!Yo)
              throw new en.ErrnoError(48);
            return zr(hr, l(), Yo, xr, Is), { ptr: Yo, allocated: !0 };
          }, Hn.stream_ops = Er, Hn;
        }, createPreloadedFile: (je, Je, At, qt, un, An, Fn, wn, Hn, Er) => {
          var Cr = Je ? Qr.resolve(ls.join2(je, Je)) : je;
          function zr(hr) {
            function xr(Is) {
              Er && Er(), wn || en.createDataFile(je, Je, Is, qt, un, Hn), An && An(), xn();
            }
            Browser.handledByPreloadPlugin(hr, Cr, xr, () => {
              Fn && Fn(), xn();
            }) || xr(hr);
          }
          Dn(), typeof At == "string" ? Ts(At, (hr) => zr(hr), Fn) : zr(At);
        }, indexedDB: () => window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB, DB_NAME: () => "EM_FS_" + window.location.pathname, DB_VERSION: 20, DB_STORE_NAME: "FILE_DATA", saveFilesToDB: (je, Je = () => {
        }, At = () => {
        }) => {
          var qt = en.indexedDB();
          try {
            var un = qt.open(en.DB_NAME(), en.DB_VERSION);
          } catch (An) {
            return At(An);
          }
          un.onupgradeneeded = () => {
            te("creating db");
            var An = un.result;
            An.createObjectStore(en.DB_STORE_NAME);
          }, un.onsuccess = () => {
            var An = un.result, Fn = An.transaction([en.DB_STORE_NAME], "readwrite"), wn = Fn.objectStore(en.DB_STORE_NAME), Hn = 0, Er = 0, Cr = je.length;
            function zr() {
              Er == 0 ? Je() : At();
            }
            je.forEach((hr) => {
              var xr = wn.put(en.analyzePath(hr).object.contents, hr);
              xr.onsuccess = () => {
                Hn++, Hn + Er == Cr && zr();
              }, xr.onerror = () => {
                Er++, Hn + Er == Cr && zr();
              };
            }), Fn.onerror = At;
          }, un.onerror = At;
        }, loadFilesFromDB: (je, Je = () => {
        }, At = () => {
        }) => {
          var qt = en.indexedDB();
          try {
            var un = qt.open(en.DB_NAME(), en.DB_VERSION);
          } catch (An) {
            return At(An);
          }
          un.onupgradeneeded = At, un.onsuccess = () => {
            var An = un.result;
            try {
              var Fn = An.transaction([en.DB_STORE_NAME], "readonly");
            } catch (hr) {
              At(hr);
              return;
            }
            var wn = Fn.objectStore(en.DB_STORE_NAME), Hn = 0, Er = 0, Cr = je.length;
            function zr() {
              Er == 0 ? Je() : At();
            }
            je.forEach((hr) => {
              var xr = wn.get(hr);
              xr.onsuccess = () => {
                en.analyzePath(hr).exists && en.unlink(hr), en.createDataFile(ls.dirname(hr), ls.basename(hr), xr.result, !0, !0, !0), Hn++, Hn + Er == Cr && zr();
              }, xr.onerror = () => {
                Er++, Hn + Er == Cr && zr();
              };
            }), Fn.onerror = At;
          }, un.onerror = At;
        } }, to = { DEFAULT_POLLMASK: 5, calculateAt: function(je, Je, At) {
          if (ls.isAbs(Je))
            return Je;
          var qt;
          if (je === -100)
            qt = en.cwd();
          else {
            var un = to.getStreamFromFD(je);
            qt = un.path;
          }
          if (Je.length == 0) {
            if (!At)
              throw new en.ErrnoError(44);
            return qt;
          }
          return ls.join2(qt, Je);
        }, doStat: function(je, Je, At) {
          try {
            var qt = je(Je);
          } catch (wn) {
            if (wn && wn.node && ls.normalize(Je) !== ls.normalize(en.getPath(wn.node)))
              return -54;
            throw wn;
          }
          d()[At >>> 2] = qt.dev, d()[At + 8 >>> 2] = qt.ino, d()[At + 12 >>> 2] = qt.mode, f()[At + 16 >>> 2] = qt.nlink, d()[At + 20 >>> 2] = qt.uid, d()[At + 24 >>> 2] = qt.gid, d()[At + 28 >>> 2] = qt.rdev, Xn = [qt.size >>> 0, (Jn = qt.size, +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[At + 40 >>> 2] = Xn[0], d()[At + 44 >>> 2] = Xn[1], d()[At + 48 >>> 2] = 4096, d()[At + 52 >>> 2] = qt.blocks;
          var un = qt.atime.getTime(), An = qt.mtime.getTime(), Fn = qt.ctime.getTime();
          return Xn = [Math.floor(un / 1e3) >>> 0, (Jn = Math.floor(un / 1e3), +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[At + 56 >>> 2] = Xn[0], d()[At + 60 >>> 2] = Xn[1], f()[At + 64 >>> 2] = un % 1e3 * 1e3, Xn = [Math.floor(An / 1e3) >>> 0, (Jn = Math.floor(An / 1e3), +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[At + 72 >>> 2] = Xn[0], d()[At + 76 >>> 2] = Xn[1], f()[At + 80 >>> 2] = An % 1e3 * 1e3, Xn = [Math.floor(Fn / 1e3) >>> 0, (Jn = Math.floor(Fn / 1e3), +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[At + 88 >>> 2] = Xn[0], d()[At + 92 >>> 2] = Xn[1], f()[At + 96 >>> 2] = Fn % 1e3 * 1e3, Xn = [qt.ino >>> 0, (Jn = qt.ino, +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[At + 104 >>> 2] = Xn[0], d()[At + 108 >>> 2] = Xn[1], 0;
        }, doMsync: function(je, Je, At, qt, un) {
          if (!en.isFile(Je.node.mode))
            throw new en.ErrnoError(43);
          if (qt & 2)
            return 0;
          je >>>= 0;
          var An = u().slice(je, je + At);
          en.msync(Je, An, un, At, qt);
        }, varargs: void 0, get: function() {
          to.varargs += 4;
          var je = d()[to.varargs - 4 >>> 2];
          return je;
        }, getStr: function(je) {
          var Je = Se(je);
          return Je;
        }, getStreamFromFD: function(je) {
          var Je = en.getStream(je);
          if (!Je)
            throw new en.ErrnoError(8);
          return Je;
        } };
        function bs(je) {
          if (_e)
            return Ar(1, 1, je);
          ke = je, In() || (En.terminateAllThreads(), R.onExit && R.onExit(je), ze = !0), W(je, new rr(je));
        }
        function jn(je, Je) {
          if (ke = je, !Je && _e)
            throw kn(je), "unwind";
          bs(je);
        }
        var lr = jn;
        function pr(je) {
          if (je instanceof rr || je == "unwind")
            return ke;
          W(1, je);
        }
        var En = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], pthreads: {}, init: function() {
          _e ? En.initWorker() : En.initMainThread();
        }, initMainThread: function() {
          for (var je = navigator.hardwareConcurrency; je--; )
            En.allocateUnusedWorker();
        }, initWorker: function() {
          Te = !1;
        }, setExitStatus: function(je) {
          ke = je;
        }, terminateAllThreads: function() {
          for (var je of Object.values(En.pthreads))
            En.returnWorkerToPool(je);
          for (var je of En.unusedWorkers)
            je.terminate();
          En.unusedWorkers = [];
        }, returnWorkerToPool: function(je) {
          var Je = je.pthread_ptr;
          delete En.pthreads[Je], En.unusedWorkers.push(je), En.runningWorkers.splice(En.runningWorkers.indexOf(je), 1), je.pthread_ptr = 0, za(Je);
        }, receiveObjectTransfer: function(je) {
        }, threadInitTLS: function() {
          En.tlsInitFunctions.forEach((je) => je());
        }, loadWasmModuleToWorker: (je) => new Promise((Je) => {
          je.onmessage = (An) => {
            var Fn = An.data, wn = Fn.cmd;
            if (je.pthread_ptr && (En.currentProxiedOperationCallerThread = je.pthread_ptr), Fn.targetThread && Fn.targetThread != $i()) {
              var Hn = En.pthreads[Fn.targetThread];
              Hn ? Hn.postMessage(Fn, Fn.transferList) : ae('Internal error! Worker sent a message "' + wn + '" to target pthread ' + Fn.targetThread + ", but that thread no longer exists!"), En.currentProxiedOperationCallerThread = void 0;
              return;
            }
            wn === "processProxyingQueue" ? Fo(Fn.queue) : wn === "spawnThread" ? Ms(Fn) : wn === "cleanupThread" ? is(Fn.thread) : wn === "killThread" ? _r(Fn.thread) : wn === "cancelThread" ? Ss(Fn.thread) : wn === "loaded" ? (je.loaded = !0, Je(je)) : wn === "print" ? te("Thread " + Fn.threadId + ": " + Fn.text) : wn === "printErr" ? ae("Thread " + Fn.threadId + ": " + Fn.text) : wn === "alert" ? alert("Thread " + Fn.threadId + ": " + Fn.text) : Fn.target === "setimmediate" ? je.postMessage(Fn) : wn === "callHandler" ? R[Fn.handler](...Fn.args) : wn && ae("worker sent an unknown command " + wn), En.currentProxiedOperationCallerThread = void 0;
          }, je.onerror = (An) => {
            var Fn = "worker sent an error!";
            throw ae(Fn + " " + An.filename + ":" + An.lineno + ": " + An.message), An;
          };
          var At = [], qt = ["onExit", "onAbort", "print", "printErr"];
          for (var un of qt)
            R.hasOwnProperty(un) && At.push(un);
          je.postMessage({ cmd: "load", handlers: At, urlOrBlob: R.mainScriptUrlOrBlob || o, wasmMemory: De, wasmModule: be });
        }), loadWasmModuleToAllWorkers: function(je) {
          if (_e)
            return je();
          Promise.all(En.unusedWorkers.map(En.loadWasmModuleToWorker)).then(je);
        }, allocateUnusedWorker: function() {
          var je, Je = Fe("web-ifc-mt.worker.js");
          je = new Worker(Je), En.unusedWorkers.push(je);
        }, getNewWorker: function() {
          return En.unusedWorkers.length == 0 && (En.allocateUnusedWorker(), En.loadWasmModuleToWorker(En.unusedWorkers[0])), En.unusedWorkers.pop();
        } };
        R.PThread = En;
        function qn(je) {
          for (; je.length > 0; )
            je.shift()(R);
        }
        function Wn() {
          var je = $i(), Je = d()[je + 52 >>> 2], At = d()[je + 56 >>> 2], qt = Je - At;
          Na(Je, qt), fi(Je);
        }
        R.establishStackSpace = Wn;
        function kn(je) {
          if (_e)
            return Ar(2, 0, je);
          try {
            lr(je);
          } catch (Je) {
            pr(Je);
          }
        }
        var zn = [];
        function wr(je) {
          var Je = zn[je];
          return Je || (je >= zn.length && (zn.length = je + 1), zn[je] = Je = Ke.get(je)), Je;
        }
        function jr(je, Je) {
          var At = wr(je)(Je);
          In() ? En.setExitStatus(At) : Ta(At);
        }
        R.invokeEntryPoint = jr;
        function Vr(je) {
          En.tlsInitFunctions.push(je);
        }
        function us(je) {
          this.excPtr = je, this.ptr = je - 24, this.set_type = function(Je) {
            f()[this.ptr + 4 >>> 2] = Je;
          }, this.get_type = function() {
            return f()[this.ptr + 4 >>> 2];
          }, this.set_destructor = function(Je) {
            f()[this.ptr + 8 >>> 2] = Je;
          }, this.get_destructor = function() {
            return f()[this.ptr + 8 >>> 2];
          }, this.set_refcount = function(Je) {
            d()[this.ptr >>> 2] = Je;
          }, this.set_caught = function(Je) {
            Je = Je ? 1 : 0, l()[this.ptr + 12 >>> 0] = Je;
          }, this.get_caught = function() {
            return l()[this.ptr + 12 >>> 0] != 0;
          }, this.set_rethrown = function(Je) {
            Je = Je ? 1 : 0, l()[this.ptr + 13 >>> 0] = Je;
          }, this.get_rethrown = function() {
            return l()[this.ptr + 13 >>> 0] != 0;
          }, this.init = function(Je, At) {
            this.set_adjusted_ptr(0), this.set_type(Je), this.set_destructor(At), this.set_refcount(0), this.set_caught(!1), this.set_rethrown(!1);
          }, this.add_ref = function() {
            Atomics.add(d(), this.ptr + 0 >> 2, 1);
          }, this.release_ref = function() {
            var Je = Atomics.sub(d(), this.ptr + 0 >> 2, 1);
            return Je === 1;
          }, this.set_adjusted_ptr = function(Je) {
            f()[this.ptr + 16 >>> 2] = Je;
          }, this.get_adjusted_ptr = function() {
            return f()[this.ptr + 16 >>> 2];
          }, this.get_exception_ptr = function() {
            var Je = ca(this.get_type());
            if (Je)
              return f()[this.excPtr >>> 2];
            var At = this.get_adjusted_ptr();
            return At !== 0 ? At : this.excPtr;
          };
        }
        function Es(je, Je, At) {
          var qt = new us(je);
          throw qt.init(Je, At), je;
        }
        function Dr(je) {
          Ui(je, !q, 1, !G), En.threadInitTLS();
        }
        function Kr(je) {
          _e ? postMessage({ cmd: "cleanupThread", thread: je }) : is(je);
        }
        function Js(je) {
        }
        var io = "To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking";
        function No(je) {
          $n(io);
        }
        function Ai(je, Je) {
          $n(io);
        }
        var go = {};
        function ks(je) {
          for (; je.length; ) {
            var Je = je.pop(), At = je.pop();
            At(Je);
          }
        }
        function Ci(je) {
          return this.fromWireType(d()[je >>> 2]);
        }
        var Io = {}, Oo = {}, Zs = {}, wt = 48, _t = 57;
        function Ve(je) {
          if (je === void 0)
            return "_unknown";
          je = je.replace(/[^a-zA-Z0-9_]/g, "$");
          var Je = je.charCodeAt(0);
          return Je >= wt && Je <= _t ? "_" + je : je;
        }
        function Ze(je, Je) {
          return je = Ve(je), new Function("body", "return function " + je + `() {
    "use strict";    return body.apply(this, arguments);
};
`)(Je);
        }
        function bt(je, Je) {
          var At = Ze(Je, function(qt) {
            this.name = Je, this.message = qt;
            var un = new Error(qt).stack;
            un !== void 0 && (this.stack = this.toString() + `
` + un.replace(/^Error(:[^\n]*)?\n/, ""));
          });
          return At.prototype = Object.create(je.prototype), At.prototype.constructor = At, At.prototype.toString = function() {
            return this.message === void 0 ? this.name : this.name + ": " + this.message;
          }, At;
        }
        var Ut = void 0;
        function mn(je) {
          throw new Ut(je);
        }
        function nn(je, Je, At) {
          je.forEach(function(wn) {
            Zs[wn] = Je;
          });
          function qt(wn) {
            var Hn = At(wn);
            Hn.length !== je.length && mn("Mismatched type converter count");
            for (var Er = 0; Er < je.length; ++Er)
              as(je[Er], Hn[Er]);
          }
          var un = new Array(Je.length), An = [], Fn = 0;
          Je.forEach((wn, Hn) => {
            Oo.hasOwnProperty(wn) ? un[Hn] = Oo[wn] : (An.push(wn), Io.hasOwnProperty(wn) || (Io[wn] = []), Io[wn].push(() => {
              un[Hn] = Oo[wn], ++Fn, Fn === An.length && qt(un);
            }));
          }), An.length === 0 && qt(un);
        }
        function Sn(je) {
          var Je = go[je];
          delete go[je];
          var At = Je.elements, qt = At.length, un = At.map(function(wn) {
            return wn.getterReturnType;
          }).concat(At.map(function(wn) {
            return wn.setterArgumentType;
          })), An = Je.rawConstructor, Fn = Je.rawDestructor;
          nn([je], un, function(wn) {
            return At.forEach((Hn, Er) => {
              var Cr = wn[Er], zr = Hn.getter, hr = Hn.getterContext, xr = wn[Er + qt], Is = Hn.setter, fs = Hn.setterContext;
              Hn.read = (co) => Cr.fromWireType(zr(hr, co)), Hn.write = (co, Yo) => {
                var Qn = [];
                Is(fs, co, xr.toWireType(Qn, Yo)), ks(Qn);
              };
            }), [{ name: Je.name, fromWireType: function(Hn) {
              for (var Er = new Array(qt), Cr = 0; Cr < qt; ++Cr)
                Er[Cr] = At[Cr].read(Hn);
              return Fn(Hn), Er;
            }, toWireType: function(Hn, Er) {
              if (qt !== Er.length)
                throw new TypeError("Incorrect number of tuple elements for " + Je.name + ": expected=" + qt + ", actual=" + Er.length);
              for (var Cr = An(), zr = 0; zr < qt; ++zr)
                At[zr].write(Cr, Er[zr]);
              return Hn !== null && Hn.push(Fn, Cr), Cr;
            }, argPackAdvance: 8, readValueFromPointer: Ci, destructorFunction: Fn }];
          });
        }
        var Mn = {};
        function yn(je) {
          var Je = Mn[je];
          delete Mn[je];
          var At = Je.rawConstructor, qt = Je.rawDestructor, un = Je.fields, An = un.map((Fn) => Fn.getterReturnType).concat(un.map((Fn) => Fn.setterArgumentType));
          nn([je], An, (Fn) => {
            var wn = {};
            return un.forEach((Hn, Er) => {
              var Cr = Hn.fieldName, zr = Fn[Er], hr = Hn.getter, xr = Hn.getterContext, Is = Fn[Er + un.length], fs = Hn.setter, co = Hn.setterContext;
              wn[Cr] = { read: (Yo) => zr.fromWireType(hr(xr, Yo)), write: (Yo, Qn) => {
                var es = [];
                fs(co, Yo, Is.toWireType(es, Qn)), ks(es);
              } };
            }), [{ name: Je.name, fromWireType: function(Hn) {
              var Er = {};
              for (var Cr in wn)
                Er[Cr] = wn[Cr].read(Hn);
              return qt(Hn), Er;
            }, toWireType: function(Hn, Er) {
              for (var Cr in wn)
                if (!(Cr in Er))
                  throw new TypeError('Missing field:  "' + Cr + '"');
              var zr = At();
              for (Cr in wn)
                wn[Cr].write(zr, Er[Cr]);
              return Hn !== null && Hn.push(qt, zr), zr;
            }, argPackAdvance: 8, readValueFromPointer: Ci, destructorFunction: qt }];
          });
        }
        function Pt(je, Je, At, qt, un) {
        }
        function tr(je) {
          switch (je) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError("Unknown type size: " + je);
          }
        }
        function Lt() {
          for (var je = new Array(256), Je = 0; Je < 256; ++Je)
            je[Je] = String.fromCharCode(Je);
          dr = je;
        }
        var dr = void 0;
        function ur(je) {
          for (var Je = "", At = je; u()[At >>> 0]; )
            Je += dr[u()[At++ >>> 0]];
          return Je;
        }
        var gr = void 0;
        function Rr(je) {
          throw new gr(je);
        }
        function as(je, Je, At = {}) {
          if (!("argPackAdvance" in Je))
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          var qt = Je.name;
          if (je || Rr('type "' + qt + '" must have a positive integer typeid pointer'), Oo.hasOwnProperty(je)) {
            if (At.ignoreDuplicateRegistrations)
              return;
            Rr("Cannot register type '" + qt + "' twice");
          }
          if (Oo[je] = Je, delete Zs[je], Io.hasOwnProperty(je)) {
            var un = Io[je];
            delete Io[je], un.forEach((An) => An());
          }
        }
        function hs(je, Je, At, qt, un) {
          var An = tr(At);
          Je = ur(Je), as(je, { name: Je, fromWireType: function(Fn) {
            return !!Fn;
          }, toWireType: function(Fn, wn) {
            return wn ? qt : un;
          }, argPackAdvance: 8, readValueFromPointer: function(Fn) {
            var wn;
            if (At === 1)
              wn = l();
            else if (At === 2)
              wn = c();
            else if (At === 4)
              wn = d();
            else
              throw new TypeError("Unknown boolean type size: " + Je);
            return this.fromWireType(wn[Fn >>> An]);
          }, destructorFunction: null });
        }
        function Os(je) {
          if (!(this instanceof As) || !(je instanceof As))
            return !1;
          for (var Je = this.$$.ptrType.registeredClass, At = this.$$.ptr, qt = je.$$.ptrType.registeredClass, un = je.$$.ptr; Je.baseClass; )
            At = Je.upcast(At), Je = Je.baseClass;
          for (; qt.baseClass; )
            un = qt.upcast(un), qt = qt.baseClass;
          return Je === qt && At === un;
        }
        function jo(je) {
          return { count: je.count, deleteScheduled: je.deleteScheduled, preservePointerOnDelete: je.preservePointerOnDelete, ptr: je.ptr, ptrType: je.ptrType, smartPtr: je.smartPtr, smartPtrType: je.smartPtrType };
        }
        function po(je) {
          function Je(At) {
            return At.$$.ptrType.registeredClass.name;
          }
          Rr(Je(je) + " instance already deleted");
        }
        var So = !1;
        function Eo(je) {
        }
        function Ps(je) {
          je.smartPtr ? je.smartPtrType.rawDestructor(je.smartPtr) : je.ptrType.registeredClass.rawDestructor(je.ptr);
        }
        function no(je) {
          je.count.value -= 1;
          var Je = je.count.value === 0;
          Je && Ps(je);
        }
        function gs(je, Je, At) {
          if (Je === At)
            return je;
          if (At.baseClass === void 0)
            return null;
          var qt = gs(je, Je, At.baseClass);
          return qt === null ? null : At.downcast(qt);
        }
        var fo = {};
        function xs() {
          return Object.keys(Ro).length;
        }
        function Ir() {
          var je = [];
          for (var Je in Ro)
            Ro.hasOwnProperty(Je) && je.push(Ro[Je]);
          return je;
        }
        var ws = [];
        function fr() {
          for (; ws.length; ) {
            var je = ws.pop();
            je.$$.deleteScheduled = !1, je.delete();
          }
        }
        var Mr = void 0;
        function Nr(je) {
          Mr = je, ws.length && Mr && Mr(fr);
        }
        function ii() {
          R.getInheritedInstanceCount = xs, R.getLiveInheritedInstances = Ir, R.flushPendingDeletes = fr, R.setDelayFunction = Nr;
        }
        var Ro = {};
        function Bo(je, Je) {
          for (Je === void 0 && Rr("ptr should not be undefined"); je.baseClass; )
            Je = je.upcast(Je), je = je.baseClass;
          return Je;
        }
        function Rs(je, Je) {
          return Je = Bo(je, Je), Ro[Je];
        }
        function Uo(je, Je) {
          (!Je.ptrType || !Je.ptr) && mn("makeClassHandle requires ptr and ptrType");
          var At = !!Je.smartPtrType, qt = !!Je.smartPtr;
          return At !== qt && mn("Both smartPtrType and smartPtr must be specified"), Je.count = { value: 1 }, Vo(Object.create(je, { $$: { value: Je } }));
        }
        function xi(je) {
          var Je = this.getPointee(je);
          if (!Je)
            return this.destructor(je), null;
          var At = Rs(this.registeredClass, Je);
          if (At !== void 0) {
            if (At.$$.count.value === 0)
              return At.$$.ptr = Je, At.$$.smartPtr = je, At.clone();
            var qt = At.clone();
            return this.destructor(je), qt;
          }
          function un() {
            return this.isSmartPointer ? Uo(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: Je, smartPtrType: this, smartPtr: je }) : Uo(this.registeredClass.instancePrototype, { ptrType: this, ptr: je });
          }
          var An = this.registeredClass.getActualType(Je), Fn = fo[An];
          if (!Fn)
            return un.call(this);
          var wn;
          this.isConst ? wn = Fn.constPointerType : wn = Fn.pointerType;
          var Hn = gs(Je, this.registeredClass, wn.registeredClass);
          return Hn === null ? un.call(this) : this.isSmartPointer ? Uo(wn.registeredClass.instancePrototype, { ptrType: wn, ptr: Hn, smartPtrType: this, smartPtr: je }) : Uo(wn.registeredClass.instancePrototype, { ptrType: wn, ptr: Hn });
        }
        function Vo(je) {
          return typeof FinalizationRegistry > "u" ? (Vo = (Je) => Je, je) : (So = new FinalizationRegistry((Je) => {
            no(Je.$$);
          }), Vo = (Je) => {
            var At = Je.$$, qt = !!At.smartPtr;
            if (qt) {
              var un = { $$: At };
              So.register(Je, un, Je);
            }
            return Je;
          }, Eo = (Je) => So.unregister(Je), Vo(je));
        }
        function oa() {
          if (this.$$.ptr || po(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var je = Vo(Object.create(Object.getPrototypeOf(this), { $$: { value: jo(this.$$) } }));
          return je.$$.count.value += 1, je.$$.deleteScheduled = !1, je;
        }
        function ti() {
          this.$$.ptr || po(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Rr("Object already scheduled for deletion"), Eo(this), no(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        }
        function Po() {
          return !this.$$.ptr;
        }
        function ai() {
          return this.$$.ptr || po(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Rr("Object already scheduled for deletion"), ws.push(this), ws.length === 1 && Mr && Mr(fr), this.$$.deleteScheduled = !0, this;
        }
        function Wo() {
          As.prototype.isAliasOf = Os, As.prototype.clone = oa, As.prototype.delete = ti, As.prototype.isDeleted = Po, As.prototype.deleteLater = ai;
        }
        function As() {
        }
        function ro(je, Je, At) {
          if (je[Je].overloadTable === void 0) {
            var qt = je[Je];
            je[Je] = function() {
              return je[Je].overloadTable.hasOwnProperty(arguments.length) || Rr("Function '" + At + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + je[Je].overloadTable + ")!"), je[Je].overloadTable[arguments.length].apply(this, arguments);
            }, je[Je].overloadTable = [], je[Je].overloadTable[qt.argCount] = qt;
          }
        }
        function Mo(je, Je, At) {
          R.hasOwnProperty(je) ? ((At === void 0 || R[je].overloadTable !== void 0 && R[je].overloadTable[At] !== void 0) && Rr("Cannot register public name '" + je + "' twice"), ro(R, je, je), R.hasOwnProperty(At) && Rr("Cannot register multiple overloads of a function with the same number of arguments (" + At + ")!"), R[je].overloadTable[At] = Je) : (R[je] = Je, At !== void 0 && (R[je].numArguments = At));
        }
        function vr(je, Je, At, qt, un, An, Fn, wn) {
          this.name = je, this.constructor = Je, this.instancePrototype = At, this.rawDestructor = qt, this.baseClass = un, this.getActualType = An, this.upcast = Fn, this.downcast = wn, this.pureVirtualFunctions = [];
        }
        function ts(je, Je, At) {
          for (; Je !== At; )
            Je.upcast || Rr("Expected null or instance of " + At.name + ", got an instance of " + Je.name), je = Je.upcast(je), Je = Je.baseClass;
          return je;
        }
        function kr(je, Je) {
          if (Je === null)
            return this.isReference && Rr("null is not a valid " + this.name), 0;
          Je.$$ || Rr('Cannot pass "' + Gt(Je) + '" as a ' + this.name), Je.$$.ptr || Rr("Cannot pass deleted object as a pointer of type " + this.name);
          var At = Je.$$.ptrType.registeredClass, qt = ts(Je.$$.ptr, At, this.registeredClass);
          return qt;
        }
        function Us(je, Je) {
          var At;
          if (Je === null)
            return this.isReference && Rr("null is not a valid " + this.name), this.isSmartPointer ? (At = this.rawConstructor(), je !== null && je.push(this.rawDestructor, At), At) : 0;
          Je.$$ || Rr('Cannot pass "' + Gt(Je) + '" as a ' + this.name), Je.$$.ptr || Rr("Cannot pass deleted object as a pointer of type " + this.name), !this.isConst && Je.$$.ptrType.isConst && Rr("Cannot convert argument of type " + (Je.$$.smartPtrType ? Je.$$.smartPtrType.name : Je.$$.ptrType.name) + " to parameter type " + this.name);
          var qt = Je.$$.ptrType.registeredClass;
          if (At = ts(Je.$$.ptr, qt, this.registeredClass), this.isSmartPointer)
            switch (Je.$$.smartPtr === void 0 && Rr("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
              case 0:
                Je.$$.smartPtrType === this ? At = Je.$$.smartPtr : Rr("Cannot convert argument of type " + (Je.$$.smartPtrType ? Je.$$.smartPtrType.name : Je.$$.ptrType.name) + " to parameter type " + this.name);
                break;
              case 1:
                At = Je.$$.smartPtr;
                break;
              case 2:
                if (Je.$$.smartPtrType === this)
                  At = Je.$$.smartPtr;
                else {
                  var un = Je.clone();
                  At = this.rawShare(At, ds.toHandle(function() {
                    un.delete();
                  })), je !== null && je.push(this.rawDestructor, At);
                }
                break;
              default:
                Rr("Unsupporting sharing policy");
            }
          return At;
        }
        function ri(je, Je) {
          if (Je === null)
            return this.isReference && Rr("null is not a valid " + this.name), 0;
          Je.$$ || Rr('Cannot pass "' + Gt(Je) + '" as a ' + this.name), Je.$$.ptr || Rr("Cannot pass deleted object as a pointer of type " + this.name), Je.$$.ptrType.isConst && Rr("Cannot convert argument of type " + Je.$$.ptrType.name + " to parameter type " + this.name);
          var At = Je.$$.ptrType.registeredClass, qt = ts(Je.$$.ptr, At, this.registeredClass);
          return qt;
        }
        function Wi(je) {
          return this.rawGetPointee && (je = this.rawGetPointee(je)), je;
        }
        function To(je) {
          this.rawDestructor && this.rawDestructor(je);
        }
        function ia(je) {
          je !== null && je.delete();
        }
        function bo() {
          Ys.prototype.getPointee = Wi, Ys.prototype.destructor = To, Ys.prototype.argPackAdvance = 8, Ys.prototype.readValueFromPointer = Ci, Ys.prototype.deleteObject = ia, Ys.prototype.fromWireType = xi;
        }
        function Ys(je, Je, At, qt, un, An, Fn, wn, Hn, Er, Cr) {
          this.name = je, this.registeredClass = Je, this.isReference = At, this.isConst = qt, this.isSmartPointer = un, this.pointeeType = An, this.sharingPolicy = Fn, this.rawGetPointee = wn, this.rawConstructor = Hn, this.rawShare = Er, this.rawDestructor = Cr, !un && Je.baseClass === void 0 ? qt ? (this.toWireType = kr, this.destructorFunction = null) : (this.toWireType = ri, this.destructorFunction = null) : this.toWireType = Us;
        }
        function Di(je, Je, At) {
          R.hasOwnProperty(je) || mn("Replacing nonexistant public symbol"), R[je].overloadTable !== void 0 && At !== void 0 ? R[je].overloadTable[At] = Je : (R[je] = Je, R[je].argCount = At);
        }
        function Yn(je, Je, At) {
          var qt = R["dynCall_" + je];
          return At && At.length ? qt.apply(null, [Je].concat(At)) : qt.call(null, Je);
        }
        function Lo(je, Je, At) {
          if (je.includes("j"))
            return Yn(je, Je, At);
          var qt = wr(Je).apply(null, At);
          return qt;
        }
        function Un(je, Je) {
          var At = [];
          return function() {
            return At.length = 0, Object.assign(At, arguments), Lo(je, Je, At);
          };
        }
        function so(je, Je) {
          je = ur(je);
          function At() {
            return je.includes("j") ? Un(je, Je) : wr(Je);
          }
          var qt = At();
          return typeof qt != "function" && Rr("unknown function pointer with signature " + je + ": " + Je), qt;
        }
        var rs = void 0;
        function hi(je) {
          var Je = Ya(je), At = ur(Je);
          return oi(Je), At;
        }
        function Zo(je, Je) {
          var At = [], qt = {};
          function un(An) {
            if (!qt[An] && !Oo[An]) {
              if (Zs[An]) {
                Zs[An].forEach(un);
                return;
              }
              At.push(An), qt[An] = !0;
            }
          }
          throw Je.forEach(un), new rs(je + ": " + At.map(hi).join([", "]));
        }
        function li(je, Je, At, qt, un, An, Fn, wn, Hn, Er, Cr, zr, hr) {
          Cr = ur(Cr), An = so(un, An), wn && (wn = so(Fn, wn)), Er && (Er = so(Hn, Er)), hr = so(zr, hr);
          var xr = Ve(Cr);
          Mo(xr, function() {
            Zo("Cannot construct " + Cr + " due to unbound types", [qt]);
          }), nn([je, Je, At], qt ? [qt] : [], function(Is) {
            Is = Is[0];
            var fs, co;
            qt ? (fs = Is.registeredClass, co = fs.instancePrototype) : co = As.prototype;
            var Yo = Ze(xr, function() {
              if (Object.getPrototypeOf(this) !== Qn)
                throw new gr("Use 'new' to construct " + Cr);
              if (es.constructor_body === void 0)
                throw new gr(Cr + " has no accessible constructor");
              var zs = es.constructor_body[arguments.length];
              if (zs === void 0)
                throw new gr("Tried to invoke ctor of " + Cr + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(es.constructor_body).toString() + ") parameters instead!");
              return zs.apply(this, arguments);
            }), Qn = Object.create(co, { constructor: { value: Yo } });
            Yo.prototype = Qn;
            var es = new vr(Cr, Yo, Qn, hr, fs, An, wn, Er), Jo = new Ys(Cr, es, !0, !1, !1), js = new Ys(Cr + "*", es, !1, !1, !1), Hi = new Ys(Cr + " const*", es, !1, !0, !1);
            return fo[je] = { pointerType: js, constPointerType: Hi }, Di(xr, Yo), [Jo, js, Hi];
          });
        }
        function ei(je, Je) {
          for (var At = [], qt = 0; qt < je; qt++)
            At.push(f()[Je + qt * 4 >>> 2]);
          return At;
        }
        function Or(je, Je) {
          if (!(je instanceof Function))
            throw new TypeError("new_ called with constructor type " + typeof je + " which is not a function");
          var At = Ze(je.name || "unknownFunctionName", function() {
          });
          At.prototype = je.prototype;
          var qt = new At(), un = je.apply(qt, Je);
          return un instanceof Object ? un : qt;
        }
        function ui(je, Je, At, qt, un) {
          var An = Je.length;
          An < 2 && Rr("argTypes array size mismatch! Must at least get return value and 'this' types!");
          for (var Fn = Je[1] !== null && At !== null, wn = !1, Hn = 1; Hn < Je.length; ++Hn)
            if (Je[Hn] !== null && Je[Hn].destructorFunction === void 0) {
              wn = !0;
              break;
            }
          for (var Er = Je[0].name !== "void", Cr = "", zr = "", Hn = 0; Hn < An - 2; ++Hn)
            Cr += (Hn !== 0 ? ", " : "") + "arg" + Hn, zr += (Hn !== 0 ? ", " : "") + "arg" + Hn + "Wired";
          var hr = "return function " + Ve(je) + "(" + Cr + `) {
if (arguments.length !== ` + (An - 2) + `) {
throwBindingError('function ` + je + " called with ' + arguments.length + ' arguments, expected " + (An - 2) + ` args!');
}
`;
          wn && (hr += `var destructors = [];
`);
          var xr = wn ? "destructors" : "null", Is = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], fs = [Rr, qt, un, ks, Je[0], Je[1]];
          Fn && (hr += "var thisWired = classParam.toWireType(" + xr + `, this);
`);
          for (var Hn = 0; Hn < An - 2; ++Hn)
            hr += "var arg" + Hn + "Wired = argType" + Hn + ".toWireType(" + xr + ", arg" + Hn + "); // " + Je[Hn + 2].name + `
`, Is.push("argType" + Hn), fs.push(Je[Hn + 2]);
          if (Fn && (zr = "thisWired" + (zr.length > 0 ? ", " : "") + zr), hr += (Er ? "var rv = " : "") + "invoker(fn" + (zr.length > 0 ? ", " : "") + zr + `);
`, wn)
            hr += `runDestructors(destructors);
`;
          else
            for (var Hn = Fn ? 1 : 2; Hn < Je.length; ++Hn) {
              var co = Hn === 1 ? "thisWired" : "arg" + (Hn - 2) + "Wired";
              Je[Hn].destructorFunction !== null && (hr += co + "_dtor(" + co + "); // " + Je[Hn].name + `
`, Is.push(co + "_dtor"), fs.push(Je[Hn].destructorFunction));
            }
          Er && (hr += `var ret = retType.fromWireType(rv);
return ret;
`), hr += `}
`, Is.push(hr);
          var Yo = Or(Function, Is).apply(null, fs);
          return Yo;
        }
        function _s(je, Je, At, qt, un, An) {
          Be(Je > 0);
          var Fn = ei(Je, At);
          un = so(qt, un), nn([], [je], function(wn) {
            wn = wn[0];
            var Hn = "constructor " + wn.name;
            if (wn.registeredClass.constructor_body === void 0 && (wn.registeredClass.constructor_body = []), wn.registeredClass.constructor_body[Je - 1] !== void 0)
              throw new gr("Cannot register multiple constructors with identical number of parameters (" + (Je - 1) + ") for class '" + wn.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            return wn.registeredClass.constructor_body[Je - 1] = () => {
              Zo("Cannot construct " + wn.name + " due to unbound types", Fn);
            }, nn([], Fn, function(Er) {
              return Er.splice(1, 0, null), wn.registeredClass.constructor_body[Je - 1] = ui(Hn, Er, null, un, An), [];
            }), [];
          });
        }
        function xo(je, Je, At, qt, un, An, Fn, wn) {
          var Hn = ei(At, qt);
          Je = ur(Je), An = so(un, An), nn([], [je], function(Er) {
            Er = Er[0];
            var Cr = Er.name + "." + Je;
            Je.startsWith("@@") && (Je = Symbol[Je.substring(2)]), wn && Er.registeredClass.pureVirtualFunctions.push(Je);
            function zr() {
              Zo("Cannot call " + Cr + " due to unbound types", Hn);
            }
            var hr = Er.registeredClass.instancePrototype, xr = hr[Je];
            return xr === void 0 || xr.overloadTable === void 0 && xr.className !== Er.name && xr.argCount === At - 2 ? (zr.argCount = At - 2, zr.className = Er.name, hr[Je] = zr) : (ro(hr, Je, Cr), hr[Je].overloadTable[At - 2] = zr), nn([], Hn, function(Is) {
              var fs = ui(Cr, Is, Er, An, Fn);
              return hr[Je].overloadTable === void 0 ? (fs.argCount = At - 2, hr[Je] = fs) : hr[Je].overloadTable[At - 2] = fs, [];
            }), [];
          });
        }
        var aa = [], oo = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }];
        function vs(je) {
          je > 4 && --oo[je].refcount === 0 && (oo[je] = void 0, aa.push(je));
        }
        function yi() {
          for (var je = 0, Je = 5; Je < oo.length; ++Je)
            oo[Je] !== void 0 && ++je;
          return je;
        }
        function $r() {
          for (var je = 5; je < oo.length; ++je)
            if (oo[je] !== void 0)
              return oo[je];
          return null;
        }
        function ki() {
          R.count_emval_handles = yi, R.get_first_emval = $r;
        }
        var ds = { toValue: (je) => (je || Rr("Cannot use deleted val. handle = " + je), oo[je].value), toHandle: (je) => {
          switch (je) {
            case void 0:
              return 1;
            case null:
              return 2;
            case !0:
              return 3;
            case !1:
              return 4;
            default: {
              var Je = aa.length ? aa.pop() : oo.length;
              return oo[Je] = { refcount: 1, value: je }, Je;
            }
          }
        } };
        function Ls(je, Je) {
          Je = ur(Je), as(je, { name: Je, fromWireType: function(At) {
            var qt = ds.toValue(At);
            return vs(At), qt;
          }, toWireType: function(At, qt) {
            return ds.toHandle(qt);
          }, argPackAdvance: 8, readValueFromPointer: Ci, destructorFunction: null });
        }
        function Co(je, Je, At) {
          switch (Je) {
            case 0:
              return function(qt) {
                var un = At ? l() : u();
                return this.fromWireType(un[qt >>> 0]);
              };
            case 1:
              return function(qt) {
                var un = At ? c() : E();
                return this.fromWireType(un[qt >>> 1]);
              };
            case 2:
              return function(qt) {
                var un = At ? d() : f();
                return this.fromWireType(un[qt >>> 2]);
              };
            default:
              throw new TypeError("Unknown integer type: " + je);
          }
        }
        function ps(je, Je, At, qt) {
          var un = tr(At);
          Je = ur(Je);
          function An() {
          }
          An.values = {}, as(je, { name: Je, constructor: An, fromWireType: function(Fn) {
            return this.constructor.values[Fn];
          }, toWireType: function(Fn, wn) {
            return wn.value;
          }, argPackAdvance: 8, readValueFromPointer: Co(Je, un, qt), destructorFunction: null }), Mo(Je, An);
        }
        function Tr(je, Je) {
          var At = Oo[je];
          return At === void 0 && Rr(Je + " has unknown type " + hi(je)), At;
        }
        function ao(je, Je, At) {
          var qt = Tr(je, "enum");
          Je = ur(Je);
          var un = qt.constructor, An = Object.create(qt.constructor.prototype, { value: { value: At }, constructor: { value: Ze(qt.name + "_" + Je, function() {
          }) } });
          un.values[At] = An, un[Je] = An;
        }
        function Gt(je) {
          if (je === null)
            return "null";
          var Je = typeof je;
          return Je === "object" || Je === "array" || Je === "function" ? je.toString() : "" + je;
        }
        function sr(je, Je) {
          switch (Je) {
            case 2:
              return function(At) {
                return this.fromWireType(h()[At >>> 2]);
              };
            case 3:
              return function(At) {
                return this.fromWireType(S()[At >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + je);
          }
        }
        function vt(je, Je, At) {
          var qt = tr(At);
          Je = ur(Je), as(je, { name: Je, fromWireType: function(un) {
            return un;
          }, toWireType: function(un, An) {
            return An;
          }, argPackAdvance: 8, readValueFromPointer: sr(Je, qt), destructorFunction: null });
        }
        function Jr(je, Je, At, qt, un, An) {
          var Fn = ei(Je, At);
          je = ur(je), un = so(qt, un), Mo(je, function() {
            Zo("Cannot call " + je + " due to unbound types", Fn);
          }, Je - 1), nn([], Fn, function(wn) {
            var Hn = [wn[0], null].concat(wn.slice(1));
            return Di(je, ui(je, Hn, null, un, An), Je - 1), [];
          });
        }
        function Qs(je, Je, At) {
          switch (Je) {
            case 0:
              return At ? function(un) {
                return l()[un >>> 0];
              } : function(un) {
                return u()[un >>> 0];
              };
            case 1:
              return At ? function(un) {
                return c()[un >>> 1];
              } : function(un) {
                return E()[un >>> 1];
              };
            case 2:
              return At ? function(un) {
                return d()[un >>> 2];
              } : function(un) {
                return f()[un >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + je);
          }
        }
        function Ds(je, Je, At, qt, un) {
          Je = ur(Je);
          var An = tr(At), Fn = (zr) => zr;
          if (qt === 0) {
            var wn = 32 - 8 * At;
            Fn = (zr) => zr << wn >>> wn;
          }
          var Hn = Je.includes("unsigned"), Er = (zr, hr) => {
          }, Cr;
          Hn ? Cr = function(zr, hr) {
            return Er(hr, this.name), hr >>> 0;
          } : Cr = function(zr, hr) {
            return Er(hr, this.name), hr;
          }, as(je, { name: Je, fromWireType: Fn, toWireType: Cr, argPackAdvance: 8, readValueFromPointer: Qs(Je, An, qt !== 0), destructorFunction: null });
        }
        function Hs(je, Je, At) {
          var qt = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], un = qt[Je];
          function An(Fn) {
            Fn = Fn >> 2;
            var wn = f(), Hn = wn[Fn >>> 0], Er = wn[Fn + 1 >>> 0];
            return new un(wn.buffer, Er, Hn);
          }
          At = ur(At), as(je, { name: At, fromWireType: An, argPackAdvance: 8, readValueFromPointer: An }, { ignoreDuplicateRegistrations: !0 });
        }
        function Xr(je, Je) {
          Je = ur(Je);
          var At = Je === "std::string";
          as(je, { name: Je, fromWireType: function(qt) {
            var un = f()[qt >>> 2], An = qt + 4, Fn;
            if (At)
              for (var wn = An, Hn = 0; Hn <= un; ++Hn) {
                var Er = An + Hn;
                if (Hn == un || u()[Er >>> 0] == 0) {
                  var Cr = Er - wn, zr = Se(wn, Cr);
                  Fn === void 0 ? Fn = zr : (Fn += String.fromCharCode(0), Fn += zr), wn = Er + 1;
                }
              }
            else {
              for (var hr = new Array(un), Hn = 0; Hn < un; ++Hn)
                hr[Hn] = String.fromCharCode(u()[An + Hn >>> 0]);
              Fn = hr.join("");
            }
            return oi(qt), Fn;
          }, toWireType: function(qt, un) {
            un instanceof ArrayBuffer && (un = new Uint8Array(un));
            var An, Fn = typeof un == "string";
            Fn || un instanceof Uint8Array || un instanceof Uint8ClampedArray || un instanceof Int8Array || Rr("Cannot pass non-string to std::string"), At && Fn ? An = Bt(un) : An = un.length;
            var wn = Go(4 + An + 1), Hn = wn + 4;
            if (Hn >>>= 0, f()[wn >>> 2] = An, At && Fn)
              Ht(un, Hn, An + 1);
            else if (Fn)
              for (var Er = 0; Er < An; ++Er) {
                var Cr = un.charCodeAt(Er);
                Cr > 255 && (oi(Hn), Rr("String has UTF-16 code units that do not fit in 8 bits")), u()[Hn + Er >>> 0] = Cr;
              }
            else
              for (var Er = 0; Er < An; ++Er)
                u()[Hn + Er >>> 0] = un[Er];
            return qt !== null && qt.push(oi, wn), wn;
          }, argPackAdvance: 8, readValueFromPointer: Ci, destructorFunction: function(qt) {
            oi(qt);
          } });
        }
        var bi = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0;
        function rn(je, Je) {
          for (var At = je, qt = At >> 1, un = qt + Je / 2; !(qt >= un) && E()[qt >>> 0]; )
            ++qt;
          if (At = qt << 1, At - je > 32 && bi)
            return bi.decode(u().slice(je, At));
          for (var An = "", Fn = 0; !(Fn >= Je / 2); ++Fn) {
            var wn = c()[je + Fn * 2 >>> 1];
            if (wn == 0)
              break;
            An += String.fromCharCode(wn);
          }
          return An;
        }
        function mo(je, Je, At) {
          if (At === void 0 && (At = 2147483647), At < 2)
            return 0;
          At -= 2;
          for (var qt = Je, un = At < je.length * 2 ? At / 2 : je.length, An = 0; An < un; ++An) {
            var Fn = je.charCodeAt(An);
            c()[Je >>> 1] = Fn, Je += 2;
          }
          return c()[Je >>> 1] = 0, Je - qt;
        }
        function Gi(je) {
          return je.length * 2;
        }
        function yo(je, Je) {
          for (var At = 0, qt = ""; !(At >= Je / 4); ) {
            var un = d()[je + At * 4 >>> 2];
            if (un == 0)
              break;
            if (++At, un >= 65536) {
              var An = un - 65536;
              qt += String.fromCharCode(55296 | An >> 10, 56320 | An & 1023);
            } else
              qt += String.fromCharCode(un);
          }
          return qt;
        }
        function ci(je, Je, At) {
          if (Je >>>= 0, At === void 0 && (At = 2147483647), At < 4)
            return 0;
          for (var qt = Je, un = qt + At - 4, An = 0; An < je.length; ++An) {
            var Fn = je.charCodeAt(An);
            if (Fn >= 55296 && Fn <= 57343) {
              var wn = je.charCodeAt(++An);
              Fn = 65536 + ((Fn & 1023) << 10) | wn & 1023;
            }
            if (d()[Je >>> 2] = Fn, Je += 4, Je + 4 > un)
              break;
          }
          return d()[Je >>> 2] = 0, Je - qt;
        }
        function Ri(je) {
          for (var Je = 0, At = 0; At < je.length; ++At) {
            var qt = je.charCodeAt(At);
            qt >= 55296 && qt <= 57343 && ++At, Je += 4;
          }
          return Je;
        }
        function ms(je, Je, At) {
          At = ur(At);
          var qt, un, An, Fn, wn;
          Je === 2 ? (qt = rn, un = mo, Fn = Gi, An = () => E(), wn = 1) : Je === 4 && (qt = yo, un = ci, Fn = Ri, An = () => f(), wn = 2), as(je, { name: At, fromWireType: function(Hn) {
            for (var Er = f()[Hn >>> 2], Cr = An(), zr, hr = Hn + 4, xr = 0; xr <= Er; ++xr) {
              var Is = Hn + 4 + xr * Je;
              if (xr == Er || Cr[Is >>> wn] == 0) {
                var fs = Is - hr, co = qt(hr, fs);
                zr === void 0 ? zr = co : (zr += String.fromCharCode(0), zr += co), hr = Is + Je;
              }
            }
            return oi(Hn), zr;
          }, toWireType: function(Hn, Er) {
            typeof Er != "string" && Rr("Cannot pass non-string to C++ string type " + At);
            var Cr = Fn(Er), zr = Go(4 + Cr + Je);
            return zr >>>= 0, f()[zr >>> 2] = Cr >> wn, un(Er, zr + 4, Cr + Je), Hn !== null && Hn.push(oi, zr), zr;
          }, argPackAdvance: 8, readValueFromPointer: Ci, destructorFunction: function(Hn) {
            oi(Hn);
          } });
        }
        function zt(je, Je, At, qt, un, An) {
          go[je] = { name: ur(Je), rawConstructor: so(At, qt), rawDestructor: so(un, An), elements: [] };
        }
        function fn(je, Je, At, qt, un, An, Fn, wn, Hn) {
          go[je].elements.push({ getterReturnType: Je, getter: so(At, qt), getterContext: un, setterArgumentType: An, setter: so(Fn, wn), setterContext: Hn });
        }
        function Bn(je, Je, At, qt, un, An) {
          Mn[je] = { name: ur(Je), rawConstructor: so(At, qt), rawDestructor: so(un, An), fields: [] };
        }
        function or(je, Je, At, qt, un, An, Fn, wn, Hn, Er) {
          Mn[je].fields.push({ fieldName: ur(Je), getterReturnType: At, getter: so(qt, un), getterContext: An, setterArgumentType: Fn, setter: so(wn, Hn), setterContext: Er });
        }
        function ss(je, Je) {
          Je = ur(Je), as(je, { isVoid: !0, name: Je, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function(At, qt) {
          } });
        }
        function Xs(je) {
          ae(Se(je));
        }
        function Fo(je) {
          Atomics.store(d(), je >> 2, 1), $i() && La(je), Atomics.compareExchange(d(), je >> 2, 1, 0);
        }
        R.executeNotifiedProxyingQueue = Fo;
        function ji(je, Je, At, qt) {
          if (je == Je)
            setTimeout(() => Fo(qt));
          else if (_e)
            postMessage({ targetThread: je, cmd: "processProxyingQueue", queue: qt });
          else {
            var un = En.pthreads[je];
            if (!un)
              return;
            un.postMessage({ cmd: "processProxyingQueue", queue: qt });
          }
          return 1;
        }
        function zo(je, Je, At) {
          return -1;
        }
        function Yi(je, Je, At) {
          je = ds.toValue(je), Je = Tr(Je, "emval::as");
          var qt = [], un = ds.toHandle(qt);
          return f()[At >>> 2] = un, Je.toWireType(qt, je);
        }
        function Li(je, Je) {
          for (var At = new Array(je), qt = 0; qt < je; ++qt)
            At[qt] = Tr(f()[Je + qt * 4 >>> 2], "parameter " + qt);
          return At;
        }
        function _i(je, Je, At, qt) {
          je = ds.toValue(je);
          for (var un = Li(Je, At), An = new Array(Je), Fn = 0; Fn < Je; ++Fn) {
            var wn = un[Fn];
            An[Fn] = wn.readValueFromPointer(qt), qt += wn.argPackAdvance;
          }
          var Hn = je.apply(void 0, An);
          return ds.toHandle(Hn);
        }
        var pa = {};
        function $o(je) {
          var Je = pa[je];
          return Je === void 0 ? ur(je) : Je;
        }
        function wo() {
          return typeof globalThis == "object" ? globalThis : function() {
            return Function;
          }()("return this")();
        }
        function Ks(je) {
          return je === 0 ? ds.toHandle(wo()) : (je = $o(je), ds.toHandle(wo()[je]));
        }
        function Qo(je, Je) {
          return je = ds.toValue(je), Je = ds.toValue(Je), ds.toHandle(je[Je]);
        }
        function pi(je) {
          je > 4 && (oo[je].refcount += 1);
        }
        function Ns(je, Je) {
          return je = ds.toValue(je), Je = ds.toValue(Je), je instanceof Je;
        }
        function Fi(je) {
          return je = ds.toValue(je), typeof je == "number";
        }
        function la(je) {
          return je = ds.toValue(je), typeof je == "string";
        }
        function Ho() {
          return ds.toHandle([]);
        }
        function Ye(je) {
          return ds.toHandle($o(je));
        }
        function qe() {
          return ds.toHandle({});
        }
        function Nt(je) {
          var Je = ds.toValue(je);
          ks(Je), vs(je);
        }
        function mt(je, Je, At) {
          je = ds.toValue(je), Je = ds.toValue(Je), At = ds.toValue(At), je[Je] = At;
        }
        function pn(je, Je) {
          je = Tr(je, "_emval_take_value");
          var At = je.readValueFromPointer(Je);
          return ds.toHandle(At);
        }
        function Mt() {
          $n("");
        }
        function Ln(je) {
          Ln.shown || (Ln.shown = {}), Ln.shown[je] || (Ln.shown[je] = 1, ae(je));
        }
        function ot() {
          q || Ln("Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread");
        }
        var Xt;
        Xt = () => performance.timeOrigin + performance.now();
        function sn(je, Je, At) {
          u().copyWithin(je >>> 0, Je >>> 0, Je + At >>> 0);
        }
        function dn(je) {
          var Je = Qi(), At = je();
          return fi(Je), At;
        }
        function Ar(je, Je) {
          var At = arguments.length - 2, qt = arguments;
          return dn(() => {
            for (var un = At, An = ha(un * 8), Fn = An >> 3, wn = 0; wn < At; wn++) {
              var Hn = qt[2 + wn];
              S()[Fn + wn >>> 0] = Hn;
            }
            return Aa(je, un, An, Je);
          });
        }
        var yr = [];
        function Pr(je, Je, At) {
          yr.length = Je;
          for (var qt = At >> 3, un = 0; un < Je; un++)
            yr[un] = S()[qt + un >>> 0];
          var An = Bi[je];
          return An.apply(null, yr);
        }
        function Zr() {
          return 4294901760;
        }
        function qs(je) {
          var Je = De.buffer;
          try {
            return De.grow(je - Je.byteLength + 65535 >>> 16), Zt(), 1;
          } catch {
          }
        }
        function Ws(je) {
          var Je = u().length;
          if (je = je >>> 0, je <= Je)
            return !1;
          var At = Zr();
          if (je > At)
            return !1;
          let qt = (Hn, Er) => Hn + (Er - Hn % Er) % Er;
          for (var un = 1; un <= 4; un *= 2) {
            var An = Je * (1 + 0.2 / un);
            An = Math.min(An, je + 100663296);
            var Fn = Math.min(At, qt(Math.max(je, An), 65536)), wn = qs(Fn);
            if (wn)
              return !0;
          }
          return !1;
        }
        function Bs() {
          throw "unwind";
        }
        var Sr = {};
        function Wr() {
          return F || "./this.program";
        }
        function lo() {
          if (!lo.strings) {
            var je = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", Je = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: je, _: Wr() };
            for (var At in Sr)
              Sr[At] === void 0 ? delete Je[At] : Je[At] = Sr[At];
            var qt = [];
            for (var At in Je)
              qt.push(At + "=" + Je[At]);
            lo.strings = qt;
          }
          return lo.strings;
        }
        function uo(je, Je, At) {
          for (var qt = 0; qt < je.length; ++qt)
            l()[Je++ >>> 0] = je.charCodeAt(qt);
          At || (l()[Je >>> 0] = 0);
        }
        function Vs(je, Je) {
          if (_e)
            return Ar(3, 1, je, Je);
          var At = 0;
          return lo().forEach(function(qt, un) {
            var An = Je + At;
            f()[je + un * 4 >>> 2] = An, uo(qt, An), At += qt.length + 1;
          }), 0;
        }
        function Gs(je, Je) {
          if (_e)
            return Ar(4, 1, je, Je);
          var At = lo();
          f()[je >>> 2] = At.length;
          var qt = 0;
          return At.forEach(function(un) {
            qt += un.length + 1;
          }), f()[Je >>> 2] = qt, 0;
        }
        function Ni(je) {
          if (_e)
            return Ar(5, 1, je);
          try {
            var Je = to.getStreamFromFD(je);
            return en.close(Je), 0;
          } catch (At) {
            if (typeof en > "u" || !(At instanceof en.ErrnoError))
              throw At;
            return At.errno;
          }
        }
        function zi(je, Je, At, qt) {
          for (var un = 0, An = 0; An < At; An++) {
            var Fn = f()[Je >>> 2], wn = f()[Je + 4 >>> 2];
            Je += 8;
            var Hn = en.read(je, l(), Fn, wn, qt);
            if (Hn < 0)
              return -1;
            if (un += Hn, Hn < wn)
              break;
            typeof qt < "u" && (qt += Hn);
          }
          return un;
        }
        function Ko(je, Je, At, qt) {
          if (_e)
            return Ar(6, 1, je, Je, At, qt);
          try {
            var un = to.getStreamFromFD(je), An = zi(un, Je, At);
            return f()[qt >>> 2] = An, 0;
          } catch (Fn) {
            if (typeof en > "u" || !(Fn instanceof en.ErrnoError))
              throw Fn;
            return Fn.errno;
          }
        }
        function di(je, Je) {
          return Je + 2097152 >>> 0 < 4194305 - !!je ? (je >>> 0) + Je * 4294967296 : NaN;
        }
        function eo(je, Je, At, qt, un) {
          if (_e)
            return Ar(7, 1, je, Je, At, qt, un);
          try {
            var An = di(Je, At);
            if (isNaN(An))
              return 61;
            var Fn = to.getStreamFromFD(je);
            return en.llseek(Fn, An, qt), Xn = [Fn.position >>> 0, (Jn = Fn.position, +Math.abs(Jn) >= 1 ? Jn > 0 ? (Math.min(+Math.floor(Jn / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((Jn - +(~~Jn >>> 0)) / 4294967296) >>> 0 : 0)], d()[un >>> 2] = Xn[0], d()[un + 4 >>> 2] = Xn[1], Fn.getdents && An === 0 && qt === 0 && (Fn.getdents = null), 0;
          } catch (wn) {
            if (typeof en > "u" || !(wn instanceof en.ErrnoError))
              throw wn;
            return wn.errno;
          }
        }
        function ua(je, Je, At, qt) {
          for (var un = 0, An = 0; An < At; An++) {
            var Fn = f()[Je >>> 2], wn = f()[Je + 4 >>> 2];
            Je += 8;
            var Hn = en.write(je, l(), Fn, wn, qt);
            if (Hn < 0)
              return -1;
            un += Hn, typeof qt < "u" && (qt += Hn);
          }
          return un;
        }
        function qo(je, Je, At, qt) {
          if (_e)
            return Ar(8, 1, je, Je, At, qt);
          try {
            var un = to.getStreamFromFD(je), An = ua(un, Je, At);
            return f()[qt >>> 2] = An, 0;
          } catch (Fn) {
            if (typeof en > "u" || !(Fn instanceof en.ErrnoError))
              throw Fn;
            return Fn.errno;
          }
        }
        function Mi(je) {
          return je % 4 === 0 && (je % 100 !== 0 || je % 400 === 0);
        }
        function si(je, Je) {
          for (var At = 0, qt = 0; qt <= Je; At += je[qt++])
            ;
          return At;
        }
        var ko = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ni = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function da(je, Je) {
          for (var At = new Date(je.getTime()); Je > 0; ) {
            var qt = Mi(At.getFullYear()), un = At.getMonth(), An = (qt ? ko : ni)[un];
            if (Je > An - At.getDate())
              Je -= An - At.getDate() + 1, At.setDate(1), un < 11 ? At.setMonth(un + 1) : (At.setMonth(0), At.setFullYear(At.getFullYear() + 1));
            else
              return At.setDate(At.getDate() + Je), At;
          }
          return At;
        }
        function vi(je, Je) {
          l().set(je, Je >>> 0);
        }
        function fa(je, Je, At, qt) {
          var un = d()[qt + 40 >>> 2], An = { tm_sec: d()[qt >>> 2], tm_min: d()[qt + 4 >>> 2], tm_hour: d()[qt + 8 >>> 2], tm_mday: d()[qt + 12 >>> 2], tm_mon: d()[qt + 16 >>> 2], tm_year: d()[qt + 20 >>> 2], tm_wday: d()[qt + 24 >>> 2], tm_yday: d()[qt + 28 >>> 2], tm_isdst: d()[qt + 32 >>> 2], tm_gmtoff: d()[qt + 36 >>> 2], tm_zone: un ? Se(un) : "" }, Fn = Se(At), wn = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var Hn in wn)
            Fn = Fn.replace(new RegExp(Hn, "g"), wn[Hn]);
          var Er = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Cr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function zr(Qn, es, Jo) {
            for (var js = typeof Qn == "number" ? Qn.toString() : Qn || ""; js.length < es; )
              js = Jo[0] + js;
            return js;
          }
          function hr(Qn, es) {
            return zr(Qn, es, "0");
          }
          function xr(Qn, es) {
            function Jo(Hi) {
              return Hi < 0 ? -1 : Hi > 0 ? 1 : 0;
            }
            var js;
            return (js = Jo(Qn.getFullYear() - es.getFullYear())) === 0 && (js = Jo(Qn.getMonth() - es.getMonth())) === 0 && (js = Jo(Qn.getDate() - es.getDate())), js;
          }
          function Is(Qn) {
            switch (Qn.getDay()) {
              case 0:
                return new Date(Qn.getFullYear() - 1, 11, 29);
              case 1:
                return Qn;
              case 2:
                return new Date(Qn.getFullYear(), 0, 3);
              case 3:
                return new Date(Qn.getFullYear(), 0, 2);
              case 4:
                return new Date(Qn.getFullYear(), 0, 1);
              case 5:
                return new Date(Qn.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(Qn.getFullYear() - 1, 11, 30);
            }
          }
          function fs(Qn) {
            var es = da(new Date(Qn.tm_year + 1900, 0, 1), Qn.tm_yday), Jo = new Date(es.getFullYear(), 0, 4), js = new Date(es.getFullYear() + 1, 0, 4), Hi = Is(Jo), zs = Is(js);
            return xr(Hi, es) <= 0 ? xr(zs, es) <= 0 ? es.getFullYear() + 1 : es.getFullYear() : es.getFullYear() - 1;
          }
          var co = { "%a": function(Qn) {
            return Er[Qn.tm_wday].substring(0, 3);
          }, "%A": function(Qn) {
            return Er[Qn.tm_wday];
          }, "%b": function(Qn) {
            return Cr[Qn.tm_mon].substring(0, 3);
          }, "%B": function(Qn) {
            return Cr[Qn.tm_mon];
          }, "%C": function(Qn) {
            var es = Qn.tm_year + 1900;
            return hr(es / 100 | 0, 2);
          }, "%d": function(Qn) {
            return hr(Qn.tm_mday, 2);
          }, "%e": function(Qn) {
            return zr(Qn.tm_mday, 2, " ");
          }, "%g": function(Qn) {
            return fs(Qn).toString().substring(2);
          }, "%G": function(Qn) {
            return fs(Qn);
          }, "%H": function(Qn) {
            return hr(Qn.tm_hour, 2);
          }, "%I": function(Qn) {
            var es = Qn.tm_hour;
            return es == 0 ? es = 12 : es > 12 && (es -= 12), hr(es, 2);
          }, "%j": function(Qn) {
            return hr(Qn.tm_mday + si(Mi(Qn.tm_year + 1900) ? ko : ni, Qn.tm_mon - 1), 3);
          }, "%m": function(Qn) {
            return hr(Qn.tm_mon + 1, 2);
          }, "%M": function(Qn) {
            return hr(Qn.tm_min, 2);
          }, "%n": function() {
            return `
`;
          }, "%p": function(Qn) {
            return Qn.tm_hour >= 0 && Qn.tm_hour < 12 ? "AM" : "PM";
          }, "%S": function(Qn) {
            return hr(Qn.tm_sec, 2);
          }, "%t": function() {
            return "	";
          }, "%u": function(Qn) {
            return Qn.tm_wday || 7;
          }, "%U": function(Qn) {
            var es = Qn.tm_yday + 7 - Qn.tm_wday;
            return hr(Math.floor(es / 7), 2);
          }, "%V": function(Qn) {
            var es = Math.floor((Qn.tm_yday + 7 - (Qn.tm_wday + 6) % 7) / 7);
            if ((Qn.tm_wday + 371 - Qn.tm_yday - 2) % 7 <= 2 && es++, es) {
              if (es == 53) {
                var js = (Qn.tm_wday + 371 - Qn.tm_yday) % 7;
                js != 4 && (js != 3 || !Mi(Qn.tm_year)) && (es = 1);
              }
            } else {
              es = 52;
              var Jo = (Qn.tm_wday + 7 - Qn.tm_yday - 1) % 7;
              (Jo == 4 || Jo == 5 && Mi(Qn.tm_year % 400 - 1)) && es++;
            }
            return hr(es, 2);
          }, "%w": function(Qn) {
            return Qn.tm_wday;
          }, "%W": function(Qn) {
            var es = Qn.tm_yday + 7 - (Qn.tm_wday + 6) % 7;
            return hr(Math.floor(es / 7), 2);
          }, "%y": function(Qn) {
            return (Qn.tm_year + 1900).toString().substring(2);
          }, "%Y": function(Qn) {
            return Qn.tm_year + 1900;
          }, "%z": function(Qn) {
            var es = Qn.tm_gmtoff, Jo = es >= 0;
            return es = Math.abs(es) / 60, es = es / 60 * 100 + es % 60, (Jo ? "+" : "-") + ("0000" + es).slice(-4);
          }, "%Z": function(Qn) {
            return Qn.tm_zone;
          }, "%%": function() {
            return "%";
          } };
          Fn = Fn.replace(/%%/g, "\0\0");
          for (var Hn in co)
            Fn.includes(Hn) && (Fn = Fn.replace(new RegExp(Hn, "g"), co[Hn](An)));
          Fn = Fn.replace(/\0\0/g, "%");
          var Yo = Fr(Fn, !1);
          return Yo.length > Je ? 0 : (vi(Yo, je), Yo.length - 1);
        }
        function vo(je, Je, At, qt, un) {
          return fa(je, Je, At, qt);
        }
        En.init();
        var Xi = function(je, Je, At, qt) {
          je || (je = this), this.parent = je, this.mount = je.mount, this.mounted = null, this.id = en.nextInode++, this.name = Je, this.mode = At, this.node_ops = {}, this.stream_ops = {}, this.rdev = qt;
        }, gi = 365, Ao = 146;
        Object.defineProperties(Xi.prototype, { read: { get: function() {
          return (this.mode & gi) === gi;
        }, set: function(je) {
          je ? this.mode |= gi : this.mode &= ~gi;
        } }, write: { get: function() {
          return (this.mode & Ao) === Ao;
        }, set: function(je) {
          je ? this.mode |= Ao : this.mode &= ~Ao;
        } }, isFolder: { get: function() {
          return en.isDir(this.mode);
        } }, isDevice: { get: function() {
          return en.isChrdev(this.mode);
        } } }), en.FSNode = Xi, en.staticInit(), Ut = R.InternalError = bt(Error, "InternalError"), Lt(), gr = R.BindingError = bt(Error, "BindingError"), Wo(), ii(), bo(), rs = R.UnboundTypeError = bt(Error, "UnboundTypeError"), ki();
        var Bi = [null, bs, kn, Vs, Gs, Ni, Ko, eo, qo], Ga = { h: Es, U: Dr, K: Kr, Y: Js, $: No, _: Ai, ea: Sn, r: yn, I: Pt, ca: hs, q: li, p: _s, c: xo, ba: Ls, E: ps, u: ao, C: vt, d: Jr, t: Ds, j: Hs, D: Xr, y: ms, fa: zt, m: fn, s: Bn, f: or, da: ss, Z: Xs, W: ji, T: zo, l: Yi, x: _i, b: vs, A: Ks, i: Qo, o: pi, G: Ns, z: Fi, F: la, ga: Ho, g: Ye, w: qe, k: Nt, n: mt, e: pn, B: Mt, V: ot, v: Xt, X: sn, S: Pr, Q: Ws, aa: Bs, M: Vs, N: Gs, J: lr, O: Ni, P: Ko, H: eo, R: qo, a: De || R.wasmMemory, L: vo };
        Gn();
        var Go = function() {
          return (Go = R.asm.ja).apply(null, arguments);
        };
        R.__emscripten_tls_init = function() {
          return (R.__emscripten_tls_init = R.asm.ka).apply(null, arguments);
        };
        var $i = R._pthread_self = function() {
          return ($i = R._pthread_self = R.asm.la).apply(null, arguments);
        }, Ya = R.___getTypeName = function() {
          return (Ya = R.___getTypeName = R.asm.ma).apply(null, arguments);
        };
        R.__embind_initialize_bindings = function() {
          return (R.__embind_initialize_bindings = R.asm.na).apply(null, arguments);
        };
        var Ui = R.__emscripten_thread_init = function() {
          return (Ui = R.__emscripten_thread_init = R.asm.oa).apply(null, arguments);
        };
        R.__emscripten_thread_crashed = function() {
          return (R.__emscripten_thread_crashed = R.asm.pa).apply(null, arguments);
        };
        var Aa = function() {
          return (Aa = R.asm.qa).apply(null, arguments);
        }, La = R.__emscripten_proxy_execute_task_queue = function() {
          return (La = R.__emscripten_proxy_execute_task_queue = R.asm.ra).apply(null, arguments);
        }, za = function() {
          return (za = R.asm.sa).apply(null, arguments);
        }, Ta = R.__emscripten_thread_exit = function() {
          return (Ta = R.__emscripten_thread_exit = R.asm.ta).apply(null, arguments);
        }, oi = function() {
          return (oi = R.asm.ua).apply(null, arguments);
        }, Na = function() {
          return (Na = R.asm.va).apply(null, arguments);
        }, Qi = function() {
          return (Qi = R.asm.wa).apply(null, arguments);
        }, fi = function() {
          return (fi = R.asm.xa).apply(null, arguments);
        }, ha = function() {
          return (ha = R.asm.ya).apply(null, arguments);
        }, ca = function() {
          return (ca = R.asm.za).apply(null, arguments);
        };
        R.dynCall_jiji = function() {
          return (R.dynCall_jiji = R.asm.Aa).apply(null, arguments);
        }, R.dynCall_viijii = function() {
          return (R.dynCall_viijii = R.asm.Ba).apply(null, arguments);
        }, R.dynCall_iiiiij = function() {
          return (R.dynCall_iiiiij = R.asm.Ca).apply(null, arguments);
        }, R.dynCall_iiiiijj = function() {
          return (R.dynCall_iiiiijj = R.asm.Da).apply(null, arguments);
        }, R.dynCall_iiiiiijj = function() {
          return (R.dynCall_iiiiiijj = R.asm.Ea).apply(null, arguments);
        }, R.keepRuntimeAlive = In, R.wasmMemory = De, R.ExitStatus = rr, R.PThread = En;
        var Ki;
        Rn = function je() {
          Ki || Ba(), Ki || (Rn = je);
        };
        function Ba() {
          if (Tn > 0)
            return;
          if (_e) {
            _(R), It(), startWorker(R);
            return;
          }
          if (Cn(), Tn > 0)
            return;
          function je() {
            Ki || (Ki = !0, R.calledRun = !0, !ze && (It(), _(R), R.onRuntimeInitialized && R.onRuntimeInitialized(), ht()));
          }
          R.setStatus ? (R.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              R.setStatus("");
            }, 1), je();
          }, 1)) : je();
        }
        if (R.preInit)
          for (typeof R.preInit == "function" && (R.preInit = [R.preInit]); R.preInit.length > 0; )
            R.preInit.pop()();
        return Ba(), a.ready;
      };
    })();
    typeof r == "object" && typeof e == "object" ? e.exports = s : typeof define == "function" && define.amd ? define([], function() {
      return s;
    }) : typeof r == "object" && (r.WebIFCWasm = s);
  }
}), require_web_ifc = __commonJS({
  "dist/web-ifc.js"(r, e) {
    var s = (() => {
      var o = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
      return function(a = {}) {
        var l = typeof a < "u" ? a : {}, u, c;
        l.ready = new Promise(function(Ye, qe) {
          u = Ye, c = qe;
        });
        var E = Object.assign({}, l), d = "./this.program", f = !0, h = "";
        function S(Ye) {
          return l.locateFile ? l.locateFile(Ye, h) : h + Ye;
        }
        var R, _, m;
        typeof document < "u" && document.currentScript && (h = document.currentScript.src), o && (h = o), h.indexOf("blob:") !== 0 ? h = h.substr(0, h.replace(/[?#].*/, "").lastIndexOf("/") + 1) : h = "", R = (Ye) => {
          var qe = new XMLHttpRequest();
          return qe.open("GET", Ye, !1), qe.send(null), qe.responseText;
        }, _ = (Ye, qe, Nt) => {
          var mt = new XMLHttpRequest();
          mt.open("GET", Ye, !0), mt.responseType = "arraybuffer", mt.onload = () => {
            if (mt.status == 200 || mt.status == 0 && mt.response) {
              qe(mt.response);
              return;
            }
            Nt();
          }, mt.onerror = Nt, mt.send(null);
        };
        var L = l.print || console.log.bind(console), F = l.printErr || console.warn.bind(console);
        Object.assign(l, E), E = null, l.arguments && l.arguments, l.thisProgram && (d = l.thisProgram), l.quit && l.quit;
        var W;
        l.wasmBinary && (W = l.wasmBinary), l.noExitRuntime, typeof WebAssembly != "object" && Et("no native wasm support detected");
        var G, q = !1;
        function fe(Ye, qe) {
          Ye || Et(qe);
        }
        var _e = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
        function Le(Ye, qe, Nt) {
          qe >>>= 0;
          for (var mt = qe + Nt, pn = qe; Ye[pn] && !(pn >= mt); )
            ++pn;
          if (pn - qe > 16 && Ye.buffer && _e)
            return _e.decode(Ye.subarray(qe, pn));
          for (var Mt = ""; qe < pn; ) {
            var Ln = Ye[qe++];
            if (!(Ln & 128)) {
              Mt += String.fromCharCode(Ln);
              continue;
            }
            var ot = Ye[qe++] & 63;
            if ((Ln & 224) == 192) {
              Mt += String.fromCharCode((Ln & 31) << 6 | ot);
              continue;
            }
            var Xt = Ye[qe++] & 63;
            if ((Ln & 240) == 224 ? Ln = (Ln & 15) << 12 | ot << 6 | Xt : Ln = (Ln & 7) << 18 | ot << 12 | Xt << 6 | Ye[qe++] & 63, Ln < 65536)
              Mt += String.fromCharCode(Ln);
            else {
              var sn = Ln - 65536;
              Mt += String.fromCharCode(55296 | sn >> 10, 56320 | sn & 1023);
            }
          }
          return Mt;
        }
        function Fe(Ye, qe) {
          return Ye >>>= 0, Ye ? Le(ae, Ye, qe) : "";
        }
        function Ee(Ye, qe, Nt, mt) {
          if (Nt >>>= 0, !(mt > 0))
            return 0;
          for (var pn = Nt, Mt = Nt + mt - 1, Ln = 0; Ln < Ye.length; ++Ln) {
            var ot = Ye.charCodeAt(Ln);
            if (ot >= 55296 && ot <= 57343) {
              var Xt = Ye.charCodeAt(++Ln);
              ot = 65536 + ((ot & 1023) << 10) | Xt & 1023;
            }
            if (ot <= 127) {
              if (Nt >= Mt)
                break;
              qe[Nt++ >>> 0] = ot;
            } else if (ot <= 2047) {
              if (Nt + 1 >= Mt)
                break;
              qe[Nt++ >>> 0] = 192 | ot >> 6, qe[Nt++ >>> 0] = 128 | ot & 63;
            } else if (ot <= 65535) {
              if (Nt + 2 >= Mt)
                break;
              qe[Nt++ >>> 0] = 224 | ot >> 12, qe[Nt++ >>> 0] = 128 | ot >> 6 & 63, qe[Nt++ >>> 0] = 128 | ot & 63;
            } else {
              if (Nt + 3 >= Mt)
                break;
              qe[Nt++ >>> 0] = 240 | ot >> 18, qe[Nt++ >>> 0] = 128 | ot >> 12 & 63, qe[Nt++ >>> 0] = 128 | ot >> 6 & 63, qe[Nt++ >>> 0] = 128 | ot & 63;
            }
          }
          return qe[Nt >>> 0] = 0, Nt - pn;
        }
        function Ge(Ye, qe, Nt) {
          return Ee(Ye, ae, qe, Nt);
        }
        function ve(Ye) {
          for (var qe = 0, Nt = 0; Nt < Ye.length; ++Nt) {
            var mt = Ye.charCodeAt(Nt);
            mt <= 127 ? qe++ : mt <= 2047 ? qe += 2 : mt >= 55296 && mt <= 57343 ? (qe += 4, ++Nt) : qe += 3;
          }
          return qe;
        }
        var te, ae, v, Te, De, be, ze, ke;
        function Be() {
          var Ye = G.buffer;
          l.HEAP8 = te = new Int8Array(Ye), l.HEAP16 = v = new Int16Array(Ye), l.HEAP32 = De = new Int32Array(Ye), l.HEAPU8 = ae = new Uint8Array(Ye), l.HEAPU16 = Te = new Uint16Array(Ye), l.HEAPU32 = be = new Uint32Array(Ye), l.HEAPF32 = ze = new Float32Array(Ye), l.HEAPF64 = ke = new Float64Array(Ye);
        }
        var Me, me = [], Se = [], xt = [];
        function Ht() {
          if (l.preRun)
            for (typeof l.preRun == "function" && (l.preRun = [l.preRun]); l.preRun.length; )
              Tt(l.preRun.shift());
          Wt(me);
        }
        function Bt() {
          !l.noFSInit && !rn.init.initialized && rn.init(), rn.ignorePermissions = !1, Wt(Se);
        }
        function ut() {
          if (l.postRun)
            for (typeof l.postRun == "function" && (l.postRun = [l.postRun]); l.postRun.length; )
              an(l.postRun.shift());
          Wt(xt);
        }
        function Tt(Ye) {
          me.unshift(Ye);
        }
        function Yt(Ye) {
          Se.unshift(Ye);
        }
        function an(Ye) {
          xt.unshift(Ye);
        }
        var Ct = 0, st = null;
        function jt(Ye) {
          return Ye;
        }
        function lt(Ye) {
          Ct++, l.monitorRunDependencies && l.monitorRunDependencies(Ct);
        }
        function Zt(Ye) {
          if (Ct--, l.monitorRunDependencies && l.monitorRunDependencies(Ct), Ct == 0 && st) {
            var qe = st;
            st = null, qe();
          }
        }
        function Et(Ye) {
          l.onAbort && l.onAbort(Ye), Ye = "Aborted(" + Ye + ")", F(Ye), q = !0, Ye += ". Build with -sASSERTIONS for more info.";
          var qe = new WebAssembly.RuntimeError(Ye);
          throw c(qe), qe;
        }
        var Ke = "data:application/octet-stream;base64,";
        function $e(Ye) {
          return Ye.startsWith(Ke);
        }
        var pt;
        pt = "web-ifc.wasm", $e(pt) || (pt = S(pt));
        function Jt(Ye) {
          try {
            if (Ye == pt && W)
              return new Uint8Array(W);
            throw "both async and sync fetching of the wasm failed";
          } catch (qe) {
            Et(qe);
          }
        }
        function In() {
          return !W && f && typeof fetch == "function" ? fetch(pt, { credentials: "same-origin" }).then(function(Ye) {
            if (!Ye.ok)
              throw "failed to load wasm binary file at '" + pt + "'";
            return Ye.arrayBuffer();
          }).catch(function() {
            return Jt(pt);
          }) : Promise.resolve().then(function() {
            return Jt(pt);
          });
        }
        function Cn() {
          var Ye = { a: Ks };
          function qe(Ln, ot) {
            var Xt = Ln.exports;
            l.asm = Xt, G = l.asm.V, Be(), Me = l.asm.X, Yt(l.asm.W), Zt();
          }
          lt();
          function Nt(Ln) {
            qe(Ln.instance);
          }
          function mt(Ln) {
            return In().then(function(ot) {
              return WebAssembly.instantiate(ot, Ye);
            }).then(function(ot) {
              return ot;
            }).then(Ln, function(ot) {
              F("failed to asynchronously prepare wasm: " + ot), Et(ot);
            });
          }
          function pn() {
            return !W && typeof WebAssembly.instantiateStreaming == "function" && !$e(pt) && typeof fetch == "function" ? fetch(pt, { credentials: "same-origin" }).then(function(Ln) {
              var ot = WebAssembly.instantiateStreaming(Ln, Ye);
              return ot.then(Nt, function(Xt) {
                return F("wasm streaming compile failed: " + Xt), F("falling back to ArrayBuffer instantiation"), mt(Nt);
              });
            }) : mt(Nt);
          }
          if (l.instantiateWasm)
            try {
              var Mt = l.instantiateWasm(Ye, qe);
              return Mt;
            } catch (Ln) {
              F("Module.instantiateWasm callback failed with error: " + Ln), c(Ln);
            }
          return pn().catch(c), {};
        }
        var It, ht;
        function Wt(Ye) {
          for (; Ye.length > 0; )
            Ye.shift()(l);
        }
        function hn(Ye) {
          this.excPtr = Ye, this.ptr = Ye - 24, this.set_type = function(qe) {
            be[this.ptr + 4 >>> 2] = qe;
          }, this.get_type = function() {
            return be[this.ptr + 4 >>> 2];
          }, this.set_destructor = function(qe) {
            be[this.ptr + 8 >>> 2] = qe;
          }, this.get_destructor = function() {
            return be[this.ptr + 8 >>> 2];
          }, this.set_refcount = function(qe) {
            De[this.ptr >>> 2] = qe;
          }, this.set_caught = function(qe) {
            qe = qe ? 1 : 0, te[this.ptr + 12 >>> 0] = qe;
          }, this.get_caught = function() {
            return te[this.ptr + 12 >>> 0] != 0;
          }, this.set_rethrown = function(qe) {
            qe = qe ? 1 : 0, te[this.ptr + 13 >>> 0] = qe;
          }, this.get_rethrown = function() {
            return te[this.ptr + 13 >>> 0] != 0;
          }, this.init = function(qe, Nt) {
            this.set_adjusted_ptr(0), this.set_type(qe), this.set_destructor(Nt), this.set_refcount(0), this.set_caught(!1), this.set_rethrown(!1);
          }, this.add_ref = function() {
            var qe = De[this.ptr >>> 2];
            De[this.ptr >>> 2] = qe + 1;
          }, this.release_ref = function() {
            var qe = De[this.ptr >>> 2];
            return De[this.ptr >>> 2] = qe - 1, qe === 1;
          }, this.set_adjusted_ptr = function(qe) {
            be[this.ptr + 16 >>> 2] = qe;
          }, this.get_adjusted_ptr = function() {
            return be[this.ptr + 16 >>> 2];
          }, this.get_exception_ptr = function() {
            var qe = Fi(this.get_type());
            if (qe)
              return be[this.excPtr >>> 2];
            var Nt = this.get_adjusted_ptr();
            return Nt !== 0 ? Nt : this.excPtr;
          };
        }
        function Vt(Ye, qe, Nt) {
          var mt = new hn(Ye);
          throw mt.init(qe, Nt), Ye;
        }
        var Tn = {};
        function Rn(Ye) {
          for (; Ye.length; ) {
            var qe = Ye.pop(), Nt = Ye.pop();
            Nt(qe);
          }
        }
        function Nn(Ye) {
          return this.fromWireType(De[Ye >>> 2]);
        }
        var Dn = {}, xn = {}, $n = {}, Kn = 48, ir = 57;
        function er(Ye) {
          if (Ye === void 0)
            return "_unknown";
          Ye = Ye.replace(/[^a-zA-Z0-9_]/g, "$");
          var qe = Ye.charCodeAt(0);
          return qe >= Kn && qe <= ir ? "_" + Ye : Ye;
        }
        function br(Ye, qe) {
          return Ye = er(Ye), new Function("body", "return function " + Ye + `() {
    "use strict";    return body.apply(this, arguments);
};
`)(qe);
        }
        function cs(Ye, qe) {
          var Nt = br(qe, function(mt) {
            this.name = qe, this.message = mt;
            var pn = new Error(mt).stack;
            pn !== void 0 && (this.stack = this.toString() + `
` + pn.replace(/^Error(:[^\n]*)?\n/, ""));
          });
          return Nt.prototype = Object.create(Ye.prototype), Nt.prototype.constructor = Nt, Nt.prototype.toString = function() {
            return this.message === void 0 ? this.name : this.name + ": " + this.message;
          }, Nt;
        }
        var Gn = void 0;
        function Jn(Ye) {
          throw new Gn(Ye);
        }
        function Xn(Ye, qe, Nt) {
          Ye.forEach(function(ot) {
            $n[ot] = qe;
          });
          function mt(ot) {
            var Xt = Nt(ot);
            Xt.length !== Ye.length && Jn("Mismatched type converter count");
            for (var sn = 0; sn < Ye.length; ++sn)
              Hr(Ye[sn], Xt[sn]);
          }
          var pn = new Array(qe.length), Mt = [], Ln = 0;
          qe.forEach((ot, Xt) => {
            xn.hasOwnProperty(ot) ? pn[Xt] = xn[ot] : (Mt.push(ot), Dn.hasOwnProperty(ot) || (Dn[ot] = []), Dn[ot].push(() => {
              pn[Xt] = xn[ot], ++Ln, Ln === Mt.length && mt(pn);
            }));
          }), Mt.length === 0 && mt(pn);
        }
        function rr(Ye) {
          var qe = Tn[Ye];
          delete Tn[Ye];
          var Nt = qe.elements, mt = Nt.length, pn = Nt.map(function(ot) {
            return ot.getterReturnType;
          }).concat(Nt.map(function(ot) {
            return ot.setterArgumentType;
          })), Mt = qe.rawConstructor, Ln = qe.rawDestructor;
          Xn([Ye], pn, function(ot) {
            return Nt.forEach((Xt, sn) => {
              var dn = ot[sn], Ar = Xt.getter, yr = Xt.getterContext, Pr = ot[sn + mt], Zr = Xt.setter, qs = Xt.setterContext;
              Xt.read = (Ws) => dn.fromWireType(Ar(yr, Ws)), Xt.write = (Ws, Bs) => {
                var Sr = [];
                Zr(qs, Ws, Pr.toWireType(Sr, Bs)), Rn(Sr);
              };
            }), [{ name: qe.name, fromWireType: function(Xt) {
              for (var sn = new Array(mt), dn = 0; dn < mt; ++dn)
                sn[dn] = Nt[dn].read(Xt);
              return Ln(Xt), sn;
            }, toWireType: function(Xt, sn) {
              if (mt !== sn.length)
                throw new TypeError("Incorrect number of tuple elements for " + qe.name + ": expected=" + mt + ", actual=" + sn.length);
              for (var dn = Mt(), Ar = 0; Ar < mt; ++Ar)
                Nt[Ar].write(dn, sn[Ar]);
              return Xt !== null && Xt.push(Ln, dn), dn;
            }, argPackAdvance: 8, readValueFromPointer: Nn, destructorFunction: Ln }];
          });
        }
        var _r = {};
        function Ss(Ye) {
          var qe = _r[Ye];
          delete _r[Ye];
          var Nt = qe.rawConstructor, mt = qe.rawDestructor, pn = qe.fields, Mt = pn.map((Ln) => Ln.getterReturnType).concat(pn.map((Ln) => Ln.setterArgumentType));
          Xn([Ye], Mt, (Ln) => {
            var ot = {};
            return pn.forEach((Xt, sn) => {
              var dn = Xt.fieldName, Ar = Ln[sn], yr = Xt.getter, Pr = Xt.getterContext, Zr = Ln[sn + pn.length], qs = Xt.setter, Ws = Xt.setterContext;
              ot[dn] = { read: (Bs) => Ar.fromWireType(yr(Pr, Bs)), write: (Bs, Sr) => {
                var Wr = [];
                qs(Ws, Bs, Zr.toWireType(Wr, Sr)), Rn(Wr);
              } };
            }), [{ name: qe.name, fromWireType: function(Xt) {
              var sn = {};
              for (var dn in ot)
                sn[dn] = ot[dn].read(Xt);
              return mt(Xt), sn;
            }, toWireType: function(Xt, sn) {
              for (var dn in ot)
                if (!(dn in sn))
                  throw new TypeError('Missing field:  "' + dn + '"');
              var Ar = Nt();
              for (dn in ot)
                ot[dn].write(Ar, sn[dn]);
              return Xt !== null && Xt.push(mt, Ar), Ar;
            }, argPackAdvance: 8, readValueFromPointer: Nn, destructorFunction: mt }];
          });
        }
        function is(Ye, qe, Nt, mt, pn) {
        }
        function Ms(Ye) {
          switch (Ye) {
            case 1:
              return 0;
            case 2:
              return 1;
            case 4:
              return 2;
            case 8:
              return 3;
            default:
              throw new TypeError("Unknown type size: " + Ye);
          }
        }
        function ls() {
          for (var Ye = new Array(256), qe = 0; qe < 256; ++qe)
            Ye[qe] = String.fromCharCode(qe);
          Ur = Ye;
        }
        var Ur = void 0;
        function Qr(Ye) {
          for (var qe = "", Nt = Ye; ae[Nt >>> 0]; )
            qe += Ur[ae[Nt++ >>> 0]];
          return qe;
        }
        var Fr = void 0;
        function Lr(Ye) {
          throw new Fr(Ye);
        }
        function Hr(Ye, qe, Nt = {}) {
          if (!("argPackAdvance" in qe))
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          var mt = qe.name;
          if (Ye || Lr('type "' + mt + '" must have a positive integer typeid pointer'), xn.hasOwnProperty(Ye)) {
            if (Nt.ignoreDuplicateRegistrations)
              return;
            Lr("Cannot register type '" + mt + "' twice");
          }
          if (xn[Ye] = qe, delete $n[Ye], Dn.hasOwnProperty(Ye)) {
            var pn = Dn[Ye];
            delete Dn[Ye], pn.forEach((Mt) => Mt());
          }
        }
        function ns(Ye, qe, Nt, mt, pn) {
          var Mt = Ms(Nt);
          qe = Qr(qe), Hr(Ye, { name: qe, fromWireType: function(Ln) {
            return !!Ln;
          }, toWireType: function(Ln, ot) {
            return ot ? mt : pn;
          }, argPackAdvance: 8, readValueFromPointer: function(Ln) {
            var ot;
            if (Nt === 1)
              ot = te;
            else if (Nt === 2)
              ot = v;
            else if (Nt === 4)
              ot = De;
            else
              throw new TypeError("Unknown boolean type size: " + qe);
            return this.fromWireType(ot[Ln >>> Mt]);
          }, destructorFunction: null });
        }
        function Ts(Ye) {
          if (!(this instanceof Oo) || !(Ye instanceof Oo))
            return !1;
          for (var qe = this.$$.ptrType.registeredClass, Nt = this.$$.ptr, mt = Ye.$$.ptrType.registeredClass, pn = Ye.$$.ptr; qe.baseClass; )
            Nt = qe.upcast(Nt), qe = qe.baseClass;
          for (; mt.baseClass; )
            pn = mt.upcast(pn), mt = mt.baseClass;
          return qe === mt && Nt === pn;
        }
        function en(Ye) {
          return { count: Ye.count, deleteScheduled: Ye.deleteScheduled, preservePointerOnDelete: Ye.preservePointerOnDelete, ptr: Ye.ptr, ptrType: Ye.ptrType, smartPtr: Ye.smartPtr, smartPtrType: Ye.smartPtrType };
        }
        function to(Ye) {
          function qe(Nt) {
            return Nt.$$.ptrType.registeredClass.name;
          }
          Lr(qe(Ye) + " instance already deleted");
        }
        var bs = !1;
        function jn(Ye) {
        }
        function lr(Ye) {
          Ye.smartPtr ? Ye.smartPtrType.rawDestructor(Ye.smartPtr) : Ye.ptrType.registeredClass.rawDestructor(Ye.ptr);
        }
        function pr(Ye) {
          Ye.count.value -= 1;
          var qe = Ye.count.value === 0;
          qe && lr(Ye);
        }
        function En(Ye, qe, Nt) {
          if (qe === Nt)
            return Ye;
          if (Nt.baseClass === void 0)
            return null;
          var mt = En(Ye, qe, Nt.baseClass);
          return mt === null ? null : Nt.downcast(mt);
        }
        var qn = {};
        function Wn() {
          return Object.keys(Es).length;
        }
        function kn() {
          var Ye = [];
          for (var qe in Es)
            Es.hasOwnProperty(qe) && Ye.push(Es[qe]);
          return Ye;
        }
        var zn = [];
        function wr() {
          for (; zn.length; ) {
            var Ye = zn.pop();
            Ye.$$.deleteScheduled = !1, Ye.delete();
          }
        }
        var jr = void 0;
        function Vr(Ye) {
          jr = Ye, zn.length && jr && jr(wr);
        }
        function us() {
          l.getInheritedInstanceCount = Wn, l.getLiveInheritedInstances = kn, l.flushPendingDeletes = wr, l.setDelayFunction = Vr;
        }
        var Es = {};
        function Dr(Ye, qe) {
          for (qe === void 0 && Lr("ptr should not be undefined"); Ye.baseClass; )
            qe = Ye.upcast(qe), Ye = Ye.baseClass;
          return qe;
        }
        function Kr(Ye, qe) {
          return qe = Dr(Ye, qe), Es[qe];
        }
        function Js(Ye, qe) {
          (!qe.ptrType || !qe.ptr) && Jn("makeClassHandle requires ptr and ptrType");
          var Nt = !!qe.smartPtrType, mt = !!qe.smartPtr;
          return Nt !== mt && Jn("Both smartPtrType and smartPtr must be specified"), qe.count = { value: 1 }, No(Object.create(Ye, { $$: { value: qe } }));
        }
        function io(Ye) {
          var qe = this.getPointee(Ye);
          if (!qe)
            return this.destructor(Ye), null;
          var Nt = Kr(this.registeredClass, qe);
          if (Nt !== void 0) {
            if (Nt.$$.count.value === 0)
              return Nt.$$.ptr = qe, Nt.$$.smartPtr = Ye, Nt.clone();
            var mt = Nt.clone();
            return this.destructor(Ye), mt;
          }
          function pn() {
            return this.isSmartPointer ? Js(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: qe, smartPtrType: this, smartPtr: Ye }) : Js(this.registeredClass.instancePrototype, { ptrType: this, ptr: Ye });
          }
          var Mt = this.registeredClass.getActualType(qe), Ln = qn[Mt];
          if (!Ln)
            return pn.call(this);
          var ot;
          this.isConst ? ot = Ln.constPointerType : ot = Ln.pointerType;
          var Xt = En(qe, this.registeredClass, ot.registeredClass);
          return Xt === null ? pn.call(this) : this.isSmartPointer ? Js(ot.registeredClass.instancePrototype, { ptrType: ot, ptr: Xt, smartPtrType: this, smartPtr: Ye }) : Js(ot.registeredClass.instancePrototype, { ptrType: ot, ptr: Xt });
        }
        function No(Ye) {
          return typeof FinalizationRegistry > "u" ? (No = (qe) => qe, Ye) : (bs = new FinalizationRegistry((qe) => {
            pr(qe.$$);
          }), No = (qe) => {
            var Nt = qe.$$, mt = !!Nt.smartPtr;
            if (mt) {
              var pn = { $$: Nt };
              bs.register(qe, pn, qe);
            }
            return qe;
          }, jn = (qe) => bs.unregister(qe), No(Ye));
        }
        function Ai() {
          if (this.$$.ptr || to(this), this.$$.preservePointerOnDelete)
            return this.$$.count.value += 1, this;
          var Ye = No(Object.create(Object.getPrototypeOf(this), { $$: { value: en(this.$$) } }));
          return Ye.$$.count.value += 1, Ye.$$.deleteScheduled = !1, Ye;
        }
        function go() {
          this.$$.ptr || to(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Lr("Object already scheduled for deletion"), jn(this), pr(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        }
        function ks() {
          return !this.$$.ptr;
        }
        function Ci() {
          return this.$$.ptr || to(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Lr("Object already scheduled for deletion"), zn.push(this), zn.length === 1 && jr && jr(wr), this.$$.deleteScheduled = !0, this;
        }
        function Io() {
          Oo.prototype.isAliasOf = Ts, Oo.prototype.clone = Ai, Oo.prototype.delete = go, Oo.prototype.isDeleted = ks, Oo.prototype.deleteLater = Ci;
        }
        function Oo() {
        }
        function Zs(Ye, qe, Nt) {
          if (Ye[qe].overloadTable === void 0) {
            var mt = Ye[qe];
            Ye[qe] = function() {
              return Ye[qe].overloadTable.hasOwnProperty(arguments.length) || Lr("Function '" + Nt + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + Ye[qe].overloadTable + ")!"), Ye[qe].overloadTable[arguments.length].apply(this, arguments);
            }, Ye[qe].overloadTable = [], Ye[qe].overloadTable[mt.argCount] = mt;
          }
        }
        function wt(Ye, qe, Nt) {
          l.hasOwnProperty(Ye) ? ((Nt === void 0 || l[Ye].overloadTable !== void 0 && l[Ye].overloadTable[Nt] !== void 0) && Lr("Cannot register public name '" + Ye + "' twice"), Zs(l, Ye, Ye), l.hasOwnProperty(Nt) && Lr("Cannot register multiple overloads of a function with the same number of arguments (" + Nt + ")!"), l[Ye].overloadTable[Nt] = qe) : (l[Ye] = qe, Nt !== void 0 && (l[Ye].numArguments = Nt));
        }
        function _t(Ye, qe, Nt, mt, pn, Mt, Ln, ot) {
          this.name = Ye, this.constructor = qe, this.instancePrototype = Nt, this.rawDestructor = mt, this.baseClass = pn, this.getActualType = Mt, this.upcast = Ln, this.downcast = ot, this.pureVirtualFunctions = [];
        }
        function Ve(Ye, qe, Nt) {
          for (; qe !== Nt; )
            qe.upcast || Lr("Expected null or instance of " + Nt.name + ", got an instance of " + qe.name), Ye = qe.upcast(Ye), qe = qe.baseClass;
          return Ye;
        }
        function Ze(Ye, qe) {
          if (qe === null)
            return this.isReference && Lr("null is not a valid " + this.name), 0;
          qe.$$ || Lr('Cannot pass "' + Uo(qe) + '" as a ' + this.name), qe.$$.ptr || Lr("Cannot pass deleted object as a pointer of type " + this.name);
          var Nt = qe.$$.ptrType.registeredClass, mt = Ve(qe.$$.ptr, Nt, this.registeredClass);
          return mt;
        }
        function bt(Ye, qe) {
          var Nt;
          if (qe === null)
            return this.isReference && Lr("null is not a valid " + this.name), this.isSmartPointer ? (Nt = this.rawConstructor(), Ye !== null && Ye.push(this.rawDestructor, Nt), Nt) : 0;
          qe.$$ || Lr('Cannot pass "' + Uo(qe) + '" as a ' + this.name), qe.$$.ptr || Lr("Cannot pass deleted object as a pointer of type " + this.name), !this.isConst && qe.$$.ptrType.isConst && Lr("Cannot convert argument of type " + (qe.$$.smartPtrType ? qe.$$.smartPtrType.name : qe.$$.ptrType.name) + " to parameter type " + this.name);
          var mt = qe.$$.ptrType.registeredClass;
          if (Nt = Ve(qe.$$.ptr, mt, this.registeredClass), this.isSmartPointer)
            switch (qe.$$.smartPtr === void 0 && Lr("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
              case 0:
                qe.$$.smartPtrType === this ? Nt = qe.$$.smartPtr : Lr("Cannot convert argument of type " + (qe.$$.smartPtrType ? qe.$$.smartPtrType.name : qe.$$.ptrType.name) + " to parameter type " + this.name);
                break;
              case 1:
                Nt = qe.$$.smartPtr;
                break;
              case 2:
                if (qe.$$.smartPtrType === this)
                  Nt = qe.$$.smartPtr;
                else {
                  var pn = qe.clone();
                  Nt = this.rawShare(Nt, Mr.toHandle(function() {
                    pn.delete();
                  })), Ye !== null && Ye.push(this.rawDestructor, Nt);
                }
                break;
              default:
                Lr("Unsupporting sharing policy");
            }
          return Nt;
        }
        function Ut(Ye, qe) {
          if (qe === null)
            return this.isReference && Lr("null is not a valid " + this.name), 0;
          qe.$$ || Lr('Cannot pass "' + Uo(qe) + '" as a ' + this.name), qe.$$.ptr || Lr("Cannot pass deleted object as a pointer of type " + this.name), qe.$$.ptrType.isConst && Lr("Cannot convert argument of type " + qe.$$.ptrType.name + " to parameter type " + this.name);
          var Nt = qe.$$.ptrType.registeredClass, mt = Ve(qe.$$.ptr, Nt, this.registeredClass);
          return mt;
        }
        function mn(Ye) {
          return this.rawGetPointee && (Ye = this.rawGetPointee(Ye)), Ye;
        }
        function nn(Ye) {
          this.rawDestructor && this.rawDestructor(Ye);
        }
        function Sn(Ye) {
          Ye !== null && Ye.delete();
        }
        function Mn() {
          yn.prototype.getPointee = mn, yn.prototype.destructor = nn, yn.prototype.argPackAdvance = 8, yn.prototype.readValueFromPointer = Nn, yn.prototype.deleteObject = Sn, yn.prototype.fromWireType = io;
        }
        function yn(Ye, qe, Nt, mt, pn, Mt, Ln, ot, Xt, sn, dn) {
          this.name = Ye, this.registeredClass = qe, this.isReference = Nt, this.isConst = mt, this.isSmartPointer = pn, this.pointeeType = Mt, this.sharingPolicy = Ln, this.rawGetPointee = ot, this.rawConstructor = Xt, this.rawShare = sn, this.rawDestructor = dn, !pn && qe.baseClass === void 0 ? mt ? (this.toWireType = Ze, this.destructorFunction = null) : (this.toWireType = Ut, this.destructorFunction = null) : this.toWireType = bt;
        }
        function Pt(Ye, qe, Nt) {
          l.hasOwnProperty(Ye) || Jn("Replacing nonexistant public symbol"), l[Ye].overloadTable !== void 0 && Nt !== void 0 ? l[Ye].overloadTable[Nt] = qe : (l[Ye] = qe, l[Ye].argCount = Nt);
        }
        function tr(Ye, qe, Nt) {
          var mt = l["dynCall_" + Ye];
          return Nt && Nt.length ? mt.apply(null, [qe].concat(Nt)) : mt.call(null, qe);
        }
        var Lt = [];
        function dr(Ye) {
          var qe = Lt[Ye];
          return qe || (Ye >= Lt.length && (Lt.length = Ye + 1), Lt[Ye] = qe = Me.get(Ye)), qe;
        }
        function ur(Ye, qe, Nt) {
          if (Ye.includes("j"))
            return tr(Ye, qe, Nt);
          var mt = dr(qe).apply(null, Nt);
          return mt;
        }
        function gr(Ye, qe) {
          var Nt = [];
          return function() {
            return Nt.length = 0, Object.assign(Nt, arguments), ur(Ye, qe, Nt);
          };
        }
        function Rr(Ye, qe) {
          Ye = Qr(Ye);
          function Nt() {
            return Ye.includes("j") ? gr(Ye, qe) : dr(qe);
          }
          var mt = Nt();
          return typeof mt != "function" && Lr("unknown function pointer with signature " + Ye + ": " + qe), mt;
        }
        var as = void 0;
        function hs(Ye) {
          var qe = pi(Ye), Nt = Qr(qe);
          return Ns(qe), Nt;
        }
        function Os(Ye, qe) {
          var Nt = [], mt = {};
          function pn(Mt) {
            if (!mt[Mt] && !xn[Mt]) {
              if ($n[Mt]) {
                $n[Mt].forEach(pn);
                return;
              }
              Nt.push(Mt), mt[Mt] = !0;
            }
          }
          throw qe.forEach(pn), new as(Ye + ": " + Nt.map(hs).join([", "]));
        }
        function jo(Ye, qe, Nt, mt, pn, Mt, Ln, ot, Xt, sn, dn, Ar, yr) {
          dn = Qr(dn), Mt = Rr(pn, Mt), ot && (ot = Rr(Ln, ot)), sn && (sn = Rr(Xt, sn)), yr = Rr(Ar, yr);
          var Pr = er(dn);
          wt(Pr, function() {
            Os("Cannot construct " + dn + " due to unbound types", [mt]);
          }), Xn([Ye, qe, Nt], mt ? [mt] : [], function(Zr) {
            Zr = Zr[0];
            var qs, Ws;
            mt ? (qs = Zr.registeredClass, Ws = qs.instancePrototype) : Ws = Oo.prototype;
            var Bs = br(Pr, function() {
              if (Object.getPrototypeOf(this) !== Sr)
                throw new Fr("Use 'new' to construct " + dn);
              if (Wr.constructor_body === void 0)
                throw new Fr(dn + " has no accessible constructor");
              var Gs = Wr.constructor_body[arguments.length];
              if (Gs === void 0)
                throw new Fr("Tried to invoke ctor of " + dn + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(Wr.constructor_body).toString() + ") parameters instead!");
              return Gs.apply(this, arguments);
            }), Sr = Object.create(Ws, { constructor: { value: Bs } });
            Bs.prototype = Sr;
            var Wr = new _t(dn, Bs, Sr, yr, qs, Mt, ot, sn), lo = new yn(dn, Wr, !0, !1, !1), uo = new yn(dn + "*", Wr, !1, !1, !1), Vs = new yn(dn + " const*", Wr, !1, !0, !1);
            return qn[Ye] = { pointerType: uo, constPointerType: Vs }, Pt(Pr, Bs), [lo, uo, Vs];
          });
        }
        function po(Ye, qe) {
          for (var Nt = [], mt = 0; mt < Ye; mt++)
            Nt.push(be[qe + mt * 4 >>> 2]);
          return Nt;
        }
        function So(Ye, qe) {
          if (!(Ye instanceof Function))
            throw new TypeError("new_ called with constructor type " + typeof Ye + " which is not a function");
          var Nt = br(Ye.name || "unknownFunctionName", function() {
          });
          Nt.prototype = Ye.prototype;
          var mt = new Nt(), pn = Ye.apply(mt, qe);
          return pn instanceof Object ? pn : mt;
        }
        function Eo(Ye, qe, Nt, mt, pn) {
          var Mt = qe.length;
          Mt < 2 && Lr("argTypes array size mismatch! Must at least get return value and 'this' types!");
          for (var Ln = qe[1] !== null && Nt !== null, ot = !1, Xt = 1; Xt < qe.length; ++Xt)
            if (qe[Xt] !== null && qe[Xt].destructorFunction === void 0) {
              ot = !0;
              break;
            }
          for (var sn = qe[0].name !== "void", dn = "", Ar = "", Xt = 0; Xt < Mt - 2; ++Xt)
            dn += (Xt !== 0 ? ", " : "") + "arg" + Xt, Ar += (Xt !== 0 ? ", " : "") + "arg" + Xt + "Wired";
          var yr = "return function " + er(Ye) + "(" + dn + `) {
if (arguments.length !== ` + (Mt - 2) + `) {
throwBindingError('function ` + Ye + " called with ' + arguments.length + ' arguments, expected " + (Mt - 2) + ` args!');
}
`;
          ot && (yr += `var destructors = [];
`);
          var Pr = ot ? "destructors" : "null", Zr = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], qs = [Lr, mt, pn, Rn, qe[0], qe[1]];
          Ln && (yr += "var thisWired = classParam.toWireType(" + Pr + `, this);
`);
          for (var Xt = 0; Xt < Mt - 2; ++Xt)
            yr += "var arg" + Xt + "Wired = argType" + Xt + ".toWireType(" + Pr + ", arg" + Xt + "); // " + qe[Xt + 2].name + `
`, Zr.push("argType" + Xt), qs.push(qe[Xt + 2]);
          if (Ln && (Ar = "thisWired" + (Ar.length > 0 ? ", " : "") + Ar), yr += (sn ? "var rv = " : "") + "invoker(fn" + (Ar.length > 0 ? ", " : "") + Ar + `);
`, ot)
            yr += `runDestructors(destructors);
`;
          else
            for (var Xt = Ln ? 1 : 2; Xt < qe.length; ++Xt) {
              var Ws = Xt === 1 ? "thisWired" : "arg" + (Xt - 2) + "Wired";
              qe[Xt].destructorFunction !== null && (yr += Ws + "_dtor(" + Ws + "); // " + qe[Xt].name + `
`, Zr.push(Ws + "_dtor"), qs.push(qe[Xt].destructorFunction));
            }
          sn && (yr += `var ret = retType.fromWireType(rv);
return ret;
`), yr += `}
`, Zr.push(yr);
          var Bs = So(Function, Zr).apply(null, qs);
          return Bs;
        }
        function Ps(Ye, qe, Nt, mt, pn, Mt) {
          fe(qe > 0);
          var Ln = po(qe, Nt);
          pn = Rr(mt, pn), Xn([], [Ye], function(ot) {
            ot = ot[0];
            var Xt = "constructor " + ot.name;
            if (ot.registeredClass.constructor_body === void 0 && (ot.registeredClass.constructor_body = []), ot.registeredClass.constructor_body[qe - 1] !== void 0)
              throw new Fr("Cannot register multiple constructors with identical number of parameters (" + (qe - 1) + ") for class '" + ot.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            return ot.registeredClass.constructor_body[qe - 1] = () => {
              Os("Cannot construct " + ot.name + " due to unbound types", Ln);
            }, Xn([], Ln, function(sn) {
              return sn.splice(1, 0, null), ot.registeredClass.constructor_body[qe - 1] = Eo(Xt, sn, null, pn, Mt), [];
            }), [];
          });
        }
        function no(Ye, qe, Nt, mt, pn, Mt, Ln, ot) {
          var Xt = po(Nt, mt);
          qe = Qr(qe), Mt = Rr(pn, Mt), Xn([], [Ye], function(sn) {
            sn = sn[0];
            var dn = sn.name + "." + qe;
            qe.startsWith("@@") && (qe = Symbol[qe.substring(2)]), ot && sn.registeredClass.pureVirtualFunctions.push(qe);
            function Ar() {
              Os("Cannot call " + dn + " due to unbound types", Xt);
            }
            var yr = sn.registeredClass.instancePrototype, Pr = yr[qe];
            return Pr === void 0 || Pr.overloadTable === void 0 && Pr.className !== sn.name && Pr.argCount === Nt - 2 ? (Ar.argCount = Nt - 2, Ar.className = sn.name, yr[qe] = Ar) : (Zs(yr, qe, dn), yr[qe].overloadTable[Nt - 2] = Ar), Xn([], Xt, function(Zr) {
              var qs = Eo(dn, Zr, sn, Mt, Ln);
              return yr[qe].overloadTable === void 0 ? (qs.argCount = Nt - 2, yr[qe] = qs) : yr[qe].overloadTable[Nt - 2] = qs, [];
            }), [];
          });
        }
        var gs = [], fo = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }];
        function xs(Ye) {
          Ye > 4 && --fo[Ye].refcount === 0 && (fo[Ye] = void 0, gs.push(Ye));
        }
        function Ir() {
          for (var Ye = 0, qe = 5; qe < fo.length; ++qe)
            fo[qe] !== void 0 && ++Ye;
          return Ye;
        }
        function ws() {
          for (var Ye = 5; Ye < fo.length; ++Ye)
            if (fo[Ye] !== void 0)
              return fo[Ye];
          return null;
        }
        function fr() {
          l.count_emval_handles = Ir, l.get_first_emval = ws;
        }
        var Mr = { toValue: (Ye) => (Ye || Lr("Cannot use deleted val. handle = " + Ye), fo[Ye].value), toHandle: (Ye) => {
          switch (Ye) {
            case void 0:
              return 1;
            case null:
              return 2;
            case !0:
              return 3;
            case !1:
              return 4;
            default: {
              var qe = gs.length ? gs.pop() : fo.length;
              return fo[qe] = { refcount: 1, value: Ye }, qe;
            }
          }
        } };
        function Nr(Ye, qe) {
          qe = Qr(qe), Hr(Ye, { name: qe, fromWireType: function(Nt) {
            var mt = Mr.toValue(Nt);
            return xs(Nt), mt;
          }, toWireType: function(Nt, mt) {
            return Mr.toHandle(mt);
          }, argPackAdvance: 8, readValueFromPointer: Nn, destructorFunction: null });
        }
        function ii(Ye, qe, Nt) {
          switch (qe) {
            case 0:
              return function(mt) {
                var pn = Nt ? te : ae;
                return this.fromWireType(pn[mt >>> 0]);
              };
            case 1:
              return function(mt) {
                var pn = Nt ? v : Te;
                return this.fromWireType(pn[mt >>> 1]);
              };
            case 2:
              return function(mt) {
                var pn = Nt ? De : be;
                return this.fromWireType(pn[mt >>> 2]);
              };
            default:
              throw new TypeError("Unknown integer type: " + Ye);
          }
        }
        function Ro(Ye, qe, Nt, mt) {
          var pn = Ms(Nt);
          qe = Qr(qe);
          function Mt() {
          }
          Mt.values = {}, Hr(Ye, { name: qe, constructor: Mt, fromWireType: function(Ln) {
            return this.constructor.values[Ln];
          }, toWireType: function(Ln, ot) {
            return ot.value;
          }, argPackAdvance: 8, readValueFromPointer: ii(qe, pn, mt), destructorFunction: null }), wt(qe, Mt);
        }
        function Bo(Ye, qe) {
          var Nt = xn[Ye];
          return Nt === void 0 && Lr(qe + " has unknown type " + hs(Ye)), Nt;
        }
        function Rs(Ye, qe, Nt) {
          var mt = Bo(Ye, "enum");
          qe = Qr(qe);
          var pn = mt.constructor, Mt = Object.create(mt.constructor.prototype, { value: { value: Nt }, constructor: { value: br(mt.name + "_" + qe, function() {
          }) } });
          pn.values[Nt] = Mt, pn[qe] = Mt;
        }
        function Uo(Ye) {
          if (Ye === null)
            return "null";
          var qe = typeof Ye;
          return qe === "object" || qe === "array" || qe === "function" ? Ye.toString() : "" + Ye;
        }
        function xi(Ye, qe) {
          switch (qe) {
            case 2:
              return function(Nt) {
                return this.fromWireType(ze[Nt >>> 2]);
              };
            case 3:
              return function(Nt) {
                return this.fromWireType(ke[Nt >>> 3]);
              };
            default:
              throw new TypeError("Unknown float type: " + Ye);
          }
        }
        function Vo(Ye, qe, Nt) {
          var mt = Ms(Nt);
          qe = Qr(qe), Hr(Ye, { name: qe, fromWireType: function(pn) {
            return pn;
          }, toWireType: function(pn, Mt) {
            return Mt;
          }, argPackAdvance: 8, readValueFromPointer: xi(qe, mt), destructorFunction: null });
        }
        function oa(Ye, qe, Nt, mt, pn, Mt) {
          var Ln = po(qe, Nt);
          Ye = Qr(Ye), pn = Rr(mt, pn), wt(Ye, function() {
            Os("Cannot call " + Ye + " due to unbound types", Ln);
          }, qe - 1), Xn([], Ln, function(ot) {
            var Xt = [ot[0], null].concat(ot.slice(1));
            return Pt(Ye, Eo(Ye, Xt, null, pn, Mt), qe - 1), [];
          });
        }
        function ti(Ye, qe, Nt) {
          switch (qe) {
            case 0:
              return Nt ? function(pn) {
                return te[pn >>> 0];
              } : function(pn) {
                return ae[pn >>> 0];
              };
            case 1:
              return Nt ? function(pn) {
                return v[pn >>> 1];
              } : function(pn) {
                return Te[pn >>> 1];
              };
            case 2:
              return Nt ? function(pn) {
                return De[pn >>> 2];
              } : function(pn) {
                return be[pn >>> 2];
              };
            default:
              throw new TypeError("Unknown integer type: " + Ye);
          }
        }
        function Po(Ye, qe, Nt, mt, pn) {
          qe = Qr(qe);
          var Mt = Ms(Nt), Ln = (Ar) => Ar;
          if (mt === 0) {
            var ot = 32 - 8 * Nt;
            Ln = (Ar) => Ar << ot >>> ot;
          }
          var Xt = qe.includes("unsigned"), sn = (Ar, yr) => {
          }, dn;
          Xt ? dn = function(Ar, yr) {
            return sn(yr, this.name), yr >>> 0;
          } : dn = function(Ar, yr) {
            return sn(yr, this.name), yr;
          }, Hr(Ye, { name: qe, fromWireType: Ln, toWireType: dn, argPackAdvance: 8, readValueFromPointer: ti(qe, Mt, mt !== 0), destructorFunction: null });
        }
        function ai(Ye, qe, Nt) {
          var mt = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], pn = mt[qe];
          function Mt(Ln) {
            Ln = Ln >> 2;
            var ot = be, Xt = ot[Ln >>> 0], sn = ot[Ln + 1 >>> 0];
            return new pn(ot.buffer, sn, Xt);
          }
          Nt = Qr(Nt), Hr(Ye, { name: Nt, fromWireType: Mt, argPackAdvance: 8, readValueFromPointer: Mt }, { ignoreDuplicateRegistrations: !0 });
        }
        function Wo(Ye, qe) {
          qe = Qr(qe);
          var Nt = qe === "std::string";
          Hr(Ye, { name: qe, fromWireType: function(mt) {
            var pn = be[mt >>> 2], Mt = mt + 4, Ln;
            if (Nt)
              for (var ot = Mt, Xt = 0; Xt <= pn; ++Xt) {
                var sn = Mt + Xt;
                if (Xt == pn || ae[sn >>> 0] == 0) {
                  var dn = sn - ot, Ar = Fe(ot, dn);
                  Ln === void 0 ? Ln = Ar : (Ln += String.fromCharCode(0), Ln += Ar), ot = sn + 1;
                }
              }
            else {
              for (var yr = new Array(pn), Xt = 0; Xt < pn; ++Xt)
                yr[Xt] = String.fromCharCode(ae[Mt + Xt >>> 0]);
              Ln = yr.join("");
            }
            return Ns(mt), Ln;
          }, toWireType: function(mt, pn) {
            pn instanceof ArrayBuffer && (pn = new Uint8Array(pn));
            var Mt, Ln = typeof pn == "string";
            Ln || pn instanceof Uint8Array || pn instanceof Uint8ClampedArray || pn instanceof Int8Array || Lr("Cannot pass non-string to std::string"), Nt && Ln ? Mt = ve(pn) : Mt = pn.length;
            var ot = Qo(4 + Mt + 1), Xt = ot + 4;
            if (Xt >>>= 0, be[ot >>> 2] = Mt, Nt && Ln)
              Ge(pn, Xt, Mt + 1);
            else if (Ln)
              for (var sn = 0; sn < Mt; ++sn) {
                var dn = pn.charCodeAt(sn);
                dn > 255 && (Ns(Xt), Lr("String has UTF-16 code units that do not fit in 8 bits")), ae[Xt + sn >>> 0] = dn;
              }
            else
              for (var sn = 0; sn < Mt; ++sn)
                ae[Xt + sn >>> 0] = pn[sn];
            return mt !== null && mt.push(Ns, ot), ot;
          }, argPackAdvance: 8, readValueFromPointer: Nn, destructorFunction: function(mt) {
            Ns(mt);
          } });
        }
        var As = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0;
        function ro(Ye, qe) {
          for (var Nt = Ye, mt = Nt >> 1, pn = mt + qe / 2; !(mt >= pn) && Te[mt >>> 0]; )
            ++mt;
          if (Nt = mt << 1, Nt - Ye > 32 && As)
            return As.decode(ae.subarray(Ye >>> 0, Nt >>> 0));
          for (var Mt = "", Ln = 0; !(Ln >= qe / 2); ++Ln) {
            var ot = v[Ye + Ln * 2 >>> 1];
            if (ot == 0)
              break;
            Mt += String.fromCharCode(ot);
          }
          return Mt;
        }
        function Mo(Ye, qe, Nt) {
          if (Nt === void 0 && (Nt = 2147483647), Nt < 2)
            return 0;
          Nt -= 2;
          for (var mt = qe, pn = Nt < Ye.length * 2 ? Nt / 2 : Ye.length, Mt = 0; Mt < pn; ++Mt) {
            var Ln = Ye.charCodeAt(Mt);
            v[qe >>> 1] = Ln, qe += 2;
          }
          return v[qe >>> 1] = 0, qe - mt;
        }
        function vr(Ye) {
          return Ye.length * 2;
        }
        function ts(Ye, qe) {
          for (var Nt = 0, mt = ""; !(Nt >= qe / 4); ) {
            var pn = De[Ye + Nt * 4 >>> 2];
            if (pn == 0)
              break;
            if (++Nt, pn >= 65536) {
              var Mt = pn - 65536;
              mt += String.fromCharCode(55296 | Mt >> 10, 56320 | Mt & 1023);
            } else
              mt += String.fromCharCode(pn);
          }
          return mt;
        }
        function kr(Ye, qe, Nt) {
          if (qe >>>= 0, Nt === void 0 && (Nt = 2147483647), Nt < 4)
            return 0;
          for (var mt = qe, pn = mt + Nt - 4, Mt = 0; Mt < Ye.length; ++Mt) {
            var Ln = Ye.charCodeAt(Mt);
            if (Ln >= 55296 && Ln <= 57343) {
              var ot = Ye.charCodeAt(++Mt);
              Ln = 65536 + ((Ln & 1023) << 10) | ot & 1023;
            }
            if (De[qe >>> 2] = Ln, qe += 4, qe + 4 > pn)
              break;
          }
          return De[qe >>> 2] = 0, qe - mt;
        }
        function Us(Ye) {
          for (var qe = 0, Nt = 0; Nt < Ye.length; ++Nt) {
            var mt = Ye.charCodeAt(Nt);
            mt >= 55296 && mt <= 57343 && ++Nt, qe += 4;
          }
          return qe;
        }
        function ri(Ye, qe, Nt) {
          Nt = Qr(Nt);
          var mt, pn, Mt, Ln, ot;
          qe === 2 ? (mt = ro, pn = Mo, Ln = vr, Mt = () => Te, ot = 1) : qe === 4 && (mt = ts, pn = kr, Ln = Us, Mt = () => be, ot = 2), Hr(Ye, { name: Nt, fromWireType: function(Xt) {
            for (var sn = be[Xt >>> 2], dn = Mt(), Ar, yr = Xt + 4, Pr = 0; Pr <= sn; ++Pr) {
              var Zr = Xt + 4 + Pr * qe;
              if (Pr == sn || dn[Zr >>> ot] == 0) {
                var qs = Zr - yr, Ws = mt(yr, qs);
                Ar === void 0 ? Ar = Ws : (Ar += String.fromCharCode(0), Ar += Ws), yr = Zr + qe;
              }
            }
            return Ns(Xt), Ar;
          }, toWireType: function(Xt, sn) {
            typeof sn != "string" && Lr("Cannot pass non-string to C++ string type " + Nt);
            var dn = Ln(sn), Ar = Qo(4 + dn + qe);
            return Ar >>>= 0, be[Ar >>> 2] = dn >> ot, pn(sn, Ar + 4, dn + qe), Xt !== null && Xt.push(Ns, Ar), Ar;
          }, argPackAdvance: 8, readValueFromPointer: Nn, destructorFunction: function(Xt) {
            Ns(Xt);
          } });
        }
        function Wi(Ye, qe, Nt, mt, pn, Mt) {
          Tn[Ye] = { name: Qr(qe), rawConstructor: Rr(Nt, mt), rawDestructor: Rr(pn, Mt), elements: [] };
        }
        function To(Ye, qe, Nt, mt, pn, Mt, Ln, ot, Xt) {
          Tn[Ye].elements.push({ getterReturnType: qe, getter: Rr(Nt, mt), getterContext: pn, setterArgumentType: Mt, setter: Rr(Ln, ot), setterContext: Xt });
        }
        function ia(Ye, qe, Nt, mt, pn, Mt) {
          _r[Ye] = { name: Qr(qe), rawConstructor: Rr(Nt, mt), rawDestructor: Rr(pn, Mt), fields: [] };
        }
        function bo(Ye, qe, Nt, mt, pn, Mt, Ln, ot, Xt, sn) {
          _r[Ye].fields.push({ fieldName: Qr(qe), getterReturnType: Nt, getter: Rr(mt, pn), getterContext: Mt, setterArgumentType: Ln, setter: Rr(ot, Xt), setterContext: sn });
        }
        function Ys(Ye, qe) {
          qe = Qr(qe), Hr(Ye, { isVoid: !0, name: qe, argPackAdvance: 0, fromWireType: function() {
          }, toWireType: function(Nt, mt) {
          } });
        }
        function Di(Ye, qe, Nt) {
          Ye = Mr.toValue(Ye), qe = Bo(qe, "emval::as");
          var mt = [], pn = Mr.toHandle(mt);
          return be[Nt >>> 2] = pn, qe.toWireType(mt, Ye);
        }
        function Yn(Ye, qe) {
          for (var Nt = new Array(Ye), mt = 0; mt < Ye; ++mt)
            Nt[mt] = Bo(be[qe + mt * 4 >>> 2], "parameter " + mt);
          return Nt;
        }
        function Lo(Ye, qe, Nt, mt) {
          Ye = Mr.toValue(Ye);
          for (var pn = Yn(qe, Nt), Mt = new Array(qe), Ln = 0; Ln < qe; ++Ln) {
            var ot = pn[Ln];
            Mt[Ln] = ot.readValueFromPointer(mt), mt += ot.argPackAdvance;
          }
          var Xt = Ye.apply(void 0, Mt);
          return Mr.toHandle(Xt);
        }
        var Un = {};
        function so(Ye) {
          var qe = Un[Ye];
          return qe === void 0 ? Qr(Ye) : qe;
        }
        function rs() {
          return typeof globalThis == "object" ? globalThis : function() {
            return Function;
          }()("return this")();
        }
        function hi(Ye) {
          return Ye === 0 ? Mr.toHandle(rs()) : (Ye = so(Ye), Mr.toHandle(rs()[Ye]));
        }
        function Zo(Ye, qe) {
          return Ye = Mr.toValue(Ye), qe = Mr.toValue(qe), Mr.toHandle(Ye[qe]);
        }
        function li(Ye) {
          Ye > 4 && (fo[Ye].refcount += 1);
        }
        function ei(Ye, qe) {
          return Ye = Mr.toValue(Ye), qe = Mr.toValue(qe), Ye instanceof qe;
        }
        function Or(Ye) {
          return Ye = Mr.toValue(Ye), typeof Ye == "number";
        }
        function ui(Ye) {
          return Ye = Mr.toValue(Ye), typeof Ye == "string";
        }
        function _s() {
          return Mr.toHandle([]);
        }
        function xo(Ye) {
          return Mr.toHandle(so(Ye));
        }
        function aa() {
          return Mr.toHandle({});
        }
        function oo(Ye) {
          var qe = Mr.toValue(Ye);
          Rn(qe), xs(Ye);
        }
        function vs(Ye, qe, Nt) {
          Ye = Mr.toValue(Ye), qe = Mr.toValue(qe), Nt = Mr.toValue(Nt), Ye[qe] = Nt;
        }
        function yi(Ye, qe) {
          Ye = Bo(Ye, "_emval_take_value");
          var Nt = Ye.readValueFromPointer(qe);
          return Mr.toHandle(Nt);
        }
        function $r() {
          Et("");
        }
        function ki(Ye, qe, Nt) {
          ae.copyWithin(Ye >>> 0, qe >>> 0, qe + Nt >>> 0);
        }
        function ds() {
          return 4294901760;
        }
        function Ls(Ye) {
          var qe = G.buffer;
          try {
            return G.grow(Ye - qe.byteLength + 65535 >>> 16), Be(), 1;
          } catch {
          }
        }
        function Co(Ye) {
          var qe = ae.length;
          Ye = Ye >>> 0;
          var Nt = ds();
          if (Ye > Nt)
            return !1;
          let mt = (Xt, sn) => Xt + (sn - Xt % sn) % sn;
          for (var pn = 1; pn <= 4; pn *= 2) {
            var Mt = qe * (1 + 0.2 / pn);
            Mt = Math.min(Mt, Ye + 100663296);
            var Ln = Math.min(Nt, mt(Math.max(Ye, Mt), 65536)), ot = Ls(Ln);
            if (ot)
              return !0;
          }
          return !1;
        }
        var ps = {};
        function Tr() {
          return d || "./this.program";
        }
        function ao() {
          if (!ao.strings) {
            var Ye = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", qe = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: Ye, _: Tr() };
            for (var Nt in ps)
              ps[Nt] === void 0 ? delete qe[Nt] : qe[Nt] = ps[Nt];
            var mt = [];
            for (var Nt in qe)
              mt.push(Nt + "=" + qe[Nt]);
            ao.strings = mt;
          }
          return ao.strings;
        }
        function Gt(Ye, qe, Nt) {
          for (var mt = 0; mt < Ye.length; ++mt)
            te[qe++ >>> 0] = Ye.charCodeAt(mt);
          Nt || (te[qe >>> 0] = 0);
        }
        var sr = { isAbs: (Ye) => Ye.charAt(0) === "/", splitPath: (Ye) => {
          var qe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
          return qe.exec(Ye).slice(1);
        }, normalizeArray: (Ye, qe) => {
          for (var Nt = 0, mt = Ye.length - 1; mt >= 0; mt--) {
            var pn = Ye[mt];
            pn === "." ? Ye.splice(mt, 1) : pn === ".." ? (Ye.splice(mt, 1), Nt++) : Nt && (Ye.splice(mt, 1), Nt--);
          }
          if (qe)
            for (; Nt; Nt--)
              Ye.unshift("..");
          return Ye;
        }, normalize: (Ye) => {
          var qe = sr.isAbs(Ye), Nt = Ye.substr(-1) === "/";
          return Ye = sr.normalizeArray(Ye.split("/").filter((mt) => !!mt), !qe).join("/"), !Ye && !qe && (Ye = "."), Ye && Nt && (Ye += "/"), (qe ? "/" : "") + Ye;
        }, dirname: (Ye) => {
          var qe = sr.splitPath(Ye), Nt = qe[0], mt = qe[1];
          return !Nt && !mt ? "." : (mt && (mt = mt.substr(0, mt.length - 1)), Nt + mt);
        }, basename: (Ye) => {
          if (Ye === "/")
            return "/";
          Ye = sr.normalize(Ye), Ye = Ye.replace(/\/$/, "");
          var qe = Ye.lastIndexOf("/");
          return qe === -1 ? Ye : Ye.substr(qe + 1);
        }, join: function() {
          var Ye = Array.prototype.slice.call(arguments);
          return sr.normalize(Ye.join("/"));
        }, join2: (Ye, qe) => sr.normalize(Ye + "/" + qe) };
        function vt() {
          if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") {
            var Ye = new Uint8Array(1);
            return () => (crypto.getRandomValues(Ye), Ye[0]);
          } else
            return () => Et("randomDevice");
        }
        var Jr = { resolve: function() {
          for (var Ye = "", qe = !1, Nt = arguments.length - 1; Nt >= -1 && !qe; Nt--) {
            var mt = Nt >= 0 ? arguments[Nt] : rn.cwd();
            if (typeof mt != "string")
              throw new TypeError("Arguments to path.resolve must be strings");
            if (!mt)
              return "";
            Ye = mt + "/" + Ye, qe = sr.isAbs(mt);
          }
          return Ye = sr.normalizeArray(Ye.split("/").filter((pn) => !!pn), !qe).join("/"), (qe ? "/" : "") + Ye || ".";
        }, relative: (Ye, qe) => {
          Ye = Jr.resolve(Ye).substr(1), qe = Jr.resolve(qe).substr(1);
          function Nt(sn) {
            for (var dn = 0; dn < sn.length && sn[dn] === ""; dn++)
              ;
            for (var Ar = sn.length - 1; Ar >= 0 && sn[Ar] === ""; Ar--)
              ;
            return dn > Ar ? [] : sn.slice(dn, Ar - dn + 1);
          }
          for (var mt = Nt(Ye.split("/")), pn = Nt(qe.split("/")), Mt = Math.min(mt.length, pn.length), Ln = Mt, ot = 0; ot < Mt; ot++)
            if (mt[ot] !== pn[ot]) {
              Ln = ot;
              break;
            }
          for (var Xt = [], ot = Ln; ot < mt.length; ot++)
            Xt.push("..");
          return Xt = Xt.concat(pn.slice(Ln)), Xt.join("/");
        } };
        function Qs(Ye, qe, Nt) {
          var mt = Nt > 0 ? Nt : ve(Ye) + 1, pn = new Array(mt), Mt = Ee(Ye, pn, 0, pn.length);
          return qe && (pn.length = Mt), pn;
        }
        var Ds = { ttys: [], init: function() {
        }, shutdown: function() {
        }, register: function(Ye, qe) {
          Ds.ttys[Ye] = { input: [], output: [], ops: qe }, rn.registerDevice(Ye, Ds.stream_ops);
        }, stream_ops: { open: function(Ye) {
          var qe = Ds.ttys[Ye.node.rdev];
          if (!qe)
            throw new rn.ErrnoError(43);
          Ye.tty = qe, Ye.seekable = !1;
        }, close: function(Ye) {
          Ye.tty.ops.fsync(Ye.tty);
        }, fsync: function(Ye) {
          Ye.tty.ops.fsync(Ye.tty);
        }, read: function(Ye, qe, Nt, mt, pn) {
          if (!Ye.tty || !Ye.tty.ops.get_char)
            throw new rn.ErrnoError(60);
          for (var Mt = 0, Ln = 0; Ln < mt; Ln++) {
            var ot;
            try {
              ot = Ye.tty.ops.get_char(Ye.tty);
            } catch {
              throw new rn.ErrnoError(29);
            }
            if (ot === void 0 && Mt === 0)
              throw new rn.ErrnoError(6);
            if (ot == null)
              break;
            Mt++, qe[Nt + Ln] = ot;
          }
          return Mt && (Ye.node.timestamp = Date.now()), Mt;
        }, write: function(Ye, qe, Nt, mt, pn) {
          if (!Ye.tty || !Ye.tty.ops.put_char)
            throw new rn.ErrnoError(60);
          try {
            for (var Mt = 0; Mt < mt; Mt++)
              Ye.tty.ops.put_char(Ye.tty, qe[Nt + Mt]);
          } catch {
            throw new rn.ErrnoError(29);
          }
          return mt && (Ye.node.timestamp = Date.now()), Mt;
        } }, default_tty_ops: { get_char: function(Ye) {
          if (!Ye.input.length) {
            var qe = null;
            if (typeof window < "u" && typeof window.prompt == "function" ? (qe = window.prompt("Input: "), qe !== null && (qe += `
`)) : typeof readline == "function" && (qe = readline(), qe !== null && (qe += `
`)), !qe)
              return null;
            Ye.input = Qs(qe, !0);
          }
          return Ye.input.shift();
        }, put_char: function(Ye, qe) {
          qe === null || qe === 10 ? (L(Le(Ye.output, 0)), Ye.output = []) : qe != 0 && Ye.output.push(qe);
        }, fsync: function(Ye) {
          Ye.output && Ye.output.length > 0 && (L(Le(Ye.output, 0)), Ye.output = []);
        } }, default_tty1_ops: { put_char: function(Ye, qe) {
          qe === null || qe === 10 ? (F(Le(Ye.output, 0)), Ye.output = []) : qe != 0 && Ye.output.push(qe);
        }, fsync: function(Ye) {
          Ye.output && Ye.output.length > 0 && (F(Le(Ye.output, 0)), Ye.output = []);
        } } };
        function Hs(Ye) {
          Et();
        }
        var Xr = { ops_table: null, mount: function(Ye) {
          return Xr.createNode(null, "/", 16895, 0);
        }, createNode: function(Ye, qe, Nt, mt) {
          if (rn.isBlkdev(Nt) || rn.isFIFO(Nt))
            throw new rn.ErrnoError(63);
          Xr.ops_table || (Xr.ops_table = { dir: { node: { getattr: Xr.node_ops.getattr, setattr: Xr.node_ops.setattr, lookup: Xr.node_ops.lookup, mknod: Xr.node_ops.mknod, rename: Xr.node_ops.rename, unlink: Xr.node_ops.unlink, rmdir: Xr.node_ops.rmdir, readdir: Xr.node_ops.readdir, symlink: Xr.node_ops.symlink }, stream: { llseek: Xr.stream_ops.llseek } }, file: { node: { getattr: Xr.node_ops.getattr, setattr: Xr.node_ops.setattr }, stream: { llseek: Xr.stream_ops.llseek, read: Xr.stream_ops.read, write: Xr.stream_ops.write, allocate: Xr.stream_ops.allocate, mmap: Xr.stream_ops.mmap, msync: Xr.stream_ops.msync } }, link: { node: { getattr: Xr.node_ops.getattr, setattr: Xr.node_ops.setattr, readlink: Xr.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: Xr.node_ops.getattr, setattr: Xr.node_ops.setattr }, stream: rn.chrdev_stream_ops } });
          var pn = rn.createNode(Ye, qe, Nt, mt);
          return rn.isDir(pn.mode) ? (pn.node_ops = Xr.ops_table.dir.node, pn.stream_ops = Xr.ops_table.dir.stream, pn.contents = {}) : rn.isFile(pn.mode) ? (pn.node_ops = Xr.ops_table.file.node, pn.stream_ops = Xr.ops_table.file.stream, pn.usedBytes = 0, pn.contents = null) : rn.isLink(pn.mode) ? (pn.node_ops = Xr.ops_table.link.node, pn.stream_ops = Xr.ops_table.link.stream) : rn.isChrdev(pn.mode) && (pn.node_ops = Xr.ops_table.chrdev.node, pn.stream_ops = Xr.ops_table.chrdev.stream), pn.timestamp = Date.now(), Ye && (Ye.contents[qe] = pn, Ye.timestamp = pn.timestamp), pn;
        }, getFileDataAsTypedArray: function(Ye) {
          return Ye.contents ? Ye.contents.subarray ? Ye.contents.subarray(0, Ye.usedBytes) : new Uint8Array(Ye.contents) : new Uint8Array(0);
        }, expandFileStorage: function(Ye, qe) {
          qe >>>= 0;
          var Nt = Ye.contents ? Ye.contents.length : 0;
          if (!(Nt >= qe)) {
            var mt = 1024 * 1024;
            qe = Math.max(qe, Nt * (Nt < mt ? 2 : 1.125) >>> 0), Nt != 0 && (qe = Math.max(qe, 256));
            var pn = Ye.contents;
            Ye.contents = new Uint8Array(qe), Ye.usedBytes > 0 && Ye.contents.set(pn.subarray(0, Ye.usedBytes), 0);
          }
        }, resizeFileStorage: function(Ye, qe) {
          if (qe >>>= 0, Ye.usedBytes != qe)
            if (qe == 0)
              Ye.contents = null, Ye.usedBytes = 0;
            else {
              var Nt = Ye.contents;
              Ye.contents = new Uint8Array(qe), Nt && Ye.contents.set(Nt.subarray(0, Math.min(qe, Ye.usedBytes))), Ye.usedBytes = qe;
            }
        }, node_ops: { getattr: function(Ye) {
          var qe = {};
          return qe.dev = rn.isChrdev(Ye.mode) ? Ye.id : 1, qe.ino = Ye.id, qe.mode = Ye.mode, qe.nlink = 1, qe.uid = 0, qe.gid = 0, qe.rdev = Ye.rdev, rn.isDir(Ye.mode) ? qe.size = 4096 : rn.isFile(Ye.mode) ? qe.size = Ye.usedBytes : rn.isLink(Ye.mode) ? qe.size = Ye.link.length : qe.size = 0, qe.atime = new Date(Ye.timestamp), qe.mtime = new Date(Ye.timestamp), qe.ctime = new Date(Ye.timestamp), qe.blksize = 4096, qe.blocks = Math.ceil(qe.size / qe.blksize), qe;
        }, setattr: function(Ye, qe) {
          qe.mode !== void 0 && (Ye.mode = qe.mode), qe.timestamp !== void 0 && (Ye.timestamp = qe.timestamp), qe.size !== void 0 && Xr.resizeFileStorage(Ye, qe.size);
        }, lookup: function(Ye, qe) {
          throw rn.genericErrors[44];
        }, mknod: function(Ye, qe, Nt, mt) {
          return Xr.createNode(Ye, qe, Nt, mt);
        }, rename: function(Ye, qe, Nt) {
          if (rn.isDir(Ye.mode)) {
            var mt;
            try {
              mt = rn.lookupNode(qe, Nt);
            } catch {
            }
            if (mt)
              for (var pn in mt.contents)
                throw new rn.ErrnoError(55);
          }
          delete Ye.parent.contents[Ye.name], Ye.parent.timestamp = Date.now(), Ye.name = Nt, qe.contents[Nt] = Ye, qe.timestamp = Ye.parent.timestamp, Ye.parent = qe;
        }, unlink: function(Ye, qe) {
          delete Ye.contents[qe], Ye.timestamp = Date.now();
        }, rmdir: function(Ye, qe) {
          var Nt = rn.lookupNode(Ye, qe);
          for (var mt in Nt.contents)
            throw new rn.ErrnoError(55);
          delete Ye.contents[qe], Ye.timestamp = Date.now();
        }, readdir: function(Ye) {
          var qe = [".", ".."];
          for (var Nt in Ye.contents)
            Ye.contents.hasOwnProperty(Nt) && qe.push(Nt);
          return qe;
        }, symlink: function(Ye, qe, Nt) {
          var mt = Xr.createNode(Ye, qe, 41471, 0);
          return mt.link = Nt, mt;
        }, readlink: function(Ye) {
          if (!rn.isLink(Ye.mode))
            throw new rn.ErrnoError(28);
          return Ye.link;
        } }, stream_ops: { read: function(Ye, qe, Nt, mt, pn) {
          var Mt = Ye.node.contents;
          if (pn >= Ye.node.usedBytes)
            return 0;
          var Ln = Math.min(Ye.node.usedBytes - pn, mt);
          if (Ln > 8 && Mt.subarray)
            qe.set(Mt.subarray(pn, pn + Ln), Nt);
          else
            for (var ot = 0; ot < Ln; ot++)
              qe[Nt + ot] = Mt[pn + ot];
          return Ln;
        }, write: function(Ye, qe, Nt, mt, pn, Mt) {
          if (qe.buffer === te.buffer && (Mt = !1), !mt)
            return 0;
          var Ln = Ye.node;
          if (Ln.timestamp = Date.now(), qe.subarray && (!Ln.contents || Ln.contents.subarray)) {
            if (Mt)
              return Ln.contents = qe.subarray(Nt, Nt + mt), Ln.usedBytes = mt, mt;
            if (Ln.usedBytes === 0 && pn === 0)
              return Ln.contents = qe.slice(Nt, Nt + mt), Ln.usedBytes = mt, mt;
            if (pn + mt <= Ln.usedBytes)
              return Ln.contents.set(qe.subarray(Nt, Nt + mt), pn), mt;
          }
          if (Xr.expandFileStorage(Ln, pn + mt), Ln.contents.subarray && qe.subarray)
            Ln.contents.set(qe.subarray(Nt, Nt + mt), pn);
          else
            for (var ot = 0; ot < mt; ot++)
              Ln.contents[pn + ot] = qe[Nt + ot];
          return Ln.usedBytes = Math.max(Ln.usedBytes, pn + mt), mt;
        }, llseek: function(Ye, qe, Nt) {
          var mt = qe;
          if (Nt === 1 ? mt += Ye.position : Nt === 2 && rn.isFile(Ye.node.mode) && (mt += Ye.node.usedBytes), mt < 0)
            throw new rn.ErrnoError(28);
          return mt;
        }, allocate: function(Ye, qe, Nt) {
          Xr.expandFileStorage(Ye.node, qe + Nt), Ye.node.usedBytes = Math.max(Ye.node.usedBytes, qe + Nt);
        }, mmap: function(Ye, qe, Nt, mt, pn) {
          if (!rn.isFile(Ye.node.mode))
            throw new rn.ErrnoError(43);
          var Mt, Ln, ot = Ye.node.contents;
          if (!(pn & 2) && ot.buffer === te.buffer)
            Ln = !1, Mt = ot.byteOffset;
          else {
            if ((Nt > 0 || Nt + qe < ot.length) && (ot.subarray ? ot = ot.subarray(Nt, Nt + qe) : ot = Array.prototype.slice.call(ot, Nt, Nt + qe)), Ln = !0, Mt = Hs(), !Mt)
              throw new rn.ErrnoError(48);
            Mt >>>= 0, te.set(ot, Mt >>> 0);
          }
          return { ptr: Mt, allocated: Ln };
        }, msync: function(Ye, qe, Nt, mt, pn) {
          return Xr.stream_ops.write(Ye, qe, 0, mt, Nt, !1), 0;
        } } };
        function bi(Ye, qe, Nt, mt) {
          var pn = mt ? "" : "al " + Ye;
          _(Ye, (Mt) => {
            fe(Mt, 'Loading data file "' + Ye + '" failed (no arrayBuffer).'), qe(new Uint8Array(Mt)), pn && Zt();
          }, (Mt) => {
            if (Nt)
              Nt();
            else
              throw 'Loading data file "' + Ye + '" failed.';
          }), pn && lt();
        }
        var rn = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: (Ye, qe = {}) => {
          if (Ye = Jr.resolve(Ye), !Ye)
            return { path: "", node: null };
          var Nt = { follow_mount: !0, recurse_count: 0 };
          if (qe = Object.assign(Nt, qe), qe.recurse_count > 8)
            throw new rn.ErrnoError(32);
          for (var mt = Ye.split("/").filter((Ar) => !!Ar), pn = rn.root, Mt = "/", Ln = 0; Ln < mt.length; Ln++) {
            var ot = Ln === mt.length - 1;
            if (ot && qe.parent)
              break;
            if (pn = rn.lookupNode(pn, mt[Ln]), Mt = sr.join2(Mt, mt[Ln]), rn.isMountpoint(pn) && (!ot || ot && qe.follow_mount) && (pn = pn.mounted.root), !ot || qe.follow)
              for (var Xt = 0; rn.isLink(pn.mode); ) {
                var sn = rn.readlink(Mt);
                Mt = Jr.resolve(sr.dirname(Mt), sn);
                var dn = rn.lookupPath(Mt, { recurse_count: qe.recurse_count + 1 });
                if (pn = dn.node, Xt++ > 40)
                  throw new rn.ErrnoError(32);
              }
          }
          return { path: Mt, node: pn };
        }, getPath: (Ye) => {
          for (var qe; ; ) {
            if (rn.isRoot(Ye)) {
              var Nt = Ye.mount.mountpoint;
              return qe ? Nt[Nt.length - 1] !== "/" ? Nt + "/" + qe : Nt + qe : Nt;
            }
            qe = qe ? Ye.name + "/" + qe : Ye.name, Ye = Ye.parent;
          }
        }, hashName: (Ye, qe) => {
          for (var Nt = 0, mt = 0; mt < qe.length; mt++)
            Nt = (Nt << 5) - Nt + qe.charCodeAt(mt) | 0;
          return (Ye + Nt >>> 0) % rn.nameTable.length;
        }, hashAddNode: (Ye) => {
          var qe = rn.hashName(Ye.parent.id, Ye.name);
          Ye.name_next = rn.nameTable[qe], rn.nameTable[qe] = Ye;
        }, hashRemoveNode: (Ye) => {
          var qe = rn.hashName(Ye.parent.id, Ye.name);
          if (rn.nameTable[qe] === Ye)
            rn.nameTable[qe] = Ye.name_next;
          else
            for (var Nt = rn.nameTable[qe]; Nt; ) {
              if (Nt.name_next === Ye) {
                Nt.name_next = Ye.name_next;
                break;
              }
              Nt = Nt.name_next;
            }
        }, lookupNode: (Ye, qe) => {
          var Nt = rn.mayLookup(Ye);
          if (Nt)
            throw new rn.ErrnoError(Nt, Ye);
          for (var mt = rn.hashName(Ye.id, qe), pn = rn.nameTable[mt]; pn; pn = pn.name_next) {
            var Mt = pn.name;
            if (pn.parent.id === Ye.id && Mt === qe)
              return pn;
          }
          return rn.lookup(Ye, qe);
        }, createNode: (Ye, qe, Nt, mt) => {
          var pn = new rn.FSNode(Ye, qe, Nt, mt);
          return rn.hashAddNode(pn), pn;
        }, destroyNode: (Ye) => {
          rn.hashRemoveNode(Ye);
        }, isRoot: (Ye) => Ye === Ye.parent, isMountpoint: (Ye) => !!Ye.mounted, isFile: (Ye) => (Ye & 61440) === 32768, isDir: (Ye) => (Ye & 61440) === 16384, isLink: (Ye) => (Ye & 61440) === 40960, isChrdev: (Ye) => (Ye & 61440) === 8192, isBlkdev: (Ye) => (Ye & 61440) === 24576, isFIFO: (Ye) => (Ye & 61440) === 4096, isSocket: (Ye) => (Ye & 49152) === 49152, flagModes: { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, modeStringToFlags: (Ye) => {
          var qe = rn.flagModes[Ye];
          if (typeof qe > "u")
            throw new Error("Unknown file open mode: " + Ye);
          return qe;
        }, flagsToPermissionString: (Ye) => {
          var qe = ["r", "w", "rw"][Ye & 3];
          return Ye & 512 && (qe += "w"), qe;
        }, nodePermissions: (Ye, qe) => rn.ignorePermissions ? 0 : qe.includes("r") && !(Ye.mode & 292) || qe.includes("w") && !(Ye.mode & 146) || qe.includes("x") && !(Ye.mode & 73) ? 2 : 0, mayLookup: (Ye) => {
          var qe = rn.nodePermissions(Ye, "x");
          return qe || (Ye.node_ops.lookup ? 0 : 2);
        }, mayCreate: (Ye, qe) => {
          try {
            var Nt = rn.lookupNode(Ye, qe);
            return 20;
          } catch {
          }
          return rn.nodePermissions(Ye, "wx");
        }, mayDelete: (Ye, qe, Nt) => {
          var mt;
          try {
            mt = rn.lookupNode(Ye, qe);
          } catch (Mt) {
            return Mt.errno;
          }
          var pn = rn.nodePermissions(Ye, "wx");
          if (pn)
            return pn;
          if (Nt) {
            if (!rn.isDir(mt.mode))
              return 54;
            if (rn.isRoot(mt) || rn.getPath(mt) === rn.cwd())
              return 10;
          } else if (rn.isDir(mt.mode))
            return 31;
          return 0;
        }, mayOpen: (Ye, qe) => Ye ? rn.isLink(Ye.mode) ? 32 : rn.isDir(Ye.mode) && (rn.flagsToPermissionString(qe) !== "r" || qe & 512) ? 31 : rn.nodePermissions(Ye, rn.flagsToPermissionString(qe)) : 44, MAX_OPEN_FDS: 4096, nextfd: (Ye = 0, qe = rn.MAX_OPEN_FDS) => {
          for (var Nt = Ye; Nt <= qe; Nt++)
            if (!rn.streams[Nt])
              return Nt;
          throw new rn.ErrnoError(33);
        }, getStream: (Ye) => rn.streams[Ye], createStream: (Ye, qe, Nt) => {
          rn.FSStream || (rn.FSStream = function() {
            this.shared = {};
          }, rn.FSStream.prototype = {}, Object.defineProperties(rn.FSStream.prototype, { object: { get: function() {
            return this.node;
          }, set: function(pn) {
            this.node = pn;
          } }, isRead: { get: function() {
            return (this.flags & 2097155) !== 1;
          } }, isWrite: { get: function() {
            return (this.flags & 2097155) !== 0;
          } }, isAppend: { get: function() {
            return this.flags & 1024;
          } }, flags: { get: function() {
            return this.shared.flags;
          }, set: function(pn) {
            this.shared.flags = pn;
          } }, position: { get: function() {
            return this.shared.position;
          }, set: function(pn) {
            this.shared.position = pn;
          } } })), Ye = Object.assign(new rn.FSStream(), Ye);
          var mt = rn.nextfd(qe, Nt);
          return Ye.fd = mt, rn.streams[mt] = Ye, Ye;
        }, closeStream: (Ye) => {
          rn.streams[Ye] = null;
        }, chrdev_stream_ops: { open: (Ye) => {
          var qe = rn.getDevice(Ye.node.rdev);
          Ye.stream_ops = qe.stream_ops, Ye.stream_ops.open && Ye.stream_ops.open(Ye);
        }, llseek: () => {
          throw new rn.ErrnoError(70);
        } }, major: (Ye) => Ye >> 8, minor: (Ye) => Ye & 255, makedev: (Ye, qe) => Ye << 8 | qe, registerDevice: (Ye, qe) => {
          rn.devices[Ye] = { stream_ops: qe };
        }, getDevice: (Ye) => rn.devices[Ye], getMounts: (Ye) => {
          for (var qe = [], Nt = [Ye]; Nt.length; ) {
            var mt = Nt.pop();
            qe.push(mt), Nt.push.apply(Nt, mt.mounts);
          }
          return qe;
        }, syncfs: (Ye, qe) => {
          typeof Ye == "function" && (qe = Ye, Ye = !1), rn.syncFSRequests++, rn.syncFSRequests > 1 && F("warning: " + rn.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
          var Nt = rn.getMounts(rn.root.mount), mt = 0;
          function pn(Ln) {
            return rn.syncFSRequests--, qe(Ln);
          }
          function Mt(Ln) {
            if (Ln)
              return Mt.errored ? void 0 : (Mt.errored = !0, pn(Ln));
            ++mt >= Nt.length && pn(null);
          }
          Nt.forEach((Ln) => {
            if (!Ln.type.syncfs)
              return Mt(null);
            Ln.type.syncfs(Ln, Ye, Mt);
          });
        }, mount: (Ye, qe, Nt) => {
          var mt = Nt === "/", pn = !Nt, Mt;
          if (mt && rn.root)
            throw new rn.ErrnoError(10);
          if (!mt && !pn) {
            var Ln = rn.lookupPath(Nt, { follow_mount: !1 });
            if (Nt = Ln.path, Mt = Ln.node, rn.isMountpoint(Mt))
              throw new rn.ErrnoError(10);
            if (!rn.isDir(Mt.mode))
              throw new rn.ErrnoError(54);
          }
          var ot = { type: Ye, opts: qe, mountpoint: Nt, mounts: [] }, Xt = Ye.mount(ot);
          return Xt.mount = ot, ot.root = Xt, mt ? rn.root = Xt : Mt && (Mt.mounted = ot, Mt.mount && Mt.mount.mounts.push(ot)), Xt;
        }, unmount: (Ye) => {
          var qe = rn.lookupPath(Ye, { follow_mount: !1 });
          if (!rn.isMountpoint(qe.node))
            throw new rn.ErrnoError(28);
          var Nt = qe.node, mt = Nt.mounted, pn = rn.getMounts(mt);
          Object.keys(rn.nameTable).forEach((Ln) => {
            for (var ot = rn.nameTable[Ln]; ot; ) {
              var Xt = ot.name_next;
              pn.includes(ot.mount) && rn.destroyNode(ot), ot = Xt;
            }
          }), Nt.mounted = null;
          var Mt = Nt.mount.mounts.indexOf(mt);
          Nt.mount.mounts.splice(Mt, 1);
        }, lookup: (Ye, qe) => Ye.node_ops.lookup(Ye, qe), mknod: (Ye, qe, Nt) => {
          var mt = rn.lookupPath(Ye, { parent: !0 }), pn = mt.node, Mt = sr.basename(Ye);
          if (!Mt || Mt === "." || Mt === "..")
            throw new rn.ErrnoError(28);
          var Ln = rn.mayCreate(pn, Mt);
          if (Ln)
            throw new rn.ErrnoError(Ln);
          if (!pn.node_ops.mknod)
            throw new rn.ErrnoError(63);
          return pn.node_ops.mknod(pn, Mt, qe, Nt);
        }, create: (Ye, qe) => (qe = qe !== void 0 ? qe : 438, qe &= 4095, qe |= 32768, rn.mknod(Ye, qe, 0)), mkdir: (Ye, qe) => (qe = qe !== void 0 ? qe : 511, qe &= 1023, qe |= 16384, rn.mknod(Ye, qe, 0)), mkdirTree: (Ye, qe) => {
          for (var Nt = Ye.split("/"), mt = "", pn = 0; pn < Nt.length; ++pn)
            if (Nt[pn]) {
              mt += "/" + Nt[pn];
              try {
                rn.mkdir(mt, qe);
              } catch (Mt) {
                if (Mt.errno != 20)
                  throw Mt;
              }
            }
        }, mkdev: (Ye, qe, Nt) => (typeof Nt > "u" && (Nt = qe, qe = 438), qe |= 8192, rn.mknod(Ye, qe, Nt)), symlink: (Ye, qe) => {
          if (!Jr.resolve(Ye))
            throw new rn.ErrnoError(44);
          var Nt = rn.lookupPath(qe, { parent: !0 }), mt = Nt.node;
          if (!mt)
            throw new rn.ErrnoError(44);
          var pn = sr.basename(qe), Mt = rn.mayCreate(mt, pn);
          if (Mt)
            throw new rn.ErrnoError(Mt);
          if (!mt.node_ops.symlink)
            throw new rn.ErrnoError(63);
          return mt.node_ops.symlink(mt, pn, Ye);
        }, rename: (Ye, qe) => {
          var Nt = sr.dirname(Ye), mt = sr.dirname(qe), pn = sr.basename(Ye), Mt = sr.basename(qe), Ln, ot, Xt;
          if (Ln = rn.lookupPath(Ye, { parent: !0 }), ot = Ln.node, Ln = rn.lookupPath(qe, { parent: !0 }), Xt = Ln.node, !ot || !Xt)
            throw new rn.ErrnoError(44);
          if (ot.mount !== Xt.mount)
            throw new rn.ErrnoError(75);
          var sn = rn.lookupNode(ot, pn), dn = Jr.relative(Ye, mt);
          if (dn.charAt(0) !== ".")
            throw new rn.ErrnoError(28);
          if (dn = Jr.relative(qe, Nt), dn.charAt(0) !== ".")
            throw new rn.ErrnoError(55);
          var Ar;
          try {
            Ar = rn.lookupNode(Xt, Mt);
          } catch {
          }
          if (sn !== Ar) {
            var yr = rn.isDir(sn.mode), Pr = rn.mayDelete(ot, pn, yr);
            if (Pr)
              throw new rn.ErrnoError(Pr);
            if (Pr = Ar ? rn.mayDelete(Xt, Mt, yr) : rn.mayCreate(Xt, Mt), Pr)
              throw new rn.ErrnoError(Pr);
            if (!ot.node_ops.rename)
              throw new rn.ErrnoError(63);
            if (rn.isMountpoint(sn) || Ar && rn.isMountpoint(Ar))
              throw new rn.ErrnoError(10);
            if (Xt !== ot && (Pr = rn.nodePermissions(ot, "w"), Pr))
              throw new rn.ErrnoError(Pr);
            rn.hashRemoveNode(sn);
            try {
              ot.node_ops.rename(sn, Xt, Mt);
            } catch (Zr) {
              throw Zr;
            } finally {
              rn.hashAddNode(sn);
            }
          }
        }, rmdir: (Ye) => {
          var qe = rn.lookupPath(Ye, { parent: !0 }), Nt = qe.node, mt = sr.basename(Ye), pn = rn.lookupNode(Nt, mt), Mt = rn.mayDelete(Nt, mt, !0);
          if (Mt)
            throw new rn.ErrnoError(Mt);
          if (!Nt.node_ops.rmdir)
            throw new rn.ErrnoError(63);
          if (rn.isMountpoint(pn))
            throw new rn.ErrnoError(10);
          Nt.node_ops.rmdir(Nt, mt), rn.destroyNode(pn);
        }, readdir: (Ye) => {
          var qe = rn.lookupPath(Ye, { follow: !0 }), Nt = qe.node;
          if (!Nt.node_ops.readdir)
            throw new rn.ErrnoError(54);
          return Nt.node_ops.readdir(Nt);
        }, unlink: (Ye) => {
          var qe = rn.lookupPath(Ye, { parent: !0 }), Nt = qe.node;
          if (!Nt)
            throw new rn.ErrnoError(44);
          var mt = sr.basename(Ye), pn = rn.lookupNode(Nt, mt), Mt = rn.mayDelete(Nt, mt, !1);
          if (Mt)
            throw new rn.ErrnoError(Mt);
          if (!Nt.node_ops.unlink)
            throw new rn.ErrnoError(63);
          if (rn.isMountpoint(pn))
            throw new rn.ErrnoError(10);
          Nt.node_ops.unlink(Nt, mt), rn.destroyNode(pn);
        }, readlink: (Ye) => {
          var qe = rn.lookupPath(Ye), Nt = qe.node;
          if (!Nt)
            throw new rn.ErrnoError(44);
          if (!Nt.node_ops.readlink)
            throw new rn.ErrnoError(28);
          return Jr.resolve(rn.getPath(Nt.parent), Nt.node_ops.readlink(Nt));
        }, stat: (Ye, qe) => {
          var Nt = rn.lookupPath(Ye, { follow: !qe }), mt = Nt.node;
          if (!mt)
            throw new rn.ErrnoError(44);
          if (!mt.node_ops.getattr)
            throw new rn.ErrnoError(63);
          return mt.node_ops.getattr(mt);
        }, lstat: (Ye) => rn.stat(Ye, !0), chmod: (Ye, qe, Nt) => {
          var mt;
          if (typeof Ye == "string") {
            var pn = rn.lookupPath(Ye, { follow: !Nt });
            mt = pn.node;
          } else
            mt = Ye;
          if (!mt.node_ops.setattr)
            throw new rn.ErrnoError(63);
          mt.node_ops.setattr(mt, { mode: qe & 4095 | mt.mode & -4096, timestamp: Date.now() });
        }, lchmod: (Ye, qe) => {
          rn.chmod(Ye, qe, !0);
        }, fchmod: (Ye, qe) => {
          var Nt = rn.getStream(Ye);
          if (!Nt)
            throw new rn.ErrnoError(8);
          rn.chmod(Nt.node, qe);
        }, chown: (Ye, qe, Nt, mt) => {
          var pn;
          if (typeof Ye == "string") {
            var Mt = rn.lookupPath(Ye, { follow: !mt });
            pn = Mt.node;
          } else
            pn = Ye;
          if (!pn.node_ops.setattr)
            throw new rn.ErrnoError(63);
          pn.node_ops.setattr(pn, { timestamp: Date.now() });
        }, lchown: (Ye, qe, Nt) => {
          rn.chown(Ye, qe, Nt, !0);
        }, fchown: (Ye, qe, Nt) => {
          var mt = rn.getStream(Ye);
          if (!mt)
            throw new rn.ErrnoError(8);
          rn.chown(mt.node, qe, Nt);
        }, truncate: (Ye, qe) => {
          if (qe < 0)
            throw new rn.ErrnoError(28);
          var Nt;
          if (typeof Ye == "string") {
            var mt = rn.lookupPath(Ye, { follow: !0 });
            Nt = mt.node;
          } else
            Nt = Ye;
          if (!Nt.node_ops.setattr)
            throw new rn.ErrnoError(63);
          if (rn.isDir(Nt.mode))
            throw new rn.ErrnoError(31);
          if (!rn.isFile(Nt.mode))
            throw new rn.ErrnoError(28);
          var pn = rn.nodePermissions(Nt, "w");
          if (pn)
            throw new rn.ErrnoError(pn);
          Nt.node_ops.setattr(Nt, { size: qe, timestamp: Date.now() });
        }, ftruncate: (Ye, qe) => {
          var Nt = rn.getStream(Ye);
          if (!Nt)
            throw new rn.ErrnoError(8);
          if (!(Nt.flags & 2097155))
            throw new rn.ErrnoError(28);
          rn.truncate(Nt.node, qe);
        }, utime: (Ye, qe, Nt) => {
          var mt = rn.lookupPath(Ye, { follow: !0 }), pn = mt.node;
          pn.node_ops.setattr(pn, { timestamp: Math.max(qe, Nt) });
        }, open: (Ye, qe, Nt) => {
          if (Ye === "")
            throw new rn.ErrnoError(44);
          qe = typeof qe == "string" ? rn.modeStringToFlags(qe) : qe, Nt = typeof Nt > "u" ? 438 : Nt, qe & 64 ? Nt = Nt & 4095 | 32768 : Nt = 0;
          var mt;
          if (typeof Ye == "object")
            mt = Ye;
          else {
            Ye = sr.normalize(Ye);
            try {
              var pn = rn.lookupPath(Ye, { follow: !(qe & 131072) });
              mt = pn.node;
            } catch {
            }
          }
          var Mt = !1;
          if (qe & 64)
            if (mt) {
              if (qe & 128)
                throw new rn.ErrnoError(20);
            } else
              mt = rn.mknod(Ye, Nt, 0), Mt = !0;
          if (!mt)
            throw new rn.ErrnoError(44);
          if (rn.isChrdev(mt.mode) && (qe &= -513), qe & 65536 && !rn.isDir(mt.mode))
            throw new rn.ErrnoError(54);
          if (!Mt) {
            var Ln = rn.mayOpen(mt, qe);
            if (Ln)
              throw new rn.ErrnoError(Ln);
          }
          qe & 512 && !Mt && rn.truncate(mt, 0), qe &= -131713;
          var ot = rn.createStream({ node: mt, path: rn.getPath(mt), flags: qe, seekable: !0, position: 0, stream_ops: mt.stream_ops, ungotten: [], error: !1 });
          return ot.stream_ops.open && ot.stream_ops.open(ot), l.logReadFiles && !(qe & 1) && (rn.readFiles || (rn.readFiles = {}), Ye in rn.readFiles || (rn.readFiles[Ye] = 1)), ot;
        }, close: (Ye) => {
          if (rn.isClosed(Ye))
            throw new rn.ErrnoError(8);
          Ye.getdents && (Ye.getdents = null);
          try {
            Ye.stream_ops.close && Ye.stream_ops.close(Ye);
          } catch (qe) {
            throw qe;
          } finally {
            rn.closeStream(Ye.fd);
          }
          Ye.fd = null;
        }, isClosed: (Ye) => Ye.fd === null, llseek: (Ye, qe, Nt) => {
          if (rn.isClosed(Ye))
            throw new rn.ErrnoError(8);
          if (!Ye.seekable || !Ye.stream_ops.llseek)
            throw new rn.ErrnoError(70);
          if (Nt != 0 && Nt != 1 && Nt != 2)
            throw new rn.ErrnoError(28);
          return Ye.position = Ye.stream_ops.llseek(Ye, qe, Nt), Ye.ungotten = [], Ye.position;
        }, read: (Ye, qe, Nt, mt, pn) => {
          if (Nt >>>= 0, mt < 0 || pn < 0)
            throw new rn.ErrnoError(28);
          if (rn.isClosed(Ye))
            throw new rn.ErrnoError(8);
          if ((Ye.flags & 2097155) === 1)
            throw new rn.ErrnoError(8);
          if (rn.isDir(Ye.node.mode))
            throw new rn.ErrnoError(31);
          if (!Ye.stream_ops.read)
            throw new rn.ErrnoError(28);
          var Mt = typeof pn < "u";
          if (!Mt)
            pn = Ye.position;
          else if (!Ye.seekable)
            throw new rn.ErrnoError(70);
          var Ln = Ye.stream_ops.read(Ye, qe, Nt, mt, pn);
          return Mt || (Ye.position += Ln), Ln;
        }, write: (Ye, qe, Nt, mt, pn, Mt) => {
          if (Nt >>>= 0, mt < 0 || pn < 0)
            throw new rn.ErrnoError(28);
          if (rn.isClosed(Ye))
            throw new rn.ErrnoError(8);
          if (!(Ye.flags & 2097155))
            throw new rn.ErrnoError(8);
          if (rn.isDir(Ye.node.mode))
            throw new rn.ErrnoError(31);
          if (!Ye.stream_ops.write)
            throw new rn.ErrnoError(28);
          Ye.seekable && Ye.flags & 1024 && rn.llseek(Ye, 0, 2);
          var Ln = typeof pn < "u";
          if (!Ln)
            pn = Ye.position;
          else if (!Ye.seekable)
            throw new rn.ErrnoError(70);
          var ot = Ye.stream_ops.write(Ye, qe, Nt, mt, pn, Mt);
          return Ln || (Ye.position += ot), ot;
        }, allocate: (Ye, qe, Nt) => {
          if (rn.isClosed(Ye))
            throw new rn.ErrnoError(8);
          if (qe < 0 || Nt <= 0)
            throw new rn.ErrnoError(28);
          if (!(Ye.flags & 2097155))
            throw new rn.ErrnoError(8);
          if (!rn.isFile(Ye.node.mode) && !rn.isDir(Ye.node.mode))
            throw new rn.ErrnoError(43);
          if (!Ye.stream_ops.allocate)
            throw new rn.ErrnoError(138);
          Ye.stream_ops.allocate(Ye, qe, Nt);
        }, mmap: (Ye, qe, Nt, mt, pn) => {
          if (mt & 2 && !(pn & 2) && (Ye.flags & 2097155) !== 2)
            throw new rn.ErrnoError(2);
          if ((Ye.flags & 2097155) === 1)
            throw new rn.ErrnoError(2);
          if (!Ye.stream_ops.mmap)
            throw new rn.ErrnoError(43);
          return Ye.stream_ops.mmap(Ye, qe, Nt, mt, pn);
        }, msync: (Ye, qe, Nt, mt, pn) => (Nt >>>= 0, Ye.stream_ops.msync ? Ye.stream_ops.msync(Ye, qe, Nt, mt, pn) : 0), munmap: (Ye) => 0, ioctl: (Ye, qe, Nt) => {
          if (!Ye.stream_ops.ioctl)
            throw new rn.ErrnoError(59);
          return Ye.stream_ops.ioctl(Ye, qe, Nt);
        }, readFile: (Ye, qe = {}) => {
          if (qe.flags = qe.flags || 0, qe.encoding = qe.encoding || "binary", qe.encoding !== "utf8" && qe.encoding !== "binary")
            throw new Error('Invalid encoding type "' + qe.encoding + '"');
          var Nt, mt = rn.open(Ye, qe.flags), pn = rn.stat(Ye), Mt = pn.size, Ln = new Uint8Array(Mt);
          return rn.read(mt, Ln, 0, Mt, 0), qe.encoding === "utf8" ? Nt = Le(Ln, 0) : qe.encoding === "binary" && (Nt = Ln), rn.close(mt), Nt;
        }, writeFile: (Ye, qe, Nt = {}) => {
          Nt.flags = Nt.flags || 577;
          var mt = rn.open(Ye, Nt.flags, Nt.mode);
          if (typeof qe == "string") {
            var pn = new Uint8Array(ve(qe) + 1), Mt = Ee(qe, pn, 0, pn.length);
            rn.write(mt, pn, 0, Mt, void 0, Nt.canOwn);
          } else if (ArrayBuffer.isView(qe))
            rn.write(mt, qe, 0, qe.byteLength, void 0, Nt.canOwn);
          else
            throw new Error("Unsupported data type");
          rn.close(mt);
        }, cwd: () => rn.currentPath, chdir: (Ye) => {
          var qe = rn.lookupPath(Ye, { follow: !0 });
          if (qe.node === null)
            throw new rn.ErrnoError(44);
          if (!rn.isDir(qe.node.mode))
            throw new rn.ErrnoError(54);
          var Nt = rn.nodePermissions(qe.node, "x");
          if (Nt)
            throw new rn.ErrnoError(Nt);
          rn.currentPath = qe.path;
        }, createDefaultDirectories: () => {
          rn.mkdir("/tmp"), rn.mkdir("/home"), rn.mkdir("/home/web_user");
        }, createDefaultDevices: () => {
          rn.mkdir("/dev"), rn.registerDevice(rn.makedev(1, 3), { read: () => 0, write: (qe, Nt, mt, pn, Mt) => pn }), rn.mkdev("/dev/null", rn.makedev(1, 3)), Ds.register(rn.makedev(5, 0), Ds.default_tty_ops), Ds.register(rn.makedev(6, 0), Ds.default_tty1_ops), rn.mkdev("/dev/tty", rn.makedev(5, 0)), rn.mkdev("/dev/tty1", rn.makedev(6, 0));
          var Ye = vt();
          rn.createDevice("/dev", "random", Ye), rn.createDevice("/dev", "urandom", Ye), rn.mkdir("/dev/shm"), rn.mkdir("/dev/shm/tmp");
        }, createSpecialDirectories: () => {
          rn.mkdir("/proc");
          var Ye = rn.mkdir("/proc/self");
          rn.mkdir("/proc/self/fd"), rn.mount({ mount: () => {
            var qe = rn.createNode(Ye, "fd", 16895, 73);
            return qe.node_ops = { lookup: (Nt, mt) => {
              var pn = +mt, Mt = rn.getStream(pn);
              if (!Mt)
                throw new rn.ErrnoError(8);
              var Ln = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => Mt.path } };
              return Ln.parent = Ln, Ln;
            } }, qe;
          } }, {}, "/proc/self/fd");
        }, createStandardStreams: () => {
          l.stdin ? rn.createDevice("/dev", "stdin", l.stdin) : rn.symlink("/dev/tty", "/dev/stdin"), l.stdout ? rn.createDevice("/dev", "stdout", null, l.stdout) : rn.symlink("/dev/tty", "/dev/stdout"), l.stderr ? rn.createDevice("/dev", "stderr", null, l.stderr) : rn.symlink("/dev/tty1", "/dev/stderr"), rn.open("/dev/stdin", 0), rn.open("/dev/stdout", 1), rn.open("/dev/stderr", 1);
        }, ensureErrnoError: () => {
          rn.ErrnoError || (rn.ErrnoError = function(qe, Nt) {
            this.node = Nt, this.setErrno = function(mt) {
              this.errno = mt;
            }, this.setErrno(qe), this.message = "FS error";
          }, rn.ErrnoError.prototype = new Error(), rn.ErrnoError.prototype.constructor = rn.ErrnoError, [44].forEach((Ye) => {
            rn.genericErrors[Ye] = new rn.ErrnoError(Ye), rn.genericErrors[Ye].stack = "<generic error, no stack>";
          }));
        }, staticInit: () => {
          rn.ensureErrnoError(), rn.nameTable = new Array(4096), rn.mount(Xr, {}, "/"), rn.createDefaultDirectories(), rn.createDefaultDevices(), rn.createSpecialDirectories(), rn.filesystems = { MEMFS: Xr };
        }, init: (Ye, qe, Nt) => {
          rn.init.initialized = !0, rn.ensureErrnoError(), l.stdin = Ye || l.stdin, l.stdout = qe || l.stdout, l.stderr = Nt || l.stderr, rn.createStandardStreams();
        }, quit: () => {
          rn.init.initialized = !1;
          for (var Ye = 0; Ye < rn.streams.length; Ye++) {
            var qe = rn.streams[Ye];
            qe && rn.close(qe);
          }
        }, getMode: (Ye, qe) => {
          var Nt = 0;
          return Ye && (Nt |= 365), qe && (Nt |= 146), Nt;
        }, findObject: (Ye, qe) => {
          var Nt = rn.analyzePath(Ye, qe);
          return Nt.exists ? Nt.object : null;
        }, analyzePath: (Ye, qe) => {
          try {
            var Nt = rn.lookupPath(Ye, { follow: !qe });
            Ye = Nt.path;
          } catch {
          }
          var mt = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
          try {
            var Nt = rn.lookupPath(Ye, { parent: !0 });
            mt.parentExists = !0, mt.parentPath = Nt.path, mt.parentObject = Nt.node, mt.name = sr.basename(Ye), Nt = rn.lookupPath(Ye, { follow: !qe }), mt.exists = !0, mt.path = Nt.path, mt.object = Nt.node, mt.name = Nt.node.name, mt.isRoot = Nt.path === "/";
          } catch (pn) {
            mt.error = pn.errno;
          }
          return mt;
        }, createPath: (Ye, qe, Nt, mt) => {
          Ye = typeof Ye == "string" ? Ye : rn.getPath(Ye);
          for (var pn = qe.split("/").reverse(); pn.length; ) {
            var Mt = pn.pop();
            if (Mt) {
              var Ln = sr.join2(Ye, Mt);
              try {
                rn.mkdir(Ln);
              } catch {
              }
              Ye = Ln;
            }
          }
          return Ln;
        }, createFile: (Ye, qe, Nt, mt, pn) => {
          var Mt = sr.join2(typeof Ye == "string" ? Ye : rn.getPath(Ye), qe), Ln = rn.getMode(mt, pn);
          return rn.create(Mt, Ln);
        }, createDataFile: (Ye, qe, Nt, mt, pn, Mt) => {
          var Ln = qe;
          Ye && (Ye = typeof Ye == "string" ? Ye : rn.getPath(Ye), Ln = qe ? sr.join2(Ye, qe) : Ye);
          var ot = rn.getMode(mt, pn), Xt = rn.create(Ln, ot);
          if (Nt) {
            if (typeof Nt == "string") {
              for (var sn = new Array(Nt.length), dn = 0, Ar = Nt.length; dn < Ar; ++dn)
                sn[dn] = Nt.charCodeAt(dn);
              Nt = sn;
            }
            rn.chmod(Xt, ot | 146);
            var yr = rn.open(Xt, 577);
            rn.write(yr, Nt, 0, Nt.length, 0, Mt), rn.close(yr), rn.chmod(Xt, ot);
          }
          return Xt;
        }, createDevice: (Ye, qe, Nt, mt) => {
          var pn = sr.join2(typeof Ye == "string" ? Ye : rn.getPath(Ye), qe), Mt = rn.getMode(!!Nt, !!mt);
          rn.createDevice.major || (rn.createDevice.major = 64);
          var Ln = rn.makedev(rn.createDevice.major++, 0);
          return rn.registerDevice(Ln, { open: (ot) => {
            ot.seekable = !1;
          }, close: (ot) => {
            mt && mt.buffer && mt.buffer.length && mt(10);
          }, read: (ot, Xt, sn, dn, Ar) => {
            for (var yr = 0, Pr = 0; Pr < dn; Pr++) {
              var Zr;
              try {
                Zr = Nt();
              } catch {
                throw new rn.ErrnoError(29);
              }
              if (Zr === void 0 && yr === 0)
                throw new rn.ErrnoError(6);
              if (Zr == null)
                break;
              yr++, Xt[sn + Pr] = Zr;
            }
            return yr && (ot.node.timestamp = Date.now()), yr;
          }, write: (ot, Xt, sn, dn, Ar) => {
            for (var yr = 0; yr < dn; yr++)
              try {
                mt(Xt[sn + yr]);
              } catch {
                throw new rn.ErrnoError(29);
              }
            return dn && (ot.node.timestamp = Date.now()), yr;
          } }), rn.mkdev(pn, Mt, Ln);
        }, forceLoadFile: (Ye) => {
          if (Ye.isDevice || Ye.isFolder || Ye.link || Ye.contents)
            return !0;
          if (typeof XMLHttpRequest < "u")
            throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
          if (R)
            try {
              Ye.contents = Qs(R(Ye.url), !0), Ye.usedBytes = Ye.contents.length;
            } catch {
              throw new rn.ErrnoError(29);
            }
          else
            throw new Error("Cannot load without read() or XMLHttpRequest.");
        }, createLazyFile: (Ye, qe, Nt, mt, pn) => {
          function Mt() {
            this.lengthKnown = !1, this.chunks = [];
          }
          if (Mt.prototype.get = function(Pr) {
            if (!(Pr > this.length - 1 || Pr < 0)) {
              var Zr = Pr % this.chunkSize, qs = Pr / this.chunkSize | 0;
              return this.getter(qs)[Zr];
            }
          }, Mt.prototype.setDataGetter = function(Pr) {
            this.getter = Pr;
          }, Mt.prototype.cacheLength = function() {
            var Pr = new XMLHttpRequest();
            if (Pr.open("HEAD", Nt, !1), Pr.send(null), !(Pr.status >= 200 && Pr.status < 300 || Pr.status === 304))
              throw new Error("Couldn't load " + Nt + ". Status: " + Pr.status);
            var Zr = Number(Pr.getResponseHeader("Content-length")), qs, Ws = (qs = Pr.getResponseHeader("Accept-Ranges")) && qs === "bytes", Bs = (qs = Pr.getResponseHeader("Content-Encoding")) && qs === "gzip", Sr = 1024 * 1024;
            Ws || (Sr = Zr);
            var Wr = (uo, Vs) => {
              if (uo > Vs)
                throw new Error("invalid range (" + uo + ", " + Vs + ") or no bytes requested!");
              if (Vs > Zr - 1)
                throw new Error("only " + Zr + " bytes available! programmer error!");
              var Gs = new XMLHttpRequest();
              if (Gs.open("GET", Nt, !1), Zr !== Sr && Gs.setRequestHeader("Range", "bytes=" + uo + "-" + Vs), Gs.responseType = "arraybuffer", Gs.overrideMimeType && Gs.overrideMimeType("text/plain; charset=x-user-defined"), Gs.send(null), !(Gs.status >= 200 && Gs.status < 300 || Gs.status === 304))
                throw new Error("Couldn't load " + Nt + ". Status: " + Gs.status);
              return Gs.response !== void 0 ? new Uint8Array(Gs.response || []) : Qs(Gs.responseText || "", !0);
            }, lo = this;
            lo.setDataGetter((uo) => {
              var Vs = uo * Sr, Gs = (uo + 1) * Sr - 1;
              if (Gs = Math.min(Gs, Zr - 1), typeof lo.chunks[uo] > "u" && (lo.chunks[uo] = Wr(Vs, Gs)), typeof lo.chunks[uo] > "u")
                throw new Error("doXHR failed!");
              return lo.chunks[uo];
            }), (Bs || !Zr) && (Sr = Zr = 1, Zr = this.getter(0).length, Sr = Zr, L("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Zr, this._chunkSize = Sr, this.lengthKnown = !0;
          }, typeof XMLHttpRequest < "u") {
            throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
            var Ln, ot;
          } else
            var ot = { isDevice: !1, url: Nt };
          var Xt = rn.createFile(Ye, qe, ot, mt, pn);
          ot.contents ? Xt.contents = ot.contents : ot.url && (Xt.contents = null, Xt.url = ot.url), Object.defineProperties(Xt, { usedBytes: { get: function() {
            return this.contents.length;
          } } });
          var sn = {}, dn = Object.keys(Xt.stream_ops);
          dn.forEach((yr) => {
            var Pr = Xt.stream_ops[yr];
            sn[yr] = function() {
              return rn.forceLoadFile(Xt), Pr.apply(null, arguments);
            };
          });
          function Ar(yr, Pr, Zr, qs, Ws) {
            var Bs = yr.node.contents;
            if (Ws >= Bs.length)
              return 0;
            var Sr = Math.min(Bs.length - Ws, qs);
            if (Bs.slice)
              for (var Wr = 0; Wr < Sr; Wr++)
                Pr[Zr + Wr] = Bs[Ws + Wr];
            else
              for (var Wr = 0; Wr < Sr; Wr++)
                Pr[Zr + Wr] = Bs.get(Ws + Wr);
            return Sr;
          }
          return sn.read = (yr, Pr, Zr, qs, Ws) => (rn.forceLoadFile(Xt), Ar(yr, Pr, Zr, qs, Ws)), sn.mmap = (yr, Pr, Zr, qs, Ws) => {
            rn.forceLoadFile(Xt);
            var Bs = Hs();
            if (!Bs)
              throw new rn.ErrnoError(48);
            return Ar(yr, te, Bs, Pr, Zr), { ptr: Bs, allocated: !0 };
          }, Xt.stream_ops = sn, Xt;
        }, createPreloadedFile: (Ye, qe, Nt, mt, pn, Mt, Ln, ot, Xt, sn) => {
          var dn = qe ? Jr.resolve(sr.join2(Ye, qe)) : Ye;
          function Ar(yr) {
            function Pr(Zr) {
              sn && sn(), ot || rn.createDataFile(Ye, qe, Zr, mt, pn, Xt), Mt && Mt(), Zt();
            }
            Browser.handledByPreloadPlugin(yr, dn, Pr, () => {
              Ln && Ln(), Zt();
            }) || Pr(yr);
          }
          lt(), typeof Nt == "string" ? bi(Nt, (yr) => Ar(yr), Ln) : Ar(Nt);
        }, indexedDB: () => window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB, DB_NAME: () => "EM_FS_" + window.location.pathname, DB_VERSION: 20, DB_STORE_NAME: "FILE_DATA", saveFilesToDB: (Ye, qe = () => {
        }, Nt = () => {
        }) => {
          var mt = rn.indexedDB();
          try {
            var pn = mt.open(rn.DB_NAME(), rn.DB_VERSION);
          } catch (Mt) {
            return Nt(Mt);
          }
          pn.onupgradeneeded = () => {
            L("creating db");
            var Mt = pn.result;
            Mt.createObjectStore(rn.DB_STORE_NAME);
          }, pn.onsuccess = () => {
            var Mt = pn.result, Ln = Mt.transaction([rn.DB_STORE_NAME], "readwrite"), ot = Ln.objectStore(rn.DB_STORE_NAME), Xt = 0, sn = 0, dn = Ye.length;
            function Ar() {
              sn == 0 ? qe() : Nt();
            }
            Ye.forEach((yr) => {
              var Pr = ot.put(rn.analyzePath(yr).object.contents, yr);
              Pr.onsuccess = () => {
                Xt++, Xt + sn == dn && Ar();
              }, Pr.onerror = () => {
                sn++, Xt + sn == dn && Ar();
              };
            }), Ln.onerror = Nt;
          }, pn.onerror = Nt;
        }, loadFilesFromDB: (Ye, qe = () => {
        }, Nt = () => {
        }) => {
          var mt = rn.indexedDB();
          try {
            var pn = mt.open(rn.DB_NAME(), rn.DB_VERSION);
          } catch (Mt) {
            return Nt(Mt);
          }
          pn.onupgradeneeded = Nt, pn.onsuccess = () => {
            var Mt = pn.result;
            try {
              var Ln = Mt.transaction([rn.DB_STORE_NAME], "readonly");
            } catch (yr) {
              Nt(yr);
              return;
            }
            var ot = Ln.objectStore(rn.DB_STORE_NAME), Xt = 0, sn = 0, dn = Ye.length;
            function Ar() {
              sn == 0 ? qe() : Nt();
            }
            Ye.forEach((yr) => {
              var Pr = ot.get(yr);
              Pr.onsuccess = () => {
                rn.analyzePath(yr).exists && rn.unlink(yr), rn.createDataFile(sr.dirname(yr), sr.basename(yr), Pr.result, !0, !0, !0), Xt++, Xt + sn == dn && Ar();
              }, Pr.onerror = () => {
                sn++, Xt + sn == dn && Ar();
              };
            }), Ln.onerror = Nt;
          }, pn.onerror = Nt;
        } }, mo = { DEFAULT_POLLMASK: 5, calculateAt: function(Ye, qe, Nt) {
          if (sr.isAbs(qe))
            return qe;
          var mt;
          if (Ye === -100)
            mt = rn.cwd();
          else {
            var pn = mo.getStreamFromFD(Ye);
            mt = pn.path;
          }
          if (qe.length == 0) {
            if (!Nt)
              throw new rn.ErrnoError(44);
            return mt;
          }
          return sr.join2(mt, qe);
        }, doStat: function(Ye, qe, Nt) {
          try {
            var mt = Ye(qe);
          } catch (ot) {
            if (ot && ot.node && sr.normalize(qe) !== sr.normalize(rn.getPath(ot.node)))
              return -54;
            throw ot;
          }
          De[Nt >>> 2] = mt.dev, De[Nt + 8 >>> 2] = mt.ino, De[Nt + 12 >>> 2] = mt.mode, be[Nt + 16 >>> 2] = mt.nlink, De[Nt + 20 >>> 2] = mt.uid, De[Nt + 24 >>> 2] = mt.gid, De[Nt + 28 >>> 2] = mt.rdev, ht = [mt.size >>> 0, (It = mt.size, +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[Nt + 40 >>> 2] = ht[0], De[Nt + 44 >>> 2] = ht[1], De[Nt + 48 >>> 2] = 4096, De[Nt + 52 >>> 2] = mt.blocks;
          var pn = mt.atime.getTime(), Mt = mt.mtime.getTime(), Ln = mt.ctime.getTime();
          return ht = [Math.floor(pn / 1e3) >>> 0, (It = Math.floor(pn / 1e3), +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[Nt + 56 >>> 2] = ht[0], De[Nt + 60 >>> 2] = ht[1], be[Nt + 64 >>> 2] = pn % 1e3 * 1e3, ht = [Math.floor(Mt / 1e3) >>> 0, (It = Math.floor(Mt / 1e3), +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[Nt + 72 >>> 2] = ht[0], De[Nt + 76 >>> 2] = ht[1], be[Nt + 80 >>> 2] = Mt % 1e3 * 1e3, ht = [Math.floor(Ln / 1e3) >>> 0, (It = Math.floor(Ln / 1e3), +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[Nt + 88 >>> 2] = ht[0], De[Nt + 92 >>> 2] = ht[1], be[Nt + 96 >>> 2] = Ln % 1e3 * 1e3, ht = [mt.ino >>> 0, (It = mt.ino, +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[Nt + 104 >>> 2] = ht[0], De[Nt + 108 >>> 2] = ht[1], 0;
        }, doMsync: function(Ye, qe, Nt, mt, pn) {
          if (!rn.isFile(qe.node.mode))
            throw new rn.ErrnoError(43);
          if (mt & 2)
            return 0;
          Ye >>>= 0;
          var Mt = ae.slice(Ye, Ye + Nt);
          rn.msync(qe, Mt, pn, Nt, mt);
        }, varargs: void 0, get: function() {
          mo.varargs += 4;
          var Ye = De[mo.varargs - 4 >>> 2];
          return Ye;
        }, getStr: function(Ye) {
          var qe = Fe(Ye);
          return qe;
        }, getStreamFromFD: function(Ye) {
          var qe = rn.getStream(Ye);
          if (!qe)
            throw new rn.ErrnoError(8);
          return qe;
        } };
        function Gi(Ye, qe) {
          var Nt = 0;
          return ao().forEach(function(mt, pn) {
            var Mt = qe + Nt;
            be[Ye + pn * 4 >>> 2] = Mt, Gt(mt, Mt), Nt += mt.length + 1;
          }), 0;
        }
        function yo(Ye, qe) {
          var Nt = ao();
          be[Ye >>> 2] = Nt.length;
          var mt = 0;
          return Nt.forEach(function(pn) {
            mt += pn.length + 1;
          }), be[qe >>> 2] = mt, 0;
        }
        function ci(Ye) {
          try {
            var qe = mo.getStreamFromFD(Ye);
            return rn.close(qe), 0;
          } catch (Nt) {
            if (typeof rn > "u" || !(Nt instanceof rn.ErrnoError))
              throw Nt;
            return Nt.errno;
          }
        }
        function Ri(Ye, qe, Nt, mt) {
          for (var pn = 0, Mt = 0; Mt < Nt; Mt++) {
            var Ln = be[qe >>> 2], ot = be[qe + 4 >>> 2];
            qe += 8;
            var Xt = rn.read(Ye, te, Ln, ot, mt);
            if (Xt < 0)
              return -1;
            if (pn += Xt, Xt < ot)
              break;
            typeof mt < "u" && (mt += Xt);
          }
          return pn;
        }
        function ms(Ye, qe, Nt, mt) {
          try {
            var pn = mo.getStreamFromFD(Ye), Mt = Ri(pn, qe, Nt);
            return be[mt >>> 2] = Mt, 0;
          } catch (Ln) {
            if (typeof rn > "u" || !(Ln instanceof rn.ErrnoError))
              throw Ln;
            return Ln.errno;
          }
        }
        function zt(Ye, qe) {
          return qe + 2097152 >>> 0 < 4194305 - !!Ye ? (Ye >>> 0) + qe * 4294967296 : NaN;
        }
        function fn(Ye, qe, Nt, mt, pn) {
          try {
            var Mt = zt(qe, Nt);
            if (isNaN(Mt))
              return 61;
            var Ln = mo.getStreamFromFD(Ye);
            return rn.llseek(Ln, Mt, mt), ht = [Ln.position >>> 0, (It = Ln.position, +Math.abs(It) >= 1 ? It > 0 ? (Math.min(+Math.floor(It / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((It - +(~~It >>> 0)) / 4294967296) >>> 0 : 0)], De[pn >>> 2] = ht[0], De[pn + 4 >>> 2] = ht[1], Ln.getdents && Mt === 0 && mt === 0 && (Ln.getdents = null), 0;
          } catch (ot) {
            if (typeof rn > "u" || !(ot instanceof rn.ErrnoError))
              throw ot;
            return ot.errno;
          }
        }
        function Bn(Ye, qe, Nt, mt) {
          for (var pn = 0, Mt = 0; Mt < Nt; Mt++) {
            var Ln = be[qe >>> 2], ot = be[qe + 4 >>> 2];
            qe += 8;
            var Xt = rn.write(Ye, te, Ln, ot, mt);
            if (Xt < 0)
              return -1;
            pn += Xt, typeof mt < "u" && (mt += Xt);
          }
          return pn;
        }
        function or(Ye, qe, Nt, mt) {
          try {
            var pn = mo.getStreamFromFD(Ye), Mt = Bn(pn, qe, Nt);
            return be[mt >>> 2] = Mt, 0;
          } catch (Ln) {
            if (typeof rn > "u" || !(Ln instanceof rn.ErrnoError))
              throw Ln;
            return Ln.errno;
          }
        }
        function ss(Ye) {
          return Ye % 4 === 0 && (Ye % 100 !== 0 || Ye % 400 === 0);
        }
        function Xs(Ye, qe) {
          for (var Nt = 0, mt = 0; mt <= qe; Nt += Ye[mt++])
            ;
          return Nt;
        }
        var Fo = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ji = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function zo(Ye, qe) {
          for (var Nt = new Date(Ye.getTime()); qe > 0; ) {
            var mt = ss(Nt.getFullYear()), pn = Nt.getMonth(), Mt = (mt ? Fo : ji)[pn];
            if (qe > Mt - Nt.getDate())
              qe -= Mt - Nt.getDate() + 1, Nt.setDate(1), pn < 11 ? Nt.setMonth(pn + 1) : (Nt.setMonth(0), Nt.setFullYear(Nt.getFullYear() + 1));
            else
              return Nt.setDate(Nt.getDate() + qe), Nt;
          }
          return Nt;
        }
        function Yi(Ye, qe) {
          te.set(Ye, qe >>> 0);
        }
        function Li(Ye, qe, Nt, mt) {
          var pn = De[mt + 40 >>> 2], Mt = { tm_sec: De[mt >>> 2], tm_min: De[mt + 4 >>> 2], tm_hour: De[mt + 8 >>> 2], tm_mday: De[mt + 12 >>> 2], tm_mon: De[mt + 16 >>> 2], tm_year: De[mt + 20 >>> 2], tm_wday: De[mt + 24 >>> 2], tm_yday: De[mt + 28 >>> 2], tm_isdst: De[mt + 32 >>> 2], tm_gmtoff: De[mt + 36 >>> 2], tm_zone: pn ? Fe(pn) : "" }, Ln = Fe(Nt), ot = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
          for (var Xt in ot)
            Ln = Ln.replace(new RegExp(Xt, "g"), ot[Xt]);
          var sn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          function Ar(Sr, Wr, lo) {
            for (var uo = typeof Sr == "number" ? Sr.toString() : Sr || ""; uo.length < Wr; )
              uo = lo[0] + uo;
            return uo;
          }
          function yr(Sr, Wr) {
            return Ar(Sr, Wr, "0");
          }
          function Pr(Sr, Wr) {
            function lo(Vs) {
              return Vs < 0 ? -1 : Vs > 0 ? 1 : 0;
            }
            var uo;
            return (uo = lo(Sr.getFullYear() - Wr.getFullYear())) === 0 && (uo = lo(Sr.getMonth() - Wr.getMonth())) === 0 && (uo = lo(Sr.getDate() - Wr.getDate())), uo;
          }
          function Zr(Sr) {
            switch (Sr.getDay()) {
              case 0:
                return new Date(Sr.getFullYear() - 1, 11, 29);
              case 1:
                return Sr;
              case 2:
                return new Date(Sr.getFullYear(), 0, 3);
              case 3:
                return new Date(Sr.getFullYear(), 0, 2);
              case 4:
                return new Date(Sr.getFullYear(), 0, 1);
              case 5:
                return new Date(Sr.getFullYear() - 1, 11, 31);
              case 6:
                return new Date(Sr.getFullYear() - 1, 11, 30);
            }
          }
          function qs(Sr) {
            var Wr = zo(new Date(Sr.tm_year + 1900, 0, 1), Sr.tm_yday), lo = new Date(Wr.getFullYear(), 0, 4), uo = new Date(Wr.getFullYear() + 1, 0, 4), Vs = Zr(lo), Gs = Zr(uo);
            return Pr(Vs, Wr) <= 0 ? Pr(Gs, Wr) <= 0 ? Wr.getFullYear() + 1 : Wr.getFullYear() : Wr.getFullYear() - 1;
          }
          var Ws = { "%a": function(Sr) {
            return sn[Sr.tm_wday].substring(0, 3);
          }, "%A": function(Sr) {
            return sn[Sr.tm_wday];
          }, "%b": function(Sr) {
            return dn[Sr.tm_mon].substring(0, 3);
          }, "%B": function(Sr) {
            return dn[Sr.tm_mon];
          }, "%C": function(Sr) {
            var Wr = Sr.tm_year + 1900;
            return yr(Wr / 100 | 0, 2);
          }, "%d": function(Sr) {
            return yr(Sr.tm_mday, 2);
          }, "%e": function(Sr) {
            return Ar(Sr.tm_mday, 2, " ");
          }, "%g": function(Sr) {
            return qs(Sr).toString().substring(2);
          }, "%G": function(Sr) {
            return qs(Sr);
          }, "%H": function(Sr) {
            return yr(Sr.tm_hour, 2);
          }, "%I": function(Sr) {
            var Wr = Sr.tm_hour;
            return Wr == 0 ? Wr = 12 : Wr > 12 && (Wr -= 12), yr(Wr, 2);
          }, "%j": function(Sr) {
            return yr(Sr.tm_mday + Xs(ss(Sr.tm_year + 1900) ? Fo : ji, Sr.tm_mon - 1), 3);
          }, "%m": function(Sr) {
            return yr(Sr.tm_mon + 1, 2);
          }, "%M": function(Sr) {
            return yr(Sr.tm_min, 2);
          }, "%n": function() {
            return `
`;
          }, "%p": function(Sr) {
            return Sr.tm_hour >= 0 && Sr.tm_hour < 12 ? "AM" : "PM";
          }, "%S": function(Sr) {
            return yr(Sr.tm_sec, 2);
          }, "%t": function() {
            return "	";
          }, "%u": function(Sr) {
            return Sr.tm_wday || 7;
          }, "%U": function(Sr) {
            var Wr = Sr.tm_yday + 7 - Sr.tm_wday;
            return yr(Math.floor(Wr / 7), 2);
          }, "%V": function(Sr) {
            var Wr = Math.floor((Sr.tm_yday + 7 - (Sr.tm_wday + 6) % 7) / 7);
            if ((Sr.tm_wday + 371 - Sr.tm_yday - 2) % 7 <= 2 && Wr++, Wr) {
              if (Wr == 53) {
                var uo = (Sr.tm_wday + 371 - Sr.tm_yday) % 7;
                uo != 4 && (uo != 3 || !ss(Sr.tm_year)) && (Wr = 1);
              }
            } else {
              Wr = 52;
              var lo = (Sr.tm_wday + 7 - Sr.tm_yday - 1) % 7;
              (lo == 4 || lo == 5 && ss(Sr.tm_year % 400 - 1)) && Wr++;
            }
            return yr(Wr, 2);
          }, "%w": function(Sr) {
            return Sr.tm_wday;
          }, "%W": function(Sr) {
            var Wr = Sr.tm_yday + 7 - (Sr.tm_wday + 6) % 7;
            return yr(Math.floor(Wr / 7), 2);
          }, "%y": function(Sr) {
            return (Sr.tm_year + 1900).toString().substring(2);
          }, "%Y": function(Sr) {
            return Sr.tm_year + 1900;
          }, "%z": function(Sr) {
            var Wr = Sr.tm_gmtoff, lo = Wr >= 0;
            return Wr = Math.abs(Wr) / 60, Wr = Wr / 60 * 100 + Wr % 60, (lo ? "+" : "-") + ("0000" + Wr).slice(-4);
          }, "%Z": function(Sr) {
            return Sr.tm_zone;
          }, "%%": function() {
            return "%";
          } };
          Ln = Ln.replace(/%%/g, "\0\0");
          for (var Xt in Ws)
            Ln.includes(Xt) && (Ln = Ln.replace(new RegExp(Xt, "g"), Ws[Xt](Mt)));
          Ln = Ln.replace(/\0\0/g, "%");
          var Bs = Qs(Ln, !1);
          return Bs.length > qe ? 0 : (Yi(Bs, Ye), Bs.length - 1);
        }
        function _i(Ye, qe, Nt, mt, pn) {
          return Li(Ye, qe, Nt, mt);
        }
        Gn = l.InternalError = cs(Error, "InternalError"), ls(), Fr = l.BindingError = cs(Error, "BindingError"), Io(), us(), Mn(), as = l.UnboundTypeError = cs(Error, "UnboundTypeError"), fr();
        var pa = function(Ye, qe, Nt, mt) {
          Ye || (Ye = this), this.parent = Ye, this.mount = Ye.mount, this.mounted = null, this.id = rn.nextInode++, this.name = qe, this.mode = Nt, this.node_ops = {}, this.stream_ops = {}, this.rdev = mt;
        }, $o = 365, wo = 146;
        Object.defineProperties(pa.prototype, { read: { get: function() {
          return (this.mode & $o) === $o;
        }, set: function(Ye) {
          Ye ? this.mode |= $o : this.mode &= ~$o;
        } }, write: { get: function() {
          return (this.mode & wo) === wo;
        }, set: function(Ye) {
          Ye ? this.mode |= wo : this.mode &= ~wo;
        } }, isFolder: { get: function() {
          return rn.isDir(this.mode);
        } }, isDevice: { get: function() {
          return rn.isChrdev(this.mode);
        } } }), rn.FSNode = pa, rn.staticInit();
        var Ks = { g: Vt, S: rr, q: Ss, G: is, Q: ns, p: jo, o: Ps, b: no, P: Nr, C: Ro, t: Rs, A: Vo, c: oa, s: Po, i: ai, B: Wo, w: ri, T: Wi, l: To, r: ia, e: bo, R: Ys, k: Di, v: Lo, a: xs, y: hi, h: Zo, n: li, E: ei, x: Or, D: ui, U: _s, f: xo, u: aa, j: oo, m: vs, d: yi, z: $r, O: ki, M: Co, I: Gi, J: yo, K: ci, L: ms, F: fn, N: or, H: _i };
        Cn();
        var Qo = function() {
          return (Qo = l.asm.Y).apply(null, arguments);
        }, pi = l.___getTypeName = function() {
          return (pi = l.___getTypeName = l.asm.Z).apply(null, arguments);
        };
        l.__embind_initialize_bindings = function() {
          return (l.__embind_initialize_bindings = l.asm._).apply(null, arguments);
        };
        var Ns = function() {
          return (Ns = l.asm.$).apply(null, arguments);
        }, Fi = function() {
          return (Fi = l.asm.aa).apply(null, arguments);
        };
        l.dynCall_jiji = function() {
          return (l.dynCall_jiji = l.asm.ba).apply(null, arguments);
        }, l.dynCall_viijii = function() {
          return (l.dynCall_viijii = l.asm.ca).apply(null, arguments);
        }, l.dynCall_iiiiij = function() {
          return (l.dynCall_iiiiij = l.asm.da).apply(null, arguments);
        }, l.dynCall_iiiiijj = function() {
          return (l.dynCall_iiiiijj = l.asm.ea).apply(null, arguments);
        }, l.dynCall_iiiiiijj = function() {
          return (l.dynCall_iiiiiijj = l.asm.fa).apply(null, arguments);
        };
        var la;
        st = function Ye() {
          la || Ho(), la || (st = Ye);
        };
        function Ho() {
          if (Ct > 0 || (Ht(), Ct > 0))
            return;
          function Ye() {
            la || (la = !0, l.calledRun = !0, !q && (Bt(), u(l), l.onRuntimeInitialized && l.onRuntimeInitialized(), ut()));
          }
          l.setStatus ? (l.setStatus("Running..."), setTimeout(function() {
            setTimeout(function() {
              l.setStatus("");
            }, 1), Ye();
          }, 1)) : Ye();
        }
        if (l.preInit)
          for (typeof l.preInit == "function" && (l.preInit = [l.preInit]); l.preInit.length > 0; )
            l.preInit.pop()();
        return Ho(), a.ready;
      };
    })();
    typeof r == "object" && typeof e == "object" ? e.exports = s : typeof define == "function" && define.amd ? define([], function() {
      return s;
    }) : typeof r == "object" && (r.WebIFCWasm = s);
  }
}), IFCGEOSLICE = 1971632696, IFCGEOMODEL = 2680139844, IFCELECTRICFLOWTREATMENTDEVICE = 24726584, IFCDISTRIBUTIONBOARD = 3693000487, IFCCONVEYORSEGMENT = 3460952963, IFCCAISSONFOUNDATION = 3999819293, IFCBOREHOLE = 3314249567, IFCBEARING = 4196446775, IFCALIGNMENT = 325726236, IFCTRACKELEMENT = 3425753595, IFCSIGNAL = 991950508, IFCREINFORCEDSOIL = 3798194928, IFCRAIL = 3290496277, IFCPAVEMENT = 1383356374, IFCNAVIGATIONELEMENT = 2182337498, IFCMOORINGDEVICE = 234836483, IFCMOBILETELECOMMUNICATIONSAPPLIANCE = 2078563270, IFCLIQUIDTERMINAL = 1638804497, IFCLINEARPOSITIONINGELEMENT = 1154579445, IFCKERB = 2696325953, IFCGEOTECHNICALASSEMBLY = 2713699986, IFCELECTRICFLOWTREATMENTDEVICETYPE = 2142170206, IFCEARTHWORKSFILL = 3376911765, IFCEARTHWORKSELEMENT = 1077100507, IFCEARTHWORKSCUT = 3071239417, IFCDISTRIBUTIONBOARDTYPE = 479945903, IFCDEEPFOUNDATION = 3426335179, IFCCOURSE = 1502416096, IFCCONVEYORSEGMENTTYPE = 2940368186, IFCCAISSONFOUNDATIONTYPE = 3203706013, IFCBUILTSYSTEM = 3862327254, IFCBUILTELEMENT = 1876633798, IFCBRIDGEPART = 963979645, IFCBRIDGE = 644574406, IFCBEARINGTYPE = 3649138523, IFCALIGNMENTVERTICAL = 1662888072, IFCALIGNMENTSEGMENT = 317615605, IFCALIGNMENTHORIZONTAL = 1545765605, IFCALIGNMENTCANT = 4266260250, IFCVIBRATIONDAMPERTYPE = 3956297820, IFCVIBRATIONDAMPER = 1530820697, IFCVEHICLE = 840318589, IFCTRANSPORTATIONDEVICE = 1953115116, IFCTRACKELEMENTTYPE = 618700268, IFCTENDONCONDUITTYPE = 2281632017, IFCTENDONCONDUIT = 3663046924, IFCSINESPIRAL = 42703149, IFCSIGNALTYPE = 1894708472, IFCSIGNTYPE = 3599934289, IFCSIGN = 33720170, IFCSEVENTHORDERPOLYNOMIALSPIRAL = 1027922057, IFCSEGMENTEDREFERENCECURVE = 544395925, IFCSECONDORDERPOLYNOMIALSPIRAL = 3649235739, IFCROADPART = 550521510, IFCROAD = 146592293, IFCRELADHERESTOELEMENT = 3818125796, IFCREFERENT = 4021432810, IFCRAILWAYPART = 1891881377, IFCRAILWAY = 3992365140, IFCRAILTYPE = 1763565496, IFCPOSITIONINGELEMENT = 1946335990, IFCPAVEMENTTYPE = 514975943, IFCNAVIGATIONELEMENTTYPE = 506776471, IFCMOORINGDEVICETYPE = 710110818, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE = 1950438474, IFCMARINEPART = 976884017, IFCMARINEFACILITY = 525669439, IFCLIQUIDTERMINALTYPE = 1770583370, IFCLINEARELEMENT = 2176059722, IFCKERBTYPE = 679976338, IFCIMPACTPROTECTIONDEVICETYPE = 3948183225, IFCIMPACTPROTECTIONDEVICE = 2568555532, IFCGRADIENTCURVE = 2898700619, IFCGEOTECHNICALSTRATUM = 1594536857, IFCGEOTECHNICALELEMENT = 4230923436, IFCFACILITYPARTCOMMON = 4228831410, IFCFACILITYPART = 1310830890, IFCFACILITY = 24185140, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID = 4234616927, IFCDEEPFOUNDATIONTYPE = 1306400036, IFCCOURSETYPE = 4189326743, IFCCOSINESPIRAL = 2000195564, IFCCLOTHOID = 3497074424, IFCBUILTELEMENTTYPE = 1626504194, IFCVEHICLETYPE = 3651464721, IFCTRIANGULATEDIRREGULARNETWORK = 1229763772, IFCTRANSPORTATIONDEVICETYPE = 3665877780, IFCTHIRDORDERPOLYNOMIALSPIRAL = 782932809, IFCSPIRAL = 2735484536, IFCSECTIONEDSURFACE = 1356537516, IFCSECTIONEDSOLIDHORIZONTAL = 1290935644, IFCSECTIONEDSOLID = 1862484736, IFCRELPOSITIONS = 1441486842, IFCRELASSOCIATESPROFILEDEF = 1033248425, IFCPOLYNOMIALCURVE = 3381221214, IFCOFFSETCURVEBYDISTANCES = 2485787929, IFCOFFSETCURVE = 590820931, IFCINDEXEDPOLYGONALTEXTUREMAP = 3465909080, IFCDIRECTRIXCURVESWEPTAREASOLID = 593015953, IFCCURVESEGMENT = 4212018352, IFCAXIS2PLACEMENTLINEAR = 3425423356, IFCSEGMENT = 823603102, IFCPOINTBYDISTANCEEXPRESSION = 2165702409, IFCOPENCROSSPROFILEDEF = 182550632, IFCLINEARPLACEMENT = 388784114, IFCALIGNMENTHORIZONTALSEGMENT = 536804194, IFCALIGNMENTCANTSEGMENT = 3752311538, IFCTEXTURECOORDINATEINDICESWITHVOIDS = 1010789467, IFCTEXTURECOORDINATEINDICES = 222769930, IFCQUANTITYNUMBER = 2691318326, IFCALIGNMENTVERTICALSEGMENT = 3633395639, IFCCONTROLLER = 25142252, IFCALARM = 3087945054, IFCACTUATOR = 4288193352, IFCUNITARYCONTROLELEMENT = 630975310, IFCSENSOR = 4086658281, IFCPROTECTIVEDEVICETRIPPINGUNIT = 2295281155, IFCFLOWINSTRUMENT = 182646315, IFCFIRESUPPRESSIONTERMINAL = 1426591983, IFCFILTER = 819412036, IFCFAN = 3415622556, IFCELECTRICTIMECONTROL = 1003880860, IFCELECTRICMOTOR = 402227799, IFCELECTRICGENERATOR = 264262732, IFCELECTRICFLOWSTORAGEDEVICE = 3310460725, IFCELECTRICDISTRIBUTIONBOARD = 862014818, IFCELECTRICAPPLIANCE = 1904799276, IFCDUCTSILENCER = 1360408905, IFCDUCTSEGMENT = 3518393246, IFCDUCTFITTING = 342316401, IFCDISTRIBUTIONCIRCUIT = 562808652, IFCDAMPER = 4074379575, IFCCOOLINGTOWER = 3640358203, IFCCOOLEDBEAM = 4136498852, IFCCONDENSER = 2272882330, IFCCOMPRESSOR = 3571504051, IFCCOMMUNICATIONSAPPLIANCE = 3221913625, IFCCOIL = 639361253, IFCCHILLER = 3902619387, IFCCABLESEGMENT = 4217484030, IFCCABLEFITTING = 1051757585, IFCCABLECARRIERSEGMENT = 3758799889, IFCCABLECARRIERFITTING = 635142910, IFCBURNER = 2938176219, IFCBOILER = 32344328, IFCBEAMSTANDARDCASE = 2906023776, IFCAUDIOVISUALAPPLIANCE = 277319702, IFCAIRTOAIRHEATRECOVERY = 2056796094, IFCAIRTERMINALBOX = 177149247, IFCAIRTERMINAL = 1634111441, IFCWINDOWSTANDARDCASE = 486154966, IFCWASTETERMINAL = 4237592921, IFCWALLELEMENTEDCASE = 4156078855, IFCVALVE = 4207607924, IFCUNITARYEQUIPMENT = 4292641817, IFCUNITARYCONTROLELEMENTTYPE = 3179687236, IFCTUBEBUNDLE = 3026737570, IFCTRANSFORMER = 3825984169, IFCTANK = 812556717, IFCSWITCHINGDEVICE = 1162798199, IFCSTRUCTURALLOADCASE = 385403989, IFCSTACKTERMINAL = 1404847402, IFCSPACEHEATER = 1999602285, IFCSOLARDEVICE = 3420628829, IFCSLABSTANDARDCASE = 3027962421, IFCSLABELEMENTEDCASE = 3127900445, IFCSHADINGDEVICE = 1329646415, IFCSANITARYTERMINAL = 3053780830, IFCREINFORCINGBARTYPE = 2572171363, IFCRATIONALBSPLINECURVEWITHKNOTS = 1232101972, IFCPUMP = 90941305, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE = 655969474, IFCPROTECTIVEDEVICE = 738039164, IFCPLATESTANDARDCASE = 1156407060, IFCPIPESEGMENT = 3612865200, IFCPIPEFITTING = 310824031, IFCOUTLET = 3694346114, IFCOUTERBOUNDARYCURVE = 144952367, IFCMOTORCONNECTION = 2474470126, IFCMEMBERSTANDARDCASE = 1911478936, IFCMEDICALDEVICE = 1437502449, IFCLIGHTFIXTURE = 629592764, IFCLAMP = 76236018, IFCJUNCTIONBOX = 2176052936, IFCINTERCEPTOR = 4175244083, IFCHUMIDIFIER = 2068733104, IFCHEATEXCHANGER = 3319311131, IFCFLOWMETER = 2188021234, IFCEXTERNALSPATIALELEMENT = 1209101575, IFCEVAPORATOR = 484807127, IFCEVAPORATIVECOOLER = 3747195512, IFCENGINE = 2814081492, IFCELECTRICDISTRIBUTIONBOARDTYPE = 2417008758, IFCDOORSTANDARDCASE = 3242481149, IFCDISTRIBUTIONSYSTEM = 3205830791, IFCCOMMUNICATIONSAPPLIANCETYPE = 400855858, IFCCOLUMNSTANDARDCASE = 905975707, IFCCIVILELEMENT = 1677625105, IFCCHIMNEY = 3296154744, IFCCABLEFITTINGTYPE = 2674252688, IFCBURNERTYPE = 2188180465, IFCBUILDINGSYSTEM = 1177604601, IFCBUILDINGELEMENTPARTTYPE = 39481116, IFCBOUNDARYCURVE = 1136057603, IFCBSPLINECURVEWITHKNOTS = 2461110595, IFCAUDIOVISUALAPPLIANCETYPE = 1532957894, IFCWORKCALENDAR = 4088093105, IFCWINDOWTYPE = 4009809668, IFCVOIDINGFEATURE = 926996030, IFCVIBRATIONISOLATOR = 2391383451, IFCTENDONTYPE = 2415094496, IFCTENDONANCHORTYPE = 3081323446, IFCSYSTEMFURNITUREELEMENT = 413509423, IFCSURFACEFEATURE = 3101698114, IFCSTRUCTURALSURFACEACTION = 3657597509, IFCSTRUCTURALCURVEREACTION = 2757150158, IFCSTRUCTURALCURVEACTION = 1004757350, IFCSTAIRTYPE = 338393293, IFCSOLARDEVICETYPE = 1072016465, IFCSHADINGDEVICETYPE = 4074543187, IFCSEAMCURVE = 2157484638, IFCROOFTYPE = 2781568857, IFCREINFORCINGMESHTYPE = 2310774935, IFCREINFORCINGELEMENTTYPE = 964333572, IFCRATIONALBSPLINESURFACEWITHKNOTS = 683857671, IFCRAMPTYPE = 1469900589, IFCPOLYGONALFACESET = 2839578677, IFCPILETYPE = 1158309216, IFCOPENINGSTANDARDCASE = 3079942009, IFCMEDICALDEVICETYPE = 1114901282, IFCINTERSECTIONCURVE = 3113134337, IFCINTERCEPTORTYPE = 3946677679, IFCINDEXEDPOLYCURVE = 2571569899, IFCGEOGRAPHICELEMENT = 3493046030, IFCFURNITURE = 1509553395, IFCFOOTINGTYPE = 1893162501, IFCEXTERNALSPATIALSTRUCTUREELEMENT = 2853485674, IFCEVENT = 4148101412, IFCENGINETYPE = 132023988, IFCELEMENTASSEMBLYTYPE = 2397081782, IFCDOORTYPE = 2323601079, IFCCYLINDRICALSURFACE = 1213902940, IFCCONSTRUCTIONPRODUCTRESOURCETYPE = 1525564444, IFCCONSTRUCTIONMATERIALRESOURCETYPE = 4105962743, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE = 2185764099, IFCCOMPOSITECURVEONSURFACE = 15328376, IFCCOMPLEXPROPERTYTEMPLATE = 3875453745, IFCCIVILELEMENTTYPE = 3893394355, IFCCHIMNEYTYPE = 2197970202, IFCBSPLINESURFACEWITHKNOTS = 167062518, IFCBSPLINESURFACE = 2887950389, IFCADVANCEDBREPWITHVOIDS = 2603310189, IFCADVANCEDBREP = 1635779807, IFCTRIANGULATEDFACESET = 2916149573, IFCTOROIDALSURFACE = 1935646853, IFCTESSELLATEDFACESET = 2387106220, IFCTASKTYPE = 3206491090, IFCSURFACECURVE = 699246055, IFCSUBCONTRACTRESOURCETYPE = 4095615324, IFCSTRUCTURALSURFACEREACTION = 603775116, IFCSPHERICALSURFACE = 4015995234, IFCSPATIALZONETYPE = 2481509218, IFCSPATIALZONE = 463610769, IFCSPATIALELEMENTTYPE = 710998568, IFCSPATIALELEMENT = 1412071761, IFCSIMPLEPROPERTYTEMPLATE = 3663146110, IFCREVOLVEDAREASOLIDTAPERED = 3243963512, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT = 816062949, IFCRELSPACEBOUNDARY2NDLEVEL = 1521410863, IFCRELSPACEBOUNDARY1STLEVEL = 3523091289, IFCRELINTERFERESELEMENTS = 427948657, IFCRELDEFINESBYTEMPLATE = 307848117, IFCRELDEFINESBYOBJECT = 1462361463, IFCRELDECLARES = 2565941209, IFCRELASSIGNSTOGROUPBYFACTOR = 1027710054, IFCPROPERTYTEMPLATE = 3521284610, IFCPROPERTYSETTEMPLATE = 492091185, IFCPROJECTLIBRARY = 653396225, IFCPROCEDURETYPE = 569719735, IFCPREDEFINEDPROPERTYSET = 3967405729, IFCPCURVE = 1682466193, IFCLABORRESOURCETYPE = 428585644, IFCINDEXEDPOLYGONALFACEWITHVOIDS = 2294589976, IFCINDEXEDPOLYGONALFACE = 178912537, IFCGEOGRAPHICELEMENTTYPE = 4095422895, IFCFIXEDREFERENCESWEPTAREASOLID = 2652556860, IFCEXTRUDEDAREASOLIDTAPERED = 2804161546, IFCEVENTTYPE = 4024345920, IFCCURVEBOUNDEDSURFACE = 2629017746, IFCCREWRESOURCETYPE = 1815067380, IFCCONTEXT = 3419103109, IFCCONSTRUCTIONRESOURCETYPE = 2574617495, IFCCARTESIANPOINTLIST3D = 2059837836, IFCCARTESIANPOINTLIST2D = 1675464909, IFCCARTESIANPOINTLIST = 574549367, IFCADVANCEDFACE = 3406155212, IFCTYPERESOURCE = 3698973494, IFCTYPEPROCESS = 3736923433, IFCTESSELLATEDITEM = 901063453, IFCSWEPTDISKSOLIDPOLYGONAL = 1096409881, IFCRESOURCETIME = 1042787934, IFCRESOURCECONSTRAINTRELATIONSHIP = 1608871552, IFCRESOURCEAPPROVALRELATIONSHIP = 2943643501, IFCQUANTITYSET = 2090586900, IFCPROPERTYTEMPLATEDEFINITION = 1482703590, IFCPREDEFINEDPROPERTIES = 3778827333, IFCMIRROREDPROFILEDEF = 2998442950, IFCMATERIALRELATIONSHIP = 853536259, IFCMATERIALPROFILESETUSAGETAPERING = 3404854881, IFCMATERIALPROFILESETUSAGE = 3079605661, IFCMATERIALCONSTITUENTSET = 2852063980, IFCMATERIALCONSTITUENT = 3708119e3, IFCLAGTIME = 1585845231, IFCINDEXEDTRIANGLETEXTUREMAP = 2133299955, IFCINDEXEDTEXTUREMAP = 1437953363, IFCINDEXEDCOLOURMAP = 3570813810, IFCEXTERNALREFERENCERELATIONSHIP = 1437805879, IFCEXTENDEDPROPERTIES = 297599258, IFCEVENTTIME = 211053100, IFCCONVERSIONBASEDUNITWITHOFFSET = 2713554722, IFCCOLOURRGBLIST = 3285139300, IFCWORKTIME = 1236880293, IFCTEXTUREVERTEXLIST = 3611470254, IFCTASKTIMERECURRING = 2771591690, IFCTASKTIME = 1549132990, IFCSURFACEREINFORCEMENTAREA = 2934153892, IFCSTRUCTURALLOADORRESULT = 609421318, IFCSTRUCTURALLOADCONFIGURATION = 3478079324, IFCPROJECTEDCRS = 3843373140, IFCMATERIALPROFILEWITHOFFSETS = 552965576, IFCMATERIALPROFILESET = 164193824, IFCMATERIALPROFILE = 2235152071, IFCMATERIALLAYERWITHOFFSETS = 1847252529, IFCMAPCONVERSION = 3057273783, IFCCOORDINATEOPERATION = 1785450214, IFCCONNECTIONVOLUMEGEOMETRY = 775493141, IFCREINFORCINGBAR = 979691226, IFCELECTRICDISTRIBUTIONPOINT = 3700593921, IFCDISTRIBUTIONCONTROLELEMENT = 1062813311, IFCDISTRIBUTIONCHAMBERELEMENT = 1052013943, IFCCONTROLLERTYPE = 578613899, IFCCHAMFEREDGEFEATURE = 2454782716, IFCBEAM = 753842376, IFCALARMTYPE = 3001207471, IFCACTUATORTYPE = 2874132201, IFCWINDOW = 3304561284, IFCWALLSTANDARDCASE = 3512223829, IFCWALL = 2391406946, IFCVIBRATIONISOLATORTYPE = 3313531582, IFCTENDONANCHOR = 2347447852, IFCTENDON = 3824725483, IFCSTRUCTURALANALYSISMODEL = 2515109513, IFCSTAIRFLIGHT = 4252922144, IFCSTAIR = 331165859, IFCSLAB = 1529196076, IFCSENSORTYPE = 1783015770, IFCROUNDEDEDGEFEATURE = 1376911519, IFCROOF = 2016517767, IFCREINFORCINGMESH = 2320036040, IFCREINFORCINGELEMENT = 3027567501, IFCRATIONALBEZIERCURVE = 3055160366, IFCRAMPFLIGHT = 3283111854, IFCRAMP = 3024970846, IFCRAILING = 2262370178, IFCPLATE = 3171933400, IFCPILE = 1687234759, IFCMEMBER = 1073191201, IFCFOOTING = 900683007, IFCFLOWTREATMENTDEVICE = 3508470533, IFCFLOWTERMINAL = 2223149337, IFCFLOWSTORAGEDEVICE = 707683696, IFCFLOWSEGMENT = 987401354, IFCFLOWMOVINGDEVICE = 3132237377, IFCFLOWINSTRUMENTTYPE = 4037862832, IFCFLOWFITTING = 4278956645, IFCFLOWCONTROLLER = 2058353004, IFCFIRESUPPRESSIONTERMINALTYPE = 4222183408, IFCFILTERTYPE = 1810631287, IFCFANTYPE = 346874300, IFCENERGYCONVERSIONDEVICE = 1658829314, IFCELECTRICALELEMENT = 857184966, IFCELECTRICALCIRCUIT = 1634875225, IFCELECTRICTIMECONTROLTYPE = 712377611, IFCELECTRICMOTORTYPE = 1217240411, IFCELECTRICHEATERTYPE = 1365060375, IFCELECTRICGENERATORTYPE = 1534661035, IFCELECTRICFLOWSTORAGEDEVICETYPE = 3277789161, IFCELECTRICAPPLIANCETYPE = 663422040, IFCEDGEFEATURE = 855621170, IFCDUCTSILENCERTYPE = 2030761528, IFCDUCTSEGMENTTYPE = 3760055223, IFCDUCTFITTINGTYPE = 869906466, IFCDOOR = 395920057, IFCDISTRIBUTIONPORT = 3041715199, IFCDISTRIBUTIONFLOWELEMENT = 3040386961, IFCDISTRIBUTIONELEMENT = 1945004755, IFCDISTRIBUTIONCONTROLELEMENTTYPE = 2063403501, IFCDISTRIBUTIONCHAMBERELEMENTTYPE = 1599208980, IFCDISCRETEACCESSORYTYPE = 2635815018, IFCDISCRETEACCESSORY = 1335981549, IFCDIAMETERDIMENSION = 4147604152, IFCDAMPERTYPE = 3961806047, IFCCURTAINWALL = 3495092785, IFCCOVERING = 1973544240, IFCCOOLINGTOWERTYPE = 2954562838, IFCCOOLEDBEAMTYPE = 335055490, IFCCONSTRUCTIONPRODUCTRESOURCE = 488727124, IFCCONSTRUCTIONMATERIALRESOURCE = 1060000209, IFCCONSTRUCTIONEQUIPMENTRESOURCE = 3898045240, IFCCONDITIONCRITERION = 1163958913, IFCCONDITION = 2188551683, IFCCONDENSERTYPE = 2816379211, IFCCOMPRESSORTYPE = 3850581409, IFCCOLUMN = 843113511, IFCCOILTYPE = 2301859152, IFCCIRCLE = 2611217952, IFCCHILLERTYPE = 2951183804, IFCCABLESEGMENTTYPE = 1285652485, IFCCABLECARRIERSEGMENTTYPE = 3293546465, IFCCABLECARRIERFITTINGTYPE = 395041908, IFCBUILDINGELEMENTPROXYTYPE = 1909888760, IFCBUILDINGELEMENTPROXY = 1095909175, IFCBUILDINGELEMENTPART = 2979338954, IFCBUILDINGELEMENTCOMPONENT = 52481810, IFCBUILDINGELEMENT = 3299480353, IFCBOILERTYPE = 231477066, IFCBEZIERCURVE = 1916977116, IFCBEAMTYPE = 819618141, IFCBSPLINECURVE = 1967976161, IFCASSET = 3460190687, IFCANGULARDIMENSION = 2470393545, IFCAIRTOAIRHEATRECOVERYTYPE = 1871374353, IFCAIRTERMINALTYPE = 3352864051, IFCAIRTERMINALBOXTYPE = 1411407467, IFCACTIONREQUEST = 3821786052, IFC2DCOMPOSITECURVE = 1213861670, IFCZONE = 1033361043, IFCWORKSCHEDULE = 3342526732, IFCWORKPLAN = 4218914973, IFCWORKCONTROL = 1028945134, IFCWASTETERMINALTYPE = 1133259667, IFCWALLTYPE = 1898987631, IFCVIRTUALELEMENT = 2769231204, IFCVALVETYPE = 728799441, IFCUNITARYEQUIPMENTTYPE = 1911125066, IFCTUBEBUNDLETYPE = 1600972822, IFCTRIMMEDCURVE = 3593883385, IFCTRANSPORTELEMENT = 1620046519, IFCTRANSFORMERTYPE = 1692211062, IFCTIMESERIESSCHEDULE = 1637806684, IFCTANKTYPE = 5716631, IFCSYSTEM = 2254336722, IFCSWITCHINGDEVICETYPE = 2315554128, IFCSUBCONTRACTRESOURCE = 148013059, IFCSTRUCTURALSURFACECONNECTION = 1975003073, IFCSTRUCTURALRESULTGROUP = 2986769608, IFCSTRUCTURALPOINTREACTION = 1235345126, IFCSTRUCTURALPOINTCONNECTION = 734778138, IFCSTRUCTURALPOINTACTION = 2082059205, IFCSTRUCTURALPLANARACTIONVARYING = 3987759626, IFCSTRUCTURALPLANARACTION = 1621171031, IFCSTRUCTURALLOADGROUP = 1252848954, IFCSTRUCTURALLINEARACTIONVARYING = 1721250024, IFCSTRUCTURALLINEARACTION = 1807405624, IFCSTRUCTURALCURVEMEMBERVARYING = 2445595289, IFCSTRUCTURALCURVEMEMBER = 214636428, IFCSTRUCTURALCURVECONNECTION = 4243806635, IFCSTRUCTURALCONNECTION = 1179482911, IFCSTRUCTURALACTION = 682877961, IFCSTAIRFLIGHTTYPE = 1039846685, IFCSTACKTERMINALTYPE = 3112655638, IFCSPACETYPE = 3812236995, IFCSPACEPROGRAM = 652456506, IFCSPACEHEATERTYPE = 1305183839, IFCSPACE = 3856911033, IFCSLABTYPE = 2533589738, IFCSITE = 4097777520, IFCSERVICELIFE = 4105383287, IFCSCHEDULETIMECONTROL = 3517283431, IFCSANITARYTERMINALTYPE = 1768891740, IFCRELASSIGNSTASKS = 2863920197, IFCRELAGGREGATES = 160246688, IFCRAMPFLIGHTTYPE = 2324767716, IFCRAILINGTYPE = 2893384427, IFCRADIUSDIMENSION = 3248260540, IFCPUMPTYPE = 2250791053, IFCPROTECTIVEDEVICETYPE = 1842657554, IFCPROJECTIONELEMENT = 3651124850, IFCPROJECTORDERRECORD = 3642467123, IFCPROJECTORDER = 2904328755, IFCPROCEDURE = 2744685151, IFCPORT = 3740093272, IFCPOLYLINE = 3724593414, IFCPLATETYPE = 4017108033, IFCPIPESEGMENTTYPE = 4231323485, IFCPIPEFITTINGTYPE = 804291784, IFCPERMIT = 3327091369, IFCPERFORMANCEHISTORY = 2382730787, IFCOUTLETTYPE = 2837617999, IFCORDERACTION = 3425660407, IFCOPENINGELEMENT = 3588315303, IFCOCCUPANT = 4143007308, IFCMOVE = 1916936684, IFCMOTORCONNECTIONTYPE = 977012517, IFCMEMBERTYPE = 3181161470, IFCMECHANICALFASTENERTYPE = 2108223431, IFCMECHANICALFASTENER = 377706215, IFCLINEARDIMENSION = 2506943328, IFCLIGHTFIXTURETYPE = 1161773419, IFCLAMPTYPE = 1051575348, IFCLABORRESOURCE = 3827777499, IFCJUNCTIONBOXTYPE = 4288270099, IFCINVENTORY = 2391368822, IFCHUMIDIFIERTYPE = 1806887404, IFCHEATEXCHANGERTYPE = 1251058090, IFCGROUP = 2706460486, IFCGRID = 3009204131, IFCGASTERMINALTYPE = 200128114, IFCFURNITURESTANDARD = 814719939, IFCFURNISHINGELEMENT = 263784265, IFCFLOWTREATMENTDEVICETYPE = 3009222698, IFCFLOWTERMINALTYPE = 2297155007, IFCFLOWSTORAGEDEVICETYPE = 1339347760, IFCFLOWSEGMENTTYPE = 1834744321, IFCFLOWMOVINGDEVICETYPE = 1482959167, IFCFLOWMETERTYPE = 3815607619, IFCFLOWFITTINGTYPE = 3198132628, IFCFLOWCONTROLLERTYPE = 3907093117, IFCFEATUREELEMENTSUBTRACTION = 1287392070, IFCFEATUREELEMENTADDITION = 2143335405, IFCFEATUREELEMENT = 2827207264, IFCFASTENERTYPE = 2489546625, IFCFASTENER = 647756555, IFCFACETEDBREPWITHVOIDS = 3737207727, IFCFACETEDBREP = 807026263, IFCEVAPORATORTYPE = 3390157468, IFCEVAPORATIVECOOLERTYPE = 3174744832, IFCEQUIPMENTSTANDARD = 3272907226, IFCEQUIPMENTELEMENT = 1962604670, IFCENERGYCONVERSIONDEVICETYPE = 2107101300, IFCELLIPSE = 1704287377, IFCELEMENTCOMPONENTTYPE = 2590856083, IFCELEMENTCOMPONENT = 1623761950, IFCELEMENTASSEMBLY = 4123344466, IFCELEMENT = 1758889154, IFCELECTRICALBASEPROPERTIES = 360485395, IFCDISTRIBUTIONFLOWELEMENTTYPE = 3849074793, IFCDISTRIBUTIONELEMENTTYPE = 3256556792, IFCDIMENSIONCURVEDIRECTEDCALLOUT = 681481545, IFCCURTAINWALLTYPE = 1457835157, IFCCREWRESOURCE = 3295246426, IFCCOVERINGTYPE = 1916426348, IFCCOSTSCHEDULE = 1419761937, IFCCOSTITEM = 3895139033, IFCCONTROL = 3293443760, IFCCONSTRUCTIONRESOURCE = 2559216714, IFCCONIC = 2510884976, IFCCOMPOSITECURVE = 3732776249, IFCCOLUMNTYPE = 300633059, IFCCIRCLEHOLLOWPROFILEDEF = 2937912522, IFCBUILDINGSTOREY = 3124254112, IFCBUILDINGELEMENTTYPE = 1950629157, IFCBUILDING = 4031249490, IFCBOUNDEDCURVE = 1260505505, IFCBOOLEANCLIPPINGRESULT = 3649129432, IFCBLOCK = 1334484129, IFCASYMMETRICISHAPEPROFILEDEF = 3207858831, IFCANNOTATION = 1674181508, IFCACTOR = 2296667514, IFCTRANSPORTELEMENTTYPE = 2097647324, IFCTASK = 3473067441, IFCSYSTEMFURNITUREELEMENTTYPE = 1580310250, IFCSURFACEOFREVOLUTION = 4124788165, IFCSURFACEOFLINEAREXTRUSION = 2809605785, IFCSURFACECURVESWEPTAREASOLID = 2028607225, IFCSTRUCTUREDDIMENSIONCALLOUT = 4070609034, IFCSTRUCTURALSURFACEMEMBERVARYING = 2218152070, IFCSTRUCTURALSURFACEMEMBER = 3979015343, IFCSTRUCTURALREACTION = 3689010777, IFCSTRUCTURALMEMBER = 530289379, IFCSTRUCTURALITEM = 3136571912, IFCSTRUCTURALACTIVITY = 3544373492, IFCSPHERE = 451544542, IFCSPATIALSTRUCTUREELEMENTTYPE = 3893378262, IFCSPATIALSTRUCTUREELEMENT = 2706606064, IFCRIGHTCIRCULARCYLINDER = 3626867408, IFCRIGHTCIRCULARCONE = 4158566097, IFCREVOLVEDAREASOLID = 1856042241, IFCRESOURCE = 2914609552, IFCRELVOIDSELEMENT = 1401173127, IFCRELSPACEBOUNDARY = 3451746338, IFCRELSERVICESBUILDINGS = 366585022, IFCRELSEQUENCE = 4122056220, IFCRELSCHEDULESCOSTITEMS = 1058617721, IFCRELREFERENCEDINSPATIALSTRUCTURE = 1245217292, IFCRELPROJECTSELEMENT = 750771296, IFCRELOVERRIDESPROPERTIES = 202636808, IFCRELOCCUPIESSPACES = 2051452291, IFCRELNESTS = 3268803585, IFCRELINTERACTIONREQUIREMENTS = 4189434867, IFCRELFLOWCONTROLELEMENTS = 279856033, IFCRELFILLSELEMENT = 3940055652, IFCRELDEFINESBYTYPE = 781010003, IFCRELDEFINESBYPROPERTIES = 4186316022, IFCRELDEFINES = 693640335, IFCRELDECOMPOSES = 2551354335, IFCRELCOVERSSPACES = 2802773753, IFCRELCOVERSBLDGELEMENTS = 886880790, IFCRELCONTAINEDINSPATIALSTRUCTURE = 3242617779, IFCRELCONNECTSWITHREALIZINGELEMENTS = 3678494232, IFCRELCONNECTSWITHECCENTRICITY = 504942748, IFCRELCONNECTSSTRUCTURALMEMBER = 1638771189, IFCRELCONNECTSSTRUCTURALELEMENT = 3912681535, IFCRELCONNECTSSTRUCTURALACTIVITY = 2127690289, IFCRELCONNECTSPORTS = 3190031847, IFCRELCONNECTSPORTTOELEMENT = 4201705270, IFCRELCONNECTSPATHELEMENTS = 3945020480, IFCRELCONNECTSELEMENTS = 1204542856, IFCRELCONNECTS = 826625072, IFCRELASSOCIATESPROFILEPROPERTIES = 2851387026, IFCRELASSOCIATESMATERIAL = 2655215786, IFCRELASSOCIATESLIBRARY = 3840914261, IFCRELASSOCIATESDOCUMENT = 982818633, IFCRELASSOCIATESCONSTRAINT = 2728634034, IFCRELASSOCIATESCLASSIFICATION = 919958153, IFCRELASSOCIATESAPPROVAL = 4095574036, IFCRELASSOCIATESAPPLIEDVALUE = 1327628568, IFCRELASSOCIATES = 1865459582, IFCRELASSIGNSTORESOURCE = 205026976, IFCRELASSIGNSTOPROJECTORDER = 3372526763, IFCRELASSIGNSTOPRODUCT = 2857406711, IFCRELASSIGNSTOPROCESS = 4278684876, IFCRELASSIGNSTOGROUP = 1307041759, IFCRELASSIGNSTOCONTROL = 2495723537, IFCRELASSIGNSTOACTOR = 1683148259, IFCRELASSIGNS = 3939117080, IFCRECTANGULARTRIMMEDSURFACE = 3454111270, IFCRECTANGULARPYRAMID = 2798486643, IFCRECTANGLEHOLLOWPROFILEDEF = 2770003689, IFCPROXY = 3219374653, IFCPROPERTYSET = 1451395588, IFCPROJECTIONCURVE = 4194566429, IFCPROJECT = 103090709, IFCPRODUCT = 4208778838, IFCPROCESS = 2945172077, IFCPLANE = 220341763, IFCPLANARBOX = 603570806, IFCPERMEABLECOVERINGPROPERTIES = 3566463478, IFCOFFSETCURVE3D = 3505215534, IFCOFFSETCURVE2D = 3388369263, IFCOBJECT = 3888040117, IFCMANIFOLDSOLIDBREP = 1425443689, IFCLINE = 1281925730, IFCLSHAPEPROFILEDEF = 572779678, IFCISHAPEPROFILEDEF = 1484403080, IFCGEOMETRICCURVESET = 987898635, IFCFURNITURETYPE = 1268542332, IFCFURNISHINGELEMENTTYPE = 4238390223, IFCFLUIDFLOWPROPERTIES = 3455213021, IFCFILLAREASTYLETILES = 315944413, IFCFILLAREASTYLETILESYMBOLWITHSTYLE = 4203026998, IFCFILLAREASTYLEHATCHING = 374418227, IFCFACEBASEDSURFACEMODEL = 2047409740, IFCEXTRUDEDAREASOLID = 477187591, IFCENERGYPROPERTIES = 80994333, IFCELLIPSEPROFILEDEF = 2835456948, IFCELEMENTARYSURFACE = 2777663545, IFCELEMENTTYPE = 339256511, IFCELEMENTQUANTITY = 1883228015, IFCEDGELOOP = 1472233963, IFCDRAUGHTINGPREDEFINEDCURVEFONT = 4006246654, IFCDRAUGHTINGPREDEFINEDCOLOUR = 445594917, IFCDRAUGHTINGCALLOUT = 3073041342, IFCDOORSTYLE = 526551008, IFCDOORPANELPROPERTIES = 1714330368, IFCDOORLININGPROPERTIES = 2963535650, IFCDIRECTION = 32440307, IFCDIMENSIONCURVETERMINATOR = 4054601972, IFCDIMENSIONCURVE = 606661476, IFCDEFINEDSYMBOL = 693772133, IFCCURVEBOUNDEDPLANE = 2827736869, IFCCURVE = 2601014836, IFCCSGSOLID = 2147822146, IFCCSGPRIMITIVE3D = 2506170314, IFCCRANERAILFSHAPEPROFILEDEF = 194851669, IFCCRANERAILASHAPEPROFILEDEF = 4133800736, IFCCOMPOSITECURVESEGMENT = 2485617015, IFCCLOSEDSHELL = 2205249479, IFCCIRCLEPROFILEDEF = 1383045692, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM = 1416205885, IFCCARTESIANTRANSFORMATIONOPERATOR3D = 3331915920, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM = 3486308946, IFCCARTESIANTRANSFORMATIONOPERATOR2D = 3749851601, IFCCARTESIANTRANSFORMATIONOPERATOR = 59481748, IFCCARTESIANPOINT = 1123145078, IFCCSHAPEPROFILEDEF = 2898889636, IFCBOXEDHALFSPACE = 2713105998, IFCBOUNDINGBOX = 2581212453, IFCBOUNDEDSURFACE = 4182860854, IFCBOOLEANRESULT = 2736907675, IFCAXIS2PLACEMENT3D = 2740243338, IFCAXIS2PLACEMENT2D = 3125803723, IFCAXIS1PLACEMENT = 4261334040, IFCANNOTATIONSURFACE = 1302238472, IFCANNOTATIONFILLAREAOCCURRENCE = 2265737646, IFCANNOTATIONFILLAREA = 669184980, IFCANNOTATIONCURVEOCCURRENCE = 3288037868, IFCZSHAPEPROFILEDEF = 2543172580, IFCWINDOWSTYLE = 1299126871, IFCWINDOWPANELPROPERTIES = 512836454, IFCWINDOWLININGPROPERTIES = 336235671, IFCVERTEXLOOP = 2759199220, IFCVECTOR = 1417489154, IFCUSHAPEPROFILEDEF = 427810014, IFCTYPEPRODUCT = 2347495698, IFCTYPEOBJECT = 1628702193, IFCTWODIRECTIONREPEATFACTOR = 1345879162, IFCTRAPEZIUMPROFILEDEF = 2715220739, IFCTEXTLITERALWITHEXTENT = 3124975700, IFCTEXTLITERAL = 4282788508, IFCTERMINATORSYMBOL = 3028897424, IFCTSHAPEPROFILEDEF = 3071757647, IFCSWEPTSURFACE = 230924584, IFCSWEPTDISKSOLID = 1260650574, IFCSWEPTAREASOLID = 2247615214, IFCSURFACESTYLERENDERING = 1878645084, IFCSURFACE = 2513912981, IFCSUBEDGE = 2233826070, IFCSTRUCTURALSTEELPROFILEPROPERTIES = 3653947884, IFCSTRUCTURALPROFILEPROPERTIES = 3843319758, IFCSTRUCTURALLOADSINGLEFORCEWARPING = 1190533807, IFCSTRUCTURALLOADSINGLEFORCE = 1597423693, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION = 1973038258, IFCSTRUCTURALLOADSINGLEDISPLACEMENT = 2473145415, IFCSTRUCTURALLOADPLANARFORCE = 2668620305, IFCSTRUCTURALLOADLINEARFORCE = 1595516126, IFCSPACETHERMALLOADPROPERTIES = 390701378, IFCSOUNDVALUE = 1202362311, IFCSOUNDPROPERTIES = 2485662743, IFCSOLIDMODEL = 723233188, IFCSLIPPAGECONNECTIONCONDITION = 2609359061, IFCSHELLBASEDSURFACEMODEL = 4124623270, IFCSERVICELIFEFACTOR = 2411513650, IFCSECTIONEDSPINE = 1509187699, IFCROUNDEDRECTANGLEPROFILEDEF = 2778083089, IFCRELATIONSHIP = 478536968, IFCREINFORCEMENTDEFINITIONPROPERTIES = 3765753017, IFCREGULARTIMESERIES = 3413951693, IFCRECTANGLEPROFILEDEF = 3615266464, IFCPROPERTYTABLEVALUE = 110355661, IFCPROPERTYSINGLEVALUE = 3650150729, IFCPROPERTYSETDEFINITION = 3357820518, IFCPROPERTYREFERENCEVALUE = 941946838, IFCPROPERTYLISTVALUE = 2752243245, IFCPROPERTYENUMERATEDVALUE = 4166981789, IFCPROPERTYDEFINITION = 1680319473, IFCPROPERTYBOUNDEDVALUE = 871118103, IFCPRODUCTDEFINITIONSHAPE = 673634403, IFCPREDEFINEDPOINTMARKERSYMBOL = 179317114, IFCPREDEFINEDDIMENSIONSYMBOL = 433424934, IFCPREDEFINEDCURVEFONT = 2559016684, IFCPREDEFINEDCOLOUR = 759155922, IFCPOLYGONALBOUNDEDHALFSPACE = 2775532180, IFCPOLYLOOP = 2924175390, IFCPOINTONSURFACE = 1423911732, IFCPOINTONCURVE = 4022376103, IFCPOINT = 2067069095, IFCPLANAREXTENT = 1663979128, IFCPLACEMENT = 2004835150, IFCPIXELTEXTURE = 597895409, IFCPHYSICALCOMPLEXQUANTITY = 3021840470, IFCPATH = 2519244187, IFCPARAMETERIZEDPROFILEDEF = 2529465313, IFCORIENTEDEDGE = 1029017970, IFCOPENSHELL = 2665983363, IFCONEDIRECTIONREPEATFACTOR = 2833995503, IFCOBJECTDEFINITION = 219451334, IFCMECHANICALCONCRETEMATERIALPROPERTIES = 1430189142, IFCMATERIALDEFINITIONREPRESENTATION = 2022407955, IFCMAPPEDITEM = 2347385850, IFCLOOP = 1008929658, IFCLOCALPLACEMENT = 2624227202, IFCLIGHTSOURCESPOT = 3422422726, IFCLIGHTSOURCEPOSITIONAL = 1520743889, IFCLIGHTSOURCEGONIOMETRIC = 4266656042, IFCLIGHTSOURCEDIRECTIONAL = 2604431987, IFCLIGHTSOURCEAMBIENT = 125510826, IFCLIGHTSOURCE = 1402838566, IFCIRREGULARTIMESERIES = 3741457305, IFCIMAGETEXTURE = 3905492369, IFCHYGROSCOPICMATERIALPROPERTIES = 2445078500, IFCHALFSPACESOLID = 812098782, IFCGRIDPLACEMENT = 178086475, IFCGEOMETRICSET = 3590301190, IFCGEOMETRICREPRESENTATIONSUBCONTEXT = 4142052618, IFCGEOMETRICREPRESENTATIONITEM = 2453401579, IFCGEOMETRICREPRESENTATIONCONTEXT = 3448662350, IFCGENERALPROFILEPROPERTIES = 1446786286, IFCGENERALMATERIALPROPERTIES = 803998398, IFCFUELPROPERTIES = 3857492461, IFCFILLAREASTYLE = 738692330, IFCFAILURECONNECTIONCONDITION = 4219587988, IFCFACESURFACE = 3008276851, IFCFACEOUTERBOUND = 803316827, IFCFACEBOUND = 1809719519, IFCFACE = 2556980723, IFCEXTENDEDMATERIALPROPERTIES = 1860660968, IFCEDGECURVE = 476780140, IFCEDGE = 3900360178, IFCDRAUGHTINGPREDEFINEDTEXTFONT = 4170525392, IFCDOCUMENTREFERENCE = 3732053477, IFCDIMENSIONPAIR = 1694125774, IFCDIMENSIONCALLOUTRELATIONSHIP = 2273265877, IFCDERIVEDPROFILEDEF = 3632507154, IFCCURVESTYLE = 3800577675, IFCCONVERSIONBASEDUNIT = 2889183280, IFCCONTEXTDEPENDENTUNIT = 3050246964, IFCCONNECTIONPOINTECCENTRICITY = 45288368, IFCCONNECTIONCURVEGEOMETRY = 1981873012, IFCCONNECTEDFACESET = 370225590, IFCCOMPOSITEPROFILEDEF = 1485152156, IFCCOMPLEXPROPERTY = 2542286263, IFCCOLOURRGB = 776857604, IFCCLASSIFICATIONREFERENCE = 647927063, IFCCENTERLINEPROFILEDEF = 3150382593, IFCBLOBTEXTURE = 616511568, IFCARBITRARYPROFILEDEFWITHVOIDS = 2705031697, IFCARBITRARYOPENPROFILEDEF = 1310608509, IFCARBITRARYCLOSEDPROFILEDEF = 3798115385, IFCANNOTATIONTEXTOCCURRENCE = 2297822566, IFCANNOTATIONSYMBOLOCCURRENCE = 3612888222, IFCANNOTATIONSURFACEOCCURRENCE = 962685235, IFCANNOTATIONOCCURRENCE = 2442683028, IFCWATERPROPERTIES = 1065908215, IFCVIRTUALGRIDINTERSECTION = 891718957, IFCVERTEXPOINT = 1907098498, IFCVERTEX = 2799835756, IFCTOPOLOGYREPRESENTATION = 1735638870, IFCTOPOLOGICALREPRESENTATIONITEM = 1377556343, IFCTIMESERIESREFERENCERELATIONSHIP = 1718945513, IFCTHERMALMATERIALPROPERTIES = 3317419933, IFCTEXTUREVERTEX = 1210645708, IFCTEXTUREMAP = 2552916305, IFCTEXTURECOORDINATEGENERATOR = 1742049831, IFCTEXTURECOORDINATE = 280115917, IFCTEXTSTYLETEXTMODEL = 1640371178, IFCTEXTSTYLEFORDEFINEDFONT = 2636378356, IFCTEXTSTYLEFONTMODEL = 1983826977, IFCTEXTSTYLE = 1447204868, IFCTELECOMADDRESS = 912023232, IFCTABLE = 985171141, IFCSYMBOLSTYLE = 1290481447, IFCSURFACETEXTURE = 626085974, IFCSURFACESTYLEWITHTEXTURES = 1351298697, IFCSURFACESTYLESHADING = 846575682, IFCSURFACESTYLEREFRACTION = 1607154358, IFCSURFACESTYLELIGHTING = 3303107099, IFCSURFACESTYLE = 1300840506, IFCSTYLEDREPRESENTATION = 3049322572, IFCSTYLEDITEM = 3958052878, IFCSTYLEMODEL = 2830218821, IFCSTRUCTURALLOADTEMPERATURE = 3408363356, IFCSTRUCTURALLOADSTATIC = 2525727697, IFCSIMPLEPROPERTY = 3692461612, IFCSHAPEREPRESENTATION = 4240577450, IFCSHAPEMODEL = 3982875396, IFCSHAPEASPECT = 867548509, IFCSECTIONREINFORCEMENTPROPERTIES = 4165799628, IFCSECTIONPROPERTIES = 2042790032, IFCSIUNIT = 448429030, IFCRIBPLATEPROFILEPROPERTIES = 3679540991, IFCREPRESENTATIONMAP = 1660063152, IFCREPRESENTATION = 1076942058, IFCREINFORCEMENTBARPROPERTIES = 1580146022, IFCREFERENCESVALUEDOCUMENT = 2692823254, IFCQUANTITYWEIGHT = 825690147, IFCQUANTITYVOLUME = 2405470396, IFCQUANTITYTIME = 3252649465, IFCQUANTITYLENGTH = 931644368, IFCQUANTITYCOUNT = 2093928680, IFCQUANTITYAREA = 2044713172, IFCPROPERTYENUMERATION = 3710013099, IFCPROPERTYDEPENDENCYRELATIONSHIP = 148025276, IFCPROPERTYCONSTRAINTRELATIONSHIP = 3896028662, IFCPROPERTY = 2598011224, IFCPROFILEPROPERTIES = 2802850158, IFCPRODUCTSOFCOMBUSTIONPROPERTIES = 2267347899, IFCPRODUCTREPRESENTATION = 2095639259, IFCPRESENTATIONLAYERWITHSTYLE = 1304840413, IFCPRESENTATIONLAYERASSIGNMENT = 2022622350, IFCPREDEFINEDTEXTFONT = 1775413392, IFCPREDEFINEDTERMINATORSYMBOL = 3213052703, IFCPREDEFINEDSYMBOL = 990879717, IFCPREDEFINEDITEM = 3727388367, IFCPOSTALADDRESS = 3355820592, IFCPHYSICALSIMPLEQUANTITY = 2226359599, IFCPERSONANDORGANIZATION = 101040310, IFCPERSON = 2077209135, IFCORGANIZATIONRELATIONSHIP = 1411181986, IFCORGANIZATION = 4251960020, IFCOPTICALMATERIALPROPERTIES = 1227763645, IFCOBJECTIVE = 2251480897, IFCOBJECTPLACEMENT = 3701648758, IFCMETRIC = 3368373690, IFCMECHANICALSTEELMATERIALPROPERTIES = 677618848, IFCMECHANICALMATERIALPROPERTIES = 4256014907, IFCMATERIALPROPERTIES = 3265635763, IFCMATERIALLIST = 2199411900, IFCMATERIALLAYERSETUSAGE = 1303795690, IFCMATERIALLAYERSET = 3303938423, IFCMATERIALLAYER = 248100487, IFCMATERIALCLASSIFICATIONRELATIONSHIP = 1847130766, IFCMATERIAL = 1838606355, IFCLIBRARYREFERENCE = 3452421091, IFCLIBRARYINFORMATION = 2655187982, IFCEXTERNALLYDEFINEDTEXTFONT = 3548104201, IFCEXTERNALLYDEFINEDSYMBOL = 3207319532, IFCEXTERNALLYDEFINEDSURFACESTYLE = 1040185647, IFCEXTERNALLYDEFINEDHATCHSTYLE = 2242383968, IFCENVIRONMENTALIMPACTVALUE = 1648886627, IFCDRAUGHTINGCALLOUTRELATIONSHIP = 3796139169, IFCDOCUMENTINFORMATIONRELATIONSHIP = 770865208, IFCDOCUMENTINFORMATION = 1154170062, IFCCURVESTYLEFONTPATTERN = 3510044353, IFCCURVESTYLEFONTANDSCALING = 2367409068, IFCCURVESTYLEFONT = 1105321065, IFCCURRENCYRELATIONSHIP = 539742890, IFCCOSTVALUE = 602808272, IFCCONSTRAINTRELATIONSHIP = 347226245, IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP = 613356794, IFCCONSTRAINTAGGREGATIONRELATIONSHIP = 1658513725, IFCCONNECTIONSURFACEGEOMETRY = 2732653382, IFCCONNECTIONPORTGEOMETRY = 4257277454, IFCCONNECTIONPOINTGEOMETRY = 2614616156, IFCCOLOURSPECIFICATION = 3264961684, IFCCLASSIFICATIONITEMRELATIONSHIP = 1098599126, IFCCLASSIFICATIONITEM = 1767535486, IFCCLASSIFICATION = 747523909, IFCBOUNDARYNODECONDITIONWARPING = 2069777674, IFCBOUNDARYNODECONDITION = 1387855156, IFCBOUNDARYFACECONDITION = 3367102660, IFCBOUNDARYEDGECONDITION = 1560379544, IFCAPPROVALRELATIONSHIP = 3869604511, IFCAPPROVALACTORRELATIONSHIP = 2080292479, IFCAPPLIEDVALUERELATIONSHIP = 1110488051, FILE_DESCRIPTION = 599546466, FILE_NAME = 1390159747, FILE_SCHEMA = 1109904537, Handle = class {
  constructor(r) {
    this.value = r, this.type = 5;
  }
}, IfcLineObject = class {
  constructor(r) {
    this.expressID = r, this.type = 0;
  }
}, FromRawLineData = [], InversePropertyDef = {}, InheritanceDef = {}, Constructors = {}, ToRawLineData = {}, TypeInitialisers = {}, SchemaNames = [];
function TypeInitialiser(r, e) {
  return Array.isArray(e) && e.map((s) => TypeInitialiser(r, s)), e.typecode ? TypeInitialisers[r][e.typecode](e.value) : e.value;
}
function Labelise(r) {
  return r.value = r.value.toString(), r.valueType = r.type, r.type = 2, r.label = r.constructor.name.toUpperCase(), r;
}
var Schemas;
(function(r) {
  r.IFC2X3 = "IFC2X3", r.IFC4 = "IFC4", r.IFC4X3 = "IFC4X3";
})(Schemas || (Schemas = {}));
SchemaNames[1] = ["IFC2X3", "IFC2X_FINAL"];
FromRawLineData[1] = {
  3630933823: (r, e) => new IFC2X3.IfcActorRole(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcText(e[2].value) : null),
  618182010: (r, e) => new IFC2X3.IfcAddress(r, e[0], e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  639542469: (r, e) => new IFC2X3.IfcApplication(r, new Handle(e[0].value), new IFC2X3.IfcLabel(e[1].value), new IFC2X3.IfcLabel(e[2].value), new IFC2X3.IfcIdentifier(e[3].value)),
  411424972: (r, e) => new IFC2X3.IfcAppliedValue(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null),
  1110488051: (r, e) => new IFC2X3.IfcAppliedValueRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? new IFC2X3.IfcText(e[4].value) : null),
  130549933: (r, e) => new IFC2X3.IfcApproval(r, e[0] ? new IFC2X3.IfcText(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? new IFC2X3.IfcText(e[4].value) : null, new IFC2X3.IfcLabel(e[5].value), new IFC2X3.IfcIdentifier(e[6].value)),
  2080292479: (r, e) => new IFC2X3.IfcApprovalActorRelationship(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value)),
  390851274: (r, e) => new IFC2X3.IfcApprovalPropertyRelationship(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value)),
  3869604511: (r, e) => new IFC2X3.IfcApprovalRelationship(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcText(e[2].value) : null, new IFC2X3.IfcLabel(e[3].value)),
  4037036970: (r, e) => new IFC2X3.IfcBoundaryCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  1560379544: (r, e) => new IFC2X3.IfcBoundaryEdgeCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(e[6].value) : null),
  3367102660: (r, e) => new IFC2X3.IfcBoundaryFaceCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcModulusOfSubgradeReactionMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcModulusOfSubgradeReactionMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcModulusOfSubgradeReactionMeasure(e[3].value) : null),
  1387855156: (r, e) => new IFC2X3.IfcBoundaryNodeCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLinearStiffnessMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLinearStiffnessMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLinearStiffnessMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[6].value) : null),
  2069777674: (r, e) => new IFC2X3.IfcBoundaryNodeConditionWarping(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLinearStiffnessMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLinearStiffnessMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLinearStiffnessMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcRotationalStiffnessMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcWarpingMomentMeasure(e[7].value) : null),
  622194075: (r, e) => new IFC2X3.IfcCalendarDate(r, new IFC2X3.IfcDayInMonthNumber(e[0].value), new IFC2X3.IfcMonthInYearNumber(e[1].value), new IFC2X3.IfcYearNumber(e[2].value)),
  747523909: (r, e) => new IFC2X3.IfcClassification(r, new IFC2X3.IfcLabel(e[0].value), new IFC2X3.IfcLabel(e[1].value), e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcLabel(e[3].value)),
  1767535486: (r, e) => new IFC2X3.IfcClassificationItem(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new IFC2X3.IfcLabel(e[2].value)),
  1098599126: (r, e) => new IFC2X3.IfcClassificationItemRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  938368621: (r, e) => new IFC2X3.IfcClassificationNotation(r, e[0].map((s) => new Handle(s.value))),
  3639012971: (r, e) => new IFC2X3.IfcClassificationNotationFacet(r, new IFC2X3.IfcLabel(e[0].value)),
  3264961684: (r, e) => new IFC2X3.IfcColourSpecification(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  2859738748: (r, e) => new IFC2X3.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC2X3.IfcConnectionPointGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  4257277454: (r, e) => new IFC2X3.IfcConnectionPortGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value)),
  2732653382: (r, e) => new IFC2X3.IfcConnectionSurfaceGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1959218052: (r, e) => new IFC2X3.IfcConstraint(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null),
  1658513725: (r, e) => new IFC2X3.IfcConstraintAggregationRelationship(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value)), e[4]),
  613356794: (r, e) => new IFC2X3.IfcConstraintClassificationRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  347226245: (r, e) => new IFC2X3.IfcConstraintRelationship(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1065062679: (r, e) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(r, new IFC2X3.IfcHourInDay(e[0].value), e[1] ? new IFC2X3.IfcMinuteInHour(e[1].value) : null, e[2]),
  602808272: (r, e) => new IFC2X3.IfcCostValue(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, new IFC2X3.IfcLabel(e[6].value), e[7] ? new IFC2X3.IfcText(e[7].value) : null),
  539742890: (r, e) => new IFC2X3.IfcCurrencyRelationship(r, new Handle(e[0].value), new Handle(e[1].value), new IFC2X3.IfcPositiveRatioMeasure(e[2].value), new Handle(e[3].value), e[4] ? new Handle(e[4].value) : null),
  1105321065: (r, e) => new IFC2X3.IfcCurveStyleFont(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value))),
  2367409068: (r, e) => new IFC2X3.IfcCurveStyleFontAndScaling(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC2X3.IfcPositiveRatioMeasure(e[2].value)),
  3510044353: (r, e) => new IFC2X3.IfcCurveStyleFontPattern(r, new IFC2X3.IfcLengthMeasure(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value)),
  1072939445: (r, e) => new IFC2X3.IfcDateAndTime(r, new Handle(e[0].value), new Handle(e[1].value)),
  1765591967: (r, e) => new IFC2X3.IfcDerivedUnit(r, e[0].map((s) => new Handle(s.value)), e[1], e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  1045800335: (r, e) => new IFC2X3.IfcDerivedUnitElement(r, new Handle(e[0].value), e[1].value),
  2949456006: (r, e) => new IFC2X3.IfcDimensionalExponents(r, e[0].value, e[1].value, e[2].value, e[3].value, e[4].value, e[5].value, e[6].value),
  1376555844: (r, e) => new IFC2X3.IfcDocumentElectronicFormat(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  1154170062: (r, e) => new IFC2X3.IfcDocumentInformation(r, new IFC2X3.IfcIdentifier(e[0].value), new IFC2X3.IfcLabel(e[1].value), e[2] ? new IFC2X3.IfcText(e[2].value) : null, e[3] ? e[3].map((s) => new Handle(s.value)) : null, e[4] ? new IFC2X3.IfcText(e[4].value) : null, e[5] ? new IFC2X3.IfcText(e[5].value) : null, e[6] ? new IFC2X3.IfcText(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12] ? new Handle(e[12].value) : null, e[13] ? new Handle(e[13].value) : null, e[14] ? new Handle(e[14].value) : null, e[15], e[16]),
  770865208: (r, e) => new IFC2X3.IfcDocumentInformationRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3796139169: (r, e) => new IFC2X3.IfcDraughtingCalloutRelationship(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value)),
  1648886627: (r, e) => new IFC2X3.IfcEnvironmentalImpactValue(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, new IFC2X3.IfcLabel(e[6].value), e[7], e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3200245327: (r, e) => new IFC2X3.IfcExternalReference(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  2242383968: (r, e) => new IFC2X3.IfcExternallyDefinedHatchStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  1040185647: (r, e) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3207319532: (r, e) => new IFC2X3.IfcExternallyDefinedSymbol(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3548104201: (r, e) => new IFC2X3.IfcExternallyDefinedTextFont(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  852622518: (r, e) => new IFC2X3.IfcGridAxis(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC2X3.IfcBoolean(e[2].value)),
  3020489413: (r, e) => new IFC2X3.IfcIrregularTimeSeriesValue(r, new Handle(e[0].value), e[1].map((s) => TypeInitialiser(1, s))),
  2655187982: (r, e) => new IFC2X3.IfcLibraryInformation(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new Handle(s.value)) : null),
  3452421091: (r, e) => new IFC2X3.IfcLibraryReference(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  4162380809: (r, e) => new IFC2X3.IfcLightDistributionData(r, new IFC2X3.IfcPlaneAngleMeasure(e[0].value), e[1].map((s) => new IFC2X3.IfcPlaneAngleMeasure(s.value)), e[2].map((s) => new IFC2X3.IfcLuminousIntensityDistributionMeasure(s.value))),
  1566485204: (r, e) => new IFC2X3.IfcLightIntensityDistribution(r, e[0], e[1].map((s) => new Handle(s.value))),
  30780891: (r, e) => new IFC2X3.IfcLocalTime(r, new IFC2X3.IfcHourInDay(e[0].value), e[1] ? new IFC2X3.IfcMinuteInHour(e[1].value) : null, e[2] ? new IFC2X3.IfcSecondInMinute(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC2X3.IfcDaylightSavingHour(e[4].value) : null),
  1838606355: (r, e) => new IFC2X3.IfcMaterial(r, new IFC2X3.IfcLabel(e[0].value)),
  1847130766: (r, e) => new IFC2X3.IfcMaterialClassificationRelationship(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value)),
  248100487: (r, e) => new IFC2X3.IfcMaterialLayer(r, e[0] ? new Handle(e[0].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC2X3.IfcLogical(e[2].value) : null),
  3303938423: (r, e) => new IFC2X3.IfcMaterialLayerSet(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null),
  1303795690: (r, e) => new IFC2X3.IfcMaterialLayerSetUsage(r, new Handle(e[0].value), e[1], e[2], new IFC2X3.IfcLengthMeasure(e[3].value)),
  2199411900: (r, e) => new IFC2X3.IfcMaterialList(r, e[0].map((s) => new Handle(s.value))),
  3265635763: (r, e) => new IFC2X3.IfcMaterialProperties(r, new Handle(e[0].value)),
  2597039031: (r, e) => new IFC2X3.IfcMeasureWithUnit(r, TypeInitialiser(1, e[0]), new Handle(e[1].value)),
  4256014907: (r, e) => new IFC2X3.IfcMechanicalMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcDynamicViscosityMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcThermalExpansionCoefficientMeasure(e[5].value) : null),
  677618848: (r, e) => new IFC2X3.IfcMechanicalSteelMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcDynamicViscosityMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcThermalExpansionCoefficientMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPressureMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPressureMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveRatioMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPressureMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcPositiveRatioMeasure(e[11].value) : null, e[12] ? e[12].map((s) => new Handle(s.value)) : null),
  3368373690: (r, e) => new IFC2X3.IfcMetric(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, new Handle(e[9].value)),
  2706619895: (r, e) => new IFC2X3.IfcMonetaryUnit(r, e[0]),
  1918398963: (r, e) => new IFC2X3.IfcNamedUnit(r, new Handle(e[0].value), e[1]),
  3701648758: (r, e) => new IFC2X3.IfcObjectPlacement(r),
  2251480897: (r, e) => new IFC2X3.IfcObjective(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9], e[10] ? new IFC2X3.IfcLabel(e[10].value) : null),
  1227763645: (r, e) => new IFC2X3.IfcOpticalMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcPositiveRatioMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPositiveRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveRatioMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveRatioMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPositiveRatioMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveRatioMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveRatioMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveRatioMeasure(e[9].value) : null),
  4251960020: (r, e) => new IFC2X3.IfcOrganization(r, e[0] ? new IFC2X3.IfcIdentifier(e[0].value) : null, new IFC2X3.IfcLabel(e[1].value), e[2] ? new IFC2X3.IfcText(e[2].value) : null, e[3] ? e[3].map((s) => new Handle(s.value)) : null, e[4] ? e[4].map((s) => new Handle(s.value)) : null),
  1411181986: (r, e) => new IFC2X3.IfcOrganizationRelationship(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1207048766: (r, e) => new IFC2X3.IfcOwnerHistory(r, new Handle(e[0].value), new Handle(e[1].value), e[2], e[3], e[4] ? new IFC2X3.IfcTimeStamp(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new IFC2X3.IfcTimeStamp(e[7].value)),
  2077209135: (r, e) => new IFC2X3.IfcPerson(r, e[0] ? new IFC2X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[5] ? e[5].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  101040310: (r, e) => new IFC2X3.IfcPersonAndOrganization(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2483315170: (r, e) => new IFC2X3.IfcPhysicalQuantity(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null),
  2226359599: (r, e) => new IFC2X3.IfcPhysicalSimpleQuantity(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  3355820592: (r, e) => new IFC2X3.IfcPostalAddress(r, e[0], e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcLabel(e[3].value) : null, e[4] ? e[4].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[5] ? new IFC2X3.IfcLabel(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? new IFC2X3.IfcLabel(e[9].value) : null),
  3727388367: (r, e) => new IFC2X3.IfcPreDefinedItem(r, new IFC2X3.IfcLabel(e[0].value)),
  990879717: (r, e) => new IFC2X3.IfcPreDefinedSymbol(r, new IFC2X3.IfcLabel(e[0].value)),
  3213052703: (r, e) => new IFC2X3.IfcPreDefinedTerminatorSymbol(r, new IFC2X3.IfcLabel(e[0].value)),
  1775413392: (r, e) => new IFC2X3.IfcPreDefinedTextFont(r, new IFC2X3.IfcLabel(e[0].value)),
  2022622350: (r, e) => new IFC2X3.IfcPresentationLayerAssignment(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC2X3.IfcIdentifier(e[3].value) : null),
  1304840413: (r, e) => new IFC2X3.IfcPresentationLayerWithStyle(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC2X3.IfcIdentifier(e[3].value) : null, e[4].value, e[5].value, e[6].value, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  3119450353: (r, e) => new IFC2X3.IfcPresentationStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  2417041796: (r, e) => new IFC2X3.IfcPresentationStyleAssignment(r, e[0].map((s) => new Handle(s.value))),
  2095639259: (r, e) => new IFC2X3.IfcProductRepresentation(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  2267347899: (r, e) => new IFC2X3.IfcProductsOfCombustionProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcSpecificHeatCapacityMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPositiveRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveRatioMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null),
  3958567839: (r, e) => new IFC2X3.IfcProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null),
  2802850158: (r, e) => new IFC2X3.IfcProfileProperties(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null),
  2598011224: (r, e) => new IFC2X3.IfcProperty(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null),
  3896028662: (r, e) => new IFC2X3.IfcPropertyConstraintRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  148025276: (r, e) => new IFC2X3.IfcPropertyDependencyRelationship(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcText(e[4].value) : null),
  3710013099: (r, e) => new IFC2X3.IfcPropertyEnumeration(r, new IFC2X3.IfcLabel(e[0].value), e[1].map((s) => TypeInitialiser(1, s)), e[2] ? new Handle(e[2].value) : null),
  2044713172: (r, e) => new IFC2X3.IfcQuantityArea(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcAreaMeasure(e[3].value)),
  2093928680: (r, e) => new IFC2X3.IfcQuantityCount(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcCountMeasure(e[3].value)),
  931644368: (r, e) => new IFC2X3.IfcQuantityLength(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcLengthMeasure(e[3].value)),
  3252649465: (r, e) => new IFC2X3.IfcQuantityTime(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcTimeMeasure(e[3].value)),
  2405470396: (r, e) => new IFC2X3.IfcQuantityVolume(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcVolumeMeasure(e[3].value)),
  825690147: (r, e) => new IFC2X3.IfcQuantityWeight(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC2X3.IfcMassMeasure(e[3].value)),
  2692823254: (r, e) => new IFC2X3.IfcReferencesValueDocument(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  1580146022: (r, e) => new IFC2X3.IfcReinforcementBarProperties(r, new IFC2X3.IfcAreaMeasure(e[0].value), new IFC2X3.IfcLabel(e[1].value), e[2], e[3] ? new IFC2X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcCountMeasure(e[5].value) : null),
  1222501353: (r, e) => new IFC2X3.IfcRelaxation(r, new IFC2X3.IfcNormalisedRatioMeasure(e[0].value), new IFC2X3.IfcNormalisedRatioMeasure(e[1].value)),
  1076942058: (r, e) => new IFC2X3.IfcRepresentation(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3377609919: (r, e) => new IFC2X3.IfcRepresentationContext(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLabel(e[1].value) : null),
  3008791417: (r, e) => new IFC2X3.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC2X3.IfcRepresentationMap(r, new Handle(e[0].value), new Handle(e[1].value)),
  3679540991: (r, e) => new IFC2X3.IfcRibPlateProfileProperties(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC2X3.IfcPositiveLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6]),
  2341007311: (r, e) => new IFC2X3.IfcRoot(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  448429030: (r, e) => new IFC2X3.IfcSIUnit(r, e[0], e[1], e[2]),
  2042790032: (r, e) => new IFC2X3.IfcSectionProperties(r, e[0], new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null),
  4165799628: (r, e) => new IFC2X3.IfcSectionReinforcementProperties(r, new IFC2X3.IfcLengthMeasure(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC2X3.IfcLengthMeasure(e[2].value) : null, e[3], new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  867548509: (r, e) => new IFC2X3.IfcShapeAspect(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcText(e[2].value) : null, e[3].value, new Handle(e[4].value)),
  3982875396: (r, e) => new IFC2X3.IfcShapeModel(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  4240577450: (r, e) => new IFC2X3.IfcShapeRepresentation(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3692461612: (r, e) => new IFC2X3.IfcSimpleProperty(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null),
  2273995522: (r, e) => new IFC2X3.IfcStructuralConnectionCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  2162789131: (r, e) => new IFC2X3.IfcStructuralLoad(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  2525727697: (r, e) => new IFC2X3.IfcStructuralLoadStatic(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null),
  3408363356: (r, e) => new IFC2X3.IfcStructuralLoadTemperature(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[3].value) : null),
  2830218821: (r, e) => new IFC2X3.IfcStyleModel(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3958052878: (r, e) => new IFC2X3.IfcStyledItem(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3049322572: (r, e) => new IFC2X3.IfcStyledRepresentation(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  1300840506: (r, e) => new IFC2X3.IfcSurfaceStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1], e[2].map((s) => new Handle(s.value))),
  3303107099: (r, e) => new IFC2X3.IfcSurfaceStyleLighting(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new Handle(e[3].value)),
  1607154358: (r, e) => new IFC2X3.IfcSurfaceStyleRefraction(r, e[0] ? new IFC2X3.IfcReal(e[0].value) : null, e[1] ? new IFC2X3.IfcReal(e[1].value) : null),
  846575682: (r, e) => new IFC2X3.IfcSurfaceStyleShading(r, new Handle(e[0].value)),
  1351298697: (r, e) => new IFC2X3.IfcSurfaceStyleWithTextures(r, e[0].map((s) => new Handle(s.value))),
  626085974: (r, e) => new IFC2X3.IfcSurfaceTexture(r, e[0].value, e[1].value, e[2], e[3] ? new Handle(e[3].value) : null),
  1290481447: (r, e) => new IFC2X3.IfcSymbolStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, TypeInitialiser(1, e[1])),
  985171141: (r, e) => new IFC2X3.IfcTable(r, e[0].value, e[1].map((s) => new Handle(s.value))),
  531007025: (r, e) => new IFC2X3.IfcTableRow(r, e[0].map((s) => TypeInitialiser(1, s)), e[1].value),
  912023232: (r, e) => new IFC2X3.IfcTelecomAddress(r, e[0], e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[5] ? new IFC2X3.IfcLabel(e[5].value) : null, e[6] ? e[6].map((s) => new IFC2X3.IfcLabel(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null),
  1447204868: (r, e) => new IFC2X3.IfcTextStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value)),
  1983826977: (r, e) => new IFC2X3.IfcTextStyleFontModel(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? e[1].map((s) => new IFC2X3.IfcTextFontName(s.value)) : null, e[2] ? new IFC2X3.IfcFontStyle(e[2].value) : null, e[3] ? new IFC2X3.IfcFontVariant(e[3].value) : null, e[4] ? new IFC2X3.IfcFontWeight(e[4].value) : null, TypeInitialiser(1, e[5])),
  2636378356: (r, e) => new IFC2X3.IfcTextStyleForDefinedFont(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1640371178: (r, e) => new IFC2X3.IfcTextStyleTextModel(r, e[0] ? TypeInitialiser(1, e[0]) : null, e[1] ? new IFC2X3.IfcTextAlignment(e[1].value) : null, e[2] ? new IFC2X3.IfcTextDecoration(e[2].value) : null, e[3] ? TypeInitialiser(1, e[3]) : null, e[4] ? TypeInitialiser(1, e[4]) : null, e[5] ? new IFC2X3.IfcTextTransformation(e[5].value) : null, e[6] ? TypeInitialiser(1, e[6]) : null),
  1484833681: (r, e) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(r, e[0] ? new IFC2X3.IfcPositiveLengthMeasure(e[0].value) : null, e[1] ? new IFC2X3.IfcPositiveLengthMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPlaneAngleMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPlaneAngleMeasure(e[3].value) : null, e[4] ? TypeInitialiser(1, e[4]) : null),
  280115917: (r, e) => new IFC2X3.IfcTextureCoordinate(r),
  1742049831: (r, e) => new IFC2X3.IfcTextureCoordinateGenerator(r, new IFC2X3.IfcLabel(e[0].value), e[1].map((s) => TypeInitialiser(1, s))),
  2552916305: (r, e) => new IFC2X3.IfcTextureMap(r, e[0].map((s) => new Handle(s.value))),
  1210645708: (r, e) => new IFC2X3.IfcTextureVertex(r, e[0].map((s) => new IFC2X3.IfcParameterValue(s.value))),
  3317419933: (r, e) => new IFC2X3.IfcThermalMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcSpecificHeatCapacityMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcThermalConductivityMeasure(e[4].value) : null),
  3101149627: (r, e) => new IFC2X3.IfcTimeSeries(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4], e[5], e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  1718945513: (r, e) => new IFC2X3.IfcTimeSeriesReferenceRelationship(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  581633288: (r, e) => new IFC2X3.IfcTimeSeriesValue(r, e[0].map((s) => TypeInitialiser(1, s))),
  1377556343: (r, e) => new IFC2X3.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC2X3.IfcTopologyRepresentation(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  180925521: (r, e) => new IFC2X3.IfcUnitAssignment(r, e[0].map((s) => new Handle(s.value))),
  2799835756: (r, e) => new IFC2X3.IfcVertex(r),
  3304826586: (r, e) => new IFC2X3.IfcVertexBasedTextureMap(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new Handle(s.value))),
  1907098498: (r, e) => new IFC2X3.IfcVertexPoint(r, new Handle(e[0].value)),
  891718957: (r, e) => new IFC2X3.IfcVirtualGridIntersection(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new IFC2X3.IfcLengthMeasure(s.value))),
  1065908215: (r, e) => new IFC2X3.IfcWaterProperties(r, new Handle(e[0].value), e[1] ? e[1].value : null, e[2] ? new IFC2X3.IfcIonConcentrationMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcIonConcentrationMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcIonConcentrationMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcNormalisedRatioMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPHMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcNormalisedRatioMeasure(e[7].value) : null),
  2442683028: (r, e) => new IFC2X3.IfcAnnotationOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  962685235: (r, e) => new IFC2X3.IfcAnnotationSurfaceOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3612888222: (r, e) => new IFC2X3.IfcAnnotationSymbolOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  2297822566: (r, e) => new IFC2X3.IfcAnnotationTextOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  3798115385: (r, e) => new IFC2X3.IfcArbitraryClosedProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  1310608509: (r, e) => new IFC2X3.IfcArbitraryOpenProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  2705031697: (r, e) => new IFC2X3.IfcArbitraryProfileDefWithVoids(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  616511568: (r, e) => new IFC2X3.IfcBlobTexture(r, e[0].value, e[1].value, e[2], e[3] ? new Handle(e[3].value) : null, new IFC2X3.IfcIdentifier(e[4].value), e[5].value),
  3150382593: (r, e) => new IFC2X3.IfcCenterLineProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  647927063: (r, e) => new IFC2X3.IfcClassificationReference(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null),
  776857604: (r, e) => new IFC2X3.IfcColourRgb(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new IFC2X3.IfcNormalisedRatioMeasure(e[1].value), new IFC2X3.IfcNormalisedRatioMeasure(e[2].value), new IFC2X3.IfcNormalisedRatioMeasure(e[3].value)),
  2542286263: (r, e) => new IFC2X3.IfcComplexProperty(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, new IFC2X3.IfcIdentifier(e[2].value), e[3].map((s) => new Handle(s.value))),
  1485152156: (r, e) => new IFC2X3.IfcCompositeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC2X3.IfcLabel(e[3].value) : null),
  370225590: (r, e) => new IFC2X3.IfcConnectedFaceSet(r, e[0].map((s) => new Handle(s.value))),
  1981873012: (r, e) => new IFC2X3.IfcConnectionCurveGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  45288368: (r, e) => new IFC2X3.IfcConnectionPointEccentricity(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC2X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcLengthMeasure(e[4].value) : null),
  3050246964: (r, e) => new IFC2X3.IfcContextDependentUnit(r, new Handle(e[0].value), e[1], new IFC2X3.IfcLabel(e[2].value)),
  2889183280: (r, e) => new IFC2X3.IfcConversionBasedUnit(r, new Handle(e[0].value), e[1], new IFC2X3.IfcLabel(e[2].value), new Handle(e[3].value)),
  3800577675: (r, e) => new IFC2X3.IfcCurveStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? TypeInitialiser(1, e[2]) : null, e[3] ? new Handle(e[3].value) : null),
  3632507154: (r, e) => new IFC2X3.IfcDerivedProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  2273265877: (r, e) => new IFC2X3.IfcDimensionCalloutRelationship(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value)),
  1694125774: (r, e) => new IFC2X3.IfcDimensionPair(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value)),
  3732053477: (r, e) => new IFC2X3.IfcDocumentReference(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  4170525392: (r, e) => new IFC2X3.IfcDraughtingPreDefinedTextFont(r, new IFC2X3.IfcLabel(e[0].value)),
  3900360178: (r, e) => new IFC2X3.IfcEdge(r, new Handle(e[0].value), new Handle(e[1].value)),
  476780140: (r, e) => new IFC2X3.IfcEdgeCurve(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), e[3].value),
  1860660968: (r, e) => new IFC2X3.IfcExtendedMaterialProperties(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcText(e[2].value) : null, new IFC2X3.IfcLabel(e[3].value)),
  2556980723: (r, e) => new IFC2X3.IfcFace(r, e[0].map((s) => new Handle(s.value))),
  1809719519: (r, e) => new IFC2X3.IfcFaceBound(r, new Handle(e[0].value), e[1].value),
  803316827: (r, e) => new IFC2X3.IfcFaceOuterBound(r, new Handle(e[0].value), e[1].value),
  3008276851: (r, e) => new IFC2X3.IfcFaceSurface(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), e[2].value),
  4219587988: (r, e) => new IFC2X3.IfcFailureConnectionCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcForceMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcForceMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcForceMeasure(e[6].value) : null),
  738692330: (r, e) => new IFC2X3.IfcFillAreaStyle(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value))),
  3857492461: (r, e) => new IFC2X3.IfcFuelProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPositiveRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcHeatingValueMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcHeatingValueMeasure(e[4].value) : null),
  803998398: (r, e) => new IFC2X3.IfcGeneralMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcMolecularWeightMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcMassDensityMeasure(e[3].value) : null),
  1446786286: (r, e) => new IFC2X3.IfcGeneralProfileProperties(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC2X3.IfcMassPerLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcAreaMeasure(e[6].value) : null),
  3448662350: (r, e) => new IFC2X3.IfcGeometricRepresentationContext(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new IFC2X3.IfcDimensionCount(e[2].value), e[3] ? e[3].value : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null),
  2453401579: (r, e) => new IFC2X3.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC2X3.IfcGeometricRepresentationSubContext(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC2X3.IfcPositiveRatioMeasure(e[3].value) : null, e[4], e[5] ? new IFC2X3.IfcLabel(e[5].value) : null),
  3590301190: (r, e) => new IFC2X3.IfcGeometricSet(r, e[0].map((s) => new Handle(s.value))),
  178086475: (r, e) => new IFC2X3.IfcGridPlacement(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  812098782: (r, e) => new IFC2X3.IfcHalfSpaceSolid(r, new Handle(e[0].value), e[1].value),
  2445078500: (r, e) => new IFC2X3.IfcHygroscopicMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcPositiveRatioMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPositiveRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcIsothermalMoistureCapacityMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcVaporPermeabilityMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcMoistureDiffusivityMeasure(e[5].value) : null),
  3905492369: (r, e) => new IFC2X3.IfcImageTexture(r, e[0].value, e[1].value, e[2], e[3] ? new Handle(e[3].value) : null, new IFC2X3.IfcIdentifier(e[4].value)),
  3741457305: (r, e) => new IFC2X3.IfcIrregularTimeSeries(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4], e[5], e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8].map((s) => new Handle(s.value))),
  1402838566: (r, e) => new IFC2X3.IfcLightSource(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null),
  125510826: (r, e) => new IFC2X3.IfcLightSourceAmbient(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null),
  2604431987: (r, e) => new IFC2X3.IfcLightSourceDirectional(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value)),
  4266656042: (r, e) => new IFC2X3.IfcLightSourceGoniometric(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null, new IFC2X3.IfcThermodynamicTemperatureMeasure(e[6].value), new IFC2X3.IfcLuminousFluxMeasure(e[7].value), e[8], new Handle(e[9].value)),
  1520743889: (r, e) => new IFC2X3.IfcLightSourcePositional(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcReal(e[6].value), new IFC2X3.IfcReal(e[7].value), new IFC2X3.IfcReal(e[8].value)),
  3422422726: (r, e) => new IFC2X3.IfcLightSourceSpot(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC2X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcReal(e[6].value), new IFC2X3.IfcReal(e[7].value), new IFC2X3.IfcReal(e[8].value), new Handle(e[9].value), e[10] ? new IFC2X3.IfcReal(e[10].value) : null, new IFC2X3.IfcPositivePlaneAngleMeasure(e[11].value), new IFC2X3.IfcPositivePlaneAngleMeasure(e[12].value)),
  2624227202: (r, e) => new IFC2X3.IfcLocalPlacement(r, e[0] ? new Handle(e[0].value) : null, new Handle(e[1].value)),
  1008929658: (r, e) => new IFC2X3.IfcLoop(r),
  2347385850: (r, e) => new IFC2X3.IfcMappedItem(r, new Handle(e[0].value), new Handle(e[1].value)),
  2022407955: (r, e) => new IFC2X3.IfcMaterialDefinitionRepresentation(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  1430189142: (r, e) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcDynamicViscosityMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcModulusOfElasticityMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcThermalExpansionCoefficientMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPressureMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcText(e[8].value) : null, e[9] ? new IFC2X3.IfcText(e[9].value) : null, e[10] ? new IFC2X3.IfcNormalisedRatioMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcText(e[11].value) : null),
  219451334: (r, e) => new IFC2X3.IfcObjectDefinition(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  2833995503: (r, e) => new IFC2X3.IfcOneDirectionRepeatFactor(r, new Handle(e[0].value)),
  2665983363: (r, e) => new IFC2X3.IfcOpenShell(r, e[0].map((s) => new Handle(s.value))),
  1029017970: (r, e) => new IFC2X3.IfcOrientedEdge(r, new Handle(e[0].value), e[1].value),
  2529465313: (r, e) => new IFC2X3.IfcParameterizedProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  2519244187: (r, e) => new IFC2X3.IfcPath(r, e[0].map((s) => new Handle(s.value))),
  3021840470: (r, e) => new IFC2X3.IfcPhysicalComplexQuantity(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new IFC2X3.IfcLabel(e[3].value), e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcLabel(e[5].value) : null),
  597895409: (r, e) => new IFC2X3.IfcPixelTexture(r, e[0].value, e[1].value, e[2], e[3] ? new Handle(e[3].value) : null, new IFC2X3.IfcInteger(e[4].value), new IFC2X3.IfcInteger(e[5].value), new IFC2X3.IfcInteger(e[6].value), e[7].map((s) => s.value)),
  2004835150: (r, e) => new IFC2X3.IfcPlacement(r, new Handle(e[0].value)),
  1663979128: (r, e) => new IFC2X3.IfcPlanarExtent(r, new IFC2X3.IfcLengthMeasure(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value)),
  2067069095: (r, e) => new IFC2X3.IfcPoint(r),
  4022376103: (r, e) => new IFC2X3.IfcPointOnCurve(r, new Handle(e[0].value), new IFC2X3.IfcParameterValue(e[1].value)),
  1423911732: (r, e) => new IFC2X3.IfcPointOnSurface(r, new Handle(e[0].value), new IFC2X3.IfcParameterValue(e[1].value), new IFC2X3.IfcParameterValue(e[2].value)),
  2924175390: (r, e) => new IFC2X3.IfcPolyLoop(r, e[0].map((s) => new Handle(s.value))),
  2775532180: (r, e) => new IFC2X3.IfcPolygonalBoundedHalfSpace(r, new Handle(e[0].value), e[1].value, new Handle(e[2].value), new Handle(e[3].value)),
  759155922: (r, e) => new IFC2X3.IfcPreDefinedColour(r, new IFC2X3.IfcLabel(e[0].value)),
  2559016684: (r, e) => new IFC2X3.IfcPreDefinedCurveFont(r, new IFC2X3.IfcLabel(e[0].value)),
  433424934: (r, e) => new IFC2X3.IfcPreDefinedDimensionSymbol(r, new IFC2X3.IfcLabel(e[0].value)),
  179317114: (r, e) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(r, new IFC2X3.IfcLabel(e[0].value)),
  673634403: (r, e) => new IFC2X3.IfcProductDefinitionShape(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  871118103: (r, e) => new IFC2X3.IfcPropertyBoundedValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(1, e[2]) : null, e[3] ? TypeInitialiser(1, e[3]) : null, e[4] ? new Handle(e[4].value) : null),
  1680319473: (r, e) => new IFC2X3.IfcPropertyDefinition(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  4166981789: (r, e) => new IFC2X3.IfcPropertyEnumeratedValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => TypeInitialiser(1, s)), e[3] ? new Handle(e[3].value) : null),
  2752243245: (r, e) => new IFC2X3.IfcPropertyListValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => TypeInitialiser(1, s)), e[3] ? new Handle(e[3].value) : null),
  941946838: (r, e) => new IFC2X3.IfcPropertyReferenceValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, new Handle(e[3].value)),
  3357820518: (r, e) => new IFC2X3.IfcPropertySetDefinition(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  3650150729: (r, e) => new IFC2X3.IfcPropertySingleValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(1, e[2]) : null, e[3] ? new Handle(e[3].value) : null),
  110355661: (r, e) => new IFC2X3.IfcPropertyTableValue(r, new IFC2X3.IfcIdentifier(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, e[2].map((s) => TypeInitialiser(1, s)), e[3].map((s) => TypeInitialiser(1, s)), e[4] ? new IFC2X3.IfcText(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3615266464: (r, e) => new IFC2X3.IfcRectangleProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value)),
  3413951693: (r, e) => new IFC2X3.IfcRegularTimeSeries(r, new IFC2X3.IfcLabel(e[0].value), e[1] ? new IFC2X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4], e[5], e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new IFC2X3.IfcTimeMeasure(e[8].value), e[9].map((s) => new Handle(s.value))),
  3765753017: (r, e) => new IFC2X3.IfcReinforcementDefinitionProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  478536968: (r, e) => new IFC2X3.IfcRelationship(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  2778083089: (r, e) => new IFC2X3.IfcRoundedRectangleProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value)),
  1509187699: (r, e) => new IFC2X3.IfcSectionedSpine(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value))),
  2411513650: (r, e) => new IFC2X3.IfcServiceLifeFactor(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5] ? TypeInitialiser(1, e[5]) : null, TypeInitialiser(1, e[6]), e[7] ? TypeInitialiser(1, e[7]) : null),
  4124623270: (r, e) => new IFC2X3.IfcShellBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  2609359061: (r, e) => new IFC2X3.IfcSlippageConnectionCondition(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLengthMeasure(e[3].value) : null),
  723233188: (r, e) => new IFC2X3.IfcSolidModel(r),
  2485662743: (r, e) => new IFC2X3.IfcSoundProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new IFC2X3.IfcBoolean(e[4].value), e[5], e[6].map((s) => new Handle(s.value))),
  1202362311: (r, e) => new IFC2X3.IfcSoundValue(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new IFC2X3.IfcFrequencyMeasure(e[5].value), e[6] ? TypeInitialiser(1, e[6]) : null),
  390701378: (r, e) => new IFC2X3.IfcSpaceThermalLoadProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5], e[6], e[7] ? new IFC2X3.IfcText(e[7].value) : null, new IFC2X3.IfcPowerMeasure(e[8].value), e[9] ? new IFC2X3.IfcPowerMeasure(e[9].value) : null, e[10] ? new Handle(e[10].value) : null, e[11] ? new IFC2X3.IfcLabel(e[11].value) : null, e[12] ? new IFC2X3.IfcLabel(e[12].value) : null, e[13]),
  1595516126: (r, e) => new IFC2X3.IfcStructuralLoadLinearForce(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLinearForceMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLinearForceMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLinearForceMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcLinearMomentMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcLinearMomentMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcLinearMomentMeasure(e[6].value) : null),
  2668620305: (r, e) => new IFC2X3.IfcStructuralLoadPlanarForce(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcPlanarForceMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcPlanarForceMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPlanarForceMeasure(e[3].value) : null),
  2473145415: (r, e) => new IFC2X3.IfcStructuralLoadSingleDisplacement(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPlaneAngleMeasure(e[6].value) : null),
  1973038258: (r, e) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPlaneAngleMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcCurvatureMeasure(e[7].value) : null),
  1597423693: (r, e) => new IFC2X3.IfcStructuralLoadSingleForce(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcTorqueMeasure(e[6].value) : null),
  1190533807: (r, e) => new IFC2X3.IfcStructuralLoadSingleForceWarping(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new IFC2X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC2X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcTorqueMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcWarpingMomentMeasure(e[7].value) : null),
  3843319758: (r, e) => new IFC2X3.IfcStructuralProfileProperties(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC2X3.IfcMassPerLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcAreaMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcWarpingConstantMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcLengthMeasure(e[12].value) : null, e[13] ? new IFC2X3.IfcLengthMeasure(e[13].value) : null, e[14] ? new IFC2X3.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC2X3.IfcAreaMeasure(e[15].value) : null, e[16] ? new IFC2X3.IfcSectionModulusMeasure(e[16].value) : null, e[17] ? new IFC2X3.IfcSectionModulusMeasure(e[17].value) : null, e[18] ? new IFC2X3.IfcSectionModulusMeasure(e[18].value) : null, e[19] ? new IFC2X3.IfcSectionModulusMeasure(e[19].value) : null, e[20] ? new IFC2X3.IfcSectionModulusMeasure(e[20].value) : null, e[21] ? new IFC2X3.IfcLengthMeasure(e[21].value) : null, e[22] ? new IFC2X3.IfcLengthMeasure(e[22].value) : null),
  3653947884: (r, e) => new IFC2X3.IfcStructuralSteelProfileProperties(r, e[0] ? new IFC2X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC2X3.IfcMassPerLengthMeasure(e[2].value) : null, e[3] ? new IFC2X3.IfcPositiveLengthMeasure(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcAreaMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcMomentOfInertiaMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcWarpingConstantMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcLengthMeasure(e[12].value) : null, e[13] ? new IFC2X3.IfcLengthMeasure(e[13].value) : null, e[14] ? new IFC2X3.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC2X3.IfcAreaMeasure(e[15].value) : null, e[16] ? new IFC2X3.IfcSectionModulusMeasure(e[16].value) : null, e[17] ? new IFC2X3.IfcSectionModulusMeasure(e[17].value) : null, e[18] ? new IFC2X3.IfcSectionModulusMeasure(e[18].value) : null, e[19] ? new IFC2X3.IfcSectionModulusMeasure(e[19].value) : null, e[20] ? new IFC2X3.IfcSectionModulusMeasure(e[20].value) : null, e[21] ? new IFC2X3.IfcLengthMeasure(e[21].value) : null, e[22] ? new IFC2X3.IfcLengthMeasure(e[22].value) : null, e[23] ? new IFC2X3.IfcAreaMeasure(e[23].value) : null, e[24] ? new IFC2X3.IfcAreaMeasure(e[24].value) : null, e[25] ? new IFC2X3.IfcPositiveRatioMeasure(e[25].value) : null, e[26] ? new IFC2X3.IfcPositiveRatioMeasure(e[26].value) : null),
  2233826070: (r, e) => new IFC2X3.IfcSubedge(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value)),
  2513912981: (r, e) => new IFC2X3.IfcSurface(r),
  1878645084: (r, e) => new IFC2X3.IfcSurfaceStyleRendering(r, new Handle(e[0].value), e[1] ? new IFC2X3.IfcNormalisedRatioMeasure(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? TypeInitialiser(1, e[7]) : null, e[8]),
  2247615214: (r, e) => new IFC2X3.IfcSweptAreaSolid(r, new Handle(e[0].value), new Handle(e[1].value)),
  1260650574: (r, e) => new IFC2X3.IfcSweptDiskSolid(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC2X3.IfcPositiveLengthMeasure(e[2].value) : null, new IFC2X3.IfcParameterValue(e[3].value), new IFC2X3.IfcParameterValue(e[4].value)),
  230924584: (r, e) => new IFC2X3.IfcSweptSurface(r, new Handle(e[0].value), new Handle(e[1].value)),
  3071757647: (r, e) => new IFC2X3.IfcTShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPlaneAngleMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcPlaneAngleMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcPositiveLengthMeasure(e[12].value) : null),
  3028897424: (r, e) => new IFC2X3.IfcTerminatorSymbol(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, new Handle(e[3].value)),
  4282788508: (r, e) => new IFC2X3.IfcTextLiteral(r, new IFC2X3.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2]),
  3124975700: (r, e) => new IFC2X3.IfcTextLiteralWithExtent(r, new IFC2X3.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2], new Handle(e[3].value), new IFC2X3.IfcBoxAlignment(e[4].value)),
  2715220739: (r, e) => new IFC2X3.IfcTrapeziumProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcLengthMeasure(e[6].value)),
  1345879162: (r, e) => new IFC2X3.IfcTwoDirectionRepeatFactor(r, new Handle(e[0].value), new Handle(e[1].value)),
  1628702193: (r, e) => new IFC2X3.IfcTypeObject(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null),
  2347495698: (r, e) => new IFC2X3.IfcTypeProduct(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null),
  427810014: (r, e) => new IFC2X3.IfcUShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPlaneAngleMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null),
  1417489154: (r, e) => new IFC2X3.IfcVector(r, new Handle(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value)),
  2759199220: (r, e) => new IFC2X3.IfcVertexLoop(r, new Handle(e[0].value)),
  336235671: (r, e) => new IFC2X3.IfcWindowLiningProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcNormalisedRatioMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcNormalisedRatioMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcNormalisedRatioMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcNormalisedRatioMeasure(e[11].value) : null, e[12] ? new Handle(e[12].value) : null),
  512836454: (r, e) => new IFC2X3.IfcWindowPanelProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  1299126871: (r, e) => new IFC2X3.IfcWindowStyle(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10].value, e[11].value),
  2543172580: (r, e) => new IFC2X3.IfcZShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null),
  3288037868: (r, e) => new IFC2X3.IfcAnnotationCurveOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  669184980: (r, e) => new IFC2X3.IfcAnnotationFillArea(r, new Handle(e[0].value), e[1] ? e[1].map((s) => new Handle(s.value)) : null),
  2265737646: (r, e) => new IFC2X3.IfcAnnotationFillAreaOccurrence(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4]),
  1302238472: (r, e) => new IFC2X3.IfcAnnotationSurface(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  4261334040: (r, e) => new IFC2X3.IfcAxis1Placement(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  3125803723: (r, e) => new IFC2X3.IfcAxis2Placement2D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  2740243338: (r, e) => new IFC2X3.IfcAxis2Placement3D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  2736907675: (r, e) => new IFC2X3.IfcBooleanResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  4182860854: (r, e) => new IFC2X3.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC2X3.IfcBoundingBox(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  2713105998: (r, e) => new IFC2X3.IfcBoxedHalfSpace(r, new Handle(e[0].value), e[1].value, new Handle(e[2].value)),
  2898889636: (r, e) => new IFC2X3.IfcCShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null),
  1123145078: (r, e) => new IFC2X3.IfcCartesianPoint(r, e[0].map((s) => new IFC2X3.IfcLengthMeasure(s.value))),
  59481748: (r, e) => new IFC2X3.IfcCartesianTransformationOperator(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? e[3].value : null),
  3749851601: (r, e) => new IFC2X3.IfcCartesianTransformationOperator2D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? e[3].value : null),
  3486308946: (r, e) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? e[3].value : null, e[4] ? e[4].value : null),
  3331915920: (r, e) => new IFC2X3.IfcCartesianTransformationOperator3D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? e[3].value : null, e[4] ? new Handle(e[4].value) : null),
  1416205885: (r, e) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? e[3].value : null, e[4] ? new Handle(e[4].value) : null, e[5] ? e[5].value : null, e[6] ? e[6].value : null),
  1383045692: (r, e) => new IFC2X3.IfcCircleProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  2205249479: (r, e) => new IFC2X3.IfcClosedShell(r, e[0].map((s) => new Handle(s.value))),
  2485617015: (r, e) => new IFC2X3.IfcCompositeCurveSegment(r, e[0], e[1].value, new Handle(e[2].value)),
  4133800736: (r, e) => new IFC2X3.IfcCraneRailAShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[6].value), new IFC2X3.IfcPositiveLengthMeasure(e[7].value), new IFC2X3.IfcPositiveLengthMeasure(e[8].value), new IFC2X3.IfcPositiveLengthMeasure(e[9].value), new IFC2X3.IfcPositiveLengthMeasure(e[10].value), new IFC2X3.IfcPositiveLengthMeasure(e[11].value), new IFC2X3.IfcPositiveLengthMeasure(e[12].value), new IFC2X3.IfcPositiveLengthMeasure(e[13].value), e[14] ? new IFC2X3.IfcPositiveLengthMeasure(e[14].value) : null),
  194851669: (r, e) => new IFC2X3.IfcCraneRailFShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[6].value), new IFC2X3.IfcPositiveLengthMeasure(e[7].value), new IFC2X3.IfcPositiveLengthMeasure(e[8].value), new IFC2X3.IfcPositiveLengthMeasure(e[9].value), new IFC2X3.IfcPositiveLengthMeasure(e[10].value), e[11] ? new IFC2X3.IfcPositiveLengthMeasure(e[11].value) : null),
  2506170314: (r, e) => new IFC2X3.IfcCsgPrimitive3D(r, new Handle(e[0].value)),
  2147822146: (r, e) => new IFC2X3.IfcCsgSolid(r, new Handle(e[0].value)),
  2601014836: (r, e) => new IFC2X3.IfcCurve(r),
  2827736869: (r, e) => new IFC2X3.IfcCurveBoundedPlane(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  693772133: (r, e) => new IFC2X3.IfcDefinedSymbol(r, new Handle(e[0].value), new Handle(e[1].value)),
  606661476: (r, e) => new IFC2X3.IfcDimensionCurve(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  4054601972: (r, e) => new IFC2X3.IfcDimensionCurveTerminator(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, new Handle(e[3].value), e[4]),
  32440307: (r, e) => new IFC2X3.IfcDirection(r, e[0].map((s) => s.value)),
  2963535650: (r, e) => new IFC2X3.IfcDoorLiningProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcPositiveLengthMeasure(e[5].value) : null, e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcLengthMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC2X3.IfcPositiveLengthMeasure(e[13].value) : null, e[14] ? new Handle(e[14].value) : null),
  1714330368: (r, e) => new IFC2X3.IfcDoorPanelProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5], e[6] ? new IFC2X3.IfcNormalisedRatioMeasure(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  526551008: (r, e) => new IFC2X3.IfcDoorStyle(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10].value, e[11].value),
  3073041342: (r, e) => new IFC2X3.IfcDraughtingCallout(r, e[0].map((s) => new Handle(s.value))),
  445594917: (r, e) => new IFC2X3.IfcDraughtingPreDefinedColour(r, new IFC2X3.IfcLabel(e[0].value)),
  4006246654: (r, e) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(r, new IFC2X3.IfcLabel(e[0].value)),
  1472233963: (r, e) => new IFC2X3.IfcEdgeLoop(r, e[0].map((s) => new Handle(s.value))),
  1883228015: (r, e) => new IFC2X3.IfcElementQuantity(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  339256511: (r, e) => new IFC2X3.IfcElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  2777663545: (r, e) => new IFC2X3.IfcElementarySurface(r, new Handle(e[0].value)),
  2835456948: (r, e) => new IFC2X3.IfcEllipseProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value)),
  80994333: (r, e) => new IFC2X3.IfcEnergyProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5] ? new IFC2X3.IfcLabel(e[5].value) : null),
  477187591: (r, e) => new IFC2X3.IfcExtrudedAreaSolid(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  2047409740: (r, e) => new IFC2X3.IfcFaceBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  374418227: (r, e) => new IFC2X3.IfcFillAreaStyleHatching(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, new IFC2X3.IfcPlaneAngleMeasure(e[4].value)),
  4203026998: (r, e) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(r, new Handle(e[0].value)),
  315944413: (r, e) => new IFC2X3.IfcFillAreaStyleTiles(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), new IFC2X3.IfcPositiveRatioMeasure(e[2].value)),
  3455213021: (r, e) => new IFC2X3.IfcFluidFlowProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new Handle(e[8].value), e[9] ? new Handle(e[9].value) : null, e[10] ? new IFC2X3.IfcLabel(e[10].value) : null, e[11] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcThermodynamicTemperatureMeasure(e[12].value) : null, e[13] ? new Handle(e[13].value) : null, e[14] ? new Handle(e[14].value) : null, e[15] ? TypeInitialiser(1, e[15]) : null, e[16] ? new IFC2X3.IfcPositiveRatioMeasure(e[16].value) : null, e[17] ? new IFC2X3.IfcLinearVelocityMeasure(e[17].value) : null, e[18] ? new IFC2X3.IfcPressureMeasure(e[18].value) : null),
  4238390223: (r, e) => new IFC2X3.IfcFurnishingElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1268542332: (r, e) => new IFC2X3.IfcFurnitureType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  987898635: (r, e) => new IFC2X3.IfcGeometricCurveSet(r, e[0].map((s) => new Handle(s.value))),
  1484403080: (r, e) => new IFC2X3.IfcIShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null),
  572779678: (r, e) => new IFC2X3.IfcLShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), e[4] ? new IFC2X3.IfcPositiveLengthMeasure(e[4].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new IFC2X3.IfcPlaneAngleMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null),
  1281925730: (r, e) => new IFC2X3.IfcLine(r, new Handle(e[0].value), new Handle(e[1].value)),
  1425443689: (r, e) => new IFC2X3.IfcManifoldSolidBrep(r, new Handle(e[0].value)),
  3888040117: (r, e) => new IFC2X3.IfcObject(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  3388369263: (r, e) => new IFC2X3.IfcOffsetCurve2D(r, new Handle(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value), e[2].value),
  3505215534: (r, e) => new IFC2X3.IfcOffsetCurve3D(r, new Handle(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value), e[2].value, new Handle(e[3].value)),
  3566463478: (r, e) => new IFC2X3.IfcPermeableCoveringProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  603570806: (r, e) => new IFC2X3.IfcPlanarBox(r, new IFC2X3.IfcLengthMeasure(e[0].value), new IFC2X3.IfcLengthMeasure(e[1].value), new Handle(e[2].value)),
  220341763: (r, e) => new IFC2X3.IfcPlane(r, new Handle(e[0].value)),
  2945172077: (r, e) => new IFC2X3.IfcProcess(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  4208778838: (r, e) => new IFC2X3.IfcProduct(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  103090709: (r, e) => new IFC2X3.IfcProject(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcLabel(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7].map((s) => new Handle(s.value)), new Handle(e[8].value)),
  4194566429: (r, e) => new IFC2X3.IfcProjectionCurve(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null),
  1451395588: (r, e) => new IFC2X3.IfcPropertySet(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  3219374653: (r, e) => new IFC2X3.IfcProxy(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  2770003689: (r, e) => new IFC2X3.IfcRectangleHollowProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC2X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null),
  2798486643: (r, e) => new IFC2X3.IfcRectangularPyramid(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  3454111270: (r, e) => new IFC2X3.IfcRectangularTrimmedSurface(r, new Handle(e[0].value), new IFC2X3.IfcParameterValue(e[1].value), new IFC2X3.IfcParameterValue(e[2].value), new IFC2X3.IfcParameterValue(e[3].value), new IFC2X3.IfcParameterValue(e[4].value), e[5].value, e[6].value),
  3939117080: (r, e) => new IFC2X3.IfcRelAssigns(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5]),
  1683148259: (r, e) => new IFC2X3.IfcRelAssignsToActor(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2495723537: (r, e) => new IFC2X3.IfcRelAssignsToControl(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1307041759: (r, e) => new IFC2X3.IfcRelAssignsToGroup(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  4278684876: (r, e) => new IFC2X3.IfcRelAssignsToProcess(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2857406711: (r, e) => new IFC2X3.IfcRelAssignsToProduct(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  3372526763: (r, e) => new IFC2X3.IfcRelAssignsToProjectOrder(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  205026976: (r, e) => new IFC2X3.IfcRelAssignsToResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1865459582: (r, e) => new IFC2X3.IfcRelAssociates(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  1327628568: (r, e) => new IFC2X3.IfcRelAssociatesAppliedValue(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4095574036: (r, e) => new IFC2X3.IfcRelAssociatesApproval(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  919958153: (r, e) => new IFC2X3.IfcRelAssociatesClassification(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2728634034: (r, e) => new IFC2X3.IfcRelAssociatesConstraint(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new IFC2X3.IfcLabel(e[5].value), new Handle(e[6].value)),
  982818633: (r, e) => new IFC2X3.IfcRelAssociatesDocument(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3840914261: (r, e) => new IFC2X3.IfcRelAssociatesLibrary(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2655215786: (r, e) => new IFC2X3.IfcRelAssociatesMaterial(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2851387026: (r, e) => new IFC2X3.IfcRelAssociatesProfileProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  826625072: (r, e) => new IFC2X3.IfcRelConnects(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null),
  1204542856: (r, e) => new IFC2X3.IfcRelConnectsElements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value)),
  3945020480: (r, e) => new IFC2X3.IfcRelConnectsPathElements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => s.value) : null, e[8] ? e[8].map((s) => s.value) : null, e[9], e[10]),
  4201705270: (r, e) => new IFC2X3.IfcRelConnectsPortToElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  3190031847: (r, e) => new IFC2X3.IfcRelConnectsPorts(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null),
  2127690289: (r, e) => new IFC2X3.IfcRelConnectsStructuralActivity(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  3912681535: (r, e) => new IFC2X3.IfcRelConnectsStructuralElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1638771189: (r, e) => new IFC2X3.IfcRelConnectsStructuralMember(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC2X3.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null),
  504942748: (r, e) => new IFC2X3.IfcRelConnectsWithEccentricity(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC2X3.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, new Handle(e[10].value)),
  3678494232: (r, e) => new IFC2X3.IfcRelConnectsWithRealizingElements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7].map((s) => new Handle(s.value)), e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3242617779: (r, e) => new IFC2X3.IfcRelContainedInSpatialStructure(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  886880790: (r, e) => new IFC2X3.IfcRelCoversBldgElements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2802773753: (r, e) => new IFC2X3.IfcRelCoversSpaces(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2551354335: (r, e) => new IFC2X3.IfcRelDecomposes(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  693640335: (r, e) => new IFC2X3.IfcRelDefines(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  4186316022: (r, e) => new IFC2X3.IfcRelDefinesByProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  781010003: (r, e) => new IFC2X3.IfcRelDefinesByType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3940055652: (r, e) => new IFC2X3.IfcRelFillsElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  279856033: (r, e) => new IFC2X3.IfcRelFlowControlElements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4189434867: (r, e) => new IFC2X3.IfcRelInteractionRequirements(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcCountMeasure(e[4].value) : null, e[5] ? new IFC2X3.IfcNormalisedRatioMeasure(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), new Handle(e[8].value)),
  3268803585: (r, e) => new IFC2X3.IfcRelNests(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2051452291: (r, e) => new IFC2X3.IfcRelOccupiesSpaces(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  202636808: (r, e) => new IFC2X3.IfcRelOverridesProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value), e[6].map((s) => new Handle(s.value))),
  750771296: (r, e) => new IFC2X3.IfcRelProjectsElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1245217292: (r, e) => new IFC2X3.IfcRelReferencedInSpatialStructure(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  1058617721: (r, e) => new IFC2X3.IfcRelSchedulesCostItems(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  4122056220: (r, e) => new IFC2X3.IfcRelSequence(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), new IFC2X3.IfcTimeMeasure(e[6].value), e[7]),
  366585022: (r, e) => new IFC2X3.IfcRelServicesBuildings(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  3451746338: (r, e) => new IFC2X3.IfcRelSpaceBoundary(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8]),
  1401173127: (r, e) => new IFC2X3.IfcRelVoidsElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  2914609552: (r, e) => new IFC2X3.IfcResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  1856042241: (r, e) => new IFC2X3.IfcRevolvedAreaSolid(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC2X3.IfcPlaneAngleMeasure(e[3].value)),
  4158566097: (r, e) => new IFC2X3.IfcRightCircularCone(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value)),
  3626867408: (r, e) => new IFC2X3.IfcRightCircularCylinder(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value)),
  2706606064: (r, e) => new IFC2X3.IfcSpatialStructureElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8]),
  3893378262: (r, e) => new IFC2X3.IfcSpatialStructureElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  451544542: (r, e) => new IFC2X3.IfcSphere(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value)),
  3544373492: (r, e) => new IFC2X3.IfcStructuralActivity(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3136571912: (r, e) => new IFC2X3.IfcStructuralItem(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  530289379: (r, e) => new IFC2X3.IfcStructuralMember(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3689010777: (r, e) => new IFC2X3.IfcStructuralReaction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3979015343: (r, e) => new IFC2X3.IfcStructuralSurfaceMember(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null),
  2218152070: (r, e) => new IFC2X3.IfcStructuralSurfaceMemberVarying(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9].map((s) => new IFC2X3.IfcPositiveLengthMeasure(s.value)), new Handle(e[10].value)),
  4070609034: (r, e) => new IFC2X3.IfcStructuredDimensionCallout(r, e[0].map((s) => new Handle(s.value))),
  2028607225: (r, e) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC2X3.IfcParameterValue(e[3].value), new IFC2X3.IfcParameterValue(e[4].value), new Handle(e[5].value)),
  2809605785: (r, e) => new IFC2X3.IfcSurfaceOfLinearExtrusion(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC2X3.IfcLengthMeasure(e[3].value)),
  4124788165: (r, e) => new IFC2X3.IfcSurfaceOfRevolution(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value)),
  1580310250: (r, e) => new IFC2X3.IfcSystemFurnitureElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3473067441: (r, e) => new IFC2X3.IfcTask(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8].value, e[9] ? e[9].value : null),
  2097647324: (r, e) => new IFC2X3.IfcTransportElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2296667514: (r, e) => new IFC2X3.IfcActor(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new Handle(e[5].value)),
  1674181508: (r, e) => new IFC2X3.IfcAnnotation(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3207858831: (r, e) => new IFC2X3.IfcAsymmetricIShapeProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value), new IFC2X3.IfcPositiveLengthMeasure(e[5].value), new IFC2X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC2X3.IfcPositiveLengthMeasure(e[7].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[8].value), e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcPositiveLengthMeasure(e[11].value) : null),
  1334484129: (r, e) => new IFC2X3.IfcBlock(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value)),
  3649129432: (r, e) => new IFC2X3.IfcBooleanClippingResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  1260505505: (r, e) => new IFC2X3.IfcBoundedCurve(r),
  4031249490: (r, e) => new IFC2X3.IfcBuilding(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC2X3.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcLengthMeasure(e[10].value) : null, e[11] ? new Handle(e[11].value) : null),
  1950629157: (r, e) => new IFC2X3.IfcBuildingElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3124254112: (r, e) => new IFC2X3.IfcBuildingStorey(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC2X3.IfcLengthMeasure(e[9].value) : null),
  2937912522: (r, e) => new IFC2X3.IfcCircleHollowProfileDef(r, e[0], e[1] ? new IFC2X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC2X3.IfcPositiveLengthMeasure(e[3].value), new IFC2X3.IfcPositiveLengthMeasure(e[4].value)),
  300633059: (r, e) => new IFC2X3.IfcColumnType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3732776249: (r, e) => new IFC2X3.IfcCompositeCurve(r, e[0].map((s) => new Handle(s.value)), e[1].value),
  2510884976: (r, e) => new IFC2X3.IfcConic(r, new Handle(e[0].value)),
  2559216714: (r, e) => new IFC2X3.IfcConstructionResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  3293443760: (r, e) => new IFC2X3.IfcControl(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  3895139033: (r, e) => new IFC2X3.IfcCostItem(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  1419761937: (r, e) => new IFC2X3.IfcCostSchedule(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, new IFC2X3.IfcIdentifier(e[11].value), e[12]),
  1916426348: (r, e) => new IFC2X3.IfcCoveringType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3295246426: (r, e) => new IFC2X3.IfcCrewResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  1457835157: (r, e) => new IFC2X3.IfcCurtainWallType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  681481545: (r, e) => new IFC2X3.IfcDimensionCurveDirectedCallout(r, e[0].map((s) => new Handle(s.value))),
  3256556792: (r, e) => new IFC2X3.IfcDistributionElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3849074793: (r, e) => new IFC2X3.IfcDistributionFlowElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  360485395: (r, e) => new IFC2X3.IfcElectricalBaseProperties(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4], e[5] ? new IFC2X3.IfcLabel(e[5].value) : null, e[6], new IFC2X3.IfcElectricVoltageMeasure(e[7].value), new IFC2X3.IfcFrequencyMeasure(e[8].value), e[9] ? new IFC2X3.IfcElectricCurrentMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcElectricCurrentMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcPowerMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcPowerMeasure(e[12].value) : null, e[13].value),
  1758889154: (r, e) => new IFC2X3.IfcElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  4123344466: (r, e) => new IFC2X3.IfcElementAssembly(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  1623761950: (r, e) => new IFC2X3.IfcElementComponent(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2590856083: (r, e) => new IFC2X3.IfcElementComponentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1704287377: (r, e) => new IFC2X3.IfcEllipse(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value), new IFC2X3.IfcPositiveLengthMeasure(e[2].value)),
  2107101300: (r, e) => new IFC2X3.IfcEnergyConversionDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1962604670: (r, e) => new IFC2X3.IfcEquipmentElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3272907226: (r, e) => new IFC2X3.IfcEquipmentStandard(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  3174744832: (r, e) => new IFC2X3.IfcEvaporativeCoolerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3390157468: (r, e) => new IFC2X3.IfcEvaporatorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  807026263: (r, e) => new IFC2X3.IfcFacetedBrep(r, new Handle(e[0].value)),
  3737207727: (r, e) => new IFC2X3.IfcFacetedBrepWithVoids(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  647756555: (r, e) => new IFC2X3.IfcFastener(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2489546625: (r, e) => new IFC2X3.IfcFastenerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  2827207264: (r, e) => new IFC2X3.IfcFeatureElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2143335405: (r, e) => new IFC2X3.IfcFeatureElementAddition(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1287392070: (r, e) => new IFC2X3.IfcFeatureElementSubtraction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3907093117: (r, e) => new IFC2X3.IfcFlowControllerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3198132628: (r, e) => new IFC2X3.IfcFlowFittingType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3815607619: (r, e) => new IFC2X3.IfcFlowMeterType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1482959167: (r, e) => new IFC2X3.IfcFlowMovingDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1834744321: (r, e) => new IFC2X3.IfcFlowSegmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1339347760: (r, e) => new IFC2X3.IfcFlowStorageDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  2297155007: (r, e) => new IFC2X3.IfcFlowTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3009222698: (r, e) => new IFC2X3.IfcFlowTreatmentDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  263784265: (r, e) => new IFC2X3.IfcFurnishingElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  814719939: (r, e) => new IFC2X3.IfcFurnitureStandard(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  200128114: (r, e) => new IFC2X3.IfcGasTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3009204131: (r, e) => new IFC2X3.IfcGrid(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7].map((s) => new Handle(s.value)), e[8].map((s) => new Handle(s.value)), e[9] ? e[9].map((s) => new Handle(s.value)) : null),
  2706460486: (r, e) => new IFC2X3.IfcGroup(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  1251058090: (r, e) => new IFC2X3.IfcHeatExchangerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1806887404: (r, e) => new IFC2X3.IfcHumidifierType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2391368822: (r, e) => new IFC2X3.IfcInventory(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5], new Handle(e[6].value), e[7].map((s) => new Handle(s.value)), new Handle(e[8].value), e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  4288270099: (r, e) => new IFC2X3.IfcJunctionBoxType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3827777499: (r, e) => new IFC2X3.IfcLaborResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null, e[9] ? new IFC2X3.IfcText(e[9].value) : null),
  1051575348: (r, e) => new IFC2X3.IfcLampType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1161773419: (r, e) => new IFC2X3.IfcLightFixtureType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2506943328: (r, e) => new IFC2X3.IfcLinearDimension(r, e[0].map((s) => new Handle(s.value))),
  377706215: (r, e) => new IFC2X3.IfcMechanicalFastener(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null),
  2108223431: (r, e) => new IFC2X3.IfcMechanicalFastenerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3181161470: (r, e) => new IFC2X3.IfcMemberType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  977012517: (r, e) => new IFC2X3.IfcMotorConnectionType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1916936684: (r, e) => new IFC2X3.IfcMove(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8].value, e[9] ? e[9].value : null, new Handle(e[10].value), new Handle(e[11].value), e[12] ? e[12].map((s) => new IFC2X3.IfcText(s.value)) : null),
  4143007308: (r, e) => new IFC2X3.IfcOccupant(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new Handle(e[5].value), e[6]),
  3588315303: (r, e) => new IFC2X3.IfcOpeningElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3425660407: (r, e) => new IFC2X3.IfcOrderAction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8].value, e[9] ? e[9].value : null, new IFC2X3.IfcIdentifier(e[10].value)),
  2837617999: (r, e) => new IFC2X3.IfcOutletType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2382730787: (r, e) => new IFC2X3.IfcPerformanceHistory(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcLabel(e[5].value)),
  3327091369: (r, e) => new IFC2X3.IfcPermit(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value)),
  804291784: (r, e) => new IFC2X3.IfcPipeFittingType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  4231323485: (r, e) => new IFC2X3.IfcPipeSegmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  4017108033: (r, e) => new IFC2X3.IfcPlateType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3724593414: (r, e) => new IFC2X3.IfcPolyline(r, e[0].map((s) => new Handle(s.value))),
  3740093272: (r, e) => new IFC2X3.IfcPort(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  2744685151: (r, e) => new IFC2X3.IfcProcedure(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6], e[7] ? new IFC2X3.IfcLabel(e[7].value) : null),
  2904328755: (r, e) => new IFC2X3.IfcProjectOrder(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6], e[7] ? new IFC2X3.IfcLabel(e[7].value) : null),
  3642467123: (r, e) => new IFC2X3.IfcProjectOrderRecord(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value)), e[6]),
  3651124850: (r, e) => new IFC2X3.IfcProjectionElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1842657554: (r, e) => new IFC2X3.IfcProtectiveDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2250791053: (r, e) => new IFC2X3.IfcPumpType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3248260540: (r, e) => new IFC2X3.IfcRadiusDimension(r, e[0].map((s) => new Handle(s.value))),
  2893384427: (r, e) => new IFC2X3.IfcRailingType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2324767716: (r, e) => new IFC2X3.IfcRampFlightType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  160246688: (r, e) => new IFC2X3.IfcRelAggregates(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2863920197: (r, e) => new IFC2X3.IfcRelAssignsTasks(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  1768891740: (r, e) => new IFC2X3.IfcSanitaryTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3517283431: (r, e) => new IFC2X3.IfcScheduleTimeControl(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12] ? new Handle(e[12].value) : null, e[13] ? new IFC2X3.IfcTimeMeasure(e[13].value) : null, e[14] ? new IFC2X3.IfcTimeMeasure(e[14].value) : null, e[15] ? new IFC2X3.IfcTimeMeasure(e[15].value) : null, e[16] ? new IFC2X3.IfcTimeMeasure(e[16].value) : null, e[17] ? new IFC2X3.IfcTimeMeasure(e[17].value) : null, e[18] ? e[18].value : null, e[19] ? new Handle(e[19].value) : null, e[20] ? new IFC2X3.IfcTimeMeasure(e[20].value) : null, e[21] ? new IFC2X3.IfcTimeMeasure(e[21].value) : null, e[22] ? new IFC2X3.IfcPositiveRatioMeasure(e[22].value) : null),
  4105383287: (r, e) => new IFC2X3.IfcServiceLife(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5], new IFC2X3.IfcTimeMeasure(e[6].value)),
  4097777520: (r, e) => new IFC2X3.IfcSite(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC2X3.IfcCompoundPlaneAngleMeasure(e[9].map((s) => s.value)) : null, e[10] ? new IFC2X3.IfcCompoundPlaneAngleMeasure(e[10].map((s) => s.value)) : null, e[11] ? new IFC2X3.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC2X3.IfcLabel(e[12].value) : null, e[13] ? new Handle(e[13].value) : null),
  2533589738: (r, e) => new IFC2X3.IfcSlabType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3856911033: (r, e) => new IFC2X3.IfcSpace(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10] ? new IFC2X3.IfcLengthMeasure(e[10].value) : null),
  1305183839: (r, e) => new IFC2X3.IfcSpaceHeaterType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  652456506: (r, e) => new IFC2X3.IfcSpaceProgram(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), e[6] ? new IFC2X3.IfcAreaMeasure(e[6].value) : null, e[7] ? new IFC2X3.IfcAreaMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, new IFC2X3.IfcAreaMeasure(e[9].value)),
  3812236995: (r, e) => new IFC2X3.IfcSpaceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3112655638: (r, e) => new IFC2X3.IfcStackTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1039846685: (r, e) => new IFC2X3.IfcStairFlightType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  682877961: (r, e) => new IFC2X3.IfcStructuralAction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null),
  1179482911: (r, e) => new IFC2X3.IfcStructuralConnection(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  4243806635: (r, e) => new IFC2X3.IfcStructuralCurveConnection(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  214636428: (r, e) => new IFC2X3.IfcStructuralCurveMember(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  2445595289: (r, e) => new IFC2X3.IfcStructuralCurveMemberVarying(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  1807405624: (r, e) => new IFC2X3.IfcStructuralLinearAction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null, e[11]),
  1721250024: (r, e) => new IFC2X3.IfcStructuralLinearActionVarying(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null, e[11], new Handle(e[12].value), e[13].map((s) => new Handle(s.value))),
  1252848954: (r, e) => new IFC2X3.IfcStructuralLoadGroup(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5], e[6], e[7], e[8] ? new IFC2X3.IfcRatioMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcLabel(e[9].value) : null),
  1621171031: (r, e) => new IFC2X3.IfcStructuralPlanarAction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null, e[11]),
  3987759626: (r, e) => new IFC2X3.IfcStructuralPlanarActionVarying(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null, e[11], new Handle(e[12].value), e[13].map((s) => new Handle(s.value))),
  2082059205: (r, e) => new IFC2X3.IfcStructuralPointAction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9].value, e[10] ? new Handle(e[10].value) : null),
  734778138: (r, e) => new IFC2X3.IfcStructuralPointConnection(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  1235345126: (r, e) => new IFC2X3.IfcStructuralPointReaction(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  2986769608: (r, e) => new IFC2X3.IfcStructuralResultGroup(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7].value),
  1975003073: (r, e) => new IFC2X3.IfcStructuralSurfaceConnection(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  148013059: (r, e) => new IFC2X3.IfcSubContractResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new IFC2X3.IfcText(e[10].value) : null),
  2315554128: (r, e) => new IFC2X3.IfcSwitchingDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2254336722: (r, e) => new IFC2X3.IfcSystem(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  5716631: (r, e) => new IFC2X3.IfcTankType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1637806684: (r, e) => new IFC2X3.IfcTimeSeriesSchedule(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6], new Handle(e[7].value)),
  1692211062: (r, e) => new IFC2X3.IfcTransformerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1620046519: (r, e) => new IFC2X3.IfcTransportElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8], e[9] ? new IFC2X3.IfcMassMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcCountMeasure(e[10].value) : null),
  3593883385: (r, e) => new IFC2X3.IfcTrimmedCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value)), e[3].value, e[4]),
  1600972822: (r, e) => new IFC2X3.IfcTubeBundleType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1911125066: (r, e) => new IFC2X3.IfcUnitaryEquipmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  728799441: (r, e) => new IFC2X3.IfcValveType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2769231204: (r, e) => new IFC2X3.IfcVirtualElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1898987631: (r, e) => new IFC2X3.IfcWallType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1133259667: (r, e) => new IFC2X3.IfcWasteTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1028945134: (r, e) => new IFC2X3.IfcWorkControl(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? new IFC2X3.IfcTimeMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcTimeMeasure(e[10].value) : null, new Handle(e[11].value), e[12] ? new Handle(e[12].value) : null, e[13], e[14] ? new IFC2X3.IfcLabel(e[14].value) : null),
  4218914973: (r, e) => new IFC2X3.IfcWorkPlan(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? new IFC2X3.IfcTimeMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcTimeMeasure(e[10].value) : null, new Handle(e[11].value), e[12] ? new Handle(e[12].value) : null, e[13], e[14] ? new IFC2X3.IfcLabel(e[14].value) : null),
  3342526732: (r, e) => new IFC2X3.IfcWorkSchedule(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? new IFC2X3.IfcTimeMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcTimeMeasure(e[10].value) : null, new Handle(e[11].value), e[12] ? new Handle(e[12].value) : null, e[13], e[14] ? new IFC2X3.IfcLabel(e[14].value) : null),
  1033361043: (r, e) => new IFC2X3.IfcZone(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  1213861670: (r, e) => new IFC2X3.Ifc2DCompositeCurve(r, e[0].map((s) => new Handle(s.value)), e[1].value),
  3821786052: (r, e) => new IFC2X3.IfcActionRequest(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value)),
  1411407467: (r, e) => new IFC2X3.IfcAirTerminalBoxType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3352864051: (r, e) => new IFC2X3.IfcAirTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1871374353: (r, e) => new IFC2X3.IfcAirToAirHeatRecoveryType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2470393545: (r, e) => new IFC2X3.IfcAngularDimension(r, e[0].map((s) => new Handle(s.value))),
  3460190687: (r, e) => new IFC2X3.IfcAsset(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new IFC2X3.IfcIdentifier(e[5].value), new Handle(e[6].value), new Handle(e[7].value), new Handle(e[8].value), new Handle(e[9].value), new Handle(e[10].value), new Handle(e[11].value), new Handle(e[12].value), new Handle(e[13].value)),
  1967976161: (r, e) => new IFC2X3.IfcBSplineCurve(r, e[0].value, e[1].map((s) => new Handle(s.value)), e[2], e[3].value, e[4].value),
  819618141: (r, e) => new IFC2X3.IfcBeamType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1916977116: (r, e) => new IFC2X3.IfcBezierCurve(r, e[0].value, e[1].map((s) => new Handle(s.value)), e[2], e[3].value, e[4].value),
  231477066: (r, e) => new IFC2X3.IfcBoilerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3299480353: (r, e) => new IFC2X3.IfcBuildingElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  52481810: (r, e) => new IFC2X3.IfcBuildingElementComponent(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2979338954: (r, e) => new IFC2X3.IfcBuildingElementPart(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1095909175: (r, e) => new IFC2X3.IfcBuildingElementProxy(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  1909888760: (r, e) => new IFC2X3.IfcBuildingElementProxyType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  395041908: (r, e) => new IFC2X3.IfcCableCarrierFittingType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3293546465: (r, e) => new IFC2X3.IfcCableCarrierSegmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1285652485: (r, e) => new IFC2X3.IfcCableSegmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2951183804: (r, e) => new IFC2X3.IfcChillerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2611217952: (r, e) => new IFC2X3.IfcCircle(r, new Handle(e[0].value), new IFC2X3.IfcPositiveLengthMeasure(e[1].value)),
  2301859152: (r, e) => new IFC2X3.IfcCoilType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  843113511: (r, e) => new IFC2X3.IfcColumn(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3850581409: (r, e) => new IFC2X3.IfcCompressorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2816379211: (r, e) => new IFC2X3.IfcCondenserType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2188551683: (r, e) => new IFC2X3.IfcCondition(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  1163958913: (r, e) => new IFC2X3.IfcConditionCriterion(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value)),
  3898045240: (r, e) => new IFC2X3.IfcConstructionEquipmentResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  1060000209: (r, e) => new IFC2X3.IfcConstructionMaterialResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new IFC2X3.IfcRatioMeasure(e[10].value) : null),
  488727124: (r, e) => new IFC2X3.IfcConstructionProductResource(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new IFC2X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC2X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  335055490: (r, e) => new IFC2X3.IfcCooledBeamType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2954562838: (r, e) => new IFC2X3.IfcCoolingTowerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1973544240: (r, e) => new IFC2X3.IfcCovering(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  3495092785: (r, e) => new IFC2X3.IfcCurtainWall(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3961806047: (r, e) => new IFC2X3.IfcDamperType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  4147604152: (r, e) => new IFC2X3.IfcDiameterDimension(r, e[0].map((s) => new Handle(s.value))),
  1335981549: (r, e) => new IFC2X3.IfcDiscreteAccessory(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2635815018: (r, e) => new IFC2X3.IfcDiscreteAccessoryType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1599208980: (r, e) => new IFC2X3.IfcDistributionChamberElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2063403501: (r, e) => new IFC2X3.IfcDistributionControlElementType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  1945004755: (r, e) => new IFC2X3.IfcDistributionElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3040386961: (r, e) => new IFC2X3.IfcDistributionFlowElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3041715199: (r, e) => new IFC2X3.IfcDistributionPort(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  395920057: (r, e) => new IFC2X3.IfcDoor(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null),
  869906466: (r, e) => new IFC2X3.IfcDuctFittingType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3760055223: (r, e) => new IFC2X3.IfcDuctSegmentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2030761528: (r, e) => new IFC2X3.IfcDuctSilencerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  855621170: (r, e) => new IFC2X3.IfcEdgeFeature(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null),
  663422040: (r, e) => new IFC2X3.IfcElectricApplianceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3277789161: (r, e) => new IFC2X3.IfcElectricFlowStorageDeviceType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1534661035: (r, e) => new IFC2X3.IfcElectricGeneratorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1365060375: (r, e) => new IFC2X3.IfcElectricHeaterType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1217240411: (r, e) => new IFC2X3.IfcElectricMotorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  712377611: (r, e) => new IFC2X3.IfcElectricTimeControlType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1634875225: (r, e) => new IFC2X3.IfcElectricalCircuit(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null),
  857184966: (r, e) => new IFC2X3.IfcElectricalElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1658829314: (r, e) => new IFC2X3.IfcEnergyConversionDevice(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  346874300: (r, e) => new IFC2X3.IfcFanType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1810631287: (r, e) => new IFC2X3.IfcFilterType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  4222183408: (r, e) => new IFC2X3.IfcFireSuppressionTerminalType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2058353004: (r, e) => new IFC2X3.IfcFlowController(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  4278956645: (r, e) => new IFC2X3.IfcFlowFitting(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  4037862832: (r, e) => new IFC2X3.IfcFlowInstrumentType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3132237377: (r, e) => new IFC2X3.IfcFlowMovingDevice(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  987401354: (r, e) => new IFC2X3.IfcFlowSegment(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  707683696: (r, e) => new IFC2X3.IfcFlowStorageDevice(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2223149337: (r, e) => new IFC2X3.IfcFlowTerminal(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3508470533: (r, e) => new IFC2X3.IfcFlowTreatmentDevice(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  900683007: (r, e) => new IFC2X3.IfcFooting(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  1073191201: (r, e) => new IFC2X3.IfcMember(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1687234759: (r, e) => new IFC2X3.IfcPile(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  3171933400: (r, e) => new IFC2X3.IfcPlate(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2262370178: (r, e) => new IFC2X3.IfcRailing(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  3024970846: (r, e) => new IFC2X3.IfcRamp(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  3283111854: (r, e) => new IFC2X3.IfcRampFlight(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3055160366: (r, e) => new IFC2X3.IfcRationalBezierCurve(r, e[0].value, e[1].map((s) => new Handle(s.value)), e[2], e[3].value, e[4].value, e[5].map((s) => s.value)),
  3027567501: (r, e) => new IFC2X3.IfcReinforcingElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  2320036040: (r, e) => new IFC2X3.IfcReinforcingMesh(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[11].value), new IFC2X3.IfcPositiveLengthMeasure(e[12].value), new IFC2X3.IfcAreaMeasure(e[13].value), new IFC2X3.IfcAreaMeasure(e[14].value), new IFC2X3.IfcPositiveLengthMeasure(e[15].value), new IFC2X3.IfcPositiveLengthMeasure(e[16].value)),
  2016517767: (r, e) => new IFC2X3.IfcRoof(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  1376911519: (r, e) => new IFC2X3.IfcRoundedEdgeFeature(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null),
  1783015770: (r, e) => new IFC2X3.IfcSensorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1529196076: (r, e) => new IFC2X3.IfcSlab(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  331165859: (r, e) => new IFC2X3.IfcStair(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8]),
  4252922144: (r, e) => new IFC2X3.IfcStairFlight(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? e[8].value : null, e[9] ? e[9].value : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC2X3.IfcPositiveLengthMeasure(e[11].value) : null),
  2515109513: (r, e) => new IFC2X3.IfcStructuralAnalysisModel(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null),
  3824725483: (r, e) => new IFC2X3.IfcTendon(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9], new IFC2X3.IfcPositiveLengthMeasure(e[10].value), new IFC2X3.IfcAreaMeasure(e[11].value), e[12] ? new IFC2X3.IfcForceMeasure(e[12].value) : null, e[13] ? new IFC2X3.IfcPressureMeasure(e[13].value) : null, e[14] ? new IFC2X3.IfcNormalisedRatioMeasure(e[14].value) : null, e[15] ? new IFC2X3.IfcPositiveLengthMeasure(e[15].value) : null, e[16] ? new IFC2X3.IfcPositiveLengthMeasure(e[16].value) : null),
  2347447852: (r, e) => new IFC2X3.IfcTendonAnchor(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null),
  3313531582: (r, e) => new IFC2X3.IfcVibrationIsolatorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  2391406946: (r, e) => new IFC2X3.IfcWall(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3512223829: (r, e) => new IFC2X3.IfcWallStandardCase(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  3304561284: (r, e) => new IFC2X3.IfcWindow(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null),
  2874132201: (r, e) => new IFC2X3.IfcActuatorType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  3001207471: (r, e) => new IFC2X3.IfcAlarmType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  753842376: (r, e) => new IFC2X3.IfcBeam(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  2454782716: (r, e) => new IFC2X3.IfcChamferEdgeFeature(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC2X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC2X3.IfcPositiveLengthMeasure(e[10].value) : null),
  578613899: (r, e) => new IFC2X3.IfcControllerType(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC2X3.IfcLabel(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, e[9]),
  1052013943: (r, e) => new IFC2X3.IfcDistributionChamberElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null),
  1062813311: (r, e) => new IFC2X3.IfcDistributionControlElement(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcIdentifier(e[8].value) : null),
  3700593921: (r, e) => new IFC2X3.IfcElectricDistributionPoint(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8], e[9] ? new IFC2X3.IfcLabel(e[9].value) : null),
  979691226: (r, e) => new IFC2X3.IfcReinforcingBar(r, new IFC2X3.IfcGloballyUniqueId(e[0].value), new Handle(e[1].value), e[2] ? new IFC2X3.IfcLabel(e[2].value) : null, e[3] ? new IFC2X3.IfcText(e[3].value) : null, e[4] ? new IFC2X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC2X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC2X3.IfcLabel(e[8].value) : null, new IFC2X3.IfcPositiveLengthMeasure(e[9].value), new IFC2X3.IfcAreaMeasure(e[10].value), e[11] ? new IFC2X3.IfcPositiveLengthMeasure(e[11].value) : null, e[12], e[13])
};
InheritanceDef[1] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCENVIRONMENTALIMPACTVALUE, IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  3264961684: [IFCCOLOURRGB],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPORTGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  3796139169: [IFCDIMENSIONPAIR, IFCDIMENSIONCALLOUTRELATIONSHIP],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSYMBOL, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  3265635763: [IFCHYGROSCOPICMATERIALPROPERTIES, IFCGENERALMATERIALPROPERTIES, IFCFUELPROPERTIES, IFCEXTENDEDMATERIALPROPERTIES, IFCWATERPROPERTIES, IFCTHERMALMATERIALPROPERTIES, IFCPRODUCTSOFCOMBUSTIONPROPERTIES, IFCOPTICALMATERIALPROPERTIES, IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES, IFCMECHANICALMATERIALPROPERTIES],
  4256014907: [IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES],
  1918398963: [IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL, IFCPREDEFINEDSYMBOL],
  990879717: [IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL],
  1775413392: [IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSYMBOLSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  2802850158: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES, IFCGENERALPROFILEPROPERTIES, IFCRIBPLATEPROFILEPROPERTIES],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE, IFCSTYLEDITEM],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  3958052878: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  280115917: [IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  2442683028: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE],
  3612888222: [IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  2556980723: [IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  1446786286: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  219451334: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT],
  2833995503: [IFCTWODIRECTIONREPEATFACTOR],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  1680319473: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  3843319758: [IFCSTRUCTURALSTEELPROFILEPROPERTIES],
  2513912981: [IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  3028897424: [IFCDIMENSIONCURVETERMINATOR],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT],
  2347495698: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3288037868: [IFCPROJECTIONCURVE, IFCDIMENSIONCURVE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  3073041342: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT],
  339256511: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCPLANE],
  80994333: [IFCELECTRICALBASEPROPERTIES],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  1484403080: [IFCASYMMETRICISHAPEPROFILEDEF],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP],
  3888040117: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS],
  2945172077: [IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR],
  1683148259: [IFCRELOCCUPIESSPACES],
  2495723537: [IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER],
  1865459582: [IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE],
  826625072: [IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES],
  4186316022: [IFCRELOVERRIDESPROPERTIES],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  3473067441: [IFCORDERACTION, IFCMOVE],
  2296667514: [IFCOCCUPANT],
  1260505505: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE],
  3732776249: [IFC2DCOMPOSITECURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM],
  681481545: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE],
  647756555: [IFCMECHANICALFASTENER],
  2489546625: [IFCMECHANICALFASTENERTYPE],
  2827207264: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE],
  2706460486: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3740093272: [IFCDISTRIBUTIONPORT],
  682877961: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1807405624: [IFCSTRUCTURALLINEARACTIONVARYING],
  1621171031: [IFCSTRUCTURALPLANARACTIONVARYING],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE],
  1916977116: [IFCRATIONALBEZIERCURVE],
  3299480353: [IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT],
  52481810: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART],
  2635815018: [IFCVIBRATIONISOLATORTYPE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE],
  855621170: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE],
  2058353004: [IFCELECTRICDISTRIBUTIONPOINT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  2391406946: [IFCWALLSTANDARDCASE]
};
InversePropertyDef[1] = {
  618182010: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  411424972: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, !0], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, !0], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, !0]],
  130549933: [["Actors", IFCAPPROVALACTORRELATIONSHIP, 1, !0], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 0, !0], ["Relates", IFCAPPROVALRELATIONSHIP, 1, !0]],
  747523909: [["Contains", IFCCLASSIFICATIONITEM, 1, !0]],
  1767535486: [["IsClassifiedItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 1, !0], ["IsClassifyingItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 0, !0]],
  1959218052: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, !0], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, !0], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, !0], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, !0], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, !0]],
  602808272: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, !0], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, !0], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, !0]],
  1154170062: [["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 1, !0], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 0, !0]],
  1648886627: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, !0], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, !0], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, !0]],
  852622518: [["PartOfW", IFCGRID, 9, !0], ["PartOfV", IFCGRID, 8, !0], ["PartOfU", IFCGRID, 7, !0], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, !0]],
  3452421091: [["ReferenceIntoLibrary", IFCLIBRARYINFORMATION, 4, !0]],
  1838606355: [["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, !0], ["ClassifiedAs", IFCMATERIALCLASSIFICATIONRELATIONSHIP, 1, !0]],
  248100487: [["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, !1]],
  3368373690: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, !0], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, !0], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, !0], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, !0], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, !0]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  2251480897: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, !0], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, !0], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, !0], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, !0], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, !0]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, !0], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, !0], ["Engages", IFCPERSONANDORGANIZATION, 1, !0]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, !0]],
  2483315170: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2226359599: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3355820592: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  2598011224: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  2044713172: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2093928680: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  931644368: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3252649465: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2405470396: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  825690147: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0]],
  3008791417: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1660063152: [["MapUsage", IFCMAPPEDITEM, 0, !0]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  3692461612: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3958052878: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  531007025: [["OfTable", IFCTABLE, 1, !1]],
  912023232: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  280115917: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, !0]],
  1742049831: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, !0]],
  2552916305: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, !0]],
  3101149627: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, !0]],
  1377556343: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  2799835756: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1907098498: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2442683028: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  962685235: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3612888222: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2297822566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2542286263: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  370225590: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3732053477: [["ReferenceToDocument", IFCDOCUMENTINFORMATION, 3, !0]],
  3900360178: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  476780140: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2556980723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1809719519: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  803316827: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3008276851: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0]],
  2453401579: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0]],
  3590301190: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  812098782: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3741457305: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, !0]],
  1402838566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  125510826: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2604431987: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4266656042: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1520743889: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3422422726: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  1008929658: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2347385850: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  2833995503: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2665983363: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1029017970: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2519244187: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3021840470: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2004835150: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1663979128: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2067069095: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4022376103: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1423911732: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2924175390: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2775532180: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, !0], ["HasShapeAspects", IFCSHAPEASPECT, 4, !0]],
  871118103: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  1680319473: [["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  4166981789: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  2752243245: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  941946838: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  3357820518: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  3650150729: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  110355661: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0]],
  3413951693: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, !0]],
  3765753017: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  1509187699: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2411513650: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  4124623270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  723233188: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2485662743: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  1202362311: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  390701378: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  2233826070: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2513912981: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2247615214: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260650574: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  230924584: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3028897424: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4282788508: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3124975700: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1345879162: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1417489154: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2759199220: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  336235671: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  512836454: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3288037868: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  669184980: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2265737646: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1302238472: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4261334040: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3125803723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2740243338: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2736907675: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4182860854: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2581212453: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2713105998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1123145078: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  59481748: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3749851601: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3486308946: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3331915920: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1416205885: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2205249479: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2485617015: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  2506170314: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2147822146: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2601014836: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2827736869: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  693772133: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  606661476: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["AnnotatedBySymbols", IFCTERMINATORSYMBOL, 3, !0]],
  4054601972: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  32440307: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2963535650: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  1714330368: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3073041342: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  1472233963: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1883228015: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2777663545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  80994333: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  477187591: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2047409740: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  374418227: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4203026998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  315944413: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3455213021: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  987898635: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1281925730: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1425443689: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0]],
  3388369263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3505215534: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3566463478: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  603570806: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  220341763: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0]],
  4194566429: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1451395588: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2798486643: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3454111270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1856042241: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4158566097: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3626867408: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  451544542: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1], ["Causes", IFCSTRUCTURALACTION, 10, !0]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  4070609034: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  2028607225: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2809605785: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4124788165: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1334484129: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3649129432: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260505505: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3732776249: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2510884976: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  681481545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  360485395: [["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1704287377: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1962604670: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3272907226: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  807026263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3737207727: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  814719939: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  200128114: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2506943328: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1916936684: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1], ["HasFillings", IFCRELFILLSELEMENT, 4, !0]],
  3425660407: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3724593414: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !1], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3642467123: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3248260540: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3517283431: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0], ["ScheduleTimeControlAssigned", IFCRELASSIGNSTASKS, 7, !1]],
  4105383287: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["HasCoverings", IFCRELCOVERSSPACES, 4, !0], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, !0]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  652456506: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0], ["HasInteractionReqsFrom", IFCRELINTERACTIONREQUIREMENTS, 7, !0], ["HasInteractionReqsTo", IFCRELINTERACTIONREQUIREMENTS, 8, !0]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  1721250024: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, !0], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, !0]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  3987759626: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !1], ["Causes", IFCSTRUCTURALACTION, 10, !0]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, !0]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1637806684: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3593883385: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1]],
  1213861670: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2470393545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1]],
  1967976161: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1916977116: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  52481810: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2611217952: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2188551683: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1]],
  1163958913: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["CoversSpaces", IFCRELCOVERSSPACES, 5, !0], ["Covers", IFCRELCOVERSBLDGELEMENTS, 5, !0]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  4147604152: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, !0], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, !0]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !1], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  855621170: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1365060375: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1634875225: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  857184966: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3055160366: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  1376911519: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !1], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2454782716: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, !0]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  3700593921: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, !0], ["Decomposes", IFCRELDECOMPOSES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]]
};
Constructors[1] = {
  3630933823: (r, e) => new IFC2X3.IfcActorRole(r, e[0], e[1], e[2]),
  618182010: (r, e) => new IFC2X3.IfcAddress(r, e[0], e[1], e[2]),
  639542469: (r, e) => new IFC2X3.IfcApplication(r, e[0], e[1], e[2], e[3]),
  411424972: (r, e) => new IFC2X3.IfcAppliedValue(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1110488051: (r, e) => new IFC2X3.IfcAppliedValueRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  130549933: (r, e) => new IFC2X3.IfcApproval(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2080292479: (r, e) => new IFC2X3.IfcApprovalActorRelationship(r, e[0], e[1], e[2]),
  390851274: (r, e) => new IFC2X3.IfcApprovalPropertyRelationship(r, e[0], e[1]),
  3869604511: (r, e) => new IFC2X3.IfcApprovalRelationship(r, e[0], e[1], e[2], e[3]),
  4037036970: (r, e) => new IFC2X3.IfcBoundaryCondition(r, e[0]),
  1560379544: (r, e) => new IFC2X3.IfcBoundaryEdgeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (r, e) => new IFC2X3.IfcBoundaryFaceCondition(r, e[0], e[1], e[2], e[3]),
  1387855156: (r, e) => new IFC2X3.IfcBoundaryNodeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (r, e) => new IFC2X3.IfcBoundaryNodeConditionWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  622194075: (r, e) => new IFC2X3.IfcCalendarDate(r, e[0], e[1], e[2]),
  747523909: (r, e) => new IFC2X3.IfcClassification(r, e[0], e[1], e[2], e[3]),
  1767535486: (r, e) => new IFC2X3.IfcClassificationItem(r, e[0], e[1], e[2]),
  1098599126: (r, e) => new IFC2X3.IfcClassificationItemRelationship(r, e[0], e[1]),
  938368621: (r, e) => new IFC2X3.IfcClassificationNotation(r, e[0]),
  3639012971: (r, e) => new IFC2X3.IfcClassificationNotationFacet(r, e[0]),
  3264961684: (r, e) => new IFC2X3.IfcColourSpecification(r, e[0]),
  2859738748: (r, e) => new IFC2X3.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC2X3.IfcConnectionPointGeometry(r, e[0], e[1]),
  4257277454: (r, e) => new IFC2X3.IfcConnectionPortGeometry(r, e[0], e[1], e[2]),
  2732653382: (r, e) => new IFC2X3.IfcConnectionSurfaceGeometry(r, e[0], e[1]),
  1959218052: (r, e) => new IFC2X3.IfcConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1658513725: (r, e) => new IFC2X3.IfcConstraintAggregationRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  613356794: (r, e) => new IFC2X3.IfcConstraintClassificationRelationship(r, e[0], e[1]),
  347226245: (r, e) => new IFC2X3.IfcConstraintRelationship(r, e[0], e[1], e[2], e[3]),
  1065062679: (r, e) => new IFC2X3.IfcCoordinatedUniversalTimeOffset(r, e[0], e[1], e[2]),
  602808272: (r, e) => new IFC2X3.IfcCostValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  539742890: (r, e) => new IFC2X3.IfcCurrencyRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  1105321065: (r, e) => new IFC2X3.IfcCurveStyleFont(r, e[0], e[1]),
  2367409068: (r, e) => new IFC2X3.IfcCurveStyleFontAndScaling(r, e[0], e[1], e[2]),
  3510044353: (r, e) => new IFC2X3.IfcCurveStyleFontPattern(r, e[0], e[1]),
  1072939445: (r, e) => new IFC2X3.IfcDateAndTime(r, e[0], e[1]),
  1765591967: (r, e) => new IFC2X3.IfcDerivedUnit(r, e[0], e[1], e[2]),
  1045800335: (r, e) => new IFC2X3.IfcDerivedUnitElement(r, e[0], e[1]),
  2949456006: (r, e) => new IFC2X3.IfcDimensionalExponents(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1376555844: (r, e) => new IFC2X3.IfcDocumentElectronicFormat(r, e[0], e[1], e[2]),
  1154170062: (r, e) => new IFC2X3.IfcDocumentInformation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (r, e) => new IFC2X3.IfcDocumentInformationRelationship(r, e[0], e[1], e[2]),
  3796139169: (r, e) => new IFC2X3.IfcDraughtingCalloutRelationship(r, e[0], e[1], e[2], e[3]),
  1648886627: (r, e) => new IFC2X3.IfcEnvironmentalImpactValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3200245327: (r, e) => new IFC2X3.IfcExternalReference(r, e[0], e[1], e[2]),
  2242383968: (r, e) => new IFC2X3.IfcExternallyDefinedHatchStyle(r, e[0], e[1], e[2]),
  1040185647: (r, e) => new IFC2X3.IfcExternallyDefinedSurfaceStyle(r, e[0], e[1], e[2]),
  3207319532: (r, e) => new IFC2X3.IfcExternallyDefinedSymbol(r, e[0], e[1], e[2]),
  3548104201: (r, e) => new IFC2X3.IfcExternallyDefinedTextFont(r, e[0], e[1], e[2]),
  852622518: (r, e) => new IFC2X3.IfcGridAxis(r, e[0], e[1], e[2]),
  3020489413: (r, e) => new IFC2X3.IfcIrregularTimeSeriesValue(r, e[0], e[1]),
  2655187982: (r, e) => new IFC2X3.IfcLibraryInformation(r, e[0], e[1], e[2], e[3], e[4]),
  3452421091: (r, e) => new IFC2X3.IfcLibraryReference(r, e[0], e[1], e[2]),
  4162380809: (r, e) => new IFC2X3.IfcLightDistributionData(r, e[0], e[1], e[2]),
  1566485204: (r, e) => new IFC2X3.IfcLightIntensityDistribution(r, e[0], e[1]),
  30780891: (r, e) => new IFC2X3.IfcLocalTime(r, e[0], e[1], e[2], e[3], e[4]),
  1838606355: (r, e) => new IFC2X3.IfcMaterial(r, e[0]),
  1847130766: (r, e) => new IFC2X3.IfcMaterialClassificationRelationship(r, e[0], e[1]),
  248100487: (r, e) => new IFC2X3.IfcMaterialLayer(r, e[0], e[1], e[2]),
  3303938423: (r, e) => new IFC2X3.IfcMaterialLayerSet(r, e[0], e[1]),
  1303795690: (r, e) => new IFC2X3.IfcMaterialLayerSetUsage(r, e[0], e[1], e[2], e[3]),
  2199411900: (r, e) => new IFC2X3.IfcMaterialList(r, e[0]),
  3265635763: (r, e) => new IFC2X3.IfcMaterialProperties(r, e[0]),
  2597039031: (r, e) => new IFC2X3.IfcMeasureWithUnit(r, e[0], e[1]),
  4256014907: (r, e) => new IFC2X3.IfcMechanicalMaterialProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  677618848: (r, e) => new IFC2X3.IfcMechanicalSteelMaterialProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3368373690: (r, e) => new IFC2X3.IfcMetric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2706619895: (r, e) => new IFC2X3.IfcMonetaryUnit(r, e[0]),
  1918398963: (r, e) => new IFC2X3.IfcNamedUnit(r, e[0], e[1]),
  3701648758: (r, e) => new IFC2X3.IfcObjectPlacement(r),
  2251480897: (r, e) => new IFC2X3.IfcObjective(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1227763645: (r, e) => new IFC2X3.IfcOpticalMaterialProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4251960020: (r, e) => new IFC2X3.IfcOrganization(r, e[0], e[1], e[2], e[3], e[4]),
  1411181986: (r, e) => new IFC2X3.IfcOrganizationRelationship(r, e[0], e[1], e[2], e[3]),
  1207048766: (r, e) => new IFC2X3.IfcOwnerHistory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (r, e) => new IFC2X3.IfcPerson(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (r, e) => new IFC2X3.IfcPersonAndOrganization(r, e[0], e[1], e[2]),
  2483315170: (r, e) => new IFC2X3.IfcPhysicalQuantity(r, e[0], e[1]),
  2226359599: (r, e) => new IFC2X3.IfcPhysicalSimpleQuantity(r, e[0], e[1], e[2]),
  3355820592: (r, e) => new IFC2X3.IfcPostalAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3727388367: (r, e) => new IFC2X3.IfcPreDefinedItem(r, e[0]),
  990879717: (r, e) => new IFC2X3.IfcPreDefinedSymbol(r, e[0]),
  3213052703: (r, e) => new IFC2X3.IfcPreDefinedTerminatorSymbol(r, e[0]),
  1775413392: (r, e) => new IFC2X3.IfcPreDefinedTextFont(r, e[0]),
  2022622350: (r, e) => new IFC2X3.IfcPresentationLayerAssignment(r, e[0], e[1], e[2], e[3]),
  1304840413: (r, e) => new IFC2X3.IfcPresentationLayerWithStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (r, e) => new IFC2X3.IfcPresentationStyle(r, e[0]),
  2417041796: (r, e) => new IFC2X3.IfcPresentationStyleAssignment(r, e[0]),
  2095639259: (r, e) => new IFC2X3.IfcProductRepresentation(r, e[0], e[1], e[2]),
  2267347899: (r, e) => new IFC2X3.IfcProductsOfCombustionProperties(r, e[0], e[1], e[2], e[3], e[4]),
  3958567839: (r, e) => new IFC2X3.IfcProfileDef(r, e[0], e[1]),
  2802850158: (r, e) => new IFC2X3.IfcProfileProperties(r, e[0], e[1]),
  2598011224: (r, e) => new IFC2X3.IfcProperty(r, e[0], e[1]),
  3896028662: (r, e) => new IFC2X3.IfcPropertyConstraintRelationship(r, e[0], e[1], e[2], e[3]),
  148025276: (r, e) => new IFC2X3.IfcPropertyDependencyRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  3710013099: (r, e) => new IFC2X3.IfcPropertyEnumeration(r, e[0], e[1], e[2]),
  2044713172: (r, e) => new IFC2X3.IfcQuantityArea(r, e[0], e[1], e[2], e[3]),
  2093928680: (r, e) => new IFC2X3.IfcQuantityCount(r, e[0], e[1], e[2], e[3]),
  931644368: (r, e) => new IFC2X3.IfcQuantityLength(r, e[0], e[1], e[2], e[3]),
  3252649465: (r, e) => new IFC2X3.IfcQuantityTime(r, e[0], e[1], e[2], e[3]),
  2405470396: (r, e) => new IFC2X3.IfcQuantityVolume(r, e[0], e[1], e[2], e[3]),
  825690147: (r, e) => new IFC2X3.IfcQuantityWeight(r, e[0], e[1], e[2], e[3]),
  2692823254: (r, e) => new IFC2X3.IfcReferencesValueDocument(r, e[0], e[1], e[2], e[3]),
  1580146022: (r, e) => new IFC2X3.IfcReinforcementBarProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1222501353: (r, e) => new IFC2X3.IfcRelaxation(r, e[0], e[1]),
  1076942058: (r, e) => new IFC2X3.IfcRepresentation(r, e[0], e[1], e[2], e[3]),
  3377609919: (r, e) => new IFC2X3.IfcRepresentationContext(r, e[0], e[1]),
  3008791417: (r, e) => new IFC2X3.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC2X3.IfcRepresentationMap(r, e[0], e[1]),
  3679540991: (r, e) => new IFC2X3.IfcRibPlateProfileProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2341007311: (r, e) => new IFC2X3.IfcRoot(r, e[0], e[1], e[2], e[3]),
  448429030: (r, e) => new IFC2X3.IfcSIUnit(r, e[0], e[1], e[2]),
  2042790032: (r, e) => new IFC2X3.IfcSectionProperties(r, e[0], e[1], e[2]),
  4165799628: (r, e) => new IFC2X3.IfcSectionReinforcementProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  867548509: (r, e) => new IFC2X3.IfcShapeAspect(r, e[0], e[1], e[2], e[3], e[4]),
  3982875396: (r, e) => new IFC2X3.IfcShapeModel(r, e[0], e[1], e[2], e[3]),
  4240577450: (r, e) => new IFC2X3.IfcShapeRepresentation(r, e[0], e[1], e[2], e[3]),
  3692461612: (r, e) => new IFC2X3.IfcSimpleProperty(r, e[0], e[1]),
  2273995522: (r, e) => new IFC2X3.IfcStructuralConnectionCondition(r, e[0]),
  2162789131: (r, e) => new IFC2X3.IfcStructuralLoad(r, e[0]),
  2525727697: (r, e) => new IFC2X3.IfcStructuralLoadStatic(r, e[0]),
  3408363356: (r, e) => new IFC2X3.IfcStructuralLoadTemperature(r, e[0], e[1], e[2], e[3]),
  2830218821: (r, e) => new IFC2X3.IfcStyleModel(r, e[0], e[1], e[2], e[3]),
  3958052878: (r, e) => new IFC2X3.IfcStyledItem(r, e[0], e[1], e[2]),
  3049322572: (r, e) => new IFC2X3.IfcStyledRepresentation(r, e[0], e[1], e[2], e[3]),
  1300840506: (r, e) => new IFC2X3.IfcSurfaceStyle(r, e[0], e[1], e[2]),
  3303107099: (r, e) => new IFC2X3.IfcSurfaceStyleLighting(r, e[0], e[1], e[2], e[3]),
  1607154358: (r, e) => new IFC2X3.IfcSurfaceStyleRefraction(r, e[0], e[1]),
  846575682: (r, e) => new IFC2X3.IfcSurfaceStyleShading(r, e[0]),
  1351298697: (r, e) => new IFC2X3.IfcSurfaceStyleWithTextures(r, e[0]),
  626085974: (r, e) => new IFC2X3.IfcSurfaceTexture(r, e[0], e[1], e[2], e[3]),
  1290481447: (r, e) => new IFC2X3.IfcSymbolStyle(r, e[0], e[1]),
  985171141: (r, e) => new IFC2X3.IfcTable(r, e[0], e[1]),
  531007025: (r, e) => new IFC2X3.IfcTableRow(r, e[0], e[1]),
  912023232: (r, e) => new IFC2X3.IfcTelecomAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1447204868: (r, e) => new IFC2X3.IfcTextStyle(r, e[0], e[1], e[2], e[3]),
  1983826977: (r, e) => new IFC2X3.IfcTextStyleFontModel(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2636378356: (r, e) => new IFC2X3.IfcTextStyleForDefinedFont(r, e[0], e[1]),
  1640371178: (r, e) => new IFC2X3.IfcTextStyleTextModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1484833681: (r, e) => new IFC2X3.IfcTextStyleWithBoxCharacteristics(r, e[0], e[1], e[2], e[3], e[4]),
  280115917: (r, e) => new IFC2X3.IfcTextureCoordinate(r),
  1742049831: (r, e) => new IFC2X3.IfcTextureCoordinateGenerator(r, e[0], e[1]),
  2552916305: (r, e) => new IFC2X3.IfcTextureMap(r, e[0]),
  1210645708: (r, e) => new IFC2X3.IfcTextureVertex(r, e[0]),
  3317419933: (r, e) => new IFC2X3.IfcThermalMaterialProperties(r, e[0], e[1], e[2], e[3], e[4]),
  3101149627: (r, e) => new IFC2X3.IfcTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1718945513: (r, e) => new IFC2X3.IfcTimeSeriesReferenceRelationship(r, e[0], e[1]),
  581633288: (r, e) => new IFC2X3.IfcTimeSeriesValue(r, e[0]),
  1377556343: (r, e) => new IFC2X3.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC2X3.IfcTopologyRepresentation(r, e[0], e[1], e[2], e[3]),
  180925521: (r, e) => new IFC2X3.IfcUnitAssignment(r, e[0]),
  2799835756: (r, e) => new IFC2X3.IfcVertex(r),
  3304826586: (r, e) => new IFC2X3.IfcVertexBasedTextureMap(r, e[0], e[1]),
  1907098498: (r, e) => new IFC2X3.IfcVertexPoint(r, e[0]),
  891718957: (r, e) => new IFC2X3.IfcVirtualGridIntersection(r, e[0], e[1]),
  1065908215: (r, e) => new IFC2X3.IfcWaterProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2442683028: (r, e) => new IFC2X3.IfcAnnotationOccurrence(r, e[0], e[1], e[2]),
  962685235: (r, e) => new IFC2X3.IfcAnnotationSurfaceOccurrence(r, e[0], e[1], e[2]),
  3612888222: (r, e) => new IFC2X3.IfcAnnotationSymbolOccurrence(r, e[0], e[1], e[2]),
  2297822566: (r, e) => new IFC2X3.IfcAnnotationTextOccurrence(r, e[0], e[1], e[2]),
  3798115385: (r, e) => new IFC2X3.IfcArbitraryClosedProfileDef(r, e[0], e[1], e[2]),
  1310608509: (r, e) => new IFC2X3.IfcArbitraryOpenProfileDef(r, e[0], e[1], e[2]),
  2705031697: (r, e) => new IFC2X3.IfcArbitraryProfileDefWithVoids(r, e[0], e[1], e[2], e[3]),
  616511568: (r, e) => new IFC2X3.IfcBlobTexture(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3150382593: (r, e) => new IFC2X3.IfcCenterLineProfileDef(r, e[0], e[1], e[2], e[3]),
  647927063: (r, e) => new IFC2X3.IfcClassificationReference(r, e[0], e[1], e[2], e[3]),
  776857604: (r, e) => new IFC2X3.IfcColourRgb(r, e[0], e[1], e[2], e[3]),
  2542286263: (r, e) => new IFC2X3.IfcComplexProperty(r, e[0], e[1], e[2], e[3]),
  1485152156: (r, e) => new IFC2X3.IfcCompositeProfileDef(r, e[0], e[1], e[2], e[3]),
  370225590: (r, e) => new IFC2X3.IfcConnectedFaceSet(r, e[0]),
  1981873012: (r, e) => new IFC2X3.IfcConnectionCurveGeometry(r, e[0], e[1]),
  45288368: (r, e) => new IFC2X3.IfcConnectionPointEccentricity(r, e[0], e[1], e[2], e[3], e[4]),
  3050246964: (r, e) => new IFC2X3.IfcContextDependentUnit(r, e[0], e[1], e[2]),
  2889183280: (r, e) => new IFC2X3.IfcConversionBasedUnit(r, e[0], e[1], e[2], e[3]),
  3800577675: (r, e) => new IFC2X3.IfcCurveStyle(r, e[0], e[1], e[2], e[3]),
  3632507154: (r, e) => new IFC2X3.IfcDerivedProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  2273265877: (r, e) => new IFC2X3.IfcDimensionCalloutRelationship(r, e[0], e[1], e[2], e[3]),
  1694125774: (r, e) => new IFC2X3.IfcDimensionPair(r, e[0], e[1], e[2], e[3]),
  3732053477: (r, e) => new IFC2X3.IfcDocumentReference(r, e[0], e[1], e[2]),
  4170525392: (r, e) => new IFC2X3.IfcDraughtingPreDefinedTextFont(r, e[0]),
  3900360178: (r, e) => new IFC2X3.IfcEdge(r, e[0], e[1]),
  476780140: (r, e) => new IFC2X3.IfcEdgeCurve(r, e[0], e[1], e[2], e[3]),
  1860660968: (r, e) => new IFC2X3.IfcExtendedMaterialProperties(r, e[0], e[1], e[2], e[3]),
  2556980723: (r, e) => new IFC2X3.IfcFace(r, e[0]),
  1809719519: (r, e) => new IFC2X3.IfcFaceBound(r, e[0], e[1]),
  803316827: (r, e) => new IFC2X3.IfcFaceOuterBound(r, e[0], e[1]),
  3008276851: (r, e) => new IFC2X3.IfcFaceSurface(r, e[0], e[1], e[2]),
  4219587988: (r, e) => new IFC2X3.IfcFailureConnectionCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (r, e) => new IFC2X3.IfcFillAreaStyle(r, e[0], e[1]),
  3857492461: (r, e) => new IFC2X3.IfcFuelProperties(r, e[0], e[1], e[2], e[3], e[4]),
  803998398: (r, e) => new IFC2X3.IfcGeneralMaterialProperties(r, e[0], e[1], e[2], e[3]),
  1446786286: (r, e) => new IFC2X3.IfcGeneralProfileProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3448662350: (r, e) => new IFC2X3.IfcGeometricRepresentationContext(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (r, e) => new IFC2X3.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC2X3.IfcGeometricRepresentationSubContext(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3590301190: (r, e) => new IFC2X3.IfcGeometricSet(r, e[0]),
  178086475: (r, e) => new IFC2X3.IfcGridPlacement(r, e[0], e[1]),
  812098782: (r, e) => new IFC2X3.IfcHalfSpaceSolid(r, e[0], e[1]),
  2445078500: (r, e) => new IFC2X3.IfcHygroscopicMaterialProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3905492369: (r, e) => new IFC2X3.IfcImageTexture(r, e[0], e[1], e[2], e[3], e[4]),
  3741457305: (r, e) => new IFC2X3.IfcIrregularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1402838566: (r, e) => new IFC2X3.IfcLightSource(r, e[0], e[1], e[2], e[3]),
  125510826: (r, e) => new IFC2X3.IfcLightSourceAmbient(r, e[0], e[1], e[2], e[3]),
  2604431987: (r, e) => new IFC2X3.IfcLightSourceDirectional(r, e[0], e[1], e[2], e[3], e[4]),
  4266656042: (r, e) => new IFC2X3.IfcLightSourceGoniometric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (r, e) => new IFC2X3.IfcLightSourcePositional(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (r, e) => new IFC2X3.IfcLightSourceSpot(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2624227202: (r, e) => new IFC2X3.IfcLocalPlacement(r, e[0], e[1]),
  1008929658: (r, e) => new IFC2X3.IfcLoop(r),
  2347385850: (r, e) => new IFC2X3.IfcMappedItem(r, e[0], e[1]),
  2022407955: (r, e) => new IFC2X3.IfcMaterialDefinitionRepresentation(r, e[0], e[1], e[2], e[3]),
  1430189142: (r, e) => new IFC2X3.IfcMechanicalConcreteMaterialProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  219451334: (r, e) => new IFC2X3.IfcObjectDefinition(r, e[0], e[1], e[2], e[3]),
  2833995503: (r, e) => new IFC2X3.IfcOneDirectionRepeatFactor(r, e[0]),
  2665983363: (r, e) => new IFC2X3.IfcOpenShell(r, e[0]),
  1029017970: (r, e) => new IFC2X3.IfcOrientedEdge(r, e[0], e[1]),
  2529465313: (r, e) => new IFC2X3.IfcParameterizedProfileDef(r, e[0], e[1], e[2]),
  2519244187: (r, e) => new IFC2X3.IfcPath(r, e[0]),
  3021840470: (r, e) => new IFC2X3.IfcPhysicalComplexQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (r, e) => new IFC2X3.IfcPixelTexture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2004835150: (r, e) => new IFC2X3.IfcPlacement(r, e[0]),
  1663979128: (r, e) => new IFC2X3.IfcPlanarExtent(r, e[0], e[1]),
  2067069095: (r, e) => new IFC2X3.IfcPoint(r),
  4022376103: (r, e) => new IFC2X3.IfcPointOnCurve(r, e[0], e[1]),
  1423911732: (r, e) => new IFC2X3.IfcPointOnSurface(r, e[0], e[1], e[2]),
  2924175390: (r, e) => new IFC2X3.IfcPolyLoop(r, e[0]),
  2775532180: (r, e) => new IFC2X3.IfcPolygonalBoundedHalfSpace(r, e[0], e[1], e[2], e[3]),
  759155922: (r, e) => new IFC2X3.IfcPreDefinedColour(r, e[0]),
  2559016684: (r, e) => new IFC2X3.IfcPreDefinedCurveFont(r, e[0]),
  433424934: (r, e) => new IFC2X3.IfcPreDefinedDimensionSymbol(r, e[0]),
  179317114: (r, e) => new IFC2X3.IfcPreDefinedPointMarkerSymbol(r, e[0]),
  673634403: (r, e) => new IFC2X3.IfcProductDefinitionShape(r, e[0], e[1], e[2]),
  871118103: (r, e) => new IFC2X3.IfcPropertyBoundedValue(r, e[0], e[1], e[2], e[3], e[4]),
  1680319473: (r, e) => new IFC2X3.IfcPropertyDefinition(r, e[0], e[1], e[2], e[3]),
  4166981789: (r, e) => new IFC2X3.IfcPropertyEnumeratedValue(r, e[0], e[1], e[2], e[3]),
  2752243245: (r, e) => new IFC2X3.IfcPropertyListValue(r, e[0], e[1], e[2], e[3]),
  941946838: (r, e) => new IFC2X3.IfcPropertyReferenceValue(r, e[0], e[1], e[2], e[3]),
  3357820518: (r, e) => new IFC2X3.IfcPropertySetDefinition(r, e[0], e[1], e[2], e[3]),
  3650150729: (r, e) => new IFC2X3.IfcPropertySingleValue(r, e[0], e[1], e[2], e[3]),
  110355661: (r, e) => new IFC2X3.IfcPropertyTableValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3615266464: (r, e) => new IFC2X3.IfcRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  3413951693: (r, e) => new IFC2X3.IfcRegularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3765753017: (r, e) => new IFC2X3.IfcReinforcementDefinitionProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (r, e) => new IFC2X3.IfcRelationship(r, e[0], e[1], e[2], e[3]),
  2778083089: (r, e) => new IFC2X3.IfcRoundedRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (r, e) => new IFC2X3.IfcSectionedSpine(r, e[0], e[1], e[2]),
  2411513650: (r, e) => new IFC2X3.IfcServiceLifeFactor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4124623270: (r, e) => new IFC2X3.IfcShellBasedSurfaceModel(r, e[0]),
  2609359061: (r, e) => new IFC2X3.IfcSlippageConnectionCondition(r, e[0], e[1], e[2], e[3]),
  723233188: (r, e) => new IFC2X3.IfcSolidModel(r),
  2485662743: (r, e) => new IFC2X3.IfcSoundProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1202362311: (r, e) => new IFC2X3.IfcSoundValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  390701378: (r, e) => new IFC2X3.IfcSpaceThermalLoadProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1595516126: (r, e) => new IFC2X3.IfcStructuralLoadLinearForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (r, e) => new IFC2X3.IfcStructuralLoadPlanarForce(r, e[0], e[1], e[2], e[3]),
  2473145415: (r, e) => new IFC2X3.IfcStructuralLoadSingleDisplacement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (r, e) => new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (r, e) => new IFC2X3.IfcStructuralLoadSingleForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (r, e) => new IFC2X3.IfcStructuralLoadSingleForceWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3843319758: (r, e) => new IFC2X3.IfcStructuralProfileProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22]),
  3653947884: (r, e) => new IFC2X3.IfcStructuralSteelProfileProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22], e[23], e[24], e[25], e[26]),
  2233826070: (r, e) => new IFC2X3.IfcSubedge(r, e[0], e[1], e[2]),
  2513912981: (r, e) => new IFC2X3.IfcSurface(r),
  1878645084: (r, e) => new IFC2X3.IfcSurfaceStyleRendering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (r, e) => new IFC2X3.IfcSweptAreaSolid(r, e[0], e[1]),
  1260650574: (r, e) => new IFC2X3.IfcSweptDiskSolid(r, e[0], e[1], e[2], e[3], e[4]),
  230924584: (r, e) => new IFC2X3.IfcSweptSurface(r, e[0], e[1]),
  3071757647: (r, e) => new IFC2X3.IfcTShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3028897424: (r, e) => new IFC2X3.IfcTerminatorSymbol(r, e[0], e[1], e[2], e[3]),
  4282788508: (r, e) => new IFC2X3.IfcTextLiteral(r, e[0], e[1], e[2]),
  3124975700: (r, e) => new IFC2X3.IfcTextLiteralWithExtent(r, e[0], e[1], e[2], e[3], e[4]),
  2715220739: (r, e) => new IFC2X3.IfcTrapeziumProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1345879162: (r, e) => new IFC2X3.IfcTwoDirectionRepeatFactor(r, e[0], e[1]),
  1628702193: (r, e) => new IFC2X3.IfcTypeObject(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2347495698: (r, e) => new IFC2X3.IfcTypeProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  427810014: (r, e) => new IFC2X3.IfcUShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1417489154: (r, e) => new IFC2X3.IfcVector(r, e[0], e[1]),
  2759199220: (r, e) => new IFC2X3.IfcVertexLoop(r, e[0]),
  336235671: (r, e) => new IFC2X3.IfcWindowLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  512836454: (r, e) => new IFC2X3.IfcWindowPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1299126871: (r, e) => new IFC2X3.IfcWindowStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2543172580: (r, e) => new IFC2X3.IfcZShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3288037868: (r, e) => new IFC2X3.IfcAnnotationCurveOccurrence(r, e[0], e[1], e[2]),
  669184980: (r, e) => new IFC2X3.IfcAnnotationFillArea(r, e[0], e[1]),
  2265737646: (r, e) => new IFC2X3.IfcAnnotationFillAreaOccurrence(r, e[0], e[1], e[2], e[3], e[4]),
  1302238472: (r, e) => new IFC2X3.IfcAnnotationSurface(r, e[0], e[1]),
  4261334040: (r, e) => new IFC2X3.IfcAxis1Placement(r, e[0], e[1]),
  3125803723: (r, e) => new IFC2X3.IfcAxis2Placement2D(r, e[0], e[1]),
  2740243338: (r, e) => new IFC2X3.IfcAxis2Placement3D(r, e[0], e[1], e[2]),
  2736907675: (r, e) => new IFC2X3.IfcBooleanResult(r, e[0], e[1], e[2]),
  4182860854: (r, e) => new IFC2X3.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC2X3.IfcBoundingBox(r, e[0], e[1], e[2], e[3]),
  2713105998: (r, e) => new IFC2X3.IfcBoxedHalfSpace(r, e[0], e[1], e[2]),
  2898889636: (r, e) => new IFC2X3.IfcCShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1123145078: (r, e) => new IFC2X3.IfcCartesianPoint(r, e[0]),
  59481748: (r, e) => new IFC2X3.IfcCartesianTransformationOperator(r, e[0], e[1], e[2], e[3]),
  3749851601: (r, e) => new IFC2X3.IfcCartesianTransformationOperator2D(r, e[0], e[1], e[2], e[3]),
  3486308946: (r, e) => new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(r, e[0], e[1], e[2], e[3], e[4]),
  3331915920: (r, e) => new IFC2X3.IfcCartesianTransformationOperator3D(r, e[0], e[1], e[2], e[3], e[4]),
  1416205885: (r, e) => new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (r, e) => new IFC2X3.IfcCircleProfileDef(r, e[0], e[1], e[2], e[3]),
  2205249479: (r, e) => new IFC2X3.IfcClosedShell(r, e[0]),
  2485617015: (r, e) => new IFC2X3.IfcCompositeCurveSegment(r, e[0], e[1], e[2]),
  4133800736: (r, e) => new IFC2X3.IfcCraneRailAShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  194851669: (r, e) => new IFC2X3.IfcCraneRailFShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (r, e) => new IFC2X3.IfcCsgPrimitive3D(r, e[0]),
  2147822146: (r, e) => new IFC2X3.IfcCsgSolid(r, e[0]),
  2601014836: (r, e) => new IFC2X3.IfcCurve(r),
  2827736869: (r, e) => new IFC2X3.IfcCurveBoundedPlane(r, e[0], e[1], e[2]),
  693772133: (r, e) => new IFC2X3.IfcDefinedSymbol(r, e[0], e[1]),
  606661476: (r, e) => new IFC2X3.IfcDimensionCurve(r, e[0], e[1], e[2]),
  4054601972: (r, e) => new IFC2X3.IfcDimensionCurveTerminator(r, e[0], e[1], e[2], e[3], e[4]),
  32440307: (r, e) => new IFC2X3.IfcDirection(r, e[0]),
  2963535650: (r, e) => new IFC2X3.IfcDoorLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  1714330368: (r, e) => new IFC2X3.IfcDoorPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  526551008: (r, e) => new IFC2X3.IfcDoorStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  3073041342: (r, e) => new IFC2X3.IfcDraughtingCallout(r, e[0]),
  445594917: (r, e) => new IFC2X3.IfcDraughtingPreDefinedColour(r, e[0]),
  4006246654: (r, e) => new IFC2X3.IfcDraughtingPreDefinedCurveFont(r, e[0]),
  1472233963: (r, e) => new IFC2X3.IfcEdgeLoop(r, e[0]),
  1883228015: (r, e) => new IFC2X3.IfcElementQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (r, e) => new IFC2X3.IfcElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (r, e) => new IFC2X3.IfcElementarySurface(r, e[0]),
  2835456948: (r, e) => new IFC2X3.IfcEllipseProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  80994333: (r, e) => new IFC2X3.IfcEnergyProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  477187591: (r, e) => new IFC2X3.IfcExtrudedAreaSolid(r, e[0], e[1], e[2], e[3]),
  2047409740: (r, e) => new IFC2X3.IfcFaceBasedSurfaceModel(r, e[0]),
  374418227: (r, e) => new IFC2X3.IfcFillAreaStyleHatching(r, e[0], e[1], e[2], e[3], e[4]),
  4203026998: (r, e) => new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(r, e[0]),
  315944413: (r, e) => new IFC2X3.IfcFillAreaStyleTiles(r, e[0], e[1], e[2]),
  3455213021: (r, e) => new IFC2X3.IfcFluidFlowProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18]),
  4238390223: (r, e) => new IFC2X3.IfcFurnishingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (r, e) => new IFC2X3.IfcFurnitureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (r, e) => new IFC2X3.IfcGeometricCurveSet(r, e[0]),
  1484403080: (r, e) => new IFC2X3.IfcIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  572779678: (r, e) => new IFC2X3.IfcLShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1281925730: (r, e) => new IFC2X3.IfcLine(r, e[0], e[1]),
  1425443689: (r, e) => new IFC2X3.IfcManifoldSolidBrep(r, e[0]),
  3888040117: (r, e) => new IFC2X3.IfcObject(r, e[0], e[1], e[2], e[3], e[4]),
  3388369263: (r, e) => new IFC2X3.IfcOffsetCurve2D(r, e[0], e[1], e[2]),
  3505215534: (r, e) => new IFC2X3.IfcOffsetCurve3D(r, e[0], e[1], e[2], e[3]),
  3566463478: (r, e) => new IFC2X3.IfcPermeableCoveringProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603570806: (r, e) => new IFC2X3.IfcPlanarBox(r, e[0], e[1], e[2]),
  220341763: (r, e) => new IFC2X3.IfcPlane(r, e[0]),
  2945172077: (r, e) => new IFC2X3.IfcProcess(r, e[0], e[1], e[2], e[3], e[4]),
  4208778838: (r, e) => new IFC2X3.IfcProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (r, e) => new IFC2X3.IfcProject(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4194566429: (r, e) => new IFC2X3.IfcProjectionCurve(r, e[0], e[1], e[2]),
  1451395588: (r, e) => new IFC2X3.IfcPropertySet(r, e[0], e[1], e[2], e[3], e[4]),
  3219374653: (r, e) => new IFC2X3.IfcProxy(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2770003689: (r, e) => new IFC2X3.IfcRectangleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (r, e) => new IFC2X3.IfcRectangularPyramid(r, e[0], e[1], e[2], e[3]),
  3454111270: (r, e) => new IFC2X3.IfcRectangularTrimmedSurface(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3939117080: (r, e) => new IFC2X3.IfcRelAssigns(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (r, e) => new IFC2X3.IfcRelAssignsToActor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (r, e) => new IFC2X3.IfcRelAssignsToControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (r, e) => new IFC2X3.IfcRelAssignsToGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4278684876: (r, e) => new IFC2X3.IfcRelAssignsToProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (r, e) => new IFC2X3.IfcRelAssignsToProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3372526763: (r, e) => new IFC2X3.IfcRelAssignsToProjectOrder(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (r, e) => new IFC2X3.IfcRelAssignsToResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (r, e) => new IFC2X3.IfcRelAssociates(r, e[0], e[1], e[2], e[3], e[4]),
  1327628568: (r, e) => new IFC2X3.IfcRelAssociatesAppliedValue(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4095574036: (r, e) => new IFC2X3.IfcRelAssociatesApproval(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (r, e) => new IFC2X3.IfcRelAssociatesClassification(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (r, e) => new IFC2X3.IfcRelAssociatesConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (r, e) => new IFC2X3.IfcRelAssociatesDocument(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (r, e) => new IFC2X3.IfcRelAssociatesLibrary(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (r, e) => new IFC2X3.IfcRelAssociatesMaterial(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2851387026: (r, e) => new IFC2X3.IfcRelAssociatesProfileProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  826625072: (r, e) => new IFC2X3.IfcRelConnects(r, e[0], e[1], e[2], e[3]),
  1204542856: (r, e) => new IFC2X3.IfcRelConnectsElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (r, e) => new IFC2X3.IfcRelConnectsPathElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (r, e) => new IFC2X3.IfcRelConnectsPortToElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (r, e) => new IFC2X3.IfcRelConnectsPorts(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (r, e) => new IFC2X3.IfcRelConnectsStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3912681535: (r, e) => new IFC2X3.IfcRelConnectsStructuralElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (r, e) => new IFC2X3.IfcRelConnectsStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (r, e) => new IFC2X3.IfcRelConnectsWithEccentricity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (r, e) => new IFC2X3.IfcRelConnectsWithRealizingElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (r, e) => new IFC2X3.IfcRelContainedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (r, e) => new IFC2X3.IfcRelCoversBldgElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (r, e) => new IFC2X3.IfcRelCoversSpaces(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (r, e) => new IFC2X3.IfcRelDecomposes(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  693640335: (r, e) => new IFC2X3.IfcRelDefines(r, e[0], e[1], e[2], e[3], e[4]),
  4186316022: (r, e) => new IFC2X3.IfcRelDefinesByProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (r, e) => new IFC2X3.IfcRelDefinesByType(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (r, e) => new IFC2X3.IfcRelFillsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (r, e) => new IFC2X3.IfcRelFlowControlElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4189434867: (r, e) => new IFC2X3.IfcRelInteractionRequirements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3268803585: (r, e) => new IFC2X3.IfcRelNests(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2051452291: (r, e) => new IFC2X3.IfcRelOccupiesSpaces(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  202636808: (r, e) => new IFC2X3.IfcRelOverridesProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  750771296: (r, e) => new IFC2X3.IfcRelProjectsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (r, e) => new IFC2X3.IfcRelReferencedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1058617721: (r, e) => new IFC2X3.IfcRelSchedulesCostItems(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4122056220: (r, e) => new IFC2X3.IfcRelSequence(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  366585022: (r, e) => new IFC2X3.IfcRelServicesBuildings(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (r, e) => new IFC2X3.IfcRelSpaceBoundary(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1401173127: (r, e) => new IFC2X3.IfcRelVoidsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2914609552: (r, e) => new IFC2X3.IfcResource(r, e[0], e[1], e[2], e[3], e[4]),
  1856042241: (r, e) => new IFC2X3.IfcRevolvedAreaSolid(r, e[0], e[1], e[2], e[3]),
  4158566097: (r, e) => new IFC2X3.IfcRightCircularCone(r, e[0], e[1], e[2]),
  3626867408: (r, e) => new IFC2X3.IfcRightCircularCylinder(r, e[0], e[1], e[2]),
  2706606064: (r, e) => new IFC2X3.IfcSpatialStructureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (r, e) => new IFC2X3.IfcSpatialStructureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  451544542: (r, e) => new IFC2X3.IfcSphere(r, e[0], e[1]),
  3544373492: (r, e) => new IFC2X3.IfcStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (r, e) => new IFC2X3.IfcStructuralItem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (r, e) => new IFC2X3.IfcStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (r, e) => new IFC2X3.IfcStructuralReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (r, e) => new IFC2X3.IfcStructuralSurfaceMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (r, e) => new IFC2X3.IfcStructuralSurfaceMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4070609034: (r, e) => new IFC2X3.IfcStructuredDimensionCallout(r, e[0]),
  2028607225: (r, e) => new IFC2X3.IfcSurfaceCurveSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (r, e) => new IFC2X3.IfcSurfaceOfLinearExtrusion(r, e[0], e[1], e[2], e[3]),
  4124788165: (r, e) => new IFC2X3.IfcSurfaceOfRevolution(r, e[0], e[1], e[2]),
  1580310250: (r, e) => new IFC2X3.IfcSystemFurnitureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3473067441: (r, e) => new IFC2X3.IfcTask(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2097647324: (r, e) => new IFC2X3.IfcTransportElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2296667514: (r, e) => new IFC2X3.IfcActor(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1674181508: (r, e) => new IFC2X3.IfcAnnotation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3207858831: (r, e) => new IFC2X3.IfcAsymmetricIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (r, e) => new IFC2X3.IfcBlock(r, e[0], e[1], e[2], e[3]),
  3649129432: (r, e) => new IFC2X3.IfcBooleanClippingResult(r, e[0], e[1], e[2]),
  1260505505: (r, e) => new IFC2X3.IfcBoundedCurve(r),
  4031249490: (r, e) => new IFC2X3.IfcBuilding(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1950629157: (r, e) => new IFC2X3.IfcBuildingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3124254112: (r, e) => new IFC2X3.IfcBuildingStorey(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (r, e) => new IFC2X3.IfcCircleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  300633059: (r, e) => new IFC2X3.IfcColumnType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3732776249: (r, e) => new IFC2X3.IfcCompositeCurve(r, e[0], e[1]),
  2510884976: (r, e) => new IFC2X3.IfcConic(r, e[0]),
  2559216714: (r, e) => new IFC2X3.IfcConstructionResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3293443760: (r, e) => new IFC2X3.IfcControl(r, e[0], e[1], e[2], e[3], e[4]),
  3895139033: (r, e) => new IFC2X3.IfcCostItem(r, e[0], e[1], e[2], e[3], e[4]),
  1419761937: (r, e) => new IFC2X3.IfcCostSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  1916426348: (r, e) => new IFC2X3.IfcCoveringType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (r, e) => new IFC2X3.IfcCrewResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1457835157: (r, e) => new IFC2X3.IfcCurtainWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  681481545: (r, e) => new IFC2X3.IfcDimensionCurveDirectedCallout(r, e[0]),
  3256556792: (r, e) => new IFC2X3.IfcDistributionElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (r, e) => new IFC2X3.IfcDistributionFlowElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  360485395: (r, e) => new IFC2X3.IfcElectricalBaseProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1758889154: (r, e) => new IFC2X3.IfcElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (r, e) => new IFC2X3.IfcElementAssembly(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (r, e) => new IFC2X3.IfcElementComponent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (r, e) => new IFC2X3.IfcElementComponentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (r, e) => new IFC2X3.IfcEllipse(r, e[0], e[1], e[2]),
  2107101300: (r, e) => new IFC2X3.IfcEnergyConversionDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1962604670: (r, e) => new IFC2X3.IfcEquipmentElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3272907226: (r, e) => new IFC2X3.IfcEquipmentStandard(r, e[0], e[1], e[2], e[3], e[4]),
  3174744832: (r, e) => new IFC2X3.IfcEvaporativeCoolerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (r, e) => new IFC2X3.IfcEvaporatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  807026263: (r, e) => new IFC2X3.IfcFacetedBrep(r, e[0]),
  3737207727: (r, e) => new IFC2X3.IfcFacetedBrepWithVoids(r, e[0], e[1]),
  647756555: (r, e) => new IFC2X3.IfcFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2489546625: (r, e) => new IFC2X3.IfcFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2827207264: (r, e) => new IFC2X3.IfcFeatureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (r, e) => new IFC2X3.IfcFeatureElementAddition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (r, e) => new IFC2X3.IfcFeatureElementSubtraction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (r, e) => new IFC2X3.IfcFlowControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (r, e) => new IFC2X3.IfcFlowFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (r, e) => new IFC2X3.IfcFlowMeterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (r, e) => new IFC2X3.IfcFlowMovingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (r, e) => new IFC2X3.IfcFlowSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (r, e) => new IFC2X3.IfcFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (r, e) => new IFC2X3.IfcFlowTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (r, e) => new IFC2X3.IfcFlowTreatmentDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  263784265: (r, e) => new IFC2X3.IfcFurnishingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  814719939: (r, e) => new IFC2X3.IfcFurnitureStandard(r, e[0], e[1], e[2], e[3], e[4]),
  200128114: (r, e) => new IFC2X3.IfcGasTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3009204131: (r, e) => new IFC2X3.IfcGrid(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2706460486: (r, e) => new IFC2X3.IfcGroup(r, e[0], e[1], e[2], e[3], e[4]),
  1251058090: (r, e) => new IFC2X3.IfcHeatExchangerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (r, e) => new IFC2X3.IfcHumidifierType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391368822: (r, e) => new IFC2X3.IfcInventory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (r, e) => new IFC2X3.IfcJunctionBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (r, e) => new IFC2X3.IfcLaborResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1051575348: (r, e) => new IFC2X3.IfcLampType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (r, e) => new IFC2X3.IfcLightFixtureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2506943328: (r, e) => new IFC2X3.IfcLinearDimension(r, e[0]),
  377706215: (r, e) => new IFC2X3.IfcMechanicalFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2108223431: (r, e) => new IFC2X3.IfcMechanicalFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3181161470: (r, e) => new IFC2X3.IfcMemberType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (r, e) => new IFC2X3.IfcMotorConnectionType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916936684: (r, e) => new IFC2X3.IfcMove(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4143007308: (r, e) => new IFC2X3.IfcOccupant(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (r, e) => new IFC2X3.IfcOpeningElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3425660407: (r, e) => new IFC2X3.IfcOrderAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2837617999: (r, e) => new IFC2X3.IfcOutletType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (r, e) => new IFC2X3.IfcPerformanceHistory(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3327091369: (r, e) => new IFC2X3.IfcPermit(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  804291784: (r, e) => new IFC2X3.IfcPipeFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (r, e) => new IFC2X3.IfcPipeSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (r, e) => new IFC2X3.IfcPlateType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3724593414: (r, e) => new IFC2X3.IfcPolyline(r, e[0]),
  3740093272: (r, e) => new IFC2X3.IfcPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (r, e) => new IFC2X3.IfcProcedure(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (r, e) => new IFC2X3.IfcProjectOrder(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3642467123: (r, e) => new IFC2X3.IfcProjectOrderRecord(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3651124850: (r, e) => new IFC2X3.IfcProjectionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1842657554: (r, e) => new IFC2X3.IfcProtectiveDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (r, e) => new IFC2X3.IfcPumpType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3248260540: (r, e) => new IFC2X3.IfcRadiusDimension(r, e[0]),
  2893384427: (r, e) => new IFC2X3.IfcRailingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2324767716: (r, e) => new IFC2X3.IfcRampFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  160246688: (r, e) => new IFC2X3.IfcRelAggregates(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2863920197: (r, e) => new IFC2X3.IfcRelAssignsTasks(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1768891740: (r, e) => new IFC2X3.IfcSanitaryTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3517283431: (r, e) => new IFC2X3.IfcScheduleTimeControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20], e[21], e[22]),
  4105383287: (r, e) => new IFC2X3.IfcServiceLife(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4097777520: (r, e) => new IFC2X3.IfcSite(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (r, e) => new IFC2X3.IfcSlabType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (r, e) => new IFC2X3.IfcSpace(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (r, e) => new IFC2X3.IfcSpaceHeaterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  652456506: (r, e) => new IFC2X3.IfcSpaceProgram(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (r, e) => new IFC2X3.IfcSpaceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3112655638: (r, e) => new IFC2X3.IfcStackTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (r, e) => new IFC2X3.IfcStairFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (r, e) => new IFC2X3.IfcStructuralAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1179482911: (r, e) => new IFC2X3.IfcStructuralConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4243806635: (r, e) => new IFC2X3.IfcStructuralCurveConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  214636428: (r, e) => new IFC2X3.IfcStructuralCurveMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2445595289: (r, e) => new IFC2X3.IfcStructuralCurveMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1807405624: (r, e) => new IFC2X3.IfcStructuralLinearAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1721250024: (r, e) => new IFC2X3.IfcStructuralLinearActionVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1252848954: (r, e) => new IFC2X3.IfcStructuralLoadGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1621171031: (r, e) => new IFC2X3.IfcStructuralPlanarAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  3987759626: (r, e) => new IFC2X3.IfcStructuralPlanarActionVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2082059205: (r, e) => new IFC2X3.IfcStructuralPointAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  734778138: (r, e) => new IFC2X3.IfcStructuralPointConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1235345126: (r, e) => new IFC2X3.IfcStructuralPointReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (r, e) => new IFC2X3.IfcStructuralResultGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1975003073: (r, e) => new IFC2X3.IfcStructuralSurfaceConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (r, e) => new IFC2X3.IfcSubContractResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2315554128: (r, e) => new IFC2X3.IfcSwitchingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (r, e) => new IFC2X3.IfcSystem(r, e[0], e[1], e[2], e[3], e[4]),
  5716631: (r, e) => new IFC2X3.IfcTankType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1637806684: (r, e) => new IFC2X3.IfcTimeSeriesSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1692211062: (r, e) => new IFC2X3.IfcTransformerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1620046519: (r, e) => new IFC2X3.IfcTransportElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3593883385: (r, e) => new IFC2X3.IfcTrimmedCurve(r, e[0], e[1], e[2], e[3], e[4]),
  1600972822: (r, e) => new IFC2X3.IfcTubeBundleType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (r, e) => new IFC2X3.IfcUnitaryEquipmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (r, e) => new IFC2X3.IfcValveType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (r, e) => new IFC2X3.IfcVirtualElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1898987631: (r, e) => new IFC2X3.IfcWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (r, e) => new IFC2X3.IfcWasteTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1028945134: (r, e) => new IFC2X3.IfcWorkControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4218914973: (r, e) => new IFC2X3.IfcWorkPlan(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  3342526732: (r, e) => new IFC2X3.IfcWorkSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  1033361043: (r, e) => new IFC2X3.IfcZone(r, e[0], e[1], e[2], e[3], e[4]),
  1213861670: (r, e) => new IFC2X3.Ifc2DCompositeCurve(r, e[0], e[1]),
  3821786052: (r, e) => new IFC2X3.IfcActionRequest(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1411407467: (r, e) => new IFC2X3.IfcAirTerminalBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (r, e) => new IFC2X3.IfcAirTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (r, e) => new IFC2X3.IfcAirToAirHeatRecoveryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2470393545: (r, e) => new IFC2X3.IfcAngularDimension(r, e[0]),
  3460190687: (r, e) => new IFC2X3.IfcAsset(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1967976161: (r, e) => new IFC2X3.IfcBSplineCurve(r, e[0], e[1], e[2], e[3], e[4]),
  819618141: (r, e) => new IFC2X3.IfcBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916977116: (r, e) => new IFC2X3.IfcBezierCurve(r, e[0], e[1], e[2], e[3], e[4]),
  231477066: (r, e) => new IFC2X3.IfcBoilerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3299480353: (r, e) => new IFC2X3.IfcBuildingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  52481810: (r, e) => new IFC2X3.IfcBuildingElementComponent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2979338954: (r, e) => new IFC2X3.IfcBuildingElementPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1095909175: (r, e) => new IFC2X3.IfcBuildingElementProxy(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1909888760: (r, e) => new IFC2X3.IfcBuildingElementProxyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (r, e) => new IFC2X3.IfcCableCarrierFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (r, e) => new IFC2X3.IfcCableCarrierSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (r, e) => new IFC2X3.IfcCableSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (r, e) => new IFC2X3.IfcChillerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2611217952: (r, e) => new IFC2X3.IfcCircle(r, e[0], e[1]),
  2301859152: (r, e) => new IFC2X3.IfcCoilType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (r, e) => new IFC2X3.IfcColumn(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3850581409: (r, e) => new IFC2X3.IfcCompressorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (r, e) => new IFC2X3.IfcCondenserType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188551683: (r, e) => new IFC2X3.IfcCondition(r, e[0], e[1], e[2], e[3], e[4]),
  1163958913: (r, e) => new IFC2X3.IfcConditionCriterion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3898045240: (r, e) => new IFC2X3.IfcConstructionEquipmentResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1060000209: (r, e) => new IFC2X3.IfcConstructionMaterialResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (r, e) => new IFC2X3.IfcConstructionProductResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  335055490: (r, e) => new IFC2X3.IfcCooledBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (r, e) => new IFC2X3.IfcCoolingTowerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1973544240: (r, e) => new IFC2X3.IfcCovering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (r, e) => new IFC2X3.IfcCurtainWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3961806047: (r, e) => new IFC2X3.IfcDamperType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4147604152: (r, e) => new IFC2X3.IfcDiameterDimension(r, e[0]),
  1335981549: (r, e) => new IFC2X3.IfcDiscreteAccessory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2635815018: (r, e) => new IFC2X3.IfcDiscreteAccessoryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1599208980: (r, e) => new IFC2X3.IfcDistributionChamberElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (r, e) => new IFC2X3.IfcDistributionControlElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (r, e) => new IFC2X3.IfcDistributionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (r, e) => new IFC2X3.IfcDistributionFlowElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (r, e) => new IFC2X3.IfcDistributionPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  395920057: (r, e) => new IFC2X3.IfcDoor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  869906466: (r, e) => new IFC2X3.IfcDuctFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (r, e) => new IFC2X3.IfcDuctSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (r, e) => new IFC2X3.IfcDuctSilencerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  855621170: (r, e) => new IFC2X3.IfcEdgeFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  663422040: (r, e) => new IFC2X3.IfcElectricApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (r, e) => new IFC2X3.IfcElectricFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (r, e) => new IFC2X3.IfcElectricGeneratorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1365060375: (r, e) => new IFC2X3.IfcElectricHeaterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (r, e) => new IFC2X3.IfcElectricMotorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (r, e) => new IFC2X3.IfcElectricTimeControlType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634875225: (r, e) => new IFC2X3.IfcElectricalCircuit(r, e[0], e[1], e[2], e[3], e[4]),
  857184966: (r, e) => new IFC2X3.IfcElectricalElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1658829314: (r, e) => new IFC2X3.IfcEnergyConversionDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  346874300: (r, e) => new IFC2X3.IfcFanType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (r, e) => new IFC2X3.IfcFilterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (r, e) => new IFC2X3.IfcFireSuppressionTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (r, e) => new IFC2X3.IfcFlowController(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (r, e) => new IFC2X3.IfcFlowFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (r, e) => new IFC2X3.IfcFlowInstrumentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3132237377: (r, e) => new IFC2X3.IfcFlowMovingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (r, e) => new IFC2X3.IfcFlowSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (r, e) => new IFC2X3.IfcFlowStorageDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (r, e) => new IFC2X3.IfcFlowTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (r, e) => new IFC2X3.IfcFlowTreatmentDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (r, e) => new IFC2X3.IfcFooting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (r, e) => new IFC2X3.IfcMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1687234759: (r, e) => new IFC2X3.IfcPile(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3171933400: (r, e) => new IFC2X3.IfcPlate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2262370178: (r, e) => new IFC2X3.IfcRailing(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (r, e) => new IFC2X3.IfcRamp(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (r, e) => new IFC2X3.IfcRampFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3055160366: (r, e) => new IFC2X3.IfcRationalBezierCurve(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3027567501: (r, e) => new IFC2X3.IfcReinforcingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (r, e) => new IFC2X3.IfcReinforcingMesh(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2016517767: (r, e) => new IFC2X3.IfcRoof(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1376911519: (r, e) => new IFC2X3.IfcRoundedEdgeFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1783015770: (r, e) => new IFC2X3.IfcSensorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1529196076: (r, e) => new IFC2X3.IfcSlab(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (r, e) => new IFC2X3.IfcStair(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (r, e) => new IFC2X3.IfcStairFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2515109513: (r, e) => new IFC2X3.IfcStructuralAnalysisModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3824725483: (r, e) => new IFC2X3.IfcTendon(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (r, e) => new IFC2X3.IfcTendonAnchor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (r, e) => new IFC2X3.IfcVibrationIsolatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391406946: (r, e) => new IFC2X3.IfcWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3512223829: (r, e) => new IFC2X3.IfcWallStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3304561284: (r, e) => new IFC2X3.IfcWindow(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2874132201: (r, e) => new IFC2X3.IfcActuatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3001207471: (r, e) => new IFC2X3.IfcAlarmType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  753842376: (r, e) => new IFC2X3.IfcBeam(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2454782716: (r, e) => new IFC2X3.IfcChamferEdgeFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  578613899: (r, e) => new IFC2X3.IfcControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1052013943: (r, e) => new IFC2X3.IfcDistributionChamberElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1062813311: (r, e) => new IFC2X3.IfcDistributionControlElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3700593921: (r, e) => new IFC2X3.IfcElectricDistributionPoint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  979691226: (r, e) => new IFC2X3.IfcReinforcingBar(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13])
};
ToRawLineData[1] = {
  3630933823: (r) => [r.Role, r.UserDefinedRole, r.Description],
  618182010: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose],
  639542469: (r) => [r.ApplicationDeveloper, r.Version, r.ApplicationFullName, r.ApplicationIdentifier],
  411424972: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate],
  1110488051: (r) => [r.ComponentOfTotal, r.Components, r.ArithmeticOperator, r.Name, r.Description],
  130549933: (r) => [r.Description, r.ApprovalDateTime, r.ApprovalStatus, r.ApprovalLevel, r.ApprovalQualifier, r.Name, r.Identifier],
  2080292479: (r) => [r.Actor, r.Approval, r.Role],
  390851274: (r) => [r.ApprovedProperties, r.Approval],
  3869604511: (r) => [r.RelatedApproval, r.RelatingApproval, r.Description, r.Name],
  4037036970: (r) => [r.Name],
  1560379544: (r) => [r.Name, r.LinearStiffnessByLengthX, r.LinearStiffnessByLengthY, r.LinearStiffnessByLengthZ, r.RotationalStiffnessByLengthX, r.RotationalStiffnessByLengthY, r.RotationalStiffnessByLengthZ],
  3367102660: (r) => [r.Name, r.LinearStiffnessByAreaX, r.LinearStiffnessByAreaY, r.LinearStiffnessByAreaZ],
  1387855156: (r) => [r.Name, r.LinearStiffnessX, r.LinearStiffnessY, r.LinearStiffnessZ, r.RotationalStiffnessX, r.RotationalStiffnessY, r.RotationalStiffnessZ],
  2069777674: (r) => [r.Name, r.LinearStiffnessX, r.LinearStiffnessY, r.LinearStiffnessZ, r.RotationalStiffnessX, r.RotationalStiffnessY, r.RotationalStiffnessZ, r.WarpingStiffness],
  622194075: (r) => [r.DayComponent, r.MonthComponent, r.YearComponent],
  747523909: (r) => [r.Source, r.Edition, r.EditionDate, r.Name],
  1767535486: (r) => [r.Notation, r.ItemOf, r.Title],
  1098599126: (r) => [r.RelatingItem, r.RelatedItems],
  938368621: (r) => [r.NotationFacets],
  3639012971: (r) => [r.NotationValue],
  3264961684: (r) => [r.Name],
  2859738748: (r) => [],
  2614616156: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement],
  4257277454: (r) => [r.LocationAtRelatingElement, r.LocationAtRelatedElement, r.ProfileOfPort],
  2732653382: (r) => [r.SurfaceOnRelatingElement, r.SurfaceOnRelatedElement],
  1959218052: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade],
  1658513725: (r) => [r.Name, r.Description, r.RelatingConstraint, r.RelatedConstraints, r.LogicalAggregator],
  613356794: (r) => [r.ClassifiedConstraint, r.RelatedClassifications],
  347226245: (r) => [r.Name, r.Description, r.RelatingConstraint, r.RelatedConstraints],
  1065062679: (r) => [r.HourOffset, r.MinuteOffset, r.Sense],
  602808272: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.CostType, r.Condition],
  539742890: (r) => [r.RelatingMonetaryUnit, r.RelatedMonetaryUnit, r.ExchangeRate, r.RateDateTime, r.RateSource],
  1105321065: (r) => [r.Name, r.PatternList],
  2367409068: (r) => [r.Name, r.CurveFont, r.CurveFontScaling],
  3510044353: (r) => [r.VisibleSegmentLength, r.InvisibleSegmentLength],
  1072939445: (r) => [r.DateComponent, r.TimeComponent],
  1765591967: (r) => [r.Elements, r.UnitType, r.UserDefinedType],
  1045800335: (r) => [r.Unit, r.Exponent],
  2949456006: (r) => [r.LengthExponent, r.MassExponent, r.TimeExponent, r.ElectricCurrentExponent, r.ThermodynamicTemperatureExponent, r.AmountOfSubstanceExponent, r.LuminousIntensityExponent],
  1376555844: (r) => [r.FileExtension, r.MimeContentType, r.MimeSubtype],
  1154170062: (r) => [r.DocumentId, r.Name, r.Description, r.DocumentReferences, r.Purpose, r.IntendedUse, r.Scope, r.Revision, r.DocumentOwner, r.Editors, r.CreationTime, r.LastRevisionTime, r.ElectronicFormat, r.ValidFrom, r.ValidUntil, r.Confidentiality, r.Status],
  770865208: (r) => [r.RelatingDocument, r.RelatedDocuments, r.RelationshipType],
  3796139169: (r) => [r.Name, r.Description, r.RelatingDraughtingCallout, r.RelatedDraughtingCallout],
  1648886627: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.ImpactType, r.Category, r.UserDefinedCategory],
  3200245327: (r) => [r.Location, r.ItemReference, r.Name],
  2242383968: (r) => [r.Location, r.ItemReference, r.Name],
  1040185647: (r) => [r.Location, r.ItemReference, r.Name],
  3207319532: (r) => [r.Location, r.ItemReference, r.Name],
  3548104201: (r) => [r.Location, r.ItemReference, r.Name],
  852622518: (r) => {
    var e;
    return [r.AxisTag, r.AxisCurve, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  3020489413: (r) => [r.TimeStamp, r.ListValues.map((e) => Labelise(e))],
  2655187982: (r) => [r.Name, r.Version, r.Publisher, r.VersionDate, r.LibraryReference],
  3452421091: (r) => [r.Location, r.ItemReference, r.Name],
  4162380809: (r) => [r.MainPlaneAngle, r.SecondaryPlaneAngle, r.LuminousIntensity],
  1566485204: (r) => [r.LightDistributionCurve, r.DistributionData],
  30780891: (r) => [r.HourComponent, r.MinuteComponent, r.SecondComponent, r.Zone, r.DaylightSavingOffset],
  1838606355: (r) => [r.Name],
  1847130766: (r) => [r.MaterialClassifications, r.ClassifiedMaterial],
  248100487: (r) => {
    var e;
    return [r.Material, r.LayerThickness, (e = r.IsVentilated) == null ? void 0 : e.toString()];
  },
  3303938423: (r) => [r.MaterialLayers, r.LayerSetName],
  1303795690: (r) => [r.ForLayerSet, r.LayerSetDirection, r.DirectionSense, r.OffsetFromReferenceLine],
  2199411900: (r) => [r.Materials],
  3265635763: (r) => [r.Material],
  2597039031: (r) => [Labelise(r.ValueComponent), r.UnitComponent],
  4256014907: (r) => [r.Material, r.DynamicViscosity, r.YoungModulus, r.ShearModulus, r.PoissonRatio, r.ThermalExpansionCoefficient],
  677618848: (r) => [r.Material, r.DynamicViscosity, r.YoungModulus, r.ShearModulus, r.PoissonRatio, r.ThermalExpansionCoefficient, r.YieldStress, r.UltimateStress, r.UltimateStrain, r.HardeningModule, r.ProportionalStress, r.PlasticStrain, r.Relaxations],
  3368373690: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.Benchmark, r.ValueSource, r.DataValue],
  2706619895: (r) => [r.Currency],
  1918398963: (r) => [r.Dimensions, r.UnitType],
  3701648758: (r) => [],
  2251480897: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.BenchmarkValues, r.ResultValues, r.ObjectiveQualifier, r.UserDefinedQualifier],
  1227763645: (r) => [r.Material, r.VisibleTransmittance, r.SolarTransmittance, r.ThermalIrTransmittance, r.ThermalIrEmissivityBack, r.ThermalIrEmissivityFront, r.VisibleReflectanceBack, r.VisibleReflectanceFront, r.SolarReflectanceFront, r.SolarReflectanceBack],
  4251960020: (r) => [r.Id, r.Name, r.Description, r.Roles, r.Addresses],
  1411181986: (r) => [r.Name, r.Description, r.RelatingOrganization, r.RelatedOrganizations],
  1207048766: (r) => [r.OwningUser, r.OwningApplication, r.State, r.ChangeAction, r.LastModifiedDate, r.LastModifyingUser, r.LastModifyingApplication, r.CreationDate],
  2077209135: (r) => [r.Id, r.FamilyName, r.GivenName, r.MiddleNames, r.PrefixTitles, r.SuffixTitles, r.Roles, r.Addresses],
  101040310: (r) => [r.ThePerson, r.TheOrganization, r.Roles],
  2483315170: (r) => [r.Name, r.Description],
  2226359599: (r) => [r.Name, r.Description, r.Unit],
  3355820592: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.InternalLocation, r.AddressLines, r.PostalBox, r.Town, r.Region, r.PostalCode, r.Country],
  3727388367: (r) => [r.Name],
  990879717: (r) => [r.Name],
  3213052703: (r) => [r.Name],
  1775413392: (r) => [r.Name],
  2022622350: (r) => [r.Name, r.Description, r.AssignedItems, r.Identifier],
  1304840413: (r) => [r.Name, r.Description, r.AssignedItems, r.Identifier, r.LayerOn, r.LayerFrozen, r.LayerBlocked, r.LayerStyles],
  3119450353: (r) => [r.Name],
  2417041796: (r) => [r.Styles],
  2095639259: (r) => [r.Name, r.Description, r.Representations],
  2267347899: (r) => [r.Material, r.SpecificHeatCapacity, r.N20Content, r.COContent, r.CO2Content],
  3958567839: (r) => [r.ProfileType, r.ProfileName],
  2802850158: (r) => [r.ProfileName, r.ProfileDefinition],
  2598011224: (r) => [r.Name, r.Description],
  3896028662: (r) => [r.RelatingConstraint, r.RelatedProperties, r.Name, r.Description],
  148025276: (r) => [r.DependingProperty, r.DependantProperty, r.Name, r.Description, r.Expression],
  3710013099: (r) => [r.Name, r.EnumerationValues.map((e) => Labelise(e)), r.Unit],
  2044713172: (r) => [r.Name, r.Description, r.Unit, r.AreaValue],
  2093928680: (r) => [r.Name, r.Description, r.Unit, r.CountValue],
  931644368: (r) => [r.Name, r.Description, r.Unit, r.LengthValue],
  3252649465: (r) => [r.Name, r.Description, r.Unit, r.TimeValue],
  2405470396: (r) => [r.Name, r.Description, r.Unit, r.VolumeValue],
  825690147: (r) => [r.Name, r.Description, r.Unit, r.WeightValue],
  2692823254: (r) => [r.ReferencedDocument, r.ReferencingValues, r.Name, r.Description],
  1580146022: (r) => [r.TotalCrossSectionArea, r.SteelGrade, r.BarSurface, r.EffectiveDepth, r.NominalBarDiameter, r.BarCount],
  1222501353: (r) => [r.RelaxationValue, r.InitialStress],
  1076942058: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3377609919: (r) => [r.ContextIdentifier, r.ContextType],
  3008791417: (r) => [],
  1660063152: (r) => [r.MappingOrigin, r.MappedRepresentation],
  3679540991: (r) => [r.ProfileName, r.ProfileDefinition, r.Thickness, r.RibHeight, r.RibWidth, r.RibSpacing, r.Direction],
  2341007311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  448429030: (r) => [r.Dimensions, r.UnitType, r.Prefix, r.Name],
  2042790032: (r) => [r.SectionType, r.StartProfile, r.EndProfile],
  4165799628: (r) => [r.LongitudinalStartPosition, r.LongitudinalEndPosition, r.TransversePosition, r.ReinforcementRole, r.SectionDefinition, r.CrossSectionReinforcementDefinitions],
  867548509: (r) => [r.ShapeRepresentations, r.Name, r.Description, r.ProductDefinitional, r.PartOfProductDefinitionShape],
  3982875396: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  4240577450: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3692461612: (r) => [r.Name, r.Description],
  2273995522: (r) => [r.Name],
  2162789131: (r) => [r.Name],
  2525727697: (r) => [r.Name],
  3408363356: (r) => [r.Name, r.DeltaT_Constant, r.DeltaT_Y, r.DeltaT_Z],
  2830218821: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3958052878: (r) => [r.Item, r.Styles, r.Name],
  3049322572: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  1300840506: (r) => [r.Name, r.Side, r.Styles],
  3303107099: (r) => [r.DiffuseTransmissionColour, r.DiffuseReflectionColour, r.TransmissionColour, r.ReflectanceColour],
  1607154358: (r) => [r.RefractionIndex, r.DispersionFactor],
  846575682: (r) => [r.SurfaceColour],
  1351298697: (r) => [r.Textures],
  626085974: (r) => [r.RepeatS, r.RepeatT, r.TextureType, r.TextureTransform],
  1290481447: (r) => [r.Name, Labelise(r.StyleOfSymbol)],
  985171141: (r) => [r.Name, r.Rows],
  531007025: (r) => [r.RowCells.map((e) => Labelise(e)), r.IsHeading],
  912023232: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.TelephoneNumbers, r.FacsimileNumbers, r.PagerNumber, r.ElectronicMailAddresses, r.WWWHomePageURL],
  1447204868: (r) => [r.Name, r.TextCharacterAppearance, r.TextStyle, r.TextFontStyle],
  1983826977: (r) => [r.Name, r.FontFamily, r.FontStyle, r.FontVariant, r.FontWeight, Labelise(r.FontSize)],
  2636378356: (r) => [r.Colour, r.BackgroundColour],
  1640371178: (r) => [r.TextIndent ? Labelise(r.TextIndent) : null, r.TextAlign, r.TextDecoration, r.LetterSpacing ? Labelise(r.LetterSpacing) : null, r.WordSpacing ? Labelise(r.WordSpacing) : null, r.TextTransform, r.LineHeight ? Labelise(r.LineHeight) : null],
  1484833681: (r) => [r.BoxHeight, r.BoxWidth, r.BoxSlantAngle, r.BoxRotateAngle, r.CharacterSpacing ? Labelise(r.CharacterSpacing) : null],
  280115917: (r) => [],
  1742049831: (r) => [r.Mode, r.Parameter.map((e) => Labelise(e))],
  2552916305: (r) => [r.TextureMaps],
  1210645708: (r) => [r.Coordinates],
  3317419933: (r) => [r.Material, r.SpecificHeatCapacity, r.BoilingPoint, r.FreezingPoint, r.ThermalConductivity],
  3101149627: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit],
  1718945513: (r) => [r.ReferencedTimeSeries, r.TimeSeriesReferences],
  581633288: (r) => [r.ListValues.map((e) => Labelise(e))],
  1377556343: (r) => [],
  1735638870: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  180925521: (r) => [r.Units],
  2799835756: (r) => [],
  3304826586: (r) => [r.TextureVertices, r.TexturePoints],
  1907098498: (r) => [r.VertexGeometry],
  891718957: (r) => [r.IntersectingAxes, r.OffsetDistances],
  1065908215: (r) => [r.Material, r.IsPotable, r.Hardness, r.AlkalinityConcentration, r.AcidityConcentration, r.ImpuritiesContent, r.PHLevel, r.DissolvedSolidsContent],
  2442683028: (r) => [r.Item, r.Styles, r.Name],
  962685235: (r) => [r.Item, r.Styles, r.Name],
  3612888222: (r) => [r.Item, r.Styles, r.Name],
  2297822566: (r) => [r.Item, r.Styles, r.Name],
  3798115385: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve],
  1310608509: (r) => [r.ProfileType, r.ProfileName, r.Curve],
  2705031697: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve, r.InnerCurves],
  616511568: (r) => [r.RepeatS, r.RepeatT, r.TextureType, r.TextureTransform, r.RasterFormat, r.RasterCode],
  3150382593: (r) => [r.ProfileType, r.ProfileName, r.Curve, r.Thickness],
  647927063: (r) => [r.Location, r.ItemReference, r.Name, r.ReferencedSource],
  776857604: (r) => [r.Name, r.Red, r.Green, r.Blue],
  2542286263: (r) => [r.Name, r.Description, r.UsageName, r.HasProperties],
  1485152156: (r) => [r.ProfileType, r.ProfileName, r.Profiles, r.Label],
  370225590: (r) => [r.CfsFaces],
  1981873012: (r) => [r.CurveOnRelatingElement, r.CurveOnRelatedElement],
  45288368: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement, r.EccentricityInX, r.EccentricityInY, r.EccentricityInZ],
  3050246964: (r) => [r.Dimensions, r.UnitType, r.Name],
  2889183280: (r) => [r.Dimensions, r.UnitType, r.Name, r.ConversionFactor],
  3800577675: (r) => [r.Name, r.CurveFont, r.CurveWidth ? Labelise(r.CurveWidth) : null, r.CurveColour],
  3632507154: (r) => [r.ProfileType, r.ProfileName, r.ParentProfile, r.Operator, r.Label],
  2273265877: (r) => [r.Name, r.Description, r.RelatingDraughtingCallout, r.RelatedDraughtingCallout],
  1694125774: (r) => [r.Name, r.Description, r.RelatingDraughtingCallout, r.RelatedDraughtingCallout],
  3732053477: (r) => [r.Location, r.ItemReference, r.Name],
  4170525392: (r) => [r.Name],
  3900360178: (r) => [r.EdgeStart, r.EdgeEnd],
  476780140: (r) => [r.EdgeStart, r.EdgeEnd, r.EdgeGeometry, r.SameSense],
  1860660968: (r) => [r.Material, r.ExtendedProperties, r.Description, r.Name],
  2556980723: (r) => [r.Bounds],
  1809719519: (r) => [r.Bound, r.Orientation],
  803316827: (r) => [r.Bound, r.Orientation],
  3008276851: (r) => [r.Bounds, r.FaceSurface, r.SameSense],
  4219587988: (r) => [r.Name, r.TensionFailureX, r.TensionFailureY, r.TensionFailureZ, r.CompressionFailureX, r.CompressionFailureY, r.CompressionFailureZ],
  738692330: (r) => [r.Name, r.FillStyles],
  3857492461: (r) => [r.Material, r.CombustionTemperature, r.CarbonContent, r.LowerHeatingValue, r.HigherHeatingValue],
  803998398: (r) => [r.Material, r.MolecularWeight, r.Porosity, r.MassDensity],
  1446786286: (r) => [r.ProfileName, r.ProfileDefinition, r.PhysicalWeight, r.Perimeter, r.MinimumPlateThickness, r.MaximumPlateThickness, r.CrossSectionArea],
  3448662350: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth],
  2453401579: (r) => [],
  4142052618: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth, r.ParentContext, r.TargetScale, r.TargetView, r.UserDefinedTargetView],
  3590301190: (r) => [r.Elements],
  178086475: (r) => [r.PlacementLocation, r.PlacementRefDirection],
  812098782: (r) => [r.BaseSurface, r.AgreementFlag],
  2445078500: (r) => [r.Material, r.UpperVaporResistanceFactor, r.LowerVaporResistanceFactor, r.IsothermalMoistureCapacity, r.VaporPermeability, r.MoistureDiffusivity],
  3905492369: (r) => [r.RepeatS, r.RepeatT, r.TextureType, r.TextureTransform, r.UrlReference],
  3741457305: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.Values],
  1402838566: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  125510826: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  2604431987: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Orientation],
  4266656042: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.ColourAppearance, r.ColourTemperature, r.LuminousFlux, r.LightEmissionSource, r.LightDistributionDataSource],
  1520743889: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation],
  3422422726: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation, r.Orientation, r.ConcentrationExponent, r.SpreadAngle, r.BeamWidthAngle],
  2624227202: (r) => [r.PlacementRelTo, r.RelativePlacement],
  1008929658: (r) => [],
  2347385850: (r) => [r.MappingSource, r.MappingTarget],
  2022407955: (r) => [r.Name, r.Description, r.Representations, r.RepresentedMaterial],
  1430189142: (r) => [r.Material, r.DynamicViscosity, r.YoungModulus, r.ShearModulus, r.PoissonRatio, r.ThermalExpansionCoefficient, r.CompressiveStrength, r.MaxAggregateSize, r.AdmixturesDescription, r.Workability, r.ProtectivePoreRatio, r.WaterImpermeability],
  219451334: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2833995503: (r) => [r.RepeatFactor],
  2665983363: (r) => [r.CfsFaces],
  1029017970: (r) => [r.EdgeStart, r.EdgeEnd, r.EdgeElement, r.Orientation],
  2529465313: (r) => [r.ProfileType, r.ProfileName, r.Position],
  2519244187: (r) => [r.EdgeList],
  3021840470: (r) => [r.Name, r.Description, r.HasQuantities, r.Discrimination, r.Quality, r.Usage],
  597895409: (r) => [r.RepeatS, r.RepeatT, r.TextureType, r.TextureTransform, r.Width, r.Height, r.ColourComponents, r.Pixel],
  2004835150: (r) => [r.Location],
  1663979128: (r) => [r.SizeInX, r.SizeInY],
  2067069095: (r) => [],
  4022376103: (r) => [r.BasisCurve, r.PointParameter],
  1423911732: (r) => [r.BasisSurface, r.PointParameterU, r.PointParameterV],
  2924175390: (r) => [r.Polygon],
  2775532180: (r) => [r.BaseSurface, r.AgreementFlag, r.Position, r.PolygonalBoundary],
  759155922: (r) => [r.Name],
  2559016684: (r) => [r.Name],
  433424934: (r) => [r.Name],
  179317114: (r) => [r.Name],
  673634403: (r) => [r.Name, r.Description, r.Representations],
  871118103: (r) => [r.Name, r.Description, r.UpperBoundValue ? Labelise(r.UpperBoundValue) : null, r.LowerBoundValue ? Labelise(r.LowerBoundValue) : null, r.Unit],
  1680319473: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  4166981789: (r) => [r.Name, r.Description, r.EnumerationValues.map((e) => Labelise(e)), r.EnumerationReference],
  2752243245: (r) => [r.Name, r.Description, r.ListValues.map((e) => Labelise(e)), r.Unit],
  941946838: (r) => [r.Name, r.Description, r.UsageName, r.PropertyReference],
  3357820518: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  3650150729: (r) => [r.Name, r.Description, r.NominalValue ? Labelise(r.NominalValue) : null, r.Unit],
  110355661: (r) => [r.Name, r.Description, r.DefiningValues.map((e) => Labelise(e)), r.DefinedValues.map((e) => Labelise(e)), r.Expression, r.DefiningUnit, r.DefinedUnit],
  3615266464: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim],
  3413951693: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.TimeStep, r.Values],
  3765753017: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.DefinitionType, r.ReinforcementSectionDefinitions],
  478536968: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2778083089: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.RoundingRadius],
  1509187699: (r) => [r.SpineCurve, r.CrossSections, r.CrossSectionPositions],
  2411513650: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.PredefinedType, r.UpperValue ? Labelise(r.UpperValue) : null, Labelise(r.MostUsedValue), r.LowerValue ? Labelise(r.LowerValue) : null],
  4124623270: (r) => [r.SbsmBoundary],
  2609359061: (r) => [r.Name, r.SlippageX, r.SlippageY, r.SlippageZ],
  723233188: (r) => [],
  2485662743: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, (e = r.IsAttenuating) == null ? void 0 : e.toString(), r.SoundScale, r.SoundValues];
  },
  1202362311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.SoundLevelTimeSeries, r.Frequency, r.SoundLevelSingleValue ? Labelise(r.SoundLevelSingleValue) : null],
  390701378: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableValueRatio, r.ThermalLoadSource, r.PropertySource, r.SourceDescription, r.MaximumValue, r.MinimumValue, r.ThermalLoadTimeSeriesValues, r.UserDefinedThermalLoadSource, r.UserDefinedPropertySource, r.ThermalLoadType],
  1595516126: (r) => [r.Name, r.LinearForceX, r.LinearForceY, r.LinearForceZ, r.LinearMomentX, r.LinearMomentY, r.LinearMomentZ],
  2668620305: (r) => [r.Name, r.PlanarForceX, r.PlanarForceY, r.PlanarForceZ],
  2473145415: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ],
  1973038258: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ, r.Distortion],
  1597423693: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ],
  1190533807: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ, r.WarpingMoment],
  3843319758: (r) => [r.ProfileName, r.ProfileDefinition, r.PhysicalWeight, r.Perimeter, r.MinimumPlateThickness, r.MaximumPlateThickness, r.CrossSectionArea, r.TorsionalConstantX, r.MomentOfInertiaYZ, r.MomentOfInertiaY, r.MomentOfInertiaZ, r.WarpingConstant, r.ShearCentreZ, r.ShearCentreY, r.ShearDeformationAreaZ, r.ShearDeformationAreaY, r.MaximumSectionModulusY, r.MinimumSectionModulusY, r.MaximumSectionModulusZ, r.MinimumSectionModulusZ, r.TorsionalSectionModulus, r.CentreOfGravityInX, r.CentreOfGravityInY],
  3653947884: (r) => [r.ProfileName, r.ProfileDefinition, r.PhysicalWeight, r.Perimeter, r.MinimumPlateThickness, r.MaximumPlateThickness, r.CrossSectionArea, r.TorsionalConstantX, r.MomentOfInertiaYZ, r.MomentOfInertiaY, r.MomentOfInertiaZ, r.WarpingConstant, r.ShearCentreZ, r.ShearCentreY, r.ShearDeformationAreaZ, r.ShearDeformationAreaY, r.MaximumSectionModulusY, r.MinimumSectionModulusY, r.MaximumSectionModulusZ, r.MinimumSectionModulusZ, r.TorsionalSectionModulus, r.CentreOfGravityInX, r.CentreOfGravityInY, r.ShearAreaZ, r.ShearAreaY, r.PlasticShapeFactorY, r.PlasticShapeFactorZ],
  2233826070: (r) => [r.EdgeStart, r.EdgeEnd, r.ParentEdge],
  2513912981: (r) => [],
  1878645084: (r) => [r.SurfaceColour, r.Transparency, r.DiffuseColour, r.TransmissionColour, r.DiffuseTransmissionColour, r.ReflectionColour, r.SpecularColour, r.SpecularHighlight ? Labelise(r.SpecularHighlight) : null, r.ReflectanceMethod],
  2247615214: (r) => [r.SweptArea, r.Position],
  1260650574: (r) => [r.Directrix, r.Radius, r.InnerRadius, r.StartParam, r.EndParam],
  230924584: (r) => [r.SweptCurve, r.Position],
  3071757647: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.FlangeEdgeRadius, r.WebEdgeRadius, r.WebSlope, r.FlangeSlope, r.CentreOfGravityInY],
  3028897424: (r) => [r.Item, r.Styles, r.Name, r.AnnotatedCurve],
  4282788508: (r) => [r.Literal, r.Placement, r.Path],
  3124975700: (r) => [r.Literal, r.Placement, r.Path, r.Extent, r.BoxAlignment],
  2715220739: (r) => [r.ProfileType, r.ProfileName, r.Position, r.BottomXDim, r.TopXDim, r.YDim, r.TopXOffset],
  1345879162: (r) => [r.RepeatFactor, r.SecondRepeatFactor],
  1628702193: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets],
  2347495698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag],
  427810014: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius, r.FlangeSlope, r.CentreOfGravityInX],
  1417489154: (r) => [r.Orientation, r.Magnitude],
  2759199220: (r) => [r.LoopVertex],
  336235671: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.TransomThickness, r.MullionThickness, r.FirstTransomOffset, r.SecondTransomOffset, r.FirstMullionOffset, r.SecondMullionOffset, r.ShapeAspectStyle],
  512836454: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  1299126871: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ConstructionType, r.OperationType, r.ParameterTakesPrecedence, r.Sizeable],
  2543172580: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius],
  3288037868: (r) => [r.Item, r.Styles, r.Name],
  669184980: (r) => [r.OuterBoundary, r.InnerBoundaries],
  2265737646: (r) => [r.Item, r.Styles, r.Name, r.FillStyleTarget, r.GlobalOrLocal],
  1302238472: (r) => [r.Item, r.TextureCoordinates],
  4261334040: (r) => [r.Location, r.Axis],
  3125803723: (r) => [r.Location, r.RefDirection],
  2740243338: (r) => [r.Location, r.Axis, r.RefDirection],
  2736907675: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  4182860854: (r) => [],
  2581212453: (r) => [r.Corner, r.XDim, r.YDim, r.ZDim],
  2713105998: (r) => [r.BaseSurface, r.AgreementFlag, r.Enclosure],
  2898889636: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.WallThickness, r.Girth, r.InternalFilletRadius, r.CentreOfGravityInX],
  1123145078: (r) => [r.Coordinates],
  59481748: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3749851601: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3486308946: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Scale2],
  3331915920: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3],
  1416205885: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3, r.Scale2, r.Scale3],
  1383045692: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius],
  2205249479: (r) => [r.CfsFaces],
  2485617015: (r) => [r.Transition, r.SameSense, r.ParentCurve],
  4133800736: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallHeight, r.BaseWidth2, r.Radius, r.HeadWidth, r.HeadDepth2, r.HeadDepth3, r.WebThickness, r.BaseWidth4, r.BaseDepth1, r.BaseDepth2, r.BaseDepth3, r.CentreOfGravityInY],
  194851669: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallHeight, r.HeadWidth, r.Radius, r.HeadDepth2, r.HeadDepth3, r.WebThickness, r.BaseDepth1, r.BaseDepth2, r.CentreOfGravityInY],
  2506170314: (r) => [r.Position],
  2147822146: (r) => [r.TreeRootExpression],
  2601014836: (r) => [],
  2827736869: (r) => [r.BasisSurface, r.OuterBoundary, r.InnerBoundaries],
  693772133: (r) => [r.Definition, r.Target],
  606661476: (r) => [r.Item, r.Styles, r.Name],
  4054601972: (r) => [r.Item, r.Styles, r.Name, r.AnnotatedCurve, r.Role],
  32440307: (r) => [r.DirectionRatios],
  2963535650: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.ThresholdDepth, r.ThresholdThickness, r.TransomThickness, r.TransomOffset, r.LiningOffset, r.ThresholdOffset, r.CasingThickness, r.CasingDepth, r.ShapeAspectStyle],
  1714330368: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.PanelDepth, r.PanelOperation, r.PanelWidth, r.PanelPosition, r.ShapeAspectStyle],
  526551008: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.OperationType, r.ConstructionType, r.ParameterTakesPrecedence, r.Sizeable],
  3073041342: (r) => [r.Contents],
  445594917: (r) => [r.Name],
  4006246654: (r) => [r.Name],
  1472233963: (r) => [r.EdgeList],
  1883228015: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.MethodOfMeasurement, r.Quantities],
  339256511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2777663545: (r) => [r.Position],
  2835456948: (r) => [r.ProfileType, r.ProfileName, r.Position, r.SemiAxis1, r.SemiAxis2],
  80994333: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.EnergySequence, r.UserDefinedEnergySequence],
  477187591: (r) => [r.SweptArea, r.Position, r.ExtrudedDirection, r.Depth],
  2047409740: (r) => [r.FbsmFaces],
  374418227: (r) => [r.HatchLineAppearance, r.StartOfNextHatchLine, r.PointOfReferenceHatchLine, r.PatternStart, r.HatchLineAngle],
  4203026998: (r) => [r.Symbol],
  315944413: (r) => [r.TilingPattern, r.Tiles, r.TilingScale],
  3455213021: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.PropertySource, r.FlowConditionTimeSeries, r.VelocityTimeSeries, r.FlowrateTimeSeries, r.Fluid, r.PressureTimeSeries, r.UserDefinedPropertySource, r.TemperatureSingleValue, r.WetBulbTemperatureSingleValue, r.WetBulbTemperatureTimeSeries, r.TemperatureTimeSeries, r.FlowrateSingleValue ? Labelise(r.FlowrateSingleValue) : null, r.FlowConditionSingleValue, r.VelocitySingleValue, r.PressureSingleValue],
  4238390223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1268542332: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.AssemblyPlace],
  987898635: (r) => [r.Elements],
  1484403080: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallWidth, r.OverallDepth, r.WebThickness, r.FlangeThickness, r.FilletRadius],
  572779678: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.Thickness, r.FilletRadius, r.EdgeRadius, r.LegSlope, r.CentreOfGravityInX, r.CentreOfGravityInY],
  1281925730: (r) => [r.Pnt, r.Dir],
  1425443689: (r) => [r.Outer],
  3888040117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  3388369263: (r) => [r.BasisCurve, r.Distance, r.SelfIntersect],
  3505215534: (r) => [r.BasisCurve, r.Distance, r.SelfIntersect, r.RefDirection],
  3566463478: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  603570806: (r) => [r.SizeInX, r.SizeInY, r.Placement],
  220341763: (r) => [r.Position],
  2945172077: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  4208778838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  103090709: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  4194566429: (r) => [r.Item, r.Styles, r.Name],
  1451395588: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.HasProperties],
  3219374653: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.ProxyType, r.Tag],
  2770003689: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.WallThickness, r.InnerFilletRadius, r.OuterFilletRadius],
  2798486643: (r) => [r.Position, r.XLength, r.YLength, r.Height],
  3454111270: (r) => [r.BasisSurface, r.U1, r.V1, r.U2, r.V2, r.Usense, r.Vsense],
  3939117080: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType],
  1683148259: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingActor, r.ActingRole],
  2495723537: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl],
  1307041759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingGroup],
  4278684876: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProcess, r.QuantityInProcess],
  2857406711: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProduct],
  3372526763: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl],
  205026976: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingResource],
  1865459582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects],
  1327628568: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingAppliedValue],
  4095574036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingApproval],
  919958153: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingClassification],
  2728634034: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.Intent, r.RelatingConstraint],
  982818633: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingDocument],
  3840914261: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingLibrary],
  2655215786: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingMaterial],
  2851387026: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingProfileProperties, r.ProfileSectionLocation, r.ProfileOrientation],
  826625072: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1204542856: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement],
  3945020480: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RelatingPriorities, r.RelatedPriorities, r.RelatedConnectionType, r.RelatingConnectionType],
  4201705270: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedElement],
  3190031847: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedPort, r.RealizingElement],
  2127690289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedStructuralActivity],
  3912681535: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedStructuralMember],
  1638771189: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem],
  504942748: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem, r.ConnectionConstraint],
  3678494232: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RealizingElements, r.ConnectionType],
  3242617779: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  886880790: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedCoverings],
  2802773753: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedSpace, r.RelatedCoverings],
  2551354335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  693640335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects],
  4186316022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingPropertyDefinition],
  781010003: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingType],
  3940055652: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingOpeningElement, r.RelatedBuildingElement],
  279856033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedControlElements, r.RelatingFlowElement],
  4189434867: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.DailyInteraction, r.ImportanceRating, r.LocationOfInteraction, r.RelatedSpaceProgram, r.RelatingSpaceProgram],
  3268803585: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  2051452291: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingActor, r.ActingRole],
  202636808: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingPropertyDefinition, r.OverridingProperties],
  750771296: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedFeatureElement],
  1245217292: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  1058617721: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl],
  4122056220: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingProcess, r.RelatedProcess, r.TimeLag, r.SequenceType],
  366585022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSystem, r.RelatedBuildings],
  3451746338: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary],
  1401173127: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedOpeningElement],
  2914609552: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1856042241: (r) => [r.SweptArea, r.Position, r.Axis, r.Angle],
  4158566097: (r) => [r.Position, r.Height, r.BottomRadius],
  3626867408: (r) => [r.Position, r.Height, r.Radius],
  2706606064: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType],
  3893378262: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  451544542: (r) => [r.Position, r.Radius],
  3544373492: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3136571912: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  530289379: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  3689010777: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3979015343: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness],
  2218152070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness, r.SubsequentThickness, r.VaryingThicknessLocation],
  4070609034: (r) => [r.Contents],
  2028607225: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam, r.EndParam, r.ReferenceSurface],
  2809605785: (r) => [r.SweptCurve, r.Position, r.ExtrudedDirection, r.Depth],
  4124788165: (r) => [r.SweptCurve, r.Position, r.AxisPosition],
  1580310250: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3473067441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TaskId, r.Status, r.WorkMethod, r.IsMilestone, r.Priority],
  2097647324: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2296667514: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor],
  1674181508: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  3207858831: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallWidth, r.OverallDepth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.TopFlangeWidth, r.TopFlangeThickness, r.TopFlangeFilletRadius, r.CentreOfGravityInY],
  1334484129: (r) => [r.Position, r.XLength, r.YLength, r.ZLength],
  3649129432: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  1260505505: (r) => [],
  4031249490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.ElevationOfRefHeight, r.ElevationOfTerrain, r.BuildingAddress],
  1950629157: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3124254112: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.Elevation],
  2937912522: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius, r.WallThickness],
  300633059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3732776249: (r) => [r.Segments, r.SelfIntersect],
  2510884976: (r) => [r.Position],
  2559216714: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity],
  3293443760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  3895139033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1419761937: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.SubmittedBy, r.PreparedBy, r.SubmittedOn, r.Status, r.TargetUsers, r.UpdateDate, r.ID, r.PredefinedType],
  1916426348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3295246426: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity],
  1457835157: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  681481545: (r) => [r.Contents],
  3256556792: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3849074793: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  360485395: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.EnergySequence, r.UserDefinedEnergySequence, r.ElectricCurrentType, r.InputVoltage, r.InputFrequency, r.FullLoadCurrent, r.MinimumCircuitCurrent, r.MaximumPowerInput, r.RatedPowerInput, r.InputPhase],
  1758889154: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4123344466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.AssemblyPlace, r.PredefinedType],
  1623761950: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2590856083: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1704287377: (r) => [r.Position, r.SemiAxis1, r.SemiAxis2],
  2107101300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1962604670: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3272907226: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  3174744832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3390157468: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  807026263: (r) => [r.Outer],
  3737207727: (r) => [r.Outer, r.Voids],
  647756555: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2489546625: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2827207264: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2143335405: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1287392070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3907093117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3198132628: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3815607619: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1482959167: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1834744321: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1339347760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2297155007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3009222698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  263784265: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  814719939: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  200128114: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3009204131: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.UAxes, r.VAxes, r.WAxes],
  2706460486: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1251058090: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1806887404: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2391368822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.InventoryType, r.Jurisdiction, r.ResponsiblePersons, r.LastUpdateDate, r.CurrentValue, r.OriginalValue],
  4288270099: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3827777499: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity, r.SkillSet],
  1051575348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1161773419: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2506943328: (r) => [r.Contents],
  377706215: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NominalDiameter, r.NominalLength],
  2108223431: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3181161470: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  977012517: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1916936684: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TaskId, r.Status, r.WorkMethod, r.IsMilestone, r.Priority, r.MoveFrom, r.MoveTo, r.PunchList],
  4143007308: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor, r.PredefinedType],
  3588315303: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3425660407: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TaskId, r.Status, r.WorkMethod, r.IsMilestone, r.Priority, r.ActionID],
  2837617999: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2382730787: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LifeCyclePhase],
  3327091369: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PermitID],
  804291784: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4231323485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4017108033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3724593414: (r) => [r.Points],
  3740093272: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  2744685151: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ProcedureID, r.ProcedureType, r.UserDefinedProcedureType],
  2904328755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ID, r.PredefinedType, r.Status],
  3642467123: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Records, r.PredefinedType],
  3651124850: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1842657554: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2250791053: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3248260540: (r) => [r.Contents],
  2893384427: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2324767716: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  160246688: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  2863920197: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl, r.TimeForTask],
  1768891740: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3517283431: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ActualStart, r.EarlyStart, r.LateStart, r.ScheduleStart, r.ActualFinish, r.EarlyFinish, r.LateFinish, r.ScheduleFinish, r.ScheduleDuration, r.ActualDuration, r.RemainingTime, r.FreeFloat, r.TotalFloat, r.IsCritical, r.StatusTime, r.StartFloat, r.FinishFloat, r.Completion],
  4105383287: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ServiceLifeType, r.ServiceLifeDuration],
  4097777520: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.RefLatitude, r.RefLongitude, r.RefElevation, r.LandTitleNumber, r.SiteAddress],
  2533589738: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3856911033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.InteriorOrExteriorSpace, r.ElevationWithFlooring],
  1305183839: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  652456506: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.SpaceProgramIdentifier, r.MaxRequiredArea, r.MinRequiredArea, r.RequestedLocation, r.StandardRequiredArea],
  3812236995: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3112655638: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1039846685: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  682877961: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy],
  1179482911: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  4243806635: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  214636428: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType],
  2445595289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType],
  1807405624: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy, r.ProjectedOrTrue],
  1721250024: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy, r.ProjectedOrTrue, r.VaryingAppliedLoadLocation, r.SubsequentAppliedLoads],
  1252848954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.ActionType, r.ActionSource, r.Coefficient, r.Purpose],
  1621171031: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy, r.ProjectedOrTrue],
  3987759626: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy, r.ProjectedOrTrue, r.VaryingAppliedLoadLocation, r.SubsequentAppliedLoads],
  2082059205: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.DestabilizingLoad, r.CausedBy],
  734778138: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  1235345126: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  2986769608: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheoryType, r.ResultForLoadGroup, r.IsLinear],
  1975003073: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  148013059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity, r.SubContractor, r.JobDescription],
  2315554128: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2254336722: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  5716631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1637806684: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ApplicableDates, r.TimeSeriesScheduleType, r.TimeSeries],
  1692211062: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1620046519: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OperationType, r.CapacityByWeight, r.CapacityByNumber],
  3593883385: (r) => [r.BasisCurve, r.Trim1, r.Trim2, r.SenseAgreement, r.MasterRepresentation],
  1600972822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1911125066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  728799441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2769231204: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1898987631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1133259667: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1028945134: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identifier, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.WorkControlType, r.UserDefinedControlType],
  4218914973: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identifier, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.WorkControlType, r.UserDefinedControlType],
  3342526732: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identifier, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.WorkControlType, r.UserDefinedControlType],
  1033361043: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1213861670: (r) => [r.Segments, r.SelfIntersect],
  3821786052: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.RequestID],
  1411407467: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3352864051: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1871374353: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2470393545: (r) => [r.Contents],
  3460190687: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.AssetID, r.OriginalValue, r.CurrentValue, r.TotalReplacementCost, r.Owner, r.User, r.ResponsiblePerson, r.IncorporationDate, r.DepreciatedValue],
  1967976161: (r) => [r.Degree, r.ControlPointsList, r.CurveForm, r.ClosedCurve, r.SelfIntersect],
  819618141: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1916977116: (r) => [r.Degree, r.ControlPointsList, r.CurveForm, r.ClosedCurve, r.SelfIntersect],
  231477066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3299480353: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  52481810: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2979338954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1095909175: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.CompositionType],
  1909888760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  395041908: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3293546465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1285652485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2951183804: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2611217952: (r) => [r.Position, r.Radius],
  2301859152: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  843113511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3850581409: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2816379211: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2188551683: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1163958913: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Criterion, r.CriterionDateTime],
  3898045240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity],
  1060000209: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity, r.Suppliers, r.UsageRatio],
  488727124: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ResourceIdentifier, r.ResourceGroup, r.ResourceConsumption, r.BaseQuantity],
  335055490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2954562838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1973544240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3495092785: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3961806047: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4147604152: (r) => [r.Contents],
  1335981549: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2635815018: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1599208980: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2063403501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1945004755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3040386961: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3041715199: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.FlowDirection],
  395920057: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth],
  869906466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3760055223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2030761528: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  855621170: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.FeatureLength],
  663422040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3277789161: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1534661035: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1365060375: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1217240411: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  712377611: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1634875225: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  857184966: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1658829314: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  346874300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1810631287: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4222183408: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2058353004: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4278956645: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4037862832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3132237377: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  987401354: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  707683696: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2223149337: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3508470533: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  900683007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1073191201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1687234759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType, r.ConstructionType],
  3171933400: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2262370178: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3024970846: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.ShapeType],
  3283111854: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3055160366: (r) => [r.Degree, r.ControlPointsList, r.CurveForm, r.ClosedCurve, r.SelfIntersect, r.WeightsData],
  3027567501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade],
  2320036040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.MeshLength, r.MeshWidth, r.LongitudinalBarNominalDiameter, r.TransverseBarNominalDiameter, r.LongitudinalBarCrossSectionArea, r.TransverseBarCrossSectionArea, r.LongitudinalBarSpacing, r.TransverseBarSpacing],
  2016517767: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.ShapeType],
  1376911519: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.FeatureLength, r.Radius],
  1783015770: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1529196076: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  331165859: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.ShapeType],
  4252922144: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NumberOfRiser, r.NumberOfTreads, r.RiserHeight, r.TreadLength],
  2515109513: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.OrientationOf2DPlane, r.LoadedBy, r.HasResults],
  3824725483: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.TensionForce, r.PreStress, r.FrictionCoefficient, r.AnchorageSlip, r.MinCurvatureRadius],
  2347447852: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade],
  3313531582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2391406946: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3512223829: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3304561284: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth],
  2874132201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3001207471: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  753842376: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2454782716: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.FeatureLength, r.Width, r.Height],
  578613899: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1052013943: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1062813311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.ControlElementId],
  3700593921: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.DistributionPointFunction, r.UserDefinedFunction],
  979691226: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.NominalDiameter, r.CrossSectionArea, r.BarLength, r.BarRole, r.BarSurface]
};
TypeInitialisers[1] = {
  3699917729: (r) => new IFC2X3.IfcAbsorbedDoseMeasure(r),
  4182062534: (r) => new IFC2X3.IfcAccelerationMeasure(r),
  360377573: (r) => new IFC2X3.IfcAmountOfSubstanceMeasure(r),
  632304761: (r) => new IFC2X3.IfcAngularVelocityMeasure(r),
  2650437152: (r) => new IFC2X3.IfcAreaMeasure(r),
  2735952531: (r) => new IFC2X3.IfcBoolean(r),
  1867003952: (r) => new IFC2X3.IfcBoxAlignment(r),
  2991860651: (r) => new IFC2X3.IfcComplexNumber(r.map((e) => e.value)),
  3812528620: (r) => new IFC2X3.IfcCompoundPlaneAngleMeasure(r.map((e) => e.value)),
  3238673880: (r) => new IFC2X3.IfcContextDependentMeasure(r),
  1778710042: (r) => new IFC2X3.IfcCountMeasure(r),
  94842927: (r) => new IFC2X3.IfcCurvatureMeasure(r),
  86635668: (r) => new IFC2X3.IfcDayInMonthNumber(r),
  300323983: (r) => new IFC2X3.IfcDaylightSavingHour(r),
  1514641115: (r) => new IFC2X3.IfcDescriptiveMeasure(r),
  4134073009: (r) => new IFC2X3.IfcDimensionCount(r),
  524656162: (r) => new IFC2X3.IfcDoseEquivalentMeasure(r),
  69416015: (r) => new IFC2X3.IfcDynamicViscosityMeasure(r),
  1827137117: (r) => new IFC2X3.IfcElectricCapacitanceMeasure(r),
  3818826038: (r) => new IFC2X3.IfcElectricChargeMeasure(r),
  2093906313: (r) => new IFC2X3.IfcElectricConductanceMeasure(r),
  3790457270: (r) => new IFC2X3.IfcElectricCurrentMeasure(r),
  2951915441: (r) => new IFC2X3.IfcElectricResistanceMeasure(r),
  2506197118: (r) => new IFC2X3.IfcElectricVoltageMeasure(r),
  2078135608: (r) => new IFC2X3.IfcEnergyMeasure(r),
  1102727119: (r) => new IFC2X3.IfcFontStyle(r),
  2715512545: (r) => new IFC2X3.IfcFontVariant(r),
  2590844177: (r) => new IFC2X3.IfcFontWeight(r),
  1361398929: (r) => new IFC2X3.IfcForceMeasure(r),
  3044325142: (r) => new IFC2X3.IfcFrequencyMeasure(r),
  3064340077: (r) => new IFC2X3.IfcGloballyUniqueId(r),
  3113092358: (r) => new IFC2X3.IfcHeatFluxDensityMeasure(r),
  1158859006: (r) => new IFC2X3.IfcHeatingValueMeasure(r),
  2589826445: (r) => new IFC2X3.IfcHourInDay(r),
  983778844: (r) => new IFC2X3.IfcIdentifier(r),
  3358199106: (r) => new IFC2X3.IfcIlluminanceMeasure(r),
  2679005408: (r) => new IFC2X3.IfcInductanceMeasure(r),
  1939436016: (r) => new IFC2X3.IfcInteger(r),
  3809634241: (r) => new IFC2X3.IfcIntegerCountRateMeasure(r),
  3686016028: (r) => new IFC2X3.IfcIonConcentrationMeasure(r),
  3192672207: (r) => new IFC2X3.IfcIsothermalMoistureCapacityMeasure(r),
  2054016361: (r) => new IFC2X3.IfcKinematicViscosityMeasure(r),
  3258342251: (r) => new IFC2X3.IfcLabel(r),
  1243674935: (r) => new IFC2X3.IfcLengthMeasure(r),
  191860431: (r) => new IFC2X3.IfcLinearForceMeasure(r),
  2128979029: (r) => new IFC2X3.IfcLinearMomentMeasure(r),
  1307019551: (r) => new IFC2X3.IfcLinearStiffnessMeasure(r),
  3086160713: (r) => new IFC2X3.IfcLinearVelocityMeasure(r),
  503418787: (r) => new IFC2X3.IfcLogical(r),
  2095003142: (r) => new IFC2X3.IfcLuminousFluxMeasure(r),
  2755797622: (r) => new IFC2X3.IfcLuminousIntensityDistributionMeasure(r),
  151039812: (r) => new IFC2X3.IfcLuminousIntensityMeasure(r),
  286949696: (r) => new IFC2X3.IfcMagneticFluxDensityMeasure(r),
  2486716878: (r) => new IFC2X3.IfcMagneticFluxMeasure(r),
  1477762836: (r) => new IFC2X3.IfcMassDensityMeasure(r),
  4017473158: (r) => new IFC2X3.IfcMassFlowRateMeasure(r),
  3124614049: (r) => new IFC2X3.IfcMassMeasure(r),
  3531705166: (r) => new IFC2X3.IfcMassPerLengthMeasure(r),
  102610177: (r) => new IFC2X3.IfcMinuteInHour(r),
  3341486342: (r) => new IFC2X3.IfcModulusOfElasticityMeasure(r),
  2173214787: (r) => new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(r),
  1052454078: (r) => new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(r),
  1753493141: (r) => new IFC2X3.IfcModulusOfSubgradeReactionMeasure(r),
  3177669450: (r) => new IFC2X3.IfcMoistureDiffusivityMeasure(r),
  1648970520: (r) => new IFC2X3.IfcMolecularWeightMeasure(r),
  3114022597: (r) => new IFC2X3.IfcMomentOfInertiaMeasure(r),
  2615040989: (r) => new IFC2X3.IfcMonetaryMeasure(r),
  765770214: (r) => new IFC2X3.IfcMonthInYearNumber(r),
  2095195183: (r) => new IFC2X3.IfcNormalisedRatioMeasure(r),
  2395907400: (r) => new IFC2X3.IfcNumericMeasure(r),
  929793134: (r) => new IFC2X3.IfcPHMeasure(r),
  2260317790: (r) => new IFC2X3.IfcParameterValue(r),
  2642773653: (r) => new IFC2X3.IfcPlanarForceMeasure(r),
  4042175685: (r) => new IFC2X3.IfcPlaneAngleMeasure(r),
  2815919920: (r) => new IFC2X3.IfcPositiveLengthMeasure(r),
  3054510233: (r) => new IFC2X3.IfcPositivePlaneAngleMeasure(r),
  1245737093: (r) => new IFC2X3.IfcPositiveRatioMeasure(r),
  1364037233: (r) => new IFC2X3.IfcPowerMeasure(r),
  2169031380: (r) => new IFC2X3.IfcPresentableText(r),
  3665567075: (r) => new IFC2X3.IfcPressureMeasure(r),
  3972513137: (r) => new IFC2X3.IfcRadioActivityMeasure(r),
  96294661: (r) => new IFC2X3.IfcRatioMeasure(r),
  200335297: (r) => new IFC2X3.IfcReal(r),
  2133746277: (r) => new IFC2X3.IfcRotationalFrequencyMeasure(r),
  1755127002: (r) => new IFC2X3.IfcRotationalMassMeasure(r),
  3211557302: (r) => new IFC2X3.IfcRotationalStiffnessMeasure(r),
  2766185779: (r) => new IFC2X3.IfcSecondInMinute(r),
  3467162246: (r) => new IFC2X3.IfcSectionModulusMeasure(r),
  2190458107: (r) => new IFC2X3.IfcSectionalAreaIntegralMeasure(r),
  408310005: (r) => new IFC2X3.IfcShearModulusMeasure(r),
  3471399674: (r) => new IFC2X3.IfcSolidAngleMeasure(r),
  846465480: (r) => new IFC2X3.IfcSoundPowerMeasure(r),
  993287707: (r) => new IFC2X3.IfcSoundPressureMeasure(r),
  3477203348: (r) => new IFC2X3.IfcSpecificHeatCapacityMeasure(r),
  2757832317: (r) => new IFC2X3.IfcSpecularExponent(r),
  361837227: (r) => new IFC2X3.IfcSpecularRoughness(r),
  58845555: (r) => new IFC2X3.IfcTemperatureGradientMeasure(r),
  2801250643: (r) => new IFC2X3.IfcText(r),
  1460886941: (r) => new IFC2X3.IfcTextAlignment(r),
  3490877962: (r) => new IFC2X3.IfcTextDecoration(r),
  603696268: (r) => new IFC2X3.IfcTextFontName(r),
  296282323: (r) => new IFC2X3.IfcTextTransformation(r),
  232962298: (r) => new IFC2X3.IfcThermalAdmittanceMeasure(r),
  2645777649: (r) => new IFC2X3.IfcThermalConductivityMeasure(r),
  2281867870: (r) => new IFC2X3.IfcThermalExpansionCoefficientMeasure(r),
  857959152: (r) => new IFC2X3.IfcThermalResistanceMeasure(r),
  2016195849: (r) => new IFC2X3.IfcThermalTransmittanceMeasure(r),
  743184107: (r) => new IFC2X3.IfcThermodynamicTemperatureMeasure(r),
  2726807636: (r) => new IFC2X3.IfcTimeMeasure(r),
  2591213694: (r) => new IFC2X3.IfcTimeStamp(r),
  1278329552: (r) => new IFC2X3.IfcTorqueMeasure(r),
  3345633955: (r) => new IFC2X3.IfcVaporPermeabilityMeasure(r),
  3458127941: (r) => new IFC2X3.IfcVolumeMeasure(r),
  2593997549: (r) => new IFC2X3.IfcVolumetricFlowRateMeasure(r),
  51269191: (r) => new IFC2X3.IfcWarpingConstantMeasure(r),
  1718600412: (r) => new IFC2X3.IfcWarpingMomentMeasure(r),
  4065007721: (r) => new IFC2X3.IfcYearNumber(r)
};
var IFC2X3;
(function(r) {
  class e {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcAbsorbedDoseMeasure = e;
  class s {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcAccelerationMeasure = s;
  class o {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcAmountOfSubstanceMeasure = o;
  class a {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcAngularVelocityMeasure = a;
  class l {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcAreaMeasure = l;
  class u {
    constructor(ue) {
      this.type = 3, this.value = ue == "true";
    }
  }
  r.IfcBoolean = u;
  class c {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcBoxAlignment = c;
  class E {
    constructor(ue) {
      this.value = ue;
    }
  }
  r.IfcComplexNumber = E;
  class d {
    constructor(ue) {
      this.value = ue;
    }
  }
  r.IfcCompoundPlaneAngleMeasure = d;
  class f {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcContextDependentMeasure = f;
  class h {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcCountMeasure = h;
  class S {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcCurvatureMeasure = S;
  class R {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcDayInMonthNumber = R;
  class _ {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcDaylightSavingHour = _;
  class m {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcDescriptiveMeasure = m;
  class L {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcDimensionCount = L;
  class F {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcDoseEquivalentMeasure = F;
  class W {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcDynamicViscosityMeasure = W;
  class G {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricCapacitanceMeasure = G;
  class q {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricChargeMeasure = q;
  class fe {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricConductanceMeasure = fe;
  class _e {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricCurrentMeasure = _e;
  class Le {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricResistanceMeasure = Le;
  class Fe {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcElectricVoltageMeasure = Fe;
  class Ee {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcEnergyMeasure = Ee;
  class Ge {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcFontStyle = Ge;
  class ve {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcFontVariant = ve;
  class te {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcFontWeight = te;
  class ae {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcForceMeasure = ae;
  class v {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcFrequencyMeasure = v;
  class Te {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcGloballyUniqueId = Te;
  class De {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcHeatFluxDensityMeasure = De;
  class be {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcHeatingValueMeasure = be;
  class ze {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcHourInDay = ze;
  class ke {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcIdentifier = ke;
  class Be {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcIlluminanceMeasure = Be;
  class Me {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcInductanceMeasure = Me;
  class me {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcInteger = me;
  class Se {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcIntegerCountRateMeasure = Se;
  class xt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcIonConcentrationMeasure = xt;
  class Ht {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcIsothermalMoistureCapacityMeasure = Ht;
  class Bt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcKinematicViscosityMeasure = Bt;
  class ut {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcLabel = ut;
  class Tt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLengthMeasure = Tt;
  class Yt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLinearForceMeasure = Yt;
  class an {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLinearMomentMeasure = an;
  class Ct {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLinearStiffnessMeasure = Ct;
  class st {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLinearVelocityMeasure = st;
  class jt {
    constructor(ue) {
      this.type = 3, this.value = ue == "true";
    }
  }
  r.IfcLogical = jt;
  class lt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLuminousFluxMeasure = lt;
  class Zt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLuminousIntensityDistributionMeasure = Zt;
  class Et {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcLuminousIntensityMeasure = Et;
  class Ke {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMagneticFluxDensityMeasure = Ke;
  class $e {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMagneticFluxMeasure = $e;
  class pt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMassDensityMeasure = pt;
  class Jt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMassFlowRateMeasure = Jt;
  class In {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMassMeasure = In;
  class Cn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMassPerLengthMeasure = Cn;
  class It {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMinuteInHour = It;
  class ht {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcModulusOfElasticityMeasure = ht;
  class Wt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcModulusOfLinearSubgradeReactionMeasure = Wt;
  class hn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcModulusOfRotationalSubgradeReactionMeasure = hn;
  class Vt {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcModulusOfSubgradeReactionMeasure = Vt;
  class Tn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMoistureDiffusivityMeasure = Tn;
  class Rn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMolecularWeightMeasure = Rn;
  class Nn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMomentOfInertiaMeasure = Nn;
  class Dn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMonetaryMeasure = Dn;
  class xn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcMonthInYearNumber = xn;
  class $n {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcNormalisedRatioMeasure = $n;
  class Kn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcNumericMeasure = Kn;
  class ir {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPHMeasure = ir;
  class er {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcParameterValue = er;
  class br {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPlanarForceMeasure = br;
  class cs {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPlaneAngleMeasure = cs;
  class Gn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPositiveLengthMeasure = Gn;
  class Jn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPositivePlaneAngleMeasure = Jn;
  class Xn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPositiveRatioMeasure = Xn;
  class rr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPowerMeasure = rr;
  class _r {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcPresentableText = _r;
  class Ss {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcPressureMeasure = Ss;
  class is {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcRadioActivityMeasure = is;
  class Ms {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcRatioMeasure = Ms;
  class ls {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcReal = ls;
  class Ur {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcRotationalFrequencyMeasure = Ur;
  class Qr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcRotationalMassMeasure = Qr;
  class Fr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcRotationalStiffnessMeasure = Fr;
  class Lr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSecondInMinute = Lr;
  class Hr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSectionModulusMeasure = Hr;
  class ns {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSectionalAreaIntegralMeasure = ns;
  class Ts {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcShearModulusMeasure = Ts;
  class en {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSolidAngleMeasure = en;
  class to {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSoundPowerMeasure = to;
  class bs {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSoundPressureMeasure = bs;
  class jn {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSpecificHeatCapacityMeasure = jn;
  class lr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSpecularExponent = lr;
  class pr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcSpecularRoughness = pr;
  class En {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcTemperatureGradientMeasure = En;
  class qn {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcText = qn;
  class Wn {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcTextAlignment = Wn;
  class kn {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcTextDecoration = kn;
  class zn {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcTextFontName = zn;
  class wr {
    constructor(ue) {
      this.value = ue, this.type = 1;
    }
  }
  r.IfcTextTransformation = wr;
  class jr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermalAdmittanceMeasure = jr;
  class Vr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermalConductivityMeasure = Vr;
  class us {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermalExpansionCoefficientMeasure = us;
  class Es {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermalResistanceMeasure = Es;
  class Dr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermalTransmittanceMeasure = Dr;
  class Kr {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcThermodynamicTemperatureMeasure = Kr;
  class Js {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcTimeMeasure = Js;
  class io {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcTimeStamp = io;
  class No {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcTorqueMeasure = No;
  class Ai {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcVaporPermeabilityMeasure = Ai;
  class go {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcVolumeMeasure = go;
  class ks {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcVolumetricFlowRateMeasure = ks;
  class Ci {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcWarpingConstantMeasure = Ci;
  class Io {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcWarpingMomentMeasure = Io;
  class Oo {
    constructor(ue) {
      this.type = 4, this.value = parseFloat(ue);
    }
  }
  r.IfcYearNumber = Oo;
  class Zs {
  }
  Zs.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Zs.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Zs.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Zs.SNOW_S = { type: 3, value: "SNOW_S" }, Zs.WIND_W = { type: 3, value: "WIND_W" }, Zs.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Zs.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Zs.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Zs.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Zs.FIRE = { type: 3, value: "FIRE" }, Zs.IMPULSE = { type: 3, value: "IMPULSE" }, Zs.IMPACT = { type: 3, value: "IMPACT" }, Zs.TRANSPORT = { type: 3, value: "TRANSPORT" }, Zs.ERECTION = { type: 3, value: "ERECTION" }, Zs.PROPPING = { type: 3, value: "PROPPING" }, Zs.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Zs.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Zs.CREEP = { type: 3, value: "CREEP" }, Zs.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Zs.BUOYANCY = { type: 3, value: "BUOYANCY" }, Zs.ICE = { type: 3, value: "ICE" }, Zs.CURRENT = { type: 3, value: "CURRENT" }, Zs.WAVE = { type: 3, value: "WAVE" }, Zs.RAIN = { type: 3, value: "RAIN" }, Zs.BRAKES = { type: 3, value: "BRAKES" }, Zs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionSourceTypeEnum = Zs;
  class wt {
  }
  wt.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, wt.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, wt.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, wt.USERDEFINED = { type: 3, value: "USERDEFINED" }, wt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionTypeEnum = wt;
  class _t {
  }
  _t.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, _t.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, _t.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, _t.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, _t.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, _t.USERDEFINED = { type: 3, value: "USERDEFINED" }, _t.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActuatorTypeEnum = _t;
  class Ve {
  }
  Ve.OFFICE = { type: 3, value: "OFFICE" }, Ve.SITE = { type: 3, value: "SITE" }, Ve.HOME = { type: 3, value: "HOME" }, Ve.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, Ve.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcAddressTypeEnum = Ve;
  class Ze {
  }
  Ze.AHEAD = { type: 3, value: "AHEAD" }, Ze.BEHIND = { type: 3, value: "BEHIND" }, r.IfcAheadOrBehind = Ze;
  class bt {
  }
  bt.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, bt.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, bt.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, bt.USERDEFINED = { type: 3, value: "USERDEFINED" }, bt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalBoxTypeEnum = bt;
  class Ut {
  }
  Ut.GRILLE = { type: 3, value: "GRILLE" }, Ut.REGISTER = { type: 3, value: "REGISTER" }, Ut.DIFFUSER = { type: 3, value: "DIFFUSER" }, Ut.EYEBALL = { type: 3, value: "EYEBALL" }, Ut.IRIS = { type: 3, value: "IRIS" }, Ut.LINEARGRILLE = { type: 3, value: "LINEARGRILLE" }, Ut.LINEARDIFFUSER = { type: 3, value: "LINEARDIFFUSER" }, Ut.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ut.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalTypeEnum = Ut;
  class mn {
  }
  mn.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, mn.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, mn.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, mn.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, mn.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, mn.HEATPIPE = { type: 3, value: "HEATPIPE" }, mn.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, mn.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, mn.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, mn.USERDEFINED = { type: 3, value: "USERDEFINED" }, mn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirToAirHeatRecoveryTypeEnum = mn;
  class nn {
  }
  nn.BELL = { type: 3, value: "BELL" }, nn.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, nn.LIGHT = { type: 3, value: "LIGHT" }, nn.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, nn.SIREN = { type: 3, value: "SIREN" }, nn.WHISTLE = { type: 3, value: "WHISTLE" }, nn.USERDEFINED = { type: 3, value: "USERDEFINED" }, nn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAlarmTypeEnum = nn;
  class Sn {
  }
  Sn.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, Sn.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, Sn.LOADING_3D = { type: 3, value: "LOADING_3D" }, Sn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisModelTypeEnum = Sn;
  class Mn {
  }
  Mn.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, Mn.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, Mn.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, Mn.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, Mn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisTheoryTypeEnum = Mn;
  class yn {
  }
  yn.ADD = { type: 3, value: "ADD" }, yn.DIVIDE = { type: 3, value: "DIVIDE" }, yn.MULTIPLY = { type: 3, value: "MULTIPLY" }, yn.SUBTRACT = { type: 3, value: "SUBTRACT" }, r.IfcArithmeticOperatorEnum = yn;
  class Pt {
  }
  Pt.SITE = { type: 3, value: "SITE" }, Pt.FACTORY = { type: 3, value: "FACTORY" }, Pt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAssemblyPlaceEnum = Pt;
  class tr {
  }
  tr.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, tr.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, tr.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, tr.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, tr.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, tr.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcBSplineCurveForm = tr;
  class Lt {
  }
  Lt.BEAM = { type: 3, value: "BEAM" }, Lt.JOIST = { type: 3, value: "JOIST" }, Lt.LINTEL = { type: 3, value: "LINTEL" }, Lt.T_BEAM = { type: 3, value: "T_BEAM" }, Lt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBeamTypeEnum = Lt;
  class dr {
  }
  dr.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, dr.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, dr.LESSTHAN = { type: 3, value: "LESSTHAN" }, dr.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, dr.EQUALTO = { type: 3, value: "EQUALTO" }, dr.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" }, r.IfcBenchmarkEnum = dr;
  class ur {
  }
  ur.WATER = { type: 3, value: "WATER" }, ur.STEAM = { type: 3, value: "STEAM" }, ur.USERDEFINED = { type: 3, value: "USERDEFINED" }, ur.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBoilerTypeEnum = ur;
  class gr {
  }
  gr.UNION = { type: 3, value: "UNION" }, gr.INTERSECTION = { type: 3, value: "INTERSECTION" }, gr.DIFFERENCE = { type: 3, value: "DIFFERENCE" }, r.IfcBooleanOperator = gr;
  class Rr {
  }
  Rr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingElementProxyTypeEnum = Rr;
  class as {
  }
  as.BEND = { type: 3, value: "BEND" }, as.CROSS = { type: 3, value: "CROSS" }, as.REDUCER = { type: 3, value: "REDUCER" }, as.TEE = { type: 3, value: "TEE" }, as.USERDEFINED = { type: 3, value: "USERDEFINED" }, as.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierFittingTypeEnum = as;
  class hs {
  }
  hs.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, hs.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, hs.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, hs.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierSegmentTypeEnum = hs;
  class Os {
  }
  Os.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, Os.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, Os.USERDEFINED = { type: 3, value: "USERDEFINED" }, Os.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableSegmentTypeEnum = Os;
  class jo {
  }
  jo.NOCHANGE = { type: 3, value: "NOCHANGE" }, jo.MODIFIED = { type: 3, value: "MODIFIED" }, jo.ADDED = { type: 3, value: "ADDED" }, jo.DELETED = { type: 3, value: "DELETED" }, jo.MODIFIEDADDED = { type: 3, value: "MODIFIEDADDED" }, jo.MODIFIEDDELETED = { type: 3, value: "MODIFIEDDELETED" }, r.IfcChangeActionEnum = jo;
  class po {
  }
  po.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, po.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, po.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, po.USERDEFINED = { type: 3, value: "USERDEFINED" }, po.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChillerTypeEnum = po;
  class So {
  }
  So.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, So.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, So.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, So.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, So.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, So.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, So.USERDEFINED = { type: 3, value: "USERDEFINED" }, So.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoilTypeEnum = So;
  class Eo {
  }
  Eo.COLUMN = { type: 3, value: "COLUMN" }, Eo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Eo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcColumnTypeEnum = Eo;
  class Ps {
  }
  Ps.DYNAMIC = { type: 3, value: "DYNAMIC" }, Ps.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, Ps.ROTARY = { type: 3, value: "ROTARY" }, Ps.SCROLL = { type: 3, value: "SCROLL" }, Ps.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, Ps.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, Ps.BOOSTER = { type: 3, value: "BOOSTER" }, Ps.OPENTYPE = { type: 3, value: "OPENTYPE" }, Ps.HERMETIC = { type: 3, value: "HERMETIC" }, Ps.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, Ps.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, Ps.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, Ps.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, Ps.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, Ps.TWINSCREW = { type: 3, value: "TWINSCREW" }, Ps.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCompressorTypeEnum = Ps;
  class no {
  }
  no.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, no.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, no.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, no.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, no.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, no.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, no.USERDEFINED = { type: 3, value: "USERDEFINED" }, no.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCondenserTypeEnum = no;
  class gs {
  }
  gs.ATPATH = { type: 3, value: "ATPATH" }, gs.ATSTART = { type: 3, value: "ATSTART" }, gs.ATEND = { type: 3, value: "ATEND" }, gs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConnectionTypeEnum = gs;
  class fo {
  }
  fo.HARD = { type: 3, value: "HARD" }, fo.SOFT = { type: 3, value: "SOFT" }, fo.ADVISORY = { type: 3, value: "ADVISORY" }, fo.USERDEFINED = { type: 3, value: "USERDEFINED" }, fo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstraintEnum = fo;
  class xs {
  }
  xs.FLOATING = { type: 3, value: "FLOATING" }, xs.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, xs.PROPORTIONALINTEGRAL = { type: 3, value: "PROPORTIONALINTEGRAL" }, xs.PROPORTIONALINTEGRALDERIVATIVE = { type: 3, value: "PROPORTIONALINTEGRALDERIVATIVE" }, xs.TIMEDTWOPOSITION = { type: 3, value: "TIMEDTWOPOSITION" }, xs.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, xs.USERDEFINED = { type: 3, value: "USERDEFINED" }, xs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcControllerTypeEnum = xs;
  class Ir {
  }
  Ir.ACTIVE = { type: 3, value: "ACTIVE" }, Ir.PASSIVE = { type: 3, value: "PASSIVE" }, Ir.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ir.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCooledBeamTypeEnum = Ir;
  class ws {
  }
  ws.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, ws.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, ws.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, ws.USERDEFINED = { type: 3, value: "USERDEFINED" }, ws.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoolingTowerTypeEnum = ws;
  class fr {
  }
  fr.BUDGET = { type: 3, value: "BUDGET" }, fr.COSTPLAN = { type: 3, value: "COSTPLAN" }, fr.ESTIMATE = { type: 3, value: "ESTIMATE" }, fr.TENDER = { type: 3, value: "TENDER" }, fr.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, fr.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, fr.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, fr.USERDEFINED = { type: 3, value: "USERDEFINED" }, fr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCostScheduleTypeEnum = fr;
  class Mr {
  }
  Mr.CEILING = { type: 3, value: "CEILING" }, Mr.FLOORING = { type: 3, value: "FLOORING" }, Mr.CLADDING = { type: 3, value: "CLADDING" }, Mr.ROOFING = { type: 3, value: "ROOFING" }, Mr.INSULATION = { type: 3, value: "INSULATION" }, Mr.MEMBRANE = { type: 3, value: "MEMBRANE" }, Mr.SLEEVING = { type: 3, value: "SLEEVING" }, Mr.WRAPPING = { type: 3, value: "WRAPPING" }, Mr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoveringTypeEnum = Mr;
  class Nr {
  }
  Nr.AED = { type: 3, value: "AED" }, Nr.AES = { type: 3, value: "AES" }, Nr.ATS = { type: 3, value: "ATS" }, Nr.AUD = { type: 3, value: "AUD" }, Nr.BBD = { type: 3, value: "BBD" }, Nr.BEG = { type: 3, value: "BEG" }, Nr.BGL = { type: 3, value: "BGL" }, Nr.BHD = { type: 3, value: "BHD" }, Nr.BMD = { type: 3, value: "BMD" }, Nr.BND = { type: 3, value: "BND" }, Nr.BRL = { type: 3, value: "BRL" }, Nr.BSD = { type: 3, value: "BSD" }, Nr.BWP = { type: 3, value: "BWP" }, Nr.BZD = { type: 3, value: "BZD" }, Nr.CAD = { type: 3, value: "CAD" }, Nr.CBD = { type: 3, value: "CBD" }, Nr.CHF = { type: 3, value: "CHF" }, Nr.CLP = { type: 3, value: "CLP" }, Nr.CNY = { type: 3, value: "CNY" }, Nr.CYS = { type: 3, value: "CYS" }, Nr.CZK = { type: 3, value: "CZK" }, Nr.DDP = { type: 3, value: "DDP" }, Nr.DEM = { type: 3, value: "DEM" }, Nr.DKK = { type: 3, value: "DKK" }, Nr.EGL = { type: 3, value: "EGL" }, Nr.EST = { type: 3, value: "EST" }, Nr.EUR = { type: 3, value: "EUR" }, Nr.FAK = { type: 3, value: "FAK" }, Nr.FIM = { type: 3, value: "FIM" }, Nr.FJD = { type: 3, value: "FJD" }, Nr.FKP = { type: 3, value: "FKP" }, Nr.FRF = { type: 3, value: "FRF" }, Nr.GBP = { type: 3, value: "GBP" }, Nr.GIP = { type: 3, value: "GIP" }, Nr.GMD = { type: 3, value: "GMD" }, Nr.GRX = { type: 3, value: "GRX" }, Nr.HKD = { type: 3, value: "HKD" }, Nr.HUF = { type: 3, value: "HUF" }, Nr.ICK = { type: 3, value: "ICK" }, Nr.IDR = { type: 3, value: "IDR" }, Nr.ILS = { type: 3, value: "ILS" }, Nr.INR = { type: 3, value: "INR" }, Nr.IRP = { type: 3, value: "IRP" }, Nr.ITL = { type: 3, value: "ITL" }, Nr.JMD = { type: 3, value: "JMD" }, Nr.JOD = { type: 3, value: "JOD" }, Nr.JPY = { type: 3, value: "JPY" }, Nr.KES = { type: 3, value: "KES" }, Nr.KRW = { type: 3, value: "KRW" }, Nr.KWD = { type: 3, value: "KWD" }, Nr.KYD = { type: 3, value: "KYD" }, Nr.LKR = { type: 3, value: "LKR" }, Nr.LUF = { type: 3, value: "LUF" }, Nr.MTL = { type: 3, value: "MTL" }, Nr.MUR = { type: 3, value: "MUR" }, Nr.MXN = { type: 3, value: "MXN" }, Nr.MYR = { type: 3, value: "MYR" }, Nr.NLG = { type: 3, value: "NLG" }, Nr.NZD = { type: 3, value: "NZD" }, Nr.OMR = { type: 3, value: "OMR" }, Nr.PGK = { type: 3, value: "PGK" }, Nr.PHP = { type: 3, value: "PHP" }, Nr.PKR = { type: 3, value: "PKR" }, Nr.PLN = { type: 3, value: "PLN" }, Nr.PTN = { type: 3, value: "PTN" }, Nr.QAR = { type: 3, value: "QAR" }, Nr.RUR = { type: 3, value: "RUR" }, Nr.SAR = { type: 3, value: "SAR" }, Nr.SCR = { type: 3, value: "SCR" }, Nr.SEK = { type: 3, value: "SEK" }, Nr.SGD = { type: 3, value: "SGD" }, Nr.SKP = { type: 3, value: "SKP" }, Nr.THB = { type: 3, value: "THB" }, Nr.TRL = { type: 3, value: "TRL" }, Nr.TTD = { type: 3, value: "TTD" }, Nr.TWD = { type: 3, value: "TWD" }, Nr.USD = { type: 3, value: "USD" }, Nr.VEB = { type: 3, value: "VEB" }, Nr.VND = { type: 3, value: "VND" }, Nr.XEU = { type: 3, value: "XEU" }, Nr.ZAR = { type: 3, value: "ZAR" }, Nr.ZWD = { type: 3, value: "ZWD" }, Nr.NOK = { type: 3, value: "NOK" }, r.IfcCurrencyEnum = Nr;
  class ii {
  }
  ii.USERDEFINED = { type: 3, value: "USERDEFINED" }, ii.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCurtainWallTypeEnum = ii;
  class Ro {
  }
  Ro.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, Ro.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, Ro.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, Ro.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, Ro.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, Ro.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, Ro.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, Ro.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, Ro.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, Ro.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, Ro.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, Ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDamperTypeEnum = Ro;
  class Bo {
  }
  Bo.MEASURED = { type: 3, value: "MEASURED" }, Bo.PREDICTED = { type: 3, value: "PREDICTED" }, Bo.SIMULATED = { type: 3, value: "SIMULATED" }, Bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDataOriginEnum = Bo;
  class Rs {
  }
  Rs.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, Rs.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, Rs.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, Rs.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, Rs.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, Rs.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, Rs.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, Rs.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, Rs.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, Rs.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, Rs.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, Rs.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, Rs.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, Rs.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, Rs.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, Rs.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, Rs.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, Rs.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, Rs.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, Rs.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, Rs.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, Rs.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, Rs.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, Rs.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, Rs.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, Rs.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, Rs.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, Rs.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, Rs.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, Rs.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, Rs.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, Rs.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, Rs.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, Rs.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, Rs.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, Rs.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, Rs.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, Rs.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, Rs.PHUNIT = { type: 3, value: "PHUNIT" }, Rs.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, Rs.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, Rs.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, Rs.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, Rs.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, Rs.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, Rs.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, Rs.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, Rs.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, Rs.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcDerivedUnitEnum = Rs;
  class Uo {
  }
  Uo.ORIGIN = { type: 3, value: "ORIGIN" }, Uo.TARGET = { type: 3, value: "TARGET" }, r.IfcDimensionExtentUsage = Uo;
  class xi {
  }
  xi.POSITIVE = { type: 3, value: "POSITIVE" }, xi.NEGATIVE = { type: 3, value: "NEGATIVE" }, r.IfcDirectionSenseEnum = xi;
  class Vo {
  }
  Vo.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, Vo.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, Vo.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, Vo.MANHOLE = { type: 3, value: "MANHOLE" }, Vo.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, Vo.SUMP = { type: 3, value: "SUMP" }, Vo.TRENCH = { type: 3, value: "TRENCH" }, Vo.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, Vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionChamberElementTypeEnum = Vo;
  class oa {
  }
  oa.PUBLIC = { type: 3, value: "PUBLIC" }, oa.RESTRICTED = { type: 3, value: "RESTRICTED" }, oa.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, oa.PERSONAL = { type: 3, value: "PERSONAL" }, oa.USERDEFINED = { type: 3, value: "USERDEFINED" }, oa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentConfidentialityEnum = oa;
  class ti {
  }
  ti.DRAFT = { type: 3, value: "DRAFT" }, ti.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, ti.FINAL = { type: 3, value: "FINAL" }, ti.REVISION = { type: 3, value: "REVISION" }, ti.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentStatusEnum = ti;
  class Po {
  }
  Po.SWINGING = { type: 3, value: "SWINGING" }, Po.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, Po.SLIDING = { type: 3, value: "SLIDING" }, Po.FOLDING = { type: 3, value: "FOLDING" }, Po.REVOLVING = { type: 3, value: "REVOLVING" }, Po.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Po.USERDEFINED = { type: 3, value: "USERDEFINED" }, Po.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelOperationEnum = Po;
  class ai {
  }
  ai.LEFT = { type: 3, value: "LEFT" }, ai.MIDDLE = { type: 3, value: "MIDDLE" }, ai.RIGHT = { type: 3, value: "RIGHT" }, ai.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelPositionEnum = ai;
  class Wo {
  }
  Wo.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, Wo.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, Wo.STEEL = { type: 3, value: "STEEL" }, Wo.WOOD = { type: 3, value: "WOOD" }, Wo.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, Wo.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, Wo.PLASTIC = { type: 3, value: "PLASTIC" }, Wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleConstructionEnum = Wo;
  class As {
  }
  As.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, As.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, As.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, As.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, As.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, As.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, As.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, As.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, As.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, As.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, As.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, As.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, As.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, As.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, As.REVOLVING = { type: 3, value: "REVOLVING" }, As.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, As.USERDEFINED = { type: 3, value: "USERDEFINED" }, As.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleOperationEnum = As;
  class ro {
  }
  ro.BEND = { type: 3, value: "BEND" }, ro.CONNECTOR = { type: 3, value: "CONNECTOR" }, ro.ENTRY = { type: 3, value: "ENTRY" }, ro.EXIT = { type: 3, value: "EXIT" }, ro.JUNCTION = { type: 3, value: "JUNCTION" }, ro.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, ro.TRANSITION = { type: 3, value: "TRANSITION" }, ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctFittingTypeEnum = ro;
  class Mo {
  }
  Mo.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, Mo.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, Mo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSegmentTypeEnum = Mo;
  class vr {
  }
  vr.FLATOVAL = { type: 3, value: "FLATOVAL" }, vr.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, vr.ROUND = { type: 3, value: "ROUND" }, vr.USERDEFINED = { type: 3, value: "USERDEFINED" }, vr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSilencerTypeEnum = vr;
  class ts {
  }
  ts.COMPUTER = { type: 3, value: "COMPUTER" }, ts.DIRECTWATERHEATER = { type: 3, value: "DIRECTWATERHEATER" }, ts.DISHWASHER = { type: 3, value: "DISHWASHER" }, ts.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, ts.ELECTRICHEATER = { type: 3, value: "ELECTRICHEATER" }, ts.FACSIMILE = { type: 3, value: "FACSIMILE" }, ts.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, ts.FREEZER = { type: 3, value: "FREEZER" }, ts.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, ts.HANDDRYER = { type: 3, value: "HANDDRYER" }, ts.INDIRECTWATERHEATER = { type: 3, value: "INDIRECTWATERHEATER" }, ts.MICROWAVE = { type: 3, value: "MICROWAVE" }, ts.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, ts.PRINTER = { type: 3, value: "PRINTER" }, ts.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, ts.RADIANTHEATER = { type: 3, value: "RADIANTHEATER" }, ts.SCANNER = { type: 3, value: "SCANNER" }, ts.TELEPHONE = { type: 3, value: "TELEPHONE" }, ts.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, ts.TV = { type: 3, value: "TV" }, ts.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, ts.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, ts.WATERHEATER = { type: 3, value: "WATERHEATER" }, ts.WATERCOOLER = { type: 3, value: "WATERCOOLER" }, ts.USERDEFINED = { type: 3, value: "USERDEFINED" }, ts.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricApplianceTypeEnum = ts;
  class kr {
  }
  kr.ALTERNATING = { type: 3, value: "ALTERNATING" }, kr.DIRECT = { type: 3, value: "DIRECT" }, kr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricCurrentEnum = kr;
  class Us {
  }
  Us.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, Us.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, Us.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, Us.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, Us.GASDETECTORPANEL = { type: 3, value: "GASDETECTORPANEL" }, Us.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, Us.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, Us.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, Us.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, Us.USERDEFINED = { type: 3, value: "USERDEFINED" }, Us.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricDistributionPointFunctionEnum = Us;
  class ri {
  }
  ri.BATTERY = { type: 3, value: "BATTERY" }, ri.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, ri.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, ri.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, ri.UPS = { type: 3, value: "UPS" }, ri.USERDEFINED = { type: 3, value: "USERDEFINED" }, ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricFlowStorageDeviceTypeEnum = ri;
  class Wi {
  }
  Wi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricGeneratorTypeEnum = Wi;
  class To {
  }
  To.ELECTRICPOINTHEATER = { type: 3, value: "ELECTRICPOINTHEATER" }, To.ELECTRICCABLEHEATER = { type: 3, value: "ELECTRICCABLEHEATER" }, To.ELECTRICMATHEATER = { type: 3, value: "ELECTRICMATHEATER" }, To.USERDEFINED = { type: 3, value: "USERDEFINED" }, To.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricHeaterTypeEnum = To;
  class ia {
  }
  ia.DC = { type: 3, value: "DC" }, ia.INDUCTION = { type: 3, value: "INDUCTION" }, ia.POLYPHASE = { type: 3, value: "POLYPHASE" }, ia.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, ia.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, ia.USERDEFINED = { type: 3, value: "USERDEFINED" }, ia.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricMotorTypeEnum = ia;
  class bo {
  }
  bo.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, bo.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, bo.RELAY = { type: 3, value: "RELAY" }, bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricTimeControlTypeEnum = bo;
  class Ys {
  }
  Ys.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, Ys.ARCH = { type: 3, value: "ARCH" }, Ys.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, Ys.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, Ys.GIRDER = { type: 3, value: "GIRDER" }, Ys.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, Ys.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, Ys.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, Ys.TRUSS = { type: 3, value: "TRUSS" }, Ys.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ys.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElementAssemblyTypeEnum = Ys;
  class Di {
  }
  Di.COMPLEX = { type: 3, value: "COMPLEX" }, Di.ELEMENT = { type: 3, value: "ELEMENT" }, Di.PARTIAL = { type: 3, value: "PARTIAL" }, r.IfcElementCompositionEnum = Di;
  class Yn {
  }
  Yn.PRIMARY = { type: 3, value: "PRIMARY" }, Yn.SECONDARY = { type: 3, value: "SECONDARY" }, Yn.TERTIARY = { type: 3, value: "TERTIARY" }, Yn.AUXILIARY = { type: 3, value: "AUXILIARY" }, Yn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEnergySequenceEnum = Yn;
  class Lo {
  }
  Lo.COMBINEDVALUE = { type: 3, value: "COMBINEDVALUE" }, Lo.DISPOSAL = { type: 3, value: "DISPOSAL" }, Lo.EXTRACTION = { type: 3, value: "EXTRACTION" }, Lo.INSTALLATION = { type: 3, value: "INSTALLATION" }, Lo.MANUFACTURE = { type: 3, value: "MANUFACTURE" }, Lo.TRANSPORTATION = { type: 3, value: "TRANSPORTATION" }, Lo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEnvironmentalImpactCategoryEnum = Lo;
  class Un {
  }
  Un.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, Un.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, Un.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, Un.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, Un.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, Un.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, Un.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, Un.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, Un.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, Un.USERDEFINED = { type: 3, value: "USERDEFINED" }, Un.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporativeCoolerTypeEnum = Un;
  class so {
  }
  so.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, so.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, so.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, so.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, so.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, so.USERDEFINED = { type: 3, value: "USERDEFINED" }, so.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporatorTypeEnum = so;
  class rs {
  }
  rs.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, rs.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, rs.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, rs.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, rs.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, rs.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, rs.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, rs.USERDEFINED = { type: 3, value: "USERDEFINED" }, rs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFanTypeEnum = rs;
  class hi {
  }
  hi.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, hi.ODORFILTER = { type: 3, value: "ODORFILTER" }, hi.OILFILTER = { type: 3, value: "OILFILTER" }, hi.STRAINER = { type: 3, value: "STRAINER" }, hi.WATERFILTER = { type: 3, value: "WATERFILTER" }, hi.USERDEFINED = { type: 3, value: "USERDEFINED" }, hi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFilterTypeEnum = hi;
  class Zo {
  }
  Zo.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, Zo.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, Zo.HOSEREEL = { type: 3, value: "HOSEREEL" }, Zo.SPRINKLER = { type: 3, value: "SPRINKLER" }, Zo.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, Zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFireSuppressionTerminalTypeEnum = Zo;
  class li {
  }
  li.SOURCE = { type: 3, value: "SOURCE" }, li.SINK = { type: 3, value: "SINK" }, li.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowDirectionEnum = li;
  class ei {
  }
  ei.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, ei.THERMOMETER = { type: 3, value: "THERMOMETER" }, ei.AMMETER = { type: 3, value: "AMMETER" }, ei.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, ei.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, ei.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, ei.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, ei.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, ei.USERDEFINED = { type: 3, value: "USERDEFINED" }, ei.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowInstrumentTypeEnum = ei;
  class Or {
  }
  Or.ELECTRICMETER = { type: 3, value: "ELECTRICMETER" }, Or.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, Or.FLOWMETER = { type: 3, value: "FLOWMETER" }, Or.GASMETER = { type: 3, value: "GASMETER" }, Or.OILMETER = { type: 3, value: "OILMETER" }, Or.WATERMETER = { type: 3, value: "WATERMETER" }, Or.USERDEFINED = { type: 3, value: "USERDEFINED" }, Or.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowMeterTypeEnum = Or;
  class ui {
  }
  ui.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, ui.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, ui.PILE_CAP = { type: 3, value: "PILE_CAP" }, ui.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, ui.USERDEFINED = { type: 3, value: "USERDEFINED" }, ui.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFootingTypeEnum = ui;
  class _s {
  }
  _s.GASAPPLIANCE = { type: 3, value: "GASAPPLIANCE" }, _s.GASBOOSTER = { type: 3, value: "GASBOOSTER" }, _s.GASBURNER = { type: 3, value: "GASBURNER" }, _s.USERDEFINED = { type: 3, value: "USERDEFINED" }, _s.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGasTerminalTypeEnum = _s;
  class xo {
  }
  xo.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, xo.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, xo.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, xo.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, xo.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, xo.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, xo.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, xo.USERDEFINED = { type: 3, value: "USERDEFINED" }, xo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeometricProjectionEnum = xo;
  class aa {
  }
  aa.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, aa.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" }, r.IfcGlobalOrLocalEnum = aa;
  class oo {
  }
  oo.PLATE = { type: 3, value: "PLATE" }, oo.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, oo.USERDEFINED = { type: 3, value: "USERDEFINED" }, oo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHeatExchangerTypeEnum = oo;
  class vs {
  }
  vs.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, vs.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, vs.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, vs.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, vs.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, vs.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, vs.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, vs.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, vs.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, vs.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, vs.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, vs.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, vs.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHumidifierTypeEnum = vs;
  class yi {
  }
  yi.INTERNAL = { type: 3, value: "INTERNAL" }, yi.EXTERNAL = { type: 3, value: "EXTERNAL" }, yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInternalOrExternalEnum = yi;
  class $r {
  }
  $r.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, $r.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, $r.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, $r.USERDEFINED = { type: 3, value: "USERDEFINED" }, $r.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInventoryTypeEnum = $r;
  class ki {
  }
  ki.USERDEFINED = { type: 3, value: "USERDEFINED" }, ki.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcJunctionBoxTypeEnum = ki;
  class ds {
  }
  ds.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, ds.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, ds.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, ds.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, ds.METALHALIDE = { type: 3, value: "METALHALIDE" }, ds.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLampTypeEnum = ds;
  class Ls {
  }
  Ls.AXIS1 = { type: 3, value: "AXIS1" }, Ls.AXIS2 = { type: 3, value: "AXIS2" }, Ls.AXIS3 = { type: 3, value: "AXIS3" }, r.IfcLayerSetDirectionEnum = Ls;
  class Co {
  }
  Co.TYPE_A = { type: 3, value: "TYPE_A" }, Co.TYPE_B = { type: 3, value: "TYPE_B" }, Co.TYPE_C = { type: 3, value: "TYPE_C" }, Co.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightDistributionCurveEnum = Co;
  class ps {
  }
  ps.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, ps.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, ps.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, ps.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, ps.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, ps.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, ps.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, ps.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, ps.METALHALIDE = { type: 3, value: "METALHALIDE" }, ps.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightEmissionSourceEnum = ps;
  class Tr {
  }
  Tr.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, Tr.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, Tr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Tr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightFixtureTypeEnum = Tr;
  class ao {
  }
  ao.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, ao.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, ao.LOAD_COMBINATION_GROUP = { type: 3, value: "LOAD_COMBINATION_GROUP" }, ao.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, ao.USERDEFINED = { type: 3, value: "USERDEFINED" }, ao.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLoadGroupTypeEnum = ao;
  class Gt {
  }
  Gt.LOGICALAND = { type: 3, value: "LOGICALAND" }, Gt.LOGICALOR = { type: 3, value: "LOGICALOR" }, r.IfcLogicalOperatorEnum = Gt;
  class sr {
  }
  sr.BRACE = { type: 3, value: "BRACE" }, sr.CHORD = { type: 3, value: "CHORD" }, sr.COLLAR = { type: 3, value: "COLLAR" }, sr.MEMBER = { type: 3, value: "MEMBER" }, sr.MULLION = { type: 3, value: "MULLION" }, sr.PLATE = { type: 3, value: "PLATE" }, sr.POST = { type: 3, value: "POST" }, sr.PURLIN = { type: 3, value: "PURLIN" }, sr.RAFTER = { type: 3, value: "RAFTER" }, sr.STRINGER = { type: 3, value: "STRINGER" }, sr.STRUT = { type: 3, value: "STRUT" }, sr.STUD = { type: 3, value: "STUD" }, sr.USERDEFINED = { type: 3, value: "USERDEFINED" }, sr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMemberTypeEnum = sr;
  class vt {
  }
  vt.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, vt.COUPLING = { type: 3, value: "COUPLING" }, vt.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, vt.USERDEFINED = { type: 3, value: "USERDEFINED" }, vt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMotorConnectionTypeEnum = vt;
  class Jr {
  }
  Jr.NULL = { type: 3, value: "NULL" }, r.IfcNullStyle = Jr;
  class Qs {
  }
  Qs.PRODUCT = { type: 3, value: "PRODUCT" }, Qs.PROCESS = { type: 3, value: "PROCESS" }, Qs.CONTROL = { type: 3, value: "CONTROL" }, Qs.RESOURCE = { type: 3, value: "RESOURCE" }, Qs.ACTOR = { type: 3, value: "ACTOR" }, Qs.GROUP = { type: 3, value: "GROUP" }, Qs.PROJECT = { type: 3, value: "PROJECT" }, Qs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectTypeEnum = Qs;
  class Ds {
  }
  Ds.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, Ds.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, Ds.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, Ds.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, Ds.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, Ds.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, Ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectiveEnum = Ds;
  class Hs {
  }
  Hs.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, Hs.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, Hs.LESSEE = { type: 3, value: "LESSEE" }, Hs.LESSOR = { type: 3, value: "LESSOR" }, Hs.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, Hs.OWNER = { type: 3, value: "OWNER" }, Hs.TENANT = { type: 3, value: "TENANT" }, Hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOccupantTypeEnum = Hs;
  class Xr {
  }
  Xr.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, Xr.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, Xr.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, Xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOutletTypeEnum = Xr;
  class bi {
  }
  bi.GRILL = { type: 3, value: "GRILL" }, bi.LOUVER = { type: 3, value: "LOUVER" }, bi.SCREEN = { type: 3, value: "SCREEN" }, bi.USERDEFINED = { type: 3, value: "USERDEFINED" }, bi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPermeableCoveringOperationEnum = bi;
  class rn {
  }
  rn.PHYSICAL = { type: 3, value: "PHYSICAL" }, rn.VIRTUAL = { type: 3, value: "VIRTUAL" }, rn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPhysicalOrVirtualEnum = rn;
  class mo {
  }
  mo.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, mo.COMPOSITE = { type: 3, value: "COMPOSITE" }, mo.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, mo.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, mo.USERDEFINED = { type: 3, value: "USERDEFINED" }, mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileConstructionEnum = mo;
  class Gi {
  }
  Gi.COHESION = { type: 3, value: "COHESION" }, Gi.FRICTION = { type: 3, value: "FRICTION" }, Gi.SUPPORT = { type: 3, value: "SUPPORT" }, Gi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileTypeEnum = Gi;
  class yo {
  }
  yo.BEND = { type: 3, value: "BEND" }, yo.CONNECTOR = { type: 3, value: "CONNECTOR" }, yo.ENTRY = { type: 3, value: "ENTRY" }, yo.EXIT = { type: 3, value: "EXIT" }, yo.JUNCTION = { type: 3, value: "JUNCTION" }, yo.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, yo.TRANSITION = { type: 3, value: "TRANSITION" }, yo.USERDEFINED = { type: 3, value: "USERDEFINED" }, yo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeFittingTypeEnum = yo;
  class ci {
  }
  ci.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, ci.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, ci.GUTTER = { type: 3, value: "GUTTER" }, ci.SPOOL = { type: 3, value: "SPOOL" }, ci.USERDEFINED = { type: 3, value: "USERDEFINED" }, ci.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeSegmentTypeEnum = ci;
  class Ri {
  }
  Ri.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, Ri.SHEET = { type: 3, value: "SHEET" }, Ri.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPlateTypeEnum = Ri;
  class ms {
  }
  ms.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, ms.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, ms.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, ms.CALIBRATION = { type: 3, value: "CALIBRATION" }, ms.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, ms.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, ms.STARTUP = { type: 3, value: "STARTUP" }, ms.USERDEFINED = { type: 3, value: "USERDEFINED" }, ms.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProcedureTypeEnum = ms;
  class zt {
  }
  zt.CURVE = { type: 3, value: "CURVE" }, zt.AREA = { type: 3, value: "AREA" }, r.IfcProfileTypeEnum = zt;
  class fn {
  }
  fn.CHANGE = { type: 3, value: "CHANGE" }, fn.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, fn.MOVE = { type: 3, value: "MOVE" }, fn.PURCHASE = { type: 3, value: "PURCHASE" }, fn.WORK = { type: 3, value: "WORK" }, fn.USERDEFINED = { type: 3, value: "USERDEFINED" }, fn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectOrderRecordTypeEnum = fn;
  class Bn {
  }
  Bn.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, Bn.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, Bn.MOVEORDER = { type: 3, value: "MOVEORDER" }, Bn.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, Bn.WORKORDER = { type: 3, value: "WORKORDER" }, Bn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectOrderTypeEnum = Bn;
  class or {
  }
  or.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, or.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" }, r.IfcProjectedOrTrueLengthEnum = or;
  class ss {
  }
  ss.DESIGN = { type: 3, value: "DESIGN" }, ss.DESIGNMAXIMUM = { type: 3, value: "DESIGNMAXIMUM" }, ss.DESIGNMINIMUM = { type: 3, value: "DESIGNMINIMUM" }, ss.SIMULATED = { type: 3, value: "SIMULATED" }, ss.ASBUILT = { type: 3, value: "ASBUILT" }, ss.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, ss.MEASURED = { type: 3, value: "MEASURED" }, ss.USERDEFINED = { type: 3, value: "USERDEFINED" }, ss.NOTKNOWN = { type: 3, value: "NOTKNOWN" }, r.IfcPropertySourceEnum = ss;
  class Xs {
  }
  Xs.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, Xs.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, Xs.EARTHFAILUREDEVICE = { type: 3, value: "EARTHFAILUREDEVICE" }, Xs.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, Xs.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, Xs.VARISTOR = { type: 3, value: "VARISTOR" }, Xs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProtectiveDeviceTypeEnum = Xs;
  class Fo {
  }
  Fo.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, Fo.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, Fo.SPLITCASE = { type: 3, value: "SPLITCASE" }, Fo.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, Fo.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, Fo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPumpTypeEnum = Fo;
  class ji {
  }
  ji.HANDRAIL = { type: 3, value: "HANDRAIL" }, ji.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, ji.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, ji.USERDEFINED = { type: 3, value: "USERDEFINED" }, ji.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailingTypeEnum = ji;
  class zo {
  }
  zo.STRAIGHT = { type: 3, value: "STRAIGHT" }, zo.SPIRAL = { type: 3, value: "SPIRAL" }, zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampFlightTypeEnum = zo;
  class Yi {
  }
  Yi.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, Yi.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, Yi.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, Yi.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, Yi.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, Yi.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, Yi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampTypeEnum = Yi;
  class Li {
  }
  Li.BLINN = { type: 3, value: "BLINN" }, Li.FLAT = { type: 3, value: "FLAT" }, Li.GLASS = { type: 3, value: "GLASS" }, Li.MATT = { type: 3, value: "MATT" }, Li.METAL = { type: 3, value: "METAL" }, Li.MIRROR = { type: 3, value: "MIRROR" }, Li.PHONG = { type: 3, value: "PHONG" }, Li.PLASTIC = { type: 3, value: "PLASTIC" }, Li.STRAUSS = { type: 3, value: "STRAUSS" }, Li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReflectanceMethodEnum = Li;
  class _i {
  }
  _i.MAIN = { type: 3, value: "MAIN" }, _i.SHEAR = { type: 3, value: "SHEAR" }, _i.LIGATURE = { type: 3, value: "LIGATURE" }, _i.STUD = { type: 3, value: "STUD" }, _i.PUNCHING = { type: 3, value: "PUNCHING" }, _i.EDGE = { type: 3, value: "EDGE" }, _i.RING = { type: 3, value: "RING" }, _i.USERDEFINED = { type: 3, value: "USERDEFINED" }, _i.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingBarRoleEnum = _i;
  class pa {
  }
  pa.PLAIN = { type: 3, value: "PLAIN" }, pa.TEXTURED = { type: 3, value: "TEXTURED" }, r.IfcReinforcingBarSurfaceEnum = pa;
  class $o {
  }
  $o.CONSUMED = { type: 3, value: "CONSUMED" }, $o.PARTIALLYCONSUMED = { type: 3, value: "PARTIALLYCONSUMED" }, $o.NOTCONSUMED = { type: 3, value: "NOTCONSUMED" }, $o.OCCUPIED = { type: 3, value: "OCCUPIED" }, $o.PARTIALLYOCCUPIED = { type: 3, value: "PARTIALLYOCCUPIED" }, $o.NOTOCCUPIED = { type: 3, value: "NOTOCCUPIED" }, $o.USERDEFINED = { type: 3, value: "USERDEFINED" }, $o.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcResourceConsumptionEnum = $o;
  class wo {
  }
  wo.DIRECTION_X = { type: 3, value: "DIRECTION_X" }, wo.DIRECTION_Y = { type: 3, value: "DIRECTION_Y" }, r.IfcRibPlateDirectionEnum = wo;
  class Ks {
  }
  Ks.SUPPLIER = { type: 3, value: "SUPPLIER" }, Ks.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, Ks.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, Ks.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, Ks.ARCHITECT = { type: 3, value: "ARCHITECT" }, Ks.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, Ks.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, Ks.CLIENT = { type: 3, value: "CLIENT" }, Ks.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, Ks.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, Ks.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, Ks.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, Ks.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, Ks.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, Ks.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, Ks.COMISSIONINGENGINEER = { type: 3, value: "COMISSIONINGENGINEER" }, Ks.ENGINEER = { type: 3, value: "ENGINEER" }, Ks.OWNER = { type: 3, value: "OWNER" }, Ks.CONSULTANT = { type: 3, value: "CONSULTANT" }, Ks.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, Ks.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, Ks.RESELLER = { type: 3, value: "RESELLER" }, Ks.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcRoleEnum = Ks;
  class Qo {
  }
  Qo.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, Qo.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, Qo.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, Qo.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, Qo.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, Qo.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, Qo.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, Qo.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, Qo.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, Qo.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, Qo.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, Qo.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, Qo.FREEFORM = { type: 3, value: "FREEFORM" }, Qo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRoofTypeEnum = Qo;
  class pi {
  }
  pi.EXA = { type: 3, value: "EXA" }, pi.PETA = { type: 3, value: "PETA" }, pi.TERA = { type: 3, value: "TERA" }, pi.GIGA = { type: 3, value: "GIGA" }, pi.MEGA = { type: 3, value: "MEGA" }, pi.KILO = { type: 3, value: "KILO" }, pi.HECTO = { type: 3, value: "HECTO" }, pi.DECA = { type: 3, value: "DECA" }, pi.DECI = { type: 3, value: "DECI" }, pi.CENTI = { type: 3, value: "CENTI" }, pi.MILLI = { type: 3, value: "MILLI" }, pi.MICRO = { type: 3, value: "MICRO" }, pi.NANO = { type: 3, value: "NANO" }, pi.PICO = { type: 3, value: "PICO" }, pi.FEMTO = { type: 3, value: "FEMTO" }, pi.ATTO = { type: 3, value: "ATTO" }, r.IfcSIPrefix = pi;
  class Ns {
  }
  Ns.AMPERE = { type: 3, value: "AMPERE" }, Ns.BECQUEREL = { type: 3, value: "BECQUEREL" }, Ns.CANDELA = { type: 3, value: "CANDELA" }, Ns.COULOMB = { type: 3, value: "COULOMB" }, Ns.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, Ns.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, Ns.FARAD = { type: 3, value: "FARAD" }, Ns.GRAM = { type: 3, value: "GRAM" }, Ns.GRAY = { type: 3, value: "GRAY" }, Ns.HENRY = { type: 3, value: "HENRY" }, Ns.HERTZ = { type: 3, value: "HERTZ" }, Ns.JOULE = { type: 3, value: "JOULE" }, Ns.KELVIN = { type: 3, value: "KELVIN" }, Ns.LUMEN = { type: 3, value: "LUMEN" }, Ns.LUX = { type: 3, value: "LUX" }, Ns.METRE = { type: 3, value: "METRE" }, Ns.MOLE = { type: 3, value: "MOLE" }, Ns.NEWTON = { type: 3, value: "NEWTON" }, Ns.OHM = { type: 3, value: "OHM" }, Ns.PASCAL = { type: 3, value: "PASCAL" }, Ns.RADIAN = { type: 3, value: "RADIAN" }, Ns.SECOND = { type: 3, value: "SECOND" }, Ns.SIEMENS = { type: 3, value: "SIEMENS" }, Ns.SIEVERT = { type: 3, value: "SIEVERT" }, Ns.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, Ns.STERADIAN = { type: 3, value: "STERADIAN" }, Ns.TESLA = { type: 3, value: "TESLA" }, Ns.VOLT = { type: 3, value: "VOLT" }, Ns.WATT = { type: 3, value: "WATT" }, Ns.WEBER = { type: 3, value: "WEBER" }, r.IfcSIUnitName = Ns;
  class Fi {
  }
  Fi.BATH = { type: 3, value: "BATH" }, Fi.BIDET = { type: 3, value: "BIDET" }, Fi.CISTERN = { type: 3, value: "CISTERN" }, Fi.SHOWER = { type: 3, value: "SHOWER" }, Fi.SINK = { type: 3, value: "SINK" }, Fi.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, Fi.TOILETPAN = { type: 3, value: "TOILETPAN" }, Fi.URINAL = { type: 3, value: "URINAL" }, Fi.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, Fi.WCSEAT = { type: 3, value: "WCSEAT" }, Fi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSanitaryTerminalTypeEnum = Fi;
  class la {
  }
  la.UNIFORM = { type: 3, value: "UNIFORM" }, la.TAPERED = { type: 3, value: "TAPERED" }, r.IfcSectionTypeEnum = la;
  class Ho {
  }
  Ho.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, Ho.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, Ho.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, Ho.GASSENSOR = { type: 3, value: "GASSENSOR" }, Ho.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, Ho.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, Ho.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, Ho.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, Ho.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, Ho.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, Ho.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, Ho.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, Ho.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, Ho.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ho.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSensorTypeEnum = Ho;
  class Ye {
  }
  Ye.START_START = { type: 3, value: "START_START" }, Ye.START_FINISH = { type: 3, value: "START_FINISH" }, Ye.FINISH_START = { type: 3, value: "FINISH_START" }, Ye.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, Ye.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSequenceEnum = Ye;
  class qe {
  }
  qe.A_QUALITYOFCOMPONENTS = { type: 3, value: "A_QUALITYOFCOMPONENTS" }, qe.B_DESIGNLEVEL = { type: 3, value: "B_DESIGNLEVEL" }, qe.C_WORKEXECUTIONLEVEL = { type: 3, value: "C_WORKEXECUTIONLEVEL" }, qe.D_INDOORENVIRONMENT = { type: 3, value: "D_INDOORENVIRONMENT" }, qe.E_OUTDOORENVIRONMENT = { type: 3, value: "E_OUTDOORENVIRONMENT" }, qe.F_INUSECONDITIONS = { type: 3, value: "F_INUSECONDITIONS" }, qe.G_MAINTENANCELEVEL = { type: 3, value: "G_MAINTENANCELEVEL" }, qe.USERDEFINED = { type: 3, value: "USERDEFINED" }, qe.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcServiceLifeFactorTypeEnum = qe;
  class Nt {
  }
  Nt.ACTUALSERVICELIFE = { type: 3, value: "ACTUALSERVICELIFE" }, Nt.EXPECTEDSERVICELIFE = { type: 3, value: "EXPECTEDSERVICELIFE" }, Nt.OPTIMISTICREFERENCESERVICELIFE = { type: 3, value: "OPTIMISTICREFERENCESERVICELIFE" }, Nt.PESSIMISTICREFERENCESERVICELIFE = { type: 3, value: "PESSIMISTICREFERENCESERVICELIFE" }, Nt.REFERENCESERVICELIFE = { type: 3, value: "REFERENCESERVICELIFE" }, r.IfcServiceLifeTypeEnum = Nt;
  class mt {
  }
  mt.FLOOR = { type: 3, value: "FLOOR" }, mt.ROOF = { type: 3, value: "ROOF" }, mt.LANDING = { type: 3, value: "LANDING" }, mt.BASESLAB = { type: 3, value: "BASESLAB" }, mt.USERDEFINED = { type: 3, value: "USERDEFINED" }, mt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSlabTypeEnum = mt;
  class pn {
  }
  pn.DBA = { type: 3, value: "DBA" }, pn.DBB = { type: 3, value: "DBB" }, pn.DBC = { type: 3, value: "DBC" }, pn.NC = { type: 3, value: "NC" }, pn.NR = { type: 3, value: "NR" }, pn.USERDEFINED = { type: 3, value: "USERDEFINED" }, pn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSoundScaleEnum = pn;
  class Mt {
  }
  Mt.SECTIONALRADIATOR = { type: 3, value: "SECTIONALRADIATOR" }, Mt.PANELRADIATOR = { type: 3, value: "PANELRADIATOR" }, Mt.TUBULARRADIATOR = { type: 3, value: "TUBULARRADIATOR" }, Mt.CONVECTOR = { type: 3, value: "CONVECTOR" }, Mt.BASEBOARDHEATER = { type: 3, value: "BASEBOARDHEATER" }, Mt.FINNEDTUBEUNIT = { type: 3, value: "FINNEDTUBEUNIT" }, Mt.UNITHEATER = { type: 3, value: "UNITHEATER" }, Mt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceHeaterTypeEnum = Mt;
  class Ln {
  }
  Ln.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ln.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceTypeEnum = Ln;
  class ot {
  }
  ot.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, ot.COWL = { type: 3, value: "COWL" }, ot.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, ot.USERDEFINED = { type: 3, value: "USERDEFINED" }, ot.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStackTerminalTypeEnum = ot;
  class Xt {
  }
  Xt.STRAIGHT = { type: 3, value: "STRAIGHT" }, Xt.WINDER = { type: 3, value: "WINDER" }, Xt.SPIRAL = { type: 3, value: "SPIRAL" }, Xt.CURVED = { type: 3, value: "CURVED" }, Xt.FREEFORM = { type: 3, value: "FREEFORM" }, Xt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairFlightTypeEnum = Xt;
  class sn {
  }
  sn.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, sn.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, sn.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, sn.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, sn.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, sn.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, sn.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, sn.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, sn.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, sn.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, sn.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, sn.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, sn.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, sn.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, sn.USERDEFINED = { type: 3, value: "USERDEFINED" }, sn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairTypeEnum = sn;
  class dn {
  }
  dn.READWRITE = { type: 3, value: "READWRITE" }, dn.READONLY = { type: 3, value: "READONLY" }, dn.LOCKED = { type: 3, value: "LOCKED" }, dn.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" }, dn.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" }, r.IfcStateEnum = dn;
  class Ar {
  }
  Ar.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, Ar.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, Ar.CABLE = { type: 3, value: "CABLE" }, Ar.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, Ar.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, Ar.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ar.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralCurveTypeEnum = Ar;
  class yr {
  }
  yr.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, yr.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, yr.SHELL = { type: 3, value: "SHELL" }, yr.USERDEFINED = { type: 3, value: "USERDEFINED" }, yr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralSurfaceTypeEnum = yr;
  class Pr {
  }
  Pr.POSITIVE = { type: 3, value: "POSITIVE" }, Pr.NEGATIVE = { type: 3, value: "NEGATIVE" }, Pr.BOTH = { type: 3, value: "BOTH" }, r.IfcSurfaceSide = Pr;
  class Zr {
  }
  Zr.BUMP = { type: 3, value: "BUMP" }, Zr.OPACITY = { type: 3, value: "OPACITY" }, Zr.REFLECTION = { type: 3, value: "REFLECTION" }, Zr.SELFILLUMINATION = { type: 3, value: "SELFILLUMINATION" }, Zr.SHININESS = { type: 3, value: "SHININESS" }, Zr.SPECULAR = { type: 3, value: "SPECULAR" }, Zr.TEXTURE = { type: 3, value: "TEXTURE" }, Zr.TRANSPARENCYMAP = { type: 3, value: "TRANSPARENCYMAP" }, Zr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSurfaceTextureEnum = Zr;
  class qs {
  }
  qs.CONTACTOR = { type: 3, value: "CONTACTOR" }, qs.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, qs.STARTER = { type: 3, value: "STARTER" }, qs.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, qs.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, qs.USERDEFINED = { type: 3, value: "USERDEFINED" }, qs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSwitchingDeviceTypeEnum = qs;
  class Ws {
  }
  Ws.PREFORMED = { type: 3, value: "PREFORMED" }, Ws.SECTIONAL = { type: 3, value: "SECTIONAL" }, Ws.EXPANSION = { type: 3, value: "EXPANSION" }, Ws.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, Ws.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ws.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTankTypeEnum = Ws;
  class Bs {
  }
  Bs.STRAND = { type: 3, value: "STRAND" }, Bs.WIRE = { type: 3, value: "WIRE" }, Bs.BAR = { type: 3, value: "BAR" }, Bs.COATED = { type: 3, value: "COATED" }, Bs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonTypeEnum = Bs;
  class Sr {
  }
  Sr.LEFT = { type: 3, value: "LEFT" }, Sr.RIGHT = { type: 3, value: "RIGHT" }, Sr.UP = { type: 3, value: "UP" }, Sr.DOWN = { type: 3, value: "DOWN" }, r.IfcTextPath = Sr;
  class Wr {
  }
  Wr.PEOPLE = { type: 3, value: "PEOPLE" }, Wr.LIGHTING = { type: 3, value: "LIGHTING" }, Wr.EQUIPMENT = { type: 3, value: "EQUIPMENT" }, Wr.VENTILATIONINDOORAIR = { type: 3, value: "VENTILATIONINDOORAIR" }, Wr.VENTILATIONOUTSIDEAIR = { type: 3, value: "VENTILATIONOUTSIDEAIR" }, Wr.RECIRCULATEDAIR = { type: 3, value: "RECIRCULATEDAIR" }, Wr.EXHAUSTAIR = { type: 3, value: "EXHAUSTAIR" }, Wr.AIREXCHANGERATE = { type: 3, value: "AIREXCHANGERATE" }, Wr.DRYBULBTEMPERATURE = { type: 3, value: "DRYBULBTEMPERATURE" }, Wr.RELATIVEHUMIDITY = { type: 3, value: "RELATIVEHUMIDITY" }, Wr.INFILTRATION = { type: 3, value: "INFILTRATION" }, Wr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcThermalLoadSourceEnum = Wr;
  class lo {
  }
  lo.SENSIBLE = { type: 3, value: "SENSIBLE" }, lo.LATENT = { type: 3, value: "LATENT" }, lo.RADIANT = { type: 3, value: "RADIANT" }, lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcThermalLoadTypeEnum = lo;
  class uo {
  }
  uo.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, uo.DISCRETE = { type: 3, value: "DISCRETE" }, uo.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, uo.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, uo.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, uo.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, uo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTimeSeriesDataTypeEnum = uo;
  class Vs {
  }
  Vs.ANNUAL = { type: 3, value: "ANNUAL" }, Vs.MONTHLY = { type: 3, value: "MONTHLY" }, Vs.WEEKLY = { type: 3, value: "WEEKLY" }, Vs.DAILY = { type: 3, value: "DAILY" }, Vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTimeSeriesScheduleTypeEnum = Vs;
  class Gs {
  }
  Gs.CURRENT = { type: 3, value: "CURRENT" }, Gs.FREQUENCY = { type: 3, value: "FREQUENCY" }, Gs.VOLTAGE = { type: 3, value: "VOLTAGE" }, Gs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransformerTypeEnum = Gs;
  class Ni {
  }
  Ni.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" }, Ni.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, Ni.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, Ni.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" }, r.IfcTransitionCode = Ni;
  class zi {
  }
  zi.ELEVATOR = { type: 3, value: "ELEVATOR" }, zi.ESCALATOR = { type: 3, value: "ESCALATOR" }, zi.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, zi.USERDEFINED = { type: 3, value: "USERDEFINED" }, zi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransportElementTypeEnum = zi;
  class Ko {
  }
  Ko.CARTESIAN = { type: 3, value: "CARTESIAN" }, Ko.PARAMETER = { type: 3, value: "PARAMETER" }, Ko.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcTrimmingPreference = Ko;
  class di {
  }
  di.FINNED = { type: 3, value: "FINNED" }, di.USERDEFINED = { type: 3, value: "USERDEFINED" }, di.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTubeBundleTypeEnum = di;
  class eo {
  }
  eo.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, eo.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, eo.AREAUNIT = { type: 3, value: "AREAUNIT" }, eo.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, eo.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, eo.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, eo.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, eo.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, eo.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, eo.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, eo.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, eo.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, eo.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, eo.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, eo.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, eo.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, eo.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, eo.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, eo.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, eo.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, eo.MASSUNIT = { type: 3, value: "MASSUNIT" }, eo.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, eo.POWERUNIT = { type: 3, value: "POWERUNIT" }, eo.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, eo.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, eo.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, eo.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, eo.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, eo.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, eo.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcUnitEnum = eo;
  class ua {
  }
  ua.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, ua.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, ua.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, ua.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, ua.USERDEFINED = { type: 3, value: "USERDEFINED" }, ua.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcUnitaryEquipmentTypeEnum = ua;
  class qo {
  }
  qo.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, qo.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, qo.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, qo.CHECK = { type: 3, value: "CHECK" }, qo.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, qo.DIVERTING = { type: 3, value: "DIVERTING" }, qo.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, qo.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, qo.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, qo.FAUCET = { type: 3, value: "FAUCET" }, qo.FLUSHING = { type: 3, value: "FLUSHING" }, qo.GASCOCK = { type: 3, value: "GASCOCK" }, qo.GASTAP = { type: 3, value: "GASTAP" }, qo.ISOLATING = { type: 3, value: "ISOLATING" }, qo.MIXING = { type: 3, value: "MIXING" }, qo.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, qo.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, qo.REGULATING = { type: 3, value: "REGULATING" }, qo.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, qo.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, qo.STOPCOCK = { type: 3, value: "STOPCOCK" }, qo.USERDEFINED = { type: 3, value: "USERDEFINED" }, qo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcValveTypeEnum = qo;
  class Mi {
  }
  Mi.COMPRESSION = { type: 3, value: "COMPRESSION" }, Mi.SPRING = { type: 3, value: "SPRING" }, Mi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVibrationIsolatorTypeEnum = Mi;
  class si {
  }
  si.STANDARD = { type: 3, value: "STANDARD" }, si.POLYGONAL = { type: 3, value: "POLYGONAL" }, si.SHEAR = { type: 3, value: "SHEAR" }, si.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, si.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, si.USERDEFINED = { type: 3, value: "USERDEFINED" }, si.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWallTypeEnum = si;
  class ko {
  }
  ko.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, ko.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, ko.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, ko.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, ko.GREASEINTERCEPTOR = { type: 3, value: "GREASEINTERCEPTOR" }, ko.OILINTERCEPTOR = { type: 3, value: "OILINTERCEPTOR" }, ko.PETROLINTERCEPTOR = { type: 3, value: "PETROLINTERCEPTOR" }, ko.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, ko.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, ko.WASTETRAP = { type: 3, value: "WASTETRAP" }, ko.USERDEFINED = { type: 3, value: "USERDEFINED" }, ko.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWasteTerminalTypeEnum = ko;
  class ni {
  }
  ni.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, ni.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, ni.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, ni.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, ni.TOPHUNG = { type: 3, value: "TOPHUNG" }, ni.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, ni.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, ni.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, ni.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, ni.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, ni.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, ni.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, ni.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, ni.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelOperationEnum = ni;
  class da {
  }
  da.LEFT = { type: 3, value: "LEFT" }, da.MIDDLE = { type: 3, value: "MIDDLE" }, da.RIGHT = { type: 3, value: "RIGHT" }, da.BOTTOM = { type: 3, value: "BOTTOM" }, da.TOP = { type: 3, value: "TOP" }, da.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelPositionEnum = da;
  class vi {
  }
  vi.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, vi.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, vi.STEEL = { type: 3, value: "STEEL" }, vi.WOOD = { type: 3, value: "WOOD" }, vi.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, vi.PLASTIC = { type: 3, value: "PLASTIC" }, vi.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, vi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleConstructionEnum = vi;
  class fa {
  }
  fa.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, fa.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, fa.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, fa.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, fa.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, fa.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, fa.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, fa.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, fa.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, fa.USERDEFINED = { type: 3, value: "USERDEFINED" }, fa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleOperationEnum = fa;
  class vo {
  }
  vo.ACTUAL = { type: 3, value: "ACTUAL" }, vo.BASELINE = { type: 3, value: "BASELINE" }, vo.PLANNED = { type: 3, value: "PLANNED" }, vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, vo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkControlTypeEnum = vo;
  class Xi extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Role = ee, this.UserDefinedRole = le, this.Description = he, this.type = 3630933823;
    }
  }
  r.IfcActorRole = Xi;
  class gi extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Purpose = ee, this.Description = le, this.UserDefinedPurpose = he, this.type = 618182010;
    }
  }
  r.IfcAddress = gi;
  class Ao extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.ApplicationDeveloper = ee, this.Version = le, this.ApplicationFullName = he, this.ApplicationIdentifier = ge, this.type = 639542469;
    }
  }
  r.IfcApplication = Ao;
  class Bi extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue), this.Name = ee, this.Description = le, this.AppliedValue = he, this.UnitBasis = ge, this.ApplicableDate = Xe, this.FixedUntilDate = tt, this.type = 411424972;
    }
  }
  r.IfcAppliedValue = Bi;
  class Ga extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.ComponentOfTotal = ee, this.Components = le, this.ArithmeticOperator = he, this.Name = ge, this.Description = Xe, this.type = 1110488051;
    }
  }
  r.IfcAppliedValueRelationship = Ga;
  class Go extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue), this.Description = ee, this.ApprovalDateTime = le, this.ApprovalStatus = he, this.ApprovalLevel = ge, this.ApprovalQualifier = Xe, this.Name = tt, this.Identifier = at, this.type = 130549933;
    }
  }
  r.IfcApproval = Go;
  class $i extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Actor = ee, this.Approval = le, this.Role = he, this.type = 2080292479;
    }
  }
  r.IfcApprovalActorRelationship = $i;
  class Ya extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ApprovedProperties = ee, this.Approval = le, this.type = 390851274;
    }
  }
  r.IfcApprovalPropertyRelationship = Ya;
  class Ui extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.RelatedApproval = ee, this.RelatingApproval = le, this.Description = he, this.Name = ge, this.type = 3869604511;
    }
  }
  r.IfcApprovalRelationship = Ui;
  class Aa extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 4037036970;
    }
  }
  r.IfcBoundaryCondition = Aa;
  class La extends Aa {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.LinearStiffnessByLengthX = le, this.LinearStiffnessByLengthY = he, this.LinearStiffnessByLengthZ = ge, this.RotationalStiffnessByLengthX = Xe, this.RotationalStiffnessByLengthY = tt, this.RotationalStiffnessByLengthZ = at, this.type = 1560379544;
    }
  }
  r.IfcBoundaryEdgeCondition = La;
  class za extends Aa {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.LinearStiffnessByAreaX = le, this.LinearStiffnessByAreaY = he, this.LinearStiffnessByAreaZ = ge, this.type = 3367102660;
    }
  }
  r.IfcBoundaryFaceCondition = za;
  class Ta extends Aa {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.LinearStiffnessX = le, this.LinearStiffnessY = he, this.LinearStiffnessZ = ge, this.RotationalStiffnessX = Xe, this.RotationalStiffnessY = tt, this.RotationalStiffnessZ = at, this.type = 1387855156;
    }
  }
  r.IfcBoundaryNodeCondition = Ta;
  class oi extends Ta {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.Name = ee, this.LinearStiffnessX = le, this.LinearStiffnessY = he, this.LinearStiffnessZ = ge, this.RotationalStiffnessX = Xe, this.RotationalStiffnessY = tt, this.RotationalStiffnessZ = at, this.WarpingStiffness = St, this.type = 2069777674;
    }
  }
  r.IfcBoundaryNodeConditionWarping = oi;
  class Na extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.DayComponent = ee, this.MonthComponent = le, this.YearComponent = he, this.type = 622194075;
    }
  }
  r.IfcCalendarDate = Na;
  class Qi extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Source = ee, this.Edition = le, this.EditionDate = he, this.Name = ge, this.type = 747523909;
    }
  }
  r.IfcClassification = Qi;
  class fi extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Notation = ee, this.ItemOf = le, this.Title = he, this.type = 1767535486;
    }
  }
  r.IfcClassificationItem = fi;
  class ha extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.RelatingItem = ee, this.RelatedItems = le, this.type = 1098599126;
    }
  }
  r.IfcClassificationItemRelationship = ha;
  class ca extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.NotationFacets = ee, this.type = 938368621;
    }
  }
  r.IfcClassificationNotation = ca;
  class Ki extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.NotationValue = ee, this.type = 3639012971;
    }
  }
  r.IfcClassificationNotationFacet = Ki;
  class Ba extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 3264961684;
    }
  }
  r.IfcColourSpecification = Ba;
  class je extends IfcLineObject {
    constructor(ue) {
      super(ue), this.type = 2859738748;
    }
  }
  r.IfcConnectionGeometry = je;
  class Je extends je {
    constructor(ue, ee, le) {
      super(ue), this.PointOnRelatingElement = ee, this.PointOnRelatedElement = le, this.type = 2614616156;
    }
  }
  r.IfcConnectionPointGeometry = Je;
  class At extends je {
    constructor(ue, ee, le, he) {
      super(ue), this.LocationAtRelatingElement = ee, this.LocationAtRelatedElement = le, this.ProfileOfPort = he, this.type = 4257277454;
    }
  }
  r.IfcConnectionPortGeometry = At;
  class qt extends je {
    constructor(ue, ee, le) {
      super(ue), this.SurfaceOnRelatingElement = ee, this.SurfaceOnRelatedElement = le, this.type = 2732653382;
    }
  }
  r.IfcConnectionSurfaceGeometry = qt;
  class un extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue), this.Name = ee, this.Description = le, this.ConstraintGrade = he, this.ConstraintSource = ge, this.CreatingActor = Xe, this.CreationTime = tt, this.UserDefinedGrade = at, this.type = 1959218052;
    }
  }
  r.IfcConstraint = un;
  class An extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.Name = ee, this.Description = le, this.RelatingConstraint = he, this.RelatedConstraints = ge, this.LogicalAggregator = Xe, this.type = 1658513725;
    }
  }
  r.IfcConstraintAggregationRelationship = An;
  class Fn extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ClassifiedConstraint = ee, this.RelatedClassifications = le, this.type = 613356794;
    }
  }
  r.IfcConstraintClassificationRelationship = Fn;
  class wn extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Name = ee, this.Description = le, this.RelatingConstraint = he, this.RelatedConstraints = ge, this.type = 347226245;
    }
  }
  r.IfcConstraintRelationship = wn;
  class Hn extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.HourOffset = ee, this.MinuteOffset = le, this.Sense = he, this.type = 1065062679;
    }
  }
  r.IfcCoordinatedUniversalTimeOffset = Hn;
  class Er extends Bi {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt), this.Name = ee, this.Description = le, this.AppliedValue = he, this.UnitBasis = ge, this.ApplicableDate = Xe, this.FixedUntilDate = tt, this.CostType = at, this.Condition = St, this.type = 602808272;
    }
  }
  r.IfcCostValue = Er;
  class Cr extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.RelatingMonetaryUnit = ee, this.RelatedMonetaryUnit = le, this.ExchangeRate = he, this.RateDateTime = ge, this.RateSource = Xe, this.type = 539742890;
    }
  }
  r.IfcCurrencyRelationship = Cr;
  class zr extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Name = ee, this.PatternList = le, this.type = 1105321065;
    }
  }
  r.IfcCurveStyleFont = zr;
  class hr extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Name = ee, this.CurveFont = le, this.CurveFontScaling = he, this.type = 2367409068;
    }
  }
  r.IfcCurveStyleFontAndScaling = hr;
  class xr extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.VisibleSegmentLength = ee, this.InvisibleSegmentLength = le, this.type = 3510044353;
    }
  }
  r.IfcCurveStyleFontPattern = xr;
  class Is extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.DateComponent = ee, this.TimeComponent = le, this.type = 1072939445;
    }
  }
  r.IfcDateAndTime = Is;
  class fs extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Elements = ee, this.UnitType = le, this.UserDefinedType = he, this.type = 1765591967;
    }
  }
  r.IfcDerivedUnit = fs;
  class co extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Unit = ee, this.Exponent = le, this.type = 1045800335;
    }
  }
  r.IfcDerivedUnitElement = co;
  class Yo extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue), this.LengthExponent = ee, this.MassExponent = le, this.TimeExponent = he, this.ElectricCurrentExponent = ge, this.ThermodynamicTemperatureExponent = Xe, this.AmountOfSubstanceExponent = tt, this.LuminousIntensityExponent = at, this.type = 2949456006;
    }
  }
  r.IfcDimensionalExponents = Yo;
  class Qn extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.FileExtension = ee, this.MimeContentType = le, this.MimeSubtype = he, this.type = 1376555844;
    }
  }
  r.IfcDocumentElectronicFormat = Qn;
  class es extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0) {
      super(ue), this.DocumentId = ee, this.Name = le, this.Description = he, this.DocumentReferences = ge, this.Purpose = Xe, this.IntendedUse = tt, this.Scope = at, this.Revision = St, this.DocumentOwner = kt, this.Editors = On, this.CreationTime = Gr, this.LastRevisionTime = ys, this.ElectronicFormat = Fs, this.ValidFrom = Xo, this.ValidUntil = ta, this.Confidentiality = E0, this.Status = I0, this.type = 1154170062;
    }
  }
  r.IfcDocumentInformation = es;
  class Jo extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.RelatingDocument = ee, this.RelatedDocuments = le, this.RelationshipType = he, this.type = 770865208;
    }
  }
  r.IfcDocumentInformationRelationship = Jo;
  class js extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Name = ee, this.Description = le, this.RelatingDraughtingCallout = he, this.RelatedDraughtingCallout = ge, this.type = 3796139169;
    }
  }
  r.IfcDraughtingCalloutRelationship = js;
  class Hi extends Bi {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt), this.Name = ee, this.Description = le, this.AppliedValue = he, this.UnitBasis = ge, this.ApplicableDate = Xe, this.FixedUntilDate = tt, this.ImpactType = at, this.Category = St, this.UserDefinedCategory = kt, this.type = 1648886627;
    }
  }
  r.IfcEnvironmentalImpactValue = Hi;
  class zs extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 3200245327;
    }
  }
  r.IfcExternalReference = zs;
  class Ji extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 2242383968;
    }
  }
  r.IfcExternallyDefinedHatchStyle = Ji;
  class ja extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 1040185647;
    }
  }
  r.IfcExternallyDefinedSurfaceStyle = ja;
  class Ea extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 3207319532;
    }
  }
  r.IfcExternallyDefinedSymbol = Ea;
  class ga extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 3548104201;
    }
  }
  r.IfcExternallyDefinedTextFont = ga;
  class sa extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.AxisTag = ee, this.AxisCurve = le, this.SameSense = he, this.type = 852622518;
    }
  }
  r.IfcGridAxis = sa;
  class Sa extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.TimeStamp = ee, this.ListValues = le, this.type = 3020489413;
    }
  }
  r.IfcIrregularTimeSeriesValue = Sa;
  class Ua extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.Name = ee, this.Version = le, this.Publisher = he, this.VersionDate = ge, this.LibraryReference = Xe, this.type = 2655187982;
    }
  }
  r.IfcLibraryInformation = Ua;
  class mi extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 3452421091;
    }
  }
  r.IfcLibraryReference = mi;
  class $a extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.MainPlaneAngle = ee, this.SecondaryPlaneAngle = le, this.LuminousIntensity = he, this.type = 4162380809;
    }
  }
  r.IfcLightDistributionData = $a;
  class Oa extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.LightDistributionCurve = ee, this.DistributionData = le, this.type = 1566485204;
    }
  }
  r.IfcLightIntensityDistribution = Oa;
  class Ha extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.HourComponent = ee, this.MinuteComponent = le, this.SecondComponent = he, this.Zone = ge, this.DaylightSavingOffset = Xe, this.type = 30780891;
    }
  }
  r.IfcLocalTime = Ha;
  class p0 extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 1838606355;
    }
  }
  r.IfcMaterial = p0;
  class k extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.MaterialClassifications = ee, this.ClassifiedMaterial = le, this.type = 1847130766;
    }
  }
  r.IfcMaterialClassificationRelationship = k;
  class ne extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Material = ee, this.LayerThickness = le, this.IsVentilated = he, this.type = 248100487;
    }
  }
  r.IfcMaterialLayer = ne;
  class T extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.MaterialLayers = ee, this.LayerSetName = le, this.type = 3303938423;
    }
  }
  r.IfcMaterialLayerSet = T;
  class y extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.ForLayerSet = ee, this.LayerSetDirection = le, this.DirectionSense = he, this.OffsetFromReferenceLine = ge, this.type = 1303795690;
    }
  }
  r.IfcMaterialLayerSetUsage = y;
  class N extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Materials = ee, this.type = 2199411900;
    }
  }
  r.IfcMaterialList = N;
  class b extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Material = ee, this.type = 3265635763;
    }
  }
  r.IfcMaterialProperties = b;
  class X extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ValueComponent = ee, this.UnitComponent = le, this.type = 2597039031;
    }
  }
  r.IfcMeasureWithUnit = X;
  class J extends b {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee), this.Material = ee, this.DynamicViscosity = le, this.YoungModulus = he, this.ShearModulus = ge, this.PoissonRatio = Xe, this.ThermalExpansionCoefficient = tt, this.type = 4256014907;
    }
  }
  r.IfcMechanicalMaterialProperties = J;
  class Ie extends J {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he, ge, Xe, tt), this.Material = ee, this.DynamicViscosity = le, this.YoungModulus = he, this.ShearModulus = ge, this.PoissonRatio = Xe, this.ThermalExpansionCoefficient = tt, this.YieldStress = at, this.UltimateStress = St, this.UltimateStrain = kt, this.HardeningModule = On, this.ProportionalStress = Gr, this.PlasticStrain = ys, this.Relaxations = Fs, this.type = 677618848;
    }
  }
  r.IfcMechanicalSteelMaterialProperties = Ie;
  class Pe extends un {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.Name = ee, this.Description = le, this.ConstraintGrade = he, this.ConstraintSource = ge, this.CreatingActor = Xe, this.CreationTime = tt, this.UserDefinedGrade = at, this.Benchmark = St, this.ValueSource = kt, this.DataValue = On, this.type = 3368373690;
    }
  }
  r.IfcMetric = Pe;
  class We extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Currency = ee, this.type = 2706619895;
    }
  }
  r.IfcMonetaryUnit = We;
  class it extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Dimensions = ee, this.UnitType = le, this.type = 1918398963;
    }
  }
  r.IfcNamedUnit = it;
  class Rt extends IfcLineObject {
    constructor(ue) {
      super(ue), this.type = 3701648758;
    }
  }
  r.IfcObjectPlacement = Rt;
  class Dt extends un {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.Name = ee, this.Description = le, this.ConstraintGrade = he, this.ConstraintSource = ge, this.CreatingActor = Xe, this.CreationTime = tt, this.UserDefinedGrade = at, this.BenchmarkValues = St, this.ResultValues = kt, this.ObjectiveQualifier = On, this.UserDefinedQualifier = Gr, this.type = 2251480897;
    }
  }
  r.IfcObjective = Dt;
  class Kt extends b {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee), this.Material = ee, this.VisibleTransmittance = le, this.SolarTransmittance = he, this.ThermalIrTransmittance = ge, this.ThermalIrEmissivityBack = Xe, this.ThermalIrEmissivityFront = tt, this.VisibleReflectanceBack = at, this.VisibleReflectanceFront = St, this.SolarReflectanceFront = kt, this.SolarReflectanceBack = On, this.type = 1227763645;
    }
  }
  r.IfcOpticalMaterialProperties = Kt;
  class _n extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.Id = ee, this.Name = le, this.Description = he, this.Roles = ge, this.Addresses = Xe, this.type = 4251960020;
    }
  }
  r.IfcOrganization = _n;
  class gn extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Name = ee, this.Description = le, this.RelatingOrganization = he, this.RelatedOrganizations = ge, this.type = 1411181986;
    }
  }
  r.IfcOrganizationRelationship = gn;
  class Pn extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue), this.OwningUser = ee, this.OwningApplication = le, this.State = he, this.ChangeAction = ge, this.LastModifiedDate = Xe, this.LastModifyingUser = tt, this.LastModifyingApplication = at, this.CreationDate = St, this.type = 1207048766;
    }
  }
  r.IfcOwnerHistory = Pn;
  class Vn extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue), this.Id = ee, this.FamilyName = le, this.GivenName = he, this.MiddleNames = ge, this.PrefixTitles = Xe, this.SuffixTitles = tt, this.Roles = at, this.Addresses = St, this.type = 2077209135;
    }
  }
  r.IfcPerson = Vn;
  class vn extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.ThePerson = ee, this.TheOrganization = le, this.Roles = he, this.type = 101040310;
    }
  }
  r.IfcPersonAndOrganization = vn;
  class Zn extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Name = ee, this.Description = le, this.type = 2483315170;
    }
  }
  r.IfcPhysicalQuantity = Zn;
  class cr extends Zn {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.Unit = he, this.type = 2226359599;
    }
  }
  r.IfcPhysicalSimpleQuantity = cr;
  class Cs extends gi {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he), this.Purpose = ee, this.Description = le, this.UserDefinedPurpose = he, this.InternalLocation = ge, this.AddressLines = Xe, this.PostalBox = tt, this.Town = at, this.Region = St, this.PostalCode = kt, this.Country = On, this.type = 3355820592;
    }
  }
  r.IfcPostalAddress = Cs;
  class Br extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 3727388367;
    }
  }
  r.IfcPreDefinedItem = Br;
  class Do extends Br {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 990879717;
    }
  }
  r.IfcPreDefinedSymbol = Do;
  class _o extends Do {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 3213052703;
    }
  }
  r.IfcPreDefinedTerminatorSymbol = _o;
  class Ca extends Br {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 1775413392;
    }
  }
  r.IfcPreDefinedTextFont = Ca;
  class ma extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Name = ee, this.Description = le, this.AssignedItems = he, this.Identifier = ge, this.type = 2022622350;
    }
  }
  r.IfcPresentationLayerAssignment = ma;
  class s0 extends ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge), this.Name = ee, this.Description = le, this.AssignedItems = he, this.Identifier = ge, this.LayerOn = Xe, this.LayerFrozen = tt, this.LayerBlocked = at, this.LayerStyles = St, this.type = 1304840413;
    }
  }
  r.IfcPresentationLayerWithStyle = s0;
  class Ra extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 3119450353;
    }
  }
  r.IfcPresentationStyle = Ra;
  class U0 extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Styles = ee, this.type = 2417041796;
    }
  }
  r.IfcPresentationStyleAssignment = U0;
  class Qa extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Name = ee, this.Description = le, this.Representations = he, this.type = 2095639259;
    }
  }
  r.IfcProductRepresentation = Qa;
  class Fl extends b {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee), this.Material = ee, this.SpecificHeatCapacity = le, this.N20Content = he, this.COContent = ge, this.CO2Content = Xe, this.type = 2267347899;
    }
  }
  r.IfcProductsOfCombustionProperties = Fl;
  class Pa extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ProfileType = ee, this.ProfileName = le, this.type = 3958567839;
    }
  }
  r.IfcProfileDef = Pa;
  class o0 extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ProfileName = ee, this.ProfileDefinition = le, this.type = 2802850158;
    }
  }
  r.IfcProfileProperties = o0;
  class il extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Name = ee, this.Description = le, this.type = 2598011224;
    }
  }
  r.IfcProperty = il;
  class T0 extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.RelatingConstraint = ee, this.RelatedProperties = le, this.Name = he, this.Description = ge, this.type = 3896028662;
    }
  }
  r.IfcPropertyConstraintRelationship = T0;
  class zl extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.DependingProperty = ee, this.DependantProperty = le, this.Name = he, this.Description = ge, this.Expression = Xe, this.type = 148025276;
    }
  }
  r.IfcPropertyDependencyRelationship = zl;
  class Al extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.Name = ee, this.EnumerationValues = le, this.Unit = he, this.type = 3710013099;
    }
  }
  r.IfcPropertyEnumeration = Al;
  class $l extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.AreaValue = ge, this.type = 2044713172;
    }
  }
  r.IfcQuantityArea = $l;
  class aE extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.CountValue = ge, this.type = 2093928680;
    }
  }
  r.IfcQuantityCount = aE;
  class wu extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.LengthValue = ge, this.type = 931644368;
    }
  }
  r.IfcQuantityLength = wu;
  class uc extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.TimeValue = ge, this.type = 3252649465;
    }
  }
  r.IfcQuantityTime = uc;
  class lE extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.VolumeValue = ge, this.type = 2405470396;
    }
  }
  r.IfcQuantityVolume = lE;
  class uE extends cr {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Unit = he, this.WeightValue = ge, this.type = 825690147;
    }
  }
  r.IfcQuantityWeight = uE;
  class Du extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.ReferencedDocument = ee, this.ReferencingValues = le, this.Name = he, this.Description = ge, this.type = 2692823254;
    }
  }
  r.IfcReferencesValueDocument = Du;
  class i3 extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue), this.TotalCrossSectionArea = ee, this.SteelGrade = le, this.BarSurface = he, this.EffectiveDepth = ge, this.NominalBarDiameter = Xe, this.BarCount = tt, this.type = 1580146022;
    }
  }
  r.IfcReinforcementBarProperties = i3;
  class cc extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.RelaxationValue = ee, this.InitialStress = le, this.type = 1222501353;
    }
  }
  r.IfcRelaxation = cc;
  class a3 extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 1076942058;
    }
  }
  r.IfcRepresentation = a3;
  class P1 extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ContextIdentifier = ee, this.ContextType = le, this.type = 3377609919;
    }
  }
  r.IfcRepresentationContext = P1;
  class Ql extends IfcLineObject {
    constructor(ue) {
      super(ue), this.type = 3008791417;
    }
  }
  r.IfcRepresentationItem = Ql;
  class cE extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.MappingOrigin = ee, this.MappedRepresentation = le, this.type = 1660063152;
    }
  }
  r.IfcRepresentationMap = cE;
  class Ll extends o0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le), this.ProfileName = ee, this.ProfileDefinition = le, this.Thickness = he, this.RibHeight = ge, this.RibWidth = Xe, this.RibSpacing = tt, this.Direction = at, this.type = 3679540991;
    }
  }
  r.IfcRibPlateProfileProperties = Ll;
  class P0 extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 2341007311;
    }
  }
  r.IfcRoot = P0;
  class EE extends it {
    constructor(ue, ee, le, he) {
      super(ue, new Handle(0), ee), this.UnitType = ee, this.Prefix = le, this.Name = he, this.type = 448429030;
    }
  }
  r.IfcSIUnit = EE;
  class Xa extends IfcLineObject {
    constructor(ue, ee, le, he) {
      super(ue), this.SectionType = ee, this.StartProfile = le, this.EndProfile = he, this.type = 2042790032;
    }
  }
  r.IfcSectionProperties = Xa;
  class Ec extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue), this.LongitudinalStartPosition = ee, this.LongitudinalEndPosition = le, this.TransversePosition = he, this.ReinforcementRole = ge, this.SectionDefinition = Xe, this.CrossSectionReinforcementDefinitions = tt, this.type = 4165799628;
    }
  }
  r.IfcSectionReinforcementProperties = Ec;
  class w1 extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.ShapeRepresentations = ee, this.Name = le, this.Description = he, this.ProductDefinitional = ge, this.PartOfProductDefinitionShape = Xe, this.type = 867548509;
    }
  }
  r.IfcShapeAspect = w1;
  class al extends a3 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 3982875396;
    }
  }
  r.IfcShapeModel = al;
  class IE extends al {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 4240577450;
    }
  }
  r.IfcShapeRepresentation = IE;
  class $0 extends il {
    constructor(ue, ee, le) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.type = 3692461612;
    }
  }
  r.IfcSimpleProperty = $0;
  class ll extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 2273995522;
    }
  }
  r.IfcStructuralConnectionCondition = ll;
  class D1 extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Name = ee, this.type = 2162789131;
    }
  }
  r.IfcStructuralLoad = D1;
  class d0 extends D1 {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 2525727697;
    }
  }
  r.IfcStructuralLoadStatic = d0;
  class Nl extends d0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.DeltaT_Constant = le, this.DeltaT_Y = he, this.DeltaT_Z = ge, this.type = 3408363356;
    }
  }
  r.IfcStructuralLoadTemperature = Nl;
  class b1 extends a3 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 2830218821;
    }
  }
  r.IfcStyleModel = b1;
  class G1 extends Ql {
    constructor(ue, ee, le, he) {
      super(ue), this.Item = ee, this.Styles = le, this.Name = he, this.type = 3958052878;
    }
  }
  r.IfcStyledItem = G1;
  class pE extends b1 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 3049322572;
    }
  }
  r.IfcStyledRepresentation = pE;
  class dE extends Ra {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Name = ee, this.Side = le, this.Styles = he, this.type = 1300840506;
    }
  }
  r.IfcSurfaceStyle = dE;
  class fE extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.DiffuseTransmissionColour = ee, this.DiffuseReflectionColour = le, this.TransmissionColour = he, this.ReflectanceColour = ge, this.type = 3303107099;
    }
  }
  r.IfcSurfaceStyleLighting = fE;
  class CE extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.RefractionIndex = ee, this.DispersionFactor = le, this.type = 1607154358;
    }
  }
  r.IfcSurfaceStyleRefraction = CE;
  class j1 extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.SurfaceColour = ee, this.type = 846575682;
    }
  }
  r.IfcSurfaceStyleShading = j1;
  class hE extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Textures = ee, this.type = 1351298697;
    }
  }
  r.IfcSurfaceStyleWithTextures = hE;
  class Kl extends IfcLineObject {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.RepeatS = ee, this.RepeatT = le, this.TextureType = he, this.TextureTransform = ge, this.type = 626085974;
    }
  }
  r.IfcSurfaceTexture = Kl;
  class M1 extends Ra {
    constructor(ue, ee, le) {
      super(ue, ee), this.Name = ee, this.StyleOfSymbol = le, this.type = 1290481447;
    }
  }
  r.IfcSymbolStyle = M1;
  class bu extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Name = ee, this.Rows = le, this.type = 985171141;
    }
  }
  r.IfcTable = bu;
  class ul extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.RowCells = ee, this.IsHeading = le, this.type = 531007025;
    }
  }
  r.IfcTableRow = ul;
  class w0 extends gi {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he), this.Purpose = ee, this.Description = le, this.UserDefinedPurpose = he, this.TelephoneNumbers = ge, this.FacsimileNumbers = Xe, this.PagerNumber = tt, this.ElectronicMailAddresses = at, this.WWWHomePageURL = St, this.type = 912023232;
    }
  }
  r.IfcTelecomAddress = w0;
  class Ic extends Ra {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.TextCharacterAppearance = le, this.TextStyle = he, this.TextFontStyle = ge, this.type = 1447204868;
    }
  }
  r.IfcTextStyle = Ic;
  class SE extends Ca {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee), this.Name = ee, this.FontFamily = le, this.FontStyle = he, this.FontVariant = ge, this.FontWeight = Xe, this.FontSize = tt, this.type = 1983826977;
    }
  }
  r.IfcTextStyleFontModel = SE;
  class Jl extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.Colour = ee, this.BackgroundColour = le, this.type = 2636378356;
    }
  }
  r.IfcTextStyleForDefinedFont = Jl;
  class x1 extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue), this.TextIndent = ee, this.TextAlign = le, this.TextDecoration = he, this.LetterSpacing = ge, this.WordSpacing = Xe, this.TextTransform = tt, this.LineHeight = at, this.type = 1640371178;
    }
  }
  r.IfcTextStyleTextModel = x1;
  class l3 extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.BoxHeight = ee, this.BoxWidth = le, this.BoxSlantAngle = he, this.BoxRotateAngle = ge, this.CharacterSpacing = Xe, this.type = 1484833681;
    }
  }
  r.IfcTextStyleWithBoxCharacteristics = l3;
  class u3 extends IfcLineObject {
    constructor(ue) {
      super(ue), this.type = 280115917;
    }
  }
  r.IfcTextureCoordinate = u3;
  class Gu extends u3 {
    constructor(ue, ee, le) {
      super(ue), this.Mode = ee, this.Parameter = le, this.type = 1742049831;
    }
  }
  r.IfcTextureCoordinateGenerator = Gu;
  class c3 extends u3 {
    constructor(ue, ee) {
      super(ue), this.TextureMaps = ee, this.type = 2552916305;
    }
  }
  r.IfcTextureMap = c3;
  class RE extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Coordinates = ee, this.type = 1210645708;
    }
  }
  r.IfcTextureVertex = RE;
  class E3 extends b {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee), this.Material = ee, this.SpecificHeatCapacity = le, this.BoilingPoint = he, this.FreezingPoint = ge, this.ThermalConductivity = Xe, this.type = 3317419933;
    }
  }
  r.IfcThermalMaterialProperties = E3;
  class D0 extends IfcLineObject {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue), this.Name = ee, this.Description = le, this.StartTime = he, this.EndTime = ge, this.TimeSeriesDataType = Xe, this.DataOrigin = tt, this.UserDefinedDataOrigin = at, this.Unit = St, this.type = 3101149627;
    }
  }
  r.IfcTimeSeries = D0;
  class pc extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.ReferencedTimeSeries = ee, this.TimeSeriesReferences = le, this.type = 1718945513;
    }
  }
  r.IfcTimeSeriesReferenceRelationship = pc;
  class v1 extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.ListValues = ee, this.type = 581633288;
    }
  }
  r.IfcTimeSeriesValue = v1;
  class cl extends Ql {
    constructor(ue) {
      super(ue), this.type = 1377556343;
    }
  }
  r.IfcTopologicalRepresentationItem = cl;
  class TE extends al {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.ContextOfItems = ee, this.RepresentationIdentifier = le, this.RepresentationType = he, this.Items = ge, this.type = 1735638870;
    }
  }
  r.IfcTopologyRepresentation = TE;
  class _E extends IfcLineObject {
    constructor(ue, ee) {
      super(ue), this.Units = ee, this.type = 180925521;
    }
  }
  r.IfcUnitAssignment = _E;
  class B1 extends cl {
    constructor(ue) {
      super(ue), this.type = 2799835756;
    }
  }
  r.IfcVertex = B1;
  class I3 extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.TextureVertices = ee, this.TexturePoints = le, this.type = 3304826586;
    }
  }
  r.IfcVertexBasedTextureMap = I3;
  class El extends B1 {
    constructor(ue, ee) {
      super(ue), this.VertexGeometry = ee, this.type = 1907098498;
    }
  }
  r.IfcVertexPoint = El;
  class U1 extends IfcLineObject {
    constructor(ue, ee, le) {
      super(ue), this.IntersectingAxes = ee, this.OffsetDistances = le, this.type = 891718957;
    }
  }
  r.IfcVirtualGridIntersection = U1;
  class Va extends b {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee), this.Material = ee, this.IsPotable = le, this.Hardness = he, this.AlkalinityConcentration = ge, this.AcidityConcentration = Xe, this.ImpuritiesContent = tt, this.PHLevel = at, this.DissolvedSolidsContent = St, this.type = 1065908215;
    }
  }
  r.IfcWaterProperties = Va;
  class H0 extends G1 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 2442683028;
    }
  }
  r.IfcAnnotationOccurrence = H0;
  class mE extends H0 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 962685235;
    }
  }
  r.IfcAnnotationSurfaceOccurrence = mE;
  class Zl extends H0 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 3612888222;
    }
  }
  r.IfcAnnotationSymbolOccurrence = Zl;
  class p3 extends H0 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 2297822566;
    }
  }
  r.IfcAnnotationTextOccurrence = p3;
  class Q0 extends Pa {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.ProfileType = ee, this.ProfileName = le, this.OuterCurve = he, this.type = 3798115385;
    }
  }
  r.IfcArbitraryClosedProfileDef = Q0;
  class H1 extends Pa {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.ProfileType = ee, this.ProfileName = le, this.Curve = he, this.type = 1310608509;
    }
  }
  r.IfcArbitraryOpenProfileDef = H1;
  class ju extends Q0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.OuterCurve = he, this.InnerCurves = ge, this.type = 2705031697;
    }
  }
  r.IfcArbitraryProfileDefWithVoids = ju;
  class yE extends Kl {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.RepeatS = ee, this.RepeatT = le, this.TextureType = he, this.TextureTransform = ge, this.RasterFormat = Xe, this.RasterCode = tt, this.type = 616511568;
    }
  }
  r.IfcBlobTexture = yE;
  class FE extends H1 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Curve = he, this.Thickness = ge, this.type = 3150382593;
    }
  }
  r.IfcCenterLineProfileDef = FE;
  class AE extends zs {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.ReferencedSource = ge, this.type = 647927063;
    }
  }
  r.IfcClassificationReference = AE;
  class dc extends Ba {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.Red = le, this.Green = he, this.Blue = ge, this.type = 776857604;
    }
  }
  r.IfcColourRgb = dc;
  class LE extends il {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.UsageName = he, this.HasProperties = ge, this.type = 2542286263;
    }
  }
  r.IfcComplexProperty = LE;
  class NE extends Pa {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.ProfileType = ee, this.ProfileName = le, this.Profiles = he, this.Label = ge, this.type = 1485152156;
    }
  }
  r.IfcCompositeProfileDef = NE;
  class d3 extends cl {
    constructor(ue, ee) {
      super(ue), this.CfsFaces = ee, this.type = 370225590;
    }
  }
  r.IfcConnectedFaceSet = d3;
  class gE extends je {
    constructor(ue, ee, le) {
      super(ue), this.CurveOnRelatingElement = ee, this.CurveOnRelatedElement = le, this.type = 1981873012;
    }
  }
  r.IfcConnectionCurveGeometry = gE;
  class OE extends Je {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le), this.PointOnRelatingElement = ee, this.PointOnRelatedElement = le, this.EccentricityInX = he, this.EccentricityInY = ge, this.EccentricityInZ = Xe, this.type = 45288368;
    }
  }
  r.IfcConnectionPointEccentricity = OE;
  class f3 extends it {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.Dimensions = ee, this.UnitType = le, this.Name = he, this.type = 3050246964;
    }
  }
  r.IfcContextDependentUnit = f3;
  class C3 extends it {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Dimensions = ee, this.UnitType = le, this.Name = he, this.ConversionFactor = ge, this.type = 2889183280;
    }
  }
  r.IfcConversionBasedUnit = C3;
  class K0 extends Ra {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.CurveFont = le, this.CurveWidth = he, this.CurveColour = ge, this.type = 3800577675;
    }
  }
  r.IfcCurveStyle = K0;
  class Mu extends Pa {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le), this.ProfileType = ee, this.ProfileName = le, this.ParentProfile = he, this.Operator = ge, this.Label = Xe, this.type = 3632507154;
    }
  }
  r.IfcDerivedProfileDef = Mu;
  class PE extends js {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.Name = ee, this.Description = le, this.RelatingDraughtingCallout = he, this.RelatedDraughtingCallout = ge, this.type = 2273265877;
    }
  }
  r.IfcDimensionCalloutRelationship = PE;
  class b0 extends js {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.Name = ee, this.Description = le, this.RelatingDraughtingCallout = he, this.RelatedDraughtingCallout = ge, this.type = 1694125774;
    }
  }
  r.IfcDimensionPair = b0;
  class fc extends zs {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Location = ee, this.ItemReference = le, this.Name = he, this.type = 3732053477;
    }
  }
  r.IfcDocumentReference = fc;
  class wE extends Ca {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 4170525392;
    }
  }
  r.IfcDraughtingPreDefinedTextFont = wE;
  class J0 extends cl {
    constructor(ue, ee, le) {
      super(ue), this.EdgeStart = ee, this.EdgeEnd = le, this.type = 3900360178;
    }
  }
  r.IfcEdge = J0;
  class DE extends J0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.EdgeStart = ee, this.EdgeEnd = le, this.EdgeGeometry = he, this.SameSense = ge, this.type = 476780140;
    }
  }
  r.IfcEdgeCurve = DE;
  class Cc extends b {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Material = ee, this.ExtendedProperties = le, this.Description = he, this.Name = ge, this.type = 1860660968;
    }
  }
  r.IfcExtendedMaterialProperties = Cc;
  class h3 extends cl {
    constructor(ue, ee) {
      super(ue), this.Bounds = ee, this.type = 2556980723;
    }
  }
  r.IfcFace = h3;
  class hc extends cl {
    constructor(ue, ee, le) {
      super(ue), this.Bound = ee, this.Orientation = le, this.type = 1809719519;
    }
  }
  r.IfcFaceBound = hc;
  class S3 extends hc {
    constructor(ue, ee, le) {
      super(ue, ee, le), this.Bound = ee, this.Orientation = le, this.type = 803316827;
    }
  }
  r.IfcFaceOuterBound = S3;
  class bE extends h3 {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Bounds = ee, this.FaceSurface = le, this.SameSense = he, this.type = 3008276851;
    }
  }
  r.IfcFaceSurface = bE;
  class R3 extends ll {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.TensionFailureX = le, this.TensionFailureY = he, this.TensionFailureZ = ge, this.CompressionFailureX = Xe, this.CompressionFailureY = tt, this.CompressionFailureZ = at, this.type = 4219587988;
    }
  }
  r.IfcFailureConnectionCondition = R3;
  class eu extends Ra {
    constructor(ue, ee, le) {
      super(ue, ee), this.Name = ee, this.FillStyles = le, this.type = 738692330;
    }
  }
  r.IfcFillAreaStyle = eu;
  class GE extends b {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee), this.Material = ee, this.CombustionTemperature = le, this.CarbonContent = he, this.LowerHeatingValue = ge, this.HigherHeatingValue = Xe, this.type = 3857492461;
    }
  }
  r.IfcFuelProperties = GE;
  class T3 extends b {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Material = ee, this.MolecularWeight = le, this.Porosity = he, this.MassDensity = ge, this.type = 803998398;
    }
  }
  r.IfcGeneralMaterialProperties = T3;
  class q1 extends o0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le), this.ProfileName = ee, this.ProfileDefinition = le, this.PhysicalWeight = he, this.Perimeter = ge, this.MinimumPlateThickness = Xe, this.MaximumPlateThickness = tt, this.CrossSectionArea = at, this.type = 1446786286;
    }
  }
  r.IfcGeneralProfileProperties = q1;
  class Sc extends P1 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le), this.ContextIdentifier = ee, this.ContextType = le, this.CoordinateSpaceDimension = he, this.Precision = ge, this.WorldCoordinateSystem = Xe, this.TrueNorth = tt, this.type = 3448662350;
    }
  }
  r.IfcGeometricRepresentationContext = Sc;
  class Zi extends Ql {
    constructor(ue) {
      super(ue), this.type = 2453401579;
    }
  }
  r.IfcGeometricRepresentationItem = Zi;
  class jE extends Sc {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, new L(0), null, new Handle(0), null), this.ContextIdentifier = ee, this.ContextType = le, this.ParentContext = he, this.TargetScale = ge, this.TargetView = Xe, this.UserDefinedTargetView = tt, this.type = 4142052618;
    }
  }
  r.IfcGeometricRepresentationSubContext = jE;
  class k1 extends Zi {
    constructor(ue, ee) {
      super(ue), this.Elements = ee, this.type = 3590301190;
    }
  }
  r.IfcGeometricSet = k1;
  class Y1 extends Rt {
    constructor(ue, ee, le) {
      super(ue), this.PlacementLocation = ee, this.PlacementRefDirection = le, this.type = 178086475;
    }
  }
  r.IfcGridPlacement = Y1;
  class Rc extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.BaseSurface = ee, this.AgreementFlag = le, this.type = 812098782;
    }
  }
  r.IfcHalfSpaceSolid = Rc;
  class ME extends b {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee), this.Material = ee, this.UpperVaporResistanceFactor = le, this.LowerVaporResistanceFactor = he, this.IsothermalMoistureCapacity = ge, this.VaporPermeability = Xe, this.MoistureDiffusivity = tt, this.type = 2445078500;
    }
  }
  r.IfcHygroscopicMaterialProperties = ME;
  class Tc extends Kl {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.RepeatS = ee, this.RepeatT = le, this.TextureType = he, this.TextureTransform = ge, this.UrlReference = Xe, this.type = 3905492369;
    }
  }
  r.IfcImageTexture = Tc;
  class xE extends D0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.Name = ee, this.Description = le, this.StartTime = he, this.EndTime = ge, this.TimeSeriesDataType = Xe, this.DataOrigin = tt, this.UserDefinedDataOrigin = at, this.Unit = St, this.Values = kt, this.type = 3741457305;
    }
  }
  r.IfcIrregularTimeSeries = xE;
  class xu extends Zi {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.type = 1402838566;
    }
  }
  r.IfcLightSource = xu;
  class vE extends xu {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.type = 125510826;
    }
  }
  r.IfcLightSourceAmbient = vE;
  class _3 extends xu {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.Orientation = Xe, this.type = 2604431987;
    }
  }
  r.IfcLightSourceDirectional = _3;
  class BE extends xu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.Position = Xe, this.ColourAppearance = tt, this.ColourTemperature = at, this.LuminousFlux = St, this.LightEmissionSource = kt, this.LightDistributionDataSource = On, this.type = 4266656042;
    }
  }
  r.IfcLightSourceGoniometric = BE;
  class X1 extends xu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.Position = Xe, this.Radius = tt, this.ConstantAttenuation = at, this.DistanceAttenuation = St, this.QuadricAttenuation = kt, this.type = 1520743889;
    }
  }
  r.IfcLightSourcePositional = X1;
  class UE extends X1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.Name = ee, this.LightColour = le, this.AmbientIntensity = he, this.Intensity = ge, this.Position = Xe, this.Radius = tt, this.ConstantAttenuation = at, this.DistanceAttenuation = St, this.QuadricAttenuation = kt, this.Orientation = On, this.ConcentrationExponent = Gr, this.SpreadAngle = ys, this.BeamWidthAngle = Fs, this.type = 3422422726;
    }
  }
  r.IfcLightSourceSpot = UE;
  class _c extends Rt {
    constructor(ue, ee, le) {
      super(ue), this.PlacementRelTo = ee, this.RelativePlacement = le, this.type = 2624227202;
    }
  }
  r.IfcLocalPlacement = _c;
  class mc extends cl {
    constructor(ue) {
      super(ue), this.type = 1008929658;
    }
  }
  r.IfcLoop = mc;
  class yc extends Ql {
    constructor(ue, ee, le) {
      super(ue), this.MappingSource = ee, this.MappingTarget = le, this.type = 2347385850;
    }
  }
  r.IfcMappedItem = yc;
  class m3 extends Qa {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Representations = he, this.RepresentedMaterial = ge, this.type = 2022407955;
    }
  }
  r.IfcMaterialDefinitionRepresentation = m3;
  class V1 extends J {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt), this.Material = ee, this.DynamicViscosity = le, this.YoungModulus = he, this.ShearModulus = ge, this.PoissonRatio = Xe, this.ThermalExpansionCoefficient = tt, this.CompressiveStrength = at, this.MaxAggregateSize = St, this.AdmixturesDescription = kt, this.Workability = On, this.ProtectivePoreRatio = Gr, this.WaterImpermeability = ys, this.type = 1430189142;
    }
  }
  r.IfcMechanicalConcreteMaterialProperties = V1;
  class Fc extends P0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 219451334;
    }
  }
  r.IfcObjectDefinition = Fc;
  class y3 extends Zi {
    constructor(ue, ee) {
      super(ue), this.RepeatFactor = ee, this.type = 2833995503;
    }
  }
  r.IfcOneDirectionRepeatFactor = y3;
  class HE extends d3 {
    constructor(ue, ee) {
      super(ue, ee), this.CfsFaces = ee, this.type = 2665983363;
    }
  }
  r.IfcOpenShell = HE;
  class W1 extends J0 {
    constructor(ue, ee, le) {
      super(ue, new Handle(0), new Handle(0)), this.EdgeElement = ee, this.Orientation = le, this.type = 1029017970;
    }
  }
  r.IfcOrientedEdge = W1;
  class f0 extends Pa {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.type = 2529465313;
    }
  }
  r.IfcParameterizedProfileDef = f0;
  class F3 extends cl {
    constructor(ue, ee) {
      super(ue), this.EdgeList = ee, this.type = 2519244187;
    }
  }
  r.IfcPath = F3;
  class z1 extends Zn {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.HasQuantities = he, this.Discrimination = ge, this.Quality = Xe, this.Usage = tt, this.type = 3021840470;
    }
  }
  r.IfcPhysicalComplexQuantity = z1;
  class Oi extends Kl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge), this.RepeatS = ee, this.RepeatT = le, this.TextureType = he, this.TextureTransform = ge, this.Width = Xe, this.Height = tt, this.ColourComponents = at, this.Pixel = St, this.type = 597895409;
    }
  }
  r.IfcPixelTexture = Oi;
  class Ac extends Zi {
    constructor(ue, ee) {
      super(ue), this.Location = ee, this.type = 2004835150;
    }
  }
  r.IfcPlacement = Ac;
  class L3 extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.SizeInX = ee, this.SizeInY = le, this.type = 1663979128;
    }
  }
  r.IfcPlanarExtent = L3;
  class vu extends Zi {
    constructor(ue) {
      super(ue), this.type = 2067069095;
    }
  }
  r.IfcPoint = vu;
  class N3 extends vu {
    constructor(ue, ee, le) {
      super(ue), this.BasisCurve = ee, this.PointParameter = le, this.type = 4022376103;
    }
  }
  r.IfcPointOnCurve = N3;
  class qE extends vu {
    constructor(ue, ee, le, he) {
      super(ue), this.BasisSurface = ee, this.PointParameterU = le, this.PointParameterV = he, this.type = 1423911732;
    }
  }
  r.IfcPointOnSurface = qE;
  class kE extends mc {
    constructor(ue, ee) {
      super(ue), this.Polygon = ee, this.type = 2924175390;
    }
  }
  r.IfcPolyLoop = kE;
  class $1 extends Rc {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.BaseSurface = ee, this.AgreementFlag = le, this.Position = he, this.PolygonalBoundary = ge, this.type = 2775532180;
    }
  }
  r.IfcPolygonalBoundedHalfSpace = $1;
  class Q1 extends Br {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 759155922;
    }
  }
  r.IfcPreDefinedColour = Q1;
  class K1 extends Br {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 2559016684;
    }
  }
  r.IfcPreDefinedCurveFont = K1;
  class J1 extends Do {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 433424934;
    }
  }
  r.IfcPreDefinedDimensionSymbol = J1;
  class tu extends Do {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 179317114;
    }
  }
  r.IfcPreDefinedPointMarkerSymbol = tu;
  class YE extends Qa {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Name = ee, this.Description = le, this.Representations = he, this.type = 673634403;
    }
  }
  r.IfcProductDefinitionShape = YE;
  class XE extends $0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.UpperBoundValue = he, this.LowerBoundValue = ge, this.Unit = Xe, this.type = 871118103;
    }
  }
  r.IfcPropertyBoundedValue = XE;
  class Z1 extends P0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 1680319473;
    }
  }
  r.IfcPropertyDefinition = Z1;
  class e4 extends $0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.EnumerationValues = he, this.EnumerationReference = ge, this.type = 4166981789;
    }
  }
  r.IfcPropertyEnumeratedValue = e4;
  class VE extends $0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.ListValues = he, this.Unit = ge, this.type = 2752243245;
    }
  }
  r.IfcPropertyListValue = VE;
  class WE extends $0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.UsageName = he, this.PropertyReference = ge, this.type = 941946838;
    }
  }
  r.IfcPropertyReferenceValue = WE;
  class qa extends Z1 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 3357820518;
    }
  }
  r.IfcPropertySetDefinition = qa;
  class zE extends $0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.NominalValue = he, this.Unit = ge, this.type = 3650150729;
    }
  }
  r.IfcPropertySingleValue = zE;
  class g3 extends $0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le), this.Name = ee, this.Description = le, this.DefiningValues = he, this.DefinedValues = ge, this.Expression = Xe, this.DefiningUnit = tt, this.DefinedUnit = at, this.type = 110355661;
    }
  }
  r.IfcPropertyTableValue = g3;
  class O3 extends f0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.XDim = ge, this.YDim = Xe, this.type = 3615266464;
    }
  }
  r.IfcRectangleProfileDef = O3;
  class $E extends D0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.Name = ee, this.Description = le, this.StartTime = he, this.EndTime = ge, this.TimeSeriesDataType = Xe, this.DataOrigin = tt, this.UserDefinedDataOrigin = at, this.Unit = St, this.TimeStep = kt, this.Values = On, this.type = 3413951693;
    }
  }
  r.IfcRegularTimeSeries = $E;
  class QE extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.DefinitionType = Xe, this.ReinforcementSectionDefinitions = tt, this.type = 3765753017;
    }
  }
  r.IfcReinforcementDefinitionProperties = QE;
  class gl extends P0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 478536968;
    }
  }
  r.IfcRelationship = gl;
  class t4 extends O3 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.XDim = ge, this.YDim = Xe, this.RoundingRadius = tt, this.type = 2778083089;
    }
  }
  r.IfcRoundedRectangleProfileDef = t4;
  class KE extends Zi {
    constructor(ue, ee, le, he) {
      super(ue), this.SpineCurve = ee, this.CrossSections = le, this.CrossSectionPositions = he, this.type = 1509187699;
    }
  }
  r.IfcSectionedSpine = KE;
  class JE extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.PredefinedType = Xe, this.UpperValue = tt, this.MostUsedValue = at, this.LowerValue = St, this.type = 2411513650;
    }
  }
  r.IfcServiceLifeFactor = JE;
  class ZE extends Zi {
    constructor(ue, ee) {
      super(ue), this.SbsmBoundary = ee, this.type = 4124623270;
    }
  }
  r.IfcShellBasedSurfaceModel = ZE;
  class e2 extends ll {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.SlippageX = le, this.SlippageY = he, this.SlippageZ = ge, this.type = 2609359061;
    }
  }
  r.IfcSlippageConnectionCondition = e2;
  class Il extends Zi {
    constructor(ue) {
      super(ue), this.type = 723233188;
    }
  }
  r.IfcSolidModel = Il;
  class n4 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.IsAttenuating = Xe, this.SoundScale = tt, this.SoundValues = at, this.type = 2485662743;
    }
  }
  r.IfcSoundProperties = n4;
  class t2 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.SoundLevelTimeSeries = Xe, this.Frequency = tt, this.SoundLevelSingleValue = at, this.type = 1202362311;
    }
  }
  r.IfcSoundValue = t2;
  class r2 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableValueRatio = Xe, this.ThermalLoadSource = tt, this.PropertySource = at, this.SourceDescription = St, this.MaximumValue = kt, this.MinimumValue = On, this.ThermalLoadTimeSeriesValues = Gr, this.UserDefinedThermalLoadSource = ys, this.UserDefinedPropertySource = Fs, this.ThermalLoadType = Xo, this.type = 390701378;
    }
  }
  r.IfcSpaceThermalLoadProperties = r2;
  class _0 extends d0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.LinearForceX = le, this.LinearForceY = he, this.LinearForceZ = ge, this.LinearMomentX = Xe, this.LinearMomentY = tt, this.LinearMomentZ = at, this.type = 1595516126;
    }
  }
  r.IfcStructuralLoadLinearForce = _0;
  class Lc extends d0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Name = ee, this.PlanarForceX = le, this.PlanarForceY = he, this.PlanarForceZ = ge, this.type = 2668620305;
    }
  }
  r.IfcStructuralLoadPlanarForce = Lc;
  class r4 extends d0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.DisplacementX = le, this.DisplacementY = he, this.DisplacementZ = ge, this.RotationalDisplacementRX = Xe, this.RotationalDisplacementRY = tt, this.RotationalDisplacementRZ = at, this.type = 2473145415;
    }
  }
  r.IfcStructuralLoadSingleDisplacement = r4;
  class s2 extends r4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.Name = ee, this.DisplacementX = le, this.DisplacementY = he, this.DisplacementZ = ge, this.RotationalDisplacementRX = Xe, this.RotationalDisplacementRY = tt, this.RotationalDisplacementRZ = at, this.Distortion = St, this.type = 1973038258;
    }
  }
  r.IfcStructuralLoadSingleDisplacementDistortion = s2;
  class Ol extends d0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee), this.Name = ee, this.ForceX = le, this.ForceY = he, this.ForceZ = ge, this.MomentX = Xe, this.MomentY = tt, this.MomentZ = at, this.type = 1597423693;
    }
  }
  r.IfcStructuralLoadSingleForce = Ol;
  class s4 extends Ol {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.Name = ee, this.ForceX = le, this.ForceY = he, this.ForceZ = ge, this.MomentX = Xe, this.MomentY = tt, this.MomentZ = at, this.WarpingMoment = St, this.type = 1190533807;
    }
  }
  r.IfcStructuralLoadSingleForceWarping = s4;
  class nu extends q1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0, Tl, _l, mu, yu, Fu, Au) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.ProfileName = ee, this.ProfileDefinition = le, this.PhysicalWeight = he, this.Perimeter = ge, this.MinimumPlateThickness = Xe, this.MaximumPlateThickness = tt, this.CrossSectionArea = at, this.TorsionalConstantX = St, this.MomentOfInertiaYZ = kt, this.MomentOfInertiaY = On, this.MomentOfInertiaZ = Gr, this.WarpingConstant = ys, this.ShearCentreZ = Fs, this.ShearCentreY = Xo, this.ShearDeformationAreaZ = ta, this.ShearDeformationAreaY = E0, this.MaximumSectionModulusY = I0, this.MinimumSectionModulusY = Tl, this.MaximumSectionModulusZ = _l, this.MinimumSectionModulusZ = mu, this.TorsionalSectionModulus = yu, this.CentreOfGravityInX = Fu, this.CentreOfGravityInY = Au, this.type = 3843319758;
    }
  }
  r.IfcStructuralProfileProperties = nu;
  class o4 extends nu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0, Tl, _l, mu, yu, Fu, Au, JI, ZI, ep, tp) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0, Tl, _l, mu, yu, Fu, Au), this.ProfileName = ee, this.ProfileDefinition = le, this.PhysicalWeight = he, this.Perimeter = ge, this.MinimumPlateThickness = Xe, this.MaximumPlateThickness = tt, this.CrossSectionArea = at, this.TorsionalConstantX = St, this.MomentOfInertiaYZ = kt, this.MomentOfInertiaY = On, this.MomentOfInertiaZ = Gr, this.WarpingConstant = ys, this.ShearCentreZ = Fs, this.ShearCentreY = Xo, this.ShearDeformationAreaZ = ta, this.ShearDeformationAreaY = E0, this.MaximumSectionModulusY = I0, this.MinimumSectionModulusY = Tl, this.MaximumSectionModulusZ = _l, this.MinimumSectionModulusZ = mu, this.TorsionalSectionModulus = yu, this.CentreOfGravityInX = Fu, this.CentreOfGravityInY = Au, this.ShearAreaZ = JI, this.ShearAreaY = ZI, this.PlasticShapeFactorY = ep, this.PlasticShapeFactorZ = tp, this.type = 3653947884;
    }
  }
  r.IfcStructuralSteelProfileProperties = o4;
  class o2 extends J0 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.EdgeStart = ee, this.EdgeEnd = le, this.ParentEdge = he, this.type = 2233826070;
    }
  }
  r.IfcSubedge = o2;
  class Bu extends Zi {
    constructor(ue) {
      super(ue), this.type = 2513912981;
    }
  }
  r.IfcSurface = Bu;
  class i2 extends j1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee), this.SurfaceColour = ee, this.Transparency = le, this.DiffuseColour = he, this.TransmissionColour = ge, this.DiffuseTransmissionColour = Xe, this.ReflectionColour = tt, this.SpecularColour = at, this.SpecularHighlight = St, this.ReflectanceMethod = kt, this.type = 1878645084;
    }
  }
  r.IfcSurfaceStyleRendering = i2;
  class Pl extends Il {
    constructor(ue, ee, le) {
      super(ue), this.SweptArea = ee, this.Position = le, this.type = 2247615214;
    }
  }
  r.IfcSweptAreaSolid = Pl;
  class Uu extends Il {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.Directrix = ee, this.Radius = le, this.InnerRadius = he, this.StartParam = ge, this.EndParam = Xe, this.type = 1260650574;
    }
  }
  r.IfcSweptDiskSolid = Uu;
  class ea extends Bu {
    constructor(ue, ee, le) {
      super(ue), this.SweptCurve = ee, this.Position = le, this.type = 230924584;
    }
  }
  r.IfcSweptSurface = ea;
  class a2 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Depth = ge, this.FlangeWidth = Xe, this.WebThickness = tt, this.FlangeThickness = at, this.FilletRadius = St, this.FlangeEdgeRadius = kt, this.WebEdgeRadius = On, this.WebSlope = Gr, this.FlangeSlope = ys, this.CentreOfGravityInY = Fs, this.type = 3071757647;
    }
  }
  r.IfcTShapeProfileDef = a2;
  class P3 extends Zl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.AnnotatedCurve = ge, this.type = 3028897424;
    }
  }
  r.IfcTerminatorSymbol = P3;
  class Nc extends Zi {
    constructor(ue, ee, le, he) {
      super(ue), this.Literal = ee, this.Placement = le, this.Path = he, this.type = 4282788508;
    }
  }
  r.IfcTextLiteral = Nc;
  class Hu extends Nc {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he), this.Literal = ee, this.Placement = le, this.Path = he, this.Extent = ge, this.BoxAlignment = Xe, this.type = 3124975700;
    }
  }
  r.IfcTextLiteralWithExtent = Hu;
  class l2 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.BottomXDim = ge, this.TopXDim = Xe, this.YDim = tt, this.TopXOffset = at, this.type = 2715220739;
    }
  }
  r.IfcTrapeziumProfileDef = l2;
  class gc extends y3 {
    constructor(ue, ee, le) {
      super(ue, ee), this.RepeatFactor = ee, this.SecondRepeatFactor = le, this.type = 1345879162;
    }
  }
  r.IfcTwoDirectionRepeatFactor = gc;
  class ru extends Fc {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.type = 1628702193;
    }
  }
  r.IfcTypeObject = ru;
  class qu extends ru {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.type = 2347495698;
    }
  }
  r.IfcTypeProduct = qu;
  class w3 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Depth = ge, this.FlangeWidth = Xe, this.WebThickness = tt, this.FlangeThickness = at, this.FilletRadius = St, this.EdgeRadius = kt, this.FlangeSlope = On, this.CentreOfGravityInX = Gr, this.type = 427810014;
    }
  }
  r.IfcUShapeProfileDef = w3;
  class u2 extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.Orientation = ee, this.Magnitude = le, this.type = 1417489154;
    }
  }
  r.IfcVector = u2;
  class ku extends mc {
    constructor(ue, ee) {
      super(ue), this.LoopVertex = ee, this.type = 2759199220;
    }
  }
  r.IfcVertexLoop = ku;
  class wl extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.LiningDepth = Xe, this.LiningThickness = tt, this.TransomThickness = at, this.MullionThickness = St, this.FirstTransomOffset = kt, this.SecondTransomOffset = On, this.FirstMullionOffset = Gr, this.SecondMullionOffset = ys, this.ShapeAspectStyle = Fs, this.type = 336235671;
    }
  }
  r.IfcWindowLiningProperties = wl;
  class c2 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.OperationType = Xe, this.PanelPosition = tt, this.FrameDepth = at, this.FrameThickness = St, this.ShapeAspectStyle = kt, this.type = 512836454;
    }
  }
  r.IfcWindowPanelProperties = c2;
  class E2 extends qu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ConstructionType = kt, this.OperationType = On, this.ParameterTakesPrecedence = Gr, this.Sizeable = ys, this.type = 1299126871;
    }
  }
  r.IfcWindowStyle = E2;
  class i4 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Depth = ge, this.FlangeWidth = Xe, this.WebThickness = tt, this.FlangeThickness = at, this.FilletRadius = St, this.EdgeRadius = kt, this.type = 2543172580;
    }
  }
  r.IfcZShapeProfileDef = i4;
  class D3 extends H0 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 3288037868;
    }
  }
  r.IfcAnnotationCurveOccurrence = D3;
  class I2 extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.OuterBoundary = ee, this.InnerBoundaries = le, this.type = 669184980;
    }
  }
  r.IfcAnnotationFillArea = I2;
  class p2 extends H0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.FillStyleTarget = ge, this.GlobalOrLocal = Xe, this.type = 2265737646;
    }
  }
  r.IfcAnnotationFillAreaOccurrence = p2;
  class Oc extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.Item = ee, this.TextureCoordinates = le, this.type = 1302238472;
    }
  }
  r.IfcAnnotationSurface = Oc;
  class d2 extends Ac {
    constructor(ue, ee, le) {
      super(ue, ee), this.Location = ee, this.Axis = le, this.type = 4261334040;
    }
  }
  r.IfcAxis1Placement = d2;
  class Dl extends Ac {
    constructor(ue, ee, le) {
      super(ue, ee), this.Location = ee, this.RefDirection = le, this.type = 3125803723;
    }
  }
  r.IfcAxis2Placement2D = Dl;
  class f2 extends Ac {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Location = ee, this.Axis = le, this.RefDirection = he, this.type = 2740243338;
    }
  }
  r.IfcAxis2Placement3D = f2;
  class su extends Zi {
    constructor(ue, ee, le, he) {
      super(ue), this.Operator = ee, this.FirstOperand = le, this.SecondOperand = he, this.type = 2736907675;
    }
  }
  r.IfcBooleanResult = su;
  class b3 extends Bu {
    constructor(ue) {
      super(ue), this.type = 4182860854;
    }
  }
  r.IfcBoundedSurface = b3;
  class C2 extends Zi {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Corner = ee, this.XDim = le, this.YDim = he, this.ZDim = ge, this.type = 2581212453;
    }
  }
  r.IfcBoundingBox = C2;
  class G3 extends Rc {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.BaseSurface = ee, this.AgreementFlag = le, this.Enclosure = he, this.type = 2713105998;
    }
  }
  r.IfcBoxedHalfSpace = G3;
  class h2 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Depth = ge, this.Width = Xe, this.WallThickness = tt, this.Girth = at, this.InternalFilletRadius = St, this.CentreOfGravityInX = kt, this.type = 2898889636;
    }
  }
  r.IfcCShapeProfileDef = h2;
  class a4 extends vu {
    constructor(ue, ee) {
      super(ue), this.Coordinates = ee, this.type = 1123145078;
    }
  }
  r.IfcCartesianPoint = a4;
  class j3 extends Zi {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.Axis1 = ee, this.Axis2 = le, this.LocalOrigin = he, this.Scale = ge, this.type = 59481748;
    }
  }
  r.IfcCartesianTransformationOperator = j3;
  class l4 extends j3 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.Axis1 = ee, this.Axis2 = le, this.LocalOrigin = he, this.Scale = ge, this.type = 3749851601;
    }
  }
  r.IfcCartesianTransformationOperator2D = l4;
  class bl extends l4 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.Axis1 = ee, this.Axis2 = le, this.LocalOrigin = he, this.Scale = ge, this.Scale2 = Xe, this.type = 3486308946;
    }
  }
  r.IfcCartesianTransformationOperator2DnonUniform = bl;
  class u4 extends j3 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.Axis1 = ee, this.Axis2 = le, this.LocalOrigin = he, this.Scale = ge, this.Axis3 = Xe, this.type = 3331915920;
    }
  }
  r.IfcCartesianTransformationOperator3D = u4;
  class Yu extends u4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.Axis1 = ee, this.Axis2 = le, this.LocalOrigin = he, this.Scale = ge, this.Axis3 = Xe, this.Scale2 = tt, this.Scale3 = at, this.type = 1416205885;
    }
  }
  r.IfcCartesianTransformationOperator3DnonUniform = Yu;
  class M3 extends f0 {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Radius = ge, this.type = 1383045692;
    }
  }
  r.IfcCircleProfileDef = M3;
  class S2 extends d3 {
    constructor(ue, ee) {
      super(ue, ee), this.CfsFaces = ee, this.type = 2205249479;
    }
  }
  r.IfcClosedShell = S2;
  class a0 extends Zi {
    constructor(ue, ee, le, he) {
      super(ue), this.Transition = ee, this.SameSense = le, this.ParentCurve = he, this.type = 2485617015;
    }
  }
  r.IfcCompositeCurveSegment = a0;
  class R2 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.OverallHeight = ge, this.BaseWidth2 = Xe, this.Radius = tt, this.HeadWidth = at, this.HeadDepth2 = St, this.HeadDepth3 = kt, this.WebThickness = On, this.BaseWidth4 = Gr, this.BaseDepth1 = ys, this.BaseDepth2 = Fs, this.BaseDepth3 = Xo, this.CentreOfGravityInY = ta, this.type = 4133800736;
    }
  }
  r.IfcCraneRailAShapeProfileDef = R2;
  class x3 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.OverallHeight = ge, this.HeadWidth = Xe, this.Radius = tt, this.HeadDepth2 = at, this.HeadDepth3 = St, this.WebThickness = kt, this.BaseDepth1 = On, this.BaseDepth2 = Gr, this.CentreOfGravityInY = ys, this.type = 194851669;
    }
  }
  r.IfcCraneRailFShapeProfileDef = x3;
  class Gl extends Zi {
    constructor(ue, ee) {
      super(ue), this.Position = ee, this.type = 2506170314;
    }
  }
  r.IfcCsgPrimitive3D = Gl;
  class Xu extends Il {
    constructor(ue, ee) {
      super(ue), this.TreeRootExpression = ee, this.type = 2147822146;
    }
  }
  r.IfcCsgSolid = Xu;
  class jl extends Zi {
    constructor(ue) {
      super(ue), this.type = 2601014836;
    }
  }
  r.IfcCurve = jl;
  class Vu extends b3 {
    constructor(ue, ee, le, he) {
      super(ue), this.BasisSurface = ee, this.OuterBoundary = le, this.InnerBoundaries = he, this.type = 2827736869;
    }
  }
  r.IfcCurveBoundedPlane = Vu;
  class Pc extends Zi {
    constructor(ue, ee, le) {
      super(ue), this.Definition = ee, this.Target = le, this.type = 693772133;
    }
  }
  r.IfcDefinedSymbol = Pc;
  class wc extends D3 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 606661476;
    }
  }
  r.IfcDimensionCurve = wc;
  class Wu extends P3 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.Item = ee, this.Styles = le, this.Name = he, this.AnnotatedCurve = ge, this.Role = Xe, this.type = 4054601972;
    }
  }
  r.IfcDimensionCurveTerminator = Wu;
  class c4 extends Zi {
    constructor(ue, ee) {
      super(ue), this.DirectionRatios = ee, this.type = 32440307;
    }
  }
  r.IfcDirection = c4;
  class T2 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.LiningDepth = Xe, this.LiningThickness = tt, this.ThresholdDepth = at, this.ThresholdThickness = St, this.TransomThickness = kt, this.TransomOffset = On, this.LiningOffset = Gr, this.ThresholdOffset = ys, this.CasingThickness = Fs, this.CasingDepth = Xo, this.ShapeAspectStyle = ta, this.type = 2963535650;
    }
  }
  r.IfcDoorLiningProperties = T2;
  class Dc extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.PanelDepth = Xe, this.PanelOperation = tt, this.PanelWidth = at, this.PanelPosition = St, this.ShapeAspectStyle = kt, this.type = 1714330368;
    }
  }
  r.IfcDoorPanelProperties = Dc;
  class bc extends qu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.OperationType = kt, this.ConstructionType = On, this.ParameterTakesPrecedence = Gr, this.Sizeable = ys, this.type = 526551008;
    }
  }
  r.IfcDoorStyle = bc;
  class Gc extends Zi {
    constructor(ue, ee) {
      super(ue), this.Contents = ee, this.type = 3073041342;
    }
  }
  r.IfcDraughtingCallout = Gc;
  class _2 extends Q1 {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 445594917;
    }
  }
  r.IfcDraughtingPreDefinedColour = _2;
  class m2 extends K1 {
    constructor(ue, ee) {
      super(ue, ee), this.Name = ee, this.type = 4006246654;
    }
  }
  r.IfcDraughtingPreDefinedCurveFont = m2;
  class v3 extends mc {
    constructor(ue, ee) {
      super(ue), this.EdgeList = ee, this.type = 1472233963;
    }
  }
  r.IfcEdgeLoop = v3;
  class B3 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.MethodOfMeasurement = Xe, this.Quantities = tt, this.type = 1883228015;
    }
  }
  r.IfcElementQuantity = B3;
  class Ml extends qu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 339256511;
    }
  }
  r.IfcElementType = Ml;
  class zu extends Bu {
    constructor(ue, ee) {
      super(ue), this.Position = ee, this.type = 2777663545;
    }
  }
  r.IfcElementarySurface = zu;
  class U3 extends f0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.SemiAxis1 = ge, this.SemiAxis2 = Xe, this.type = 2835456948;
    }
  }
  r.IfcEllipseProfileDef = U3;
  class jc extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.EnergySequence = Xe, this.UserDefinedEnergySequence = tt, this.type = 80994333;
    }
  }
  r.IfcEnergyProperties = jc;
  class xl extends Pl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.SweptArea = ee, this.Position = le, this.ExtrudedDirection = he, this.Depth = ge, this.type = 477187591;
    }
  }
  r.IfcExtrudedAreaSolid = xl;
  class y2 extends Zi {
    constructor(ue, ee) {
      super(ue), this.FbsmFaces = ee, this.type = 2047409740;
    }
  }
  r.IfcFaceBasedSurfaceModel = y2;
  class F2 extends Zi {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.HatchLineAppearance = ee, this.StartOfNextHatchLine = le, this.PointOfReferenceHatchLine = he, this.PatternStart = ge, this.HatchLineAngle = Xe, this.type = 374418227;
    }
  }
  r.IfcFillAreaStyleHatching = F2;
  class vl extends Zi {
    constructor(ue, ee) {
      super(ue), this.Symbol = ee, this.type = 4203026998;
    }
  }
  r.IfcFillAreaStyleTileSymbolWithStyle = vl;
  class L2 extends Zi {
    constructor(ue, ee, le, he) {
      super(ue), this.TilingPattern = ee, this.Tiles = le, this.TilingScale = he, this.type = 315944413;
    }
  }
  r.IfcFillAreaStyleTiles = L2;
  class H3 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0, Tl, _l) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.PropertySource = Xe, this.FlowConditionTimeSeries = tt, this.VelocityTimeSeries = at, this.FlowrateTimeSeries = St, this.Fluid = kt, this.PressureTimeSeries = On, this.UserDefinedPropertySource = Gr, this.TemperatureSingleValue = ys, this.WetBulbTemperatureSingleValue = Fs, this.WetBulbTemperatureTimeSeries = Xo, this.TemperatureTimeSeries = ta, this.FlowrateSingleValue = E0, this.FlowConditionSingleValue = I0, this.VelocitySingleValue = Tl, this.PressureSingleValue = _l, this.type = 3455213021;
    }
  }
  r.IfcFluidFlowProperties = H3;
  class q3 extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 4238390223;
    }
  }
  r.IfcFurnishingElementType = q3;
  class N2 extends q3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.AssemblyPlace = On, this.type = 1268542332;
    }
  }
  r.IfcFurnitureType = N2;
  class k3 extends k1 {
    constructor(ue, ee) {
      super(ue, ee), this.Elements = ee, this.type = 987898635;
    }
  }
  r.IfcGeometricCurveSet = k3;
  class Y3 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.OverallWidth = ge, this.OverallDepth = Xe, this.WebThickness = tt, this.FlangeThickness = at, this.FilletRadius = St, this.type = 1484403080;
    }
  }
  r.IfcIShapeProfileDef = Y3;
  class g2 extends f0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Depth = ge, this.Width = Xe, this.Thickness = tt, this.FilletRadius = at, this.EdgeRadius = St, this.LegSlope = kt, this.CentreOfGravityInX = On, this.CentreOfGravityInY = Gr, this.type = 572779678;
    }
  }
  r.IfcLShapeProfileDef = g2;
  class Mc extends jl {
    constructor(ue, ee, le) {
      super(ue), this.Pnt = ee, this.Dir = le, this.type = 1281925730;
    }
  }
  r.IfcLine = Mc;
  class X3 extends Il {
    constructor(ue, ee) {
      super(ue), this.Outer = ee, this.type = 1425443689;
    }
  }
  r.IfcManifoldSolidBrep = X3;
  class i0 extends Fc {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 3888040117;
    }
  }
  r.IfcObject = i0;
  class O2 extends jl {
    constructor(ue, ee, le, he) {
      super(ue), this.BasisCurve = ee, this.Distance = le, this.SelfIntersect = he, this.type = 3388369263;
    }
  }
  r.IfcOffsetCurve2D = O2;
  class ou extends jl {
    constructor(ue, ee, le, he, ge) {
      super(ue), this.BasisCurve = ee, this.Distance = le, this.SelfIntersect = he, this.RefDirection = ge, this.type = 3505215534;
    }
  }
  r.IfcOffsetCurve3D = ou;
  class P2 extends qa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.OperationType = Xe, this.PanelPosition = tt, this.FrameDepth = at, this.FrameThickness = St, this.ShapeAspectStyle = kt, this.type = 3566463478;
    }
  }
  r.IfcPermeableCoveringProperties = P2;
  class E4 extends L3 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.SizeInX = ee, this.SizeInY = le, this.Placement = he, this.type = 603570806;
    }
  }
  r.IfcPlanarBox = E4;
  class pl extends zu {
    constructor(ue, ee) {
      super(ue, ee), this.Position = ee, this.type = 220341763;
    }
  }
  r.IfcPlane = pl;
  class $u extends i0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 2945172077;
    }
  }
  r.IfcProcess = $u;
  class q0 extends i0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.type = 4208778838;
    }
  }
  r.IfcProduct = q0;
  class iu extends i0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.LongName = tt, this.Phase = at, this.RepresentationContexts = St, this.UnitsInContext = kt, this.type = 103090709;
    }
  }
  r.IfcProject = iu;
  class w2 extends D3 {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Item = ee, this.Styles = le, this.Name = he, this.type = 4194566429;
    }
  }
  r.IfcProjectionCurve = w2;
  class m0 extends qa {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.HasProperties = Xe, this.type = 1451395588;
    }
  }
  r.IfcPropertySet = m0;
  class D2 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.ProxyType = St, this.Tag = kt, this.type = 3219374653;
    }
  }
  r.IfcProxy = D2;
  class xc extends O3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.XDim = ge, this.YDim = Xe, this.WallThickness = tt, this.InnerFilletRadius = at, this.OuterFilletRadius = St, this.type = 2770003689;
    }
  }
  r.IfcRectangleHollowProfileDef = xc;
  class I4 extends Gl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Position = ee, this.XLength = le, this.YLength = he, this.Height = ge, this.type = 2798486643;
    }
  }
  r.IfcRectangularPyramid = I4;
  class b2 extends b3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue), this.BasisSurface = ee, this.U1 = le, this.V1 = he, this.U2 = ge, this.V2 = Xe, this.Usense = tt, this.Vsense = at, this.type = 3454111270;
    }
  }
  r.IfcRectangularTrimmedSurface = b2;
  class Z0 extends gl {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.type = 3939117080;
    }
  }
  r.IfcRelAssigns = Z0;
  class p4 extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingActor = at, this.ActingRole = St, this.type = 1683148259;
    }
  }
  r.IfcRelAssignsToActor = p4;
  class l0 extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingControl = at, this.type = 2495723537;
    }
  }
  r.IfcRelAssignsToControl = l0;
  class au extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingGroup = at, this.type = 1307041759;
    }
  }
  r.IfcRelAssignsToGroup = au;
  class G2 extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingProcess = at, this.QuantityInProcess = St, this.type = 4278684876;
    }
  }
  r.IfcRelAssignsToProcess = G2;
  class j2 extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingProduct = at, this.type = 2857406711;
    }
  }
  r.IfcRelAssignsToProduct = j2;
  class d4 extends l0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingControl = at, this.type = 3372526763;
    }
  }
  r.IfcRelAssignsToProjectOrder = d4;
  class vc extends Z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingResource = at, this.type = 205026976;
    }
  }
  r.IfcRelAssignsToResource = vc;
  class y0 extends gl {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.type = 1865459582;
    }
  }
  r.IfcRelAssociates = y0;
  class V3 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingAppliedValue = tt, this.type = 1327628568;
    }
  }
  r.IfcRelAssociatesAppliedValue = V3;
  class f4 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingApproval = tt, this.type = 4095574036;
    }
  }
  r.IfcRelAssociatesApproval = f4;
  class M2 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingClassification = tt, this.type = 919958153;
    }
  }
  r.IfcRelAssociatesClassification = M2;
  class W3 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.Intent = tt, this.RelatingConstraint = at, this.type = 2728634034;
    }
  }
  r.IfcRelAssociatesConstraint = W3;
  class x2 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingDocument = tt, this.type = 982818633;
    }
  }
  r.IfcRelAssociatesDocument = x2;
  class v2 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingLibrary = tt, this.type = 3840914261;
    }
  }
  r.IfcRelAssociatesLibrary = v2;
  class B2 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingMaterial = tt, this.type = 2655215786;
    }
  }
  r.IfcRelAssociatesMaterial = B2;
  class U2 extends y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingProfileProperties = tt, this.ProfileSectionLocation = at, this.ProfileOrientation = St, this.type = 2851387026;
    }
  }
  r.IfcRelAssociatesProfileProperties = U2;
  class Ma extends gl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.type = 826625072;
    }
  }
  r.IfcRelConnects = Ma;
  class z3 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ConnectionGeometry = Xe, this.RelatingElement = tt, this.RelatedElement = at, this.type = 1204542856;
    }
  }
  r.IfcRelConnectsElements = z3;
  class H2 extends z3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ConnectionGeometry = Xe, this.RelatingElement = tt, this.RelatedElement = at, this.RelatingPriorities = St, this.RelatedPriorities = kt, this.RelatedConnectionType = On, this.RelatingConnectionType = Gr, this.type = 3945020480;
    }
  }
  r.IfcRelConnectsPathElements = H2;
  class q2 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingPort = Xe, this.RelatedElement = tt, this.type = 4201705270;
    }
  }
  r.IfcRelConnectsPortToElement = q2;
  class k2 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingPort = Xe, this.RelatedPort = tt, this.RealizingElement = at, this.type = 3190031847;
    }
  }
  r.IfcRelConnectsPorts = k2;
  class Bc extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingElement = Xe, this.RelatedStructuralActivity = tt, this.type = 2127690289;
    }
  }
  r.IfcRelConnectsStructuralActivity = Bc;
  class G0 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingElement = Xe, this.RelatedStructuralMember = tt, this.type = 3912681535;
    }
  }
  r.IfcRelConnectsStructuralElement = G0;
  class C4 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingStructuralMember = Xe, this.RelatedStructuralConnection = tt, this.AppliedCondition = at, this.AdditionalConditions = St, this.SupportedLength = kt, this.ConditionCoordinateSystem = On, this.type = 1638771189;
    }
  }
  r.IfcRelConnectsStructuralMember = C4;
  class Y2 extends C4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingStructuralMember = Xe, this.RelatedStructuralConnection = tt, this.AppliedCondition = at, this.AdditionalConditions = St, this.SupportedLength = kt, this.ConditionCoordinateSystem = On, this.ConnectionConstraint = Gr, this.type = 504942748;
    }
  }
  r.IfcRelConnectsWithEccentricity = Y2;
  class X2 extends z3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ConnectionGeometry = Xe, this.RelatingElement = tt, this.RelatedElement = at, this.RealizingElements = St, this.ConnectionType = kt, this.type = 3678494232;
    }
  }
  r.IfcRelConnectsWithRealizingElements = X2;
  class V2 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedElements = Xe, this.RelatingStructure = tt, this.type = 3242617779;
    }
  }
  r.IfcRelContainedInSpatialStructure = V2;
  class $3 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingBuildingElement = Xe, this.RelatedCoverings = tt, this.type = 886880790;
    }
  }
  r.IfcRelCoversBldgElements = $3;
  class h4 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedSpace = Xe, this.RelatedCoverings = tt, this.type = 2802773753;
    }
  }
  r.IfcRelCoversSpaces = h4;
  class Uc extends gl {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingObject = Xe, this.RelatedObjects = tt, this.type = 2551354335;
    }
  }
  r.IfcRelDecomposes = Uc;
  class j0 extends gl {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.type = 693640335;
    }
  }
  r.IfcRelDefines = j0;
  class Q3 extends j0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingPropertyDefinition = tt, this.type = 4186316022;
    }
  }
  r.IfcRelDefinesByProperties = Q3;
  class Hc extends j0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingType = tt, this.type = 781010003;
    }
  }
  r.IfcRelDefinesByType = Hc;
  class k0 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingOpeningElement = Xe, this.RelatedBuildingElement = tt, this.type = 3940055652;
    }
  }
  r.IfcRelFillsElement = k0;
  class W2 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedControlElements = Xe, this.RelatingFlowElement = tt, this.type = 279856033;
    }
  }
  r.IfcRelFlowControlElements = W2;
  class S4 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.DailyInteraction = Xe, this.ImportanceRating = tt, this.LocationOfInteraction = at, this.RelatedSpaceProgram = St, this.RelatingSpaceProgram = kt, this.type = 4189434867;
    }
  }
  r.IfcRelInteractionRequirements = S4;
  class z2 extends Uc {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingObject = Xe, this.RelatedObjects = tt, this.type = 3268803585;
    }
  }
  r.IfcRelNests = z2;
  class $2 extends p4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingActor = at, this.ActingRole = St, this.type = 2051452291;
    }
  }
  r.IfcRelOccupiesSpaces = $2;
  class Q2 extends Q3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatingPropertyDefinition = tt, this.OverridingProperties = at, this.type = 202636808;
    }
  }
  r.IfcRelOverridesProperties = Q2;
  class R4 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingElement = Xe, this.RelatedFeatureElement = tt, this.type = 750771296;
    }
  }
  r.IfcRelProjectsElement = R4;
  class Bl extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedElements = Xe, this.RelatingStructure = tt, this.type = 1245217292;
    }
  }
  r.IfcRelReferencedInSpatialStructure = Bl;
  class K3 extends l0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingControl = at, this.type = 1058617721;
    }
  }
  r.IfcRelSchedulesCostItems = K3;
  class K2 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingProcess = Xe, this.RelatedProcess = tt, this.TimeLag = at, this.SequenceType = St, this.type = 4122056220;
    }
  }
  r.IfcRelSequence = K2;
  class lu extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingSystem = Xe, this.RelatedBuildings = tt, this.type = 366585022;
    }
  }
  r.IfcRelServicesBuildings = lu;
  class J3 extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingSpace = Xe, this.RelatedBuildingElement = tt, this.ConnectionGeometry = at, this.PhysicalOrVirtualBoundary = St, this.InternalOrExternalBoundary = kt, this.type = 3451746338;
    }
  }
  r.IfcRelSpaceBoundary = J3;
  class el extends Ma {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingBuildingElement = Xe, this.RelatedOpeningElement = tt, this.type = 1401173127;
    }
  }
  r.IfcRelVoidsElement = el;
  class T4 extends i0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 2914609552;
    }
  }
  r.IfcResource = T4;
  class J2 extends Pl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.SweptArea = ee, this.Position = le, this.Axis = he, this.Angle = ge, this.type = 1856042241;
    }
  }
  r.IfcRevolvedAreaSolid = J2;
  class Z2 extends Gl {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Position = ee, this.Height = le, this.BottomRadius = he, this.type = 4158566097;
    }
  }
  r.IfcRightCircularCone = Z2;
  class e6 extends Gl {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Position = ee, this.Height = le, this.Radius = he, this.type = 3626867408;
    }
  }
  r.IfcRightCircularCylinder = e6;
  class C0 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.LongName = St, this.CompositionType = kt, this.type = 2706606064;
    }
  }
  r.IfcSpatialStructureElement = C0;
  class _4 extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3893378262;
    }
  }
  r.IfcSpatialStructureElementType = _4;
  class t6 extends Gl {
    constructor(ue, ee, le) {
      super(ue, ee), this.Position = ee, this.Radius = le, this.type = 451544542;
    }
  }
  r.IfcSphere = t6;
  class F0 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.type = 3544373492;
    }
  }
  r.IfcStructuralActivity = F0;
  class Ul extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.type = 3136571912;
    }
  }
  r.IfcStructuralItem = Ul;
  class Z3 extends Ul {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.type = 530289379;
    }
  }
  r.IfcStructuralMember = Z3;
  class m4 extends F0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.type = 3689010777;
    }
  }
  r.IfcStructuralReaction = m4;
  class e1 extends Z3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.PredefinedType = St, this.Thickness = kt, this.type = 3979015343;
    }
  }
  r.IfcStructuralSurfaceMember = e1;
  class Hl extends e1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.PredefinedType = St, this.Thickness = kt, this.SubsequentThickness = On, this.VaryingThicknessLocation = Gr, this.type = 2218152070;
    }
  }
  r.IfcStructuralSurfaceMemberVarying = Hl;
  class n6 extends Gc {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 4070609034;
    }
  }
  r.IfcStructuredDimensionCallout = n6;
  class r6 extends Pl {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le), this.SweptArea = ee, this.Position = le, this.Directrix = he, this.StartParam = ge, this.EndParam = Xe, this.ReferenceSurface = tt, this.type = 2028607225;
    }
  }
  r.IfcSurfaceCurveSweptAreaSolid = r6;
  class s6 extends ea {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee, le), this.SweptCurve = ee, this.Position = le, this.ExtrudedDirection = he, this.Depth = ge, this.type = 2809605785;
    }
  }
  r.IfcSurfaceOfLinearExtrusion = s6;
  class y4 extends ea {
    constructor(ue, ee, le, he) {
      super(ue, ee, le), this.SweptCurve = ee, this.Position = le, this.AxisPosition = he, this.type = 4124788165;
    }
  }
  r.IfcSurfaceOfRevolution = y4;
  class t1 extends q3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 1580310250;
    }
  }
  r.IfcSystemFurnitureElementType = t1;
  class r1 extends $u {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TaskId = tt, this.Status = at, this.WorkMethod = St, this.IsMilestone = kt, this.Priority = On, this.type = 3473067441;
    }
  }
  r.IfcTask = r1;
  class e0 extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2097647324;
    }
  }
  r.IfcTransportElementType = e0;
  class qc extends i0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TheActor = tt, this.type = 2296667514;
    }
  }
  r.IfcActor = qc;
  class o6 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.type = 1674181508;
    }
  }
  r.IfcAnnotation = o6;
  class F4 extends Y3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.OverallWidth = ge, this.OverallDepth = Xe, this.WebThickness = tt, this.FlangeThickness = at, this.FilletRadius = St, this.TopFlangeWidth = kt, this.TopFlangeThickness = On, this.TopFlangeFilletRadius = Gr, this.CentreOfGravityInY = ys, this.type = 3207858831;
    }
  }
  r.IfcAsymmetricIShapeProfileDef = F4;
  class i6 extends Gl {
    constructor(ue, ee, le, he, ge) {
      super(ue, ee), this.Position = ee, this.XLength = le, this.YLength = he, this.ZLength = ge, this.type = 1334484129;
    }
  }
  r.IfcBlock = i6;
  class a6 extends su {
    constructor(ue, ee, le, he) {
      super(ue, ee, le, he), this.Operator = ee, this.FirstOperand = le, this.SecondOperand = he, this.type = 3649129432;
    }
  }
  r.IfcBooleanClippingResult = a6;
  class uu extends jl {
    constructor(ue) {
      super(ue), this.type = 1260505505;
    }
  }
  r.IfcBoundedCurve = uu;
  class l6 extends C0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.LongName = St, this.CompositionType = kt, this.ElevationOfRefHeight = On, this.ElevationOfTerrain = Gr, this.BuildingAddress = ys, this.type = 4031249490;
    }
  }
  r.IfcBuilding = l6;
  class h0 extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 1950629157;
    }
  }
  r.IfcBuildingElementType = h0;
  class s1 extends C0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.LongName = St, this.CompositionType = kt, this.Elevation = On, this.type = 3124254112;
    }
  }
  r.IfcBuildingStorey = s1;
  class ql extends M3 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge), this.ProfileType = ee, this.ProfileName = le, this.Position = he, this.Radius = ge, this.WallThickness = Xe, this.type = 2937912522;
    }
  }
  r.IfcCircleHollowProfileDef = ql;
  class kc extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 300633059;
    }
  }
  r.IfcColumnType = kc;
  class L4 extends uu {
    constructor(ue, ee, le) {
      super(ue), this.Segments = ee, this.SelfIntersect = le, this.type = 3732776249;
    }
  }
  r.IfcCompositeCurve = L4;
  class kl extends jl {
    constructor(ue, ee) {
      super(ue), this.Position = ee, this.type = 2510884976;
    }
  }
  r.IfcConic = kl;
  class M0 extends T4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.type = 2559216714;
    }
  }
  r.IfcConstructionResource = M0;
  class t0 extends i0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 3293443760;
    }
  }
  r.IfcControl = t0;
  class u6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 3895139033;
    }
  }
  r.IfcCostItem = u6;
  class c6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.SubmittedBy = tt, this.PreparedBy = at, this.SubmittedOn = St, this.Status = kt, this.TargetUsers = On, this.UpdateDate = Gr, this.ID = ys, this.PredefinedType = Fs, this.type = 1419761937;
    }
  }
  r.IfcCostSchedule = c6;
  class E6 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1916426348;
    }
  }
  r.IfcCoveringType = E6;
  class N4 extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.type = 3295246426;
    }
  }
  r.IfcCrewResource = N4;
  class g4 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1457835157;
    }
  }
  r.IfcCurtainWallType = g4;
  class x0 extends Gc {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 681481545;
    }
  }
  r.IfcDimensionCurveDirectedCallout = x0;
  class o1 extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3256556792;
    }
  }
  r.IfcDistributionElementType = o1;
  class S0 extends o1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3849074793;
    }
  }
  r.IfcDistributionFlowElementType = S0;
  class tl extends jc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.EnergySequence = Xe, this.UserDefinedEnergySequence = tt, this.ElectricCurrentType = at, this.InputVoltage = St, this.InputFrequency = kt, this.FullLoadCurrent = On, this.MinimumCircuitCurrent = Gr, this.MaximumPowerInput = ys, this.RatedPowerInput = Fs, this.InputPhase = Xo, this.type = 360485395;
    }
  }
  r.IfcElectricalBaseProperties = tl;
  class v0 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1758889154;
    }
  }
  r.IfcElement = v0;
  class I6 extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.AssemblyPlace = kt, this.PredefinedType = On, this.type = 4123344466;
    }
  }
  r.IfcElementAssembly = I6;
  class Yc extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1623761950;
    }
  }
  r.IfcElementComponent = Yc;
  class Xc extends Ml {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2590856083;
    }
  }
  r.IfcElementComponentType = Xc;
  class p6 extends kl {
    constructor(ue, ee, le, he) {
      super(ue, ee), this.Position = ee, this.SemiAxis1 = le, this.SemiAxis2 = he, this.type = 1704287377;
    }
  }
  r.IfcEllipse = p6;
  class ka extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2107101300;
    }
  }
  r.IfcEnergyConversionDeviceType = ka;
  class d6 extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1962604670;
    }
  }
  r.IfcEquipmentElement = d6;
  class O4 extends t0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 3272907226;
    }
  }
  r.IfcEquipmentStandard = O4;
  class P4 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3174744832;
    }
  }
  r.IfcEvaporativeCoolerType = P4;
  class f6 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3390157468;
    }
  }
  r.IfcEvaporatorType = f6;
  class i1 extends X3 {
    constructor(ue, ee) {
      super(ue, ee), this.Outer = ee, this.type = 807026263;
    }
  }
  r.IfcFacetedBrep = i1;
  class C6 extends X3 {
    constructor(ue, ee, le) {
      super(ue, ee), this.Outer = ee, this.Voids = le, this.type = 3737207727;
    }
  }
  r.IfcFacetedBrepWithVoids = C6;
  class w4 extends Yc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 647756555;
    }
  }
  r.IfcFastener = w4;
  class Qu extends Xc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2489546625;
    }
  }
  r.IfcFastenerType = Qu;
  class Ku extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2827207264;
    }
  }
  r.IfcFeatureElement = Ku;
  class A0 extends Ku {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2143335405;
    }
  }
  r.IfcFeatureElementAddition = A0;
  class Vc extends Ku {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1287392070;
    }
  }
  r.IfcFeatureElementSubtraction = Vc;
  class dl extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3907093117;
    }
  }
  r.IfcFlowControllerType = dl;
  class cu extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3198132628;
    }
  }
  r.IfcFlowFittingType = cu;
  class h6 extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3815607619;
    }
  }
  r.IfcFlowMeterType = h6;
  class Wc extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 1482959167;
    }
  }
  r.IfcFlowMovingDeviceType = Wc;
  class Yl extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 1834744321;
    }
  }
  r.IfcFlowSegmentType = Yl;
  class Ju extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 1339347760;
    }
  }
  r.IfcFlowStorageDeviceType = Ju;
  class wa extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2297155007;
    }
  }
  r.IfcFlowTerminalType = wa;
  class Eu extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 3009222698;
    }
  }
  r.IfcFlowTreatmentDeviceType = Eu;
  class D4 extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 263784265;
    }
  }
  r.IfcFurnishingElement = D4;
  class S6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 814719939;
    }
  }
  r.IfcFurnitureStandard = S6;
  class R6 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 200128114;
    }
  }
  r.IfcGasTerminalType = R6;
  class T6 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.UAxes = St, this.VAxes = kt, this.WAxes = On, this.type = 3009204131;
    }
  }
  r.IfcGrid = T6;
  class Y0 extends i0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 2706460486;
    }
  }
  r.IfcGroup = Y0;
  class _6 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1251058090;
    }
  }
  r.IfcHeatExchangerType = _6;
  class Ka extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1806887404;
    }
  }
  r.IfcHumidifierType = Ka;
  class a1 extends Y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.InventoryType = tt, this.Jurisdiction = at, this.ResponsiblePersons = St, this.LastUpdateDate = kt, this.CurrentValue = On, this.OriginalValue = Gr, this.type = 2391368822;
    }
  }
  r.IfcInventory = a1;
  class m6 extends cu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 4288270099;
    }
  }
  r.IfcJunctionBoxType = m6;
  class y6 extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.SkillSet = On, this.type = 3827777499;
    }
  }
  r.IfcLaborResource = y6;
  class F6 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1051575348;
    }
  }
  r.IfcLampType = F6;
  class l1 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1161773419;
    }
  }
  r.IfcLightFixtureType = l1;
  class b4 extends x0 {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 2506943328;
    }
  }
  r.IfcLinearDimension = b4;
  class A6 extends w4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.NominalDiameter = kt, this.NominalLength = On, this.type = 377706215;
    }
  }
  r.IfcMechanicalFastener = A6;
  class L6 extends Qu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2108223431;
    }
  }
  r.IfcMechanicalFastenerType = L6;
  class N6 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3181161470;
    }
  }
  r.IfcMemberType = N6;
  class g6 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 977012517;
    }
  }
  r.IfcMotorConnectionType = g6;
  class G4 extends r1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TaskId = tt, this.Status = at, this.WorkMethod = St, this.IsMilestone = kt, this.Priority = On, this.MoveFrom = Gr, this.MoveTo = ys, this.PunchList = Fs, this.type = 1916936684;
    }
  }
  r.IfcMove = G4;
  class j4 extends qc {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TheActor = tt, this.PredefinedType = at, this.type = 4143007308;
    }
  }
  r.IfcOccupant = j4;
  class Iu extends Vc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3588315303;
    }
  }
  r.IfcOpeningElement = Iu;
  class Zu extends r1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TaskId = tt, this.Status = at, this.WorkMethod = St, this.IsMilestone = kt, this.Priority = On, this.ActionID = Gr, this.type = 3425660407;
    }
  }
  r.IfcOrderAction = Zu;
  class M4 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2837617999;
    }
  }
  r.IfcOutletType = M4;
  class x4 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.LifeCyclePhase = tt, this.type = 2382730787;
    }
  }
  r.IfcPerformanceHistory = x4;
  class O6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.PermitID = tt, this.type = 3327091369;
    }
  }
  r.IfcPermit = O6;
  class P6 extends cu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 804291784;
    }
  }
  r.IfcPipeFittingType = P6;
  class pu extends Yl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 4231323485;
    }
  }
  r.IfcPipeSegmentType = pu;
  class w6 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 4017108033;
    }
  }
  r.IfcPlateType = w6;
  class ya extends uu {
    constructor(ue, ee) {
      super(ue), this.Points = ee, this.type = 3724593414;
    }
  }
  r.IfcPolyline = ya;
  class v4 extends q0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.type = 3740093272;
    }
  }
  r.IfcPort = v4;
  class D6 extends $u {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ProcedureID = tt, this.ProcedureType = at, this.UserDefinedProcedureType = St, this.type = 2744685151;
    }
  }
  r.IfcProcedure = D6;
  class b6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ID = tt, this.PredefinedType = at, this.Status = St, this.type = 2904328755;
    }
  }
  r.IfcProjectOrder = b6;
  class G6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.Records = tt, this.PredefinedType = at, this.type = 3642467123;
    }
  }
  r.IfcProjectOrderRecord = G6;
  class j6 extends A0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3651124850;
    }
  }
  r.IfcProjectionElement = j6;
  class M6 extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1842657554;
    }
  }
  r.IfcProtectiveDeviceType = M6;
  class u1 extends Wc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2250791053;
    }
  }
  r.IfcPumpType = u1;
  class c1 extends x0 {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 3248260540;
    }
  }
  r.IfcRadiusDimension = c1;
  class E1 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2893384427;
    }
  }
  r.IfcRailingType = E1;
  class x6 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2324767716;
    }
  }
  r.IfcRampFlightType = x6;
  class v6 extends Uc {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe, tt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatingObject = Xe, this.RelatedObjects = tt, this.type = 160246688;
    }
  }
  r.IfcRelAggregates = v6;
  class B4 extends l0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.RelatedObjects = Xe, this.RelatedObjectsType = tt, this.RelatingControl = at, this.TimeForTask = St, this.type = 2863920197;
    }
  }
  r.IfcRelAssignsTasks = B4;
  class fl extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1768891740;
    }
  }
  r.IfcSanitaryTerminalType = fl;
  class nl extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0, Tl, _l, mu, yu, Fu, Au) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ActualStart = tt, this.EarlyStart = at, this.LateStart = St, this.ScheduleStart = kt, this.ActualFinish = On, this.EarlyFinish = Gr, this.LateFinish = ys, this.ScheduleFinish = Fs, this.ScheduleDuration = Xo, this.ActualDuration = ta, this.RemainingTime = E0, this.FreeFloat = I0, this.TotalFloat = Tl, this.IsCritical = _l, this.StatusTime = mu, this.StartFloat = yu, this.FinishFloat = Fu, this.Completion = Au, this.type = 3517283431;
    }
  }
  r.IfcScheduleTimeControl = nl;
  class B6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ServiceLifeType = tt, this.ServiceLifeDuration = at, this.type = 4105383287;
    }
  }
  r.IfcServiceLife = B6;
  class U6 extends C0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.LongName = St, this.CompositionType = kt, this.RefLatitude = On, this.RefLongitude = Gr, this.RefElevation = ys, this.LandTitleNumber = Fs, this.SiteAddress = Xo, this.type = 4097777520;
    }
  }
  r.IfcSite = U6;
  class U4 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2533589738;
    }
  }
  r.IfcSlabType = U4;
  class H6 extends C0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.LongName = St, this.CompositionType = kt, this.InteriorOrExteriorSpace = On, this.ElevationWithFlooring = Gr, this.type = 3856911033;
    }
  }
  r.IfcSpace = H6;
  class q6 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1305183839;
    }
  }
  r.IfcSpaceHeaterType = q6;
  class k6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.SpaceProgramIdentifier = tt, this.MaxRequiredArea = at, this.MinRequiredArea = St, this.RequestedLocation = kt, this.StandardRequiredArea = On, this.type = 652456506;
    }
  }
  r.IfcSpaceProgram = k6;
  class du extends _4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3812236995;
    }
  }
  r.IfcSpaceType = du;
  class L0 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3112655638;
    }
  }
  r.IfcStackTerminalType = L0;
  class fu extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1039846685;
    }
  }
  r.IfcStairFlightType = fu;
  class tc extends F0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.type = 682877961;
    }
  }
  r.IfcStructuralAction = tc;
  class zc extends Ul {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedCondition = St, this.type = 1179482911;
    }
  }
  r.IfcStructuralConnection = zc;
  class Y6 extends zc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedCondition = St, this.type = 4243806635;
    }
  }
  r.IfcStructuralCurveConnection = Y6;
  class H4 extends Z3 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.PredefinedType = St, this.type = 214636428;
    }
  }
  r.IfcStructuralCurveMember = H4;
  class B0 extends H4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.PredefinedType = St, this.type = 2445595289;
    }
  }
  r.IfcStructuralCurveMemberVarying = B0;
  class Cl extends tc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.ProjectedOrTrue = ys, this.type = 1807405624;
    }
  }
  r.IfcStructuralLinearAction = Cl;
  class I1 extends Cl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.ProjectedOrTrue = ys, this.VaryingAppliedLoadLocation = Fs, this.SubsequentAppliedLoads = Xo, this.type = 1721250024;
    }
  }
  r.IfcStructuralLinearActionVarying = I1;
  class rl extends Y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.PredefinedType = tt, this.ActionType = at, this.ActionSource = St, this.Coefficient = kt, this.Purpose = On, this.type = 1252848954;
    }
  }
  r.IfcStructuralLoadGroup = rl;
  class X0 extends tc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.ProjectedOrTrue = ys, this.type = 1621171031;
    }
  }
  r.IfcStructuralPlanarAction = X0;
  class $c extends X0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.ProjectedOrTrue = ys, this.VaryingAppliedLoadLocation = Fs, this.SubsequentAppliedLoads = Xo, this.type = 3987759626;
    }
  }
  r.IfcStructuralPlanarActionVarying = $c;
  class Fa extends tc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.DestabilizingLoad = On, this.CausedBy = Gr, this.type = 2082059205;
    }
  }
  r.IfcStructuralPointAction = Fa;
  class X6 extends zc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedCondition = St, this.type = 734778138;
    }
  }
  r.IfcStructuralPointConnection = X6;
  class V6 extends m4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedLoad = St, this.GlobalOrLocal = kt, this.type = 1235345126;
    }
  }
  r.IfcStructuralPointReaction = V6;
  class W6 extends Y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.TheoryType = tt, this.ResultForLoadGroup = at, this.IsLinear = St, this.type = 2986769608;
    }
  }
  r.IfcStructuralResultGroup = W6;
  class p1 extends zc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.AppliedCondition = St, this.type = 1975003073;
    }
  }
  r.IfcStructuralSurfaceConnection = p1;
  class q4 extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.SubContractor = On, this.JobDescription = Gr, this.type = 148013059;
    }
  }
  r.IfcSubContractResource = q4;
  class k4 extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2315554128;
    }
  }
  r.IfcSwitchingDeviceType = k4;
  class d1 extends Y0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 2254336722;
    }
  }
  r.IfcSystem = d1;
  class z6 extends Ju {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 5716631;
    }
  }
  r.IfcTankType = z6;
  class $6 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ApplicableDates = tt, this.TimeSeriesScheduleType = at, this.TimeSeries = St, this.type = 1637806684;
    }
  }
  r.IfcTimeSeriesSchedule = $6;
  class Qc extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1692211062;
    }
  }
  r.IfcTransformerType = Qc;
  class Kc extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.OperationType = kt, this.CapacityByWeight = On, this.CapacityByNumber = Gr, this.type = 1620046519;
    }
  }
  r.IfcTransportElement = Kc;
  class f1 extends uu {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.BasisCurve = ee, this.Trim1 = le, this.Trim2 = he, this.SenseAgreement = ge, this.MasterRepresentation = Xe, this.type = 3593883385;
    }
  }
  r.IfcTrimmedCurve = f1;
  class sl extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1600972822;
    }
  }
  r.IfcTubeBundleType = sl;
  class hl extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1911125066;
    }
  }
  r.IfcUnitaryEquipmentType = hl;
  class Y4 extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 728799441;
    }
  }
  r.IfcValveType = Y4;
  class Jc extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2769231204;
    }
  }
  r.IfcVirtualElement = Jc;
  class nc extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1898987631;
    }
  }
  r.IfcWallType = nc;
  class h1 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1133259667;
    }
  }
  r.IfcWasteTerminalType = h1;
  class n0 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.Identifier = tt, this.CreationDate = at, this.Creators = St, this.Purpose = kt, this.Duration = On, this.TotalFloat = Gr, this.StartTime = ys, this.FinishTime = Fs, this.WorkControlType = Xo, this.UserDefinedControlType = ta, this.type = 1028945134;
    }
  }
  r.IfcWorkControl = n0;
  class rc extends n0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.Identifier = tt, this.CreationDate = at, this.Creators = St, this.Purpose = kt, this.Duration = On, this.TotalFloat = Gr, this.StartTime = ys, this.FinishTime = Fs, this.WorkControlType = Xo, this.UserDefinedControlType = ta, this.type = 4218914973;
    }
  }
  r.IfcWorkPlan = rc;
  class X4 extends n0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.Identifier = tt, this.CreationDate = at, this.Creators = St, this.Purpose = kt, this.Duration = On, this.TotalFloat = Gr, this.StartTime = ys, this.FinishTime = Fs, this.WorkControlType = Xo, this.UserDefinedControlType = ta, this.type = 3342526732;
    }
  }
  r.IfcWorkSchedule = X4;
  class S1 extends Y0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 1033361043;
    }
  }
  r.IfcZone = S1;
  class Q6 extends L4 {
    constructor(ue, ee, le) {
      super(ue, ee, le), this.Segments = ee, this.SelfIntersect = le, this.type = 1213861670;
    }
  }
  r.Ifc2DCompositeCurve = Q6;
  class V4 extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.RequestID = tt, this.type = 3821786052;
    }
  }
  r.IfcActionRequest = V4;
  class W4 extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1411407467;
    }
  }
  r.IfcAirTerminalBoxType = W4;
  class Cu extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3352864051;
    }
  }
  r.IfcAirTerminalType = Cu;
  class K6 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1871374353;
    }
  }
  r.IfcAirToAirHeatRecoveryType = K6;
  class hu extends x0 {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 2470393545;
    }
  }
  r.IfcAngularDimension = hu;
  class J6 extends Y0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.AssetID = tt, this.OriginalValue = at, this.CurrentValue = St, this.TotalReplacementCost = kt, this.Owner = On, this.User = Gr, this.ResponsiblePerson = ys, this.IncorporationDate = Fs, this.DepreciatedValue = Xo, this.type = 3460190687;
    }
  }
  r.IfcAsset = J6;
  class qi extends uu {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue), this.Degree = ee, this.ControlPointsList = le, this.CurveForm = he, this.ClosedCurve = ge, this.SelfIntersect = Xe, this.type = 1967976161;
    }
  }
  r.IfcBSplineCurve = qi;
  class Z6 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 819618141;
    }
  }
  r.IfcBeamType = Z6;
  class z4 extends qi {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.Degree = ee, this.ControlPointsList = le, this.CurveForm = he, this.ClosedCurve = ge, this.SelfIntersect = Xe, this.type = 1916977116;
    }
  }
  r.IfcBezierCurve = z4;
  class eI extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 231477066;
    }
  }
  r.IfcBoilerType = eI;
  class Da extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3299480353;
    }
  }
  r.IfcBuildingElement = Da;
  class R1 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 52481810;
    }
  }
  r.IfcBuildingElementComponent = R1;
  class tI extends R1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2979338954;
    }
  }
  r.IfcBuildingElementPart = tI;
  class Zc extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.CompositionType = kt, this.type = 1095909175;
    }
  }
  r.IfcBuildingElementProxy = Zc;
  class $4 extends h0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1909888760;
    }
  }
  r.IfcBuildingElementProxyType = $4;
  class T1 extends cu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 395041908;
    }
  }
  r.IfcCableCarrierFittingType = T1;
  class nI extends Yl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3293546465;
    }
  }
  r.IfcCableCarrierSegmentType = nI;
  class rI extends Yl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1285652485;
    }
  }
  r.IfcCableSegmentType = rI;
  class sI extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2951183804;
    }
  }
  r.IfcChillerType = sI;
  class Sl extends kl {
    constructor(ue, ee, le) {
      super(ue, ee), this.Position = ee, this.Radius = le, this.type = 2611217952;
    }
  }
  r.IfcCircle = Sl;
  class ol extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2301859152;
    }
  }
  r.IfcCoilType = ol;
  class oI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 843113511;
    }
  }
  r.IfcColumn = oI;
  class iI extends Wc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3850581409;
    }
  }
  r.IfcCompressorType = iI;
  class aI extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2816379211;
    }
  }
  r.IfcCondenserType = aI;
  class lI extends Y0 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 2188551683;
    }
  }
  r.IfcCondition = lI;
  class uI extends t0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.Criterion = tt, this.CriterionDateTime = at, this.type = 1163958913;
    }
  }
  r.IfcConditionCriterion = uI;
  class cI extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.type = 3898045240;
    }
  }
  r.IfcConstructionEquipmentResource = cI;
  class EI extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.Suppliers = On, this.UsageRatio = Gr, this.type = 1060000209;
    }
  }
  r.IfcConstructionMaterialResource = EI;
  class II extends M0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ResourceIdentifier = tt, this.ResourceGroup = at, this.ResourceConsumption = St, this.BaseQuantity = kt, this.type = 488727124;
    }
  }
  r.IfcConstructionProductResource = II;
  class m1 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 335055490;
    }
  }
  r.IfcCooledBeamType = m1;
  class pI extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2954562838;
    }
  }
  r.IfcCoolingTowerType = pI;
  class e3 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.PredefinedType = kt, this.type = 1973544240;
    }
  }
  r.IfcCovering = e3;
  class V0 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3495092785;
    }
  }
  r.IfcCurtainWall = V0;
  class dI extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3961806047;
    }
  }
  r.IfcDamperType = dI;
  class fI extends x0 {
    constructor(ue, ee) {
      super(ue, ee), this.Contents = ee, this.type = 4147604152;
    }
  }
  r.IfcDiameterDimension = fI;
  class CI extends Yc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1335981549;
    }
  }
  r.IfcDiscreteAccessory = CI;
  class Q4 extends Xc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2635815018;
    }
  }
  r.IfcDiscreteAccessoryType = Q4;
  class hI extends S0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1599208980;
    }
  }
  r.IfcDistributionChamberElementType = hI;
  class Ja extends o1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.type = 2063403501;
    }
  }
  r.IfcDistributionControlElementType = Ja;
  class y1 extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1945004755;
    }
  }
  r.IfcDistributionElement = y1;
  class W0 extends y1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3040386961;
    }
  }
  r.IfcDistributionFlowElement = W0;
  class u0 extends v4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.FlowDirection = St, this.type = 3041715199;
    }
  }
  r.IfcDistributionPort = u0;
  class c0 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.OverallHeight = kt, this.OverallWidth = On, this.type = 395920057;
    }
  }
  r.IfcDoor = c0;
  class SI extends cu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 869906466;
    }
  }
  r.IfcDuctFittingType = SI;
  class ba extends Yl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3760055223;
    }
  }
  r.IfcDuctSegmentType = ba;
  class RI extends Eu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2030761528;
    }
  }
  r.IfcDuctSilencerType = RI;
  class F1 extends Vc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.FeatureLength = kt, this.type = 855621170;
    }
  }
  r.IfcEdgeFeature = F1;
  class TI extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 663422040;
    }
  }
  r.IfcElectricApplianceType = TI;
  class _I extends Ju {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3277789161;
    }
  }
  r.IfcElectricFlowStorageDeviceType = _I;
  class K4 extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1534661035;
    }
  }
  r.IfcElectricGeneratorType = K4;
  class J4 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1365060375;
    }
  }
  r.IfcElectricHeaterType = J4;
  class mI extends ka {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1217240411;
    }
  }
  r.IfcElectricMotorType = mI;
  class Su extends dl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 712377611;
    }
  }
  r.IfcElectricTimeControlType = Su;
  class Ru extends d1 {
    constructor(ue, ee, le, he, ge, Xe) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.type = 1634875225;
    }
  }
  r.IfcElectricalCircuit = Ru;
  class yI extends v0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 857184966;
    }
  }
  r.IfcElectricalElement = yI;
  class FI extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1658829314;
    }
  }
  r.IfcEnergyConversionDevice = FI;
  class AI extends Wc {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 346874300;
    }
  }
  r.IfcFanType = AI;
  class t3 extends Eu {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1810631287;
    }
  }
  r.IfcFilterType = t3;
  class Z4 extends wa {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 4222183408;
    }
  }
  r.IfcFireSuppressionTerminalType = Z4;
  class Rl extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2058353004;
    }
  }
  r.IfcFlowController = Rl;
  class R0 extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 4278956645;
    }
  }
  r.IfcFlowFitting = R0;
  class Xl extends Ja {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 4037862832;
    }
  }
  r.IfcFlowInstrumentType = Xl;
  class LI extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3132237377;
    }
  }
  r.IfcFlowMovingDevice = LI;
  class sc extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 987401354;
    }
  }
  r.IfcFlowSegment = sc;
  class Tu extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 707683696;
    }
  }
  r.IfcFlowStorageDevice = Tu;
  class L1 extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2223149337;
    }
  }
  r.IfcFlowTerminal = L1;
  class Za extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3508470533;
    }
  }
  r.IfcFlowTreatmentDevice = Za;
  class _u extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.PredefinedType = kt, this.type = 900683007;
    }
  }
  r.IfcFooting = _u;
  class NI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1073191201;
    }
  }
  r.IfcMember = NI;
  class N1 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.PredefinedType = kt, this.ConstructionType = On, this.type = 1687234759;
    }
  }
  r.IfcPile = N1;
  class gI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3171933400;
    }
  }
  r.IfcPlate = gI;
  class OI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.PredefinedType = kt, this.type = 2262370178;
    }
  }
  r.IfcRailing = OI;
  class n3 extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.ShapeType = kt, this.type = 3024970846;
    }
  }
  r.IfcRamp = n3;
  class wI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3283111854;
    }
  }
  r.IfcRampFlight = wI;
  class DI extends z4 {
    constructor(ue, ee, le, he, ge, Xe, tt) {
      super(ue, ee, le, he, ge, Xe), this.Degree = ee, this.ControlPointsList = le, this.CurveForm = he, this.ClosedCurve = ge, this.SelfIntersect = Xe, this.WeightsData = tt, this.type = 3055160366;
    }
  }
  r.IfcRationalBezierCurve = DI;
  class z0 extends R1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.SteelGrade = kt, this.type = 3027567501;
    }
  }
  r.IfcReinforcingElement = z0;
  class bI extends z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.SteelGrade = kt, this.MeshLength = On, this.MeshWidth = Gr, this.LongitudinalBarNominalDiameter = ys, this.TransverseBarNominalDiameter = Fs, this.LongitudinalBarCrossSectionArea = Xo, this.TransverseBarCrossSectionArea = ta, this.LongitudinalBarSpacing = E0, this.TransverseBarSpacing = I0, this.type = 2320036040;
    }
  }
  r.IfcReinforcingMesh = bI;
  class oc extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.ShapeType = kt, this.type = 2016517767;
    }
  }
  r.IfcRoof = oc;
  class GI extends F1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.FeatureLength = kt, this.Radius = On, this.type = 1376911519;
    }
  }
  r.IfcRoundedEdgeFeature = GI;
  class jI extends Ja {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 1783015770;
    }
  }
  r.IfcSensorType = jI;
  class MI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.PredefinedType = kt, this.type = 1529196076;
    }
  }
  r.IfcSlab = MI;
  class xI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.ShapeType = kt, this.type = 331165859;
    }
  }
  r.IfcStair = xI;
  class vI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.NumberOfRiser = kt, this.NumberOfTreads = On, this.RiserHeight = Gr, this.TreadLength = ys, this.type = 4252922144;
    }
  }
  r.IfcStairFlight = vI;
  class BI extends d1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.PredefinedType = tt, this.OrientationOf2DPlane = at, this.LoadedBy = St, this.HasResults = kt, this.type = 2515109513;
    }
  }
  r.IfcStructuralAnalysisModel = BI;
  class UI extends z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo, ta, E0, I0) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.SteelGrade = kt, this.PredefinedType = On, this.NominalDiameter = Gr, this.CrossSectionArea = ys, this.TensionForce = Fs, this.PreStress = Xo, this.FrictionCoefficient = ta, this.AnchorageSlip = E0, this.MinCurvatureRadius = I0, this.type = 3824725483;
    }
  }
  r.IfcTendon = UI;
  class HI extends z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.SteelGrade = kt, this.type = 2347447852;
    }
  }
  r.IfcTendonAnchor = HI;
  class qI extends Q4 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3313531582;
    }
  }
  r.IfcVibrationIsolatorType = qI;
  class eE extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 2391406946;
    }
  }
  r.IfcWall = eE;
  class kI extends eE {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 3512223829;
    }
  }
  r.IfcWallStandardCase = kI;
  class ic extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.OverallHeight = kt, this.OverallWidth = On, this.type = 3304561284;
    }
  }
  r.IfcWindow = ic;
  class YI extends Ja {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 2874132201;
    }
  }
  r.IfcActuatorType = YI;
  class XI extends Ja {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 3001207471;
    }
  }
  r.IfcAlarmType = XI;
  class VI extends Da {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 753842376;
    }
  }
  r.IfcBeam = VI;
  class WI extends F1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.FeatureLength = kt, this.Width = On, this.Height = Gr, this.type = 2454782716;
    }
  }
  r.IfcChamferEdgeFeature = WI;
  class zI extends Ja {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ApplicableOccurrence = Xe, this.HasPropertySets = tt, this.RepresentationMaps = at, this.Tag = St, this.ElementType = kt, this.PredefinedType = On, this.type = 578613899;
    }
  }
  r.IfcControllerType = zI;
  class $I extends W0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.type = 1052013943;
    }
  }
  r.IfcDistributionChamberElement = $I;
  class QI extends y1 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.ControlElementId = kt, this.type = 1062813311;
    }
  }
  r.IfcDistributionControlElement = QI;
  class KI extends Rl {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On) {
      super(ue, ee, le, he, ge, Xe, tt, at, St), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.DistributionPointFunction = kt, this.UserDefinedFunction = On, this.type = 3700593921;
    }
  }
  r.IfcElectricDistributionPoint = KI;
  class g1 extends z0 {
    constructor(ue, ee, le, he, ge, Xe, tt, at, St, kt, On, Gr, ys, Fs, Xo) {
      super(ue, ee, le, he, ge, Xe, tt, at, St, kt), this.GlobalId = ee, this.OwnerHistory = le, this.Name = he, this.Description = ge, this.ObjectType = Xe, this.ObjectPlacement = tt, this.Representation = at, this.Tag = St, this.SteelGrade = kt, this.NominalDiameter = On, this.CrossSectionArea = Gr, this.BarLength = ys, this.BarRole = Fs, this.BarSurface = Xo, this.type = 979691226;
    }
  }
  r.IfcReinforcingBar = g1;
})(IFC2X3 || (IFC2X3 = {}));
SchemaNames[2] = ["IFC4", "IFC4X1", "IFC4X2"];
FromRawLineData[2] = {
  3630933823: (r, e) => new IFC4.IfcActorRole(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null),
  618182010: (r, e) => new IFC4.IfcAddress(r, e[0], e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  639542469: (r, e) => new IFC4.IfcApplication(r, new Handle(e[0].value), new IFC4.IfcLabel(e[1].value), new IFC4.IfcLabel(e[2].value), new IFC4.IfcIdentifier(e[3].value)),
  411424972: (r, e) => new IFC4.IfcAppliedValue(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4.IfcDate(e[4].value) : null, e[5] ? new IFC4.IfcDate(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9] ? e[9].map((s) => new Handle(s.value)) : null),
  130549933: (r, e) => new IFC4.IfcApproval(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null, e[3] ? new IFC4.IfcDateTime(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  4037036970: (r, e) => new IFC4.IfcBoundaryCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  1560379544: (r, e) => new IFC4.IfcBoundaryEdgeCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(2, e[1]) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? TypeInitialiser(2, e[3]) : null, e[4] ? TypeInitialiser(2, e[4]) : null, e[5] ? TypeInitialiser(2, e[5]) : null, e[6] ? TypeInitialiser(2, e[6]) : null),
  3367102660: (r, e) => new IFC4.IfcBoundaryFaceCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(2, e[1]) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? TypeInitialiser(2, e[3]) : null),
  1387855156: (r, e) => new IFC4.IfcBoundaryNodeCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(2, e[1]) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? TypeInitialiser(2, e[3]) : null, e[4] ? TypeInitialiser(2, e[4]) : null, e[5] ? TypeInitialiser(2, e[5]) : null, e[6] ? TypeInitialiser(2, e[6]) : null),
  2069777674: (r, e) => new IFC4.IfcBoundaryNodeConditionWarping(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(2, e[1]) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? TypeInitialiser(2, e[3]) : null, e[4] ? TypeInitialiser(2, e[4]) : null, e[5] ? TypeInitialiser(2, e[5]) : null, e[6] ? TypeInitialiser(2, e[6]) : null, e[7] ? TypeInitialiser(2, e[7]) : null),
  2859738748: (r, e) => new IFC4.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC4.IfcConnectionPointGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  2732653382: (r, e) => new IFC4.IfcConnectionSurfaceGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  775493141: (r, e) => new IFC4.IfcConnectionVolumeGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1959218052: (r, e) => new IFC4.IfcConstraint(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null),
  1785450214: (r, e) => new IFC4.IfcCoordinateOperation(r, new Handle(e[0].value), new Handle(e[1].value)),
  1466758467: (r, e) => new IFC4.IfcCoordinateReferenceSystem(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new IFC4.IfcIdentifier(e[3].value) : null),
  602808272: (r, e) => new IFC4.IfcCostValue(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4.IfcDate(e[4].value) : null, e[5] ? new IFC4.IfcDate(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9] ? e[9].map((s) => new Handle(s.value)) : null),
  1765591967: (r, e) => new IFC4.IfcDerivedUnit(r, e[0].map((s) => new Handle(s.value)), e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  1045800335: (r, e) => new IFC4.IfcDerivedUnitElement(r, new Handle(e[0].value), e[1].value),
  2949456006: (r, e) => new IFC4.IfcDimensionalExponents(r, e[0].value, e[1].value, e[2].value, e[3].value, e[4].value, e[5].value, e[6].value),
  4294318154: (r, e) => new IFC4.IfcExternalInformation(r),
  3200245327: (r, e) => new IFC4.IfcExternalReference(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  2242383968: (r, e) => new IFC4.IfcExternallyDefinedHatchStyle(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  1040185647: (r, e) => new IFC4.IfcExternallyDefinedSurfaceStyle(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  3548104201: (r, e) => new IFC4.IfcExternallyDefinedTextFont(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  852622518: (r, e) => new IFC4.IfcGridAxis(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC4.IfcBoolean(e[2].value)),
  3020489413: (r, e) => new IFC4.IfcIrregularTimeSeriesValue(r, new IFC4.IfcDateTime(e[0].value), e[1].map((s) => TypeInitialiser(2, s))),
  2655187982: (r, e) => new IFC4.IfcLibraryInformation(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new IFC4.IfcDateTime(e[3].value) : null, e[4] ? new IFC4.IfcURIReference(e[4].value) : null, e[5] ? new IFC4.IfcText(e[5].value) : null),
  3452421091: (r, e) => new IFC4.IfcLibraryReference(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLanguageId(e[4].value) : null, e[5] ? new Handle(e[5].value) : null),
  4162380809: (r, e) => new IFC4.IfcLightDistributionData(r, new IFC4.IfcPlaneAngleMeasure(e[0].value), e[1].map((s) => new IFC4.IfcPlaneAngleMeasure(s.value)), e[2].map((s) => new IFC4.IfcLuminousIntensityDistributionMeasure(s.value))),
  1566485204: (r, e) => new IFC4.IfcLightIntensityDistribution(r, e[0], e[1].map((s) => new Handle(s.value))),
  3057273783: (r, e) => new IFC4.IfcMapConversion(r, new Handle(e[0].value), new Handle(e[1].value), new IFC4.IfcLengthMeasure(e[2].value), new IFC4.IfcLengthMeasure(e[3].value), new IFC4.IfcLengthMeasure(e[4].value), e[5] ? new IFC4.IfcReal(e[5].value) : null, e[6] ? new IFC4.IfcReal(e[6].value) : null, e[7] ? new IFC4.IfcReal(e[7].value) : null),
  1847130766: (r, e) => new IFC4.IfcMaterialClassificationRelationship(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value)),
  760658860: (r, e) => new IFC4.IfcMaterialDefinition(r),
  248100487: (r, e) => new IFC4.IfcMaterialLayer(r, e[0] ? new Handle(e[0].value) : null, new IFC4.IfcNonNegativeLengthMeasure(e[1].value), e[2] ? new IFC4.IfcLogical(e[2].value) : null, e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcInteger(e[6].value) : null),
  3303938423: (r, e) => new IFC4.IfcMaterialLayerSet(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null),
  1847252529: (r, e) => new IFC4.IfcMaterialLayerWithOffsets(r, e[0] ? new Handle(e[0].value) : null, new IFC4.IfcNonNegativeLengthMeasure(e[1].value), e[2] ? new IFC4.IfcLogical(e[2].value) : null, e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcInteger(e[6].value) : null, e[7], new IFC4.IfcLengthMeasure(e[8].value)),
  2199411900: (r, e) => new IFC4.IfcMaterialList(r, e[0].map((s) => new Handle(s.value))),
  2235152071: (r, e) => new IFC4.IfcMaterialProfile(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4.IfcInteger(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null),
  164193824: (r, e) => new IFC4.IfcMaterialProfileSet(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new Handle(e[3].value) : null),
  552965576: (r, e) => new IFC4.IfcMaterialProfileWithOffsets(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4.IfcInteger(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, new IFC4.IfcLengthMeasure(e[6].value)),
  1507914824: (r, e) => new IFC4.IfcMaterialUsageDefinition(r),
  2597039031: (r, e) => new IFC4.IfcMeasureWithUnit(r, TypeInitialiser(2, e[0]), new Handle(e[1].value)),
  3368373690: (r, e) => new IFC4.IfcMetric(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7], e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  2706619895: (r, e) => new IFC4.IfcMonetaryUnit(r, new IFC4.IfcLabel(e[0].value)),
  1918398963: (r, e) => new IFC4.IfcNamedUnit(r, new Handle(e[0].value), e[1]),
  3701648758: (r, e) => new IFC4.IfcObjectPlacement(r),
  2251480897: (r, e) => new IFC4.IfcObjective(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8], e[9], e[10] ? new IFC4.IfcLabel(e[10].value) : null),
  4251960020: (r, e) => new IFC4.IfcOrganization(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, new IFC4.IfcLabel(e[1].value), e[2] ? new IFC4.IfcText(e[2].value) : null, e[3] ? e[3].map((s) => new Handle(s.value)) : null, e[4] ? e[4].map((s) => new Handle(s.value)) : null),
  1207048766: (r, e) => new IFC4.IfcOwnerHistory(r, new Handle(e[0].value), new Handle(e[1].value), e[2], e[3], e[4] ? new IFC4.IfcTimeStamp(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new IFC4.IfcTimeStamp(e[7].value)),
  2077209135: (r, e) => new IFC4.IfcPerson(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC4.IfcLabel(s.value)) : null, e[5] ? e[5].map((s) => new IFC4.IfcLabel(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  101040310: (r, e) => new IFC4.IfcPersonAndOrganization(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2483315170: (r, e) => new IFC4.IfcPhysicalQuantity(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null),
  2226359599: (r, e) => new IFC4.IfcPhysicalSimpleQuantity(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  3355820592: (r, e) => new IFC4.IfcPostalAddress(r, e[0], e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcLabel(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4.IfcLabel(s.value)) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcLabel(e[9].value) : null),
  677532197: (r, e) => new IFC4.IfcPresentationItem(r),
  2022622350: (r, e) => new IFC4.IfcPresentationLayerAssignment(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4.IfcIdentifier(e[3].value) : null),
  1304840413: (r, e) => new IFC4.IfcPresentationLayerWithStyle(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4.IfcIdentifier(e[3].value) : null, new IFC4.IfcLogical(e[4].value), new IFC4.IfcLogical(e[5].value), new IFC4.IfcLogical(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  3119450353: (r, e) => new IFC4.IfcPresentationStyle(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  2417041796: (r, e) => new IFC4.IfcPresentationStyleAssignment(r, e[0].map((s) => new Handle(s.value))),
  2095639259: (r, e) => new IFC4.IfcProductRepresentation(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  3958567839: (r, e) => new IFC4.IfcProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null),
  3843373140: (r, e) => new IFC4.IfcProjectedCRS(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new IFC4.IfcIdentifier(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  986844984: (r, e) => new IFC4.IfcPropertyAbstraction(r),
  3710013099: (r, e) => new IFC4.IfcPropertyEnumeration(r, new IFC4.IfcLabel(e[0].value), e[1].map((s) => TypeInitialiser(2, s)), e[2] ? new Handle(e[2].value) : null),
  2044713172: (r, e) => new IFC4.IfcQuantityArea(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcAreaMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  2093928680: (r, e) => new IFC4.IfcQuantityCount(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcCountMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  931644368: (r, e) => new IFC4.IfcQuantityLength(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcLengthMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  3252649465: (r, e) => new IFC4.IfcQuantityTime(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcTimeMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  2405470396: (r, e) => new IFC4.IfcQuantityVolume(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcVolumeMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  825690147: (r, e) => new IFC4.IfcQuantityWeight(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcMassMeasure(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  3915482550: (r, e) => new IFC4.IfcRecurrencePattern(r, e[0], e[1] ? e[1].map((s) => new IFC4.IfcDayInMonthNumber(s.value)) : null, e[2] ? e[2].map((s) => new IFC4.IfcDayInWeekNumber(s.value)) : null, e[3] ? e[3].map((s) => new IFC4.IfcMonthInYearNumber(s.value)) : null, e[4] ? new IFC4.IfcInteger(e[4].value) : null, e[5] ? new IFC4.IfcInteger(e[5].value) : null, e[6] ? new IFC4.IfcInteger(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  2433181523: (r, e) => new IFC4.IfcReference(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4.IfcInteger(s.value)) : null, e[4] ? new Handle(e[4].value) : null),
  1076942058: (r, e) => new IFC4.IfcRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3377609919: (r, e) => new IFC4.IfcRepresentationContext(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null),
  3008791417: (r, e) => new IFC4.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC4.IfcRepresentationMap(r, new Handle(e[0].value), new Handle(e[1].value)),
  2439245199: (r, e) => new IFC4.IfcResourceLevelRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null),
  2341007311: (r, e) => new IFC4.IfcRoot(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  448429030: (r, e) => new IFC4.IfcSIUnit(r, e[0], e[1], e[2]),
  1054537805: (r, e) => new IFC4.IfcSchedulingTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  867548509: (r, e) => new IFC4.IfcShapeAspect(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null, new IFC4.IfcLogical(e[3].value), e[4] ? new Handle(e[4].value) : null),
  3982875396: (r, e) => new IFC4.IfcShapeModel(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  4240577450: (r, e) => new IFC4.IfcShapeRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  2273995522: (r, e) => new IFC4.IfcStructuralConnectionCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  2162789131: (r, e) => new IFC4.IfcStructuralLoad(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  3478079324: (r, e) => new IFC4.IfcStructuralLoadConfiguration(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? e[2].map((s) => new IFC4.IfcLengthMeasure(s.value)) : null),
  609421318: (r, e) => new IFC4.IfcStructuralLoadOrResult(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  2525727697: (r, e) => new IFC4.IfcStructuralLoadStatic(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  3408363356: (r, e) => new IFC4.IfcStructuralLoadTemperature(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcThermodynamicTemperatureMeasure(e[1].value) : null, e[2] ? new IFC4.IfcThermodynamicTemperatureMeasure(e[2].value) : null, e[3] ? new IFC4.IfcThermodynamicTemperatureMeasure(e[3].value) : null),
  2830218821: (r, e) => new IFC4.IfcStyleModel(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3958052878: (r, e) => new IFC4.IfcStyledItem(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  3049322572: (r, e) => new IFC4.IfcStyledRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  2934153892: (r, e) => new IFC4.IfcSurfaceReinforcementArea(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? e[1].map((s) => new IFC4.IfcLengthMeasure(s.value)) : null, e[2] ? e[2].map((s) => new IFC4.IfcLengthMeasure(s.value)) : null, e[3] ? new IFC4.IfcRatioMeasure(e[3].value) : null),
  1300840506: (r, e) => new IFC4.IfcSurfaceStyle(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2].map((s) => new Handle(s.value))),
  3303107099: (r, e) => new IFC4.IfcSurfaceStyleLighting(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new Handle(e[3].value)),
  1607154358: (r, e) => new IFC4.IfcSurfaceStyleRefraction(r, e[0] ? new IFC4.IfcReal(e[0].value) : null, e[1] ? new IFC4.IfcReal(e[1].value) : null),
  846575682: (r, e) => new IFC4.IfcSurfaceStyleShading(r, new Handle(e[0].value), e[1] ? new IFC4.IfcNormalisedRatioMeasure(e[1].value) : null),
  1351298697: (r, e) => new IFC4.IfcSurfaceStyleWithTextures(r, e[0].map((s) => new Handle(s.value))),
  626085974: (r, e) => new IFC4.IfcSurfaceTexture(r, new IFC4.IfcBoolean(e[0].value), new IFC4.IfcBoolean(e[1].value), e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4.IfcIdentifier(s.value)) : null),
  985171141: (r, e) => new IFC4.IfcTable(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? e[1].map((s) => new Handle(s.value)) : null, e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2043862942: (r, e) => new IFC4.IfcTableColumn(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  531007025: (r, e) => new IFC4.IfcTableRow(r, e[0] ? e[0].map((s) => TypeInitialiser(2, s)) : null, e[1] ? new IFC4.IfcBoolean(e[1].value) : null),
  1549132990: (r, e) => new IFC4.IfcTaskTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3], e[4] ? new IFC4.IfcDuration(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcDateTime(e[6].value) : null, e[7] ? new IFC4.IfcDateTime(e[7].value) : null, e[8] ? new IFC4.IfcDateTime(e[8].value) : null, e[9] ? new IFC4.IfcDateTime(e[9].value) : null, e[10] ? new IFC4.IfcDateTime(e[10].value) : null, e[11] ? new IFC4.IfcDuration(e[11].value) : null, e[12] ? new IFC4.IfcDuration(e[12].value) : null, e[13] ? new IFC4.IfcBoolean(e[13].value) : null, e[14] ? new IFC4.IfcDateTime(e[14].value) : null, e[15] ? new IFC4.IfcDuration(e[15].value) : null, e[16] ? new IFC4.IfcDateTime(e[16].value) : null, e[17] ? new IFC4.IfcDateTime(e[17].value) : null, e[18] ? new IFC4.IfcDuration(e[18].value) : null, e[19] ? new IFC4.IfcPositiveRatioMeasure(e[19].value) : null),
  2771591690: (r, e) => new IFC4.IfcTaskTimeRecurring(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3], e[4] ? new IFC4.IfcDuration(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcDateTime(e[6].value) : null, e[7] ? new IFC4.IfcDateTime(e[7].value) : null, e[8] ? new IFC4.IfcDateTime(e[8].value) : null, e[9] ? new IFC4.IfcDateTime(e[9].value) : null, e[10] ? new IFC4.IfcDateTime(e[10].value) : null, e[11] ? new IFC4.IfcDuration(e[11].value) : null, e[12] ? new IFC4.IfcDuration(e[12].value) : null, e[13] ? new IFC4.IfcBoolean(e[13].value) : null, e[14] ? new IFC4.IfcDateTime(e[14].value) : null, e[15] ? new IFC4.IfcDuration(e[15].value) : null, e[16] ? new IFC4.IfcDateTime(e[16].value) : null, e[17] ? new IFC4.IfcDateTime(e[17].value) : null, e[18] ? new IFC4.IfcDuration(e[18].value) : null, e[19] ? new IFC4.IfcPositiveRatioMeasure(e[19].value) : null, new Handle(e[20].value)),
  912023232: (r, e) => new IFC4.IfcTelecomAddress(r, e[0], e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC4.IfcLabel(s.value)) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? e[6].map((s) => new IFC4.IfcLabel(s.value)) : null, e[7] ? new IFC4.IfcURIReference(e[7].value) : null, e[8] ? e[8].map((s) => new IFC4.IfcURIReference(s.value)) : null),
  1447204868: (r, e) => new IFC4.IfcTextStyle(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4.IfcBoolean(e[4].value) : null),
  2636378356: (r, e) => new IFC4.IfcTextStyleForDefinedFont(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1640371178: (r, e) => new IFC4.IfcTextStyleTextModel(r, e[0] ? TypeInitialiser(2, e[0]) : null, e[1] ? new IFC4.IfcTextAlignment(e[1].value) : null, e[2] ? new IFC4.IfcTextDecoration(e[2].value) : null, e[3] ? TypeInitialiser(2, e[3]) : null, e[4] ? TypeInitialiser(2, e[4]) : null, e[5] ? new IFC4.IfcTextTransformation(e[5].value) : null, e[6] ? TypeInitialiser(2, e[6]) : null),
  280115917: (r, e) => new IFC4.IfcTextureCoordinate(r, e[0].map((s) => new Handle(s.value))),
  1742049831: (r, e) => new IFC4.IfcTextureCoordinateGenerator(r, e[0].map((s) => new Handle(s.value)), new IFC4.IfcLabel(e[1].value), e[2] ? e[2].map((s) => new IFC4.IfcReal(s.value)) : null),
  2552916305: (r, e) => new IFC4.IfcTextureMap(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new Handle(s.value)), new Handle(e[2].value)),
  1210645708: (r, e) => new IFC4.IfcTextureVertex(r, e[0].map((s) => new IFC4.IfcParameterValue(s.value))),
  3611470254: (r, e) => new IFC4.IfcTextureVertexList(r, e[0].map((s) => new IFC4.IfcParameterValue(s.value))),
  1199560280: (r, e) => new IFC4.IfcTimePeriod(r, new IFC4.IfcTime(e[0].value), new IFC4.IfcTime(e[1].value)),
  3101149627: (r, e) => new IFC4.IfcTimeSeries(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, new IFC4.IfcDateTime(e[2].value), new IFC4.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  581633288: (r, e) => new IFC4.IfcTimeSeriesValue(r, e[0].map((s) => TypeInitialiser(2, s))),
  1377556343: (r, e) => new IFC4.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC4.IfcTopologyRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  180925521: (r, e) => new IFC4.IfcUnitAssignment(r, e[0].map((s) => new Handle(s.value))),
  2799835756: (r, e) => new IFC4.IfcVertex(r),
  1907098498: (r, e) => new IFC4.IfcVertexPoint(r, new Handle(e[0].value)),
  891718957: (r, e) => new IFC4.IfcVirtualGridIntersection(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new IFC4.IfcLengthMeasure(s.value))),
  1236880293: (r, e) => new IFC4.IfcWorkTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4.IfcDate(e[4].value) : null, e[5] ? new IFC4.IfcDate(e[5].value) : null),
  3869604511: (r, e) => new IFC4.IfcApprovalRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  3798115385: (r, e) => new IFC4.IfcArbitraryClosedProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  1310608509: (r, e) => new IFC4.IfcArbitraryOpenProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  2705031697: (r, e) => new IFC4.IfcArbitraryProfileDefWithVoids(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  616511568: (r, e) => new IFC4.IfcBlobTexture(r, new IFC4.IfcBoolean(e[0].value), new IFC4.IfcBoolean(e[1].value), e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4.IfcIdentifier(s.value)) : null, new IFC4.IfcIdentifier(e[5].value), new IFC4.IfcBinary(e[6].value)),
  3150382593: (r, e) => new IFC4.IfcCenterLineProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  747523909: (r, e) => new IFC4.IfcClassification(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new IFC4.IfcDate(e[2].value) : null, new IFC4.IfcLabel(e[3].value), e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new IFC4.IfcURIReference(e[5].value) : null, e[6] ? e[6].map((s) => new IFC4.IfcIdentifier(s.value)) : null),
  647927063: (r, e) => new IFC4.IfcClassificationReference(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null),
  3285139300: (r, e) => new IFC4.IfcColourRgbList(r, e[0].map((s) => new IFC4.IfcNormalisedRatioMeasure(s.value))),
  3264961684: (r, e) => new IFC4.IfcColourSpecification(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null),
  1485152156: (r, e) => new IFC4.IfcCompositeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4.IfcLabel(e[3].value) : null),
  370225590: (r, e) => new IFC4.IfcConnectedFaceSet(r, e[0].map((s) => new Handle(s.value))),
  1981873012: (r, e) => new IFC4.IfcConnectionCurveGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  45288368: (r, e) => new IFC4.IfcConnectionPointEccentricity(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4.IfcLengthMeasure(e[4].value) : null),
  3050246964: (r, e) => new IFC4.IfcContextDependentUnit(r, new Handle(e[0].value), e[1], new IFC4.IfcLabel(e[2].value)),
  2889183280: (r, e) => new IFC4.IfcConversionBasedUnit(r, new Handle(e[0].value), e[1], new IFC4.IfcLabel(e[2].value), new Handle(e[3].value)),
  2713554722: (r, e) => new IFC4.IfcConversionBasedUnitWithOffset(r, new Handle(e[0].value), e[1], new IFC4.IfcLabel(e[2].value), new Handle(e[3].value), new IFC4.IfcReal(e[4].value)),
  539742890: (r, e) => new IFC4.IfcCurrencyRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), new IFC4.IfcPositiveRatioMeasure(e[4].value), e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3800577675: (r, e) => new IFC4.IfcCurveStyle(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4.IfcBoolean(e[4].value) : null),
  1105321065: (r, e) => new IFC4.IfcCurveStyleFont(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value))),
  2367409068: (r, e) => new IFC4.IfcCurveStyleFontAndScaling(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC4.IfcPositiveRatioMeasure(e[2].value)),
  3510044353: (r, e) => new IFC4.IfcCurveStyleFontPattern(r, new IFC4.IfcLengthMeasure(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value)),
  3632507154: (r, e) => new IFC4.IfcDerivedProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  1154170062: (r, e) => new IFC4.IfcDocumentInformation(r, new IFC4.IfcIdentifier(e[0].value), new IFC4.IfcLabel(e[1].value), e[2] ? new IFC4.IfcText(e[2].value) : null, e[3] ? new IFC4.IfcURIReference(e[3].value) : null, e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new IFC4.IfcText(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new IFC4.IfcDateTime(e[10].value) : null, e[11] ? new IFC4.IfcDateTime(e[11].value) : null, e[12] ? new IFC4.IfcIdentifier(e[12].value) : null, e[13] ? new IFC4.IfcDate(e[13].value) : null, e[14] ? new IFC4.IfcDate(e[14].value) : null, e[15], e[16]),
  770865208: (r, e) => new IFC4.IfcDocumentInformationRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value)), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  3732053477: (r, e) => new IFC4.IfcDocumentReference(r, e[0] ? new IFC4.IfcURIReference(e[0].value) : null, e[1] ? new IFC4.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  3900360178: (r, e) => new IFC4.IfcEdge(r, new Handle(e[0].value), new Handle(e[1].value)),
  476780140: (r, e) => new IFC4.IfcEdgeCurve(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC4.IfcBoolean(e[3].value)),
  211053100: (r, e) => new IFC4.IfcEventTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcDateTime(e[3].value) : null, e[4] ? new IFC4.IfcDateTime(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcDateTime(e[6].value) : null),
  297599258: (r, e) => new IFC4.IfcExtendedProperties(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  1437805879: (r, e) => new IFC4.IfcExternalReferenceRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  2556980723: (r, e) => new IFC4.IfcFace(r, e[0].map((s) => new Handle(s.value))),
  1809719519: (r, e) => new IFC4.IfcFaceBound(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value)),
  803316827: (r, e) => new IFC4.IfcFaceOuterBound(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value)),
  3008276851: (r, e) => new IFC4.IfcFaceSurface(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new IFC4.IfcBoolean(e[2].value)),
  4219587988: (r, e) => new IFC4.IfcFailureConnectionCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4.IfcForceMeasure(e[4].value) : null, e[5] ? new IFC4.IfcForceMeasure(e[5].value) : null, e[6] ? new IFC4.IfcForceMeasure(e[6].value) : null),
  738692330: (r, e) => new IFC4.IfcFillAreaStyle(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC4.IfcBoolean(e[2].value) : null),
  3448662350: (r, e) => new IFC4.IfcGeometricRepresentationContext(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, new IFC4.IfcDimensionCount(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null),
  2453401579: (r, e) => new IFC4.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC4.IfcGeometricRepresentationSubContext(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcPositiveRatioMeasure(e[3].value) : null, e[4], e[5] ? new IFC4.IfcLabel(e[5].value) : null),
  3590301190: (r, e) => new IFC4.IfcGeometricSet(r, e[0].map((s) => new Handle(s.value))),
  178086475: (r, e) => new IFC4.IfcGridPlacement(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  812098782: (r, e) => new IFC4.IfcHalfSpaceSolid(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value)),
  3905492369: (r, e) => new IFC4.IfcImageTexture(r, new IFC4.IfcBoolean(e[0].value), new IFC4.IfcBoolean(e[1].value), e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4.IfcIdentifier(s.value)) : null, new IFC4.IfcURIReference(e[5].value)),
  3570813810: (r, e) => new IFC4.IfcIndexedColourMap(r, new Handle(e[0].value), e[1] ? new IFC4.IfcNormalisedRatioMeasure(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new IFC4.IfcPositiveInteger(s.value))),
  1437953363: (r, e) => new IFC4.IfcIndexedTextureMap(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new Handle(e[2].value)),
  2133299955: (r, e) => new IFC4.IfcIndexedTriangleTextureMap(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new Handle(e[2].value), e[3] ? e[3].map((s) => new IFC4.IfcPositiveInteger(s.value)) : null),
  3741457305: (r, e) => new IFC4.IfcIrregularTimeSeries(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, new IFC4.IfcDateTime(e[2].value), new IFC4.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8].map((s) => new Handle(s.value))),
  1585845231: (r, e) => new IFC4.IfcLagTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, TypeInitialiser(2, e[3]), e[4]),
  1402838566: (r, e) => new IFC4.IfcLightSource(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null),
  125510826: (r, e) => new IFC4.IfcLightSourceAmbient(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null),
  2604431987: (r, e) => new IFC4.IfcLightSourceDirectional(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value)),
  4266656042: (r, e) => new IFC4.IfcLightSourceGoniometric(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null, new IFC4.IfcThermodynamicTemperatureMeasure(e[6].value), new IFC4.IfcLuminousFluxMeasure(e[7].value), e[8], new Handle(e[9].value)),
  1520743889: (r, e) => new IFC4.IfcLightSourcePositional(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcReal(e[6].value), new IFC4.IfcReal(e[7].value), new IFC4.IfcReal(e[8].value)),
  3422422726: (r, e) => new IFC4.IfcLightSourceSpot(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcReal(e[6].value), new IFC4.IfcReal(e[7].value), new IFC4.IfcReal(e[8].value), new Handle(e[9].value), e[10] ? new IFC4.IfcReal(e[10].value) : null, new IFC4.IfcPositivePlaneAngleMeasure(e[11].value), new IFC4.IfcPositivePlaneAngleMeasure(e[12].value)),
  2624227202: (r, e) => new IFC4.IfcLocalPlacement(r, e[0] ? new Handle(e[0].value) : null, new Handle(e[1].value)),
  1008929658: (r, e) => new IFC4.IfcLoop(r),
  2347385850: (r, e) => new IFC4.IfcMappedItem(r, new Handle(e[0].value), new Handle(e[1].value)),
  1838606355: (r, e) => new IFC4.IfcMaterial(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null),
  3708119e3: (r, e) => new IFC4.IfcMaterialConstituent(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcNormalisedRatioMeasure(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  2852063980: (r, e) => new IFC4.IfcMaterialConstituentSet(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2022407955: (r, e) => new IFC4.IfcMaterialDefinitionRepresentation(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  1303795690: (r, e) => new IFC4.IfcMaterialLayerSetUsage(r, new Handle(e[0].value), e[1], e[2], new IFC4.IfcLengthMeasure(e[3].value), e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null),
  3079605661: (r, e) => new IFC4.IfcMaterialProfileSetUsage(r, new Handle(e[0].value), e[1] ? new IFC4.IfcCardinalPointReference(e[1].value) : null, e[2] ? new IFC4.IfcPositiveLengthMeasure(e[2].value) : null),
  3404854881: (r, e) => new IFC4.IfcMaterialProfileSetUsageTapering(r, new Handle(e[0].value), e[1] ? new IFC4.IfcCardinalPointReference(e[1].value) : null, e[2] ? new IFC4.IfcPositiveLengthMeasure(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4.IfcCardinalPointReference(e[4].value) : null),
  3265635763: (r, e) => new IFC4.IfcMaterialProperties(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  853536259: (r, e) => new IFC4.IfcMaterialRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value)), e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  2998442950: (r, e) => new IFC4.IfcMirroredProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcLabel(e[3].value) : null),
  219451334: (r, e) => new IFC4.IfcObjectDefinition(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  2665983363: (r, e) => new IFC4.IfcOpenShell(r, e[0].map((s) => new Handle(s.value))),
  1411181986: (r, e) => new IFC4.IfcOrganizationRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1029017970: (r, e) => new IFC4.IfcOrientedEdge(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value)),
  2529465313: (r, e) => new IFC4.IfcParameterizedProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  2519244187: (r, e) => new IFC4.IfcPath(r, e[0].map((s) => new Handle(s.value))),
  3021840470: (r, e) => new IFC4.IfcPhysicalComplexQuantity(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new IFC4.IfcLabel(e[3].value), e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null),
  597895409: (r, e) => new IFC4.IfcPixelTexture(r, new IFC4.IfcBoolean(e[0].value), new IFC4.IfcBoolean(e[1].value), e[2] ? new IFC4.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4.IfcIdentifier(s.value)) : null, new IFC4.IfcInteger(e[5].value), new IFC4.IfcInteger(e[6].value), new IFC4.IfcInteger(e[7].value), e[8].map((s) => new IFC4.IfcBinary(s.value))),
  2004835150: (r, e) => new IFC4.IfcPlacement(r, new Handle(e[0].value)),
  1663979128: (r, e) => new IFC4.IfcPlanarExtent(r, new IFC4.IfcLengthMeasure(e[0].value), new IFC4.IfcLengthMeasure(e[1].value)),
  2067069095: (r, e) => new IFC4.IfcPoint(r),
  4022376103: (r, e) => new IFC4.IfcPointOnCurve(r, new Handle(e[0].value), new IFC4.IfcParameterValue(e[1].value)),
  1423911732: (r, e) => new IFC4.IfcPointOnSurface(r, new Handle(e[0].value), new IFC4.IfcParameterValue(e[1].value), new IFC4.IfcParameterValue(e[2].value)),
  2924175390: (r, e) => new IFC4.IfcPolyLoop(r, e[0].map((s) => new Handle(s.value))),
  2775532180: (r, e) => new IFC4.IfcPolygonalBoundedHalfSpace(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value), new Handle(e[2].value), new Handle(e[3].value)),
  3727388367: (r, e) => new IFC4.IfcPreDefinedItem(r, new IFC4.IfcLabel(e[0].value)),
  3778827333: (r, e) => new IFC4.IfcPreDefinedProperties(r),
  1775413392: (r, e) => new IFC4.IfcPreDefinedTextFont(r, new IFC4.IfcLabel(e[0].value)),
  673634403: (r, e) => new IFC4.IfcProductDefinitionShape(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  2802850158: (r, e) => new IFC4.IfcProfileProperties(r, e[0] ? new IFC4.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  2598011224: (r, e) => new IFC4.IfcProperty(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null),
  1680319473: (r, e) => new IFC4.IfcPropertyDefinition(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  148025276: (r, e) => new IFC4.IfcPropertyDependencyRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4.IfcText(e[4].value) : null),
  3357820518: (r, e) => new IFC4.IfcPropertySetDefinition(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  1482703590: (r, e) => new IFC4.IfcPropertyTemplateDefinition(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  2090586900: (r, e) => new IFC4.IfcQuantitySet(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  3615266464: (r, e) => new IFC4.IfcRectangleProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value)),
  3413951693: (r, e) => new IFC4.IfcRegularTimeSeries(r, new IFC4.IfcLabel(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, new IFC4.IfcDateTime(e[2].value), new IFC4.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new IFC4.IfcTimeMeasure(e[8].value), e[9].map((s) => new Handle(s.value))),
  1580146022: (r, e) => new IFC4.IfcReinforcementBarProperties(r, new IFC4.IfcAreaMeasure(e[0].value), new IFC4.IfcLabel(e[1].value), e[2], e[3] ? new IFC4.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4.IfcCountMeasure(e[5].value) : null),
  478536968: (r, e) => new IFC4.IfcRelationship(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  2943643501: (r, e) => new IFC4.IfcResourceApprovalRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  1608871552: (r, e) => new IFC4.IfcResourceConstraintRelationship(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1042787934: (r, e) => new IFC4.IfcResourceTime(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcDuration(e[3].value) : null, e[4] ? new IFC4.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC4.IfcDateTime(e[5].value) : null, e[6] ? new IFC4.IfcDateTime(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcDuration(e[8].value) : null, e[9] ? new IFC4.IfcBoolean(e[9].value) : null, e[10] ? new IFC4.IfcDateTime(e[10].value) : null, e[11] ? new IFC4.IfcDuration(e[11].value) : null, e[12] ? new IFC4.IfcPositiveRatioMeasure(e[12].value) : null, e[13] ? new IFC4.IfcDateTime(e[13].value) : null, e[14] ? new IFC4.IfcDateTime(e[14].value) : null, e[15] ? new IFC4.IfcDuration(e[15].value) : null, e[16] ? new IFC4.IfcPositiveRatioMeasure(e[16].value) : null, e[17] ? new IFC4.IfcPositiveRatioMeasure(e[17].value) : null),
  2778083089: (r, e) => new IFC4.IfcRoundedRectangleProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value)),
  2042790032: (r, e) => new IFC4.IfcSectionProperties(r, e[0], new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null),
  4165799628: (r, e) => new IFC4.IfcSectionReinforcementProperties(r, new IFC4.IfcLengthMeasure(e[0].value), new IFC4.IfcLengthMeasure(e[1].value), e[2] ? new IFC4.IfcLengthMeasure(e[2].value) : null, e[3], new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  1509187699: (r, e) => new IFC4.IfcSectionedSpine(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value))),
  4124623270: (r, e) => new IFC4.IfcShellBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  3692461612: (r, e) => new IFC4.IfcSimpleProperty(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null),
  2609359061: (r, e) => new IFC4.IfcSlippageConnectionCondition(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcLengthMeasure(e[3].value) : null),
  723233188: (r, e) => new IFC4.IfcSolidModel(r),
  1595516126: (r, e) => new IFC4.IfcStructuralLoadLinearForce(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLinearForceMeasure(e[1].value) : null, e[2] ? new IFC4.IfcLinearForceMeasure(e[2].value) : null, e[3] ? new IFC4.IfcLinearForceMeasure(e[3].value) : null, e[4] ? new IFC4.IfcLinearMomentMeasure(e[4].value) : null, e[5] ? new IFC4.IfcLinearMomentMeasure(e[5].value) : null, e[6] ? new IFC4.IfcLinearMomentMeasure(e[6].value) : null),
  2668620305: (r, e) => new IFC4.IfcStructuralLoadPlanarForce(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcPlanarForceMeasure(e[1].value) : null, e[2] ? new IFC4.IfcPlanarForceMeasure(e[2].value) : null, e[3] ? new IFC4.IfcPlanarForceMeasure(e[3].value) : null),
  2473145415: (r, e) => new IFC4.IfcStructuralLoadSingleDisplacement(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC4.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC4.IfcPlaneAngleMeasure(e[6].value) : null),
  1973038258: (r, e) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC4.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC4.IfcPlaneAngleMeasure(e[6].value) : null, e[7] ? new IFC4.IfcCurvatureMeasure(e[7].value) : null),
  1597423693: (r, e) => new IFC4.IfcStructuralLoadSingleForce(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC4.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC4.IfcTorqueMeasure(e[6].value) : null),
  1190533807: (r, e) => new IFC4.IfcStructuralLoadSingleForceWarping(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, e[1] ? new IFC4.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC4.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC4.IfcTorqueMeasure(e[6].value) : null, e[7] ? new IFC4.IfcWarpingMomentMeasure(e[7].value) : null),
  2233826070: (r, e) => new IFC4.IfcSubedge(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value)),
  2513912981: (r, e) => new IFC4.IfcSurface(r),
  1878645084: (r, e) => new IFC4.IfcSurfaceStyleRendering(r, new Handle(e[0].value), e[1] ? new IFC4.IfcNormalisedRatioMeasure(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? TypeInitialiser(2, e[7]) : null, e[8]),
  2247615214: (r, e) => new IFC4.IfcSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1260650574: (r, e) => new IFC4.IfcSweptDiskSolid(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC4.IfcPositiveLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4.IfcParameterValue(e[4].value) : null),
  1096409881: (r, e) => new IFC4.IfcSweptDiskSolidPolygonal(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC4.IfcPositiveLengthMeasure(e[2].value) : null, e[3] ? new IFC4.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4.IfcParameterValue(e[4].value) : null, e[5] ? new IFC4.IfcPositiveLengthMeasure(e[5].value) : null),
  230924584: (r, e) => new IFC4.IfcSweptSurface(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  3071757647: (r, e) => new IFC4.IfcTShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcNonNegativeLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcPlaneAngleMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPlaneAngleMeasure(e[11].value) : null),
  901063453: (r, e) => new IFC4.IfcTessellatedItem(r),
  4282788508: (r, e) => new IFC4.IfcTextLiteral(r, new IFC4.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2]),
  3124975700: (r, e) => new IFC4.IfcTextLiteralWithExtent(r, new IFC4.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2], new Handle(e[3].value), new IFC4.IfcBoxAlignment(e[4].value)),
  1983826977: (r, e) => new IFC4.IfcTextStyleFontModel(r, new IFC4.IfcLabel(e[0].value), e[1].map((s) => new IFC4.IfcTextFontName(s.value)), e[2] ? new IFC4.IfcFontStyle(e[2].value) : null, e[3] ? new IFC4.IfcFontVariant(e[3].value) : null, e[4] ? new IFC4.IfcFontWeight(e[4].value) : null, TypeInitialiser(2, e[5])),
  2715220739: (r, e) => new IFC4.IfcTrapeziumProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcLengthMeasure(e[6].value)),
  1628702193: (r, e) => new IFC4.IfcTypeObject(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null),
  3736923433: (r, e) => new IFC4.IfcTypeProcess(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2347495698: (r, e) => new IFC4.IfcTypeProduct(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null),
  3698973494: (r, e) => new IFC4.IfcTypeResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  427810014: (r, e) => new IFC4.IfcUShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPlaneAngleMeasure(e[9].value) : null),
  1417489154: (r, e) => new IFC4.IfcVector(r, new Handle(e[0].value), new IFC4.IfcLengthMeasure(e[1].value)),
  2759199220: (r, e) => new IFC4.IfcVertexLoop(r, new Handle(e[0].value)),
  1299126871: (r, e) => new IFC4.IfcWindowStyle(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9], new IFC4.IfcBoolean(e[10].value), new IFC4.IfcBoolean(e[11].value)),
  2543172580: (r, e) => new IFC4.IfcZShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNonNegativeLengthMeasure(e[8].value) : null),
  3406155212: (r, e) => new IFC4.IfcAdvancedFace(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new IFC4.IfcBoolean(e[2].value)),
  669184980: (r, e) => new IFC4.IfcAnnotationFillArea(r, new Handle(e[0].value), e[1] ? e[1].map((s) => new Handle(s.value)) : null),
  3207858831: (r, e) => new IFC4.IfcAsymmetricIShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, new IFC4.IfcPositiveLengthMeasure(e[8].value), e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcNonNegativeLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcNonNegativeLengthMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPlaneAngleMeasure(e[12].value) : null, e[13] ? new IFC4.IfcNonNegativeLengthMeasure(e[13].value) : null, e[14] ? new IFC4.IfcPlaneAngleMeasure(e[14].value) : null),
  4261334040: (r, e) => new IFC4.IfcAxis1Placement(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  3125803723: (r, e) => new IFC4.IfcAxis2Placement2D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  2740243338: (r, e) => new IFC4.IfcAxis2Placement3D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  2736907675: (r, e) => new IFC4.IfcBooleanResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  4182860854: (r, e) => new IFC4.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC4.IfcBoundingBox(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  2713105998: (r, e) => new IFC4.IfcBoxedHalfSpace(r, new Handle(e[0].value), new IFC4.IfcBoolean(e[1].value), new Handle(e[2].value)),
  2898889636: (r, e) => new IFC4.IfcCShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null),
  1123145078: (r, e) => new IFC4.IfcCartesianPoint(r, e[0].map((s) => new IFC4.IfcLengthMeasure(s.value))),
  574549367: (r, e) => new IFC4.IfcCartesianPointList(r),
  1675464909: (r, e) => new IFC4.IfcCartesianPointList2D(r, e[0].map((s) => new IFC4.IfcLengthMeasure(s.value))),
  2059837836: (r, e) => new IFC4.IfcCartesianPointList3D(r, e[0].map((s) => new IFC4.IfcLengthMeasure(s.value))),
  59481748: (r, e) => new IFC4.IfcCartesianTransformationOperator(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null),
  3749851601: (r, e) => new IFC4.IfcCartesianTransformationOperator2D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null),
  3486308946: (r, e) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null, e[4] ? new IFC4.IfcReal(e[4].value) : null),
  3331915920: (r, e) => new IFC4.IfcCartesianTransformationOperator3D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  1416205885: (r, e) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcReal(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4.IfcReal(e[5].value) : null, e[6] ? new IFC4.IfcReal(e[6].value) : null),
  1383045692: (r, e) => new IFC4.IfcCircleProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  2205249479: (r, e) => new IFC4.IfcClosedShell(r, e[0].map((s) => new Handle(s.value))),
  776857604: (r, e) => new IFC4.IfcColourRgb(r, e[0] ? new IFC4.IfcLabel(e[0].value) : null, new IFC4.IfcNormalisedRatioMeasure(e[1].value), new IFC4.IfcNormalisedRatioMeasure(e[2].value), new IFC4.IfcNormalisedRatioMeasure(e[3].value)),
  2542286263: (r, e) => new IFC4.IfcComplexProperty(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, new IFC4.IfcIdentifier(e[2].value), e[3].map((s) => new Handle(s.value))),
  2485617015: (r, e) => new IFC4.IfcCompositeCurveSegment(r, e[0], new IFC4.IfcBoolean(e[1].value), new Handle(e[2].value)),
  2574617495: (r, e) => new IFC4.IfcConstructionResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null),
  3419103109: (r, e) => new IFC4.IfcContext(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  1815067380: (r, e) => new IFC4.IfcCrewResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  2506170314: (r, e) => new IFC4.IfcCsgPrimitive3D(r, new Handle(e[0].value)),
  2147822146: (r, e) => new IFC4.IfcCsgSolid(r, new Handle(e[0].value)),
  2601014836: (r, e) => new IFC4.IfcCurve(r),
  2827736869: (r, e) => new IFC4.IfcCurveBoundedPlane(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2629017746: (r, e) => new IFC4.IfcCurveBoundedSurface(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), new IFC4.IfcBoolean(e[2].value)),
  32440307: (r, e) => new IFC4.IfcDirection(r, e[0].map((s) => new IFC4.IfcReal(s.value))),
  526551008: (r, e) => new IFC4.IfcDoorStyle(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9], new IFC4.IfcBoolean(e[10].value), new IFC4.IfcBoolean(e[11].value)),
  1472233963: (r, e) => new IFC4.IfcEdgeLoop(r, e[0].map((s) => new Handle(s.value))),
  1883228015: (r, e) => new IFC4.IfcElementQuantity(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  339256511: (r, e) => new IFC4.IfcElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2777663545: (r, e) => new IFC4.IfcElementarySurface(r, new Handle(e[0].value)),
  2835456948: (r, e) => new IFC4.IfcEllipseProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value)),
  4024345920: (r, e) => new IFC4.IfcEventType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4.IfcLabel(e[11].value) : null),
  477187591: (r, e) => new IFC4.IfcExtrudedAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  2804161546: (r, e) => new IFC4.IfcExtrudedAreaSolidTapered(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value), new Handle(e[4].value)),
  2047409740: (r, e) => new IFC4.IfcFaceBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  374418227: (r, e) => new IFC4.IfcFillAreaStyleHatching(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, new IFC4.IfcPlaneAngleMeasure(e[4].value)),
  315944413: (r, e) => new IFC4.IfcFillAreaStyleTiles(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new Handle(s.value)), new IFC4.IfcPositiveRatioMeasure(e[2].value)),
  2652556860: (r, e) => new IFC4.IfcFixedReferenceSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4.IfcParameterValue(e[4].value) : null, new Handle(e[5].value)),
  4238390223: (r, e) => new IFC4.IfcFurnishingElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1268542332: (r, e) => new IFC4.IfcFurnitureType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10]),
  4095422895: (r, e) => new IFC4.IfcGeographicElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  987898635: (r, e) => new IFC4.IfcGeometricCurveSet(r, e[0].map((s) => new Handle(s.value))),
  1484403080: (r, e) => new IFC4.IfcIShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), new IFC4.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPlaneAngleMeasure(e[9].value) : null),
  178912537: (r, e) => new IFC4.IfcIndexedPolygonalFace(r, e[0].map((s) => new IFC4.IfcPositiveInteger(s.value))),
  2294589976: (r, e) => new IFC4.IfcIndexedPolygonalFaceWithVoids(r, e[0].map((s) => new IFC4.IfcPositiveInteger(s.value)), e[1].map((s) => new IFC4.IfcPositiveInteger(s.value))),
  572779678: (r, e) => new IFC4.IfcLShapeProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null, new IFC4.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC4.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcPlaneAngleMeasure(e[8].value) : null),
  428585644: (r, e) => new IFC4.IfcLaborResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  1281925730: (r, e) => new IFC4.IfcLine(r, new Handle(e[0].value), new Handle(e[1].value)),
  1425443689: (r, e) => new IFC4.IfcManifoldSolidBrep(r, new Handle(e[0].value)),
  3888040117: (r, e) => new IFC4.IfcObject(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  3388369263: (r, e) => new IFC4.IfcOffsetCurve2D(r, new Handle(e[0].value), new IFC4.IfcLengthMeasure(e[1].value), new IFC4.IfcLogical(e[2].value)),
  3505215534: (r, e) => new IFC4.IfcOffsetCurve3D(r, new Handle(e[0].value), new IFC4.IfcLengthMeasure(e[1].value), new IFC4.IfcLogical(e[2].value), new Handle(e[3].value)),
  1682466193: (r, e) => new IFC4.IfcPcurve(r, new Handle(e[0].value), new Handle(e[1].value)),
  603570806: (r, e) => new IFC4.IfcPlanarBox(r, new IFC4.IfcLengthMeasure(e[0].value), new IFC4.IfcLengthMeasure(e[1].value), new Handle(e[2].value)),
  220341763: (r, e) => new IFC4.IfcPlane(r, new Handle(e[0].value)),
  759155922: (r, e) => new IFC4.IfcPreDefinedColour(r, new IFC4.IfcLabel(e[0].value)),
  2559016684: (r, e) => new IFC4.IfcPreDefinedCurveFont(r, new IFC4.IfcLabel(e[0].value)),
  3967405729: (r, e) => new IFC4.IfcPreDefinedPropertySet(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  569719735: (r, e) => new IFC4.IfcProcedureType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2945172077: (r, e) => new IFC4.IfcProcess(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null),
  4208778838: (r, e) => new IFC4.IfcProduct(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  103090709: (r, e) => new IFC4.IfcProject(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  653396225: (r, e) => new IFC4.IfcProjectLibrary(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  871118103: (r, e) => new IFC4.IfcPropertyBoundedValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? TypeInitialiser(2, e[3]) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? TypeInitialiser(2, e[5]) : null),
  4166981789: (r, e) => new IFC4.IfcPropertyEnumeratedValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(2, s)) : null, e[3] ? new Handle(e[3].value) : null),
  2752243245: (r, e) => new IFC4.IfcPropertyListValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(2, s)) : null, e[3] ? new Handle(e[3].value) : null),
  941946838: (r, e) => new IFC4.IfcPropertyReferenceValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? new IFC4.IfcText(e[2].value) : null, e[3] ? new Handle(e[3].value) : null),
  1451395588: (r, e) => new IFC4.IfcPropertySet(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  492091185: (r, e) => new IFC4.IfcPropertySetTemplate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4], e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6].map((s) => new Handle(s.value))),
  3650150729: (r, e) => new IFC4.IfcPropertySingleValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(2, e[2]) : null, e[3] ? new Handle(e[3].value) : null),
  110355661: (r, e) => new IFC4.IfcPropertyTableValue(r, new IFC4.IfcIdentifier(e[0].value), e[1] ? new IFC4.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(2, s)) : null, e[3] ? e[3].map((s) => TypeInitialiser(2, s)) : null, e[4] ? new IFC4.IfcText(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  3521284610: (r, e) => new IFC4.IfcPropertyTemplate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  3219374653: (r, e) => new IFC4.IfcProxy(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2770003689: (r, e) => new IFC4.IfcRectangleHollowProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value), new IFC4.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC4.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null),
  2798486643: (r, e) => new IFC4.IfcRectangularPyramid(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  3454111270: (r, e) => new IFC4.IfcRectangularTrimmedSurface(r, new Handle(e[0].value), new IFC4.IfcParameterValue(e[1].value), new IFC4.IfcParameterValue(e[2].value), new IFC4.IfcParameterValue(e[3].value), new IFC4.IfcParameterValue(e[4].value), new IFC4.IfcBoolean(e[5].value), new IFC4.IfcBoolean(e[6].value)),
  3765753017: (r, e) => new IFC4.IfcReinforcementDefinitionProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  3939117080: (r, e) => new IFC4.IfcRelAssigns(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5]),
  1683148259: (r, e) => new IFC4.IfcRelAssignsToActor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2495723537: (r, e) => new IFC4.IfcRelAssignsToControl(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1307041759: (r, e) => new IFC4.IfcRelAssignsToGroup(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1027710054: (r, e) => new IFC4.IfcRelAssignsToGroupByFactor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), new IFC4.IfcRatioMeasure(e[7].value)),
  4278684876: (r, e) => new IFC4.IfcRelAssignsToProcess(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2857406711: (r, e) => new IFC4.IfcRelAssignsToProduct(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  205026976: (r, e) => new IFC4.IfcRelAssignsToResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1865459582: (r, e) => new IFC4.IfcRelAssociates(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  4095574036: (r, e) => new IFC4.IfcRelAssociatesApproval(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  919958153: (r, e) => new IFC4.IfcRelAssociatesClassification(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2728634034: (r, e) => new IFC4.IfcRelAssociatesConstraint(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5] ? new IFC4.IfcLabel(e[5].value) : null, new Handle(e[6].value)),
  982818633: (r, e) => new IFC4.IfcRelAssociatesDocument(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3840914261: (r, e) => new IFC4.IfcRelAssociatesLibrary(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2655215786: (r, e) => new IFC4.IfcRelAssociatesMaterial(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  826625072: (r, e) => new IFC4.IfcRelConnects(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  1204542856: (r, e) => new IFC4.IfcRelConnectsElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value)),
  3945020480: (r, e) => new IFC4.IfcRelConnectsPathElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => new IFC4.IfcInteger(s.value)) : null, e[8] ? e[8].map((s) => new IFC4.IfcInteger(s.value)) : null, e[9], e[10]),
  4201705270: (r, e) => new IFC4.IfcRelConnectsPortToElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  3190031847: (r, e) => new IFC4.IfcRelConnectsPorts(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null),
  2127690289: (r, e) => new IFC4.IfcRelConnectsStructuralActivity(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1638771189: (r, e) => new IFC4.IfcRelConnectsStructuralMember(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC4.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null),
  504942748: (r, e) => new IFC4.IfcRelConnectsWithEccentricity(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC4.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, new Handle(e[10].value)),
  3678494232: (r, e) => new IFC4.IfcRelConnectsWithRealizingElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7].map((s) => new Handle(s.value)), e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3242617779: (r, e) => new IFC4.IfcRelContainedInSpatialStructure(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  886880790: (r, e) => new IFC4.IfcRelCoversBldgElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2802773753: (r, e) => new IFC4.IfcRelCoversSpaces(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2565941209: (r, e) => new IFC4.IfcRelDeclares(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2551354335: (r, e) => new IFC4.IfcRelDecomposes(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  693640335: (r, e) => new IFC4.IfcRelDefines(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null),
  1462361463: (r, e) => new IFC4.IfcRelDefinesByObject(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4186316022: (r, e) => new IFC4.IfcRelDefinesByProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  307848117: (r, e) => new IFC4.IfcRelDefinesByTemplate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  781010003: (r, e) => new IFC4.IfcRelDefinesByType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3940055652: (r, e) => new IFC4.IfcRelFillsElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  279856033: (r, e) => new IFC4.IfcRelFlowControlElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  427948657: (r, e) => new IFC4.IfcRelInterferesElements(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8].value),
  3268803585: (r, e) => new IFC4.IfcRelNests(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  750771296: (r, e) => new IFC4.IfcRelProjectsElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1245217292: (r, e) => new IFC4.IfcRelReferencedInSpatialStructure(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4122056220: (r, e) => new IFC4.IfcRelSequence(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  366585022: (r, e) => new IFC4.IfcRelServicesBuildings(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  3451746338: (r, e) => new IFC4.IfcRelSpaceBoundary(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8]),
  3523091289: (r, e) => new IFC4.IfcRelSpaceBoundary1stLevel(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9] ? new Handle(e[9].value) : null),
  1521410863: (r, e) => new IFC4.IfcRelSpaceBoundary2ndLevel(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  1401173127: (r, e) => new IFC4.IfcRelVoidsElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  816062949: (r, e) => new IFC4.IfcReparametrisedCompositeCurveSegment(r, e[0], new IFC4.IfcBoolean(e[1].value), new Handle(e[2].value), new IFC4.IfcParameterValue(e[3].value)),
  2914609552: (r, e) => new IFC4.IfcResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null),
  1856042241: (r, e) => new IFC4.IfcRevolvedAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcPlaneAngleMeasure(e[3].value)),
  3243963512: (r, e) => new IFC4.IfcRevolvedAreaSolidTapered(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcPlaneAngleMeasure(e[3].value), new Handle(e[4].value)),
  4158566097: (r, e) => new IFC4.IfcRightCircularCone(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value)),
  3626867408: (r, e) => new IFC4.IfcRightCircularCylinder(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value)),
  3663146110: (r, e) => new IFC4.IfcSimplePropertyTemplate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4], e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6] ? new IFC4.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new IFC4.IfcLabel(e[10].value) : null, e[11]),
  1412071761: (r, e) => new IFC4.IfcSpatialElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null),
  710998568: (r, e) => new IFC4.IfcSpatialElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2706606064: (r, e) => new IFC4.IfcSpatialStructureElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8]),
  3893378262: (r, e) => new IFC4.IfcSpatialStructureElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  463610769: (r, e) => new IFC4.IfcSpatialZone(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8]),
  2481509218: (r, e) => new IFC4.IfcSpatialZoneType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcLabel(e[10].value) : null),
  451544542: (r, e) => new IFC4.IfcSphere(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value)),
  4015995234: (r, e) => new IFC4.IfcSphericalSurface(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value)),
  3544373492: (r, e) => new IFC4.IfcStructuralActivity(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3136571912: (r, e) => new IFC4.IfcStructuralItem(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  530289379: (r, e) => new IFC4.IfcStructuralMember(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3689010777: (r, e) => new IFC4.IfcStructuralReaction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3979015343: (r, e) => new IFC4.IfcStructuralSurfaceMember(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null),
  2218152070: (r, e) => new IFC4.IfcStructuralSurfaceMemberVarying(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null),
  603775116: (r, e) => new IFC4.IfcStructuralSurfaceReaction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9]),
  4095615324: (r, e) => new IFC4.IfcSubContractResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  699246055: (r, e) => new IFC4.IfcSurfaceCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  2028607225: (r, e) => new IFC4.IfcSurfaceCurveSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4.IfcParameterValue(e[4].value) : null, new Handle(e[5].value)),
  2809605785: (r, e) => new IFC4.IfcSurfaceOfLinearExtrusion(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4.IfcLengthMeasure(e[3].value)),
  4124788165: (r, e) => new IFC4.IfcSurfaceOfRevolution(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value)),
  1580310250: (r, e) => new IFC4.IfcSystemFurnitureElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3473067441: (r, e) => new IFC4.IfcTask(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, new IFC4.IfcBoolean(e[9].value), e[10] ? new IFC4.IfcInteger(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12]),
  3206491090: (r, e) => new IFC4.IfcTaskType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcLabel(e[10].value) : null),
  2387106220: (r, e) => new IFC4.IfcTessellatedFaceSet(r, new Handle(e[0].value)),
  1935646853: (r, e) => new IFC4.IfcToroidalSurface(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value)),
  2097647324: (r, e) => new IFC4.IfcTransportElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2916149573: (r, e) => new IFC4.IfcTriangulatedFaceSet(r, new Handle(e[0].value), e[1] ? e[1].map((s) => new IFC4.IfcParameterValue(s.value)) : null, e[2] ? new IFC4.IfcBoolean(e[2].value) : null, e[3].map((s) => new IFC4.IfcPositiveInteger(s.value)), e[4] ? e[4].map((s) => new IFC4.IfcPositiveInteger(s.value)) : null),
  336235671: (r, e) => new IFC4.IfcWindowLiningProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4.IfcNonNegativeLengthMeasure(e[5].value) : null, e[6] ? new IFC4.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNormalisedRatioMeasure(e[8].value) : null, e[9] ? new IFC4.IfcNormalisedRatioMeasure(e[9].value) : null, e[10] ? new IFC4.IfcNormalisedRatioMeasure(e[10].value) : null, e[11] ? new IFC4.IfcNormalisedRatioMeasure(e[11].value) : null, e[12] ? new Handle(e[12].value) : null, e[13] ? new IFC4.IfcLengthMeasure(e[13].value) : null, e[14] ? new IFC4.IfcLengthMeasure(e[14].value) : null, e[15] ? new IFC4.IfcLengthMeasure(e[15].value) : null),
  512836454: (r, e) => new IFC4.IfcWindowPanelProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC4.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  2296667514: (r, e) => new IFC4.IfcActor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, new Handle(e[5].value)),
  1635779807: (r, e) => new IFC4.IfcAdvancedBrep(r, new Handle(e[0].value)),
  2603310189: (r, e) => new IFC4.IfcAdvancedBrepWithVoids(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  1674181508: (r, e) => new IFC4.IfcAnnotation(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  2887950389: (r, e) => new IFC4.IfcBSplineSurface(r, new IFC4.IfcInteger(e[0].value), new IFC4.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4.IfcLogical(e[4].value), new IFC4.IfcLogical(e[5].value), new IFC4.IfcLogical(e[6].value)),
  167062518: (r, e) => new IFC4.IfcBSplineSurfaceWithKnots(r, new IFC4.IfcInteger(e[0].value), new IFC4.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4.IfcLogical(e[4].value), new IFC4.IfcLogical(e[5].value), new IFC4.IfcLogical(e[6].value), e[7].map((s) => new IFC4.IfcInteger(s.value)), e[8].map((s) => new IFC4.IfcInteger(s.value)), e[9].map((s) => new IFC4.IfcParameterValue(s.value)), e[10].map((s) => new IFC4.IfcParameterValue(s.value)), e[11]),
  1334484129: (r, e) => new IFC4.IfcBlock(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value), new IFC4.IfcPositiveLengthMeasure(e[3].value)),
  3649129432: (r, e) => new IFC4.IfcBooleanClippingResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  1260505505: (r, e) => new IFC4.IfcBoundedCurve(r),
  4031249490: (r, e) => new IFC4.IfcBuilding(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcLengthMeasure(e[10].value) : null, e[11] ? new Handle(e[11].value) : null),
  1950629157: (r, e) => new IFC4.IfcBuildingElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3124254112: (r, e) => new IFC4.IfcBuildingStorey(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4.IfcLengthMeasure(e[9].value) : null),
  2197970202: (r, e) => new IFC4.IfcChimneyType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2937912522: (r, e) => new IFC4.IfcCircleHollowProfileDef(r, e[0], e[1] ? new IFC4.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4.IfcPositiveLengthMeasure(e[3].value), new IFC4.IfcPositiveLengthMeasure(e[4].value)),
  3893394355: (r, e) => new IFC4.IfcCivilElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  300633059: (r, e) => new IFC4.IfcColumnType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3875453745: (r, e) => new IFC4.IfcComplexPropertyTemplate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6] ? e[6].map((s) => new Handle(s.value)) : null),
  3732776249: (r, e) => new IFC4.IfcCompositeCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4.IfcLogical(e[1].value)),
  15328376: (r, e) => new IFC4.IfcCompositeCurveOnSurface(r, e[0].map((s) => new Handle(s.value)), new IFC4.IfcLogical(e[1].value)),
  2510884976: (r, e) => new IFC4.IfcConic(r, new Handle(e[0].value)),
  2185764099: (r, e) => new IFC4.IfcConstructionEquipmentResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  4105962743: (r, e) => new IFC4.IfcConstructionMaterialResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  1525564444: (r, e) => new IFC4.IfcConstructionProductResourceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4.IfcText(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  2559216714: (r, e) => new IFC4.IfcConstructionResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null),
  3293443760: (r, e) => new IFC4.IfcControl(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null),
  3895139033: (r, e) => new IFC4.IfcCostItem(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6], e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null),
  1419761937: (r, e) => new IFC4.IfcCostSchedule(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcDateTime(e[8].value) : null, e[9] ? new IFC4.IfcDateTime(e[9].value) : null),
  1916426348: (r, e) => new IFC4.IfcCoveringType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3295246426: (r, e) => new IFC4.IfcCrewResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1457835157: (r, e) => new IFC4.IfcCurtainWallType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1213902940: (r, e) => new IFC4.IfcCylindricalSurface(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value)),
  3256556792: (r, e) => new IFC4.IfcDistributionElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3849074793: (r, e) => new IFC4.IfcDistributionFlowElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2963535650: (r, e) => new IFC4.IfcDoorLiningProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4.IfcNonNegativeLengthMeasure(e[5].value) : null, e[6] ? new IFC4.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4.IfcPositiveLengthMeasure(e[13].value) : null, e[14] ? new Handle(e[14].value) : null, e[15] ? new IFC4.IfcLengthMeasure(e[15].value) : null, e[16] ? new IFC4.IfcLengthMeasure(e[16].value) : null),
  1714330368: (r, e) => new IFC4.IfcDoorPanelProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcPositiveLengthMeasure(e[4].value) : null, e[5], e[6] ? new IFC4.IfcNormalisedRatioMeasure(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  2323601079: (r, e) => new IFC4.IfcDoorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4.IfcBoolean(e[11].value) : null, e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  445594917: (r, e) => new IFC4.IfcDraughtingPreDefinedColour(r, new IFC4.IfcLabel(e[0].value)),
  4006246654: (r, e) => new IFC4.IfcDraughtingPreDefinedCurveFont(r, new IFC4.IfcLabel(e[0].value)),
  1758889154: (r, e) => new IFC4.IfcElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  4123344466: (r, e) => new IFC4.IfcElementAssembly(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  2397081782: (r, e) => new IFC4.IfcElementAssemblyType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1623761950: (r, e) => new IFC4.IfcElementComponent(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2590856083: (r, e) => new IFC4.IfcElementComponentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1704287377: (r, e) => new IFC4.IfcEllipse(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value), new IFC4.IfcPositiveLengthMeasure(e[2].value)),
  2107101300: (r, e) => new IFC4.IfcEnergyConversionDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  132023988: (r, e) => new IFC4.IfcEngineType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3174744832: (r, e) => new IFC4.IfcEvaporativeCoolerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3390157468: (r, e) => new IFC4.IfcEvaporatorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4148101412: (r, e) => new IFC4.IfcEvent(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7], e[8], e[9] ? new IFC4.IfcLabel(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  2853485674: (r, e) => new IFC4.IfcExternalSpatialStructureElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null),
  807026263: (r, e) => new IFC4.IfcFacetedBrep(r, new Handle(e[0].value)),
  3737207727: (r, e) => new IFC4.IfcFacetedBrepWithVoids(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  647756555: (r, e) => new IFC4.IfcFastener(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2489546625: (r, e) => new IFC4.IfcFastenerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2827207264: (r, e) => new IFC4.IfcFeatureElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2143335405: (r, e) => new IFC4.IfcFeatureElementAddition(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  1287392070: (r, e) => new IFC4.IfcFeatureElementSubtraction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  3907093117: (r, e) => new IFC4.IfcFlowControllerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3198132628: (r, e) => new IFC4.IfcFlowFittingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3815607619: (r, e) => new IFC4.IfcFlowMeterType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1482959167: (r, e) => new IFC4.IfcFlowMovingDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1834744321: (r, e) => new IFC4.IfcFlowSegmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1339347760: (r, e) => new IFC4.IfcFlowStorageDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2297155007: (r, e) => new IFC4.IfcFlowTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  3009222698: (r, e) => new IFC4.IfcFlowTreatmentDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1893162501: (r, e) => new IFC4.IfcFootingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  263784265: (r, e) => new IFC4.IfcFurnishingElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  1509553395: (r, e) => new IFC4.IfcFurniture(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3493046030: (r, e) => new IFC4.IfcGeographicElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3009204131: (r, e) => new IFC4.IfcGrid(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7].map((s) => new Handle(s.value)), e[8].map((s) => new Handle(s.value)), e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10]),
  2706460486: (r, e) => new IFC4.IfcGroup(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  1251058090: (r, e) => new IFC4.IfcHeatExchangerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1806887404: (r, e) => new IFC4.IfcHumidifierType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2571569899: (r, e) => new IFC4.IfcIndexedPolyCurve(r, new Handle(e[0].value), e[1] ? e[1].map((s) => TypeInitialiser(2, s)) : null, e[2] ? new IFC4.IfcBoolean(e[2].value) : null),
  3946677679: (r, e) => new IFC4.IfcInterceptorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3113134337: (r, e) => new IFC4.IfcIntersectionCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  2391368822: (r, e) => new IFC4.IfcInventory(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4.IfcDate(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  4288270099: (r, e) => new IFC4.IfcJunctionBoxType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3827777499: (r, e) => new IFC4.IfcLaborResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1051575348: (r, e) => new IFC4.IfcLampType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1161773419: (r, e) => new IFC4.IfcLightFixtureType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  377706215: (r, e) => new IFC4.IfcMechanicalFastener(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10]),
  2108223431: (r, e) => new IFC4.IfcMechanicalFastenerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPositiveLengthMeasure(e[11].value) : null),
  1114901282: (r, e) => new IFC4.IfcMedicalDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3181161470: (r, e) => new IFC4.IfcMemberType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  977012517: (r, e) => new IFC4.IfcMotorConnectionType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4143007308: (r, e) => new IFC4.IfcOccupant(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, new Handle(e[5].value), e[6]),
  3588315303: (r, e) => new IFC4.IfcOpeningElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3079942009: (r, e) => new IFC4.IfcOpeningStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2837617999: (r, e) => new IFC4.IfcOutletType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2382730787: (r, e) => new IFC4.IfcPerformanceHistory(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, new IFC4.IfcLabel(e[6].value), e[7]),
  3566463478: (r, e) => new IFC4.IfcPermeableCoveringProperties(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC4.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  3327091369: (r, e) => new IFC4.IfcPermit(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcText(e[8].value) : null),
  1158309216: (r, e) => new IFC4.IfcPileType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  804291784: (r, e) => new IFC4.IfcPipeFittingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4231323485: (r, e) => new IFC4.IfcPipeSegmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4017108033: (r, e) => new IFC4.IfcPlateType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2839578677: (r, e) => new IFC4.IfcPolygonalFaceSet(r, new Handle(e[0].value), e[1] ? new IFC4.IfcBoolean(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? e[3].map((s) => new IFC4.IfcPositiveInteger(s.value)) : null),
  3724593414: (r, e) => new IFC4.IfcPolyline(r, e[0].map((s) => new Handle(s.value))),
  3740093272: (r, e) => new IFC4.IfcPort(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  2744685151: (r, e) => new IFC4.IfcProcedure(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7]),
  2904328755: (r, e) => new IFC4.IfcProjectOrder(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcText(e[8].value) : null),
  3651124850: (r, e) => new IFC4.IfcProjectionElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1842657554: (r, e) => new IFC4.IfcProtectiveDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2250791053: (r, e) => new IFC4.IfcPumpType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2893384427: (r, e) => new IFC4.IfcRailingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2324767716: (r, e) => new IFC4.IfcRampFlightType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1469900589: (r, e) => new IFC4.IfcRampType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  683857671: (r, e) => new IFC4.IfcRationalBSplineSurfaceWithKnots(r, new IFC4.IfcInteger(e[0].value), new IFC4.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4.IfcLogical(e[4].value), new IFC4.IfcLogical(e[5].value), new IFC4.IfcLogical(e[6].value), e[7].map((s) => new IFC4.IfcInteger(s.value)), e[8].map((s) => new IFC4.IfcInteger(s.value)), e[9].map((s) => new IFC4.IfcParameterValue(s.value)), e[10].map((s) => new IFC4.IfcParameterValue(s.value)), e[11], e[12].map((s) => new IFC4.IfcReal(s.value))),
  3027567501: (r, e) => new IFC4.IfcReinforcingElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  964333572: (r, e) => new IFC4.IfcReinforcingElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  2320036040: (r, e) => new IFC4.IfcReinforcingMesh(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPositiveLengthMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4.IfcAreaMeasure(e[13].value) : null, e[14] ? new IFC4.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC4.IfcPositiveLengthMeasure(e[15].value) : null, e[16] ? new IFC4.IfcPositiveLengthMeasure(e[16].value) : null, e[17]),
  2310774935: (r, e) => new IFC4.IfcReinforcingMeshType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPositiveLengthMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4.IfcPositiveLengthMeasure(e[13].value) : null, e[14] ? new IFC4.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC4.IfcAreaMeasure(e[15].value) : null, e[16] ? new IFC4.IfcPositiveLengthMeasure(e[16].value) : null, e[17] ? new IFC4.IfcPositiveLengthMeasure(e[17].value) : null, e[18] ? new IFC4.IfcLabel(e[18].value) : null, e[19] ? e[19].map((s) => TypeInitialiser(2, s)) : null),
  160246688: (r, e) => new IFC4.IfcRelAggregates(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2781568857: (r, e) => new IFC4.IfcRoofType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1768891740: (r, e) => new IFC4.IfcSanitaryTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2157484638: (r, e) => new IFC4.IfcSeamCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  4074543187: (r, e) => new IFC4.IfcShadingDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4097777520: (r, e) => new IFC4.IfcSite(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4.IfcCompoundPlaneAngleMeasure(e[9].map((s) => s.value)) : null, e[10] ? new IFC4.IfcCompoundPlaneAngleMeasure(e[10].map((s) => s.value)) : null, e[11] ? new IFC4.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC4.IfcLabel(e[12].value) : null, e[13] ? new Handle(e[13].value) : null),
  2533589738: (r, e) => new IFC4.IfcSlabType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1072016465: (r, e) => new IFC4.IfcSolarDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3856911033: (r, e) => new IFC4.IfcSpace(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8], e[9], e[10] ? new IFC4.IfcLengthMeasure(e[10].value) : null),
  1305183839: (r, e) => new IFC4.IfcSpaceHeaterType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3812236995: (r, e) => new IFC4.IfcSpaceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcLabel(e[10].value) : null),
  3112655638: (r, e) => new IFC4.IfcStackTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1039846685: (r, e) => new IFC4.IfcStairFlightType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  338393293: (r, e) => new IFC4.IfcStairType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  682877961: (r, e) => new IFC4.IfcStructuralAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null),
  1179482911: (r, e) => new IFC4.IfcStructuralConnection(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  1004757350: (r, e) => new IFC4.IfcStructuralCurveAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null, e[10], e[11]),
  4243806635: (r, e) => new IFC4.IfcStructuralCurveConnection(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new Handle(e[8].value)),
  214636428: (r, e) => new IFC4.IfcStructuralCurveMember(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], new Handle(e[8].value)),
  2445595289: (r, e) => new IFC4.IfcStructuralCurveMemberVarying(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], new Handle(e[8].value)),
  2757150158: (r, e) => new IFC4.IfcStructuralCurveReaction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9]),
  1807405624: (r, e) => new IFC4.IfcStructuralLinearAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1252848954: (r, e) => new IFC4.IfcStructuralLoadGroup(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6], e[7], e[8] ? new IFC4.IfcRatioMeasure(e[8].value) : null, e[9] ? new IFC4.IfcLabel(e[9].value) : null),
  2082059205: (r, e) => new IFC4.IfcStructuralPointAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null),
  734778138: (r, e) => new IFC4.IfcStructuralPointConnection(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  1235345126: (r, e) => new IFC4.IfcStructuralPointReaction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  2986769608: (r, e) => new IFC4.IfcStructuralResultGroup(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, new IFC4.IfcBoolean(e[7].value)),
  3657597509: (r, e) => new IFC4.IfcStructuralSurfaceAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1975003073: (r, e) => new IFC4.IfcStructuralSurfaceConnection(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  148013059: (r, e) => new IFC4.IfcSubContractResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  3101698114: (r, e) => new IFC4.IfcSurfaceFeature(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2315554128: (r, e) => new IFC4.IfcSwitchingDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2254336722: (r, e) => new IFC4.IfcSystem(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null),
  413509423: (r, e) => new IFC4.IfcSystemFurnitureElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  5716631: (r, e) => new IFC4.IfcTankType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3824725483: (r, e) => new IFC4.IfcTendon(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4.IfcForceMeasure(e[12].value) : null, e[13] ? new IFC4.IfcPressureMeasure(e[13].value) : null, e[14] ? new IFC4.IfcNormalisedRatioMeasure(e[14].value) : null, e[15] ? new IFC4.IfcPositiveLengthMeasure(e[15].value) : null, e[16] ? new IFC4.IfcPositiveLengthMeasure(e[16].value) : null),
  2347447852: (r, e) => new IFC4.IfcTendonAnchor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3081323446: (r, e) => new IFC4.IfcTendonAnchorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2415094496: (r, e) => new IFC4.IfcTendonType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPositiveLengthMeasure(e[12].value) : null),
  1692211062: (r, e) => new IFC4.IfcTransformerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1620046519: (r, e) => new IFC4.IfcTransportElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3593883385: (r, e) => new IFC4.IfcTrimmedCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value)), new IFC4.IfcBoolean(e[3].value), e[4]),
  1600972822: (r, e) => new IFC4.IfcTubeBundleType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1911125066: (r, e) => new IFC4.IfcUnitaryEquipmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  728799441: (r, e) => new IFC4.IfcValveType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2391383451: (r, e) => new IFC4.IfcVibrationIsolator(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3313531582: (r, e) => new IFC4.IfcVibrationIsolatorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2769231204: (r, e) => new IFC4.IfcVirtualElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  926996030: (r, e) => new IFC4.IfcVoidingFeature(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1898987631: (r, e) => new IFC4.IfcWallType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1133259667: (r, e) => new IFC4.IfcWasteTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4009809668: (r, e) => new IFC4.IfcWindowType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4.IfcBoolean(e[11].value) : null, e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  4088093105: (r, e) => new IFC4.IfcWorkCalendar(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8]),
  1028945134: (r, e) => new IFC4.IfcWorkControl(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, new IFC4.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcDuration(e[9].value) : null, e[10] ? new IFC4.IfcDuration(e[10].value) : null, new IFC4.IfcDateTime(e[11].value), e[12] ? new IFC4.IfcDateTime(e[12].value) : null),
  4218914973: (r, e) => new IFC4.IfcWorkPlan(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, new IFC4.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcDuration(e[9].value) : null, e[10] ? new IFC4.IfcDuration(e[10].value) : null, new IFC4.IfcDateTime(e[11].value), e[12] ? new IFC4.IfcDateTime(e[12].value) : null, e[13]),
  3342526732: (r, e) => new IFC4.IfcWorkSchedule(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, new IFC4.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcDuration(e[9].value) : null, e[10] ? new IFC4.IfcDuration(e[10].value) : null, new IFC4.IfcDateTime(e[11].value), e[12] ? new IFC4.IfcDateTime(e[12].value) : null, e[13]),
  1033361043: (r, e) => new IFC4.IfcZone(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null),
  3821786052: (r, e) => new IFC4.IfcActionRequest(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcText(e[8].value) : null),
  1411407467: (r, e) => new IFC4.IfcAirTerminalBoxType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3352864051: (r, e) => new IFC4.IfcAirTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1871374353: (r, e) => new IFC4.IfcAirToAirHeatRecoveryType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3460190687: (r, e) => new IFC4.IfcAsset(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12] ? new IFC4.IfcDate(e[12].value) : null, e[13] ? new Handle(e[13].value) : null),
  1532957894: (r, e) => new IFC4.IfcAudioVisualApplianceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1967976161: (r, e) => new IFC4.IfcBSplineCurve(r, new IFC4.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4.IfcLogical(e[3].value), new IFC4.IfcLogical(e[4].value)),
  2461110595: (r, e) => new IFC4.IfcBSplineCurveWithKnots(r, new IFC4.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4.IfcLogical(e[3].value), new IFC4.IfcLogical(e[4].value), e[5].map((s) => new IFC4.IfcInteger(s.value)), e[6].map((s) => new IFC4.IfcParameterValue(s.value)), e[7]),
  819618141: (r, e) => new IFC4.IfcBeamType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  231477066: (r, e) => new IFC4.IfcBoilerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1136057603: (r, e) => new IFC4.IfcBoundaryCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4.IfcLogical(e[1].value)),
  3299480353: (r, e) => new IFC4.IfcBuildingElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2979338954: (r, e) => new IFC4.IfcBuildingElementPart(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  39481116: (r, e) => new IFC4.IfcBuildingElementPartType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1095909175: (r, e) => new IFC4.IfcBuildingElementProxy(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1909888760: (r, e) => new IFC4.IfcBuildingElementProxyType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1177604601: (r, e) => new IFC4.IfcBuildingSystem(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6] ? new IFC4.IfcLabel(e[6].value) : null),
  2188180465: (r, e) => new IFC4.IfcBurnerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  395041908: (r, e) => new IFC4.IfcCableCarrierFittingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3293546465: (r, e) => new IFC4.IfcCableCarrierSegmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2674252688: (r, e) => new IFC4.IfcCableFittingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1285652485: (r, e) => new IFC4.IfcCableSegmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2951183804: (r, e) => new IFC4.IfcChillerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3296154744: (r, e) => new IFC4.IfcChimney(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2611217952: (r, e) => new IFC4.IfcCircle(r, new Handle(e[0].value), new IFC4.IfcPositiveLengthMeasure(e[1].value)),
  1677625105: (r, e) => new IFC4.IfcCivilElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2301859152: (r, e) => new IFC4.IfcCoilType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  843113511: (r, e) => new IFC4.IfcColumn(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  905975707: (r, e) => new IFC4.IfcColumnStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  400855858: (r, e) => new IFC4.IfcCommunicationsApplianceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3850581409: (r, e) => new IFC4.IfcCompressorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2816379211: (r, e) => new IFC4.IfcCondenserType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3898045240: (r, e) => new IFC4.IfcConstructionEquipmentResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1060000209: (r, e) => new IFC4.IfcConstructionMaterialResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  488727124: (r, e) => new IFC4.IfcConstructionProductResource(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  335055490: (r, e) => new IFC4.IfcCooledBeamType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2954562838: (r, e) => new IFC4.IfcCoolingTowerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1973544240: (r, e) => new IFC4.IfcCovering(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3495092785: (r, e) => new IFC4.IfcCurtainWall(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3961806047: (r, e) => new IFC4.IfcDamperType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1335981549: (r, e) => new IFC4.IfcDiscreteAccessory(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2635815018: (r, e) => new IFC4.IfcDiscreteAccessoryType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1599208980: (r, e) => new IFC4.IfcDistributionChamberElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2063403501: (r, e) => new IFC4.IfcDistributionControlElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null),
  1945004755: (r, e) => new IFC4.IfcDistributionElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  3040386961: (r, e) => new IFC4.IfcDistributionFlowElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  3041715199: (r, e) => new IFC4.IfcDistributionPort(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9]),
  3205830791: (r, e) => new IFC4.IfcDistributionSystem(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6]),
  395920057: (r, e) => new IFC4.IfcDoor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  3242481149: (r, e) => new IFC4.IfcDoorStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  869906466: (r, e) => new IFC4.IfcDuctFittingType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3760055223: (r, e) => new IFC4.IfcDuctSegmentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2030761528: (r, e) => new IFC4.IfcDuctSilencerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  663422040: (r, e) => new IFC4.IfcElectricApplianceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2417008758: (r, e) => new IFC4.IfcElectricDistributionBoardType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  3277789161: (r, e) => new IFC4.IfcElectricFlowStorageDeviceType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1534661035: (r, e) => new IFC4.IfcElectricGeneratorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1217240411: (r, e) => new IFC4.IfcElectricMotorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  712377611: (r, e) => new IFC4.IfcElectricTimeControlType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1658829314: (r, e) => new IFC4.IfcEnergyConversionDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2814081492: (r, e) => new IFC4.IfcEngine(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3747195512: (r, e) => new IFC4.IfcEvaporativeCooler(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  484807127: (r, e) => new IFC4.IfcEvaporator(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1209101575: (r, e) => new IFC4.IfcExternalSpatialElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8]),
  346874300: (r, e) => new IFC4.IfcFanType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1810631287: (r, e) => new IFC4.IfcFilterType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4222183408: (r, e) => new IFC4.IfcFireSuppressionTerminalType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2058353004: (r, e) => new IFC4.IfcFlowController(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  4278956645: (r, e) => new IFC4.IfcFlowFitting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  4037862832: (r, e) => new IFC4.IfcFlowInstrumentType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  2188021234: (r, e) => new IFC4.IfcFlowMeter(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3132237377: (r, e) => new IFC4.IfcFlowMovingDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  987401354: (r, e) => new IFC4.IfcFlowSegment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  707683696: (r, e) => new IFC4.IfcFlowStorageDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  2223149337: (r, e) => new IFC4.IfcFlowTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  3508470533: (r, e) => new IFC4.IfcFlowTreatmentDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  900683007: (r, e) => new IFC4.IfcFooting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3319311131: (r, e) => new IFC4.IfcHeatExchanger(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2068733104: (r, e) => new IFC4.IfcHumidifier(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4175244083: (r, e) => new IFC4.IfcInterceptor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2176052936: (r, e) => new IFC4.IfcJunctionBox(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  76236018: (r, e) => new IFC4.IfcLamp(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  629592764: (r, e) => new IFC4.IfcLightFixture(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1437502449: (r, e) => new IFC4.IfcMedicalDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1073191201: (r, e) => new IFC4.IfcMember(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1911478936: (r, e) => new IFC4.IfcMemberStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2474470126: (r, e) => new IFC4.IfcMotorConnection(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  144952367: (r, e) => new IFC4.IfcOuterBoundaryCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4.IfcLogical(e[1].value)),
  3694346114: (r, e) => new IFC4.IfcOutlet(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1687234759: (r, e) => new IFC4.IfcPile(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  310824031: (r, e) => new IFC4.IfcPipeFitting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3612865200: (r, e) => new IFC4.IfcPipeSegment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3171933400: (r, e) => new IFC4.IfcPlate(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1156407060: (r, e) => new IFC4.IfcPlateStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  738039164: (r, e) => new IFC4.IfcProtectiveDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  655969474: (r, e) => new IFC4.IfcProtectiveDeviceTrippingUnitType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  90941305: (r, e) => new IFC4.IfcPump(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2262370178: (r, e) => new IFC4.IfcRailing(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3024970846: (r, e) => new IFC4.IfcRamp(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3283111854: (r, e) => new IFC4.IfcRampFlight(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1232101972: (r, e) => new IFC4.IfcRationalBSplineCurveWithKnots(r, new IFC4.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4.IfcLogical(e[3].value), new IFC4.IfcLogical(e[4].value), e[5].map((s) => new IFC4.IfcInteger(s.value)), e[6].map((s) => new IFC4.IfcParameterValue(s.value)), e[7], e[8].map((s) => new IFC4.IfcReal(s.value))),
  979691226: (r, e) => new IFC4.IfcReinforcingBar(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4.IfcAreaMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPositiveLengthMeasure(e[11].value) : null, e[12], e[13]),
  2572171363: (r, e) => new IFC4.IfcReinforcingBarType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4.IfcPositiveLengthMeasure(e[12].value) : null, e[13], e[14] ? new IFC4.IfcLabel(e[14].value) : null, e[15] ? e[15].map((s) => TypeInitialiser(2, s)) : null),
  2016517767: (r, e) => new IFC4.IfcRoof(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3053780830: (r, e) => new IFC4.IfcSanitaryTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1783015770: (r, e) => new IFC4.IfcSensorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1329646415: (r, e) => new IFC4.IfcShadingDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1529196076: (r, e) => new IFC4.IfcSlab(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3127900445: (r, e) => new IFC4.IfcSlabElementedCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3027962421: (r, e) => new IFC4.IfcSlabStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3420628829: (r, e) => new IFC4.IfcSolarDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1999602285: (r, e) => new IFC4.IfcSpaceHeater(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1404847402: (r, e) => new IFC4.IfcStackTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  331165859: (r, e) => new IFC4.IfcStair(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4252922144: (r, e) => new IFC4.IfcStairFlight(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcInteger(e[8].value) : null, e[9] ? new IFC4.IfcInteger(e[9].value) : null, e[10] ? new IFC4.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4.IfcPositiveLengthMeasure(e[11].value) : null, e[12]),
  2515109513: (r, e) => new IFC4.IfcStructuralAnalysisModel(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null),
  385403989: (r, e) => new IFC4.IfcStructuralLoadCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5], e[6], e[7], e[8] ? new IFC4.IfcRatioMeasure(e[8].value) : null, e[9] ? new IFC4.IfcLabel(e[9].value) : null, e[10] ? e[10].map((s) => new IFC4.IfcRatioMeasure(s.value)) : null),
  1621171031: (r, e) => new IFC4.IfcStructuralPlanarAction(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1162798199: (r, e) => new IFC4.IfcSwitchingDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  812556717: (r, e) => new IFC4.IfcTank(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3825984169: (r, e) => new IFC4.IfcTransformer(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3026737570: (r, e) => new IFC4.IfcTubeBundle(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3179687236: (r, e) => new IFC4.IfcUnitaryControlElementType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4292641817: (r, e) => new IFC4.IfcUnitaryEquipment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4207607924: (r, e) => new IFC4.IfcValve(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2391406946: (r, e) => new IFC4.IfcWall(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4156078855: (r, e) => new IFC4.IfcWallElementedCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3512223829: (r, e) => new IFC4.IfcWallStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4237592921: (r, e) => new IFC4.IfcWasteTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3304561284: (r, e) => new IFC4.IfcWindow(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  486154966: (r, e) => new IFC4.IfcWindowStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4.IfcLabel(e[12].value) : null),
  2874132201: (r, e) => new IFC4.IfcActuatorType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  1634111441: (r, e) => new IFC4.IfcAirTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  177149247: (r, e) => new IFC4.IfcAirTerminalBox(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2056796094: (r, e) => new IFC4.IfcAirToAirHeatRecovery(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3001207471: (r, e) => new IFC4.IfcAlarmType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  277319702: (r, e) => new IFC4.IfcAudioVisualAppliance(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  753842376: (r, e) => new IFC4.IfcBeam(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2906023776: (r, e) => new IFC4.IfcBeamStandardCase(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  32344328: (r, e) => new IFC4.IfcBoiler(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2938176219: (r, e) => new IFC4.IfcBurner(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  635142910: (r, e) => new IFC4.IfcCableCarrierFitting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3758799889: (r, e) => new IFC4.IfcCableCarrierSegment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1051757585: (r, e) => new IFC4.IfcCableFitting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4217484030: (r, e) => new IFC4.IfcCableSegment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3902619387: (r, e) => new IFC4.IfcChiller(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  639361253: (r, e) => new IFC4.IfcCoil(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3221913625: (r, e) => new IFC4.IfcCommunicationsAppliance(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3571504051: (r, e) => new IFC4.IfcCompressor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2272882330: (r, e) => new IFC4.IfcCondenser(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  578613899: (r, e) => new IFC4.IfcControllerType(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4.IfcLabel(e[7].value) : null, e[8] ? new IFC4.IfcLabel(e[8].value) : null, e[9]),
  4136498852: (r, e) => new IFC4.IfcCooledBeam(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3640358203: (r, e) => new IFC4.IfcCoolingTower(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4074379575: (r, e) => new IFC4.IfcDamper(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1052013943: (r, e) => new IFC4.IfcDistributionChamberElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  562808652: (r, e) => new IFC4.IfcDistributionCircuit(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new IFC4.IfcLabel(e[5].value) : null, e[6]),
  1062813311: (r, e) => new IFC4.IfcDistributionControlElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null),
  342316401: (r, e) => new IFC4.IfcDuctFitting(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3518393246: (r, e) => new IFC4.IfcDuctSegment(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1360408905: (r, e) => new IFC4.IfcDuctSilencer(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1904799276: (r, e) => new IFC4.IfcElectricAppliance(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  862014818: (r, e) => new IFC4.IfcElectricDistributionBoard(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3310460725: (r, e) => new IFC4.IfcElectricFlowStorageDevice(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  264262732: (r, e) => new IFC4.IfcElectricGenerator(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  402227799: (r, e) => new IFC4.IfcElectricMotor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1003880860: (r, e) => new IFC4.IfcElectricTimeControl(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3415622556: (r, e) => new IFC4.IfcFan(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  819412036: (r, e) => new IFC4.IfcFilter(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  1426591983: (r, e) => new IFC4.IfcFireSuppressionTerminal(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  182646315: (r, e) => new IFC4.IfcFlowInstrument(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  2295281155: (r, e) => new IFC4.IfcProtectiveDeviceTrippingUnit(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4086658281: (r, e) => new IFC4.IfcSensor(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  630975310: (r, e) => new IFC4.IfcUnitaryControlElement(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  4288193352: (r, e) => new IFC4.IfcActuator(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  3087945054: (r, e) => new IFC4.IfcAlarm(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8]),
  25142252: (r, e) => new IFC4.IfcController(r, new IFC4.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4.IfcLabel(e[2].value) : null, e[3] ? new IFC4.IfcText(e[3].value) : null, e[4] ? new IFC4.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4.IfcIdentifier(e[7].value) : null, e[8])
};
InheritanceDef[2] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  2827207264: [IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3588315303: [IFCOPENINGSTANDARDCASE],
  3740093272: [IFCDISTRIBUTIONPORT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  3299480353: [IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY],
  843113511: [IFCCOLUMNSTANDARDCASE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  395920057: [IFCDOORSTANDARDCASE],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR],
  1073191201: [IFCMEMBERSTANDARDCASE],
  3171933400: [IFCPLATESTANDARDCASE],
  1529196076: [IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE],
  2391406946: [IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE],
  3304561284: [IFCWINDOWSTANDARDCASE],
  753842376: [IFCBEAMSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[2] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  618182010: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, !0], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, !0], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, !0], ["Relates", IFCAPPROVALRELATIONSHIP, 2, !0]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  852622518: [["PartOfW", IFCGRID, 9, !0], ["PartOfV", IFCGRID, 8, !0], ["PartOfU", IFCGRID, 7, !0], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, !0]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, !0], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, !0]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, !0]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, !1]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, !1]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, !1]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, !1]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, !0], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, !0], ["Engages", IFCPERSONANDORGANIZATION, 1, !0]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, !0]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3355820592: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, !0], ["MapUsage", IFCMAPPEDITEM, 0, !0]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  912023232: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, !0], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, !0]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, !0], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, !0]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, !0], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, !0], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, !0], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, !0]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, !0]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, !0]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, !0], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, !0], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, !0]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, !1]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, !0], ["HasShapeAspects", IFCSHAPEASPECT, 4, !0]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["ToFaceSet", IFCPOLYGONALFACESET, 2, !0]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["ToFaceSet", IFCPOLYGONALFACESET, 2, !0]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  492091185: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, !0]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, !0]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, !0], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, !0]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  336235671: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  512836454: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1], ["HasFillings", IFCRELFILLSELEMENT, 4, !0]],
  3079942009: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1], ["HasFillings", IFCRELFILLSELEMENT, 4, !0]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !0], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["HasCoverings", IFCRELCOVERSSPACES, 4, !0], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, !0]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, !0], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, !0]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, !0]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  905975707: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["CoversSpaces", IFCRELCOVERSSPACES, 5, !0], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, !0]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !0], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3242481149: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, !0]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1911478936: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1156407060: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3127900445: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3027962421: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, !0], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, !0]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  4156078855: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  486154966: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  2906023776: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]]
};
Constructors[2] = {
  3630933823: (r, e) => new IFC4.IfcActorRole(r, e[0], e[1], e[2]),
  618182010: (r, e) => new IFC4.IfcAddress(r, e[0], e[1], e[2]),
  639542469: (r, e) => new IFC4.IfcApplication(r, e[0], e[1], e[2], e[3]),
  411424972: (r, e) => new IFC4.IfcAppliedValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  130549933: (r, e) => new IFC4.IfcApproval(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4037036970: (r, e) => new IFC4.IfcBoundaryCondition(r, e[0]),
  1560379544: (r, e) => new IFC4.IfcBoundaryEdgeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (r, e) => new IFC4.IfcBoundaryFaceCondition(r, e[0], e[1], e[2], e[3]),
  1387855156: (r, e) => new IFC4.IfcBoundaryNodeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (r, e) => new IFC4.IfcBoundaryNodeConditionWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2859738748: (r, e) => new IFC4.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC4.IfcConnectionPointGeometry(r, e[0], e[1]),
  2732653382: (r, e) => new IFC4.IfcConnectionSurfaceGeometry(r, e[0], e[1]),
  775493141: (r, e) => new IFC4.IfcConnectionVolumeGeometry(r, e[0], e[1]),
  1959218052: (r, e) => new IFC4.IfcConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1785450214: (r, e) => new IFC4.IfcCoordinateOperation(r, e[0], e[1]),
  1466758467: (r, e) => new IFC4.IfcCoordinateReferenceSystem(r, e[0], e[1], e[2], e[3]),
  602808272: (r, e) => new IFC4.IfcCostValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1765591967: (r, e) => new IFC4.IfcDerivedUnit(r, e[0], e[1], e[2]),
  1045800335: (r, e) => new IFC4.IfcDerivedUnitElement(r, e[0], e[1]),
  2949456006: (r, e) => new IFC4.IfcDimensionalExponents(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4294318154: (r, e) => new IFC4.IfcExternalInformation(r),
  3200245327: (r, e) => new IFC4.IfcExternalReference(r, e[0], e[1], e[2]),
  2242383968: (r, e) => new IFC4.IfcExternallyDefinedHatchStyle(r, e[0], e[1], e[2]),
  1040185647: (r, e) => new IFC4.IfcExternallyDefinedSurfaceStyle(r, e[0], e[1], e[2]),
  3548104201: (r, e) => new IFC4.IfcExternallyDefinedTextFont(r, e[0], e[1], e[2]),
  852622518: (r, e) => new IFC4.IfcGridAxis(r, e[0], e[1], e[2]),
  3020489413: (r, e) => new IFC4.IfcIrregularTimeSeriesValue(r, e[0], e[1]),
  2655187982: (r, e) => new IFC4.IfcLibraryInformation(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3452421091: (r, e) => new IFC4.IfcLibraryReference(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4162380809: (r, e) => new IFC4.IfcLightDistributionData(r, e[0], e[1], e[2]),
  1566485204: (r, e) => new IFC4.IfcLightIntensityDistribution(r, e[0], e[1]),
  3057273783: (r, e) => new IFC4.IfcMapConversion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1847130766: (r, e) => new IFC4.IfcMaterialClassificationRelationship(r, e[0], e[1]),
  760658860: (r, e) => new IFC4.IfcMaterialDefinition(r),
  248100487: (r, e) => new IFC4.IfcMaterialLayer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3303938423: (r, e) => new IFC4.IfcMaterialLayerSet(r, e[0], e[1], e[2]),
  1847252529: (r, e) => new IFC4.IfcMaterialLayerWithOffsets(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2199411900: (r, e) => new IFC4.IfcMaterialList(r, e[0]),
  2235152071: (r, e) => new IFC4.IfcMaterialProfile(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  164193824: (r, e) => new IFC4.IfcMaterialProfileSet(r, e[0], e[1], e[2], e[3]),
  552965576: (r, e) => new IFC4.IfcMaterialProfileWithOffsets(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1507914824: (r, e) => new IFC4.IfcMaterialUsageDefinition(r),
  2597039031: (r, e) => new IFC4.IfcMeasureWithUnit(r, e[0], e[1]),
  3368373690: (r, e) => new IFC4.IfcMetric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706619895: (r, e) => new IFC4.IfcMonetaryUnit(r, e[0]),
  1918398963: (r, e) => new IFC4.IfcNamedUnit(r, e[0], e[1]),
  3701648758: (r, e) => new IFC4.IfcObjectPlacement(r),
  2251480897: (r, e) => new IFC4.IfcObjective(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4251960020: (r, e) => new IFC4.IfcOrganization(r, e[0], e[1], e[2], e[3], e[4]),
  1207048766: (r, e) => new IFC4.IfcOwnerHistory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (r, e) => new IFC4.IfcPerson(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (r, e) => new IFC4.IfcPersonAndOrganization(r, e[0], e[1], e[2]),
  2483315170: (r, e) => new IFC4.IfcPhysicalQuantity(r, e[0], e[1]),
  2226359599: (r, e) => new IFC4.IfcPhysicalSimpleQuantity(r, e[0], e[1], e[2]),
  3355820592: (r, e) => new IFC4.IfcPostalAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  677532197: (r, e) => new IFC4.IfcPresentationItem(r),
  2022622350: (r, e) => new IFC4.IfcPresentationLayerAssignment(r, e[0], e[1], e[2], e[3]),
  1304840413: (r, e) => new IFC4.IfcPresentationLayerWithStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (r, e) => new IFC4.IfcPresentationStyle(r, e[0]),
  2417041796: (r, e) => new IFC4.IfcPresentationStyleAssignment(r, e[0]),
  2095639259: (r, e) => new IFC4.IfcProductRepresentation(r, e[0], e[1], e[2]),
  3958567839: (r, e) => new IFC4.IfcProfileDef(r, e[0], e[1]),
  3843373140: (r, e) => new IFC4.IfcProjectedCRS(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  986844984: (r, e) => new IFC4.IfcPropertyAbstraction(r),
  3710013099: (r, e) => new IFC4.IfcPropertyEnumeration(r, e[0], e[1], e[2]),
  2044713172: (r, e) => new IFC4.IfcQuantityArea(r, e[0], e[1], e[2], e[3], e[4]),
  2093928680: (r, e) => new IFC4.IfcQuantityCount(r, e[0], e[1], e[2], e[3], e[4]),
  931644368: (r, e) => new IFC4.IfcQuantityLength(r, e[0], e[1], e[2], e[3], e[4]),
  3252649465: (r, e) => new IFC4.IfcQuantityTime(r, e[0], e[1], e[2], e[3], e[4]),
  2405470396: (r, e) => new IFC4.IfcQuantityVolume(r, e[0], e[1], e[2], e[3], e[4]),
  825690147: (r, e) => new IFC4.IfcQuantityWeight(r, e[0], e[1], e[2], e[3], e[4]),
  3915482550: (r, e) => new IFC4.IfcRecurrencePattern(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2433181523: (r, e) => new IFC4.IfcReference(r, e[0], e[1], e[2], e[3], e[4]),
  1076942058: (r, e) => new IFC4.IfcRepresentation(r, e[0], e[1], e[2], e[3]),
  3377609919: (r, e) => new IFC4.IfcRepresentationContext(r, e[0], e[1]),
  3008791417: (r, e) => new IFC4.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC4.IfcRepresentationMap(r, e[0], e[1]),
  2439245199: (r, e) => new IFC4.IfcResourceLevelRelationship(r, e[0], e[1]),
  2341007311: (r, e) => new IFC4.IfcRoot(r, e[0], e[1], e[2], e[3]),
  448429030: (r, e) => new IFC4.IfcSIUnit(r, e[0], e[1], e[2]),
  1054537805: (r, e) => new IFC4.IfcSchedulingTime(r, e[0], e[1], e[2]),
  867548509: (r, e) => new IFC4.IfcShapeAspect(r, e[0], e[1], e[2], e[3], e[4]),
  3982875396: (r, e) => new IFC4.IfcShapeModel(r, e[0], e[1], e[2], e[3]),
  4240577450: (r, e) => new IFC4.IfcShapeRepresentation(r, e[0], e[1], e[2], e[3]),
  2273995522: (r, e) => new IFC4.IfcStructuralConnectionCondition(r, e[0]),
  2162789131: (r, e) => new IFC4.IfcStructuralLoad(r, e[0]),
  3478079324: (r, e) => new IFC4.IfcStructuralLoadConfiguration(r, e[0], e[1], e[2]),
  609421318: (r, e) => new IFC4.IfcStructuralLoadOrResult(r, e[0]),
  2525727697: (r, e) => new IFC4.IfcStructuralLoadStatic(r, e[0]),
  3408363356: (r, e) => new IFC4.IfcStructuralLoadTemperature(r, e[0], e[1], e[2], e[3]),
  2830218821: (r, e) => new IFC4.IfcStyleModel(r, e[0], e[1], e[2], e[3]),
  3958052878: (r, e) => new IFC4.IfcStyledItem(r, e[0], e[1], e[2]),
  3049322572: (r, e) => new IFC4.IfcStyledRepresentation(r, e[0], e[1], e[2], e[3]),
  2934153892: (r, e) => new IFC4.IfcSurfaceReinforcementArea(r, e[0], e[1], e[2], e[3]),
  1300840506: (r, e) => new IFC4.IfcSurfaceStyle(r, e[0], e[1], e[2]),
  3303107099: (r, e) => new IFC4.IfcSurfaceStyleLighting(r, e[0], e[1], e[2], e[3]),
  1607154358: (r, e) => new IFC4.IfcSurfaceStyleRefraction(r, e[0], e[1]),
  846575682: (r, e) => new IFC4.IfcSurfaceStyleShading(r, e[0], e[1]),
  1351298697: (r, e) => new IFC4.IfcSurfaceStyleWithTextures(r, e[0]),
  626085974: (r, e) => new IFC4.IfcSurfaceTexture(r, e[0], e[1], e[2], e[3], e[4]),
  985171141: (r, e) => new IFC4.IfcTable(r, e[0], e[1], e[2]),
  2043862942: (r, e) => new IFC4.IfcTableColumn(r, e[0], e[1], e[2], e[3], e[4]),
  531007025: (r, e) => new IFC4.IfcTableRow(r, e[0], e[1]),
  1549132990: (r, e) => new IFC4.IfcTaskTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  2771591690: (r, e) => new IFC4.IfcTaskTimeRecurring(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20]),
  912023232: (r, e) => new IFC4.IfcTelecomAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1447204868: (r, e) => new IFC4.IfcTextStyle(r, e[0], e[1], e[2], e[3], e[4]),
  2636378356: (r, e) => new IFC4.IfcTextStyleForDefinedFont(r, e[0], e[1]),
  1640371178: (r, e) => new IFC4.IfcTextStyleTextModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  280115917: (r, e) => new IFC4.IfcTextureCoordinate(r, e[0]),
  1742049831: (r, e) => new IFC4.IfcTextureCoordinateGenerator(r, e[0], e[1], e[2]),
  2552916305: (r, e) => new IFC4.IfcTextureMap(r, e[0], e[1], e[2]),
  1210645708: (r, e) => new IFC4.IfcTextureVertex(r, e[0]),
  3611470254: (r, e) => new IFC4.IfcTextureVertexList(r, e[0]),
  1199560280: (r, e) => new IFC4.IfcTimePeriod(r, e[0], e[1]),
  3101149627: (r, e) => new IFC4.IfcTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  581633288: (r, e) => new IFC4.IfcTimeSeriesValue(r, e[0]),
  1377556343: (r, e) => new IFC4.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC4.IfcTopologyRepresentation(r, e[0], e[1], e[2], e[3]),
  180925521: (r, e) => new IFC4.IfcUnitAssignment(r, e[0]),
  2799835756: (r, e) => new IFC4.IfcVertex(r),
  1907098498: (r, e) => new IFC4.IfcVertexPoint(r, e[0]),
  891718957: (r, e) => new IFC4.IfcVirtualGridIntersection(r, e[0], e[1]),
  1236880293: (r, e) => new IFC4.IfcWorkTime(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3869604511: (r, e) => new IFC4.IfcApprovalRelationship(r, e[0], e[1], e[2], e[3]),
  3798115385: (r, e) => new IFC4.IfcArbitraryClosedProfileDef(r, e[0], e[1], e[2]),
  1310608509: (r, e) => new IFC4.IfcArbitraryOpenProfileDef(r, e[0], e[1], e[2]),
  2705031697: (r, e) => new IFC4.IfcArbitraryProfileDefWithVoids(r, e[0], e[1], e[2], e[3]),
  616511568: (r, e) => new IFC4.IfcBlobTexture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3150382593: (r, e) => new IFC4.IfcCenterLineProfileDef(r, e[0], e[1], e[2], e[3]),
  747523909: (r, e) => new IFC4.IfcClassification(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  647927063: (r, e) => new IFC4.IfcClassificationReference(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3285139300: (r, e) => new IFC4.IfcColourRgbList(r, e[0]),
  3264961684: (r, e) => new IFC4.IfcColourSpecification(r, e[0]),
  1485152156: (r, e) => new IFC4.IfcCompositeProfileDef(r, e[0], e[1], e[2], e[3]),
  370225590: (r, e) => new IFC4.IfcConnectedFaceSet(r, e[0]),
  1981873012: (r, e) => new IFC4.IfcConnectionCurveGeometry(r, e[0], e[1]),
  45288368: (r, e) => new IFC4.IfcConnectionPointEccentricity(r, e[0], e[1], e[2], e[3], e[4]),
  3050246964: (r, e) => new IFC4.IfcContextDependentUnit(r, e[0], e[1], e[2]),
  2889183280: (r, e) => new IFC4.IfcConversionBasedUnit(r, e[0], e[1], e[2], e[3]),
  2713554722: (r, e) => new IFC4.IfcConversionBasedUnitWithOffset(r, e[0], e[1], e[2], e[3], e[4]),
  539742890: (r, e) => new IFC4.IfcCurrencyRelationship(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3800577675: (r, e) => new IFC4.IfcCurveStyle(r, e[0], e[1], e[2], e[3], e[4]),
  1105321065: (r, e) => new IFC4.IfcCurveStyleFont(r, e[0], e[1]),
  2367409068: (r, e) => new IFC4.IfcCurveStyleFontAndScaling(r, e[0], e[1], e[2]),
  3510044353: (r, e) => new IFC4.IfcCurveStyleFontPattern(r, e[0], e[1]),
  3632507154: (r, e) => new IFC4.IfcDerivedProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  1154170062: (r, e) => new IFC4.IfcDocumentInformation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (r, e) => new IFC4.IfcDocumentInformationRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  3732053477: (r, e) => new IFC4.IfcDocumentReference(r, e[0], e[1], e[2], e[3], e[4]),
  3900360178: (r, e) => new IFC4.IfcEdge(r, e[0], e[1]),
  476780140: (r, e) => new IFC4.IfcEdgeCurve(r, e[0], e[1], e[2], e[3]),
  211053100: (r, e) => new IFC4.IfcEventTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  297599258: (r, e) => new IFC4.IfcExtendedProperties(r, e[0], e[1], e[2]),
  1437805879: (r, e) => new IFC4.IfcExternalReferenceRelationship(r, e[0], e[1], e[2], e[3]),
  2556980723: (r, e) => new IFC4.IfcFace(r, e[0]),
  1809719519: (r, e) => new IFC4.IfcFaceBound(r, e[0], e[1]),
  803316827: (r, e) => new IFC4.IfcFaceOuterBound(r, e[0], e[1]),
  3008276851: (r, e) => new IFC4.IfcFaceSurface(r, e[0], e[1], e[2]),
  4219587988: (r, e) => new IFC4.IfcFailureConnectionCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (r, e) => new IFC4.IfcFillAreaStyle(r, e[0], e[1], e[2]),
  3448662350: (r, e) => new IFC4.IfcGeometricRepresentationContext(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (r, e) => new IFC4.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC4.IfcGeometricRepresentationSubContext(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3590301190: (r, e) => new IFC4.IfcGeometricSet(r, e[0]),
  178086475: (r, e) => new IFC4.IfcGridPlacement(r, e[0], e[1]),
  812098782: (r, e) => new IFC4.IfcHalfSpaceSolid(r, e[0], e[1]),
  3905492369: (r, e) => new IFC4.IfcImageTexture(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3570813810: (r, e) => new IFC4.IfcIndexedColourMap(r, e[0], e[1], e[2], e[3]),
  1437953363: (r, e) => new IFC4.IfcIndexedTextureMap(r, e[0], e[1], e[2]),
  2133299955: (r, e) => new IFC4.IfcIndexedTriangleTextureMap(r, e[0], e[1], e[2], e[3]),
  3741457305: (r, e) => new IFC4.IfcIrregularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1585845231: (r, e) => new IFC4.IfcLagTime(r, e[0], e[1], e[2], e[3], e[4]),
  1402838566: (r, e) => new IFC4.IfcLightSource(r, e[0], e[1], e[2], e[3]),
  125510826: (r, e) => new IFC4.IfcLightSourceAmbient(r, e[0], e[1], e[2], e[3]),
  2604431987: (r, e) => new IFC4.IfcLightSourceDirectional(r, e[0], e[1], e[2], e[3], e[4]),
  4266656042: (r, e) => new IFC4.IfcLightSourceGoniometric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (r, e) => new IFC4.IfcLightSourcePositional(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (r, e) => new IFC4.IfcLightSourceSpot(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2624227202: (r, e) => new IFC4.IfcLocalPlacement(r, e[0], e[1]),
  1008929658: (r, e) => new IFC4.IfcLoop(r),
  2347385850: (r, e) => new IFC4.IfcMappedItem(r, e[0], e[1]),
  1838606355: (r, e) => new IFC4.IfcMaterial(r, e[0], e[1], e[2]),
  3708119e3: (r, e) => new IFC4.IfcMaterialConstituent(r, e[0], e[1], e[2], e[3], e[4]),
  2852063980: (r, e) => new IFC4.IfcMaterialConstituentSet(r, e[0], e[1], e[2]),
  2022407955: (r, e) => new IFC4.IfcMaterialDefinitionRepresentation(r, e[0], e[1], e[2], e[3]),
  1303795690: (r, e) => new IFC4.IfcMaterialLayerSetUsage(r, e[0], e[1], e[2], e[3], e[4]),
  3079605661: (r, e) => new IFC4.IfcMaterialProfileSetUsage(r, e[0], e[1], e[2]),
  3404854881: (r, e) => new IFC4.IfcMaterialProfileSetUsageTapering(r, e[0], e[1], e[2], e[3], e[4]),
  3265635763: (r, e) => new IFC4.IfcMaterialProperties(r, e[0], e[1], e[2], e[3]),
  853536259: (r, e) => new IFC4.IfcMaterialRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  2998442950: (r, e) => new IFC4.IfcMirroredProfileDef(r, e[0], e[1], e[2], e[3]),
  219451334: (r, e) => new IFC4.IfcObjectDefinition(r, e[0], e[1], e[2], e[3]),
  2665983363: (r, e) => new IFC4.IfcOpenShell(r, e[0]),
  1411181986: (r, e) => new IFC4.IfcOrganizationRelationship(r, e[0], e[1], e[2], e[3]),
  1029017970: (r, e) => new IFC4.IfcOrientedEdge(r, e[0], e[1]),
  2529465313: (r, e) => new IFC4.IfcParameterizedProfileDef(r, e[0], e[1], e[2]),
  2519244187: (r, e) => new IFC4.IfcPath(r, e[0]),
  3021840470: (r, e) => new IFC4.IfcPhysicalComplexQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (r, e) => new IFC4.IfcPixelTexture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2004835150: (r, e) => new IFC4.IfcPlacement(r, e[0]),
  1663979128: (r, e) => new IFC4.IfcPlanarExtent(r, e[0], e[1]),
  2067069095: (r, e) => new IFC4.IfcPoint(r),
  4022376103: (r, e) => new IFC4.IfcPointOnCurve(r, e[0], e[1]),
  1423911732: (r, e) => new IFC4.IfcPointOnSurface(r, e[0], e[1], e[2]),
  2924175390: (r, e) => new IFC4.IfcPolyLoop(r, e[0]),
  2775532180: (r, e) => new IFC4.IfcPolygonalBoundedHalfSpace(r, e[0], e[1], e[2], e[3]),
  3727388367: (r, e) => new IFC4.IfcPreDefinedItem(r, e[0]),
  3778827333: (r, e) => new IFC4.IfcPreDefinedProperties(r),
  1775413392: (r, e) => new IFC4.IfcPreDefinedTextFont(r, e[0]),
  673634403: (r, e) => new IFC4.IfcProductDefinitionShape(r, e[0], e[1], e[2]),
  2802850158: (r, e) => new IFC4.IfcProfileProperties(r, e[0], e[1], e[2], e[3]),
  2598011224: (r, e) => new IFC4.IfcProperty(r, e[0], e[1]),
  1680319473: (r, e) => new IFC4.IfcPropertyDefinition(r, e[0], e[1], e[2], e[3]),
  148025276: (r, e) => new IFC4.IfcPropertyDependencyRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  3357820518: (r, e) => new IFC4.IfcPropertySetDefinition(r, e[0], e[1], e[2], e[3]),
  1482703590: (r, e) => new IFC4.IfcPropertyTemplateDefinition(r, e[0], e[1], e[2], e[3]),
  2090586900: (r, e) => new IFC4.IfcQuantitySet(r, e[0], e[1], e[2], e[3]),
  3615266464: (r, e) => new IFC4.IfcRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  3413951693: (r, e) => new IFC4.IfcRegularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1580146022: (r, e) => new IFC4.IfcReinforcementBarProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (r, e) => new IFC4.IfcRelationship(r, e[0], e[1], e[2], e[3]),
  2943643501: (r, e) => new IFC4.IfcResourceApprovalRelationship(r, e[0], e[1], e[2], e[3]),
  1608871552: (r, e) => new IFC4.IfcResourceConstraintRelationship(r, e[0], e[1], e[2], e[3]),
  1042787934: (r, e) => new IFC4.IfcResourceTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2778083089: (r, e) => new IFC4.IfcRoundedRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2042790032: (r, e) => new IFC4.IfcSectionProperties(r, e[0], e[1], e[2]),
  4165799628: (r, e) => new IFC4.IfcSectionReinforcementProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (r, e) => new IFC4.IfcSectionedSpine(r, e[0], e[1], e[2]),
  4124623270: (r, e) => new IFC4.IfcShellBasedSurfaceModel(r, e[0]),
  3692461612: (r, e) => new IFC4.IfcSimpleProperty(r, e[0], e[1]),
  2609359061: (r, e) => new IFC4.IfcSlippageConnectionCondition(r, e[0], e[1], e[2], e[3]),
  723233188: (r, e) => new IFC4.IfcSolidModel(r),
  1595516126: (r, e) => new IFC4.IfcStructuralLoadLinearForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (r, e) => new IFC4.IfcStructuralLoadPlanarForce(r, e[0], e[1], e[2], e[3]),
  2473145415: (r, e) => new IFC4.IfcStructuralLoadSingleDisplacement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (r, e) => new IFC4.IfcStructuralLoadSingleDisplacementDistortion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (r, e) => new IFC4.IfcStructuralLoadSingleForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (r, e) => new IFC4.IfcStructuralLoadSingleForceWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2233826070: (r, e) => new IFC4.IfcSubedge(r, e[0], e[1], e[2]),
  2513912981: (r, e) => new IFC4.IfcSurface(r),
  1878645084: (r, e) => new IFC4.IfcSurfaceStyleRendering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (r, e) => new IFC4.IfcSweptAreaSolid(r, e[0], e[1]),
  1260650574: (r, e) => new IFC4.IfcSweptDiskSolid(r, e[0], e[1], e[2], e[3], e[4]),
  1096409881: (r, e) => new IFC4.IfcSweptDiskSolidPolygonal(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  230924584: (r, e) => new IFC4.IfcSweptSurface(r, e[0], e[1]),
  3071757647: (r, e) => new IFC4.IfcTShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  901063453: (r, e) => new IFC4.IfcTessellatedItem(r),
  4282788508: (r, e) => new IFC4.IfcTextLiteral(r, e[0], e[1], e[2]),
  3124975700: (r, e) => new IFC4.IfcTextLiteralWithExtent(r, e[0], e[1], e[2], e[3], e[4]),
  1983826977: (r, e) => new IFC4.IfcTextStyleFontModel(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2715220739: (r, e) => new IFC4.IfcTrapeziumProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1628702193: (r, e) => new IFC4.IfcTypeObject(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3736923433: (r, e) => new IFC4.IfcTypeProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2347495698: (r, e) => new IFC4.IfcTypeProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3698973494: (r, e) => new IFC4.IfcTypeResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  427810014: (r, e) => new IFC4.IfcUShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1417489154: (r, e) => new IFC4.IfcVector(r, e[0], e[1]),
  2759199220: (r, e) => new IFC4.IfcVertexLoop(r, e[0]),
  1299126871: (r, e) => new IFC4.IfcWindowStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2543172580: (r, e) => new IFC4.IfcZShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3406155212: (r, e) => new IFC4.IfcAdvancedFace(r, e[0], e[1], e[2]),
  669184980: (r, e) => new IFC4.IfcAnnotationFillArea(r, e[0], e[1]),
  3207858831: (r, e) => new IFC4.IfcAsymmetricIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4261334040: (r, e) => new IFC4.IfcAxis1Placement(r, e[0], e[1]),
  3125803723: (r, e) => new IFC4.IfcAxis2Placement2D(r, e[0], e[1]),
  2740243338: (r, e) => new IFC4.IfcAxis2Placement3D(r, e[0], e[1], e[2]),
  2736907675: (r, e) => new IFC4.IfcBooleanResult(r, e[0], e[1], e[2]),
  4182860854: (r, e) => new IFC4.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC4.IfcBoundingBox(r, e[0], e[1], e[2], e[3]),
  2713105998: (r, e) => new IFC4.IfcBoxedHalfSpace(r, e[0], e[1], e[2]),
  2898889636: (r, e) => new IFC4.IfcCShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1123145078: (r, e) => new IFC4.IfcCartesianPoint(r, e[0]),
  574549367: (r, e) => new IFC4.IfcCartesianPointList(r),
  1675464909: (r, e) => new IFC4.IfcCartesianPointList2D(r, e[0]),
  2059837836: (r, e) => new IFC4.IfcCartesianPointList3D(r, e[0]),
  59481748: (r, e) => new IFC4.IfcCartesianTransformationOperator(r, e[0], e[1], e[2], e[3]),
  3749851601: (r, e) => new IFC4.IfcCartesianTransformationOperator2D(r, e[0], e[1], e[2], e[3]),
  3486308946: (r, e) => new IFC4.IfcCartesianTransformationOperator2DnonUniform(r, e[0], e[1], e[2], e[3], e[4]),
  3331915920: (r, e) => new IFC4.IfcCartesianTransformationOperator3D(r, e[0], e[1], e[2], e[3], e[4]),
  1416205885: (r, e) => new IFC4.IfcCartesianTransformationOperator3DnonUniform(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (r, e) => new IFC4.IfcCircleProfileDef(r, e[0], e[1], e[2], e[3]),
  2205249479: (r, e) => new IFC4.IfcClosedShell(r, e[0]),
  776857604: (r, e) => new IFC4.IfcColourRgb(r, e[0], e[1], e[2], e[3]),
  2542286263: (r, e) => new IFC4.IfcComplexProperty(r, e[0], e[1], e[2], e[3]),
  2485617015: (r, e) => new IFC4.IfcCompositeCurveSegment(r, e[0], e[1], e[2]),
  2574617495: (r, e) => new IFC4.IfcConstructionResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3419103109: (r, e) => new IFC4.IfcContext(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1815067380: (r, e) => new IFC4.IfcCrewResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (r, e) => new IFC4.IfcCsgPrimitive3D(r, e[0]),
  2147822146: (r, e) => new IFC4.IfcCsgSolid(r, e[0]),
  2601014836: (r, e) => new IFC4.IfcCurve(r),
  2827736869: (r, e) => new IFC4.IfcCurveBoundedPlane(r, e[0], e[1], e[2]),
  2629017746: (r, e) => new IFC4.IfcCurveBoundedSurface(r, e[0], e[1], e[2]),
  32440307: (r, e) => new IFC4.IfcDirection(r, e[0]),
  526551008: (r, e) => new IFC4.IfcDoorStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1472233963: (r, e) => new IFC4.IfcEdgeLoop(r, e[0]),
  1883228015: (r, e) => new IFC4.IfcElementQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (r, e) => new IFC4.IfcElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (r, e) => new IFC4.IfcElementarySurface(r, e[0]),
  2835456948: (r, e) => new IFC4.IfcEllipseProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  4024345920: (r, e) => new IFC4.IfcEventType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  477187591: (r, e) => new IFC4.IfcExtrudedAreaSolid(r, e[0], e[1], e[2], e[3]),
  2804161546: (r, e) => new IFC4.IfcExtrudedAreaSolidTapered(r, e[0], e[1], e[2], e[3], e[4]),
  2047409740: (r, e) => new IFC4.IfcFaceBasedSurfaceModel(r, e[0]),
  374418227: (r, e) => new IFC4.IfcFillAreaStyleHatching(r, e[0], e[1], e[2], e[3], e[4]),
  315944413: (r, e) => new IFC4.IfcFillAreaStyleTiles(r, e[0], e[1], e[2]),
  2652556860: (r, e) => new IFC4.IfcFixedReferenceSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4238390223: (r, e) => new IFC4.IfcFurnishingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (r, e) => new IFC4.IfcFurnitureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4095422895: (r, e) => new IFC4.IfcGeographicElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (r, e) => new IFC4.IfcGeometricCurveSet(r, e[0]),
  1484403080: (r, e) => new IFC4.IfcIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  178912537: (r, e) => new IFC4.IfcIndexedPolygonalFace(r, e[0]),
  2294589976: (r, e) => new IFC4.IfcIndexedPolygonalFaceWithVoids(r, e[0], e[1]),
  572779678: (r, e) => new IFC4.IfcLShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  428585644: (r, e) => new IFC4.IfcLaborResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1281925730: (r, e) => new IFC4.IfcLine(r, e[0], e[1]),
  1425443689: (r, e) => new IFC4.IfcManifoldSolidBrep(r, e[0]),
  3888040117: (r, e) => new IFC4.IfcObject(r, e[0], e[1], e[2], e[3], e[4]),
  3388369263: (r, e) => new IFC4.IfcOffsetCurve2D(r, e[0], e[1], e[2]),
  3505215534: (r, e) => new IFC4.IfcOffsetCurve3D(r, e[0], e[1], e[2], e[3]),
  1682466193: (r, e) => new IFC4.IfcPcurve(r, e[0], e[1]),
  603570806: (r, e) => new IFC4.IfcPlanarBox(r, e[0], e[1], e[2]),
  220341763: (r, e) => new IFC4.IfcPlane(r, e[0]),
  759155922: (r, e) => new IFC4.IfcPreDefinedColour(r, e[0]),
  2559016684: (r, e) => new IFC4.IfcPreDefinedCurveFont(r, e[0]),
  3967405729: (r, e) => new IFC4.IfcPreDefinedPropertySet(r, e[0], e[1], e[2], e[3]),
  569719735: (r, e) => new IFC4.IfcProcedureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2945172077: (r, e) => new IFC4.IfcProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4208778838: (r, e) => new IFC4.IfcProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (r, e) => new IFC4.IfcProject(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  653396225: (r, e) => new IFC4.IfcProjectLibrary(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  871118103: (r, e) => new IFC4.IfcPropertyBoundedValue(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4166981789: (r, e) => new IFC4.IfcPropertyEnumeratedValue(r, e[0], e[1], e[2], e[3]),
  2752243245: (r, e) => new IFC4.IfcPropertyListValue(r, e[0], e[1], e[2], e[3]),
  941946838: (r, e) => new IFC4.IfcPropertyReferenceValue(r, e[0], e[1], e[2], e[3]),
  1451395588: (r, e) => new IFC4.IfcPropertySet(r, e[0], e[1], e[2], e[3], e[4]),
  492091185: (r, e) => new IFC4.IfcPropertySetTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3650150729: (r, e) => new IFC4.IfcPropertySingleValue(r, e[0], e[1], e[2], e[3]),
  110355661: (r, e) => new IFC4.IfcPropertyTableValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3521284610: (r, e) => new IFC4.IfcPropertyTemplate(r, e[0], e[1], e[2], e[3]),
  3219374653: (r, e) => new IFC4.IfcProxy(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2770003689: (r, e) => new IFC4.IfcRectangleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (r, e) => new IFC4.IfcRectangularPyramid(r, e[0], e[1], e[2], e[3]),
  3454111270: (r, e) => new IFC4.IfcRectangularTrimmedSurface(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3765753017: (r, e) => new IFC4.IfcReinforcementDefinitionProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3939117080: (r, e) => new IFC4.IfcRelAssigns(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (r, e) => new IFC4.IfcRelAssignsToActor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (r, e) => new IFC4.IfcRelAssignsToControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (r, e) => new IFC4.IfcRelAssignsToGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1027710054: (r, e) => new IFC4.IfcRelAssignsToGroupByFactor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278684876: (r, e) => new IFC4.IfcRelAssignsToProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (r, e) => new IFC4.IfcRelAssignsToProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (r, e) => new IFC4.IfcRelAssignsToResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (r, e) => new IFC4.IfcRelAssociates(r, e[0], e[1], e[2], e[3], e[4]),
  4095574036: (r, e) => new IFC4.IfcRelAssociatesApproval(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (r, e) => new IFC4.IfcRelAssociatesClassification(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (r, e) => new IFC4.IfcRelAssociatesConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (r, e) => new IFC4.IfcRelAssociatesDocument(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (r, e) => new IFC4.IfcRelAssociatesLibrary(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (r, e) => new IFC4.IfcRelAssociatesMaterial(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  826625072: (r, e) => new IFC4.IfcRelConnects(r, e[0], e[1], e[2], e[3]),
  1204542856: (r, e) => new IFC4.IfcRelConnectsElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (r, e) => new IFC4.IfcRelConnectsPathElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (r, e) => new IFC4.IfcRelConnectsPortToElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (r, e) => new IFC4.IfcRelConnectsPorts(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (r, e) => new IFC4.IfcRelConnectsStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (r, e) => new IFC4.IfcRelConnectsStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (r, e) => new IFC4.IfcRelConnectsWithEccentricity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (r, e) => new IFC4.IfcRelConnectsWithRealizingElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (r, e) => new IFC4.IfcRelContainedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (r, e) => new IFC4.IfcRelCoversBldgElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (r, e) => new IFC4.IfcRelCoversSpaces(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2565941209: (r, e) => new IFC4.IfcRelDeclares(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (r, e) => new IFC4.IfcRelDecomposes(r, e[0], e[1], e[2], e[3]),
  693640335: (r, e) => new IFC4.IfcRelDefines(r, e[0], e[1], e[2], e[3]),
  1462361463: (r, e) => new IFC4.IfcRelDefinesByObject(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4186316022: (r, e) => new IFC4.IfcRelDefinesByProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  307848117: (r, e) => new IFC4.IfcRelDefinesByTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (r, e) => new IFC4.IfcRelDefinesByType(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (r, e) => new IFC4.IfcRelFillsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (r, e) => new IFC4.IfcRelFlowControlElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  427948657: (r, e) => new IFC4.IfcRelInterferesElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3268803585: (r, e) => new IFC4.IfcRelNests(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  750771296: (r, e) => new IFC4.IfcRelProjectsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (r, e) => new IFC4.IfcRelReferencedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4122056220: (r, e) => new IFC4.IfcRelSequence(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  366585022: (r, e) => new IFC4.IfcRelServicesBuildings(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (r, e) => new IFC4.IfcRelSpaceBoundary(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3523091289: (r, e) => new IFC4.IfcRelSpaceBoundary1stLevel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1521410863: (r, e) => new IFC4.IfcRelSpaceBoundary2ndLevel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1401173127: (r, e) => new IFC4.IfcRelVoidsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  816062949: (r, e) => new IFC4.IfcReparametrisedCompositeCurveSegment(r, e[0], e[1], e[2], e[3]),
  2914609552: (r, e) => new IFC4.IfcResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1856042241: (r, e) => new IFC4.IfcRevolvedAreaSolid(r, e[0], e[1], e[2], e[3]),
  3243963512: (r, e) => new IFC4.IfcRevolvedAreaSolidTapered(r, e[0], e[1], e[2], e[3], e[4]),
  4158566097: (r, e) => new IFC4.IfcRightCircularCone(r, e[0], e[1], e[2]),
  3626867408: (r, e) => new IFC4.IfcRightCircularCylinder(r, e[0], e[1], e[2]),
  3663146110: (r, e) => new IFC4.IfcSimplePropertyTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1412071761: (r, e) => new IFC4.IfcSpatialElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  710998568: (r, e) => new IFC4.IfcSpatialElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2706606064: (r, e) => new IFC4.IfcSpatialStructureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (r, e) => new IFC4.IfcSpatialStructureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  463610769: (r, e) => new IFC4.IfcSpatialZone(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2481509218: (r, e) => new IFC4.IfcSpatialZoneType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  451544542: (r, e) => new IFC4.IfcSphere(r, e[0], e[1]),
  4015995234: (r, e) => new IFC4.IfcSphericalSurface(r, e[0], e[1]),
  3544373492: (r, e) => new IFC4.IfcStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (r, e) => new IFC4.IfcStructuralItem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (r, e) => new IFC4.IfcStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (r, e) => new IFC4.IfcStructuralReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (r, e) => new IFC4.IfcStructuralSurfaceMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (r, e) => new IFC4.IfcStructuralSurfaceMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603775116: (r, e) => new IFC4.IfcStructuralSurfaceReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4095615324: (r, e) => new IFC4.IfcSubContractResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  699246055: (r, e) => new IFC4.IfcSurfaceCurve(r, e[0], e[1], e[2]),
  2028607225: (r, e) => new IFC4.IfcSurfaceCurveSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (r, e) => new IFC4.IfcSurfaceOfLinearExtrusion(r, e[0], e[1], e[2], e[3]),
  4124788165: (r, e) => new IFC4.IfcSurfaceOfRevolution(r, e[0], e[1], e[2]),
  1580310250: (r, e) => new IFC4.IfcSystemFurnitureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3473067441: (r, e) => new IFC4.IfcTask(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3206491090: (r, e) => new IFC4.IfcTaskType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2387106220: (r, e) => new IFC4.IfcTessellatedFaceSet(r, e[0]),
  1935646853: (r, e) => new IFC4.IfcToroidalSurface(r, e[0], e[1], e[2]),
  2097647324: (r, e) => new IFC4.IfcTransportElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2916149573: (r, e) => new IFC4.IfcTriangulatedFaceSet(r, e[0], e[1], e[2], e[3], e[4]),
  336235671: (r, e) => new IFC4.IfcWindowLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  512836454: (r, e) => new IFC4.IfcWindowPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2296667514: (r, e) => new IFC4.IfcActor(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1635779807: (r, e) => new IFC4.IfcAdvancedBrep(r, e[0]),
  2603310189: (r, e) => new IFC4.IfcAdvancedBrepWithVoids(r, e[0], e[1]),
  1674181508: (r, e) => new IFC4.IfcAnnotation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2887950389: (r, e) => new IFC4.IfcBSplineSurface(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  167062518: (r, e) => new IFC4.IfcBSplineSurfaceWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (r, e) => new IFC4.IfcBlock(r, e[0], e[1], e[2], e[3]),
  3649129432: (r, e) => new IFC4.IfcBooleanClippingResult(r, e[0], e[1], e[2]),
  1260505505: (r, e) => new IFC4.IfcBoundedCurve(r),
  4031249490: (r, e) => new IFC4.IfcBuilding(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1950629157: (r, e) => new IFC4.IfcBuildingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3124254112: (r, e) => new IFC4.IfcBuildingStorey(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2197970202: (r, e) => new IFC4.IfcChimneyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (r, e) => new IFC4.IfcCircleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  3893394355: (r, e) => new IFC4.IfcCivilElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  300633059: (r, e) => new IFC4.IfcColumnType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3875453745: (r, e) => new IFC4.IfcComplexPropertyTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3732776249: (r, e) => new IFC4.IfcCompositeCurve(r, e[0], e[1]),
  15328376: (r, e) => new IFC4.IfcCompositeCurveOnSurface(r, e[0], e[1]),
  2510884976: (r, e) => new IFC4.IfcConic(r, e[0]),
  2185764099: (r, e) => new IFC4.IfcConstructionEquipmentResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4105962743: (r, e) => new IFC4.IfcConstructionMaterialResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1525564444: (r, e) => new IFC4.IfcConstructionProductResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2559216714: (r, e) => new IFC4.IfcConstructionResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293443760: (r, e) => new IFC4.IfcControl(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3895139033: (r, e) => new IFC4.IfcCostItem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1419761937: (r, e) => new IFC4.IfcCostSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916426348: (r, e) => new IFC4.IfcCoveringType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (r, e) => new IFC4.IfcCrewResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1457835157: (r, e) => new IFC4.IfcCurtainWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1213902940: (r, e) => new IFC4.IfcCylindricalSurface(r, e[0], e[1]),
  3256556792: (r, e) => new IFC4.IfcDistributionElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (r, e) => new IFC4.IfcDistributionFlowElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2963535650: (r, e) => new IFC4.IfcDoorLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  1714330368: (r, e) => new IFC4.IfcDoorPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2323601079: (r, e) => new IFC4.IfcDoorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  445594917: (r, e) => new IFC4.IfcDraughtingPreDefinedColour(r, e[0]),
  4006246654: (r, e) => new IFC4.IfcDraughtingPreDefinedCurveFont(r, e[0]),
  1758889154: (r, e) => new IFC4.IfcElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (r, e) => new IFC4.IfcElementAssembly(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2397081782: (r, e) => new IFC4.IfcElementAssemblyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (r, e) => new IFC4.IfcElementComponent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (r, e) => new IFC4.IfcElementComponentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (r, e) => new IFC4.IfcEllipse(r, e[0], e[1], e[2]),
  2107101300: (r, e) => new IFC4.IfcEnergyConversionDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  132023988: (r, e) => new IFC4.IfcEngineType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3174744832: (r, e) => new IFC4.IfcEvaporativeCoolerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (r, e) => new IFC4.IfcEvaporatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4148101412: (r, e) => new IFC4.IfcEvent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2853485674: (r, e) => new IFC4.IfcExternalSpatialStructureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  807026263: (r, e) => new IFC4.IfcFacetedBrep(r, e[0]),
  3737207727: (r, e) => new IFC4.IfcFacetedBrepWithVoids(r, e[0], e[1]),
  647756555: (r, e) => new IFC4.IfcFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2489546625: (r, e) => new IFC4.IfcFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2827207264: (r, e) => new IFC4.IfcFeatureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (r, e) => new IFC4.IfcFeatureElementAddition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (r, e) => new IFC4.IfcFeatureElementSubtraction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (r, e) => new IFC4.IfcFlowControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (r, e) => new IFC4.IfcFlowFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (r, e) => new IFC4.IfcFlowMeterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (r, e) => new IFC4.IfcFlowMovingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (r, e) => new IFC4.IfcFlowSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (r, e) => new IFC4.IfcFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (r, e) => new IFC4.IfcFlowTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (r, e) => new IFC4.IfcFlowTreatmentDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1893162501: (r, e) => new IFC4.IfcFootingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  263784265: (r, e) => new IFC4.IfcFurnishingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1509553395: (r, e) => new IFC4.IfcFurniture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3493046030: (r, e) => new IFC4.IfcGeographicElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009204131: (r, e) => new IFC4.IfcGrid(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706460486: (r, e) => new IFC4.IfcGroup(r, e[0], e[1], e[2], e[3], e[4]),
  1251058090: (r, e) => new IFC4.IfcHeatExchangerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (r, e) => new IFC4.IfcHumidifierType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2571569899: (r, e) => new IFC4.IfcIndexedPolyCurve(r, e[0], e[1], e[2]),
  3946677679: (r, e) => new IFC4.IfcInterceptorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3113134337: (r, e) => new IFC4.IfcIntersectionCurve(r, e[0], e[1], e[2]),
  2391368822: (r, e) => new IFC4.IfcInventory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (r, e) => new IFC4.IfcJunctionBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (r, e) => new IFC4.IfcLaborResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1051575348: (r, e) => new IFC4.IfcLampType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (r, e) => new IFC4.IfcLightFixtureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  377706215: (r, e) => new IFC4.IfcMechanicalFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2108223431: (r, e) => new IFC4.IfcMechanicalFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1114901282: (r, e) => new IFC4.IfcMedicalDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3181161470: (r, e) => new IFC4.IfcMemberType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (r, e) => new IFC4.IfcMotorConnectionType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4143007308: (r, e) => new IFC4.IfcOccupant(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (r, e) => new IFC4.IfcOpeningElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3079942009: (r, e) => new IFC4.IfcOpeningStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2837617999: (r, e) => new IFC4.IfcOutletType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (r, e) => new IFC4.IfcPerformanceHistory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3566463478: (r, e) => new IFC4.IfcPermeableCoveringProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3327091369: (r, e) => new IFC4.IfcPermit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1158309216: (r, e) => new IFC4.IfcPileType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  804291784: (r, e) => new IFC4.IfcPipeFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (r, e) => new IFC4.IfcPipeSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (r, e) => new IFC4.IfcPlateType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2839578677: (r, e) => new IFC4.IfcPolygonalFaceSet(r, e[0], e[1], e[2], e[3]),
  3724593414: (r, e) => new IFC4.IfcPolyline(r, e[0]),
  3740093272: (r, e) => new IFC4.IfcPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (r, e) => new IFC4.IfcProcedure(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (r, e) => new IFC4.IfcProjectOrder(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3651124850: (r, e) => new IFC4.IfcProjectionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1842657554: (r, e) => new IFC4.IfcProtectiveDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (r, e) => new IFC4.IfcPumpType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2893384427: (r, e) => new IFC4.IfcRailingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2324767716: (r, e) => new IFC4.IfcRampFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1469900589: (r, e) => new IFC4.IfcRampType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  683857671: (r, e) => new IFC4.IfcRationalBSplineSurfaceWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3027567501: (r, e) => new IFC4.IfcReinforcingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  964333572: (r, e) => new IFC4.IfcReinforcingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (r, e) => new IFC4.IfcReinforcingMesh(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2310774935: (r, e) => new IFC4.IfcReinforcingMeshType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  160246688: (r, e) => new IFC4.IfcRelAggregates(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2781568857: (r, e) => new IFC4.IfcRoofType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1768891740: (r, e) => new IFC4.IfcSanitaryTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2157484638: (r, e) => new IFC4.IfcSeamCurve(r, e[0], e[1], e[2]),
  4074543187: (r, e) => new IFC4.IfcShadingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4097777520: (r, e) => new IFC4.IfcSite(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (r, e) => new IFC4.IfcSlabType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1072016465: (r, e) => new IFC4.IfcSolarDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (r, e) => new IFC4.IfcSpace(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (r, e) => new IFC4.IfcSpaceHeaterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (r, e) => new IFC4.IfcSpaceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3112655638: (r, e) => new IFC4.IfcStackTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (r, e) => new IFC4.IfcStairFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  338393293: (r, e) => new IFC4.IfcStairType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (r, e) => new IFC4.IfcStructuralAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1179482911: (r, e) => new IFC4.IfcStructuralConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1004757350: (r, e) => new IFC4.IfcStructuralCurveAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4243806635: (r, e) => new IFC4.IfcStructuralCurveConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  214636428: (r, e) => new IFC4.IfcStructuralCurveMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2445595289: (r, e) => new IFC4.IfcStructuralCurveMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2757150158: (r, e) => new IFC4.IfcStructuralCurveReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1807405624: (r, e) => new IFC4.IfcStructuralLinearAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1252848954: (r, e) => new IFC4.IfcStructuralLoadGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2082059205: (r, e) => new IFC4.IfcStructuralPointAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  734778138: (r, e) => new IFC4.IfcStructuralPointConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1235345126: (r, e) => new IFC4.IfcStructuralPointReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (r, e) => new IFC4.IfcStructuralResultGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3657597509: (r, e) => new IFC4.IfcStructuralSurfaceAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1975003073: (r, e) => new IFC4.IfcStructuralSurfaceConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (r, e) => new IFC4.IfcSubContractResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3101698114: (r, e) => new IFC4.IfcSurfaceFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2315554128: (r, e) => new IFC4.IfcSwitchingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (r, e) => new IFC4.IfcSystem(r, e[0], e[1], e[2], e[3], e[4]),
  413509423: (r, e) => new IFC4.IfcSystemFurnitureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  5716631: (r, e) => new IFC4.IfcTankType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3824725483: (r, e) => new IFC4.IfcTendon(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (r, e) => new IFC4.IfcTendonAnchor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3081323446: (r, e) => new IFC4.IfcTendonAnchorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2415094496: (r, e) => new IFC4.IfcTendonType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  1692211062: (r, e) => new IFC4.IfcTransformerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1620046519: (r, e) => new IFC4.IfcTransportElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3593883385: (r, e) => new IFC4.IfcTrimmedCurve(r, e[0], e[1], e[2], e[3], e[4]),
  1600972822: (r, e) => new IFC4.IfcTubeBundleType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (r, e) => new IFC4.IfcUnitaryEquipmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (r, e) => new IFC4.IfcValveType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391383451: (r, e) => new IFC4.IfcVibrationIsolator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (r, e) => new IFC4.IfcVibrationIsolatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (r, e) => new IFC4.IfcVirtualElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  926996030: (r, e) => new IFC4.IfcVoidingFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1898987631: (r, e) => new IFC4.IfcWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (r, e) => new IFC4.IfcWasteTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4009809668: (r, e) => new IFC4.IfcWindowType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4088093105: (r, e) => new IFC4.IfcWorkCalendar(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1028945134: (r, e) => new IFC4.IfcWorkControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4218914973: (r, e) => new IFC4.IfcWorkPlan(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  3342526732: (r, e) => new IFC4.IfcWorkSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1033361043: (r, e) => new IFC4.IfcZone(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3821786052: (r, e) => new IFC4.IfcActionRequest(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1411407467: (r, e) => new IFC4.IfcAirTerminalBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (r, e) => new IFC4.IfcAirTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (r, e) => new IFC4.IfcAirToAirHeatRecoveryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3460190687: (r, e) => new IFC4.IfcAsset(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1532957894: (r, e) => new IFC4.IfcAudioVisualApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1967976161: (r, e) => new IFC4.IfcBSplineCurve(r, e[0], e[1], e[2], e[3], e[4]),
  2461110595: (r, e) => new IFC4.IfcBSplineCurveWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  819618141: (r, e) => new IFC4.IfcBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  231477066: (r, e) => new IFC4.IfcBoilerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1136057603: (r, e) => new IFC4.IfcBoundaryCurve(r, e[0], e[1]),
  3299480353: (r, e) => new IFC4.IfcBuildingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2979338954: (r, e) => new IFC4.IfcBuildingElementPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  39481116: (r, e) => new IFC4.IfcBuildingElementPartType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1095909175: (r, e) => new IFC4.IfcBuildingElementProxy(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1909888760: (r, e) => new IFC4.IfcBuildingElementProxyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1177604601: (r, e) => new IFC4.IfcBuildingSystem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2188180465: (r, e) => new IFC4.IfcBurnerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (r, e) => new IFC4.IfcCableCarrierFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (r, e) => new IFC4.IfcCableCarrierSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2674252688: (r, e) => new IFC4.IfcCableFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (r, e) => new IFC4.IfcCableSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (r, e) => new IFC4.IfcChillerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3296154744: (r, e) => new IFC4.IfcChimney(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2611217952: (r, e) => new IFC4.IfcCircle(r, e[0], e[1]),
  1677625105: (r, e) => new IFC4.IfcCivilElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2301859152: (r, e) => new IFC4.IfcCoilType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (r, e) => new IFC4.IfcColumn(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  905975707: (r, e) => new IFC4.IfcColumnStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  400855858: (r, e) => new IFC4.IfcCommunicationsApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3850581409: (r, e) => new IFC4.IfcCompressorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (r, e) => new IFC4.IfcCondenserType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3898045240: (r, e) => new IFC4.IfcConstructionEquipmentResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1060000209: (r, e) => new IFC4.IfcConstructionMaterialResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (r, e) => new IFC4.IfcConstructionProductResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  335055490: (r, e) => new IFC4.IfcCooledBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (r, e) => new IFC4.IfcCoolingTowerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1973544240: (r, e) => new IFC4.IfcCovering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (r, e) => new IFC4.IfcCurtainWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3961806047: (r, e) => new IFC4.IfcDamperType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1335981549: (r, e) => new IFC4.IfcDiscreteAccessory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2635815018: (r, e) => new IFC4.IfcDiscreteAccessoryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1599208980: (r, e) => new IFC4.IfcDistributionChamberElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (r, e) => new IFC4.IfcDistributionControlElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (r, e) => new IFC4.IfcDistributionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (r, e) => new IFC4.IfcDistributionFlowElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (r, e) => new IFC4.IfcDistributionPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3205830791: (r, e) => new IFC4.IfcDistributionSystem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  395920057: (r, e) => new IFC4.IfcDoor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3242481149: (r, e) => new IFC4.IfcDoorStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  869906466: (r, e) => new IFC4.IfcDuctFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (r, e) => new IFC4.IfcDuctSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (r, e) => new IFC4.IfcDuctSilencerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  663422040: (r, e) => new IFC4.IfcElectricApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2417008758: (r, e) => new IFC4.IfcElectricDistributionBoardType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (r, e) => new IFC4.IfcElectricFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (r, e) => new IFC4.IfcElectricGeneratorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (r, e) => new IFC4.IfcElectricMotorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (r, e) => new IFC4.IfcElectricTimeControlType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1658829314: (r, e) => new IFC4.IfcEnergyConversionDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2814081492: (r, e) => new IFC4.IfcEngine(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3747195512: (r, e) => new IFC4.IfcEvaporativeCooler(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  484807127: (r, e) => new IFC4.IfcEvaporator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1209101575: (r, e) => new IFC4.IfcExternalSpatialElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  346874300: (r, e) => new IFC4.IfcFanType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (r, e) => new IFC4.IfcFilterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (r, e) => new IFC4.IfcFireSuppressionTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (r, e) => new IFC4.IfcFlowController(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (r, e) => new IFC4.IfcFlowFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (r, e) => new IFC4.IfcFlowInstrumentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188021234: (r, e) => new IFC4.IfcFlowMeter(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3132237377: (r, e) => new IFC4.IfcFlowMovingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (r, e) => new IFC4.IfcFlowSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (r, e) => new IFC4.IfcFlowStorageDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (r, e) => new IFC4.IfcFlowTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (r, e) => new IFC4.IfcFlowTreatmentDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (r, e) => new IFC4.IfcFooting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3319311131: (r, e) => new IFC4.IfcHeatExchanger(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2068733104: (r, e) => new IFC4.IfcHumidifier(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4175244083: (r, e) => new IFC4.IfcInterceptor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2176052936: (r, e) => new IFC4.IfcJunctionBox(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  76236018: (r, e) => new IFC4.IfcLamp(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  629592764: (r, e) => new IFC4.IfcLightFixture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1437502449: (r, e) => new IFC4.IfcMedicalDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (r, e) => new IFC4.IfcMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1911478936: (r, e) => new IFC4.IfcMemberStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2474470126: (r, e) => new IFC4.IfcMotorConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  144952367: (r, e) => new IFC4.IfcOuterBoundaryCurve(r, e[0], e[1]),
  3694346114: (r, e) => new IFC4.IfcOutlet(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1687234759: (r, e) => new IFC4.IfcPile(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  310824031: (r, e) => new IFC4.IfcPipeFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3612865200: (r, e) => new IFC4.IfcPipeSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3171933400: (r, e) => new IFC4.IfcPlate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1156407060: (r, e) => new IFC4.IfcPlateStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  738039164: (r, e) => new IFC4.IfcProtectiveDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  655969474: (r, e) => new IFC4.IfcProtectiveDeviceTrippingUnitType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  90941305: (r, e) => new IFC4.IfcPump(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2262370178: (r, e) => new IFC4.IfcRailing(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (r, e) => new IFC4.IfcRamp(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (r, e) => new IFC4.IfcRampFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1232101972: (r, e) => new IFC4.IfcRationalBSplineCurveWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  979691226: (r, e) => new IFC4.IfcReinforcingBar(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2572171363: (r, e) => new IFC4.IfcReinforcingBarType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  2016517767: (r, e) => new IFC4.IfcRoof(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3053780830: (r, e) => new IFC4.IfcSanitaryTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1783015770: (r, e) => new IFC4.IfcSensorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1329646415: (r, e) => new IFC4.IfcShadingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1529196076: (r, e) => new IFC4.IfcSlab(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3127900445: (r, e) => new IFC4.IfcSlabElementedCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3027962421: (r, e) => new IFC4.IfcSlabStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3420628829: (r, e) => new IFC4.IfcSolarDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1999602285: (r, e) => new IFC4.IfcSpaceHeater(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1404847402: (r, e) => new IFC4.IfcStackTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (r, e) => new IFC4.IfcStair(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (r, e) => new IFC4.IfcStairFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2515109513: (r, e) => new IFC4.IfcStructuralAnalysisModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  385403989: (r, e) => new IFC4.IfcStructuralLoadCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1621171031: (r, e) => new IFC4.IfcStructuralPlanarAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1162798199: (r, e) => new IFC4.IfcSwitchingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  812556717: (r, e) => new IFC4.IfcTank(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3825984169: (r, e) => new IFC4.IfcTransformer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3026737570: (r, e) => new IFC4.IfcTubeBundle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3179687236: (r, e) => new IFC4.IfcUnitaryControlElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4292641817: (r, e) => new IFC4.IfcUnitaryEquipment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4207607924: (r, e) => new IFC4.IfcValve(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2391406946: (r, e) => new IFC4.IfcWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4156078855: (r, e) => new IFC4.IfcWallElementedCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3512223829: (r, e) => new IFC4.IfcWallStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4237592921: (r, e) => new IFC4.IfcWasteTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3304561284: (r, e) => new IFC4.IfcWindow(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  486154966: (r, e) => new IFC4.IfcWindowStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2874132201: (r, e) => new IFC4.IfcActuatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634111441: (r, e) => new IFC4.IfcAirTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  177149247: (r, e) => new IFC4.IfcAirTerminalBox(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2056796094: (r, e) => new IFC4.IfcAirToAirHeatRecovery(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3001207471: (r, e) => new IFC4.IfcAlarmType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  277319702: (r, e) => new IFC4.IfcAudioVisualAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  753842376: (r, e) => new IFC4.IfcBeam(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2906023776: (r, e) => new IFC4.IfcBeamStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  32344328: (r, e) => new IFC4.IfcBoiler(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2938176219: (r, e) => new IFC4.IfcBurner(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  635142910: (r, e) => new IFC4.IfcCableCarrierFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3758799889: (r, e) => new IFC4.IfcCableCarrierSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1051757585: (r, e) => new IFC4.IfcCableFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4217484030: (r, e) => new IFC4.IfcCableSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3902619387: (r, e) => new IFC4.IfcChiller(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639361253: (r, e) => new IFC4.IfcCoil(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3221913625: (r, e) => new IFC4.IfcCommunicationsAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3571504051: (r, e) => new IFC4.IfcCompressor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2272882330: (r, e) => new IFC4.IfcCondenser(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  578613899: (r, e) => new IFC4.IfcControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4136498852: (r, e) => new IFC4.IfcCooledBeam(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3640358203: (r, e) => new IFC4.IfcCoolingTower(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074379575: (r, e) => new IFC4.IfcDamper(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1052013943: (r, e) => new IFC4.IfcDistributionChamberElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  562808652: (r, e) => new IFC4.IfcDistributionCircuit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1062813311: (r, e) => new IFC4.IfcDistributionControlElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  342316401: (r, e) => new IFC4.IfcDuctFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3518393246: (r, e) => new IFC4.IfcDuctSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1360408905: (r, e) => new IFC4.IfcDuctSilencer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1904799276: (r, e) => new IFC4.IfcElectricAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  862014818: (r, e) => new IFC4.IfcElectricDistributionBoard(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3310460725: (r, e) => new IFC4.IfcElectricFlowStorageDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  264262732: (r, e) => new IFC4.IfcElectricGenerator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  402227799: (r, e) => new IFC4.IfcElectricMotor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1003880860: (r, e) => new IFC4.IfcElectricTimeControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3415622556: (r, e) => new IFC4.IfcFan(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  819412036: (r, e) => new IFC4.IfcFilter(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1426591983: (r, e) => new IFC4.IfcFireSuppressionTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  182646315: (r, e) => new IFC4.IfcFlowInstrument(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2295281155: (r, e) => new IFC4.IfcProtectiveDeviceTrippingUnit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4086658281: (r, e) => new IFC4.IfcSensor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  630975310: (r, e) => new IFC4.IfcUnitaryControlElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4288193352: (r, e) => new IFC4.IfcActuator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3087945054: (r, e) => new IFC4.IfcAlarm(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  25142252: (r, e) => new IFC4.IfcController(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8])
};
ToRawLineData[2] = {
  3630933823: (r) => [r.Role, r.UserDefinedRole, r.Description],
  618182010: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose],
  639542469: (r) => [r.ApplicationDeveloper, r.Version, r.ApplicationFullName, r.ApplicationIdentifier],
  411424972: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.Category, r.Condition, r.ArithmeticOperator, r.Components],
  130549933: (r) => [r.Identifier, r.Name, r.Description, r.TimeOfApproval, r.Status, r.Level, r.Qualifier, r.RequestingApproval, r.GivingApproval],
  4037036970: (r) => [r.Name],
  1560379544: (r) => [r.Name, r.TranslationalStiffnessByLengthX ? Labelise(r.TranslationalStiffnessByLengthX) : null, r.TranslationalStiffnessByLengthY ? Labelise(r.TranslationalStiffnessByLengthY) : null, r.TranslationalStiffnessByLengthZ ? Labelise(r.TranslationalStiffnessByLengthZ) : null, r.RotationalStiffnessByLengthX ? Labelise(r.RotationalStiffnessByLengthX) : null, r.RotationalStiffnessByLengthY ? Labelise(r.RotationalStiffnessByLengthY) : null, r.RotationalStiffnessByLengthZ ? Labelise(r.RotationalStiffnessByLengthZ) : null],
  3367102660: (r) => [r.Name, r.TranslationalStiffnessByAreaX ? Labelise(r.TranslationalStiffnessByAreaX) : null, r.TranslationalStiffnessByAreaY ? Labelise(r.TranslationalStiffnessByAreaY) : null, r.TranslationalStiffnessByAreaZ ? Labelise(r.TranslationalStiffnessByAreaZ) : null],
  1387855156: (r) => [r.Name, r.TranslationalStiffnessX ? Labelise(r.TranslationalStiffnessX) : null, r.TranslationalStiffnessY ? Labelise(r.TranslationalStiffnessY) : null, r.TranslationalStiffnessZ ? Labelise(r.TranslationalStiffnessZ) : null, r.RotationalStiffnessX ? Labelise(r.RotationalStiffnessX) : null, r.RotationalStiffnessY ? Labelise(r.RotationalStiffnessY) : null, r.RotationalStiffnessZ ? Labelise(r.RotationalStiffnessZ) : null],
  2069777674: (r) => [r.Name, r.TranslationalStiffnessX ? Labelise(r.TranslationalStiffnessX) : null, r.TranslationalStiffnessY ? Labelise(r.TranslationalStiffnessY) : null, r.TranslationalStiffnessZ ? Labelise(r.TranslationalStiffnessZ) : null, r.RotationalStiffnessX ? Labelise(r.RotationalStiffnessX) : null, r.RotationalStiffnessY ? Labelise(r.RotationalStiffnessY) : null, r.RotationalStiffnessZ ? Labelise(r.RotationalStiffnessZ) : null, r.WarpingStiffness ? Labelise(r.WarpingStiffness) : null],
  2859738748: (r) => [],
  2614616156: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement],
  2732653382: (r) => [r.SurfaceOnRelatingElement, r.SurfaceOnRelatedElement],
  775493141: (r) => [r.VolumeOnRelatingElement, r.VolumeOnRelatedElement],
  1959218052: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade],
  1785450214: (r) => [r.SourceCRS, r.TargetCRS],
  1466758467: (r) => [r.Name, r.Description, r.GeodeticDatum, r.VerticalDatum],
  602808272: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.Category, r.Condition, r.ArithmeticOperator, r.Components],
  1765591967: (r) => [r.Elements, r.UnitType, r.UserDefinedType],
  1045800335: (r) => [r.Unit, r.Exponent],
  2949456006: (r) => [r.LengthExponent, r.MassExponent, r.TimeExponent, r.ElectricCurrentExponent, r.ThermodynamicTemperatureExponent, r.AmountOfSubstanceExponent, r.LuminousIntensityExponent],
  4294318154: (r) => [],
  3200245327: (r) => [r.Location, r.Identification, r.Name],
  2242383968: (r) => [r.Location, r.Identification, r.Name],
  1040185647: (r) => [r.Location, r.Identification, r.Name],
  3548104201: (r) => [r.Location, r.Identification, r.Name],
  852622518: (r) => {
    var e;
    return [r.AxisTag, r.AxisCurve, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  3020489413: (r) => [r.TimeStamp, r.ListValues.map((e) => Labelise(e))],
  2655187982: (r) => [r.Name, r.Version, r.Publisher, r.VersionDate, r.Location, r.Description],
  3452421091: (r) => [r.Location, r.Identification, r.Name, r.Description, r.Language, r.ReferencedLibrary],
  4162380809: (r) => [r.MainPlaneAngle, r.SecondaryPlaneAngle, r.LuminousIntensity],
  1566485204: (r) => [r.LightDistributionCurve, r.DistributionData],
  3057273783: (r) => [r.SourceCRS, r.TargetCRS, r.Eastings, r.Northings, r.OrthogonalHeight, r.XAxisAbscissa, r.XAxisOrdinate, r.Scale],
  1847130766: (r) => [r.MaterialClassifications, r.ClassifiedMaterial],
  760658860: (r) => [],
  248100487: (r) => {
    var e;
    return [r.Material, r.LayerThickness, (e = r.IsVentilated) == null ? void 0 : e.toString(), r.Name, r.Description, r.Category, r.Priority];
  },
  3303938423: (r) => [r.MaterialLayers, r.LayerSetName, r.Description],
  1847252529: (r) => {
    var e;
    return [r.Material, r.LayerThickness, (e = r.IsVentilated) == null ? void 0 : e.toString(), r.Name, r.Description, r.Category, r.Priority, r.OffsetDirection, r.OffsetValues];
  },
  2199411900: (r) => [r.Materials],
  2235152071: (r) => [r.Name, r.Description, r.Material, r.Profile, r.Priority, r.Category],
  164193824: (r) => [r.Name, r.Description, r.MaterialProfiles, r.CompositeProfile],
  552965576: (r) => [r.Name, r.Description, r.Material, r.Profile, r.Priority, r.Category, r.OffsetValues],
  1507914824: (r) => [],
  2597039031: (r) => [Labelise(r.ValueComponent), r.UnitComponent],
  3368373690: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.Benchmark, r.ValueSource, r.DataValue, r.ReferencePath],
  2706619895: (r) => [r.Currency],
  1918398963: (r) => [r.Dimensions, r.UnitType],
  3701648758: (r) => [],
  2251480897: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.BenchmarkValues, r.LogicalAggregator, r.ObjectiveQualifier, r.UserDefinedQualifier],
  4251960020: (r) => [r.Identification, r.Name, r.Description, r.Roles, r.Addresses],
  1207048766: (r) => [r.OwningUser, r.OwningApplication, r.State, r.ChangeAction, r.LastModifiedDate, r.LastModifyingUser, r.LastModifyingApplication, r.CreationDate],
  2077209135: (r) => [r.Identification, r.FamilyName, r.GivenName, r.MiddleNames, r.PrefixTitles, r.SuffixTitles, r.Roles, r.Addresses],
  101040310: (r) => [r.ThePerson, r.TheOrganization, r.Roles],
  2483315170: (r) => [r.Name, r.Description],
  2226359599: (r) => [r.Name, r.Description, r.Unit],
  3355820592: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.InternalLocation, r.AddressLines, r.PostalBox, r.Town, r.Region, r.PostalCode, r.Country],
  677532197: (r) => [],
  2022622350: (r) => [r.Name, r.Description, r.AssignedItems, r.Identifier],
  1304840413: (r) => {
    var e, s, o;
    return [r.Name, r.Description, r.AssignedItems, r.Identifier, (e = r.LayerOn) == null ? void 0 : e.toString(), (s = r.LayerFrozen) == null ? void 0 : s.toString(), (o = r.LayerBlocked) == null ? void 0 : o.toString(), r.LayerStyles];
  },
  3119450353: (r) => [r.Name],
  2417041796: (r) => [r.Styles],
  2095639259: (r) => [r.Name, r.Description, r.Representations],
  3958567839: (r) => [r.ProfileType, r.ProfileName],
  3843373140: (r) => [r.Name, r.Description, r.GeodeticDatum, r.VerticalDatum, r.MapProjection, r.MapZone, r.MapUnit],
  986844984: (r) => [],
  3710013099: (r) => [r.Name, r.EnumerationValues.map((e) => Labelise(e)), r.Unit],
  2044713172: (r) => [r.Name, r.Description, r.Unit, r.AreaValue, r.Formula],
  2093928680: (r) => [r.Name, r.Description, r.Unit, r.CountValue, r.Formula],
  931644368: (r) => [r.Name, r.Description, r.Unit, r.LengthValue, r.Formula],
  3252649465: (r) => [r.Name, r.Description, r.Unit, r.TimeValue, r.Formula],
  2405470396: (r) => [r.Name, r.Description, r.Unit, r.VolumeValue, r.Formula],
  825690147: (r) => [r.Name, r.Description, r.Unit, r.WeightValue, r.Formula],
  3915482550: (r) => [r.RecurrenceType, r.DayComponent, r.WeekdayComponent, r.MonthComponent, r.Position, r.Interval, r.Occurrences, r.TimePeriods],
  2433181523: (r) => [r.TypeIdentifier, r.AttributeIdentifier, r.InstanceName, r.ListPositions, r.InnerReference],
  1076942058: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3377609919: (r) => [r.ContextIdentifier, r.ContextType],
  3008791417: (r) => [],
  1660063152: (r) => [r.MappingOrigin, r.MappedRepresentation],
  2439245199: (r) => [r.Name, r.Description],
  2341007311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  448429030: (r) => [r.Dimensions, r.UnitType, r.Prefix, r.Name],
  1054537805: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin],
  867548509: (r) => {
    var e;
    return [r.ShapeRepresentations, r.Name, r.Description, (e = r.ProductDefinitional) == null ? void 0 : e.toString(), r.PartOfProductDefinitionShape];
  },
  3982875396: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  4240577450: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  2273995522: (r) => [r.Name],
  2162789131: (r) => [r.Name],
  3478079324: (r) => [r.Name, r.Values, r.Locations],
  609421318: (r) => [r.Name],
  2525727697: (r) => [r.Name],
  3408363356: (r) => [r.Name, r.DeltaTConstant, r.DeltaTY, r.DeltaTZ],
  2830218821: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3958052878: (r) => [r.Item, r.Styles, r.Name],
  3049322572: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  2934153892: (r) => [r.Name, r.SurfaceReinforcement1, r.SurfaceReinforcement2, r.ShearReinforcement],
  1300840506: (r) => [r.Name, r.Side, r.Styles],
  3303107099: (r) => [r.DiffuseTransmissionColour, r.DiffuseReflectionColour, r.TransmissionColour, r.ReflectanceColour],
  1607154358: (r) => [r.RefractionIndex, r.DispersionFactor],
  846575682: (r) => [r.SurfaceColour, r.Transparency],
  1351298697: (r) => [r.Textures],
  626085974: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter];
  },
  985171141: (r) => [r.Name, r.Rows, r.Columns],
  2043862942: (r) => [r.Identifier, r.Name, r.Description, r.Unit, r.ReferencePath],
  531007025: (r) => {
    var e;
    return [r.RowCells ? r.RowCells.map((s) => Labelise(s)) : null, (e = r.IsHeading) == null ? void 0 : e.toString()];
  },
  1549132990: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.DurationType, r.ScheduleDuration, r.ScheduleStart, r.ScheduleFinish, r.EarlyStart, r.EarlyFinish, r.LateStart, r.LateFinish, r.FreeFloat, r.TotalFloat, (e = r.IsCritical) == null ? void 0 : e.toString(), r.StatusTime, r.ActualDuration, r.ActualStart, r.ActualFinish, r.RemainingTime, r.Completion];
  },
  2771591690: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.DurationType, r.ScheduleDuration, r.ScheduleStart, r.ScheduleFinish, r.EarlyStart, r.EarlyFinish, r.LateStart, r.LateFinish, r.FreeFloat, r.TotalFloat, (e = r.IsCritical) == null ? void 0 : e.toString(), r.StatusTime, r.ActualDuration, r.ActualStart, r.ActualFinish, r.RemainingTime, r.Completion, r.Recurrence];
  },
  912023232: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.TelephoneNumbers, r.FacsimileNumbers, r.PagerNumber, r.ElectronicMailAddresses, r.WWWHomePageURL, r.MessagingIDs],
  1447204868: (r) => {
    var e;
    return [r.Name, r.TextCharacterAppearance, r.TextStyle, r.TextFontStyle, (e = r.ModelOrDraughting) == null ? void 0 : e.toString()];
  },
  2636378356: (r) => [r.Colour, r.BackgroundColour],
  1640371178: (r) => [r.TextIndent ? Labelise(r.TextIndent) : null, r.TextAlign, r.TextDecoration, r.LetterSpacing ? Labelise(r.LetterSpacing) : null, r.WordSpacing ? Labelise(r.WordSpacing) : null, r.TextTransform, r.LineHeight ? Labelise(r.LineHeight) : null],
  280115917: (r) => [r.Maps],
  1742049831: (r) => [r.Maps, r.Mode, r.Parameter],
  2552916305: (r) => [r.Maps, r.Vertices, r.MappedTo],
  1210645708: (r) => [r.Coordinates],
  3611470254: (r) => [r.TexCoordsList],
  1199560280: (r) => [r.StartTime, r.EndTime],
  3101149627: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit],
  581633288: (r) => [r.ListValues.map((e) => Labelise(e))],
  1377556343: (r) => [],
  1735638870: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  180925521: (r) => [r.Units],
  2799835756: (r) => [],
  1907098498: (r) => [r.VertexGeometry],
  891718957: (r) => [r.IntersectingAxes, r.OffsetDistances],
  1236880293: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.RecurrencePattern, r.Start, r.Finish],
  3869604511: (r) => [r.Name, r.Description, r.RelatingApproval, r.RelatedApprovals],
  3798115385: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve],
  1310608509: (r) => [r.ProfileType, r.ProfileName, r.Curve],
  2705031697: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve, r.InnerCurves],
  616511568: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.RasterFormat, r.RasterCode];
  },
  3150382593: (r) => [r.ProfileType, r.ProfileName, r.Curve, r.Thickness],
  747523909: (r) => [r.Source, r.Edition, r.EditionDate, r.Name, r.Description, r.Location, r.ReferenceTokens],
  647927063: (r) => [r.Location, r.Identification, r.Name, r.ReferencedSource, r.Description, r.Sort],
  3285139300: (r) => [r.ColourList],
  3264961684: (r) => [r.Name],
  1485152156: (r) => [r.ProfileType, r.ProfileName, r.Profiles, r.Label],
  370225590: (r) => [r.CfsFaces],
  1981873012: (r) => [r.CurveOnRelatingElement, r.CurveOnRelatedElement],
  45288368: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement, r.EccentricityInX, r.EccentricityInY, r.EccentricityInZ],
  3050246964: (r) => [r.Dimensions, r.UnitType, r.Name],
  2889183280: (r) => [r.Dimensions, r.UnitType, r.Name, r.ConversionFactor],
  2713554722: (r) => [r.Dimensions, r.UnitType, r.Name, r.ConversionFactor, r.ConversionOffset],
  539742890: (r) => [r.Name, r.Description, r.RelatingMonetaryUnit, r.RelatedMonetaryUnit, r.ExchangeRate, r.RateDateTime, r.RateSource],
  3800577675: (r) => {
    var e;
    return [r.Name, r.CurveFont, r.CurveWidth ? Labelise(r.CurveWidth) : null, r.CurveColour, (e = r.ModelOrDraughting) == null ? void 0 : e.toString()];
  },
  1105321065: (r) => [r.Name, r.PatternList],
  2367409068: (r) => [r.Name, r.CurveFont, r.CurveFontScaling],
  3510044353: (r) => [r.VisibleSegmentLength, r.InvisibleSegmentLength],
  3632507154: (r) => [r.ProfileType, r.ProfileName, r.ParentProfile, r.Operator, r.Label],
  1154170062: (r) => [r.Identification, r.Name, r.Description, r.Location, r.Purpose, r.IntendedUse, r.Scope, r.Revision, r.DocumentOwner, r.Editors, r.CreationTime, r.LastRevisionTime, r.ElectronicFormat, r.ValidFrom, r.ValidUntil, r.Confidentiality, r.Status],
  770865208: (r) => [r.Name, r.Description, r.RelatingDocument, r.RelatedDocuments, r.RelationshipType],
  3732053477: (r) => [r.Location, r.Identification, r.Name, r.Description, r.ReferencedDocument],
  3900360178: (r) => [r.EdgeStart, r.EdgeEnd],
  476780140: (r) => {
    var e;
    return [r.EdgeStart, r.EdgeEnd, r.EdgeGeometry, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  211053100: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.ActualDate, r.EarlyDate, r.LateDate, r.ScheduleDate],
  297599258: (r) => [r.Name, r.Description, r.Properties],
  1437805879: (r) => [r.Name, r.Description, r.RelatingReference, r.RelatedResourceObjects],
  2556980723: (r) => [r.Bounds],
  1809719519: (r) => {
    var e;
    return [r.Bound, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  803316827: (r) => {
    var e;
    return [r.Bound, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  3008276851: (r) => {
    var e;
    return [r.Bounds, r.FaceSurface, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  4219587988: (r) => [r.Name, r.TensionFailureX, r.TensionFailureY, r.TensionFailureZ, r.CompressionFailureX, r.CompressionFailureY, r.CompressionFailureZ],
  738692330: (r) => {
    var e;
    return [r.Name, r.FillStyles, (e = r.ModelorDraughting) == null ? void 0 : e.toString()];
  },
  3448662350: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth],
  2453401579: (r) => [],
  4142052618: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth, r.ParentContext, r.TargetScale, r.TargetView, r.UserDefinedTargetView],
  3590301190: (r) => [r.Elements],
  178086475: (r) => [r.PlacementLocation, r.PlacementRefDirection],
  812098782: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString()];
  },
  3905492369: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.URLReference];
  },
  3570813810: (r) => [r.MappedTo, r.Opacity, r.Colours, r.ColourIndex],
  1437953363: (r) => [r.Maps, r.MappedTo, r.TexCoords],
  2133299955: (r) => [r.Maps, r.MappedTo, r.TexCoords, r.TexCoordIndex],
  3741457305: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.Values],
  1585845231: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, Labelise(r.LagValue), r.DurationType],
  1402838566: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  125510826: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  2604431987: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Orientation],
  4266656042: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.ColourAppearance, r.ColourTemperature, r.LuminousFlux, r.LightEmissionSource, r.LightDistributionDataSource],
  1520743889: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation],
  3422422726: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation, r.Orientation, r.ConcentrationExponent, r.SpreadAngle, r.BeamWidthAngle],
  2624227202: (r) => [r.PlacementRelTo, r.RelativePlacement],
  1008929658: (r) => [],
  2347385850: (r) => [r.MappingSource, r.MappingTarget],
  1838606355: (r) => [r.Name, r.Description, r.Category],
  3708119e3: (r) => [r.Name, r.Description, r.Material, r.Fraction, r.Category],
  2852063980: (r) => [r.Name, r.Description, r.MaterialConstituents],
  2022407955: (r) => [r.Name, r.Description, r.Representations, r.RepresentedMaterial],
  1303795690: (r) => [r.ForLayerSet, r.LayerSetDirection, r.DirectionSense, r.OffsetFromReferenceLine, r.ReferenceExtent],
  3079605661: (r) => [r.ForProfileSet, r.CardinalPoint, r.ReferenceExtent],
  3404854881: (r) => [r.ForProfileSet, r.CardinalPoint, r.ReferenceExtent, r.ForProfileEndSet, r.CardinalEndPoint],
  3265635763: (r) => [r.Name, r.Description, r.Properties, r.Material],
  853536259: (r) => [r.Name, r.Description, r.RelatingMaterial, r.RelatedMaterials, r.Expression],
  2998442950: (r) => [r.ProfileType, r.ProfileName, r.ParentProfile, r.Operator, r.Label],
  219451334: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2665983363: (r) => [r.CfsFaces],
  1411181986: (r) => [r.Name, r.Description, r.RelatingOrganization, r.RelatedOrganizations],
  1029017970: (r) => {
    var e;
    return [r.EdgeStart, r.EdgeEnd, r.EdgeElement, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  2529465313: (r) => [r.ProfileType, r.ProfileName, r.Position],
  2519244187: (r) => [r.EdgeList],
  3021840470: (r) => [r.Name, r.Description, r.HasQuantities, r.Discrimination, r.Quality, r.Usage],
  597895409: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.Width, r.Height, r.ColourComponents, r.Pixel];
  },
  2004835150: (r) => [r.Location],
  1663979128: (r) => [r.SizeInX, r.SizeInY],
  2067069095: (r) => [],
  4022376103: (r) => [r.BasisCurve, r.PointParameter],
  1423911732: (r) => [r.BasisSurface, r.PointParameterU, r.PointParameterV],
  2924175390: (r) => [r.Polygon],
  2775532180: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString(), r.Position, r.PolygonalBoundary];
  },
  3727388367: (r) => [r.Name],
  3778827333: (r) => [],
  1775413392: (r) => [r.Name],
  673634403: (r) => [r.Name, r.Description, r.Representations],
  2802850158: (r) => [r.Name, r.Description, r.Properties, r.ProfileDefinition],
  2598011224: (r) => [r.Name, r.Description],
  1680319473: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  148025276: (r) => [r.Name, r.Description, r.DependingProperty, r.DependantProperty, r.Expression],
  3357820518: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1482703590: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2090586900: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  3615266464: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim],
  3413951693: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.TimeStep, r.Values],
  1580146022: (r) => [r.TotalCrossSectionArea, r.SteelGrade, r.BarSurface, r.EffectiveDepth, r.NominalBarDiameter, r.BarCount],
  478536968: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2943643501: (r) => [r.Name, r.Description, r.RelatedResourceObjects, r.RelatingApproval],
  1608871552: (r) => [r.Name, r.Description, r.RelatingConstraint, r.RelatedResourceObjects],
  1042787934: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.ScheduleWork, r.ScheduleUsage, r.ScheduleStart, r.ScheduleFinish, r.ScheduleContour, r.LevelingDelay, (e = r.IsOverAllocated) == null ? void 0 : e.toString(), r.StatusTime, r.ActualWork, r.ActualUsage, r.ActualStart, r.ActualFinish, r.RemainingWork, r.RemainingUsage, r.Completion];
  },
  2778083089: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.RoundingRadius],
  2042790032: (r) => [r.SectionType, r.StartProfile, r.EndProfile],
  4165799628: (r) => [r.LongitudinalStartPosition, r.LongitudinalEndPosition, r.TransversePosition, r.ReinforcementRole, r.SectionDefinition, r.CrossSectionReinforcementDefinitions],
  1509187699: (r) => [r.SpineCurve, r.CrossSections, r.CrossSectionPositions],
  4124623270: (r) => [r.SbsmBoundary],
  3692461612: (r) => [r.Name, r.Description],
  2609359061: (r) => [r.Name, r.SlippageX, r.SlippageY, r.SlippageZ],
  723233188: (r) => [],
  1595516126: (r) => [r.Name, r.LinearForceX, r.LinearForceY, r.LinearForceZ, r.LinearMomentX, r.LinearMomentY, r.LinearMomentZ],
  2668620305: (r) => [r.Name, r.PlanarForceX, r.PlanarForceY, r.PlanarForceZ],
  2473145415: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ],
  1973038258: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ, r.Distortion],
  1597423693: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ],
  1190533807: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ, r.WarpingMoment],
  2233826070: (r) => [r.EdgeStart, r.EdgeEnd, r.ParentEdge],
  2513912981: (r) => [],
  1878645084: (r) => [r.SurfaceColour, r.Transparency, r.DiffuseColour, r.TransmissionColour, r.DiffuseTransmissionColour, r.ReflectionColour, r.SpecularColour, r.SpecularHighlight ? Labelise(r.SpecularHighlight) : null, r.ReflectanceMethod],
  2247615214: (r) => [r.SweptArea, r.Position],
  1260650574: (r) => [r.Directrix, r.Radius, r.InnerRadius, r.StartParam, r.EndParam],
  1096409881: (r) => [r.Directrix, r.Radius, r.InnerRadius, r.StartParam, r.EndParam, r.FilletRadius],
  230924584: (r) => [r.SweptCurve, r.Position],
  3071757647: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.FlangeEdgeRadius, r.WebEdgeRadius, r.WebSlope, r.FlangeSlope],
  901063453: (r) => [],
  4282788508: (r) => [r.Literal, r.Placement, r.Path],
  3124975700: (r) => [r.Literal, r.Placement, r.Path, r.Extent, r.BoxAlignment],
  1983826977: (r) => [r.Name, r.FontFamily, r.FontStyle, r.FontVariant, r.FontWeight, Labelise(r.FontSize)],
  2715220739: (r) => [r.ProfileType, r.ProfileName, r.Position, r.BottomXDim, r.TopXDim, r.YDim, r.TopXOffset],
  1628702193: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets],
  3736923433: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType],
  2347495698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag],
  3698973494: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType],
  427810014: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius, r.FlangeSlope],
  1417489154: (r) => [r.Orientation, r.Magnitude],
  2759199220: (r) => [r.LoopVertex],
  1299126871: (r) => {
    var e, s;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ConstructionType, r.OperationType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), (s = r.Sizeable) == null ? void 0 : s.toString()];
  },
  2543172580: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius],
  3406155212: (r) => {
    var e;
    return [r.Bounds, r.FaceSurface, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  669184980: (r) => [r.OuterBoundary, r.InnerBoundaries],
  3207858831: (r) => [r.ProfileType, r.ProfileName, r.Position, r.BottomFlangeWidth, r.OverallDepth, r.WebThickness, r.BottomFlangeThickness, r.BottomFlangeFilletRadius, r.TopFlangeWidth, r.TopFlangeThickness, r.TopFlangeFilletRadius, r.BottomFlangeEdgeRadius, r.BottomFlangeSlope, r.TopFlangeEdgeRadius, r.TopFlangeSlope],
  4261334040: (r) => [r.Location, r.Axis],
  3125803723: (r) => [r.Location, r.RefDirection],
  2740243338: (r) => [r.Location, r.Axis, r.RefDirection],
  2736907675: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  4182860854: (r) => [],
  2581212453: (r) => [r.Corner, r.XDim, r.YDim, r.ZDim],
  2713105998: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString(), r.Enclosure];
  },
  2898889636: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.WallThickness, r.Girth, r.InternalFilletRadius],
  1123145078: (r) => [r.Coordinates],
  574549367: (r) => [],
  1675464909: (r) => [r.CoordList],
  2059837836: (r) => [r.CoordList],
  59481748: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3749851601: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3486308946: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Scale2],
  3331915920: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3],
  1416205885: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3, r.Scale2, r.Scale3],
  1383045692: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius],
  2205249479: (r) => [r.CfsFaces],
  776857604: (r) => [r.Name, r.Red, r.Green, r.Blue],
  2542286263: (r) => [r.Name, r.Description, r.UsageName, r.HasProperties],
  2485617015: (r) => {
    var e;
    return [r.Transition, (e = r.SameSense) == null ? void 0 : e.toString(), r.ParentCurve];
  },
  2574617495: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity],
  3419103109: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  1815067380: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  2506170314: (r) => [r.Position],
  2147822146: (r) => [r.TreeRootExpression],
  2601014836: (r) => [],
  2827736869: (r) => [r.BasisSurface, r.OuterBoundary, r.InnerBoundaries],
  2629017746: (r) => {
    var e;
    return [r.BasisSurface, r.Boundaries, (e = r.ImplicitOuter) == null ? void 0 : e.toString()];
  },
  32440307: (r) => [r.DirectionRatios],
  526551008: (r) => {
    var e, s;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.OperationType, r.ConstructionType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), (s = r.Sizeable) == null ? void 0 : s.toString()];
  },
  1472233963: (r) => [r.EdgeList],
  1883228015: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.MethodOfMeasurement, r.Quantities],
  339256511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2777663545: (r) => [r.Position],
  2835456948: (r) => [r.ProfileType, r.ProfileName, r.Position, r.SemiAxis1, r.SemiAxis2],
  4024345920: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType, r.EventTriggerType, r.UserDefinedEventTriggerType],
  477187591: (r) => [r.SweptArea, r.Position, r.ExtrudedDirection, r.Depth],
  2804161546: (r) => [r.SweptArea, r.Position, r.ExtrudedDirection, r.Depth, r.EndSweptArea],
  2047409740: (r) => [r.FbsmFaces],
  374418227: (r) => [r.HatchLineAppearance, r.StartOfNextHatchLine, r.PointOfReferenceHatchLine, r.PatternStart, r.HatchLineAngle],
  315944413: (r) => [r.TilingPattern, r.Tiles, r.TilingScale],
  2652556860: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam, r.EndParam, r.FixedReference],
  4238390223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1268542332: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.AssemblyPlace, r.PredefinedType],
  4095422895: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  987898635: (r) => [r.Elements],
  1484403080: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallWidth, r.OverallDepth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.FlangeEdgeRadius, r.FlangeSlope],
  178912537: (r) => [r.CoordIndex],
  2294589976: (r) => [r.CoordIndex, r.InnerCoordIndices],
  572779678: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.Thickness, r.FilletRadius, r.EdgeRadius, r.LegSlope],
  428585644: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1281925730: (r) => [r.Pnt, r.Dir],
  1425443689: (r) => [r.Outer],
  3888040117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  3388369263: (r) => {
    var e;
    return [r.BasisCurve, r.Distance, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3505215534: (r) => {
    var e;
    return [r.BasisCurve, r.Distance, (e = r.SelfIntersect) == null ? void 0 : e.toString(), r.RefDirection];
  },
  1682466193: (r) => [r.BasisSurface, r.ReferenceCurve],
  603570806: (r) => [r.SizeInX, r.SizeInY, r.Placement],
  220341763: (r) => [r.Position],
  759155922: (r) => [r.Name],
  2559016684: (r) => [r.Name],
  3967405729: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  569719735: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType],
  2945172077: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription],
  4208778838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  103090709: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  653396225: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  871118103: (r) => [r.Name, r.Description, r.UpperBoundValue ? Labelise(r.UpperBoundValue) : null, r.LowerBoundValue ? Labelise(r.LowerBoundValue) : null, r.Unit, r.SetPointValue ? Labelise(r.SetPointValue) : null],
  4166981789: (r) => [r.Name, r.Description, r.EnumerationValues ? r.EnumerationValues.map((e) => Labelise(e)) : null, r.EnumerationReference],
  2752243245: (r) => [r.Name, r.Description, r.ListValues ? r.ListValues.map((e) => Labelise(e)) : null, r.Unit],
  941946838: (r) => [r.Name, r.Description, r.UsageName, r.PropertyReference],
  1451395588: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.HasProperties],
  492091185: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.TemplateType, r.ApplicableEntity, r.HasPropertyTemplates],
  3650150729: (r) => [r.Name, r.Description, r.NominalValue ? Labelise(r.NominalValue) : null, r.Unit],
  110355661: (r) => [r.Name, r.Description, r.DefiningValues ? r.DefiningValues.map((e) => Labelise(e)) : null, r.DefinedValues ? r.DefinedValues.map((e) => Labelise(e)) : null, r.Expression, r.DefiningUnit, r.DefinedUnit, r.CurveInterpolation],
  3521284610: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  3219374653: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.ProxyType, r.Tag],
  2770003689: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.WallThickness, r.InnerFilletRadius, r.OuterFilletRadius],
  2798486643: (r) => [r.Position, r.XLength, r.YLength, r.Height],
  3454111270: (r) => {
    var e, s;
    return [r.BasisSurface, r.U1, r.V1, r.U2, r.V2, (e = r.Usense) == null ? void 0 : e.toString(), (s = r.Vsense) == null ? void 0 : s.toString()];
  },
  3765753017: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.DefinitionType, r.ReinforcementSectionDefinitions],
  3939117080: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType],
  1683148259: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingActor, r.ActingRole],
  2495723537: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl],
  1307041759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingGroup],
  1027710054: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingGroup, r.Factor],
  4278684876: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProcess, r.QuantityInProcess],
  2857406711: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProduct],
  205026976: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingResource],
  1865459582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects],
  4095574036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingApproval],
  919958153: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingClassification],
  2728634034: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.Intent, r.RelatingConstraint],
  982818633: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingDocument],
  3840914261: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingLibrary],
  2655215786: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingMaterial],
  826625072: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1204542856: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement],
  3945020480: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RelatingPriorities, r.RelatedPriorities, r.RelatedConnectionType, r.RelatingConnectionType],
  4201705270: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedElement],
  3190031847: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedPort, r.RealizingElement],
  2127690289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedStructuralActivity],
  1638771189: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem],
  504942748: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem, r.ConnectionConstraint],
  3678494232: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RealizingElements, r.ConnectionType],
  3242617779: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  886880790: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedCoverings],
  2802773753: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedCoverings],
  2565941209: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingContext, r.RelatedDefinitions],
  2551354335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  693640335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1462361463: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingObject],
  4186316022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingPropertyDefinition],
  307848117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedPropertySets, r.RelatingTemplate],
  781010003: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingType],
  3940055652: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingOpeningElement, r.RelatedBuildingElement],
  279856033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedControlElements, r.RelatingFlowElement],
  427948657: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedElement, r.InterferenceGeometry, r.InterferenceType, r.ImpliedOrder],
  3268803585: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  750771296: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedFeatureElement],
  1245217292: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  4122056220: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingProcess, r.RelatedProcess, r.TimeLag, r.SequenceType, r.UserDefinedSequenceType],
  366585022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSystem, r.RelatedBuildings],
  3451746338: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary],
  3523091289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary, r.ParentBoundary],
  1521410863: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary, r.ParentBoundary, r.CorrespondingBoundary],
  1401173127: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedOpeningElement],
  816062949: (r) => {
    var e;
    return [r.Transition, (e = r.SameSense) == null ? void 0 : e.toString(), r.ParentCurve, r.ParamLength];
  },
  2914609552: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription],
  1856042241: (r) => [r.SweptArea, r.Position, r.Axis, r.Angle],
  3243963512: (r) => [r.SweptArea, r.Position, r.Axis, r.Angle, r.EndSweptArea],
  4158566097: (r) => [r.Position, r.Height, r.BottomRadius],
  3626867408: (r) => [r.Position, r.Height, r.Radius],
  3663146110: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.TemplateType, r.PrimaryMeasureType, r.SecondaryMeasureType, r.Enumerators, r.PrimaryUnit, r.SecondaryUnit, r.Expression, r.AccessState],
  1412071761: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName],
  710998568: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2706606064: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType],
  3893378262: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  463610769: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.PredefinedType],
  2481509218: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.LongName],
  451544542: (r) => [r.Position, r.Radius],
  4015995234: (r) => [r.Position, r.Radius],
  3544373492: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3136571912: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  530289379: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  3689010777: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3979015343: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness],
  2218152070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness],
  603775116: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.PredefinedType],
  4095615324: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  699246055: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  2028607225: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam, r.EndParam, r.ReferenceSurface],
  2809605785: (r) => [r.SweptCurve, r.Position, r.ExtrudedDirection, r.Depth],
  4124788165: (r) => [r.SweptCurve, r.Position, r.AxisPosition],
  1580310250: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3473067441: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Status, r.WorkMethod, (e = r.IsMilestone) == null ? void 0 : e.toString(), r.Priority, r.TaskTime, r.PredefinedType];
  },
  3206491090: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType, r.WorkMethod],
  2387106220: (r) => [r.Coordinates],
  1935646853: (r) => [r.Position, r.MajorRadius, r.MinorRadius],
  2097647324: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2916149573: (r) => {
    var e;
    return [r.Coordinates, r.Normals, (e = r.Closed) == null ? void 0 : e.toString(), r.CoordIndex, r.PnIndex];
  },
  336235671: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.TransomThickness, r.MullionThickness, r.FirstTransomOffset, r.SecondTransomOffset, r.FirstMullionOffset, r.SecondMullionOffset, r.ShapeAspectStyle, r.LiningOffset, r.LiningToPanelOffsetX, r.LiningToPanelOffsetY],
  512836454: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  2296667514: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor],
  1635779807: (r) => [r.Outer],
  2603310189: (r) => [r.Outer, r.Voids],
  1674181508: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  2887950389: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString()];
  },
  167062518: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString(), r.UMultiplicities, r.VMultiplicities, r.UKnots, r.VKnots, r.KnotSpec];
  },
  1334484129: (r) => [r.Position, r.XLength, r.YLength, r.ZLength],
  3649129432: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  1260505505: (r) => [],
  4031249490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.ElevationOfRefHeight, r.ElevationOfTerrain, r.BuildingAddress],
  1950629157: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3124254112: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.Elevation],
  2197970202: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2937912522: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius, r.WallThickness],
  3893394355: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  300633059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3875453745: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.UsageName, r.TemplateType, r.HasPropertyTemplates],
  3732776249: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  15328376: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  2510884976: (r) => [r.Position],
  2185764099: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  4105962743: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1525564444: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  2559216714: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity],
  3293443760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification],
  3895139033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.CostValues, r.CostQuantities],
  1419761937: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.SubmittedOn, r.UpdateDate],
  1916426348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3295246426: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1457835157: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1213902940: (r) => [r.Position, r.Radius],
  3256556792: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3849074793: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2963535650: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.ThresholdDepth, r.ThresholdThickness, r.TransomThickness, r.TransomOffset, r.LiningOffset, r.ThresholdOffset, r.CasingThickness, r.CasingDepth, r.ShapeAspectStyle, r.LiningToPanelOffsetX, r.LiningToPanelOffsetY],
  1714330368: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.PanelDepth, r.PanelOperation, r.PanelWidth, r.PanelPosition, r.ShapeAspectStyle],
  2323601079: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.OperationType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), r.UserDefinedOperationType];
  },
  445594917: (r) => [r.Name],
  4006246654: (r) => [r.Name],
  1758889154: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4123344466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.AssemblyPlace, r.PredefinedType],
  2397081782: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1623761950: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2590856083: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1704287377: (r) => [r.Position, r.SemiAxis1, r.SemiAxis2],
  2107101300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  132023988: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3174744832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3390157468: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4148101412: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.PredefinedType, r.EventTriggerType, r.UserDefinedEventTriggerType, r.EventOccurenceTime],
  2853485674: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName],
  807026263: (r) => [r.Outer],
  3737207727: (r) => [r.Outer, r.Voids],
  647756555: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2489546625: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2827207264: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2143335405: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1287392070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3907093117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3198132628: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3815607619: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1482959167: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1834744321: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1339347760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2297155007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3009222698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1893162501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  263784265: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1509553395: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3493046030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3009204131: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.UAxes, r.VAxes, r.WAxes, r.PredefinedType],
  2706460486: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1251058090: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1806887404: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2571569899: (r) => {
    var e;
    return [r.Points, r.Segments ? r.Segments.map((s) => Labelise(s)) : null, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3946677679: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3113134337: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  2391368822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.Jurisdiction, r.ResponsiblePersons, r.LastUpdateDate, r.CurrentValue, r.OriginalValue],
  4288270099: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3827777499: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1051575348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1161773419: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  377706215: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NominalDiameter, r.NominalLength, r.PredefinedType],
  2108223431: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.NominalLength],
  1114901282: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3181161470: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  977012517: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4143007308: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor, r.PredefinedType],
  3588315303: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3079942009: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2837617999: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2382730787: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LifeCyclePhase, r.PredefinedType],
  3566463478: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  3327091369: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  1158309216: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  804291784: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4231323485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4017108033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2839578677: (r) => {
    var e;
    return [r.Coordinates, (e = r.Closed) == null ? void 0 : e.toString(), r.Faces, r.PnIndex];
  },
  3724593414: (r) => [r.Points],
  3740093272: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  2744685151: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.PredefinedType],
  2904328755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  3651124850: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1842657554: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2250791053: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2893384427: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2324767716: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1469900589: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  683857671: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString(), r.UMultiplicities, r.VMultiplicities, r.UKnots, r.VKnots, r.KnotSpec, r.WeightsData];
  },
  3027567501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade],
  964333572: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2320036040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.MeshLength, r.MeshWidth, r.LongitudinalBarNominalDiameter, r.TransverseBarNominalDiameter, r.LongitudinalBarCrossSectionArea, r.TransverseBarCrossSectionArea, r.LongitudinalBarSpacing, r.TransverseBarSpacing, r.PredefinedType],
  2310774935: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.MeshLength, r.MeshWidth, r.LongitudinalBarNominalDiameter, r.TransverseBarNominalDiameter, r.LongitudinalBarCrossSectionArea, r.TransverseBarCrossSectionArea, r.LongitudinalBarSpacing, r.TransverseBarSpacing, r.BendingShapeCode, r.BendingParameters ? r.BendingParameters.map((e) => Labelise(e)) : null],
  160246688: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  2781568857: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1768891740: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2157484638: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  4074543187: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4097777520: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.RefLatitude, r.RefLongitude, r.RefElevation, r.LandTitleNumber, r.SiteAddress],
  2533589738: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1072016465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3856911033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType, r.ElevationWithFlooring],
  1305183839: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3812236995: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.LongName],
  3112655638: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1039846685: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  338393293: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  682877961: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString()];
  },
  1179482911: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  1004757350: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  4243806635: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition, r.Axis],
  214636428: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Axis],
  2445595289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Axis],
  2757150158: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.PredefinedType],
  1807405624: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1252848954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.ActionType, r.ActionSource, r.Coefficient, r.Purpose],
  2082059205: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString()];
  },
  734778138: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition, r.ConditionCoordinateSystem],
  1235345126: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  2986769608: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheoryType, r.ResultForLoadGroup, (e = r.IsLinear) == null ? void 0 : e.toString()];
  },
  3657597509: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1975003073: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  148013059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  3101698114: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2315554128: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2254336722: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  413509423: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  5716631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3824725483: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.TensionForce, r.PreStress, r.FrictionCoefficient, r.AnchorageSlip, r.MinCurvatureRadius],
  2347447852: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType],
  3081323446: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2415094496: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.SheathDiameter],
  1692211062: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1620046519: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3593883385: (r) => {
    var e;
    return [r.BasisCurve, r.Trim1, r.Trim2, (e = r.SenseAgreement) == null ? void 0 : e.toString(), r.MasterRepresentation];
  },
  1600972822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1911125066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  728799441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2391383451: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3313531582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2769231204: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  926996030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1898987631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1133259667: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4009809668: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.PartitioningType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), r.UserDefinedPartitioningType];
  },
  4088093105: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.WorkingTimes, r.ExceptionTimes, r.PredefinedType],
  1028945134: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime],
  4218914973: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.PredefinedType],
  3342526732: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.PredefinedType],
  1033361043: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName],
  3821786052: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  1411407467: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3352864051: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1871374353: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3460190687: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.OriginalValue, r.CurrentValue, r.TotalReplacementCost, r.Owner, r.User, r.ResponsiblePerson, r.IncorporationDate, r.DepreciatedValue],
  1532957894: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1967976161: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString()];
  },
  2461110595: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString(), r.KnotMultiplicities, r.Knots, r.KnotSpec];
  },
  819618141: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  231477066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1136057603: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3299480353: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2979338954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  39481116: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1095909175: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1909888760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1177604601: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.LongName],
  2188180465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  395041908: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3293546465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2674252688: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1285652485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2951183804: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3296154744: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2611217952: (r) => [r.Position, r.Radius],
  1677625105: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2301859152: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  843113511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  905975707: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  400855858: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3850581409: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2816379211: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3898045240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1060000209: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  488727124: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  335055490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2954562838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1973544240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3495092785: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3961806047: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1335981549: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2635815018: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1599208980: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2063403501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1945004755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3040386961: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3041715199: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.FlowDirection, r.PredefinedType, r.SystemType],
  3205830791: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.PredefinedType],
  395920057: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.OperationType, r.UserDefinedOperationType],
  3242481149: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.OperationType, r.UserDefinedOperationType],
  869906466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3760055223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2030761528: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  663422040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2417008758: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3277789161: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1534661035: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1217240411: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  712377611: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1658829314: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2814081492: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3747195512: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  484807127: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1209101575: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.PredefinedType],
  346874300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1810631287: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4222183408: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2058353004: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4278956645: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4037862832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2188021234: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3132237377: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  987401354: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  707683696: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2223149337: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3508470533: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  900683007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3319311131: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2068733104: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4175244083: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2176052936: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  76236018: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  629592764: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1437502449: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1073191201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1911478936: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2474470126: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  144952367: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3694346114: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1687234759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType, r.ConstructionType],
  310824031: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3612865200: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3171933400: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1156407060: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  738039164: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  655969474: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  90941305: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2262370178: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3024970846: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3283111854: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1232101972: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString(), r.KnotMultiplicities, r.Knots, r.KnotSpec, r.WeightsData];
  },
  979691226: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.NominalDiameter, r.CrossSectionArea, r.BarLength, r.PredefinedType, r.BarSurface],
  2572171363: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.BarLength, r.BarSurface, r.BendingShapeCode, r.BendingParameters ? r.BendingParameters.map((e) => Labelise(e)) : null],
  2016517767: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3053780830: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1783015770: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1329646415: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1529196076: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3127900445: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3027962421: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3420628829: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1999602285: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1404847402: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  331165859: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4252922144: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NumberOfRisers, r.NumberOfTreads, r.RiserHeight, r.TreadLength, r.PredefinedType],
  2515109513: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.OrientationOf2DPlane, r.LoadedBy, r.HasResults, r.SharedPlacement],
  385403989: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.ActionType, r.ActionSource, r.Coefficient, r.Purpose, r.SelfWeightCoefficients],
  1621171031: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1162798199: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  812556717: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3825984169: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3026737570: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3179687236: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4292641817: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4207607924: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2391406946: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4156078855: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3512223829: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4237592921: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3304561284: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.PartitioningType, r.UserDefinedPartitioningType],
  486154966: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.PartitioningType, r.UserDefinedPartitioningType],
  2874132201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1634111441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  177149247: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2056796094: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3001207471: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  277319702: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  753842376: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2906023776: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  32344328: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2938176219: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  635142910: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3758799889: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1051757585: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4217484030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3902619387: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  639361253: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3221913625: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3571504051: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2272882330: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  578613899: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4136498852: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3640358203: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4074379575: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1052013943: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  562808652: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.PredefinedType],
  1062813311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  342316401: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3518393246: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1360408905: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1904799276: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  862014818: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3310460725: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  264262732: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  402227799: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1003880860: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3415622556: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  819412036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1426591983: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  182646315: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2295281155: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4086658281: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  630975310: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4288193352: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3087945054: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  25142252: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType]
};
TypeInitialisers[2] = {
  3699917729: (r) => new IFC4.IfcAbsorbedDoseMeasure(r),
  4182062534: (r) => new IFC4.IfcAccelerationMeasure(r),
  360377573: (r) => new IFC4.IfcAmountOfSubstanceMeasure(r),
  632304761: (r) => new IFC4.IfcAngularVelocityMeasure(r),
  3683503648: (r) => new IFC4.IfcArcIndex(r.map((e) => e.value)),
  1500781891: (r) => new IFC4.IfcAreaDensityMeasure(r),
  2650437152: (r) => new IFC4.IfcAreaMeasure(r),
  2314439260: (r) => new IFC4.IfcBinary(r),
  2735952531: (r) => new IFC4.IfcBoolean(r),
  1867003952: (r) => new IFC4.IfcBoxAlignment(r),
  1683019596: (r) => new IFC4.IfcCardinalPointReference(r),
  2991860651: (r) => new IFC4.IfcComplexNumber(r.map((e) => e.value)),
  3812528620: (r) => new IFC4.IfcCompoundPlaneAngleMeasure(r.map((e) => e.value)),
  3238673880: (r) => new IFC4.IfcContextDependentMeasure(r),
  1778710042: (r) => new IFC4.IfcCountMeasure(r),
  94842927: (r) => new IFC4.IfcCurvatureMeasure(r),
  937566702: (r) => new IFC4.IfcDate(r),
  2195413836: (r) => new IFC4.IfcDateTime(r),
  86635668: (r) => new IFC4.IfcDayInMonthNumber(r),
  3701338814: (r) => new IFC4.IfcDayInWeekNumber(r),
  1514641115: (r) => new IFC4.IfcDescriptiveMeasure(r),
  4134073009: (r) => new IFC4.IfcDimensionCount(r),
  524656162: (r) => new IFC4.IfcDoseEquivalentMeasure(r),
  2541165894: (r) => new IFC4.IfcDuration(r),
  69416015: (r) => new IFC4.IfcDynamicViscosityMeasure(r),
  1827137117: (r) => new IFC4.IfcElectricCapacitanceMeasure(r),
  3818826038: (r) => new IFC4.IfcElectricChargeMeasure(r),
  2093906313: (r) => new IFC4.IfcElectricConductanceMeasure(r),
  3790457270: (r) => new IFC4.IfcElectricCurrentMeasure(r),
  2951915441: (r) => new IFC4.IfcElectricResistanceMeasure(r),
  2506197118: (r) => new IFC4.IfcElectricVoltageMeasure(r),
  2078135608: (r) => new IFC4.IfcEnergyMeasure(r),
  1102727119: (r) => new IFC4.IfcFontStyle(r),
  2715512545: (r) => new IFC4.IfcFontVariant(r),
  2590844177: (r) => new IFC4.IfcFontWeight(r),
  1361398929: (r) => new IFC4.IfcForceMeasure(r),
  3044325142: (r) => new IFC4.IfcFrequencyMeasure(r),
  3064340077: (r) => new IFC4.IfcGloballyUniqueId(r),
  3113092358: (r) => new IFC4.IfcHeatFluxDensityMeasure(r),
  1158859006: (r) => new IFC4.IfcHeatingValueMeasure(r),
  983778844: (r) => new IFC4.IfcIdentifier(r),
  3358199106: (r) => new IFC4.IfcIlluminanceMeasure(r),
  2679005408: (r) => new IFC4.IfcInductanceMeasure(r),
  1939436016: (r) => new IFC4.IfcInteger(r),
  3809634241: (r) => new IFC4.IfcIntegerCountRateMeasure(r),
  3686016028: (r) => new IFC4.IfcIonConcentrationMeasure(r),
  3192672207: (r) => new IFC4.IfcIsothermalMoistureCapacityMeasure(r),
  2054016361: (r) => new IFC4.IfcKinematicViscosityMeasure(r),
  3258342251: (r) => new IFC4.IfcLabel(r),
  1275358634: (r) => new IFC4.IfcLanguageId(r),
  1243674935: (r) => new IFC4.IfcLengthMeasure(r),
  1774176899: (r) => new IFC4.IfcLineIndex(r.map((e) => e.value)),
  191860431: (r) => new IFC4.IfcLinearForceMeasure(r),
  2128979029: (r) => new IFC4.IfcLinearMomentMeasure(r),
  1307019551: (r) => new IFC4.IfcLinearStiffnessMeasure(r),
  3086160713: (r) => new IFC4.IfcLinearVelocityMeasure(r),
  503418787: (r) => new IFC4.IfcLogical(r),
  2095003142: (r) => new IFC4.IfcLuminousFluxMeasure(r),
  2755797622: (r) => new IFC4.IfcLuminousIntensityDistributionMeasure(r),
  151039812: (r) => new IFC4.IfcLuminousIntensityMeasure(r),
  286949696: (r) => new IFC4.IfcMagneticFluxDensityMeasure(r),
  2486716878: (r) => new IFC4.IfcMagneticFluxMeasure(r),
  1477762836: (r) => new IFC4.IfcMassDensityMeasure(r),
  4017473158: (r) => new IFC4.IfcMassFlowRateMeasure(r),
  3124614049: (r) => new IFC4.IfcMassMeasure(r),
  3531705166: (r) => new IFC4.IfcMassPerLengthMeasure(r),
  3341486342: (r) => new IFC4.IfcModulusOfElasticityMeasure(r),
  2173214787: (r) => new IFC4.IfcModulusOfLinearSubgradeReactionMeasure(r),
  1052454078: (r) => new IFC4.IfcModulusOfRotationalSubgradeReactionMeasure(r),
  1753493141: (r) => new IFC4.IfcModulusOfSubgradeReactionMeasure(r),
  3177669450: (r) => new IFC4.IfcMoistureDiffusivityMeasure(r),
  1648970520: (r) => new IFC4.IfcMolecularWeightMeasure(r),
  3114022597: (r) => new IFC4.IfcMomentOfInertiaMeasure(r),
  2615040989: (r) => new IFC4.IfcMonetaryMeasure(r),
  765770214: (r) => new IFC4.IfcMonthInYearNumber(r),
  525895558: (r) => new IFC4.IfcNonNegativeLengthMeasure(r),
  2095195183: (r) => new IFC4.IfcNormalisedRatioMeasure(r),
  2395907400: (r) => new IFC4.IfcNumericMeasure(r),
  929793134: (r) => new IFC4.IfcPHMeasure(r),
  2260317790: (r) => new IFC4.IfcParameterValue(r),
  2642773653: (r) => new IFC4.IfcPlanarForceMeasure(r),
  4042175685: (r) => new IFC4.IfcPlaneAngleMeasure(r),
  1790229001: (r) => new IFC4.IfcPositiveInteger(r),
  2815919920: (r) => new IFC4.IfcPositiveLengthMeasure(r),
  3054510233: (r) => new IFC4.IfcPositivePlaneAngleMeasure(r),
  1245737093: (r) => new IFC4.IfcPositiveRatioMeasure(r),
  1364037233: (r) => new IFC4.IfcPowerMeasure(r),
  2169031380: (r) => new IFC4.IfcPresentableText(r),
  3665567075: (r) => new IFC4.IfcPressureMeasure(r),
  2798247006: (r) => new IFC4.IfcPropertySetDefinitionSet(r.map((e) => e.value)),
  3972513137: (r) => new IFC4.IfcRadioActivityMeasure(r),
  96294661: (r) => new IFC4.IfcRatioMeasure(r),
  200335297: (r) => new IFC4.IfcReal(r),
  2133746277: (r) => new IFC4.IfcRotationalFrequencyMeasure(r),
  1755127002: (r) => new IFC4.IfcRotationalMassMeasure(r),
  3211557302: (r) => new IFC4.IfcRotationalStiffnessMeasure(r),
  3467162246: (r) => new IFC4.IfcSectionModulusMeasure(r),
  2190458107: (r) => new IFC4.IfcSectionalAreaIntegralMeasure(r),
  408310005: (r) => new IFC4.IfcShearModulusMeasure(r),
  3471399674: (r) => new IFC4.IfcSolidAngleMeasure(r),
  4157543285: (r) => new IFC4.IfcSoundPowerLevelMeasure(r),
  846465480: (r) => new IFC4.IfcSoundPowerMeasure(r),
  3457685358: (r) => new IFC4.IfcSoundPressureLevelMeasure(r),
  993287707: (r) => new IFC4.IfcSoundPressureMeasure(r),
  3477203348: (r) => new IFC4.IfcSpecificHeatCapacityMeasure(r),
  2757832317: (r) => new IFC4.IfcSpecularExponent(r),
  361837227: (r) => new IFC4.IfcSpecularRoughness(r),
  58845555: (r) => new IFC4.IfcTemperatureGradientMeasure(r),
  1209108979: (r) => new IFC4.IfcTemperatureRateOfChangeMeasure(r),
  2801250643: (r) => new IFC4.IfcText(r),
  1460886941: (r) => new IFC4.IfcTextAlignment(r),
  3490877962: (r) => new IFC4.IfcTextDecoration(r),
  603696268: (r) => new IFC4.IfcTextFontName(r),
  296282323: (r) => new IFC4.IfcTextTransformation(r),
  232962298: (r) => new IFC4.IfcThermalAdmittanceMeasure(r),
  2645777649: (r) => new IFC4.IfcThermalConductivityMeasure(r),
  2281867870: (r) => new IFC4.IfcThermalExpansionCoefficientMeasure(r),
  857959152: (r) => new IFC4.IfcThermalResistanceMeasure(r),
  2016195849: (r) => new IFC4.IfcThermalTransmittanceMeasure(r),
  743184107: (r) => new IFC4.IfcThermodynamicTemperatureMeasure(r),
  4075327185: (r) => new IFC4.IfcTime(r),
  2726807636: (r) => new IFC4.IfcTimeMeasure(r),
  2591213694: (r) => new IFC4.IfcTimeStamp(r),
  1278329552: (r) => new IFC4.IfcTorqueMeasure(r),
  950732822: (r) => new IFC4.IfcURIReference(r),
  3345633955: (r) => new IFC4.IfcVaporPermeabilityMeasure(r),
  3458127941: (r) => new IFC4.IfcVolumeMeasure(r),
  2593997549: (r) => new IFC4.IfcVolumetricFlowRateMeasure(r),
  51269191: (r) => new IFC4.IfcWarpingConstantMeasure(r),
  1718600412: (r) => new IFC4.IfcWarpingMomentMeasure(r)
};
var IFC4;
(function(r) {
  class e {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAbsorbedDoseMeasure = e;
  class s {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAccelerationMeasure = s;
  class o {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAmountOfSubstanceMeasure = o;
  class a {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAngularVelocityMeasure = a;
  class l {
    constructor($) {
      this.value = $;
    }
  }
  r.IfcArcIndex = l;
  class u {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAreaDensityMeasure = u;
  class c {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcAreaMeasure = c;
  class E {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcBinary = E;
  class d {
    constructor($) {
      this.type = 3, this.value = $ == "true";
    }
  }
  r.IfcBoolean = d;
  class f {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcBoxAlignment = f;
  class h {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcCardinalPointReference = h;
  class S {
    constructor($) {
      this.value = $;
    }
  }
  r.IfcComplexNumber = S;
  class R {
    constructor($) {
      this.value = $;
    }
  }
  r.IfcCompoundPlaneAngleMeasure = R;
  class _ {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcContextDependentMeasure = _;
  class m {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcCountMeasure = m;
  class L {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcCurvatureMeasure = L;
  class F {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcDate = F;
  class W {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcDateTime = W;
  class G {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcDayInMonthNumber = G;
  class q {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcDayInWeekNumber = q;
  class fe {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcDescriptiveMeasure = fe;
  class _e {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcDimensionCount = _e;
  class Le {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcDoseEquivalentMeasure = Le;
  class Fe {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcDuration = Fe;
  class Ee {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcDynamicViscosityMeasure = Ee;
  class Ge {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricCapacitanceMeasure = Ge;
  class ve {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricChargeMeasure = ve;
  class te {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricConductanceMeasure = te;
  class ae {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricCurrentMeasure = ae;
  class v {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricResistanceMeasure = v;
  class Te {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcElectricVoltageMeasure = Te;
  class De {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcEnergyMeasure = De;
  class be {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcFontStyle = be;
  class ze {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcFontVariant = ze;
  class ke {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcFontWeight = ke;
  class Be {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcForceMeasure = Be;
  class Me {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcFrequencyMeasure = Me;
  class me {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcGloballyUniqueId = me;
  class Se {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcHeatFluxDensityMeasure = Se;
  class xt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcHeatingValueMeasure = xt;
  class Ht {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcIdentifier = Ht;
  class Bt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcIlluminanceMeasure = Bt;
  class ut {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcInductanceMeasure = ut;
  class Tt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcInteger = Tt;
  class Yt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcIntegerCountRateMeasure = Yt;
  class an {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcIonConcentrationMeasure = an;
  class Ct {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcIsothermalMoistureCapacityMeasure = Ct;
  class st {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcKinematicViscosityMeasure = st;
  class jt {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcLabel = jt;
  class lt {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcLanguageId = lt;
  class Zt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLengthMeasure = Zt;
  class Et {
    constructor($) {
      this.value = $;
    }
  }
  r.IfcLineIndex = Et;
  class Ke {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLinearForceMeasure = Ke;
  class $e {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLinearMomentMeasure = $e;
  class pt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLinearStiffnessMeasure = pt;
  class Jt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLinearVelocityMeasure = Jt;
  class In {
    constructor($) {
      this.type = 3, this.value = $ == "true";
    }
  }
  r.IfcLogical = In;
  class Cn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLuminousFluxMeasure = Cn;
  class It {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLuminousIntensityDistributionMeasure = It;
  class ht {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcLuminousIntensityMeasure = ht;
  class Wt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMagneticFluxDensityMeasure = Wt;
  class hn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMagneticFluxMeasure = hn;
  class Vt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMassDensityMeasure = Vt;
  class Tn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMassFlowRateMeasure = Tn;
  class Rn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMassMeasure = Rn;
  class Nn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMassPerLengthMeasure = Nn;
  class Dn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcModulusOfElasticityMeasure = Dn;
  class xn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcModulusOfLinearSubgradeReactionMeasure = xn;
  class $n {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcModulusOfRotationalSubgradeReactionMeasure = $n;
  class Kn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcModulusOfSubgradeReactionMeasure = Kn;
  class ir {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMoistureDiffusivityMeasure = ir;
  class er {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMolecularWeightMeasure = er;
  class br {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMomentOfInertiaMeasure = br;
  class cs {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMonetaryMeasure = cs;
  class Gn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcMonthInYearNumber = Gn;
  class Jn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcNonNegativeLengthMeasure = Jn;
  class Xn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcNormalisedRatioMeasure = Xn;
  class rr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcNumericMeasure = rr;
  class _r {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPHMeasure = _r;
  class Ss {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcParameterValue = Ss;
  class is {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPlanarForceMeasure = is;
  class Ms {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPlaneAngleMeasure = Ms;
  class ls {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPositiveInteger = ls;
  class Ur {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPositiveLengthMeasure = Ur;
  class Qr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPositivePlaneAngleMeasure = Qr;
  class Fr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPositiveRatioMeasure = Fr;
  class Lr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPowerMeasure = Lr;
  class Hr {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcPresentableText = Hr;
  class ns {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcPressureMeasure = ns;
  class Ts {
    constructor($) {
      this.value = $;
    }
  }
  r.IfcPropertySetDefinitionSet = Ts;
  class en {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcRadioActivityMeasure = en;
  class to {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcRatioMeasure = to;
  class bs {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcReal = bs;
  class jn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcRotationalFrequencyMeasure = jn;
  class lr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcRotationalMassMeasure = lr;
  class pr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcRotationalStiffnessMeasure = pr;
  class En {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSectionModulusMeasure = En;
  class qn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSectionalAreaIntegralMeasure = qn;
  class Wn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcShearModulusMeasure = Wn;
  class kn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSolidAngleMeasure = kn;
  class zn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSoundPowerLevelMeasure = zn;
  class wr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSoundPowerMeasure = wr;
  class jr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSoundPressureLevelMeasure = jr;
  class Vr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSoundPressureMeasure = Vr;
  class us {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSpecificHeatCapacityMeasure = us;
  class Es {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSpecularExponent = Es;
  class Dr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcSpecularRoughness = Dr;
  class Kr {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcTemperatureGradientMeasure = Kr;
  class Js {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcTemperatureRateOfChangeMeasure = Js;
  class io {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcText = io;
  class No {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcTextAlignment = No;
  class Ai {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcTextDecoration = Ai;
  class go {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcTextFontName = go;
  class ks {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcTextTransformation = ks;
  class Ci {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermalAdmittanceMeasure = Ci;
  class Io {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermalConductivityMeasure = Io;
  class Oo {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermalExpansionCoefficientMeasure = Oo;
  class Zs {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermalResistanceMeasure = Zs;
  class wt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermalTransmittanceMeasure = wt;
  class _t {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcThermodynamicTemperatureMeasure = _t;
  class Ve {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcTime = Ve;
  class Ze {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcTimeMeasure = Ze;
  class bt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcTimeStamp = bt;
  class Ut {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcTorqueMeasure = Ut;
  class mn {
    constructor($) {
      this.value = $, this.type = 1;
    }
  }
  r.IfcURIReference = mn;
  class nn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcVaporPermeabilityMeasure = nn;
  class Sn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcVolumeMeasure = Sn;
  class Mn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcVolumetricFlowRateMeasure = Mn;
  class yn {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcWarpingConstantMeasure = yn;
  class Pt {
    constructor($) {
      this.type = 4, this.value = parseFloat($);
    }
  }
  r.IfcWarpingMomentMeasure = Pt;
  class tr {
  }
  tr.EMAIL = { type: 3, value: "EMAIL" }, tr.FAX = { type: 3, value: "FAX" }, tr.PHONE = { type: 3, value: "PHONE" }, tr.POST = { type: 3, value: "POST" }, tr.VERBAL = { type: 3, value: "VERBAL" }, tr.USERDEFINED = { type: 3, value: "USERDEFINED" }, tr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionRequestTypeEnum = tr;
  class Lt {
  }
  Lt.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Lt.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Lt.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Lt.SNOW_S = { type: 3, value: "SNOW_S" }, Lt.WIND_W = { type: 3, value: "WIND_W" }, Lt.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Lt.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Lt.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Lt.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Lt.FIRE = { type: 3, value: "FIRE" }, Lt.IMPULSE = { type: 3, value: "IMPULSE" }, Lt.IMPACT = { type: 3, value: "IMPACT" }, Lt.TRANSPORT = { type: 3, value: "TRANSPORT" }, Lt.ERECTION = { type: 3, value: "ERECTION" }, Lt.PROPPING = { type: 3, value: "PROPPING" }, Lt.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Lt.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Lt.CREEP = { type: 3, value: "CREEP" }, Lt.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Lt.BUOYANCY = { type: 3, value: "BUOYANCY" }, Lt.ICE = { type: 3, value: "ICE" }, Lt.CURRENT = { type: 3, value: "CURRENT" }, Lt.WAVE = { type: 3, value: "WAVE" }, Lt.RAIN = { type: 3, value: "RAIN" }, Lt.BRAKES = { type: 3, value: "BRAKES" }, Lt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionSourceTypeEnum = Lt;
  class dr {
  }
  dr.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, dr.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, dr.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, dr.USERDEFINED = { type: 3, value: "USERDEFINED" }, dr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionTypeEnum = dr;
  class ur {
  }
  ur.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, ur.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, ur.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, ur.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, ur.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, ur.USERDEFINED = { type: 3, value: "USERDEFINED" }, ur.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActuatorTypeEnum = ur;
  class gr {
  }
  gr.OFFICE = { type: 3, value: "OFFICE" }, gr.SITE = { type: 3, value: "SITE" }, gr.HOME = { type: 3, value: "HOME" }, gr.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, gr.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcAddressTypeEnum = gr;
  class Rr {
  }
  Rr.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, Rr.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, Rr.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, Rr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalBoxTypeEnum = Rr;
  class as {
  }
  as.DIFFUSER = { type: 3, value: "DIFFUSER" }, as.GRILLE = { type: 3, value: "GRILLE" }, as.LOUVRE = { type: 3, value: "LOUVRE" }, as.REGISTER = { type: 3, value: "REGISTER" }, as.USERDEFINED = { type: 3, value: "USERDEFINED" }, as.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalTypeEnum = as;
  class hs {
  }
  hs.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, hs.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, hs.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, hs.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, hs.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, hs.HEATPIPE = { type: 3, value: "HEATPIPE" }, hs.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, hs.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, hs.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirToAirHeatRecoveryTypeEnum = hs;
  class Os {
  }
  Os.BELL = { type: 3, value: "BELL" }, Os.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, Os.LIGHT = { type: 3, value: "LIGHT" }, Os.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, Os.SIREN = { type: 3, value: "SIREN" }, Os.WHISTLE = { type: 3, value: "WHISTLE" }, Os.USERDEFINED = { type: 3, value: "USERDEFINED" }, Os.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAlarmTypeEnum = Os;
  class jo {
  }
  jo.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, jo.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, jo.LOADING_3D = { type: 3, value: "LOADING_3D" }, jo.USERDEFINED = { type: 3, value: "USERDEFINED" }, jo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisModelTypeEnum = jo;
  class po {
  }
  po.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, po.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, po.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, po.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, po.USERDEFINED = { type: 3, value: "USERDEFINED" }, po.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisTheoryTypeEnum = po;
  class So {
  }
  So.ADD = { type: 3, value: "ADD" }, So.DIVIDE = { type: 3, value: "DIVIDE" }, So.MULTIPLY = { type: 3, value: "MULTIPLY" }, So.SUBTRACT = { type: 3, value: "SUBTRACT" }, r.IfcArithmeticOperatorEnum = So;
  class Eo {
  }
  Eo.SITE = { type: 3, value: "SITE" }, Eo.FACTORY = { type: 3, value: "FACTORY" }, Eo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAssemblyPlaceEnum = Eo;
  class Ps {
  }
  Ps.AMPLIFIER = { type: 3, value: "AMPLIFIER" }, Ps.CAMERA = { type: 3, value: "CAMERA" }, Ps.DISPLAY = { type: 3, value: "DISPLAY" }, Ps.MICROPHONE = { type: 3, value: "MICROPHONE" }, Ps.PLAYER = { type: 3, value: "PLAYER" }, Ps.PROJECTOR = { type: 3, value: "PROJECTOR" }, Ps.RECEIVER = { type: 3, value: "RECEIVER" }, Ps.SPEAKER = { type: 3, value: "SPEAKER" }, Ps.SWITCHER = { type: 3, value: "SWITCHER" }, Ps.TELEPHONE = { type: 3, value: "TELEPHONE" }, Ps.TUNER = { type: 3, value: "TUNER" }, Ps.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAudioVisualApplianceTypeEnum = Ps;
  class no {
  }
  no.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, no.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, no.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, no.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, no.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, no.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcBSplineCurveForm = no;
  class gs {
  }
  gs.PLANE_SURF = { type: 3, value: "PLANE_SURF" }, gs.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" }, gs.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" }, gs.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" }, gs.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" }, gs.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" }, gs.RULED_SURF = { type: 3, value: "RULED_SURF" }, gs.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" }, gs.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" }, gs.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" }, gs.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcBSplineSurfaceForm = gs;
  class fo {
  }
  fo.BEAM = { type: 3, value: "BEAM" }, fo.JOIST = { type: 3, value: "JOIST" }, fo.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" }, fo.LINTEL = { type: 3, value: "LINTEL" }, fo.SPANDREL = { type: 3, value: "SPANDREL" }, fo.T_BEAM = { type: 3, value: "T_BEAM" }, fo.USERDEFINED = { type: 3, value: "USERDEFINED" }, fo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBeamTypeEnum = fo;
  class xs {
  }
  xs.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, xs.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, xs.LESSTHAN = { type: 3, value: "LESSTHAN" }, xs.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, xs.EQUALTO = { type: 3, value: "EQUALTO" }, xs.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" }, xs.INCLUDES = { type: 3, value: "INCLUDES" }, xs.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" }, xs.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" }, xs.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" }, r.IfcBenchmarkEnum = xs;
  class Ir {
  }
  Ir.WATER = { type: 3, value: "WATER" }, Ir.STEAM = { type: 3, value: "STEAM" }, Ir.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ir.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBoilerTypeEnum = Ir;
  class ws {
  }
  ws.UNION = { type: 3, value: "UNION" }, ws.INTERSECTION = { type: 3, value: "INTERSECTION" }, ws.DIFFERENCE = { type: 3, value: "DIFFERENCE" }, r.IfcBooleanOperator = ws;
  class fr {
  }
  fr.INSULATION = { type: 3, value: "INSULATION" }, fr.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" }, fr.USERDEFINED = { type: 3, value: "USERDEFINED" }, fr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingElementPartTypeEnum = fr;
  class Mr {
  }
  Mr.COMPLEX = { type: 3, value: "COMPLEX" }, Mr.ELEMENT = { type: 3, value: "ELEMENT" }, Mr.PARTIAL = { type: 3, value: "PARTIAL" }, Mr.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" }, Mr.PROVISIONFORSPACE = { type: 3, value: "PROVISIONFORSPACE" }, Mr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingElementProxyTypeEnum = Mr;
  class Nr {
  }
  Nr.FENESTRATION = { type: 3, value: "FENESTRATION" }, Nr.FOUNDATION = { type: 3, value: "FOUNDATION" }, Nr.LOADBEARING = { type: 3, value: "LOADBEARING" }, Nr.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, Nr.SHADING = { type: 3, value: "SHADING" }, Nr.TRANSPORT = { type: 3, value: "TRANSPORT" }, Nr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingSystemTypeEnum = Nr;
  class ii {
  }
  ii.USERDEFINED = { type: 3, value: "USERDEFINED" }, ii.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBurnerTypeEnum = ii;
  class Ro {
  }
  Ro.BEND = { type: 3, value: "BEND" }, Ro.CROSS = { type: 3, value: "CROSS" }, Ro.REDUCER = { type: 3, value: "REDUCER" }, Ro.TEE = { type: 3, value: "TEE" }, Ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierFittingTypeEnum = Ro;
  class Bo {
  }
  Bo.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, Bo.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, Bo.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, Bo.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, Bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierSegmentTypeEnum = Bo;
  class Rs {
  }
  Rs.CONNECTOR = { type: 3, value: "CONNECTOR" }, Rs.ENTRY = { type: 3, value: "ENTRY" }, Rs.EXIT = { type: 3, value: "EXIT" }, Rs.JUNCTION = { type: 3, value: "JUNCTION" }, Rs.TRANSITION = { type: 3, value: "TRANSITION" }, Rs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableFittingTypeEnum = Rs;
  class Uo {
  }
  Uo.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" }, Uo.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, Uo.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, Uo.CORESEGMENT = { type: 3, value: "CORESEGMENT" }, Uo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Uo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableSegmentTypeEnum = Uo;
  class xi {
  }
  xi.NOCHANGE = { type: 3, value: "NOCHANGE" }, xi.MODIFIED = { type: 3, value: "MODIFIED" }, xi.ADDED = { type: 3, value: "ADDED" }, xi.DELETED = { type: 3, value: "DELETED" }, xi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChangeActionEnum = xi;
  class Vo {
  }
  Vo.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, Vo.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, Vo.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, Vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChillerTypeEnum = Vo;
  class oa {
  }
  oa.USERDEFINED = { type: 3, value: "USERDEFINED" }, oa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChimneyTypeEnum = oa;
  class ti {
  }
  ti.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, ti.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, ti.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, ti.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" }, ti.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, ti.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, ti.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, ti.USERDEFINED = { type: 3, value: "USERDEFINED" }, ti.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoilTypeEnum = ti;
  class Po {
  }
  Po.COLUMN = { type: 3, value: "COLUMN" }, Po.PILASTER = { type: 3, value: "PILASTER" }, Po.USERDEFINED = { type: 3, value: "USERDEFINED" }, Po.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcColumnTypeEnum = Po;
  class ai {
  }
  ai.ANTENNA = { type: 3, value: "ANTENNA" }, ai.COMPUTER = { type: 3, value: "COMPUTER" }, ai.FAX = { type: 3, value: "FAX" }, ai.GATEWAY = { type: 3, value: "GATEWAY" }, ai.MODEM = { type: 3, value: "MODEM" }, ai.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" }, ai.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" }, ai.NETWORKHUB = { type: 3, value: "NETWORKHUB" }, ai.PRINTER = { type: 3, value: "PRINTER" }, ai.REPEATER = { type: 3, value: "REPEATER" }, ai.ROUTER = { type: 3, value: "ROUTER" }, ai.SCANNER = { type: 3, value: "SCANNER" }, ai.USERDEFINED = { type: 3, value: "USERDEFINED" }, ai.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCommunicationsApplianceTypeEnum = ai;
  class Wo {
  }
  Wo.P_COMPLEX = { type: 3, value: "P_COMPLEX" }, Wo.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" }, r.IfcComplexPropertyTemplateTypeEnum = Wo;
  class As {
  }
  As.DYNAMIC = { type: 3, value: "DYNAMIC" }, As.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, As.ROTARY = { type: 3, value: "ROTARY" }, As.SCROLL = { type: 3, value: "SCROLL" }, As.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, As.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, As.BOOSTER = { type: 3, value: "BOOSTER" }, As.OPENTYPE = { type: 3, value: "OPENTYPE" }, As.HERMETIC = { type: 3, value: "HERMETIC" }, As.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, As.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, As.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, As.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, As.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, As.TWINSCREW = { type: 3, value: "TWINSCREW" }, As.USERDEFINED = { type: 3, value: "USERDEFINED" }, As.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCompressorTypeEnum = As;
  class ro {
  }
  ro.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, ro.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, ro.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, ro.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, ro.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, ro.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, ro.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCondenserTypeEnum = ro;
  class Mo {
  }
  Mo.ATPATH = { type: 3, value: "ATPATH" }, Mo.ATSTART = { type: 3, value: "ATSTART" }, Mo.ATEND = { type: 3, value: "ATEND" }, Mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConnectionTypeEnum = Mo;
  class vr {
  }
  vr.HARD = { type: 3, value: "HARD" }, vr.SOFT = { type: 3, value: "SOFT" }, vr.ADVISORY = { type: 3, value: "ADVISORY" }, vr.USERDEFINED = { type: 3, value: "USERDEFINED" }, vr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstraintEnum = vr;
  class ts {
  }
  ts.DEMOLISHING = { type: 3, value: "DEMOLISHING" }, ts.EARTHMOVING = { type: 3, value: "EARTHMOVING" }, ts.ERECTING = { type: 3, value: "ERECTING" }, ts.HEATING = { type: 3, value: "HEATING" }, ts.LIGHTING = { type: 3, value: "LIGHTING" }, ts.PAVING = { type: 3, value: "PAVING" }, ts.PUMPING = { type: 3, value: "PUMPING" }, ts.TRANSPORTING = { type: 3, value: "TRANSPORTING" }, ts.USERDEFINED = { type: 3, value: "USERDEFINED" }, ts.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstructionEquipmentResourceTypeEnum = ts;
  class kr {
  }
  kr.AGGREGATES = { type: 3, value: "AGGREGATES" }, kr.CONCRETE = { type: 3, value: "CONCRETE" }, kr.DRYWALL = { type: 3, value: "DRYWALL" }, kr.FUEL = { type: 3, value: "FUEL" }, kr.GYPSUM = { type: 3, value: "GYPSUM" }, kr.MASONRY = { type: 3, value: "MASONRY" }, kr.METAL = { type: 3, value: "METAL" }, kr.PLASTIC = { type: 3, value: "PLASTIC" }, kr.WOOD = { type: 3, value: "WOOD" }, kr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, kr.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcConstructionMaterialResourceTypeEnum = kr;
  class Us {
  }
  Us.ASSEMBLY = { type: 3, value: "ASSEMBLY" }, Us.FORMWORK = { type: 3, value: "FORMWORK" }, Us.USERDEFINED = { type: 3, value: "USERDEFINED" }, Us.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstructionProductResourceTypeEnum = Us;
  class ri {
  }
  ri.FLOATING = { type: 3, value: "FLOATING" }, ri.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" }, ri.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, ri.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" }, ri.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, ri.USERDEFINED = { type: 3, value: "USERDEFINED" }, ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcControllerTypeEnum = ri;
  class Wi {
  }
  Wi.ACTIVE = { type: 3, value: "ACTIVE" }, Wi.PASSIVE = { type: 3, value: "PASSIVE" }, Wi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCooledBeamTypeEnum = Wi;
  class To {
  }
  To.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, To.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, To.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, To.USERDEFINED = { type: 3, value: "USERDEFINED" }, To.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoolingTowerTypeEnum = To;
  class ia {
  }
  ia.USERDEFINED = { type: 3, value: "USERDEFINED" }, ia.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCostItemTypeEnum = ia;
  class bo {
  }
  bo.BUDGET = { type: 3, value: "BUDGET" }, bo.COSTPLAN = { type: 3, value: "COSTPLAN" }, bo.ESTIMATE = { type: 3, value: "ESTIMATE" }, bo.TENDER = { type: 3, value: "TENDER" }, bo.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, bo.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, bo.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCostScheduleTypeEnum = bo;
  class Ys {
  }
  Ys.CEILING = { type: 3, value: "CEILING" }, Ys.FLOORING = { type: 3, value: "FLOORING" }, Ys.CLADDING = { type: 3, value: "CLADDING" }, Ys.ROOFING = { type: 3, value: "ROOFING" }, Ys.MOLDING = { type: 3, value: "MOLDING" }, Ys.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" }, Ys.INSULATION = { type: 3, value: "INSULATION" }, Ys.MEMBRANE = { type: 3, value: "MEMBRANE" }, Ys.SLEEVING = { type: 3, value: "SLEEVING" }, Ys.WRAPPING = { type: 3, value: "WRAPPING" }, Ys.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ys.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoveringTypeEnum = Ys;
  class Di {
  }
  Di.OFFICE = { type: 3, value: "OFFICE" }, Di.SITE = { type: 3, value: "SITE" }, Di.USERDEFINED = { type: 3, value: "USERDEFINED" }, Di.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCrewResourceTypeEnum = Di;
  class Yn {
  }
  Yn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCurtainWallTypeEnum = Yn;
  class Lo {
  }
  Lo.LINEAR = { type: 3, value: "LINEAR" }, Lo.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" }, Lo.LOG_LOG = { type: 3, value: "LOG_LOG" }, Lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCurveInterpolationEnum = Lo;
  class Un {
  }
  Un.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, Un.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, Un.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, Un.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, Un.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, Un.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, Un.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, Un.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, Un.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, Un.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, Un.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, Un.USERDEFINED = { type: 3, value: "USERDEFINED" }, Un.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDamperTypeEnum = Un;
  class so {
  }
  so.MEASURED = { type: 3, value: "MEASURED" }, so.PREDICTED = { type: 3, value: "PREDICTED" }, so.SIMULATED = { type: 3, value: "SIMULATED" }, so.USERDEFINED = { type: 3, value: "USERDEFINED" }, so.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDataOriginEnum = so;
  class rs {
  }
  rs.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, rs.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" }, rs.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, rs.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, rs.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, rs.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, rs.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, rs.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, rs.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, rs.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, rs.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, rs.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, rs.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, rs.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, rs.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, rs.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, rs.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, rs.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, rs.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, rs.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, rs.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, rs.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, rs.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, rs.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, rs.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, rs.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, rs.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, rs.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, rs.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, rs.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, rs.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, rs.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, rs.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, rs.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, rs.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, rs.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, rs.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, rs.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, rs.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, rs.PHUNIT = { type: 3, value: "PHUNIT" }, rs.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, rs.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, rs.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, rs.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" }, rs.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, rs.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" }, rs.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, rs.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, rs.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" }, rs.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, rs.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, rs.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, rs.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcDerivedUnitEnum = rs;
  class hi {
  }
  hi.POSITIVE = { type: 3, value: "POSITIVE" }, hi.NEGATIVE = { type: 3, value: "NEGATIVE" }, r.IfcDirectionSenseEnum = hi;
  class Zo {
  }
  Zo.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" }, Zo.BRACKET = { type: 3, value: "BRACKET" }, Zo.SHOE = { type: 3, value: "SHOE" }, Zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDiscreteAccessoryTypeEnum = Zo;
  class li {
  }
  li.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, li.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, li.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, li.MANHOLE = { type: 3, value: "MANHOLE" }, li.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, li.SUMP = { type: 3, value: "SUMP" }, li.TRENCH = { type: 3, value: "TRENCH" }, li.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, li.USERDEFINED = { type: 3, value: "USERDEFINED" }, li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionChamberElementTypeEnum = li;
  class ei {
  }
  ei.CABLE = { type: 3, value: "CABLE" }, ei.CABLECARRIER = { type: 3, value: "CABLECARRIER" }, ei.DUCT = { type: 3, value: "DUCT" }, ei.PIPE = { type: 3, value: "PIPE" }, ei.USERDEFINED = { type: 3, value: "USERDEFINED" }, ei.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionPortTypeEnum = ei;
  class Or {
  }
  Or.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" }, Or.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" }, Or.CHEMICAL = { type: 3, value: "CHEMICAL" }, Or.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" }, Or.COMMUNICATION = { type: 3, value: "COMMUNICATION" }, Or.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" }, Or.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" }, Or.CONTROL = { type: 3, value: "CONTROL" }, Or.CONVEYING = { type: 3, value: "CONVEYING" }, Or.DATA = { type: 3, value: "DATA" }, Or.DISPOSAL = { type: 3, value: "DISPOSAL" }, Or.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" }, Or.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" }, Or.DRAINAGE = { type: 3, value: "DRAINAGE" }, Or.EARTHING = { type: 3, value: "EARTHING" }, Or.ELECTRICAL = { type: 3, value: "ELECTRICAL" }, Or.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" }, Or.EXHAUST = { type: 3, value: "EXHAUST" }, Or.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" }, Or.FUEL = { type: 3, value: "FUEL" }, Or.GAS = { type: 3, value: "GAS" }, Or.HAZARDOUS = { type: 3, value: "HAZARDOUS" }, Or.HEATING = { type: 3, value: "HEATING" }, Or.LIGHTING = { type: 3, value: "LIGHTING" }, Or.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" }, Or.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" }, Or.OIL = { type: 3, value: "OIL" }, Or.OPERATIONAL = { type: 3, value: "OPERATIONAL" }, Or.POWERGENERATION = { type: 3, value: "POWERGENERATION" }, Or.RAINWATER = { type: 3, value: "RAINWATER" }, Or.REFRIGERATION = { type: 3, value: "REFRIGERATION" }, Or.SECURITY = { type: 3, value: "SECURITY" }, Or.SEWAGE = { type: 3, value: "SEWAGE" }, Or.SIGNAL = { type: 3, value: "SIGNAL" }, Or.STORMWATER = { type: 3, value: "STORMWATER" }, Or.TELEPHONE = { type: 3, value: "TELEPHONE" }, Or.TV = { type: 3, value: "TV" }, Or.VACUUM = { type: 3, value: "VACUUM" }, Or.VENT = { type: 3, value: "VENT" }, Or.VENTILATION = { type: 3, value: "VENTILATION" }, Or.WASTEWATER = { type: 3, value: "WASTEWATER" }, Or.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" }, Or.USERDEFINED = { type: 3, value: "USERDEFINED" }, Or.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionSystemEnum = Or;
  class ui {
  }
  ui.PUBLIC = { type: 3, value: "PUBLIC" }, ui.RESTRICTED = { type: 3, value: "RESTRICTED" }, ui.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, ui.PERSONAL = { type: 3, value: "PERSONAL" }, ui.USERDEFINED = { type: 3, value: "USERDEFINED" }, ui.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentConfidentialityEnum = ui;
  class _s {
  }
  _s.DRAFT = { type: 3, value: "DRAFT" }, _s.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, _s.FINAL = { type: 3, value: "FINAL" }, _s.REVISION = { type: 3, value: "REVISION" }, _s.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentStatusEnum = _s;
  class xo {
  }
  xo.SWINGING = { type: 3, value: "SWINGING" }, xo.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, xo.SLIDING = { type: 3, value: "SLIDING" }, xo.FOLDING = { type: 3, value: "FOLDING" }, xo.REVOLVING = { type: 3, value: "REVOLVING" }, xo.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, xo.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" }, xo.USERDEFINED = { type: 3, value: "USERDEFINED" }, xo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelOperationEnum = xo;
  class aa {
  }
  aa.LEFT = { type: 3, value: "LEFT" }, aa.MIDDLE = { type: 3, value: "MIDDLE" }, aa.RIGHT = { type: 3, value: "RIGHT" }, aa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelPositionEnum = aa;
  class oo {
  }
  oo.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, oo.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, oo.STEEL = { type: 3, value: "STEEL" }, oo.WOOD = { type: 3, value: "WOOD" }, oo.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, oo.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, oo.PLASTIC = { type: 3, value: "PLASTIC" }, oo.USERDEFINED = { type: 3, value: "USERDEFINED" }, oo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleConstructionEnum = oo;
  class vs {
  }
  vs.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, vs.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, vs.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, vs.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, vs.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, vs.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, vs.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, vs.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, vs.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, vs.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, vs.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, vs.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, vs.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, vs.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, vs.REVOLVING = { type: 3, value: "REVOLVING" }, vs.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleOperationEnum = vs;
  class yi {
  }
  yi.DOOR = { type: 3, value: "DOOR" }, yi.GATE = { type: 3, value: "GATE" }, yi.TRAPDOOR = { type: 3, value: "TRAPDOOR" }, yi.USERDEFINED = { type: 3, value: "USERDEFINED" }, yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorTypeEnum = yi;
  class $r {
  }
  $r.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, $r.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, $r.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, $r.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, $r.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, $r.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, $r.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, $r.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, $r.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, $r.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, $r.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, $r.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, $r.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, $r.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, $r.REVOLVING = { type: 3, value: "REVOLVING" }, $r.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, $r.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" }, $r.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" }, $r.USERDEFINED = { type: 3, value: "USERDEFINED" }, $r.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorTypeOperationEnum = $r;
  class ki {
  }
  ki.BEND = { type: 3, value: "BEND" }, ki.CONNECTOR = { type: 3, value: "CONNECTOR" }, ki.ENTRY = { type: 3, value: "ENTRY" }, ki.EXIT = { type: 3, value: "EXIT" }, ki.JUNCTION = { type: 3, value: "JUNCTION" }, ki.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, ki.TRANSITION = { type: 3, value: "TRANSITION" }, ki.USERDEFINED = { type: 3, value: "USERDEFINED" }, ki.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctFittingTypeEnum = ki;
  class ds {
  }
  ds.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, ds.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSegmentTypeEnum = ds;
  class Ls {
  }
  Ls.FLATOVAL = { type: 3, value: "FLATOVAL" }, Ls.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, Ls.ROUND = { type: 3, value: "ROUND" }, Ls.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ls.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSilencerTypeEnum = Ls;
  class Co {
  }
  Co.DISHWASHER = { type: 3, value: "DISHWASHER" }, Co.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, Co.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" }, Co.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, Co.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" }, Co.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" }, Co.FREEZER = { type: 3, value: "FREEZER" }, Co.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, Co.HANDDRYER = { type: 3, value: "HANDDRYER" }, Co.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" }, Co.MICROWAVE = { type: 3, value: "MICROWAVE" }, Co.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, Co.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, Co.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, Co.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, Co.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, Co.USERDEFINED = { type: 3, value: "USERDEFINED" }, Co.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricApplianceTypeEnum = Co;
  class ps {
  }
  ps.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, ps.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, ps.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, ps.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, ps.USERDEFINED = { type: 3, value: "USERDEFINED" }, ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricDistributionBoardTypeEnum = ps;
  class Tr {
  }
  Tr.BATTERY = { type: 3, value: "BATTERY" }, Tr.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, Tr.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, Tr.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, Tr.UPS = { type: 3, value: "UPS" }, Tr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Tr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricFlowStorageDeviceTypeEnum = Tr;
  class ao {
  }
  ao.CHP = { type: 3, value: "CHP" }, ao.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" }, ao.STANDALONE = { type: 3, value: "STANDALONE" }, ao.USERDEFINED = { type: 3, value: "USERDEFINED" }, ao.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricGeneratorTypeEnum = ao;
  class Gt {
  }
  Gt.DC = { type: 3, value: "DC" }, Gt.INDUCTION = { type: 3, value: "INDUCTION" }, Gt.POLYPHASE = { type: 3, value: "POLYPHASE" }, Gt.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, Gt.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, Gt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricMotorTypeEnum = Gt;
  class sr {
  }
  sr.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, sr.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, sr.RELAY = { type: 3, value: "RELAY" }, sr.USERDEFINED = { type: 3, value: "USERDEFINED" }, sr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricTimeControlTypeEnum = sr;
  class vt {
  }
  vt.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, vt.ARCH = { type: 3, value: "ARCH" }, vt.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, vt.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, vt.GIRDER = { type: 3, value: "GIRDER" }, vt.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, vt.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, vt.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, vt.TRUSS = { type: 3, value: "TRUSS" }, vt.USERDEFINED = { type: 3, value: "USERDEFINED" }, vt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElementAssemblyTypeEnum = vt;
  class Jr {
  }
  Jr.COMPLEX = { type: 3, value: "COMPLEX" }, Jr.ELEMENT = { type: 3, value: "ELEMENT" }, Jr.PARTIAL = { type: 3, value: "PARTIAL" }, r.IfcElementCompositionEnum = Jr;
  class Qs {
  }
  Qs.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" }, Qs.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" }, Qs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEngineTypeEnum = Qs;
  class Ds {
  }
  Ds.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, Ds.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, Ds.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, Ds.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, Ds.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, Ds.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, Ds.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, Ds.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, Ds.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, Ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporativeCoolerTypeEnum = Ds;
  class Hs {
  }
  Hs.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" }, Hs.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, Hs.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, Hs.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, Hs.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, Hs.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, Hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporatorTypeEnum = Hs;
  class Xr {
  }
  Xr.EVENTRULE = { type: 3, value: "EVENTRULE" }, Xr.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" }, Xr.EVENTTIME = { type: 3, value: "EVENTTIME" }, Xr.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" }, Xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEventTriggerTypeEnum = Xr;
  class bi {
  }
  bi.STARTEVENT = { type: 3, value: "STARTEVENT" }, bi.ENDEVENT = { type: 3, value: "ENDEVENT" }, bi.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" }, bi.USERDEFINED = { type: 3, value: "USERDEFINED" }, bi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEventTypeEnum = bi;
  class rn {
  }
  rn.EXTERNAL = { type: 3, value: "EXTERNAL" }, rn.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, rn.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, rn.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, rn.USERDEFINED = { type: 3, value: "USERDEFINED" }, rn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcExternalSpatialElementTypeEnum = rn;
  class mo {
  }
  mo.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, mo.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, mo.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, mo.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, mo.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, mo.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, mo.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, mo.USERDEFINED = { type: 3, value: "USERDEFINED" }, mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFanTypeEnum = mo;
  class Gi {
  }
  Gi.GLUE = { type: 3, value: "GLUE" }, Gi.MORTAR = { type: 3, value: "MORTAR" }, Gi.WELD = { type: 3, value: "WELD" }, Gi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFastenerTypeEnum = Gi;
  class yo {
  }
  yo.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, yo.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" }, yo.ODORFILTER = { type: 3, value: "ODORFILTER" }, yo.OILFILTER = { type: 3, value: "OILFILTER" }, yo.STRAINER = { type: 3, value: "STRAINER" }, yo.WATERFILTER = { type: 3, value: "WATERFILTER" }, yo.USERDEFINED = { type: 3, value: "USERDEFINED" }, yo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFilterTypeEnum = yo;
  class ci {
  }
  ci.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, ci.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, ci.HOSEREEL = { type: 3, value: "HOSEREEL" }, ci.SPRINKLER = { type: 3, value: "SPRINKLER" }, ci.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, ci.USERDEFINED = { type: 3, value: "USERDEFINED" }, ci.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFireSuppressionTerminalTypeEnum = ci;
  class Ri {
  }
  Ri.SOURCE = { type: 3, value: "SOURCE" }, Ri.SINK = { type: 3, value: "SINK" }, Ri.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, Ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowDirectionEnum = Ri;
  class ms {
  }
  ms.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, ms.THERMOMETER = { type: 3, value: "THERMOMETER" }, ms.AMMETER = { type: 3, value: "AMMETER" }, ms.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, ms.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, ms.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, ms.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, ms.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, ms.USERDEFINED = { type: 3, value: "USERDEFINED" }, ms.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowInstrumentTypeEnum = ms;
  class zt {
  }
  zt.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, zt.GASMETER = { type: 3, value: "GASMETER" }, zt.OILMETER = { type: 3, value: "OILMETER" }, zt.WATERMETER = { type: 3, value: "WATERMETER" }, zt.USERDEFINED = { type: 3, value: "USERDEFINED" }, zt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowMeterTypeEnum = zt;
  class fn {
  }
  fn.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" }, fn.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, fn.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, fn.PILE_CAP = { type: 3, value: "PILE_CAP" }, fn.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, fn.USERDEFINED = { type: 3, value: "USERDEFINED" }, fn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFootingTypeEnum = fn;
  class Bn {
  }
  Bn.CHAIR = { type: 3, value: "CHAIR" }, Bn.TABLE = { type: 3, value: "TABLE" }, Bn.DESK = { type: 3, value: "DESK" }, Bn.BED = { type: 3, value: "BED" }, Bn.FILECABINET = { type: 3, value: "FILECABINET" }, Bn.SHELF = { type: 3, value: "SHELF" }, Bn.SOFA = { type: 3, value: "SOFA" }, Bn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFurnitureTypeEnum = Bn;
  class or {
  }
  or.TERRAIN = { type: 3, value: "TERRAIN" }, or.USERDEFINED = { type: 3, value: "USERDEFINED" }, or.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeographicElementTypeEnum = or;
  class ss {
  }
  ss.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, ss.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, ss.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, ss.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, ss.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, ss.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, ss.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, ss.USERDEFINED = { type: 3, value: "USERDEFINED" }, ss.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeometricProjectionEnum = ss;
  class Xs {
  }
  Xs.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, Xs.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" }, r.IfcGlobalOrLocalEnum = Xs;
  class Fo {
  }
  Fo.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, Fo.RADIAL = { type: 3, value: "RADIAL" }, Fo.TRIANGULAR = { type: 3, value: "TRIANGULAR" }, Fo.IRREGULAR = { type: 3, value: "IRREGULAR" }, Fo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGridTypeEnum = Fo;
  class ji {
  }
  ji.PLATE = { type: 3, value: "PLATE" }, ji.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, ji.USERDEFINED = { type: 3, value: "USERDEFINED" }, ji.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHeatExchangerTypeEnum = ji;
  class zo {
  }
  zo.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, zo.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, zo.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, zo.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, zo.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, zo.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, zo.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, zo.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, zo.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, zo.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, zo.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, zo.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, zo.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHumidifierTypeEnum = zo;
  class Yi {
  }
  Yi.CYCLONIC = { type: 3, value: "CYCLONIC" }, Yi.GREASE = { type: 3, value: "GREASE" }, Yi.OIL = { type: 3, value: "OIL" }, Yi.PETROL = { type: 3, value: "PETROL" }, Yi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInterceptorTypeEnum = Yi;
  class Li {
  }
  Li.INTERNAL = { type: 3, value: "INTERNAL" }, Li.EXTERNAL = { type: 3, value: "EXTERNAL" }, Li.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, Li.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, Li.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, Li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInternalOrExternalEnum = Li;
  class _i {
  }
  _i.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, _i.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, _i.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, _i.USERDEFINED = { type: 3, value: "USERDEFINED" }, _i.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInventoryTypeEnum = _i;
  class pa {
  }
  pa.DATA = { type: 3, value: "DATA" }, pa.POWER = { type: 3, value: "POWER" }, pa.USERDEFINED = { type: 3, value: "USERDEFINED" }, pa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcJunctionBoxTypeEnum = pa;
  class $o {
  }
  $o.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" }, $o.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" }, $o.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" }, $o.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcKnotType = $o;
  class wo {
  }
  wo.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" }, wo.CARPENTRY = { type: 3, value: "CARPENTRY" }, wo.CLEANING = { type: 3, value: "CLEANING" }, wo.CONCRETE = { type: 3, value: "CONCRETE" }, wo.DRYWALL = { type: 3, value: "DRYWALL" }, wo.ELECTRIC = { type: 3, value: "ELECTRIC" }, wo.FINISHING = { type: 3, value: "FINISHING" }, wo.FLOORING = { type: 3, value: "FLOORING" }, wo.GENERAL = { type: 3, value: "GENERAL" }, wo.HVAC = { type: 3, value: "HVAC" }, wo.LANDSCAPING = { type: 3, value: "LANDSCAPING" }, wo.MASONRY = { type: 3, value: "MASONRY" }, wo.PAINTING = { type: 3, value: "PAINTING" }, wo.PAVING = { type: 3, value: "PAVING" }, wo.PLUMBING = { type: 3, value: "PLUMBING" }, wo.ROOFING = { type: 3, value: "ROOFING" }, wo.SITEGRADING = { type: 3, value: "SITEGRADING" }, wo.STEELWORK = { type: 3, value: "STEELWORK" }, wo.SURVEYING = { type: 3, value: "SURVEYING" }, wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLaborResourceTypeEnum = wo;
  class Ks {
  }
  Ks.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, Ks.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, Ks.HALOGEN = { type: 3, value: "HALOGEN" }, Ks.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, Ks.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, Ks.LED = { type: 3, value: "LED" }, Ks.METALHALIDE = { type: 3, value: "METALHALIDE" }, Ks.OLED = { type: 3, value: "OLED" }, Ks.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, Ks.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ks.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLampTypeEnum = Ks;
  class Qo {
  }
  Qo.AXIS1 = { type: 3, value: "AXIS1" }, Qo.AXIS2 = { type: 3, value: "AXIS2" }, Qo.AXIS3 = { type: 3, value: "AXIS3" }, r.IfcLayerSetDirectionEnum = Qo;
  class pi {
  }
  pi.TYPE_A = { type: 3, value: "TYPE_A" }, pi.TYPE_B = { type: 3, value: "TYPE_B" }, pi.TYPE_C = { type: 3, value: "TYPE_C" }, pi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightDistributionCurveEnum = pi;
  class Ns {
  }
  Ns.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, Ns.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, Ns.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, Ns.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, Ns.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, Ns.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, Ns.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, Ns.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, Ns.METALHALIDE = { type: 3, value: "METALHALIDE" }, Ns.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, Ns.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightEmissionSourceEnum = Ns;
  class Fi {
  }
  Fi.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, Fi.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, Fi.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" }, Fi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightFixtureTypeEnum = Fi;
  class la {
  }
  la.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, la.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, la.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, la.USERDEFINED = { type: 3, value: "USERDEFINED" }, la.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLoadGroupTypeEnum = la;
  class Ho {
  }
  Ho.LOGICALAND = { type: 3, value: "LOGICALAND" }, Ho.LOGICALOR = { type: 3, value: "LOGICALOR" }, Ho.LOGICALXOR = { type: 3, value: "LOGICALXOR" }, Ho.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" }, Ho.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" }, r.IfcLogicalOperatorEnum = Ho;
  class Ye {
  }
  Ye.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" }, Ye.BOLT = { type: 3, value: "BOLT" }, Ye.DOWEL = { type: 3, value: "DOWEL" }, Ye.NAIL = { type: 3, value: "NAIL" }, Ye.NAILPLATE = { type: 3, value: "NAILPLATE" }, Ye.RIVET = { type: 3, value: "RIVET" }, Ye.SCREW = { type: 3, value: "SCREW" }, Ye.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" }, Ye.STAPLE = { type: 3, value: "STAPLE" }, Ye.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" }, Ye.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ye.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMechanicalFastenerTypeEnum = Ye;
  class qe {
  }
  qe.AIRSTATION = { type: 3, value: "AIRSTATION" }, qe.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" }, qe.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" }, qe.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" }, qe.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" }, qe.USERDEFINED = { type: 3, value: "USERDEFINED" }, qe.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMedicalDeviceTypeEnum = qe;
  class Nt {
  }
  Nt.BRACE = { type: 3, value: "BRACE" }, Nt.CHORD = { type: 3, value: "CHORD" }, Nt.COLLAR = { type: 3, value: "COLLAR" }, Nt.MEMBER = { type: 3, value: "MEMBER" }, Nt.MULLION = { type: 3, value: "MULLION" }, Nt.PLATE = { type: 3, value: "PLATE" }, Nt.POST = { type: 3, value: "POST" }, Nt.PURLIN = { type: 3, value: "PURLIN" }, Nt.RAFTER = { type: 3, value: "RAFTER" }, Nt.STRINGER = { type: 3, value: "STRINGER" }, Nt.STRUT = { type: 3, value: "STRUT" }, Nt.STUD = { type: 3, value: "STUD" }, Nt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMemberTypeEnum = Nt;
  class mt {
  }
  mt.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, mt.COUPLING = { type: 3, value: "COUPLING" }, mt.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, mt.USERDEFINED = { type: 3, value: "USERDEFINED" }, mt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMotorConnectionTypeEnum = mt;
  class pn {
  }
  pn.NULL = { type: 3, value: "NULL" }, r.IfcNullStyle = pn;
  class Mt {
  }
  Mt.PRODUCT = { type: 3, value: "PRODUCT" }, Mt.PROCESS = { type: 3, value: "PROCESS" }, Mt.CONTROL = { type: 3, value: "CONTROL" }, Mt.RESOURCE = { type: 3, value: "RESOURCE" }, Mt.ACTOR = { type: 3, value: "ACTOR" }, Mt.GROUP = { type: 3, value: "GROUP" }, Mt.PROJECT = { type: 3, value: "PROJECT" }, Mt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectTypeEnum = Mt;
  class Ln {
  }
  Ln.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, Ln.CODEWAIVER = { type: 3, value: "CODEWAIVER" }, Ln.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, Ln.EXTERNAL = { type: 3, value: "EXTERNAL" }, Ln.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, Ln.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" }, Ln.MODELVIEW = { type: 3, value: "MODELVIEW" }, Ln.PARAMETER = { type: 3, value: "PARAMETER" }, Ln.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, Ln.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, Ln.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, Ln.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ln.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectiveEnum = Ln;
  class ot {
  }
  ot.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, ot.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, ot.LESSEE = { type: 3, value: "LESSEE" }, ot.LESSOR = { type: 3, value: "LESSOR" }, ot.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, ot.OWNER = { type: 3, value: "OWNER" }, ot.TENANT = { type: 3, value: "TENANT" }, ot.USERDEFINED = { type: 3, value: "USERDEFINED" }, ot.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOccupantTypeEnum = ot;
  class Xt {
  }
  Xt.OPENING = { type: 3, value: "OPENING" }, Xt.RECESS = { type: 3, value: "RECESS" }, Xt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOpeningElementTypeEnum = Xt;
  class sn {
  }
  sn.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, sn.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, sn.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, sn.DATAOUTLET = { type: 3, value: "DATAOUTLET" }, sn.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" }, sn.USERDEFINED = { type: 3, value: "USERDEFINED" }, sn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOutletTypeEnum = sn;
  class dn {
  }
  dn.USERDEFINED = { type: 3, value: "USERDEFINED" }, dn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPerformanceHistoryTypeEnum = dn;
  class Ar {
  }
  Ar.GRILL = { type: 3, value: "GRILL" }, Ar.LOUVER = { type: 3, value: "LOUVER" }, Ar.SCREEN = { type: 3, value: "SCREEN" }, Ar.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ar.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPermeableCoveringOperationEnum = Ar;
  class yr {
  }
  yr.ACCESS = { type: 3, value: "ACCESS" }, yr.BUILDING = { type: 3, value: "BUILDING" }, yr.WORK = { type: 3, value: "WORK" }, yr.USERDEFINED = { type: 3, value: "USERDEFINED" }, yr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPermitTypeEnum = yr;
  class Pr {
  }
  Pr.PHYSICAL = { type: 3, value: "PHYSICAL" }, Pr.VIRTUAL = { type: 3, value: "VIRTUAL" }, Pr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPhysicalOrVirtualEnum = Pr;
  class Zr {
  }
  Zr.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, Zr.COMPOSITE = { type: 3, value: "COMPOSITE" }, Zr.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, Zr.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, Zr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileConstructionEnum = Zr;
  class qs {
  }
  qs.BORED = { type: 3, value: "BORED" }, qs.DRIVEN = { type: 3, value: "DRIVEN" }, qs.JETGROUTING = { type: 3, value: "JETGROUTING" }, qs.COHESION = { type: 3, value: "COHESION" }, qs.FRICTION = { type: 3, value: "FRICTION" }, qs.SUPPORT = { type: 3, value: "SUPPORT" }, qs.USERDEFINED = { type: 3, value: "USERDEFINED" }, qs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileTypeEnum = qs;
  class Ws {
  }
  Ws.BEND = { type: 3, value: "BEND" }, Ws.CONNECTOR = { type: 3, value: "CONNECTOR" }, Ws.ENTRY = { type: 3, value: "ENTRY" }, Ws.EXIT = { type: 3, value: "EXIT" }, Ws.JUNCTION = { type: 3, value: "JUNCTION" }, Ws.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, Ws.TRANSITION = { type: 3, value: "TRANSITION" }, Ws.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ws.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeFittingTypeEnum = Ws;
  class Bs {
  }
  Bs.CULVERT = { type: 3, value: "CULVERT" }, Bs.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, Bs.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, Bs.GUTTER = { type: 3, value: "GUTTER" }, Bs.SPOOL = { type: 3, value: "SPOOL" }, Bs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeSegmentTypeEnum = Bs;
  class Sr {
  }
  Sr.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, Sr.SHEET = { type: 3, value: "SHEET" }, Sr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPlateTypeEnum = Sr;
  class Wr {
  }
  Wr.CURVE3D = { type: 3, value: "CURVE3D" }, Wr.PCURVE_S1 = { type: 3, value: "PCURVE_S1" }, Wr.PCURVE_S2 = { type: 3, value: "PCURVE_S2" }, r.IfcPreferredSurfaceCurveRepresentation = Wr;
  class lo {
  }
  lo.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, lo.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, lo.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, lo.CALIBRATION = { type: 3, value: "CALIBRATION" }, lo.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, lo.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, lo.STARTUP = { type: 3, value: "STARTUP" }, lo.USERDEFINED = { type: 3, value: "USERDEFINED" }, lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProcedureTypeEnum = lo;
  class uo {
  }
  uo.CURVE = { type: 3, value: "CURVE" }, uo.AREA = { type: 3, value: "AREA" }, r.IfcProfileTypeEnum = uo;
  class Vs {
  }
  Vs.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, Vs.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, Vs.MOVEORDER = { type: 3, value: "MOVEORDER" }, Vs.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, Vs.WORKORDER = { type: 3, value: "WORKORDER" }, Vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectOrderTypeEnum = Vs;
  class Gs {
  }
  Gs.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, Gs.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" }, r.IfcProjectedOrTrueLengthEnum = Gs;
  class Ni {
  }
  Ni.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ni.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectionElementTypeEnum = Ni;
  class zi {
  }
  zi.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" }, zi.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" }, zi.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" }, zi.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" }, zi.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" }, zi.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" }, zi.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" }, zi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPropertySetTemplateTypeEnum = zi;
  class Ko {
  }
  Ko.ELECTRONIC = { type: 3, value: "ELECTRONIC" }, Ko.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" }, Ko.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" }, Ko.THERMAL = { type: 3, value: "THERMAL" }, Ko.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ko.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProtectiveDeviceTrippingUnitTypeEnum = Ko;
  class di {
  }
  di.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, di.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" }, di.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" }, di.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, di.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, di.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, di.VARISTOR = { type: 3, value: "VARISTOR" }, di.USERDEFINED = { type: 3, value: "USERDEFINED" }, di.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProtectiveDeviceTypeEnum = di;
  class eo {
  }
  eo.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, eo.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, eo.SPLITCASE = { type: 3, value: "SPLITCASE" }, eo.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" }, eo.SUMPPUMP = { type: 3, value: "SUMPPUMP" }, eo.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, eo.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, eo.USERDEFINED = { type: 3, value: "USERDEFINED" }, eo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPumpTypeEnum = eo;
  class ua {
  }
  ua.HANDRAIL = { type: 3, value: "HANDRAIL" }, ua.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, ua.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, ua.USERDEFINED = { type: 3, value: "USERDEFINED" }, ua.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailingTypeEnum = ua;
  class qo {
  }
  qo.STRAIGHT = { type: 3, value: "STRAIGHT" }, qo.SPIRAL = { type: 3, value: "SPIRAL" }, qo.USERDEFINED = { type: 3, value: "USERDEFINED" }, qo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampFlightTypeEnum = qo;
  class Mi {
  }
  Mi.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, Mi.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, Mi.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, Mi.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, Mi.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, Mi.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, Mi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampTypeEnum = Mi;
  class si {
  }
  si.DAILY = { type: 3, value: "DAILY" }, si.WEEKLY = { type: 3, value: "WEEKLY" }, si.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" }, si.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" }, si.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" }, si.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" }, si.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" }, si.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" }, r.IfcRecurrenceTypeEnum = si;
  class ko {
  }
  ko.BLINN = { type: 3, value: "BLINN" }, ko.FLAT = { type: 3, value: "FLAT" }, ko.GLASS = { type: 3, value: "GLASS" }, ko.MATT = { type: 3, value: "MATT" }, ko.METAL = { type: 3, value: "METAL" }, ko.MIRROR = { type: 3, value: "MIRROR" }, ko.PHONG = { type: 3, value: "PHONG" }, ko.PLASTIC = { type: 3, value: "PLASTIC" }, ko.STRAUSS = { type: 3, value: "STRAUSS" }, ko.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReflectanceMethodEnum = ko;
  class ni {
  }
  ni.MAIN = { type: 3, value: "MAIN" }, ni.SHEAR = { type: 3, value: "SHEAR" }, ni.LIGATURE = { type: 3, value: "LIGATURE" }, ni.STUD = { type: 3, value: "STUD" }, ni.PUNCHING = { type: 3, value: "PUNCHING" }, ni.EDGE = { type: 3, value: "EDGE" }, ni.RING = { type: 3, value: "RING" }, ni.ANCHORING = { type: 3, value: "ANCHORING" }, ni.USERDEFINED = { type: 3, value: "USERDEFINED" }, ni.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingBarRoleEnum = ni;
  class da {
  }
  da.PLAIN = { type: 3, value: "PLAIN" }, da.TEXTURED = { type: 3, value: "TEXTURED" }, r.IfcReinforcingBarSurfaceEnum = da;
  class vi {
  }
  vi.ANCHORING = { type: 3, value: "ANCHORING" }, vi.EDGE = { type: 3, value: "EDGE" }, vi.LIGATURE = { type: 3, value: "LIGATURE" }, vi.MAIN = { type: 3, value: "MAIN" }, vi.PUNCHING = { type: 3, value: "PUNCHING" }, vi.RING = { type: 3, value: "RING" }, vi.SHEAR = { type: 3, value: "SHEAR" }, vi.STUD = { type: 3, value: "STUD" }, vi.USERDEFINED = { type: 3, value: "USERDEFINED" }, vi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingBarTypeEnum = vi;
  class fa {
  }
  fa.USERDEFINED = { type: 3, value: "USERDEFINED" }, fa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingMeshTypeEnum = fa;
  class vo {
  }
  vo.SUPPLIER = { type: 3, value: "SUPPLIER" }, vo.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, vo.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, vo.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, vo.ARCHITECT = { type: 3, value: "ARCHITECT" }, vo.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, vo.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, vo.CLIENT = { type: 3, value: "CLIENT" }, vo.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, vo.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, vo.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, vo.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, vo.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, vo.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, vo.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, vo.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" }, vo.ENGINEER = { type: 3, value: "ENGINEER" }, vo.OWNER = { type: 3, value: "OWNER" }, vo.CONSULTANT = { type: 3, value: "CONSULTANT" }, vo.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, vo.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, vo.RESELLER = { type: 3, value: "RESELLER" }, vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcRoleEnum = vo;
  class Xi {
  }
  Xi.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, Xi.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, Xi.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, Xi.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, Xi.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, Xi.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, Xi.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, Xi.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, Xi.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, Xi.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, Xi.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, Xi.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, Xi.FREEFORM = { type: 3, value: "FREEFORM" }, Xi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRoofTypeEnum = Xi;
  class gi {
  }
  gi.EXA = { type: 3, value: "EXA" }, gi.PETA = { type: 3, value: "PETA" }, gi.TERA = { type: 3, value: "TERA" }, gi.GIGA = { type: 3, value: "GIGA" }, gi.MEGA = { type: 3, value: "MEGA" }, gi.KILO = { type: 3, value: "KILO" }, gi.HECTO = { type: 3, value: "HECTO" }, gi.DECA = { type: 3, value: "DECA" }, gi.DECI = { type: 3, value: "DECI" }, gi.CENTI = { type: 3, value: "CENTI" }, gi.MILLI = { type: 3, value: "MILLI" }, gi.MICRO = { type: 3, value: "MICRO" }, gi.NANO = { type: 3, value: "NANO" }, gi.PICO = { type: 3, value: "PICO" }, gi.FEMTO = { type: 3, value: "FEMTO" }, gi.ATTO = { type: 3, value: "ATTO" }, r.IfcSIPrefix = gi;
  class Ao {
  }
  Ao.AMPERE = { type: 3, value: "AMPERE" }, Ao.BECQUEREL = { type: 3, value: "BECQUEREL" }, Ao.CANDELA = { type: 3, value: "CANDELA" }, Ao.COULOMB = { type: 3, value: "COULOMB" }, Ao.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, Ao.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, Ao.FARAD = { type: 3, value: "FARAD" }, Ao.GRAM = { type: 3, value: "GRAM" }, Ao.GRAY = { type: 3, value: "GRAY" }, Ao.HENRY = { type: 3, value: "HENRY" }, Ao.HERTZ = { type: 3, value: "HERTZ" }, Ao.JOULE = { type: 3, value: "JOULE" }, Ao.KELVIN = { type: 3, value: "KELVIN" }, Ao.LUMEN = { type: 3, value: "LUMEN" }, Ao.LUX = { type: 3, value: "LUX" }, Ao.METRE = { type: 3, value: "METRE" }, Ao.MOLE = { type: 3, value: "MOLE" }, Ao.NEWTON = { type: 3, value: "NEWTON" }, Ao.OHM = { type: 3, value: "OHM" }, Ao.PASCAL = { type: 3, value: "PASCAL" }, Ao.RADIAN = { type: 3, value: "RADIAN" }, Ao.SECOND = { type: 3, value: "SECOND" }, Ao.SIEMENS = { type: 3, value: "SIEMENS" }, Ao.SIEVERT = { type: 3, value: "SIEVERT" }, Ao.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, Ao.STERADIAN = { type: 3, value: "STERADIAN" }, Ao.TESLA = { type: 3, value: "TESLA" }, Ao.VOLT = { type: 3, value: "VOLT" }, Ao.WATT = { type: 3, value: "WATT" }, Ao.WEBER = { type: 3, value: "WEBER" }, r.IfcSIUnitName = Ao;
  class Bi {
  }
  Bi.BATH = { type: 3, value: "BATH" }, Bi.BIDET = { type: 3, value: "BIDET" }, Bi.CISTERN = { type: 3, value: "CISTERN" }, Bi.SHOWER = { type: 3, value: "SHOWER" }, Bi.SINK = { type: 3, value: "SINK" }, Bi.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, Bi.TOILETPAN = { type: 3, value: "TOILETPAN" }, Bi.URINAL = { type: 3, value: "URINAL" }, Bi.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, Bi.WCSEAT = { type: 3, value: "WCSEAT" }, Bi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSanitaryTerminalTypeEnum = Bi;
  class Ga {
  }
  Ga.UNIFORM = { type: 3, value: "UNIFORM" }, Ga.TAPERED = { type: 3, value: "TAPERED" }, r.IfcSectionTypeEnum = Ga;
  class Go {
  }
  Go.COSENSOR = { type: 3, value: "COSENSOR" }, Go.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, Go.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" }, Go.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" }, Go.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, Go.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, Go.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" }, Go.GASSENSOR = { type: 3, value: "GASSENSOR" }, Go.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, Go.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, Go.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" }, Go.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" }, Go.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" }, Go.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, Go.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, Go.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, Go.PHSENSOR = { type: 3, value: "PHSENSOR" }, Go.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, Go.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" }, Go.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" }, Go.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, Go.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, Go.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, Go.WINDSENSOR = { type: 3, value: "WINDSENSOR" }, Go.USERDEFINED = { type: 3, value: "USERDEFINED" }, Go.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSensorTypeEnum = Go;
  class $i {
  }
  $i.START_START = { type: 3, value: "START_START" }, $i.START_FINISH = { type: 3, value: "START_FINISH" }, $i.FINISH_START = { type: 3, value: "FINISH_START" }, $i.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, $i.USERDEFINED = { type: 3, value: "USERDEFINED" }, $i.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSequenceEnum = $i;
  class Ya {
  }
  Ya.JALOUSIE = { type: 3, value: "JALOUSIE" }, Ya.SHUTTER = { type: 3, value: "SHUTTER" }, Ya.AWNING = { type: 3, value: "AWNING" }, Ya.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ya.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcShadingDeviceTypeEnum = Ya;
  class Ui {
  }
  Ui.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" }, Ui.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" }, Ui.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" }, Ui.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" }, Ui.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" }, Ui.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" }, Ui.Q_LENGTH = { type: 3, value: "Q_LENGTH" }, Ui.Q_AREA = { type: 3, value: "Q_AREA" }, Ui.Q_VOLUME = { type: 3, value: "Q_VOLUME" }, Ui.Q_COUNT = { type: 3, value: "Q_COUNT" }, Ui.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" }, Ui.Q_TIME = { type: 3, value: "Q_TIME" }, r.IfcSimplePropertyTemplateTypeEnum = Ui;
  class Aa {
  }
  Aa.FLOOR = { type: 3, value: "FLOOR" }, Aa.ROOF = { type: 3, value: "ROOF" }, Aa.LANDING = { type: 3, value: "LANDING" }, Aa.BASESLAB = { type: 3, value: "BASESLAB" }, Aa.USERDEFINED = { type: 3, value: "USERDEFINED" }, Aa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSlabTypeEnum = Aa;
  class La {
  }
  La.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" }, La.SOLARPANEL = { type: 3, value: "SOLARPANEL" }, La.USERDEFINED = { type: 3, value: "USERDEFINED" }, La.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSolarDeviceTypeEnum = La;
  class za {
  }
  za.CONVECTOR = { type: 3, value: "CONVECTOR" }, za.RADIATOR = { type: 3, value: "RADIATOR" }, za.USERDEFINED = { type: 3, value: "USERDEFINED" }, za.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceHeaterTypeEnum = za;
  class Ta {
  }
  Ta.SPACE = { type: 3, value: "SPACE" }, Ta.PARKING = { type: 3, value: "PARKING" }, Ta.GFA = { type: 3, value: "GFA" }, Ta.INTERNAL = { type: 3, value: "INTERNAL" }, Ta.EXTERNAL = { type: 3, value: "EXTERNAL" }, Ta.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ta.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceTypeEnum = Ta;
  class oi {
  }
  oi.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, oi.FIRESAFETY = { type: 3, value: "FIRESAFETY" }, oi.LIGHTING = { type: 3, value: "LIGHTING" }, oi.OCCUPANCY = { type: 3, value: "OCCUPANCY" }, oi.SECURITY = { type: 3, value: "SECURITY" }, oi.THERMAL = { type: 3, value: "THERMAL" }, oi.TRANSPORT = { type: 3, value: "TRANSPORT" }, oi.VENTILATION = { type: 3, value: "VENTILATION" }, oi.USERDEFINED = { type: 3, value: "USERDEFINED" }, oi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpatialZoneTypeEnum = oi;
  class Na {
  }
  Na.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, Na.COWL = { type: 3, value: "COWL" }, Na.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, Na.USERDEFINED = { type: 3, value: "USERDEFINED" }, Na.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStackTerminalTypeEnum = Na;
  class Qi {
  }
  Qi.STRAIGHT = { type: 3, value: "STRAIGHT" }, Qi.WINDER = { type: 3, value: "WINDER" }, Qi.SPIRAL = { type: 3, value: "SPIRAL" }, Qi.CURVED = { type: 3, value: "CURVED" }, Qi.FREEFORM = { type: 3, value: "FREEFORM" }, Qi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairFlightTypeEnum = Qi;
  class fi {
  }
  fi.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, fi.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, fi.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, fi.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, fi.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, fi.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, fi.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, fi.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, fi.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, fi.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, fi.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, fi.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, fi.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, fi.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, fi.USERDEFINED = { type: 3, value: "USERDEFINED" }, fi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairTypeEnum = fi;
  class ha {
  }
  ha.READWRITE = { type: 3, value: "READWRITE" }, ha.READONLY = { type: 3, value: "READONLY" }, ha.LOCKED = { type: 3, value: "LOCKED" }, ha.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" }, ha.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" }, r.IfcStateEnum = ha;
  class ca {
  }
  ca.CONST = { type: 3, value: "CONST" }, ca.LINEAR = { type: 3, value: "LINEAR" }, ca.POLYGONAL = { type: 3, value: "POLYGONAL" }, ca.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" }, ca.SINUS = { type: 3, value: "SINUS" }, ca.PARABOLA = { type: 3, value: "PARABOLA" }, ca.DISCRETE = { type: 3, value: "DISCRETE" }, ca.USERDEFINED = { type: 3, value: "USERDEFINED" }, ca.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralCurveActivityTypeEnum = ca;
  class Ki {
  }
  Ki.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, Ki.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, Ki.CABLE = { type: 3, value: "CABLE" }, Ki.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, Ki.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, Ki.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ki.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralCurveMemberTypeEnum = Ki;
  class Ba {
  }
  Ba.CONST = { type: 3, value: "CONST" }, Ba.BILINEAR = { type: 3, value: "BILINEAR" }, Ba.DISCRETE = { type: 3, value: "DISCRETE" }, Ba.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" }, Ba.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ba.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralSurfaceActivityTypeEnum = Ba;
  class je {
  }
  je.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, je.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, je.SHELL = { type: 3, value: "SHELL" }, je.USERDEFINED = { type: 3, value: "USERDEFINED" }, je.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralSurfaceMemberTypeEnum = je;
  class Je {
  }
  Je.PURCHASE = { type: 3, value: "PURCHASE" }, Je.WORK = { type: 3, value: "WORK" }, Je.USERDEFINED = { type: 3, value: "USERDEFINED" }, Je.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSubContractResourceTypeEnum = Je;
  class At {
  }
  At.MARK = { type: 3, value: "MARK" }, At.TAG = { type: 3, value: "TAG" }, At.TREATMENT = { type: 3, value: "TREATMENT" }, At.USERDEFINED = { type: 3, value: "USERDEFINED" }, At.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSurfaceFeatureTypeEnum = At;
  class qt {
  }
  qt.POSITIVE = { type: 3, value: "POSITIVE" }, qt.NEGATIVE = { type: 3, value: "NEGATIVE" }, qt.BOTH = { type: 3, value: "BOTH" }, r.IfcSurfaceSide = qt;
  class un {
  }
  un.CONTACTOR = { type: 3, value: "CONTACTOR" }, un.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" }, un.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, un.KEYPAD = { type: 3, value: "KEYPAD" }, un.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" }, un.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" }, un.STARTER = { type: 3, value: "STARTER" }, un.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, un.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, un.USERDEFINED = { type: 3, value: "USERDEFINED" }, un.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSwitchingDeviceTypeEnum = un;
  class An {
  }
  An.PANEL = { type: 3, value: "PANEL" }, An.WORKSURFACE = { type: 3, value: "WORKSURFACE" }, An.USERDEFINED = { type: 3, value: "USERDEFINED" }, An.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSystemFurnitureElementTypeEnum = An;
  class Fn {
  }
  Fn.BASIN = { type: 3, value: "BASIN" }, Fn.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" }, Fn.EXPANSION = { type: 3, value: "EXPANSION" }, Fn.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" }, Fn.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, Fn.STORAGE = { type: 3, value: "STORAGE" }, Fn.VESSEL = { type: 3, value: "VESSEL" }, Fn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTankTypeEnum = Fn;
  class wn {
  }
  wn.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" }, wn.WORKTIME = { type: 3, value: "WORKTIME" }, wn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTaskDurationEnum = wn;
  class Hn {
  }
  Hn.ATTENDANCE = { type: 3, value: "ATTENDANCE" }, Hn.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, Hn.DEMOLITION = { type: 3, value: "DEMOLITION" }, Hn.DISMANTLE = { type: 3, value: "DISMANTLE" }, Hn.DISPOSAL = { type: 3, value: "DISPOSAL" }, Hn.INSTALLATION = { type: 3, value: "INSTALLATION" }, Hn.LOGISTIC = { type: 3, value: "LOGISTIC" }, Hn.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, Hn.MOVE = { type: 3, value: "MOVE" }, Hn.OPERATION = { type: 3, value: "OPERATION" }, Hn.REMOVAL = { type: 3, value: "REMOVAL" }, Hn.RENOVATION = { type: 3, value: "RENOVATION" }, Hn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTaskTypeEnum = Hn;
  class Er {
  }
  Er.COUPLER = { type: 3, value: "COUPLER" }, Er.FIXED_END = { type: 3, value: "FIXED_END" }, Er.TENSIONING_END = { type: 3, value: "TENSIONING_END" }, Er.USERDEFINED = { type: 3, value: "USERDEFINED" }, Er.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonAnchorTypeEnum = Er;
  class Cr {
  }
  Cr.BAR = { type: 3, value: "BAR" }, Cr.COATED = { type: 3, value: "COATED" }, Cr.STRAND = { type: 3, value: "STRAND" }, Cr.WIRE = { type: 3, value: "WIRE" }, Cr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonTypeEnum = Cr;
  class zr {
  }
  zr.LEFT = { type: 3, value: "LEFT" }, zr.RIGHT = { type: 3, value: "RIGHT" }, zr.UP = { type: 3, value: "UP" }, zr.DOWN = { type: 3, value: "DOWN" }, r.IfcTextPath = zr;
  class hr {
  }
  hr.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, hr.DISCRETE = { type: 3, value: "DISCRETE" }, hr.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, hr.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, hr.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, hr.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, hr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTimeSeriesDataTypeEnum = hr;
  class xr {
  }
  xr.CURRENT = { type: 3, value: "CURRENT" }, xr.FREQUENCY = { type: 3, value: "FREQUENCY" }, xr.INVERTER = { type: 3, value: "INVERTER" }, xr.RECTIFIER = { type: 3, value: "RECTIFIER" }, xr.VOLTAGE = { type: 3, value: "VOLTAGE" }, xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransformerTypeEnum = xr;
  class Is {
  }
  Is.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" }, Is.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, Is.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, Is.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" }, r.IfcTransitionCode = Is;
  class fs {
  }
  fs.ELEVATOR = { type: 3, value: "ELEVATOR" }, fs.ESCALATOR = { type: 3, value: "ESCALATOR" }, fs.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, fs.CRANEWAY = { type: 3, value: "CRANEWAY" }, fs.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" }, fs.USERDEFINED = { type: 3, value: "USERDEFINED" }, fs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransportElementTypeEnum = fs;
  class co {
  }
  co.CARTESIAN = { type: 3, value: "CARTESIAN" }, co.PARAMETER = { type: 3, value: "PARAMETER" }, co.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcTrimmingPreference = co;
  class Yo {
  }
  Yo.FINNED = { type: 3, value: "FINNED" }, Yo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTubeBundleTypeEnum = Yo;
  class Qn {
  }
  Qn.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, Qn.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, Qn.AREAUNIT = { type: 3, value: "AREAUNIT" }, Qn.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, Qn.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, Qn.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, Qn.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, Qn.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, Qn.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, Qn.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, Qn.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, Qn.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, Qn.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, Qn.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, Qn.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, Qn.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, Qn.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, Qn.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, Qn.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, Qn.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, Qn.MASSUNIT = { type: 3, value: "MASSUNIT" }, Qn.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, Qn.POWERUNIT = { type: 3, value: "POWERUNIT" }, Qn.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, Qn.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, Qn.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, Qn.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, Qn.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, Qn.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, Qn.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcUnitEnum = Qn;
  class es {
  }
  es.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, es.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, es.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" }, es.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, es.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, es.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" }, es.THERMOSTAT = { type: 3, value: "THERMOSTAT" }, es.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" }, es.USERDEFINED = { type: 3, value: "USERDEFINED" }, es.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcUnitaryControlElementTypeEnum = es;
  class Jo {
  }
  Jo.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, Jo.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, Jo.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" }, Jo.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, Jo.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, Jo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcUnitaryEquipmentTypeEnum = Jo;
  class js {
  }
  js.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, js.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, js.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, js.CHECK = { type: 3, value: "CHECK" }, js.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, js.DIVERTING = { type: 3, value: "DIVERTING" }, js.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, js.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, js.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, js.FAUCET = { type: 3, value: "FAUCET" }, js.FLUSHING = { type: 3, value: "FLUSHING" }, js.GASCOCK = { type: 3, value: "GASCOCK" }, js.GASTAP = { type: 3, value: "GASTAP" }, js.ISOLATING = { type: 3, value: "ISOLATING" }, js.MIXING = { type: 3, value: "MIXING" }, js.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, js.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, js.REGULATING = { type: 3, value: "REGULATING" }, js.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, js.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, js.STOPCOCK = { type: 3, value: "STOPCOCK" }, js.USERDEFINED = { type: 3, value: "USERDEFINED" }, js.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcValveTypeEnum = js;
  class Hi {
  }
  Hi.COMPRESSION = { type: 3, value: "COMPRESSION" }, Hi.SPRING = { type: 3, value: "SPRING" }, Hi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVibrationIsolatorTypeEnum = Hi;
  class zs {
  }
  zs.CUTOUT = { type: 3, value: "CUTOUT" }, zs.NOTCH = { type: 3, value: "NOTCH" }, zs.HOLE = { type: 3, value: "HOLE" }, zs.MITER = { type: 3, value: "MITER" }, zs.CHAMFER = { type: 3, value: "CHAMFER" }, zs.EDGE = { type: 3, value: "EDGE" }, zs.USERDEFINED = { type: 3, value: "USERDEFINED" }, zs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVoidingFeatureTypeEnum = zs;
  class Ji {
  }
  Ji.MOVABLE = { type: 3, value: "MOVABLE" }, Ji.PARAPET = { type: 3, value: "PARAPET" }, Ji.PARTITIONING = { type: 3, value: "PARTITIONING" }, Ji.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, Ji.SHEAR = { type: 3, value: "SHEAR" }, Ji.SOLIDWALL = { type: 3, value: "SOLIDWALL" }, Ji.STANDARD = { type: 3, value: "STANDARD" }, Ji.POLYGONAL = { type: 3, value: "POLYGONAL" }, Ji.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, Ji.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ji.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWallTypeEnum = Ji;
  class ja {
  }
  ja.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, ja.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, ja.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, ja.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, ja.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, ja.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, ja.WASTETRAP = { type: 3, value: "WASTETRAP" }, ja.USERDEFINED = { type: 3, value: "USERDEFINED" }, ja.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWasteTerminalTypeEnum = ja;
  class Ea {
  }
  Ea.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, Ea.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, Ea.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, Ea.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, Ea.TOPHUNG = { type: 3, value: "TOPHUNG" }, Ea.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, Ea.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, Ea.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, Ea.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, Ea.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, Ea.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, Ea.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, Ea.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, Ea.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelOperationEnum = Ea;
  class ga {
  }
  ga.LEFT = { type: 3, value: "LEFT" }, ga.MIDDLE = { type: 3, value: "MIDDLE" }, ga.RIGHT = { type: 3, value: "RIGHT" }, ga.BOTTOM = { type: 3, value: "BOTTOM" }, ga.TOP = { type: 3, value: "TOP" }, ga.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelPositionEnum = ga;
  class sa {
  }
  sa.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, sa.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, sa.STEEL = { type: 3, value: "STEEL" }, sa.WOOD = { type: 3, value: "WOOD" }, sa.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, sa.PLASTIC = { type: 3, value: "PLASTIC" }, sa.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, sa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleConstructionEnum = sa;
  class Sa {
  }
  Sa.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, Sa.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, Sa.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, Sa.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, Sa.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, Sa.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, Sa.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, Sa.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, Sa.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, Sa.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleOperationEnum = Sa;
  class Ua {
  }
  Ua.WINDOW = { type: 3, value: "WINDOW" }, Ua.SKYLIGHT = { type: 3, value: "SKYLIGHT" }, Ua.LIGHTDOME = { type: 3, value: "LIGHTDOME" }, Ua.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ua.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowTypeEnum = Ua;
  class mi {
  }
  mi.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, mi.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, mi.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, mi.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, mi.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, mi.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, mi.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, mi.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, mi.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, mi.USERDEFINED = { type: 3, value: "USERDEFINED" }, mi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowTypePartitioningEnum = mi;
  class $a {
  }
  $a.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" }, $a.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" }, $a.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" }, $a.USERDEFINED = { type: 3, value: "USERDEFINED" }, $a.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkCalendarTypeEnum = $a;
  class Oa {
  }
  Oa.ACTUAL = { type: 3, value: "ACTUAL" }, Oa.BASELINE = { type: 3, value: "BASELINE" }, Oa.PLANNED = { type: 3, value: "PLANNED" }, Oa.USERDEFINED = { type: 3, value: "USERDEFINED" }, Oa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkPlanTypeEnum = Oa;
  class Ha {
  }
  Ha.ACTUAL = { type: 3, value: "ACTUAL" }, Ha.BASELINE = { type: 3, value: "BASELINE" }, Ha.PLANNED = { type: 3, value: "PLANNED" }, Ha.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ha.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkScheduleTypeEnum = Ha;
  class p0 extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Role = j, this.UserDefinedRole = Y, this.Description = K, this.type = 3630933823;
    }
  }
  r.IfcActorRole = p0;
  class k extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Purpose = j, this.Description = Y, this.UserDefinedPurpose = K, this.type = 618182010;
    }
  }
  r.IfcAddress = k;
  class ne extends IfcLineObject {
    constructor($, j, Y, K, ie) {
      super($), this.ApplicationDeveloper = j, this.Version = Y, this.ApplicationFullName = K, this.ApplicationIdentifier = ie, this.type = 639542469;
    }
  }
  r.IfcApplication = ne;
  class T extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($), this.Name = j, this.Description = Y, this.AppliedValue = K, this.UnitBasis = ie, this.ApplicableDate = Ce, this.FixedUntilDate = ye, this.Category = we, this.Condition = He, this.ArithmeticOperator = rt, this.Components = cn, this.type = 411424972;
    }
  }
  r.IfcAppliedValue = T;
  class y extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($), this.Identifier = j, this.Name = Y, this.Description = K, this.TimeOfApproval = ie, this.Status = Ce, this.Level = ye, this.Qualifier = we, this.RequestingApproval = He, this.GivingApproval = rt, this.type = 130549933;
    }
  }
  r.IfcApproval = y;
  class N extends IfcLineObject {
    constructor($, j) {
      super($), this.Name = j, this.type = 4037036970;
    }
  }
  r.IfcBoundaryCondition = N;
  class b extends N {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.TranslationalStiffnessByLengthX = Y, this.TranslationalStiffnessByLengthY = K, this.TranslationalStiffnessByLengthZ = ie, this.RotationalStiffnessByLengthX = Ce, this.RotationalStiffnessByLengthY = ye, this.RotationalStiffnessByLengthZ = we, this.type = 1560379544;
    }
  }
  r.IfcBoundaryEdgeCondition = b;
  class X extends N {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.TranslationalStiffnessByAreaX = Y, this.TranslationalStiffnessByAreaY = K, this.TranslationalStiffnessByAreaZ = ie, this.type = 3367102660;
    }
  }
  r.IfcBoundaryFaceCondition = X;
  class J extends N {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.TranslationalStiffnessX = Y, this.TranslationalStiffnessY = K, this.TranslationalStiffnessZ = ie, this.RotationalStiffnessX = Ce, this.RotationalStiffnessY = ye, this.RotationalStiffnessZ = we, this.type = 1387855156;
    }
  }
  r.IfcBoundaryNodeCondition = J;
  class Ie extends J {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.Name = j, this.TranslationalStiffnessX = Y, this.TranslationalStiffnessY = K, this.TranslationalStiffnessZ = ie, this.RotationalStiffnessX = Ce, this.RotationalStiffnessY = ye, this.RotationalStiffnessZ = we, this.WarpingStiffness = He, this.type = 2069777674;
    }
  }
  r.IfcBoundaryNodeConditionWarping = Ie;
  class Pe extends IfcLineObject {
    constructor($) {
      super($), this.type = 2859738748;
    }
  }
  r.IfcConnectionGeometry = Pe;
  class We extends Pe {
    constructor($, j, Y) {
      super($), this.PointOnRelatingElement = j, this.PointOnRelatedElement = Y, this.type = 2614616156;
    }
  }
  r.IfcConnectionPointGeometry = We;
  class it extends Pe {
    constructor($, j, Y) {
      super($), this.SurfaceOnRelatingElement = j, this.SurfaceOnRelatedElement = Y, this.type = 2732653382;
    }
  }
  r.IfcConnectionSurfaceGeometry = it;
  class Rt extends Pe {
    constructor($, j, Y) {
      super($), this.VolumeOnRelatingElement = j, this.VolumeOnRelatedElement = Y, this.type = 775493141;
    }
  }
  r.IfcConnectionVolumeGeometry = Rt;
  class Dt extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.Name = j, this.Description = Y, this.ConstraintGrade = K, this.ConstraintSource = ie, this.CreatingActor = Ce, this.CreationTime = ye, this.UserDefinedGrade = we, this.type = 1959218052;
    }
  }
  r.IfcConstraint = Dt;
  class Kt extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.SourceCRS = j, this.TargetCRS = Y, this.type = 1785450214;
    }
  }
  r.IfcCoordinateOperation = Kt;
  class _n extends IfcLineObject {
    constructor($, j, Y, K, ie) {
      super($), this.Name = j, this.Description = Y, this.GeodeticDatum = K, this.VerticalDatum = ie, this.type = 1466758467;
    }
  }
  r.IfcCoordinateReferenceSystem = _n;
  class gn extends T {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.Name = j, this.Description = Y, this.AppliedValue = K, this.UnitBasis = ie, this.ApplicableDate = Ce, this.FixedUntilDate = ye, this.Category = we, this.Condition = He, this.ArithmeticOperator = rt, this.Components = cn, this.type = 602808272;
    }
  }
  r.IfcCostValue = gn;
  class Pn extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Elements = j, this.UnitType = Y, this.UserDefinedType = K, this.type = 1765591967;
    }
  }
  r.IfcDerivedUnit = Pn;
  class Vn extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.Unit = j, this.Exponent = Y, this.type = 1045800335;
    }
  }
  r.IfcDerivedUnitElement = Vn;
  class vn extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.LengthExponent = j, this.MassExponent = Y, this.TimeExponent = K, this.ElectricCurrentExponent = ie, this.ThermodynamicTemperatureExponent = Ce, this.AmountOfSubstanceExponent = ye, this.LuminousIntensityExponent = we, this.type = 2949456006;
    }
  }
  r.IfcDimensionalExponents = vn;
  class Zn extends IfcLineObject {
    constructor($) {
      super($), this.type = 4294318154;
    }
  }
  r.IfcExternalInformation = Zn;
  class cr extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Location = j, this.Identification = Y, this.Name = K, this.type = 3200245327;
    }
  }
  r.IfcExternalReference = cr;
  class Cs extends cr {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.type = 2242383968;
    }
  }
  r.IfcExternallyDefinedHatchStyle = Cs;
  class Br extends cr {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.type = 1040185647;
    }
  }
  r.IfcExternallyDefinedSurfaceStyle = Br;
  class Do extends cr {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.type = 3548104201;
    }
  }
  r.IfcExternallyDefinedTextFont = Do;
  class _o extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.AxisTag = j, this.AxisCurve = Y, this.SameSense = K, this.type = 852622518;
    }
  }
  r.IfcGridAxis = _o;
  class Ca extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.TimeStamp = j, this.ListValues = Y, this.type = 3020489413;
    }
  }
  r.IfcIrregularTimeSeriesValue = Ca;
  class ma extends Zn {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($), this.Name = j, this.Version = Y, this.Publisher = K, this.VersionDate = ie, this.Location = Ce, this.Description = ye, this.type = 2655187982;
    }
  }
  r.IfcLibraryInformation = ma;
  class s0 extends cr {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.Description = ie, this.Language = Ce, this.ReferencedLibrary = ye, this.type = 3452421091;
    }
  }
  r.IfcLibraryReference = s0;
  class Ra extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.MainPlaneAngle = j, this.SecondaryPlaneAngle = Y, this.LuminousIntensity = K, this.type = 4162380809;
    }
  }
  r.IfcLightDistributionData = Ra;
  class U0 extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.LightDistributionCurve = j, this.DistributionData = Y, this.type = 1566485204;
    }
  }
  r.IfcLightIntensityDistribution = U0;
  class Qa extends Kt {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y), this.SourceCRS = j, this.TargetCRS = Y, this.Eastings = K, this.Northings = ie, this.OrthogonalHeight = Ce, this.XAxisAbscissa = ye, this.XAxisOrdinate = we, this.Scale = He, this.type = 3057273783;
    }
  }
  r.IfcMapConversion = Qa;
  class Fl extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.MaterialClassifications = j, this.ClassifiedMaterial = Y, this.type = 1847130766;
    }
  }
  r.IfcMaterialClassificationRelationship = Fl;
  class Pa extends IfcLineObject {
    constructor($) {
      super($), this.type = 760658860;
    }
  }
  r.IfcMaterialDefinition = Pa;
  class o0 extends Pa {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.Material = j, this.LayerThickness = Y, this.IsVentilated = K, this.Name = ie, this.Description = Ce, this.Category = ye, this.Priority = we, this.type = 248100487;
    }
  }
  r.IfcMaterialLayer = o0;
  class il extends Pa {
    constructor($, j, Y, K) {
      super($), this.MaterialLayers = j, this.LayerSetName = Y, this.Description = K, this.type = 3303938423;
    }
  }
  r.IfcMaterialLayerSet = il;
  class T0 extends o0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.Material = j, this.LayerThickness = Y, this.IsVentilated = K, this.Name = ie, this.Description = Ce, this.Category = ye, this.Priority = we, this.OffsetDirection = He, this.OffsetValues = rt, this.type = 1847252529;
    }
  }
  r.IfcMaterialLayerWithOffsets = T0;
  class zl extends IfcLineObject {
    constructor($, j) {
      super($), this.Materials = j, this.type = 2199411900;
    }
  }
  r.IfcMaterialList = zl;
  class Al extends Pa {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($), this.Name = j, this.Description = Y, this.Material = K, this.Profile = ie, this.Priority = Ce, this.Category = ye, this.type = 2235152071;
    }
  }
  r.IfcMaterialProfile = Al;
  class $l extends Pa {
    constructor($, j, Y, K, ie) {
      super($), this.Name = j, this.Description = Y, this.MaterialProfiles = K, this.CompositeProfile = ie, this.type = 164193824;
    }
  }
  r.IfcMaterialProfileSet = $l;
  class aE extends Al {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.Name = j, this.Description = Y, this.Material = K, this.Profile = ie, this.Priority = Ce, this.Category = ye, this.OffsetValues = we, this.type = 552965576;
    }
  }
  r.IfcMaterialProfileWithOffsets = aE;
  class wu extends IfcLineObject {
    constructor($) {
      super($), this.type = 1507914824;
    }
  }
  r.IfcMaterialUsageDefinition = wu;
  class uc extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.ValueComponent = j, this.UnitComponent = Y, this.type = 2597039031;
    }
  }
  r.IfcMeasureWithUnit = uc;
  class lE extends Dt {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we), this.Name = j, this.Description = Y, this.ConstraintGrade = K, this.ConstraintSource = ie, this.CreatingActor = Ce, this.CreationTime = ye, this.UserDefinedGrade = we, this.Benchmark = He, this.ValueSource = rt, this.DataValue = cn, this.ReferencePath = nr, this.type = 3368373690;
    }
  }
  r.IfcMetric = lE;
  class uE extends IfcLineObject {
    constructor($, j) {
      super($), this.Currency = j, this.type = 2706619895;
    }
  }
  r.IfcMonetaryUnit = uE;
  class Du extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.Dimensions = j, this.UnitType = Y, this.type = 1918398963;
    }
  }
  r.IfcNamedUnit = Du;
  class i3 extends IfcLineObject {
    constructor($) {
      super($), this.type = 3701648758;
    }
  }
  r.IfcObjectPlacement = i3;
  class cc extends Dt {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we), this.Name = j, this.Description = Y, this.ConstraintGrade = K, this.ConstraintSource = ie, this.CreatingActor = Ce, this.CreationTime = ye, this.UserDefinedGrade = we, this.BenchmarkValues = He, this.LogicalAggregator = rt, this.ObjectiveQualifier = cn, this.UserDefinedQualifier = nr, this.type = 2251480897;
    }
  }
  r.IfcObjective = cc;
  class a3 extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.Identification = j, this.Name = Y, this.Description = K, this.Roles = ie, this.Addresses = Ce, this.type = 4251960020;
    }
  }
  r.IfcOrganization = a3;
  class P1 extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($), this.OwningUser = j, this.OwningApplication = Y, this.State = K, this.ChangeAction = ie, this.LastModifiedDate = Ce, this.LastModifyingUser = ye, this.LastModifyingApplication = we, this.CreationDate = He, this.type = 1207048766;
    }
  }
  r.IfcOwnerHistory = P1;
  class Ql extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($), this.Identification = j, this.FamilyName = Y, this.GivenName = K, this.MiddleNames = ie, this.PrefixTitles = Ce, this.SuffixTitles = ye, this.Roles = we, this.Addresses = He, this.type = 2077209135;
    }
  }
  r.IfcPerson = Ql;
  class cE extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.ThePerson = j, this.TheOrganization = Y, this.Roles = K, this.type = 101040310;
    }
  }
  r.IfcPersonAndOrganization = cE;
  class Ll extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.Name = j, this.Description = Y, this.type = 2483315170;
    }
  }
  r.IfcPhysicalQuantity = Ll;
  class P0 extends Ll {
    constructor($, j, Y, K) {
      super($, j, Y), this.Name = j, this.Description = Y, this.Unit = K, this.type = 2226359599;
    }
  }
  r.IfcPhysicalSimpleQuantity = P0;
  class EE extends k {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K), this.Purpose = j, this.Description = Y, this.UserDefinedPurpose = K, this.InternalLocation = ie, this.AddressLines = Ce, this.PostalBox = ye, this.Town = we, this.Region = He, this.PostalCode = rt, this.Country = cn, this.type = 3355820592;
    }
  }
  r.IfcPostalAddress = EE;
  class Xa extends IfcLineObject {
    constructor($) {
      super($), this.type = 677532197;
    }
  }
  r.IfcPresentationItem = Xa;
  class Ec extends IfcLineObject {
    constructor($, j, Y, K, ie) {
      super($), this.Name = j, this.Description = Y, this.AssignedItems = K, this.Identifier = ie, this.type = 2022622350;
    }
  }
  r.IfcPresentationLayerAssignment = Ec;
  class w1 extends Ec {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie), this.Name = j, this.Description = Y, this.AssignedItems = K, this.Identifier = ie, this.LayerOn = Ce, this.LayerFrozen = ye, this.LayerBlocked = we, this.LayerStyles = He, this.type = 1304840413;
    }
  }
  r.IfcPresentationLayerWithStyle = w1;
  class al extends IfcLineObject {
    constructor($, j) {
      super($), this.Name = j, this.type = 3119450353;
    }
  }
  r.IfcPresentationStyle = al;
  class IE extends IfcLineObject {
    constructor($, j) {
      super($), this.Styles = j, this.type = 2417041796;
    }
  }
  r.IfcPresentationStyleAssignment = IE;
  class $0 extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.Description = Y, this.Representations = K, this.type = 2095639259;
    }
  }
  r.IfcProductRepresentation = $0;
  class ll extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.ProfileType = j, this.ProfileName = Y, this.type = 3958567839;
    }
  }
  r.IfcProfileDef = ll;
  class D1 extends _n {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie), this.Name = j, this.Description = Y, this.GeodeticDatum = K, this.VerticalDatum = ie, this.MapProjection = Ce, this.MapZone = ye, this.MapUnit = we, this.type = 3843373140;
    }
  }
  r.IfcProjectedCRS = D1;
  class d0 extends IfcLineObject {
    constructor($) {
      super($), this.type = 986844984;
    }
  }
  r.IfcPropertyAbstraction = d0;
  class Nl extends d0 {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.EnumerationValues = Y, this.Unit = K, this.type = 3710013099;
    }
  }
  r.IfcPropertyEnumeration = Nl;
  class b1 extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.AreaValue = ie, this.Formula = Ce, this.type = 2044713172;
    }
  }
  r.IfcQuantityArea = b1;
  class G1 extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.CountValue = ie, this.Formula = Ce, this.type = 2093928680;
    }
  }
  r.IfcQuantityCount = G1;
  class pE extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.LengthValue = ie, this.Formula = Ce, this.type = 931644368;
    }
  }
  r.IfcQuantityLength = pE;
  class dE extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.TimeValue = ie, this.Formula = Ce, this.type = 3252649465;
    }
  }
  r.IfcQuantityTime = dE;
  class fE extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.VolumeValue = ie, this.Formula = Ce, this.type = 2405470396;
    }
  }
  r.IfcQuantityVolume = fE;
  class CE extends P0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Unit = K, this.WeightValue = ie, this.Formula = Ce, this.type = 825690147;
    }
  }
  r.IfcQuantityWeight = CE;
  class j1 extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($), this.RecurrenceType = j, this.DayComponent = Y, this.WeekdayComponent = K, this.MonthComponent = ie, this.Position = Ce, this.Interval = ye, this.Occurrences = we, this.TimePeriods = He, this.type = 3915482550;
    }
  }
  r.IfcRecurrencePattern = j1;
  class hE extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.TypeIdentifier = j, this.AttributeIdentifier = Y, this.InstanceName = K, this.ListPositions = ie, this.InnerReference = Ce, this.type = 2433181523;
    }
  }
  r.IfcReference = hE;
  class Kl extends IfcLineObject {
    constructor($, j, Y, K, ie) {
      super($), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 1076942058;
    }
  }
  r.IfcRepresentation = Kl;
  class M1 extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.ContextIdentifier = j, this.ContextType = Y, this.type = 3377609919;
    }
  }
  r.IfcRepresentationContext = M1;
  class bu extends IfcLineObject {
    constructor($) {
      super($), this.type = 3008791417;
    }
  }
  r.IfcRepresentationItem = bu;
  class ul extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.MappingOrigin = j, this.MappedRepresentation = Y, this.type = 1660063152;
    }
  }
  r.IfcRepresentationMap = ul;
  class w0 extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.Name = j, this.Description = Y, this.type = 2439245199;
    }
  }
  r.IfcResourceLevelRelationship = w0;
  class Ic extends IfcLineObject {
    constructor($, j, Y, K, ie) {
      super($), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 2341007311;
    }
  }
  r.IfcRoot = Ic;
  class SE extends Du {
    constructor($, j, Y, K) {
      super($, new Handle(0), j), this.UnitType = j, this.Prefix = Y, this.Name = K, this.type = 448429030;
    }
  }
  r.IfcSIUnit = SE;
  class Jl extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.type = 1054537805;
    }
  }
  r.IfcSchedulingTime = Jl;
  class x1 extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.ShapeRepresentations = j, this.Name = Y, this.Description = K, this.ProductDefinitional = ie, this.PartOfProductDefinitionShape = Ce, this.type = 867548509;
    }
  }
  r.IfcShapeAspect = x1;
  class l3 extends Kl {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 3982875396;
    }
  }
  r.IfcShapeModel = l3;
  class u3 extends l3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 4240577450;
    }
  }
  r.IfcShapeRepresentation = u3;
  class Gu extends IfcLineObject {
    constructor($, j) {
      super($), this.Name = j, this.type = 2273995522;
    }
  }
  r.IfcStructuralConnectionCondition = Gu;
  class c3 extends IfcLineObject {
    constructor($, j) {
      super($), this.Name = j, this.type = 2162789131;
    }
  }
  r.IfcStructuralLoad = c3;
  class RE extends c3 {
    constructor($, j, Y, K) {
      super($, j), this.Name = j, this.Values = Y, this.Locations = K, this.type = 3478079324;
    }
  }
  r.IfcStructuralLoadConfiguration = RE;
  class E3 extends c3 {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 609421318;
    }
  }
  r.IfcStructuralLoadOrResult = E3;
  class D0 extends E3 {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 2525727697;
    }
  }
  r.IfcStructuralLoadStatic = D0;
  class pc extends D0 {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.DeltaTConstant = Y, this.DeltaTY = K, this.DeltaTZ = ie, this.type = 3408363356;
    }
  }
  r.IfcStructuralLoadTemperature = pc;
  class v1 extends Kl {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 2830218821;
    }
  }
  r.IfcStyleModel = v1;
  class cl extends bu {
    constructor($, j, Y, K) {
      super($), this.Item = j, this.Styles = Y, this.Name = K, this.type = 3958052878;
    }
  }
  r.IfcStyledItem = cl;
  class TE extends v1 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 3049322572;
    }
  }
  r.IfcStyledRepresentation = TE;
  class _E extends E3 {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.SurfaceReinforcement1 = Y, this.SurfaceReinforcement2 = K, this.ShearReinforcement = ie, this.type = 2934153892;
    }
  }
  r.IfcSurfaceReinforcementArea = _E;
  class B1 extends al {
    constructor($, j, Y, K) {
      super($, j), this.Name = j, this.Side = Y, this.Styles = K, this.type = 1300840506;
    }
  }
  r.IfcSurfaceStyle = B1;
  class I3 extends Xa {
    constructor($, j, Y, K, ie) {
      super($), this.DiffuseTransmissionColour = j, this.DiffuseReflectionColour = Y, this.TransmissionColour = K, this.ReflectanceColour = ie, this.type = 3303107099;
    }
  }
  r.IfcSurfaceStyleLighting = I3;
  class El extends Xa {
    constructor($, j, Y) {
      super($), this.RefractionIndex = j, this.DispersionFactor = Y, this.type = 1607154358;
    }
  }
  r.IfcSurfaceStyleRefraction = El;
  class U1 extends Xa {
    constructor($, j, Y) {
      super($), this.SurfaceColour = j, this.Transparency = Y, this.type = 846575682;
    }
  }
  r.IfcSurfaceStyleShading = U1;
  class Va extends Xa {
    constructor($, j) {
      super($), this.Textures = j, this.type = 1351298697;
    }
  }
  r.IfcSurfaceStyleWithTextures = Va;
  class H0 extends Xa {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.RepeatS = j, this.RepeatT = Y, this.Mode = K, this.TextureTransform = ie, this.Parameter = Ce, this.type = 626085974;
    }
  }
  r.IfcSurfaceTexture = H0;
  class mE extends IfcLineObject {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.Rows = Y, this.Columns = K, this.type = 985171141;
    }
  }
  r.IfcTable = mE;
  class Zl extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.Identifier = j, this.Name = Y, this.Description = K, this.Unit = ie, this.ReferencePath = Ce, this.type = 2043862942;
    }
  }
  r.IfcTableColumn = Zl;
  class p3 extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.RowCells = j, this.IsHeading = Y, this.type = 531007025;
    }
  }
  r.IfcTableRow = p3;
  class Q0 extends Jl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0, s3, Wl) {
      super($, j, Y, K), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.DurationType = ie, this.ScheduleDuration = Ce, this.ScheduleStart = ye, this.ScheduleFinish = we, this.EarlyStart = He, this.EarlyFinish = rt, this.LateStart = cn, this.LateFinish = nr, this.FreeFloat = Yr, this.TotalFloat = $s, this.IsCritical = wi, this.StatusTime = Ia, this.ActualDuration = va, this.ActualStart = Vi, this.ActualFinish = g0, this.RemainingTime = s3, this.Completion = Wl, this.type = 1549132990;
    }
  }
  r.IfcTaskTime = Q0;
  class H1 extends Q0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0, s3, Wl, Nd) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0, s3, Wl), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.DurationType = ie, this.ScheduleDuration = Ce, this.ScheduleStart = ye, this.ScheduleFinish = we, this.EarlyStart = He, this.EarlyFinish = rt, this.LateStart = cn, this.LateFinish = nr, this.FreeFloat = Yr, this.TotalFloat = $s, this.IsCritical = wi, this.StatusTime = Ia, this.ActualDuration = va, this.ActualStart = Vi, this.ActualFinish = g0, this.RemainingTime = s3, this.Completion = Wl, this.Recurrence = Nd, this.type = 2771591690;
    }
  }
  r.IfcTaskTimeRecurring = H1;
  class ju extends k {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K), this.Purpose = j, this.Description = Y, this.UserDefinedPurpose = K, this.TelephoneNumbers = ie, this.FacsimileNumbers = Ce, this.PagerNumber = ye, this.ElectronicMailAddresses = we, this.WWWHomePageURL = He, this.MessagingIDs = rt, this.type = 912023232;
    }
  }
  r.IfcTelecomAddress = ju;
  class yE extends al {
    constructor($, j, Y, K, ie, Ce) {
      super($, j), this.Name = j, this.TextCharacterAppearance = Y, this.TextStyle = K, this.TextFontStyle = ie, this.ModelOrDraughting = Ce, this.type = 1447204868;
    }
  }
  r.IfcTextStyle = yE;
  class FE extends Xa {
    constructor($, j, Y) {
      super($), this.Colour = j, this.BackgroundColour = Y, this.type = 2636378356;
    }
  }
  r.IfcTextStyleForDefinedFont = FE;
  class AE extends Xa {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.TextIndent = j, this.TextAlign = Y, this.TextDecoration = K, this.LetterSpacing = ie, this.WordSpacing = Ce, this.TextTransform = ye, this.LineHeight = we, this.type = 1640371178;
    }
  }
  r.IfcTextStyleTextModel = AE;
  class dc extends Xa {
    constructor($, j) {
      super($), this.Maps = j, this.type = 280115917;
    }
  }
  r.IfcTextureCoordinate = dc;
  class LE extends dc {
    constructor($, j, Y, K) {
      super($, j), this.Maps = j, this.Mode = Y, this.Parameter = K, this.type = 1742049831;
    }
  }
  r.IfcTextureCoordinateGenerator = LE;
  class NE extends dc {
    constructor($, j, Y, K) {
      super($, j), this.Maps = j, this.Vertices = Y, this.MappedTo = K, this.type = 2552916305;
    }
  }
  r.IfcTextureMap = NE;
  class d3 extends Xa {
    constructor($, j) {
      super($), this.Coordinates = j, this.type = 1210645708;
    }
  }
  r.IfcTextureVertex = d3;
  class gE extends Xa {
    constructor($, j) {
      super($), this.TexCoordsList = j, this.type = 3611470254;
    }
  }
  r.IfcTextureVertexList = gE;
  class OE extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.StartTime = j, this.EndTime = Y, this.type = 1199560280;
    }
  }
  r.IfcTimePeriod = OE;
  class f3 extends IfcLineObject {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($), this.Name = j, this.Description = Y, this.StartTime = K, this.EndTime = ie, this.TimeSeriesDataType = Ce, this.DataOrigin = ye, this.UserDefinedDataOrigin = we, this.Unit = He, this.type = 3101149627;
    }
  }
  r.IfcTimeSeries = f3;
  class C3 extends IfcLineObject {
    constructor($, j) {
      super($), this.ListValues = j, this.type = 581633288;
    }
  }
  r.IfcTimeSeriesValue = C3;
  class K0 extends bu {
    constructor($) {
      super($), this.type = 1377556343;
    }
  }
  r.IfcTopologicalRepresentationItem = K0;
  class Mu extends l3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.ContextOfItems = j, this.RepresentationIdentifier = Y, this.RepresentationType = K, this.Items = ie, this.type = 1735638870;
    }
  }
  r.IfcTopologyRepresentation = Mu;
  class PE extends IfcLineObject {
    constructor($, j) {
      super($), this.Units = j, this.type = 180925521;
    }
  }
  r.IfcUnitAssignment = PE;
  class b0 extends K0 {
    constructor($) {
      super($), this.type = 2799835756;
    }
  }
  r.IfcVertex = b0;
  class fc extends b0 {
    constructor($, j) {
      super($), this.VertexGeometry = j, this.type = 1907098498;
    }
  }
  r.IfcVertexPoint = fc;
  class wE extends IfcLineObject {
    constructor($, j, Y) {
      super($), this.IntersectingAxes = j, this.OffsetDistances = Y, this.type = 891718957;
    }
  }
  r.IfcVirtualGridIntersection = wE;
  class J0 extends Jl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.RecurrencePattern = ie, this.Start = Ce, this.Finish = ye, this.type = 1236880293;
    }
  }
  r.IfcWorkTime = J0;
  class DE extends w0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingApproval = K, this.RelatedApprovals = ie, this.type = 3869604511;
    }
  }
  r.IfcApprovalRelationship = DE;
  class Cc extends ll {
    constructor($, j, Y, K) {
      super($, j, Y), this.ProfileType = j, this.ProfileName = Y, this.OuterCurve = K, this.type = 3798115385;
    }
  }
  r.IfcArbitraryClosedProfileDef = Cc;
  class h3 extends ll {
    constructor($, j, Y, K) {
      super($, j, Y), this.ProfileType = j, this.ProfileName = Y, this.Curve = K, this.type = 1310608509;
    }
  }
  r.IfcArbitraryOpenProfileDef = h3;
  class hc extends Cc {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.OuterCurve = K, this.InnerCurves = ie, this.type = 2705031697;
    }
  }
  r.IfcArbitraryProfileDefWithVoids = hc;
  class S3 extends H0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.RepeatS = j, this.RepeatT = Y, this.Mode = K, this.TextureTransform = ie, this.Parameter = Ce, this.RasterFormat = ye, this.RasterCode = we, this.type = 616511568;
    }
  }
  r.IfcBlobTexture = S3;
  class bE extends h3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Curve = K, this.Thickness = ie, this.type = 3150382593;
    }
  }
  r.IfcCenterLineProfileDef = bE;
  class R3 extends Zn {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.Source = j, this.Edition = Y, this.EditionDate = K, this.Name = ie, this.Description = Ce, this.Location = ye, this.ReferenceTokens = we, this.type = 747523909;
    }
  }
  r.IfcClassification = R3;
  class eu extends cr {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.ReferencedSource = ie, this.Description = Ce, this.Sort = ye, this.type = 647927063;
    }
  }
  r.IfcClassificationReference = eu;
  class GE extends Xa {
    constructor($, j) {
      super($), this.ColourList = j, this.type = 3285139300;
    }
  }
  r.IfcColourRgbList = GE;
  class T3 extends Xa {
    constructor($, j) {
      super($), this.Name = j, this.type = 3264961684;
    }
  }
  r.IfcColourSpecification = T3;
  class q1 extends ll {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.ProfileType = j, this.ProfileName = Y, this.Profiles = K, this.Label = ie, this.type = 1485152156;
    }
  }
  r.IfcCompositeProfileDef = q1;
  class Sc extends K0 {
    constructor($, j) {
      super($), this.CfsFaces = j, this.type = 370225590;
    }
  }
  r.IfcConnectedFaceSet = Sc;
  class Zi extends Pe {
    constructor($, j, Y) {
      super($), this.CurveOnRelatingElement = j, this.CurveOnRelatedElement = Y, this.type = 1981873012;
    }
  }
  r.IfcConnectionCurveGeometry = Zi;
  class jE extends We {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y), this.PointOnRelatingElement = j, this.PointOnRelatedElement = Y, this.EccentricityInX = K, this.EccentricityInY = ie, this.EccentricityInZ = Ce, this.type = 45288368;
    }
  }
  r.IfcConnectionPointEccentricity = jE;
  class k1 extends Du {
    constructor($, j, Y, K) {
      super($, j, Y), this.Dimensions = j, this.UnitType = Y, this.Name = K, this.type = 3050246964;
    }
  }
  r.IfcContextDependentUnit = k1;
  class Y1 extends Du {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Dimensions = j, this.UnitType = Y, this.Name = K, this.ConversionFactor = ie, this.type = 2889183280;
    }
  }
  r.IfcConversionBasedUnit = Y1;
  class Rc extends Y1 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.Dimensions = j, this.UnitType = Y, this.Name = K, this.ConversionFactor = ie, this.ConversionOffset = Ce, this.type = 2713554722;
    }
  }
  r.IfcConversionBasedUnitWithOffset = Rc;
  class ME extends w0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingMonetaryUnit = K, this.RelatedMonetaryUnit = ie, this.ExchangeRate = Ce, this.RateDateTime = ye, this.RateSource = we, this.type = 539742890;
    }
  }
  r.IfcCurrencyRelationship = ME;
  class Tc extends al {
    constructor($, j, Y, K, ie, Ce) {
      super($, j), this.Name = j, this.CurveFont = Y, this.CurveWidth = K, this.CurveColour = ie, this.ModelOrDraughting = Ce, this.type = 3800577675;
    }
  }
  r.IfcCurveStyle = Tc;
  class xE extends Xa {
    constructor($, j, Y) {
      super($), this.Name = j, this.PatternList = Y, this.type = 1105321065;
    }
  }
  r.IfcCurveStyleFont = xE;
  class xu extends Xa {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.CurveFont = Y, this.CurveFontScaling = K, this.type = 2367409068;
    }
  }
  r.IfcCurveStyleFontAndScaling = xu;
  class vE extends Xa {
    constructor($, j, Y) {
      super($), this.VisibleSegmentLength = j, this.InvisibleSegmentLength = Y, this.type = 3510044353;
    }
  }
  r.IfcCurveStyleFontPattern = vE;
  class _3 extends ll {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y), this.ProfileType = j, this.ProfileName = Y, this.ParentProfile = K, this.Operator = ie, this.Label = Ce, this.type = 3632507154;
    }
  }
  r.IfcDerivedProfileDef = _3;
  class BE extends Zn {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi) {
      super($), this.Identification = j, this.Name = Y, this.Description = K, this.Location = ie, this.Purpose = Ce, this.IntendedUse = ye, this.Scope = we, this.Revision = He, this.DocumentOwner = rt, this.Editors = cn, this.CreationTime = nr, this.LastRevisionTime = Yr, this.ElectronicFormat = $s, this.ValidFrom = wi, this.ValidUntil = Ia, this.Confidentiality = va, this.Status = Vi, this.type = 1154170062;
    }
  }
  r.IfcDocumentInformation = BE;
  class X1 extends w0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingDocument = K, this.RelatedDocuments = ie, this.RelationshipType = Ce, this.type = 770865208;
    }
  }
  r.IfcDocumentInformationRelationship = X1;
  class UE extends cr {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Location = j, this.Identification = Y, this.Name = K, this.Description = ie, this.ReferencedDocument = Ce, this.type = 3732053477;
    }
  }
  r.IfcDocumentReference = UE;
  class _c extends K0 {
    constructor($, j, Y) {
      super($), this.EdgeStart = j, this.EdgeEnd = Y, this.type = 3900360178;
    }
  }
  r.IfcEdge = _c;
  class mc extends _c {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.EdgeStart = j, this.EdgeEnd = Y, this.EdgeGeometry = K, this.SameSense = ie, this.type = 476780140;
    }
  }
  r.IfcEdgeCurve = mc;
  class yc extends Jl {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.ActualDate = ie, this.EarlyDate = Ce, this.LateDate = ye, this.ScheduleDate = we, this.type = 211053100;
    }
  }
  r.IfcEventTime = yc;
  class m3 extends d0 {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.Description = Y, this.Properties = K, this.type = 297599258;
    }
  }
  r.IfcExtendedProperties = m3;
  class V1 extends w0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingReference = K, this.RelatedResourceObjects = ie, this.type = 1437805879;
    }
  }
  r.IfcExternalReferenceRelationship = V1;
  class Fc extends K0 {
    constructor($, j) {
      super($), this.Bounds = j, this.type = 2556980723;
    }
  }
  r.IfcFace = Fc;
  class y3 extends K0 {
    constructor($, j, Y) {
      super($), this.Bound = j, this.Orientation = Y, this.type = 1809719519;
    }
  }
  r.IfcFaceBound = y3;
  class HE extends y3 {
    constructor($, j, Y) {
      super($, j, Y), this.Bound = j, this.Orientation = Y, this.type = 803316827;
    }
  }
  r.IfcFaceOuterBound = HE;
  class W1 extends Fc {
    constructor($, j, Y, K) {
      super($, j), this.Bounds = j, this.FaceSurface = Y, this.SameSense = K, this.type = 3008276851;
    }
  }
  r.IfcFaceSurface = W1;
  class f0 extends Gu {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.TensionFailureX = Y, this.TensionFailureY = K, this.TensionFailureZ = ie, this.CompressionFailureX = Ce, this.CompressionFailureY = ye, this.CompressionFailureZ = we, this.type = 4219587988;
    }
  }
  r.IfcFailureConnectionCondition = f0;
  class F3 extends al {
    constructor($, j, Y, K) {
      super($, j), this.Name = j, this.FillStyles = Y, this.ModelorDraughting = K, this.type = 738692330;
    }
  }
  r.IfcFillAreaStyle = F3;
  class z1 extends M1 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y), this.ContextIdentifier = j, this.ContextType = Y, this.CoordinateSpaceDimension = K, this.Precision = ie, this.WorldCoordinateSystem = Ce, this.TrueNorth = ye, this.type = 3448662350;
    }
  }
  r.IfcGeometricRepresentationContext = z1;
  class Oi extends bu {
    constructor($) {
      super($), this.type = 2453401579;
    }
  }
  r.IfcGeometricRepresentationItem = Oi;
  class Ac extends z1 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, new _e(0), null, new Handle(0), null), this.ContextIdentifier = j, this.ContextType = Y, this.ParentContext = K, this.TargetScale = ie, this.TargetView = Ce, this.UserDefinedTargetView = ye, this.type = 4142052618;
    }
  }
  r.IfcGeometricRepresentationSubContext = Ac;
  class L3 extends Oi {
    constructor($, j) {
      super($), this.Elements = j, this.type = 3590301190;
    }
  }
  r.IfcGeometricSet = L3;
  class vu extends i3 {
    constructor($, j, Y) {
      super($), this.PlacementLocation = j, this.PlacementRefDirection = Y, this.type = 178086475;
    }
  }
  r.IfcGridPlacement = vu;
  class N3 extends Oi {
    constructor($, j, Y) {
      super($), this.BaseSurface = j, this.AgreementFlag = Y, this.type = 812098782;
    }
  }
  r.IfcHalfSpaceSolid = N3;
  class qE extends H0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.RepeatS = j, this.RepeatT = Y, this.Mode = K, this.TextureTransform = ie, this.Parameter = Ce, this.URLReference = ye, this.type = 3905492369;
    }
  }
  r.IfcImageTexture = qE;
  class kE extends Xa {
    constructor($, j, Y, K, ie) {
      super($), this.MappedTo = j, this.Opacity = Y, this.Colours = K, this.ColourIndex = ie, this.type = 3570813810;
    }
  }
  r.IfcIndexedColourMap = kE;
  class $1 extends dc {
    constructor($, j, Y, K) {
      super($, j), this.Maps = j, this.MappedTo = Y, this.TexCoords = K, this.type = 1437953363;
    }
  }
  r.IfcIndexedTextureMap = $1;
  class Q1 extends $1 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.Maps = j, this.MappedTo = Y, this.TexCoords = K, this.TexCoordIndex = ie, this.type = 2133299955;
    }
  }
  r.IfcIndexedTriangleTextureMap = Q1;
  class K1 extends f3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.Name = j, this.Description = Y, this.StartTime = K, this.EndTime = ie, this.TimeSeriesDataType = Ce, this.DataOrigin = ye, this.UserDefinedDataOrigin = we, this.Unit = He, this.Values = rt, this.type = 3741457305;
    }
  }
  r.IfcIrregularTimeSeries = K1;
  class J1 extends Jl {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.LagValue = ie, this.DurationType = Ce, this.type = 1585845231;
    }
  }
  r.IfcLagTime = J1;
  class tu extends Oi {
    constructor($, j, Y, K, ie) {
      super($), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.type = 1402838566;
    }
  }
  r.IfcLightSource = tu;
  class YE extends tu {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.type = 125510826;
    }
  }
  r.IfcLightSourceAmbient = YE;
  class XE extends tu {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.Orientation = Ce, this.type = 2604431987;
    }
  }
  r.IfcLightSourceDirectional = XE;
  class Z1 extends tu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.Position = Ce, this.ColourAppearance = ye, this.ColourTemperature = we, this.LuminousFlux = He, this.LightEmissionSource = rt, this.LightDistributionDataSource = cn, this.type = 4266656042;
    }
  }
  r.IfcLightSourceGoniometric = Z1;
  class e4 extends tu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.Position = Ce, this.Radius = ye, this.ConstantAttenuation = we, this.DistanceAttenuation = He, this.QuadricAttenuation = rt, this.type = 1520743889;
    }
  }
  r.IfcLightSourcePositional = e4;
  class VE extends e4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.Name = j, this.LightColour = Y, this.AmbientIntensity = K, this.Intensity = ie, this.Position = Ce, this.Radius = ye, this.ConstantAttenuation = we, this.DistanceAttenuation = He, this.QuadricAttenuation = rt, this.Orientation = cn, this.ConcentrationExponent = nr, this.SpreadAngle = Yr, this.BeamWidthAngle = $s, this.type = 3422422726;
    }
  }
  r.IfcLightSourceSpot = VE;
  class WE extends i3 {
    constructor($, j, Y) {
      super($), this.PlacementRelTo = j, this.RelativePlacement = Y, this.type = 2624227202;
    }
  }
  r.IfcLocalPlacement = WE;
  class qa extends K0 {
    constructor($) {
      super($), this.type = 1008929658;
    }
  }
  r.IfcLoop = qa;
  class zE extends bu {
    constructor($, j, Y) {
      super($), this.MappingSource = j, this.MappingTarget = Y, this.type = 2347385850;
    }
  }
  r.IfcMappedItem = zE;
  class g3 extends Pa {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.Description = Y, this.Category = K, this.type = 1838606355;
    }
  }
  r.IfcMaterial = g3;
  class O3 extends Pa {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.Name = j, this.Description = Y, this.Material = K, this.Fraction = ie, this.Category = Ce, this.type = 3708119e3;
    }
  }
  r.IfcMaterialConstituent = O3;
  class $E extends Pa {
    constructor($, j, Y, K) {
      super($), this.Name = j, this.Description = Y, this.MaterialConstituents = K, this.type = 2852063980;
    }
  }
  r.IfcMaterialConstituentSet = $E;
  class QE extends $0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Representations = K, this.RepresentedMaterial = ie, this.type = 2022407955;
    }
  }
  r.IfcMaterialDefinitionRepresentation = QE;
  class gl extends wu {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.ForLayerSet = j, this.LayerSetDirection = Y, this.DirectionSense = K, this.OffsetFromReferenceLine = ie, this.ReferenceExtent = Ce, this.type = 1303795690;
    }
  }
  r.IfcMaterialLayerSetUsage = gl;
  class t4 extends wu {
    constructor($, j, Y, K) {
      super($), this.ForProfileSet = j, this.CardinalPoint = Y, this.ReferenceExtent = K, this.type = 3079605661;
    }
  }
  r.IfcMaterialProfileSetUsage = t4;
  class KE extends t4 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.ForProfileSet = j, this.CardinalPoint = Y, this.ReferenceExtent = K, this.ForProfileEndSet = ie, this.CardinalEndPoint = Ce, this.type = 3404854881;
    }
  }
  r.IfcMaterialProfileSetUsageTapering = KE;
  class JE extends m3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Properties = K, this.Material = ie, this.type = 3265635763;
    }
  }
  r.IfcMaterialProperties = JE;
  class ZE extends w0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingMaterial = K, this.RelatedMaterials = ie, this.Expression = Ce, this.type = 853536259;
    }
  }
  r.IfcMaterialRelationship = ZE;
  class e2 extends _3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, new Handle(0), ie), this.ProfileType = j, this.ProfileName = Y, this.ParentProfile = K, this.Label = ie, this.type = 2998442950;
    }
  }
  r.IfcMirroredProfileDef = e2;
  class Il extends Ic {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 219451334;
    }
  }
  r.IfcObjectDefinition = Il;
  class n4 extends Sc {
    constructor($, j) {
      super($, j), this.CfsFaces = j, this.type = 2665983363;
    }
  }
  r.IfcOpenShell = n4;
  class t2 extends w0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingOrganization = K, this.RelatedOrganizations = ie, this.type = 1411181986;
    }
  }
  r.IfcOrganizationRelationship = t2;
  class r2 extends _c {
    constructor($, j, Y) {
      super($, new Handle(0), new Handle(0)), this.EdgeElement = j, this.Orientation = Y, this.type = 1029017970;
    }
  }
  r.IfcOrientedEdge = r2;
  class _0 extends ll {
    constructor($, j, Y, K) {
      super($, j, Y), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.type = 2529465313;
    }
  }
  r.IfcParameterizedProfileDef = _0;
  class Lc extends K0 {
    constructor($, j) {
      super($), this.EdgeList = j, this.type = 2519244187;
    }
  }
  r.IfcPath = Lc;
  class r4 extends Ll {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y), this.Name = j, this.Description = Y, this.HasQuantities = K, this.Discrimination = ie, this.Quality = Ce, this.Usage = ye, this.type = 3021840470;
    }
  }
  r.IfcPhysicalComplexQuantity = r4;
  class s2 extends H0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce), this.RepeatS = j, this.RepeatT = Y, this.Mode = K, this.TextureTransform = ie, this.Parameter = Ce, this.Width = ye, this.Height = we, this.ColourComponents = He, this.Pixel = rt, this.type = 597895409;
    }
  }
  r.IfcPixelTexture = s2;
  class Ol extends Oi {
    constructor($, j) {
      super($), this.Location = j, this.type = 2004835150;
    }
  }
  r.IfcPlacement = Ol;
  class s4 extends Oi {
    constructor($, j, Y) {
      super($), this.SizeInX = j, this.SizeInY = Y, this.type = 1663979128;
    }
  }
  r.IfcPlanarExtent = s4;
  class nu extends Oi {
    constructor($) {
      super($), this.type = 2067069095;
    }
  }
  r.IfcPoint = nu;
  class o4 extends nu {
    constructor($, j, Y) {
      super($), this.BasisCurve = j, this.PointParameter = Y, this.type = 4022376103;
    }
  }
  r.IfcPointOnCurve = o4;
  class o2 extends nu {
    constructor($, j, Y, K) {
      super($), this.BasisSurface = j, this.PointParameterU = Y, this.PointParameterV = K, this.type = 1423911732;
    }
  }
  r.IfcPointOnSurface = o2;
  class Bu extends qa {
    constructor($, j) {
      super($), this.Polygon = j, this.type = 2924175390;
    }
  }
  r.IfcPolyLoop = Bu;
  class i2 extends N3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.BaseSurface = j, this.AgreementFlag = Y, this.Position = K, this.PolygonalBoundary = ie, this.type = 2775532180;
    }
  }
  r.IfcPolygonalBoundedHalfSpace = i2;
  class Pl extends Xa {
    constructor($, j) {
      super($), this.Name = j, this.type = 3727388367;
    }
  }
  r.IfcPreDefinedItem = Pl;
  class Uu extends d0 {
    constructor($) {
      super($), this.type = 3778827333;
    }
  }
  r.IfcPreDefinedProperties = Uu;
  class ea extends Pl {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 1775413392;
    }
  }
  r.IfcPreDefinedTextFont = ea;
  class a2 extends $0 {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Representations = K, this.type = 673634403;
    }
  }
  r.IfcProductDefinitionShape = a2;
  class P3 extends m3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.Name = j, this.Description = Y, this.Properties = K, this.ProfileDefinition = ie, this.type = 2802850158;
    }
  }
  r.IfcProfileProperties = P3;
  class Nc extends d0 {
    constructor($, j, Y) {
      super($), this.Name = j, this.Description = Y, this.type = 2598011224;
    }
  }
  r.IfcProperty = Nc;
  class Hu extends Ic {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 1680319473;
    }
  }
  r.IfcPropertyDefinition = Hu;
  class l2 extends w0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y), this.Name = j, this.Description = Y, this.DependingProperty = K, this.DependantProperty = ie, this.Expression = Ce, this.type = 148025276;
    }
  }
  r.IfcPropertyDependencyRelationship = l2;
  class gc extends Hu {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 3357820518;
    }
  }
  r.IfcPropertySetDefinition = gc;
  class ru extends Hu {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 1482703590;
    }
  }
  r.IfcPropertyTemplateDefinition = ru;
  class qu extends gc {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 2090586900;
    }
  }
  r.IfcQuantitySet = qu;
  class w3 extends _0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.XDim = ie, this.YDim = Ce, this.type = 3615266464;
    }
  }
  r.IfcRectangleProfileDef = w3;
  class u2 extends f3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.Name = j, this.Description = Y, this.StartTime = K, this.EndTime = ie, this.TimeSeriesDataType = Ce, this.DataOrigin = ye, this.UserDefinedDataOrigin = we, this.Unit = He, this.TimeStep = rt, this.Values = cn, this.type = 3413951693;
    }
  }
  r.IfcRegularTimeSeries = u2;
  class ku extends Uu {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($), this.TotalCrossSectionArea = j, this.SteelGrade = Y, this.BarSurface = K, this.EffectiveDepth = ie, this.NominalBarDiameter = Ce, this.BarCount = ye, this.type = 1580146022;
    }
  }
  r.IfcReinforcementBarProperties = ku;
  class wl extends Ic {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 478536968;
    }
  }
  r.IfcRelationship = wl;
  class c2 extends w0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatedResourceObjects = K, this.RelatingApproval = ie, this.type = 2943643501;
    }
  }
  r.IfcResourceApprovalRelationship = c2;
  class E2 extends w0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.RelatingConstraint = K, this.RelatedResourceObjects = ie, this.type = 1608871552;
    }
  }
  r.IfcResourceConstraintRelationship = E2;
  class i4 extends Jl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0) {
      super($, j, Y, K), this.Name = j, this.DataOrigin = Y, this.UserDefinedDataOrigin = K, this.ScheduleWork = ie, this.ScheduleUsage = Ce, this.ScheduleStart = ye, this.ScheduleFinish = we, this.ScheduleContour = He, this.LevelingDelay = rt, this.IsOverAllocated = cn, this.StatusTime = nr, this.ActualWork = Yr, this.ActualUsage = $s, this.ActualStart = wi, this.ActualFinish = Ia, this.RemainingWork = va, this.RemainingUsage = Vi, this.Completion = g0, this.type = 1042787934;
    }
  }
  r.IfcResourceTime = i4;
  class D3 extends w3 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.XDim = ie, this.YDim = Ce, this.RoundingRadius = ye, this.type = 2778083089;
    }
  }
  r.IfcRoundedRectangleProfileDef = D3;
  class I2 extends Uu {
    constructor($, j, Y, K) {
      super($), this.SectionType = j, this.StartProfile = Y, this.EndProfile = K, this.type = 2042790032;
    }
  }
  r.IfcSectionProperties = I2;
  class p2 extends Uu {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($), this.LongitudinalStartPosition = j, this.LongitudinalEndPosition = Y, this.TransversePosition = K, this.ReinforcementRole = ie, this.SectionDefinition = Ce, this.CrossSectionReinforcementDefinitions = ye, this.type = 4165799628;
    }
  }
  r.IfcSectionReinforcementProperties = p2;
  class Oc extends Oi {
    constructor($, j, Y, K) {
      super($), this.SpineCurve = j, this.CrossSections = Y, this.CrossSectionPositions = K, this.type = 1509187699;
    }
  }
  r.IfcSectionedSpine = Oc;
  class d2 extends Oi {
    constructor($, j) {
      super($), this.SbsmBoundary = j, this.type = 4124623270;
    }
  }
  r.IfcShellBasedSurfaceModel = d2;
  class Dl extends Nc {
    constructor($, j, Y) {
      super($, j, Y), this.Name = j, this.Description = Y, this.type = 3692461612;
    }
  }
  r.IfcSimpleProperty = Dl;
  class f2 extends Gu {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.SlippageX = Y, this.SlippageY = K, this.SlippageZ = ie, this.type = 2609359061;
    }
  }
  r.IfcSlippageConnectionCondition = f2;
  class su extends Oi {
    constructor($) {
      super($), this.type = 723233188;
    }
  }
  r.IfcSolidModel = su;
  class b3 extends D0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.LinearForceX = Y, this.LinearForceY = K, this.LinearForceZ = ie, this.LinearMomentX = Ce, this.LinearMomentY = ye, this.LinearMomentZ = we, this.type = 1595516126;
    }
  }
  r.IfcStructuralLoadLinearForce = b3;
  class C2 extends D0 {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.PlanarForceX = Y, this.PlanarForceY = K, this.PlanarForceZ = ie, this.type = 2668620305;
    }
  }
  r.IfcStructuralLoadPlanarForce = C2;
  class G3 extends D0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.DisplacementX = Y, this.DisplacementY = K, this.DisplacementZ = ie, this.RotationalDisplacementRX = Ce, this.RotationalDisplacementRY = ye, this.RotationalDisplacementRZ = we, this.type = 2473145415;
    }
  }
  r.IfcStructuralLoadSingleDisplacement = G3;
  class h2 extends G3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.Name = j, this.DisplacementX = Y, this.DisplacementY = K, this.DisplacementZ = ie, this.RotationalDisplacementRX = Ce, this.RotationalDisplacementRY = ye, this.RotationalDisplacementRZ = we, this.Distortion = He, this.type = 1973038258;
    }
  }
  r.IfcStructuralLoadSingleDisplacementDistortion = h2;
  class a4 extends D0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j), this.Name = j, this.ForceX = Y, this.ForceY = K, this.ForceZ = ie, this.MomentX = Ce, this.MomentY = ye, this.MomentZ = we, this.type = 1597423693;
    }
  }
  r.IfcStructuralLoadSingleForce = a4;
  class j3 extends a4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.Name = j, this.ForceX = Y, this.ForceY = K, this.ForceZ = ie, this.MomentX = Ce, this.MomentY = ye, this.MomentZ = we, this.WarpingMoment = He, this.type = 1190533807;
    }
  }
  r.IfcStructuralLoadSingleForceWarping = j3;
  class l4 extends _c {
    constructor($, j, Y, K) {
      super($, j, Y), this.EdgeStart = j, this.EdgeEnd = Y, this.ParentEdge = K, this.type = 2233826070;
    }
  }
  r.IfcSubedge = l4;
  class bl extends Oi {
    constructor($) {
      super($), this.type = 2513912981;
    }
  }
  r.IfcSurface = bl;
  class u4 extends U1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y), this.SurfaceColour = j, this.Transparency = Y, this.DiffuseColour = K, this.TransmissionColour = ie, this.DiffuseTransmissionColour = Ce, this.ReflectionColour = ye, this.SpecularColour = we, this.SpecularHighlight = He, this.ReflectanceMethod = rt, this.type = 1878645084;
    }
  }
  r.IfcSurfaceStyleRendering = u4;
  class Yu extends su {
    constructor($, j, Y) {
      super($), this.SweptArea = j, this.Position = Y, this.type = 2247615214;
    }
  }
  r.IfcSweptAreaSolid = Yu;
  class M3 extends su {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.Directrix = j, this.Radius = Y, this.InnerRadius = K, this.StartParam = ie, this.EndParam = Ce, this.type = 1260650574;
    }
  }
  r.IfcSweptDiskSolid = M3;
  class S2 extends M3 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.Directrix = j, this.Radius = Y, this.InnerRadius = K, this.StartParam = ie, this.EndParam = Ce, this.FilletRadius = ye, this.type = 1096409881;
    }
  }
  r.IfcSweptDiskSolidPolygonal = S2;
  class a0 extends bl {
    constructor($, j, Y) {
      super($), this.SweptCurve = j, this.Position = Y, this.type = 230924584;
    }
  }
  r.IfcSweptSurface = a0;
  class R2 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Depth = ie, this.FlangeWidth = Ce, this.WebThickness = ye, this.FlangeThickness = we, this.FilletRadius = He, this.FlangeEdgeRadius = rt, this.WebEdgeRadius = cn, this.WebSlope = nr, this.FlangeSlope = Yr, this.type = 3071757647;
    }
  }
  r.IfcTShapeProfileDef = R2;
  class x3 extends Oi {
    constructor($) {
      super($), this.type = 901063453;
    }
  }
  r.IfcTessellatedItem = x3;
  class Gl extends Oi {
    constructor($, j, Y, K) {
      super($), this.Literal = j, this.Placement = Y, this.Path = K, this.type = 4282788508;
    }
  }
  r.IfcTextLiteral = Gl;
  class Xu extends Gl {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.Literal = j, this.Placement = Y, this.Path = K, this.Extent = ie, this.BoxAlignment = Ce, this.type = 3124975700;
    }
  }
  r.IfcTextLiteralWithExtent = Xu;
  class jl extends ea {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j), this.Name = j, this.FontFamily = Y, this.FontStyle = K, this.FontVariant = ie, this.FontWeight = Ce, this.FontSize = ye, this.type = 1983826977;
    }
  }
  r.IfcTextStyleFontModel = jl;
  class Vu extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.BottomXDim = ie, this.TopXDim = Ce, this.YDim = ye, this.TopXOffset = we, this.type = 2715220739;
    }
  }
  r.IfcTrapeziumProfileDef = Vu;
  class Pc extends Il {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.type = 1628702193;
    }
  }
  r.IfcTypeObject = Pc;
  class wc extends Pc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ProcessType = rt, this.type = 3736923433;
    }
  }
  r.IfcTypeProcess = wc;
  class Wu extends Pc {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.type = 2347495698;
    }
  }
  r.IfcTypeProduct = Wu;
  class c4 extends Pc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.type = 3698973494;
    }
  }
  r.IfcTypeResource = c4;
  class T2 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Depth = ie, this.FlangeWidth = Ce, this.WebThickness = ye, this.FlangeThickness = we, this.FilletRadius = He, this.EdgeRadius = rt, this.FlangeSlope = cn, this.type = 427810014;
    }
  }
  r.IfcUShapeProfileDef = T2;
  class Dc extends Oi {
    constructor($, j, Y) {
      super($), this.Orientation = j, this.Magnitude = Y, this.type = 1417489154;
    }
  }
  r.IfcVector = Dc;
  class bc extends qa {
    constructor($, j) {
      super($), this.LoopVertex = j, this.type = 2759199220;
    }
  }
  r.IfcVertexLoop = bc;
  class Gc extends Wu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ConstructionType = rt, this.OperationType = cn, this.ParameterTakesPrecedence = nr, this.Sizeable = Yr, this.type = 1299126871;
    }
  }
  r.IfcWindowStyle = Gc;
  class _2 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Depth = ie, this.FlangeWidth = Ce, this.WebThickness = ye, this.FlangeThickness = we, this.FilletRadius = He, this.EdgeRadius = rt, this.type = 2543172580;
    }
  }
  r.IfcZShapeProfileDef = _2;
  class m2 extends W1 {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Bounds = j, this.FaceSurface = Y, this.SameSense = K, this.type = 3406155212;
    }
  }
  r.IfcAdvancedFace = m2;
  class v3 extends Oi {
    constructor($, j, Y) {
      super($), this.OuterBoundary = j, this.InnerBoundaries = Y, this.type = 669184980;
    }
  }
  r.IfcAnnotationFillArea = v3;
  class B3 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.BottomFlangeWidth = ie, this.OverallDepth = Ce, this.WebThickness = ye, this.BottomFlangeThickness = we, this.BottomFlangeFilletRadius = He, this.TopFlangeWidth = rt, this.TopFlangeThickness = cn, this.TopFlangeFilletRadius = nr, this.BottomFlangeEdgeRadius = Yr, this.BottomFlangeSlope = $s, this.TopFlangeEdgeRadius = wi, this.TopFlangeSlope = Ia, this.type = 3207858831;
    }
  }
  r.IfcAsymmetricIShapeProfileDef = B3;
  class Ml extends Ol {
    constructor($, j, Y) {
      super($, j), this.Location = j, this.Axis = Y, this.type = 4261334040;
    }
  }
  r.IfcAxis1Placement = Ml;
  class zu extends Ol {
    constructor($, j, Y) {
      super($, j), this.Location = j, this.RefDirection = Y, this.type = 3125803723;
    }
  }
  r.IfcAxis2Placement2D = zu;
  class U3 extends Ol {
    constructor($, j, Y, K) {
      super($, j), this.Location = j, this.Axis = Y, this.RefDirection = K, this.type = 2740243338;
    }
  }
  r.IfcAxis2Placement3D = U3;
  class jc extends Oi {
    constructor($, j, Y, K) {
      super($), this.Operator = j, this.FirstOperand = Y, this.SecondOperand = K, this.type = 2736907675;
    }
  }
  r.IfcBooleanResult = jc;
  class xl extends bl {
    constructor($) {
      super($), this.type = 4182860854;
    }
  }
  r.IfcBoundedSurface = xl;
  class y2 extends Oi {
    constructor($, j, Y, K, ie) {
      super($), this.Corner = j, this.XDim = Y, this.YDim = K, this.ZDim = ie, this.type = 2581212453;
    }
  }
  r.IfcBoundingBox = y2;
  class F2 extends N3 {
    constructor($, j, Y, K) {
      super($, j, Y), this.BaseSurface = j, this.AgreementFlag = Y, this.Enclosure = K, this.type = 2713105998;
    }
  }
  r.IfcBoxedHalfSpace = F2;
  class vl extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Depth = ie, this.Width = Ce, this.WallThickness = ye, this.Girth = we, this.InternalFilletRadius = He, this.type = 2898889636;
    }
  }
  r.IfcCShapeProfileDef = vl;
  class L2 extends nu {
    constructor($, j) {
      super($), this.Coordinates = j, this.type = 1123145078;
    }
  }
  r.IfcCartesianPoint = L2;
  class H3 extends Oi {
    constructor($) {
      super($), this.type = 574549367;
    }
  }
  r.IfcCartesianPointList = H3;
  class q3 extends H3 {
    constructor($, j) {
      super($), this.CoordList = j, this.type = 1675464909;
    }
  }
  r.IfcCartesianPointList2D = q3;
  class N2 extends H3 {
    constructor($, j) {
      super($), this.CoordList = j, this.type = 2059837836;
    }
  }
  r.IfcCartesianPointList3D = N2;
  class k3 extends Oi {
    constructor($, j, Y, K, ie) {
      super($), this.Axis1 = j, this.Axis2 = Y, this.LocalOrigin = K, this.Scale = ie, this.type = 59481748;
    }
  }
  r.IfcCartesianTransformationOperator = k3;
  class Y3 extends k3 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.Axis1 = j, this.Axis2 = Y, this.LocalOrigin = K, this.Scale = ie, this.type = 3749851601;
    }
  }
  r.IfcCartesianTransformationOperator2D = Y3;
  class g2 extends Y3 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.Axis1 = j, this.Axis2 = Y, this.LocalOrigin = K, this.Scale = ie, this.Scale2 = Ce, this.type = 3486308946;
    }
  }
  r.IfcCartesianTransformationOperator2DnonUniform = g2;
  class Mc extends k3 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.Axis1 = j, this.Axis2 = Y, this.LocalOrigin = K, this.Scale = ie, this.Axis3 = Ce, this.type = 3331915920;
    }
  }
  r.IfcCartesianTransformationOperator3D = Mc;
  class X3 extends Mc {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.Axis1 = j, this.Axis2 = Y, this.LocalOrigin = K, this.Scale = ie, this.Axis3 = Ce, this.Scale2 = ye, this.Scale3 = we, this.type = 1416205885;
    }
  }
  r.IfcCartesianTransformationOperator3DnonUniform = X3;
  class i0 extends _0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Radius = ie, this.type = 1383045692;
    }
  }
  r.IfcCircleProfileDef = i0;
  class O2 extends Sc {
    constructor($, j) {
      super($, j), this.CfsFaces = j, this.type = 2205249479;
    }
  }
  r.IfcClosedShell = O2;
  class ou extends T3 {
    constructor($, j, Y, K, ie) {
      super($, j), this.Name = j, this.Red = Y, this.Green = K, this.Blue = ie, this.type = 776857604;
    }
  }
  r.IfcColourRgb = ou;
  class P2 extends Nc {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.UsageName = K, this.HasProperties = ie, this.type = 2542286263;
    }
  }
  r.IfcComplexProperty = P2;
  class E4 extends Oi {
    constructor($, j, Y, K) {
      super($), this.Transition = j, this.SameSense = Y, this.ParentCurve = K, this.type = 2485617015;
    }
  }
  r.IfcCompositeCurveSegment = E4;
  class pl extends c4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.type = 2574617495;
    }
  }
  r.IfcConstructionResourceType = pl;
  class $u extends Il {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.Phase = we, this.RepresentationContexts = He, this.UnitsInContext = rt, this.type = 3419103109;
    }
  }
  r.IfcContext = $u;
  class q0 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 1815067380;
    }
  }
  r.IfcCrewResourceType = q0;
  class iu extends Oi {
    constructor($, j) {
      super($), this.Position = j, this.type = 2506170314;
    }
  }
  r.IfcCsgPrimitive3D = iu;
  class w2 extends su {
    constructor($, j) {
      super($), this.TreeRootExpression = j, this.type = 2147822146;
    }
  }
  r.IfcCsgSolid = w2;
  class m0 extends Oi {
    constructor($) {
      super($), this.type = 2601014836;
    }
  }
  r.IfcCurve = m0;
  class D2 extends xl {
    constructor($, j, Y, K) {
      super($), this.BasisSurface = j, this.OuterBoundary = Y, this.InnerBoundaries = K, this.type = 2827736869;
    }
  }
  r.IfcCurveBoundedPlane = D2;
  class xc extends xl {
    constructor($, j, Y, K) {
      super($), this.BasisSurface = j, this.Boundaries = Y, this.ImplicitOuter = K, this.type = 2629017746;
    }
  }
  r.IfcCurveBoundedSurface = xc;
  class I4 extends Oi {
    constructor($, j) {
      super($), this.DirectionRatios = j, this.type = 32440307;
    }
  }
  r.IfcDirection = I4;
  class b2 extends Wu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.OperationType = rt, this.ConstructionType = cn, this.ParameterTakesPrecedence = nr, this.Sizeable = Yr, this.type = 526551008;
    }
  }
  r.IfcDoorStyle = b2;
  class Z0 extends qa {
    constructor($, j) {
      super($), this.EdgeList = j, this.type = 1472233963;
    }
  }
  r.IfcEdgeLoop = Z0;
  class p4 extends qu {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.MethodOfMeasurement = Ce, this.Quantities = ye, this.type = 1883228015;
    }
  }
  r.IfcElementQuantity = p4;
  class l0 extends Wu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 339256511;
    }
  }
  r.IfcElementType = l0;
  class au extends bl {
    constructor($, j) {
      super($), this.Position = j, this.type = 2777663545;
    }
  }
  r.IfcElementarySurface = au;
  class G2 extends _0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.SemiAxis1 = ie, this.SemiAxis2 = Ce, this.type = 2835456948;
    }
  }
  r.IfcEllipseProfileDef = G2;
  class j2 extends wc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ProcessType = rt, this.PredefinedType = cn, this.EventTriggerType = nr, this.UserDefinedEventTriggerType = Yr, this.type = 4024345920;
    }
  }
  r.IfcEventType = j2;
  class d4 extends Yu {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.SweptArea = j, this.Position = Y, this.ExtrudedDirection = K, this.Depth = ie, this.type = 477187591;
    }
  }
  r.IfcExtrudedAreaSolid = d4;
  class vc extends d4 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.SweptArea = j, this.Position = Y, this.ExtrudedDirection = K, this.Depth = ie, this.EndSweptArea = Ce, this.type = 2804161546;
    }
  }
  r.IfcExtrudedAreaSolidTapered = vc;
  class y0 extends Oi {
    constructor($, j) {
      super($), this.FbsmFaces = j, this.type = 2047409740;
    }
  }
  r.IfcFaceBasedSurfaceModel = y0;
  class V3 extends Oi {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.HatchLineAppearance = j, this.StartOfNextHatchLine = Y, this.PointOfReferenceHatchLine = K, this.PatternStart = ie, this.HatchLineAngle = Ce, this.type = 374418227;
    }
  }
  r.IfcFillAreaStyleHatching = V3;
  class f4 extends Oi {
    constructor($, j, Y, K) {
      super($), this.TilingPattern = j, this.Tiles = Y, this.TilingScale = K, this.type = 315944413;
    }
  }
  r.IfcFillAreaStyleTiles = f4;
  class M2 extends Yu {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y), this.SweptArea = j, this.Position = Y, this.Directrix = K, this.StartParam = ie, this.EndParam = Ce, this.FixedReference = ye, this.type = 2652556860;
    }
  }
  r.IfcFixedReferenceSweptAreaSolid = M2;
  class W3 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 4238390223;
    }
  }
  r.IfcFurnishingElementType = W3;
  class x2 extends W3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.AssemblyPlace = cn, this.PredefinedType = nr, this.type = 1268542332;
    }
  }
  r.IfcFurnitureType = x2;
  class v2 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4095422895;
    }
  }
  r.IfcGeographicElementType = v2;
  class B2 extends L3 {
    constructor($, j) {
      super($, j), this.Elements = j, this.type = 987898635;
    }
  }
  r.IfcGeometricCurveSet = B2;
  class U2 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.OverallWidth = ie, this.OverallDepth = Ce, this.WebThickness = ye, this.FlangeThickness = we, this.FilletRadius = He, this.FlangeEdgeRadius = rt, this.FlangeSlope = cn, this.type = 1484403080;
    }
  }
  r.IfcIShapeProfileDef = U2;
  class Ma extends x3 {
    constructor($, j) {
      super($), this.CoordIndex = j, this.type = 178912537;
    }
  }
  r.IfcIndexedPolygonalFace = Ma;
  class z3 extends Ma {
    constructor($, j, Y) {
      super($, j), this.CoordIndex = j, this.InnerCoordIndices = Y, this.type = 2294589976;
    }
  }
  r.IfcIndexedPolygonalFaceWithVoids = z3;
  class H2 extends _0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Depth = ie, this.Width = Ce, this.Thickness = ye, this.FilletRadius = we, this.EdgeRadius = He, this.LegSlope = rt, this.type = 572779678;
    }
  }
  r.IfcLShapeProfileDef = H2;
  class q2 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 428585644;
    }
  }
  r.IfcLaborResourceType = q2;
  class k2 extends m0 {
    constructor($, j, Y) {
      super($), this.Pnt = j, this.Dir = Y, this.type = 1281925730;
    }
  }
  r.IfcLine = k2;
  class Bc extends su {
    constructor($, j) {
      super($), this.Outer = j, this.type = 1425443689;
    }
  }
  r.IfcManifoldSolidBrep = Bc;
  class G0 extends Il {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.type = 3888040117;
    }
  }
  r.IfcObject = G0;
  class C4 extends m0 {
    constructor($, j, Y, K) {
      super($), this.BasisCurve = j, this.Distance = Y, this.SelfIntersect = K, this.type = 3388369263;
    }
  }
  r.IfcOffsetCurve2D = C4;
  class Y2 extends m0 {
    constructor($, j, Y, K, ie) {
      super($), this.BasisCurve = j, this.Distance = Y, this.SelfIntersect = K, this.RefDirection = ie, this.type = 3505215534;
    }
  }
  r.IfcOffsetCurve3D = Y2;
  class X2 extends m0 {
    constructor($, j, Y) {
      super($), this.BasisSurface = j, this.ReferenceCurve = Y, this.type = 1682466193;
    }
  }
  r.IfcPcurve = X2;
  class V2 extends s4 {
    constructor($, j, Y, K) {
      super($, j, Y), this.SizeInX = j, this.SizeInY = Y, this.Placement = K, this.type = 603570806;
    }
  }
  r.IfcPlanarBox = V2;
  class $3 extends au {
    constructor($, j) {
      super($, j), this.Position = j, this.type = 220341763;
    }
  }
  r.IfcPlane = $3;
  class h4 extends Pl {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 759155922;
    }
  }
  r.IfcPreDefinedColour = h4;
  class Uc extends Pl {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 2559016684;
    }
  }
  r.IfcPreDefinedCurveFont = Uc;
  class j0 extends gc {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 3967405729;
    }
  }
  r.IfcPreDefinedPropertySet = j0;
  class Q3 extends wc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ProcessType = rt, this.PredefinedType = cn, this.type = 569719735;
    }
  }
  r.IfcProcedureType = Q3;
  class Hc extends G0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.type = 2945172077;
    }
  }
  r.IfcProcess = Hc;
  class k0 extends G0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.type = 4208778838;
    }
  }
  r.IfcProduct = k0;
  class W2 extends $u {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.Phase = we, this.RepresentationContexts = He, this.UnitsInContext = rt, this.type = 103090709;
    }
  }
  r.IfcProject = W2;
  class S4 extends $u {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.Phase = we, this.RepresentationContexts = He, this.UnitsInContext = rt, this.type = 653396225;
    }
  }
  r.IfcProjectLibrary = S4;
  class z2 extends Dl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y), this.Name = j, this.Description = Y, this.UpperBoundValue = K, this.LowerBoundValue = ie, this.Unit = Ce, this.SetPointValue = ye, this.type = 871118103;
    }
  }
  r.IfcPropertyBoundedValue = z2;
  class $2 extends Dl {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.EnumerationValues = K, this.EnumerationReference = ie, this.type = 4166981789;
    }
  }
  r.IfcPropertyEnumeratedValue = $2;
  class Q2 extends Dl {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.ListValues = K, this.Unit = ie, this.type = 2752243245;
    }
  }
  r.IfcPropertyListValue = Q2;
  class R4 extends Dl {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.UsageName = K, this.PropertyReference = ie, this.type = 941946838;
    }
  }
  r.IfcPropertyReferenceValue = R4;
  class Bl extends gc {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.HasProperties = Ce, this.type = 1451395588;
    }
  }
  r.IfcPropertySet = Bl;
  class K3 extends ru {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.TemplateType = Ce, this.ApplicableEntity = ye, this.HasPropertyTemplates = we, this.type = 492091185;
    }
  }
  r.IfcPropertySetTemplate = K3;
  class K2 extends Dl {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.Name = j, this.Description = Y, this.NominalValue = K, this.Unit = ie, this.type = 3650150729;
    }
  }
  r.IfcPropertySingleValue = K2;
  class lu extends Dl {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y), this.Name = j, this.Description = Y, this.DefiningValues = K, this.DefinedValues = ie, this.Expression = Ce, this.DefiningUnit = ye, this.DefinedUnit = we, this.CurveInterpolation = He, this.type = 110355661;
    }
  }
  r.IfcPropertyTableValue = lu;
  class J3 extends ru {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 3521284610;
    }
  }
  r.IfcPropertyTemplate = J3;
  class el extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.ProxyType = He, this.Tag = rt, this.type = 3219374653;
    }
  }
  r.IfcProxy = el;
  class T4 extends w3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.XDim = ie, this.YDim = Ce, this.WallThickness = ye, this.InnerFilletRadius = we, this.OuterFilletRadius = He, this.type = 2770003689;
    }
  }
  r.IfcRectangleHollowProfileDef = T4;
  class J2 extends iu {
    constructor($, j, Y, K, ie) {
      super($, j), this.Position = j, this.XLength = Y, this.YLength = K, this.Height = ie, this.type = 2798486643;
    }
  }
  r.IfcRectangularPyramid = J2;
  class Z2 extends xl {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.BasisSurface = j, this.U1 = Y, this.V1 = K, this.U2 = ie, this.V2 = Ce, this.Usense = ye, this.Vsense = we, this.type = 3454111270;
    }
  }
  r.IfcRectangularTrimmedSurface = Z2;
  class e6 extends j0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.DefinitionType = Ce, this.ReinforcementSectionDefinitions = ye, this.type = 3765753017;
    }
  }
  r.IfcReinforcementDefinitionProperties = e6;
  class C0 extends wl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.type = 3939117080;
    }
  }
  r.IfcRelAssigns = C0;
  class _4 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingActor = we, this.ActingRole = He, this.type = 1683148259;
    }
  }
  r.IfcRelAssignsToActor = _4;
  class t6 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingControl = we, this.type = 2495723537;
    }
  }
  r.IfcRelAssignsToControl = t6;
  class F0 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingGroup = we, this.type = 1307041759;
    }
  }
  r.IfcRelAssignsToGroup = F0;
  class Ul extends F0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingGroup = we, this.Factor = He, this.type = 1027710054;
    }
  }
  r.IfcRelAssignsToGroupByFactor = Ul;
  class Z3 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingProcess = we, this.QuantityInProcess = He, this.type = 4278684876;
    }
  }
  r.IfcRelAssignsToProcess = Z3;
  class m4 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingProduct = we, this.type = 2857406711;
    }
  }
  r.IfcRelAssignsToProduct = m4;
  class e1 extends C0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatedObjectsType = ye, this.RelatingResource = we, this.type = 205026976;
    }
  }
  r.IfcRelAssignsToResource = e1;
  class Hl extends wl {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.type = 1865459582;
    }
  }
  r.IfcRelAssociates = Hl;
  class n6 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingApproval = ye, this.type = 4095574036;
    }
  }
  r.IfcRelAssociatesApproval = n6;
  class r6 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingClassification = ye, this.type = 919958153;
    }
  }
  r.IfcRelAssociatesClassification = r6;
  class s6 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.Intent = ye, this.RelatingConstraint = we, this.type = 2728634034;
    }
  }
  r.IfcRelAssociatesConstraint = s6;
  class y4 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingDocument = ye, this.type = 982818633;
    }
  }
  r.IfcRelAssociatesDocument = y4;
  class t1 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingLibrary = ye, this.type = 3840914261;
    }
  }
  r.IfcRelAssociatesLibrary = t1;
  class r1 extends Hl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingMaterial = ye, this.type = 2655215786;
    }
  }
  r.IfcRelAssociatesMaterial = r1;
  class e0 extends wl {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 826625072;
    }
  }
  r.IfcRelConnects = e0;
  class qc extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ConnectionGeometry = Ce, this.RelatingElement = ye, this.RelatedElement = we, this.type = 1204542856;
    }
  }
  r.IfcRelConnectsElements = qc;
  class o6 extends qc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ConnectionGeometry = Ce, this.RelatingElement = ye, this.RelatedElement = we, this.RelatingPriorities = He, this.RelatedPriorities = rt, this.RelatedConnectionType = cn, this.RelatingConnectionType = nr, this.type = 3945020480;
    }
  }
  r.IfcRelConnectsPathElements = o6;
  class F4 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingPort = Ce, this.RelatedElement = ye, this.type = 4201705270;
    }
  }
  r.IfcRelConnectsPortToElement = F4;
  class i6 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingPort = Ce, this.RelatedPort = ye, this.RealizingElement = we, this.type = 3190031847;
    }
  }
  r.IfcRelConnectsPorts = i6;
  class a6 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingElement = Ce, this.RelatedStructuralActivity = ye, this.type = 2127690289;
    }
  }
  r.IfcRelConnectsStructuralActivity = a6;
  class uu extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingStructuralMember = Ce, this.RelatedStructuralConnection = ye, this.AppliedCondition = we, this.AdditionalConditions = He, this.SupportedLength = rt, this.ConditionCoordinateSystem = cn, this.type = 1638771189;
    }
  }
  r.IfcRelConnectsStructuralMember = uu;
  class l6 extends uu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingStructuralMember = Ce, this.RelatedStructuralConnection = ye, this.AppliedCondition = we, this.AdditionalConditions = He, this.SupportedLength = rt, this.ConditionCoordinateSystem = cn, this.ConnectionConstraint = nr, this.type = 504942748;
    }
  }
  r.IfcRelConnectsWithEccentricity = l6;
  class h0 extends qc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ConnectionGeometry = Ce, this.RelatingElement = ye, this.RelatedElement = we, this.RealizingElements = He, this.ConnectionType = rt, this.type = 3678494232;
    }
  }
  r.IfcRelConnectsWithRealizingElements = h0;
  class s1 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedElements = Ce, this.RelatingStructure = ye, this.type = 3242617779;
    }
  }
  r.IfcRelContainedInSpatialStructure = s1;
  class ql extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingBuildingElement = Ce, this.RelatedCoverings = ye, this.type = 886880790;
    }
  }
  r.IfcRelCoversBldgElements = ql;
  class kc extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingSpace = Ce, this.RelatedCoverings = ye, this.type = 2802773753;
    }
  }
  r.IfcRelCoversSpaces = kc;
  class L4 extends wl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingContext = Ce, this.RelatedDefinitions = ye, this.type = 2565941209;
    }
  }
  r.IfcRelDeclares = L4;
  class kl extends wl {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 2551354335;
    }
  }
  r.IfcRelDecomposes = kl;
  class M0 extends wl {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.type = 693640335;
    }
  }
  r.IfcRelDefines = M0;
  class t0 extends M0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingObject = ye, this.type = 1462361463;
    }
  }
  r.IfcRelDefinesByObject = t0;
  class u6 extends M0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingPropertyDefinition = ye, this.type = 4186316022;
    }
  }
  r.IfcRelDefinesByProperties = u6;
  class c6 extends M0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedPropertySets = Ce, this.RelatingTemplate = ye, this.type = 307848117;
    }
  }
  r.IfcRelDefinesByTemplate = c6;
  class E6 extends M0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedObjects = Ce, this.RelatingType = ye, this.type = 781010003;
    }
  }
  r.IfcRelDefinesByType = E6;
  class N4 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingOpeningElement = Ce, this.RelatedBuildingElement = ye, this.type = 3940055652;
    }
  }
  r.IfcRelFillsElement = N4;
  class g4 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedControlElements = Ce, this.RelatingFlowElement = ye, this.type = 279856033;
    }
  }
  r.IfcRelFlowControlElements = g4;
  class x0 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingElement = Ce, this.RelatedElement = ye, this.InterferenceGeometry = we, this.InterferenceType = He, this.ImpliedOrder = rt, this.type = 427948657;
    }
  }
  r.IfcRelInterferesElements = x0;
  class o1 extends kl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingObject = Ce, this.RelatedObjects = ye, this.type = 3268803585;
    }
  }
  r.IfcRelNests = o1;
  class S0 extends kl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingElement = Ce, this.RelatedFeatureElement = ye, this.type = 750771296;
    }
  }
  r.IfcRelProjectsElement = S0;
  class tl extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatedElements = Ce, this.RelatingStructure = ye, this.type = 1245217292;
    }
  }
  r.IfcRelReferencedInSpatialStructure = tl;
  class v0 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingProcess = Ce, this.RelatedProcess = ye, this.TimeLag = we, this.SequenceType = He, this.UserDefinedSequenceType = rt, this.type = 4122056220;
    }
  }
  r.IfcRelSequence = v0;
  class I6 extends e0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingSystem = Ce, this.RelatedBuildings = ye, this.type = 366585022;
    }
  }
  r.IfcRelServicesBuildings = I6;
  class Yc extends e0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingSpace = Ce, this.RelatedBuildingElement = ye, this.ConnectionGeometry = we, this.PhysicalOrVirtualBoundary = He, this.InternalOrExternalBoundary = rt, this.type = 3451746338;
    }
  }
  r.IfcRelSpaceBoundary = Yc;
  class Xc extends Yc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingSpace = Ce, this.RelatedBuildingElement = ye, this.ConnectionGeometry = we, this.PhysicalOrVirtualBoundary = He, this.InternalOrExternalBoundary = rt, this.ParentBoundary = cn, this.type = 3523091289;
    }
  }
  r.IfcRelSpaceBoundary1stLevel = Xc;
  class p6 extends Xc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingSpace = Ce, this.RelatedBuildingElement = ye, this.ConnectionGeometry = we, this.PhysicalOrVirtualBoundary = He, this.InternalOrExternalBoundary = rt, this.ParentBoundary = cn, this.CorrespondingBoundary = nr, this.type = 1521410863;
    }
  }
  r.IfcRelSpaceBoundary2ndLevel = p6;
  class ka extends kl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingBuildingElement = Ce, this.RelatedOpeningElement = ye, this.type = 1401173127;
    }
  }
  r.IfcRelVoidsElement = ka;
  class d6 extends E4 {
    constructor($, j, Y, K, ie) {
      super($, j, Y, K), this.Transition = j, this.SameSense = Y, this.ParentCurve = K, this.ParamLength = ie, this.type = 816062949;
    }
  }
  r.IfcReparametrisedCompositeCurveSegment = d6;
  class O4 extends G0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.type = 2914609552;
    }
  }
  r.IfcResource = O4;
  class P4 extends Yu {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.SweptArea = j, this.Position = Y, this.Axis = K, this.Angle = ie, this.type = 1856042241;
    }
  }
  r.IfcRevolvedAreaSolid = P4;
  class f6 extends P4 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.SweptArea = j, this.Position = Y, this.Axis = K, this.Angle = ie, this.EndSweptArea = Ce, this.type = 3243963512;
    }
  }
  r.IfcRevolvedAreaSolidTapered = f6;
  class i1 extends iu {
    constructor($, j, Y, K) {
      super($, j), this.Position = j, this.Height = Y, this.BottomRadius = K, this.type = 4158566097;
    }
  }
  r.IfcRightCircularCone = i1;
  class C6 extends iu {
    constructor($, j, Y, K) {
      super($, j), this.Position = j, this.Height = Y, this.Radius = K, this.type = 3626867408;
    }
  }
  r.IfcRightCircularCylinder = C6;
  class w4 extends J3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.TemplateType = Ce, this.PrimaryMeasureType = ye, this.SecondaryMeasureType = we, this.Enumerators = He, this.PrimaryUnit = rt, this.SecondaryUnit = cn, this.Expression = nr, this.AccessState = Yr, this.type = 3663146110;
    }
  }
  r.IfcSimplePropertyTemplate = w4;
  class Qu extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.type = 1412071761;
    }
  }
  r.IfcSpatialElement = Qu;
  class Ku extends Wu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 710998568;
    }
  }
  r.IfcSpatialElementType = Ku;
  class A0 extends Qu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.CompositionType = rt, this.type = 2706606064;
    }
  }
  r.IfcSpatialStructureElement = A0;
  class Vc extends Ku {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3893378262;
    }
  }
  r.IfcSpatialStructureElementType = Vc;
  class dl extends Qu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.PredefinedType = rt, this.type = 463610769;
    }
  }
  r.IfcSpatialZone = dl;
  class cu extends Ku {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.LongName = nr, this.type = 2481509218;
    }
  }
  r.IfcSpatialZoneType = cu;
  class h6 extends iu {
    constructor($, j, Y) {
      super($, j), this.Position = j, this.Radius = Y, this.type = 451544542;
    }
  }
  r.IfcSphere = h6;
  class Wc extends au {
    constructor($, j, Y) {
      super($, j), this.Position = j, this.Radius = Y, this.type = 4015995234;
    }
  }
  r.IfcSphericalSurface = Wc;
  class Yl extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.type = 3544373492;
    }
  }
  r.IfcStructuralActivity = Yl;
  class Ju extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.type = 3136571912;
    }
  }
  r.IfcStructuralItem = Ju;
  class wa extends Ju {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.type = 530289379;
    }
  }
  r.IfcStructuralMember = wa;
  class Eu extends Yl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.type = 3689010777;
    }
  }
  r.IfcStructuralReaction = Eu;
  class D4 extends wa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.PredefinedType = He, this.Thickness = rt, this.type = 3979015343;
    }
  }
  r.IfcStructuralSurfaceMember = D4;
  class S6 extends D4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.PredefinedType = He, this.Thickness = rt, this.type = 2218152070;
    }
  }
  r.IfcStructuralSurfaceMemberVarying = S6;
  class R6 extends Eu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.PredefinedType = cn, this.type = 603775116;
    }
  }
  r.IfcStructuralSurfaceReaction = R6;
  class T6 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 4095615324;
    }
  }
  r.IfcSubContractResourceType = T6;
  class Y0 extends m0 {
    constructor($, j, Y, K) {
      super($), this.Curve3D = j, this.AssociatedGeometry = Y, this.MasterRepresentation = K, this.type = 699246055;
    }
  }
  r.IfcSurfaceCurve = Y0;
  class _6 extends Yu {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y), this.SweptArea = j, this.Position = Y, this.Directrix = K, this.StartParam = ie, this.EndParam = Ce, this.ReferenceSurface = ye, this.type = 2028607225;
    }
  }
  r.IfcSurfaceCurveSweptAreaSolid = _6;
  class Ka extends a0 {
    constructor($, j, Y, K, ie) {
      super($, j, Y), this.SweptCurve = j, this.Position = Y, this.ExtrudedDirection = K, this.Depth = ie, this.type = 2809605785;
    }
  }
  r.IfcSurfaceOfLinearExtrusion = Ka;
  class a1 extends a0 {
    constructor($, j, Y, K) {
      super($, j, Y), this.SweptCurve = j, this.Position = Y, this.AxisPosition = K, this.type = 4124788165;
    }
  }
  r.IfcSurfaceOfRevolution = a1;
  class m6 extends W3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1580310250;
    }
  }
  r.IfcSystemFurnitureElementType = m6;
  class y6 extends Hc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Status = He, this.WorkMethod = rt, this.IsMilestone = cn, this.Priority = nr, this.TaskTime = Yr, this.PredefinedType = $s, this.type = 3473067441;
    }
  }
  r.IfcTask = y6;
  class F6 extends wc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ProcessType = rt, this.PredefinedType = cn, this.WorkMethod = nr, this.type = 3206491090;
    }
  }
  r.IfcTaskType = F6;
  class l1 extends x3 {
    constructor($, j) {
      super($), this.Coordinates = j, this.type = 2387106220;
    }
  }
  r.IfcTessellatedFaceSet = l1;
  class b4 extends au {
    constructor($, j, Y, K) {
      super($, j), this.Position = j, this.MajorRadius = Y, this.MinorRadius = K, this.type = 1935646853;
    }
  }
  r.IfcToroidalSurface = b4;
  class A6 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2097647324;
    }
  }
  r.IfcTransportElementType = A6;
  class L6 extends l1 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j), this.Coordinates = j, this.Normals = Y, this.Closed = K, this.CoordIndex = ie, this.PnIndex = Ce, this.type = 2916149573;
    }
  }
  r.IfcTriangulatedFaceSet = L6;
  class N6 extends j0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.LiningDepth = Ce, this.LiningThickness = ye, this.TransomThickness = we, this.MullionThickness = He, this.FirstTransomOffset = rt, this.SecondTransomOffset = cn, this.FirstMullionOffset = nr, this.SecondMullionOffset = Yr, this.ShapeAspectStyle = $s, this.LiningOffset = wi, this.LiningToPanelOffsetX = Ia, this.LiningToPanelOffsetY = va, this.type = 336235671;
    }
  }
  r.IfcWindowLiningProperties = N6;
  class g6 extends j0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.OperationType = Ce, this.PanelPosition = ye, this.FrameDepth = we, this.FrameThickness = He, this.ShapeAspectStyle = rt, this.type = 512836454;
    }
  }
  r.IfcWindowPanelProperties = g6;
  class G4 extends G0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.TheActor = ye, this.type = 2296667514;
    }
  }
  r.IfcActor = G4;
  class j4 extends Bc {
    constructor($, j) {
      super($, j), this.Outer = j, this.type = 1635779807;
    }
  }
  r.IfcAdvancedBrep = j4;
  class Iu extends j4 {
    constructor($, j, Y) {
      super($, j), this.Outer = j, this.Voids = Y, this.type = 2603310189;
    }
  }
  r.IfcAdvancedBrepWithVoids = Iu;
  class Zu extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.type = 1674181508;
    }
  }
  r.IfcAnnotation = Zu;
  class M4 extends xl {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($), this.UDegree = j, this.VDegree = Y, this.ControlPointsList = K, this.SurfaceForm = ie, this.UClosed = Ce, this.VClosed = ye, this.SelfIntersect = we, this.type = 2887950389;
    }
  }
  r.IfcBSplineSurface = M4;
  class x4 extends M4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we), this.UDegree = j, this.VDegree = Y, this.ControlPointsList = K, this.SurfaceForm = ie, this.UClosed = Ce, this.VClosed = ye, this.SelfIntersect = we, this.UMultiplicities = He, this.VMultiplicities = rt, this.UKnots = cn, this.VKnots = nr, this.KnotSpec = Yr, this.type = 167062518;
    }
  }
  r.IfcBSplineSurfaceWithKnots = x4;
  class O6 extends iu {
    constructor($, j, Y, K, ie) {
      super($, j), this.Position = j, this.XLength = Y, this.YLength = K, this.ZLength = ie, this.type = 1334484129;
    }
  }
  r.IfcBlock = O6;
  class P6 extends jc {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Operator = j, this.FirstOperand = Y, this.SecondOperand = K, this.type = 3649129432;
    }
  }
  r.IfcBooleanClippingResult = P6;
  class pu extends m0 {
    constructor($) {
      super($), this.type = 1260505505;
    }
  }
  r.IfcBoundedCurve = pu;
  class w6 extends A0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.CompositionType = rt, this.ElevationOfRefHeight = cn, this.ElevationOfTerrain = nr, this.BuildingAddress = Yr, this.type = 4031249490;
    }
  }
  r.IfcBuilding = w6;
  class ya extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 1950629157;
    }
  }
  r.IfcBuildingElementType = ya;
  class v4 extends A0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.CompositionType = rt, this.Elevation = cn, this.type = 3124254112;
    }
  }
  r.IfcBuildingStorey = v4;
  class D6 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2197970202;
    }
  }
  r.IfcChimneyType = D6;
  class b6 extends i0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie), this.ProfileType = j, this.ProfileName = Y, this.Position = K, this.Radius = ie, this.WallThickness = Ce, this.type = 2937912522;
    }
  }
  r.IfcCircleHollowProfileDef = b6;
  class G6 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3893394355;
    }
  }
  r.IfcCivilElementType = G6;
  class j6 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 300633059;
    }
  }
  r.IfcColumnType = j6;
  class M6 extends J3 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.UsageName = Ce, this.TemplateType = ye, this.HasPropertyTemplates = we, this.type = 3875453745;
    }
  }
  r.IfcComplexPropertyTemplate = M6;
  class u1 extends pu {
    constructor($, j, Y) {
      super($), this.Segments = j, this.SelfIntersect = Y, this.type = 3732776249;
    }
  }
  r.IfcCompositeCurve = u1;
  class c1 extends u1 {
    constructor($, j, Y) {
      super($, j, Y), this.Segments = j, this.SelfIntersect = Y, this.type = 15328376;
    }
  }
  r.IfcCompositeCurveOnSurface = c1;
  class E1 extends m0 {
    constructor($, j) {
      super($), this.Position = j, this.type = 2510884976;
    }
  }
  r.IfcConic = E1;
  class x6 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 2185764099;
    }
  }
  r.IfcConstructionEquipmentResourceType = x6;
  class v6 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 4105962743;
    }
  }
  r.IfcConstructionMaterialResourceType = v6;
  class B4 extends pl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.Identification = we, this.LongDescription = He, this.ResourceType = rt, this.BaseCosts = cn, this.BaseQuantity = nr, this.PredefinedType = Yr, this.type = 1525564444;
    }
  }
  r.IfcConstructionProductResourceType = B4;
  class fl extends O4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.type = 2559216714;
    }
  }
  r.IfcConstructionResource = fl;
  class nl extends G0 {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.type = 3293443760;
    }
  }
  r.IfcControl = nl;
  class B6 extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.PredefinedType = we, this.CostValues = He, this.CostQuantities = rt, this.type = 3895139033;
    }
  }
  r.IfcCostItem = B6;
  class U6 extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.PredefinedType = we, this.Status = He, this.SubmittedOn = rt, this.UpdateDate = cn, this.type = 1419761937;
    }
  }
  r.IfcCostSchedule = U6;
  class U4 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1916426348;
    }
  }
  r.IfcCoveringType = U4;
  class H6 extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 3295246426;
    }
  }
  r.IfcCrewResource = H6;
  class q6 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1457835157;
    }
  }
  r.IfcCurtainWallType = q6;
  class k6 extends au {
    constructor($, j, Y) {
      super($, j), this.Position = j, this.Radius = Y, this.type = 1213902940;
    }
  }
  r.IfcCylindricalSurface = k6;
  class du extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3256556792;
    }
  }
  r.IfcDistributionElementType = du;
  class L0 extends du {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3849074793;
    }
  }
  r.IfcDistributionFlowElementType = L0;
  class fu extends j0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.LiningDepth = Ce, this.LiningThickness = ye, this.ThresholdDepth = we, this.ThresholdThickness = He, this.TransomThickness = rt, this.TransomOffset = cn, this.LiningOffset = nr, this.ThresholdOffset = Yr, this.CasingThickness = $s, this.CasingDepth = wi, this.ShapeAspectStyle = Ia, this.LiningToPanelOffsetX = va, this.LiningToPanelOffsetY = Vi, this.type = 2963535650;
    }
  }
  r.IfcDoorLiningProperties = fu;
  class tc extends j0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.PanelDepth = Ce, this.PanelOperation = ye, this.PanelWidth = we, this.PanelPosition = He, this.ShapeAspectStyle = rt, this.type = 1714330368;
    }
  }
  r.IfcDoorPanelProperties = tc;
  class zc extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.OperationType = nr, this.ParameterTakesPrecedence = Yr, this.UserDefinedOperationType = $s, this.type = 2323601079;
    }
  }
  r.IfcDoorType = zc;
  class Y6 extends h4 {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 445594917;
    }
  }
  r.IfcDraughtingPreDefinedColour = Y6;
  class H4 extends Uc {
    constructor($, j) {
      super($, j), this.Name = j, this.type = 4006246654;
    }
  }
  r.IfcDraughtingPreDefinedCurveFont = H4;
  class B0 extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1758889154;
    }
  }
  r.IfcElement = B0;
  class Cl extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.AssemblyPlace = rt, this.PredefinedType = cn, this.type = 4123344466;
    }
  }
  r.IfcElementAssembly = Cl;
  class I1 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2397081782;
    }
  }
  r.IfcElementAssemblyType = I1;
  class rl extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1623761950;
    }
  }
  r.IfcElementComponent = rl;
  class X0 extends l0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 2590856083;
    }
  }
  r.IfcElementComponentType = X0;
  class $c extends E1 {
    constructor($, j, Y, K) {
      super($, j), this.Position = j, this.SemiAxis1 = Y, this.SemiAxis2 = K, this.type = 1704287377;
    }
  }
  r.IfcEllipse = $c;
  class Fa extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 2107101300;
    }
  }
  r.IfcEnergyConversionDeviceType = Fa;
  class X6 extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 132023988;
    }
  }
  r.IfcEngineType = X6;
  class V6 extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3174744832;
    }
  }
  r.IfcEvaporativeCoolerType = V6;
  class W6 extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3390157468;
    }
  }
  r.IfcEvaporatorType = W6;
  class p1 extends Hc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.PredefinedType = He, this.EventTriggerType = rt, this.UserDefinedEventTriggerType = cn, this.EventOccurenceTime = nr, this.type = 4148101412;
    }
  }
  r.IfcEvent = p1;
  class q4 extends Qu {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.type = 2853485674;
    }
  }
  r.IfcExternalSpatialStructureElement = q4;
  class k4 extends Bc {
    constructor($, j) {
      super($, j), this.Outer = j, this.type = 807026263;
    }
  }
  r.IfcFacetedBrep = k4;
  class d1 extends k4 {
    constructor($, j, Y) {
      super($, j), this.Outer = j, this.Voids = Y, this.type = 3737207727;
    }
  }
  r.IfcFacetedBrepWithVoids = d1;
  class z6 extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 647756555;
    }
  }
  r.IfcFastener = z6;
  class $6 extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2489546625;
    }
  }
  r.IfcFastenerType = $6;
  class Qc extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 2827207264;
    }
  }
  r.IfcFeatureElement = Qc;
  class Kc extends Qc {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 2143335405;
    }
  }
  r.IfcFeatureElementAddition = Kc;
  class f1 extends Qc {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1287392070;
    }
  }
  r.IfcFeatureElementSubtraction = f1;
  class sl extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3907093117;
    }
  }
  r.IfcFlowControllerType = sl;
  class hl extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3198132628;
    }
  }
  r.IfcFlowFittingType = hl;
  class Y4 extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3815607619;
    }
  }
  r.IfcFlowMeterType = Y4;
  class Jc extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 1482959167;
    }
  }
  r.IfcFlowMovingDeviceType = Jc;
  class nc extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 1834744321;
    }
  }
  r.IfcFlowSegmentType = nc;
  class h1 extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 1339347760;
    }
  }
  r.IfcFlowStorageDeviceType = h1;
  class n0 extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 2297155007;
    }
  }
  r.IfcFlowTerminalType = n0;
  class rc extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 3009222698;
    }
  }
  r.IfcFlowTreatmentDeviceType = rc;
  class X4 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1893162501;
    }
  }
  r.IfcFootingType = X4;
  class S1 extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 263784265;
    }
  }
  r.IfcFurnishingElement = S1;
  class Q6 extends S1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1509553395;
    }
  }
  r.IfcFurniture = Q6;
  class V4 extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3493046030;
    }
  }
  r.IfcGeographicElement = V4;
  class W4 extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.UAxes = He, this.VAxes = rt, this.WAxes = cn, this.PredefinedType = nr, this.type = 3009204131;
    }
  }
  r.IfcGrid = W4;
  class Cu extends G0 {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.type = 2706460486;
    }
  }
  r.IfcGroup = Cu;
  class K6 extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1251058090;
    }
  }
  r.IfcHeatExchangerType = K6;
  class hu extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1806887404;
    }
  }
  r.IfcHumidifierType = hu;
  class J6 extends pu {
    constructor($, j, Y, K) {
      super($), this.Points = j, this.Segments = Y, this.SelfIntersect = K, this.type = 2571569899;
    }
  }
  r.IfcIndexedPolyCurve = J6;
  class qi extends rc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3946677679;
    }
  }
  r.IfcInterceptorType = qi;
  class Z6 extends Y0 {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Curve3D = j, this.AssociatedGeometry = Y, this.MasterRepresentation = K, this.type = 3113134337;
    }
  }
  r.IfcIntersectionCurve = Z6;
  class z4 extends Cu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.PredefinedType = ye, this.Jurisdiction = we, this.ResponsiblePersons = He, this.LastUpdateDate = rt, this.CurrentValue = cn, this.OriginalValue = nr, this.type = 2391368822;
    }
  }
  r.IfcInventory = z4;
  class eI extends hl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4288270099;
    }
  }
  r.IfcJunctionBoxType = eI;
  class Da extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 3827777499;
    }
  }
  r.IfcLaborResource = Da;
  class R1 extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1051575348;
    }
  }
  r.IfcLampType = R1;
  class tI extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1161773419;
    }
  }
  r.IfcLightFixtureType = tI;
  class Zc extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.NominalDiameter = rt, this.NominalLength = cn, this.PredefinedType = nr, this.type = 377706215;
    }
  }
  r.IfcMechanicalFastener = Zc;
  class $4 extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.NominalDiameter = nr, this.NominalLength = Yr, this.type = 2108223431;
    }
  }
  r.IfcMechanicalFastenerType = $4;
  class T1 extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1114901282;
    }
  }
  r.IfcMedicalDeviceType = T1;
  class nI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3181161470;
    }
  }
  r.IfcMemberType = nI;
  class rI extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 977012517;
    }
  }
  r.IfcMotorConnectionType = rI;
  class sI extends G4 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.TheActor = ye, this.PredefinedType = we, this.type = 4143007308;
    }
  }
  r.IfcOccupant = sI;
  class Sl extends f1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3588315303;
    }
  }
  r.IfcOpeningElement = Sl;
  class ol extends Sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3079942009;
    }
  }
  r.IfcOpeningStandardCase = ol;
  class oI extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2837617999;
    }
  }
  r.IfcOutletType = oI;
  class iI extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LifeCyclePhase = we, this.PredefinedType = He, this.type = 2382730787;
    }
  }
  r.IfcPerformanceHistory = iI;
  class aI extends j0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.OperationType = Ce, this.PanelPosition = ye, this.FrameDepth = we, this.FrameThickness = He, this.ShapeAspectStyle = rt, this.type = 3566463478;
    }
  }
  r.IfcPermeableCoveringProperties = aI;
  class lI extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.PredefinedType = we, this.Status = He, this.LongDescription = rt, this.type = 3327091369;
    }
  }
  r.IfcPermit = lI;
  class uI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1158309216;
    }
  }
  r.IfcPileType = uI;
  class cI extends hl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 804291784;
    }
  }
  r.IfcPipeFittingType = cI;
  class EI extends nc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4231323485;
    }
  }
  r.IfcPipeSegmentType = EI;
  class II extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4017108033;
    }
  }
  r.IfcPlateType = II;
  class m1 extends l1 {
    constructor($, j, Y, K, ie) {
      super($, j), this.Coordinates = j, this.Closed = Y, this.Faces = K, this.PnIndex = ie, this.type = 2839578677;
    }
  }
  r.IfcPolygonalFaceSet = m1;
  class pI extends pu {
    constructor($, j) {
      super($), this.Points = j, this.type = 3724593414;
    }
  }
  r.IfcPolyline = pI;
  class e3 extends k0 {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.type = 3740093272;
    }
  }
  r.IfcPort = e3;
  class V0 extends Hc {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.PredefinedType = He, this.type = 2744685151;
    }
  }
  r.IfcProcedure = V0;
  class dI extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.PredefinedType = we, this.Status = He, this.LongDescription = rt, this.type = 2904328755;
    }
  }
  r.IfcProjectOrder = dI;
  class fI extends Kc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3651124850;
    }
  }
  r.IfcProjectionElement = fI;
  class CI extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1842657554;
    }
  }
  r.IfcProtectiveDeviceType = CI;
  class Q4 extends Jc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2250791053;
    }
  }
  r.IfcPumpType = Q4;
  class hI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2893384427;
    }
  }
  r.IfcRailingType = hI;
  class Ja extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2324767716;
    }
  }
  r.IfcRampFlightType = Ja;
  class y1 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1469900589;
    }
  }
  r.IfcRampType = y1;
  class W0 extends x4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr), this.UDegree = j, this.VDegree = Y, this.ControlPointsList = K, this.SurfaceForm = ie, this.UClosed = Ce, this.VClosed = ye, this.SelfIntersect = we, this.UMultiplicities = He, this.VMultiplicities = rt, this.UKnots = cn, this.VKnots = nr, this.KnotSpec = Yr, this.WeightsData = $s, this.type = 683857671;
    }
  }
  r.IfcRationalBSplineSurfaceWithKnots = W0;
  class u0 extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.SteelGrade = rt, this.type = 3027567501;
    }
  }
  r.IfcReinforcingElement = u0;
  class c0 extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 964333572;
    }
  }
  r.IfcReinforcingElementType = c0;
  class SI extends u0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.SteelGrade = rt, this.MeshLength = cn, this.MeshWidth = nr, this.LongitudinalBarNominalDiameter = Yr, this.TransverseBarNominalDiameter = $s, this.LongitudinalBarCrossSectionArea = wi, this.TransverseBarCrossSectionArea = Ia, this.LongitudinalBarSpacing = va, this.TransverseBarSpacing = Vi, this.PredefinedType = g0, this.type = 2320036040;
    }
  }
  r.IfcReinforcingMesh = SI;
  class ba extends c0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi, g0, s3, Wl) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.MeshLength = nr, this.MeshWidth = Yr, this.LongitudinalBarNominalDiameter = $s, this.TransverseBarNominalDiameter = wi, this.LongitudinalBarCrossSectionArea = Ia, this.TransverseBarCrossSectionArea = va, this.LongitudinalBarSpacing = Vi, this.TransverseBarSpacing = g0, this.BendingShapeCode = s3, this.BendingParameters = Wl, this.type = 2310774935;
    }
  }
  r.IfcReinforcingMeshType = ba;
  class RI extends kl {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.RelatingObject = Ce, this.RelatedObjects = ye, this.type = 160246688;
    }
  }
  r.IfcRelAggregates = RI;
  class F1 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2781568857;
    }
  }
  r.IfcRoofType = F1;
  class TI extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1768891740;
    }
  }
  r.IfcSanitaryTerminalType = TI;
  class _I extends Y0 {
    constructor($, j, Y, K) {
      super($, j, Y, K), this.Curve3D = j, this.AssociatedGeometry = Y, this.MasterRepresentation = K, this.type = 2157484638;
    }
  }
  r.IfcSeamCurve = _I;
  class K4 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4074543187;
    }
  }
  r.IfcShadingDeviceType = K4;
  class J4 extends A0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.CompositionType = rt, this.RefLatitude = cn, this.RefLongitude = nr, this.RefElevation = Yr, this.LandTitleNumber = $s, this.SiteAddress = wi, this.type = 4097777520;
    }
  }
  r.IfcSite = J4;
  class mI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2533589738;
    }
  }
  r.IfcSlabType = mI;
  class Su extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1072016465;
    }
  }
  r.IfcSolarDeviceType = Su;
  class Ru extends A0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.CompositionType = rt, this.PredefinedType = cn, this.ElevationWithFlooring = nr, this.type = 3856911033;
    }
  }
  r.IfcSpace = Ru;
  class yI extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1305183839;
    }
  }
  r.IfcSpaceHeaterType = yI;
  class FI extends Vc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.LongName = nr, this.type = 3812236995;
    }
  }
  r.IfcSpaceType = FI;
  class AI extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3112655638;
    }
  }
  r.IfcStackTerminalType = AI;
  class t3 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1039846685;
    }
  }
  r.IfcStairFlightType = t3;
  class Z4 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 338393293;
    }
  }
  r.IfcStairType = Z4;
  class Rl extends Yl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.type = 682877961;
    }
  }
  r.IfcStructuralAction = Rl;
  class R0 extends Ju {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedCondition = He, this.type = 1179482911;
    }
  }
  r.IfcStructuralConnection = R0;
  class Xl extends Rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.ProjectedOrTrue = nr, this.PredefinedType = Yr, this.type = 1004757350;
    }
  }
  r.IfcStructuralCurveAction = Xl;
  class LI extends R0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedCondition = He, this.Axis = rt, this.type = 4243806635;
    }
  }
  r.IfcStructuralCurveConnection = LI;
  class sc extends wa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.PredefinedType = He, this.Axis = rt, this.type = 214636428;
    }
  }
  r.IfcStructuralCurveMember = sc;
  class Tu extends sc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.PredefinedType = He, this.Axis = rt, this.type = 2445595289;
    }
  }
  r.IfcStructuralCurveMemberVarying = Tu;
  class L1 extends Eu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.PredefinedType = cn, this.type = 2757150158;
    }
  }
  r.IfcStructuralCurveReaction = L1;
  class Za extends Xl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.ProjectedOrTrue = nr, this.PredefinedType = Yr, this.type = 1807405624;
    }
  }
  r.IfcStructuralLinearAction = Za;
  class _u extends Cu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.PredefinedType = ye, this.ActionType = we, this.ActionSource = He, this.Coefficient = rt, this.Purpose = cn, this.type = 1252848954;
    }
  }
  r.IfcStructuralLoadGroup = _u;
  class NI extends Rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.type = 2082059205;
    }
  }
  r.IfcStructuralPointAction = NI;
  class N1 extends R0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedCondition = He, this.ConditionCoordinateSystem = rt, this.type = 734778138;
    }
  }
  r.IfcStructuralPointConnection = N1;
  class gI extends Eu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.type = 1235345126;
    }
  }
  r.IfcStructuralPointReaction = gI;
  class OI extends Cu {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.TheoryType = ye, this.ResultForLoadGroup = we, this.IsLinear = He, this.type = 2986769608;
    }
  }
  r.IfcStructuralResultGroup = OI;
  class n3 extends Rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.ProjectedOrTrue = nr, this.PredefinedType = Yr, this.type = 3657597509;
    }
  }
  r.IfcStructuralSurfaceAction = n3;
  class wI extends R0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedCondition = He, this.type = 1975003073;
    }
  }
  r.IfcStructuralSurfaceConnection = wI;
  class DI extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 148013059;
    }
  }
  r.IfcSubContractResource = DI;
  class z0 extends Qc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3101698114;
    }
  }
  r.IfcSurfaceFeature = z0;
  class bI extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2315554128;
    }
  }
  r.IfcSwitchingDeviceType = bI;
  class oc extends Cu {
    constructor($, j, Y, K, ie, Ce) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.type = 2254336722;
    }
  }
  r.IfcSystem = oc;
  class GI extends S1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 413509423;
    }
  }
  r.IfcSystemFurnitureElement = GI;
  class jI extends h1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 5716631;
    }
  }
  r.IfcTankType = jI;
  class MI extends u0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va, Vi) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.SteelGrade = rt, this.PredefinedType = cn, this.NominalDiameter = nr, this.CrossSectionArea = Yr, this.TensionForce = $s, this.PreStress = wi, this.FrictionCoefficient = Ia, this.AnchorageSlip = va, this.MinCurvatureRadius = Vi, this.type = 3824725483;
    }
  }
  r.IfcTendon = MI;
  class xI extends u0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.SteelGrade = rt, this.PredefinedType = cn, this.type = 2347447852;
    }
  }
  r.IfcTendonAnchor = xI;
  class vI extends c0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3081323446;
    }
  }
  r.IfcTendonAnchorType = vI;
  class BI extends c0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.NominalDiameter = nr, this.CrossSectionArea = Yr, this.SheathDiameter = $s, this.type = 2415094496;
    }
  }
  r.IfcTendonType = BI;
  class UI extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1692211062;
    }
  }
  r.IfcTransformerType = UI;
  class HI extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1620046519;
    }
  }
  r.IfcTransportElement = HI;
  class qI extends pu {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.BasisCurve = j, this.Trim1 = Y, this.Trim2 = K, this.SenseAgreement = ie, this.MasterRepresentation = Ce, this.type = 3593883385;
    }
  }
  r.IfcTrimmedCurve = qI;
  class eE extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1600972822;
    }
  }
  r.IfcTubeBundleType = eE;
  class kI extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1911125066;
    }
  }
  r.IfcUnitaryEquipmentType = kI;
  class ic extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 728799441;
    }
  }
  r.IfcValveType = ic;
  class YI extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2391383451;
    }
  }
  r.IfcVibrationIsolator = YI;
  class XI extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3313531582;
    }
  }
  r.IfcVibrationIsolatorType = XI;
  class VI extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 2769231204;
    }
  }
  r.IfcVirtualElement = VI;
  class WI extends f1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 926996030;
    }
  }
  r.IfcVoidingFeature = WI;
  class zI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1898987631;
    }
  }
  r.IfcWallType = zI;
  class $I extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1133259667;
    }
  }
  r.IfcWasteTerminalType = $I;
  class QI extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.PartitioningType = nr, this.ParameterTakesPrecedence = Yr, this.UserDefinedPartitioningType = $s, this.type = 4009809668;
    }
  }
  r.IfcWindowType = QI;
  class KI extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.WorkingTimes = we, this.ExceptionTimes = He, this.PredefinedType = rt, this.type = 4088093105;
    }
  }
  r.IfcWorkCalendar = KI;
  class g1 extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.CreationDate = we, this.Creators = He, this.Purpose = rt, this.Duration = cn, this.TotalFloat = nr, this.StartTime = Yr, this.FinishTime = $s, this.type = 1028945134;
    }
  }
  r.IfcWorkControl = g1;
  class et extends g1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.CreationDate = we, this.Creators = He, this.Purpose = rt, this.Duration = cn, this.TotalFloat = nr, this.StartTime = Yr, this.FinishTime = $s, this.PredefinedType = wi, this.type = 4218914973;
    }
  }
  r.IfcWorkPlan = et;
  class ue extends g1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.CreationDate = we, this.Creators = He, this.Purpose = rt, this.Duration = cn, this.TotalFloat = nr, this.StartTime = Yr, this.FinishTime = $s, this.PredefinedType = wi, this.type = 3342526732;
    }
  }
  r.IfcWorkSchedule = ue;
  class ee extends oc {
    constructor($, j, Y, K, ie, Ce, ye) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.type = 1033361043;
    }
  }
  r.IfcZone = ee;
  class le extends nl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.PredefinedType = we, this.Status = He, this.LongDescription = rt, this.type = 3821786052;
    }
  }
  r.IfcActionRequest = le;
  class he extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1411407467;
    }
  }
  r.IfcAirTerminalBoxType = he;
  class ge extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3352864051;
    }
  }
  r.IfcAirTerminalType = ge;
  class Xe extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1871374353;
    }
  }
  r.IfcAirToAirHeatRecoveryType = Xe;
  class tt extends Cu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.OriginalValue = we, this.CurrentValue = He, this.TotalReplacementCost = rt, this.Owner = cn, this.User = nr, this.ResponsiblePerson = Yr, this.IncorporationDate = $s, this.DepreciatedValue = wi, this.type = 3460190687;
    }
  }
  r.IfcAsset = tt;
  class at extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1532957894;
    }
  }
  r.IfcAudioVisualApplianceType = at;
  class St extends pu {
    constructor($, j, Y, K, ie, Ce) {
      super($), this.Degree = j, this.ControlPointsList = Y, this.CurveForm = K, this.ClosedCurve = ie, this.SelfIntersect = Ce, this.type = 1967976161;
    }
  }
  r.IfcBSplineCurve = St;
  class kt extends St {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce), this.Degree = j, this.ControlPointsList = Y, this.CurveForm = K, this.ClosedCurve = ie, this.SelfIntersect = Ce, this.KnotMultiplicities = ye, this.Knots = we, this.KnotSpec = He, this.type = 2461110595;
    }
  }
  r.IfcBSplineCurveWithKnots = kt;
  class On extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 819618141;
    }
  }
  r.IfcBeamType = On;
  class Gr extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 231477066;
    }
  }
  r.IfcBoilerType = Gr;
  class ys extends c1 {
    constructor($, j, Y) {
      super($, j, Y), this.Segments = j, this.SelfIntersect = Y, this.type = 1136057603;
    }
  }
  r.IfcBoundaryCurve = ys;
  class Fs extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 3299480353;
    }
  }
  r.IfcBuildingElement = Fs;
  class Xo extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2979338954;
    }
  }
  r.IfcBuildingElementPart = Xo;
  class ta extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 39481116;
    }
  }
  r.IfcBuildingElementPartType = ta;
  class E0 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1095909175;
    }
  }
  r.IfcBuildingElementProxy = E0;
  class I0 extends ya {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1909888760;
    }
  }
  r.IfcBuildingElementProxyType = I0;
  class Tl extends oc {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.PredefinedType = ye, this.LongName = we, this.type = 1177604601;
    }
  }
  r.IfcBuildingSystem = Tl;
  class _l extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2188180465;
    }
  }
  r.IfcBurnerType = _l;
  class mu extends hl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 395041908;
    }
  }
  r.IfcCableCarrierFittingType = mu;
  class yu extends nc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3293546465;
    }
  }
  r.IfcCableCarrierSegmentType = yu;
  class Fu extends hl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2674252688;
    }
  }
  r.IfcCableFittingType = Fu;
  class Au extends nc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1285652485;
    }
  }
  r.IfcCableSegmentType = Au;
  class JI extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2951183804;
    }
  }
  r.IfcChillerType = JI;
  class ZI extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3296154744;
    }
  }
  r.IfcChimney = ZI;
  class ep extends E1 {
    constructor($, j, Y) {
      super($, j), this.Position = j, this.Radius = Y, this.type = 2611217952;
    }
  }
  r.IfcCircle = ep;
  class tp extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1677625105;
    }
  }
  r.IfcCivilElement = tp;
  class yp extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2301859152;
    }
  }
  r.IfcCoilType = yp;
  class ac extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 843113511;
    }
  }
  r.IfcColumn = ac;
  class r3 extends ac {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 905975707;
    }
  }
  r.IfcColumnStandardCase = r3;
  class Fp extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 400855858;
    }
  }
  r.IfcCommunicationsApplianceType = Fp;
  class Ap extends Jc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3850581409;
    }
  }
  r.IfcCompressorType = Ap;
  class Lp extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2816379211;
    }
  }
  r.IfcCondenserType = Lp;
  class Np extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 3898045240;
    }
  }
  r.IfcConstructionEquipmentResource = Np;
  class gp extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 1060000209;
    }
  }
  r.IfcConstructionMaterialResource = gp;
  class Op extends fl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.Identification = ye, this.LongDescription = we, this.Usage = He, this.BaseCosts = rt, this.BaseQuantity = cn, this.PredefinedType = nr, this.type = 488727124;
    }
  }
  r.IfcConstructionProductResource = Op;
  class Pp extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 335055490;
    }
  }
  r.IfcCooledBeamType = Pp;
  class wp extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2954562838;
    }
  }
  r.IfcCoolingTowerType = wp;
  class Dp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1973544240;
    }
  }
  r.IfcCovering = Dp;
  class bp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3495092785;
    }
  }
  r.IfcCurtainWall = bp;
  class Gp extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3961806047;
    }
  }
  r.IfcDamperType = Gp;
  class jp extends rl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1335981549;
    }
  }
  r.IfcDiscreteAccessory = jp;
  class Mp extends X0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2635815018;
    }
  }
  r.IfcDiscreteAccessoryType = Mp;
  class xp extends L0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1599208980;
    }
  }
  r.IfcDistributionChamberElementType = xp;
  class Lu extends du {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.type = 2063403501;
    }
  }
  r.IfcDistributionControlElementType = Lu;
  class np extends B0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1945004755;
    }
  }
  r.IfcDistributionElement = np;
  class ml extends np {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 3040386961;
    }
  }
  r.IfcDistributionFlowElement = ml;
  class vp extends e3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.FlowDirection = He, this.PredefinedType = rt, this.SystemType = cn, this.type = 3041715199;
    }
  }
  r.IfcDistributionPort = vp;
  class cp extends oc {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.PredefinedType = we, this.type = 3205830791;
    }
  }
  r.IfcDistributionSystem = cp;
  class Ep extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.OverallHeight = rt, this.OverallWidth = cn, this.PredefinedType = nr, this.OperationType = Yr, this.UserDefinedOperationType = $s, this.type = 395920057;
    }
  }
  r.IfcDoor = Ep;
  class Bp extends Ep {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.OverallHeight = rt, this.OverallWidth = cn, this.PredefinedType = nr, this.OperationType = Yr, this.UserDefinedOperationType = $s, this.type = 3242481149;
    }
  }
  r.IfcDoorStandardCase = Bp;
  class Up extends hl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 869906466;
    }
  }
  r.IfcDuctFittingType = Up;
  class Hp extends nc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3760055223;
    }
  }
  r.IfcDuctSegmentType = Hp;
  class qp extends rc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2030761528;
    }
  }
  r.IfcDuctSilencerType = qp;
  class kp extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 663422040;
    }
  }
  r.IfcElectricApplianceType = kp;
  class Yp extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2417008758;
    }
  }
  r.IfcElectricDistributionBoardType = Yp;
  class tE extends h1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3277789161;
    }
  }
  r.IfcElectricFlowStorageDeviceType = tE;
  class nE extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1534661035;
    }
  }
  r.IfcElectricGeneratorType = nE;
  class Ip extends Fa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1217240411;
    }
  }
  r.IfcElectricMotorType = Ip;
  class Xp extends sl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 712377611;
    }
  }
  r.IfcElectricTimeControlType = Xp;
  class xa extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1658829314;
    }
  }
  r.IfcEnergyConversionDevice = xa;
  class Vp extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2814081492;
    }
  }
  r.IfcEngine = Vp;
  class Wp extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3747195512;
    }
  }
  r.IfcEvaporativeCooler = Wp;
  class zp extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 484807127;
    }
  }
  r.IfcEvaporator = zp;
  class pp extends q4 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.LongName = He, this.PredefinedType = rt, this.type = 1209101575;
    }
  }
  r.IfcExternalSpatialElement = pp;
  class $p extends Jc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 346874300;
    }
  }
  r.IfcFanType = $p;
  class Qp extends rc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1810631287;
    }
  }
  r.IfcFilterType = Qp;
  class Kp extends n0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4222183408;
    }
  }
  r.IfcFireSuppressionTerminalType = Kp;
  class Vl extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 2058353004;
    }
  }
  r.IfcFlowController = Vl;
  class lc extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 4278956645;
    }
  }
  r.IfcFlowFitting = lc;
  class Jp extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 4037862832;
    }
  }
  r.IfcFlowInstrumentType = Jp;
  class Zp extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2188021234;
    }
  }
  r.IfcFlowMeter = Zp;
  class rE extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 3132237377;
    }
  }
  r.IfcFlowMovingDevice = rE;
  class O1 extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 987401354;
    }
  }
  r.IfcFlowSegment = O1;
  class Nu extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 707683696;
    }
  }
  r.IfcFlowStorageDevice = Nu;
  class N0 extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 2223149337;
    }
  }
  r.IfcFlowTerminal = N0;
  class sE extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 3508470533;
    }
  }
  r.IfcFlowTreatmentDevice = sE;
  class e5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 900683007;
    }
  }
  r.IfcFooting = e5;
  class t5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3319311131;
    }
  }
  r.IfcHeatExchanger = t5;
  class n5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2068733104;
    }
  }
  r.IfcHumidifier = n5;
  class r5 extends sE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4175244083;
    }
  }
  r.IfcInterceptor = r5;
  class s5 extends lc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2176052936;
    }
  }
  r.IfcJunctionBox = s5;
  class o5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 76236018;
    }
  }
  r.IfcLamp = o5;
  class i5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 629592764;
    }
  }
  r.IfcLightFixture = i5;
  class a5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1437502449;
    }
  }
  r.IfcMedicalDevice = a5;
  class dp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1073191201;
    }
  }
  r.IfcMember = dp;
  class rp extends dp {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1911478936;
    }
  }
  r.IfcMemberStandardCase = rp;
  class l5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2474470126;
    }
  }
  r.IfcMotorConnection = l5;
  class u5 extends ys {
    constructor($, j, Y) {
      super($, j, Y), this.Segments = j, this.SelfIntersect = Y, this.type = 144952367;
    }
  }
  r.IfcOuterBoundaryCurve = u5;
  class c5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3694346114;
    }
  }
  r.IfcOutlet = c5;
  class E5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.ConstructionType = cn, this.type = 1687234759;
    }
  }
  r.IfcPile = E5;
  class I5 extends lc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 310824031;
    }
  }
  r.IfcPipeFitting = I5;
  class p5 extends O1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3612865200;
    }
  }
  r.IfcPipeSegment = p5;
  class fp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3171933400;
    }
  }
  r.IfcPlate = fp;
  class d5 extends fp {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1156407060;
    }
  }
  r.IfcPlateStandardCase = d5;
  class f5 extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 738039164;
    }
  }
  r.IfcProtectiveDevice = f5;
  class C5 extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 655969474;
    }
  }
  r.IfcProtectiveDeviceTrippingUnitType = C5;
  class h5 extends rE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 90941305;
    }
  }
  r.IfcPump = h5;
  class S5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2262370178;
    }
  }
  r.IfcRailing = S5;
  class R5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3024970846;
    }
  }
  r.IfcRamp = R5;
  class T5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3283111854;
    }
  }
  r.IfcRampFlight = T5;
  class _5 extends kt {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.Degree = j, this.ControlPointsList = Y, this.CurveForm = K, this.ClosedCurve = ie, this.SelfIntersect = Ce, this.KnotMultiplicities = ye, this.Knots = we, this.KnotSpec = He, this.WeightsData = rt, this.type = 1232101972;
    }
  }
  r.IfcRationalBSplineCurveWithKnots = _5;
  class sp extends u0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.SteelGrade = rt, this.NominalDiameter = cn, this.CrossSectionArea = nr, this.BarLength = Yr, this.PredefinedType = $s, this.BarSurface = wi, this.type = 979691226;
    }
  }
  r.IfcReinforcingBar = sp;
  class m5 extends c0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s, wi, Ia, va) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.NominalDiameter = nr, this.CrossSectionArea = Yr, this.BarLength = $s, this.BarSurface = wi, this.BendingShapeCode = Ia, this.BendingParameters = va, this.type = 2572171363;
    }
  }
  r.IfcReinforcingBarType = m5;
  class y5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2016517767;
    }
  }
  r.IfcRoof = y5;
  class F5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3053780830;
    }
  }
  r.IfcSanitaryTerminal = F5;
  class A5 extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 1783015770;
    }
  }
  r.IfcSensorType = A5;
  class L5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1329646415;
    }
  }
  r.IfcShadingDevice = L5;
  class op extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1529196076;
    }
  }
  r.IfcSlab = op;
  class N5 extends op {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3127900445;
    }
  }
  r.IfcSlabElementedCase = N5;
  class g5 extends op {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3027962421;
    }
  }
  r.IfcSlabStandardCase = g5;
  class O5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3420628829;
    }
  }
  r.IfcSolarDevice = O5;
  class P5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1999602285;
    }
  }
  r.IfcSpaceHeater = P5;
  class w5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1404847402;
    }
  }
  r.IfcStackTerminal = w5;
  class D5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 331165859;
    }
  }
  r.IfcStair = D5;
  class b5 extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.NumberOfRisers = rt, this.NumberOfTreads = cn, this.RiserHeight = nr, this.TreadLength = Yr, this.PredefinedType = $s, this.type = 4252922144;
    }
  }
  r.IfcStairFlight = b5;
  class Cp extends oc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.PredefinedType = ye, this.OrientationOf2DPlane = we, this.LoadedBy = He, this.HasResults = rt, this.SharedPlacement = cn, this.type = 2515109513;
    }
  }
  r.IfcStructuralAnalysisModel = Cp;
  class hp extends _u {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.PredefinedType = ye, this.ActionType = we, this.ActionSource = He, this.Coefficient = rt, this.Purpose = cn, this.SelfWeightCoefficients = nr, this.type = 385403989;
    }
  }
  r.IfcStructuralLoadCase = hp;
  class G5 extends n3 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.AppliedLoad = He, this.GlobalOrLocal = rt, this.DestabilizingLoad = cn, this.ProjectedOrTrue = nr, this.PredefinedType = Yr, this.type = 1621171031;
    }
  }
  r.IfcStructuralPlanarAction = G5;
  class j5 extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1162798199;
    }
  }
  r.IfcSwitchingDevice = j5;
  class M5 extends Nu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 812556717;
    }
  }
  r.IfcTank = M5;
  class Sp extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3825984169;
    }
  }
  r.IfcTransformer = Sp;
  class x5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3026737570;
    }
  }
  r.IfcTubeBundle = x5;
  class v5 extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3179687236;
    }
  }
  r.IfcUnitaryControlElementType = v5;
  class B5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4292641817;
    }
  }
  r.IfcUnitaryEquipment = B5;
  class U5 extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4207607924;
    }
  }
  r.IfcValve = U5;
  class ip extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2391406946;
    }
  }
  r.IfcWall = ip;
  class H5 extends ip {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4156078855;
    }
  }
  r.IfcWallElementedCase = H5;
  class q5 extends ip {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3512223829;
    }
  }
  r.IfcWallStandardCase = q5;
  class na extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4237592921;
    }
  }
  r.IfcWasteTerminal = na;
  class Rp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.OverallHeight = rt, this.OverallWidth = cn, this.PredefinedType = nr, this.PartitioningType = Yr, this.UserDefinedPartitioningType = $s, this.type = 3304561284;
    }
  }
  r.IfcWindow = Rp;
  class k5 extends Rp {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt, cn, nr, Yr, $s), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.OverallHeight = rt, this.OverallWidth = cn, this.PredefinedType = nr, this.PartitioningType = Yr, this.UserDefinedPartitioningType = $s, this.type = 486154966;
    }
  }
  r.IfcWindowStandardCase = k5;
  class Y5 extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 2874132201;
    }
  }
  r.IfcActuatorType = Y5;
  class X5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1634111441;
    }
  }
  r.IfcAirTerminal = X5;
  class V5 extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 177149247;
    }
  }
  r.IfcAirTerminalBox = V5;
  class W5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2056796094;
    }
  }
  r.IfcAirToAirHeatRecovery = W5;
  class z5 extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 3001207471;
    }
  }
  r.IfcAlarmType = z5;
  class $5 extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 277319702;
    }
  }
  r.IfcAudioVisualAppliance = $5;
  class Tp extends Fs {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 753842376;
    }
  }
  r.IfcBeam = Tp;
  class Q5 extends Tp {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2906023776;
    }
  }
  r.IfcBeamStandardCase = Q5;
  class K5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 32344328;
    }
  }
  r.IfcBoiler = K5;
  class J5 extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2938176219;
    }
  }
  r.IfcBurner = J5;
  class Z5 extends lc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 635142910;
    }
  }
  r.IfcCableCarrierFitting = Z5;
  class ed extends O1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3758799889;
    }
  }
  r.IfcCableCarrierSegment = ed;
  class td extends lc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1051757585;
    }
  }
  r.IfcCableFitting = td;
  class nd extends O1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4217484030;
    }
  }
  r.IfcCableSegment = nd;
  class rd extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3902619387;
    }
  }
  r.IfcChiller = rd;
  class sd extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 639361253;
    }
  }
  r.IfcCoil = sd;
  class od extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3221913625;
    }
  }
  r.IfcCommunicationsAppliance = od;
  class id extends rE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3571504051;
    }
  }
  r.IfcCompressor = id;
  class ad extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2272882330;
    }
  }
  r.IfcCondenser = ad;
  class ld extends Lu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt, cn) {
      super($, j, Y, K, ie, Ce, ye, we, He, rt), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ApplicableOccurrence = Ce, this.HasPropertySets = ye, this.RepresentationMaps = we, this.Tag = He, this.ElementType = rt, this.PredefinedType = cn, this.type = 578613899;
    }
  }
  r.IfcControllerType = ld;
  class ud extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4136498852;
    }
  }
  r.IfcCooledBeam = ud;
  class cd extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3640358203;
    }
  }
  r.IfcCoolingTower = cd;
  class Ed extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4074379575;
    }
  }
  r.IfcDamper = Ed;
  class Id extends ml {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1052013943;
    }
  }
  r.IfcDistributionChamberElement = Id;
  class ap extends cp {
    constructor($, j, Y, K, ie, Ce, ye, we) {
      super($, j, Y, K, ie, Ce, ye, we), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.LongName = ye, this.PredefinedType = we, this.type = 562808652;
    }
  }
  r.IfcDistributionCircuit = ap;
  class gu extends np {
    constructor($, j, Y, K, ie, Ce, ye, we, He) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.type = 1062813311;
    }
  }
  r.IfcDistributionControlElement = gu;
  class pd extends lc {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 342316401;
    }
  }
  r.IfcDuctFitting = pd;
  class dd extends O1 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3518393246;
    }
  }
  r.IfcDuctSegment = dd;
  class fd extends sE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1360408905;
    }
  }
  r.IfcDuctSilencer = fd;
  class Ou extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1904799276;
    }
  }
  r.IfcElectricAppliance = Ou;
  class lp extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 862014818;
    }
  }
  r.IfcElectricDistributionBoard = lp;
  class yl extends Nu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3310460725;
    }
  }
  r.IfcElectricFlowStorageDevice = yl;
  class Cd extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 264262732;
    }
  }
  r.IfcElectricGenerator = Cd;
  class _p extends xa {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 402227799;
    }
  }
  r.IfcElectricMotor = _p;
  class hd extends Vl {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1003880860;
    }
  }
  r.IfcElectricTimeControl = hd;
  class Sd extends rE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3415622556;
    }
  }
  r.IfcFan = Sd;
  class Rd extends sE {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 819412036;
    }
  }
  r.IfcFilter = Rd;
  class Td extends N0 {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 1426591983;
    }
  }
  r.IfcFireSuppressionTerminal = Td;
  class _d extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 182646315;
    }
  }
  r.IfcFlowInstrument = _d;
  class up extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 2295281155;
    }
  }
  r.IfcProtectiveDeviceTrippingUnit = up;
  class md extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4086658281;
    }
  }
  r.IfcSensor = md;
  class yd extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 630975310;
    }
  }
  r.IfcUnitaryControlElement = yd;
  class Fd extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 4288193352;
    }
  }
  r.IfcActuator = Fd;
  class Ad extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 3087945054;
    }
  }
  r.IfcAlarm = Ad;
  class Ld extends gu {
    constructor($, j, Y, K, ie, Ce, ye, we, He, rt) {
      super($, j, Y, K, ie, Ce, ye, we, He), this.GlobalId = j, this.OwnerHistory = Y, this.Name = K, this.Description = ie, this.ObjectType = Ce, this.ObjectPlacement = ye, this.Representation = we, this.Tag = He, this.PredefinedType = rt, this.type = 25142252;
    }
  }
  r.IfcController = Ld;
})(IFC4 || (IFC4 = {}));
SchemaNames[3] = ["IFC4X3"];
FromRawLineData[3] = {
  3630933823: (r, e) => new IFC4X3.IfcActorRole(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null),
  618182010: (r, e) => new IFC4X3.IfcAddress(r, e[0], e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  2879124712: (r, e) => new IFC4X3.IfcAlignmentParameterSegment(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null),
  3633395639: (r, e) => new IFC4X3.IfcAlignmentVerticalSegment(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new IFC4X3.IfcLengthMeasure(e[2].value), new IFC4X3.IfcNonNegativeLengthMeasure(e[3].value), new IFC4X3.IfcLengthMeasure(e[4].value), new IFC4X3.IfcRatioMeasure(e[5].value), new IFC4X3.IfcRatioMeasure(e[6].value), e[7] ? new IFC4X3.IfcLengthMeasure(e[7].value) : null, e[8]),
  639542469: (r, e) => new IFC4X3.IfcApplication(r, new Handle(e[0].value), new IFC4X3.IfcLabel(e[1].value), new IFC4X3.IfcLabel(e[2].value), new IFC4X3.IfcIdentifier(e[3].value)),
  411424972: (r, e) => new IFC4X3.IfcAppliedValue(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4X3.IfcDate(e[4].value) : null, e[5] ? new IFC4X3.IfcDate(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9] ? e[9].map((s) => new Handle(s.value)) : null),
  130549933: (r, e) => new IFC4X3.IfcApproval(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null, e[3] ? new IFC4X3.IfcDateTime(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  4037036970: (r, e) => new IFC4X3.IfcBoundaryCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  1560379544: (r, e) => new IFC4X3.IfcBoundaryEdgeCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(3, e[1]) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, e[5] ? TypeInitialiser(3, e[5]) : null, e[6] ? TypeInitialiser(3, e[6]) : null),
  3367102660: (r, e) => new IFC4X3.IfcBoundaryFaceCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(3, e[1]) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? TypeInitialiser(3, e[3]) : null),
  1387855156: (r, e) => new IFC4X3.IfcBoundaryNodeCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(3, e[1]) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, e[5] ? TypeInitialiser(3, e[5]) : null, e[6] ? TypeInitialiser(3, e[6]) : null),
  2069777674: (r, e) => new IFC4X3.IfcBoundaryNodeConditionWarping(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? TypeInitialiser(3, e[1]) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, e[5] ? TypeInitialiser(3, e[5]) : null, e[6] ? TypeInitialiser(3, e[6]) : null, e[7] ? TypeInitialiser(3, e[7]) : null),
  2859738748: (r, e) => new IFC4X3.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC4X3.IfcConnectionPointGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  2732653382: (r, e) => new IFC4X3.IfcConnectionSurfaceGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  775493141: (r, e) => new IFC4X3.IfcConnectionVolumeGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1959218052: (r, e) => new IFC4X3.IfcConstraint(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null),
  1785450214: (r, e) => new IFC4X3.IfcCoordinateOperation(r, new Handle(e[0].value), new Handle(e[1].value)),
  1466758467: (r, e) => new IFC4X3.IfcCoordinateReferenceSystem(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new IFC4X3.IfcIdentifier(e[3].value) : null),
  602808272: (r, e) => new IFC4X3.IfcCostValue(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4X3.IfcDate(e[4].value) : null, e[5] ? new IFC4X3.IfcDate(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9] ? e[9].map((s) => new Handle(s.value)) : null),
  1765591967: (r, e) => new IFC4X3.IfcDerivedUnit(r, e[0].map((s) => new Handle(s.value)), e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcLabel(e[3].value) : null),
  1045800335: (r, e) => new IFC4X3.IfcDerivedUnitElement(r, new Handle(e[0].value), e[1].value),
  2949456006: (r, e) => new IFC4X3.IfcDimensionalExponents(r, e[0].value, e[1].value, e[2].value, e[3].value, e[4].value, e[5].value, e[6].value),
  4294318154: (r, e) => new IFC4X3.IfcExternalInformation(r),
  3200245327: (r, e) => new IFC4X3.IfcExternalReference(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  2242383968: (r, e) => new IFC4X3.IfcExternallyDefinedHatchStyle(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  1040185647: (r, e) => new IFC4X3.IfcExternallyDefinedSurfaceStyle(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  3548104201: (r, e) => new IFC4X3.IfcExternallyDefinedTextFont(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  852622518: (r, e) => new IFC4X3.IfcGridAxis(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC4X3.IfcBoolean(e[2].value)),
  3020489413: (r, e) => new IFC4X3.IfcIrregularTimeSeriesValue(r, new IFC4X3.IfcDateTime(e[0].value), e[1].map((s) => TypeInitialiser(3, s))),
  2655187982: (r, e) => new IFC4X3.IfcLibraryInformation(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new IFC4X3.IfcDateTime(e[3].value) : null, e[4] ? new IFC4X3.IfcURIReference(e[4].value) : null, e[5] ? new IFC4X3.IfcText(e[5].value) : null),
  3452421091: (r, e) => new IFC4X3.IfcLibraryReference(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLanguageId(e[4].value) : null, e[5] ? new Handle(e[5].value) : null),
  4162380809: (r, e) => new IFC4X3.IfcLightDistributionData(r, new IFC4X3.IfcPlaneAngleMeasure(e[0].value), e[1].map((s) => new IFC4X3.IfcPlaneAngleMeasure(s.value)), e[2].map((s) => new IFC4X3.IfcLuminousIntensityDistributionMeasure(s.value))),
  1566485204: (r, e) => new IFC4X3.IfcLightIntensityDistribution(r, e[0], e[1].map((s) => new Handle(s.value))),
  3057273783: (r, e) => new IFC4X3.IfcMapConversion(r, new Handle(e[0].value), new Handle(e[1].value), new IFC4X3.IfcLengthMeasure(e[2].value), new IFC4X3.IfcLengthMeasure(e[3].value), new IFC4X3.IfcLengthMeasure(e[4].value), e[5] ? new IFC4X3.IfcReal(e[5].value) : null, e[6] ? new IFC4X3.IfcReal(e[6].value) : null, e[7] ? new IFC4X3.IfcReal(e[7].value) : null, e[8] ? new IFC4X3.IfcReal(e[8].value) : null, e[9] ? new IFC4X3.IfcReal(e[9].value) : null),
  1847130766: (r, e) => new IFC4X3.IfcMaterialClassificationRelationship(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value)),
  760658860: (r, e) => new IFC4X3.IfcMaterialDefinition(r),
  248100487: (r, e) => new IFC4X3.IfcMaterialLayer(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcNonNegativeLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLogical(e[2].value) : null, e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcInteger(e[6].value) : null),
  3303938423: (r, e) => new IFC4X3.IfcMaterialLayerSet(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null),
  1847252529: (r, e) => new IFC4X3.IfcMaterialLayerWithOffsets(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcNonNegativeLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLogical(e[2].value) : null, e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcInteger(e[6].value) : null, e[7], new IFC4X3.IfcLengthMeasure(e[8].value)),
  2199411900: (r, e) => new IFC4X3.IfcMaterialList(r, e[0].map((s) => new Handle(s.value))),
  2235152071: (r, e) => new IFC4X3.IfcMaterialProfile(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4X3.IfcInteger(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null),
  164193824: (r, e) => new IFC4X3.IfcMaterialProfileSet(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new Handle(e[3].value) : null),
  552965576: (r, e) => new IFC4X3.IfcMaterialProfileWithOffsets(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4X3.IfcInteger(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, new IFC4X3.IfcLengthMeasure(e[6].value)),
  1507914824: (r, e) => new IFC4X3.IfcMaterialUsageDefinition(r),
  2597039031: (r, e) => new IFC4X3.IfcMeasureWithUnit(r, TypeInitialiser(3, e[0]), new Handle(e[1].value)),
  3368373690: (r, e) => new IFC4X3.IfcMetric(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7], e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  2706619895: (r, e) => new IFC4X3.IfcMonetaryUnit(r, new IFC4X3.IfcLabel(e[0].value)),
  1918398963: (r, e) => new IFC4X3.IfcNamedUnit(r, new Handle(e[0].value), e[1]),
  3701648758: (r, e) => new IFC4X3.IfcObjectPlacement(r, e[0] ? new Handle(e[0].value) : null),
  2251480897: (r, e) => new IFC4X3.IfcObjective(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2], e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8], e[9], e[10] ? new IFC4X3.IfcLabel(e[10].value) : null),
  4251960020: (r, e) => new IFC4X3.IfcOrganization(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, new IFC4X3.IfcLabel(e[1].value), e[2] ? new IFC4X3.IfcText(e[2].value) : null, e[3] ? e[3].map((s) => new Handle(s.value)) : null, e[4] ? e[4].map((s) => new Handle(s.value)) : null),
  1207048766: (r, e) => new IFC4X3.IfcOwnerHistory(r, new Handle(e[0].value), new Handle(e[1].value), e[2], e[3], e[4] ? new IFC4X3.IfcTimeStamp(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new IFC4X3.IfcTimeStamp(e[7].value)),
  2077209135: (r, e) => new IFC4X3.IfcPerson(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[5] ? e[5].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  101040310: (r, e) => new IFC4X3.IfcPersonAndOrganization(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2483315170: (r, e) => new IFC4X3.IfcPhysicalQuantity(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null),
  2226359599: (r, e) => new IFC4X3.IfcPhysicalSimpleQuantity(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  3355820592: (r, e) => new IFC4X3.IfcPostalAddress(r, e[0], e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcLabel(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcLabel(e[9].value) : null),
  677532197: (r, e) => new IFC4X3.IfcPresentationItem(r),
  2022622350: (r, e) => new IFC4X3.IfcPresentationLayerAssignment(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4X3.IfcIdentifier(e[3].value) : null),
  1304840413: (r, e) => new IFC4X3.IfcPresentationLayerWithStyle(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4X3.IfcIdentifier(e[3].value) : null, new IFC4X3.IfcLogical(e[4].value), new IFC4X3.IfcLogical(e[5].value), new IFC4X3.IfcLogical(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  3119450353: (r, e) => new IFC4X3.IfcPresentationStyle(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  2095639259: (r, e) => new IFC4X3.IfcProductRepresentation(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  3958567839: (r, e) => new IFC4X3.IfcProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null),
  3843373140: (r, e) => new IFC4X3.IfcProjectedCRS(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new IFC4X3.IfcIdentifier(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  986844984: (r, e) => new IFC4X3.IfcPropertyAbstraction(r),
  3710013099: (r, e) => new IFC4X3.IfcPropertyEnumeration(r, new IFC4X3.IfcLabel(e[0].value), e[1].map((s) => TypeInitialiser(3, s)), e[2] ? new Handle(e[2].value) : null),
  2044713172: (r, e) => new IFC4X3.IfcQuantityArea(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcAreaMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  2093928680: (r, e) => new IFC4X3.IfcQuantityCount(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcCountMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  931644368: (r, e) => new IFC4X3.IfcQuantityLength(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcLengthMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  2691318326: (r, e) => new IFC4X3.IfcQuantityNumber(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcNumericMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  3252649465: (r, e) => new IFC4X3.IfcQuantityTime(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcTimeMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  2405470396: (r, e) => new IFC4X3.IfcQuantityVolume(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcVolumeMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  825690147: (r, e) => new IFC4X3.IfcQuantityWeight(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcMassMeasure(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  3915482550: (r, e) => new IFC4X3.IfcRecurrencePattern(r, e[0], e[1] ? e[1].map((s) => new IFC4X3.IfcDayInMonthNumber(s.value)) : null, e[2] ? e[2].map((s) => new IFC4X3.IfcDayInWeekNumber(s.value)) : null, e[3] ? e[3].map((s) => new IFC4X3.IfcMonthInYearNumber(s.value)) : null, e[4] ? new IFC4X3.IfcInteger(e[4].value) : null, e[5] ? new IFC4X3.IfcInteger(e[5].value) : null, e[6] ? new IFC4X3.IfcInteger(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null),
  2433181523: (r, e) => new IFC4X3.IfcReference(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4X3.IfcInteger(s.value)) : null, e[4] ? new Handle(e[4].value) : null),
  1076942058: (r, e) => new IFC4X3.IfcRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3377609919: (r, e) => new IFC4X3.IfcRepresentationContext(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null),
  3008791417: (r, e) => new IFC4X3.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC4X3.IfcRepresentationMap(r, new Handle(e[0].value), new Handle(e[1].value)),
  2439245199: (r, e) => new IFC4X3.IfcResourceLevelRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null),
  2341007311: (r, e) => new IFC4X3.IfcRoot(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  448429030: (r, e) => new IFC4X3.IfcSIUnit(r, new Handle(e[0].value), e[1], e[2], e[3]),
  1054537805: (r, e) => new IFC4X3.IfcSchedulingTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  867548509: (r, e) => new IFC4X3.IfcShapeAspect(r, e[0].map((s) => new Handle(s.value)), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null, new IFC4X3.IfcLogical(e[3].value), e[4] ? new Handle(e[4].value) : null),
  3982875396: (r, e) => new IFC4X3.IfcShapeModel(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  4240577450: (r, e) => new IFC4X3.IfcShapeRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  2273995522: (r, e) => new IFC4X3.IfcStructuralConnectionCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  2162789131: (r, e) => new IFC4X3.IfcStructuralLoad(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  3478079324: (r, e) => new IFC4X3.IfcStructuralLoadConfiguration(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? e[2].map((s) => new IFC4X3.IfcLengthMeasure(s.value)) : null),
  609421318: (r, e) => new IFC4X3.IfcStructuralLoadOrResult(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  2525727697: (r, e) => new IFC4X3.IfcStructuralLoadStatic(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  3408363356: (r, e) => new IFC4X3.IfcStructuralLoadTemperature(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcThermodynamicTemperatureMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcThermodynamicTemperatureMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcThermodynamicTemperatureMeasure(e[3].value) : null),
  2830218821: (r, e) => new IFC4X3.IfcStyleModel(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  3958052878: (r, e) => new IFC4X3.IfcStyledItem(r, e[0] ? new Handle(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  3049322572: (r, e) => new IFC4X3.IfcStyledRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  2934153892: (r, e) => new IFC4X3.IfcSurfaceReinforcementArea(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? e[1].map((s) => new IFC4X3.IfcLengthMeasure(s.value)) : null, e[2] ? e[2].map((s) => new IFC4X3.IfcLengthMeasure(s.value)) : null, e[3] ? new IFC4X3.IfcRatioMeasure(e[3].value) : null),
  1300840506: (r, e) => new IFC4X3.IfcSurfaceStyle(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2].map((s) => new Handle(s.value))),
  3303107099: (r, e) => new IFC4X3.IfcSurfaceStyleLighting(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new Handle(e[3].value)),
  1607154358: (r, e) => new IFC4X3.IfcSurfaceStyleRefraction(r, e[0] ? new IFC4X3.IfcReal(e[0].value) : null, e[1] ? new IFC4X3.IfcReal(e[1].value) : null),
  846575682: (r, e) => new IFC4X3.IfcSurfaceStyleShading(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcNormalisedRatioMeasure(e[1].value) : null),
  1351298697: (r, e) => new IFC4X3.IfcSurfaceStyleWithTextures(r, e[0].map((s) => new Handle(s.value))),
  626085974: (r, e) => new IFC4X3.IfcSurfaceTexture(r, new IFC4X3.IfcBoolean(e[0].value), new IFC4X3.IfcBoolean(e[1].value), e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcIdentifier(s.value)) : null),
  985171141: (r, e) => new IFC4X3.IfcTable(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? e[1].map((s) => new Handle(s.value)) : null, e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2043862942: (r, e) => new IFC4X3.IfcTableColumn(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  531007025: (r, e) => new IFC4X3.IfcTableRow(r, e[0] ? e[0].map((s) => TypeInitialiser(3, s)) : null, e[1] ? new IFC4X3.IfcBoolean(e[1].value) : null),
  1549132990: (r, e) => new IFC4X3.IfcTaskTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3], e[4] ? new IFC4X3.IfcDuration(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcDateTime(e[6].value) : null, e[7] ? new IFC4X3.IfcDateTime(e[7].value) : null, e[8] ? new IFC4X3.IfcDateTime(e[8].value) : null, e[9] ? new IFC4X3.IfcDateTime(e[9].value) : null, e[10] ? new IFC4X3.IfcDateTime(e[10].value) : null, e[11] ? new IFC4X3.IfcDuration(e[11].value) : null, e[12] ? new IFC4X3.IfcDuration(e[12].value) : null, e[13] ? new IFC4X3.IfcBoolean(e[13].value) : null, e[14] ? new IFC4X3.IfcDateTime(e[14].value) : null, e[15] ? new IFC4X3.IfcDuration(e[15].value) : null, e[16] ? new IFC4X3.IfcDateTime(e[16].value) : null, e[17] ? new IFC4X3.IfcDateTime(e[17].value) : null, e[18] ? new IFC4X3.IfcDuration(e[18].value) : null, e[19] ? new IFC4X3.IfcPositiveRatioMeasure(e[19].value) : null),
  2771591690: (r, e) => new IFC4X3.IfcTaskTimeRecurring(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3], e[4] ? new IFC4X3.IfcDuration(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcDateTime(e[6].value) : null, e[7] ? new IFC4X3.IfcDateTime(e[7].value) : null, e[8] ? new IFC4X3.IfcDateTime(e[8].value) : null, e[9] ? new IFC4X3.IfcDateTime(e[9].value) : null, e[10] ? new IFC4X3.IfcDateTime(e[10].value) : null, e[11] ? new IFC4X3.IfcDuration(e[11].value) : null, e[12] ? new IFC4X3.IfcDuration(e[12].value) : null, e[13] ? new IFC4X3.IfcBoolean(e[13].value) : null, e[14] ? new IFC4X3.IfcDateTime(e[14].value) : null, e[15] ? new IFC4X3.IfcDuration(e[15].value) : null, e[16] ? new IFC4X3.IfcDateTime(e[16].value) : null, e[17] ? new IFC4X3.IfcDateTime(e[17].value) : null, e[18] ? new IFC4X3.IfcDuration(e[18].value) : null, e[19] ? new IFC4X3.IfcPositiveRatioMeasure(e[19].value) : null, new Handle(e[20].value)),
  912023232: (r, e) => new IFC4X3.IfcTelecomAddress(r, e[0], e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? e[3].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? e[6].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[7] ? new IFC4X3.IfcURIReference(e[7].value) : null, e[8] ? e[8].map((s) => new IFC4X3.IfcURIReference(s.value)) : null),
  1447204868: (r, e) => new IFC4X3.IfcTextStyle(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4X3.IfcBoolean(e[4].value) : null),
  2636378356: (r, e) => new IFC4X3.IfcTextStyleForDefinedFont(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1640371178: (r, e) => new IFC4X3.IfcTextStyleTextModel(r, e[0] ? TypeInitialiser(3, e[0]) : null, e[1] ? new IFC4X3.IfcTextAlignment(e[1].value) : null, e[2] ? new IFC4X3.IfcTextDecoration(e[2].value) : null, e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, e[5] ? new IFC4X3.IfcTextTransformation(e[5].value) : null, e[6] ? TypeInitialiser(3, e[6]) : null),
  280115917: (r, e) => new IFC4X3.IfcTextureCoordinate(r, e[0].map((s) => new Handle(s.value))),
  1742049831: (r, e) => new IFC4X3.IfcTextureCoordinateGenerator(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLabel(e[1].value), e[2] ? e[2].map((s) => new IFC4X3.IfcReal(s.value)) : null),
  222769930: (r, e) => new IFC4X3.IfcTextureCoordinateIndices(r, e[0].map((s) => new IFC4X3.IfcPositiveInteger(s.value)), new Handle(e[1].value)),
  1010789467: (r, e) => new IFC4X3.IfcTextureCoordinateIndicesWithVoids(r, e[0].map((s) => new IFC4X3.IfcPositiveInteger(s.value)), new Handle(e[1].value), e[2].map((s) => new IFC4X3.IfcPositiveInteger(s.value))),
  2552916305: (r, e) => new IFC4X3.IfcTextureMap(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new Handle(s.value)), new Handle(e[2].value)),
  1210645708: (r, e) => new IFC4X3.IfcTextureVertex(r, e[0].map((s) => new IFC4X3.IfcParameterValue(s.value))),
  3611470254: (r, e) => new IFC4X3.IfcTextureVertexList(r, e[0].map((s) => new IFC4X3.IfcParameterValue(s.value))),
  1199560280: (r, e) => new IFC4X3.IfcTimePeriod(r, new IFC4X3.IfcTime(e[0].value), new IFC4X3.IfcTime(e[1].value)),
  3101149627: (r, e) => new IFC4X3.IfcTimeSeries(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, new IFC4X3.IfcDateTime(e[2].value), new IFC4X3.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  581633288: (r, e) => new IFC4X3.IfcTimeSeriesValue(r, e[0].map((s) => TypeInitialiser(3, s))),
  1377556343: (r, e) => new IFC4X3.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC4X3.IfcTopologyRepresentation(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3].map((s) => new Handle(s.value))),
  180925521: (r, e) => new IFC4X3.IfcUnitAssignment(r, e[0].map((s) => new Handle(s.value))),
  2799835756: (r, e) => new IFC4X3.IfcVertex(r),
  1907098498: (r, e) => new IFC4X3.IfcVertexPoint(r, new Handle(e[0].value)),
  891718957: (r, e) => new IFC4X3.IfcVirtualGridIntersection(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new IFC4X3.IfcLengthMeasure(s.value))),
  1236880293: (r, e) => new IFC4X3.IfcWorkTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4X3.IfcDate(e[4].value) : null, e[5] ? new IFC4X3.IfcDate(e[5].value) : null),
  3752311538: (r, e) => new IFC4X3.IfcAlignmentCantSegment(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new IFC4X3.IfcLengthMeasure(e[2].value), new IFC4X3.IfcNonNegativeLengthMeasure(e[3].value), new IFC4X3.IfcLengthMeasure(e[4].value), e[5] ? new IFC4X3.IfcLengthMeasure(e[5].value) : null, new IFC4X3.IfcLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcLengthMeasure(e[7].value) : null, e[8]),
  536804194: (r, e) => new IFC4X3.IfcAlignmentHorizontalSegment(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPlaneAngleMeasure(e[3].value), new IFC4X3.IfcLengthMeasure(e[4].value), new IFC4X3.IfcLengthMeasure(e[5].value), new IFC4X3.IfcNonNegativeLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8]),
  3869604511: (r, e) => new IFC4X3.IfcApprovalRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  3798115385: (r, e) => new IFC4X3.IfcArbitraryClosedProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  1310608509: (r, e) => new IFC4X3.IfcArbitraryOpenProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value)),
  2705031697: (r, e) => new IFC4X3.IfcArbitraryProfileDefWithVoids(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  616511568: (r, e) => new IFC4X3.IfcBlobTexture(r, new IFC4X3.IfcBoolean(e[0].value), new IFC4X3.IfcBoolean(e[1].value), e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcIdentifier(s.value)) : null, new IFC4X3.IfcIdentifier(e[5].value), new IFC4X3.IfcBinary(e[6].value)),
  3150382593: (r, e) => new IFC4X3.IfcCenterLineProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  747523909: (r, e) => new IFC4X3.IfcClassification(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new IFC4X3.IfcDate(e[2].value) : null, new IFC4X3.IfcLabel(e[3].value), e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new IFC4X3.IfcURIReference(e[5].value) : null, e[6] ? e[6].map((s) => new IFC4X3.IfcIdentifier(s.value)) : null),
  647927063: (r, e) => new IFC4X3.IfcClassificationReference(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null),
  3285139300: (r, e) => new IFC4X3.IfcColourRgbList(r, e[0].map((s) => new IFC4X3.IfcNormalisedRatioMeasure(s.value))),
  3264961684: (r, e) => new IFC4X3.IfcColourSpecification(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null),
  1485152156: (r, e) => new IFC4X3.IfcCompositeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? new IFC4X3.IfcLabel(e[3].value) : null),
  370225590: (r, e) => new IFC4X3.IfcConnectedFaceSet(r, e[0].map((s) => new Handle(s.value))),
  1981873012: (r, e) => new IFC4X3.IfcConnectionCurveGeometry(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  45288368: (r, e) => new IFC4X3.IfcConnectionPointEccentricity(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcLengthMeasure(e[4].value) : null),
  3050246964: (r, e) => new IFC4X3.IfcContextDependentUnit(r, new Handle(e[0].value), e[1], new IFC4X3.IfcLabel(e[2].value)),
  2889183280: (r, e) => new IFC4X3.IfcConversionBasedUnit(r, new Handle(e[0].value), e[1], new IFC4X3.IfcLabel(e[2].value), new Handle(e[3].value)),
  2713554722: (r, e) => new IFC4X3.IfcConversionBasedUnitWithOffset(r, new Handle(e[0].value), e[1], new IFC4X3.IfcLabel(e[2].value), new Handle(e[3].value), new IFC4X3.IfcReal(e[4].value)),
  539742890: (r, e) => new IFC4X3.IfcCurrencyRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), new IFC4X3.IfcPositiveRatioMeasure(e[4].value), e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3800577675: (r, e) => new IFC4X3.IfcCurveStyle(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new IFC4X3.IfcBoolean(e[4].value) : null),
  1105321065: (r, e) => new IFC4X3.IfcCurveStyleFont(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value))),
  2367409068: (r, e) => new IFC4X3.IfcCurveStyleFontAndScaling(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), new IFC4X3.IfcPositiveRatioMeasure(e[2].value)),
  3510044353: (r, e) => new IFC4X3.IfcCurveStyleFontPattern(r, new IFC4X3.IfcLengthMeasure(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value)),
  3632507154: (r, e) => new IFC4X3.IfcDerivedProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  1154170062: (r, e) => new IFC4X3.IfcDocumentInformation(r, new IFC4X3.IfcIdentifier(e[0].value), new IFC4X3.IfcLabel(e[1].value), e[2] ? new IFC4X3.IfcText(e[2].value) : null, e[3] ? new IFC4X3.IfcURIReference(e[3].value) : null, e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new IFC4X3.IfcText(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new IFC4X3.IfcDateTime(e[10].value) : null, e[11] ? new IFC4X3.IfcDateTime(e[11].value) : null, e[12] ? new IFC4X3.IfcIdentifier(e[12].value) : null, e[13] ? new IFC4X3.IfcDate(e[13].value) : null, e[14] ? new IFC4X3.IfcDate(e[14].value) : null, e[15], e[16]),
  770865208: (r, e) => new IFC4X3.IfcDocumentInformationRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value)), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  3732053477: (r, e) => new IFC4X3.IfcDocumentReference(r, e[0] ? new IFC4X3.IfcURIReference(e[0].value) : null, e[1] ? new IFC4X3.IfcIdentifier(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  3900360178: (r, e) => new IFC4X3.IfcEdge(r, new Handle(e[0].value), new Handle(e[1].value)),
  476780140: (r, e) => new IFC4X3.IfcEdgeCurve(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value), new IFC4X3.IfcBoolean(e[3].value)),
  211053100: (r, e) => new IFC4X3.IfcEventTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcDateTime(e[3].value) : null, e[4] ? new IFC4X3.IfcDateTime(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcDateTime(e[6].value) : null),
  297599258: (r, e) => new IFC4X3.IfcExtendedProperties(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  1437805879: (r, e) => new IFC4X3.IfcExternalReferenceRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  2556980723: (r, e) => new IFC4X3.IfcFace(r, e[0].map((s) => new Handle(s.value))),
  1809719519: (r, e) => new IFC4X3.IfcFaceBound(r, new Handle(e[0].value), new IFC4X3.IfcBoolean(e[1].value)),
  803316827: (r, e) => new IFC4X3.IfcFaceOuterBound(r, new Handle(e[0].value), new IFC4X3.IfcBoolean(e[1].value)),
  3008276851: (r, e) => new IFC4X3.IfcFaceSurface(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new IFC4X3.IfcBoolean(e[2].value)),
  4219587988: (r, e) => new IFC4X3.IfcFailureConnectionCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcForceMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcForceMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcForceMeasure(e[6].value) : null),
  738692330: (r, e) => new IFC4X3.IfcFillAreaStyle(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1].map((s) => new Handle(s.value)), e[2] ? new IFC4X3.IfcBoolean(e[2].value) : null),
  3448662350: (r, e) => new IFC4X3.IfcGeometricRepresentationContext(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new IFC4X3.IfcDimensionCount(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null),
  2453401579: (r, e) => new IFC4X3.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC4X3.IfcGeometricRepresentationSubContext(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null),
  3590301190: (r, e) => new IFC4X3.IfcGeometricSet(r, e[0].map((s) => new Handle(s.value))),
  178086475: (r, e) => new IFC4X3.IfcGridPlacement(r, e[0] ? new Handle(e[0].value) : null, new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null),
  812098782: (r, e) => new IFC4X3.IfcHalfSpaceSolid(r, new Handle(e[0].value), new IFC4X3.IfcBoolean(e[1].value)),
  3905492369: (r, e) => new IFC4X3.IfcImageTexture(r, new IFC4X3.IfcBoolean(e[0].value), new IFC4X3.IfcBoolean(e[1].value), e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcIdentifier(s.value)) : null, new IFC4X3.IfcURIReference(e[5].value)),
  3570813810: (r, e) => new IFC4X3.IfcIndexedColourMap(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcNormalisedRatioMeasure(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new IFC4X3.IfcPositiveInteger(s.value))),
  1437953363: (r, e) => new IFC4X3.IfcIndexedTextureMap(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new Handle(e[2].value)),
  2133299955: (r, e) => new IFC4X3.IfcIndexedTriangleTextureMap(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new Handle(e[2].value), e[3] ? e[3].map((s) => new IFC4X3.IfcPositiveInteger(s.value)) : null),
  3741457305: (r, e) => new IFC4X3.IfcIrregularTimeSeries(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, new IFC4X3.IfcDateTime(e[2].value), new IFC4X3.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8].map((s) => new Handle(s.value))),
  1585845231: (r, e) => new IFC4X3.IfcLagTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, TypeInitialiser(3, e[3]), e[4]),
  1402838566: (r, e) => new IFC4X3.IfcLightSource(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null),
  125510826: (r, e) => new IFC4X3.IfcLightSourceAmbient(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null),
  2604431987: (r, e) => new IFC4X3.IfcLightSourceDirectional(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value)),
  4266656042: (r, e) => new IFC4X3.IfcLightSourceGoniometric(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), e[5] ? new Handle(e[5].value) : null, new IFC4X3.IfcThermodynamicTemperatureMeasure(e[6].value), new IFC4X3.IfcLuminousFluxMeasure(e[7].value), e[8], new Handle(e[9].value)),
  1520743889: (r, e) => new IFC4X3.IfcLightSourcePositional(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcReal(e[6].value), new IFC4X3.IfcReal(e[7].value), new IFC4X3.IfcReal(e[8].value)),
  3422422726: (r, e) => new IFC4X3.IfcLightSourceSpot(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new Handle(e[1].value), e[2] ? new IFC4X3.IfcNormalisedRatioMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null, new Handle(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcReal(e[6].value), new IFC4X3.IfcReal(e[7].value), new IFC4X3.IfcReal(e[8].value), new Handle(e[9].value), e[10] ? new IFC4X3.IfcReal(e[10].value) : null, new IFC4X3.IfcPositivePlaneAngleMeasure(e[11].value), new IFC4X3.IfcPositivePlaneAngleMeasure(e[12].value)),
  388784114: (r, e) => new IFC4X3.IfcLinearPlacement(r, e[0] ? new Handle(e[0].value) : null, new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null),
  2624227202: (r, e) => new IFC4X3.IfcLocalPlacement(r, e[0] ? new Handle(e[0].value) : null, new Handle(e[1].value)),
  1008929658: (r, e) => new IFC4X3.IfcLoop(r),
  2347385850: (r, e) => new IFC4X3.IfcMappedItem(r, new Handle(e[0].value), new Handle(e[1].value)),
  1838606355: (r, e) => new IFC4X3.IfcMaterial(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  3708119e3: (r, e) => new IFC4X3.IfcMaterialConstituent(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcNormalisedRatioMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  2852063980: (r, e) => new IFC4X3.IfcMaterialConstituentSet(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2022407955: (r, e) => new IFC4X3.IfcMaterialDefinitionRepresentation(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  1303795690: (r, e) => new IFC4X3.IfcMaterialLayerSetUsage(r, new Handle(e[0].value), e[1], e[2], new IFC4X3.IfcLengthMeasure(e[3].value), e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null),
  3079605661: (r, e) => new IFC4X3.IfcMaterialProfileSetUsage(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcCardinalPointReference(e[1].value) : null, e[2] ? new IFC4X3.IfcPositiveLengthMeasure(e[2].value) : null),
  3404854881: (r, e) => new IFC4X3.IfcMaterialProfileSetUsageTapering(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcCardinalPointReference(e[1].value) : null, e[2] ? new IFC4X3.IfcPositiveLengthMeasure(e[2].value) : null, new Handle(e[3].value), e[4] ? new IFC4X3.IfcCardinalPointReference(e[4].value) : null),
  3265635763: (r, e) => new IFC4X3.IfcMaterialProperties(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  853536259: (r, e) => new IFC4X3.IfcMaterialRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value)), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  2998442950: (r, e) => new IFC4X3.IfcMirroredProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  219451334: (r, e) => new IFC4X3.IfcObjectDefinition(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  182550632: (r, e) => new IFC4X3.IfcOpenCrossProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, new IFC4X3.IfcBoolean(e[2].value), e[3].map((s) => new IFC4X3.IfcNonNegativeLengthMeasure(s.value)), e[4].map((s) => new IFC4X3.IfcPlaneAngleMeasure(s.value)), e[5] ? e[5].map((s) => new IFC4X3.IfcLabel(s.value)) : null, e[6] ? new Handle(e[6].value) : null),
  2665983363: (r, e) => new IFC4X3.IfcOpenShell(r, e[0].map((s) => new Handle(s.value))),
  1411181986: (r, e) => new IFC4X3.IfcOrganizationRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1029017970: (r, e) => new IFC4X3.IfcOrientedEdge(r, new Handle(e[0].value), new Handle(e[1].value), new IFC4X3.IfcBoolean(e[2].value)),
  2529465313: (r, e) => new IFC4X3.IfcParameterizedProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  2519244187: (r, e) => new IFC4X3.IfcPath(r, e[0].map((s) => new Handle(s.value))),
  3021840470: (r, e) => new IFC4X3.IfcPhysicalComplexQuantity(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new IFC4X3.IfcLabel(e[3].value), e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null),
  597895409: (r, e) => new IFC4X3.IfcPixelTexture(r, new IFC4X3.IfcBoolean(e[0].value), new IFC4X3.IfcBoolean(e[1].value), e[2] ? new IFC4X3.IfcIdentifier(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? e[4].map((s) => new IFC4X3.IfcIdentifier(s.value)) : null, new IFC4X3.IfcInteger(e[5].value), new IFC4X3.IfcInteger(e[6].value), new IFC4X3.IfcInteger(e[7].value), e[8].map((s) => new IFC4X3.IfcBinary(s.value))),
  2004835150: (r, e) => new IFC4X3.IfcPlacement(r, new Handle(e[0].value)),
  1663979128: (r, e) => new IFC4X3.IfcPlanarExtent(r, new IFC4X3.IfcLengthMeasure(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value)),
  2067069095: (r, e) => new IFC4X3.IfcPoint(r),
  2165702409: (r, e) => new IFC4X3.IfcPointByDistanceExpression(r, TypeInitialiser(3, e[0]), e[1] ? new IFC4X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, new Handle(e[4].value)),
  4022376103: (r, e) => new IFC4X3.IfcPointOnCurve(r, new Handle(e[0].value), new IFC4X3.IfcParameterValue(e[1].value)),
  1423911732: (r, e) => new IFC4X3.IfcPointOnSurface(r, new Handle(e[0].value), new IFC4X3.IfcParameterValue(e[1].value), new IFC4X3.IfcParameterValue(e[2].value)),
  2924175390: (r, e) => new IFC4X3.IfcPolyLoop(r, e[0].map((s) => new Handle(s.value))),
  2775532180: (r, e) => new IFC4X3.IfcPolygonalBoundedHalfSpace(r, new Handle(e[0].value), new IFC4X3.IfcBoolean(e[1].value), new Handle(e[2].value), new Handle(e[3].value)),
  3727388367: (r, e) => new IFC4X3.IfcPreDefinedItem(r, new IFC4X3.IfcLabel(e[0].value)),
  3778827333: (r, e) => new IFC4X3.IfcPreDefinedProperties(r),
  1775413392: (r, e) => new IFC4X3.IfcPreDefinedTextFont(r, new IFC4X3.IfcLabel(e[0].value)),
  673634403: (r, e) => new IFC4X3.IfcProductDefinitionShape(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value))),
  2802850158: (r, e) => new IFC4X3.IfcProfileProperties(r, e[0] ? new IFC4X3.IfcIdentifier(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  2598011224: (r, e) => new IFC4X3.IfcProperty(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null),
  1680319473: (r, e) => new IFC4X3.IfcPropertyDefinition(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  148025276: (r, e) => new IFC4X3.IfcPropertyDependencyRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), new Handle(e[3].value), e[4] ? new IFC4X3.IfcText(e[4].value) : null),
  3357820518: (r, e) => new IFC4X3.IfcPropertySetDefinition(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  1482703590: (r, e) => new IFC4X3.IfcPropertyTemplateDefinition(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  2090586900: (r, e) => new IFC4X3.IfcQuantitySet(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  3615266464: (r, e) => new IFC4X3.IfcRectangleProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value)),
  3413951693: (r, e) => new IFC4X3.IfcRegularTimeSeries(r, new IFC4X3.IfcLabel(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, new IFC4X3.IfcDateTime(e[2].value), new IFC4X3.IfcDateTime(e[3].value), e[4], e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new IFC4X3.IfcTimeMeasure(e[8].value), e[9].map((s) => new Handle(s.value))),
  1580146022: (r, e) => new IFC4X3.IfcReinforcementBarProperties(r, new IFC4X3.IfcAreaMeasure(e[0].value), new IFC4X3.IfcLabel(e[1].value), e[2], e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcCountMeasure(e[5].value) : null),
  478536968: (r, e) => new IFC4X3.IfcRelationship(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  2943643501: (r, e) => new IFC4X3.IfcResourceApprovalRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2].map((s) => new Handle(s.value)), new Handle(e[3].value)),
  1608871552: (r, e) => new IFC4X3.IfcResourceConstraintRelationship(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcText(e[1].value) : null, new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  1042787934: (r, e) => new IFC4X3.IfcResourceTime(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1], e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcDuration(e[3].value) : null, e[4] ? new IFC4X3.IfcPositiveRatioMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcDateTime(e[5].value) : null, e[6] ? new IFC4X3.IfcDateTime(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcDuration(e[8].value) : null, e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null, e[10] ? new IFC4X3.IfcDateTime(e[10].value) : null, e[11] ? new IFC4X3.IfcDuration(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveRatioMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcDateTime(e[13].value) : null, e[14] ? new IFC4X3.IfcDateTime(e[14].value) : null, e[15] ? new IFC4X3.IfcDuration(e[15].value) : null, e[16] ? new IFC4X3.IfcPositiveRatioMeasure(e[16].value) : null, e[17] ? new IFC4X3.IfcPositiveRatioMeasure(e[17].value) : null),
  2778083089: (r, e) => new IFC4X3.IfcRoundedRectangleProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value)),
  2042790032: (r, e) => new IFC4X3.IfcSectionProperties(r, e[0], new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null),
  4165799628: (r, e) => new IFC4X3.IfcSectionReinforcementProperties(r, new IFC4X3.IfcLengthMeasure(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3], new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  1509187699: (r, e) => new IFC4X3.IfcSectionedSpine(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value))),
  823603102: (r, e) => new IFC4X3.IfcSegment(r, e[0]),
  4124623270: (r, e) => new IFC4X3.IfcShellBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  3692461612: (r, e) => new IFC4X3.IfcSimpleProperty(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null),
  2609359061: (r, e) => new IFC4X3.IfcSlippageConnectionCondition(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null),
  723233188: (r, e) => new IFC4X3.IfcSolidModel(r),
  1595516126: (r, e) => new IFC4X3.IfcStructuralLoadLinearForce(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLinearForceMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcLinearForceMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLinearForceMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcLinearMomentMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcLinearMomentMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcLinearMomentMeasure(e[6].value) : null),
  2668620305: (r, e) => new IFC4X3.IfcStructuralLoadPlanarForce(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcPlanarForceMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcPlanarForceMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcPlanarForceMeasure(e[3].value) : null),
  2473145415: (r, e) => new IFC4X3.IfcStructuralLoadSingleDisplacement(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcPlaneAngleMeasure(e[6].value) : null),
  1973038258: (r, e) => new IFC4X3.IfcStructuralLoadSingleDisplacementDistortion(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcLengthMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcPlaneAngleMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcPlaneAngleMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcPlaneAngleMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcCurvatureMeasure(e[7].value) : null),
  1597423693: (r, e) => new IFC4X3.IfcStructuralLoadSingleForce(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcTorqueMeasure(e[6].value) : null),
  1190533807: (r, e) => new IFC4X3.IfcStructuralLoadSingleForceWarping(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, e[1] ? new IFC4X3.IfcForceMeasure(e[1].value) : null, e[2] ? new IFC4X3.IfcForceMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcForceMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcTorqueMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcTorqueMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcTorqueMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcWarpingMomentMeasure(e[7].value) : null),
  2233826070: (r, e) => new IFC4X3.IfcSubedge(r, new Handle(e[0].value), new Handle(e[1].value), new Handle(e[2].value)),
  2513912981: (r, e) => new IFC4X3.IfcSurface(r),
  1878645084: (r, e) => new IFC4X3.IfcSurfaceStyleRendering(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcNormalisedRatioMeasure(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? TypeInitialiser(3, e[7]) : null, e[8]),
  2247615214: (r, e) => new IFC4X3.IfcSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  1260650574: (r, e) => new IFC4X3.IfcSweptDiskSolid(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcPositiveLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4X3.IfcParameterValue(e[4].value) : null),
  1096409881: (r, e) => new IFC4X3.IfcSweptDiskSolidPolygonal(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcPositiveLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcParameterValue(e[3].value) : null, e[4] ? new IFC4X3.IfcParameterValue(e[4].value) : null, e[5] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[5].value) : null),
  230924584: (r, e) => new IFC4X3.IfcSweptSurface(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  3071757647: (r, e) => new IFC4X3.IfcTShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcPlaneAngleMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPlaneAngleMeasure(e[11].value) : null),
  901063453: (r, e) => new IFC4X3.IfcTessellatedItem(r),
  4282788508: (r, e) => new IFC4X3.IfcTextLiteral(r, new IFC4X3.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2]),
  3124975700: (r, e) => new IFC4X3.IfcTextLiteralWithExtent(r, new IFC4X3.IfcPresentableText(e[0].value), new Handle(e[1].value), e[2], new Handle(e[3].value), new IFC4X3.IfcBoxAlignment(e[4].value)),
  1983826977: (r, e) => new IFC4X3.IfcTextStyleFontModel(r, new IFC4X3.IfcLabel(e[0].value), e[1].map((s) => new IFC4X3.IfcTextFontName(s.value)), e[2] ? new IFC4X3.IfcFontStyle(e[2].value) : null, e[3] ? new IFC4X3.IfcFontVariant(e[3].value) : null, e[4] ? new IFC4X3.IfcFontWeight(e[4].value) : null, TypeInitialiser(3, e[5])),
  2715220739: (r, e) => new IFC4X3.IfcTrapeziumProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcLengthMeasure(e[6].value)),
  1628702193: (r, e) => new IFC4X3.IfcTypeObject(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null),
  3736923433: (r, e) => new IFC4X3.IfcTypeProcess(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2347495698: (r, e) => new IFC4X3.IfcTypeProduct(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null),
  3698973494: (r, e) => new IFC4X3.IfcTypeResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  427810014: (r, e) => new IFC4X3.IfcUShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcPlaneAngleMeasure(e[9].value) : null),
  1417489154: (r, e) => new IFC4X3.IfcVector(r, new Handle(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value)),
  2759199220: (r, e) => new IFC4X3.IfcVertexLoop(r, new Handle(e[0].value)),
  2543172580: (r, e) => new IFC4X3.IfcZShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[8].value) : null),
  3406155212: (r, e) => new IFC4X3.IfcAdvancedFace(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new IFC4X3.IfcBoolean(e[2].value)),
  669184980: (r, e) => new IFC4X3.IfcAnnotationFillArea(r, new Handle(e[0].value), e[1] ? e[1].map((s) => new Handle(s.value)) : null),
  3207858831: (r, e) => new IFC4X3.IfcAsymmetricIShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[8].value), e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPlaneAngleMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[13].value) : null, e[14] ? new IFC4X3.IfcPlaneAngleMeasure(e[14].value) : null),
  4261334040: (r, e) => new IFC4X3.IfcAxis1Placement(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  3125803723: (r, e) => new IFC4X3.IfcAxis2Placement2D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null),
  2740243338: (r, e) => new IFC4X3.IfcAxis2Placement3D(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  3425423356: (r, e) => new IFC4X3.IfcAxis2PlacementLinear(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new Handle(e[2].value) : null),
  2736907675: (r, e) => new IFC4X3.IfcBooleanResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  4182860854: (r, e) => new IFC4X3.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC4X3.IfcBoundingBox(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  2713105998: (r, e) => new IFC4X3.IfcBoxedHalfSpace(r, new Handle(e[0].value), new IFC4X3.IfcBoolean(e[1].value), new Handle(e[2].value)),
  2898889636: (r, e) => new IFC4X3.IfcCShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null),
  1123145078: (r, e) => new IFC4X3.IfcCartesianPoint(r, e[0].map((s) => new IFC4X3.IfcLengthMeasure(s.value))),
  574549367: (r, e) => new IFC4X3.IfcCartesianPointList(r),
  1675464909: (r, e) => new IFC4X3.IfcCartesianPointList2D(r, e[0].map((s) => new IFC4X3.IfcLengthMeasure(s.value)), e[1] ? e[1].map((s) => new IFC4X3.IfcLabel(s.value)) : null),
  2059837836: (r, e) => new IFC4X3.IfcCartesianPointList3D(r, e[0].map((s) => new IFC4X3.IfcLengthMeasure(s.value)), e[1] ? e[1].map((s) => new IFC4X3.IfcLabel(s.value)) : null),
  59481748: (r, e) => new IFC4X3.IfcCartesianTransformationOperator(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null),
  3749851601: (r, e) => new IFC4X3.IfcCartesianTransformationOperator2D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null),
  3486308946: (r, e) => new IFC4X3.IfcCartesianTransformationOperator2DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null, e[4] ? new IFC4X3.IfcReal(e[4].value) : null),
  3331915920: (r, e) => new IFC4X3.IfcCartesianTransformationOperator3D(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null, e[4] ? new Handle(e[4].value) : null),
  1416205885: (r, e) => new IFC4X3.IfcCartesianTransformationOperator3DnonUniform(r, e[0] ? new Handle(e[0].value) : null, e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? new IFC4X3.IfcReal(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? new IFC4X3.IfcReal(e[5].value) : null, e[6] ? new IFC4X3.IfcReal(e[6].value) : null),
  1383045692: (r, e) => new IFC4X3.IfcCircleProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  2205249479: (r, e) => new IFC4X3.IfcClosedShell(r, e[0].map((s) => new Handle(s.value))),
  776857604: (r, e) => new IFC4X3.IfcColourRgb(r, e[0] ? new IFC4X3.IfcLabel(e[0].value) : null, new IFC4X3.IfcNormalisedRatioMeasure(e[1].value), new IFC4X3.IfcNormalisedRatioMeasure(e[2].value), new IFC4X3.IfcNormalisedRatioMeasure(e[3].value)),
  2542286263: (r, e) => new IFC4X3.IfcComplexProperty(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, new IFC4X3.IfcIdentifier(e[2].value), e[3].map((s) => new Handle(s.value))),
  2485617015: (r, e) => new IFC4X3.IfcCompositeCurveSegment(r, e[0], new IFC4X3.IfcBoolean(e[1].value), new Handle(e[2].value)),
  2574617495: (r, e) => new IFC4X3.IfcConstructionResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null),
  3419103109: (r, e) => new IFC4X3.IfcContext(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  1815067380: (r, e) => new IFC4X3.IfcCrewResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  2506170314: (r, e) => new IFC4X3.IfcCsgPrimitive3D(r, new Handle(e[0].value)),
  2147822146: (r, e) => new IFC4X3.IfcCsgSolid(r, new Handle(e[0].value)),
  2601014836: (r, e) => new IFC4X3.IfcCurve(r),
  2827736869: (r, e) => new IFC4X3.IfcCurveBoundedPlane(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? e[2].map((s) => new Handle(s.value)) : null),
  2629017746: (r, e) => new IFC4X3.IfcCurveBoundedSurface(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), new IFC4X3.IfcBoolean(e[2].value)),
  4212018352: (r, e) => new IFC4X3.IfcCurveSegment(r, e[0], new Handle(e[1].value), TypeInitialiser(3, e[2]), TypeInitialiser(3, e[3]), new Handle(e[4].value)),
  32440307: (r, e) => new IFC4X3.IfcDirection(r, e[0].map((s) => new IFC4X3.IfcReal(s.value))),
  593015953: (r, e) => new IFC4X3.IfcDirectrixCurveSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null),
  1472233963: (r, e) => new IFC4X3.IfcEdgeLoop(r, e[0].map((s) => new Handle(s.value))),
  1883228015: (r, e) => new IFC4X3.IfcElementQuantity(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  339256511: (r, e) => new IFC4X3.IfcElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2777663545: (r, e) => new IFC4X3.IfcElementarySurface(r, new Handle(e[0].value)),
  2835456948: (r, e) => new IFC4X3.IfcEllipseProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value)),
  4024345920: (r, e) => new IFC4X3.IfcEventType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4X3.IfcLabel(e[11].value) : null),
  477187591: (r, e) => new IFC4X3.IfcExtrudedAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  2804161546: (r, e) => new IFC4X3.IfcExtrudedAreaSolidTapered(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new Handle(e[4].value)),
  2047409740: (r, e) => new IFC4X3.IfcFaceBasedSurfaceModel(r, e[0].map((s) => new Handle(s.value))),
  374418227: (r, e) => new IFC4X3.IfcFillAreaStyleHatching(r, new Handle(e[0].value), new Handle(e[1].value), e[2] ? new Handle(e[2].value) : null, e[3] ? new Handle(e[3].value) : null, new IFC4X3.IfcPlaneAngleMeasure(e[4].value)),
  315944413: (r, e) => new IFC4X3.IfcFillAreaStyleTiles(r, e[0].map((s) => new Handle(s.value)), e[1].map((s) => new Handle(s.value)), new IFC4X3.IfcPositiveRatioMeasure(e[2].value)),
  2652556860: (r, e) => new IFC4X3.IfcFixedReferenceSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, new Handle(e[5].value)),
  4238390223: (r, e) => new IFC4X3.IfcFurnishingElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1268542332: (r, e) => new IFC4X3.IfcFurnitureType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10]),
  4095422895: (r, e) => new IFC4X3.IfcGeographicElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  987898635: (r, e) => new IFC4X3.IfcGeometricCurveSet(r, e[0].map((s) => new Handle(s.value))),
  1484403080: (r, e) => new IFC4X3.IfcIShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), new IFC4X3.IfcPositiveLengthMeasure(e[6].value), e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcPlaneAngleMeasure(e[9].value) : null),
  178912537: (r, e) => new IFC4X3.IfcIndexedPolygonalFace(r, e[0].map((s) => new IFC4X3.IfcPositiveInteger(s.value))),
  2294589976: (r, e) => new IFC4X3.IfcIndexedPolygonalFaceWithVoids(r, e[0].map((s) => new IFC4X3.IfcPositiveInteger(s.value)), e[1].map((s) => new IFC4X3.IfcPositiveInteger(s.value))),
  3465909080: (r, e) => new IFC4X3.IfcIndexedPolygonalTextureMap(r, e[0].map((s) => new Handle(s.value)), new Handle(e[1].value), new Handle(e[2].value), e[3].map((s) => new Handle(s.value))),
  572779678: (r, e) => new IFC4X3.IfcLShapeProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcPlaneAngleMeasure(e[8].value) : null),
  428585644: (r, e) => new IFC4X3.IfcLaborResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  1281925730: (r, e) => new IFC4X3.IfcLine(r, new Handle(e[0].value), new Handle(e[1].value)),
  1425443689: (r, e) => new IFC4X3.IfcManifoldSolidBrep(r, new Handle(e[0].value)),
  3888040117: (r, e) => new IFC4X3.IfcObject(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  590820931: (r, e) => new IFC4X3.IfcOffsetCurve(r, new Handle(e[0].value)),
  3388369263: (r, e) => new IFC4X3.IfcOffsetCurve2D(r, new Handle(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value), new IFC4X3.IfcLogical(e[2].value)),
  3505215534: (r, e) => new IFC4X3.IfcOffsetCurve3D(r, new Handle(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value), new IFC4X3.IfcLogical(e[2].value), new Handle(e[3].value)),
  2485787929: (r, e) => new IFC4X3.IfcOffsetCurveByDistances(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2] ? new IFC4X3.IfcLabel(e[2].value) : null),
  1682466193: (r, e) => new IFC4X3.IfcPcurve(r, new Handle(e[0].value), new Handle(e[1].value)),
  603570806: (r, e) => new IFC4X3.IfcPlanarBox(r, new IFC4X3.IfcLengthMeasure(e[0].value), new IFC4X3.IfcLengthMeasure(e[1].value), new Handle(e[2].value)),
  220341763: (r, e) => new IFC4X3.IfcPlane(r, new Handle(e[0].value)),
  3381221214: (r, e) => new IFC4X3.IfcPolynomialCurve(r, new Handle(e[0].value), e[1] ? e[1].map((s) => new IFC4X3.IfcReal(s.value)) : null, e[2] ? e[2].map((s) => new IFC4X3.IfcReal(s.value)) : null, e[3] ? e[3].map((s) => new IFC4X3.IfcReal(s.value)) : null),
  759155922: (r, e) => new IFC4X3.IfcPreDefinedColour(r, new IFC4X3.IfcLabel(e[0].value)),
  2559016684: (r, e) => new IFC4X3.IfcPreDefinedCurveFont(r, new IFC4X3.IfcLabel(e[0].value)),
  3967405729: (r, e) => new IFC4X3.IfcPreDefinedPropertySet(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  569719735: (r, e) => new IFC4X3.IfcProcedureType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2945172077: (r, e) => new IFC4X3.IfcProcess(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null),
  4208778838: (r, e) => new IFC4X3.IfcProduct(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  103090709: (r, e) => new IFC4X3.IfcProject(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  653396225: (r, e) => new IFC4X3.IfcProjectLibrary(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new Handle(e[8].value) : null),
  871118103: (r, e) => new IFC4X3.IfcPropertyBoundedValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? new Handle(e[4].value) : null, e[5] ? TypeInitialiser(3, e[5]) : null),
  4166981789: (r, e) => new IFC4X3.IfcPropertyEnumeratedValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(3, s)) : null, e[3] ? new Handle(e[3].value) : null),
  2752243245: (r, e) => new IFC4X3.IfcPropertyListValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(3, s)) : null, e[3] ? new Handle(e[3].value) : null),
  941946838: (r, e) => new IFC4X3.IfcPropertyReferenceValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? new IFC4X3.IfcText(e[2].value) : null, e[3] ? new Handle(e[3].value) : null),
  1451395588: (r, e) => new IFC4X3.IfcPropertySet(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  492091185: (r, e) => new IFC4X3.IfcPropertySetTemplate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4], e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6].map((s) => new Handle(s.value))),
  3650150729: (r, e) => new IFC4X3.IfcPropertySingleValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? TypeInitialiser(3, e[2]) : null, e[3] ? new Handle(e[3].value) : null),
  110355661: (r, e) => new IFC4X3.IfcPropertyTableValue(r, new IFC4X3.IfcIdentifier(e[0].value), e[1] ? new IFC4X3.IfcText(e[1].value) : null, e[2] ? e[2].map((s) => TypeInitialiser(3, s)) : null, e[3] ? e[3].map((s) => TypeInitialiser(3, s)) : null, e[4] ? new IFC4X3.IfcText(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  3521284610: (r, e) => new IFC4X3.IfcPropertyTemplate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  2770003689: (r, e) => new IFC4X3.IfcRectangleHollowProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value), new IFC4X3.IfcPositiveLengthMeasure(e[5].value), e[6] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null),
  2798486643: (r, e) => new IFC4X3.IfcRectangularPyramid(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  3454111270: (r, e) => new IFC4X3.IfcRectangularTrimmedSurface(r, new Handle(e[0].value), new IFC4X3.IfcParameterValue(e[1].value), new IFC4X3.IfcParameterValue(e[2].value), new IFC4X3.IfcParameterValue(e[3].value), new IFC4X3.IfcParameterValue(e[4].value), new IFC4X3.IfcBoolean(e[5].value), new IFC4X3.IfcBoolean(e[6].value)),
  3765753017: (r, e) => new IFC4X3.IfcReinforcementDefinitionProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5].map((s) => new Handle(s.value))),
  3939117080: (r, e) => new IFC4X3.IfcRelAssigns(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5]),
  1683148259: (r, e) => new IFC4X3.IfcRelAssignsToActor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2495723537: (r, e) => new IFC4X3.IfcRelAssignsToControl(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1307041759: (r, e) => new IFC4X3.IfcRelAssignsToGroup(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1027710054: (r, e) => new IFC4X3.IfcRelAssignsToGroupByFactor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), new IFC4X3.IfcRatioMeasure(e[7].value)),
  4278684876: (r, e) => new IFC4X3.IfcRelAssignsToProcess(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value), e[7] ? new Handle(e[7].value) : null),
  2857406711: (r, e) => new IFC4X3.IfcRelAssignsToProduct(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  205026976: (r, e) => new IFC4X3.IfcRelAssignsToResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5], new Handle(e[6].value)),
  1865459582: (r, e) => new IFC4X3.IfcRelAssociates(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value))),
  4095574036: (r, e) => new IFC4X3.IfcRelAssociatesApproval(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  919958153: (r, e) => new IFC4X3.IfcRelAssociatesClassification(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2728634034: (r, e) => new IFC4X3.IfcRelAssociatesConstraint(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, new Handle(e[6].value)),
  982818633: (r, e) => new IFC4X3.IfcRelAssociatesDocument(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3840914261: (r, e) => new IFC4X3.IfcRelAssociatesLibrary(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  2655215786: (r, e) => new IFC4X3.IfcRelAssociatesMaterial(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  1033248425: (r, e) => new IFC4X3.IfcRelAssociatesProfileDef(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  826625072: (r, e) => new IFC4X3.IfcRelConnects(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  1204542856: (r, e) => new IFC4X3.IfcRelConnectsElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value)),
  3945020480: (r, e) => new IFC4X3.IfcRelConnectsPathElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7] ? e[7].map((s) => new IFC4X3.IfcInteger(s.value)) : null, e[8] ? e[8].map((s) => new IFC4X3.IfcInteger(s.value)) : null, e[9], e[10]),
  4201705270: (r, e) => new IFC4X3.IfcRelConnectsPortToElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  3190031847: (r, e) => new IFC4X3.IfcRelConnectsPorts(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null),
  2127690289: (r, e) => new IFC4X3.IfcRelConnectsStructuralActivity(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1638771189: (r, e) => new IFC4X3.IfcRelConnectsStructuralMember(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC4X3.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null),
  504942748: (r, e) => new IFC4X3.IfcRelConnectsWithEccentricity(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC4X3.IfcLengthMeasure(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, new Handle(e[10].value)),
  3678494232: (r, e) => new IFC4X3.IfcRelConnectsWithRealizingElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new Handle(e[4].value) : null, new Handle(e[5].value), new Handle(e[6].value), e[7].map((s) => new Handle(s.value)), e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3242617779: (r, e) => new IFC4X3.IfcRelContainedInSpatialStructure(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  886880790: (r, e) => new IFC4X3.IfcRelCoversBldgElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2802773753: (r, e) => new IFC4X3.IfcRelCoversSpaces(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2565941209: (r, e) => new IFC4X3.IfcRelDeclares(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  2551354335: (r, e) => new IFC4X3.IfcRelDecomposes(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  693640335: (r, e) => new IFC4X3.IfcRelDefines(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null),
  1462361463: (r, e) => new IFC4X3.IfcRelDefinesByObject(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4186316022: (r, e) => new IFC4X3.IfcRelDefinesByProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  307848117: (r, e) => new IFC4X3.IfcRelDefinesByTemplate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  781010003: (r, e) => new IFC4X3.IfcRelDefinesByType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  3940055652: (r, e) => new IFC4X3.IfcRelFillsElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  279856033: (r, e) => new IFC4X3.IfcRelFlowControlElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  427948657: (r, e) => new IFC4X3.IfcRelInterferesElements(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new IFC4X3.IfcIdentifier(e[8].value) : null, new IFC4X3.IfcLogical(e[9].value)),
  3268803585: (r, e) => new IFC4X3.IfcRelNests(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  1441486842: (r, e) => new IFC4X3.IfcRelPositions(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  750771296: (r, e) => new IFC4X3.IfcRelProjectsElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  1245217292: (r, e) => new IFC4X3.IfcRelReferencedInSpatialStructure(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4].map((s) => new Handle(s.value)), new Handle(e[5].value)),
  4122056220: (r, e) => new IFC4X3.IfcRelSequence(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  366585022: (r, e) => new IFC4X3.IfcRelServicesBuildings(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  3451746338: (r, e) => new IFC4X3.IfcRelSpaceBoundary(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8]),
  3523091289: (r, e) => new IFC4X3.IfcRelSpaceBoundary1stLevel(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9] ? new Handle(e[9].value) : null),
  1521410863: (r, e) => new IFC4X3.IfcRelSpaceBoundary2ndLevel(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value), e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  1401173127: (r, e) => new IFC4X3.IfcRelVoidsElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), new Handle(e[5].value)),
  816062949: (r, e) => new IFC4X3.IfcReparametrisedCompositeCurveSegment(r, e[0], new IFC4X3.IfcBoolean(e[1].value), new Handle(e[2].value), new IFC4X3.IfcParameterValue(e[3].value)),
  2914609552: (r, e) => new IFC4X3.IfcResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null),
  1856042241: (r, e) => new IFC4X3.IfcRevolvedAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPlaneAngleMeasure(e[3].value)),
  3243963512: (r, e) => new IFC4X3.IfcRevolvedAreaSolidTapered(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcPlaneAngleMeasure(e[3].value), new Handle(e[4].value)),
  4158566097: (r, e) => new IFC4X3.IfcRightCircularCone(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value)),
  3626867408: (r, e) => new IFC4X3.IfcRightCircularCylinder(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value)),
  1862484736: (r, e) => new IFC4X3.IfcSectionedSolid(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  1290935644: (r, e) => new IFC4X3.IfcSectionedSolidHorizontal(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value))),
  1356537516: (r, e) => new IFC4X3.IfcSectionedSurface(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value))),
  3663146110: (r, e) => new IFC4X3.IfcSimplePropertyTemplate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4], e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6] ? new IFC4X3.IfcLabel(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new IFC4X3.IfcLabel(e[10].value) : null, e[11]),
  1412071761: (r, e) => new IFC4X3.IfcSpatialElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null),
  710998568: (r, e) => new IFC4X3.IfcSpatialElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2706606064: (r, e) => new IFC4X3.IfcSpatialStructureElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8]),
  3893378262: (r, e) => new IFC4X3.IfcSpatialStructureElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  463610769: (r, e) => new IFC4X3.IfcSpatialZone(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8]),
  2481509218: (r, e) => new IFC4X3.IfcSpatialZoneType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcLabel(e[10].value) : null),
  451544542: (r, e) => new IFC4X3.IfcSphere(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value)),
  4015995234: (r, e) => new IFC4X3.IfcSphericalSurface(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value)),
  2735484536: (r, e) => new IFC4X3.IfcSpiral(r, e[0] ? new Handle(e[0].value) : null),
  3544373492: (r, e) => new IFC4X3.IfcStructuralActivity(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3136571912: (r, e) => new IFC4X3.IfcStructuralItem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  530289379: (r, e) => new IFC4X3.IfcStructuralMember(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3689010777: (r, e) => new IFC4X3.IfcStructuralReaction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  3979015343: (r, e) => new IFC4X3.IfcStructuralSurfaceMember(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4X3.IfcPositiveLengthMeasure(e[8].value) : null),
  2218152070: (r, e) => new IFC4X3.IfcStructuralSurfaceMemberVarying(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8] ? new IFC4X3.IfcPositiveLengthMeasure(e[8].value) : null),
  603775116: (r, e) => new IFC4X3.IfcStructuralSurfaceReaction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9]),
  4095615324: (r, e) => new IFC4X3.IfcSubContractResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  699246055: (r, e) => new IFC4X3.IfcSurfaceCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  2028607225: (r, e) => new IFC4X3.IfcSurfaceCurveSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, new Handle(e[5].value)),
  2809605785: (r, e) => new IFC4X3.IfcSurfaceOfLinearExtrusion(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), new IFC4X3.IfcLengthMeasure(e[3].value)),
  4124788165: (r, e) => new IFC4X3.IfcSurfaceOfRevolution(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value)),
  1580310250: (r, e) => new IFC4X3.IfcSystemFurnitureElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3473067441: (r, e) => new IFC4X3.IfcTask(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, new IFC4X3.IfcBoolean(e[9].value), e[10] ? new IFC4X3.IfcInteger(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12]),
  3206491090: (r, e) => new IFC4X3.IfcTaskType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcLabel(e[10].value) : null),
  2387106220: (r, e) => new IFC4X3.IfcTessellatedFaceSet(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcBoolean(e[1].value) : null),
  782932809: (r, e) => new IFC4X3.IfcThirdOrderPolynomialSpiral(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcLengthMeasure(e[4].value) : null),
  1935646853: (r, e) => new IFC4X3.IfcToroidalSurface(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value)),
  3665877780: (r, e) => new IFC4X3.IfcTransportationDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2916149573: (r, e) => new IFC4X3.IfcTriangulatedFaceSet(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcBoolean(e[1].value) : null, e[2] ? e[2].map((s) => new IFC4X3.IfcParameterValue(s.value)) : null, e[3].map((s) => new IFC4X3.IfcPositiveInteger(s.value)), e[4] ? e[4].map((s) => new IFC4X3.IfcPositiveInteger(s.value)) : null),
  1229763772: (r, e) => new IFC4X3.IfcTriangulatedIrregularNetwork(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcBoolean(e[1].value) : null, e[2] ? e[2].map((s) => new IFC4X3.IfcParameterValue(s.value)) : null, e[3].map((s) => new IFC4X3.IfcPositiveInteger(s.value)), e[4] ? e[4].map((s) => new IFC4X3.IfcPositiveInteger(s.value)) : null, e[5].map((s) => new IFC4X3.IfcInteger(s.value))),
  3651464721: (r, e) => new IFC4X3.IfcVehicleType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  336235671: (r, e) => new IFC4X3.IfcWindowLiningProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNormalisedRatioMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcNormalisedRatioMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcNormalisedRatioMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcNormalisedRatioMeasure(e[11].value) : null, e[12] ? new Handle(e[12].value) : null, e[13] ? new IFC4X3.IfcLengthMeasure(e[13].value) : null, e[14] ? new IFC4X3.IfcLengthMeasure(e[14].value) : null, e[15] ? new IFC4X3.IfcLengthMeasure(e[15].value) : null),
  512836454: (r, e) => new IFC4X3.IfcWindowPanelProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC4X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  2296667514: (r, e) => new IFC4X3.IfcActor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, new Handle(e[5].value)),
  1635779807: (r, e) => new IFC4X3.IfcAdvancedBrep(r, new Handle(e[0].value)),
  2603310189: (r, e) => new IFC4X3.IfcAdvancedBrepWithVoids(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  1674181508: (r, e) => new IFC4X3.IfcAnnotation(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  2887950389: (r, e) => new IFC4X3.IfcBSplineSurface(r, new IFC4X3.IfcInteger(e[0].value), new IFC4X3.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4X3.IfcLogical(e[4].value), new IFC4X3.IfcLogical(e[5].value), new IFC4X3.IfcLogical(e[6].value)),
  167062518: (r, e) => new IFC4X3.IfcBSplineSurfaceWithKnots(r, new IFC4X3.IfcInteger(e[0].value), new IFC4X3.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4X3.IfcLogical(e[4].value), new IFC4X3.IfcLogical(e[5].value), new IFC4X3.IfcLogical(e[6].value), e[7].map((s) => new IFC4X3.IfcInteger(s.value)), e[8].map((s) => new IFC4X3.IfcInteger(s.value)), e[9].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[10].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[11]),
  1334484129: (r, e) => new IFC4X3.IfcBlock(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value), new IFC4X3.IfcPositiveLengthMeasure(e[3].value)),
  3649129432: (r, e) => new IFC4X3.IfcBooleanClippingResult(r, e[0], new Handle(e[1].value), new Handle(e[2].value)),
  1260505505: (r, e) => new IFC4X3.IfcBoundedCurve(r),
  3124254112: (r, e) => new IFC4X3.IfcBuildingStorey(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4X3.IfcLengthMeasure(e[9].value) : null),
  1626504194: (r, e) => new IFC4X3.IfcBuiltElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2197970202: (r, e) => new IFC4X3.IfcChimneyType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2937912522: (r, e) => new IFC4X3.IfcCircleHollowProfileDef(r, e[0], e[1] ? new IFC4X3.IfcLabel(e[1].value) : null, e[2] ? new Handle(e[2].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[3].value), new IFC4X3.IfcPositiveLengthMeasure(e[4].value)),
  3893394355: (r, e) => new IFC4X3.IfcCivilElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3497074424: (r, e) => new IFC4X3.IfcClothoid(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value)),
  300633059: (r, e) => new IFC4X3.IfcColumnType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3875453745: (r, e) => new IFC4X3.IfcComplexPropertyTemplate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? e[6].map((s) => new Handle(s.value)) : null),
  3732776249: (r, e) => new IFC4X3.IfcCompositeCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value)),
  15328376: (r, e) => new IFC4X3.IfcCompositeCurveOnSurface(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value)),
  2510884976: (r, e) => new IFC4X3.IfcConic(r, new Handle(e[0].value)),
  2185764099: (r, e) => new IFC4X3.IfcConstructionEquipmentResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  4105962743: (r, e) => new IFC4X3.IfcConstructionMaterialResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  1525564444: (r, e) => new IFC4X3.IfcConstructionProductResourceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? new IFC4X3.IfcIdentifier(e[6].value) : null, e[7] ? new IFC4X3.IfcText(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10] ? new Handle(e[10].value) : null, e[11]),
  2559216714: (r, e) => new IFC4X3.IfcConstructionResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null),
  3293443760: (r, e) => new IFC4X3.IfcControl(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null),
  2000195564: (r, e) => new IFC4X3.IfcCosineSpiral(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null),
  3895139033: (r, e) => new IFC4X3.IfcCostItem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6], e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null),
  1419761937: (r, e) => new IFC4X3.IfcCostSchedule(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcDateTime(e[8].value) : null, e[9] ? new IFC4X3.IfcDateTime(e[9].value) : null),
  4189326743: (r, e) => new IFC4X3.IfcCourseType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1916426348: (r, e) => new IFC4X3.IfcCoveringType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3295246426: (r, e) => new IFC4X3.IfcCrewResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1457835157: (r, e) => new IFC4X3.IfcCurtainWallType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1213902940: (r, e) => new IFC4X3.IfcCylindricalSurface(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value)),
  1306400036: (r, e) => new IFC4X3.IfcDeepFoundationType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  4234616927: (r, e) => new IFC4X3.IfcDirectrixDerivedReferenceSweptAreaSolid(r, new Handle(e[0].value), e[1] ? new Handle(e[1].value) : null, new Handle(e[2].value), e[3] ? TypeInitialiser(3, e[3]) : null, e[4] ? TypeInitialiser(3, e[4]) : null, new Handle(e[5].value)),
  3256556792: (r, e) => new IFC4X3.IfcDistributionElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3849074793: (r, e) => new IFC4X3.IfcDistributionFlowElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2963535650: (r, e) => new IFC4X3.IfcDoorLiningProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcNonNegativeLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcPositiveLengthMeasure(e[13].value) : null, e[14] ? new Handle(e[14].value) : null, e[15] ? new IFC4X3.IfcLengthMeasure(e[15].value) : null, e[16] ? new IFC4X3.IfcLengthMeasure(e[16].value) : null),
  1714330368: (r, e) => new IFC4X3.IfcDoorPanelProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcPositiveLengthMeasure(e[4].value) : null, e[5], e[6] ? new IFC4X3.IfcNormalisedRatioMeasure(e[6].value) : null, e[7], e[8] ? new Handle(e[8].value) : null),
  2323601079: (r, e) => new IFC4X3.IfcDoorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4X3.IfcBoolean(e[11].value) : null, e[12] ? new IFC4X3.IfcLabel(e[12].value) : null),
  445594917: (r, e) => new IFC4X3.IfcDraughtingPreDefinedColour(r, new IFC4X3.IfcLabel(e[0].value)),
  4006246654: (r, e) => new IFC4X3.IfcDraughtingPreDefinedCurveFont(r, new IFC4X3.IfcLabel(e[0].value)),
  1758889154: (r, e) => new IFC4X3.IfcElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  4123344466: (r, e) => new IFC4X3.IfcElementAssembly(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  2397081782: (r, e) => new IFC4X3.IfcElementAssemblyType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1623761950: (r, e) => new IFC4X3.IfcElementComponent(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2590856083: (r, e) => new IFC4X3.IfcElementComponentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1704287377: (r, e) => new IFC4X3.IfcEllipse(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value), new IFC4X3.IfcPositiveLengthMeasure(e[2].value)),
  2107101300: (r, e) => new IFC4X3.IfcEnergyConversionDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  132023988: (r, e) => new IFC4X3.IfcEngineType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3174744832: (r, e) => new IFC4X3.IfcEvaporativeCoolerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3390157468: (r, e) => new IFC4X3.IfcEvaporatorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4148101412: (r, e) => new IFC4X3.IfcEvent(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7], e[8], e[9] ? new IFC4X3.IfcLabel(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  2853485674: (r, e) => new IFC4X3.IfcExternalSpatialStructureElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null),
  807026263: (r, e) => new IFC4X3.IfcFacetedBrep(r, new Handle(e[0].value)),
  3737207727: (r, e) => new IFC4X3.IfcFacetedBrepWithVoids(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value))),
  24185140: (r, e) => new IFC4X3.IfcFacility(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8]),
  1310830890: (r, e) => new IFC4X3.IfcFacilityPart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9]),
  4228831410: (r, e) => new IFC4X3.IfcFacilityPartCommon(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10]),
  647756555: (r, e) => new IFC4X3.IfcFastener(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2489546625: (r, e) => new IFC4X3.IfcFastenerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2827207264: (r, e) => new IFC4X3.IfcFeatureElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2143335405: (r, e) => new IFC4X3.IfcFeatureElementAddition(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1287392070: (r, e) => new IFC4X3.IfcFeatureElementSubtraction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3907093117: (r, e) => new IFC4X3.IfcFlowControllerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3198132628: (r, e) => new IFC4X3.IfcFlowFittingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3815607619: (r, e) => new IFC4X3.IfcFlowMeterType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1482959167: (r, e) => new IFC4X3.IfcFlowMovingDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1834744321: (r, e) => new IFC4X3.IfcFlowSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1339347760: (r, e) => new IFC4X3.IfcFlowStorageDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2297155007: (r, e) => new IFC4X3.IfcFlowTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  3009222698: (r, e) => new IFC4X3.IfcFlowTreatmentDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1893162501: (r, e) => new IFC4X3.IfcFootingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  263784265: (r, e) => new IFC4X3.IfcFurnishingElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1509553395: (r, e) => new IFC4X3.IfcFurniture(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3493046030: (r, e) => new IFC4X3.IfcGeographicElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4230923436: (r, e) => new IFC4X3.IfcGeotechnicalElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1594536857: (r, e) => new IFC4X3.IfcGeotechnicalStratum(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2898700619: (r, e) => new IFC4X3.IfcGradientCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value), new Handle(e[2].value), e[3] ? new Handle(e[3].value) : null),
  2706460486: (r, e) => new IFC4X3.IfcGroup(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  1251058090: (r, e) => new IFC4X3.IfcHeatExchangerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1806887404: (r, e) => new IFC4X3.IfcHumidifierType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2568555532: (r, e) => new IFC4X3.IfcImpactProtectionDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3948183225: (r, e) => new IFC4X3.IfcImpactProtectionDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2571569899: (r, e) => new IFC4X3.IfcIndexedPolyCurve(r, new Handle(e[0].value), e[1] ? e[1].map((s) => TypeInitialiser(3, s)) : null, new IFC4X3.IfcLogical(e[2].value)),
  3946677679: (r, e) => new IFC4X3.IfcInterceptorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3113134337: (r, e) => new IFC4X3.IfcIntersectionCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  2391368822: (r, e) => new IFC4X3.IfcInventory(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4X3.IfcDate(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null),
  4288270099: (r, e) => new IFC4X3.IfcJunctionBoxType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  679976338: (r, e) => new IFC4X3.IfcKerbType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, new IFC4X3.IfcBoolean(e[9].value)),
  3827777499: (r, e) => new IFC4X3.IfcLaborResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1051575348: (r, e) => new IFC4X3.IfcLampType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1161773419: (r, e) => new IFC4X3.IfcLightFixtureType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2176059722: (r, e) => new IFC4X3.IfcLinearElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  1770583370: (r, e) => new IFC4X3.IfcLiquidTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  525669439: (r, e) => new IFC4X3.IfcMarineFacility(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9]),
  976884017: (r, e) => new IFC4X3.IfcMarinePart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10]),
  377706215: (r, e) => new IFC4X3.IfcMechanicalFastener(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10]),
  2108223431: (r, e) => new IFC4X3.IfcMechanicalFastenerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPositiveLengthMeasure(e[11].value) : null),
  1114901282: (r, e) => new IFC4X3.IfcMedicalDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3181161470: (r, e) => new IFC4X3.IfcMemberType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1950438474: (r, e) => new IFC4X3.IfcMobileTelecommunicationsApplianceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  710110818: (r, e) => new IFC4X3.IfcMooringDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  977012517: (r, e) => new IFC4X3.IfcMotorConnectionType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  506776471: (r, e) => new IFC4X3.IfcNavigationElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4143007308: (r, e) => new IFC4X3.IfcOccupant(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, new Handle(e[5].value), e[6]),
  3588315303: (r, e) => new IFC4X3.IfcOpeningElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2837617999: (r, e) => new IFC4X3.IfcOutletType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  514975943: (r, e) => new IFC4X3.IfcPavementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2382730787: (r, e) => new IFC4X3.IfcPerformanceHistory(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, new IFC4X3.IfcLabel(e[6].value), e[7]),
  3566463478: (r, e) => new IFC4X3.IfcPermeableCoveringProperties(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4], e[5], e[6] ? new IFC4X3.IfcPositiveLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcPositiveLengthMeasure(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  3327091369: (r, e) => new IFC4X3.IfcPermit(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcText(e[8].value) : null),
  1158309216: (r, e) => new IFC4X3.IfcPileType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  804291784: (r, e) => new IFC4X3.IfcPipeFittingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4231323485: (r, e) => new IFC4X3.IfcPipeSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4017108033: (r, e) => new IFC4X3.IfcPlateType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2839578677: (r, e) => new IFC4X3.IfcPolygonalFaceSet(r, new Handle(e[0].value), e[1] ? new IFC4X3.IfcBoolean(e[1].value) : null, e[2].map((s) => new Handle(s.value)), e[3] ? e[3].map((s) => new IFC4X3.IfcPositiveInteger(s.value)) : null),
  3724593414: (r, e) => new IFC4X3.IfcPolyline(r, e[0].map((s) => new Handle(s.value))),
  3740093272: (r, e) => new IFC4X3.IfcPort(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  1946335990: (r, e) => new IFC4X3.IfcPositioningElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  2744685151: (r, e) => new IFC4X3.IfcProcedure(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7]),
  2904328755: (r, e) => new IFC4X3.IfcProjectOrder(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcText(e[8].value) : null),
  3651124850: (r, e) => new IFC4X3.IfcProjectionElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1842657554: (r, e) => new IFC4X3.IfcProtectiveDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2250791053: (r, e) => new IFC4X3.IfcPumpType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1763565496: (r, e) => new IFC4X3.IfcRailType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2893384427: (r, e) => new IFC4X3.IfcRailingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3992365140: (r, e) => new IFC4X3.IfcRailway(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9]),
  1891881377: (r, e) => new IFC4X3.IfcRailwayPart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10]),
  2324767716: (r, e) => new IFC4X3.IfcRampFlightType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1469900589: (r, e) => new IFC4X3.IfcRampType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  683857671: (r, e) => new IFC4X3.IfcRationalBSplineSurfaceWithKnots(r, new IFC4X3.IfcInteger(e[0].value), new IFC4X3.IfcInteger(e[1].value), e[2].map((s) => new Handle(s.value)), e[3], new IFC4X3.IfcLogical(e[4].value), new IFC4X3.IfcLogical(e[5].value), new IFC4X3.IfcLogical(e[6].value), e[7].map((s) => new IFC4X3.IfcInteger(s.value)), e[8].map((s) => new IFC4X3.IfcInteger(s.value)), e[9].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[10].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[11], e[12].map((s) => new IFC4X3.IfcReal(s.value))),
  4021432810: (r, e) => new IFC4X3.IfcReferent(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  3027567501: (r, e) => new IFC4X3.IfcReinforcingElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  964333572: (r, e) => new IFC4X3.IfcReinforcingElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  2320036040: (r, e) => new IFC4X3.IfcReinforcingMesh(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPositiveLengthMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcAreaMeasure(e[13].value) : null, e[14] ? new IFC4X3.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC4X3.IfcPositiveLengthMeasure(e[15].value) : null, e[16] ? new IFC4X3.IfcPositiveLengthMeasure(e[16].value) : null, e[17]),
  2310774935: (r, e) => new IFC4X3.IfcReinforcingMeshType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPositiveLengthMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveLengthMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcPositiveLengthMeasure(e[13].value) : null, e[14] ? new IFC4X3.IfcAreaMeasure(e[14].value) : null, e[15] ? new IFC4X3.IfcAreaMeasure(e[15].value) : null, e[16] ? new IFC4X3.IfcPositiveLengthMeasure(e[16].value) : null, e[17] ? new IFC4X3.IfcPositiveLengthMeasure(e[17].value) : null, e[18] ? new IFC4X3.IfcLabel(e[18].value) : null, e[19] ? e[19].map((s) => TypeInitialiser(3, s)) : null),
  3818125796: (r, e) => new IFC4X3.IfcRelAdheresToElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  160246688: (r, e) => new IFC4X3.IfcRelAggregates(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, new Handle(e[4].value), e[5].map((s) => new Handle(s.value))),
  146592293: (r, e) => new IFC4X3.IfcRoad(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9]),
  550521510: (r, e) => new IFC4X3.IfcRoadPart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10]),
  2781568857: (r, e) => new IFC4X3.IfcRoofType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1768891740: (r, e) => new IFC4X3.IfcSanitaryTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2157484638: (r, e) => new IFC4X3.IfcSeamCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2]),
  3649235739: (r, e) => new IFC4X3.IfcSecondOrderPolynomialSpiral(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null),
  544395925: (r, e) => new IFC4X3.IfcSegmentedReferenceCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value), new Handle(e[2].value), e[3] ? new Handle(e[3].value) : null),
  1027922057: (r, e) => new IFC4X3.IfcSeventhOrderPolynomialSpiral(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null, e[4] ? new IFC4X3.IfcLengthMeasure(e[4].value) : null, e[5] ? new IFC4X3.IfcLengthMeasure(e[5].value) : null, e[6] ? new IFC4X3.IfcLengthMeasure(e[6].value) : null, e[7] ? new IFC4X3.IfcLengthMeasure(e[7].value) : null, e[8] ? new IFC4X3.IfcLengthMeasure(e[8].value) : null),
  4074543187: (r, e) => new IFC4X3.IfcShadingDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  33720170: (r, e) => new IFC4X3.IfcSign(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3599934289: (r, e) => new IFC4X3.IfcSignType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1894708472: (r, e) => new IFC4X3.IfcSignalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  42703149: (r, e) => new IFC4X3.IfcSineSpiral(r, e[0] ? new Handle(e[0].value) : null, new IFC4X3.IfcLengthMeasure(e[1].value), e[2] ? new IFC4X3.IfcLengthMeasure(e[2].value) : null, e[3] ? new IFC4X3.IfcLengthMeasure(e[3].value) : null),
  4097777520: (r, e) => new IFC4X3.IfcSite(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4X3.IfcCompoundPlaneAngleMeasure(e[9].map((s) => s.value)) : null, e[10] ? new IFC4X3.IfcCompoundPlaneAngleMeasure(e[10].map((s) => s.value)) : null, e[11] ? new IFC4X3.IfcLengthMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcLabel(e[12].value) : null, e[13] ? new Handle(e[13].value) : null),
  2533589738: (r, e) => new IFC4X3.IfcSlabType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1072016465: (r, e) => new IFC4X3.IfcSolarDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3856911033: (r, e) => new IFC4X3.IfcSpace(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10] ? new IFC4X3.IfcLengthMeasure(e[10].value) : null),
  1305183839: (r, e) => new IFC4X3.IfcSpaceHeaterType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3812236995: (r, e) => new IFC4X3.IfcSpaceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcLabel(e[10].value) : null),
  3112655638: (r, e) => new IFC4X3.IfcStackTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1039846685: (r, e) => new IFC4X3.IfcStairFlightType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  338393293: (r, e) => new IFC4X3.IfcStairType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  682877961: (r, e) => new IFC4X3.IfcStructuralAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null),
  1179482911: (r, e) => new IFC4X3.IfcStructuralConnection(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  1004757350: (r, e) => new IFC4X3.IfcStructuralCurveAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null, e[10], e[11]),
  4243806635: (r, e) => new IFC4X3.IfcStructuralCurveConnection(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, new Handle(e[8].value)),
  214636428: (r, e) => new IFC4X3.IfcStructuralCurveMember(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], new Handle(e[8].value)),
  2445595289: (r, e) => new IFC4X3.IfcStructuralCurveMemberVarying(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], new Handle(e[8].value)),
  2757150158: (r, e) => new IFC4X3.IfcStructuralCurveReaction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9]),
  1807405624: (r, e) => new IFC4X3.IfcStructuralLinearAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1252848954: (r, e) => new IFC4X3.IfcStructuralLoadGroup(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6], e[7], e[8] ? new IFC4X3.IfcRatioMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcLabel(e[9].value) : null),
  2082059205: (r, e) => new IFC4X3.IfcStructuralPointAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null),
  734778138: (r, e) => new IFC4X3.IfcStructuralPointConnection(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null),
  1235345126: (r, e) => new IFC4X3.IfcStructuralPointReaction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8]),
  2986769608: (r, e) => new IFC4X3.IfcStructuralResultGroup(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, new IFC4X3.IfcBoolean(e[7].value)),
  3657597509: (r, e) => new IFC4X3.IfcStructuralSurfaceAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1975003073: (r, e) => new IFC4X3.IfcStructuralSurfaceConnection(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null),
  148013059: (r, e) => new IFC4X3.IfcSubContractResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  3101698114: (r, e) => new IFC4X3.IfcSurfaceFeature(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2315554128: (r, e) => new IFC4X3.IfcSwitchingDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2254336722: (r, e) => new IFC4X3.IfcSystem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null),
  413509423: (r, e) => new IFC4X3.IfcSystemFurnitureElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  5716631: (r, e) => new IFC4X3.IfcTankType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3824725483: (r, e) => new IFC4X3.IfcTendon(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcForceMeasure(e[12].value) : null, e[13] ? new IFC4X3.IfcPressureMeasure(e[13].value) : null, e[14] ? new IFC4X3.IfcNormalisedRatioMeasure(e[14].value) : null, e[15] ? new IFC4X3.IfcPositiveLengthMeasure(e[15].value) : null, e[16] ? new IFC4X3.IfcPositiveLengthMeasure(e[16].value) : null),
  2347447852: (r, e) => new IFC4X3.IfcTendonAnchor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3081323446: (r, e) => new IFC4X3.IfcTendonAnchorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3663046924: (r, e) => new IFC4X3.IfcTendonConduit(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2281632017: (r, e) => new IFC4X3.IfcTendonConduitType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2415094496: (r, e) => new IFC4X3.IfcTendonType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveLengthMeasure(e[12].value) : null),
  618700268: (r, e) => new IFC4X3.IfcTrackElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1692211062: (r, e) => new IFC4X3.IfcTransformerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2097647324: (r, e) => new IFC4X3.IfcTransportElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1953115116: (r, e) => new IFC4X3.IfcTransportationDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3593883385: (r, e) => new IFC4X3.IfcTrimmedCurve(r, new Handle(e[0].value), e[1].map((s) => new Handle(s.value)), e[2].map((s) => new Handle(s.value)), new IFC4X3.IfcBoolean(e[3].value), e[4]),
  1600972822: (r, e) => new IFC4X3.IfcTubeBundleType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1911125066: (r, e) => new IFC4X3.IfcUnitaryEquipmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  728799441: (r, e) => new IFC4X3.IfcValveType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  840318589: (r, e) => new IFC4X3.IfcVehicle(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1530820697: (r, e) => new IFC4X3.IfcVibrationDamper(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3956297820: (r, e) => new IFC4X3.IfcVibrationDamperType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2391383451: (r, e) => new IFC4X3.IfcVibrationIsolator(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3313531582: (r, e) => new IFC4X3.IfcVibrationIsolatorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2769231204: (r, e) => new IFC4X3.IfcVirtualElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  926996030: (r, e) => new IFC4X3.IfcVoidingFeature(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1898987631: (r, e) => new IFC4X3.IfcWallType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1133259667: (r, e) => new IFC4X3.IfcWasteTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4009809668: (r, e) => new IFC4X3.IfcWindowType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10], e[11] ? new IFC4X3.IfcBoolean(e[11].value) : null, e[12] ? new IFC4X3.IfcLabel(e[12].value) : null),
  4088093105: (r, e) => new IFC4X3.IfcWorkCalendar(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8]),
  1028945134: (r, e) => new IFC4X3.IfcWorkControl(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, new IFC4X3.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcDuration(e[9].value) : null, e[10] ? new IFC4X3.IfcDuration(e[10].value) : null, new IFC4X3.IfcDateTime(e[11].value), e[12] ? new IFC4X3.IfcDateTime(e[12].value) : null),
  4218914973: (r, e) => new IFC4X3.IfcWorkPlan(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, new IFC4X3.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcDuration(e[9].value) : null, e[10] ? new IFC4X3.IfcDuration(e[10].value) : null, new IFC4X3.IfcDateTime(e[11].value), e[12] ? new IFC4X3.IfcDateTime(e[12].value) : null, e[13]),
  3342526732: (r, e) => new IFC4X3.IfcWorkSchedule(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, new IFC4X3.IfcDateTime(e[6].value), e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcDuration(e[9].value) : null, e[10] ? new IFC4X3.IfcDuration(e[10].value) : null, new IFC4X3.IfcDateTime(e[11].value), e[12] ? new IFC4X3.IfcDateTime(e[12].value) : null, e[13]),
  1033361043: (r, e) => new IFC4X3.IfcZone(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null),
  3821786052: (r, e) => new IFC4X3.IfcActionRequest(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6], e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcText(e[8].value) : null),
  1411407467: (r, e) => new IFC4X3.IfcAirTerminalBoxType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3352864051: (r, e) => new IFC4X3.IfcAirTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1871374353: (r, e) => new IFC4X3.IfcAirToAirHeatRecoveryType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4266260250: (r, e) => new IFC4X3.IfcAlignmentCant(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new IFC4X3.IfcPositiveLengthMeasure(e[7].value)),
  1545765605: (r, e) => new IFC4X3.IfcAlignmentHorizontal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  317615605: (r, e) => new IFC4X3.IfcAlignmentSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value)),
  1662888072: (r, e) => new IFC4X3.IfcAlignmentVertical(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  3460190687: (r, e) => new IFC4X3.IfcAsset(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? new Handle(e[8].value) : null, e[9] ? new Handle(e[9].value) : null, e[10] ? new Handle(e[10].value) : null, e[11] ? new Handle(e[11].value) : null, e[12] ? new IFC4X3.IfcDate(e[12].value) : null, e[13] ? new Handle(e[13].value) : null),
  1532957894: (r, e) => new IFC4X3.IfcAudioVisualApplianceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1967976161: (r, e) => new IFC4X3.IfcBSplineCurve(r, new IFC4X3.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4X3.IfcLogical(e[3].value), new IFC4X3.IfcLogical(e[4].value)),
  2461110595: (r, e) => new IFC4X3.IfcBSplineCurveWithKnots(r, new IFC4X3.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4X3.IfcLogical(e[3].value), new IFC4X3.IfcLogical(e[4].value), e[5].map((s) => new IFC4X3.IfcInteger(s.value)), e[6].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[7]),
  819618141: (r, e) => new IFC4X3.IfcBeamType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3649138523: (r, e) => new IFC4X3.IfcBearingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  231477066: (r, e) => new IFC4X3.IfcBoilerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1136057603: (r, e) => new IFC4X3.IfcBoundaryCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value)),
  644574406: (r, e) => new IFC4X3.IfcBridge(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9]),
  963979645: (r, e) => new IFC4X3.IfcBridgePart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9], e[10]),
  4031249490: (r, e) => new IFC4X3.IfcBuilding(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8], e[9] ? new IFC4X3.IfcLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcLengthMeasure(e[10].value) : null, e[11] ? new Handle(e[11].value) : null),
  2979338954: (r, e) => new IFC4X3.IfcBuildingElementPart(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  39481116: (r, e) => new IFC4X3.IfcBuildingElementPartType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1909888760: (r, e) => new IFC4X3.IfcBuildingElementProxyType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1177604601: (r, e) => new IFC4X3.IfcBuildingSystem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null),
  1876633798: (r, e) => new IFC4X3.IfcBuiltElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3862327254: (r, e) => new IFC4X3.IfcBuiltSystem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new IFC4X3.IfcLabel(e[6].value) : null),
  2188180465: (r, e) => new IFC4X3.IfcBurnerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  395041908: (r, e) => new IFC4X3.IfcCableCarrierFittingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3293546465: (r, e) => new IFC4X3.IfcCableCarrierSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2674252688: (r, e) => new IFC4X3.IfcCableFittingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1285652485: (r, e) => new IFC4X3.IfcCableSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3203706013: (r, e) => new IFC4X3.IfcCaissonFoundationType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2951183804: (r, e) => new IFC4X3.IfcChillerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3296154744: (r, e) => new IFC4X3.IfcChimney(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2611217952: (r, e) => new IFC4X3.IfcCircle(r, new Handle(e[0].value), new IFC4X3.IfcPositiveLengthMeasure(e[1].value)),
  1677625105: (r, e) => new IFC4X3.IfcCivilElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2301859152: (r, e) => new IFC4X3.IfcCoilType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  843113511: (r, e) => new IFC4X3.IfcColumn(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  400855858: (r, e) => new IFC4X3.IfcCommunicationsApplianceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3850581409: (r, e) => new IFC4X3.IfcCompressorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2816379211: (r, e) => new IFC4X3.IfcCondenserType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3898045240: (r, e) => new IFC4X3.IfcConstructionEquipmentResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  1060000209: (r, e) => new IFC4X3.IfcConstructionMaterialResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  488727124: (r, e) => new IFC4X3.IfcConstructionProductResource(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcIdentifier(e[5].value) : null, e[6] ? new IFC4X3.IfcText(e[6].value) : null, e[7] ? new Handle(e[7].value) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null, e[10]),
  2940368186: (r, e) => new IFC4X3.IfcConveyorSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  335055490: (r, e) => new IFC4X3.IfcCooledBeamType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2954562838: (r, e) => new IFC4X3.IfcCoolingTowerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1502416096: (r, e) => new IFC4X3.IfcCourse(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1973544240: (r, e) => new IFC4X3.IfcCovering(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3495092785: (r, e) => new IFC4X3.IfcCurtainWall(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3961806047: (r, e) => new IFC4X3.IfcDamperType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3426335179: (r, e) => new IFC4X3.IfcDeepFoundation(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1335981549: (r, e) => new IFC4X3.IfcDiscreteAccessory(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2635815018: (r, e) => new IFC4X3.IfcDiscreteAccessoryType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  479945903: (r, e) => new IFC4X3.IfcDistributionBoardType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1599208980: (r, e) => new IFC4X3.IfcDistributionChamberElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2063403501: (r, e) => new IFC4X3.IfcDistributionControlElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null),
  1945004755: (r, e) => new IFC4X3.IfcDistributionElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3040386961: (r, e) => new IFC4X3.IfcDistributionFlowElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3041715199: (r, e) => new IFC4X3.IfcDistributionPort(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7], e[8], e[9]),
  3205830791: (r, e) => new IFC4X3.IfcDistributionSystem(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6]),
  395920057: (r, e) => new IFC4X3.IfcDoor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4X3.IfcLabel(e[12].value) : null),
  869906466: (r, e) => new IFC4X3.IfcDuctFittingType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3760055223: (r, e) => new IFC4X3.IfcDuctSegmentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2030761528: (r, e) => new IFC4X3.IfcDuctSilencerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3071239417: (r, e) => new IFC4X3.IfcEarthworksCut(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1077100507: (r, e) => new IFC4X3.IfcEarthworksElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3376911765: (r, e) => new IFC4X3.IfcEarthworksFill(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  663422040: (r, e) => new IFC4X3.IfcElectricApplianceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2417008758: (r, e) => new IFC4X3.IfcElectricDistributionBoardType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3277789161: (r, e) => new IFC4X3.IfcElectricFlowStorageDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2142170206: (r, e) => new IFC4X3.IfcElectricFlowTreatmentDeviceType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1534661035: (r, e) => new IFC4X3.IfcElectricGeneratorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1217240411: (r, e) => new IFC4X3.IfcElectricMotorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  712377611: (r, e) => new IFC4X3.IfcElectricTimeControlType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1658829314: (r, e) => new IFC4X3.IfcEnergyConversionDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2814081492: (r, e) => new IFC4X3.IfcEngine(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3747195512: (r, e) => new IFC4X3.IfcEvaporativeCooler(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  484807127: (r, e) => new IFC4X3.IfcEvaporator(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1209101575: (r, e) => new IFC4X3.IfcExternalSpatialElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8]),
  346874300: (r, e) => new IFC4X3.IfcFanType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1810631287: (r, e) => new IFC4X3.IfcFilterType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4222183408: (r, e) => new IFC4X3.IfcFireSuppressionTerminalType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2058353004: (r, e) => new IFC4X3.IfcFlowController(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  4278956645: (r, e) => new IFC4X3.IfcFlowFitting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  4037862832: (r, e) => new IFC4X3.IfcFlowInstrumentType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  2188021234: (r, e) => new IFC4X3.IfcFlowMeter(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3132237377: (r, e) => new IFC4X3.IfcFlowMovingDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  987401354: (r, e) => new IFC4X3.IfcFlowSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  707683696: (r, e) => new IFC4X3.IfcFlowStorageDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2223149337: (r, e) => new IFC4X3.IfcFlowTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3508470533: (r, e) => new IFC4X3.IfcFlowTreatmentDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  900683007: (r, e) => new IFC4X3.IfcFooting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2713699986: (r, e) => new IFC4X3.IfcGeotechnicalAssembly(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  3009204131: (r, e) => new IFC4X3.IfcGrid(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7].map((s) => new Handle(s.value)), e[8].map((s) => new Handle(s.value)), e[9] ? e[9].map((s) => new Handle(s.value)) : null, e[10]),
  3319311131: (r, e) => new IFC4X3.IfcHeatExchanger(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2068733104: (r, e) => new IFC4X3.IfcHumidifier(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4175244083: (r, e) => new IFC4X3.IfcInterceptor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2176052936: (r, e) => new IFC4X3.IfcJunctionBox(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2696325953: (r, e) => new IFC4X3.IfcKerb(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, new IFC4X3.IfcBoolean(e[8].value)),
  76236018: (r, e) => new IFC4X3.IfcLamp(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  629592764: (r, e) => new IFC4X3.IfcLightFixture(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1154579445: (r, e) => new IFC4X3.IfcLinearPositioningElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null),
  1638804497: (r, e) => new IFC4X3.IfcLiquidTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1437502449: (r, e) => new IFC4X3.IfcMedicalDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1073191201: (r, e) => new IFC4X3.IfcMember(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2078563270: (r, e) => new IFC4X3.IfcMobileTelecommunicationsAppliance(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  234836483: (r, e) => new IFC4X3.IfcMooringDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2474470126: (r, e) => new IFC4X3.IfcMotorConnection(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2182337498: (r, e) => new IFC4X3.IfcNavigationElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  144952367: (r, e) => new IFC4X3.IfcOuterBoundaryCurve(r, e[0].map((s) => new Handle(s.value)), new IFC4X3.IfcLogical(e[1].value)),
  3694346114: (r, e) => new IFC4X3.IfcOutlet(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1383356374: (r, e) => new IFC4X3.IfcPavement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1687234759: (r, e) => new IFC4X3.IfcPile(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8], e[9]),
  310824031: (r, e) => new IFC4X3.IfcPipeFitting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3612865200: (r, e) => new IFC4X3.IfcPipeSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3171933400: (r, e) => new IFC4X3.IfcPlate(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  738039164: (r, e) => new IFC4X3.IfcProtectiveDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  655969474: (r, e) => new IFC4X3.IfcProtectiveDeviceTrippingUnitType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  90941305: (r, e) => new IFC4X3.IfcPump(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3290496277: (r, e) => new IFC4X3.IfcRail(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2262370178: (r, e) => new IFC4X3.IfcRailing(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3024970846: (r, e) => new IFC4X3.IfcRamp(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3283111854: (r, e) => new IFC4X3.IfcRampFlight(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1232101972: (r, e) => new IFC4X3.IfcRationalBSplineCurveWithKnots(r, new IFC4X3.IfcInteger(e[0].value), e[1].map((s) => new Handle(s.value)), e[2], new IFC4X3.IfcLogical(e[3].value), new IFC4X3.IfcLogical(e[4].value), e[5].map((s) => new IFC4X3.IfcInteger(s.value)), e[6].map((s) => new IFC4X3.IfcParameterValue(s.value)), e[7], e[8].map((s) => new IFC4X3.IfcReal(s.value))),
  3798194928: (r, e) => new IFC4X3.IfcReinforcedSoil(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  979691226: (r, e) => new IFC4X3.IfcReinforcingBar(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10] ? new IFC4X3.IfcAreaMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPositiveLengthMeasure(e[11].value) : null, e[12], e[13]),
  2572171363: (r, e) => new IFC4X3.IfcReinforcingBarType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9], e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcAreaMeasure(e[11].value) : null, e[12] ? new IFC4X3.IfcPositiveLengthMeasure(e[12].value) : null, e[13], e[14] ? new IFC4X3.IfcLabel(e[14].value) : null, e[15] ? e[15].map((s) => TypeInitialiser(3, s)) : null),
  2016517767: (r, e) => new IFC4X3.IfcRoof(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3053780830: (r, e) => new IFC4X3.IfcSanitaryTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1783015770: (r, e) => new IFC4X3.IfcSensorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1329646415: (r, e) => new IFC4X3.IfcShadingDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  991950508: (r, e) => new IFC4X3.IfcSignal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1529196076: (r, e) => new IFC4X3.IfcSlab(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3420628829: (r, e) => new IFC4X3.IfcSolarDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1999602285: (r, e) => new IFC4X3.IfcSpaceHeater(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1404847402: (r, e) => new IFC4X3.IfcStackTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  331165859: (r, e) => new IFC4X3.IfcStair(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4252922144: (r, e) => new IFC4X3.IfcStairFlight(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcInteger(e[8].value) : null, e[9] ? new IFC4X3.IfcInteger(e[9].value) : null, e[10] ? new IFC4X3.IfcPositiveLengthMeasure(e[10].value) : null, e[11] ? new IFC4X3.IfcPositiveLengthMeasure(e[11].value) : null, e[12]),
  2515109513: (r, e) => new IFC4X3.IfcStructuralAnalysisModel(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6] ? new Handle(e[6].value) : null, e[7] ? e[7].map((s) => new Handle(s.value)) : null, e[8] ? e[8].map((s) => new Handle(s.value)) : null, e[9] ? new Handle(e[9].value) : null),
  385403989: (r, e) => new IFC4X3.IfcStructuralLoadCase(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5], e[6], e[7], e[8] ? new IFC4X3.IfcRatioMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcLabel(e[9].value) : null, e[10] ? e[10].map((s) => new IFC4X3.IfcRatioMeasure(s.value)) : null),
  1621171031: (r, e) => new IFC4X3.IfcStructuralPlanarAction(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, new Handle(e[7].value), e[8], e[9] ? new IFC4X3.IfcBoolean(e[9].value) : null, e[10], e[11]),
  1162798199: (r, e) => new IFC4X3.IfcSwitchingDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  812556717: (r, e) => new IFC4X3.IfcTank(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3425753595: (r, e) => new IFC4X3.IfcTrackElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3825984169: (r, e) => new IFC4X3.IfcTransformer(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1620046519: (r, e) => new IFC4X3.IfcTransportElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3026737570: (r, e) => new IFC4X3.IfcTubeBundle(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3179687236: (r, e) => new IFC4X3.IfcUnitaryControlElementType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  4292641817: (r, e) => new IFC4X3.IfcUnitaryEquipment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4207607924: (r, e) => new IFC4X3.IfcValve(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2391406946: (r, e) => new IFC4X3.IfcWall(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3512223829: (r, e) => new IFC4X3.IfcWallStandardCase(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4237592921: (r, e) => new IFC4X3.IfcWasteTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3304561284: (r, e) => new IFC4X3.IfcWindow(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8] ? new IFC4X3.IfcPositiveLengthMeasure(e[8].value) : null, e[9] ? new IFC4X3.IfcPositiveLengthMeasure(e[9].value) : null, e[10], e[11], e[12] ? new IFC4X3.IfcLabel(e[12].value) : null),
  2874132201: (r, e) => new IFC4X3.IfcActuatorType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  1634111441: (r, e) => new IFC4X3.IfcAirTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  177149247: (r, e) => new IFC4X3.IfcAirTerminalBox(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2056796094: (r, e) => new IFC4X3.IfcAirToAirHeatRecovery(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3001207471: (r, e) => new IFC4X3.IfcAlarmType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  325726236: (r, e) => new IFC4X3.IfcAlignment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7]),
  277319702: (r, e) => new IFC4X3.IfcAudioVisualAppliance(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  753842376: (r, e) => new IFC4X3.IfcBeam(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4196446775: (r, e) => new IFC4X3.IfcBearing(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  32344328: (r, e) => new IFC4X3.IfcBoiler(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3314249567: (r, e) => new IFC4X3.IfcBorehole(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1095909175: (r, e) => new IFC4X3.IfcBuildingElementProxy(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2938176219: (r, e) => new IFC4X3.IfcBurner(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  635142910: (r, e) => new IFC4X3.IfcCableCarrierFitting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3758799889: (r, e) => new IFC4X3.IfcCableCarrierSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1051757585: (r, e) => new IFC4X3.IfcCableFitting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4217484030: (r, e) => new IFC4X3.IfcCableSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3999819293: (r, e) => new IFC4X3.IfcCaissonFoundation(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3902619387: (r, e) => new IFC4X3.IfcChiller(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  639361253: (r, e) => new IFC4X3.IfcCoil(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3221913625: (r, e) => new IFC4X3.IfcCommunicationsAppliance(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3571504051: (r, e) => new IFC4X3.IfcCompressor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2272882330: (r, e) => new IFC4X3.IfcCondenser(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  578613899: (r, e) => new IFC4X3.IfcControllerType(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcIdentifier(e[4].value) : null, e[5] ? e[5].map((s) => new Handle(s.value)) : null, e[6] ? e[6].map((s) => new Handle(s.value)) : null, e[7] ? new IFC4X3.IfcLabel(e[7].value) : null, e[8] ? new IFC4X3.IfcLabel(e[8].value) : null, e[9]),
  3460952963: (r, e) => new IFC4X3.IfcConveyorSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4136498852: (r, e) => new IFC4X3.IfcCooledBeam(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3640358203: (r, e) => new IFC4X3.IfcCoolingTower(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4074379575: (r, e) => new IFC4X3.IfcDamper(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3693000487: (r, e) => new IFC4X3.IfcDistributionBoard(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1052013943: (r, e) => new IFC4X3.IfcDistributionChamberElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  562808652: (r, e) => new IFC4X3.IfcDistributionCircuit(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new IFC4X3.IfcLabel(e[5].value) : null, e[6]),
  1062813311: (r, e) => new IFC4X3.IfcDistributionControlElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  342316401: (r, e) => new IFC4X3.IfcDuctFitting(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3518393246: (r, e) => new IFC4X3.IfcDuctSegment(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1360408905: (r, e) => new IFC4X3.IfcDuctSilencer(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1904799276: (r, e) => new IFC4X3.IfcElectricAppliance(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  862014818: (r, e) => new IFC4X3.IfcElectricDistributionBoard(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3310460725: (r, e) => new IFC4X3.IfcElectricFlowStorageDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  24726584: (r, e) => new IFC4X3.IfcElectricFlowTreatmentDevice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  264262732: (r, e) => new IFC4X3.IfcElectricGenerator(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  402227799: (r, e) => new IFC4X3.IfcElectricMotor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1003880860: (r, e) => new IFC4X3.IfcElectricTimeControl(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3415622556: (r, e) => new IFC4X3.IfcFan(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  819412036: (r, e) => new IFC4X3.IfcFilter(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  1426591983: (r, e) => new IFC4X3.IfcFireSuppressionTerminal(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  182646315: (r, e) => new IFC4X3.IfcFlowInstrument(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  2680139844: (r, e) => new IFC4X3.IfcGeomodel(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  1971632696: (r, e) => new IFC4X3.IfcGeoslice(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null),
  2295281155: (r, e) => new IFC4X3.IfcProtectiveDeviceTrippingUnit(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4086658281: (r, e) => new IFC4X3.IfcSensor(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  630975310: (r, e) => new IFC4X3.IfcUnitaryControlElement(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  4288193352: (r, e) => new IFC4X3.IfcActuator(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  3087945054: (r, e) => new IFC4X3.IfcAlarm(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8]),
  25142252: (r, e) => new IFC4X3.IfcController(r, new IFC4X3.IfcGloballyUniqueId(e[0].value), e[1] ? new Handle(e[1].value) : null, e[2] ? new IFC4X3.IfcLabel(e[2].value) : null, e[3] ? new IFC4X3.IfcText(e[3].value) : null, e[4] ? new IFC4X3.IfcLabel(e[4].value) : null, e[5] ? new Handle(e[5].value) : null, e[6] ? new Handle(e[6].value) : null, e[7] ? new IFC4X3.IfcIdentifier(e[7].value) : null, e[8])
};
InheritanceDef[3] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  2879124712: [IFCALIGNMENTHORIZONTALSEGMENT, IFCALIGNMENTCANTSEGMENT, IFCALIGNMENTVERTICALSEGMENT],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCLINEARPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCOPENCROSSPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  222769930: [IFCTEXTURECOORDINATEINDICESWITHVOIDS],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  823603102: [IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE],
  593015953: [IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  2652556860: [IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  590820931: [IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1862484736: [IFCSECTIONEDSOLIDHORIZONTAL],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY],
  3893378262: [IFCSPACETYPE],
  2735484536: [IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET],
  3665877780: [IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE],
  2916149573: [IFCTRIANGULATEDIRREGULARNETWORK],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1626504194: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  1306400036: [IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  24185140: [IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY],
  1310830890: [IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON],
  2827207264: [IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  4230923436: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  2176059722: [IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT],
  3740093272: [IFCDISTRIBUTIONPORT],
  1946335990: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1953115116: [IFCTRANSPORTELEMENT, IFCVEHICLE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  1876633798: [IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY],
  3426335179: [IFCCAISSONFOUNDATION, IFCPILE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  1077100507: [IFCREINFORCEDSOIL, IFCEARTHWORKSFILL],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR],
  2713699986: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE],
  1154579445: [IFCALIGNMENT],
  2391406946: [IFCWALLSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[3] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  618182010: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, !0], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, !0], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, !0], ["Relates", IFCAPPROVALRELATIONSHIP, 2, !0]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0]],
  852622518: [["PartOfW", IFCGRID, 9, !0], ["PartOfV", IFCGRID, 8, !0], ["PartOfU", IFCGRID, 7, !0], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, !0]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, !0], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, !0]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, !0]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, !1]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, !1]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, !1]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, !1]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, !0]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, !0]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, !0], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, !0], ["Engages", IFCPERSONANDORGANIZATION, 1, !0]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, !0]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3355820592: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2691318326: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, !0], ["MapUsage", IFCMAPPEDITEM, 0, !0]],
  867548509: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  912023232: [["OfPerson", IFCPERSON, 7, !0], ["OfOrganization", IFCORGANIZATION, 4, !0]],
  222769930: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, !1]],
  1010789467: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, !1]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, !0], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, !0], ["OfShapeAspect", IFCSHAPEASPECT, 0, !0]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, !0], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, !0]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, !0], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, !0]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, !0], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, !0], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, !0], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, !0]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, !0], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, !0]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, !0], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, !0], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, !0]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, !0]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  388784114: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, !0]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, !0], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, !0]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, !0], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, !0], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, !0]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, !1]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCMATERIALPROPERTIES, 3, !0]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, !0]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  182550632: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, !0]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, !0], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, !0]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2165702409: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, !0], ["HasShapeAspects", IFCSHAPEASPECT, 4, !0]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  823603102: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasTextureMaps", IFCTEXTUREMAP, 2, !0]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3425423356: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4212018352: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  593015953: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["ToFaceSet", IFCPOLYGONALFACESET, 2, !0], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, !0]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["ToFaceSet", IFCPOLYGONALFACESET, 2, !0], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, !0]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0]],
  590820931: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2485787929: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3381221214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Declares", IFCRELDECLARES, 4, !0]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  492091185: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, !0]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["PartOfPset", IFCPROPERTYSET, 4, !0], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, !0], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, !0], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, !0], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, !0], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, !0]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, !0]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, !0], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, !0]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["UsingCurves", IFCCOMPOSITECURVE, 0, !0]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1862484736: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1290935644: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1356537516: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2735484536: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  782932809: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3665877780: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  1229763772: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  3651464721: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  336235671: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  512836454: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  1626504194: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, !0], ["HasProperties", IFCPROFILEPROPERTIES, 3, !0]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3497074424: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, !0], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, !0]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  2000195564: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  4189326743: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1306400036: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4234616927: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  24185140: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  1310830890: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  4228831410: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  4230923436: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1594536857: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2898700619: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2568555532: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3948183225: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  679976338: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2176059722: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1770583370: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  525669439: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  976884017: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1950438474: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  710110818: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  506776471: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, !0]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1], ["HasFillings", IFCRELFILLSELEMENT, 4, !0]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  514975943: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["DefinesType", IFCTYPEOBJECT, 5, !0], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, !0], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, !0]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0], ["HasColours", IFCINDEXEDCOLOURMAP, 0, !0], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, !0]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !0], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  1946335990: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["Positions", IFCRELPOSITIONS, 4, !0]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsPredecessorTo", IFCRELSEQUENCE, 4, !0], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, !0], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, !0]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, !1]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1763565496: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3992365140: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  1891881377: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4021432810: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["Positions", IFCRELPOSITIONS, 4, !0]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  146592293: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  550521510: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3649235739: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  544395925: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1027922057: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  33720170: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3599934289: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1894708472: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  42703149: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasCoverings", IFCRELCOVERSSPACES, 4, !0], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, !0]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, !0]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, !0], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, !0]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, !0]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, !0], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, !0]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["AdheresToElement", IFCRELADHERESTOELEMENT, 5, !1]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3663046924: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2281632017: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  618700268: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1953115116: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  840318589: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1530820697: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3956297820: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["Controls", IFCRELASSIGNSTOCONTROL, 6, !0]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4266260250: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1545765605: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  317615605: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1662888072: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3649138523: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  644574406: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  963979645: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1876633798: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3862327254: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3203706013: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, !0]],
  2940368186: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1502416096: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["CoversSpaces", IFCRELCOVERSSPACES, 5, !0], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, !0]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3426335179: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  479945903: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, !0], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, !0], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, !0]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3071239417: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["VoidsElements", IFCRELVOIDSELEMENT, 5, !1]],
  1077100507: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3376911765: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2142170206: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, !0], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, !0], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, !0]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2713699986: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["Positions", IFCRELPOSITIONS, 4, !0]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2696325953: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1154579445: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["Positions", IFCRELPOSITIONS, 4, !0]],
  1638804497: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2078563270: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  234836483: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2182337498: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1383356374: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3290496277: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, !0], ["StyledByItem", IFCSTYLEDITEM, 0, !0]],
  3798194928: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  991950508: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, !0], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, !0]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, !0]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3425753595: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  325726236: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["Positions", IFCRELPOSITIONS, 4, !0]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  4196446775: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3314249567: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3999819293: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["Types", IFCRELDEFINESBYTYPE, 5, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0]],
  3460952963: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3693000487: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, !0], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  24726584: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, !0]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  2680139844: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  1971632696: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, !0], ["Nests", IFCRELNESTS, 5, !0], ["IsNestedBy", IFCRELNESTS, 4, !0], ["HasContext", IFCRELDECLARES, 5, !0], ["IsDecomposedBy", IFCRELAGGREGATES, 4, !0], ["Decomposes", IFCRELAGGREGATES, 5, !0], ["HasAssociations", IFCRELASSOCIATES, 4, !0], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, !0], ["Declares", IFCRELDEFINESBYOBJECT, 5, !0], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, !0], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, !0], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, !0], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, !0], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, !0], ["FillsVoids", IFCRELFILLSELEMENT, 5, !0], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, !0], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, !0], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, !0], ["HasProjections", IFCRELPROJECTSELEMENT, 4, !0], ["HasOpenings", IFCRELVOIDSELEMENT, 4, !0], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, !0], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, !0], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, !0], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, !0], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, !0], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, !0], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, !0], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, !0]]
};
Constructors[3] = {
  3630933823: (r, e) => new IFC4X3.IfcActorRole(r, e[0], e[1], e[2]),
  618182010: (r, e) => new IFC4X3.IfcAddress(r, e[0], e[1], e[2]),
  2879124712: (r, e) => new IFC4X3.IfcAlignmentParameterSegment(r, e[0], e[1]),
  3633395639: (r, e) => new IFC4X3.IfcAlignmentVerticalSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639542469: (r, e) => new IFC4X3.IfcApplication(r, e[0], e[1], e[2], e[3]),
  411424972: (r, e) => new IFC4X3.IfcAppliedValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  130549933: (r, e) => new IFC4X3.IfcApproval(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4037036970: (r, e) => new IFC4X3.IfcBoundaryCondition(r, e[0]),
  1560379544: (r, e) => new IFC4X3.IfcBoundaryEdgeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3367102660: (r, e) => new IFC4X3.IfcBoundaryFaceCondition(r, e[0], e[1], e[2], e[3]),
  1387855156: (r, e) => new IFC4X3.IfcBoundaryNodeCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2069777674: (r, e) => new IFC4X3.IfcBoundaryNodeConditionWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2859738748: (r, e) => new IFC4X3.IfcConnectionGeometry(r),
  2614616156: (r, e) => new IFC4X3.IfcConnectionPointGeometry(r, e[0], e[1]),
  2732653382: (r, e) => new IFC4X3.IfcConnectionSurfaceGeometry(r, e[0], e[1]),
  775493141: (r, e) => new IFC4X3.IfcConnectionVolumeGeometry(r, e[0], e[1]),
  1959218052: (r, e) => new IFC4X3.IfcConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1785450214: (r, e) => new IFC4X3.IfcCoordinateOperation(r, e[0], e[1]),
  1466758467: (r, e) => new IFC4X3.IfcCoordinateReferenceSystem(r, e[0], e[1], e[2], e[3]),
  602808272: (r, e) => new IFC4X3.IfcCostValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1765591967: (r, e) => new IFC4X3.IfcDerivedUnit(r, e[0], e[1], e[2], e[3]),
  1045800335: (r, e) => new IFC4X3.IfcDerivedUnitElement(r, e[0], e[1]),
  2949456006: (r, e) => new IFC4X3.IfcDimensionalExponents(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4294318154: (r, e) => new IFC4X3.IfcExternalInformation(r),
  3200245327: (r, e) => new IFC4X3.IfcExternalReference(r, e[0], e[1], e[2]),
  2242383968: (r, e) => new IFC4X3.IfcExternallyDefinedHatchStyle(r, e[0], e[1], e[2]),
  1040185647: (r, e) => new IFC4X3.IfcExternallyDefinedSurfaceStyle(r, e[0], e[1], e[2]),
  3548104201: (r, e) => new IFC4X3.IfcExternallyDefinedTextFont(r, e[0], e[1], e[2]),
  852622518: (r, e) => new IFC4X3.IfcGridAxis(r, e[0], e[1], e[2]),
  3020489413: (r, e) => new IFC4X3.IfcIrregularTimeSeriesValue(r, e[0], e[1]),
  2655187982: (r, e) => new IFC4X3.IfcLibraryInformation(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3452421091: (r, e) => new IFC4X3.IfcLibraryReference(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4162380809: (r, e) => new IFC4X3.IfcLightDistributionData(r, e[0], e[1], e[2]),
  1566485204: (r, e) => new IFC4X3.IfcLightIntensityDistribution(r, e[0], e[1]),
  3057273783: (r, e) => new IFC4X3.IfcMapConversion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1847130766: (r, e) => new IFC4X3.IfcMaterialClassificationRelationship(r, e[0], e[1]),
  760658860: (r, e) => new IFC4X3.IfcMaterialDefinition(r),
  248100487: (r, e) => new IFC4X3.IfcMaterialLayer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3303938423: (r, e) => new IFC4X3.IfcMaterialLayerSet(r, e[0], e[1], e[2]),
  1847252529: (r, e) => new IFC4X3.IfcMaterialLayerWithOffsets(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2199411900: (r, e) => new IFC4X3.IfcMaterialList(r, e[0]),
  2235152071: (r, e) => new IFC4X3.IfcMaterialProfile(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  164193824: (r, e) => new IFC4X3.IfcMaterialProfileSet(r, e[0], e[1], e[2], e[3]),
  552965576: (r, e) => new IFC4X3.IfcMaterialProfileWithOffsets(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1507914824: (r, e) => new IFC4X3.IfcMaterialUsageDefinition(r),
  2597039031: (r, e) => new IFC4X3.IfcMeasureWithUnit(r, e[0], e[1]),
  3368373690: (r, e) => new IFC4X3.IfcMetric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2706619895: (r, e) => new IFC4X3.IfcMonetaryUnit(r, e[0]),
  1918398963: (r, e) => new IFC4X3.IfcNamedUnit(r, e[0], e[1]),
  3701648758: (r, e) => new IFC4X3.IfcObjectPlacement(r, e[0]),
  2251480897: (r, e) => new IFC4X3.IfcObjective(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4251960020: (r, e) => new IFC4X3.IfcOrganization(r, e[0], e[1], e[2], e[3], e[4]),
  1207048766: (r, e) => new IFC4X3.IfcOwnerHistory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2077209135: (r, e) => new IFC4X3.IfcPerson(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  101040310: (r, e) => new IFC4X3.IfcPersonAndOrganization(r, e[0], e[1], e[2]),
  2483315170: (r, e) => new IFC4X3.IfcPhysicalQuantity(r, e[0], e[1]),
  2226359599: (r, e) => new IFC4X3.IfcPhysicalSimpleQuantity(r, e[0], e[1], e[2]),
  3355820592: (r, e) => new IFC4X3.IfcPostalAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  677532197: (r, e) => new IFC4X3.IfcPresentationItem(r),
  2022622350: (r, e) => new IFC4X3.IfcPresentationLayerAssignment(r, e[0], e[1], e[2], e[3]),
  1304840413: (r, e) => new IFC4X3.IfcPresentationLayerWithStyle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3119450353: (r, e) => new IFC4X3.IfcPresentationStyle(r, e[0]),
  2095639259: (r, e) => new IFC4X3.IfcProductRepresentation(r, e[0], e[1], e[2]),
  3958567839: (r, e) => new IFC4X3.IfcProfileDef(r, e[0], e[1]),
  3843373140: (r, e) => new IFC4X3.IfcProjectedCRS(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  986844984: (r, e) => new IFC4X3.IfcPropertyAbstraction(r),
  3710013099: (r, e) => new IFC4X3.IfcPropertyEnumeration(r, e[0], e[1], e[2]),
  2044713172: (r, e) => new IFC4X3.IfcQuantityArea(r, e[0], e[1], e[2], e[3], e[4]),
  2093928680: (r, e) => new IFC4X3.IfcQuantityCount(r, e[0], e[1], e[2], e[3], e[4]),
  931644368: (r, e) => new IFC4X3.IfcQuantityLength(r, e[0], e[1], e[2], e[3], e[4]),
  2691318326: (r, e) => new IFC4X3.IfcQuantityNumber(r, e[0], e[1], e[2], e[3], e[4]),
  3252649465: (r, e) => new IFC4X3.IfcQuantityTime(r, e[0], e[1], e[2], e[3], e[4]),
  2405470396: (r, e) => new IFC4X3.IfcQuantityVolume(r, e[0], e[1], e[2], e[3], e[4]),
  825690147: (r, e) => new IFC4X3.IfcQuantityWeight(r, e[0], e[1], e[2], e[3], e[4]),
  3915482550: (r, e) => new IFC4X3.IfcRecurrencePattern(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2433181523: (r, e) => new IFC4X3.IfcReference(r, e[0], e[1], e[2], e[3], e[4]),
  1076942058: (r, e) => new IFC4X3.IfcRepresentation(r, e[0], e[1], e[2], e[3]),
  3377609919: (r, e) => new IFC4X3.IfcRepresentationContext(r, e[0], e[1]),
  3008791417: (r, e) => new IFC4X3.IfcRepresentationItem(r),
  1660063152: (r, e) => new IFC4X3.IfcRepresentationMap(r, e[0], e[1]),
  2439245199: (r, e) => new IFC4X3.IfcResourceLevelRelationship(r, e[0], e[1]),
  2341007311: (r, e) => new IFC4X3.IfcRoot(r, e[0], e[1], e[2], e[3]),
  448429030: (r, e) => new IFC4X3.IfcSIUnit(r, e[0], e[1], e[2], e[3]),
  1054537805: (r, e) => new IFC4X3.IfcSchedulingTime(r, e[0], e[1], e[2]),
  867548509: (r, e) => new IFC4X3.IfcShapeAspect(r, e[0], e[1], e[2], e[3], e[4]),
  3982875396: (r, e) => new IFC4X3.IfcShapeModel(r, e[0], e[1], e[2], e[3]),
  4240577450: (r, e) => new IFC4X3.IfcShapeRepresentation(r, e[0], e[1], e[2], e[3]),
  2273995522: (r, e) => new IFC4X3.IfcStructuralConnectionCondition(r, e[0]),
  2162789131: (r, e) => new IFC4X3.IfcStructuralLoad(r, e[0]),
  3478079324: (r, e) => new IFC4X3.IfcStructuralLoadConfiguration(r, e[0], e[1], e[2]),
  609421318: (r, e) => new IFC4X3.IfcStructuralLoadOrResult(r, e[0]),
  2525727697: (r, e) => new IFC4X3.IfcStructuralLoadStatic(r, e[0]),
  3408363356: (r, e) => new IFC4X3.IfcStructuralLoadTemperature(r, e[0], e[1], e[2], e[3]),
  2830218821: (r, e) => new IFC4X3.IfcStyleModel(r, e[0], e[1], e[2], e[3]),
  3958052878: (r, e) => new IFC4X3.IfcStyledItem(r, e[0], e[1], e[2]),
  3049322572: (r, e) => new IFC4X3.IfcStyledRepresentation(r, e[0], e[1], e[2], e[3]),
  2934153892: (r, e) => new IFC4X3.IfcSurfaceReinforcementArea(r, e[0], e[1], e[2], e[3]),
  1300840506: (r, e) => new IFC4X3.IfcSurfaceStyle(r, e[0], e[1], e[2]),
  3303107099: (r, e) => new IFC4X3.IfcSurfaceStyleLighting(r, e[0], e[1], e[2], e[3]),
  1607154358: (r, e) => new IFC4X3.IfcSurfaceStyleRefraction(r, e[0], e[1]),
  846575682: (r, e) => new IFC4X3.IfcSurfaceStyleShading(r, e[0], e[1]),
  1351298697: (r, e) => new IFC4X3.IfcSurfaceStyleWithTextures(r, e[0]),
  626085974: (r, e) => new IFC4X3.IfcSurfaceTexture(r, e[0], e[1], e[2], e[3], e[4]),
  985171141: (r, e) => new IFC4X3.IfcTable(r, e[0], e[1], e[2]),
  2043862942: (r, e) => new IFC4X3.IfcTableColumn(r, e[0], e[1], e[2], e[3], e[4]),
  531007025: (r, e) => new IFC4X3.IfcTableRow(r, e[0], e[1]),
  1549132990: (r, e) => new IFC4X3.IfcTaskTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  2771591690: (r, e) => new IFC4X3.IfcTaskTimeRecurring(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19], e[20]),
  912023232: (r, e) => new IFC4X3.IfcTelecomAddress(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1447204868: (r, e) => new IFC4X3.IfcTextStyle(r, e[0], e[1], e[2], e[3], e[4]),
  2636378356: (r, e) => new IFC4X3.IfcTextStyleForDefinedFont(r, e[0], e[1]),
  1640371178: (r, e) => new IFC4X3.IfcTextStyleTextModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  280115917: (r, e) => new IFC4X3.IfcTextureCoordinate(r, e[0]),
  1742049831: (r, e) => new IFC4X3.IfcTextureCoordinateGenerator(r, e[0], e[1], e[2]),
  222769930: (r, e) => new IFC4X3.IfcTextureCoordinateIndices(r, e[0], e[1]),
  1010789467: (r, e) => new IFC4X3.IfcTextureCoordinateIndicesWithVoids(r, e[0], e[1], e[2]),
  2552916305: (r, e) => new IFC4X3.IfcTextureMap(r, e[0], e[1], e[2]),
  1210645708: (r, e) => new IFC4X3.IfcTextureVertex(r, e[0]),
  3611470254: (r, e) => new IFC4X3.IfcTextureVertexList(r, e[0]),
  1199560280: (r, e) => new IFC4X3.IfcTimePeriod(r, e[0], e[1]),
  3101149627: (r, e) => new IFC4X3.IfcTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  581633288: (r, e) => new IFC4X3.IfcTimeSeriesValue(r, e[0]),
  1377556343: (r, e) => new IFC4X3.IfcTopologicalRepresentationItem(r),
  1735638870: (r, e) => new IFC4X3.IfcTopologyRepresentation(r, e[0], e[1], e[2], e[3]),
  180925521: (r, e) => new IFC4X3.IfcUnitAssignment(r, e[0]),
  2799835756: (r, e) => new IFC4X3.IfcVertex(r),
  1907098498: (r, e) => new IFC4X3.IfcVertexPoint(r, e[0]),
  891718957: (r, e) => new IFC4X3.IfcVirtualGridIntersection(r, e[0], e[1]),
  1236880293: (r, e) => new IFC4X3.IfcWorkTime(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3752311538: (r, e) => new IFC4X3.IfcAlignmentCantSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  536804194: (r, e) => new IFC4X3.IfcAlignmentHorizontalSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3869604511: (r, e) => new IFC4X3.IfcApprovalRelationship(r, e[0], e[1], e[2], e[3]),
  3798115385: (r, e) => new IFC4X3.IfcArbitraryClosedProfileDef(r, e[0], e[1], e[2]),
  1310608509: (r, e) => new IFC4X3.IfcArbitraryOpenProfileDef(r, e[0], e[1], e[2]),
  2705031697: (r, e) => new IFC4X3.IfcArbitraryProfileDefWithVoids(r, e[0], e[1], e[2], e[3]),
  616511568: (r, e) => new IFC4X3.IfcBlobTexture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3150382593: (r, e) => new IFC4X3.IfcCenterLineProfileDef(r, e[0], e[1], e[2], e[3]),
  747523909: (r, e) => new IFC4X3.IfcClassification(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  647927063: (r, e) => new IFC4X3.IfcClassificationReference(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3285139300: (r, e) => new IFC4X3.IfcColourRgbList(r, e[0]),
  3264961684: (r, e) => new IFC4X3.IfcColourSpecification(r, e[0]),
  1485152156: (r, e) => new IFC4X3.IfcCompositeProfileDef(r, e[0], e[1], e[2], e[3]),
  370225590: (r, e) => new IFC4X3.IfcConnectedFaceSet(r, e[0]),
  1981873012: (r, e) => new IFC4X3.IfcConnectionCurveGeometry(r, e[0], e[1]),
  45288368: (r, e) => new IFC4X3.IfcConnectionPointEccentricity(r, e[0], e[1], e[2], e[3], e[4]),
  3050246964: (r, e) => new IFC4X3.IfcContextDependentUnit(r, e[0], e[1], e[2]),
  2889183280: (r, e) => new IFC4X3.IfcConversionBasedUnit(r, e[0], e[1], e[2], e[3]),
  2713554722: (r, e) => new IFC4X3.IfcConversionBasedUnitWithOffset(r, e[0], e[1], e[2], e[3], e[4]),
  539742890: (r, e) => new IFC4X3.IfcCurrencyRelationship(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3800577675: (r, e) => new IFC4X3.IfcCurveStyle(r, e[0], e[1], e[2], e[3], e[4]),
  1105321065: (r, e) => new IFC4X3.IfcCurveStyleFont(r, e[0], e[1]),
  2367409068: (r, e) => new IFC4X3.IfcCurveStyleFontAndScaling(r, e[0], e[1], e[2]),
  3510044353: (r, e) => new IFC4X3.IfcCurveStyleFontPattern(r, e[0], e[1]),
  3632507154: (r, e) => new IFC4X3.IfcDerivedProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  1154170062: (r, e) => new IFC4X3.IfcDocumentInformation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  770865208: (r, e) => new IFC4X3.IfcDocumentInformationRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  3732053477: (r, e) => new IFC4X3.IfcDocumentReference(r, e[0], e[1], e[2], e[3], e[4]),
  3900360178: (r, e) => new IFC4X3.IfcEdge(r, e[0], e[1]),
  476780140: (r, e) => new IFC4X3.IfcEdgeCurve(r, e[0], e[1], e[2], e[3]),
  211053100: (r, e) => new IFC4X3.IfcEventTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  297599258: (r, e) => new IFC4X3.IfcExtendedProperties(r, e[0], e[1], e[2]),
  1437805879: (r, e) => new IFC4X3.IfcExternalReferenceRelationship(r, e[0], e[1], e[2], e[3]),
  2556980723: (r, e) => new IFC4X3.IfcFace(r, e[0]),
  1809719519: (r, e) => new IFC4X3.IfcFaceBound(r, e[0], e[1]),
  803316827: (r, e) => new IFC4X3.IfcFaceOuterBound(r, e[0], e[1]),
  3008276851: (r, e) => new IFC4X3.IfcFaceSurface(r, e[0], e[1], e[2]),
  4219587988: (r, e) => new IFC4X3.IfcFailureConnectionCondition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  738692330: (r, e) => new IFC4X3.IfcFillAreaStyle(r, e[0], e[1], e[2]),
  3448662350: (r, e) => new IFC4X3.IfcGeometricRepresentationContext(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2453401579: (r, e) => new IFC4X3.IfcGeometricRepresentationItem(r),
  4142052618: (r, e) => new IFC4X3.IfcGeometricRepresentationSubContext(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3590301190: (r, e) => new IFC4X3.IfcGeometricSet(r, e[0]),
  178086475: (r, e) => new IFC4X3.IfcGridPlacement(r, e[0], e[1], e[2]),
  812098782: (r, e) => new IFC4X3.IfcHalfSpaceSolid(r, e[0], e[1]),
  3905492369: (r, e) => new IFC4X3.IfcImageTexture(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3570813810: (r, e) => new IFC4X3.IfcIndexedColourMap(r, e[0], e[1], e[2], e[3]),
  1437953363: (r, e) => new IFC4X3.IfcIndexedTextureMap(r, e[0], e[1], e[2]),
  2133299955: (r, e) => new IFC4X3.IfcIndexedTriangleTextureMap(r, e[0], e[1], e[2], e[3]),
  3741457305: (r, e) => new IFC4X3.IfcIrregularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1585845231: (r, e) => new IFC4X3.IfcLagTime(r, e[0], e[1], e[2], e[3], e[4]),
  1402838566: (r, e) => new IFC4X3.IfcLightSource(r, e[0], e[1], e[2], e[3]),
  125510826: (r, e) => new IFC4X3.IfcLightSourceAmbient(r, e[0], e[1], e[2], e[3]),
  2604431987: (r, e) => new IFC4X3.IfcLightSourceDirectional(r, e[0], e[1], e[2], e[3], e[4]),
  4266656042: (r, e) => new IFC4X3.IfcLightSourceGoniometric(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1520743889: (r, e) => new IFC4X3.IfcLightSourcePositional(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3422422726: (r, e) => new IFC4X3.IfcLightSourceSpot(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  388784114: (r, e) => new IFC4X3.IfcLinearPlacement(r, e[0], e[1], e[2]),
  2624227202: (r, e) => new IFC4X3.IfcLocalPlacement(r, e[0], e[1]),
  1008929658: (r, e) => new IFC4X3.IfcLoop(r),
  2347385850: (r, e) => new IFC4X3.IfcMappedItem(r, e[0], e[1]),
  1838606355: (r, e) => new IFC4X3.IfcMaterial(r, e[0], e[1], e[2]),
  3708119e3: (r, e) => new IFC4X3.IfcMaterialConstituent(r, e[0], e[1], e[2], e[3], e[4]),
  2852063980: (r, e) => new IFC4X3.IfcMaterialConstituentSet(r, e[0], e[1], e[2]),
  2022407955: (r, e) => new IFC4X3.IfcMaterialDefinitionRepresentation(r, e[0], e[1], e[2], e[3]),
  1303795690: (r, e) => new IFC4X3.IfcMaterialLayerSetUsage(r, e[0], e[1], e[2], e[3], e[4]),
  3079605661: (r, e) => new IFC4X3.IfcMaterialProfileSetUsage(r, e[0], e[1], e[2]),
  3404854881: (r, e) => new IFC4X3.IfcMaterialProfileSetUsageTapering(r, e[0], e[1], e[2], e[3], e[4]),
  3265635763: (r, e) => new IFC4X3.IfcMaterialProperties(r, e[0], e[1], e[2], e[3]),
  853536259: (r, e) => new IFC4X3.IfcMaterialRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  2998442950: (r, e) => new IFC4X3.IfcMirroredProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  219451334: (r, e) => new IFC4X3.IfcObjectDefinition(r, e[0], e[1], e[2], e[3]),
  182550632: (r, e) => new IFC4X3.IfcOpenCrossProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2665983363: (r, e) => new IFC4X3.IfcOpenShell(r, e[0]),
  1411181986: (r, e) => new IFC4X3.IfcOrganizationRelationship(r, e[0], e[1], e[2], e[3]),
  1029017970: (r, e) => new IFC4X3.IfcOrientedEdge(r, e[0], e[1], e[2]),
  2529465313: (r, e) => new IFC4X3.IfcParameterizedProfileDef(r, e[0], e[1], e[2]),
  2519244187: (r, e) => new IFC4X3.IfcPath(r, e[0]),
  3021840470: (r, e) => new IFC4X3.IfcPhysicalComplexQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  597895409: (r, e) => new IFC4X3.IfcPixelTexture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2004835150: (r, e) => new IFC4X3.IfcPlacement(r, e[0]),
  1663979128: (r, e) => new IFC4X3.IfcPlanarExtent(r, e[0], e[1]),
  2067069095: (r, e) => new IFC4X3.IfcPoint(r),
  2165702409: (r, e) => new IFC4X3.IfcPointByDistanceExpression(r, e[0], e[1], e[2], e[3], e[4]),
  4022376103: (r, e) => new IFC4X3.IfcPointOnCurve(r, e[0], e[1]),
  1423911732: (r, e) => new IFC4X3.IfcPointOnSurface(r, e[0], e[1], e[2]),
  2924175390: (r, e) => new IFC4X3.IfcPolyLoop(r, e[0]),
  2775532180: (r, e) => new IFC4X3.IfcPolygonalBoundedHalfSpace(r, e[0], e[1], e[2], e[3]),
  3727388367: (r, e) => new IFC4X3.IfcPreDefinedItem(r, e[0]),
  3778827333: (r, e) => new IFC4X3.IfcPreDefinedProperties(r),
  1775413392: (r, e) => new IFC4X3.IfcPreDefinedTextFont(r, e[0]),
  673634403: (r, e) => new IFC4X3.IfcProductDefinitionShape(r, e[0], e[1], e[2]),
  2802850158: (r, e) => new IFC4X3.IfcProfileProperties(r, e[0], e[1], e[2], e[3]),
  2598011224: (r, e) => new IFC4X3.IfcProperty(r, e[0], e[1]),
  1680319473: (r, e) => new IFC4X3.IfcPropertyDefinition(r, e[0], e[1], e[2], e[3]),
  148025276: (r, e) => new IFC4X3.IfcPropertyDependencyRelationship(r, e[0], e[1], e[2], e[3], e[4]),
  3357820518: (r, e) => new IFC4X3.IfcPropertySetDefinition(r, e[0], e[1], e[2], e[3]),
  1482703590: (r, e) => new IFC4X3.IfcPropertyTemplateDefinition(r, e[0], e[1], e[2], e[3]),
  2090586900: (r, e) => new IFC4X3.IfcQuantitySet(r, e[0], e[1], e[2], e[3]),
  3615266464: (r, e) => new IFC4X3.IfcRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  3413951693: (r, e) => new IFC4X3.IfcRegularTimeSeries(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1580146022: (r, e) => new IFC4X3.IfcReinforcementBarProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  478536968: (r, e) => new IFC4X3.IfcRelationship(r, e[0], e[1], e[2], e[3]),
  2943643501: (r, e) => new IFC4X3.IfcResourceApprovalRelationship(r, e[0], e[1], e[2], e[3]),
  1608871552: (r, e) => new IFC4X3.IfcResourceConstraintRelationship(r, e[0], e[1], e[2], e[3]),
  1042787934: (r, e) => new IFC4X3.IfcResourceTime(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2778083089: (r, e) => new IFC4X3.IfcRoundedRectangleProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2042790032: (r, e) => new IFC4X3.IfcSectionProperties(r, e[0], e[1], e[2]),
  4165799628: (r, e) => new IFC4X3.IfcSectionReinforcementProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1509187699: (r, e) => new IFC4X3.IfcSectionedSpine(r, e[0], e[1], e[2]),
  823603102: (r, e) => new IFC4X3.IfcSegment(r, e[0]),
  4124623270: (r, e) => new IFC4X3.IfcShellBasedSurfaceModel(r, e[0]),
  3692461612: (r, e) => new IFC4X3.IfcSimpleProperty(r, e[0], e[1]),
  2609359061: (r, e) => new IFC4X3.IfcSlippageConnectionCondition(r, e[0], e[1], e[2], e[3]),
  723233188: (r, e) => new IFC4X3.IfcSolidModel(r),
  1595516126: (r, e) => new IFC4X3.IfcStructuralLoadLinearForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2668620305: (r, e) => new IFC4X3.IfcStructuralLoadPlanarForce(r, e[0], e[1], e[2], e[3]),
  2473145415: (r, e) => new IFC4X3.IfcStructuralLoadSingleDisplacement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1973038258: (r, e) => new IFC4X3.IfcStructuralLoadSingleDisplacementDistortion(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1597423693: (r, e) => new IFC4X3.IfcStructuralLoadSingleForce(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1190533807: (r, e) => new IFC4X3.IfcStructuralLoadSingleForceWarping(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2233826070: (r, e) => new IFC4X3.IfcSubedge(r, e[0], e[1], e[2]),
  2513912981: (r, e) => new IFC4X3.IfcSurface(r),
  1878645084: (r, e) => new IFC4X3.IfcSurfaceStyleRendering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2247615214: (r, e) => new IFC4X3.IfcSweptAreaSolid(r, e[0], e[1]),
  1260650574: (r, e) => new IFC4X3.IfcSweptDiskSolid(r, e[0], e[1], e[2], e[3], e[4]),
  1096409881: (r, e) => new IFC4X3.IfcSweptDiskSolidPolygonal(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  230924584: (r, e) => new IFC4X3.IfcSweptSurface(r, e[0], e[1]),
  3071757647: (r, e) => new IFC4X3.IfcTShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  901063453: (r, e) => new IFC4X3.IfcTessellatedItem(r),
  4282788508: (r, e) => new IFC4X3.IfcTextLiteral(r, e[0], e[1], e[2]),
  3124975700: (r, e) => new IFC4X3.IfcTextLiteralWithExtent(r, e[0], e[1], e[2], e[3], e[4]),
  1983826977: (r, e) => new IFC4X3.IfcTextStyleFontModel(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2715220739: (r, e) => new IFC4X3.IfcTrapeziumProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1628702193: (r, e) => new IFC4X3.IfcTypeObject(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3736923433: (r, e) => new IFC4X3.IfcTypeProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2347495698: (r, e) => new IFC4X3.IfcTypeProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3698973494: (r, e) => new IFC4X3.IfcTypeResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  427810014: (r, e) => new IFC4X3.IfcUShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1417489154: (r, e) => new IFC4X3.IfcVector(r, e[0], e[1]),
  2759199220: (r, e) => new IFC4X3.IfcVertexLoop(r, e[0]),
  2543172580: (r, e) => new IFC4X3.IfcZShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3406155212: (r, e) => new IFC4X3.IfcAdvancedFace(r, e[0], e[1], e[2]),
  669184980: (r, e) => new IFC4X3.IfcAnnotationFillArea(r, e[0], e[1]),
  3207858831: (r, e) => new IFC4X3.IfcAsymmetricIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14]),
  4261334040: (r, e) => new IFC4X3.IfcAxis1Placement(r, e[0], e[1]),
  3125803723: (r, e) => new IFC4X3.IfcAxis2Placement2D(r, e[0], e[1]),
  2740243338: (r, e) => new IFC4X3.IfcAxis2Placement3D(r, e[0], e[1], e[2]),
  3425423356: (r, e) => new IFC4X3.IfcAxis2PlacementLinear(r, e[0], e[1], e[2]),
  2736907675: (r, e) => new IFC4X3.IfcBooleanResult(r, e[0], e[1], e[2]),
  4182860854: (r, e) => new IFC4X3.IfcBoundedSurface(r),
  2581212453: (r, e) => new IFC4X3.IfcBoundingBox(r, e[0], e[1], e[2], e[3]),
  2713105998: (r, e) => new IFC4X3.IfcBoxedHalfSpace(r, e[0], e[1], e[2]),
  2898889636: (r, e) => new IFC4X3.IfcCShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1123145078: (r, e) => new IFC4X3.IfcCartesianPoint(r, e[0]),
  574549367: (r, e) => new IFC4X3.IfcCartesianPointList(r),
  1675464909: (r, e) => new IFC4X3.IfcCartesianPointList2D(r, e[0], e[1]),
  2059837836: (r, e) => new IFC4X3.IfcCartesianPointList3D(r, e[0], e[1]),
  59481748: (r, e) => new IFC4X3.IfcCartesianTransformationOperator(r, e[0], e[1], e[2], e[3]),
  3749851601: (r, e) => new IFC4X3.IfcCartesianTransformationOperator2D(r, e[0], e[1], e[2], e[3]),
  3486308946: (r, e) => new IFC4X3.IfcCartesianTransformationOperator2DnonUniform(r, e[0], e[1], e[2], e[3], e[4]),
  3331915920: (r, e) => new IFC4X3.IfcCartesianTransformationOperator3D(r, e[0], e[1], e[2], e[3], e[4]),
  1416205885: (r, e) => new IFC4X3.IfcCartesianTransformationOperator3DnonUniform(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1383045692: (r, e) => new IFC4X3.IfcCircleProfileDef(r, e[0], e[1], e[2], e[3]),
  2205249479: (r, e) => new IFC4X3.IfcClosedShell(r, e[0]),
  776857604: (r, e) => new IFC4X3.IfcColourRgb(r, e[0], e[1], e[2], e[3]),
  2542286263: (r, e) => new IFC4X3.IfcComplexProperty(r, e[0], e[1], e[2], e[3]),
  2485617015: (r, e) => new IFC4X3.IfcCompositeCurveSegment(r, e[0], e[1], e[2]),
  2574617495: (r, e) => new IFC4X3.IfcConstructionResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3419103109: (r, e) => new IFC4X3.IfcContext(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1815067380: (r, e) => new IFC4X3.IfcCrewResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2506170314: (r, e) => new IFC4X3.IfcCsgPrimitive3D(r, e[0]),
  2147822146: (r, e) => new IFC4X3.IfcCsgSolid(r, e[0]),
  2601014836: (r, e) => new IFC4X3.IfcCurve(r),
  2827736869: (r, e) => new IFC4X3.IfcCurveBoundedPlane(r, e[0], e[1], e[2]),
  2629017746: (r, e) => new IFC4X3.IfcCurveBoundedSurface(r, e[0], e[1], e[2]),
  4212018352: (r, e) => new IFC4X3.IfcCurveSegment(r, e[0], e[1], e[2], e[3], e[4]),
  32440307: (r, e) => new IFC4X3.IfcDirection(r, e[0]),
  593015953: (r, e) => new IFC4X3.IfcDirectrixCurveSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4]),
  1472233963: (r, e) => new IFC4X3.IfcEdgeLoop(r, e[0]),
  1883228015: (r, e) => new IFC4X3.IfcElementQuantity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  339256511: (r, e) => new IFC4X3.IfcElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2777663545: (r, e) => new IFC4X3.IfcElementarySurface(r, e[0]),
  2835456948: (r, e) => new IFC4X3.IfcEllipseProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  4024345920: (r, e) => new IFC4X3.IfcEventType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  477187591: (r, e) => new IFC4X3.IfcExtrudedAreaSolid(r, e[0], e[1], e[2], e[3]),
  2804161546: (r, e) => new IFC4X3.IfcExtrudedAreaSolidTapered(r, e[0], e[1], e[2], e[3], e[4]),
  2047409740: (r, e) => new IFC4X3.IfcFaceBasedSurfaceModel(r, e[0]),
  374418227: (r, e) => new IFC4X3.IfcFillAreaStyleHatching(r, e[0], e[1], e[2], e[3], e[4]),
  315944413: (r, e) => new IFC4X3.IfcFillAreaStyleTiles(r, e[0], e[1], e[2]),
  2652556860: (r, e) => new IFC4X3.IfcFixedReferenceSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4238390223: (r, e) => new IFC4X3.IfcFurnishingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1268542332: (r, e) => new IFC4X3.IfcFurnitureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4095422895: (r, e) => new IFC4X3.IfcGeographicElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  987898635: (r, e) => new IFC4X3.IfcGeometricCurveSet(r, e[0]),
  1484403080: (r, e) => new IFC4X3.IfcIShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  178912537: (r, e) => new IFC4X3.IfcIndexedPolygonalFace(r, e[0]),
  2294589976: (r, e) => new IFC4X3.IfcIndexedPolygonalFaceWithVoids(r, e[0], e[1]),
  3465909080: (r, e) => new IFC4X3.IfcIndexedPolygonalTextureMap(r, e[0], e[1], e[2], e[3]),
  572779678: (r, e) => new IFC4X3.IfcLShapeProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  428585644: (r, e) => new IFC4X3.IfcLaborResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1281925730: (r, e) => new IFC4X3.IfcLine(r, e[0], e[1]),
  1425443689: (r, e) => new IFC4X3.IfcManifoldSolidBrep(r, e[0]),
  3888040117: (r, e) => new IFC4X3.IfcObject(r, e[0], e[1], e[2], e[3], e[4]),
  590820931: (r, e) => new IFC4X3.IfcOffsetCurve(r, e[0]),
  3388369263: (r, e) => new IFC4X3.IfcOffsetCurve2D(r, e[0], e[1], e[2]),
  3505215534: (r, e) => new IFC4X3.IfcOffsetCurve3D(r, e[0], e[1], e[2], e[3]),
  2485787929: (r, e) => new IFC4X3.IfcOffsetCurveByDistances(r, e[0], e[1], e[2]),
  1682466193: (r, e) => new IFC4X3.IfcPcurve(r, e[0], e[1]),
  603570806: (r, e) => new IFC4X3.IfcPlanarBox(r, e[0], e[1], e[2]),
  220341763: (r, e) => new IFC4X3.IfcPlane(r, e[0]),
  3381221214: (r, e) => new IFC4X3.IfcPolynomialCurve(r, e[0], e[1], e[2], e[3]),
  759155922: (r, e) => new IFC4X3.IfcPreDefinedColour(r, e[0]),
  2559016684: (r, e) => new IFC4X3.IfcPreDefinedCurveFont(r, e[0]),
  3967405729: (r, e) => new IFC4X3.IfcPreDefinedPropertySet(r, e[0], e[1], e[2], e[3]),
  569719735: (r, e) => new IFC4X3.IfcProcedureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2945172077: (r, e) => new IFC4X3.IfcProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  4208778838: (r, e) => new IFC4X3.IfcProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  103090709: (r, e) => new IFC4X3.IfcProject(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  653396225: (r, e) => new IFC4X3.IfcProjectLibrary(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  871118103: (r, e) => new IFC4X3.IfcPropertyBoundedValue(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4166981789: (r, e) => new IFC4X3.IfcPropertyEnumeratedValue(r, e[0], e[1], e[2], e[3]),
  2752243245: (r, e) => new IFC4X3.IfcPropertyListValue(r, e[0], e[1], e[2], e[3]),
  941946838: (r, e) => new IFC4X3.IfcPropertyReferenceValue(r, e[0], e[1], e[2], e[3]),
  1451395588: (r, e) => new IFC4X3.IfcPropertySet(r, e[0], e[1], e[2], e[3], e[4]),
  492091185: (r, e) => new IFC4X3.IfcPropertySetTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3650150729: (r, e) => new IFC4X3.IfcPropertySingleValue(r, e[0], e[1], e[2], e[3]),
  110355661: (r, e) => new IFC4X3.IfcPropertyTableValue(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3521284610: (r, e) => new IFC4X3.IfcPropertyTemplate(r, e[0], e[1], e[2], e[3]),
  2770003689: (r, e) => new IFC4X3.IfcRectangleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2798486643: (r, e) => new IFC4X3.IfcRectangularPyramid(r, e[0], e[1], e[2], e[3]),
  3454111270: (r, e) => new IFC4X3.IfcRectangularTrimmedSurface(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3765753017: (r, e) => new IFC4X3.IfcReinforcementDefinitionProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3939117080: (r, e) => new IFC4X3.IfcRelAssigns(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1683148259: (r, e) => new IFC4X3.IfcRelAssignsToActor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2495723537: (r, e) => new IFC4X3.IfcRelAssignsToControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1307041759: (r, e) => new IFC4X3.IfcRelAssignsToGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1027710054: (r, e) => new IFC4X3.IfcRelAssignsToGroupByFactor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278684876: (r, e) => new IFC4X3.IfcRelAssignsToProcess(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2857406711: (r, e) => new IFC4X3.IfcRelAssignsToProduct(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  205026976: (r, e) => new IFC4X3.IfcRelAssignsToResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1865459582: (r, e) => new IFC4X3.IfcRelAssociates(r, e[0], e[1], e[2], e[3], e[4]),
  4095574036: (r, e) => new IFC4X3.IfcRelAssociatesApproval(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  919958153: (r, e) => new IFC4X3.IfcRelAssociatesClassification(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2728634034: (r, e) => new IFC4X3.IfcRelAssociatesConstraint(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  982818633: (r, e) => new IFC4X3.IfcRelAssociatesDocument(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3840914261: (r, e) => new IFC4X3.IfcRelAssociatesLibrary(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2655215786: (r, e) => new IFC4X3.IfcRelAssociatesMaterial(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1033248425: (r, e) => new IFC4X3.IfcRelAssociatesProfileDef(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  826625072: (r, e) => new IFC4X3.IfcRelConnects(r, e[0], e[1], e[2], e[3]),
  1204542856: (r, e) => new IFC4X3.IfcRelConnectsElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3945020480: (r, e) => new IFC4X3.IfcRelConnectsPathElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4201705270: (r, e) => new IFC4X3.IfcRelConnectsPortToElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3190031847: (r, e) => new IFC4X3.IfcRelConnectsPorts(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2127690289: (r, e) => new IFC4X3.IfcRelConnectsStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1638771189: (r, e) => new IFC4X3.IfcRelConnectsStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  504942748: (r, e) => new IFC4X3.IfcRelConnectsWithEccentricity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3678494232: (r, e) => new IFC4X3.IfcRelConnectsWithRealizingElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3242617779: (r, e) => new IFC4X3.IfcRelContainedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  886880790: (r, e) => new IFC4X3.IfcRelCoversBldgElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2802773753: (r, e) => new IFC4X3.IfcRelCoversSpaces(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2565941209: (r, e) => new IFC4X3.IfcRelDeclares(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2551354335: (r, e) => new IFC4X3.IfcRelDecomposes(r, e[0], e[1], e[2], e[3]),
  693640335: (r, e) => new IFC4X3.IfcRelDefines(r, e[0], e[1], e[2], e[3]),
  1462361463: (r, e) => new IFC4X3.IfcRelDefinesByObject(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4186316022: (r, e) => new IFC4X3.IfcRelDefinesByProperties(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  307848117: (r, e) => new IFC4X3.IfcRelDefinesByTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  781010003: (r, e) => new IFC4X3.IfcRelDefinesByType(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3940055652: (r, e) => new IFC4X3.IfcRelFillsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  279856033: (r, e) => new IFC4X3.IfcRelFlowControlElements(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  427948657: (r, e) => new IFC4X3.IfcRelInterferesElements(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3268803585: (r, e) => new IFC4X3.IfcRelNests(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1441486842: (r, e) => new IFC4X3.IfcRelPositions(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  750771296: (r, e) => new IFC4X3.IfcRelProjectsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1245217292: (r, e) => new IFC4X3.IfcRelReferencedInSpatialStructure(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  4122056220: (r, e) => new IFC4X3.IfcRelSequence(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  366585022: (r, e) => new IFC4X3.IfcRelServicesBuildings(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3451746338: (r, e) => new IFC4X3.IfcRelSpaceBoundary(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3523091289: (r, e) => new IFC4X3.IfcRelSpaceBoundary1stLevel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1521410863: (r, e) => new IFC4X3.IfcRelSpaceBoundary2ndLevel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1401173127: (r, e) => new IFC4X3.IfcRelVoidsElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  816062949: (r, e) => new IFC4X3.IfcReparametrisedCompositeCurveSegment(r, e[0], e[1], e[2], e[3]),
  2914609552: (r, e) => new IFC4X3.IfcResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1856042241: (r, e) => new IFC4X3.IfcRevolvedAreaSolid(r, e[0], e[1], e[2], e[3]),
  3243963512: (r, e) => new IFC4X3.IfcRevolvedAreaSolidTapered(r, e[0], e[1], e[2], e[3], e[4]),
  4158566097: (r, e) => new IFC4X3.IfcRightCircularCone(r, e[0], e[1], e[2]),
  3626867408: (r, e) => new IFC4X3.IfcRightCircularCylinder(r, e[0], e[1], e[2]),
  1862484736: (r, e) => new IFC4X3.IfcSectionedSolid(r, e[0], e[1]),
  1290935644: (r, e) => new IFC4X3.IfcSectionedSolidHorizontal(r, e[0], e[1], e[2]),
  1356537516: (r, e) => new IFC4X3.IfcSectionedSurface(r, e[0], e[1], e[2]),
  3663146110: (r, e) => new IFC4X3.IfcSimplePropertyTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1412071761: (r, e) => new IFC4X3.IfcSpatialElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  710998568: (r, e) => new IFC4X3.IfcSpatialElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2706606064: (r, e) => new IFC4X3.IfcSpatialStructureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3893378262: (r, e) => new IFC4X3.IfcSpatialStructureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  463610769: (r, e) => new IFC4X3.IfcSpatialZone(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2481509218: (r, e) => new IFC4X3.IfcSpatialZoneType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  451544542: (r, e) => new IFC4X3.IfcSphere(r, e[0], e[1]),
  4015995234: (r, e) => new IFC4X3.IfcSphericalSurface(r, e[0], e[1]),
  2735484536: (r, e) => new IFC4X3.IfcSpiral(r, e[0]),
  3544373492: (r, e) => new IFC4X3.IfcStructuralActivity(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3136571912: (r, e) => new IFC4X3.IfcStructuralItem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  530289379: (r, e) => new IFC4X3.IfcStructuralMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3689010777: (r, e) => new IFC4X3.IfcStructuralReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3979015343: (r, e) => new IFC4X3.IfcStructuralSurfaceMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2218152070: (r, e) => new IFC4X3.IfcStructuralSurfaceMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  603775116: (r, e) => new IFC4X3.IfcStructuralSurfaceReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4095615324: (r, e) => new IFC4X3.IfcSubContractResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  699246055: (r, e) => new IFC4X3.IfcSurfaceCurve(r, e[0], e[1], e[2]),
  2028607225: (r, e) => new IFC4X3.IfcSurfaceCurveSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2809605785: (r, e) => new IFC4X3.IfcSurfaceOfLinearExtrusion(r, e[0], e[1], e[2], e[3]),
  4124788165: (r, e) => new IFC4X3.IfcSurfaceOfRevolution(r, e[0], e[1], e[2]),
  1580310250: (r, e) => new IFC4X3.IfcSystemFurnitureElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3473067441: (r, e) => new IFC4X3.IfcTask(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  3206491090: (r, e) => new IFC4X3.IfcTaskType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2387106220: (r, e) => new IFC4X3.IfcTessellatedFaceSet(r, e[0], e[1]),
  782932809: (r, e) => new IFC4X3.IfcThirdOrderPolynomialSpiral(r, e[0], e[1], e[2], e[3], e[4]),
  1935646853: (r, e) => new IFC4X3.IfcToroidalSurface(r, e[0], e[1], e[2]),
  3665877780: (r, e) => new IFC4X3.IfcTransportationDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2916149573: (r, e) => new IFC4X3.IfcTriangulatedFaceSet(r, e[0], e[1], e[2], e[3], e[4]),
  1229763772: (r, e) => new IFC4X3.IfcTriangulatedIrregularNetwork(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3651464721: (r, e) => new IFC4X3.IfcVehicleType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  336235671: (r, e) => new IFC4X3.IfcWindowLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  512836454: (r, e) => new IFC4X3.IfcWindowPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2296667514: (r, e) => new IFC4X3.IfcActor(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  1635779807: (r, e) => new IFC4X3.IfcAdvancedBrep(r, e[0]),
  2603310189: (r, e) => new IFC4X3.IfcAdvancedBrepWithVoids(r, e[0], e[1]),
  1674181508: (r, e) => new IFC4X3.IfcAnnotation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2887950389: (r, e) => new IFC4X3.IfcBSplineSurface(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  167062518: (r, e) => new IFC4X3.IfcBSplineSurfaceWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1334484129: (r, e) => new IFC4X3.IfcBlock(r, e[0], e[1], e[2], e[3]),
  3649129432: (r, e) => new IFC4X3.IfcBooleanClippingResult(r, e[0], e[1], e[2]),
  1260505505: (r, e) => new IFC4X3.IfcBoundedCurve(r),
  3124254112: (r, e) => new IFC4X3.IfcBuildingStorey(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1626504194: (r, e) => new IFC4X3.IfcBuiltElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2197970202: (r, e) => new IFC4X3.IfcChimneyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2937912522: (r, e) => new IFC4X3.IfcCircleHollowProfileDef(r, e[0], e[1], e[2], e[3], e[4]),
  3893394355: (r, e) => new IFC4X3.IfcCivilElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3497074424: (r, e) => new IFC4X3.IfcClothoid(r, e[0], e[1]),
  300633059: (r, e) => new IFC4X3.IfcColumnType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3875453745: (r, e) => new IFC4X3.IfcComplexPropertyTemplate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3732776249: (r, e) => new IFC4X3.IfcCompositeCurve(r, e[0], e[1]),
  15328376: (r, e) => new IFC4X3.IfcCompositeCurveOnSurface(r, e[0], e[1]),
  2510884976: (r, e) => new IFC4X3.IfcConic(r, e[0]),
  2185764099: (r, e) => new IFC4X3.IfcConstructionEquipmentResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4105962743: (r, e) => new IFC4X3.IfcConstructionMaterialResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1525564444: (r, e) => new IFC4X3.IfcConstructionProductResourceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2559216714: (r, e) => new IFC4X3.IfcConstructionResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293443760: (r, e) => new IFC4X3.IfcControl(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  2000195564: (r, e) => new IFC4X3.IfcCosineSpiral(r, e[0], e[1], e[2]),
  3895139033: (r, e) => new IFC4X3.IfcCostItem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1419761937: (r, e) => new IFC4X3.IfcCostSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4189326743: (r, e) => new IFC4X3.IfcCourseType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1916426348: (r, e) => new IFC4X3.IfcCoveringType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3295246426: (r, e) => new IFC4X3.IfcCrewResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1457835157: (r, e) => new IFC4X3.IfcCurtainWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1213902940: (r, e) => new IFC4X3.IfcCylindricalSurface(r, e[0], e[1]),
  1306400036: (r, e) => new IFC4X3.IfcDeepFoundationType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4234616927: (r, e) => new IFC4X3.IfcDirectrixDerivedReferenceSweptAreaSolid(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3256556792: (r, e) => new IFC4X3.IfcDistributionElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3849074793: (r, e) => new IFC4X3.IfcDistributionFlowElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2963535650: (r, e) => new IFC4X3.IfcDoorLiningProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  1714330368: (r, e) => new IFC4X3.IfcDoorPanelProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2323601079: (r, e) => new IFC4X3.IfcDoorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  445594917: (r, e) => new IFC4X3.IfcDraughtingPreDefinedColour(r, e[0]),
  4006246654: (r, e) => new IFC4X3.IfcDraughtingPreDefinedCurveFont(r, e[0]),
  1758889154: (r, e) => new IFC4X3.IfcElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4123344466: (r, e) => new IFC4X3.IfcElementAssembly(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2397081782: (r, e) => new IFC4X3.IfcElementAssemblyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1623761950: (r, e) => new IFC4X3.IfcElementComponent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2590856083: (r, e) => new IFC4X3.IfcElementComponentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1704287377: (r, e) => new IFC4X3.IfcEllipse(r, e[0], e[1], e[2]),
  2107101300: (r, e) => new IFC4X3.IfcEnergyConversionDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  132023988: (r, e) => new IFC4X3.IfcEngineType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3174744832: (r, e) => new IFC4X3.IfcEvaporativeCoolerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3390157468: (r, e) => new IFC4X3.IfcEvaporatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4148101412: (r, e) => new IFC4X3.IfcEvent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2853485674: (r, e) => new IFC4X3.IfcExternalSpatialStructureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  807026263: (r, e) => new IFC4X3.IfcFacetedBrep(r, e[0]),
  3737207727: (r, e) => new IFC4X3.IfcFacetedBrepWithVoids(r, e[0], e[1]),
  24185140: (r, e) => new IFC4X3.IfcFacility(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1310830890: (r, e) => new IFC4X3.IfcFacilityPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4228831410: (r, e) => new IFC4X3.IfcFacilityPartCommon(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  647756555: (r, e) => new IFC4X3.IfcFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2489546625: (r, e) => new IFC4X3.IfcFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2827207264: (r, e) => new IFC4X3.IfcFeatureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2143335405: (r, e) => new IFC4X3.IfcFeatureElementAddition(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1287392070: (r, e) => new IFC4X3.IfcFeatureElementSubtraction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3907093117: (r, e) => new IFC4X3.IfcFlowControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3198132628: (r, e) => new IFC4X3.IfcFlowFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3815607619: (r, e) => new IFC4X3.IfcFlowMeterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1482959167: (r, e) => new IFC4X3.IfcFlowMovingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1834744321: (r, e) => new IFC4X3.IfcFlowSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1339347760: (r, e) => new IFC4X3.IfcFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2297155007: (r, e) => new IFC4X3.IfcFlowTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3009222698: (r, e) => new IFC4X3.IfcFlowTreatmentDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1893162501: (r, e) => new IFC4X3.IfcFootingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  263784265: (r, e) => new IFC4X3.IfcFurnishingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1509553395: (r, e) => new IFC4X3.IfcFurniture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3493046030: (r, e) => new IFC4X3.IfcGeographicElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4230923436: (r, e) => new IFC4X3.IfcGeotechnicalElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1594536857: (r, e) => new IFC4X3.IfcGeotechnicalStratum(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2898700619: (r, e) => new IFC4X3.IfcGradientCurve(r, e[0], e[1], e[2], e[3]),
  2706460486: (r, e) => new IFC4X3.IfcGroup(r, e[0], e[1], e[2], e[3], e[4]),
  1251058090: (r, e) => new IFC4X3.IfcHeatExchangerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1806887404: (r, e) => new IFC4X3.IfcHumidifierType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2568555532: (r, e) => new IFC4X3.IfcImpactProtectionDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3948183225: (r, e) => new IFC4X3.IfcImpactProtectionDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2571569899: (r, e) => new IFC4X3.IfcIndexedPolyCurve(r, e[0], e[1], e[2]),
  3946677679: (r, e) => new IFC4X3.IfcInterceptorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3113134337: (r, e) => new IFC4X3.IfcIntersectionCurve(r, e[0], e[1], e[2]),
  2391368822: (r, e) => new IFC4X3.IfcInventory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4288270099: (r, e) => new IFC4X3.IfcJunctionBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  679976338: (r, e) => new IFC4X3.IfcKerbType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3827777499: (r, e) => new IFC4X3.IfcLaborResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1051575348: (r, e) => new IFC4X3.IfcLampType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1161773419: (r, e) => new IFC4X3.IfcLightFixtureType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2176059722: (r, e) => new IFC4X3.IfcLinearElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1770583370: (r, e) => new IFC4X3.IfcLiquidTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  525669439: (r, e) => new IFC4X3.IfcMarineFacility(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  976884017: (r, e) => new IFC4X3.IfcMarinePart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  377706215: (r, e) => new IFC4X3.IfcMechanicalFastener(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2108223431: (r, e) => new IFC4X3.IfcMechanicalFastenerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1114901282: (r, e) => new IFC4X3.IfcMedicalDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3181161470: (r, e) => new IFC4X3.IfcMemberType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1950438474: (r, e) => new IFC4X3.IfcMobileTelecommunicationsApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  710110818: (r, e) => new IFC4X3.IfcMooringDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  977012517: (r, e) => new IFC4X3.IfcMotorConnectionType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  506776471: (r, e) => new IFC4X3.IfcNavigationElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4143007308: (r, e) => new IFC4X3.IfcOccupant(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3588315303: (r, e) => new IFC4X3.IfcOpeningElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2837617999: (r, e) => new IFC4X3.IfcOutletType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  514975943: (r, e) => new IFC4X3.IfcPavementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2382730787: (r, e) => new IFC4X3.IfcPerformanceHistory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3566463478: (r, e) => new IFC4X3.IfcPermeableCoveringProperties(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3327091369: (r, e) => new IFC4X3.IfcPermit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1158309216: (r, e) => new IFC4X3.IfcPileType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  804291784: (r, e) => new IFC4X3.IfcPipeFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4231323485: (r, e) => new IFC4X3.IfcPipeSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4017108033: (r, e) => new IFC4X3.IfcPlateType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2839578677: (r, e) => new IFC4X3.IfcPolygonalFaceSet(r, e[0], e[1], e[2], e[3]),
  3724593414: (r, e) => new IFC4X3.IfcPolyline(r, e[0]),
  3740093272: (r, e) => new IFC4X3.IfcPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1946335990: (r, e) => new IFC4X3.IfcPositioningElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2744685151: (r, e) => new IFC4X3.IfcProcedure(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2904328755: (r, e) => new IFC4X3.IfcProjectOrder(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3651124850: (r, e) => new IFC4X3.IfcProjectionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1842657554: (r, e) => new IFC4X3.IfcProtectiveDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2250791053: (r, e) => new IFC4X3.IfcPumpType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1763565496: (r, e) => new IFC4X3.IfcRailType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2893384427: (r, e) => new IFC4X3.IfcRailingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3992365140: (r, e) => new IFC4X3.IfcRailway(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1891881377: (r, e) => new IFC4X3.IfcRailwayPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2324767716: (r, e) => new IFC4X3.IfcRampFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1469900589: (r, e) => new IFC4X3.IfcRampType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  683857671: (r, e) => new IFC4X3.IfcRationalBSplineSurfaceWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4021432810: (r, e) => new IFC4X3.IfcReferent(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3027567501: (r, e) => new IFC4X3.IfcReinforcingElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  964333572: (r, e) => new IFC4X3.IfcReinforcingElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2320036040: (r, e) => new IFC4X3.IfcReinforcingMesh(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17]),
  2310774935: (r, e) => new IFC4X3.IfcReinforcingMeshType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], e[18], e[19]),
  3818125796: (r, e) => new IFC4X3.IfcRelAdheresToElement(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  160246688: (r, e) => new IFC4X3.IfcRelAggregates(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  146592293: (r, e) => new IFC4X3.IfcRoad(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  550521510: (r, e) => new IFC4X3.IfcRoadPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2781568857: (r, e) => new IFC4X3.IfcRoofType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1768891740: (r, e) => new IFC4X3.IfcSanitaryTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2157484638: (r, e) => new IFC4X3.IfcSeamCurve(r, e[0], e[1], e[2]),
  3649235739: (r, e) => new IFC4X3.IfcSecondOrderPolynomialSpiral(r, e[0], e[1], e[2], e[3]),
  544395925: (r, e) => new IFC4X3.IfcSegmentedReferenceCurve(r, e[0], e[1], e[2], e[3]),
  1027922057: (r, e) => new IFC4X3.IfcSeventhOrderPolynomialSpiral(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074543187: (r, e) => new IFC4X3.IfcShadingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  33720170: (r, e) => new IFC4X3.IfcSign(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3599934289: (r, e) => new IFC4X3.IfcSignType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1894708472: (r, e) => new IFC4X3.IfcSignalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  42703149: (r, e) => new IFC4X3.IfcSineSpiral(r, e[0], e[1], e[2], e[3]),
  4097777520: (r, e) => new IFC4X3.IfcSite(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2533589738: (r, e) => new IFC4X3.IfcSlabType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1072016465: (r, e) => new IFC4X3.IfcSolarDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3856911033: (r, e) => new IFC4X3.IfcSpace(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1305183839: (r, e) => new IFC4X3.IfcSpaceHeaterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3812236995: (r, e) => new IFC4X3.IfcSpaceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3112655638: (r, e) => new IFC4X3.IfcStackTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1039846685: (r, e) => new IFC4X3.IfcStairFlightType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  338393293: (r, e) => new IFC4X3.IfcStairType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  682877961: (r, e) => new IFC4X3.IfcStructuralAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1179482911: (r, e) => new IFC4X3.IfcStructuralConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1004757350: (r, e) => new IFC4X3.IfcStructuralCurveAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  4243806635: (r, e) => new IFC4X3.IfcStructuralCurveConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  214636428: (r, e) => new IFC4X3.IfcStructuralCurveMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2445595289: (r, e) => new IFC4X3.IfcStructuralCurveMemberVarying(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2757150158: (r, e) => new IFC4X3.IfcStructuralCurveReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1807405624: (r, e) => new IFC4X3.IfcStructuralLinearAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1252848954: (r, e) => new IFC4X3.IfcStructuralLoadGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2082059205: (r, e) => new IFC4X3.IfcStructuralPointAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  734778138: (r, e) => new IFC4X3.IfcStructuralPointConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1235345126: (r, e) => new IFC4X3.IfcStructuralPointReaction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2986769608: (r, e) => new IFC4X3.IfcStructuralResultGroup(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3657597509: (r, e) => new IFC4X3.IfcStructuralSurfaceAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1975003073: (r, e) => new IFC4X3.IfcStructuralSurfaceConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  148013059: (r, e) => new IFC4X3.IfcSubContractResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3101698114: (r, e) => new IFC4X3.IfcSurfaceFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2315554128: (r, e) => new IFC4X3.IfcSwitchingDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2254336722: (r, e) => new IFC4X3.IfcSystem(r, e[0], e[1], e[2], e[3], e[4]),
  413509423: (r, e) => new IFC4X3.IfcSystemFurnitureElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  5716631: (r, e) => new IFC4X3.IfcTankType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3824725483: (r, e) => new IFC4X3.IfcTendon(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16]),
  2347447852: (r, e) => new IFC4X3.IfcTendonAnchor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3081323446: (r, e) => new IFC4X3.IfcTendonAnchorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3663046924: (r, e) => new IFC4X3.IfcTendonConduit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2281632017: (r, e) => new IFC4X3.IfcTendonConduitType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2415094496: (r, e) => new IFC4X3.IfcTendonType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  618700268: (r, e) => new IFC4X3.IfcTrackElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1692211062: (r, e) => new IFC4X3.IfcTransformerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2097647324: (r, e) => new IFC4X3.IfcTransportElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1953115116: (r, e) => new IFC4X3.IfcTransportationDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3593883385: (r, e) => new IFC4X3.IfcTrimmedCurve(r, e[0], e[1], e[2], e[3], e[4]),
  1600972822: (r, e) => new IFC4X3.IfcTubeBundleType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1911125066: (r, e) => new IFC4X3.IfcUnitaryEquipmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  728799441: (r, e) => new IFC4X3.IfcValveType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  840318589: (r, e) => new IFC4X3.IfcVehicle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1530820697: (r, e) => new IFC4X3.IfcVibrationDamper(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3956297820: (r, e) => new IFC4X3.IfcVibrationDamperType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2391383451: (r, e) => new IFC4X3.IfcVibrationIsolator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3313531582: (r, e) => new IFC4X3.IfcVibrationIsolatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2769231204: (r, e) => new IFC4X3.IfcVirtualElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  926996030: (r, e) => new IFC4X3.IfcVoidingFeature(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1898987631: (r, e) => new IFC4X3.IfcWallType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1133259667: (r, e) => new IFC4X3.IfcWasteTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4009809668: (r, e) => new IFC4X3.IfcWindowType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4088093105: (r, e) => new IFC4X3.IfcWorkCalendar(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1028945134: (r, e) => new IFC4X3.IfcWorkControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  4218914973: (r, e) => new IFC4X3.IfcWorkPlan(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  3342526732: (r, e) => new IFC4X3.IfcWorkSchedule(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1033361043: (r, e) => new IFC4X3.IfcZone(r, e[0], e[1], e[2], e[3], e[4], e[5]),
  3821786052: (r, e) => new IFC4X3.IfcActionRequest(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1411407467: (r, e) => new IFC4X3.IfcAirTerminalBoxType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3352864051: (r, e) => new IFC4X3.IfcAirTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1871374353: (r, e) => new IFC4X3.IfcAirToAirHeatRecoveryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4266260250: (r, e) => new IFC4X3.IfcAlignmentCant(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1545765605: (r, e) => new IFC4X3.IfcAlignmentHorizontal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  317615605: (r, e) => new IFC4X3.IfcAlignmentSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1662888072: (r, e) => new IFC4X3.IfcAlignmentVertical(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  3460190687: (r, e) => new IFC4X3.IfcAsset(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  1532957894: (r, e) => new IFC4X3.IfcAudioVisualApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1967976161: (r, e) => new IFC4X3.IfcBSplineCurve(r, e[0], e[1], e[2], e[3], e[4]),
  2461110595: (r, e) => new IFC4X3.IfcBSplineCurveWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  819618141: (r, e) => new IFC4X3.IfcBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3649138523: (r, e) => new IFC4X3.IfcBearingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  231477066: (r, e) => new IFC4X3.IfcBoilerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1136057603: (r, e) => new IFC4X3.IfcBoundaryCurve(r, e[0], e[1]),
  644574406: (r, e) => new IFC4X3.IfcBridge(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  963979645: (r, e) => new IFC4X3.IfcBridgePart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  4031249490: (r, e) => new IFC4X3.IfcBuilding(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  2979338954: (r, e) => new IFC4X3.IfcBuildingElementPart(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  39481116: (r, e) => new IFC4X3.IfcBuildingElementPartType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1909888760: (r, e) => new IFC4X3.IfcBuildingElementProxyType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1177604601: (r, e) => new IFC4X3.IfcBuildingSystem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1876633798: (r, e) => new IFC4X3.IfcBuiltElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3862327254: (r, e) => new IFC4X3.IfcBuiltSystem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  2188180465: (r, e) => new IFC4X3.IfcBurnerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  395041908: (r, e) => new IFC4X3.IfcCableCarrierFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3293546465: (r, e) => new IFC4X3.IfcCableCarrierSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2674252688: (r, e) => new IFC4X3.IfcCableFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1285652485: (r, e) => new IFC4X3.IfcCableSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3203706013: (r, e) => new IFC4X3.IfcCaissonFoundationType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2951183804: (r, e) => new IFC4X3.IfcChillerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3296154744: (r, e) => new IFC4X3.IfcChimney(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2611217952: (r, e) => new IFC4X3.IfcCircle(r, e[0], e[1]),
  1677625105: (r, e) => new IFC4X3.IfcCivilElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2301859152: (r, e) => new IFC4X3.IfcCoilType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  843113511: (r, e) => new IFC4X3.IfcColumn(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  400855858: (r, e) => new IFC4X3.IfcCommunicationsApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3850581409: (r, e) => new IFC4X3.IfcCompressorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2816379211: (r, e) => new IFC4X3.IfcCondenserType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3898045240: (r, e) => new IFC4X3.IfcConstructionEquipmentResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1060000209: (r, e) => new IFC4X3.IfcConstructionMaterialResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  488727124: (r, e) => new IFC4X3.IfcConstructionProductResource(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  2940368186: (r, e) => new IFC4X3.IfcConveyorSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  335055490: (r, e) => new IFC4X3.IfcCooledBeamType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2954562838: (r, e) => new IFC4X3.IfcCoolingTowerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1502416096: (r, e) => new IFC4X3.IfcCourse(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1973544240: (r, e) => new IFC4X3.IfcCovering(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3495092785: (r, e) => new IFC4X3.IfcCurtainWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3961806047: (r, e) => new IFC4X3.IfcDamperType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3426335179: (r, e) => new IFC4X3.IfcDeepFoundation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1335981549: (r, e) => new IFC4X3.IfcDiscreteAccessory(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2635815018: (r, e) => new IFC4X3.IfcDiscreteAccessoryType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  479945903: (r, e) => new IFC4X3.IfcDistributionBoardType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1599208980: (r, e) => new IFC4X3.IfcDistributionChamberElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2063403501: (r, e) => new IFC4X3.IfcDistributionControlElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1945004755: (r, e) => new IFC4X3.IfcDistributionElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3040386961: (r, e) => new IFC4X3.IfcDistributionFlowElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3041715199: (r, e) => new IFC4X3.IfcDistributionPort(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3205830791: (r, e) => new IFC4X3.IfcDistributionSystem(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  395920057: (r, e) => new IFC4X3.IfcDoor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  869906466: (r, e) => new IFC4X3.IfcDuctFittingType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3760055223: (r, e) => new IFC4X3.IfcDuctSegmentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2030761528: (r, e) => new IFC4X3.IfcDuctSilencerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3071239417: (r, e) => new IFC4X3.IfcEarthworksCut(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1077100507: (r, e) => new IFC4X3.IfcEarthworksElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3376911765: (r, e) => new IFC4X3.IfcEarthworksFill(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  663422040: (r, e) => new IFC4X3.IfcElectricApplianceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2417008758: (r, e) => new IFC4X3.IfcElectricDistributionBoardType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3277789161: (r, e) => new IFC4X3.IfcElectricFlowStorageDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2142170206: (r, e) => new IFC4X3.IfcElectricFlowTreatmentDeviceType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1534661035: (r, e) => new IFC4X3.IfcElectricGeneratorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1217240411: (r, e) => new IFC4X3.IfcElectricMotorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  712377611: (r, e) => new IFC4X3.IfcElectricTimeControlType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1658829314: (r, e) => new IFC4X3.IfcEnergyConversionDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2814081492: (r, e) => new IFC4X3.IfcEngine(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3747195512: (r, e) => new IFC4X3.IfcEvaporativeCooler(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  484807127: (r, e) => new IFC4X3.IfcEvaporator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1209101575: (r, e) => new IFC4X3.IfcExternalSpatialElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  346874300: (r, e) => new IFC4X3.IfcFanType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1810631287: (r, e) => new IFC4X3.IfcFilterType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4222183408: (r, e) => new IFC4X3.IfcFireSuppressionTerminalType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2058353004: (r, e) => new IFC4X3.IfcFlowController(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4278956645: (r, e) => new IFC4X3.IfcFlowFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  4037862832: (r, e) => new IFC4X3.IfcFlowInstrumentType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  2188021234: (r, e) => new IFC4X3.IfcFlowMeter(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3132237377: (r, e) => new IFC4X3.IfcFlowMovingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  987401354: (r, e) => new IFC4X3.IfcFlowSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  707683696: (r, e) => new IFC4X3.IfcFlowStorageDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2223149337: (r, e) => new IFC4X3.IfcFlowTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3508470533: (r, e) => new IFC4X3.IfcFlowTreatmentDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  900683007: (r, e) => new IFC4X3.IfcFooting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2713699986: (r, e) => new IFC4X3.IfcGeotechnicalAssembly(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  3009204131: (r, e) => new IFC4X3.IfcGrid(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  3319311131: (r, e) => new IFC4X3.IfcHeatExchanger(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2068733104: (r, e) => new IFC4X3.IfcHumidifier(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4175244083: (r, e) => new IFC4X3.IfcInterceptor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2176052936: (r, e) => new IFC4X3.IfcJunctionBox(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2696325953: (r, e) => new IFC4X3.IfcKerb(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  76236018: (r, e) => new IFC4X3.IfcLamp(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  629592764: (r, e) => new IFC4X3.IfcLightFixture(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1154579445: (r, e) => new IFC4X3.IfcLinearPositioningElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1638804497: (r, e) => new IFC4X3.IfcLiquidTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1437502449: (r, e) => new IFC4X3.IfcMedicalDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1073191201: (r, e) => new IFC4X3.IfcMember(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2078563270: (r, e) => new IFC4X3.IfcMobileTelecommunicationsAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  234836483: (r, e) => new IFC4X3.IfcMooringDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2474470126: (r, e) => new IFC4X3.IfcMotorConnection(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2182337498: (r, e) => new IFC4X3.IfcNavigationElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  144952367: (r, e) => new IFC4X3.IfcOuterBoundaryCurve(r, e[0], e[1]),
  3694346114: (r, e) => new IFC4X3.IfcOutlet(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1383356374: (r, e) => new IFC4X3.IfcPavement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1687234759: (r, e) => new IFC4X3.IfcPile(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  310824031: (r, e) => new IFC4X3.IfcPipeFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3612865200: (r, e) => new IFC4X3.IfcPipeSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3171933400: (r, e) => new IFC4X3.IfcPlate(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  738039164: (r, e) => new IFC4X3.IfcProtectiveDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  655969474: (r, e) => new IFC4X3.IfcProtectiveDeviceTrippingUnitType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  90941305: (r, e) => new IFC4X3.IfcPump(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3290496277: (r, e) => new IFC4X3.IfcRail(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2262370178: (r, e) => new IFC4X3.IfcRailing(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3024970846: (r, e) => new IFC4X3.IfcRamp(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3283111854: (r, e) => new IFC4X3.IfcRampFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1232101972: (r, e) => new IFC4X3.IfcRationalBSplineCurveWithKnots(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3798194928: (r, e) => new IFC4X3.IfcReinforcedSoil(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  979691226: (r, e) => new IFC4X3.IfcReinforcingBar(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13]),
  2572171363: (r, e) => new IFC4X3.IfcReinforcingBarType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]),
  2016517767: (r, e) => new IFC4X3.IfcRoof(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3053780830: (r, e) => new IFC4X3.IfcSanitaryTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1783015770: (r, e) => new IFC4X3.IfcSensorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1329646415: (r, e) => new IFC4X3.IfcShadingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  991950508: (r, e) => new IFC4X3.IfcSignal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1529196076: (r, e) => new IFC4X3.IfcSlab(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3420628829: (r, e) => new IFC4X3.IfcSolarDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1999602285: (r, e) => new IFC4X3.IfcSpaceHeater(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1404847402: (r, e) => new IFC4X3.IfcStackTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  331165859: (r, e) => new IFC4X3.IfcStair(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4252922144: (r, e) => new IFC4X3.IfcStairFlight(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2515109513: (r, e) => new IFC4X3.IfcStructuralAnalysisModel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  385403989: (r, e) => new IFC4X3.IfcStructuralLoadCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10]),
  1621171031: (r, e) => new IFC4X3.IfcStructuralPlanarAction(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11]),
  1162798199: (r, e) => new IFC4X3.IfcSwitchingDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  812556717: (r, e) => new IFC4X3.IfcTank(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3425753595: (r, e) => new IFC4X3.IfcTrackElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3825984169: (r, e) => new IFC4X3.IfcTransformer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1620046519: (r, e) => new IFC4X3.IfcTransportElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3026737570: (r, e) => new IFC4X3.IfcTubeBundle(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3179687236: (r, e) => new IFC4X3.IfcUnitaryControlElementType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  4292641817: (r, e) => new IFC4X3.IfcUnitaryEquipment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4207607924: (r, e) => new IFC4X3.IfcValve(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2391406946: (r, e) => new IFC4X3.IfcWall(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3512223829: (r, e) => new IFC4X3.IfcWallStandardCase(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4237592921: (r, e) => new IFC4X3.IfcWasteTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3304561284: (r, e) => new IFC4X3.IfcWindow(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12]),
  2874132201: (r, e) => new IFC4X3.IfcActuatorType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  1634111441: (r, e) => new IFC4X3.IfcAirTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  177149247: (r, e) => new IFC4X3.IfcAirTerminalBox(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2056796094: (r, e) => new IFC4X3.IfcAirToAirHeatRecovery(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3001207471: (r, e) => new IFC4X3.IfcAlarmType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  325726236: (r, e) => new IFC4X3.IfcAlignment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  277319702: (r, e) => new IFC4X3.IfcAudioVisualAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  753842376: (r, e) => new IFC4X3.IfcBeam(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4196446775: (r, e) => new IFC4X3.IfcBearing(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  32344328: (r, e) => new IFC4X3.IfcBoiler(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3314249567: (r, e) => new IFC4X3.IfcBorehole(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1095909175: (r, e) => new IFC4X3.IfcBuildingElementProxy(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2938176219: (r, e) => new IFC4X3.IfcBurner(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  635142910: (r, e) => new IFC4X3.IfcCableCarrierFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3758799889: (r, e) => new IFC4X3.IfcCableCarrierSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1051757585: (r, e) => new IFC4X3.IfcCableFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4217484030: (r, e) => new IFC4X3.IfcCableSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3999819293: (r, e) => new IFC4X3.IfcCaissonFoundation(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3902619387: (r, e) => new IFC4X3.IfcChiller(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  639361253: (r, e) => new IFC4X3.IfcCoil(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3221913625: (r, e) => new IFC4X3.IfcCommunicationsAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3571504051: (r, e) => new IFC4X3.IfcCompressor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2272882330: (r, e) => new IFC4X3.IfcCondenser(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  578613899: (r, e) => new IFC4X3.IfcControllerType(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9]),
  3460952963: (r, e) => new IFC4X3.IfcConveyorSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4136498852: (r, e) => new IFC4X3.IfcCooledBeam(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3640358203: (r, e) => new IFC4X3.IfcCoolingTower(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4074379575: (r, e) => new IFC4X3.IfcDamper(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3693000487: (r, e) => new IFC4X3.IfcDistributionBoard(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1052013943: (r, e) => new IFC4X3.IfcDistributionChamberElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  562808652: (r, e) => new IFC4X3.IfcDistributionCircuit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6]),
  1062813311: (r, e) => new IFC4X3.IfcDistributionControlElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  342316401: (r, e) => new IFC4X3.IfcDuctFitting(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3518393246: (r, e) => new IFC4X3.IfcDuctSegment(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1360408905: (r, e) => new IFC4X3.IfcDuctSilencer(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1904799276: (r, e) => new IFC4X3.IfcElectricAppliance(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  862014818: (r, e) => new IFC4X3.IfcElectricDistributionBoard(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3310460725: (r, e) => new IFC4X3.IfcElectricFlowStorageDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  24726584: (r, e) => new IFC4X3.IfcElectricFlowTreatmentDevice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  264262732: (r, e) => new IFC4X3.IfcElectricGenerator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  402227799: (r, e) => new IFC4X3.IfcElectricMotor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1003880860: (r, e) => new IFC4X3.IfcElectricTimeControl(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3415622556: (r, e) => new IFC4X3.IfcFan(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  819412036: (r, e) => new IFC4X3.IfcFilter(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  1426591983: (r, e) => new IFC4X3.IfcFireSuppressionTerminal(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  182646315: (r, e) => new IFC4X3.IfcFlowInstrument(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  2680139844: (r, e) => new IFC4X3.IfcGeomodel(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  1971632696: (r, e) => new IFC4X3.IfcGeoslice(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]),
  2295281155: (r, e) => new IFC4X3.IfcProtectiveDeviceTrippingUnit(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4086658281: (r, e) => new IFC4X3.IfcSensor(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  630975310: (r, e) => new IFC4X3.IfcUnitaryControlElement(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  4288193352: (r, e) => new IFC4X3.IfcActuator(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  3087945054: (r, e) => new IFC4X3.IfcAlarm(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8]),
  25142252: (r, e) => new IFC4X3.IfcController(r, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8])
};
ToRawLineData[3] = {
  3630933823: (r) => [r.Role, r.UserDefinedRole, r.Description],
  618182010: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose],
  2879124712: (r) => [r.StartTag, r.EndTag],
  3633395639: (r) => [r.StartTag, r.EndTag, r.StartDistAlong, r.HorizontalLength, r.StartHeight, r.StartGradient, r.EndGradient, r.RadiusOfCurvature, r.PredefinedType],
  639542469: (r) => [r.ApplicationDeveloper, r.Version, r.ApplicationFullName, r.ApplicationIdentifier],
  411424972: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.Category, r.Condition, r.ArithmeticOperator, r.Components],
  130549933: (r) => [r.Identifier, r.Name, r.Description, r.TimeOfApproval, r.Status, r.Level, r.Qualifier, r.RequestingApproval, r.GivingApproval],
  4037036970: (r) => [r.Name],
  1560379544: (r) => [r.Name, r.TranslationalStiffnessByLengthX ? Labelise(r.TranslationalStiffnessByLengthX) : null, r.TranslationalStiffnessByLengthY ? Labelise(r.TranslationalStiffnessByLengthY) : null, r.TranslationalStiffnessByLengthZ ? Labelise(r.TranslationalStiffnessByLengthZ) : null, r.RotationalStiffnessByLengthX ? Labelise(r.RotationalStiffnessByLengthX) : null, r.RotationalStiffnessByLengthY ? Labelise(r.RotationalStiffnessByLengthY) : null, r.RotationalStiffnessByLengthZ ? Labelise(r.RotationalStiffnessByLengthZ) : null],
  3367102660: (r) => [r.Name, r.TranslationalStiffnessByAreaX ? Labelise(r.TranslationalStiffnessByAreaX) : null, r.TranslationalStiffnessByAreaY ? Labelise(r.TranslationalStiffnessByAreaY) : null, r.TranslationalStiffnessByAreaZ ? Labelise(r.TranslationalStiffnessByAreaZ) : null],
  1387855156: (r) => [r.Name, r.TranslationalStiffnessX ? Labelise(r.TranslationalStiffnessX) : null, r.TranslationalStiffnessY ? Labelise(r.TranslationalStiffnessY) : null, r.TranslationalStiffnessZ ? Labelise(r.TranslationalStiffnessZ) : null, r.RotationalStiffnessX ? Labelise(r.RotationalStiffnessX) : null, r.RotationalStiffnessY ? Labelise(r.RotationalStiffnessY) : null, r.RotationalStiffnessZ ? Labelise(r.RotationalStiffnessZ) : null],
  2069777674: (r) => [r.Name, r.TranslationalStiffnessX ? Labelise(r.TranslationalStiffnessX) : null, r.TranslationalStiffnessY ? Labelise(r.TranslationalStiffnessY) : null, r.TranslationalStiffnessZ ? Labelise(r.TranslationalStiffnessZ) : null, r.RotationalStiffnessX ? Labelise(r.RotationalStiffnessX) : null, r.RotationalStiffnessY ? Labelise(r.RotationalStiffnessY) : null, r.RotationalStiffnessZ ? Labelise(r.RotationalStiffnessZ) : null, r.WarpingStiffness ? Labelise(r.WarpingStiffness) : null],
  2859738748: (r) => [],
  2614616156: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement],
  2732653382: (r) => [r.SurfaceOnRelatingElement, r.SurfaceOnRelatedElement],
  775493141: (r) => [r.VolumeOnRelatingElement, r.VolumeOnRelatedElement],
  1959218052: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade],
  1785450214: (r) => [r.SourceCRS, r.TargetCRS],
  1466758467: (r) => [r.Name, r.Description, r.GeodeticDatum, r.VerticalDatum],
  602808272: (r) => [r.Name, r.Description, r.AppliedValue, r.UnitBasis, r.ApplicableDate, r.FixedUntilDate, r.Category, r.Condition, r.ArithmeticOperator, r.Components],
  1765591967: (r) => [r.Elements, r.UnitType, r.UserDefinedType, r.Name],
  1045800335: (r) => [r.Unit, r.Exponent],
  2949456006: (r) => [r.LengthExponent, r.MassExponent, r.TimeExponent, r.ElectricCurrentExponent, r.ThermodynamicTemperatureExponent, r.AmountOfSubstanceExponent, r.LuminousIntensityExponent],
  4294318154: (r) => [],
  3200245327: (r) => [r.Location, r.Identification, r.Name],
  2242383968: (r) => [r.Location, r.Identification, r.Name],
  1040185647: (r) => [r.Location, r.Identification, r.Name],
  3548104201: (r) => [r.Location, r.Identification, r.Name],
  852622518: (r) => {
    var e;
    return [r.AxisTag, r.AxisCurve, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  3020489413: (r) => [r.TimeStamp, r.ListValues.map((e) => Labelise(e))],
  2655187982: (r) => [r.Name, r.Version, r.Publisher, r.VersionDate, r.Location, r.Description],
  3452421091: (r) => [r.Location, r.Identification, r.Name, r.Description, r.Language, r.ReferencedLibrary],
  4162380809: (r) => [r.MainPlaneAngle, r.SecondaryPlaneAngle, r.LuminousIntensity],
  1566485204: (r) => [r.LightDistributionCurve, r.DistributionData],
  3057273783: (r) => [r.SourceCRS, r.TargetCRS, r.Eastings, r.Northings, r.OrthogonalHeight, r.XAxisAbscissa, r.XAxisOrdinate, r.Scale, r.ScaleY, r.ScaleZ],
  1847130766: (r) => [r.MaterialClassifications, r.ClassifiedMaterial],
  760658860: (r) => [],
  248100487: (r) => {
    var e;
    return [r.Material, r.LayerThickness, (e = r.IsVentilated) == null ? void 0 : e.toString(), r.Name, r.Description, r.Category, r.Priority];
  },
  3303938423: (r) => [r.MaterialLayers, r.LayerSetName, r.Description],
  1847252529: (r) => {
    var e;
    return [r.Material, r.LayerThickness, (e = r.IsVentilated) == null ? void 0 : e.toString(), r.Name, r.Description, r.Category, r.Priority, r.OffsetDirection, r.OffsetValues];
  },
  2199411900: (r) => [r.Materials],
  2235152071: (r) => [r.Name, r.Description, r.Material, r.Profile, r.Priority, r.Category],
  164193824: (r) => [r.Name, r.Description, r.MaterialProfiles, r.CompositeProfile],
  552965576: (r) => [r.Name, r.Description, r.Material, r.Profile, r.Priority, r.Category, r.OffsetValues],
  1507914824: (r) => [],
  2597039031: (r) => [Labelise(r.ValueComponent), r.UnitComponent],
  3368373690: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.Benchmark, r.ValueSource, r.DataValue, r.ReferencePath],
  2706619895: (r) => [r.Currency],
  1918398963: (r) => [r.Dimensions, r.UnitType],
  3701648758: (r) => [r.PlacementRelTo],
  2251480897: (r) => [r.Name, r.Description, r.ConstraintGrade, r.ConstraintSource, r.CreatingActor, r.CreationTime, r.UserDefinedGrade, r.BenchmarkValues, r.LogicalAggregator, r.ObjectiveQualifier, r.UserDefinedQualifier],
  4251960020: (r) => [r.Identification, r.Name, r.Description, r.Roles, r.Addresses],
  1207048766: (r) => [r.OwningUser, r.OwningApplication, r.State, r.ChangeAction, r.LastModifiedDate, r.LastModifyingUser, r.LastModifyingApplication, r.CreationDate],
  2077209135: (r) => [r.Identification, r.FamilyName, r.GivenName, r.MiddleNames, r.PrefixTitles, r.SuffixTitles, r.Roles, r.Addresses],
  101040310: (r) => [r.ThePerson, r.TheOrganization, r.Roles],
  2483315170: (r) => [r.Name, r.Description],
  2226359599: (r) => [r.Name, r.Description, r.Unit],
  3355820592: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.InternalLocation, r.AddressLines, r.PostalBox, r.Town, r.Region, r.PostalCode, r.Country],
  677532197: (r) => [],
  2022622350: (r) => [r.Name, r.Description, r.AssignedItems, r.Identifier],
  1304840413: (r) => {
    var e, s, o;
    return [r.Name, r.Description, r.AssignedItems, r.Identifier, (e = r.LayerOn) == null ? void 0 : e.toString(), (s = r.LayerFrozen) == null ? void 0 : s.toString(), (o = r.LayerBlocked) == null ? void 0 : o.toString(), r.LayerStyles];
  },
  3119450353: (r) => [r.Name],
  2095639259: (r) => [r.Name, r.Description, r.Representations],
  3958567839: (r) => [r.ProfileType, r.ProfileName],
  3843373140: (r) => [r.Name, r.Description, r.GeodeticDatum, r.VerticalDatum, r.MapProjection, r.MapZone, r.MapUnit],
  986844984: (r) => [],
  3710013099: (r) => [r.Name, r.EnumerationValues.map((e) => Labelise(e)), r.Unit],
  2044713172: (r) => [r.Name, r.Description, r.Unit, r.AreaValue, r.Formula],
  2093928680: (r) => [r.Name, r.Description, r.Unit, r.CountValue, r.Formula],
  931644368: (r) => [r.Name, r.Description, r.Unit, r.LengthValue, r.Formula],
  2691318326: (r) => [r.Name, r.Description, r.Unit, r.NumberValue, r.Formula],
  3252649465: (r) => [r.Name, r.Description, r.Unit, r.TimeValue, r.Formula],
  2405470396: (r) => [r.Name, r.Description, r.Unit, r.VolumeValue, r.Formula],
  825690147: (r) => [r.Name, r.Description, r.Unit, r.WeightValue, r.Formula],
  3915482550: (r) => [r.RecurrenceType, r.DayComponent, r.WeekdayComponent, r.MonthComponent, r.Position, r.Interval, r.Occurrences, r.TimePeriods],
  2433181523: (r) => [r.TypeIdentifier, r.AttributeIdentifier, r.InstanceName, r.ListPositions, r.InnerReference],
  1076942058: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3377609919: (r) => [r.ContextIdentifier, r.ContextType],
  3008791417: (r) => [],
  1660063152: (r) => [r.MappingOrigin, r.MappedRepresentation],
  2439245199: (r) => [r.Name, r.Description],
  2341007311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  448429030: (r) => [r.Dimensions, r.UnitType, r.Prefix, r.Name],
  1054537805: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin],
  867548509: (r) => {
    var e;
    return [r.ShapeRepresentations, r.Name, r.Description, (e = r.ProductDefinitional) == null ? void 0 : e.toString(), r.PartOfProductDefinitionShape];
  },
  3982875396: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  4240577450: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  2273995522: (r) => [r.Name],
  2162789131: (r) => [r.Name],
  3478079324: (r) => [r.Name, r.Values, r.Locations],
  609421318: (r) => [r.Name],
  2525727697: (r) => [r.Name],
  3408363356: (r) => [r.Name, r.DeltaTConstant, r.DeltaTY, r.DeltaTZ],
  2830218821: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  3958052878: (r) => [r.Item, r.Styles, r.Name],
  3049322572: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  2934153892: (r) => [r.Name, r.SurfaceReinforcement1, r.SurfaceReinforcement2, r.ShearReinforcement],
  1300840506: (r) => [r.Name, r.Side, r.Styles],
  3303107099: (r) => [r.DiffuseTransmissionColour, r.DiffuseReflectionColour, r.TransmissionColour, r.ReflectanceColour],
  1607154358: (r) => [r.RefractionIndex, r.DispersionFactor],
  846575682: (r) => [r.SurfaceColour, r.Transparency],
  1351298697: (r) => [r.Textures],
  626085974: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter];
  },
  985171141: (r) => [r.Name, r.Rows, r.Columns],
  2043862942: (r) => [r.Identifier, r.Name, r.Description, r.Unit, r.ReferencePath],
  531007025: (r) => {
    var e;
    return [r.RowCells ? r.RowCells.map((s) => Labelise(s)) : null, (e = r.IsHeading) == null ? void 0 : e.toString()];
  },
  1549132990: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.DurationType, r.ScheduleDuration, r.ScheduleStart, r.ScheduleFinish, r.EarlyStart, r.EarlyFinish, r.LateStart, r.LateFinish, r.FreeFloat, r.TotalFloat, (e = r.IsCritical) == null ? void 0 : e.toString(), r.StatusTime, r.ActualDuration, r.ActualStart, r.ActualFinish, r.RemainingTime, r.Completion];
  },
  2771591690: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.DurationType, r.ScheduleDuration, r.ScheduleStart, r.ScheduleFinish, r.EarlyStart, r.EarlyFinish, r.LateStart, r.LateFinish, r.FreeFloat, r.TotalFloat, (e = r.IsCritical) == null ? void 0 : e.toString(), r.StatusTime, r.ActualDuration, r.ActualStart, r.ActualFinish, r.RemainingTime, r.Completion, r.Recurrence];
  },
  912023232: (r) => [r.Purpose, r.Description, r.UserDefinedPurpose, r.TelephoneNumbers, r.FacsimileNumbers, r.PagerNumber, r.ElectronicMailAddresses, r.WWWHomePageURL, r.MessagingIDs],
  1447204868: (r) => {
    var e;
    return [r.Name, r.TextCharacterAppearance, r.TextStyle, r.TextFontStyle, (e = r.ModelOrDraughting) == null ? void 0 : e.toString()];
  },
  2636378356: (r) => [r.Colour, r.BackgroundColour],
  1640371178: (r) => [r.TextIndent ? Labelise(r.TextIndent) : null, r.TextAlign, r.TextDecoration, r.LetterSpacing ? Labelise(r.LetterSpacing) : null, r.WordSpacing ? Labelise(r.WordSpacing) : null, r.TextTransform, r.LineHeight ? Labelise(r.LineHeight) : null],
  280115917: (r) => [r.Maps],
  1742049831: (r) => [r.Maps, r.Mode, r.Parameter],
  222769930: (r) => [r.TexCoordIndex, r.TexCoordsOf],
  1010789467: (r) => [r.TexCoordIndex, r.TexCoordsOf, r.InnerTexCoordIndices],
  2552916305: (r) => [r.Maps, r.Vertices, r.MappedTo],
  1210645708: (r) => [r.Coordinates],
  3611470254: (r) => [r.TexCoordsList],
  1199560280: (r) => [r.StartTime, r.EndTime],
  3101149627: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit],
  581633288: (r) => [r.ListValues.map((e) => Labelise(e))],
  1377556343: (r) => [],
  1735638870: (r) => [r.ContextOfItems, r.RepresentationIdentifier, r.RepresentationType, r.Items],
  180925521: (r) => [r.Units],
  2799835756: (r) => [],
  1907098498: (r) => [r.VertexGeometry],
  891718957: (r) => [r.IntersectingAxes, r.OffsetDistances],
  1236880293: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.RecurrencePattern, r.StartDate, r.FinishDate],
  3752311538: (r) => [r.StartTag, r.EndTag, r.StartDistAlong, r.HorizontalLength, r.StartCantLeft, r.EndCantLeft, r.StartCantRight, r.EndCantRight, r.PredefinedType],
  536804194: (r) => [r.StartTag, r.EndTag, r.StartPoint, r.StartDirection, r.StartRadiusOfCurvature, r.EndRadiusOfCurvature, r.SegmentLength, r.GravityCenterLineHeight, r.PredefinedType],
  3869604511: (r) => [r.Name, r.Description, r.RelatingApproval, r.RelatedApprovals],
  3798115385: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve],
  1310608509: (r) => [r.ProfileType, r.ProfileName, r.Curve],
  2705031697: (r) => [r.ProfileType, r.ProfileName, r.OuterCurve, r.InnerCurves],
  616511568: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.RasterFormat, r.RasterCode];
  },
  3150382593: (r) => [r.ProfileType, r.ProfileName, r.Curve, r.Thickness],
  747523909: (r) => [r.Source, r.Edition, r.EditionDate, r.Name, r.Description, r.Specification, r.ReferenceTokens],
  647927063: (r) => [r.Location, r.Identification, r.Name, r.ReferencedSource, r.Description, r.Sort],
  3285139300: (r) => [r.ColourList],
  3264961684: (r) => [r.Name],
  1485152156: (r) => [r.ProfileType, r.ProfileName, r.Profiles, r.Label],
  370225590: (r) => [r.CfsFaces],
  1981873012: (r) => [r.CurveOnRelatingElement, r.CurveOnRelatedElement],
  45288368: (r) => [r.PointOnRelatingElement, r.PointOnRelatedElement, r.EccentricityInX, r.EccentricityInY, r.EccentricityInZ],
  3050246964: (r) => [r.Dimensions, r.UnitType, r.Name],
  2889183280: (r) => [r.Dimensions, r.UnitType, r.Name, r.ConversionFactor],
  2713554722: (r) => [r.Dimensions, r.UnitType, r.Name, r.ConversionFactor, r.ConversionOffset],
  539742890: (r) => [r.Name, r.Description, r.RelatingMonetaryUnit, r.RelatedMonetaryUnit, r.ExchangeRate, r.RateDateTime, r.RateSource],
  3800577675: (r) => {
    var e;
    return [r.Name, r.CurveFont, r.CurveWidth ? Labelise(r.CurveWidth) : null, r.CurveColour, (e = r.ModelOrDraughting) == null ? void 0 : e.toString()];
  },
  1105321065: (r) => [r.Name, r.PatternList],
  2367409068: (r) => [r.Name, r.CurveStyleFont, r.CurveFontScaling],
  3510044353: (r) => [r.VisibleSegmentLength, r.InvisibleSegmentLength],
  3632507154: (r) => [r.ProfileType, r.ProfileName, r.ParentProfile, r.Operator, r.Label],
  1154170062: (r) => [r.Identification, r.Name, r.Description, r.Location, r.Purpose, r.IntendedUse, r.Scope, r.Revision, r.DocumentOwner, r.Editors, r.CreationTime, r.LastRevisionTime, r.ElectronicFormat, r.ValidFrom, r.ValidUntil, r.Confidentiality, r.Status],
  770865208: (r) => [r.Name, r.Description, r.RelatingDocument, r.RelatedDocuments, r.RelationshipType],
  3732053477: (r) => [r.Location, r.Identification, r.Name, r.Description, r.ReferencedDocument],
  3900360178: (r) => [r.EdgeStart, r.EdgeEnd],
  476780140: (r) => {
    var e;
    return [r.EdgeStart, r.EdgeEnd, r.EdgeGeometry, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  211053100: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.ActualDate, r.EarlyDate, r.LateDate, r.ScheduleDate],
  297599258: (r) => [r.Name, r.Description, r.Properties],
  1437805879: (r) => [r.Name, r.Description, r.RelatingReference, r.RelatedResourceObjects],
  2556980723: (r) => [r.Bounds],
  1809719519: (r) => {
    var e;
    return [r.Bound, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  803316827: (r) => {
    var e;
    return [r.Bound, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  3008276851: (r) => {
    var e;
    return [r.Bounds, r.FaceSurface, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  4219587988: (r) => [r.Name, r.TensionFailureX, r.TensionFailureY, r.TensionFailureZ, r.CompressionFailureX, r.CompressionFailureY, r.CompressionFailureZ],
  738692330: (r) => {
    var e;
    return [r.Name, r.FillStyles, (e = r.ModelOrDraughting) == null ? void 0 : e.toString()];
  },
  3448662350: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth],
  2453401579: (r) => [],
  4142052618: (r) => [r.ContextIdentifier, r.ContextType, r.CoordinateSpaceDimension, r.Precision, r.WorldCoordinateSystem, r.TrueNorth, r.ParentContext, r.TargetScale, r.TargetView, r.UserDefinedTargetView],
  3590301190: (r) => [r.Elements],
  178086475: (r) => [r.PlacementRelTo, r.PlacementLocation, r.PlacementRefDirection],
  812098782: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString()];
  },
  3905492369: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.URLReference];
  },
  3570813810: (r) => [r.MappedTo, r.Opacity, r.Colours, r.ColourIndex],
  1437953363: (r) => [r.Maps, r.MappedTo, r.TexCoords],
  2133299955: (r) => [r.Maps, r.MappedTo, r.TexCoords, r.TexCoordIndex],
  3741457305: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.Values],
  1585845231: (r) => [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, Labelise(r.LagValue), r.DurationType],
  1402838566: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  125510826: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity],
  2604431987: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Orientation],
  4266656042: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.ColourAppearance, r.ColourTemperature, r.LuminousFlux, r.LightEmissionSource, r.LightDistributionDataSource],
  1520743889: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation],
  3422422726: (r) => [r.Name, r.LightColour, r.AmbientIntensity, r.Intensity, r.Position, r.Radius, r.ConstantAttenuation, r.DistanceAttenuation, r.QuadricAttenuation, r.Orientation, r.ConcentrationExponent, r.SpreadAngle, r.BeamWidthAngle],
  388784114: (r) => [r.PlacementRelTo, r.RelativePlacement, r.CartesianPosition],
  2624227202: (r) => [r.PlacementRelTo, r.RelativePlacement],
  1008929658: (r) => [],
  2347385850: (r) => [r.MappingSource, r.MappingTarget],
  1838606355: (r) => [r.Name, r.Description, r.Category],
  3708119e3: (r) => [r.Name, r.Description, r.Material, r.Fraction, r.Category],
  2852063980: (r) => [r.Name, r.Description, r.MaterialConstituents],
  2022407955: (r) => [r.Name, r.Description, r.Representations, r.RepresentedMaterial],
  1303795690: (r) => [r.ForLayerSet, r.LayerSetDirection, r.DirectionSense, r.OffsetFromReferenceLine, r.ReferenceExtent],
  3079605661: (r) => [r.ForProfileSet, r.CardinalPoint, r.ReferenceExtent],
  3404854881: (r) => [r.ForProfileSet, r.CardinalPoint, r.ReferenceExtent, r.ForProfileEndSet, r.CardinalEndPoint],
  3265635763: (r) => [r.Name, r.Description, r.Properties, r.Material],
  853536259: (r) => [r.Name, r.Description, r.RelatingMaterial, r.RelatedMaterials, r.MaterialExpression],
  2998442950: (r) => [r.ProfileType, r.ProfileName, r.ParentProfile, r.Operator, r.Label],
  219451334: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  182550632: (r) => {
    var e;
    return [r.ProfileType, r.ProfileName, (e = r.HorizontalWidths) == null ? void 0 : e.toString(), r.Widths, r.Slopes, r.Tags, r.OffsetPoint];
  },
  2665983363: (r) => [r.CfsFaces],
  1411181986: (r) => [r.Name, r.Description, r.RelatingOrganization, r.RelatedOrganizations],
  1029017970: (r) => {
    var e;
    return [r.EdgeStart, r.EdgeEnd, r.EdgeElement, (e = r.Orientation) == null ? void 0 : e.toString()];
  },
  2529465313: (r) => [r.ProfileType, r.ProfileName, r.Position],
  2519244187: (r) => [r.EdgeList],
  3021840470: (r) => [r.Name, r.Description, r.HasQuantities, r.Discrimination, r.Quality, r.Usage],
  597895409: (r) => {
    var e, s;
    return [(e = r.RepeatS) == null ? void 0 : e.toString(), (s = r.RepeatT) == null ? void 0 : s.toString(), r.Mode, r.TextureTransform, r.Parameter, r.Width, r.Height, r.ColourComponents, r.Pixel];
  },
  2004835150: (r) => [r.Location],
  1663979128: (r) => [r.SizeInX, r.SizeInY],
  2067069095: (r) => [],
  2165702409: (r) => [Labelise(r.DistanceAlong), r.OffsetLateral, r.OffsetVertical, r.OffsetLongitudinal, r.BasisCurve],
  4022376103: (r) => [r.BasisCurve, r.PointParameter],
  1423911732: (r) => [r.BasisSurface, r.PointParameterU, r.PointParameterV],
  2924175390: (r) => [r.Polygon],
  2775532180: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString(), r.Position, r.PolygonalBoundary];
  },
  3727388367: (r) => [r.Name],
  3778827333: (r) => [],
  1775413392: (r) => [r.Name],
  673634403: (r) => [r.Name, r.Description, r.Representations],
  2802850158: (r) => [r.Name, r.Description, r.Properties, r.ProfileDefinition],
  2598011224: (r) => [r.Name, r.Specification],
  1680319473: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  148025276: (r) => [r.Name, r.Description, r.DependingProperty, r.DependantProperty, r.Expression],
  3357820518: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1482703590: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2090586900: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  3615266464: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim],
  3413951693: (r) => [r.Name, r.Description, r.StartTime, r.EndTime, r.TimeSeriesDataType, r.DataOrigin, r.UserDefinedDataOrigin, r.Unit, r.TimeStep, r.Values],
  1580146022: (r) => [r.TotalCrossSectionArea, r.SteelGrade, r.BarSurface, r.EffectiveDepth, r.NominalBarDiameter, r.BarCount],
  478536968: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2943643501: (r) => [r.Name, r.Description, r.RelatedResourceObjects, r.RelatingApproval],
  1608871552: (r) => [r.Name, r.Description, r.RelatingConstraint, r.RelatedResourceObjects],
  1042787934: (r) => {
    var e;
    return [r.Name, r.DataOrigin, r.UserDefinedDataOrigin, r.ScheduleWork, r.ScheduleUsage, r.ScheduleStart, r.ScheduleFinish, r.ScheduleContour, r.LevelingDelay, (e = r.IsOverAllocated) == null ? void 0 : e.toString(), r.StatusTime, r.ActualWork, r.ActualUsage, r.ActualStart, r.ActualFinish, r.RemainingWork, r.RemainingUsage, r.Completion];
  },
  2778083089: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.RoundingRadius],
  2042790032: (r) => [r.SectionType, r.StartProfile, r.EndProfile],
  4165799628: (r) => [r.LongitudinalStartPosition, r.LongitudinalEndPosition, r.TransversePosition, r.ReinforcementRole, r.SectionDefinition, r.CrossSectionReinforcementDefinitions],
  1509187699: (r) => [r.SpineCurve, r.CrossSections, r.CrossSectionPositions],
  823603102: (r) => [r.Transition],
  4124623270: (r) => [r.SbsmBoundary],
  3692461612: (r) => [r.Name, r.Specification],
  2609359061: (r) => [r.Name, r.SlippageX, r.SlippageY, r.SlippageZ],
  723233188: (r) => [],
  1595516126: (r) => [r.Name, r.LinearForceX, r.LinearForceY, r.LinearForceZ, r.LinearMomentX, r.LinearMomentY, r.LinearMomentZ],
  2668620305: (r) => [r.Name, r.PlanarForceX, r.PlanarForceY, r.PlanarForceZ],
  2473145415: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ],
  1973038258: (r) => [r.Name, r.DisplacementX, r.DisplacementY, r.DisplacementZ, r.RotationalDisplacementRX, r.RotationalDisplacementRY, r.RotationalDisplacementRZ, r.Distortion],
  1597423693: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ],
  1190533807: (r) => [r.Name, r.ForceX, r.ForceY, r.ForceZ, r.MomentX, r.MomentY, r.MomentZ, r.WarpingMoment],
  2233826070: (r) => [r.EdgeStart, r.EdgeEnd, r.ParentEdge],
  2513912981: (r) => [],
  1878645084: (r) => [r.SurfaceColour, r.Transparency, r.DiffuseColour, r.TransmissionColour, r.DiffuseTransmissionColour, r.ReflectionColour, r.SpecularColour, r.SpecularHighlight ? Labelise(r.SpecularHighlight) : null, r.ReflectanceMethod],
  2247615214: (r) => [r.SweptArea, r.Position],
  1260650574: (r) => [r.Directrix, r.Radius, r.InnerRadius, r.StartParam, r.EndParam],
  1096409881: (r) => [r.Directrix, r.Radius, r.InnerRadius, r.StartParam, r.EndParam, r.FilletRadius],
  230924584: (r) => [r.SweptCurve, r.Position],
  3071757647: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.FlangeEdgeRadius, r.WebEdgeRadius, r.WebSlope, r.FlangeSlope],
  901063453: (r) => [],
  4282788508: (r) => [r.Literal, r.Placement, r.Path],
  3124975700: (r) => [r.Literal, r.Placement, r.Path, r.Extent, r.BoxAlignment],
  1983826977: (r) => [r.Name, r.FontFamily, r.FontStyle, r.FontVariant, r.FontWeight, Labelise(r.FontSize)],
  2715220739: (r) => [r.ProfileType, r.ProfileName, r.Position, r.BottomXDim, r.TopXDim, r.YDim, r.TopXOffset],
  1628702193: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets],
  3736923433: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType],
  2347495698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag],
  3698973494: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType],
  427810014: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius, r.FlangeSlope],
  1417489154: (r) => [r.Orientation, r.Magnitude],
  2759199220: (r) => [r.LoopVertex],
  2543172580: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.FlangeWidth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.EdgeRadius],
  3406155212: (r) => {
    var e;
    return [r.Bounds, r.FaceSurface, (e = r.SameSense) == null ? void 0 : e.toString()];
  },
  669184980: (r) => [r.OuterBoundary, r.InnerBoundaries],
  3207858831: (r) => [r.ProfileType, r.ProfileName, r.Position, r.BottomFlangeWidth, r.OverallDepth, r.WebThickness, r.BottomFlangeThickness, r.BottomFlangeFilletRadius, r.TopFlangeWidth, r.TopFlangeThickness, r.TopFlangeFilletRadius, r.BottomFlangeEdgeRadius, r.BottomFlangeSlope, r.TopFlangeEdgeRadius, r.TopFlangeSlope],
  4261334040: (r) => [r.Location, r.Axis],
  3125803723: (r) => [r.Location, r.RefDirection],
  2740243338: (r) => [r.Location, r.Axis, r.RefDirection],
  3425423356: (r) => [r.Location, r.Axis, r.RefDirection],
  2736907675: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  4182860854: (r) => [],
  2581212453: (r) => [r.Corner, r.XDim, r.YDim, r.ZDim],
  2713105998: (r) => {
    var e;
    return [r.BaseSurface, (e = r.AgreementFlag) == null ? void 0 : e.toString(), r.Enclosure];
  },
  2898889636: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.WallThickness, r.Girth, r.InternalFilletRadius],
  1123145078: (r) => [r.Coordinates],
  574549367: (r) => [],
  1675464909: (r) => [r.CoordList, r.TagList],
  2059837836: (r) => [r.CoordList, r.TagList],
  59481748: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3749851601: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale],
  3486308946: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Scale2],
  3331915920: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3],
  1416205885: (r) => [r.Axis1, r.Axis2, r.LocalOrigin, r.Scale, r.Axis3, r.Scale2, r.Scale3],
  1383045692: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius],
  2205249479: (r) => [r.CfsFaces],
  776857604: (r) => [r.Name, r.Red, r.Green, r.Blue],
  2542286263: (r) => [r.Name, r.Specification, r.UsageName, r.HasProperties],
  2485617015: (r) => {
    var e;
    return [r.Transition, (e = r.SameSense) == null ? void 0 : e.toString(), r.ParentCurve];
  },
  2574617495: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity],
  3419103109: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  1815067380: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  2506170314: (r) => [r.Position],
  2147822146: (r) => [r.TreeRootExpression],
  2601014836: (r) => [],
  2827736869: (r) => [r.BasisSurface, r.OuterBoundary, r.InnerBoundaries],
  2629017746: (r) => {
    var e;
    return [r.BasisSurface, r.Boundaries, (e = r.ImplicitOuter) == null ? void 0 : e.toString()];
  },
  4212018352: (r) => [r.Transition, r.Placement, Labelise(r.SegmentStart), Labelise(r.SegmentLength), r.ParentCurve],
  32440307: (r) => [r.DirectionRatios],
  593015953: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam ? Labelise(r.StartParam) : null, r.EndParam ? Labelise(r.EndParam) : null],
  1472233963: (r) => [r.EdgeList],
  1883228015: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.MethodOfMeasurement, r.Quantities],
  339256511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2777663545: (r) => [r.Position],
  2835456948: (r) => [r.ProfileType, r.ProfileName, r.Position, r.SemiAxis1, r.SemiAxis2],
  4024345920: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType, r.EventTriggerType, r.UserDefinedEventTriggerType],
  477187591: (r) => [r.SweptArea, r.Position, r.ExtrudedDirection, r.Depth],
  2804161546: (r) => [r.SweptArea, r.Position, r.ExtrudedDirection, r.Depth, r.EndSweptArea],
  2047409740: (r) => [r.FbsmFaces],
  374418227: (r) => [r.HatchLineAppearance, r.StartOfNextHatchLine, r.PointOfReferenceHatchLine, r.PatternStart, r.HatchLineAngle],
  315944413: (r) => [r.TilingPattern, r.Tiles, r.TilingScale],
  2652556860: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam ? Labelise(r.StartParam) : null, r.EndParam ? Labelise(r.EndParam) : null, r.FixedReference],
  4238390223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1268542332: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.AssemblyPlace, r.PredefinedType],
  4095422895: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  987898635: (r) => [r.Elements],
  1484403080: (r) => [r.ProfileType, r.ProfileName, r.Position, r.OverallWidth, r.OverallDepth, r.WebThickness, r.FlangeThickness, r.FilletRadius, r.FlangeEdgeRadius, r.FlangeSlope],
  178912537: (r) => [r.CoordIndex],
  2294589976: (r) => [r.CoordIndex, r.InnerCoordIndices],
  3465909080: (r) => [r.Maps, r.MappedTo, r.TexCoords, r.TexCoordIndices],
  572779678: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Depth, r.Width, r.Thickness, r.FilletRadius, r.EdgeRadius, r.LegSlope],
  428585644: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1281925730: (r) => [r.Pnt, r.Dir],
  1425443689: (r) => [r.Outer],
  3888040117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  590820931: (r) => [r.BasisCurve],
  3388369263: (r) => {
    var e;
    return [r.BasisCurve, r.Distance, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3505215534: (r) => {
    var e;
    return [r.BasisCurve, r.Distance, (e = r.SelfIntersect) == null ? void 0 : e.toString(), r.RefDirection];
  },
  2485787929: (r) => [r.BasisCurve, r.OffsetValues, r.Tag],
  1682466193: (r) => [r.BasisSurface, r.ReferenceCurve],
  603570806: (r) => [r.SizeInX, r.SizeInY, r.Placement],
  220341763: (r) => [r.Position],
  3381221214: (r) => [r.Position, r.CoefficientsX, r.CoefficientsY, r.CoefficientsZ],
  759155922: (r) => [r.Name],
  2559016684: (r) => [r.Name],
  3967405729: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  569719735: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType],
  2945172077: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription],
  4208778838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  103090709: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  653396225: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.Phase, r.RepresentationContexts, r.UnitsInContext],
  871118103: (r) => [r.Name, r.Specification, r.UpperBoundValue ? Labelise(r.UpperBoundValue) : null, r.LowerBoundValue ? Labelise(r.LowerBoundValue) : null, r.Unit, r.SetPointValue ? Labelise(r.SetPointValue) : null],
  4166981789: (r) => [r.Name, r.Specification, r.EnumerationValues ? r.EnumerationValues.map((e) => Labelise(e)) : null, r.EnumerationReference],
  2752243245: (r) => [r.Name, r.Specification, r.ListValues ? r.ListValues.map((e) => Labelise(e)) : null, r.Unit],
  941946838: (r) => [r.Name, r.Specification, r.UsageName, r.PropertyReference],
  1451395588: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.HasProperties],
  492091185: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.TemplateType, r.ApplicableEntity, r.HasPropertyTemplates],
  3650150729: (r) => [r.Name, r.Specification, r.NominalValue ? Labelise(r.NominalValue) : null, r.Unit],
  110355661: (r) => [r.Name, r.Specification, r.DefiningValues ? r.DefiningValues.map((e) => Labelise(e)) : null, r.DefinedValues ? r.DefinedValues.map((e) => Labelise(e)) : null, r.Expression, r.DefiningUnit, r.DefinedUnit, r.CurveInterpolation],
  3521284610: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  2770003689: (r) => [r.ProfileType, r.ProfileName, r.Position, r.XDim, r.YDim, r.WallThickness, r.InnerFilletRadius, r.OuterFilletRadius],
  2798486643: (r) => [r.Position, r.XLength, r.YLength, r.Height],
  3454111270: (r) => {
    var e, s;
    return [r.BasisSurface, r.U1, r.V1, r.U2, r.V2, (e = r.Usense) == null ? void 0 : e.toString(), (s = r.Vsense) == null ? void 0 : s.toString()];
  },
  3765753017: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.DefinitionType, r.ReinforcementSectionDefinitions],
  3939117080: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType],
  1683148259: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingActor, r.ActingRole],
  2495723537: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingControl],
  1307041759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingGroup],
  1027710054: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingGroup, r.Factor],
  4278684876: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProcess, r.QuantityInProcess],
  2857406711: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingProduct],
  205026976: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatedObjectsType, r.RelatingResource],
  1865459582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects],
  4095574036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingApproval],
  919958153: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingClassification],
  2728634034: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.Intent, r.RelatingConstraint],
  982818633: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingDocument],
  3840914261: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingLibrary],
  2655215786: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingMaterial],
  1033248425: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingProfileDef],
  826625072: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1204542856: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement],
  3945020480: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RelatingPriorities, r.RelatedPriorities, r.RelatedConnectionType, r.RelatingConnectionType],
  4201705270: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedElement],
  3190031847: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPort, r.RelatedPort, r.RealizingElement],
  2127690289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedStructuralActivity],
  1638771189: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem],
  504942748: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingStructuralMember, r.RelatedStructuralConnection, r.AppliedCondition, r.AdditionalConditions, r.SupportedLength, r.ConditionCoordinateSystem, r.ConnectionConstraint],
  3678494232: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ConnectionGeometry, r.RelatingElement, r.RelatedElement, r.RealizingElements, r.ConnectionType],
  3242617779: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  886880790: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedCoverings],
  2802773753: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedCoverings],
  2565941209: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingContext, r.RelatedDefinitions],
  2551354335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  693640335: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description],
  1462361463: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingObject],
  4186316022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingPropertyDefinition],
  307848117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedPropertySets, r.RelatingTemplate],
  781010003: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedObjects, r.RelatingType],
  3940055652: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingOpeningElement, r.RelatedBuildingElement],
  279856033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedControlElements, r.RelatingFlowElement],
  427948657: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedElement, r.InterferenceGeometry, r.InterferenceSpace, r.InterferenceType, (e = r.ImpliedOrder) == null ? void 0 : e.toString()];
  },
  3268803585: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  1441486842: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingPositioningElement, r.RelatedProducts],
  750771296: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedFeatureElement],
  1245217292: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatedElements, r.RelatingStructure],
  4122056220: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingProcess, r.RelatedProcess, r.TimeLag, r.SequenceType, r.UserDefinedSequenceType],
  366585022: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSystem, r.RelatedBuildings],
  3451746338: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary],
  3523091289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary, r.ParentBoundary],
  1521410863: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingSpace, r.RelatedBuildingElement, r.ConnectionGeometry, r.PhysicalOrVirtualBoundary, r.InternalOrExternalBoundary, r.ParentBoundary, r.CorrespondingBoundary],
  1401173127: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingBuildingElement, r.RelatedOpeningElement],
  816062949: (r) => {
    var e;
    return [r.Transition, (e = r.SameSense) == null ? void 0 : e.toString(), r.ParentCurve, r.ParamLength];
  },
  2914609552: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription],
  1856042241: (r) => [r.SweptArea, r.Position, r.Axis, r.Angle],
  3243963512: (r) => [r.SweptArea, r.Position, r.Axis, r.Angle, r.EndSweptArea],
  4158566097: (r) => [r.Position, r.Height, r.BottomRadius],
  3626867408: (r) => [r.Position, r.Height, r.Radius],
  1862484736: (r) => [r.Directrix, r.CrossSections],
  1290935644: (r) => [r.Directrix, r.CrossSections, r.CrossSectionPositions],
  1356537516: (r) => [r.Directrix, r.CrossSectionPositions, r.CrossSections],
  3663146110: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.TemplateType, r.PrimaryMeasureType, r.SecondaryMeasureType, r.Enumerators, r.PrimaryUnit, r.SecondaryUnit, r.Expression, r.AccessState],
  1412071761: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName],
  710998568: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2706606064: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType],
  3893378262: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  463610769: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.PredefinedType],
  2481509218: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.LongName],
  451544542: (r) => [r.Position, r.Radius],
  4015995234: (r) => [r.Position, r.Radius],
  2735484536: (r) => [r.Position],
  3544373492: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3136571912: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  530289379: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  3689010777: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  3979015343: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness],
  2218152070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Thickness],
  603775116: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.PredefinedType],
  4095615324: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  699246055: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  2028607225: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam ? Labelise(r.StartParam) : null, r.EndParam ? Labelise(r.EndParam) : null, r.ReferenceSurface],
  2809605785: (r) => [r.SweptCurve, r.Position, r.ExtrudedDirection, r.Depth],
  4124788165: (r) => [r.SweptCurve, r.Position, r.AxisPosition],
  1580310250: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3473067441: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Status, r.WorkMethod, (e = r.IsMilestone) == null ? void 0 : e.toString(), r.Priority, r.TaskTime, r.PredefinedType];
  },
  3206491090: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ProcessType, r.PredefinedType, r.WorkMethod],
  2387106220: (r) => {
    var e;
    return [r.Coordinates, (e = r.Closed) == null ? void 0 : e.toString()];
  },
  782932809: (r) => [r.Position, r.CubicTerm, r.QuadraticTerm, r.LinearTerm, r.ConstantTerm],
  1935646853: (r) => [r.Position, r.MajorRadius, r.MinorRadius],
  3665877780: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2916149573: (r) => {
    var e;
    return [r.Coordinates, (e = r.Closed) == null ? void 0 : e.toString(), r.Normals, r.CoordIndex, r.PnIndex];
  },
  1229763772: (r) => {
    var e;
    return [r.Coordinates, (e = r.Closed) == null ? void 0 : e.toString(), r.Normals, r.CoordIndex, r.PnIndex, r.Flags];
  },
  3651464721: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  336235671: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.TransomThickness, r.MullionThickness, r.FirstTransomOffset, r.SecondTransomOffset, r.FirstMullionOffset, r.SecondMullionOffset, r.ShapeAspectStyle, r.LiningOffset, r.LiningToPanelOffsetX, r.LiningToPanelOffsetY],
  512836454: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  2296667514: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor],
  1635779807: (r) => [r.Outer],
  2603310189: (r) => [r.Outer, r.Voids],
  1674181508: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType],
  2887950389: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString()];
  },
  167062518: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString(), r.UMultiplicities, r.VMultiplicities, r.UKnots, r.VKnots, r.KnotSpec];
  },
  1334484129: (r) => [r.Position, r.XLength, r.YLength, r.ZLength],
  3649129432: (r) => [r.Operator, r.FirstOperand, r.SecondOperand],
  1260505505: (r) => [],
  3124254112: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.Elevation],
  1626504194: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2197970202: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2937912522: (r) => [r.ProfileType, r.ProfileName, r.Position, r.Radius, r.WallThickness],
  3893394355: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3497074424: (r) => [r.Position, r.ClothoidConstant],
  300633059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3875453745: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.UsageName, r.TemplateType, r.HasPropertyTemplates],
  3732776249: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  15328376: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  2510884976: (r) => [r.Position],
  2185764099: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  4105962743: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1525564444: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.Identification, r.LongDescription, r.ResourceType, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  2559216714: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity],
  3293443760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification],
  2000195564: (r) => [r.Position, r.CosineTerm, r.ConstantTerm],
  3895139033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.CostValues, r.CostQuantities],
  1419761937: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.SubmittedOn, r.UpdateDate],
  4189326743: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1916426348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3295246426: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1457835157: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1213902940: (r) => [r.Position, r.Radius],
  1306400036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  4234616927: (r) => [r.SweptArea, r.Position, r.Directrix, r.StartParam ? Labelise(r.StartParam) : null, r.EndParam ? Labelise(r.EndParam) : null, r.FixedReference],
  3256556792: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3849074793: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2963535650: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.LiningDepth, r.LiningThickness, r.ThresholdDepth, r.ThresholdThickness, r.TransomThickness, r.TransomOffset, r.LiningOffset, r.ThresholdOffset, r.CasingThickness, r.CasingDepth, r.ShapeAspectStyle, r.LiningToPanelOffsetX, r.LiningToPanelOffsetY],
  1714330368: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.PanelDepth, r.PanelOperation, r.PanelWidth, r.PanelPosition, r.ShapeAspectStyle],
  2323601079: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.OperationType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), r.UserDefinedOperationType];
  },
  445594917: (r) => [r.Name],
  4006246654: (r) => [r.Name],
  1758889154: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4123344466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.AssemblyPlace, r.PredefinedType],
  2397081782: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1623761950: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2590856083: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1704287377: (r) => [r.Position, r.SemiAxis1, r.SemiAxis2],
  2107101300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  132023988: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3174744832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3390157468: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4148101412: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.PredefinedType, r.EventTriggerType, r.UserDefinedEventTriggerType, r.EventOccurenceTime],
  2853485674: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName],
  807026263: (r) => [r.Outer],
  3737207727: (r) => [r.Outer, r.Voids],
  24185140: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType],
  1310830890: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType],
  4228831410: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType, r.PredefinedType],
  647756555: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2489546625: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2827207264: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2143335405: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1287392070: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3907093117: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3198132628: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3815607619: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1482959167: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1834744321: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1339347760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2297155007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  3009222698: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1893162501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  263784265: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1509553395: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3493046030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4230923436: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1594536857: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2898700619: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString(), r.BaseCurve, r.EndPoint];
  },
  2706460486: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  1251058090: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1806887404: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2568555532: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3948183225: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2571569899: (r) => {
    var e;
    return [r.Points, r.Segments ? r.Segments.map((s) => Labelise(s)) : null, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3946677679: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3113134337: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  2391368822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.Jurisdiction, r.ResponsiblePersons, r.LastUpdateDate, r.CurrentValue, r.OriginalValue],
  4288270099: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  679976338: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, (e = r.Mountable) == null ? void 0 : e.toString()];
  },
  3827777499: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1051575348: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1161773419: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2176059722: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  1770583370: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  525669439: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType],
  976884017: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType, r.PredefinedType],
  377706215: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NominalDiameter, r.NominalLength, r.PredefinedType],
  2108223431: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.NominalLength],
  1114901282: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3181161470: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1950438474: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  710110818: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  977012517: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  506776471: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4143007308: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheActor, r.PredefinedType],
  3588315303: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2837617999: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  514975943: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2382730787: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LifeCyclePhase, r.PredefinedType],
  3566463478: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.OperationType, r.PanelPosition, r.FrameDepth, r.FrameThickness, r.ShapeAspectStyle],
  3327091369: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  1158309216: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  804291784: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4231323485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4017108033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2839578677: (r) => {
    var e;
    return [r.Coordinates, (e = r.Closed) == null ? void 0 : e.toString(), r.Faces, r.PnIndex];
  },
  3724593414: (r) => [r.Points],
  3740093272: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  1946335990: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  2744685151: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.PredefinedType],
  2904328755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  3651124850: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1842657554: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2250791053: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1763565496: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2893384427: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3992365140: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType],
  1891881377: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType, r.PredefinedType],
  2324767716: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1469900589: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  683857671: (r) => {
    var e, s, o;
    return [r.UDegree, r.VDegree, r.ControlPointsList, r.SurfaceForm, (e = r.UClosed) == null ? void 0 : e.toString(), (s = r.VClosed) == null ? void 0 : s.toString(), (o = r.SelfIntersect) == null ? void 0 : o.toString(), r.UMultiplicities, r.VMultiplicities, r.UKnots, r.VKnots, r.KnotSpec, r.WeightsData];
  },
  4021432810: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType],
  3027567501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade],
  964333572: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  2320036040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.MeshLength, r.MeshWidth, r.LongitudinalBarNominalDiameter, r.TransverseBarNominalDiameter, r.LongitudinalBarCrossSectionArea, r.TransverseBarCrossSectionArea, r.LongitudinalBarSpacing, r.TransverseBarSpacing, r.PredefinedType],
  2310774935: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.MeshLength, r.MeshWidth, r.LongitudinalBarNominalDiameter, r.TransverseBarNominalDiameter, r.LongitudinalBarCrossSectionArea, r.TransverseBarCrossSectionArea, r.LongitudinalBarSpacing, r.TransverseBarSpacing, r.BendingShapeCode, r.BendingParameters ? r.BendingParameters.map((e) => Labelise(e)) : null],
  3818125796: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingElement, r.RelatedSurfaceFeatures],
  160246688: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.RelatingObject, r.RelatedObjects],
  146592293: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType],
  550521510: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType, r.PredefinedType],
  2781568857: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1768891740: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2157484638: (r) => [r.Curve3D, r.AssociatedGeometry, r.MasterRepresentation],
  3649235739: (r) => [r.Position, r.QuadraticTerm, r.LinearTerm, r.ConstantTerm],
  544395925: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString(), r.BaseCurve, r.EndPoint];
  },
  1027922057: (r) => [r.Position, r.SepticTerm, r.SexticTerm, r.QuinticTerm, r.QuarticTerm, r.CubicTerm, r.QuadraticTerm, r.LinearTerm, r.ConstantTerm],
  4074543187: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  33720170: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3599934289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1894708472: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  42703149: (r) => [r.Position, r.SineTerm, r.LinearTerm, r.ConstantTerm],
  4097777520: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.RefLatitude, r.RefLongitude, r.RefElevation, r.LandTitleNumber, r.SiteAddress],
  2533589738: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1072016465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3856911033: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType, r.ElevationWithFlooring],
  1305183839: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3812236995: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.LongName],
  3112655638: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1039846685: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  338393293: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  682877961: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString()];
  },
  1179482911: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  1004757350: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  4243806635: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition, r.AxisDirection],
  214636428: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Axis],
  2445595289: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType, r.Axis],
  2757150158: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, r.PredefinedType],
  1807405624: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1252848954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.ActionType, r.ActionSource, r.Coefficient, r.Purpose],
  2082059205: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString()];
  },
  734778138: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition, r.ConditionCoordinateSystem],
  1235345126: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal],
  2986769608: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.TheoryType, r.ResultForLoadGroup, (e = r.IsLinear) == null ? void 0 : e.toString()];
  },
  3657597509: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1975003073: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedCondition],
  148013059: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  3101698114: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2315554128: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2254336722: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType],
  413509423: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  5716631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3824725483: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.TensionForce, r.PreStress, r.FrictionCoefficient, r.AnchorageSlip, r.MinCurvatureRadius],
  2347447852: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType],
  3081323446: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3663046924: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.PredefinedType],
  2281632017: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2415094496: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.SheathDiameter],
  618700268: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1692211062: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2097647324: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1953115116: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3593883385: (r) => {
    var e;
    return [r.BasisCurve, r.Trim1, r.Trim2, (e = r.SenseAgreement) == null ? void 0 : e.toString(), r.MasterRepresentation];
  },
  1600972822: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1911125066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  728799441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  840318589: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1530820697: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3956297820: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2391383451: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3313531582: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2769231204: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  926996030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1898987631: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1133259667: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4009809668: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.PartitioningType, (e = r.ParameterTakesPrecedence) == null ? void 0 : e.toString(), r.UserDefinedPartitioningType];
  },
  4088093105: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.WorkingTimes, r.ExceptionTimes, r.PredefinedType],
  1028945134: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime],
  4218914973: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.PredefinedType],
  3342526732: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.CreationDate, r.Creators, r.Purpose, r.Duration, r.TotalFloat, r.StartTime, r.FinishTime, r.PredefinedType],
  1033361043: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName],
  3821786052: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.PredefinedType, r.Status, r.LongDescription],
  1411407467: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3352864051: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1871374353: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4266260250: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.RailHeadDistance],
  1545765605: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  317615605: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.DesignParameters],
  1662888072: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  3460190687: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.OriginalValue, r.CurrentValue, r.TotalReplacementCost, r.Owner, r.User, r.ResponsiblePerson, r.IncorporationDate, r.DepreciatedValue],
  1532957894: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1967976161: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString()];
  },
  2461110595: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString(), r.KnotMultiplicities, r.Knots, r.KnotSpec];
  },
  819618141: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3649138523: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  231477066: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1136057603: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  644574406: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.PredefinedType],
  963979645: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.UsageType, r.PredefinedType],
  4031249490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.CompositionType, r.ElevationOfRefHeight, r.ElevationOfTerrain, r.BuildingAddress],
  2979338954: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  39481116: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1909888760: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1177604601: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.LongName],
  1876633798: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3862327254: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.LongName],
  2188180465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  395041908: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3293546465: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2674252688: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1285652485: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3203706013: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2951183804: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3296154744: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2611217952: (r) => [r.Position, r.Radius],
  1677625105: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2301859152: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  843113511: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  400855858: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3850581409: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2816379211: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3898045240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  1060000209: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  488727124: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.Identification, r.LongDescription, r.Usage, r.BaseCosts, r.BaseQuantity, r.PredefinedType],
  2940368186: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  335055490: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2954562838: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1502416096: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1973544240: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3495092785: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3961806047: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3426335179: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1335981549: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2635815018: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  479945903: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1599208980: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2063403501: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType],
  1945004755: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3040386961: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3041715199: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.FlowDirection, r.PredefinedType, r.SystemType],
  3205830791: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.PredefinedType],
  395920057: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.OperationType, r.UserDefinedOperationType],
  869906466: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3760055223: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2030761528: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3071239417: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1077100507: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3376911765: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  663422040: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2417008758: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3277789161: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2142170206: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1534661035: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1217240411: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  712377611: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1658829314: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2814081492: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3747195512: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  484807127: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1209101575: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.LongName, r.PredefinedType],
  346874300: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1810631287: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4222183408: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2058353004: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4278956645: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  4037862832: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  2188021234: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3132237377: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  987401354: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  707683696: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2223149337: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3508470533: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  900683007: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2713699986: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  3009204131: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.UAxes, r.VAxes, r.WAxes, r.PredefinedType],
  3319311131: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2068733104: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4175244083: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2176052936: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2696325953: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, (e = r.Mountable) == null ? void 0 : e.toString()];
  },
  76236018: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  629592764: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1154579445: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation],
  1638804497: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1437502449: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1073191201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2078563270: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  234836483: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2474470126: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2182337498: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  144952367: (r) => {
    var e;
    return [r.Segments, (e = r.SelfIntersect) == null ? void 0 : e.toString()];
  },
  3694346114: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1383356374: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1687234759: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType, r.ConstructionType],
  310824031: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3612865200: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3171933400: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  738039164: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  655969474: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  90941305: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3290496277: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2262370178: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3024970846: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3283111854: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1232101972: (r) => {
    var e, s;
    return [r.Degree, r.ControlPointsList, r.CurveForm, (e = r.ClosedCurve) == null ? void 0 : e.toString(), (s = r.SelfIntersect) == null ? void 0 : s.toString(), r.KnotMultiplicities, r.Knots, r.KnotSpec, r.WeightsData];
  },
  3798194928: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  979691226: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.SteelGrade, r.NominalDiameter, r.CrossSectionArea, r.BarLength, r.PredefinedType, r.BarSurface],
  2572171363: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType, r.NominalDiameter, r.CrossSectionArea, r.BarLength, r.BarSurface, r.BendingShapeCode, r.BendingParameters ? r.BendingParameters.map((e) => Labelise(e)) : null],
  2016517767: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3053780830: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1783015770: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1329646415: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  991950508: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1529196076: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3420628829: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1999602285: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1404847402: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  331165859: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4252922144: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.NumberOfRisers, r.NumberOfTreads, r.RiserHeight, r.TreadLength, r.PredefinedType],
  2515109513: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.OrientationOf2DPlane, r.LoadedBy, r.HasResults, r.SharedPlacement],
  385403989: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.PredefinedType, r.ActionType, r.ActionSource, r.Coefficient, r.Purpose, r.SelfWeightCoefficients],
  1621171031: (r) => {
    var e;
    return [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.AppliedLoad, r.GlobalOrLocal, (e = r.DestabilizingLoad) == null ? void 0 : e.toString(), r.ProjectedOrTrue, r.PredefinedType];
  },
  1162798199: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  812556717: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3425753595: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3825984169: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1620046519: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3026737570: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3179687236: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  4292641817: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4207607924: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2391406946: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3512223829: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4237592921: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3304561284: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.OverallHeight, r.OverallWidth, r.PredefinedType, r.PartitioningType, r.UserDefinedPartitioningType],
  2874132201: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  1634111441: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  177149247: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2056796094: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3001207471: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  325726236: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.PredefinedType],
  277319702: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  753842376: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4196446775: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  32344328: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3314249567: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1095909175: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2938176219: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  635142910: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3758799889: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1051757585: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4217484030: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3999819293: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3902619387: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  639361253: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3221913625: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3571504051: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2272882330: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  578613899: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ApplicableOccurrence, r.HasPropertySets, r.RepresentationMaps, r.Tag, r.ElementType, r.PredefinedType],
  3460952963: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4136498852: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3640358203: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4074379575: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3693000487: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1052013943: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  562808652: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.LongName, r.PredefinedType],
  1062813311: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  342316401: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3518393246: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1360408905: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1904799276: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  862014818: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3310460725: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  24726584: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  264262732: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  402227799: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1003880860: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3415622556: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  819412036: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  1426591983: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  182646315: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  2680139844: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  1971632696: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag],
  2295281155: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4086658281: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  630975310: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  4288193352: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  3087945054: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType],
  25142252: (r) => [r.GlobalId, r.OwnerHistory, r.Name, r.Description, r.ObjectType, r.ObjectPlacement, r.Representation, r.Tag, r.PredefinedType]
};
TypeInitialisers[3] = {
  3699917729: (r) => new IFC4X3.IfcAbsorbedDoseMeasure(r),
  4182062534: (r) => new IFC4X3.IfcAccelerationMeasure(r),
  360377573: (r) => new IFC4X3.IfcAmountOfSubstanceMeasure(r),
  632304761: (r) => new IFC4X3.IfcAngularVelocityMeasure(r),
  3683503648: (r) => new IFC4X3.IfcArcIndex(r.map((e) => e.value)),
  1500781891: (r) => new IFC4X3.IfcAreaDensityMeasure(r),
  2650437152: (r) => new IFC4X3.IfcAreaMeasure(r),
  2314439260: (r) => new IFC4X3.IfcBinary(r),
  2735952531: (r) => new IFC4X3.IfcBoolean(r),
  1867003952: (r) => new IFC4X3.IfcBoxAlignment(r),
  1683019596: (r) => new IFC4X3.IfcCardinalPointReference(r),
  2991860651: (r) => new IFC4X3.IfcComplexNumber(r.map((e) => e.value)),
  3812528620: (r) => new IFC4X3.IfcCompoundPlaneAngleMeasure(r.map((e) => e.value)),
  3238673880: (r) => new IFC4X3.IfcContextDependentMeasure(r),
  1778710042: (r) => new IFC4X3.IfcCountMeasure(r),
  94842927: (r) => new IFC4X3.IfcCurvatureMeasure(r),
  937566702: (r) => new IFC4X3.IfcDate(r),
  2195413836: (r) => new IFC4X3.IfcDateTime(r),
  86635668: (r) => new IFC4X3.IfcDayInMonthNumber(r),
  3701338814: (r) => new IFC4X3.IfcDayInWeekNumber(r),
  1514641115: (r) => new IFC4X3.IfcDescriptiveMeasure(r),
  4134073009: (r) => new IFC4X3.IfcDimensionCount(r),
  524656162: (r) => new IFC4X3.IfcDoseEquivalentMeasure(r),
  2541165894: (r) => new IFC4X3.IfcDuration(r),
  69416015: (r) => new IFC4X3.IfcDynamicViscosityMeasure(r),
  1827137117: (r) => new IFC4X3.IfcElectricCapacitanceMeasure(r),
  3818826038: (r) => new IFC4X3.IfcElectricChargeMeasure(r),
  2093906313: (r) => new IFC4X3.IfcElectricConductanceMeasure(r),
  3790457270: (r) => new IFC4X3.IfcElectricCurrentMeasure(r),
  2951915441: (r) => new IFC4X3.IfcElectricResistanceMeasure(r),
  2506197118: (r) => new IFC4X3.IfcElectricVoltageMeasure(r),
  2078135608: (r) => new IFC4X3.IfcEnergyMeasure(r),
  1102727119: (r) => new IFC4X3.IfcFontStyle(r),
  2715512545: (r) => new IFC4X3.IfcFontVariant(r),
  2590844177: (r) => new IFC4X3.IfcFontWeight(r),
  1361398929: (r) => new IFC4X3.IfcForceMeasure(r),
  3044325142: (r) => new IFC4X3.IfcFrequencyMeasure(r),
  3064340077: (r) => new IFC4X3.IfcGloballyUniqueId(r),
  3113092358: (r) => new IFC4X3.IfcHeatFluxDensityMeasure(r),
  1158859006: (r) => new IFC4X3.IfcHeatingValueMeasure(r),
  983778844: (r) => new IFC4X3.IfcIdentifier(r),
  3358199106: (r) => new IFC4X3.IfcIlluminanceMeasure(r),
  2679005408: (r) => new IFC4X3.IfcInductanceMeasure(r),
  1939436016: (r) => new IFC4X3.IfcInteger(r),
  3809634241: (r) => new IFC4X3.IfcIntegerCountRateMeasure(r),
  3686016028: (r) => new IFC4X3.IfcIonConcentrationMeasure(r),
  3192672207: (r) => new IFC4X3.IfcIsothermalMoistureCapacityMeasure(r),
  2054016361: (r) => new IFC4X3.IfcKinematicViscosityMeasure(r),
  3258342251: (r) => new IFC4X3.IfcLabel(r),
  1275358634: (r) => new IFC4X3.IfcLanguageId(r),
  1243674935: (r) => new IFC4X3.IfcLengthMeasure(r),
  1774176899: (r) => new IFC4X3.IfcLineIndex(r.map((e) => e.value)),
  191860431: (r) => new IFC4X3.IfcLinearForceMeasure(r),
  2128979029: (r) => new IFC4X3.IfcLinearMomentMeasure(r),
  1307019551: (r) => new IFC4X3.IfcLinearStiffnessMeasure(r),
  3086160713: (r) => new IFC4X3.IfcLinearVelocityMeasure(r),
  503418787: (r) => new IFC4X3.IfcLogical(r),
  2095003142: (r) => new IFC4X3.IfcLuminousFluxMeasure(r),
  2755797622: (r) => new IFC4X3.IfcLuminousIntensityDistributionMeasure(r),
  151039812: (r) => new IFC4X3.IfcLuminousIntensityMeasure(r),
  286949696: (r) => new IFC4X3.IfcMagneticFluxDensityMeasure(r),
  2486716878: (r) => new IFC4X3.IfcMagneticFluxMeasure(r),
  1477762836: (r) => new IFC4X3.IfcMassDensityMeasure(r),
  4017473158: (r) => new IFC4X3.IfcMassFlowRateMeasure(r),
  3124614049: (r) => new IFC4X3.IfcMassMeasure(r),
  3531705166: (r) => new IFC4X3.IfcMassPerLengthMeasure(r),
  3341486342: (r) => new IFC4X3.IfcModulusOfElasticityMeasure(r),
  2173214787: (r) => new IFC4X3.IfcModulusOfLinearSubgradeReactionMeasure(r),
  1052454078: (r) => new IFC4X3.IfcModulusOfRotationalSubgradeReactionMeasure(r),
  1753493141: (r) => new IFC4X3.IfcModulusOfSubgradeReactionMeasure(r),
  3177669450: (r) => new IFC4X3.IfcMoistureDiffusivityMeasure(r),
  1648970520: (r) => new IFC4X3.IfcMolecularWeightMeasure(r),
  3114022597: (r) => new IFC4X3.IfcMomentOfInertiaMeasure(r),
  2615040989: (r) => new IFC4X3.IfcMonetaryMeasure(r),
  765770214: (r) => new IFC4X3.IfcMonthInYearNumber(r),
  525895558: (r) => new IFC4X3.IfcNonNegativeLengthMeasure(r),
  2095195183: (r) => new IFC4X3.IfcNormalisedRatioMeasure(r),
  2395907400: (r) => new IFC4X3.IfcNumericMeasure(r),
  929793134: (r) => new IFC4X3.IfcPHMeasure(r),
  2260317790: (r) => new IFC4X3.IfcParameterValue(r),
  2642773653: (r) => new IFC4X3.IfcPlanarForceMeasure(r),
  4042175685: (r) => new IFC4X3.IfcPlaneAngleMeasure(r),
  1790229001: (r) => new IFC4X3.IfcPositiveInteger(r),
  2815919920: (r) => new IFC4X3.IfcPositiveLengthMeasure(r),
  3054510233: (r) => new IFC4X3.IfcPositivePlaneAngleMeasure(r),
  1245737093: (r) => new IFC4X3.IfcPositiveRatioMeasure(r),
  1364037233: (r) => new IFC4X3.IfcPowerMeasure(r),
  2169031380: (r) => new IFC4X3.IfcPresentableText(r),
  3665567075: (r) => new IFC4X3.IfcPressureMeasure(r),
  2798247006: (r) => new IFC4X3.IfcPropertySetDefinitionSet(r.map((e) => e.value)),
  3972513137: (r) => new IFC4X3.IfcRadioActivityMeasure(r),
  96294661: (r) => new IFC4X3.IfcRatioMeasure(r),
  200335297: (r) => new IFC4X3.IfcReal(r),
  2133746277: (r) => new IFC4X3.IfcRotationalFrequencyMeasure(r),
  1755127002: (r) => new IFC4X3.IfcRotationalMassMeasure(r),
  3211557302: (r) => new IFC4X3.IfcRotationalStiffnessMeasure(r),
  3467162246: (r) => new IFC4X3.IfcSectionModulusMeasure(r),
  2190458107: (r) => new IFC4X3.IfcSectionalAreaIntegralMeasure(r),
  408310005: (r) => new IFC4X3.IfcShearModulusMeasure(r),
  3471399674: (r) => new IFC4X3.IfcSolidAngleMeasure(r),
  4157543285: (r) => new IFC4X3.IfcSoundPowerLevelMeasure(r),
  846465480: (r) => new IFC4X3.IfcSoundPowerMeasure(r),
  3457685358: (r) => new IFC4X3.IfcSoundPressureLevelMeasure(r),
  993287707: (r) => new IFC4X3.IfcSoundPressureMeasure(r),
  3477203348: (r) => new IFC4X3.IfcSpecificHeatCapacityMeasure(r),
  2757832317: (r) => new IFC4X3.IfcSpecularExponent(r),
  361837227: (r) => new IFC4X3.IfcSpecularRoughness(r),
  58845555: (r) => new IFC4X3.IfcTemperatureGradientMeasure(r),
  1209108979: (r) => new IFC4X3.IfcTemperatureRateOfChangeMeasure(r),
  2801250643: (r) => new IFC4X3.IfcText(r),
  1460886941: (r) => new IFC4X3.IfcTextAlignment(r),
  3490877962: (r) => new IFC4X3.IfcTextDecoration(r),
  603696268: (r) => new IFC4X3.IfcTextFontName(r),
  296282323: (r) => new IFC4X3.IfcTextTransformation(r),
  232962298: (r) => new IFC4X3.IfcThermalAdmittanceMeasure(r),
  2645777649: (r) => new IFC4X3.IfcThermalConductivityMeasure(r),
  2281867870: (r) => new IFC4X3.IfcThermalExpansionCoefficientMeasure(r),
  857959152: (r) => new IFC4X3.IfcThermalResistanceMeasure(r),
  2016195849: (r) => new IFC4X3.IfcThermalTransmittanceMeasure(r),
  743184107: (r) => new IFC4X3.IfcThermodynamicTemperatureMeasure(r),
  4075327185: (r) => new IFC4X3.IfcTime(r),
  2726807636: (r) => new IFC4X3.IfcTimeMeasure(r),
  2591213694: (r) => new IFC4X3.IfcTimeStamp(r),
  1278329552: (r) => new IFC4X3.IfcTorqueMeasure(r),
  950732822: (r) => new IFC4X3.IfcURIReference(r),
  3345633955: (r) => new IFC4X3.IfcVaporPermeabilityMeasure(r),
  3458127941: (r) => new IFC4X3.IfcVolumeMeasure(r),
  2593997549: (r) => new IFC4X3.IfcVolumetricFlowRateMeasure(r),
  51269191: (r) => new IFC4X3.IfcWarpingConstantMeasure(r),
  1718600412: (r) => new IFC4X3.IfcWarpingMomentMeasure(r)
};
var IFC4X3;
(function(r) {
  class e {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAbsorbedDoseMeasure = e;
  class s {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAccelerationMeasure = s;
  class o {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAmountOfSubstanceMeasure = o;
  class a {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAngularVelocityMeasure = a;
  class l {
    constructor(H) {
      this.value = H;
    }
  }
  r.IfcArcIndex = l;
  class u {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAreaDensityMeasure = u;
  class c {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcAreaMeasure = c;
  class E {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcBinary = E;
  class d {
    constructor(H) {
      this.type = 3, this.value = H == "true";
    }
  }
  r.IfcBoolean = d;
  class f {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcBoxAlignment = f;
  class h {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcCardinalPointReference = h;
  class S {
    constructor(H) {
      this.value = H;
    }
  }
  r.IfcComplexNumber = S;
  class R {
    constructor(H) {
      this.value = H;
    }
  }
  r.IfcCompoundPlaneAngleMeasure = R;
  class _ {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcContextDependentMeasure = _;
  class m {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcCountMeasure = m;
  class L {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcCurvatureMeasure = L;
  class F {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcDate = F;
  class W {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcDateTime = W;
  class G {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcDayInMonthNumber = G;
  class q {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcDayInWeekNumber = q;
  class fe {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcDescriptiveMeasure = fe;
  class _e {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcDimensionCount = _e;
  class Le {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcDoseEquivalentMeasure = Le;
  class Fe {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcDuration = Fe;
  class Ee {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcDynamicViscosityMeasure = Ee;
  class Ge {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricCapacitanceMeasure = Ge;
  class ve {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricChargeMeasure = ve;
  class te {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricConductanceMeasure = te;
  class ae {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricCurrentMeasure = ae;
  class v {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricResistanceMeasure = v;
  class Te {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcElectricVoltageMeasure = Te;
  class De {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcEnergyMeasure = De;
  class be {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcFontStyle = be;
  class ze {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcFontVariant = ze;
  class ke {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcFontWeight = ke;
  class Be {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcForceMeasure = Be;
  class Me {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcFrequencyMeasure = Me;
  class me {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcGloballyUniqueId = me;
  class Se {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcHeatFluxDensityMeasure = Se;
  class xt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcHeatingValueMeasure = xt;
  class Ht {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcIdentifier = Ht;
  class Bt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcIlluminanceMeasure = Bt;
  class ut {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcInductanceMeasure = ut;
  class Tt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcInteger = Tt;
  class Yt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcIntegerCountRateMeasure = Yt;
  class an {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcIonConcentrationMeasure = an;
  class Ct {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcIsothermalMoistureCapacityMeasure = Ct;
  class st {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcKinematicViscosityMeasure = st;
  class jt {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcLabel = jt;
  class lt {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcLanguageId = lt;
  class Zt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLengthMeasure = Zt;
  class Et {
    constructor(H) {
      this.value = H;
    }
  }
  r.IfcLineIndex = Et;
  class Ke {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLinearForceMeasure = Ke;
  class $e {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLinearMomentMeasure = $e;
  class pt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLinearStiffnessMeasure = pt;
  class Jt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLinearVelocityMeasure = Jt;
  class In {
    constructor(H) {
      this.type = 3, this.value = H == "true";
    }
  }
  r.IfcLogical = In;
  class Cn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLuminousFluxMeasure = Cn;
  class It {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLuminousIntensityDistributionMeasure = It;
  class ht {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcLuminousIntensityMeasure = ht;
  class Wt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMagneticFluxDensityMeasure = Wt;
  class hn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMagneticFluxMeasure = hn;
  class Vt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMassDensityMeasure = Vt;
  class Tn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMassFlowRateMeasure = Tn;
  class Rn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMassMeasure = Rn;
  class Nn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMassPerLengthMeasure = Nn;
  class Dn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcModulusOfElasticityMeasure = Dn;
  class xn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcModulusOfLinearSubgradeReactionMeasure = xn;
  class $n {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcModulusOfRotationalSubgradeReactionMeasure = $n;
  class Kn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcModulusOfSubgradeReactionMeasure = Kn;
  class ir {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMoistureDiffusivityMeasure = ir;
  class er {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMolecularWeightMeasure = er;
  class br {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMomentOfInertiaMeasure = br;
  class cs {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMonetaryMeasure = cs;
  class Gn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcMonthInYearNumber = Gn;
  class Jn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcNonNegativeLengthMeasure = Jn;
  class Xn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcNormalisedRatioMeasure = Xn;
  class rr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcNumericMeasure = rr;
  class _r {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPHMeasure = _r;
  class Ss {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcParameterValue = Ss;
  class is {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPlanarForceMeasure = is;
  class Ms {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPlaneAngleMeasure = Ms;
  class ls {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPositiveInteger = ls;
  class Ur {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPositiveLengthMeasure = Ur;
  class Qr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPositivePlaneAngleMeasure = Qr;
  class Fr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPositiveRatioMeasure = Fr;
  class Lr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPowerMeasure = Lr;
  class Hr {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcPresentableText = Hr;
  class ns {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcPressureMeasure = ns;
  class Ts {
    constructor(H) {
      this.value = H;
    }
  }
  r.IfcPropertySetDefinitionSet = Ts;
  class en {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcRadioActivityMeasure = en;
  class to {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcRatioMeasure = to;
  class bs {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcReal = bs;
  class jn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcRotationalFrequencyMeasure = jn;
  class lr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcRotationalMassMeasure = lr;
  class pr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcRotationalStiffnessMeasure = pr;
  class En {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSectionModulusMeasure = En;
  class qn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSectionalAreaIntegralMeasure = qn;
  class Wn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcShearModulusMeasure = Wn;
  class kn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSolidAngleMeasure = kn;
  class zn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSoundPowerLevelMeasure = zn;
  class wr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSoundPowerMeasure = wr;
  class jr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSoundPressureLevelMeasure = jr;
  class Vr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSoundPressureMeasure = Vr;
  class us {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSpecificHeatCapacityMeasure = us;
  class Es {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSpecularExponent = Es;
  class Dr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcSpecularRoughness = Dr;
  class Kr {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcTemperatureGradientMeasure = Kr;
  class Js {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcTemperatureRateOfChangeMeasure = Js;
  class io {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcText = io;
  class No {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcTextAlignment = No;
  class Ai {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcTextDecoration = Ai;
  class go {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcTextFontName = go;
  class ks {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcTextTransformation = ks;
  class Ci {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermalAdmittanceMeasure = Ci;
  class Io {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermalConductivityMeasure = Io;
  class Oo {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermalExpansionCoefficientMeasure = Oo;
  class Zs {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermalResistanceMeasure = Zs;
  class wt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermalTransmittanceMeasure = wt;
  class _t {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcThermodynamicTemperatureMeasure = _t;
  class Ve {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcTime = Ve;
  class Ze {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcTimeMeasure = Ze;
  class bt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcTimeStamp = bt;
  class Ut {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcTorqueMeasure = Ut;
  class mn {
    constructor(H) {
      this.value = H, this.type = 1;
    }
  }
  r.IfcURIReference = mn;
  class nn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcVaporPermeabilityMeasure = nn;
  class Sn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcVolumeMeasure = Sn;
  class Mn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcVolumetricFlowRateMeasure = Mn;
  class yn {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcWarpingConstantMeasure = yn;
  class Pt {
    constructor(H) {
      this.type = 4, this.value = parseFloat(H);
    }
  }
  r.IfcWarpingMomentMeasure = Pt;
  class tr {
  }
  tr.EMAIL = { type: 3, value: "EMAIL" }, tr.FAX = { type: 3, value: "FAX" }, tr.PHONE = { type: 3, value: "PHONE" }, tr.POST = { type: 3, value: "POST" }, tr.VERBAL = { type: 3, value: "VERBAL" }, tr.USERDEFINED = { type: 3, value: "USERDEFINED" }, tr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionRequestTypeEnum = tr;
  class Lt {
  }
  Lt.BRAKES = { type: 3, value: "BRAKES" }, Lt.BUOYANCY = { type: 3, value: "BUOYANCY" }, Lt.COMPLETION_G1 = { type: 3, value: "COMPLETION_G1" }, Lt.CREEP = { type: 3, value: "CREEP" }, Lt.CURRENT = { type: 3, value: "CURRENT" }, Lt.DEAD_LOAD_G = { type: 3, value: "DEAD_LOAD_G" }, Lt.EARTHQUAKE_E = { type: 3, value: "EARTHQUAKE_E" }, Lt.ERECTION = { type: 3, value: "ERECTION" }, Lt.FIRE = { type: 3, value: "FIRE" }, Lt.ICE = { type: 3, value: "ICE" }, Lt.IMPACT = { type: 3, value: "IMPACT" }, Lt.IMPULSE = { type: 3, value: "IMPULSE" }, Lt.LACK_OF_FIT = { type: 3, value: "LACK_OF_FIT" }, Lt.LIVE_LOAD_Q = { type: 3, value: "LIVE_LOAD_Q" }, Lt.PRESTRESSING_P = { type: 3, value: "PRESTRESSING_P" }, Lt.PROPPING = { type: 3, value: "PROPPING" }, Lt.RAIN = { type: 3, value: "RAIN" }, Lt.SETTLEMENT_U = { type: 3, value: "SETTLEMENT_U" }, Lt.SHRINKAGE = { type: 3, value: "SHRINKAGE" }, Lt.SNOW_S = { type: 3, value: "SNOW_S" }, Lt.SYSTEM_IMPERFECTION = { type: 3, value: "SYSTEM_IMPERFECTION" }, Lt.TEMPERATURE_T = { type: 3, value: "TEMPERATURE_T" }, Lt.TRANSPORT = { type: 3, value: "TRANSPORT" }, Lt.WAVE = { type: 3, value: "WAVE" }, Lt.WIND_W = { type: 3, value: "WIND_W" }, Lt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionSourceTypeEnum = Lt;
  class dr {
  }
  dr.EXTRAORDINARY_A = { type: 3, value: "EXTRAORDINARY_A" }, dr.PERMANENT_G = { type: 3, value: "PERMANENT_G" }, dr.VARIABLE_Q = { type: 3, value: "VARIABLE_Q" }, dr.USERDEFINED = { type: 3, value: "USERDEFINED" }, dr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActionTypeEnum = dr;
  class ur {
  }
  ur.ELECTRICACTUATOR = { type: 3, value: "ELECTRICACTUATOR" }, ur.HANDOPERATEDACTUATOR = { type: 3, value: "HANDOPERATEDACTUATOR" }, ur.HYDRAULICACTUATOR = { type: 3, value: "HYDRAULICACTUATOR" }, ur.PNEUMATICACTUATOR = { type: 3, value: "PNEUMATICACTUATOR" }, ur.THERMOSTATICACTUATOR = { type: 3, value: "THERMOSTATICACTUATOR" }, ur.USERDEFINED = { type: 3, value: "USERDEFINED" }, ur.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcActuatorTypeEnum = ur;
  class gr {
  }
  gr.DISTRIBUTIONPOINT = { type: 3, value: "DISTRIBUTIONPOINT" }, gr.HOME = { type: 3, value: "HOME" }, gr.OFFICE = { type: 3, value: "OFFICE" }, gr.SITE = { type: 3, value: "SITE" }, gr.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcAddressTypeEnum = gr;
  class Rr {
  }
  Rr.CONSTANTFLOW = { type: 3, value: "CONSTANTFLOW" }, Rr.VARIABLEFLOWPRESSUREDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREDEPENDANT" }, Rr.VARIABLEFLOWPRESSUREINDEPENDANT = { type: 3, value: "VARIABLEFLOWPRESSUREINDEPENDANT" }, Rr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Rr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalBoxTypeEnum = Rr;
  class as {
  }
  as.DIFFUSER = { type: 3, value: "DIFFUSER" }, as.GRILLE = { type: 3, value: "GRILLE" }, as.LOUVRE = { type: 3, value: "LOUVRE" }, as.REGISTER = { type: 3, value: "REGISTER" }, as.USERDEFINED = { type: 3, value: "USERDEFINED" }, as.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirTerminalTypeEnum = as;
  class hs {
  }
  hs.FIXEDPLATECOUNTERFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECOUNTERFLOWEXCHANGER" }, hs.FIXEDPLATECROSSFLOWEXCHANGER = { type: 3, value: "FIXEDPLATECROSSFLOWEXCHANGER" }, hs.FIXEDPLATEPARALLELFLOWEXCHANGER = { type: 3, value: "FIXEDPLATEPARALLELFLOWEXCHANGER" }, hs.HEATPIPE = { type: 3, value: "HEATPIPE" }, hs.ROTARYWHEEL = { type: 3, value: "ROTARYWHEEL" }, hs.RUNAROUNDCOILLOOP = { type: 3, value: "RUNAROUNDCOILLOOP" }, hs.THERMOSIPHONCOILTYPEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS" }, hs.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = { type: 3, value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS" }, hs.TWINTOWERENTHALPYRECOVERYLOOPS = { type: 3, value: "TWINTOWERENTHALPYRECOVERYLOOPS" }, hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAirToAirHeatRecoveryTypeEnum = hs;
  class Os {
  }
  Os.BELL = { type: 3, value: "BELL" }, Os.BREAKGLASSBUTTON = { type: 3, value: "BREAKGLASSBUTTON" }, Os.LIGHT = { type: 3, value: "LIGHT" }, Os.MANUALPULLBOX = { type: 3, value: "MANUALPULLBOX" }, Os.RAILWAYCROCODILE = { type: 3, value: "RAILWAYCROCODILE" }, Os.RAILWAYDETONATOR = { type: 3, value: "RAILWAYDETONATOR" }, Os.SIREN = { type: 3, value: "SIREN" }, Os.WHISTLE = { type: 3, value: "WHISTLE" }, Os.USERDEFINED = { type: 3, value: "USERDEFINED" }, Os.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAlarmTypeEnum = Os;
  class jo {
  }
  jo.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" }, jo.CONSTANTCANT = { type: 3, value: "CONSTANTCANT" }, jo.COSINECURVE = { type: 3, value: "COSINECURVE" }, jo.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" }, jo.LINEARTRANSITION = { type: 3, value: "LINEARTRANSITION" }, jo.SINECURVE = { type: 3, value: "SINECURVE" }, jo.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" }, r.IfcAlignmentCantSegmentTypeEnum = jo;
  class po {
  }
  po.BLOSSCURVE = { type: 3, value: "BLOSSCURVE" }, po.CIRCULARARC = { type: 3, value: "CIRCULARARC" }, po.CLOTHOID = { type: 3, value: "CLOTHOID" }, po.COSINECURVE = { type: 3, value: "COSINECURVE" }, po.CUBIC = { type: 3, value: "CUBIC" }, po.HELMERTCURVE = { type: 3, value: "HELMERTCURVE" }, po.LINE = { type: 3, value: "LINE" }, po.SINECURVE = { type: 3, value: "SINECURVE" }, po.VIENNESEBEND = { type: 3, value: "VIENNESEBEND" }, r.IfcAlignmentHorizontalSegmentTypeEnum = po;
  class So {
  }
  So.USERDEFINED = { type: 3, value: "USERDEFINED" }, So.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAlignmentTypeEnum = So;
  class Eo {
  }
  Eo.CIRCULARARC = { type: 3, value: "CIRCULARARC" }, Eo.CLOTHOID = { type: 3, value: "CLOTHOID" }, Eo.CONSTANTGRADIENT = { type: 3, value: "CONSTANTGRADIENT" }, Eo.PARABOLICARC = { type: 3, value: "PARABOLICARC" }, r.IfcAlignmentVerticalSegmentTypeEnum = Eo;
  class Ps {
  }
  Ps.IN_PLANE_LOADING_2D = { type: 3, value: "IN_PLANE_LOADING_2D" }, Ps.LOADING_3D = { type: 3, value: "LOADING_3D" }, Ps.OUT_PLANE_LOADING_2D = { type: 3, value: "OUT_PLANE_LOADING_2D" }, Ps.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisModelTypeEnum = Ps;
  class no {
  }
  no.FIRST_ORDER_THEORY = { type: 3, value: "FIRST_ORDER_THEORY" }, no.FULL_NONLINEAR_THEORY = { type: 3, value: "FULL_NONLINEAR_THEORY" }, no.SECOND_ORDER_THEORY = { type: 3, value: "SECOND_ORDER_THEORY" }, no.THIRD_ORDER_THEORY = { type: 3, value: "THIRD_ORDER_THEORY" }, no.USERDEFINED = { type: 3, value: "USERDEFINED" }, no.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnalysisTheoryTypeEnum = no;
  class gs {
  }
  gs.ASBUILTAREA = { type: 3, value: "ASBUILTAREA" }, gs.ASBUILTLINE = { type: 3, value: "ASBUILTLINE" }, gs.ASBUILTPOINT = { type: 3, value: "ASBUILTPOINT" }, gs.ASSUMEDAREA = { type: 3, value: "ASSUMEDAREA" }, gs.ASSUMEDLINE = { type: 3, value: "ASSUMEDLINE" }, gs.ASSUMEDPOINT = { type: 3, value: "ASSUMEDPOINT" }, gs.NON_PHYSICAL_SIGNAL = { type: 3, value: "NON_PHYSICAL_SIGNAL" }, gs.SUPERELEVATIONEVENT = { type: 3, value: "SUPERELEVATIONEVENT" }, gs.WIDTHEVENT = { type: 3, value: "WIDTHEVENT" }, gs.USERDEFINED = { type: 3, value: "USERDEFINED" }, gs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAnnotationTypeEnum = gs;
  class fo {
  }
  fo.ADD = { type: 3, value: "ADD" }, fo.DIVIDE = { type: 3, value: "DIVIDE" }, fo.MULTIPLY = { type: 3, value: "MULTIPLY" }, fo.SUBTRACT = { type: 3, value: "SUBTRACT" }, r.IfcArithmeticOperatorEnum = fo;
  class xs {
  }
  xs.FACTORY = { type: 3, value: "FACTORY" }, xs.SITE = { type: 3, value: "SITE" }, xs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAssemblyPlaceEnum = xs;
  class Ir {
  }
  Ir.AMPLIFIER = { type: 3, value: "AMPLIFIER" }, Ir.CAMERA = { type: 3, value: "CAMERA" }, Ir.COMMUNICATIONTERMINAL = { type: 3, value: "COMMUNICATIONTERMINAL" }, Ir.DISPLAY = { type: 3, value: "DISPLAY" }, Ir.MICROPHONE = { type: 3, value: "MICROPHONE" }, Ir.PLAYER = { type: 3, value: "PLAYER" }, Ir.PROJECTOR = { type: 3, value: "PROJECTOR" }, Ir.RECEIVER = { type: 3, value: "RECEIVER" }, Ir.RECORDINGEQUIPMENT = { type: 3, value: "RECORDINGEQUIPMENT" }, Ir.SPEAKER = { type: 3, value: "SPEAKER" }, Ir.SWITCHER = { type: 3, value: "SWITCHER" }, Ir.TELEPHONE = { type: 3, value: "TELEPHONE" }, Ir.TUNER = { type: 3, value: "TUNER" }, Ir.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ir.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcAudioVisualApplianceTypeEnum = Ir;
  class ws {
  }
  ws.CIRCULAR_ARC = { type: 3, value: "CIRCULAR_ARC" }, ws.ELLIPTIC_ARC = { type: 3, value: "ELLIPTIC_ARC" }, ws.HYPERBOLIC_ARC = { type: 3, value: "HYPERBOLIC_ARC" }, ws.PARABOLIC_ARC = { type: 3, value: "PARABOLIC_ARC" }, ws.POLYLINE_FORM = { type: 3, value: "POLYLINE_FORM" }, ws.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcBSplineCurveForm = ws;
  class fr {
  }
  fr.CONICAL_SURF = { type: 3, value: "CONICAL_SURF" }, fr.CYLINDRICAL_SURF = { type: 3, value: "CYLINDRICAL_SURF" }, fr.GENERALISED_CONE = { type: 3, value: "GENERALISED_CONE" }, fr.PLANE_SURF = { type: 3, value: "PLANE_SURF" }, fr.QUADRIC_SURF = { type: 3, value: "QUADRIC_SURF" }, fr.RULED_SURF = { type: 3, value: "RULED_SURF" }, fr.SPHERICAL_SURF = { type: 3, value: "SPHERICAL_SURF" }, fr.SURF_OF_LINEAR_EXTRUSION = { type: 3, value: "SURF_OF_LINEAR_EXTRUSION" }, fr.SURF_OF_REVOLUTION = { type: 3, value: "SURF_OF_REVOLUTION" }, fr.TOROIDAL_SURF = { type: 3, value: "TOROIDAL_SURF" }, fr.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcBSplineSurfaceForm = fr;
  class Mr {
  }
  Mr.BEAM = { type: 3, value: "BEAM" }, Mr.CORNICE = { type: 3, value: "CORNICE" }, Mr.DIAPHRAGM = { type: 3, value: "DIAPHRAGM" }, Mr.EDGEBEAM = { type: 3, value: "EDGEBEAM" }, Mr.GIRDER_SEGMENT = { type: 3, value: "GIRDER_SEGMENT" }, Mr.HATSTONE = { type: 3, value: "HATSTONE" }, Mr.HOLLOWCORE = { type: 3, value: "HOLLOWCORE" }, Mr.JOIST = { type: 3, value: "JOIST" }, Mr.LINTEL = { type: 3, value: "LINTEL" }, Mr.PIERCAP = { type: 3, value: "PIERCAP" }, Mr.SPANDREL = { type: 3, value: "SPANDREL" }, Mr.T_BEAM = { type: 3, value: "T_BEAM" }, Mr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBeamTypeEnum = Mr;
  class Nr {
  }
  Nr.FIXED_MOVEMENT = { type: 3, value: "FIXED_MOVEMENT" }, Nr.FREE_MOVEMENT = { type: 3, value: "FREE_MOVEMENT" }, Nr.GUIDED_LONGITUDINAL = { type: 3, value: "GUIDED_LONGITUDINAL" }, Nr.GUIDED_TRANSVERSAL = { type: 3, value: "GUIDED_TRANSVERSAL" }, Nr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBearingTypeDisplacementEnum = Nr;
  class ii {
  }
  ii.CYLINDRICAL = { type: 3, value: "CYLINDRICAL" }, ii.DISK = { type: 3, value: "DISK" }, ii.ELASTOMERIC = { type: 3, value: "ELASTOMERIC" }, ii.GUIDE = { type: 3, value: "GUIDE" }, ii.POT = { type: 3, value: "POT" }, ii.ROCKER = { type: 3, value: "ROCKER" }, ii.ROLLER = { type: 3, value: "ROLLER" }, ii.SPHERICAL = { type: 3, value: "SPHERICAL" }, ii.USERDEFINED = { type: 3, value: "USERDEFINED" }, ii.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBearingTypeEnum = ii;
  class Ro {
  }
  Ro.EQUALTO = { type: 3, value: "EQUALTO" }, Ro.GREATERTHAN = { type: 3, value: "GREATERTHAN" }, Ro.GREATERTHANOREQUALTO = { type: 3, value: "GREATERTHANOREQUALTO" }, Ro.INCLUDEDIN = { type: 3, value: "INCLUDEDIN" }, Ro.INCLUDES = { type: 3, value: "INCLUDES" }, Ro.LESSTHAN = { type: 3, value: "LESSTHAN" }, Ro.LESSTHANOREQUALTO = { type: 3, value: "LESSTHANOREQUALTO" }, Ro.NOTEQUALTO = { type: 3, value: "NOTEQUALTO" }, Ro.NOTINCLUDEDIN = { type: 3, value: "NOTINCLUDEDIN" }, Ro.NOTINCLUDES = { type: 3, value: "NOTINCLUDES" }, r.IfcBenchmarkEnum = Ro;
  class Bo {
  }
  Bo.STEAM = { type: 3, value: "STEAM" }, Bo.WATER = { type: 3, value: "WATER" }, Bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBoilerTypeEnum = Bo;
  class Rs {
  }
  Rs.DIFFERENCE = { type: 3, value: "DIFFERENCE" }, Rs.INTERSECTION = { type: 3, value: "INTERSECTION" }, Rs.UNION = { type: 3, value: "UNION" }, r.IfcBooleanOperator = Rs;
  class Uo {
  }
  Uo.ABUTMENT = { type: 3, value: "ABUTMENT" }, Uo.DECK = { type: 3, value: "DECK" }, Uo.DECK_SEGMENT = { type: 3, value: "DECK_SEGMENT" }, Uo.FOUNDATION = { type: 3, value: "FOUNDATION" }, Uo.PIER = { type: 3, value: "PIER" }, Uo.PIER_SEGMENT = { type: 3, value: "PIER_SEGMENT" }, Uo.PYLON = { type: 3, value: "PYLON" }, Uo.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" }, Uo.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, Uo.SURFACESTRUCTURE = { type: 3, value: "SURFACESTRUCTURE" }, Uo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Uo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBridgePartTypeEnum = Uo;
  class xi {
  }
  xi.ARCHED = { type: 3, value: "ARCHED" }, xi.CABLE_STAYED = { type: 3, value: "CABLE_STAYED" }, xi.CANTILEVER = { type: 3, value: "CANTILEVER" }, xi.CULVERT = { type: 3, value: "CULVERT" }, xi.FRAMEWORK = { type: 3, value: "FRAMEWORK" }, xi.GIRDER = { type: 3, value: "GIRDER" }, xi.SUSPENSION = { type: 3, value: "SUSPENSION" }, xi.TRUSS = { type: 3, value: "TRUSS" }, xi.USERDEFINED = { type: 3, value: "USERDEFINED" }, xi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBridgeTypeEnum = xi;
  class Vo {
  }
  Vo.APRON = { type: 3, value: "APRON" }, Vo.ARMOURUNIT = { type: 3, value: "ARMOURUNIT" }, Vo.INSULATION = { type: 3, value: "INSULATION" }, Vo.PRECASTPANEL = { type: 3, value: "PRECASTPANEL" }, Vo.SAFETYCAGE = { type: 3, value: "SAFETYCAGE" }, Vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingElementPartTypeEnum = Vo;
  class oa {
  }
  oa.COMPLEX = { type: 3, value: "COMPLEX" }, oa.ELEMENT = { type: 3, value: "ELEMENT" }, oa.PARTIAL = { type: 3, value: "PARTIAL" }, oa.USERDEFINED = { type: 3, value: "USERDEFINED" }, oa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingElementProxyTypeEnum = oa;
  class ti {
  }
  ti.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" }, ti.FENESTRATION = { type: 3, value: "FENESTRATION" }, ti.FOUNDATION = { type: 3, value: "FOUNDATION" }, ti.LOADBEARING = { type: 3, value: "LOADBEARING" }, ti.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, ti.PRESTRESSING = { type: 3, value: "PRESTRESSING" }, ti.REINFORCING = { type: 3, value: "REINFORCING" }, ti.SHADING = { type: 3, value: "SHADING" }, ti.TRANSPORT = { type: 3, value: "TRANSPORT" }, ti.USERDEFINED = { type: 3, value: "USERDEFINED" }, ti.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuildingSystemTypeEnum = ti;
  class Po {
  }
  Po.EROSIONPREVENTION = { type: 3, value: "EROSIONPREVENTION" }, Po.FENESTRATION = { type: 3, value: "FENESTRATION" }, Po.FOUNDATION = { type: 3, value: "FOUNDATION" }, Po.LOADBEARING = { type: 3, value: "LOADBEARING" }, Po.MOORING = { type: 3, value: "MOORING" }, Po.OUTERSHELL = { type: 3, value: "OUTERSHELL" }, Po.PRESTRESSING = { type: 3, value: "PRESTRESSING" }, Po.RAILWAYLINE = { type: 3, value: "RAILWAYLINE" }, Po.RAILWAYTRACK = { type: 3, value: "RAILWAYTRACK" }, Po.REINFORCING = { type: 3, value: "REINFORCING" }, Po.SHADING = { type: 3, value: "SHADING" }, Po.TRACKCIRCUIT = { type: 3, value: "TRACKCIRCUIT" }, Po.TRANSPORT = { type: 3, value: "TRANSPORT" }, Po.USERDEFINED = { type: 3, value: "USERDEFINED" }, Po.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBuiltSystemTypeEnum = Po;
  class ai {
  }
  ai.USERDEFINED = { type: 3, value: "USERDEFINED" }, ai.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcBurnerTypeEnum = ai;
  class Wo {
  }
  Wo.BEND = { type: 3, value: "BEND" }, Wo.CONNECTOR = { type: 3, value: "CONNECTOR" }, Wo.CROSS = { type: 3, value: "CROSS" }, Wo.JUNCTION = { type: 3, value: "JUNCTION" }, Wo.TEE = { type: 3, value: "TEE" }, Wo.TRANSITION = { type: 3, value: "TRANSITION" }, Wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierFittingTypeEnum = Wo;
  class As {
  }
  As.CABLEBRACKET = { type: 3, value: "CABLEBRACKET" }, As.CABLELADDERSEGMENT = { type: 3, value: "CABLELADDERSEGMENT" }, As.CABLETRAYSEGMENT = { type: 3, value: "CABLETRAYSEGMENT" }, As.CABLETRUNKINGSEGMENT = { type: 3, value: "CABLETRUNKINGSEGMENT" }, As.CATENARYWIRE = { type: 3, value: "CATENARYWIRE" }, As.CONDUITSEGMENT = { type: 3, value: "CONDUITSEGMENT" }, As.DROPPER = { type: 3, value: "DROPPER" }, As.USERDEFINED = { type: 3, value: "USERDEFINED" }, As.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableCarrierSegmentTypeEnum = As;
  class ro {
  }
  ro.CONNECTOR = { type: 3, value: "CONNECTOR" }, ro.ENTRY = { type: 3, value: "ENTRY" }, ro.EXIT = { type: 3, value: "EXIT" }, ro.FANOUT = { type: 3, value: "FANOUT" }, ro.JUNCTION = { type: 3, value: "JUNCTION" }, ro.TRANSITION = { type: 3, value: "TRANSITION" }, ro.USERDEFINED = { type: 3, value: "USERDEFINED" }, ro.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableFittingTypeEnum = ro;
  class Mo {
  }
  Mo.BUSBARSEGMENT = { type: 3, value: "BUSBARSEGMENT" }, Mo.CABLESEGMENT = { type: 3, value: "CABLESEGMENT" }, Mo.CONDUCTORSEGMENT = { type: 3, value: "CONDUCTORSEGMENT" }, Mo.CONTACTWIRESEGMENT = { type: 3, value: "CONTACTWIRESEGMENT" }, Mo.CORESEGMENT = { type: 3, value: "CORESEGMENT" }, Mo.FIBERSEGMENT = { type: 3, value: "FIBERSEGMENT" }, Mo.FIBERTUBE = { type: 3, value: "FIBERTUBE" }, Mo.OPTICALCABLESEGMENT = { type: 3, value: "OPTICALCABLESEGMENT" }, Mo.STITCHWIRE = { type: 3, value: "STITCHWIRE" }, Mo.WIREPAIRSEGMENT = { type: 3, value: "WIREPAIRSEGMENT" }, Mo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCableSegmentTypeEnum = Mo;
  class vr {
  }
  vr.CAISSON = { type: 3, value: "CAISSON" }, vr.WELL = { type: 3, value: "WELL" }, vr.USERDEFINED = { type: 3, value: "USERDEFINED" }, vr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCaissonFoundationTypeEnum = vr;
  class ts {
  }
  ts.ADDED = { type: 3, value: "ADDED" }, ts.DELETED = { type: 3, value: "DELETED" }, ts.MODIFIED = { type: 3, value: "MODIFIED" }, ts.NOCHANGE = { type: 3, value: "NOCHANGE" }, ts.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChangeActionEnum = ts;
  class kr {
  }
  kr.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, kr.HEATRECOVERY = { type: 3, value: "HEATRECOVERY" }, kr.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, kr.USERDEFINED = { type: 3, value: "USERDEFINED" }, kr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChillerTypeEnum = kr;
  class Us {
  }
  Us.USERDEFINED = { type: 3, value: "USERDEFINED" }, Us.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcChimneyTypeEnum = Us;
  class ri {
  }
  ri.DXCOOLINGCOIL = { type: 3, value: "DXCOOLINGCOIL" }, ri.ELECTRICHEATINGCOIL = { type: 3, value: "ELECTRICHEATINGCOIL" }, ri.GASHEATINGCOIL = { type: 3, value: "GASHEATINGCOIL" }, ri.HYDRONICCOIL = { type: 3, value: "HYDRONICCOIL" }, ri.STEAMHEATINGCOIL = { type: 3, value: "STEAMHEATINGCOIL" }, ri.WATERCOOLINGCOIL = { type: 3, value: "WATERCOOLINGCOIL" }, ri.WATERHEATINGCOIL = { type: 3, value: "WATERHEATINGCOIL" }, ri.USERDEFINED = { type: 3, value: "USERDEFINED" }, ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoilTypeEnum = ri;
  class Wi {
  }
  Wi.COLUMN = { type: 3, value: "COLUMN" }, Wi.PIERSTEM = { type: 3, value: "PIERSTEM" }, Wi.PIERSTEM_SEGMENT = { type: 3, value: "PIERSTEM_SEGMENT" }, Wi.PILASTER = { type: 3, value: "PILASTER" }, Wi.STANDCOLUMN = { type: 3, value: "STANDCOLUMN" }, Wi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcColumnTypeEnum = Wi;
  class To {
  }
  To.ANTENNA = { type: 3, value: "ANTENNA" }, To.AUTOMATON = { type: 3, value: "AUTOMATON" }, To.COMPUTER = { type: 3, value: "COMPUTER" }, To.FAX = { type: 3, value: "FAX" }, To.GATEWAY = { type: 3, value: "GATEWAY" }, To.INTELLIGENTPERIPHERAL = { type: 3, value: "INTELLIGENTPERIPHERAL" }, To.IPNETWORKEQUIPMENT = { type: 3, value: "IPNETWORKEQUIPMENT" }, To.LINESIDEELECTRONICUNIT = { type: 3, value: "LINESIDEELECTRONICUNIT" }, To.MODEM = { type: 3, value: "MODEM" }, To.NETWORKAPPLIANCE = { type: 3, value: "NETWORKAPPLIANCE" }, To.NETWORKBRIDGE = { type: 3, value: "NETWORKBRIDGE" }, To.NETWORKHUB = { type: 3, value: "NETWORKHUB" }, To.OPTICALLINETERMINAL = { type: 3, value: "OPTICALLINETERMINAL" }, To.OPTICALNETWORKUNIT = { type: 3, value: "OPTICALNETWORKUNIT" }, To.PRINTER = { type: 3, value: "PRINTER" }, To.RADIOBLOCKCENTER = { type: 3, value: "RADIOBLOCKCENTER" }, To.REPEATER = { type: 3, value: "REPEATER" }, To.ROUTER = { type: 3, value: "ROUTER" }, To.SCANNER = { type: 3, value: "SCANNER" }, To.TELECOMMAND = { type: 3, value: "TELECOMMAND" }, To.TELEPHONYEXCHANGE = { type: 3, value: "TELEPHONYEXCHANGE" }, To.TRANSITIONCOMPONENT = { type: 3, value: "TRANSITIONCOMPONENT" }, To.TRANSPONDER = { type: 3, value: "TRANSPONDER" }, To.TRANSPORTEQUIPMENT = { type: 3, value: "TRANSPORTEQUIPMENT" }, To.USERDEFINED = { type: 3, value: "USERDEFINED" }, To.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCommunicationsApplianceTypeEnum = To;
  class ia {
  }
  ia.P_COMPLEX = { type: 3, value: "P_COMPLEX" }, ia.Q_COMPLEX = { type: 3, value: "Q_COMPLEX" }, r.IfcComplexPropertyTemplateTypeEnum = ia;
  class bo {
  }
  bo.BOOSTER = { type: 3, value: "BOOSTER" }, bo.DYNAMIC = { type: 3, value: "DYNAMIC" }, bo.HERMETIC = { type: 3, value: "HERMETIC" }, bo.OPENTYPE = { type: 3, value: "OPENTYPE" }, bo.RECIPROCATING = { type: 3, value: "RECIPROCATING" }, bo.ROLLINGPISTON = { type: 3, value: "ROLLINGPISTON" }, bo.ROTARY = { type: 3, value: "ROTARY" }, bo.ROTARYVANE = { type: 3, value: "ROTARYVANE" }, bo.SCROLL = { type: 3, value: "SCROLL" }, bo.SEMIHERMETIC = { type: 3, value: "SEMIHERMETIC" }, bo.SINGLESCREW = { type: 3, value: "SINGLESCREW" }, bo.SINGLESTAGE = { type: 3, value: "SINGLESTAGE" }, bo.TROCHOIDAL = { type: 3, value: "TROCHOIDAL" }, bo.TWINSCREW = { type: 3, value: "TWINSCREW" }, bo.WELDEDSHELLHERMETIC = { type: 3, value: "WELDEDSHELLHERMETIC" }, bo.USERDEFINED = { type: 3, value: "USERDEFINED" }, bo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCompressorTypeEnum = bo;
  class Ys {
  }
  Ys.AIRCOOLED = { type: 3, value: "AIRCOOLED" }, Ys.EVAPORATIVECOOLED = { type: 3, value: "EVAPORATIVECOOLED" }, Ys.WATERCOOLED = { type: 3, value: "WATERCOOLED" }, Ys.WATERCOOLEDBRAZEDPLATE = { type: 3, value: "WATERCOOLEDBRAZEDPLATE" }, Ys.WATERCOOLEDSHELLCOIL = { type: 3, value: "WATERCOOLEDSHELLCOIL" }, Ys.WATERCOOLEDSHELLTUBE = { type: 3, value: "WATERCOOLEDSHELLTUBE" }, Ys.WATERCOOLEDTUBEINTUBE = { type: 3, value: "WATERCOOLEDTUBEINTUBE" }, Ys.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ys.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCondenserTypeEnum = Ys;
  class Di {
  }
  Di.ATEND = { type: 3, value: "ATEND" }, Di.ATPATH = { type: 3, value: "ATPATH" }, Di.ATSTART = { type: 3, value: "ATSTART" }, Di.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConnectionTypeEnum = Di;
  class Yn {
  }
  Yn.ADVISORY = { type: 3, value: "ADVISORY" }, Yn.HARD = { type: 3, value: "HARD" }, Yn.SOFT = { type: 3, value: "SOFT" }, Yn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstraintEnum = Yn;
  class Lo {
  }
  Lo.DEMOLISHING = { type: 3, value: "DEMOLISHING" }, Lo.EARTHMOVING = { type: 3, value: "EARTHMOVING" }, Lo.ERECTING = { type: 3, value: "ERECTING" }, Lo.HEATING = { type: 3, value: "HEATING" }, Lo.LIGHTING = { type: 3, value: "LIGHTING" }, Lo.PAVING = { type: 3, value: "PAVING" }, Lo.PUMPING = { type: 3, value: "PUMPING" }, Lo.TRANSPORTING = { type: 3, value: "TRANSPORTING" }, Lo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstructionEquipmentResourceTypeEnum = Lo;
  class Un {
  }
  Un.AGGREGATES = { type: 3, value: "AGGREGATES" }, Un.CONCRETE = { type: 3, value: "CONCRETE" }, Un.DRYWALL = { type: 3, value: "DRYWALL" }, Un.FUEL = { type: 3, value: "FUEL" }, Un.GYPSUM = { type: 3, value: "GYPSUM" }, Un.MASONRY = { type: 3, value: "MASONRY" }, Un.METAL = { type: 3, value: "METAL" }, Un.PLASTIC = { type: 3, value: "PLASTIC" }, Un.WOOD = { type: 3, value: "WOOD" }, Un.USERDEFINED = { type: 3, value: "USERDEFINED" }, Un.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstructionMaterialResourceTypeEnum = Un;
  class so {
  }
  so.ASSEMBLY = { type: 3, value: "ASSEMBLY" }, so.FORMWORK = { type: 3, value: "FORMWORK" }, so.USERDEFINED = { type: 3, value: "USERDEFINED" }, so.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConstructionProductResourceTypeEnum = so;
  class rs {
  }
  rs.FLOATING = { type: 3, value: "FLOATING" }, rs.MULTIPOSITION = { type: 3, value: "MULTIPOSITION" }, rs.PROGRAMMABLE = { type: 3, value: "PROGRAMMABLE" }, rs.PROPORTIONAL = { type: 3, value: "PROPORTIONAL" }, rs.TWOPOSITION = { type: 3, value: "TWOPOSITION" }, rs.USERDEFINED = { type: 3, value: "USERDEFINED" }, rs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcControllerTypeEnum = rs;
  class hi {
  }
  hi.BELTCONVEYOR = { type: 3, value: "BELTCONVEYOR" }, hi.BUCKETCONVEYOR = { type: 3, value: "BUCKETCONVEYOR" }, hi.CHUTECONVEYOR = { type: 3, value: "CHUTECONVEYOR" }, hi.SCREWCONVEYOR = { type: 3, value: "SCREWCONVEYOR" }, hi.USERDEFINED = { type: 3, value: "USERDEFINED" }, hi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcConveyorSegmentTypeEnum = hi;
  class Zo {
  }
  Zo.ACTIVE = { type: 3, value: "ACTIVE" }, Zo.PASSIVE = { type: 3, value: "PASSIVE" }, Zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCooledBeamTypeEnum = Zo;
  class li {
  }
  li.MECHANICALFORCEDDRAFT = { type: 3, value: "MECHANICALFORCEDDRAFT" }, li.MECHANICALINDUCEDDRAFT = { type: 3, value: "MECHANICALINDUCEDDRAFT" }, li.NATURALDRAFT = { type: 3, value: "NATURALDRAFT" }, li.USERDEFINED = { type: 3, value: "USERDEFINED" }, li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoolingTowerTypeEnum = li;
  class ei {
  }
  ei.USERDEFINED = { type: 3, value: "USERDEFINED" }, ei.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCostItemTypeEnum = ei;
  class Or {
  }
  Or.BUDGET = { type: 3, value: "BUDGET" }, Or.COSTPLAN = { type: 3, value: "COSTPLAN" }, Or.ESTIMATE = { type: 3, value: "ESTIMATE" }, Or.PRICEDBILLOFQUANTITIES = { type: 3, value: "PRICEDBILLOFQUANTITIES" }, Or.SCHEDULEOFRATES = { type: 3, value: "SCHEDULEOFRATES" }, Or.TENDER = { type: 3, value: "TENDER" }, Or.UNPRICEDBILLOFQUANTITIES = { type: 3, value: "UNPRICEDBILLOFQUANTITIES" }, Or.USERDEFINED = { type: 3, value: "USERDEFINED" }, Or.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCostScheduleTypeEnum = Or;
  class ui {
  }
  ui.ARMOUR = { type: 3, value: "ARMOUR" }, ui.BALLASTBED = { type: 3, value: "BALLASTBED" }, ui.CORE = { type: 3, value: "CORE" }, ui.FILTER = { type: 3, value: "FILTER" }, ui.PAVEMENT = { type: 3, value: "PAVEMENT" }, ui.PROTECTION = { type: 3, value: "PROTECTION" }, ui.USERDEFINED = { type: 3, value: "USERDEFINED" }, ui.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCourseTypeEnum = ui;
  class _s {
  }
  _s.CEILING = { type: 3, value: "CEILING" }, _s.CLADDING = { type: 3, value: "CLADDING" }, _s.COPING = { type: 3, value: "COPING" }, _s.FLOORING = { type: 3, value: "FLOORING" }, _s.INSULATION = { type: 3, value: "INSULATION" }, _s.MEMBRANE = { type: 3, value: "MEMBRANE" }, _s.MOLDING = { type: 3, value: "MOLDING" }, _s.ROOFING = { type: 3, value: "ROOFING" }, _s.SKIRTINGBOARD = { type: 3, value: "SKIRTINGBOARD" }, _s.SLEEVING = { type: 3, value: "SLEEVING" }, _s.TOPPING = { type: 3, value: "TOPPING" }, _s.WRAPPING = { type: 3, value: "WRAPPING" }, _s.USERDEFINED = { type: 3, value: "USERDEFINED" }, _s.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCoveringTypeEnum = _s;
  class xo {
  }
  xo.OFFICE = { type: 3, value: "OFFICE" }, xo.SITE = { type: 3, value: "SITE" }, xo.USERDEFINED = { type: 3, value: "USERDEFINED" }, xo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCrewResourceTypeEnum = xo;
  class aa {
  }
  aa.USERDEFINED = { type: 3, value: "USERDEFINED" }, aa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCurtainWallTypeEnum = aa;
  class oo {
  }
  oo.LINEAR = { type: 3, value: "LINEAR" }, oo.LOG_LINEAR = { type: 3, value: "LOG_LINEAR" }, oo.LOG_LOG = { type: 3, value: "LOG_LOG" }, oo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcCurveInterpolationEnum = oo;
  class vs {
  }
  vs.BACKDRAFTDAMPER = { type: 3, value: "BACKDRAFTDAMPER" }, vs.BALANCINGDAMPER = { type: 3, value: "BALANCINGDAMPER" }, vs.BLASTDAMPER = { type: 3, value: "BLASTDAMPER" }, vs.CONTROLDAMPER = { type: 3, value: "CONTROLDAMPER" }, vs.FIREDAMPER = { type: 3, value: "FIREDAMPER" }, vs.FIRESMOKEDAMPER = { type: 3, value: "FIRESMOKEDAMPER" }, vs.FUMEHOODEXHAUST = { type: 3, value: "FUMEHOODEXHAUST" }, vs.GRAVITYDAMPER = { type: 3, value: "GRAVITYDAMPER" }, vs.GRAVITYRELIEFDAMPER = { type: 3, value: "GRAVITYRELIEFDAMPER" }, vs.RELIEFDAMPER = { type: 3, value: "RELIEFDAMPER" }, vs.SMOKEDAMPER = { type: 3, value: "SMOKEDAMPER" }, vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDamperTypeEnum = vs;
  class yi {
  }
  yi.MEASURED = { type: 3, value: "MEASURED" }, yi.PREDICTED = { type: 3, value: "PREDICTED" }, yi.SIMULATED = { type: 3, value: "SIMULATED" }, yi.USERDEFINED = { type: 3, value: "USERDEFINED" }, yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDataOriginEnum = yi;
  class $r {
  }
  $r.ACCELERATIONUNIT = { type: 3, value: "ACCELERATIONUNIT" }, $r.ANGULARVELOCITYUNIT = { type: 3, value: "ANGULARVELOCITYUNIT" }, $r.AREADENSITYUNIT = { type: 3, value: "AREADENSITYUNIT" }, $r.COMPOUNDPLANEANGLEUNIT = { type: 3, value: "COMPOUNDPLANEANGLEUNIT" }, $r.CURVATUREUNIT = { type: 3, value: "CURVATUREUNIT" }, $r.DYNAMICVISCOSITYUNIT = { type: 3, value: "DYNAMICVISCOSITYUNIT" }, $r.HEATFLUXDENSITYUNIT = { type: 3, value: "HEATFLUXDENSITYUNIT" }, $r.HEATINGVALUEUNIT = { type: 3, value: "HEATINGVALUEUNIT" }, $r.INTEGERCOUNTRATEUNIT = { type: 3, value: "INTEGERCOUNTRATEUNIT" }, $r.IONCONCENTRATIONUNIT = { type: 3, value: "IONCONCENTRATIONUNIT" }, $r.ISOTHERMALMOISTURECAPACITYUNIT = { type: 3, value: "ISOTHERMALMOISTURECAPACITYUNIT" }, $r.KINEMATICVISCOSITYUNIT = { type: 3, value: "KINEMATICVISCOSITYUNIT" }, $r.LINEARFORCEUNIT = { type: 3, value: "LINEARFORCEUNIT" }, $r.LINEARMOMENTUNIT = { type: 3, value: "LINEARMOMENTUNIT" }, $r.LINEARSTIFFNESSUNIT = { type: 3, value: "LINEARSTIFFNESSUNIT" }, $r.LINEARVELOCITYUNIT = { type: 3, value: "LINEARVELOCITYUNIT" }, $r.LUMINOUSINTENSITYDISTRIBUTIONUNIT = { type: 3, value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT" }, $r.MASSDENSITYUNIT = { type: 3, value: "MASSDENSITYUNIT" }, $r.MASSFLOWRATEUNIT = { type: 3, value: "MASSFLOWRATEUNIT" }, $r.MASSPERLENGTHUNIT = { type: 3, value: "MASSPERLENGTHUNIT" }, $r.MODULUSOFELASTICITYUNIT = { type: 3, value: "MODULUSOFELASTICITYUNIT" }, $r.MODULUSOFLINEARSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT" }, $r.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT" }, $r.MODULUSOFSUBGRADEREACTIONUNIT = { type: 3, value: "MODULUSOFSUBGRADEREACTIONUNIT" }, $r.MOISTUREDIFFUSIVITYUNIT = { type: 3, value: "MOISTUREDIFFUSIVITYUNIT" }, $r.MOLECULARWEIGHTUNIT = { type: 3, value: "MOLECULARWEIGHTUNIT" }, $r.MOMENTOFINERTIAUNIT = { type: 3, value: "MOMENTOFINERTIAUNIT" }, $r.PHUNIT = { type: 3, value: "PHUNIT" }, $r.PLANARFORCEUNIT = { type: 3, value: "PLANARFORCEUNIT" }, $r.ROTATIONALFREQUENCYUNIT = { type: 3, value: "ROTATIONALFREQUENCYUNIT" }, $r.ROTATIONALMASSUNIT = { type: 3, value: "ROTATIONALMASSUNIT" }, $r.ROTATIONALSTIFFNESSUNIT = { type: 3, value: "ROTATIONALSTIFFNESSUNIT" }, $r.SECTIONAREAINTEGRALUNIT = { type: 3, value: "SECTIONAREAINTEGRALUNIT" }, $r.SECTIONMODULUSUNIT = { type: 3, value: "SECTIONMODULUSUNIT" }, $r.SHEARMODULUSUNIT = { type: 3, value: "SHEARMODULUSUNIT" }, $r.SOUNDPOWERLEVELUNIT = { type: 3, value: "SOUNDPOWERLEVELUNIT" }, $r.SOUNDPOWERUNIT = { type: 3, value: "SOUNDPOWERUNIT" }, $r.SOUNDPRESSURELEVELUNIT = { type: 3, value: "SOUNDPRESSURELEVELUNIT" }, $r.SOUNDPRESSUREUNIT = { type: 3, value: "SOUNDPRESSUREUNIT" }, $r.SPECIFICHEATCAPACITYUNIT = { type: 3, value: "SPECIFICHEATCAPACITYUNIT" }, $r.TEMPERATUREGRADIENTUNIT = { type: 3, value: "TEMPERATUREGRADIENTUNIT" }, $r.TEMPERATURERATEOFCHANGEUNIT = { type: 3, value: "TEMPERATURERATEOFCHANGEUNIT" }, $r.THERMALADMITTANCEUNIT = { type: 3, value: "THERMALADMITTANCEUNIT" }, $r.THERMALCONDUCTANCEUNIT = { type: 3, value: "THERMALCONDUCTANCEUNIT" }, $r.THERMALEXPANSIONCOEFFICIENTUNIT = { type: 3, value: "THERMALEXPANSIONCOEFFICIENTUNIT" }, $r.THERMALRESISTANCEUNIT = { type: 3, value: "THERMALRESISTANCEUNIT" }, $r.THERMALTRANSMITTANCEUNIT = { type: 3, value: "THERMALTRANSMITTANCEUNIT" }, $r.TORQUEUNIT = { type: 3, value: "TORQUEUNIT" }, $r.VAPORPERMEABILITYUNIT = { type: 3, value: "VAPORPERMEABILITYUNIT" }, $r.VOLUMETRICFLOWRATEUNIT = { type: 3, value: "VOLUMETRICFLOWRATEUNIT" }, $r.WARPINGCONSTANTUNIT = { type: 3, value: "WARPINGCONSTANTUNIT" }, $r.WARPINGMOMENTUNIT = { type: 3, value: "WARPINGMOMENTUNIT" }, $r.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcDerivedUnitEnum = $r;
  class ki {
  }
  ki.NEGATIVE = { type: 3, value: "NEGATIVE" }, ki.POSITIVE = { type: 3, value: "POSITIVE" }, r.IfcDirectionSenseEnum = ki;
  class ds {
  }
  ds.ANCHORPLATE = { type: 3, value: "ANCHORPLATE" }, ds.BIRDPROTECTION = { type: 3, value: "BIRDPROTECTION" }, ds.BRACKET = { type: 3, value: "BRACKET" }, ds.CABLEARRANGER = { type: 3, value: "CABLEARRANGER" }, ds.ELASTIC_CUSHION = { type: 3, value: "ELASTIC_CUSHION" }, ds.EXPANSION_JOINT_DEVICE = { type: 3, value: "EXPANSION_JOINT_DEVICE" }, ds.FILLER = { type: 3, value: "FILLER" }, ds.FLASHING = { type: 3, value: "FLASHING" }, ds.INSULATOR = { type: 3, value: "INSULATOR" }, ds.LOCK = { type: 3, value: "LOCK" }, ds.PANEL_STRENGTHENING = { type: 3, value: "PANEL_STRENGTHENING" }, ds.POINTMACHINEMOUNTINGDEVICE = { type: 3, value: "POINTMACHINEMOUNTINGDEVICE" }, ds.POINT_MACHINE_LOCKING_DEVICE = { type: 3, value: "POINT_MACHINE_LOCKING_DEVICE" }, ds.RAILBRACE = { type: 3, value: "RAILBRACE" }, ds.RAILPAD = { type: 3, value: "RAILPAD" }, ds.RAIL_LUBRICATION = { type: 3, value: "RAIL_LUBRICATION" }, ds.RAIL_MECHANICAL_EQUIPMENT = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT" }, ds.SHOE = { type: 3, value: "SHOE" }, ds.SLIDINGCHAIR = { type: 3, value: "SLIDINGCHAIR" }, ds.SOUNDABSORPTION = { type: 3, value: "SOUNDABSORPTION" }, ds.TENSIONINGEQUIPMENT = { type: 3, value: "TENSIONINGEQUIPMENT" }, ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDiscreteAccessoryTypeEnum = ds;
  class Ls {
  }
  Ls.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, Ls.DISPATCHINGBOARD = { type: 3, value: "DISPATCHINGBOARD" }, Ls.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, Ls.DISTRIBUTIONFRAME = { type: 3, value: "DISTRIBUTIONFRAME" }, Ls.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, Ls.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, Ls.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ls.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionBoardTypeEnum = Ls;
  class Co {
  }
  Co.FORMEDDUCT = { type: 3, value: "FORMEDDUCT" }, Co.INSPECTIONCHAMBER = { type: 3, value: "INSPECTIONCHAMBER" }, Co.INSPECTIONPIT = { type: 3, value: "INSPECTIONPIT" }, Co.MANHOLE = { type: 3, value: "MANHOLE" }, Co.METERCHAMBER = { type: 3, value: "METERCHAMBER" }, Co.SUMP = { type: 3, value: "SUMP" }, Co.TRENCH = { type: 3, value: "TRENCH" }, Co.VALVECHAMBER = { type: 3, value: "VALVECHAMBER" }, Co.USERDEFINED = { type: 3, value: "USERDEFINED" }, Co.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionChamberElementTypeEnum = Co;
  class ps {
  }
  ps.CABLE = { type: 3, value: "CABLE" }, ps.CABLECARRIER = { type: 3, value: "CABLECARRIER" }, ps.DUCT = { type: 3, value: "DUCT" }, ps.PIPE = { type: 3, value: "PIPE" }, ps.WIRELESS = { type: 3, value: "WIRELESS" }, ps.USERDEFINED = { type: 3, value: "USERDEFINED" }, ps.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionPortTypeEnum = ps;
  class Tr {
  }
  Tr.AIRCONDITIONING = { type: 3, value: "AIRCONDITIONING" }, Tr.AUDIOVISUAL = { type: 3, value: "AUDIOVISUAL" }, Tr.CATENARY_SYSTEM = { type: 3, value: "CATENARY_SYSTEM" }, Tr.CHEMICAL = { type: 3, value: "CHEMICAL" }, Tr.CHILLEDWATER = { type: 3, value: "CHILLEDWATER" }, Tr.COMMUNICATION = { type: 3, value: "COMMUNICATION" }, Tr.COMPRESSEDAIR = { type: 3, value: "COMPRESSEDAIR" }, Tr.CONDENSERWATER = { type: 3, value: "CONDENSERWATER" }, Tr.CONTROL = { type: 3, value: "CONTROL" }, Tr.CONVEYING = { type: 3, value: "CONVEYING" }, Tr.DATA = { type: 3, value: "DATA" }, Tr.DISPOSAL = { type: 3, value: "DISPOSAL" }, Tr.DOMESTICCOLDWATER = { type: 3, value: "DOMESTICCOLDWATER" }, Tr.DOMESTICHOTWATER = { type: 3, value: "DOMESTICHOTWATER" }, Tr.DRAINAGE = { type: 3, value: "DRAINAGE" }, Tr.EARTHING = { type: 3, value: "EARTHING" }, Tr.ELECTRICAL = { type: 3, value: "ELECTRICAL" }, Tr.ELECTROACOUSTIC = { type: 3, value: "ELECTROACOUSTIC" }, Tr.EXHAUST = { type: 3, value: "EXHAUST" }, Tr.FIREPROTECTION = { type: 3, value: "FIREPROTECTION" }, Tr.FIXEDTRANSMISSIONNETWORK = { type: 3, value: "FIXEDTRANSMISSIONNETWORK" }, Tr.FUEL = { type: 3, value: "FUEL" }, Tr.GAS = { type: 3, value: "GAS" }, Tr.HAZARDOUS = { type: 3, value: "HAZARDOUS" }, Tr.HEATING = { type: 3, value: "HEATING" }, Tr.LIGHTING = { type: 3, value: "LIGHTING" }, Tr.LIGHTNINGPROTECTION = { type: 3, value: "LIGHTNINGPROTECTION" }, Tr.MOBILENETWORK = { type: 3, value: "MOBILENETWORK" }, Tr.MONITORINGSYSTEM = { type: 3, value: "MONITORINGSYSTEM" }, Tr.MUNICIPALSOLIDWASTE = { type: 3, value: "MUNICIPALSOLIDWASTE" }, Tr.OIL = { type: 3, value: "OIL" }, Tr.OPERATIONAL = { type: 3, value: "OPERATIONAL" }, Tr.OPERATIONALTELEPHONYSYSTEM = { type: 3, value: "OPERATIONALTELEPHONYSYSTEM" }, Tr.OVERHEAD_CONTACTLINE_SYSTEM = { type: 3, value: "OVERHEAD_CONTACTLINE_SYSTEM" }, Tr.POWERGENERATION = { type: 3, value: "POWERGENERATION" }, Tr.RAINWATER = { type: 3, value: "RAINWATER" }, Tr.REFRIGERATION = { type: 3, value: "REFRIGERATION" }, Tr.RETURN_CIRCUIT = { type: 3, value: "RETURN_CIRCUIT" }, Tr.SECURITY = { type: 3, value: "SECURITY" }, Tr.SEWAGE = { type: 3, value: "SEWAGE" }, Tr.SIGNAL = { type: 3, value: "SIGNAL" }, Tr.STORMWATER = { type: 3, value: "STORMWATER" }, Tr.TELEPHONE = { type: 3, value: "TELEPHONE" }, Tr.TV = { type: 3, value: "TV" }, Tr.VACUUM = { type: 3, value: "VACUUM" }, Tr.VENT = { type: 3, value: "VENT" }, Tr.VENTILATION = { type: 3, value: "VENTILATION" }, Tr.WASTEWATER = { type: 3, value: "WASTEWATER" }, Tr.WATERSUPPLY = { type: 3, value: "WATERSUPPLY" }, Tr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Tr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDistributionSystemEnum = Tr;
  class ao {
  }
  ao.CONFIDENTIAL = { type: 3, value: "CONFIDENTIAL" }, ao.PERSONAL = { type: 3, value: "PERSONAL" }, ao.PUBLIC = { type: 3, value: "PUBLIC" }, ao.RESTRICTED = { type: 3, value: "RESTRICTED" }, ao.USERDEFINED = { type: 3, value: "USERDEFINED" }, ao.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentConfidentialityEnum = ao;
  class Gt {
  }
  Gt.DRAFT = { type: 3, value: "DRAFT" }, Gt.FINAL = { type: 3, value: "FINAL" }, Gt.FINALDRAFT = { type: 3, value: "FINALDRAFT" }, Gt.REVISION = { type: 3, value: "REVISION" }, Gt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDocumentStatusEnum = Gt;
  class sr {
  }
  sr.DOUBLE_ACTING = { type: 3, value: "DOUBLE_ACTING" }, sr.FIXEDPANEL = { type: 3, value: "FIXEDPANEL" }, sr.FOLDING = { type: 3, value: "FOLDING" }, sr.REVOLVING = { type: 3, value: "REVOLVING" }, sr.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, sr.SLIDING = { type: 3, value: "SLIDING" }, sr.SWINGING = { type: 3, value: "SWINGING" }, sr.USERDEFINED = { type: 3, value: "USERDEFINED" }, sr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelOperationEnum = sr;
  class vt {
  }
  vt.LEFT = { type: 3, value: "LEFT" }, vt.MIDDLE = { type: 3, value: "MIDDLE" }, vt.RIGHT = { type: 3, value: "RIGHT" }, vt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorPanelPositionEnum = vt;
  class Jr {
  }
  Jr.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, Jr.ALUMINIUM_PLASTIC = { type: 3, value: "ALUMINIUM_PLASTIC" }, Jr.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, Jr.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, Jr.PLASTIC = { type: 3, value: "PLASTIC" }, Jr.STEEL = { type: 3, value: "STEEL" }, Jr.WOOD = { type: 3, value: "WOOD" }, Jr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleConstructionEnum = Jr;
  class Qs {
  }
  Qs.DOUBLE_DOOR_DOUBLE_SWING = { type: 3, value: "DOUBLE_DOOR_DOUBLE_SWING" }, Qs.DOUBLE_DOOR_FOLDING = { type: 3, value: "DOUBLE_DOOR_FOLDING" }, Qs.DOUBLE_DOOR_SINGLE_SWING = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING" }, Qs.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT" }, Qs.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT" }, Qs.DOUBLE_DOOR_SLIDING = { type: 3, value: "DOUBLE_DOOR_SLIDING" }, Qs.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Qs.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Qs.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Qs.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Qs.REVOLVING = { type: 3, value: "REVOLVING" }, Qs.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Qs.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Qs.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Qs.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Qs.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Qs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorStyleOperationEnum = Qs;
  class Ds {
  }
  Ds.BOOM_BARRIER = { type: 3, value: "BOOM_BARRIER" }, Ds.DOOR = { type: 3, value: "DOOR" }, Ds.GATE = { type: 3, value: "GATE" }, Ds.TRAPDOOR = { type: 3, value: "TRAPDOOR" }, Ds.TURNSTILE = { type: 3, value: "TURNSTILE" }, Ds.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ds.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorTypeEnum = Ds;
  class Hs {
  }
  Hs.DOUBLE_PANEL_DOUBLE_SWING = { type: 3, value: "DOUBLE_PANEL_DOUBLE_SWING" }, Hs.DOUBLE_PANEL_FOLDING = { type: 3, value: "DOUBLE_PANEL_FOLDING" }, Hs.DOUBLE_PANEL_LIFTING_VERTICAL = { type: 3, value: "DOUBLE_PANEL_LIFTING_VERTICAL" }, Hs.DOUBLE_PANEL_SINGLE_SWING = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING" }, Hs.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT" }, Hs.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT = { type: 3, value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT" }, Hs.DOUBLE_PANEL_SLIDING = { type: 3, value: "DOUBLE_PANEL_SLIDING" }, Hs.DOUBLE_SWING_LEFT = { type: 3, value: "DOUBLE_SWING_LEFT" }, Hs.DOUBLE_SWING_RIGHT = { type: 3, value: "DOUBLE_SWING_RIGHT" }, Hs.FOLDING_TO_LEFT = { type: 3, value: "FOLDING_TO_LEFT" }, Hs.FOLDING_TO_RIGHT = { type: 3, value: "FOLDING_TO_RIGHT" }, Hs.LIFTING_HORIZONTAL = { type: 3, value: "LIFTING_HORIZONTAL" }, Hs.LIFTING_VERTICAL_LEFT = { type: 3, value: "LIFTING_VERTICAL_LEFT" }, Hs.LIFTING_VERTICAL_RIGHT = { type: 3, value: "LIFTING_VERTICAL_RIGHT" }, Hs.REVOLVING_HORIZONTAL = { type: 3, value: "REVOLVING_HORIZONTAL" }, Hs.REVOLVING_VERTICAL = { type: 3, value: "REVOLVING_VERTICAL" }, Hs.ROLLINGUP = { type: 3, value: "ROLLINGUP" }, Hs.SINGLE_SWING_LEFT = { type: 3, value: "SINGLE_SWING_LEFT" }, Hs.SINGLE_SWING_RIGHT = { type: 3, value: "SINGLE_SWING_RIGHT" }, Hs.SLIDING_TO_LEFT = { type: 3, value: "SLIDING_TO_LEFT" }, Hs.SLIDING_TO_RIGHT = { type: 3, value: "SLIDING_TO_RIGHT" }, Hs.SWING_FIXED_LEFT = { type: 3, value: "SWING_FIXED_LEFT" }, Hs.SWING_FIXED_RIGHT = { type: 3, value: "SWING_FIXED_RIGHT" }, Hs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDoorTypeOperationEnum = Hs;
  class Xr {
  }
  Xr.BEND = { type: 3, value: "BEND" }, Xr.CONNECTOR = { type: 3, value: "CONNECTOR" }, Xr.ENTRY = { type: 3, value: "ENTRY" }, Xr.EXIT = { type: 3, value: "EXIT" }, Xr.JUNCTION = { type: 3, value: "JUNCTION" }, Xr.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, Xr.TRANSITION = { type: 3, value: "TRANSITION" }, Xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctFittingTypeEnum = Xr;
  class bi {
  }
  bi.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, bi.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, bi.USERDEFINED = { type: 3, value: "USERDEFINED" }, bi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSegmentTypeEnum = bi;
  class rn {
  }
  rn.FLATOVAL = { type: 3, value: "FLATOVAL" }, rn.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, rn.ROUND = { type: 3, value: "ROUND" }, rn.USERDEFINED = { type: 3, value: "USERDEFINED" }, rn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcDuctSilencerTypeEnum = rn;
  class mo {
  }
  mo.BASE_EXCAVATION = { type: 3, value: "BASE_EXCAVATION" }, mo.CUT = { type: 3, value: "CUT" }, mo.DREDGING = { type: 3, value: "DREDGING" }, mo.EXCAVATION = { type: 3, value: "EXCAVATION" }, mo.OVEREXCAVATION = { type: 3, value: "OVEREXCAVATION" }, mo.PAVEMENTMILLING = { type: 3, value: "PAVEMENTMILLING" }, mo.STEPEXCAVATION = { type: 3, value: "STEPEXCAVATION" }, mo.TOPSOILREMOVAL = { type: 3, value: "TOPSOILREMOVAL" }, mo.TRENCH = { type: 3, value: "TRENCH" }, mo.USERDEFINED = { type: 3, value: "USERDEFINED" }, mo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEarthworksCutTypeEnum = mo;
  class Gi {
  }
  Gi.BACKFILL = { type: 3, value: "BACKFILL" }, Gi.COUNTERWEIGHT = { type: 3, value: "COUNTERWEIGHT" }, Gi.EMBANKMENT = { type: 3, value: "EMBANKMENT" }, Gi.SLOPEFILL = { type: 3, value: "SLOPEFILL" }, Gi.SUBGRADE = { type: 3, value: "SUBGRADE" }, Gi.SUBGRADEBED = { type: 3, value: "SUBGRADEBED" }, Gi.TRANSITIONSECTION = { type: 3, value: "TRANSITIONSECTION" }, Gi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEarthworksFillTypeEnum = Gi;
  class yo {
  }
  yo.DISHWASHER = { type: 3, value: "DISHWASHER" }, yo.ELECTRICCOOKER = { type: 3, value: "ELECTRICCOOKER" }, yo.FREESTANDINGELECTRICHEATER = { type: 3, value: "FREESTANDINGELECTRICHEATER" }, yo.FREESTANDINGFAN = { type: 3, value: "FREESTANDINGFAN" }, yo.FREESTANDINGWATERCOOLER = { type: 3, value: "FREESTANDINGWATERCOOLER" }, yo.FREESTANDINGWATERHEATER = { type: 3, value: "FREESTANDINGWATERHEATER" }, yo.FREEZER = { type: 3, value: "FREEZER" }, yo.FRIDGE_FREEZER = { type: 3, value: "FRIDGE_FREEZER" }, yo.HANDDRYER = { type: 3, value: "HANDDRYER" }, yo.KITCHENMACHINE = { type: 3, value: "KITCHENMACHINE" }, yo.MICROWAVE = { type: 3, value: "MICROWAVE" }, yo.PHOTOCOPIER = { type: 3, value: "PHOTOCOPIER" }, yo.REFRIGERATOR = { type: 3, value: "REFRIGERATOR" }, yo.TUMBLEDRYER = { type: 3, value: "TUMBLEDRYER" }, yo.VENDINGMACHINE = { type: 3, value: "VENDINGMACHINE" }, yo.WASHINGMACHINE = { type: 3, value: "WASHINGMACHINE" }, yo.USERDEFINED = { type: 3, value: "USERDEFINED" }, yo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricApplianceTypeEnum = yo;
  class ci {
  }
  ci.CONSUMERUNIT = { type: 3, value: "CONSUMERUNIT" }, ci.DISTRIBUTIONBOARD = { type: 3, value: "DISTRIBUTIONBOARD" }, ci.MOTORCONTROLCENTRE = { type: 3, value: "MOTORCONTROLCENTRE" }, ci.SWITCHBOARD = { type: 3, value: "SWITCHBOARD" }, ci.USERDEFINED = { type: 3, value: "USERDEFINED" }, ci.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricDistributionBoardTypeEnum = ci;
  class Ri {
  }
  Ri.BATTERY = { type: 3, value: "BATTERY" }, Ri.CAPACITOR = { type: 3, value: "CAPACITOR" }, Ri.CAPACITORBANK = { type: 3, value: "CAPACITORBANK" }, Ri.COMPENSATOR = { type: 3, value: "COMPENSATOR" }, Ri.HARMONICFILTER = { type: 3, value: "HARMONICFILTER" }, Ri.INDUCTOR = { type: 3, value: "INDUCTOR" }, Ri.INDUCTORBANK = { type: 3, value: "INDUCTORBANK" }, Ri.RECHARGER = { type: 3, value: "RECHARGER" }, Ri.UPS = { type: 3, value: "UPS" }, Ri.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ri.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricFlowStorageDeviceTypeEnum = Ri;
  class ms {
  }
  ms.ELECTRONICFILTER = { type: 3, value: "ELECTRONICFILTER" }, ms.USERDEFINED = { type: 3, value: "USERDEFINED" }, ms.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricFlowTreatmentDeviceTypeEnum = ms;
  class zt {
  }
  zt.CHP = { type: 3, value: "CHP" }, zt.ENGINEGENERATOR = { type: 3, value: "ENGINEGENERATOR" }, zt.STANDALONE = { type: 3, value: "STANDALONE" }, zt.USERDEFINED = { type: 3, value: "USERDEFINED" }, zt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricGeneratorTypeEnum = zt;
  class fn {
  }
  fn.DC = { type: 3, value: "DC" }, fn.INDUCTION = { type: 3, value: "INDUCTION" }, fn.POLYPHASE = { type: 3, value: "POLYPHASE" }, fn.RELUCTANCESYNCHRONOUS = { type: 3, value: "RELUCTANCESYNCHRONOUS" }, fn.SYNCHRONOUS = { type: 3, value: "SYNCHRONOUS" }, fn.USERDEFINED = { type: 3, value: "USERDEFINED" }, fn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricMotorTypeEnum = fn;
  class Bn {
  }
  Bn.RELAY = { type: 3, value: "RELAY" }, Bn.TIMECLOCK = { type: 3, value: "TIMECLOCK" }, Bn.TIMEDELAY = { type: 3, value: "TIMEDELAY" }, Bn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElectricTimeControlTypeEnum = Bn;
  class or {
  }
  or.ABUTMENT = { type: 3, value: "ABUTMENT" }, or.ACCESSORY_ASSEMBLY = { type: 3, value: "ACCESSORY_ASSEMBLY" }, or.ARCH = { type: 3, value: "ARCH" }, or.BEAM_GRID = { type: 3, value: "BEAM_GRID" }, or.BRACED_FRAME = { type: 3, value: "BRACED_FRAME" }, or.CROSS_BRACING = { type: 3, value: "CROSS_BRACING" }, or.DECK = { type: 3, value: "DECK" }, or.DILATATIONPANEL = { type: 3, value: "DILATATIONPANEL" }, or.ENTRANCEWORKS = { type: 3, value: "ENTRANCEWORKS" }, or.GIRDER = { type: 3, value: "GIRDER" }, or.GRID = { type: 3, value: "GRID" }, or.MAST = { type: 3, value: "MAST" }, or.PIER = { type: 3, value: "PIER" }, or.PYLON = { type: 3, value: "PYLON" }, or.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = { type: 3, value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY" }, or.REINFORCEMENT_UNIT = { type: 3, value: "REINFORCEMENT_UNIT" }, or.RIGID_FRAME = { type: 3, value: "RIGID_FRAME" }, or.SHELTER = { type: 3, value: "SHELTER" }, or.SIGNALASSEMBLY = { type: 3, value: "SIGNALASSEMBLY" }, or.SLAB_FIELD = { type: 3, value: "SLAB_FIELD" }, or.SUMPBUSTER = { type: 3, value: "SUMPBUSTER" }, or.SUPPORTINGASSEMBLY = { type: 3, value: "SUPPORTINGASSEMBLY" }, or.SUSPENSIONASSEMBLY = { type: 3, value: "SUSPENSIONASSEMBLY" }, or.TRACKPANEL = { type: 3, value: "TRACKPANEL" }, or.TRACTION_SWITCHING_ASSEMBLY = { type: 3, value: "TRACTION_SWITCHING_ASSEMBLY" }, or.TRAFFIC_CALMING_DEVICE = { type: 3, value: "TRAFFIC_CALMING_DEVICE" }, or.TRUSS = { type: 3, value: "TRUSS" }, or.TURNOUTPANEL = { type: 3, value: "TURNOUTPANEL" }, or.USERDEFINED = { type: 3, value: "USERDEFINED" }, or.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcElementAssemblyTypeEnum = or;
  class ss {
  }
  ss.COMPLEX = { type: 3, value: "COMPLEX" }, ss.ELEMENT = { type: 3, value: "ELEMENT" }, ss.PARTIAL = { type: 3, value: "PARTIAL" }, r.IfcElementCompositionEnum = ss;
  class Xs {
  }
  Xs.EXTERNALCOMBUSTION = { type: 3, value: "EXTERNALCOMBUSTION" }, Xs.INTERNALCOMBUSTION = { type: 3, value: "INTERNALCOMBUSTION" }, Xs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEngineTypeEnum = Xs;
  class Fo {
  }
  Fo.DIRECTEVAPORATIVEAIRWASHER = { type: 3, value: "DIRECTEVAPORATIVEAIRWASHER" }, Fo.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER" }, Fo.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER" }, Fo.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER" }, Fo.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = { type: 3, value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER" }, Fo.INDIRECTDIRECTCOMBINATION = { type: 3, value: "INDIRECTDIRECTCOMBINATION" }, Fo.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = { type: 3, value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER" }, Fo.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = { type: 3, value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER" }, Fo.INDIRECTEVAPORATIVEWETCOIL = { type: 3, value: "INDIRECTEVAPORATIVEWETCOIL" }, Fo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporativeCoolerTypeEnum = Fo;
  class ji {
  }
  ji.DIRECTEXPANSION = { type: 3, value: "DIRECTEXPANSION" }, ji.DIRECTEXPANSIONBRAZEDPLATE = { type: 3, value: "DIRECTEXPANSIONBRAZEDPLATE" }, ji.DIRECTEXPANSIONSHELLANDTUBE = { type: 3, value: "DIRECTEXPANSIONSHELLANDTUBE" }, ji.DIRECTEXPANSIONTUBEINTUBE = { type: 3, value: "DIRECTEXPANSIONTUBEINTUBE" }, ji.FLOODEDSHELLANDTUBE = { type: 3, value: "FLOODEDSHELLANDTUBE" }, ji.SHELLANDCOIL = { type: 3, value: "SHELLANDCOIL" }, ji.USERDEFINED = { type: 3, value: "USERDEFINED" }, ji.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEvaporatorTypeEnum = ji;
  class zo {
  }
  zo.EVENTCOMPLEX = { type: 3, value: "EVENTCOMPLEX" }, zo.EVENTMESSAGE = { type: 3, value: "EVENTMESSAGE" }, zo.EVENTRULE = { type: 3, value: "EVENTRULE" }, zo.EVENTTIME = { type: 3, value: "EVENTTIME" }, zo.USERDEFINED = { type: 3, value: "USERDEFINED" }, zo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEventTriggerTypeEnum = zo;
  class Yi {
  }
  Yi.ENDEVENT = { type: 3, value: "ENDEVENT" }, Yi.INTERMEDIATEEVENT = { type: 3, value: "INTERMEDIATEEVENT" }, Yi.STARTEVENT = { type: 3, value: "STARTEVENT" }, Yi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Yi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcEventTypeEnum = Yi;
  class Li {
  }
  Li.EXTERNAL = { type: 3, value: "EXTERNAL" }, Li.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, Li.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, Li.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, Li.USERDEFINED = { type: 3, value: "USERDEFINED" }, Li.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcExternalSpatialElementTypeEnum = Li;
  class _i {
  }
  _i.ABOVEGROUND = { type: 3, value: "ABOVEGROUND" }, _i.BELOWGROUND = { type: 3, value: "BELOWGROUND" }, _i.JUNCTION = { type: 3, value: "JUNCTION" }, _i.LEVELCROSSING = { type: 3, value: "LEVELCROSSING" }, _i.SEGMENT = { type: 3, value: "SEGMENT" }, _i.SUBSTRUCTURE = { type: 3, value: "SUBSTRUCTURE" }, _i.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, _i.TERMINAL = { type: 3, value: "TERMINAL" }, _i.USERDEFINED = { type: 3, value: "USERDEFINED" }, _i.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFacilityPartCommonTypeEnum = _i;
  class pa {
  }
  pa.LATERAL = { type: 3, value: "LATERAL" }, pa.LONGITUDINAL = { type: 3, value: "LONGITUDINAL" }, pa.REGION = { type: 3, value: "REGION" }, pa.VERTICAL = { type: 3, value: "VERTICAL" }, pa.USERDEFINED = { type: 3, value: "USERDEFINED" }, pa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFacilityUsageEnum = pa;
  class $o {
  }
  $o.CENTRIFUGALAIRFOIL = { type: 3, value: "CENTRIFUGALAIRFOIL" }, $o.CENTRIFUGALBACKWARDINCLINEDCURVED = { type: 3, value: "CENTRIFUGALBACKWARDINCLINEDCURVED" }, $o.CENTRIFUGALFORWARDCURVED = { type: 3, value: "CENTRIFUGALFORWARDCURVED" }, $o.CENTRIFUGALRADIAL = { type: 3, value: "CENTRIFUGALRADIAL" }, $o.PROPELLORAXIAL = { type: 3, value: "PROPELLORAXIAL" }, $o.TUBEAXIAL = { type: 3, value: "TUBEAXIAL" }, $o.VANEAXIAL = { type: 3, value: "VANEAXIAL" }, $o.USERDEFINED = { type: 3, value: "USERDEFINED" }, $o.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFanTypeEnum = $o;
  class wo {
  }
  wo.GLUE = { type: 3, value: "GLUE" }, wo.MORTAR = { type: 3, value: "MORTAR" }, wo.WELD = { type: 3, value: "WELD" }, wo.USERDEFINED = { type: 3, value: "USERDEFINED" }, wo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFastenerTypeEnum = wo;
  class Ks {
  }
  Ks.AIRPARTICLEFILTER = { type: 3, value: "AIRPARTICLEFILTER" }, Ks.COMPRESSEDAIRFILTER = { type: 3, value: "COMPRESSEDAIRFILTER" }, Ks.ODORFILTER = { type: 3, value: "ODORFILTER" }, Ks.OILFILTER = { type: 3, value: "OILFILTER" }, Ks.STRAINER = { type: 3, value: "STRAINER" }, Ks.WATERFILTER = { type: 3, value: "WATERFILTER" }, Ks.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ks.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFilterTypeEnum = Ks;
  class Qo {
  }
  Qo.BREECHINGINLET = { type: 3, value: "BREECHINGINLET" }, Qo.FIREHYDRANT = { type: 3, value: "FIREHYDRANT" }, Qo.FIREMONITOR = { type: 3, value: "FIREMONITOR" }, Qo.HOSEREEL = { type: 3, value: "HOSEREEL" }, Qo.SPRINKLER = { type: 3, value: "SPRINKLER" }, Qo.SPRINKLERDEFLECTOR = { type: 3, value: "SPRINKLERDEFLECTOR" }, Qo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFireSuppressionTerminalTypeEnum = Qo;
  class pi {
  }
  pi.SINK = { type: 3, value: "SINK" }, pi.SOURCE = { type: 3, value: "SOURCE" }, pi.SOURCEANDSINK = { type: 3, value: "SOURCEANDSINK" }, pi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowDirectionEnum = pi;
  class Ns {
  }
  Ns.AMMETER = { type: 3, value: "AMMETER" }, Ns.COMBINED = { type: 3, value: "COMBINED" }, Ns.FREQUENCYMETER = { type: 3, value: "FREQUENCYMETER" }, Ns.PHASEANGLEMETER = { type: 3, value: "PHASEANGLEMETER" }, Ns.POWERFACTORMETER = { type: 3, value: "POWERFACTORMETER" }, Ns.PRESSUREGAUGE = { type: 3, value: "PRESSUREGAUGE" }, Ns.THERMOMETER = { type: 3, value: "THERMOMETER" }, Ns.VOLTMETER = { type: 3, value: "VOLTMETER" }, Ns.VOLTMETER_PEAK = { type: 3, value: "VOLTMETER_PEAK" }, Ns.VOLTMETER_RMS = { type: 3, value: "VOLTMETER_RMS" }, Ns.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ns.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowInstrumentTypeEnum = Ns;
  class Fi {
  }
  Fi.ENERGYMETER = { type: 3, value: "ENERGYMETER" }, Fi.GASMETER = { type: 3, value: "GASMETER" }, Fi.OILMETER = { type: 3, value: "OILMETER" }, Fi.WATERMETER = { type: 3, value: "WATERMETER" }, Fi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFlowMeterTypeEnum = Fi;
  class la {
  }
  la.CAISSON_FOUNDATION = { type: 3, value: "CAISSON_FOUNDATION" }, la.FOOTING_BEAM = { type: 3, value: "FOOTING_BEAM" }, la.PAD_FOOTING = { type: 3, value: "PAD_FOOTING" }, la.PILE_CAP = { type: 3, value: "PILE_CAP" }, la.STRIP_FOOTING = { type: 3, value: "STRIP_FOOTING" }, la.USERDEFINED = { type: 3, value: "USERDEFINED" }, la.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFootingTypeEnum = la;
  class Ho {
  }
  Ho.BED = { type: 3, value: "BED" }, Ho.CHAIR = { type: 3, value: "CHAIR" }, Ho.DESK = { type: 3, value: "DESK" }, Ho.FILECABINET = { type: 3, value: "FILECABINET" }, Ho.SHELF = { type: 3, value: "SHELF" }, Ho.SOFA = { type: 3, value: "SOFA" }, Ho.TABLE = { type: 3, value: "TABLE" }, Ho.TECHNICALCABINET = { type: 3, value: "TECHNICALCABINET" }, Ho.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ho.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcFurnitureTypeEnum = Ho;
  class Ye {
  }
  Ye.SOIL_BORING_POINT = { type: 3, value: "SOIL_BORING_POINT" }, Ye.TERRAIN = { type: 3, value: "TERRAIN" }, Ye.VEGETATION = { type: 3, value: "VEGETATION" }, Ye.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ye.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeographicElementTypeEnum = Ye;
  class qe {
  }
  qe.ELEVATION_VIEW = { type: 3, value: "ELEVATION_VIEW" }, qe.GRAPH_VIEW = { type: 3, value: "GRAPH_VIEW" }, qe.MODEL_VIEW = { type: 3, value: "MODEL_VIEW" }, qe.PLAN_VIEW = { type: 3, value: "PLAN_VIEW" }, qe.REFLECTED_PLAN_VIEW = { type: 3, value: "REFLECTED_PLAN_VIEW" }, qe.SECTION_VIEW = { type: 3, value: "SECTION_VIEW" }, qe.SKETCH_VIEW = { type: 3, value: "SKETCH_VIEW" }, qe.USERDEFINED = { type: 3, value: "USERDEFINED" }, qe.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeometricProjectionEnum = qe;
  class Nt {
  }
  Nt.SOLID = { type: 3, value: "SOLID" }, Nt.VOID = { type: 3, value: "VOID" }, Nt.WATER = { type: 3, value: "WATER" }, Nt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Nt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGeotechnicalStratumTypeEnum = Nt;
  class mt {
  }
  mt.GLOBAL_COORDS = { type: 3, value: "GLOBAL_COORDS" }, mt.LOCAL_COORDS = { type: 3, value: "LOCAL_COORDS" }, r.IfcGlobalOrLocalEnum = mt;
  class pn {
  }
  pn.IRREGULAR = { type: 3, value: "IRREGULAR" }, pn.RADIAL = { type: 3, value: "RADIAL" }, pn.RECTANGULAR = { type: 3, value: "RECTANGULAR" }, pn.TRIANGULAR = { type: 3, value: "TRIANGULAR" }, pn.USERDEFINED = { type: 3, value: "USERDEFINED" }, pn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcGridTypeEnum = pn;
  class Mt {
  }
  Mt.PLATE = { type: 3, value: "PLATE" }, Mt.SHELLANDTUBE = { type: 3, value: "SHELLANDTUBE" }, Mt.TURNOUTHEATING = { type: 3, value: "TURNOUTHEATING" }, Mt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Mt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHeatExchangerTypeEnum = Mt;
  class Ln {
  }
  Ln.ADIABATICAIRWASHER = { type: 3, value: "ADIABATICAIRWASHER" }, Ln.ADIABATICATOMIZING = { type: 3, value: "ADIABATICATOMIZING" }, Ln.ADIABATICCOMPRESSEDAIRNOZZLE = { type: 3, value: "ADIABATICCOMPRESSEDAIRNOZZLE" }, Ln.ADIABATICPAN = { type: 3, value: "ADIABATICPAN" }, Ln.ADIABATICRIGIDMEDIA = { type: 3, value: "ADIABATICRIGIDMEDIA" }, Ln.ADIABATICULTRASONIC = { type: 3, value: "ADIABATICULTRASONIC" }, Ln.ADIABATICWETTEDELEMENT = { type: 3, value: "ADIABATICWETTEDELEMENT" }, Ln.ASSISTEDBUTANE = { type: 3, value: "ASSISTEDBUTANE" }, Ln.ASSISTEDELECTRIC = { type: 3, value: "ASSISTEDELECTRIC" }, Ln.ASSISTEDNATURALGAS = { type: 3, value: "ASSISTEDNATURALGAS" }, Ln.ASSISTEDPROPANE = { type: 3, value: "ASSISTEDPROPANE" }, Ln.ASSISTEDSTEAM = { type: 3, value: "ASSISTEDSTEAM" }, Ln.STEAMINJECTION = { type: 3, value: "STEAMINJECTION" }, Ln.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ln.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcHumidifierTypeEnum = Ln;
  class ot {
  }
  ot.BUMPER = { type: 3, value: "BUMPER" }, ot.CRASHCUSHION = { type: 3, value: "CRASHCUSHION" }, ot.DAMPINGSYSTEM = { type: 3, value: "DAMPINGSYSTEM" }, ot.FENDER = { type: 3, value: "FENDER" }, ot.USERDEFINED = { type: 3, value: "USERDEFINED" }, ot.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcImpactProtectionDeviceTypeEnum = ot;
  class Xt {
  }
  Xt.CYCLONIC = { type: 3, value: "CYCLONIC" }, Xt.GREASE = { type: 3, value: "GREASE" }, Xt.OIL = { type: 3, value: "OIL" }, Xt.PETROL = { type: 3, value: "PETROL" }, Xt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInterceptorTypeEnum = Xt;
  class sn {
  }
  sn.EXTERNAL = { type: 3, value: "EXTERNAL" }, sn.EXTERNAL_EARTH = { type: 3, value: "EXTERNAL_EARTH" }, sn.EXTERNAL_FIRE = { type: 3, value: "EXTERNAL_FIRE" }, sn.EXTERNAL_WATER = { type: 3, value: "EXTERNAL_WATER" }, sn.INTERNAL = { type: 3, value: "INTERNAL" }, sn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInternalOrExternalEnum = sn;
  class dn {
  }
  dn.ASSETINVENTORY = { type: 3, value: "ASSETINVENTORY" }, dn.FURNITUREINVENTORY = { type: 3, value: "FURNITUREINVENTORY" }, dn.SPACEINVENTORY = { type: 3, value: "SPACEINVENTORY" }, dn.USERDEFINED = { type: 3, value: "USERDEFINED" }, dn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcInventoryTypeEnum = dn;
  class Ar {
  }
  Ar.DATA = { type: 3, value: "DATA" }, Ar.POWER = { type: 3, value: "POWER" }, Ar.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ar.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcJunctionBoxTypeEnum = Ar;
  class yr {
  }
  yr.PIECEWISE_BEZIER_KNOTS = { type: 3, value: "PIECEWISE_BEZIER_KNOTS" }, yr.QUASI_UNIFORM_KNOTS = { type: 3, value: "QUASI_UNIFORM_KNOTS" }, yr.UNIFORM_KNOTS = { type: 3, value: "UNIFORM_KNOTS" }, yr.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcKnotType = yr;
  class Pr {
  }
  Pr.ADMINISTRATION = { type: 3, value: "ADMINISTRATION" }, Pr.CARPENTRY = { type: 3, value: "CARPENTRY" }, Pr.CLEANING = { type: 3, value: "CLEANING" }, Pr.CONCRETE = { type: 3, value: "CONCRETE" }, Pr.DRYWALL = { type: 3, value: "DRYWALL" }, Pr.ELECTRIC = { type: 3, value: "ELECTRIC" }, Pr.FINISHING = { type: 3, value: "FINISHING" }, Pr.FLOORING = { type: 3, value: "FLOORING" }, Pr.GENERAL = { type: 3, value: "GENERAL" }, Pr.HVAC = { type: 3, value: "HVAC" }, Pr.LANDSCAPING = { type: 3, value: "LANDSCAPING" }, Pr.MASONRY = { type: 3, value: "MASONRY" }, Pr.PAINTING = { type: 3, value: "PAINTING" }, Pr.PAVING = { type: 3, value: "PAVING" }, Pr.PLUMBING = { type: 3, value: "PLUMBING" }, Pr.ROOFING = { type: 3, value: "ROOFING" }, Pr.SITEGRADING = { type: 3, value: "SITEGRADING" }, Pr.STEELWORK = { type: 3, value: "STEELWORK" }, Pr.SURVEYING = { type: 3, value: "SURVEYING" }, Pr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLaborResourceTypeEnum = Pr;
  class Zr {
  }
  Zr.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, Zr.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, Zr.HALOGEN = { type: 3, value: "HALOGEN" }, Zr.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, Zr.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, Zr.LED = { type: 3, value: "LED" }, Zr.METALHALIDE = { type: 3, value: "METALHALIDE" }, Zr.OLED = { type: 3, value: "OLED" }, Zr.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, Zr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Zr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLampTypeEnum = Zr;
  class qs {
  }
  qs.AXIS1 = { type: 3, value: "AXIS1" }, qs.AXIS2 = { type: 3, value: "AXIS2" }, qs.AXIS3 = { type: 3, value: "AXIS3" }, r.IfcLayerSetDirectionEnum = qs;
  class Ws {
  }
  Ws.TYPE_A = { type: 3, value: "TYPE_A" }, Ws.TYPE_B = { type: 3, value: "TYPE_B" }, Ws.TYPE_C = { type: 3, value: "TYPE_C" }, Ws.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightDistributionCurveEnum = Ws;
  class Bs {
  }
  Bs.COMPACTFLUORESCENT = { type: 3, value: "COMPACTFLUORESCENT" }, Bs.FLUORESCENT = { type: 3, value: "FLUORESCENT" }, Bs.HIGHPRESSUREMERCURY = { type: 3, value: "HIGHPRESSUREMERCURY" }, Bs.HIGHPRESSURESODIUM = { type: 3, value: "HIGHPRESSURESODIUM" }, Bs.LIGHTEMITTINGDIODE = { type: 3, value: "LIGHTEMITTINGDIODE" }, Bs.LOWPRESSURESODIUM = { type: 3, value: "LOWPRESSURESODIUM" }, Bs.LOWVOLTAGEHALOGEN = { type: 3, value: "LOWVOLTAGEHALOGEN" }, Bs.MAINVOLTAGEHALOGEN = { type: 3, value: "MAINVOLTAGEHALOGEN" }, Bs.METALHALIDE = { type: 3, value: "METALHALIDE" }, Bs.TUNGSTENFILAMENT = { type: 3, value: "TUNGSTENFILAMENT" }, Bs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightEmissionSourceEnum = Bs;
  class Sr {
  }
  Sr.DIRECTIONSOURCE = { type: 3, value: "DIRECTIONSOURCE" }, Sr.POINTSOURCE = { type: 3, value: "POINTSOURCE" }, Sr.SECURITYLIGHTING = { type: 3, value: "SECURITYLIGHTING" }, Sr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLightFixtureTypeEnum = Sr;
  class Wr {
  }
  Wr.HOSEREEL = { type: 3, value: "HOSEREEL" }, Wr.LOADINGARM = { type: 3, value: "LOADINGARM" }, Wr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Wr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLiquidTerminalTypeEnum = Wr;
  class lo {
  }
  lo.LOAD_CASE = { type: 3, value: "LOAD_CASE" }, lo.LOAD_COMBINATION = { type: 3, value: "LOAD_COMBINATION" }, lo.LOAD_GROUP = { type: 3, value: "LOAD_GROUP" }, lo.USERDEFINED = { type: 3, value: "USERDEFINED" }, lo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcLoadGroupTypeEnum = lo;
  class uo {
  }
  uo.LOGICALAND = { type: 3, value: "LOGICALAND" }, uo.LOGICALNOTAND = { type: 3, value: "LOGICALNOTAND" }, uo.LOGICALNOTOR = { type: 3, value: "LOGICALNOTOR" }, uo.LOGICALOR = { type: 3, value: "LOGICALOR" }, uo.LOGICALXOR = { type: 3, value: "LOGICALXOR" }, r.IfcLogicalOperatorEnum = uo;
  class Vs {
  }
  Vs.BARRIERBEACH = { type: 3, value: "BARRIERBEACH" }, Vs.BREAKWATER = { type: 3, value: "BREAKWATER" }, Vs.CANAL = { type: 3, value: "CANAL" }, Vs.DRYDOCK = { type: 3, value: "DRYDOCK" }, Vs.FLOATINGDOCK = { type: 3, value: "FLOATINGDOCK" }, Vs.HYDROLIFT = { type: 3, value: "HYDROLIFT" }, Vs.JETTY = { type: 3, value: "JETTY" }, Vs.LAUNCHRECOVERY = { type: 3, value: "LAUNCHRECOVERY" }, Vs.MARINEDEFENCE = { type: 3, value: "MARINEDEFENCE" }, Vs.NAVIGATIONALCHANNEL = { type: 3, value: "NAVIGATIONALCHANNEL" }, Vs.PORT = { type: 3, value: "PORT" }, Vs.QUAY = { type: 3, value: "QUAY" }, Vs.REVETMENT = { type: 3, value: "REVETMENT" }, Vs.SHIPLIFT = { type: 3, value: "SHIPLIFT" }, Vs.SHIPLOCK = { type: 3, value: "SHIPLOCK" }, Vs.SHIPYARD = { type: 3, value: "SHIPYARD" }, Vs.SLIPWAY = { type: 3, value: "SLIPWAY" }, Vs.WATERWAY = { type: 3, value: "WATERWAY" }, Vs.WATERWAYSHIPLIFT = { type: 3, value: "WATERWAYSHIPLIFT" }, Vs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Vs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMarineFacilityTypeEnum = Vs;
  class Gs {
  }
  Gs.ABOVEWATERLINE = { type: 3, value: "ABOVEWATERLINE" }, Gs.ANCHORAGE = { type: 3, value: "ANCHORAGE" }, Gs.APPROACHCHANNEL = { type: 3, value: "APPROACHCHANNEL" }, Gs.BELOWWATERLINE = { type: 3, value: "BELOWWATERLINE" }, Gs.BERTHINGSTRUCTURE = { type: 3, value: "BERTHINGSTRUCTURE" }, Gs.CHAMBER = { type: 3, value: "CHAMBER" }, Gs.CILL_LEVEL = { type: 3, value: "CILL_LEVEL" }, Gs.COPELEVEL = { type: 3, value: "COPELEVEL" }, Gs.CORE = { type: 3, value: "CORE" }, Gs.CREST = { type: 3, value: "CREST" }, Gs.GATEHEAD = { type: 3, value: "GATEHEAD" }, Gs.GUDINGSTRUCTURE = { type: 3, value: "GUDINGSTRUCTURE" }, Gs.HIGHWATERLINE = { type: 3, value: "HIGHWATERLINE" }, Gs.LANDFIELD = { type: 3, value: "LANDFIELD" }, Gs.LEEWARDSIDE = { type: 3, value: "LEEWARDSIDE" }, Gs.LOWWATERLINE = { type: 3, value: "LOWWATERLINE" }, Gs.MANUFACTURING = { type: 3, value: "MANUFACTURING" }, Gs.NAVIGATIONALAREA = { type: 3, value: "NAVIGATIONALAREA" }, Gs.PROTECTION = { type: 3, value: "PROTECTION" }, Gs.SHIPTRANSFER = { type: 3, value: "SHIPTRANSFER" }, Gs.STORAGEAREA = { type: 3, value: "STORAGEAREA" }, Gs.VEHICLESERVICING = { type: 3, value: "VEHICLESERVICING" }, Gs.WATERFIELD = { type: 3, value: "WATERFIELD" }, Gs.WEATHERSIDE = { type: 3, value: "WEATHERSIDE" }, Gs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Gs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMarinePartTypeEnum = Gs;
  class Ni {
  }
  Ni.ANCHORBOLT = { type: 3, value: "ANCHORBOLT" }, Ni.BOLT = { type: 3, value: "BOLT" }, Ni.CHAIN = { type: 3, value: "CHAIN" }, Ni.COUPLER = { type: 3, value: "COUPLER" }, Ni.DOWEL = { type: 3, value: "DOWEL" }, Ni.NAIL = { type: 3, value: "NAIL" }, Ni.NAILPLATE = { type: 3, value: "NAILPLATE" }, Ni.RAILFASTENING = { type: 3, value: "RAILFASTENING" }, Ni.RAILJOINT = { type: 3, value: "RAILJOINT" }, Ni.RIVET = { type: 3, value: "RIVET" }, Ni.ROPE = { type: 3, value: "ROPE" }, Ni.SCREW = { type: 3, value: "SCREW" }, Ni.SHEARCONNECTOR = { type: 3, value: "SHEARCONNECTOR" }, Ni.STAPLE = { type: 3, value: "STAPLE" }, Ni.STUDSHEARCONNECTOR = { type: 3, value: "STUDSHEARCONNECTOR" }, Ni.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ni.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMechanicalFastenerTypeEnum = Ni;
  class zi {
  }
  zi.AIRSTATION = { type: 3, value: "AIRSTATION" }, zi.FEEDAIRUNIT = { type: 3, value: "FEEDAIRUNIT" }, zi.OXYGENGENERATOR = { type: 3, value: "OXYGENGENERATOR" }, zi.OXYGENPLANT = { type: 3, value: "OXYGENPLANT" }, zi.VACUUMSTATION = { type: 3, value: "VACUUMSTATION" }, zi.USERDEFINED = { type: 3, value: "USERDEFINED" }, zi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMedicalDeviceTypeEnum = zi;
  class Ko {
  }
  Ko.ARCH_SEGMENT = { type: 3, value: "ARCH_SEGMENT" }, Ko.BRACE = { type: 3, value: "BRACE" }, Ko.CHORD = { type: 3, value: "CHORD" }, Ko.COLLAR = { type: 3, value: "COLLAR" }, Ko.MEMBER = { type: 3, value: "MEMBER" }, Ko.MULLION = { type: 3, value: "MULLION" }, Ko.PLATE = { type: 3, value: "PLATE" }, Ko.POST = { type: 3, value: "POST" }, Ko.PURLIN = { type: 3, value: "PURLIN" }, Ko.RAFTER = { type: 3, value: "RAFTER" }, Ko.STAY_CABLE = { type: 3, value: "STAY_CABLE" }, Ko.STIFFENING_RIB = { type: 3, value: "STIFFENING_RIB" }, Ko.STRINGER = { type: 3, value: "STRINGER" }, Ko.STRUCTURALCABLE = { type: 3, value: "STRUCTURALCABLE" }, Ko.STRUT = { type: 3, value: "STRUT" }, Ko.STUD = { type: 3, value: "STUD" }, Ko.SUSPENDER = { type: 3, value: "SUSPENDER" }, Ko.SUSPENSION_CABLE = { type: 3, value: "SUSPENSION_CABLE" }, Ko.TIEBAR = { type: 3, value: "TIEBAR" }, Ko.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ko.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMemberTypeEnum = Ko;
  class di {
  }
  di.ACCESSPOINT = { type: 3, value: "ACCESSPOINT" }, di.BASEBANDUNIT = { type: 3, value: "BASEBANDUNIT" }, di.BASETRANSCEIVERSTATION = { type: 3, value: "BASETRANSCEIVERSTATION" }, di.E_UTRAN_NODE_B = { type: 3, value: "E_UTRAN_NODE_B" }, di.GATEWAY_GPRS_SUPPORT_NODE = { type: 3, value: "GATEWAY_GPRS_SUPPORT_NODE" }, di.MASTERUNIT = { type: 3, value: "MASTERUNIT" }, di.MOBILESWITCHINGCENTER = { type: 3, value: "MOBILESWITCHINGCENTER" }, di.MSCSERVER = { type: 3, value: "MSCSERVER" }, di.PACKETCONTROLUNIT = { type: 3, value: "PACKETCONTROLUNIT" }, di.REMOTERADIOUNIT = { type: 3, value: "REMOTERADIOUNIT" }, di.REMOTEUNIT = { type: 3, value: "REMOTEUNIT" }, di.SERVICE_GPRS_SUPPORT_NODE = { type: 3, value: "SERVICE_GPRS_SUPPORT_NODE" }, di.SUBSCRIBERSERVER = { type: 3, value: "SUBSCRIBERSERVER" }, di.USERDEFINED = { type: 3, value: "USERDEFINED" }, di.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMobileTelecommunicationsApplianceTypeEnum = di;
  class eo {
  }
  eo.BOLLARD = { type: 3, value: "BOLLARD" }, eo.LINETENSIONER = { type: 3, value: "LINETENSIONER" }, eo.MAGNETICDEVICE = { type: 3, value: "MAGNETICDEVICE" }, eo.MOORINGHOOKS = { type: 3, value: "MOORINGHOOKS" }, eo.VACUUMDEVICE = { type: 3, value: "VACUUMDEVICE" }, eo.USERDEFINED = { type: 3, value: "USERDEFINED" }, eo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMooringDeviceTypeEnum = eo;
  class ua {
  }
  ua.BELTDRIVE = { type: 3, value: "BELTDRIVE" }, ua.COUPLING = { type: 3, value: "COUPLING" }, ua.DIRECTDRIVE = { type: 3, value: "DIRECTDRIVE" }, ua.USERDEFINED = { type: 3, value: "USERDEFINED" }, ua.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcMotorConnectionTypeEnum = ua;
  class qo {
  }
  qo.BEACON = { type: 3, value: "BEACON" }, qo.BUOY = { type: 3, value: "BUOY" }, qo.USERDEFINED = { type: 3, value: "USERDEFINED" }, qo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcNavigationElementTypeEnum = qo;
  class Mi {
  }
  Mi.ACTOR = { type: 3, value: "ACTOR" }, Mi.CONTROL = { type: 3, value: "CONTROL" }, Mi.GROUP = { type: 3, value: "GROUP" }, Mi.PROCESS = { type: 3, value: "PROCESS" }, Mi.PRODUCT = { type: 3, value: "PRODUCT" }, Mi.PROJECT = { type: 3, value: "PROJECT" }, Mi.RESOURCE = { type: 3, value: "RESOURCE" }, Mi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectTypeEnum = Mi;
  class si {
  }
  si.CODECOMPLIANCE = { type: 3, value: "CODECOMPLIANCE" }, si.CODEWAIVER = { type: 3, value: "CODEWAIVER" }, si.DESIGNINTENT = { type: 3, value: "DESIGNINTENT" }, si.EXTERNAL = { type: 3, value: "EXTERNAL" }, si.HEALTHANDSAFETY = { type: 3, value: "HEALTHANDSAFETY" }, si.MERGECONFLICT = { type: 3, value: "MERGECONFLICT" }, si.MODELVIEW = { type: 3, value: "MODELVIEW" }, si.PARAMETER = { type: 3, value: "PARAMETER" }, si.REQUIREMENT = { type: 3, value: "REQUIREMENT" }, si.SPECIFICATION = { type: 3, value: "SPECIFICATION" }, si.TRIGGERCONDITION = { type: 3, value: "TRIGGERCONDITION" }, si.USERDEFINED = { type: 3, value: "USERDEFINED" }, si.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcObjectiveEnum = si;
  class ko {
  }
  ko.ASSIGNEE = { type: 3, value: "ASSIGNEE" }, ko.ASSIGNOR = { type: 3, value: "ASSIGNOR" }, ko.LESSEE = { type: 3, value: "LESSEE" }, ko.LESSOR = { type: 3, value: "LESSOR" }, ko.LETTINGAGENT = { type: 3, value: "LETTINGAGENT" }, ko.OWNER = { type: 3, value: "OWNER" }, ko.TENANT = { type: 3, value: "TENANT" }, ko.USERDEFINED = { type: 3, value: "USERDEFINED" }, ko.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOccupantTypeEnum = ko;
  class ni {
  }
  ni.OPENING = { type: 3, value: "OPENING" }, ni.RECESS = { type: 3, value: "RECESS" }, ni.USERDEFINED = { type: 3, value: "USERDEFINED" }, ni.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOpeningElementTypeEnum = ni;
  class da {
  }
  da.AUDIOVISUALOUTLET = { type: 3, value: "AUDIOVISUALOUTLET" }, da.COMMUNICATIONSOUTLET = { type: 3, value: "COMMUNICATIONSOUTLET" }, da.DATAOUTLET = { type: 3, value: "DATAOUTLET" }, da.POWEROUTLET = { type: 3, value: "POWEROUTLET" }, da.TELEPHONEOUTLET = { type: 3, value: "TELEPHONEOUTLET" }, da.USERDEFINED = { type: 3, value: "USERDEFINED" }, da.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcOutletTypeEnum = da;
  class vi {
  }
  vi.FLEXIBLE = { type: 3, value: "FLEXIBLE" }, vi.RIGID = { type: 3, value: "RIGID" }, vi.USERDEFINED = { type: 3, value: "USERDEFINED" }, vi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPavementTypeEnum = vi;
  class fa {
  }
  fa.USERDEFINED = { type: 3, value: "USERDEFINED" }, fa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPerformanceHistoryTypeEnum = fa;
  class vo {
  }
  vo.GRILL = { type: 3, value: "GRILL" }, vo.LOUVER = { type: 3, value: "LOUVER" }, vo.SCREEN = { type: 3, value: "SCREEN" }, vo.USERDEFINED = { type: 3, value: "USERDEFINED" }, vo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPermeableCoveringOperationEnum = vo;
  class Xi {
  }
  Xi.ACCESS = { type: 3, value: "ACCESS" }, Xi.BUILDING = { type: 3, value: "BUILDING" }, Xi.WORK = { type: 3, value: "WORK" }, Xi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Xi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPermitTypeEnum = Xi;
  class gi {
  }
  gi.PHYSICAL = { type: 3, value: "PHYSICAL" }, gi.VIRTUAL = { type: 3, value: "VIRTUAL" }, gi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPhysicalOrVirtualEnum = gi;
  class Ao {
  }
  Ao.CAST_IN_PLACE = { type: 3, value: "CAST_IN_PLACE" }, Ao.COMPOSITE = { type: 3, value: "COMPOSITE" }, Ao.PRECAST_CONCRETE = { type: 3, value: "PRECAST_CONCRETE" }, Ao.PREFAB_STEEL = { type: 3, value: "PREFAB_STEEL" }, Ao.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ao.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileConstructionEnum = Ao;
  class Bi {
  }
  Bi.BORED = { type: 3, value: "BORED" }, Bi.COHESION = { type: 3, value: "COHESION" }, Bi.DRIVEN = { type: 3, value: "DRIVEN" }, Bi.FRICTION = { type: 3, value: "FRICTION" }, Bi.JETGROUTING = { type: 3, value: "JETGROUTING" }, Bi.SUPPORT = { type: 3, value: "SUPPORT" }, Bi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Bi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPileTypeEnum = Bi;
  class Ga {
  }
  Ga.BEND = { type: 3, value: "BEND" }, Ga.CONNECTOR = { type: 3, value: "CONNECTOR" }, Ga.ENTRY = { type: 3, value: "ENTRY" }, Ga.EXIT = { type: 3, value: "EXIT" }, Ga.JUNCTION = { type: 3, value: "JUNCTION" }, Ga.OBSTRUCTION = { type: 3, value: "OBSTRUCTION" }, Ga.TRANSITION = { type: 3, value: "TRANSITION" }, Ga.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ga.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeFittingTypeEnum = Ga;
  class Go {
  }
  Go.CULVERT = { type: 3, value: "CULVERT" }, Go.FLEXIBLESEGMENT = { type: 3, value: "FLEXIBLESEGMENT" }, Go.GUTTER = { type: 3, value: "GUTTER" }, Go.RIGIDSEGMENT = { type: 3, value: "RIGIDSEGMENT" }, Go.SPOOL = { type: 3, value: "SPOOL" }, Go.USERDEFINED = { type: 3, value: "USERDEFINED" }, Go.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPipeSegmentTypeEnum = Go;
  class $i {
  }
  $i.BASE_PLATE = { type: 3, value: "BASE_PLATE" }, $i.COVER_PLATE = { type: 3, value: "COVER_PLATE" }, $i.CURTAIN_PANEL = { type: 3, value: "CURTAIN_PANEL" }, $i.FLANGE_PLATE = { type: 3, value: "FLANGE_PLATE" }, $i.GUSSET_PLATE = { type: 3, value: "GUSSET_PLATE" }, $i.SHEET = { type: 3, value: "SHEET" }, $i.SPLICE_PLATE = { type: 3, value: "SPLICE_PLATE" }, $i.STIFFENER_PLATE = { type: 3, value: "STIFFENER_PLATE" }, $i.WEB_PLATE = { type: 3, value: "WEB_PLATE" }, $i.USERDEFINED = { type: 3, value: "USERDEFINED" }, $i.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPlateTypeEnum = $i;
  class Ya {
  }
  Ya.CURVE3D = { type: 3, value: "CURVE3D" }, Ya.PCURVE_S1 = { type: 3, value: "PCURVE_S1" }, Ya.PCURVE_S2 = { type: 3, value: "PCURVE_S2" }, r.IfcPreferredSurfaceCurveRepresentation = Ya;
  class Ui {
  }
  Ui.ADVICE_CAUTION = { type: 3, value: "ADVICE_CAUTION" }, Ui.ADVICE_NOTE = { type: 3, value: "ADVICE_NOTE" }, Ui.ADVICE_WARNING = { type: 3, value: "ADVICE_WARNING" }, Ui.CALIBRATION = { type: 3, value: "CALIBRATION" }, Ui.DIAGNOSTIC = { type: 3, value: "DIAGNOSTIC" }, Ui.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, Ui.STARTUP = { type: 3, value: "STARTUP" }, Ui.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ui.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProcedureTypeEnum = Ui;
  class Aa {
  }
  Aa.AREA = { type: 3, value: "AREA" }, Aa.CURVE = { type: 3, value: "CURVE" }, r.IfcProfileTypeEnum = Aa;
  class La {
  }
  La.CHANGEORDER = { type: 3, value: "CHANGEORDER" }, La.MAINTENANCEWORKORDER = { type: 3, value: "MAINTENANCEWORKORDER" }, La.MOVEORDER = { type: 3, value: "MOVEORDER" }, La.PURCHASEORDER = { type: 3, value: "PURCHASEORDER" }, La.WORKORDER = { type: 3, value: "WORKORDER" }, La.USERDEFINED = { type: 3, value: "USERDEFINED" }, La.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectOrderTypeEnum = La;
  class za {
  }
  za.PROJECTED_LENGTH = { type: 3, value: "PROJECTED_LENGTH" }, za.TRUE_LENGTH = { type: 3, value: "TRUE_LENGTH" }, r.IfcProjectedOrTrueLengthEnum = za;
  class Ta {
  }
  Ta.BLISTER = { type: 3, value: "BLISTER" }, Ta.DEVIATOR = { type: 3, value: "DEVIATOR" }, Ta.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ta.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProjectionElementTypeEnum = Ta;
  class oi {
  }
  oi.PSET_MATERIALDRIVEN = { type: 3, value: "PSET_MATERIALDRIVEN" }, oi.PSET_OCCURRENCEDRIVEN = { type: 3, value: "PSET_OCCURRENCEDRIVEN" }, oi.PSET_PERFORMANCEDRIVEN = { type: 3, value: "PSET_PERFORMANCEDRIVEN" }, oi.PSET_PROFILEDRIVEN = { type: 3, value: "PSET_PROFILEDRIVEN" }, oi.PSET_TYPEDRIVENONLY = { type: 3, value: "PSET_TYPEDRIVENONLY" }, oi.PSET_TYPEDRIVENOVERRIDE = { type: 3, value: "PSET_TYPEDRIVENOVERRIDE" }, oi.QTO_OCCURRENCEDRIVEN = { type: 3, value: "QTO_OCCURRENCEDRIVEN" }, oi.QTO_TYPEDRIVENONLY = { type: 3, value: "QTO_TYPEDRIVENONLY" }, oi.QTO_TYPEDRIVENOVERRIDE = { type: 3, value: "QTO_TYPEDRIVENOVERRIDE" }, oi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPropertySetTemplateTypeEnum = oi;
  class Na {
  }
  Na.ELECTROMAGNETIC = { type: 3, value: "ELECTROMAGNETIC" }, Na.ELECTRONIC = { type: 3, value: "ELECTRONIC" }, Na.RESIDUALCURRENT = { type: 3, value: "RESIDUALCURRENT" }, Na.THERMAL = { type: 3, value: "THERMAL" }, Na.USERDEFINED = { type: 3, value: "USERDEFINED" }, Na.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProtectiveDeviceTrippingUnitTypeEnum = Na;
  class Qi {
  }
  Qi.ANTI_ARCING_DEVICE = { type: 3, value: "ANTI_ARCING_DEVICE" }, Qi.CIRCUITBREAKER = { type: 3, value: "CIRCUITBREAKER" }, Qi.EARTHINGSWITCH = { type: 3, value: "EARTHINGSWITCH" }, Qi.EARTHLEAKAGECIRCUITBREAKER = { type: 3, value: "EARTHLEAKAGECIRCUITBREAKER" }, Qi.FUSEDISCONNECTOR = { type: 3, value: "FUSEDISCONNECTOR" }, Qi.RESIDUALCURRENTCIRCUITBREAKER = { type: 3, value: "RESIDUALCURRENTCIRCUITBREAKER" }, Qi.RESIDUALCURRENTSWITCH = { type: 3, value: "RESIDUALCURRENTSWITCH" }, Qi.SPARKGAP = { type: 3, value: "SPARKGAP" }, Qi.VARISTOR = { type: 3, value: "VARISTOR" }, Qi.VOLTAGELIMITER = { type: 3, value: "VOLTAGELIMITER" }, Qi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcProtectiveDeviceTypeEnum = Qi;
  class fi {
  }
  fi.CIRCULATOR = { type: 3, value: "CIRCULATOR" }, fi.ENDSUCTION = { type: 3, value: "ENDSUCTION" }, fi.SPLITCASE = { type: 3, value: "SPLITCASE" }, fi.SUBMERSIBLEPUMP = { type: 3, value: "SUBMERSIBLEPUMP" }, fi.SUMPPUMP = { type: 3, value: "SUMPPUMP" }, fi.VERTICALINLINE = { type: 3, value: "VERTICALINLINE" }, fi.VERTICALTURBINE = { type: 3, value: "VERTICALTURBINE" }, fi.USERDEFINED = { type: 3, value: "USERDEFINED" }, fi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcPumpTypeEnum = fi;
  class ha {
  }
  ha.BLADE = { type: 3, value: "BLADE" }, ha.CHECKRAIL = { type: 3, value: "CHECKRAIL" }, ha.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, ha.RACKRAIL = { type: 3, value: "RACKRAIL" }, ha.RAIL = { type: 3, value: "RAIL" }, ha.STOCKRAIL = { type: 3, value: "STOCKRAIL" }, ha.USERDEFINED = { type: 3, value: "USERDEFINED" }, ha.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailTypeEnum = ha;
  class ca {
  }
  ca.BALUSTRADE = { type: 3, value: "BALUSTRADE" }, ca.FENCE = { type: 3, value: "FENCE" }, ca.GUARDRAIL = { type: 3, value: "GUARDRAIL" }, ca.HANDRAIL = { type: 3, value: "HANDRAIL" }, ca.USERDEFINED = { type: 3, value: "USERDEFINED" }, ca.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailingTypeEnum = ca;
  class Ki {
  }
  Ki.DILATATIONSUPERSTRUCTURE = { type: 3, value: "DILATATIONSUPERSTRUCTURE" }, Ki.LINESIDESTRUCTURE = { type: 3, value: "LINESIDESTRUCTURE" }, Ki.LINESIDESTRUCTUREPART = { type: 3, value: "LINESIDESTRUCTUREPART" }, Ki.PLAINTRACKSUPERSTRUCTURE = { type: 3, value: "PLAINTRACKSUPERSTRUCTURE" }, Ki.SUPERSTRUCTURE = { type: 3, value: "SUPERSTRUCTURE" }, Ki.TRACKSTRUCTURE = { type: 3, value: "TRACKSTRUCTURE" }, Ki.TRACKSTRUCTUREPART = { type: 3, value: "TRACKSTRUCTUREPART" }, Ki.TURNOUTSUPERSTRUCTURE = { type: 3, value: "TURNOUTSUPERSTRUCTURE" }, Ki.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ki.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailwayPartTypeEnum = Ki;
  class Ba {
  }
  Ba.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ba.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRailwayTypeEnum = Ba;
  class je {
  }
  je.SPIRAL = { type: 3, value: "SPIRAL" }, je.STRAIGHT = { type: 3, value: "STRAIGHT" }, je.USERDEFINED = { type: 3, value: "USERDEFINED" }, je.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampFlightTypeEnum = je;
  class Je {
  }
  Je.HALF_TURN_RAMP = { type: 3, value: "HALF_TURN_RAMP" }, Je.QUARTER_TURN_RAMP = { type: 3, value: "QUARTER_TURN_RAMP" }, Je.SPIRAL_RAMP = { type: 3, value: "SPIRAL_RAMP" }, Je.STRAIGHT_RUN_RAMP = { type: 3, value: "STRAIGHT_RUN_RAMP" }, Je.TWO_QUARTER_TURN_RAMP = { type: 3, value: "TWO_QUARTER_TURN_RAMP" }, Je.TWO_STRAIGHT_RUN_RAMP = { type: 3, value: "TWO_STRAIGHT_RUN_RAMP" }, Je.USERDEFINED = { type: 3, value: "USERDEFINED" }, Je.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRampTypeEnum = Je;
  class At {
  }
  At.BY_DAY_COUNT = { type: 3, value: "BY_DAY_COUNT" }, At.BY_WEEKDAY_COUNT = { type: 3, value: "BY_WEEKDAY_COUNT" }, At.DAILY = { type: 3, value: "DAILY" }, At.MONTHLY_BY_DAY_OF_MONTH = { type: 3, value: "MONTHLY_BY_DAY_OF_MONTH" }, At.MONTHLY_BY_POSITION = { type: 3, value: "MONTHLY_BY_POSITION" }, At.WEEKLY = { type: 3, value: "WEEKLY" }, At.YEARLY_BY_DAY_OF_MONTH = { type: 3, value: "YEARLY_BY_DAY_OF_MONTH" }, At.YEARLY_BY_POSITION = { type: 3, value: "YEARLY_BY_POSITION" }, r.IfcRecurrenceTypeEnum = At;
  class qt {
  }
  qt.BOUNDARY = { type: 3, value: "BOUNDARY" }, qt.INTERSECTION = { type: 3, value: "INTERSECTION" }, qt.KILOPOINT = { type: 3, value: "KILOPOINT" }, qt.LANDMARK = { type: 3, value: "LANDMARK" }, qt.MILEPOINT = { type: 3, value: "MILEPOINT" }, qt.POSITION = { type: 3, value: "POSITION" }, qt.REFERENCEMARKER = { type: 3, value: "REFERENCEMARKER" }, qt.STATION = { type: 3, value: "STATION" }, qt.USERDEFINED = { type: 3, value: "USERDEFINED" }, qt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReferentTypeEnum = qt;
  class un {
  }
  un.BLINN = { type: 3, value: "BLINN" }, un.FLAT = { type: 3, value: "FLAT" }, un.GLASS = { type: 3, value: "GLASS" }, un.MATT = { type: 3, value: "MATT" }, un.METAL = { type: 3, value: "METAL" }, un.MIRROR = { type: 3, value: "MIRROR" }, un.PHONG = { type: 3, value: "PHONG" }, un.PHYSICAL = { type: 3, value: "PHYSICAL" }, un.PLASTIC = { type: 3, value: "PLASTIC" }, un.STRAUSS = { type: 3, value: "STRAUSS" }, un.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReflectanceMethodEnum = un;
  class An {
  }
  An.DYNAMICALLYCOMPACTED = { type: 3, value: "DYNAMICALLYCOMPACTED" }, An.GROUTED = { type: 3, value: "GROUTED" }, An.REPLACED = { type: 3, value: "REPLACED" }, An.ROLLERCOMPACTED = { type: 3, value: "ROLLERCOMPACTED" }, An.SURCHARGEPRELOADED = { type: 3, value: "SURCHARGEPRELOADED" }, An.VERTICALLYDRAINED = { type: 3, value: "VERTICALLYDRAINED" }, An.USERDEFINED = { type: 3, value: "USERDEFINED" }, An.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcedSoilTypeEnum = An;
  class Fn {
  }
  Fn.ANCHORING = { type: 3, value: "ANCHORING" }, Fn.EDGE = { type: 3, value: "EDGE" }, Fn.LIGATURE = { type: 3, value: "LIGATURE" }, Fn.MAIN = { type: 3, value: "MAIN" }, Fn.PUNCHING = { type: 3, value: "PUNCHING" }, Fn.RING = { type: 3, value: "RING" }, Fn.SHEAR = { type: 3, value: "SHEAR" }, Fn.STUD = { type: 3, value: "STUD" }, Fn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Fn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingBarRoleEnum = Fn;
  class wn {
  }
  wn.PLAIN = { type: 3, value: "PLAIN" }, wn.TEXTURED = { type: 3, value: "TEXTURED" }, r.IfcReinforcingBarSurfaceEnum = wn;
  class Hn {
  }
  Hn.ANCHORING = { type: 3, value: "ANCHORING" }, Hn.EDGE = { type: 3, value: "EDGE" }, Hn.LIGATURE = { type: 3, value: "LIGATURE" }, Hn.MAIN = { type: 3, value: "MAIN" }, Hn.PUNCHING = { type: 3, value: "PUNCHING" }, Hn.RING = { type: 3, value: "RING" }, Hn.SHEAR = { type: 3, value: "SHEAR" }, Hn.SPACEBAR = { type: 3, value: "SPACEBAR" }, Hn.STUD = { type: 3, value: "STUD" }, Hn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingBarTypeEnum = Hn;
  class Er {
  }
  Er.USERDEFINED = { type: 3, value: "USERDEFINED" }, Er.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcReinforcingMeshTypeEnum = Er;
  class Cr {
  }
  Cr.BICYCLECROSSING = { type: 3, value: "BICYCLECROSSING" }, Cr.BUS_STOP = { type: 3, value: "BUS_STOP" }, Cr.CARRIAGEWAY = { type: 3, value: "CARRIAGEWAY" }, Cr.CENTRALISLAND = { type: 3, value: "CENTRALISLAND" }, Cr.CENTRALRESERVE = { type: 3, value: "CENTRALRESERVE" }, Cr.HARDSHOULDER = { type: 3, value: "HARDSHOULDER" }, Cr.INTERSECTION = { type: 3, value: "INTERSECTION" }, Cr.LAYBY = { type: 3, value: "LAYBY" }, Cr.PARKINGBAY = { type: 3, value: "PARKINGBAY" }, Cr.PASSINGBAY = { type: 3, value: "PASSINGBAY" }, Cr.PEDESTRIAN_CROSSING = { type: 3, value: "PEDESTRIAN_CROSSING" }, Cr.RAILWAYCROSSING = { type: 3, value: "RAILWAYCROSSING" }, Cr.REFUGEISLAND = { type: 3, value: "REFUGEISLAND" }, Cr.ROADSEGMENT = { type: 3, value: "ROADSEGMENT" }, Cr.ROADSIDE = { type: 3, value: "ROADSIDE" }, Cr.ROADSIDEPART = { type: 3, value: "ROADSIDEPART" }, Cr.ROADWAYPLATEAU = { type: 3, value: "ROADWAYPLATEAU" }, Cr.ROUNDABOUT = { type: 3, value: "ROUNDABOUT" }, Cr.SHOULDER = { type: 3, value: "SHOULDER" }, Cr.SIDEWALK = { type: 3, value: "SIDEWALK" }, Cr.SOFTSHOULDER = { type: 3, value: "SOFTSHOULDER" }, Cr.TOLLPLAZA = { type: 3, value: "TOLLPLAZA" }, Cr.TRAFFICISLAND = { type: 3, value: "TRAFFICISLAND" }, Cr.TRAFFICLANE = { type: 3, value: "TRAFFICLANE" }, Cr.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRoadPartTypeEnum = Cr;
  class zr {
  }
  zr.USERDEFINED = { type: 3, value: "USERDEFINED" }, zr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRoadTypeEnum = zr;
  class hr {
  }
  hr.ARCHITECT = { type: 3, value: "ARCHITECT" }, hr.BUILDINGOPERATOR = { type: 3, value: "BUILDINGOPERATOR" }, hr.BUILDINGOWNER = { type: 3, value: "BUILDINGOWNER" }, hr.CIVILENGINEER = { type: 3, value: "CIVILENGINEER" }, hr.CLIENT = { type: 3, value: "CLIENT" }, hr.COMMISSIONINGENGINEER = { type: 3, value: "COMMISSIONINGENGINEER" }, hr.CONSTRUCTIONMANAGER = { type: 3, value: "CONSTRUCTIONMANAGER" }, hr.CONSULTANT = { type: 3, value: "CONSULTANT" }, hr.CONTRACTOR = { type: 3, value: "CONTRACTOR" }, hr.COSTENGINEER = { type: 3, value: "COSTENGINEER" }, hr.ELECTRICALENGINEER = { type: 3, value: "ELECTRICALENGINEER" }, hr.ENGINEER = { type: 3, value: "ENGINEER" }, hr.FACILITIESMANAGER = { type: 3, value: "FACILITIESMANAGER" }, hr.FIELDCONSTRUCTIONMANAGER = { type: 3, value: "FIELDCONSTRUCTIONMANAGER" }, hr.MANUFACTURER = { type: 3, value: "MANUFACTURER" }, hr.MECHANICALENGINEER = { type: 3, value: "MECHANICALENGINEER" }, hr.OWNER = { type: 3, value: "OWNER" }, hr.PROJECTMANAGER = { type: 3, value: "PROJECTMANAGER" }, hr.RESELLER = { type: 3, value: "RESELLER" }, hr.STRUCTURALENGINEER = { type: 3, value: "STRUCTURALENGINEER" }, hr.SUBCONTRACTOR = { type: 3, value: "SUBCONTRACTOR" }, hr.SUPPLIER = { type: 3, value: "SUPPLIER" }, hr.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcRoleEnum = hr;
  class xr {
  }
  xr.BARREL_ROOF = { type: 3, value: "BARREL_ROOF" }, xr.BUTTERFLY_ROOF = { type: 3, value: "BUTTERFLY_ROOF" }, xr.DOME_ROOF = { type: 3, value: "DOME_ROOF" }, xr.FLAT_ROOF = { type: 3, value: "FLAT_ROOF" }, xr.FREEFORM = { type: 3, value: "FREEFORM" }, xr.GABLE_ROOF = { type: 3, value: "GABLE_ROOF" }, xr.GAMBREL_ROOF = { type: 3, value: "GAMBREL_ROOF" }, xr.HIPPED_GABLE_ROOF = { type: 3, value: "HIPPED_GABLE_ROOF" }, xr.HIP_ROOF = { type: 3, value: "HIP_ROOF" }, xr.MANSARD_ROOF = { type: 3, value: "MANSARD_ROOF" }, xr.PAVILION_ROOF = { type: 3, value: "PAVILION_ROOF" }, xr.RAINBOW_ROOF = { type: 3, value: "RAINBOW_ROOF" }, xr.SHED_ROOF = { type: 3, value: "SHED_ROOF" }, xr.USERDEFINED = { type: 3, value: "USERDEFINED" }, xr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcRoofTypeEnum = xr;
  class Is {
  }
  Is.ATTO = { type: 3, value: "ATTO" }, Is.CENTI = { type: 3, value: "CENTI" }, Is.DECA = { type: 3, value: "DECA" }, Is.DECI = { type: 3, value: "DECI" }, Is.EXA = { type: 3, value: "EXA" }, Is.FEMTO = { type: 3, value: "FEMTO" }, Is.GIGA = { type: 3, value: "GIGA" }, Is.HECTO = { type: 3, value: "HECTO" }, Is.KILO = { type: 3, value: "KILO" }, Is.MEGA = { type: 3, value: "MEGA" }, Is.MICRO = { type: 3, value: "MICRO" }, Is.MILLI = { type: 3, value: "MILLI" }, Is.NANO = { type: 3, value: "NANO" }, Is.PETA = { type: 3, value: "PETA" }, Is.PICO = { type: 3, value: "PICO" }, Is.TERA = { type: 3, value: "TERA" }, r.IfcSIPrefix = Is;
  class fs {
  }
  fs.AMPERE = { type: 3, value: "AMPERE" }, fs.BECQUEREL = { type: 3, value: "BECQUEREL" }, fs.CANDELA = { type: 3, value: "CANDELA" }, fs.COULOMB = { type: 3, value: "COULOMB" }, fs.CUBIC_METRE = { type: 3, value: "CUBIC_METRE" }, fs.DEGREE_CELSIUS = { type: 3, value: "DEGREE_CELSIUS" }, fs.FARAD = { type: 3, value: "FARAD" }, fs.GRAM = { type: 3, value: "GRAM" }, fs.GRAY = { type: 3, value: "GRAY" }, fs.HENRY = { type: 3, value: "HENRY" }, fs.HERTZ = { type: 3, value: "HERTZ" }, fs.JOULE = { type: 3, value: "JOULE" }, fs.KELVIN = { type: 3, value: "KELVIN" }, fs.LUMEN = { type: 3, value: "LUMEN" }, fs.LUX = { type: 3, value: "LUX" }, fs.METRE = { type: 3, value: "METRE" }, fs.MOLE = { type: 3, value: "MOLE" }, fs.NEWTON = { type: 3, value: "NEWTON" }, fs.OHM = { type: 3, value: "OHM" }, fs.PASCAL = { type: 3, value: "PASCAL" }, fs.RADIAN = { type: 3, value: "RADIAN" }, fs.SECOND = { type: 3, value: "SECOND" }, fs.SIEMENS = { type: 3, value: "SIEMENS" }, fs.SIEVERT = { type: 3, value: "SIEVERT" }, fs.SQUARE_METRE = { type: 3, value: "SQUARE_METRE" }, fs.STERADIAN = { type: 3, value: "STERADIAN" }, fs.TESLA = { type: 3, value: "TESLA" }, fs.VOLT = { type: 3, value: "VOLT" }, fs.WATT = { type: 3, value: "WATT" }, fs.WEBER = { type: 3, value: "WEBER" }, r.IfcSIUnitName = fs;
  class co {
  }
  co.BATH = { type: 3, value: "BATH" }, co.BIDET = { type: 3, value: "BIDET" }, co.CISTERN = { type: 3, value: "CISTERN" }, co.SANITARYFOUNTAIN = { type: 3, value: "SANITARYFOUNTAIN" }, co.SHOWER = { type: 3, value: "SHOWER" }, co.SINK = { type: 3, value: "SINK" }, co.TOILETPAN = { type: 3, value: "TOILETPAN" }, co.URINAL = { type: 3, value: "URINAL" }, co.WASHHANDBASIN = { type: 3, value: "WASHHANDBASIN" }, co.WCSEAT = { type: 3, value: "WCSEAT" }, co.USERDEFINED = { type: 3, value: "USERDEFINED" }, co.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSanitaryTerminalTypeEnum = co;
  class Yo {
  }
  Yo.TAPERED = { type: 3, value: "TAPERED" }, Yo.UNIFORM = { type: 3, value: "UNIFORM" }, r.IfcSectionTypeEnum = Yo;
  class Qn {
  }
  Qn.CO2SENSOR = { type: 3, value: "CO2SENSOR" }, Qn.CONDUCTANCESENSOR = { type: 3, value: "CONDUCTANCESENSOR" }, Qn.CONTACTSENSOR = { type: 3, value: "CONTACTSENSOR" }, Qn.COSENSOR = { type: 3, value: "COSENSOR" }, Qn.EARTHQUAKESENSOR = { type: 3, value: "EARTHQUAKESENSOR" }, Qn.FIRESENSOR = { type: 3, value: "FIRESENSOR" }, Qn.FLOWSENSOR = { type: 3, value: "FLOWSENSOR" }, Qn.FOREIGNOBJECTDETECTIONSENSOR = { type: 3, value: "FOREIGNOBJECTDETECTIONSENSOR" }, Qn.FROSTSENSOR = { type: 3, value: "FROSTSENSOR" }, Qn.GASSENSOR = { type: 3, value: "GASSENSOR" }, Qn.HEATSENSOR = { type: 3, value: "HEATSENSOR" }, Qn.HUMIDITYSENSOR = { type: 3, value: "HUMIDITYSENSOR" }, Qn.IDENTIFIERSENSOR = { type: 3, value: "IDENTIFIERSENSOR" }, Qn.IONCONCENTRATIONSENSOR = { type: 3, value: "IONCONCENTRATIONSENSOR" }, Qn.LEVELSENSOR = { type: 3, value: "LEVELSENSOR" }, Qn.LIGHTSENSOR = { type: 3, value: "LIGHTSENSOR" }, Qn.MOISTURESENSOR = { type: 3, value: "MOISTURESENSOR" }, Qn.MOVEMENTSENSOR = { type: 3, value: "MOVEMENTSENSOR" }, Qn.OBSTACLESENSOR = { type: 3, value: "OBSTACLESENSOR" }, Qn.PHSENSOR = { type: 3, value: "PHSENSOR" }, Qn.PRESSURESENSOR = { type: 3, value: "PRESSURESENSOR" }, Qn.RADIATIONSENSOR = { type: 3, value: "RADIATIONSENSOR" }, Qn.RADIOACTIVITYSENSOR = { type: 3, value: "RADIOACTIVITYSENSOR" }, Qn.RAINSENSOR = { type: 3, value: "RAINSENSOR" }, Qn.SMOKESENSOR = { type: 3, value: "SMOKESENSOR" }, Qn.SNOWDEPTHSENSOR = { type: 3, value: "SNOWDEPTHSENSOR" }, Qn.SOUNDSENSOR = { type: 3, value: "SOUNDSENSOR" }, Qn.TEMPERATURESENSOR = { type: 3, value: "TEMPERATURESENSOR" }, Qn.TRAINSENSOR = { type: 3, value: "TRAINSENSOR" }, Qn.TURNOUTCLOSURESENSOR = { type: 3, value: "TURNOUTCLOSURESENSOR" }, Qn.WHEELSENSOR = { type: 3, value: "WHEELSENSOR" }, Qn.WINDSENSOR = { type: 3, value: "WINDSENSOR" }, Qn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Qn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSensorTypeEnum = Qn;
  class es {
  }
  es.FINISH_FINISH = { type: 3, value: "FINISH_FINISH" }, es.FINISH_START = { type: 3, value: "FINISH_START" }, es.START_FINISH = { type: 3, value: "START_FINISH" }, es.START_START = { type: 3, value: "START_START" }, es.USERDEFINED = { type: 3, value: "USERDEFINED" }, es.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSequenceEnum = es;
  class Jo {
  }
  Jo.AWNING = { type: 3, value: "AWNING" }, Jo.JALOUSIE = { type: 3, value: "JALOUSIE" }, Jo.SHUTTER = { type: 3, value: "SHUTTER" }, Jo.USERDEFINED = { type: 3, value: "USERDEFINED" }, Jo.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcShadingDeviceTypeEnum = Jo;
  class js {
  }
  js.MARKER = { type: 3, value: "MARKER" }, js.MIRROR = { type: 3, value: "MIRROR" }, js.PICTORAL = { type: 3, value: "PICTORAL" }, js.USERDEFINED = { type: 3, value: "USERDEFINED" }, js.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSignTypeEnum = js;
  class Hi {
  }
  Hi.AUDIO = { type: 3, value: "AUDIO" }, Hi.MIXED = { type: 3, value: "MIXED" }, Hi.VISUAL = { type: 3, value: "VISUAL" }, Hi.USERDEFINED = { type: 3, value: "USERDEFINED" }, Hi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSignalTypeEnum = Hi;
  class zs {
  }
  zs.P_BOUNDEDVALUE = { type: 3, value: "P_BOUNDEDVALUE" }, zs.P_ENUMERATEDVALUE = { type: 3, value: "P_ENUMERATEDVALUE" }, zs.P_LISTVALUE = { type: 3, value: "P_LISTVALUE" }, zs.P_REFERENCEVALUE = { type: 3, value: "P_REFERENCEVALUE" }, zs.P_SINGLEVALUE = { type: 3, value: "P_SINGLEVALUE" }, zs.P_TABLEVALUE = { type: 3, value: "P_TABLEVALUE" }, zs.Q_AREA = { type: 3, value: "Q_AREA" }, zs.Q_COUNT = { type: 3, value: "Q_COUNT" }, zs.Q_LENGTH = { type: 3, value: "Q_LENGTH" }, zs.Q_NUMBER = { type: 3, value: "Q_NUMBER" }, zs.Q_TIME = { type: 3, value: "Q_TIME" }, zs.Q_VOLUME = { type: 3, value: "Q_VOLUME" }, zs.Q_WEIGHT = { type: 3, value: "Q_WEIGHT" }, r.IfcSimplePropertyTemplateTypeEnum = zs;
  class Ji {
  }
  Ji.APPROACH_SLAB = { type: 3, value: "APPROACH_SLAB" }, Ji.BASESLAB = { type: 3, value: "BASESLAB" }, Ji.FLOOR = { type: 3, value: "FLOOR" }, Ji.LANDING = { type: 3, value: "LANDING" }, Ji.PAVING = { type: 3, value: "PAVING" }, Ji.ROOF = { type: 3, value: "ROOF" }, Ji.SIDEWALK = { type: 3, value: "SIDEWALK" }, Ji.TRACKSLAB = { type: 3, value: "TRACKSLAB" }, Ji.WEARING = { type: 3, value: "WEARING" }, Ji.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ji.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSlabTypeEnum = Ji;
  class ja {
  }
  ja.SOLARCOLLECTOR = { type: 3, value: "SOLARCOLLECTOR" }, ja.SOLARPANEL = { type: 3, value: "SOLARPANEL" }, ja.USERDEFINED = { type: 3, value: "USERDEFINED" }, ja.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSolarDeviceTypeEnum = ja;
  class Ea {
  }
  Ea.CONVECTOR = { type: 3, value: "CONVECTOR" }, Ea.RADIATOR = { type: 3, value: "RADIATOR" }, Ea.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ea.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceHeaterTypeEnum = Ea;
  class ga {
  }
  ga.BERTH = { type: 3, value: "BERTH" }, ga.EXTERNAL = { type: 3, value: "EXTERNAL" }, ga.GFA = { type: 3, value: "GFA" }, ga.INTERNAL = { type: 3, value: "INTERNAL" }, ga.PARKING = { type: 3, value: "PARKING" }, ga.SPACE = { type: 3, value: "SPACE" }, ga.USERDEFINED = { type: 3, value: "USERDEFINED" }, ga.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpaceTypeEnum = ga;
  class sa {
  }
  sa.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, sa.FIRESAFETY = { type: 3, value: "FIRESAFETY" }, sa.INTERFERENCE = { type: 3, value: "INTERFERENCE" }, sa.LIGHTING = { type: 3, value: "LIGHTING" }, sa.OCCUPANCY = { type: 3, value: "OCCUPANCY" }, sa.RESERVATION = { type: 3, value: "RESERVATION" }, sa.SECURITY = { type: 3, value: "SECURITY" }, sa.THERMAL = { type: 3, value: "THERMAL" }, sa.TRANSPORT = { type: 3, value: "TRANSPORT" }, sa.VENTILATION = { type: 3, value: "VENTILATION" }, sa.USERDEFINED = { type: 3, value: "USERDEFINED" }, sa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSpatialZoneTypeEnum = sa;
  class Sa {
  }
  Sa.BIRDCAGE = { type: 3, value: "BIRDCAGE" }, Sa.COWL = { type: 3, value: "COWL" }, Sa.RAINWATERHOPPER = { type: 3, value: "RAINWATERHOPPER" }, Sa.USERDEFINED = { type: 3, value: "USERDEFINED" }, Sa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStackTerminalTypeEnum = Sa;
  class Ua {
  }
  Ua.CURVED = { type: 3, value: "CURVED" }, Ua.FREEFORM = { type: 3, value: "FREEFORM" }, Ua.SPIRAL = { type: 3, value: "SPIRAL" }, Ua.STRAIGHT = { type: 3, value: "STRAIGHT" }, Ua.WINDER = { type: 3, value: "WINDER" }, Ua.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ua.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairFlightTypeEnum = Ua;
  class mi {
  }
  mi.CURVED_RUN_STAIR = { type: 3, value: "CURVED_RUN_STAIR" }, mi.DOUBLE_RETURN_STAIR = { type: 3, value: "DOUBLE_RETURN_STAIR" }, mi.HALF_TURN_STAIR = { type: 3, value: "HALF_TURN_STAIR" }, mi.HALF_WINDING_STAIR = { type: 3, value: "HALF_WINDING_STAIR" }, mi.LADDER = { type: 3, value: "LADDER" }, mi.QUARTER_TURN_STAIR = { type: 3, value: "QUARTER_TURN_STAIR" }, mi.QUARTER_WINDING_STAIR = { type: 3, value: "QUARTER_WINDING_STAIR" }, mi.SPIRAL_STAIR = { type: 3, value: "SPIRAL_STAIR" }, mi.STRAIGHT_RUN_STAIR = { type: 3, value: "STRAIGHT_RUN_STAIR" }, mi.THREE_QUARTER_TURN_STAIR = { type: 3, value: "THREE_QUARTER_TURN_STAIR" }, mi.THREE_QUARTER_WINDING_STAIR = { type: 3, value: "THREE_QUARTER_WINDING_STAIR" }, mi.TWO_CURVED_RUN_STAIR = { type: 3, value: "TWO_CURVED_RUN_STAIR" }, mi.TWO_QUARTER_TURN_STAIR = { type: 3, value: "TWO_QUARTER_TURN_STAIR" }, mi.TWO_QUARTER_WINDING_STAIR = { type: 3, value: "TWO_QUARTER_WINDING_STAIR" }, mi.TWO_STRAIGHT_RUN_STAIR = { type: 3, value: "TWO_STRAIGHT_RUN_STAIR" }, mi.USERDEFINED = { type: 3, value: "USERDEFINED" }, mi.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStairTypeEnum = mi;
  class $a {
  }
  $a.LOCKED = { type: 3, value: "LOCKED" }, $a.READONLY = { type: 3, value: "READONLY" }, $a.READONLYLOCKED = { type: 3, value: "READONLYLOCKED" }, $a.READWRITE = { type: 3, value: "READWRITE" }, $a.READWRITELOCKED = { type: 3, value: "READWRITELOCKED" }, r.IfcStateEnum = $a;
  class Oa {
  }
  Oa.CONST = { type: 3, value: "CONST" }, Oa.DISCRETE = { type: 3, value: "DISCRETE" }, Oa.EQUIDISTANT = { type: 3, value: "EQUIDISTANT" }, Oa.LINEAR = { type: 3, value: "LINEAR" }, Oa.PARABOLA = { type: 3, value: "PARABOLA" }, Oa.POLYGONAL = { type: 3, value: "POLYGONAL" }, Oa.SINUS = { type: 3, value: "SINUS" }, Oa.USERDEFINED = { type: 3, value: "USERDEFINED" }, Oa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralCurveActivityTypeEnum = Oa;
  class Ha {
  }
  Ha.CABLE = { type: 3, value: "CABLE" }, Ha.COMPRESSION_MEMBER = { type: 3, value: "COMPRESSION_MEMBER" }, Ha.PIN_JOINED_MEMBER = { type: 3, value: "PIN_JOINED_MEMBER" }, Ha.RIGID_JOINED_MEMBER = { type: 3, value: "RIGID_JOINED_MEMBER" }, Ha.TENSION_MEMBER = { type: 3, value: "TENSION_MEMBER" }, Ha.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ha.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralCurveMemberTypeEnum = Ha;
  class p0 {
  }
  p0.BILINEAR = { type: 3, value: "BILINEAR" }, p0.CONST = { type: 3, value: "CONST" }, p0.DISCRETE = { type: 3, value: "DISCRETE" }, p0.ISOCONTOUR = { type: 3, value: "ISOCONTOUR" }, p0.USERDEFINED = { type: 3, value: "USERDEFINED" }, p0.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralSurfaceActivityTypeEnum = p0;
  class k {
  }
  k.BENDING_ELEMENT = { type: 3, value: "BENDING_ELEMENT" }, k.MEMBRANE_ELEMENT = { type: 3, value: "MEMBRANE_ELEMENT" }, k.SHELL = { type: 3, value: "SHELL" }, k.USERDEFINED = { type: 3, value: "USERDEFINED" }, k.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcStructuralSurfaceMemberTypeEnum = k;
  class ne {
  }
  ne.PURCHASE = { type: 3, value: "PURCHASE" }, ne.WORK = { type: 3, value: "WORK" }, ne.USERDEFINED = { type: 3, value: "USERDEFINED" }, ne.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSubContractResourceTypeEnum = ne;
  class T {
  }
  T.DEFECT = { type: 3, value: "DEFECT" }, T.HATCHMARKING = { type: 3, value: "HATCHMARKING" }, T.LINEMARKING = { type: 3, value: "LINEMARKING" }, T.MARK = { type: 3, value: "MARK" }, T.NONSKIDSURFACING = { type: 3, value: "NONSKIDSURFACING" }, T.PAVEMENTSURFACEMARKING = { type: 3, value: "PAVEMENTSURFACEMARKING" }, T.RUMBLESTRIP = { type: 3, value: "RUMBLESTRIP" }, T.SYMBOLMARKING = { type: 3, value: "SYMBOLMARKING" }, T.TAG = { type: 3, value: "TAG" }, T.TRANSVERSERUMBLESTRIP = { type: 3, value: "TRANSVERSERUMBLESTRIP" }, T.TREATMENT = { type: 3, value: "TREATMENT" }, T.USERDEFINED = { type: 3, value: "USERDEFINED" }, T.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSurfaceFeatureTypeEnum = T;
  class y {
  }
  y.BOTH = { type: 3, value: "BOTH" }, y.NEGATIVE = { type: 3, value: "NEGATIVE" }, y.POSITIVE = { type: 3, value: "POSITIVE" }, r.IfcSurfaceSide = y;
  class N {
  }
  N.CONTACTOR = { type: 3, value: "CONTACTOR" }, N.DIMMERSWITCH = { type: 3, value: "DIMMERSWITCH" }, N.EMERGENCYSTOP = { type: 3, value: "EMERGENCYSTOP" }, N.KEYPAD = { type: 3, value: "KEYPAD" }, N.MOMENTARYSWITCH = { type: 3, value: "MOMENTARYSWITCH" }, N.RELAY = { type: 3, value: "RELAY" }, N.SELECTORSWITCH = { type: 3, value: "SELECTORSWITCH" }, N.STARTER = { type: 3, value: "STARTER" }, N.START_AND_STOP_EQUIPMENT = { type: 3, value: "START_AND_STOP_EQUIPMENT" }, N.SWITCHDISCONNECTOR = { type: 3, value: "SWITCHDISCONNECTOR" }, N.TOGGLESWITCH = { type: 3, value: "TOGGLESWITCH" }, N.USERDEFINED = { type: 3, value: "USERDEFINED" }, N.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSwitchingDeviceTypeEnum = N;
  class b {
  }
  b.PANEL = { type: 3, value: "PANEL" }, b.SUBRACK = { type: 3, value: "SUBRACK" }, b.WORKSURFACE = { type: 3, value: "WORKSURFACE" }, b.USERDEFINED = { type: 3, value: "USERDEFINED" }, b.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcSystemFurnitureElementTypeEnum = b;
  class X {
  }
  X.BASIN = { type: 3, value: "BASIN" }, X.BREAKPRESSURE = { type: 3, value: "BREAKPRESSURE" }, X.EXPANSION = { type: 3, value: "EXPANSION" }, X.FEEDANDEXPANSION = { type: 3, value: "FEEDANDEXPANSION" }, X.OILRETENTIONTRAY = { type: 3, value: "OILRETENTIONTRAY" }, X.PRESSUREVESSEL = { type: 3, value: "PRESSUREVESSEL" }, X.STORAGE = { type: 3, value: "STORAGE" }, X.VESSEL = { type: 3, value: "VESSEL" }, X.USERDEFINED = { type: 3, value: "USERDEFINED" }, X.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTankTypeEnum = X;
  class J {
  }
  J.ELAPSEDTIME = { type: 3, value: "ELAPSEDTIME" }, J.WORKTIME = { type: 3, value: "WORKTIME" }, J.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTaskDurationEnum = J;
  class Ie {
  }
  Ie.ADJUSTMENT = { type: 3, value: "ADJUSTMENT" }, Ie.ATTENDANCE = { type: 3, value: "ATTENDANCE" }, Ie.CALIBRATION = { type: 3, value: "CALIBRATION" }, Ie.CONSTRUCTION = { type: 3, value: "CONSTRUCTION" }, Ie.DEMOLITION = { type: 3, value: "DEMOLITION" }, Ie.DISMANTLE = { type: 3, value: "DISMANTLE" }, Ie.DISPOSAL = { type: 3, value: "DISPOSAL" }, Ie.EMERGENCY = { type: 3, value: "EMERGENCY" }, Ie.INSPECTION = { type: 3, value: "INSPECTION" }, Ie.INSTALLATION = { type: 3, value: "INSTALLATION" }, Ie.LOGISTIC = { type: 3, value: "LOGISTIC" }, Ie.MAINTENANCE = { type: 3, value: "MAINTENANCE" }, Ie.MOVE = { type: 3, value: "MOVE" }, Ie.OPERATION = { type: 3, value: "OPERATION" }, Ie.REMOVAL = { type: 3, value: "REMOVAL" }, Ie.RENOVATION = { type: 3, value: "RENOVATION" }, Ie.SAFETY = { type: 3, value: "SAFETY" }, Ie.SHUTDOWN = { type: 3, value: "SHUTDOWN" }, Ie.STARTUP = { type: 3, value: "STARTUP" }, Ie.TESTING = { type: 3, value: "TESTING" }, Ie.TROUBLESHOOTING = { type: 3, value: "TROUBLESHOOTING" }, Ie.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ie.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTaskTypeEnum = Ie;
  class Pe {
  }
  Pe.COUPLER = { type: 3, value: "COUPLER" }, Pe.FIXED_END = { type: 3, value: "FIXED_END" }, Pe.TENSIONING_END = { type: 3, value: "TENSIONING_END" }, Pe.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pe.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonAnchorTypeEnum = Pe;
  class We {
  }
  We.COUPLER = { type: 3, value: "COUPLER" }, We.DIABOLO = { type: 3, value: "DIABOLO" }, We.DUCT = { type: 3, value: "DUCT" }, We.GROUTING_DUCT = { type: 3, value: "GROUTING_DUCT" }, We.TRUMPET = { type: 3, value: "TRUMPET" }, We.USERDEFINED = { type: 3, value: "USERDEFINED" }, We.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonConduitTypeEnum = We;
  class it {
  }
  it.BAR = { type: 3, value: "BAR" }, it.COATED = { type: 3, value: "COATED" }, it.STRAND = { type: 3, value: "STRAND" }, it.WIRE = { type: 3, value: "WIRE" }, it.USERDEFINED = { type: 3, value: "USERDEFINED" }, it.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTendonTypeEnum = it;
  class Rt {
  }
  Rt.DOWN = { type: 3, value: "DOWN" }, Rt.LEFT = { type: 3, value: "LEFT" }, Rt.RIGHT = { type: 3, value: "RIGHT" }, Rt.UP = { type: 3, value: "UP" }, r.IfcTextPath = Rt;
  class Dt {
  }
  Dt.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, Dt.DISCRETE = { type: 3, value: "DISCRETE" }, Dt.DISCRETEBINARY = { type: 3, value: "DISCRETEBINARY" }, Dt.PIECEWISEBINARY = { type: 3, value: "PIECEWISEBINARY" }, Dt.PIECEWISECONSTANT = { type: 3, value: "PIECEWISECONSTANT" }, Dt.PIECEWISECONTINUOUS = { type: 3, value: "PIECEWISECONTINUOUS" }, Dt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTimeSeriesDataTypeEnum = Dt;
  class Kt {
  }
  Kt.BLOCKINGDEVICE = { type: 3, value: "BLOCKINGDEVICE" }, Kt.DERAILER = { type: 3, value: "DERAILER" }, Kt.FROG = { type: 3, value: "FROG" }, Kt.HALF_SET_OF_BLADES = { type: 3, value: "HALF_SET_OF_BLADES" }, Kt.SLEEPER = { type: 3, value: "SLEEPER" }, Kt.SPEEDREGULATOR = { type: 3, value: "SPEEDREGULATOR" }, Kt.TRACKENDOFALIGNMENT = { type: 3, value: "TRACKENDOFALIGNMENT" }, Kt.VEHICLESTOP = { type: 3, value: "VEHICLESTOP" }, Kt.USERDEFINED = { type: 3, value: "USERDEFINED" }, Kt.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTrackElementTypeEnum = Kt;
  class _n {
  }
  _n.CHOPPER = { type: 3, value: "CHOPPER" }, _n.COMBINED = { type: 3, value: "COMBINED" }, _n.CURRENT = { type: 3, value: "CURRENT" }, _n.FREQUENCY = { type: 3, value: "FREQUENCY" }, _n.INVERTER = { type: 3, value: "INVERTER" }, _n.RECTIFIER = { type: 3, value: "RECTIFIER" }, _n.VOLTAGE = { type: 3, value: "VOLTAGE" }, _n.USERDEFINED = { type: 3, value: "USERDEFINED" }, _n.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransformerTypeEnum = _n;
  class gn {
  }
  gn.CONTINUOUS = { type: 3, value: "CONTINUOUS" }, gn.CONTSAMEGRADIENT = { type: 3, value: "CONTSAMEGRADIENT" }, gn.CONTSAMEGRADIENTSAMECURVATURE = { type: 3, value: "CONTSAMEGRADIENTSAMECURVATURE" }, gn.DISCONTINUOUS = { type: 3, value: "DISCONTINUOUS" }, r.IfcTransitionCode = gn;
  class Pn {
  }
  Pn.CRANEWAY = { type: 3, value: "CRANEWAY" }, Pn.ELEVATOR = { type: 3, value: "ELEVATOR" }, Pn.ESCALATOR = { type: 3, value: "ESCALATOR" }, Pn.HAULINGGEAR = { type: 3, value: "HAULINGGEAR" }, Pn.LIFTINGGEAR = { type: 3, value: "LIFTINGGEAR" }, Pn.MOVINGWALKWAY = { type: 3, value: "MOVINGWALKWAY" }, Pn.USERDEFINED = { type: 3, value: "USERDEFINED" }, Pn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTransportElementTypeEnum = Pn;
  class Vn {
  }
  Vn.CARTESIAN = { type: 3, value: "CARTESIAN" }, Vn.PARAMETER = { type: 3, value: "PARAMETER" }, Vn.UNSPECIFIED = { type: 3, value: "UNSPECIFIED" }, r.IfcTrimmingPreference = Vn;
  class vn {
  }
  vn.FINNED = { type: 3, value: "FINNED" }, vn.USERDEFINED = { type: 3, value: "USERDEFINED" }, vn.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcTubeBundleTypeEnum = vn;
  class Zn {
  }
  Zn.ABSORBEDDOSEUNIT = { type: 3, value: "ABSORBEDDOSEUNIT" }, Zn.AMOUNTOFSUBSTANCEUNIT = { type: 3, value: "AMOUNTOFSUBSTANCEUNIT" }, Zn.AREAUNIT = { type: 3, value: "AREAUNIT" }, Zn.DOSEEQUIVALENTUNIT = { type: 3, value: "DOSEEQUIVALENTUNIT" }, Zn.ELECTRICCAPACITANCEUNIT = { type: 3, value: "ELECTRICCAPACITANCEUNIT" }, Zn.ELECTRICCHARGEUNIT = { type: 3, value: "ELECTRICCHARGEUNIT" }, Zn.ELECTRICCONDUCTANCEUNIT = { type: 3, value: "ELECTRICCONDUCTANCEUNIT" }, Zn.ELECTRICCURRENTUNIT = { type: 3, value: "ELECTRICCURRENTUNIT" }, Zn.ELECTRICRESISTANCEUNIT = { type: 3, value: "ELECTRICRESISTANCEUNIT" }, Zn.ELECTRICVOLTAGEUNIT = { type: 3, value: "ELECTRICVOLTAGEUNIT" }, Zn.ENERGYUNIT = { type: 3, value: "ENERGYUNIT" }, Zn.FORCEUNIT = { type: 3, value: "FORCEUNIT" }, Zn.FREQUENCYUNIT = { type: 3, value: "FREQUENCYUNIT" }, Zn.ILLUMINANCEUNIT = { type: 3, value: "ILLUMINANCEUNIT" }, Zn.INDUCTANCEUNIT = { type: 3, value: "INDUCTANCEUNIT" }, Zn.LENGTHUNIT = { type: 3, value: "LENGTHUNIT" }, Zn.LUMINOUSFLUXUNIT = { type: 3, value: "LUMINOUSFLUXUNIT" }, Zn.LUMINOUSINTENSITYUNIT = { type: 3, value: "LUMINOUSINTENSITYUNIT" }, Zn.MAGNETICFLUXDENSITYUNIT = { type: 3, value: "MAGNETICFLUXDENSITYUNIT" }, Zn.MAGNETICFLUXUNIT = { type: 3, value: "MAGNETICFLUXUNIT" }, Zn.MASSUNIT = { type: 3, value: "MASSUNIT" }, Zn.PLANEANGLEUNIT = { type: 3, value: "PLANEANGLEUNIT" }, Zn.POWERUNIT = { type: 3, value: "POWERUNIT" }, Zn.PRESSUREUNIT = { type: 3, value: "PRESSUREUNIT" }, Zn.RADIOACTIVITYUNIT = { type: 3, value: "RADIOACTIVITYUNIT" }, Zn.SOLIDANGLEUNIT = { type: 3, value: "SOLIDANGLEUNIT" }, Zn.THERMODYNAMICTEMPERATUREUNIT = { type: 3, value: "THERMODYNAMICTEMPERATUREUNIT" }, Zn.TIMEUNIT = { type: 3, value: "TIMEUNIT" }, Zn.VOLUMEUNIT = { type: 3, value: "VOLUMEUNIT" }, Zn.USERDEFINED = { type: 3, value: "USERDEFINED" }, r.IfcUnitEnum = Zn;
  class cr {
  }
  cr.ALARMPANEL = { type: 3, value: "ALARMPANEL" }, cr.BASESTATIONCONTROLLER = { type: 3, value: "BASESTATIONCONTROLLER" }, cr.COMBINED = { type: 3, value: "COMBINED" }, cr.CONTROLPANEL = { type: 3, value: "CONTROLPANEL" }, cr.GASDETECTIONPANEL = { type: 3, value: "GASDETECTIONPANEL" }, cr.HUMIDISTAT = { type: 3, value: "HUMIDISTAT" }, cr.INDICATORPANEL = { type: 3, value: "INDICATORPANEL" }, cr.MIMICPANEL = { type: 3, value: "MIMICPANEL" }, cr.THERMOSTAT = { type: 3, value: "THERMOSTAT" }, cr.WEATHERSTATION = { type: 3, value: "WEATHERSTATION" }, cr.USERDEFINED = { type: 3, value: "USERDEFINED" }, cr.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcUnitaryControlElementTypeEnum = cr;
  class Cs {
  }
  Cs.AIRCONDITIONINGUNIT = { type: 3, value: "AIRCONDITIONINGUNIT" }, Cs.AIRHANDLER = { type: 3, value: "AIRHANDLER" }, Cs.DEHUMIDIFIER = { type: 3, value: "DEHUMIDIFIER" }, Cs.ROOFTOPUNIT = { type: 3, value: "ROOFTOPUNIT" }, Cs.SPLITSYSTEM = { type: 3, value: "SPLITSYSTEM" }, Cs.USERDEFINED = { type: 3, value: "USERDEFINED" }, Cs.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcUnitaryEquipmentTypeEnum = Cs;
  class Br {
  }
  Br.AIRRELEASE = { type: 3, value: "AIRRELEASE" }, Br.ANTIVACUUM = { type: 3, value: "ANTIVACUUM" }, Br.CHANGEOVER = { type: 3, value: "CHANGEOVER" }, Br.CHECK = { type: 3, value: "CHECK" }, Br.COMMISSIONING = { type: 3, value: "COMMISSIONING" }, Br.DIVERTING = { type: 3, value: "DIVERTING" }, Br.DOUBLECHECK = { type: 3, value: "DOUBLECHECK" }, Br.DOUBLEREGULATING = { type: 3, value: "DOUBLEREGULATING" }, Br.DRAWOFFCOCK = { type: 3, value: "DRAWOFFCOCK" }, Br.FAUCET = { type: 3, value: "FAUCET" }, Br.FLUSHING = { type: 3, value: "FLUSHING" }, Br.GASCOCK = { type: 3, value: "GASCOCK" }, Br.GASTAP = { type: 3, value: "GASTAP" }, Br.ISOLATING = { type: 3, value: "ISOLATING" }, Br.MIXING = { type: 3, value: "MIXING" }, Br.PRESSUREREDUCING = { type: 3, value: "PRESSUREREDUCING" }, Br.PRESSURERELIEF = { type: 3, value: "PRESSURERELIEF" }, Br.REGULATING = { type: 3, value: "REGULATING" }, Br.SAFETYCUTOFF = { type: 3, value: "SAFETYCUTOFF" }, Br.STEAMTRAP = { type: 3, value: "STEAMTRAP" }, Br.STOPCOCK = { type: 3, value: "STOPCOCK" }, Br.USERDEFINED = { type: 3, value: "USERDEFINED" }, Br.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcValveTypeEnum = Br;
  class Do {
  }
  Do.CARGO = { type: 3, value: "CARGO" }, Do.ROLLINGSTOCK = { type: 3, value: "ROLLINGSTOCK" }, Do.VEHICLE = { type: 3, value: "VEHICLE" }, Do.VEHICLEAIR = { type: 3, value: "VEHICLEAIR" }, Do.VEHICLEMARINE = { type: 3, value: "VEHICLEMARINE" }, Do.VEHICLETRACKED = { type: 3, value: "VEHICLETRACKED" }, Do.VEHICLEWHEELED = { type: 3, value: "VEHICLEWHEELED" }, Do.USERDEFINED = { type: 3, value: "USERDEFINED" }, Do.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVehicleTypeEnum = Do;
  class _o {
  }
  _o.AXIAL_YIELD = { type: 3, value: "AXIAL_YIELD" }, _o.BENDING_YIELD = { type: 3, value: "BENDING_YIELD" }, _o.FRICTION = { type: 3, value: "FRICTION" }, _o.RUBBER = { type: 3, value: "RUBBER" }, _o.SHEAR_YIELD = { type: 3, value: "SHEAR_YIELD" }, _o.VISCOUS = { type: 3, value: "VISCOUS" }, _o.USERDEFINED = { type: 3, value: "USERDEFINED" }, _o.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVibrationDamperTypeEnum = _o;
  class Ca {
  }
  Ca.BASE = { type: 3, value: "BASE" }, Ca.COMPRESSION = { type: 3, value: "COMPRESSION" }, Ca.SPRING = { type: 3, value: "SPRING" }, Ca.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ca.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVibrationIsolatorTypeEnum = Ca;
  class ma {
  }
  ma.BOUNDARY = { type: 3, value: "BOUNDARY" }, ma.CLEARANCE = { type: 3, value: "CLEARANCE" }, ma.PROVISIONFORVOID = { type: 3, value: "PROVISIONFORVOID" }, ma.USERDEFINED = { type: 3, value: "USERDEFINED" }, ma.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVirtualElementTypeEnum = ma;
  class s0 {
  }
  s0.CHAMFER = { type: 3, value: "CHAMFER" }, s0.CUTOUT = { type: 3, value: "CUTOUT" }, s0.EDGE = { type: 3, value: "EDGE" }, s0.HOLE = { type: 3, value: "HOLE" }, s0.MITER = { type: 3, value: "MITER" }, s0.NOTCH = { type: 3, value: "NOTCH" }, s0.USERDEFINED = { type: 3, value: "USERDEFINED" }, s0.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcVoidingFeatureTypeEnum = s0;
  class Ra {
  }
  Ra.ELEMENTEDWALL = { type: 3, value: "ELEMENTEDWALL" }, Ra.MOVABLE = { type: 3, value: "MOVABLE" }, Ra.PARAPET = { type: 3, value: "PARAPET" }, Ra.PARTITIONING = { type: 3, value: "PARTITIONING" }, Ra.PLUMBINGWALL = { type: 3, value: "PLUMBINGWALL" }, Ra.POLYGONAL = { type: 3, value: "POLYGONAL" }, Ra.RETAININGWALL = { type: 3, value: "RETAININGWALL" }, Ra.SHEAR = { type: 3, value: "SHEAR" }, Ra.SOLIDWALL = { type: 3, value: "SOLIDWALL" }, Ra.STANDARD = { type: 3, value: "STANDARD" }, Ra.WAVEWALL = { type: 3, value: "WAVEWALL" }, Ra.USERDEFINED = { type: 3, value: "USERDEFINED" }, Ra.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWallTypeEnum = Ra;
  class U0 {
  }
  U0.FLOORTRAP = { type: 3, value: "FLOORTRAP" }, U0.FLOORWASTE = { type: 3, value: "FLOORWASTE" }, U0.GULLYSUMP = { type: 3, value: "GULLYSUMP" }, U0.GULLYTRAP = { type: 3, value: "GULLYTRAP" }, U0.ROOFDRAIN = { type: 3, value: "ROOFDRAIN" }, U0.WASTEDISPOSALUNIT = { type: 3, value: "WASTEDISPOSALUNIT" }, U0.WASTETRAP = { type: 3, value: "WASTETRAP" }, U0.USERDEFINED = { type: 3, value: "USERDEFINED" }, U0.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWasteTerminalTypeEnum = U0;
  class Qa {
  }
  Qa.BOTTOMHUNG = { type: 3, value: "BOTTOMHUNG" }, Qa.FIXEDCASEMENT = { type: 3, value: "FIXEDCASEMENT" }, Qa.OTHEROPERATION = { type: 3, value: "OTHEROPERATION" }, Qa.PIVOTHORIZONTAL = { type: 3, value: "PIVOTHORIZONTAL" }, Qa.PIVOTVERTICAL = { type: 3, value: "PIVOTVERTICAL" }, Qa.REMOVABLECASEMENT = { type: 3, value: "REMOVABLECASEMENT" }, Qa.SIDEHUNGLEFTHAND = { type: 3, value: "SIDEHUNGLEFTHAND" }, Qa.SIDEHUNGRIGHTHAND = { type: 3, value: "SIDEHUNGRIGHTHAND" }, Qa.SLIDINGHORIZONTAL = { type: 3, value: "SLIDINGHORIZONTAL" }, Qa.SLIDINGVERTICAL = { type: 3, value: "SLIDINGVERTICAL" }, Qa.TILTANDTURNLEFTHAND = { type: 3, value: "TILTANDTURNLEFTHAND" }, Qa.TILTANDTURNRIGHTHAND = { type: 3, value: "TILTANDTURNRIGHTHAND" }, Qa.TOPHUNG = { type: 3, value: "TOPHUNG" }, Qa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelOperationEnum = Qa;
  class Fl {
  }
  Fl.BOTTOM = { type: 3, value: "BOTTOM" }, Fl.LEFT = { type: 3, value: "LEFT" }, Fl.MIDDLE = { type: 3, value: "MIDDLE" }, Fl.RIGHT = { type: 3, value: "RIGHT" }, Fl.TOP = { type: 3, value: "TOP" }, Fl.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowPanelPositionEnum = Fl;
  class Pa {
  }
  Pa.ALUMINIUM = { type: 3, value: "ALUMINIUM" }, Pa.ALUMINIUM_WOOD = { type: 3, value: "ALUMINIUM_WOOD" }, Pa.HIGH_GRADE_STEEL = { type: 3, value: "HIGH_GRADE_STEEL" }, Pa.OTHER_CONSTRUCTION = { type: 3, value: "OTHER_CONSTRUCTION" }, Pa.PLASTIC = { type: 3, value: "PLASTIC" }, Pa.STEEL = { type: 3, value: "STEEL" }, Pa.WOOD = { type: 3, value: "WOOD" }, Pa.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleConstructionEnum = Pa;
  class o0 {
  }
  o0.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, o0.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, o0.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, o0.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, o0.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, o0.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, o0.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, o0.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, o0.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, o0.USERDEFINED = { type: 3, value: "USERDEFINED" }, o0.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowStyleOperationEnum = o0;
  class il {
  }
  il.LIGHTDOME = { type: 3, value: "LIGHTDOME" }, il.SKYLIGHT = { type: 3, value: "SKYLIGHT" }, il.WINDOW = { type: 3, value: "WINDOW" }, il.USERDEFINED = { type: 3, value: "USERDEFINED" }, il.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowTypeEnum = il;
  class T0 {
  }
  T0.DOUBLE_PANEL_HORIZONTAL = { type: 3, value: "DOUBLE_PANEL_HORIZONTAL" }, T0.DOUBLE_PANEL_VERTICAL = { type: 3, value: "DOUBLE_PANEL_VERTICAL" }, T0.SINGLE_PANEL = { type: 3, value: "SINGLE_PANEL" }, T0.TRIPLE_PANEL_BOTTOM = { type: 3, value: "TRIPLE_PANEL_BOTTOM" }, T0.TRIPLE_PANEL_HORIZONTAL = { type: 3, value: "TRIPLE_PANEL_HORIZONTAL" }, T0.TRIPLE_PANEL_LEFT = { type: 3, value: "TRIPLE_PANEL_LEFT" }, T0.TRIPLE_PANEL_RIGHT = { type: 3, value: "TRIPLE_PANEL_RIGHT" }, T0.TRIPLE_PANEL_TOP = { type: 3, value: "TRIPLE_PANEL_TOP" }, T0.TRIPLE_PANEL_VERTICAL = { type: 3, value: "TRIPLE_PANEL_VERTICAL" }, T0.USERDEFINED = { type: 3, value: "USERDEFINED" }, T0.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWindowTypePartitioningEnum = T0;
  class zl {
  }
  zl.FIRSTSHIFT = { type: 3, value: "FIRSTSHIFT" }, zl.SECONDSHIFT = { type: 3, value: "SECONDSHIFT" }, zl.THIRDSHIFT = { type: 3, value: "THIRDSHIFT" }, zl.USERDEFINED = { type: 3, value: "USERDEFINED" }, zl.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkCalendarTypeEnum = zl;
  class Al {
  }
  Al.ACTUAL = { type: 3, value: "ACTUAL" }, Al.BASELINE = { type: 3, value: "BASELINE" }, Al.PLANNED = { type: 3, value: "PLANNED" }, Al.USERDEFINED = { type: 3, value: "USERDEFINED" }, Al.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkPlanTypeEnum = Al;
  class $l {
  }
  $l.ACTUAL = { type: 3, value: "ACTUAL" }, $l.BASELINE = { type: 3, value: "BASELINE" }, $l.PLANNED = { type: 3, value: "PLANNED" }, $l.USERDEFINED = { type: 3, value: "USERDEFINED" }, $l.NOTDEFINED = { type: 3, value: "NOTDEFINED" }, r.IfcWorkScheduleTypeEnum = $l;
  class aE extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Role = w, this.UserDefinedRole = D, this.Description = U, this.type = 3630933823;
    }
  }
  r.IfcActorRole = aE;
  class wu extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Purpose = w, this.Description = D, this.UserDefinedPurpose = U, this.type = 618182010;
    }
  }
  r.IfcAddress = wu;
  class uc extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.StartTag = w, this.EndTag = D, this.type = 2879124712;
    }
  }
  r.IfcAlignmentParameterSegment = uc;
  class lE extends uc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D), this.StartTag = w, this.EndTag = D, this.StartDistAlong = U, this.HorizontalLength = z, this.StartHeight = oe, this.StartGradient = ce, this.EndGradient = Re, this.RadiusOfCurvature = Ne, this.PredefinedType = Qe, this.type = 3633395639;
    }
  }
  r.IfcAlignmentVerticalSegment = lE;
  class uE extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.ApplicationDeveloper = w, this.Version = D, this.ApplicationFullName = U, this.ApplicationIdentifier = z, this.type = 639542469;
    }
  }
  r.IfcApplication = uE;
  class Du extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H), this.Name = w, this.Description = D, this.AppliedValue = U, this.UnitBasis = z, this.ApplicableDate = oe, this.FixedUntilDate = ce, this.Category = Re, this.Condition = Ne, this.ArithmeticOperator = Qe, this.Components = tn, this.type = 411424972;
    }
  }
  r.IfcAppliedValue = Du;
  class i3 extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H), this.Identifier = w, this.Name = D, this.Description = U, this.TimeOfApproval = z, this.Status = oe, this.Level = ce, this.Qualifier = Re, this.RequestingApproval = Ne, this.GivingApproval = Qe, this.type = 130549933;
    }
  }
  r.IfcApproval = i3;
  class cc extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 4037036970;
    }
  }
  r.IfcBoundaryCondition = cc;
  class a3 extends cc {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.TranslationalStiffnessByLengthX = D, this.TranslationalStiffnessByLengthY = U, this.TranslationalStiffnessByLengthZ = z, this.RotationalStiffnessByLengthX = oe, this.RotationalStiffnessByLengthY = ce, this.RotationalStiffnessByLengthZ = Re, this.type = 1560379544;
    }
  }
  r.IfcBoundaryEdgeCondition = a3;
  class P1 extends cc {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.TranslationalStiffnessByAreaX = D, this.TranslationalStiffnessByAreaY = U, this.TranslationalStiffnessByAreaZ = z, this.type = 3367102660;
    }
  }
  r.IfcBoundaryFaceCondition = P1;
  class Ql extends cc {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.TranslationalStiffnessX = D, this.TranslationalStiffnessY = U, this.TranslationalStiffnessZ = z, this.RotationalStiffnessX = oe, this.RotationalStiffnessY = ce, this.RotationalStiffnessZ = Re, this.type = 1387855156;
    }
  }
  r.IfcBoundaryNodeCondition = Ql;
  class cE extends Ql {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.Name = w, this.TranslationalStiffnessX = D, this.TranslationalStiffnessY = U, this.TranslationalStiffnessZ = z, this.RotationalStiffnessX = oe, this.RotationalStiffnessY = ce, this.RotationalStiffnessZ = Re, this.WarpingStiffness = Ne, this.type = 2069777674;
    }
  }
  r.IfcBoundaryNodeConditionWarping = cE;
  class Ll extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 2859738748;
    }
  }
  r.IfcConnectionGeometry = Ll;
  class P0 extends Ll {
    constructor(H, w, D) {
      super(H), this.PointOnRelatingElement = w, this.PointOnRelatedElement = D, this.type = 2614616156;
    }
  }
  r.IfcConnectionPointGeometry = P0;
  class EE extends Ll {
    constructor(H, w, D) {
      super(H), this.SurfaceOnRelatingElement = w, this.SurfaceOnRelatedElement = D, this.type = 2732653382;
    }
  }
  r.IfcConnectionSurfaceGeometry = EE;
  class Xa extends Ll {
    constructor(H, w, D) {
      super(H), this.VolumeOnRelatingElement = w, this.VolumeOnRelatedElement = D, this.type = 775493141;
    }
  }
  r.IfcConnectionVolumeGeometry = Xa;
  class Ec extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.Name = w, this.Description = D, this.ConstraintGrade = U, this.ConstraintSource = z, this.CreatingActor = oe, this.CreationTime = ce, this.UserDefinedGrade = Re, this.type = 1959218052;
    }
  }
  r.IfcConstraint = Ec;
  class w1 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.SourceCRS = w, this.TargetCRS = D, this.type = 1785450214;
    }
  }
  r.IfcCoordinateOperation = w1;
  class al extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.Name = w, this.Description = D, this.GeodeticDatum = U, this.VerticalDatum = z, this.type = 1466758467;
    }
  }
  r.IfcCoordinateReferenceSystem = al;
  class IE extends Du {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.Name = w, this.Description = D, this.AppliedValue = U, this.UnitBasis = z, this.ApplicableDate = oe, this.FixedUntilDate = ce, this.Category = Re, this.Condition = Ne, this.ArithmeticOperator = Qe, this.Components = tn, this.type = 602808272;
    }
  }
  r.IfcCostValue = IE;
  class $0 extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.Elements = w, this.UnitType = D, this.UserDefinedType = U, this.Name = z, this.type = 1765591967;
    }
  }
  r.IfcDerivedUnit = $0;
  class ll extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.Unit = w, this.Exponent = D, this.type = 1045800335;
    }
  }
  r.IfcDerivedUnitElement = ll;
  class D1 extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.LengthExponent = w, this.MassExponent = D, this.TimeExponent = U, this.ElectricCurrentExponent = z, this.ThermodynamicTemperatureExponent = oe, this.AmountOfSubstanceExponent = ce, this.LuminousIntensityExponent = Re, this.type = 2949456006;
    }
  }
  r.IfcDimensionalExponents = D1;
  class d0 extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 4294318154;
    }
  }
  r.IfcExternalInformation = d0;
  class Nl extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Location = w, this.Identification = D, this.Name = U, this.type = 3200245327;
    }
  }
  r.IfcExternalReference = Nl;
  class b1 extends Nl {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.type = 2242383968;
    }
  }
  r.IfcExternallyDefinedHatchStyle = b1;
  class G1 extends Nl {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.type = 1040185647;
    }
  }
  r.IfcExternallyDefinedSurfaceStyle = G1;
  class pE extends Nl {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.type = 3548104201;
    }
  }
  r.IfcExternallyDefinedTextFont = pE;
  class dE extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.AxisTag = w, this.AxisCurve = D, this.SameSense = U, this.type = 852622518;
    }
  }
  r.IfcGridAxis = dE;
  class fE extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.TimeStamp = w, this.ListValues = D, this.type = 3020489413;
    }
  }
  r.IfcIrregularTimeSeriesValue = fE;
  class CE extends d0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H), this.Name = w, this.Version = D, this.Publisher = U, this.VersionDate = z, this.Location = oe, this.Description = ce, this.type = 2655187982;
    }
  }
  r.IfcLibraryInformation = CE;
  class j1 extends Nl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.Description = z, this.Language = oe, this.ReferencedLibrary = ce, this.type = 3452421091;
    }
  }
  r.IfcLibraryReference = j1;
  class hE extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.MainPlaneAngle = w, this.SecondaryPlaneAngle = D, this.LuminousIntensity = U, this.type = 4162380809;
    }
  }
  r.IfcLightDistributionData = hE;
  class Kl extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.LightDistributionCurve = w, this.DistributionData = D, this.type = 1566485204;
    }
  }
  r.IfcLightIntensityDistribution = Kl;
  class M1 extends w1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D), this.SourceCRS = w, this.TargetCRS = D, this.Eastings = U, this.Northings = z, this.OrthogonalHeight = oe, this.XAxisAbscissa = ce, this.XAxisOrdinate = Re, this.Scale = Ne, this.ScaleY = Qe, this.ScaleZ = tn, this.type = 3057273783;
    }
  }
  r.IfcMapConversion = M1;
  class bu extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.MaterialClassifications = w, this.ClassifiedMaterial = D, this.type = 1847130766;
    }
  }
  r.IfcMaterialClassificationRelationship = bu;
  class ul extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 760658860;
    }
  }
  r.IfcMaterialDefinition = ul;
  class w0 extends ul {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.Material = w, this.LayerThickness = D, this.IsVentilated = U, this.Name = z, this.Description = oe, this.Category = ce, this.Priority = Re, this.type = 248100487;
    }
  }
  r.IfcMaterialLayer = w0;
  class Ic extends ul {
    constructor(H, w, D, U) {
      super(H), this.MaterialLayers = w, this.LayerSetName = D, this.Description = U, this.type = 3303938423;
    }
  }
  r.IfcMaterialLayerSet = Ic;
  class SE extends w0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re), this.Material = w, this.LayerThickness = D, this.IsVentilated = U, this.Name = z, this.Description = oe, this.Category = ce, this.Priority = Re, this.OffsetDirection = Ne, this.OffsetValues = Qe, this.type = 1847252529;
    }
  }
  r.IfcMaterialLayerWithOffsets = SE;
  class Jl extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Materials = w, this.type = 2199411900;
    }
  }
  r.IfcMaterialList = Jl;
  class x1 extends ul {
    constructor(H, w, D, U, z, oe, ce) {
      super(H), this.Name = w, this.Description = D, this.Material = U, this.Profile = z, this.Priority = oe, this.Category = ce, this.type = 2235152071;
    }
  }
  r.IfcMaterialProfile = x1;
  class l3 extends ul {
    constructor(H, w, D, U, z) {
      super(H), this.Name = w, this.Description = D, this.MaterialProfiles = U, this.CompositeProfile = z, this.type = 164193824;
    }
  }
  r.IfcMaterialProfileSet = l3;
  class u3 extends x1 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.Name = w, this.Description = D, this.Material = U, this.Profile = z, this.Priority = oe, this.Category = ce, this.OffsetValues = Re, this.type = 552965576;
    }
  }
  r.IfcMaterialProfileWithOffsets = u3;
  class Gu extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 1507914824;
    }
  }
  r.IfcMaterialUsageDefinition = Gu;
  class c3 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.ValueComponent = w, this.UnitComponent = D, this.type = 2597039031;
    }
  }
  r.IfcMeasureWithUnit = c3;
  class RE extends Ec {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re), this.Name = w, this.Description = D, this.ConstraintGrade = U, this.ConstraintSource = z, this.CreatingActor = oe, this.CreationTime = ce, this.UserDefinedGrade = Re, this.Benchmark = Ne, this.ValueSource = Qe, this.DataValue = tn, this.ReferencePath = ar, this.type = 3368373690;
    }
  }
  r.IfcMetric = RE;
  class E3 extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Currency = w, this.type = 2706619895;
    }
  }
  r.IfcMonetaryUnit = E3;
  class D0 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.Dimensions = w, this.UnitType = D, this.type = 1918398963;
    }
  }
  r.IfcNamedUnit = D0;
  class pc extends IfcLineObject {
    constructor(H, w) {
      super(H), this.PlacementRelTo = w, this.type = 3701648758;
    }
  }
  r.IfcObjectPlacement = pc;
  class v1 extends Ec {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re), this.Name = w, this.Description = D, this.ConstraintGrade = U, this.ConstraintSource = z, this.CreatingActor = oe, this.CreationTime = ce, this.UserDefinedGrade = Re, this.BenchmarkValues = Ne, this.LogicalAggregator = Qe, this.ObjectiveQualifier = tn, this.UserDefinedQualifier = ar, this.type = 2251480897;
    }
  }
  r.IfcObjective = v1;
  class cl extends IfcLineObject {
    constructor(H, w, D, U, z, oe) {
      super(H), this.Identification = w, this.Name = D, this.Description = U, this.Roles = z, this.Addresses = oe, this.type = 4251960020;
    }
  }
  r.IfcOrganization = cl;
  class TE extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H), this.OwningUser = w, this.OwningApplication = D, this.State = U, this.ChangeAction = z, this.LastModifiedDate = oe, this.LastModifyingUser = ce, this.LastModifyingApplication = Re, this.CreationDate = Ne, this.type = 1207048766;
    }
  }
  r.IfcOwnerHistory = TE;
  class _E extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H), this.Identification = w, this.FamilyName = D, this.GivenName = U, this.MiddleNames = z, this.PrefixTitles = oe, this.SuffixTitles = ce, this.Roles = Re, this.Addresses = Ne, this.type = 2077209135;
    }
  }
  r.IfcPerson = _E;
  class B1 extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.ThePerson = w, this.TheOrganization = D, this.Roles = U, this.type = 101040310;
    }
  }
  r.IfcPersonAndOrganization = B1;
  class I3 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.Name = w, this.Description = D, this.type = 2483315170;
    }
  }
  r.IfcPhysicalQuantity = I3;
  class El extends I3 {
    constructor(H, w, D, U) {
      super(H, w, D), this.Name = w, this.Description = D, this.Unit = U, this.type = 2226359599;
    }
  }
  r.IfcPhysicalSimpleQuantity = El;
  class U1 extends wu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U), this.Purpose = w, this.Description = D, this.UserDefinedPurpose = U, this.InternalLocation = z, this.AddressLines = oe, this.PostalBox = ce, this.Town = Re, this.Region = Ne, this.PostalCode = Qe, this.Country = tn, this.type = 3355820592;
    }
  }
  r.IfcPostalAddress = U1;
  class Va extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 677532197;
    }
  }
  r.IfcPresentationItem = Va;
  class H0 extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.Name = w, this.Description = D, this.AssignedItems = U, this.Identifier = z, this.type = 2022622350;
    }
  }
  r.IfcPresentationLayerAssignment = H0;
  class mE extends H0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z), this.Name = w, this.Description = D, this.AssignedItems = U, this.Identifier = z, this.LayerOn = oe, this.LayerFrozen = ce, this.LayerBlocked = Re, this.LayerStyles = Ne, this.type = 1304840413;
    }
  }
  r.IfcPresentationLayerWithStyle = mE;
  class Zl extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 3119450353;
    }
  }
  r.IfcPresentationStyle = Zl;
  class p3 extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.Description = D, this.Representations = U, this.type = 2095639259;
    }
  }
  r.IfcProductRepresentation = p3;
  class Q0 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.ProfileType = w, this.ProfileName = D, this.type = 3958567839;
    }
  }
  r.IfcProfileDef = Q0;
  class H1 extends al {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z), this.Name = w, this.Description = D, this.GeodeticDatum = U, this.VerticalDatum = z, this.MapProjection = oe, this.MapZone = ce, this.MapUnit = Re, this.type = 3843373140;
    }
  }
  r.IfcProjectedCRS = H1;
  class ju extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 986844984;
    }
  }
  r.IfcPropertyAbstraction = ju;
  class yE extends ju {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.EnumerationValues = D, this.Unit = U, this.type = 3710013099;
    }
  }
  r.IfcPropertyEnumeration = yE;
  class FE extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.AreaValue = z, this.Formula = oe, this.type = 2044713172;
    }
  }
  r.IfcQuantityArea = FE;
  class AE extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.CountValue = z, this.Formula = oe, this.type = 2093928680;
    }
  }
  r.IfcQuantityCount = AE;
  class dc extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.LengthValue = z, this.Formula = oe, this.type = 931644368;
    }
  }
  r.IfcQuantityLength = dc;
  class LE extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.NumberValue = z, this.Formula = oe, this.type = 2691318326;
    }
  }
  r.IfcQuantityNumber = LE;
  class NE extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.TimeValue = z, this.Formula = oe, this.type = 3252649465;
    }
  }
  r.IfcQuantityTime = NE;
  class d3 extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.VolumeValue = z, this.Formula = oe, this.type = 2405470396;
    }
  }
  r.IfcQuantityVolume = d3;
  class gE extends El {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Unit = U, this.WeightValue = z, this.Formula = oe, this.type = 825690147;
    }
  }
  r.IfcQuantityWeight = gE;
  class OE extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H), this.RecurrenceType = w, this.DayComponent = D, this.WeekdayComponent = U, this.MonthComponent = z, this.Position = oe, this.Interval = ce, this.Occurrences = Re, this.TimePeriods = Ne, this.type = 3915482550;
    }
  }
  r.IfcRecurrencePattern = OE;
  class f3 extends IfcLineObject {
    constructor(H, w, D, U, z, oe) {
      super(H), this.TypeIdentifier = w, this.AttributeIdentifier = D, this.InstanceName = U, this.ListPositions = z, this.InnerReference = oe, this.type = 2433181523;
    }
  }
  r.IfcReference = f3;
  class C3 extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 1076942058;
    }
  }
  r.IfcRepresentation = C3;
  class K0 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.ContextIdentifier = w, this.ContextType = D, this.type = 3377609919;
    }
  }
  r.IfcRepresentationContext = K0;
  class Mu extends IfcLineObject {
    constructor(H) {
      super(H), this.type = 3008791417;
    }
  }
  r.IfcRepresentationItem = Mu;
  class PE extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.MappingOrigin = w, this.MappedRepresentation = D, this.type = 1660063152;
    }
  }
  r.IfcRepresentationMap = PE;
  class b0 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.Name = w, this.Description = D, this.type = 2439245199;
    }
  }
  r.IfcResourceLevelRelationship = b0;
  class fc extends IfcLineObject {
    constructor(H, w, D, U, z) {
      super(H), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 2341007311;
    }
  }
  r.IfcRoot = fc;
  class wE extends D0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Dimensions = w, this.UnitType = D, this.Prefix = U, this.Name = z, this.type = 448429030;
    }
  }
  r.IfcSIUnit = wE;
  class J0 extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.type = 1054537805;
    }
  }
  r.IfcSchedulingTime = J0;
  class DE extends IfcLineObject {
    constructor(H, w, D, U, z, oe) {
      super(H), this.ShapeRepresentations = w, this.Name = D, this.Description = U, this.ProductDefinitional = z, this.PartOfProductDefinitionShape = oe, this.type = 867548509;
    }
  }
  r.IfcShapeAspect = DE;
  class Cc extends C3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 3982875396;
    }
  }
  r.IfcShapeModel = Cc;
  class h3 extends Cc {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 4240577450;
    }
  }
  r.IfcShapeRepresentation = h3;
  class hc extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 2273995522;
    }
  }
  r.IfcStructuralConnectionCondition = hc;
  class S3 extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 2162789131;
    }
  }
  r.IfcStructuralLoad = S3;
  class bE extends S3 {
    constructor(H, w, D, U) {
      super(H, w), this.Name = w, this.Values = D, this.Locations = U, this.type = 3478079324;
    }
  }
  r.IfcStructuralLoadConfiguration = bE;
  class R3 extends S3 {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 609421318;
    }
  }
  r.IfcStructuralLoadOrResult = R3;
  class eu extends R3 {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 2525727697;
    }
  }
  r.IfcStructuralLoadStatic = eu;
  class GE extends eu {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.DeltaTConstant = D, this.DeltaTY = U, this.DeltaTZ = z, this.type = 3408363356;
    }
  }
  r.IfcStructuralLoadTemperature = GE;
  class T3 extends C3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 2830218821;
    }
  }
  r.IfcStyleModel = T3;
  class q1 extends Mu {
    constructor(H, w, D, U) {
      super(H), this.Item = w, this.Styles = D, this.Name = U, this.type = 3958052878;
    }
  }
  r.IfcStyledItem = q1;
  class Sc extends T3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 3049322572;
    }
  }
  r.IfcStyledRepresentation = Sc;
  class Zi extends R3 {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.SurfaceReinforcement1 = D, this.SurfaceReinforcement2 = U, this.ShearReinforcement = z, this.type = 2934153892;
    }
  }
  r.IfcSurfaceReinforcementArea = Zi;
  class jE extends Zl {
    constructor(H, w, D, U) {
      super(H, w), this.Name = w, this.Side = D, this.Styles = U, this.type = 1300840506;
    }
  }
  r.IfcSurfaceStyle = jE;
  class k1 extends Va {
    constructor(H, w, D, U, z) {
      super(H), this.DiffuseTransmissionColour = w, this.DiffuseReflectionColour = D, this.TransmissionColour = U, this.ReflectanceColour = z, this.type = 3303107099;
    }
  }
  r.IfcSurfaceStyleLighting = k1;
  class Y1 extends Va {
    constructor(H, w, D) {
      super(H), this.RefractionIndex = w, this.DispersionFactor = D, this.type = 1607154358;
    }
  }
  r.IfcSurfaceStyleRefraction = Y1;
  class Rc extends Va {
    constructor(H, w, D) {
      super(H), this.SurfaceColour = w, this.Transparency = D, this.type = 846575682;
    }
  }
  r.IfcSurfaceStyleShading = Rc;
  class ME extends Va {
    constructor(H, w) {
      super(H), this.Textures = w, this.type = 1351298697;
    }
  }
  r.IfcSurfaceStyleWithTextures = ME;
  class Tc extends Va {
    constructor(H, w, D, U, z, oe) {
      super(H), this.RepeatS = w, this.RepeatT = D, this.Mode = U, this.TextureTransform = z, this.Parameter = oe, this.type = 626085974;
    }
  }
  r.IfcSurfaceTexture = Tc;
  class xE extends IfcLineObject {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.Rows = D, this.Columns = U, this.type = 985171141;
    }
  }
  r.IfcTable = xE;
  class xu extends IfcLineObject {
    constructor(H, w, D, U, z, oe) {
      super(H), this.Identifier = w, this.Name = D, this.Description = U, this.Unit = z, this.ReferencePath = oe, this.type = 2043862942;
    }
  }
  r.IfcTableColumn = xu;
  class vE extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.RowCells = w, this.IsHeading = D, this.type = 531007025;
    }
  }
  r.IfcTableRow = vE;
  class _3 extends J0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu, oE, iE) {
      super(H, w, D, U), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.DurationType = z, this.ScheduleDuration = oe, this.ScheduleStart = ce, this.ScheduleFinish = Re, this.EarlyStart = Ne, this.EarlyFinish = Qe, this.LateStart = tn, this.LateFinish = ar, this.FreeFloat = os, this.TotalFloat = ho, this.IsCritical = ra, this.StatusTime = Wa, this.ActualDuration = r0, this.ActualStart = O0, this.ActualFinish = Pu, this.RemainingTime = oE, this.Completion = iE, this.type = 1549132990;
    }
  }
  r.IfcTaskTime = _3;
  class BE extends _3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu, oE, iE, x8) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu, oE, iE), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.DurationType = z, this.ScheduleDuration = oe, this.ScheduleStart = ce, this.ScheduleFinish = Re, this.EarlyStart = Ne, this.EarlyFinish = Qe, this.LateStart = tn, this.LateFinish = ar, this.FreeFloat = os, this.TotalFloat = ho, this.IsCritical = ra, this.StatusTime = Wa, this.ActualDuration = r0, this.ActualStart = O0, this.ActualFinish = Pu, this.RemainingTime = oE, this.Completion = iE, this.Recurrence = x8, this.type = 2771591690;
    }
  }
  r.IfcTaskTimeRecurring = BE;
  class X1 extends wu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U), this.Purpose = w, this.Description = D, this.UserDefinedPurpose = U, this.TelephoneNumbers = z, this.FacsimileNumbers = oe, this.PagerNumber = ce, this.ElectronicMailAddresses = Re, this.WWWHomePageURL = Ne, this.MessagingIDs = Qe, this.type = 912023232;
    }
  }
  r.IfcTelecomAddress = X1;
  class UE extends Zl {
    constructor(H, w, D, U, z, oe) {
      super(H, w), this.Name = w, this.TextCharacterAppearance = D, this.TextStyle = U, this.TextFontStyle = z, this.ModelOrDraughting = oe, this.type = 1447204868;
    }
  }
  r.IfcTextStyle = UE;
  class _c extends Va {
    constructor(H, w, D) {
      super(H), this.Colour = w, this.BackgroundColour = D, this.type = 2636378356;
    }
  }
  r.IfcTextStyleForDefinedFont = _c;
  class mc extends Va {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.TextIndent = w, this.TextAlign = D, this.TextDecoration = U, this.LetterSpacing = z, this.WordSpacing = oe, this.TextTransform = ce, this.LineHeight = Re, this.type = 1640371178;
    }
  }
  r.IfcTextStyleTextModel = mc;
  class yc extends Va {
    constructor(H, w) {
      super(H), this.Maps = w, this.type = 280115917;
    }
  }
  r.IfcTextureCoordinate = yc;
  class m3 extends yc {
    constructor(H, w, D, U) {
      super(H, w), this.Maps = w, this.Mode = D, this.Parameter = U, this.type = 1742049831;
    }
  }
  r.IfcTextureCoordinateGenerator = m3;
  class V1 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.TexCoordIndex = w, this.TexCoordsOf = D, this.type = 222769930;
    }
  }
  r.IfcTextureCoordinateIndices = V1;
  class Fc extends V1 {
    constructor(H, w, D, U) {
      super(H, w, D), this.TexCoordIndex = w, this.TexCoordsOf = D, this.InnerTexCoordIndices = U, this.type = 1010789467;
    }
  }
  r.IfcTextureCoordinateIndicesWithVoids = Fc;
  class y3 extends yc {
    constructor(H, w, D, U) {
      super(H, w), this.Maps = w, this.Vertices = D, this.MappedTo = U, this.type = 2552916305;
    }
  }
  r.IfcTextureMap = y3;
  class HE extends Va {
    constructor(H, w) {
      super(H), this.Coordinates = w, this.type = 1210645708;
    }
  }
  r.IfcTextureVertex = HE;
  class W1 extends Va {
    constructor(H, w) {
      super(H), this.TexCoordsList = w, this.type = 3611470254;
    }
  }
  r.IfcTextureVertexList = W1;
  class f0 extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.StartTime = w, this.EndTime = D, this.type = 1199560280;
    }
  }
  r.IfcTimePeriod = f0;
  class F3 extends IfcLineObject {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H), this.Name = w, this.Description = D, this.StartTime = U, this.EndTime = z, this.TimeSeriesDataType = oe, this.DataOrigin = ce, this.UserDefinedDataOrigin = Re, this.Unit = Ne, this.type = 3101149627;
    }
  }
  r.IfcTimeSeries = F3;
  class z1 extends IfcLineObject {
    constructor(H, w) {
      super(H), this.ListValues = w, this.type = 581633288;
    }
  }
  r.IfcTimeSeriesValue = z1;
  class Oi extends Mu {
    constructor(H) {
      super(H), this.type = 1377556343;
    }
  }
  r.IfcTopologicalRepresentationItem = Oi;
  class Ac extends Cc {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.ContextOfItems = w, this.RepresentationIdentifier = D, this.RepresentationType = U, this.Items = z, this.type = 1735638870;
    }
  }
  r.IfcTopologyRepresentation = Ac;
  class L3 extends IfcLineObject {
    constructor(H, w) {
      super(H), this.Units = w, this.type = 180925521;
    }
  }
  r.IfcUnitAssignment = L3;
  class vu extends Oi {
    constructor(H) {
      super(H), this.type = 2799835756;
    }
  }
  r.IfcVertex = vu;
  class N3 extends vu {
    constructor(H, w) {
      super(H), this.VertexGeometry = w, this.type = 1907098498;
    }
  }
  r.IfcVertexPoint = N3;
  class qE extends IfcLineObject {
    constructor(H, w, D) {
      super(H), this.IntersectingAxes = w, this.OffsetDistances = D, this.type = 891718957;
    }
  }
  r.IfcVirtualGridIntersection = qE;
  class kE extends J0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.RecurrencePattern = z, this.StartDate = oe, this.FinishDate = ce, this.type = 1236880293;
    }
  }
  r.IfcWorkTime = kE;
  class $1 extends uc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D), this.StartTag = w, this.EndTag = D, this.StartDistAlong = U, this.HorizontalLength = z, this.StartCantLeft = oe, this.EndCantLeft = ce, this.StartCantRight = Re, this.EndCantRight = Ne, this.PredefinedType = Qe, this.type = 3752311538;
    }
  }
  r.IfcAlignmentCantSegment = $1;
  class Q1 extends uc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D), this.StartTag = w, this.EndTag = D, this.StartPoint = U, this.StartDirection = z, this.StartRadiusOfCurvature = oe, this.EndRadiusOfCurvature = ce, this.SegmentLength = Re, this.GravityCenterLineHeight = Ne, this.PredefinedType = Qe, this.type = 536804194;
    }
  }
  r.IfcAlignmentHorizontalSegment = Q1;
  class K1 extends b0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingApproval = U, this.RelatedApprovals = z, this.type = 3869604511;
    }
  }
  r.IfcApprovalRelationship = K1;
  class J1 extends Q0 {
    constructor(H, w, D, U) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.OuterCurve = U, this.type = 3798115385;
    }
  }
  r.IfcArbitraryClosedProfileDef = J1;
  class tu extends Q0 {
    constructor(H, w, D, U) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.Curve = U, this.type = 1310608509;
    }
  }
  r.IfcArbitraryOpenProfileDef = tu;
  class YE extends J1 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.OuterCurve = U, this.InnerCurves = z, this.type = 2705031697;
    }
  }
  r.IfcArbitraryProfileDefWithVoids = YE;
  class XE extends Tc {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.RepeatS = w, this.RepeatT = D, this.Mode = U, this.TextureTransform = z, this.Parameter = oe, this.RasterFormat = ce, this.RasterCode = Re, this.type = 616511568;
    }
  }
  r.IfcBlobTexture = XE;
  class Z1 extends tu {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Curve = U, this.Thickness = z, this.type = 3150382593;
    }
  }
  r.IfcCenterLineProfileDef = Z1;
  class e4 extends d0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.Source = w, this.Edition = D, this.EditionDate = U, this.Name = z, this.Description = oe, this.Specification = ce, this.ReferenceTokens = Re, this.type = 747523909;
    }
  }
  r.IfcClassification = e4;
  class VE extends Nl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.ReferencedSource = z, this.Description = oe, this.Sort = ce, this.type = 647927063;
    }
  }
  r.IfcClassificationReference = VE;
  class WE extends Va {
    constructor(H, w) {
      super(H), this.ColourList = w, this.type = 3285139300;
    }
  }
  r.IfcColourRgbList = WE;
  class qa extends Va {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 3264961684;
    }
  }
  r.IfcColourSpecification = qa;
  class zE extends Q0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.Profiles = U, this.Label = z, this.type = 1485152156;
    }
  }
  r.IfcCompositeProfileDef = zE;
  class g3 extends Oi {
    constructor(H, w) {
      super(H), this.CfsFaces = w, this.type = 370225590;
    }
  }
  r.IfcConnectedFaceSet = g3;
  class O3 extends Ll {
    constructor(H, w, D) {
      super(H), this.CurveOnRelatingElement = w, this.CurveOnRelatedElement = D, this.type = 1981873012;
    }
  }
  r.IfcConnectionCurveGeometry = O3;
  class $E extends P0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.PointOnRelatingElement = w, this.PointOnRelatedElement = D, this.EccentricityInX = U, this.EccentricityInY = z, this.EccentricityInZ = oe, this.type = 45288368;
    }
  }
  r.IfcConnectionPointEccentricity = $E;
  class QE extends D0 {
    constructor(H, w, D, U) {
      super(H, w, D), this.Dimensions = w, this.UnitType = D, this.Name = U, this.type = 3050246964;
    }
  }
  r.IfcContextDependentUnit = QE;
  class gl extends D0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Dimensions = w, this.UnitType = D, this.Name = U, this.ConversionFactor = z, this.type = 2889183280;
    }
  }
  r.IfcConversionBasedUnit = gl;
  class t4 extends gl {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.Dimensions = w, this.UnitType = D, this.Name = U, this.ConversionFactor = z, this.ConversionOffset = oe, this.type = 2713554722;
    }
  }
  r.IfcConversionBasedUnitWithOffset = t4;
  class KE extends b0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingMonetaryUnit = U, this.RelatedMonetaryUnit = z, this.ExchangeRate = oe, this.RateDateTime = ce, this.RateSource = Re, this.type = 539742890;
    }
  }
  r.IfcCurrencyRelationship = KE;
  class JE extends Zl {
    constructor(H, w, D, U, z, oe) {
      super(H, w), this.Name = w, this.CurveFont = D, this.CurveWidth = U, this.CurveColour = z, this.ModelOrDraughting = oe, this.type = 3800577675;
    }
  }
  r.IfcCurveStyle = JE;
  class ZE extends Va {
    constructor(H, w, D) {
      super(H), this.Name = w, this.PatternList = D, this.type = 1105321065;
    }
  }
  r.IfcCurveStyleFont = ZE;
  class e2 extends Va {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.CurveStyleFont = D, this.CurveFontScaling = U, this.type = 2367409068;
    }
  }
  r.IfcCurveStyleFontAndScaling = e2;
  class Il extends Va {
    constructor(H, w, D) {
      super(H), this.VisibleSegmentLength = w, this.InvisibleSegmentLength = D, this.type = 3510044353;
    }
  }
  r.IfcCurveStyleFontPattern = Il;
  class n4 extends Q0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.ParentProfile = U, this.Operator = z, this.Label = oe, this.type = 3632507154;
    }
  }
  r.IfcDerivedProfileDef = n4;
  class t2 extends d0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0) {
      super(H), this.Identification = w, this.Name = D, this.Description = U, this.Location = z, this.Purpose = oe, this.IntendedUse = ce, this.Scope = Re, this.Revision = Ne, this.DocumentOwner = Qe, this.Editors = tn, this.CreationTime = ar, this.LastRevisionTime = os, this.ElectronicFormat = ho, this.ValidFrom = ra, this.ValidUntil = Wa, this.Confidentiality = r0, this.Status = O0, this.type = 1154170062;
    }
  }
  r.IfcDocumentInformation = t2;
  class r2 extends b0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingDocument = U, this.RelatedDocuments = z, this.RelationshipType = oe, this.type = 770865208;
    }
  }
  r.IfcDocumentInformationRelationship = r2;
  class _0 extends Nl {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Location = w, this.Identification = D, this.Name = U, this.Description = z, this.ReferencedDocument = oe, this.type = 3732053477;
    }
  }
  r.IfcDocumentReference = _0;
  class Lc extends Oi {
    constructor(H, w, D) {
      super(H), this.EdgeStart = w, this.EdgeEnd = D, this.type = 3900360178;
    }
  }
  r.IfcEdge = Lc;
  class r4 extends Lc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.EdgeStart = w, this.EdgeEnd = D, this.EdgeGeometry = U, this.SameSense = z, this.type = 476780140;
    }
  }
  r.IfcEdgeCurve = r4;
  class s2 extends J0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.ActualDate = z, this.EarlyDate = oe, this.LateDate = ce, this.ScheduleDate = Re, this.type = 211053100;
    }
  }
  r.IfcEventTime = s2;
  class Ol extends ju {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.Description = D, this.Properties = U, this.type = 297599258;
    }
  }
  r.IfcExtendedProperties = Ol;
  class s4 extends b0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingReference = U, this.RelatedResourceObjects = z, this.type = 1437805879;
    }
  }
  r.IfcExternalReferenceRelationship = s4;
  class nu extends Oi {
    constructor(H, w) {
      super(H), this.Bounds = w, this.type = 2556980723;
    }
  }
  r.IfcFace = nu;
  class o4 extends Oi {
    constructor(H, w, D) {
      super(H), this.Bound = w, this.Orientation = D, this.type = 1809719519;
    }
  }
  r.IfcFaceBound = o4;
  class o2 extends o4 {
    constructor(H, w, D) {
      super(H, w, D), this.Bound = w, this.Orientation = D, this.type = 803316827;
    }
  }
  r.IfcFaceOuterBound = o2;
  class Bu extends nu {
    constructor(H, w, D, U) {
      super(H, w), this.Bounds = w, this.FaceSurface = D, this.SameSense = U, this.type = 3008276851;
    }
  }
  r.IfcFaceSurface = Bu;
  class i2 extends hc {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.TensionFailureX = D, this.TensionFailureY = U, this.TensionFailureZ = z, this.CompressionFailureX = oe, this.CompressionFailureY = ce, this.CompressionFailureZ = Re, this.type = 4219587988;
    }
  }
  r.IfcFailureConnectionCondition = i2;
  class Pl extends Zl {
    constructor(H, w, D, U) {
      super(H, w), this.Name = w, this.FillStyles = D, this.ModelOrDraughting = U, this.type = 738692330;
    }
  }
  r.IfcFillAreaStyle = Pl;
  class Uu extends K0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D), this.ContextIdentifier = w, this.ContextType = D, this.CoordinateSpaceDimension = U, this.Precision = z, this.WorldCoordinateSystem = oe, this.TrueNorth = ce, this.type = 3448662350;
    }
  }
  r.IfcGeometricRepresentationContext = Uu;
  class ea extends Mu {
    constructor(H) {
      super(H), this.type = 2453401579;
    }
  }
  r.IfcGeometricRepresentationItem = ea;
  class a2 extends Uu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, new _e(0), null, U, null), this.ContextIdentifier = w, this.ContextType = D, this.WorldCoordinateSystem = U, this.ParentContext = z, this.TargetScale = oe, this.TargetView = ce, this.UserDefinedTargetView = Re, this.type = 4142052618;
    }
  }
  r.IfcGeometricRepresentationSubContext = a2;
  class P3 extends ea {
    constructor(H, w) {
      super(H), this.Elements = w, this.type = 3590301190;
    }
  }
  r.IfcGeometricSet = P3;
  class Nc extends pc {
    constructor(H, w, D, U) {
      super(H, w), this.PlacementRelTo = w, this.PlacementLocation = D, this.PlacementRefDirection = U, this.type = 178086475;
    }
  }
  r.IfcGridPlacement = Nc;
  class Hu extends ea {
    constructor(H, w, D) {
      super(H), this.BaseSurface = w, this.AgreementFlag = D, this.type = 812098782;
    }
  }
  r.IfcHalfSpaceSolid = Hu;
  class l2 extends Tc {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.RepeatS = w, this.RepeatT = D, this.Mode = U, this.TextureTransform = z, this.Parameter = oe, this.URLReference = ce, this.type = 3905492369;
    }
  }
  r.IfcImageTexture = l2;
  class gc extends Va {
    constructor(H, w, D, U, z) {
      super(H), this.MappedTo = w, this.Opacity = D, this.Colours = U, this.ColourIndex = z, this.type = 3570813810;
    }
  }
  r.IfcIndexedColourMap = gc;
  class ru extends yc {
    constructor(H, w, D, U) {
      super(H, w), this.Maps = w, this.MappedTo = D, this.TexCoords = U, this.type = 1437953363;
    }
  }
  r.IfcIndexedTextureMap = ru;
  class qu extends ru {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Maps = w, this.MappedTo = D, this.TexCoords = U, this.TexCoordIndex = z, this.type = 2133299955;
    }
  }
  r.IfcIndexedTriangleTextureMap = qu;
  class w3 extends F3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.Name = w, this.Description = D, this.StartTime = U, this.EndTime = z, this.TimeSeriesDataType = oe, this.DataOrigin = ce, this.UserDefinedDataOrigin = Re, this.Unit = Ne, this.Values = Qe, this.type = 3741457305;
    }
  }
  r.IfcIrregularTimeSeries = w3;
  class u2 extends J0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.LagValue = z, this.DurationType = oe, this.type = 1585845231;
    }
  }
  r.IfcLagTime = u2;
  class ku extends ea {
    constructor(H, w, D, U, z) {
      super(H), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.type = 1402838566;
    }
  }
  r.IfcLightSource = ku;
  class wl extends ku {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.type = 125510826;
    }
  }
  r.IfcLightSourceAmbient = wl;
  class c2 extends ku {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.Orientation = oe, this.type = 2604431987;
    }
  }
  r.IfcLightSourceDirectional = c2;
  class E2 extends ku {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.Position = oe, this.ColourAppearance = ce, this.ColourTemperature = Re, this.LuminousFlux = Ne, this.LightEmissionSource = Qe, this.LightDistributionDataSource = tn, this.type = 4266656042;
    }
  }
  r.IfcLightSourceGoniometric = E2;
  class i4 extends ku {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.Position = oe, this.Radius = ce, this.ConstantAttenuation = Re, this.DistanceAttenuation = Ne, this.QuadricAttenuation = Qe, this.type = 1520743889;
    }
  }
  r.IfcLightSourcePositional = i4;
  class D3 extends i4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.Name = w, this.LightColour = D, this.AmbientIntensity = U, this.Intensity = z, this.Position = oe, this.Radius = ce, this.ConstantAttenuation = Re, this.DistanceAttenuation = Ne, this.QuadricAttenuation = Qe, this.Orientation = tn, this.ConcentrationExponent = ar, this.SpreadAngle = os, this.BeamWidthAngle = ho, this.type = 3422422726;
    }
  }
  r.IfcLightSourceSpot = D3;
  class I2 extends pc {
    constructor(H, w, D, U) {
      super(H, w), this.PlacementRelTo = w, this.RelativePlacement = D, this.CartesianPosition = U, this.type = 388784114;
    }
  }
  r.IfcLinearPlacement = I2;
  class p2 extends pc {
    constructor(H, w, D) {
      super(H, w), this.PlacementRelTo = w, this.RelativePlacement = D, this.type = 2624227202;
    }
  }
  r.IfcLocalPlacement = p2;
  class Oc extends Oi {
    constructor(H) {
      super(H), this.type = 1008929658;
    }
  }
  r.IfcLoop = Oc;
  class d2 extends Mu {
    constructor(H, w, D) {
      super(H), this.MappingSource = w, this.MappingTarget = D, this.type = 2347385850;
    }
  }
  r.IfcMappedItem = d2;
  class Dl extends ul {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.Description = D, this.Category = U, this.type = 1838606355;
    }
  }
  r.IfcMaterial = Dl;
  class f2 extends ul {
    constructor(H, w, D, U, z, oe) {
      super(H), this.Name = w, this.Description = D, this.Material = U, this.Fraction = z, this.Category = oe, this.type = 3708119e3;
    }
  }
  r.IfcMaterialConstituent = f2;
  class su extends ul {
    constructor(H, w, D, U) {
      super(H), this.Name = w, this.Description = D, this.MaterialConstituents = U, this.type = 2852063980;
    }
  }
  r.IfcMaterialConstituentSet = su;
  class b3 extends p3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Representations = U, this.RepresentedMaterial = z, this.type = 2022407955;
    }
  }
  r.IfcMaterialDefinitionRepresentation = b3;
  class C2 extends Gu {
    constructor(H, w, D, U, z, oe) {
      super(H), this.ForLayerSet = w, this.LayerSetDirection = D, this.DirectionSense = U, this.OffsetFromReferenceLine = z, this.ReferenceExtent = oe, this.type = 1303795690;
    }
  }
  r.IfcMaterialLayerSetUsage = C2;
  class G3 extends Gu {
    constructor(H, w, D, U) {
      super(H), this.ForProfileSet = w, this.CardinalPoint = D, this.ReferenceExtent = U, this.type = 3079605661;
    }
  }
  r.IfcMaterialProfileSetUsage = G3;
  class h2 extends G3 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.ForProfileSet = w, this.CardinalPoint = D, this.ReferenceExtent = U, this.ForProfileEndSet = z, this.CardinalEndPoint = oe, this.type = 3404854881;
    }
  }
  r.IfcMaterialProfileSetUsageTapering = h2;
  class a4 extends Ol {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Properties = U, this.Material = z, this.type = 3265635763;
    }
  }
  r.IfcMaterialProperties = a4;
  class j3 extends b0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingMaterial = U, this.RelatedMaterials = z, this.MaterialExpression = oe, this.type = 853536259;
    }
  }
  r.IfcMaterialRelationship = j3;
  class l4 extends n4 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z, oe), this.ProfileType = w, this.ProfileName = D, this.ParentProfile = U, this.Operator = z, this.Label = oe, this.type = 2998442950;
    }
  }
  r.IfcMirroredProfileDef = l4;
  class bl extends fc {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 219451334;
    }
  }
  r.IfcObjectDefinition = bl;
  class u4 extends Q0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.HorizontalWidths = U, this.Widths = z, this.Slopes = oe, this.Tags = ce, this.OffsetPoint = Re, this.type = 182550632;
    }
  }
  r.IfcOpenCrossProfileDef = u4;
  class Yu extends g3 {
    constructor(H, w) {
      super(H, w), this.CfsFaces = w, this.type = 2665983363;
    }
  }
  r.IfcOpenShell = Yu;
  class M3 extends b0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingOrganization = U, this.RelatedOrganizations = z, this.type = 1411181986;
    }
  }
  r.IfcOrganizationRelationship = M3;
  class S2 extends Lc {
    constructor(H, w, D, U) {
      super(H, w, new Handle(0)), this.EdgeStart = w, this.EdgeElement = D, this.Orientation = U, this.type = 1029017970;
    }
  }
  r.IfcOrientedEdge = S2;
  class a0 extends Q0 {
    constructor(H, w, D, U) {
      super(H, w, D), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.type = 2529465313;
    }
  }
  r.IfcParameterizedProfileDef = a0;
  class R2 extends Oi {
    constructor(H, w) {
      super(H), this.EdgeList = w, this.type = 2519244187;
    }
  }
  r.IfcPath = R2;
  class x3 extends I3 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D), this.Name = w, this.Description = D, this.HasQuantities = U, this.Discrimination = z, this.Quality = oe, this.Usage = ce, this.type = 3021840470;
    }
  }
  r.IfcPhysicalComplexQuantity = x3;
  class Gl extends Tc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe), this.RepeatS = w, this.RepeatT = D, this.Mode = U, this.TextureTransform = z, this.Parameter = oe, this.Width = ce, this.Height = Re, this.ColourComponents = Ne, this.Pixel = Qe, this.type = 597895409;
    }
  }
  r.IfcPixelTexture = Gl;
  class Xu extends ea {
    constructor(H, w) {
      super(H), this.Location = w, this.type = 2004835150;
    }
  }
  r.IfcPlacement = Xu;
  class jl extends ea {
    constructor(H, w, D) {
      super(H), this.SizeInX = w, this.SizeInY = D, this.type = 1663979128;
    }
  }
  r.IfcPlanarExtent = jl;
  class Vu extends ea {
    constructor(H) {
      super(H), this.type = 2067069095;
    }
  }
  r.IfcPoint = Vu;
  class Pc extends Vu {
    constructor(H, w, D, U, z, oe) {
      super(H), this.DistanceAlong = w, this.OffsetLateral = D, this.OffsetVertical = U, this.OffsetLongitudinal = z, this.BasisCurve = oe, this.type = 2165702409;
    }
  }
  r.IfcPointByDistanceExpression = Pc;
  class wc extends Vu {
    constructor(H, w, D) {
      super(H), this.BasisCurve = w, this.PointParameter = D, this.type = 4022376103;
    }
  }
  r.IfcPointOnCurve = wc;
  class Wu extends Vu {
    constructor(H, w, D, U) {
      super(H), this.BasisSurface = w, this.PointParameterU = D, this.PointParameterV = U, this.type = 1423911732;
    }
  }
  r.IfcPointOnSurface = Wu;
  class c4 extends Oc {
    constructor(H, w) {
      super(H), this.Polygon = w, this.type = 2924175390;
    }
  }
  r.IfcPolyLoop = c4;
  class T2 extends Hu {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.BaseSurface = w, this.AgreementFlag = D, this.Position = U, this.PolygonalBoundary = z, this.type = 2775532180;
    }
  }
  r.IfcPolygonalBoundedHalfSpace = T2;
  class Dc extends Va {
    constructor(H, w) {
      super(H), this.Name = w, this.type = 3727388367;
    }
  }
  r.IfcPreDefinedItem = Dc;
  class bc extends ju {
    constructor(H) {
      super(H), this.type = 3778827333;
    }
  }
  r.IfcPreDefinedProperties = bc;
  class Gc extends Dc {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 1775413392;
    }
  }
  r.IfcPreDefinedTextFont = Gc;
  class _2 extends p3 {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Representations = U, this.type = 673634403;
    }
  }
  r.IfcProductDefinitionShape = _2;
  class m2 extends Ol {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Name = w, this.Description = D, this.Properties = U, this.ProfileDefinition = z, this.type = 2802850158;
    }
  }
  r.IfcProfileProperties = m2;
  class v3 extends ju {
    constructor(H, w, D) {
      super(H), this.Name = w, this.Specification = D, this.type = 2598011224;
    }
  }
  r.IfcProperty = v3;
  class B3 extends fc {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 1680319473;
    }
  }
  r.IfcPropertyDefinition = B3;
  class Ml extends b0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.Name = w, this.Description = D, this.DependingProperty = U, this.DependantProperty = z, this.Expression = oe, this.type = 148025276;
    }
  }
  r.IfcPropertyDependencyRelationship = Ml;
  class zu extends B3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 3357820518;
    }
  }
  r.IfcPropertySetDefinition = zu;
  class U3 extends B3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 1482703590;
    }
  }
  r.IfcPropertyTemplateDefinition = U3;
  class jc extends zu {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 2090586900;
    }
  }
  r.IfcQuantitySet = jc;
  class xl extends a0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.XDim = z, this.YDim = oe, this.type = 3615266464;
    }
  }
  r.IfcRectangleProfileDef = xl;
  class y2 extends F3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.Name = w, this.Description = D, this.StartTime = U, this.EndTime = z, this.TimeSeriesDataType = oe, this.DataOrigin = ce, this.UserDefinedDataOrigin = Re, this.Unit = Ne, this.TimeStep = Qe, this.Values = tn, this.type = 3413951693;
    }
  }
  r.IfcRegularTimeSeries = y2;
  class F2 extends bc {
    constructor(H, w, D, U, z, oe, ce) {
      super(H), this.TotalCrossSectionArea = w, this.SteelGrade = D, this.BarSurface = U, this.EffectiveDepth = z, this.NominalBarDiameter = oe, this.BarCount = ce, this.type = 1580146022;
    }
  }
  r.IfcReinforcementBarProperties = F2;
  class vl extends fc {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 478536968;
    }
  }
  r.IfcRelationship = vl;
  class L2 extends b0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatedResourceObjects = U, this.RelatingApproval = z, this.type = 2943643501;
    }
  }
  r.IfcResourceApprovalRelationship = L2;
  class H3 extends b0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Description = D, this.RelatingConstraint = U, this.RelatedResourceObjects = z, this.type = 1608871552;
    }
  }
  r.IfcResourceConstraintRelationship = H3;
  class q3 extends J0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu) {
      super(H, w, D, U), this.Name = w, this.DataOrigin = D, this.UserDefinedDataOrigin = U, this.ScheduleWork = z, this.ScheduleUsage = oe, this.ScheduleStart = ce, this.ScheduleFinish = Re, this.ScheduleContour = Ne, this.LevelingDelay = Qe, this.IsOverAllocated = tn, this.StatusTime = ar, this.ActualWork = os, this.ActualUsage = ho, this.ActualStart = ra, this.ActualFinish = Wa, this.RemainingWork = r0, this.RemainingUsage = O0, this.Completion = Pu, this.type = 1042787934;
    }
  }
  r.IfcResourceTime = q3;
  class N2 extends xl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.XDim = z, this.YDim = oe, this.RoundingRadius = ce, this.type = 2778083089;
    }
  }
  r.IfcRoundedRectangleProfileDef = N2;
  class k3 extends bc {
    constructor(H, w, D, U) {
      super(H), this.SectionType = w, this.StartProfile = D, this.EndProfile = U, this.type = 2042790032;
    }
  }
  r.IfcSectionProperties = k3;
  class Y3 extends bc {
    constructor(H, w, D, U, z, oe, ce) {
      super(H), this.LongitudinalStartPosition = w, this.LongitudinalEndPosition = D, this.TransversePosition = U, this.ReinforcementRole = z, this.SectionDefinition = oe, this.CrossSectionReinforcementDefinitions = ce, this.type = 4165799628;
    }
  }
  r.IfcSectionReinforcementProperties = Y3;
  class g2 extends ea {
    constructor(H, w, D, U) {
      super(H), this.SpineCurve = w, this.CrossSections = D, this.CrossSectionPositions = U, this.type = 1509187699;
    }
  }
  r.IfcSectionedSpine = g2;
  class Mc extends ea {
    constructor(H, w) {
      super(H), this.Transition = w, this.type = 823603102;
    }
  }
  r.IfcSegment = Mc;
  class X3 extends ea {
    constructor(H, w) {
      super(H), this.SbsmBoundary = w, this.type = 4124623270;
    }
  }
  r.IfcShellBasedSurfaceModel = X3;
  class i0 extends v3 {
    constructor(H, w, D) {
      super(H, w, D), this.Name = w, this.Specification = D, this.type = 3692461612;
    }
  }
  r.IfcSimpleProperty = i0;
  class O2 extends hc {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.SlippageX = D, this.SlippageY = U, this.SlippageZ = z, this.type = 2609359061;
    }
  }
  r.IfcSlippageConnectionCondition = O2;
  class ou extends ea {
    constructor(H) {
      super(H), this.type = 723233188;
    }
  }
  r.IfcSolidModel = ou;
  class P2 extends eu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.LinearForceX = D, this.LinearForceY = U, this.LinearForceZ = z, this.LinearMomentX = oe, this.LinearMomentY = ce, this.LinearMomentZ = Re, this.type = 1595516126;
    }
  }
  r.IfcStructuralLoadLinearForce = P2;
  class E4 extends eu {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.PlanarForceX = D, this.PlanarForceY = U, this.PlanarForceZ = z, this.type = 2668620305;
    }
  }
  r.IfcStructuralLoadPlanarForce = E4;
  class pl extends eu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.DisplacementX = D, this.DisplacementY = U, this.DisplacementZ = z, this.RotationalDisplacementRX = oe, this.RotationalDisplacementRY = ce, this.RotationalDisplacementRZ = Re, this.type = 2473145415;
    }
  }
  r.IfcStructuralLoadSingleDisplacement = pl;
  class $u extends pl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.Name = w, this.DisplacementX = D, this.DisplacementY = U, this.DisplacementZ = z, this.RotationalDisplacementRX = oe, this.RotationalDisplacementRY = ce, this.RotationalDisplacementRZ = Re, this.Distortion = Ne, this.type = 1973038258;
    }
  }
  r.IfcStructuralLoadSingleDisplacementDistortion = $u;
  class q0 extends eu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w), this.Name = w, this.ForceX = D, this.ForceY = U, this.ForceZ = z, this.MomentX = oe, this.MomentY = ce, this.MomentZ = Re, this.type = 1597423693;
    }
  }
  r.IfcStructuralLoadSingleForce = q0;
  class iu extends q0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.Name = w, this.ForceX = D, this.ForceY = U, this.ForceZ = z, this.MomentX = oe, this.MomentY = ce, this.MomentZ = Re, this.WarpingMoment = Ne, this.type = 1190533807;
    }
  }
  r.IfcStructuralLoadSingleForceWarping = iu;
  class w2 extends Lc {
    constructor(H, w, D, U) {
      super(H, w, D), this.EdgeStart = w, this.EdgeEnd = D, this.ParentEdge = U, this.type = 2233826070;
    }
  }
  r.IfcSubedge = w2;
  class m0 extends ea {
    constructor(H) {
      super(H), this.type = 2513912981;
    }
  }
  r.IfcSurface = m0;
  class D2 extends Rc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D), this.SurfaceColour = w, this.Transparency = D, this.DiffuseColour = U, this.TransmissionColour = z, this.DiffuseTransmissionColour = oe, this.ReflectionColour = ce, this.SpecularColour = Re, this.SpecularHighlight = Ne, this.ReflectanceMethod = Qe, this.type = 1878645084;
    }
  }
  r.IfcSurfaceStyleRendering = D2;
  class xc extends ou {
    constructor(H, w, D) {
      super(H), this.SweptArea = w, this.Position = D, this.type = 2247615214;
    }
  }
  r.IfcSweptAreaSolid = xc;
  class I4 extends ou {
    constructor(H, w, D, U, z, oe) {
      super(H), this.Directrix = w, this.Radius = D, this.InnerRadius = U, this.StartParam = z, this.EndParam = oe, this.type = 1260650574;
    }
  }
  r.IfcSweptDiskSolid = I4;
  class b2 extends I4 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.Directrix = w, this.Radius = D, this.InnerRadius = U, this.StartParam = z, this.EndParam = oe, this.FilletRadius = ce, this.type = 1096409881;
    }
  }
  r.IfcSweptDiskSolidPolygonal = b2;
  class Z0 extends m0 {
    constructor(H, w, D) {
      super(H), this.SweptCurve = w, this.Position = D, this.type = 230924584;
    }
  }
  r.IfcSweptSurface = Z0;
  class p4 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Depth = z, this.FlangeWidth = oe, this.WebThickness = ce, this.FlangeThickness = Re, this.FilletRadius = Ne, this.FlangeEdgeRadius = Qe, this.WebEdgeRadius = tn, this.WebSlope = ar, this.FlangeSlope = os, this.type = 3071757647;
    }
  }
  r.IfcTShapeProfileDef = p4;
  class l0 extends ea {
    constructor(H) {
      super(H), this.type = 901063453;
    }
  }
  r.IfcTessellatedItem = l0;
  class au extends ea {
    constructor(H, w, D, U) {
      super(H), this.Literal = w, this.Placement = D, this.Path = U, this.type = 4282788508;
    }
  }
  r.IfcTextLiteral = au;
  class G2 extends au {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.Literal = w, this.Placement = D, this.Path = U, this.Extent = z, this.BoxAlignment = oe, this.type = 3124975700;
    }
  }
  r.IfcTextLiteralWithExtent = G2;
  class j2 extends Gc {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w), this.Name = w, this.FontFamily = D, this.FontStyle = U, this.FontVariant = z, this.FontWeight = oe, this.FontSize = ce, this.type = 1983826977;
    }
  }
  r.IfcTextStyleFontModel = j2;
  class d4 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.BottomXDim = z, this.TopXDim = oe, this.YDim = ce, this.TopXOffset = Re, this.type = 2715220739;
    }
  }
  r.IfcTrapeziumProfileDef = d4;
  class vc extends bl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.type = 1628702193;
    }
  }
  r.IfcTypeObject = vc;
  class y0 extends vc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ProcessType = Qe, this.type = 3736923433;
    }
  }
  r.IfcTypeProcess = y0;
  class V3 extends vc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.type = 2347495698;
    }
  }
  r.IfcTypeProduct = V3;
  class f4 extends vc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.type = 3698973494;
    }
  }
  r.IfcTypeResource = f4;
  class M2 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Depth = z, this.FlangeWidth = oe, this.WebThickness = ce, this.FlangeThickness = Re, this.FilletRadius = Ne, this.EdgeRadius = Qe, this.FlangeSlope = tn, this.type = 427810014;
    }
  }
  r.IfcUShapeProfileDef = M2;
  class W3 extends ea {
    constructor(H, w, D) {
      super(H), this.Orientation = w, this.Magnitude = D, this.type = 1417489154;
    }
  }
  r.IfcVector = W3;
  class x2 extends Oc {
    constructor(H, w) {
      super(H), this.LoopVertex = w, this.type = 2759199220;
    }
  }
  r.IfcVertexLoop = x2;
  class v2 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Depth = z, this.FlangeWidth = oe, this.WebThickness = ce, this.FlangeThickness = Re, this.FilletRadius = Ne, this.EdgeRadius = Qe, this.type = 2543172580;
    }
  }
  r.IfcZShapeProfileDef = v2;
  class B2 extends Bu {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Bounds = w, this.FaceSurface = D, this.SameSense = U, this.type = 3406155212;
    }
  }
  r.IfcAdvancedFace = B2;
  class U2 extends ea {
    constructor(H, w, D) {
      super(H), this.OuterBoundary = w, this.InnerBoundaries = D, this.type = 669184980;
    }
  }
  r.IfcAnnotationFillArea = U2;
  class Ma extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.BottomFlangeWidth = z, this.OverallDepth = oe, this.WebThickness = ce, this.BottomFlangeThickness = Re, this.BottomFlangeFilletRadius = Ne, this.TopFlangeWidth = Qe, this.TopFlangeThickness = tn, this.TopFlangeFilletRadius = ar, this.BottomFlangeEdgeRadius = os, this.BottomFlangeSlope = ho, this.TopFlangeEdgeRadius = ra, this.TopFlangeSlope = Wa, this.type = 3207858831;
    }
  }
  r.IfcAsymmetricIShapeProfileDef = Ma;
  class z3 extends Xu {
    constructor(H, w, D) {
      super(H, w), this.Location = w, this.Axis = D, this.type = 4261334040;
    }
  }
  r.IfcAxis1Placement = z3;
  class H2 extends Xu {
    constructor(H, w, D) {
      super(H, w), this.Location = w, this.RefDirection = D, this.type = 3125803723;
    }
  }
  r.IfcAxis2Placement2D = H2;
  class q2 extends Xu {
    constructor(H, w, D, U) {
      super(H, w), this.Location = w, this.Axis = D, this.RefDirection = U, this.type = 2740243338;
    }
  }
  r.IfcAxis2Placement3D = q2;
  class k2 extends Xu {
    constructor(H, w, D, U) {
      super(H, w), this.Location = w, this.Axis = D, this.RefDirection = U, this.type = 3425423356;
    }
  }
  r.IfcAxis2PlacementLinear = k2;
  class Bc extends ea {
    constructor(H, w, D, U) {
      super(H), this.Operator = w, this.FirstOperand = D, this.SecondOperand = U, this.type = 2736907675;
    }
  }
  r.IfcBooleanResult = Bc;
  class G0 extends m0 {
    constructor(H) {
      super(H), this.type = 4182860854;
    }
  }
  r.IfcBoundedSurface = G0;
  class C4 extends ea {
    constructor(H, w, D, U, z) {
      super(H), this.Corner = w, this.XDim = D, this.YDim = U, this.ZDim = z, this.type = 2581212453;
    }
  }
  r.IfcBoundingBox = C4;
  class Y2 extends Hu {
    constructor(H, w, D, U) {
      super(H, w, D), this.BaseSurface = w, this.AgreementFlag = D, this.Enclosure = U, this.type = 2713105998;
    }
  }
  r.IfcBoxedHalfSpace = Y2;
  class X2 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Depth = z, this.Width = oe, this.WallThickness = ce, this.Girth = Re, this.InternalFilletRadius = Ne, this.type = 2898889636;
    }
  }
  r.IfcCShapeProfileDef = X2;
  class V2 extends Vu {
    constructor(H, w) {
      super(H), this.Coordinates = w, this.type = 1123145078;
    }
  }
  r.IfcCartesianPoint = V2;
  class $3 extends ea {
    constructor(H) {
      super(H), this.type = 574549367;
    }
  }
  r.IfcCartesianPointList = $3;
  class h4 extends $3 {
    constructor(H, w, D) {
      super(H), this.CoordList = w, this.TagList = D, this.type = 1675464909;
    }
  }
  r.IfcCartesianPointList2D = h4;
  class Uc extends $3 {
    constructor(H, w, D) {
      super(H), this.CoordList = w, this.TagList = D, this.type = 2059837836;
    }
  }
  r.IfcCartesianPointList3D = Uc;
  class j0 extends ea {
    constructor(H, w, D, U, z) {
      super(H), this.Axis1 = w, this.Axis2 = D, this.LocalOrigin = U, this.Scale = z, this.type = 59481748;
    }
  }
  r.IfcCartesianTransformationOperator = j0;
  class Q3 extends j0 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.Axis1 = w, this.Axis2 = D, this.LocalOrigin = U, this.Scale = z, this.type = 3749851601;
    }
  }
  r.IfcCartesianTransformationOperator2D = Q3;
  class Hc extends Q3 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.Axis1 = w, this.Axis2 = D, this.LocalOrigin = U, this.Scale = z, this.Scale2 = oe, this.type = 3486308946;
    }
  }
  r.IfcCartesianTransformationOperator2DnonUniform = Hc;
  class k0 extends j0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.Axis1 = w, this.Axis2 = D, this.LocalOrigin = U, this.Scale = z, this.Axis3 = oe, this.type = 3331915920;
    }
  }
  r.IfcCartesianTransformationOperator3D = k0;
  class W2 extends k0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.Axis1 = w, this.Axis2 = D, this.LocalOrigin = U, this.Scale = z, this.Axis3 = oe, this.Scale2 = ce, this.Scale3 = Re, this.type = 1416205885;
    }
  }
  r.IfcCartesianTransformationOperator3DnonUniform = W2;
  class S4 extends a0 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Radius = z, this.type = 1383045692;
    }
  }
  r.IfcCircleProfileDef = S4;
  class z2 extends g3 {
    constructor(H, w) {
      super(H, w), this.CfsFaces = w, this.type = 2205249479;
    }
  }
  r.IfcClosedShell = z2;
  class $2 extends qa {
    constructor(H, w, D, U, z) {
      super(H, w), this.Name = w, this.Red = D, this.Green = U, this.Blue = z, this.type = 776857604;
    }
  }
  r.IfcColourRgb = $2;
  class Q2 extends v3 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Specification = D, this.UsageName = U, this.HasProperties = z, this.type = 2542286263;
    }
  }
  r.IfcComplexProperty = Q2;
  class R4 extends Mc {
    constructor(H, w, D, U) {
      super(H, w), this.Transition = w, this.SameSense = D, this.ParentCurve = U, this.type = 2485617015;
    }
  }
  r.IfcCompositeCurveSegment = R4;
  class Bl extends f4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.type = 2574617495;
    }
  }
  r.IfcConstructionResourceType = Bl;
  class K3 extends bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.Phase = Re, this.RepresentationContexts = Ne, this.UnitsInContext = Qe, this.type = 3419103109;
    }
  }
  r.IfcContext = K3;
  class K2 extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 1815067380;
    }
  }
  r.IfcCrewResourceType = K2;
  class lu extends ea {
    constructor(H, w) {
      super(H), this.Position = w, this.type = 2506170314;
    }
  }
  r.IfcCsgPrimitive3D = lu;
  class J3 extends ou {
    constructor(H, w) {
      super(H), this.TreeRootExpression = w, this.type = 2147822146;
    }
  }
  r.IfcCsgSolid = J3;
  class el extends ea {
    constructor(H) {
      super(H), this.type = 2601014836;
    }
  }
  r.IfcCurve = el;
  class T4 extends G0 {
    constructor(H, w, D, U) {
      super(H), this.BasisSurface = w, this.OuterBoundary = D, this.InnerBoundaries = U, this.type = 2827736869;
    }
  }
  r.IfcCurveBoundedPlane = T4;
  class J2 extends G0 {
    constructor(H, w, D, U) {
      super(H), this.BasisSurface = w, this.Boundaries = D, this.ImplicitOuter = U, this.type = 2629017746;
    }
  }
  r.IfcCurveBoundedSurface = J2;
  class Z2 extends Mc {
    constructor(H, w, D, U, z, oe) {
      super(H, w), this.Transition = w, this.Placement = D, this.SegmentStart = U, this.SegmentLength = z, this.ParentCurve = oe, this.type = 4212018352;
    }
  }
  r.IfcCurveSegment = Z2;
  class e6 extends ea {
    constructor(H, w) {
      super(H), this.DirectionRatios = w, this.type = 32440307;
    }
  }
  r.IfcDirection = e6;
  class C0 extends xc {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.SweptArea = w, this.Position = D, this.Directrix = U, this.StartParam = z, this.EndParam = oe, this.type = 593015953;
    }
  }
  r.IfcDirectrixCurveSweptAreaSolid = C0;
  class _4 extends Oc {
    constructor(H, w) {
      super(H), this.EdgeList = w, this.type = 1472233963;
    }
  }
  r.IfcEdgeLoop = _4;
  class t6 extends jc {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.MethodOfMeasurement = oe, this.Quantities = ce, this.type = 1883228015;
    }
  }
  r.IfcElementQuantity = t6;
  class F0 extends V3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 339256511;
    }
  }
  r.IfcElementType = F0;
  class Ul extends m0 {
    constructor(H, w) {
      super(H), this.Position = w, this.type = 2777663545;
    }
  }
  r.IfcElementarySurface = Ul;
  class Z3 extends a0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.SemiAxis1 = z, this.SemiAxis2 = oe, this.type = 2835456948;
    }
  }
  r.IfcEllipseProfileDef = Z3;
  class m4 extends y0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ProcessType = Qe, this.PredefinedType = tn, this.EventTriggerType = ar, this.UserDefinedEventTriggerType = os, this.type = 4024345920;
    }
  }
  r.IfcEventType = m4;
  class e1 extends xc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.SweptArea = w, this.Position = D, this.ExtrudedDirection = U, this.Depth = z, this.type = 477187591;
    }
  }
  r.IfcExtrudedAreaSolid = e1;
  class Hl extends e1 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.SweptArea = w, this.Position = D, this.ExtrudedDirection = U, this.Depth = z, this.EndSweptArea = oe, this.type = 2804161546;
    }
  }
  r.IfcExtrudedAreaSolidTapered = Hl;
  class n6 extends ea {
    constructor(H, w) {
      super(H), this.FbsmFaces = w, this.type = 2047409740;
    }
  }
  r.IfcFaceBasedSurfaceModel = n6;
  class r6 extends ea {
    constructor(H, w, D, U, z, oe) {
      super(H), this.HatchLineAppearance = w, this.StartOfNextHatchLine = D, this.PointOfReferenceHatchLine = U, this.PatternStart = z, this.HatchLineAngle = oe, this.type = 374418227;
    }
  }
  r.IfcFillAreaStyleHatching = r6;
  class s6 extends ea {
    constructor(H, w, D, U) {
      super(H), this.TilingPattern = w, this.Tiles = D, this.TilingScale = U, this.type = 315944413;
    }
  }
  r.IfcFillAreaStyleTiles = s6;
  class y4 extends C0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.SweptArea = w, this.Position = D, this.Directrix = U, this.StartParam = z, this.EndParam = oe, this.FixedReference = ce, this.type = 2652556860;
    }
  }
  r.IfcFixedReferenceSweptAreaSolid = y4;
  class t1 extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 4238390223;
    }
  }
  r.IfcFurnishingElementType = t1;
  class r1 extends t1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.AssemblyPlace = tn, this.PredefinedType = ar, this.type = 1268542332;
    }
  }
  r.IfcFurnitureType = r1;
  class e0 extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4095422895;
    }
  }
  r.IfcGeographicElementType = e0;
  class qc extends P3 {
    constructor(H, w) {
      super(H, w), this.Elements = w, this.type = 987898635;
    }
  }
  r.IfcGeometricCurveSet = qc;
  class o6 extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.OverallWidth = z, this.OverallDepth = oe, this.WebThickness = ce, this.FlangeThickness = Re, this.FilletRadius = Ne, this.FlangeEdgeRadius = Qe, this.FlangeSlope = tn, this.type = 1484403080;
    }
  }
  r.IfcIShapeProfileDef = o6;
  class F4 extends l0 {
    constructor(H, w) {
      super(H), this.CoordIndex = w, this.type = 178912537;
    }
  }
  r.IfcIndexedPolygonalFace = F4;
  class i6 extends F4 {
    constructor(H, w, D) {
      super(H, w), this.CoordIndex = w, this.InnerCoordIndices = D, this.type = 2294589976;
    }
  }
  r.IfcIndexedPolygonalFaceWithVoids = i6;
  class a6 extends ru {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Maps = w, this.MappedTo = D, this.TexCoords = U, this.TexCoordIndices = z, this.type = 3465909080;
    }
  }
  r.IfcIndexedPolygonalTextureMap = a6;
  class uu extends a0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Depth = z, this.Width = oe, this.Thickness = ce, this.FilletRadius = Re, this.EdgeRadius = Ne, this.LegSlope = Qe, this.type = 572779678;
    }
  }
  r.IfcLShapeProfileDef = uu;
  class l6 extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 428585644;
    }
  }
  r.IfcLaborResourceType = l6;
  class h0 extends el {
    constructor(H, w, D) {
      super(H), this.Pnt = w, this.Dir = D, this.type = 1281925730;
    }
  }
  r.IfcLine = h0;
  class s1 extends ou {
    constructor(H, w) {
      super(H), this.Outer = w, this.type = 1425443689;
    }
  }
  r.IfcManifoldSolidBrep = s1;
  class ql extends bl {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.type = 3888040117;
    }
  }
  r.IfcObject = ql;
  class kc extends el {
    constructor(H, w) {
      super(H), this.BasisCurve = w, this.type = 590820931;
    }
  }
  r.IfcOffsetCurve = kc;
  class L4 extends kc {
    constructor(H, w, D, U) {
      super(H, w), this.BasisCurve = w, this.Distance = D, this.SelfIntersect = U, this.type = 3388369263;
    }
  }
  r.IfcOffsetCurve2D = L4;
  class kl extends kc {
    constructor(H, w, D, U, z) {
      super(H, w), this.BasisCurve = w, this.Distance = D, this.SelfIntersect = U, this.RefDirection = z, this.type = 3505215534;
    }
  }
  r.IfcOffsetCurve3D = kl;
  class M0 extends kc {
    constructor(H, w, D, U) {
      super(H, w), this.BasisCurve = w, this.OffsetValues = D, this.Tag = U, this.type = 2485787929;
    }
  }
  r.IfcOffsetCurveByDistances = M0;
  class t0 extends el {
    constructor(H, w, D) {
      super(H), this.BasisSurface = w, this.ReferenceCurve = D, this.type = 1682466193;
    }
  }
  r.IfcPcurve = t0;
  class u6 extends jl {
    constructor(H, w, D, U) {
      super(H, w, D), this.SizeInX = w, this.SizeInY = D, this.Placement = U, this.type = 603570806;
    }
  }
  r.IfcPlanarBox = u6;
  class c6 extends Ul {
    constructor(H, w) {
      super(H, w), this.Position = w, this.type = 220341763;
    }
  }
  r.IfcPlane = c6;
  class E6 extends el {
    constructor(H, w, D, U, z) {
      super(H), this.Position = w, this.CoefficientsX = D, this.CoefficientsY = U, this.CoefficientsZ = z, this.type = 3381221214;
    }
  }
  r.IfcPolynomialCurve = E6;
  class N4 extends Dc {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 759155922;
    }
  }
  r.IfcPreDefinedColour = N4;
  class g4 extends Dc {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 2559016684;
    }
  }
  r.IfcPreDefinedCurveFont = g4;
  class x0 extends zu {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 3967405729;
    }
  }
  r.IfcPreDefinedPropertySet = x0;
  class o1 extends y0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ProcessType = Qe, this.PredefinedType = tn, this.type = 569719735;
    }
  }
  r.IfcProcedureType = o1;
  class S0 extends ql {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.type = 2945172077;
    }
  }
  r.IfcProcess = S0;
  class tl extends ql {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 4208778838;
    }
  }
  r.IfcProduct = tl;
  class v0 extends K3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.Phase = Re, this.RepresentationContexts = Ne, this.UnitsInContext = Qe, this.type = 103090709;
    }
  }
  r.IfcProject = v0;
  class I6 extends K3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.Phase = Re, this.RepresentationContexts = Ne, this.UnitsInContext = Qe, this.type = 653396225;
    }
  }
  r.IfcProjectLibrary = I6;
  class Yc extends i0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D), this.Name = w, this.Specification = D, this.UpperBoundValue = U, this.LowerBoundValue = z, this.Unit = oe, this.SetPointValue = ce, this.type = 871118103;
    }
  }
  r.IfcPropertyBoundedValue = Yc;
  class Xc extends i0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Specification = D, this.EnumerationValues = U, this.EnumerationReference = z, this.type = 4166981789;
    }
  }
  r.IfcPropertyEnumeratedValue = Xc;
  class p6 extends i0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Specification = D, this.ListValues = U, this.Unit = z, this.type = 2752243245;
    }
  }
  r.IfcPropertyListValue = p6;
  class ka extends i0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Specification = D, this.UsageName = U, this.PropertyReference = z, this.type = 941946838;
    }
  }
  r.IfcPropertyReferenceValue = ka;
  class d6 extends zu {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.HasProperties = oe, this.type = 1451395588;
    }
  }
  r.IfcPropertySet = d6;
  class O4 extends U3 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.TemplateType = oe, this.ApplicableEntity = ce, this.HasPropertyTemplates = Re, this.type = 492091185;
    }
  }
  r.IfcPropertySetTemplate = O4;
  class P4 extends i0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Name = w, this.Specification = D, this.NominalValue = U, this.Unit = z, this.type = 3650150729;
    }
  }
  r.IfcPropertySingleValue = P4;
  class f6 extends i0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D), this.Name = w, this.Specification = D, this.DefiningValues = U, this.DefinedValues = z, this.Expression = oe, this.DefiningUnit = ce, this.DefinedUnit = Re, this.CurveInterpolation = Ne, this.type = 110355661;
    }
  }
  r.IfcPropertyTableValue = f6;
  class i1 extends U3 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 3521284610;
    }
  }
  r.IfcPropertyTemplate = i1;
  class C6 extends xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.XDim = z, this.YDim = oe, this.WallThickness = ce, this.InnerFilletRadius = Re, this.OuterFilletRadius = Ne, this.type = 2770003689;
    }
  }
  r.IfcRectangleHollowProfileDef = C6;
  class w4 extends lu {
    constructor(H, w, D, U, z) {
      super(H, w), this.Position = w, this.XLength = D, this.YLength = U, this.Height = z, this.type = 2798486643;
    }
  }
  r.IfcRectangularPyramid = w4;
  class Qu extends G0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.BasisSurface = w, this.U1 = D, this.V1 = U, this.U2 = z, this.V2 = oe, this.Usense = ce, this.Vsense = Re, this.type = 3454111270;
    }
  }
  r.IfcRectangularTrimmedSurface = Qu;
  class Ku extends x0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.DefinitionType = oe, this.ReinforcementSectionDefinitions = ce, this.type = 3765753017;
    }
  }
  r.IfcReinforcementDefinitionProperties = Ku;
  class A0 extends vl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.type = 3939117080;
    }
  }
  r.IfcRelAssigns = A0;
  class Vc extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingActor = Re, this.ActingRole = Ne, this.type = 1683148259;
    }
  }
  r.IfcRelAssignsToActor = Vc;
  class dl extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingControl = Re, this.type = 2495723537;
    }
  }
  r.IfcRelAssignsToControl = dl;
  class cu extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingGroup = Re, this.type = 1307041759;
    }
  }
  r.IfcRelAssignsToGroup = cu;
  class h6 extends cu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingGroup = Re, this.Factor = Ne, this.type = 1027710054;
    }
  }
  r.IfcRelAssignsToGroupByFactor = h6;
  class Wc extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingProcess = Re, this.QuantityInProcess = Ne, this.type = 4278684876;
    }
  }
  r.IfcRelAssignsToProcess = Wc;
  class Yl extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingProduct = Re, this.type = 2857406711;
    }
  }
  r.IfcRelAssignsToProduct = Yl;
  class Ju extends A0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatedObjectsType = ce, this.RelatingResource = Re, this.type = 205026976;
    }
  }
  r.IfcRelAssignsToResource = Ju;
  class wa extends vl {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.type = 1865459582;
    }
  }
  r.IfcRelAssociates = wa;
  class Eu extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingApproval = ce, this.type = 4095574036;
    }
  }
  r.IfcRelAssociatesApproval = Eu;
  class D4 extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingClassification = ce, this.type = 919958153;
    }
  }
  r.IfcRelAssociatesClassification = D4;
  class S6 extends wa {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.Intent = ce, this.RelatingConstraint = Re, this.type = 2728634034;
    }
  }
  r.IfcRelAssociatesConstraint = S6;
  class R6 extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingDocument = ce, this.type = 982818633;
    }
  }
  r.IfcRelAssociatesDocument = R6;
  class T6 extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingLibrary = ce, this.type = 3840914261;
    }
  }
  r.IfcRelAssociatesLibrary = T6;
  class Y0 extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingMaterial = ce, this.type = 2655215786;
    }
  }
  r.IfcRelAssociatesMaterial = Y0;
  class _6 extends wa {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingProfileDef = ce, this.type = 1033248425;
    }
  }
  r.IfcRelAssociatesProfileDef = _6;
  class Ka extends vl {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 826625072;
    }
  }
  r.IfcRelConnects = Ka;
  class a1 extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ConnectionGeometry = oe, this.RelatingElement = ce, this.RelatedElement = Re, this.type = 1204542856;
    }
  }
  r.IfcRelConnectsElements = a1;
  class m6 extends a1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ConnectionGeometry = oe, this.RelatingElement = ce, this.RelatedElement = Re, this.RelatingPriorities = Ne, this.RelatedPriorities = Qe, this.RelatedConnectionType = tn, this.RelatingConnectionType = ar, this.type = 3945020480;
    }
  }
  r.IfcRelConnectsPathElements = m6;
  class y6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingPort = oe, this.RelatedElement = ce, this.type = 4201705270;
    }
  }
  r.IfcRelConnectsPortToElement = y6;
  class F6 extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingPort = oe, this.RelatedPort = ce, this.RealizingElement = Re, this.type = 3190031847;
    }
  }
  r.IfcRelConnectsPorts = F6;
  class l1 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingElement = oe, this.RelatedStructuralActivity = ce, this.type = 2127690289;
    }
  }
  r.IfcRelConnectsStructuralActivity = l1;
  class b4 extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingStructuralMember = oe, this.RelatedStructuralConnection = ce, this.AppliedCondition = Re, this.AdditionalConditions = Ne, this.SupportedLength = Qe, this.ConditionCoordinateSystem = tn, this.type = 1638771189;
    }
  }
  r.IfcRelConnectsStructuralMember = b4;
  class A6 extends b4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingStructuralMember = oe, this.RelatedStructuralConnection = ce, this.AppliedCondition = Re, this.AdditionalConditions = Ne, this.SupportedLength = Qe, this.ConditionCoordinateSystem = tn, this.ConnectionConstraint = ar, this.type = 504942748;
    }
  }
  r.IfcRelConnectsWithEccentricity = A6;
  class L6 extends a1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ConnectionGeometry = oe, this.RelatingElement = ce, this.RelatedElement = Re, this.RealizingElements = Ne, this.ConnectionType = Qe, this.type = 3678494232;
    }
  }
  r.IfcRelConnectsWithRealizingElements = L6;
  class N6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedElements = oe, this.RelatingStructure = ce, this.type = 3242617779;
    }
  }
  r.IfcRelContainedInSpatialStructure = N6;
  class g6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingBuildingElement = oe, this.RelatedCoverings = ce, this.type = 886880790;
    }
  }
  r.IfcRelCoversBldgElements = g6;
  class G4 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingSpace = oe, this.RelatedCoverings = ce, this.type = 2802773753;
    }
  }
  r.IfcRelCoversSpaces = G4;
  class j4 extends vl {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingContext = oe, this.RelatedDefinitions = ce, this.type = 2565941209;
    }
  }
  r.IfcRelDeclares = j4;
  class Iu extends vl {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 2551354335;
    }
  }
  r.IfcRelDecomposes = Iu;
  class Zu extends vl {
    constructor(H, w, D, U, z) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.type = 693640335;
    }
  }
  r.IfcRelDefines = Zu;
  class M4 extends Zu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingObject = ce, this.type = 1462361463;
    }
  }
  r.IfcRelDefinesByObject = M4;
  class x4 extends Zu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingPropertyDefinition = ce, this.type = 4186316022;
    }
  }
  r.IfcRelDefinesByProperties = x4;
  class O6 extends Zu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedPropertySets = oe, this.RelatingTemplate = ce, this.type = 307848117;
    }
  }
  r.IfcRelDefinesByTemplate = O6;
  class P6 extends Zu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedObjects = oe, this.RelatingType = ce, this.type = 781010003;
    }
  }
  r.IfcRelDefinesByType = P6;
  class pu extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingOpeningElement = oe, this.RelatedBuildingElement = ce, this.type = 3940055652;
    }
  }
  r.IfcRelFillsElement = pu;
  class w6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedControlElements = oe, this.RelatingFlowElement = ce, this.type = 279856033;
    }
  }
  r.IfcRelFlowControlElements = w6;
  class ya extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingElement = oe, this.RelatedElement = ce, this.InterferenceGeometry = Re, this.InterferenceSpace = Ne, this.InterferenceType = Qe, this.ImpliedOrder = tn, this.type = 427948657;
    }
  }
  r.IfcRelInterferesElements = ya;
  class v4 extends Iu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingObject = oe, this.RelatedObjects = ce, this.type = 3268803585;
    }
  }
  r.IfcRelNests = v4;
  class D6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingPositioningElement = oe, this.RelatedProducts = ce, this.type = 1441486842;
    }
  }
  r.IfcRelPositions = D6;
  class b6 extends Iu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingElement = oe, this.RelatedFeatureElement = ce, this.type = 750771296;
    }
  }
  r.IfcRelProjectsElement = b6;
  class G6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatedElements = oe, this.RelatingStructure = ce, this.type = 1245217292;
    }
  }
  r.IfcRelReferencedInSpatialStructure = G6;
  class j6 extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingProcess = oe, this.RelatedProcess = ce, this.TimeLag = Re, this.SequenceType = Ne, this.UserDefinedSequenceType = Qe, this.type = 4122056220;
    }
  }
  r.IfcRelSequence = j6;
  class M6 extends Ka {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingSystem = oe, this.RelatedBuildings = ce, this.type = 366585022;
    }
  }
  r.IfcRelServicesBuildings = M6;
  class u1 extends Ka {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingSpace = oe, this.RelatedBuildingElement = ce, this.ConnectionGeometry = Re, this.PhysicalOrVirtualBoundary = Ne, this.InternalOrExternalBoundary = Qe, this.type = 3451746338;
    }
  }
  r.IfcRelSpaceBoundary = u1;
  class c1 extends u1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingSpace = oe, this.RelatedBuildingElement = ce, this.ConnectionGeometry = Re, this.PhysicalOrVirtualBoundary = Ne, this.InternalOrExternalBoundary = Qe, this.ParentBoundary = tn, this.type = 3523091289;
    }
  }
  r.IfcRelSpaceBoundary1stLevel = c1;
  class E1 extends c1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingSpace = oe, this.RelatedBuildingElement = ce, this.ConnectionGeometry = Re, this.PhysicalOrVirtualBoundary = Ne, this.InternalOrExternalBoundary = Qe, this.ParentBoundary = tn, this.CorrespondingBoundary = ar, this.type = 1521410863;
    }
  }
  r.IfcRelSpaceBoundary2ndLevel = E1;
  class x6 extends Iu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingBuildingElement = oe, this.RelatedOpeningElement = ce, this.type = 1401173127;
    }
  }
  r.IfcRelVoidsElement = x6;
  class v6 extends R4 {
    constructor(H, w, D, U, z) {
      super(H, w, D, U), this.Transition = w, this.SameSense = D, this.ParentCurve = U, this.ParamLength = z, this.type = 816062949;
    }
  }
  r.IfcReparametrisedCompositeCurveSegment = v6;
  class B4 extends ql {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.type = 2914609552;
    }
  }
  r.IfcResource = B4;
  class fl extends xc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.SweptArea = w, this.Position = D, this.Axis = U, this.Angle = z, this.type = 1856042241;
    }
  }
  r.IfcRevolvedAreaSolid = fl;
  class nl extends fl {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.SweptArea = w, this.Position = D, this.Axis = U, this.Angle = z, this.EndSweptArea = oe, this.type = 3243963512;
    }
  }
  r.IfcRevolvedAreaSolidTapered = nl;
  class B6 extends lu {
    constructor(H, w, D, U) {
      super(H, w), this.Position = w, this.Height = D, this.BottomRadius = U, this.type = 4158566097;
    }
  }
  r.IfcRightCircularCone = B6;
  class U6 extends lu {
    constructor(H, w, D, U) {
      super(H, w), this.Position = w, this.Height = D, this.Radius = U, this.type = 3626867408;
    }
  }
  r.IfcRightCircularCylinder = U6;
  class U4 extends ou {
    constructor(H, w, D) {
      super(H), this.Directrix = w, this.CrossSections = D, this.type = 1862484736;
    }
  }
  r.IfcSectionedSolid = U4;
  class H6 extends U4 {
    constructor(H, w, D, U) {
      super(H, w, D), this.Directrix = w, this.CrossSections = D, this.CrossSectionPositions = U, this.type = 1290935644;
    }
  }
  r.IfcSectionedSolidHorizontal = H6;
  class q6 extends m0 {
    constructor(H, w, D, U) {
      super(H), this.Directrix = w, this.CrossSectionPositions = D, this.CrossSections = U, this.type = 1356537516;
    }
  }
  r.IfcSectionedSurface = q6;
  class k6 extends i1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.TemplateType = oe, this.PrimaryMeasureType = ce, this.SecondaryMeasureType = Re, this.Enumerators = Ne, this.PrimaryUnit = Qe, this.SecondaryUnit = tn, this.Expression = ar, this.AccessState = os, this.type = 3663146110;
    }
  }
  r.IfcSimplePropertyTemplate = k6;
  class du extends tl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.type = 1412071761;
    }
  }
  r.IfcSpatialElement = du;
  class L0 extends V3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 710998568;
    }
  }
  r.IfcSpatialElementType = L0;
  class fu extends du {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.type = 2706606064;
    }
  }
  r.IfcSpatialStructureElement = fu;
  class tc extends L0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3893378262;
    }
  }
  r.IfcSpatialStructureElementType = tc;
  class zc extends du {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.PredefinedType = Qe, this.type = 463610769;
    }
  }
  r.IfcSpatialZone = zc;
  class Y6 extends L0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.LongName = ar, this.type = 2481509218;
    }
  }
  r.IfcSpatialZoneType = Y6;
  class H4 extends lu {
    constructor(H, w, D) {
      super(H, w), this.Position = w, this.Radius = D, this.type = 451544542;
    }
  }
  r.IfcSphere = H4;
  class B0 extends Ul {
    constructor(H, w, D) {
      super(H, w), this.Position = w, this.Radius = D, this.type = 4015995234;
    }
  }
  r.IfcSphericalSurface = B0;
  class Cl extends el {
    constructor(H, w) {
      super(H), this.Position = w, this.type = 2735484536;
    }
  }
  r.IfcSpiral = Cl;
  class I1 extends tl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.type = 3544373492;
    }
  }
  r.IfcStructuralActivity = I1;
  class rl extends tl {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 3136571912;
    }
  }
  r.IfcStructuralItem = rl;
  class X0 extends rl {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 530289379;
    }
  }
  r.IfcStructuralMember = X0;
  class $c extends I1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.type = 3689010777;
    }
  }
  r.IfcStructuralReaction = $c;
  class Fa extends X0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.Thickness = Qe, this.type = 3979015343;
    }
  }
  r.IfcStructuralSurfaceMember = Fa;
  class X6 extends Fa {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.Thickness = Qe, this.type = 2218152070;
    }
  }
  r.IfcStructuralSurfaceMemberVarying = X6;
  class V6 extends $c {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.PredefinedType = tn, this.type = 603775116;
    }
  }
  r.IfcStructuralSurfaceReaction = V6;
  class W6 extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 4095615324;
    }
  }
  r.IfcSubContractResourceType = W6;
  class p1 extends el {
    constructor(H, w, D, U) {
      super(H), this.Curve3D = w, this.AssociatedGeometry = D, this.MasterRepresentation = U, this.type = 699246055;
    }
  }
  r.IfcSurfaceCurve = p1;
  class q4 extends C0 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.SweptArea = w, this.Position = D, this.Directrix = U, this.StartParam = z, this.EndParam = oe, this.ReferenceSurface = ce, this.type = 2028607225;
    }
  }
  r.IfcSurfaceCurveSweptAreaSolid = q4;
  class k4 extends Z0 {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.SweptCurve = w, this.Position = D, this.ExtrudedDirection = U, this.Depth = z, this.type = 2809605785;
    }
  }
  r.IfcSurfaceOfLinearExtrusion = k4;
  class d1 extends Z0 {
    constructor(H, w, D, U) {
      super(H, w, D), this.SweptCurve = w, this.Position = D, this.AxisPosition = U, this.type = 4124788165;
    }
  }
  r.IfcSurfaceOfRevolution = d1;
  class z6 extends t1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1580310250;
    }
  }
  r.IfcSystemFurnitureElementType = z6;
  class $6 extends S0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Status = Ne, this.WorkMethod = Qe, this.IsMilestone = tn, this.Priority = ar, this.TaskTime = os, this.PredefinedType = ho, this.type = 3473067441;
    }
  }
  r.IfcTask = $6;
  class Qc extends y0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ProcessType = Qe, this.PredefinedType = tn, this.WorkMethod = ar, this.type = 3206491090;
    }
  }
  r.IfcTaskType = Qc;
  class Kc extends l0 {
    constructor(H, w, D) {
      super(H), this.Coordinates = w, this.Closed = D, this.type = 2387106220;
    }
  }
  r.IfcTessellatedFaceSet = Kc;
  class f1 extends Cl {
    constructor(H, w, D, U, z, oe) {
      super(H, w), this.Position = w, this.CubicTerm = D, this.QuadraticTerm = U, this.LinearTerm = z, this.ConstantTerm = oe, this.type = 782932809;
    }
  }
  r.IfcThirdOrderPolynomialSpiral = f1;
  class sl extends Ul {
    constructor(H, w, D, U) {
      super(H, w), this.Position = w, this.MajorRadius = D, this.MinorRadius = U, this.type = 1935646853;
    }
  }
  r.IfcToroidalSurface = sl;
  class hl extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3665877780;
    }
  }
  r.IfcTransportationDeviceType = hl;
  class Y4 extends Kc {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D), this.Coordinates = w, this.Closed = D, this.Normals = U, this.CoordIndex = z, this.PnIndex = oe, this.type = 2916149573;
    }
  }
  r.IfcTriangulatedFaceSet = Y4;
  class Jc extends Y4 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.Coordinates = w, this.Closed = D, this.Normals = U, this.CoordIndex = z, this.PnIndex = oe, this.Flags = ce, this.type = 1229763772;
    }
  }
  r.IfcTriangulatedIrregularNetwork = Jc;
  class nc extends hl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3651464721;
    }
  }
  r.IfcVehicleType = nc;
  class h1 extends x0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.LiningDepth = oe, this.LiningThickness = ce, this.TransomThickness = Re, this.MullionThickness = Ne, this.FirstTransomOffset = Qe, this.SecondTransomOffset = tn, this.FirstMullionOffset = ar, this.SecondMullionOffset = os, this.ShapeAspectStyle = ho, this.LiningOffset = ra, this.LiningToPanelOffsetX = Wa, this.LiningToPanelOffsetY = r0, this.type = 336235671;
    }
  }
  r.IfcWindowLiningProperties = h1;
  class n0 extends x0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.OperationType = oe, this.PanelPosition = ce, this.FrameDepth = Re, this.FrameThickness = Ne, this.ShapeAspectStyle = Qe, this.type = 512836454;
    }
  }
  r.IfcWindowPanelProperties = n0;
  class rc extends ql {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.TheActor = ce, this.type = 2296667514;
    }
  }
  r.IfcActor = rc;
  class X4 extends s1 {
    constructor(H, w) {
      super(H, w), this.Outer = w, this.type = 1635779807;
    }
  }
  r.IfcAdvancedBrep = X4;
  class S1 extends X4 {
    constructor(H, w, D) {
      super(H, w), this.Outer = w, this.Voids = D, this.type = 2603310189;
    }
  }
  r.IfcAdvancedBrepWithVoids = S1;
  class Q6 extends tl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.type = 1674181508;
    }
  }
  r.IfcAnnotation = Q6;
  class V4 extends G0 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H), this.UDegree = w, this.VDegree = D, this.ControlPointsList = U, this.SurfaceForm = z, this.UClosed = oe, this.VClosed = ce, this.SelfIntersect = Re, this.type = 2887950389;
    }
  }
  r.IfcBSplineSurface = V4;
  class W4 extends V4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re), this.UDegree = w, this.VDegree = D, this.ControlPointsList = U, this.SurfaceForm = z, this.UClosed = oe, this.VClosed = ce, this.SelfIntersect = Re, this.UMultiplicities = Ne, this.VMultiplicities = Qe, this.UKnots = tn, this.VKnots = ar, this.KnotSpec = os, this.type = 167062518;
    }
  }
  r.IfcBSplineSurfaceWithKnots = W4;
  class Cu extends lu {
    constructor(H, w, D, U, z) {
      super(H, w), this.Position = w, this.XLength = D, this.YLength = U, this.ZLength = z, this.type = 1334484129;
    }
  }
  r.IfcBlock = Cu;
  class K6 extends Bc {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Operator = w, this.FirstOperand = D, this.SecondOperand = U, this.type = 3649129432;
    }
  }
  r.IfcBooleanClippingResult = K6;
  class hu extends el {
    constructor(H) {
      super(H), this.type = 1260505505;
    }
  }
  r.IfcBoundedCurve = hu;
  class J6 extends fu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.Elevation = tn, this.type = 3124254112;
    }
  }
  r.IfcBuildingStorey = J6;
  class qi extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 1626504194;
    }
  }
  r.IfcBuiltElementType = qi;
  class Z6 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2197970202;
    }
  }
  r.IfcChimneyType = Z6;
  class z4 extends S4 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z), this.ProfileType = w, this.ProfileName = D, this.Position = U, this.Radius = z, this.WallThickness = oe, this.type = 2937912522;
    }
  }
  r.IfcCircleHollowProfileDef = z4;
  class eI extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3893394355;
    }
  }
  r.IfcCivilElementType = eI;
  class Da extends Cl {
    constructor(H, w, D) {
      super(H, w), this.Position = w, this.ClothoidConstant = D, this.type = 3497074424;
    }
  }
  r.IfcClothoid = Da;
  class R1 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 300633059;
    }
  }
  r.IfcColumnType = R1;
  class tI extends i1 {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.UsageName = oe, this.TemplateType = ce, this.HasPropertyTemplates = Re, this.type = 3875453745;
    }
  }
  r.IfcComplexPropertyTemplate = tI;
  class Zc extends hu {
    constructor(H, w, D) {
      super(H), this.Segments = w, this.SelfIntersect = D, this.type = 3732776249;
    }
  }
  r.IfcCompositeCurve = Zc;
  class $4 extends Zc {
    constructor(H, w, D) {
      super(H, w, D), this.Segments = w, this.SelfIntersect = D, this.type = 15328376;
    }
  }
  r.IfcCompositeCurveOnSurface = $4;
  class T1 extends el {
    constructor(H, w) {
      super(H), this.Position = w, this.type = 2510884976;
    }
  }
  r.IfcConic = T1;
  class nI extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 2185764099;
    }
  }
  r.IfcConstructionEquipmentResourceType = nI;
  class rI extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 4105962743;
    }
  }
  r.IfcConstructionMaterialResourceType = rI;
  class sI extends Bl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.Identification = Re, this.LongDescription = Ne, this.ResourceType = Qe, this.BaseCosts = tn, this.BaseQuantity = ar, this.PredefinedType = os, this.type = 1525564444;
    }
  }
  r.IfcConstructionProductResourceType = sI;
  class Sl extends B4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.type = 2559216714;
    }
  }
  r.IfcConstructionResource = Sl;
  class ol extends ql {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.type = 3293443760;
    }
  }
  r.IfcControl = ol;
  class oI extends Cl {
    constructor(H, w, D, U) {
      super(H, w), this.Position = w, this.CosineTerm = D, this.ConstantTerm = U, this.type = 2000195564;
    }
  }
  r.IfcCosineSpiral = oI;
  class iI extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.PredefinedType = Re, this.CostValues = Ne, this.CostQuantities = Qe, this.type = 3895139033;
    }
  }
  r.IfcCostItem = iI;
  class aI extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.PredefinedType = Re, this.Status = Ne, this.SubmittedOn = Qe, this.UpdateDate = tn, this.type = 1419761937;
    }
  }
  r.IfcCostSchedule = aI;
  class lI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4189326743;
    }
  }
  r.IfcCourseType = lI;
  class uI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1916426348;
    }
  }
  r.IfcCoveringType = uI;
  class cI extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 3295246426;
    }
  }
  r.IfcCrewResource = cI;
  class EI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1457835157;
    }
  }
  r.IfcCurtainWallType = EI;
  class II extends Ul {
    constructor(H, w, D) {
      super(H, w), this.Position = w, this.Radius = D, this.type = 1213902940;
    }
  }
  r.IfcCylindricalSurface = II;
  class m1 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 1306400036;
    }
  }
  r.IfcDeepFoundationType = m1;
  class pI extends y4 {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe, ce), this.SweptArea = w, this.Position = D, this.Directrix = U, this.StartParam = z, this.EndParam = oe, this.FixedReference = ce, this.type = 4234616927;
    }
  }
  r.IfcDirectrixDerivedReferenceSweptAreaSolid = pI;
  class e3 extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3256556792;
    }
  }
  r.IfcDistributionElementType = e3;
  class V0 extends e3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3849074793;
    }
  }
  r.IfcDistributionFlowElementType = V0;
  class dI extends x0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.LiningDepth = oe, this.LiningThickness = ce, this.ThresholdDepth = Re, this.ThresholdThickness = Ne, this.TransomThickness = Qe, this.TransomOffset = tn, this.LiningOffset = ar, this.ThresholdOffset = os, this.CasingThickness = ho, this.CasingDepth = ra, this.ShapeAspectStyle = Wa, this.LiningToPanelOffsetX = r0, this.LiningToPanelOffsetY = O0, this.type = 2963535650;
    }
  }
  r.IfcDoorLiningProperties = dI;
  class fI extends x0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.PanelDepth = oe, this.PanelOperation = ce, this.PanelWidth = Re, this.PanelPosition = Ne, this.ShapeAspectStyle = Qe, this.type = 1714330368;
    }
  }
  r.IfcDoorPanelProperties = fI;
  class CI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.OperationType = ar, this.ParameterTakesPrecedence = os, this.UserDefinedOperationType = ho, this.type = 2323601079;
    }
  }
  r.IfcDoorType = CI;
  class Q4 extends N4 {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 445594917;
    }
  }
  r.IfcDraughtingPreDefinedColour = Q4;
  class hI extends g4 {
    constructor(H, w) {
      super(H, w), this.Name = w, this.type = 4006246654;
    }
  }
  r.IfcDraughtingPreDefinedCurveFont = hI;
  class Ja extends tl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1758889154;
    }
  }
  r.IfcElement = Ja;
  class y1 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.AssemblyPlace = Qe, this.PredefinedType = tn, this.type = 4123344466;
    }
  }
  r.IfcElementAssembly = y1;
  class W0 extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2397081782;
    }
  }
  r.IfcElementAssemblyType = W0;
  class u0 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1623761950;
    }
  }
  r.IfcElementComponent = u0;
  class c0 extends F0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 2590856083;
    }
  }
  r.IfcElementComponentType = c0;
  class SI extends T1 {
    constructor(H, w, D, U) {
      super(H, w), this.Position = w, this.SemiAxis1 = D, this.SemiAxis2 = U, this.type = 1704287377;
    }
  }
  r.IfcEllipse = SI;
  class ba extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 2107101300;
    }
  }
  r.IfcEnergyConversionDeviceType = ba;
  class RI extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 132023988;
    }
  }
  r.IfcEngineType = RI;
  class F1 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3174744832;
    }
  }
  r.IfcEvaporativeCoolerType = F1;
  class TI extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3390157468;
    }
  }
  r.IfcEvaporatorType = TI;
  class _I extends S0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.PredefinedType = Ne, this.EventTriggerType = Qe, this.UserDefinedEventTriggerType = tn, this.EventOccurenceTime = ar, this.type = 4148101412;
    }
  }
  r.IfcEvent = _I;
  class K4 extends du {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.type = 2853485674;
    }
  }
  r.IfcExternalSpatialStructureElement = K4;
  class J4 extends s1 {
    constructor(H, w) {
      super(H, w), this.Outer = w, this.type = 807026263;
    }
  }
  r.IfcFacetedBrep = J4;
  class mI extends J4 {
    constructor(H, w, D) {
      super(H, w), this.Outer = w, this.Voids = D, this.type = 3737207727;
    }
  }
  r.IfcFacetedBrepWithVoids = mI;
  class Su extends fu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.type = 24185140;
    }
  }
  r.IfcFacility = Su;
  class Ru extends fu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.type = 1310830890;
    }
  }
  r.IfcFacilityPart = Ru;
  class yI extends Ru {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.PredefinedType = ar, this.type = 4228831410;
    }
  }
  r.IfcFacilityPartCommon = yI;
  class FI extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 647756555;
    }
  }
  r.IfcFastener = FI;
  class AI extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2489546625;
    }
  }
  r.IfcFastenerType = AI;
  class t3 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2827207264;
    }
  }
  r.IfcFeatureElement = t3;
  class Z4 extends t3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2143335405;
    }
  }
  r.IfcFeatureElementAddition = Z4;
  class Rl extends t3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1287392070;
    }
  }
  r.IfcFeatureElementSubtraction = Rl;
  class R0 extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3907093117;
    }
  }
  r.IfcFlowControllerType = R0;
  class Xl extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3198132628;
    }
  }
  r.IfcFlowFittingType = Xl;
  class LI extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3815607619;
    }
  }
  r.IfcFlowMeterType = LI;
  class sc extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 1482959167;
    }
  }
  r.IfcFlowMovingDeviceType = sc;
  class Tu extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 1834744321;
    }
  }
  r.IfcFlowSegmentType = Tu;
  class L1 extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 1339347760;
    }
  }
  r.IfcFlowStorageDeviceType = L1;
  class Za extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 2297155007;
    }
  }
  r.IfcFlowTerminalType = Za;
  class _u extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 3009222698;
    }
  }
  r.IfcFlowTreatmentDeviceType = _u;
  class NI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1893162501;
    }
  }
  r.IfcFootingType = NI;
  class N1 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 263784265;
    }
  }
  r.IfcFurnishingElement = N1;
  class gI extends N1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1509553395;
    }
  }
  r.IfcFurniture = gI;
  class OI extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3493046030;
    }
  }
  r.IfcGeographicElement = OI;
  class n3 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 4230923436;
    }
  }
  r.IfcGeotechnicalElement = n3;
  class wI extends n3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1594536857;
    }
  }
  r.IfcGeotechnicalStratum = wI;
  class DI extends Zc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Segments = w, this.SelfIntersect = D, this.BaseCurve = U, this.EndPoint = z, this.type = 2898700619;
    }
  }
  r.IfcGradientCurve = DI;
  class z0 extends ql {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.type = 2706460486;
    }
  }
  r.IfcGroup = z0;
  class bI extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1251058090;
    }
  }
  r.IfcHeatExchangerType = bI;
  class oc extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1806887404;
    }
  }
  r.IfcHumidifierType = oc;
  class GI extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2568555532;
    }
  }
  r.IfcImpactProtectionDevice = GI;
  class jI extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3948183225;
    }
  }
  r.IfcImpactProtectionDeviceType = jI;
  class MI extends hu {
    constructor(H, w, D, U) {
      super(H), this.Points = w, this.Segments = D, this.SelfIntersect = U, this.type = 2571569899;
    }
  }
  r.IfcIndexedPolyCurve = MI;
  class xI extends _u {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3946677679;
    }
  }
  r.IfcInterceptorType = xI;
  class vI extends p1 {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Curve3D = w, this.AssociatedGeometry = D, this.MasterRepresentation = U, this.type = 3113134337;
    }
  }
  r.IfcIntersectionCurve = vI;
  class BI extends z0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.Jurisdiction = Re, this.ResponsiblePersons = Ne, this.LastUpdateDate = Qe, this.CurrentValue = tn, this.OriginalValue = ar, this.type = 2391368822;
    }
  }
  r.IfcInventory = BI;
  class UI extends Xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4288270099;
    }
  }
  r.IfcJunctionBoxType = UI;
  class HI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.Mountable = tn, this.type = 679976338;
    }
  }
  r.IfcKerbType = HI;
  class qI extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 3827777499;
    }
  }
  r.IfcLaborResource = qI;
  class eE extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1051575348;
    }
  }
  r.IfcLampType = eE;
  class kI extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1161773419;
    }
  }
  r.IfcLightFixtureType = kI;
  class ic extends tl {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 2176059722;
    }
  }
  r.IfcLinearElement = ic;
  class YI extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1770583370;
    }
  }
  r.IfcLiquidTerminalType = YI;
  class XI extends Su {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.PredefinedType = tn, this.type = 525669439;
    }
  }
  r.IfcMarineFacility = XI;
  class VI extends Ru {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.PredefinedType = ar, this.type = 976884017;
    }
  }
  r.IfcMarinePart = VI;
  class WI extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.NominalDiameter = Qe, this.NominalLength = tn, this.PredefinedType = ar, this.type = 377706215;
    }
  }
  r.IfcMechanicalFastener = WI;
  class zI extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.NominalDiameter = ar, this.NominalLength = os, this.type = 2108223431;
    }
  }
  r.IfcMechanicalFastenerType = zI;
  class $I extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1114901282;
    }
  }
  r.IfcMedicalDeviceType = $I;
  class QI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3181161470;
    }
  }
  r.IfcMemberType = QI;
  class KI extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1950438474;
    }
  }
  r.IfcMobileTelecommunicationsApplianceType = KI;
  class g1 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 710110818;
    }
  }
  r.IfcMooringDeviceType = g1;
  class et extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 977012517;
    }
  }
  r.IfcMotorConnectionType = et;
  class ue extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 506776471;
    }
  }
  r.IfcNavigationElementType = ue;
  class ee extends rc {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.TheActor = ce, this.PredefinedType = Re, this.type = 4143007308;
    }
  }
  r.IfcOccupant = ee;
  class le extends Rl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3588315303;
    }
  }
  r.IfcOpeningElement = le;
  class he extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2837617999;
    }
  }
  r.IfcOutletType = he;
  class ge extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 514975943;
    }
  }
  r.IfcPavementType = ge;
  class Xe extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LifeCyclePhase = Re, this.PredefinedType = Ne, this.type = 2382730787;
    }
  }
  r.IfcPerformanceHistory = Xe;
  class tt extends x0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.OperationType = oe, this.PanelPosition = ce, this.FrameDepth = Re, this.FrameThickness = Ne, this.ShapeAspectStyle = Qe, this.type = 3566463478;
    }
  }
  r.IfcPermeableCoveringProperties = tt;
  class at extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.PredefinedType = Re, this.Status = Ne, this.LongDescription = Qe, this.type = 3327091369;
    }
  }
  r.IfcPermit = at;
  class St extends m1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1158309216;
    }
  }
  r.IfcPileType = St;
  class kt extends Xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 804291784;
    }
  }
  r.IfcPipeFittingType = kt;
  class On extends Tu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4231323485;
    }
  }
  r.IfcPipeSegmentType = On;
  class Gr extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4017108033;
    }
  }
  r.IfcPlateType = Gr;
  class ys extends Kc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Coordinates = w, this.Closed = D, this.Faces = U, this.PnIndex = z, this.type = 2839578677;
    }
  }
  r.IfcPolygonalFaceSet = ys;
  class Fs extends hu {
    constructor(H, w) {
      super(H), this.Points = w, this.type = 3724593414;
    }
  }
  r.IfcPolyline = Fs;
  class Xo extends tl {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 3740093272;
    }
  }
  r.IfcPort = Xo;
  class ta extends tl {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 1946335990;
    }
  }
  r.IfcPositioningElement = ta;
  class E0 extends S0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.PredefinedType = Ne, this.type = 2744685151;
    }
  }
  r.IfcProcedure = E0;
  class I0 extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.PredefinedType = Re, this.Status = Ne, this.LongDescription = Qe, this.type = 2904328755;
    }
  }
  r.IfcProjectOrder = I0;
  class Tl extends Z4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3651124850;
    }
  }
  r.IfcProjectionElement = Tl;
  class _l extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1842657554;
    }
  }
  r.IfcProtectiveDeviceType = _l;
  class mu extends sc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2250791053;
    }
  }
  r.IfcPumpType = mu;
  class yu extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1763565496;
    }
  }
  r.IfcRailType = yu;
  class Fu extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2893384427;
    }
  }
  r.IfcRailingType = Fu;
  class Au extends Su {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.PredefinedType = tn, this.type = 3992365140;
    }
  }
  r.IfcRailway = Au;
  class JI extends Ru {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.PredefinedType = ar, this.type = 1891881377;
    }
  }
  r.IfcRailwayPart = JI;
  class ZI extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2324767716;
    }
  }
  r.IfcRampFlightType = ZI;
  class ep extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1469900589;
    }
  }
  r.IfcRampType = ep;
  class tp extends W4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os), this.UDegree = w, this.VDegree = D, this.ControlPointsList = U, this.SurfaceForm = z, this.UClosed = oe, this.VClosed = ce, this.SelfIntersect = Re, this.UMultiplicities = Ne, this.VMultiplicities = Qe, this.UKnots = tn, this.VKnots = ar, this.KnotSpec = os, this.WeightsData = ho, this.type = 683857671;
    }
  }
  r.IfcRationalBSplineSurfaceWithKnots = tp;
  class yp extends ta {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.type = 4021432810;
    }
  }
  r.IfcReferent = yp;
  class ac extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.type = 3027567501;
    }
  }
  r.IfcReinforcingElement = ac;
  class r3 extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 964333572;
    }
  }
  r.IfcReinforcingElementType = r3;
  class Fp extends ac {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.MeshLength = tn, this.MeshWidth = ar, this.LongitudinalBarNominalDiameter = os, this.TransverseBarNominalDiameter = ho, this.LongitudinalBarCrossSectionArea = ra, this.TransverseBarCrossSectionArea = Wa, this.LongitudinalBarSpacing = r0, this.TransverseBarSpacing = O0, this.PredefinedType = Pu, this.type = 2320036040;
    }
  }
  r.IfcReinforcingMesh = Fp;
  class Ap extends r3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0, Pu, oE, iE) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.MeshLength = ar, this.MeshWidth = os, this.LongitudinalBarNominalDiameter = ho, this.TransverseBarNominalDiameter = ra, this.LongitudinalBarCrossSectionArea = Wa, this.TransverseBarCrossSectionArea = r0, this.LongitudinalBarSpacing = O0, this.TransverseBarSpacing = Pu, this.BendingShapeCode = oE, this.BendingParameters = iE, this.type = 2310774935;
    }
  }
  r.IfcReinforcingMeshType = Ap;
  class Lp extends Iu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingElement = oe, this.RelatedSurfaceFeatures = ce, this.type = 3818125796;
    }
  }
  r.IfcRelAdheresToElement = Lp;
  class Np extends Iu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.RelatingObject = oe, this.RelatedObjects = ce, this.type = 160246688;
    }
  }
  r.IfcRelAggregates = Np;
  class gp extends Su {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.PredefinedType = tn, this.type = 146592293;
    }
  }
  r.IfcRoad = gp;
  class Op extends Ru {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.PredefinedType = ar, this.type = 550521510;
    }
  }
  r.IfcRoadPart = Op;
  class Pp extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2781568857;
    }
  }
  r.IfcRoofType = Pp;
  class wp extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1768891740;
    }
  }
  r.IfcSanitaryTerminalType = wp;
  class Dp extends p1 {
    constructor(H, w, D, U) {
      super(H, w, D, U), this.Curve3D = w, this.AssociatedGeometry = D, this.MasterRepresentation = U, this.type = 2157484638;
    }
  }
  r.IfcSeamCurve = Dp;
  class bp extends Cl {
    constructor(H, w, D, U, z) {
      super(H, w), this.Position = w, this.QuadraticTerm = D, this.LinearTerm = U, this.ConstantTerm = z, this.type = 3649235739;
    }
  }
  r.IfcSecondOrderPolynomialSpiral = bp;
  class Gp extends Zc {
    constructor(H, w, D, U, z) {
      super(H, w, D), this.Segments = w, this.SelfIntersect = D, this.BaseCurve = U, this.EndPoint = z, this.type = 544395925;
    }
  }
  r.IfcSegmentedReferenceCurve = Gp;
  class jp extends Cl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w), this.Position = w, this.SepticTerm = D, this.SexticTerm = U, this.QuinticTerm = z, this.QuarticTerm = oe, this.CubicTerm = ce, this.QuadraticTerm = Re, this.LinearTerm = Ne, this.ConstantTerm = Qe, this.type = 1027922057;
    }
  }
  r.IfcSeventhOrderPolynomialSpiral = jp;
  class Mp extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4074543187;
    }
  }
  r.IfcShadingDeviceType = Mp;
  class xp extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 33720170;
    }
  }
  r.IfcSign = xp;
  class Lu extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3599934289;
    }
  }
  r.IfcSignType = Lu;
  class np extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1894708472;
    }
  }
  r.IfcSignalType = np;
  class ml extends Cl {
    constructor(H, w, D, U, z) {
      super(H, w), this.Position = w, this.SineTerm = D, this.LinearTerm = U, this.ConstantTerm = z, this.type = 42703149;
    }
  }
  r.IfcSineSpiral = ml;
  class vp extends fu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.RefLatitude = tn, this.RefLongitude = ar, this.RefElevation = os, this.LandTitleNumber = ho, this.SiteAddress = ra, this.type = 4097777520;
    }
  }
  r.IfcSite = vp;
  class cp extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2533589738;
    }
  }
  r.IfcSlabType = cp;
  class Ep extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1072016465;
    }
  }
  r.IfcSolarDeviceType = Ep;
  class Bp extends fu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.PredefinedType = tn, this.ElevationWithFlooring = ar, this.type = 3856911033;
    }
  }
  r.IfcSpace = Bp;
  class Up extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1305183839;
    }
  }
  r.IfcSpaceHeaterType = Up;
  class Hp extends tc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.LongName = ar, this.type = 3812236995;
    }
  }
  r.IfcSpaceType = Hp;
  class qp extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3112655638;
    }
  }
  r.IfcStackTerminalType = qp;
  class kp extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1039846685;
    }
  }
  r.IfcStairFlightType = kp;
  class Yp extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 338393293;
    }
  }
  r.IfcStairType = Yp;
  class tE extends I1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.type = 682877961;
    }
  }
  r.IfcStructuralAction = tE;
  class nE extends rl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedCondition = Ne, this.type = 1179482911;
    }
  }
  r.IfcStructuralConnection = nE;
  class Ip extends tE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.ProjectedOrTrue = ar, this.PredefinedType = os, this.type = 1004757350;
    }
  }
  r.IfcStructuralCurveAction = Ip;
  class Xp extends nE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedCondition = Ne, this.AxisDirection = Qe, this.type = 4243806635;
    }
  }
  r.IfcStructuralCurveConnection = Xp;
  class xa extends X0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.Axis = Qe, this.type = 214636428;
    }
  }
  r.IfcStructuralCurveMember = xa;
  class Vp extends xa {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.Axis = Qe, this.type = 2445595289;
    }
  }
  r.IfcStructuralCurveMemberVarying = Vp;
  class Wp extends $c {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.PredefinedType = tn, this.type = 2757150158;
    }
  }
  r.IfcStructuralCurveReaction = Wp;
  class zp extends Ip {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.ProjectedOrTrue = ar, this.PredefinedType = os, this.type = 1807405624;
    }
  }
  r.IfcStructuralLinearAction = zp;
  class pp extends z0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.ActionType = Re, this.ActionSource = Ne, this.Coefficient = Qe, this.Purpose = tn, this.type = 1252848954;
    }
  }
  r.IfcStructuralLoadGroup = pp;
  class $p extends tE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.type = 2082059205;
    }
  }
  r.IfcStructuralPointAction = $p;
  class Qp extends nE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedCondition = Ne, this.ConditionCoordinateSystem = Qe, this.type = 734778138;
    }
  }
  r.IfcStructuralPointConnection = Qp;
  class Kp extends $c {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.type = 1235345126;
    }
  }
  r.IfcStructuralPointReaction = Kp;
  class Vl extends z0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.TheoryType = ce, this.ResultForLoadGroup = Re, this.IsLinear = Ne, this.type = 2986769608;
    }
  }
  r.IfcStructuralResultGroup = Vl;
  class lc extends tE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.ProjectedOrTrue = ar, this.PredefinedType = os, this.type = 3657597509;
    }
  }
  r.IfcStructuralSurfaceAction = lc;
  class Jp extends nE {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedCondition = Ne, this.type = 1975003073;
    }
  }
  r.IfcStructuralSurfaceConnection = Jp;
  class Zp extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 148013059;
    }
  }
  r.IfcSubContractResource = Zp;
  class rE extends t3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3101698114;
    }
  }
  r.IfcSurfaceFeature = rE;
  class O1 extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2315554128;
    }
  }
  r.IfcSwitchingDeviceType = O1;
  class Nu extends z0 {
    constructor(H, w, D, U, z, oe) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.type = 2254336722;
    }
  }
  r.IfcSystem = Nu;
  class N0 extends N1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 413509423;
    }
  }
  r.IfcSystemFurnitureElement = N0;
  class sE extends L1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 5716631;
    }
  }
  r.IfcTankType = sE;
  class e5 extends ac {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0, O0) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.PredefinedType = tn, this.NominalDiameter = ar, this.CrossSectionArea = os, this.TensionForce = ho, this.PreStress = ra, this.FrictionCoefficient = Wa, this.AnchorageSlip = r0, this.MinCurvatureRadius = O0, this.type = 3824725483;
    }
  }
  r.IfcTendon = e5;
  class t5 extends ac {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.PredefinedType = tn, this.type = 2347447852;
    }
  }
  r.IfcTendonAnchor = t5;
  class n5 extends r3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3081323446;
    }
  }
  r.IfcTendonAnchorType = n5;
  class r5 extends ac {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.PredefinedType = tn, this.type = 3663046924;
    }
  }
  r.IfcTendonConduit = r5;
  class s5 extends r3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2281632017;
    }
  }
  r.IfcTendonConduitType = s5;
  class o5 extends r3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.NominalDiameter = ar, this.CrossSectionArea = os, this.SheathDiameter = ho, this.type = 2415094496;
    }
  }
  r.IfcTendonType = o5;
  class i5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 618700268;
    }
  }
  r.IfcTrackElementType = i5;
  class a5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1692211062;
    }
  }
  r.IfcTransformerType = a5;
  class dp extends hl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2097647324;
    }
  }
  r.IfcTransportElementType = dp;
  class rp extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1953115116;
    }
  }
  r.IfcTransportationDevice = rp;
  class l5 extends hu {
    constructor(H, w, D, U, z, oe) {
      super(H), this.BasisCurve = w, this.Trim1 = D, this.Trim2 = U, this.SenseAgreement = z, this.MasterRepresentation = oe, this.type = 3593883385;
    }
  }
  r.IfcTrimmedCurve = l5;
  class u5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1600972822;
    }
  }
  r.IfcTubeBundleType = u5;
  class c5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1911125066;
    }
  }
  r.IfcUnitaryEquipmentType = c5;
  class E5 extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 728799441;
    }
  }
  r.IfcValveType = E5;
  class I5 extends rp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 840318589;
    }
  }
  r.IfcVehicle = I5;
  class p5 extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1530820697;
    }
  }
  r.IfcVibrationDamper = p5;
  class fp extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3956297820;
    }
  }
  r.IfcVibrationDamperType = fp;
  class d5 extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2391383451;
    }
  }
  r.IfcVibrationIsolator = d5;
  class f5 extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3313531582;
    }
  }
  r.IfcVibrationIsolatorType = f5;
  class C5 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2769231204;
    }
  }
  r.IfcVirtualElement = C5;
  class h5 extends Rl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 926996030;
    }
  }
  r.IfcVoidingFeature = h5;
  class S5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1898987631;
    }
  }
  r.IfcWallType = S5;
  class R5 extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1133259667;
    }
  }
  r.IfcWasteTerminalType = R5;
  class T5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.PartitioningType = ar, this.ParameterTakesPrecedence = os, this.UserDefinedPartitioningType = ho, this.type = 4009809668;
    }
  }
  r.IfcWindowType = T5;
  class _5 extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.WorkingTimes = Re, this.ExceptionTimes = Ne, this.PredefinedType = Qe, this.type = 4088093105;
    }
  }
  r.IfcWorkCalendar = _5;
  class sp extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.CreationDate = Re, this.Creators = Ne, this.Purpose = Qe, this.Duration = tn, this.TotalFloat = ar, this.StartTime = os, this.FinishTime = ho, this.type = 1028945134;
    }
  }
  r.IfcWorkControl = sp;
  class m5 extends sp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.CreationDate = Re, this.Creators = Ne, this.Purpose = Qe, this.Duration = tn, this.TotalFloat = ar, this.StartTime = os, this.FinishTime = ho, this.PredefinedType = ra, this.type = 4218914973;
    }
  }
  r.IfcWorkPlan = m5;
  class y5 extends sp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.CreationDate = Re, this.Creators = Ne, this.Purpose = Qe, this.Duration = tn, this.TotalFloat = ar, this.StartTime = os, this.FinishTime = ho, this.PredefinedType = ra, this.type = 3342526732;
    }
  }
  r.IfcWorkSchedule = y5;
  class F5 extends Nu {
    constructor(H, w, D, U, z, oe, ce) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.type = 1033361043;
    }
  }
  r.IfcZone = F5;
  class A5 extends ol {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.PredefinedType = Re, this.Status = Ne, this.LongDescription = Qe, this.type = 3821786052;
    }
  }
  r.IfcActionRequest = A5;
  class L5 extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1411407467;
    }
  }
  r.IfcAirTerminalBoxType = L5;
  class op extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3352864051;
    }
  }
  r.IfcAirTerminalType = op;
  class N5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1871374353;
    }
  }
  r.IfcAirToAirHeatRecoveryType = N5;
  class g5 extends ic {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.RailHeadDistance = Ne, this.type = 4266260250;
    }
  }
  r.IfcAlignmentCant = g5;
  class O5 extends ic {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 1545765605;
    }
  }
  r.IfcAlignmentHorizontal = O5;
  class P5 extends ic {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.DesignParameters = Ne, this.type = 317615605;
    }
  }
  r.IfcAlignmentSegment = P5;
  class w5 extends ic {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 1662888072;
    }
  }
  r.IfcAlignmentVertical = w5;
  class D5 extends z0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.OriginalValue = Re, this.CurrentValue = Ne, this.TotalReplacementCost = Qe, this.Owner = tn, this.User = ar, this.ResponsiblePerson = os, this.IncorporationDate = ho, this.DepreciatedValue = ra, this.type = 3460190687;
    }
  }
  r.IfcAsset = D5;
  class b5 extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1532957894;
    }
  }
  r.IfcAudioVisualApplianceType = b5;
  class Cp extends hu {
    constructor(H, w, D, U, z, oe) {
      super(H), this.Degree = w, this.ControlPointsList = D, this.CurveForm = U, this.ClosedCurve = z, this.SelfIntersect = oe, this.type = 1967976161;
    }
  }
  r.IfcBSplineCurve = Cp;
  class hp extends Cp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe), this.Degree = w, this.ControlPointsList = D, this.CurveForm = U, this.ClosedCurve = z, this.SelfIntersect = oe, this.KnotMultiplicities = ce, this.Knots = Re, this.KnotSpec = Ne, this.type = 2461110595;
    }
  }
  r.IfcBSplineCurveWithKnots = hp;
  class G5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 819618141;
    }
  }
  r.IfcBeamType = G5;
  class j5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3649138523;
    }
  }
  r.IfcBearingType = j5;
  class M5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 231477066;
    }
  }
  r.IfcBoilerType = M5;
  class Sp extends $4 {
    constructor(H, w, D) {
      super(H, w, D), this.Segments = w, this.SelfIntersect = D, this.type = 1136057603;
    }
  }
  r.IfcBoundaryCurve = Sp;
  class x5 extends Su {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.PredefinedType = tn, this.type = 644574406;
    }
  }
  r.IfcBridge = x5;
  class v5 extends Ru {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.UsageType = tn, this.PredefinedType = ar, this.type = 963979645;
    }
  }
  r.IfcBridgePart = v5;
  class B5 extends Su {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.CompositionType = Qe, this.ElevationOfRefHeight = tn, this.ElevationOfTerrain = ar, this.BuildingAddress = os, this.type = 4031249490;
    }
  }
  r.IfcBuilding = B5;
  class U5 extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2979338954;
    }
  }
  r.IfcBuildingElementPart = U5;
  class ip extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 39481116;
    }
  }
  r.IfcBuildingElementPartType = ip;
  class H5 extends qi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1909888760;
    }
  }
  r.IfcBuildingElementProxyType = H5;
  class q5 extends Nu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.LongName = Re, this.type = 1177604601;
    }
  }
  r.IfcBuildingSystem = q5;
  class na extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1876633798;
    }
  }
  r.IfcBuiltElement = na;
  class Rp extends Nu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.LongName = Re, this.type = 3862327254;
    }
  }
  r.IfcBuiltSystem = Rp;
  class k5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2188180465;
    }
  }
  r.IfcBurnerType = k5;
  class Y5 extends Xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 395041908;
    }
  }
  r.IfcCableCarrierFittingType = Y5;
  class X5 extends Tu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3293546465;
    }
  }
  r.IfcCableCarrierSegmentType = X5;
  class V5 extends Xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2674252688;
    }
  }
  r.IfcCableFittingType = V5;
  class W5 extends Tu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1285652485;
    }
  }
  r.IfcCableSegmentType = W5;
  class z5 extends m1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3203706013;
    }
  }
  r.IfcCaissonFoundationType = z5;
  class $5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2951183804;
    }
  }
  r.IfcChillerType = $5;
  class Tp extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3296154744;
    }
  }
  r.IfcChimney = Tp;
  class Q5 extends T1 {
    constructor(H, w, D) {
      super(H, w), this.Position = w, this.Radius = D, this.type = 2611217952;
    }
  }
  r.IfcCircle = Q5;
  class K5 extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1677625105;
    }
  }
  r.IfcCivilElement = K5;
  class J5 extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2301859152;
    }
  }
  r.IfcCoilType = J5;
  class Z5 extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 843113511;
    }
  }
  r.IfcColumn = Z5;
  class ed extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 400855858;
    }
  }
  r.IfcCommunicationsApplianceType = ed;
  class td extends sc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3850581409;
    }
  }
  r.IfcCompressorType = td;
  class nd extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2816379211;
    }
  }
  r.IfcCondenserType = nd;
  class rd extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 3898045240;
    }
  }
  r.IfcConstructionEquipmentResource = rd;
  class sd extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 1060000209;
    }
  }
  r.IfcConstructionMaterialResource = sd;
  class od extends Sl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.Identification = ce, this.LongDescription = Re, this.Usage = Ne, this.BaseCosts = Qe, this.BaseQuantity = tn, this.PredefinedType = ar, this.type = 488727124;
    }
  }
  r.IfcConstructionProductResource = od;
  class id extends Tu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2940368186;
    }
  }
  r.IfcConveyorSegmentType = id;
  class ad extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 335055490;
    }
  }
  r.IfcCooledBeamType = ad;
  class ld extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2954562838;
    }
  }
  r.IfcCoolingTowerType = ld;
  class ud extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1502416096;
    }
  }
  r.IfcCourse = ud;
  class cd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1973544240;
    }
  }
  r.IfcCovering = cd;
  class Ed extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3495092785;
    }
  }
  r.IfcCurtainWall = Ed;
  class Id extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3961806047;
    }
  }
  r.IfcDamperType = Id;
  class ap extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 3426335179;
    }
  }
  r.IfcDeepFoundation = ap;
  class gu extends u0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1335981549;
    }
  }
  r.IfcDiscreteAccessory = gu;
  class pd extends c0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2635815018;
    }
  }
  r.IfcDiscreteAccessoryType = pd;
  class dd extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 479945903;
    }
  }
  r.IfcDistributionBoardType = dd;
  class fd extends V0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1599208980;
    }
  }
  r.IfcDistributionChamberElementType = fd;
  class Ou extends e3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.type = 2063403501;
    }
  }
  r.IfcDistributionControlElementType = Ou;
  class lp extends Ja {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1945004755;
    }
  }
  r.IfcDistributionElement = lp;
  class yl extends lp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 3040386961;
    }
  }
  r.IfcDistributionFlowElement = yl;
  class Cd extends Xo {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.FlowDirection = Ne, this.PredefinedType = Qe, this.SystemType = tn, this.type = 3041715199;
    }
  }
  r.IfcDistributionPort = Cd;
  class _p extends Nu {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.PredefinedType = Re, this.type = 3205830791;
    }
  }
  r.IfcDistributionSystem = _p;
  class hd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.OverallHeight = Qe, this.OverallWidth = tn, this.PredefinedType = ar, this.OperationType = os, this.UserDefinedOperationType = ho, this.type = 395920057;
    }
  }
  r.IfcDoor = hd;
  class Sd extends Xl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 869906466;
    }
  }
  r.IfcDuctFittingType = Sd;
  class Rd extends Tu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3760055223;
    }
  }
  r.IfcDuctSegmentType = Rd;
  class Td extends _u {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2030761528;
    }
  }
  r.IfcDuctSilencerType = Td;
  class _d extends Rl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3071239417;
    }
  }
  r.IfcEarthworksCut = _d;
  class up extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1077100507;
    }
  }
  r.IfcEarthworksElement = up;
  class md extends up {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3376911765;
    }
  }
  r.IfcEarthworksFill = md;
  class yd extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 663422040;
    }
  }
  r.IfcElectricApplianceType = yd;
  class Fd extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2417008758;
    }
  }
  r.IfcElectricDistributionBoardType = Fd;
  class Ad extends L1 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3277789161;
    }
  }
  r.IfcElectricFlowStorageDeviceType = Ad;
  class Ld extends _u {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2142170206;
    }
  }
  r.IfcElectricFlowTreatmentDeviceType = Ld;
  class Ue extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1534661035;
    }
  }
  r.IfcElectricGeneratorType = Ue;
  class $ extends ba {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1217240411;
    }
  }
  r.IfcElectricMotorType = $;
  class j extends R0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 712377611;
    }
  }
  r.IfcElectricTimeControlType = j;
  class Y extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1658829314;
    }
  }
  r.IfcEnergyConversionDevice = Y;
  class K extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2814081492;
    }
  }
  r.IfcEngine = K;
  class ie extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3747195512;
    }
  }
  r.IfcEvaporativeCooler = ie;
  class Ce extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 484807127;
    }
  }
  r.IfcEvaporator = Ce;
  class ye extends K4 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.LongName = Ne, this.PredefinedType = Qe, this.type = 1209101575;
    }
  }
  r.IfcExternalSpatialElement = ye;
  class we extends sc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 346874300;
    }
  }
  r.IfcFanType = we;
  class He extends _u {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1810631287;
    }
  }
  r.IfcFilterType = He;
  class rt extends Za {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4222183408;
    }
  }
  r.IfcFireSuppressionTerminalType = rt;
  class cn extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2058353004;
    }
  }
  r.IfcFlowController = cn;
  class nr extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 4278956645;
    }
  }
  r.IfcFlowFitting = nr;
  class Yr extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 4037862832;
    }
  }
  r.IfcFlowInstrumentType = Yr;
  class $s extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2188021234;
    }
  }
  r.IfcFlowMeter = $s;
  class wi extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 3132237377;
    }
  }
  r.IfcFlowMovingDevice = wi;
  class Ia extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 987401354;
    }
  }
  r.IfcFlowSegment = Ia;
  class va extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 707683696;
    }
  }
  r.IfcFlowStorageDevice = va;
  class Vi extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2223149337;
    }
  }
  r.IfcFlowTerminal = Vi;
  class g0 extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 3508470533;
    }
  }
  r.IfcFlowTreatmentDevice = g0;
  class s3 extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 900683007;
    }
  }
  r.IfcFooting = s3;
  class Wl extends n3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2713699986;
    }
  }
  r.IfcGeotechnicalAssembly = Wl;
  class Nd extends ta {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.UAxes = Ne, this.VAxes = Qe, this.WAxes = tn, this.PredefinedType = ar, this.type = 3009204131;
    }
  }
  r.IfcGrid = Nd;
  class bd extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3319311131;
    }
  }
  r.IfcHeatExchanger = bd;
  class Gd extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2068733104;
    }
  }
  r.IfcHumidifier = Gd;
  class jd extends g0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4175244083;
    }
  }
  r.IfcInterceptor = jd;
  class Md extends nr {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2176052936;
    }
  }
  r.IfcJunctionBox = Md;
  class xd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.Mountable = Qe, this.type = 2696325953;
    }
  }
  r.IfcKerb = xd;
  class vd extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 76236018;
    }
  }
  r.IfcLamp = vd;
  class Bd extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 629592764;
    }
  }
  r.IfcLightFixture = Bd;
  class Od extends ta {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.type = 1154579445;
    }
  }
  r.IfcLinearPositioningElement = Od;
  class Ud extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1638804497;
    }
  }
  r.IfcLiquidTerminal = Ud;
  class Hd extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1437502449;
    }
  }
  r.IfcMedicalDevice = Hd;
  class qd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1073191201;
    }
  }
  r.IfcMember = qd;
  class kd extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2078563270;
    }
  }
  r.IfcMobileTelecommunicationsAppliance = kd;
  class Yd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 234836483;
    }
  }
  r.IfcMooringDevice = Yd;
  class Xd extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2474470126;
    }
  }
  r.IfcMotorConnection = Xd;
  class Vd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2182337498;
    }
  }
  r.IfcNavigationElement = Vd;
  class Wd extends Sp {
    constructor(H, w, D) {
      super(H, w, D), this.Segments = w, this.SelfIntersect = D, this.type = 144952367;
    }
  }
  r.IfcOuterBoundaryCurve = Wd;
  class zd extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3694346114;
    }
  }
  r.IfcOutlet = zd;
  class $d extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1383356374;
    }
  }
  r.IfcPavement = $d;
  class Qd extends ap {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.ConstructionType = tn, this.type = 1687234759;
    }
  }
  r.IfcPile = Qd;
  class Kd extends nr {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 310824031;
    }
  }
  r.IfcPipeFitting = Kd;
  class Jd extends Ia {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3612865200;
    }
  }
  r.IfcPipeSegment = Jd;
  class Zd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3171933400;
    }
  }
  r.IfcPlate = Zd;
  class ef extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 738039164;
    }
  }
  r.IfcProtectiveDevice = ef;
  class tf extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 655969474;
    }
  }
  r.IfcProtectiveDeviceTrippingUnitType = tf;
  class nf extends wi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 90941305;
    }
  }
  r.IfcPump = nf;
  class rf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3290496277;
    }
  }
  r.IfcRail = rf;
  class sf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2262370178;
    }
  }
  r.IfcRailing = sf;
  class of extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3024970846;
    }
  }
  r.IfcRamp = of;
  class af extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3283111854;
    }
  }
  r.IfcRampFlight = af;
  class lf extends hp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.Degree = w, this.ControlPointsList = D, this.CurveForm = U, this.ClosedCurve = z, this.SelfIntersect = oe, this.KnotMultiplicities = ce, this.Knots = Re, this.KnotSpec = Ne, this.WeightsData = Qe, this.type = 1232101972;
    }
  }
  r.IfcRationalBSplineCurveWithKnots = lf;
  class uf extends up {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3798194928;
    }
  }
  r.IfcReinforcedSoil = uf;
  class cf extends ac {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.SteelGrade = Qe, this.NominalDiameter = tn, this.CrossSectionArea = ar, this.BarLength = os, this.PredefinedType = ho, this.BarSurface = ra, this.type = 979691226;
    }
  }
  r.IfcReinforcingBar = cf;
  class Ef extends r3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho, ra, Wa, r0) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.NominalDiameter = ar, this.CrossSectionArea = os, this.BarLength = ho, this.BarSurface = ra, this.BendingShapeCode = Wa, this.BendingParameters = r0, this.type = 2572171363;
    }
  }
  r.IfcReinforcingBarType = Ef;
  class If extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2016517767;
    }
  }
  r.IfcRoof = If;
  class pf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3053780830;
    }
  }
  r.IfcSanitaryTerminal = pf;
  class df extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 1783015770;
    }
  }
  r.IfcSensorType = df;
  class ff extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1329646415;
    }
  }
  r.IfcShadingDevice = ff;
  class Cf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 991950508;
    }
  }
  r.IfcSignal = Cf;
  class hf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1529196076;
    }
  }
  r.IfcSlab = hf;
  class Sf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3420628829;
    }
  }
  r.IfcSolarDevice = Sf;
  class Rf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1999602285;
    }
  }
  r.IfcSpaceHeater = Rf;
  class Tf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1404847402;
    }
  }
  r.IfcStackTerminal = Tf;
  class _f extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 331165859;
    }
  }
  r.IfcStair = _f;
  class mf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.NumberOfRisers = Qe, this.NumberOfTreads = tn, this.RiserHeight = ar, this.TreadLength = os, this.PredefinedType = ho, this.type = 4252922144;
    }
  }
  r.IfcStairFlight = mf;
  class yf extends Nu {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.OrientationOf2DPlane = Re, this.LoadedBy = Ne, this.HasResults = Qe, this.SharedPlacement = tn, this.type = 2515109513;
    }
  }
  r.IfcStructuralAnalysisModel = yf;
  class Ff extends pp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.PredefinedType = ce, this.ActionType = Re, this.ActionSource = Ne, this.Coefficient = Qe, this.Purpose = tn, this.SelfWeightCoefficients = ar, this.type = 385403989;
    }
  }
  r.IfcStructuralLoadCase = Ff;
  class Af extends lc {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.AppliedLoad = Ne, this.GlobalOrLocal = Qe, this.DestabilizingLoad = tn, this.ProjectedOrTrue = ar, this.PredefinedType = os, this.type = 1621171031;
    }
  }
  r.IfcStructuralPlanarAction = Af;
  class Lf extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1162798199;
    }
  }
  r.IfcSwitchingDevice = Lf;
  class Nf extends va {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 812556717;
    }
  }
  r.IfcTank = Nf;
  class gf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3425753595;
    }
  }
  r.IfcTrackElement = gf;
  class Of extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3825984169;
    }
  }
  r.IfcTransformer = Of;
  class Pf extends rp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1620046519;
    }
  }
  r.IfcTransportElement = Pf;
  class wf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3026737570;
    }
  }
  r.IfcTubeBundle = wf;
  class Df extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3179687236;
    }
  }
  r.IfcUnitaryControlElementType = Df;
  class bf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4292641817;
    }
  }
  r.IfcUnitaryEquipment = bf;
  class Gf extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4207607924;
    }
  }
  r.IfcValve = Gf;
  class Pd extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2391406946;
    }
  }
  r.IfcWall = Pd;
  class jf extends Pd {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3512223829;
    }
  }
  r.IfcWallStandardCase = jf;
  class Mf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4237592921;
    }
  }
  r.IfcWasteTerminal = Mf;
  class xf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn, ar, os, ho) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.OverallHeight = Qe, this.OverallWidth = tn, this.PredefinedType = ar, this.PartitioningType = os, this.UserDefinedPartitioningType = ho, this.type = 3304561284;
    }
  }
  r.IfcWindow = xf;
  class vf extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 2874132201;
    }
  }
  r.IfcActuatorType = vf;
  class Bf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1634111441;
    }
  }
  r.IfcAirTerminal = Bf;
  class Uf extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 177149247;
    }
  }
  r.IfcAirTerminalBox = Uf;
  class Hf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2056796094;
    }
  }
  r.IfcAirToAirHeatRecovery = Hf;
  class qf extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 3001207471;
    }
  }
  r.IfcAlarmType = qf;
  class kf extends Od {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.PredefinedType = Ne, this.type = 325726236;
    }
  }
  r.IfcAlignment = kf;
  class Yf extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 277319702;
    }
  }
  r.IfcAudioVisualAppliance = Yf;
  class Xf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 753842376;
    }
  }
  r.IfcBeam = Xf;
  class Vf extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4196446775;
    }
  }
  r.IfcBearing = Vf;
  class Wf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 32344328;
    }
  }
  r.IfcBoiler = Wf;
  class zf extends Wl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 3314249567;
    }
  }
  r.IfcBorehole = zf;
  class $f extends na {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1095909175;
    }
  }
  r.IfcBuildingElementProxy = $f;
  class Qf extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2938176219;
    }
  }
  r.IfcBurner = Qf;
  class Kf extends nr {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 635142910;
    }
  }
  r.IfcCableCarrierFitting = Kf;
  class Jf extends Ia {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3758799889;
    }
  }
  r.IfcCableCarrierSegment = Jf;
  class Zf extends nr {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1051757585;
    }
  }
  r.IfcCableFitting = Zf;
  class e8 extends Ia {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4217484030;
    }
  }
  r.IfcCableSegment = e8;
  class t8 extends ap {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3999819293;
    }
  }
  r.IfcCaissonFoundation = t8;
  class n8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3902619387;
    }
  }
  r.IfcChiller = n8;
  class r8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 639361253;
    }
  }
  r.IfcCoil = r8;
  class s8 extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3221913625;
    }
  }
  r.IfcCommunicationsAppliance = s8;
  class o8 extends wi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3571504051;
    }
  }
  r.IfcCompressor = o8;
  class i8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2272882330;
    }
  }
  r.IfcCondenser = i8;
  class a8 extends Ou {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe, tn) {
      super(H, w, D, U, z, oe, ce, Re, Ne, Qe), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ApplicableOccurrence = oe, this.HasPropertySets = ce, this.RepresentationMaps = Re, this.Tag = Ne, this.ElementType = Qe, this.PredefinedType = tn, this.type = 578613899;
    }
  }
  r.IfcControllerType = a8;
  class l8 extends Ia {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3460952963;
    }
  }
  r.IfcConveyorSegment = l8;
  class u8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4136498852;
    }
  }
  r.IfcCooledBeam = u8;
  class c8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3640358203;
    }
  }
  r.IfcCoolingTower = c8;
  class E8 extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4074379575;
    }
  }
  r.IfcDamper = E8;
  class I8 extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3693000487;
    }
  }
  r.IfcDistributionBoard = I8;
  class p8 extends yl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1052013943;
    }
  }
  r.IfcDistributionChamberElement = p8;
  class d8 extends _p {
    constructor(H, w, D, U, z, oe, ce, Re) {
      super(H, w, D, U, z, oe, ce, Re), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.LongName = ce, this.PredefinedType = Re, this.type = 562808652;
    }
  }
  r.IfcDistributionCircuit = d8;
  class o3 extends lp {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1062813311;
    }
  }
  r.IfcDistributionControlElement = o3;
  class f8 extends nr {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 342316401;
    }
  }
  r.IfcDuctFitting = f8;
  class C8 extends Ia {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3518393246;
    }
  }
  r.IfcDuctSegment = C8;
  class h8 extends g0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1360408905;
    }
  }
  r.IfcDuctSilencer = h8;
  class S8 extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1904799276;
    }
  }
  r.IfcElectricAppliance = S8;
  class R8 extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 862014818;
    }
  }
  r.IfcElectricDistributionBoard = R8;
  class T8 extends va {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3310460725;
    }
  }
  r.IfcElectricFlowStorageDevice = T8;
  class _8 extends g0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 24726584;
    }
  }
  r.IfcElectricFlowTreatmentDevice = _8;
  class m8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 264262732;
    }
  }
  r.IfcElectricGenerator = m8;
  class y8 extends Y {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 402227799;
    }
  }
  r.IfcElectricMotor = y8;
  class F8 extends cn {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1003880860;
    }
  }
  r.IfcElectricTimeControl = F8;
  class A8 extends wi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3415622556;
    }
  }
  r.IfcFan = A8;
  class L8 extends g0 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 819412036;
    }
  }
  r.IfcFilter = L8;
  class N8 extends Vi {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 1426591983;
    }
  }
  r.IfcFireSuppressionTerminal = N8;
  class g8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 182646315;
    }
  }
  r.IfcFlowInstrument = g8;
  class O8 extends Wl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 2680139844;
    }
  }
  r.IfcGeomodel = O8;
  class P8 extends Wl {
    constructor(H, w, D, U, z, oe, ce, Re, Ne) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.type = 1971632696;
    }
  }
  r.IfcGeoslice = P8;
  class w8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 2295281155;
    }
  }
  r.IfcProtectiveDeviceTrippingUnit = w8;
  class D8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4086658281;
    }
  }
  r.IfcSensor = D8;
  class b8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 630975310;
    }
  }
  r.IfcUnitaryControlElement = b8;
  class G8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 4288193352;
    }
  }
  r.IfcActuator = G8;
  class j8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 3087945054;
    }
  }
  r.IfcAlarm = j8;
  class M8 extends o3 {
    constructor(H, w, D, U, z, oe, ce, Re, Ne, Qe) {
      super(H, w, D, U, z, oe, ce, Re, Ne), this.GlobalId = w, this.OwnerHistory = D, this.Name = U, this.Description = z, this.ObjectType = oe, this.ObjectPlacement = ce, this.Representation = Re, this.Tag = Ne, this.PredefinedType = Qe, this.type = 25142252;
    }
  }
  r.IfcController = M8;
})(IFC4X3 || (IFC4X3 = {}));
var PropsNames = {
  aggregates: {
    name: IFCRELAGGREGATES,
    relating: "RelatingObject",
    related: "RelatedObjects",
    key: "children"
  },
  spatial: {
    name: IFCRELCONTAINEDINSPATIALSTRUCTURE,
    relating: "RelatingStructure",
    related: "RelatedElements",
    key: "children"
  },
  psets: {
    name: IFCRELDEFINESBYPROPERTIES,
    relating: "RelatingPropertyDefinition",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  },
  materials: {
    name: IFCRELASSOCIATESMATERIAL,
    relating: "RelatingMaterial",
    related: "RelatedObjects",
    key: "HasAssociations"
  },
  type: {
    name: IFCRELDEFINESBYTYPE,
    relating: "RelatingType",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  }
}, Properties = class {
  constructor(r) {
    this.api = r;
  }
  getItemProperties(r, e, s = !1, o = !1) {
    return __async(this, null, function* () {
      return this.api.GetLine(r, e, s, o);
    });
  }
  getPropertySets(r, e = 0, s = !1) {
    return __async(this, null, function* () {
      return yield this.getRelatedProperties(r, e, PropsNames.psets, s);
    });
  }
  setPropertySets(r, e, s) {
    return __async(this, null, function* () {
      return this.setItemProperties(r, e, s, PropsNames.psets);
    });
  }
  getTypeProperties(r, e = 0, s = !1) {
    return __async(this, null, function* () {
      return this.api.GetModelSchema(r) == "IFC2X3" ? yield this.getRelatedProperties(r, e, PropsNames.type, s) : yield this.getRelatedProperties(r, e, __spreadProps(__spreadValues({}, PropsNames.type), { key: "IsTypedBy" }), s);
    });
  }
  getMaterialsProperties(r, e = 0, s = !1) {
    return __async(this, null, function* () {
      return yield this.getRelatedProperties(r, e, PropsNames.materials, s);
    });
  }
  setMaterialsProperties(r, e, s) {
    return __async(this, null, function* () {
      return this.setItemProperties(r, e, s, PropsNames.materials);
    });
  }
  getSpatialStructure(r, e = !1) {
    return __async(this, null, function* () {
      const s = yield this.getSpatialTreeChunks(r), a = (yield this.api.GetLineIDsWithType(r, IFCPROJECT)).get(0), l = Properties.newIfcProject(a);
      return yield this.getSpatialNode(r, l, s, e), l;
    });
  }
  getRelatedProperties(r, e, s, o = !1) {
    return __async(this, null, function* () {
      const a = [];
      let l = null;
      if (e !== 0)
        l = yield this.api.GetLine(r, e, !1, !0)[s.key];
      else {
        let u = this.api.GetLineIDsWithType(r, s.name);
        l = [];
        for (let c = 0; c < u.size(); ++c)
          l.push({ value: u.get(c) });
      }
      if (l == null)
        return a;
      Array.isArray(l) || (l = [l]);
      for (let u = 0; u < l.length; u++) {
        let c = yield this.api.GetLine(r, l[u].value, !1, !1)[s.relating];
        if (c != null) {
          Array.isArray(c) || (c = [c]);
          for (let E = 0; E < c.length; E++)
            a.push(yield this.api.GetLine(r, c[E].value, o));
        }
      }
      return a;
    });
  }
  getChunks(r, e, s) {
    return __async(this, null, function* () {
      const o = yield this.api.GetLineIDsWithType(r, s.name, !0);
      for (let a = 0; a < o.size(); a++) {
        const l = yield this.api.GetLine(r, o.get(a), !1);
        this.saveChunk(e, s, l);
      }
    });
  }
  static newIfcProject(r) {
    return {
      expressID: r,
      type: "IFCPROJECT",
      children: []
    };
  }
  getSpatialNode(r, e, s, o) {
    return __async(this, null, function* () {
      yield this.getChildren(r, e, s, PropsNames.aggregates, o), yield this.getChildren(r, e, s, PropsNames.spatial, o);
    });
  }
  getChildren(r, e, s, o, a) {
    return __async(this, null, function* () {
      const l = s[e.expressID];
      if (l == null)
        return;
      const u = o.key, c = [];
      for (let E = 0; E < l.length; E++) {
        const d = l[E];
        let f = this.newNode(d, this.api.GetLineType(r, d));
        if (a) {
          const h = yield this.getItemProperties(r, f.expressID);
          f = __spreadValues(__spreadValues({}, h), f);
        }
        yield this.getSpatialNode(r, f, s, a), c.push(f);
      }
      e[u] = c;
    });
  }
  newNode(r, e) {
    return {
      expressID: r,
      type: this.api.GetNameFromTypeCode(e),
      children: []
    };
  }
  getSpatialTreeChunks(r) {
    return __async(this, null, function* () {
      const e = {};
      return yield this.getChunks(r, e, PropsNames.aggregates), yield this.getChunks(r, e, PropsNames.spatial), e;
    });
  }
  saveChunk(r, e, s) {
    const o = s[e.relating].value, a = s[e.related].map((l) => l.value);
    r[o] == null ? r[o] = a : r[o] = r[o].concat(a);
  }
  setItemProperties(r, e, s, o) {
    return __async(this, null, function* () {
      Array.isArray(e) || (e = [e]), Array.isArray(s) || (s = [s]);
      let a = 0;
      const l = [], u = [];
      for (const E of e) {
        const d = yield this.api.GetLine(r, E, !1, !0);
        d[o.key] && u.push(d);
      }
      if (u.length < 1)
        return !1;
      const c = this.api.GetLineIDsWithType(r, o.name);
      for (let E = 0; E < c.size(); ++E) {
        const d = yield this.api.GetLine(r, c.get(E));
        if (s.includes(Number(d[o.relating].value)) && (l.push(d), a++), a == s.length)
          break;
      }
      for (const E of u) {
        for (const d of l)
          E[o.key].some((f) => f.value === d.expressID) || E[o.key].push({ type: 5, value: d.expressID }), d[o.related].some((f) => f.value === E.expressID) || (d[o.related].push({ type: 5, value: E.expressID }), this.api.WriteLine(r, d));
        this.api.WriteLine(r, E);
      }
      return !0;
    });
  }
}, LogLevel;
(function(r) {
  r[r.LOG_LEVEL_DEBUG = 0] = "LOG_LEVEL_DEBUG", r[r.LOG_LEVEL_INFO = 1] = "LOG_LEVEL_INFO", r[r.LOG_LEVEL_WARN = 2] = "LOG_LEVEL_WARN", r[r.LOG_LEVEL_ERROR = 3] = "LOG_LEVEL_ERROR", r[r.LOG_LEVEL_OFF = 4] = "LOG_LEVEL_OFF";
})(LogLevel || (LogLevel = {}));
var Log = class {
  static setLogLevel(r) {
    this.logLevel = r;
  }
  static log(r, ...e) {
    this.logLevel <= 3 && console.log(r, ...e);
  }
  static debug(r, ...e) {
    this.logLevel <= 0 && console.trace("DEBUG: ", r, ...e);
  }
  static info(r, ...e) {
    this.logLevel <= 1 && console.info("INFO: ", r, ...e);
  }
  static warn(r, ...e) {
    this.logLevel <= 2 && console.warn("WARN: ", r, ...e);
  }
  static error(r, ...e) {
    this.logLevel <= 3 && console.error("ERROR: ", r, ...e);
  }
};
Log.logLevel = 1;
var WebIFCWasm;
if (typeof self < "u" && self.crossOriginIsolated)
  try {
    WebIFCWasm = require_web_ifc_mt();
  } catch {
    WebIFCWasm = require_web_ifc();
  }
else
  WebIFCWasm = require_web_ifc();
var STRING = 1, IfcAPI2 = class {
  constructor() {
    this.wasmModule = void 0, this.wasmPath = "", this.isWasmPathAbsolute = !1, this.modelSchemaList = [], this.modelSchemaNameList = [], this.ifcGuidMap = /* @__PURE__ */ new Map(), this.deletedLines = /* @__PURE__ */ new Map(), this.properties = new Properties(this);
  }
  Init(r) {
    return __async(this, null, function* () {
      if (WebIFCWasm) {
        let e = (s, o) => s.endsWith(".wasm") ? this.isWasmPathAbsolute ? this.wasmPath + s : o + this.wasmPath + s : o + s;
        this.wasmModule = yield WebIFCWasm({ noInitialRun: !0, locateFile: r || e });
      } else
        Log.error("Could not find wasm module at './web-ifc' from web-ifc-api.ts");
    });
  }
  OpenModels(r, e) {
    let s = __spreadValues({
      MEMORY_LIMIT: 2147483648
    }, e);
    s.MEMORY_LIMIT = s.MEMORY_LIMIT / r.length;
    let o = [];
    for (let a of r)
      o.push(this.OpenModel(a, s));
    return o;
  }
  CreateSettings(r) {
    let e = __spreadValues({
      OPTIMIZE_PROFILES: !1,
      COORDINATE_TO_ORIGIN: !1,
      CIRCLE_SEGMENTS: 12,
      TAPE_SIZE: 67108864,
      MEMORY_LIMIT: 2147483648
    }, r), s = ["USE_FAST_BOOLS", "CIRCLE_SEGMENTS_LOW", "CIRCLE_SEGMENTS_MEDIUM", "CIRCLE_SEGMENTS_HIGH"];
    for (let o in s)
      o in e && Log.info("Use of deprecated settings " + o + " detected");
    return e;
  }
  LookupSchemaId(r) {
    for (var e = 0; e < SchemaNames.length; e++)
      if (typeof SchemaNames[e] < "u") {
        for (var s = 0; s < SchemaNames[e].length; s++)
          if (SchemaNames[e][s] == r)
            return e;
      }
    return -1;
  }
  OpenModel(r, e) {
    let s = this.CreateSettings(e), o = this.wasmModule.OpenModel(s, (l, u, c) => {
      let E = Math.min(r.byteLength - u, c), d = this.wasmModule.HEAPU8.subarray(l, l + E), f = r.subarray(u, u + E);
      return d.set(f), E;
    });
    this.deletedLines.set(o, /* @__PURE__ */ new Set());
    var a = this.GetHeaderLine(o, FILE_SCHEMA).arguments[0][0].value;
    return this.modelSchemaList[o] = this.LookupSchemaId(a), this.modelSchemaList[o] == -1 ? (Log.error("Unsupported Schema:" + a), this.CloseModel(o), -1) : (Log.info("Parsing Model using " + a + " Schema"), o);
  }
  GetModelSchema(r) {
    return this.modelSchemaNameList[r];
  }
  CreateModel(r, e) {
    var s, o, a;
    let l = this.CreateSettings(e), u = this.wasmModule.CreateModel(l);
    if (this.modelSchemaList[u] = this.LookupSchemaId(r.schema), this.modelSchemaNameList[u] = r.schema, this.modelSchemaList[u] == -1)
      return Log.error("Unsupported Schema:" + r.schema), this.CloseModel(u), -1;
    this.deletedLines.set(u, /* @__PURE__ */ new Set());
    const c = r.name || "web-ifc-model-" + u + ".ifc", E = (/* @__PURE__ */ new Date()).toISOString().slice(0, 19), d = ((s = r.description) == null ? void 0 : s.map((R) => ({ type: STRING, value: R }))) || [{ type: STRING, value: "ViewDefinition [CoordinationView]" }], f = ((o = r.authors) == null ? void 0 : o.map((R) => ({ type: STRING, value: R }))) || [null], h = ((a = r.organizations) == null ? void 0 : a.map((R) => ({ type: STRING, value: R }))) || [null], S = r.authorization ? { type: STRING, value: r.authorization } : null;
    return this.wasmModule.WriteHeaderLine(u, FILE_DESCRIPTION, [
      d,
      { type: STRING, value: "2;1" }
    ]), this.wasmModule.WriteHeaderLine(u, FILE_NAME, [
      { type: STRING, value: c },
      { type: STRING, value: E },
      f,
      h,
      { type: STRING, value: "ifcjs/web-ifc-api" },
      { type: STRING, value: "ifcjs/web-ifc-api" },
      S
    ]), this.wasmModule.WriteHeaderLine(u, FILE_SCHEMA, [[{ type: STRING, value: r.schema }]]), u;
  }
  SaveModel(r) {
    let e = this.wasmModule.GetModelSize(r);
    const s = 512;
    let o = new Uint8Array(e + s), a = 0;
    this.wasmModule.SaveModel(r, (u, c) => {
      let E = this.wasmModule.HEAPU8.subarray(u, u + c);
      a = c, o.set(E, 0);
    });
    let l = new Uint8Array(a);
    return l.set(o.subarray(0, a), 0), l;
  }
  ExportFileAsIFC(r) {
    return Log.warn("ExportFileAsIFC is deprecated, use SaveModel instead"), this.SaveModel(r);
  }
  GetGeometry(r, e) {
    return this.wasmModule.GetGeometry(r, e);
  }
  GetHeaderLine(r, e) {
    return this.wasmModule.GetHeaderLine(r, e);
  }
  GetAllTypesOfModel(r) {
    let e = [];
    const s = Object.keys(FromRawLineData[this.modelSchemaList[r]]).map((o) => parseInt(o));
    for (let o = 0; o < s.length; o++)
      this.GetLineIDsWithType(r, s[o]).size() > 0 && e.push({ typeID: s[o], typeName: this.wasmModule.GetNameFromTypeCode(s[o]) });
    return e;
  }
  GetLine(r, e, s = !1, o = !1) {
    if (!this.wasmModule.ValidateExpressID(r, e))
      return;
    let l = this.GetRawLineData(r, e), u;
    try {
      u = FromRawLineData[this.modelSchemaList[r]][l.type](l.ID, l.arguments);
    } catch {
      Log.error("Invalid IFC Line:" + e);
      return;
    }
    s && this.FlattenLine(r, u);
    let c = InversePropertyDef[this.modelSchemaList[r]][l.type];
    if (o && c != null)
      for (let E of c) {
        E[3] ? u[E[0]] = [] : u[E[0]] = null;
        let d = [E[1]];
        typeof InheritanceDef[this.modelSchemaList[r]][E[1]] < "u" && (d = d.concat(InheritanceDef[this.modelSchemaList[r]][E[1]]));
        let f = this.wasmModule.GetInversePropertyForItem(r, e, d, E[2], E[3]);
        if (!E[3] && f.size() > 0)
          s ? u[E[0]] = this.GetLine(r, f.get(0)) : u[E[0]] = { type: 5, value: f.get(0) };
        else
          for (let h = 0; h < f.size(); h++)
            s ? u[E[0]].push(this.GetLine(r, f.get(h))) : u[E[0]].push({ type: 5, value: f.get(h) });
      }
    return u;
  }
  GetNextExpressID(r, e) {
    return this.wasmModule.GetNextExpressID(r, e);
  }
  GetAndClearErrors(r) {
    return this.wasmModule.GetAndClearErrors(r);
  }
  CreateIfcEntity(r, e, ...s) {
    return Constructors[this.modelSchemaList[r]][e](-1, s);
  }
  CreateIfcType(r, e, s) {
    return TypeInitialisers[this.modelSchemaList[r]][e](s);
  }
  GetNameFromTypeCode(r) {
    return this.wasmModule.GetNameFromTypeCode(r);
  }
  GetTypeCodeFromName(r) {
    return this.wasmModule.GetTypeCodeFromName(r);
  }
  IsIfcElement(r) {
    return this.wasmModule.IsIfcElement(r);
  }
  GetIfcEntityList(r) {
    return Object.keys(FromRawLineData[this.modelSchemaList[r]]).map((e) => parseInt(e));
  }
  DeleteLine(r, e) {
    this.wasmModule.RemoveLine(r, e), this.deletedLines.get(r).add(e);
  }
  WriteLine(r, e) {
    if (e.expressID != -1 && this.deletedLines.get(r).has(e.expressID)) {
      Log.error("Cannot re-use deleted express ID");
      return;
    }
    if (e.expressID != -1 && this.GetLineType(r, e.expressID) != e.type && this.GetLineType(r, e.expressID) != 0) {
      Log.error("Cannot change type of existing IFC Line");
      return;
    }
    let s;
    for (s in e) {
      const a = e[s];
      if (a && a.expressID !== void 0)
        this.WriteLine(r, a), e[s] = new Handle(a.expressID);
      else if (Array.isArray(a) && a.length > 0)
        for (let l = 0; l < a.length; l++)
          a[l].expressID !== void 0 && (this.WriteLine(r, a[l]), e[s][l] = new Handle(a[l].expressID));
    }
    (e.expressID === void 0 || e.expressID < 0) && (e.expressID = this.GetMaxExpressID(r) + 1);
    let o = {
      ID: e.expressID,
      type: e.type,
      arguments: ToRawLineData[this.modelSchemaList[r]][e.type](e)
    };
    this.WriteRawLineData(r, o);
  }
  FlattenLine(r, e) {
    Object.keys(e).forEach((s) => {
      let o = e[s];
      if (o && o.type === 5)
        o.value && (e[s] = this.GetLine(r, o.value, !0));
      else if (Array.isArray(o) && o.length > 0 && o[0].type === 5)
        for (let a = 0; a < o.length; a++)
          o[a].value && (e[s][a] = this.GetLine(r, o[a].value, !0));
    });
  }
  GetRawLineData(r, e) {
    return this.wasmModule.GetLine(r, e);
  }
  WriteRawLineData(r, e) {
    this.wasmModule.WriteLine(r, e.ID, e.type, e.arguments);
  }
  GetLineIDsWithType(r, e, s = !1) {
    let o = [];
    return o.push(e), s && typeof InheritanceDef[this.modelSchemaList[r]][e] < "u" && (o = o.concat(InheritanceDef[this.modelSchemaList[r]][e])), this.wasmModule.GetLineIDsWithType(r, o);
  }
  GetAllLines(r) {
    return this.wasmModule.GetAllLines(r);
  }
  GetAllAlignments(r) {
    const e = this.wasmModule.GetAllAlignments(r), s = [];
    for (let o = 0; o < e.size(); o++) {
      const a = e.get(o), l = [];
      for (let E = 0; E < a.Horizontal.curves.size(); E++) {
        const d = a.Horizontal.curves.get(E), f = [];
        for (let S = 0; S < d.points.size(); S++) {
          const R = d.points.get(S), _ = { x: R.x, y: R.y };
          f.push(_);
        }
        const h = { points: f };
        l.push(h);
      }
      const u = [];
      for (let E = 0; E < a.Vertical.curves.size(); E++) {
        const d = a.Vertical.curves.get(E), f = [];
        for (let S = 0; S < d.points.size(); S++) {
          const R = d.points.get(S), _ = { x: R.x, y: R.y };
          f.push(_);
        }
        const h = { points: f };
        u.push(h);
      }
      const c = { origin, horizontal: l, vertical: u };
      s.push(c);
    }
    return s;
  }
  SetGeometryTransformation(r, e) {
    if (e.length != 16)
      throw new Error(`invalid matrix size: ${e.length}`);
    this.wasmModule.SetGeometryTransformation(r, e);
  }
  GetCoordinationMatrix(r) {
    return this.wasmModule.GetCoordinationMatrix(r);
  }
  GetVertexArray(r, e) {
    return this.getSubArray(this.wasmModule.HEAPF32, r, e);
  }
  GetIndexArray(r, e) {
    return this.getSubArray(this.wasmModule.HEAPU32, r, e);
  }
  getSubArray(r, e, s) {
    return r.subarray(e / 4, e / 4 + s).slice(0);
  }
  CloseModel(r) {
    this.ifcGuidMap.delete(r), this.wasmModule.CloseModel(r);
  }
  StreamMeshes(r, e, s) {
    this.wasmModule.StreamMeshes(r, e, s);
  }
  StreamAllMeshes(r, e) {
    this.wasmModule.StreamAllMeshes(r, e);
  }
  StreamAllMeshesWithTypes(r, e, s) {
    this.wasmModule.StreamAllMeshesWithTypes(r, e, s);
  }
  IsModelOpen(r) {
    return this.wasmModule.IsModelOpen(r);
  }
  LoadAllGeometry(r) {
    return this.wasmModule.LoadAllGeometry(r);
  }
  GetFlatMesh(r, e) {
    return this.wasmModule.GetFlatMesh(r, e);
  }
  GetMaxExpressID(r) {
    return this.wasmModule.GetMaxExpressID(r);
  }
  IncrementMaxExpressID(r, e) {
    return Log.warn("IncrementMaxExpressID is deprecated, use GetNextExpressID or GetMaxExpressID instead"), this.wasmModule.GetMaxExpressID(r) + e;
  }
  GetLineType(r, e) {
    return this.wasmModule.GetLineType(r, e);
  }
  GetVersion() {
    return this.wasmModule.GetVersion();
  }
  GetExpressIdFromGuid(r, e) {
    var s;
    return this.ifcGuidMap.has(r) || this.CreateIfcGuidToExpressIdMapping(r), (s = this.ifcGuidMap.get(r)) == null ? void 0 : s.get(e);
  }
  GetGuidFromExpressId(r, e) {
    var s;
    return this.ifcGuidMap.has(r) || this.CreateIfcGuidToExpressIdMapping(r), (s = this.ifcGuidMap.get(r)) == null ? void 0 : s.get(e);
  }
  CreateIfcGuidToExpressIdMapping(r) {
    const e = /* @__PURE__ */ new Map();
    let s = this.GetIfcEntityList(r);
    for (const o of s) {
      if (!this.IsIfcElement(o))
        continue;
      const a = this.GetLineIDsWithType(r, o), l = a.size();
      for (let u = 0; u < l; u++) {
        const c = a.get(u), E = this.GetLine(r, c);
        if ("GlobalId" in E) {
          const d = E.GlobalId.value;
          e.set(c, d), e.set(d, c);
        }
      }
    }
    this.ifcGuidMap.set(r, e);
  }
  SetWasmPath(r, e = !1) {
    this.wasmPath = r, this.isWasmPathAbsolute = e;
  }
  SetLogLevel(r) {
    Log.setLogLevel(r), this.wasmModule.SetLogLevel(r);
  }
}, __awaiter$Q = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class IfcLoader {
  static load(e, s) {
    var o, a;
    return __awaiter$Q(this, void 0, void 0, function* () {
      const l = (o = s == null ? void 0 : s.objectId) !== null && o !== void 0 ? o : 0, u = /* @__PURE__ */ new Map(), c = new IfcAPI2();
      c.SetWasmPath((a = IfcLoader.IFC_WASM_PATH) !== null && a !== void 0 ? a : "./", !0), yield c.Init(), c.SetLogLevel(LogLevel.LOG_LEVEL_WARN);
      const E = yield FileLoader.loadArrayBuffer(e, { cacheKey: s == null ? void 0 : s.cacheKey, cache: !0 }), d = yield c.OpenModel(new Uint8Array(E), {
        COORDINATE_TO_ORIGIN: !0,
        USE_FAST_BOOLS: !1,
        CIRCLE_SEGMENTS: 60
      }), f = c.LoadAllGeometry(d), h = f.size();
      for (let L = 0; L < h; L++) {
        const F = f.get(L), W = F.geometries.size(), { expressID: G } = c.GetLine(d, F.expressID);
        for (let q = 0; q < W; q++) {
          const fe = F.geometries.get(q);
          IfcLoader.addToMaterialGroup(c, l, d, G, fe, u);
        }
      }
      const S = IfcLoader.createMesh(u), R = IfcLoader.createRangeGroups(S), _ = c.GetCoordinationMatrix(d);
      return new Matrix4().fromArray(_).invert().decompose(S.position, S.quaternion, S.scale), S.updateMatrix(), { ifcApi: c, modelId: d, mesh: S, rangeGroups: R };
    });
  }
  /**
   * Set the path to the web-ifc WASM file
   *
   * @param wasmRootPath
   */
  static init(e) {
    return __awaiter$Q(this, void 0, void 0, function* () {
      e && (IfcLoader.IFC_WASM_PATH = e);
    });
  }
  static createRangeGroups(e) {
    var s, o;
    const a = /* @__PURE__ */ new Map(), l = e.geometry.getAttribute("pickingUserId"), u = e.geometry.index.array;
    let c = 0, E = 0, d = l.array[u[0]];
    for (let f = 0; f < u.length; f++) {
      const h = u[f], S = l.array[h];
      if (S === d)
        E++;
      else {
        const R = (s = a.get(d)) !== null && s !== void 0 ? s : [];
        R.push({ start: c, count: E }), a.set(d, R), c = f, E = 1, d = S;
      }
    }
    {
      const f = (o = a.get(d)) !== null && o !== void 0 ? o : [];
      f.push({ start: c, count: E }), a.set(d, f);
    }
    return a;
  }
  static createMesh(e) {
    const s = [], o = [];
    e.forEach((l) => {
      s.push(mergeGeometries(l.geometries)), l.geometries.forEach((u) => u.dispose()), o.push(l.material);
    });
    const a = mergeGeometries(s, !0);
    return a.computeBoundsTree(), a.computeBoundingSphere(), s.forEach((l) => l.dispose()), new Mesh(a, o);
  }
  static addToMaterialGroup(e, s, o, a, l, u) {
    var c;
    const E = new Matrix4().fromArray(l.flatTransformation), d = IfcLoader.getBufferGeometry(e, o, a, l);
    d.applyMatrix4(E);
    const { x: f, y: h, z: S, w: R } = l.color, _ = new PickingMeshStandardMaterial({
      objectId: s,
      color: new Color().setRGB(f, h, S, "srgb"),
      opacity: R,
      transparent: R < 1,
      depthWrite: R === 1,
      userIdChannel: !0,
      side: DoubleSide,
      forceSinglePass: !0
    }), m = `${f},${h},${S},${R}`, L = (c = u.get(m)) !== null && c !== void 0 ? c : {
      material: _,
      geometries: []
    };
    L.geometries.push(d), u.set(m, L);
  }
  static getBufferGeometry(e, s, o, a) {
    const l = e.GetGeometry(s, a.geometryExpressID), u = e.GetVertexArray(l.GetVertexData(), l.GetVertexDataSize()), c = e.GetIndexArray(l.GetIndexData(), l.GetIndexDataSize()), E = IfcLoader.geometryToBuffer(o, u, c);
    return l.delete(), E;
  }
  static geometryToBuffer(e, s, o) {
    const a = new BufferGeometry(), l = new Float32Array(s.length / 2), u = new Float32Array(s.length / 2), c = new Uint32Array(s.length / 6);
    for (let E = 0; E < s.length; E += 6)
      l[E / 2] = s[E], l[E / 2 + 1] = s[E + 1], l[E / 2 + 2] = s[E + 2], u[E / 2] = s[E + 3], u[E / 2 + 1] = s[E + 4], u[E / 2 + 2] = s[E + 5], c[E / 6] = e;
    return a.setAttribute("position", new BufferAttribute(l, 3)), a.setAttribute("normal", new BufferAttribute(u, 3)), a.setAttribute("pickingUserId", new Uint32BufferAttribute(c, 1, !1)), a.setIndex(new Uint32BufferAttribute(o, 1)), a;
  }
}
IfcLoader.IFC_WASM_PATH = "./";
const CENTER = 0, AVERAGE = 1, SAH = 2, NOT_INTERSECTED = 0, INTERSECTED = 1, CONTAINED = 2, TRIANGLE_INTERSECT_COST = 1.25, TRAVERSAL_COST = 1, BYTES_PER_NODE = 6 * 4 + 4 + 4, IS_LEAFNODE_FLAG = 65535, FLOAT32_EPSILON = Math.pow(2, -24), SKIP_GENERATION = Symbol("SKIP_GENERATION");
function getVertexCount(r) {
  return r.index ? r.index.count : r.attributes.position.count;
}
function getTriCount(r) {
  return getVertexCount(r) / 3;
}
function getIndexArray(r, e = ArrayBuffer) {
  return r > 65535 ? new Uint32Array(new e(4 * r)) : new Uint16Array(new e(2 * r));
}
function ensureIndex(r, e) {
  if (!r.index) {
    const s = r.attributes.position.count, o = e.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, a = getIndexArray(s, o);
    r.setIndex(new BufferAttribute(a, 1));
    for (let l = 0; l < s; l++)
      a[l] = l;
  }
}
function getFullGeometryRange(r) {
  const e = getTriCount(r), s = r.drawRange, o = s.start / 3, a = (s.start + s.count) / 3, l = Math.max(0, o), u = Math.min(e, a) - l;
  return [{
    offset: Math.floor(l),
    count: Math.floor(u)
  }];
}
function getRootIndexRanges(r) {
  if (!r.groups || !r.groups.length)
    return getFullGeometryRange(r);
  const e = [], s = /* @__PURE__ */ new Set(), o = r.drawRange, a = o.start / 3, l = (o.start + o.count) / 3;
  for (const c of r.groups) {
    const E = c.start / 3, d = (c.start + c.count) / 3;
    s.add(Math.max(a, E)), s.add(Math.min(l, d));
  }
  const u = Array.from(s.values()).sort((c, E) => c - E);
  for (let c = 0; c < u.length - 1; c++) {
    const E = u[c], d = u[c + 1];
    e.push({
      offset: Math.floor(E),
      count: Math.floor(d - E)
    });
  }
  return e;
}
function hasGroupGaps(r) {
  if (r.groups.length === 0)
    return !1;
  const e = getTriCount(r), s = getRootIndexRanges(r).sort((l, u) => l.offset - u.offset), o = s[s.length - 1];
  o.count = Math.min(e - o.offset, o.count);
  let a = 0;
  return s.forEach(({ count: l }) => a += l), e !== a;
}
function arrayToBox(r, e, s) {
  return s.min.x = e[r], s.min.y = e[r + 1], s.min.z = e[r + 2], s.max.x = e[r + 3], s.max.y = e[r + 4], s.max.z = e[r + 5], s;
}
function makeEmptyBounds(r) {
  r[0] = r[1] = r[2] = 1 / 0, r[3] = r[4] = r[5] = -1 / 0;
}
function getLongestEdgeIndex(r) {
  let e = -1, s = -1 / 0;
  for (let o = 0; o < 3; o++) {
    const a = r[o + 3] - r[o];
    a > s && (s = a, e = o);
  }
  return e;
}
function copyBounds(r, e) {
  e.set(r);
}
function unionBounds(r, e, s) {
  let o, a;
  for (let l = 0; l < 3; l++) {
    const u = l + 3;
    o = r[l], a = e[l], s[l] = o < a ? o : a, o = r[u], a = e[u], s[u] = o > a ? o : a;
  }
}
function expandByTriangleBounds(r, e, s) {
  for (let o = 0; o < 3; o++) {
    const a = e[r + 2 * o], l = e[r + 2 * o + 1], u = a - l, c = a + l;
    u < s[o] && (s[o] = u), c > s[o + 3] && (s[o + 3] = c);
  }
}
function computeSurfaceArea(r) {
  const e = r[3] - r[0], s = r[4] - r[1], o = r[5] - r[2];
  return 2 * (e * s + s * o + o * e);
}
function getBounds(r, e, s, o, a = null) {
  let l = 1 / 0, u = 1 / 0, c = 1 / 0, E = -1 / 0, d = -1 / 0, f = -1 / 0, h = 1 / 0, S = 1 / 0, R = 1 / 0, _ = -1 / 0, m = -1 / 0, L = -1 / 0;
  const F = a !== null;
  for (let W = e * 6, G = (e + s) * 6; W < G; W += 6) {
    const q = r[W + 0], fe = r[W + 1], _e = q - fe, Le = q + fe;
    _e < l && (l = _e), Le > E && (E = Le), F && q < h && (h = q), F && q > _ && (_ = q);
    const Fe = r[W + 2], Ee = r[W + 3], Ge = Fe - Ee, ve = Fe + Ee;
    Ge < u && (u = Ge), ve > d && (d = ve), F && Fe < S && (S = Fe), F && Fe > m && (m = Fe);
    const te = r[W + 4], ae = r[W + 5], v = te - ae, Te = te + ae;
    v < c && (c = v), Te > f && (f = Te), F && te < R && (R = te), F && te > L && (L = te);
  }
  o[0] = l, o[1] = u, o[2] = c, o[3] = E, o[4] = d, o[5] = f, F && (a[0] = h, a[1] = S, a[2] = R, a[3] = _, a[4] = m, a[5] = L);
}
function getCentroidBounds(r, e, s, o) {
  let a = 1 / 0, l = 1 / 0, u = 1 / 0, c = -1 / 0, E = -1 / 0, d = -1 / 0;
  for (let f = e * 6, h = (e + s) * 6; f < h; f += 6) {
    const S = r[f + 0];
    S < a && (a = S), S > c && (c = S);
    const R = r[f + 2];
    R < l && (l = R), R > E && (E = R);
    const _ = r[f + 4];
    _ < u && (u = _), _ > d && (d = _);
  }
  o[0] = a, o[1] = l, o[2] = u, o[3] = c, o[4] = E, o[5] = d;
}
function computeTriangleBounds(r, e) {
  makeEmptyBounds(e);
  const s = r.attributes.position, o = r.index ? r.index.array : null, a = getTriCount(r), l = new Float32Array(a * 6), u = s.normalized, c = s.array, E = s.offset || 0;
  let d = 3;
  s.isInterleavedBufferAttribute && (d = s.data.stride);
  const f = ["getX", "getY", "getZ"];
  for (let h = 0; h < a; h++) {
    const S = h * 3, R = h * 6;
    let _ = S + 0, m = S + 1, L = S + 2;
    o && (_ = o[_], m = o[m], L = o[L]), u || (_ = _ * d + E, m = m * d + E, L = L * d + E);
    for (let F = 0; F < 3; F++) {
      let W, G, q;
      u ? (W = s[f[F]](_), G = s[f[F]](m), q = s[f[F]](L)) : (W = c[_ + F], G = c[m + F], q = c[L + F]);
      let fe = W;
      G < fe && (fe = G), q < fe && (fe = q);
      let _e = W;
      G > _e && (_e = G), q > _e && (_e = q);
      const Le = (_e - fe) / 2, Fe = F * 2;
      l[R + Fe + 0] = fe + Le, l[R + Fe + 1] = Le + (Math.abs(fe) + Le) * FLOAT32_EPSILON, fe < e[F] && (e[F] = fe), _e > e[F + 3] && (e[F + 3] = _e);
    }
  }
  return l;
}
const BIN_COUNT = 32, binsSort = (r, e) => r.candidate - e.candidate, sahBins = new Array(BIN_COUNT).fill().map(() => ({
  count: 0,
  bounds: new Float32Array(6),
  rightCacheBounds: new Float32Array(6),
  leftCacheBounds: new Float32Array(6),
  candidate: 0
})), leftBounds = new Float32Array(6);
function getOptimalSplit(r, e, s, o, a, l) {
  let u = -1, c = 0;
  if (l === CENTER)
    u = getLongestEdgeIndex(e), u !== -1 && (c = (e[u] + e[u + 3]) / 2);
  else if (l === AVERAGE)
    u = getLongestEdgeIndex(r), u !== -1 && (c = getAverage(s, o, a, u));
  else if (l === SAH) {
    const E = computeSurfaceArea(r);
    let d = TRIANGLE_INTERSECT_COST * a;
    const f = o * 6, h = (o + a) * 6;
    for (let S = 0; S < 3; S++) {
      const R = e[S], L = (e[S + 3] - R) / BIN_COUNT;
      if (a < BIN_COUNT / 4) {
        const F = [...sahBins];
        F.length = a;
        let W = 0;
        for (let q = f; q < h; q += 6, W++) {
          const fe = F[W];
          fe.candidate = s[q + 2 * S], fe.count = 0;
          const {
            bounds: _e,
            leftCacheBounds: Le,
            rightCacheBounds: Fe
          } = fe;
          for (let Ee = 0; Ee < 3; Ee++)
            Fe[Ee] = 1 / 0, Fe[Ee + 3] = -1 / 0, Le[Ee] = 1 / 0, Le[Ee + 3] = -1 / 0, _e[Ee] = 1 / 0, _e[Ee + 3] = -1 / 0;
          expandByTriangleBounds(q, s, _e);
        }
        F.sort(binsSort);
        let G = a;
        for (let q = 0; q < G; q++) {
          const fe = F[q];
          for (; q + 1 < G && F[q + 1].candidate === fe.candidate; )
            F.splice(q + 1, 1), G--;
        }
        for (let q = f; q < h; q += 6) {
          const fe = s[q + 2 * S];
          for (let _e = 0; _e < G; _e++) {
            const Le = F[_e];
            fe >= Le.candidate ? expandByTriangleBounds(q, s, Le.rightCacheBounds) : (expandByTriangleBounds(q, s, Le.leftCacheBounds), Le.count++);
          }
        }
        for (let q = 0; q < G; q++) {
          const fe = F[q], _e = fe.count, Le = a - fe.count, Fe = fe.leftCacheBounds, Ee = fe.rightCacheBounds;
          let Ge = 0;
          _e !== 0 && (Ge = computeSurfaceArea(Fe) / E);
          let ve = 0;
          Le !== 0 && (ve = computeSurfaceArea(Ee) / E);
          const te = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (Ge * _e + ve * Le);
          te < d && (u = S, d = te, c = fe.candidate);
        }
      } else {
        for (let G = 0; G < BIN_COUNT; G++) {
          const q = sahBins[G];
          q.count = 0, q.candidate = R + L + G * L;
          const fe = q.bounds;
          for (let _e = 0; _e < 3; _e++)
            fe[_e] = 1 / 0, fe[_e + 3] = -1 / 0;
        }
        for (let G = f; G < h; G += 6) {
          let _e = ~~((s[G + 2 * S] - R) / L);
          _e >= BIN_COUNT && (_e = BIN_COUNT - 1);
          const Le = sahBins[_e];
          Le.count++, expandByTriangleBounds(G, s, Le.bounds);
        }
        const F = sahBins[BIN_COUNT - 1];
        copyBounds(F.bounds, F.rightCacheBounds);
        for (let G = BIN_COUNT - 2; G >= 0; G--) {
          const q = sahBins[G], fe = sahBins[G + 1];
          unionBounds(q.bounds, fe.rightCacheBounds, q.rightCacheBounds);
        }
        let W = 0;
        for (let G = 0; G < BIN_COUNT - 1; G++) {
          const q = sahBins[G], fe = q.count, _e = q.bounds, Fe = sahBins[G + 1].rightCacheBounds;
          fe !== 0 && (W === 0 ? copyBounds(_e, leftBounds) : unionBounds(_e, leftBounds, leftBounds)), W += fe;
          let Ee = 0, Ge = 0;
          W !== 0 && (Ee = computeSurfaceArea(leftBounds) / E);
          const ve = a - W;
          ve !== 0 && (Ge = computeSurfaceArea(Fe) / E);
          const te = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (Ee * W + Ge * ve);
          te < d && (u = S, d = te, c = q.candidate);
        }
      }
    }
  } else
    console.warn(`MeshBVH: Invalid build strategy value ${l} used.`);
  return { axis: u, pos: c };
}
function getAverage(r, e, s, o) {
  let a = 0;
  for (let l = e, u = e + s; l < u; l++)
    a += r[l * 6 + o * 2];
  return a / s;
}
class MeshBVHNode {
  constructor() {
  }
}
function partition(r, e, s, o, a, l) {
  let u = o, c = o + a - 1;
  const E = l.pos, d = l.axis * 2;
  for (; ; ) {
    for (; u <= c && s[u * 6 + d] < E; )
      u++;
    for (; u <= c && s[c * 6 + d] >= E; )
      c--;
    if (u < c) {
      for (let f = 0; f < 3; f++) {
        let h = e[u * 3 + f];
        e[u * 3 + f] = e[c * 3 + f], e[c * 3 + f] = h;
      }
      for (let f = 0; f < 6; f++) {
        let h = s[u * 6 + f];
        s[u * 6 + f] = s[c * 6 + f], s[c * 6 + f] = h;
      }
      u++, c--;
    } else
      return u;
  }
}
function partition_indirect(r, e, s, o, a, l) {
  let u = o, c = o + a - 1;
  const E = l.pos, d = l.axis * 2;
  for (; ; ) {
    for (; u <= c && s[u * 6 + d] < E; )
      u++;
    for (; u <= c && s[c * 6 + d] >= E; )
      c--;
    if (u < c) {
      let f = r[u];
      r[u] = r[c], r[c] = f;
      for (let h = 0; h < 6; h++) {
        let S = s[u * 6 + h];
        s[u * 6 + h] = s[c * 6 + h], s[c * 6 + h] = S;
      }
      u++, c--;
    } else
      return u;
  }
}
function generateIndirectBuffer(r, e) {
  const s = (r.index ? r.index.count : r.attributes.position.count) / 3, o = s > 2 ** 16, a = o ? 4 : 2, l = e ? new SharedArrayBuffer(s * a) : new ArrayBuffer(s * a), u = o ? new Uint32Array(l) : new Uint16Array(l);
  for (let c = 0, E = u.length; c < E; c++)
    u[c] = c;
  return u;
}
function buildTree(r, e) {
  const s = r.geometry, o = s.index ? s.index.array : null, a = e.maxDepth, l = e.verbose, u = e.maxLeafTris, c = e.strategy, E = e.onProgress, d = getTriCount(s), f = r._indirectBuffer;
  let h = !1;
  const S = new Float32Array(6), R = new Float32Array(6), _ = computeTriangleBounds(s, S), m = e.indirect ? partition_indirect : partition, L = [], F = e.indirect ? getFullGeometryRange(s) : getRootIndexRanges(s);
  if (F.length === 1) {
    const q = F[0], fe = new MeshBVHNode();
    fe.boundingData = S, getCentroidBounds(_, q.offset, q.count, R), G(fe, q.offset, q.count, R), L.push(fe);
  } else
    for (let q of F) {
      const fe = new MeshBVHNode();
      fe.boundingData = new Float32Array(6), getBounds(_, q.offset, q.count, fe.boundingData, R), G(fe, q.offset, q.count, R), L.push(fe);
    }
  return L;
  function W(q) {
    E && E(q / d);
  }
  function G(q, fe, _e, Le = null, Fe = 0) {
    if (!h && Fe >= a && (h = !0, l && (console.warn(`MeshBVH: Max depth of ${a} reached when generating BVH. Consider increasing maxDepth.`), console.warn(s))), _e <= u || Fe >= a)
      return W(fe + _e), q.offset = fe, q.count = _e, q;
    const Ee = getOptimalSplit(q.boundingData, Le, _, fe, _e, c);
    if (Ee.axis === -1)
      return W(fe + _e), q.offset = fe, q.count = _e, q;
    const Ge = m(f, o, _, fe, _e, Ee);
    if (Ge === fe || Ge === fe + _e)
      W(fe + _e), q.offset = fe, q.count = _e;
    else {
      q.splitAxis = Ee.axis;
      const ve = new MeshBVHNode(), te = fe, ae = Ge - fe;
      q.left = ve, ve.boundingData = new Float32Array(6), getBounds(_, te, ae, ve.boundingData, R), G(ve, te, ae, R, Fe + 1);
      const v = new MeshBVHNode(), Te = Ge, De = _e - ae;
      q.right = v, v.boundingData = new Float32Array(6), getBounds(_, Te, De, v.boundingData, R), G(v, Te, De, R, Fe + 1);
    }
    return q;
  }
}
function buildPackedTree(r, e) {
  const s = r.geometry;
  e.indirect && (r._indirectBuffer = generateIndirectBuffer(s, e.useSharedArrayBuffer), hasGroupGaps(s) && !e.verbose && console.warn(
    'MeshBVH: Provided geometry contains groups that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.'
  )), r._indirectBuffer || ensureIndex(s, e);
  const o = buildTree(r, e);
  let a, l, u;
  const c = [], E = e.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
  for (let h = 0; h < o.length; h++) {
    const S = o[h];
    let R = d(S);
    const _ = new E(BYTES_PER_NODE * R);
    a = new Float32Array(_), l = new Uint32Array(_), u = new Uint16Array(_), f(0, S), c.push(_);
  }
  r._roots = c;
  return;
  function d(h) {
    return h.count ? 1 : 1 + d(h.left) + d(h.right);
  }
  function f(h, S) {
    const R = h / 4, _ = h / 2, m = !!S.count, L = S.boundingData;
    for (let F = 0; F < 6; F++)
      a[R + F] = L[F];
    if (m) {
      const F = S.offset, W = S.count;
      return l[R + 6] = F, u[_ + 14] = W, u[_ + 15] = IS_LEAFNODE_FLAG, h + BYTES_PER_NODE;
    } else {
      const F = S.left, W = S.right, G = S.splitAxis;
      let q;
      if (q = f(h + BYTES_PER_NODE, F), q / 4 > Math.pow(2, 32))
        throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
      return l[R + 6] = q / 4, q = f(q, W), l[R + 7] = G, q;
    }
  }
}
class SeparatingAxisBounds {
  constructor() {
    this.min = 1 / 0, this.max = -1 / 0;
  }
  setFromPointsField(e, s) {
    let o = 1 / 0, a = -1 / 0;
    for (let l = 0, u = e.length; l < u; l++) {
      const E = e[l][s];
      o = E < o ? E : o, a = E > a ? E : a;
    }
    this.min = o, this.max = a;
  }
  setFromPoints(e, s) {
    let o = 1 / 0, a = -1 / 0;
    for (let l = 0, u = s.length; l < u; l++) {
      const c = s[l], E = e.dot(c);
      o = E < o ? E : o, a = E > a ? E : a;
    }
    this.min = o, this.max = a;
  }
  isSeparated(e) {
    return this.min > e.max || e.min > this.max;
  }
}
SeparatingAxisBounds.prototype.setFromBox = function() {
  const r = new Vector3$1();
  return function(s, o) {
    const a = o.min, l = o.max;
    let u = 1 / 0, c = -1 / 0;
    for (let E = 0; E <= 1; E++)
      for (let d = 0; d <= 1; d++)
        for (let f = 0; f <= 1; f++) {
          r.x = a.x * E + l.x * (1 - E), r.y = a.y * d + l.y * (1 - d), r.z = a.z * f + l.z * (1 - f);
          const h = s.dot(r);
          u = Math.min(h, u), c = Math.max(h, c);
        }
    this.min = u, this.max = c;
  };
}();
const closestPointLineToLine = function() {
  const r = new Vector3$1(), e = new Vector3$1(), s = new Vector3$1();
  return function(a, l, u) {
    const c = a.start, E = r, d = l.start, f = e;
    s.subVectors(c, d), r.subVectors(a.end, a.start), e.subVectors(l.end, l.start);
    const h = s.dot(f), S = f.dot(E), R = f.dot(f), _ = s.dot(E), L = E.dot(E) * R - S * S;
    let F, W;
    L !== 0 ? F = (h * S - _ * R) / L : F = 0, W = (h + F * S) / R, u.x = F, u.y = W;
  };
}(), closestPointsSegmentToSegment = function() {
  const r = new Vector2(), e = new Vector3$1(), s = new Vector3$1();
  return function(a, l, u, c) {
    closestPointLineToLine(a, l, r);
    let E = r.x, d = r.y;
    if (E >= 0 && E <= 1 && d >= 0 && d <= 1) {
      a.at(E, u), l.at(d, c);
      return;
    } else if (E >= 0 && E <= 1) {
      d < 0 ? l.at(0, c) : l.at(1, c), a.closestPointToPoint(c, !0, u);
      return;
    } else if (d >= 0 && d <= 1) {
      E < 0 ? a.at(0, u) : a.at(1, u), l.closestPointToPoint(u, !0, c);
      return;
    } else {
      let f;
      E < 0 ? f = a.start : f = a.end;
      let h;
      d < 0 ? h = l.start : h = l.end;
      const S = e, R = s;
      if (a.closestPointToPoint(h, !0, e), l.closestPointToPoint(f, !0, s), S.distanceToSquared(h) <= R.distanceToSquared(f)) {
        u.copy(S), c.copy(h);
        return;
      } else {
        u.copy(f), c.copy(R);
        return;
      }
    }
  };
}(), sphereIntersectTriangle = function() {
  const r = new Vector3$1(), e = new Vector3$1(), s = new Plane(), o = new Line3();
  return function(l, u) {
    const { radius: c, center: E } = l, { a: d, b: f, c: h } = u;
    if (o.start = d, o.end = f, o.closestPointToPoint(E, !0, r).distanceTo(E) <= c || (o.start = d, o.end = h, o.closestPointToPoint(E, !0, r).distanceTo(E) <= c) || (o.start = f, o.end = h, o.closestPointToPoint(E, !0, r).distanceTo(E) <= c))
      return !0;
    const m = u.getPlane(s);
    if (Math.abs(m.distanceToPoint(E)) <= c) {
      const F = m.projectPoint(E, e);
      if (u.containsPoint(F))
        return !0;
    }
    return !1;
  };
}(), ZERO_EPSILON = 1e-15;
function isNearZero(r) {
  return Math.abs(r) < ZERO_EPSILON;
}
class ExtendedTriangle extends Triangle {
  constructor(...e) {
    super(...e), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(() => new Vector3$1()), this.satBounds = new Array(4).fill().map(() => new SeparatingAxisBounds()), this.points = [this.a, this.b, this.c], this.sphere = new Sphere$1(), this.plane = new Plane(), this.needsUpdate = !0;
  }
  intersectsSphere(e) {
    return sphereIntersectTriangle(e, this);
  }
  update() {
    const e = this.a, s = this.b, o = this.c, a = this.points, l = this.satAxes, u = this.satBounds, c = l[0], E = u[0];
    this.getNormal(c), E.setFromPoints(c, a);
    const d = l[1], f = u[1];
    d.subVectors(e, s), f.setFromPoints(d, a);
    const h = l[2], S = u[2];
    h.subVectors(s, o), S.setFromPoints(h, a);
    const R = l[3], _ = u[3];
    R.subVectors(o, e), _.setFromPoints(R, a), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(c, e), this.needsUpdate = !1;
  }
}
ExtendedTriangle.prototype.closestPointToSegment = function() {
  const r = new Vector3$1(), e = new Vector3$1(), s = new Line3();
  return function(a, l = null, u = null) {
    const { start: c, end: E } = a, d = this.points;
    let f, h = 1 / 0;
    for (let S = 0; S < 3; S++) {
      const R = (S + 1) % 3;
      s.start.copy(d[S]), s.end.copy(d[R]), closestPointsSegmentToSegment(s, a, r, e), f = r.distanceToSquared(e), f < h && (h = f, l && l.copy(r), u && u.copy(e));
    }
    return this.closestPointToPoint(c, r), f = c.distanceToSquared(r), f < h && (h = f, l && l.copy(r), u && u.copy(c)), this.closestPointToPoint(E, r), f = E.distanceToSquared(r), f < h && (h = f, l && l.copy(r), u && u.copy(E)), Math.sqrt(h);
  };
}();
ExtendedTriangle.prototype.intersectsTriangle = function() {
  const r = new ExtendedTriangle(), e = new Array(3), s = new Array(3), o = new SeparatingAxisBounds(), a = new SeparatingAxisBounds(), l = new Vector3$1(), u = new Vector3$1(), c = new Vector3$1(), E = new Vector3$1(), d = new Vector3$1(), f = new Line3(), h = new Line3(), S = new Line3(), R = new Vector3$1();
  function _(m, L, F) {
    const W = m.points;
    let G = 0, q = -1;
    for (let fe = 0; fe < 3; fe++) {
      const { start: _e, end: Le } = f;
      _e.copy(W[fe]), Le.copy(W[(fe + 1) % 3]), f.delta(u);
      const Fe = isNearZero(L.distanceToPoint(_e));
      if (isNearZero(L.normal.dot(u)) && Fe) {
        F.copy(f), G = 2;
        break;
      }
      const Ee = L.intersectLine(f, R);
      if (!Ee && Fe && R.copy(_e), (Ee || Fe) && !isNearZero(R.distanceTo(Le))) {
        if (G <= 1)
          (G === 1 ? F.start : F.end).copy(R), Fe && (q = G);
        else if (G >= 2) {
          (q === 1 ? F.start : F.end).copy(R), G = 2;
          break;
        }
        if (G++, G === 2 && q === -1)
          break;
      }
    }
    return G;
  }
  return function(L, F = null, W = !1) {
    this.needsUpdate && this.update(), L.isExtendedTriangle ? L.needsUpdate && L.update() : (r.copy(L), r.update(), L = r);
    const G = this.plane, q = L.plane;
    if (Math.abs(G.normal.dot(q.normal)) > 1 - 1e-10) {
      const fe = this.satBounds, _e = this.satAxes;
      s[0] = L.a, s[1] = L.b, s[2] = L.c;
      for (let Ee = 0; Ee < 4; Ee++) {
        const Ge = fe[Ee], ve = _e[Ee];
        if (o.setFromPoints(ve, s), Ge.isSeparated(o))
          return !1;
      }
      const Le = L.satBounds, Fe = L.satAxes;
      e[0] = this.a, e[1] = this.b, e[2] = this.c;
      for (let Ee = 0; Ee < 4; Ee++) {
        const Ge = Le[Ee], ve = Fe[Ee];
        if (o.setFromPoints(ve, e), Ge.isSeparated(o))
          return !1;
      }
      for (let Ee = 0; Ee < 4; Ee++) {
        const Ge = _e[Ee];
        for (let ve = 0; ve < 4; ve++) {
          const te = Fe[ve];
          if (l.crossVectors(Ge, te), o.setFromPoints(l, e), a.setFromPoints(l, s), o.isSeparated(a))
            return !1;
        }
      }
      return F && (W || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), F.start.set(0, 0, 0), F.end.set(0, 0, 0)), !0;
    } else {
      const fe = _(this, q, h);
      if (fe === 1 && L.containsPoint(h.end))
        return F && (F.start.copy(h.end), F.end.copy(h.end)), !0;
      if (fe !== 2)
        return !1;
      const _e = _(L, G, S);
      if (_e === 1 && this.containsPoint(S.end))
        return F && (F.start.copy(S.end), F.end.copy(S.end)), !0;
      if (_e !== 2)
        return !1;
      if (h.delta(c), S.delta(E), c.dot(E) < 0) {
        let ae = S.start;
        S.start = S.end, S.end = ae;
      }
      const Le = h.start.dot(c), Fe = h.end.dot(c), Ee = S.start.dot(c), Ge = S.end.dot(c), ve = Fe < Ee, te = Le < Ge;
      return Le !== Ge && Ee !== Fe && ve === te ? !1 : (F && (d.subVectors(h.start, S.start), d.dot(c) > 0 ? F.start.copy(h.start) : F.start.copy(S.start), d.subVectors(h.end, S.end), d.dot(c) < 0 ? F.end.copy(h.end) : F.end.copy(S.end)), !0);
    }
  };
}();
ExtendedTriangle.prototype.distanceToPoint = function() {
  const r = new Vector3$1();
  return function(s) {
    return this.closestPointToPoint(s, r), s.distanceTo(r);
  };
}();
ExtendedTriangle.prototype.distanceToTriangle = function() {
  const r = new Vector3$1(), e = new Vector3$1(), s = ["a", "b", "c"], o = new Line3(), a = new Line3();
  return function(u, c = null, E = null) {
    const d = c || E ? o : null;
    if (this.intersectsTriangle(u, d))
      return (c || E) && (c && d.getCenter(c), E && d.getCenter(E)), 0;
    let f = 1 / 0;
    for (let h = 0; h < 3; h++) {
      let S;
      const R = s[h], _ = u[R];
      this.closestPointToPoint(_, r), S = _.distanceToSquared(r), S < f && (f = S, c && c.copy(r), E && E.copy(_));
      const m = this[R];
      u.closestPointToPoint(m, r), S = m.distanceToSquared(r), S < f && (f = S, c && c.copy(m), E && E.copy(r));
    }
    for (let h = 0; h < 3; h++) {
      const S = s[h], R = s[(h + 1) % 3];
      o.set(this[S], this[R]);
      for (let _ = 0; _ < 3; _++) {
        const m = s[_], L = s[(_ + 1) % 3];
        a.set(u[m], u[L]), closestPointsSegmentToSegment(o, a, r, e);
        const F = r.distanceToSquared(e);
        F < f && (f = F, c && c.copy(r), E && E.copy(e));
      }
    }
    return Math.sqrt(f);
  };
}();
class OrientedBox {
  constructor(e, s, o) {
    this.isOrientedBox = !0, this.min = new Vector3$1(), this.max = new Vector3$1(), this.matrix = new Matrix4(), this.invMatrix = new Matrix4(), this.points = new Array(8).fill().map(() => new Vector3$1()), this.satAxes = new Array(3).fill().map(() => new Vector3$1()), this.satBounds = new Array(3).fill().map(() => new SeparatingAxisBounds()), this.alignedSatBounds = new Array(3).fill().map(() => new SeparatingAxisBounds()), this.needsUpdate = !1, e && this.min.copy(e), s && this.max.copy(s), o && this.matrix.copy(o);
  }
  set(e, s, o) {
    this.min.copy(e), this.max.copy(s), this.matrix.copy(o), this.needsUpdate = !0;
  }
  copy(e) {
    this.min.copy(e.min), this.max.copy(e.max), this.matrix.copy(e.matrix), this.needsUpdate = !0;
  }
}
OrientedBox.prototype.update = function() {
  return function() {
    const e = this.matrix, s = this.min, o = this.max, a = this.points;
    for (let d = 0; d <= 1; d++)
      for (let f = 0; f <= 1; f++)
        for (let h = 0; h <= 1; h++) {
          const S = 1 * d | 2 * f | 4 * h, R = a[S];
          R.x = d ? o.x : s.x, R.y = f ? o.y : s.y, R.z = h ? o.z : s.z, R.applyMatrix4(e);
        }
    const l = this.satBounds, u = this.satAxes, c = a[0];
    for (let d = 0; d < 3; d++) {
      const f = u[d], h = l[d], S = 1 << d, R = a[S];
      f.subVectors(c, R), h.setFromPoints(f, a);
    }
    const E = this.alignedSatBounds;
    E[0].setFromPointsField(a, "x"), E[1].setFromPointsField(a, "y"), E[2].setFromPointsField(a, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
  };
}();
OrientedBox.prototype.intersectsBox = function() {
  const r = new SeparatingAxisBounds();
  return function(s) {
    this.needsUpdate && this.update();
    const o = s.min, a = s.max, l = this.satBounds, u = this.satAxes, c = this.alignedSatBounds;
    if (r.min = o.x, r.max = a.x, c[0].isSeparated(r) || (r.min = o.y, r.max = a.y, c[1].isSeparated(r)) || (r.min = o.z, r.max = a.z, c[2].isSeparated(r)))
      return !1;
    for (let E = 0; E < 3; E++) {
      const d = u[E], f = l[E];
      if (r.setFromBox(d, s), f.isSeparated(r))
        return !1;
    }
    return !0;
  };
}();
OrientedBox.prototype.intersectsTriangle = function() {
  const r = new ExtendedTriangle(), e = new Array(3), s = new SeparatingAxisBounds(), o = new SeparatingAxisBounds(), a = new Vector3$1();
  return function(u) {
    this.needsUpdate && this.update(), u.isExtendedTriangle ? u.needsUpdate && u.update() : (r.copy(u), r.update(), u = r);
    const c = this.satBounds, E = this.satAxes;
    e[0] = u.a, e[1] = u.b, e[2] = u.c;
    for (let S = 0; S < 3; S++) {
      const R = c[S], _ = E[S];
      if (s.setFromPoints(_, e), R.isSeparated(s))
        return !1;
    }
    const d = u.satBounds, f = u.satAxes, h = this.points;
    for (let S = 0; S < 3; S++) {
      const R = d[S], _ = f[S];
      if (s.setFromPoints(_, h), R.isSeparated(s))
        return !1;
    }
    for (let S = 0; S < 3; S++) {
      const R = E[S];
      for (let _ = 0; _ < 4; _++) {
        const m = f[_];
        if (a.crossVectors(R, m), s.setFromPoints(a, e), o.setFromPoints(a, h), s.isSeparated(o))
          return !1;
      }
    }
    return !0;
  };
}();
OrientedBox.prototype.closestPointToPoint = function() {
  return function(e, s) {
    return this.needsUpdate && this.update(), s.copy(e).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), s;
  };
}();
OrientedBox.prototype.distanceToPoint = function() {
  const r = new Vector3$1();
  return function(s) {
    return this.closestPointToPoint(s, r), s.distanceTo(r);
  };
}();
OrientedBox.prototype.distanceToBox = function() {
  const r = ["x", "y", "z"], e = new Array(12).fill().map(() => new Line3()), s = new Array(12).fill().map(() => new Line3()), o = new Vector3$1(), a = new Vector3$1();
  return function(u, c = 0, E = null, d = null) {
    if (this.needsUpdate && this.update(), this.intersectsBox(u))
      return (E || d) && (u.getCenter(a), this.closestPointToPoint(a, o), u.closestPointToPoint(o, a), E && E.copy(o), d && d.copy(a)), 0;
    const f = c * c, h = u.min, S = u.max, R = this.points;
    let _ = 1 / 0;
    for (let L = 0; L < 8; L++) {
      const F = R[L];
      a.copy(F).clamp(h, S);
      const W = F.distanceToSquared(a);
      if (W < _ && (_ = W, E && E.copy(F), d && d.copy(a), W < f))
        return Math.sqrt(W);
    }
    let m = 0;
    for (let L = 0; L < 3; L++)
      for (let F = 0; F <= 1; F++)
        for (let W = 0; W <= 1; W++) {
          const G = (L + 1) % 3, q = (L + 2) % 3, fe = F << G | W << q, _e = 1 << L | F << G | W << q, Le = R[fe], Fe = R[_e];
          e[m].set(Le, Fe);
          const Ge = r[L], ve = r[G], te = r[q], ae = s[m], v = ae.start, Te = ae.end;
          v[Ge] = h[Ge], v[ve] = F ? h[ve] : S[ve], v[te] = W ? h[te] : S[ve], Te[Ge] = S[Ge], Te[ve] = F ? h[ve] : S[ve], Te[te] = W ? h[te] : S[ve], m++;
        }
    for (let L = 0; L <= 1; L++)
      for (let F = 0; F <= 1; F++)
        for (let W = 0; W <= 1; W++) {
          a.x = L ? S.x : h.x, a.y = F ? S.y : h.y, a.z = W ? S.z : h.z, this.closestPointToPoint(a, o);
          const G = a.distanceToSquared(o);
          if (G < _ && (_ = G, E && E.copy(o), d && d.copy(a), G < f))
            return Math.sqrt(G);
        }
    for (let L = 0; L < 12; L++) {
      const F = e[L];
      for (let W = 0; W < 12; W++) {
        const G = s[W];
        closestPointsSegmentToSegment(F, G, o, a);
        const q = o.distanceToSquared(a);
        if (q < _ && (_ = q, E && E.copy(o), d && d.copy(a), q < f))
          return Math.sqrt(q);
      }
    }
    return Math.sqrt(_);
  };
}();
class PrimitivePool {
  constructor(e) {
    this._getNewPrimitive = e, this._primitives = [];
  }
  getPrimitive() {
    const e = this._primitives;
    return e.length === 0 ? this._getNewPrimitive() : e.pop();
  }
  releasePrimitive(e) {
    this._primitives.push(e);
  }
}
class ExtendedTrianglePoolBase extends PrimitivePool {
  constructor() {
    super(() => new ExtendedTriangle());
  }
}
const ExtendedTrianglePool = /* @__PURE__ */ new ExtendedTrianglePoolBase();
function IS_LEAF(r, e) {
  return e[r + 15] === 65535;
}
function OFFSET(r, e) {
  return e[r + 6];
}
function COUNT(r, e) {
  return e[r + 14];
}
function LEFT_NODE(r) {
  return r + 8;
}
function RIGHT_NODE(r, e) {
  return e[r + 6];
}
function SPLIT_AXIS(r, e) {
  return e[r + 7];
}
function BOUNDING_DATA_INDEX(r) {
  return r;
}
class _BufferStack {
  constructor() {
    this.float32Array = null, this.uint16Array = null, this.uint32Array = null;
    const e = [];
    let s = null;
    this.setBuffer = (o) => {
      s && e.push(s), s = o, this.float32Array = new Float32Array(o), this.uint16Array = new Uint16Array(o), this.uint32Array = new Uint32Array(o);
    }, this.clearBuffer = () => {
      s = null, this.float32Array = null, this.uint16Array = null, this.uint32Array = null, e.length !== 0 && this.setBuffer(e.pop());
    };
  }
}
const BufferStack = new _BufferStack();
let _box1, _box2;
const boxStack = [], boxPool = /* @__PURE__ */ new PrimitivePool(() => new Box3$1());
function shapecast(r, e, s, o, a, l) {
  _box1 = boxPool.getPrimitive(), _box2 = boxPool.getPrimitive(), boxStack.push(_box1, _box2), BufferStack.setBuffer(r._roots[e]);
  const u = shapecastTraverse(0, r.geometry, s, o, a, l);
  BufferStack.clearBuffer(), boxPool.releasePrimitive(_box1), boxPool.releasePrimitive(_box2), boxStack.pop(), boxStack.pop();
  const c = boxStack.length;
  return c > 0 && (_box2 = boxStack[c - 1], _box1 = boxStack[c - 2]), u;
}
function shapecastTraverse(r, e, s, o, a = null, l = 0, u = 0) {
  const { float32Array: c, uint16Array: E, uint32Array: d } = BufferStack;
  let f = r * 2;
  if (IS_LEAF(f, E)) {
    const S = OFFSET(r, d), R = COUNT(f, E);
    return arrayToBox(r, c, _box1), o(S, R, !1, u, l + r, _box1);
  } else {
    let Ge = function(te) {
      const { uint16Array: ae, uint32Array: v } = BufferStack;
      let Te = te * 2;
      for (; !IS_LEAF(Te, ae); )
        te = LEFT_NODE(te), Te = te * 2;
      return OFFSET(te, v);
    }, ve = function(te) {
      const { uint16Array: ae, uint32Array: v } = BufferStack;
      let Te = te * 2;
      for (; !IS_LEAF(Te, ae); )
        te = RIGHT_NODE(te, v), Te = te * 2;
      return OFFSET(te, v) + COUNT(Te, ae);
    };
    const S = LEFT_NODE(r), R = RIGHT_NODE(r, d);
    let _ = S, m = R, L, F, W, G;
    if (a && (W = _box1, G = _box2, arrayToBox(_, c, W), arrayToBox(m, c, G), L = a(W), F = a(G), F < L)) {
      _ = R, m = S;
      const te = L;
      L = F, F = te, W = G;
    }
    W || (W = _box1, arrayToBox(_, c, W));
    const q = IS_LEAF(_ * 2, E), fe = s(W, q, L, u + 1, l + _);
    let _e;
    if (fe === CONTAINED) {
      const te = Ge(_), v = ve(_) - te;
      _e = o(te, v, !0, u + 1, l + _, W);
    } else
      _e = fe && shapecastTraverse(
        _,
        e,
        s,
        o,
        a,
        l,
        u + 1
      );
    if (_e)
      return !0;
    G = _box2, arrayToBox(m, c, G);
    const Le = IS_LEAF(m * 2, E), Fe = s(G, Le, F, u + 1, l + m);
    let Ee;
    if (Fe === CONTAINED) {
      const te = Ge(m), v = ve(m) - te;
      Ee = o(te, v, !0, u + 1, l + m, G);
    } else
      Ee = Fe && shapecastTraverse(
        m,
        e,
        s,
        o,
        a,
        l,
        u + 1
      );
    return !!Ee;
  }
}
const temp = /* @__PURE__ */ new Vector3$1(), temp1$2 = /* @__PURE__ */ new Vector3$1();
function closestPointToPoint(r, e, s = {}, o = 0, a = 1 / 0) {
  const l = o * o, u = a * a;
  let c = 1 / 0, E = null;
  if (r.shapecast(
    {
      boundsTraverseOrder: (f) => (temp.copy(e).clamp(f.min, f.max), temp.distanceToSquared(e)),
      intersectsBounds: (f, h, S) => S < c && S < u,
      intersectsTriangle: (f, h) => {
        f.closestPointToPoint(e, temp);
        const S = e.distanceToSquared(temp);
        return S < c && (temp1$2.copy(temp), c = S, E = h), S < l;
      }
    }
  ), c === 1 / 0)
    return null;
  const d = Math.sqrt(c);
  return s.point ? s.point.copy(temp1$2) : s.point = temp1$2.clone(), s.distance = d, s.faceIndex = E, s;
}
const _vA$1 = /* @__PURE__ */ new Vector3$1(), _vB$1 = /* @__PURE__ */ new Vector3$1(), _vC$1 = /* @__PURE__ */ new Vector3$1(), _uvA = /* @__PURE__ */ new Vector2(), _uvB = /* @__PURE__ */ new Vector2(), _uvC = /* @__PURE__ */ new Vector2(), _normalA = /* @__PURE__ */ new Vector3$1(), _normalB = /* @__PURE__ */ new Vector3$1(), _normalC = /* @__PURE__ */ new Vector3$1(), _intersectionPoint = /* @__PURE__ */ new Vector3$1();
function checkIntersection(r, e, s, o, a, l) {
  let u;
  return l === BackSide ? u = r.intersectTriangle(o, s, e, !0, a) : u = r.intersectTriangle(e, s, o, l !== DoubleSide, a), u === null ? null : {
    distance: r.origin.distanceTo(a),
    point: a.clone()
  };
}
function checkBufferGeometryIntersection(r, e, s, o, a, l, u, c, E) {
  _vA$1.fromBufferAttribute(e, l), _vB$1.fromBufferAttribute(e, u), _vC$1.fromBufferAttribute(e, c);
  const d = checkIntersection(r, _vA$1, _vB$1, _vC$1, _intersectionPoint, E);
  if (d) {
    o && (_uvA.fromBufferAttribute(o, l), _uvB.fromBufferAttribute(o, u), _uvC.fromBufferAttribute(o, c), d.uv = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA, _uvB, _uvC, new Vector2())), a && (_uvA.fromBufferAttribute(a, l), _uvB.fromBufferAttribute(a, u), _uvC.fromBufferAttribute(a, c), d.uv1 = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA, _uvB, _uvC, new Vector2())), s && (_normalA.fromBufferAttribute(s, l), _normalB.fromBufferAttribute(s, u), _normalC.fromBufferAttribute(s, c), d.normal = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3$1()), d.normal.dot(r.direction) > 0 && d.normal.multiplyScalar(-1));
    const f = {
      a: l,
      b: u,
      c,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, f.normal), d.face = f, d.faceIndex = l;
  }
  return d;
}
function intersectTri(r, e, s, o, a) {
  const l = o * 3;
  let u = l + 0, c = l + 1, E = l + 2;
  const d = r.index;
  r.index && (u = d.getX(u), c = d.getX(c), E = d.getX(E));
  const { position: f, normal: h, uv: S, uv1: R } = r.attributes, _ = checkBufferGeometryIntersection(s, f, h, S, R, u, c, E, e);
  return _ ? (_.faceIndex = o, a && a.push(_), _) : null;
}
function setTriangle(r, e, s, o) {
  const a = r.a, l = r.b, u = r.c;
  let c = e, E = e + 1, d = e + 2;
  s && (c = s.getX(c), E = s.getX(E), d = s.getX(d)), a.x = o.getX(c), a.y = o.getY(c), a.z = o.getZ(c), l.x = o.getX(E), l.y = o.getY(E), l.z = o.getZ(E), u.x = o.getX(d), u.y = o.getY(d), u.z = o.getZ(d);
}
function intersectTris(r, e, s, o, a, l) {
  const { geometry: u, _indirectBuffer: c } = r;
  for (let E = o, d = o + a; E < d; E++)
    intersectTri(u, e, s, E, l);
}
function intersectClosestTri(r, e, s, o, a) {
  const { geometry: l, _indirectBuffer: u } = r;
  let c = 1 / 0, E = null;
  for (let d = o, f = o + a; d < f; d++) {
    let h;
    h = intersectTri(l, e, s, d), h && h.distance < c && (E = h, c = h.distance);
  }
  return E;
}
function iterateOverTriangles(r, e, s, o, a, l, u) {
  const { geometry: c } = s, { index: E } = c, d = c.attributes.position;
  for (let f = r, h = e + r; f < h; f++) {
    let S;
    if (S = f, setTriangle(u, S * 3, E, d), u.needsUpdate = !0, o(u, S, a, l))
      return !0;
  }
  return !1;
}
function refit(r, e = null) {
  e && Array.isArray(e) && (e = new Set(e));
  const s = r.geometry, o = s.index ? s.index.array : null, a = s.attributes.position;
  let l, u, c, E, d = 0;
  const f = r._roots;
  for (let S = 0, R = f.length; S < R; S++)
    l = f[S], u = new Uint32Array(l), c = new Uint16Array(l), E = new Float32Array(l), h(0, d), d += l.byteLength;
  function h(S, R, _ = !1) {
    const m = S * 2;
    if (c[m + 15] === IS_LEAFNODE_FLAG) {
      const F = u[S + 6], W = c[m + 14];
      let G = 1 / 0, q = 1 / 0, fe = 1 / 0, _e = -1 / 0, Le = -1 / 0, Fe = -1 / 0;
      for (let Ee = 3 * F, Ge = 3 * (F + W); Ee < Ge; Ee++) {
        let ve = o[Ee];
        const te = a.getX(ve), ae = a.getY(ve), v = a.getZ(ve);
        te < G && (G = te), te > _e && (_e = te), ae < q && (q = ae), ae > Le && (Le = ae), v < fe && (fe = v), v > Fe && (Fe = v);
      }
      return E[S + 0] !== G || E[S + 1] !== q || E[S + 2] !== fe || E[S + 3] !== _e || E[S + 4] !== Le || E[S + 5] !== Fe ? (E[S + 0] = G, E[S + 1] = q, E[S + 2] = fe, E[S + 3] = _e, E[S + 4] = Le, E[S + 5] = Fe, !0) : !1;
    } else {
      const F = S + 8, W = u[S + 6], G = F + R, q = W + R;
      let fe = _, _e = !1, Le = !1;
      e ? fe || (_e = e.has(G), Le = e.has(q), fe = !_e && !Le) : (_e = !0, Le = !0);
      const Fe = fe || _e, Ee = fe || Le;
      let Ge = !1;
      Fe && (Ge = h(F, R, fe));
      let ve = !1;
      Ee && (ve = h(W, R, fe));
      const te = Ge || ve;
      if (te)
        for (let ae = 0; ae < 3; ae++) {
          const v = F + ae, Te = W + ae, De = E[v], be = E[v + 3], ze = E[Te], ke = E[Te + 3];
          E[S + ae] = De < ze ? De : ze, E[S + ae + 3] = be > ke ? be : ke;
        }
      return te;
    }
  }
}
const _boundingBox = /* @__PURE__ */ new Box3$1();
function intersectRay(r, e, s, o) {
  return arrayToBox(r, e, _boundingBox), s.intersectBox(_boundingBox, o);
}
function intersectTris_indirect(r, e, s, o, a, l) {
  const { geometry: u, _indirectBuffer: c } = r;
  for (let E = o, d = o + a; E < d; E++) {
    let f = c ? c[E] : E;
    intersectTri(u, e, s, f, l);
  }
}
function intersectClosestTri_indirect(r, e, s, o, a) {
  const { geometry: l, _indirectBuffer: u } = r;
  let c = 1 / 0, E = null;
  for (let d = o, f = o + a; d < f; d++) {
    let h;
    h = intersectTri(l, e, s, u ? u[d] : d), h && h.distance < c && (E = h, c = h.distance);
  }
  return E;
}
function iterateOverTriangles_indirect(r, e, s, o, a, l, u) {
  const { geometry: c } = s, { index: E } = c, d = c.attributes.position;
  for (let f = r, h = e + r; f < h; f++) {
    let S;
    if (S = s.resolveTriangleIndex(f), setTriangle(u, S * 3, E, d), u.needsUpdate = !0, o(u, S, a, l))
      return !0;
  }
  return !1;
}
const _boxIntersection$3 = /* @__PURE__ */ new Vector3$1();
function raycast(r, e, s, o, a) {
  BufferStack.setBuffer(r._roots[e]), _raycast$1(0, r, s, o, a), BufferStack.clearBuffer();
}
function _raycast$1(r, e, s, o, a) {
  const { float32Array: l, uint16Array: u, uint32Array: c } = BufferStack, E = r * 2;
  if (IS_LEAF(E, u)) {
    const f = OFFSET(r, c), h = COUNT(E, u);
    intersectTris(e, s, o, f, h, a);
  } else {
    const f = LEFT_NODE(r);
    intersectRay(f, l, o, _boxIntersection$3) && _raycast$1(f, e, s, o, a);
    const h = RIGHT_NODE(r, c);
    intersectRay(h, l, o, _boxIntersection$3) && _raycast$1(h, e, s, o, a);
  }
}
const _boxIntersection$2 = /* @__PURE__ */ new Vector3$1(), _xyzFields$1 = ["x", "y", "z"];
function raycastFirst(r, e, s, o) {
  BufferStack.setBuffer(r._roots[e]);
  const a = _raycastFirst$1(0, r, s, o);
  return BufferStack.clearBuffer(), a;
}
function _raycastFirst$1(r, e, s, o) {
  const { float32Array: a, uint16Array: l, uint32Array: u } = BufferStack;
  let c = r * 2;
  if (IS_LEAF(c, l)) {
    const d = OFFSET(r, u), f = COUNT(c, l);
    return intersectClosestTri(e, s, o, d, f);
  } else {
    const d = SPLIT_AXIS(r, u), f = _xyzFields$1[d], S = o.direction[f] >= 0;
    let R, _;
    S ? (R = LEFT_NODE(r), _ = RIGHT_NODE(r, u)) : (R = RIGHT_NODE(r, u), _ = LEFT_NODE(r));
    const L = intersectRay(R, a, o, _boxIntersection$2) ? _raycastFirst$1(R, e, s, o) : null;
    if (L) {
      const G = L.point[f];
      if (S ? G <= a[_ + d] : (
        // min bounding data
        G >= a[_ + d + 3]
      ))
        return L;
    }
    const W = intersectRay(_, a, o, _boxIntersection$2) ? _raycastFirst$1(_, e, s, o) : null;
    return L && W ? L.distance <= W.distance ? L : W : L || W || null;
  }
}
const boundingBox$2 = /* @__PURE__ */ new Box3$1(), triangle$1 = /* @__PURE__ */ new ExtendedTriangle(), triangle2$1 = /* @__PURE__ */ new ExtendedTriangle(), invertedMat$1 = /* @__PURE__ */ new Matrix4(), obb$4 = /* @__PURE__ */ new OrientedBox(), obb2$3 = /* @__PURE__ */ new OrientedBox();
function intersectsGeometry(r, e, s, o) {
  BufferStack.setBuffer(r._roots[e]);
  const a = _intersectsGeometry$1(0, r, s, o);
  return BufferStack.clearBuffer(), a;
}
function _intersectsGeometry$1(r, e, s, o, a = null) {
  const { float32Array: l, uint16Array: u, uint32Array: c } = BufferStack;
  let E = r * 2;
  if (a === null && (s.boundingBox || s.computeBoundingBox(), obb$4.set(s.boundingBox.min, s.boundingBox.max, o), a = obb$4), IS_LEAF(E, u)) {
    const f = e.geometry, h = f.index, S = f.attributes.position, R = s.index, _ = s.attributes.position, m = OFFSET(r, c), L = COUNT(E, u);
    if (invertedMat$1.copy(o).invert(), s.boundsTree)
      return arrayToBox(r, l, obb2$3), obb2$3.matrix.copy(invertedMat$1), obb2$3.needsUpdate = !0, s.boundsTree.shapecast({
        intersectsBounds: (W) => obb2$3.intersectsBox(W),
        intersectsTriangle: (W) => {
          W.a.applyMatrix4(o), W.b.applyMatrix4(o), W.c.applyMatrix4(o), W.needsUpdate = !0;
          for (let G = m * 3, q = (L + m) * 3; G < q; G += 3)
            if (setTriangle(triangle2$1, G, h, S), triangle2$1.needsUpdate = !0, W.intersectsTriangle(triangle2$1))
              return !0;
          return !1;
        }
      });
    for (let F = m * 3, W = (L + m) * 3; F < W; F += 3) {
      setTriangle(triangle$1, F, h, S), triangle$1.a.applyMatrix4(invertedMat$1), triangle$1.b.applyMatrix4(invertedMat$1), triangle$1.c.applyMatrix4(invertedMat$1), triangle$1.needsUpdate = !0;
      for (let G = 0, q = R.count; G < q; G += 3)
        if (setTriangle(triangle2$1, G, R, _), triangle2$1.needsUpdate = !0, triangle$1.intersectsTriangle(triangle2$1))
          return !0;
    }
  } else {
    const f = r + 8, h = c[r + 6];
    return arrayToBox(f, l, boundingBox$2), !!(a.intersectsBox(boundingBox$2) && _intersectsGeometry$1(f, e, s, o, a) || (arrayToBox(h, l, boundingBox$2), a.intersectsBox(boundingBox$2) && _intersectsGeometry$1(h, e, s, o, a)));
  }
}
const tempMatrix$1 = /* @__PURE__ */ new Matrix4(), obb$3 = /* @__PURE__ */ new OrientedBox(), obb2$2 = /* @__PURE__ */ new OrientedBox(), temp1$1 = /* @__PURE__ */ new Vector3$1(), temp2$1 = /* @__PURE__ */ new Vector3$1(), temp3$1 = /* @__PURE__ */ new Vector3$1(), temp4$1 = /* @__PURE__ */ new Vector3$1();
function closestPointToGeometry(r, e, s, o = {}, a = {}, l = 0, u = 1 / 0) {
  e.boundingBox || e.computeBoundingBox(), obb$3.set(e.boundingBox.min, e.boundingBox.max, s), obb$3.needsUpdate = !0;
  const c = r.geometry, E = c.attributes.position, d = c.index, f = e.attributes.position, h = e.index, S = ExtendedTrianglePool.getPrimitive(), R = ExtendedTrianglePool.getPrimitive();
  let _ = temp1$1, m = temp2$1, L = null, F = null;
  a && (L = temp3$1, F = temp4$1);
  let W = 1 / 0, G = null, q = null;
  return tempMatrix$1.copy(s).invert(), obb2$2.matrix.copy(tempMatrix$1), r.shapecast(
    {
      boundsTraverseOrder: (fe) => obb$3.distanceToBox(fe),
      intersectsBounds: (fe, _e, Le) => Le < W && Le < u ? (_e && (obb2$2.min.copy(fe.min), obb2$2.max.copy(fe.max), obb2$2.needsUpdate = !0), !0) : !1,
      intersectsRange: (fe, _e) => {
        if (e.boundsTree)
          return e.boundsTree.shapecast({
            boundsTraverseOrder: (Fe) => obb2$2.distanceToBox(Fe),
            intersectsBounds: (Fe, Ee, Ge) => Ge < W && Ge < u,
            intersectsRange: (Fe, Ee) => {
              for (let Ge = Fe, ve = Fe + Ee; Ge < ve; Ge++) {
                setTriangle(R, 3 * Ge, h, f), R.a.applyMatrix4(s), R.b.applyMatrix4(s), R.c.applyMatrix4(s), R.needsUpdate = !0;
                for (let te = fe, ae = fe + _e; te < ae; te++) {
                  setTriangle(S, 3 * te, d, E), S.needsUpdate = !0;
                  const v = S.distanceToTriangle(R, _, L);
                  if (v < W && (m.copy(_), F && F.copy(L), W = v, G = te, q = Ge), v < l)
                    return !0;
                }
              }
            }
          });
        {
          const Le = getTriCount(e);
          for (let Fe = 0, Ee = Le; Fe < Ee; Fe++) {
            setTriangle(R, 3 * Fe, h, f), R.a.applyMatrix4(s), R.b.applyMatrix4(s), R.c.applyMatrix4(s), R.needsUpdate = !0;
            for (let Ge = fe, ve = fe + _e; Ge < ve; Ge++) {
              setTriangle(S, 3 * Ge, d, E), S.needsUpdate = !0;
              const te = S.distanceToTriangle(R, _, L);
              if (te < W && (m.copy(_), F && F.copy(L), W = te, G = Ge, q = Fe), te < l)
                return !0;
            }
          }
        }
      }
    }
  ), ExtendedTrianglePool.releasePrimitive(S), ExtendedTrianglePool.releasePrimitive(R), W === 1 / 0 ? null : (o.point ? o.point.copy(m) : o.point = m.clone(), o.distance = W, o.faceIndex = G, a && (a.point ? a.point.copy(F) : a.point = F.clone(), a.point.applyMatrix4(tempMatrix$1), m.applyMatrix4(tempMatrix$1), a.distance = m.sub(a.point).length(), a.faceIndex = q), o);
}
function refit_indirect(r, e = null) {
  e && Array.isArray(e) && (e = new Set(e));
  const s = r.geometry, o = s.index ? s.index.array : null, a = s.attributes.position;
  let l, u, c, E, d = 0;
  const f = r._roots;
  for (let S = 0, R = f.length; S < R; S++)
    l = f[S], u = new Uint32Array(l), c = new Uint16Array(l), E = new Float32Array(l), h(0, d), d += l.byteLength;
  function h(S, R, _ = !1) {
    const m = S * 2;
    if (c[m + 15] === IS_LEAFNODE_FLAG) {
      const F = u[S + 6], W = c[m + 14];
      let G = 1 / 0, q = 1 / 0, fe = 1 / 0, _e = -1 / 0, Le = -1 / 0, Fe = -1 / 0;
      for (let Ee = F, Ge = F + W; Ee < Ge; Ee++) {
        const ve = 3 * r.resolveTriangleIndex(Ee);
        for (let te = 0; te < 3; te++) {
          let ae = ve + te;
          ae = o ? o[ae] : ae;
          const v = a.getX(ae), Te = a.getY(ae), De = a.getZ(ae);
          v < G && (G = v), v > _e && (_e = v), Te < q && (q = Te), Te > Le && (Le = Te), De < fe && (fe = De), De > Fe && (Fe = De);
        }
      }
      return E[S + 0] !== G || E[S + 1] !== q || E[S + 2] !== fe || E[S + 3] !== _e || E[S + 4] !== Le || E[S + 5] !== Fe ? (E[S + 0] = G, E[S + 1] = q, E[S + 2] = fe, E[S + 3] = _e, E[S + 4] = Le, E[S + 5] = Fe, !0) : !1;
    } else {
      const F = S + 8, W = u[S + 6], G = F + R, q = W + R;
      let fe = _, _e = !1, Le = !1;
      e ? fe || (_e = e.has(G), Le = e.has(q), fe = !_e && !Le) : (_e = !0, Le = !0);
      const Fe = fe || _e, Ee = fe || Le;
      let Ge = !1;
      Fe && (Ge = h(F, R, fe));
      let ve = !1;
      Ee && (ve = h(W, R, fe));
      const te = Ge || ve;
      if (te)
        for (let ae = 0; ae < 3; ae++) {
          const v = F + ae, Te = W + ae, De = E[v], be = E[v + 3], ze = E[Te], ke = E[Te + 3];
          E[S + ae] = De < ze ? De : ze, E[S + ae + 3] = be > ke ? be : ke;
        }
      return te;
    }
  }
}
const _boxIntersection$1 = /* @__PURE__ */ new Vector3$1();
function raycast_indirect(r, e, s, o, a) {
  BufferStack.setBuffer(r._roots[e]), _raycast(0, r, s, o, a), BufferStack.clearBuffer();
}
function _raycast(r, e, s, o, a) {
  const { float32Array: l, uint16Array: u, uint32Array: c } = BufferStack, E = r * 2;
  if (IS_LEAF(E, u)) {
    const f = OFFSET(r, c), h = COUNT(E, u);
    intersectTris_indirect(e, s, o, f, h, a);
  } else {
    const f = LEFT_NODE(r);
    intersectRay(f, l, o, _boxIntersection$1) && _raycast(f, e, s, o, a);
    const h = RIGHT_NODE(r, c);
    intersectRay(h, l, o, _boxIntersection$1) && _raycast(h, e, s, o, a);
  }
}
const _boxIntersection = /* @__PURE__ */ new Vector3$1(), _xyzFields = ["x", "y", "z"];
function raycastFirst_indirect(r, e, s, o) {
  BufferStack.setBuffer(r._roots[e]);
  const a = _raycastFirst(0, r, s, o);
  return BufferStack.clearBuffer(), a;
}
function _raycastFirst(r, e, s, o) {
  const { float32Array: a, uint16Array: l, uint32Array: u } = BufferStack;
  let c = r * 2;
  if (IS_LEAF(c, l)) {
    const d = OFFSET(r, u), f = COUNT(c, l);
    return intersectClosestTri_indirect(e, s, o, d, f);
  } else {
    const d = SPLIT_AXIS(r, u), f = _xyzFields[d], S = o.direction[f] >= 0;
    let R, _;
    S ? (R = LEFT_NODE(r), _ = RIGHT_NODE(r, u)) : (R = RIGHT_NODE(r, u), _ = LEFT_NODE(r));
    const L = intersectRay(R, a, o, _boxIntersection) ? _raycastFirst(R, e, s, o) : null;
    if (L) {
      const G = L.point[f];
      if (S ? G <= a[_ + d] : (
        // min bounding data
        G >= a[_ + d + 3]
      ))
        return L;
    }
    const W = intersectRay(_, a, o, _boxIntersection) ? _raycastFirst(_, e, s, o) : null;
    return L && W ? L.distance <= W.distance ? L : W : L || W || null;
  }
}
const boundingBox$1 = /* @__PURE__ */ new Box3$1(), triangle = /* @__PURE__ */ new ExtendedTriangle(), triangle2 = /* @__PURE__ */ new ExtendedTriangle(), invertedMat = /* @__PURE__ */ new Matrix4(), obb$2 = /* @__PURE__ */ new OrientedBox(), obb2$1 = /* @__PURE__ */ new OrientedBox();
function intersectsGeometry_indirect(r, e, s, o) {
  BufferStack.setBuffer(r._roots[e]);
  const a = _intersectsGeometry(0, r, s, o);
  return BufferStack.clearBuffer(), a;
}
function _intersectsGeometry(r, e, s, o, a = null) {
  const { float32Array: l, uint16Array: u, uint32Array: c } = BufferStack;
  let E = r * 2;
  if (a === null && (s.boundingBox || s.computeBoundingBox(), obb$2.set(s.boundingBox.min, s.boundingBox.max, o), a = obb$2), IS_LEAF(E, u)) {
    const f = e.geometry, h = f.index, S = f.attributes.position, R = s.index, _ = s.attributes.position, m = OFFSET(r, c), L = COUNT(E, u);
    if (invertedMat.copy(o).invert(), s.boundsTree)
      return arrayToBox(r, l, obb2$1), obb2$1.matrix.copy(invertedMat), obb2$1.needsUpdate = !0, s.boundsTree.shapecast({
        intersectsBounds: (W) => obb2$1.intersectsBox(W),
        intersectsTriangle: (W) => {
          W.a.applyMatrix4(o), W.b.applyMatrix4(o), W.c.applyMatrix4(o), W.needsUpdate = !0;
          for (let G = m, q = L + m; G < q; G++)
            if (setTriangle(triangle2, 3 * e.resolveTriangleIndex(G), h, S), triangle2.needsUpdate = !0, W.intersectsTriangle(triangle2))
              return !0;
          return !1;
        }
      });
    for (let F = m, W = L + m; F < W; F++) {
      const G = e.resolveTriangleIndex(F);
      setTriangle(triangle, 3 * G, h, S), triangle.a.applyMatrix4(invertedMat), triangle.b.applyMatrix4(invertedMat), triangle.c.applyMatrix4(invertedMat), triangle.needsUpdate = !0;
      for (let q = 0, fe = R.count; q < fe; q += 3)
        if (setTriangle(triangle2, q, R, _), triangle2.needsUpdate = !0, triangle.intersectsTriangle(triangle2))
          return !0;
    }
  } else {
    const f = r + 8, h = c[r + 6];
    return arrayToBox(f, l, boundingBox$1), !!(a.intersectsBox(boundingBox$1) && _intersectsGeometry(f, e, s, o, a) || (arrayToBox(h, l, boundingBox$1), a.intersectsBox(boundingBox$1) && _intersectsGeometry(h, e, s, o, a)));
  }
}
const tempMatrix = /* @__PURE__ */ new Matrix4(), obb$1 = /* @__PURE__ */ new OrientedBox(), obb2 = /* @__PURE__ */ new OrientedBox(), temp1 = /* @__PURE__ */ new Vector3$1(), temp2 = /* @__PURE__ */ new Vector3$1(), temp3 = /* @__PURE__ */ new Vector3$1(), temp4 = /* @__PURE__ */ new Vector3$1();
function closestPointToGeometry_indirect(r, e, s, o = {}, a = {}, l = 0, u = 1 / 0) {
  e.boundingBox || e.computeBoundingBox(), obb$1.set(e.boundingBox.min, e.boundingBox.max, s), obb$1.needsUpdate = !0;
  const c = r.geometry, E = c.attributes.position, d = c.index, f = e.attributes.position, h = e.index, S = ExtendedTrianglePool.getPrimitive(), R = ExtendedTrianglePool.getPrimitive();
  let _ = temp1, m = temp2, L = null, F = null;
  a && (L = temp3, F = temp4);
  let W = 1 / 0, G = null, q = null;
  return tempMatrix.copy(s).invert(), obb2.matrix.copy(tempMatrix), r.shapecast(
    {
      boundsTraverseOrder: (fe) => obb$1.distanceToBox(fe),
      intersectsBounds: (fe, _e, Le) => Le < W && Le < u ? (_e && (obb2.min.copy(fe.min), obb2.max.copy(fe.max), obb2.needsUpdate = !0), !0) : !1,
      intersectsRange: (fe, _e) => {
        if (e.boundsTree) {
          const Le = e.boundsTree;
          return Le.shapecast({
            boundsTraverseOrder: (Fe) => obb2.distanceToBox(Fe),
            intersectsBounds: (Fe, Ee, Ge) => Ge < W && Ge < u,
            intersectsRange: (Fe, Ee) => {
              for (let Ge = Fe, ve = Fe + Ee; Ge < ve; Ge++) {
                const te = Le.resolveTriangleIndex(Ge);
                setTriangle(R, 3 * te, h, f), R.a.applyMatrix4(s), R.b.applyMatrix4(s), R.c.applyMatrix4(s), R.needsUpdate = !0;
                for (let ae = fe, v = fe + _e; ae < v; ae++) {
                  const Te = r.resolveTriangleIndex(ae);
                  setTriangle(S, 3 * Te, d, E), S.needsUpdate = !0;
                  const De = S.distanceToTriangle(R, _, L);
                  if (De < W && (m.copy(_), F && F.copy(L), W = De, G = ae, q = Ge), De < l)
                    return !0;
                }
              }
            }
          });
        } else {
          const Le = getTriCount(e);
          for (let Fe = 0, Ee = Le; Fe < Ee; Fe++) {
            setTriangle(R, 3 * Fe, h, f), R.a.applyMatrix4(s), R.b.applyMatrix4(s), R.c.applyMatrix4(s), R.needsUpdate = !0;
            for (let Ge = fe, ve = fe + _e; Ge < ve; Ge++) {
              const te = r.resolveTriangleIndex(Ge);
              setTriangle(S, 3 * te, d, E), S.needsUpdate = !0;
              const ae = S.distanceToTriangle(R, _, L);
              if (ae < W && (m.copy(_), F && F.copy(L), W = ae, G = Ge, q = Fe), ae < l)
                return !0;
            }
          }
        }
      }
    }
  ), ExtendedTrianglePool.releasePrimitive(S), ExtendedTrianglePool.releasePrimitive(R), W === 1 / 0 ? null : (o.point ? o.point.copy(m) : o.point = m.clone(), o.distance = W, o.faceIndex = G, a && (a.point ? a.point.copy(F) : a.point = F.clone(), a.point.applyMatrix4(tempMatrix), m.applyMatrix4(tempMatrix), a.distance = m.sub(a.point).length(), a.faceIndex = q), o);
}
function isSharedArrayBufferSupported() {
  return typeof SharedArrayBuffer < "u";
}
const _bufferStack1 = new BufferStack.constructor(), _bufferStack2 = new BufferStack.constructor(), _boxPool = new PrimitivePool(() => new Box3$1()), _leftBox1 = new Box3$1(), _rightBox1 = new Box3$1(), _leftBox2 = new Box3$1(), _rightBox2 = new Box3$1();
let _active = !1;
function bvhcast(r, e, s, o) {
  if (_active)
    throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
  _active = !0;
  const a = r._roots, l = e._roots;
  let u, c = 0, E = 0;
  const d = new Matrix4().copy(s).invert();
  for (let f = 0, h = a.length; f < h; f++) {
    _bufferStack1.setBuffer(a[f]), E = 0;
    const S = _boxPool.getPrimitive();
    arrayToBox(0, _bufferStack1.float32Array, S), S.applyMatrix4(d);
    for (let R = 0, _ = l.length; R < _ && (_bufferStack2.setBuffer(l[f]), u = _traverse(
      0,
      0,
      s,
      d,
      o,
      c,
      E,
      0,
      0,
      S
    ), _bufferStack2.clearBuffer(), E += l[R].length, !u); R++)
      ;
    if (_boxPool.releasePrimitive(S), _bufferStack1.clearBuffer(), c += a[f].length, u)
      break;
  }
  return _active = !1, u;
}
function _traverse(r, e, s, o, a, l = 0, u = 0, c = 0, E = 0, d = null, f = !1) {
  let h, S;
  f ? (h = _bufferStack2, S = _bufferStack1) : (h = _bufferStack1, S = _bufferStack2);
  const R = h.float32Array, _ = h.uint32Array, m = h.uint16Array, L = S.float32Array, F = S.uint32Array, W = S.uint16Array, G = r * 2, q = e * 2, fe = IS_LEAF(G, m), _e = IS_LEAF(q, W);
  let Le = !1;
  if (_e && fe)
    f ? Le = a(
      OFFSET(e, F),
      COUNT(e * 2, W),
      OFFSET(r, _),
      COUNT(r * 2, m),
      E,
      u + e,
      c,
      l + r
    ) : Le = a(
      OFFSET(r, _),
      COUNT(r * 2, m),
      OFFSET(e, F),
      COUNT(e * 2, W),
      c,
      l + r,
      E,
      u + e
    );
  else if (_e) {
    const Fe = _boxPool.getPrimitive();
    arrayToBox(e, L, Fe), Fe.applyMatrix4(s);
    const Ee = LEFT_NODE(r), Ge = RIGHT_NODE(r, _);
    arrayToBox(Ee, R, _leftBox1), arrayToBox(Ge, R, _rightBox1);
    const ve = Fe.intersectsBox(_leftBox1), te = Fe.intersectsBox(_rightBox1);
    Le = ve && _traverse(
      e,
      Ee,
      o,
      s,
      a,
      u,
      l,
      E,
      c + 1,
      Fe,
      !f
    ) || te && _traverse(
      e,
      Ge,
      o,
      s,
      a,
      u,
      l,
      E,
      c + 1,
      Fe,
      !f
    ), _boxPool.releasePrimitive(Fe);
  } else {
    const Fe = LEFT_NODE(e), Ee = RIGHT_NODE(e, F);
    arrayToBox(Fe, L, _leftBox2), arrayToBox(Ee, L, _rightBox2);
    const Ge = d.intersectsBox(_leftBox2), ve = d.intersectsBox(_rightBox2);
    if (Ge && ve)
      Le = _traverse(
        r,
        Fe,
        s,
        o,
        a,
        l,
        u,
        c,
        E + 1,
        d,
        f
      ) || _traverse(
        r,
        Ee,
        s,
        o,
        a,
        l,
        u,
        c,
        E + 1,
        d,
        f
      );
    else if (Ge)
      if (fe)
        Le = _traverse(
          r,
          Fe,
          s,
          o,
          a,
          l,
          u,
          c,
          E + 1,
          d,
          f
        );
      else {
        const te = _boxPool.getPrimitive();
        te.copy(_leftBox2).applyMatrix4(s);
        const ae = LEFT_NODE(r), v = RIGHT_NODE(r, _);
        arrayToBox(ae, R, _leftBox1), arrayToBox(v, R, _rightBox1);
        const Te = te.intersectsBox(_leftBox1), De = te.intersectsBox(_rightBox1);
        Le = Te && _traverse(
          Fe,
          ae,
          o,
          s,
          a,
          u,
          l,
          E,
          c + 1,
          te,
          !f
        ) || De && _traverse(
          Fe,
          v,
          o,
          s,
          a,
          u,
          l,
          E,
          c + 1,
          te,
          !f
        ), _boxPool.releasePrimitive(te);
      }
    else if (ve)
      if (fe)
        Le = _traverse(
          r,
          Ee,
          s,
          o,
          a,
          l,
          u,
          c,
          E + 1,
          d,
          f
        );
      else {
        const te = _boxPool.getPrimitive();
        te.copy(_rightBox2).applyMatrix4(s);
        const ae = LEFT_NODE(r), v = RIGHT_NODE(r, _);
        arrayToBox(ae, R, _leftBox1), arrayToBox(v, R, _rightBox1);
        const Te = te.intersectsBox(_leftBox1), De = te.intersectsBox(_rightBox1);
        Le = Te && _traverse(
          Ee,
          ae,
          o,
          s,
          a,
          u,
          l,
          E,
          c + 1,
          te,
          !f
        ) || De && _traverse(
          Ee,
          v,
          o,
          s,
          a,
          u,
          l,
          E,
          c + 1,
          te,
          !f
        ), _boxPool.releasePrimitive(te);
      }
  }
  return Le;
}
const obb = /* @__PURE__ */ new OrientedBox(), tempBox = /* @__PURE__ */ new Box3$1();
class MeshBVH {
  static serialize(e, s = {}) {
    s = {
      cloneBuffers: !0,
      ...s
    };
    const o = e.geometry, a = e._roots, l = e._indirectBuffer, u = o.getIndex();
    let c;
    return s.cloneBuffers ? c = {
      roots: a.map((E) => E.slice()),
      index: u.array.slice(),
      indirectBuffer: l ? l.slice() : null
    } : c = {
      roots: a,
      index: u.array,
      indirectBuffer: l
    }, c;
  }
  static deserialize(e, s, o = {}) {
    o = {
      setIndex: !0,
      indirect: !!e.indirectBuffer,
      ...o
    };
    const { index: a, roots: l, indirectBuffer: u } = e, c = new MeshBVH(s, { ...o, [SKIP_GENERATION]: !0 });
    if (c._roots = l, c._indirectBuffer = u || null, o.setIndex) {
      const E = s.getIndex();
      if (E === null) {
        const d = new BufferAttribute(e.index, 1, !1);
        s.setIndex(d);
      } else
        E.array !== a && (E.array.set(a), E.needsUpdate = !0);
    }
    return c;
  }
  get indirect() {
    return !!this._indirectBuffer;
  }
  constructor(e, s = {}) {
    if (e.isBufferGeometry) {
      if (e.index && e.index.isInterleavedBufferAttribute)
        throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
    } else
      throw new Error("MeshBVH: Only BufferGeometries are supported.");
    if (s = Object.assign({
      strategy: CENTER,
      maxDepth: 40,
      maxLeafTris: 10,
      verbose: !0,
      useSharedArrayBuffer: !1,
      setBoundingBox: !0,
      onProgress: null,
      indirect: !1,
      // undocumented options
      // Whether to skip generating the tree. Used for deserialization.
      [SKIP_GENERATION]: !1
    }, s), s.useSharedArrayBuffer && !isSharedArrayBufferSupported())
      throw new Error("MeshBVH: SharedArrayBuffer is not available.");
    this.geometry = e, this._roots = null, this._indirectBuffer = null, s[SKIP_GENERATION] || (buildPackedTree(this, s), !e.boundingBox && s.setBoundingBox && (e.boundingBox = this.getBoundingBox(new Box3$1())));
    const { _indirectBuffer: o } = this;
    this.resolveTriangleIndex = s.indirect ? (a) => o[a] : (a) => a;
  }
  refit(e = null) {
    return (this.indirect ? refit_indirect : refit)(this, e);
  }
  traverse(e, s = 0) {
    const o = this._roots[s], a = new Uint32Array(o), l = new Uint16Array(o);
    u(0);
    function u(c, E = 0) {
      const d = c * 2, f = l[d + 15] === IS_LEAFNODE_FLAG;
      if (f) {
        const h = a[c + 6], S = l[d + 14];
        e(E, f, new Float32Array(o, c * 4, 6), h, S);
      } else {
        const h = c + BYTES_PER_NODE / 4, S = a[c + 6], R = a[c + 7];
        e(E, f, new Float32Array(o, c * 4, 6), R) || (u(h, E + 1), u(S, E + 1));
      }
    }
  }
  /* Core Cast Functions */
  raycast(e, s = FrontSide) {
    const o = this._roots, a = this.geometry, l = [], u = s.isMaterial, c = Array.isArray(s), E = a.groups, d = u ? s.side : s, f = this.indirect ? raycast_indirect : raycast;
    for (let h = 0, S = o.length; h < S; h++) {
      const R = c ? s[E[h].materialIndex].side : d, _ = l.length;
      if (f(this, h, R, e, l), c) {
        const m = E[h].materialIndex;
        for (let L = _, F = l.length; L < F; L++)
          l[L].face.materialIndex = m;
      }
    }
    return l;
  }
  raycastFirst(e, s = FrontSide) {
    const o = this._roots, a = this.geometry, l = s.isMaterial, u = Array.isArray(s);
    let c = null;
    const E = a.groups, d = l ? s.side : s, f = this.indirect ? raycastFirst_indirect : raycastFirst;
    for (let h = 0, S = o.length; h < S; h++) {
      const R = u ? s[E[h].materialIndex].side : d, _ = f(this, h, R, e);
      _ != null && (c == null || _.distance < c.distance) && (c = _, u && (_.face.materialIndex = E[h].materialIndex));
    }
    return c;
  }
  intersectsGeometry(e, s) {
    let o = !1;
    const a = this._roots, l = this.indirect ? intersectsGeometry_indirect : intersectsGeometry;
    for (let u = 0, c = a.length; u < c && (o = l(this, u, e, s), !o); u++)
      ;
    return o;
  }
  shapecast(e) {
    const s = ExtendedTrianglePool.getPrimitive(), o = this.indirect ? iterateOverTriangles_indirect : iterateOverTriangles;
    let {
      boundsTraverseOrder: a,
      intersectsBounds: l,
      intersectsRange: u,
      intersectsTriangle: c
    } = e;
    if (u && c) {
      const h = u;
      u = (S, R, _, m, L) => h(S, R, _, m, L) ? !0 : o(S, R, this, c, _, m, s);
    } else
      u || (c ? u = (h, S, R, _) => o(h, S, this, c, R, _, s) : u = (h, S, R) => R);
    let E = !1, d = 0;
    const f = this._roots;
    for (let h = 0, S = f.length; h < S; h++) {
      const R = f[h];
      if (E = shapecast(this, h, l, u, a, d), E)
        break;
      d += R.byteLength;
    }
    return ExtendedTrianglePool.releasePrimitive(s), E;
  }
  bvhcast(e, s, o) {
    let {
      intersectsRanges: a,
      intersectsTriangles: l
    } = o;
    const u = ExtendedTrianglePool.getPrimitive(), c = this.geometry.index, E = this.geometry.attributes.position, d = this.indirect ? (_) => {
      const m = this.resolveTriangleIndex(_);
      setTriangle(u, m * 3, c, E);
    } : (_) => {
      setTriangle(u, _ * 3, c, E);
    }, f = ExtendedTrianglePool.getPrimitive(), h = e.geometry.index, S = e.geometry.attributes.position, R = e.indirect ? (_) => {
      const m = e.resolveTriangleIndex(_);
      setTriangle(f, m * 3, h, S);
    } : (_) => {
      setTriangle(f, _ * 3, h, S);
    };
    if (l) {
      const _ = (m, L, F, W, G, q, fe, _e) => {
        for (let Le = F, Fe = F + W; Le < Fe; Le++) {
          R(Le), f.a.applyMatrix4(s), f.b.applyMatrix4(s), f.c.applyMatrix4(s), f.needsUpdate = !0;
          for (let Ee = m, Ge = m + L; Ee < Ge; Ee++)
            if (d(Ee), u.needsUpdate = !0, l(u, f, Ee, Le, G, q, fe, _e))
              return !0;
        }
        return !1;
      };
      if (a) {
        const m = a;
        a = function(L, F, W, G, q, fe, _e, Le) {
          return m(L, F, W, G, q, fe, _e, Le) ? !0 : _(L, F, W, G, q, fe, _e, Le);
        };
      } else
        a = _;
    }
    return bvhcast(this, e, s, a);
  }
  /* Derived Cast Functions */
  intersectsBox(e, s) {
    return obb.set(e.min, e.max, s), obb.needsUpdate = !0, this.shapecast(
      {
        intersectsBounds: (o) => obb.intersectsBox(o),
        intersectsTriangle: (o) => obb.intersectsTriangle(o)
      }
    );
  }
  intersectsSphere(e) {
    return this.shapecast(
      {
        intersectsBounds: (s) => e.intersectsBox(s),
        intersectsTriangle: (s) => s.intersectsSphere(e)
      }
    );
  }
  closestPointToGeometry(e, s, o = {}, a = {}, l = 0, u = 1 / 0) {
    return (this.indirect ? closestPointToGeometry_indirect : closestPointToGeometry)(
      this,
      e,
      s,
      o,
      a,
      l,
      u
    );
  }
  closestPointToPoint(e, s = {}, o = 0, a = 1 / 0) {
    return closestPointToPoint(
      this,
      e,
      s,
      o,
      a
    );
  }
  getBoundingBox(e) {
    return e.makeEmpty(), this._roots.forEach((o) => {
      arrayToBox(0, new Float32Array(o), tempBox), e.union(tempBox);
    }), e;
  }
}
function convertRaycastIntersect(r, e, s) {
  return r === null || (r.point.applyMatrix4(e.matrixWorld), r.distance = r.point.distanceTo(s.ray.origin), r.object = e, r.distance < s.near || r.distance > s.far) ? null : r;
}
const ray = /* @__PURE__ */ new Ray(), tmpInverseMatrix = /* @__PURE__ */ new Matrix4(), origMeshRaycastFunc = Mesh.prototype.raycast;
function acceleratedRaycast(r, e) {
  if (this.geometry.boundsTree) {
    if (this.material === void 0)
      return;
    tmpInverseMatrix.copy(this.matrixWorld).invert(), ray.copy(r.ray).applyMatrix4(tmpInverseMatrix);
    const s = this.geometry.boundsTree;
    if (r.firstHitOnly === !0) {
      const o = convertRaycastIntersect(s.raycastFirst(ray, this.material), this, r);
      o && e.push(o);
    } else {
      const o = s.raycast(ray, this.material);
      for (let a = 0, l = o.length; a < l; a++) {
        const u = convertRaycastIntersect(o[a], this, r);
        u && e.push(u);
      }
    }
  } else
    origMeshRaycastFunc.call(this, r, e);
}
function computeBoundsTree(r) {
  return this.boundsTree = new MeshBVH(this, r), this.boundsTree;
}
function disposeBoundsTree() {
  this.boundsTree = null;
}
var __awaiter$P = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
const _object_pattern = /^[og]\s*(.+)?/, _material_library_pattern = /^mtllib /, _material_use_pattern = /^usemtl /, _map_use_pattern = /^usemap /, _face_vertex_data_separator_pattern = /\s+/, _vA = new Vector3$1(), _vB = new Vector3$1(), _vC = new Vector3$1(), _ab = new Vector3$1(), _cb = new Vector3$1(), _color = new Color();
function ParserState() {
  const r = {
    objects: [],
    object: {},
    vertices: [],
    normals: [],
    colors: [],
    uvs: [],
    materials: {},
    materialLibraries: [],
    startObject: function(e, s) {
      if (this.object && this.object.fromDeclaration === !1) {
        this.object.name = e, this.object.fromDeclaration = s !== !1;
        return;
      }
      const o = this.object && typeof this.object.currentMaterial == "function" ? this.object.currentMaterial() : void 0;
      if (this.object && typeof this.object._finalize == "function" && this.object._finalize(!0), this.object = {
        name: e || "",
        fromDeclaration: s !== !1,
        geometry: {
          vertices: [],
          normals: [],
          colors: [],
          uvs: [],
          hasUVIndices: !1
        },
        materials: [],
        smooth: !0,
        startMaterial: function(a, l) {
          const u = this._finalize(!1);
          u && (u.inherited || u.groupCount <= 0) && this.materials.splice(u.index, 1);
          const c = {
            index: this.materials.length,
            name: a || "",
            mtllib: Array.isArray(l) && l.length > 0 ? l[l.length - 1] : "",
            smooth: u !== void 0 ? u.smooth : this.smooth,
            groupStart: u !== void 0 ? u.groupEnd : 0,
            groupEnd: -1,
            groupCount: -1,
            inherited: !1,
            clone: function(E) {
              const d = {
                index: typeof E == "number" ? E : this.index,
                name: this.name,
                mtllib: this.mtllib,
                smooth: this.smooth,
                groupStart: 0,
                groupEnd: -1,
                groupCount: -1,
                inherited: !1
              };
              return d.clone = this.clone.bind(d), d;
            }
          };
          return this.materials.push(c), c;
        },
        currentMaterial: function() {
          if (this.materials.length > 0)
            return this.materials[this.materials.length - 1];
        },
        _finalize: function(a) {
          const l = this.currentMaterial();
          if (l && l.groupEnd === -1 && (l.groupEnd = this.geometry.vertices.length / 3, l.groupCount = l.groupEnd - l.groupStart, l.inherited = !1), a && this.materials.length > 1)
            for (let u = this.materials.length - 1; u >= 0; u--)
              this.materials[u].groupCount <= 0 && this.materials.splice(u, 1);
          return a && this.materials.length === 0 && this.materials.push({
            name: "",
            smooth: this.smooth
          }), l;
        }
      }, o && o.name && typeof o.clone == "function") {
        const a = o.clone(0);
        a.inherited = !0, this.object.materials.push(a);
      }
      this.objects.push(this.object);
    },
    finalize: function() {
      this.object && typeof this.object._finalize == "function" && this.object._finalize(!0);
    },
    parseVertexIndex: function(e, s) {
      const o = parseInt(e, 10);
      return (o >= 0 ? o - 1 : o + s / 3) * 3;
    },
    parseNormalIndex: function(e, s) {
      const o = parseInt(e, 10);
      return (o >= 0 ? o - 1 : o + s / 3) * 3;
    },
    parseUVIndex: function(e, s) {
      const o = parseInt(e, 10);
      return (o >= 0 ? o - 1 : o + s / 2) * 2;
    },
    addVertex: function(e, s, o) {
      const a = this.vertices, l = this.object.geometry.vertices;
      l.push(a[e + 0], a[e + 1], a[e + 2]), l.push(a[s + 0], a[s + 1], a[s + 2]), l.push(a[o + 0], a[o + 1], a[o + 2]);
    },
    addVertexPoint: function(e) {
      const s = this.vertices;
      this.object.geometry.vertices.push(s[e + 0], s[e + 1], s[e + 2]);
    },
    addVertexLine: function(e) {
      const s = this.vertices;
      this.object.geometry.vertices.push(s[e + 0], s[e + 1], s[e + 2]);
    },
    addNormal: function(e, s, o) {
      const a = this.normals, l = this.object.geometry.normals;
      l.push(a[e + 0], a[e + 1], a[e + 2]), l.push(a[s + 0], a[s + 1], a[s + 2]), l.push(a[o + 0], a[o + 1], a[o + 2]);
    },
    addFaceNormal: function(e, s, o) {
      const a = this.vertices, l = this.object.geometry.normals;
      _vA.fromArray(a, e), _vB.fromArray(a, s), _vC.fromArray(a, o), _cb.subVectors(_vC, _vB), _ab.subVectors(_vA, _vB), _cb.cross(_ab), _cb.normalize(), l.push(_cb.x, _cb.y, _cb.z), l.push(_cb.x, _cb.y, _cb.z), l.push(_cb.x, _cb.y, _cb.z);
    },
    addColor: function(e, s, o) {
      const a = this.colors, l = this.object.geometry.colors;
      a[e] !== void 0 && l.push(a[e + 0], a[e + 1], a[e + 2]), a[s] !== void 0 && l.push(a[s + 0], a[s + 1], a[s + 2]), a[o] !== void 0 && l.push(a[o + 0], a[o + 1], a[o + 2]);
    },
    addUV: function(e, s, o) {
      const a = this.uvs, l = this.object.geometry.uvs;
      l.push(a[e + 0], a[e + 1]), l.push(a[s + 0], a[s + 1]), l.push(a[o + 0], a[o + 1]);
    },
    addDefaultUV: function() {
      const e = this.object.geometry.uvs;
      e.push(0, 0), e.push(0, 0), e.push(0, 0);
    },
    addUVLine: function(e) {
      const s = this.uvs;
      this.object.geometry.uvs.push(s[e + 0], s[e + 1]);
    },
    addFace: function(e, s, o, a, l, u, c, E, d) {
      const f = this.vertices.length;
      let h = this.parseVertexIndex(e, f), S = this.parseVertexIndex(s, f), R = this.parseVertexIndex(o, f);
      if (this.addVertex(h, S, R), this.addColor(h, S, R), c !== void 0 && c !== "") {
        const _ = this.normals.length;
        h = this.parseNormalIndex(c, _), S = this.parseNormalIndex(E, _), R = this.parseNormalIndex(d, _), this.addNormal(h, S, R);
      } else
        this.addFaceNormal(h, S, R);
      if (a !== void 0 && a !== "") {
        const _ = this.uvs.length;
        h = this.parseUVIndex(a, _), S = this.parseUVIndex(l, _), R = this.parseUVIndex(u, _), this.addUV(h, S, R), this.object.geometry.hasUVIndices = !0;
      } else
        this.addDefaultUV();
    },
    addPointGeometry: function(e) {
      this.object.geometry.type = "Points";
      const s = this.vertices.length;
      for (let o = 0, a = e.length; o < a; o++) {
        const l = this.parseVertexIndex(e[o], s);
        this.addVertexPoint(l), this.addColor(l);
      }
    },
    addLineGeometry: function(e, s) {
      this.object.geometry.type = "Line";
      const o = this.vertices.length, a = this.uvs.length;
      for (let l = 0, u = e.length; l < u; l++)
        this.addVertexLine(this.parseVertexIndex(e[l], o));
      for (let l = 0, u = s.length; l < u; l++)
        this.addUVLine(this.parseUVIndex(s[l], a));
    }
  };
  return r.startObject("", !1), r;
}
class OBJLoader extends Loader {
  constructor(e) {
    super(e), this.materials = null;
  }
  load(e, s, o, a) {
    const l = this, u = new FileLoader$1(this.manager);
    u.setPath(this.path), u.setRequestHeader(this.requestHeader), u.setWithCredentials(this.withCredentials), u.load(e, function(c) {
      try {
        s(l.parse(c));
      } catch (E) {
        a ? a(E) : console.error(E), l.manager.itemError(e);
      }
    }, o, a);
  }
  setMaterials(e) {
    return this.materials = e, this;
  }
  parse(e) {
    return __awaiter$P(this, void 0, void 0, function* () {
      const s = new ParserState();
      e.indexOf(`\r
`) !== -1 && (e = e.replace(/\r\n/g, `
`)), e.indexOf(`\\
`) !== -1 && (e = e.replace(/\\\n/g, ""));
      const o = e.split(`
`);
      let a = [];
      for (let c = 0, E = o.length; c < E; c++) {
        const d = o[c].trimStart();
        if (d.length === 0)
          continue;
        const f = d.charAt(0);
        if (f !== "#")
          if (f === "v") {
            const h = d.split(_face_vertex_data_separator_pattern);
            switch (h[0]) {
              case "v":
                s.vertices.push(parseFloat(h[1]), parseFloat(h[2]), parseFloat(h[3])), h.length >= 7 ? (_color.setRGB(parseFloat(h[4]), parseFloat(h[5]), parseFloat(h[6])).convertSRGBToLinear(), s.colors.push(_color.r, _color.g, _color.b)) : s.colors.push(void 0, void 0, void 0);
                break;
              case "vn":
                s.normals.push(parseFloat(h[1]), parseFloat(h[2]), parseFloat(h[3]));
                break;
              case "vt":
                s.uvs.push(parseFloat(h[1]), parseFloat(h[2]));
                break;
            }
          } else if (f === "f") {
            const S = d.slice(1).trim().split(_face_vertex_data_separator_pattern), R = [];
            for (let m = 0, L = S.length; m < L; m++) {
              const F = S[m];
              if (F.length > 0) {
                const W = F.split("/");
                R.push(W);
              }
            }
            const _ = R[0];
            for (let m = 1, L = R.length - 1; m < L; m++) {
              const F = R[m], W = R[m + 1];
              s.addFace(_[0], F[0], W[0], _[1], F[1], W[1], _[2], F[2], W[2]);
            }
          } else if (f === "l") {
            const h = d.substring(1).trim().split(" ");
            let S = [];
            const R = [];
            if (d.indexOf("/") === -1)
              S = h;
            else
              for (let _ = 0, m = h.length; _ < m; _++) {
                const L = h[_].split("/");
                L[0] !== "" && S.push(L[0]), L[1] !== "" && R.push(L[1]);
              }
            s.addLineGeometry(S, R);
          } else if (f === "p") {
            const S = d.slice(1).trim().split(" ");
            s.addPointGeometry(S);
          } else if ((a = _object_pattern.exec(d)) !== null) {
            const h = (" " + a[0].slice(1).trim()).slice(1);
            s.startObject(h);
          } else if (_material_use_pattern.test(d))
            s.object.startMaterial(d.substring(7).trim(), s.materialLibraries);
          else if (_material_library_pattern.test(d))
            s.materialLibraries.push(d.substring(7).trim());
          else if (_map_use_pattern.test(d))
            console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
          else if (f === "s") {
            if (a = d.split(" "), a.length > 1) {
              const S = a[1].trim().toLowerCase();
              s.object.smooth = S !== "0" && S !== "off";
            } else
              s.object.smooth = !0;
            const h = s.object.currentMaterial();
            h && (h.smooth = s.object.smooth);
          } else {
            if (d === "\0")
              continue;
            console.warn('THREE.OBJLoader: Unexpected line: "' + d + '"');
          }
      }
      s.finalize();
      const l = new Group();
      if (l.materialLibraries = [].concat(s.materialLibraries), !(s.objects.length === 1 && s.objects[0].geometry.vertices.length === 0) === !0) {
        const c = new Vector3$1(0, 0, 0);
        let E = 0;
        for (let d = 0, f = s.objects.length; d < f; d++) {
          const S = s.objects[d].geometry;
          for (let R = 0; R < S.vertices.length; R += 3)
            c.x += S.vertices[R], c.y += S.vertices[R + 1], c.z += S.vertices[R + 2], E++;
        }
        c.divideScalar(E), l.position.set(c.x, c.y, c.z);
        for (let d = 0, f = s.objects.length; d < f; d++) {
          const h = s.objects[d], S = h.geometry, R = h.materials, _ = S.type === "Line", m = S.type === "Points";
          let L = !1;
          if (S.vertices.length === 0)
            continue;
          const F = new BufferGeometry();
          for (let q = 0; q < S.vertices.length; q += 3)
            S.vertices[q] -= c.x, S.vertices[q + 1] -= c.y, S.vertices[q + 2] -= c.z;
          F.setAttribute("position", new Float32BufferAttribute(S.vertices, 3)), S.normals.length > 0 && F.setAttribute("normal", new Float32BufferAttribute(S.normals, 3)), S.colors.length > 0 && (L = !0, F.setAttribute("color", new Float32BufferAttribute(S.colors, 3))), S.hasUVIndices === !0 && F.setAttribute("uv", new Float32BufferAttribute(S.uvs, 2));
          const W = [];
          for (let q = 0, fe = R.length; q < fe; q++) {
            const _e = R[q], Le = _e.name + "_" + _e.smooth + "_" + L;
            let Fe = s.materials[Le];
            if (this.materials !== null) {
              if (Fe = yield this.materials.create(_e.name), _ && Fe && !(Fe instanceof LineBasicMaterial)) {
                const Ee = new PickingLineBasicMaterial();
                Material.prototype.copy.call(Ee, Fe), Ee.color.copy(Fe.color), Fe = Ee;
              } else if (m && Fe && !(Fe instanceof PointsMaterial)) {
                const Ee = new PickingPointsMaterial({ size: 10, sizeAttenuation: !1 });
                Material.prototype.copy.call(Ee, Fe), Ee.color.copy(Fe.color), Ee.map = Fe.map, Fe = Ee;
              }
            }
            Fe === void 0 && (_ ? Fe = new PickingLineBasicMaterial() : m ? Fe = new PickingPointsMaterial({ size: 1, sizeAttenuation: !1 }) : Fe = new PickingMeshPhongMaterial(), Fe.name = _e.name, Fe.flatShading = !_e.smooth, Fe.vertexColors = L, s.materials[Le] = Fe), W.push(Fe);
          }
          let G;
          if (W.length > 1) {
            for (let q = 0, fe = R.length; q < fe; q++) {
              const _e = R[q];
              F.addGroup(_e.groupStart, _e.groupCount, q);
            }
            _ ? G = new LineSegments(F, W) : m ? G = new Points(F, W) : (F.computeBoundsTree(), G = new Mesh(F, W));
          } else
            _ ? G = new LineSegments(F, W[0]) : m ? G = new Points(F, W[0]) : (F.computeBoundsTree(), G = new Mesh(F, W[0]));
          G.name = h.name, l.add(G);
        }
      } else {
        const c = new Vector3$1(0, 0, 0);
        let E = 0;
        for (let d = 0, f = s.vertices.length; d < f; d++)
          for (let h = 0; h < s.vertices.length; h += 3)
            c.x += s.vertices[h], c.y += s.vertices[h + 1], c.z += s.vertices[h + 2], E++;
        c.divideScalar(E), l.position.set(c.x, c.y, c.z);
        for (let d = 0; d < s.vertices.length; d += 3)
          s.vertices[d] -= c.x, s.vertices[d + 1] -= c.y, s.vertices[d + 2] -= c.z;
        if (s.vertices.length > 0) {
          const d = new PickingPointsMaterial({ size: 1, sizeAttenuation: !1 }), f = new BufferGeometry();
          f.setAttribute("position", new Float32BufferAttribute(s.vertices, 3)), s.colors.length > 0 && s.colors[0] !== void 0 && (f.setAttribute("color", new Float32BufferAttribute(s.colors, 3)), d.vertexColors = !0);
          const h = new Points(f, d);
          l.add(h);
        }
      }
      return l;
    });
  }
}
var __awaiter$O = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class MTLLoader extends Loader {
  constructor(e) {
    super(e);
  }
  /**
   * Loads and parses a MTL asset from a URL.
   *
   * @param {String} url - URL to the MTL file.
   * @param {Function} [onLoad] - Callback invoked with the loaded object.
   * @param {Function} [onProgress] - Callback for download progress.
   * @param {Function} [onError] - Callback for download errors.
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to load.
   */
  load(e, s, o, a) {
    const l = this, u = this.path === "" ? LoaderUtils.extractUrlBase(e) : this.path, c = new FileLoader$1(this.manager);
    c.setPath(this.path), c.setRequestHeader(this.requestHeader), c.setWithCredentials(this.withCredentials), c.load(e, function(E) {
      try {
        s(l.parse(E, u));
      } catch (d) {
        a ? a(d) : console.error(d), l.manager.itemError(e);
      }
    }, o, a);
  }
  setMaterialOptions(e) {
    return this.materialOptions = e, this;
  }
  /**
   * Parses a MTL file.
   *
   * @param {String} text - Content of MTL file
   * @return {MaterialCreator}
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to parse.
   */
  parse(e, s) {
    const o = e.split(`
`);
    let a = {};
    const l = /\s+/, u = {};
    for (let E = 0; E < o.length; E++) {
      let d = o[E];
      if (d = d.trim(), d.length === 0 || d.charAt(0) === "#")
        continue;
      const f = d.indexOf(" ");
      let h = f >= 0 ? d.substring(0, f) : d;
      h = h.toLowerCase();
      let S = f >= 0 ? d.substring(f + 1) : "";
      if (S = S.trim(), h === "newmtl")
        a = { name: S }, u[S] = a;
      else if (h === "ka" || h === "kd" || h === "ks" || h === "ke") {
        const R = S.split(l, 3);
        a[h] = [parseFloat(R[0]), parseFloat(R[1]), parseFloat(R[2])];
      } else
        a[h] = S;
    }
    const c = new MaterialCreator(this.resourcePath || s, this.materialOptions);
    return c.setCrossOrigin(this.crossOrigin), c.setManager(this.manager), c.setMaterials(u), c;
  }
}
class MaterialCreator {
  constructor(e = "", s = {}) {
    this.baseUrl = e, this.options = s, this.materialsInfo = {}, this.materials = {}, this.materialsArray = [], this.nameLookup = {}, this.crossOrigin = "anonymous", this.side = this.options.side !== void 0 ? this.options.side : FrontSide, this.wrap = this.options.wrap !== void 0 ? this.options.wrap : RepeatWrapping;
  }
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  setManager(e) {
    this.manager = e;
  }
  setMaterials(e) {
    this.materialsInfo = this.convert(e), this.materials = {}, this.materialsArray = [], this.nameLookup = {};
  }
  convert(e) {
    if (!this.options)
      return e;
    const s = {};
    for (const o in e) {
      const a = e[o], l = {};
      s[o] = l;
      for (const u in a) {
        let c = !0, E = a[u];
        const d = u.toLowerCase();
        switch (d) {
          case "kd":
          case "ka":
          case "ks":
            this.options && this.options.normalizeRGB && (E = [E[0] / 255, E[1] / 255, E[2] / 255]), this.options && this.options.ignoreZeroRGBs && E[0] === 0 && E[1] === 0 && E[2] === 0 && (c = !1);
            break;
        }
        c && (l[d] = E);
      }
    }
    return s;
  }
  preload() {
    return __awaiter$O(this, void 0, void 0, function* () {
      for (const e in this.materialsInfo)
        yield this.create(e);
    });
  }
  getIndex(e) {
    return this.nameLookup[e];
  }
  getAsArray() {
    return __awaiter$O(this, void 0, void 0, function* () {
      let e = 0;
      for (const s in this.materialsInfo)
        this.materialsArray[e] = yield this.create(s), this.nameLookup[s] = e, e++;
      return this.materialsArray;
    });
  }
  create(e) {
    return __awaiter$O(this, void 0, void 0, function* () {
      return this.materials[e] === void 0 && (yield this.createMaterial_(e)), this.materials[e];
    });
  }
  createMaterial_(e) {
    return __awaiter$O(this, void 0, void 0, function* () {
      const s = this, o = this.materialsInfo[e], a = {
        name: e,
        side: this.side,
        objectId: this.options.objectId,
        clippingPlanes: this.options.clippingPlanes
      };
      function l(c, E) {
        return typeof E != "string" || E === "" ? "" : /^https?:\/\//i.test(E) ? E : c + E;
      }
      function u(c, E) {
        return __awaiter$O(this, void 0, void 0, function* () {
          if (a[c])
            return;
          const d = s.getTextureParams(E, a), f = yield s.loadTexture(l(s.baseUrl, d.url));
          f.repeat.copy(d.scale), f.offset.copy(d.offset), f.wrapS = s.wrap, f.wrapT = s.wrap, (c === "map" || c === "emissiveMap") && (f.colorSpace = SRGBColorSpace), a[c] = f;
        });
      }
      for (const c in o) {
        const E = o[c];
        let d;
        if (E !== "")
          switch (c.toLowerCase()) {
            case "kd":
              a.color = new Color().fromArray(E).convertSRGBToLinear();
              break;
            case "ks":
              a.specular = new Color().fromArray(E).convertSRGBToLinear();
              break;
            case "ke":
              a.emissive = new Color().fromArray(E).convertSRGBToLinear();
              break;
            case "map_kd":
              yield u("map", E);
              break;
            case "map_ks":
              yield u("specularMap", E);
              break;
            case "map_ke":
              yield u("emissiveMap", E);
              break;
            case "norm":
              yield u("normalMap", E);
              break;
            case "map_bump":
            case "bump":
              yield u("bumpMap", E);
              break;
            case "map_d":
              yield u("alphaMap", E), a.transparent = !0;
              break;
            case "ns":
              a.shininess = parseFloat(E);
              break;
            case "d":
              d = parseFloat(E), d < 1 && (a.opacity = d, a.transparent = !0);
              break;
            case "tr":
              d = parseFloat(E), this.options && this.options.invertTrProperty && (d = 1 - d), d > 0 && (a.opacity = 1 - d, a.transparent = !0);
              break;
          }
      }
      return this.materials[e] = new PickingMeshPhongMaterial(a), this.materials[e];
    });
  }
  getTextureParams(e, s) {
    const o = {
      scale: new Vector2(1, 1),
      offset: new Vector2(0, 0)
    }, a = e.split(/\s+/);
    let l;
    return l = a.indexOf("-bm"), l >= 0 && (s.bumpScale = parseFloat(a[l + 1]), a.splice(l, 2)), l = a.indexOf("-s"), l >= 0 && (o.scale.set(parseFloat(a[l + 1]), parseFloat(a[l + 2])), a.splice(l, 4)), l = a.indexOf("-o"), l >= 0 && (o.offset.set(parseFloat(a[l + 1]), parseFloat(a[l + 2])), a.splice(l, 4)), o.url = a.join(" ").trim(), o;
  }
  loadTexture(e, s, o, a, l) {
    return __awaiter$O(this, void 0, void 0, function* () {
      const c = yield (yield fetch(e)).blob(), E = yield createImageBitmap(c, {
        imageOrientation: "flipY"
      }), d = new Texture(E);
      return d.minFilter = LinearFilter, d.magFilter = LinearFilter, d.generateMipmaps = !1, d.needsUpdate = !0, s !== void 0 && (d.mapping = s), d;
    });
  }
}
var __awaiter$N = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class ObjLoader {
  static load(e, s) {
    return __awaiter$N(this, void 0, void 0, function* () {
      const o = `${e}/../`;
      let a;
      try {
        const c = e.replace(ObjLoader.REPLACE_REGEX, ".mtl"), E = yield FileLoader.loadText(c, { headers: s == null ? void 0 : s.headers });
        ObjLoader.MTL_LOADER.setResourcePath(o), ObjLoader.MTL_LOADER.setMaterialOptions({
          objectId: (s == null ? void 0 : s.objectId) || 0,
          clippingPlanes: s == null ? void 0 : s.clippingPlanes
        }), a = ObjLoader.MTL_LOADER.parse(E, `${c}/../`);
      } catch {
        a = null;
      }
      const l = yield FileLoader.loadText(e, {
        headers: s == null ? void 0 : s.headers,
        cacheKey: s == null ? void 0 : s.cacheKey,
        cache: !0
      });
      ObjLoader.OBJ_LOADER.setMaterials(a);
      const u = new Group();
      return u.add(yield ObjLoader.OBJ_LOADER.parse(l)), u;
    });
  }
}
ObjLoader.OBJ_LOADER = new OBJLoader();
ObjLoader.MTL_LOADER = new MTLLoader();
ObjLoader.REPLACE_REGEX = new RegExp(".obj$");
var KMLElementType;
(function(r) {
  r[r.Virtual = 0] = "Virtual", r[r.Placemark = 1] = "Placemark", r[r.Document = 2] = "Document", r[r.Folder = 3] = "Folder", r[r.Point = 4] = "Point", r[r.LineString = 5] = "LineString", r[r.LinearRing = 6] = "LinearRing", r[r.Polygon = 7] = "Polygon", r[r.MultiGeometry = 8] = "MultiGeometry", r[r.Style = 9] = "Style", r[r.StyleMap = 10] = "StyleMap", r[r.LineStyle = 11] = "LineStyle", r[r.PolyStyle = 12] = "PolyStyle", r[r.IconStyle = 13] = "IconStyle", r[r.LabelStyle = 14] = "LabelStyle", r[r.BalloonStyle = 15] = "BalloonStyle", r[r.ListStyle = 16] = "ListStyle";
})(KMLElementType || (KMLElementType = {}));
var AltitudeMode;
(function(r) {
  r[r.ClampToGround = 0] = "ClampToGround", r[r.RelativeToGround = 1] = "RelativeToGround", r[r.Absolute = 2] = "Absolute";
})(AltitudeMode || (AltitudeMode = {}));
var StyleState;
(function(r) {
  r[r.Normal = 0] = "Normal", r[r.Highlight = 1] = "Highlight";
})(StyleState || (StyleState = {}));
var ColorMode;
(function(r) {
  r[r.Normal = 0] = "Normal", r[r.Random = 1] = "Random";
})(ColorMode || (ColorMode = {}));
var DisplayMode;
(function(r) {
  r[r.Default = 0] = "Default", r[r.Hide = 1] = "Hide";
})(DisplayMode || (DisplayMode = {}));
var ListItemType;
(function(r) {
  r[r.Check = 0] = "Check", r[r.CheckOffOnly = 1] = "CheckOffOnly", r[r.CheckHideChildren = 2] = "CheckHideChildren", r[r.RadioFolder = 3] = "RadioFolder";
})(ListItemType || (ListItemType = {}));
var IconState;
(function(r) {
  r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r[r.Error = 2] = "Error", r[r.Fetching0 = 3] = "Fetching0", r[r.Fetching1 = 4] = "Fetching1", r[r.Fetching2 = 5] = "Fetching2";
})(IconState || (IconState = {}));
const OptionsManager = Object.freeze({
  DEBUG_COLOR_IMAGERY_TILES_BY_ZOOM_LEVEL: !1,
  DEBUG_COLOR_IMAGERY_TILES_RANDOMLY: !1,
  DEBUG_KML_NAN_ASSERT: !0,
  KML_HEIGHT_OFFSET: 0,
  KML_TEXT_HEIGHT_OFFSET: 0
});
var entities = {};
entities.entityMap = {
  lt: "<",
  gt: ">",
  amp: "&",
  quot: '"',
  apos: "'",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  times: "×",
  divide: "÷",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  fnof: "ƒ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  bull: "•",
  hellip: "…",
  permil: "‰",
  prime: "′",
  Prime: "″",
  lsaquo: "‹",
  rsaquo: "›",
  oline: "‾",
  euro: "€",
  trade: "™",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦"
};
var sax$1 = {}, nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), tagNamePattern = new RegExp("^" + nameStartChar.source + nameChar.source + "*(?::" + nameStartChar.source + nameChar.source + "*)?$"), S_TAG = 0, S_ATTR = 1, S_ATTR_SPACE = 2, S_EQ = 3, S_ATTR_NOQUOT_VALUE = 4, S_ATTR_END = 5, S_TAG_SPACE = 6, S_TAG_CLOSE = 7;
function ParseError$1(r, e) {
  this.message = r, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, ParseError$1);
}
ParseError$1.prototype = new Error();
ParseError$1.prototype.name = ParseError$1.name;
function XMLReader$1() {
}
XMLReader$1.prototype = {
  parse: function(r, e, s) {
    var o = this.domBuilder;
    o.startDocument(), _copy(e, e = {}), parse$2(
      r,
      e,
      s,
      o,
      this.errorHandler
    ), o.endDocument();
  }
};
function parse$2(r, e, s, o, a) {
  function l(De) {
    if (De > 65535) {
      De -= 65536;
      var be = 55296 + (De >> 10), ze = 56320 + (De & 1023);
      return String.fromCharCode(be, ze);
    } else
      return String.fromCharCode(De);
  }
  function u(De) {
    var be = De.slice(1, -1);
    return be in s ? s[be] : be.charAt(0) === "#" ? l(parseInt(be.substr(1).replace("x", "0x"))) : (a.error("entity not found:" + De), De);
  }
  function c(De) {
    if (De > m) {
      var be = r.substring(m, De).replace(/&#?\w+;/g, u);
      S && E(m), o.characters(be, 0, De - m), m = De;
    }
  }
  function E(De, be) {
    for (; De >= f && (be = h.exec(r)); )
      d = be.index, f = d + be[0].length, S.lineNumber++;
    S.columnNumber = De - d + 1;
  }
  for (var d = 0, f = 0, h = /.*(?:\r\n?|\n)|.*$/g, S = o.locator, R = [{ currentNSMap: e }], _ = {}, m = 0; ; ) {
    try {
      var L = r.indexOf("<", m);
      if (L < 0) {
        if (!r.substr(m).match(/^\s*$/)) {
          var F = o.doc, W = F.createTextNode(r.substr(m));
          F.appendChild(W), o.currentElement = W;
        }
        return;
      }
      switch (L > m && c(L), r.charAt(L + 1)) {
        case "/":
          var ve = r.indexOf(">", L + 3), G = r.substring(L + 2, ve), q = R.pop();
          ve < 0 ? (G = r.substring(L + 2).replace(/[\s<].*/, ""), a.error("end tag name: " + G + " is not complete:" + q.tagName), ve = L + 1 + G.length) : G.match(/\s</) && (G = G.replace(/[\s<].*/, ""), a.error("end tag name: " + G + " maybe not complete"), ve = L + 1 + G.length);
          var fe = q.localNSMap, _e = q.tagName == G, Le = _e || q.tagName && q.tagName.toLowerCase() == G.toLowerCase();
          if (Le) {
            if (o.endElement(q.uri, q.localName, G), fe)
              for (var Fe in fe)
                o.endPrefixMapping(Fe);
            _e || a.fatalError("end tag name: " + G + " is not match the current start tagName:" + q.tagName);
          } else
            R.push(q);
          ve++;
          break;
        case "?":
          S && E(L), ve = parseInstruction(r, L, o);
          break;
        case "!":
          S && E(L), ve = parseDCC(r, L, o, a);
          break;
        default:
          S && E(L);
          var Ee = new ElementAttributes(), Ge = R[R.length - 1].currentNSMap, ve = parseElementStartPart(r, L, Ee, Ge, u, a), te = Ee.length;
          if (!Ee.closed && fixSelfClosed(r, ve, Ee.tagName, _) && (Ee.closed = !0, s.nbsp || a.warning("unclosed xml attribute")), S && te) {
            for (var ae = copyLocator(S, {}), v = 0; v < te; v++) {
              var Te = Ee[v];
              E(Te.offset), Te.locator = copyLocator(S, {});
            }
            o.locator = ae, appendElement$1(Ee, o, Ge) && R.push(Ee), o.locator = S;
          } else
            appendElement$1(Ee, o, Ge) && R.push(Ee);
          Ee.uri === "http://www.w3.org/1999/xhtml" && !Ee.closed ? ve = parseHtmlSpecialContent(r, ve, Ee.tagName, u, o) : ve++;
      }
    } catch (De) {
      if (De instanceof ParseError$1)
        throw De;
      a.error("element parse error: " + De), ve = -1;
    }
    ve > m ? m = ve : c(Math.max(L, m) + 1);
  }
}
function copyLocator(r, e) {
  return e.lineNumber = r.lineNumber, e.columnNumber = r.columnNumber, e;
}
function parseElementStartPart(r, e, s, o, a, l) {
  function u(S, R, _) {
    S in s.attributeNames && l.fatalError("Attribute " + S + " redefined"), s.addValue(S, R, _);
  }
  for (var c, E, d = ++e, f = S_TAG; ; ) {
    var h = r.charAt(d);
    switch (h) {
      case "=":
        if (f === S_ATTR)
          c = r.slice(e, d), f = S_EQ;
        else if (f === S_ATTR_SPACE)
          f = S_EQ;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (f === S_EQ || f === S_ATTR)
          if (f === S_ATTR && (l.warning('attribute value must after "="'), c = r.slice(e, d)), e = d + 1, d = r.indexOf(h, e), d > 0)
            E = r.slice(e, d).replace(/&#?\w+;/g, a), u(c, E, e - 1), f = S_ATTR_END;
          else
            throw new Error("attribute value no end '" + h + "' match");
        else if (f == S_ATTR_NOQUOT_VALUE)
          E = r.slice(e, d).replace(/&#?\w+;/g, a), u(c, E, e), l.warning('attribute "' + c + '" missed start quot(' + h + ")!!"), e = d + 1, f = S_ATTR_END;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (f) {
          case S_TAG:
            s.setTagName(r.slice(e, d));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            f = S_TAG_CLOSE, s.closed = !0;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
          case S_ATTR_SPACE:
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return l.error("unexpected end of input"), f == S_TAG && s.setTagName(r.slice(e, d)), d;
      case ">":
        switch (f) {
          case S_TAG:
            s.setTagName(r.slice(e, d));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            break;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            E = r.slice(e, d), E.slice(-1) === "/" && (s.closed = !0, E = E.slice(0, -1));
          case S_ATTR_SPACE:
            f === S_ATTR_SPACE && (E = c), f == S_ATTR_NOQUOT_VALUE ? (l.warning('attribute "' + E + '" missed quot(")!'), u(c, E.replace(/&#?\w+;/g, a), e)) : ((o[""] !== "http://www.w3.org/1999/xhtml" || !E.match(/^(?:disabled|checked|selected)$/i)) && l.warning('attribute "' + E + '" missed value!! "' + E + '" instead!!'), u(E, E, e));
            break;
          case S_EQ:
            throw new Error("attribute value missed!!");
        }
        return d;
      case "":
        h = " ";
      default:
        if (h <= " ")
          switch (f) {
            case S_TAG:
              s.setTagName(r.slice(e, d)), f = S_TAG_SPACE;
              break;
            case S_ATTR:
              c = r.slice(e, d), f = S_ATTR_SPACE;
              break;
            case S_ATTR_NOQUOT_VALUE:
              var E = r.slice(e, d).replace(/&#?\w+;/g, a);
              l.warning('attribute "' + E + '" missed quot(")!!'), u(c, E, e);
            case S_ATTR_END:
              f = S_TAG_SPACE;
              break;
          }
        else
          switch (f) {
            case S_ATTR_SPACE:
              s.tagName, (o[""] !== "http://www.w3.org/1999/xhtml" || !c.match(/^(?:disabled|checked|selected)$/i)) && l.warning('attribute "' + c + '" missed value!! "' + c + '" instead2!!'), u(c, c, e), e = d, f = S_ATTR;
              break;
            case S_ATTR_END:
              l.warning('attribute space is required"' + c + '"!!');
            case S_TAG_SPACE:
              f = S_ATTR, e = d;
              break;
            case S_EQ:
              f = S_ATTR_NOQUOT_VALUE, e = d;
              break;
            case S_TAG_CLOSE:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    d++;
  }
}
function appendElement$1(r, e, s) {
  for (var o = r.tagName, a = null, h = r.length; h--; ) {
    var l = r[h], u = l.qName, c = l.value, S = u.indexOf(":");
    if (S > 0)
      var E = l.prefix = u.slice(0, S), d = u.slice(S + 1), f = E === "xmlns" && d;
    else
      d = u, E = null, f = u === "xmlns" && "";
    l.localName = d, f !== !1 && (a == null && (a = {}, _copy(s, s = {})), s[f] = a[f] = c, l.uri = "http://www.w3.org/2000/xmlns/", e.startPrefixMapping(f, c));
  }
  for (var h = r.length; h--; ) {
    l = r[h];
    var E = l.prefix;
    E && (E === "xml" && (l.uri = "http://www.w3.org/XML/1998/namespace"), E !== "xmlns" && (l.uri = s[E || ""]));
  }
  var S = o.indexOf(":");
  S > 0 ? (E = r.prefix = o.slice(0, S), d = r.localName = o.slice(S + 1)) : (E = null, d = r.localName = o);
  var R = r.uri = s[E || ""];
  if (e.startElement(R, d, o, r), r.closed) {
    if (e.endElement(R, d, o), a)
      for (E in a)
        e.endPrefixMapping(E);
  } else
    return r.currentNSMap = s, r.localNSMap = a, !0;
}
function parseHtmlSpecialContent(r, e, s, o, a) {
  if (/^(?:script|textarea)$/i.test(s)) {
    var l = r.indexOf("</" + s + ">", e), u = r.substring(e + 1, l);
    if (/[&<]/.test(u))
      return /^script$/i.test(s) ? (a.characters(u, 0, u.length), l) : (u = u.replace(/&#?\w+;/g, o), a.characters(u, 0, u.length), l);
  }
  return e + 1;
}
function fixSelfClosed(r, e, s, o) {
  var a = o[s];
  return a == null && (a = r.lastIndexOf("</" + s + ">"), a < e && (a = r.lastIndexOf("</" + s)), o[s] = a), a < e;
}
function _copy(r, e) {
  for (var s in r)
    e[s] = r[s];
}
function parseDCC(r, e, s, o) {
  var a = r.charAt(e + 2);
  switch (a) {
    case "-":
      if (r.charAt(e + 3) === "-") {
        var l = r.indexOf("-->", e + 4);
        return l > e ? (s.comment(r, e + 4, l - e - 4), l + 3) : (o.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (r.substr(e + 3, 6) == "CDATA[") {
        var l = r.indexOf("]]>", e + 9);
        return s.startCDATA(), s.characters(r, e + 9, l - e - 9), s.endCDATA(), l + 3;
      }
      var u = split(r, e), c = u.length;
      if (c > 1 && /!doctype/i.test(u[0][0])) {
        var E = u[1][0], d = !1, f = !1;
        c > 3 && (/^public$/i.test(u[2][0]) ? (d = u[3][0], f = c > 4 && u[4][0]) : /^system$/i.test(u[2][0]) && (f = u[3][0]));
        var h = u[c - 1];
        return s.startDTD(E, d, f), s.endDTD(), h.index + h[0].length;
      }
  }
  return -1;
}
function parseInstruction(r, e, s) {
  var o = r.indexOf("?>", e);
  if (o) {
    var a = r.substring(e, o).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return a ? (a[0].length, s.processingInstruction(a[1], a[2]), o + 2) : -1;
  }
  return -1;
}
function ElementAttributes() {
  this.attributeNames = {};
}
ElementAttributes.prototype = {
  setTagName: function(r) {
    if (!tagNamePattern.test(r))
      throw new Error("invalid tagName:" + r);
    this.tagName = r;
  },
  addValue: function(r, e, s) {
    if (!tagNamePattern.test(r))
      throw new Error("invalid attribute:" + r);
    this.attributeNames[r] = this.length, this[this.length++] = { qName: r, value: e, offset: s };
  },
  length: 0,
  getLocalName: function(r) {
    return this[r].localName;
  },
  getLocator: function(r) {
    return this[r].locator;
  },
  getQName: function(r) {
    return this[r].qName;
  },
  getURI: function(r) {
    return this[r].uri;
  },
  getValue: function(r) {
    return this[r].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //			
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function split(r, e) {
  var s, o = [], a = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (a.lastIndex = e, a.exec(r); s = a.exec(r); )
    if (o.push(s), s[1])
      return o;
}
sax$1.XMLReader = XMLReader$1;
sax$1.ParseError = ParseError$1;
var dom = {};
function copy(r, e) {
  for (var s in r)
    e[s] = r[s];
}
function _extends(r, e) {
  var s = r.prototype;
  if (!(s instanceof e)) {
    let o = function() {
    };
    o.prototype = e.prototype, o = new o(), copy(s, o), r.prototype = s = o;
  }
  s.constructor != r && (typeof r != "function" && console.error("unknow Class:" + r), s.constructor = r);
}
var htmlns = "http://www.w3.org/1999/xhtml", NodeType = {}, ELEMENT_NODE$1 = NodeType.ELEMENT_NODE = 1, ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2, TEXT_NODE = NodeType.TEXT_NODE = 3, CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4, ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5, ENTITY_NODE = NodeType.ENTITY_NODE = 6, PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7, COMMENT_NODE = NodeType.COMMENT_NODE = 8, DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9, DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10, DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11, NOTATION_NODE = NodeType.NOTATION_NODE = 12, ExceptionCode = {}, ExceptionMessage = {};
ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);
function DOMException$1(r, e) {
  if (e instanceof Error)
    var s = e;
  else
    s = this, Error.call(this, ExceptionMessage[r]), this.message = ExceptionMessage[r], Error.captureStackTrace && Error.captureStackTrace(this, DOMException$1);
  return s.code = r, e && (this.message = this.message + ": " + e), s;
}
DOMException$1.prototype = Error.prototype;
copy(ExceptionCode, DOMException$1);
function NodeList() {
}
NodeList.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long 
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
   */
  item: function(r) {
    return this[r] || null;
  },
  toString: function(r, e) {
    for (var s = [], o = 0; o < this.length; o++)
      serializeToString(this[o], s, r, e);
    return s.join("");
  }
};
function LiveNodeList(r, e) {
  this._node = r, this._refresh = e, _updateLiveList(this);
}
function _updateLiveList(r) {
  var e = r._node._inc || r._node.ownerDocument._inc;
  if (r._inc != e) {
    var s = r._refresh(r._node);
    __set__(r, "length", s.length), copy(s, r), r._inc = e;
  }
}
LiveNodeList.prototype.item = function(r) {
  return _updateLiveList(this), this[r];
};
_extends(LiveNodeList, NodeList);
function NamedNodeMap() {
}
function _findNodeIndex(r, e) {
  for (var s = r.length; s--; )
    if (r[s] === e)
      return s;
}
function _addNamedNode(r, e, s, o) {
  if (o ? e[_findNodeIndex(e, o)] = s : e[e.length++] = s, r) {
    s.ownerElement = r;
    var a = r.ownerDocument;
    a && (o && _onRemoveAttribute(a, r, o), _onAddAttribute(a, r, s));
  }
}
function _removeNamedNode(r, e, s) {
  var o = _findNodeIndex(e, s);
  if (o >= 0) {
    for (var a = e.length - 1; o < a; )
      e[o] = e[++o];
    if (e.length = a, r) {
      var l = r.ownerDocument;
      l && (_onRemoveAttribute(l, r, s), s.ownerElement = null);
    }
  } else
    throw DOMException$1(NOT_FOUND_ERR, new Error(r.tagName + "@" + s));
}
NamedNodeMap.prototype = {
  length: 0,
  item: NodeList.prototype.item,
  getNamedItem: function(r) {
    for (var e = this.length; e--; ) {
      var s = this[e];
      if (s.nodeName == r)
        return s;
    }
  },
  setNamedItem: function(r) {
    var e = r.ownerElement;
    if (e && e != this._ownerElement)
      throw new DOMException$1(INUSE_ATTRIBUTE_ERR);
    var s = this.getNamedItem(r.nodeName);
    return _addNamedNode(this._ownerElement, this, r, s), s;
  },
  /* returns Node */
  setNamedItemNS: function(r) {
    var e = r.ownerElement, s;
    if (e && e != this._ownerElement)
      throw new DOMException$1(INUSE_ATTRIBUTE_ERR);
    return s = this.getNamedItemNS(r.namespaceURI, r.localName), _addNamedNode(this._ownerElement, this, r, s), s;
  },
  /* returns Node */
  removeNamedItem: function(r) {
    var e = this.getNamedItem(r);
    return _removeNamedNode(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(r, e) {
    var s = this.getNamedItemNS(r, e);
    return _removeNamedNode(this._ownerElement, this, s), s;
  },
  getNamedItemNS: function(r, e) {
    for (var s = this.length; s--; ) {
      var o = this[s];
      if (o.localName == e && o.namespaceURI == r)
        return o;
    }
    return null;
  }
};
function DOMImplementation$1(r) {
  if (this._features = {}, r)
    for (var e in r)
      this._features = r[e];
}
DOMImplementation$1.prototype = {
  hasFeature: function(r, e) {
    var s = this._features[r.toLowerCase()];
    return !!(s && (!e || e in s));
  },
  // Introduced in DOM Level 2:
  createDocument: function(r, e, s) {
    var o = new Document$1();
    if (o.implementation = this, o.childNodes = new NodeList(), o.doctype = s, s && o.appendChild(s), e) {
      var a = o.createElementNS(r, e);
      o.appendChild(a);
    }
    return o;
  },
  // Introduced in DOM Level 2:
  createDocumentType: function(r, e, s) {
    var o = new DocumentType();
    return o.name = r, o.nodeName = r, o.publicId = e, o.systemId = s, o;
  }
};
function Node$2() {
}
Node$2.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(r, e) {
    return _insertBefore(this, r, e);
  },
  replaceChild: function(r, e) {
    this.insertBefore(r, e), e && this.removeChild(e);
  },
  removeChild: function(r) {
    return _removeChild(this, r);
  },
  appendChild: function(r) {
    return this.insertBefore(r, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(r) {
    return cloneNode(this.ownerDocument || this, this, r);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var r = this.firstChild; r; ) {
      var e = r.nextSibling;
      e && e.nodeType == TEXT_NODE && r.nodeType == TEXT_NODE ? (this.removeChild(e), r.appendData(e.data)) : (r.normalize(), r = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(r, e) {
    return this.ownerDocument.implementation.hasFeature(r, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  lookupPrefix: function(r) {
    for (var e = this; e; ) {
      var s = e._nsMap;
      if (s) {
        for (var o in s)
          if (s[o] == r)
            return o;
      }
      e = e.nodeType == ATTRIBUTE_NODE ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(r) {
    for (var e = this; e; ) {
      var s = e._nsMap;
      if (s && r in s)
        return s[r];
      e = e.nodeType == ATTRIBUTE_NODE ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(r) {
    var e = this.lookupPrefix(r);
    return e == null;
  }
};
function _xmlEncoder(r) {
  return r == "<" && "&lt;" || r == ">" && "&gt;" || r == "&" && "&amp;" || r == '"' && "&quot;" || "&#" + r.charCodeAt() + ";";
}
copy(NodeType, Node$2);
copy(NodeType, Node$2.prototype);
function _visitNode(r, e) {
  if (e(r))
    return !0;
  if (r = r.firstChild)
    do
      if (_visitNode(r, e))
        return !0;
    while (r = r.nextSibling);
}
function Document$1() {
}
function _onAddAttribute(r, e, s) {
  r && r._inc++;
  var o = s.namespaceURI;
  o == "http://www.w3.org/2000/xmlns/" && (e._nsMap[s.prefix ? s.localName : ""] = s.value);
}
function _onRemoveAttribute(r, e, s, o) {
  r && r._inc++;
  var a = s.namespaceURI;
  a == "http://www.w3.org/2000/xmlns/" && delete e._nsMap[s.prefix ? s.localName : ""];
}
function _onUpdateChild(r, e, s) {
  if (r && r._inc) {
    r._inc++;
    var o = e.childNodes;
    if (s)
      o[o.length++] = s;
    else {
      for (var a = e.firstChild, l = 0; a; )
        o[l++] = a, a = a.nextSibling;
      o.length = l;
    }
  }
}
function _removeChild(r, e) {
  var s = e.previousSibling, o = e.nextSibling;
  return s ? s.nextSibling = o : r.firstChild = o, o ? o.previousSibling = s : r.lastChild = s, _onUpdateChild(r.ownerDocument, r), e;
}
function _insertBefore(r, e, s) {
  var o = e.parentNode;
  if (o && o.removeChild(e), e.nodeType === DOCUMENT_FRAGMENT_NODE) {
    var a = e.firstChild;
    if (a == null)
      return e;
    var l = e.lastChild;
  } else
    a = l = e;
  var u = s ? s.previousSibling : r.lastChild;
  a.previousSibling = u, l.nextSibling = s, u ? u.nextSibling = a : r.firstChild = a, s == null ? r.lastChild = l : s.previousSibling = l;
  do
    a.parentNode = r;
  while (a !== l && (a = a.nextSibling));
  return _onUpdateChild(r.ownerDocument || r, r), e.nodeType == DOCUMENT_FRAGMENT_NODE && (e.firstChild = e.lastChild = null), e;
}
function _appendSingleChild(r, e) {
  var s = e.parentNode;
  if (s) {
    var o = r.lastChild;
    s.removeChild(e);
    var o = r.lastChild;
  }
  var o = r.lastChild;
  return e.parentNode = r, e.previousSibling = o, e.nextSibling = null, o ? o.nextSibling = e : r.firstChild = e, r.lastChild = e, _onUpdateChild(r.ownerDocument, r, e), e;
}
Document$1.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: DOCUMENT_NODE,
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(r, e) {
    if (r.nodeType == DOCUMENT_FRAGMENT_NODE) {
      for (var s = r.firstChild; s; ) {
        var o = s.nextSibling;
        this.insertBefore(s, e), s = o;
      }
      return r;
    }
    return this.documentElement == null && r.nodeType == ELEMENT_NODE$1 && (this.documentElement = r), _insertBefore(this, r, e), r.ownerDocument = this, r;
  },
  removeChild: function(r) {
    return this.documentElement == r && (this.documentElement = null), _removeChild(this, r);
  },
  // Introduced in DOM Level 2:
  importNode: function(r, e) {
    return importNode(this, r, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(r) {
    var e = null;
    return _visitNode(this.documentElement, function(s) {
      if (s.nodeType == ELEMENT_NODE$1 && s.getAttribute("id") == r)
        return e = s, !0;
    }), e;
  },
  getElementsByClassName: function(r) {
    var e = new RegExp("(^|\\s)" + r + "(\\s|$)");
    return new LiveNodeList(this, function(s) {
      var o = [];
      return _visitNode(s.documentElement, function(a) {
        a !== s && a.nodeType == ELEMENT_NODE$1 && e.test(a.getAttribute("class")) && o.push(a);
      }), o;
    });
  },
  //document factory method:
  createElement: function(r) {
    var e = new Element();
    e.ownerDocument = this, e.nodeName = r, e.tagName = r, e.childNodes = new NodeList();
    var s = e.attributes = new NamedNodeMap();
    return s._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var r = new DocumentFragment();
    return r.ownerDocument = this, r.childNodes = new NodeList(), r;
  },
  createTextNode: function(r) {
    var e = new Text$1();
    return e.ownerDocument = this, e.appendData(r), e;
  },
  createComment: function(r) {
    var e = new Comment();
    return e.ownerDocument = this, e.appendData(r), e;
  },
  createCDATASection: function(r) {
    var e = new CDATASection();
    return e.ownerDocument = this, e.appendData(r), e;
  },
  createProcessingInstruction: function(r, e) {
    var s = new ProcessingInstruction();
    return s.ownerDocument = this, s.tagName = s.target = r, s.nodeValue = s.data = e, s;
  },
  createAttribute: function(r) {
    var e = new Attr();
    return e.ownerDocument = this, e.name = r, e.nodeName = r, e.localName = r, e.specified = !0, e;
  },
  createEntityReference: function(r) {
    var e = new EntityReference();
    return e.ownerDocument = this, e.nodeName = r, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(r, e) {
    var s = new Element(), o = e.split(":"), a = s.attributes = new NamedNodeMap();
    return s.childNodes = new NodeList(), s.ownerDocument = this, s.nodeName = e, s.tagName = e, s.namespaceURI = r, o.length == 2 ? (s.prefix = o[0], s.localName = o[1]) : s.localName = e, a._ownerElement = s, s;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(r, e) {
    var s = new Attr(), o = e.split(":");
    return s.ownerDocument = this, s.nodeName = e, s.name = e, s.namespaceURI = r, s.specified = !0, o.length == 2 ? (s.prefix = o[0], s.localName = o[1]) : s.localName = e, s;
  }
};
_extends(Document$1, Node$2);
function Element() {
  this._nsMap = {};
}
Element.prototype = {
  nodeType: ELEMENT_NODE$1,
  hasAttribute: function(r) {
    return this.getAttributeNode(r) != null;
  },
  getAttribute: function(r) {
    var e = this.getAttributeNode(r);
    return e && e.value || "";
  },
  getAttributeNode: function(r) {
    return this.attributes.getNamedItem(r);
  },
  setAttribute: function(r, e) {
    var s = this.ownerDocument.createAttribute(r);
    s.value = s.nodeValue = "" + e, this.setAttributeNode(s);
  },
  removeAttribute: function(r) {
    var e = this.getAttributeNode(r);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(r) {
    return r.nodeType === DOCUMENT_FRAGMENT_NODE ? this.insertBefore(r, null) : _appendSingleChild(this, r);
  },
  setAttributeNode: function(r) {
    return this.attributes.setNamedItem(r);
  },
  setAttributeNodeNS: function(r) {
    return this.attributes.setNamedItemNS(r);
  },
  removeAttributeNode: function(r) {
    return this.attributes.removeNamedItem(r.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(r, e) {
    var s = this.getAttributeNodeNS(r, e);
    s && this.removeAttributeNode(s);
  },
  hasAttributeNS: function(r, e) {
    return this.getAttributeNodeNS(r, e) != null;
  },
  getAttributeNS: function(r, e) {
    var s = this.getAttributeNodeNS(r, e);
    return s && s.value || "";
  },
  setAttributeNS: function(r, e, s) {
    var o = this.ownerDocument.createAttributeNS(r, e);
    o.value = o.nodeValue = "" + s, this.setAttributeNode(o);
  },
  getAttributeNodeNS: function(r, e) {
    return this.attributes.getNamedItemNS(r, e);
  },
  getElementsByTagName: function(r) {
    return new LiveNodeList(this, function(e) {
      var s = [];
      return _visitNode(e, function(o) {
        o !== e && o.nodeType == ELEMENT_NODE$1 && (r === "*" || o.tagName == r) && s.push(o);
      }), s;
    });
  },
  getElementsByTagNameNS: function(r, e) {
    return new LiveNodeList(this, function(s) {
      var o = [];
      return _visitNode(s, function(a) {
        a !== s && a.nodeType === ELEMENT_NODE$1 && (r === "*" || a.namespaceURI === r) && (e === "*" || a.localName == e) && o.push(a);
      }), o;
    });
  }
};
Document$1.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document$1.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
_extends(Element, Node$2);
function Attr() {
}
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node$2);
function CharacterData() {
}
CharacterData.prototype = {
  data: "",
  substringData: function(r, e) {
    return this.data.substring(r, r + e);
  },
  appendData: function(r) {
    r = this.data + r, this.nodeValue = this.data = r, this.length = r.length;
  },
  insertData: function(r, e) {
    this.replaceData(r, 0, e);
  },
  appendChild: function(r) {
    throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
  },
  deleteData: function(r, e) {
    this.replaceData(r, e, "");
  },
  replaceData: function(r, e, s) {
    var o = this.data.substring(0, r), a = this.data.substring(r + e);
    s = o + s + a, this.nodeValue = this.data = s, this.length = s.length;
  }
};
_extends(CharacterData, Node$2);
function Text$1() {
}
Text$1.prototype = {
  nodeName: "#text",
  nodeType: TEXT_NODE,
  splitText: function(r) {
    var e = this.data, s = e.substring(r);
    e = e.substring(0, r), this.data = this.nodeValue = e, this.length = e.length;
    var o = this.ownerDocument.createTextNode(s);
    return this.parentNode && this.parentNode.insertBefore(o, this.nextSibling), o;
  }
};
_extends(Text$1, CharacterData);
function Comment() {
}
Comment.prototype = {
  nodeName: "#comment",
  nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);
function CDATASection() {
}
CDATASection.prototype = {
  nodeName: "#cdata-section",
  nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);
function DocumentType() {
}
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node$2);
function Notation() {
}
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node$2);
function Entity$1() {
}
Entity$1.prototype.nodeType = ENTITY_NODE;
_extends(Entity$1, Node$2);
function EntityReference() {
}
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node$2);
function DocumentFragment() {
}
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node$2);
function ProcessingInstruction() {
}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node$2);
function XMLSerializer() {
}
XMLSerializer.prototype.serializeToString = function(r, e, s) {
  return nodeSerializeToString.call(r, e, s);
};
Node$2.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(r, e) {
  var s = [], o = this.nodeType == 9 && this.documentElement || this, a = o.prefix, l = o.namespaceURI;
  if (l && a == null) {
    var a = o.lookupPrefix(l);
    if (a == null)
      var u = [
        { namespace: l, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return serializeToString(this, s, r, e, u), s.join("");
}
function needNamespaceDefine(r, e, s) {
  var o = r.prefix || "", a = r.namespaceURI;
  if (!o && !a || o === "xml" && a === "http://www.w3.org/XML/1998/namespace" || a == "http://www.w3.org/2000/xmlns/")
    return !1;
  for (var l = s.length; l--; ) {
    var u = s[l];
    if (u.prefix == o)
      return u.namespace != a;
  }
  return !0;
}
function serializeToString(r, e, s, o, a) {
  if (o)
    if (r = o(r), r) {
      if (typeof r == "string") {
        e.push(r);
        return;
      }
    } else
      return;
  switch (r.nodeType) {
    case ELEMENT_NODE$1:
      a || (a = []), a.length;
      var l = r.attributes, u = l.length, R = r.firstChild, c = r.tagName;
      s = htmlns === r.namespaceURI || s, e.push("<", c);
      for (var E = 0; E < u; E++) {
        var d = l.item(E);
        d.prefix == "xmlns" ? a.push({ prefix: d.localName, namespace: d.value }) : d.nodeName == "xmlns" && a.push({ prefix: "", namespace: d.value });
      }
      for (var E = 0; E < u; E++) {
        var d = l.item(E);
        if (needNamespaceDefine(d, s, a)) {
          var f = d.prefix || "", h = d.namespaceURI, S = f ? " xmlns:" + f : " xmlns";
          e.push(S, '="', h, '"'), a.push({ prefix: f, namespace: h });
        }
        serializeToString(d, e, s, o, a);
      }
      if (needNamespaceDefine(r, s, a)) {
        var f = r.prefix || "", h = r.namespaceURI;
        if (h) {
          var S = f ? " xmlns:" + f : " xmlns";
          e.push(S, '="', h, '"'), a.push({ prefix: f, namespace: h });
        }
      }
      if (R || s && !/^(?:meta|link|img|br|hr|input)$/i.test(c)) {
        if (e.push(">"), s && /^script$/i.test(c))
          for (; R; )
            R.data ? e.push(R.data) : serializeToString(R, e, s, o, a), R = R.nextSibling;
        else
          for (; R; )
            serializeToString(R, e, s, o, a), R = R.nextSibling;
        e.push("</", c, ">");
      } else
        e.push("/>");
      return;
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      for (var R = r.firstChild; R; )
        serializeToString(R, e, s, o, a), R = R.nextSibling;
      return;
    case ATTRIBUTE_NODE:
      return e.push(" ", r.name, '="', r.value.replace(/[<&"]/g, _xmlEncoder), '"');
    case TEXT_NODE:
      return e.push(
        r.data.replace(/[<&]/g, _xmlEncoder).replace(/]]>/g, "]]&gt;")
      );
    case CDATA_SECTION_NODE:
      return e.push("<![CDATA[", r.data, "]]>");
    case COMMENT_NODE:
      return e.push("<!--", r.data, "-->");
    case DOCUMENT_TYPE_NODE:
      var _ = r.publicId, m = r.systemId;
      if (e.push("<!DOCTYPE ", r.name), _)
        e.push(" PUBLIC ", _), m && m != "." && e.push(" ", m), e.push(">");
      else if (m && m != ".")
        e.push(" SYSTEM ", m, ">");
      else {
        var L = r.internalSubset;
        L && e.push(" [", L, "]"), e.push(">");
      }
      return;
    case PROCESSING_INSTRUCTION_NODE:
      return e.push("<?", r.target, " ", r.data, "?>");
    case ENTITY_REFERENCE_NODE:
      return e.push("&", r.nodeName, ";");
    default:
      e.push("??", r.nodeName);
  }
}
function importNode(r, e, s) {
  var o;
  switch (e.nodeType) {
    case ELEMENT_NODE$1:
      o = e.cloneNode(!1), o.ownerDocument = r;
    case DOCUMENT_FRAGMENT_NODE:
      break;
    case ATTRIBUTE_NODE:
      s = !0;
      break;
  }
  if (o || (o = e.cloneNode(!1)), o.ownerDocument = r, o.parentNode = null, s)
    for (var a = e.firstChild; a; )
      o.appendChild(importNode(r, a, s)), a = a.nextSibling;
  return o;
}
function cloneNode(r, e, s) {
  var o = new e.constructor();
  for (var a in e) {
    var l = e[a];
    typeof l != "object" && l != o[a] && (o[a] = l);
  }
  switch (e.childNodes && (o.childNodes = new NodeList()), o.ownerDocument = r, o.nodeType) {
    case ELEMENT_NODE$1:
      var u = e.attributes, c = o.attributes = new NamedNodeMap(), E = u.length;
      c._ownerElement = o;
      for (var d = 0; d < E; d++)
        o.setAttributeNode(cloneNode(r, u.item(d), !0));
      break;
    case ATTRIBUTE_NODE:
      s = !0;
  }
  if (s)
    for (var f = e.firstChild; f; )
      o.appendChild(cloneNode(r, f, s)), f = f.nextSibling;
  return o;
}
function __set__(r, e, s) {
  r[e] = s;
}
try {
  if (Object.defineProperty) {
    let r = function(e) {
      switch (e.nodeType) {
        case ELEMENT_NODE$1:
        case DOCUMENT_FRAGMENT_NODE:
          var s = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && s.push(r(e)), e = e.nextSibling;
          return s.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(LiveNodeList.prototype, "length", {
      get: function() {
        return _updateLiveList(this), this.$$length;
      }
    }), Object.defineProperty(Node$2.prototype, "textContent", {
      get: function() {
        return r(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case ELEMENT_NODE$1:
          case DOCUMENT_FRAGMENT_NODE:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), __set__ = function(e, s, o) {
      e["$$" + s] = o;
    };
  }
} catch (r) {
}
dom.Node = Node$2;
dom.DOMException = DOMException$1;
dom.DOMImplementation = DOMImplementation$1;
dom.XMLSerializer = XMLSerializer;
function DOMParser$1(r) {
  this.options = r || { locator: {} };
}
DOMParser$1.prototype.parseFromString = function(r, e) {
  var s = this.options, o = new XMLReader(), a = s.domBuilder || new DOMHandler(), l = s.errorHandler, u = s.locator, c = s.xmlns || {}, E = /\/x?html?$/.test(e), d = E ? htmlEntity.entityMap : { lt: "<", gt: ">", amp: "&", quot: '"', apos: "'" };
  return u && a.setDocumentLocator(u), o.errorHandler = buildErrorHandler(l, a, u), o.domBuilder = s.domBuilder || a, E && (c[""] = "http://www.w3.org/1999/xhtml"), c.xml = c.xml || "http://www.w3.org/XML/1998/namespace", r && typeof r == "string" ? o.parse(r, c, d) : o.errorHandler.error("invalid doc source"), a.doc;
};
function buildErrorHandler(r, e, s) {
  if (!r) {
    if (e instanceof DOMHandler)
      return e;
    r = e;
  }
  var o = {}, a = r instanceof Function;
  s = s || {};
  function l(u) {
    var c = r[u];
    !c && a && (c = r.length == 2 ? function(E) {
      r(u, E);
    } : r), o[u] = c && function(E) {
      c("[xmldom " + u + "]	" + E + _locator(s));
    } || function() {
    };
  }
  return l("warning"), l("error"), l("fatalError"), o;
}
function DOMHandler() {
  this.cdata = !1;
}
function position(r, e) {
  e.lineNumber = r.lineNumber, e.columnNumber = r.columnNumber;
}
DOMHandler.prototype = {
  startDocument: function() {
    this.doc = new DOMImplementation().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(r, e, s, o) {
    var a = this.doc, l = a.createElementNS(r, s || e), u = o.length;
    appendElement(this, l), this.currentElement = l, this.locator && position(this.locator, l);
    for (var c = 0; c < u; c++) {
      var r = o.getURI(c), E = o.getValue(c), s = o.getQName(c), d = a.createAttributeNS(r, s);
      this.locator && position(o.getLocator(c), d), d.value = d.nodeValue = E, l.setAttributeNode(d);
    }
  },
  endElement: function(r, e, s) {
    var o = this.currentElement;
    o.tagName, this.currentElement = o.parentNode;
  },
  startPrefixMapping: function(r, e) {
  },
  endPrefixMapping: function(r) {
  },
  processingInstruction: function(r, e) {
    var s = this.doc.createProcessingInstruction(r, e);
    this.locator && position(this.locator, s), appendElement(this, s);
  },
  ignorableWhitespace: function(r, e, s) {
  },
  characters: function(r, e, s) {
    if (r = _toString.apply(this, arguments), r) {
      if (this.cdata)
        var o = this.doc.createCDATASection(r);
      else
        var o = this.doc.createTextNode(r);
      this.currentElement ? this.currentElement.appendChild(o) : /^\s*$/.test(r) && this.doc.appendChild(o), this.locator && position(this.locator, o);
    }
  },
  skippedEntity: function(r) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(r) {
    (this.locator = r) && (r.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(r, e, s) {
    r = _toString.apply(this, arguments);
    var o = this.doc.createComment(r);
    this.locator && position(this.locator, o), appendElement(this, o);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(r, e, s) {
    var o = this.doc.implementation;
    if (o && o.createDocumentType) {
      var a = o.createDocumentType(r, e, s);
      this.locator && position(this.locator, a), appendElement(this, a);
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(r) {
    console.warn("[xmldom warning]	" + r, _locator(this.locator));
  },
  error: function(r) {
    console.error("[xmldom error]	" + r, _locator(this.locator));
  },
  fatalError: function(r) {
    throw new ParseError(r, this.locator);
  }
};
function _locator(r) {
  if (r)
    return `
@` + (r.systemId || "") + "#[line:" + r.lineNumber + ",col:" + r.columnNumber + "]";
}
function _toString(r, e, s) {
  return typeof r == "string" ? r.substr(e, s) : r.length >= e + s || e ? new java.lang.String(r, e, s) + "" : r;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(r) {
  DOMHandler.prototype[r] = function() {
    return null;
  };
});
function appendElement(r, e) {
  r.currentElement ? r.currentElement.appendChild(e) : r.doc.appendChild(e);
}
var htmlEntity = entities, sax = sax$1, XMLReader = sax.XMLReader, ParseError = sax.ParseError, DOMImplementation = dom.DOMImplementation, DOMParser_1 = DOMParser$1;
const ELEMENT_NODE = Node.ELEMENT_NODE;
class KMLParserSession {
  constructor() {
    this.objectsById = /* @__PURE__ */ new Map();
  }
  parseText(e) {
    const s = KMLParserSession._domParser.parseFromString(insertNamespaces(e), "application/xml");
    return this.parseDocument(s);
  }
  parseDocument(e) {
    const s = findChildElementByName$1(e, "kml");
    if (s === null)
      throw new Error("KML file missing kml element");
    const o = this.parseRoot(s);
    return this.root = o, o;
  }
  parseRoot(e) {
    let s;
    for (let o = 0; o < e.childNodes.length; o += 1) {
      const a = e.childNodes.item(o);
      if (a === null || a.nodeType !== ELEMENT_NODE)
        continue;
      const l = elementTypeFromTagName(a);
      if (l !== void 0 && isContainerElement(l)) {
        if (s !== void 0)
          throw new Error("KML file has multiple root containers");
        s = a;
      }
    }
    if (s !== void 0)
      return this.parseContainer(s);
  }
  parseContainer(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (!isContainerElement(a))
      throw new Error("Unknown container element type");
    const l = {
      elementType: a,
      visibility: !0,
      open: !1,
      features: [],
      styleSelectors: [],
      isContainerElement: !0,
      isFeatureElement: !0,
      isGeometryElement: !1,
      isStyleSelector: !1,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadFeatureField(l, E), this.tryLoadContainerField(l, E));
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseFeature(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (!isFeatureElement(a))
      throw new Error("Unknown feature element type");
    if (isContainerElement(a))
      return this.parseContainer(e);
    let l;
    switch (a) {
      case KMLElementType.Placemark:
        l = {
          elementType: a,
          visibility: !0,
          open: !1,
          geometries: [],
          styleSelectors: [],
          isContainerElement: !1,
          isFeatureElement: !0,
          isGeometryElement: !1,
          isStyleSelector: !1,
          isColorStyle: !1
        };
        break;
      default:
        throw new Error("Unreachable");
    }
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadFeatureField(l, E), l.elementType === KMLElementType.Placemark && this.tryLoadPlacemarkField(l, E));
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseGeometry(e) {
    const s = elementTypeFromTagName(e);
    if (s === void 0)
      throw new Error("Unknown element type");
    if (!isGeometryElement(s))
      throw new Error("Unknown feature element type");
    switch (s) {
      case KMLElementType.Point:
        return this.parsePoint(e);
      case KMLElementType.LineString:
        return this.parseLineString(e);
      case KMLElementType.LinearRing:
        return this.parseLinearRing(e);
      case KMLElementType.Polygon:
        return this.parsePolygon(e);
      case KMLElementType.MultiGeometry:
        return this.parseMultiGeometry(e);
      default:
        throw new Error("Unreachable");
    }
  }
  parseStyleSelector(e) {
    const s = elementTypeFromTagName(e);
    if (s === void 0)
      throw new Error("Unknown element type");
    if (!isStyleSelectorElement(s))
      throw new Error("Unknown feature element type");
    switch (s) {
      case KMLElementType.Style:
        return this.parseStyle(e);
      case KMLElementType.StyleMap:
        return this.parseStyleMap(e);
      default:
        throw new Error("Unreachable");
    }
  }
  parsePoint(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.Point)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a Point`);
    const l = {
      elementType: KMLElementType.Point,
      coordinates: [0, 0, 0],
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !0,
      isStyleSelector: !1,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      if (E === null || E.nodeType !== ELEMENT_NODE)
        continue;
      this.tryLoadExtrudeAltitudeMode(l, E);
      const d = {
        coordinates: []
      };
      this.tryLoadMultipleCoordinate(d, E, 1), d.coordinates.length === 1 && (l.coordinates = d.coordinates[0]);
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseLineString(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.LineString)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a LineString`);
    const l = {
      elementType: KMLElementType.LineString,
      coordinates: [],
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !0,
      isStyleSelector: !1,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadExtrudeAltitudeMode(l, E), this.tryLoadTessellate(l, E), this.tryLoadMultipleCoordinate(l, E));
    }
    if (l.coordinates.length === 0 || l.coordinates.length < 2)
      return;
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseLinearRing(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.LinearRing)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a LinearRing`);
    const l = {
      elementType: KMLElementType.LinearRing,
      coordinates: [],
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !0,
      isStyleSelector: !1,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadExtrudeAltitudeMode(l, E), this.tryLoadTessellate(l, E), this.tryLoadMultipleCoordinate(l, E));
    }
    if (l.coordinates.length === 0 || l.coordinates.length < 2)
      return;
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parsePolygon(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.Polygon)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a Polygon`);
    const l = {
      elementType: KMLElementType.Polygon,
      // @ts-ignore
      outerRing: void 0,
      innerRings: [],
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !0
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadExtrudeAltitudeMode(l, E), this.tryLoadTessellate(l, E), this.tryLoadPolygonField(l, E));
    }
    if (l.outerRing === void 0)
      return;
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseMultiGeometry(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.MultiGeometry)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a MultiGeometry`);
    const l = {
      elementType: KMLElementType.MultiGeometry,
      geometries: [],
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !0,
      isStyleSelector: !1,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && this.tryLoadMultiGeometryField(l, E);
    }
    if (l.geometries.length === 0)
      return;
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.Style)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a Style`);
    const l = {
      elementType: KMLElementType.Style,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !0,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && this.tryLoadStyleField(l, E);
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseStyleMap(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.StyleMap)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a StyleMap`);
    const l = {
      elementType: KMLElementType.StyleMap,
      map: /* @__PURE__ */ new Map(),
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !0,
      isColorStyle: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && this.tryLoadStyleMapField(l, E);
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseLineStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.LineStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a LineStyle`);
    const l = {
      elementType: KMLElementType.LineStyle,
      color: [1, 1, 1, 1],
      colorMode: ColorMode.Normal,
      width: 1,
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadColorStyleField(l, E), this.tryLoadLineStyleField(l, E));
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parsePolyStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.PolyStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a PolyStyle`);
    const l = {
      elementType: KMLElementType.PolyStyle,
      color: [1, 1, 1, 1],
      colorMode: ColorMode.Normal,
      fill: !0,
      outline: !0,
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadColorStyleField(l, E), this.tryLoadPolyStyleField(l, E));
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseIconStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.IconStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a IconStyle`);
    const l = {
      elementType: KMLElementType.IconStyle,
      color: [1, 1, 1, 1],
      colorMode: ColorMode.Normal,
      heading: 0,
      scale: 0,
      hotSpot: {
        x: 0,
        y: 0,
        xUnits: "pixels",
        yUnits: "pixels"
      },
      icon: "",
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && (this.tryLoadColorStyleField(l, E), this.tryLoadIconStyleField(l, E));
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseLabelStyle(e) {
    const s = elementTypeFromTagName(e);
    if (s === void 0)
      throw new Error("Unknown element type");
    if (s !== KMLElementType.LabelStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a LabelStyle`);
    const o = {
      elementType: KMLElementType.LabelStyle,
      color: [1, 1, 1, 1],
      colorMode: ColorMode.Normal,
      scale: 1,
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let a = 0; a < e.childNodes.length; a += 1) {
      const l = e.childNodes.item(a);
      l !== null && l.nodeType === ELEMENT_NODE && (this.tryLoadColorStyleField(o, l), this.tryLoadLabelStyleField(o, l));
    }
    return o;
  }
  parseBalloonStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.BalloonStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a BalloonStyle`);
    const l = {
      elementType: KMLElementType.BalloonStyle,
      bgColor: [1, 1, 1, 1],
      textColor: [0, 0, 0, 1],
      displayMode: DisplayMode.Default,
      text: "",
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && this.tryLoadBalloonStyleField(l, E);
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  parseListStyle(e) {
    var s, o;
    const a = elementTypeFromTagName(e);
    if (a === void 0)
      throw new Error("Unknown element type");
    if (a !== KMLElementType.ListStyle)
      throw new Error(`Attempt to parse a '${e.tagName}' element as a ListStyle`);
    const l = {
      elementType: KMLElementType.ListStyle,
      bgColor: [0, 0, 0, 0],
      listItemType: ListItemType.Check,
      icons: [],
      isColorStyle: !0,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !1
    };
    for (let c = 0; c < e.childNodes.length; c += 1) {
      const E = e.childNodes.item(c);
      E !== null && E.nodeType === ELEMENT_NODE && this.tryLoadListStyleField(l, E);
    }
    const u = (o = (s = e.attributes.getNamedItem("id")) === null || s === void 0 ? void 0 : s.textContent) !== null && o !== void 0 ? o : "";
    return u.length !== 0 && this.objectsById.set(u, l), l;
  }
  tryLoadFeatureField(e, s) {
    const o = elementTypeFromTagName(s);
    switch (o !== void 0 && isStyleSelectorElement(o) && e.styleSelectors.push(this.parseStyleSelector(s)), s.tagName) {
      case "name": {
        e.name = s.textContent || void 0;
        break;
      }
      case "visibility": {
        e.visibility = readBooleanTextContent(s.textContent);
        break;
      }
      case "open": {
        e.open = readBooleanTextContent(s.textContent);
        break;
      }
      case "styleUrl": {
        e.styleUri = s.textContent !== null ? s.textContent.trim() : void 0;
        break;
      }
      case "Region": {
        e.region;
        let a = null, l = null;
        for (let u = 0; u < s.childNodes.length; u += 1) {
          const c = s.childNodes.item(u);
          if (c !== null && c.nodeType === ELEMENT_NODE)
            switch (c.tagName) {
              case "LatLonAltBox": {
                a = {
                  north: 0,
                  south: 0,
                  east: 0,
                  west: 0,
                  minAlt: 0,
                  maxAlt: 0,
                  altitudeMode: AltitudeMode.ClampToGround
                };
                for (let E = 0; E < c.childNodes.length; E += 1) {
                  const d = c.childNodes.item(E);
                  if (d !== null && d.nodeType === ELEMENT_NODE)
                    switch (d.tagName) {
                      case "north": {
                        a.north = readFloat(d.textContent);
                        break;
                      }
                      case "south": {
                        a.south = readFloat(d.textContent);
                        break;
                      }
                      case "east": {
                        a.east = readFloat(d.textContent);
                        break;
                      }
                      case "west": {
                        a.west = readFloat(d.textContent);
                        break;
                      }
                      case "minAltitude": {
                        a.minAlt = readFloat(d.textContent);
                        break;
                      }
                      case "maxAltitude": {
                        a.maxAlt = readFloat(d.textContent);
                        break;
                      }
                      case "altitudeMode":
                        a.altitudeMode = readAltitudeModeTextContent(d.textContent);
                    }
                }
                break;
              }
              case "Lod": {
                l = {
                  minLodPixels: 0,
                  maxLodPixels: -1
                };
                for (let E = 0; E < c.childNodes.length; E += 1) {
                  const d = c.childNodes.item(E);
                  if (d !== null && d.nodeType === ELEMENT_NODE)
                    switch (d.tagName) {
                      case "minLodPixels": {
                        l.minLodPixels = readFloat(d.textContent);
                        break;
                      }
                      case "maxLodPixels": {
                        l.maxLodPixels = readFloat(d.textContent);
                        break;
                      }
                      case "minFadeExtent": {
                        l.minFadeExtent = readFloat(d.textContent);
                        break;
                      }
                      case "maxFadeExtent": {
                        l.maxFadeExtent = readFloat(d.textContent);
                        break;
                      }
                    }
                }
                break;
              }
            }
        }
        if (a === null)
          throw new Error("LatLonAltBox field missing on Region");
        e.region = {
          box: a,
          lod: l || void 0
        };
        break;
      }
    }
  }
  tryLoadExtrudeAltitudeMode(e, s) {
    switch (s.tagName) {
      case "extrude": {
        e.extrude = readBooleanTextContent(s.textContent);
        break;
      }
      case "altitudeMode": {
        e.altitudeMode = readAltitudeModeTextContent(s.textContent);
        break;
      }
    }
  }
  tryLoadTessellate(e, s) {
    switch (s.tagName) {
      case "tessellate": {
        e.tessellate = readBooleanTextContent(s.textContent);
        break;
      }
    }
  }
  tryLoadMultipleCoordinate(e, s, o) {
    switch (s.tagName) {
      case "coordinates": {
        e.coordinates = readMultiLatLongAltTuple(s.textContent, o);
        break;
      }
    }
  }
  tryLoadContainerField(e, s) {
    const o = elementTypeFromTagName(s);
    o !== void 0 && isFeatureElement(o) && e.features.push(this.parseFeature(s));
  }
  tryLoadPlacemarkField(e, s) {
    const o = elementTypeFromTagName(s);
    if (o !== void 0 && isGeometryElement(o)) {
      const a = this.parseGeometry(s);
      a !== void 0 && e.geometries.push(a);
    }
  }
  tryLoadPolygonField(e, s) {
    switch (s.tagName) {
      case "outerBoundaryIs": {
        for (let o = 0; o < s.childNodes.length; o += 1) {
          const a = s.childNodes.item(o);
          if (a === null || a.nodeType !== ELEMENT_NODE)
            continue;
          if (elementTypeFromTagName(a) === KMLElementType.LinearRing) {
            if (e.outerRing !== void 0)
              throw new Error("Multiple LinearRing elements defined in outerBoundaryIs");
            {
              const u = this.parseLinearRing(a);
              if (u === void 0)
                throw new Error("Polygon outerBoundaryIs contains broken LinearRing");
              e.outerRing = u;
            }
            break;
          }
        }
        break;
      }
      case "innerBoundaryIs": {
        for (let o = 0; o < s.childNodes.length; o += 1) {
          const a = s.childNodes.item(o);
          if (a === null || a.nodeType !== ELEMENT_NODE)
            continue;
          if (elementTypeFromTagName(a) === KMLElementType.LinearRing) {
            const u = this.parseLinearRing(a);
            if (u === void 0)
              throw new Error("Polygon innerBoundaryIs contains broken LinearRing");
            e.innerRings.push(u);
            break;
          }
        }
        break;
      }
    }
  }
  tryLoadMultiGeometryField(e, s) {
    const o = elementTypeFromTagName(s);
    if (o !== void 0)
      if (isGeometryElement(o)) {
        const a = this.parseGeometry(s);
        a !== void 0 && e.geometries.push(a);
      } else
        throw new Error(`Unexpected '${s.tagName}' in MultiGeometry element`);
  }
  tryLoadStyleField(e, s) {
    const o = elementTypeFromTagName(s);
    if (o !== void 0)
      switch (o) {
        case KMLElementType.LineStyle:
          e.lineStyle = this.parseLineStyle(s);
          break;
        case KMLElementType.PolyStyle:
          e.polyStyle = this.parsePolyStyle(s);
          break;
        case KMLElementType.IconStyle:
          e.iconStyle = this.parseIconStyle(s);
          break;
        case KMLElementType.LabelStyle:
          e.labelStyle = this.parseLabelStyle(s);
          break;
        case KMLElementType.BalloonStyle:
          e.balloonStyle = this.parseBalloonStyle(s);
          break;
        case KMLElementType.ListStyle:
          e.listStyle = this.parseListStyle(s);
          break;
      }
  }
  tryLoadColorStyleField(e, s) {
    switch (s.tagName) {
      case "color": {
        e.color = readColor(s.textContent);
        break;
      }
      case "colorMode": {
        e.colorMode = readColorMode(s.textContent);
        break;
      }
    }
  }
  tryLoadLineStyleField(e, s) {
    switch (s.tagName) {
      case "width": {
        e.width = readFloat(s.textContent);
        break;
      }
    }
  }
  tryLoadPolyStyleField(e, s) {
    switch (s.tagName) {
      case "fill": {
        e.fill = readBooleanTextContent(s.textContent);
        break;
      }
      case "outline": {
        e.outline = readBooleanTextContent(s.textContent);
        break;
      }
    }
  }
  tryLoadIconStyleField(e, s) {
    switch (s.tagName) {
      case "scale": {
        e.scale = readFloat(s.textContent);
        break;
      }
      case "heading": {
        e.heading = readFloat(s.textContent);
        break;
      }
      case "Icon": {
        let o = null;
        for (let a = 0; a < s.childNodes.length; ++a) {
          const l = s.childNodes.item(a);
          if (l.nodeType === ELEMENT_NODE && l.nodeName === "href") {
            o = l;
            break;
          }
        }
        o !== null && o.textContent !== null && (e.icon = o.textContent.trim());
        break;
      }
      case "hotSpot": {
        let c = function(E) {
          return E !== null && E.textContent !== null;
        };
        const o = s.attributes.getNamedItem("x"), a = s.attributes.getNamedItem("y"), l = s.attributes.getNamedItem("xunits"), u = s.attributes.getNamedItem("yunits");
        c(o) && c(a) && c(l) && c(u) && (e.hotSpot.x = assertNaN(parseFloat(o.textContent.trim())), e.hotSpot.y = assertNaN(parseFloat(a.textContent.trim())), e.hotSpot.xUnits = readHotSpotUnits(l.textContent.trim()), e.hotSpot.yUnits = readHotSpotUnits(u.textContent.trim()));
        break;
      }
    }
  }
  tryLoadLabelStyleField(e, s) {
    switch (s.tagName) {
      case "scale": {
        e.scale = readFloat(s.textContent);
        break;
      }
    }
  }
  tryLoadBalloonStyleField(e, s) {
    switch (s.tagName) {
      case "bgColor": {
        e.bgColor = readColor(s.textContent);
        break;
      }
      case "textColor": {
        e.textColor = readColor(s.textContent);
        break;
      }
      case "text": {
        e.text = s.textContent || "";
        break;
      }
      case "displayMode": {
        e.displayMode = readDisplayMode(s.textContent);
        break;
      }
    }
  }
  tryLoadListStyleField(e, s) {
    switch (s.tagName) {
      case "bgColor": {
        e.bgColor = readColor(s.textContent);
        break;
      }
      case "listItemType": {
        e.listItemType = readListItemType(s.textContent);
        break;
      }
      case "ItemIcon": {
        let o = function(u) {
          return u !== null && u.textContent !== null;
        }, a = null;
        for (let u = 0; u < s.childNodes.length; ++u) {
          const c = s.childNodes.item(u);
          if (c.nodeType === ELEMENT_NODE && c.nodeName === "state") {
            a = c;
            break;
          }
        }
        let l = null;
        for (let u = 0; u < s.childNodes.length; ++u) {
          const c = s.childNodes.item(u);
          if (c.nodeType === ELEMENT_NODE && c.nodeName === "href") {
            l = c;
            break;
          }
        }
        o(a) && o(l) && e.icons.push({
          state: readIconState(a.textContent.trim()),
          href: l.textContent.trim()
        });
      }
    }
  }
  tryLoadStyleMapField(e, s) {
    switch (s.tagName) {
      case "Pair": {
        let o = function(c) {
          return c !== null && c.textContent !== null;
        }, a = null, l = null, u = null;
        for (let c = 0; c < s.childNodes.length; c += 1) {
          const E = s.childNodes.item(c);
          if (E !== null && E.nodeType === ELEMENT_NODE)
            switch (E.tagName) {
              case "key":
                a = E;
                break;
              case "styleUrl":
                l = E;
                break;
              case "Style":
                u = E;
                break;
            }
        }
        if (o(a) && o(l)) {
          const c = readStyleState(a.textContent);
          e.map.set(c, l.textContent.trim());
        } else if (o(a) && u !== null) {
          const c = readStyleState(a.textContent);
          e.map.set(c, this.parseStyle(u));
        }
        break;
      }
    }
  }
}
KMLParserSession._domParser = new DOMParser_1();
function readBooleanTextContent(r) {
  if (r !== null)
    switch (r) {
      case "0":
        return !1;
      case "1":
        return !0;
      default:
        throw new Error(`Invalid KML boolean field value '${r}'`);
    }
  else
    throw new Error("KML boolean field textContent empty");
}
function readAltitudeModeTextContent(r) {
  if (r !== null)
    switch (r) {
      case "clampedToGround":
      case "clampToGround":
        return AltitudeMode.ClampToGround;
      case "relativeToGround":
        return AltitudeMode.RelativeToGround;
      case "absolute":
        return AltitudeMode.Absolute;
      default:
        throw new Error(`Invalid KML altitudeMode field value '${r}'`);
    }
  else
    throw new Error("KML altitudeMode field textContent empty");
}
function readMultiLatLongAltTuple(r, e) {
  if (r !== null) {
    r = r.trim();
    const s = r.split(/\s+/g);
    return e !== void 0 && (s.length = e), s.map((o) => {
      const a = o.split(",");
      if (a === null || a.length < 2)
        throw new Error("KML");
      const l = assertNaN(parseFloat(a[0])), u = assertNaN(parseFloat(a[1])), c = a.length > 2 ? assertNaN(parseFloat(a[2])) : 0;
      return [l, u, c];
    });
  } else
    throw new Error("KML field textContent unexpectedly empty");
}
function readColor(r) {
  if (r !== null) {
    if (r = r.trim(), r.length !== 8)
      throw new Error("KML color field invalid");
    const e = r.match(/[\dA-Fa-f]{2}/g);
    if (e === null || e.length !== 4)
      throw new Error("KML color field invalid");
    const s = parseInt(e[3], 16), o = parseInt(e[2], 16), a = parseInt(e[1], 16), l = parseInt(e[0], 16);
    return [s, o, a, l];
  } else
    throw new Error("KML field textContent unexpectedly empty");
}
function readColorMode(r) {
  if (r !== null)
    switch (r) {
      case "normal":
        return ColorMode.Normal;
      case "random":
        return ColorMode.Random;
      default:
        return ColorMode.Normal;
    }
  else
    return ColorMode.Normal;
}
function readDisplayMode(r) {
  if (r !== null)
    switch (r) {
      case "default":
        return DisplayMode.Default;
      case "hide":
        return DisplayMode.Hide;
      default:
        return DisplayMode.Default;
    }
  else
    return DisplayMode.Default;
}
function readListItemType(r) {
  if (r !== null)
    switch (r) {
      case "check":
        return ListItemType.Check;
      case "checkOffOnly":
        return ListItemType.CheckOffOnly;
      case "checkHideChildren":
        return ListItemType.CheckHideChildren;
      case "radioFolder":
        return ListItemType.RadioFolder;
      default:
        return ListItemType.Check;
    }
  else
    return ListItemType.Check;
}
function readHotSpotUnits(r) {
  if (r !== null)
    switch (r) {
      case "fraction":
        return "fraction";
      case "pixels":
        return "pixels";
      case "insetPixels":
        return "insetPixels";
      default:
        return "fraction";
    }
  else
    return "fraction";
}
function readIconState(r) {
  if (r !== null)
    switch (r) {
      case "open":
        return IconState.Open;
      case "closed":
        return IconState.Closed;
      case "error":
        return IconState.Error;
      case "fetching0":
        return IconState.Fetching0;
      case "fetching1":
        return IconState.Fetching1;
      case "fetching2":
        return IconState.Fetching2;
      default:
        return IconState.Open;
    }
  else
    return IconState.Open;
}
function readStyleState(r) {
  if (r !== null)
    switch (r) {
      case "normal":
        return StyleState.Normal;
      case "highlight":
        return StyleState.Highlight;
      default:
        return StyleState.Normal;
    }
  else
    return StyleState.Normal;
}
function readFloat(r) {
  if (r !== null)
    return assertNaN(parseFloat(r.trim()));
  throw new Error("KML boolean field textContent empty");
}
function findChildElementByName$1(r, e) {
  for (let s = 0; s < r.childNodes.length; s += 1) {
    const o = r.childNodes.item(s);
    if (o !== null && o.nodeType === ELEMENT_NODE && o.tagName === e)
      return o;
  }
  return null;
}
function elementTypeFromTagName(r) {
  switch (r.tagName) {
    case "Document":
      return KMLElementType.Document;
    case "Folder":
      return KMLElementType.Folder;
    case "Placemark":
      return KMLElementType.Placemark;
    case "Point":
      return KMLElementType.Point;
    case "LineString":
      return KMLElementType.LineString;
    case "LinearRing":
      return KMLElementType.LinearRing;
    case "Polygon":
      return KMLElementType.Polygon;
    case "MultiGeometry":
      return KMLElementType.MultiGeometry;
    case "Style":
      return KMLElementType.Style;
    case "StyleMap":
      return KMLElementType.StyleMap;
    case "LineStyle":
      return KMLElementType.LineStyle;
    case "PolyStyle":
      return KMLElementType.PolyStyle;
    case "IconStyle":
      return KMLElementType.IconStyle;
    case "LabelStyle":
      return KMLElementType.LabelStyle;
    case "BalloonStyle":
      return KMLElementType.BalloonStyle;
    case "ListStyle":
      return KMLElementType.ListStyle;
    default:
      return;
  }
}
function isFeatureElement(r) {
  if (isContainerElement(r))
    return !0;
  switch (r) {
    case KMLElementType.Placemark:
      return !0;
    default:
      return !1;
  }
}
function isContainerElement(r) {
  switch (r) {
    case KMLElementType.Document:
    case KMLElementType.Folder:
      return !0;
    default:
      return !1;
  }
}
function isGeometryElement(r) {
  switch (r) {
    case KMLElementType.Point:
    case KMLElementType.LineString:
    case KMLElementType.LinearRing:
    case KMLElementType.Polygon:
    case KMLElementType.MultiGeometry:
      return !0;
    default:
      return !1;
  }
}
function isStyleSelectorElement(r) {
  switch (r) {
    case KMLElementType.Style:
    case KMLElementType.StyleMap:
      return !0;
    default:
      return !1;
  }
}
function insertNamespaces(r) {
  const e = {
    xsi: "http://www.w3.org/2001/XMLSchema-instance"
  };
  let s, o;
  for (const a in e)
    if (e.hasOwnProperty(a)) {
      const l = RegExp("[< ]" + a + ":"), u = "xmlns:" + a + "=";
      l.test(r) && r.indexOf(u) === -1 && (s == null && (s = r.substr(0, r.indexOf("<kml") + 4), o = r.substr(s.length)), s += " " + u + '"' + e[a] + '"');
    }
  return s != null && (r = s + o), r;
}
function assertNaN(r) {
  if (OptionsManager.DEBUG_KML_NAN_ASSERT) {
    if (isNaN(r))
      throw new Error("NaN");
    return r;
  } else
    return r;
}
var earcut$2 = { exports: {} };
earcut$2.exports = earcut;
earcut$2.exports.default = earcut;
function earcut(r, e, s) {
  s = s || 2;
  var o = e && e.length, a = o ? e[0] * s : r.length, l = linkedList(r, 0, a, s, !0), u = [];
  if (!l || l.next === l.prev)
    return u;
  var c, E, d, f, h, S, R;
  if (o && (l = eliminateHoles(r, e, l, s)), r.length > 80 * s) {
    c = d = r[0], E = f = r[1];
    for (var _ = s; _ < a; _ += s)
      h = r[_], S = r[_ + 1], h < c && (c = h), S < E && (E = S), h > d && (d = h), S > f && (f = S);
    R = Math.max(d - c, f - E), R = R !== 0 ? 32767 / R : 0;
  }
  return earcutLinked(l, u, s, c, E, R, 0), u;
}
function linkedList(r, e, s, o, a) {
  var l, u;
  if (a === signedArea(r, e, s, o) > 0)
    for (l = e; l < s; l += o)
      u = insertNode(l, r[l], r[l + 1], u);
  else
    for (l = s - o; l >= e; l -= o)
      u = insertNode(l, r[l], r[l + 1], u);
  return u && equals(u, u.next) && (removeNode(u), u = u.next), u;
}
function filterPoints(r, e) {
  if (!r)
    return r;
  e || (e = r);
  var s = r, o;
  do
    if (o = !1, !s.steiner && (equals(s, s.next) || area(s.prev, s, s.next) === 0)) {
      if (removeNode(s), s = e = s.prev, s === s.next)
        break;
      o = !0;
    } else
      s = s.next;
  while (o || s !== e);
  return e;
}
function earcutLinked(r, e, s, o, a, l, u) {
  if (r) {
    !u && l && indexCurve(r, o, a, l);
    for (var c = r, E, d; r.prev !== r.next; ) {
      if (E = r.prev, d = r.next, l ? isEarHashed(r, o, a, l) : isEar(r)) {
        e.push(E.i / s | 0), e.push(r.i / s | 0), e.push(d.i / s | 0), removeNode(r), r = d.next, c = d.next;
        continue;
      }
      if (r = d, r === c) {
        u ? u === 1 ? (r = cureLocalIntersections(filterPoints(r), e, s), earcutLinked(r, e, s, o, a, l, 2)) : u === 2 && splitEarcut(r, e, s, o, a, l) : earcutLinked(filterPoints(r), e, s, o, a, l, 1);
        break;
      }
    }
  }
}
function isEar(r) {
  var e = r.prev, s = r, o = r.next;
  if (area(e, s, o) >= 0)
    return !1;
  for (var a = e.x, l = s.x, u = o.x, c = e.y, E = s.y, d = o.y, f = a < l ? a < u ? a : u : l < u ? l : u, h = c < E ? c < d ? c : d : E < d ? E : d, S = a > l ? a > u ? a : u : l > u ? l : u, R = c > E ? c > d ? c : d : E > d ? E : d, _ = o.next; _ !== e; ) {
    if (_.x >= f && _.x <= S && _.y >= h && _.y <= R && pointInTriangle(a, c, l, E, u, d, _.x, _.y) && area(_.prev, _, _.next) >= 0)
      return !1;
    _ = _.next;
  }
  return !0;
}
function isEarHashed(r, e, s, o) {
  var a = r.prev, l = r, u = r.next;
  if (area(a, l, u) >= 0)
    return !1;
  for (var c = a.x, E = l.x, d = u.x, f = a.y, h = l.y, S = u.y, R = c < E ? c < d ? c : d : E < d ? E : d, _ = f < h ? f < S ? f : S : h < S ? h : S, m = c > E ? c > d ? c : d : E > d ? E : d, L = f > h ? f > S ? f : S : h > S ? h : S, F = zOrder(R, _, e, s, o), W = zOrder(m, L, e, s, o), G = r.prevZ, q = r.nextZ; G && G.z >= F && q && q.z <= W; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangle(c, f, E, h, d, S, G.x, G.y) && area(G.prev, G, G.next) >= 0 || (G = G.prevZ, q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangle(c, f, E, h, d, S, q.x, q.y) && area(q.prev, q, q.next) >= 0))
      return !1;
    q = q.nextZ;
  }
  for (; G && G.z >= F; ) {
    if (G.x >= R && G.x <= m && G.y >= _ && G.y <= L && G !== a && G !== u && pointInTriangle(c, f, E, h, d, S, G.x, G.y) && area(G.prev, G, G.next) >= 0)
      return !1;
    G = G.prevZ;
  }
  for (; q && q.z <= W; ) {
    if (q.x >= R && q.x <= m && q.y >= _ && q.y <= L && q !== a && q !== u && pointInTriangle(c, f, E, h, d, S, q.x, q.y) && area(q.prev, q, q.next) >= 0)
      return !1;
    q = q.nextZ;
  }
  return !0;
}
function cureLocalIntersections(r, e, s) {
  var o = r;
  do {
    var a = o.prev, l = o.next.next;
    !equals(a, l) && intersects(a, o, o.next, l) && locallyInside(a, l) && locallyInside(l, a) && (e.push(a.i / s | 0), e.push(o.i / s | 0), e.push(l.i / s | 0), removeNode(o), removeNode(o.next), o = r = l), o = o.next;
  } while (o !== r);
  return filterPoints(o);
}
function splitEarcut(r, e, s, o, a, l) {
  var u = r;
  do {
    for (var c = u.next.next; c !== u.prev; ) {
      if (u.i !== c.i && isValidDiagonal(u, c)) {
        var E = splitPolygon(u, c);
        u = filterPoints(u, u.next), E = filterPoints(E, E.next), earcutLinked(u, e, s, o, a, l, 0), earcutLinked(E, e, s, o, a, l, 0);
        return;
      }
      c = c.next;
    }
    u = u.next;
  } while (u !== r);
}
function eliminateHoles(r, e, s, o) {
  var a = [], l, u, c, E, d;
  for (l = 0, u = e.length; l < u; l++)
    c = e[l] * o, E = l < u - 1 ? e[l + 1] * o : r.length, d = linkedList(r, c, E, o, !1), d === d.next && (d.steiner = !0), a.push(getLeftmost(d));
  for (a.sort(compareX), l = 0; l < a.length; l++)
    s = eliminateHole(a[l], s);
  return s;
}
function compareX(r, e) {
  return r.x - e.x;
}
function eliminateHole(r, e) {
  var s = findHoleBridge(r, e);
  if (!s)
    return e;
  var o = splitPolygon(s, r);
  return filterPoints(o, o.next), filterPoints(s, s.next);
}
function findHoleBridge(r, e) {
  var s = e, o = r.x, a = r.y, l = -1 / 0, u;
  do {
    if (a <= s.y && a >= s.next.y && s.next.y !== s.y) {
      var c = s.x + (a - s.y) * (s.next.x - s.x) / (s.next.y - s.y);
      if (c <= o && c > l && (l = c, u = s.x < s.next.x ? s : s.next, c === o))
        return u;
    }
    s = s.next;
  } while (s !== e);
  if (!u)
    return null;
  var E = u, d = u.x, f = u.y, h = 1 / 0, S;
  s = u;
  do
    o >= s.x && s.x >= d && o !== s.x && pointInTriangle(a < f ? o : l, a, d, f, a < f ? l : o, a, s.x, s.y) && (S = Math.abs(a - s.y) / (o - s.x), locallyInside(s, r) && (S < h || S === h && (s.x > u.x || s.x === u.x && sectorContainsSector(u, s))) && (u = s, h = S)), s = s.next;
  while (s !== E);
  return u;
}
function sectorContainsSector(r, e) {
  return area(r.prev, r, e.prev) < 0 && area(e.next, r, r.next) < 0;
}
function indexCurve(r, e, s, o) {
  var a = r;
  do
    a.z === 0 && (a.z = zOrder(a.x, a.y, e, s, o)), a.prevZ = a.prev, a.nextZ = a.next, a = a.next;
  while (a !== r);
  a.prevZ.nextZ = null, a.prevZ = null, sortLinked(a);
}
function sortLinked(r) {
  var e, s, o, a, l, u, c, E, d = 1;
  do {
    for (s = r, r = null, l = null, u = 0; s; ) {
      for (u++, o = s, c = 0, e = 0; e < d && (c++, o = o.nextZ, !!o); e++)
        ;
      for (E = d; c > 0 || E > 0 && o; )
        c !== 0 && (E === 0 || !o || s.z <= o.z) ? (a = s, s = s.nextZ, c--) : (a = o, o = o.nextZ, E--), l ? l.nextZ = a : r = a, a.prevZ = l, l = a;
      s = o;
    }
    l.nextZ = null, d *= 2;
  } while (u > 1);
  return r;
}
function zOrder(r, e, s, o, a) {
  return r = (r - s) * a | 0, e = (e - o) * a | 0, r = (r | r << 8) & 16711935, r = (r | r << 4) & 252645135, r = (r | r << 2) & 858993459, r = (r | r << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, r | e << 1;
}
function getLeftmost(r) {
  var e = r, s = r;
  do
    (e.x < s.x || e.x === s.x && e.y < s.y) && (s = e), e = e.next;
  while (e !== r);
  return s;
}
function pointInTriangle(r, e, s, o, a, l, u, c) {
  return (a - u) * (e - c) >= (r - u) * (l - c) && (r - u) * (o - c) >= (s - u) * (e - c) && (s - u) * (l - c) >= (a - u) * (o - c);
}
function isValidDiagonal(r, e) {
  return r.next.i !== e.i && r.prev.i !== e.i && !intersectsPolygon(r, e) && // dones't intersect other edges
  (locallyInside(r, e) && locallyInside(e, r) && middleInside(r, e) && // locally visible
  (area(r.prev, r, e.prev) || area(r, e.prev, e)) || // does not create opposite-facing sectors
  equals(r, e) && area(r.prev, r, r.next) > 0 && area(e.prev, e, e.next) > 0);
}
function area(r, e, s) {
  return (e.y - r.y) * (s.x - e.x) - (e.x - r.x) * (s.y - e.y);
}
function equals(r, e) {
  return r.x === e.x && r.y === e.y;
}
function intersects(r, e, s, o) {
  var a = sign$1(area(r, e, s)), l = sign$1(area(r, e, o)), u = sign$1(area(s, o, r)), c = sign$1(area(s, o, e));
  return !!(a !== l && u !== c || a === 0 && onSegment(r, s, e) || l === 0 && onSegment(r, o, e) || u === 0 && onSegment(s, r, o) || c === 0 && onSegment(s, e, o));
}
function onSegment(r, e, s) {
  return e.x <= Math.max(r.x, s.x) && e.x >= Math.min(r.x, s.x) && e.y <= Math.max(r.y, s.y) && e.y >= Math.min(r.y, s.y);
}
function sign$1(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}
function intersectsPolygon(r, e) {
  var s = r;
  do {
    if (s.i !== r.i && s.next.i !== r.i && s.i !== e.i && s.next.i !== e.i && intersects(s, s.next, r, e))
      return !0;
    s = s.next;
  } while (s !== r);
  return !1;
}
function locallyInside(r, e) {
  return area(r.prev, r, r.next) < 0 ? area(r, e, r.next) >= 0 && area(r, r.prev, e) >= 0 : area(r, e, r.prev) < 0 || area(r, r.next, e) < 0;
}
function middleInside(r, e) {
  var s = r, o = !1, a = (r.x + e.x) / 2, l = (r.y + e.y) / 2;
  do
    s.y > l != s.next.y > l && s.next.y !== s.y && a < (s.next.x - s.x) * (l - s.y) / (s.next.y - s.y) + s.x && (o = !o), s = s.next;
  while (s !== r);
  return o;
}
function splitPolygon(r, e) {
  var s = new Node$1(r.i, r.x, r.y), o = new Node$1(e.i, e.x, e.y), a = r.next, l = e.prev;
  return r.next = e, e.prev = r, s.next = a, a.prev = s, o.next = s, s.prev = o, l.next = o, o.prev = l, o;
}
function insertNode(r, e, s, o) {
  var a = new Node$1(r, e, s);
  return o ? (a.next = o.next, a.prev = o, o.next.prev = a, o.next = a) : (a.prev = a, a.next = a), a;
}
function removeNode(r) {
  r.next.prev = r.prev, r.prev.next = r.next, r.prevZ && (r.prevZ.nextZ = r.nextZ), r.nextZ && (r.nextZ.prevZ = r.prevZ);
}
function Node$1(r, e, s) {
  this.i = r, this.x = e, this.y = s, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
earcut.deviation = function(r, e, s, o) {
  var a = e && e.length, l = a ? e[0] * s : r.length, u = Math.abs(signedArea(r, 0, l, s));
  if (a)
    for (var c = 0, E = e.length; c < E; c++) {
      var d = e[c] * s, f = c < E - 1 ? e[c + 1] * s : r.length;
      u -= Math.abs(signedArea(r, d, f, s));
    }
  var h = 0;
  for (c = 0; c < o.length; c += 3) {
    var S = o[c] * s, R = o[c + 1] * s, _ = o[c + 2] * s;
    h += Math.abs(
      (r[S] - r[_]) * (r[R + 1] - r[S + 1]) - (r[S] - r[R]) * (r[_ + 1] - r[S + 1])
    );
  }
  return u === 0 && h === 0 ? 0 : Math.abs((h - u) / u);
};
function signedArea(r, e, s, o) {
  for (var a = 0, l = e, u = s - o; l < s; l += o)
    a += (r[u] - r[l]) * (r[l + 1] + r[u + 1]), u = l;
  return a;
}
earcut.flatten = function(r) {
  for (var e = r[0][0].length, s = { vertices: [], holes: [], dimensions: e }, o = 0, a = 0; a < r.length; a++) {
    for (var l = 0; l < r[a].length; l++)
      for (var u = 0; u < e; u++)
        s.vertices.push(r[a][l][u]);
    a > 0 && (o += r[a - 1].length, s.holes.push(o));
  }
  return s;
};
var earcutExports = earcut$2.exports;
const earcut$1 = /* @__PURE__ */ getDefaultExportFromCjs(earcutExports), _box$1 = new Box3$1(), _vector = new Vector3$1();
class LineSegmentsGeometry extends InstancedBufferGeometry {
  constructor() {
    super(), this.isLineSegmentsGeometry = !0, this.type = "LineSegmentsGeometry";
    const e = [-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0], s = [-1, 2, 1, 2, -1, 1, 1, 1, -1, -1, 1, -1, -1, -2, 1, -2], o = [0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5];
    this.setIndex(o), this.setAttribute("position", new Float32BufferAttribute(e, 3)), this.setAttribute("uv", new Float32BufferAttribute(s, 2));
  }
  applyMatrix4(e) {
    const s = this.attributes.instanceStart, o = this.attributes.instanceEnd;
    return s !== void 0 && (s.applyMatrix4(e), o.applyMatrix4(e), s.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  setPositions(e) {
    let s;
    e instanceof Float32Array ? s = e : Array.isArray(e) && (s = new Float32Array(e));
    const o = new InstancedInterleavedBuffer(s, 6, 1);
    return this.setAttribute("instanceStart", new InterleavedBufferAttribute(o, 3, 0)), this.setAttribute("instanceEnd", new InterleavedBufferAttribute(o, 3, 3)), this.computeBoundingBox(), this.computeBoundingSphere(), this;
  }
  setColors(e) {
    let s;
    e instanceof Float32Array ? s = e : Array.isArray(e) && (s = new Float32Array(e));
    const o = new InstancedInterleavedBuffer(s, 6, 1);
    return this.setAttribute("instanceColorStart", new InterleavedBufferAttribute(o, 3, 0)), this.setAttribute("instanceColorEnd", new InterleavedBufferAttribute(o, 3, 3)), this;
  }
  fromWireframeGeometry(e) {
    return this.setPositions(e.attributes.position.array), this;
  }
  fromEdgesGeometry(e) {
    return this.setPositions(e.attributes.position.array), this;
  }
  fromMesh(e) {
    return this.fromWireframeGeometry(new WireframeGeometry(e.geometry)), this;
  }
  fromLineSegments(e) {
    const s = e.geometry;
    return this.setPositions(s.attributes.position.array), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Box3$1());
    const e = this.attributes.instanceStart, s = this.attributes.instanceEnd;
    e !== void 0 && s !== void 0 && (this.boundingBox.setFromBufferAttribute(e), _box$1.setFromBufferAttribute(s), this.boundingBox.union(_box$1));
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Sphere$1()), this.boundingBox === null && this.computeBoundingBox();
    const e = this.attributes.instanceStart, s = this.attributes.instanceEnd;
    if (e !== void 0 && s !== void 0) {
      const o = this.boundingSphere.center;
      this.boundingBox.getCenter(o);
      let a = 0;
      for (let l = 0, u = e.count; l < u; l++)
        _vector.fromBufferAttribute(e, l), a = Math.max(a, o.distanceToSquared(_vector)), _vector.fromBufferAttribute(s, l), a = Math.max(a, o.distanceToSquared(_vector));
      this.boundingSphere.radius = Math.sqrt(a), isNaN(this.boundingSphere.radius) && console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
    }
  }
  toJSON() {
  }
  applyMatrix(e) {
    return console.warn("THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4()."), this.applyMatrix4(e);
  }
}
const _start = new Vector3$1(), _end = new Vector3$1(), _start4 = new Vector4(), _end4 = new Vector4(), _ssOrigin = new Vector4(), _ssOrigin3 = new Vector3$1(), _mvMatrix = new Matrix4(), _line = new Line3(), _closestPoint = new Vector3$1(), _box = new Box3$1(), _sphere = new Sphere$1(), _clipToWorldVector = new Vector4();
let _ray, _lineWidth;
function getWorldSpaceHalfWidth(r, e, s) {
  return _clipToWorldVector.set(0, 0, -e, 1).applyMatrix4(r.projectionMatrix), _clipToWorldVector.multiplyScalar(1 / _clipToWorldVector.w), _clipToWorldVector.x = _lineWidth / s.width, _clipToWorldVector.y = _lineWidth / s.height, _clipToWorldVector.applyMatrix4(r.projectionMatrixInverse), _clipToWorldVector.multiplyScalar(1 / _clipToWorldVector.w), Math.abs(Math.max(_clipToWorldVector.x, _clipToWorldVector.y));
}
function raycastWorldUnits(r, e) {
  const s = r.matrixWorld, o = r.geometry, a = o.attributes.instanceStart, l = o.attributes.instanceEnd, u = Math.min(o.instanceCount, a.count);
  for (let c = 0, E = u; c < E; c++) {
    _line.start.fromBufferAttribute(a, c), _line.end.fromBufferAttribute(l, c), _line.applyMatrix4(s);
    const d = new Vector3$1(), f = new Vector3$1();
    _ray.distanceSqToSegment(_line.start, _line.end, f, d), f.distanceTo(d) < _lineWidth * 0.5 && e.push({
      point: f,
      pointOnLine: d,
      distance: _ray.origin.distanceTo(f),
      object: r,
      face: null,
      faceIndex: c,
      uv: null,
      uv1: null
    });
  }
}
function raycastScreenSpace(r, e, s) {
  const o = e.projectionMatrix, l = r.material.resolution, u = r.matrixWorld, c = r.geometry, E = c.attributes.instanceStart, d = c.attributes.instanceEnd, f = Math.min(c.instanceCount, E.count), h = -e.near;
  _ray.at(1, _ssOrigin), _ssOrigin.w = 1, _ssOrigin.applyMatrix4(e.matrixWorldInverse), _ssOrigin.applyMatrix4(o), _ssOrigin.multiplyScalar(1 / _ssOrigin.w), _ssOrigin.x *= l.x / 2, _ssOrigin.y *= l.y / 2, _ssOrigin.z = 0, _ssOrigin3.copy(_ssOrigin), _mvMatrix.multiplyMatrices(e.matrixWorldInverse, u);
  for (let S = 0, R = f; S < R; S++) {
    if (_start4.fromBufferAttribute(E, S), _end4.fromBufferAttribute(d, S), _start4.w = 1, _end4.w = 1, _start4.applyMatrix4(_mvMatrix), _end4.applyMatrix4(_mvMatrix), _start4.z > h && _end4.z > h)
      continue;
    if (_start4.z > h) {
      const G = _start4.z - _end4.z, q = (_start4.z - h) / G;
      _start4.lerp(_end4, q);
    } else if (_end4.z > h) {
      const G = _end4.z - _start4.z, q = (_end4.z - h) / G;
      _end4.lerp(_start4, q);
    }
    _start4.applyMatrix4(o), _end4.applyMatrix4(o), _start4.multiplyScalar(1 / _start4.w), _end4.multiplyScalar(1 / _end4.w), _start4.x *= l.x / 2, _start4.y *= l.y / 2, _end4.x *= l.x / 2, _end4.y *= l.y / 2, _line.start.copy(_start4), _line.start.z = 0, _line.end.copy(_end4), _line.end.z = 0;
    const m = _line.closestPointToPointParameter(_ssOrigin3, !0);
    _line.at(m, _closestPoint);
    const L = MathUtils$1.lerp(_start4.z, _end4.z, m), F = L >= -1 && L <= 1, W = _ssOrigin3.distanceTo(_closestPoint) < _lineWidth * 0.5;
    if (F && W) {
      _line.start.fromBufferAttribute(E, S), _line.end.fromBufferAttribute(d, S), _line.start.applyMatrix4(u), _line.end.applyMatrix4(u);
      const G = new Vector3$1(), q = new Vector3$1();
      _ray.distanceSqToSegment(_line.start, _line.end, q, G), s.push({
        point: q,
        pointOnLine: G,
        distance: _ray.origin.distanceTo(q),
        object: r,
        face: null,
        faceIndex: S,
        uv: null,
        uv1: null
      });
    }
  }
}
class LineSegments2 extends Mesh {
  constructor(e = new LineSegmentsGeometry(), s = new LineMaterial({ color: Math.random() * 16777215 })) {
    super(e, s), this.isLineSegments2 = !0, this.type = "LineSegments2";
  }
  // for backwards-compatibility, but could be a method of LineSegmentsGeometry...
  computeLineDistances() {
    const e = this.geometry, s = e.attributes.instanceStart, o = e.attributes.instanceEnd, a = new Float32Array(2 * s.count);
    for (let u = 0, c = 0, E = s.count; u < E; u++, c += 2)
      _start.fromBufferAttribute(s, u), _end.fromBufferAttribute(o, u), a[c] = c === 0 ? 0 : a[c - 1], a[c + 1] = a[c] + _start.distanceTo(_end);
    const l = new InstancedInterleavedBuffer(a, 2, 1);
    return e.setAttribute("instanceDistanceStart", new InterleavedBufferAttribute(l, 1, 0)), e.setAttribute("instanceDistanceEnd", new InterleavedBufferAttribute(l, 1, 1)), this;
  }
  raycast(e, s) {
    const o = this.material.worldUnits, a = e.camera;
    a === null && !o && console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
    const l = e.params.Line2 !== void 0 && e.params.Line2.threshold || 0;
    _ray = e.ray;
    const u = this.matrixWorld, c = this.geometry, E = this.material;
    _lineWidth = E.linewidth + l, c.boundingSphere === null && c.computeBoundingSphere(), _sphere.copy(c.boundingSphere).applyMatrix4(u);
    let d;
    if (o)
      d = _lineWidth * 0.5;
    else {
      const h = Math.max(a.near, _sphere.distanceToPoint(_ray.origin));
      d = getWorldSpaceHalfWidth(a, h, E.resolution);
    }
    if (_sphere.radius += d, _ray.intersectsSphere(_sphere) === !1)
      return;
    c.boundingBox === null && c.computeBoundingBox(), _box.copy(c.boundingBox).applyMatrix4(u);
    let f;
    if (o)
      f = _lineWidth * 0.5;
    else {
      const h = Math.max(a.near, _box.distanceToPoint(_ray.origin));
      f = getWorldSpaceHalfWidth(a, h, E.resolution);
    }
    _box.expandByScalar(f), _ray.intersectsBox(_box) !== !1 && (o ? raycastWorldUnits(this, s) : raycastScreenSpace(this, a, s));
  }
}
var hbjs$2 = { exports: {} };
function hbjs(r) {
  var e = r.exports, s = new Uint8Array(e.memory.buffer), o = new Uint32Array(e.memory.buffer), a = new Int32Array(e.memory.buffer), l = new Float32Array(e.memory.buffer), u = new TextDecoder("utf8"), c = 2;
  function E(_e) {
    return (_e.charCodeAt(0) & 255) << 24 | (_e.charCodeAt(1) & 255) << 16 | (_e.charCodeAt(2) & 255) << 8 | (_e.charCodeAt(3) & 255) << 0;
  }
  function d(_e) {
    return [
      String.fromCharCode(_e >> 24 & 255),
      String.fromCharCode(_e >> 16 & 255),
      String.fromCharCode(_e >> 8 & 255),
      String.fromCharCode(_e >> 0 & 255)
    ].join("");
  }
  function f(_e) {
    return _e == "BOT" ? 1 : _e == "EOT" ? 2 : _e == "PRESERVE_DEFAULT_IGNORABLES" ? 4 : _e == "REMOVE_DEFAULT_IGNORABLES" ? 8 : _e == "DO_NOT_INSERT_DOTTED_CIRCLE" ? 16 : 0;
  }
  function h(_e) {
    var Le = e.malloc(_e.byteLength);
    s.set(new Uint8Array(_e), Le);
    var Fe = e.hb_blob_create(Le, _e.byteLength, c, Le, e.free_ptr());
    return {
      ptr: Fe,
      /**
      * Free the object.
      */
      destroy: function() {
        e.hb_blob_destroy(Fe);
      }
    };
  }
  function S(_e, Le) {
    var Fe = e.hb_face_create(_e.ptr, Le);
    const Ee = e.hb_face_get_upem(Fe);
    return {
      ptr: Fe,
      upem: Ee,
      /**
       * Return the binary contents of an OpenType table.
       * @param {string} table Table name
       */
      reference_table: function(Ge) {
        var ve = e.hb_face_reference_table(Fe, E(Ge)), te = e.hb_blob_get_length(ve);
        if (te) {
          var ae = e.hb_blob_get_data(ve, null), v = s.subarray(ae, ae + te);
          return v;
        }
      },
      /**
       * Return variation axis infos
       */
      getAxisInfos: function() {
        var Ge = e.malloc(2048), ve = e.malloc(4);
        o[ve / 4] = 64, e.hb_ot_var_get_axis_infos(Fe, 0, ve, Ge);
        var te = {};
        return Array.from({ length: o[ve / 4] }).forEach(function(ae, v) {
          te[d(o[Ge / 4 + v * 8 + 1])] = {
            min: l[Ge / 4 + v * 8 + 4],
            default: l[Ge / 4 + v * 8 + 5],
            max: l[Ge / 4 + v * 8 + 6]
          };
        }), e.free(ve), e.free(Ge), te;
      },
      /**
       * Free the object.
       */
      destroy: function() {
        e.hb_face_destroy(Fe);
      }
    };
  }
  var R = 65536, _ = e.malloc(R);
  function m(_e) {
    var Le = e.hb_font_create(_e.ptr);
    function Fe(Ee) {
      var Ge = e.hbjs_glyph_svg(Le, Ee, _, R);
      return Ge > 0 ? u.decode(s.subarray(_, _ + Ge)) : "";
    }
    return {
      ptr: Le,
      glyphToPath: Fe,
      /**
      * Return a glyph as a JSON path string
      * based on format described on https://svgwg.org/specs/paths/#InterfaceSVGPathSegment
      * @param {number} glyphId ID of the requested glyph in the font.
      **/
      glyphToJson: function(Ee) {
        var Ge = Fe(Ee);
        return Ge.replace(/([MLQCZ])/g, "|$1 ").split("|").filter(function(ve) {
          return ve.length;
        }).map(function(ve) {
          var te = ve.split(/[ ,]/g);
          return { type: te[0], values: te.slice(1).filter(function(ae) {
            return ae.length;
          }).map(function(ae) {
            return +ae;
          }) };
        });
      },
      /**
      * Set the font's scale factor, affecting the position values returned from
      * shaping.
      * @param {number} xScale Units to scale in the X dimension.
      * @param {number} yScale Units to scale in the Y dimension.
      **/
      setScale: function(Ee, Ge) {
        e.hb_font_set_scale(Le, Ee, Ge);
      },
      /**
       * Set the font's variations.
       * @param {object} variations Dictionary of variations to set
       **/
      setVariations: function(Ee) {
        var Ge = Object.entries(Ee), ve = e.malloc(8 * Ge.length);
        Ge.forEach(function(te, ae) {
          o[ve / 4 + ae * 2 + 0] = E(te[0]), l[ve / 4 + ae * 2 + 1] = te[1];
        }), e.hb_font_set_variations(Le, ve, Ge.length), e.free(ve);
      },
      /**
      * Free the object.
      */
      destroy: function() {
        e.hb_font_destroy(Le);
      }
    };
  }
  var L = new TextEncoder("utf8");
  function F(_e) {
    var Le = L.encode(_e), Fe = e.malloc(Le.byteLength);
    return s.set(Le, Fe), {
      ptr: Fe,
      length: Le.byteLength,
      free: function() {
        e.free(Fe);
      }
    };
  }
  function W(_e) {
    const Le = e.malloc(_e.length * 2), Fe = new Uint16Array(e.memory.buffer, Le, _e.length);
    for (let Ee = 0; Ee < Fe.length; ++Ee)
      Fe[Ee] = _e.charCodeAt(Ee);
    return {
      ptr: Le,
      length: Fe.length,
      free: function() {
        e.free(Le);
      }
    };
  }
  function G() {
    var _e = e.hb_buffer_create();
    return {
      ptr: _e,
      /**
      * Add text to the buffer.
      * @param {string} text Text to be added to the buffer.
      **/
      addText: function(Le) {
        const Fe = W(Le);
        e.hb_buffer_add_utf16(_e, Fe.ptr, Fe.length, 0, Fe.length), Fe.free();
      },
      /**
      * Set buffer script, language and direction.
      *
      * This needs to be done before shaping.
      **/
      guessSegmentProperties: function() {
        return e.hb_buffer_guess_segment_properties(_e);
      },
      /**
      * Set buffer direction explicitly.
      * @param {string} direction: One of "ltr", "rtl", "ttb" or "btt"
      */
      setDirection: function(Le) {
        e.hb_buffer_set_direction(_e, {
          ltr: 4,
          rtl: 5,
          ttb: 6,
          btt: 7
        }[Le] || 0);
      },
      /**
      * Set buffer flags explicitly.
      * @param {string[]} flags: A list of strings which may be either:
      * "BOT"
      * "EOT"
      * "PRESERVE_DEFAULT_IGNORABLES"
      * "REMOVE_DEFAULT_IGNORABLES"
      * "DO_NOT_INSERT_DOTTED_CIRCLE"
      */
      setFlags: function(Le) {
        var Fe = 0;
        Le.forEach(function(Ee) {
          Fe |= f(Ee);
        }), e.hb_buffer_set_flags(_e, Fe);
      },
      /**
      * Set buffer language explicitly.
      * @param {string} language: The buffer language
      */
      setLanguage: function(Le) {
        var Fe = F(Le);
        e.hb_buffer_set_language(_e, e.hb_language_from_string(Fe.ptr, -1)), Fe.free();
      },
      /**
      * Set buffer script explicitly.
      * @param {string} script: The buffer script
      */
      setScript: function(Le) {
        var Fe = F(Le);
        e.hb_buffer_set_script(_e, e.hb_script_from_string(Fe.ptr, -1)), Fe.free();
      },
      /**
      * Set the Harfbuzz clustering level.
      *
      * Affects the cluster values returned from shaping.
      * @param {number} level: Clustering level. See the Harfbuzz manual chapter
      * on Clusters.
      **/
      setClusterLevel: function(Le) {
        e.hb_buffer_set_cluster_level(_e, Le);
      },
      /**
      * Return the buffer contents as a JSON object.
      *
      * After shaping, this function will return an array of glyph information
      * objects. Each object will have the following attributes:
      *
      *   - g: The glyph ID
      *   - cl: The cluster ID
      *   - ax: Advance width (width to advance after this glyph is painted)
      *   - ay: Advance height (height to advance after this glyph is painted)
      *   - dx: X displacement (adjustment in X dimension when painting this glyph)
      *   - d5: Y displacement (adjustment in Y dimension when painting this glyph)
      **/
      json: function(Le) {
        for (var Fe = e.hb_buffer_get_length(_e), Ee = [], Ge = e.hb_buffer_get_glyph_infos(_e, 0) / 4, ve = e.hb_buffer_get_glyph_positions(_e, 0) / 4, te = o.subarray(Ge, Ge + 5 * Fe), ae = a.subarray(ve, ve + 5 * Fe), v = 0; v < Fe; ++v)
          Ee.push({
            g: te[v * 5 + 0],
            cl: te[v * 5 + 2],
            ax: ae[v * 5 + 0],
            ay: ae[v * 5 + 1],
            dx: ae[v * 5 + 2],
            dy: ae[v * 5 + 3]
          });
        return Ee;
      },
      /**
      * Free the object.
      */
      destroy: function() {
        e.hb_buffer_destroy(_e);
      }
    };
  }
  function q(_e, Le, Fe) {
    e.hb_shape(_e.ptr, Le.ptr, 0, 0);
  }
  function fe(_e, Le, Fe, Ee, Ge) {
    var ve = 1048576, te = e.malloc(ve), ae = F(Fe), v = e.hbjs_shape_with_trace(_e.ptr, Le.ptr, ae.ptr, Ee, Ge, te, ve);
    ae.free();
    var Te = u.decode(s.subarray(te, te + v - 1));
    return e.free(te), JSON.parse(Te);
  }
  return {
    createBlob: h,
    createFace: S,
    createFont: m,
    createBuffer: G,
    shape: q,
    shapeWithTrace: fe
  };
}
try {
  hbjs$2.exports = hbjs;
} catch (r) {
}
var hbjsExports = hbjs$2.exports;
const hbjs$1 = /* @__PURE__ */ getDefaultExportFromCjs(hbjsExports);
var __awaiter$M = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class HarfBuzz {
  /**
   * Returns the loaded module, or throws if the module is not yet initialized yet.
   *
   * As long as this is called after the 'HarfBuzz.init' promise has resolved then this will never throw.
   *
   * A renderer should initialize this very early so rendering systems can just assume the module is present to avoid
   * polluting synchronous code with async just to lazily load the module.
   */
  static get module() {
    if (this.state.loaded !== void 0)
      return this.state.loaded;
    throw new Error("Tried to get harfbuzz module when it is not yet initialized");
  }
  /**
   * Takes a path string produced by HarfBuzzFont.glyphToFont and decodes the string into an array of objects for more
   * easily consuming the path.
   *
   * This is takend directly from the implementation of HarfBuzzFont.glyphToJson.
   *
   * @param path
   */
  static pathStringToObject(e) {
    return e.replace(/([MLQCZ])/g, "|$1 ").split("|").filter((s) => s.length).map((s) => {
      const o = s.split(/[ ,]/g);
      return {
        type: o[0],
        values: o.slice(1).filter((a) => a.length).map((a) => +a)
      };
    });
  }
  /**
   * Internal function for initializing the module
   * @private
   */
  static init(e) {
    return __awaiter$M(this, void 0, void 0, function* () {
      if (this.state.loaded !== void 0)
        return this.state.loaded;
      if (this.state.inFlight === void 0) {
        const s = () => __awaiter$M(this, void 0, void 0, function* () {
          const a = yield (yield fetch(e ?? "hb.wasm")).arrayBuffer(), l = yield WebAssembly.instantiate(a);
          return l.instance.exports.memory.grow(400), hbjs$1(l.instance);
        });
        this.state.inFlight = s();
      }
      return this.state.loaded = yield this.state.inFlight, this.state.loaded;
    });
  }
}
HarfBuzz.state = {};
class PreparingObject extends Object3D {
  /**
   * This function will be called exactly once per frame, before the call to WebGLRenderer.render which drives
   * rendering this object.
   *
   * The intended use of this callback is to allow objects to modify their Object3D.children array directly prior to
   * rendering.
   *
   * @param renderer The renderer the object will be rendered with
   * @param camera The camera the object is being rendered from
   * @param frameData FrameData object
   */
  // tslint:disable-next-line:no-empty
  prepare(e, s, o) {
  }
}
class LabelCollection extends PreparingObject {
  /**
   * Constructs a new LabelCollection. A GlyphCache is required as it will be used to source glyph textures.
   * @param glyphCache The glyph cache for the font all labels in the collection will share.
   */
  constructor(e) {
    super(), this.labels = [], this.needsUpdate = !0, this.meshes = [], this._opacity = 1, this.transformAtlas = {
      size: 2048,
      texture: null
    }, this.frustumCulled = !1, this.glyphCache = e;
  }
  /**
   * Returns the maximum number of labels that the collection can hold.
   *
   * This upper limit is constrained by WebGL and GPU support.
   */
  get maxLabelNum() {
    return 2048 * 2048;
  }
  /**
   * Force a build of all the text rendering data, if an update is required.
   *
   * Useful for eating the build cost upfront rather than lazily on first render.
   */
  prepare() {
    this.needsUpdate && this.rebuildImpl();
  }
  get opacity() {
    return this._opacity;
  }
  set opacity(e) {
    this._opacity = e;
    for (const s of this.meshes)
      s.material.opacity = e, s.material.needsUpdate = !0;
  }
  rebuildImpl() {
    this.transformAtlas.size = this.selectTransformAtlasSize();
    const e = new Float32Array(this.transformAtlas.size * this.transformAtlas.size * 4), s = [];
    for (let o = 0; o < this.labels.length; o += 1) {
      const a = this.labels[o];
      e[o * 4 + 0] = a.position.x, e[o * 4 + 1] = a.position.y, e[o * 4 + 2] = a.position.z;
      const l = this.shapeLabelText(a);
      this.generateGlyphInstanceData(o, l, s);
    }
    if (this.transformAtlas.texture !== null && this.transformAtlas.texture.dispose(), this.transformAtlas.texture = new DataTexture(e, this.transformAtlas.size, this.transformAtlas.size, RGBAFormat, FloatType), this.transformAtlas.texture.needsUpdate = !0, this.meshes.length > 0) {
      this.clear();
      for (const o of this.meshes)
        o.material.dispose(), o.geometry.dispose();
      this.meshes.length = 0;
    }
    for (let o = 0; o < this.glyphCache.textureCount; o += 1) {
      const a = new InstancedBufferGeometry(), l = s[o];
      a.instanceCount = l.numGlyphs, a.setAttribute("position", new Float32BufferAttribute(LabelCollection.PLANE_NUMS, 3, !1)), a.setIndex([0, 1, 2, 0, 2, 3]), a.setAttribute("skGlyphBoundingBox", new InstancedBufferAttribute(new Float32Array(l.glyphBoundingBoxes), 4, !1)), a.setAttribute("skGlyphTexCoords", new InstancedBufferAttribute(new Float32Array(l.glyphTexCoords), 4, !1)), a.setAttribute("skGlyphLabelIndex", new InstancedBufferAttribute(new Float32Array(l.glyphLabelIndices), 1, !1));
      const u = new Mesh(a, new LabelCollectionMaterial({
        map: this.glyphCache.getTexture(o),
        transformAtlas: this.transformAtlas.texture,
        transparent: !0,
        depthWrite: !1,
        depthTest: !1,
        strokeWidth: 40,
        glyphScale: 2e-5,
        opacity: this._opacity
      }));
      u.frustumCulled = !1, this.meshes.push(u), this.add(u);
    }
    this.needsUpdate = !1;
  }
  /**
   * Internal function for selecting a transform atlas texture size based on the number of labels in the collection.
   *
   * We pick the smallest possible atlas size that fits all the labels to avoid allocating a 2048*2048 texture for
   * 100 labels. A 2048*2048 R32G32B32_SFLOAT texture consumes ~50MB of memory, so we should only eat the cost if we
   * have to.
   * @private
   */
  selectTransformAtlasSize() {
    const e = [
      [4, 2],
      [16, 4],
      [64, 8],
      [256, 16],
      [1024, 32],
      [4096, 64],
      [16384, 128],
      [65536, 256],
      [262144, 512],
      [1048576, 1024],
      [4194304, 2048]
    ];
    for (const [s, o] of e)
      if (this.labels.length <= s)
        return o;
    throw new Error("Exceeded maximum number of labels in a single LabelCollection");
  }
  shapeLabelText(e) {
    const s = HarfBuzz.module.createBuffer();
    s.addText(e.text), s.guessSegmentProperties(), HarfBuzz.module.shape(this.glyphCache.font, s);
    const o = s.json();
    return s.destroy(), o;
  }
  generateGlyphInstanceData(e, s, o) {
    let a = 0, l = 0;
    for (const u of s) {
      const c = this.glyphCache.addGlyph(u.g);
      if (c.atlasIndex >= o.length)
        for (let R = c.atlasIndex; R < this.glyphCache.textureCount; R += 1)
          o.push({
            numGlyphs: 0,
            glyphBoundingBoxes: [],
            glyphTexCoords: [],
            glyphLabelIndices: []
          });
      const E = o[c.atlasIndex];
      E.numGlyphs += 1;
      const d = c.sdfViewBox[2] - c.sdfViewBox[0], f = c.sdfViewBox[3] - c.sdfViewBox[1], h = a + u.dx + c.sdfViewBox[0], S = l + u.dy + c.sdfViewBox[1];
      E.glyphBoundingBoxes.push(h), E.glyphBoundingBoxes.push(S), E.glyphBoundingBoxes.push(d), E.glyphBoundingBoxes.push(f), E.glyphTexCoords.push(c.x / this.glyphCache.size), E.glyphTexCoords.push(c.y / this.glyphCache.size), E.glyphTexCoords.push(c.w / this.glyphCache.size), E.glyphTexCoords.push(c.h / this.glyphCache.size), E.glyphLabelIndices.push(e), a += u.ax, l += u.ay;
    }
  }
}
LabelCollection.PLANE_NUMS = [0, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0];
class ShelfPack {
  /**
   * Create a new ShelfPack bin allocator.
   *
   * @param  w Width of the sprite
   * @param  h Height of the sprite
   * @example
   * var sprite = new ShelfPack(64, 64, { autoResize: false });
   */
  constructor(e = 64, s = 64) {
    this.shelves = [], this.freeBins = [], this.stats = {}, this.bins = {}, this.maxId = 0, this.w = e, this.h = s;
  }
  /**
   * Batch pack multiple bins into the sprite.
   *
   * @param   bins       Array of requested bins
   * @returns Array of allocated Bins - each Bin is an object with `id`, `x`, `y`, `w`, `h` properties
   * @example
   * var bins = [
   *     { id: 1, w: 12, h: 12 },
   *     { id: 2, w: 12, h: 16 },
   *     { id: 3, w: 12, h: 24 }
   * ];
   * var results = sprite.pack(bins);
   */
  pack(e) {
    e = [...e];
    const s = [];
    for (const o of e) {
      const a = this.packOne(o.w, o.h, o.id);
      a && s.push(a);
    }
    return s;
  }
  /**
   * Pack a single bin into the sprite.
   *
   * Each bin will have a unique identitifer.
   * If no identifier is supplied in the `id` parameter, one will be created.
   * Note: The supplied `id` is used as an object index, so numeric values are fastest!
   *
   * Bins are automatically refcounted (i.e. a newly packed Bin will have a refcount of 1).
   * When a bin is no longer needed, use the `ShelfPack.unref` function to mark it
   *   as unused.  When a Bin's refcount decrements to 0, the Bin will be marked
   *   as free and its space may be reused by the packing code.
   *
   * @param    w      Width of the bin to allocate
   * @param    h      Height of the bin to allocate
   * @param    id     Unique identifier for this bin, (if unsupplied, assume it's a new bin and create an id)
   * @returns  Bin object with `id`, `x`, `y`, `w`, `h` properties, or `null` if allocation failed
   * @example
   * var results = sprite.packOne(12, 16, 'a');
   */
  packOne(e, s, o) {
    const a = { freebin: -1, shelf: -1, waste: 1 / 0 };
    if (typeof o == "string" || typeof o == "number") {
      const u = this.getBin(o);
      if (u)
        return this.ref(u), u;
      typeof o == "number" && (this.maxId = Math.max(o, this.maxId));
    } else
      o = ++this.maxId;
    for (let u = 0; u < this.freeBins.length; u++) {
      const c = this.freeBins[u];
      if (s === c.maxh && e === c.maxw)
        return this.allocFreebin(u, e, s, o);
      if (!(s > c.maxh || e > c.maxw) && s <= c.maxh && e <= c.maxw) {
        const E = c.maxw * c.maxh - e * s;
        E < a.waste && (a.waste = E, a.freebin = u);
      }
    }
    let l = 0;
    for (let u = 0; u < this.shelves.length; u++) {
      const c = this.shelves[u];
      if (l += c.h, !(e > c.free)) {
        if (s === c.h)
          return this.allocShelf(u, e, s, o);
        if (!(s > c.h) && s < c.h) {
          const E = (c.h - s) * e;
          E < a.waste && (a.freebin = -1, a.waste = E, a.shelf = u);
        }
      }
    }
    if (a.freebin !== -1)
      return this.allocFreebin(a.freebin, e, s, o);
    if (a.shelf !== -1)
      return this.allocShelf(a.shelf, e, s, o);
    if (s <= this.h - l && e <= this.w) {
      const u = new Shelf(l, this.w, s);
      return this.allocShelf(this.shelves.push(u) - 1, e, s, o);
    }
    return null;
  }
  /**
   * Called by packOne() to allocate a bin by reusing an existing freebin
   *
   * @private
   * @param    index  Index into the `this.freeBins` array
   * @param    w      Width of the bin to allocate
   * @param    h      Height of the bin to allocate
   * @param    id     Unique identifier for this bin
   * @returns  Bin object with `id`, `x`, `y`, `w`, `h` properties
   * @example
   * var bin = sprite.allocFreebin(0, 12, 16, 'a');
   */
  allocFreebin(e, s, o, a) {
    const l = this.freeBins.splice(e, 1)[0];
    return l.id = a, l.w = s, l.h = o, l.refcount = 0, this.bins[a] = l, this.ref(l), l;
  }
  /**
   * Called by `packOne() to allocate bin on an existing shelf
   *
   * @private
   * @param    index  Index into the `this.shelves` array
   * @param    w      Width of the bin to allocate
   * @param    h      Height of the bin to allocate
   * @param    id     Unique identifier for this bin
   * @returns  Bin object with `id`, `x`, `y`, `w`, `h` properties
   * @example
   * var results = sprite.allocShelf(0, 12, 16, 'a');
   */
  allocShelf(e, s, o, a) {
    const u = this.shelves[e].alloc(s, o, a);
    return u !== null && (this.bins[a] = u, this.ref(u)), u;
  }
  /**
   * Return a packed bin given its id, or undefined if the id is not found
   *
   * @param    id  Unique identifier for this bin,
   * @returns  The requested bin, or undefined if not yet packed
   * @example
   * var b = sprite.getBin('a');
   */
  getBin(e) {
    return this.bins[e];
  }
  /**
   * Increment the ref count of a bin and update statistics.
   *
   * @param    bin  Bin instance
   * @returns  New refcount of the bin
   * @example
   * var bin = sprite.getBin('a');
   * sprite.ref(bin);
   */
  ref(e) {
    if (++e.refcount === 1) {
      const s = e.h;
      this.stats[s] = (this.stats[s] | 0) + 1;
    }
    return e.refcount;
  }
  /**
   * Decrement the ref count of a bin and update statistics.
   * The bin will be automatically marked as free space once the refcount reaches 0.
   *
   * @param    bin  Bin instance
   * @returns  New refcount of the bin
   * @example
   * var bin = sprite.getBin('a');
   * sprite.unref(bin);
   */
  unref(e) {
    return e.refcount === 0 ? 0 : (--e.refcount === 0 && (this.stats[e.h]--, delete this.bins[e.id], this.freeBins.push(e)), e.refcount);
  }
  /**
   * Clear the sprite.  Resets everything and resets statistics.
   *
   * @example
   * sprite.clear();
   */
  clear() {
    this.shelves = [], this.freeBins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
  }
}
class Shelf {
  /**
   * Create a new Shelf.
   *
   * @param  {number}  y   Top coordinate of the new shelf
   * @param  {number}  w   Width of the new shelf
   * @param  {number}  h   Height of the new shelf
   * @example
   * var shelf = new Shelf(64, 512, 24);
   */
  constructor(e, s, o) {
    this.x = 0, this.y = e, this.w = s, this.free = s, this.h = o;
  }
  /**
   * Allocate a single bin into the shelf.
   *
   * @param   w   Width of the bin to allocate
   * @param   h   Height of the bin to allocate
   * @param   id  Unique id of the bin to allocate
   * @returns Bin object with `id`, `x`, `y`, `w`, `h` properties, or `null` if allocation failed
   * @example
   * shelf.alloc(12, 16, 'a');
   */
  alloc(e, s, o) {
    if (e > this.free || s > this.h)
      return null;
    const a = this.x;
    return this.x += e, this.free -= e, createBin(o, a, this.y, e, s, e, this.h);
  }
  /**
   * Resize the shelf.
   *
   * @param   w  Requested new width of the shelf
   * @returns true
   * @example
   * shelf.resize(512);
   */
  resize(e) {
    return this.free += e - this.w, this.w = e, !0;
  }
}
function createBin(r, e, s, o, a, l, u) {
  return {
    id: r,
    x: e,
    y: s,
    w: o,
    h: a,
    maxw: l || o,
    maxh: u || a,
    refcount: 0
  };
}
class FontAtlasPacker {
  /**
   * Constructs a new FontAtlasPacker that will manage packing rectangles into multiple atlas textures.
   *
   * All atlas textures will be the same size (width x height).
   *
   * @param width The width each atlas texture will be
   * @param height The height each atlas texture will be
   */
  constructor(e, s) {
    this.pages = [], this._width = e, this._height = s;
  }
  /**
   * Takes an array of rectangles and packs them into the underlying shelves. There is no guarantee all requested
   * rectangles will be packed into the same atlas textures. Make sure to check 'atlasIndex' for each output rectangle
   * to know which atlas the rectangle was packed into.
   *
   * @param bins Array of rectangles to pack
   */
  pack(e) {
    this.pages.length === 0 && this.pages.push(new ShelfPack(this._width, this._height)), e = [...e];
    const s = [];
    for (const o of e) {
      let a = !1;
      for (let l = this.pages.length - 1; l >= 0; l += 1) {
        const c = this.pages[l].packOne(o.w, o.h, o.id);
        if (c) {
          s.push(Object.assign({ atlasIndex: l }, c)), a = !0;
          break;
        }
      }
      if (!a) {
        const l = new ShelfPack(this._width, this._height), u = l.packOne(o.w, o.h, o.id);
        if (u)
          s.push(Object.assign({ atlasIndex: this.pages.length }, u)), this.pages.push(l);
        else
          throw new Error("Rectangle too large to allocate");
      }
    }
    return s;
  }
  get numPages() {
    return this.pages.length;
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
}
function SDFGenerator$1() {
  var r = function(e) {
    function s(ke, Be, Me, me, Se, xt, Ht, Bt) {
      var ut = 1 - Ht;
      Bt.x = ut * ut * ke + 2 * ut * Ht * Me + Ht * Ht * Se, Bt.y = ut * ut * Be + 2 * ut * Ht * me + Ht * Ht * xt;
    }
    function o(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt) {
      var Yt = 1 - ut;
      Tt.x = Yt * Yt * Yt * ke + 3 * Yt * Yt * ut * Me + 3 * Yt * ut * ut * Se + ut * ut * ut * Ht, Tt.y = Yt * Yt * Yt * Be + 3 * Yt * Yt * ut * me + 3 * Yt * ut * ut * xt + ut * ut * ut * Bt;
    }
    function a(ke, Be) {
      for (var Me = /([MLQCZ])([^MLQCZ]*)/g, me, Se, xt, Ht, Bt; me = Me.exec(ke); ) {
        var ut = me[2].replace(/^\s*|\s*$/g, "").split(/[,\s]+/).map(function(Tt) {
          return parseFloat(Tt);
        });
        switch (me[1]) {
          case "M":
            Ht = Se = ut[0], Bt = xt = ut[1];
            break;
          case "L":
            (ut[0] !== Ht || ut[1] !== Bt) && Be("L", Ht, Bt, Ht = ut[0], Bt = ut[1]);
            break;
          case "Q": {
            Be("Q", Ht, Bt, Ht = ut[2], Bt = ut[3], ut[0], ut[1]);
            break;
          }
          case "C": {
            Be("C", Ht, Bt, Ht = ut[4], Bt = ut[5], ut[0], ut[1], ut[2], ut[3]);
            break;
          }
          case "Z":
            (Ht !== Se || Bt !== xt) && Be("L", Ht, Bt, Se, xt);
            break;
        }
      }
    }
    function l(ke, Be, Me) {
      Me === void 0 && (Me = 16);
      var me = { x: 0, y: 0 };
      a(ke, function(Se, xt, Ht, Bt, ut, Tt, Yt, an, Ct) {
        switch (Se) {
          case "L":
            Be(xt, Ht, Bt, ut);
            break;
          case "Q": {
            for (var st = xt, jt = Ht, lt = 1; lt < Me; lt++)
              s(
                xt,
                Ht,
                Tt,
                Yt,
                Bt,
                ut,
                lt / (Me - 1),
                me
              ), Be(st, jt, me.x, me.y), st = me.x, jt = me.y;
            break;
          }
          case "C": {
            for (var Zt = xt, Et = Ht, Ke = 1; Ke < Me; Ke++)
              o(
                xt,
                Ht,
                Tt,
                Yt,
                an,
                Ct,
                Bt,
                ut,
                Ke / (Me - 1),
                me
              ), Be(Zt, Et, me.x, me.y), Zt = me.x, Et = me.y;
            break;
          }
        }
      });
    }
    var u = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", c = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}", E = /* @__PURE__ */ new WeakMap(), d = {
      premultipliedAlpha: !1,
      preserveDrawingBuffer: !0,
      antialias: !1,
      depth: !1
    };
    function f(ke, Be) {
      var Me = ke.getContext ? ke.getContext("webgl", d) : ke, me = E.get(Me);
      if (!me) {
        let Yt = function(Zt) {
          var Et = xt[Zt];
          if (!Et && (Et = xt[Zt] = Me.getExtension(Zt), !Et))
            throw new Error(Zt + " not supported");
          return Et;
        }, an = function(Zt, Et) {
          var Ke = Me.createShader(Et);
          return Me.shaderSource(Ke, Zt), Me.compileShader(Ke), Ke;
        }, Ct = function(Zt, Et, Ke, $e) {
          if (!Ht[Zt]) {
            var pt = {}, Jt = {}, In = Me.createProgram();
            Me.attachShader(In, an(Et, Me.VERTEX_SHADER)), Me.attachShader(In, an(Ke, Me.FRAGMENT_SHADER)), Me.linkProgram(In), Ht[Zt] = {
              program: In,
              transaction: function(It) {
                Me.useProgram(In), It({
                  setUniform: function(Wt, hn) {
                    for (var Vt = [], Tn = arguments.length - 2; Tn-- > 0; )
                      Vt[Tn] = arguments[Tn + 2];
                    var Rn = Jt[hn] || (Jt[hn] = Me.getUniformLocation(In, hn));
                    Me["uniform" + Wt].apply(Me, [Rn].concat(Vt));
                  },
                  setAttribute: function(Wt, hn, Vt, Tn, Rn) {
                    var Nn = pt[Wt];
                    Nn || (Nn = pt[Wt] = {
                      buf: Me.createBuffer(),
                      // TODO should we destroy our buffers?
                      loc: Me.getAttribLocation(In, Wt),
                      data: null
                    }), Me.bindBuffer(Me.ARRAY_BUFFER, Nn.buf), Me.vertexAttribPointer(Nn.loc, hn, Me.FLOAT, !1, 0, 0), Me.enableVertexAttribArray(Nn.loc), Se ? Me.vertexAttribDivisor(Nn.loc, Tn) : Yt("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(Nn.loc, Tn), Rn !== Nn.data && (Me.bufferData(Me.ARRAY_BUFFER, Rn, Vt), Nn.data = Rn);
                  }
                });
              }
            };
          }
          Ht[Zt].transaction($e);
        }, st = function(Zt, Et) {
          ut++;
          try {
            Me.activeTexture(Me.TEXTURE0 + ut);
            var Ke = Bt[Zt];
            Ke || (Ke = Bt[Zt] = Me.createTexture(), Me.bindTexture(Me.TEXTURE_2D, Ke), Me.texParameteri(Me.TEXTURE_2D, Me.TEXTURE_MIN_FILTER, Me.NEAREST), Me.texParameteri(Me.TEXTURE_2D, Me.TEXTURE_MAG_FILTER, Me.NEAREST)), Me.bindTexture(Me.TEXTURE_2D, Ke), Et(Ke, ut);
          } finally {
            ut--;
          }
        }, jt = function(Zt, Et, Ke) {
          var $e = Me.createFramebuffer();
          Tt.push($e), Me.bindFramebuffer(Me.FRAMEBUFFER, $e), Me.activeTexture(Me.TEXTURE0 + Et), Me.bindTexture(Me.TEXTURE_2D, Zt), Me.framebufferTexture2D(Me.FRAMEBUFFER, Me.COLOR_ATTACHMENT0, Me.TEXTURE_2D, Zt, 0);
          try {
            Ke($e);
          } finally {
            Me.deleteFramebuffer($e), Me.bindFramebuffer(Me.FRAMEBUFFER, Tt[--Tt.length - 1] || null);
          }
        }, lt = function() {
          xt = {}, Ht = {}, Bt = {}, ut = -1, Tt.length = 0;
        };
        var Se = typeof WebGL2RenderingContext < "u" && Me instanceof WebGL2RenderingContext, xt = {}, Ht = {}, Bt = {}, ut = -1, Tt = [];
        Me.canvas.addEventListener("webglcontextlost", function(Zt) {
          lt(), Zt.preventDefault();
        }, !1), E.set(Me, me = {
          gl: Me,
          isWebGL2: Se,
          getExtension: Yt,
          withProgram: Ct,
          withTexture: st,
          withTextureFramebuffer: jt,
          handleContextLoss: lt
        });
      }
      Be(me);
    }
    function h(ke, Be, Me, me, Se, xt, Ht, Bt) {
      Ht === void 0 && (Ht = 15), Bt === void 0 && (Bt = null), f(ke, function(ut) {
        var Tt = ut.gl, Yt = ut.withProgram, an = ut.withTexture;
        an("copy", function(Ct, st) {
          Tt.texImage2D(Tt.TEXTURE_2D, 0, Tt.RGBA, Se, xt, 0, Tt.RGBA, Tt.UNSIGNED_BYTE, Be), Yt("copy", u, c, function(jt) {
            var lt = jt.setUniform, Zt = jt.setAttribute;
            Zt("aUV", 2, Tt.STATIC_DRAW, 0, new Float32Array([0, 0, 2, 0, 0, 2])), lt("1i", "image", st), Tt.bindFramebuffer(Tt.FRAMEBUFFER, Bt || null), Tt.disable(Tt.BLEND), Tt.colorMask(Ht & 8, Ht & 4, Ht & 2, Ht & 1), Tt.viewport(Me, me, Se, xt), Tt.scissor(Me, me, Se, xt), Tt.drawArrays(Tt.TRIANGLES, 0, 3);
          });
        });
      });
    }
    function S(ke, Be, Me) {
      var me = ke.width, Se = ke.height;
      f(ke, function(xt) {
        var Ht = xt.gl, Bt = new Uint8Array(me * Se * 4);
        Ht.readPixels(0, 0, me, Se, Ht.RGBA, Ht.UNSIGNED_BYTE, Bt), ke.width = Be, ke.height = Me, h(Ht, Bt, 0, 0, me, Se);
      });
    }
    var R = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      withWebGLContext: f,
      renderImageData: h,
      resizeWebGLCanvasWithoutClearing: S
    });
    function _(ke, Be, Me, me, Se, xt) {
      xt === void 0 && (xt = 1);
      var Ht = new Uint8Array(ke * Be), Bt = me[2] - me[0], ut = me[3] - me[1], Tt = [];
      l(Me, function(Zt, Et, Ke, $e) {
        Tt.push({
          x1: Zt,
          y1: Et,
          x2: Ke,
          y2: $e,
          minX: Math.min(Zt, Ke),
          minY: Math.min(Et, $e),
          maxX: Math.max(Zt, Ke),
          maxY: Math.max(Et, $e)
        });
      }), Tt.sort(function(Zt, Et) {
        return Zt.maxX - Et.maxX;
      });
      for (var Yt = 0; Yt < ke; Yt++)
        for (var an = 0; an < Be; an++) {
          var Ct = jt(
            me[0] + Bt * (Yt + 0.5) / ke,
            me[1] + ut * (an + 0.5) / Be
          ), st = Math.pow(1 - Math.abs(Ct) / Se, xt) / 2;
          Ct < 0 && (st = 1 - st), st = Math.max(0, Math.min(255, Math.round(st * 255))), Ht[an * ke + Yt] = st;
        }
      return Ht;
      function jt(Zt, Et) {
        for (var Ke = 1 / 0, $e = 1 / 0, pt = Tt.length; pt--; ) {
          var Jt = Tt[pt];
          if (Jt.maxX + $e <= Zt)
            break;
          if (Zt + $e > Jt.minX && Et - $e < Jt.maxY && Et + $e > Jt.minY) {
            var In = F(Zt, Et, Jt.x1, Jt.y1, Jt.x2, Jt.y2);
            In < Ke && (Ke = In, $e = Math.sqrt(Ke));
          }
        }
        return lt(Zt, Et) && ($e = -$e), $e;
      }
      function lt(Zt, Et) {
        for (var Ke = 0, $e = Tt.length; $e--; ) {
          var pt = Tt[$e];
          if (pt.maxX <= Zt)
            break;
          var Jt = pt.y1 > Et != pt.y2 > Et && Zt < (pt.x2 - pt.x1) * (Et - pt.y1) / (pt.y2 - pt.y1) + pt.x1;
          Jt && (Ke += pt.y1 < pt.y2 ? 1 : -1);
        }
        return Ke !== 0;
      }
    }
    function m(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt) {
      xt === void 0 && (xt = 1), Bt === void 0 && (Bt = 0), ut === void 0 && (ut = 0), Tt === void 0 && (Tt = 0), L(ke, Be, Me, me, Se, xt, Ht, null, Bt, ut, Tt);
    }
    function L(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt, Yt) {
      xt === void 0 && (xt = 1), ut === void 0 && (ut = 0), Tt === void 0 && (Tt = 0), Yt === void 0 && (Yt = 0);
      for (var an = _(ke, Be, Me, me, Se, xt), Ct = new Uint8Array(an.length * 4), st = 0; st < an.length; st++)
        Ct[st * 4 + Yt] = an[st];
      h(Ht, Ct, ut, Tt, ke, Be, 1 << 3 - Yt, Bt);
    }
    function F(ke, Be, Me, me, Se, xt) {
      var Ht = Se - Me, Bt = xt - me, ut = Ht * Ht + Bt * Bt, Tt = ut ? Math.max(0, Math.min(1, ((ke - Me) * Ht + (Be - me) * Bt) / ut)) : 0, Yt = ke - (Me + Tt * Ht), an = Be - (me + Tt * Bt);
      return Yt * Yt + an * an;
    }
    var W = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      generate: _,
      generateIntoCanvas: m,
      generateIntoFramebuffer: L
    }), G = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", q = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}", fe = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}", _e = new Float32Array([0, 0, 2, 0, 0, 2]), Le = null, Fe = !1, Ee = {}, Ge = /* @__PURE__ */ new WeakMap();
    function ve(ke) {
      if (!Fe && !Te(ke))
        throw new Error("WebGL generation not supported");
    }
    function te(ke, Be, Me, me, Se, xt, Ht) {
      if (xt === void 0 && (xt = 1), Ht === void 0 && (Ht = null), !Ht && (Ht = Le, !Ht)) {
        var Bt = typeof OffscreenCanvas == "function" ? new OffscreenCanvas(1, 1) : typeof document < "u" ? document.createElement("canvas") : null;
        if (!Bt)
          throw new Error("OffscreenCanvas or DOM canvas not supported");
        Ht = Le = Bt.getContext("webgl", { depth: !1 });
      }
      ve(Ht);
      var ut = new Uint8Array(ke * Be * 4);
      f(Ht, function(Ct) {
        var st = Ct.gl, jt = Ct.withTexture, lt = Ct.withTextureFramebuffer;
        jt("readable", function(Zt, Et) {
          st.texImage2D(st.TEXTURE_2D, 0, st.RGBA, ke, Be, 0, st.RGBA, st.UNSIGNED_BYTE, null), lt(Zt, Et, function(Ke) {
            v(
              ke,
              Be,
              Me,
              me,
              Se,
              xt,
              st,
              Ke,
              0,
              0,
              0
              // red channel
            ), st.readPixels(0, 0, ke, Be, st.RGBA, st.UNSIGNED_BYTE, ut);
          });
        });
      });
      for (var Tt = new Uint8Array(ke * Be), Yt = 0, an = 0; Yt < ut.length; Yt += 4)
        Tt[an++] = ut[Yt];
      return Tt;
    }
    function ae(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt) {
      xt === void 0 && (xt = 1), Bt === void 0 && (Bt = 0), ut === void 0 && (ut = 0), Tt === void 0 && (Tt = 0), v(ke, Be, Me, me, Se, xt, Ht, null, Bt, ut, Tt);
    }
    function v(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt, Yt) {
      xt === void 0 && (xt = 1), ut === void 0 && (ut = 0), Tt === void 0 && (Tt = 0), Yt === void 0 && (Yt = 0), ve(Ht);
      var an = [];
      l(Me, function(Ct, st, jt, lt) {
        an.push(Ct, st, jt, lt);
      }), an = new Float32Array(an), f(Ht, function(Ct) {
        var st = Ct.gl, jt = Ct.isWebGL2, lt = Ct.getExtension, Zt = Ct.withProgram, Et = Ct.withTexture, Ke = Ct.withTextureFramebuffer, $e = Ct.handleContextLoss;
        if (Et("rawDistances", function(pt, Jt) {
          (ke !== pt._lastWidth || Be !== pt._lastHeight) && st.texImage2D(
            st.TEXTURE_2D,
            0,
            st.RGBA,
            pt._lastWidth = ke,
            pt._lastHeight = Be,
            0,
            st.RGBA,
            st.UNSIGNED_BYTE,
            null
          ), Zt("main", G, q, function(In) {
            var Cn = In.setAttribute, It = In.setUniform, ht = !jt && lt("ANGLE_instanced_arrays"), Wt = !jt && lt("EXT_blend_minmax");
            Cn("aUV", 2, st.STATIC_DRAW, 0, _e), Cn("aLineSegment", 4, st.DYNAMIC_DRAW, 1, an), It.apply(void 0, ["4f", "uGlyphBounds"].concat(me)), It("1f", "uMaxDistance", Se), It("1f", "uExponent", xt), Ke(pt, Jt, function(hn) {
              st.enable(st.BLEND), st.colorMask(!0, !0, !0, !0), st.viewport(0, 0, ke, Be), st.scissor(0, 0, ke, Be), st.blendFunc(st.ONE, st.ONE), st.blendEquationSeparate(st.FUNC_ADD, jt ? st.MAX : Wt.MAX_EXT), st.clear(st.COLOR_BUFFER_BIT), jt ? st.drawArraysInstanced(st.TRIANGLES, 0, 3, an.length / 4) : ht.drawArraysInstancedANGLE(st.TRIANGLES, 0, 3, an.length / 4);
            });
          }), Zt("post", u, fe, function(In) {
            In.setAttribute("aUV", 2, st.STATIC_DRAW, 0, _e), In.setUniform("1i", "tex", Jt), st.bindFramebuffer(st.FRAMEBUFFER, Bt), st.disable(st.BLEND), st.colorMask(Yt === 0, Yt === 1, Yt === 2, Yt === 3), st.viewport(ut, Tt, ke, Be), st.scissor(ut, Tt, ke, Be), st.drawArrays(st.TRIANGLES, 0, 3);
          });
        }), st.isContextLost())
          throw $e(), new Error("webgl context lost");
      });
    }
    function Te(ke) {
      var Be = !ke || ke === Le ? Ee : ke.canvas || ke, Me = Ge.get(Be);
      if (Me === void 0) {
        Fe = !0;
        var me = null;
        try {
          var Se = [
            97,
            106,
            97,
            61,
            99,
            137,
            118,
            80,
            80,
            118,
            137,
            99,
            61,
            97,
            106,
            97
          ], xt = te(
            4,
            4,
            "M8,8L16,8L24,24L16,24Z",
            [0, 0, 32, 32],
            24,
            1,
            ke
          );
          Me = xt && Se.length === xt.length && xt.every(function(Ht, Bt) {
            return Ht === Se[Bt];
          }), Me || (me = "bad trial run results", console.info(Se, xt));
        } catch (Ht) {
          Me = !1, me = Ht.message;
        }
        me && console.warn("WebGL SDF generation not supported:", me), Fe = !1, Ge.set(Be, Me);
      }
      return Me;
    }
    var De = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      generate: te,
      generateIntoCanvas: ae,
      generateIntoFramebuffer: v,
      isSupported: Te
    });
    function be(ke, Be, Me, me, Se, xt) {
      Se === void 0 && (Se = Math.max(me[2] - me[0], me[3] - me[1]) / 2), xt === void 0 && (xt = 1);
      try {
        return te.apply(De, arguments);
      } catch (Ht) {
        return console.info("WebGL SDF generation failed, falling back to JS", Ht), _.apply(W, arguments);
      }
    }
    function ze(ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt) {
      Se === void 0 && (Se = Math.max(me[2] - me[0], me[3] - me[1]) / 2), xt === void 0 && (xt = 1), Bt === void 0 && (Bt = 0), ut === void 0 && (ut = 0), Tt === void 0 && (Tt = 0);
      try {
        return ae.apply(De, arguments);
      } catch (Yt) {
        return console.info("WebGL SDF generation failed, falling back to JS", Yt), m.apply(W, arguments);
      }
    }
    return e.forEachPathCommand = a, e.generate = be, e.generateIntoCanvas = ze, e.javascript = W, e.pathToLineSegments = l, e.webgl = De, e.webglUtils = R, Object.defineProperty(e, "__esModule", { value: !0 }), e;
  }({});
  return r;
}
class SDFGenerator {
  static get module() {
    return this.MODULE === null && (this.MODULE = SDFGenerator$1()), this.MODULE;
  }
}
SDFGenerator.MODULE = null;
class GlyphCache {
  /**
   *
   * @param font Reference to the font that the GlyphCache will be caching glyphs for
   * @param size The side length each atlas texture will have
   * @param glyphSize The width/height of each glyph in the glyph cache
   */
  constructor(e, s, o) {
    this.glyphs = /* @__PURE__ */ new Map(), this.textures = [], this.font = e, this.glyphSize = o, this.packer = new FontAtlasPacker(s, s);
  }
  get size() {
    return this.packer.width;
  }
  /**
   * Adds the given glyph into the cache, if it is not already present in the cache. Will return either the existing
   * glyph or a newly rendered one if it wasn't already cached.
   * @param glyphId
   */
  addGlyph(e) {
    const s = this.glyphs.get(e);
    if (s !== void 0)
      return s;
    {
      const o = this.packer.pack([
        {
          id: e,
          w: this.glyphSize,
          h: this.glyphSize
        }
      ])[0];
      this.addTextureIfNeeded(o);
      const a = this.font.glyphToPath(e), l = HarfBuzz.pathStringToObject(a), { xMin: u, yMin: c, xMax: E, yMax: d } = calculatePathBounds(l), f = Math.max(E - u, d - c) / this.glyphSize * (GlyphCache.SDF_MARGIN * this.glyphSize + 0.5), h = Object.assign({ path: a, pathBounds: [u, c, E, d], sdfViewBox: [
        u - f,
        c - f,
        E + f,
        d + f
      ] }, o);
      return this.glyphs.set(e, h), this.renderGlyphIntoCanvas(h), h;
    }
  }
  /**
   * Returns the texture for the corresponding atlas index
   * @param i
   */
  getTexture(e) {
    return this.textures[e];
  }
  /**
   * Returns the number of backing atlas textures the atlas is currently using
   */
  get textureCount() {
    return this.textures.length;
  }
  /**
   * Internal function for adding new canvas textures to the atlas when needed
   * @param packResult
   * @private
   */
  addTextureIfNeeded(e) {
    if (e.atlasIndex >= this.textures.length) {
      const s = document.createElement("canvas").getContext("webgl");
      s.canvas.width = this.packer.width, s.canvas.height = this.packer.height, this.textures.push(new CanvasTexture(s.canvas, void 0, void 0, void 0, LinearFilter, LinearFilter));
    }
  }
  /**
   * Internal function for rendering a glyph into the canvas
   * @param glyph
   * @private
   */
  renderGlyphIntoCanvas(e) {
    const s = Math.max(e.sdfViewBox[2] - e.sdfViewBox[0], e.sdfViewBox[3] - e.sdfViewBox[1]);
    SDFGenerator.module.generateIntoCanvas(this.glyphSize, this.glyphSize, e.path, e.sdfViewBox, s, 9, this.textures[e.atlasIndex].image, e.x, e.y, 0), this.textures[e.atlasIndex].needsUpdate = !0;
  }
}
GlyphCache.SDF_MARGIN = 1 / 16;
function calculatePathBounds(r) {
  let e, s, o, a;
  if (r.length) {
    e = 1 / 0, s = 1 / 0, o = -1 / 0, a = -1 / 0;
    for (const l of r)
      switch (l.type) {
        case "M":
        case "L":
        case "Q":
        case "C": {
          const u = l.values[0], c = l.values[1];
          e = Math.min(e, u), s = Math.min(s, c), o = Math.max(o, u), a = Math.max(a, c);
          break;
        }
      }
  } else
    e = o = s = a = 0;
  return { xMin: e, yMin: s, xMax: o, yMax: a };
}
var __awaiter$L = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class KmlLoader {
  static load(e, s) {
    return __awaiter$L(this, void 0, void 0, function* () {
      const o = yield FileLoader.loadText(e, {
        headers: s.headers,
        cacheKey: s.cacheKey,
        cache: !0
      }), a = new KMLParserSession(), l = a.parseText(o);
      if (l === void 0)
        return;
      const u = {
        points: {
          labels: [],
          min: new Vector3$1(1 / 0, 1 / 0, 1 / 0),
          max: new Vector3$1(-1 / 0, -1 / 0, -1 / 0)
        },
        lines: /* @__PURE__ */ new Map(),
        polys: {
          positions: [],
          colours: [],
          indices: [],
          min: new Vector3$1(1 / 0, 1 / 0, 1 / 0),
          max: new Vector3$1(-1 / 0, -1 / 0, -1 / 0)
        }
      }, c = new Object3D();
      this.convertContainer(a, u, l), this.convertPointGeometryToObject(u.points, c, s.glyphCache), this.convertPolyGeometryToObject(u.polys, c), this.convertLinesGeometryToObject(u.lines, c);
      const E = [];
      return u.points.min.lengthSq() < 1 / 0 && E.push(u.points.min), u.points.max.lengthSq() < 1 / 0 && E.push(u.points.max), { object: c, labelPositions: E };
    });
  }
  static convertContainer(e, s, o) {
    const a = [o];
    for (; a.length > 0; ) {
      const l = a.pop();
      for (const u of l.features)
        u.isContainerElement ? a.push(u) : u.isFeatureElement && u.elementType === KMLElementType.Placemark && this.convertPlacemark(e, s, u);
    }
  }
  static convertPlacemark(e, s, o) {
    const a = {
      elementType: KMLElementType.Style,
      isColorStyle: !1,
      isContainerElement: !1,
      isFeatureElement: !1,
      isGeometryElement: !1,
      isStyleSelector: !0
    };
    o.styleUri !== void 0 && this.resolveStyleReferenceChain(e, a, o.styleUri);
    for (const u of o.styleSelectors)
      if (u.elementType === KMLElementType.Style) {
        const c = u;
        this.overlayStyle(e, a, c);
      }
    const l = {
      pointName: o.name,
      lineWidth: this.selectLineWidth(a),
      fill: this.selectFillEnabled(a),
      outline: this.selectOutlineEnabled(a),
      lineColour: this.selectLineColour(a),
      fillColour: this.selectFillColour(a),
      points: s.points,
      lines: s.lines,
      polys: s.polys
    };
    for (const u of o.geometries)
      this.convertGeometry(e, l, u);
  }
  static convertGeometry(e, s, o) {
    switch (o.elementType) {
      case KMLElementType.Point:
        this.convertPoint(e, s, o);
        break;
      case KMLElementType.LineString:
        this.convertLineStringOrLinearRing(e, s, o);
        break;
      case KMLElementType.LinearRing:
        this.convertLineStringOrLinearRing(e, s, o);
        break;
      case KMLElementType.Polygon:
        this.convertPolygon(e, s, o);
        break;
      case KMLElementType.MultiGeometry:
        this.convertMultiGeometry(e, s, o);
        break;
      default:
        throw new Error("Element is not a Geometry element");
    }
  }
  static convertPoint(e, s, o) {
    var a;
    if (s.pointName !== void 0) {
      const l = (a = o.altitudeMode) !== null && a !== void 0 ? a : AltitudeMode.ClampToGround, u = new Vector3$1(), c = {
        text: s.pointName,
        position: u
      }, E = new Cartographic$1(), d = l === AltitudeMode.ClampToGround ? 0 : o.coordinates[2], f = OptionsManager.KML_HEIGHT_OFFSET + OptionsManager.KML_TEXT_HEIGHT_OFFSET;
      E.set(MathUtils.degreesToRadians(o.coordinates[0]), MathUtils.degreesToRadians(o.coordinates[1]), d + f), Ellipsoid$1.WGS_84.cartesianForCartographic(E, u), s.points.min.min(u), s.points.max.max(u), s.points.labels.push(c);
    }
  }
  static convertLineStringOrLinearRing(e, s, o) {
    var a;
    const l = (a = o.altitudeMode) !== null && a !== void 0 ? a : AltitudeMode.ClampToGround, u = this.getOrAddLinesGeometry(s, s.lineWidth);
    this.addLinearRingGeometry(u, l, s, o.coordinates);
  }
  static convertPolygon(e, s, o) {
    s.fill && this.convertPolygonFill(e, s, o), s.outline && this.convertPolygonOutline(e, s, o);
  }
  static convertPolygonFill(e, s, o) {
    var a;
    const l = (a = o.altitudeMode) !== null && a !== void 0 ? a : AltitudeMode.ClampToGround, u = [o.outerRing.coordinates];
    for (const L of o.innerRings)
      u.push(L.coordinates);
    const c = earcut$1.flatten(u), E = earcut$1(c.vertices, c.holes, c.dimensions), d = c.vertices.length / 3, f = new Cartographic$1(), h = new Vector3$1(), S = new Vector3$1(1 / 0, 1 / 0, 1 / 0), R = new Vector3$1(-1 / 0, -1 / 0, -1 / 0), _ = new Array(d * 4);
    for (let L = 0; L < d; L += 1) {
      const F = l === AltitudeMode.ClampToGround ? 0 : c.vertices[L * 3 + 2];
      f.set(MathUtils.degreesToRadians(c.vertices[L * 3 + 0]), MathUtils.degreesToRadians(c.vertices[L * 3 + 1]), F + OptionsManager.KML_HEIGHT_OFFSET), Ellipsoid$1.WGS_84.cartesianForCartographic(f, h), S.min(h), R.max(h), c.vertices[L * 3 + 0] = h.x, c.vertices[L * 3 + 1] = h.y, c.vertices[L * 3 + 2] = h.z, _[L * 4 + 0] = s.fillColour[0], _[L * 4 + 1] = s.fillColour[1], _[L * 4 + 2] = s.fillColour[2], _[L * 4 + 3] = s.fillColour[3];
    }
    s.polys.min.min(S), s.polys.max.max(R);
    const m = s.polys.positions.length / 3;
    s.polys.positions.push(...c.vertices), s.polys.colours.push(..._), s.polys.indices.push(...E.map((L) => L + m));
  }
  static convertPolygonOutline(e, s, o) {
    var a;
    const l = (a = o.altitudeMode) !== null && a !== void 0 ? a : AltitudeMode.ClampToGround, u = this.getOrAddLinesGeometry(s, s.lineWidth);
    this.addLinearRingGeometry(u, l, s, o.outerRing.coordinates);
    for (const c of o.innerRings)
      this.addLinearRingGeometry(u, l, s, c.coordinates);
  }
  static addLinearRingGeometry(e, s, o, a) {
    const [l, u, c, E] = this.readLineStringLike(s, a, o.lineColour), d = l.length - 3, f = new Array(2 * d), h = new Array(2 * d);
    for (let S = 0; S < d; S += 3)
      f[2 * S + 0] = l[S + 0], f[2 * S + 1] = l[S + 1], f[2 * S + 2] = l[S + 2], f[2 * S + 3] = l[S + 3], f[2 * S + 4] = l[S + 4], f[2 * S + 5] = l[S + 5], h[2 * S + 0] = u[S + 0], h[2 * S + 1] = u[S + 1], h[2 * S + 2] = u[S + 2], h[2 * S + 3] = u[S + 3], h[2 * S + 4] = u[S + 4], h[2 * S + 5] = u[S + 5];
    e.min.min(c), e.max.max(E);
    for (const S of f)
      e.positions.push(S);
    for (const S of h)
      e.colours.push(S);
  }
  static convertMultiGeometry(e, s, o) {
    for (const a of o.geometries)
      this.convertGeometry(e, s, a);
  }
  static selectLineWidth(e) {
    return e.lineStyle !== void 0 ? e.lineStyle.width : 1;
  }
  static selectOutlineEnabled(e) {
    return e.polyStyle !== void 0 ? e.polyStyle.outline : !0;
  }
  static selectFillEnabled(e) {
    return e.polyStyle !== void 0 ? e.polyStyle.fill : !0;
  }
  static selectLineColour(e) {
    return e.lineStyle !== void 0 ? e.lineStyle.color : [1, 1, 1, 1];
  }
  static selectFillColour(e) {
    return e.polyStyle !== void 0 ? e.polyStyle.color : [1, 1, 1, 1];
  }
  static readLineStringLike(e, s, o) {
    const a = new Vector3$1(1 / 0, 1 / 0, 1 / 0), l = new Vector3$1(-1 / 0, -1 / 0, -1 / 0), u = new Cartographic$1(), c = new Vector3$1(), E = new Array(s.length * 3), d = new Array(s.length * 3);
    for (let f = 0; f < s.length; f += 1) {
      const h = e === AltitudeMode.ClampToGround ? 0 : s[f][2];
      u.set(MathUtils.degreesToRadians(s[f][0]), MathUtils.degreesToRadians(s[f][1]), h + OptionsManager.KML_HEIGHT_OFFSET), Ellipsoid$1.WGS_84.cartesianForCartographic(u, c), a.min(c), l.max(c), E[f * 3 + 0] = c.x, E[f * 3 + 1] = c.y, E[f * 3 + 2] = c.z, d[f * 3 + 0] = o[0], d[f * 3 + 1] = o[1], d[f * 3 + 2] = o[2];
    }
    return [E, d, a, l];
  }
  static applyCenterOffset(e, s) {
    for (let o = 0; o < e.length; o += 3)
      e[o + 0] = e[o + 0] - s.x, e[o + 1] = e[o + 1] - s.y, e[o + 2] = e[o + 2] - s.z;
  }
  static convertPointGeometryToObject(e, s, o) {
    if (e.labels.length > 0) {
      const a = e.min, l = e.max, u = a.clone().add(l).divideScalar(2);
      for (const E of e.labels)
        E.position.x -= u.x, E.position.y -= u.y, E.position.z -= u.z;
      const c = new LabelCollection(o);
      c.position.copy(u), c.labels.push(...e.labels), s.add(c);
    }
  }
  static convertPolyGeometryToObject(e, s) {
    if (e.positions.length === 0)
      return;
    const o = e.min, a = e.max, l = o.clone().add(a).divideScalar(2);
    this.applyCenterOffset(e.positions, l);
    const u = new BufferGeometry();
    u.setAttribute("position", new Float32BufferAttribute(e.positions, 3, !1)), u.setAttribute("color", new Uint8BufferAttribute(e.colours, 4, !0)), u.setIndex(e.indices);
    const c = new Mesh(u, this.MESHMAT);
    c.position.copy(l), s.add(c);
  }
  static convertLinesGeometryToObject(e, s) {
    e.forEach((o, a) => {
      if (o.positions.length === 0)
        return;
      const l = o.min, u = o.max, c = l.clone().add(u).divideScalar(2);
      this.applyCenterOffset(o.positions, c);
      const E = new LineSegmentsGeometry();
      E.setPositions(o.positions), E.setColors(o.colours);
      const d = new LineSegments2(E, o.material);
      d.computeLineDistances(), d.position.copy(c), s.add(d);
    });
  }
  static getOrAddLinesGeometry(e, s) {
    const o = e.lines.get(s);
    if (o === void 0) {
      const a = {
        material: new PickingLineMaterial({
          vertexColors: !0,
          linewidth: MathUtils$1.clamp(s / 2, 1, 1 / 0),
          worldUnits: !1
        }),
        positions: [],
        colours: [],
        min: new Vector3$1(1 / 0, 1 / 0, 1 / 0),
        max: new Vector3$1(-1 / 0, -1 / 0, -1 / 0)
      };
      return e.lines.set(s, a), a;
    } else
      return o;
  }
  static resolveStyleReferenceChain(e, s, o) {
    if (o.startsWith("#")) {
      const l = o.split("#")[1], u = e.objectsById.get(l);
      if (u !== void 0) {
        if (u.elementType === KMLElementType.Style) {
          const c = u;
          this.overlayStyle(e, s, c);
        } else if (u.elementType === KMLElementType.StyleMap) {
          const c = u;
          this.overlayStyleMap(e, s, c);
        }
      }
    }
  }
  static overlayStyle(e, s, o) {
    s.iconStyle = o.iconStyle, s.labelStyle = o.labelStyle, s.lineStyle = o.lineStyle, s.polyStyle = o.polyStyle, s.balloonStyle = o.balloonStyle, s.listStyle = o.listStyle;
  }
  static overlayStyleMap(e, s, o) {
    const a = o.map.get(StyleState.Normal);
    typeof a == "string" ? this.resolveStyleReferenceChain(e, s, a) : this.overlayStyle(e, s, a);
  }
  static makeLabelCanvas(e, s, o = 1) {
    const l = document.createElement("canvas").getContext("2d");
    if (l === null)
      throw new Error("No 2D canvas");
    const u = `${e}px bold sans-serif`;
    l.font = u;
    const c = l.measureText(s).width, E = 2 * 2 * o, d = (c + E) * o, f = (e + E) * o;
    return l.canvas.width = d, l.canvas.height = f, l.font = u, l.textBaseline = "middle", l.textAlign = "center", l.fillStyle = "transparent", l.fillRect(0, 0, d, f), l.translate(d / 2, f / 2), l.scale(o, o), l.fillStyle = "white", l.fillText(s, 0, 0), l.canvas;
  }
}
KmlLoader.MESHMAT = new MeshBasicMaterial({
  vertexColors: !0,
  side: DoubleSide
});
const dxfTextControlCodeSymbolMap = {
  d: "°",
  c: "⌀",
  p: "±"
}, parseDxfMTextContent = (r, e) => {
  r = r.replace(/%%(.)/g, (E, d) => dxfTextControlCodeSymbolMap[d] || d);
  const s = e == null ? void 0 : e.encoding;
  let o = s instanceof TextDecoder ? s : void 0, a = "", l;
  const u = [], c = (E) => {
    a && (u.push(a), a = ""), u.push(E);
  };
  for (let E = 0; E < r.length; E++)
    switch (l = r[E]) {
      default:
        a += l;
        break;
      case "\\": {
        switch (l = r[++E]) {
          default:
            a += l;
            break;
          case "P":
            a += `
`;
            break;
          case "f":
          case "F": {
            let S = "";
            for (; l = r[++E]; ) {
              if (l === ";") {
                c({ f: S });
                break;
              }
              if (l === "|") {
                const R = { f: S }, _ = r.indexOf(";", ++E);
                for (const m of r.slice(E, _).split("|"))
                  R[m[0]] = +m.slice(1);
                E = _, c(R);
                break;
              }
              S += l === "\\" ? r[++E] : l;
            }
            break;
          }
          case "S": {
            let S = "", R, _ = "";
            for (; l = r[++E]; ) {
              if (l === ";") {
                R && c({ S: [S, R, _] });
                break;
              }
              l === "\\" ? R ? _ += r[++E] : S += r[++E] : R ? _ += l : l === "^" || l === "/" || l === "#" ? R = l : S += l;
            }
            break;
          }
          case "H":
          case "W":
            const d = ++E, [, f, h] = r.slice(d, E = r.indexOf(";", E)).match(/^(\d*(?:\.\d+)?)(\D*)$/);
            c({ [l]: [+f, h] });
            break;
          case "Q":
          case "A":
          case "C":
          case "T": {
            const S = ++E;
            c({ [l]: +r.slice(S, E = r.indexOf(";", E)) });
            break;
          }
          case "L":
          case "O":
          case "K":
            c({ [l]: 1 });
            break;
          case "l":
          case "o":
          case "k":
            c({ [l.toUpperCase()]: 0 });
            break;
          case "U":
          case "u":
            r[E + 1] === "+" ? (a += String.fromCodePoint(parseInt(r.substr(E + 2, 4), 16)), E += 5) : a += l;
            break;
          case "M":
          case "m":
            s ? r[E + 1] === "+" && r[E + 2] === "1" ? (a += (o = o || new TextDecoder(s)).decode(new Uint8Array([
              parseInt(r.substr(E + 3, 2), 16),
              parseInt(r.substr(E + 5, 2), 16)
            ])), E += 6) : a += l : a += "\\" + l;
            break;
        }
        break;
      }
      case "{": {
        let d = 1;
        const f = E;
        for (; l = r[++E]; )
          if (l === "{")
            d++;
          else if (l === "}") {
            if (--d === 0) {
              c(parseDxfMTextContent(r.slice(f + 1, E)));
              break;
            }
          } else
            l === "\\" && E++;
        break;
      }
    }
  return a && u.push(a), u;
};
function interpolate(r, e, s, o, a, F) {
  var u, c, E, d, f = s.length, h = s[0].length;
  if (e < 1)
    throw new Error("degree must be at least 1 (linear)");
  if (e > f - 1)
    throw new Error("degree must be less than or equal to point count - 1");
  if (!a)
    for (a = [], u = 0; u < f; u++)
      a[u] = 1;
  if (o) {
    if (o.length !== f + e + 1)
      throw new Error("bad knot vector length");
  } else {
    var o = [];
    for (u = 0; u < f + e + 1; u++)
      o[u] = u;
  }
  var S = [
    e,
    o.length - 1 - e
  ], R = o[S[0]], _ = o[S[1]];
  if (r = r * (_ - R) + R, r < R || r > _)
    throw new Error("out of bounds");
  for (E = S[0]; E < S[1] && !(r >= o[E] && r <= o[E + 1]); E++)
    ;
  var m = [];
  for (u = 0; u < f; u++) {
    for (m[u] = [], c = 0; c < h; c++)
      m[u][c] = s[u][c] * a[u];
    m[u][h] = a[u];
  }
  var L;
  for (d = 1; d <= e + 1; d++)
    for (u = E; u > E - e - 1 + d; u--)
      for (L = (r - o[u]) / (o[u + e + 1 - d] - o[u]), c = 0; c < h + 1; c++)
        m[u][c] = (1 - L) * m[u - 1][c] + L * m[u][c];
  var F = F || [];
  for (u = 0; u < h; u++)
    F[u] = m[E][u] / m[E][h];
  return F;
}
var bSpline = interpolate;
const bspline = /* @__PURE__ */ getDefaultExportFromCjs(bSpline);
class DxfArrayScanner {
  constructor(e) {
    this._pointer = 0, this._eof = !1, this._data = e;
  }
  /**
   * Gets the next group (code, value) from the array. A group is two consecutive elements
   * in the array. The first is the code, the second is the value.
   * @returns {{code: Number}|*}
   */
  next() {
    if (!this.hasNext())
      throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error("Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]);
    const e = {
      code: parseInt(this._data[this._pointer])
    };
    return this._pointer++, e.value = parseGroupValue(e.code, this._data[this._pointer].trim()), this._pointer++, e.code === 0 && e.value === "EOF" && (this._eof = !0), this.lastReadGroup = e, e;
  }
  peek() {
    if (!this.hasNext())
      throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error("Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]);
    const e = {
      code: parseInt(this._data[this._pointer])
    };
    return e.value = parseGroupValue(e.code, this._data[this._pointer + 1].trim()), e;
  }
  rewind(e = 1) {
    this._pointer = this._pointer - e * 2;
  }
  /**
   * Returns true if there is another code/value pair (2 elements in the array).
   * @returns {boolean}
   */
  hasNext() {
    return !(this._eof || this._pointer > this._data.length - 2);
  }
  /**
   * Returns true if the scanner is at the end of the array
   * @returns {boolean}
   */
  isEOF() {
    return this._eof;
  }
}
function parseGroupValue(r, e) {
  return r <= 9 ? e : r >= 10 && r <= 59 ? parseFloat(e) : r >= 60 && r <= 99 ? parseInt(e) : r >= 100 && r <= 109 ? e : r >= 110 && r <= 149 ? parseFloat(e) : r >= 160 && r <= 179 ? parseInt(e) : r >= 210 && r <= 239 ? parseFloat(e) : r >= 270 && r <= 289 ? parseInt(e) : r >= 290 && r <= 299 ? parseBoolean(e) : r >= 300 && r <= 369 ? e : r >= 370 && r <= 389 ? parseInt(e) : r >= 390 && r <= 399 ? e : r >= 400 && r <= 409 ? parseInt(e) : r >= 410 && r <= 419 ? e : r >= 420 && r <= 429 ? parseInt(e) : r >= 430 && r <= 439 ? e : r >= 440 && r <= 459 ? parseInt(e) : r >= 460 && r <= 469 ? parseFloat(e) : r >= 470 && r <= 481 || r === 999 || r >= 1e3 && r <= 1009 ? e : r >= 1010 && r <= 1059 ? parseFloat(e) : r >= 1060 && r <= 1071 ? parseInt(e) : (console.log("WARNING: Group code does not have a defined type: %j", { code: r, value: e }), e);
}
function parseBoolean(r) {
  if (r === "0")
    return !1;
  if (r === "1")
    return !0;
  throw TypeError("String '" + r + "' cannot be cast to Boolean type");
}
const AUTO_CAD_COLOR_INDEX = [
  0,
  16711680,
  16776960,
  65280,
  65535,
  255,
  16711935,
  16777215,
  8421504,
  12632256,
  16711680,
  16744319,
  13369344,
  13395558,
  10027008,
  10046540,
  8323072,
  8339263,
  4980736,
  4990502,
  16727808,
  16752511,
  13382400,
  13401958,
  10036736,
  10051404,
  8331008,
  8343359,
  4985600,
  4992806,
  16744192,
  16760703,
  13395456,
  13408614,
  10046464,
  10056268,
  8339200,
  8347455,
  4990464,
  4995366,
  16760576,
  16768895,
  13408512,
  13415014,
  10056192,
  10061132,
  8347392,
  8351551,
  4995328,
  4997670,
  16776960,
  16777087,
  13421568,
  13421670,
  10000384,
  10000460,
  8355584,
  8355647,
  5000192,
  5000230,
  12582656,
  14679935,
  10079232,
  11717734,
  7510016,
  8755276,
  6258432,
  7307071,
  3755008,
  4344870,
  8388352,
  12582783,
  6736896,
  10079334,
  5019648,
  7510092,
  4161280,
  6258495,
  2509824,
  3755046,
  4194048,
  10485631,
  3394560,
  8375398,
  2529280,
  6264908,
  2064128,
  5209919,
  1264640,
  3099686,
  65280,
  8388479,
  52224,
  6736998,
  38912,
  5019724,
  32512,
  4161343,
  19456,
  2509862,
  65343,
  8388511,
  52275,
  6737023,
  38950,
  5019743,
  32543,
  4161359,
  19475,
  2509871,
  65407,
  8388543,
  52326,
  6737049,
  38988,
  5019762,
  32575,
  4161375,
  19494,
  2509881,
  65471,
  8388575,
  52377,
  6737074,
  39026,
  5019781,
  32607,
  4161391,
  19513,
  2509890,
  65535,
  8388607,
  52428,
  6737100,
  39064,
  5019800,
  32639,
  4161407,
  19532,
  2509900,
  49151,
  8380415,
  39372,
  6730444,
  29336,
  5014936,
  24447,
  4157311,
  14668,
  2507340,
  32767,
  8372223,
  26316,
  6724044,
  19608,
  5010072,
  16255,
  4153215,
  9804,
  2505036,
  16383,
  8364031,
  13260,
  6717388,
  9880,
  5005208,
  8063,
  4149119,
  4940,
  2502476,
  255,
  8355839,
  204,
  6710988,
  152,
  5000344,
  127,
  4145023,
  76,
  2500172,
  4129023,
  10452991,
  3342540,
  8349388,
  2490520,
  6245528,
  2031743,
  5193599,
  1245260,
  3089996,
  8323327,
  12550143,
  6684876,
  10053324,
  4980888,
  7490712,
  4128895,
  6242175,
  2490444,
  3745356,
  12517631,
  14647295,
  10027212,
  11691724,
  7471256,
  8735896,
  6226047,
  7290751,
  3735628,
  4335180,
  16711935,
  16744447,
  13369548,
  13395660,
  9961624,
  9981080,
  8323199,
  8339327,
  4980812,
  4990540,
  16711871,
  16744415,
  13369497,
  13395634,
  9961586,
  9981061,
  8323167,
  8339311,
  4980793,
  4990530,
  16711807,
  16744383,
  13369446,
  13395609,
  9961548,
  9981042,
  8323135,
  8339295,
  4980774,
  4990521,
  16711743,
  16744351,
  13369395,
  13395583,
  9961510,
  9981023,
  8323103,
  8339279,
  4980755,
  4990511,
  3355443,
  5987163,
  8684676,
  11382189,
  14079702,
  16777215
];
function getAcadColor$1(r) {
  return AUTO_CAD_COLOR_INDEX[r];
}
function parsePoint(r) {
  const e = {};
  r.rewind();
  let s = r.next(), o = s.code;
  if (e.x = s.value, o += 10, s = r.next(), s.code != o)
    throw new Error("Expected code for point value to be " + o + " but got " + s.code + ".");
  return e.y = s.value, o += 10, s = r.next(), s.code != o ? (r.rewind(), e) : (e.z = s.value, e);
}
function checkCommonEntityProperties(r, e, s) {
  switch (e.code) {
    case 0:
      r.type = e.value;
      break;
    case 5:
      r.handle = e.value;
      break;
    case 6:
      r.lineType = e.value;
      break;
    case 8:
      r.layer = e.value;
      break;
    case 48:
      r.lineTypeScale = e.value;
      break;
    case 60:
      r.visible = e.value === 0;
      break;
    case 62:
      r.colorIndex = e.value, r.color = getAcadColor$1(Math.abs(e.value));
      break;
    case 67:
      r.inPaperSpace = e.value !== 0;
      break;
    case 100:
      break;
    case 101:
      for (; e.code != 0; )
        e = s.next();
      s.rewind();
      break;
    case 330:
      r.ownerHandle = e.value;
      break;
    case 347:
      r.materialObjectHandle = e.value;
      break;
    case 370:
      r.lineweight = e.value;
      break;
    case 420:
      r.color = e.value;
      break;
    case 1e3:
      r.extendedData = r.extendedData || {}, r.extendedData.customStrings = r.extendedData.customStrings || [], r.extendedData.customStrings.push(e.value);
      break;
    case 1001:
      r.extendedData = r.extendedData || {}, r.extendedData.applicationName = e.value;
      break;
    default:
      return !1;
  }
  return !0;
}
class ThreeDface {
  constructor() {
    this.ForEntityName = "3DFACE";
  }
  parseEntity(e, s) {
    const o = { type: s.value, vertices: [] };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 70:
          o.shape = (s.value & 1) === 1, o.hasContinuousLinetypePattern = (s.value & 128) === 128;
          break;
        case 10:
          o.vertices = parse3dFaceVertices(e, s), s = e.lastReadGroup;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
function parse3dFaceVertices(r, e) {
  var s = [], o = !1, a = !1, l = 4;
  for (let c = 0; c <= l; c++) {
    for (var u = {}; !r.isEOF() && !(e.code === 0 || a); ) {
      switch (e.code) {
        case 10:
        case 11:
        case 12:
        case 13:
          if (o) {
            a = !0;
            continue;
          }
          u.x = e.value, o = !0;
          break;
        case 20:
        case 21:
        case 22:
        case 23:
          u.y = e.value;
          break;
        case 30:
        case 31:
        case 32:
        case 33:
          u.z = e.value;
          break;
        default:
          return s;
      }
      e = r.next();
    }
    s.push(u), o = !1, a = !1;
  }
  return r.rewind(), s;
}
class Arc {
  constructor() {
    this.ForEntityName = "ARC";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.center = parsePoint(e);
          break;
        case 40:
          o.radius = s.value;
          break;
        case 50:
          o.startAngle = Math.PI / 180 * s.value;
          break;
        case 51:
          o.endAngle = Math.PI / 180 * s.value, o.angleLength = o.endAngle - o.startAngle;
          break;
        case 210:
          o.extrusionDirectionX = s.value;
          break;
        case 220:
          o.extrusionDirectionY = s.value;
          break;
        case 230:
          o.extrusionDirectionZ = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Attdef {
  constructor() {
    this.ForEntityName = "ATTDEF";
  }
  parseEntity(e, s) {
    var o = {
      type: s.value,
      scale: 1,
      textStyle: "STANDARD"
    };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 1:
          o.text = s.value;
          break;
        case 2:
          o.tag = s.value;
          break;
        case 3:
          o.prompt = s.value;
          break;
        case 7:
          o.textStyle = s.value;
          break;
        case 10:
          o.startPoint = parsePoint(e);
          break;
        case 11:
          o.endPoint = parsePoint(e);
          break;
        case 39:
          o.thickness = s.value;
          break;
        case 40:
          o.textHeight = s.value;
          break;
        case 41:
          o.scale = s.value;
          break;
        case 50:
          o.rotation = s.value;
          break;
        case 51:
          o.obliqueAngle = s.value;
          break;
        case 70:
          o.invisible = !!(s.value & 1), o.constant = !!(s.value & 2), o.verificationRequired = !!(s.value & 4), o.preset = !!(s.value & 8);
          break;
        case 71:
          o.backwards = !!(s.value & 2), o.mirrored = !!(s.value & 4);
          break;
        case 72:
          o.horizontalJustification = s.value;
          break;
        case 73:
          o.fieldLength = s.value;
          break;
        case 74:
          o.verticalJustification = s.value;
          break;
        case 100:
          break;
        case 210:
          o.extrusionDirectionX = s.value;
          break;
        case 220:
          o.extrusionDirectionY = s.value;
          break;
        case 230:
          o.extrusionDirectionZ = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Circle {
  constructor() {
    this.ForEntityName = "CIRCLE";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.center = parsePoint(e);
          break;
        case 40:
          o.radius = s.value;
          break;
        case 50:
          o.startAngle = Math.PI / 180 * s.value;
          break;
        case 51:
          const a = Math.PI / 180 * s.value;
          a < o.startAngle ? o.angleLength = a + 2 * Math.PI - o.startAngle : o.angleLength = a - o.startAngle, o.endAngle = a;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Dimension {
  constructor() {
    this.ForEntityName = "DIMENSION";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 2:
          o.block = s.value;
          break;
        case 10:
          o.anchorPoint = parsePoint(e);
          break;
        case 11:
          o.middleOfText = parsePoint(e);
          break;
        case 12:
          o.insertionPoint = parsePoint(e);
          break;
        case 13:
          o.linearOrAngularPoint1 = parsePoint(e);
          break;
        case 14:
          o.linearOrAngularPoint2 = parsePoint(e);
          break;
        case 15:
          o.diameterOrRadiusPoint = parsePoint(e);
          break;
        case 16:
          o.arcPoint = parsePoint(e);
          break;
        case 70:
          o.dimensionType = s.value;
          break;
        case 71:
          o.attachmentPoint = s.value;
          break;
        case 42:
          o.actualMeasurement = s.value;
          break;
        case 1:
          o.text = s.value;
          break;
        case 50:
          o.angle = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Ellipse {
  constructor() {
    this.ForEntityName = "ELLIPSE";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.center = parsePoint(e);
          break;
        case 11:
          o.majorAxisEndPoint = parsePoint(e);
          break;
        case 40:
          o.axisRatio = s.value;
          break;
        case 41:
          o.startAngle = s.value;
          break;
        case 42:
          o.endAngle = s.value;
          break;
        case 2:
          o.name = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Insert {
  constructor() {
    this.ForEntityName = "INSERT";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 2:
          o.name = s.value;
          break;
        case 41:
          o.xScale = s.value;
          break;
        case 42:
          o.yScale = s.value;
          break;
        case 43:
          o.zScale = s.value;
          break;
        case 10:
          o.position = parsePoint(e);
          break;
        case 50:
          o.rotation = s.value;
          break;
        case 70:
          o.columnCount = s.value;
          break;
        case 71:
          o.rowCount = s.value;
          break;
        case 44:
          o.columnSpacing = s.value;
          break;
        case 45:
          o.rowSpacing = s.value;
          break;
        case 210:
          o.extrusionDirection = parsePoint(e);
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Line {
  constructor() {
    this.ForEntityName = "LINE";
  }
  parseEntity(e, s) {
    const o = { type: s.value, vertices: [] };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.vertices.unshift(parsePoint(e));
          break;
        case 11:
          o.vertices.push(parsePoint(e));
          break;
        case 210:
          o.extrusionDirection = parsePoint(e);
          break;
        case 100:
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Lwpolyline {
  constructor() {
    this.ForEntityName = "LWPOLYLINE";
  }
  parseEntity(e, s) {
    const o = { type: s.value, vertices: [] };
    let a = 0;
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 38:
          o.elevation = s.value;
          break;
        case 39:
          o.depth = s.value;
          break;
        case 70:
          o.shape = (s.value & 1) === 1, o.hasContinuousLinetypePattern = (s.value & 128) === 128;
          break;
        case 90:
          a = s.value;
          break;
        case 10:
          o.vertices = parseLWPolylineVertices(a, e);
          break;
        case 43:
          s.value !== 0 && (o.width = s.value);
          break;
        case 210:
          o.extrusionDirectionX = s.value;
          break;
        case 220:
          o.extrusionDirectionY = s.value;
          break;
        case 230:
          o.extrusionDirectionZ = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
function parseLWPolylineVertices(r, e) {
  if (!r || r <= 0)
    throw Error("n must be greater than 0 verticies");
  const s = [];
  let o = !1, a = !1, l = e.lastReadGroup;
  for (let u = 0; u < r; u++) {
    const c = {};
    for (; !e.isEOF() && !(l.code === 0 || a); ) {
      switch (l.code) {
        case 10:
          if (o) {
            a = !0;
            continue;
          }
          c.x = l.value, o = !0;
          break;
        case 20:
          c.y = l.value;
          break;
        case 30:
          c.z = l.value;
          break;
        case 40:
          c.startWidth = l.value;
          break;
        case 41:
          c.endWidth = l.value;
          break;
        case 42:
          l.value != 0 && (c.bulge = l.value);
          break;
        default:
          return e.rewind(), o && s.push(c), e.rewind(), s;
      }
      l = e.next();
    }
    s.push(c), o = !1, a = !1;
  }
  return e.rewind(), s;
}
class Mtext {
  constructor() {
    this.ForEntityName = "MTEXT";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 3:
          o.text ? o.text += s.value : o.text = s.value;
          break;
        case 1:
          o.text ? o.text += s.value : o.text = s.value;
          break;
        case 10:
          o.position = parsePoint(e);
          break;
        case 11:
          o.directionVector = parsePoint(e);
          break;
        case 40:
          o.height = s.value;
          break;
        case 41:
          o.width = s.value;
          break;
        case 50:
          o.rotation = s.value;
          break;
        case 71:
          o.attachmentPoint = s.value;
          break;
        case 72:
          o.drawingDirection = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
let Point$1 = class {
  constructor() {
    this.ForEntityName = "POINT";
  }
  parseEntity(e, s) {
    const a = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          a.position = parsePoint(e);
          break;
        case 39:
          a.thickness = s.value;
          break;
        case 210:
          a.extrusionDirection = parsePoint(e);
          break;
        case 100:
          break;
        default:
          checkCommonEntityProperties(a, s, e);
          break;
      }
      s = e.next();
    }
    return a;
  }
};
class Vertex {
  constructor() {
    this.ForEntityName = "VERTEX";
  }
  parseEntity(e, s) {
    var o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.x = s.value;
          break;
        case 20:
          o.y = s.value;
          break;
        case 30:
          o.z = s.value;
          break;
        case 40:
          break;
        case 41:
          break;
        case 42:
          s.value != 0 && (o.bulge = s.value);
          break;
        case 70:
          o.curveFittingVertex = (s.value & 1) !== 0, o.curveFitTangent = (s.value & 2) !== 0, o.splineVertex = (s.value & 8) !== 0, o.splineControlPoint = (s.value & 16) !== 0, o.threeDPolylineVertex = (s.value & 32) !== 0, o.threeDPolylineMesh = (s.value & 64) !== 0, o.polyfaceMeshVertex = (s.value & 128) !== 0;
          break;
        case 50:
          break;
        case 71:
          o.faceA = s.value;
          break;
        case 72:
          o.faceB = s.value;
          break;
        case 73:
          o.faceC = s.value;
          break;
        case 74:
          o.faceD = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Polyline {
  constructor() {
    this.ForEntityName = "POLYLINE";
  }
  parseEntity(e, s) {
    var o = { type: s.value, vertices: [] };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          break;
        case 20:
          break;
        case 30:
          break;
        case 39:
          o.thickness = s.value;
          break;
        case 40:
          break;
        case 41:
          break;
        case 70:
          o.shape = (s.value & 1) !== 0, o.includesCurveFitVertices = (s.value & 2) !== 0, o.includesSplineFitVertices = (s.value & 4) !== 0, o.is3dPolyline = (s.value & 8) !== 0, o.is3dPolygonMesh = (s.value & 16) !== 0, o.is3dPolygonMeshClosed = (s.value & 32) !== 0, o.isPolyfaceMesh = (s.value & 64) !== 0, o.hasContinuousLinetypePattern = (s.value & 128) !== 0;
          break;
        case 71:
          break;
        case 72:
          break;
        case 73:
          break;
        case 74:
          break;
        case 75:
          break;
        case 210:
          o.extrusionDirection = parsePoint(e);
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o.vertices = parsePolylineVertices(e, s), o;
  }
}
function parsePolylineVertices(r, e) {
  const s = new Vertex(), o = [];
  for (; !r.isEOF(); )
    if (e.code === 0) {
      if (e.value === "VERTEX")
        o.push(s.parseEntity(r, e)), e = r.lastReadGroup;
      else if (e.value === "SEQEND") {
        parseSeqEnd(r, e);
        break;
      }
    }
  return o;
}
function parseSeqEnd(r, e) {
  const s = { type: e.value };
  for (e = r.next(); !r.isEOF() && e.code != 0; )
    checkCommonEntityProperties(s, e, r), e = r.next();
  return s;
}
class Solid {
  constructor() {
    this.ForEntityName = "SOLID";
  }
  parseEntity(e, s) {
    const o = { type: s.value, points: [] };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.points[0] = parsePoint(e);
          break;
        case 11:
          o.points[1] = parsePoint(e);
          break;
        case 12:
          o.points[2] = parsePoint(e);
          break;
        case 13:
          o.points[3] = parsePoint(e);
          break;
        case 210:
          o.extrusionDirection = parsePoint(e);
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Spline {
  constructor() {
    this.ForEntityName = "SPLINE";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.controlPoints || (o.controlPoints = []), o.controlPoints.push(parsePoint(e));
          break;
        case 11:
          o.fitPoints || (o.fitPoints = []), o.fitPoints.push(parsePoint(e));
          break;
        case 12:
          o.startTangent = parsePoint(e);
          break;
        case 13:
          o.endTangent = parsePoint(e);
          break;
        case 40:
          o.knotValues || (o.knotValues = []), o.knotValues.push(s.value);
          break;
        case 70:
          s.value & 1 && (o.closed = !0), s.value & 2 && (o.periodic = !0), s.value & 4 && (o.rational = !0), s.value & 8 && (o.planar = !0), s.value & 16 && (o.planar = !0, o.linear = !0);
          break;
        case 71:
          o.degreeOfSplineCurve = s.value;
          break;
        case 72:
          o.numberOfKnots = s.value;
          break;
        case 73:
          o.numberOfControlPoints = s.value;
          break;
        case 74:
          o.numberOfFitPoints = s.value;
          break;
        case 210:
          o.normalVector = parsePoint(e);
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
class Text {
  constructor() {
    this.ForEntityName = "TEXT";
  }
  parseEntity(e, s) {
    const o = { type: s.value };
    for (s = e.next(); !e.isEOF() && s.code !== 0; ) {
      switch (s.code) {
        case 10:
          o.startPoint = parsePoint(e);
          break;
        case 11:
          o.endPoint = parsePoint(e);
          break;
        case 40:
          o.textHeight = s.value;
          break;
        case 41:
          o.xScale = s.value;
          break;
        case 50:
          o.rotation = s.value;
          break;
        case 1:
          o.text = s.value;
          break;
        case 72:
          o.halign = s.value;
          break;
        case 73:
          o.valign = s.value;
          break;
        default:
          checkCommonEntityProperties(o, s, e);
          break;
      }
      s = e.next();
    }
    return o;
  }
}
var loglevel = { exports: {} };
(function(r) {
  (function(e, s) {
    r.exports ? r.exports = s() : e.log = s();
  })(commonjsGlobal, function() {
    var e = function() {
    }, s = "undefined", o = typeof window !== s && typeof window.navigator !== s && /Trident\/|MSIE /.test(window.navigator.userAgent), a = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ], l = {}, u = null;
    function c(m, L) {
      var F = m[L];
      if (typeof F.bind == "function")
        return F.bind(m);
      try {
        return Function.prototype.bind.call(F, m);
      } catch {
        return function() {
          return Function.prototype.apply.apply(F, [m, arguments]);
        };
      }
    }
    function E() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function d(m) {
      return m === "debug" && (m = "log"), typeof console === s ? !1 : m === "trace" && o ? E : console[m] !== void 0 ? c(console, m) : console.log !== void 0 ? c(console, "log") : e;
    }
    function f() {
      for (var m = this.getLevel(), L = 0; L < a.length; L++) {
        var F = a[L];
        this[F] = L < m ? e : this.methodFactory(F, m, this.name);
      }
      if (this.log = this.debug, typeof console === s && m < this.levels.SILENT)
        return "No console available for logging";
    }
    function h(m) {
      return function() {
        typeof console !== s && (f.call(this), this[m].apply(this, arguments));
      };
    }
    function S(m, L, F) {
      return d(m) || h.apply(this, arguments);
    }
    function R(m, L) {
      var F = this, W, G, q, fe = "loglevel";
      typeof m == "string" ? fe += ":" + m : typeof m == "symbol" && (fe = void 0);
      function _e(ve) {
        var te = (a[ve] || "silent").toUpperCase();
        if (!(typeof window === s || !fe)) {
          try {
            window.localStorage[fe] = te;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(fe) + "=" + te + ";";
          } catch {
          }
        }
      }
      function Le() {
        var ve;
        if (!(typeof window === s || !fe)) {
          try {
            ve = window.localStorage[fe];
          } catch {
          }
          if (typeof ve === s)
            try {
              var te = window.document.cookie, ae = encodeURIComponent(fe), v = te.indexOf(ae + "=");
              v !== -1 && (ve = /^([^;]+)/.exec(
                te.slice(v + ae.length + 1)
              )[1]);
            } catch {
            }
          return F.levels[ve] === void 0 && (ve = void 0), ve;
        }
      }
      function Fe() {
        if (!(typeof window === s || !fe)) {
          try {
            window.localStorage.removeItem(fe);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(fe) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function Ee(ve) {
        var te = ve;
        if (typeof te == "string" && F.levels[te.toUpperCase()] !== void 0 && (te = F.levels[te.toUpperCase()]), typeof te == "number" && te >= 0 && te <= F.levels.SILENT)
          return te;
        throw new TypeError("log.setLevel() called with invalid level: " + ve);
      }
      F.name = m, F.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, F.methodFactory = L || S, F.getLevel = function() {
        return q ?? G ?? W;
      }, F.setLevel = function(ve, te) {
        return q = Ee(ve), te !== !1 && _e(q), f.call(F);
      }, F.setDefaultLevel = function(ve) {
        G = Ee(ve), Le() || F.setLevel(ve, !1);
      }, F.resetLevel = function() {
        q = null, Fe(), f.call(F);
      }, F.enableAll = function(ve) {
        F.setLevel(F.levels.TRACE, ve);
      }, F.disableAll = function(ve) {
        F.setLevel(F.levels.SILENT, ve);
      }, F.rebuild = function() {
        if (u !== F && (W = Ee(u.getLevel())), f.call(F), u === F)
          for (var ve in l)
            l[ve].rebuild();
      }, W = Ee(
        u ? u.getLevel() : "WARN"
      );
      var Ge = Le();
      Ge != null && (q = Ee(Ge)), f.call(F);
    }
    u = new R(), u.getLogger = function(L) {
      if (typeof L != "symbol" && typeof L != "string" || L === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var F = l[L];
      return F || (F = l[L] = new R(
        L,
        u.methodFactory
      )), F;
    };
    var _ = typeof window !== s ? window.log : void 0;
    return u.noConflict = function() {
      return typeof window !== s && window.log === u && (window.log = _), u;
    }, u.getLoggers = function() {
      return l;
    }, u.default = u, u;
  });
})(loglevel);
var loglevelExports = loglevel.exports;
const log = /* @__PURE__ */ getDefaultExportFromCjs(loglevelExports);
log.setLevel("error");
function registerDefaultEntityHandlers(r) {
  r.registerEntityHandler(ThreeDface), r.registerEntityHandler(Arc), r.registerEntityHandler(Attdef), r.registerEntityHandler(Circle), r.registerEntityHandler(Dimension), r.registerEntityHandler(Ellipse), r.registerEntityHandler(Insert), r.registerEntityHandler(Line), r.registerEntityHandler(Lwpolyline), r.registerEntityHandler(Mtext), r.registerEntityHandler(Point$1), r.registerEntityHandler(Polyline), r.registerEntityHandler(Solid), r.registerEntityHandler(Spline), r.registerEntityHandler(Text);
}
class DxfParser {
  constructor() {
    this._entityHandlers = {}, registerDefaultEntityHandlers(this);
  }
  parse(e) {
    return typeof e == "string" ? this._parse(e) : (console.error("Cannot read dxf source of type `" + typeof e), null);
  }
  registerEntityHandler(e) {
    const s = new e();
    this._entityHandlers[s.ForEntityName] = s;
  }
  parseSync(e) {
    return this.parse(e);
  }
  parseStream(e) {
    let s = "";
    const o = this;
    return new Promise((a, l) => {
      e.on("data", (u) => {
        s += u;
      }), e.on("end", () => {
        try {
          a(o._parse(s));
        } catch (u) {
          l(u);
        }
      }), e.on("error", (u) => {
        l(u);
      });
    });
  }
  _parse(e) {
    const s = {};
    let o = 0;
    const a = e.split(/\r\n|\r|\n/g), l = new DxfArrayScanner(a);
    if (!l.hasNext())
      throw Error("Empty file");
    const u = this;
    let c;
    function E() {
      for (c = l.next(); !l.isEOF(); )
        if (c.code === 0 && c.value === "SECTION") {
          if (c = l.next(), c.code !== 2) {
            console.error("Unexpected code %s after 0:SECTION", debugCode(c)), c = l.next();
            continue;
          }
          c.value === "HEADER" ? (log.debug("> HEADER"), s.header = d(), log.debug("<")) : c.value === "BLOCKS" ? (log.debug("> BLOCKS"), s.blocks = f(), log.debug("<")) : c.value === "ENTITIES" ? (log.debug("> ENTITIES"), s.entities = G(!1), log.debug("<")) : c.value === "TABLES" ? (log.debug("> TABLES"), s.tables = S(), log.debug("<")) : c.value === "EOF" ? log.debug("EOF") : log.warn("Skipping section '%s'", c.value);
        } else
          c = l.next();
    }
    function d() {
      let _e = null, Le = null;
      const Fe = {};
      for (c = l.next(); ; ) {
        if (groupIs(c, 0, "ENDSEC")) {
          _e && (Fe[_e] = Le);
          break;
        } else
          c.code === 9 ? (_e && (Fe[_e] = Le), _e = c.value) : c.code === 10 ? Le = { x: c.value } : c.code === 20 ? Le.y = c.value : c.code === 30 ? Le.z = c.value : Le = c.value;
        c = l.next();
      }
      return c = l.next(), Fe;
    }
    function f() {
      const _e = {};
      for (c = l.next(); c.value !== "EOF" && !groupIs(c, 0, "ENDSEC"); )
        if (groupIs(c, 0, "BLOCK")) {
          log.debug("block {");
          const Le = h();
          log.debug("}"), fe(Le), Le.name ? _e[Le.name] = Le : log.error('block with handle "' + Le.handle + '" is missing a name.');
        } else
          logUnhandledGroup(c), c = l.next();
      return _e;
    }
    function h() {
      const _e = {};
      for (c = l.next(); c.value !== "EOF"; ) {
        switch (c.code) {
          case 1:
            _e.xrefPath = c.value, c = l.next();
            break;
          case 2:
            _e.name = c.value, c = l.next();
            break;
          case 3:
            _e.name2 = c.value, c = l.next();
            break;
          case 5:
            _e.handle = c.value, c = l.next();
            break;
          case 8:
            _e.layer = c.value, c = l.next();
            break;
          case 10:
            _e.position = q(c), c = l.next();
            break;
          case 67:
            _e.paperSpace = !!(c.value && c.value == 1), c = l.next();
            break;
          case 70:
            c.value != 0 && (_e.type = c.value), c = l.next();
            break;
          case 100:
            c = l.next();
            break;
          case 330:
            _e.ownerHandle = c.value, c = l.next();
            break;
          case 0:
            if (c.value == "ENDBLK")
              break;
            _e.entities = G(!0);
            break;
          default:
            logUnhandledGroup(c), c = l.next();
        }
        if (groupIs(c, 0, "ENDBLK")) {
          c = l.next();
          break;
        }
      }
      return _e;
    }
    function S() {
      const _e = {};
      for (c = l.next(); c.value !== "EOF" && !groupIs(c, 0, "ENDSEC"); )
        groupIs(c, 0, "TABLE") ? (c = l.next(), W[c.value] ? (log.debug(c.value + " Table {"), _e[W[c.value].tableName] = _(c), log.debug("}")) : log.debug("Unhandled Table " + c.value)) : c = l.next();
      return c = l.next(), _e;
    }
    const R = "ENDTAB";
    function _(_e) {
      const Le = W[_e.value], Fe = {};
      let Ee = 0;
      for (c = l.next(); !groupIs(c, 0, R); )
        switch (c.code) {
          case 5:
            Fe.handle = c.value, c = l.next();
            break;
          case 330:
            Fe.ownerHandle = c.value, c = l.next();
            break;
          case 100:
            c.value === "AcDbSymbolTable" || logUnhandledGroup(c), c = l.next();
            break;
          case 70:
            Ee = c.value, c = l.next();
            break;
          case 0:
            c.value === Le.dxfSymbolName ? Fe[Le.tableRecordsProperty] = Le.parseTableRecords() : (logUnhandledGroup(c), c = l.next());
            break;
          default:
            logUnhandledGroup(c), c = l.next();
        }
      const Ge = Fe[Le.tableRecordsProperty];
      if (Ge) {
        let ve = (() => {
          if (Ge.constructor === Array)
            return Ge.length;
          if (typeof Ge == "object")
            return Object.keys(Ge).length;
        })();
        Ee !== ve && log.warn("Parsed " + ve + " " + Le.dxfSymbolName + "'s but expected " + Ee);
      }
      return c = l.next(), Fe;
    }
    function m() {
      const _e = [];
      let Le = {};
      for (log.debug("ViewPort {"), c = l.next(); !groupIs(c, 0, R); )
        switch (c.code) {
          case 2:
            Le.name = c.value, c = l.next();
            break;
          case 10:
            Le.lowerLeftCorner = q(c), c = l.next();
            break;
          case 11:
            Le.upperRightCorner = q(c), c = l.next();
            break;
          case 12:
            Le.center = q(c), c = l.next();
            break;
          case 13:
            Le.snapBasePoint = q(c), c = l.next();
            break;
          case 14:
            Le.snapSpacing = q(c), c = l.next();
            break;
          case 15:
            Le.gridSpacing = q(c), c = l.next();
            break;
          case 16:
            Le.viewDirectionFromTarget = q(c), c = l.next();
            break;
          case 17:
            Le.viewTarget = q(c), c = l.next();
            break;
          case 42:
            Le.lensLength = c.value, c = l.next();
            break;
          case 43:
            Le.frontClippingPlane = c.value, c = l.next();
            break;
          case 44:
            Le.backClippingPlane = c.value, c = l.next();
            break;
          case 45:
            Le.viewHeight = c.value, c = l.next();
            break;
          case 50:
            Le.snapRotationAngle = c.value, c = l.next();
            break;
          case 51:
            Le.viewTwistAngle = c.value, c = l.next();
            break;
          case 79:
            Le.orthographicType = c.value, c = l.next();
            break;
          case 110:
            Le.ucsOrigin = q(c), c = l.next();
            break;
          case 111:
            Le.ucsXAxis = q(c), c = l.next();
            break;
          case 112:
            Le.ucsYAxis = q(c), c = l.next();
            break;
          case 110:
            Le.ucsOrigin = q(c), c = l.next();
            break;
          case 281:
            Le.renderMode = c.value, c = l.next();
            break;
          case 281:
            Le.defaultLightingType = c.value, c = l.next();
            break;
          case 292:
            Le.defaultLightingOn = c.value, c = l.next();
            break;
          case 330:
            Le.ownerHandle = c.value, c = l.next();
            break;
          case 63:
          case 421:
          case 431:
            Le.ambientColor = c.value, c = l.next();
            break;
          case 0:
            c.value === "VPORT" && (log.debug("}"), _e.push(Le), log.debug("ViewPort {"), Le = {}, c = l.next());
            break;
          default:
            logUnhandledGroup(c), c = l.next();
            break;
        }
      return log.debug("}"), _e.push(Le), _e;
    }
    function L() {
      const _e = {};
      let Le = {}, Fe = 0, Ee;
      for (log.debug("LType {"), c = l.next(); !groupIs(c, 0, "ENDTAB"); )
        switch (c.code) {
          case 2:
            Le.name = c.value, Ee = c.value, c = l.next();
            break;
          case 3:
            Le.description = c.value, c = l.next();
            break;
          case 73:
            Fe = c.value, Fe > 0 && (Le.pattern = []), c = l.next();
            break;
          case 40:
            Le.patternLength = c.value, c = l.next();
            break;
          case 49:
            Le.pattern.push(c.value), c = l.next();
            break;
          case 0:
            log.debug("}"), Fe > 0 && Fe !== Le.pattern.length && log.warn("lengths do not match on LTYPE pattern"), _e[Ee] = Le, Le = {}, log.debug("LType {"), c = l.next();
            break;
          default:
            c = l.next();
        }
      return log.debug("}"), _e[Ee] = Le, _e;
    }
    function F() {
      const _e = {};
      let Le = {}, Fe;
      for (log.debug("Layer {"), c = l.next(); !groupIs(c, 0, "ENDTAB"); )
        switch (c.code) {
          case 2:
            Le.name = c.value, Fe = c.value, c = l.next();
            break;
          case 62:
            Le.visible = c.value >= 0, Le.colorIndex = Math.abs(c.value), Le.color = getAcadColor(Le.colorIndex), c = l.next();
            break;
          case 70:
            Le.frozen = (c.value & 1) != 0 || (c.value & 2) != 0, c = l.next();
            break;
          case 0:
            c.value === "LAYER" && (log.debug("}"), _e[Fe] = Le, log.debug("Layer {"), Le = {}, Fe = void 0, c = l.next());
            break;
          default:
            logUnhandledGroup(c), c = l.next();
            break;
        }
      return log.debug("}"), _e[Fe] = Le, _e;
    }
    const W = {
      VPORT: {
        tableRecordsProperty: "viewPorts",
        tableName: "viewPort",
        dxfSymbolName: "VPORT",
        parseTableRecords: m
      },
      LTYPE: {
        tableRecordsProperty: "lineTypes",
        tableName: "lineType",
        dxfSymbolName: "LTYPE",
        parseTableRecords: L
      },
      LAYER: {
        tableRecordsProperty: "layers",
        tableName: "layer",
        dxfSymbolName: "LAYER",
        parseTableRecords: F
      }
    };
    function G(_e) {
      const Le = [], Fe = _e ? "ENDBLK" : "ENDSEC";
      for (_e || (c = l.next()); ; )
        if (c.code === 0) {
          if (c.value === Fe)
            break;
          const Ee = u._entityHandlers[c.value];
          if (Ee != null) {
            log.debug(c.value + " {");
            const Ge = Ee.parseEntity(l, c);
            c = l.lastReadGroup, log.debug("}"), fe(Ge), Le.push(Ge);
          } else {
            log.warn("Unhandled entity " + c.value), c = l.next();
            continue;
          }
        } else
          c = l.next();
      return Fe == "ENDSEC" && (c = l.next()), Le;
    }
    function q(_e) {
      const Le = {};
      let Fe = _e.code;
      if (Le.x = _e.value, Fe += 10, _e = l.next(), _e.code != Fe)
        throw new Error("Expected code for point value to be " + Fe + " but got " + _e.code + ".");
      return Le.y = _e.value, Fe += 10, _e = l.next(), _e.code != Fe ? (l.rewind(), Le) : (Le.z = _e.value, Le);
    }
    function fe(_e) {
      if (!_e)
        throw new TypeError("entity cannot be undefined or null");
      _e.handle || (_e.handle = o++);
    }
    return E(), s;
  }
}
function groupIs(r, e, s) {
  return r.code === e && r.value === s;
}
function logUnhandledGroup(r) {
  log.debug("unhandled group " + debugCode(r));
}
function debugCode(r) {
  return r.code + ":" + r.value;
}
function getAcadColor(r) {
  return AUTO_CAD_COLOR_INDEX[r];
}
const glyphs = {
  0: {
    x_min: 66,
    x_max: 700,
    ha: 765,
    o: "m 700 496 q 682 281 700 376 q 627 121 665 186 q 528 20 588 55 q 381 -14 467 -14 q 242 20 301 -14 q 143 121 182 55 q 85 281 104 186 q 66 496 66 376 q 83 711 66 616 q 138 872 100 806 q 236 972 175 937 q 381 1007 296 1007 q 522 972 462 1007 q 621 873 581 938 q 680 712 660 807 q 700 496 700 617 m 191 497 q 201 319 191 395 q 234 192 211 243 q 292 116 256 142 q 381 91 329 91 q 470 116 433 91 q 530 191 506 141 q 564 318 553 241 q 574 497 574 394 q 564 675 574 599 q 530 801 553 751 q 470 876 506 851 q 381 901 433 901 q 292 876 329 901 q 234 801 256 851 q 201 675 211 751 q 191 497 191 599 "
  },
  1: {
    x_min: 121,
    x_max: 482.375,
    ha: 765,
    o: "m 482 0 l 363 0 l 363 619 q 363 682 363 648 q 364 748 363 715 q 366 811 365 781 q 368 864 367 841 q 348 843 356 852 q 330 826 339 834 q 310 809 320 818 q 286 788 300 800 l 186 706 l 121 789 l 380 992 l 482 992 l 482 0 "
  },
  2: {
    x_min: 65,
    x_max: 683.34375,
    ha: 765,
    o: "m 683 0 l 65 0 l 65 105 l 301 364 q 392 464 352 419 q 460 553 432 510 q 503 640 488 596 q 518 736 518 684 q 507 806 518 775 q 474 857 495 836 q 423 890 452 879 q 358 900 394 900 q 242 874 294 900 q 144 808 190 849 l 75 889 q 133 935 102 913 q 200 972 164 956 q 276 996 236 987 q 360 1006 316 1006 q 478 987 425 1006 q 567 935 530 969 q 623 851 603 900 q 644 740 644 802 q 626 630 644 683 q 576 528 608 578 q 501 426 545 477 q 406 320 457 375 l 216 118 l 216 112 l 683 112 l 683 0 "
  },
  3: {
    x_min: 56,
    x_max: 682,
    ha: 765,
    o: "m 651 759 q 635 668 651 709 q 591 598 619 628 q 524 548 563 568 q 436 521 484 529 l 436 517 q 619 441 556 502 q 682 281 682 379 q 659 162 682 216 q 593 68 637 108 q 480 7 548 29 q 318 -14 411 -14 q 178 -2 244 -14 q 56 39 113 9 l 56 154 q 184 107 115 124 q 316 91 252 91 q 424 104 378 91 q 499 142 469 118 q 542 204 528 167 q 556 285 556 240 q 538 363 556 331 q 487 417 520 396 q 405 448 453 438 q 297 458 357 458 l 207 458 l 207 564 l 297 564 q 395 577 352 564 q 466 616 437 591 q 510 675 495 641 q 525 751 525 710 q 513 814 525 786 q 478 861 501 842 q 425 890 456 880 q 355 900 393 900 q 227 878 283 900 q 122 819 172 855 l 60 904 q 117 943 85 925 q 185 975 148 961 q 265 997 223 989 q 355 1006 307 1006 q 483 987 428 1006 q 575 936 538 969 q 632 858 613 903 q 651 759 651 812 "
  },
  4: {
    x_min: 16,
    x_max: 738,
    ha: 765,
    o: "m 738 222 l 593 222 l 593 0 l 474 0 l 474 222 l 16 222 l 16 329 l 465 997 l 593 997 l 593 334 l 738 334 l 738 222 m 474 334 l 474 576 q 475 656 474 614 q 477 737 476 697 q 480 811 478 777 q 482 869 482 846 l 476 869 q 464 839 471 855 q 449 806 457 822 q 431 773 440 789 q 415 747 423 758 l 136 334 l 474 334 "
  },
  5: {
    x_min: 89,
    x_max: 688,
    ha: 765,
    o: "m 369 608 q 494 589 436 608 q 596 534 552 570 q 663 443 639 497 q 688 317 688 388 q 664 178 688 240 q 596 74 641 116 q 484 8 550 31 q 330 -14 417 -14 q 262 -10 295 -14 q 197 0 228 -7 q 139 15 167 5 q 89 39 111 26 l 89 156 q 141 128 111 140 q 205 108 172 116 q 272 95 238 99 q 334 91 306 91 q 430 103 388 91 q 501 142 472 116 q 546 208 531 169 q 562 303 562 248 q 502 451 562 400 q 328 502 442 502 q 288 501 310 502 q 245 496 267 499 q 204 491 224 494 q 171 485 185 487 l 110 523 l 147 992 l 615 992 l 615 879 l 254 879 l 228 594 q 285 603 249 598 q 369 608 320 608 "
  },
  6: {
    x_min: 77,
    x_max: 701,
    ha: 765,
    o: "m 77 423 q 84 565 77 494 q 109 700 91 636 q 158 821 127 765 q 237 918 189 877 q 352 982 285 959 q 509 1006 419 1006 q 538 1005 522 1006 q 569 1002 553 1004 q 600 998 585 1001 q 626 992 614 996 l 626 884 q 573 896 602 892 q 514 900 543 900 q 407 886 453 900 q 327 845 361 872 q 271 783 294 819 q 234 703 248 747 q 213 609 220 659 q 205 505 207 559 l 213 505 q 245 551 226 530 q 290 588 265 572 q 348 612 316 603 q 420 621 380 621 q 536 600 484 621 q 624 542 588 580 q 681 447 661 503 q 701 319 701 391 q 680 180 701 242 q 619 75 659 118 q 524 9 580 32 q 400 -14 469 -14 q 273 12 332 -14 q 170 93 213 38 q 102 229 127 147 q 77 423 77 311 m 399 91 q 473 105 440 91 q 531 147 506 118 q 568 218 555 175 q 581 320 581 261 q 570 405 581 367 q 537 469 559 442 q 481 509 514 495 q 403 524 448 524 q 321 508 358 524 q 257 466 283 492 q 216 408 231 441 q 202 343 202 376 q 214 253 202 298 q 251 172 227 208 q 313 113 276 136 q 399 91 350 91 "
  },
  7: {
    x_min: 61,
    x_max: 699,
    ha: 765,
    o: "m 190 0 l 572 879 l 61 879 l 61 992 l 699 992 l 699 893 l 322 0 l 190 0 "
  },
  8: {
    x_min: 72,
    x_max: 694,
    ha: 765,
    o: "m 383 1007 q 490 992 440 1007 q 579 947 540 977 q 639 873 617 917 q 662 768 662 828 q 648 686 662 723 q 610 620 634 650 q 554 568 587 591 q 483 525 521 544 q 561 478 523 504 q 628 420 598 453 q 675 348 657 388 q 694 258 694 308 q 671 145 694 196 q 607 59 648 94 q 509 5 566 24 q 383 -14 452 -14 q 250 4 308 -14 q 152 57 192 22 q 92 141 113 91 q 72 253 72 190 q 87 344 72 304 q 128 418 102 385 q 189 476 154 451 q 264 520 225 501 q 202 566 231 541 q 151 621 172 590 q 117 688 130 651 q 105 770 105 725 q 127 873 105 829 q 188 947 150 917 q 277 992 227 977 q 383 1007 328 1007 m 191 253 q 202 187 191 217 q 236 136 213 157 q 295 102 259 114 q 379 91 330 91 q 464 102 427 91 q 525 136 500 114 q 562 189 550 158 q 574 258 574 220 q 561 322 574 293 q 523 374 547 350 q 463 420 498 399 q 385 463 428 442 l 364 472 q 235 379 278 432 q 191 253 191 327 m 381 901 q 266 866 309 901 q 224 762 224 830 q 236 696 224 724 q 269 647 248 669 q 320 609 290 626 q 384 576 349 592 q 446 608 417 590 q 496 647 475 625 q 530 698 518 670 q 542 762 542 726 q 499 866 542 830 q 381 901 456 901 "
  },
  9: {
    x_min: 72,
    x_max: 697,
    ha: 765,
    o: "m 697 568 q 689 426 697 497 q 664 290 682 355 q 615 170 646 226 q 536 73 584 114 q 421 9 488 32 q 263 -14 354 -14 q 235 -13 250 -14 q 204 -11 219 -12 q 173 -7 188 -9 q 147 -2 158 -5 l 147 99 q 200 87 171 91 q 259 82 230 82 q 410 115 351 82 q 504 203 469 147 q 553 332 538 258 q 571 486 568 405 l 562 486 q 530 440 549 461 q 485 404 511 419 q 426 379 459 388 q 354 371 394 371 q 237 391 289 371 q 148 449 185 411 q 92 544 112 488 q 72 672 72 600 q 93 811 72 749 q 153 916 114 873 q 248 982 192 959 q 373 1006 304 1006 q 501 979 442 1006 q 603 898 560 953 q 671 762 646 844 q 697 568 697 679 m 374 900 q 300 887 334 900 q 242 845 266 873 q 204 773 217 816 q 191 671 191 730 q 202 586 191 624 q 236 522 213 549 q 292 482 258 496 q 370 467 326 467 q 454 483 417 467 q 518 525 491 499 q 559 583 545 550 q 574 648 574 615 q 561 738 574 693 q 524 819 549 783 q 462 878 499 856 q 374 900 424 900 "
  },
  ǻ: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 308 1166 q 338 1203 322 1182 q 370 1246 354 1224 q 401 1290 386 1268 q 426 1331 415 1311 l 575 1331 l 575 1320 q 542 1283 564 1305 q 495 1236 521 1261 q 441 1190 469 1212 q 389 1153 413 1167 l 308 1153 l 308 1166 m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 522 959 q 510 897 522 924 q 477 850 498 869 q 428 821 456 831 q 366 812 400 812 q 305 821 332 812 q 257 850 277 831 q 226 896 237 869 q 215 958 215 923 q 226 1019 215 992 q 257 1065 237 1046 q 305 1094 277 1084 q 366 1104 332 1104 q 427 1094 399 1104 q 477 1065 456 1084 q 510 1020 498 1046 q 522 959 522 993 m 447 958 q 425 1014 447 994 q 368 1034 403 1034 q 311 1014 333 1034 q 289 958 289 994 q 309 901 289 921 q 368 881 329 881 q 425 901 403 881 q 447 958 447 921 "
  },
  Á: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 362 1089 q 392 1134 376 1108 q 424 1187 408 1160 q 455 1242 440 1215 q 480 1293 469 1269 l 629 1293 l 629 1278 q 596 1233 618 1260 q 549 1175 575 1205 q 495 1118 523 1146 q 444 1071 467 1089 l 362 1071 l 362 1089 "
  },
  ĥ: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 1055 l 241 1055 l 241 741 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 m 655 1109 l 573 1109 q 501 1164 538 1131 q 430 1234 465 1197 q 357 1164 393 1197 q 287 1109 321 1131 l 205 1109 l 205 1127 q 245 1172 222 1146 q 291 1225 268 1198 q 334 1280 314 1253 q 364 1331 354 1307 l 495 1331 q 525 1280 505 1307 q 568 1225 545 1253 q 614 1172 591 1198 q 655 1127 638 1146 l 655 1109 "
  },
  Κ: {
    x_min: 135,
    x_max: 804.25,
    ha: 804,
    o: "m 804 0 l 661 0 l 355 473 l 261 396 l 261 0 l 135 0 l 135 992 l 261 992 l 261 496 l 343 609 l 649 992 l 791 992 l 438 559 l 804 0 "
  },
  "»": {
    x_min: 57,
    x_max: 621.5,
    ha: 676,
    o: "m 621 356 l 411 78 l 333 130 l 494 367 l 333 603 l 411 656 l 621 375 l 621 356 m 345 356 l 136 78 l 57 130 l 218 367 l 57 603 l 136 656 l 345 375 l 345 356 "
  },
  "∆": {
    x_min: 28,
    x_max: 761,
    ha: 789,
    o: "m 28 76 l 330 992 l 457 992 l 761 75 l 761 0 l 28 0 l 28 76 m 456 625 q 419 748 434 691 q 393 856 403 805 q 367 748 381 805 q 333 629 353 691 l 161 111 l 627 111 l 456 625 "
  },
  ў: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 m 607 1058 q 586 964 602 1005 q 538 897 569 924 q 458 855 506 869 q 342 842 410 842 q 225 855 273 842 q 148 895 177 868 q 104 963 118 922 q 87 1058 90 1003 l 202 1058 q 214 990 205 1016 q 241 949 224 964 q 283 929 258 934 q 345 923 309 923 q 400 930 375 923 q 443 952 425 937 q 473 993 461 968 q 488 1058 484 1019 l 607 1058 "
  },
  ţ: {
    x_min: 23,
    x_max: 445,
    ha: 471,
    o: "m 343 88 q 371 89 355 88 q 400 93 386 91 q 426 97 415 95 q 445 102 438 100 l 445 8 q 422 0 436 3 q 392 -7 409 -4 q 358 -12 376 -10 q 324 -14 341 -14 q 246 -3 282 -14 q 184 34 210 7 q 142 106 157 61 q 128 221 128 152 l 128 656 l 23 656 l 23 709 l 128 759 l 180 915 l 251 915 l 251 745 l 439 745 l 439 656 l 251 656 l 251 221 q 272 121 251 155 q 343 88 294 88 m 138 -288 q 154 -246 145 -271 q 171 -191 163 -220 q 185 -135 179 -163 q 194 -85 192 -107 l 317 -85 l 317 -98 q 302 -141 312 -115 q 276 -197 291 -167 q 242 -255 261 -226 q 204 -307 224 -284 l 138 -307 l 138 -288 "
  },
  "«": {
    x_min: 55.5,
    x_max: 620,
    ha: 676,
    o: "m 55 375 l 264 656 l 344 603 l 183 367 l 344 130 l 264 78 l 55 356 l 55 375 m 331 375 l 541 656 l 620 603 l 459 367 l 620 130 l 541 78 l 331 356 l 331 375 "
  },
  í: {
    x_min: 118,
    x_max: 392,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 125 860 q 155 905 139 879 q 187 958 171 931 q 218 1013 203 986 q 243 1064 232 1040 l 392 1064 l 392 1049 q 359 1004 381 1031 q 312 946 338 976 q 258 889 286 917 q 207 842 230 860 l 125 842 l 125 860 "
  },
  ņ: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 m 300 -288 q 316 -246 307 -271 q 333 -191 325 -220 q 347 -135 341 -163 q 356 -85 354 -107 l 479 -85 l 479 -98 q 464 -141 474 -115 q 438 -197 453 -167 q 404 -255 423 -226 q 366 -307 386 -284 l 300 -307 l 300 -288 "
  },
  µ: {
    x_min: 118,
    x_max: 706,
    ha: 825,
    o: "m 241 264 q 277 132 241 176 q 388 88 313 88 q 481 106 443 88 q 540 158 518 123 q 573 242 563 192 q 582 357 582 292 l 582 745 l 706 745 l 706 0 l 606 0 l 588 99 l 581 99 q 500 14 548 43 q 381 -14 451 -14 q 296 1 332 -14 q 237 45 261 17 q 239 -7 238 19 q 241 -59 240 -30 q 241 -117 241 -88 l 241 -334 l 118 -334 l 118 745 l 241 745 l 241 264 "
  },
  ỳ: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 m 411 842 l 329 842 q 277 889 305 860 q 223 946 249 917 q 176 1004 197 976 q 144 1049 154 1031 l 144 1064 l 292 1064 q 318 1013 303 1040 q 348 958 332 986 q 380 905 364 931 q 411 860 396 879 l 411 842 "
  },
  Ι: {
    x_min: 55.34375,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 "
  },
  Ύ: {
    x_min: -18,
    x_max: 924.25,
    ha: 925,
    o: "m 557 490 l 788 992 l 924 992 l 621 386 l 621 0 l 495 0 l 495 379 l 192 992 l 330 992 l 557 490 m -18 789 q -4 835 -11 809 q 8 889 2 861 q 20 943 15 916 q 29 993 26 970 l 164 993 l 164 978 q 148 936 159 962 q 122 880 137 909 q 89 821 106 850 q 55 771 71 792 l -18 771 l -18 789 "
  },
  ѕ: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 "
  },
  Ш: {
    x_min: 135,
    x_max: 1250,
    ha: 1385,
    o: "m 1250 0 l 135 0 l 135 992 l 261 992 l 261 111 l 629 111 l 629 992 l 755 992 l 755 111 l 1123 111 l 1123 992 l 1250 992 l 1250 0 "
  },
  M: {
    x_min: 135,
    x_max: 1074,
    ha: 1209,
    o: "m 544 0 l 253 868 l 248 868 q 255 768 252 818 q 259 678 257 726 q 261 593 261 631 l 261 0 l 135 0 l 135 992 l 331 992 l 601 183 l 605 183 l 886 992 l 1074 992 l 1074 0 l 947 0 l 947 601 q 949 682 947 637 q 952 769 950 728 q 957 867 955 817 l 951 867 l 648 0 l 544 0 "
  },
  Ψ: {
    x_min: 71,
    x_max: 994,
    ha: 1065,
    o: "m 994 667 q 985 582 994 625 q 959 499 977 539 q 913 423 942 458 q 844 360 885 387 q 749 318 803 334 q 626 303 694 303 l 594 303 l 594 0 l 468 0 l 468 303 l 436 303 q 314 318 368 303 q 220 359 260 333 q 151 421 179 386 q 105 497 122 456 q 79 580 87 537 q 71 664 71 623 l 71 992 l 204 992 l 204 667 q 219 560 204 607 q 265 479 235 512 q 342 428 295 446 q 450 410 388 410 l 468 410 l 468 992 l 594 992 l 594 410 l 611 410 q 798 477 737 410 q 860 664 860 544 l 860 992 l 994 992 l 994 667 "
  },
  ũ: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 510 843 q 456 854 483 843 q 404 881 430 866 q 354 907 378 895 q 309 919 330 919 q 262 901 278 919 q 236 841 246 883 l 166 841 q 180 915 169 882 q 209 972 191 948 q 252 1008 227 995 q 309 1021 277 1021 q 365 1009 337 1021 q 418 982 392 997 q 467 956 444 968 q 510 944 491 944 q 556 962 541 944 q 582 1022 572 980 l 654 1022 q 639 948 650 981 q 610 892 628 915 q 567 855 592 868 q 510 843 542 843 "
  },
  ŭ: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 612 1030 q 594 954 609 988 q 553 894 579 920 q 490 855 527 869 q 405 842 453 842 q 318 855 355 842 q 257 893 281 868 q 219 952 232 918 q 204 1030 206 987 l 278 1030 q 290 983 281 1000 q 316 957 300 965 q 355 946 332 948 q 408 943 378 943 q 454 946 432 943 q 494 959 476 949 q 523 985 511 968 q 537 1030 534 1002 l 612 1030 "
  },
  "―": {
    x_min: 56,
    x_max: 1333,
    ha: 1389,
    o: "m 56 315 l 56 429 l 1333 429 l 1333 315 l 56 315 "
  },
  "{": {
    x_min: 41,
    x_max: 456,
    ha: 492,
    o: "m 338 -10 q 346 -64 338 -43 q 369 -96 354 -84 q 407 -113 385 -108 q 456 -118 428 -117 l 456 -220 q 359 -208 404 -219 q 283 -172 315 -196 q 233 -110 251 -148 q 215 -19 215 -73 l 215 208 q 170 307 215 278 q 41 337 125 337 l 41 439 q 170 468 125 439 q 215 567 215 497 l 215 793 q 233 883 215 846 q 283 944 251 920 q 359 980 315 968 q 456 992 404 991 l 456 890 q 407 885 428 889 q 369 868 385 880 q 346 836 354 857 q 338 783 338 815 l 338 559 q 298 446 338 488 q 180 391 258 405 l 180 383 q 298 328 258 369 q 338 214 338 286 l 338 -10 "
  },
  "¼": {
    x_min: 42,
    x_max: 962.765625,
    ha: 1023,
    o: "m 207 992 l 297 992 l 297 397 l 201 397 l 201 754 q 201 792 201 771 q 202 833 201 813 q 204 873 203 854 q 206 908 205 893 q 184 881 196 895 q 156 853 171 866 l 92 799 l 42 864 l 207 992 m 815 992 l 264 0 l 157 0 l 708 992 l 815 992 m 962 133 l 877 133 l 877 0 l 781 0 l 781 133 l 526 133 l 526 208 l 782 599 l 877 599 l 877 217 l 962 217 l 962 133 m 781 217 l 781 368 q 782 439 781 400 q 785 515 783 477 q 774 492 781 507 q 760 462 767 478 q 744 430 752 445 q 729 403 736 414 l 622 217 l 781 217 "
  },
  Ḿ: {
    x_min: 135,
    x_max: 1074,
    ha: 1209,
    o: "m 544 0 l 253 868 l 248 868 q 255 768 252 818 q 259 678 257 726 q 261 593 261 631 l 261 0 l 135 0 l 135 992 l 331 992 l 601 183 l 605 183 l 886 992 l 1074 992 l 1074 0 l 947 0 l 947 601 q 949 682 947 637 q 952 769 950 728 q 957 867 955 817 l 951 867 l 648 0 l 544 0 m 522 1091 q 552 1136 536 1110 q 584 1189 568 1162 q 615 1244 600 1217 q 640 1295 629 1271 l 789 1295 l 789 1280 q 756 1235 778 1262 q 709 1177 735 1207 q 655 1120 683 1148 q 604 1073 627 1091 l 522 1073 l 522 1091 "
  },
  ι: {
    x_min: 111,
    x_max: 428,
    ha: 454,
    o: "m 234 743 l 234 220 q 255 121 234 154 q 326 88 277 88 q 353 89 338 88 q 383 93 368 91 q 409 97 397 95 q 428 102 421 100 l 428 8 q 405 0 419 3 q 375 -7 391 -4 q 341 -12 358 -10 q 307 -14 323 -14 q 229 -3 265 -14 q 167 34 193 7 q 125 105 140 60 q 111 219 111 150 l 111 743 l 234 743 "
  },
  Ĳ: {
    x_min: 55.34375,
    x_max: 722.15625,
    ha: 847,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 451 -264 q 390 -259 416 -264 q 346 -247 364 -255 l 346 -139 q 395 -149 369 -145 q 452 -152 422 -152 q 503 -146 477 -152 q 549 -122 528 -139 q 583 -76 570 -105 q 596 0 596 -46 l 596 992 l 722 992 l 722 13 q 702 -109 722 -57 q 646 -196 682 -162 q 561 -247 611 -230 q 451 -264 511 -264 "
  },
  Ê: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 616 1071 l 534 1071 q 462 1126 499 1093 q 391 1196 426 1159 q 318 1126 354 1159 q 248 1071 282 1093 l 166 1071 l 166 1089 q 206 1134 183 1108 q 252 1187 229 1160 q 295 1242 275 1215 q 325 1293 315 1269 l 456 1293 q 486 1242 466 1269 q 529 1187 506 1215 q 575 1134 552 1160 q 616 1089 599 1108 l 616 1071 "
  },
  Ά: {
    x_min: -16,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m -16 789 q -2 835 -9 809 q 10 889 4 861 q 22 943 17 916 q 31 993 28 970 l 166 993 l 166 978 q 150 936 161 962 q 124 880 139 909 q 91 821 108 850 q 57 771 73 792 l -16 771 l -16 789 "
  },
  ")": {
    x_min: 42,
    x_max: 363,
    ha: 418,
    o: "m 363 380 q 350 214 363 296 q 313 57 338 133 q 249 -89 287 -19 q 158 -220 211 -158 l 43 -220 q 126 -84 90 -156 q 186 64 162 -12 q 223 221 211 141 q 235 381 235 301 q 186 704 235 547 q 42 992 137 861 l 158 992 q 249 857 211 928 q 313 708 287 785 q 350 547 338 630 q 363 380 363 465 "
  },
  ε: {
    x_min: 61,
    x_max: 583,
    ha: 629,
    o: "m 453 439 l 453 336 l 366 336 q 229 305 273 336 q 184 210 184 274 q 198 152 184 176 q 235 114 212 129 q 291 94 259 100 q 360 88 323 88 q 426 93 395 88 q 484 106 457 98 q 535 125 511 114 q 580 146 559 135 l 580 37 q 486 0 540 14 q 359 -14 433 -14 q 226 2 282 -14 q 133 48 170 19 q 78 117 96 77 q 61 203 61 157 q 73 275 61 245 q 108 326 86 305 q 157 361 129 347 q 215 385 185 375 l 215 392 q 162 416 185 402 q 121 452 138 431 q 94 500 103 473 q 85 561 85 527 q 104 645 85 608 q 159 707 124 682 q 244 745 195 732 q 351 758 293 758 q 417 754 387 758 q 475 745 448 751 q 529 729 503 739 q 583 706 555 720 l 540 606 q 445 642 489 629 q 353 655 401 655 q 240 629 279 655 q 201 551 201 603 q 214 499 201 520 q 252 464 228 477 q 311 445 277 451 q 386 439 345 439 l 453 439 "
  },
  э: {
    x_min: 37,
    x_max: 566,
    ha: 642,
    o: "m 218 -14 q 115 -3 157 -14 q 37 26 73 6 l 37 135 q 118 106 73 118 q 219 93 163 93 q 308 107 269 93 q 376 149 348 121 q 420 223 404 178 q 439 331 437 268 l 114 331 l 114 434 l 438 434 q 379 598 429 547 q 234 650 329 650 q 197 647 217 650 q 156 638 176 644 q 116 627 135 633 q 82 614 97 621 l 45 718 q 83 733 62 726 q 130 746 105 741 q 180 754 154 751 q 233 758 207 758 q 363 736 302 758 q 468 669 424 715 q 539 548 513 623 q 566 367 566 474 q 538 196 566 268 q 463 78 511 125 q 352 8 415 31 q 218 -14 289 -14 "
  },
  ш: {
    x_min: 118,
    x_max: 1089,
    ha: 1207,
    o: "m 665 102 l 965 102 l 965 745 l 1089 745 l 1089 0 l 118 0 l 118 745 l 241 745 l 241 102 l 542 102 l 542 745 l 665 745 l 665 102 "
  },
  Я: {
    x_min: 16.75,
    x_max: 685,
    ha: 819,
    o: "m 391 410 l 165 0 l 16 0 l 275 444 q 204 479 237 458 q 145 533 170 500 q 104 612 119 566 q 90 721 90 658 q 175 923 90 855 q 431 992 261 992 l 685 992 l 685 0 l 558 0 l 558 410 l 391 410 m 558 884 l 432 884 q 343 874 382 884 q 277 843 304 864 q 237 789 251 822 q 223 710 223 756 q 236 630 223 666 q 276 569 249 595 q 342 531 302 544 q 437 517 382 517 l 558 517 l 558 884 "
  },
  a: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 "
  },
  Ę: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 489 -161 q 507 -206 489 -191 q 549 -220 525 -220 q 582 -218 566 -220 q 608 -214 598 -217 l 608 -291 q 568 -299 590 -296 q 527 -302 547 -302 q 425 -266 459 -302 q 392 -170 392 -231 q 401 -116 392 -142 q 427 -69 411 -91 q 460 -30 442 -48 q 496 0 479 -12 l 583 0 q 489 -161 489 -90 "
  },
  Z: {
    x_min: 56,
    x_max: 693,
    ha: 749,
    o: "m 693 0 l 56 0 l 56 97 l 537 880 l 70 880 l 70 992 l 679 992 l 679 894 l 197 111 l 693 111 l 693 0 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 231
  },
  k: {
    x_min: 118,
    x_max: 684.25,
    ha: 689,
    o: "m 233 384 l 324 500 l 522 745 l 665 745 l 394 422 l 684 0 l 542 0 l 315 341 l 241 286 l 241 0 l 118 0 l 118 1055 l 241 1055 l 241 571 l 230 384 l 233 384 "
  },
  Ù: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 575 1071 l 493 1071 q 441 1118 469 1089 q 387 1175 413 1146 q 340 1233 361 1205 q 308 1278 318 1260 l 308 1293 l 456 1293 q 482 1242 467 1269 q 512 1187 496 1215 q 544 1134 528 1160 q 575 1089 560 1108 l 575 1071 "
  },
  Ů: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 639 1218 q 627 1156 639 1183 q 594 1109 615 1128 q 545 1080 573 1090 q 483 1071 516 1071 q 421 1080 449 1071 q 373 1109 393 1090 q 342 1155 353 1128 q 332 1217 332 1182 q 342 1278 332 1251 q 373 1324 353 1305 q 421 1353 393 1343 q 483 1363 449 1363 q 544 1353 516 1363 q 594 1324 573 1343 q 627 1279 615 1305 q 639 1218 639 1252 m 564 1217 q 542 1273 564 1253 q 485 1293 520 1293 q 428 1273 450 1293 q 406 1217 406 1253 q 426 1160 406 1180 q 485 1140 446 1140 q 542 1160 520 1140 q 564 1217 564 1180 "
  },
  "¢": {
    x_min: 128,
    x_max: 647,
    ha: 765,
    o: "m 634 162 q 574 133 605 143 q 498 121 542 123 l 498 -14 l 382 -14 l 382 126 q 276 160 323 134 q 196 230 229 185 q 145 343 163 275 q 128 503 128 410 q 145 668 128 599 q 196 783 163 737 q 276 854 229 829 q 382 889 323 880 l 382 1006 l 498 1006 l 498 894 q 580 880 540 892 q 647 853 620 869 l 611 747 q 576 761 595 754 q 537 772 557 767 q 496 780 516 777 q 459 783 476 783 q 304 715 353 783 q 255 504 255 647 q 304 296 255 362 q 454 231 353 231 q 553 243 509 231 q 634 272 598 256 l 634 162 "
  },
  В: {
    x_min: 135,
    x_max: 786,
    ha: 863,
    o: "m 135 992 l 405 992 q 558 978 492 992 q 668 936 624 965 q 735 858 713 906 q 758 740 758 810 q 744 662 758 698 q 707 597 731 625 q 645 551 682 569 q 563 526 609 532 l 563 519 q 650 496 609 511 q 720 454 690 480 q 768 386 751 427 q 786 287 786 345 q 763 166 786 219 q 700 76 741 113 q 598 19 658 39 q 463 0 539 0 l 135 0 l 135 992 m 261 572 l 427 572 q 523 582 485 572 q 586 612 562 592 q 621 662 610 632 q 631 732 631 692 q 579 848 631 813 q 413 884 526 884 l 261 884 l 261 572 m 261 464 l 261 107 l 441 107 q 541 121 500 107 q 606 159 581 134 q 641 217 630 183 q 652 292 652 251 q 641 362 652 330 q 604 416 630 393 q 537 451 579 439 q 433 464 495 464 l 261 464 "
  },
  І: {
    x_min: 55.34375,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 "
  },
  ē: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 192 943 l 582 943 l 582 842 l 192 842 l 192 943 "
  },
  β: {
    x_min: 118,
    x_max: 774,
    ha: 836,
    o: "m 427 1063 q 548 1046 493 1063 q 643 996 603 1029 q 706 913 683 963 q 729 796 729 863 q 677 637 729 695 q 528 563 625 578 l 528 559 q 711 476 648 544 q 774 281 774 407 q 752 152 774 207 q 690 60 731 97 q 591 4 649 23 q 458 -14 532 -14 q 337 -3 393 -14 q 241 28 282 7 l 241 -334 l 118 -334 l 118 743 q 141 887 118 826 q 205 986 164 947 q 303 1044 246 1025 q 427 1063 360 1063 m 427 960 q 355 950 389 960 q 296 913 321 939 q 256 845 271 888 q 241 737 241 802 l 241 142 q 289 120 263 130 q 344 102 316 110 q 399 92 371 95 q 452 88 427 88 q 544 101 506 88 q 605 141 581 115 q 640 205 629 167 q 650 291 650 243 q 632 385 650 345 q 581 451 614 425 q 504 490 549 477 q 405 502 459 502 l 336 502 l 336 605 l 388 605 q 483 618 443 605 q 550 656 523 632 q 589 715 576 681 q 601 791 601 750 q 588 865 601 834 q 552 918 575 897 q 497 950 529 939 q 427 960 465 960 "
  },
  "≠": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 237 300 l 69 300 l 69 402 l 285 402 l 367 577 l 69 577 l 69 679 l 414 679 l 504 870 l 598 830 l 526 679 l 696 679 l 696 577 l 479 577 l 396 402 l 696 402 l 696 300 l 349 300 l 260 111 l 167 150 l 237 300 "
  },
  "‼": {
    x_min: 100,
    x_max: 587.265625,
    ha: 688,
    o: "m 543 280 l 461 280 l 427 992 l 577 992 l 543 280 m 415 74 q 421 118 415 100 q 440 147 428 136 q 467 163 451 158 q 501 169 482 169 q 534 163 518 169 q 562 147 550 158 q 580 118 573 136 q 587 74 587 100 q 580 31 587 49 q 562 2 573 13 q 534 -14 550 -9 q 501 -20 518 -20 q 467 -14 482 -20 q 440 2 451 -9 q 421 31 428 13 q 415 74 415 49 m 228 280 l 146 280 l 112 992 l 262 992 l 228 280 m 100 74 q 106 118 100 100 q 125 147 113 136 q 152 163 136 158 q 186 169 167 169 q 219 163 203 169 q 247 147 235 158 q 265 118 258 136 q 272 74 272 100 q 265 31 272 49 q 247 2 258 13 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 167 -20 q 125 2 136 -9 q 106 31 113 13 q 100 74 100 49 "
  },
  "¥": {
    x_min: 20,
    x_max: 751,
    ha: 765,
    o: "m 384 490 l 621 992 l 751 992 l 490 471 l 652 471 l 652 363 l 448 363 l 448 271 l 652 271 l 652 163 l 448 163 l 448 0 l 322 0 l 322 163 l 118 163 l 118 271 l 322 271 l 322 363 l 118 363 l 118 471 l 276 471 l 20 992 l 150 992 l 384 490 "
  },
  Ĥ: {
    x_min: 135,
    x_max: 839,
    ha: 974,
    o: "m 839 0 l 712 0 l 712 462 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 712 574 l 712 992 l 839 992 l 839 0 m 712 1071 l 630 1071 q 558 1126 595 1093 q 487 1196 522 1159 q 414 1126 450 1159 q 344 1071 378 1093 l 262 1071 l 262 1089 q 302 1134 279 1108 q 348 1187 325 1160 q 391 1242 371 1215 q 421 1293 411 1269 l 552 1293 q 582 1242 562 1269 q 625 1187 602 1215 q 671 1134 648 1160 q 712 1089 695 1108 l 712 1071 "
  },
  U: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 "
  },
  Ñ: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 m 614 1072 q 560 1083 587 1072 q 508 1110 534 1095 q 458 1136 482 1124 q 413 1148 434 1148 q 366 1130 382 1148 q 340 1070 350 1112 l 270 1070 q 284 1144 273 1111 q 313 1201 295 1177 q 356 1237 331 1224 q 413 1250 381 1250 q 469 1238 441 1250 q 522 1211 496 1226 q 571 1185 548 1197 q 614 1173 595 1173 q 660 1191 645 1173 q 686 1251 676 1209 l 758 1251 q 743 1177 754 1210 q 714 1121 732 1144 q 671 1084 696 1097 q 614 1072 646 1072 "
  },
  F: {
    x_min: 135,
    x_max: 649,
    ha: 682,
    o: "m 261 0 l 135 0 l 135 992 l 649 992 l 649 880 l 261 880 l 261 531 l 623 531 l 623 419 l 261 419 l 261 0 "
  },
  ϑ: {
    x_min: 7.125,
    x_max: 815.203125,
    ha: 834,
    o: "m 594 664 q 566 793 585 736 q 521 888 547 850 q 464 948 495 927 q 401 968 433 968 q 321 939 350 968 q 292 861 292 909 q 307 788 292 824 q 359 726 323 753 q 452 681 394 698 q 594 664 509 664 m 722 575 q 724 540 723 560 q 725 499 725 520 q 703 296 725 390 q 637 133 681 202 q 527 25 594 64 q 372 -14 461 -14 q 247 4 297 -14 q 169 55 198 23 q 128 129 140 87 q 117 218 117 172 q 120 277 117 245 q 127 338 123 308 q 134 394 131 368 q 138 435 138 419 q 127 477 138 466 q 95 488 117 488 q 61 483 79 488 q 32 471 43 478 l 7 560 q 66 581 32 572 q 136 591 100 591 q 194 581 171 591 q 233 555 218 572 q 255 515 248 538 q 261 465 261 492 q 258 412 261 441 q 250 351 254 383 q 243 287 247 320 q 240 224 240 254 q 247 170 240 195 q 270 127 254 145 q 313 98 287 109 q 379 88 340 88 q 546 192 490 88 q 601 503 601 296 q 600 540 601 519 q 598 575 600 561 q 398 601 480 576 q 265 667 316 626 q 191 759 214 707 q 169 865 169 810 q 182 947 169 909 q 222 1012 195 985 q 293 1055 250 1040 q 396 1071 336 1071 q 521 1042 466 1071 q 615 961 576 1014 q 680 833 655 908 q 718 664 706 757 l 815 664 l 815 575 l 722 575 "
  },
  Ќ: {
    x_min: 135,
    x_max: 804.25,
    ha: 804,
    o: "m 804 0 l 655 0 l 261 502 l 261 0 l 135 0 l 135 992 l 261 992 l 261 511 l 644 992 l 784 992 l 401 515 l 804 0 m 359 1089 q 389 1134 373 1108 q 421 1187 405 1160 q 452 1242 437 1215 q 477 1293 466 1269 l 626 1293 l 626 1278 q 593 1233 615 1260 q 546 1175 572 1205 q 492 1118 520 1146 q 441 1071 464 1089 l 359 1071 l 359 1089 "
  },
  å: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 531 989 q 519 927 531 954 q 486 880 507 899 q 437 851 465 861 q 375 842 408 842 q 313 851 341 842 q 265 880 285 861 q 234 926 245 899 q 224 988 224 953 q 234 1049 224 1022 q 265 1095 245 1076 q 313 1124 285 1114 q 375 1134 341 1134 q 436 1124 408 1134 q 486 1095 465 1114 q 519 1050 507 1076 q 531 989 531 1023 m 456 988 q 434 1044 456 1024 q 377 1064 412 1064 q 320 1044 342 1064 q 298 988 298 1024 q 318 931 298 951 q 377 911 338 911 q 434 931 412 911 q 456 988 456 951 "
  },
  Ϋ: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 m 174 1174 q 192 1227 174 1211 q 239 1244 211 1244 q 285 1227 265 1244 q 304 1174 304 1210 q 285 1121 304 1138 q 239 1105 265 1105 q 192 1121 211 1105 q 174 1174 174 1138 m 428 1174 q 447 1227 428 1211 q 493 1244 466 1244 q 518 1239 506 1244 q 539 1227 530 1235 q 553 1206 548 1218 q 559 1174 559 1193 q 539 1121 559 1138 q 493 1105 519 1105 q 447 1121 466 1105 q 428 1174 428 1138 "
  },
  ō: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 206 943 l 596 943 l 596 842 l 206 842 l 206 943 "
  },
  "”": {
    x_min: 16,
    x_max: 489,
    ha: 504,
    o: "m 219 992 l 228 977 q 205 898 218 939 q 176 815 192 857 q 143 731 160 772 q 108 652 125 690 l 16 652 q 38 737 26 692 q 60 827 49 782 q 79 913 70 871 q 94 992 88 956 l 219 992 m 480 992 l 489 977 q 466 898 479 939 q 437 815 453 857 q 404 731 421 772 q 369 652 386 690 l 277 652 q 299 737 287 692 q 321 827 310 782 q 340 913 331 871 q 355 992 349 956 l 480 992 "
  },
  ö: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 204 945 q 222 998 204 982 q 269 1015 241 1015 q 315 998 295 1015 q 334 945 334 981 q 315 892 334 909 q 269 876 295 876 q 222 892 241 876 q 204 945 204 909 m 458 945 q 477 998 458 982 q 523 1015 496 1015 q 548 1010 536 1015 q 569 998 560 1006 q 583 977 578 989 q 589 945 589 964 q 569 892 589 909 q 523 876 549 876 q 477 892 496 876 q 458 945 458 909 "
  },
  ć: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 m 316 860 q 346 905 330 879 q 378 958 362 931 q 409 1013 394 986 q 434 1064 423 1040 l 583 1064 l 583 1049 q 550 1004 572 1031 q 503 946 529 976 q 449 889 477 917 q 398 842 421 860 l 316 842 l 316 860 "
  },
  þ: {
    x_min: 118,
    x_max: 737,
    ha: 814,
    o: "m 241 644 q 276 688 257 667 q 322 724 296 709 q 381 748 348 739 q 454 758 413 758 q 570 733 518 758 q 659 660 622 709 q 716 540 696 612 q 737 373 737 468 q 716 205 737 277 q 659 84 696 133 q 570 10 622 35 q 454 -14 518 -14 q 381 -5 414 -14 q 323 18 349 3 q 277 52 297 32 q 241 93 257 72 l 233 93 q 237 49 235 70 q 240 13 238 32 q 241 -16 241 -5 l 241 -334 l 118 -334 l 118 1055 l 241 1055 l 241 744 l 236 644 l 241 644 m 430 655 q 343 639 379 655 q 285 592 307 624 q 253 513 263 560 q 241 401 242 465 l 241 373 q 250 251 241 304 q 281 162 259 198 q 340 107 303 125 q 431 88 377 88 q 566 162 523 88 q 609 374 609 236 q 566 585 609 515 q 430 655 523 655 "
  },
  "]": {
    x_min: 35,
    x_max: 310,
    ha: 421,
    o: "m 35 -118 l 186 -118 l 186 890 l 35 890 l 35 992 l 310 992 l 310 -220 l 35 -220 l 35 -118 "
  },
  А: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 "
  },
  "′": {
    x_min: 90,
    x_max: 223.609375,
    ha: 314,
    o: "m 223 992 l 195 634 l 117 634 l 90 992 l 223 992 "
  },
  Ы: {
    x_min: 135,
    x_max: 1008,
    ha: 1143,
    o: "m 729 290 q 708 170 729 224 q 645 79 688 117 q 537 20 602 41 q 380 0 471 0 l 135 0 l 135 992 l 261 992 l 261 574 l 362 574 q 536 551 465 574 q 648 490 606 529 q 710 400 691 452 q 729 290 729 349 m 261 107 l 368 107 q 540 152 485 107 q 595 290 595 197 q 579 370 595 337 q 533 424 564 403 q 456 453 503 444 q 347 462 410 462 l 261 462 l 261 107 m 881 0 l 881 992 l 1008 992 l 1008 0 l 881 0 "
  },
  ẁ: {
    x_min: 13.75,
    x_max: 1022.25,
    ha: 1036,
    o: "m 683 0 l 570 417 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 546 542 529 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 13 745 l 143 745 l 232 348 q 245 282 239 318 q 258 211 252 246 q 269 146 264 177 q 277 95 274 115 l 281 95 q 290 142 284 113 q 303 205 296 172 q 317 270 310 238 q 331 324 325 302 l 453 745 l 586 745 l 702 324 q 716 270 709 301 q 732 207 724 239 q 745 145 739 175 q 754 95 751 115 l 758 95 q 764 142 760 113 q 775 207 769 172 q 788 279 781 242 q 803 348 795 316 l 896 745 l 1022 745 l 829 0 l 683 0 m 585 842 l 503 842 q 451 889 479 860 q 397 946 423 917 q 350 1004 371 976 q 318 1049 328 1031 l 318 1064 l 466 1064 q 492 1013 477 1040 q 522 958 506 986 q 554 905 538 931 q 585 860 570 879 l 585 842 "
  },
  ĭ: {
    x_min: -23,
    x_max: 385,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 385 1030 q 367 954 382 988 q 326 894 352 920 q 263 855 300 869 q 178 842 226 842 q 91 855 128 842 q 30 893 54 868 q -7 952 5 918 q -23 1030 -20 987 l 51 1030 q 63 983 54 1000 q 89 957 73 965 q 128 946 105 948 q 181 943 151 943 q 227 946 205 943 q 267 959 249 949 q 296 985 284 968 q 310 1030 307 1002 l 385 1030 "
  },
  R: {
    x_min: 135,
    x_max: 803.25,
    ha: 819,
    o: "m 261 410 l 261 0 l 135 0 l 135 992 l 376 992 q 642 922 556 992 q 729 710 729 852 q 712 607 729 651 q 668 531 695 563 q 605 479 640 500 q 533 444 570 458 l 803 0 l 654 0 l 416 410 l 261 410 m 261 517 l 371 517 q 473 529 431 517 q 543 564 516 541 q 582 623 570 588 q 595 704 595 658 q 581 787 595 753 q 540 842 567 821 q 469 874 512 864 q 368 884 426 884 l 261 884 l 261 517 "
  },
  Ż: {
    x_min: 56,
    x_max: 693,
    ha: 749,
    o: "m 693 0 l 56 0 l 56 97 l 537 880 l 70 880 l 70 992 l 679 992 l 679 894 l 197 111 l 693 111 l 693 0 m 310 1174 q 330 1233 310 1215 q 381 1252 351 1252 q 410 1247 396 1252 q 433 1233 423 1243 q 448 1209 442 1224 q 454 1174 454 1195 q 433 1116 454 1135 q 381 1097 411 1097 q 330 1115 351 1097 q 310 1174 310 1134 "
  },
  ħ: {
    x_min: 12.1875,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 451 q 547 583 583 539 q 436 627 512 627 q 343 609 381 627 q 283 557 306 592 q 251 473 261 523 q 241 357 241 422 l 241 0 l 118 0 l 118 843 l 12 843 l 12 932 l 118 932 l 118 1055 l 241 1055 l 241 932 l 498 932 l 498 843 l 241 843 l 241 715 l 236 616 l 242 616 q 283 666 259 645 q 334 702 306 687 q 393 723 362 716 q 457 730 424 730 q 644 665 581 730 q 707 458 707 600 l 707 0 l 583 0 "
  },
  õ: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 499 843 q 445 854 472 843 q 393 881 419 866 q 343 907 367 895 q 298 919 319 919 q 251 901 267 919 q 225 841 235 883 l 155 841 q 169 915 158 882 q 198 972 180 948 q 241 1008 216 995 q 298 1021 266 1021 q 354 1009 326 1021 q 407 982 381 997 q 456 956 433 968 q 499 944 480 944 q 545 962 530 944 q 571 1022 561 980 l 643 1022 q 628 948 639 981 q 599 892 617 915 q 556 855 581 868 q 499 843 531 843 "
  },
  "˙": {
    x_min: 109,
    x_max: 253.46875,
    ha: 359,
    o: "m 109 945 q 129 1004 109 986 q 180 1023 150 1023 q 209 1018 195 1023 q 232 1004 222 1014 q 247 980 241 995 q 253 945 253 966 q 232 887 253 906 q 180 868 210 868 q 129 886 150 868 q 109 945 109 905 "
  },
  ê: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 602 842 l 520 842 q 448 897 485 864 q 377 967 412 930 q 304 897 340 930 q 234 842 268 864 l 152 842 l 152 860 q 192 905 169 879 q 238 958 215 931 q 281 1013 261 986 q 311 1064 301 1040 l 442 1064 q 472 1013 452 1040 q 515 958 492 986 q 561 905 538 931 q 602 860 585 879 l 602 842 "
  },
  "″": {
    x_min: 90,
    x_max: 468.609375,
    ha: 558,
    o: "m 223 992 l 195 634 l 117 634 l 90 992 l 223 992 m 468 992 l 440 634 l 362 634 l 335 992 l 468 992 "
  },
  "„": {
    x_min: 43,
    x_max: 517,
    ha: 608,
    o: "m 246 161 l 256 145 q 233 67 246 108 q 204 -15 220 26 q 170 -99 188 -57 q 136 -179 153 -141 l 43 -179 q 66 -92 54 -137 q 88 -3 77 -48 q 107 82 98 40 q 122 161 116 125 l 246 161 m 508 161 l 517 145 q 494 67 507 108 q 465 -15 481 26 q 432 -99 449 -57 q 397 -179 414 -141 l 305 -179 q 327 -92 315 -137 q 349 -3 338 -48 q 368 82 359 40 q 383 161 377 125 l 508 161 "
  },
  ч: {
    x_min: 104,
    x_max: 693,
    ha: 811,
    o: "m 227 745 l 227 466 q 352 348 227 348 q 410 353 382 348 q 462 368 437 358 q 514 392 488 377 q 569 427 541 407 l 569 745 l 693 745 l 693 0 l 569 0 l 569 332 q 512 295 539 311 q 456 268 485 279 q 395 251 427 257 q 324 246 363 246 q 230 261 271 246 q 161 306 188 277 q 118 373 133 334 q 104 458 104 412 l 104 745 l 227 745 "
  },
  δ: {
    x_min: 75,
    x_max: 725,
    ha: 802,
    o: "m 360 635 q 291 683 322 657 q 236 737 259 708 q 201 800 214 767 q 189 872 189 833 q 206 956 189 921 q 254 1016 223 992 q 328 1051 286 1039 q 421 1063 370 1063 q 505 1056 467 1063 q 576 1038 543 1049 q 636 1015 609 1028 q 687 989 663 1001 l 637 890 q 590 916 615 903 q 538 938 565 928 q 479 954 510 948 q 413 960 448 960 q 364 952 385 960 q 331 933 344 945 q 311 904 317 920 q 305 869 305 887 q 314 823 305 844 q 344 781 324 802 q 398 738 364 760 q 479 689 431 716 q 583 619 537 655 q 660 539 629 582 q 708 447 691 496 q 725 337 725 397 q 701 185 725 251 q 635 75 678 120 q 531 8 592 31 q 397 -14 471 -14 q 268 6 327 -14 q 166 67 209 27 q 99 164 123 106 q 75 296 75 222 q 97 423 75 368 q 159 520 120 479 q 249 590 197 562 q 360 635 301 618 m 597 325 q 587 410 597 372 q 557 478 577 448 q 510 533 538 508 q 446 579 482 557 q 363 548 407 568 q 284 495 320 528 q 225 413 249 462 q 202 294 202 363 q 215 211 202 249 q 253 146 228 173 q 314 103 278 118 q 395 88 350 88 q 545 149 492 88 q 597 325 597 210 "
  },
  Â: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 647 1071 l 565 1071 q 493 1126 530 1093 q 422 1196 457 1159 q 349 1126 385 1159 q 279 1071 313 1093 l 197 1071 l 197 1089 q 237 1134 214 1108 q 283 1187 260 1160 q 326 1242 306 1215 q 356 1293 346 1269 l 487 1293 q 517 1242 497 1269 q 560 1187 537 1215 q 606 1134 583 1160 q 647 1089 630 1108 l 647 1071 "
  },
  Į: {
    x_min: 55.34375,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 224 -161 q 242 -206 224 -191 q 284 -220 260 -220 q 317 -218 301 -220 q 343 -214 333 -217 l 343 -291 q 303 -299 325 -296 q 262 -302 282 -302 q 160 -266 194 -302 q 127 -170 127 -231 q 136 -116 127 -142 q 162 -69 146 -91 q 195 -30 177 -48 q 231 0 214 -12 l 318 0 q 224 -161 224 -90 "
  },
  ω: {
    x_min: 77,
    x_max: 970,
    ha: 1046,
    o: "m 332 -14 q 223 13 271 -14 q 143 91 176 41 q 93 209 110 140 q 77 360 77 278 q 82 464 77 415 q 97 558 87 512 q 124 650 108 604 q 162 745 140 696 l 289 745 q 251 649 267 695 q 225 558 235 604 q 209 464 214 512 q 204 360 204 416 q 214 243 204 294 q 242 158 224 192 q 285 106 260 123 q 340 88 310 88 q 394 102 371 88 q 432 140 417 116 q 454 198 447 165 q 462 270 462 231 l 462 478 l 585 478 l 585 270 q 618 135 585 182 q 706 88 651 88 q 761 106 736 88 q 804 158 786 123 q 832 243 823 192 q 842 360 842 294 q 837 464 842 416 q 821 558 832 512 q 795 649 811 604 q 757 745 779 695 l 884 745 q 922 650 906 696 q 949 558 938 604 q 964 464 959 512 q 970 360 970 415 q 953 209 970 278 q 903 91 936 140 q 823 13 871 41 q 714 -14 775 -14 q 595 15 642 -14 q 527 106 548 45 l 520 106 q 452 15 499 45 q 332 -14 404 -14 "
  },
  Ţ: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 423 0 l 297 0 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 0 m 244 -288 q 260 -246 251 -271 q 277 -191 269 -220 q 291 -135 285 -163 q 300 -85 298 -107 l 423 -85 l 423 -98 q 408 -141 418 -115 q 382 -197 397 -167 q 348 -255 367 -226 q 310 -307 330 -284 l 244 -307 l 244 -288 "
  },
  "´": {
    x_min: 267,
    x_max: 534,
    ha: 802,
    o: "m 267 860 q 297 905 281 879 q 329 958 313 931 q 360 1013 345 986 q 385 1064 374 1040 l 534 1064 l 534 1049 q 501 1004 523 1031 q 454 946 480 976 q 400 889 428 917 q 349 842 372 860 l 267 842 l 267 860 "
  },
  Ĉ: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 m 747 1071 l 665 1071 q 593 1126 630 1093 q 522 1196 557 1159 q 449 1126 485 1159 q 379 1071 413 1093 l 297 1071 l 297 1089 q 337 1134 314 1108 q 383 1187 360 1160 q 426 1242 406 1215 q 456 1293 446 1269 l 587 1293 q 617 1242 597 1269 q 660 1187 637 1215 q 706 1134 683 1160 q 747 1089 730 1108 l 747 1071 "
  },
  И: {
    x_min: 136,
    x_max: 879,
    ha: 1013,
    o: "m 136 992 l 262 992 l 262 449 q 261 410 262 431 q 260 366 261 389 q 259 321 260 343 q 257 276 258 298 q 251 174 254 226 l 256 174 l 725 992 l 879 992 l 879 0 l 752 0 l 752 538 q 754 624 752 576 q 759 717 756 673 q 765 821 762 768 l 760 821 l 289 0 l 136 0 l 136 992 "
  },
  Љ: {
    x_min: 0,
    x_max: 1193,
    ha: 1264,
    o: "m 1193 290 q 1172 170 1193 224 q 1109 79 1152 117 q 1000 20 1066 41 q 843 0 934 0 l 625 0 l 625 880 l 431 880 q 410 721 420 804 q 388 558 399 638 q 366 406 377 478 q 343 279 354 334 q 310 154 329 209 q 262 61 291 99 q 194 4 234 24 q 98 -16 154 -16 q 46 -10 73 -16 q 0 1 20 -5 l 0 111 q 35 97 15 102 q 76 91 54 91 q 129 113 108 91 q 164 167 150 134 q 187 239 179 200 q 204 315 196 279 q 223 421 213 354 q 247 577 234 488 q 275 771 261 665 q 305 992 290 877 l 751 992 l 751 574 l 825 574 q 999 551 928 574 q 1112 490 1069 529 q 1174 400 1155 452 q 1193 290 1193 349 m 751 107 l 831 107 q 1004 152 948 107 q 1059 290 1059 197 q 1043 370 1059 337 q 997 424 1028 403 q 920 453 966 444 q 810 462 873 462 l 751 462 l 751 107 "
  },
  р: {
    x_min: 118,
    x_max: 737,
    ha: 814,
    o: "m 454 -14 q 381 -5 414 -14 q 323 18 349 3 q 277 52 297 32 q 241 93 257 72 l 233 93 q 237 49 235 70 q 240 13 238 32 q 241 -16 241 -5 l 241 -334 l 118 -334 l 118 745 l 218 745 l 236 644 l 241 644 q 276 688 257 667 q 322 724 296 709 q 381 748 348 739 q 454 758 413 758 q 570 733 518 758 q 659 660 622 709 q 716 540 696 612 q 737 373 737 468 q 716 205 737 277 q 659 84 696 133 q 570 10 622 35 q 454 -14 518 -14 m 430 655 q 343 639 379 655 q 285 592 307 624 q 253 513 263 560 q 241 401 242 465 l 241 373 q 250 251 241 304 q 281 162 259 198 q 340 107 303 125 q 431 88 377 88 q 566 162 523 88 q 609 374 609 236 q 566 585 609 515 q 430 655 523 655 "
  },
  Ω: {
    x_min: 53.0625,
    x_max: 980.9375,
    ha: 1031,
    o: "m 517 895 q 384 872 439 895 q 292 805 328 849 q 239 699 256 762 q 222 556 222 636 q 234 425 222 488 q 273 304 246 362 q 345 194 301 246 q 455 99 390 143 l 455 0 l 53 0 l 53 111 l 321 111 q 229 189 271 143 q 155 292 186 235 q 106 416 124 349 q 89 559 89 484 q 116 743 89 661 q 198 884 143 826 q 332 975 252 943 q 517 1007 412 1007 q 701 975 622 1007 q 835 884 781 943 q 917 743 890 826 q 945 559 945 661 q 927 416 945 484 q 878 292 909 349 q 805 189 847 235 q 712 111 762 143 l 980 111 l 980 0 l 579 0 l 579 99 q 688 194 643 143 q 760 304 732 246 q 799 425 787 362 q 811 556 811 488 q 794 699 811 636 q 741 805 777 762 q 649 872 705 849 q 517 895 594 895 "
  },
  т: {
    x_min: 28,
    x_max: 584,
    ha: 612,
    o: "m 584 642 l 367 642 l 367 0 l 244 0 l 244 642 l 28 642 l 28 745 l 584 745 l 584 642 "
  },
  П: {
    x_min: 135,
    x_max: 826,
    ha: 960,
    o: "m 826 0 l 699 0 l 699 880 l 261 880 l 261 0 l 135 0 l 135 992 l 826 992 l 826 0 "
  },
  Ö: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 323 1174 q 341 1227 323 1211 q 388 1244 360 1244 q 434 1227 414 1244 q 453 1174 453 1210 q 434 1121 453 1138 q 388 1105 414 1105 q 341 1121 360 1105 q 323 1174 323 1138 m 577 1174 q 596 1227 577 1211 q 642 1244 615 1244 q 667 1239 655 1244 q 688 1227 679 1235 q 702 1206 697 1218 q 708 1174 708 1193 q 688 1121 708 1138 q 642 1105 668 1105 q 596 1121 615 1105 q 577 1174 577 1138 "
  },
  z: {
    x_min: 56,
    x_max: 556.21875,
    ha: 612,
    o: "m 556 0 l 56 0 l 56 80 l 418 656 l 78 656 l 78 745 l 544 745 l 544 650 l 189 88 l 556 88 l 556 0 "
  },
  "™": {
    x_min: 25,
    x_max: 922,
    ha: 1040,
    o: "m 244 503 l 158 503 l 158 918 l 25 918 l 25 992 l 379 992 l 379 918 l 244 918 l 244 503 m 636 503 l 511 875 l 506 875 q 508 852 507 864 q 509 831 508 841 q 509 812 509 821 q 510 800 510 804 l 510 503 l 424 503 l 424 992 l 552 992 l 673 618 l 801 992 l 922 992 l 922 503 l 835 503 l 835 793 q 836 809 835 799 q 836 831 836 819 q 837 855 837 843 q 838 875 837 867 l 834 875 l 703 503 l 636 503 "
  },
  Θ: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 334 560 l 696 560 l 696 452 l 334 452 l 334 560 m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 "
  },
  Ř: {
    x_min: 135,
    x_max: 803.25,
    ha: 819,
    o: "m 261 410 l 261 0 l 135 0 l 135 992 l 376 992 q 642 922 556 992 q 729 710 729 852 q 712 607 729 651 q 668 531 695 563 q 605 479 640 500 q 533 444 570 458 l 803 0 l 654 0 l 416 410 l 261 410 m 261 517 l 371 517 q 473 529 431 517 q 543 564 516 541 q 582 623 570 588 q 595 704 595 658 q 581 787 595 753 q 540 842 567 821 q 469 874 512 864 q 368 884 426 884 l 261 884 l 261 517 m 635 1274 q 594 1229 618 1255 q 548 1176 571 1203 q 505 1121 525 1148 q 475 1071 485 1094 l 344 1071 q 314 1121 334 1094 q 271 1176 294 1148 q 225 1229 248 1203 q 185 1274 202 1255 l 185 1293 l 267 1293 q 337 1237 301 1270 q 410 1166 373 1204 q 481 1237 445 1204 q 553 1293 518 1270 l 635 1293 l 635 1274 "
  },
  Ň: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 m 732 1274 q 691 1229 715 1255 q 645 1176 668 1203 q 602 1121 622 1148 q 572 1071 582 1094 l 441 1071 q 411 1121 431 1094 q 368 1176 391 1148 q 322 1229 345 1203 q 282 1274 299 1255 l 282 1293 l 364 1293 q 434 1237 398 1270 q 507 1166 470 1204 q 578 1237 542 1204 q 650 1293 615 1270 l 732 1293 l 732 1274 "
  },
  É: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 309 1089 q 339 1134 323 1108 q 371 1187 355 1160 q 402 1242 387 1215 q 427 1293 416 1269 l 576 1293 l 576 1278 q 543 1233 565 1260 q 496 1175 522 1205 q 442 1118 470 1146 q 391 1071 414 1089 l 309 1071 l 309 1089 "
  },
  и: {
    x_min: 118,
    x_max: 735,
    ha: 853,
    o: "m 234 745 l 234 291 l 226 120 l 576 745 l 735 745 l 735 0 l 618 0 l 618 439 l 625 622 l 276 0 l 118 0 l 118 745 l 234 745 "
  },
  "³": {
    x_min: 21,
    x_max: 418,
    ha: 460,
    o: "m 400 852 q 372 764 400 800 q 298 712 345 729 q 388 660 358 697 q 418 571 418 624 q 404 496 418 530 q 362 437 390 461 q 291 399 334 413 q 190 386 249 386 q 101 394 143 386 q 21 423 59 402 l 21 514 q 110 481 64 493 q 192 469 155 469 q 290 497 260 469 q 321 575 321 525 q 283 648 321 625 q 179 671 246 671 l 111 671 l 111 745 l 179 745 q 273 771 244 745 q 303 839 303 797 q 296 876 303 860 q 277 901 289 891 q 248 915 264 911 q 213 920 232 920 q 138 907 172 920 q 69 870 105 894 l 22 935 q 62 963 41 951 q 106 985 83 976 q 155 998 129 993 q 210 1004 180 1004 q 293 992 257 1004 q 352 961 328 981 q 388 913 376 940 q 400 852 400 885 "
  },
  "[": {
    x_min: 111,
    x_max: 386,
    ha: 421,
    o: "m 386 -220 l 111 -220 l 111 992 l 386 992 l 386 890 l 234 890 l 234 -118 l 386 -118 l 386 -220 "
  },
  ζ: {
    x_min: 77,
    x_max: 593,
    ha: 632,
    o: "m 118 952 l 118 1055 l 589 1055 l 589 960 q 439 811 502 880 q 334 680 377 741 q 266 567 291 619 q 226 470 240 515 q 208 387 213 425 q 204 317 204 349 q 219 220 204 256 q 263 161 235 183 q 332 128 291 140 q 424 104 373 116 q 504 78 472 94 q 556 43 536 63 q 584 -1 576 23 q 593 -54 593 -25 q 585 -114 593 -84 q 567 -172 578 -144 q 541 -225 555 -200 q 511 -272 526 -250 l 396 -272 q 426 -225 412 -250 q 451 -176 440 -201 q 469 -129 463 -152 q 476 -87 476 -107 q 471 -61 476 -73 q 450 -37 466 -48 q 403 -15 434 -25 q 321 5 373 -4 q 215 39 261 17 q 139 98 170 61 q 92 186 108 135 q 77 307 77 238 q 108 495 77 408 q 191 661 139 582 q 311 813 243 740 q 453 960 380 887 q 392 956 424 958 q 332 953 365 955 q 268 952 299 952 l 118 952 "
  },
  "∏": {
    x_min: 135,
    x_max: 895,
    ha: 1030,
    o: "m 768 -334 l 768 880 l 261 880 l 261 -334 l 135 -334 l 135 992 l 895 992 l 895 -334 l 768 -334 "
  },
  Έ: {
    x_min: -17,
    x_max: 747,
    ha: 831,
    o: "m 747 0 l 232 0 l 232 992 l 747 992 l 747 880 l 358 880 l 358 574 l 721 574 l 721 462 l 358 462 l 358 111 l 747 111 l 747 0 m -17 789 q -3 835 -10 809 q 9 889 3 861 q 21 943 16 916 q 30 993 27 970 l 165 993 l 165 978 q 149 936 160 962 q 123 880 138 909 q 90 821 107 850 q 56 771 72 792 l -17 771 l -17 789 "
  },
  Ρ: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 701 q 710 582 729 639 q 648 482 691 525 q 536 412 606 438 q 362 386 465 386 l 261 386 l 261 0 l 135 0 l 135 992 l 380 992 q 537 972 471 992 q 645 916 602 953 q 708 825 688 879 q 729 701 729 770 m 261 493 l 347 493 q 456 504 410 493 q 533 539 503 515 q 579 601 564 563 q 595 695 595 640 q 540 837 595 791 q 368 884 485 884 l 261 884 l 261 493 "
  },
  ğ: {
    x_min: 25,
    x_max: 692.484375,
    ha: 720,
    o: "m 692 745 l 692 668 l 559 649 q 591 588 578 625 q 604 504 604 551 q 588 409 604 453 q 539 333 572 365 q 459 283 507 301 q 348 266 412 266 q 319 266 333 266 q 294 268 304 266 q 271 253 282 261 q 251 233 260 244 q 236 208 242 222 q 230 178 230 194 q 238 148 230 159 q 260 130 246 136 q 293 122 274 124 q 333 120 312 120 l 453 120 q 560 104 516 120 q 631 61 603 88 q 670 -2 658 34 q 683 -80 683 -38 q 660 -186 683 -139 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 96 -278 132 -305 q 42 -213 60 -251 q 25 -128 25 -175 q 38 -57 25 -87 q 73 -4 51 -26 q 125 32 96 17 q 187 53 155 46 q 140 94 158 66 q 122 159 122 122 q 143 231 122 201 q 212 291 165 262 q 158 324 182 303 q 118 373 134 346 q 92 433 101 401 q 83 500 83 466 q 99 608 83 561 q 150 689 116 656 q 233 740 183 722 q 348 758 282 758 q 400 754 373 758 q 445 745 427 750 l 692 745 m 141 -126 q 150 -173 141 -151 q 179 -211 159 -195 q 232 -235 199 -226 q 314 -245 265 -245 q 503 -205 440 -245 q 566 -92 566 -166 q 558 -41 566 -61 q 531 -10 550 -21 q 482 4 512 0 q 407 8 451 8 l 287 8 q 238 3 263 8 q 190 -17 212 -2 q 155 -58 169 -32 q 141 -126 141 -84 m 206 504 q 242 388 206 426 q 344 350 278 350 q 446 388 411 350 q 480 506 480 426 q 445 629 480 590 q 343 669 410 669 q 241 628 277 669 q 206 504 206 587 m 551 1030 q 533 954 548 988 q 492 894 518 920 q 429 855 466 869 q 344 842 392 842 q 257 855 294 842 q 196 893 220 868 q 158 952 171 918 q 143 1030 145 987 l 217 1030 q 229 983 220 1000 q 255 957 239 965 q 294 946 271 948 q 347 943 317 943 q 393 946 371 943 q 433 959 415 949 q 462 985 450 968 q 476 1030 473 1002 l 551 1030 "
  },
  ª: {
    x_min: 46,
    x_max: 392,
    ha: 460,
    o: "m 328 541 l 308 597 q 283 570 296 582 q 254 549 270 558 q 219 536 238 540 q 177 532 201 532 q 124 540 148 532 q 82 566 100 549 q 55 610 65 584 q 46 671 46 636 q 93 777 46 740 q 236 817 140 813 l 303 820 l 303 841 q 282 909 303 890 q 224 929 262 929 q 162 919 192 929 q 104 894 132 909 l 72 961 q 146 991 106 979 q 226 1003 185 1003 q 351 967 311 1003 q 392 848 392 931 l 392 541 l 328 541 m 253 743 q 196 736 219 741 q 160 720 174 730 q 140 698 146 711 q 134 666 134 684 q 151 620 134 634 q 196 605 168 605 q 238 612 219 605 q 272 632 257 619 q 294 667 286 646 q 303 715 303 687 l 303 746 l 253 743 "
  },
  ї: {
    x_min: -13,
    x_max: 372,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m -13 945 q 5 998 -13 982 q 52 1015 24 1015 q 98 998 78 1015 q 117 945 117 981 q 98 892 117 909 q 52 876 78 876 q 5 892 24 876 q -13 945 -13 909 m 241 945 q 260 998 241 982 q 306 1015 279 1015 q 331 1010 319 1015 q 352 998 343 1006 q 366 977 361 989 q 372 945 372 964 q 352 892 372 909 q 306 876 332 876 q 260 892 279 876 q 241 945 241 909 "
  },
  T: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 423 0 l 297 0 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 0 "
  },
  š: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 m 554 1045 q 513 1000 537 1026 q 467 947 490 974 q 424 892 444 919 q 394 842 404 865 l 263 842 q 233 892 253 865 q 190 947 213 919 q 144 1000 167 974 q 104 1045 121 1026 l 104 1064 l 186 1064 q 256 1008 220 1041 q 329 937 292 975 q 400 1008 364 975 q 472 1064 437 1041 l 554 1064 l 554 1045 "
  },
  є: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 264 598 314 650 q 205 434 215 547 l 528 434 l 528 331 l 204 331 q 260 149 210 205 q 402 93 309 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 "
  },
  Þ: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 530 q 710 411 729 468 q 648 311 691 354 q 536 241 606 267 q 362 215 465 215 l 261 215 l 261 0 l 135 0 l 135 992 l 261 992 l 261 821 l 380 821 q 537 801 471 821 q 645 745 602 782 q 708 654 688 708 q 729 530 729 599 m 261 322 l 347 322 q 456 333 410 322 q 533 368 503 344 q 579 430 564 392 q 595 524 595 469 q 540 667 595 621 q 368 713 485 713 l 261 713 l 261 322 "
  },
  j: {
    x_min: -46,
    x_max: 252.96875,
    ha: 359,
    o: "m 44 -334 q -9 -329 12 -334 q -46 -317 -30 -324 l -46 -217 q -10 -227 -28 -224 q 31 -231 8 -231 q 65 -226 50 -231 q 93 -208 81 -221 q 111 -172 105 -194 q 118 -116 118 -150 l 118 745 l 241 745 l 241 -107 q 229 -201 241 -159 q 193 -272 218 -243 q 132 -318 169 -302 q 44 -334 95 -334 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 "
  },
  Σ: {
    x_min: 53,
    x_max: 706,
    ha: 739,
    o: "m 53 0 l 53 103 l 333 519 l 61 892 l 61 992 l 666 992 l 666 880 l 200 880 l 466 520 l 186 111 l 706 111 l 706 0 l 53 0 "
  },
  ϒ: {
    x_min: -0.25,
    x_max: 742,
    ha: 750,
    o: "m 366 496 q 403 603 383 546 q 445 714 424 660 q 487 815 467 769 q 523 891 507 861 q 554 939 538 918 q 588 973 570 960 q 628 993 606 986 q 677 1000 649 1000 q 715 996 701 1000 q 742 988 730 993 l 742 890 q 722 893 733 892 q 702 895 711 895 q 685 893 695 895 q 665 883 676 890 q 642 860 654 875 q 617 823 630 846 q 595 778 609 806 q 565 711 582 749 q 529 631 548 674 q 493 542 511 587 q 457 452 474 497 q 428 367 441 407 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 366 496 "
  },
  ℓ: {
    x_min: 81,
    x_max: 605,
    ha: 695,
    o: "m 426 82 q 466 90 447 82 q 500 114 485 97 q 525 158 515 130 q 537 225 535 185 l 605 225 q 589 124 602 168 q 552 49 576 79 q 493 2 528 18 q 410 -14 457 -14 q 334 -1 370 -14 q 271 39 298 11 q 227 114 243 68 q 211 228 211 161 l 211 385 q 147 364 179 374 q 81 347 114 355 l 81 422 q 148 442 116 431 q 211 462 180 452 l 211 801 q 220 878 211 841 q 251 943 230 915 q 308 989 273 972 q 395 1006 344 1006 q 461 991 431 1006 q 511 950 491 977 q 543 886 532 924 q 555 802 555 848 q 537 679 555 735 q 489 577 519 622 q 418 496 459 532 q 330 436 377 461 l 330 232 q 335 172 330 199 q 353 125 341 145 q 383 94 365 105 q 426 82 401 82 m 461 795 q 396 925 461 925 q 363 916 376 925 q 343 889 350 906 q 333 848 336 872 q 330 795 330 824 l 330 516 q 389 566 364 539 q 430 626 413 593 q 453 702 446 660 q 461 795 461 743 "
  },
  ĉ: {
    x_min: 77,
    x_max: 618,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 m 618 842 l 536 842 q 464 897 501 864 q 393 967 428 930 q 320 897 356 930 q 250 842 284 864 l 168 842 l 168 860 q 208 905 185 879 q 254 958 231 931 q 297 1013 277 986 q 327 1064 317 1040 l 458 1064 q 488 1013 468 1040 q 531 958 508 986 q 577 905 554 931 q 618 860 601 879 l 618 842 "
  },
  ī: {
    x_min: -14,
    x_max: 376,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m -14 943 l 376 943 l 376 842 l -14 842 l -14 943 "
  },
  О: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 "
  },
  ξ: {
    x_min: 77,
    x_max: 593,
    ha: 632,
    o: "m 543 601 l 543 512 l 433 512 q 336 495 379 512 q 264 449 293 478 q 219 382 234 420 q 204 299 204 343 q 219 213 204 246 q 263 160 235 181 q 332 129 291 140 q 424 106 373 117 q 504 80 472 95 q 556 44 536 64 q 584 0 576 24 q 593 -53 593 -24 q 585 -113 593 -83 q 566 -171 578 -143 q 540 -225 555 -199 q 510 -272 525 -250 l 394 -272 q 425 -225 410 -250 q 451 -176 439 -201 q 469 -129 462 -152 q 476 -86 476 -106 q 471 -60 476 -73 q 450 -36 466 -47 q 403 -14 434 -24 q 321 6 373 -3 q 139 97 201 29 q 77 288 77 165 q 92 383 77 340 q 135 459 108 426 q 195 515 161 493 q 267 550 230 538 l 267 558 q 160 622 199 577 q 122 747 122 667 q 137 830 122 796 q 179 889 152 865 q 242 931 206 914 q 321 960 278 947 q 271 956 297 958 q 220 953 249 955 q 160 952 191 952 l 117 952 l 117 1055 l 553 1055 l 553 960 l 515 960 q 415 947 465 960 q 326 908 366 934 q 262 841 287 881 q 238 748 238 801 q 249 685 238 712 q 284 638 260 657 q 346 610 308 620 q 440 601 385 601 l 543 601 "
  },
  Ď: {
    x_min: 135,
    x_max: 865,
    ha: 950,
    o: "m 865 505 q 832 285 865 379 q 738 127 799 190 q 586 31 676 63 q 383 0 496 0 l 135 0 l 135 992 l 410 992 q 598 960 514 992 q 741 868 682 929 q 832 715 800 806 q 865 505 865 624 m 731 501 q 709 672 731 600 q 643 791 686 744 q 538 861 601 838 q 397 884 476 884 l 261 884 l 261 107 l 370 107 q 640 207 549 107 q 731 501 731 306 m 676 1274 q 635 1229 659 1255 q 589 1176 612 1203 q 546 1121 566 1148 q 516 1071 526 1094 l 385 1071 q 355 1121 375 1094 q 312 1176 335 1148 q 266 1229 289 1203 q 226 1274 243 1255 l 226 1293 l 308 1293 q 378 1237 342 1270 q 451 1166 414 1204 q 522 1237 486 1204 q 594 1293 559 1270 l 676 1293 l 676 1274 "
  },
  "&": {
    x_min: 74,
    x_max: 953,
    ha: 975,
    o: "m 289 789 q 294 744 289 766 q 311 700 300 722 q 340 655 322 678 q 381 608 357 633 q 448 652 420 631 q 494 695 476 673 q 522 740 513 717 q 531 792 531 764 q 523 837 531 816 q 499 872 515 857 q 462 896 483 887 q 412 904 440 904 q 322 874 355 904 q 289 789 289 844 m 377 93 q 449 101 416 93 q 511 123 483 109 q 565 155 540 137 q 611 195 589 174 l 349 471 q 285 427 313 449 q 239 381 258 406 q 211 328 220 357 q 201 261 201 299 q 213 193 201 224 q 247 140 225 162 q 302 106 270 118 q 377 93 335 93 m 74 257 q 87 352 74 310 q 127 427 101 393 q 191 490 153 461 q 277 548 228 519 q 235 598 256 572 q 200 654 215 624 q 175 717 184 683 q 166 789 166 751 q 182 881 166 840 q 231 949 199 921 q 310 992 263 977 q 416 1007 356 1007 q 516 992 472 1007 q 591 949 560 977 q 638 881 622 921 q 655 790 655 840 q 638 709 655 746 q 593 641 621 672 q 529 582 565 609 q 452 531 492 556 l 690 279 q 723 319 708 299 q 749 362 738 339 q 770 411 761 385 q 786 470 779 438 l 910 470 q 886 387 899 425 q 854 317 872 350 q 814 255 836 283 q 766 198 792 226 l 953 0 l 800 0 l 686 116 q 620 61 653 85 q 551 21 588 37 q 472 -4 514 4 q 377 -14 430 -14 q 250 3 306 -14 q 154 56 193 21 q 94 142 115 91 q 74 257 74 192 "
  },
  G: {
    x_min: 85,
    x_max: 858,
    ha: 958,
    o: "m 530 524 l 858 524 l 858 36 q 782 15 820 24 q 704 0 744 5 q 620 -10 664 -7 q 526 -14 576 -14 q 337 21 419 -14 q 199 123 255 57 q 114 284 143 189 q 85 497 85 378 q 117 708 85 613 q 211 868 149 802 q 363 970 272 934 q 569 1006 453 1006 q 713 991 644 1006 q 842 947 782 976 l 793 837 q 741 859 769 849 q 683 877 713 869 q 621 890 653 885 q 559 894 590 894 q 412 867 476 894 q 306 788 349 839 q 240 662 263 736 q 218 496 218 588 q 237 334 218 407 q 296 208 255 261 q 401 126 336 155 q 556 97 465 97 q 610 98 585 97 q 656 103 635 100 q 695 109 677 106 q 731 116 714 113 l 731 412 l 530 412 l 530 524 "
  },
  ΰ: {
    x_min: 111,
    x_max: 736,
    ha: 819,
    o: "m 409 -14 q 264 13 322 -14 q 172 87 206 40 q 124 199 138 135 q 111 337 111 263 l 111 745 l 234 745 l 234 345 q 245 239 234 286 q 278 158 256 192 q 335 106 300 125 q 417 88 370 88 q 564 167 516 88 q 612 412 612 245 q 609 503 612 461 q 601 585 606 545 q 587 664 595 625 q 569 745 580 703 l 693 745 q 711 664 703 703 q 725 585 719 626 q 733 501 730 545 q 736 406 736 457 q 653 88 736 190 q 409 -14 570 -14 m 357 959 q 372 1005 364 980 q 389 1057 381 1030 q 404 1112 397 1084 q 417 1164 412 1139 l 558 1164 l 558 1150 q 529 1102 545 1128 q 494 1049 513 1076 q 454 994 475 1022 q 412 942 434 967 l 357 942 l 357 959 m 198 945 q 212 998 198 982 q 247 1015 226 1015 q 265 1010 256 1015 q 281 998 274 1006 q 291 977 287 989 q 295 945 295 964 q 280 892 295 909 q 247 876 266 876 q 212 892 226 876 q 198 945 198 909 m 527 945 q 541 998 527 982 q 576 1015 555 1015 q 594 1010 585 1015 q 610 998 603 1006 q 620 977 616 989 q 625 945 625 964 q 610 892 625 909 q 576 876 595 876 q 541 892 555 876 q 527 945 527 909 "
  },
  "`": {
    x_min: 267,
    x_max: 534,
    ha: 802,
    o: "m 534 842 l 452 842 q 400 889 428 860 q 346 946 372 917 q 299 1004 320 976 q 267 1049 277 1031 l 267 1064 l 415 1064 q 441 1013 426 1040 q 471 958 455 986 q 503 905 487 931 q 534 860 519 879 l 534 842 "
  },
  ŏ: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 605 1030 q 587 954 602 988 q 546 894 572 920 q 483 855 520 869 q 398 842 446 842 q 311 855 348 842 q 250 893 274 868 q 212 952 225 918 q 197 1030 199 987 l 271 1030 q 283 983 274 1000 q 309 957 293 965 q 348 946 325 948 q 401 943 371 943 q 447 946 425 943 q 487 959 469 949 q 516 985 504 968 q 530 1030 527 1002 l 605 1030 "
  },
  ý: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 m 276 860 q 306 905 290 879 q 338 958 322 931 q 369 1013 354 986 q 394 1064 383 1040 l 543 1064 l 543 1049 q 510 1004 532 1031 q 463 946 489 976 q 409 889 437 917 q 358 842 381 860 l 276 842 l 276 860 "
  },
  º: {
    x_min: 45,
    x_max: 441,
    ha: 486,
    o: "m 441 768 q 427 668 441 712 q 387 594 413 624 q 324 547 361 563 q 241 532 287 532 q 162 547 198 532 q 100 594 126 563 q 59 668 74 624 q 45 768 45 712 q 58 868 45 824 q 98 942 72 912 q 161 987 124 971 q 244 1003 197 1003 q 322 987 285 1003 q 384 942 358 971 q 426 868 411 912 q 441 768 441 824 m 133 769 q 159 647 133 688 q 243 605 184 605 q 326 647 301 605 q 352 769 352 688 q 326 889 352 850 q 243 929 301 929 q 159 889 184 929 q 133 769 133 850 "
  },
  "∞": {
    x_min: 81,
    x_max: 901,
    ha: 982,
    o: "m 901 486 q 886 405 901 443 q 845 336 871 366 q 782 289 819 307 q 700 272 745 272 q 585 307 637 272 q 488 421 532 343 q 445 362 468 388 q 395 316 421 335 q 340 287 368 297 q 283 277 312 277 q 202 291 239 277 q 138 334 164 306 q 96 402 111 362 q 81 490 81 441 q 95 573 81 534 q 136 641 110 612 q 200 687 162 670 q 283 704 238 704 q 394 667 340 704 q 489 555 447 631 q 532 614 509 588 q 582 659 555 640 q 638 689 609 678 q 700 699 668 699 q 782 684 745 699 q 845 641 819 669 q 886 574 871 613 q 901 486 901 534 m 296 369 q 372 398 337 369 q 441 490 407 426 q 374 581 409 552 q 294 611 339 611 q 247 601 268 611 q 212 575 227 592 q 190 536 198 558 q 182 489 182 514 q 189 443 182 465 q 210 405 196 422 q 246 379 225 389 q 296 369 267 369 m 690 607 q 612 578 648 607 q 538 486 575 550 q 609 395 573 425 q 692 365 646 365 q 740 374 718 365 q 777 400 762 384 q 800 439 792 417 q 808 487 808 462 q 800 534 808 512 q 776 572 791 556 q 739 597 760 588 q 690 607 717 607 "
  },
  ź: {
    x_min: 56,
    x_max: 556.21875,
    ha: 612,
    o: "m 556 0 l 56 0 l 56 80 l 418 656 l 78 656 l 78 745 l 544 745 l 544 650 l 189 88 l 556 88 l 556 0 m 238 860 q 268 905 252 879 q 300 958 284 931 q 331 1013 316 986 q 356 1064 345 1040 l 505 1064 l 505 1049 q 472 1004 494 1031 q 425 946 451 976 q 371 889 399 917 q 320 842 343 860 l 238 842 l 238 860 "
  },
  я: {
    x_min: 22.75,
    x_max: 619,
    ha: 737,
    o: "m 157 0 l 22 0 l 220 315 q 161 339 190 323 q 111 381 133 355 q 75 443 89 407 q 62 527 62 479 q 81 621 62 580 q 133 689 100 662 q 214 730 167 716 q 317 745 261 745 l 619 745 l 619 0 l 495 0 l 495 295 l 330 295 l 157 0 m 178 525 q 191 468 178 492 q 226 428 203 444 q 278 405 248 413 q 346 398 309 398 l 495 398 l 495 642 l 322 642 q 214 610 249 642 q 178 525 178 577 "
  },
  Ё: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 201 1174 q 219 1227 201 1211 q 266 1244 238 1244 q 312 1227 292 1244 q 331 1174 331 1210 q 312 1121 331 1138 q 266 1105 292 1105 q 219 1121 238 1105 q 201 1174 201 1138 m 455 1174 q 474 1227 455 1211 q 520 1244 493 1244 q 545 1239 533 1244 q 566 1227 557 1235 q 580 1206 575 1218 q 586 1174 586 1193 q 566 1121 586 1138 q 520 1105 546 1105 q 474 1121 493 1105 q 455 1174 455 1138 "
  },
  ń: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 m 342 860 q 372 905 356 879 q 404 958 388 931 q 435 1013 420 986 q 460 1064 449 1040 l 609 1064 l 609 1049 q 576 1004 598 1031 q 529 946 555 976 q 475 889 503 917 q 424 842 447 860 l 342 842 l 342 860 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 347
  },
  Г: {
    x_min: 135,
    x_max: 649,
    ha: 682,
    o: "m 649 992 l 649 880 l 261 880 l 261 0 l 135 0 l 135 992 l 649 992 "
  },
  Ь: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 290 q 708 170 729 224 q 645 79 688 117 q 537 20 602 41 q 380 0 471 0 l 135 0 l 135 992 l 261 992 l 261 574 l 362 574 q 536 551 465 574 q 648 490 606 529 q 710 400 691 452 q 729 290 729 349 m 261 107 l 368 107 q 540 152 485 107 q 595 290 595 197 q 579 370 595 337 q 533 424 564 403 q 456 453 503 444 q 347 462 410 462 l 261 462 l 261 107 "
  },
  "¤": {
    x_min: 83.640625,
    x_max: 680.03125,
    ha: 765,
    o: "m 126 490 q 137 566 126 530 q 170 634 149 602 l 83 721 l 149 788 l 235 700 q 304 734 267 722 q 381 747 341 747 q 458 734 422 747 q 526 700 495 722 l 613 788 l 680 723 l 592 635 q 626 567 613 604 q 639 490 639 530 q 627 412 639 449 q 592 344 615 375 l 678 258 l 613 193 l 526 279 q 458 246 495 258 q 381 235 422 235 q 303 247 341 235 q 235 281 266 259 l 149 195 l 85 259 l 170 345 q 137 412 149 376 q 126 490 126 449 m 227 489 q 239 426 227 455 q 273 375 252 397 q 323 340 295 353 q 385 327 352 327 q 448 340 419 327 q 499 375 478 353 q 534 426 521 397 q 546 489 546 455 q 534 554 546 524 q 499 606 521 584 q 448 641 478 628 q 385 654 419 654 q 323 641 352 654 q 273 606 295 628 q 239 554 252 584 q 227 489 227 524 "
  },
  Ĝ: {
    x_min: 85,
    x_max: 858,
    ha: 958,
    o: "m 530 524 l 858 524 l 858 36 q 782 15 820 24 q 704 0 744 5 q 620 -10 664 -7 q 526 -14 576 -14 q 337 21 419 -14 q 199 123 255 57 q 114 284 143 189 q 85 497 85 378 q 117 708 85 613 q 211 868 149 802 q 363 970 272 934 q 569 1006 453 1006 q 713 991 644 1006 q 842 947 782 976 l 793 837 q 741 859 769 849 q 683 877 713 869 q 621 890 653 885 q 559 894 590 894 q 412 867 476 894 q 306 788 349 839 q 240 662 263 736 q 218 496 218 588 q 237 334 218 407 q 296 208 255 261 q 401 126 336 155 q 556 97 465 97 q 610 98 585 97 q 656 103 635 100 q 695 109 677 106 q 731 116 714 113 l 731 412 l 530 412 l 530 524 m 771 1071 l 689 1071 q 617 1126 654 1093 q 546 1196 581 1159 q 473 1126 509 1159 q 403 1071 437 1093 l 321 1071 l 321 1089 q 361 1134 338 1108 q 407 1187 384 1160 q 450 1242 430 1215 q 480 1293 470 1269 l 611 1293 q 641 1242 621 1269 q 684 1187 661 1215 q 730 1134 707 1160 q 771 1089 754 1108 l 771 1071 "
  },
  p: {
    x_min: 118,
    x_max: 737,
    ha: 814,
    o: "m 454 -14 q 381 -5 414 -14 q 323 18 349 3 q 277 52 297 32 q 241 93 257 72 l 233 93 q 237 49 235 70 q 240 13 238 32 q 241 -16 241 -5 l 241 -334 l 118 -334 l 118 745 l 218 745 l 236 644 l 241 644 q 276 688 257 667 q 322 724 296 709 q 381 748 348 739 q 454 758 413 758 q 570 733 518 758 q 659 660 622 709 q 716 540 696 612 q 737 373 737 468 q 716 205 737 277 q 659 84 696 133 q 570 10 622 35 q 454 -14 518 -14 m 430 655 q 343 639 379 655 q 285 592 307 624 q 253 513 263 560 q 241 401 242 465 l 241 373 q 250 251 241 304 q 281 162 259 198 q 340 107 303 125 q 431 88 377 88 q 566 162 523 88 q 609 374 609 236 q 566 585 609 515 q 430 655 523 655 "
  },
  Ю: {
    x_min: 135,
    x_max: 1323,
    ha: 1409,
    o: "m 1323 496 q 1296 287 1323 382 q 1216 126 1269 193 q 1086 22 1164 59 q 906 -14 1008 -14 q 728 19 804 -14 q 600 116 651 53 q 521 266 548 178 q 490 462 494 354 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 493 574 q 529 752 500 672 q 609 889 558 832 q 735 976 661 946 q 908 1007 809 1007 q 1087 970 1009 1007 q 1217 867 1164 934 q 1296 706 1269 800 q 1323 496 1323 612 m 626 497 q 643 330 626 404 q 694 204 659 255 q 782 124 729 152 q 908 97 835 97 q 1035 124 981 97 q 1122 204 1088 152 q 1173 330 1156 255 q 1189 497 1189 404 q 1173 664 1189 590 q 1122 789 1156 738 q 1035 868 1088 840 q 909 895 982 895 q 782 868 836 895 q 694 789 729 840 q 643 664 659 738 q 626 497 626 590 "
  },
  ο: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 "
  },
  S: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 "
  },
  "/": {
    x_min: 13.75,
    x_max: 504.015625,
    ha: 518,
    o: "m 504 992 l 135 0 l 13 0 l 383 992 l 504 992 "
  },
  Ŧ: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 297 556 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 556 l 623 556 l 623 448 l 423 448 l 423 0 l 297 0 l 297 448 l 95 448 l 95 556 l 297 556 "
  },
  ђ: {
    x_min: 12.1875,
    x_max: 707,
    ha: 818,
    o: "m 510 -334 q 456 -329 477 -334 q 419 -317 435 -324 l 419 -217 q 455 -227 437 -224 q 497 -231 473 -231 q 531 -226 515 -231 q 558 -208 546 -221 q 577 -172 570 -194 q 583 -116 583 -150 l 583 451 q 547 583 583 539 q 436 627 512 627 q 343 609 381 627 q 283 557 306 592 q 251 473 261 523 q 241 357 241 422 l 241 0 l 118 0 l 118 843 l 12 843 l 12 932 l 118 932 l 118 1055 l 241 1055 l 241 932 l 498 932 l 498 843 l 241 843 l 241 715 l 236 616 l 242 616 q 283 666 259 645 q 334 702 306 687 q 393 723 362 716 q 457 730 424 730 q 644 665 581 730 q 707 458 707 600 l 707 -107 q 695 -201 707 -159 q 659 -272 683 -243 q 598 -318 635 -302 q 510 -334 561 -334 "
  },
  y: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 "
  },
  Π: {
    x_min: 135,
    x_max: 826,
    ha: 960,
    o: "m 826 0 l 699 0 l 699 880 l 261 880 l 261 0 l 135 0 l 135 992 l 826 992 l 826 0 "
  },
  "‗": {
    x_min: -3,
    x_max: 574,
    ha: 571,
    o: "m 574 -314 l -3 -314 l -3 -219 l 574 -219 l 574 -314 m 574 -125 l -3 -125 l -3 -31 l 574 -31 l 574 -125 "
  },
  "–": {
    x_min: 56,
    x_max: 639,
    ha: 695,
    o: "m 56 315 l 56 429 l 639 429 l 639 315 l 56 315 "
  },
  ë: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 183 945 q 201 998 183 982 q 248 1015 220 1015 q 294 998 274 1015 q 313 945 313 981 q 294 892 313 909 q 248 876 274 876 q 201 892 220 876 q 183 945 183 909 m 437 945 q 456 998 437 982 q 502 1015 475 1015 q 527 1010 515 1015 q 548 998 539 1006 q 562 977 557 989 q 568 945 568 964 q 548 892 568 909 q 502 876 528 876 q 456 892 475 876 q 437 945 437 909 "
  },
  б: {
    x_min: 79,
    x_max: 716,
    ha: 791,
    o: "m 79 446 q 95 664 79 569 q 147 828 112 759 q 237 940 182 897 q 369 999 292 982 q 535 1034 453 1018 q 686 1065 617 1051 l 709 957 q 633 944 675 951 q 549 928 592 936 q 467 912 507 920 q 398 897 428 904 q 322 865 356 887 q 264 804 288 843 q 225 710 239 766 q 209 577 211 654 l 218 577 q 251 617 230 597 q 300 654 272 638 q 365 682 329 671 q 445 693 401 693 q 562 668 512 693 q 647 599 613 643 q 699 493 682 554 q 716 359 716 432 q 692 196 716 266 q 627 79 669 126 q 526 9 585 32 q 396 -14 467 -14 q 265 16 324 -14 q 165 105 207 46 q 101 249 123 163 q 79 446 79 335 m 406 88 q 481 101 447 88 q 538 144 514 114 q 575 223 562 174 q 588 343 588 271 q 579 445 588 400 q 550 523 570 491 q 500 573 531 555 q 425 590 469 590 q 347 574 383 590 q 282 534 311 557 q 234 486 254 511 q 206 444 215 462 q 215 312 206 376 q 245 198 223 248 q 306 118 268 148 q 406 88 345 88 "
  },
  ƒ: {
    x_min: 138,
    x_max: 679,
    ha: 765,
    o: "m 444 552 l 444 -89 q 429 -207 444 -160 q 385 -282 413 -254 q 314 -322 356 -310 q 220 -334 272 -334 q 177 -330 198 -334 q 138 -323 156 -327 l 138 -219 q 174 -228 155 -224 q 215 -231 194 -231 q 262 -225 242 -231 q 295 -202 282 -218 q 314 -159 308 -187 q 321 -88 321 -131 l 321 552 l 189 552 l 189 610 l 321 664 l 321 757 q 336 877 321 829 q 380 953 351 925 q 451 994 409 982 q 546 1006 493 1006 q 619 998 586 1006 q 679 980 653 990 l 647 884 q 601 897 626 892 q 550 903 577 903 q 503 897 523 903 q 470 874 483 890 q 450 830 457 858 q 444 758 444 802 l 444 660 l 611 660 l 611 552 l 444 552 "
  },
  у: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 "
  },
  J: {
    x_min: -125,
    x_max: 251.15625,
    ha: 376,
    o: "m -19 -264 q -80 -259 -54 -264 q -125 -247 -106 -255 l -125 -139 q -75 -149 -101 -145 q -18 -152 -48 -152 q 32 -146 6 -152 q 78 -122 57 -139 q 112 -76 99 -105 q 125 0 125 -46 l 125 992 l 251 992 l 251 13 q 231 -109 251 -57 q 175 -196 211 -162 q 90 -247 140 -230 q -19 -264 40 -264 "
  },
  ŷ: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 m 566 842 l 484 842 q 412 897 449 864 q 341 967 376 930 q 268 897 304 930 q 198 842 232 864 l 116 842 l 116 860 q 156 905 133 879 q 202 958 179 931 q 245 1013 225 986 q 275 1064 265 1040 l 406 1064 q 436 1013 416 1040 q 479 958 456 986 q 525 905 502 931 q 566 860 549 879 l 566 842 "
  },
  ŕ: {
    x_min: 118,
    x_max: 526,
    ha: 554,
    o: "m 439 758 q 483 756 459 758 q 526 751 508 754 l 509 637 q 470 643 490 640 q 433 645 450 645 q 355 628 390 645 q 294 578 320 610 q 255 501 269 546 q 241 401 241 456 l 241 0 l 118 0 l 118 745 l 218 745 l 233 608 l 238 608 q 274 664 255 637 q 318 712 294 691 q 372 745 342 732 q 439 758 402 758 m 232 860 q 262 905 246 879 q 294 958 278 931 q 325 1013 310 986 q 350 1064 339 1040 l 499 1064 l 499 1049 q 466 1004 488 1031 q 419 946 445 976 q 365 889 393 917 q 314 842 337 860 l 232 842 l 232 860 "
  },
  ώ: {
    x_min: 77,
    x_max: 970,
    ha: 1046,
    o: "m 332 -14 q 223 13 271 -14 q 143 91 176 41 q 93 209 110 140 q 77 360 77 278 q 82 464 77 415 q 97 558 87 512 q 124 650 108 604 q 162 745 140 696 l 289 745 q 251 649 267 695 q 225 558 235 604 q 209 464 214 512 q 204 360 204 416 q 214 243 204 294 q 242 158 224 192 q 285 106 260 123 q 340 88 310 88 q 394 102 371 88 q 432 140 417 116 q 454 198 447 165 q 462 270 462 231 l 462 478 l 585 478 l 585 270 q 618 135 585 182 q 706 88 651 88 q 761 106 736 88 q 804 158 786 123 q 832 243 823 192 q 842 360 842 294 q 837 464 842 416 q 821 558 832 512 q 795 649 811 604 q 757 745 779 695 l 884 745 q 922 650 906 696 q 949 558 938 604 q 964 464 959 512 q 970 360 970 415 q 953 209 970 278 q 903 91 936 140 q 823 13 871 41 q 714 -14 775 -14 q 595 15 642 -14 q 527 106 548 45 l 520 106 q 452 15 499 45 q 332 -14 404 -14 m 474 860 q 487 906 480 880 q 500 960 494 932 q 512 1014 507 987 q 521 1064 518 1041 l 656 1064 l 656 1049 q 640 1007 651 1033 q 614 951 629 980 q 581 892 598 921 q 547 842 563 863 l 474 842 l 474 860 "
  },
  "˘": {
    x_min: 196,
    x_max: 604,
    ha: 802,
    o: "m 604 1030 q 586 954 601 988 q 545 894 571 920 q 482 855 519 869 q 397 842 445 842 q 310 855 347 842 q 249 893 273 868 q 211 952 224 918 q 196 1030 198 987 l 270 1030 q 282 983 273 1000 q 308 957 292 965 q 347 946 324 948 q 400 943 370 943 q 446 946 424 943 q 486 959 468 949 q 515 985 503 968 q 529 1030 526 1002 l 604 1030 "
  },
  D: {
    x_min: 135,
    x_max: 865,
    ha: 950,
    o: "m 865 505 q 832 285 865 379 q 738 127 799 190 q 586 31 676 63 q 383 0 496 0 l 135 0 l 135 992 l 410 992 q 598 960 514 992 q 741 868 682 929 q 832 715 800 806 q 865 505 865 624 m 731 501 q 709 672 731 600 q 643 791 686 744 q 538 861 601 838 q 397 884 476 884 l 261 884 l 261 107 l 370 107 q 640 207 549 107 q 731 501 731 306 "
  },
  ł: {
    x_min: -7,
    x_max: 367,
    ha: 359,
    o: "m 118 513 l 118 1055 l 241 1055 l 241 593 l 314 641 l 367 558 l 241 477 l 241 0 l 118 0 l 118 396 l 45 350 l -7 432 l 118 513 "
  },
  ĺ: {
    x_min: 116,
    x_max: 383,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 m 116 1128 q 146 1173 130 1147 q 178 1226 162 1199 q 209 1281 194 1254 q 234 1332 223 1308 l 383 1332 l 383 1317 q 350 1272 372 1299 q 303 1214 329 1244 q 249 1157 277 1185 q 198 1110 221 1128 l 116 1110 l 116 1128 "
  },
  ц: {
    x_min: 118,
    x_max: 815,
    ha: 836,
    o: "m 815 -258 l 691 -258 l 691 0 l 118 0 l 118 745 l 241 745 l 241 102 l 582 102 l 582 745 l 706 745 l 706 102 l 815 102 l 815 -258 "
  },
  Л: {
    x_min: 0,
    x_max: 794,
    ha: 929,
    o: "m 794 0 l 667 0 l 667 880 l 432 880 q 411 721 421 804 q 389 558 400 638 q 367 406 378 478 q 344 279 355 334 q 311 154 330 209 q 263 61 291 99 q 195 4 234 24 q 99 -16 155 -16 q 46 -11 73 -16 q 0 0 20 -6 l 0 105 q 35 95 15 99 q 76 91 55 91 q 130 113 109 91 q 165 167 151 134 q 188 239 180 200 q 205 315 197 279 q 224 421 214 354 q 248 577 235 488 q 276 771 262 665 q 306 992 291 877 l 794 992 l 794 0 "
  },
  $: {
    x_min: 83,
    x_max: 668,
    ha: 765,
    o: "m 668 303 q 651 216 668 255 q 602 149 634 177 q 525 102 570 120 q 423 75 480 83 l 423 -81 l 330 -81 l 330 69 q 261 72 296 69 q 194 81 226 75 q 133 96 161 87 q 83 116 104 104 l 83 233 q 134 212 105 222 q 197 193 164 201 q 263 179 229 185 q 330 174 298 174 l 330 466 q 225 509 269 487 q 151 560 180 531 q 108 626 122 589 q 94 713 94 663 q 110 796 94 759 q 158 862 127 834 q 232 908 188 890 q 330 932 276 926 l 330 1054 l 423 1054 l 423 935 q 548 917 491 931 q 651 882 606 903 l 606 783 q 521 812 568 799 q 423 829 473 826 l 423 547 q 529 504 483 526 q 605 453 574 481 q 652 388 636 425 q 668 303 668 352 m 548 302 q 541 344 548 325 q 520 378 535 362 q 482 406 505 393 q 423 432 458 420 l 423 180 q 517 222 486 190 q 548 302 548 254 m 213 711 q 219 668 213 687 q 238 633 224 649 q 274 605 252 617 q 330 580 296 592 l 330 827 q 241 787 269 816 q 213 711 213 757 "
  },
  w: {
    x_min: 13.75,
    x_max: 1022.25,
    ha: 1036,
    o: "m 683 0 l 570 417 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 546 542 529 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 13 745 l 143 745 l 232 348 q 245 282 239 318 q 258 211 252 246 q 269 146 264 177 q 277 95 274 115 l 281 95 q 290 142 284 113 q 303 205 296 172 q 317 270 310 238 q 331 324 325 302 l 453 745 l 586 745 l 702 324 q 716 270 709 301 q 732 207 724 239 q 745 145 739 175 q 754 95 751 115 l 758 95 q 764 142 760 113 q 775 207 769 172 q 788 279 781 242 q 803 348 795 316 l 896 745 l 1022 745 l 829 0 l 683 0 "
  },
  о: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 "
  },
  Д: {
    x_min: 10,
    x_max: 876,
    ha: 903,
    o: "m 876 -261 l 749 -261 l 749 0 l 136 0 l 136 -261 l 10 -261 l 10 111 l 86 111 q 147 223 118 170 q 203 354 177 277 q 251 512 229 431 q 290 675 273 593 q 316 837 306 757 q 329 992 326 917 l 744 992 l 744 111 l 876 111 l 876 -261 m 617 111 l 617 880 l 455 880 q 440 766 452 829 q 413 634 429 703 q 374 494 396 565 q 326 355 352 423 q 273 224 301 286 q 216 111 245 162 l 617 111 "
  },
  Ç: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 m 622 -194 q 574 -297 622 -260 q 424 -334 526 -334 q 394 -331 409 -334 q 369 -327 379 -329 l 369 -254 q 395 -257 379 -256 q 422 -258 412 -258 q 497 -247 470 -258 q 524 -208 524 -235 q 515 -186 524 -195 q 491 -169 506 -176 q 454 -157 476 -162 q 409 -147 433 -152 l 470 0 l 552 0 l 513 -78 q 556 -92 536 -83 q 590 -115 575 -101 q 613 -148 605 -128 q 622 -194 622 -168 "
  },
  Ŝ: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 m 612 1071 l 530 1071 q 458 1126 495 1093 q 387 1196 422 1159 q 314 1126 350 1159 q 244 1071 278 1093 l 162 1071 l 162 1089 q 202 1134 179 1108 q 248 1187 225 1160 q 291 1242 271 1215 q 321 1293 311 1269 l 452 1293 q 482 1242 462 1269 q 525 1187 502 1215 q 571 1134 548 1160 q 612 1089 595 1108 l 612 1071 "
  },
  C: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 "
  },
  Ḁ: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 576 -229 q 564 -291 576 -264 q 531 -338 552 -319 q 482 -367 510 -357 q 420 -377 453 -377 q 358 -367 386 -377 q 310 -338 330 -357 q 279 -292 290 -319 q 269 -231 269 -265 q 279 -169 269 -196 q 310 -123 290 -142 q 358 -94 330 -104 q 420 -85 386 -85 q 481 -94 453 -85 q 531 -123 510 -104 q 564 -168 552 -142 q 576 -229 576 -195 m 501 -231 q 479 -174 501 -194 q 422 -154 456 -154 q 365 -174 387 -154 q 343 -231 343 -194 q 363 -287 343 -267 q 422 -307 383 -307 q 479 -287 456 -307 q 501 -231 501 -267 "
  },
  Ĵ: {
    x_min: -125,
    x_max: 414,
    ha: 376,
    o: "m -19 -264 q -80 -259 -54 -264 q -125 -247 -106 -255 l -125 -139 q -75 -149 -101 -145 q -18 -152 -48 -152 q 32 -146 6 -152 q 78 -122 57 -139 q 112 -76 99 -105 q 125 0 125 -46 l 125 992 l 251 992 l 251 13 q 231 -109 251 -57 q 175 -196 211 -162 q 90 -247 140 -230 q -19 -264 40 -264 m 414 1071 l 332 1071 q 260 1126 297 1093 q 189 1196 224 1159 q 116 1126 152 1159 q 46 1071 80 1093 l -36 1071 l -36 1089 q 4 1134 -18 1108 q 50 1187 27 1160 q 93 1242 73 1215 q 123 1293 113 1269 l 254 1293 q 284 1242 264 1269 q 327 1187 304 1215 q 373 1134 350 1160 q 414 1089 397 1108 l 414 1071 "
  },
  È: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 484 1071 l 402 1071 q 350 1118 378 1089 q 296 1175 322 1146 q 249 1233 270 1205 q 217 1278 227 1260 l 217 1293 l 365 1293 q 391 1242 376 1269 q 421 1187 405 1215 q 453 1134 437 1160 q 484 1089 469 1108 l 484 1071 "
  },
  ﬁ: {
    x_min: 19,
    x_max: 709.96875,
    ha: 817,
    o: "m 441 656 l 274 656 l 274 0 l 151 0 l 151 656 l 19 656 l 19 704 l 151 749 l 151 814 q 166 934 151 886 q 210 1010 181 982 q 280 1051 238 1039 q 375 1063 322 1063 q 449 1055 415 1063 q 509 1037 482 1047 l 477 941 q 431 954 456 949 q 379 960 406 960 q 332 954 352 960 q 300 931 313 947 q 280 887 287 915 q 274 815 274 859 l 274 745 l 441 745 l 441 656 m 698 0 l 575 0 l 575 745 l 698 745 l 698 0 m 565 945 q 586 1004 565 986 q 637 1023 606 1023 q 665 1018 652 1023 q 688 1004 678 1014 q 704 980 698 995 q 709 945 709 966 q 688 887 709 906 q 637 868 667 868 q 586 886 606 868 q 565 945 565 905 "
  },
  X: {
    x_min: -0.25,
    x_max: 760.25,
    ha: 760,
    o: "m 760 0 l 617 0 l 376 430 l 127 0 l 0 0 l 307 518 l 20 992 l 155 992 l 380 612 l 608 992 l 737 992 l 450 522 l 760 0 "
  },
  ô: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 622 842 l 540 842 q 468 897 505 864 q 397 967 432 930 q 324 897 360 930 q 254 842 288 864 l 172 842 l 172 860 q 212 905 189 879 q 258 958 235 931 q 301 1013 281 986 q 331 1064 321 1040 l 462 1064 q 492 1013 472 1040 q 535 958 512 986 q 581 905 558 931 q 622 860 605 879 l 622 842 "
  },
  Ė: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 325 1155 q 345 1214 325 1196 q 396 1233 366 1233 q 425 1228 411 1233 q 448 1214 438 1224 q 463 1190 457 1205 q 469 1155 469 1176 q 448 1097 469 1116 q 396 1078 426 1078 q 345 1096 366 1078 q 325 1155 325 1115 "
  },
  г: {
    x_min: 118,
    x_max: 527,
    ha: 555,
    o: "m 527 642 l 241 642 l 241 0 l 118 0 l 118 745 l 527 745 l 527 642 "
  },
  Ŀ: {
    x_min: 135,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 0 l 135 992 l 261 992 l 261 111 l 649 111 l 649 0 l 135 0 m 436 493 q 456 552 436 534 q 507 571 477 571 q 536 566 522 571 q 559 552 549 562 q 574 528 568 543 q 580 493 580 514 q 559 435 580 454 q 507 416 537 416 q 456 434 477 416 q 436 493 436 453 "
  },
  х: {
    x_min: 24,
    x_max: 670,
    ha: 695,
    o: "m 276 382 l 38 745 l 178 745 l 347 466 l 517 745 l 658 745 l 416 382 l 670 0 l 529 0 l 347 295 l 164 0 l 24 0 l 276 382 "
  },
  ŋ: {
    x_min: 118,
    x_max: 706.34375,
    ha: 818,
    o: "m 508 -334 q 454 -329 476 -334 q 418 -317 433 -324 l 418 -217 q 453 -227 435 -224 q 495 -231 472 -231 q 529 -226 513 -231 q 556 -208 545 -221 q 575 -172 568 -194 q 581 -116 581 -150 l 582 479 q 547 611 582 567 q 435 655 511 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 456 758 424 758 q 643 693 580 758 q 706 486 706 628 l 705 -107 q 693 -201 705 -159 q 657 -272 681 -243 q 596 -318 633 -302 q 508 -334 559 -334 "
  },
  Ч: {
    x_min: 113,
    x_max: 782,
    ha: 917,
    o: "m 782 0 l 655 0 l 655 406 q 511 360 577 376 q 379 345 445 345 q 266 361 316 345 q 183 410 217 378 q 130 489 148 442 q 113 596 113 536 l 113 992 l 239 992 l 239 612 q 274 495 239 534 q 393 456 310 456 q 517 469 454 456 q 655 510 579 483 l 655 992 l 782 992 l 782 0 "
  },
  ü: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 210 945 q 228 998 210 982 q 275 1015 247 1015 q 321 998 301 1015 q 340 945 340 981 q 321 892 340 909 q 275 876 301 876 q 228 892 247 876 q 210 945 210 909 m 464 945 q 483 998 464 982 q 529 1015 502 1015 q 554 1010 542 1015 q 575 998 566 1006 q 589 977 584 989 q 595 945 595 964 q 575 892 595 909 q 529 876 555 876 q 483 892 502 876 q 464 945 464 909 "
  },
  ь: {
    x_min: 118,
    x_max: 711,
    ha: 787,
    o: "m 241 439 l 429 439 q 641 386 572 439 q 711 227 711 333 q 695 133 711 175 q 644 61 679 91 q 556 15 610 31 q 426 0 502 0 l 118 0 l 118 745 l 241 745 l 241 439 m 241 336 l 241 102 l 416 102 q 485 108 454 102 q 539 127 516 113 q 574 164 561 141 q 587 219 587 186 q 576 275 587 252 q 543 311 565 297 q 489 330 521 325 q 413 336 456 336 l 241 336 "
  },
  Ÿ: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 m 174 1174 q 192 1227 174 1211 q 239 1244 211 1244 q 285 1227 265 1244 q 304 1174 304 1210 q 285 1121 304 1138 q 239 1105 265 1105 q 192 1121 211 1105 q 174 1174 174 1138 m 428 1174 q 447 1227 428 1211 q 493 1244 466 1244 q 518 1239 506 1244 q 539 1227 530 1235 q 553 1206 548 1218 q 559 1174 559 1193 q 539 1121 559 1138 q 493 1105 519 1105 q 447 1121 466 1105 q 428 1174 428 1138 "
  },
  "€": {
    x_min: 42.984375,
    x_max: 744.875,
    ha: 765,
    o: "m 526 893 q 440 875 480 893 q 368 825 400 858 q 313 743 336 791 q 279 634 291 695 l 571 634 l 571 526 l 268 526 q 268 509 268 517 q 267 494 267 502 q 267 481 267 487 q 267 458 267 470 q 268 434 267 446 l 529 434 l 529 326 l 281 326 q 367 155 304 214 q 530 97 429 97 q 627 107 581 97 q 713 135 673 118 l 713 26 q 627 -3 672 7 q 521 -14 582 -14 q 381 9 443 -14 q 273 77 319 33 q 198 184 228 121 q 154 326 168 247 l 42 326 l 42 434 l 143 434 q 142 456 142 447 q 142 481 142 464 q 142 508 142 494 q 143 526 143 521 l 42 526 l 42 634 l 151 634 q 193 787 163 718 q 269 904 223 855 q 377 979 314 953 q 517 1006 439 1006 q 637 991 582 1006 q 744 943 691 976 l 690 844 q 615 879 656 865 q 526 893 575 893 "
  },
  в: {
    x_min: 118,
    x_max: 711,
    ha: 787,
    o: "m 687 557 q 645 447 687 486 q 531 395 603 407 l 531 390 q 602 373 569 385 q 659 340 635 361 q 697 289 683 320 q 711 215 711 258 q 695 130 711 169 q 644 61 679 91 q 556 16 610 32 q 426 0 502 0 l 118 0 l 118 745 l 424 745 q 529 735 481 745 q 612 704 577 726 q 667 646 647 682 q 687 557 687 610 m 587 224 q 543 312 587 287 q 413 336 500 336 l 241 336 l 241 102 l 416 102 q 485 108 454 102 q 539 128 516 114 q 574 166 561 143 q 587 224 587 190 m 570 545 q 533 620 570 598 q 422 642 496 642 l 241 642 l 241 439 l 401 439 q 475 444 443 439 q 527 461 506 449 q 559 494 549 473 q 570 545 570 515 "
  },
  Η: {
    x_min: 135,
    x_max: 839,
    ha: 974,
    o: "m 839 0 l 712 0 l 712 462 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 712 574 l 712 992 l 839 992 l 839 0 "
  },
  С: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 "
  },
  ß: {
    x_min: 118,
    x_max: 774,
    ha: 836,
    o: "m 685 854 q 670 785 685 815 q 633 730 655 755 q 586 685 612 706 q 538 646 560 665 q 502 609 517 627 q 487 570 487 591 q 492 545 487 556 q 510 521 497 534 q 547 491 523 507 q 610 448 571 474 q 679 399 649 423 q 730 347 709 374 q 762 286 751 319 q 774 211 774 254 q 755 110 774 152 q 701 39 736 67 q 619 0 667 12 q 514 -14 571 -14 q 401 -2 448 -14 q 318 32 353 9 l 318 145 q 357 124 335 134 q 404 106 379 114 q 454 93 428 98 q 505 88 480 88 q 571 96 543 88 q 616 120 598 105 q 642 156 634 135 q 650 205 650 178 q 644 249 650 229 q 624 288 639 269 q 585 327 609 307 q 522 370 560 347 q 450 421 479 397 q 403 466 422 444 q 378 513 385 489 q 371 565 371 537 q 385 629 371 602 q 420 677 399 655 q 466 716 441 698 q 512 754 490 735 q 547 797 533 774 q 561 849 561 820 q 550 899 561 878 q 518 933 539 920 q 469 954 498 947 q 406 960 441 960 q 343 954 373 960 q 290 931 313 947 q 254 887 268 915 q 241 814 241 858 l 241 0 l 118 0 l 118 814 q 139 932 118 884 q 199 1009 160 980 q 290 1050 237 1037 q 405 1063 343 1063 q 519 1050 467 1063 q 607 1011 571 1037 q 664 946 644 985 q 685 854 685 906 "
  },
  њ: {
    x_min: 118,
    x_max: 1121,
    ha: 1197,
    o: "m 241 745 l 241 437 l 554 437 l 554 745 l 677 745 l 677 439 l 837 439 q 1051 386 982 439 q 1121 228 1121 333 q 1105 133 1121 176 q 1054 61 1089 91 q 966 15 1020 31 q 835 0 912 0 l 554 0 l 554 334 l 241 334 l 241 0 l 118 0 l 118 745 l 241 745 m 997 220 q 986 276 997 253 q 953 312 975 298 q 898 332 931 326 q 823 337 865 337 l 677 337 l 677 102 l 826 102 q 894 108 863 102 q 948 128 925 114 q 984 164 971 142 q 997 220 997 187 "
  },
  Ű: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 273 1089 q 303 1134 287 1108 q 335 1187 319 1160 q 365 1242 351 1215 q 391 1293 380 1269 l 526 1293 l 526 1278 q 493 1233 515 1260 q 446 1175 472 1205 q 392 1118 420 1146 q 341 1071 365 1089 l 273 1071 l 273 1089 m 519 1089 q 549 1134 533 1108 q 581 1187 565 1160 q 611 1242 597 1215 q 636 1293 626 1269 l 771 1293 l 771 1278 q 738 1233 760 1260 q 691 1175 717 1205 q 637 1118 665 1146 q 586 1071 610 1089 l 519 1071 l 519 1089 "
  },
  c: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 "
  },
  "¶": {
    x_min: 77,
    x_max: 764,
    ha: 910,
    o: "m 764 -176 l 682 -176 l 682 947 l 541 947 l 541 -176 l 460 -176 l 460 379 q 361 366 418 366 q 244 384 296 366 q 154 441 191 401 q 97 546 117 481 q 77 706 77 611 q 99 872 77 806 q 161 980 121 939 q 258 1038 201 1021 q 382 1055 314 1055 l 764 1055 l 764 -176 "
  },
  Ή: {
    x_min: -17,
    x_max: 922,
    ha: 1057,
    o: "m 922 0 l 795 0 l 795 462 l 344 462 l 344 0 l 218 0 l 218 992 l 344 992 l 344 574 l 795 574 l 795 992 l 922 992 l 922 0 m -17 789 q -3 835 -10 809 q 9 889 3 861 q 21 943 16 916 q 30 993 27 970 l 165 993 l 165 978 q 149 936 160 962 q 123 880 138 909 q 90 821 107 850 q 56 771 72 792 l -17 771 l -17 789 "
  },
  Ὅ: {
    x_min: -203,
    x_max: 1001,
    ha: 1087,
    o: "m 1001 496 q 973 287 1001 382 q 891 126 946 193 q 757 22 837 59 q 571 -14 676 -14 q 380 22 461 -14 q 245 126 299 59 q 166 288 192 193 q 141 498 141 382 q 166 707 141 613 q 246 867 192 801 q 381 970 299 934 q 573 1007 462 1007 q 757 970 678 1007 q 891 867 837 934 q 973 706 946 800 q 1001 496 1001 612 m 274 497 q 292 330 274 404 q 346 204 309 255 q 438 124 382 152 q 571 97 494 97 q 704 124 649 97 q 797 204 760 152 q 850 330 833 255 q 867 497 867 404 q 850 664 867 590 q 797 789 833 738 q 705 868 761 840 q 573 895 650 895 q 439 868 495 895 q 346 789 383 840 q 292 664 309 738 q 274 497 274 590 m -10 787 q 5 833 -2 807 q 22 885 14 858 q 38 939 30 911 q 50 991 45 966 l 191 991 l 191 977 q 162 929 178 955 q 127 876 146 903 q 87 822 108 849 q 45 770 66 795 l -10 770 l -10 787 m -203 851 q -162 942 -203 904 q -38 1003 -121 981 l -38 951 q -98 920 -79 936 q -118 889 -118 905 q -107 870 -118 876 q -84 858 -97 864 q -61 844 -72 853 q -51 816 -51 835 q -67 778 -51 791 q -116 765 -84 765 q -179 788 -156 765 q -203 851 -203 812 "
  },
  γ: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 412 12 q 385 -76 397 -30 q 365 -167 373 -122 q 352 -255 356 -213 q 348 -334 348 -298 l 220 -334 q 225 -264 220 -305 q 240 -176 230 -223 q 262 -82 249 -130 q 289 8 274 -34 l 6 745 l 134 745 l 282 349 q 301 291 291 322 q 320 229 312 259 q 336 171 329 198 q 346 126 343 144 l 350 126 q 360 171 353 143 q 375 230 367 199 q 393 292 383 262 q 409 345 402 323 l 544 745 l 672 745 l 412 12 "
  },
  "­": {
    x_min: 56,
    x_max: 392,
    ha: 447,
    o: "m 56 315 l 56 429 l 392 429 l 392 315 l 56 315 "
  },
  ":": {
    x_min: 100,
    x_max: 272,
    ha: 372,
    o: "m 100 74 q 106 118 100 100 q 125 147 113 136 q 152 163 136 158 q 186 169 167 169 q 219 163 203 169 q 246 147 235 158 q 265 118 258 136 q 272 74 272 100 q 265 31 272 49 q 246 2 258 13 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 167 -20 q 125 2 136 -9 q 106 31 113 13 q 100 74 100 49 m 100 669 q 106 714 100 696 q 125 743 113 732 q 152 759 136 754 q 186 764 167 764 q 219 759 203 764 q 246 743 235 754 q 265 714 258 732 q 272 669 272 696 q 265 626 272 644 q 246 597 258 609 q 219 580 235 585 q 186 575 203 575 q 152 580 167 575 q 125 597 136 585 q 106 626 113 609 q 100 669 100 644 "
  },
  ś: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 m 242 860 q 272 905 256 879 q 304 958 288 931 q 335 1013 320 986 q 360 1064 349 1040 l 509 1064 l 509 1049 q 476 1004 498 1031 q 429 946 455 976 q 375 889 403 917 q 324 842 347 860 l 242 842 l 242 860 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 361
  },
  У: {
    x_min: 16.75,
    x_max: 813.25,
    ha: 813,
    o: "m 813 992 l 522 289 q 468 172 496 227 q 402 75 440 116 q 311 10 364 34 q 183 -14 258 -14 q 117 -8 148 -14 q 62 6 87 -3 l 62 131 q 117 106 87 116 q 183 97 147 97 q 246 105 219 97 q 297 130 274 112 q 338 178 319 149 q 376 250 357 207 l 16 992 l 155 992 l 415 440 q 422 425 418 433 q 428 408 425 417 q 434 391 431 399 q 440 377 437 383 l 441 377 q 447 394 443 383 q 455 416 451 404 q 462 437 458 427 q 468 451 466 447 l 679 992 l 813 992 "
  },
  "¾": {
    x_min: 21,
    x_max: 1008.765625,
    ha: 1023,
    o: "m 400 852 q 372 764 400 800 q 298 712 345 729 q 388 660 358 697 q 418 571 418 624 q 404 496 418 530 q 362 437 390 461 q 291 399 334 413 q 190 386 249 386 q 101 394 143 386 q 21 423 59 402 l 21 514 q 110 481 64 493 q 192 469 155 469 q 290 497 260 469 q 321 575 321 525 q 283 648 321 625 q 179 671 246 671 l 111 671 l 111 745 l 179 745 q 273 771 244 745 q 303 839 303 797 q 296 876 303 860 q 277 901 289 891 q 248 915 264 911 q 213 920 232 920 q 138 907 172 920 q 69 870 105 894 l 22 935 q 62 963 41 951 q 106 985 83 976 q 155 998 129 993 q 210 1004 180 1004 q 293 992 257 1004 q 352 961 328 981 q 388 913 376 940 q 400 852 400 885 m 879 992 l 328 0 l 221 0 l 772 992 l 879 992 m 1008 133 l 923 133 l 923 0 l 827 0 l 827 133 l 572 133 l 572 208 l 828 599 l 923 599 l 923 217 l 1008 217 l 1008 133 m 827 217 l 827 368 q 828 439 827 400 q 831 515 829 477 q 820 492 827 507 q 806 462 813 478 q 790 430 798 445 q 775 403 782 414 l 668 217 l 827 217 "
  },
  Ί: {
    x_min: -17,
    x_max: 585.8125,
    ha: 642,
    o: "m 585 0 l 226 0 l 226 69 l 343 96 l 343 895 l 226 922 l 226 992 l 585 992 l 585 922 l 469 895 l 469 96 l 585 69 l 585 0 m -17 789 q -3 835 -10 809 q 9 889 3 861 q 21 943 16 916 q 30 993 27 970 l 165 993 l 165 978 q 149 936 160 962 q 123 880 138 909 q 90 821 107 850 q 56 771 72 792 l -17 771 l -17 789 "
  },
  ŉ: {
    x_min: 0,
    x_max: 804,
    ha: 916,
    o: "m 680 0 l 680 479 q 644 611 680 567 q 533 655 609 655 q 440 637 478 655 q 380 585 403 620 q 348 501 358 551 q 338 385 338 450 l 338 0 l 215 0 l 215 745 l 315 745 l 333 644 l 339 644 q 380 694 356 673 q 431 730 403 715 q 490 751 459 744 q 554 758 521 758 q 741 693 678 758 q 804 486 804 628 l 804 0 l 680 0 m 203 992 l 212 977 q 189 898 202 939 q 160 815 176 857 q 127 731 144 772 q 92 652 109 690 l 0 652 q 22 737 10 692 q 44 827 33 782 q 63 913 54 871 q 78 992 72 956 l 203 992 "
  },
  Ģ: {
    x_min: 85,
    x_max: 858,
    ha: 958,
    o: "m 530 524 l 858 524 l 858 36 q 782 15 820 24 q 704 0 744 5 q 620 -10 664 -7 q 526 -14 576 -14 q 337 21 419 -14 q 199 123 255 57 q 114 284 143 189 q 85 497 85 378 q 117 708 85 613 q 211 868 149 802 q 363 970 272 934 q 569 1006 453 1006 q 713 991 644 1006 q 842 947 782 976 l 793 837 q 741 859 769 849 q 683 877 713 869 q 621 890 653 885 q 559 894 590 894 q 412 867 476 894 q 306 788 349 839 q 240 662 263 736 q 218 496 218 588 q 237 334 218 407 q 296 208 255 261 q 401 126 336 155 q 556 97 465 97 q 610 98 585 97 q 656 103 635 100 q 695 109 677 106 q 731 116 714 113 l 731 412 l 530 412 l 530 524 m 437 -288 q 453 -246 444 -271 q 470 -191 462 -220 q 484 -135 478 -163 q 493 -85 491 -107 l 616 -85 l 616 -98 q 601 -141 611 -115 q 575 -197 590 -167 q 541 -255 560 -226 q 503 -307 523 -284 l 437 -307 l 437 -288 "
  },
  m: {
    x_min: 118,
    x_max: 1134,
    ha: 1245,
    o: "m 1010 0 l 1010 479 q 976 611 1010 567 q 871 655 942 655 q 786 639 821 655 q 729 592 752 623 q 697 516 707 562 q 687 410 687 470 l 687 0 l 564 0 l 564 479 q 530 611 564 567 q 425 655 496 655 q 337 637 373 655 q 281 585 302 620 q 250 501 259 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 281 694 259 673 q 330 730 303 715 q 387 751 357 744 q 448 758 417 758 q 584 728 530 758 q 663 634 637 698 l 669 634 q 711 689 686 666 q 765 727 736 712 q 828 750 795 743 q 894 758 860 758 q 1073 693 1013 758 q 1134 486 1134 628 l 1134 0 l 1010 0 "
  },
  Е: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 "
  },
  ž: {
    x_min: 56,
    x_max: 556.21875,
    ha: 612,
    o: "m 556 0 l 56 0 l 56 80 l 418 656 l 78 656 l 78 745 l 544 745 l 544 650 l 189 88 l 556 88 l 556 0 m 542 1045 q 501 1000 525 1026 q 455 947 478 974 q 412 892 432 919 q 382 842 392 865 l 251 842 q 221 892 241 865 q 178 947 201 919 q 132 1000 155 974 q 92 1045 109 1026 l 92 1064 l 174 1064 q 244 1008 208 1041 q 317 937 280 975 q 388 1008 352 975 q 460 1064 425 1041 l 542 1064 l 542 1045 "
  },
  á: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 302 860 q 332 905 316 879 q 364 958 348 931 q 395 1013 380 986 q 420 1064 409 1040 l 569 1064 l 569 1049 q 536 1004 558 1031 q 489 946 515 976 q 435 889 463 917 q 384 842 407 860 l 302 842 l 302 860 "
  },
  "×": {
    x_min: 95.28125,
    x_max: 670.421875,
    ha: 765,
    o: "m 310 490 l 95 706 l 166 778 l 381 562 l 599 778 l 670 708 l 452 490 l 669 273 l 599 204 l 381 419 l 166 205 l 96 275 l 310 490 "
  },
  п: {
    x_min: 118,
    x_max: 706,
    ha: 825,
    o: "m 241 0 l 118 0 l 118 745 l 706 745 l 706 0 l 582 0 l 582 642 l 241 642 l 241 0 "
  },
  Ǻ: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 575 974 q 554 894 575 926 q 499 844 534 861 l 844 0 l 715 0 l 610 266 l 233 266 l 127 0 l 0 0 l 341 843 q 287 892 307 860 q 268 972 268 925 q 278 1034 268 1007 q 309 1080 289 1061 q 357 1109 329 1099 q 419 1119 385 1119 q 480 1109 452 1119 q 530 1080 509 1099 q 563 1035 551 1061 q 575 974 575 1008 m 566 378 l 466 636 q 456 662 462 647 q 444 696 450 678 q 432 734 438 714 q 421 773 426 754 q 410 734 416 754 q 397 695 404 714 q 386 662 391 677 q 376 636 380 646 l 277 378 l 566 378 m 368 1166 q 398 1203 382 1182 q 430 1246 414 1224 q 460 1290 446 1268 q 486 1331 475 1311 l 635 1331 l 635 1320 q 602 1283 624 1305 q 555 1236 581 1261 q 501 1190 528 1212 q 450 1153 473 1167 l 368 1153 l 368 1166 m 500 973 q 478 1029 500 1008 q 421 1049 456 1049 q 364 1029 386 1049 q 342 973 342 1008 q 360 918 342 938 q 412 896 378 898 l 421 896 q 478 916 456 896 q 500 973 500 937 "
  },
  K: {
    x_min: 135,
    x_max: 804.25,
    ha: 804,
    o: "m 804 0 l 661 0 l 355 473 l 261 396 l 261 0 l 135 0 l 135 992 l 261 992 l 261 496 l 343 609 l 649 992 l 791 992 l 438 559 l 804 0 "
  },
  "¨": {
    x_min: 208,
    x_max: 593,
    ha: 802,
    o: "m 208 945 q 226 998 208 982 q 273 1015 245 1015 q 319 998 299 1015 q 338 945 338 981 q 319 892 338 909 q 273 876 299 876 q 226 892 245 876 q 208 945 208 909 m 462 945 q 481 998 462 982 q 527 1015 500 1015 q 552 1010 540 1015 q 573 998 564 1006 q 587 977 582 989 q 593 945 593 964 q 573 892 593 909 q 527 876 553 876 q 481 892 500 876 q 462 945 462 909 "
  },
  Y: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 "
  },
  E: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 "
  },
  Ô: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 744 1071 l 662 1071 q 590 1126 627 1093 q 519 1196 554 1159 q 446 1126 482 1159 q 376 1071 410 1093 l 294 1071 l 294 1089 q 334 1134 311 1108 q 380 1187 357 1160 q 423 1242 403 1215 q 453 1293 443 1269 l 584 1293 q 614 1242 594 1269 q 657 1187 634 1215 q 703 1134 680 1160 q 744 1089 727 1108 l 744 1071 "
  },
  Є: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 419 872 473 894 q 324 809 365 850 q 257 708 283 767 q 222 574 231 649 l 649 574 l 649 462 l 218 462 q 243 307 222 374 q 305 192 265 239 q 403 121 345 145 q 538 97 461 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 "
  },
  Ï: {
    x_min: 43,
    x_max: 428,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 43 1174 q 61 1227 43 1211 q 108 1244 80 1244 q 154 1227 134 1244 q 173 1174 173 1210 q 154 1121 173 1138 q 108 1105 134 1105 q 61 1121 80 1105 q 43 1174 43 1138 m 297 1174 q 316 1227 297 1211 q 362 1244 335 1244 q 387 1239 375 1244 q 408 1227 399 1235 q 422 1206 417 1218 q 428 1174 428 1193 q 408 1121 428 1138 q 362 1105 388 1105 q 316 1121 335 1105 q 297 1174 297 1138 "
  },
  ġ: {
    x_min: 25,
    x_max: 692.484375,
    ha: 720,
    o: "m 692 745 l 692 668 l 559 649 q 591 588 578 625 q 604 504 604 551 q 588 409 604 453 q 539 333 572 365 q 459 283 507 301 q 348 266 412 266 q 319 266 333 266 q 294 268 304 266 q 271 253 282 261 q 251 233 260 244 q 236 208 242 222 q 230 178 230 194 q 238 148 230 159 q 260 130 246 136 q 293 122 274 124 q 333 120 312 120 l 453 120 q 560 104 516 120 q 631 61 603 88 q 670 -2 658 34 q 683 -80 683 -38 q 660 -186 683 -139 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 96 -278 132 -305 q 42 -213 60 -251 q 25 -128 25 -175 q 38 -57 25 -87 q 73 -4 51 -26 q 125 32 96 17 q 187 53 155 46 q 140 94 158 66 q 122 159 122 122 q 143 231 122 201 q 212 291 165 262 q 158 324 182 303 q 118 373 134 346 q 92 433 101 401 q 83 500 83 466 q 99 608 83 561 q 150 689 116 656 q 233 740 183 722 q 348 758 282 758 q 400 754 373 758 q 445 745 427 750 l 692 745 m 141 -126 q 150 -173 141 -151 q 179 -211 159 -195 q 232 -235 199 -226 q 314 -245 265 -245 q 503 -205 440 -245 q 566 -92 566 -166 q 558 -41 566 -61 q 531 -10 550 -21 q 482 4 512 0 q 407 8 451 8 l 287 8 q 238 3 263 8 q 190 -17 212 -2 q 155 -58 169 -32 q 141 -126 141 -84 m 206 504 q 242 388 206 426 q 344 350 278 350 q 446 388 411 350 q 480 506 480 426 q 445 629 480 590 q 343 669 410 669 q 241 628 277 669 q 206 504 206 587 m 273 945 q 293 1004 273 986 q 344 1023 314 1023 q 373 1018 359 1023 q 396 1004 386 1014 q 411 980 405 995 q 417 945 417 966 q 396 887 417 906 q 344 868 374 868 q 293 886 314 868 q 273 945 273 905 "
  },
  έ: {
    x_min: 61,
    x_max: 583,
    ha: 629,
    o: "m 453 439 l 453 336 l 366 336 q 229 305 273 336 q 184 210 184 274 q 198 152 184 176 q 235 114 212 129 q 291 94 259 100 q 360 88 323 88 q 426 93 395 88 q 484 106 457 98 q 535 125 511 114 q 580 146 559 135 l 580 37 q 486 0 540 14 q 359 -14 433 -14 q 226 2 282 -14 q 133 48 170 19 q 78 117 96 77 q 61 203 61 157 q 73 275 61 245 q 108 326 86 305 q 157 361 129 347 q 215 385 185 375 l 215 392 q 162 416 185 402 q 121 452 138 431 q 94 500 103 473 q 85 561 85 527 q 104 645 85 608 q 159 707 124 682 q 244 745 195 732 q 351 758 293 758 q 417 754 387 758 q 475 745 448 751 q 529 729 503 739 q 583 706 555 720 l 540 606 q 445 642 489 629 q 353 655 401 655 q 240 629 279 655 q 201 551 201 603 q 214 499 201 520 q 252 464 228 477 q 311 445 277 451 q 386 439 345 439 l 453 439 m 305 860 q 318 906 311 880 q 331 960 325 932 q 343 1014 338 987 q 352 1064 349 1041 l 487 1064 l 487 1049 q 471 1007 482 1033 q 445 951 460 980 q 412 892 429 921 q 378 842 394 863 l 305 842 l 305 860 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 463
  },
  ϋ: {
    x_min: 111,
    x_max: 736,
    ha: 819,
    o: "m 409 -14 q 264 13 322 -14 q 172 87 206 40 q 124 199 138 135 q 111 337 111 263 l 111 745 l 234 745 l 234 345 q 245 239 234 286 q 278 158 256 192 q 335 106 300 125 q 417 88 370 88 q 564 167 516 88 q 612 412 612 245 q 609 503 612 461 q 601 585 606 545 q 587 664 595 625 q 569 745 580 703 l 693 745 q 711 664 703 703 q 725 585 719 626 q 733 501 730 545 q 736 406 736 457 q 653 88 736 190 q 409 -14 570 -14 m 208 945 q 226 998 208 982 q 273 1015 245 1015 q 319 998 299 1015 q 338 945 338 981 q 319 892 338 909 q 273 876 299 876 q 226 892 245 876 q 208 945 208 909 m 462 945 q 481 998 462 982 q 527 1015 500 1015 q 552 1010 540 1015 q 573 998 564 1006 q 587 977 582 989 q 593 945 593 964 q 573 892 593 909 q 527 876 553 876 q 481 892 500 876 q 462 945 462 909 "
  },
  й: {
    x_min: 118,
    x_max: 735,
    ha: 853,
    o: "m 234 745 l 234 291 l 226 120 l 576 745 l 735 745 l 735 0 l 618 0 l 618 439 l 625 622 l 276 0 l 118 0 l 118 745 l 234 745 m 686 1058 q 665 964 681 1005 q 617 897 648 924 q 537 855 585 869 q 421 842 489 842 q 304 855 352 842 q 227 895 256 868 q 183 963 197 922 q 166 1058 169 1003 l 281 1058 q 293 990 284 1016 q 320 949 303 964 q 362 929 337 934 q 424 923 388 923 q 479 930 454 923 q 522 952 504 937 q 552 993 540 968 q 567 1058 563 1019 l 686 1058 "
  },
  b: {
    x_min: 118,
    x_max: 737,
    ha: 814,
    o: "m 454 758 q 570 733 518 758 q 659 660 622 709 q 716 540 696 612 q 737 373 737 468 q 716 205 737 277 q 659 84 696 133 q 570 10 622 35 q 454 -14 518 -14 q 381 -5 414 -14 q 323 18 349 3 q 277 52 297 32 q 241 93 257 72 l 233 93 l 208 0 l 118 0 l 118 1055 l 241 1055 l 241 800 q 240 749 241 776 q 238 699 240 722 q 236 646 237 672 l 241 646 q 276 690 257 670 q 322 726 296 711 q 381 749 348 741 q 454 758 413 758 m 430 655 q 340 638 376 655 q 281 585 303 621 q 250 497 259 550 q 241 373 241 444 q 250 251 241 304 q 281 162 259 198 q 340 107 303 125 q 431 88 377 88 q 566 162 523 88 q 609 374 609 236 q 566 585 609 515 q 430 655 523 655 "
  },
  ύ: {
    x_min: 111,
    x_max: 736,
    ha: 819,
    o: "m 409 -14 q 264 13 322 -14 q 172 87 206 40 q 124 199 138 135 q 111 337 111 263 l 111 745 l 234 745 l 234 345 q 245 239 234 286 q 278 158 256 192 q 335 106 300 125 q 417 88 370 88 q 564 167 516 88 q 612 412 612 245 q 609 503 612 461 q 601 585 606 545 q 587 664 595 625 q 569 745 580 703 l 693 745 q 711 664 703 703 q 725 585 719 626 q 733 501 730 545 q 736 406 736 457 q 653 88 736 190 q 409 -14 570 -14 m 352 860 q 365 906 358 880 q 378 960 372 932 q 390 1014 385 987 q 399 1064 396 1041 l 534 1064 l 534 1049 q 518 1007 529 1033 q 492 951 507 980 q 459 892 476 921 q 425 842 441 863 l 352 842 l 352 860 "
  },
  ﬂ: {
    x_min: 19,
    x_max: 698.4375,
    ha: 817,
    o: "m 441 656 l 274 656 l 274 0 l 151 0 l 151 656 l 19 656 l 19 704 l 151 749 l 151 814 q 166 934 151 886 q 210 1010 181 982 q 280 1051 238 1039 q 375 1063 322 1063 q 449 1055 415 1063 q 509 1037 482 1047 l 477 941 q 431 954 456 949 q 379 960 406 960 q 332 954 352 960 q 300 931 313 947 q 280 887 287 915 q 274 815 274 859 l 274 745 l 441 745 l 441 656 m 698 0 l 575 0 l 575 1055 l 698 1055 l 698 0 "
  },
  ф: {
    x_min: 77,
    x_max: 892,
    ha: 968,
    o: "m 545 756 q 685 719 621 747 q 794 641 749 690 q 866 525 840 593 q 892 373 892 458 q 868 221 892 289 q 799 104 844 153 q 689 25 753 54 q 545 -11 625 -3 l 545 -334 l 429 -334 l 429 -11 q 286 24 351 -4 q 175 103 221 54 q 102 220 128 151 q 77 373 77 288 q 101 526 77 458 q 170 642 125 593 q 281 719 215 690 q 429 756 346 748 l 429 1055 l 545 1055 l 545 756 m 204 373 q 257 175 204 246 q 429 91 310 104 l 429 653 q 326 626 369 647 q 256 571 284 606 q 217 486 229 536 q 204 373 204 437 m 764 373 q 712 569 764 500 q 545 652 660 638 l 545 91 q 712 175 661 104 q 764 373 764 246 "
  },
  Ŋ: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 615 -264 q 554 -259 580 -264 q 510 -247 528 -255 l 510 -139 q 557 -149 532 -145 q 613 -152 583 -152 q 662 -146 637 -152 q 706 -122 686 -139 q 739 -76 726 -105 q 751 0 751 -46 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 202 l 762 202 q 757 291 759 246 q 753 371 755 329 q 751 449 751 413 l 751 992 l 878 992 l 878 13 q 859 -109 878 -57 q 806 -196 840 -162 q 724 -247 772 -230 q 615 -264 675 -264 "
  },
  Ũ: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 585 1072 q 531 1083 558 1072 q 479 1110 505 1095 q 429 1136 453 1124 q 384 1148 405 1148 q 337 1130 353 1148 q 311 1070 321 1112 l 241 1070 q 255 1144 244 1111 q 284 1201 266 1177 q 327 1237 302 1224 q 384 1250 352 1250 q 440 1238 412 1250 q 493 1211 467 1226 q 542 1185 519 1197 q 585 1173 566 1173 q 631 1191 616 1173 q 657 1251 647 1209 l 729 1251 q 714 1177 725 1210 q 685 1121 703 1144 q 642 1084 667 1097 q 585 1072 617 1072 "
  },
  Щ: {
    x_min: 135,
    x_max: 1369,
    ha: 1385,
    o: "m 1250 111 l 1369 111 l 1369 -261 l 1242 -261 l 1242 0 l 135 0 l 135 992 l 261 992 l 261 111 l 629 111 l 629 992 l 755 992 l 755 111 l 1123 111 l 1123 992 l 1250 992 l 1250 111 "
  },
  L: {
    x_min: 135,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 0 l 135 992 l 261 992 l 261 111 l 649 111 l 649 0 l 135 0 "
  },
  ď: {
    x_min: 77,
    x_max: 924,
    ha: 814,
    o: "m 577 99 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 q 244 10 296 -14 q 154 83 192 34 q 97 203 117 131 q 77 370 77 275 q 97 538 77 466 q 154 659 117 610 q 244 733 192 708 q 359 758 296 758 q 432 749 399 758 q 490 725 464 740 q 537 690 516 710 q 572 649 557 671 l 580 649 q 576 693 578 672 q 573 729 575 711 q 572 759 572 748 l 572 1055 l 696 1055 l 696 0 l 596 0 l 577 99 m 383 88 q 470 104 434 88 q 528 151 506 119 q 560 231 550 183 q 572 342 571 279 l 572 370 q 563 492 572 439 q 532 581 554 545 q 473 636 510 618 q 382 655 437 655 q 247 581 290 655 q 204 369 204 507 q 247 157 204 227 q 383 88 290 88 m 760 850 q 772 897 766 871 q 784 950 778 923 q 794 1005 789 978 q 801 1055 799 1032 l 924 1055 l 924 1041 q 909 997 919 1024 q 885 942 898 971 q 855 883 871 913 q 825 833 840 854 l 760 833 l 760 850 "
  },
  Ο: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 "
  },
  Ĭ: {
    x_min: 33,
    x_max: 441,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 441 1259 q 423 1183 438 1217 q 382 1123 408 1149 q 319 1084 356 1098 q 234 1071 282 1071 q 147 1084 184 1071 q 86 1122 110 1097 q 48 1181 61 1147 q 33 1259 35 1216 l 107 1259 q 119 1212 110 1229 q 145 1186 129 1194 q 184 1175 161 1177 q 237 1172 207 1172 q 283 1175 261 1172 q 323 1188 305 1178 q 352 1214 340 1197 q 366 1259 363 1231 l 441 1259 "
  },
  ŧ: {
    x_min: 23,
    x_max: 445,
    ha: 471,
    o: "m 343 88 q 371 89 355 88 q 400 93 386 91 q 426 97 415 95 q 445 102 438 100 l 445 8 q 422 0 436 3 q 392 -7 409 -4 q 358 -12 376 -10 q 324 -14 341 -14 q 246 -3 282 -14 q 184 34 210 8 q 142 107 157 61 q 128 222 128 153 l 128 395 l 33 395 l 33 484 l 128 484 l 128 656 l 23 656 l 23 709 l 128 759 l 180 915 l 251 915 l 251 745 l 439 745 l 439 656 l 251 656 l 251 484 l 427 484 l 427 395 l 251 395 l 251 222 q 272 122 251 155 q 343 88 294 88 "
  },
  À: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 488 1071 l 406 1071 q 354 1118 382 1089 q 300 1175 326 1146 q 253 1233 274 1205 q 221 1278 231 1260 l 221 1293 l 369 1293 q 395 1242 380 1269 q 425 1187 409 1215 q 457 1134 441 1160 q 488 1089 473 1108 l 488 1071 "
  },
  Ϊ: {
    x_min: 43,
    x_max: 428,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 43 1174 q 61 1227 43 1211 q 108 1244 80 1244 q 154 1227 134 1244 q 173 1174 173 1210 q 154 1121 173 1138 q 108 1105 134 1105 q 61 1121 80 1105 q 43 1174 43 1138 m 297 1174 q 316 1227 297 1211 q 362 1244 335 1244 q 387 1239 375 1244 q 408 1227 399 1235 q 422 1206 417 1218 q 428 1174 428 1193 q 408 1121 428 1138 q 362 1105 388 1105 q 316 1121 335 1105 q 297 1174 297 1138 "
  },
  ḁ: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 512 -229 q 500 -291 512 -264 q 467 -338 488 -319 q 418 -367 446 -357 q 356 -377 389 -377 q 294 -367 322 -377 q 246 -338 266 -357 q 215 -292 226 -319 q 205 -231 205 -265 q 215 -169 205 -196 q 246 -123 226 -142 q 294 -94 266 -104 q 356 -85 322 -85 q 417 -94 389 -85 q 467 -123 446 -104 q 500 -168 488 -142 q 512 -229 512 -195 m 437 -231 q 415 -174 437 -194 q 358 -154 392 -154 q 301 -174 323 -154 q 279 -231 279 -194 q 299 -287 279 -267 q 358 -307 319 -307 q 415 -287 392 -307 q 437 -231 437 -267 "
  },
  "½": {
    x_min: 29,
    x_max: 976.734375,
    ha: 1023,
    o: "m 194 992 l 284 992 l 284 397 l 188 397 l 188 754 q 188 792 188 771 q 189 833 188 813 q 191 873 190 854 q 193 908 192 893 q 171 881 183 895 q 143 853 158 866 l 79 799 l 29 864 l 194 992 m 801 992 l 250 0 l 143 0 l 694 992 l 801 992 m 976 0 l 588 0 l 588 75 l 730 230 q 793 300 769 272 q 832 352 818 329 q 850 394 845 374 q 856 437 856 414 q 833 502 856 481 q 774 523 810 523 q 707 506 739 523 q 645 463 675 489 l 592 527 q 673 584 628 561 q 774 607 719 607 q 848 595 815 607 q 904 563 881 584 q 940 510 927 541 q 953 440 953 479 q 942 377 953 406 q 911 318 931 347 q 862 258 891 289 q 794 190 832 227 l 684 83 l 976 83 l 976 0 "
  },
  "'": {
    x_min: 90,
    x_max: 223.609375,
    ha: 314,
    o: "m 223 992 l 195 634 l 117 634 l 90 992 l 223 992 "
  },
  ĳ: {
    x_min: 108.5,
    x_max: 611.96875,
    ha: 720,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 m 403 -334 q 349 -329 371 -334 q 313 -317 328 -324 l 313 -217 q 348 -227 330 -224 q 390 -231 367 -231 q 424 -226 409 -231 q 452 -208 440 -221 q 470 -172 464 -194 q 477 -116 477 -150 l 477 745 l 600 745 l 600 -107 q 588 -201 600 -159 q 552 -272 577 -243 q 491 -318 528 -302 q 403 -334 454 -334 m 467 945 q 488 1004 467 986 q 539 1023 508 1023 q 567 1018 554 1023 q 590 1004 580 1014 q 606 980 600 995 q 611 945 611 966 q 590 887 611 906 q 539 868 569 868 q 488 886 508 868 q 467 945 467 905 "
  },
  Р: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 701 q 710 582 729 639 q 648 482 691 525 q 536 412 606 438 q 362 386 465 386 l 261 386 l 261 0 l 135 0 l 135 992 l 380 992 q 537 972 471 992 q 645 916 602 953 q 708 825 688 879 q 729 701 729 770 m 261 493 l 347 493 q 456 504 410 493 q 533 539 503 515 q 579 601 564 563 q 595 695 595 640 q 540 837 595 791 q 368 884 485 884 l 261 884 l 261 493 "
  },
  "˛": {
    x_min: 21,
    x_max: 237,
    ha: 257,
    o: "m 118 -161 q 136 -206 118 -191 q 178 -220 154 -220 q 211 -218 195 -220 q 237 -214 227 -217 l 237 -291 q 197 -299 219 -296 q 156 -302 176 -302 q 54 -266 88 -302 q 21 -170 21 -231 q 30 -116 21 -142 q 56 -69 40 -91 q 89 -30 71 -48 q 125 0 108 -12 l 212 0 q 118 -161 118 -90 "
  },
  Ć: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 m 447 1089 q 477 1134 461 1108 q 509 1187 493 1160 q 540 1242 525 1215 q 565 1293 554 1269 l 714 1293 l 714 1278 q 681 1233 703 1260 q 634 1175 660 1205 q 580 1118 608 1146 q 529 1071 552 1089 l 447 1071 l 447 1089 "
  },
  Т: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 423 0 l 297 0 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 0 "
  },
  "£": {
    x_min: 46,
    x_max: 718,
    ha: 765,
    o: "m 451 1004 q 582 988 523 1004 q 686 948 641 972 l 641 850 q 556 884 603 869 q 457 898 508 898 q 397 889 425 898 q 349 860 370 880 q 318 809 329 840 q 307 732 307 777 l 307 534 l 561 534 l 561 437 l 307 437 l 307 295 q 299 224 307 254 q 278 173 291 194 q 248 137 265 152 q 212 112 230 123 l 718 112 l 718 0 l 46 0 l 46 103 q 100 124 75 110 q 143 161 125 138 q 171 216 161 183 q 182 294 182 249 l 182 437 l 47 437 l 47 534 l 182 534 l 182 753 q 201 859 182 812 q 257 937 221 905 q 342 987 293 970 q 451 1004 392 1004 "
  },
  ů: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 563 989 q 551 927 563 954 q 518 880 539 899 q 469 851 497 861 q 407 842 440 842 q 345 851 373 842 q 297 880 317 861 q 266 926 277 899 q 256 988 256 953 q 266 1049 256 1022 q 297 1095 277 1076 q 345 1124 317 1114 q 407 1134 373 1134 q 468 1124 440 1134 q 518 1095 497 1114 q 551 1050 539 1076 q 563 989 563 1023 m 488 988 q 466 1044 488 1024 q 409 1064 444 1064 q 352 1044 374 1064 q 330 988 330 1024 q 350 931 330 951 q 409 911 370 911 q 466 931 444 911 q 488 988 488 951 "
  },
  Ō: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 320 1172 l 710 1172 l 710 1071 l 320 1071 l 320 1172 "
  },
  а: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 "
  },
  Ğ: {
    x_min: 85,
    x_max: 858,
    ha: 958,
    o: "m 530 524 l 858 524 l 858 36 q 782 15 820 24 q 704 0 744 5 q 620 -10 664 -7 q 526 -14 576 -14 q 337 21 419 -14 q 199 123 255 57 q 114 284 143 189 q 85 497 85 378 q 117 708 85 613 q 211 868 149 802 q 363 970 272 934 q 569 1006 453 1006 q 713 991 644 1006 q 842 947 782 976 l 793 837 q 741 859 769 849 q 683 877 713 869 q 621 890 653 885 q 559 894 590 894 q 412 867 476 894 q 306 788 349 839 q 240 662 263 736 q 218 496 218 588 q 237 334 218 407 q 296 208 255 261 q 401 126 336 155 q 556 97 465 97 q 610 98 585 97 q 656 103 635 100 q 695 109 677 106 q 731 116 714 113 l 731 412 l 530 412 l 530 524 m 740 1259 q 722 1183 737 1217 q 681 1123 707 1149 q 618 1084 655 1098 q 533 1071 581 1071 q 446 1084 483 1071 q 385 1122 409 1097 q 347 1181 360 1147 q 332 1259 334 1216 l 406 1259 q 418 1212 409 1229 q 444 1186 428 1194 q 483 1175 460 1177 q 536 1172 506 1172 q 582 1175 560 1172 q 622 1188 604 1178 q 651 1214 639 1197 q 665 1259 662 1231 l 740 1259 "
  },
  v: {
    x_min: -0.25,
    x_max: 665.25,
    ha: 665,
    o: "m 254 0 l 0 745 l 127 745 l 262 330 q 280 272 269 308 q 300 200 290 237 q 319 131 310 164 q 330 82 327 99 l 335 82 q 346 131 338 99 q 364 200 354 164 q 385 272 375 237 q 402 330 395 308 l 537 745 l 665 745 l 410 0 l 254 0 "
  },
  Ї: {
    x_min: 43,
    x_max: 428,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 43 1174 q 61 1227 43 1211 q 108 1244 80 1244 q 154 1227 134 1244 q 173 1174 173 1210 q 154 1121 173 1138 q 108 1105 134 1105 q 61 1121 80 1105 q 43 1174 43 1138 m 297 1174 q 316 1227 297 1211 q 362 1244 335 1244 q 387 1239 375 1244 q 408 1227 399 1235 q 422 1206 417 1218 q 428 1174 428 1193 q 408 1121 428 1138 q 362 1105 388 1105 q 316 1121 335 1105 q 297 1174 297 1138 "
  },
  û: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 631 842 l 549 842 q 477 897 514 864 q 406 967 441 930 q 333 897 369 930 q 263 842 297 864 l 181 842 l 181 860 q 221 905 198 879 q 267 958 244 931 q 310 1013 290 986 q 340 1064 330 1040 l 471 1064 q 501 1013 481 1040 q 544 958 521 986 q 590 905 567 931 q 631 860 614 879 l 631 842 "
  },
  Ź: {
    x_min: 56,
    x_max: 693,
    ha: 749,
    o: "m 693 0 l 56 0 l 56 97 l 537 880 l 70 880 l 70 992 l 679 992 l 679 894 l 197 111 l 693 111 l 693 0 m 305 1089 q 335 1134 319 1108 q 367 1187 351 1160 q 398 1242 383 1215 q 423 1293 412 1269 l 572 1293 l 572 1278 q 539 1233 561 1260 q 492 1175 518 1205 q 438 1118 466 1146 q 387 1071 410 1089 l 305 1071 l 305 1089 "
  },
  "ˉ": {
    x_min: 192,
    x_max: 582,
    ha: 774,
    o: "m 192 943 l 582 943 l 582 842 l 192 842 l 192 943 "
  },
  Ĺ: {
    x_min: 135,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 0 l 135 992 l 261 992 l 261 111 l 649 111 l 649 0 l 135 0 m 161 1089 q 191 1134 175 1108 q 223 1187 207 1160 q 254 1242 239 1215 q 279 1293 268 1269 l 428 1293 l 428 1278 q 395 1233 417 1260 q 348 1175 374 1205 q 294 1118 322 1146 q 243 1071 266 1089 l 161 1071 l 161 1089 "
  },
  "₤": {
    x_min: 46,
    x_max: 718,
    ha: 765,
    o: "m 451 1004 q 582 988 523 1004 q 686 948 641 972 l 641 850 q 556 884 603 869 q 457 898 508 898 q 397 889 425 898 q 349 860 370 880 q 318 809 329 840 q 307 733 307 777 l 307 604 l 561 604 l 561 507 l 307 507 l 307 404 l 561 404 l 561 307 l 307 307 l 307 294 q 299 223 307 253 q 278 172 291 194 q 248 137 265 151 q 212 112 230 123 l 718 112 l 718 0 l 46 0 l 46 104 q 100 125 75 111 q 143 161 125 138 q 171 216 161 184 q 182 293 182 248 l 182 307 l 47 307 l 47 404 l 182 404 l 182 507 l 47 507 l 47 604 l 182 604 l 182 753 q 201 859 182 812 q 257 937 221 905 q 342 987 293 970 q 451 1004 392 1004 "
  },
  Č: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 m 739 1274 q 698 1229 722 1255 q 652 1176 675 1203 q 609 1121 629 1148 q 579 1071 589 1094 l 448 1071 q 418 1121 438 1094 q 375 1176 398 1148 q 329 1229 352 1203 q 289 1274 306 1255 l 289 1293 l 371 1293 q 441 1237 405 1270 q 514 1166 477 1204 q 585 1237 549 1204 q 657 1293 622 1270 l 739 1293 l 739 1274 "
  },
  x: {
    x_min: 24,
    x_max: 670,
    ha: 695,
    o: "m 276 382 l 38 745 l 178 745 l 347 466 l 517 745 l 658 745 l 416 382 l 670 0 l 529 0 l 347 295 l 164 0 l 24 0 l 276 382 "
  },
  è: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 461 842 l 379 842 q 327 889 355 860 q 273 946 299 917 q 226 1004 247 976 q 194 1049 204 1031 l 194 1064 l 342 1064 q 368 1013 353 1040 q 398 958 382 986 q 430 905 414 931 q 461 860 446 879 l 461 842 "
  },
  Ń: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 m 431 1089 q 461 1134 445 1108 q 493 1187 477 1160 q 524 1242 509 1215 q 549 1293 538 1269 l 698 1293 l 698 1278 q 665 1233 687 1260 q 618 1175 644 1205 q 564 1118 592 1146 q 513 1071 536 1089 l 431 1071 l 431 1089 "
  },
  ḿ: {
    x_min: 118,
    x_max: 1134,
    ha: 1245,
    o: "m 1010 0 l 1010 479 q 976 611 1010 567 q 871 655 942 655 q 786 639 821 655 q 729 592 752 623 q 697 516 707 562 q 687 410 687 470 l 687 0 l 564 0 l 564 479 q 530 611 564 567 q 425 655 496 655 q 337 637 373 655 q 281 585 302 620 q 250 501 259 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 281 694 259 673 q 330 730 303 715 q 387 751 357 744 q 448 758 417 758 q 584 728 530 758 q 663 634 637 698 l 669 634 q 711 689 686 666 q 765 727 736 712 q 828 750 795 743 q 894 758 860 758 q 1073 693 1013 758 q 1134 486 1134 628 l 1134 0 l 1010 0 m 575 860 q 605 905 589 879 q 637 958 621 931 q 668 1013 653 986 q 693 1064 682 1040 l 842 1064 l 842 1049 q 809 1004 831 1031 q 762 946 788 976 q 708 889 736 917 q 657 842 680 860 l 575 842 l 575 860 "
  },
  μ: {
    x_min: 118,
    x_max: 706,
    ha: 825,
    o: "m 241 264 q 277 132 241 176 q 388 88 313 88 q 481 106 443 88 q 540 158 518 123 q 573 242 563 192 q 582 357 582 292 l 582 745 l 706 745 l 706 0 l 606 0 l 588 99 l 581 99 q 500 14 548 42 q 381 -14 451 -14 q 296 1 332 -14 q 237 45 261 17 q 239 -7 238 19 q 241 -59 240 -30 q 241 -117 241 -88 l 241 -334 l 118 -334 l 118 745 l 241 745 l 241 264 "
  },
  ".": {
    x_min: 100,
    x_max: 272,
    ha: 372,
    o: "m 100 74 q 106 118 100 100 q 125 147 113 136 q 152 163 136 158 q 186 169 167 169 q 219 163 203 169 q 246 147 235 158 q 265 118 258 136 q 272 74 272 100 q 265 31 272 49 q 246 2 258 13 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 167 -20 q 125 2 136 -9 q 106 31 113 13 q 100 74 100 49 "
  },
  "‘": {
    x_min: 16,
    x_max: 228,
    ha: 243,
    o: "m 24 652 l 16 666 q 38 744 25 703 q 67 828 51 786 q 100 912 82 870 q 135 992 118 954 l 228 992 q 204 905 216 950 q 183 816 193 861 q 164 730 173 772 q 149 652 155 687 l 24 652 "
  },
  π: {
    x_min: 17.109375,
    x_max: 831,
    ha: 875,
    o: "m 749 88 q 783 92 767 88 q 810 102 799 97 l 810 3 q 774 -8 799 -2 q 717 -14 749 -14 q 602 30 640 -14 q 564 164 564 75 l 564 642 l 290 642 l 290 0 l 167 0 l 167 642 l 17 642 l 17 691 l 110 745 l 831 745 l 831 642 l 688 642 l 688 173 q 703 107 688 125 q 749 88 719 88 "
  },
  l: {
    x_min: 118,
    x_max: 241.4375,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 "
  },
  Ъ: {
    x_min: 14,
    x_max: 839,
    ha: 910,
    o: "m 839 290 q 818 170 839 224 q 755 79 798 117 q 647 20 712 41 q 490 0 581 0 l 244 0 l 244 880 l 14 880 l 14 992 l 370 992 l 370 574 l 471 574 q 645 551 574 574 q 758 490 715 529 q 820 400 801 452 q 839 290 839 349 m 370 107 l 478 107 q 650 152 595 107 q 705 290 705 197 q 690 370 705 337 q 644 424 675 403 q 566 453 612 444 q 457 462 519 462 l 370 462 l 370 107 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 139
  },
  Ś: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 m 306 1089 q 336 1134 320 1108 q 368 1187 352 1160 q 399 1242 384 1215 q 424 1293 413 1269 l 573 1293 l 573 1278 q 540 1233 562 1260 q 493 1175 519 1205 q 439 1118 467 1146 q 388 1071 411 1089 l 306 1071 l 306 1089 "
  },
  Ü: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 293 1174 q 311 1227 293 1211 q 358 1244 330 1244 q 404 1227 384 1244 q 423 1174 423 1210 q 404 1121 423 1138 q 358 1105 384 1105 q 311 1121 330 1105 q 293 1174 293 1138 m 547 1174 q 566 1227 547 1211 q 612 1244 585 1244 q 637 1239 625 1244 q 658 1227 649 1235 q 672 1206 667 1218 q 678 1174 678 1193 q 658 1121 678 1138 q 612 1105 638 1105 q 566 1121 585 1105 q 547 1174 547 1138 "
  },
  à: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 460 842 l 378 842 q 326 889 354 860 q 272 946 298 917 q 225 1004 246 976 q 193 1049 203 1031 l 193 1064 l 341 1064 q 367 1013 352 1040 q 397 958 381 986 q 429 905 413 931 q 460 860 445 879 l 460 842 "
  },
  η: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 -334 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 -334 l 583 -334 "
  },
  ó: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 321 860 q 351 905 335 879 q 383 958 367 931 q 414 1013 399 986 q 439 1064 428 1040 l 588 1064 l 588 1049 q 555 1004 577 1031 q 508 946 534 976 q 454 889 482 917 q 403 842 426 860 l 321 842 l 321 860 "
  },
  "¦": {
    x_min: 332,
    x_max: 433.734375,
    ha: 765,
    o: "m 332 1055 l 433 1055 l 433 526 l 332 526 l 332 1055 m 332 196 l 433 196 l 433 -334 l 332 -334 l 332 196 "
  },
  Ő: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 312 1089 q 342 1134 326 1108 q 374 1187 358 1160 q 404 1242 390 1215 q 430 1293 419 1269 l 565 1293 l 565 1278 q 532 1233 554 1260 q 485 1175 511 1205 q 431 1118 459 1146 q 380 1071 404 1089 l 312 1071 l 312 1089 m 558 1089 q 588 1134 572 1108 q 620 1187 604 1160 q 650 1242 636 1215 q 675 1293 665 1269 l 810 1293 l 810 1278 q 777 1233 799 1260 q 730 1175 756 1205 q 676 1118 704 1146 q 625 1071 649 1089 l 558 1071 l 558 1089 "
  },
  Ž: {
    x_min: 56,
    x_max: 693,
    ha: 749,
    o: "m 693 0 l 56 0 l 56 97 l 537 880 l 70 880 l 70 992 l 679 992 l 679 894 l 197 111 l 693 111 l 693 0 m 604 1274 q 563 1229 587 1255 q 517 1176 540 1203 q 474 1121 494 1148 q 444 1071 454 1094 l 313 1071 q 283 1121 303 1094 q 240 1176 263 1148 q 194 1229 217 1203 q 154 1274 171 1255 l 154 1293 l 236 1293 q 306 1237 270 1270 q 379 1166 342 1204 q 450 1237 414 1204 q 522 1293 487 1270 l 604 1293 l 604 1274 "
  },
  е: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 "
  },
  Î: {
    x_min: 12,
    x_max: 462,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 462 1071 l 380 1071 q 308 1126 345 1093 q 237 1196 272 1159 q 164 1126 200 1159 q 94 1071 128 1093 l 12 1071 l 12 1089 q 52 1134 29 1108 q 98 1187 75 1160 q 141 1242 121 1215 q 171 1293 161 1269 l 302 1293 q 332 1242 312 1269 q 375 1187 352 1215 q 421 1134 398 1160 q 462 1089 445 1108 l 462 1071 "
  },
  e: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 "
  },
  ό: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 352 860 q 365 906 358 880 q 378 960 372 932 q 390 1014 385 987 q 399 1064 396 1041 l 534 1064 l 534 1049 q 518 1007 529 1033 q 492 951 507 980 q 459 892 476 921 q 425 842 441 863 l 352 842 l 352 860 "
  },
  Ĕ: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 601 1259 q 583 1183 598 1217 q 542 1123 568 1149 q 479 1084 516 1098 q 394 1071 442 1071 q 307 1084 344 1071 q 246 1122 270 1097 q 208 1181 221 1147 q 193 1259 195 1216 l 267 1259 q 279 1212 270 1229 q 305 1186 289 1194 q 344 1175 321 1177 q 397 1172 367 1172 q 443 1175 421 1172 q 483 1188 465 1178 q 512 1214 500 1197 q 526 1259 523 1231 l 601 1259 "
  },
  ļ: {
    x_min: 69,
    x_max: 248,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 m 69 -288 q 85 -246 76 -271 q 102 -191 94 -220 q 116 -135 110 -163 q 125 -85 123 -107 l 248 -85 l 248 -98 q 233 -141 243 -115 q 207 -197 222 -167 q 173 -255 192 -226 q 135 -307 155 -284 l 69 -307 l 69 -288 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 695
  },
  Ѓ: {
    x_min: 135,
    x_max: 649,
    ha: 682,
    o: "m 649 992 l 649 880 l 261 880 l 261 0 l 135 0 l 135 992 l 649 992 m 301 1089 q 331 1134 315 1108 q 363 1187 347 1160 q 394 1242 379 1215 q 419 1293 408 1269 l 568 1293 l 568 1278 q 535 1233 557 1260 q 488 1175 514 1205 q 434 1118 462 1146 q 383 1071 406 1089 l 301 1071 l 301 1089 "
  },
  ò: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 507 842 l 425 842 q 373 889 401 860 q 319 946 345 917 q 272 1004 293 976 q 240 1049 250 1031 l 240 1064 l 388 1064 q 414 1013 399 1040 q 444 958 428 986 q 476 905 460 931 q 507 860 492 879 l 507 842 "
  },
  ﬄ: {
    x_min: 19,
    x_max: 1155.4375,
    ha: 1274,
    o: "m 441 656 l 274 656 l 274 0 l 151 0 l 151 656 l 19 656 l 19 704 l 151 749 l 151 814 q 166 934 151 886 q 210 1010 181 982 q 280 1051 238 1039 q 375 1063 322 1063 q 449 1055 415 1063 q 509 1037 482 1047 l 477 941 q 431 954 456 949 q 379 960 406 960 q 332 954 352 960 q 300 931 313 947 q 280 887 287 915 q 274 815 274 859 l 274 745 l 441 745 l 441 656 m 898 656 l 731 656 l 731 0 l 608 0 l 608 656 l 476 656 l 476 704 l 608 749 l 608 814 q 623 934 608 886 q 667 1010 638 982 q 737 1051 695 1039 q 832 1063 779 1063 q 906 1055 872 1063 q 966 1037 939 1047 l 934 941 q 888 954 913 949 q 836 960 863 960 q 789 954 809 960 q 757 931 770 947 q 737 887 744 915 q 731 815 731 859 l 731 745 l 898 745 l 898 656 m 1155 0 l 1032 0 l 1032 1055 l 1155 1055 l 1155 0 "
  },
  "^": {
    x_min: 28,
    x_max: 711,
    ha: 739,
    o: "m 28 372 l 339 999 l 408 999 l 711 372 l 601 372 l 373 870 l 137 372 l 28 372 "
  },
  ⁿ: {
    x_min: 72,
    x_max: 446,
    ha: 515,
    o: "m 357 540 l 357 827 q 336 905 357 882 q 274 929 315 929 q 223 921 244 929 q 188 897 202 914 q 167 849 174 879 q 160 775 160 820 l 160 540 l 72 540 l 72 994 l 145 994 l 156 934 l 162 934 q 292 1003 205 1003 q 446 833 446 1003 l 446 540 l 357 540 "
  },
  к: {
    x_min: 118,
    x_max: 676.25,
    ha: 682,
    o: "m 516 745 l 649 745 l 369 387 l 676 0 l 536 0 l 241 377 l 241 0 l 118 0 l 118 745 l 241 745 l 241 383 l 516 745 "
  },
  "￼": {
    x_min: 57,
    x_max: 1346,
    ha: 1389,
    o: "m 57 823 l 57 1030 l 262 1030 l 262 954 l 132 954 l 132 823 l 57 823 m 1139 954 l 1139 1030 l 1346 1030 l 1346 823 l 1272 823 l 1272 954 l 1139 954 m 57 -260 l 57 -54 l 132 -54 l 132 -186 l 262 -186 l 262 -260 l 57 -260 m 1139 -260 l 1139 -186 l 1272 -186 l 1272 -54 l 1346 -54 l 1346 -260 l 1139 -260 m 875 -260 l 875 -186 l 1060 -186 l 1060 -260 l 875 -260 m 345 -260 l 345 -186 l 528 -186 l 528 -260 l 345 -260 m 345 954 l 345 1030 l 528 1030 l 528 954 l 345 954 m 1346 26 l 1272 26 l 1272 210 l 1346 210 l 1346 26 m 1346 558 l 1272 558 l 1272 742 l 1346 742 l 1346 558 m 610 -260 l 610 -186 l 794 -186 l 794 -260 l 610 -260 m 132 26 l 57 26 l 57 210 l 132 210 l 132 26 m 610 954 l 610 1030 l 794 1030 l 794 954 l 610 954 m 875 954 l 875 1030 l 1060 1030 l 1060 954 l 875 954 m 132 291 l 57 291 l 57 476 l 132 476 l 132 291 m 132 558 l 57 558 l 57 742 l 132 742 l 132 558 m 1346 291 l 1272 291 l 1272 476 l 1346 476 l 1346 291 m 408 224 q 276 277 322 224 q 231 427 231 331 q 276 577 231 525 q 408 631 322 630 q 540 578 494 631 q 586 427 586 525 q 540 277 586 331 q 408 224 494 224 m 408 294 q 478 329 457 294 q 499 427 499 364 q 478 525 499 490 q 408 559 457 559 q 339 525 361 559 q 317 427 317 490 q 339 329 317 364 q 408 294 361 294 m 643 626 l 759 626 q 871 603 833 626 q 909 524 909 580 q 893 468 909 491 q 847 439 878 445 l 847 437 q 903 406 886 429 q 921 344 921 383 q 884 259 921 289 q 783 229 847 229 l 643 229 l 643 626 m 726 469 l 770 469 q 814 480 801 469 q 826 513 826 491 q 812 546 826 536 q 766 556 798 556 l 726 556 l 726 469 m 726 402 l 726 298 l 776 298 q 822 312 809 298 q 834 352 834 327 q 821 388 834 374 q 773 402 809 402 l 726 402 m 956 231 l 956 300 q 978 297 967 298 q 1002 295 989 295 q 1044 307 1028 295 q 1061 353 1061 319 l 1061 626 l 1146 626 l 1146 356 q 1110 258 1146 292 q 1011 225 1075 225 q 956 231 969 225 "
  },
  ū: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 214 943 l 604 943 l 604 842 l 214 842 l 214 943 "
  },
  "ˆ": {
    x_min: 175,
    x_max: 625,
    ha: 802,
    o: "m 625 842 l 543 842 q 471 897 508 864 q 400 967 435 930 q 327 897 363 930 q 257 842 291 864 l 175 842 l 175 860 q 215 905 192 879 q 261 958 238 931 q 304 1013 284 986 q 334 1064 324 1040 l 465 1064 q 495 1013 475 1040 q 538 958 515 986 q 584 905 561 931 q 625 860 608 879 l 625 842 "
  },
  Ẅ: {
    x_min: 13.75,
    x_max: 1214.25,
    ha: 1228,
    o: "m 549 992 l 682 992 l 837 411 q 857 335 847 373 q 876 261 867 297 q 891 194 884 225 q 901 136 897 162 q 908 192 904 162 q 917 256 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 992 l 1214 992 l 965 0 l 837 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 622 813 q 600 776 608 814 q 585 707 593 745 q 567 632 576 669 l 402 0 l 275 0 l 13 992 l 147 992 l 298 388 q 313 323 306 357 q 325 257 320 290 q 336 192 331 223 q 344 136 341 162 q 352 194 347 161 q 364 264 358 227 q 379 338 371 301 q 396 409 387 376 l 549 992 m 421 1174 q 439 1227 421 1211 q 486 1244 458 1244 q 532 1227 512 1244 q 551 1174 551 1210 q 532 1121 551 1138 q 486 1105 512 1105 q 439 1121 458 1105 q 421 1174 421 1138 m 675 1174 q 694 1227 675 1211 q 740 1244 713 1244 q 765 1239 753 1244 q 786 1227 777 1235 q 800 1206 795 1218 q 806 1174 806 1193 q 786 1121 806 1138 q 740 1105 766 1105 q 694 1121 713 1105 q 675 1174 675 1138 "
  },
  č: {
    x_min: 77,
    x_max: 630,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 m 630 1045 q 589 1000 613 1026 q 543 947 566 974 q 500 892 520 919 q 470 842 480 865 l 339 842 q 309 892 329 865 q 266 947 289 919 q 220 1000 243 974 q 180 1045 197 1026 l 180 1064 l 262 1064 q 332 1008 296 1041 q 405 937 368 975 q 476 1008 440 975 q 548 1064 513 1041 l 630 1064 l 630 1045 "
  },
  "’": {
    x_min: 16,
    x_max: 228,
    ha: 243,
    o: "m 219 992 l 228 977 q 205 898 218 939 q 176 815 192 857 q 143 731 160 772 q 108 652 125 690 l 16 652 q 38 737 26 692 q 60 827 49 782 q 79 913 70 871 q 94 992 88 956 l 219 992 "
  },
  Ν: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 "
  },
  "-": {
    x_min: 56,
    x_max: 392,
    ha: 447,
    o: "m 56 315 l 56 429 l 392 429 l 392 315 l 56 315 "
  },
  Q: {
    x_min: 85,
    x_max: 945,
    ha: 1030,
    o: "m 945 496 q 928 331 945 407 q 879 193 911 254 q 799 87 847 131 q 687 16 751 42 q 763 -95 717 -47 q 871 -184 810 -144 l 789 -281 q 660 -164 719 -231 q 567 -11 601 -97 q 541 -13 555 -12 q 515 -14 527 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 "
  },
  ј: {
    x_min: -46,
    x_max: 252.96875,
    ha: 359,
    o: "m 44 -334 q -9 -329 12 -334 q -46 -317 -30 -324 l -46 -217 q -10 -227 -28 -224 q 31 -231 8 -231 q 65 -226 50 -231 q 93 -208 81 -221 q 111 -172 105 -194 q 118 -116 118 -150 l 118 745 l 241 745 l 241 -107 q 229 -201 241 -159 q 193 -272 218 -243 q 132 -318 169 -302 q 44 -334 95 -334 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 "
  },
  ě: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 606 1045 q 565 1000 589 1026 q 519 947 542 974 q 476 892 496 919 q 446 842 456 865 l 315 842 q 285 892 305 865 q 242 947 265 919 q 196 1000 219 974 q 156 1045 173 1026 l 156 1064 l 238 1064 q 308 1008 272 1041 q 381 937 344 975 q 452 1008 416 975 q 524 1064 489 1041 l 606 1064 l 606 1045 "
  },
  œ: {
    x_min: 77,
    x_max: 1194,
    ha: 1264,
    o: "m 934 -14 q 777 23 846 -14 q 665 135 708 61 q 554 23 622 61 q 400 -14 487 -14 q 271 11 330 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 207 707 q 404 758 328 758 q 553 720 486 758 q 662 610 619 682 q 765 720 702 682 q 906 758 827 758 q 1026 733 973 758 q 1117 665 1079 709 q 1174 560 1154 621 q 1194 423 1194 498 l 1194 346 l 727 346 q 782 155 730 216 q 935 93 833 93 q 999 97 970 93 q 1056 107 1028 100 q 1108 123 1083 113 q 1160 145 1134 133 l 1160 35 q 1107 13 1133 22 q 1054 -2 1081 3 q 997 -11 1027 -8 q 934 -14 968 -14 m 204 373 q 251 159 204 231 q 402 88 297 88 q 552 156 505 88 q 600 366 600 224 q 552 585 600 515 q 401 655 504 655 q 250 585 296 655 q 204 373 204 515 m 1066 449 q 1057 533 1066 495 q 1028 598 1048 571 q 979 640 1009 625 q 906 655 948 655 q 783 602 828 655 q 730 449 737 549 l 1066 449 "
  },
  "#": {
    x_min: 35,
    x_max: 863,
    ha: 897,
    o: "m 666 606 l 623 382 l 814 382 l 814 290 l 605 290 l 550 0 l 450 0 l 507 290 l 310 290 l 254 0 l 157 0 l 209 290 l 35 290 l 35 382 l 228 382 l 272 606 l 87 606 l 87 699 l 289 699 l 345 992 l 444 992 l 389 699 l 587 699 l 644 992 l 742 992 l 685 699 l 863 699 l 863 606 l 666 606 m 327 382 l 524 382 l 568 606 l 371 606 l 327 382 "
  },
  Џ: {
    x_min: 135,
    x_max: 826,
    ha: 960,
    o: "m 826 0 l 546 0 l 546 -261 l 420 -261 l 420 0 l 135 0 l 135 992 l 261 992 l 261 111 l 699 111 l 699 992 l 826 992 l 826 0 "
  },
  Å: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 576 1074 q 564 1012 576 1039 q 531 965 552 984 q 482 936 510 946 q 420 927 453 927 q 358 936 386 927 q 310 965 330 946 q 279 1011 290 984 q 269 1073 269 1038 q 279 1134 269 1107 q 310 1180 290 1161 q 358 1209 330 1199 q 420 1219 386 1219 q 481 1209 453 1219 q 531 1180 510 1199 q 564 1135 552 1161 q 576 1074 576 1108 m 501 1073 q 479 1129 501 1109 q 422 1149 457 1149 q 365 1129 387 1149 q 343 1073 343 1109 q 363 1016 343 1036 q 422 996 383 996 q 479 1016 457 996 q 501 1073 501 1036 "
  },
  ș: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 m 202 -288 q 218 -246 209 -271 q 235 -191 227 -220 q 249 -135 243 -163 q 258 -85 256 -107 l 381 -85 l 381 -98 q 366 -141 376 -115 q 340 -197 355 -167 q 306 -255 325 -226 q 268 -307 288 -284 l 202 -307 l 202 -288 "
  },
  "¸": {
    x_min: 24,
    x_max: 277,
    ha: 285,
    o: "m 277 -194 q 229 -297 277 -260 q 79 -334 181 -334 q 49 -331 64 -334 q 24 -327 34 -329 l 24 -254 q 50 -257 34 -256 q 77 -258 67 -258 q 152 -247 125 -258 q 179 -208 179 -235 q 170 -186 179 -195 q 146 -169 161 -176 q 109 -157 131 -162 q 64 -147 88 -152 l 125 0 l 207 0 l 168 -78 q 211 -92 191 -83 q 245 -115 230 -101 q 268 -148 260 -128 q 277 -194 277 -168 "
  },
  "=": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 69 577 l 69 679 l 696 679 l 696 577 l 69 577 m 69 300 l 69 402 l 696 402 l 696 300 l 69 300 "
  },
  ρ: {
    x_min: 111,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 703 208 725 280 q 642 86 682 135 q 546 11 602 37 q 418 -14 489 -14 q 319 1 368 -14 q 234 47 271 16 l 230 47 q 232 -13 231 17 q 234 -72 233 -39 q 234 -136 234 -105 l 234 -334 l 111 -334 l 111 373 q 133 537 111 465 q 195 657 155 608 q 293 732 236 707 q 422 758 351 758 q 543 732 488 758 q 639 657 598 707 q 702 537 679 608 q 725 373 725 465 m 417 655 q 280 589 324 655 q 234 386 236 522 l 234 156 q 319 105 271 121 q 419 88 368 88 q 555 159 514 88 q 597 373 597 231 q 555 585 597 515 q 417 655 512 655 "
  },
  Ћ: {
    x_min: 13,
    x_max: 873,
    ha: 977,
    o: "m 370 609 l 605 609 q 718 592 668 609 q 802 543 768 575 q 854 464 836 511 q 873 357 873 417 l 873 0 l 746 0 l 746 340 q 711 458 746 419 q 591 497 675 497 l 370 497 l 370 0 l 244 0 l 244 880 l 13 880 l 13 992 l 654 992 l 654 880 l 370 880 l 370 609 "
  },
  ú: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 331 860 q 361 905 345 879 q 393 958 377 931 q 424 1013 409 986 q 449 1064 438 1040 l 598 1064 l 598 1049 q 565 1004 587 1031 q 518 946 544 976 q 464 889 492 917 q 413 842 436 860 l 331 842 l 331 860 "
  },
  "˚": {
    x_min: 248,
    x_max: 555,
    ha: 802,
    o: "m 555 989 q 543 927 555 954 q 510 880 531 899 q 461 851 489 861 q 399 842 432 842 q 337 851 365 842 q 289 880 309 861 q 258 926 269 899 q 248 988 248 953 q 258 1049 248 1022 q 289 1095 269 1076 q 337 1124 309 1114 q 399 1134 365 1134 q 460 1124 432 1134 q 510 1095 489 1114 q 543 1050 531 1076 q 555 989 555 1023 m 480 988 q 458 1044 480 1024 q 401 1064 436 1064 q 344 1044 366 1064 q 322 988 322 1024 q 342 931 322 951 q 401 911 362 911 q 458 931 436 911 q 480 988 480 951 "
  },
  д: {
    x_min: 28,
    x_max: 732,
    ha: 760,
    o: "m 732 -258 l 615 -258 l 615 0 l 144 0 l 144 -258 l 28 -258 l 28 102 l 85 102 q 163 242 130 167 q 220 401 197 318 q 254 571 243 484 q 267 745 266 658 l 630 745 l 630 102 l 732 102 l 732 -258 m 506 102 l 506 656 l 383 656 q 365 511 378 585 q 332 365 352 437 q 282 226 311 293 q 215 102 253 159 l 506 102 "
  },
  "¯": {
    x_min: -4,
    x_max: 699,
    ha: 695,
    o: "m 699 1055 l -4 1055 l -4 1150 l 699 1150 l 699 1055 "
  },
  u: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 "
  },
  З: {
    x_min: 49,
    x_max: 681,
    ha: 757,
    o: "m 663 759 q 645 668 663 709 q 597 598 628 628 q 524 548 566 568 q 431 521 481 529 l 431 517 q 536 490 489 509 q 615 441 583 471 q 664 370 647 410 q 681 281 681 330 q 658 162 681 216 q 589 68 635 108 q 473 7 543 29 q 311 -14 404 -14 q 171 -2 236 -14 q 49 39 106 9 l 49 154 q 110 128 78 140 q 176 109 143 117 q 243 97 209 102 q 308 93 276 93 q 487 142 428 93 q 547 281 547 192 q 477 414 547 371 q 281 457 407 457 l 153 457 l 153 565 l 271 565 q 382 578 334 565 q 462 615 430 591 q 512 673 495 639 q 529 747 529 706 q 516 811 529 783 q 481 858 504 839 q 426 888 458 878 q 354 898 394 898 q 223 876 280 898 q 115 819 166 854 l 53 904 q 112 943 78 925 q 184 975 145 961 q 268 997 223 989 q 361 1006 312 1006 q 491 987 435 1006 q 585 936 547 969 q 643 858 624 903 q 663 759 663 812 "
  },
  Α: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 "
  },
  "⅝": {
    x_min: 54,
    x_max: 1011,
    ha: 1051,
    o: "m 232 769 q 310 757 274 769 q 373 722 346 745 q 415 664 400 699 q 431 586 431 630 q 374 438 431 491 q 208 385 318 385 q 124 394 166 385 q 54 422 83 404 l 54 518 q 92 497 71 506 q 133 481 112 488 q 174 471 154 475 q 211 468 194 468 q 301 493 269 468 q 334 577 334 519 q 301 657 334 628 q 208 685 269 685 q 186 684 199 685 q 160 680 174 682 q 134 676 147 678 q 112 672 122 674 l 67 702 l 89 992 l 389 992 l 389 908 l 170 908 l 158 762 q 191 766 172 764 q 232 769 210 769 m 860 992 l 309 0 l 202 0 l 753 992 l 860 992 m 815 604 q 883 594 851 604 q 938 567 914 585 q 976 519 962 548 q 991 453 991 491 q 983 407 991 428 q 962 369 976 386 q 931 338 949 352 q 893 313 914 325 q 938 285 917 300 q 975 251 959 270 q 1001 209 991 233 q 1011 157 1011 186 q 996 87 1011 119 q 956 33 982 56 q 894 0 930 11 q 816 -13 858 -13 q 670 31 721 -13 q 620 153 620 75 q 628 205 620 182 q 651 247 636 228 q 684 281 665 266 q 724 307 703 295 q 690 335 705 321 q 662 368 674 350 q 644 407 650 386 q 638 453 638 428 q 652 519 638 491 q 691 566 667 547 q 748 594 716 585 q 815 604 780 604 m 716 155 q 741 93 716 116 q 814 70 766 70 q 888 93 863 70 q 914 155 914 116 q 906 190 914 174 q 885 219 899 206 q 854 242 872 232 q 813 262 835 253 l 802 266 q 738 219 760 244 q 716 155 716 193 m 813 520 q 755 502 776 520 q 734 449 734 484 q 741 417 734 431 q 757 392 747 404 q 783 371 768 380 q 815 353 798 361 q 846 370 831 360 q 871 390 860 379 q 887 416 881 402 q 894 449 894 430 q 872 502 894 484 q 813 520 850 520 "
  },
  é: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 322 860 q 352 905 336 879 q 384 958 368 931 q 415 1013 400 986 q 440 1064 429 1040 l 589 1064 l 589 1049 q 556 1004 578 1031 q 509 946 535 976 q 455 889 483 917 q 404 842 427 860 l 322 842 l 322 860 "
  },
  Ş: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 m 486 -194 q 438 -297 486 -260 q 288 -334 390 -334 q 258 -331 273 -334 q 233 -327 243 -329 l 233 -254 q 259 -257 243 -256 q 286 -258 276 -258 q 361 -247 334 -258 q 388 -208 388 -235 q 379 -186 388 -195 q 355 -169 370 -176 q 318 -157 340 -162 q 273 -147 297 -152 l 334 0 l 416 0 l 377 -78 q 420 -92 400 -83 q 454 -115 439 -101 q 477 -148 469 -128 q 486 -194 486 -168 "
  },
  B: {
    x_min: 135,
    x_max: 786,
    ha: 863,
    o: "m 135 992 l 405 992 q 558 978 492 992 q 668 936 624 965 q 735 858 713 906 q 758 740 758 810 q 744 662 758 698 q 707 597 731 625 q 645 551 682 569 q 563 526 609 532 l 563 519 q 650 496 609 511 q 720 454 690 480 q 768 386 751 427 q 786 287 786 345 q 763 166 786 219 q 700 76 741 113 q 598 19 658 39 q 463 0 539 0 l 135 0 l 135 992 m 261 572 l 427 572 q 523 582 485 572 q 586 612 562 592 q 621 662 610 632 q 631 732 631 692 q 579 848 631 813 q 413 884 526 884 l 261 884 l 261 572 m 261 464 l 261 107 l 441 107 q 541 121 500 107 q 606 159 581 134 q 641 217 630 183 q 652 292 652 251 q 641 362 652 330 q 604 416 630 393 q 537 451 579 439 q 433 464 495 464 l 261 464 "
  },
  "…": {
    x_min: 100,
    x_max: 1017,
    ha: 1117,
    o: "m 100 74 q 106 118 100 100 q 125 147 113 136 q 152 163 136 158 q 186 169 167 169 q 219 163 203 169 q 246 147 235 158 q 265 118 258 136 q 272 74 272 100 q 265 31 272 49 q 246 2 258 13 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 167 -20 q 125 2 136 -9 q 106 31 113 13 q 100 74 100 49 m 473 74 q 479 118 473 100 q 498 147 486 136 q 525 163 509 158 q 559 169 540 169 q 592 163 576 169 q 619 147 608 158 q 638 118 631 136 q 645 74 645 100 q 638 31 645 49 q 619 2 631 13 q 592 -14 608 -9 q 559 -20 576 -20 q 525 -14 540 -20 q 498 2 509 -9 q 479 31 486 13 q 473 74 473 49 m 845 74 q 851 118 845 100 q 869 147 857 136 q 897 163 881 158 q 931 169 912 169 q 964 163 948 169 q 991 147 980 158 q 1010 118 1003 136 q 1017 74 1017 100 q 1010 31 1017 49 q 991 2 1003 13 q 964 -14 980 -9 q 931 -20 948 -20 q 869 2 894 -20 q 845 74 845 24 "
  },
  H: {
    x_min: 135,
    x_max: 839,
    ha: 974,
    o: "m 839 0 l 712 0 l 712 462 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 712 574 l 712 992 l 839 992 l 839 0 "
  },
  î: {
    x_min: -45,
    x_max: 405,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 405 842 l 323 842 q 251 897 288 864 q 180 967 215 930 q 107 897 143 930 q 37 842 71 864 l -45 842 l -45 860 q -4 905 -27 879 q 41 958 18 931 q 84 1013 64 986 q 114 1064 104 1040 l 245 1064 q 275 1013 255 1040 q 318 958 295 986 q 364 905 341 931 q 405 860 388 879 l 405 842 "
  },
  ν: {
    x_min: -0.25,
    x_max: 661,
    ha: 718,
    o: "m 0 745 l 127 745 l 263 343 q 282 287 271 320 q 302 218 292 253 q 321 152 313 183 q 333 104 330 121 l 337 104 q 437 239 398 169 q 498 387 475 308 q 529 553 520 465 q 537 745 537 642 l 661 745 q 648 536 661 634 q 604 348 635 439 q 521 172 573 257 q 389 0 469 86 l 259 0 l 0 745 "
  },
  Ό: {
    x_min: -16,
    x_max: 1001,
    ha: 1087,
    o: "m 1001 496 q 973 287 1001 382 q 891 126 946 193 q 757 22 837 59 q 571 -14 676 -14 q 380 22 461 -14 q 245 126 299 59 q 166 288 192 193 q 141 498 141 382 q 166 707 141 613 q 246 867 192 801 q 381 970 299 934 q 573 1007 462 1007 q 757 970 678 1007 q 891 867 837 934 q 973 706 946 800 q 1001 496 1001 612 m 274 497 q 292 330 274 404 q 346 204 309 255 q 438 124 382 152 q 571 97 494 97 q 704 124 649 97 q 797 204 760 152 q 850 330 833 255 q 867 497 867 404 q 850 664 867 590 q 797 789 833 738 q 705 868 761 840 q 573 895 650 895 q 439 868 495 895 q 346 789 383 840 q 292 664 309 738 q 274 497 274 590 m -16 789 q -2 835 -9 809 q 10 889 4 861 q 22 943 17 916 q 31 993 28 970 l 166 993 l 166 978 q 150 936 161 962 q 124 880 139 909 q 91 821 108 850 q 57 771 73 792 l -16 771 l -16 789 "
  },
  "−": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 69 439 l 69 541 l 696 541 l 696 439 l 69 439 "
  },
  "⅜": {
    x_min: 35,
    x_max: 1011,
    ha: 1051,
    o: "m 414 852 q 386 764 414 800 q 312 712 359 729 q 402 660 372 697 q 432 571 432 624 q 418 496 432 530 q 376 437 404 461 q 305 399 348 413 q 204 386 263 386 q 115 394 157 386 q 35 423 73 402 l 35 514 q 124 481 78 493 q 206 469 169 469 q 304 497 274 469 q 335 575 335 525 q 297 648 335 625 q 193 671 260 671 l 125 671 l 125 745 l 193 745 q 287 771 258 745 q 317 839 317 797 q 310 876 317 860 q 291 901 303 891 q 262 915 278 911 q 227 920 246 920 q 152 907 186 920 q 83 870 119 894 l 36 935 q 76 963 55 951 q 120 985 97 976 q 169 998 143 993 q 224 1004 194 1004 q 307 992 271 1004 q 366 961 342 981 q 402 913 390 940 q 414 852 414 885 m 860 992 l 309 0 l 202 0 l 753 992 l 860 992 m 815 604 q 883 594 851 604 q 938 567 914 585 q 976 519 962 548 q 991 453 991 491 q 983 407 991 428 q 962 369 976 386 q 931 338 949 352 q 893 313 914 325 q 938 285 917 300 q 975 251 959 270 q 1001 209 991 233 q 1011 157 1011 186 q 996 87 1011 119 q 956 33 982 56 q 894 0 930 11 q 816 -13 858 -13 q 670 31 721 -13 q 620 153 620 75 q 628 205 620 182 q 651 247 636 228 q 684 281 665 266 q 724 307 703 295 q 690 335 705 321 q 662 368 674 350 q 644 407 650 386 q 638 453 638 428 q 652 519 638 491 q 691 566 667 547 q 748 594 716 585 q 815 604 780 604 m 716 155 q 741 93 716 116 q 814 70 766 70 q 888 93 863 70 q 914 155 914 116 q 906 190 914 174 q 885 219 899 206 q 854 242 872 232 q 813 262 835 253 l 802 266 q 738 219 760 244 q 716 155 716 193 m 813 520 q 755 502 776 520 q 734 449 734 484 q 741 417 734 431 q 757 392 747 404 q 783 371 768 380 q 815 353 798 361 q 846 370 831 360 q 871 390 860 379 q 887 416 881 402 q 894 449 894 430 q 872 502 894 484 q 813 520 850 520 "
  },
  ǰ: {
    x_min: -46,
    x_max: 405,
    ha: 359,
    o: "m 44 -334 q -9 -329 12 -334 q -46 -317 -30 -324 l -46 -217 q -10 -227 -28 -224 q 31 -231 8 -231 q 65 -226 50 -231 q 93 -208 81 -221 q 111 -172 105 -194 q 118 -116 118 -150 l 118 745 l 241 745 l 241 -107 q 229 -201 241 -159 q 193 -272 218 -243 q 132 -318 169 -302 q 44 -334 95 -334 m 405 1045 q 364 1000 388 1026 q 318 947 341 974 q 275 892 295 919 q 245 842 255 865 l 114 842 q 84 892 104 865 q 41 947 64 919 q -4 1000 18 974 q -45 1045 -27 1026 l -45 1064 l 37 1064 q 107 1008 71 1041 q 180 937 143 975 q 251 1008 215 975 q 323 1064 288 1041 l 405 1064 l 405 1045 "
  },
  ā: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 174 943 l 564 943 l 564 842 l 174 842 l 174 943 "
  },
  ĵ: {
    x_min: -46,
    x_max: 405,
    ha: 359,
    o: "m 44 -334 q -9 -329 12 -334 q -46 -317 -30 -324 l -46 -217 q -10 -227 -28 -224 q 31 -231 8 -231 q 65 -226 50 -231 q 93 -208 81 -221 q 111 -172 105 -194 q 118 -116 118 -150 l 118 745 l 241 745 l 241 -107 q 229 -201 241 -159 q 193 -272 218 -243 q 132 -318 169 -302 q 44 -334 95 -334 m 405 842 l 323 842 q 251 897 288 864 q 180 967 215 930 q 107 897 143 930 q 37 842 71 864 l -45 842 l -45 860 q -4 905 -27 879 q 41 958 18 931 q 84 1013 64 986 q 114 1064 104 1040 l 245 1064 q 275 1013 255 1040 q 318 958 295 986 q 364 905 341 931 q 405 860 388 879 l 405 842 "
  },
  Ĩ: {
    x_min: -8,
    x_max: 480,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 336 1072 q 282 1083 309 1072 q 230 1110 256 1095 q 180 1136 204 1124 q 135 1148 156 1148 q 88 1130 104 1148 q 62 1070 72 1112 l -8 1070 q 6 1144 -4 1111 q 35 1201 17 1177 q 78 1237 53 1224 q 135 1250 103 1250 q 191 1238 163 1250 q 244 1211 218 1226 q 293 1185 270 1197 q 336 1173 317 1173 q 382 1191 367 1173 q 408 1251 398 1209 l 480 1251 q 465 1177 476 1210 q 436 1121 454 1144 q 393 1084 418 1097 q 336 1072 368 1072 "
  },
  "*": {
    x_min: 55.3125,
    x_max: 707.71875,
    ha: 765,
    o: "m 450 1055 l 420 788 l 690 863 l 707 733 l 451 714 l 617 493 l 496 428 l 377 670 l 270 428 l 145 493 l 309 714 l 55 733 l 74 863 l 340 788 l 311 1055 l 450 1055 "
  },
  ă: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 574 1030 q 556 954 571 988 q 515 894 541 920 q 452 855 489 869 q 367 842 415 842 q 280 855 317 842 q 219 893 243 868 q 181 952 194 918 q 166 1030 168 987 l 240 1030 q 252 983 243 1000 q 278 957 262 965 q 317 946 294 948 q 370 943 340 943 q 416 946 394 943 q 456 959 438 949 q 485 985 473 968 q 499 1030 496 1002 l 574 1030 "
  },
  Χ: {
    x_min: -0.25,
    x_max: 760.25,
    ha: 760,
    o: "m 760 0 l 617 0 l 376 430 l 127 0 l 0 0 l 307 518 l 20 992 l 155 992 l 380 612 l 608 992 l 737 992 l 450 522 l 760 0 "
  },
  "†": {
    x_min: 83,
    x_max: 591.171875,
    ha: 675,
    o: "m 591 670 l 366 691 l 404 0 l 257 0 l 294 691 l 83 670 l 83 793 l 294 772 l 257 1055 l 404 1055 l 366 772 l 591 793 l 591 670 "
  },
  "°": {
    x_min: 83,
    x_max: 512,
    ha: 595,
    o: "m 83 791 q 100 874 83 835 q 145 942 117 913 q 213 989 174 972 q 297 1006 252 1006 q 380 989 341 1006 q 448 942 419 972 q 495 874 478 913 q 512 791 512 835 q 495 708 512 747 q 448 641 478 669 q 380 595 419 612 q 297 579 341 579 q 213 595 252 579 q 145 641 174 612 q 100 708 117 669 q 83 791 83 747 m 184 790 q 193 744 184 766 q 218 707 203 723 q 256 681 234 690 q 301 671 277 671 q 347 681 326 671 q 385 707 369 690 q 410 744 401 723 q 419 790 419 766 q 410 838 419 815 q 385 877 401 860 q 347 903 369 893 q 301 913 326 913 q 256 903 277 913 q 218 877 234 893 q 193 838 203 860 q 184 790 184 815 "
  },
  Ξ: {
    x_min: 56,
    x_max: 682,
    ha: 737,
    o: "m 139 574 l 599 574 l 599 462 l 139 462 l 139 574 m 84 992 l 654 992 l 654 880 l 84 880 l 84 992 m 682 111 l 682 0 l 56 0 l 56 111 l 682 111 "
  },
  Ķ: {
    x_min: 135,
    x_max: 804.25,
    ha: 804,
    o: "m 804 0 l 661 0 l 355 473 l 261 396 l 261 0 l 135 0 l 135 992 l 261 992 l 261 496 l 343 609 l 649 992 l 791 992 l 438 559 l 804 0 m 327 -288 q 343 -246 334 -271 q 360 -191 352 -220 q 374 -135 368 -163 q 383 -85 381 -107 l 506 -85 l 506 -98 q 491 -141 501 -115 q 465 -197 480 -167 q 431 -255 450 -226 q 393 -307 413 -284 l 327 -307 l 327 -288 "
  },
  ŵ: {
    x_min: 13.75,
    x_max: 1022.25,
    ha: 1036,
    o: "m 683 0 l 570 417 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 546 542 529 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 13 745 l 143 745 l 232 348 q 245 282 239 318 q 258 211 252 246 q 269 146 264 177 q 277 95 274 115 l 281 95 q 290 142 284 113 q 303 205 296 172 q 317 270 310 238 q 331 324 325 302 l 453 745 l 586 745 l 702 324 q 716 270 709 301 q 732 207 724 239 q 745 145 739 175 q 754 95 751 115 l 758 95 q 764 142 760 113 q 775 207 769 172 q 788 279 781 242 q 803 348 795 316 l 896 745 l 1022 745 l 829 0 l 683 0 m 743 842 l 661 842 q 589 897 626 864 q 518 967 553 930 q 445 897 481 930 q 375 842 409 864 l 293 842 l 293 860 q 333 905 310 879 q 379 958 356 931 q 422 1013 402 986 q 452 1064 442 1040 l 583 1064 q 613 1013 593 1040 q 656 958 633 986 q 702 905 679 931 q 743 860 726 879 l 743 842 "
  },
  "΄": {
    x_min: 342,
    x_max: 524,
    ha: 802,
    o: "m 342 860 q 355 906 348 880 q 368 960 362 932 q 380 1014 375 987 q 389 1064 386 1041 l 524 1064 l 524 1049 q 508 1007 519 1033 q 482 951 497 980 q 449 892 466 921 q 415 842 431 863 l 342 842 l 342 860 "
  },
  ǽ: {
    x_min: 64,
    x_max: 1088,
    ha: 1157,
    o: "m 64 208 q 142 379 64 320 q 382 445 221 439 l 508 450 l 508 496 q 498 572 508 541 q 469 620 488 602 q 423 647 450 639 q 360 655 395 655 q 254 639 303 655 q 160 599 205 623 l 117 692 q 229 739 167 720 q 359 758 291 758 q 505 729 448 758 q 591 637 562 700 q 681 726 625 694 q 807 758 737 758 q 924 733 872 758 q 1013 665 976 709 q 1068 560 1049 622 q 1088 424 1088 499 l 1088 347 l 634 347 q 687 157 637 218 q 836 96 737 96 q 897 99 869 96 q 952 109 926 103 q 1004 126 979 116 q 1054 148 1029 135 l 1054 36 q 1002 13 1027 23 q 950 -2 977 4 q 895 -11 923 -8 q 833 -14 866 -14 q 672 24 740 -14 q 562 141 604 63 q 513 75 539 104 q 454 27 487 47 q 383 -3 422 7 q 293 -14 343 -14 q 202 0 244 -14 q 130 40 160 12 q 81 109 99 67 q 64 208 64 151 m 191 207 q 224 117 191 146 q 312 88 258 88 q 389 101 354 88 q 451 139 425 113 q 492 204 477 165 q 507 296 507 243 l 507 363 l 408 358 q 305 345 347 355 q 238 315 263 334 q 202 269 213 296 q 191 207 191 241 m 807 655 q 688 603 731 655 q 637 450 644 550 l 960 450 q 951 533 960 495 q 923 598 942 572 q 876 640 904 625 q 807 655 847 655 m 519 860 q 549 905 533 879 q 581 958 565 931 q 612 1013 597 986 q 637 1064 626 1040 l 786 1064 l 786 1049 q 753 1004 775 1031 q 706 946 732 976 q 652 889 680 917 q 601 842 624 860 l 519 842 l 519 860 "
  },
  Β: {
    x_min: 135,
    x_max: 786,
    ha: 863,
    o: "m 135 992 l 405 992 q 558 978 492 992 q 668 936 624 965 q 735 858 713 906 q 758 740 758 810 q 744 662 758 698 q 707 597 731 625 q 645 551 682 569 q 563 526 609 532 l 563 519 q 650 496 609 511 q 720 454 690 480 q 768 386 751 427 q 786 287 786 345 q 763 166 786 219 q 700 76 741 113 q 598 19 658 39 q 463 0 539 0 l 135 0 l 135 992 m 261 572 l 427 572 q 523 582 485 572 q 586 612 562 592 q 621 662 610 632 q 631 732 631 692 q 579 848 631 813 q 413 884 526 884 l 261 884 l 261 572 m 261 464 l 261 107 l 441 107 q 541 121 500 107 q 606 159 581 134 q 641 217 630 183 q 652 292 652 251 q 641 362 652 330 q 604 416 630 393 q 537 451 579 439 q 433 464 495 464 l 261 464 "
  },
  Ļ: {
    x_min: 135,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 0 l 135 992 l 261 992 l 261 111 l 649 111 l 649 0 l 135 0 m 279 -288 q 295 -246 286 -271 q 312 -191 304 -220 q 326 -135 320 -163 q 335 -85 333 -107 l 458 -85 l 458 -98 q 443 -141 453 -115 q 417 -197 432 -167 q 383 -255 402 -226 q 345 -307 365 -284 l 279 -307 l 279 -288 "
  },
  Õ: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 604 1072 q 550 1083 577 1072 q 498 1110 524 1095 q 448 1136 472 1124 q 403 1148 424 1148 q 356 1130 372 1148 q 330 1070 340 1112 l 260 1070 q 274 1144 263 1111 q 303 1201 285 1177 q 346 1237 321 1224 q 403 1250 371 1250 q 459 1238 431 1250 q 512 1211 486 1226 q 561 1185 538 1197 q 604 1173 585 1173 q 650 1191 635 1173 q 676 1251 666 1209 l 748 1251 q 733 1177 744 1210 q 704 1121 722 1144 q 661 1084 686 1097 q 604 1072 636 1072 "
  },
  "№": {
    x_min: 135,
    x_max: 1308,
    ha: 1372,
    o: "m 807 0 l 653 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 686 174 l 690 174 q 685 276 688 226 q 683 321 684 298 q 682 366 682 343 q 681 410 681 389 q 680 449 680 431 l 680 992 l 807 992 l 807 0 m 1308 412 q 1294 309 1308 354 q 1254 234 1280 264 q 1190 187 1227 203 q 1107 171 1153 171 q 1028 187 1064 171 q 966 234 992 203 q 924 309 939 264 q 910 412 910 354 q 923 513 910 469 q 963 588 937 558 q 1027 635 990 619 q 1110 651 1064 651 q 1188 635 1152 651 q 1251 588 1225 619 q 1293 513 1278 558 q 1308 412 1308 469 m 1006 412 q 1031 294 1006 334 q 1109 254 1055 254 q 1187 294 1163 254 q 1211 412 1211 334 q 1187 529 1211 491 q 1109 567 1163 567 q 1031 529 1055 567 q 1006 412 1006 491 m 938 0 l 938 83 l 1275 83 l 1275 0 l 938 0 "
  },
  χ: {
    x_min: -14.25,
    x_max: 720,
    ha: 728,
    o: "m 126 747 q 182 736 157 747 q 226 704 207 725 q 263 652 246 683 q 294 580 279 621 l 377 346 l 573 745 l 694 745 l 424 218 l 544 -107 q 564 -155 554 -132 q 586 -194 574 -177 q 617 -221 599 -211 q 660 -231 635 -231 q 693 -229 677 -231 q 720 -226 709 -228 l 720 -322 q 685 -330 705 -326 q 639 -334 666 -334 q 561 -321 593 -334 q 505 -284 529 -308 q 463 -226 481 -260 q 430 -147 446 -191 l 342 98 l 117 -334 l -14 -334 l 294 228 l 185 530 q 142 614 167 584 q 82 644 118 644 q 39 637 58 644 l 39 735 q 75 743 53 740 q 126 747 96 747 "
  },
  ί: {
    x_min: 111,
    x_max: 428,
    ha: 454,
    o: "m 234 743 l 234 220 q 255 121 234 154 q 326 88 277 88 q 353 89 338 88 q 383 93 368 91 q 409 97 397 95 q 428 102 421 100 l 428 8 q 405 0 419 3 q 375 -7 391 -4 q 341 -12 358 -10 q 307 -14 323 -14 q 229 -3 265 -14 q 167 34 193 7 q 125 105 140 60 q 111 219 111 150 l 111 743 l 234 743 m 134 860 q 147 906 140 880 q 160 960 154 932 q 172 1014 167 987 q 181 1064 178 1041 l 316 1064 l 316 1049 q 300 1007 311 1033 q 274 951 289 980 q 241 892 258 921 q 207 842 223 863 l 134 842 l 134 860 "
  },
  Ζ: {
    x_min: 56,
    x_max: 693,
    ha: 749,
    o: "m 693 0 l 56 0 l 56 97 l 537 880 l 70 880 l 70 992 l 679 992 l 679 894 l 197 111 l 693 111 l 693 0 "
  },
  Ľ: {
    x_min: 135,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 0 l 135 992 l 261 992 l 261 111 l 649 111 l 649 0 l 135 0 m 439 787 q 451 834 445 808 q 463 887 457 860 q 473 942 468 915 q 480 992 478 969 l 603 992 l 603 978 q 588 934 598 961 q 564 879 577 908 q 534 820 550 850 q 504 770 519 791 l 439 770 l 439 787 "
  },
  ť: {
    x_min: 23,
    x_max: 505,
    ha: 471,
    o: "m 343 88 q 371 89 355 88 q 400 93 386 91 q 426 97 415 95 q 445 102 438 100 l 445 8 q 422 0 436 3 q 392 -7 409 -4 q 358 -12 376 -10 q 324 -14 341 -14 q 246 -3 282 -14 q 184 34 210 7 q 142 106 157 61 q 128 221 128 152 l 128 656 l 23 656 l 23 709 l 128 759 l 180 915 l 251 915 l 251 745 l 439 745 l 439 656 l 251 656 l 251 221 q 272 121 251 155 q 343 88 294 88 m 341 850 q 353 897 347 871 q 365 950 359 923 q 375 1005 370 978 q 382 1055 380 1032 l 505 1055 l 505 1041 q 490 997 500 1024 q 466 942 479 971 q 436 883 452 913 q 406 833 421 854 l 341 833 l 341 850 "
  },
  o: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 "
  },
  Ѕ: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 "
  },
  "�": {
    x_min: 57.328125,
    x_max: 1331.03125,
    ha: 1389,
    o: "m 693 1055 l 1331 419 l 693 -216 l 57 419 l 693 1055 m 737 249 l 737 280 q 748 331 737 310 q 811 392 759 352 q 904 488 878 443 q 931 592 931 532 q 914 676 931 639 q 866 737 897 712 q 791 775 835 762 q 692 789 747 789 q 632 783 662 789 q 572 769 601 778 q 514 747 542 759 q 464 722 487 736 l 519 601 q 608 640 565 624 q 689 656 651 656 q 753 636 732 656 q 774 584 774 616 q 761 528 774 551 q 692 461 747 505 q 620 384 645 425 q 595 289 595 343 l 595 249 l 737 249 m 577 62 q 601 -4 577 20 q 672 -29 625 -29 q 742 -4 718 -29 q 767 62 767 20 q 742 130 767 105 q 672 155 718 155 q 601 130 625 155 q 577 62 577 105 "
  },
  d: {
    x_min: 77,
    x_max: 696,
    ha: 814,
    o: "m 577 99 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 q 244 10 296 -14 q 154 83 192 34 q 97 203 117 131 q 77 370 77 275 q 97 538 77 466 q 154 659 117 610 q 244 733 192 708 q 359 758 296 758 q 432 749 399 758 q 490 725 464 740 q 537 690 516 710 q 572 649 557 671 l 580 649 q 576 693 578 672 q 573 729 575 711 q 572 759 572 748 l 572 1055 l 696 1055 l 696 0 l 596 0 l 577 99 m 383 88 q 470 104 434 88 q 528 151 506 119 q 560 231 550 183 q 572 342 571 279 l 572 370 q 563 492 572 439 q 532 581 554 545 q 473 636 510 618 q 382 655 437 655 q 247 581 290 655 q 204 369 204 507 q 247 157 204 227 q 383 88 290 88 "
  },
  ",": {
    x_min: 43,
    x_max: 256,
    ha: 347,
    o: "m 245 161 l 256 145 q 233 67 246 108 q 204 -15 220 26 q 170 -99 188 -57 q 136 -179 153 -141 l 43 -179 q 63 -92 53 -137 q 82 -3 72 -48 q 98 82 91 40 q 111 161 106 125 l 245 161 "
  },
  '"': {
    x_min: 90,
    x_max: 468.609375,
    ha: 558,
    o: "m 223 992 l 195 634 l 117 634 l 90 992 l 223 992 m 468 992 l 440 634 l 362 634 l 335 992 l 468 992 "
  },
  ľ: {
    x_min: 118,
    x_max: 469,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 m 305 850 q 317 897 311 871 q 329 950 323 923 q 339 1005 334 978 q 346 1055 344 1032 l 469 1055 l 469 1041 q 454 997 464 1024 q 430 942 443 971 q 400 883 416 913 q 370 833 385 854 l 305 833 l 305 850 "
  },
  ė: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 311 945 q 331 1004 311 986 q 382 1023 352 1023 q 411 1018 397 1023 q 434 1004 424 1014 q 449 980 443 995 q 455 945 455 966 q 434 887 455 906 q 382 868 412 868 q 331 886 352 868 q 311 945 311 905 "
  },
  Í: {
    x_min: 55.34375,
    x_max: 441,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 174 1089 q 204 1134 188 1108 q 236 1187 220 1160 q 267 1242 252 1215 q 292 1293 281 1269 l 441 1293 l 441 1278 q 408 1233 430 1260 q 361 1175 387 1205 q 307 1118 335 1146 q 256 1071 279 1089 l 174 1071 l 174 1089 "
  },
  Ú: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 401 1089 q 431 1134 415 1108 q 463 1187 447 1160 q 494 1242 479 1215 q 519 1293 508 1269 l 668 1293 l 668 1278 q 635 1233 657 1260 q 588 1175 614 1205 q 534 1118 562 1146 q 483 1071 506 1089 l 401 1071 l 401 1089 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 278
  },
  Ŷ: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 m 592 1071 l 510 1071 q 438 1126 475 1093 q 367 1196 402 1159 q 294 1126 330 1159 q 224 1071 258 1093 l 142 1071 l 142 1089 q 182 1134 159 1108 q 228 1187 205 1160 q 271 1242 251 1215 q 301 1293 291 1269 l 432 1293 q 462 1242 442 1269 q 505 1187 482 1215 q 551 1134 528 1160 q 592 1089 575 1108 l 592 1071 "
  },
  Ý: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 m 299 1089 q 329 1134 313 1108 q 361 1187 345 1160 q 392 1242 377 1215 q 417 1293 406 1269 l 566 1293 l 566 1278 q 533 1233 555 1260 q 486 1175 512 1205 q 432 1118 460 1146 q 381 1071 404 1089 l 299 1071 l 299 1089 "
  },
  ŝ: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 m 557 842 l 475 842 q 403 897 440 864 q 332 967 367 930 q 259 897 295 930 q 189 842 223 864 l 107 842 l 107 860 q 147 905 124 879 q 193 958 170 931 q 236 1013 216 986 q 266 1064 256 1040 l 397 1064 q 427 1013 407 1040 q 470 958 447 986 q 516 905 493 931 q 557 860 540 879 l 557 842 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 1389
  },
  ą: {
    x_min: 64,
    x_max: 646,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 527 -161 q 545 -206 527 -191 q 587 -220 563 -220 q 620 -218 604 -220 q 646 -214 636 -217 l 646 -291 q 606 -299 628 -296 q 565 -302 585 -302 q 463 -266 497 -302 q 430 -170 430 -231 q 439 -116 430 -142 q 465 -69 449 -91 q 498 -30 480 -48 q 534 0 517 -12 l 621 0 q 527 -161 527 -90 "
  },
  "​": {
    x_min: 0,
    x_max: 0,
    ha: 0
  },
  ã: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 473 843 q 419 854 446 843 q 367 881 393 866 q 317 907 341 895 q 272 919 293 919 q 225 901 241 919 q 199 841 209 883 l 129 841 q 143 915 132 882 q 172 972 154 948 q 215 1008 190 995 q 272 1021 240 1021 q 328 1009 300 1021 q 381 982 355 997 q 430 956 407 968 q 473 944 454 944 q 519 962 504 944 q 545 1022 535 980 l 617 1022 q 602 948 613 981 q 573 892 591 915 q 530 855 555 868 q 473 843 505 843 "
  },
  æ: {
    x_min: 64,
    x_max: 1088,
    ha: 1157,
    o: "m 64 208 q 142 379 64 320 q 382 445 221 439 l 508 450 l 508 496 q 498 572 508 541 q 469 620 488 602 q 423 647 450 639 q 360 655 395 655 q 254 639 303 655 q 160 599 205 623 l 117 692 q 229 739 167 720 q 359 758 291 758 q 505 729 448 758 q 591 637 562 700 q 681 726 625 694 q 807 758 737 758 q 924 733 872 758 q 1013 665 976 709 q 1068 560 1049 622 q 1088 424 1088 499 l 1088 347 l 634 347 q 687 157 637 218 q 836 96 737 96 q 897 99 869 96 q 952 109 926 103 q 1004 126 979 116 q 1054 148 1029 135 l 1054 36 q 1002 13 1027 23 q 950 -2 977 4 q 895 -11 923 -8 q 833 -14 866 -14 q 672 24 740 -14 q 562 141 604 63 q 513 75 539 104 q 454 27 487 47 q 383 -3 422 7 q 293 -14 343 -14 q 202 0 244 -14 q 130 40 160 12 q 81 109 99 67 q 64 208 64 151 m 191 207 q 224 117 191 146 q 312 88 258 88 q 389 101 354 88 q 451 139 425 113 q 492 204 477 165 q 507 296 507 243 l 507 363 l 408 358 q 305 345 347 355 q 238 315 263 334 q 202 269 213 296 q 191 207 191 241 m 807 655 q 688 603 731 655 q 637 450 644 550 l 960 450 q 951 533 960 495 q 923 598 942 572 q 876 640 904 625 q 807 655 847 655 "
  },
  ĩ: {
    x_min: -63,
    x_max: 425,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 281 843 q 227 854 254 843 q 175 881 201 866 q 125 907 149 895 q 80 919 101 919 q 33 901 49 919 q 7 841 17 883 l -63 841 q -48 915 -59 882 q -19 972 -37 948 q 23 1008 -1 995 q 80 1021 48 1021 q 136 1009 108 1021 q 189 982 163 997 q 238 956 215 968 q 281 944 262 944 q 327 962 312 944 q 353 1022 343 980 l 425 1022 q 410 948 421 981 q 381 892 399 915 q 338 855 363 868 q 281 843 313 843 "
  },
  "~": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 359 441 q 315 459 334 452 q 281 471 297 467 q 252 477 266 475 q 223 479 238 479 q 184 472 204 479 q 143 455 164 466 q 104 429 123 444 q 69 397 85 414 l 69 507 q 237 581 136 581 q 273 579 256 581 q 309 573 290 577 q 350 560 328 568 q 405 538 373 552 q 449 520 430 527 q 483 508 468 512 q 513 502 499 504 q 541 500 527 500 q 581 507 560 500 q 621 524 601 513 q 660 550 641 535 q 696 582 679 565 l 696 472 q 527 399 628 399 q 491 400 508 399 q 455 406 474 402 q 414 419 436 411 q 359 441 391 428 "
  },
  ŀ: {
    x_min: 118,
    x_max: 457.46875,
    ha: 416,
    o: "m 241 0 l 118 0 l 118 1055 l 241 1055 l 241 0 m 313 462 q 333 521 313 503 q 384 540 354 540 q 413 535 399 540 q 436 521 426 531 q 451 497 445 512 q 457 462 457 483 q 436 404 457 423 q 384 385 414 385 q 333 403 354 385 q 313 462 313 422 "
  },
  Ċ: {
    x_min: 85,
    x_max: 798,
    ha: 838,
    o: "m 538 894 q 406 867 465 894 q 305 788 347 839 q 241 662 264 736 q 218 496 218 588 q 238 326 218 400 q 298 200 258 251 q 398 123 338 150 q 538 97 458 97 q 652 108 598 97 q 760 135 707 120 l 760 26 q 707 8 733 15 q 651 -4 680 0 q 590 -11 622 -9 q 517 -14 557 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 497 85 382 q 114 703 85 609 q 201 864 144 796 q 343 968 258 931 q 538 1006 428 1006 q 677 991 611 1006 q 798 947 744 976 l 745 841 q 652 879 702 863 q 538 894 601 894 m 456 1174 q 476 1233 456 1215 q 527 1252 497 1252 q 556 1247 542 1252 q 579 1233 569 1243 q 594 1209 588 1224 q 600 1174 600 1195 q 579 1116 600 1135 q 527 1097 557 1097 q 476 1115 497 1097 q 456 1174 456 1134 "
  },
  "¡": {
    x_min: 100,
    x_max: 272.265625,
    ha: 374,
    o: "m 144 458 l 226 458 l 261 -253 l 110 -253 l 144 458 m 272 663 q 265 619 272 637 q 247 590 259 601 q 220 574 235 579 q 186 569 204 569 q 152 574 168 569 q 125 590 137 579 q 106 619 113 601 q 100 663 100 637 q 106 706 100 688 q 125 735 113 724 q 152 752 137 747 q 186 758 168 758 q 220 752 204 758 q 247 735 235 747 q 265 706 259 724 q 272 663 272 688 "
  },
  ẅ: {
    x_min: 13.75,
    x_max: 1022.25,
    ha: 1036,
    o: "m 683 0 l 570 417 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 546 542 529 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 13 745 l 143 745 l 232 348 q 245 282 239 318 q 258 211 252 246 q 269 146 264 177 q 277 95 274 115 l 281 95 q 290 142 284 113 q 303 205 296 172 q 317 270 310 238 q 331 324 325 302 l 453 745 l 586 745 l 702 324 q 716 270 709 301 q 732 207 724 239 q 745 145 739 175 q 754 95 751 115 l 758 95 q 764 142 760 113 q 775 207 769 172 q 788 279 781 242 q 803 348 795 316 l 896 745 l 1022 745 l 829 0 l 683 0 m 325 945 q 343 998 325 982 q 390 1015 362 1015 q 436 998 416 1015 q 455 945 455 981 q 436 892 455 909 q 390 876 416 876 q 343 892 362 876 q 325 945 325 909 m 579 945 q 598 998 579 982 q 644 1015 617 1015 q 669 1010 657 1015 q 690 998 681 1006 q 704 977 699 989 q 710 945 710 964 q 690 892 710 909 q 644 876 670 876 q 598 892 617 876 q 579 945 579 909 "
  },
  К: {
    x_min: 135,
    x_max: 804.25,
    ha: 804,
    o: "m 804 0 l 655 0 l 261 502 l 261 0 l 135 0 l 135 992 l 261 992 l 261 511 l 644 992 l 784 992 l 401 515 l 804 0 "
  },
  Γ: {
    x_min: 135,
    x_max: 649,
    ha: 682,
    o: "m 649 992 l 649 880 l 261 880 l 261 0 l 135 0 l 135 992 l 649 992 "
  },
  P: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 701 q 710 582 729 639 q 648 482 691 525 q 536 412 606 438 q 362 386 465 386 l 261 386 l 261 0 l 135 0 l 135 992 l 380 992 q 537 972 471 992 q 645 916 602 953 q 708 825 688 879 q 729 701 729 770 m 261 493 l 347 493 q 456 504 410 493 q 533 539 503 515 q 579 601 564 563 q 595 695 595 640 q 540 837 595 791 q 368 884 485 884 l 261 884 l 261 493 "
  },
  "%": {
    x_min: 69,
    x_max: 1076,
    ha: 1146,
    o: "m 169 695 q 193 527 169 583 q 271 471 217 471 q 377 695 377 471 q 271 917 377 917 q 193 862 217 917 q 169 695 169 807 m 478 695 q 465 564 478 622 q 428 465 453 505 q 364 404 403 425 q 271 383 325 383 q 184 404 222 383 q 120 465 146 425 q 81 564 94 505 q 69 695 69 622 q 80 826 69 769 q 117 924 92 884 q 180 984 142 963 q 271 1006 218 1006 q 360 984 322 1006 q 425 924 399 963 q 464 826 451 884 q 478 695 478 769 m 768 297 q 792 129 768 185 q 870 74 816 74 q 975 297 975 74 q 870 519 975 519 q 792 464 816 519 q 768 297 768 409 m 1076 298 q 1064 166 1076 224 q 1027 68 1052 108 q 963 7 1002 28 q 870 -14 924 -14 q 782 7 820 -14 q 719 68 744 28 q 680 166 693 108 q 668 298 668 224 q 679 428 668 371 q 716 526 691 486 q 779 586 741 565 q 870 608 817 608 q 959 586 921 608 q 1023 526 998 565 q 1062 428 1049 486 q 1076 298 1076 371 m 902 992 l 351 0 l 244 0 l 795 992 l 902 992 "
  },
  ϖ: {
    x_min: 11.828125,
    x_max: 1106.265625,
    ha: 1150,
    o: "m 374 -14 q 185 65 251 -14 q 119 310 119 145 q 125 392 119 349 q 142 477 131 434 q 167 562 152 520 q 199 642 182 604 l 11 642 l 11 691 l 102 745 l 1106 745 l 1106 642 l 941 642 q 970 562 957 604 q 992 477 983 520 q 1006 392 1001 434 q 1012 310 1012 349 q 945 65 1012 145 q 756 -14 879 -14 q 637 15 684 -14 q 569 106 590 45 l 562 106 q 493 15 541 45 q 374 -14 446 -14 m 321 642 q 293 565 306 605 q 269 484 279 525 q 252 401 258 442 q 246 320 246 359 q 256 208 246 253 q 284 137 266 164 q 327 99 302 110 q 382 88 352 88 q 436 102 413 88 q 474 140 459 116 q 496 198 489 165 q 504 270 504 231 l 504 390 l 627 390 l 627 270 q 660 135 627 182 q 748 88 693 88 q 803 99 778 88 q 846 137 828 110 q 874 208 865 164 q 884 320 884 253 q 879 401 884 359 q 865 484 874 442 q 845 565 857 525 q 819 642 833 605 l 321 642 "
  },
  _: {
    x_min: -3,
    x_max: 574,
    ha: 571,
    o: "m 574 -219 l -3 -219 l -3 -125 l 574 -125 l 574 -219 "
  },
  ñ: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 m 514 843 q 460 854 487 843 q 408 881 434 866 q 358 907 382 895 q 313 919 334 919 q 266 901 282 919 q 240 841 250 883 l 170 841 q 184 915 173 882 q 213 972 195 948 q 256 1008 231 995 q 313 1021 281 1021 q 369 1009 341 1021 q 422 982 396 997 q 471 956 448 968 q 514 944 495 944 q 560 962 545 944 q 586 1022 576 980 l 658 1022 q 643 948 654 981 q 614 892 632 915 q 571 855 596 868 q 514 843 546 843 "
  },
  Ŕ: {
    x_min: 135,
    x_max: 803.25,
    ha: 819,
    o: "m 261 410 l 261 0 l 135 0 l 135 992 l 376 992 q 642 922 556 992 q 729 710 729 852 q 712 607 729 651 q 668 531 695 563 q 605 479 640 500 q 533 444 570 458 l 803 0 l 654 0 l 416 410 l 261 410 m 261 517 l 371 517 q 473 529 431 517 q 543 564 516 541 q 582 623 570 588 q 595 704 595 658 q 581 787 595 753 q 540 842 567 821 q 469 874 512 864 q 368 884 426 884 l 261 884 l 261 517 m 324 1089 q 354 1134 338 1108 q 386 1187 370 1160 q 417 1242 402 1215 q 442 1293 431 1269 l 591 1293 l 591 1278 q 558 1233 580 1260 q 511 1175 537 1205 q 457 1118 485 1146 q 406 1071 429 1089 l 324 1071 l 324 1089 "
  },
  "‚": {
    x_min: 43,
    x_max: 256,
    ha: 347,
    o: "m 246 161 l 256 145 q 233 67 246 108 q 204 -15 220 26 q 170 -99 188 -57 q 136 -179 153 -141 l 43 -179 q 66 -92 54 -137 q 88 -3 77 -48 q 107 82 98 40 q 122 161 116 125 l 246 161 "
  },
  "⅞": {
    x_min: 77,
    x_max: 1011,
    ha: 1051,
    o: "m 141 397 l 363 908 l 77 908 l 77 992 l 460 992 l 460 924 l 243 397 l 141 397 m 804 992 l 253 0 l 146 0 l 697 992 l 804 992 m 815 604 q 883 594 851 604 q 938 567 914 585 q 976 519 962 548 q 991 453 991 491 q 983 407 991 428 q 962 369 976 386 q 931 338 949 352 q 893 313 914 325 q 938 285 917 300 q 975 251 959 270 q 1001 209 991 233 q 1011 157 1011 186 q 996 87 1011 119 q 956 33 982 56 q 894 0 930 11 q 816 -13 858 -13 q 670 31 721 -13 q 620 153 620 75 q 628 205 620 182 q 651 247 636 228 q 684 281 665 266 q 724 307 703 295 q 690 335 705 321 q 662 368 674 350 q 644 407 650 386 q 638 453 638 428 q 652 519 638 491 q 691 566 667 547 q 748 594 716 585 q 815 604 780 604 m 716 155 q 741 93 716 116 q 814 70 766 70 q 888 93 863 70 q 914 155 914 116 q 906 190 914 174 q 885 219 899 206 q 854 242 872 232 q 813 262 835 253 l 802 266 q 738 219 760 244 q 716 155 716 193 m 813 520 q 755 502 776 520 q 734 449 734 484 q 741 417 734 431 q 757 392 747 404 q 783 371 768 380 q 815 353 798 361 q 846 370 831 360 q 871 390 860 379 q 887 416 881 402 q 894 449 894 430 q 872 502 894 484 q 813 520 850 520 "
  },
  Æ: {
    x_min: -1.25,
    x_max: 1101,
    ha: 1184,
    o: "m 1101 0 l 585 0 l 585 307 l 262 307 l 124 0 l -1 0 l 443 992 l 1101 992 l 1101 880 l 711 880 l 711 574 l 1075 574 l 1075 462 l 711 462 l 711 111 l 1101 111 l 1101 0 m 311 419 l 585 419 l 585 880 l 512 880 l 311 419 "
  },
  "₣": {
    x_min: 65,
    x_max: 694,
    ha: 765,
    o: "m 310 271 l 503 271 l 503 163 l 310 163 l 310 0 l 184 0 l 184 163 l 65 163 l 65 271 l 184 271 l 184 992 l 694 992 l 694 880 l 310 880 l 310 531 l 668 531 l 668 419 l 310 419 l 310 271 "
  },
  Ū: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 290 1172 l 680 1172 l 680 1071 l 290 1071 l 290 1172 "
  },
  ы: {
    x_min: 118,
    x_max: 922,
    ha: 1040,
    o: "m 241 439 l 401 439 q 613 386 544 439 q 683 227 683 333 q 667 133 683 175 q 616 61 651 91 q 528 15 582 31 q 398 0 475 0 l 118 0 l 118 745 l 241 745 l 241 439 m 922 0 l 798 0 l 798 745 l 922 745 l 922 0 m 241 336 l 241 102 l 388 102 q 457 108 426 102 q 511 127 488 113 q 546 164 534 141 q 559 219 559 186 q 548 275 559 252 q 515 311 537 297 q 461 330 493 325 q 386 336 429 336 l 241 336 "
  },
  ѓ: {
    x_min: 118,
    x_max: 527,
    ha: 555,
    o: "m 527 642 l 241 642 l 241 0 l 118 0 l 118 745 l 527 745 l 527 642 m 236 860 q 266 905 250 879 q 298 958 282 931 q 329 1013 314 986 q 354 1064 343 1040 l 503 1064 l 503 1049 q 470 1004 492 1031 q 423 946 449 976 q 369 889 397 917 q 318 842 341 860 l 236 842 l 236 860 "
  },
  Œ: {
    x_min: 85,
    x_max: 1153,
    ha: 1236,
    o: "m 1153 0 l 639 0 q 578 -10 609 -6 q 515 -14 548 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 516 1007 406 1007 q 640 992 583 1007 l 1153 992 l 1153 880 l 764 880 l 764 574 l 1127 574 l 1127 462 l 764 462 l 764 111 l 1153 111 l 1153 0 m 517 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 581 103 551 97 q 638 119 612 109 l 638 873 q 582 890 612 884 q 517 895 551 895 "
  },
  "΅": {
    x_min: 187,
    x_max: 614,
    ha: 802,
    o: "m 346 959 q 361 1005 353 980 q 378 1057 370 1030 q 393 1112 386 1084 q 406 1164 401 1139 l 547 1164 l 547 1150 q 518 1102 534 1128 q 483 1049 502 1076 q 443 994 464 1022 q 401 942 423 967 l 346 942 l 346 959 m 187 945 q 201 998 187 982 q 236 1015 215 1015 q 254 1010 245 1015 q 270 998 263 1006 q 280 977 276 989 q 284 945 284 964 q 269 892 284 909 q 236 876 255 876 q 201 892 215 876 q 187 945 187 909 m 516 945 q 530 998 516 982 q 565 1015 544 1015 q 583 1010 574 1015 q 599 998 592 1006 q 609 977 605 989 q 614 945 614 964 q 599 892 614 909 q 565 876 584 876 q 530 892 544 876 q 516 945 516 909 "
  },
  Ą: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 706 -161 q 724 -206 706 -191 q 766 -220 742 -220 q 799 -218 783 -220 q 825 -214 815 -217 l 825 -291 q 785 -299 807 -296 q 744 -302 764 -302 q 642 -266 676 -302 q 609 -170 609 -231 q 618 -116 609 -142 q 644 -69 628 -91 q 677 -30 659 -48 q 713 0 696 -12 l 800 0 q 706 -161 706 -90 "
  },
  Њ: {
    x_min: 135,
    x_max: 1224,
    ha: 1295,
    o: "m 1224 290 q 1203 170 1224 224 q 1140 79 1183 117 q 1031 20 1097 41 q 874 0 965 0 l 656 0 l 656 462 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 656 574 l 656 992 l 782 992 l 782 574 l 856 574 q 1030 551 959 574 q 1143 490 1100 529 q 1205 400 1186 452 q 1224 290 1224 349 m 782 107 l 862 107 q 1035 152 979 107 q 1090 290 1090 197 q 1074 370 1090 337 q 1028 424 1059 403 q 951 453 997 444 q 841 462 904 462 l 782 462 l 782 107 "
  },
  "›": {
    x_min: 56,
    x_max: 343.5,
    ha: 400,
    o: "m 343 356 l 134 78 l 56 130 l 216 367 l 56 603 l 134 656 l 343 375 l 343 356 "
  },
  ћ: {
    x_min: 12.1875,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 451 q 547 583 583 539 q 436 627 512 627 q 343 609 381 627 q 283 557 306 592 q 251 473 261 523 q 241 357 241 422 l 241 0 l 118 0 l 118 843 l 12 843 l 12 932 l 118 932 l 118 1055 l 241 1055 l 241 932 l 498 932 l 498 843 l 241 843 l 241 715 l 236 616 l 242 616 q 283 666 259 645 q 334 702 306 687 q 393 723 362 716 q 457 730 424 730 q 644 665 581 730 q 707 458 707 600 l 707 0 l 583 0 "
  },
  "<": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 696 161 l 69 448 l 69 517 l 696 844 l 696 735 l 197 488 l 696 270 l 696 161 "
  },
  "¬": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 696 541 l 696 178 l 594 178 l 594 439 l 69 439 l 69 541 l 696 541 "
  },
  t: {
    x_min: 23,
    x_max: 445,
    ha: 471,
    o: "m 343 88 q 371 89 355 88 q 400 93 386 91 q 426 97 415 95 q 445 102 438 100 l 445 8 q 422 0 436 3 q 392 -7 409 -4 q 358 -12 376 -10 q 324 -14 341 -14 q 246 -3 282 -14 q 184 34 210 7 q 142 106 157 61 q 128 221 128 152 l 128 656 l 23 656 l 23 709 l 128 759 l 180 915 l 251 915 l 251 745 l 439 745 l 439 656 l 251 656 l 251 221 q 272 121 251 155 q 343 88 294 88 "
  },
  Ц: {
    x_min: 135,
    x_max: 945,
    ha: 973,
    o: "m 826 111 l 945 111 l 945 -261 l 818 -261 l 818 0 l 135 0 l 135 992 l 261 992 l 261 111 l 699 111 l 699 992 l 826 992 l 826 111 "
  },
  ù: {
    x_min: 111,
    x_max: 700,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 471 842 l 389 842 q 337 889 365 860 q 283 946 309 917 q 236 1004 257 976 q 204 1049 214 1031 l 204 1064 l 352 1064 q 378 1013 363 1040 q 408 958 392 986 q 440 905 424 931 q 471 860 456 879 l 471 842 "
  },
  ï: {
    x_min: -13,
    x_max: 372,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m -13 945 q 5 998 -13 982 q 52 1015 24 1015 q 98 998 78 1015 q 117 945 117 981 q 98 892 117 909 q 52 876 78 876 q 5 892 24 876 q -13 945 -13 909 m 241 945 q 260 998 241 982 q 306 1015 279 1015 q 331 1010 319 1015 q 352 998 343 1006 q 366 977 361 989 q 372 945 372 964 q 352 892 372 909 q 306 876 332 876 q 260 892 279 876 q 241 945 241 909 "
  },
  Ф: {
    x_min: 71,
    x_max: 994,
    ha: 1065,
    o: "m 468 1006 l 594 1006 l 594 884 l 643 884 q 801 852 735 884 q 910 768 867 820 q 973 649 953 716 q 994 514 994 583 q 985 429 994 472 q 959 343 977 385 q 913 264 942 301 q 844 199 885 227 q 749 155 803 171 q 626 139 694 139 l 594 139 l 594 -14 l 468 -14 l 468 139 l 436 139 q 314 155 368 139 q 220 199 260 171 q 151 264 179 227 q 105 343 122 301 q 79 429 87 385 q 71 514 71 472 q 91 649 71 583 q 154 768 112 716 q 262 852 197 820 q 418 884 328 884 l 468 884 l 468 1006 m 594 246 l 611 246 q 721 266 674 246 q 798 322 768 286 q 844 408 829 358 q 860 517 860 458 q 846 617 860 570 q 804 700 832 665 q 734 755 776 735 q 632 776 691 776 l 594 776 l 594 246 m 468 776 l 429 776 q 329 755 371 776 q 259 700 287 735 q 217 617 231 665 q 204 517 204 570 q 219 408 204 458 q 265 322 235 358 q 342 266 295 286 q 450 246 388 246 l 468 246 l 468 776 "
  },
  Ò: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 591 1071 l 509 1071 q 457 1118 485 1089 q 403 1175 429 1146 q 356 1233 377 1205 q 324 1278 334 1260 l 324 1293 l 472 1293 q 498 1242 483 1269 q 528 1187 512 1215 q 560 1134 544 1160 q 591 1089 576 1108 l 591 1071 "
  },
  I: {
    x_min: 55.34375,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 "
  },
  "˝": {
    x_min: 151,
    x_max: 649,
    ha: 802,
    o: "m 151 860 q 181 905 165 879 q 213 958 197 931 q 243 1013 229 986 q 269 1064 258 1040 l 404 1064 l 404 1049 q 371 1004 393 1031 q 324 946 350 976 q 270 889 298 917 q 219 842 243 860 l 151 842 l 151 860 m 397 860 q 427 905 411 879 q 459 958 443 931 q 489 1013 475 986 q 514 1064 504 1040 l 649 1064 l 649 1049 q 616 1004 638 1031 q 569 946 595 976 q 515 889 543 917 q 464 842 488 860 l 397 842 l 397 860 "
  },
  "·": {
    x_min: 100,
    x_max: 272,
    ha: 372,
    o: "m 100 490 q 106 534 100 516 q 125 563 113 552 q 152 579 136 574 q 186 585 167 585 q 219 579 203 585 q 246 563 235 574 q 265 534 258 552 q 272 490 272 516 q 265 447 272 465 q 246 418 258 430 q 219 401 235 406 q 186 396 203 396 q 152 401 167 396 q 125 418 136 406 q 106 447 113 430 q 100 490 100 465 "
  },
  "¿": {
    x_min: 46,
    x_max: 567,
    ha: 591,
    o: "m 401 458 l 401 432 q 395 362 401 393 q 376 304 390 331 q 341 251 363 276 q 285 196 319 225 q 229 146 252 169 q 191 100 206 123 q 169 50 176 76 q 162 -12 162 23 q 172 -72 162 -45 q 202 -118 183 -99 q 250 -148 221 -138 q 317 -159 279 -159 q 425 -141 374 -159 q 523 -100 476 -124 l 567 -199 q 447 -247 511 -227 q 318 -267 383 -267 q 204 -249 254 -267 q 118 -199 153 -232 q 64 -120 83 -167 q 46 -14 46 -73 q 54 67 46 32 q 79 133 62 102 q 120 192 95 163 q 179 252 145 220 q 231 305 211 283 q 263 349 252 328 q 280 393 275 370 q 284 445 284 415 l 284 458 l 401 458 m 433 663 q 426 619 433 637 q 408 590 420 601 q 380 574 396 579 q 346 569 365 569 q 313 574 329 569 q 286 590 298 579 q 267 619 274 601 q 260 663 260 637 q 267 706 260 688 q 286 735 274 724 q 313 752 298 747 q 346 758 329 758 q 380 752 365 758 q 408 735 396 747 q 426 706 420 724 q 433 663 433 688 "
  },
  ſ: {
    x_min: 118,
    x_max: 476,
    ha: 399,
    o: "m 118 0 l 118 814 q 133 934 118 886 q 177 1010 148 982 q 248 1051 206 1039 q 343 1063 290 1063 q 416 1055 383 1063 q 476 1037 450 1047 l 444 941 q 398 954 423 949 q 347 960 374 960 q 300 954 320 960 q 267 931 280 947 q 247 887 254 915 q 241 814 241 858 l 241 0 l 118 0 "
  },
  Ђ: {
    x_min: 13,
    x_max: 873,
    ha: 977,
    o: "m 628 -14 q 572 -9 596 -14 q 532 2 548 -5 l 532 111 q 574 101 551 105 q 624 97 597 97 q 667 103 646 97 q 707 127 689 110 q 735 174 724 144 q 746 250 746 203 l 746 340 q 711 458 746 419 q 591 497 675 497 l 370 497 l 370 0 l 244 0 l 244 880 l 13 880 l 13 992 l 654 992 l 654 880 l 370 880 l 370 609 l 605 609 q 718 592 668 609 q 802 543 768 575 q 854 464 836 511 q 873 356 873 417 l 873 263 q 855 140 873 192 q 804 53 837 87 q 727 2 772 19 q 628 -14 682 -14 "
  },
  ű: {
    x_min: 111,
    x_max: 704,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 206 860 q 236 905 220 879 q 268 958 252 931 q 298 1013 284 986 q 324 1064 313 1040 l 459 1064 l 459 1049 q 426 1004 448 1031 q 379 946 405 976 q 325 889 353 917 q 274 842 298 860 l 206 842 l 206 860 m 452 860 q 482 905 466 879 q 514 958 498 931 q 544 1013 530 986 q 569 1064 559 1040 l 704 1064 l 704 1049 q 671 1004 693 1031 q 624 946 650 976 q 570 889 598 917 q 519 842 543 860 l 452 842 l 452 860 "
  },
  Ǽ: {
    x_min: -1.25,
    x_max: 1101,
    ha: 1184,
    o: "m 1101 0 l 585 0 l 585 307 l 262 307 l 124 0 l -1 0 l 443 992 l 1101 992 l 1101 880 l 711 880 l 711 574 l 1075 574 l 1075 462 l 711 462 l 711 111 l 1101 111 l 1101 0 m 311 419 l 585 419 l 585 880 l 512 880 l 311 419 m 639 1089 q 669 1134 653 1108 q 701 1187 685 1160 q 732 1242 717 1215 q 757 1293 746 1269 l 906 1293 l 906 1278 q 873 1233 895 1260 q 826 1175 852 1205 q 772 1118 800 1146 q 721 1071 744 1089 l 639 1071 l 639 1089 "
  },
  φ: {
    x_min: 77,
    x_max: 893,
    ha: 970,
    o: "m 417 -334 l 417 -12 q 280 14 343 -8 q 173 83 218 36 q 102 201 127 129 q 77 376 77 274 q 87 484 77 432 q 117 582 98 535 q 163 671 136 629 q 220 751 189 713 l 315 686 q 269 616 290 651 q 232 542 247 581 q 208 462 217 504 q 200 371 200 419 q 217 244 200 296 q 264 160 235 193 q 334 111 294 127 q 417 90 373 95 l 417 500 q 472 692 417 627 q 626 758 528 758 q 737 730 687 758 q 821 654 786 703 q 874 538 855 606 q 893 387 893 469 q 864 212 893 286 q 786 90 835 139 q 674 16 738 41 q 540 -12 610 -8 l 540 -334 l 417 -334 m 765 386 q 755 502 765 452 q 727 586 745 552 q 684 638 709 621 q 631 655 660 655 q 596 647 613 655 q 567 622 580 640 q 547 574 555 604 q 540 501 540 545 l 540 90 q 630 115 588 95 q 701 171 671 135 q 748 261 731 207 q 765 386 765 314 "
  },
  ";": {
    x_min: 43,
    x_max: 272,
    ha: 372,
    o: "m 245 161 l 256 145 q 233 67 246 108 q 204 -15 220 26 q 170 -99 188 -57 q 136 -179 153 -141 l 43 -179 q 63 -92 53 -137 q 82 -3 72 -48 q 98 82 91 40 q 111 161 106 125 l 245 161 m 100 669 q 106 714 100 696 q 125 743 113 732 q 152 759 136 754 q 186 764 167 764 q 219 759 203 764 q 246 743 235 754 q 265 714 258 732 q 272 669 272 696 q 265 626 272 644 q 246 597 258 609 q 219 580 235 585 q 186 575 203 575 q 152 580 167 575 q 125 597 136 585 q 106 626 113 609 q 100 669 100 644 "
  },
  Ș: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 m 249 -288 q 265 -246 256 -271 q 282 -191 274 -220 q 296 -135 290 -163 q 305 -85 303 -107 l 428 -85 l 428 -98 q 413 -141 423 -115 q 387 -197 402 -167 q 353 -255 372 -226 q 315 -307 335 -284 l 249 -307 l 249 -288 "
  },
  Ġ: {
    x_min: 85,
    x_max: 858,
    ha: 958,
    o: "m 530 524 l 858 524 l 858 36 q 782 15 820 24 q 704 0 744 5 q 620 -10 664 -7 q 526 -14 576 -14 q 337 21 419 -14 q 199 123 255 57 q 114 284 143 189 q 85 497 85 378 q 117 708 85 613 q 211 868 149 802 q 363 970 272 934 q 569 1006 453 1006 q 713 991 644 1006 q 842 947 782 976 l 793 837 q 741 859 769 849 q 683 877 713 869 q 621 890 653 885 q 559 894 590 894 q 412 867 476 894 q 306 788 349 839 q 240 662 263 736 q 218 496 218 588 q 237 334 218 407 q 296 208 255 261 q 401 126 336 155 q 556 97 465 97 q 610 98 585 97 q 656 103 635 100 q 695 109 677 106 q 731 116 714 113 l 731 412 l 530 412 l 530 524 m 464 1174 q 484 1233 464 1215 q 535 1252 505 1252 q 564 1247 550 1252 q 587 1233 577 1243 q 602 1209 596 1224 q 608 1174 608 1195 q 587 1116 608 1135 q 535 1097 565 1097 q 484 1115 505 1097 q 464 1174 464 1134 "
  },
  n: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 "
  },
  ά: {
    x_min: 77,
    x_max: 792.984375,
    ha: 814,
    o: "m 383 88 q 470 104 434 88 q 528 153 506 120 q 560 238 550 186 q 572 360 571 289 l 572 370 q 563 492 572 439 q 532 581 554 545 q 473 636 510 618 q 382 655 437 655 q 247 581 290 655 q 204 369 204 507 q 247 157 204 227 q 383 88 290 88 m 359 -14 q 244 10 296 -14 q 154 83 192 34 q 97 203 117 131 q 77 370 77 275 q 97 538 77 466 q 156 659 118 610 q 249 733 194 708 q 372 758 304 758 q 497 729 448 758 q 579 644 546 701 l 587 644 q 605 695 594 667 q 633 745 616 723 l 730 745 q 716 687 723 722 q 705 610 710 651 q 698 527 701 569 q 696 446 696 484 l 696 162 q 712 104 696 121 q 752 87 729 87 q 775 89 762 87 q 792 93 787 91 l 792 3 q 760 -8 782 -2 q 715 -14 738 -14 q 668 -8 689 -14 q 630 10 647 -3 q 601 45 613 23 q 580 99 588 66 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 m 359 860 q 372 906 365 880 q 385 960 379 932 q 397 1014 392 987 q 406 1064 403 1041 l 541 1064 l 541 1049 q 525 1007 536 1033 q 499 951 514 980 q 466 892 483 921 q 432 842 448 863 l 359 842 l 359 860 "
  },
  ϊ: {
    x_min: 14,
    x_max: 428,
    ha: 454,
    o: "m 234 743 l 234 220 q 255 121 234 154 q 326 88 277 88 q 353 89 338 88 q 383 93 368 91 q 409 97 397 95 q 428 102 421 100 l 428 8 q 405 0 419 3 q 375 -7 391 -4 q 341 -12 358 -10 q 307 -14 323 -14 q 229 -3 265 -14 q 167 34 193 7 q 125 105 140 60 q 111 219 111 150 l 111 743 l 234 743 m 14 945 q 32 998 14 982 q 79 1015 51 1015 q 125 998 105 1015 q 144 945 144 981 q 125 892 144 909 q 79 876 105 876 q 32 892 51 876 q 14 945 14 909 m 268 945 q 287 998 268 982 q 333 1015 306 1015 q 358 1010 346 1015 q 379 998 370 1006 q 393 977 388 989 q 399 945 399 964 q 379 892 399 909 q 333 876 359 876 q 287 892 306 876 q 268 945 268 909 "
  },
  "\uFEFF": {
    x_min: 0,
    x_max: 0,
    ha: 0
  },
  ģ: {
    x_min: 25,
    x_max: 692.484375,
    ha: 720,
    o: "m 692 745 l 692 668 l 559 649 q 591 588 578 625 q 604 504 604 551 q 588 409 604 453 q 539 333 572 365 q 459 283 507 301 q 348 266 412 266 q 319 266 333 266 q 294 268 304 266 q 271 253 282 261 q 251 233 260 244 q 236 208 242 222 q 230 178 230 194 q 238 148 230 159 q 260 130 246 136 q 293 122 274 124 q 333 120 312 120 l 453 120 q 560 104 516 120 q 631 61 603 88 q 670 -2 658 34 q 683 -80 683 -38 q 660 -186 683 -139 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 96 -278 132 -305 q 42 -213 60 -251 q 25 -128 25 -175 q 38 -57 25 -87 q 73 -4 51 -26 q 125 32 96 17 q 187 53 155 46 q 140 94 158 66 q 122 159 122 122 q 143 231 122 201 q 212 291 165 262 q 158 324 182 303 q 118 373 134 346 q 92 433 101 401 q 83 500 83 466 q 99 608 83 561 q 150 689 116 656 q 233 740 183 722 q 348 758 282 758 q 400 754 373 758 q 445 745 427 750 l 692 745 m 141 -126 q 150 -173 141 -151 q 179 -211 159 -195 q 232 -235 199 -226 q 314 -245 265 -245 q 503 -205 440 -245 q 566 -92 566 -166 q 558 -41 566 -61 q 531 -10 550 -21 q 482 4 512 0 q 407 8 451 8 l 287 8 q 238 3 263 8 q 190 -17 212 -2 q 155 -58 169 -32 q 141 -126 141 -84 m 206 504 q 242 388 206 426 q 344 350 278 350 q 446 388 411 350 q 480 506 480 426 q 445 629 480 590 q 343 669 410 669 q 241 628 277 669 q 206 504 206 587 m 467 1045 q 450 1003 458 1028 q 433 948 441 977 q 418 892 424 920 q 410 842 412 864 l 288 842 l 288 856 q 302 898 291 872 q 328 954 312 925 q 362 1012 343 983 q 400 1064 381 1041 l 467 1064 l 467 1045 "
  },
  "∂": {
    x_min: 66,
    x_max: 734,
    ha: 807,
    o: "m 734 633 q 723 485 734 561 q 690 336 712 408 q 633 201 668 264 q 552 89 599 137 q 446 13 506 41 q 312 -14 386 -14 q 192 8 240 -14 q 117 68 145 30 q 77 153 89 105 q 66 254 66 202 q 73 342 66 294 q 98 438 81 390 q 142 530 115 486 q 209 609 170 575 q 299 664 247 643 q 417 685 351 685 q 529 658 479 685 q 609 584 578 631 q 610 611 610 597 q 610 633 610 626 q 563 831 610 762 q 424 899 516 899 q 380 895 403 899 q 334 883 357 891 q 289 865 311 876 q 249 841 268 854 l 249 959 q 288 975 266 968 q 336 989 311 983 q 389 998 362 995 q 441 1002 415 1002 q 582 971 525 1002 q 671 890 638 941 q 719 773 705 839 q 734 633 734 706 m 319 88 q 387 103 355 88 q 446 145 418 118 q 496 207 473 171 q 537 285 519 243 q 567 373 555 327 q 586 465 580 419 q 566 516 580 492 q 532 557 552 540 q 487 585 512 575 q 434 596 462 596 q 358 579 392 596 q 296 535 323 563 q 250 471 270 507 q 218 397 230 435 q 199 321 205 359 q 193 251 193 283 q 200 186 193 216 q 222 135 207 157 q 261 100 238 113 q 319 88 285 88 "
  },
  κ: {
    x_min: 118,
    x_max: 684.25,
    ha: 689,
    o: "m 545 0 l 315 331 l 241 276 l 241 0 l 118 0 l 118 745 l 241 745 l 241 554 q 239 479 241 513 q 236 418 238 444 q 230 364 233 388 l 319 483 l 526 745 l 665 745 l 394 412 l 684 0 l 545 0 "
  },
  "‡": {
    x_min: 84,
    x_max: 606.171875,
    ha: 689,
    o: "m 380 336 l 606 357 l 606 235 l 380 256 l 418 0 l 271 0 l 308 256 l 84 235 l 84 357 l 308 336 l 277 532 l 308 718 l 84 697 l 84 820 l 308 799 l 271 1055 l 418 1055 l 380 799 l 606 820 l 606 697 l 380 718 l 412 532 l 380 336 "
  },
  ň: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 m 634 1045 q 593 1000 617 1026 q 547 947 570 974 q 504 892 524 919 q 474 842 484 865 l 343 842 q 313 892 333 865 q 270 947 293 919 q 224 1000 247 974 q 184 1045 201 1026 l 184 1064 l 266 1064 q 336 1008 300 1041 q 409 937 372 975 q 480 1008 444 975 q 552 1064 517 1041 l 634 1064 l 634 1045 "
  },
  "√": {
    x_min: 25,
    x_max: 828.25,
    ha: 762,
    o: "m 424 -10 l 334 -10 l 147 522 l 25 522 l 25 615 l 226 615 l 381 165 l 729 1150 l 828 1150 l 424 -10 "
  },
  ę: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 506 -140 q 524 -185 506 -170 q 566 -199 542 -199 q 599 -197 583 -199 q 625 -193 615 -196 l 625 -270 q 585 -278 607 -275 q 544 -281 564 -281 q 442 -245 476 -281 q 409 -149 409 -210 q 418 -95 409 -121 q 444 -48 428 -70 q 477 -9 459 -27 q 513 21 496 8 l 600 21 q 506 -140 506 -69 "
  },
  į: {
    x_min: 47,
    x_max: 263,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 m 144 -161 q 162 -206 144 -191 q 204 -220 180 -220 q 237 -218 221 -220 q 263 -214 253 -217 l 263 -291 q 223 -299 245 -296 q 182 -302 202 -302 q 80 -266 114 -302 q 47 -170 47 -231 q 56 -116 47 -142 q 82 -69 66 -91 q 115 -30 97 -48 q 151 0 134 -12 l 238 0 q 144 -161 144 -90 "
  },
  Τ: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 423 0 l 297 0 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 0 "
  },
  "≈": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 359 300 q 315 318 334 311 q 281 330 297 326 q 252 336 266 334 q 223 338 238 338 q 184 331 204 338 q 143 314 164 325 q 104 288 123 303 q 69 256 85 273 l 69 366 q 237 440 136 440 q 273 438 256 440 q 309 432 290 436 q 350 419 328 427 q 405 397 373 411 q 449 379 430 386 q 483 367 468 371 q 513 361 499 363 q 541 359 527 359 q 581 366 560 359 q 621 383 601 372 q 660 409 641 394 q 696 441 679 424 l 696 331 q 527 258 628 258 q 491 259 508 258 q 455 265 474 261 q 414 278 436 270 q 359 300 391 287 m 359 578 q 315 596 334 589 q 281 608 297 604 q 252 614 266 612 q 223 616 238 616 q 184 609 204 616 q 143 592 164 603 q 104 566 123 581 q 69 533 85 551 l 69 643 q 237 718 136 718 q 273 716 256 718 q 309 709 290 714 q 350 696 328 705 q 405 674 373 688 q 449 656 430 664 q 483 645 468 649 q 513 639 499 641 q 541 637 527 637 q 581 644 560 637 q 621 661 601 650 q 660 687 641 672 q 696 719 679 702 l 696 609 q 527 536 630 536 q 491 537 508 536 q 455 543 474 539 q 414 556 436 548 q 359 578 391 565 "
  },
  ΐ: {
    x_min: -19,
    x_max: 428,
    ha: 454,
    o: "m 234 743 l 234 220 q 255 121 234 154 q 326 88 277 88 q 353 89 338 88 q 383 93 368 91 q 409 97 397 95 q 428 102 421 100 l 428 8 q 405 0 419 3 q 375 -7 391 -4 q 341 -12 358 -10 q 307 -14 323 -14 q 229 -3 265 -14 q 167 34 193 7 q 125 105 140 60 q 111 219 111 150 l 111 743 l 234 743 m 140 959 q 155 1005 147 980 q 172 1057 164 1030 q 187 1112 180 1084 q 200 1164 195 1139 l 341 1164 l 341 1150 q 312 1102 328 1128 q 277 1049 296 1076 q 237 994 258 1022 q 195 942 217 967 l 140 942 l 140 959 m -19 945 q -4 998 -19 982 q 30 1015 9 1015 q 48 1010 39 1015 q 64 998 57 1006 q 74 977 70 989 q 78 945 78 964 q 63 892 78 909 q 30 876 49 876 q -4 892 9 876 q -19 945 -19 909 m 310 945 q 324 998 310 982 q 359 1015 338 1015 q 377 1010 368 1015 q 393 998 386 1006 q 403 977 399 989 q 408 945 408 964 q 393 892 408 909 q 359 876 378 876 q 324 892 338 876 q 310 945 310 909 "
  },
  ĸ: {
    x_min: 118,
    x_max: 684.25,
    ha: 689,
    o: "m 545 0 l 315 331 l 241 276 l 241 0 l 118 0 l 118 745 l 241 745 l 241 554 q 239 479 241 513 q 236 418 238 444 q 230 364 233 388 l 319 483 l 526 745 l 665 745 l 394 412 l 684 0 l 545 0 "
  },
  g: {
    x_min: 25,
    x_max: 692.484375,
    ha: 720,
    o: "m 692 745 l 692 668 l 559 649 q 591 588 578 625 q 604 504 604 551 q 588 409 604 453 q 539 333 572 365 q 459 283 507 301 q 348 266 412 266 q 319 266 333 266 q 294 268 304 266 q 271 253 282 261 q 251 233 260 244 q 236 208 242 222 q 230 178 230 194 q 238 148 230 159 q 260 130 246 136 q 293 122 274 124 q 333 120 312 120 l 453 120 q 560 104 516 120 q 631 61 603 88 q 670 -2 658 34 q 683 -80 683 -38 q 660 -186 683 -139 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 96 -278 132 -305 q 42 -213 60 -251 q 25 -128 25 -175 q 38 -57 25 -87 q 73 -4 51 -26 q 125 32 96 17 q 187 53 155 46 q 140 94 158 66 q 122 159 122 122 q 143 231 122 201 q 212 291 165 262 q 158 324 182 303 q 118 373 134 346 q 92 433 101 401 q 83 500 83 466 q 99 608 83 561 q 150 689 116 656 q 233 740 183 722 q 348 758 282 758 q 400 754 373 758 q 445 745 427 750 l 692 745 m 141 -126 q 150 -173 141 -151 q 179 -211 159 -195 q 232 -235 199 -226 q 314 -245 265 -245 q 503 -205 440 -245 q 566 -92 566 -166 q 558 -41 566 -61 q 531 -10 550 -21 q 482 4 512 0 q 407 8 451 8 l 287 8 q 238 3 263 8 q 190 -17 212 -2 q 155 -58 169 -32 q 141 -126 141 -84 m 206 504 q 242 388 206 426 q 344 350 278 350 q 446 388 411 350 q 480 506 480 426 q 445 629 480 590 q 343 669 410 669 q 241 628 277 669 q 206 504 206 587 "
  },
  ǿ: {
    x_min: 78,
    x_max: 727,
    ha: 802,
    o: "m 727 373 q 704 208 727 280 q 639 86 681 135 q 536 11 596 37 q 400 -14 475 -14 q 249 21 315 -14 l 202 -52 l 113 -1 l 168 87 q 101 208 125 135 q 78 373 78 280 q 100 537 78 465 q 165 657 123 608 q 268 732 207 707 q 404 758 329 758 q 485 748 447 758 q 557 719 524 738 l 603 793 l 692 743 l 638 655 q 703 535 680 606 q 727 373 727 464 m 205 373 q 211 271 205 316 q 233 192 218 227 l 503 631 q 457 649 483 643 q 401 655 432 655 q 251 585 297 655 q 205 373 205 515 m 599 373 q 573 548 599 481 l 302 110 q 348 93 323 99 q 403 88 372 88 q 553 159 507 88 q 599 373 599 231 m 321 860 q 351 905 335 879 q 383 958 367 931 q 414 1013 399 986 q 439 1064 428 1040 l 588 1064 l 588 1049 q 555 1004 577 1031 q 508 946 534 976 q 454 889 482 917 q 403 842 426 860 l 321 842 l 321 860 "
  },
  "²": {
    x_min: 33,
    x_max: 421.734375,
    ha: 460,
    o: "m 421 397 l 33 397 l 33 472 l 175 627 q 238 697 214 669 q 277 749 263 726 q 295 791 290 771 q 301 834 301 811 q 278 899 301 878 q 219 920 255 920 q 152 903 184 920 q 90 860 120 886 l 37 924 q 118 981 73 958 q 219 1004 164 1004 q 293 992 260 1004 q 349 960 326 981 q 385 907 372 938 q 398 837 398 876 q 387 774 398 803 q 356 715 376 744 q 307 655 336 686 q 239 587 277 624 l 129 480 l 421 480 l 421 397 "
  },
  Ã: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 523 1072 q 469 1083 496 1072 q 417 1110 443 1095 q 367 1136 391 1124 q 322 1148 343 1148 q 275 1130 291 1148 q 249 1070 259 1112 l 179 1070 q 193 1144 182 1111 q 222 1201 204 1177 q 265 1237 240 1224 q 322 1250 290 1250 q 378 1238 350 1250 q 431 1211 405 1226 q 480 1185 457 1197 q 523 1173 504 1173 q 569 1191 554 1173 q 595 1251 585 1209 l 667 1251 q 652 1177 663 1210 q 623 1121 641 1144 q 580 1084 605 1097 q 523 1072 555 1072 "
  },
  Ј: {
    x_min: -125,
    x_max: 251.15625,
    ha: 376,
    o: "m -19 -264 q -80 -259 -54 -264 q -125 -247 -106 -255 l -125 -139 q -75 -149 -101 -145 q -18 -152 -48 -152 q 32 -146 6 -152 q 78 -122 57 -139 q 112 -76 99 -105 q 125 0 125 -46 l 125 992 l 251 992 l 251 13 q 231 -109 251 -57 q 175 -196 211 -162 q 90 -247 140 -230 q -19 -264 40 -264 "
  },
  "©": {
    x_min: 68,
    x_max: 1088,
    ha: 1156,
    o: "m 604 713 q 531 698 563 713 q 477 655 499 683 q 444 587 455 627 q 433 495 433 546 q 443 402 433 443 q 473 334 453 361 q 526 291 494 306 q 604 277 559 277 q 638 279 620 277 q 676 286 657 281 q 714 295 695 290 q 751 307 734 301 l 751 218 q 718 205 734 211 q 683 194 701 199 q 645 187 665 189 q 600 185 624 185 q 479 207 531 185 q 393 271 428 229 q 342 370 359 312 q 325 497 325 427 q 343 622 325 566 q 397 719 361 679 q 484 783 432 760 q 604 806 536 806 q 692 794 647 806 q 777 763 736 783 l 734 677 q 666 704 699 694 q 604 713 633 713 m 68 495 q 86 631 68 566 q 137 753 104 696 q 217 856 170 809 q 320 936 264 903 q 442 987 377 969 q 578 1006 507 1006 q 713 987 648 1006 q 835 936 778 969 q 938 856 892 903 q 1018 753 985 809 q 1069 631 1051 696 q 1088 495 1088 566 q 1069 359 1088 425 q 1018 238 1051 294 q 938 134 985 181 q 835 55 892 88 q 713 3 778 21 q 578 -14 648 -14 q 442 3 507 -14 q 320 55 377 21 q 217 134 264 88 q 137 238 170 181 q 86 359 104 294 q 68 495 68 425 m 141 496 q 176 326 141 405 q 269 187 210 247 q 408 94 329 128 q 578 59 487 59 q 747 94 668 59 q 886 187 826 128 q 979 326 945 247 q 1014 496 1014 405 q 979 665 1014 586 q 886 804 945 744 q 747 897 826 863 q 578 932 668 932 q 408 897 487 932 q 269 804 329 863 q 176 665 210 744 q 141 496 141 586 "
  },
  "≥": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 69 270 l 569 488 l 69 734 l 69 844 l 696 517 l 696 448 l 69 161 l 69 270 m 69 0 l 69 101 l 696 101 l 696 0 l 69 0 "
  },
  Ă: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 626 1259 q 608 1183 623 1217 q 567 1123 593 1149 q 504 1084 541 1098 q 419 1071 467 1071 q 332 1084 369 1071 q 271 1122 295 1097 q 233 1181 246 1147 q 218 1259 220 1216 l 292 1259 q 304 1212 295 1229 q 330 1186 314 1194 q 369 1175 346 1177 q 422 1172 392 1172 q 468 1175 446 1172 q 508 1188 490 1178 q 537 1214 525 1197 q 551 1259 548 1231 l 626 1259 "
  },
  ґ: {
    x_min: 118,
    x_max: 527,
    ha: 555,
    o: "m 527 656 l 241 656 l 241 0 l 118 0 l 118 745 l 403 745 l 403 961 l 527 961 l 527 656 "
  },
  ÿ: {
    x_min: 6.75,
    x_max: 672.25,
    ha: 679,
    o: "m 6 745 l 134 745 l 280 329 q 300 272 290 301 q 318 212 310 242 q 333 154 327 182 q 341 103 339 126 l 346 103 q 356 149 349 120 q 373 211 364 178 q 392 276 382 244 q 409 330 402 308 l 544 745 l 672 745 l 377 -96 q 336 -195 358 -152 q 285 -270 314 -239 q 217 -317 256 -300 q 123 -334 177 -334 q 62 -330 88 -334 q 18 -322 36 -326 l 18 -223 q 54 -229 32 -226 q 99 -231 75 -231 q 156 -223 132 -231 q 197 -201 179 -216 q 227 -164 215 -186 q 250 -115 240 -142 l 289 -6 l 6 745 m 155 945 q 173 998 155 982 q 220 1015 192 1015 q 266 998 246 1015 q 285 945 285 981 q 266 892 285 909 q 220 876 246 876 q 173 892 192 876 q 155 945 155 909 m 409 945 q 428 998 409 982 q 474 1015 447 1015 q 499 1010 487 1015 q 520 998 511 1006 q 534 977 529 989 q 540 945 540 964 q 520 892 540 909 q 474 876 500 876 q 428 892 447 876 q 409 945 409 909 "
  },
  Ł: {
    x_min: 20,
    x_max: 649.4375,
    ha: 682,
    o: "m 135 458 l 135 992 l 261 992 l 261 537 l 415 635 l 468 550 l 261 420 l 261 111 l 649 111 l 649 0 l 135 0 l 135 341 l 69 301 l 20 385 l 135 458 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 372
  },
  "∫": {
    x_min: 10.578125,
    x_max: 524.65625,
    ha: 538,
    o: "m 435 1055 q 484 1051 458 1055 q 524 1042 509 1048 l 524 944 q 491 956 512 950 q 446 962 471 962 q 389 948 412 962 q 354 913 367 935 q 335 862 340 891 q 330 803 330 834 l 330 -92 q 313 -202 330 -156 q 265 -276 296 -247 q 193 -320 235 -306 q 101 -334 151 -334 q 51 -330 77 -334 q 10 -321 26 -326 l 10 -224 q 45 -235 24 -230 q 89 -241 66 -241 q 147 -228 124 -241 q 185 -194 171 -215 q 205 -143 199 -172 q 212 -82 212 -115 l 212 814 q 227 923 212 878 q 273 998 243 969 q 343 1041 302 1027 q 435 1055 384 1055 "
  },
  "\\": {
    x_min: 15.75,
    x_max: 505.375,
    ha: 518,
    o: "m 136 992 l 505 0 l 384 0 l 15 992 l 136 992 "
  },
  Ì: {
    x_min: 42,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 309 1071 l 227 1071 q 175 1118 203 1089 q 121 1175 147 1146 q 74 1233 95 1205 q 42 1278 52 1260 l 42 1293 l 190 1293 q 216 1242 201 1269 q 246 1187 230 1215 q 278 1134 262 1160 q 309 1089 294 1108 l 309 1071 "
  },
  ъ: {
    x_min: 28,
    x_max: 865,
    ha: 942,
    o: "m 395 439 l 582 439 q 795 386 726 439 q 865 227 865 333 q 849 133 865 175 q 798 61 833 91 q 710 15 764 31 q 580 0 656 0 l 272 0 l 272 642 l 28 642 l 28 745 l 395 745 l 395 439 m 741 219 q 730 275 741 252 q 697 311 719 297 q 643 330 675 325 q 567 336 610 336 l 395 336 l 395 102 l 570 102 q 638 108 607 102 q 693 127 670 113 q 728 164 715 141 q 741 219 741 186 "
  },
  ς: {
    x_min: 77,
    x_max: 596,
    ha: 632,
    o: "m 204 351 q 213 245 204 286 q 248 177 223 204 q 315 135 272 151 q 424 104 358 119 q 504 78 472 94 q 556 42 536 62 q 584 -1 576 22 q 593 -54 593 -25 q 585 -114 593 -84 q 567 -172 578 -144 q 541 -225 555 -200 q 511 -272 526 -250 l 396 -272 q 426 -225 412 -250 q 451 -177 440 -201 q 469 -129 463 -152 q 476 -87 476 -107 q 471 -61 476 -74 q 450 -37 466 -48 q 403 -15 434 -25 q 321 5 373 -4 q 224 37 269 15 q 147 99 180 59 q 95 200 114 139 q 77 349 77 261 q 101 530 77 454 q 170 657 126 607 q 275 733 215 708 q 408 758 336 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 315 630 354 650 q 252 573 276 611 q 216 479 227 535 q 204 351 204 423 "
  },
  Ē: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 199 1172 l 589 1172 l 589 1071 l 199 1071 l 199 1172 "
  },
  "!": {
    x_min: 100,
    x_max: 272.265625,
    ha: 374,
    o: "m 228 280 l 146 280 l 112 992 l 262 992 l 228 280 m 100 74 q 106 118 100 100 q 125 147 113 136 q 152 163 136 158 q 186 169 167 169 q 219 163 203 169 q 247 147 235 158 q 265 118 258 136 q 272 74 272 100 q 265 31 272 49 q 247 2 258 13 q 219 -14 235 -9 q 186 -20 203 -20 q 152 -14 167 -20 q 125 2 136 -9 q 106 31 113 13 q 100 74 100 49 "
  },
  ç: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 m 495 -194 q 447 -297 495 -260 q 297 -334 399 -334 q 267 -331 282 -334 q 242 -327 252 -329 l 242 -254 q 268 -257 252 -256 q 295 -258 285 -258 q 370 -247 343 -258 q 397 -208 397 -235 q 388 -186 397 -195 q 364 -169 379 -176 q 327 -157 349 -162 q 282 -147 306 -152 l 343 0 l 425 0 l 386 -78 q 429 -92 409 -83 q 463 -115 448 -101 q 486 -148 478 -128 q 495 -194 495 -168 "
  },
  Й: {
    x_min: 136,
    x_max: 879,
    ha: 1013,
    o: "m 136 992 l 262 992 l 262 449 q 261 410 262 431 q 260 366 261 389 q 259 321 260 343 q 257 276 258 298 q 251 174 254 226 l 256 174 l 725 992 l 879 992 l 879 0 l 752 0 l 752 538 q 754 624 752 576 q 759 717 756 673 q 765 821 762 768 l 760 821 l 289 0 l 136 0 l 136 992 m 754 1287 q 733 1193 749 1234 q 685 1126 716 1153 q 605 1084 653 1098 q 489 1071 557 1071 q 372 1084 420 1071 q 295 1124 324 1097 q 251 1192 265 1151 q 234 1287 237 1232 l 349 1287 q 361 1219 352 1245 q 388 1178 371 1193 q 430 1158 405 1163 q 492 1152 456 1152 q 547 1159 522 1152 q 590 1181 572 1166 q 620 1222 608 1197 q 635 1287 631 1248 l 754 1287 "
  },
  Б: {
    x_min: 135,
    x_max: 729,
    ha: 800,
    o: "m 729 290 q 708 170 729 224 q 645 79 688 117 q 537 20 602 41 q 380 0 471 0 l 135 0 l 135 992 l 669 992 l 669 880 l 261 880 l 261 574 l 362 574 q 536 551 465 574 q 648 490 606 529 q 710 400 691 452 q 729 290 729 349 m 261 107 l 368 107 q 540 152 485 107 q 595 290 595 197 q 579 370 595 337 q 533 424 564 403 q 456 453 503 444 q 347 462 410 462 l 261 462 l 261 107 "
  },
  đ: {
    x_min: 77,
    x_max: 801.796875,
    ha: 814,
    o: "m 577 99 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 q 244 9 296 -14 q 154 80 192 33 q 97 196 117 127 q 77 356 77 265 q 97 517 77 447 q 154 634 117 587 q 244 705 192 681 q 359 730 296 730 q 432 721 399 730 q 490 698 464 713 q 537 663 516 683 q 572 622 557 643 l 580 622 q 576 666 578 645 q 573 703 575 684 q 572 733 572 722 l 572 843 l 316 843 l 316 932 l 572 932 l 572 1055 l 696 1055 l 696 932 l 801 932 l 801 843 l 696 843 l 696 0 l 596 0 l 577 99 m 383 88 q 470 103 434 88 q 528 148 506 118 q 560 223 550 178 q 572 329 571 268 l 572 356 q 563 472 572 422 q 532 557 554 523 q 473 609 510 592 q 382 627 437 627 q 247 557 290 627 q 204 354 204 487 q 247 154 204 220 q 383 88 290 88 "
  },
  ċ: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 m 317 945 q 337 1004 317 986 q 388 1023 358 1023 q 417 1018 403 1023 q 440 1004 430 1014 q 455 980 449 995 q 461 945 461 966 q 440 887 461 906 q 388 868 418 868 q 337 886 358 868 q 317 945 317 905 "
  },
  Ā: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 227 1172 l 617 1172 l 617 1071 l 227 1071 l 227 1172 "
  },
  Ẃ: {
    x_min: 13.75,
    x_max: 1214.25,
    ha: 1228,
    o: "m 549 992 l 682 992 l 837 411 q 857 335 847 373 q 876 261 867 297 q 891 194 884 225 q 901 136 897 162 q 908 192 904 162 q 917 256 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 992 l 1214 992 l 965 0 l 837 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 622 813 q 600 776 608 814 q 585 707 593 745 q 567 632 576 669 l 402 0 l 275 0 l 13 992 l 147 992 l 298 388 q 313 323 306 357 q 325 257 320 290 q 336 192 331 223 q 344 136 341 162 q 352 194 347 161 q 364 264 358 227 q 379 338 371 301 q 396 409 387 376 l 549 992 m 549 1089 q 579 1134 563 1108 q 611 1187 595 1160 q 642 1242 627 1215 q 667 1293 656 1269 l 816 1293 l 816 1278 q 783 1233 805 1260 q 736 1175 762 1205 q 682 1118 710 1146 q 631 1071 654 1089 l 549 1071 l 549 1089 "
  },
  ø: {
    x_min: 78,
    x_max: 727,
    ha: 802,
    o: "m 727 373 q 704 208 727 280 q 639 86 681 135 q 536 11 596 37 q 400 -14 475 -14 q 249 21 315 -14 l 202 -52 l 113 -1 l 168 87 q 101 208 125 135 q 78 373 78 280 q 100 537 78 465 q 165 657 123 608 q 268 732 207 707 q 404 758 329 758 q 485 748 447 758 q 557 719 524 738 l 603 793 l 692 743 l 638 655 q 703 535 680 606 q 727 373 727 464 m 205 373 q 211 271 205 316 q 233 192 218 227 l 503 631 q 457 649 483 643 q 401 655 432 655 q 251 585 297 655 q 205 373 205 515 m 599 373 q 573 548 599 481 l 302 110 q 348 93 323 99 q 403 88 372 88 q 553 159 507 88 q 599 373 599 231 "
  },
  â: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 605 842 l 523 842 q 451 897 488 864 q 380 967 415 930 q 307 897 343 930 q 237 842 271 864 l 155 842 l 155 860 q 195 905 172 879 q 241 958 218 931 q 284 1013 264 986 q 314 1064 304 1040 l 445 1064 q 475 1013 455 1040 q 518 958 495 986 q 564 905 541 931 q 605 860 588 879 l 605 842 "
  },
  "}": {
    x_min: 36,
    x_max: 451,
    ha: 492,
    o: "m 153 214 q 193 328 153 286 q 311 383 233 369 l 311 391 q 193 446 233 405 q 153 559 153 488 l 153 783 q 145 836 153 815 q 122 868 137 857 q 84 885 106 880 q 36 890 63 889 l 36 992 q 132 980 87 991 q 208 944 176 968 q 258 883 240 920 q 277 793 277 846 l 277 567 q 288 507 277 531 q 321 467 299 483 q 376 445 343 452 q 451 439 408 439 l 451 337 q 321 307 366 337 q 277 208 277 278 l 277 -19 q 258 -110 277 -73 q 208 -172 240 -148 q 132 -208 176 -196 q 36 -220 87 -219 l 36 -118 q 84 -113 63 -117 q 122 -96 106 -108 q 145 -64 137 -84 q 153 -10 153 -43 l 153 214 "
  },
  Δ: {
    x_min: 25,
    x_max: 765,
    ha: 789,
    o: "m 765 84 l 765 0 l 25 0 l 25 90 l 330 992 l 457 992 l 765 84 m 393 852 q 367 745 381 802 q 333 626 352 688 l 158 111 l 631 111 l 457 622 q 419 745 435 688 q 393 852 403 802 "
  },
  "‰": {
    x_min: 69,
    x_max: 1555,
    ha: 1624,
    o: "m 169 695 q 193 527 169 583 q 271 471 217 471 q 377 695 377 471 q 271 917 377 917 q 193 862 217 917 q 169 695 169 807 m 478 695 q 465 564 478 622 q 428 465 453 505 q 364 404 403 425 q 271 383 325 383 q 184 404 222 383 q 120 465 146 425 q 81 564 94 505 q 69 695 69 622 q 80 826 69 769 q 117 924 92 884 q 180 984 142 963 q 271 1006 218 1006 q 360 984 322 1006 q 425 924 399 963 q 464 826 451 884 q 478 695 478 769 m 769 297 q 793 129 769 185 q 871 74 817 74 q 976 297 976 74 q 871 519 976 519 q 793 464 817 519 q 769 297 769 409 m 1077 298 q 1065 166 1077 224 q 1028 68 1053 108 q 964 7 1003 28 q 871 -14 925 -14 q 783 7 821 -14 q 720 68 745 28 q 681 166 694 108 q 669 298 669 224 q 680 428 669 371 q 717 526 692 486 q 780 586 742 565 q 871 608 818 608 q 960 586 922 608 q 1024 526 999 565 q 1063 428 1050 486 q 1077 298 1077 371 m 903 992 l 352 0 l 245 0 l 796 992 l 903 992 m 1247 297 q 1271 129 1247 185 q 1349 74 1295 74 q 1454 297 1454 74 q 1349 519 1454 519 q 1271 464 1295 519 q 1247 297 1247 409 m 1555 298 q 1543 166 1555 224 q 1506 68 1531 108 q 1442 7 1481 28 q 1349 -14 1403 -14 q 1261 7 1299 -14 q 1198 68 1223 28 q 1159 166 1172 108 q 1147 298 1147 224 q 1158 428 1147 371 q 1195 526 1170 486 q 1258 586 1220 565 q 1349 608 1296 608 q 1438 586 1399 608 q 1502 526 1477 565 q 1541 428 1528 486 q 1555 298 1555 371 "
  },
  Ä: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 m 230 1174 q 248 1227 230 1211 q 295 1244 267 1244 q 341 1227 321 1244 q 360 1174 360 1210 q 341 1121 360 1138 q 295 1105 321 1105 q 248 1121 267 1105 q 230 1174 230 1138 m 484 1174 q 503 1227 484 1211 q 549 1244 522 1244 q 574 1239 562 1244 q 595 1227 586 1235 q 609 1206 604 1218 q 615 1174 615 1193 q 595 1121 615 1138 q 549 1105 575 1105 q 503 1121 522 1105 q 484 1174 484 1138 "
  },
  ř: {
    x_min: 78,
    x_max: 528,
    ha: 554,
    o: "m 439 758 q 483 756 459 758 q 526 751 508 754 l 509 637 q 470 643 490 640 q 433 645 450 645 q 355 628 390 645 q 294 578 320 610 q 255 501 269 546 q 241 401 241 456 l 241 0 l 118 0 l 118 745 l 218 745 l 233 608 l 238 608 q 274 664 255 637 q 318 712 294 691 q 372 745 342 732 q 439 758 402 758 m 528 1045 q 487 1000 511 1026 q 441 947 464 974 q 398 892 418 919 q 368 842 378 865 l 237 842 q 207 892 227 865 q 164 947 187 919 q 118 1000 141 974 q 78 1045 95 1026 l 78 1064 l 160 1064 q 230 1008 194 1041 q 303 937 266 975 q 374 1008 338 975 q 446 1064 411 1041 l 528 1064 l 528 1045 "
  },
  "—": {
    x_min: 56,
    x_max: 1333,
    ha: 1389,
    o: "m 56 315 l 56 429 l 1333 429 l 1333 315 l 56 315 "
  },
  N: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 "
  },
  "⁄": {
    x_min: -239.25,
    x_max: 418.25,
    ha: 180,
    o: "m 418 992 l -132 0 l -239 0 l 311 992 l 418 992 "
  },
  М: {
    x_min: 135,
    x_max: 1074,
    ha: 1209,
    o: "m 544 0 l 253 868 l 248 868 q 255 768 252 818 q 259 678 257 726 q 261 593 261 631 l 261 0 l 135 0 l 135 992 l 331 992 l 601 183 l 605 183 l 886 992 l 1074 992 l 1074 0 l 947 0 l 947 601 q 949 682 947 637 q 952 769 950 728 q 957 867 955 817 l 951 867 l 648 0 l 544 0 "
  },
  Ó: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 441 1089 q 471 1134 455 1108 q 503 1187 487 1160 q 534 1242 519 1215 q 559 1293 548 1269 l 708 1293 l 708 1278 q 675 1233 697 1260 q 628 1175 654 1205 q 574 1118 602 1146 q 523 1071 546 1089 l 441 1071 l 441 1089 "
  },
  "˜": {
    x_min: 175,
    x_max: 663,
    ha: 802,
    o: "m 519 843 q 465 854 492 843 q 413 881 439 866 q 363 907 387 895 q 318 919 339 919 q 271 901 287 919 q 245 841 255 883 l 175 841 q 189 915 178 882 q 218 972 200 948 q 261 1008 236 995 q 318 1021 286 1021 q 374 1009 346 1021 q 427 982 401 997 q 476 956 453 968 q 519 944 500 944 q 565 962 550 944 q 591 1022 581 980 l 663 1022 q 648 948 659 981 q 619 892 637 915 q 576 855 601 868 q 519 843 551 843 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 695
  },
  "ˇ": {
    x_min: 175,
    x_max: 625,
    ha: 802,
    o: "m 625 1045 q 584 1000 608 1026 q 538 947 561 974 q 495 892 515 919 q 465 842 475 865 l 334 842 q 304 892 324 865 q 261 947 284 919 q 215 1000 238 974 q 175 1045 192 1026 l 175 1064 l 257 1064 q 327 1008 291 1041 q 400 937 363 975 q 471 1008 435 975 q 543 1064 508 1041 l 625 1064 l 625 1045 "
  },
  ų: {
    x_min: 111,
    x_max: 710,
    ha: 818,
    o: "m 600 0 l 582 99 l 575 99 q 534 48 558 70 q 483 13 511 27 q 424 -7 455 0 q 360 -14 393 -14 q 252 1 299 -14 q 174 50 205 17 q 126 135 142 83 q 111 258 111 186 l 111 745 l 234 745 l 234 264 q 270 132 234 176 q 381 88 306 88 q 474 106 436 88 q 534 158 511 123 q 566 242 556 192 q 576 357 576 292 l 576 745 l 700 745 l 700 0 l 600 0 m 591 -161 q 609 -206 591 -191 q 651 -220 627 -220 q 684 -218 668 -220 q 710 -214 700 -217 l 710 -291 q 670 -299 692 -296 q 629 -302 649 -302 q 527 -266 561 -302 q 494 -170 494 -231 q 503 -116 494 -142 q 529 -69 513 -91 q 562 -30 544 -48 q 598 0 581 -12 l 685 0 q 591 -161 591 -90 "
  },
  Ў: {
    x_min: 16.75,
    x_max: 813.25,
    ha: 813,
    o: "m 813 992 l 522 289 q 468 172 496 227 q 402 75 440 116 q 311 10 364 34 q 183 -14 258 -14 q 117 -8 148 -14 q 62 6 87 -3 l 62 131 q 117 106 87 116 q 183 97 147 97 q 246 105 219 97 q 297 130 274 112 q 338 178 319 149 q 376 250 357 207 l 16 992 l 155 992 l 415 440 q 422 425 418 433 q 428 408 425 417 q 434 391 431 399 q 440 377 437 383 l 441 377 q 447 394 443 383 q 455 416 451 404 q 462 437 458 427 q 468 451 466 447 l 679 992 l 813 992 m 684 1287 q 663 1193 679 1234 q 615 1126 646 1153 q 535 1084 583 1098 q 419 1071 487 1071 q 302 1084 350 1071 q 225 1124 254 1097 q 181 1192 195 1151 q 164 1287 167 1232 l 279 1287 q 291 1219 282 1245 q 318 1178 301 1193 q 360 1158 335 1163 q 422 1152 386 1152 q 477 1159 452 1152 q 520 1181 502 1166 q 550 1222 538 1197 q 565 1287 561 1248 l 684 1287 "
  },
  Ŭ: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 689 1259 q 671 1183 686 1217 q 630 1123 656 1149 q 567 1084 604 1098 q 482 1071 530 1071 q 395 1084 432 1071 q 334 1122 358 1097 q 296 1181 309 1147 q 281 1259 283 1216 l 355 1259 q 367 1212 358 1229 q 393 1186 377 1194 q 432 1175 409 1177 q 485 1172 455 1172 q 531 1175 509 1172 q 571 1188 553 1178 q 600 1214 588 1197 q 614 1259 611 1231 l 689 1259 "
  },
  ĝ: {
    x_min: 25,
    x_max: 692.484375,
    ha: 720,
    o: "m 692 745 l 692 668 l 559 649 q 591 588 578 625 q 604 504 604 551 q 588 409 604 453 q 539 333 572 365 q 459 283 507 301 q 348 266 412 266 q 319 266 333 266 q 294 268 304 266 q 271 253 282 261 q 251 233 260 244 q 236 208 242 222 q 230 178 230 194 q 238 148 230 159 q 260 130 246 136 q 293 122 274 124 q 333 120 312 120 l 453 120 q 560 104 516 120 q 631 61 603 88 q 670 -2 658 34 q 683 -80 683 -38 q 660 -186 683 -139 q 593 -266 638 -233 q 478 -316 547 -298 q 314 -334 408 -334 q 187 -319 241 -334 q 96 -278 132 -305 q 42 -213 60 -251 q 25 -128 25 -175 q 38 -57 25 -87 q 73 -4 51 -26 q 125 32 96 17 q 187 53 155 46 q 140 94 158 66 q 122 159 122 122 q 143 231 122 201 q 212 291 165 262 q 158 324 182 303 q 118 373 134 346 q 92 433 101 401 q 83 500 83 466 q 99 608 83 561 q 150 689 116 656 q 233 740 183 722 q 348 758 282 758 q 400 754 373 758 q 445 745 427 750 l 692 745 m 141 -126 q 150 -173 141 -151 q 179 -211 159 -195 q 232 -235 199 -226 q 314 -245 265 -245 q 503 -205 440 -245 q 566 -92 566 -166 q 558 -41 566 -61 q 531 -10 550 -21 q 482 4 512 0 q 407 8 451 8 l 287 8 q 238 3 263 8 q 190 -17 212 -2 q 155 -58 169 -32 q 141 -126 141 -84 m 206 504 q 242 388 206 426 q 344 350 278 350 q 446 388 411 350 q 480 506 480 426 q 445 629 480 590 q 343 669 410 669 q 241 628 277 669 q 206 504 206 587 m 586 842 l 504 842 q 432 897 469 864 q 361 967 396 930 q 288 897 324 930 q 218 842 252 864 l 136 842 l 136 860 q 176 905 153 879 q 222 958 199 931 q 265 1013 245 986 q 295 1064 285 1040 l 426 1064 q 456 1013 436 1040 q 499 958 476 986 q 545 905 522 931 q 586 860 569 879 l 586 842 "
  },
  Ω: {
    x_min: 53.0625,
    x_max: 980.9375,
    ha: 1031,
    o: "m 517 895 q 384 872 439 895 q 292 805 328 849 q 239 699 256 762 q 222 556 222 636 q 234 425 222 488 q 273 304 246 362 q 345 194 301 246 q 455 99 390 143 l 455 0 l 53 0 l 53 111 l 321 111 q 229 189 271 143 q 155 292 186 235 q 106 416 124 349 q 89 559 89 484 q 116 743 89 661 q 198 884 143 826 q 332 975 252 943 q 517 1007 412 1007 q 701 975 622 1007 q 835 884 781 943 q 917 743 890 826 q 945 559 945 661 q 927 416 945 484 q 878 292 909 349 q 805 189 847 235 q 712 111 762 143 l 980 111 l 980 0 l 579 0 l 579 99 q 688 194 643 143 q 760 304 732 246 q 799 425 787 362 q 811 556 811 488 q 794 699 811 636 q 741 805 777 762 q 649 872 705 849 q 517 895 594 895 "
  },
  s: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 "
  },
  "?": {
    x_min: 25,
    x_max: 546,
    ha: 591,
    o: "m 191 280 l 191 305 q 196 375 191 343 q 214 433 201 406 q 250 486 227 460 q 306 541 272 512 q 362 592 339 569 q 400 638 385 614 q 422 688 415 661 q 429 751 429 715 q 419 811 429 784 q 389 857 408 838 q 341 887 370 876 q 274 898 312 898 q 166 880 217 898 q 67 839 115 862 l 25 937 q 143 985 79 965 q 273 1006 207 1006 q 386 988 336 1006 q 472 938 437 971 q 527 858 508 906 q 546 752 546 811 q 537 671 546 707 q 512 605 529 635 q 471 546 495 574 q 412 485 446 517 q 360 432 380 455 q 328 388 339 409 q 311 344 316 366 q 307 292 307 322 l 307 280 l 191 280 m 158 74 q 164 118 158 100 q 183 147 171 136 q 210 163 194 158 q 244 169 225 169 q 277 163 261 169 q 305 147 293 158 q 323 118 316 136 q 330 74 330 100 q 323 31 330 49 q 305 2 316 13 q 277 -14 293 -9 q 244 -20 261 -20 q 210 -14 225 -20 q 183 2 194 -9 q 164 31 171 13 q 158 74 158 49 "
  },
  Ņ: {
    x_min: 135,
    x_max: 878,
    ha: 1013,
    o: "m 878 0 l 724 0 l 253 821 l 248 821 q 255 717 252 768 q 259 624 257 673 q 261 538 261 576 l 261 0 l 135 0 l 135 992 l 288 992 l 757 174 l 762 174 q 757 276 759 226 q 755 321 756 298 q 753 366 754 343 q 752 410 752 389 q 751 449 751 431 l 751 992 l 878 992 l 878 0 m 396 -288 q 412 -246 403 -271 q 429 -191 421 -220 q 443 -135 437 -163 q 452 -85 450 -107 l 575 -85 l 575 -98 q 560 -141 570 -115 q 534 -197 549 -167 q 500 -255 519 -226 q 462 -307 482 -284 l 396 -307 l 396 -288 "
  },
  Ī: {
    x_min: 41,
    x_max: 431,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 41 1172 l 431 1172 l 431 1071 l 41 1071 l 41 1172 "
  },
  Μ: {
    x_min: 135,
    x_max: 1074,
    ha: 1209,
    o: "m 544 0 l 253 868 l 248 868 q 255 768 252 818 q 259 678 257 726 q 261 593 261 631 l 261 0 l 135 0 l 135 992 l 331 992 l 601 183 l 605 183 l 886 992 l 1074 992 l 1074 0 l 947 0 l 947 601 q 949 682 947 637 q 952 769 950 728 q 957 867 955 817 l 951 867 l 648 0 l 544 0 "
  },
  "•": {
    x_min: 102,
    x_max: 421,
    ha: 522,
    o: "m 102 507 q 114 589 102 555 q 147 644 126 623 q 198 675 169 666 q 261 685 227 685 q 323 675 294 685 q 374 644 352 666 q 408 589 395 623 q 421 507 421 555 q 408 425 421 459 q 374 370 395 392 q 323 339 352 349 q 261 329 294 329 q 198 339 227 329 q 147 370 169 349 q 114 425 126 392 q 102 507 102 459 "
  },
  н: {
    x_min: 118,
    x_max: 735,
    ha: 853,
    o: "m 241 745 l 241 436 l 611 436 l 611 745 l 735 745 l 735 0 l 611 0 l 611 333 l 241 333 l 241 0 l 118 0 l 118 745 l 241 745 "
  },
  "(": {
    x_min: 56,
    x_max: 376.34375,
    ha: 418,
    o: "m 56 380 q 68 547 56 465 q 105 708 80 630 q 168 857 130 785 q 259 992 207 928 l 376 992 q 232 704 281 861 q 183 381 183 547 q 196 221 183 301 q 232 64 208 141 q 292 -84 256 -12 q 375 -220 328 -156 l 259 -220 q 168 -89 207 -158 q 105 57 130 -19 q 68 214 80 133 q 56 380 56 296 "
  },
  "◊": {
    x_min: 74,
    x_max: 737,
    ha: 810,
    o: "m 737 499 l 430 0 l 379 0 l 74 498 l 379 1000 l 430 1000 l 737 499 m 618 499 l 405 898 l 175 499 l 405 101 l 618 499 "
  },
  α: {
    x_min: 77,
    x_max: 792.984375,
    ha: 814,
    o: "m 383 88 q 470 104 434 88 q 528 153 506 120 q 560 238 550 186 q 572 360 571 289 l 572 370 q 563 492 572 439 q 532 581 554 545 q 473 636 510 618 q 382 655 437 655 q 247 581 290 655 q 204 369 204 507 q 247 157 204 227 q 383 88 290 88 m 359 -14 q 244 10 296 -14 q 154 83 192 34 q 97 203 117 131 q 77 370 77 275 q 97 538 77 466 q 156 659 118 610 q 249 733 194 708 q 372 758 304 758 q 497 729 448 758 q 579 644 546 701 l 587 644 q 605 695 594 667 q 633 745 616 723 l 730 745 q 716 687 723 722 q 705 610 710 651 q 698 527 701 569 q 696 446 696 484 l 696 162 q 712 104 696 121 q 752 87 729 87 q 775 89 762 87 q 792 93 787 91 l 792 3 q 760 -8 782 -2 q 715 -14 738 -14 q 668 -8 689 -14 q 630 10 647 -3 q 601 45 613 23 q 580 99 588 66 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 "
  },
  Ħ: {
    x_min: 0.03125,
    x_max: 973.953125,
    ha: 974,
    o: "m 135 827 l 135 992 l 261 992 l 261 827 l 712 827 l 712 992 l 839 992 l 839 827 l 973 827 l 973 719 l 839 719 l 839 0 l 712 0 l 712 462 l 261 462 l 261 0 l 135 0 l 135 719 l 0 719 l 0 827 l 135 827 m 712 574 l 712 719 l 261 719 l 261 574 l 712 574 "
  },
  м: {
    x_min: 118,
    x_max: 879,
    ha: 997,
    o: "m 879 0 l 762 0 l 762 608 q 752 575 758 594 q 740 535 747 555 q 728 497 733 515 q 717 466 722 479 l 543 0 l 453 0 l 278 466 q 269 492 275 475 q 257 528 264 508 q 245 569 251 548 q 234 608 239 591 l 234 0 l 118 0 l 118 745 l 274 745 l 450 272 q 465 226 458 248 q 479 183 473 203 q 490 145 485 162 q 498 118 495 128 q 506 146 502 129 q 517 182 511 162 q 531 224 523 202 q 546 269 538 246 l 724 745 l 879 745 l 879 0 "
  },
  з: {
    x_min: 45.859375,
    x_max: 577,
    ha: 639,
    o: "m 250 439 q 326 445 292 439 q 385 464 360 451 q 423 499 409 477 q 436 551 436 520 q 397 629 436 603 q 284 655 357 655 q 192 642 235 655 q 96 606 148 629 l 54 706 q 107 729 81 720 q 161 745 133 739 q 219 754 189 751 q 286 758 250 758 q 393 745 344 758 q 477 707 442 732 q 533 645 513 682 q 553 561 553 608 q 543 501 553 527 q 516 455 533 475 q 475 421 499 435 q 422 398 451 407 l 422 390 q 480 366 452 381 q 529 328 508 351 q 564 275 551 306 q 577 202 577 245 q 559 117 577 157 q 504 48 541 77 q 411 2 467 19 q 278 -14 354 -14 q 144 -1 204 -14 q 45 33 85 10 l 45 146 q 92 125 66 135 q 147 106 118 114 q 209 93 176 98 q 276 88 242 88 q 346 94 313 88 q 402 114 378 100 q 439 152 425 129 q 453 210 453 176 q 408 305 453 274 q 270 336 363 336 l 184 336 l 184 439 l 250 439 "
  },
  Ґ: {
    x_min: 135,
    x_max: 649,
    ha: 682,
    o: "m 522 992 l 522 1196 l 649 1196 l 649 880 l 261 880 l 261 0 l 135 0 l 135 992 l 522 992 "
  },
  Û: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 708 1071 l 626 1071 q 554 1126 591 1093 q 483 1196 518 1159 q 410 1126 446 1159 q 340 1071 374 1093 l 258 1071 l 258 1089 q 298 1134 275 1108 q 344 1187 321 1160 q 387 1242 367 1215 q 417 1293 407 1269 l 548 1293 q 578 1242 558 1269 q 621 1187 598 1215 q 667 1134 644 1160 q 708 1089 691 1108 l 708 1071 "
  },
  і: {
    x_min: 108.5,
    x_max: 252.96875,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 "
  },
  V: {
    x_min: -0.25,
    x_max: 789.25,
    ha: 789,
    o: "m 654 992 l 789 992 l 457 0 l 330 0 l 0 992 l 133 992 l 333 362 q 367 243 353 301 q 393 136 381 186 q 419 243 403 186 q 455 367 434 301 l 654 992 "
  },
  Ŗ: {
    x_min: 135,
    x_max: 803.25,
    ha: 819,
    o: "m 261 410 l 261 0 l 135 0 l 135 992 l 376 992 q 642 922 556 992 q 729 710 729 852 q 712 607 729 651 q 668 531 695 563 q 605 479 640 500 q 533 444 570 458 l 803 0 l 654 0 l 416 410 l 261 410 m 261 517 l 371 517 q 473 529 431 517 q 543 564 516 541 q 582 623 570 588 q 595 704 595 658 q 581 787 595 753 q 540 842 567 821 q 469 874 512 864 q 368 884 426 884 l 261 884 l 261 517 m 330 -288 q 346 -246 337 -271 q 363 -191 355 -220 q 377 -135 371 -163 q 386 -85 384 -107 l 509 -85 l 509 -98 q 494 -141 504 -115 q 468 -197 483 -167 q 434 -255 453 -226 q 396 -307 416 -284 l 330 -307 l 330 -288 "
  },
  "@": {
    x_min: 74,
    x_max: 1129,
    ha: 1203,
    o: "m 1129 496 q 1122 411 1129 453 q 1103 330 1116 369 q 1071 259 1091 292 q 1026 202 1052 226 q 967 163 1000 177 q 895 150 934 150 q 840 160 865 150 q 797 187 815 170 q 769 226 780 204 q 753 272 757 248 l 751 272 q 720 224 738 246 q 678 185 702 202 q 623 159 654 168 q 557 150 593 150 q 465 169 505 150 q 396 222 424 188 q 354 304 369 256 q 340 411 340 353 q 360 536 340 479 q 417 635 380 594 q 509 699 455 676 q 629 723 562 723 q 690 720 659 723 q 748 712 720 717 q 799 702 776 708 q 838 691 823 696 l 823 408 q 822 384 822 393 q 822 369 822 375 q 822 361 822 364 q 822 357 822 359 q 829 297 822 321 q 847 261 836 274 q 873 242 859 247 q 903 237 888 237 q 958 258 935 237 q 998 314 982 278 q 1022 396 1014 349 q 1030 497 1030 444 q 1001 668 1030 593 q 920 795 972 743 q 798 873 869 846 q 644 900 727 900 q 442 862 529 900 q 295 757 354 825 q 205 597 236 690 q 175 395 175 505 q 201 213 175 292 q 280 79 228 134 q 409 -2 332 25 q 585 -30 486 -30 q 667 -25 627 -30 q 745 -12 707 -20 q 816 6 783 -4 q 880 28 850 16 l 880 -67 q 748 -108 821 -93 q 587 -123 675 -123 q 370 -88 465 -123 q 209 12 275 -53 q 108 173 143 78 q 74 390 74 269 q 114 628 74 517 q 228 819 154 738 q 407 945 302 899 q 644 992 513 992 q 838 957 749 992 q 992 859 927 923 q 1093 703 1057 795 q 1129 496 1129 611 m 448 408 q 482 277 448 318 q 574 237 517 237 q 638 252 612 237 q 682 296 665 268 q 708 363 699 324 q 719 449 716 402 l 729 621 q 683 631 710 626 q 629 635 657 635 q 544 615 578 635 q 488 564 510 596 q 458 491 467 532 q 448 408 448 450 "
  },
  ʼ: {
    x_min: 16,
    x_max: 228,
    ha: 243,
    o: "m 219 992 l 228 977 q 205 898 218 939 q 176 815 192 857 q 143 731 160 772 q 108 652 125 690 l 16 652 q 38 737 26 692 q 60 827 49 782 q 79 913 70 871 q 94 992 88 956 l 219 992 "
  },
  "℅": {
    x_min: 96,
    x_max: 1016,
    ha: 1112,
    o: "m 874 992 l 325 0 l 218 0 l 767 992 l 874 992 m 1016 227 q 1000 127 1016 170 q 958 55 985 84 q 893 10 931 25 q 809 -5 855 -5 q 729 10 766 -5 q 664 55 691 25 q 620 127 636 84 q 605 227 605 170 q 619 326 605 283 q 661 398 634 369 q 727 443 689 428 q 811 459 765 459 q 891 443 853 459 q 956 398 928 428 q 1000 326 984 369 q 1016 227 1016 283 m 705 228 q 711 164 705 193 q 729 114 716 135 q 762 82 742 93 q 811 70 782 70 q 859 82 839 70 q 891 114 879 93 q 909 164 904 135 q 915 228 915 193 q 909 291 915 263 q 891 340 904 320 q 859 372 879 361 q 811 383 839 383 q 762 372 782 383 q 729 340 742 361 q 711 291 716 320 q 705 228 705 263 m 320 534 q 233 546 274 534 q 161 587 192 559 q 113 658 131 615 q 96 763 96 702 q 113 872 96 827 q 163 945 131 917 q 236 986 194 973 q 327 999 278 999 q 395 991 362 999 q 451 973 429 984 l 429 901 q 380 916 408 910 q 328 923 351 923 q 228 884 259 923 q 196 764 196 844 q 326 609 196 609 q 390 615 360 609 q 444 631 420 620 l 444 559 q 386 540 420 546 q 320 534 353 534 "
  },
  i: {
    x_min: 108.5,
    x_max: 252.96875,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 108 945 q 129 1004 108 986 q 180 1023 149 1023 q 208 1018 195 1023 q 231 1004 221 1014 q 247 980 241 995 q 252 945 252 966 q 231 887 252 906 q 180 868 210 868 q 129 886 149 868 q 108 945 108 905 "
  },
  ќ: {
    x_min: 118,
    x_max: 676.25,
    ha: 682,
    o: "m 516 745 l 649 745 l 369 387 l 676 0 l 536 0 l 241 377 l 241 0 l 118 0 l 118 745 l 241 745 l 241 383 l 516 745 m 272 860 q 302 905 286 879 q 334 958 318 931 q 365 1013 350 986 q 390 1064 379 1040 l 539 1064 l 539 1049 q 506 1004 528 1031 q 459 946 485 976 q 405 889 433 917 q 354 842 377 860 l 272 842 l 272 860 "
  },
  "≤": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 696 161 l 69 448 l 69 517 l 696 844 l 696 735 l 197 488 l 696 270 l 696 161 m 69 0 l 69 101 l 696 101 l 696 0 l 69 0 "
  },
  ё: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 183 945 q 201 998 183 982 q 248 1015 220 1015 q 294 998 274 1015 q 313 945 313 981 q 294 892 313 909 q 248 876 274 876 q 201 892 220 876 q 183 945 183 909 m 437 945 q 456 998 437 982 q 502 1015 475 1015 q 527 1010 515 1015 q 548 998 539 1006 q 562 977 557 989 q 568 945 568 964 q 548 892 568 909 q 502 876 528 876 q 456 892 475 876 q 437 945 437 909 "
  },
  υ: {
    x_min: 111,
    x_max: 736,
    ha: 819,
    o: "m 409 -14 q 264 13 322 -14 q 172 87 206 40 q 124 199 138 135 q 111 337 111 263 l 111 745 l 234 745 l 234 345 q 245 239 234 286 q 278 158 256 192 q 335 106 300 125 q 417 88 370 88 q 564 167 516 88 q 612 412 612 245 q 609 503 612 461 q 601 585 606 545 q 587 664 595 625 q 569 745 580 703 l 693 745 q 711 664 703 703 q 725 585 719 626 q 733 501 730 545 q 736 406 736 457 q 653 88 736 190 q 409 -14 570 -14 "
  },
  ĕ: {
    x_min: 77,
    x_max: 673,
    ha: 743,
    o: "m 412 -14 q 276 11 337 -14 q 170 84 214 36 q 101 203 125 132 q 77 366 77 274 q 99 531 77 458 q 162 654 121 604 q 259 731 202 705 q 384 758 316 758 q 505 733 451 758 q 595 665 558 709 q 653 560 633 621 q 673 423 673 498 l 673 346 l 204 346 q 259 155 207 216 q 413 93 311 93 q 477 97 448 93 q 534 107 507 100 q 587 123 561 113 q 639 145 613 133 l 639 35 q 586 13 612 22 q 533 -2 560 3 q 476 -11 505 -8 q 412 -14 446 -14 m 384 655 q 260 602 306 655 q 207 449 214 549 l 545 449 q 536 533 545 495 q 507 598 526 571 q 457 640 487 625 q 384 655 427 655 m 589 1030 q 571 954 586 988 q 530 894 556 920 q 467 855 504 869 q 382 842 430 842 q 295 855 332 842 q 234 893 258 868 q 196 952 209 918 q 181 1030 183 987 l 255 1030 q 267 983 258 1000 q 293 957 277 965 q 332 946 309 948 q 385 943 355 943 q 431 946 409 943 q 471 959 453 949 q 500 985 488 968 q 514 1030 511 1002 l 589 1030 "
  },
  ﬃ: {
    x_min: 19,
    x_max: 1166.96875,
    ha: 1274,
    o: "m 441 656 l 274 656 l 274 0 l 151 0 l 151 656 l 19 656 l 19 704 l 151 749 l 151 814 q 166 934 151 886 q 210 1010 181 982 q 280 1051 238 1039 q 375 1063 322 1063 q 449 1055 415 1063 q 509 1037 482 1047 l 477 941 q 431 954 456 949 q 379 960 406 960 q 332 954 352 960 q 300 931 313 947 q 280 887 287 915 q 274 815 274 859 l 274 745 l 441 745 l 441 656 m 898 656 l 731 656 l 731 0 l 608 0 l 608 656 l 476 656 l 476 704 l 608 749 l 608 814 q 623 934 608 886 q 667 1010 638 982 q 737 1051 695 1039 q 832 1063 779 1063 q 906 1055 872 1063 q 966 1037 939 1047 l 934 941 q 888 954 913 949 q 836 960 863 960 q 789 954 809 960 q 757 931 770 947 q 737 887 744 915 q 731 815 731 859 l 731 745 l 898 745 l 898 656 m 1155 0 l 1032 0 l 1032 745 l 1155 745 l 1155 0 m 1022 945 q 1043 1004 1022 986 q 1094 1023 1063 1023 q 1122 1018 1109 1023 q 1145 1004 1135 1014 q 1161 980 1155 995 q 1166 945 1166 966 q 1145 887 1166 906 q 1094 868 1124 868 q 1043 886 1063 868 q 1022 945 1022 905 "
  },
  ż: {
    x_min: 56,
    x_max: 556.21875,
    ha: 612,
    o: "m 556 0 l 56 0 l 56 80 l 418 656 l 78 656 l 78 745 l 544 745 l 544 650 l 189 88 l 556 88 l 556 0 m 248 945 q 268 1004 248 986 q 319 1023 289 1023 q 348 1018 334 1023 q 371 1004 361 1014 q 386 980 380 995 q 392 945 392 966 q 371 887 392 906 q 319 868 349 868 q 268 886 289 868 q 248 945 248 905 "
  },
  Э: {
    x_min: 40,
    x_max: 740,
    ha: 825,
    o: "m 301 894 q 186 879 237 894 q 93 841 136 863 l 40 947 q 159 991 93 976 q 299 1006 226 1006 q 491 969 409 1006 q 629 866 574 932 q 712 710 684 801 q 740 513 740 620 q 712 294 740 392 q 628 128 684 197 q 489 22 572 59 q 294 -14 405 -14 q 222 -11 255 -14 q 160 -4 189 -9 q 104 8 131 0 q 52 26 78 15 l 52 135 q 159 108 105 120 q 274 97 214 97 q 520 191 436 97 q 609 462 605 285 l 179 462 l 179 574 l 606 574 q 576 708 600 649 q 512 809 551 768 q 419 873 473 851 q 301 894 366 894 "
  },
  ő: {
    x_min: 77,
    x_max: 725,
    ha: 802,
    o: "m 725 373 q 702 208 725 280 q 637 86 679 135 q 534 11 594 37 q 398 -14 474 -14 q 270 11 329 -14 q 168 86 211 37 q 101 208 125 135 q 77 373 77 280 q 99 537 77 465 q 164 657 122 608 q 267 732 206 707 q 403 758 327 758 q 531 732 472 758 q 633 657 590 707 q 700 537 676 608 q 725 373 725 465 m 204 373 q 250 159 204 231 q 401 88 297 88 q 551 159 506 88 q 597 373 597 231 q 551 585 597 515 q 400 655 504 655 q 250 585 295 655 q 204 373 204 515 m 199 860 q 229 905 213 879 q 261 958 245 931 q 291 1013 277 986 q 317 1064 306 1040 l 452 1064 l 452 1049 q 419 1004 441 1031 q 372 946 398 976 q 318 889 346 917 q 267 842 291 860 l 199 842 l 199 860 m 445 860 q 475 905 459 879 q 507 958 491 931 q 537 1013 523 986 q 562 1064 552 1040 l 697 1064 l 697 1049 q 664 1004 686 1031 q 617 946 643 976 q 563 889 591 917 q 512 842 536 860 l 445 842 l 445 860 "
  },
  Ŏ: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 720 1259 q 702 1183 717 1217 q 661 1123 687 1149 q 598 1084 635 1098 q 513 1071 561 1071 q 426 1084 463 1071 q 365 1122 389 1097 q 327 1181 340 1147 q 312 1259 314 1216 l 386 1259 q 398 1212 389 1229 q 424 1186 408 1194 q 463 1175 440 1177 q 516 1172 486 1172 q 562 1175 540 1172 q 602 1188 584 1178 q 631 1214 619 1197 q 645 1259 642 1231 l 720 1259 "
  },
  ю: {
    x_min: 118,
    x_max: 1047,
    ha: 1124,
    o: "m 1047 373 q 1025 208 1047 280 q 962 86 1003 135 q 864 11 922 37 q 734 -14 806 -14 q 613 8 668 -14 q 518 75 558 31 q 455 184 478 119 q 426 333 431 248 l 241 333 l 241 0 l 118 0 l 118 745 l 241 745 l 241 436 l 428 436 q 459 574 434 514 q 523 675 483 634 q 617 736 563 715 q 739 758 672 758 q 862 732 805 758 q 959 657 918 707 q 1023 537 1000 608 q 1047 373 1047 465 m 555 373 q 598 159 555 231 q 737 88 641 88 q 876 159 834 88 q 919 373 919 231 q 876 585 919 515 q 736 655 833 655 q 598 585 640 655 q 555 373 555 515 "
  },
  İ: {
    x_min: 55.34375,
    x_max: 414.8125,
    ha: 471,
    o: "m 414 0 l 55 0 l 55 69 l 172 96 l 172 895 l 55 922 l 55 992 l 414 992 l 414 922 l 298 895 l 298 96 l 414 69 l 414 0 m 163 1174 q 183 1233 163 1215 q 234 1252 204 1252 q 263 1247 249 1252 q 286 1233 276 1243 q 301 1209 295 1224 q 307 1174 307 1195 q 286 1116 307 1135 q 234 1097 264 1097 q 183 1115 204 1097 q 163 1174 163 1134 "
  },
  Ě: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 620 1274 q 579 1229 603 1255 q 533 1176 556 1203 q 490 1121 510 1148 q 460 1071 470 1094 l 329 1071 q 299 1121 319 1094 q 256 1176 279 1148 q 210 1229 233 1203 q 170 1274 187 1255 l 170 1293 l 252 1293 q 322 1237 286 1270 q 395 1166 358 1204 q 466 1237 430 1204 q 538 1293 503 1270 l 620 1293 l 620 1274 "
  },
  "‹": {
    x_min: 55.5,
    x_max: 344,
    ha: 400,
    o: "m 55 375 l 264 656 l 344 603 l 183 367 l 344 130 l 264 78 l 55 356 l 55 375 "
  },
  ķ: {
    x_min: 118,
    x_max: 684.25,
    ha: 689,
    o: "m 233 384 l 324 500 l 522 745 l 665 745 l 394 422 l 684 0 l 542 0 l 315 341 l 241 286 l 241 0 l 118 0 l 118 1055 l 241 1055 l 241 571 l 230 384 l 233 384 m 271 -288 q 287 -246 278 -271 q 304 -191 296 -220 q 318 -135 312 -163 q 327 -85 325 -107 l 450 -85 l 450 -98 q 435 -141 445 -115 q 409 -197 424 -167 q 375 -255 394 -226 q 337 -307 357 -284 l 271 -307 l 271 -288 "
  },
  ì: {
    x_min: -23,
    x_max: 244,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 m 244 842 l 162 842 q 110 889 138 860 q 56 946 82 917 q 9 1004 30 976 q -23 1049 -12 1031 l -23 1064 l 125 1064 q 151 1013 136 1040 q 181 958 165 986 q 213 905 197 931 q 244 860 229 879 l 244 842 "
  },
  "±": {
    x_min: 69.515625,
    x_max: 696.203125,
    ha: 765,
    o: "m 332 439 l 69 439 l 69 541 l 332 541 l 332 804 l 433 804 l 433 541 l 696 541 l 696 439 l 433 439 l 433 178 l 332 178 l 332 439 m 69 0 l 69 101 l 696 101 l 696 0 l 69 0 "
  },
  "|": {
    x_min: 332,
    x_max: 433.734375,
    ha: 765,
    o: "m 332 1055 l 433 1055 l 433 -334 l 332 -334 l 332 1055 "
  },
  "§": {
    x_min: 82.140625,
    x_max: 585,
    ha: 675,
    o: "m 93 550 q 101 612 93 584 q 125 661 110 640 q 159 698 139 683 q 198 723 178 713 q 121 788 149 749 q 93 883 93 826 q 111 958 93 925 q 164 1014 130 991 q 245 1050 198 1037 q 351 1063 293 1063 q 470 1048 417 1063 q 572 1011 523 1034 l 534 915 q 442 947 490 934 q 346 960 394 960 q 244 941 279 960 q 209 886 209 922 q 217 852 209 868 q 245 822 226 837 q 297 791 264 807 q 377 755 329 775 q 464 714 426 736 q 529 666 503 692 q 570 606 556 639 q 585 531 585 573 q 577 467 585 496 q 555 415 569 438 q 525 376 542 392 q 489 348 508 359 q 560 285 535 322 q 585 195 585 248 q 564 110 585 147 q 508 46 544 72 q 419 6 471 20 q 301 -7 366 -7 q 175 4 228 -7 q 82 40 122 16 l 82 151 q 129 130 103 140 q 184 112 155 120 q 243 100 213 104 q 303 95 274 95 q 382 103 351 95 q 433 124 414 111 q 460 154 452 137 q 468 190 468 171 q 462 224 468 209 q 439 254 456 239 q 389 286 421 269 q 305 323 357 302 q 215 365 254 344 q 148 412 176 386 q 107 471 121 438 q 93 550 93 505 m 209 563 q 218 517 209 538 q 248 476 228 495 q 302 437 269 456 q 383 398 335 419 l 406 388 q 428 409 417 397 q 448 437 439 421 q 462 472 457 453 q 468 514 468 491 q 459 561 468 539 q 429 603 451 583 q 372 642 408 623 q 282 682 336 662 q 256 666 268 676 q 232 640 243 655 q 215 605 222 625 q 209 563 209 586 "
  },
  џ: {
    x_min: 118,
    x_max: 706,
    ha: 825,
    o: "m 241 102 l 582 102 l 582 745 l 706 745 l 706 0 l 479 0 l 479 -258 l 356 -258 l 356 0 l 118 0 l 118 745 l 241 745 l 241 102 "
  },
  љ: {
    x_min: 11,
    x_max: 1054,
    ha: 1131,
    o: "m 611 439 l 771 439 q 985 386 916 439 q 1054 227 1054 333 q 1038 133 1054 175 q 988 61 1022 91 q 900 15 954 31 q 769 0 846 0 l 488 0 l 488 642 l 351 642 q 315 342 337 466 q 259 139 293 218 q 181 25 226 61 q 75 -10 135 -10 q 39 -8 56 -10 q 11 -2 22 -6 l 11 82 q 44 78 26 78 q 111 118 81 78 q 165 241 141 158 q 205 448 188 323 q 235 745 222 574 l 611 745 l 611 439 m 930 219 q 919 275 930 252 q 886 311 908 297 q 832 330 864 325 q 756 336 799 336 l 611 336 l 611 102 l 759 102 q 828 108 796 102 q 882 127 859 113 q 917 164 904 141 q 930 219 930 186 "
  },
  q: {
    x_min: 77,
    x_max: 696,
    ha: 814,
    o: "m 383 88 q 470 104 434 88 q 528 151 506 119 q 560 231 550 183 q 572 342 571 279 l 572 370 q 563 492 572 439 q 532 581 554 545 q 473 636 510 618 q 382 655 437 655 q 247 581 290 655 q 204 369 204 507 q 247 157 204 227 q 383 88 290 88 m 359 -14 q 244 10 296 -14 q 154 83 192 34 q 97 203 117 131 q 77 370 77 275 q 97 538 77 466 q 154 659 117 610 q 244 733 192 708 q 359 758 296 758 q 432 748 399 758 q 490 724 464 739 q 536 688 516 709 q 572 644 556 667 l 577 644 l 596 745 l 696 745 l 696 -334 l 572 -334 l 572 -16 q 573 16 572 -3 q 576 54 575 36 q 580 99 578 76 l 572 99 q 537 55 557 76 q 491 19 517 34 q 432 -5 465 3 q 359 -14 400 -14 "
  },
  "˳": {
    x_min: 78,
    x_max: 385,
    ha: 463,
    o: "m 385 -229 q 373 -291 385 -264 q 340 -338 361 -319 q 291 -367 319 -357 q 229 -377 262 -377 q 167 -367 195 -377 q 119 -338 139 -357 q 88 -292 99 -319 q 78 -231 78 -265 q 88 -169 78 -196 q 119 -123 99 -142 q 167 -94 139 -104 q 229 -85 195 -85 q 290 -94 262 -85 q 340 -123 319 -104 q 373 -168 361 -142 q 385 -229 385 -195 m 310 -231 q 288 -174 310 -194 q 231 -154 265 -154 q 174 -174 196 -154 q 152 -231 152 -194 q 172 -287 152 -267 q 231 -307 192 -307 q 288 -287 265 -307 q 310 -231 310 -267 "
  },
  ή: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 -334 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 745 l 218 745 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 -334 l 583 -334 m 388 860 q 401 906 394 880 q 414 960 408 932 q 426 1014 421 987 q 435 1064 432 1041 l 570 1064 l 570 1049 q 554 1007 565 1033 q 528 951 543 980 q 495 892 512 921 q 461 842 477 863 l 388 842 l 388 860 "
  },
  Ж: {
    x_min: 2.75,
    x_max: 1129.25,
    ha: 1132,
    o: "m 372 511 l 12 992 l 151 992 l 505 511 l 505 992 l 631 992 l 631 511 l 980 992 l 1119 992 l 764 511 l 1129 0 l 986 0 l 631 502 l 631 0 l 505 0 l 505 502 l 145 0 l 2 0 l 372 511 "
  },
  "®": {
    x_min: 68,
    x_max: 1088,
    ha: 1156,
    o: "m 506 521 l 554 521 q 641 545 615 521 q 668 616 668 569 q 640 686 668 666 q 553 706 612 706 l 506 706 l 506 521 m 776 617 q 767 559 776 584 q 743 513 758 533 q 709 480 728 494 q 669 458 689 467 q 749 326 714 384 q 779 277 765 301 q 804 235 793 254 q 822 205 816 216 l 829 194 l 707 194 l 569 429 l 506 429 l 506 194 l 398 194 l 398 799 l 555 799 q 723 754 669 799 q 776 617 776 710 m 68 495 q 86 631 68 566 q 137 753 104 696 q 217 856 170 809 q 320 936 264 903 q 442 987 377 969 q 578 1006 507 1006 q 713 987 648 1006 q 835 936 778 969 q 938 856 892 903 q 1018 753 985 809 q 1069 631 1051 696 q 1088 495 1088 566 q 1069 359 1088 425 q 1018 238 1051 294 q 938 134 985 181 q 835 55 892 88 q 713 3 778 21 q 578 -14 648 -14 q 442 3 507 -14 q 320 55 377 21 q 217 134 264 88 q 137 238 170 181 q 86 359 104 294 q 68 495 68 425 m 141 496 q 176 326 141 405 q 269 187 210 247 q 408 94 329 128 q 578 59 487 59 q 747 94 668 59 q 886 187 826 128 q 979 326 945 247 q 1014 496 1014 405 q 979 665 1014 586 q 886 804 945 744 q 747 897 826 863 q 578 932 668 932 q 408 897 487 932 q 269 804 329 863 q 176 665 210 744 q 141 496 141 586 "
  },
  Н: {
    x_min: 135,
    x_max: 839,
    ha: 974,
    o: "m 839 0 l 712 0 l 712 462 l 261 462 l 261 0 l 135 0 l 135 992 l 261 992 l 261 574 l 712 574 l 712 992 l 839 992 l 839 0 "
  },
  Ε: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 "
  },
  "₧": {
    x_min: 102,
    x_max: 992,
    ha: 1042,
    o: "m 908 82 q 931 84 918 82 q 955 87 943 85 q 977 92 966 89 q 992 97 987 95 l 992 6 q 948 -7 976 0 q 878 -14 921 -14 q 812 -2 842 -14 q 760 32 782 8 q 725 91 738 56 q 713 175 713 127 l 713 477 l 607 477 l 607 534 l 713 588 l 758 717 l 833 717 l 833 574 l 974 574 l 974 477 l 833 477 l 833 187 q 850 109 833 135 q 908 82 868 82 m 616 701 q 598 582 616 639 q 538 482 580 525 q 426 412 496 438 q 253 386 357 386 l 221 386 l 221 0 l 102 0 l 102 992 l 272 992 q 428 972 363 992 q 534 916 493 953 q 596 825 576 879 q 616 701 616 770 m 221 491 l 239 491 q 349 502 302 491 q 428 537 397 513 q 474 600 459 561 q 490 695 490 639 q 434 839 490 792 q 260 886 378 886 l 221 886 l 221 491 "
  },
  л: {
    x_min: 11,
    x_max: 640,
    ha: 758,
    o: "m 640 0 l 516 0 l 516 642 l 352 642 q 316 342 338 466 q 260 139 293 218 q 181 25 227 61 q 76 -10 136 -10 q 39 -8 56 -10 q 11 -2 22 -6 l 11 82 q 44 78 26 78 q 112 118 82 78 q 165 241 142 158 q 206 448 189 323 q 236 745 223 574 l 640 745 l 640 0 "
  },
  σ: {
    x_min: 77,
    x_max: 784.6875,
    ha: 817,
    o: "m 725 342 q 703 201 725 267 q 641 88 682 136 q 539 13 600 40 q 398 -14 478 -14 q 267 9 326 -14 q 165 80 207 33 q 100 196 123 127 q 77 355 77 265 q 103 535 77 461 q 178 656 129 609 q 296 723 226 702 q 453 745 366 745 l 784 745 l 784 642 l 604 642 q 651 583 629 614 q 689 514 673 551 q 715 435 706 477 q 725 342 725 393 m 204 356 q 215 249 204 298 q 250 164 226 200 q 312 108 274 128 q 401 88 349 88 q 490 107 453 88 q 551 159 527 125 q 586 238 575 192 q 597 337 597 284 q 570 508 597 435 q 493 642 543 581 l 453 642 q 341 627 388 642 q 264 578 294 612 q 219 490 233 545 q 204 356 204 435 "
  },
  θ: {
    x_min: 77,
    x_max: 710,
    ha: 786,
    o: "m 710 528 q 692 300 710 401 q 636 129 674 199 q 538 22 598 59 q 392 -14 477 -14 q 252 22 312 -14 q 154 129 193 59 q 95 300 114 199 q 77 528 77 401 q 94 757 77 656 q 149 927 111 857 q 246 1034 186 997 q 392 1071 306 1071 q 531 1034 472 1071 q 631 928 591 998 q 690 758 670 859 q 710 528 710 657 m 392 88 q 477 113 442 88 q 537 189 513 138 q 572 315 560 239 q 586 493 584 391 l 200 493 q 213 317 201 393 q 247 190 224 241 q 306 113 270 139 q 392 88 341 88 m 392 968 q 309 945 343 968 q 251 875 274 921 q 215 758 227 828 q 200 596 203 689 l 585 596 q 533 875 579 781 q 392 968 488 968 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 361
  },
  "∑": {
    x_min: 50,
    x_max: 848,
    ha: 876,
    o: "m 50 -334 l 50 -255 l 473 364 l 60 914 l 60 992 l 804 992 l 804 880 l 237 880 l 606 365 l 222 -222 l 848 -222 l 848 -334 l 50 -334 "
  },
  Ώ: {
    x_min: -17,
    x_max: 1041.9375,
    ha: 1092,
    o: "m 578 895 q 445 872 500 895 q 353 805 389 849 q 300 699 317 762 q 283 556 283 636 q 295 425 283 488 q 334 304 307 362 q 406 194 362 246 q 516 99 451 143 l 516 0 l 114 0 l 114 111 l 382 111 q 290 189 332 143 q 216 292 247 235 q 167 416 185 349 q 150 559 150 484 q 177 743 150 661 q 259 884 204 826 q 393 975 313 943 q 578 1007 473 1007 q 762 975 683 1007 q 896 884 842 943 q 978 743 951 826 q 1006 559 1006 661 q 988 416 1006 484 q 939 292 970 349 q 866 189 908 235 q 773 111 823 143 l 1041 111 l 1041 0 l 640 0 l 640 99 q 749 194 704 143 q 821 304 793 246 q 860 425 848 362 q 872 556 872 488 q 855 699 872 636 q 802 805 838 762 q 710 872 766 849 q 578 895 655 895 m -17 789 q -3 835 -10 809 q 9 889 3 861 q 21 943 16 916 q 30 993 27 970 l 165 993 l 165 978 q 149 936 160 962 q 123 880 138 909 q 90 821 107 850 q 56 771 72 792 l -17 771 l -17 789 "
  },
  ẃ: {
    x_min: 13.75,
    x_max: 1022.25,
    ha: 1036,
    o: "m 683 0 l 570 417 q 563 445 567 430 q 555 477 559 460 q 546 512 551 494 q 538 546 542 529 q 518 628 528 586 l 514 628 q 496 546 505 585 q 480 476 488 512 q 464 415 471 440 l 347 0 l 204 0 l 13 745 l 143 745 l 232 348 q 245 282 239 318 q 258 211 252 246 q 269 146 264 177 q 277 95 274 115 l 281 95 q 290 142 284 113 q 303 205 296 172 q 317 270 310 238 q 331 324 325 302 l 453 745 l 586 745 l 702 324 q 716 270 709 301 q 732 207 724 239 q 745 145 739 175 q 754 95 751 115 l 758 95 q 764 142 760 113 q 775 207 769 172 q 788 279 781 242 q 803 348 795 316 l 896 745 l 1022 745 l 829 0 l 683 0 m 456 860 q 486 905 470 879 q 518 958 502 931 q 549 1013 534 986 q 574 1064 563 1040 l 723 1064 l 723 1049 q 690 1004 712 1031 q 643 946 669 976 q 589 889 617 917 q 538 842 561 860 l 456 842 l 456 860 "
  },
  "+": {
    x_min: 69.515625,
    x_max: 696.203125,
    ha: 765,
    o: "m 332 439 l 69 439 l 69 541 l 332 541 l 332 804 l 433 804 l 433 541 l 696 541 l 696 439 l 433 439 l 433 178 l 332 178 l 332 439 "
  },
  Ë: {
    x_min: 135,
    x_max: 650,
    ha: 733,
    o: "m 650 0 l 135 0 l 135 992 l 650 992 l 650 880 l 261 880 l 261 574 l 624 574 l 624 462 l 261 462 l 261 111 l 650 111 l 650 0 m 201 1174 q 219 1227 201 1211 q 266 1244 238 1244 q 312 1227 292 1244 q 331 1174 331 1210 q 312 1121 331 1138 q 266 1105 292 1105 q 219 1121 238 1105 q 201 1174 201 1138 m 455 1174 q 474 1227 455 1211 q 520 1244 493 1244 q 545 1239 533 1244 q 566 1227 557 1235 q 580 1206 575 1218 q 586 1174 586 1193 q 566 1121 586 1138 q 520 1105 546 1105 q 474 1121 493 1105 q 455 1174 455 1138 "
  },
  Š: {
    x_min: 70.109375,
    x_max: 657,
    ha: 721,
    o: "m 657 264 q 633 147 657 199 q 566 59 610 95 q 460 4 523 23 q 320 -14 398 -14 q 179 -2 245 -14 q 70 32 114 9 l 70 153 q 122 131 93 142 q 184 112 151 120 q 251 99 216 104 q 319 93 285 93 q 479 134 427 93 q 530 252 530 176 q 521 316 530 289 q 486 366 511 343 q 420 410 461 389 q 316 456 379 431 q 212 508 256 480 q 139 572 168 537 q 96 652 110 607 q 83 754 83 697 q 104 860 83 813 q 165 939 126 907 q 259 989 205 972 q 380 1006 314 1006 q 525 990 460 1006 q 640 951 589 975 l 595 845 q 495 880 551 865 q 381 894 440 894 q 254 856 299 894 q 209 752 209 818 q 219 686 209 714 q 252 635 229 657 q 315 592 276 612 q 410 549 353 572 q 517 499 471 525 q 594 441 563 473 q 641 366 625 408 q 657 264 657 323 m 607 1274 q 566 1229 590 1255 q 520 1176 543 1203 q 477 1121 497 1148 q 447 1071 457 1094 l 316 1071 q 286 1121 306 1094 q 243 1176 266 1148 q 197 1229 220 1203 q 157 1274 174 1255 l 157 1293 l 239 1293 q 309 1237 273 1270 q 382 1166 345 1204 q 453 1237 417 1204 q 525 1293 490 1270 l 607 1293 l 607 1274 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 1389
  },
  ð: {
    x_min: 75,
    x_max: 725,
    ha: 802,
    o: "m 725 388 q 702 217 725 291 q 637 91 679 142 q 534 12 594 39 q 398 -14 473 -14 q 268 8 328 -14 q 166 73 209 30 q 99 179 123 116 q 75 323 75 242 q 96 466 75 403 q 157 571 117 528 q 254 635 197 613 q 383 658 311 658 q 504 637 452 658 q 585 577 556 617 l 591 580 q 529 725 570 660 q 427 845 488 790 l 254 742 l 204 819 l 350 907 q 294 945 323 926 q 234 981 265 964 l 281 1065 q 367 1018 325 1043 q 448 964 408 994 l 602 1058 l 653 981 l 520 902 q 603 805 566 858 q 668 689 641 752 q 710 550 695 625 q 725 388 725 475 m 597 355 q 585 429 597 393 q 550 493 574 466 q 488 538 526 521 q 400 555 451 555 q 310 540 347 555 q 248 494 272 524 q 213 420 225 464 q 202 318 202 376 q 213 224 202 267 q 249 152 225 182 q 310 104 273 121 q 400 88 348 88 q 551 155 505 88 q 597 355 597 223 "
  },
  щ: {
    x_min: 118,
    x_max: 1197,
    ha: 1218,
    o: "m 1197 -258 l 1073 -258 l 1073 0 l 118 0 l 118 745 l 241 745 l 241 102 l 542 102 l 542 745 l 665 745 l 665 102 l 965 102 l 965 745 l 1089 745 l 1089 102 l 1197 102 l 1197 -258 "
  },
  "℮": {
    x_min: 69,
    x_max: 789,
    ha: 860,
    o: "m 429 -24 q 273 7 341 -24 q 161 92 206 39 q 92 215 115 146 q 69 359 69 284 q 83 480 69 426 q 124 577 98 534 q 185 651 150 620 q 259 702 219 682 q 343 733 299 723 q 429 743 386 743 q 571 716 506 743 q 685 639 637 689 q 761 518 734 589 q 789 359 789 448 l 213 359 l 213 117 q 251 86 228 100 q 300 59 273 71 q 357 40 327 47 q 420 33 388 33 q 512 44 472 33 q 585 75 553 55 q 645 125 618 96 q 696 193 672 155 l 746 165 q 693 92 721 126 q 628 31 665 58 q 542 -9 590 5 q 429 -24 493 -24 m 644 417 l 644 604 q 609 632 630 618 q 560 658 588 646 q 498 677 532 670 q 426 685 465 685 q 358 678 389 685 q 300 661 327 672 q 252 635 274 650 q 213 606 230 621 l 213 417 l 644 417 "
  },
  Φ: {
    x_min: 71,
    x_max: 994,
    ha: 1065,
    o: "m 468 1006 l 594 1006 l 594 884 l 643 884 q 801 852 735 884 q 910 768 867 820 q 973 649 953 716 q 994 514 994 583 q 985 429 994 472 q 959 343 977 385 q 913 264 942 301 q 844 199 885 227 q 749 155 803 171 q 626 139 694 139 l 594 139 l 594 -14 l 468 -14 l 468 139 l 436 139 q 314 155 368 139 q 220 199 260 171 q 151 264 179 227 q 105 343 122 301 q 79 429 87 385 q 71 514 71 472 q 91 649 71 583 q 154 768 112 716 q 262 852 197 820 q 418 884 328 884 l 468 884 l 468 1006 m 594 246 l 611 246 q 721 266 674 246 q 798 322 768 286 q 844 408 829 358 q 860 517 860 458 q 846 617 860 570 q 804 700 832 665 q 734 755 776 735 q 632 776 691 776 l 594 776 l 594 246 m 468 776 l 429 776 q 329 755 371 776 q 259 700 287 735 q 217 617 231 665 q 204 517 204 570 q 219 408 204 458 q 265 322 235 358 q 342 266 295 286 q 450 246 388 246 l 468 246 l 468 776 "
  },
  ş: {
    x_min: 61.15625,
    x_max: 564,
    ha: 627,
    o: "m 564 203 q 544 108 564 149 q 487 40 524 68 q 398 0 450 13 q 281 -14 346 -14 q 154 -2 207 -14 q 61 33 101 9 l 61 146 q 107 125 82 135 q 161 106 133 114 q 219 93 189 98 q 279 88 249 88 q 353 95 323 88 q 403 116 384 103 q 431 150 423 130 q 440 194 440 170 q 433 232 440 215 q 409 265 427 249 q 360 299 391 282 q 280 337 329 316 q 193 378 232 358 q 127 424 154 399 q 86 482 100 449 q 72 560 72 515 q 90 645 72 608 q 143 707 109 682 q 224 745 177 732 q 330 758 272 758 q 451 743 396 758 q 554 706 505 729 l 512 606 q 422 641 468 626 q 329 655 376 655 q 228 632 261 655 q 195 568 195 610 q 203 526 195 544 q 229 493 210 509 q 279 461 248 477 q 358 426 311 445 q 444 385 406 405 q 509 339 482 365 q 549 281 535 314 q 564 203 564 249 m 440 -194 q 392 -297 440 -260 q 242 -334 344 -334 q 212 -331 227 -334 q 187 -327 197 -329 l 187 -254 q 213 -257 197 -256 q 240 -258 230 -258 q 315 -247 288 -258 q 342 -208 342 -235 q 333 -186 342 -195 q 309 -169 324 -176 q 272 -157 294 -162 q 227 -147 251 -152 l 288 0 l 370 0 l 331 -78 q 374 -92 354 -83 q 408 -115 393 -101 q 431 -148 423 -128 q 440 -194 440 -168 "
  },
  " ": {
    x_min: 0,
    x_max: 0,
    ha: 765
  },
  ı: {
    x_min: 118,
    x_max: 241.4375,
    ha: 359,
    o: "m 241 0 l 118 0 l 118 745 l 241 745 l 241 0 "
  },
  ä: {
    x_min: 64,
    x_max: 626,
    ha: 737,
    o: "m 536 0 l 511 102 l 505 102 q 461 50 483 72 q 412 13 439 28 q 353 -7 386 0 q 278 -14 321 -14 q 193 0 232 -14 q 125 40 153 12 q 80 109 96 67 q 64 208 64 151 q 142 379 64 320 q 379 445 220 439 l 503 450 l 503 496 q 494 572 503 541 q 465 620 484 602 q 419 647 447 639 q 357 655 392 655 q 253 639 301 655 q 160 599 204 623 l 117 692 q 228 739 167 720 q 357 758 290 758 q 477 744 427 758 q 560 700 527 730 q 609 623 593 669 q 626 509 626 576 l 626 0 l 536 0 m 310 88 q 386 101 351 88 q 447 140 422 114 q 488 205 473 166 q 502 298 502 245 l 502 365 l 405 360 q 303 346 345 357 q 237 316 262 336 q 202 270 213 297 q 191 208 191 243 q 224 117 191 146 q 310 88 257 88 m 185 945 q 203 998 185 982 q 250 1015 222 1015 q 296 998 276 1015 q 315 945 315 981 q 296 892 315 909 q 250 876 276 876 q 203 892 222 876 q 185 945 185 909 m 439 945 q 458 998 439 982 q 504 1015 477 1015 q 529 1010 517 1015 q 550 998 541 1006 q 564 977 559 989 q 570 945 570 964 q 550 892 570 909 q 504 876 530 876 q 458 892 477 876 q 439 945 439 909 "
  },
  "¹": {
    x_min: 42,
    x_max: 297.984375,
    ha: 460,
    o: "m 207 992 l 297 992 l 297 397 l 201 397 l 201 754 q 201 792 201 771 q 202 833 201 813 q 204 873 203 854 q 206 908 205 893 q 184 881 196 895 q 156 853 171 866 l 92 799 l 42 864 l 207 992 "
  },
  W: {
    x_min: 13.75,
    x_max: 1214.25,
    ha: 1228,
    o: "m 549 992 l 682 992 l 837 411 q 857 335 847 373 q 876 261 867 297 q 891 194 884 225 q 901 136 897 162 q 908 192 904 162 q 917 256 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 992 l 1214 992 l 965 0 l 837 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 622 813 q 600 776 608 814 q 585 707 593 745 q 567 632 576 669 l 402 0 l 275 0 l 13 992 l 147 992 l 298 388 q 313 323 306 357 q 325 257 320 290 q 336 192 331 223 q 344 136 341 162 q 352 194 347 161 q 364 264 358 227 q 379 338 371 301 q 396 409 387 376 l 549 992 "
  },
  λ: {
    x_min: -10.25,
    x_max: 710,
    ha: 710,
    o: "m -10 0 l 288 729 l 252 837 q 233 887 243 864 q 208 926 222 910 q 172 952 193 943 q 122 961 152 961 q 82 959 99 961 q 52 953 65 956 l 52 1052 q 92 1060 69 1057 q 138 1064 114 1064 q 224 1049 188 1064 q 286 1005 260 1035 q 335 929 313 975 q 377 820 356 883 l 600 163 q 627 107 612 127 q 669 88 643 88 q 691 90 678 88 q 710 95 704 93 l 710 3 q 675 -9 694 -4 q 632 -14 657 -14 q 585 -8 605 -14 q 549 11 565 -2 q 521 46 533 24 q 498 99 508 68 l 406 382 q 389 437 399 405 q 370 502 379 469 q 353 564 361 534 q 343 610 346 594 l 338 610 q 312 501 330 558 q 272 389 294 443 l 117 0 l -10 0 "
  },
  ">": {
    x_min: 69,
    x_max: 696,
    ha: 765,
    o: "m 69 270 l 568 488 l 69 735 l 69 844 l 696 517 l 696 448 l 69 161 l 69 270 "
  },
  τ: {
    x_min: 13,
    x_max: 590.296875,
    ha: 624,
    o: "m 590 745 l 590 642 l 337 642 l 337 230 q 345 162 337 190 q 369 117 354 134 q 406 92 385 100 q 451 84 427 84 q 478 85 463 84 q 506 88 492 86 q 531 92 519 90 q 553 97 544 95 l 553 5 q 530 -2 544 1 q 502 -10 517 -6 q 468 -15 486 -13 q 432 -18 450 -18 q 349 -8 388 -18 q 279 27 309 1 q 231 99 249 54 q 214 216 214 145 l 214 642 l 13 642 l 13 691 l 103 745 l 590 745 "
  },
  Ų: {
    x_min: 125,
    x_max: 845,
    ha: 970,
    o: "m 845 993 l 845 349 q 822 205 845 272 q 755 90 800 139 q 641 13 709 41 q 481 -14 573 -14 q 327 12 394 -14 q 216 86 261 38 q 148 202 171 134 q 125 352 125 269 l 125 991 l 251 991 l 251 346 q 309 162 251 227 q 487 97 368 97 q 591 115 548 97 q 663 167 635 133 q 704 246 690 200 q 718 347 718 292 l 718 993 l 845 993 m 483 -161 q 501 -206 483 -191 q 543 -220 519 -220 q 576 -218 560 -220 q 602 -214 592 -217 l 602 -291 q 562 -299 584 -296 q 521 -302 541 -302 q 419 -266 453 -302 q 386 -170 386 -231 q 395 -116 386 -142 q 421 -69 405 -91 q 454 -30 436 -48 q 490 0 473 -12 l 577 0 q 483 -161 483 -90 "
  },
  Ŵ: {
    x_min: 13.75,
    x_max: 1214.25,
    ha: 1228,
    o: "m 549 992 l 682 992 l 837 411 q 857 335 847 373 q 876 261 867 297 q 891 194 884 225 q 901 136 897 162 q 908 192 904 162 q 917 256 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 992 l 1214 992 l 965 0 l 837 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 622 813 q 600 776 608 814 q 585 707 593 745 q 567 632 576 669 l 402 0 l 275 0 l 13 992 l 147 992 l 298 388 q 313 323 306 357 q 325 257 320 290 q 336 192 331 223 q 344 136 341 162 q 352 194 347 161 q 364 264 358 227 q 379 338 371 301 q 396 409 387 376 l 549 992 m 839 1071 l 757 1071 q 685 1126 722 1093 q 614 1196 649 1159 q 541 1126 577 1159 q 471 1071 505 1093 l 389 1071 l 389 1089 q 429 1134 406 1108 q 475 1187 452 1160 q 518 1242 498 1215 q 548 1293 538 1269 l 679 1293 q 709 1242 689 1269 q 752 1187 729 1215 q 798 1134 775 1160 q 839 1089 822 1108 l 839 1071 "
  },
  "‛": {
    x_min: 17,
    x_max: 229,
    ha: 243,
    o: "m 150 992 q 165 913 156 956 q 184 827 174 871 q 205 737 194 782 q 229 652 217 692 l 136 652 q 101 731 119 690 q 68 815 83 772 q 39 898 52 857 q 17 977 26 939 l 25 992 l 150 992 "
  },
  Ð: {
    x_min: 32,
    x_max: 865,
    ha: 950,
    o: "m 32 546 l 135 546 l 135 992 l 410 992 q 598 960 514 992 q 741 868 682 929 q 832 715 800 806 q 865 505 865 624 q 832 285 865 379 q 738 127 799 190 q 586 31 676 63 q 383 0 496 0 l 135 0 l 135 434 l 32 434 l 32 546 m 731 501 q 709 672 731 600 q 643 791 686 744 q 538 861 601 838 q 397 884 476 884 l 261 884 l 261 546 l 489 546 l 489 434 l 261 434 l 261 107 l 370 107 q 640 207 549 107 q 731 501 731 306 "
  },
  Λ: {
    x_min: -0.25,
    x_max: 789.25,
    ha: 789,
    o: "m 789 0 l 654 0 l 455 625 q 419 748 434 691 q 393 856 403 805 q 367 748 381 805 q 333 629 353 691 l 133 0 l 0 0 l 330 992 l 457 992 l 789 0 "
  },
  "·": {
    x_min: 100,
    x_max: 272,
    ha: 372,
    o: "m 100 490 q 106 534 100 516 q 125 563 113 552 q 152 579 136 574 q 186 585 167 585 q 219 579 203 585 q 246 563 235 574 q 265 534 258 552 q 272 490 272 516 q 265 447 272 465 q 246 418 258 430 q 219 401 235 406 q 186 396 203 396 q 152 401 167 396 q 125 418 136 406 q 106 447 113 430 q 100 490 100 465 "
  },
  Х: {
    x_min: -0.25,
    x_max: 760.25,
    ha: 760,
    o: "m 760 0 l 617 0 l 376 430 l 127 0 l 0 0 l 307 518 l 20 992 l 155 992 l 380 612 l 608 992 l 737 992 l 450 522 l 760 0 "
  },
  Υ: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 "
  },
  r: {
    x_min: 118,
    x_max: 526,
    ha: 554,
    o: "m 439 758 q 483 756 459 758 q 526 751 508 754 l 509 637 q 470 643 490 640 q 433 645 450 645 q 355 628 390 645 q 294 578 320 610 q 255 501 269 546 q 241 401 241 456 l 241 0 l 118 0 l 118 745 l 218 745 l 233 608 l 238 608 q 274 664 255 637 q 318 712 294 691 q 372 745 342 732 q 439 758 402 758 "
  },
  ж: {
    x_min: 2.75,
    x_max: 997.25,
    ha: 1e3,
    o: "m 444 383 l 444 745 l 560 745 l 560 383 l 837 745 l 971 745 l 688 383 l 997 0 l 857 0 l 560 377 l 560 0 l 444 0 l 444 377 l 143 0 l 2 0 l 316 383 l 29 745 l 162 745 l 444 383 "
  },
  Ø: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 881 985 l 819 884 q 913 719 881 817 q 945 496 945 620 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 297 34 387 -14 l 244 -51 l 151 0 l 212 99 q 115 268 146 167 q 85 498 85 369 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 635 992 580 1007 q 734 952 689 978 l 789 1038 l 881 985 m 218 497 q 234 337 218 408 q 282 213 249 266 l 675 854 q 603 884 642 874 q 517 895 565 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 811 497 q 751 773 811 671 l 359 136 q 430 107 391 117 q 515 97 468 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 "
  },
  Ỳ: {
    x_min: -0.25,
    x_max: 731.25,
    ha: 732,
    o: "m 364 490 l 595 992 l 731 992 l 428 386 l 428 0 l 302 0 l 302 379 l 0 992 l 137 992 l 364 490 m 437 1071 l 355 1071 q 303 1118 331 1089 q 249 1175 275 1146 q 202 1233 223 1205 q 170 1278 180 1260 l 170 1293 l 318 1293 q 344 1242 329 1269 q 374 1187 358 1215 q 406 1134 390 1160 q 437 1089 422 1108 l 437 1071 "
  },
  "÷": {
    x_min: 69.65625,
    x_max: 696.34375,
    ha: 765,
    o: "m 69 439 l 69 541 l 696 541 l 696 439 l 69 439 m 305 219 q 309 243 305 234 q 319 259 313 253 q 335 268 326 265 q 355 270 344 270 q 375 268 365 270 q 391 259 384 265 q 402 243 398 253 q 406 219 406 234 q 402 196 406 206 q 391 181 398 187 q 375 171 384 174 q 355 169 365 169 q 335 171 344 169 q 319 181 326 174 q 309 196 313 187 q 305 219 305 206 m 305 761 q 309 784 305 775 q 319 800 313 794 q 335 809 326 806 q 355 812 344 812 q 375 809 365 812 q 391 800 384 806 q 402 784 398 794 q 406 761 406 775 q 402 738 406 747 q 391 722 398 728 q 375 713 384 715 q 355 710 365 710 q 335 713 344 710 q 319 722 326 715 q 309 738 313 728 q 305 761 305 747 "
  },
  с: {
    x_min: 77,
    x_max: 596,
    ha: 643,
    o: "m 402 -14 q 274 7 334 -14 q 171 75 215 28 q 102 193 127 121 q 77 367 77 266 q 102 548 77 474 q 173 669 128 623 q 278 736 218 715 q 408 758 339 758 q 511 746 461 758 q 596 718 562 735 l 559 614 q 524 627 543 621 q 485 638 505 633 q 445 647 465 644 q 408 650 425 650 q 253 581 302 650 q 204 369 204 513 q 253 160 204 226 q 402 93 302 93 q 502 106 457 93 q 583 135 546 118 l 583 26 q 504 -3 546 6 q 402 -14 463 -14 "
  },
  h: {
    x_min: 118,
    x_max: 707,
    ha: 818,
    o: "m 583 0 l 583 479 q 547 611 583 567 q 436 655 512 655 q 343 637 381 655 q 283 585 306 620 q 251 501 261 551 q 241 385 241 450 l 241 0 l 118 0 l 118 1055 l 241 1055 l 241 741 l 236 644 l 242 644 q 283 694 259 673 q 334 730 306 715 q 393 751 362 744 q 457 758 424 758 q 644 693 581 758 q 707 486 707 628 l 707 0 l 583 0 "
  },
  f: {
    x_min: 19,
    x_max: 509,
    ha: 457,
    o: "m 441 656 l 274 656 l 274 0 l 151 0 l 151 656 l 19 656 l 19 704 l 151 749 l 151 814 q 166 934 151 886 q 210 1010 181 982 q 280 1051 238 1039 q 375 1063 322 1063 q 449 1055 415 1063 q 509 1037 482 1047 l 477 941 q 431 954 456 949 q 379 960 406 960 q 332 954 352 960 q 300 931 313 947 q 280 887 287 915 q 274 815 274 859 l 274 745 l 441 745 l 441 656 "
  },
  "“": {
    x_min: 16,
    x_max: 489,
    ha: 504,
    o: "m 285 652 l 277 666 q 299 744 286 703 q 328 828 312 786 q 361 912 343 870 q 396 992 379 954 l 489 992 q 465 905 477 950 q 444 816 454 861 q 425 730 434 772 q 410 652 416 687 l 285 652 m 24 652 l 16 666 q 38 744 25 703 q 67 828 51 786 q 100 912 82 870 q 135 992 118 954 l 228 992 q 204 905 216 950 q 183 816 193 861 q 164 730 173 772 q 149 652 155 687 l 24 652 "
  },
  A: {
    x_min: -0.25,
    x_max: 844.25,
    ha: 844,
    o: "m 715 0 l 606 307 l 237 307 l 127 0 l 0 0 l 364 996 l 479 996 l 844 0 l 715 0 m 566 419 l 466 706 q 456 736 462 719 q 444 774 450 754 q 432 817 438 795 q 421 860 426 839 q 410 816 416 839 q 397 773 404 794 q 386 735 391 752 q 376 706 380 718 l 277 419 l 566 419 "
  },
  O: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 945 496 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 324 22 405 -14 q 189 126 243 59 q 110 288 136 193 q 85 498 85 382 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 701 970 622 1007 q 835 867 781 934 q 917 706 890 800 q 945 496 945 612 m 218 497 q 236 330 218 404 q 290 204 253 255 q 382 124 326 152 q 515 97 438 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 q 794 664 811 590 q 741 789 777 738 q 649 868 705 840 q 517 895 594 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 "
  },
  Đ: {
    x_min: 32,
    x_max: 865,
    ha: 950,
    o: "m 32 546 l 135 546 l 135 992 l 410 992 q 598 960 514 992 q 741 868 682 929 q 832 715 800 806 q 865 505 865 624 q 832 285 865 379 q 738 127 799 190 q 586 31 676 63 q 383 0 496 0 l 135 0 l 135 434 l 32 434 l 32 546 m 731 501 q 709 672 731 600 q 643 791 686 744 q 538 861 601 838 q 397 884 476 884 l 261 884 l 261 546 l 489 546 l 489 434 l 261 434 l 261 107 l 370 107 q 640 207 549 107 q 731 501 731 306 "
  },
  Ǿ: {
    x_min: 85,
    x_max: 945,
    ha: 1031,
    o: "m 881 985 l 819 884 q 913 719 881 817 q 945 496 945 620 q 917 287 945 382 q 835 126 890 193 q 701 22 781 59 q 515 -14 620 -14 q 297 34 387 -14 l 244 -51 l 151 0 l 212 99 q 115 268 146 167 q 85 498 85 369 q 110 707 85 613 q 190 867 136 801 q 325 970 243 934 q 517 1007 406 1007 q 635 992 580 1007 q 734 952 689 978 l 789 1038 l 881 985 m 218 497 q 234 337 218 408 q 282 213 249 266 l 675 854 q 603 884 642 874 q 517 895 565 895 q 383 868 439 895 q 290 789 327 840 q 236 664 253 738 q 218 497 218 590 m 811 497 q 751 773 811 671 l 359 136 q 430 107 391 117 q 515 97 468 97 q 648 124 593 97 q 741 204 704 152 q 794 330 777 255 q 811 497 811 404 m 441 1089 q 471 1134 455 1108 q 503 1187 487 1160 q 534 1242 519 1215 q 559 1293 548 1269 l 708 1293 l 708 1278 q 675 1233 697 1260 q 628 1175 654 1205 q 574 1118 602 1146 q 523 1071 546 1089 l 441 1071 l 441 1089 "
  },
  "⅛": {
    x_min: 56,
    x_max: 1011,
    ha: 1051,
    o: "m 221 992 l 311 992 l 311 397 l 215 397 l 215 754 q 215 792 215 771 q 216 833 215 813 q 218 873 217 854 q 220 908 219 893 q 198 881 210 895 q 170 853 185 866 l 106 799 l 56 864 l 221 992 m 829 992 l 278 0 l 171 0 l 722 992 l 829 992 m 815 604 q 883 594 851 604 q 938 567 914 585 q 976 519 962 548 q 991 453 991 491 q 983 407 991 428 q 962 369 976 386 q 931 338 949 352 q 893 313 914 325 q 938 285 917 300 q 975 251 959 270 q 1001 209 991 233 q 1011 157 1011 186 q 996 87 1011 119 q 956 33 982 56 q 894 0 930 11 q 816 -13 858 -13 q 670 31 721 -13 q 620 153 620 75 q 628 205 620 182 q 651 247 636 228 q 684 281 665 266 q 724 307 703 295 q 690 335 705 321 q 662 368 674 350 q 644 407 650 386 q 638 453 638 428 q 652 519 638 491 q 691 566 667 547 q 748 594 716 585 q 815 604 780 604 m 716 155 q 741 93 716 116 q 814 70 766 70 q 888 93 863 70 q 914 155 914 116 q 906 190 914 174 q 885 219 899 206 q 854 242 872 232 q 813 262 835 253 l 802 266 q 738 219 760 244 q 716 155 716 193 m 813 520 q 755 502 776 520 q 734 449 734 484 q 741 417 734 431 q 757 392 747 404 q 783 371 768 380 q 815 353 798 361 q 846 370 831 360 q 871 390 860 379 q 887 416 881 402 q 894 449 894 430 q 872 502 894 484 q 813 520 850 520 "
  },
  Ẁ: {
    x_min: 13.75,
    x_max: 1214.25,
    ha: 1228,
    o: "m 549 992 l 682 992 l 837 411 q 857 335 847 373 q 876 261 867 297 q 891 194 884 225 q 901 136 897 162 q 908 192 904 162 q 917 256 912 223 q 929 325 923 290 q 943 393 936 360 l 1079 992 l 1214 992 l 965 0 l 837 0 l 665 636 q 647 707 656 671 q 631 776 638 744 q 615 848 622 813 q 600 776 608 814 q 585 707 593 745 q 567 632 576 669 l 402 0 l 275 0 l 13 992 l 147 992 l 298 388 q 313 323 306 357 q 325 257 320 290 q 336 192 331 223 q 344 136 341 162 q 352 194 347 161 q 364 264 358 227 q 379 338 371 301 q 396 409 387 376 l 549 992 m 691 1071 l 609 1071 q 557 1118 585 1089 q 503 1175 529 1146 q 456 1233 477 1205 q 424 1278 434 1260 l 424 1293 l 572 1293 q 598 1242 583 1269 q 628 1187 612 1215 q 660 1134 644 1160 q 691 1089 676 1108 l 691 1071 "
  },
  Ť: {
    x_min: 14,
    x_max: 706,
    ha: 721,
    o: "m 423 0 l 297 0 l 297 880 l 14 880 l 14 992 l 706 992 l 706 880 l 423 880 l 423 0 m 587 1274 q 546 1229 570 1255 q 500 1176 523 1203 q 457 1121 477 1148 q 427 1071 437 1094 l 296 1071 q 266 1121 286 1094 q 223 1176 246 1148 q 177 1229 200 1203 q 137 1274 154 1255 l 137 1293 l 219 1293 q 289 1237 253 1270 q 362 1166 325 1204 q 433 1237 397 1204 q 505 1293 470 1270 l 587 1293 l 587 1274 "
  },
  ψ: {
    x_min: 111,
    x_max: 945,
    ha: 1028,
    o: "m 582 1054 l 582 91 q 678 118 634 97 q 754 175 722 138 q 804 264 786 211 q 821 386 821 317 q 818 478 821 434 q 811 564 816 521 q 797 651 805 606 q 778 745 789 695 l 901 745 q 920 651 912 696 q 934 564 928 607 q 942 479 939 521 q 945 390 945 436 q 915 209 945 283 q 837 87 886 134 q 721 16 787 39 q 582 -12 655 -7 l 582 -334 l 459 -334 l 459 -12 q 319 12 383 -9 q 209 80 255 34 q 136 199 162 127 q 111 376 111 272 l 111 745 l 234 745 l 234 372 q 252 242 234 294 q 301 157 271 190 q 373 109 332 124 q 459 90 414 93 l 459 1054 l 582 1054 "
  },
  ŗ: {
    x_min: 65,
    x_max: 526,
    ha: 554,
    o: "m 439 758 q 483 756 459 758 q 526 751 508 754 l 509 637 q 470 643 490 640 q 433 645 450 645 q 355 628 390 645 q 294 578 320 610 q 255 501 269 546 q 241 401 241 456 l 241 0 l 118 0 l 118 745 l 218 745 l 233 608 l 238 608 q 274 664 255 637 q 318 712 294 691 q 372 745 342 732 q 439 758 402 758 m 65 -288 q 81 -246 72 -271 q 98 -191 90 -220 q 112 -135 106 -163 q 121 -85 119 -107 l 244 -85 l 244 -98 q 229 -141 239 -115 q 203 -197 218 -167 q 169 -255 188 -226 q 131 -307 151 -284 l 65 -307 l 65 -288 "
  }
}, cssFontWeight = "normal", ascender = 1290, underlinePosition = -154, cssFontStyle = "normal", boundingBox = {
  yMin: -377,
  xMin: -239.25,
  yMax: 1363,
  xMax: 1555
}, resolution = 1e3, original_font_information = {
  postscript_name: "DroidSans",
  version_string: "Version 1.00 build 107",
  vendor_url: "http://www.ascendercorp.com/",
  full_font_name: "Droid Sans",
  font_family_name: "Droid Sans",
  copyright: "Digitized data copyright © 2006, Google Corporation.",
  description: "Droid Sans is a humanist sans serif typeface designed for user interfaces and electronic communication.",
  trademark: "Droid is a trademark of Google and may be registered in certain jurisdictions.",
  designer: "",
  designer_url: "http://www.ascendercorp.com/typedesigners.html",
  unique_font_identifier: "Ascender - Droid Sans",
  license_url: "http://ascendercorp.com/eula10.html",
  license_description: `This font software is the valuable property of Ascender Corporation and/or its suppliers and its use by you is covered under the terms of a license agreement. This font software is licensed to you by Ascender Corporation for your personal or business use on up to five personal computers. You may not use this font software on more than five personal computers unless you have obtained a license from Ascender to do so. Except as specifically permitted by the license, you may not copy this font software.

If you have any questions, please review the license agreement you received with this font software, and/or contact Ascender Corporation. 

Contact Information:
Ascender Corporation
Web http://www.ascendercorp.com/`,
  manufacturer_name: "Ascender Corporation",
  font_sub_family_name: "Regular"
}, descender = -328, familyName = "Droid Sans", lineHeight = 1617, underlineThickness = 102, DxfTypeface = {
  glyphs,
  cssFontWeight,
  ascender,
  underlinePosition,
  cssFontStyle,
  boundingBox,
  resolution,
  original_font_information,
  descender,
  familyName,
  lineHeight,
  underlineThickness
};
class TextGeometry extends ExtrudeGeometry {
  constructor(e, s = {}) {
    const o = s.font;
    if (o === void 0)
      super();
    else {
      const a = o.generateShapes(e, s.size);
      s.depth = s.height !== void 0 ? s.height : 50, s.bevelThickness === void 0 && (s.bevelThickness = 10), s.bevelSize === void 0 && (s.bevelSize = 8), s.bevelEnabled === void 0 && (s.bevelEnabled = !1), super(a, s);
    }
    this.type = "TextGeometry";
  }
}
let FontLoader$1 = class extends Loader {
  constructor(e) {
    super(e);
  }
  load(e, s, o, a) {
    const l = this, u = new FileLoader$1(this.manager);
    u.setPath(this.path), u.setRequestHeader(this.requestHeader), u.setWithCredentials(this.withCredentials), u.load(e, function(c) {
      const E = l.parse(JSON.parse(c));
      s && s(E);
    }, o, a);
  }
  parse(e) {
    return new Font(e);
  }
};
class Font {
  constructor(e) {
    this.isFont = !0, this.type = "Font", this.data = e;
  }
  generateShapes(e, s = 100) {
    const o = [], a = createPaths(e, s, this.data);
    for (let l = 0, u = a.length; l < u; l++)
      o.push(...a[l].toShapes());
    return o;
  }
}
function createPaths(r, e, s) {
  const o = Array.from(r), a = e / s.resolution, l = (s.boundingBox.yMax - s.boundingBox.yMin + s.underlineThickness) * a, u = [];
  let c = 0, E = 0;
  for (let d = 0; d < o.length; d++) {
    const f = o[d];
    if (f === `
`)
      c = 0, E -= l;
    else {
      const h = createPath(f, a, c, E, s);
      c += h.offsetX, u.push(h.path);
    }
  }
  return u;
}
function createPath(r, e, s, o, a) {
  const l = a.glyphs[r] || a.glyphs["?"];
  if (!l) {
    console.error('THREE.Font: character "' + r + '" does not exists in font family ' + a.familyName + ".");
    return;
  }
  const u = new ShapePath();
  let c, E, d, f, h, S, R, _;
  if (l.o) {
    const m = l._cachedOutline || (l._cachedOutline = l.o.split(" "));
    for (let L = 0, F = m.length; L < F; )
      switch (m[L++]) {
        case "m":
          c = m[L++] * e + s, E = m[L++] * e + o, u.moveTo(c, E);
          break;
        case "l":
          c = m[L++] * e + s, E = m[L++] * e + o, u.lineTo(c, E);
          break;
        case "q":
          d = m[L++] * e + s, f = m[L++] * e + o, h = m[L++] * e + s, S = m[L++] * e + o, u.quadraticCurveTo(h, S, d, f);
          break;
        case "b":
          d = m[L++] * e + s, f = m[L++] * e + o, h = m[L++] * e + s, S = m[L++] * e + o, R = m[L++] * e + s, _ = m[L++] * e + o, u.bezierCurveTo(h, S, R, _, d, f);
          break;
      }
  }
  return { offsetX: l.ha * e, path: u };
}
const spatialReferenceSystems = {
  "EPSG:2000": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      270929.95612930687,
      2.0024083905449142e6,
      302793.2719302293,
      2.0265628621407438e6
    ]
  },
  "EPSG:2001": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      405323.4386632039,
      1.8725668210855026e6,
      441461.1684966317,
      1.9035776402753799e6
    ]
  },
  "EPSG:2002": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      448343.3661899214,
      167354468247419e-8,
      485719.64868305356,
      1.7344806322540229e6
    ]
  },
  "EPSG:2003": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      417419.9219936627,
      1.3196732580127656e6,
      470602.0029772207,
      1.3894079532957277e6
    ]
  },
  "EPSG:2004": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      369072.230700752,
      1.8371956180712671e6,
      391479.35324885894,
      1864825575286414e-9
    ]
  },
  "EPSG:2005": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      302107.5423853528,
      1.8860693610042287e6,
      346913.48425787484,
      1.9301515371673782e6
    ]
  },
  "EPSG:2006": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      494084.22237930703,
      1510007425605348e-9,
      527338.3550395798,
      1.5654465346425069e6
    ]
  },
  "EPSG:2007": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      452142.4408965596,
      1.3860513538369073e6,
      500665.81093109184,
      1.4857030669591816e6
    ]
  },
  "EPSG:2009": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      197712.5526910124,
      5563395053747014e-9,
      400919.1477600282,
      5764587191742931e-9
    ]
  },
  "EPSG:2010": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      191065.83938793317,
      5225385193717233e-9,
      407784.435007561,
      5764724150095397e-9
    ]
  },
  "EPSG:2011": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      192762.8316525321,
      531320701320451e-8,
      387426.9477068279,
      6700932417082549e-9
    ]
  },
  "EPSG:2012": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      191386.38771860278,
      5242059341046785e-9,
      391003.0106197632,
      6542773357820272e-9
    ]
  },
  "EPSG:2013": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      186558.63960851394,
      4986434585624339e-9,
      383902.35038133303,
      6854666991546373e-9
    ]
  },
  "EPSG:2014": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      186517.4891245498,
      4984212188962133e-9,
      382018.95411398535,
      6936002285842994e-9
    ]
  },
  "EPSG:2015": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      187301.82273021474,
      5026438985755411e-9,
      381785.86857240344,
      6946030486989453e-9
    ]
  },
  "EPSG:2016": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      277802.29026838363,
      5120980442038459e-9,
      382225.97915085335,
      6927088432321059e-9
    ]
  },
  "EPSG:2017": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      186496.91932091408,
      498310099339458e-8,
      238546.97155977983,
      5056812089322808e-9
    ]
  },
  "EPSG:2018": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      183753.5363853264,
      4833106499062827e-9,
      420461.9119635035,
      5124237570814416e-9
    ]
  },
  "EPSG:2019": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      181038.60732218676,
      4680924130815978e-9,
      418926.6047611646,
      5244297192268048e-9
    ]
  },
  "EPSG:2020": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      213200.80208008463,
      4614893787394747e-9,
      420986.39040903986,
      5096452431331324e-9
    ]
  },
  "EPSG:2021": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      188613.60959096014,
      5096452431331324e-9,
      400279.2886973716,
      6120808006988622e-9
    ]
  },
  "EPSG:2022": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      188613.60959096014,
      5096452431331324e-9,
      399367.598504493,
      6163104874491744e-9
    ]
  },
  "EPSG:2023": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      191087.18487281067,
      5226496790672485e-9,
      396680.5692804825,
      6286670454193955e-9
    ]
  },
  "EPSG:2024": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      192806.07336816186,
      5315430499097413e-9,
      396192.6825015697,
      6308936755010155e-9
    ]
  },
  "EPSG:2025": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      193000.83116982027,
      5325436276397444e-9,
      400303.22339510603,
      6119694965245194e-9
    ]
  },
  "EPSG:2026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      366640.35762768466,
      5394735487883799e-9,
      404936.7530835757,
      5901572485258575e-9
    ]
  },
  "EPSG:2027": {
    proj4: "+proj=utm +zone=15 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      338966.06341714715,
      53216730483177e-7,
      686110.4779459039,
      6232176104824322e-9
    ]
  },
  "EPSG:2028": {
    proj4: "+proj=utm +zone=16 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      268160.78805427515,
      5110427438069775e-9,
      682705.2597812891,
      6310050360377814e-9
    ]
  },
  "EPSG:2029": {
    proj4: "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      250247.33514047807,
      4617273907461225e-9,
      690111.7429647236,
      613984798761419e-8
    ]
  },
  "EPSG:2030": {
    proj4: "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      257975.62965301747,
      4.8349373396180095e6,
      550105.3204230913,
      512181199402489e-8
    ]
  },
  "EPSG:2031": {
    proj4: "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      588679.9220240426,
      5120027168348256e-9,
      654775.1397800944,
      6927705425233738e-9
    ]
  },
  "EPSG:2032": {
    proj4: "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      263505.8305929514,
      4986001577935528e-9,
      653895.0989006903,
      694663060244584e-8
    ]
  },
  "EPSG:2033": {
    proj4: "+proj=utm +zone=19 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      263588.1636838212,
      4988223309720161e-9,
      658127.2363073531,
      6855347634833782e-9
    ]
  },
  "EPSG:2034": {
    proj4: "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      272605.7248748614,
      5227093097699325e-9,
      665175.288531207,
      6701743484736209e-9
    ]
  },
  "EPSG:2035": {
    proj4: "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      285902.5663358804,
      5564957193285207e-9,
      493136.242470721,
      5761937059178195e-9
    ]
  },
  "EPSG:2039": {
    proj4: "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      119163.57033917059,
      374097.5044487774,
      264756.2074962809,
      798414.8657018573
    ]
  },
  "EPSG:2040": {
    proj4: "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      167240.07550436212,
      544518.9297310134,
      556909.5238510221,
      115621468989142e-8
    ]
  },
  "EPSG:2041": {
    proj4: "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      167240.07550436212,
      544518.9297310134,
      556909.5238510221,
      115621468989142e-8
    ]
  },
  "EPSG:2042": {
    proj4: "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      543277.5628183077,
      474150.18859665544,
      828162.2902521879,
      1.1887261454550028e6
    ]
  },
  "EPSG:2043": {
    proj4: "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      543277.5628183077,
      474150.18859665544,
      828162.2902521879,
      1.1887261454550028e6
    ]
  },
  "EPSG:2044": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      18184831357407123e-9,
      922305.3920718052,
      18806755651703008e-9,
      2.5920738541971724e6
    ]
  },
  "EPSG:2045": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      19171376706238452e-9,
      1.1549959775799832e6,
      19347725998914827e-9,
      2385840920892099e-9
    ]
  },
  "EPSG:2046": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      66566.77965388742,
      2.5612977866707174e6,
      41105.280828077885,
      2.5091555346384184e6
    ]
  },
  "EPSG:2047": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      51341.52794236908,
      3.6639731517422358e6,
      -98337.42125464002,
      3.1021696411172505e6
    ]
  },
  "EPSG:2048": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      92337.12260687677,
      3.8617456017202716e6,
      -98017.40326536167,
      3.1409609017624347e6
    ]
  },
  "EPSG:2049": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      92337.12260687648,
      3.8617456017202716e6,
      -102160.21451244314,
      2739846247483812e-9
    ]
  },
  "EPSG:2050": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      92104.09145680397,
      3.7929543771656463e6,
      -101747.35573579097,
      2795238335653293e-9
    ]
  },
  "EPSG:2051": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      92104.09145680367,
      3.7929543771656463e6,
      -102201.07382381843,
      273430723652643e-8
    ]
  },
  "EPSG:2052": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      92570.2176986904,
      3745254667120244e-9,
      -102586.50769540344,
      2536026772435321e-9
    ]
  },
  "EPSG:2053": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      94357.7898872217,
      3656528533778404e-9,
      -103171.5459594391,
      2.4485347182507594e6
    ]
  },
  "EPSG:2054": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      96076.97872142438,
      3.4735469380844003e6,
      -105168.1539512989,
      2458515498024216e-9
    ]
  },
  "EPSG:2055": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      102372.9506626046,
      3203073152182701e-9,
      4971.494332427702,
      2965470882780678e-9
    ]
  },
  "EPSG:2056": {
    proj4: "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2485014011782823e-9,
      1.0752141686203242e6,
      2.8284139350080597e6,
      1.2997827670088513e6
    ]
  },
  "EPSG:2057": {
    proj4: "+proj=omerc +lat_0=27.5188288055556 +lonc=52.6035391666667 +alpha=0.571661194444444 +gamma=0.571661194444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      648136.9873080353,
      3030699040874187e-9,
      668885.9373666034,
      3055075773565207e-9
    ]
  },
  "EPSG:2058": {
    proj4: "+proj=utm +zone=38 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      407382.17223639676,
      3.4289480545879127e6,
      756932.1247370132,
      4407721075766407e-9
    ]
  },
  "EPSG:2059": {
    proj4: "+proj=utm +zone=39 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      198332.50833979936,
      2.8204283870873745e6,
      757192.5227262236,
      4399949921679461e-9
    ]
  },
  "EPSG:2060": {
    proj4: "+proj=utm +zone=40 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197958.85053302674,
      2803803403127545e-9,
      762391.2221693802,
      4242321285938624e-9
    ]
  },
  "EPSG:2061": {
    proj4: "+proj=utm +zone=41 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197217.73955993517,
      2770554174734913e-9,
      530229.4702756623,
      4.1016494181327196e6
    ]
  },
  "EPSG:2062": {
    proj4: "+proj=lcc +lat_1=40 +lat_0=40 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000 +a=6378298.3 +rf=294.73 +pm=-3.687375 +units=m +no_defs +type=crs",
    projected_bounds: [
      86996.5756094206,
      166996.33473225706,
      1.1693971520236381e6,
      1.0467217622999799e6
    ]
  },
  "EPSG:2065": {
    proj4: "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=42.5 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2763191515697467e6,
      951555.937880166,
      983087.5480082307,
      159523.53474958125
    ]
  },
  "EPSG:2066": {
    proj4: "+proj=cass +lat_0=11.2521786111111 +lon_0=-60.6860088888889 +x_0=37718.66159325 +y_0=36209.91512952 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.201166195164 +no_defs +type=crs",
    projected_bounds: [
      71273.47278005749,
      85371.12503918163,
      320964.644492222,
      266834.0768053727
    ]
  },
  "EPSG:2067": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      611800.8693022823,
      1.1044919840408617e6,
      735014.0000512095,
      1.2057702230927942e6
    ]
  },
  "EPSG:2068": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      231198.4452718011,
      2.8068346253131772e6,
      296965.76088539045,
      3.3745788212967347e6
    ]
  },
  "EPSG:2069": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97869.07883155135,
      2601148574709198e-9,
      293206.637665178,
      3678390851374029e-9
    ]
  },
  "EPSG:2070": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97329.37908727085,
      2.5225169410772594e6,
      293386.57444407465,
      3.6595369312844733e6
    ]
  },
  "EPSG:2071": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97187.6161663412,
      2.5014758354332065e6,
      293670.6639599114,
      3629593499539256e-9
    ]
  },
  "EPSG:2072": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97113.45690695361,
      2.4904017642132915e6,
      296112.21068426786,
      3.4688162562759365e6
    ]
  },
  "EPSG:2073": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      96410.36431427632,
      2.3829901462423485e6,
      294315.12667796377,
      3560839263181057e-9
    ]
  },
  "EPSG:2074": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95716.51581274923,
      2.2722692378593925e6,
      293449.8850971139,
      3652882726276019e-9
    ]
  },
  "EPSG:2075": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95028.50117697679,
      2157132665911656e-9,
      293481.5019523626,
      3.6495556471651453e6
    ]
  },
  "EPSG:2076": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95348.38179109046,
      2.2113780662812362e6,
      219810.08350787038,
      3.5582027116243634e6
    ]
  },
  "EPSG:2077": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      531650.0892688019,
      2.6000468578690276e6,
      779581.7167072997,
      368085487575646e-8
    ]
  },
  "EPSG:2078": {
    proj4: "+proj=utm +zone=33 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      191343.7477416353,
      2492406463906521e-9,
      781056.1648385271,
      3662024058943863e-9
    ]
  },
  "EPSG:2079": {
    proj4: "+proj=utm +zone=34 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      184029.40584218432,
      2158952027706404e-9,
      780312.2005100151,
      3655341787129566e-9
    ]
  },
  "EPSG:2080": {
    proj4: "+proj=utm +zone=35 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      186040.95039987098,
      2.2132141184456204e6,
      331181.44666762615,
      3558519392449182e-9
    ]
  },
  "EPSG:2081": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.3776885257377457e6,
      5192823838573829e-9,
      2642837381755413e-9,
      6469367571685745e-9
    ]
  },
  "EPSG:2082": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.3932138605253347e6,
      4422433006547288e-9,
      2.6241472578958054e6,
      5295033993118764e-9
    ]
  },
  "EPSG:2083": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.5230962251322465e6,
      3.9159986810639375e6,
      2601659094293887e-9,
      4.1721143250466194e6
    ]
  },
  "EPSG:2084": {
    proj4: "+proj=utm +zone=19 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      524544.3872746612,
      3948408753170098e-9,
      707542.1354917262,
      4273507473727035e-9
    ]
  },
  "EPSG:2087": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      223455.56317945477,
      2502877527651402e-9,
      779581.7167072995,
      368085487575646e-8
    ]
  },
  "EPSG:2088": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      202673.2733362199,
      3679938072950124e-9,
      733136.1930896889,
      4254386518105749e-9
    ]
  },
  "EPSG:2089": {
    proj4: "+proj=utm +zone=38 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      172775.81641768105,
      1.2807251449628044e6,
      818855.7943057276,
      1987236647534176e-9
    ]
  },
  "EPSG:2090": {
    proj4: "+proj=utm +zone=39 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      170532.2322524247,
      1.0460206925068045e6,
      816917.8376070575,
      2.1035394217415433e6
    ]
  },
  "EPSG:2093": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      443924.4053971424,
      998625.3550280435,
      672674.3556609205,
      1221368448928832e-9
    ]
  },
  "EPSG:2094": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      559509.844355032,
      883231.0950321336,
      937083.619661679,
      1.2355187289507461e6
    ]
  },
  "EPSG:2095": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      306517.6738931922,
      1202182724018616e-9,
      647679.6796479973,
      1.4032556889765337e6
    ]
  },
  "EPSG:2096": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      108158.31654931026,
      111012.86615429865,
      256584.86023692688,
      571234.4211525712
    ]
  },
  "EPSG:2097": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      107581.16537482892,
      52224.72096609819,
      287427.9682594175,
      537099.1393462556
    ]
  },
  "EPSG:2098": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      156579.05228842917,
      55201.038919837854,
      287775.2982135481,
      504911.4331100837
    ]
  },
  "EPSG:2099": {
    proj4: "+proj=cass +lat_0=25.3823611111111 +lon_0=50.7613888888889 +x_0=100000 +y_0=100000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      92767.18843813198,
      7798.261909035937,
      191813.08712804754,
      190907.91227344956
    ]
  },
  "EPSG:2100": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      95025.32184528175,
      3.8686992204557727e6,
      857544.6954534401,
      4630962493401705e-9
    ]
  },
  "EPSG:2101": {
    proj4: "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=0 +y_0=-52684.972 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -70652.71800295515,
      -71049.81384055778,
      11544.383085960157,
      39497.73780645125
    ]
  },
  "EPSG:2102": {
    proj4: "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=200000 +y_0=147315.028 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      129347.28199704485,
      128950.18615944221,
      211544.38308596014,
      239497.73780645124
    ]
  },
  "EPSG:2103": {
    proj4: "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=500000 +y_0=447315.028 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      429347.28199704486,
      428950.18615944224,
      511544.3830859602,
      539497.7378064513
    ]
  },
  "EPSG:2104": {
    proj4: "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=-17044 +y_0=-23139.97 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5463.6249032670075,
      -41573.05632807437,
      30643.236982196853,
      14868.83569271661
    ]
  },
  "EPSG:2105": {
    proj4: "+proj=tmerc +lat_0=-36.8797222222222 +lon_0=174.764166666667 +k=0.9999 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      159722.08670653088,
      559909.3774744014,
      525103.2634924628,
      1.1075483999035982e6
    ]
  },
  "EPSG:2106": {
    proj4: "+proj=tmerc +lat_0=-37.7611111111111 +lon_0=176.466111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      338079.21376455604,
      647802.365562084,
      467799.17150354164,
      859782.832964711
    ]
  },
  "EPSG:2107": {
    proj4: "+proj=tmerc +lat_0=-38.6244444444444 +lon_0=177.885555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      299953.3466348467,
      753232.723456258,
      465837.09328845923,
      925660.2522529426
    ]
  },
  "EPSG:2108": {
    proj4: "+proj=tmerc +lat_0=-39.6508333333333 +lon_0=176.673611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      326022.51983114006,
      697571.8959503456,
      521187.7630184046,
      885761.6182345663
    ]
  },
  "EPSG:2109": {
    proj4: "+proj=tmerc +lat_0=-39.1355555555556 +lon_0=174.227777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      353073.24108547176,
      728307.5162985184,
      505893.3623461356,
      880958.9274278634
    ]
  },
  "EPSG:2110": {
    proj4: "+proj=tmerc +lat_0=-39.5122222222222 +lon_0=175.64 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      334676.29712235124,
      795529.8210856072,
      459881.75185913715,
      871072.669778655
    ]
  },
  "EPSG:2111": {
    proj4: "+proj=tmerc +lat_0=-40.2419444444444 +lon_0=175.488055555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      308413.96593510796,
      718581.9100282267,
      467296.6569444586,
      886528.8186018829
    ]
  },
  "EPSG:2112": {
    proj4: "+proj=tmerc +lat_0=-40.9252777777778 +lon_0=175.647222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      346933.63235053845,
      717095.204403778,
      476765.08945602295,
      870154.1702578864
    ]
  },
  "EPSG:2113": {
    proj4: "+proj=tmerc +lat_0=-41.3011111111111 +lon_0=174.776388888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      378592.5012313212,
      777879.3322444925,
      449169.08215060213,
      843271.2217299109
    ]
  },
  "EPSG:2114": {
    proj4: "+proj=tmerc +lat_0=-40.7147222222222 +lon_0=172.671944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      357070.9203976522,
      743760.8654153575,
      438862.9830909714,
      830405.9677569862
    ]
  },
  "EPSG:2115": {
    proj4: "+proj=tmerc +lat_0=-41.2744444444444 +lon_0=173.299166666667 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      325713.3677744962,
      699030.3463818699,
      466032.29725026665,
      867942.886591709
    ]
  },
  "EPSG:2116": {
    proj4: "+proj=tmerc +lat_0=-41.2897222222222 +lon_0=172.108888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      387566.43428381847,
      777746.1568661178,
      449920.81510657514,
      859770.372847304
    ]
  },
  "EPSG:2117": {
    proj4: "+proj=tmerc +lat_0=-41.8105555555556 +lon_0=171.581111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374301.01455101045,
      757806.9991322052,
      469294.4575959161,
      843045.7559681997
    ]
  },
  "EPSG:2118": {
    proj4: "+proj=tmerc +lat_0=-42.3336111111111 +lon_0=171.549722222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      367269.15081990097,
      754779.3245131352,
      500219.50421288615,
      891894.9462404557
    ]
  },
  "EPSG:2119": {
    proj4: "+proj=tmerc +lat_0=-42.6888888888889 +lon_0=173.01 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      307783.59031107766,
      770373.729781629,
      444676.381604188,
      866383.9667833812
    ]
  },
  "EPSG:2120": {
    proj4: "+proj=tmerc +lat_0=-41.5444444444444 +lon_0=173.801944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      330138.41655190097,
      676848.3099814288,
      455491.1325367,
      876914.982130751
    ]
  },
  "EPSG:2121": {
    proj4: "+proj=tmerc +lat_0=-42.8861111111111 +lon_0=170.979722222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352093.17305216426,
      761627.1859796605,
      474931.4379266977,
      852487.7632893431
    ]
  },
  "EPSG:2122": {
    proj4: "+proj=tmerc +lat_0=-43.11 +lon_0=170.260833333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      315504.4092320163,
      717247.6269372113,
      451302.9327729296,
      812028.2098750061
    ]
  },
  "EPSG:2123": {
    proj4: "+proj=tmerc +lat_0=-43.9777777777778 +lon_0=168.606111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      353307.21867613454,
      752917.2857969411,
      513223.35076644196,
      833238.9059669231
    ]
  },
  "EPSG:2124": {
    proj4: "+proj=tmerc +lat_0=-43.5905555555556 +lon_0=172.726944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      270223.2895135086,
      757680.498605363,
      453517.79846628115,
      899840.8417026715
    ]
  },
  "EPSG:2125": {
    proj4: "+proj=tmerc +lat_0=-43.7486111111111 +lon_0=171.360555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345644.9158724317,
      744064.3017716812,
      473186.9629972589,
      868335.7532531273
    ]
  },
  "EPSG:2126": {
    proj4: "+proj=tmerc +lat_0=-44.4019444444444 +lon_0=171.057222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      302414.9945174688,
      735018.3392760918,
      439952.7849338846,
      916763.4199339706
    ]
  },
  "EPSG:2127": {
    proj4: "+proj=tmerc +lat_0=-44.735 +lon_0=169.4675 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      333643.91642146546,
      725747.0452051756,
      462260.364190622,
      913604.4649830614
    ]
  },
  "EPSG:2128": {
    proj4: "+proj=tmerc +lat_0=-45.1327777777778 +lon_0=168.398611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      347036.25624071,
      750072.2608976156,
      456779.18172295997,
      893408.4946720286
    ]
  },
  "EPSG:2129": {
    proj4: "+proj=tmerc +lat_0=-45.5636111111111 +lon_0=167.738611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      294615.3468619585,
      713905.1588297703,
      437470.130470534,
      914759.8894913999
    ]
  },
  "EPSG:2130": {
    proj4: "+proj=tmerc +lat_0=-45.8161111111111 +lon_0=170.628333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      333295.46372098586,
      799209.4253714177,
      448554.04269600223,
      933860.2795169557
    ]
  },
  "EPSG:2131": {
    proj4: "+proj=tmerc +lat_0=-45.8613888888889 +lon_0=170.2825 +k=0.99996 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      274456.14875960926,
      702141.1385203155,
      446134.9637561002,
      870003.3710792353
    ]
  },
  "EPSG:2132": {
    proj4: "+proj=tmerc +lat_0=-46.6 +lon_0=168.342777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      320424.62767151266,
      718308.2173642612,
      449169.7724037481,
      940969.9021003912
    ]
  },
  "EPSG:2133": {
    proj4: "+proj=utm +zone=58 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      312397.25996348116,
      3802095008515806e-9,
      757292.3897059488,
      5603455638276808e-9
    ]
  },
  "EPSG:2134": {
    proj4: "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      312686.9741450035,
      3795420663662715e-9,
      787116.5064302344,
      6590930361670781e-9
    ]
  },
  "EPSG:2135": {
    proj4: "+proj=utm +zone=60 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      304891.08757719095,
      3976723319445407e-9,
      799240.5259482102,
      7074314596293032e-9
    ]
  },
  "EPSG:2136": {
    proj4: "+proj=tmerc +lat_0=4.66666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.739163358 +y_0=0 +a=6378300 +rf=296 +to_meter=0.304799710181509 +no_defs +type=crs",
    projected_bounds: [
      80935.44972511052,
      2518.8812058425665,
      1.6991533707749667e6,
      2.3584688366106814e6
    ]
  },
  "EPSG:2137": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-1 +k=0.9996 +x_0=500000 +y_0=0 +a=6378300 +rf=296 +units=m +no_defs +type=crs",
    projected_bounds: [
      189503.5538593328,
      154923.20394994208,
      843211.2826925986,
      670800.9606095343
    ]
  },
  "EPSG:2138": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893301.7678677401,
      181373.05721489427,
      586983.1793314099,
      211281228483975e-8
    ]
  },
  "EPSG:2154": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -378305.8099675195,
      6093283211317765e-9,
      1212610742309418e-9,
      7186901681865061e-9
    ]
  },
  "EPSG:2157": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      421849.8127984968,
      518361.28220504196,
      768347.2762717761,
      968015.3873916555
    ]
  },
  "EPSG:2158": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      391458.60817856144,
      569435058468557e-8,
      731558.2768218241,
      6148736506844529e-9
    ]
  },
  "EPSG:2159": {
    proj4: "+proj=tmerc +lat_0=6.66666666666667 +lon_0=-12 +k=1 +x_0=152399.855090754 +y_0=0 +a=6378300 +rf=296 +to_meter=0.304799710181509 +no_defs +type=crs",
    projected_bounds: [
      15664.392656381155,
      600698.8819738255,
      91819.62219669494,
      683932.4018315859
    ]
  },
  "EPSG:2160": {
    proj4: "+proj=tmerc +lat_0=6.66666666666667 +lon_0=-12 +k=1 +x_0=243839.768145207 +y_0=182879.826108905 +a=6378300 +rf=296 +to_meter=0.304799710181509 +no_defs +type=crs",
    projected_bounds: [
      315664.3926563822,
      1.2006988819738242e6,
      391819.62219669594,
      1.2839324018315845e6
    ]
  },
  "EPSG:2161": {
    proj4: "+proj=utm +zone=28 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      682213.3099009001,
      790585.2628951559,
      828995.3421957258,
      1.1001668608773318e6
    ]
  },
  "EPSG:2162": {
    proj4: "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      168408.70082324778,
      761454.352119665,
      361896.47210375353,
      1.1055760249082274e6
    ]
  },
  "EPSG:2164": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      216194.22230798187,
      112842.84589660096,
      709494.5961837969,
      573926.6295109327
    ]
  },
  "EPSG:2165": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      216194.22230798187,
      112842.84589660096,
      709494.5961837969,
      573926.6295109327
    ]
  },
  "EPSG:2169": {
    proj4: "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      48329.25647256348,
      56342.79017840069,
      105947.85849765247,
      139736.40264725967
    ]
  },
  "EPSG:2172": {
    proj4: "+proj=sterea +lat_0=53.0019444444444 +lon_0=21.5027777777778 +k=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4428579112825773e-9,
      5622992322910131e-9,
      4761485967852209e-9,
      5976556558323002e-9
    ]
  },
  "EPSG:2173": {
    proj4: "+proj=sterea +lat_0=53.5833333333333 +lon_0=17.0083333333333 +k=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3047545904275803e6,
      5844544426477845e-9,
      3.6929196844658726e6,
      6148490830248254e-9
    ]
  },
  "EPSG:2174": {
    proj4: "+proj=sterea +lat_0=51.6708333333333 +lon_0=16.6722222222222 +k=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3519148372629127e-9,
      5376432241435382e-9,
      3864028185164152e-9,
      5815415170229434e-9
    ]
  },
  "EPSG:2175": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.9583333333333 +k=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      191383.91603765805,
      773194.0156725077,
      286591.0506782434,
      990154.9769965131
    ]
  },
  "EPSG:2176": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5438679954042289e-9,
      5569692263086982e-9,
      5595142645542588e-9,
      6136746812857672e-9
    ]
  },
  "EPSG:2177": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6391112088834764e-9,
      5473661653540782e-9,
      6593747046274156e-9,
      6201308275430432e-9
    ]
  },
  "EPSG:2178": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7390450406876147e-9,
      5440301581136983e-9,
      7597051412098972e-9,
      6047705957969969e-9
    ]
  },
  "EPSG:2179": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8390252491822466e-9,
      5430293875972978e-9,
      850973870368214e-8,
      6031098580414013e-9
    ]
  },
  "EPSG:2180": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      144693.2803694181,
      137212.44215662032,
      821516.4770167258,
      908411.1932242764
    ]
  },
  "EPSG:2188": {
    proj4: "+proj=utm +zone=25 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      643143.7876827708,
      4351456063496282e-9,
      669591.7477979186,
      4404180117411035e-9
    ]
  },
  "EPSG:2189": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      333898.0006933059,
      4.2430993868726175e6,
      502592.74225173006,
      4332386361786783e-9
    ]
  },
  "EPSG:2190": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      596263.3900096521,
      4081062012849771e-9,
      709095.2114175938,
      4204118742699012e-9
    ]
  },
  "EPSG:2193": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0991539260851431e6,
      4736810692701401e-9,
      2.1196206610291996e6,
      6212415674931265e-9
    ]
  },
  "EPSG:2195": {
    proj4: "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      512925.15731334634,
      8387017607775072e-9,
      814222.9665084919,
      8438161672488501e-9
    ]
  },
  "EPSG:2196": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      103231.08034568946,
      6061225046149768e-9,
      306424.5456331773,
      6410093957739449e-9
    ]
  },
  "EPSG:2197": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      421632.14308493,
      6043055675060914e-9,
      542166.1990547928,
      6296426314720093e-9
    ]
  },
  "EPSG:2198": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      873723.3447364616,
      6090627891698857e-9,
      915846.9595696031,
      6139563033293629e-9
    ]
  },
  "EPSG:2200": {
    proj4: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=300000 +y_0=800000 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      97385.342224488,
      587601.3112874171,
      508663.0975820464,
      978289.6474101938
    ]
  },
  "EPSG:2201": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      678946.3228169603,
      776269.0402757725,
      828257.3513757389,
      1286272451209455e-9
    ]
  },
  "EPSG:2202": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166048.41869024694,
      80798.44367946054,
      821669.5980448748,
      1.7313866614760826e6
    ]
  },
  "EPSG:2203": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166042.17725734005,
      70836.98526620852,
      931964.6290044868,
      1856304259555879e-9
    ]
  },
  "EPSG:2204": {
    proj4: "+proj=lcc +lat_0=34.6666666666667 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=609601.219202438 +y_0=30480.0609601219 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      709174.7596897599,
      242441.9692081677,
      3275279794317624e-9,
      861190.3428329674
    ]
  },
  "EPSG:2205": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      349218.2791870525,
      24709.163041468903,
      653864.4011060491,
      184641.09895005127
    ]
  },
  "EPSG:2206": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      9376355267334206e-9,
      4041975666212052e-9,
      962406900744415e-8,
      4.6650269910503095e6
    ]
  },
  "EPSG:2207": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1036484622423385e-8,
      3993305876653603e-9,
      10625328793682108e-9,
      4592827100452076e-9
    ]
  },
  "EPSG:2208": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      11364692441565853e-9,
      3983318220721068e-9,
      11624146997754773e-9,
      4660583699234411e-9
    ]
  },
  "EPSG:2209": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      12364419876672981e-9,
      3.9655627347394614e6,
      1262399095636238e-8,
      4669470311958777e-9
    ]
  },
  "EPSG:2210": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      13365879966794476e-9,
      4059893850463856e-9,
      13625847334639035e-9,
      4562838630020543e-9
    ]
  },
  "EPSG:2211": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      14366507297827693e-9,
      4.0998496523980116e6,
      14625058819042286e-9,
      460837719801983e-8
    ]
  },
  "EPSG:2212": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      15366419851942373e-9,
      4094300099681896e-9,
      15485700689853678e-9,
      4542887490109834e-9
    ]
  },
  "EPSG:2213": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      389942.3185842265,
      4810576150470277e-9,
      610742.2139930581,
      5006135239818186e-9
    ]
  },
  "EPSG:2215": {
    proj4: "+proj=utm +zone=32 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      438839.9410718031,
      238735.0924551155,
      655216.5479336417,
      551673.2279033428
    ]
  },
  "EPSG:2216": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      335889.307209132,
      6725480212141092e-9,
      597589.8587712229,
      8108725397652661e-9
    ]
  },
  "EPSG:2217": {
    proj4: "+proj=utm +zone=23 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      331385.20572302607,
      6626424612764263e-9,
      629666.588140707,
      6882395151493401e-9
    ]
  },
  "EPSG:2219": {
    proj4: "+proj=utm +zone=19 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      4831888164992779e-9,
      723472.7072893906,
      5328433235436496e-9
    ]
  },
  "EPSG:2220": {
    proj4: "+proj=utm +zone=20 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      257100.82377739056,
      4810716831936432e-9,
      744007.8409535226,
      5.3192512241647625e6
    ]
  },
  "EPSG:2222": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "EPSG:2223": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "EPSG:2224": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2229279364,
      383550.2956986203,
      1.0591843756185349e6,
      2185694073289227e-9
    ]
  },
  "EPSG:2225": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061538175e-9,
      1743578655997185e-9,
      7107948036431532e-9,
      2621858229560954e-9
    ]
  },
  "EPSG:2226": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695585834e-9,
      1.7758289912692206e6,
      7249234998005839e-9,
      2557837815660115e-9
    ]
  },
  "EPSG:2227": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5823176279241634e-9,
      1.7341078745824352e6,
      7323536053585911e-9,
      2456022576740115e-9
    ]
  },
  "EPSG:2228": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532745296e-9,
      1.8170183934613287e6,
      7541064059406428e-9,
      2.4755949233672824e6
    ]
  },
  "EPSG:2229": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907499317929e-9,
      1.3889622129240783e6,
      7711985335332574e-9,
      2.5033539392974693e6
    ]
  },
  "EPSG:2230": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324927474e-9,
      1.7779544793630175e6,
      711581051154454e-8,
      2.3414823256298574e6
    ]
  },
  "EPSG:2231": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881830670196e6,
      1.1027147224423632e6,
      3.9547319487911398e6,
      1.6294292262439965e6
    ]
  },
  "EPSG:2232": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755545300983e6,
      1.1317506265283525e6,
      3.9679384194670366e6,
      1.8403627655659935e6
    ]
  },
  "EPSG:2233": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9602860992269719e6,
      1.1339074161224284e6,
      3.9875972708977414e6,
      1.7514299533442387e6
    ]
  },
  "EPSG:2234": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113992947,
      554973.7807348338,
      1.2634591601046422e6,
      944805.9744306704
    ]
  },
  "EPSG:2235": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.5484832405,
      160464.3815257733,
      781579.1360700305,
      674114.4099112981
    ]
  },
  "EPSG:2236": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.61022244688,
      29981.8801461913,
      979460.662179514,
      2363281056551985e-9
    ]
  },
  "EPSG:2237": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.82954406223,
      706098.4749466283,
      932656.8409836462,
      1.9155034706385157e6
    ]
  },
  "EPSG:2238": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "EPSG:2239": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.36742384572,
      133281.58971744485,
      1.0760648463948576e6,
      1705427168185772e-9
    ]
  },
  "EPSG:2240": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772960456433e6,
      228387.93674624796,
      2648926914067581e-9,
      1.8246882200295548e6
    ]
  },
  "EPSG:2241": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.5530599571,
      119645.62784245881,
      948865.9582228954,
      1.1258115973909926e6
    ]
  },
  "EPSG:2242": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1287011305489751e-9,
      120499.55212947368,
      1.9776769335287954e6,
      1472936186843373e-9
    ]
  },
  "EPSG:2243": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2219614274047403e-9,
      121339.35700592819,
      2.9678622998676198e6,
      2.6806285919257025e6
    ]
  },
  "EPSG:2246": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269712995207e6,
      81066.64574521924,
      2145220122962096e-9,
      605776.6721386266
    ]
  },
  "EPSG:2247": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83662030625,
      1.7201585409581168e6,
      2.7326679393377476e6,
      2331135994555516e-9
    ]
  },
  "EPSG:2248": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6544428327,
      120261.76452802098,
      1.8832856601052207e6,
      757830.009017196
    ]
  },
  "EPSG:2249": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86729421368,
      2.6346779313810905e6,
      1095674268683903e-9,
      3.1535976510802875e6
    ]
  },
  "EPSG:2250": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5275684954588155e6,
      69495.24782569606,
      1.8074913108940115e6,
      186415.18831819796
    ]
  },
  "EPSG:2251": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      25363418888951235e-9,
      127241.77155271676,
      2711310000589763e-8,
      1.3093914233873296e6
    ]
  },
  "EPSG:2252": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901533205e-9,
      188024.34626186846,
      20218635176379602e-9,
      956036.5511824941
    ]
  },
  "EPSG:2253": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498039389e-9,
      82266.70251847472,
      13709781320390796e-9,
      999144.9583176089
    ]
  },
  "EPSG:2254": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "EPSG:2255": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1884030919468199e-9,
      547967.9321047692,
      2585058044938464e-9,
      2005923102561951e-9
    ]
  },
  "EPSG:2256": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497126905,
      108545.02663791207,
      3.2779430675884755e6,
      1781155686491397e-9
    ]
  },
  "EPSG:2257": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84118137152,
      366496.4069528699,
      933608.7763713576,
      2.1860840758552696e6
    ]
  },
  "EPSG:2258": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234895707152e6,
      286838.0024767893,
      2.0521528247102818e6,
      2.1863457693688734e6
    ]
  },
  "EPSG:2259": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2340084161100859e-9,
      122160.72241634964,
      3.1650115939820465e6,
      2186845615586309e-9
    ]
  },
  "EPSG:2260": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "EPSG:2261": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37071982364,
      727169.7435368465,
      1223494718072112e-9,
      1610820417709873e-9
    ]
  },
  "EPSG:2262": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6801707726,
      727244.453797864,
      1.4721244650838003e6,
      1328725000767546e-9
    ]
  },
  "EPSG:2263": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.870781804,
      1.5887138859583358e6,
      420506.5270969149
    ]
  },
  "EPSG:2264": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "EPSG:2265": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592824906e6,
      75307.10902631191,
      2849091059938587e-9,
      754225.2387347483
    ]
  },
  "EPSG:2266": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      106540706736943e-8,
      116445.58968075218,
      2938446300794301e-9,
      813394.0983347377
    ]
  },
  "EPSG:2267": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.48223499593,
      3.0136582731721397e6,
      750989.2504948481
    ]
  },
  "EPSG:2268": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3033092255522582e-9,
      832905.3202086495
    ]
  },
  "EPSG:2269": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:2270": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:2271": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2.7905844426662596e6,
      875632.1554836772
    ]
  },
  "EPSG:2272": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.847010236,
      2802472178387044e-9,
      687058.9427278236
    ]
  },
  "EPSG:2273": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "EPSG:2274": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3.2437979306370523e6,
      882581.6584900919
    ]
  },
  "EPSG:2275": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.14716290752,
      3.3936042030115686e6,
      1.1000285612285445e6,
      4.1941994715287737e6
    ]
  },
  "EPSG:2276": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980025016344e-9,
      3323001743114402e-9,
      7650725432965473e-9
    ]
  },
  "EPSG:2277": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5689827447,
      9940788826055452e-9,
      4407735767408789e-9,
      10854275232265161e-9
    ]
  },
  "EPSG:2278": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.767031274747,
      13153708000668947e-9,
      3.6156651831929674e6,
      14191752320645498e-9
    ]
  },
  "EPSG:2279": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062632026e-9,
      1.5157309066701222e6,
      17332185274254806e-9
    ]
  },
  "EPSG:2280": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      934625.2194864015,
      3.3700951715373998e6,
      2.3089332074950845e6,
      3.9012110411944846e6
    ]
  },
  "EPSG:2281": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      910491.0889545543,
      6629153124161247e-9,
      2.3186484211643036e6,
      7571527831670606e-9
    ]
  },
  "EPSG:2282": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      895695.7755898271,
      9970406834938742e-9,
      2343636976743468e-9,
      10548488685409209e-9
    ]
  },
  "EPSG:2283": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703824143e-8,
      660312897188164e-8,
      1204479558507679e-8,
      7220874862534711e-9
    ]
  },
  "EPSG:2284": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002990512e-9,
      3397821737396317e-9,
      12398544508659353e-9,
      4.0051171085510924e6
    ]
  },
  "EPSG:2285": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9679273608,
      54521.95757222446,
      2554640134365972e-9,
      770489.672684708
    ]
  },
  "EPSG:2286": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9196607294,
      100068.83787833528,
      2525733221089436e-9,
      850434.0872122366
    ]
  },
  "EPSG:2287": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "EPSG:2288": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205946,
      2.9246965143188736e6,
      739108.438997525
    ]
  },
  "EPSG:2289": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.67995732513,
      2766498039939692e-9,
      863858.9966404126
    ]
  },
  "EPSG:2290": {
    proj4: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=700000 +y_0=400000 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      584369.9350988589,
      251028.99178997765,
      783512.2250754624,
      382801.629446525
    ]
  },
  "EPSG:2294": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=4500000 +y_0=0 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      4381003229198036e-9,
      4945536761075708e-9,
      4634403041476005e-9,
      5217137978904729e-9
    ]
  },
  "EPSG:2295": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=5500000 +y_0=0 +a=6378135 +rf=298.257 +units=m +no_defs +type=crs",
    projected_bounds: [
      5355838993485266e-9,
      480932633678804e-8,
      5616140972423896e-9,
      5098891600067531e-9
    ]
  },
  "EPSG:2308": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=109 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      143016.81396782963,
      9237276261794977e-9,
      612098.9465827303,
      9550108135948988e-9
    ]
  },
  "EPSG:2309": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=116 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      147592.67085210973,
      906339892300425e-8,
      611608.0154598382,
      9248243864371838e-9
    ]
  },
  "EPSG:2310": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      487775.74960437405,
      9675038200143669e-9,
      702435.731040925,
      978214439356269e-8
    ]
  },
  "EPSG:2311": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      128337.38333144627,
      212581.74370278817,
      775455.2001039207,
      705876.3237062612
    ]
  },
  "EPSG:2312": {
    proj4: "+proj=utm +zone=33 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      269076.21853213967,
      986574.320958011,
      411188.0731372251,
      1.0910479721904236e6
    ]
  },
  "EPSG:2313": {
    proj4: "+proj=utm +zone=33 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      409543.5568997682,
      1293397003919729e-9,
      509768.83326132165,
      1.4115763171350542e6
    ]
  },
  "EPSG:2314": {
    proj4: "+proj=cass +lat_0=10.4416666666667 +lon_0=-61.3333333333333 +x_0=86501.46392052 +y_0=65379.0134283 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs +type=crs",
    projected_bounds: [
      11470.496695430033,
      -7148.403837207892,
      761047.8021235393,
      603295.2245893767
    ]
  },
  "EPSG:2315": {
    proj4: "+proj=utm +zone=19 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      524544.3872746612,
      3948408753170098e-9,
      707542.1354917262,
      4273507473727035e-9
    ]
  },
  "EPSG:2316": {
    proj4: "+proj=utm +zone=20 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      307780.87049041846,
      3.9087455391850667e6,
      605136.4335193969,
      4308941152707579e-9
    ]
  },
  "EPSG:2317": {
    proj4: "+proj=lcc +lat_0=6 +lon_0=-66 +lat_1=9 +lat_2=3 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      176053.1898571403,
      412788.7276860572,
      1.6776756178007093e6,
      1.6955383468387574e6
    ]
  },
  "EPSG:2318": {
    proj4: "+proj=lcc +lat_0=25.08951 +lon_0=48 +lat_1=17 +lat_2=33 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.4411213418747021e6,
      -887676.536998516,
      721712.2038119116,
      798539.2017411744
    ]
  },
  "EPSG:2319": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      376355.2673342066,
      4041975666212052e-9,
      624069.0074441498,
      4.6650269910503095e6
    ]
  },
  "EPSG:2320": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      364846.22423385107,
      3993305876653603e-9,
      625328.7936821077,
      4592827100452076e-9
    ]
  },
  "EPSG:2321": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      364692.4415658534,
      3983318220721068e-9,
      624146.9977547731,
      4660583699234411e-9
    ]
  },
  "EPSG:2322": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      364419.87667298166,
      3.9655627347394614e6,
      623990.9563623789,
      4669470311958777e-9
    ]
  },
  "EPSG:2323": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      365879.96679447556,
      4059893850463856e-9,
      625847.3346390356,
      4562838630020543e-9
    ]
  },
  "EPSG:2324": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      366507.2978276927,
      4.0998496523980116e6,
      625058.8190422861,
      460837719801983e-8
    ]
  },
  "EPSG:2325": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      366419.8519423738,
      4094300099681896e-9,
      485700.68985367846,
      4542887490109834e-9
    ]
  },
  "EPSG:2326": {
    proj4: "+proj=tmerc +lat_0=22.3121333333333 +lon_0=114.178555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      793510.5441972517,
      798960.6585465458,
      870780.3431383321,
      848770.737603157
    ]
  },
  "EPSG:2327": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      13374665346331367e-9,
      3922066271229741e-9,
      13752995032201746e-9,
      4552717342266815e-9
    ]
  },
  "EPSG:2328": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      14206116693886297e-9,
      3230780813217304e-9,
      14727179143644013e-9,
      5237187189365182e-9
    ]
  },
  "EPSG:2329": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      15203003585037896e-9,
      3.0266603366292384e6,
      15718708909028454e-9,
      5453983173957889e-9
    ]
  },
  "EPSG:2330": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      16204050756442944e-9,
      3069911112839626e-9,
      16725045803950109e-9,
      5311699123989046e-9
    ]
  },
  "EPSG:2331": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      17188253376103718e-9,
      2.3404152515994543e6,
      1774472807835426e-8,
      4787120079604619e-9
    ]
  },
  "EPSG:2332": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      18189098505543537e-9,
      2384748787929881e-9,
      18746725124750897e-9,
      47082090701406e-7
    ]
  },
  "EPSG:2333": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      1918236458103976e-8,
      2.0057443251042569e6,
      1973608729913605e-8,
      5001552167032628e-9
    ]
  },
  "EPSG:2334": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      2019041642251396e-8,
      2452360404181216e-9,
      20708209041323945e-9,
      5714208919257005e-9
    ]
  },
  "EPSG:2335": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      21200433018734872e-9,
      2.9179865915250513e6,
      21698769377891913e-9,
      5.9411343701720005e6
    ]
  },
  "EPSG:2336": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      2224715843229366e-8,
      4532694831288505e-9,
      22702362867586795e-9,
      5855474418451538e-9
    ]
  },
  "EPSG:2337": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      23263541627294257e-9,
      4991550205699189e-9,
      23482969266651213e-9,
      5362933345701906e-9
    ]
  },
  "EPSG:2338": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      374665.3463313674,
      3922066271229741e-9,
      752995.0322017458,
      4552717342266815e-9
    ]
  },
  "EPSG:2339": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      206116.69388629694,
      3230780813217304e-9,
      727179.1436440118,
      5237187189365182e-9
    ]
  },
  "EPSG:2340": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      203003.58503789647,
      3.0266603366292384e6,
      718708.9090284538,
      5453983173957889e-9
    ]
  },
  "EPSG:2341": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      204050.75644294324,
      3069911112839626e-9,
      725045.8039501093,
      5311699123989046e-9
    ]
  },
  "EPSG:2342": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      188253.37610371766,
      2.3404152515994543e6,
      744728.0783542631,
      4787120079604619e-9
    ]
  },
  "EPSG:2343": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      189098.5055435361,
      2384748787929881e-9,
      746725.1247508986,
      47082090701406e-7
    ]
  },
  "EPSG:2344": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      182364.58103975857,
      2.0057443251042569e6,
      736087.2991360482,
      5001552167032628e-9
    ]
  },
  "EPSG:2345": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      190416.4225139605,
      2452360404181216e-9,
      708209.0413239438,
      5714208919257005e-9
    ]
  },
  "EPSG:2346": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      200433.01873487356,
      2.9179865915250513e6,
      698769.3778919112,
      5.9411343701720005e6
    ]
  },
  "EPSG:2347": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      247158.43229366053,
      4532694831288505e-9,
      702362.8675867956,
      5855474418451538e-9
    ]
  },
  "EPSG:2348": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      263541.62729425734,
      4991550205699189e-9,
      482969.26665121224,
      5362933345701906e-9
    ]
  },
  "EPSG:2349": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      25375272437965494e-9,
      3965341599595137e-9,
      2562687028618993e-8,
      4.5027896994728595e6
    ]
  },
  "EPSG:2350": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      26356780682329662e-9,
      3435268555207913e-9,
      26624608029898636e-9,
      4633844823027357e-9
    ]
  },
  "EPSG:2351": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      27355189655774307e-9,
      3315518826571013e-9,
      2761722184404081e-8,
      5083859293880278e-9
    ]
  },
  "EPSG:2352": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      28352803435920816e-9,
      3.1281692300121286e6,
      28613592564246852e-9,
      5233910910306751e-9
    ]
  },
  "EPSG:2353": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      29352176007371027e-9,
      3077182209673039e-9,
      29609359877903443e-9,
      5450731683733984e-9
    ]
  },
  "EPSG:2354": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      30350541526633743e-9,
      3023993671656736e-9,
      30611765140188705e-9,
      5366233536254313e-9
    ]
  },
  "EPSG:2355": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      31352054361954562e-9,
      3067206859443327e-9,
      31618002516516987e-9,
      5.0004888402534975e6
    ]
  },
  "EPSG:2356": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      32352762227229774e-9,
      3.1248438924340312e6,
      326200899604647e-7,
      493049251899106e-8
    ]
  },
  "EPSG:2357": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3334448225038394e-8,
      2371431400753844e-9,
      3362278759660247e-8,
      4737151761249449e-9
    ]
  },
  "EPSG:2358": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3434416649731504e-8,
      2338206735629828e-9,
      3462292575608254e-8,
      4729375424777305e-9
    ]
  },
  "EPSG:2359": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3534564299844865e-8,
      2.4899418141916906e6,
      35624693962828115e-9,
      4676068944527105e-9
    ]
  },
  "EPSG:2360": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3634129875337088e-8,
      2.0126609557176153e6,
      3662418117879881e-8,
      470495067800589e-8
    ]
  },
  "EPSG:2361": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3734122650567978e-8,
      2.0038039204557734e6,
      3761804375837917e-8,
      4998266158811075e-9
    ]
  },
  "EPSG:2362": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      3834457780565374e-8,
      2.3813990157216443e6,
      3861734068235627e-8,
      503605273389127e-8
    ]
  },
  "EPSG:2363": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      39345754229113415e-9,
      2.5010182938375385e6,
      396078090521523e-7,
      5528581540079267e-9
    ]
  },
  "EPSG:2364": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      4034787217508141e-8,
      2.7037409990684018e6,
      4059993309560358e-8,
      5912397962312722e-9
    ]
  },
  "EPSG:2365": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      4135274849996303e-8,
      3.1237354495961196e6,
      4159939470575535e-8,
      5937993196408385e-9
    ]
  },
  "EPSG:2366": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      42372262406646594e-9,
      4451707202780935e-9,
      4260023668413316e-8,
      5897931499918422e-9
    ]
  },
  "EPSG:2367": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      43374503705447905e-9,
      4582752551054417e-9,
      4360698276037035e-8,
      5569734309275349e-9
    ]
  },
  "EPSG:2368": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      4437654307256449e-8,
      4699381816387394e-9,
      4461001949364571e-8,
      5417370163319311e-9
    ]
  },
  "EPSG:2369": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      4538349178813429e-8,
      508051022289652e-8,
      4548296926665121e-8,
      5362933345701906e-9
    ]
  },
  "EPSG:2370": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      375272.43796549534,
      3965341599595137e-9,
      626870.2861899302,
      4.5027896994728595e6
    ]
  },
  "EPSG:2371": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      356780.6823296633,
      3435268555207913e-9,
      624608.0298986378,
      4633844823027357e-9
    ]
  },
  "EPSG:2372": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      355189.655774305,
      3315518826571013e-9,
      617221.8440408127,
      5083859293880278e-9
    ]
  },
  "EPSG:2373": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      352803.4359208173,
      3.1281692300121286e6,
      613592.5642468528,
      5233910910306751e-9
    ]
  },
  "EPSG:2374": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      352176.0073710256,
      3077182209673039e-9,
      609359.8779034446,
      5450731683733984e-9
    ]
  },
  "EPSG:2375": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      350541.52663374436,
      3023993671656736e-9,
      611765.1401887037,
      5366233536254313e-9
    ]
  },
  "EPSG:2376": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      352054.36195456114,
      3067206859443327e-9,
      618002.5165169882,
      5.0004888402534975e6
    ]
  },
  "EPSG:2377": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      352762.2272297734,
      3.1248438924340312e6,
      620089.9604647005,
      493049251899106e-8
    ]
  },
  "EPSG:2378": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      344482.2503839384,
      2371431400753844e-9,
      622787.5966024663,
      4737151761249449e-9
    ]
  },
  "EPSG:2379": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      344166.49731503846,
      2338206735629828e-9,
      622925.756082546,
      4729375424777305e-9
    ]
  },
  "EPSG:2380": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      345642.9984486472,
      2.4899418141916906e6,
      624693.9628281136,
      4676068944527105e-9
    ]
  },
  "EPSG:2381": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      341298.753370882,
      2.0126609557176153e6,
      624181.1787988081,
      470495067800589e-8
    ]
  },
  "EPSG:2382": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      341226.5056797819,
      2.0038039204557734e6,
      618043.7583791714,
      4998266158811075e-9
    ]
  },
  "EPSG:2383": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      344577.8056537466,
      2.3813990157216443e6,
      617340.6823562654,
      503605273389127e-8
    ]
  },
  "EPSG:2384": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      345754.22911341314,
      2.5010182938375385e6,
      607809.0521522979,
      5528581540079267e-9
    ]
  },
  "EPSG:2385": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      347872.1750814093,
      2.7037409990684018e6,
      599933.0956035751,
      5912397962312722e-9
    ]
  },
  "EPSG:2386": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      352748.49996303243,
      3.1237354495961196e6,
      599394.7057553503,
      5937993196408385e-9
    ]
  },
  "EPSG:2387": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      372262.40664659307,
      4451707202780935e-9,
      600236.6841331584,
      5897931499918422e-9
    ]
  },
  "EPSG:2388": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      374503.7054479012,
      4582752551054417e-9,
      606982.760370349,
      5569734309275349e-9
    ]
  },
  "EPSG:2389": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      376543.072564488,
      4699381816387394e-9,
      610019.4936457147,
      5417370163319311e-9
    ]
  },
  "EPSG:2390": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs +type=crs",
    projected_bounds: [
      383491.78813429363,
      508051022289652e-8,
      482969.26665121224,
      5362933345701906e-9
    ]
  },
  "EPSG:2391": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4156950347348335e6,
      6628442258079236e-9,
      1.5591126266469967e6,
      7695164139998106e-9
    ]
  },
  "EPSG:2392": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.4156698357390594e6,
      6627328317329907e-9,
      2560285909163401e-9,
      764720732025856e-8
    ]
  },
  "EPSG:2393": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.4156698357390594e6,
      6627328317329907e-9,
      3557030688951835e-9,
      7779930505547379e-9
    ]
  },
  "EPSG:2394": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4418686560903375e-9,
      6759898402441222e-9,
      4557798924370788e-9,
      7748699988172213e-9
    ]
  },
  "EPSG:2395": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8322825055041893e-9,
      1.3873937623245951e6,
      8818988774312785e-9,
      1988067347212486e-9
    ]
  },
  "EPSG:2396": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      917567673778363e-8,
      1.5437816951787225e6,
      9725370277558941e-9,
      2.1030763256244687e6
    ]
  },
  "EPSG:2397": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3565480568566394e-9,
      5580281274399278e-9,
      3604022990100036e-9,
      5715554777568022e-9
    ]
  },
  "EPSG:2398": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      439017629495391e-8,
      5427471404062636e-9,
      4596608840767236e-9,
      606942590845794e-8
    ]
  },
  "EPSG:2399": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      538493934625595e-8,
      5157294696838746e-9,
      5596656434281129e-9,
      6067199753510543e-9
    ]
  },
  "EPSG:2401": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      25375270405261002e-9,
      3.9654100324684693e6,
      25626872348776396e-9,
      4502867202883635e-9
    ]
  },
  "EPSG:2402": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2635677834295784e-8,
      3.4353279806508054e6,
      2662461005447431e-8,
      4633924528483284e-9
    ]
  },
  "EPSG:2403": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      27355187289261073e-9,
      3.3155762091446896e6,
      27617223744599424e-9,
      5083946530919504e-9
    ]
  },
  "EPSG:2404": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      28352801028629202e-9,
      3128223410843368e-9,
      28613594404666655e-9,
      5234000648390519e-9
    ]
  },
  "EPSG:2405": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2935217358934277e-8,
      3.0772355179861137e6,
      29609361647951264e-9,
      5450825026701923e-9
    ]
  },
  "EPSG:2406": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3035053908137362e-8,
      3.0240460692474865e6,
      3061176694988002e-8,
      5366325475610118e-9
    ]
  },
  "EPSG:2407": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3135205194184399e-8,
      3067259996995274e-9,
      31618004430481795e-9,
      5000574685472533e-9
    ]
  },
  "EPSG:2408": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      32352759819233175e-9,
      3.1248980163752725e6,
      32620091908927303e-9,
      4930577194424021e-9
    ]
  },
  "EPSG:2409": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3334447970019824e-8,
      2.3714725841607456e6,
      33622789590639256e-9,
      4737233199767044e-9
    ]
  },
  "EPSG:2410": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      34344163941685416e-9,
      2.3382473461902845e6,
      3462292775243555e-8,
      4729456732924733e-9
    ]
  },
  "EPSG:2411": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3534564046826165e-8,
      2.4899850394998877e6,
      35624695988401435e-9,
      467614935861393e-8
    ]
  },
  "EPSG:2412": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3634129614822373e-8,
      2.0126959447015524e6,
      3662418319577043e-8,
      4705031576575562e-9
    ]
  },
  "EPSG:2413": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3734122389928338e-8,
      2.0038387562858479e6,
      3761804567303289e-8,
      4998351966901854e-9
    ]
  },
  "EPSG:2414": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3834457525711521e-8,
      2.3814403709528917e6,
      3861734258526859e-8,
      5036139173025487e-9
    ]
  },
  "EPSG:2415": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3934575170084169e-8,
      2.5010617098759683e6,
      39607810796467885e-9,
      5528676174789069e-9
    ]
  },
  "EPSG:2416": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      40347869683240615e-9,
      2703787902292285e-9,
      4059993470964578e-8,
      5912498945761737e-9
    ]
  },
  "EPSG:2417": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      41352746091731586e-9,
      3.1237895545736123e6,
      41599396310916424e-9,
      5938094602071491e-9
    ]
  },
  "EPSG:2418": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4237226032946961e-8,
      4451783846830089e-9,
      42600238303184606e-9,
      5898032244668005e-9
    ]
  },
  "EPSG:2419": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      43374501665955454e-9,
      4582831398498325e-9,
      43606984490986675e-9,
      5569829626270264e-9
    ]
  },
  "EPSG:2420": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4437654106730423e-8,
      46994626215635e-7,
      44610021274646565e-9,
      5417462952309373e-9
    ]
  },
  "EPSG:2421": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4538348989911644e-8,
      5080597404062229e-9,
      4548296899088785e-8,
      5363025230667173e-9
    ]
  },
  "EPSG:2422": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      375270.40526100073,
      3.9654100324684693e6,
      626872.3487763973,
      4502867202883635e-9
    ]
  },
  "EPSG:2423": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      356778.342957841,
      3.4353279806508054e6,
      624610.0544743093,
      4633924528483284e-9
    ]
  },
  "EPSG:2424": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      355187.2892610746,
      3.3155762091446896e6,
      617223.7445994257,
      5083946530919504e-9
    ]
  },
  "EPSG:2425": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352801.0286292013,
      3128223410843368e-9,
      613594.4046666537,
      5234000648390519e-9
    ]
  },
  "EPSG:2426": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352173.58934276877,
      3.0772355179861137e6,
      609361.6479512625,
      5450825026701923e-9
    ]
  },
  "EPSG:2427": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      350539.0813736223,
      3.0240460692474865e6,
      611766.9498800174,
      5366325475610118e-9
    ]
  },
  "EPSG:2428": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352051.9418439908,
      3067259996995274e-9,
      618004.4304817966,
      5000574685472533e-9
    ]
  },
  "EPSG:2429": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352759.8192331744,
      3.1248980163752725e6,
      620091.908927303,
      4930577194424021e-9
    ]
  },
  "EPSG:2430": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344479.7001982392,
      2.3714725841607456e6,
      622789.5906392526,
      4737233199767044e-9
    ]
  },
  "EPSG:2431": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344163.941685413,
      2.3382473461902845e6,
      622927.7524355468,
      4729456732924733e-9
    ]
  },
  "EPSG:2432": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      345640.4682616495,
      2.4899850394998877e6,
      624695.9884014355,
      467614935861393e-8
    ]
  },
  "EPSG:2433": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341296.1482237305,
      2.0126959447015524e6,
      624183.1957704299,
      4705031576575562e-9
    ]
  },
  "EPSG:2434": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341223.8992833793,
      2.0038387562858479e6,
      618045.6730328879,
      4998351966901854e-9
    ]
  },
  "EPSG:2435": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344575.25711520563,
      2.3814403709528917e6,
      617342.5852685891,
      5036139173025487e-9
    ]
  },
  "EPSG:2436": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      345751.70084168506,
      2.5010617098759683e6,
      607810.7964678872,
      5528676174789069e-9
    ]
  },
  "EPSG:2437": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      347869.68324061215,
      2703787902292285e-9,
      599934.7096457767,
      5912498945761737e-9
    ]
  },
  "EPSG:2438": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352746.0917315865,
      3.1237895545736123e6,
      599396.3109164219,
      5938094602071491e-9
    ]
  },
  "EPSG:2439": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      372260.32946960814,
      4451783846830089e-9,
      600238.3031846032,
      5898032244668005e-9
    ]
  },
  "EPSG:2440": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      374501.66595545696,
      4582831398498325e-9,
      606984.4909866764,
      5569829626270264e-9
    ]
  },
  "EPSG:2441": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376541.0673042309,
      46994626215635e-7,
      610021.2746465626,
      5417462952309373e-9
    ]
  },
  "EPSG:2442": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      383489.8991164382,
      5080597404062229e-9,
      482968.9908878475,
      5363025230667173e-9
    ]
  },
  "EPSG:2443": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -132049.50809238307,
      -668787.9965111837,
      87905.60739467604,
      193401.31124209717
    ]
  },
  "EPSG:2444": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -119419.18290007114,
      -311999.9676425828,
      97007.74237412079,
      110290.15565012966
    ]
  },
  "EPSG:2445": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -125737.06392055089,
      -252087.01766658467,
      118732.8549713948,
      42974.913619416235
    ]
  },
  "EPSG:2446": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -145349.82388383587,
      -33314.0838704339,
      120373.92844181918,
      161592.74679487603
    ]
  },
  "EPSG:2447": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110992.00295443885,
      -206786.41253943156,
      102851.84721320926,
      -31578.584843732177
    ]
  },
  "EPSG:2448": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -106045.51424832072,
      -287821.7820397009,
      88881.12612888413,
      37068.76311181089
    ]
  },
  "EPSG:2449": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -86924.20137166914,
      -164885.0639883593,
      59470.62651639598,
      175534.08328598388
    ]
  },
  "EPSG:2450": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -108311.31609817347,
      -161331.87717495687,
      122852.53486351445,
      287250.6401937568
    ]
  },
  "EPSG:2451": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -139237.37425984908,
      -740986.5827938248,
      112154.28054505108,
      220482.4546000297
    ]
  },
  "EPSG:2452": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -118410.45564325571,
      -251124.64589962916,
      108957.53417588453,
      176265.86497031027
    ]
  },
  "EPSG:2453": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -76161.02776472867,
      -295060.56985245284,
      97980.50829603229,
      -63724.195556120096
    ]
  },
  "EPSG:2454": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112401.8523644654,
      -204608.41722348426,
      106208.88063008069,
      172018.66555383214
    ]
  },
  "EPSG:2455": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -136139.90274731265,
      -235300.560838289,
      129045.39378118758,
      45718.60856236123
    ]
  },
  "EPSG:2456": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -80968.06937713006,
      -147083.96782694227,
      32515.99943426242,
      199467.3347356876
    ]
  },
  "EPSG:2457": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -87081.0218032431,
      2505.5859933912316,
      89393.65205321205,
      101131.1656057617
    ]
  },
  "EPSG:2458": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -119061.6410094445,
      -223244.5998951997,
      152504.784614614,
      -116567.49353079096
    ]
  },
  "EPSG:2459": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      12170.964575906783,
      -177218.48155592856,
      38037.87865557607,
      1163.0856537163943
    ]
  },
  "EPSG:2460": {
    proj4: "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2087.7993220864046,
      40957.476010164195,
      16690.544009082074,
      53142.34550229258
    ]
  },
  "EPSG:2461": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9141.112772019294,
      -197156.09703477332,
      5073.227612596988,
      -182760.4635641074
    ]
  },
  "EPSG:2462": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4347196542573736e-9,
      4391149962607118e-9,
      4504918641110145e-9,
      4726145545331657e-9
    ]
  },
  "EPSG:2463": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      406948.8301598333,
      6022583485251955e-9,
      618709.2906172591,
      6134555539008731e-9
    ]
  },
  "EPSG:2464": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      475472.06570441584,
      6174225051903019e-9,
      617425.2840046014,
      7.7128683272320805e6
    ]
  },
  "EPSG:2465": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      286447.8897420238,
      5583069936754964e-9,
      614411.6370873044,
      7774162716634687e-9
    ]
  },
  "EPSG:2466": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      256081.05959033253,
      4787173144948495e-9,
      619132.4312237855,
      7686141985427631e-9
    ]
  },
  "EPSG:2467": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      248300.99086734117,
      4566096180558951e-9,
      552911.6057528508,
      8988276335345622e-9
    ]
  },
  "EPSG:2468": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      249069.28569681002,
      4588312446546785e-9,
      550081.7744449297,
      9042922756726556e-9
    ]
  },
  "EPSG:2469": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      287031.73328650265,
      5597527264717192e-9,
      547132.4970607558,
      9099800724680038e-9
    ]
  },
  "EPSG:2470": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      287887.0276478871,
      5618657630227684e-9,
      547942.4898284647,
      9084187058666075e-9
    ]
  },
  "EPSG:2471": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      303769.18366545235,
      6.0013148492511045e6,
      574935.8565552565,
      8560068375251852e-9
    ]
  },
  "EPSG:2472": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      299402.7408946989,
      5897847888617684e-9,
      559824.801769982,
      885445301426915e-8
    ]
  },
  "EPSG:2473": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      288022.28903292725,
      5.6219940497905165e6,
      552218.9407067001,
      9001659035253026e-9
    ]
  },
  "EPSG:2474": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      280802.8587967834,
      5.4418454210249195e6,
      550832.9167272551,
      902842462503835e-8
    ]
  },
  "EPSG:2475": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      284435.4574776775,
      5533027165774099e-9,
      550370.7064843985,
      9037346543693524e-9
    ]
  },
  "EPSG:2476": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      283723.144953105,
      5515234864293874e-9,
      550544.0470467615,
      9034000820986697e-9
    ]
  },
  "EPSG:2477": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      283323.21476049325,
      5505226852548886e-9,
      561146.8863034418,
      8828804348140907e-9
    ]
  },
  "EPSG:2478": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      281111.20538000204,
      5449628859473506e-9,
      576415.8690801577,
      8531078169374652e-9
    ]
  },
  "EPSG:2479": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      282746.4879867024,
      5490771036350928e-9,
      581243.0774592084,
      8436305541392285e-9
    ]
  },
  "EPSG:2480": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      291741.96420566726,
      5713194370626235e-9,
      592303.2032611601,
      8217790026561463e-9
    ]
  },
  "EPSG:2481": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      252407.80383986945,
      4683848810351307e-9,
      594491.303157459,
      8174313274365788e-9
    ]
  },
  "EPSG:2482": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      253900.84550468263,
      4.7260658776550945e6,
      580165.5891636863,
      8457489597908182e-9
    ]
  },
  "EPSG:2483": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      266940.29144984693,
      5082770654099713e-9,
      579484.6090987622,
      8470869126102943e-9
    ]
  },
  "EPSG:2484": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      257761.16001264832,
      4833839761162132e-9,
      576358.9748197924,
      8532193169384241e-9
    ]
  },
  "EPSG:2485": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      266647.9512679782,
      5074990485225236e-9,
      579541.370977278,
      8469754161775332e-9
    ]
  },
  "EPSG:2486": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      286133.9706550996,
      5575285319558777e-9,
      574195.2617573777,
      8574563637140198e-9
    ]
  },
  "EPSG:2487": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      305520.92426773405,
      6042482385332407e-9,
      614356.7438625711,
      7775277186006402e-9
    ]
  },
  "EPSG:2488": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      305426.02592130436,
      6040257065872187e-9,
      613477.9737760838,
      7793108820650335e-9
    ]
  },
  "EPSG:2489": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341042.216920733,
      6841708934015177e-9,
      605751.2814538042,
      7949145415708783e-9
    ]
  },
  "EPSG:2490": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      355082.7326057195,
      7142417650495278e-9,
      605418.6753073101,
      7.9558330818749685e6
    ]
  },
  "EPSG:2491": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      354293.8780123715,
      7.1257094232059745e6,
      587881.8251480686,
      7455992844597268e-9
    ]
  },
  "EPSG:2494": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      393182.0155200382,
      5313951562441295e-9,
      670186.2334046238,
      6595637757951948e-9
    ]
  },
  "EPSG:2495": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      264197.89392747934,
      5.0094175411680965e6,
      617816.4303901168,
      7712887556479445e-9
    ]
  },
  "EPSG:2496": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      260671.69817869063,
      4913845494223263e-9,
      614411.6370873044,
      7774162716634687e-9
    ]
  },
  "EPSG:2497": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      249223.31318524267,
      4592755767269399e-9,
      618736.9137596262,
      7686122571963354e-9
    ]
  },
  "EPSG:2498": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      239506.499884692,
      4305097002115024e-9,
      553087.8238302275,
      898828546978921e-8
    ]
  },
  "EPSG:2499": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      234121.83705312642,
      4.1385418321746127e6,
      550081.7744449297,
      9042922756726556e-9
    ]
  },
  "EPSG:2500": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      233101.76002252696,
      4106344725106357e-9,
      547132.4970607558,
      9099800724680038e-9
    ]
  },
  "EPSG:2501": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      226555.67724895367,
      3.8943163657914447e6,
      547942.4898284647,
      9084187058666075e-9
    ]
  },
  "EPSG:2502": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      231775.48348959466,
      4.0641571457690555e6,
      574935.8565552565,
      8560068375251852e-9
    ]
  },
  "EPSG:2503": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      232193.033135097,
      4.0774793272321625e6,
      559824.801769982,
      885445301426915e-8
    ]
  },
  "EPSG:2504": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      247726.78901981493,
      4.5494343501091665e6,
      552392.8517085662,
      9001668053108038e-9
    ]
  },
  "EPSG:2505": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      271069.571120144,
      5191700322012202e-9,
      550832.9167272551,
      902842462503835e-8
    ]
  },
  "EPSG:2506": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      284435.4574776775,
      5533027165774099e-9,
      550370.7064843985,
      9037346543693524e-9
    ]
  },
  "EPSG:2507": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      283723.144953105,
      5515234864293874e-9,
      550544.0470467615,
      9034000820986697e-9
    ]
  },
  "EPSG:2508": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      283323.21476049325,
      5505226852548886e-9,
      561146.8863034418,
      8828804348140907e-9
    ]
  },
  "EPSG:2509": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      281111.20538000204,
      5449628859473506e-9,
      576415.8690801577,
      8531078169374652e-9
    ]
  },
  "EPSG:2510": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      282746.4879867024,
      5490771036350928e-9,
      581243.0774592084,
      8436305541392285e-9
    ]
  },
  "EPSG:2511": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      291741.96420566726,
      5713194370626235e-9,
      592303.2032611601,
      8217790026561463e-9
    ]
  },
  "EPSG:2512": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      252407.80383986945,
      4683848810351307e-9,
      594491.303157459,
      8174313274365788e-9
    ]
  },
  "EPSG:2513": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      253900.84550468263,
      4.7260658776550945e6,
      580165.5891636863,
      8457489597908182e-9
    ]
  },
  "EPSG:2514": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      266940.29144984693,
      5082770654099713e-9,
      579484.6090987622,
      8470869126102943e-9
    ]
  },
  "EPSG:2515": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      257761.16001264832,
      4833839761162132e-9,
      576358.9748197924,
      8532193169384241e-9
    ]
  },
  "EPSG:2516": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      266647.9512679782,
      5074990485225236e-9,
      579541.370977278,
      8469754161775332e-9
    ]
  },
  "EPSG:2517": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      286133.9706550996,
      5575285319558777e-9,
      574195.2617573777,
      8574563637140198e-9
    ]
  },
  "EPSG:2518": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      305520.92426773405,
      6042482385332407e-9,
      614356.7438625711,
      7775277186006402e-9
    ]
  },
  "EPSG:2519": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      305426.02592130436,
      6040257065872187e-9,
      613477.9737760838,
      7793108820650335e-9
    ]
  },
  "EPSG:2520": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341042.216920733,
      6841708934015177e-9,
      605751.2814538042,
      7949145415708783e-9
    ]
  },
  "EPSG:2521": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      355082.7326057195,
      7142417650495278e-9,
      605418.6753073101,
      7.9558330818749685e6
    ]
  },
  "EPSG:2522": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      354293.8780123715,
      7.1257094232059745e6,
      587881.8251480686,
      7455992844597268e-9
    ]
  },
  "EPSG:2523": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7393781101909672e-9,
      5346196771983995e-9,
      7585959627610223e-9,
      6554888856957995e-9
    ]
  },
  "EPSG:2524": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8387435393607327e-9,
      528736641108538e-8,
      8584327348728104e-9,
      6627289704492721e-9
    ]
  },
  "EPSG:2525": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      9381479093262402e-9,
      5015037181694607e-9,
      95606033207796e-7,
      7650494871812218e-9
    ]
  },
  "EPSG:2526": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      10382098739186065e-9,
      5006131513760138e-9,
      10557687220565997e-9,
      7753090150158134e-9
    ]
  },
  "EPSG:2527": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      11380336873778392e-9,
      4910560407812479e-9,
      11557220851831736e-9,
      7772050900526357e-9
    ]
  },
  "EPSG:2528": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      12380927979934499e-9,
      4.9427863693147125e6,
      12558946561113846e-9,
      7701786314544678e-9
    ]
  },
  "EPSG:2529": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      13377824480607405e-9,
      4771672907214434e-9,
      13560556141767507e-9,
      7635987315206223e-9
    ]
  },
  "EPSG:2530": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      14373812156580329e-9,
      4542848133790021e-9,
      14561124193118801e-9,
      7629306040665898e-9
    ]
  },
  "EPSG:2531": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1536976286561827e-8,
      4301887157062036e-9,
      15526781879896441e-9,
      897497086261004e-8
    ]
  },
  "EPSG:2532": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16368802140533347e-9,
      4243047689920445e-9,
      1652646441945971e-8,
      8987250269439492e-9
    ]
  },
  "EPSG:2533": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      17367639278448038e-9,
      4170892855620059e-9,
      17525569227748312e-9,
      9021856240672324e-9
    ]
  },
  "EPSG:2534": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1836705543272874e-8,
      4134263245638144e-9,
      1852502018343823e-8,
      9043066616279008e-9
    ]
  },
  "EPSG:2535": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      19367603768297836e-9,
      4168672824841187e-9,
      19523631890104033e-9,
      9096651585371295e-9
    ]
  },
  "EPSG:2536": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2036391539952093e-8,
      3.9322794917069944e6,
      2052357400720756e-8,
      9098884318524582e-9
    ]
  },
  "EPSG:2537": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      21363293773527708e-9,
      3891223855386482e-9,
      2152397912565384e-8,
      9083255229693826e-9
    ]
  },
  "EPSG:2538": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      22365210063482855e-9,
      4016617371325727e-9,
      22525482555418316e-9,
      9025205234163687e-9
    ]
  },
  "EPSG:2539": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      23366353672516517e-9,
      4089866275294738e-9,
      23537479486970432e-9,
      8558634017521972e-9
    ]
  },
  "EPSG:2540": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      24365901028888956e-9,
      4061009742190826e-9,
      24547371375622697e-9,
      8168069972943586e-9
    ]
  },
  "EPSG:2541": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2536686179944835e-8,
      4.1220537998667643e6,
      25529922000877175e-9,
      8853297022362867e-9
    ]
  },
  "EPSG:2542": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2637273067780864e-8,
      447954606915934e-8,
      26526117985749464e-9,
      9000646064981556e-9
    ]
  },
  "EPSG:2543": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      27375370549077522e-9,
      4632813767619936e-9,
      27526117985749464e-9,
      9000646064981556e-9
    ]
  },
  "EPSG:2544": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      28381954326967113e-9,
      4998351966901854e-9,
      2853608240580551e-8,
      8613321361519752e-9
    ]
  },
  "EPSG:2545": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      29386021487370946e-9,
      5213989565961048e-9,
      29537223086274967e-9,
      8568678489688782e-9
    ]
  },
  "EPSG:2546": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      30391212473894253e-9,
      5479740137508675e-9,
      3052539587597458e-8,
      902855423262264e-8
    ]
  },
  "EPSG:2547": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      31392814100367647e-9,
      5559819101148453e-9,
      31525453663059626e-9,
      9026321566432199e-9
    ]
  },
  "EPSG:2548": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      323918555044012e-7,
      5511993043569505e-9,
      32525193596410446e-9,
      9036368581585966e-9
    ]
  },
  "EPSG:2549": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3339198889449763e-8,
      551866624752104e-8,
      3352649328362146e-8,
      89861339568522e-7
    ]
  },
  "EPSG:2551": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      34392836465944104e-9,
      5.5609313745435225e6,
      3452992200087718e-8,
      8853297022362867e-9
    ]
  },
  "EPSG:2552": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3539274702339736e-8,
      555648229172689e-8,
      3553135880459175e-8,
      8797485851457562e-9
    ]
  },
  "EPSG:2553": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3639079270048236e-8,
      545860974436096e-8,
      3653368121891824e-8,
      8707075368070645e-9
    ]
  },
  "EPSG:2554": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      37390550226808704e-9,
      5446376656285444e-9,
      3753821966922257e-8,
      8529617019074585e-9
    ]
  },
  "EPSG:2555": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3839132314122176e-8,
      5485300875377802e-9,
      3853853258307374e-8,
      8517340761956424e-9
    ]
  },
  "EPSG:2556": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3939136743152045e-8,
      5487525183130738e-9,
      3954495602001635e-8,
      8264026745784358e-9
    ]
  },
  "EPSG:2557": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      40392166933717676e-9,
      5527563953459505e-9,
      4054720320821655e-8,
      8174764396687429e-9
    ]
  },
  "EPSG:2558": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4139971503632732e-8,
      5895806624597178e-9,
      41546165019899175e-9,
      8216047460952335e-9
    ]
  },
  "EPSG:2559": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      42392189203532115e-9,
      5528676174789069e-9,
      42546165019899175e-9,
      8216047460952335e-9
    ]
  },
  "EPSG:2560": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      43377032806633756e-9,
      4727234901576959e-9,
      4354731532568054e-8,
      8170301443550731e-9
    ]
  },
  "EPSG:2561": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4437620803344076e-8,
      4680578118021258e-9,
      44551780207776815e-9,
      7991796720395234e-9
    ]
  },
  "EPSG:2562": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4537717091575298e-8,
      4.7350113430296825e6,
      45540803899345845e-9,
      8428061929769995e-9
    ]
  },
  "EPSG:2563": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4638123492963741e-8,
      4959455570728209e-9,
      46539754394286856e-9,
      846935271762947e-8
    ]
  },
  "EPSG:2564": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4738346901717669e-8,
      5079485912788836e-9,
      4753986793640131e-8,
      846488879232949e-8
    ]
  },
  "EPSG:2565": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4837890272983431e-8,
      4831668822749684e-9,
      4854057712449161e-8,
      843698956811353e-8
    ]
  },
  "EPSG:2566": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      49378882663662955e-9,
      4.8305577391275875e6,
      4953836192063122e-8,
      8524036889929483e-9
    ]
  },
  "EPSG:2567": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      50382160684361055e-9,
      5009465632580258e-9,
      505381912153834e-7,
      8530733047351377e-9
    ]
  },
  "EPSG:2568": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5138532023459773e-8,
      5177304110687376e-9,
      5153978278166578e-8,
      8468236735034157e-9
    ]
  },
  "EPSG:2569": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5239028617389528e-8,
      5433031718224293e-9,
      5253710910037266e-8,
      857314272023716e-8
    ]
  },
  "EPSG:2570": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      53395521284931526e-9,
      5693304683573038e-9,
      5355419098645532e-8,
      7894746223422435e-9
    ]
  },
  "EPSG:2571": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5440244155648437e-8,
      6024904119862094e-9,
      54554577756541274e-9,
      7879129686902671e-9
    ]
  },
  "EPSG:2572": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5540327219776204e-8,
      6063860534002597e-9,
      55557769467496626e-9,
      7749744170876845e-9
    ]
  },
  "EPSG:2573": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      56402702220325835e-9,
      6037147336431702e-9,
      56557083586981e-6,
      7.7776276566521935e6
    ]
  },
  "EPSG:2574": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5741594997591854e-8,
      6639542823063844e-9,
      5755675397135648e-8,
      7791011991040514e-9
    ]
  },
  "EPSG:2575": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      584188168338337e-7,
      6.7654268169739405e6,
      58557220851831734e-9,
      7772050900526357e-9
    ]
  },
  "EPSG:2576": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      59421638310934536e-9,
      6887987786261765e-9,
      5955424625950889e-8,
      7892515276132623e-9
    ]
  },
  "EPSG:2578": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      614285536495066e-7,
      7183322547602382e-9,
      61552834717312604e-9,
      7949405824594064e-9
    ]
  },
  "EPSG:2579": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      62427131424557775e-9,
      7123132838579394e-9,
      6256332332692538e-8,
      7522243311412292e-9
    ]
  },
  "EPSG:2580": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      634275258340785e-7,
      7139851785302197e-9,
      63562219197732404e-9,
      744188970980878e-8
    ]
  },
  "EPSG:2581": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      644439581603729e-7,
      7290058340345639e-9,
      64455716780549265e-9,
      7307697576988738e-9
    ]
  },
  "EPSG:2582": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      393781.10190967185,
      5346196771983995e-9,
      585959.6276102233,
      6554888856957995e-9
    ]
  },
  "EPSG:2583": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      387435.3936073271,
      528736641108538e-8,
      584327.3487281029,
      6627289704492721e-9
    ]
  },
  "EPSG:2584": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      381479.09326240246,
      5015037181694607e-9,
      560603.3207795997,
      7650494871812218e-9
    ]
  },
  "EPSG:2585": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      382098.73918606533,
      5006131513760138e-9,
      557687.2205659978,
      7753090150158134e-9
    ]
  },
  "EPSG:2586": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      380336.87377839093,
      4910560407812479e-9,
      557220.8518317352,
      7772050900526357e-9
    ]
  },
  "EPSG:2587": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      380927.97993449896,
      4.9427863693147125e6,
      558946.5611138464,
      7701786314544678e-9
    ]
  },
  "EPSG:2588": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377824.48060740443,
      4771672907214434e-9,
      560556.141767508,
      7635987315206223e-9
    ]
  },
  "EPSG:2589": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      373812.15658032976,
      4542848133790021e-9,
      561124.1931188011,
      7629306040665898e-9
    ]
  },
  "EPSG:2590": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      369762.8656182694,
      4301887157062036e-9,
      526781.8798964409,
      897497086261004e-8
    ]
  },
  "EPSG:2591": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      368802.1405333469,
      4243047689920445e-9,
      526464.4194597097,
      8987250269439492e-9
    ]
  },
  "EPSG:2592": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      367639.2784480395,
      4170892855620059e-9,
      525569.2277483135,
      9021856240672324e-9
    ]
  },
  "EPSG:2593": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      367055.4327287412,
      4134263245638144e-9,
      525020.1834382316,
      9043066616279008e-9
    ]
  },
  "EPSG:2594": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      367603.7682978359,
      4168672824841187e-9,
      523631.89010403317,
      9096651585371295e-9
    ]
  },
  "EPSG:2595": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      363915.3995209297,
      3.9322794917069944e6,
      523574.0072075609,
      9098884318524582e-9
    ]
  },
  "EPSG:2596": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      363293.7735277092,
      3891223855386482e-9,
      523979.1256538399,
      9083255229693826e-9
    ]
  },
  "EPSG:2597": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      365210.06348285533,
      4016617371325727e-9,
      525482.5554183148,
      9025205234163687e-9
    ]
  },
  "EPSG:2598": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      366353.6725165165,
      4089866275294738e-9,
      537479.4869704318,
      8558634017521972e-9
    ]
  },
  "EPSG:2599": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      365901.028888955,
      4061009742190826e-9,
      547371.3756226961,
      8168069972943586e-9
    ]
  },
  "EPSG:2601": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      366861.7994483486,
      4.1220537998667643e6,
      529922.0008771765,
      8853297022362867e-9
    ]
  },
  "EPSG:2602": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      372730.67780864023,
      447954606915934e-8,
      526117.9857494653,
      9000646064981556e-9
    ]
  },
  "EPSG:2603": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      375370.54907752224,
      4632813767619936e-9,
      526117.9857494652,
      9000646064981556e-9
    ]
  },
  "EPSG:2604": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      381954.3269671112,
      4998351966901854e-9,
      536082.4058055106,
      8613321361519752e-9
    ]
  },
  "EPSG:2605": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      386021.48737094493,
      5213989565961048e-9,
      537223.0862749652,
      8568678489688782e-9
    ]
  },
  "EPSG:2606": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391212.47389425186,
      5479740137508675e-9,
      525395.8759745805,
      902855423262264e-8
    ]
  },
  "EPSG:2607": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392814.10036764835,
      5559819101148453e-9,
      525453.6630596248,
      9026321566432199e-9
    ]
  },
  "EPSG:2608": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391855.5044011981,
      5511993043569505e-9,
      525193.5964104452,
      9036368581585966e-9
    ]
  },
  "EPSG:2609": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391988.8944976275,
      551866624752104e-8,
      526493.2836214605,
      89861339568522e-7
    ]
  },
  "EPSG:2610": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392836.46594410564,
      5.5609313745435225e6,
      529922.0008771765,
      8853297022362867e-9
    ]
  },
  "EPSG:2611": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392747.02339736186,
      555648229172689e-8,
      531358.8045917508,
      8797485851457562e-9
    ]
  },
  "EPSG:2612": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390792.7004823582,
      545860974436096e-8,
      533681.2189182389,
      8707075368070645e-9
    ]
  },
  "EPSG:2613": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390550.226808702,
      5446376656285444e-9,
      538219.6692225707,
      8529617019074585e-9
    ]
  },
  "EPSG:2614": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391323.1412217622,
      5485300875377802e-9,
      538532.5830737436,
      8517340761956424e-9
    ]
  },
  "EPSG:2615": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391367.4315204483,
      5487525183130738e-9,
      544956.0200163496,
      8264026745784358e-9
    ]
  },
  "EPSG:2616": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392166.93371767306,
      5527563953459505e-9,
      547203.2082165445,
      8174764396687429e-9
    ]
  },
  "EPSG:2617": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      399715.0363273198,
      5895806624597178e-9,
      546165.0198991738,
      8216047460952335e-9
    ]
  },
  "EPSG:2618": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392189.2035321128,
      5528676174789069e-9,
      546165.0198991745,
      8216047460952335e-9
    ]
  },
  "EPSG:2619": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377032.8066337532,
      4727234901576959e-9,
      547315.3256805356,
      8170301443550731e-9
    ]
  },
  "EPSG:2620": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376208.0334407599,
      4680578118021258e-9,
      551780.2077768123,
      7991796720395234e-9
    ]
  },
  "EPSG:2621": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377170.9157529762,
      4.7350113430296825e6,
      540803.8993458475,
      8428061929769995e-9
    ]
  },
  "EPSG:2622": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      381234.9296374115,
      4959455570728209e-9,
      539754.3942868551,
      846935271762947e-8
    ]
  },
  "EPSG:2623": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      383469.0171766905,
      5079485912788836e-9,
      539867.9364013111,
      846488879232949e-8
    ]
  },
  "EPSG:2624": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      378902.72983430716,
      4831668822749684e-9,
      540577.1244916127,
      843698956811353e-8
    ]
  },
  "EPSG:2625": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      378882.6636629543,
      4.8305577391275875e6,
      538361.9206312259,
      8524036889929483e-9
    ]
  },
  "EPSG:2626": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      382160.68436105846,
      5009465632580258e-9,
      538191.2153834053,
      8530733047351377e-9
    ]
  },
  "EPSG:2627": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      385320.23459772696,
      5177304110687376e-9,
      539782.7816657781,
      8468236735034157e-9
    ]
  },
  "EPSG:2628": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390286.1738952751,
      5433031718224293e-9,
      537109.1003726585,
      857314272023716e-8
    ]
  },
  "EPSG:2629": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      395521.2849315221,
      5693304683573038e-9,
      554190.9864553215,
      7894746223422435e-9
    ]
  },
  "EPSG:2630": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402441.55648437014,
      6024904119862094e-9,
      554577.7565412731,
      7879129686902671e-9
    ]
  },
  "EPSG:2631": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      403272.19776203996,
      6063860534002597e-9,
      557769.467496629,
      7749744170876845e-9
    ]
  },
  "EPSG:2632": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402702.2203258358,
      6037147336431702e-9,
      557083.5869809991,
      7.7776276566521935e6
    ]
  },
  "EPSG:2633": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      415949.9759185419,
      6639542823063844e-9,
      556753.9713564805,
      7791011991040514e-9
    ]
  },
  "EPSG:2634": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      418816.8338336995,
      6.7654268169739405e6,
      557220.8518317357,
      7772050900526357e-9
    ]
  },
  "EPSG:2635": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      421638.3109345345,
      6887987786261765e-9,
      554246.259508891,
      7892515276132623e-9
    ]
  },
  "EPSG:2636": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      422025.3487051754,
      6904702074893652e-9,
      552723.826723176,
      7953867950004541e-9
    ]
  },
  "EPSG:2637": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      428553.6495065995,
      7183322547602382e-9,
      552834.7173126015,
      7949405824594064e-9
    ]
  },
  "EPSG:2638": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      427131.4245577723,
      7123132838579394e-9,
      563323.3269253826,
      7522243311412292e-9
    ]
  },
  "EPSG:2639": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      427525.8340784968,
      7139851785302197e-9,
      562219.1977324008,
      744188970980878e-8
    ]
  },
  "EPSG:2640": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      443958.1603729015,
      7290058340345639e-9,
      455716.78054926643,
      7307697576988738e-9
    ]
  },
  "EPSG:2641": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7406948830159834e-9,
      6022583485251955e-9,
      7595223478381446e-9,
      6133987390097153e-9
    ]
  },
  "EPSG:2642": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8402441556484371e-9,
      6024904119862094e-9,
      8427812991764298e-9,
      6105713654034847e-9
    ]
  },
  "EPSG:2643": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      9475697911062619e-9,
      6214307592642094e-9,
      95606033207796e-7,
      7650494871812218e-9
    ]
  },
  "EPSG:2644": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      10398946923874054e-9,
      5859084905706649e-9,
      10557687220565997e-9,
      7753090150158134e-9
    ]
  },
  "EPSG:2645": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      11395248466151122e-9,
      5679954968720522e-9,
      11557220851831736e-9,
      7772050900526357e-9
    ]
  },
  "EPSG:2646": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      12380927979934499e-9,
      4.9427863693147125e6,
      12559339469975943e-9,
      7701795976846415e-9
    ]
  },
  "EPSG:2647": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      13378342281429917e-9,
      4800559168272482e-9,
      13560556141767507e-9,
      7635987315206223e-9
    ]
  },
  "EPSG:2648": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      14377427892917268e-9,
      4749453541520347e-9,
      14560719465530207e-9,
      7629296130824446e-9
    ]
  },
  "EPSG:2649": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      15375506404292911e-9,
      4640589131628188e-9,
      15526781879896441e-9,
      897497086261004e-8
    ]
  },
  "EPSG:2650": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16374156287421433e-9,
      45628394741493e-7,
      1652646441945971e-8,
      8987250269439492e-9
    ]
  },
  "EPSG:2651": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      17376423401054908e-9,
      4692797442893094e-9,
      17525569227748312e-9,
      9021856240672324e-9
    ]
  },
  "EPSG:2652": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      18393621330305018e-9,
      5599862072648273e-9,
      1852502018343823e-8,
      9043066616279008e-9
    ]
  },
  "EPSG:2653": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      19393643813970782e-9,
      5600974410548431e-9,
      19523631890104033e-9,
      9096651585371295e-9
    ]
  },
  "EPSG:2654": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2039350896101628e-8,
      5594300409996985e-9,
      2052357400720756e-8,
      9098884318524582e-9
    ]
  },
  "EPSG:2655": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2139477214952873e-8,
      5656593584927704e-9,
      2152397912565384e-8,
      9083255229693826e-9
    ]
  },
  "EPSG:2656": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      22402370529353004e-9,
      6021565097104017e-9,
      22525482555418316e-9,
      9025205234163687e-9
    ]
  },
  "EPSG:2657": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2340365313601133e-8,
      6081669883694747e-9,
      23537479486970432e-9,
      8558634017521972e-9
    ]
  },
  "EPSG:2658": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2440029917744755e-8,
      5923627378462869e-9,
      24547371375622697e-9,
      8168069972943586e-9
    ]
  },
  "EPSG:2659": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      25400392818201233e-9,
      5928078800459592e-9,
      25529922000877175e-9,
      8853297022362867e-9
    ]
  },
  "EPSG:2660": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      26395817360394508e-9,
      5707767163782473e-9,
      26526117985749464e-9,
      9000646064981556e-9
    ]
  },
  "EPSG:2661": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      27394026535703342e-9,
      5619884428578449e-9,
      27526117985749464e-9,
      9000646064981556e-9
    ]
  },
  "EPSG:2662": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2839152255262254e-8,
      5495310316975928e-9,
      2853608240580551e-8,
      8613321361519752e-9
    ]
  },
  "EPSG:2663": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      29390396137055125e-9,
      5438592077506841e-9,
      29537223086274967e-9,
      8568678489688782e-9
    ]
  },
  "EPSG:2664": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      30391212473894253e-9,
      5479740137508675e-9,
      3052539587597458e-8,
      902855423262264e-8
    ]
  },
  "EPSG:2665": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      31392814100367647e-9,
      5559819101148453e-9,
      31525453663059626e-9,
      9026321566432199e-9
    ]
  },
  "EPSG:2666": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      323918555044012e-7,
      5511993043569505e-9,
      32525193596410446e-9,
      9036368581585966e-9
    ]
  },
  "EPSG:2667": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3339198889449763e-8,
      551866624752104e-8,
      3352649328362146e-8,
      89861339568522e-7
    ]
  },
  "EPSG:2668": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      34392836465944104e-9,
      5.5609313745435225e6,
      3452992200087718e-8,
      8853297022362867e-9
    ]
  },
  "EPSG:2669": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3539274702339736e-8,
      555648229172689e-8,
      3553135880459175e-8,
      8797485851457562e-9
    ]
  },
  "EPSG:2670": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3639079270048236e-8,
      545860974436096e-8,
      3653368121891824e-8,
      8707075368070645e-9
    ]
  },
  "EPSG:2671": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      37390550226808704e-9,
      5446376656285444e-9,
      3753821966922257e-8,
      8529617019074585e-9
    ]
  },
  "EPSG:2672": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3839132314122176e-8,
      5485300875377802e-9,
      3853853258307374e-8,
      8517340761956424e-9
    ]
  },
  "EPSG:2673": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3939136743152045e-8,
      5487525183130738e-9,
      3954495602001635e-8,
      8264026745784358e-9
    ]
  },
  "EPSG:2674": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      40392166933717676e-9,
      5527563953459505e-9,
      4054720320821655e-8,
      8174764396687429e-9
    ]
  },
  "EPSG:2675": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4139971503632732e-8,
      5895806624597178e-9,
      41546165019899175e-9,
      8216047460952335e-9
    ]
  },
  "EPSG:2676": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      42392189203532115e-9,
      5528676174789069e-9,
      42546165019899175e-9,
      8216047460952335e-9
    ]
  },
  "EPSG:2677": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      43377032806633756e-9,
      4727234901576959e-9,
      4354731532568054e-8,
      8170301443550731e-9
    ]
  },
  "EPSG:2678": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4437620803344076e-8,
      4680578118021258e-9,
      44551780207776815e-9,
      7991796720395234e-9
    ]
  },
  "EPSG:2679": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4537717091575298e-8,
      4.7350113430296825e6,
      45540803899345845e-9,
      8428061929769995e-9
    ]
  },
  "EPSG:2680": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4638123492963741e-8,
      4959455570728209e-9,
      46539754394286856e-9,
      846935271762947e-8
    ]
  },
  "EPSG:2681": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4738346901717669e-8,
      5079485912788836e-9,
      4753986793640131e-8,
      846488879232949e-8
    ]
  },
  "EPSG:2682": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4837890272983431e-8,
      4831668822749684e-9,
      4854057712449161e-8,
      843698956811353e-8
    ]
  },
  "EPSG:2683": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      49378882663662955e-9,
      4.8305577391275875e6,
      4953836192063122e-8,
      8524036889929483e-9
    ]
  },
  "EPSG:2684": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      50382160684361055e-9,
      5009465632580258e-9,
      505381912153834e-7,
      8530733047351377e-9
    ]
  },
  "EPSG:2685": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5138532023459773e-8,
      5177304110687376e-9,
      5153978278166578e-8,
      8468236735034157e-9
    ]
  },
  "EPSG:2686": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5239028617389528e-8,
      5433031718224293e-9,
      5253710910037266e-8,
      857314272023716e-8
    ]
  },
  "EPSG:2687": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      53395521284931526e-9,
      5693304683573038e-9,
      5355419098645532e-8,
      7894746223422435e-9
    ]
  },
  "EPSG:2688": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5440244155648437e-8,
      6024904119862094e-9,
      54554577756541274e-9,
      7879129686902671e-9
    ]
  },
  "EPSG:2689": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5540327219776204e-8,
      6063860534002597e-9,
      55557769467496626e-9,
      7749744170876845e-9
    ]
  },
  "EPSG:2690": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      56402702220325835e-9,
      6037147336431702e-9,
      56557083586981e-6,
      7.7776276566521935e6
    ]
  },
  "EPSG:2691": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5741594997591854e-8,
      6639542823063844e-9,
      5755675397135648e-8,
      7791011991040514e-9
    ]
  },
  "EPSG:2692": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      584188168338337e-7,
      6.7654268169739405e6,
      58557220851831734e-9,
      7772050900526357e-9
    ]
  },
  "EPSG:2693": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      59421638310934536e-9,
      6887987786261765e-9,
      5955424625950889e-8,
      7892515276132623e-9
    ]
  },
  "EPSG:2695": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      614285536495066e-7,
      7183322547602382e-9,
      61552834717312604e-9,
      7949405824594064e-9
    ]
  },
  "EPSG:2696": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      62427131424557775e-9,
      7123132838579394e-9,
      6256332332692538e-8,
      7522243311412292e-9
    ]
  },
  "EPSG:2697": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      634275258340785e-7,
      7139851785302197e-9,
      63562219197732404e-9,
      744188970980878e-8
    ]
  },
  "EPSG:2698": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      644439581603729e-7,
      7290058340345639e-9,
      64455716780549265e-9,
      7307697576988738e-9
    ]
  },
  "EPSG:2699": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      406948.8301598333,
      6022583485251955e-9,
      595223.4783814454,
      6133987390097153e-9
    ]
  },
  "EPSG:2700": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402441.55648437055,
      6024904119862094e-9,
      427812.9917642971,
      6105713654034847e-9
    ]
  },
  "EPSG:2701": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      475697.9110626195,
      6214307592642094e-9,
      560603.3207795997,
      7650494871812218e-9
    ]
  },
  "EPSG:2702": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      398946.923874054,
      5859084905706649e-9,
      557687.2205659978,
      7753090150158134e-9
    ]
  },
  "EPSG:2703": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      395248.4661511213,
      5679954968720522e-9,
      557220.8518317352,
      7772050900526357e-9
    ]
  },
  "EPSG:2704": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      380927.97993449896,
      4.9427863693147125e6,
      559339.4699759432,
      7701795976846415e-9
    ]
  },
  "EPSG:2705": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      378342.2814299158,
      4800559168272482e-9,
      560556.141767508,
      7635987315206223e-9
    ]
  },
  "EPSG:2706": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377427.89291726775,
      4749453541520347e-9,
      560719.4655302073,
      7629296130824446e-9
    ]
  },
  "EPSG:2707": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      375506.4042929116,
      4640589131628188e-9,
      526781.8798964409,
      897497086261004e-8
    ]
  },
  "EPSG:2708": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      374156.2874214335,
      45628394741493e-7,
      526464.4194597097,
      8987250269439492e-9
    ]
  },
  "EPSG:2709": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376423.401054909,
      4692797442893094e-9,
      525569.2277483135,
      9021856240672324e-9
    ]
  },
  "EPSG:2710": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      393621.33030501683,
      5599862072648273e-9,
      525020.1834382316,
      9043066616279008e-9
    ]
  },
  "EPSG:2711": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      393643.8139707809,
      5600974410548431e-9,
      523631.89010403317,
      9096651585371295e-9
    ]
  },
  "EPSG:2712": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      393508.9610162806,
      5594300409996985e-9,
      523574.0072075609,
      9098884318524582e-9
    ]
  },
  "EPSG:2713": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      394772.1495287308,
      5656593584927704e-9,
      523979.1256538399,
      9083255229693826e-9
    ]
  },
  "EPSG:2714": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402370.52935300244,
      6021565097104017e-9,
      525482.5554183148,
      9025205234163687e-9
    ]
  },
  "EPSG:2715": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      403653.13601132995,
      6081669883694747e-9,
      537479.4869704318,
      8558634017521972e-9
    ]
  },
  "EPSG:2716": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      400299.17744754936,
      5923627378462869e-9,
      547371.3756226961,
      8168069972943586e-9
    ]
  },
  "EPSG:2717": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      400392.81820123247,
      5928078800459592e-9,
      529922.0008771765,
      8853297022362867e-9
    ]
  },
  "EPSG:2718": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      395817.36039450805,
      5707767163782473e-9,
      526117.9857494653,
      9000646064981556e-9
    ]
  },
  "EPSG:2719": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      394026.535703342,
      5619884428578449e-9,
      526117.9857494652,
      9000646064981556e-9
    ]
  },
  "EPSG:2720": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391522.5526225407,
      5495310316975928e-9,
      536082.4058055106,
      8613321361519752e-9
    ]
  },
  "EPSG:2721": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390396.1370551269,
      5438592077506841e-9,
      537223.0862749652,
      8568678489688782e-9
    ]
  },
  "EPSG:2722": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391212.47389425186,
      5479740137508675e-9,
      525395.8759745805,
      902855423262264e-8
    ]
  },
  "EPSG:2723": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392814.10036764835,
      5559819101148453e-9,
      525453.6630596248,
      9026321566432199e-9
    ]
  },
  "EPSG:2724": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391855.5044011981,
      5511993043569505e-9,
      525193.5964104452,
      9036368581585966e-9
    ]
  },
  "EPSG:2725": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391988.8944976275,
      551866624752104e-8,
      526493.2836214605,
      89861339568522e-7
    ]
  },
  "EPSG:2726": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392836.46594410564,
      5.5609313745435225e6,
      529922.0008771765,
      8853297022362867e-9
    ]
  },
  "EPSG:2727": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392747.02339736186,
      555648229172689e-8,
      531358.8045917508,
      8797485851457562e-9
    ]
  },
  "EPSG:2728": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390792.7004823582,
      545860974436096e-8,
      533681.2189182389,
      8707075368070645e-9
    ]
  },
  "EPSG:2729": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390550.226808702,
      5446376656285444e-9,
      538219.6692225707,
      8529617019074585e-9
    ]
  },
  "EPSG:2730": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391323.1412217622,
      5485300875377802e-9,
      538532.5830737436,
      8517340761956424e-9
    ]
  },
  "EPSG:2731": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      391367.4315204483,
      5487525183130738e-9,
      544956.0200163496,
      8264026745784358e-9
    ]
  },
  "EPSG:2732": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392166.93371767306,
      5527563953459505e-9,
      547203.2082165445,
      8174764396687429e-9
    ]
  },
  "EPSG:2733": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      399715.0363273198,
      5895806624597178e-9,
      546165.0198991738,
      8216047460952335e-9
    ]
  },
  "EPSG:2734": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      392189.2035321128,
      5528676174789069e-9,
      546165.0198991745,
      8216047460952335e-9
    ]
  },
  "EPSG:2735": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377032.8066337532,
      4727234901576959e-9,
      547315.3256805356,
      8170301443550731e-9
    ]
  },
  "EPSG:2736": {
    proj4: "+proj=utm +zone=36 +south +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      222801.65214669856,
      7025078037524216e-9,
      827413.1640705413,
      8737067942639949e-9
    ]
  },
  "EPSG:2737": {
    proj4: "+proj=utm +zone=37 +south +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      183039.55172368226,
      7898801642165867e-9,
      707996.8942948064,
      88475985184654e-7
    ]
  },
  "EPSG:2738": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376208.0334407599,
      4680578118021258e-9,
      551780.2077768123,
      7991796720395234e-9
    ]
  },
  "EPSG:2739": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      377170.9157529762,
      4.7350113430296825e6,
      540803.8993458475,
      8428061929769995e-9
    ]
  },
  "EPSG:2740": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      381234.9296374115,
      4959455570728209e-9,
      539754.3942868551,
      846935271762947e-8
    ]
  },
  "EPSG:2741": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      383469.0171766905,
      5079485912788836e-9,
      539867.9364013111,
      846488879232949e-8
    ]
  },
  "EPSG:2742": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      378902.72983430716,
      4831668822749684e-9,
      540577.1244916127,
      843698956811353e-8
    ]
  },
  "EPSG:2743": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      378882.6636629543,
      4.8305577391275875e6,
      538361.9206312259,
      8524036889929483e-9
    ]
  },
  "EPSG:2744": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      382160.68436105846,
      5009465632580258e-9,
      538191.2153834053,
      8530733047351377e-9
    ]
  },
  "EPSG:2745": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      385320.23459772696,
      5177304110687376e-9,
      539782.7816657781,
      8468236735034157e-9
    ]
  },
  "EPSG:2746": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      390286.1738952751,
      5433031718224293e-9,
      537109.1003726585,
      857314272023716e-8
    ]
  },
  "EPSG:2747": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      395521.2849315221,
      5693304683573038e-9,
      554190.9864553215,
      7894746223422435e-9
    ]
  },
  "EPSG:2748": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402441.55648437014,
      6024904119862094e-9,
      554577.7565412731,
      7879129686902671e-9
    ]
  },
  "EPSG:2749": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      403272.19776203996,
      6063860534002597e-9,
      557769.467496629,
      7749744170876845e-9
    ]
  },
  "EPSG:2750": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      402702.2203258358,
      6037147336431702e-9,
      557083.5869809991,
      7.7776276566521935e6
    ]
  },
  "EPSG:2751": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      415949.9759185419,
      6639542823063844e-9,
      556753.9713564805,
      7791011991040514e-9
    ]
  },
  "EPSG:2752": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      418816.8338336995,
      6.7654268169739405e6,
      557220.8518317357,
      7772050900526357e-9
    ]
  },
  "EPSG:2753": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      421638.3109345345,
      6887987786261765e-9,
      554246.259508891,
      7892515276132623e-9
    ]
  },
  "EPSG:2754": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      422025.3487051754,
      6904702074893652e-9,
      552723.826723176,
      7953867950004541e-9
    ]
  },
  "EPSG:2755": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      428553.6495065995,
      7183322547602382e-9,
      552834.7173126015,
      7949405824594064e-9
    ]
  },
  "EPSG:2756": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      427131.4245577723,
      7123132838579394e-9,
      563323.3269253826,
      7522243311412292e-9
    ]
  },
  "EPSG:2757": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      427525.8340784968,
      7139851785302197e-9,
      562219.1977324008,
      744188970980878e-8
    ]
  },
  "EPSG:2758": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      443958.1603729015,
      7290058340345639e-9,
      455716.78054926643,
      7307697576988738e-9
    ]
  },
  "EPSG:2759": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "EPSG:2760": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      505580.44594500464,
      15923.948440411992,
      709514.5981036696,
      557319.3872848145
    ]
  },
  "EPSG:2761": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66481.57726905748,
      37612.94225911591,
      313625.1177186511,
      667173.219860401
    ]
  },
  "EPSG:2762": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76951.28315104556,
      37471.49767701424,
      344774.25509364414,
      667599.2730779602
    ]
  },
  "EPSG:2763": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113255.82314843503,
      116906.13012893949,
      322839.39768852945,
      666199.5535385566
    ]
  },
  "EPSG:2764": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      159882.1517288231,
      40546.019450230866,
      611428.2003751276,
      242921.67605554135
    ]
  },
  "EPSG:2765": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      168267.01668838607,
      440888.471984403,
      545890.5412777681,
      671045.3781161602
    ]
  },
  "EPSG:2766": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7895395665343686e6,
      531443.8371340163,
      216650689441652e-8,
      799143.9865565519
    ]
  },
  "EPSG:2767": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8191142581414783e6,
      541273.7589847766,
      2.2095712464330723e6,
      779630.525372654
    ]
  },
  "EPSG:2768": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1774907679626609e-9,
      528557.1371854008,
      2.2322182534678923e6,
      748597.178483144
    ]
  },
  "EPSG:2769": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1727886776452719e-9,
      553828.3138820408,
      2298520922247323e-9,
      754562.841666431
    ]
  },
  "EPSG:2770": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6794231645368338e6,
      423356.5291107174,
      2350617831343431e-9,
      763023.8066438821
    ]
  },
  "EPSG:2771": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8215040867444675e6,
      541921.609051466,
      2168903381623939e-9,
      713685.2401208607
    ]
  },
  "EPSG:2772": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      608530.8153568001,
      336108.1196154525,
      1.2054047088972987e6,
      496651.021459994
    ]
  },
  "EPSG:2773": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      602369.9938571034,
      344958.28088118456,
      1.2094300492099929e6,
      560943.6928306813
    ]
  },
  "EPSG:2774": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      597496.3981335191,
      345615.6716642405,
      1.2154220791101314e6,
      533836.9174519398
    ]
  },
  "EPSG:2775": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222322.54347837297,
      169156.3466800607,
      385103.12220492034,
      287977.4369607322
    ]
  },
  "EPSG:2776": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166533.1617424154,
      48909.64130833831,
      238225.79702413955,
      205470.4830819298
    ]
  },
  "EPSG:2777": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      65102.24329868861,
      9138.495345549798,
      298540.2068111297,
      720329.5066960583
    ]
  },
  "EPSG:2778": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66150.82424507887,
      215219.2456022235,
      284274.37357896275,
      583846.6255438706
    ]
  },
  "EPSG:2779": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      295646.50247016025,
      27456.531402877317,
      834910.9831262925,
      225348.7609827654
    ]
  },
  "EPSG:2780": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      74709.789308767,
      40624.309794496774,
      327985.22104999487,
      519815.2404935042
    ]
  },
  "EPSG:2781": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      561618.6831736781,
      69612.78234582106,
      807394.5382984749,
      556166.0817971718
    ]
  },
  "EPSG:2782": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      436777.08375684114,
      4165.575750461832,
      579363.8665818895,
      165857.1024786704
    ]
  },
  "EPSG:2783": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427654.1631252822,
      13068.587207479659,
      576457.1208456453,
      102770.16729568072
    ]
  },
  "EPSG:2784": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465735.88276390824,
      3726.293434735615,
      540342.2667704654,
      64638.67443510627
    ]
  },
  "EPSG:2785": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      463810.4999186106,
      -2542.5573324230195,
      527823.5334422863,
      50591.56716225392
    ]
  },
  "EPSG:2786": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      486205.7939946483,
      7018.603270238967,
      518234.0339630389,
      44671.05923083076
    ]
  },
  "EPSG:2787": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      111063.71939851393,
      36468.06030250205,
      289214.9223945835,
      343148.0611808968
    ]
  },
  "EPSG:2788": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      392281.83037533704,
      36728.336945737465,
      602797.1348322467,
      448951.8476535554
    ]
  },
  "EPSG:2789": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      676539.7837076162,
      36984.30998402688,
      904606.2381105269,
      817057.2289334119
    ]
  },
  "EPSG:2790": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215802.92024991306,
      44068.31688321397,
      407952.84533971857,
      648476.2402160055
    ]
  },
  "EPSG:2791": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      579509.9562219738,
      35625.98718209203,
      801631.300013067,
      649470.3402959756
    ]
  },
  "EPSG:2792": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18848.169675766898,
      300346.5557813935,
      173722.82933421258,
      724452.6023682763
    ]
  },
  "EPSG:2793": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      813951.5557038783,
      280415.4110952896,
      970119.8033495815,
      724416.3646416317
    ]
  },
  "EPSG:2794": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2384564841177673e6,
      1043750404067701e-9,
      1.7708357650029673e6,
      1.2286439962682903e6
    ]
  },
  "EPSG:2795": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275804.31496850675,
      44490.99603974775,
      778150.4552814267,
      231925.01089940732
    ]
  },
  "EPSG:2796": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      46038.237386999186,
      28658.252530809354,
      691948.0045848172,
      191653.8734461696
    ]
  },
  "EPSG:2797": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      84022.72728234128,
      441902.1544802367,
      738340.2719366557,
      652740.3625160322
    ]
  },
  "EPSG:2798": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      349218.2791870525,
      24709.163041468903,
      653864.4011060491,
      184641.09895005127
    ]
  },
  "EPSG:2799": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      157793.0920864537,
      524305.3717931777,
      832918.8536462528,
      710531.6721022655
    ]
  },
  "EPSG:2800": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      851729.3635550354,
      39868.512993891505,
      1153221324211875e-9,
      281692.5559034941
    ]
  },
  "EPSG:2801": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      745633.3912495468,
      41691.410611282045,
      1246542614779638e-9,
      287665.49443279085
    ]
  },
  "EPSG:2802": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177049.16196835245,
      24838.65270351215,
      419851.20673729526,
      423896.7865970171
    ]
  },
  "EPSG:2803": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      824761.6428981957,
      23371.92855680277,
      969493.4665432682,
      416737.78627018543
    ]
  },
  "EPSG:2804": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181219.09721396962,
      36655.85913985907,
      574026.6173549057,
      230987.04872253875
    ]
  },
  "EPSG:2805": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32912.32927433509,
      803051.4395878355,
      333962.18491762364,
      961218.4864862445
    ]
  },
  "EPSG:2806": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465603.8085218641,
      21182.19390165996,
      550924.4533078014,
      56819.46303831281
    ]
  },
  "EPSG:2807": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7730770077384338e-9,
      38783.29196926807,
      8264072881829599e-9,
      399102.5058484581
    ]
  },
  "EPSG:2808": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5783269683611322e-9,
      57309.82074061751,
      6162640001784503e-9,
      291399.94080042426
    ]
  },
  "EPSG:2809": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3764135981418406e-9,
      25074.8909276311,
      4178741346471115e-9,
      304539.3832952072
    ]
  },
  "EPSG:2810": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      484662.883379609,
      123970.60197833316,
      1.0621099971384865e6,
      426349.3882135941
    ]
  },
  "EPSG:2811": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      595233.1859048485,
      134496.0658554411,
      947732.4888004595,
      377495.16347312875
    ]
  },
  "EPSG:2812": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      569492.5128116711,
      158465.4349358629,
      1.0176934793720534e6,
      391514.8607947015
    ]
  },
  "EPSG:2813": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      190340.12052613805,
      57073.9038946292,
      367846.54652006144,
      611234.9881211288
    ]
  },
  "EPSG:2814": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      574253.7728630524,
      167020.95974745313,
      787927.2680533797,
      611406.5844740515
    ]
  },
  "EPSG:2815": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      117430.21416727672,
      17271.89955836394,
      368474.73767414974,
      531120.8788109587
    ]
  },
  "EPSG:2816": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384402.582974351,
      72524.35270280449,
      592240.4863549052,
      530749.7674890533
    ]
  },
  "EPSG:2817": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857344828,
      35516.95357112248,
      936343.0942781423,
      491477.91794944176
    ]
  },
  "EPSG:2818": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76530.54027482809,
      33084.524119235604,
      999117.0470033675,
      542896.2532425779
    ]
  },
  "EPSG:2819": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153376.2252400727,
      25535.919165928193,
      882993.4575054274,
      363144.7550580989
    ]
  },
  "EPSG:2820": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69754.74639531817,
      802755247237993e-8,
      328683.6587060269,
      880586542636728e-8
    ]
  },
  "EPSG:2821": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      362659.33828742534,
      6139743768849751e-9,
      641055.3972230253,
      6694999823411577e-9
    ]
  },
  "EPSG:2822": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      673826.6301758505,
      4245017139322905e-9,
      931997.4907157569,
      4.8059263308652975e6
    ]
  },
  "EPSG:2823": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226793.8024079331,
      21492.387739553997,
      381293.173427484,
      312732.6717501454
    ]
  },
  "EPSG:2824": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      54545.12015456795,
      4645.126015017602,
      201873.90102511132,
      280709.69043490384
    ]
  },
  "EPSG:2825": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33975.77074362352,
      111708.32825589125,
      284564.5241670381,
      666319.758960204
    ]
  },
  "EPSG:2826": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      359824.2791681125,
      87428.3980117214,
      625497.4318649578,
      666399.5233026792
    ]
  },
  "EPSG:2827": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      713259.0787200994,
      37234.66266182869,
      964697.4631390541,
      666551.8767344605
    ]
  },
  "EPSG:2828": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34535.94492432893,
      228126.12062753108,
      250090.6353354547,
      687881.3551997013
    ]
  },
  "EPSG:2829": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153330.97415895032,
      221641.78111359302,
      372921.93601385155,
      490979.04527605977
    ]
  },
  "EPSG:2830": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251673.76576198317,
      221664.55284669463,
      448704.434264811,
      404996.19022632844
    ]
  },
  "EPSG:2831": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277950.22920969536,
      33716.39444708275,
      484240.9609220226,
      128170.64580043124
    ]
  },
  "EPSG:2832": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329319.5931117032,
      22953.606831219873,
      868402.9550716814,
      229887.8527663513
    ]
  },
  "EPSG:2833": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324736.07413660234,
      35492.61573469327,
      895638.4324845031,
      247922.52117242807
    ]
  },
  "EPSG:2834": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403035.4105968764,
      50729.9881009595,
      764034.121937581,
      297653.7686659716
    ]
  },
  "EPSG:2835": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      396472.80539090245,
      47032.74485349966,
      752900.9644348032,
      263532.0000815143
    ]
  },
  "EPSG:2836": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      145234.1114682252,
      41670.65752654181,
      918564.8787926256,
      228901.9813547924
    ]
  },
  "EPSG:2837": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      414409.71996951895,
      33637.59674371423,
      924488.3684600198,
      253870.04933969502
    ]
  },
  "EPSG:2838": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546260644754e-8,
      38177.19394785736,
      2.8106066110863457e6,
      295944.2058068297
    ]
  },
  "EPSG:2839": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1160304687469061e-9,
      43124.56959847481,
      1785979111173056e-9,
      327582.564817976
    ]
  },
  "EPSG:2840": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70610.77827680032,
      5241.624167031077,
      134786.23705289746,
      104115.19509468034
    ]
  },
  "EPSG:2841": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      274445.55115673057,
      42263.33611194055,
      875171.275386896,
      241258.5494374619
    ]
  },
  "EPSG:2842": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      293645.5414990948,
      23168.18099115532,
      908809.9399088017,
      280198.16460002324
    ]
  },
  "EPSG:2843": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206556.4167882325,
      80414.01570951591,
      988711.5866813468,
      269011.42753063503
    ]
  },
  "EPSG:2844": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      59141.726237106894,
      1.0343726299247856e6,
      335289.3759396124,
      1.2783945558126816e6
    ]
  },
  "EPSG:2845": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166935.12352544628,
      2015335542194466e-9,
      1.0128529570071837e6,
      2.3319457757578273e6
    ]
  },
  "EPSG:2846": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      88485.92409938853,
      302995849409869e-8,
      1.3434805489688965e6,
      3308389707573836e-9
    ]
  },
  "EPSG:2847": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8759.288909710362,
      4.0092582172219283e6,
      1.1020569519511203e6,
      4.3256547587438645e6
    ]
  },
  "EPSG:2848": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      129543.46292791484,
      5019245231079103e-9,
      461995.7043444619,
      5282860637212539e-9
    ]
  },
  "EPSG:2849": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284873.76674905524,
      1.0272050082885996e6,
      703762.8414941019,
      1189089125360079e-9
    ]
  },
  "EPSG:2850": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277517.6837629482,
      2.0205658722523483e6,
      706724.0386204798,
      2307801683101201e-9
    ]
  },
  "EPSG:2851": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      273008.07224937936,
      3038980003301329e-9,
      714340.5503610092,
      3.2151793513247273e6
    ]
  },
  "EPSG:2852": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      423006.8382807577,
      24866.35169431841,
      578802.8666454776,
      281578.89655270055
    ]
  },
  "EPSG:2853": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3625533262610403e6,
      2.0126377358033953e6,
      3671261036751879e-9,
      2.2009270598530993e6
    ]
  },
  "EPSG:2854": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0363669807438697e6,
      1035658136976271e-9,
      3779083924305619e-9,
      1.2207621363122454e6
    ]
  },
  "EPSG:2855": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199622.13896693767,
      16618.325904665824,
      778655.8701648887,
      234845.72192574284
    ]
  },
  "EPSG:2856": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195499.3912097729,
      30501.042787402166,
      769845.025376511,
      259212.8282079461
    ]
  },
  "EPSG:2857": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403574.77820059075,
      31335.654182597726,
      750577.3343822454,
      239088.0765441185
    ]
  },
  "EPSG:2858": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      453513.4977037739,
      23502.170616556796,
      768516.5072083795,
      242635.52047372516
    ]
  },
  "EPSG:2859": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373644.5392621008,
      26717.932057823346,
      747455.7457836679,
      240055.50940082088
    ]
  },
  "EPSG:2860": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      368160.8288686152,
      20423.476917061555,
      891449.2804629535,
      225280.70276785115
    ]
  },
  "EPSG:2861": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      482416.58582546015,
      54333.04951709173,
      843230.2890341961,
      263304.7487854953
    ]
  },
  "EPSG:2862": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      102113.10863394958,
      55062.47534181787,
      288024.8211402613,
      501582.3192299155
    ]
  },
  "EPSG:2863": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      290893.7234442881,
      155220.4817241857,
      505104.26743197144,
      601840.6136762074
    ]
  },
  "EPSG:2864": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      405623.04948556976,
      56981.50934947065,
      698535.2494466461,
      501735.86149144557
    ]
  },
  "EPSG:2865": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      717820.1237859536,
      154870.05021642725,
      882729.2572612413,
      563723.8222876207
    ]
  },
  "EPSG:2866": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      36907.96076240871,
      177072.36487476467,
      403024.65399685316,
      282602.55471139686
    ]
  },
  "EPSG:2867": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "EPSG:2868": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "EPSG:2869": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2229279364,
      383550.2956986203,
      1.0591843756185349e6,
      2185694073289227e-9
    ]
  },
  "EPSG:2870": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061538175e-9,
      1743578655997185e-9,
      7107948036431532e-9,
      2621858229560954e-9
    ]
  },
  "EPSG:2871": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695585834e-9,
      1.7758289912692206e6,
      7249234998005839e-9,
      2557837815660115e-9
    ]
  },
  "EPSG:2872": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5823176279241634e-9,
      1.7341078745824352e6,
      7323536053585911e-9,
      2456022576740115e-9
    ]
  },
  "EPSG:2873": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532745296e-9,
      1.8170183934613287e6,
      7541064059406428e-9,
      2.4755949233672824e6
    ]
  },
  "EPSG:2874": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907499317929e-9,
      1.3889622129240783e6,
      7711985335332574e-9,
      2.5033539392974693e6
    ]
  },
  "EPSG:2875": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324927474e-9,
      1.7779544793630175e6,
      711581051154454e-8,
      2.3414823256298574e6
    ]
  },
  "EPSG:2876": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881830670196e6,
      1.1027147224423632e6,
      3.9547319487911398e6,
      1.6294292262439965e6
    ]
  },
  "EPSG:2877": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755545300983e6,
      1.1317506265283525e6,
      3.9679384194670366e6,
      1.8403627655659935e6
    ]
  },
  "EPSG:2878": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9602860992269719e6,
      1.1339074161224284e6,
      3.9875972708977414e6,
      1.7514299533442387e6
    ]
  },
  "EPSG:2879": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113992947,
      554973.7807348338,
      1.2634591601046422e6,
      944805.9744306704
    ]
  },
  "EPSG:2880": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.5484832405,
      160464.3815257733,
      781579.1360700305,
      674114.4099112981
    ]
  },
  "EPSG:2881": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.61022244688,
      29981.8801461913,
      979460.662179514,
      2363281056551985e-9
    ]
  },
  "EPSG:2882": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.82954406223,
      706098.4749466283,
      932656.8409836462,
      1.9155034706385157e6
    ]
  },
  "EPSG:2883": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "EPSG:2884": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.36742384572,
      133281.58971744485,
      1.0760648463948576e6,
      1705427168185772e-9
    ]
  },
  "EPSG:2885": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772960456433e6,
      228387.93674624796,
      2648926914067581e-9,
      1.8246882200295548e6
    ]
  },
  "EPSG:2886": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.5530599571,
      119645.62784245881,
      948865.9582228954,
      1.1258115973909926e6
    ]
  },
  "EPSG:2887": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1287011305489751e-9,
      120499.55212947368,
      1.9776769335287954e6,
      1472936186843373e-9
    ]
  },
  "EPSG:2888": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2219614274047403e-9,
      121339.35700592819,
      2.9678622998676198e6,
      2.6806285919257025e6
    ]
  },
  "EPSG:2891": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269712995207e6,
      81066.64574521924,
      2145220122962096e-9,
      605776.6721386266
    ]
  },
  "EPSG:2892": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83662030625,
      1.7201585409581168e6,
      2.7326679393377476e6,
      2331135994555516e-9
    ]
  },
  "EPSG:2893": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6544428327,
      120261.76452802098,
      1.8832856601052207e6,
      757830.009017196
    ]
  },
  "EPSG:2894": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86729421368,
      2.6346779313810905e6,
      1095674268683903e-9,
      3.1535976510802875e6
    ]
  },
  "EPSG:2895": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5275684954588155e6,
      69495.24782569606,
      1.8074913108940115e6,
      186415.18831819796
    ]
  },
  "EPSG:2896": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      25363418888951235e-9,
      127241.77155271676,
      2711310000589763e-8,
      1.3093914233873296e6
    ]
  },
  "EPSG:2897": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901533205e-9,
      188024.34626186846,
      20218635176379602e-9,
      956036.5511824941
    ]
  },
  "EPSG:2898": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498039389e-9,
      82266.70251847472,
      13709781320390796e-9,
      999144.9583176089
    ]
  },
  "EPSG:2899": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "EPSG:2900": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1884030919468199e-9,
      547967.9321047692,
      2585058044938464e-9,
      2005923102561951e-9
    ]
  },
  "EPSG:2901": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497126905,
      108545.02663791207,
      3.2779430675884755e6,
      1781155686491397e-9
    ]
  },
  "EPSG:2902": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84118137152,
      366496.4069528699,
      933608.7763713576,
      2.1860840758552696e6
    ]
  },
  "EPSG:2903": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234895707152e6,
      286838.0024767893,
      2.0521528247102818e6,
      2.1863457693688734e6
    ]
  },
  "EPSG:2904": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2340084161100859e-9,
      122160.72241634964,
      3.1650115939820465e6,
      2186845615586309e-9
    ]
  },
  "EPSG:2905": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "EPSG:2906": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37071982364,
      727169.7435368465,
      1223494718072112e-9,
      1610820417709873e-9
    ]
  },
  "EPSG:2907": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6801707726,
      727244.453797864,
      1.4721244650838003e6,
      1328725000767546e-9
    ]
  },
  "EPSG:2908": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.870781804,
      1.5887138859583358e6,
      420506.5270969149
    ]
  },
  "EPSG:2909": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592824906e6,
      75307.10902631191,
      2849091059938587e-9,
      754225.2387347483
    ]
  },
  "EPSG:2910": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      106540706736943e-8,
      116445.58968075218,
      2938446300794301e-9,
      813394.0983347377
    ]
  },
  "EPSG:2911": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.48223499593,
      3.0136582731721397e6,
      750989.2504948481
    ]
  },
  "EPSG:2912": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3033092255522582e-9,
      832905.3202086495
    ]
  },
  "EPSG:2913": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:2914": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:2915": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3.2437979306370523e6,
      882581.6584900919
    ]
  },
  "EPSG:2916": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.14716290752,
      3.3936042030115686e6,
      1.1000285612285445e6,
      4.1941994715287737e6
    ]
  },
  "EPSG:2917": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980025016344e-9,
      3323001743114402e-9,
      7650725432965473e-9
    ]
  },
  "EPSG:2918": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5689827447,
      9940788826055452e-9,
      4407735767408789e-9,
      10854275232265161e-9
    ]
  },
  "EPSG:2919": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.767031274747,
      13153708000668947e-9,
      3.6156651831929674e6,
      14191752320645498e-9
    ]
  },
  "EPSG:2920": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062632026e-9,
      1.5157309066701222e6,
      17332185274254806e-9
    ]
  },
  "EPSG:2921": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      934625.2194864015,
      3.3700951715373998e6,
      2.3089332074950845e6,
      3.9012110411944846e6
    ]
  },
  "EPSG:2922": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      910491.0889545543,
      6629153124161247e-9,
      2.3186484211643036e6,
      7571527831670606e-9
    ]
  },
  "EPSG:2923": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      895695.7755898271,
      9970406834938742e-9,
      2343636976743468e-9,
      10548488685409209e-9
    ]
  },
  "EPSG:2924": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703824143e-8,
      660312897188164e-8,
      1204479558507679e-8,
      7220874862534711e-9
    ]
  },
  "EPSG:2925": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002990512e-9,
      3397821737396317e-9,
      12398544508659353e-9,
      4.0051171085510924e6
    ]
  },
  "EPSG:2926": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9679273608,
      54521.95757222446,
      2554640134365972e-9,
      770489.672684708
    ]
  },
  "EPSG:2927": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9196607294,
      100068.83787833528,
      2525733221089436e-9,
      850434.0872122366
    ]
  },
  "EPSG:2928": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "EPSG:2929": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205946,
      2.9246965143188736e6,
      739108.438997525
    ]
  },
  "EPSG:2930": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.67995732513,
      2766498039939692e-9,
      863858.9966404126
    ]
  },
  "EPSG:2931": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -63969.98072922963,
      1.4205623451661407e6,
      702596.8450317406,
      1.8471716583596996e6
    ]
  },
  "EPSG:2932": {
    proj4: "+proj=tmerc +lat_0=24.45 +lon_0=51.2166666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      146638.75328730507,
      311178.5404459303,
      246310.84172649332,
      493945.5063699561
    ]
  },
  "EPSG:2933": {
    proj4: "+proj=utm +zone=50 +south +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      468853.74663474964,
      9862954019553877e-9,
      610154.9530750124,
      1e7
    ]
  },
  "EPSG:2935": {
    proj4: "+proj=tmerc +lat_0=0.116666666666667 +lon_0=41.5333333333333 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1708760475925603e6,
      4569994489889461e-9,
      1.4216757935339122e6,
      4816555836426949e-9
    ]
  },
  "EPSG:2936": {
    proj4: "+proj=tmerc +lat_0=0.116666666666667 +lon_0=44.5333333333333 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2.1695282729722257e6,
      429232203816007e-8,
      2.4227584331716616e6,
      4756560106058768e-9
    ]
  },
  "EPSG:2937": {
    proj4: "+proj=tmerc +lat_0=0.116666666666667 +lon_0=47.5333333333333 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3.1686370991907762e6,
      423792283302562e-8,
      3424636412039432e-9,
      4651024895667492e-9
    ]
  },
  "EPSG:2938": {
    proj4: "+proj=tmerc +lat_0=0.116666666666667 +lon_0=50.5333333333333 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4167755565285296e-9,
      4183527873060046e-9,
      4398225884278137e-9,
      4705050475520541e-9
    ]
  },
  "EPSG:2939": {
    proj4: "+proj=tmerc +lat_0=0.133333333333333 +lon_0=50.7666666666667 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2.1735200427070674e6,
      4543663067824951e-9,
      2403773185945916e-9,
      5724179378168784e-9
    ]
  },
  "EPSG:2940": {
    proj4: "+proj=tmerc +lat_0=0.133333333333333 +lon_0=53.7666666666667 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3.1741178052394195e6,
      4.5780937577474285e6,
      3403727307295756e-9,
      5.7264045004209755e6
    ]
  },
  "EPSG:2941": {
    proj4: "+proj=tmerc +lat_0=0.133333333333333 +lon_0=56.7666666666667 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4173731727141673e-9,
      4555880211174365e-9,
      4405211803035204e-9,
      5654091663181183e-9
    ]
  },
  "EPSG:2942": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      282606.26840470236,
      3.5816314340632767e6,
      385284.775575673,
      3.6686457012004736e6
    ]
  },
  "EPSG:2943": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392913.63690535654,
      3317135806822846e-9,
      423962.7989209326,
      3342367985547919e-9
    ]
  },
  "EPSG:2945": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      191797.0588894946,
      5263399287544292e-9,
      393531.0745527109,
      6139812811649809e-9
    ]
  },
  "EPSG:2946": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      191069.35639250712,
      5225603830010193e-9,
      391199.5989891613,
      6534072854250059e-9
    ]
  },
  "EPSG:2947": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      192766.35373007116,
      5313425913117096e-9,
      387169.92260410154,
      6712276997392e-6
    ]
  },
  "EPSG:2948": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      191389.90588198055,
      5242278037802561e-9,
      390999.70872502594,
      6542982088926093e-9
    ]
  },
  "EPSG:2949": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      186562.1302475625,
      4986651818248523e-9,
      383899.1959539077,
      6854869249580907e-9
    ]
  },
  "EPSG:2950": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      186500.4094665522,
      4983318199325804e-9,
      382015.8443033126,
      6.9362026173374085e6
    ]
  },
  "EPSG:2951": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      183757.00091203628,
      4833322301442292e-9,
      381705.0283408768,
      6949573253538423e-9
    ]
  },
  "EPSG:2952": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181042.0392854039,
      4681138104747794e-9,
      382222.86432708433,
      6927288979642742e-9
    ]
  },
  "EPSG:2953": {
    proj4: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.2973852789392835e6,
      7.2876012444234695e6,
      2.7086631627243985e6,
      767828970348011e-8
    ]
  },
  "EPSG:2954": {
    proj4: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284369.89898945676,
      651028.9449166519,
      483512.251150617,
      782801.6240353768
    ]
  },
  "EPSG:2955": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901135,
      5430681423873871e-9,
      537898.6633350778,
      9273261908761378e-9
    ]
  },
  "EPSG:2956": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:2957": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:2958": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      250254.16737771095,
      4617486815618051e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:2959": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      257982.5584520604,
      4835152983178707e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:2960": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      246917.18544612406,
      4520887054048674e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:2961": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      244050.00895109907,
      4436509744106726e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:2962": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      238596.64535791575,
      4272219139229722e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "EPSG:2964": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -7405489415497937e-9,
      2.3845211363330707e6,
      2816059684129435e-9,
      8315894581720717e-9
    ]
  },
  "EPSG:2965": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70301124523,
      985386.9914261225,
      569955.6489073292,
      2.3768082459365875e6
    ]
  },
  "EPSG:2966": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393956718077e6,
      919996.2275684634,
      3.1828013881560857e6,
      2.3766893559950874e6
    ]
  },
  "EPSG:2967": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70301124523,
      985386.9914261225,
      569955.6489073292,
      2.3768082459365875e6
    ]
  },
  "EPSG:2968": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393956718077e6,
      919996.2275684634,
      3.1828013881560857e6,
      2.3766893559950874e6
    ]
  },
  "EPSG:2969": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      477745.4576167865,
      1.9703077717474666e6,
      528556.6425488614,
      2009039472578366e-9
    ]
  },
  "EPSG:2970": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      623174.0218054055,
      1.7471701441543351e6,
      716635.8044327177,
      1830890409599189e-9
    ]
  },
  "EPSG:2971": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166603.68366167508,
      379649.3121206524,
      432464.7147481524,
      642245.0950515373
    ]
  },
  "EPSG:2972": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166259.78529881366,
      240182.41586781724,
      670442.3867769681,
      981941.3024976149
    ]
  },
  "EPSG:2973": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      684412.9180257954,
      1587135963140958e-9,
      740958.1973738096,
      1.6518171890304566e6
    ]
  },
  "EPSG:2975": {
    proj4: "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      196497.6159470986,
      7262730879340785e-9,
      631069.189567503,
      7978390979911227e-9
    ]
  },
  "EPSG:2976": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182155.62144796562,
      8014971337546237e-9,
      275847.8606817934,
      8073829067801932e-9
    ]
  },
  "EPSG:2977": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      616058.2673890517,
      8124525230102114e-9,
      725612.8537531571,
      8211081314223438e-9
    ]
  },
  "EPSG:2978": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      575722.9537791273,
      894204149631833e-8,
      671622.8106230092,
      9035738539211886e-9
    ]
  },
  "EPSG:2980": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      497831.52082027635,
      8557318138219088e-9,
      538014.6037354566,
      8605950819343597e-9
    ]
  },
  "EPSG:2981": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      705487.1456188019,
      7649973912572586e-9,
      762632.6424488659,
      7717843312152257e-9
    ]
  },
  "EPSG:2987": {
    proj4: "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      539762.559607864,
      5170628785414807e-9,
      570454.6976500757,
      522647934886562e-8
    ]
  },
  "EPSG:2988": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      581200.7827249687,
      851738268780144e-8,
      600793.5043626277,
      854496722948711e-8
    ]
  },
  "EPSG:2991": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      60163.86735144921,
      34049.00237979901,
      710705.1662058923,
      508757.95951940055
    ]
  },
  "EPSG:2992": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +datum=NAD83 +units=ft +no_defs +type=crs",
    projected_bounds: [
      197388.0162396627,
      111709.32539304135,
      2.3317098628749745e6,
      1.6691534104967208e6
    ]
  },
  "EPSG:2993": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60163.86735144921,
      34049.00237979901,
      710705.1662058923,
      508757.95951940055
    ]
  },
  "EPSG:2994": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      197388.0162396627,
      111709.32539304135,
      2.3317098628749745e6,
      1.6691534104967208e6
    ]
  },
  "EPSG:2995": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      784522.4669554641,
      7596713474404179e-9,
      811235.2228633696,
      7639441950303779e-9
    ]
  },
  "EPSG:2996": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      742393.2171406125,
      7484406272610035e-9,
      768548.3539695612,
      7.5105621373614445e6
    ]
  },
  "EPSG:2997": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      347113.1412668368,
      7804428518150989e-9,
      368822.06324348145,
      7843342544840092e-9
    ]
  },
  "EPSG:2998": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      638998.7218350341,
      7525562925485341e-9,
      658767.8069446665,
      7545304745778958e-9
    ]
  },
  "EPSG:2999": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      299652.20928280347,
      8673868450071538e-9,
      341742.2381254296,
      874933629952285e-8
    ]
  },
  "EPSG:3000": {
    proj4: "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4404925595391867e-9,
      432183.510811514,
      4905412284450619e-9,
      1.3733435980596216e6
    ]
  },
  "EPSG:3001": {
    proj4: "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2253165750414217e-9,
      -86202.69350955344,
      4540312238551884e-9,
      1559294896294201e-9
    ]
  },
  "EPSG:3002": {
    proj4: "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      486657185403586e-8,
      177491.30226585164,
      5096285256774577e-9,
      692726.1743573038
    ]
  },
  "EPSG:3003": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1226016210788518e-9,
      4047158633340355e-9,
      1727909853789162e-9,
      5214077882908902e-9
    ]
  },
  "EPSG:3004": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      224539180762884e-8,
      3.8505900508226375e6,
      2822772077317902e-9,
      5224106003023173e-9
    ]
  },
  "EPSG:3005": {
    proj4: "+proj=aea +lat_0=45 +lon_0=-126 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      34758.748716825736,
      448536.3005205687,
      1.6635770321550844e6,
      1.7256471090491414e6
    ]
  },
  "EPSG:3006": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181896.32914256962,
      6101648070549415e-9,
      864416.0017674144,
      7689478305602837e-9
    ]
  },
  "EPSG:3007": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      84522.4789376898,
      6.2914721930941045e6,
      211692.8964099536,
      6669074791864619e-9
    ]
  },
  "EPSG:3008": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      62307.125049790615,
      6129269719805825e-9,
      216969.3817410282,
      6908803733255374e-9
    ]
  },
  "EPSG:3009": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      58792.657955065486,
      6.2039588558832295e6,
      211004.8983259734,
      6835121450001828e-9
    ]
  },
  "EPSG:3010": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      82257.06993158946,
      622579966873971e-8,
      208702.6684692285,
      6906419685139441e-9
    ]
  },
  "EPSG:3011": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      96603.43689671528,
      6505161904215527e-9,
      237927.36564764893,
      6733142998795946e-9
    ]
  },
  "EPSG:3012": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26665.314208580123,
      6828977958128993e-9,
      212719.79682528114,
      714397310956681e-8
    ]
  },
  "EPSG:3013": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34943.160569237574,
      6704921513905811e-9,
      209149.05656189876,
      7226423380480291e-9
    ]
  },
  "EPSG:3014": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3406.7090479791514,
      6893784621018781e-9,
      227460.9821367364,
      7456658730847786e-9
    ]
  },
  "EPSG:3015": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      54234.490803413835,
      6305422432314068e-9,
      216295.45503502229,
      7342573659252606e-9
    ]
  },
  "EPSG:3016": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -57936.15594631786,
      7045316966080985e-9,
      270803.4434850197,
      7668217943256962e-9
    ]
  },
  "EPSG:3017": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      50039.93131663973,
      7214130484533945e-9,
      201778.75742900991,
      7.3712691680278145e6
    ]
  },
  "EPSG:3018": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      85170.75094270395,
      7266693010241891e-9,
      188242.02975711616,
      7561782741942218e-9
    ]
  },
  "EPSG:3019": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4771932230545813e6,
      6351611224925671e-9,
      1.5900864688552353e6,
      6624386611332937e-9
    ]
  },
  "EPSG:3020": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1388920626451573e-9,
      612915974290965e-8,
      1590768950269042e-9,
      7143920560705222e-9
    ]
  },
  "EPSG:3021": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15.8082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3658182048165046e6,
      6204436906036567e-9,
      1.5831838412912756e6,
      7454921207398946e-9
    ]
  },
  "EPSG:3022": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.0582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3793491288056376e6,
      6305412515070215e-9,
      1588269197204732e-9,
      7606852631897359e-9
    ]
  },
  "EPSG:3023": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4045504560033006e6,
      7030306067651382e-9,
      157542787864939e-8,
      7665578290957332e-9
    ]
  },
  "EPSG:3024": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4430531256353355e6,
      7237881009947255e-9,
      1.5656994240804452e6,
      7610624167766904e-9
    ]
  },
  "EPSG:3025": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4771932230545813e6,
      6351611224925671e-9,
      1.5900864688552353e6,
      6624386611332937e-9
    ]
  },
  "EPSG:3026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1388920626451573e-9,
      612915974290965e-8,
      1590768950269042e-9,
      7143920560705222e-9
    ]
  },
  "EPSG:3027": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15.8082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3658182048165046e6,
      6204436906036567e-9,
      1.5831838412912756e6,
      7454921207398946e-9
    ]
  },
  "EPSG:3028": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.0582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3793491288056376e6,
      6305412515070215e-9,
      1588269197204732e-9,
      7606852631897359e-9
    ]
  },
  "EPSG:3029": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4045504560033006e6,
      7030306067651382e-9,
      157542787864939e-8,
      7665578290957332e-9
    ]
  },
  "EPSG:3030": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4430531256353355e6,
      7237881009947255e-9,
      1.5656994240804452e6,
      7610624167766904e-9
    ]
  },
  "EPSG:3031": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 4081911918066543e-25, -3333134027630276e-9]
  },
  "EPSG:3032": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=70 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [6e6, 6e6, 9333134027630277e-9, 6e6]
  },
  "EPSG:3033": {
    proj4: "+proj=lcc +lat_0=-50 +lon_0=70 +lat_1=-68.5 +lat_2=-74.5 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      5523249213317601e-9,
      2508116944096161e-9,
      9413886621138304e-9,
      1.6983905713155856e6
    ]
  },
  "EPSG:3034": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -587060.1593063148,
      1232915313015799e-9,
      4468001660970012e-9,
      6783173064718411e-9
    ]
  },
  "EPSG:3035": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -146473.1132416511,
      1.5275411102207187e6,
      4672093287283024e-9,
      6905958262875387e-9
    ]
  },
  "EPSG:3036": {
    proj4: "+proj=utm +zone=36 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      224561.2980032112,
      6946215286114503e-9,
      827409.1151353413,
      8736989211156605e-9
    ]
  },
  "EPSG:3037": {
    proj4: "+proj=utm +zone=37 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      204169.27544722374,
      6931318281240938e-9,
      828837.6562357566,
      8883127491883846e-9
    ]
  },
  "EPSG:3040": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      399535.6294497436,
      3865832600599011e-9,
      601322.8726211493,
      8040550060403315e-9
    ]
  },
  "EPSG:3041": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225902.0805645627,
      3.8671713718875768e6,
      591534.7303909996,
      8228847090053825e-9
    ]
  },
  "EPSG:3042": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227071.85729005415,
      3.9060037759658666e6,
      555495.2251114178,
      8937716116827e-6
    ]
  },
  "EPSG:3043": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      233037.87982875673,
      4099080693337798e-9,
      544133.7771850436,
      9156211355012117e-9
    ]
  },
  "EPSG:3044": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      239323.4449753319,
      4294418796805556e-9,
      533076.5145945294,
      9365796154998856e-9
    ]
  },
  "EPSG:3045": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      269387.69437979034,
      5142865884479615e-9,
      532553.189460577,
      9375830110660298e-9
    ]
  },
  "EPSG:3046": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      326880.8907341509,
      6526115873062309e-9,
      531961.3846213385,
      9389214296997491e-9
    ]
  },
  "EPSG:3047": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      330890.1192646407,
      6615141393451322e-9,
      530852.416986177,
      9410397036520464e-9
    ]
  },
  "EPSG:3048": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      341519.301819355,
      6847757828023774e-9,
      530924.5515790338,
      9407047003761513e-9
    ]
  },
  "EPSG:3049": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      402080.1501976735,
      8101816317119474e-9,
      478833.7855118617,
      8777967971489828e-9
    ]
  },
  "EPSG:3054": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      611527.441473003,
      7178373615389982e-9,
      636871.0896798815,
      7307760988278395e-9
    ]
  },
  "EPSG:3055": {
    proj4: "+proj=utm +zone=27 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      349845.718126295,
      7027158019206632e-9,
      633346.8492006997,
      7381263713557851e-9
    ]
  },
  "EPSG:3056": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      350419.59797886526,
      7039405069592119e-9,
      571820.7963195107,
      738679596755078e-8
    ]
  },
  "EPSG:3057": {
    proj4: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -161615.71096808626,
      -72.3832669260446,
      1021477132962391e-9,
      1.0681160339988442e6
    ]
  },
  "EPSG:3058": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-8.5 +k=1 +x_0=50000 +y_0=-7800000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      25335.80012664486,
      53002.68934212625,
      72623.36078222451,
      107658.42064693384
    ]
  },
  "EPSG:3059": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      189423.14348479116,
      180420.27793885116,
      749893.1876944554,
      446584.7970396569
    ]
  },
  "EPSG:3060": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      388867.3235372126,
      751693074393986e-8,
      718629.8075373425,
      7783804870389406e-9
    ]
  },
  "EPSG:3061": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      282606.26840470236,
      3.5816314340632767e6,
      385284.775575673,
      3.6686457012004736e6
    ]
  },
  "EPSG:3062": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      596263.3900096521,
      4081062012849771e-9,
      709095.2114175938,
      4204118742699012e-9
    ]
  },
  "EPSG:3063": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      333898.0006933059,
      4.2430993868726175e6,
      502592.74225173006,
      4332386361786783e-9
    ]
  },
  "EPSG:3064": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226028.37041470746,
      4.0470930109668463e6,
      727899.151793387,
      5213977493738186e-9
    ]
  },
  "EPSG:3065": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225503.37015502725,
      3.8538577796685467e6,
      727643.3224890253,
      5220644504847022e-9
    ]
  },
  "EPSG:3066": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      293795.98374013766,
      230481.05102648493,
      714936.3252875668,
      696595.4539879942
    ]
  },
  "EPSG:3067": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      43547.78922768647,
      6549298621987618e-9,
      674306.9889334934,
      7782478683824445e-9
    ]
  },
  "EPSG:3068": {
    proj4: "+proj=cass +lat_0=52.4186482777778 +lon_0=13.6272036666667 +x_0=40000 +y_0=10000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3382.636910450783,
      272.72352084983504,
      48986.40208372318,
      35749.55913769956
    ]
  },
  "EPSG:3069": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=500000 +y_0=-4500000 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      262464.6114303941,
      206906.1503007328,
      783432.8945369496,
      746217.9955826057
    ]
  },
  "EPSG:3070": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      282455.2023938304,
      227119.95484749787,
      803426.5861082915,
      766436.4349943912
    ]
  },
  "EPSG:3071": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282455.2023938304,
      227119.95484749787,
      803426.5861082915,
      766436.4349943912
    ]
  },
  "EPSG:3072": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      643626.9498361305,
      38759.89775611995,
      772884.0925903314,
      393521.3588579671
    ]
  },
  "EPSG:3074": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      241765.49550198903,
      26539.33912282469,
      358635.93205308926,
      416628.2804443663
    ]
  },
  "EPSG:3075": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      643626.9498361305,
      38759.89775611995,
      772884.0925903314,
      393521.3588579671
    ]
  },
  "EPSG:3077": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      241765.49550198903,
      26539.33912282469,
      358635.93205308926,
      416628.2804443663
    ]
  },
  "EPSG:3078": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      131754.1460535056,
      135994.88864500355,
      786822.1064603678,
      870498.7798355976
    ]
  },
  "EPSG:3079": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      131754.1460535056,
      135994.88864500355,
      786822.1064603678,
      870498.7798355976
    ]
  },
  "EPSG:3080": {
    proj4: "+proj=lcc +lat_0=31.1666666666667 +lon_0=-100 +lat_1=27.4166666666667 +lat_2=34.9166666666667 +x_0=914400 +y_0=914400 +datum=NAD27 +units=ft +no_defs +type=crs",
    projected_bounds: [
      805989.158169452,
      1.1268934267305364e6,
      4913837860684796e-9,
      4995667235296718e-9
    ]
  },
  "EPSG:3081": {
    proj4: "+proj=lcc +lat_0=31.1666666666667 +lon_0=-100 +lat_1=27.4166666666667 +lat_2=34.9166666666667 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      331226.35401596106,
      429093.9412772608,
      1583305674184638e-9,
      1.6083026853412504e6
    ]
  },
  "EPSG:3082": {
    proj4: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      831139.3452904851,
      589725675084688e-8,
      2083223989295547e-9,
      7076453726029536e-9
    ]
  },
  "EPSG:3083": {
    proj4: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      831192.2778944278,
      6877890180217122e-9,
      2.0832733485623298e6,
      8058739531869909e-9
    ]
  },
  "EPSG:3084": {
    proj4: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831139.3452904851,
      589725675084688e-8,
      2083223989295547e-9,
      7076453726029536e-9
    ]
  },
  "EPSG:3085": {
    proj4: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831192.2778944278,
      6877890180217122e-9,
      2.0832733485623298e6,
      8058739531869909e-9
    ]
  },
  "EPSG:3086": {
    proj4: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      32031.289285340346,
      50838.306792611686,
      784566.8641495073,
      784246.4748000703
    ]
  },
  "EPSG:3087": {
    proj4: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32031.289285340346,
      50838.306792611686,
      784566.8641495073,
      784246.4748000703
    ]
  },
  "EPSG:3088": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1577469491398442e6,
      1.0243945737160366e6,
      1.8284434576961924e6,
      1.3193168596829686e6
    ]
  },
  "EPSG:3089": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.7983747823029724e6,
      3.3608678636000315e6,
      5998818244124926e-9,
      4328458730143207e-9
    ]
  },
  "EPSG:3090": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1577469491398442e6,
      1.0243945737160366e6,
      1.8284434576961924e6,
      1.3193168596829686e6
    ]
  },
  "EPSG:3091": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.7983747823029724e6,
      3.3608678636000315e6,
      5998818244124926e-9,
      4328458730143207e-9
    ]
  },
  "EPSG:3092": {
    proj4: "+proj=utm +zone=51 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      563064.0175253295,
      2651892235101601e-9,
      753428.9877204339,
      2.7603763381809425e6
    ]
  },
  "EPSG:3093": {
    proj4: "+proj=utm +zone=52 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      259678.5167929407,
      2.7003039356376263e6,
      774098.4921796711,
      3865677878450131e-9
    ]
  },
  "EPSG:3094": {
    proj4: "+proj=utm +zone=53 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      186851.60603725287,
      2.2550631439139233e6,
      764886.6287369127,
      4.1630331275423733e6
    ]
  },
  "EPSG:3095": {
    proj4: "+proj=utm +zone=54 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      196412.03956362122,
      2731461133352081e-9,
      734184.1292956917,
      5046806708813968e-9
    ]
  },
  "EPSG:3096": {
    proj4: "+proj=utm +zone=55 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      254862.3957567638,
      4746934690353548e-9,
      410024.8804529458,
      4916424812783342e-9
    ]
  },
  "EPSG:3097": {
    proj4: "+proj=utm +zone=51 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      435606.2142612379,
      2333340405071788e-9,
      790248.5778711198,
      3.2904198819867927e6
    ]
  },
  "EPSG:3098": {
    proj4: "+proj=utm +zone=52 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188357.29562846932,
      2338370121015073e-9,
      761149.3376064628,
      4279988956497406e-9
    ]
  },
  "EPSG:3099": {
    proj4: "+proj=utm +zone=53 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      180701.57177046937,
      1891969490273159e-9,
      742338.515259152,
      4826267585702048e-9
    ]
  },
  "EPSG:3100": {
    proj4: "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181636.80059141235,
      1.9517769337818655e6,
      732083.8475862955,
      5103979180954936e-9
    ]
  },
  "EPSG:3101": {
    proj4: "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      192525.24287410482,
      2.5499918613784714e6,
      567010.3566700317,
      5055520921608147e-9
    ]
  },
  "EPSG:3102": {
    proj4: "+proj=lcc +lat_1=-14.2666666666667 +lat_0=-14.2666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480061 +y_0=95169.3116586233 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      188675.53367022792,
      252358.83939157162,
      719652.2435744753,
      368807.77131724206
    ]
  },
  "EPSG:3106": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      292524.730156826,
      2.2701044669028274e6,
      765763.4295766877,
      2949093613230923e-9
    ]
  },
  "EPSG:3107": {
    proj4: "+proj=lcc +lat_0=-32 +lon_0=135 +lat_1=-28 +lat_2=-36 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471559.8940370092,
      1305574975884134e-9,
      1603250901256566e-9,
      2.6489402061111545e6
    ]
  },
  "EPSG:3108": {
    proj4: "+proj=tmerc +lat_0=49.5 +lon_0=-2.41666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -48885.67292327189,
      7456.864617265594,
      75344.69515947833,
      123484.13562391243
    ]
  },
  "EPSG:3109": {
    proj4: "+proj=tmerc +lat_0=49.225 +lon_0=-2.135 +k=0.9999999 +x_0=40000 +y_0=70000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3002.148043096793,
      19564.70107568772,
      63570.62905521982,
      93962.26314590946
    ]
  },
  "EPSG:3110": {
    proj4: "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=4500000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      2150914842304097e-9,
      4248371484172233e-9,
      2966079006259745e-9,
      4822831443320299e-9
    ]
  },
  "EPSG:3111": {
    proj4: "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2150916112417634e-9,
      2.2483723746383237e6,
      2966077313809796e-9,
      2822830306610196e-9
    ]
  },
  "EPSG:3112": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=134 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7526853488839234e6,
      -5065635719046252e-9,
      2.2192747621920486e6,
      -1.3330055356387005e6
    ]
  },
  "EPSG:3113": {
    proj4: "+proj=tmerc +lat_0=-28 +lon_0=153 +k=0.99999 +x_0=50000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -124862.90472267606,
      -109743.67176167082,
      119857.55958940266,
      472085.7564342426
    ]
  },
  "EPSG:3114": {
    proj4: "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-80.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1108796086779052e-9,
      627794.0267448111,
      1.1665657486795294e6,
      766087.661769198
    ]
  },
  "EPSG:3115": {
    proj4: "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-77.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831610.4843022372,
      495085.9265868276,
      116409692763004e-8,
      1.6212303285970383e6
    ]
  },
  "EPSG:3116": {
    proj4: "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-74.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831771.0109272165,
      214127.06079913536,
      1.1632071228147843e6,
      1.7993770759141587e6
    ]
  },
  "EPSG:3117": {
    proj4: "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-71.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      832066.3111449128,
      23866.300860648975,
      1.1627802248217824e6,
      1.8768378988206927e6
    ]
  },
  "EPSG:3118": {
    proj4: "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-68.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831739.476184484,
      242886.92367182544,
      1133619946763676e-9,
      1.1896742429598777e6
    ]
  },
  "EPSG:3119": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      772126.3652688034,
      1238759025549665e-9,
      988920.6086148483,
      1551234737146456e-9
    ]
  },
  "EPSG:3120": {
    proj4: "+proj=sterea +lat_0=50.625 +lon_0=21.0833333333333 +k=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4411423945135396e-9,
      5290918045880976e-9,
      4845979893366327e-9,
      566216321520887e-8
    ]
  },
  "EPSG:3121": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      393755.4328607631,
      686711.567330543,
      605516.9342606523,
      206188718271449e-8
    ]
  },
  "EPSG:3122": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      388832.7626596983,
      333950.5313001741,
      611673.4893063162,
      2258980129316444e-9
    ]
  },
  "EPSG:3123": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      355474.8861577523,
      331773.9421033546,
      625279.9015198837,
      2391951296740727e-9
    ]
  },
  "EPSG:3124": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      359982.65931309573,
      380429.2130765242,
      633043.0052253617,
      2454031420950242e-9
    ]
  },
  "EPSG:3125": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      359102.6182766735,
      526415.4786159754,
      670429.6606012376,
      2.4311329255564897e6
    ]
  },
  "EPSG:3126": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      513359.63482055016,
      6663010107980846e-9,
      527613.0466049619,
      6692058676605167e-9
    ]
  },
  "EPSG:3127": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472032.84343091416,
      6645265487353398e-9,
      527494.6748418101,
      6707657064247388e-9
    ]
  },
  "EPSG:3128": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471965.5659836573,
      6636352836028312e-9,
      519704.6901654947,
      7694317478669044e-9
    ]
  },
  "EPSG:3129": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471898.34391590505,
      6627440292990826e-9,
      519722.90534676774,
      76920864762662e-7
    ]
  },
  "EPSG:3130": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471889.94505783316,
      6626326232733572e-9,
      520241.00228193455,
      7628505092807954e-9
    ]
  },
  "EPSG:3131": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471982.38015876303,
      6638580988714271e-9,
      520150.25390590844,
      7639659414177734e-9
    ]
  },
  "EPSG:3132": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472049.6714304124,
      6647493667084635e-9,
      520095.7749118593,
      7646352070098566e-9
    ]
  },
  "EPSG:3133": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472251.8760136142,
      667423234995397e-8,
      519147.9651136367,
      776236550972573e-8
    ]
  },
  "EPSG:3134": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472403.8534337728,
      6694286997617445e-9,
      519047.33533531765,
      7774636967642463e-9
    ]
  },
  "EPSG:3135": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472454.57398863137,
      6700972000829727e-9,
      519010.724967903,
      7779099353574873e-9
    ]
  },
  "EPSG:3136": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      472895.4285795114,
      6758911209249102e-9,
      519266.7986573983,
      7747863073913258e-9
    ]
  },
  "EPSG:3137": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      473312.9209599612,
      6813511865091154e-9,
      520928.62166101485,
      7543736596232613e-9
    ]
  },
  "EPSG:3138": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      473869.785998047,
      688594736250547e-8,
      528590.5150577489,
      7130086160671611e-9
    ]
  },
  "EPSG:3139": {
    proj4: "+proj=cass +hyperbolic +lat_0=-16.25 +lon_0=179.333333333333 +x_0=251727.9155424 +y_0=334519.953768 +a=6378306.3696 +b=6356571.996 +units=link +no_defs +type=crs",
    projected_bounds: [
      768036.4165235008,
      1.2107099465996576e6,
      1.7281916113245792e6,
      1744361214968435e-9
    ]
  },
  "EPSG:3140": {
    proj4: "+proj=cass +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272 +a=6378306.3696 +b=6356571.996 +units=link +no_defs +type=crs",
    projected_bounds: [
      118338.70442841049,
      527002.6976311576,
      940484.6814373794,
      1.1158281293982822e6
    ]
  },
  "EPSG:3141": {
    proj4: "+proj=utm +zone=60 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      480028.1026344775,
      7874792429002027e-9,
      820952.5141254424,
      8217650141858188e-9
    ]
  },
  "EPSG:3142": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      180603.4449186197,
      8113545220129913e-9,
      203670.86491537234,
      8217994268571784e-9
    ]
  },
  "EPSG:3148": {
    proj4: "+proj=utm +zone=48 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      185005.46073877206,
      921847.4276594727,
      806585.0308093943,
      2.5907766684287325e6
    ]
  },
  "EPSG:3149": {
    proj4: "+proj=utm +zone=49 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      171558.3502362332,
      1.1544220839933008e6,
      347810.5971914593,
      2384648639230175e-9
    ]
  },
  "EPSG:3152": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      82600.9775337726,
      66564.44840806443,
      108249.55263650628,
      89926.53184093256
    ]
  },
  "EPSG:3153": {
    proj4: "+proj=aea +lat_0=45 +lon_0=-126 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34758.748716825736,
      448536.3005205687,
      1.6635770321550844e6,
      1.7256471090491414e6
    ]
  },
  "EPSG:3154": {
    proj4: "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      499314.25966117124,
      5766599425710034e-9,
      600485.3252605255,
      8050561199050144e-9
    ]
  },
  "EPSG:3155": {
    proj4: "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      276483.89691439964,
      5327323615473784e-9,
      561466.0056721768,
      881843231451587e-8
    ]
  },
  "EPSG:3156": {
    proj4: "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      269894.2173448665,
      5156198868703588e-9,
      552774.1905777643,
      898675552561162e-8
    ]
  },
  "EPSG:3157": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      276787.3228804136,
      5335102810582594e-9,
      547749.0506840231,
      9083741173250612e-9
    ]
  },
  "EPSG:3158": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3159": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      276353.9599205883,
      532398969591123e-8,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3160": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      268167.7999873924,
      5110645349514422e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:3161": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-85 +lat_1=44.5 +lat_2=53.5 +x_0=930000 +y_0=6430000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      82306.08027170459,
      11728968376012327e-9,
      1581260236199931e-9,
      13411520073628198e-9
    ]
  },
  "EPSG:3162": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-85 +lat_1=44.5 +lat_2=53.5 +x_0=930000 +y_0=6430000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      82306.08027170459,
      11728968376012327e-9,
      1581260236199931e-9,
      13411520073628198e-9
    ]
  },
  "EPSG:3163": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      147274.752366249,
      161815.2070888825,
      629999.1002407128,
      519831.609275465
    ]
  },
  "EPSG:3164": {
    proj4: "+proj=utm +zone=58 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      649897.446159468,
      7702638670380788e-9,
      678507.9818271662,
      7749967463400473e-9
    ]
  },
  "EPSG:3165": {
    proj4: "+proj=lcc +lat_0=-22.26969175 +lon_0=166.44242575 +lat_1=-22.24469175 +lat_2=-22.29469175 +x_0=0.66 +y_0=1.02 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -9518.872592683763,
      -11109.678506550772,
      10063.334181249036,
      8822.461900403765
    ]
  },
  "EPSG:3166": {
    proj4: "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -9518.867076109194,
      -11109.682816295399,
      10063.329907605346,
      8822.467205265477
    ]
  },
  "EPSG:3167": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.0257905 +gamma=323.130102361111 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +to_meter=20.116756 +no_defs +type=crs",
    projected_bounds: [
      8750.862905719743,
      6692.454417010801,
      36455.190953848854,
      36951.48695670852
    ]
  },
  "EPSG:3168": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.0257905 +gamma=323.130102361111 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +units=m +no_defs +type=crs",
    projected_bounds: [
      176038.97386381507,
      134630.4725481285,
      733360.1813519846,
      743344.0469452877
    ]
  },
  "EPSG:3169": {
    proj4: "+proj=utm +zone=57 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224790.9326693641,
      7.1180940220431425e6,
      823209.2359982361,
      830182048720752e-8
    ]
  },
  "EPSG:3170": {
    proj4: "+proj=utm +zone=58 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      200837.05714468984,
      707098931562895e-8,
      822904.8985143863,
      835831145793679e-8
    ]
  },
  "EPSG:3171": {
    proj4: "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199554.71816236124,
      7.1264093437173925e6,
      843789.4494923698,
      7812855508827486e-9
    ]
  },
  "EPSG:3172": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      189595.28198250342,
      7596232653299985e-9,
      208547.79340796178,
      7636482527171179e-9
    ]
  },
  "EPSG:3174": {
    proj4: "+proj=aea +lat_0=45.568977 +lon_0=-84.455955 +lat_1=42.122774 +lat_2=49.01518 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      267230.5689468704,
      530669.6252423832,
      1.7048452177001343e6,
      1619073612597927e-9
    ]
  },
  "EPSG:3175": {
    proj4: "+proj=aea +lat_0=45.568977 +lon_0=-83.248627 +lat_1=42.122774 +lat_2=49.01518 +x_0=1000000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      166190.12270840083,
      542435.0945383593,
      2917795132371449e-9,
      2.0828262612476677e6
    ]
  },
  "EPSG:3176": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      559501.8003421403,
      883161.9113678157,
      937024.2969549673,
      1235421149565907e-9
    ]
  },
  "EPSG:3177": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9965 +x_0=1000000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      193651.29492919822,
      216763274358481e-8,
      1836713377148436e-9,
      3925511873927728e-9
    ]
  },
  "EPSG:3178": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      8270052562830534e-9,
      563646.7716046057,
      877607462542012e-8
    ]
  },
  "EPSG:3179": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403477.1227391754,
      8129673073025397e-9,
      552947.2578827766,
      8983411251385827e-9
    ]
  },
  "EPSG:3180": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      379622.18129182723,
      7648383252548674e-9,
      545319.0518273646,
      9130562946692087e-9
    ]
  },
  "EPSG:3181": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      327230.34943643,
      6533905285040864e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "EPSG:3182": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      317301.5131119407,
      6310262780839807e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:3183": {
    proj4: "+proj=utm +zone=23 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      314769.3023609242,
      6252413531843125e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3184": {
    proj4: "+proj=utm +zone=24 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      315644.1058682364,
      6272437871030272e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3185": {
    proj4: "+proj=utm +zone=25 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      333514.0169763592,
      6673012260546302e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "EPSG:3186": {
    proj4: "+proj=utm +zone=26 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      358360.05123312544,
      720735732486655e-8,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3187": {
    proj4: "+proj=utm +zone=27 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373004.91047825763,
      7512494556404714e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3188": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      378261.58393038285,
      7620536022440157e-9,
      534994.6550617068,
      9329005182354301e-9
    ]
  },
  "EPSG:3189": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      398957.8250853348,
      8.0394190102805635e6,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:3190": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      231200.00535007252,
      2.8069749810800194e6,
      296970.60965831205,
      3.3747475671123806e6
    ]
  },
  "EPSG:3191": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97863.97177478723,
      2601278645144977e-9,
      293211.298463141,
      3.6785747893103915e6
    ]
  },
  "EPSG:3192": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97324.24504282078,
      2522643079538159e-9,
      293391.2442397764,
      3659719926430552e-9
    ]
  },
  "EPSG:3193": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97182.47503303619,
      2.5016009217336075e6,
      293675.34796150954,
      3.6297749973640153e6
    ]
  },
  "EPSG:3194": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      97108.3120653148,
      2490526296754756e-9,
      296117.01677541115,
      3.4689897144345655e6
    ]
  },
  "EPSG:3195": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      96405.18431449207,
      2.3831093076658025e6,
      294319.84290592046,
      3561017322950192e-9
    ]
  },
  "EPSG:3196": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95711.30111707032,
      2.2723828626837675e6,
      293454.5580586649,
      3.6530653886785726e6
    ]
  },
  "EPSG:3197": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95023.25207712565,
      2157240533331693e-9,
      293486.17649491446,
      3.6497381431971067e6
    ]
  },
  "EPSG:3198": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      95343.14868686961,
      2211488646242546e-9,
      219811.0741111061,
      3.5583806395527376e6
    ]
  },
  "EPSG:3199": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      531650.0892688019,
      2.6000468578690276e6,
      777363.2542155273,
      3.7573982904380052e6
    ]
  },
  "EPSG:3200": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7138558849344344e6,
      470649.38957184984,
      2.3008748392124423e6,
      1.2783006128503692e6
    ]
  },
  "EPSG:3201": {
    proj4: "+proj=utm +zone=33 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      191343.7477416353,
      2492406463906521e-9,
      773040.8438097122,
      3.9027371568726236e6
    ]
  },
  "EPSG:3202": {
    proj4: "+proj=utm +zone=34 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      184029.40584218432,
      2158952027706404e-9,
      774622.7106185404,
      3880574038708568e-9
    ]
  },
  "EPSG:3203": {
    proj4: "+proj=utm +zone=35 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      186040.95039987098,
      2.2132141184456204e6,
      426700.9289161929,
      3718143201208171e-9
    ]
  },
  "EPSG:3204": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -293273.66528118734,
      3162494191288473e-9,
      334433.76258510683,
      3.6063409598406623e6
    ]
  },
  "EPSG:3205": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-54 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -293273.66528118734,
      3162494191288473e-9,
      334433.7625851061,
      3.6063409598406623e6
    ]
  },
  "EPSG:3206": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-42 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -293273.6652811876,
      3162494191288473e-9,
      334433.7625851065,
      3.6063409598406623e6
    ]
  },
  "EPSG:3207": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-174 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.4627316155,
      305559827773546e-8
    ]
  },
  "EPSG:3208": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3209": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-54 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.4627316161,
      305559827773546e-8
    ]
  },
  "EPSG:3210": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=42 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.662186142,
      2.6116395773764863e6,
      293239.46273161646,
      305559827773546e-8
    ]
  },
  "EPSG:3211": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=54 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.4627316161,
      305559827773546e-8
    ]
  },
  "EPSG:3212": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=66 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.4627316161,
      305559827773546e-8
    ]
  },
  "EPSG:3213": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=78 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3214": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=90 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3215": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=102 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861418,
      2.6116395773764867e6,
      293239.4627316161,
      305559827773546e-8
    ]
  },
  "EPSG:3216": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=114 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.4627316155,
      305559827773546e-8
    ]
  },
  "EPSG:3217": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=126 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3218": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=138 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861412,
      2.6116395773764867e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3219": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=150 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.4627316155,
      305559827773546e-8
    ]
  },
  "EPSG:3220": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=162 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -250633.6621861423,
      2.6116395773764863e6,
      293239.46273161675,
      305559827773546e-8
    ]
  },
  "EPSG:3221": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-102 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3222": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-90 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3223": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-78 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3224": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3225": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-18 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379786,
      2094186780961655e-9,
      250606.57635726992,
      2.5382442326681656e6
    ]
  },
  "EPSG:3226": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-6 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837978,
      2094186780961655e-9,
      250606.57635727,
      2.5382442326681656e6
    ]
  },
  "EPSG:3227": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=6 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837978,
      2094186780961655e-9,
      250606.57635727,
      2.5382442326681656e6
    ]
  },
  "EPSG:3228": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=18 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837977,
      2094186780961655e-9,
      250606.57635727007,
      2.5382442326681656e6
    ]
  },
  "EPSG:3229": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=30 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635727007,
      2.5382442326681656e6
    ]
  },
  "EPSG:3230": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=42 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379786,
      2094186780961655e-9,
      250606.57635727007,
      2.5382442326681656e6
    ]
  },
  "EPSG:3231": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=54 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3232": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=66 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3233": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=78 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3234": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=90 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3235": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=102 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.78288379763,
      2094186780961655e-9,
      250606.57635726983,
      2.5382442326681656e6
    ]
  },
  "EPSG:3236": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=114 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.5763572693,
      2.5382442326681656e6
    ]
  },
  "EPSG:3237": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=126 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3238": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=138 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837972,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3239": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=150 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.5763572693,
      2.5382442326681656e6
    ]
  },
  "EPSG:3240": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=162 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837981,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3241": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=174 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -206763.7828837972,
      2094186780961655e-9,
      250606.57635727036,
      2.5382442326681656e6
    ]
  },
  "EPSG:3242": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-153 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3243": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-135 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3244": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-117 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3245": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-99 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3246": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-81 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3247": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-63 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3248": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-27 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3249": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-9 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3250": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=9 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3251": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=27 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3252": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=45 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3253": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=63 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3254": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=81 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3255": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=99 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3256": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=117 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3257": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=135 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3258": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=153 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3259": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=171 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -242305.69611743742,
      1.5923697956802014e6,
      309460.09526773373,
      2033690980313667e-9
    ]
  },
  "EPSG:3260": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-168 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.1444477496,
      1.5497389965701962e6
    ]
  },
  "EPSG:3261": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-144 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3262": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-120 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463785,
      1112529574203626e-9,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3263": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-96 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.14444774925,
      1.5497389965701965e6
    ]
  },
  "EPSG:3264": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-72 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946376,
      1.1125295742036263e6,
      322031.14444774925,
      1.5497389965701965e6
    ]
  },
  "EPSG:3265": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-48 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.14444774925,
      1.5497389965701965e6
    ]
  },
  "EPSG:3266": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=-24 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463747,
      1.1125295742036263e6,
      322031.1444477492,
      1.5497389965701965e6
    ]
  },
  "EPSG:3267": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=0 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946375,
      1.1125295742036263e6,
      322031.1444477492,
      1.5497389965701965e6
    ]
  },
  "EPSG:3268": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=24 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946375,
      1.1125295742036263e6,
      322031.1444477491,
      1.5497389965701965e6
    ]
  },
  "EPSG:3269": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=48 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946376,
      1.1125295742036263e6,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3270": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=72 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946376,
      1.1125295742036263e6,
      322031.14444774925,
      1.5497389965701965e6
    ]
  },
  "EPSG:3271": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=96 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.3295946376,
      1.1125295742036263e6,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3272": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=120 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.1444477496,
      1.5497389965701962e6
    ]
  },
  "EPSG:3273": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=144 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463733,
      1.1125295742036263e6,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3274": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=168 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -231180.32959463785,
      1112529574203626e-9,
      322031.1444477489,
      1.5497389965701965e6
    ]
  },
  "EPSG:3275": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-165 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892417,
      643207.3403364574,
      287694.15644879005,
      1073689208907555e-9
    ]
  },
  "EPSG:3276": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892417,
      643207.3403364574,
      287694.1564487905,
      1.0736892089075549e6
    ]
  },
  "EPSG:3277": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892388,
      643207.3403364575,
      287694.1564487905,
      1.0736892089075549e6
    ]
  },
  "EPSG:3278": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.887408924,
      643207.3403364575,
      287694.1564487905,
      1.0736892089075549e6
    ]
  },
  "EPSG:3279": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.887408924,
      643207.3403364575,
      287694.1564487904,
      1073689208907555e-9
    ]
  },
  "EPSG:3280": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892406,
      643207.3403364575,
      287694.15644879034,
      1073689208907555e-9
    ]
  },
  "EPSG:3281": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892406,
      643207.3403364575,
      287694.15644879034,
      1073689208907555e-9
    ]
  },
  "EPSG:3282": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892409,
      643207.3403364575,
      287694.1564487903,
      1073689208907555e-9
    ]
  },
  "EPSG:3283": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892417,
      643207.3403364574,
      287694.1564487903,
      1073689208907555e-9
    ]
  },
  "EPSG:3284": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892417,
      643207.3403364574,
      287694.15644879005,
      1073689208907555e-9
    ]
  },
  "EPSG:3285": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892417,
      643207.3403364574,
      287694.1564487905,
      1.0736892089075549e6
    ]
  },
  "EPSG:3286": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=165 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -172346.88740892388,
      643207.3403364575,
      287694.1564487905,
      1.0736892089075549e6
    ]
  },
  "EPSG:3287": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214063,
      192078.08058667023,
      332948.61925762816,
      576683.924864117
    ]
  },
  "EPSG:3288": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214063,
      192078.08058667023,
      332948.619257628,
      576683.9248641172
    ]
  },
  "EPSG:3289": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214066,
      192078.08058667023,
      332948.619257628,
      576683.9248641173
    ]
  },
  "EPSG:3290": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214066,
      192078.08058667023,
      332948.619257628,
      576683.9248641173
    ]
  },
  "EPSG:3291": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214067,
      192078.0805866702,
      332948.61925762787,
      576683.9248641173
    ]
  },
  "EPSG:3292": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110896.33153214071,
      192078.08058667017,
      332948.61925762787,
      576683.9248641173
    ]
  },
  "EPSG:3293": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 27161767489603954e-27, -221792.66306428134]
  },
  "EPSG:3294": {
    proj4: "+proj=lcc +lat_0=-78 +lon_0=162 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -234408.45224081134,
      -247731.83507788787,
      491219.4869003015,
      1.0023288016981696e6
    ]
  },
  "EPSG:3295": {
    proj4: "+proj=aeqd +lat_0=9.54670833333333 +lon_0=138.168744444444 +x_0=40000 +y_0=60000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      20366.87035941602,
      42673.48658681672,
      51112.099459463396,
      75849.48823115163
    ]
  },
  "EPSG:3296": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10727.131026558694,
      7036500483253664e-9,
      826098.998238188,
      861630729947541e-8
    ]
  },
  "EPSG:3297": {
    proj4: "+proj=utm +zone=6 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214140.3358506682,
      6544353688743853e-9,
      831291.8171216743,
      9193091126411527e-9
    ]
  },
  "EPSG:3298": {
    proj4: "+proj=utm +zone=7 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214260.8375300772,
      6539917700180792e-9,
      832944.861574,
      9499706400400037e-9
    ]
  },
  "EPSG:3299": {
    proj4: "+proj=utm +zone=8 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      201174.1970633017,
      7056579648918083e-9,
      835764.676564869,
      938900059843823e-8
    ]
  },
  "EPSG:3300": {
    proj4: "+proj=lcc +lat_0=57.5175539305556 +lon_0=24 +lat_1=59.3333333333333 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364584.07317227725,
      6377553918072123e-9,
      735998.1181040717,
      6631059041381989e-9
    ]
  },
  "EPSG:3301": {
    proj4: "+proj=lcc +lat_0=57.5175539305556 +lon_0=24 +lat_1=59.3333333333333 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282560.6696905027,
      6381157437945092e-9,
      734255.0146500409,
      6658861367557157e-9
    ]
  },
  "EPSG:3302": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      693973.289783419,
      8885205288633063e-9,
      746926.6055172755,
      8933565733442469e-9
    ]
  },
  "EPSG:3303": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      746193.2948957279,
      8827345317291074e-9,
      769391.5764651494,
      8853730750734093e-9
    ]
  },
  "EPSG:3304": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      213960.3327093452,
      8015458782818578e-9,
      278009.5987890748,
      8070531623842654e-9
    ]
  },
  "EPSG:3305": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      181623.85519053089,
      8.0481992091575675e6,
      209946.7153569648,
      8072995715791368e-9
    ]
  },
  "EPSG:3306": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      565080.2938425632,
      8167891863106772e-9,
      591862.1826775568,
      8193239467068976e-9
    ]
  },
  "EPSG:3307": {
    proj4: "+proj=utm +zone=39 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      579161.9380645991,
      301991719721282e-8,
      697284.7405057999,
      3.1209934059626074e6
    ]
  },
  "EPSG:3308": {
    proj4: "+proj=lcc +lat_0=-33.25 +lon_0=147 +lat_1=-30.75 +lat_2=-35.75 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8768078383760821e-9,
      4.0098458103185324e6,
      9958614107648712e-9,
      5044516158964828e-9
    ]
  },
  "EPSG:3309": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -418517.34597017436,
      -599419.5685635679,
      487815.4548701769,
      458493.06867659464
    ]
  },
  "EPSG:3310": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -418604.90866352344,
      -599248.9206782463,
      487730.49001781485,
      458666.85968259815
    ]
  },
  "EPSG:3311": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -418604.90866352344,
      -599248.9206782463,
      487730.49001781485,
      458666.85968259815
    ]
  },
  "EPSG:3312": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      782849.9335775315,
      535515.3864825504,
      832354.0620290937,
      629806.8767202345
    ]
  },
  "EPSG:3313": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      765845.4667151424,
      233423.68965441713,
      832340.932864933,
      629799.9175822859
    ]
  },
  "EPSG:3316": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      444793.47013385966,
      9191782203602083e-9,
      611949.9601132746,
      9412855045087373e-9
    ]
  },
  "EPSG:3317": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389505.960823519,
      9227078059755214e-9,
      610893.5108009666,
      944603049272255e-8
    ]
  },
  "EPSG:3318": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      518818.4433876857,
      9332231663791455e-9,
      612058.4832365708,
      9483625348301249e-9
    ]
  },
  "EPSG:3319": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389271.7802276114,
      934650858039956e-8,
      612117.8033435871,
      9526750368482174e-9
    ]
  },
  "EPSG:3320": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389263.8571797839,
      935093184029137e-8,
      611133.7483225069,
      9636220841486316e-9
    ]
  },
  "EPSG:3321": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389171.1533406088,
      9405116281915218e-9,
      611121.3605397413,
      9624057734788049e-9
    ]
  },
  "EPSG:3322": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389577.9384797263,
      9193901994567001e-9,
      611045.2809270297,
      9556607258523485e-9
    ]
  },
  "EPSG:3323": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389582.84398279723,
      9191690241688943e-9,
      610841.4327210207,
      9412856844726074e-9
    ]
  },
  "EPSG:3324": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389505.960823519,
      9227078059755214e-9,
      610893.5108009666,
      944603049272255e-8
    ]
  },
  "EPSG:3325": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389570.60529683024,
      9197219620278234e-9,
      611014.7735804664,
      9532280621747477e-9
    ]
  },
  "EPSG:3326": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389595.1662370242,
      9186160851042468e-9,
      611013.3482411512,
      9531174862351364e-9
    ]
  },
  "EPSG:3327": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389297.9004717557,
      9332132942289846e-9,
      460042.1499797505,
      9520181061111009e-9
    ]
  },
  "EPSG:3328": {
    proj4: "+proj=sterea +lat_0=52.1666666666667 +lon_0=19.1666666666667 +k=0.999714 +x_0=500000 +y_0=500000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      132195.46667540196,
      160221.80032415857,
      819680.2870093468,
      814261.5664558464
    ]
  },
  "EPSG:3329": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      538493934625595e-8,
      5157294696838746e-9,
      5596656434281129e-9,
      6067199753510543e-9
    ]
  },
  "EPSG:3330": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6372166552566127e-9,
      4446231536849187e-9,
      6596251510687349e-9,
      6086122289910144e-9
    ]
  },
  "EPSG:3331": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7371234171269215e-9,
      4390710898445708e-9,
      7597155446623255e-9,
      6.0438255426649945e6
    ]
  },
  "EPSG:3332": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8374252100890662e-9,
      4568392727867019e-9,
      8597392608496968e-9,
      6032695233484209e-9
    ]
  },
  "EPSG:3333": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3266689692727278e-9,
      5076101933661515e-9,
      3692480710285709e-9,
      6089215337300765e-9
    ]
  },
  "EPSG:3334": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4242451754734185e-9,
      4393939137586286e-9,
      4692480710285708e-9,
      6089215337300765e-9
    ]
  },
  "EPSG:3335": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      524849277639358e-8,
      4571650194318225e-9,
      5692619074434307e-9,
      56479745774283e-7
    ]
  },
  "EPSG:3336": {
    proj4: "+proj=utm +zone=42 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      477680.94517865754,
      4485672581470467e-9,
      619440.5066459399,
      4.6156358868174385e6
    ]
  },
  "EPSG:3337": {
    proj4: "+proj=lcc +lat_1=-20.1950694444444 +lat_0=-20.1950694444444 +lon_0=57.5218277777778 +k_0=1 +x_0=1000000 +y_0=1000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      971656.5267325954,
      958471.2747959716,
      1.0343563982649179e6,
      1.0282015618725254e6
    ]
  },
  "EPSG:3338": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2257390750018839e-9,
      726719.5466732185,
      858192.2020793316,
      2534628449266282e-9
    ]
  },
  "EPSG:3339": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      518818.4433876857,
      9332231663791455e-9,
      612058.4832365708,
      9483625348301249e-9
    ]
  },
  "EPSG:3340": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      389271.7802276114,
      934650858039956e-8,
      612117.8033435871,
      9526750368482174e-9
    ]
  },
  "EPSG:3341": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      388156.38322959177,
      9350929853382908e-9,
      531074.946284382,
      9511339941332413e-9
    ]
  },
  "EPSG:3342": {
    proj4: "+proj=utm +zone=33 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      186697.2611340597,
      9331620293918727e-9,
      642051.6983338604,
      952684765714712e-8
    ]
  },
  "EPSG:3343": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      176932.2986923267,
      1.6295076734331187e6,
      806489.2294950235,
      2597639473083322e-9
    ]
  },
  "EPSG:3344": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      176976.58181025274,
      1.6328297201886289e6,
      796930.7861062696,
      3023231210009084e-9
    ]
  },
  "EPSG:3345": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      178096.8018903971,
      1714775543526336e-9,
      319446.88665543287,
      2848122961629669e-9
    ]
  },
  "EPSG:3346": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      172763.81342171825,
      5983979336978682e-9,
      673835.6447485696,
      6260983357557363e-9
    ]
  },
  "EPSG:3347": {
    proj4: "+proj=lcc +lat_0=63.390675 +lon_0=-91.8666666666667 +lat_1=49 +lat_2=77 +x_0=6200000 +y_0=3000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0930690021458385e6,
      1869904286051279e-9,
      6555264392418929e-9,
      5740847387925235e-9
    ]
  },
  "EPSG:3348": {
    proj4: "+proj=lcc +lat_0=63.390675 +lon_0=-91.8666666666667 +lat_1=49 +lat_2=77 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0930690021458385e6,
      1869904286051279e-9,
      6555264392418929e-9,
      5740847387925235e-9
    ]
  },
  "EPSG:3350": {
    proj4: "+proj=tmerc +lat_0=0.1 +lon_0=21.95 +k=1 +x_0=250000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      94577.69141780408,
      5.9965036223483225e6,
      335533.7967321719,
      6562766183708859e-9
    ]
  },
  "EPSG:3351": {
    proj4: "+proj=tmerc +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1513789974587306e6,
      5963762790159026e-9,
      1.3344029281518382e6,
      6612890352683952e-9
    ]
  },
  "EPSG:3352": {
    proj4: "+proj=tmerc +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      215436943915971e-8,
      6104005974176977e-9,
      2.2663723163046734e6,
      6599716980635598e-9
    ]
  },
  "EPSG:3353": {
    proj4: "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      669338.3551857569,
      9332128431802575e-9,
      955308.5494448934,
      9514617892548751e-9
    ]
  },
  "EPSG:3354": {
    proj4: "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      669338.3551857569,
      9332128431802575e-9,
      873779.0873536201,
      9440834192817446e-9
    ]
  },
  "EPSG:3355": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      747785.6917124563,
      499276.1815193609,
      930567.7928500362,
      815615.5312374844
    ]
  },
  "EPSG:3358": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      116361.13496227108,
      22119.88887843388,
      933520.6710072559,
      320979.26197346306
    ]
  },
  "EPSG:3360": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386694.5942843487,
      26576.309440707257,
      835428.2312511974,
      377206.79542095796
    ]
  },
  "EPSG:3361": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "EPSG:3362": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364722.69794594496,
      51900.29667448759,
      850571.8392683543,
      266893.21477785433
    ]
  },
  "EPSG:3363": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2.7905844426662596e6,
      875632.1554836772
    ]
  },
  "EPSG:3364": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      361633.13518682023,
      45575.569319858565,
      854195.2283628277,
      209415.98457540976
    ]
  },
  "EPSG:3365": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.847010236,
      2802472178387044e-9,
      687058.9427278236
    ]
  },
  "EPSG:3367": {
    proj4: "+proj=utm +zone=28 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      276048.2783976105,
      1628245973026569e-9,
      806497.2828377405,
      2.5974231003800514e6
    ]
  },
  "EPSG:3368": {
    proj4: "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      176969.74481177045,
      16326850989759e-7,
      796939.4295255042,
      3022988434832701e-9
    ]
  },
  "EPSG:3369": {
    proj4: "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      178089.87444523367,
      1.7146242838521814e6,
      319441.8493208074,
      2.8478904141970933e6
    ]
  },
  "EPSG:3370": {
    proj4: "+proj=utm +zone=59 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      255033.10516190119,
      5433756921808092e-9,
      686341.5763637786,
      6241102710691315e-9
    ]
  },
  "EPSG:3371": {
    proj4: "+proj=utm +zone=60 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      275871.00953532726,
      5311546709122141e-9,
      683827.1770594025,
      6284462385851946e-9
    ]
  },
  "EPSG:3372": {
    proj4: "+proj=utm +zone=59 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      255040.97594940502,
      5433975758357479e-9,
      686334.7381179817,
      6241316103447333e-9
    ]
  },
  "EPSG:3373": {
    proj4: "+proj=utm +zone=60 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      275878.0522029962,
      5311765433025767e-9,
      683820.3879196523,
      6284675176375143e-9
    ]
  },
  "EPSG:3374": {
    proj4: "+proj=utm +zone=29 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      580820.0095465741,
      6800641572030566e-9,
      637942.8967841733,
      6922872480863505e-9
    ]
  },
  "EPSG:3375": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.025796466667 +gamma=323.130102361111 +k=0.99984 +x_0=804671 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      697.3052038988099,
      126545.97386297693,
      867997.96252272,
      864788.5483524016
    ]
  },
  "EPSG:3376": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.31580995 +gamma=53.1301023611111 +k=0.99984 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -41827.29528490901,
      93997.32118408076,
      1.0981038029166984e6,
      852159.238669353
    ]
  },
  "EPSG:3377": {
    proj4: "+proj=cass +lat_0=2.12167974444444 +lon_0=103.427936236111 +x_0=-14810.562 +y_0=8758.32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -124762.75909349952,
      -92030.86426607426,
      115491.21036851947,
      100419.65012719788
    ]
  },
  "EPSG:3378": {
    proj4: "+proj=cass +lat_0=2.68234763611111 +lon_0=101.974905041667 +x_0=3673.785 +y_0=-4240.573 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -26909.427070335274,
      -76372.07351856417,
      85371.01879478319,
      61876.19288603566
    ]
  },
  "EPSG:3379": {
    proj4: "+proj=cass +lat_0=3.76938808888889 +lon_0=102.368298983333 +x_0=-7368.228 +y_0=6485.858 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -122846.18327233705,
      -139364.1658460017,
      137035.7590279281,
      118376.52196337617
    ]
  },
  "EPSG:3380": {
    proj4: "+proj=cass +lat_0=3.68464905 +lon_0=101.389107913889 +x_0=-34836.161 +y_0=56464.049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -104799.78620821459,
      -70091.45640554279,
      29681.97777041419,
      76982.06450532164
    ]
  },
  "EPSG:3381": {
    proj4: "+proj=cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -57071.026971585205,
      -116719.2146573992,
      91540.6306183129,
      105562.15879360249
    ]
  },
  "EPSG:3382": {
    proj4: "+proj=cass +lat_0=5.42151754166667 +lon_0=100.344376963889 +x_0=-23.414 +y_0=62.283 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -24901.945094199877,
      -33276.27961395521,
      23866.242297116423,
      18698.209997573133
    ]
  },
  "EPSG:3383": {
    proj4: "+proj=cass +lat_0=5.96467271388889 +lon_0=100.636371111111 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116026.95843195463,
      -97737.33518651681,
      53469.89394807668,
      83556.42294233653
    ]
  },
  "EPSG:3384": {
    proj4: "+proj=cass +lat_0=4.85906302222222 +lon_0=100.815410586111 +x_0=-1.769 +y_0=133454.779 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -82812.37472315582,
      896.2497713388002,
      131167.424636132,
      250917.4216973792
    ]
  },
  "EPSG:3385": {
    proj4: "+proj=cass +lat_0=5.97254365833333 +lon_0=102.295241669444 +x_0=13227.851 +y_0=8739.894 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -93887.43002072848,
      -149604.58780730332,
      54696.28220578203,
      43861.28002714346
    ]
  },
  "EPSG:3386": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      569025.6294103068,
      666378923429995e-8,
      582838.9996813686,
      6693053546303265e-9
    ]
  },
  "EPSG:3387": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      5423550322791057e-9,
      6970496065278934e-9,
      5428551937248337e-9,
      6989338165716584e-9
    ]
  },
  "EPSG:3388": {
    proj4: "+proj=merc +lat_ts=42 +lon_0=51 +x_0=0 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      -335551.1939537754,
      3321010631956877e-9,
      242756.78969989167,
      4.3956301604068335e6
    ]
  },
  "EPSG:3389": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6042202534870517e-8,
      6904702074893652e-9,
      6055272382672317e-8,
      7953867950004541e-9
    ]
  },
  "EPSG:3390": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6042202534870517e-8,
      6904702074893652e-9,
      6055272382672317e-8,
      7953867950004541e-9
    ]
  },
  "EPSG:3391": {
    proj4: "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      479980.81030344154,
      3444871084091685e-9,
      767844.5729074054,
      4.0710463321258444e6
    ]
  },
  "EPSG:3392": {
    proj4: "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      207889.20143174805,
      3.2180961154680727e6,
      765600.8985612501,
      4.1420689560165005e6
    ]
  },
  "EPSG:3393": {
    proj4: "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      210204.32676690468,
      3.3079026619069446e6,
      271797.4895598126,
      343178941712336e-8
    ]
  },
  "EPSG:3394": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      895240.3275604235,
      802691.489302889,
      2.0377090274607344e6,
      1.7239645173262293e6
    ]
  },
  "EPSG:3395": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -15496570739723718e-9,
      20037508342789244e-9,
      18764656231380563e-9
    ]
  },
  "EPSG:3396": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3565471493220262e-9,
      5579611205367224e-9,
      3.6040085522726006e6,
      5714866975008925e-9
    ]
  },
  "EPSG:3397": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4392918422939275e-9,
      5563600224422616e-9,
      4538762551778335e-9,
      5722848783313898e-9
    ]
  },
  "EPSG:3398": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      449214719086193e-8,
      5562529004616768e-9,
      4604472071430011e-9,
      5.7260050836864505e6
    ]
  },
  "EPSG:3399": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5393861031146521e-9,
      561031144103346e-8,
      5502772416177894e-9,
      571602617021165e-8
    ]
  },
  "EPSG:3400": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      134424.9540668641,
      543622373541443e-8,
      779712.6713351428,
      6659371689555864e-9
    ]
  },
  "EPSG:3401": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -365575.0459331359,
      543622373541443e-8,
      279712.67133514275,
      6659371689555864e-9
    ]
  },
  "EPSG:3402": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      134424.9540668641,
      543622373541443e-8,
      779712.6713351428,
      6659371689555864e-9
    ]
  },
  "EPSG:3403": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -365575.0459331359,
      543622373541443e-8,
      279712.67133514275,
      6659371689555864e-9
    ]
  },
  "EPSG:3404": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "EPSG:3405": {
    proj4: "+proj=utm +zone=48 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      184962.75604983052,
      921919.9800815885,
      806627.7806582332,
      2.5909908554942394e6
    ]
  },
  "EPSG:3406": {
    proj4: "+proj=utm +zone=49 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171513.71246661333,
      1.1545133357928563e6,
      347789.47600189055,
      2.3848440594616113e6
    ]
  },
  "EPSG:3407": {
    proj4: "+proj=cass +lat_0=22.3121333333333 +lon_0=114.178555555556 +x_0=40243.5777560424 +y_0=19069.9335151258 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs +type=crs",
    projected_bounds: [
      -9642.964998605905,
      -3405.254337423441,
      243864.92014524864,
      160004.62387255215
    ]
  },
  "EPSG:3413": {
    proj4: "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-2.3498291623399756e6, 2349829162339975e-9, 0, 0]
  },
  "EPSG:3414": {
    proj4: "+proj=tmerc +lat_0=1.36666666666667 +lon_0=103.833333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      919.0500208435915,
      12576.33577303091,
      54338.71764056321,
      50172.046234256464
    ]
  },
  "EPSG:3415": {
    proj4: "+proj=lcc +lat_0=21 +lon_0=114 +lat_1=18 +lat_2=24 +x_0=500000 +y_0=500000 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      91018.6338595036,
      207465.34187349566,
      782942.977578433,
      711474.3707314165
    ]
  },
  "EPSG:3416": {
    proj4: "+proj=lcc +lat_0=47.5 +lon_0=13.3333333333333 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      107674.10011432646,
      284902.9479101519,
      680511.9472727762,
      575905.4776601079
    ]
  },
  "EPSG:3417": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117312116e-9,
      5809817005680569e-9,
      403097617772355e-8
    ]
  },
  "EPSG:3418": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900591759,
      145967.54284040575,
      2.5529819520691475e6,
      760907.3065924722
    ]
  },
  "EPSG:3419": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78379384667,
      94022.9501781637,
      2.2701660783420214e6,
      628784.4164646415
    ]
  },
  "EPSG:3420": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.5643921482,
      1.4498073184572435e6,
      2.4223713754788456e6,
      2.1415323393213493e6
    ]
  },
  "EPSG:3421": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69716530634,
      26337061736499824e-9,
      1.0783563036380236e6,
      2889057681970665e-8
    ]
  },
  "EPSG:3422": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845731328e-9,
      20143476014967892e-9,
      2103195915755876e-9,
      21965178587309487e-9
    ]
  },
  "EPSG:3423": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128692019363e6,
      13927193731228566e-9,
      3057728434156613e-9,
      15767443303813899e-9
    ]
  },
  "EPSG:3424": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "EPSG:3425": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117312116e-9,
      5809817005680569e-9,
      403097617772355e-8
    ]
  },
  "EPSG:3426": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900591759,
      145967.54284040575,
      2.5529819520691475e6,
      760907.3065924722
    ]
  },
  "EPSG:3427": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78379384667,
      94022.9501781637,
      2.2701660783420214e6,
      628784.4164646415
    ]
  },
  "EPSG:3428": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.5643921482,
      1.4498073184572435e6,
      2.4223713754788456e6,
      2.1415323393213493e6
    ]
  },
  "EPSG:3429": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69716530634,
      26337061736499824e-9,
      1.0783563036380236e6,
      2889057681970665e-8
    ]
  },
  "EPSG:3430": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845731328e-9,
      20143476014967892e-9,
      2103195915755876e-9,
      21965178587309487e-9
    ]
  },
  "EPSG:3431": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128692019363e6,
      13927193731228566e-9,
      3057728434156613e-9,
      15767443303813899e-9
    ]
  },
  "EPSG:3432": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "EPSG:3433": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927636474,
      133024.73214629912,
      2.0059940206973983e6,
      796985.532192222
    ]
  },
  "EPSG:3434": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372184801,
      1.4464815951354958e6,
      1.7909758841421446e6,
      2201588044669436e-9
    ]
  },
  "EPSG:3435": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "EPSG:3436": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755813382592e6,
      116882.92627991362,
      2630018690092871e-9,
      2.1308039414543803e6
    ]
  },
  "EPSG:3437": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6667333606,
      70512.94210885341,
      1.2509593531533373e6,
      1.0260237739002687e6
    ]
  },
  "EPSG:3438": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19502980247,
      17196.895288001127,
      442211.17936438107,
      341584.60257313045
    ]
  },
  "EPSG:3439": {
    proj4: "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      605612.0033490162,
      1834299214095929e-9,
      814583.8794618597,
      2.1775510999585465e6
    ]
  },
  "EPSG:3440": {
    proj4: "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      180355.25430918485,
      1869655601100105e-9,
      789864.5786164876,
      2.9429750684825745e6
    ]
  },
  "EPSG:3441": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927636474,
      133024.73214629912,
      2.0059940206973983e6,
      796985.532192222
    ]
  },
  "EPSG:3442": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372184801,
      1.4464815951354958e6,
      1.7909758841421446e6,
      2201588044669436e-9
    ]
  },
  "EPSG:3443": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "EPSG:3444": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755813382592e6,
      116882.92627991362,
      2630018690092871e-9,
      2.1308039414543803e6
    ]
  },
  "EPSG:3445": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6667333606,
      70512.94210885341,
      1.2509593531533373e6,
      1.0260237739002687e6
    ]
  },
  "EPSG:3446": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19502980247,
      17196.895288001127,
      442211.17936438107,
      341584.60257313045
    ]
  },
  "EPSG:3447": {
    proj4: "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150328 +y_0=166262 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      15655.595656322024,
      23593.653625145933,
      292004.7334139676,
      247440.8533193401
    ]
  },
  "EPSG:3448": {
    proj4: "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=750000 +y_0=650000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      598250.0782528355,
      610740.7240190364,
      837613.4627725295,
      714393.7537292626
    ]
  },
  "EPSG:3449": {
    proj4: "+proj=utm +zone=17 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      543166.5685480806,
      1565458490695683e-9,
      816228.9305791942,
      2.1434168312582434e6
    ]
  },
  "EPSG:3450": {
    proj4: "+proj=utm +zone=18 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      176008.63414233836,
      1.5586388071227847e6,
      551511.0144998208,
      2.1230296888891626e6
    ]
  },
  "EPSG:3451": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820868968125e6,
      130801.94638079239,
      3.7835269611517936e6,
      924186.3271600471
    ]
  },
  "EPSG:3452": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2446298884424555e-9,
      136782.5696471812,
      4.0896985619561956e6,
      943782.5429849147
    ]
  },
  "EPSG:3453": {
    proj4: "+proj=lcc +lat_0=25.5 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2410821807220307e-9,
      1.2272656766738745e6,
      4.0769514860433824e6,
      2750307038609246e-9
    ]
  },
  "EPSG:3455": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848209,
      2.9816539445174607e6,
      919283.4783585763
    ]
  },
  "EPSG:3456": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820868968125e6,
      130801.94638079239,
      3.7835269611517936e6,
      924186.3271600471
    ]
  },
  "EPSG:3457": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2446298884424555e-9,
      136782.5696471812,
      4.0896985619561956e6,
      943782.5429849147
    ]
  },
  "EPSG:3458": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392498,
      2871291092665175e-9,
      791529.090946073
    ]
  },
  "EPSG:3459": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848209,
      2.9816539445174607e6,
      919283.4783585763
    ]
  },
  "EPSG:3460": {
    proj4: "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7980445826221989e6,
      3.5771146535891336e6,
      2.3371662042853376e6,
      4.5047213075596765e6
    ]
  },
  "EPSG:3461": {
    proj4: "+proj=utm +zone=28 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      485711.29208523344,
      995869.7447232855,
      825877.9313571809,
      1403496919346865e-9
    ]
  },
  "EPSG:3462": {
    proj4: "+proj=utm +zone=29 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      168628.94148984103,
      795766.7007880502,
      646693.0584611611,
      1.3831998508691427e6
    ]
  },
  "EPSG:3463": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      427110.6227171908,
      28173.763208158933,
      559930.8874513158,
      441528.35357238876
    ]
  },
  "EPSG:3464": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427110.6227171908,
      28173.763208158933,
      559930.8874513158,
      441528.35357238876
    ]
  },
  "EPSG:3465": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "EPSG:3466": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      505580.44594500464,
      15923.948440411992,
      709514.5981036696,
      557319.3872848145
    ]
  },
  "EPSG:3467": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2257390058712074e-9,
      726720.2472649922,
      858192.2020793316,
      2534628449266282e-9
    ]
  },
  "EPSG:3468": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345065.0006292928,
      334042.20469821244,
      1.0216737568623158e6,
      954041.2679213481
    ]
  },
  "EPSG:3469": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386918.31041990273,
      638611.495563188,
      538646.0751082397,
      1.8010582813575123e6
    ]
  },
  "EPSG:3470": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      387480.7933152069,
      638594.4905497337,
      574961.5237298968,
      1.8265091488610085e6
    ]
  },
  "EPSG:3471": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384866.0062102319,
      570683.0524052249,
      574413.9786087219,
      1.8543974615086422e6
    ]
  },
  "EPSG:3472": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374335.66296567384,
      193265.41672186597,
      576665.1462954525,
      1927037849194219e-9
    ]
  },
  "EPSG:3473": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      371683.47061143327,
      100891.27017918504,
      571564.5392518891,
      1.9402596195834302e6
    ]
  },
  "EPSG:3474": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      369227.2759588344,
      37478.56021629183,
      573639.6586334868,
      1866650932337704e-9
    ]
  },
  "EPSG:3475": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      353035.9059764714,
      40196.47731406788,
      579818.6224001455,
      1678220016121422e-9
    ]
  },
  "EPSG:3476": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      305398.63289577013,
      281655.18765712064,
      591427.5708482452,
      1.3181762713116712e6
    ]
  },
  "EPSG:3477": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195688.3999031469,
      98298.29792074177,
      1.7230791763698556e6,
      427904.9014095053
    ]
  },
  "EPSG:3478": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76951.28315104556,
      37471.49767701424,
      344774.25509364414,
      667599.2730779602
    ]
  },
  "EPSG:3479": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "EPSG:3480": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66481.57726905748,
      37612.94225911591,
      313625.1177186511,
      667173.219860401
    ]
  },
  "EPSG:3481": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "EPSG:3482": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113255.82314843503,
      116906.13012893949,
      322839.39768852945,
      666199.5535385566
    ]
  },
  "EPSG:3483": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2229279364,
      383550.2956986203,
      1.0591843756185349e6,
      2185694073289227e-9
    ]
  },
  "EPSG:3484": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      159882.1517288231,
      40546.019450230866,
      611428.2003751276,
      242921.67605554135
    ]
  },
  "EPSG:3485": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927636474,
      133024.73214629912,
      2.0059940206973983e6,
      796985.532192222
    ]
  },
  "EPSG:3486": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      168267.01668838607,
      440888.471984403,
      545890.5412777681,
      671045.3781161602
    ]
  },
  "EPSG:3487": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372184801,
      1.4464815951354958e6,
      1.7909758841421446e6,
      2201588044669436e-9
    ]
  },
  "EPSG:3488": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -418604.90866352344,
      -599248.9206782463,
      487730.49001781485,
      458666.85968259815
    ]
  },
  "EPSG:3489": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7895395665343686e6,
      531443.8371340163,
      216650689441652e-8,
      799143.9865565519
    ]
  },
  "EPSG:3490": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061538175e-9,
      1743578655997185e-9,
      7107948036431532e-9,
      2621858229560954e-9
    ]
  },
  "EPSG:3491": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8191142581414783e6,
      541273.7589847766,
      2.2095712464330723e6,
      779630.525372654
    ]
  },
  "EPSG:3492": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695585834e-9,
      1.7758289912692206e6,
      7249234998005839e-9,
      2557837815660115e-9
    ]
  },
  "EPSG:3493": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1774907679626609e-9,
      528557.1371854008,
      2.2322182534678923e6,
      748597.178483144
    ]
  },
  "EPSG:3494": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5823176279241634e-9,
      1.7341078745824352e6,
      7323536053585911e-9,
      2456022576740115e-9
    ]
  },
  "EPSG:3495": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1727886776452719e-9,
      553828.3138820408,
      2298520922247323e-9,
      754562.841666431
    ]
  },
  "EPSG:3496": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532745296e-9,
      1.8170183934613287e6,
      7541064059406428e-9,
      2.4755949233672824e6
    ]
  },
  "EPSG:3497": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6794231645368338e6,
      423356.5291107174,
      2350617831343431e-9,
      763023.8066438821
    ]
  },
  "EPSG:3498": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907499317929e-9,
      1.3889622129240783e6,
      7711985335332574e-9,
      2.5033539392974693e6
    ]
  },
  "EPSG:3499": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8215040867444675e6,
      541921.609051466,
      2168903381623939e-9,
      713685.2401208607
    ]
  },
  "EPSG:3500": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324927474e-9,
      1.7779544793630175e6,
      711581051154454e-8,
      2.3414823256298574e6
    ]
  },
  "EPSG:3501": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      602369.9938571034,
      344958.28088118456,
      1.2094300492099929e6,
      560943.6928306813
    ]
  },
  "EPSG:3502": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755545300983e6,
      1.1317506265283525e6,
      3.9679384194670366e6,
      1.8403627655659935e6
    ]
  },
  "EPSG:3503": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      608530.8153568001,
      336108.1196154525,
      1.2054047088972987e6,
      496651.021459994
    ]
  },
  "EPSG:3504": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881830670196e6,
      1.1027147224423632e6,
      3.9547319487911398e6,
      1.6294292262439965e6
    ]
  },
  "EPSG:3505": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      597496.3981335191,
      345615.6716642405,
      1.2154220791101314e6,
      533836.9174519398
    ]
  },
  "EPSG:3506": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9602860992269719e6,
      1.1339074161224284e6,
      3.9875972708977414e6,
      1.7514299533442387e6
    ]
  },
  "EPSG:3507": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222322.54347837297,
      169156.3466800607,
      385103.12220492034,
      287977.4369607322
    ]
  },
  "EPSG:3508": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113992947,
      554973.7807348338,
      1.2634591601046422e6,
      944805.9744306704
    ]
  },
  "EPSG:3509": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166533.1617424154,
      48909.64130833831,
      238225.79702413955,
      205470.4830819298
    ]
  },
  "EPSG:3510": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.5484832405,
      160464.3815257733,
      781579.1360700305,
      674114.4099112981
    ]
  },
  "EPSG:3511": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      65102.24329868861,
      9138.495345549798,
      298540.2068111297,
      720329.5066960583
    ]
  },
  "EPSG:3512": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.61022244688,
      29981.8801461913,
      979460.662179514,
      2363281056551985e-9
    ]
  },
  "EPSG:3513": {
    proj4: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32031.289285340346,
      50838.306792611686,
      784566.8641495073,
      784246.4748000703
    ]
  },
  "EPSG:3514": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      295646.50247016025,
      27456.531402877317,
      834910.9831262925,
      225348.7609827654
    ]
  },
  "EPSG:3515": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "EPSG:3516": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66150.82424507887,
      215219.2456022235,
      284274.37357896275,
      583846.6255438706
    ]
  },
  "EPSG:3517": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.82954406223,
      706098.4749466283,
      932656.8409836462,
      1.9155034706385157e6
    ]
  },
  "EPSG:3518": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      74709.789308767,
      40624.309794496774,
      327985.22104999487,
      519815.2404935042
    ]
  },
  "EPSG:3519": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.36742384572,
      133281.58971744485,
      1.0760648463948576e6,
      1705427168185772e-9
    ]
  },
  "EPSG:3520": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      561618.6831736781,
      69612.78234582106,
      807394.5382984749,
      556166.0817971718
    ]
  },
  "EPSG:3521": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772960456433e6,
      228387.93674624796,
      2648926914067581e-9,
      1.8246882200295548e6
    ]
  },
  "EPSG:3522": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      392281.83037533704,
      36728.336945737465,
      602797.1348322467,
      448951.8476535554
    ]
  },
  "EPSG:3523": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1287011305489751e-9,
      120499.55212947368,
      1.9776769335287954e6,
      1472936186843373e-9
    ]
  },
  "EPSG:3524": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      111063.71939851393,
      36468.06030250205,
      289214.9223945835,
      343148.0611808968
    ]
  },
  "EPSG:3525": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.5530599571,
      119645.62784245881,
      948865.9582228954,
      1.1258115973909926e6
    ]
  },
  "EPSG:3526": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      676539.7837076162,
      36984.30998402688,
      904606.2381105269,
      817057.2289334119
    ]
  },
  "EPSG:3527": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2219614274047403e-9,
      121339.35700592819,
      2.9678622998676198e6,
      2.6806285919257025e6
    ]
  },
  "EPSG:3528": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215802.92024991306,
      44068.31688321397,
      407952.84533971857,
      648476.2402160055
    ]
  },
  "EPSG:3529": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "EPSG:3530": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      579509.9562219738,
      35625.98718209203,
      801631.300013067,
      649470.3402959756
    ]
  },
  "EPSG:3531": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755813382592e6,
      116882.92627991362,
      2630018690092871e-9,
      2.1308039414543803e6
    ]
  },
  "EPSG:3532": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18848.169675766898,
      300346.5557813935,
      173722.82933421258,
      724452.6023682763
    ]
  },
  "EPSG:3533": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70301124523,
      985386.9914261225,
      569955.6489073292,
      2.3768082459365875e6
    ]
  },
  "EPSG:3534": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      813951.5557038783,
      280415.4110952896,
      970119.8033495815,
      724416.3646416317
    ]
  },
  "EPSG:3535": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393956718077e6,
      919996.2275684634,
      3.1828013881560857e6,
      2.3766893559950874e6
    ]
  },
  "EPSG:3536": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2384564841177673e6,
      1043750404067701e-9,
      1.7708357650029673e6,
      1.2286439962682903e6
    ]
  },
  "EPSG:3537": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117312116e-9,
      5809817005680569e-9,
      403097617772355e-8
    ]
  },
  "EPSG:3538": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275804.31496850675,
      44490.99603974775,
      778150.4552814267,
      231925.01089940732
    ]
  },
  "EPSG:3539": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900591759,
      145967.54284040575,
      2.5529819520691475e6,
      760907.3065924722
    ]
  },
  "EPSG:3540": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      46038.237386999186,
      28658.252530809354,
      691948.0045848172,
      191653.8734461696
    ]
  },
  "EPSG:3541": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78379384667,
      94022.9501781637,
      2.2701660783420214e6,
      628784.4164646415
    ]
  },
  "EPSG:3542": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      84022.72728234128,
      441902.1544802367,
      738340.2719366557,
      652740.3625160322
    ]
  },
  "EPSG:3543": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.5643921482,
      1.4498073184572435e6,
      2.4223713754788456e6,
      2.1415323393213493e6
    ]
  },
  "EPSG:3544": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      349218.2791870525,
      24709.163041468903,
      653864.4011060491,
      184641.09895005127
    ]
  },
  "EPSG:3545": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269712995207e6,
      81066.64574521924,
      2145220122962096e-9,
      605776.6721386266
    ]
  },
  "EPSG:3546": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1577469491398442e6,
      1.0243945737160366e6,
      1.8284434576961924e6,
      1.3193168596829686e6
    ]
  },
  "EPSG:3547": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.7983747823029724e6,
      3.3608678636000315e6,
      5998818244124926e-9,
      4328458730143207e-9
    ]
  },
  "EPSG:3548": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      157793.0920864537,
      524305.3717931777,
      832918.8536462528,
      710531.6721022655
    ]
  },
  "EPSG:3549": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83662030625,
      1.7201585409581168e6,
      2.7326679393377476e6,
      2331135994555516e-9
    ]
  },
  "EPSG:3550": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      851729.3635550354,
      39868.512993891505,
      1153221324211875e-9,
      281692.5559034941
    ]
  },
  "EPSG:3551": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820868968125e6,
      130801.94638079239,
      3.7835269611517936e6,
      924186.3271600471
    ]
  },
  "EPSG:3552": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      745633.3912495468,
      41691.410611282045,
      1246542614779638e-9,
      287665.49443279085
    ]
  },
  "EPSG:3553": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2446298884424555e-9,
      136782.5696471812,
      4.0896985619561956e6,
      943782.5429849147
    ]
  },
  "EPSG:3554": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427110.6227171908,
      28173.763208158933,
      559930.8874513158,
      441528.35357238876
    ]
  },
  "EPSG:3555": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      643626.9498361305,
      38759.89775611995,
      772884.0925903314,
      393521.3588579671
    ]
  },
  "EPSG:3556": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      241765.49550198903,
      26539.33912282469,
      358635.93205308926,
      416628.2804443663
    ]
  },
  "EPSG:3557": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177049.16196835245,
      24838.65270351215,
      419851.20673729526,
      423896.7865970171
    ]
  },
  "EPSG:3558": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      824761.6428981957,
      23371.92855680277,
      969493.4665432682,
      416737.78627018543
    ]
  },
  "EPSG:3559": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181219.09721396962,
      36655.85913985907,
      574026.6173549057,
      230987.04872253875
    ]
  },
  "EPSG:3560": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497758587,
      3.3700884313268475e6,
      2308928589168566e-9,
      3.9012032387521933e6
    ]
  },
  "EPSG:3561": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      292573.0853884094,
      13665.869128843442,
      760383.620771604,
      544121.5975899016
    ]
  },
  "EPSG:3562": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      262641.7068920412,
      42873.73025629307,
      750847.0264068362,
      337155.02425699594
    ]
  },
  "EPSG:3563": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      387583.37236274465,
      12224.75215440103,
      632358.3693831638,
      212058.34259624648
    ]
  },
  "EPSG:3564": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381266.38061698416,
      -8341.29366817564,
      591285.857455226,
      165974.51056681288
    ]
  },
  "EPSG:3565": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      454742.78609139106,
      23025.748440961423,
      559823.791330004,
      146551.20504334153
    ]
  },
  "EPSG:3566": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2675122725,
      662913986591458e-8,
      2318643783407357e-9,
      7.5715126886745235e6
    ]
  },
  "EPSG:3567": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837381719,
      9970386894164445e-9,
      2343632289009411e-9,
      10548467588471211e-9
    ]
  },
  "EPSG:3568": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497758587,
      3.3700884313268475e6,
      2308928589168566e-9,
      3.9012032387521933e6
    ]
  },
  "EPSG:3569": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2675122725,
      662913986591458e-8,
      2318643783407357e-9,
      7.5715126886745235e6
    ]
  },
  "EPSG:3570": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837381719,
      9970386894164445e-9,
      2343632289009411e-9,
      10548467588471211e-9
    ]
  },
  "EPSG:3571": {
    proj4: "+proj=laea +lat_0=90 +lon_0=180 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, -4889334802954878e-9, 0, 0]
  },
  "EPSG:3572": {
    proj4: "+proj=laea +lat_0=90 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-2444667401477438e-9, -4234288146966307e-9, 0, 0]
  },
  "EPSG:3573": {
    proj4: "+proj=laea +lat_0=90 +lon_0=-100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-4815054821022379e-9, -849024.0785366148, 0, 0]
  },
  "EPSG:3574": {
    proj4: "+proj=laea +lat_0=90 +lon_0=-40 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-3142803830948573e-9, 3.7454477563518067e6, 0, 0]
  },
  "EPSG:3575": {
    proj4: "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [849024.078536614, 481505482102238e-8, 0, 0]
  },
  "EPSG:3576": {
    proj4: "+proj=laea +lat_0=90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [4889334802954878e-9, -29938541081992227e-26, 0, 0]
  },
  "EPSG:3577": {
    proj4: "+proj=aea +lat_0=0 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.5944945069731595e6,
      -4894565948680871e-9,
      2436270292794993e-9,
      -1.2404800126373384e6
    ]
  },
  "EPSG:3578": {
    proj4: "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.6666666666667 +lat_2=68 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      25598.640187743935,
      641914.604659865,
      832564.8475667299,
      1715492359443621e-9
    ]
  },
  "EPSG:3579": {
    proj4: "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.6666666666667 +lat_2=68 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25598.640187743935,
      641914.604659865,
      832564.8475667299,
      1715492359443621e-9
    ]
  },
  "EPSG:3580": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-112 +lat_1=62 +lat_2=70 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1335122527440251e-9,
      8383623535945726e-9,
      222225.85153524185,
      10247935770543916e-9
    ]
  },
  "EPSG:3581": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-112 +lat_1=62 +lat_2=70 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1335122527440251e-9,
      8383623535945726e-9,
      222225.85153524185,
      10247935770543916e-9
    ]
  },
  "EPSG:3582": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6544428327,
      120261.76452802098,
      1.8832856601052207e6,
      757830.009017196
    ]
  },
  "EPSG:3583": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465603.8085218641,
      21182.19390165996,
      550924.4533078014,
      56819.46303831281
    ]
  },
  "EPSG:3584": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5275684954588155e6,
      69495.24782569606,
      1.8074913108940115e6,
      186415.18831819796
    ]
  },
  "EPSG:3585": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32912.32927433509,
      803051.4395878355,
      333962.18491762364,
      961218.4864862445
    ]
  },
  "EPSG:3586": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86729421368,
      2.6346779313810905e6,
      1095674268683903e-9,
      3.1535976510802875e6
    ]
  },
  "EPSG:3587": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5783269683611322e-9,
      57309.82074061751,
      6162640001784503e-9,
      291399.94080042426
    ]
  },
  "EPSG:3588": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901533205e-9,
      188024.34626186846,
      20218635176379602e-9,
      956036.5511824941
    ]
  },
  "EPSG:3589": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7730770077384338e-9,
      38783.29196926807,
      8264072881829599e-9,
      399102.5058484581
    ]
  },
  "EPSG:3590": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      25363418888951235e-9,
      127241.77155271676,
      2711310000589763e-8,
      1.3093914233873296e6
    ]
  },
  "EPSG:3591": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      131754.1460535056,
      135994.88864500355,
      786822.1064603678,
      870498.7798355976
    ]
  },
  "EPSG:3592": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3764135981418406e-9,
      25074.8909276311,
      4178741346471115e-9,
      304539.3832952072
    ]
  },
  "EPSG:3593": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498039389e-9,
      82266.70251847472,
      13709781320390796e-9,
      999144.9583176089
    ]
  },
  "EPSG:3594": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      595233.1859048485,
      134496.0658554411,
      947732.4888004595,
      377495.16347312875
    ]
  },
  "EPSG:3595": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      484662.883379609,
      123970.60197833316,
      1.0621099971384865e6,
      426349.3882135941
    ]
  },
  "EPSG:3596": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      569492.5128116711,
      158465.4349358629,
      1.0176934793720534e6,
      391514.8607947015
    ]
  },
  "EPSG:3597": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      190340.12052613805,
      57073.9038946292,
      367846.54652006144,
      611234.9881211288
    ]
  },
  "EPSG:3598": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "EPSG:3599": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      574253.7728630524,
      167020.95974745313,
      787927.2680533797,
      611406.5844740515
    ]
  },
  "EPSG:3600": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1884030919468199e-9,
      547967.9321047692,
      2585058044938464e-9,
      2005923102561951e-9
    ]
  },
  "EPSG:3601": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384402.582974351,
      72524.35270280449,
      592240.4863549052,
      530749.7674890533
    ]
  },
  "EPSG:3602": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      117430.21416727672,
      17271.89955836394,
      368474.73767414974,
      531120.8788109587
    ]
  },
  "EPSG:3603": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857344828,
      35516.95357112248,
      936343.0942781423,
      491477.91794944176
    ]
  },
  "EPSG:3604": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76530.54027482809,
      33084.524119235604,
      999117.0470033675,
      542896.2532425779
    ]
  },
  "EPSG:3605": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497126905,
      108545.02663791207,
      3.2779430675884755e6,
      1781155686491397e-9
    ]
  },
  "EPSG:3606": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153376.2252400727,
      25535.919165928193,
      882993.4575054274,
      363144.7550580989
    ]
  },
  "EPSG:3607": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      362659.33828742534,
      6139743768849751e-9,
      641055.3972230253,
      6694999823411577e-9
    ]
  },
  "EPSG:3608": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845731328e-9,
      20143476014967892e-9,
      2103195915755876e-9,
      21965178587309487e-9
    ]
  },
  "EPSG:3609": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69754.74639531817,
      802755247237993e-8,
      328683.6587060269,
      880586542636728e-8
    ]
  },
  "EPSG:3610": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69716530634,
      26337061736499824e-9,
      1.0783563036380236e6,
      2889057681970665e-8
    ]
  },
  "EPSG:3611": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      673826.6301758505,
      4245017139322905e-9,
      931997.4907157569,
      4.8059263308652975e6
    ]
  },
  "EPSG:3612": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128692019363e6,
      13927193731228566e-9,
      3057728434156613e-9,
      15767443303813899e-9
    ]
  },
  "EPSG:3613": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226793.8024079331,
      21492.387739553997,
      381293.173427484,
      312732.6717501454
    ]
  },
  "EPSG:3614": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6667333606,
      70512.94210885341,
      1.2509593531533373e6,
      1.0260237739002687e6
    ]
  },
  "EPSG:3615": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      54545.12015456795,
      4645.126015017602,
      201873.90102511132,
      280709.69043490384
    ]
  },
  "EPSG:3616": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "EPSG:3617": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      359824.2791681125,
      87428.3980117214,
      625497.4318649578,
      666399.5233026792
    ]
  },
  "EPSG:3618": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234895707152e6,
      286838.0024767893,
      2.0521528247102818e6,
      2.1863457693688734e6
    ]
  },
  "EPSG:3619": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33975.77074362352,
      111708.32825589125,
      284564.5241670381,
      666319.758960204
    ]
  },
  "EPSG:3620": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84118137152,
      366496.4069528699,
      933608.7763713576,
      2.1860840758552696e6
    ]
  },
  "EPSG:3621": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      713259.0787200994,
      37234.66266182869,
      964697.4631390541,
      666551.8767344605
    ]
  },
  "EPSG:3622": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2340084161100859e-9,
      122160.72241634964,
      3.1650115939820465e6,
      2186845615586309e-9
    ]
  },
  "EPSG:3623": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153330.97415895032,
      221641.78111359302,
      372921.93601385155,
      490979.04527605977
    ]
  },
  "EPSG:3624": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37071982364,
      727169.7435368465,
      1223494718072112e-9,
      1610820417709873e-9
    ]
  },
  "EPSG:3625": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34535.94492432893,
      228126.12062753108,
      250090.6353354547,
      687881.3551997013
    ]
  },
  "EPSG:3626": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "EPSG:3627": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277950.22920969536,
      33716.39444708275,
      484240.9609220226,
      128170.64580043124
    ]
  },
  "EPSG:3628": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.870781804,
      1.5887138859583358e6,
      420506.5270969149
    ]
  },
  "EPSG:3629": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251673.76576198317,
      221664.55284669463,
      448704.434264811,
      404996.19022632844
    ]
  },
  "EPSG:3630": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6801707726,
      727244.453797864,
      1.4721244650838003e6,
      1328725000767546e-9
    ]
  },
  "EPSG:3631": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      116361.13496227108,
      22119.88887843388,
      933520.6710072559,
      320979.26197346306
    ]
  },
  "EPSG:3632": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "EPSG:3633": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329319.5931117032,
      22953.606831219873,
      868402.9550716814,
      229887.8527663513
    ]
  },
  "EPSG:3634": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592824906e6,
      75307.10902631191,
      2849091059938587e-9,
      754225.2387347483
    ]
  },
  "EPSG:3635": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324736.07413660234,
      35492.61573469327,
      895638.4324845031,
      247922.52117242807
    ]
  },
  "EPSG:3636": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      106540706736943e-8,
      116445.58968075218,
      2938446300794301e-9,
      813394.0983347377
    ]
  },
  "EPSG:3637": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403035.4105968764,
      50729.9881009595,
      764034.121937581,
      297653.7686659716
    ]
  },
  "EPSG:3638": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      396472.80539090245,
      47032.74485349966,
      752900.9644348032,
      263532.0000815143
    ]
  },
  "EPSG:3639": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      145234.1114682252,
      41670.65752654181,
      918564.8787926256,
      228901.9813547924
    ]
  },
  "EPSG:3640": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.48223499593,
      3.0136582731721397e6,
      750989.2504948481
    ]
  },
  "EPSG:3641": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      414409.71996951895,
      33637.59674371423,
      924488.3684600198,
      253870.04933969502
    ]
  },
  "EPSG:3642": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3033092255522582e-9,
      832905.3202086495
    ]
  },
  "EPSG:3643": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60163.86735144921,
      34049.00237979901,
      710705.1662058923,
      508757.95951940055
    ]
  },
  "EPSG:3644": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      197388.0162396627,
      111709.32539304135,
      2.3317098628749745e6,
      1.6691534104967208e6
    ]
  },
  "EPSG:3645": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546260644754e-8,
      38177.19394785736,
      2.8106066110863457e6,
      295944.2058068297
    ]
  },
  "EPSG:3646": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:3647": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1160304687469061e-9,
      43124.56959847481,
      1785979111173056e-9,
      327582.564817976
    ]
  },
  "EPSG:3648": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:3649": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364722.69794594496,
      51900.29667448759,
      850571.8392683543,
      266893.21477785433
    ]
  },
  "EPSG:3650": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2.7905844426662596e6,
      875632.1554836772
    ]
  },
  "EPSG:3651": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      361633.13518682023,
      45575.569319858565,
      854195.2283628277,
      209415.98457540976
    ]
  },
  "EPSG:3652": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.847010236,
      2802472178387044e-9,
      687058.9427278236
    ]
  },
  "EPSG:3653": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70610.77827680032,
      5241.624167031077,
      134786.23705289746,
      104115.19509468034
    ]
  },
  "EPSG:3654": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19502980247,
      17196.895288001127,
      442211.17936438107,
      341584.60257313045
    ]
  },
  "EPSG:3655": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386694.5942843487,
      26576.309440707257,
      835428.2312511974,
      377206.79542095796
    ]
  },
  "EPSG:3656": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "EPSG:3657": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      274445.55115673057,
      42263.33611194055,
      875171.275386896,
      241258.5494374619
    ]
  },
  "EPSG:3658": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392498,
      2871291092665175e-9,
      791529.090946073
    ]
  },
  "EPSG:3659": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      293645.5414990948,
      23168.18099115532,
      908809.9399088017,
      280198.16460002324
    ]
  },
  "EPSG:3660": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848209,
      2.9816539445174607e6,
      919283.4783585763
    ]
  },
  "EPSG:3661": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206556.4167882325,
      80414.01570951591,
      988711.5866813468,
      269011.42753063503
    ]
  },
  "EPSG:3662": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3.2437979306370523e6,
      882581.6584900919
    ]
  },
  "EPSG:3663": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      88485.92409938853,
      302995849409869e-8,
      1.3434805489688965e6,
      3308389707573836e-9
    ]
  },
  "EPSG:3664": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5689827447,
      9940788826055452e-9,
      4407735767408789e-9,
      10854275232265161e-9
    ]
  },
  "EPSG:3665": {
    proj4: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831192.2778944278,
      6877890180217122e-9,
      2.0832733485623298e6,
      8058739531869909e-9
    ]
  },
  "EPSG:3666": {
    proj4: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831139.3452904851,
      589725675084688e-8,
      2083223989295547e-9,
      7076453726029536e-9
    ]
  },
  "EPSG:3667": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      59141.726237106894,
      1.0343726299247856e6,
      335289.3759396124,
      1.2783945558126816e6
    ]
  },
  "EPSG:3668": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.14716290752,
      3.3936042030115686e6,
      1.1000285612285445e6,
      4.1941994715287737e6
    ]
  },
  "EPSG:3669": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166935.12352544628,
      2015335542194466e-9,
      1.0128529570071837e6,
      2.3319457757578273e6
    ]
  },
  "EPSG:3670": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980025016344e-9,
      3323001743114402e-9,
      7650725432965473e-9
    ]
  },
  "EPSG:3671": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      129543.46292791484,
      5019245231079103e-9,
      461995.7043444619,
      5282860637212539e-9
    ]
  },
  "EPSG:3672": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062632026e-9,
      1.5157309066701222e6,
      17332185274254806e-9
    ]
  },
  "EPSG:3673": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8759.288909710362,
      4.0092582172219283e6,
      1.1020569519511203e6,
      4.3256547587438645e6
    ]
  },
  "EPSG:3674": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.767031274747,
      13153708000668947e-9,
      3.6156651831929674e6,
      14191752320645498e-9
    ]
  },
  "EPSG:3675": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277517.6837629482,
      2.0205658722523483e6,
      706724.0386204798,
      2307801683101201e-9
    ]
  },
  "EPSG:3676": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      910491.0889545543,
      6629153124161247e-9,
      2.3186484211643036e6,
      7571527831670606e-9
    ]
  },
  "EPSG:3677": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2675122725,
      662913986591458e-8,
      2318643783407357e-9,
      7.5715126886745235e6
    ]
  },
  "EPSG:3678": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284873.76674905524,
      1.0272050082885996e6,
      703762.8414941019,
      1189089125360079e-9
    ]
  },
  "EPSG:3679": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      934625.2194864015,
      3.3700951715373998e6,
      2.3089332074950845e6,
      3.9012110411944846e6
    ]
  },
  "EPSG:3680": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497758587,
      3.3700884313268475e6,
      2308928589168566e-9,
      3.9012032387521933e6
    ]
  },
  "EPSG:3681": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      273008.07224937936,
      3038980003301329e-9,
      714340.5503610092,
      3.2151793513247273e6
    ]
  },
  "EPSG:3682": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      895695.7755898271,
      9970406834938742e-9,
      2343636976743468e-9,
      10548488685409209e-9
    ]
  },
  "EPSG:3683": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837381719,
      9970386894164445e-9,
      2343632289009411e-9,
      10548467588471211e-9
    ]
  },
  "EPSG:3684": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      423006.8382807577,
      24866.35169431841,
      578802.8666454776,
      281578.89655270055
    ]
  },
  "EPSG:3685": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3625533262610403e6,
      2.0126377358033953e6,
      3671261036751879e-9,
      2.2009270598530993e6
    ]
  },
  "EPSG:3686": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703824143e-8,
      660312897188164e-8,
      1204479558507679e-8,
      7220874862534711e-9
    ]
  },
  "EPSG:3687": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0363669807438697e6,
      1035658136976271e-9,
      3779083924305619e-9,
      1.2207621363122454e6
    ]
  },
  "EPSG:3688": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002990512e-9,
      3397821737396317e-9,
      12398544508659353e-9,
      4.0051171085510924e6
    ]
  },
  "EPSG:3689": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199622.13896693767,
      16618.325904665824,
      778655.8701648887,
      234845.72192574284
    ]
  },
  "EPSG:3690": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9679273608,
      54521.95757222446,
      2554640134365972e-9,
      770489.672684708
    ]
  },
  "EPSG:3691": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195499.3912097729,
      30501.042787402166,
      769845.025376511,
      259212.8282079461
    ]
  },
  "EPSG:3692": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9196607294,
      100068.83787833528,
      2525733221089436e-9,
      850434.0872122366
    ]
  },
  "EPSG:3693": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403574.77820059075,
      31335.654182597726,
      750577.3343822454,
      239088.0765441185
    ]
  },
  "EPSG:3694": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      453513.4977037739,
      23502.170616556796,
      768516.5072083795,
      242635.52047372516
    ]
  },
  "EPSG:3695": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      368160.8288686152,
      20423.476917061555,
      891449.2804629535,
      225280.70276785115
    ]
  },
  "EPSG:3696": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205946,
      2.9246965143188736e6,
      739108.438997525
    ]
  },
  "EPSG:3697": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373644.5392621008,
      26717.932057823346,
      747455.7457836679,
      240055.50940082088
    ]
  },
  "EPSG:3698": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "EPSG:3699": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      482416.58582546015,
      54333.04951709173,
      843230.2890341961,
      263304.7487854953
    ]
  },
  "EPSG:3700": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.67995732513,
      2766498039939692e-9,
      863858.9966404126
    ]
  },
  "EPSG:3701": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282455.2023938304,
      227119.95484749787,
      803426.5861082915,
      766436.4349943912
    ]
  },
  "EPSG:3702": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      102113.10863394958,
      55062.47534181787,
      288024.8211402613,
      501582.3192299155
    ]
  },
  "EPSG:3703": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      290893.7234442881,
      155220.4817241857,
      505104.26743197144,
      601840.6136762074
    ]
  },
  "EPSG:3704": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      405623.04948556976,
      56981.50934947065,
      698535.2494466461,
      501735.86149144557
    ]
  },
  "EPSG:3705": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      717820.1237859536,
      154870.05021642725,
      882729.2572612413,
      563723.8222876207
    ]
  },
  "EPSG:3706": {
    proj4: "+proj=utm +zone=59 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      255040.97594940502,
      5433975758357479e-9,
      686334.7381179817,
      6241316103447333e-9
    ]
  },
  "EPSG:3707": {
    proj4: "+proj=utm +zone=60 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275878.0522029962,
      5311765433025767e-9,
      683820.3879196523,
      6284675176375143e-9
    ]
  },
  "EPSG:3708": {
    proj4: "+proj=utm +zone=1 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275705.2007711646,
      5307320288937037e-9,
      651326.6101829188,
      7012536575907362e-9
    ]
  },
  "EPSG:3709": {
    proj4: "+proj=utm +zone=2 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      279095.5340691147,
      5394004676025433e-9,
      597909.7820209023,
      8108518214682238e-9
    ]
  },
  "EPSG:3710": {
    proj4: "+proj=utm +zone=3 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282881.3113258418,
      5489589711728697e-9,
      590937.4580819238,
      8246692023643711e-9
    ]
  },
  "EPSG:3711": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      289420.59814113064,
      5651885738696898e-9,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:3712": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      294760.555044646,
      5781966310022121e-9,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:3713": {
    proj4: "+proj=utm +zone=6 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      303614.943130552,
      599324839556645e-8,
      591839.6077320275,
      8228862484656331e-9
    ]
  },
  "EPSG:3714": {
    proj4: "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      300888.49477118085,
      5928746531703682e-9,
      594878.9639862768,
      8168689220963358e-9
    ]
  },
  "EPSG:3715": {
    proj4: "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      301497.8173291563,
      5943203448548857e-9,
      597965.8260328542,
      8107403958493016e-9
    ]
  },
  "EPSG:3716": {
    proj4: "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227475.2739848646,
      3919318118925639e-9,
      682991.4437860795,
      6303587686966957e-9
    ]
  },
  "EPSG:3717": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212172.22206675174,
      3382455381866777e-9,
      719747.7478332217,
      5441824852507818e-9
    ]
  },
  "EPSG:3718": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213181.34452594037,
      3.4201591228960655e6,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:3719": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214532.47558561602,
      3470063347430235e-9,
      719369.7373790785,
      5432904306382319e-9
    ]
  },
  "EPSG:3720": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207672.60560265684,
      3209479925667875e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:3721": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199250.35388242255,
      2860290264055177e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:3722": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197690.84663826128,
      2835929428023703e-9,
      717738.3550121312,
      5474028648072391e-9
    ]
  },
  "EPSG:3723": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194701.98624121048,
      2654154227656937e-9,
      722387.4042487555,
      5356218117683916e-9
    ]
  },
  "EPSG:3724": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194325.66756335914,
      2.6364238174826605e6,
      731748.2606832965,
      5112867417055887e-9
    ]
  },
  "EPSG:3725": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      205723.7692717061,
      3131872261800517e-9,
      736322.492924318,
      4990662135233918e-9
    ]
  },
  "EPSG:3726": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221647.2089282641,
      3.7229509105618917e6,
      726813.6466742919,
      5261788015335406e-9
    ]
  },
  "EPSG:3727": {
    proj4: "+proj=tmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      121292.20783867055,
      16368.163076148528,
      199213.35558190945,
      83907.83677292572
    ]
  },
  "EPSG:3728": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999187e6,
      166436.6359612313,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "EPSG:3729": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "EPSG:3730": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.0906098829,
      180650.80451728083,
      944961.4340576739,
      1645607992340148e-9
    ]
  },
  "EPSG:3731": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243001354,
      509252.5304234326,
      1.6571629173663934e6,
      1.9745387466693572e6
    ]
  },
  "EPSG:3732": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "EPSG:3733": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3550481894877497e6,
      508102.8230517286,
      2.8960875715645896e6,
      1.8494839069219697e6
    ]
  },
  "EPSG:3734": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999187e6,
      166436.6359612313,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "EPSG:3735": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "EPSG:3736": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.0906098829,
      180650.80451728083,
      944961.4340576739,
      1645607992340148e-9
    ]
  },
  "EPSG:3737": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243001354,
      509252.5304234326,
      1.6571629173663934e6,
      1.9745387466693572e6
    ]
  },
  "EPSG:3738": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "EPSG:3739": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3550481894877497e6,
      508102.8230517286,
      2.8960875715645896e6,
      1.8494839069219697e6
    ]
  },
  "EPSG:3740": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      334397.0868878313,
      3746965678622876e-9,
      719924.366033589,
      5437379053845363e-9
    ]
  },
  "EPSG:3741": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      217380.5420221003,
      3.5732068241059245e6,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:3742": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214532.47558561602,
      3470063347430235e-9,
      719369.7373790785,
      5432904306382319e-9
    ]
  },
  "EPSG:3743": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207672.60560265684,
      3209479925667875e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:3744": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199250.35388242255,
      2860290264055177e-9,
      720100.8763796273,
      5.4329332776495535e6
    ]
  },
  "EPSG:3745": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206110.03339592955,
      314739332970223e-8,
      718464.0482232452,
      5474057564312558e-9
    ]
  },
  "EPSG:3746": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207307.372217301,
      3.1950666329976325e6,
      723128.6171684514,
      5356247178652207e-9
    ]
  },
  "EPSG:3747": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194734.3220702249,
      2.7029362573199198e6,
      731748.2606832965,
      5112867417055887e-9
    ]
  },
  "EPSG:3748": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222389.60969022533,
      3748465221809087e-9,
      736322.492924318,
      4990662135233918e-9
    ]
  },
  "EPSG:3749": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247526.51166603915,
      4538651729351171e-9,
      657491.7475348234,
      5259512880788523e-9
    ]
  },
  "EPSG:3750": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      363588.224686614,
      2157776289271998e-9,
      809130.2828161139,
      2467998025444025e-9
    ]
  },
  "EPSG:3751": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      183890.92296712555,
      2.0891216193225265e6,
      318974.86555910145,
      2.3076325822246308e6
    ]
  },
  "EPSG:3753": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999187e6,
      166436.6359612313,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "EPSG:3754": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "EPSG:3755": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.0906098829,
      180650.80451728083,
      944961.4340576739,
      1645607992340148e-9
    ]
  },
  "EPSG:3756": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243001354,
      509252.5304234326,
      1.6571629173663934e6,
      1.9745387466693572e6
    ]
  },
  "EPSG:3757": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "EPSG:3758": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3550481894877497e6,
      508102.8230517286,
      2.8960875715645896e6,
      1.8494839069219697e6
    ]
  },
  "EPSG:3759": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5280036493835326e6,
      12226.862235159942,
      1.7727747003918204e6,
      212070.18255271934
    ]
  },
  "EPSG:3760": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1528001808734589e-9,
      12225.347710461765,
      1.7727729202627684e6,
      212068.71770917784
    ]
  },
  "EPSG:3761": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      242040.22836453855,
      4.3765623477354655e6,
      679019.5758874652,
      639370540243708e-8
    ]
  },
  "EPSG:3762": {
    proj4: "+proj=lcc +lat_0=-55 +lon_0=-37 +lat_1=-54 +lat_2=-54.75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -69198.87838385493,
      5036.200304822425,
      82760.34181329545,
      118365.20614458184
    ]
  },
  "EPSG:3763": {
    proj4: "+proj=tmerc +lat_0=39.6682583333333 +lon_0=-8.13310833333333 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -127096.8068699822,
      -300781.71070544416,
      160587.191454222,
      278541.6694683329
    ]
  },
  "EPSG:3764": {
    proj4: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      340495.7177898465,
      728610.5071479003,
      477897.63770058344,
      877326.2053848506
    ]
  },
  "EPSG:3765": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247020.52671709875,
      4693501137232486e-9,
      724721.7751192064,
      5159767363267958e-9
    ]
  },
  "EPSG:3766": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=16.5 +lat_1=45.9166666666667 +lat_2=43.0833333333333 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -291881.44653858687,
      5099103039990188e-9,
      224775.6951966773,
      5643576760062468e-9
    ]
  },
  "EPSG:3767": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      333404.67572008225,
      4610628889444937e-9,
      730021.2634432798,
      5158421052602622e-9
    ]
  },
  "EPSG:3768": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      250060.8142008657,
      4.6119348168276325e6,
      378256.650499544,
      5086357383567646e-9
    ]
  },
  "EPSG:3769": {
    proj4: "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      321869.6062490489,
      3565090971779565e-9,
      348629.0986578096,
      3589051101394658e-9
    ]
  },
  "EPSG:3770": {
    proj4: "+proj=tmerc +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000 +y_0=100000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      151924.96805420803,
      -235698.94415488996,
      916501.3776587315,
      521303.60332962644
    ]
  },
  "EPSG:3771": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109702.01049069187,
      5428848995108609e-9,
      56961.86183925288,
      6653622087021167e-9
    ]
  },
  "EPSG:3772": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109694.52116431158,
      542885169142634e-8,
      83747.6107187866,
      6654134744819891e-9
    ]
  },
  "EPSG:3773": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -105734.34062550432,
      5.6267938334074365e6,
      83755.23568111668,
      665413768489266e-8
    ]
  },
  "EPSG:3775": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109766.95700661388,
      5429057036957045e-9,
      56908.80813065395,
      6653846119429227e-9
    ]
  },
  "EPSG:3776": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109766.95700661292,
      5429057036957045e-9,
      83686.8554501166,
      665435618831199e-8
    ]
  },
  "EPSG:3777": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -105803.25671816146,
      5627009396058702e-9,
      83686.8554501166,
      665435618831199e-8
    ]
  },
  "EPSG:3779": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109766.95700661388,
      5429057036957045e-9,
      56908.80813065395,
      6653846119429227e-9
    ]
  },
  "EPSG:3780": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -109766.95700661292,
      5429057036957045e-9,
      83686.8554501166,
      665435618831199e-8
    ]
  },
  "EPSG:3781": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -105803.25671816146,
      5627009396058702e-9,
      83686.8554501166,
      665435618831199e-8
    ]
  },
  "EPSG:3783": {
    proj4: "+proj=tmerc +lat_0=-25.0685526111111 +lon_0=-130.112967111111 +k=1 +x_0=14200 +y_0=15500 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      9457.41949962715,
      7584.62846572282,
      24594.542784801353,
      23089.858296141458
    ]
  },
  "EPSG:3784": {
    proj4: "+proj=utm +zone=9 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      383067.68264420517,
      7.2190096668549515e6,
      398073.5068284768,
      7234635323050497e-9
    ]
  },
  "EPSG:3788": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=166 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3468499468740232e-9,
      4333355527810196e-9,
      3.5696691020396794e6,
      4703391197312544e-9
    ]
  },
  "EPSG:3789": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=169 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3476409818471512e-9,
      4144240603165781e-9,
      3.5409674677587682e6,
      420755666388803e-8
    ]
  },
  "EPSG:3790": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=179 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3456911341500969e-9,
      4.4678785930502005e6,
      3.5278559223839315e6,
      4732651538288933e-9
    ]
  },
  "EPSG:3791": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-178 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3398409795720417e-9,
      6.5064395478759855e6,
      3.5370162333111027e6,
      678734602846904e-8
    ]
  },
  "EPSG:3793": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-176.5 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.4404957177898465e6,
      5054788137551742e-9,
      3.5778976377005833e6,
      5203503835788691e-9
    ]
  },
  "EPSG:3794": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373217.6542446415,
      32395.089991691522,
      622710.7360243343,
      194645.86094378773
    ]
  },
  "EPSG:3795": {
    proj4: "+proj=lcc +lat_0=22.35 +lon_0=-81 +lat_1=23 +lat_2=21.7 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      84145.30837693752,
      178370.868130365,
      918495.9393222793,
      385588.6986994556
    ]
  },
  "EPSG:3796": {
    proj4: "+proj=lcc +lat_0=20.7166666666667 +lon_0=-76.8333333333333 +lat_1=21.3 +lat_2=20.1333333333333 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      305387.6096125501,
      125379.97528661572,
      786307.809102262,
      318237.71449936886
    ]
  },
  "EPSG:3797": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      24720.470321031753,
      159738.0984430174,
      1.4833709701454039e6,
      2.1480607027043835e6
    ]
  },
  "EPSG:3798": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      24751.16153865354,
      159747.26695232387,
      1483410012670911e-9,
      2148077320464921e-9
    ]
  },
  "EPSG:3799": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24751.16153865354,
      159747.26695232387,
      1483410012670911e-9,
      2148077320464921e-9
    ]
  },
  "EPSG:3800": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      76.02810352890343,
      5860466817493848e-9,
      83762.67515800227,
      6654140965585137e-9
    ]
  },
  "EPSG:3801": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      0,
      5860680032327342e-9,
      83686.85545011518,
      665435618831199e-8
    ]
  },
  "EPSG:3802": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      0,
      5860680032327342e-9,
      83686.85545011518,
      665435618831199e-8
    ]
  },
  "EPSG:3812": {
    proj4: "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=649328 +y_0=665262 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      514655.595656322,
      522593.6536251459,
      791004.7334139675,
      746440.85331934
    ]
  },
  "EPSG:3814": {
    proj4: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      316708.0593904875,
      1.0254902162416982e6,
      651501.9999229677,
      157961726758018e-8
    ]
  },
  "EPSG:3815": {
    proj4: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      316708.0593904875,
      1.0254902162416982e6,
      651501.9999229677,
      157961726758018e-8
    ]
  },
  "EPSG:3816": {
    proj4: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      316708.0593904875,
      1.0254902162416982e6,
      651501.9999229677,
      157961726758018e-8
    ]
  },
  "EPSG:3819": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [16.11, 45.74, 22.9, 48.58]
  },
  "EPSG:3821": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [119.25, 21.87, 122.06, 25.34]
  },
  "EPSG:3822": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2507821101956483e-9,
      5549042732262811e-9,
      -3.1490145230569025e6,
      4737853672145291e-9
    ]
  },
  "EPSG:3823": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [114.32, 17.36, 123.61, 26.96]
  },
  "EPSG:3824": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [114.32, 17.36, 123.61, 26.96]
  },
  "EPSG:3825": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      144483.71698908266,
      2.0608009721256404e6,
      351227.4346001176,
      2.7273802976675844e6
    ]
  },
  "EPSG:3826": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      144589.1710246117,
      2.2578543190041967e6,
      355462.5704696885,
      2.9567489358171048e6
    ]
  },
  "EPSG:3827": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      275605.509645693,
      2557601951429386e-9,
      329470.3900336043,
      2635316456070162e-9
    ]
  },
  "EPSG:3828": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      145616.56852252665,
      2.4195148088463894e6,
      356704.34457951103,
      2803869612294213e-9
    ]
  },
  "EPSG:3829": {
    proj4: "+proj=utm +zone=51 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      112352.69193118875,
      2423199147118797e-9,
      405400.8927187247,
      2802966400196656e-9
    ]
  },
  "EPSG:3832": {
    proj4: "+proj=merc +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5711803072602868e-9,
      -8362698548500747e-9,
      15807367692644844e-9,
      10023392492023032e-9
    ]
  },
  "EPSG:3833": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2565686643178933e-9,
      5563596227624678e-9,
      2.6956162760560163e6,
      601577890795482e-8
    ]
  },
  "EPSG:3834": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2565686643178933e-9,
      5563596227624678e-9,
      2.6956162760560163e6,
      601577890795482e-8
    ]
  },
  "EPSG:3835": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3266689692727278e-9,
      5076101933661515e-9,
      3693839402871037e-9,
      6072552320885858e-9
    ]
  },
  "EPSG:3836": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4266522769762803e-9,
      5071656148436723e-9,
      4636050231396473e-9,
      5549348209587863e-9
    ]
  },
  "EPSG:3837": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3565480568566394e-9,
      5580281274399278e-9,
      3604022990100036e-9,
      5715554777568022e-9
    ]
  },
  "EPSG:3838": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      439017629495391e-8,
      5427471404062636e-9,
      4596608840767236e-9,
      606942590845794e-8
    ]
  },
  "EPSG:3839": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      9374328820934512e-9,
      4572835363292646e-9,
      9611353121192772e-9,
      5349631749058411e-9
    ]
  },
  "EPSG:3840": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      10378362247217601e-9,
      480167020283193e-8,
      10479656992695086e-9,
      5033965891512486e-9
    ]
  },
  "EPSG:3841": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6.3832603944045715e6,
      5068371100170383e-9,
      6606535963801213e-9,
      559207575746841e-8
    ]
  },
  "EPSG:3844": {
    proj4: "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      116269.96399989695,
      226713.67470507923,
      975618.5868500522,
      771862.6058807531
    ]
  },
  "EPSG:3845": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4773376910264557e6,
      6351642512538115e-9,
      1.5902373265664114e6,
      6624455106975315e-9
    ]
  },
  "EPSG:3846": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.5562666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3890788178848475e6,
      6129160136771047e-9,
      1590922445500226e-9,
      7144053053257277e-9
    ]
  },
  "EPSG:3847": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15.8062845294444 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3659897264155457e6,
      6204444081492297e-9,
      1.5833452118461821e6,
      7455090923345683e-9
    ]
  },
  "EPSG:3848": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.844 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3795377676882362e6,
      6305429969951629e-9,
      1.5884449450953708e6,
      7607039137211339e-9
    ]
  },
  "EPSG:3849": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20.3063166666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1404738967433724e-9,
      7030410655762993e-9,
      1.5756186321326373e6,
      7665768463631121e-9
    ]
  },
  "EPSG:3850": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22.5563333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1443258507202797e-9,
      7238008803560425e-9,
      1.5659090441102867e6,
      7610802872648535e-9
    ]
  },
  "EPSG:3851": {
    proj4: "+proj=lcc +lat_0=-41 +lon_0=173 +lat_1=-37.5 +lat_2=-44.5 +x_0=3000000 +y_0=7000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2199991088926523e-9,
      5263459162295011e-9,
      4624385494808555e-9,
      8545243464907229e-9
    ]
  },
  "EPSG:3852": {
    proj4: "+proj=lcc +lat_0=-90 +lon_0=157 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      291554.7899136308,
      1003119345096537e-9,
      822031.1444527463,
      1549738996594248e-9
    ]
  },
  "EPSG:3854": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      53334.444074496474,
      7767.347013718449,
      186079.14440079304,
      184512.02098705992
    ]
  },
  "EPSG:3855": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:3857": {
    proj4: "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -20048966104014598e-9,
      20037508342789244e-9,
      20048966104014598e-9
    ]
  },
  "EPSG:3873": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1951335963482055e-8,
      6663010107980846e-9,
      1952761304660496e-8,
      6692058676605167e-9
    ]
  },
  "EPSG:3874": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20472032843430914e-9,
      6645265487353398e-9,
      2052749467484181e-8,
      6707657064247388e-9
    ]
  },
  "EPSG:3875": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      21471965565983657e-9,
      6636352836028312e-9,
      21519704690165494e-9,
      7694317478669044e-9
    ]
  },
  "EPSG:3876": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22471898343915906e-9,
      6627440292990826e-9,
      22519722905346766e-9,
      76920864762662e-7
    ]
  },
  "EPSG:3877": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2347188994505783e-8,
      6626326232733572e-9,
      23520241002281934e-9,
      7628505092807954e-9
    ]
  },
  "EPSG:3878": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=24500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24471982380158763e-9,
      6638580988714271e-9,
      24520150253905907e-9,
      7639659414177734e-9
    ]
  },
  "EPSG:3879": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25472049671430413e-9,
      6647493667084635e-9,
      2552009577491186e-8,
      7646352070098566e-9
    ]
  },
  "EPSG:3880": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26472251876013614e-9,
      667423234995397e-8,
      26519147965113636e-9,
      776236550972573e-8
    ]
  },
  "EPSG:3881": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      27472403853433773e-9,
      6694286997617445e-9,
      27519047335335318e-9,
      7774636967642463e-9
    ]
  },
  "EPSG:3882": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2847245457398863e-8,
      6700972000829727e-9,
      28519010724967904e-9,
      7779099353574873e-9
    ]
  },
  "EPSG:3883": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29472895428579513e-9,
      6758911209249102e-9,
      295192667986574e-7,
      7747863073913258e-9
    ]
  },
  "EPSG:3884": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3047331292095996e-8,
      6813511865091154e-9,
      30520928621661015e-9,
      7543736596232613e-9
    ]
  },
  "EPSG:3885": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31473869785998046e-9,
      688594736250547e-8,
      3152859051505775e-8,
      7130086160671611e-9
    ]
  },
  "EPSG:3886": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:3887": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4349012886582955e-9,
      3.4954465804908876e6,
      3345406921133877e-9,
      3.8147054821943454e6
    ]
  },
  "EPSG:3888": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [38.79, 29.06, 48.75, 37.39]
  },
  "EPSG:3889": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [38.79, 29.06, 48.75, 37.39]
  },
  "EPSG:3890": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      479981.4549363365,
      3445136589965514e-9,
      767834.6133592875,
      4.0713372402205863e6
    ]
  },
  "EPSG:3891": {
    proj4: "+proj=utm +zone=38 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207898.11248667457,
      3218349744759559e-9,
      765590.8661462171,
      4.1423621796268467e6
    ]
  },
  "EPSG:3892": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      209435.1531162312,
      3.2782230379644237e6,
      285175.247400803,
      3.4317750993062584e6
    ]
  },
  "EPSG:3893": {
    proj4: "+proj=tmerc +lat_0=29.0262683333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      48394.31713310699,
      28394.773154147548,
      986758.4440438183,
      929166.9668946941
    ]
  },
  "EPSG:3900": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:3901": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      306436677494318e-8,
      6651917245954645e-9,
      3.6743857956011533e6,
      7785800448452208e-9
    ]
  },
  "EPSG:3902": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      64562.78588868573,
      664910087912667e-8,
      674306.9889334934,
      7782478683824445e-9
    ]
  },
  "EPSG:3903": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      64562.78588868573,
      664910087912667e-8,
      674306.9889334934,
      7782478683824445e-9
    ]
  },
  "EPSG:3906": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [13.38, 40.85, 23.04, 46.88]
  },
  "EPSG:3912": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      373233.0062728352,
      31884.691833678633,
      622695.8455677517,
      194117.3688241765
    ]
  },
  "EPSG:3920": {
    proj4: "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      301263.01055711106,
      2022065397662468e-9,
      368255.41868071456,
      2.0768233637701767e6
    ]
  },
  "EPSG:3942": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3601484364888417e6,
      1.1314274887314436e6,
      2239511025035966e-9,
      1.3397541403672944e6
    ]
  },
  "EPSG:3943": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3054225577783042e6,
      2.1368288677029624e6,
      2.0727318019300369e6,
      2322528009920486e-9
    ]
  },
  "EPSG:3944": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3090966163205083e6,
      3091367567333826e-9,
      2.0711915732185666e6,
      3321719663969387e-9
    ]
  },
  "EPSG:3945": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3424373808461847e6,
      4098725174010325e-9,
      2.0646710636930296e6,
      4.3217397201765645e6
    ]
  },
  "EPSG:3946": {
    proj4: "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1289473772772382e-9,
      5102293909117337e-9,
      2.0162702600515436e6,
      5319418437278013e-9
    ]
  },
  "EPSG:3947": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0990568387382692e6,
      6118668990048366e-9,
      2.0453373635087823e6,
      6321384661705492e-9
    ]
  },
  "EPSG:3948": {
    proj4: "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1024388273905618e6,
      7119349134108447e-9,
      2082420612005638e-9,
      7324172227208503e-9
    ]
  },
  "EPSG:3949": {
    proj4: "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1137111645370102e6,
      8119220756691261e-9,
      2.0746973196147452e6,
      8324127545972525e-9
    ]
  },
  "EPSG:3950": {
    proj4: "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3321989930973798e6,
      9101156988274556e-9,
      2055296770727337e-9,
      9338881938902993e-9
    ]
  },
  "EPSG:3968": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -374247.5203708042,
      68395.7536437515,
      360474.10643138486,
      392175.15701176226
    ]
  },
  "EPSG:3969": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -374247.5203708042,
      68395.7536437515,
      360474.10643138486,
      392175.15701176226
    ]
  },
  "EPSG:3970": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -374247.5203708042,
      68395.7536437515,
      360474.10643138486,
      392175.15701176226
    ]
  },
  "EPSG:3976": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 40696975884941556e-26, -3.3231602706410023e6]
  },
  "EPSG:3978": {
    proj4: "+proj=lcc +lat_0=49 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3894481379315484e-9,
      243795.63696335163,
      371689.59337552893,
      4329768401274024e-9
    ]
  },
  "EPSG:3979": {
    proj4: "+proj=lcc +lat_0=49 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3894481379315484e-9,
      243795.63696335163,
      371689.59337552893,
      4329768401274024e-9
    ]
  },
  "EPSG:3986": {
    proj4: "+proj=tmerc +lat_0=-9 +lon_0=30 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      37559.02811499781,
      6182.9260827124235,
      286505.91670387785,
      943391.8489043999
    ]
  },
  "EPSG:3987": {
    proj4: "+proj=tmerc +lat_0=-9 +lon_0=28 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      37545.54774341814,
      8396.16648179281,
      366371.28270171594,
      943253.6070867614
    ]
  },
  "EPSG:3988": {
    proj4: "+proj=tmerc +lat_0=-9 +lon_0=26 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      36675.169914137165,
      158888.99670953822,
      366371.2827017156,
      943253.6070867614
    ]
  },
  "EPSG:3989": {
    proj4: "+proj=tmerc +lat_0=-9 +lon_0=24 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -46433.179925837234,
      198170.24724688497,
      367098.53880497895,
      796131.6848380021
    ]
  },
  "EPSG:3991": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -34323.68704149138,
      15555.778081389719,
      930602.9260763987,
      268954.8152620333
    ]
  },
  "EPSG:3992": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      967765.7907099647,
      24253.03706958503,
      1.1665956182424265e6,
      323787.3260523693
    ]
  },
  "EPSG:3993": {
    proj4: "+proj=aeqd +guam +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      31706.169796531492,
      17651.502442844674,
      78260.39875150577,
      75187.12167692347
    ]
  },
  "EPSG:3994": {
    proj4: "+proj=merc +lat_ts=-41 +lon_0=100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      462743518127395e-8,
      -6320521100279815e-9,
      7572166660266464e-9,
      -2.1598418670958807e6
    ]
  },
  "EPSG:3995": {
    proj4: "+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-4081911918066543e-25, 3333134027630276e-9, 0, 0]
  },
  "EPSG:3996": {
    proj4: "+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-4124703470669501e-25, 3.3680759820229635e6, 0, 0]
  },
  "EPSG:3997": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=55.3333333333333 +k=1 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      450137.2613983766,
      274952861725011e-8,
      521811.977911564,
      2.8037354648820544e6
    ]
  },
  "EPSG:4000": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4.0073355116058732e6,
      2.0093492265898422e6,
      3664305894345187e-9,
      2126687949233734e-9
    ]
  },
  "EPSG:4017": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [26.63, 45.44, 30.13, 48.47]
  },
  "EPSG:4023": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [26.63, 45.44, 30.13, 48.47]
  },
  "EPSG:4026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28.4 +k=0.99994 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      61521.9850165043,
      35066.50213971827,
      327914.8622103678,
      371812.8309298195
    ]
  },
  "EPSG:4037": {
    proj4: "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      471062.39995446254,
      5031897288777543e-9,
      721734.1348109341,
      5.3728884571692785e6
    ]
  },
  "EPSG:4038": {
    proj4: "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      269261.2224556608,
      5139532670467642e-9,
      279663.0122474504,
      5150272460301618e-9
    ]
  },
  "EPSG:4039": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6073184858466258e-9,
      1.2676482280661045e6,
      5524440588192649e-9,
      3.1651575296297236e6
    ]
  },
  "EPSG:4040": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [11.79, -13.46, 29.81, -3.41]
  },
  "EPSG:4046": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [11.79, -13.46, 29.81, -3.41]
  },
  "EPSG:4048": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      476754.09269481694,
      9332168891867872e-9,
      610946.8893131169,
      9483579470326614e-9
    ]
  },
  "EPSG:4049": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      389273.7917659518,
      9346448656333128e-9,
      612115.7973319093,
      952670684221402e-8
    ]
  },
  "EPSG:4050": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      389584.88353289815,
      9191616368383905e-9,
      611118.2383665242,
      9622917276194192e-9
    ]
  },
  "EPSG:4051": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      389792.08013750054,
      9103136713322012e-9,
      611115.9353862659,
      9620705596098328e-9
    ]
  },
  "EPSG:4056": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      389762.3233116571,
      9115302857851248e-9,
      611074.7267077544,
      9583106892870156e-9
    ]
  },
  "EPSG:4057": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      390807.56824840215,
      8756924790471476e-9,
      612130.177677358,
      953776547903258e-8
    ]
  },
  "EPSG:4058": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      390895.0079985162,
      8731481749301337e-9,
      610960.8976616536,
      9493532315939626e-9
    ]
  },
  "EPSG:4059": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      391099.1411831278,
      8673956911559056e-9,
      610894.879051396,
      9448191371511335e-9
    ]
  },
  "EPSG:4060": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      391693.02831822657,
      8519071843179723e-9,
      610618.3202150625,
      9288940495285219e-9
    ]
  },
  "EPSG:4061": {
    proj4: "+proj=utm +zone=33 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      169345.58069602883,
      9102319397763561e-9,
      834502.41796577,
      9622565088510301e-9
    ]
  },
  "EPSG:4062": {
    proj4: "+proj=utm +zone=34 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      172397.1812030492,
      8755810561579466e-9,
      833333.5963147947,
      960485884317595e-8
    ]
  },
  "EPSG:4063": {
    proj4: "+proj=utm +zone=35 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175152.2391319326,
      85100128119795e-7,
      811721.9340626965,
      9469910017402256e-9
    ]
  },
  "EPSG:4071": {
    proj4: "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      168075.45170806954,
      823521264752241e-8,
      274574.4374408821,
      8299634197786521e-9
    ]
  },
  "EPSG:4073": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4477258406224048e-9,
      1.5250551299677242e6,
      4.0711869992756867e6,
      1.7289549987965042e6
    ]
  },
  "EPSG:4074": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [18.81, 42.23, 23.01, 46.19]
  },
  "EPSG:4075": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [18.81, 42.23, 23.01, 46.19]
  },
  "EPSG:4079": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5382727894003865e-9,
      -2.1671172759355134e6,
      5256421134852832e-9,
      -1.0933371684107604e6
    ]
  },
  "EPSG:4080": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-21.93, 24.6, -11.75, 32.76]
  },
  "EPSG:4081": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-21.93, 24.6, -11.75, 32.76]
  },
  "EPSG:4082": {
    proj4: "+proj=utm +zone=27 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      405849.7056392291,
      2.7209756028399584e6,
      785889.7677948053,
      3454537317247042e-9
    ]
  },
  "EPSG:4083": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197797.85831451224,
      2.7960072719394118e6,
      804488.9247242536,
      3.6293571008458943e6
    ]
  },
  "EPSG:4087": {
    proj4: "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -10018754171394622e-9,
      20037508342789244e-9,
      10018754171394622e-9
    ]
  },
  "EPSG:4093": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      135690.3285612957,
      1.0753030837704418e6,
      259722.65787638188,
      1.3915002972894665e6
    ]
  },
  "EPSG:4094": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      335484.09794662637,
      1060832682947535e-9,
      476701.9092067635,
      1409610019167508e-9
    ]
  },
  "EPSG:4095": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      537821.4266769625,
      1.0429872919776887e6,
      657445.0560324782,
      1.2967970501547642e6
    ]
  },
  "EPSG:4096": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      773723.3447364616,
      1.0906278916988568e6,
      815846.9595696031,
      1139563033293629e-9
    ]
  },
  "EPSG:4097": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      135690.3285612957,
      1.0753030837704418e6,
      259722.65787638188,
      1.3915002972894665e6
    ]
  },
  "EPSG:4098": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      335484.09794662637,
      1060832682947535e-9,
      476701.9092067635,
      1409610019167508e-9
    ]
  },
  "EPSG:4099": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      537821.4266769625,
      1.0429872919776887e6,
      657445.0560324782,
      1.2967970501547642e6
    ]
  },
  "EPSG:4100": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      773723.3447364616,
      1.0906278916988568e6,
      815846.9595696031,
      1139563033293629e-9
    ]
  },
  "EPSG:4120": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [19.57, 34.88, 28.3, 41.75]
  },
  "EPSG:4121": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.57, 34.88, 28.3, 41.75]
  },
  "EPSG:4122": {
    proj4: "+proj=longlat +a=6378135 +rf=298.257 +no_defs +type=crs",
    projected_bounds: [-69.05, 43.41, -59.73, 48.07]
  },
  "EPSG:4123": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [19.24, 59.75, 31.59, 70.09]
  },
  "EPSG:4124": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [10.03, 54.96, 24.17, 69.07]
  },
  "EPSG:4127": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [30.21, -26.87, 40.9, -10.42]
  },
  "EPSG:4128": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [30.21, -17.76, 35.37, -14.01]
  },
  "EPSG:4129": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [31.29, -26.87, 35.65, -19.84]
  },
  "EPSG:4130": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [30.21, -27.71, 43.03, -10.09]
  },
  "EPSG:4131": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [102.14, 7.99, 110, 23.4]
  },
  "EPSG:4132": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [47.13, 26.21, 53.61, 33.22]
  },
  "EPSG:4133": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [21.74, 57.52, 28.2, 59.75]
  },
  "EPSG:4134": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [51.99, 16.59, 59.91, 26.58]
  },
  "EPSG:4135": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-160.3, 18.87, -154.74, 22.29]
  },
  "EPSG:4136": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-171.97, 62.89, -168.59, 63.84]
  },
  "EPSG:4137": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-170.51, 57.06, -170.04, 57.28]
  },
  "EPSG:4138": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-169.88, 56.49, -169.38, 56.67]
  },
  "EPSG:4139": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-67.97, 17.62, -64.25, 18.78]
  },
  "EPSG:4141": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.17, 29.45, 35.69, 33.28]
  },
  "EPSG:4142": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-8.61, 1.02, -2.48, 10.74]
  },
  "EPSG:4143": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-8.61, 1.02, -2.48, 10.74]
  },
  "EPSG:4144": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [60.86, 8.02, 101.17, 37.07]
  },
  "EPSG:4145": {
    proj4: "+proj=longlat +a=6377301.243 +rf=300.8017255 +no_defs +type=crs",
    projected_bounds: [60.86, 21.05, 77.83, 37.07]
  },
  "EPSG:4146": {
    proj4: "+proj=longlat +a=6377299.151 +rf=300.8017255 +no_defs +type=crs",
    projected_bounds: [68.13, 8.02, 97.42, 35.51]
  },
  "EPSG:4147": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [102.14, 8.33, 109.53, 23.4]
  },
  "EPSG:4148": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [13.33, -50.32, 42.85, -22.13]
  },
  "EPSG:4149": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.96, 45.82, 10.49, 47.81]
  },
  "EPSG:4150": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.96, 45.82, 10.49, 47.81]
  },
  "EPSG:4151": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.96, 45.82, 10.49, 47.81]
  },
  "EPSG:4152": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.58, -14.59, -64.51, 71.4]
  },
  "EPSG:4153": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [52.5, 27.39, 52.71, 27.61]
  },
  "EPSG:4154": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.03, 23.34, 63.34, 39.78]
  },
  "EPSG:4155": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-15.13, 7.19, -7.65, 12.68]
  },
  "EPSG:4156": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [12.09, 47.73, 22.56, 51.06]
  },
  "EPSG:4157": {
    proj4: "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs +type=crs",
    projected_bounds: [-60.9, 11.08, -60.44, 11.41]
  },
  "EPSG:4158": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.98, 9.99, -60.85, 10.9]
  },
  "EPSG:4159": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [9.31, 19.5, 26.21, 35.23]
  },
  "EPSG:4160": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-72.14, -43.41, -65.86, -31.91]
  },
  "EPSG:4161": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.59, -50.34, -65.47, -42.49]
  },
  "EPSG:4162": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [124.53, 33.14, 131.01, 38.64]
  },
  "EPSG:4163": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [41.08, 8.95, 57.96, 19]
  },
  "EPSG:4164": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [43.37, 12.54, 53.14, 19]
  },
  "EPSG:4165": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-16.77, 10.87, -13.64, 12.69]
  },
  "EPSG:4166": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [124.53, 33.14, 131.01, 38.64]
  },
  "EPSG:4167": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [160.6, -55.95, -171.2, -25.88]
  },
  "EPSG:4168": {
    proj4: "+proj=longlat +a=6378300 +rf=296 +no_defs +type=crs",
    projected_bounds: [-3.79, 1.4, 2.1, 11.16]
  },
  "EPSG:4169": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-170.88, -14.43, -169.38, -14.11]
  },
  "EPSG:4170": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -26, 16.75]
  },
  "EPSG:4171": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-9.86, 41.15, 10.38, 51.56]
  },
  "EPSG:4173": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-10.56, 51.39, -5.34, 55.43]
  },
  "EPSG:4174": {
    proj4: "+proj=longlat +a=6378300 +rf=296 +no_defs +type=crs",
    projected_bounds: [-13.34, 8.32, -13.13, 8.55]
  },
  "EPSG:4175": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-13.35, 6.88, -10.26, 10]
  },
  "EPSG:4176": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [45, -90, 160, -60]
  },
  "EPSG:4178": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [9.92, 41.24, 28.68, 54.74]
  },
  "EPSG:4179": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [9.92, 39.63, 31.41, 54.89]
  },
  "EPSG:4180": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [20.37, 57.52, 28.2, 60]
  },
  "EPSG:4181": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [5.73, 49.44, 6.53, 50.19]
  },
  "EPSG:4182": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-31.34, 39.3, -31.02, 39.77]
  },
  "EPSG:4183": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-28.9, 38.32, -26.97, 39.14]
  },
  "EPSG:4184": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-25.92, 36.87, -24.62, 37.96]
  },
  "EPSG:4188": {
    proj4: "+proj=longlat +ellps=airy +no_defs +type=crs",
    projected_bounds: [-8.18, 53.96, -5.34, 55.36]
  },
  "EPSG:4189": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-73.38, 0.64, -58.95, 16.75]
  },
  "EPSG:4190": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:4191": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [19.22, 39.64, 21.06, 42.67]
  },
  "EPSG:4192": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [8.45, 2.16, 10.4, 4.99]
  },
  "EPSG:4193": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [8.45, 2.16, 10.4, 4.99]
  },
  "EPSG:4194": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.29, 59.74, -42.52, 79]
  },
  "EPSG:4195": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-29.69, 68.66, -19.89, 74.58]
  },
  "EPSG:4196": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-38.86, 65.52, -36.81, 65.91]
  },
  "EPSG:4197": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [12.9, 8.92, 14.19, 9.87]
  },
  "EPSG:4198": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [14.17, 11.7, 15.09, 12.77]
  },
  "EPSG:4199": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [24.7, 21.97, 36.95, 31.68]
  },
  "EPSG:4200": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [18.92, 39.87, -168.97, 85.2]
  },
  "EPSG:4201": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [21.82, 3.4, 47.99, 22.24]
  },
  "EPSG:4202": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [109.23, -47.2, 163.2, -1.3]
  },
  "EPSG:4203": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [109.23, -38.53, 153.61, -9.37]
  },
  "EPSG:4204": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [34.51, 16.37, 55.67, 32.16]
  },
  "EPSG:4205": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [40.99, -1.71, 51.47, 12.03]
  },
  "EPSG:4206": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [0.16, 11.69, 16, 23.53]
  },
  "EPSG:4207": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-9.56, 36.95, -6.19, 42.16]
  },
  "EPSG:4208": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-53.38, -35.71, -26, 4.26]
  },
  "EPSG:4209": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.4663077 +no_defs +type=crs",
    projected_bounds: [19.99, -26.88, 35.93, -8.19]
  },
  "EPSG:4210": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [28.85, -11.75, 41.91, 4.63]
  },
  "EPSG:4211": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [95.16, -8.91, 117.01, 5.97]
  },
  "EPSG:4212": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-59.71, 13, -59.37, 13.39]
  },
  "EPSG:4213": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [7.81, 12.8, 14.9, 16.7]
  },
  "EPSG:4214": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [73.62, 16.7, 134.77, 53.56]
  },
  "EPSG:4215": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [2.5, 49.5, 6.4, 51.51]
  },
  "EPSG:4216": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-64.89, 32.21, -64.61, 32.43]
  },
  "EPSG:4217": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      836746.9385940062,
      178279688005445e-7,
      2.2517498899754114e6,
      20476717916060127e-9
    ]
  },
  "EPSG:4218": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-79.1, -4.23, -66.87, 13.68]
  },
  "EPSG:4219": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [105.07, -3.3, 108.35, -1.44]
  },
  "EPSG:4220": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [8.2, -18.02, 24.09, -5.82]
  },
  "EPSG:4221": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.59, -54.93, -53.65, -21.78]
  },
  "EPSG:4222": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.4663077 +no_defs +type=crs",
    projected_bounds: [16.45, -34.88, 32.95, -17.78]
  },
  "EPSG:4223": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [7.49, 30.23, 13.67, 38.41]
  },
  "EPSG:4224": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-62.57, -31.91, -47.1, -15.37]
  },
  "EPSG:4225": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-58.16, -33.78, -34.74, -2.68]
  },
  "EPSG:4227": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [35.04, 32.31, 42.38, 37.3]
  },
  "EPSG:4229": {
    proj4: "+proj=longlat +ellps=helmert +no_defs +type=crs",
    projected_bounds: [24.7, 21.89, 37.91, 33.82]
  },
  "EPSG:4230": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-16.1, 25.71, 48.61, 84.73]
  },
  "EPSG:4231": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-10.56, 34.88, 38, 84.73]
  },
  "EPSG:4232": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [51.99, 16.59, 59.91, 26.42]
  },
  "EPSG:4236": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [119.25, 21.87, 122.06, 25.34]
  },
  "EPSG:4237": {
    proj4: "+proj=longlat +ellps=GRS67 +no_defs +type=crs",
    projected_bounds: [16.11, 45.74, 22.9, 48.58]
  },
  "EPSG:4238": {
    proj4: "+proj=longlat +a=6378160 +rf=298.247 +no_defs +type=crs",
    projected_bounds: [95.16, -10.98, 141.01, 5.97]
  },
  "EPSG:4239": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [92.2, 5.63, 105.64, 28.55]
  },
  "EPSG:4240": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [97.34, 5.63, 105.64, 20.46]
  },
  "EPSG:4241": {
    proj4: "+proj=longlat +a=6378249.14480801 +b=6356514.96620413 +no_defs +type=crs",
    projected_bounds: [-78.43, 17.64, -76.17, 18.58]
  },
  "EPSG:4242": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-78.43, 17.64, -76.17, 18.58]
  },
  "EPSG:4243": {
    proj4: "+proj=longlat +a=6377299.36559538 +b=6356098.35900516 +no_defs +type=crs",
    projected_bounds: [60.86, 8.02, 101.17, 37.07]
  },
  "EPSG:4244": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [79.64, 5.86, 81.95, 9.88]
  },
  "EPSG:4245": {
    proj4: "+proj=longlat +ellps=evrst48 +no_defs +type=crs",
    projected_bounds: [99.59, 1.13, 105.82, 7.81]
  },
  "EPSG:4246": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [46.54, 28.53, 48.48, 30.09]
  },
  "EPSG:4247": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.38, 0.64, -59.8, 12.25]
  },
  "EPSG:4248": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-81.41, -43.5, -47.99, 12.68]
  },
  "EPSG:4249": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-72.4, 8.72, -70.78, 11.04]
  },
  "EPSG:4250": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-3.79, 1.4, 2.1, 11.16]
  },
  "EPSG:4251": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-11.52, 4.29, -7.36, 8.52]
  },
  "EPSG:4252": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-0.15, 2.91, 2.42, 11.14]
  },
  "EPSG:4253": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [116.89, 4.99, 126.65, 19.45]
  },
  "EPSG:4254": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-74.83, -55.96, -63.73, -51.65]
  },
  "EPSG:4255": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [60.5, 29.4, 74.92, 38.48]
  },
  "EPSG:4256": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [55.3, -4.86, 55.59, -4.5]
  },
  "EPSG:4257": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [118.71, -6.54, 120.78, -1.88]
  },
  "EPSG:4258": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:4259": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [10.53, -6.04, 12.37, -5.05]
  },
  "EPSG:4261": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-17.16, 20.71, -1.01, 35.97]
  },
  "EPSG:4262": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [36.44, 12.36, 43.31, 18.1]
  },
  "EPSG:4263": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [2.66, 1.92, 14.65, 13.9]
  },
  "EPSG:4265": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "EPSG:4266": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [7.03, -6.37, 14.52, 2.32]
  },
  "EPSG:4267": {
    proj4: "+proj=longlat +datum=NAD27 +no_defs +type=crs",
    projected_bounds: [167.65, 7.15, -47.74744119646247, 83.16920616678068]
  },
  "EPSG:4269": {
    proj4: "+proj=longlat +datum=NAD83 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -47.74, 86.46]
  },
  "EPSG:4270": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [50.55, 22.63, 57.13, 27.05]
  },
  "EPSG:4271": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-60.9, 11.08, -60.44, 11.41]
  },
  "EPSG:4272": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [165.87, -47.65, 179.27, -33.89]
  },
  "EPSG:4273": {
    proj4: "+proj=longlat +a=6377492.018 +rf=299.1528128 +no_defs +type=crs",
    projected_bounds: [4.68, 57.93, 31.22, 71.21]
  },
  "EPSG:4274": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-9.56, 36.95, -6.19, 42.16]
  },
  "EPSG:4275": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-4.87, 41.31, 9.63, 51.14]
  },
  "EPSG:4276": {
    proj4: "+proj=longlat +ellps=NWL9D +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4277": {
    proj4: "+proj=longlat +ellps=airy +no_defs +type=crs",
    projected_bounds: [-9, 49.75, 2.01, 61.01]
  },
  "EPSG:4278": {
    proj4: "+proj=longlat +ellps=airy +no_defs +type=crs",
    projected_bounds: [-8.818, 49.797, 1.92, 60.935]
  },
  "EPSG:4279": {
    proj4: "+proj=longlat +ellps=airy +no_defs +type=crs",
    projected_bounds: [-10.56, 49.81, 1.84, 60.9]
  },
  "EPSG:4281": {
    proj4: "+proj=longlat +a=6378300.789 +b=6356566.435 +no_defs +type=crs",
    projected_bounds: [34.17, 29.18, 39.31, 33.38]
  },
  "EPSG:4282": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [8.84, -6.91, 18.65, 3.72]
  },
  "EPSG:4283": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:4284": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [19.57, 35.14, -168.97, 81.91]
  },
  "EPSG:4285": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [50.55, 24.55, 53.04, 27.05]
  },
  "EPSG:4286": {
    proj4: "+proj=longlat +ellps=helmert +no_defs +type=crs",
    projected_bounds: [50.69, 24.55, 51.68, 26.2]
  },
  "EPSG:4288": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.38, 7.75, -59.8, 12.25]
  },
  "EPSG:4289": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [3.2, 50.75, 7.22, 53.7]
  },
  "EPSG:4292": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.55, -52.51, -57.6, -50.96]
  },
  "EPSG:4293": {
    proj4: "+proj=longlat +ellps=bess_nam +no_defs +type=crs",
    projected_bounds: [8.24, -30.64, 25.27, -16.95]
  },
  "EPSG:4295": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [108.79, 0.06, 109.78, 2.13]
  },
  "EPSG:4297": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [42.53, -26.59, 51.03, -11.69]
  },
  "EPSG:4298": {
    proj4: "+proj=longlat +ellps=evrstSS +no_defs +type=crs",
    projected_bounds: [109.31, 0.85, 119.61, 7.67]
  },
  "EPSG:4299": {
    proj4: "+proj=longlat +a=6377340.189 +rf=299.3249646 +no_defs +type=crs",
    projected_bounds: [-10.56, 51.39, -5.34, 55.43]
  },
  "EPSG:4300": {
    proj4: "+proj=longlat +a=6377340.189 +rf=299.3249646 +no_defs +type=crs",
    projected_bounds: [-10.56, 51.39, -5.34, 55.43]
  },
  "EPSG:4301": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [122.83, 20.37, 154.05, 45.54]
  },
  "EPSG:4302": {
    proj4: "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs +type=crs",
    projected_bounds: [-62.09, 9.83, -60, 11.51]
  },
  "EPSG:4303": {
    proj4: "+proj=longlat +ellps=helmert +no_defs +type=crs",
    projected_bounds: [51.56, 22.63, 56.03, 25.34]
  },
  "EPSG:4304": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-2.95, 31.99, 9.09, 37.14]
  },
  "EPSG:4306": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.96, 45.82, 10.49, 47.81]
  },
  "EPSG:4307": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-8.67, 18.97, 11.99, 38.8]
  },
  "EPSG:4308": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [10.93, 55.28, 24.17, 69.07]
  },
  "EPSG:4309": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-58.49, -35, -53.09, -30.09]
  },
  "EPSG:4310": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-20.22, 10.64, -11.36, 16.7]
  },
  "EPSG:4311": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-58.08, 1.83, -52.66, 9.35]
  },
  "EPSG:4312": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [9.53, 46.4, 17.17, 49.02]
  },
  "EPSG:4313": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [2.5, 49.5, 6.4, 51.51]
  },
  "EPSG:4314": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.87, 47.27, 13.84, 55.09]
  },
  "EPSG:4315": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-15.13, 7.19, -7.65, 12.68]
  },
  "EPSG:4316": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [20.26, 43.62, 29.74, 48.27]
  },
  "EPSG:4318": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [46.54, 28.53, 48.48, 30.09]
  },
  "EPSG:4319": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [47.78, 29.17, 48.16, 29.45]
  },
  "EPSG:4322": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4324": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4326": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4390": {
    proj4: "+proj=cass +lat_0=2.04258333333333 +lon_0=103.562758333333 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -124940.87885302871,
      -92030.41518621943,
      115298.1406307859,
      100385.18088905358
    ]
  },
  "EPSG:4391": {
    proj4: "+proj=cass +lat_0=2.71228333333333 +lon_0=101.941166666667 +x_0=-242.005 +y_0=-948.547 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -27068.314943074027,
      -76385.26804083047,
      85193.68845678528,
      61856.198672905884
    ]
  },
  "EPSG:4392": {
    proj4: "+proj=cass +lat_0=3.71097222222222 +lon_0=102.436177777778 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -123011.25195773371,
      -139374.11220236664,
      136855.9709247778,
      118327.56041680585
    ]
  },
  "EPSG:4393": {
    proj4: "+proj=cass +lat_0=3.68034444444444 +lon_0=101.508244444444 +x_0=-21759.438 +y_0=55960.906 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -104961.4649539034,
      -70102.22247192518,
      29519.820544267972,
      76945.23847809003
    ]
  },
  "EPSG:4394": {
    proj4: "+proj=cass +lat_0=4.94614166666667 +lon_0=102.895208333333 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -57213.994172492276,
      -116762.97543634739,
      91320.26777507718,
      105541.39714779046
    ]
  },
  "EPSG:4395": {
    proj4: "+proj=cass +lat_0=5.421325 +lon_0=100.345869444444 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -25040.738560864513,
      -33314.73392763553,
      23721.19440523253,
      18655.769081818493
    ]
  },
  "EPSG:4396": {
    proj4: "+proj=cass +lat_0=5.96514722222222 +lon_0=100.637594444444 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116147.41203398153,
      -97782.31239973192,
      53327.656803740276,
      83497.57438162273
    ]
  },
  "EPSG:4397": {
    proj4: "+proj=cass +lat_0=4.85938055555556 +lon_0=100.816766666667 +x_0=0 +y_0=133453.669 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -82950.4143577335,
      869.9821830906149,
      131001.88601138532,
      250872.12931618394
    ]
  },
  "EPSG:4398": {
    proj4: "+proj=cass +lat_0=5.89392222222222 +lon_0=102.177291666667 +x_0=0 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      -94013.78499374671,
      -149655.30131684177,
      54512.9047386443,
      43823.379882375404
    ]
  },
  "EPSG:4399": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      836721.115852004,
      1782725083429872e-8,
      2.2517723251201636e6,
      20476017809993092e-9
    ]
  },
  "EPSG:4400": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      905086.8071171464,
      1742629949484489e-8,
      2.2435230000690515e6,
      20618273677582595e-9
    ]
  },
  "EPSG:4401": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904519.7116660778,
      1741171575168584e-8,
      2136914232213296e-9,
      2300631321663154e-8
    ]
  },
  "EPSG:4402": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      915642.8129059315,
      1769611232513405e-8,
      1.9616568258041767e6,
      2660216288611853e-8
    ]
  },
  "EPSG:4403": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      928063.3176004598,
      18009710895987075e-9,
      1.9387808929260965e6,
      27055505960918218e-9
    ]
  },
  "EPSG:4404": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      949517.676652421,
      185421783034744e-7,
      1.9309999421427175e6,
      27209066429476656e-9
    ]
  },
  "EPSG:4405": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      967037.2692618313,
      18968953009679332e-9,
      1.9309999421427175e6,
      27209066429476656e-9
    ]
  },
  "EPSG:4406": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      996087.2646152651,
      1966213963454542e-8,
      1.9417408137136041e6,
      26997007880235367e-9
    ]
  },
  "EPSG:4407": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      987142.1620288459,
      19450517884107344e-9,
      1.9521222612791152e6,
      26799543751369487e-9
    ]
  },
  "EPSG:4408": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      989555.8257064561,
      19498039496984877e-9,
      1.9621855574371237e6,
      2659840190027349e-8
    ]
  },
  "EPSG:4409": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      746287.5650979382,
      12857977963750785e-9,
      2241098235597433e-9,
      20680354998234995e-9
    ]
  },
  "EPSG:4410": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      696082.3375938039,
      11096675008930335e-9,
      2361643939621593e-9,
      17853034835063506e-9
    ]
  },
  "EPSG:4411": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      699675.7699110442,
      11220331429427397e-9,
      2360389572841745e-9,
      1782378980558654e-8
    ]
  },
  "EPSG:4412": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      704060.7773139959,
      11384045445051054e-9,
      2.3603402717508995e6,
      17823771132889323e-9
    ]
  },
  "EPSG:4413": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      681504.6160189655,
      10529109011091033e-9,
      2360288772786056e-9,
      17823756413033392e-9
    ]
  },
  "EPSG:4414": {
    proj4: "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      81570.94872594497,
      164603.54114968982,
      128124.97912921364,
      222142.25314293997
    ]
  },
  "EPSG:4415": {
    proj4: "+proj=lcc +lat_0=-9 +lon_0=26 +lat_1=-6.5 +lat_2=-11.5 +x_0=500000 +y_0=500000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      37766.9240990557,
      3959.5269159682794,
      1.0308816521271889e6,
      939917.8817437876
    ]
  },
  "EPSG:4417": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7384013107048991e-9,
      5108385277433447e-9,
      7608455273888367e-9,
      5496422486153803e-9
    ]
  },
  "EPSG:4418": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      674840.731729043,
      10274481719639812e-9,
      2.4156818309577564e6,
      16372786027580041e-9
    ]
  },
  "EPSG:4419": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      727028.6723065433,
      12213708916194582e-9,
      2384430741667502e-9,
      1726230815374468e-8
    ]
  },
  "EPSG:4420": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      905109.9129359904,
      17427017091518708e-9,
      2.2435007260330543e6,
      2061897180782412e-8
    ]
  },
  "EPSG:4421": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904542.816196729,
      1741243331462093e-8,
      2.1368940569084594e6,
      2300696374945607e-8
    ]
  },
  "EPSG:4422": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      915665.9346917536,
      1769683034126011e-8,
      1.9616423465135766e6,
      2660269684266998e-8
    ]
  },
  "EPSG:4423": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      928086.4389081993,
      18010428912563235e-9,
      1.9387673137237786e6,
      2705602208090441e-8
    ]
  },
  "EPSG:4424": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      949540.7490680261,
      18542895127708077e-9,
      1.9309866758175138e6,
      27209576374869928e-9
    ]
  },
  "EPSG:4425": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      967060.2576756426,
      1896966780213091e-8,
      1.9309866758175138e6,
      27209576374869928e-9
    ]
  },
  "EPSG:4426": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      996110.0292541473,
      1966284911112093e-8,
      1.9417271163674912e6,
      2699752633507665e-8
    ]
  },
  "EPSG:4427": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      987165.0065951211,
      19451229246097833e-9,
      1.9516987376783122e6,
      26800107885777287e-9
    ]
  },
  "EPSG:4428": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      989164.0923540739,
      1949865998078071e-8,
      1.9618262175761226e6,
      26599041153822504e-9
    ]
  },
  "EPSG:4429": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      746308.4647320098,
      12858629528508535e-9,
      2.2407810984881623e6,
      20681020602990758e-9
    ]
  },
  "EPSG:4430": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      696101.7018973345,
      11097272365341252e-9,
      2361372406016161e-9,
      178537203702694e-7
    ]
  },
  "EPSG:4431": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      699412.4644988559,
      1122097205570151e-8,
      2360132216717857e-9,
      1782445354518933e-8
    ]
  },
  "EPSG:4432": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      703845.3003171418,
      11384699499027364e-9,
      236013221671786e-8,
      1782445354518933e-8
    ]
  },
  "EPSG:4433": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      681339.2102147207,
      10529768722795354e-9,
      236013221671786e-8,
      1782445354518933e-8
    ]
  },
  "EPSG:4434": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8387543123182079e-9,
      5.2929255851395065e6,
      841967164684147e-8,
      5441427290579536e-9
    ]
  },
  "EPSG:4437": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      36907.96076240871,
      177072.36487476467,
      403024.65399685316,
      282602.55471139686
    ]
  },
  "EPSG:4438": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      674945.4030189223,
      10275150912257196e-9,
      2415751382202533e-9,
      16373530688679948e-9
    ]
  },
  "EPSG:4439": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      727187.5546254797,
      12214381445735142e-9,
      2384554442463906e-9,
      1726304951364625e-8
    ]
  },
  "EPSG:4440": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:4455": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2178768514487934e6,
      149514.5475616046,
      2833881736326699e-9,
      687044.5668766277
    ]
  },
  "EPSG:4456": {
    proj4: "+proj=lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=609601.219202438 +y_0=30480.0609601219 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9275393123542739e6,
      89176.80367341581,
      2604341154744074e-9,
      399063.7792832535
    ]
  },
  "EPSG:4457": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392498,
      2871291092665175e-9,
      791529.090946073
    ]
  },
  "EPSG:4458": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:4462": {
    proj4: "+proj=lcc +lat_0=-27 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1588299497774265e-9,
      -1.9782789993885823e6,
      2442558210171892e-9,
      1690669262562978e-9
    ]
  },
  "EPSG:4463": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-57.1, 43.41, -55.9, 47.37]
  },
  "EPSG:4465": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2520747469168562e-9,
      -3896482334139582e-9,
      2.4261727804201236e6,
      -3583442221980605e-9
    ]
  },
  "EPSG:4466": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-57.1, 43.41, -55.9, 47.37]
  },
  "EPSG:4467": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      491903.56871610647,
      4806351091585173e-9,
      583048.6460627514,
      5246868778277355e-9
    ]
  },
  "EPSG:4468": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4466932996786122e-9,
      4265711703881345e-9,
      4289552037273227e-9,
      4551962049360644e-9
    ]
  },
  "EPSG:4469": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [43.68, -14.49, 46.7, -11.33]
  },
  "EPSG:4470": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [43.68, -14.49, 46.7, -11.33]
  },
  "EPSG:4471": {
    proj4: "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      357748.3079614133,
      8397670967034938e-9,
      685530.1864412951,
      8746991061045438e-9
    ]
  },
  "EPSG:4472": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.98, -13.05, 45.35, -12.61]
  },
  "EPSG:4473": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      439582890886927e-8,
      4392761112095194e-9,
      4374966587667964e-9,
      4428746076947177e-9
    ]
  },
  "EPSG:4475": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.98, -13.05, 45.35, -12.61]
  },
  "EPSG:4479": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7232892646246485e6,
      5862789574377123e-9,
      -2673890411115534e-9,
      2.6954444183168826e6
    ]
  },
  "EPSG:4480": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [73.62, 16.7, 134.77, 53.56]
  },
  "EPSG:4481": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.3228161328105684e6,
      -5278585393329643e-9,
      501752.82453685993,
      -534783698604474e-8
    ]
  },
  "EPSG:4482": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, 12.1, -84.64, 32.72]
  },
  "EPSG:4483": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, 12.1, -84.64, 32.72]
  },
  "EPSG:4484": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -58603.97078634275,
      1.6659974578202576e6,
      781183.1502370356,
      3624228096601195e-9
    ]
  },
  "EPSG:4485": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177484.6212754076,
      1670480022141903e-9,
      782588.4274016112,
      3.5743159534130353e6
    ]
  },
  "EPSG:4486": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175966.32469811483,
      1.5553168965950068e6,
      784068.1618622246,
      3521079182476001e-9
    ]
  },
  "EPSG:4487": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      173651.79368814215,
      1.3615487184263577e6,
      789960.1323065503,
      3.3015080496930014e6
    ]
  },
  "EPSG:4488": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      173406.5462399603,
      1.3394049705963186e6,
      800318.0748014629,
      2879132533539659e-9
    ]
  },
  "EPSG:4489": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181954.8123379539,
      1971713271934229e-9,
      736683.2282941658,
      2.8523332125410233e6
    ]
  },
  "EPSG:4490": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [73.62, 16.7, 134.77, 53.56]
  },
  "EPSG:4491": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13374665405388365e-9,
      3922064442643563e-9,
      13752994912931172e-9,
      4.5527152183884075e6
    ]
  },
  "EPSG:4492": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1420611683229053e-8,
      3230779307786192e-9,
      14727179036482967e-9,
      5237184744482762e-9
    ]
  },
  "EPSG:4493": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      15203003724888427e-9,
      3.0266589265276226e6,
      15718708805844318e-9,
      5453980627287079e-9
    ]
  },
  "EPSG:4494": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16204050895804493e-9,
      3069909682542227e-9,
      16725045697788803e-9,
      5311696644128502e-9
    ]
  },
  "EPSG:4495": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      17188253522837225e-9,
      2.3404141617095727e6,
      17744727962958597e-9,
      4787117845857609e-9
    ]
  },
  "EPSG:4496": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1818172114902159e-8,
      1.9658541381273957e6,
      18746725008421198e-9,
      4708206873387816e-9
    ]
  },
  "EPSG:4497": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      19179915672892306e-9,
      1.8495164703460322e6,
      1973608718779485e-8,
      5001549832721092e-9
    ]
  },
  "EPSG:4498": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20184047248444457e-9,
      2.1065794114609063e6,
      2070820894307258e-8,
      5714206250334625e-9
    ]
  },
  "EPSG:4499": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2119618207563519e-8,
      272949504529727e-8,
      2169876928407788e-8,
      5941131594578639e-9
    ]
  },
  "EPSG:4500": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22209606468768533e-9,
      3.2906273228382827e6,
      2270236277208327e-8,
      5.8554716831312915e6
    ]
  },
  "EPSG:4501": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2326354173880953e-8,
      4991547876079588e-9,
      23482969274685517e-9,
      5362930841796424e-9
    ]
  },
  "EPSG:4502": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374665.40538836503,
      3922064442643563e-9,
      752994.9129311722,
      4.5527152183884075e6
    ]
  },
  "EPSG:4503": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206116.83229052927,
      3230779307786192e-9,
      727179.0364829676,
      5237184744482762e-9
    ]
  },
  "EPSG:4504": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203003.72488842712,
      3.0266589265276226e6,
      718708.8058443179,
      5453980627287079e-9
    ]
  },
  "EPSG:4505": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204050.8958044923,
      3069909682542227e-9,
      725045.6977888022,
      5311696644128502e-9
    ]
  },
  "EPSG:4506": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188253.52283722558,
      2.3404141617095727e6,
      744727.962958596,
      4787117845857609e-9
    ]
  },
  "EPSG:4507": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181721.14902158943,
      1.9658541381273957e6,
      746725.0084211985,
      4708206873387816e-9
    ]
  },
  "EPSG:4508": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      179915.67289230676,
      1.8495164703460322e6,
      736087.1877948482,
      5001549832721092e-9
    ]
  },
  "EPSG:4509": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      184047.2484444559,
      2.1065794114609063e6,
      708208.9430725785,
      5714206250334625e-9
    ]
  },
  "EPSG:4510": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      196182.07563519222,
      272949504529727e-8,
      698769.2840778776,
      5941131594578639e-9
    ]
  },
  "EPSG:4511": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      209606.46876853413,
      3.2906273228382827e6,
      702362.7720832725,
      5.8554716831312915e6
    ]
  },
  "EPSG:4512": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      263541.7388095296,
      4991547876079588e-9,
      482969.27468551655,
      5362930841796424e-9
    ]
  },
  "EPSG:4513": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25375272496738445e-9,
      3965339750761115e-9,
      2562687022638128e-8,
      4502787598997584e-9
    ]
  },
  "EPSG:4514": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2635678074978872e-8,
      3.4352669542450504e6,
      26624607971150085e-9,
      4633842661139593e-9
    ]
  },
  "EPSG:4515": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2735518972397681e-8,
      3.3155172815639093e6,
      2761722178875389e-8,
      5083856920961833e-9
    ]
  },
  "EPSG:4516": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2835280350523797e-8,
      3128167772519138e-9,
      28613592510664962e-9,
      5233908466969767e-9
    ]
  },
  "EPSG:4517": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2935217607698119e-8,
      3.0771807759909052e6,
      29609359826308854e-9,
      5450729138597192e-9
    ]
  },
  "EPSG:4518": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30350541597011022e-9,
      3.0239922628108254e6,
      3061176508746302e-8,
      5366231030796881e-9
    ]
  },
  "EPSG:4519": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3135205443162153e-8,
      3.0672054304193696e6,
      31618002460865736e-9,
      5000486506449008e-9
    ]
  },
  "EPSG:4520": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32352762296566173e-9,
      3124842436494045e-9,
      32620089903832294e-9,
      4930490218019535e-9
    ]
  },
  "EPSG:4521": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33344482323584504e-9,
      2371430296409771e-9,
      3362278753870722e-8,
      4737149550937824e-9
    ]
  },
  "EPSG:4522": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3434416657066285e-8,
      2.3382056467794734e6,
      3462292569812253e-8,
      4729373218111179e-9
    ]
  },
  "EPSG:4523": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3534564307110784e-8,
      2.4899406545751723e6,
      3562469390403699e-8,
      4676066762848776e-9
    ]
  },
  "EPSG:4524": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      36341298828055635e-9,
      2.0126600186349405e6,
      3662418112024805e-8,
      4704948482789434e-9
    ]
  },
  "EPSG:4525": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3734122658039821e-8,
      2003802987501119e-9,
      3761804370270857e-8,
      4998263826049262e-9
    ]
  },
  "EPSG:4526": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3834457787880975e-8,
      2381397906729184e-9,
      386173406270155e-7,
      5036050383402696e-9
    ]
  },
  "EPSG:4527": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3934575430172073e-8,
      2501017129054436e-9,
      39607809001286104e-9,
      5528578958377667e-9
    ]
  },
  "EPSG:4528": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      40347872246700615e-9,
      2.7037397397075254e6,
      40599933048438706e-9,
      5912395200236397e-9
    ]
  },
  "EPSG:4529": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      41352748569305845e-9,
      3123733994173798e-9,
      4159939465884363e-8,
      5937990422297582e-9
    ]
  },
  "EPSG:4530": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4237226246686157e-8,
      4451705126237508e-9,
      42600236636825554e-9,
      5897928744643673e-9
    ]
  },
  "EPSG:4531": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      43374503764612734e-9,
      4582750413110903e-9,
      4360698270989231e-8,
      5569731708242115e-9
    ]
  },
  "EPSG:4532": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      443765431307735e-7,
      4699379623781421e-9,
      44610019441741355e-9,
      5417367633849718e-9
    ]
  },
  "EPSG:4533": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      45383491843084484e-9,
      5080507851549512e-9,
      4548296927468552e-8,
      5362930841796424e-9
    ]
  },
  "EPSG:4534": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      375272.4967384436,
      3965339750761115e-9,
      626870.2263812805,
      4502787598997584e-9
    ]
  },
  "EPSG:4535": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      356780.74978872173,
      3.4352669542450504e6,
      624607.9711500857,
      4633842661139593e-9
    ]
  },
  "EPSG:4536": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      355189.72397680994,
      3.3155172815639093e6,
      617221.7887538893,
      5083856920961833e-9
    ]
  },
  "EPSG:4537": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352803.5052379721,
      3128167772519138e-9,
      613592.5106649607,
      5233908466969767e-9
    ]
  },
  "EPSG:4538": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352176.0769811899,
      3.0771807759909052e6,
      609359.8263088523,
      5450729138597192e-9
    ]
  },
  "EPSG:4539": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      350541.5970110224,
      3.0239922628108254e6,
      611765.0874630229,
      5366231030796881e-9
    ]
  },
  "EPSG:4540": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352054.43162153027,
      3.0672054304193696e6,
      618002.4608657343,
      5000486506449008e-9
    ]
  },
  "EPSG:4541": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352762.29656617367,
      3124842436494045e-9,
      620089.9038322923,
      4930490218019535e-9
    ]
  },
  "EPSG:4542": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      344482.3235845044,
      2371430296409771e-9,
      622787.5387072222,
      4737149550937824e-9
    ]
  },
  "EPSG:4543": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      344166.57066285104,
      2.3382056467794734e6,
      622925.6981225334,
      4729373218111179e-9
    ]
  },
  "EPSG:4544": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345643.0711078448,
      2.4899406545751723e6,
      624693.9040369882,
      4676066762848776e-9
    ]
  },
  "EPSG:4545": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      341298.8280556375,
      2.0126600186349405e6,
      624181.1202480474,
      4704948482789434e-9
    ]
  },
  "EPSG:4546": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      341226.58039821027,
      2003802987501119e-9,
      618043.7027085705,
      4998263826049262e-9
    ]
  },
  "EPSG:4547": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      344577.87880975025,
      2381397906729184e-9,
      617340.6270154982,
      5036050383402696e-9
    ]
  },
  "EPSG:4548": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345754.3017207273,
      2501017129054436e-9,
      607809.0012861043,
      5528578958377667e-9
    ]
  },
  "EPSG:4549": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      347872.24670061446,
      2.7037397397075254e6,
      599933.0484387091,
      5912395200236397e-9
    ]
  },
  "EPSG:4550": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      352748.56930584356,
      3123733994173798e-9,
      599394.6588436271,
      5937990422297582e-9
    ]
  },
  "EPSG:4551": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      372262.46686157194,
      4451705126237508e-9,
      600236.6368255566,
      5897928744643673e-9
    ]
  },
  "EPSG:4552": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374503.76461273705,
      4582750413110903e-9,
      606982.7098923089,
      5569731708242115e-9
    ]
  },
  "EPSG:4553": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      376543.1307734992,
      4699379623781421e-9,
      610019.4417413541,
      5417367633849718e-9
    ]
  },
  "EPSG:4554": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      383491.84308448405,
      5080507851549512e-9,
      482969.27468551655,
      5362930841796424e-9
    ]
  },
  "EPSG:4555": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [73.62, 18.11, 134.77, 53.56]
  },
  "EPSG:4556": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7454833491934296e6,
      -5545313615603975e-9,
      3.2484362904258994e6,
      -5102953540434239e-9
    ]
  },
  "EPSG:4557": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:4558": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:4559": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      428749.41277109383,
      1.5566737762602603e6,
      817127.1701552824,
      2.0282010142361335e6
    ]
  },
  "EPSG:4568": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      13374663303342246e-9,
      3.9221339709725827e6,
      13752999144337732e-9,
      4.5527956832253635e6
    ]
  },
  "EPSG:4569": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1420611188957779e-8,
      3230836746379479e-9,
      14727182824370552e-9,
      5237276980529349e-9
    ]
  },
  "EPSG:4570": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      152029987260007e-7,
      3026712777844745e-9,
      15718712448935227e-9,
      5454076569551503e-9
    ]
  },
  "EPSG:4571": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16204045915334363e-9,
      3.0699642946240343e6,
      16725049448841698e-9,
      5311790155172144e-9
    ]
  },
  "EPSG:4572": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1718824826361774e-8,
      2340455898374974e-9,
      17744732051780507e-9,
      4787202353799313e-9
    ]
  },
  "EPSG:4573": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1818909340762585e-8,
      2.3847901990150865e6,
      1874672913207768e-8,
      4708290021631301e-9
    ]
  },
  "EPSG:4574": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      191823593668821e-7,
      2005779192783834e-9,
      19736091128420427e-9,
      5001638028420056e-9
    ]
  },
  "EPSG:4575": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2019041134730298e-8,
      2.4524029803003413e6,
      20708212407232597e-9,
      5714306627329533e-9
    ]
  },
  "EPSG:4576": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      21200428115651168e-9,
      2918037170429944e-9,
      2169877258788229e-8,
      5941235826562119e-9
    ]
  },
  "EPSG:4577": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      22247154322271165e-9,
      4532772835711776e-9,
      22702366136876598e-9,
      5855574461258299e-9
    ]
  },
  "EPSG:4578": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2326353779181119e-8,
      4991635899999732e-9,
      23482968990887847e-9,
      5363025230667173e-9
    ]
  },
  "EPSG:4579": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      374663.3033422447,
      3.9221339709725827e6,
      752999.1443377327,
      4.5527956832253635e6
    ]
  },
  "EPSG:4580": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      206111.88957778917,
      3230836746379479e-9,
      727182.8243705523,
      5237276980529349e-9
    ]
  },
  "EPSG:4581": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      202998.72600069945,
      3026712777844745e-9,
      718712.4489352279,
      5454076569551503e-9
    ]
  },
  "EPSG:4582": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      204045.915334362,
      3.0699642946240343e6,
      725049.4488416981,
      5311790155172144e-9
    ]
  },
  "EPSG:4583": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      188248.26361773786,
      2340455898374974e-9,
      744732.0517805086,
      4787202353799313e-9
    ]
  },
  "EPSG:4584": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      189093.4076258511,
      2.3847901990150865e6,
      746729.1320776793,
      4708290021631301e-9
    ]
  },
  "EPSG:4585": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      182359.36688210128,
      2005779192783834e-9,
      736091.1284204279,
      5001638028420056e-9
    ]
  },
  "EPSG:4586": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      190411.34730298247,
      2.4524029803003413e6,
      708212.4072325986,
      5714306627329533e-9
    ]
  },
  "EPSG:4587": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      200428.1156511674,
      2918037170429944e-9,
      698772.5878822905,
      5941235826562119e-9
    ]
  },
  "EPSG:4588": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      247154.32227116346,
      4532772835711776e-9,
      702366.1368765975,
      5855574461258299e-9
    ]
  },
  "EPSG:4589": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      263537.79181118915,
      4991635899999732e-9,
      482968.9908878475,
      5363025230667173e-9
    ]
  },
  "EPSG:4600": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-63.22, 18.11, -62.92, 18.33]
  },
  "EPSG:4601": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-61.95, 16.94, -61.61, 17.22]
  },
  "EPSG:4602": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-61.55, 15.14, -61.2, 15.69]
  },
  "EPSG:4603": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-61.84, 11.94, -61.35, 12.57]
  },
  "EPSG:4604": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-62.29, 16.62, -62.08, 16.87]
  },
  "EPSG:4605": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-62.92, 17.06, -62.5, 17.46]
  },
  "EPSG:4606": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-61.13, 13.66, -60.82, 14.16]
  },
  "EPSG:4607": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-61.52, 12.54, -61.07, 13.44]
  },
  "EPSG:4608": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-95.16, 41.67, -74.35, 56.9]
  },
  "EPSG:4609": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-79.85, 44.99, -57.1, 62.62]
  },
  "EPSG:4610": {
    proj4: "+proj=longlat +ellps=IAU76 +no_defs +type=crs",
    projected_bounds: [73.62, 18.11, 134.77, 53.56]
  },
  "EPSG:4611": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [113.76, 22.13, 114.51, 22.58]
  },
  "EPSG:4612": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.38, 17.09, 157.65, 46.05]
  },
  "EPSG:4613": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [114.55, -4.24, 119.06, 4.29]
  },
  "EPSG:4614": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [50.69, 24.55, 51.68, 26.2]
  },
  "EPSG:4615": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-17.31, 32.35, -16.23, 33.15]
  },
  "EPSG:4616": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-16.11, 29.98, -15.79, 30.21]
  },
  "EPSG:4617": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:4618": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [-91.72, -55.96, -25.28, 12.52]
  },
  "EPSG:4619": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [10.03, 54.96, 24.17, 69.07]
  },
  "EPSG:4620": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-17.19, 10.26, 30.42, 15.7]
  },
  "EPSG:4621": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-63.21, 17.82, -62.73, 18.17]
  },
  "EPSG:4622": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.85, 15.8, -60.97, 16.55]
  },
  "EPSG:4623": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-54.45, 3.43, -51.61, 5.81]
  },
  "EPSG:4624": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.61, 2.11, -49.45, 8.88]
  },
  "EPSG:4625": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.29, 14.35, -60.76, 14.93]
  },
  "EPSG:4626": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.16, -21.42, 55.91, -20.81]
  },
  "EPSG:4627": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.83, -24.72, 58.24, -18.28]
  },
  "EPSG:4628": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -17.93, -149.11, -17.41]
  },
  "EPSG:4629": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.91, -16.96, -150.89, -16.17]
  },
  "EPSG:4630": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-140.31, -9.57, -139.44, -8.72]
  },
  "EPSG:4632": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.98, -13.05, 45.35, -12.61]
  },
  "EPSG:4633": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.98, -21.24, 167.52, -20.62]
  },
  "EPSG:4636": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [139.44, -66.78, 141.5, -66.1]
  },
  "EPSG:4637": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [136, -67.13, 142, -65.61]
  },
  "EPSG:4638": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-56.48, 46.69, -56.07, 47.19]
  },
  "EPSG:4639": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-176.25, -13.41, -176.07, -13.16]
  },
  "EPSG:4641": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [167.75, -21.71, 168.19, -21.32]
  },
  "EPSG:4642": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [167.36, -22.73, 167.61, -22.49]
  },
  "EPSG:4643": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.54, -19.85, 163.75, -19.5]
  },
  "EPSG:4644": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.35, -22.37, 166.54, -22.19]
  },
  "EPSG:4646": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [43.16, -11.99, 43.55, -11.31]
  },
  "EPSG:4647": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3227308288950614e-8,
      523953464667462e-8,
      32689624912264265e-9,
      6151185913701432e-9
    ]
  },
  "EPSG:4652": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      25375270405261002e-9,
      3.9654100324684693e6,
      25626872348776396e-9,
      4502867202883635e-9
    ]
  },
  "EPSG:4653": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2635677834295784e-8,
      3.4353279806508054e6,
      2662461005447431e-8,
      4633924528483284e-9
    ]
  },
  "EPSG:4654": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      27355187289261073e-9,
      3.3155762091446896e6,
      27617223744599424e-9,
      5083946530919504e-9
    ]
  },
  "EPSG:4655": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      28352801028629202e-9,
      3128223410843368e-9,
      28613594404666655e-9,
      5234000648390519e-9
    ]
  },
  "EPSG:4656": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2935217358934277e-8,
      3.0772355179861137e6,
      29609361647951264e-9,
      5450825026701923e-9
    ]
  },
  "EPSG:4657": {
    proj4: "+proj=longlat +a=6377019.27 +rf=300 +no_defs +type=crs",
    projected_bounds: [-24.66, 63.34, -13.38, 66.59]
  },
  "EPSG:4658": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-24.66, 63.34, -13.38, 66.59]
  },
  "EPSG:4659": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:4660": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-9.17, 70.75, -7.87, 71.24]
  },
  "EPSG:4661": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.06, 55.67, 28.24, 58.09]
  },
  "EPSG:4662": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.92, -22.45, 167.09, -20.03]
  },
  "EPSG:4663": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-17.31, 32.35, -16.23, 33.15]
  },
  "EPSG:4664": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-25.92, 36.87, -24.62, 37.96]
  },
  "EPSG:4665": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-28.9, 38.32, -26.97, 39.14]
  },
  "EPSG:4666": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [-9.56, 36.95, -6.19, 42.16]
  },
  "EPSG:4667": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [46.36, 29.06, 48.61, 30.32]
  },
  "EPSG:4668": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-10.56, 34.88, 38, 84.73]
  },
  "EPSG:4669": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.02, 53.89, 26.82, 56.45]
  },
  "EPSG:4670": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "EPSG:4671": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-2.95, 31.99, 9.09, 37.14]
  },
  "EPSG:4672": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-177.25, -44.64, -175.54, -43.3]
  },
  "EPSG:4673": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-177.25, -44.64, -175.54, -43.3]
  },
  "EPSG:4674": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:4675": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [144.58, 13.18, 146.12, 20.61]
  },
  "EPSG:4676": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [100.09, 13.92, 107.64, 22.5]
  },
  "EPSG:4677": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [100.09, 13.92, 107.64, 22.5]
  },
  "EPSG:4678": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [100.09, 13.92, 107.64, 22.5]
  },
  "EPSG:4679": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-17.08, 19.37, -15.88, 21.34]
  },
  "EPSG:4680": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-16.57, 16.81, -15.59, 19.41]
  },
  "EPSG:4682": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [88.01, 18.56, 92.67, 26.64]
  },
  "EPSG:4683": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [116.04, 3, 129.95, 22.18]
  },
  "EPSG:4684": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [72.81, -0.69, 73.69, 7.08]
  },
  "EPSG:4686": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.77, -4.23, -66.87, 15.51]
  },
  "EPSG:4687": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-158.13, -31.24, -131.97, -4.52]
  },
  "EPSG:4688": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.75, -10.6, -138.54, -10.36]
  },
  "EPSG:4689": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.23, -10.08, -138.75, -9.64]
  },
  "EPSG:4690": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-149.7, -17.93, -149.09, -17.44]
  },
  "EPSG:4691": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -17.63, -149.73, -17.41]
  },
  "EPSG:4692": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-152.39, -16.57, -152.14, -16.34]
  },
  "EPSG:4693": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [51.8, 27.3, 53.01, 28.2]
  },
  "EPSG:4694": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:4695": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [21.74, -13.46, 30.78, -4.99]
  },
  "EPSG:4696": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [21.5, -7.31, 26.26, -5.01]
  },
  "EPSG:4697": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [12.17, -7.36, 29.64, -3.29]
  },
  "EPSG:4698": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [68.69, -49.78, 70.62, -48.6]
  },
  "EPSG:4699": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [57.25, -20.57, 57.85, -19.94]
  },
  "EPSG:4700": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-17.08, 14.72, -4.8, 27.3]
  },
  "EPSG:4701": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [12.17, -6.04, 16.28, -4.28]
  },
  "EPSG:4702": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-20.04, 14.72, -4.8, 27.3]
  },
  "EPSG:4703": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [10.53, -6.04, 13.1, -4.38]
  },
  "EPSG:4704": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [10.53, -6.04, 13.1, -4.38]
  },
  "EPSG:4705": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [10.53, -6.04, 12.37, -5.05]
  },
  "EPSG:4706": {
    proj4: "+proj=longlat +ellps=helmert +no_defs +type=crs",
    projected_bounds: [32.34, 27.19, 34.27, 30.01]
  },
  "EPSG:4707": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-166.36, 23.69, -166.03, 23.93]
  },
  "EPSG:4708": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [96.76, -12.27, 96.99, -11.76]
  },
  "EPSG:4709": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [141.2, 24.67, 141.42, 24.89]
  },
  "EPSG:4710": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:4711": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [153.91, 24.22, 154.05, 24.35]
  },
  "EPSG:4712": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-14.46, -8.03, -14.24, -7.83]
  },
  "EPSG:4713": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [41.75, 10.94, 44.15, 12.72]
  },
  "EPSG:4714": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [168.09, -20.31, 169.95, -17.37]
  },
  "EPSG:4715": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [165.73, -77.94, 167.43, -77.17]
  },
  "EPSG:4716": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-174.6, -4.76, -170.66, -2.68]
  },
  "EPSG:4717": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-82.33, 20.86, -72.68, 30.83]
  },
  "EPSG:4718": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [155.62, -10.9, 162.44, -6.55]
  },
  "EPSG:4719": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-109.51, -27.25, -109.16, -27.01]
  },
  "EPSG:4720": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [176.81, -20.81, -178.15, -12.42]
  },
  "EPSG:4721": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [176.81, -19.22, -179.77, -16.1]
  },
  "EPSG:4722": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-38.08, -54.95, -35.74, -53.93]
  },
  "EPSG:4723": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-81.46, 19.21, -81.04, 19.41]
  },
  "EPSG:4724": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [72.3, -7.49, 72.55, -7.18]
  },
  "EPSG:4725": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-169.59, 16.67, -169.47, 16.79]
  },
  "EPSG:4726": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-80.14, 19.63, -79.69, 19.78]
  },
  "EPSG:4727": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-177.45, 28.13, -177.31, 28.28]
  },
  "EPSG:4728": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-18.22, 27.58, -16.08, 28.9]
  },
  "EPSG:4729": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-130.16, -25.14, -130.01, -25]
  },
  "EPSG:4730": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.47, -17.32, 168.71, -14.57]
  },
  "EPSG:4732": {
    proj4: "+proj=longlat +ellps=hough +no_defs +type=crs",
    projected_bounds: [162.27, 8.66, 167.82, 19.38]
  },
  "EPSG:4733": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.55, 19.22, 166.72, 19.38]
  },
  "EPSG:4734": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-12.76, -40.42, -9.8, -37]
  },
  "EPSG:4735": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [162.85, 5.21, 163.1, 5.43]
  },
  "EPSG:4736": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-60.89, -63.08, -60.35, -62.82]
  },
  "EPSG:4737": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.71, 28.6, 134.28, 40.27]
  },
  "EPSG:4738": {
    proj4: "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs +type=crs",
    projected_bounds: [113.76, 22.13, 114.51, 22.58]
  },
  "EPSG:4739": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [113.76, 22.13, 114.51, 22.58]
  },
  "EPSG:4740": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4741": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-7.49, 61.33, -6.33, 62.41]
  },
  "EPSG:4742": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [98.02, 0.85, 119.61, 7.81]
  },
  "EPSG:4743": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [38.79, 29.06, 48.61, 37.39]
  },
  "EPSG:4744": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [38.79, 29.06, 51.06, 37.39]
  },
  "EPSG:4745": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [11.89, 50.2, 15.04, 51.66]
  },
  "EPSG:4746": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [9.92, 50.2, 12.56, 51.64]
  },
  "EPSG:4747": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-75, 56.38, 7.99, 87.03]
  },
  "EPSG:4748": {
    proj4: "+proj=longlat +a=6378306.3696 +b=6356571.996 +no_defs +type=crs",
    projected_bounds: [178.42, -17.07, -179.77, -16.1]
  },
  "EPSG:4749": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [156.25, -26.45, 174.28, -14.83]
  },
  "EPSG:4750": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [166.44, -20.77, 166.71, -20.34]
  },
  "EPSG:4751": {
    proj4: "+proj=longlat +ellps=evrst69 +no_defs +type=crs",
    projected_bounds: [99.59, 1.13, 104.6, 6.72]
  },
  "EPSG:4752": {
    proj4: "+proj=longlat +a=6378306.3696 +b=6356571.996 +no_defs +type=crs",
    projected_bounds: [177.19, -18.32, 178.75, -17.25]
  },
  "EPSG:4753": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-7.49, 61.33, -6.33, 62.41]
  },
  "EPSG:4754": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [9.31, 19.5, 26.21, 35.23]
  },
  "EPSG:4755": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [92.01, -13.95, 141.46, 7.79]
  },
  "EPSG:4756": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [102.14, 8.33, 109.53, 23.4]
  },
  "EPSG:4757": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [103.59, 1.13, 104.07, 1.47]
  },
  "EPSG:4758": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-80.6, 14.08, -74.51, 19.36]
  },
  "EPSG:4759": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:4760": {
    proj4: "+proj=longlat +ellps=NWL9D +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4761": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [13, 41.62, 19.43, 46.54]
  },
  "EPSG:4762": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-68.83, 28.91, -60.7, 35.73]
  },
  "EPSG:4763": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-130.16, -25.14, -130.01, -25]
  },
  "EPSG:4764": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.99, -90, -144.99, -59.99]
  },
  "EPSG:4765": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [13.38, 45.42, 16.61, 46.88]
  },
  "EPSG:4766": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3035053908137362e-8,
      3.0240460692474865e6,
      3061176694988002e-8,
      5366325475610118e-9
    ]
  },
  "EPSG:4767": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3135205194184399e-8,
      3067259996995274e-9,
      31618004430481795e-9,
      5000574685472533e-9
    ]
  },
  "EPSG:4768": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      32352759819233175e-9,
      3.1248980163752725e6,
      32620091908927303e-9,
      4930577194424021e-9
    ]
  },
  "EPSG:4769": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3334447970019824e-8,
      2.3714725841607456e6,
      33622789590639256e-9,
      4737233199767044e-9
    ]
  },
  "EPSG:4770": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      34344163941685416e-9,
      2.3382473461902845e6,
      3462292775243555e-8,
      4729456732924733e-9
    ]
  },
  "EPSG:4771": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3534564046826165e-8,
      2.4899850394998877e6,
      35624695988401435e-9,
      467614935861393e-8
    ]
  },
  "EPSG:4772": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3634129614822373e-8,
      2.0126959447015524e6,
      3662418319577043e-8,
      4705031576575562e-9
    ]
  },
  "EPSG:4773": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3734122389928338e-8,
      2.0038387562858479e6,
      3761804567303289e-8,
      4998351966901854e-9
    ]
  },
  "EPSG:4774": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3834457525711521e-8,
      2.3814403709528917e6,
      3861734258526859e-8,
      5036139173025487e-9
    ]
  },
  "EPSG:4775": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3934575170084169e-8,
      2.5010617098759683e6,
      39607810796467885e-9,
      5528676174789069e-9
    ]
  },
  "EPSG:4776": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      40347869683240615e-9,
      2703787902292285e-9,
      4059993470964578e-8,
      5912498945761737e-9
    ]
  },
  "EPSG:4777": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      41352746091731586e-9,
      3.1237895545736123e6,
      41599396310916424e-9,
      5938094602071491e-9
    ]
  },
  "EPSG:4778": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4237226032946961e-8,
      4451783846830089e-9,
      42600238303184606e-9,
      5898032244668005e-9
    ]
  },
  "EPSG:4779": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      43374501665955454e-9,
      4582831398498325e-9,
      43606984490986675e-9,
      5569829626270264e-9
    ]
  },
  "EPSG:4780": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4437654106730423e-8,
      46994626215635e-7,
      44610021274646565e-9,
      5417462952309373e-9
    ]
  },
  "EPSG:4781": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4538348989911644e-8,
      5080597404062229e-9,
      4548296899088785e-8,
      5363025230667173e-9
    ]
  },
  "EPSG:4782": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      375270.40526100073,
      3.9654100324684693e6,
      626872.3487763973,
      4502867202883635e-9
    ]
  },
  "EPSG:4783": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      356778.342957841,
      3.4353279806508054e6,
      624610.0544743093,
      4633924528483284e-9
    ]
  },
  "EPSG:4784": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      355187.2892610746,
      3.3155762091446896e6,
      617223.7445994257,
      5083946530919504e-9
    ]
  },
  "EPSG:4785": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352801.0286292013,
      3128223410843368e-9,
      613594.4046666537,
      5234000648390519e-9
    ]
  },
  "EPSG:4786": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352173.58934276877,
      3.0772355179861137e6,
      609361.6479512625,
      5450825026701923e-9
    ]
  },
  "EPSG:4787": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      350539.0813736223,
      3.0240460692474865e6,
      611766.9498800174,
      5366325475610118e-9
    ]
  },
  "EPSG:4788": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352051.9418439908,
      3067259996995274e-9,
      618004.4304817966,
      5000574685472533e-9
    ]
  },
  "EPSG:4789": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352759.8192331744,
      3.1248980163752725e6,
      620091.908927303,
      4930577194424021e-9
    ]
  },
  "EPSG:4790": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344479.7001982392,
      2.3714725841607456e6,
      622789.5906392526,
      4737233199767044e-9
    ]
  },
  "EPSG:4791": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344163.941685413,
      2.3382473461902845e6,
      622927.7524355468,
      4729456732924733e-9
    ]
  },
  "EPSG:4792": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      345640.4682616495,
      2.4899850394998877e6,
      624695.9884014355,
      467614935861393e-8
    ]
  },
  "EPSG:4793": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341296.1482237305,
      2.0126959447015524e6,
      624183.1957704299,
      4705031576575562e-9
    ]
  },
  "EPSG:4794": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      341223.8992833793,
      2.0038387562858479e6,
      618045.6730328879,
      4998351966901854e-9
    ]
  },
  "EPSG:4795": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      344575.25711520563,
      2.3814403709528917e6,
      617342.5852685891,
      5036139173025487e-9
    ]
  },
  "EPSG:4796": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      345751.70084168506,
      2.5010617098759683e6,
      607810.7964678872,
      5528676174789069e-9
    ]
  },
  "EPSG:4797": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      347869.68324061215,
      2703787902292285e-9,
      599934.7096457767,
      5912498945761737e-9
    ]
  },
  "EPSG:4798": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      352746.0917315865,
      3.1237895545736123e6,
      599396.3109164219,
      5938094602071491e-9
    ]
  },
  "EPSG:4799": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      372260.32946960814,
      4451783846830089e-9,
      600238.3031846032,
      5898032244668005e-9
    ]
  },
  "EPSG:4800": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      374501.66595545696,
      4582831398498325e-9,
      606984.4909866764,
      5569829626270264e-9
    ]
  },
  "EPSG:4801": {
    proj4: "+proj=longlat +ellps=bessel +pm=bern +no_defs +type=crs",
    projected_bounds: [-1.479583333333333, 45.82, 3.0504166666666683, 47.81]
  },
  "EPSG:4802": {
    proj4: "+proj=longlat +ellps=intl +pm=bogota +no_defs +type=crs",
    projected_bounds: [
      -5.019083333333319,
      -4.230000000000001,
      7.21091666666667,
      12.520000000000001
    ]
  },
  "EPSG:4803": {
    proj4: "+proj=longlat +ellps=intl +pm=lisbon +no_defs +type=crs",
    projected_bounds: [-0.4280938888888889, 36.95, 2.9419061111111104, 42.16]
  },
  "EPSG:4804": {
    proj4: "+proj=longlat +ellps=bessel +pm=jakarta +no_defs +type=crs",
    projected_bounds: [11.902280555555558, -6.54, 13.972280555555557, -1.88]
  },
  "EPSG:4805": {
    proj4: "+proj=longlat +ellps=bessel +pm=ferro +no_defs +type=crs",
    projected_bounds: [27.196666666666665, 40.85, 40.70666666666666, 49.02]
  },
  "EPSG:4806": {
    proj4: "+proj=longlat +ellps=intl +pm=rome +no_defs +type=crs",
    projected_bounds: [-6.522333333333335, 34.76, 6.537666666666664, 47.1]
  },
  "EPSG:4807": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [-7.207229166666667, 41.31, 7.292770833333335, 51.14]
  },
  "EPSG:4809": {
    proj4: "+proj=longlat +ellps=intl +pm=brussels +no_defs +type=crs",
    projected_bounds: [-1.8679750000000004, 49.5, 2.032025, 51.510000000000005]
  },
  "EPSG:4810": {
    proj4: "+proj=longlat +ellps=intl +pm=paris +no_defs +type=crs",
    projected_bounds: [
      40.84277083333333,
      -25.64,
      48.222770833333335,
      -11.890000000000002
    ]
  },
  "EPSG:4811": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [
      -5.287229166666667,
      31.990000000000002,
      6.752770833333334,
      37.14
    ]
  },
  "EPSG:4812": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376541.0673042309,
      46994626215635e-7,
      610021.2746465626,
      5417462952309373e-9
    ]
  },
  "EPSG:4813": {
    proj4: "+proj=longlat +ellps=bessel +pm=jakarta +no_defs +type=crs",
    projected_bounds: [-11.64771944444444, -8.91, 8.962280555555562, 5.97]
  },
  "EPSG:4814": {
    proj4: "+proj=longlat +ellps=bessel +pm=stockholm +no_defs +type=crs",
    projected_bounds: [-7.128277777777778, 55.28, 6.111722222222223, 69.07]
  },
  "EPSG:4815": {
    proj4: "+proj=longlat +ellps=bessel +pm=athens +no_defs +type=crs",
    projected_bounds: [-4.146337500000002, 34.88, 4.583662499999999, 41.75]
  },
  "EPSG:4816": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [
      5.152770833333333,
      30.230000000000004,
      9.252770833333333,
      37.4
    ]
  },
  "EPSG:4817": {
    proj4: "+proj=longlat +a=6377492.018 +rf=299.1528128 +pm=oslo +no_defs +type=crs",
    projected_bounds: [-6.042916666666667, 57.93, 20.497083333333332, 71.21]
  },
  "EPSG:4818": {
    proj4: "+proj=longlat +ellps=bessel +pm=ferro +no_defs +type=crs",
    projected_bounds: [29.756666666666668, 47.73, 40.22666666666667, 51.06]
  },
  "EPSG:4820": {
    proj4: "+proj=longlat +ellps=bessel +pm=jakarta +no_defs +type=crs",
    projected_bounds: [7.742280555555562, -4.24, 12.252280555555561, 4.29]
  },
  "EPSG:4821": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [
      -5.287229166666667,
      31.990000000000002,
      6.752770833333334,
      37.14
    ]
  },
  "EPSG:4822": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      383489.8991164382,
      5080597404062229e-9,
      482968.9908878475,
      5363025230667173e-9
    ]
  },
  "EPSG:4823": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [6.41, -0.04, 6.82, 0.46]
  },
  "EPSG:4824": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [7.27, 1.48, 7.52, 1.76]
  },
  "EPSG:4826": {
    proj4: "+proj=lcc +lat_0=15.8333333333333 +lon_0=-24 +lat_1=15 +lat_2=16.6666666666667 +x_0=161587.83 +y_0=128511.202 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -369014.4053421186,
      -348516.76628650055,
      629239.8757424491,
      654968.7498930206
    ]
  },
  "EPSG:4839": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=10.5 +lat_1=48.6666666666667 +lat_2=53.6666666666667 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -351349.46064530895,
      -403670.62116915523,
      290114.04864218127,
      464032.93723517715
    ]
  },
  "EPSG:4882": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4362741426280586e-9,
      1.0377424319909861e6,
      4.1851934294829722e6,
      1248455761318298e-9
    ]
  },
  "EPSG:4883": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [13.38, 45.42, 16.61, 46.88]
  },
  "EPSG:4884": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -32095540072683433e-26,
      22481888325542284e-26,
      -2619384891598636e-9,
      -1.8347944443737061e6
    ]
  },
  "EPSG:4885": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.99, -90, -144.99, -59.99]
  },
  "EPSG:4886": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0179098474018858e6,
      -5210572596563e-6,
      2.5367387146032765e6,
      -4520415223898938e-9
    ]
  },
  "EPSG:4887": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-68.83, 28.91, -60.7, 35.73]
  },
  "EPSG:4888": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4652749940017604e-9,
      1.0741719624114365e6,
      4144647900859242e-9,
      1.4620006365754432e6
    ]
  },
  "EPSG:4889": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [13, 41.62, 19.43, 46.54]
  },
  "EPSG:4890": {
    proj4: "+proj=geocent +ellps=NWL9D +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4891": {
    proj4: "+proj=longlat +ellps=NWL9D +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4892": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6021823892127135e-9,
      1.3184758432680832e6,
      742797.5508297635,
      -1.5148997474609122e6
    ]
  },
  "EPSG:4893": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:4894": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0106193234964428e6,
      -6104656460365053e-9,
      1.6076812216708362e6,
      -5801042657406304e-9
    ]
  },
  "EPSG:4895": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-80.6, 14.08, -74.51, 19.36]
  },
  "EPSG:4896": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4897": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -217150.6436071961,
      6187418404931405e-9,
      -4943073721432246e-9,
      3.9375358827488623e6
    ]
  },
  "EPSG:4898": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [92.01, -13.95, 141.46, 7.79]
  },
  "EPSG:4899": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      5935313664058406e-9,
      973008.6038794864,
      4679472534242988e-9,
      2.3036005030929036e6
    ]
  },
  "EPSG:4900": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [9.31, 19.5, 26.21, 35.23]
  },
  "EPSG:4901": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +no_defs +type=crs",
    projected_bounds: [-7.207208333333329, 42.33, 5.89279166666667, 51.14]
  },
  "EPSG:4903": {
    proj4: "+proj=longlat +a=6378298.3 +rf=294.73 +pm=-3.687375 +no_defs +type=crs",
    projected_bounds: [-5.682624999999999, 35.95, 7.077375000000001, 43.82]
  },
  "EPSG:4904": {
    proj4: "+proj=longlat +ellps=bessel +pm=lisbon +no_defs +type=crs",
    projected_bounds: [-0.4280938888888889, 36.95, 2.9419061111111104, 42.16]
  },
  "EPSG:4906": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5230356386608627e-9,
      2.3014118904251535e6,
      -6136323918007774e-9,
      614649.9492741128
    ]
  },
  "EPSG:4907": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [156.25, -26.45, 174.28, -14.83]
  },
  "EPSG:4908": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      916138.3308359273,
      -3419074797441026e-9,
      328360.71890551253,
      46089.64922792975
    ]
  },
  "EPSG:4909": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-75, 56.38, 7.99, 87.03]
  },
  "EPSG:4910": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4911": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4912": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4913": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4914": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4915": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4916": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4917": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4918": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4919": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4920": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -889772.5064960773,
      6315064830402468e-9,
      -3122357837781285e-9,
      5494110854755269e-9
    ]
  },
  "EPSG:4921": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [98.02, 0.85, 119.61, 7.81]
  },
  "EPSG:4922": {
    proj4: "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4923": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4924": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5796555147002059e-9,
      -2114357550914429e-9,
      5651825875720928e-9,
      -474597.078925669
    ]
  },
  "EPSG:4925": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-20.04, 14.72, -4.8, 27.3]
  },
  "EPSG:4926": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3028435552147094e-9,
      4.7154626493538935e6,
      -3402427311552728e-9,
      3.4890325084881634e6
    ]
  },
  "EPSG:4927": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.71, 28.6, 134.28, 40.27]
  },
  "EPSG:4928": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      946192.8641922786,
      -3212817178839778e-9,
      3.5965812760434104e6,
      -4709241267617184e-9
    ]
  },
  "EPSG:4929": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:4930": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2770883428835813e-25,
      27708834288358126e-26,
      -3.0042955882132137e6,
      1093474169046882e-9
    ]
  },
  "EPSG:4931": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [45, -90, 160, -60]
  },
  "EPSG:4932": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4428621578105948e-9,
      462341.19760114007,
      421967051453041e-8,
      781307.9580760685
    ]
  },
  "EPSG:4933": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.96, 45.82, 10.49, 47.81]
  },
  "EPSG:4934": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.2185779022258422e6,
      1.1950604408880125e6,
      2.8176193090688963e6,
      1.5107942179172724e6
    ]
  },
  "EPSG:4935": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [20.37, 57.52, 28.2, 60]
  },
  "EPSG:4936": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:4937": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:4938": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -187000.39268983566,
      3138322518735391e-9,
      -6.2664553650716785e6,
      731704.4997082698
    ]
  },
  "EPSG:4939": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:4940": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3970596966222775e-9,
      940804.7959487172,
      4333627785326437e-9,
      4.0200136932170745e6
    ]
  },
  "EPSG:4941": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [13.33, -50.32, 42.85, -22.13]
  },
  "EPSG:4942": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.9206726195754586e6,
      -730901.2972635905,
      361153488099095e-8,
      -337575.15131785173
    ]
  },
  "EPSG:4943": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-10.56, 51.39, -5.34, 55.43]
  },
  "EPSG:4944": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7474945428760527e6,
      -1.6423883063142947e6,
      2.2203944136126074e6,
      -215755.45437617964
    ]
  },
  "EPSG:4945": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:4946": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.2658184677053094e6,
      5150079195754373e-9,
      -4101206603478336e-9,
      1.6862098943059877e6
    ]
  },
  "EPSG:4947": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.38, 17.09, 157.65, 46.05]
  },
  "EPSG:4948": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.4075936661971025e6,
      1.1773215368067243e6,
      2977300808239313e-9,
      1.5990918309906137e6
    ]
  },
  "EPSG:4949": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.06, 55.67, 28.24, 58.09]
  },
  "EPSG:4950": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3561447280730758e-9,
      1.2276953821159252e6,
      3153122056913683e-9,
      1.5941382959866484e6
    ]
  },
  "EPSG:4951": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.02, 53.89, 26.82, 56.45]
  },
  "EPSG:4952": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      488329206082794e-8,
      2.8432849663549205e6,
      4590757858290794e-9,
      4285447103770458e-9
    ]
  },
  "EPSG:4953": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [30.21, -27.71, 43.03, -10.09]
  },
  "EPSG:4954": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:4955": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:4956": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.0311657558557065e6,
      3578107219585675e-9,
      878140.978905032,
      -1.8418880890567058e6
    ]
  },
  "EPSG:4957": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.58, -14.59, -64.51, 71.4]
  },
  "EPSG:4958": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.3762244068596973e6,
      1.1889562989465455e6,
      -5674543635930873e-9,
      -878465.76760162
    ]
  },
  "EPSG:4959": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [160.6, -55.95, -171.2, -25.88]
  },
  "EPSG:4960": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      946192.8641922786,
      -3212817178839778e-9,
      3.5965812760434104e6,
      -4709241267617184e-9
    ]
  },
  "EPSG:4961": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:4962": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8241799884673622e6,
      -6111297519348621e-9,
      3151049512004882e-9,
      -5233875778150579e-9
    ]
  },
  "EPSG:4963": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-73.38, 0.64, -58.95, 16.75]
  },
  "EPSG:4964": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4738603017524563e-9,
      -823610.0968234192,
      3.9083947108615926e6,
      715914.5089933969
    ]
  },
  "EPSG:4965": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-9.86, 41.15, 10.38, 51.56]
  },
  "EPSG:4966": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6913394977677655e6,
      -5196139658938199e-9,
      4.0971255141601246e6,
      -4788649366327153e-9
    ]
  },
  "EPSG:4967": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.61, 2.11, -49.45, 8.88]
  },
  "EPSG:4970": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3582560560838083e-9,
      4557530691605738e-9,
      3.1888397587162945e6,
      5151098244158522e-9
    ]
  },
  "EPSG:4971": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.83, -24.72, 58.24, -18.28]
  },
  "EPSG:4974": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      5.4909305399790285e6,
      -2.6781057658993145e6
    ]
  },
  "EPSG:4975": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -26, 16.75]
  },
  "EPSG:4976": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3614146856969358e-9,
      639222.9821743815,
      2.0847994208415002e6,
      935634.2430989214
    ]
  },
  "EPSG:4977": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [10.03, 54.96, 24.17, 69.07]
  },
  "EPSG:4978": {
    proj4: "+proj=geocent +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4979": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4980": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4749641232215108e-9,
      4.1404573839858114e6,
      3.2004613624915862e6,
      5113861050492625e-9
    ]
  },
  "EPSG:4981": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [41.08, 8.95, 57.96, 19]
  },
  "EPSG:4982": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5217582481883848e-9,
      541945.9431942484,
      4112827887050154e-9,
      1.4153573282994651e6
    ]
  },
  "EPSG:4983": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "EPSG:4984": {
    proj4: "+proj=geocent +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4985": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4986": {
    proj4: "+proj=geocent +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:4987": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:4988": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:4989": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:4990": {
    proj4: "+proj=geocent +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.0848115323676048e6,
      6096259762064445e-9,
      -1.7865507450005105e6,
      5618309560536875e-9
    ]
  },
  "EPSG:4991": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [100.09, 13.92, 107.64, 22.5]
  },
  "EPSG:4992": {
    proj4: "+proj=geocent +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.0848115323676048e6,
      6096259762064445e-9,
      -1.7865507450005105e6,
      5618309560536875e-9
    ]
  },
  "EPSG:4993": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [100.09, 13.92, 107.64, 22.5]
  },
  "EPSG:4994": {
    proj4: "+proj=geocent +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2796181024406598e-9,
      5722876968130804e-9,
      -3.7942738192217625e6,
      4529861647487035e-9
    ]
  },
  "EPSG:4995": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [116.04, 3, 129.95, 22.18]
  },
  "EPSG:4996": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      579819.615178284,
      -633439718192773e-8,
      2414790369684015e-9,
      -5653192776404951e-9
    ]
  },
  "EPSG:4997": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.77, -4.23, -66.87, 15.51]
  },
  "EPSG:4998": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.0654170213178415e6,
      -2.0332043803082115e6,
      -4.2521470459165955e6,
      -4727463235982678e-9
    ]
  },
  "EPSG:4999": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-158.13, -31.24, -131.97, -4.52]
  },
  "EPSG:5011": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4530015809263112e-9,
      -3240781615965941e-9,
      4556380395835678e-9,
      -1.0084566973960816e6
    ]
  },
  "EPSG:5012": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-35.58, 29.24, -12.48, 43.07]
  },
  "EPSG:5013": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-35.58, 29.24, -12.48, 43.07]
  },
  "EPSG:5014": {
    proj4: "+proj=utm +zone=25 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      265262.32681305043,
      3903819147460058e-9,
      744254.9714018108,
      4772957105149555e-9
    ]
  },
  "EPSG:5015": {
    proj4: "+proj=utm +zone=26 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221357.92593481962,
      3.7129672375482456e6,
      744691.7395160486,
      4760740579556911e-9
    ]
  },
  "EPSG:5016": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      208407.58381458843,
      3.2383071185549917e6,
      725816.8615060982,
      4037923327854117e-9
    ]
  },
  "EPSG:5018": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -127209.55581609436,
      -300611.5531991816,
      160495.17241202403,
      278724.27586874366
    ]
  },
  "EPSG:5041": {
    proj4: "+proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.9999999999999995e6,
      540588071737131e-8,
      2e6,
      2e6
    ]
  },
  "EPSG:5042": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2e6,
      2e6,
      2.0000000000000005e6,
      -140588071737131e-8
    ]
  },
  "EPSG:5048": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      43547.78922768647,
      6549298621987618e-9,
      674306.9889334934,
      7782478683824445e-9
    ]
  },
  "EPSG:5069": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.9162744020150914e6,
      598709.1635716655,
      210912352802371e-8,
      3255196845054552e-9
    ]
  },
  "EPSG:5070": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      598769.8229192615,
      2.1091213560858895e6,
      3.2552747939838283e6
    ]
  },
  "EPSG:5071": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      598769.8229192615,
      2.1091213560858895e6,
      3.2552747939838283e6
    ]
  },
  "EPSG:5072": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      598769.8229192615,
      2.1091213560858895e6,
      3.2552747939838283e6
    ]
  },
  "EPSG:5105": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      51945.1247628411,
      1.0359343907770405e6,
      125777.20199394811,
      1.5003582838161755e6
    ]
  },
  "EPSG:5106": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440847,
      992313.1428330106,
      125318.88805964643,
      1.5594295851280722e6
    ]
  },
  "EPSG:5107": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440851,
      992313.1428330106,
      124884.50093879795,
      1.6151612869753996e6
    ]
  },
  "EPSG:5108": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70458.46551056494,
      1003450687001294e-9,
      124579.28383650187,
      1654175795684301e-9
    ]
  },
  "EPSG:5109": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70863.58091185403,
      1.0580271755708447e6,
      124325.68404458911,
      1.6865035342487227e6
    ]
  },
  "EPSG:5110": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      71179.23933332431,
      1.1003546674867903e6,
      123552.29536064467,
      1784609330756158e-9
    ]
  },
  "EPSG:5111": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      71162.59359829966,
      1.0981268426024655e6,
      122915.31902708235,
      1.8648863163462114e6
    ]
  },
  "EPSG:5112": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      71999.1977930403,
      1.2095264762870348e6,
      120775.13266603666,
      2131414625984512e-9
    ]
  },
  "EPSG:5113": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      75543.06426897892,
      1.6697821289203397e6,
      120576.22412355251,
      2.1559525825377745e6
    ]
  },
  "EPSG:5114": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      75560.55468435661,
      1.6720116296961522e6,
      119959.4795473024,
      2231801244248977e-9
    ]
  },
  "EPSG:5115": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      77422.35089921986,
      1907257787718176e-9,
      119686.4725431606,
      2265265814349963e-9
    ]
  },
  "EPSG:5116": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      78082.79970798217,
      1.9897766101278397e6,
      119595.34789405452,
      2.2764209293533033e6
    ]
  },
  "EPSG:5117": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79035.29044252675,
      2.1079926396731324e6,
      119385.53134366407,
      2.3020781799278613e6
    ]
  },
  "EPSG:5118": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79125.52961502795,
      2.1191458920571413e6,
      118845.86197135382,
      2367897665411326e-9
    ]
  },
  "EPSG:5119": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79387.58766576619,
      2151491087596586e-9,
      118781.69740806193,
      2375707045576591e-9
    ]
  },
  "EPSG:5120": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79423.77587644749,
      2.1559525825377745e6,
      118827.53215390828,
      237012891069196e-8
    ]
  },
  "EPSG:5121": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118442.07052856867,
      2.4169862004581476e6
    ]
  },
  "EPSG:5122": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79713.64701614449,
      2.1916453096719477e6,
      118350.14460384905,
      2428143016014467e-9
    ]
  },
  "EPSG:5123": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79650.1824237814,
      2183837409423878e-9,
      118101.6614118561,
      2458267021949799e-9
    ]
  },
  "EPSG:5124": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79613.93079864373,
      2179375781275641e-9,
      118027.95798376336,
      2467192821487358e-9
    ]
  },
  "EPSG:5125": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      79622.99275879291,
      2.1804911863236446e6,
      117981.87517628688,
      2472771485000811e-9
    ]
  },
  "EPSG:5126": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80641.85952282792,
      2305424827540595e-9,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:5127": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80815.46001396282,
      2.3266205272116154e6,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:5128": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118055.60096688129,
      2463845637695616e-9
    ]
  },
  "EPSG:5129": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80013.25022374123,
      2.2284548515287233e6,
      118239.75846874082,
      2.4415313546318635e6
    ]
  },
  "EPSG:5130": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      80413.76791343899,
      2277536447918715e-9,
      126476.88491594889,
      2423761602474995e-9
    ]
  },
  "EPSG:5132": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [122.83, 20.37, 154.05, 45.54]
  },
  "EPSG:5167": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      174322.09614019556,
      432342.3755583337,
      200882.73172253792,
      457827.27043605485
    ]
  },
  "EPSG:5168": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      115100.79331753669,
      11202.599748495151,
      200927.9379378109,
      62956.8163575104
    ]
  },
  "EPSG:5169": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      132558.54965335748,
      55341.66861145332,
      284252.70011999644,
      822416.6233628609
    ]
  },
  "EPSG:5170": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      106703.83829131498,
      -38720.879047489376,
      283100.1561905821,
      922362.3086270792
    ]
  },
  "EPSG:5171": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      108158.31654931026,
      111012.86615429865,
      281518.20042654464,
      1.0567576769847218e6
    ]
  },
  "EPSG:5172": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      111454.41215119358,
      432772.1578017138,
      200815.57567821044,
      1052940035677026e-9
    ]
  },
  "EPSG:5173": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=125.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      156312.03170456007,
      55202.267242373084,
      287521.5969849986,
      504908.7082390331
    ]
  },
  "EPSG:5174": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      107314.03894590301,
      52227.3293880634,
      287175.27118798834,
      537096.4077376351
    ]
  },
  "EPSG:5175": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127.002890277778 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      114831.13321024933,
      11204.945057573961,
      200659.73809706524,
      62956.7941910965
    ]
  },
  "EPSG:5176": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=129.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      107892.85878008862,
      111015.49377291981,
      256333.2486739894,
      571232.6426533179
    ]
  },
  "EPSG:5177": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=131.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      174066.17736258951,
      432343.16605213017,
      200627.59773397405,
      457827.24718254077
    ]
  },
  "EPSG:5178": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      722976.6531622016,
      1.4649769730468192e6,
      1.3054770237803466e6,
      2.0768523715483223e6
    ]
  },
  "EPSG:5179": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      531371.8435902168,
      967246.4734501475,
      1.5766746820754781e6,
      2.2740213084433167e6
    ]
  },
  "EPSG:5180": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      156573.87893945113,
      55153.775307679665,
      287785.8154191448,
      504911.9659364498
    ]
  },
  "EPSG:5181": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      107570.15463309048,
      52177.148942266125,
      287438.4481722591,
      537103.1280820005
    ]
  },
  "EPSG:5182": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      115090.68971100752,
      11145.464417463518,
      200928.04843886118,
      62905.108372866875
    ]
  },
  "EPSG:5183": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108147.36663107073,
      110971.48937409656,
      256591.64600065327,
      571242.076752063
    ]
  },
  "EPSG:5184": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      174319.02226692662,
      432335.1288373182,
      200882.83742775573,
      457822.75058999355
    ]
  },
  "EPSG:5185": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      156573.87893945113,
      155153.77530767967,
      287785.8154191448,
      604911.9659364498
    ]
  },
  "EPSG:5186": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      106692.73537958687,
      61221.99472833192,
      287438.4481722591,
      637103.1280820005
    ]
  },
  "EPSG:5187": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108147.36663107073,
      210971.48937409656,
      256591.64600065327,
      671242.076752063
    ]
  },
  "EPSG:5188": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      174319.02226692662,
      532335.1288373183,
      200882.83742775573,
      557822.7505899935
    ]
  },
  "EPSG:5193": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5195": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5214": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5221": {
    proj4: "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -951555.937880166,
      -1.2763191515697467e6,
      -159523.53474958125,
      -983087.5480082307
    ]
  },
  "EPSG:5223": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      127910.44056990609,
      59327.65742980206,
      780275.284659538,
      756680.741393731
    ]
  },
  "EPSG:5228": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [12.09, 48.58, 18.86, 51.06]
  },
  "EPSG:5229": {
    proj4: "+proj=longlat +ellps=bessel +pm=ferro +no_defs +type=crs",
    projected_bounds: [29.756666666666668, 48.58, 36.52666666666667, 51.06]
  },
  "EPSG:5233": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [79.64, 5.86, 81.95, 9.88]
  },
  "EPSG:5234": {
    proj4: "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=0.9999238418 +x_0=200000 +y_0=200000 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      74690.91934909172,
      74022.2393149679,
      329215.2036102752,
      518648.6571192497
    ]
  },
  "EPSG:5235": {
    proj4: "+proj=tmerc +lat_0=7.00047152777778 +lon_0=80.7717130833333 +k=0.9999238418 +x_0=500000 +y_0=500000 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      374690.70094615076,
      374023.2072742976,
      629214.9873007298,
      818649.6238746879
    ]
  },
  "EPSG:5237": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5243": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=10.5 +lat_1=48.6666666666667 +lat_2=53.6666666666667 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -351349.46064530895,
      -403670.62116915523,
      290114.04864218127,
      464032.93723517715
    ]
  },
  "EPSG:5244": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2421528081181278e-9,
      5883809881904284e-9,
      -2.7163439174079914e6,
      5728345905206778e-9
    ]
  },
  "EPSG:5245": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [112.37, 4.01, 115.37, 6.31]
  },
  "EPSG:5246": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [112.37, 4.01, 115.37, 6.31]
  },
  "EPSG:5247": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.31580995 +gamma=53.1301023611111 +k=0.99984 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      298469.2192786111,
      443468.67232586775,
      630678.5348688912,
      698468.7367861853
    ]
  },
  "EPSG:5250": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4749215622665898e-9,
      2.2774815509628435e6,
      3289074943977524e-9,
      3.2696148624765133e6
    ]
  },
  "EPSG:5251": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [25.62, 34.42, 44.83, 43.45]
  },
  "EPSG:5252": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [25.62, 34.42, 44.83, 43.45]
  },
  "EPSG:5253": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      376360.7533509631,
      404191025815213e-8,
      624063.3335408499,
      4664944162932519e-9
    ]
  },
  "EPSG:5254": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364852.20685853914,
      3993241719757602e-9,
      625323.0822645578,
      4592746421844221e-9
    ]
  },
  "EPSG:5255": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364698.428125733,
      3983254319317595e-9,
      624141.3215114928,
      4660501004404184e-9
    ]
  },
  "EPSG:5256": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364425.8701835414,
      3.9654992859669398e6,
      623985.2848031952,
      4669387350420825e-9
    ]
  },
  "EPSG:5257": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      365885.92271309276,
      4059827973897915e-9,
      625841.607956759,
      4562758834017447e-9
    ]
  },
  "EPSG:5258": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      366513.2373255517,
      4.0997827302967133e6,
      625053.1156130657,
      4608296059394121e-9
    ]
  },
  "EPSG:5259": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      366425.79373884096,
      4.0942333234118326e6,
      485701.33993086783,
      4542808295392414e-9
    ]
  },
  "EPSG:5262": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      125381.2125990338,
      5700520808358288e-9,
      -208820.94524594187,
      5614575859311065e-9
    ]
  },
  "EPSG:5263": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [88.74, 26.7, 92.13, 28.33]
  },
  "EPSG:5264": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [88.74, 26.7, 92.13, 28.33]
  },
  "EPSG:5266": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      124602.61151308281,
      2955009538578154e-9,
      458895.6880410209,
      3.1368562215950857e6
    ]
  },
  "EPSG:5269": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      9376360753350964e-9,
      404191025815213e-8,
      962406333354085e-8,
      4664944162932519e-9
    ]
  },
  "EPSG:5270": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1036485220685854e-8,
      3993241719757602e-9,
      10625323082264557e-9,
      4592746421844221e-9
    ]
  },
  "EPSG:5271": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      11364698428125734e-9,
      3983254319317595e-9,
      11624141321511492e-9,
      4660501004404184e-9
    ]
  },
  "EPSG:5272": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1236442587018354e-8,
      3.9654992859669398e6,
      12623985284803195e-9,
      4669387350420825e-9
    ]
  },
  "EPSG:5273": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13365885922713093e-9,
      4059827973897915e-9,
      1362584160795676e-8,
      4562758834017447e-9
    ]
  },
  "EPSG:5274": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14366513237325551e-9,
      4.0997827302967133e6,
      14625053115613066e-9,
      4608296059394121e-9
    ]
  },
  "EPSG:5275": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1536642579373884e-8,
      4.0942333234118326e6,
      15485701339930868e-9,
      4542808295392414e-9
    ]
  },
  "EPSG:5292": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.7333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222949.91178467305,
      524225.93850674527,
      278173.67266653304,
      608448.7496198616
    ]
  },
  "EPSG:5293": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221142.53949649457,
      455530.75910667935,
      277712.3352728491,
      523119.306919517
    ]
  },
  "EPSG:5294": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.85 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      228106.24530760729,
      454408.8309187824,
      272769.8082932242,
      519784.93279520795
    ]
  },
  "EPSG:5295": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.0333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      191487.86942721886,
      567553.8594422182,
      292820.0195208106,
      635090.4801941393
    ]
  },
  "EPSG:5296": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.15 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      125947.523672709,
      490461.1939205206,
      174983.12107039435,
      556562.1834927592
    ]
  },
  "EPSG:5297": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.1333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214062.49125999858,
      530897.2887991644,
      285053.3353442691,
      608466.935953272
    ]
  },
  "EPSG:5298": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.2333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221860.32095271317,
      479905.5982814762,
      276323.7138752808,
      555251.7742847218
    ]
  },
  "EPSG:5299": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.35 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227207.79957707503,
      507596.0801620395,
      270695.92429221235,
      575187.7005901723
    ]
  },
  "EPSG:5300": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.35 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215193.31147556257,
      463301.8006280507,
      270810.2644945982,
      507592.60395226814
    ]
  },
  "EPSG:5301": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.85 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      228253.4453594662,
      538620.8372666184,
      272650.3561727187,
      584056.6069704955
    ]
  },
  "EPSG:5302": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.5666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      232432.49791845988,
      464374.10895265546,
      305789.9357852461,
      515457.2482704534
    ]
  },
  "EPSG:5303": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.0666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      217519.4676495203,
      465511.6527680438,
      281022.55840754433,
      518694.77801386407
    ]
  },
  "EPSG:5304": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.2666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224463.96665478594,
      457739.6426144005,
      300847.1736434802,
      513219.7463667798
    ]
  },
  "EPSG:5305": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      217286.43952075945,
      503185.91674208967,
      271637.64288144815,
      599569.4515284277
    ]
  },
  "EPSG:5306": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.75 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212286.31495268142,
      488795.12812687224,
      287552.1644368128,
      541983.3977842536
    ]
  },
  "EPSG:5307": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.5 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226206.23916938144,
      502057.61003328394,
      275623.5427207774,
      575197.123545147
    ]
  },
  "EPSG:5308": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.1666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      233429.79297577453,
      466588.77933907975,
      268164.4452964517,
      509804.59758704295
    ]
  },
  "EPSG:5309": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.1166666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      209675.49387899082,
      499883.9908196926,
      291609.27713930304,
      607379.7107169819
    ]
  },
  "EPSG:5310": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=91.5666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227576.29100233404,
      528649.0689485935,
      270000.2701354182,
      598458.4083434045
    ]
  },
  "EPSG:5311": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90.8666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      216516.35688651324,
      462190.2091886983,
      281981.0598530332,
      530886.3818236431
    ]
  },
  "EPSG:5316": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -185807.00688851182,
      667540.4917147234,
      499083.3332854327,
      1304897692962436e-9
    ]
  },
  "EPSG:5317": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5318": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      173763.07717415728,
      802344.0876518181,
      234633.58853369628,
      922783.6745958459
    ]
  },
  "EPSG:5320": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-84 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      69130.65010078647,
      5326891890075152e-9,
      1.5892385591659765e6,
      6987918337245586e-9
    ]
  },
  "EPSG:5321": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-84 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69130.65010078647,
      5326891890075152e-9,
      1.5892385591659765e6,
      6987918337245586e-9
    ]
  },
  "EPSG:5322": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7474945428760527e6,
      -1.6423883063142947e6,
      2.2203944136126074e6,
      -215755.45437617964
    ]
  },
  "EPSG:5323": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:5324": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:5325": {
    proj4: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0383842890319137e6,
      -200072.38326692604,
      2221477132962391e-9,
      868116.0339988441
    ]
  },
  "EPSG:5329": {
    proj4: "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +units=m +no_defs +type=crs",
    projected_bounds: [
      4404925595391868e-9,
      432183.510811514,
      4.9054122844506195e6,
      1.3733435980596216e6
    ]
  },
  "EPSG:5330": {
    proj4: "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +units=m +no_defs +type=crs",
    projected_bounds: [
      2.2531657504142174e6,
      -86202.69350955344,
      4540312238551885e-9,
      1559294896294201e-9
    ]
  },
  "EPSG:5331": {
    proj4: "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +units=m +no_defs +type=crs",
    projected_bounds: [
      486657185403586e-8,
      177491.30226585164,
      5096285256774578e-9,
      692726.1743573038
    ]
  },
  "EPSG:5332": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:5336": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5337": {
    proj4: "+proj=utm +zone=25 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      186279.80486712162,
      7773492366581797e-9,
      833991.7044214617,
      1e7
    ]
  },
  "EPSG:5340": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:5341": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      946192.8641922786,
      -3212817178839778e-9,
      3.5965812760434104e6,
      -4709241267617184e-9
    ]
  },
  "EPSG:5342": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-73.59, -58.41, -52.63, -21.78]
  },
  "EPSG:5343": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3908053332574747e6,
      4237428116255282e-9,
      1.6349765358670535e6,
      5997626733650266e-9
    ]
  },
  "EPSG:5344": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2403773933422364e-9,
      3.9148370406625527e6,
      2.6535619911046457e6,
      733699062150393e-8
    ]
  },
  "EPSG:5345": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3404275368451082e-9,
      3.8914618170146984e6,
      3656178392633631e-9,
      7591761856141459e-9
    ]
  },
  "EPSG:5346": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4403797781714471e-9,
      3913723951940559e-9,
      4654916903295189e-9,
      7568513113464434e-9
    ]
  },
  "EPSG:5347": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      5369301525917733e-9,
      5675715396964289e-9,
      5653373549549709e-9,
      7415655411885936e-9
    ]
  },
  "EPSG:5348": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      6.3693104835499255e6,
      5727909302089395e-9,
      6652642960720958e-9,
      7252789935004573e-9
    ]
  },
  "EPSG:5349": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      7.3525978653740855e6,
      6890424500979647e-9,
      7535191254971214e-9,
      7181584792707844e-9
    ]
  },
  "EPSG:5352": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204313453418718e-8,
      -5511482166817328e-9,
      3.3767462632651725e6,
      -5304515083168803e-9
    ]
  },
  "EPSG:5353": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-69.66, -22.91, -57.52, -9.67]
  },
  "EPSG:5354": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-69.66, -22.91, -57.52, -9.67]
  },
  "EPSG:5355": {
    proj4: "+proj=utm +zone=20 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      192162.94450114993,
      746773700184644e-8,
      829255.7797784247,
      8929624212524584e-9
    ]
  },
  "EPSG:5356": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      432316.38276791654,
      7466291394678213e-9,
      829157.8235930861,
      8918553640569665e-9
    ]
  },
  "EPSG:5357": {
    proj4: "+proj=utm +zone=21 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      186412.61853778252,
      7766873739435537e-9,
      444439.0626132998,
      8201127714287189e-9
    ]
  },
  "EPSG:5358": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      2502038091084371e-9,
      -5546561512064938e-9
    ]
  },
  "EPSG:5359": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:5360": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:5361": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      818590.9266396924,
      8062621368716022e-9
    ]
  },
  "EPSG:5362": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      818130.0801922004,
      7968458629497271e-9
    ]
  },
  "EPSG:5363": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -50058.22780592597,
      -6373480465513657e-9,
      930600.4089156577,
      -6175175007133024e-9
    ]
  },
  "EPSG:5364": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-90.45, 2.15, -81.43, 11.77]
  },
  "EPSG:5365": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-90.45, 2.15, -81.43, 11.77]
  },
  "EPSG:5367": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      221846.0906086433,
      244580.05224873184,
      780173.5616687416,
      1302793770734301e-9
    ]
  },
  "EPSG:5368": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      628873.4070927888,
      -6322830677973918e-9,
      1.3966880543255387e6,
      -6069048127711327e-9
    ]
  },
  "EPSG:5369": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      552143.9443504977,
      -59294269181574e-7,
      2.3199769415444764e6,
      -5941239559494892e-9
    ]
  },
  "EPSG:5370": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.32, 5, -77.04, 12.51]
  },
  "EPSG:5371": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.32, 5, -77.04, 12.51]
  },
  "EPSG:5372": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.68, -21.05, -68.67, -0.03]
  },
  "EPSG:5373": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-84.68, -21.05, -68.67, -0.03]
  },
  "EPSG:5379": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.6383792921263822e6,
      -4303757453953611e-9,
      3549545518385869e-9,
      -4231683327341083e-9
    ]
  },
  "EPSG:5380": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-58.49, -37.77, -50.01, -30.09]
  },
  "EPSG:5381": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-58.49, -37.77, -50.01, -30.09]
  },
  "EPSG:5382": {
    proj4: "+proj=utm +zone=21 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      366781.6940015565,
      5945138009772285e-9,
      789147.7888576603,
      6667444431492319e-9
    ]
  },
  "EPSG:5383": {
    proj4: "+proj=utm +zone=22 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      235757.09118114458,
      5815464116658477e-9,
      593614.2125444749,
      6470221054143693e-9
    ]
  },
  "EPSG:5387": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188211.080249184,
      7669384977687117e-9,
      833978.5113605198,
      999667951731828e-8
    ]
  },
  "EPSG:5389": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      186956.5917946475,
      773696317772405e-8,
      536695.5025226505,
      9763460651053915e-9
    ]
  },
  "EPSG:5391": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -156782.3721748295,
      -6280491573533483e-9,
      253318.36046652842,
      -6172737553212978e-9
    ]
  },
  "EPSG:5392": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-91.43, 9.97, -87.65, 14.44]
  },
  "EPSG:5393": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-91.43, 9.97, -87.65, 14.44]
  },
  "EPSG:5396": {
    proj4: "+proj=utm +zone=26 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194443.01165892632,
      7.3580354580501225e6,
      690896.2367896695,
      1047107959138161e-8
    ]
  },
  "EPSG:5451": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-92.29, 7.98, -82.53, 17.83]
  },
  "EPSG:5456": {
    proj4: "+proj=lcc +lat_1=10.4666666666667 +lat_0=10.4666666666667 +lon_0=-84.3333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      320287.6178510644,
      168690.34170717065,
      696944.1008548496,
      355706.27163886745
    ]
  },
  "EPSG:5457": {
    proj4: "+proj=lcc +lat_1=9 +lat_0=9 +lon_0=-83.6666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      271390.25431981764,
      215829.89058378874,
      624658.8143282278,
      432142.8055285551
    ]
  },
  "EPSG:5459": {
    proj4: "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.3333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      288307.73314739537,
      193056.5529874447,
      729577.9182155668,
      433311.44771096297
    ]
  },
  "EPSG:5460": {
    proj4: "+proj=lcc +lat_1=13.7833333333333 +lat_0=13.7833333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      379624.6737961642,
      220491.96523288562,
      641256.8474496471,
      368842.7589825936
    ]
  },
  "EPSG:5461": {
    proj4: "+proj=lcc +lat_1=13.8666666666667 +lat_0=13.8666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      256783.2435358093,
      243033.82558545674,
      760263.0854810738,
      489913.3384531034
    ]
  },
  "EPSG:5462": {
    proj4: "+proj=lcc +lat_1=11.7333333333333 +lat_0=11.7333333333333 +lon_0=-85.5 +k_0=0.99992228 +x_0=500000 +y_0=288876.327 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      266965.17738722736,
      175463.20491087734,
      725849.8154621691,
      407700.0615934872
    ]
  },
  "EPSG:5463": {
    proj4: "+proj=utm +zone=17 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      591248.9347505379,
      0,
      833610.7978733575,
      298846.0791533556
    ]
  },
  "EPSG:5464": {
    proj4: "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs +type=crs",
    projected_bounds: [-89.22, 15.88, -87.72, 18.49]
  },
  "EPSG:5467": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-83.04, 7.15, -77.19, 9.68]
  },
  "EPSG:5469": {
    proj4: "+proj=lcc +lat_1=8.41666666666667 +lat_0=8.41666666666667 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      164154.9039600988,
      156094.29112440624,
      808427.7370445093,
      435687.8812192306
    ]
  },
  "EPSG:5472": {
    proj4: "+proj=poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.721715486 +ellps=clrk66 +to_meter=0.9143917962 +no_defs +type=crs",
    projected_bounds: [
      753563.6725215253,
      960483.1282506187,
      1.4572705922654043e6,
      1.2684852274876032e6
    ]
  },
  "EPSG:5479": {
    proj4: "+proj=lcc +lat_0=-78 +lon_0=163 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=7000000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6825923050643827e-9,
      4650065224002194e-9,
      7268934935951674e-9,
      5200244076984031e-9
    ]
  },
  "EPSG:5480": {
    proj4: "+proj=lcc +lat_0=-74.5 +lon_0=165 +lat_1=-73.6666666666667 +lat_2=-75.3333333333333 +x_0=5000000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4784471634826645e-9,
      2.8180453349486007e6,
      5260446569684585e-9,
      3149861195493848e-9
    ]
  },
  "EPSG:5481": {
    proj4: "+proj=lcc +lat_0=-71.5 +lon_0=166 +lat_1=-70.6666666666667 +lat_2=-72.3333333333333 +x_0=3000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2804393681405756e-9,
      822893.8404181403,
      3.2343280506279184e6,
      1.2115120324313266e6
    ]
  },
  "EPSG:5482": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=180 +k=0.994 +x_0=5000000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5e6,
      1e6,
      5780900350992607e-9,
      2352559083567567e-9
    ]
  },
  "EPSG:5487": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7454833491934296e6,
      -5545313615603975e-9,
      3.2484362904258994e6,
      -5102953540434239e-9
    ]
  },
  "EPSG:5488": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:5489": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:5490": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      428749.41277109383,
      1.5566737762602603e6,
      817127.1701552824,
      2.0282010142361335e6
    ]
  },
  "EPSG:5498": {
    proj4: "+proj=longlat +datum=NAD83 +vunits=m +no_defs +type=crs",
    projected_bounds: [-168.26, 24.41, -66.91, 71.4]
  },
  "EPSG:5499": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-124.79, 24.41, -66.91, 49.38]
  },
  "EPSG:5500": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-124.79, 24.41, -66.91, 49.38]
  },
  "EPSG:5513": {
    proj4: "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2763191515697485e6,
      951555.9378801635,
      983087.548008231,
      159523.53474957874
    ]
  },
  "EPSG:5514": {
    proj4: "+proj=krovak +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -951555.9378801635,
      -1.2763191515697485e6,
      -159523.53474957874,
      -983087.548008231
    ]
  },
  "EPSG:5518": {
    proj4: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      290492.95913988806,
      578608.24337184,
      427901.2231699323,
      727328.6078028628
    ]
  },
  "EPSG:5519": {
    proj4: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      290492.95913988806,
      578608.24337184,
      427901.2231699323,
      727328.6078028628
    ]
  },
  "EPSG:5520": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1521625238487588e-9,
      6.1233667172220275e6,
      1593766887447702e-9,
      6200029128679838e-9
    ]
  },
  "EPSG:5523": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=1500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0051582604903807e6,
      4793749634939545e-9,
      1835932899719798e-9,
      5756789754670369e-9
    ]
  },
  "EPSG:5524": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-58.16, -27.5, -38.82, -14.99]
  },
  "EPSG:5527": {
    proj4: "+proj=longlat +ellps=aust_SA +no_defs +type=crs",
    projected_bounds: [-74.01, -35.71, -25.28, 7.04]
  },
  "EPSG:5530": {
    proj4: "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      3201750187381406e-9,
      5862700919144396e-9,
      8171167615166185e-9,
      10875926387243846e-9
    ]
  },
  "EPSG:5531": {
    proj4: "+proj=utm +zone=21 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      216298.87616601895,
      6465599645606804e-9,
      834061.4787920921,
      10499193026788488e-9
    ]
  },
  "EPSG:5533": {
    proj4: "+proj=utm +zone=23 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      221292.72233677725,
      6289238468774924e-9,
      832648.4187113973,
      10567815516865943e-9
    ]
  },
  "EPSG:5534": {
    proj4: "+proj=utm +zone=24 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      200577.6810514102,
      7082063449815907e-9,
      833952.0414790213,
      10081905554595917e-9
    ]
  },
  "EPSG:5535": {
    proj4: "+proj=utm +zone=25 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      194301.12021194678,
      7364675214398226e-9,
      834202.7501274353,
      10463772616500929e-9
    ]
  },
  "EPSG:5536": {
    proj4: "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      385414.3914497104,
      6957604988156326e-9,
      817736.9823694777,
      8008325673951928e-9
    ]
  },
  "EPSG:5537": {
    proj4: "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      203591.37296726851,
      6.9545553533114055e6,
      823755.4433870856,
      8340559375979635e-9
    ]
  },
  "EPSG:5538": {
    proj4: "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197884.3669798266,
      7199521564006133e-9,
      822663.9686874531,
      8339466610008035e-9
    ]
  },
  "EPSG:5539": {
    proj4: "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      192353.67058017355,
      7457731223299272e-9,
      519353.05102670647,
      8342752587735518e-9
    ]
  },
  "EPSG:5544": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -467012217262436e-8,
      4.0311413237917013e6,
      -6087090202754794e-9,
      1.8831050420262716e6
    ]
  },
  "EPSG:5545": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [139.2, -14.75, 162.81, 2.58]
  },
  "EPSG:5546": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [139.2, -14.75, 162.81, 2.58]
  },
  "EPSG:5550": {
    proj4: "+proj=utm +zone=54 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      303431.05520831514,
      8766837675082365e-9,
      833708.4729209987,
      10255678174011018e-9
    ]
  },
  "EPSG:5551": {
    proj4: "+proj=utm +zone=55 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175728.24327543058,
      8463507150439527e-9,
      834754.821346672,
      10285565544768637e-9
    ]
  },
  "EPSG:5552": {
    proj4: "+proj=utm +zone=56 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      176976.58181025373,
      8367170279811371e-9,
      833780.1210376038,
      1021915249148026e-8
    ]
  },
  "EPSG:5554": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      701499.2092590338,
      5650410574883465e-9,
      706708.6039938158,
      5746386834403614e-9
    ]
  },
  "EPSG:5555": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      273082.8895061389,
      523953464667462e-8,
      691445.6462745746,
      6108918294434424e-9
    ]
  },
  "EPSG:5556": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      273896.9152040301,
      5260647642575641e-9,
      502575.26032301516,
      6065860237588203e-9
    ]
  },
  "EPSG:5558": {
    proj4: "+proj=geocent +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4314510267230183e-9,
      1756328426755994e-9,
      2.9808710465034666e6,
      2517248272350985e-9
    ]
  },
  "EPSG:5559": {
    proj4: "+proj=lcc +lat_1=16.8166666666667 +lat_0=16.8166666666667 +lon_0=-90.3333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      336461.82922351925,
      185875.66177416808,
      711321.2347004244,
      405412.5795361546
    ]
  },
  "EPSG:5560": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [22.15, 43.18, 40.18, 52.38]
  },
  "EPSG:5561": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [22.15, 43.18, 40.18, 52.38]
  },
  "EPSG:5562": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4585902895029604e-9,
      5313601832200398e-9,
      4707572937330755e-9,
      5729878366730131e-9
    ]
  },
  "EPSG:5563": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5263867611570254e-9,
      5000526675136958e-9,
      57061984466965e-7,
      5763247293558072e-9
    ]
  },
  "EPSG:5564": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6256081059590332e-9,
      4787173144948495e-9,
      6704264602677078e-9,
      5809965879692466e-9
    ]
  },
  "EPSG:5565": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      725707953945962e-8,
      4814950591545987e-9,
      7583826643610965e-9,
      5590553487848774e-9
    ]
  },
  "EPSG:5566": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      585902.8950296043,
      5313601832200398e-9,
      707572.9373307554,
      5729878366730131e-9
    ]
  },
  "EPSG:5567": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      263867.6115702536,
      5000526675136958e-9,
      706198.4466965001,
      5763247293558072e-9
    ]
  },
  "EPSG:5568": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      256081.05959033204,
      4787173144948495e-9,
      704264.6026770778,
      5809965879692466e-9
    ]
  },
  "EPSG:5569": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      257079.53945961938,
      4814950591545987e-9,
      583826.6436109653,
      5590553487848774e-9
    ]
  },
  "EPSG:5588": {
    proj4: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=304800 +y_0=304800 +datum=NAD27 +units=ft +no_defs +type=crs",
    projected_bounds: [
      335113.01957664423,
      303136.93874429836,
      1684444676303038e-9,
      1.5849182260491187e6
    ]
  },
  "EPSG:5589": {
    proj4: "+proj=tmerc +lat_0=17.0612419444444 +lon_0=-88.6318575 +k=1 +x_0=66220.0283308276 +y_0=135779.50998853 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs +type=crs",
    projected_bounds: [
      10592.006110544013,
      16912.10758752289,
      533226.9750323215,
      965054.3708176949
    ]
  },
  "EPSG:5591": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6631090815317095e6,
      689503.3587513545,
      3.6014836884211316e6,
      766175.9908990202
    ]
  },
  "EPSG:5592": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [10.66, 54.33, 12.01, 54.83]
  },
  "EPSG:5593": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [10.66, 54.33, 12.01, 54.83]
  },
  "EPSG:5596": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.3333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      956195.9215920349,
      6022856797674092e-9,
      1.0434852466783529e6,
      6078515488586844e-9
    ]
  },
  "EPSG:5597": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5598": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.3333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      989397.3985088811,
      6032678061511265e-9,
      1.0113730060526435e6,
      6070527517331567e-9
    ]
  },
  "EPSG:5600": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5601": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5602": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5603": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5604": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5605": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5606": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5607": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5608": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5609": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5610": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5611": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5612": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5613": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5614": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:5615": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5616": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5617": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5618": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5619": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5620": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5621": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5623": {
    proj4: "+proj=tmerc +lat_0=41.5 +lon_0=-83.6666666666667 +k=0.999942857 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      171313.83197777893,
      71519.0981679901,
      890195.2994820217,
      1658605680536321e-9
    ]
  },
  "EPSG:5624": {
    proj4: "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -7532.2673318681545,
      96568.67037823446,
      791644.3805851422,
      1.6824161954776116e6
    ]
  },
  "EPSG:5625": {
    proj4: "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      68732.43328954327,
      1312863200006872e-9,
      1.7916805333009663e6,
      2531082595664183e-9
    ]
  },
  "EPSG:5627": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      251598.38884613322,
      4.5597125264680525e6,
      852724.1777050167,
      4852414836750101e-9
    ]
  },
  "EPSG:5628": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [10.93, 55.28, 24.17, 69.07]
  },
  "EPSG:5629": {
    proj4: "+proj=utm +zone=38 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -451529.07307193265,
      787690969126648e-8,
      50886.68279028515,
      8845240268602928e-9
    ]
  },
  "EPSG:5631": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2565686643178933e-9,
      5563596227624678e-9,
      2.6956162760560163e6,
      601577890795482e-8
    ]
  },
  "EPSG:5632": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -276612.52069490496,
      1.6706971569277514e6,
      2.2438567513605813e6,
      2108021841483879e-9
    ]
  },
  "EPSG:5633": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      82549.71285824571,
      1985362012397218e-9,
      2515870100495171e-9,
      2491358555272759e-9
    ]
  },
  "EPSG:5634": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      679090.188174224,
      500431.632596761,
      1970585315597419e-9,
      1.0069399598972525e6
    ]
  },
  "EPSG:5635": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1090443139749668e-9,
      852680.5303986734,
      2.2844161025193995e6,
      1.3694024327681197e6
    ]
  },
  "EPSG:5636": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5762516981165621e-9,
      1.4101831575229971e6,
      7032165858062416e-9,
      2908779050274115e-9
    ]
  },
  "EPSG:5637": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5428842622945271e-9,
      1.0429618759523812e6,
      6643496818479182e-9,
      2514728164160406e-9
    ]
  },
  "EPSG:5638": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.1800270871075992e6,
      4739806760715886e-9,
      3714401461962507e-9,
      523094047948676e-8
    ]
  },
  "EPSG:5639": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8770578841124293e6,
      4262719705874953e-9,
      3380297711154961e-9,
      4800189871621847e-9
    ]
  },
  "EPSG:5641": {
    proj4: "+proj=merc +lat_ts=-2 +lon_0=-43 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403878158366629e-8,
      9364609783144454e-9,
      6175935030167514e-9,
      10779963087784486e-9
    ]
  },
  "EPSG:5643": {
    proj4: "+proj=lcc +lat_0=48 +lon_0=10 +lat_1=52.6666666666667 +lat_2=54.3333333333333 +x_0=815000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -10342.652126634726,
      346499.0321324038,
      1.5608602481550858e6,
      954013.1326926182
    ]
  },
  "EPSG:5644": {
    proj4: "+proj=utm +zone=39 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      584179.0281333587,
      7304556722341054e-9,
      816760.3208658055,
      7949646336100033e-9
    ]
  },
  "EPSG:5646": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1387814935292786e-9,
      81582.35551710967,
      1.8989557383527043e6,
      923813.4297733185
    ]
  },
  "EPSG:5649": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3152387301645947e-8,
      5646543807680271e-9,
      3168745790886059e-8,
      6201242157957689e-9
    ]
  },
  "EPSG:5650": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332414919039561e-7,
      5261988811040167e-9,
      3350255683170643e-8,
      6.0981305305440705e6
    ]
  },
  "EPSG:5651": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3152387301645947e-8,
      5646543807680271e-9,
      3168745790886059e-8,
      6201242157957689e-9
    ]
  },
  "EPSG:5652": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3227308288950614e-8,
      523953464667462e-8,
      32689624912264265e-9,
      6151185913701432e-9
    ]
  },
  "EPSG:5653": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332414919039561e-7,
      5261988811040167e-9,
      3350255683170643e-8,
      6.0981305305440705e6
    ]
  },
  "EPSG:5654": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1387814935292786e-9,
      81582.35551710967,
      1.8989557383527043e6,
      923813.4297733185
    ]
  },
  "EPSG:5655": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1387814935292786e-9,
      81582.35551710967,
      1.8989557383527043e6,
      923813.4297733185
    ]
  },
  "EPSG:5659": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=500053 +y_0=-3999820 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      515355.69811366446,
      842171.0381105356,
      795688.8687308326,
      1.0056569969919492e6
    ]
  },
  "EPSG:5663": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3266689692727278e-9,
      5076101933661515e-9,
      3692480710285709e-9,
      6089215337300765e-9
    ]
  },
  "EPSG:5664": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2565686643178933e-9,
      5563596227624678e-9,
      2.6956162760560163e6,
      601577890795482e-8
    ]
  },
  "EPSG:5665": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3266689692727278e-9,
      5076101933661515e-9,
      3693839402871037e-9,
      6072552320885858e-9
    ]
  },
  "EPSG:5666": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3565471493220262e-9,
      5579611205367224e-9,
      3.6040085522726006e6,
      5714866975008925e-9
    ]
  },
  "EPSG:5667": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4392918422939275e-9,
      5563600224422616e-9,
      4538762551778335e-9,
      5722848783313898e-9
    ]
  },
  "EPSG:5668": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      449214719086193e-8,
      5562529004616768e-9,
      4604472071430011e-9,
      5.7260050836864505e6
    ]
  },
  "EPSG:5669": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5393861031146521e-9,
      561031144103346e-8,
      5502772416177894e-9,
      571602617021165e-8
    ]
  },
  "EPSG:5670": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3565480568566394e-9,
      5580281274399278e-9,
      3604022990100036e-9,
      5715554777568022e-9
    ]
  },
  "EPSG:5671": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      439017629495391e-8,
      5427471404062636e-9,
      4596608840767236e-9,
      606942590845794e-8
    ]
  },
  "EPSG:5672": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      538493934625595e-8,
      5157294696838746e-9,
      5596656434281129e-9,
      6067199753510543e-9
    ]
  },
  "EPSG:5673": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3565480568566394e-9,
      5580281274399278e-9,
      3604022990100036e-9,
      5715554777568022e-9
    ]
  },
  "EPSG:5674": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      439017629495391e-8,
      5427471404062636e-9,
      4596608840767236e-9,
      606942590845794e-8
    ]
  },
  "EPSG:5675": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      538493934625595e-8,
      5157294696838746e-9,
      5596656434281129e-9,
      6067199753510543e-9
    ]
  },
  "EPSG:5676": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2489779772762066e-9,
      5441313975742755e-9,
      2.5987955103882626e6,
      5965196188600703e-9
    ]
  },
  "EPSG:5677": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3386506780049417e-9,
      5237821997001279e-9,
      3.5963990407126797e6,
      6107658748655212e-9
    ]
  },
  "EPSG:5678": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4386763613430334e-9,
      5251161408309198e-9,
      4597598293959737e-9,
      6052011414167817e-9
    ]
  },
  "EPSG:5679": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5389184701626548e-9,
      5375675134883275e-9,
      5415097871261377e-9,
      5427497276098792e-9
    ]
  },
  "EPSG:5680": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1521625238487588e-9,
      6.1233667172220275e6,
      1593766887447702e-9,
      6200029128679838e-9
    ]
  },
  "EPSG:5681": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.86, 47.27, 15.04, 55.09]
  },
  "EPSG:5682": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2489779772762066e-9,
      5441313975742755e-9,
      2.5987955103882626e6,
      5965196188600703e-9
    ]
  },
  "EPSG:5683": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3386506780049417e-9,
      5237821997001279e-9,
      3.5963990407126797e6,
      6107658748655212e-9
    ]
  },
  "EPSG:5684": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4386763613430334e-9,
      5251161408309198e-9,
      4597239302325003e-9,
      6.0687051649350375e6
    ]
  },
  "EPSG:5685": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5389184701626548e-9,
      5375675134883275e-9,
      5502577243584406e-9,
      6065433414579916e-9
    ]
  },
  "EPSG:5698": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      51347.01887910941,
      6.1690136015630625e6,
      1.0666374661425329e6,
      7.1282216638350515e6
    ]
  },
  "EPSG:5699": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.1616027141117037e6,
      6039189403974507e-9,
      1239811300821791e-9,
      6241642578487854e-9
    ]
  },
  "EPSG:5700": {
    proj4: "+proj=utm +zone=1 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      298554.60041171056,
      4.1268548464045385e6,
      800622.9877260556,
      7134167925248303e-9
    ]
  },
  "EPSG:5701": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5702": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:5703": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5705": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5706": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5707": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      64323.22805854608,
      1.0744025369253752e6,
      1.0121331252694363e6,
      1.3985533017506995e6
    ]
  },
  "EPSG:5708": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      515904.771963488,
      4.1095259808092187e6,
      593562.8907930726,
      4311753164314833e-9
    ]
  },
  "EPSG:5709": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5710": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5711": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5712": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5713": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5714": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5715": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5716": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5717": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5718": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5719": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5720": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5721": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5722": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5723": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5724": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5725": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5726": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5727": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5728": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5729": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5730": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5731": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5732": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5733": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5734": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5735": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5736": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5737": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5738": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5739": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5740": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5741": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5742": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5743": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5744": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5745": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5746": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5747": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5748": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5749": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5750": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5751": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5752": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5753": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5754": {
    proj4: "+vto_meter=0.3048007491 +no_defs +type=crs"
  },
  "EPSG:5755": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5756": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5757": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5758": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5759": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5760": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5761": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5762": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5763": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5764": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5765": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5766": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5767": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5768": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5769": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5770": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5771": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5772": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5773": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5774": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5775": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5776": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5777": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5778": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5779": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5780": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5781": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5782": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5783": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5784": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5785": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5786": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5787": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5788": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5789": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5790": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5791": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5792": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5793": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5794": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5795": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5796": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5797": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5798": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5799": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5825": {
    proj4: "+proj=tmerc +lat_0=-35.3177362777778 +lon_0=149.009294830556 +k=1.000086 +x_0=200000 +y_0=600000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      177500.77257078607,
      532033.2828558194,
      235617.89761613557,
      621869.8694375784
    ]
  },
  "EPSG:5828": {
    proj4: "+proj=geocent +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4313029794628776e-9,
      442665.2726990267,
      3.5330635411632885e6,
      949325.6512390451
    ]
  },
  "EPSG:5829": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5830": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [5.86, 47.27, 15.04, 55.09]
  },
  "EPSG:5831": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5832": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      2489779772762066e-9,
      5441313975742755e-9,
      2.5987955103882626e6,
      5965196188600703e-9
    ]
  },
  "EPSG:5833": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      3386506780049417e-9,
      5237821997001279e-9,
      3.5963990407126797e6,
      6107658748655212e-9
    ]
  },
  "EPSG:5834": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      4386763613430334e-9,
      5251161408309198e-9,
      4597239302325003e-9,
      6.0687051649350375e6
    ]
  },
  "EPSG:5835": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5389184701626548e-9,
      5375675134883275e-9,
      5502577243584406e-9,
      6065433414579916e-9
    ]
  },
  "EPSG:5836": {
    proj4: "+proj=utm +zone=37 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      723936.7737164471,
      1629497004387846e-9,
      820517.7620486903,
      1811122341851777e-9
    ]
  },
  "EPSG:5837": {
    proj4: "+proj=utm +zone=40 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      170068.432802297,
      990669.0160366348,
      603235.3285713479,
      1.6530189127426762e6
    ]
  },
  "EPSG:5839": {
    proj4: "+proj=utm +zone=17 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181113.7434146548,
      8081449712308735e-9,
      833489.060022791,
      965577417044656e-8
    ]
  },
  "EPSG:5842": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      324765.79941523063,
      9114257756542506e-9,
      593113.8600248881,
      9441748689361433e-9
    ]
  },
  "EPSG:5843": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5844": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      391724.41431749694,
      8511327167299287e-9,
      479322.0404898661,
      8656449249515306e-9
    ]
  },
  "EPSG:5845": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      241540.62101139865,
      6133500820275096e-9,
      864416.0017674144,
      7689478305602837e-9
    ]
  },
  "EPSG:5846": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      84522.4789376898,
      6.2914721930941045e6,
      211692.8964099536,
      6669074791864619e-9
    ]
  },
  "EPSG:5847": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      62307.125049790615,
      6129269719805825e-9,
      216969.3817410282,
      6908803733255374e-9
    ]
  },
  "EPSG:5848": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      58792.657955065486,
      6.2039588558832295e6,
      211004.8983259734,
      6835121450001828e-9
    ]
  },
  "EPSG:5849": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      82257.06993158946,
      622579966873971e-8,
      208702.6684692285,
      6906419685139441e-9
    ]
  },
  "EPSG:5850": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      96603.43689671528,
      6505161904215527e-9,
      237927.36564764893,
      6733142998795946e-9
    ]
  },
  "EPSG:5851": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      26665.314208580123,
      6828977958128993e-9,
      212719.79682528114,
      714397310956681e-8
    ]
  },
  "EPSG:5852": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      34943.160569237574,
      6704921513905811e-9,
      209149.05656189876,
      7226423380480291e-9
    ]
  },
  "EPSG:5853": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -3406.7090479791514,
      6893784621018781e-9,
      227460.9821367364,
      7456658730847786e-9
    ]
  },
  "EPSG:5854": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      54234.490803413835,
      6305422432314068e-9,
      216295.45503502229,
      7342573659252606e-9
    ]
  },
  "EPSG:5855": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -57936.15594631786,
      7045316966080985e-9,
      270803.4434850197,
      7668217943256962e-9
    ]
  },
  "EPSG:5856": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      50039.93131663973,
      7214130484533945e-9,
      201778.75742900991,
      7.3712691680278145e6
    ]
  },
  "EPSG:5857": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      85170.75094270395,
      7266693010241891e-9,
      188242.02975711616,
      7561782741942218e-9
    ]
  },
  "EPSG:5858": {
    proj4: "+proj=utm +zone=22 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      227684.88518530852,
      604402497921689e-8,
      832579.8155508627,
      10779244851141386e-9
    ]
  },
  "EPSG:5861": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5862": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5863": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5864": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5865": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5866": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5867": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5868": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5869": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5870": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5871": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5872": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5873": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5874": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5875": {
    proj4: "+proj=utm +zone=18 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      608501.7327780775,
      8893315111686148e-9,
      834024.5403022802,
      949195183608271e-8
    ]
  },
  "EPSG:5876": {
    proj4: "+proj=utm +zone=19 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      172283.3966506896,
      876687762158106e-8,
      834859.3035863107,
      10237971750302069e-9
    ]
  },
  "EPSG:5877": {
    proj4: "+proj=utm +zone=20 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      179350.6034517528,
      8197731152786968e-9,
      833679.0511299483,
      1058442434204458e-8
    ]
  },
  "EPSG:5879": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      497831.52082027635,
      8557318138219088e-9,
      538014.6037354566,
      8605950819343597e-9
    ]
  },
  "EPSG:5880": {
    proj4: "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3201756721655599e-9,
      5862715314687066e-9,
      8171156175904385e-9,
      10875923354369992e-9
    ]
  },
  "EPSG:5884": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5751032838993699e-9,
      -92352.43891326664,
      -6114620883951442e-9,
      -937852.9782740312
    ]
  },
  "EPSG:5885": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.08, -25.68, -171.28, -14.14]
  },
  "EPSG:5886": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.08, -25.68, -171.28, -14.14]
  },
  "EPSG:5887": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2912488985134186e6,
      2158110878574114e-9,
      2.1182424115101174e6,
      342923297805742e-8
    ]
  },
  "EPSG:5896": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      515384.0434175864,
      1.0172719566645061e6,
      655010.668194647,
      2.5251437491983487e6
    ]
  },
  "EPSG:5897": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      334769.09288694744,
      921369.8987920248,
      654345.9959409399,
      2.5893852894921224e6
    ]
  },
  "EPSG:5898": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      334871.25445313187,
      947919.5898526311,
      656914.5712015177,
      2539563560606996e-9
    ]
  },
  "EPSG:5899": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      354690.30716977856,
      947846.8944300995,
      604527.8542327591,
      2397360716989709e-9
    ]
  },
  "EPSG:5921": {
    proj4: "+proj=lcc +lat_0=81.317226 +lon_0=-111 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1768976406584494e6,
      -223483.65693944765,
      237725.6557377168,
      732749.6996492343
    ]
  },
  "EPSG:5922": {
    proj4: "+proj=lcc +lat_0=81.317226 +lon_0=-39 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1768976406584496e6,
      -223483.65693944713,
      237767.41274175383,
      732790.7186912709
    ]
  },
  "EPSG:5923": {
    proj4: "+proj=lcc +lat_0=81.317226 +lon_0=33 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1768976406584496e6,
      -223483.65693944748,
      237767.41274175385,
      732790.7186912709
    ]
  },
  "EPSG:5924": {
    proj4: "+proj=lcc +lat_0=81.317226 +lon_0=105 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1768976406584498e6,
      -223483.65693944713,
      237767.41274175368,
      732790.7186912708
    ]
  },
  "EPSG:5925": {
    proj4: "+proj=lcc +lat_0=81.317226 +lon_0=177 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1768976406584496e6,
      -223483.65693944748,
      237725.6557377168,
      732749.6996492343
    ]
  },
  "EPSG:5926": {
    proj4: "+proj=lcc +lat_0=73.1557408611111 +lon_0=-111 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1788158296771795e-9,
      19334.96256251501,
      873474.029845368,
      997837.6510542653
    ]
  },
  "EPSG:5927": {
    proj4: "+proj=lcc +lat_0=73.1557408611111 +lon_0=-39 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1788158296771796e-9,
      19334.96256251572,
      873630.1071469986,
      997983.573347155
    ]
  },
  "EPSG:5928": {
    proj4: "+proj=lcc +lat_0=73.1557408611111 +lon_0=33 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7881582967717957e6,
      19334.962562515364,
      873630.1071469989,
      997983.5733471554
    ]
  },
  "EPSG:5929": {
    proj4: "+proj=lcc +lat_0=73.1557408611111 +lon_0=105 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1788158296771796e-9,
      19334.96256251572,
      873630.1071469983,
      997983.5733471549
    ]
  },
  "EPSG:5930": {
    proj4: "+proj=lcc +lat_0=73.1557408611111 +lon_0=177 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7881582967717957e6,
      19334.962562515364,
      873474.029845368,
      997837.6510542653
    ]
  },
  "EPSG:5931": {
    proj4: "+proj=lcc +lat_0=65.1012708888889 +lon_0=-111 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.3798938050166275e6,
      205965.13433174163,
      1.5059164317166149e6,
      1.2178561991561656e6
    ]
  },
  "EPSG:5932": {
    proj4: "+proj=lcc +lat_0=65.1012708888889 +lon_0=-39 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.3798938050166285e6,
      205965.13433174268,
      1.5059164317166149e6,
      1.2178561991561656e6
    ]
  },
  "EPSG:5933": {
    proj4: "+proj=lcc +lat_0=65.1012708888889 +lon_0=33 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2379893805016628e-9,
      205965.13433174233,
      1506192435448149e-9,
      1218094623652487e-9
    ]
  },
  "EPSG:5934": {
    proj4: "+proj=lcc +lat_0=65.1012708888889 +lon_0=105 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2379893805016629e-9,
      205965.13433174268,
      1506192435448148e-9,
      1218094623652486e-9
    ]
  },
  "EPSG:5935": {
    proj4: "+proj=lcc +lat_0=65.1012708888889 +lon_0=177 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2379893805016628e-9,
      205965.13433174233,
      1.5059164317166149e6,
      1.2178561991561656e6
    ]
  },
  "EPSG:5936": {
    proj4: "+proj=stere +lat_0=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      297059.6413143459,
      -949579.2235031226,
      2e6,
      2e6
    ]
  },
  "EPSG:5937": {
    proj4: "+proj=stere +lat_0=90 +lon_0=-100 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.3541377363020466e6,
      1.4085750200775345e6,
      2e6,
      2e6
    ]
  },
  "EPSG:5938": {
    proj4: "+proj=stere +lat_0=90 +lon_0=-33 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      145024.4127146008,
      4856411915592164e-9,
      2e6,
      2e6
    ]
  },
  "EPSG:5939": {
    proj4: "+proj=stere +lat_0=90 +lon_0=18 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0524750224816725e6,
      5239185049979996e-9,
      2e6,
      2e6
    ]
  },
  "EPSG:5940": {
    proj4: "+proj=stere +lat_0=90 +lon_0=105 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      5289828146168888e-9,
      111849320499687e-8,
      2e6,
      2e6
    ]
  },
  "EPSG:5941": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:5942": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [4.68, 57.93, 31.22, 71.21]
  },
  "EPSG:5945": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      51945.1247628411,
      1.0359343907770405e6,
      125777.20199394811,
      1.5003582838161755e6
    ]
  },
  "EPSG:5946": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440847,
      992313.1428330106,
      125318.88805964643,
      1.5594295851280722e6
    ]
  },
  "EPSG:5947": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440851,
      992313.1428330106,
      124884.50093879795,
      1.6151612869753996e6
    ]
  },
  "EPSG:5948": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70458.46551056494,
      1003450687001294e-9,
      124579.28383650187,
      1654175795684301e-9
    ]
  },
  "EPSG:5949": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70863.58091185403,
      1.0580271755708447e6,
      124325.68404458911,
      1.6865035342487227e6
    ]
  },
  "EPSG:5950": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71179.23933332431,
      1.1003546674867903e6,
      123552.29536064467,
      1784609330756158e-9
    ]
  },
  "EPSG:5951": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71162.59359829966,
      1.0981268426024655e6,
      122915.31902708235,
      1.8648863163462114e6
    ]
  },
  "EPSG:5952": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71999.1977930403,
      1.2095264762870348e6,
      120775.13266603666,
      2131414625984512e-9
    ]
  },
  "EPSG:5953": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      75543.06426897892,
      1.6697821289203397e6,
      120576.22412355251,
      2.1559525825377745e6
    ]
  },
  "EPSG:5954": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      75560.55468435661,
      1.6720116296961522e6,
      119959.4795473024,
      2231801244248977e-9
    ]
  },
  "EPSG:5955": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      77422.35089921986,
      1907257787718176e-9,
      119686.4725431606,
      2265265814349963e-9
    ]
  },
  "EPSG:5956": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      78082.79970798217,
      1.9897766101278397e6,
      119595.34789405452,
      2.2764209293533033e6
    ]
  },
  "EPSG:5957": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79035.29044252675,
      2.1079926396731324e6,
      119385.53134366407,
      2.3020781799278613e6
    ]
  },
  "EPSG:5958": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79125.52961502795,
      2.1191458920571413e6,
      118845.86197135382,
      2367897665411326e-9
    ]
  },
  "EPSG:5959": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79387.58766576619,
      2151491087596586e-9,
      118781.69740806193,
      2375707045576591e-9
    ]
  },
  "EPSG:5960": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79423.77587644749,
      2.1559525825377745e6,
      118827.53215390828,
      237012891069196e-8
    ]
  },
  "EPSG:5961": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118442.07052856867,
      2.4169862004581476e6
    ]
  },
  "EPSG:5962": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79713.64701614449,
      2.1916453096719477e6,
      118350.14460384905,
      2428143016014467e-9
    ]
  },
  "EPSG:5963": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79650.1824237814,
      2183837409423878e-9,
      118101.6614118561,
      2458267021949799e-9
    ]
  },
  "EPSG:5964": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79613.93079864373,
      2179375781275641e-9,
      118027.95798376336,
      2467192821487358e-9
    ]
  },
  "EPSG:5965": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79622.99275879291,
      2.1804911863236446e6,
      117981.87517628688,
      2472771485000811e-9
    ]
  },
  "EPSG:5966": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80641.85952282792,
      2305424827540595e-9,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:5967": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80815.46001396282,
      2.3266205272116154e6,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:5968": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118055.60096688129,
      2463845637695616e-9
    ]
  },
  "EPSG:5969": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80013.25022374123,
      2.2284548515287233e6,
      118239.75846874082,
      2.4415313546318635e6
    ]
  },
  "EPSG:5970": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80413.76791343899,
      2277536447918715e-9,
      126476.88491594889,
      2423761602474995e-9
    ]
  },
  "EPSG:5971": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      598409.6963484859,
      6465565569583835e-9,
      654561.9732058336,
      6932358648247227e-9
    ]
  },
  "EPSG:5972": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      322361.85269627953,
      6424859178169648e-9,
      637396.4425061183,
      7.2964402817092715e6
    ]
  },
  "EPSG:5973": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      332099.4144576283,
      664185060830174e-8,
      616614.6218669154,
      773306155198181e-8
    ]
  },
  "EPSG:5974": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      374843.34104633454,
      7550363702229862e-9,
      608889.9332252084,
      7889025642961286e-9
    ]
  },
  "EPSG:5975": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      377772.34176522493,
      7.6105111676075235e6,
      607810.1235083707,
      7903491063464906e-9
    ]
  },
  "EPSG:5976": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      382568.9537480979,
      7708535309958897e-9,
      434576.3324297024,
      7852704885047318e-9
    ]
  },
  "EPSG:6050": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=-30 +lat_1=87 +lat_2=83.6666666666667 +x_0=25500000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25100338007828988e-9,
      1.3156009058090504e6,
      25620721726249453e-9,
      1.8005965408930546e6
    ]
  },
  "EPSG:6051": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=-52 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=18500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18100819545393318e-9,
      2.2840443990066857e6,
      18709609769791324e-9,
      2810361182052331e-9
    ]
  },
  "EPSG:6052": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=-12 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=20500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20100819545393318e-9,
      2.2840443990066857e6,
      20709710362428136e-9,
      2810397423694918e-9
    ]
  },
  "EPSG:6053": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-69 +lat_1=80.3333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29339921413472433e-9,
      3.2238724283946976e6,
      29754492100761093e-9,
      3807801265606377e-9
    ]
  },
  "EPSG:6054": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-39 +lat_1=80.3333333333333 +lat_2=77 +x_0=31500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31103488727831822e-9,
      3.2668255362905753e6,
      31754492100761093e-9,
      3807801265606377e-9
    ]
  },
  "EPSG:6055": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-10 +lat_1=80.3333333333333 +lat_2=77 +x_0=33500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33129396294023275e-9,
      3.2602606391168865e6,
      3370255570517703e-8,
      3.7956343235700876e6
    ]
  },
  "EPSG:6056": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-64 +lat_1=77 +lat_2=73.6666666666667 +x_0=20500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20106943948936753e-9,
      4257130665713221e-9,
      20803533729390644e-9,
      4809783682960124e-9
    ]
  },
  "EPSG:6057": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-39 +lat_1=77 +lat_2=73.6666666666667 +x_0=22500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22106943948936753e-9,
      4257130665713221e-9,
      22803533729390644e-9,
      4809783682960124e-9
    ]
  },
  "EPSG:6058": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-14 +lat_1=77 +lat_2=73.6666666666667 +x_0=24500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24106943948936753e-9,
      4257130665713221e-9,
      2478051909281864e-8,
      4804852123131185e-9
    ]
  },
  "EPSG:6059": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-62 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=41500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4111447679321027e-8,
      524780040289856e-8,
      41797323318607934e-9,
      5802060086260605e-9
    ]
  },
  "EPSG:6060": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-42 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=43500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4311059700301783e-8,
      5250709876204114e-9,
      43797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6061": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-22 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=45500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4511059700301783e-8,
      5250709876204114e-9,
      45797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6062": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-56 +lat_1=70.3333333333333 +lat_2=67 +x_0=26500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26095158421761535e-9,
      6247821613101342e-9,
      26823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6063": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-38 +lat_1=70.3333333333333 +lat_2=67 +x_0=28500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28095158421761535e-9,
      6247821613101342e-9,
      28823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6064": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-20 +lat_1=70.3333333333333 +lat_2=67 +x_0=30500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30095158421761535e-9,
      6247821613101342e-9,
      30823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6065": {
    proj4: "+proj=lcc +lat_0=65.3510393055555 +lon_0=-51 +lat_1=67 +lat_2=63.6666666666667 +x_0=11500000 +y_0=7500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      11093145782901898e-9,
      72448386176211e-7,
      11877913798422907e-9,
      7804553489199778e-9
    ]
  },
  "EPSG:6066": {
    proj4: "+proj=lcc +lat_0=65.3510393055555 +lon_0=-34 +lat_1=67 +lat_2=63.6666666666667 +x_0=13500000 +y_0=7500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      130931457829019e-7,
      72448386176211e-7,
      13877913798422907e-9,
      7804553489199778e-9
    ]
  },
  "EPSG:6067": {
    proj4: "+proj=lcc +lat_0=62.0153068888889 +lon_0=-52 +lat_1=63.6666666666667 +lat_2=60.3333333333333 +x_0=20500000 +y_0=8500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2010408612578967e-8,
      8241140187196851e-9,
      20883542037449867e-9,
      8801720306383334e-9
    ]
  },
  "EPSG:6068": {
    proj4: "+proj=lcc +lat_0=62.0153068888889 +lon_0=-37 +lat_1=63.6666666666667 +lat_2=60.3333333333333 +x_0=22500000 +y_0=8500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2210408612578967e-8,
      8241140187196851e-9,
      22883542037449867e-9,
      8801720306383334e-9
    ]
  },
  "EPSG:6069": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=16 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=22500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22100819545393318e-9,
      2.2840443990066857e6,
      22709710362428136e-9,
      2810397423694918e-9
    ]
  },
  "EPSG:6070": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=21 +lat_1=80.3333333333333 +lat_2=77 +x_0=11500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1086788086244412e-8,
      3349306941403126e-9,
      11787520018117832e-9,
      3817078921619541e-9
    ]
  },
  "EPSG:6071": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=10 +lat_1=77 +lat_2=73.6666666666667 +x_0=26500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26106943948936753e-9,
      4257130665713221e-9,
      26780749646109857e-9,
      4804899513786441e-9
    ]
  },
  "EPSG:6072": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=34 +lat_1=77 +lat_2=73.6666666666667 +x_0=28500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28106943948936753e-9,
      4257130665713221e-9,
      28780749646109857e-9,
      4804899513786441e-9
    ]
  },
  "EPSG:6073": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=14 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=11500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      11110597003017824e-9,
      5250709876204114e-9,
      11797323318607934e-9,
      5802060086260605e-9
    ]
  },
  "EPSG:6074": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=34 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=13500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13110597003017824e-9,
      5250709876204114e-9,
      13797323318607934e-9,
      5802060086260605e-9
    ]
  },
  "EPSG:6075": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=53 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=24500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2410081954539968e-8,
      2284044399009918e-9,
      2470971036242471e-8,
      2.8103974236899936e6
    ]
  },
  "EPSG:6076": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=93 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=26500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2610081954539968e-8,
      2284044399009918e-9,
      2670971036242471e-8,
      2.8103974236899936e6
    ]
  },
  "EPSG:6077": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=52 +lat_1=80.3333333333333 +lat_2=77 +x_0=13500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      13051773573141044e-9,
      3.2813572767451745e6,
      13754658014443615e-9,
      3.8078448371217763e6
    ]
  },
  "EPSG:6078": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=83 +lat_1=80.3333333333333 +lat_2=77 +x_0=15500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      15077697311497377e-9,
      3.2738328684529774e6,
      15754658014443617e-9,
      3.8078448371217763e6
    ]
  },
  "EPSG:6079": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=114 +lat_1=80.3333333333333 +lat_2=77 +x_0=17500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1707769731149738e-8,
      3273832868452978e-9,
      17754658014443617e-9,
      3.8078448371217763e6
    ]
  },
  "EPSG:6080": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=145 +lat_1=80.3333333333333 +lat_2=77 +x_0=19500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      19077697311497375e-9,
      3273832868452978e-9,
      19754658014443617e-9,
      3.8078448371217763e6
    ]
  },
  "EPSG:6081": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=58 +lat_1=77 +lat_2=73.6666666666667 +x_0=30500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      30106943948942665e-9,
      4257130665716224e-9,
      3078074964610543e-8,
      4804899513782174e-9
    ]
  },
  "EPSG:6082": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=82 +lat_1=77 +lat_2=73.6666666666667 +x_0=32500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      32106943948942665e-9,
      4257130665716224e-9,
      3278074964610543e-8,
      4804899513782174e-9
    ]
  },
  "EPSG:6083": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=106 +lat_1=77 +lat_2=73.6666666666667 +x_0=34500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3410694394894267e-8,
      4257130665716223e-9,
      3478074964610543e-8,
      4804899513782174e-9
    ]
  },
  "EPSG:6084": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=130 +lat_1=77 +lat_2=73.6666666666667 +x_0=36500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3610694394894267e-8,
      4257130665716223e-9,
      3678074964610543e-8,
      4804899513782173e-9
    ]
  },
  "EPSG:6085": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=154 +lat_1=77 +lat_2=73.6666666666667 +x_0=38500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3810694394894267e-8,
      4257130665716224e-9,
      3878074964610543e-8,
      4804899513782173e-9
    ]
  },
  "EPSG:6086": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=179 +lat_1=77 +lat_2=73.6666666666667 +x_0=40500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      40074696439239785e-9,
      4264040638981998e-9,
      4078074964610543e-8,
      4804899513782173e-9
    ]
  },
  "EPSG:6087": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=54 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=15500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      15110597003023453e-9,
      5250709876206768e-9,
      15797323318603383e-9,
      5802060086256799e-9
    ]
  },
  "EPSG:6088": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=74 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=17500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      17110597003023453e-9,
      5250709876206768e-9,
      1782670969880976e-8,
      580724012242635e-8
    ]
  },
  "EPSG:6089": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=95 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=19500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      19110597003023453e-9,
      5250709876206768e-9,
      1982670969880976e-8,
      580724012242635e-8
    ]
  },
  "EPSG:6090": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=116 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=21500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      21110597003023453e-9,
      5250709876206768e-9,
      2182670969880976e-8,
      580724012242635e-8
    ]
  },
  "EPSG:6091": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=137 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=23500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      23110597003023453e-9,
      5250709876206767e-9,
      23826416267235935e-9,
      5807185908332909e-9
    ]
  },
  "EPSG:6092": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=158 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=25500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      25110597003023453e-9,
      5250709876206767e-9,
      2582670969880976e-8,
      580724012242635e-8
    ]
  },
  "EPSG:6093": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=179 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=27500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      27110597003023453e-9,
      5250709876206768e-9,
      27855713546404157e-9,
      5812848200244373e-9
    ]
  },
  "EPSG:6094": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-163 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29110597003017824e-9,
      5250709876204114e-9,
      2979702902747949e-8,
      580201075079501e-8
    ]
  },
  "EPSG:6095": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-147 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31110597003017824e-9,
      5250709876204114e-9,
      31797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6096": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-165 +lat_1=70.3333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14095158421761535e-9,
      6247821613101342e-9,
      14823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6097": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-147 +lat_1=70.3333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16095158421761535e-9,
      6247821613101342e-9,
      16823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6098": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=-90 +lat_1=87 +lat_2=83.6666666666667 +x_0=23500000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      23100338007828988e-9,
      1.3156009058090504e6,
      23620721726249453e-9,
      1.8005965408930546e6
    ]
  },
  "EPSG:6099": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=-115 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=14500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14100819545393316e-9,
      2.2840443990066857e6,
      14709609769791324e-9,
      2.8103611820523306e6
    ]
  },
  "EPSG:6100": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=-75 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=16500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16100819545393316e-9,
      2.2840443990066857e6,
      16709609769791324e-9,
      2810361182052331e-9
    ]
  },
  "EPSG:6101": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-129 +lat_1=80.3333333333333 +lat_2=77 +x_0=25500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25103488727831822e-9,
      3.2668255362905753e6,
      25754492100761093e-9,
      3807801265606377e-9
    ]
  },
  "EPSG:6102": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-99 +lat_1=80.3333333333333 +lat_2=77 +x_0=27500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      27103488727831822e-9,
      3.2668255362905753e6,
      27754492100761093e-9,
      3807801265606377e-9
    ]
  },
  "EPSG:6103": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-69 +lat_1=80.3333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29103488727831822e-9,
      3.2668255362905753e6,
      29572326781186387e-9,
      3777565760586041e-9
    ]
  },
  "EPSG:6104": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-129 +lat_1=77 +lat_2=73.6666666666667 +x_0=14500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14106943948936753e-9,
      4257130665713221e-9,
      14803533729390644e-9,
      4809783682960124e-9
    ]
  },
  "EPSG:6105": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-104 +lat_1=77 +lat_2=73.6666666666667 +x_0=16500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16106943948936753e-9,
      4257130665713221e-9,
      16803533729390644e-9,
      4809783682960124e-9
    ]
  },
  "EPSG:6106": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-79 +lat_1=77 +lat_2=73.6666666666667 +x_0=18500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18106943948936753e-9,
      4257130665713221e-9,
      1878051909281864e-8,
      4804852123131185e-9
    ]
  },
  "EPSG:6107": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-131 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=33500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33110597003017824e-9,
      5250709876204114e-9,
      33797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6108": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-111 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=35500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3511059700301783e-8,
      5250709876204114e-9,
      35797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6109": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-91 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=37500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3711059700301783e-8,
      5250709876204114e-9,
      37797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6110": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-71 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=39500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3911059700301783e-8,
      5250709876204114e-9,
      39797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6111": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-132 +lat_1=70.3333333333333 +lat_2=67 +x_0=18500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18095158421761535e-9,
      6247821613101342e-9,
      1885899116121909e-8,
      6806174826902062e-9
    ]
  },
  "EPSG:6112": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-113 +lat_1=70.3333333333333 +lat_2=67 +x_0=20500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20095158421761535e-9,
      6247821613101342e-9,
      2085899116121909e-8,
      6806174826902062e-9
    ]
  },
  "EPSG:6113": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-94 +lat_1=70.3333333333333 +lat_2=67 +x_0=22500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22095158421761535e-9,
      6247821613101342e-9,
      2285899116121909e-8,
      6806174826902062e-9
    ]
  },
  "EPSG:6114": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-75 +lat_1=70.3333333333333 +lat_2=67 +x_0=24500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24095158421761535e-9,
      6247821613101342e-9,
      2485899116121909e-8,
      6806174826902062e-9
    ]
  },
  "EPSG:6115": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=30 +lat_1=87 +lat_2=83.6666666666667 +x_0=27500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      27100338007835474e-9,
      1.3156009058119645e6,
      276207582427408e-7,
      1.8006175472023517e6
    ]
  },
  "EPSG:6116": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=90 +lat_1=87 +lat_2=83.6666666666667 +x_0=29500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      29100338007835474e-9,
      1.3156009058119645e6,
      296207582427408e-7,
      1.8006175472023517e6
    ]
  },
  "EPSG:6117": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=150 +lat_1=87 +lat_2=83.6666666666667 +x_0=31500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      31100338007835474e-9,
      1.3156009058119648e6,
      31621278975227002e-9,
      1.7996276477029421e6
    ]
  },
  "EPSG:6118": {
    proj4: "+proj=lcc +lat_0=85.4371183333333 +lon_0=-150 +lat_1=87 +lat_2=83.6666666666667 +x_0=21500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      21100338007835474e-9,
      1.3156009058119645e6,
      21620721726247467e-9,
      1.8005965408881463e6
    ]
  },
  "EPSG:6119": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=133 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=28500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2810081954539968e-8,
      2284044399009918e-9,
      2870971036242471e-8,
      2.8103974236899936e6
    ]
  },
  "EPSG:6120": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=166 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=10500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      10100819545399679e-9,
      2284044399009918e-9,
      10709710362424709e-9,
      2.8103974236899936e6
    ]
  },
  "EPSG:6121": {
    proj4: "+proj=lcc +lat_0=82.0584248888889 +lon_0=-154 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=12500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      12100819545399679e-9,
      2284044399009918e-9,
      12699620582720255e-9,
      2806859507420668e-9
    ]
  },
  "EPSG:6122": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=176 +lat_1=80.3333333333333 +lat_2=77 +x_0=21500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2107769731149738e-8,
      3.2738328684529774e6,
      21754658014443617e-9,
      3.8078448371217763e6
    ]
  },
  "EPSG:6123": {
    proj4: "+proj=lcc +lat_0=78.7073375277778 +lon_0=-153 +lat_1=80.3333333333333 +lat_2=77 +x_0=23500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2307769731149738e-8,
      3.2738328684529774e6,
      23754492100756995e-9,
      3.8078012656017337e6
    ]
  },
  "EPSG:6124": {
    proj4: "+proj=lcc +lat_0=75.3644033055556 +lon_0=-155 +lat_1=77 +lat_2=73.6666666666667 +x_0=12500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      12042570210435681e-9,
      4271494164013618e-9,
      12826461809326185e-9,
      4815103168750525e-9
    ]
  },
  "EPSG:6125": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-5 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=47500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4711059700301783e-8,
      5250709876204114e-9,
      47797323318607934e-9,
      5802060086260605e-9
    ]
  },
  "EPSG:6128": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=499999.999998 +y_0=0 +ellps=clrk66 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.4817748619965503e6,
      6968505818555192e-9,
      1.6266415994767512e6,
      7040900105060624e-9
    ]
  },
  "EPSG:6129": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=499999.999998 +y_0=0 +ellps=clrk66 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.9362625267931812e6,
      7121508756117333e-9,
      2.0906613411845104e6,
      7176958949192124e-9
    ]
  },
  "EPSG:6130": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:6131": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:6132": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:6133": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      677966.4141445553,
      -6044206751690514e-9,
      1.1676901973317387e6,
      -5854353175594698e-9
    ]
  },
  "EPSG:6134": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-83.6, 17.58, -78.72, 20.68]
  },
  "EPSG:6135": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-83.6, 17.58, -78.72, 20.68]
  },
  "EPSG:6144": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [4.68, 57.93, 31.22, 71.21]
  },
  "EPSG:6145": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      51945.1247628411,
      1.0359343907770405e6,
      125777.20199394811,
      1.5003582838161755e6
    ]
  },
  "EPSG:6146": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440847,
      992313.1428330106,
      125318.88805964643,
      1.5594295851280722e6
    ]
  },
  "EPSG:6147": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70376.05672440851,
      992313.1428330106,
      124884.50093879795,
      1.6151612869753996e6
    ]
  },
  "EPSG:6148": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70458.46551056494,
      1003450687001294e-9,
      124579.28383650187,
      1654175795684301e-9
    ]
  },
  "EPSG:6149": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      70863.58091185403,
      1.0580271755708447e6,
      124325.68404458911,
      1.6865035342487227e6
    ]
  },
  "EPSG:6150": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71179.23933332431,
      1.1003546674867903e6,
      123552.29536064467,
      1784609330756158e-9
    ]
  },
  "EPSG:6151": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71162.59359829966,
      1.0981268426024655e6,
      122915.31902708235,
      1.8648863163462114e6
    ]
  },
  "EPSG:6152": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      71999.1977930403,
      1.2095264762870348e6,
      120775.13266603666,
      2131414625984512e-9
    ]
  },
  "EPSG:6153": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      75543.06426897892,
      1.6697821289203397e6,
      120576.22412355251,
      2.1559525825377745e6
    ]
  },
  "EPSG:6154": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      75560.55468435661,
      1.6720116296961522e6,
      119959.4795473024,
      2231801244248977e-9
    ]
  },
  "EPSG:6155": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      77422.35089921986,
      1907257787718176e-9,
      119686.4725431606,
      2265265814349963e-9
    ]
  },
  "EPSG:6156": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      78082.79970798217,
      1.9897766101278397e6,
      119595.34789405452,
      2.2764209293533033e6
    ]
  },
  "EPSG:6157": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79035.29044252675,
      2.1079926396731324e6,
      119385.53134366407,
      2.3020781799278613e6
    ]
  },
  "EPSG:6158": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79125.52961502795,
      2.1191458920571413e6,
      118845.86197135382,
      2367897665411326e-9
    ]
  },
  "EPSG:6159": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79387.58766576619,
      2151491087596586e-9,
      118781.69740806193,
      2375707045576591e-9
    ]
  },
  "EPSG:6160": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79423.77587644749,
      2.1559525825377745e6,
      118827.53215390828,
      237012891069196e-8
    ]
  },
  "EPSG:6161": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118442.07052856867,
      2.4169862004581476e6
    ]
  },
  "EPSG:6162": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79713.64701614449,
      2.1916453096719477e6,
      118350.14460384905,
      2428143016014467e-9
    ]
  },
  "EPSG:6163": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79650.1824237814,
      2183837409423878e-9,
      118101.6614118561,
      2458267021949799e-9
    ]
  },
  "EPSG:6164": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79613.93079864373,
      2179375781275641e-9,
      118027.95798376336,
      2467192821487358e-9
    ]
  },
  "EPSG:6165": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      79622.99275879291,
      2.1804911863236446e6,
      117981.87517628688,
      2472771485000811e-9
    ]
  },
  "EPSG:6166": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80641.85952282792,
      2305424827540595e-9,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:6167": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80815.46001396282,
      2.3266205272116154e6,
      118018.74253840542,
      2468308551805427e-9
    ]
  },
  "EPSG:6168": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80022.33968149094,
      2229570314464634e-9,
      118055.60096688129,
      2463845637695616e-9
    ]
  },
  "EPSG:6169": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80013.25022374123,
      2.2284548515287233e6,
      118239.75846874082,
      2.4415313546318635e6
    ]
  },
  "EPSG:6170": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      80413.76791343899,
      2277536447918715e-9,
      126476.88491594889,
      2423761602474995e-9
    ]
  },
  "EPSG:6171": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      598409.6963484859,
      6465565569583835e-9,
      654561.9732058336,
      6932358648247227e-9
    ]
  },
  "EPSG:6172": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      322361.85269627953,
      6424859178169648e-9,
      637396.4425061183,
      7.2964402817092715e6
    ]
  },
  "EPSG:6173": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      332099.4144576283,
      664185060830174e-8,
      616614.6218669154,
      773306155198181e-8
    ]
  },
  "EPSG:6174": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      374843.34104633454,
      7550363702229862e-9,
      608889.9332252084,
      7889025642961286e-9
    ]
  },
  "EPSG:6175": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      377772.34176522493,
      7.6105111676075235e6,
      607810.1235083707,
      7903491063464906e-9
    ]
  },
  "EPSG:6176": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      382568.9537480979,
      7708535309958897e-9,
      434576.3324297024,
      7852704885047318e-9
    ]
  },
  "EPSG:6178": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6179": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6180": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6181": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6182": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6183": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6184": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6185": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6186": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6187": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6190": {
    proj4: "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      14722.20244943403,
      22542.41597773414,
      291109.4871510995,
      246366.94720796496
    ]
  },
  "EPSG:6201": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3333333333333 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2800981341768974e6,
      188322.8706269183,
      2.5251045857476015e6,
      955846.6985531407
    ]
  },
  "EPSG:6202": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3333333333333 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1217018127467249e-9,
      82571.4808399682,
      2.5776759923523185e6,
      998938.8266845831
    ]
  },
  "EPSG:6204": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      453631.0116501207,
      4523154165407691e-9,
      668025.8299300658,
      4692698538421413e-9
    ]
  },
  "EPSG:6207": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [80.06, 26.34, 88.21, 30.43]
  },
  "EPSG:6210": {
    proj4: "+proj=utm +zone=23 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053405,
      0,
      833757.0527369918,
      567818.7708602059
    ]
  },
  "EPSG:6211": {
    proj4: "+proj=utm +zone=24 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053335,
      0,
      586789.9786608018,
      81799.90986453294
    ]
  },
  "EPSG:6244": {
    proj4: "+proj=col_urban +lat_0=7.08760639166667 +lon_0=-70.7583096555555 +x_0=1035263.443 +y_0=1275526.621 +h_0=100 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0328669819483911e6,
      1.2713676760289613e6,
      1.0406003684864544e6,
      1.2768975440337586e6
    ]
  },
  "EPSG:6245": {
    proj4: "+proj=col_urban +lat_0=4.532325 +lon_0=-75.6734891666667 +x_0=1155824.666 +y_0=993087.465 +h_0=1470 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1495517264989454e6,
      989512.3425229416,
      1158431883140022e-9,
      995042.4835857403
    ]
  },
  "EPSG:6246": {
    proj4: "+proj=col_urban +lat_0=10.9231830833333 +lon_0=-74.8343313333333 +x_0=917264.406 +y_0=1699839.935 +h_0=100 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      913364.2457787974,
      169174495227798e-8,
      926479.0469252871,
      1.7149753461533303e6
    ]
  },
  "EPSG:6247": {
    proj4: "+proj=col_urban +lat_0=4.68048611111111 +lon_0=-74.1465916666667 +x_0=92334.879 +y_0=109320.965 +h_0=2550 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      78632.78786954907,
      83824.37254485596,
      110821.20761581796,
      128075.8306136524
    ]
  },
  "EPSG:6248": {
    proj4: "+proj=col_urban +lat_0=7.07888714166667 +lon_0=-73.1973432222222 +x_0=1097241.305 +y_0=1274642.278 +h_0=931 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0980527624867167e6,
      1.2692350052749566e6,
      1.1124137309579167e6,
      1.2847222740157705e6
    ]
  },
  "EPSG:6249": {
    proj4: "+proj=col_urban +lat_0=3.44188333333333 +lon_0=-76.5205625 +x_0=1061900.18 +y_0=872364.63 +h_0=1000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0519590828640014e6,
      858885.3194926217,
      1.0730750403336138e6,
      885428.4178076987
    ]
  },
  "EPSG:6250": {
    proj4: "+proj=col_urban +lat_0=10.3970475 +lon_0=-75.5112069444444 +x_0=842981.41 +y_0=1641887.09 +h_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      836540.769273674,
      1627834905679466e-9,
      852966.5770046822,
      1.6499578326592755e6
    ]
  },
  "EPSG:6251": {
    proj4: "+proj=col_urban +lat_0=7.88893673611111 +lon_0=-72.50287095 +x_0=842805.406 +y_0=1364404.57 +h_0=308 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      836504.1260790448,
      1.3556745531066835e6,
      847532.2134407683,
      1.3733704560087887e6
    ]
  },
  "EPSG:6252": {
    proj4: "+proj=col_urban +lat_0=1.62101229444444 +lon_0=-75.6191176027778 +x_0=1162300.348 +y_0=671068.716 +h_0=300 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1610893198520972e6,
      665427.7593118713,
      1.1655405221324537e6,
      674274.2113750876
    ]
  },
  "EPSG:6253": {
    proj4: "+proj=col_urban +lat_0=4.41941282777778 +lon_0=-75.1799259333333 +x_0=877634.33 +y_0=980541.348 +h_0=1100 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      867634.8284081665,
      977288.8929519164,
      885396.268351008,
      986136.657625328
    ]
  },
  "EPSG:6254": {
    proj4: "+proj=col_urban +lat_0=3.84543818333333 +lon_0=-67.9052320888889 +x_0=1019177.687 +y_0=491791.326 +h_0=96 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0153157350152778e6,
      486766.80731081375,
      1.0219800914072618e6,
      497824.86465819355
    ]
  },
  "EPSG:6255": {
    proj4: "+proj=col_urban +lat_0=-4.19768404722222 +lon_0=-69.9428110583333 +x_0=25978.217 +y_0=27501.365 +h_0=89.7 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      21849.506692287527,
      23927.710997018243,
      28510.890480068752,
      30562.679612440876
    ]
  },
  "EPSG:6256": {
    proj4: "+proj=col_urban +lat_0=5.06815388888889 +lon_0=-75.5110947222222 +x_0=1173727.04 +y_0=1052391.13 +h_0=2100 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1705205241608068e6,
      1.0470644378440438e6,
      1.1816126181820913e6,
      1.0570205619655354e6
    ]
  },
  "EPSG:6257": {
    proj4: "+proj=col_urban +lat_0=6.22920888888889 +lon_0=-75.5648869444444 +x_0=835378.647 +y_0=1180816.875 +h_0=1510 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      824848.1600603319,
      1.1687378238499418e6,
      842559.2290606597,
      1.1963907423805888e6
    ]
  },
  "EPSG:6258": {
    proj4: "+proj=col_urban +lat_0=1.24996936666667 +lon_0=-70.2354616555556 +x_0=1093717.398 +y_0=629997.236 +h_0=170 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0920993241880897e6,
      627789.0724189021,
      1.0965511385029752e6,
      634423.7479508382
    ]
  },
  "EPSG:6259": {
    proj4: "+proj=col_urban +lat_0=1.14002335833333 +lon_0=-76.6510212194444 +x_0=1047467.388 +y_0=617828.474 +h_0=655.2 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0464679617433037e6,
      615614.1694350891,
      1.0498072068482107e6,
      622249.3454610436
    ]
  },
  "EPSG:6260": {
    proj4: "+proj=col_urban +lat_0=8.77308575555556 +lon_0=-75.8795533305556 +x_0=1131814.934 +y_0=1462131.119 +h_0=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1251629398438025e6,
      1.4540483425142532e6,
      1.1383666938528165e6,
      1.4662143674563037e6
    ]
  },
  "EPSG:6261": {
    proj4: "+proj=col_urban +lat_0=2.94241505555556 +lon_0=-75.2964367222222 +x_0=864476.923 +y_0=817199.827 +h_0=430 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      861856.9623802232,
      809191.8569881375,
      871863.1221639799,
      822462.2139277086
    ]
  },
  "EPSG:6262": {
    proj4: "+proj=col_urban +lat_0=1.20098951388889 +lon_0=-77.2531256333333 +x_0=980469.695 +y_0=624555.332 +h_0=2530 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      973023.8376473037,
      620021.2073024599,
      983044.4313378627,
      631083.0191577227
    ]
  },
  "EPSG:6263": {
    proj4: "+proj=col_urban +lat_0=4.81359361111111 +lon_0=-75.6939513888889 +x_0=1153492.012 +y_0=1024195.255 +h_0=1500 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1450535828408815e6,
      1.0204799935875341e6,
      1.1594777230663965e6,
      1.0304345048253794e6
    ]
  },
  "EPSG:6264": {
    proj4: "+proj=col_urban +lat_0=2.45615988333333 +lon_0=-76.6060916361111 +x_0=1052430.525 +y_0=763366.548 +h_0=1740 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0475456304042523e6,
      758261.0365978801,
      1058670463053867e-9,
      767109.6219756003
    ]
  },
  "EPSG:6265": {
    proj4: "+proj=col_urban +lat_0=6.18072141388889 +lon_0=-67.5007502472222 +x_0=1063834.703 +y_0=1175257.481 +h_0=51.58 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0417740406113156e6,
      1.1530642230491503e6,
      1.0738764521910008e6,
      1.1884491230245875e6
    ]
  },
  "EPSG:6266": {
    proj4: "+proj=col_urban +lat_0=5.69424766111111 +lon_0=-76.6507538583333 +x_0=1047273.617 +y_0=1121443.09 +h_0=44 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0451415074453802e6,
      1.1176558145203216e6,
      1.0495725148404618e6,
      1.1242909788261016e6
    ]
  },
  "EPSG:6267": {
    proj4: "+proj=col_urban +lat_0=11.5369133277778 +lon_0=-72.9027688694444 +x_0=1128154.73 +y_0=1767887.914 +h_0=6 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1219090953082477e6,
      1.7549557250808857e6,
      1135000832604148e-9,
      1772654860238299e-9
    ]
  },
  "EPSG:6268": {
    proj4: "+proj=col_urban +lat_0=12.523794325 +lon_0=-81.72937595 +x_0=820439.298 +y_0=1877357.828 +h_0=6 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      810586.0083583266,
      1.8669833700292462e6,
      834494.0370675623,
      1891322973368837e-9
    ]
  },
  "EPSG:6269": {
    proj4: "+proj=col_urban +lat_0=2.56407894166667 +lon_0=-72.640033325 +x_0=1159876.62 +y_0=775380.342 +h_0=185 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1576560446279412e6,
      772717.7165158223,
      1.1643286463858495e6,
      780458.3496685909
    ]
  },
  "EPSG:6270": {
    proj4: "+proj=col_urban +lat_0=11.2196430555556 +lon_0=-74.2250052777778 +x_0=983892.409 +y_0=1732533.518 +h_0=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      982254.5551283844,
      1.7259360339586295e6,
      994264.7101836507,
      1.7414240212150367e6
    ]
  },
  "EPSG:6271": {
    proj4: "+proj=col_urban +lat_0=8.81055036666667 +lon_0=-74.722466825 +x_0=929043.607 +y_0=1466125.658 +h_0=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      927114.5896275807,
      1.4638528187035369e6,
      932615.2554650782,
      1.4682769556414485e6
    ]
  },
  "EPSG:6272": {
    proj4: "+proj=col_urban +lat_0=5.53419473888889 +lon_0=-73.3519389 +x_0=1080514.91 +y_0=1103772.028 +h_0=2800 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0762954926318633e6,
      1.0999890804524526e6,
      1.0862717391885414e6,
      1.1121588788895372e6
    ]
  },
  "EPSG:6273": {
    proj4: "+proj=col_urban +lat_0=10.4472611111111 +lon_0=-73.2465713888889 +x_0=1090979.66 +y_0=1647208.93 +h_0=200 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0851287175507986e6,
      1.6408755278830358e6,
      1.0971723894749265e6,
      1.6541493016077941e6
    ]
  },
  "EPSG:6274": {
    proj4: "+proj=col_urban +lat_0=4.1553751 +lon_0=-73.6244859861111 +x_0=1050678.757 +y_0=950952.124 +h_0=427.19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0434035527523734e6,
      941511.0012640031,
      1057838542768242e-9,
      956993.2504502091
    ]
  },
  "EPSG:6275": {
    proj4: "+proj=col_urban +lat_0=5.35392722222222 +lon_0=-72.4200402777778 +x_0=851184.177 +y_0=1083954.137 +h_0=300 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      850080.1224128043,
      1.0779903786963248e6,
      858947.3981986261,
      1.0857320550413365e6
    ]
  },
  "EPSG:6307": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      36907.96076240871,
      177072.36487476467,
      403024.65399685316,
      282602.55471139686
    ]
  },
  "EPSG:6309": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4.4479144587986395e6,
      2.8010012228442747e6,
      4263665691091228e-9,
      2.9468007022935664e6
    ]
  },
  "EPSG:6310": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.2, 34.59, 34.65, 35.74]
  },
  "EPSG:6311": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.2, 34.59, 34.65, 35.74]
  },
  "EPSG:6312": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      126609.87774520974,
      329208.22487068037,
      349256.0290086116,
      457751.64988159714
    ]
  },
  "EPSG:6316": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      7373537291475585e-9,
      452409148850934e-8,
      7616542241886739e-9,
      5117281889146208e-9
    ]
  },
  "EPSG:6317": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6021823892127135e-9,
      1.3184758432680832e6,
      742797.5508297635,
      -1.5148997474609122e6
    ]
  },
  "EPSG:6318": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:6319": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:6320": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5618535567829044e-9,
      2330720982291132e-9,
      -4757834895202337e-9,
      -2.6080773519419767e6
    ]
  },
  "EPSG:6321": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [157.47, -17.56, -151.27, 31.8]
  },
  "EPSG:6322": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [157.47, -17.56, -151.27, 31.8]
  },
  "EPSG:6323": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4053625832510513e-9,
      4920940111341359e-9,
      -5029708742622028e-9,
      2.9568157006459604e6
    ]
  },
  "EPSG:6324": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [129.48, 1.64, 149.55, 23.9]
  },
  "EPSG:6325": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [129.48, 1.64, 149.55, 23.9]
  },
  "EPSG:6328": {
    proj4: "+proj=utm +zone=59 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      255040.97594940502,
      5433975758357479e-9,
      686334.7381179817,
      6241316103447333e-9
    ]
  },
  "EPSG:6329": {
    proj4: "+proj=utm +zone=60 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275878.0522029962,
      5311765433025767e-9,
      683820.3879196523,
      6284675176375143e-9
    ]
  },
  "EPSG:6330": {
    proj4: "+proj=utm +zone=1 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275705.2007711646,
      5307320288937037e-9,
      651326.6101829188,
      7012536575907362e-9
    ]
  },
  "EPSG:6331": {
    proj4: "+proj=utm +zone=2 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      279095.5340691147,
      5394004676025433e-9,
      597909.7820209023,
      8108518214682238e-9
    ]
  },
  "EPSG:6332": {
    proj4: "+proj=utm +zone=3 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282881.3113258418,
      5489589711728697e-9,
      590937.4580819238,
      8246692023643711e-9
    ]
  },
  "EPSG:6333": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      289420.59814113064,
      5651885738696898e-9,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:6334": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      294760.555044646,
      5781966310022121e-9,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:6335": {
    proj4: "+proj=utm +zone=6 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      303614.943130552,
      599324839556645e-8,
      591839.6077320275,
      8228862484656331e-9
    ]
  },
  "EPSG:6336": {
    proj4: "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      300888.49477118085,
      5928746531703682e-9,
      594878.9639862768,
      8168689220963358e-9
    ]
  },
  "EPSG:6337": {
    proj4: "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      301497.8173291563,
      5943203448548857e-9,
      597965.8260328542,
      8107403958493016e-9
    ]
  },
  "EPSG:6338": {
    proj4: "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227475.2739848646,
      3919318118925639e-9,
      682991.4437860795,
      6303587686966957e-9
    ]
  },
  "EPSG:6339": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212172.22206675174,
      3382455381866777e-9,
      719747.7478332217,
      5441824852507818e-9
    ]
  },
  "EPSG:6340": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213181.34452594037,
      3.4201591228960655e6,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:6341": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214532.47558561602,
      3470063347430235e-9,
      719369.7373790785,
      5432904306382319e-9
    ]
  },
  "EPSG:6342": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207672.60560265684,
      3209479925667875e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:6343": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199250.35388242255,
      2860290264055177e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "EPSG:6344": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197690.84663826128,
      2835929428023703e-9,
      717738.3550121312,
      5474028648072391e-9
    ]
  },
  "EPSG:6345": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194701.98624121048,
      2654154227656937e-9,
      722387.4042487555,
      5356218117683916e-9
    ]
  },
  "EPSG:6346": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194325.66756335914,
      2.6364238174826605e6,
      731748.2606832965,
      5112867417055887e-9
    ]
  },
  "EPSG:6347": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      205723.7692717061,
      3131872261800517e-9,
      736322.492924318,
      4990662135233918e-9
    ]
  },
  "EPSG:6348": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221647.2089282641,
      3.7229509105618917e6,
      726813.6466742919,
      5261788015335406e-9
    ]
  },
  "EPSG:6349": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-168.26, 24.41, -66.91, 71.4]
  },
  "EPSG:6350": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      598769.8229192615,
      2.1091213560858895e6,
      3.2552747939838283e6
    ]
  },
  "EPSG:6351": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-163 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29110597003017824e-9,
      5250709876204114e-9,
      2979702902747949e-8,
      580201075079501e-8
    ]
  },
  "EPSG:6352": {
    proj4: "+proj=lcc +lat_0=72.0250091944445 +lon_0=-147 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31110597003017824e-9,
      5250709876204114e-9,
      31797029027479485e-9,
      580201075079501e-8
    ]
  },
  "EPSG:6353": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-165 +lat_1=70.3333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14095158421761535e-9,
      6247821613101342e-9,
      14823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6354": {
    proj4: "+proj=lcc +lat_0=68.6874755555556 +lon_0=-147 +lat_1=70.3333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16095158421761535e-9,
      6247821613101342e-9,
      16823363082473807e-9,
      6.8006272692875685e6
    ]
  },
  "EPSG:6355": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "EPSG:6356": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      505580.44594500464,
      15923.948440411992,
      709514.5981036696,
      557319.3872848145
    ]
  },
  "EPSG:6357": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6358": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:6359": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:6360": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:6362": {
    proj4: "+proj=lcc +lat_0=12 +lon_0=-102 +lat_1=17.5 +lat_2=29.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      278545.2095324695,
      167841.85207784953,
      4135966060568382e-9,
      2394099948216628e-9
    ]
  },
  "EPSG:6363": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.3228161328105684e6,
      -5278585393329643e-9,
      501752.82453685993,
      -534783698604474e-8
    ]
  },
  "EPSG:6364": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, 12.1, -84.64, 32.72]
  },
  "EPSG:6365": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, 12.1, -84.64, 32.72]
  },
  "EPSG:6366": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -58603.97078634275,
      1.6659974578202576e6,
      781183.1502370356,
      3624228096601195e-9
    ]
  },
  "EPSG:6367": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177484.6212754076,
      1670480022141903e-9,
      782588.4274016112,
      3.5743159534130353e6
    ]
  },
  "EPSG:6368": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175966.32469811483,
      1.5553168965950068e6,
      784068.1618622246,
      3521079182476001e-9
    ]
  },
  "EPSG:6369": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      173651.79368814215,
      1.3615487184263577e6,
      789960.1323065503,
      3.3015080496930014e6
    ]
  },
  "EPSG:6370": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      173406.5462399603,
      1.3394049705963186e6,
      800318.0748014629,
      2879132533539659e-9
    ]
  },
  "EPSG:6371": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181954.8123379539,
      1971713271934229e-9,
      736683.2282941658,
      2.8523332125410233e6
    ]
  },
  "EPSG:6372": {
    proj4: "+proj=lcc +lat_0=12 +lon_0=-102 +lat_1=17.5 +lat_2=29.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      278545.2095324695,
      167841.85207784953,
      4135966060568382e-9,
      2394099948216628e-9
    ]
  },
  "EPSG:6381": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      385421.14209891815,
      5345847420513572e-9,
      409801.7359992588,
      5428583463284795e-9
    ]
  },
  "EPSG:6382": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      187435.39360732707,
      528736641108538e-8,
      403107.70870976866,
      5760057096216361e-9
    ]
  },
  "EPSG:6383": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      182263.9985563503,
      501502253369315e-8,
      403153.59360218444,
      5757831912917792e-9
    ]
  },
  "EPSG:6384": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      178522.1075930912,
      4810558544709047e-9,
      402740.17357360874,
      5777858817493004e-9
    ]
  },
  "EPSG:6385": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      178043.24209931435,
      4783893867844882e-9,
      402141.20554289484,
      5806787579808331e-9
    ]
  },
  "EPSG:6386": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      178162.7570939854,
      4790559938977928e-9,
      404728.81664106157,
      5681067435166742e-9
    ]
  },
  "EPSG:6387": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      185426.2393415356,
      5182862385756603e-9,
      383914.93224117125,
      5584991760906148e-9
    ]
  },
  "EPSG:6391": {
    proj4: "+proj=lcc +lat_0=19.3333333333333 +lon_0=-80.5666666666667 +lat_1=19.3333333333333 +lat_2=19.7 +x_0=899160 +y_0=579120 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.8930420645683424e6,
      1.2725087345561034e6,
      3.5813639679095754e6,
      2392539679679657e-9
    ]
  },
  "EPSG:6393": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2257390058712074e-9,
      726720.2472649922,
      858192.2020793316,
      2534628449266282e-9
    ]
  },
  "EPSG:6394": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345065.0006292928,
      334042.20469821244,
      1.0216737568623158e6,
      954041.2679213481
    ]
  },
  "EPSG:6395": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386918.31041990273,
      638611.495563188,
      538646.0751082397,
      1.8010582813575123e6
    ]
  },
  "EPSG:6396": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      387480.7933152069,
      638594.4905497337,
      574961.5237298968,
      1.8265091488610085e6
    ]
  },
  "EPSG:6397": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384866.0062102319,
      570683.0524052249,
      574413.9786087219,
      1.8543974615086422e6
    ]
  },
  "EPSG:6398": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374335.66296567384,
      193265.41672186597,
      576665.1462954525,
      1927037849194219e-9
    ]
  },
  "EPSG:6399": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      371683.47061143327,
      100891.27017918504,
      571564.5392518891,
      1.9402596195834302e6
    ]
  },
  "EPSG:6400": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      369227.2759588344,
      37478.56021629183,
      573639.6586334868,
      1866650932337704e-9
    ]
  },
  "EPSG:6401": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      353035.9059764714,
      40196.47731406788,
      579818.6224001455,
      1678220016121422e-9
    ]
  },
  "EPSG:6402": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      305398.63289577013,
      281655.18765712064,
      591427.5708482452,
      1.3181762713116712e6
    ]
  },
  "EPSG:6403": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195688.3999031469,
      98298.29792074177,
      1.7230791763698556e6,
      427904.9014095053
    ]
  },
  "EPSG:6404": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76951.28315104556,
      37471.49767701424,
      344774.25509364414,
      667599.2730779602
    ]
  },
  "EPSG:6405": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "EPSG:6406": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66481.57726905748,
      37612.94225911591,
      313625.1177186511,
      667173.219860401
    ]
  },
  "EPSG:6407": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "EPSG:6408": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113255.82314843503,
      116906.13012893949,
      322839.39768852945,
      666199.5535385566
    ]
  },
  "EPSG:6409": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2229279364,
      383550.2956986203,
      1.0591843756185349e6,
      2185694073289227e-9
    ]
  },
  "EPSG:6410": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      159882.1517288231,
      40546.019450230866,
      611428.2003751276,
      242921.67605554135
    ]
  },
  "EPSG:6411": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927636474,
      133024.73214629912,
      2.0059940206973983e6,
      796985.532192222
    ]
  },
  "EPSG:6412": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      168267.01668838607,
      440888.471984403,
      545890.5412777681,
      671045.3781161602
    ]
  },
  "EPSG:6413": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372184801,
      1.4464815951354958e6,
      1.7909758841421446e6,
      2201588044669436e-9
    ]
  },
  "EPSG:6414": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -418604.90866352344,
      -599248.9206782463,
      487730.49001781485,
      458666.85968259815
    ]
  },
  "EPSG:6415": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7895395665343686e6,
      531443.8371340163,
      216650689441652e-8,
      799143.9865565519
    ]
  },
  "EPSG:6416": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061538175e-9,
      1743578655997185e-9,
      7107948036431532e-9,
      2621858229560954e-9
    ]
  },
  "EPSG:6417": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8191142581414783e6,
      541273.7589847766,
      2.2095712464330723e6,
      779630.525372654
    ]
  },
  "EPSG:6418": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695585834e-9,
      1.7758289912692206e6,
      7249234998005839e-9,
      2557837815660115e-9
    ]
  },
  "EPSG:6419": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1774907679626609e-9,
      528557.1371854008,
      2.2322182534678923e6,
      748597.178483144
    ]
  },
  "EPSG:6420": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5823176279241634e-9,
      1.7341078745824352e6,
      7323536053585911e-9,
      2456022576740115e-9
    ]
  },
  "EPSG:6421": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1727886776452719e-9,
      553828.3138820408,
      2298520922247323e-9,
      754562.841666431
    ]
  },
  "EPSG:6422": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532745296e-9,
      1.8170183934613287e6,
      7541064059406428e-9,
      2.4755949233672824e6
    ]
  },
  "EPSG:6423": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6794231645368338e6,
      423356.5291107174,
      2350617831343431e-9,
      763023.8066438821
    ]
  },
  "EPSG:6424": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907499317929e-9,
      1.3889622129240783e6,
      7711985335332574e-9,
      2.5033539392974693e6
    ]
  },
  "EPSG:6425": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8215040867444675e6,
      541921.609051466,
      2168903381623939e-9,
      713685.2401208607
    ]
  },
  "EPSG:6426": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324927474e-9,
      1.7779544793630175e6,
      711581051154454e-8,
      2.3414823256298574e6
    ]
  },
  "EPSG:6427": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      602369.9938571034,
      344958.28088118456,
      1.2094300492099929e6,
      560943.6928306813
    ]
  },
  "EPSG:6428": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755545300983e6,
      1.1317506265283525e6,
      3.9679384194670366e6,
      1.8403627655659935e6
    ]
  },
  "EPSG:6429": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      608530.8153568001,
      336108.1196154525,
      1.2054047088972987e6,
      496651.021459994
    ]
  },
  "EPSG:6430": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881830670196e6,
      1.1027147224423632e6,
      3.9547319487911398e6,
      1.6294292262439965e6
    ]
  },
  "EPSG:6431": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      597496.3981335191,
      345615.6716642405,
      1.2154220791101314e6,
      533836.9174519398
    ]
  },
  "EPSG:6432": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9602860992269719e6,
      1.1339074161224284e6,
      3.9875972708977414e6,
      1.7514299533442387e6
    ]
  },
  "EPSG:6433": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222322.54347837297,
      169156.3466800607,
      385103.12220492034,
      287977.4369607322
    ]
  },
  "EPSG:6434": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113992947,
      554973.7807348338,
      1.2634591601046422e6,
      944805.9744306704
    ]
  },
  "EPSG:6435": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166533.1617424154,
      48909.64130833831,
      238225.79702413955,
      205470.4830819298
    ]
  },
  "EPSG:6436": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.5484832405,
      160464.3815257733,
      781579.1360700305,
      674114.4099112981
    ]
  },
  "EPSG:6437": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      65102.24329868861,
      9138.495345549798,
      298540.2068111297,
      720329.5066960583
    ]
  },
  "EPSG:6438": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.61022244688,
      29981.8801461913,
      979460.662179514,
      2363281056551985e-9
    ]
  },
  "EPSG:6439": {
    proj4: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32031.289285340346,
      50838.306792611686,
      784566.8641495073,
      784246.4748000703
    ]
  },
  "EPSG:6440": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      295646.50247016025,
      27456.531402877317,
      834910.9831262925,
      225348.7609827654
    ]
  },
  "EPSG:6441": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "EPSG:6442": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66150.82424507887,
      215219.2456022235,
      284274.37357896275,
      583846.6255438706
    ]
  },
  "EPSG:6443": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.82954406223,
      706098.4749466283,
      932656.8409836462,
      1.9155034706385157e6
    ]
  },
  "EPSG:6444": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      74709.789308767,
      40624.309794496774,
      327985.22104999487,
      519815.2404935042
    ]
  },
  "EPSG:6445": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.36742384572,
      133281.58971744485,
      1.0760648463948576e6,
      1705427168185772e-9
    ]
  },
  "EPSG:6446": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      561618.6831736781,
      69612.78234582106,
      807394.5382984749,
      556166.0817971718
    ]
  },
  "EPSG:6447": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772960456433e6,
      228387.93674624796,
      2648926914067581e-9,
      1.8246882200295548e6
    ]
  },
  "EPSG:6448": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      392281.83037533704,
      36728.336945737465,
      602797.1348322467,
      448951.8476535554
    ]
  },
  "EPSG:6449": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1287011305489751e-9,
      120499.55212947368,
      1.9776769335287954e6,
      1472936186843373e-9
    ]
  },
  "EPSG:6450": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      111063.71939851393,
      36468.06030250205,
      289214.9223945835,
      343148.0611808968
    ]
  },
  "EPSG:6451": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.5530599571,
      119645.62784245881,
      948865.9582228954,
      1.1258115973909926e6
    ]
  },
  "EPSG:6452": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      676539.7837076162,
      36984.30998402688,
      904606.2381105269,
      817057.2289334119
    ]
  },
  "EPSG:6453": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2219614274047403e-9,
      121339.35700592819,
      2.9678622998676198e6,
      2.6806285919257025e6
    ]
  },
  "EPSG:6454": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215802.92024991306,
      44068.31688321397,
      407952.84533971857,
      648476.2402160055
    ]
  },
  "EPSG:6455": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "EPSG:6456": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      579509.9562219738,
      35625.98718209203,
      801631.300013067,
      649470.3402959756
    ]
  },
  "EPSG:6457": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755813382592e6,
      116882.92627991362,
      2630018690092871e-9,
      2.1308039414543803e6
    ]
  },
  "EPSG:6458": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18848.169675766898,
      300346.5557813935,
      173722.82933421258,
      724452.6023682763
    ]
  },
  "EPSG:6459": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70301124523,
      985386.9914261225,
      569955.6489073292,
      2.3768082459365875e6
    ]
  },
  "EPSG:6460": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      813951.5557038783,
      280415.4110952896,
      970119.8033495815,
      724416.3646416317
    ]
  },
  "EPSG:6461": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393956718077e6,
      919996.2275684634,
      3.1828013881560857e6,
      2.3766893559950874e6
    ]
  },
  "EPSG:6462": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2384564841177673e6,
      1043750404067701e-9,
      1.7708357650029673e6,
      1.2286439962682903e6
    ]
  },
  "EPSG:6463": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117312116e-9,
      5809817005680569e-9,
      403097617772355e-8
    ]
  },
  "EPSG:6464": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275804.31496850675,
      44490.99603974775,
      778150.4552814267,
      231925.01089940732
    ]
  },
  "EPSG:6465": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900591759,
      145967.54284040575,
      2.5529819520691475e6,
      760907.3065924722
    ]
  },
  "EPSG:6466": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      46038.237386999186,
      28658.252530809354,
      691948.0045848172,
      191653.8734461696
    ]
  },
  "EPSG:6467": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78379384667,
      94022.9501781637,
      2.2701660783420214e6,
      628784.4164646415
    ]
  },
  "EPSG:6468": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      84022.72728234128,
      441902.1544802367,
      738340.2719366557,
      652740.3625160322
    ]
  },
  "EPSG:6469": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.5643921482,
      1.4498073184572435e6,
      2.4223713754788456e6,
      2.1415323393213493e6
    ]
  },
  "EPSG:6470": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      349218.2791870525,
      24709.163041468903,
      653864.4011060491,
      184641.09895005127
    ]
  },
  "EPSG:6471": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269712995207e6,
      81066.64574521924,
      2145220122962096e-9,
      605776.6721386266
    ]
  },
  "EPSG:6472": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1577469491398442e6,
      1.0243945737160366e6,
      1.8284434576961924e6,
      1.3193168596829686e6
    ]
  },
  "EPSG:6473": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.7983747823029724e6,
      3.3608678636000315e6,
      5998818244124926e-9,
      4328458730143207e-9
    ]
  },
  "EPSG:6474": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      157793.0920864537,
      524305.3717931777,
      832918.8536462528,
      710531.6721022655
    ]
  },
  "EPSG:6475": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83662030625,
      1.7201585409581168e6,
      2.7326679393377476e6,
      2331135994555516e-9
    ]
  },
  "EPSG:6476": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      851729.3635550354,
      39868.512993891505,
      1153221324211875e-9,
      281692.5559034941
    ]
  },
  "EPSG:6477": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820868968125e6,
      130801.94638079239,
      3.7835269611517936e6,
      924186.3271600471
    ]
  },
  "EPSG:6478": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      745633.3912495468,
      41691.410611282045,
      1246542614779638e-9,
      287665.49443279085
    ]
  },
  "EPSG:6479": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2446298884424555e-9,
      136782.5696471812,
      4.0896985619561956e6,
      943782.5429849147
    ]
  },
  "EPSG:6480": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427110.6227171908,
      28173.763208158933,
      559930.8874513158,
      441528.35357238876
    ]
  },
  "EPSG:6481": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      643626.9498361305,
      38759.89775611995,
      772884.0925903314,
      393521.3588579671
    ]
  },
  "EPSG:6482": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      241765.49550198903,
      26539.33912282469,
      358635.93205308926,
      416628.2804443663
    ]
  },
  "EPSG:6483": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177049.16196835245,
      24838.65270351215,
      419851.20673729526,
      423896.7865970171
    ]
  },
  "EPSG:6484": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "EPSG:6485": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      824761.6428981957,
      23371.92855680277,
      969493.4665432682,
      416737.78627018543
    ]
  },
  "EPSG:6486": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490075164e-9,
      76679.40227344376,
      3180746481484039e-9,
      1.3672472204547669e6
    ]
  },
  "EPSG:6487": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181219.09721396962,
      36655.85913985907,
      574026.6173549057,
      230987.04872253875
    ]
  },
  "EPSG:6488": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6544428327,
      120261.76452802098,
      1.8832856601052207e6,
      757830.009017196
    ]
  },
  "EPSG:6489": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465603.8085218641,
      21182.19390165996,
      550924.4533078014,
      56819.46303831281
    ]
  },
  "EPSG:6490": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5275684954588155e6,
      69495.24782569606,
      1.8074913108940115e6,
      186415.18831819796
    ]
  },
  "EPSG:6491": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32912.32927433509,
      803051.4395878355,
      333962.18491762364,
      961218.4864862445
    ]
  },
  "EPSG:6492": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86729421368,
      2.6346779313810905e6,
      1095674268683903e-9,
      3.1535976510802875e6
    ]
  },
  "EPSG:6493": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5783269683611322e-9,
      57309.82074061751,
      6162640001784503e-9,
      291399.94080042426
    ]
  },
  "EPSG:6494": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901533205e-9,
      188024.34626186846,
      20218635176379602e-9,
      956036.5511824941
    ]
  },
  "EPSG:6495": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7730770077384338e-9,
      38783.29196926807,
      8264072881829599e-9,
      399102.5058484581
    ]
  },
  "EPSG:6496": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      25363418888951235e-9,
      127241.77155271676,
      2711310000589763e-8,
      1.3093914233873296e6
    ]
  },
  "EPSG:6497": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      131754.1460535056,
      135994.88864500355,
      786822.1064603678,
      870498.7798355976
    ]
  },
  "EPSG:6498": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3764135981418406e-9,
      25074.8909276311,
      4178741346471115e-9,
      304539.3832952072
    ]
  },
  "EPSG:6499": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498039389e-9,
      82266.70251847472,
      13709781320390796e-9,
      999144.9583176089
    ]
  },
  "EPSG:6500": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      595233.1859048485,
      134496.0658554411,
      947732.4888004595,
      377495.16347312875
    ]
  },
  "EPSG:6501": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774561575e6,
      441259.17602739297,
      3.1093523403728413e6,
      1.2384987154614236e6
    ]
  },
  "EPSG:6502": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      484662.883379609,
      123970.60197833316,
      1.0621099971384865e6,
      426349.3882135941
    ]
  },
  "EPSG:6503": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432546007e6,
      406726.88329058146,
      3.4846058823118517e6,
      1.3987812844641001e6
    ]
  },
  "EPSG:6504": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      569492.5128116711,
      158465.4349358629,
      1.0176934793720534e6,
      391514.8607947015
    ]
  },
  "EPSG:6505": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8684100191496245e6,
      519898.6810854104,
      3.3388826902731457e6,
      1.2844950057572832e6
    ]
  },
  "EPSG:6506": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      190340.12052613805,
      57073.9038946292,
      367846.54652006144,
      611234.9881211288
    ]
  },
  "EPSG:6507": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "EPSG:6508": {
    proj4: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      316708.0593904875,
      1.0254902162416982e6,
      651501.9999229677,
      157961726758018e-8
    ]
  },
  "EPSG:6509": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      574253.7728630524,
      167020.95974745313,
      787927.2680533797,
      611406.5844740515
    ]
  },
  "EPSG:6510": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1884030919468199e-9,
      547967.9321047692,
      2585058044938464e-9,
      2005923102561951e-9
    ]
  },
  "EPSG:6511": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384402.582974351,
      72524.35270280449,
      592240.4863549052,
      530749.7674890533
    ]
  },
  "EPSG:6512": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      117430.21416727672,
      17271.89955836394,
      368474.73767414974,
      531120.8788109587
    ]
  },
  "EPSG:6513": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857344828,
      35516.95357112248,
      936343.0942781423,
      491477.91794944176
    ]
  },
  "EPSG:6514": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76530.54027482809,
      33084.524119235604,
      999117.0470033675,
      542896.2532425779
    ]
  },
  "EPSG:6515": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497126905,
      108545.02663791207,
      3.2779430675884755e6,
      1781155686491397e-9
    ]
  },
  "EPSG:6516": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153376.2252400727,
      25535.919165928193,
      882993.4575054274,
      363144.7550580989
    ]
  },
  "EPSG:6518": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      362659.33828742534,
      6139743768849751e-9,
      641055.3972230253,
      6694999823411577e-9
    ]
  },
  "EPSG:6519": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845731328e-9,
      20143476014967892e-9,
      2103195915755876e-9,
      21965178587309487e-9
    ]
  },
  "EPSG:6520": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69754.74639531817,
      802755247237993e-8,
      328683.6587060269,
      880586542636728e-8
    ]
  },
  "EPSG:6521": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69716530634,
      26337061736499824e-9,
      1.0783563036380236e6,
      2889057681970665e-8
    ]
  },
  "EPSG:6522": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      673826.6301758505,
      4245017139322905e-9,
      931997.4907157569,
      4.8059263308652975e6
    ]
  },
  "EPSG:6523": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128692019363e6,
      13927193731228566e-9,
      3057728434156613e-9,
      15767443303813899e-9
    ]
  },
  "EPSG:6524": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226793.8024079331,
      21492.387739553997,
      381293.173427484,
      312732.6717501454
    ]
  },
  "EPSG:6525": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6667333606,
      70512.94210885341,
      1.2509593531533373e6,
      1.0260237739002687e6
    ]
  },
  "EPSG:6526": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      54545.12015456795,
      4645.126015017602,
      201873.90102511132,
      280709.69043490384
    ]
  },
  "EPSG:6527": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "EPSG:6528": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      359824.2791681125,
      87428.3980117214,
      625497.4318649578,
      666399.5233026792
    ]
  },
  "EPSG:6529": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234895707152e6,
      286838.0024767893,
      2.0521528247102818e6,
      2.1863457693688734e6
    ]
  },
  "EPSG:6530": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33975.77074362352,
      111708.32825589125,
      284564.5241670381,
      666319.758960204
    ]
  },
  "EPSG:6531": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84118137152,
      366496.4069528699,
      933608.7763713576,
      2.1860840758552696e6
    ]
  },
  "EPSG:6532": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      713259.0787200994,
      37234.66266182869,
      964697.4631390541,
      666551.8767344605
    ]
  },
  "EPSG:6533": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2340084161100859e-9,
      122160.72241634964,
      3.1650115939820465e6,
      2186845615586309e-9
    ]
  },
  "EPSG:6534": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153330.97415895032,
      221641.78111359302,
      372921.93601385155,
      490979.04527605977
    ]
  },
  "EPSG:6535": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37071982364,
      727169.7435368465,
      1223494718072112e-9,
      1610820417709873e-9
    ]
  },
  "EPSG:6536": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34535.94492432893,
      228126.12062753108,
      250090.6353354547,
      687881.3551997013
    ]
  },
  "EPSG:6537": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "EPSG:6538": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277950.22920969536,
      33716.39444708275,
      484240.9609220226,
      128170.64580043124
    ]
  },
  "EPSG:6539": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.870781804,
      1.5887138859583358e6,
      420506.5270969149
    ]
  },
  "EPSG:6540": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251673.76576198317,
      221664.55284669463,
      448704.434264811,
      404996.19022632844
    ]
  },
  "EPSG:6541": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6801707726,
      727244.453797864,
      1.4721244650838003e6,
      1328725000767546e-9
    ]
  },
  "EPSG:6542": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      116361.13496227108,
      22119.88887843388,
      933520.6710072559,
      320979.26197346306
    ]
  },
  "EPSG:6543": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "EPSG:6544": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329319.5931117032,
      22953.606831219873,
      868402.9550716814,
      229887.8527663513
    ]
  },
  "EPSG:6545": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592824906e6,
      75307.10902631191,
      2849091059938587e-9,
      754225.2387347483
    ]
  },
  "EPSG:6546": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324736.07413660234,
      35492.61573469327,
      895638.4324845031,
      247922.52117242807
    ]
  },
  "EPSG:6547": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      106540706736943e-8,
      116445.58968075218,
      2938446300794301e-9,
      813394.0983347377
    ]
  },
  "EPSG:6548": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403035.4105968764,
      50729.9881009595,
      764034.121937581,
      297653.7686659716
    ]
  },
  "EPSG:6549": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999187e6,
      166436.6359612313,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "EPSG:6550": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      396472.80539090245,
      47032.74485349966,
      752900.9644348032,
      263532.0000815143
    ]
  },
  "EPSG:6551": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "EPSG:6552": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      145234.1114682252,
      41670.65752654181,
      918564.8787926256,
      228901.9813547924
    ]
  },
  "EPSG:6553": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.48223499593,
      3.0136582731721397e6,
      750989.2504948481
    ]
  },
  "EPSG:6554": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      414409.71996951895,
      33637.59674371423,
      924488.3684600198,
      253870.04933969502
    ]
  },
  "EPSG:6555": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3033092255522582e-9,
      832905.3202086495
    ]
  },
  "EPSG:6556": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60163.86735144921,
      34049.00237979901,
      710705.1662058923,
      508757.95951940055
    ]
  },
  "EPSG:6557": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      197388.0162396627,
      111709.32539304135,
      2.3317098628749745e6,
      1.6691534104967208e6
    ]
  },
  "EPSG:6558": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546260644754e-8,
      38177.19394785736,
      2.8106066110863457e6,
      295944.2058068297
    ]
  },
  "EPSG:6559": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:6560": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1160304687469061e-9,
      43124.56959847481,
      1785979111173056e-9,
      327582.564817976
    ]
  },
  "EPSG:6561": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:6562": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364722.69794594496,
      51900.29667448759,
      850571.8392683543,
      266893.21477785433
    ]
  },
  "EPSG:6563": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2.7905844426662596e6,
      875632.1554836772
    ]
  },
  "EPSG:6564": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      361633.13518682023,
      45575.569319858565,
      854195.2283628277,
      209415.98457540976
    ]
  },
  "EPSG:6565": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.847010236,
      2802472178387044e-9,
      687058.9427278236
    ]
  },
  "EPSG:6566": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      36907.96076240871,
      177072.36487476467,
      403024.65399685316,
      282602.55471139686
    ]
  },
  "EPSG:6567": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70610.77827680032,
      5241.624167031077,
      134786.23705289746,
      104115.19509468034
    ]
  },
  "EPSG:6568": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19502980247,
      17196.895288001127,
      442211.17936438107,
      341584.60257313045
    ]
  },
  "EPSG:6569": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386694.5942843487,
      26576.309440707257,
      835428.2312511974,
      377206.79542095796
    ]
  },
  "EPSG:6570": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "EPSG:6571": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      274445.55115673057,
      42263.33611194055,
      875171.275386896,
      241258.5494374619
    ]
  },
  "EPSG:6572": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392498,
      2871291092665175e-9,
      791529.090946073
    ]
  },
  "EPSG:6573": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      293645.5414990948,
      23168.18099115532,
      908809.9399088017,
      280198.16460002324
    ]
  },
  "EPSG:6574": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848209,
      2.9816539445174607e6,
      919283.4783585763
    ]
  },
  "EPSG:6575": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206556.4167882325,
      80414.01570951591,
      988711.5866813468,
      269011.42753063503
    ]
  },
  "EPSG:6576": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3.2437979306370523e6,
      882581.6584900919
    ]
  },
  "EPSG:6577": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      88485.92409938853,
      302995849409869e-8,
      1.3434805489688965e6,
      3308389707573836e-9
    ]
  },
  "EPSG:6578": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5689827447,
      9940788826055452e-9,
      4407735767408789e-9,
      10854275232265161e-9
    ]
  },
  "EPSG:6579": {
    proj4: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831192.2778944278,
      6877890180217122e-9,
      2.0832733485623298e6,
      8058739531869909e-9
    ]
  },
  "EPSG:6580": {
    proj4: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      831139.3452904851,
      589725675084688e-8,
      2083223989295547e-9,
      7076453726029536e-9
    ]
  },
  "EPSG:6581": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      59141.726237106894,
      1.0343726299247856e6,
      335289.3759396124,
      1.2783945558126816e6
    ]
  },
  "EPSG:6582": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.14716290752,
      3.3936042030115686e6,
      1.1000285612285445e6,
      4.1941994715287737e6
    ]
  },
  "EPSG:6583": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166935.12352544628,
      2015335542194466e-9,
      1.0128529570071837e6,
      2.3319457757578273e6
    ]
  },
  "EPSG:6584": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980025016344e-9,
      3323001743114402e-9,
      7650725432965473e-9
    ]
  },
  "EPSG:6585": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      129543.46292791484,
      5019245231079103e-9,
      461995.7043444619,
      5282860637212539e-9
    ]
  },
  "EPSG:6586": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062632026e-9,
      1.5157309066701222e6,
      17332185274254806e-9
    ]
  },
  "EPSG:6587": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8759.288909710362,
      4.0092582172219283e6,
      1.1020569519511203e6,
      4.3256547587438645e6
    ]
  },
  "EPSG:6588": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.767031274747,
      13153708000668947e-9,
      3.6156651831929674e6,
      14191752320645498e-9
    ]
  },
  "EPSG:6589": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      423006.8382807577,
      24866.35169431841,
      578802.8666454776,
      281578.89655270055
    ]
  },
  "EPSG:6590": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1387814935292786e-9,
      81582.35551710967,
      1.8989557383527043e6,
      923813.4297733185
    ]
  },
  "EPSG:6591": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -374247.5203708042,
      68395.7536437515,
      360474.10643138486,
      392175.15701176226
    ]
  },
  "EPSG:6592": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3625533262610403e6,
      2.0126377358033953e6,
      3671261036751879e-9,
      2.2009270598530993e6
    ]
  },
  "EPSG:6593": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703824143e-8,
      660312897188164e-8,
      1204479558507679e-8,
      7220874862534711e-9
    ]
  },
  "EPSG:6594": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0363669807438697e6,
      1035658136976271e-9,
      3779083924305619e-9,
      1.2207621363122454e6
    ]
  },
  "EPSG:6595": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002990512e-9,
      3397821737396317e-9,
      12398544508659353e-9,
      4.0051171085510924e6
    ]
  },
  "EPSG:6596": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199622.13896693767,
      16618.325904665824,
      778655.8701648887,
      234845.72192574284
    ]
  },
  "EPSG:6597": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9679273608,
      54521.95757222446,
      2554640134365972e-9,
      770489.672684708
    ]
  },
  "EPSG:6598": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195499.3912097729,
      30501.042787402166,
      769845.025376511,
      259212.8282079461
    ]
  },
  "EPSG:6599": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9196607294,
      100068.83787833528,
      2525733221089436e-9,
      850434.0872122366
    ]
  },
  "EPSG:6600": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403574.77820059075,
      31335.654182597726,
      750577.3343822454,
      239088.0765441185
    ]
  },
  "EPSG:6601": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1324061584813105e-9,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "EPSG:6602": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      453513.4977037739,
      23502.170616556796,
      768516.5072083795,
      242635.52047372516
    ]
  },
  "EPSG:6603": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.70342088
    ]
  },
  "EPSG:6605": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205946,
      2.9246965143188736e6,
      739108.438997525
    ]
  },
  "EPSG:6606": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373644.5392621008,
      26717.932057823346,
      747455.7457836679,
      240055.50940082088
    ]
  },
  "EPSG:6607": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "EPSG:6608": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      482416.58582546015,
      54333.04951709173,
      843230.2890341961,
      263304.7487854953
    ]
  },
  "EPSG:6609": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.67995732513,
      2766498039939692e-9,
      863858.9966404126
    ]
  },
  "EPSG:6610": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282455.2023938304,
      227119.95484749787,
      803426.5861082915,
      766436.4349943912
    ]
  },
  "EPSG:6611": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      102113.10863394958,
      55062.47534181787,
      288024.8211402613,
      501582.3192299155
    ]
  },
  "EPSG:6612": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.0906098829,
      180650.80451728083,
      944961.4340576739,
      1645607992340148e-9
    ]
  },
  "EPSG:6613": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      290893.7234442881,
      155220.4817241857,
      505104.26743197144,
      601840.6136762074
    ]
  },
  "EPSG:6614": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243001354,
      509252.5304234326,
      1.6571629173663934e6,
      1.9745387466693572e6
    ]
  },
  "EPSG:6615": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      717820.1237859536,
      154870.05021642725,
      882729.2572612413,
      563723.8222876207
    ]
  },
  "EPSG:6616": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3550481894877497e6,
      508102.8230517286,
      2.8960875715645896e6,
      1.8494839069219697e6
    ]
  },
  "EPSG:6617": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      405623.04948556976,
      56981.50934947065,
      698535.2494466461,
      501735.86149144557
    ]
  },
  "EPSG:6618": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "EPSG:6619": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277517.6837629482,
      2.0205658722523483e6,
      706724.0386204798,
      2307801683101201e-9
    ]
  },
  "EPSG:6620": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284873.76674905524,
      1.0272050082885996e6,
      703762.8414941019,
      1189089125360079e-9
    ]
  },
  "EPSG:6621": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      273008.07224937936,
      3038980003301329e-9,
      714340.5503610092,
      3.2151793513247273e6
    ]
  },
  "EPSG:6622": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893275.4794730864,
      181371.95473245814,
      586959.5989478156,
      211279411729137e-8
    ]
  },
  "EPSG:6623": {
    proj4: "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893137.6882170163,
      179952.98248503017,
      587809.593610703,
      2.1248428734256476e6
    ]
  },
  "EPSG:6624": {
    proj4: "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893137.6882170163,
      179952.98248503017,
      587809.593610703,
      2.1248428734256476e6
    ]
  },
  "EPSG:6625": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2675122725,
      662913986591458e-8,
      2318643783407357e-9,
      7.5715126886745235e6
    ]
  },
  "EPSG:6626": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497758587,
      3.3700884313268475e6,
      2308928589168566e-9,
      3.9012032387521933e6
    ]
  },
  "EPSG:6627": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837381719,
      9970386894164445e-9,
      2343632289009411e-9,
      10548467588471211e-9
    ]
  },
  "EPSG:6628": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      436777.08375684114,
      4165.575750461832,
      579363.8665818895,
      165857.1024786704
    ]
  },
  "EPSG:6629": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427654.1631252822,
      13068.587207479659,
      576457.1208456453,
      102770.16729568072
    ]
  },
  "EPSG:6630": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465735.88276390824,
      3726.293434735615,
      540342.2667704654,
      64638.67443510627
    ]
  },
  "EPSG:6631": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      463810.4999186106,
      -2542.5573324230195,
      527823.5334422863,
      50591.56716225392
    ]
  },
  "EPSG:6632": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      486205.7939946483,
      7018.603270238967,
      518234.0339630389,
      44671.05923083076
    ]
  },
  "EPSG:6633": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1528001808734589e-9,
      12225.347710461765,
      1.7727729202627684e6,
      212068.71770917784
    ]
  },
  "EPSG:6634": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      363588.224686614,
      2157776289271998e-9,
      809130.2828161139,
      2467998025444025e-9
    ]
  },
  "EPSG:6635": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      183890.92296712555,
      2.0891216193225265e6,
      318974.86555910145,
      2.3076325822246308e6
    ]
  },
  "EPSG:6636": {
    proj4: "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      512925.15731334634,
      8387017607775072e-9,
      814222.9665084919,
      8438161672488501e-9
    ]
  },
  "EPSG:6637": {
    proj4: "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      81570.94872594497,
      164603.54114968982,
      128124.97912921364,
      222142.25314293997
    ]
  },
  "EPSG:6638": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6639": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6640": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6641": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6642": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6643": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6644": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6646": {
    proj4: "+proj=tmerc +lat_0=29.0262683333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      48403.39231815038,
      28394.20952315615,
      986757.1702386381,
      929105.188198151
    ]
  },
  "EPSG:6647": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6649": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:6650": {
    proj4: "+proj=utm +zone=7 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      499314.25966117124,
      5766599425710034e-9,
      600485.3252605255,
      8050561199050144e-9
    ]
  },
  "EPSG:6651": {
    proj4: "+proj=utm +zone=8 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      276483.89691439964,
      5327323615473784e-9,
      561466.0056721768,
      881843231451587e-8
    ]
  },
  "EPSG:6652": {
    proj4: "+proj=utm +zone=9 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      269894.2173448665,
      5156198868703588e-9,
      552774.1905777643,
      898675552561162e-8
    ]
  },
  "EPSG:6653": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      276787.3228804136,
      5335102810582594e-9,
      547749.0506840231,
      9083741173250612e-9
    ]
  },
  "EPSG:6654": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901135,
      5430681423873871e-9,
      537898.6633350778,
      9273261908761378e-9
    ]
  },
  "EPSG:6655": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:6656": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:6657": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      280542.34141901036,
      5430681423873871e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:6658": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      276353.9599205883,
      532398969591123e-8,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:6659": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      268167.7999873924,
      5110645349514422e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:6660": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      250254.16737771095,
      4617486815618051e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:6661": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      257982.5584520604,
      4835152983178707e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:6662": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      246917.18544612406,
      4520887054048674e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:6663": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      244050.00895109907,
      4436509744106726e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:6664": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      238596.64535791575,
      4272219139229722e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "EPSG:6665": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      242040.22836453855,
      4.3765623477354655e6,
      679019.5758874652,
      639370540243708e-8
    ]
  },
  "EPSG:6666": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.2658184677053094e6,
      5150079195754373e-9,
      -4101206603478336e-9,
      1.6862098943059877e6
    ]
  },
  "EPSG:6667": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.38, 17.09, 157.65, 46.05]
  },
  "EPSG:6668": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [122.38, 17.09, 157.65, 46.05]
  },
  "EPSG:6669": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -132049.50809238307,
      -668787.9965111837,
      87905.60739467604,
      193401.31124209717
    ]
  },
  "EPSG:6670": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -119419.18290007114,
      -311999.9676425828,
      97007.74237412079,
      110290.15565012966
    ]
  },
  "EPSG:6671": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -125737.06392055089,
      -252087.01766658467,
      118732.8549713948,
      42974.913619416235
    ]
  },
  "EPSG:6672": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -145349.82388383587,
      -33314.0838704339,
      120373.92844181918,
      161592.74679487603
    ]
  },
  "EPSG:6673": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -110992.00295443885,
      -206786.41253943156,
      102851.84721320926,
      -31578.584843732177
    ]
  },
  "EPSG:6674": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -106045.51424832072,
      -287821.7820397009,
      88881.12612888413,
      37068.76311181089
    ]
  },
  "EPSG:6675": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -86924.20137166914,
      -164885.0639883593,
      59470.62651639598,
      175534.08328598388
    ]
  },
  "EPSG:6676": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -108311.31609817347,
      -161331.87717495687,
      122852.53486351445,
      287250.6401937568
    ]
  },
  "EPSG:6677": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -139237.37425984908,
      -740986.5827938248,
      112154.28054505108,
      220482.4546000297
    ]
  },
  "EPSG:6678": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -118410.45564325571,
      -251124.64589962916,
      108957.53417588453,
      176265.86497031027
    ]
  },
  "EPSG:6679": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -76161.02776472867,
      -295060.56985245284,
      97980.50829603229,
      -63724.195556120096
    ]
  },
  "EPSG:6680": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112401.8523644654,
      -204608.41722348426,
      106208.88063008069,
      172018.66555383214
    ]
  },
  "EPSG:6681": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -136139.90274731265,
      -235300.560838289,
      129045.39378118758,
      45718.60856236123
    ]
  },
  "EPSG:6682": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -80968.06937713006,
      -147083.96782694227,
      32515.99943426242,
      199467.3347356876
    ]
  },
  "EPSG:6683": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -87081.0218032431,
      2505.5859933912316,
      89393.65205321205,
      101131.1656057617
    ]
  },
  "EPSG:6684": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -119061.6410094445,
      -223244.5998951997,
      152504.784614614,
      -116567.49353079096
    ]
  },
  "EPSG:6685": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      12170.964575906783,
      -177218.48155592856,
      38037.87865557607,
      1163.0856537163943
    ]
  },
  "EPSG:6686": {
    proj4: "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2087.7993220864046,
      40957.476010164195,
      16690.544009082074,
      53142.34550229258
    ]
  },
  "EPSG:6687": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9141.112772019294,
      -197156.09703477332,
      5073.227612596988,
      -182760.4635641074
    ]
  },
  "EPSG:6688": {
    proj4: "+proj=utm +zone=51 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      435606.2142612379,
      2333340405071788e-9,
      790248.5778711198,
      3.2904198819867927e6
    ]
  },
  "EPSG:6689": {
    proj4: "+proj=utm +zone=52 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188357.29562846932,
      2338370121015073e-9,
      761149.3376064628,
      4279988956497406e-9
    ]
  },
  "EPSG:6690": {
    proj4: "+proj=utm +zone=53 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      180701.57177046937,
      1891969490273159e-9,
      742338.515259152,
      4826267585702048e-9
    ]
  },
  "EPSG:6691": {
    proj4: "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181636.80059141235,
      1.9517769337818655e6,
      732083.8475862955,
      5103979180954936e-9
    ]
  },
  "EPSG:6692": {
    proj4: "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      192525.24287410482,
      2.5499918613784714e6,
      567010.3566700317,
      5055520921608147e-9
    ]
  },
  "EPSG:6693": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6694": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6695": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6696": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [129.3, 30.94, 145.87, 45.54]
  },
  "EPSG:6697": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [129.3, 30.94, 145.87, 45.54]
  },
  "EPSG:6700": {
    proj4: "+proj=longlat +ellps=bessel +vunits=m +no_defs +type=crs",
    projected_bounds: [139.7, 41.34, 145.87, 45.54]
  },
  "EPSG:6703": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-60 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      313519.3261514808,
      3762021193717231e-9,
      725907.8660301906,
      4714875962839477e-9
    ]
  },
  "EPSG:6704": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5217582481883848e-9,
      541945.9431942484,
      4112827887050154e-9,
      1.4153573282994651e6
    ]
  },
  "EPSG:6705": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "EPSG:6706": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "EPSG:6707": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226028.37041470746,
      4.0470930109668463e6,
      727899.151793387,
      5213977493738186e-9
    ]
  },
  "EPSG:6708": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225503.37015502725,
      3.8538577796685467e6,
      727643.3224890253,
      5220644504847022e-9
    ]
  },
  "EPSG:6709": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224488.26420493022,
      3850556815798412e-9,
      332597.54724696174,
      4611758561637851e-9
    ]
  },
  "EPSG:6720": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.000024 +x_0=50000 +y_0=1300000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34133.47289644515,
      124429.01582237729,
      65880.29440267988,
      154294.82687255717
    ]
  },
  "EPSG:6721": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34133.4548090295,
      124427.67574173049,
      65880.31250578944,
      154293.52083718148
    ]
  },
  "EPSG:6722": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=1 +x_0=50000 +y_0=1400000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      37488.789761339794,
      43044.554181879386,
      62534.78254158063,
      99462.09043911844
    ]
  },
  "EPSG:6723": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      37488.866455049305,
      143052.8723625047,
      62534.70570337218,
      199470.06277850596
    ]
  },
  "EPSG:6736": {
    proj4: "+proj=utm +zone=46 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      543982.7439616378,
      8290752981076046e-9,
      831369.1908562363,
      905138891255792e-8
    ]
  },
  "EPSG:6737": {
    proj4: "+proj=utm +zone=47 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      178205.5417423764,
      8277472621805217e-9,
      647505.8040450831,
      9063488224004656e-9
    ]
  },
  "EPSG:6738": {
    proj4: "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      218065.20305957436,
      6402392035948924e-9,
      735995.3593227603,
      7165412326919317e-9
    ]
  },
  "EPSG:6781": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6021823892127135e-9,
      1.3184758432680832e6,
      742797.5508297635,
      -1.5148997474609122e6
    ]
  },
  "EPSG:6782": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:6783": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -63.88, 74.71]
  },
  "EPSG:6784": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14854.699585220398,
      11162.86750174107,
      76417.24972968869,
      76795.57075756064
    ]
  },
  "EPSG:6785": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      48735.891027101046,
      36623.581042457576,
      250712.76157981856,
      251953.9723017081
    ]
  },
  "EPSG:6786": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14854.699585220398,
      11162.86750174107,
      76417.24972968869,
      76795.57075756064
    ]
  },
  "EPSG:6787": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      48735.891027101046,
      36623.581042457576,
      250712.76157981856,
      251953.9723017081
    ]
  },
  "EPSG:6788": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      21883.85132963674,
      14678.950000117302,
      158763.04936787195,
      238245.52965503332
    ]
  },
  "EPSG:6789": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      71797.41249775833,
      48159.28477728773,
      520876.1462190023,
      781645.4385007654
    ]
  },
  "EPSG:6790": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      21883.85132963674,
      14678.950000117302,
      158763.04936787195,
      238245.52965503332
    ]
  },
  "EPSG:6791": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      71797.41249775833,
      48159.28477728773,
      520876.1462190023,
      781645.4385007654
    ]
  },
  "EPSG:6792": {
    proj4: "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29254.97700202278,
      29434.314520759945,
      195165.79931933188,
      165856.0833673451
    ]
  },
  "EPSG:6793": {
    proj4: "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      95980.89567487789,
      96569.27341036727,
      640307.7405479391,
      544147.2551905022
    ]
  },
  "EPSG:6794": {
    proj4: "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29254.97700202278,
      29434.314520759945,
      195165.79931933188,
      165856.0833673451
    ]
  },
  "EPSG:6795": {
    proj4: "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      95980.89567487789,
      96569.27341036727,
      640307.7405479391,
      544147.2551905022
    ]
  },
  "EPSG:6796": {
    proj4: "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22674.444223732367,
      24402.77069568674,
      195854.4881883161,
      128597.65988954264
    ]
  },
  "EPSG:6797": {
    proj4: "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      74391.22120489622,
      80061.5836464788,
      642567.2184640293,
      421908.332970153
    ]
  },
  "EPSG:6798": {
    proj4: "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      22674.444223732367,
      24402.77069568674,
      195854.4881883161,
      128597.65988954264
    ]
  },
  "EPSG:6799": {
    proj4: "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      74391.22120489622,
      80061.5836464788,
      642567.2184640293,
      421908.332970153
    ]
  },
  "EPSG:6800": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -834.9179658430949,
      -991.3565773663869,
      113376.66796147636,
      82608.78251418086
    ]
  },
  "EPSG:6801": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2739.2321719261586,
      -3252.482209207306,
      371970.6954111429,
      271026.189350987
    ]
  },
  "EPSG:6802": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -834.9179658430949,
      -991.3565773663869,
      113376.66796147636,
      82608.78251418086
    ]
  },
  "EPSG:6803": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2739.2321719261586,
      -3252.482209207306,
      371970.6954111429,
      271026.189350987
    ]
  },
  "EPSG:6804": {
    proj4: "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28839.576684185784,
      11536.819815970957,
      274531.8994960776,
      77193.83804556233
    ]
  },
  "EPSG:6805": {
    proj4: "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      94618.03378879854,
      37850.458763421775,
      900695.2083684962,
      253260.623558669
    ]
  },
  "EPSG:6806": {
    proj4: "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28839.576684185784,
      11536.819815970957,
      274531.8994960776,
      77193.83804556233
    ]
  },
  "EPSG:6807": {
    proj4: "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      94618.03378879854,
      37850.458763421775,
      900695.2083684962,
      253260.623558669
    ]
  },
  "EPSG:6808": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000 +y_0=-3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      63738.10519403778,
      103553.89197477931,
      285622.1121990932,
      258313.231569116
    ]
  },
  "EPSG:6809": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      209114.51836127916,
      339743.74011410563,
      937080.4206088362,
      847484.3555810895
    ]
  },
  "EPSG:6810": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000 +y_0=-3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      63738.10519403778,
      103553.89197477931,
      285622.1121990932,
      258313.231569116
    ]
  },
  "EPSG:6811": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      209114.51836127916,
      339743.74011410563,
      937080.4206088362,
      847484.3555810895
    ]
  },
  "EPSG:6812": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1249.1720275594635,
      -1290.7253204628432,
      125011.68796891633,
      116710.52381394178
    ]
  },
  "EPSG:6813": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -4098.3333744076845,
      -4234.663124878094,
      410143.3332806966,
      382908.54269665934
    ]
  },
  "EPSG:6814": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1249.1720275594635,
      -1290.7253204628432,
      125011.68796891633,
      116710.52381394178
    ]
  },
  "EPSG:6815": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -4098.3333744076845,
      -4234.663124878094,
      410143.3332806966,
      382908.54269665934
    ]
  },
  "EPSG:6816": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4606.651820286919,
      14886.73836541571,
      122172.6097825754,
      116843.58581842438
    ]
  },
  "EPSG:6817": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      15113.68707338229,
      48841.00513587831,
      400828.77225149405,
      383345.0978294763
    ]
  },
  "EPSG:6818": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4606.651820286919,
      14886.73836541571,
      122172.6097825754,
      116843.58581842438
    ]
  },
  "EPSG:6819": {
    proj4: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      15113.68707338229,
      48841.00513587831,
      400828.77225149405,
      383345.0978294763
    ]
  },
  "EPSG:6820": {
    proj4: "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1019.3694156658239,
      -916.1295004419339,
      128188.19377981535,
      107147.3138049227
    ]
  },
  "EPSG:6821": {
    proj4: "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -3344.387797328815,
      -3005.6742140483393,
      420564.9402718351,
      351533.18177468074
    ]
  },
  "EPSG:6822": {
    proj4: "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1019.3694156658239,
      -916.1295004419339,
      128188.19377981535,
      107147.3138049227
    ]
  },
  "EPSG:6823": {
    proj4: "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -3344.387797328815,
      -3005.6742140483393,
      420564.9402718351,
      351533.18177468074
    ]
  },
  "EPSG:6824": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1189.4915589815719,
      14623.582786927142,
      128745.61202586352,
      122642.50957817292
    ]
  },
  "EPSG:6825": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -3902.531312144261,
      47977.633815377754,
      422393.7402916782,
      402370.4382485988
    ]
  },
  "EPSG:6826": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1189.4915589815719,
      14623.582786927142,
      128745.61202586352,
      122642.50957817292
    ]
  },
  "EPSG:6827": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -3902.531312144261,
      47977.633815377754,
      422393.7402916782,
      402370.4382485988
    ]
  },
  "EPSG:6828": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2380.410373652977,
      2227.2972483922763,
      61020.58409021115,
      61336.148863353505
    ]
  },
  "EPSG:6829": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7809.745370252545,
      7307.405670578333,
      200198.76675003656,
      201234.084197354
    ]
  },
  "EPSG:6830": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2380.410373652977,
      2227.2972483922763,
      61020.58409021115,
      61336.148863353505
    ]
  },
  "EPSG:6831": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7809.745370252545,
      7307.405670578333,
      200198.76675003656,
      201234.084197354
    ]
  },
  "EPSG:6832": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26624.64471343479,
      14463.237100653108,
      106866.67725566553,
      89283.01380625537
    ]
  },
  "EPSG:6833": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      87351.19656586218,
      47451.56529085665,
      350612.4581873541,
      292923.2736425701
    ]
  },
  "EPSG:6834": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26624.64471343479,
      14463.237100653108,
      106866.67725566553,
      89283.01380625537
    ]
  },
  "EPSG:6835": {
    proj4: "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      87351.19656586218,
      47451.56529085665,
      350612.4581873541,
      292923.2736425701
    ]
  },
  "EPSG:6836": {
    proj4: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7095.500215789143,
      18171.15373328912,
      103799.99574502361,
      155615.12011301634
    ]
  },
  "EPSG:6837": {
    proj4: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      23279.200181985387,
      59616.646106591594,
      340551.167141416,
      510548.29433404305
    ]
  },
  "EPSG:6838": {
    proj4: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7095.500215789143,
      18171.15373328912,
      103799.99574502361,
      155615.12011301634
    ]
  },
  "EPSG:6839": {
    proj4: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      23279.200181985387,
      59616.646106591594,
      340551.167141416,
      510548.29433404305
    ]
  },
  "EPSG:6840": {
    proj4: "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-300000 +y_0=-4600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69167.85157776944,
      51703.80195017718,
      188577.31053263642,
      552761.4042021912
    ]
  },
  "EPSG:6841": {
    proj4: "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      226928.6469126294,
      169631.89612236543,
      618691.963693689,
      1.8135216672903902e6
    ]
  },
  "EPSG:6842": {
    proj4: "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-300000 +y_0=-4600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69167.85157776944,
      51703.80195017718,
      188577.31053263642,
      552761.4042021912
    ]
  },
  "EPSG:6843": {
    proj4: "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      226928.6469126294,
      169631.89612236543,
      618691.963693689,
      1.8135216672903902e6
    ]
  },
  "EPSG:6844": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      44878.0652051619,
      23358.365127876685,
      137180.60698050098,
      86067.94205331198
    ]
  },
  "EPSG:6845": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      147237.7467353081,
      76635.05619382113,
      450067.60820295586,
      282375.1379701836
    ]
  },
  "EPSG:6846": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      44878.0652051619,
      23358.365127876685,
      137180.60698050098,
      86067.94205331198
    ]
  },
  "EPSG:6847": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      147237.7467353081,
      76635.05619382113,
      450067.60820295586,
      282375.1379701836
    ]
  },
  "EPSG:6848": {
    proj4: "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5870.822716829287,
      5232.918770007959,
      48974.59079068739,
      61906.92480303456
    ]
  },
  "EPSG:6849": {
    proj4: "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      19261.229435529156,
      17168.368668005114,
      160677.79135763575,
      203106.70867137323
    ]
  },
  "EPSG:6850": {
    proj4: "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5870.822716829287,
      5232.918770007959,
      48974.59079068739,
      61906.92480303456
    ]
  },
  "EPSG:6851": {
    proj4: "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      19261.229435529156,
      17168.368668005114,
      160677.79135763575,
      203106.70867137323
    ]
  },
  "EPSG:6852": {
    proj4: "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      38746.179869432715,
      20289.709660334112,
      149569.11753976095,
      106883.05398723757
    ]
  },
  "EPSG:6853": {
    proj4: "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.9999996 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      127120.01269367686,
      66567.28896120115,
      490712.3278850424,
      350666.1876715143
    ]
  },
  "EPSG:6854": {
    proj4: "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      38746.179869432715,
      20289.709660334112,
      149569.11753976095,
      106883.05398723757
    ]
  },
  "EPSG:6855": {
    proj4: "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.9999996 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      127120.01269367686,
      66567.28896120115,
      490712.3278850424,
      350666.1876715143
    ]
  },
  "EPSG:6856": {
    proj4: "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1587.636007417168,
      -1278.1959950079868,
      143599.13374220382,
      108117.87859025152
    ]
  },
  "EPSG:6857": {
    proj4: "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -5208.77950254976,
      -4193.556414068197,
      471125.7669200912,
      354717.4494430824
    ]
  },
  "EPSG:6858": {
    proj4: "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1587.636007417168,
      -1278.1959950079868,
      143599.13374220382,
      108117.87859025152
    ]
  },
  "EPSG:6859": {
    proj4: "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -5208.77950254976,
      -4193.556414068197,
      471125.7669200912,
      354717.4494430824
    ]
  },
  "EPSG:6860": {
    proj4: "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -800.8376800047628,
      1852.2362113665074,
      64252.504171917106,
      64408.09338718026
    ]
  },
  "EPSG:6861": {
    proj4: "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2627.4202099893787,
      6076.890457239197,
      210802.17904172276,
      211312.64234639192
    ]
  },
  "EPSG:6862": {
    proj4: "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -800.8376800047628,
      1852.2362113665074,
      64252.504171917106,
      64408.09338718026
    ]
  },
  "EPSG:6863": {
    proj4: "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2627.4202099893787,
      6076.890457239197,
      210802.17904172276,
      211312.64234639192
    ]
  },
  "EPSG:6867": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60163.86735144921,
      34049.00237979901,
      710705.1662058923,
      508757.95951940055
    ]
  },
  "EPSG:6868": {
    proj4: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      197388.0162396627,
      111709.32539304135,
      2.3317098628749745e6,
      1.6691534104967208e6
    ]
  },
  "EPSG:6870": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      433043.94035608304,
      4389848571241506e-9,
      586894.9516733816,
      4726605169154738e-9
    ]
  },
  "EPSG:6875": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6444735932303637e-9,
      3.8590024174948805e6,
      7529745295968068e-9,
      5234265085420701e-9
    ]
  },
  "EPSG:6876": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2443901784981109e-9,
      3.8647996169202602e6,
      3.5305411076295115e6,
      5242128277837456e-9
    ]
  },
  "EPSG:6879": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      368160.8288686152,
      20423.476917061555,
      891449.2804629535,
      225280.70276785115
    ]
  },
  "EPSG:6880": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.8323418051,
      83779.09479688275,
      289695436853239e-8,
      1.1914174172197795e6
    ]
  },
  "EPSG:6881": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [43.37, 12.54, 53.14, 19]
  },
  "EPSG:6882": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [35.04, 33.06, 36.63, 34.65]
  },
  "EPSG:6883": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [8.37, 3.14, 9.02, 3.82]
  },
  "EPSG:6884": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546260644754e-8,
      38177.19394785736,
      2.8106066110863457e6,
      295944.2058068297
    ]
  },
  "EPSG:6885": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:6886": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1160304687469061e-9,
      43124.56959847481,
      1785979111173056e-9,
      327582.564817976
    ]
  },
  "EPSG:6887": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:6892": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [55.15, -4.86, 56.01, -3.66]
  },
  "EPSG:6893": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -24248588760835055e-8,
      20037508342789244e-9,
      24248588760835055e-8
    ]
  },
  "EPSG:6894": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-16.88, 13.05, -13.79, 13.83]
  },
  "EPSG:6915": {
    proj4: "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      294837.44922562083,
      -537420.2666041353,
      390053.5498967512,
      -404568.88588950096
    ]
  },
  "EPSG:6916": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:6917": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [103.59, 1.13, 104.07, 1.47]
  },
  "EPSG:6922": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      60852.596945203724,
      116930.67349509144,
      713327.9794972304,
      451383.7349776612
    ]
  },
  "EPSG:6923": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      199647.2284443894,
      383630.05129181256,
      2.3403102127004974e6,
      1.4809148038392104e6
    ]
  },
  "EPSG:6924": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60852.596945203724,
      116930.67349509144,
      713327.9794972304,
      451383.7349776612
    ]
  },
  "EPSG:6925": {
    proj4: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      199647.2284443894,
      383630.05129181256,
      2.3403102127004974e6,
      1.4809148038392104e6
    ]
  },
  "EPSG:6927": {
    proj4: "+proj=tmerc +lat_0=1.36666666666667 +lon_0=103.833333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      919.0500208435915,
      12576.33577303091,
      54338.71764056321,
      50172.046234256464
    ]
  },
  "EPSG:6931": {
    proj4: "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-11034024505272343e-25, 9009964761231286e-9, 0, 0]
  },
  "EPSG:6932": {
    proj4: "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 11034024505272343e-25, -9009964761231286e-9]
  },
  "EPSG:6933": {
    proj4: "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17367530445161372e-9,
      -732418456362408e-8,
      17367530445161372e-9,
      7324184563624077e-9
    ]
  },
  "EPSG:6934": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:6962": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=20 +lat_1=39 +lat_2=43 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -66933.07985641317,
      -150639.23503469976,
      86876.29315815055,
      185927.66047771828
    ]
  },
  "EPSG:6966": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1116671942611905e-9,
      127250.6686118669,
      2866405760424183e-9,
      1.3094314246128194e6
    ]
  },
  "EPSG:6981": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4598950988774809e-9,
      3121924961574175e-9,
      4.3350377637689095e6,
      3.1138935036448943e6
    ]
  },
  "EPSG:6982": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.17, 29.45, 35.69, 33.28]
  },
  "EPSG:6983": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.17, 29.45, 35.69, 33.28]
  },
  "EPSG:6984": {
    proj4: "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      119163.57033917059,
      374097.5044487774,
      264756.2074962809,
      798414.8657018573
    ]
  },
  "EPSG:6988": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4598950988774809e-9,
      3121924961574175e-9,
      4.3350377637689095e6,
      3.1138935036448943e6
    ]
  },
  "EPSG:6989": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.17, 29.45, 35.69, 33.28]
  },
  "EPSG:6990": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.17, 29.45, 35.69, 33.28]
  },
  "EPSG:6991": {
    proj4: "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      119163.57033917059,
      374097.5044487774,
      264756.2074962809,
      798414.8657018573
    ]
  },
  "EPSG:7005": {
    proj4: "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      479980.81030344154,
      3444871084091685e-9,
      767844.5729074054,
      4.0710463321258444e6
    ]
  },
  "EPSG:7006": {
    proj4: "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      207889.20143174805,
      3.2180961154680727e6,
      765600.8985612501,
      4.1420689560165005e6
    ]
  },
  "EPSG:7007": {
    proj4: "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      209426.16108883056,
      3.2779662438183683e6,
      285168.35180771514,
      3431510416925511e-9
    ]
  },
  "EPSG:7034": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-57.1, 43.41, -55.9, 47.37]
  },
  "EPSG:7035": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-57.1, 43.41, -55.9, 47.37]
  },
  "EPSG:7036": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.83, -24.72, 58.24, -18.28]
  },
  "EPSG:7037": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.83, -24.72, 58.24, -18.28]
  },
  "EPSG:7038": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [43.68, -14.49, 46.7, -11.33]
  },
  "EPSG:7039": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [43.68, -14.49, 46.7, -11.33]
  },
  "EPSG:7040": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.61, 2.11, -49.45, 8.88]
  },
  "EPSG:7041": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.61, 2.11, -49.45, 8.88]
  },
  "EPSG:7042": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-9.86, 41.15, 10.38, 51.56]
  },
  "EPSG:7057": {
    proj4: "+proj=lcc +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.01041402 +y_0=2926085.8521717 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      11138251671315726e-9,
      9493567262084426e-9,
      11839592238194298e-9,
      9715597987485537e-9
    ]
  },
  "EPSG:7058": {
    proj4: "+proj=lcc +lat_1=43.1666666666667 +lat_0=43.1666666666667 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.97409195 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      12170408544732595e-9,
      9705221408932267e-9,
      1280510297177493e-8,
      9927245327356204e-9
    ]
  },
  "EPSG:7059": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-91.2 +k=1.000035 +x_0=4114808.22961646 +y_0=2529845.05969012 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1338635154267109e-8,
      9043614066560231e-9,
      13582245622954302e-9,
      9488156380604278e-9
    ]
  },
  "EPSG:7060": {
    proj4: "+proj=lcc +lat_1=42.5333333333333 +lat_0=42.5333333333333 +lon_0=-94.8333333333333 +k_0=1.000045 +x_0=4419608.83921768 +y_0=2621285.24257049 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      14007751057389054e-9,
      8483790817042751e-9,
      14991088381608518e-9,
      8746243254509248e-9
    ]
  },
  "EPSG:7061": {
    proj4: "+proj=lcc +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.4488189 +y_0=2712725.42545085 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1528863571581132e-8,
      8736969821062105e-9,
      15676315858583415e-9,
      9061060848541781e-9
    ]
  },
  "EPSG:7062": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-95.7333333333333 +k=1.000039 +x_0=5029210.05842012 +y_0=2011684.02336805 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      16323140371115856e-9,
      6720866977224305e-9,
      1668781877821928e-8,
      731858936612091e-8
    ]
  },
  "EPSG:7063": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-94.6333333333333 +k=1.000045 +x_0=5334010.66802134 +y_0=2072644.14528829 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1735494562466269e-8,
      7128350784122305e-9,
      1762822303921212e-8,
      7518185932098322e-9
    ]
  },
  "EPSG:7064": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-93.7166666666667 +k=1.000033 +x_0=5638811.27762256 +y_0=2133604.26720853 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1834209454411075e-8,
      7328428033500467e-9,
      1863183338233396e-8,
      771819764803587e-8
    ]
  },
  "EPSG:7065": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-92.8166666666667 +k=1.000027 +x_0=5943611.88722378 +y_0=2194564.38912878 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1935313445157277e-8,
      7531999762502148e-9,
      1964248794372384e-8,
      7947412996659557e-9
    ]
  },
  "EPSG:7066": {
    proj4: "+proj=lcc +lat_1=41.8333333333333 +lat_0=41.8333333333333 +lon_0=-91.6666666666667 +k_0=1.00002 +x_0=6248412.49682499 +y_0=2438404.87680975 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      20323544034485813e-9,
      7850042231431925e-9,
      2071012696909415e-8,
      8171016513215149e-9
    ]
  },
  "EPSG:7067": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-90.5333333333333 +k=1.000027 +x_0=6553213.10642621 +y_0=2316484.63296927 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      21333653363026943e-9,
      8034158647408255e-9,
      2160577278026828e-8,
      8485710898511657e-9
    ]
  },
  "EPSG:7068": {
    proj4: "+proj=lcc +lat_1=40.9166666666667 +lat_0=40.9166666666667 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.71602743 +y_0=1889763.77952756 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      22044377348752066e-9,
      6077963369010778e-9,
      22935007135562185e-9,
      6296234760080877e-9
    ]
  },
  "EPSG:7069": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-91.9166666666667 +k=1.00002 +x_0=7162814.32562865 +y_0=1950723.9014478 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2336020268438713e-8,
      6524268305622439e-9,
      23619584887004733e-9,
      6863025789142996e-9
    ]
  },
  "EPSG:7070": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987 +y_0=1889763.77952756 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      24369034241142128e-9,
      6244065403040359e-9,
      24628554627473865e-9,
      6692224180439249e-9
    ]
  },
  "EPSG:7071": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.9594367709339259e6,
      1.5297786112477272e6,
      -4697039613625766e-9,
      3669729537258477e-9
    ]
  },
  "EPSG:7072": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [37.98, -67.13, 142, -20.91]
  },
  "EPSG:7073": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [37.98, -67.13, 142, -20.91]
  },
  "EPSG:7074": {
    proj4: "+proj=utm +zone=37 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      397659.5063442334,
      7157143507373763e-9,
      793343.4488925461,
      7685234964299284e-9
    ]
  },
  "EPSG:7075": {
    proj4: "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      526856.2283131063,
      4530234203995507e-9,
      744869.7117857016,
      5221460679339875e-9
    ]
  },
  "EPSG:7076": {
    proj4: "+proj=utm +zone=39 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284213.5560517409,
      4477064225192764e-9,
      746895.7385419348,
      5278099890903298e-9
    ]
  },
  "EPSG:7077": {
    proj4: "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      283280.35738949594,
      4500406601976589e-9,
      512977.7103379402,
      5205857410423533e-9
    ]
  },
  "EPSG:7078": {
    proj4: "+proj=utm +zone=41 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      497317.4462602377,
      4124391463207273e-9,
      733421.6406168113,
      4931572854950701e-9
    ]
  },
  "EPSG:7079": {
    proj4: "+proj=utm +zone=42 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      299812.9948895857,
      4.0968305262454357e6,
      736779.3932576342,
      5.0004215311606005e6
    ]
  },
  "EPSG:7080": {
    proj4: "+proj=utm +zone=43 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      290372.6051937931,
      4324767864741502e-9,
      776472.776467042,
      6181616901012991e-9
    ]
  },
  "EPSG:7081": {
    proj4: "+proj=utm +zone=44 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251690.90439017874,
      5341427298318255e-9,
      576197.6569806647,
      6182090134324199e-9
    ]
  },
  "EPSG:7084": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-9.86, 41.15, 10.38, 51.56]
  },
  "EPSG:7085": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:7086": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.66, 14.08, -57.52, 18.54]
  },
  "EPSG:7087": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [37.98, -67.13, 142, -20.91]
  },
  "EPSG:7109": {
    proj4: "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      41455.89901603742,
      6604.691146948178,
      113415.63989147401,
      56844.11157542277
    ]
  },
  "EPSG:7110": {
    proj4: "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -16.031852979998803,
      869.2265021498723,
      136585.4574637515,
      112453.9715619903
    ]
  },
  "EPSG:7111": {
    proj4: "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      37568.98017092231,
      121029.5936390001,
      315341.61946545483,
      259165.96634985623
    ]
  },
  "EPSG:7112": {
    proj4: "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24628.10434598627,
      72611.64410602214,
      310477.7475995627,
      207812.45686108284
    ]
  },
  "EPSG:7113": {
    proj4: "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      45553.14438618676,
      66127.16966394277,
      252818.10681030413,
      161046.61771526598
    ]
  },
  "EPSG:7114": {
    proj4: "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -69465.95774313185,
      -12371.523884716407,
      206820.0523219104,
      126272.85633044565
    ]
  },
  "EPSG:7115": {
    proj4: "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      114029.26949651587,
      27253.14015670512,
      284310.2840983686,
      149527.41398570416
    ]
  },
  "EPSG:7116": {
    proj4: "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14573.508346578426,
      1643.455438606281,
      138325.42861308286,
      137922.2493758542
    ]
  },
  "EPSG:7117": {
    proj4: "+proj=lcc +lat_1=45.7833333333333 +lat_0=45.7833333333333 +lon_0=-108.416666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      120859.14722947295,
      -37690.055181605596,
      232219.28375878048,
      230962.87305759496
    ]
  },
  "EPSG:7118": {
    proj4: "+proj=tmerc +lat_0=42.6666666666667 +lon_0=-108.333333333333 +k=1.00024 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4368.532982852659,
      3252.8408125448477,
      131629.45616903275,
      132683.83843034328
    ]
  },
  "EPSG:7119": {
    proj4: "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000.00001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      136010.16742348237,
      21668.934209147563,
      372098.5561224213,
      186496.4290532243
    ]
  },
  "EPSG:7120": {
    proj4: "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=99999.9999996 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -52.59794416011105,
      2851.792986056011,
      448115.0179243815,
      368943.476253249
    ]
  },
  "EPSG:7121": {
    proj4: "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.9999992 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      123257.80900775039,
      397078.71928543336,
      1.0345853657483425e6,
      850282.0418276122
    ]
  },
  "EPSG:7122": {
    proj4: "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=150000.00001464 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      80800.86727423314,
      238227.17887356348,
      1.0186277808358355e6,
      681799.3991985657
    ]
  },
  "EPSG:7123": {
    proj4: "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=99999.9999996 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      149452.5734428699,
      216952.65637645262,
      829455.73100231,
      528368.1683558595
    ]
  },
  "EPSG:7124": {
    proj4: "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.9999996 +y_0=49999.99971024 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -227906.68551027507,
      -40588.99007374149,
      678543.4787451128,
      414281.0237555303
    ]
  },
  "EPSG:7125": {
    proj4: "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=199999.9999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      374111.77656074753,
      89413.18949050235,
      932776.5226298182,
      490575.5052024414
    ]
  },
  "EPSG:7126": {
    proj4: "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.9999996 +y_0=99999.9999996 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      47813.34759244889,
      5391.914167343431,
      453823.58468727965,
      452500.818160939
    ]
  },
  "EPSG:7127": {
    proj4: "+proj=lcc +lat_1=45.7833333333333 +lat_0=45.7833333333333 +lon_0=-108.416666666667 +k_0=1.0001515 +x_0=199999.9999992 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      396519.5119050949,
      -123655.03663571388,
      761874.2905445553,
      757752.208243553
    ]
  },
  "EPSG:7128": {
    proj4: "+proj=tmerc +lat_0=42.6666666666667 +lon_0=-108.333333333333 +k=1.00024 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      14332.42859457583,
      10672.028565824223,
      431854.3074145684,
      435313.55991688464
    ]
  },
  "EPSG:7131": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -50999.14789102436,
      -75310.49818795362,
      156483.47884844866,
      149066.2095648686
    ]
  },
  "EPSG:7132": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -167319.7043724691,
      -247081.19280497788,
      513396.21352195204,
      489061.3892140731
    ]
  },
  "EPSG:7133": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [37.98, -67.13, 142, -20.91]
  },
  "EPSG:7134": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4662266843376004e-9,
      3.0265547317055846e6,
      432263918970454e-8,
      3104987505280549e-9
    ]
  },
  "EPSG:7135": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.99, 29.45, 35.69, 33.53]
  },
  "EPSG:7136": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.99, 29.45, 35.69, 33.53]
  },
  "EPSG:7137": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4662266843376004e-9,
      3.0265547317055846e6,
      432263918970454e-8,
      3104987505280549e-9
    ]
  },
  "EPSG:7138": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.99, 29.45, 35.69, 33.53]
  },
  "EPSG:7139": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [32.99, 29.45, 35.69, 33.53]
  },
  "EPSG:7142": {
    proj4: "+proj=tmerc +lat_0=31.7340969444444 +lon_0=35.2120805555556 +k=1 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs +type=crs",
    projected_bounds: [
      68881.9053626475,
      -155818.59223600314,
      551710.5826178698,
      316899.4219461493
    ]
  },
  "EPSG:7257": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      228989.63875388444,
      37118.613034373084,
      252634.0518292129,
      78210.84617395503
    ]
  },
  "EPSG:7258": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      751276.8398117026,
      121779.98293027237,
      828850.2183763428,
      256596.75115571747
    ]
  },
  "EPSG:7259": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215566.86506464772,
      37151.04847403538,
      260945.1895401529,
      78232.60177263894
    ]
  },
  "EPSG:7260": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      707238.9564662651,
      121886.39820189775,
      856117.6760163184,
      256668.12764906627
    ]
  },
  "EPSG:7261": {
    proj4: "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      219217.89228624327,
      39357.96917361887,
      254651.95755653243,
      75981.6351456737
    ]
  },
  "EPSG:7262": {
    proj4: "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      719217.3682757833,
      129126.93719711459,
      835470.6307500569,
      249283.08130709783
    ]
  },
  "EPSG:7263": {
    proj4: "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220494.15811335022,
      38246.3449607644,
      257738.1561527231,
      68225.51444455807
    ]
  },
  "EPSG:7264": {
    proj4: "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      723404.5837435499,
      125479.88342544122,
      845595.9339777258,
      223836.54197352094
    ]
  },
  "EPSG:7265": {
    proj4: "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224644.2248375579,
      38236.32724322734,
      256936.56731272212,
      93762.52974288934
    ]
  },
  "EPSG:7266": {
    proj4: "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      737020.260987888,
      125447.0169638217,
      842966.0545918226,
      307619.2329981295
    ]
  },
  "EPSG:7267": {
    proj4: "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222821.36870186043,
      36019.11152322058,
      262141.55410864222,
      101544.02219230922
    ]
  },
  "EPSG:7268": {
    proj4: "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      731039.7738160205,
      118172.70172243286,
      860042.7487714371,
      333149.01280926785
    ]
  },
  "EPSG:7269": {
    proj4: "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      232207.78082930978,
      40444.62248831893,
      259826.14698241404,
      74882.98533793553
    ]
  },
  "EPSG:7270": {
    proj4: "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      761835.0276041606,
      132692.0656137597,
      852446.2838914702,
      245678.5943962102
    ]
  },
  "EPSG:7271": {
    proj4: "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      228968.45661479578,
      39339.48130252317,
      263650.8101128154,
      73794.20319871529
    ]
  },
  "EPSG:7272": {
    proj4: "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      751207.3447437092,
      129066.28157336146,
      864994.3661784619,
      242106.48166111842
    ]
  },
  "EPSG:7273": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223908.02765591224,
      37127.833778192675,
      260217.41415793006,
      77116.93779900545
    ]
  },
  "EPSG:7274": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      734604.9207344388,
      121810.23465395381,
      853729.9662831423,
      253007.8200955704
    ]
  },
  "EPSG:7275": {
    proj4: "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      201442.2009522631,
      38311.53301130217,
      256496.37382428683,
      112612.81061270405
    ]
  },
  "EPSG:7276": {
    proj4: "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      660898.2876242166,
      125693.75455458055,
      841521.8531218478,
      369463.86281851324
    ]
  },
  "EPSG:7277": {
    proj4: "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      231356.69495320812,
      37114.97418207205,
      258893.55141513146,
      87094.81407261983
    ]
  },
  "EPSG:7278": {
    proj4: "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      759042.7566923171,
      121768.04446234807,
      849386.5932678105,
      285743.5691699203
    ]
  },
  "EPSG:7279": {
    proj4: "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      231481.5551137084,
      38225.62043961576,
      270544.57540201704,
      68264.96372529697
    ]
  },
  "EPSG:7280": {
    proj4: "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      759452.4020688917,
      125411.8897256394,
      887611.661131451,
      223965.96848874516
    ]
  },
  "EPSG:7281": {
    proj4: "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223334.09505518142,
      36017.050659693145,
      262523.4443507249,
      135940.8819543352
    ]
  },
  "EPSG:7282": {
    proj4: "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      732721.9435268744,
      118165.9403726766,
      861295.6670073367,
      445999.37687851477
    ]
  },
  "EPSG:7283": {
    proj4: "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224295.64283837526,
      40455.64854768971,
      276291.445367336,
      117124.2214860661
    ]
  },
  "EPSG:7284": {
    proj4: "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      735876.6215455696,
      132728.24027687867,
      906466.1836760016,
      384265.0499922019
    ]
  },
  "EPSG:7285": {
    proj4: "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213024.46373105107,
      39375.97746951393,
      250349.95731920082,
      109278.95859130943
    ]
  },
  "EPSG:7286": {
    proj4: "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698897.7614242901,
      129186.01941456362,
      821356.4849714114,
      358526.04997832107
    ]
  },
  "EPSG:7287": {
    proj4: "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      236541.16890396248,
      39331.412136442,
      270836.90089630184,
      112671.30989779645
    ]
  },
  "EPSG:7288": {
    proj4: "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      776052.1516457503,
      129039.80798431014,
      888570.7323572837,
      369655.7892230206
    ]
  },
  "EPSG:7289": {
    proj4: "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      219048.3127085187,
      37140.772843619685,
      252517.16795104518,
      68219.87480879601
    ]
  },
  "EPSG:7290": {
    proj4: "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      718661.0059445319,
      121852.68557110893,
      828466.7418527209,
      223818.03926852494
    ]
  },
  "EPSG:7291": {
    proj4: "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      228612.62975012063,
      36007.988954771754,
      264286.59732579766,
      114853.82555378725
    ]
  },
  "EPSG:7292": {
    proj4: "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      750039.9361051875,
      118136.21042911368,
      867080.2780597212,
      376816.259337717
    ]
  },
  "EPSG:7293": {
    proj4: "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546.25620638524,
      36025.43617422956,
      258293.26550194988,
      160412.43116298347
    ]
  },
  "EPSG:7294": {
    proj4: "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      723575.5089037823,
      118193.45184828482,
      847417.155234314,
      526286.451240555
    ]
  },
  "EPSG:7295": {
    proj4: "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      217558.9281459594,
      37142.468277460626,
      260557.9612778299,
      95983.56272876087
    ]
  },
  "EPSG:7296": {
    proj4: "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      713774.5834255352,
      121858.24800696876,
      854847.2446256804,
      314906.07205260964
    ]
  },
  "EPSG:7297": {
    proj4: "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      219490.01072408786,
      36027.58295990638,
      257806.96725282853,
      94873.20337878665
    ]
  },
  "EPSG:7298": {
    proj4: "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      720110.1435172784,
      118200.49509429286,
      845821.691728655,
      311263.1680852359
    ]
  },
  "EPSG:7299": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220619.08168209344,
      36025.469488989074,
      269934.38873140456,
      132688.18155975454
    ]
  },
  "EPSG:7300": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      723814.4371520017,
      118193.56114845834,
      885609.7403629499,
      435327.80900062807
    ]
  },
  "EPSG:7301": {
    proj4: "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      211077.96114302502,
      37161.470082100226,
      269643.1553644266,
      79346.53952209579
    ]
  },
  "EPSG:7302": {
    proj4: "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      692511.6108500747,
      121920.58976102385,
      884654.2522247897,
      260322.7717487426
    ]
  },
  "EPSG:7303": {
    proj4: "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225561.20613767617,
      38234.781135912504,
      261987.92997696777,
      70457.42611376906
    ]
  },
  "EPSG:7304": {
    proj4: "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      740028.7238033593,
      125441.94444340629,
      859538.7335994352,
      231159.07217492402
    ]
  },
  "EPSG:7305": {
    proj4: "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      218625.90443448423,
      38250.65762778891,
      251883.7375856542,
      92640.52036088747
    ]
  },
  "EPSG:7306": {
    proj4: "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      717275.1547988037,
      125494.0325671708,
      826388.5623956006,
      303938.10721734504
    ]
  },
  "EPSG:7307": {
    proj4: "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226274.90134000545,
      40453.53048775939,
      259531.99406751565,
      117083.81026003385
    ]
  },
  "EPSG:7308": {
    proj4: "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      742370.2388130013,
      132721.29127525727,
      851481.2172031744,
      384132.4674947944
    ]
  },
  "EPSG:7309": {
    proj4: "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224178.99525867146,
      36015.283090972734,
      266934.140232992,
      129291.0999951597
    ]
  },
  "EPSG:7310": {
    proj4: "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      735493.9202778247,
      118160.14127429972,
      875766.4250810747,
      424182.5505674532
    ]
  },
  "EPSG:7311": {
    proj4: "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227149.35400151886,
      39341.809907527146,
      261324.45856054797,
      72672.41968416632
    ]
  },
  "EPSG:7312": {
    proj4: "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      745239.1722533165,
      129073.92133827865,
      857361.9944607312,
      238426.09691380238
    ]
  },
  "EPSG:7313": {
    proj4: "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220465.21596346278,
      38246.29647461427,
      264399.97478520125,
      108223.71078272807
    ]
  },
  "EPSG:7314": {
    proj4: "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      723309.6293734609,
      125479.72435046366,
      867452.2506077812,
      355063.9577930004
    ]
  },
  "EPSG:7315": {
    proj4: "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223929.5020305174,
      36017.35814440666,
      256751.08292907785,
      108206.4774234374
    ]
  },
  "EPSG:7316": {
    proj4: "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      734675.3745784559,
      118166.94917877419,
      842357.5112431496,
      355007.4180133943
    ]
  },
  "EPSG:7317": {
    proj4: "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207821.5322348308,
      38285.23927136373,
      253844.91154950252,
      78198.20041266162
    ]
  },
  "EPSG:7318": {
    proj4: "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      681827.8103404408,
      125607.48917613253,
      832822.8473086596,
      256555.2625205407
    ]
  },
  "EPSG:7319": {
    proj4: "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224793.62125820856,
      39347.12765466963,
      254967.12603532587,
      154851.41927200076
    ]
  },
  "EPSG:7320": {
    proj4: "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      737510.4057446393,
      129091.36798036196,
      836504.6460008984,
      508041.69806155586
    ]
  },
  "EPSG:7321": {
    proj4: "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221295.10565627282,
      36023.22681301099,
      256934.0459405198,
      67112.47571129925
    ]
  },
  "EPSG:7322": {
    proj4: "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      726032.3591406218,
      118186.20330235356,
      842957.7823898555,
      220184.84739615434
    ]
  },
  "EPSG:7323": {
    proj4: "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      210372.82504584617,
      39385.12797298367,
      253008.9476201131,
      77085.70737510148
    ]
  },
  "EPSG:7324": {
    proj4: "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      690198.1768379137,
      129216.04069136393,
      830080.1889836545,
      252905.35827981215
    ]
  },
  "EPSG:7325": {
    proj4: "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [24e4, 36e3, 271962.1850372178, 80472.52979008225]
  },
  "EPSG:7326": {
    proj4: "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      787400.0000000001,
      118110.00000000001,
      892262.6020762721,
      264016.95815296157
    ]
  },
  "EPSG:7327": {
    proj4: "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224481.66131598852,
      40456.45403438818,
      258806.40900053937,
      105972.50759793128
    ]
  },
  "EPSG:7328": {
    proj4: "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      736486.9171675391,
      132730.88294448858,
      849100.6935292697,
      347678.13534421293
    ]
  },
  "EPSG:7329": {
    proj4: "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213797.21797890158,
      37152.67773853463,
      271225.48633312073,
      92677.00807146647
    ]
  },
  "EPSG:7330": {
    proj4: "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      701433.039319113,
      121891.7435471757,
      889845.616411247,
      304057.8173144696
    ]
  },
  "EPSG:7331": {
    proj4: "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222400.56725193217,
      37131.89942200994,
      261619.40266431143,
      93787.97845950272
    ]
  },
  "EPSG:7332": {
    proj4: "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729659.1943923809,
      121823.57335371096,
      858329.6569078285,
      307702.7259958852
    ]
  },
  "EPSG:7333": {
    proj4: "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      229017.62763781557,
      39339.66822803476,
      255798.61757916096,
      154853.08889979828
    ]
  },
  "EPSG:7334": {
    proj4: "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      751368.6666750667,
      129066.89484481073,
      839232.6311742973,
      508047.1758320883
    ]
  },
  "EPSG:7335": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223989.74218914914,
      36017.38079234579,
      264113.71030969656,
      132665.80118484504
    ]
  },
  "EPSG:7336": {
    proj4: "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      734873.0124989002,
      118167.02348288783,
      866513.0645743962,
      435254.3827206125
    ]
  },
  "EPSG:7337": {
    proj4: "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223538.1994453172,
      40457.89412836376,
      262319.19604778016,
      112639.02417121697
    ]
  },
  "EPSG:7338": {
    proj4: "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      733391.5760135116,
      132735.6076528068,
      860625.5623667588,
      369549.8651350677
    ]
  },
  "EPSG:7339": {
    proj4: "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227092.0393905246,
      38231.29498237458,
      266387.78478193475,
      121542.9753955107
    ]
  },
  "EPSG:7340": {
    proj4: "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      745051.1325670795,
      125430.50695467395,
      873973.9239053976,
      398762.24511010473
    ]
  },
  "EPSG:7341": {
    proj4: "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226170.68202318816,
      37122.40692605054,
      263230.8982159488,
      72672.8495584738
    ]
  },
  "EPSG:7342": {
    proj4: "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      742028.3126044099,
      121792.43005655083,
      863616.7052301588,
      238427.50725975947
    ]
  },
  "EPSG:7343": {
    proj4: "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223680.52934748496,
      36017.247903830576,
      269823.03718443355,
      97127.80557411863
    ]
  },
  "EPSG:7344": {
    proj4: "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      733858.5367008736,
      118166.5874978175,
      885244.4144959291,
      318660.1421210876
    ]
  },
  "EPSG:7345": {
    proj4: "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      229437.03305777,
      40446.59750931677,
      263628.0464127171,
      88204.1812303912
    ]
  },
  "EPSG:7346": {
    proj4: "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      752744.6659570338,
      132698.54532848345,
      864919.6822723894,
      289383.2179200418
    ]
  },
  "EPSG:7347": {
    proj4: "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224162.04481247335,
      38235.18193814202,
      265276.9061006279,
      114851.31403162719
    ]
  },
  "EPSG:7348": {
    proj4: "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      735438.308688923,
      125443.25940872096,
      870329.3160984769,
      376808.0194520969
    ]
  },
  "EPSG:7349": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      230308.2048585275,
      38225.565965693735,
      263637.59741396527,
      90423.40788039364
    ]
  },
  "EPSG:7350": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      755602.835440019,
      125411.7110057802,
      864951.0175156512,
      296664.1306875915
    ]
  },
  "EPSG:7351": {
    proj4: "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224563.59584598022,
      37125.83031506416,
      261249.4227164865,
      104874.61860763033
    ]
  },
  "EPSG:7352": {
    proj4: "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      736755.7307046868,
      121803.66162533968,
      857115.8143623396,
      344076.1445485339
    ]
  },
  "EPSG:7353": {
    proj4: "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226989.09655538527,
      37120.87618684152,
      260697.16341249467,
      82656.62391085103
    ]
  },
  "EPSG:7354": {
    proj4: "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744713.3942821266,
      121787.40795632922,
      855303.9436291597,
      271182.60694751714
    ]
  },
  "EPSG:7355": {
    proj4: "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      234827.22711412614,
      40442.713961709014,
      264015.3249056166,
      80448.83200673948
    ]
  },
  "EPSG:7356": {
    proj4: "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      770428.9942902622,
      132685.80405604033,
      866190.2784611771,
      263939.20967544446
    ]
  },
  "EPSG:7357": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      220618.9919888992,
      39352.60302405099,
      265398.9885246653,
      87098.67969067063
    ]
  },
  "EPSG:7358": {
    proj4: "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      723814.1428835802,
      129109.33175474065,
      870729.8481846729,
      285756.25161847525
    ]
  },
  "EPSG:7359": {
    proj4: "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223305.21640914894,
      38240.68165186427,
      256630.3735902392,
      66008.4390561573
    ]
  },
  "EPSG:7360": {
    proj4: "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      732627.1975023496,
      125461.30305282472,
      841961.4840206433,
      216562.68713674275
    ]
  },
  "EPSG:7361": {
    proj4: "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226987.54447149794,
      36010.69627444318,
      262440.60060944007,
      75999.02452049566
    ]
  },
  "EPSG:7362": {
    proj4: "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744708.3021535729,
      118145.09269373569,
      861023.8704994714,
      249340.13294765953
    ]
  },
  "EPSG:7363": {
    proj4: "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222973.213367722,
      37129.59991188384,
      266956.5071357766,
      116004.08474725556
    ]
  },
  "EPSG:7364": {
    proj4: "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      731537.950857268,
      121816.02904423891,
      875839.8071612939,
      380590.068041621
    ]
  },
  "EPSG:7365": {
    proj4: "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225912.3104276275,
      38231.95238515785,
      249639.37072179856,
      77074.92613676263
    ]
  },
  "EPSG:7366": {
    proj4: "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      741180.638461308,
      125432.66378363872,
      819025.1687764343,
      252869.98683369544
    ]
  },
  "EPSG:7367": {
    proj4: "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225325.1769625131,
      36013.77435793994,
      262328.65739124146,
      76001.6316628244
    ]
  },
  "EPSG:7368": {
    proj4: "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      739254.3514178451,
      118155.19137267463,
      860656.6034577648,
      249348.6865471164
    ]
  },
  "EPSG:7369": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      223060.97958714765,
      37129.71488583289,
      256005.54638696997,
      77106.83189197155
    ]
  },
  "EPSG:7370": {
    proj4: "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      731825.8971955003,
      121816.40625460341,
      839911.5301045841,
      252974.66429891004
    ]
  },
  "EPSG:7371": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.8062270670197485e6,
      4869996254702303e-9,
      2.5539639410606134e6,
      5095704582768716e-9
    ]
  },
  "EPSG:7372": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.99, 14.33, 63.38, 26.74]
  },
  "EPSG:7373": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.99, 14.33, 63.38, 26.74]
  },
  "EPSG:7374": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      606466.6382767549,
      1.6519268946148441e6,
      815625.7276942935,
      2177756623737552e-9
    ]
  },
  "EPSG:7375": {
    proj4: "+proj=utm +zone=40 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      176364.65321710677,
      1.5863216279581708e6,
      799403.9952776761,
      2961179095398079e-9
    ]
  },
  "EPSG:7376": {
    proj4: "+proj=utm +zone=41 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      179498.59126554977,
      1.8122298092159026e6,
      538623.4714089165,
      2.6642431284939465e6
    ]
  },
  "EPSG:7400": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.207229166666667, 42.33, 5.8927708333333335, 51.14]
  },
  "EPSG:7404": {
    proj4: "+proj=longlat +ellps=bessel +vunits=m +no_defs +type=crs",
    projected_bounds: [10.93, 55.28, 24.17, 69.07]
  },
  "EPSG:7405": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      36953.958566932415,
      15665.712719485833,
      620055.922183565,
      986449.6315737902
    ]
  },
  "EPSG:7406": {
    proj4: "+proj=longlat +datum=NAD27 +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      -124.78903517529683,
      24.40969287050548,
      -66.91072662919963,
      49.38000194368993
    ]
  },
  "EPSG:7407": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5380003536350366e6,
      112729.55924305854,
      2443989832008022e-9,
      913320.4547984318
    ]
  },
  "EPSG:7409": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9.56, 35.95, 31.59, 71.21]
  },
  "EPSG:7410": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +vunits=m +no_defs +type=crs",
    projected_bounds: [51.99, 16.59, 59.91, 26.58]
  },
  "EPSG:7411": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5094.3000770156505,
      1.7301473029733542e6,
      1.0132122316130111e6,
      2.6985567123740967e6
    ]
  },
  "EPSG:7414": {
    proj4: "+proj=longlat +ellps=bessel +vunits=m +no_defs +type=crs",
    projected_bounds: [129.3, 30.94, 142.14, 41.58]
  },
  "EPSG:7415": {
    proj4: "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      634.5732789819594,
      308884.6165973999,
      276007.32385594706,
      636324.9274066611
    ]
  },
  "EPSG:7416": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      435255.3494454158,
      6040726980068868e-9,
      678280.0592696285,
      6410394799746513e-9
    ]
  },
  "EPSG:7417": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      305791.7348086378,
      6044408285921658e-9,
      515519.38876358565,
      6226141522745737e-9
    ]
  },
  "EPSG:7418": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      103231.08034568946,
      6061225046149768e-9,
      306424.5456331773,
      6410093957739449e-9
    ]
  },
  "EPSG:7419": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      421632.14308493,
      6043055675060914e-9,
      542166.1990547928,
      6296426314720093e-9
    ]
  },
  "EPSG:7420": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      873723.3447364616,
      6090627891698857e-9,
      915846.9595696031,
      6139563033293629e-9
    ]
  },
  "EPSG:7421": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5094.3000770156505,
      1.7301473029733542e6,
      1.0132122316130111e6,
      2.6985567123740967e6
    ]
  },
  "EPSG:7422": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      259837.90399363468,
      3.0118823997281585e6,
      1.0200108643185934e6,
      3364836752198771e-9
    ]
  },
  "EPSG:7423": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9.56, 35.95, 31.59, 71.21]
  },
  "EPSG:7446": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7447": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7528": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121397.08362104541,
      30418.90656410093,
      179966.0416391383,
      98231.19093822878
    ]
  },
  "EPSG:7529": {
    proj4: "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      148970.69703856038,
      30489.848490167074,
      197288.89968597668,
      153889.84824469112
    ]
  },
  "EPSG:7530": {
    proj4: "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      68791.48004875361,
      7456.1239705285025,
      118095.29481024371,
      57474.65031699388
    ]
  },
  "EPSG:7531": {
    proj4: "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197138.84304593282,
      90866.34932666383,
      259229.82816349418,
      186467.38411761343
    ]
  },
  "EPSG:7532": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      10830.217346985108,
      142405.61923410758,
      50628.656431373965,
      191295.08189895964
    ]
  },
  "EPSG:7533": {
    proj4: "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151784.74663418197,
      59887.64310349317,
      197270.83723040996,
      124334.42999112609
    ]
  },
  "EPSG:7534": {
    proj4: "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30302.80571257961,
      29669.169076542123,
      97051.01511864769,
      88578.03659890636
    ]
  },
  "EPSG:7535": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213232.8990588185,
      91236.35725670496,
      281276.953197994,
      209049.199538236
    ]
  },
  "EPSG:7536": {
    proj4: "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30356.064658524923,
      29950.894984437975,
      89416.51358218705,
      79962.0704794284
    ]
  },
  "EPSG:7537": {
    proj4: "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182295.238759686,
      91140.32841196864,
      231336.11425996874,
      160095.25032346815
    ]
  },
  "EPSG:7538": {
    proj4: "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      137056.03503260718,
      91364.18285330072,
      200987.77362544695,
      132472.4698922942
    ]
  },
  "EPSG:7539": {
    proj4: "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90760.19642255966,
      29293.748555825863,
      136273.2036185111,
      79288.26766360743
    ]
  },
  "EPSG:7540": {
    proj4: "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213037.58627419543,
      121178.61462233923,
      281455.18172516325,
      172285.1758572581
    ]
  },
  "EPSG:7541": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243317.73292646738,
      151962.1138566844,
      293607.3720029905,
      240882.34553762054
    ]
  },
  "EPSG:7542": {
    proj4: "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121706.52000769999,
      30110.147967542518,
      195755.48585982897,
      114574.65762986627
    ]
  },
  "EPSG:7543": {
    proj4: "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29516.26374831707,
      29713.029420314655,
      87144.21480195774,
      97517.22176744304
    ]
  },
  "EPSG:7544": {
    proj4: "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30760.80503793502,
      30223.930786810106,
      71805.64284120011,
      89122.81106776184
    ]
  },
  "EPSG:7545": {
    proj4: "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90621.28884620419,
      60385.11321865599,
      149248.8284308871,
      90389.30746244712
    ]
  },
  "EPSG:7546": {
    proj4: "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90803.26018885498,
      30280.031514958442,
      140600.02386158615,
      65707.43197342718
    ]
  },
  "EPSG:7547": {
    proj4: "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243201.64193808555,
      151719.50275858634,
      292347.3337567052,
      230576.09530687466
    ]
  },
  "EPSG:7548": {
    proj4: "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212723.7884070876,
      121012.57419074225,
      273192.36734827503,
      201007.48406082307
    ]
  },
  "EPSG:7549": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121488.34982328354,
      30718.44888411177,
      209217.9560568348,
      70652.2418864604
    ]
  },
  "EPSG:7550": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121956.70406289992,
      59566.765034219396,
      179890.13349643935,
      99568.0669949991
    ]
  },
  "EPSG:7551": {
    proj4: "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91087.25490805239,
      30153.02195867813,
      139989.08931320353,
      74610.11214784518
    ]
  },
  "EPSG:7552": {
    proj4: "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197387.0814158988,
      60808.785393169725,
      246693.02668587523,
      129740.41316873346
    ]
  },
  "EPSG:7553": {
    proj4: "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      906.3710873350901,
      4679.510414527587,
      69421.17912549878,
      63661.84324360642
    ]
  },
  "EPSG:7554": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151763.7570398684,
      30446.386733544063,
      197601.2199366239,
      148134.62285462697
    ]
  },
  "EPSG:7555": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29746.113194593934,
      30554.98252613835,
      94129.30158787683,
      157057.3373114821
    ]
  },
  "EPSG:7556": {
    proj4: "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121321.69242944392,
      29881.874339566144,
      163018.06263920004,
      72179.38881975594
    ]
  },
  "EPSG:7557": {
    proj4: "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      167158.24805737444,
      90437.3352402518,
      229962.463495149,
      141565.57839153672
    ]
  },
  "EPSG:7558": {
    proj4: "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91207.19613308841,
      29562.108301780572,
      140593.99779557888,
      79576.32062079995
    ]
  },
  "EPSG:7559": {
    proj4: "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31067.372770812603,
      30647.04834390491,
      117946.05274183839,
      80657.15783465898
    ]
  },
  "EPSG:7560": {
    proj4: "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181936.00354185252,
      30071.606015130066,
      256626.32201006004,
      123205.25450466183
    ]
  },
  "EPSG:7561": {
    proj4: "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60136.05088547987,
      14977.481118396783,
      100477.6331064175,
      44826.085891221825
    ]
  },
  "EPSG:7562": {
    proj4: "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177256.05724350698,
      90859.55559989369,
      231048.05255631125,
      140859.31667974903
    ]
  },
  "EPSG:7563": {
    proj4: "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      120894.17984750256,
      30609.78170516271,
      194498.69038716183,
      109228.99735183635
    ]
  },
  "EPSG:7564": {
    proj4: "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30560.116938921456,
      30567.157629614754,
      109246.05916715396,
      80584.50674170842
    ]
  },
  "EPSG:7565": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121255.70072604134,
      59956.226239184434,
      213300.8372982731,
      112183.02190387783
    ]
  },
  "EPSG:7566": {
    proj4: "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121564.58180689419,
      59921.60599664292,
      179356.19026815722,
      118910.4015789223
    ]
  },
  "EPSG:7567": {
    proj4: "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28428.187943666828,
      30432.697609155195,
      78585.04324159437,
      80417.62709792836
    ]
  },
  "EPSG:7568": {
    proj4: "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213018.6731870523,
      90533.72658968088,
      262771.7798453235,
      159528.3659099398
    ]
  },
  "EPSG:7569": {
    proj4: "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182099.70657812397,
      116252.47408213816,
      221824.5330006373,
      160691.839139331
    ]
  },
  "EPSG:7570": {
    proj4: "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121822.5179483935,
      60643.972399859515,
      171008.4886826088,
      100637.73160218791
    ]
  },
  "EPSG:7571": {
    proj4: "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212627.65223625637,
      152422.93144901525,
      281473.4021866292,
      191287.04187149453
    ]
  },
  "EPSG:7572": {
    proj4: "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151452.924139585,
      35698.24286217081,
      210634.12874437525,
      92322.64734066189
    ]
  },
  "EPSG:7573": {
    proj4: "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182140.80037943766,
      90807.74901712377,
      251215.79319409363,
      149720.97489258696
    ]
  },
  "EPSG:7574": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212837.8790275974,
      60627.63930844978,
      291242.105102287,
      110512.1499144973
    ]
  },
  "EPSG:7575": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151540.292233117,
      90458.71122546683,
      205042.3102889032,
      131687.37214138982
    ]
  },
  "EPSG:7576": {
    proj4: "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151945.66385379553,
      91415.04661391261,
      221867.19411868032,
      131424.37683684574
    ]
  },
  "EPSG:7577": {
    proj4: "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      236620.44998842897,
      91016.21560963197,
      274149.46190714196,
      159903.44174842336
    ]
  },
  "EPSG:7578": {
    proj4: "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182281.14960612674,
      30426.970705976375,
      260635.61101719658,
      65970.15985472902
    ]
  },
  "EPSG:7579": {
    proj4: "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90831.08391199254,
      25163.909417604318,
      177478.98531440998,
      75183.9923995192
    ]
  },
  "EPSG:7580": {
    proj4: "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212968.19001545385,
      91179.61286127553,
      252317.26242130692,
      131172.83311448275
    ]
  },
  "EPSG:7581": {
    proj4: "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212511.61418416703,
      151579.89960071392,
      252882.84319245716,
      210483.3055611073
    ]
  },
  "EPSG:7582": {
    proj4: "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91142.33474615445,
      30274.04451097604,
      122830.10186379087,
      70210.50564087204
    ]
  },
  "EPSG:7583": {
    proj4: "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182218.01450898295,
      30107.48517745373,
      222199.42322749988,
      70064.37386771462
    ]
  },
  "EPSG:7584": {
    proj4: "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151994.89590197825,
      91164.59517810373,
      202189.89334340356,
      141110.60576805158
    ]
  },
  "EPSG:7585": {
    proj4: "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91340.12027735294,
      30248.798631565063,
      148978.38681418708,
      60251.79442425331
    ]
  },
  "EPSG:7586": {
    proj4: "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182920.25159745876,
      121016.50422159376,
      230680.70633727653,
      171011.42387319927
    ]
  },
  "EPSG:7587": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398283.5982922123,
      99799.36247997114,
      590438.588056572,
      322280.16546408896
    ]
  },
  "EPSG:7588": {
    proj4: "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.00182880365760732 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      488748.02803759393,
      100032.11167740649,
      647271.9978899922,
      504886.94420537417
    ]
  },
  "EPSG:7589": {
    proj4: "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      225693.38079328585,
      24462.30054555893,
      387450.9797232746,
      188564.7490672541
    ]
  },
  "EPSG:7590": {
    proj4: "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.457505715 +y_0=148551.483566167 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      646779.6875786147,
      298117.3473101458,
      850489.8612518139,
      611768.408953453
    ]
  },
  "EPSG:7591": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983998 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      35532.13774590033,
      467209.1021039014,
      166104.18330859946,
      627607.2808635036
    ]
  },
  "EPSG:7592": {
    proj4: "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502159 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497980.456301144,
      196481.37600071053,
      647212.7385322687,
      407920.5426478862
    ]
  },
  "EPSG:7593": {
    proj4: "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1277114554 +y_0=59445.9041910084 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      99418.45544102155,
      97339.59852103867,
      318408.20580076333,
      290609.77471732866
    ]
  },
  "EPSG:7594": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      699581.6026837224,
      299331.2820236229,
      922822.8036386675,
      685855.5820756126
    ]
  },
  "EPSG:7595": {
    proj4: "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.7200914402 +y_0=44091.434493269 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      99593.18910051057,
      98263.89427794365,
      293360.6786108921,
      262342.22588109144
    ]
  },
  "EPSG:7596": {
    proj4: "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      598080.2961063201,
      299016.22724976717,
      758975.2351434977,
      525245.8335544119
    ]
  },
  "EPSG:7597": {
    proj4: "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      449658.0080197286,
      299750.6569480374,
      659407.3870530705,
      434620.0953418019
    ]
  },
  "EPSG:7598": {
    proj4: "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.627381255 +y_0=53703.1202438405 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297769.07770151534,
      96107.90719215541,
      447089.66881023266,
      260131.59196493545
    ]
  },
  "EPSG:7599": {
    proj4: "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.294386589 +y_0=146591.989636779 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698940.8142572569,
      397566.83826079045,
      923407.5419993071,
      565238.9479123533
    ]
  },
  "EPSG:7600": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      798284.9290736692,
      498562.36861047207,
      963276.8532772289,
      790294.8287170101
    ]
  },
  "EPSG:7601": {
    proj4: "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.117602235 +y_0=0.00243840487680975 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      399298.8077325951,
      98786.37757759576,
      642241.1231991217,
      375900.35636140296
    ]
  },
  "EPSG:7602": {
    proj4: "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3182626365 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      96837.94185835352,
      97483.49690506568,
      285905.64460683963,
      319937.75129726937
    ]
  },
  "EPSG:7603": {
    proj4: "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.1039370079 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      100921.07432195859,
      99159.67974722617,
      235582.34634817083,
      292397.089468982
    ]
  },
  "EPSG:7604": {
    proj4: "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.44018288 +y_0=91687.9239014478 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297313.3451000871,
      198113.4922896239,
      489660.53122083435,
      296552.25290446193
    ]
  },
  "EPSG:7605": {
    proj4: "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.668224536 +y_0=0.0064008128016256 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297910.3625553503,
      99343.7370594095,
      461285.24470496917,
      215575.13339690238
    ]
  },
  "EPSG:7606": {
    proj4: "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.553213106 +y_0=0.0158496316992634 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      797904.0533067842,
      497766.4024580454,
      959142.877215039,
      756481.7398435547
    ]
  },
  "EPSG:7607": {
    proj4: "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.0100584201168402 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697911.295547503,
      397022.08734912693,
      896298.6249570489,
      659472.0541478838
    ]
  },
  "EPSG:7608": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398583.02724430506,
      100782.11151904009,
      686409.2436955479,
      231798.23072757883
    ]
  },
  "EPSG:7609": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      400119.6197575293,
      195428.62787351833,
      590189.5461573999,
      326666.2327231764
    ]
  },
  "EPSG:7610": {
    proj4: "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.026162052 +y_0=0.00457200914401829 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      298842.10234775086,
      98927.03977901318,
      459280.8707253175,
      244783.34317463878
    ]
  },
  "EPSG:7611": {
    proj4: "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.441960884 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      647594.1164784116,
      199503.490190341,
      809358.7052516593,
      425656.67231733643
    ]
  },
  "EPSG:7612": {
    proj4: "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=24999.9998983998 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2973.652475698542,
      15352.693418329276,
      227759.3185142406,
      208863.8970417321
    ]
  },
  "EPSG:7613": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497911.59279363643,
      99889.52052221916,
      648296.6689807419,
      486005.00852947205
    ]
  },
  "EPSG:7614": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      97592.04017943032,
      100245.80523417224,
      308822.55076639267,
      515278.94755908754
    ]
  },
  "EPSG:7615": {
    proj4: "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.659690119 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398036.2522184328,
      98037.4495689766,
      534835.0934816076,
      236808.54499273264
    ]
  },
  "EPSG:7616": {
    proj4: "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.196850394 +y_0=105279.782880366 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      548418.3516774037,
      296709.82396964356,
      754468.5151595024,
      464453.0683751508
    ]
  },
  "EPSG:7617": {
    proj4: "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.032258065 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299235.6091757258,
      96988.35029125844,
      461265.47429674666,
      261076.6452079079
    ]
  },
  "EPSG:7618": {
    proj4: "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.2669545339 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      101926.87233715766,
      100547.857953878,
      386961.34154209815,
      264622.6921747937
    ]
  },
  "EPSG:7619": {
    proj4: "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.879451359 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      596901.7051220615,
      98659.92690263924,
      841948.1916298391,
      404215.90532204474
    ]
  },
  "EPSG:7620": {
    proj4: "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.012141224 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      197296.36041536092,
      49138.61978819012,
      329650.3680852205,
      147066.91728036696
    ]
  },
  "EPSG:7621": {
    proj4: "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209042418 +y_0=121923.986182372 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      581547.5812789055,
      298095.0589342334,
      758030.1525676642,
      462135.94174372545
    ]
  },
  "EPSG:7622": {
    proj4: "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.367589535 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      396633.6550153474,
      100425.59231760468,
      638117.7866775462,
      358362.13565173314
    ]
  },
  "EPSG:7623": {
    proj4: "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1402082804 +y_0=57588.0347472695 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      100262.65067902808,
      100285.7501396611,
      358418.11280615424,
      264384.3363515884
    ]
  },
  "EPSG:7624": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      397819.7444071887,
      196706.38601872438,
      699804.4966445859,
      368053.79812863935
    ]
  },
  "EPSG:7625": {
    proj4: "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.282245365 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398833.1319655371,
      196592.801983736,
      588437.7673921976,
      390125.2088232643
    ]
  },
  "EPSG:7626": {
    proj4: "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1127762256 +y_0=50022.1874523749 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      93268.14653384674,
      99844.60891120332,
      257824.42929046406,
      263836.8317422866
    ]
  },
  "EPSG:7627": {
    proj4: "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.854457709 +y_0=0.0109728219456439 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698878.7631476879,
      297026.06822522805,
      862110.4139090325,
      523385.98072844424
    ]
  },
  "EPSG:7628": {
    proj4: "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.60477521 +y_0=134255.425450851 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597438.7872503966,
      381404.9925460653,
      727769.3219382592,
      527203.1427378721
    ]
  },
  "EPSG:7629": {
    proj4: "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.292608585 +y_0=0.00670561341122682 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      399679.37766385375,
      198962.76580553912,
      561050.3499810251,
      330175.6241218449
    ]
  },
  "EPSG:7630": {
    proj4: "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.101397003 +y_0=0.0234696469392939 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697595.8893633685,
      500074.23449081084,
      923467.3206588832,
      627580.9034352283
    ]
  },
  "EPSG:7631": {
    proj4: "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.571551943 +y_0=0.00518161036322073 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      496891.8017902882,
      117119.98539138875,
      691055.4705645042,
      302895.21908457164
    ]
  },
  "EPSG:7632": {
    proj4: "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.233731268 +y_0=120734.163169926 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597573.6096755402,
      297925.0901297625,
      824197.1486016241,
      491209.565356178
    ]
  },
  "EPSG:7633": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.32517145 +y_0=0.0094488188976378 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698285.6076879579,
      198909.17946847237,
      955516.8060680021,
      362571.94468181324
    ]
  },
  "EPSG:7634": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.73009906 +y_0=0.0103632207264415 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497178.4417703175,
      296779.9552863025,
      672709.6460083426,
      432044.32030795986
    ]
  },
  "EPSG:7635": {
    proj4: "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.574295149 +y_0=107746.752146304 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      498508.3984829956,
      299917.53192297736,
      727909.2856937051,
      431181.4761627171
    ]
  },
  "EPSG:7636": {
    proj4: "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.913893828 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      776312.2599782047,
      298609.03359451756,
      899438.6932481824,
      524616.5413515357
    ]
  },
  "EPSG:7637": {
    proj4: "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      598034.0713671842,
      99825.82021835749,
      855102.0001800025,
      216437.0999505568
    ]
  },
  "EPSG:7638": {
    proj4: "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.068834138 +y_0=50337.1092710185 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      298001.6475851799,
      82558.5930472567,
      582278.9707696112,
      246666.14863042242
    ]
  },
  "EPSG:7639": {
    proj4: "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.86512573 +y_0=111088.222402845 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698713.1368267841,
      299145.11320503545,
      827810.8852116538,
      430356.2033190995
    ]
  },
  "EPSG:7640": {
    proj4: "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.868173736 +y_0=188358.605943612 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697215.1874497203,
      497308.38774450927,
      829666.4612877521,
      690560.6454662334
    ]
  },
  "EPSG:7641": {
    proj4: "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.441402083 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299022.80959175905,
      99324.09452392724,
      402985.0922102046,
      230348.96741426105
    ]
  },
  "EPSG:7642": {
    proj4: "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.417881636 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597826.9355465558,
      98777.64079819612,
      728999.2739838901,
      229869.5331094937
    ]
  },
  "EPSG:7643": {
    proj4: "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.970942342 +y_0=0.00701041402082804 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      498669.9211106574,
      299095.84271432867,
      663351.341883067,
      462960.3791248493
    ]
  },
  "EPSG:7644": {
    proj4: "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.44018288 +y_0=45069.7588011176 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299671.7112204476,
      99241.26717547637,
      488773.2573500444,
      197676.09587198772
    ]
  },
  "EPSG:7645": {
    proj4: "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.617272035 +y_0=134589.753924308 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      600130.8586909141,
      397034.9806853461,
      756824.9506164662,
      561059.9795756552
    ]
  },
  "EPSG:7651": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7652": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7656": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7657": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7658": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7659": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7660": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7661": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7662": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7663": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7664": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7665": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7677": {
    proj4: "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7678": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7679": {
    proj4: "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7680": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7681": {
    proj4: "+proj=geocent +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4637130591997724e-9,
      1.5894532841116982e6,
      -525599.4983168814,
      -102451.82351448534
    ]
  },
  "EPSG:7682": {
    proj4: "+proj=longlat +ellps=GSK2011 +no_defs +type=crs",
    projected_bounds: [18.92, 39.87, -168.97, 85.2]
  },
  "EPSG:7683": {
    proj4: "+proj=longlat +ellps=GSK2011 +no_defs +type=crs",
    projected_bounds: [18.92, 39.87, -168.97, 85.2]
  },
  "EPSG:7684": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175455763665586e-8,
      462863720815239e-8,
      785161.1178787948,
      4588559499818429e-9
    ]
  },
  "EPSG:7685": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [69.24, 39.19, 80.29, 43.22]
  },
  "EPSG:7686": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [69.24, 39.19, 80.29, 43.22]
  },
  "EPSG:7692": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=68.5166666666667 +k=1 +x_0=1300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3622077752749862e6,
      4390117695471778e-9,
      1.4279649680650164e6,
      4469784779298123e-9
    ]
  },
  "EPSG:7693": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=71.5166666666667 +k=1 +x_0=2300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      216982961043121e-8,
      4355422395251061e-9,
      2.4229217536589853e6,
      4759674330101149e-9
    ]
  },
  "EPSG:7694": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=74.5166666666667 +k=1 +x_0=3300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.1701253681651945e6,
      4373186931685846e-9,
      3422145897384635e-9,
      4803001740906824e-9
    ]
  },
  "EPSG:7695": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=77.5166666666667 +k=1 +x_0=4300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4.1719967967405007e6,
      4484225636424588e-9,
      4422584261729792e-9,
      4778560298011349e-9
    ]
  },
  "EPSG:7696": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=80.5166666666667 +k=1 +x_0=5300000 +y_0=14743.5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5174507522634817e-9,
      4629713485045295e-9,
      5281457543679501e-9,
      4.7552701466987105e6
    ]
  },
  "EPSG:7699": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7700": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7707": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7755": {
    proj4: "+proj=lcc +lat_0=24 +lon_0=80 +lat_1=12.472955 +lat_2=35.1728044444444 +x_0=4000000 +y_0=4000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      233845337899335e-8,
      1.8566968875986547e6,
      5578233109134518e-9,
      5357415547826733e-9
    ]
  },
  "EPSG:7756": {
    proj4: "+proj=lcc +lat_0=16.25543298 +lon_0=80.875 +lat_1=13.75 +lat_2=18.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      551369.6799084009,
      601289.198318972,
      1.4124223362498973e6,
      1.4094574765669643e6
    ]
  },
  "EPSG:7757": {
    proj4: "+proj=lcc +lat_0=28.00157897 +lon_0=94.5 +lat_1=27 +lat_2=29 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      706289.1879097655,
      853792.3276554892,
      1283248000721598e-9,
      1.1661291911029688e6
    ]
  },
  "EPSG:7758": {
    proj4: "+proj=lcc +lat_0=26.00257703 +lon_0=92.75 +lat_1=24.6666666666667 +lat_2=27.3333333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      688900.9684217039,
      796228.797439662,
      1.3227579817295824e6,
      1.2231401815696876e6
    ]
  },
  "EPSG:7759": {
    proj4: "+proj=lcc +lat_0=25.87725247 +lon_0=85.875 +lat_1=24.625 +lat_2=27.125 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      739552.5131192901,
      825629.4257639237,
      1.2389080727994018e6,
      1.2218898938153675e6
    ]
  },
  "EPSG:7760": {
    proj4: "+proj=lcc +lat_0=28.62510126 +lon_0=77 +lat_1=28.375 +lat_2=28.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      983340.6710762054,
      975064.5427536415,
      1.0331642371212617e6,
      1.0294061652439071e6
    ]
  },
  "EPSG:7761": {
    proj4: "+proj=lcc +lat_0=22.37807121 +lon_0=71.375 +lat_1=20.7916666666667 +lat_2=23.9583333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      660405.598714418,
      745925.0913441492,
      1.3143004859778525e6,
      1261480880023685e-9
    ]
  },
  "EPSG:7762": {
    proj4: "+proj=lcc +lat_0=29.25226266 +lon_0=76 +lat_1=28.0833333333333 +lat_2=30.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      848013.0188382242,
      823438.1624354101,
      1.1529325120768847e6,
      11881245220205e-7
    ]
  },
  "EPSG:7763": {
    proj4: "+proj=lcc +lat_0=31.75183497 +lon_0=77.375 +lat_1=30.75 +lat_2=32.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      826494.6074184473,
      849350.6916511247,
      1.1514384267074321e6,
      1.1683731461395768e6
    ]
  },
  "EPSG:7764": {
    proj4: "+proj=lcc +lat_0=34.75570874 +lon_0=76.5 +lat_1=33.0833333333333 +lat_2=36.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      741751.5922655747,
      727851.9908205424,
      1.2783682108159144e6,
      1.0879023247321974e6
    ]
  },
  "EPSG:7765": {
    proj4: "+proj=lcc +lat_0=23.62652682 +lon_0=85.625 +lat_1=22.5416666666667 +lat_2=24.7083333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      761866.956093254,
      817373.6118624898,
      1237113860410398e-9,
      1.1928489641822642e6
    ]
  },
  "EPSG:7766": {
    proj4: "+proj=lcc +lat_0=24.00529821 +lon_0=78.375 +lat_1=22 +lat_2=26 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      548219.7660178377,
      681977.4684090639,
      1.4408779764952476e6,
      1.3253414703771253e6
    ]
  },
  "EPSG:7767": {
    proj4: "+proj=lcc +lat_0=18.88015774 +lon_0=76.75 +lat_1=16.625 +lat_2=21.125 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      554595.6057840632,
      642279.9630149327,
      1.4287022324415215e6,
      1.3547603232138273e6
    ]
  },
  "EPSG:7768": {
    proj4: "+proj=lcc +lat_0=24.75060911 +lon_0=94 +lat_1=24.0833333333333 +lat_2=25.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      895061.4113827385,
      899536.1215581557,
      1076286597879897e-9,
      1.1053795228302085e6
    ]
  },
  "EPSG:7769": {
    proj4: "+proj=lcc +lat_0=25.62524747 +lon_0=91.375 +lat_1=25.2083333333333 +lat_2=26.0416666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      843060.0691360368,
      934981.4087346944,
      1.1435213906028843e6,
      1.0555882158136417e6
    ]
  },
  "EPSG:7770": {
    proj4: "+proj=lcc +lat_0=26.12581974 +lon_0=94.375 +lat_1=25.375 +lat_2=26.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      894675.0319837772,
      897862.2940690425,
      108681279613778e-8,
      1.1026840790282744e6
    ]
  },
  "EPSG:7771": {
    proj4: "+proj=lcc +lat_0=25.63452135 +lon_0=93.5 +lat_1=23.0416666666667 +lat_2=28.2083333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      606052.1382013013,
      596612.5953813444,
      1.3806374454463618e6,
      1.4305415176798194e6
    ]
  },
  "EPSG:7772": {
    proj4: "+proj=lcc +lat_0=20.25305174 +lon_0=84.375 +lat_1=18.5833333333333 +lat_2=21.9166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      682321.947064034,
      731371.8600800973,
      1321497125846816e-9,
      1259535360598428e-9
    ]
  },
  "EPSG:7773": {
    proj4: "+proj=lcc +lat_0=31.00178226 +lon_0=75.375 +lat_1=30 +lat_2=32 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      854102.6797243422,
      838945.2251348211,
      1.1469719631902876e6,
      1.1760272778719787e6
    ]
  },
  "EPSG:7774": {
    proj4: "+proj=lcc +lat_0=26.88505546 +lon_0=73.875 +lat_1=24.2916666666667 +lat_2=29.4583333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      549170.684156403,
      584225.8289711158,
      1.4234035783322402e6,
      1.3745681739633775e6
    ]
  },
  "EPSG:7775": {
    proj4: "+proj=lcc +lat_0=27.13270823 +lon_0=80.875 +lat_1=24.875 +lat_2=29.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      613202.692670013,
      644481.9553145852,
      1.3619984366672747e6,
      1369683501028669e-9
    ]
  },
  "EPSG:7776": {
    proj4: "+proj=lcc +lat_0=30.0017132 +lon_0=79.375 +lat_1=29 +lat_2=31 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      822646.6595309718,
      858238.6439539723,
      1.1563350559027756e6,
      1.1650058666594662e6
    ]
  },
  "EPSG:7777": {
    proj4: "+proj=tmerc +lat_0=10.25 +lon_0=93.25 +k=0.9999428 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      878378.92207602,
      607533.1645919939,
      1.1168111425739669e6,
      1.3852056850527062e6
    ]
  },
  "EPSG:7778": {
    proj4: "+proj=tmerc +lat_0=21 +lon_0=82.25 +k=0.9998332 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      785807.6091547575,
      644768.4239953428,
      1.2175609602404628e6,
      1345998028168748e-9
    ]
  },
  "EPSG:7779": {
    proj4: "+proj=tmerc +lat_0=15.375 +lon_0=74 +k=0.9999913 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      958028.2252342092,
      943052.4593426271,
      1.0374989462317998e6,
      1.0470589392384476e6
    ]
  },
  "EPSG:7780": {
    proj4: "+proj=tmerc +lat_0=15.125 +lon_0=76.375 +k=0.9998012 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      740936.3114330955,
      607852.3925440682,
      1.2329074985520325e6,
      1.3704215881367845e6
    ]
  },
  "EPSG:7781": {
    proj4: "+proj=tmerc +lat_0=10.5 +lon_0=76 +k=0.9999177 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      868893.3438423031,
      751357.1370368889,
      1.1520005794091239e6,
      1.2548158654920268e6
    ]
  },
  "EPSG:7782": {
    proj4: "+proj=tmerc +lat_0=10 +lon_0=73.125 +k=0.9999536 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      880446.6909949868,
      802192.9617752031,
      1069211852777746e-9,
      1194749650321432e-9
    ]
  },
  "EPSG:7783": {
    proj4: "+proj=tmerc +lat_0=23.125 +lon_0=92.75 +k=0.9999821 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      948347.6832798012,
      868862.5553235526,
      1.0709313980639717e6,
      1155788972095225e-9
    ]
  },
  "EPSG:7784": {
    proj4: "+proj=tmerc +lat_0=27.625 +lon_0=88.5 +k=0.9999926 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      951399.5776550408,
      939704.0971841511,
      1.0412583702217728e6,
      1057141942816731e-9
    ]
  },
  "EPSG:7785": {
    proj4: "+proj=tmerc +lat_0=10.875 +lon_0=78.375 +k=0.9997942 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      762432.0040340228,
      684912.9250912332,
      1219146875769154e-9,
      1.3011934885573897e6
    ]
  },
  "EPSG:7786": {
    proj4: "+proj=tmerc +lat_0=23.75 +lon_0=91.75 +k=0.9999822 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      938459.6310348815,
      910420.6064166136,
      1.0597800206656777e6,
      1.0876269402043642e6
    ]
  },
  "EPSG:7787": {
    proj4: "+proj=tmerc +lat_0=24.375 +lon_0=87.875 +k=0.9998584 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      787042.4406179728,
      681950.4889355924,
      1.1985951873429667e6,
      1.3178370969306666e6
    ]
  },
  "EPSG:7789": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7791": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226028.37041470746,
      4.0470930109668463e6,
      727899.151793387,
      5213977493738186e-9
    ]
  },
  "EPSG:7792": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225503.37015502725,
      3.8538577796685467e6,
      727643.3224890253,
      5220644504847022e-9
    ]
  },
  "EPSG:7793": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224488.26420493022,
      3850556815798412e-9,
      332597.54724696174,
      4611758561637851e-9
    ]
  },
  "EPSG:7794": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6444735932303637e-9,
      3.8590024174948805e6,
      7529745295968068e-9,
      5234265085420701e-9
    ]
  },
  "EPSG:7795": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2443901784981109e-9,
      3.8647996169202602e6,
      3.5305411076295115e6,
      5242128277837456e-9
    ]
  },
  "EPSG:7796": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4441929252771132e-9,
      1.8272042933714949e6,
      3.9093678674707976e6,
      2.3816081423685336e6
    ]
  },
  "EPSG:7797": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [22.36, 41.24, 31.35, 44.23]
  },
  "EPSG:7798": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [22.36, 41.24, 31.35, 44.23]
  },
  "EPSG:7799": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      613824.5003168427,
      4575173125045112e-9,
      739594.3261291451,
      4901796356994393e-9
    ]
  },
  "EPSG:7800": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      248597.583698968,
      4569740776038191e-9,
      740718.6912419953,
      4892939521879331e-9
    ]
  },
  "EPSG:7801": {
    proj4: "+proj=lcc +lat_0=42.6678756833333 +lon_0=25.5 +lat_1=42 +lat_2=43.3333333333333 +x_0=500000 +y_0=4725824.3591 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      236773.58237551985,
      457211026829569e-8,
      754086.1937682964,
      4904167976880861e-9
    ]
  },
  "EPSG:7803": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      613824.5003168427,
      4575173125045112e-9,
      739594.3261291451,
      4901796356994393e-9
    ]
  },
  "EPSG:7805": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      253727.65883927772,
      4716318293271378e-9,
      366980.823636331,
      4.8365442668980695e6
    ]
  },
  "EPSG:7815": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:7816": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7825": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=23.5 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1986916491607307e6,
      5277944584794232e-9,
      1.4038874243908834e6,
      5746406276413149e-9
    ]
  },
  "EPSG:7826": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=26.5 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2187456932616228e-9,
      5279263554299616e-9,
      2.4037950553952022e6,
      5750856631043761e-9
    ]
  },
  "EPSG:7827": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=29.5 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3182098739186065e-9,
      4996916825791124e-9,
      3403494503787151e-9,
      5.7653204790202845e6
    ]
  },
  "EPSG:7828": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=32.5 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4180336873778391e-9,
      4901345719843465e-9,
      4402822106992987e-9,
      5797587061697322e-9
    ]
  },
  "EPSG:7829": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=35.5 +k=1 +x_0=5300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5180357205499923e-9,
      4902456934417012e-9,
      5403123856074191e-9,
      5783122547993956e-9
    ]
  },
  "EPSG:7830": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=38.5 +k=1 +x_0=6300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6185489884367378e-9,
      5176982684646076e-9,
      6407268779979651e-9,
      5581763134653685e-9
    ]
  },
  "EPSG:7831": {
    proj4: "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=41.5 +k=1 +x_0=7300000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7189803337618188e-9,
      5399351985587e-6,
      720461752231582e-8,
      5490300446843198e-9
    ]
  },
  "EPSG:7832": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7837": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7839": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7841": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7842": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -187000.39268983566,
      3138322518735391e-9,
      -6.2664553650716785e6,
      731704.4997082698
    ]
  },
  "EPSG:7843": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:7844": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:7845": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=134 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7526853488839234e6,
      -5065635719046252e-9,
      2.2192747621920486e6,
      -1.3330055356387005e6
    ]
  },
  "EPSG:7846": {
    proj4: "+proj=utm +zone=46 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      543982.7439616378,
      8290752981076046e-9,
      831369.1908562363,
      905138891255792e-8
    ]
  },
  "EPSG:7847": {
    proj4: "+proj=utm +zone=47 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      178205.5417423764,
      8277472621805217e-9,
      647505.8040450831,
      9063488224004656e-9
    ]
  },
  "EPSG:7848": {
    proj4: "+proj=utm +zone=48 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      237969.66973216366,
      6158719846304946e-9,
      831104.4355892052,
      901817823848433e-8
    ]
  },
  "EPSG:7849": {
    proj4: "+proj=utm +zone=49 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      236006.67164573778,
      5807695060841706e-9,
      829272.3553011138,
      8813370104420144e-9
    ]
  },
  "EPSG:7850": {
    proj4: "+proj=utm +zone=50 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      238487.90065300977,
      5731110761738591e-9,
      827731.7540110351,
      86650117986882e-7
    ]
  },
  "EPSG:7851": {
    proj4: "+proj=utm +zone=51 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      236829.50091370137,
      5782167689110662e-9,
      829550.5266798225,
      8842154943583598e-9
    ]
  },
  "EPSG:7852": {
    proj4: "+proj=utm +zone=52 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      233488.18310987734,
      5858719402739382e-9,
      829795.0524706775,
      899272559717385e-8
    ]
  },
  "EPSG:7853": {
    proj4: "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      246575.30941320778,
      5489105418000078e-9,
      831095.4547267796,
      9017071209460307e-9
    ]
  },
  "EPSG:7854": {
    proj4: "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      277047.6690437427,
      4658229252789943e-9,
      830913.7291054368,
      8994930538504545e-9
    ]
  },
  "EPSG:7855": {
    proj4: "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      289013.4663105268,
      4358119671970695e-9,
      830774.8002619529,
      8978324920725435e-9
    ]
  },
  "EPSG:7856": {
    proj4: "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      327480.12220176414,
      3460530811405612e-9,
      824285.6729657773,
      8464614441403877e-9
    ]
  },
  "EPSG:7857": {
    proj4: "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      335491.0396864221,
      3.2835824012734434e6,
      823991.365857983,
      8441361192927027e-9
    ]
  },
  "EPSG:7858": {
    proj4: "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      329633.6227806935,
      3412679943005142e-9,
      800470.6958234934,
      7127517715836319e-9
    ]
  },
  "EPSG:7859": {
    proj4: "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs",
    projected_bounds: [
      218065.20305957436,
      6402392035948924e-9,
      735995.3593227603,
      7165412326919317e-9
    ]
  },
  "EPSG:7877": {
    proj4: "+proj=tmerc +lat_0=-15.9666666666667 +lon_0=-5.71666666666667 +k=1 +x_0=300000 +y_0=2000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      285733.8530399954,
      1.9874538801060477e6,
      314639.4994727614,
      2012905483629854e-9
    ]
  },
  "EPSG:7878": {
    proj4: "+proj=utm +zone=30 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      195076.13383011933,
      8220092368253738e-9,
      223665.58475666196,
      8245935680089607e-9
    ]
  },
  "EPSG:7879": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      6098247397365842e-9,
      -624814.492582683,
      6108091282755866e-9,
      -596751.0359441766
    ]
  },
  "EPSG:7880": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:7881": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:7882": {
    proj4: "+proj=tmerc +lat_0=-15.9666666666667 +lon_0=-5.71666666666667 +k=1 +x_0=299483.737 +y_0=2000527.879 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      285218.16692508064,
      1.9879819362037347e6,
      314122.6449303392,
      2013433181291595e-9
    ]
  },
  "EPSG:7883": {
    proj4: "+proj=utm +zone=30 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      195088.46721007087,
      822011373101287e-8,
      223676.75296796765,
      8245956668221822e-9
    ]
  },
  "EPSG:7884": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6098247397365842e-9,
      -624814.492582683,
      6108091282755866e-9,
      -596751.0359441766
    ]
  },
  "EPSG:7885": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:7886": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:7887": {
    proj4: "+proj=utm +zone=30 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195088.46720968396,
      822011373106924e-8,
      223676.7529676272,
      8245956668277448e-9
    ]
  },
  "EPSG:7888": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7889": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7890": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7899": {
    proj4: "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2150916112417634e-9,
      2.2483723746383237e6,
      2966077313809796e-9,
      2822830306610196e-9
    ]
  },
  "EPSG:7900": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7901": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7902": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7903": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7904": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7905": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7906": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7907": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7908": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7909": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7910": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7911": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7912": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:7914": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7915": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7916": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7917": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7918": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7919": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7920": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7921": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7922": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7923": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7924": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7925": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7926": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7927": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7928": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7929": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7930": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:7931": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:7954": {
    proj4: "+proj=utm +zone=30 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      195076.13383011933,
      8220092368253738e-9,
      223665.58475666196,
      8245935680089607e-9
    ]
  },
  "EPSG:7955": {
    proj4: "+proj=utm +zone=30 +south +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      195088.46721007087,
      822011373101287e-8,
      223676.75296796765,
      8245956668221822e-9
    ]
  },
  "EPSG:7956": {
    proj4: "+proj=utm +zone=30 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      195088.46720968396,
      822011373106924e-8,
      223676.7529676272,
      8245956668277448e-9
    ]
  },
  "EPSG:7962": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7968": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7976": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7979": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:7991": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      181021.46955947802,
      4680923807973328e-9,
      418915.025752377,
      5244286946064119e-9
    ]
  },
  "EPSG:7992": {
    proj4: "+proj=utm +zone=33 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      144579.96922748914,
      9331317929660372e-9,
      208717.54518015665,
      9359327367454275e-9
    ]
  },
  "EPSG:8013": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117.883333333333 +k=1.0000044 +x_0=50000 +y_0=4100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      19648.36557945645,
      202041.11717245262,
      80827.06443088877,
      253073.11986334762
    ]
  },
  "EPSG:8014": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.25 +k=1.0000022 +x_0=60000 +y_0=2700000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      23908.904009375146,
      244006.1428296375,
      95532.82567435948,
      464344.22936117137
    ]
  },
  "EPSG:8015": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=122.333333333333 +k=1.00000298 +x_0=50000 +y_0=2300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      23184.2299696209,
      299032.4130556991,
      80566.31909029241,
      447332.25991079793
    ]
  },
  "EPSG:8016": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.433333333333 +k=0.99999592 +x_0=50000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      26527.58069004718,
      264055.0036854176,
      90622.76126239759,
      302818.61736982735
    ]
  },
  "EPSG:8017": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=113.666666666667 +k=0.99999796 +x_0=50000 +y_0=3050000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      16152.2452057263,
      228520.4613510212,
      84174.24374516096,
      505428.76987526333
    ]
  },
  "EPSG:8018": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34133.4548090295,
      224427.6757417305,
      65880.31250578944,
      254293.52083718148
    ]
  },
  "EPSG:8019": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      37488.866455049305,
      243052.8723625047,
      62534.70570337218,
      299470.06277850596
    ]
  },
  "EPSG:8020": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.933333333333 +k=1.000019 +x_0=40000 +y_0=4100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      21363.491577163386,
      261924.75942003634,
      83489.11108990818,
      419358.24927450484
    ]
  },
  "EPSG:8021": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121.883333333333 +k=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20304.852384749152,
      230806.63809494907,
      79483.08228192297,
      360587.45685840957
    ]
  },
  "EPSG:8022": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114.066666666667 +k=1.00000236 +x_0=50000 +y_0=2750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      17397.28673656564,
      269651.3958616024,
      68964.46451467006,
      343864.74861506745
    ]
  },
  "EPSG:8023": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114.583333333333 +k=1.00000628 +x_0=50000 +y_0=3450000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      42861.32256367125,
      229624.57158740703,
      90801.52339046105,
      298272.5135691962
    ]
  },
  "EPSG:8024": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=1.00004949 +x_0=60000 +y_0=3800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      12879.484146091025,
      230138.94364134502,
      93210.3786724527,
      618234.2516334839
    ]
  },
  "EPSG:8025": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114.983333333333 +k=1.00000314 +x_0=50000 +y_0=3650000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      35316.37769669027,
      247830.43165699672,
      84726.64529785074,
      431801.12335816724
    ]
  },
  "EPSG:8026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114.315277777778 +k=1.000014 +x_0=55000 +y_0=3700000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14341.832726689245,
      546032.0423014387,
      98087.91715814138,
      694524.2482945528
    ]
  },
  "EPSG:8027": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=116.933333333333 +k=0.9999989 +x_0=50000 +y_0=2550000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13244.118219556884,
      235742.5295358235,
      83085.70624211256,
      309928.1007188577
    ]
  },
  "EPSG:8028": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=128.75 +k=1.0000165 +x_0=50000 +y_0=2100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      23342.98833603086,
      247312.4889448178,
      76919.1255964007,
      468630.41374155856
    ]
  },
  "EPSG:8029": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.366666666667 +k=1.00000157 +x_0=50000 +y_0=3750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29413.91838758458,
      264671.76580131706,
      74267.39721225605,
      351144.36532393703
    ]
  },
  "EPSG:8030": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.166666666667 +k=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31001.505280215628,
      239709.23526388127,
      56813.574451508845,
      340665.55532277096
    ]
  },
  "EPSG:8031": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.816666666667 +k=0.99999906 +x_0=50000 +y_0=3900000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      14966.946525556632,
      200610.56495344825,
      76014.19200440164,
      432408.8104391033
    ]
  },
  "EPSG:8032": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=118.6 +k=1.00000135 +x_0=50000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13559.484527002664,
      200130.81018318748,
      88695.1713307804,
      276517.3152629691
    ]
  },
  "EPSG:8035": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-63 +k=0.9996 +x_0=500000.0001016 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9678021399246994e6,
      356545246631977e-8,
      2.7145196966739777e6,
      4481584569853095e-9
    ]
  },
  "EPSG:8036": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-57 +k=0.9996 +x_0=500000.0001016 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      561091.4412013779,
      3.6134229169669095e6,
      1540485296141457e-9,
      44211831591245e-7
    ]
  },
  "EPSG:8042": {
    proj4: "+proj=longlat +a=6376045 +rf=310 +pm=ferro +no_defs +type=crs",
    projected_bounds: [29.73666666666667, 46.93, 34.49666666666667, 51.06]
  },
  "EPSG:8043": {
    proj4: "+proj=longlat +a=6376045 +rf=310 +pm=ferro +no_defs +type=crs",
    projected_bounds: [32.07666666666667, 47.42, 36.52666666666667, 50.45]
  },
  "EPSG:8044": {
    proj4: "+proj=cass +lat_0=48.0384638888889 +lon_0=31.8041805555556 +x_0=0 +y_0=0 +a=6376045 +rf=310 +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -157371.5490559414,
      -121129.92596368476,
      188643.97563448982,
      339406.68754889787
    ]
  },
  "EPSG:8045": {
    proj4: "+proj=cass +lat_0=48.2087611111111 +lon_0=34.0409222222222 +x_0=0 +y_0=0 +a=6376045 +rf=310 +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -148144.13714879192,
      -85804.62478161343,
      176444.15980008565,
      252141.3960201523
    ]
  },
  "EPSG:8050": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:8051": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:8052": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:8053": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "EPSG:8058": {
    proj4: "+proj=lcc +lat_0=-33.25 +lon_0=147 +lat_1=-30.75 +lat_2=-35.75 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8768078383760821e-9,
      4.0098458103185324e6,
      9958614107648712e-9,
      5044516158964828e-9
    ]
  },
  "EPSG:8059": {
    proj4: "+proj=lcc +lat_0=-32 +lon_0=135 +lat_1=-28 +lat_2=-36 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      471559.8940370092,
      1305574975884134e-9,
      1603250901256566e-9,
      2.6489402061111545e6
    ]
  },
  "EPSG:8065": {
    proj4: "+proj=omerc +lat_0=32.25 +lonc=-111.4 +alpha=45 +gamma=45 +k=1.00011 +x_0=48768 +y_0=243840 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      106960.57676724908,
      501696.26683106227,
      455954.6411824681,
      899574.7751345761
    ]
  },
  "EPSG:8066": {
    proj4: "+proj=tmerc +lat_0=31.25 +lon_0=-112.166666666667 +k=1.00009 +x_0=548640 +y_0=304800 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.6898602184777418e6,
      1.0911271759941308e6,
      1987046726068519e-9,
      1.4589552418602472e6
    ]
  },
  "EPSG:8067": {
    proj4: "+proj=tmerc +lat_0=31.5 +lon_0=-113.166666666667 +k=1.000055 +x_0=182880 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      549251.4834872519,
      109178.67101177771,
      802455.8558619391,
      368083.9764622349
    ]
  },
  "EPSG:8068": {
    proj4: "+proj=lcc +lat_1=30.5 +lat_0=30.5 +lon_0=-110.75 +k_0=0.9998 +x_0=9144 +y_0=-188976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -7079.682530575667,
      45696.28139434231,
      73187.4091967886,
      103936.21928208084
    ]
  },
  "EPSG:8082": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=24500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2438100319203076e-8,
      4945538329990778e-9,
      2463440308344092e-8,
      5217139633297954e-9
    ]
  },
  "EPSG:8083": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      25355838948450495e-9,
      4809327862800602e-9,
      2561614100869219e-8,
      5098893217257592e-9
    ]
  },
  "EPSG:8084": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7474945428760527e6,
      -1.6423883063142947e6,
      2.2203944136126074e6,
      -215755.45437617964
    ]
  },
  "EPSG:8085": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:8086": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-30.87, 59.96, -5.55, 69.59]
  },
  "EPSG:8088": {
    proj4: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0383842890319137e6,
      -200072.38326692604,
      3221477132962391e-9,
      868116.0339988441
    ]
  },
  "EPSG:8089": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8090": {
    proj4: "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90803.26018885498,
      30280.031514958442,
      140600.02386158615,
      65707.43197342718
    ]
  },
  "EPSG:8091": {
    proj4: "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.668224536 +y_0=0.0064008128016256 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297910.3625553503,
      99343.7370594095,
      461285.24470496917,
      215575.13339690238
    ]
  },
  "EPSG:8092": {
    proj4: "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90621.28884620419,
      60385.11321865599,
      149248.8284308871,
      90389.30746244712
    ]
  },
  "EPSG:8093": {
    proj4: "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.44018288 +y_0=91687.9239014478 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297313.3451000871,
      198113.4922896239,
      489660.53122083435,
      296552.25290446193
    ]
  },
  "EPSG:8095": {
    proj4: "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182920.25159745876,
      121016.50422159376,
      230680.70633727653,
      171011.42387319927
    ]
  },
  "EPSG:8096": {
    proj4: "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.617272035 +y_0=134589.753924308 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      600130.8586909141,
      397034.9806853461,
      756824.9506164662,
      561059.9795756552
    ]
  },
  "EPSG:8097": {
    proj4: "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91340.12027735294,
      30248.798631565063,
      148978.38681418708,
      60251.79442425331
    ]
  },
  "EPSG:8098": {
    proj4: "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.44018288 +y_0=45069.7588011176 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299671.7112204476,
      99241.26717547637,
      488773.2573500444,
      197676.09587198772
    ]
  },
  "EPSG:8099": {
    proj4: "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151994.89590197825,
      91164.59517810373,
      202189.89334340356,
      141110.60576805158
    ]
  },
  "EPSG:8100": {
    proj4: "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.970942342 +y_0=0.00701041402082804 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      498669.9211106574,
      299095.84271432867,
      663351.341883067,
      462960.3791248493
    ]
  },
  "EPSG:8101": {
    proj4: "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182218.01450898295,
      30107.48517745373,
      222199.42322749988,
      70064.37386771462
    ]
  },
  "EPSG:8102": {
    proj4: "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.417881636 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597826.9355465558,
      98777.64079819612,
      728999.2739838901,
      229869.5331094937
    ]
  },
  "EPSG:8103": {
    proj4: "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91142.33474615445,
      30274.04451097604,
      122830.10186379087,
      70210.50564087204
    ]
  },
  "EPSG:8104": {
    proj4: "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.441402083 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299022.80959175905,
      99324.09452392724,
      402985.0922102046,
      230348.96741426105
    ]
  },
  "EPSG:8105": {
    proj4: "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212511.61418416703,
      151579.89960071392,
      252882.84319245716,
      210483.3055611073
    ]
  },
  "EPSG:8106": {
    proj4: "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.868173736 +y_0=188358.605943612 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697215.1874497203,
      497308.38774450927,
      829666.4612877521,
      690560.6454662334
    ]
  },
  "EPSG:8107": {
    proj4: "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212968.19001545385,
      91179.61286127553,
      252317.26242130692,
      131172.83311448275
    ]
  },
  "EPSG:8108": {
    proj4: "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.86512573 +y_0=111088.222402845 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698713.1368267841,
      299145.11320503545,
      827810.8852116538,
      430356.2033190995
    ]
  },
  "EPSG:8109": {
    proj4: "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90831.08391199254,
      25163.909417604318,
      177478.98531440998,
      75183.9923995192
    ]
  },
  "EPSG:8110": {
    proj4: "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.068834138 +y_0=50337.1092710185 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      298001.6475851799,
      82558.5930472567,
      582278.9707696112,
      246666.14863042242
    ]
  },
  "EPSG:8111": {
    proj4: "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182281.14960612674,
      30426.970705976375,
      260635.61101719658,
      65970.15985472902
    ]
  },
  "EPSG:8112": {
    proj4: "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      598034.0713671842,
      99825.82021835749,
      855102.0001800025,
      216437.0999505568
    ]
  },
  "EPSG:8113": {
    proj4: "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      236620.44998842897,
      91016.21560963197,
      274149.46190714196,
      159903.44174842336
    ]
  },
  "EPSG:8114": {
    proj4: "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.913893828 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      776312.2599782047,
      298609.03359451756,
      899438.6932481824,
      524616.5413515357
    ]
  },
  "EPSG:8115": {
    proj4: "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151945.66385379553,
      91415.04661391261,
      221867.19411868032,
      131424.37683684574
    ]
  },
  "EPSG:8116": {
    proj4: "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.574295149 +y_0=107746.752146304 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      498508.3984829956,
      299917.53192297736,
      727909.2856937051,
      431181.4761627171
    ]
  },
  "EPSG:8117": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151540.292233117,
      90458.71122546683,
      205042.3102889032,
      131687.37214138982
    ]
  },
  "EPSG:8118": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.73009906 +y_0=0.0103632207264415 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497178.4417703175,
      296779.9552863025,
      672709.6460083426,
      432044.32030795986
    ]
  },
  "EPSG:8119": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212837.8790275974,
      60627.63930844978,
      291242.105102287,
      110512.1499144973
    ]
  },
  "EPSG:8120": {
    proj4: "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.32517145 +y_0=0.0094488188976378 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698285.6076879579,
      198909.17946847237,
      955516.8060680021,
      362571.94468181324
    ]
  },
  "EPSG:8121": {
    proj4: "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182140.80037943766,
      90807.74901712377,
      251215.79319409363,
      149720.97489258696
    ]
  },
  "EPSG:8122": {
    proj4: "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.233731268 +y_0=120734.163169926 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597573.6096755402,
      297925.0901297625,
      824197.1486016241,
      491209.565356178
    ]
  },
  "EPSG:8123": {
    proj4: "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151452.924139585,
      35698.24286217081,
      210634.12874437525,
      92322.64734066189
    ]
  },
  "EPSG:8124": {
    proj4: "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.571551943 +y_0=0.00518161036322073 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      496891.8017902882,
      117119.98539138875,
      691055.4705645042,
      302895.21908457164
    ]
  },
  "EPSG:8125": {
    proj4: "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212627.65223625637,
      152422.93144901525,
      281473.4021866292,
      191287.04187149453
    ]
  },
  "EPSG:8126": {
    proj4: "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.101397003 +y_0=0.0234696469392939 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697595.8893633685,
      500074.23449081084,
      923467.3206588832,
      627580.9034352283
    ]
  },
  "EPSG:8127": {
    proj4: "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121822.5179483935,
      60643.972399859515,
      171008.4886826088,
      100637.73160218791
    ]
  },
  "EPSG:8128": {
    proj4: "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.292608585 +y_0=0.00670561341122682 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      399679.37766385375,
      198962.76580553912,
      561050.3499810251,
      330175.6241218449
    ]
  },
  "EPSG:8129": {
    proj4: "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182099.70657812397,
      116252.47408213816,
      221824.5330006373,
      160691.839139331
    ]
  },
  "EPSG:8130": {
    proj4: "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.60477521 +y_0=134255.425450851 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      597438.7872503966,
      381404.9925460653,
      727769.3219382592,
      527203.1427378721
    ]
  },
  "EPSG:8131": {
    proj4: "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213018.6731870523,
      90533.72658968088,
      262771.7798453235,
      159528.3659099398
    ]
  },
  "EPSG:8132": {
    proj4: "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.854457709 +y_0=0.0109728219456439 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698878.7631476879,
      297026.06822522805,
      862110.4139090325,
      523385.98072844424
    ]
  },
  "EPSG:8133": {
    proj4: "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      28428.187943666828,
      30432.697609155195,
      78585.04324159437,
      80417.62709792836
    ]
  },
  "EPSG:8134": {
    proj4: "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1127762256 +y_0=50022.1874523749 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      93268.14653384674,
      99844.60891120332,
      257824.42929046406,
      263836.8317422866
    ]
  },
  "EPSG:8135": {
    proj4: "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121564.58180689419,
      59921.60599664292,
      179356.19026815722,
      118910.4015789223
    ]
  },
  "EPSG:8136": {
    proj4: "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.282245365 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398833.1319655371,
      196592.801983736,
      588437.7673921976,
      390125.2088232643
    ]
  },
  "EPSG:8137": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121255.70072604134,
      59956.226239184434,
      213300.8372982731,
      112183.02190387783
    ]
  },
  "EPSG:8138": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      397819.7444071887,
      196706.38601872438,
      699804.4966445859,
      368053.79812863935
    ]
  },
  "EPSG:8139": {
    proj4: "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30560.116938921456,
      30567.157629614754,
      109246.05916715396,
      80584.50674170842
    ]
  },
  "EPSG:8140": {
    proj4: "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1402082804 +y_0=57588.0347472695 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      100262.65067902808,
      100285.7501396611,
      358418.11280615424,
      264384.3363515884
    ]
  },
  "EPSG:8141": {
    proj4: "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      120894.17984750256,
      30609.78170516271,
      194498.69038716183,
      109228.99735183635
    ]
  },
  "EPSG:8142": {
    proj4: "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.367589535 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      396633.6550153474,
      100425.59231760468,
      638117.7866775462,
      358362.13565173314
    ]
  },
  "EPSG:8143": {
    proj4: "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177256.05724350698,
      90859.55559989369,
      231048.05255631125,
      140859.31667974903
    ]
  },
  "EPSG:8144": {
    proj4: "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209042418 +y_0=121923.986182372 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      581547.5812789055,
      298095.0589342334,
      758030.1525676642,
      462135.94174372545
    ]
  },
  "EPSG:8145": {
    proj4: "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      60136.05088547987,
      14977.481118396783,
      100477.6331064175,
      44826.085891221825
    ]
  },
  "EPSG:8146": {
    proj4: "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.012141224 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      197296.36041536092,
      49138.61978819012,
      329650.3680852205,
      147066.91728036696
    ]
  },
  "EPSG:8147": {
    proj4: "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181936.00354185252,
      30071.606015130066,
      256626.32201006004,
      123205.25450466183
    ]
  },
  "EPSG:8148": {
    proj4: "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.879451359 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      596901.7051220615,
      98659.92690263924,
      841948.1916298391,
      404215.90532204474
    ]
  },
  "EPSG:8149": {
    proj4: "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      31067.372770812603,
      30647.04834390491,
      117946.05274183839,
      80657.15783465898
    ]
  },
  "EPSG:8150": {
    proj4: "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.2669545339 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      101926.87233715766,
      100547.857953878,
      386961.34154209815,
      264622.6921747937
    ]
  },
  "EPSG:8151": {
    proj4: "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91207.19613308841,
      29562.108301780572,
      140593.99779557888,
      79576.32062079995
    ]
  },
  "EPSG:8152": {
    proj4: "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.032258065 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      299235.6091757258,
      96988.35029125844,
      461265.47429674666,
      261076.6452079079
    ]
  },
  "EPSG:8153": {
    proj4: "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      167158.24805737444,
      90437.3352402518,
      229962.463495149,
      141565.57839153672
    ]
  },
  "EPSG:8154": {
    proj4: "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.196850394 +y_0=105279.782880366 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      548418.3516774037,
      296709.82396964356,
      754468.5151595024,
      464453.0683751508
    ]
  },
  "EPSG:8155": {
    proj4: "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121321.69242944392,
      29881.874339566144,
      163018.06263920004,
      72179.38881975594
    ]
  },
  "EPSG:8156": {
    proj4: "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.659690119 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398036.2522184328,
      98037.4495689766,
      534835.0934816076,
      236808.54499273264
    ]
  },
  "EPSG:8157": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29746.113194593934,
      30554.98252613835,
      94129.30158787683,
      157057.3373114821
    ]
  },
  "EPSG:8158": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      97592.04017943032,
      100245.80523417224,
      308822.55076639267,
      515278.94755908754
    ]
  },
  "EPSG:8159": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151763.7570398684,
      30446.386733544063,
      197601.2199366239,
      148134.62285462697
    ]
  },
  "EPSG:8160": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497911.59279363643,
      99889.52052221916,
      648296.6689807419,
      486005.00852947205
    ]
  },
  "EPSG:8161": {
    proj4: "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      906.3710873350901,
      4679.510414527587,
      69421.17912549878,
      63661.84324360642
    ]
  },
  "EPSG:8162": {
    proj4: "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=24999.9998983998 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2973.652475698542,
      15352.693418329276,
      227759.3185142406,
      208863.8970417321
    ]
  },
  "EPSG:8163": {
    proj4: "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197387.0814158988,
      60808.785393169725,
      246693.02668587523,
      129740.41316873346
    ]
  },
  "EPSG:8164": {
    proj4: "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.441960884 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      647594.1164784116,
      199503.490190341,
      809358.7052516593,
      425656.67231733643
    ]
  },
  "EPSG:8165": {
    proj4: "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      91087.25490805239,
      30153.02195867813,
      139989.08931320353,
      74610.11214784518
    ]
  },
  "EPSG:8166": {
    proj4: "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.026162052 +y_0=0.00457200914401829 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      298842.10234775086,
      98927.03977901318,
      459280.8707253175,
      244783.34317463878
    ]
  },
  "EPSG:8167": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121956.70406289992,
      59566.765034219396,
      179890.13349643935,
      99568.0669949991
    ]
  },
  "EPSG:8168": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      400119.6197575293,
      195428.62787351833,
      590189.5461573999,
      326666.2327231764
    ]
  },
  "EPSG:8169": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121488.34982328354,
      30718.44888411177,
      209217.9560568348,
      70652.2418864604
    ]
  },
  "EPSG:8170": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398583.02724430506,
      100782.11151904009,
      686409.2436955479,
      231798.23072757883
    ]
  },
  "EPSG:8171": {
    proj4: "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212723.7884070876,
      121012.57419074225,
      273192.36734827503,
      201007.48406082307
    ]
  },
  "EPSG:8172": {
    proj4: "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.0100584201168402 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      697911.295547503,
      397022.08734912693,
      896298.6249570489,
      659472.0541478838
    ]
  },
  "EPSG:8173": {
    proj4: "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243201.64193808555,
      151719.50275858634,
      292347.3337567052,
      230576.09530687466
    ]
  },
  "EPSG:8177": {
    proj4: "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.553213106 +y_0=0.0158496316992634 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      797904.0533067842,
      497766.4024580454,
      959142.877215039,
      756481.7398435547
    ]
  },
  "EPSG:8179": {
    proj4: "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30760.80503793502,
      30223.930786810106,
      71805.64284120011,
      89122.81106776184
    ]
  },
  "EPSG:8180": {
    proj4: "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.1039370079 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      100921.07432195859,
      99159.67974722617,
      235582.34634817083,
      292397.089468982
    ]
  },
  "EPSG:8181": {
    proj4: "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      29516.26374831707,
      29713.029420314655,
      87144.21480195774,
      97517.22176744304
    ]
  },
  "EPSG:8182": {
    proj4: "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3182626365 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      96837.94185835352,
      97483.49690506568,
      285905.64460683963,
      319937.75129726937
    ]
  },
  "EPSG:8184": {
    proj4: "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121706.52000769999,
      30110.147967542518,
      195755.48585982897,
      114574.65762986627
    ]
  },
  "EPSG:8185": {
    proj4: "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.117602235 +y_0=0.00243840487680975 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      399298.8077325951,
      98786.37757759576,
      642241.1231991217,
      375900.35636140296
    ]
  },
  "EPSG:8187": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243317.73292646738,
      151962.1138566844,
      293607.3720029905,
      240882.34553762054
    ]
  },
  "EPSG:8189": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      798284.9290736692,
      498562.36861047207,
      963276.8532772289,
      790294.8287170101
    ]
  },
  "EPSG:8191": {
    proj4: "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213037.58627419543,
      121178.61462233923,
      281455.18172516325,
      172285.1758572581
    ]
  },
  "EPSG:8193": {
    proj4: "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.294386589 +y_0=146591.989636779 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      698940.8142572569,
      397566.83826079045,
      923407.5419993071,
      565238.9479123533
    ]
  },
  "EPSG:8196": {
    proj4: "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      90760.19642255966,
      29293.748555825863,
      136273.2036185111,
      79288.26766360743
    ]
  },
  "EPSG:8197": {
    proj4: "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.627381255 +y_0=53703.1202438405 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      297769.07770151534,
      96107.90719215541,
      447089.66881023266,
      260131.59196493545
    ]
  },
  "EPSG:8198": {
    proj4: "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      137056.03503260718,
      91364.18285330072,
      200987.77362544695,
      132472.4698922942
    ]
  },
  "EPSG:8200": {
    proj4: "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      449658.0080197286,
      299750.6569480374,
      659407.3870530705,
      434620.0953418019
    ]
  },
  "EPSG:8201": {
    proj4: "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      182295.238759686,
      91140.32841196864,
      231336.11425996874,
      160095.25032346815
    ]
  },
  "EPSG:8202": {
    proj4: "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      598080.2961063201,
      299016.22724976717,
      758975.2351434977,
      525245.8335544119
    ]
  },
  "EPSG:8203": {
    proj4: "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30356.064658524923,
      29950.894984437975,
      89416.51358218705,
      79962.0704794284
    ]
  },
  "EPSG:8204": {
    proj4: "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.7200914402 +y_0=44091.434493269 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      99593.18910051057,
      98263.89427794365,
      293360.6786108921,
      262342.22588109144
    ]
  },
  "EPSG:8205": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213232.8990588185,
      91236.35725670496,
      281276.953197994,
      209049.199538236
    ]
  },
  "EPSG:8206": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      699581.6026837224,
      299331.2820236229,
      922822.8036386675,
      685855.5820756126
    ]
  },
  "EPSG:8207": {
    proj4: "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      30302.80571257961,
      29669.169076542123,
      97051.01511864769,
      88578.03659890636
    ]
  },
  "EPSG:8208": {
    proj4: "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1277114554 +y_0=59445.9041910084 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      99418.45544102155,
      97339.59852103867,
      318408.20580076333,
      290609.77471732866
    ]
  },
  "EPSG:8209": {
    proj4: "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      151784.74663418197,
      59887.64310349317,
      197270.83723040996,
      124334.42999112609
    ]
  },
  "EPSG:8210": {
    proj4: "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502159 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      497980.456301144,
      196481.37600071053,
      647212.7385322687,
      407920.5426478862
    ]
  },
  "EPSG:8212": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      10830.217346985108,
      142405.61923410758,
      50628.656431373965,
      191295.08189895964
    ]
  },
  "EPSG:8213": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983998 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      35532.13774590033,
      467209.1021039014,
      166104.18330859946,
      627607.2808635036
    ]
  },
  "EPSG:8214": {
    proj4: "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197138.84304593282,
      90866.34932666383,
      259229.82816349418,
      186467.38411761343
    ]
  },
  "EPSG:8216": {
    proj4: "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.457505715 +y_0=148551.483566167 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      646779.6875786147,
      298117.3473101458,
      850489.8612518139,
      611768.408953453
    ]
  },
  "EPSG:8218": {
    proj4: "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      68791.48004875361,
      7456.1239705285025,
      118095.29481024371,
      57474.65031699388
    ]
  },
  "EPSG:8220": {
    proj4: "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      225693.38079328585,
      24462.30054555893,
      387450.9797232746,
      188564.7490672541
    ]
  },
  "EPSG:8222": {
    proj4: "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      148970.69703856038,
      30489.848490167074,
      197288.89968597668,
      153889.84824469112
    ]
  },
  "EPSG:8224": {
    proj4: "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.00182880365760732 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      488748.02803759393,
      100032.11167740649,
      647271.9978899922,
      504886.94420537417
    ]
  },
  "EPSG:8225": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      121397.08362104541,
      30418.90656410093,
      179966.0416391383,
      98231.19093822878
    ]
  },
  "EPSG:8226": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      398283.5982922123,
      99799.36247997114,
      590438.588056572,
      322280.16546408896
    ]
  },
  "EPSG:8227": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:8228": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:8230": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8231": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8232": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8233": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8235": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8237": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8238": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8239": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8240": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8242": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8244": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8246": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8247": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8248": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8249": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8250": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8251": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8252": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8253": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.9003043755682455e6,
      -3.1572772458457267e6,
      299434.31935248646,
      -257827.04625201007
    ]
  },
  "EPSG:8254": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8255": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:8266": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8267": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8311": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-117.666666666667 +k=1.00014 +x_0=90000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      13682.872206768297,
      -678.777947945757,
      104126.44179371152,
      76691.2734676252
    ]
  },
  "EPSG:8312": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-117.666666666667 +k=1.00014 +x_0=90000.00001488 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      44891.313063150585,
      -2226.9617714755805,
      341622.18441138946,
      251611.78959194617
    ]
  },
  "EPSG:8313": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k=1.00022 +x_0=20000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2209.089450742813,
      2246.062643998739,
      58273.85408412047,
      95688.46801690572
    ]
  },
  "EPSG:8314": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k=1.00022 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7247.6688013871835,
      7368.971929129721,
      191187.18531509337,
      313938.54336255154
    ]
  },
  "EPSG:8315": {
    proj4: "+proj=lcc +lat_1=45.5833333333333 +lat_0=45.5833333333333 +lon_0=-123.416666666667 +k_0=1.000045 +x_0=30000 +y_0=20000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -797.9637095345861,
      -301.3643037255533,
      61515.12734088804,
      64170.552030226085
    ]
  },
  "EPSG:8316": {
    proj4: "+proj=lcc +lat_1=45.5833333333333 +lat_0=45.5833333333333 +lon_0=-123.416666666667 +k_0=1.000045 +x_0=30000.00001512 +y_0=19999.99999992 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2617.991123407434,
      -988.7280308581118,
      201821.2839764043,
      210533.30718551864
    ]
  },
  "EPSG:8317": {
    proj4: "+proj=tmerc +lat_0=44.25 +lon_0=-119.633333333333 +k=1.00012 +x_0=20000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -505.55364685883615,
      -1079.26031977145,
      100780.46960741203,
      77194.26058749373
    ]
  },
  "EPSG:8318": {
    proj4: "+proj=tmerc +lat_0=44.25 +lon_0=-119.633333333333 +k=1.00012 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -1658.6405739463098,
      -3540.8803142107936,
      330644.58532589243,
      253262.00980148857
    ]
  },
  "EPSG:8319": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-118.416666666667 +k=1.00019 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2468.9880934212997,
      14919.063108393433,
      140359.59558604858,
      199152.35324845338
    ]
  },
  "EPSG:8320": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-118.416666666667 +k=1.00019 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -8100.354638258846,
      48947.057442235666,
      460497.3608455662,
      653386.9857232722
    ]
  },
  "EPSG:8321": {
    proj4: "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=40000 +y_0=70000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      11419.13749022353,
      -1067.2104478469846,
      88650.0187289486,
      73521.32952478097
    ]
  },
  "EPSG:8322": {
    proj4: "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=39999.99999984 +y_0=70000.00001496 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      37464.36184404045,
      -3501.346564589862,
      290846.5181390702,
      241211.71108838898
    ]
  },
  "EPSG:8323": {
    proj4: "+proj=lcc +lat_1=42 +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=60000 +y_0=-60000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      20560.2842518737,
      -1014.6936144538631,
      103802.0427573116,
      89013.3286885343
    ]
  },
  "EPSG:8324": {
    proj4: "+proj=lcc +lat_1=42 +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=59999.99999976 +y_0=-59999.99999976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      67455.00082556989,
      -3329.0472907279054,
      340557.8830612585,
      292038.47995004687
    ]
  },
  "EPSG:8325": {
    proj4: "+proj=lcc +lat_1=47 +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000 +y_0=290000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5288.080351628461,
      -1039.0217026265454,
      64033.734784497676,
      43461.49314003775
    ]
  },
  "EPSG:8326": {
    proj4: "+proj=lcc +lat_1=47 +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000.00001512 +y_0=290000.00001408 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      17349.34503526398,
      -3408.8638075673216,
      210084.43175727583,
      142590.20063686933
    ]
  },
  "EPSG:8327": {
    proj4: "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-120.5 +k_0=1 +x_0=100000 +y_0=140000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1927.392504792835,
      -1075.3244099286967,
      213967.8792048986,
      116971.56445737847
    ]
  },
  "EPSG:8328": {
    proj4: "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-120.5 +k_0=1 +x_0=99999.9999996 +y_0=139999.99999944 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -6323.466224385951,
      -3527.967226012741,
      701994.3543454678,
      383764.9752520291
    ]
  },
  "EPSG:8329": {
    proj4: "+proj=lcc +lat_1=43.5 +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=40000 +y_0=-80000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -765.9263193208826,
      -980.6758643937792,
      55085.90834107353,
      43368.126121631154
    ]
  },
  "EPSG:8330": {
    proj4: "+proj=lcc +lat_1=43.5 +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=39999.99999984 +y_0=-79999.99999968 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -2512.881625593441,
      -3217.4404989297327,
      180728.04573790528,
      142283.8783528581
    ]
  },
  "EPSG:8331": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-117.583333333333 +k=1.00018 +x_0=70000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      23784.795565088076,
      14591.53548643279,
      129281.14982688171,
      199140.77207095822
    ]
  },
  "EPSG:8332": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-117.583333333333 +k=1.00018 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      78034.1062337535,
      47872.49175338841,
      424150.7540742838,
      653348.9897341148
    ]
  },
  "EPSG:8333": {
    proj4: "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-119 +k_0=1.000025 +x_0=50000 +y_0=130000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1270.766261980425,
      -580.9512768587447,
      118893.08824406241,
      116306.19680843843
    ]
  },
  "EPSG:8334": {
    proj4: "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-119 +k_0=1.000025 +x_0=50000.00001504 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -4169.180600198241,
      -1906.0080778830059,
      390069.1872017795,
      381582.0105746668
    ]
  },
  "EPSG:8335": {
    proj4: "+proj=lcc +lat_1=44 +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1602.3752953632866,
      18068.801759101232,
      100999.29624219396,
      113499.151331956
    ]
  },
  "EPSG:8336": {
    proj4: "+proj=lcc +lat_1=44 +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -5257.1367965987,
      59280.84566634262,
      331362.5204788515,
      372372.5437400131
    ]
  },
  "EPSG:8337": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-120.333333333333 +k=1.000215 +x_0=70000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      17141.211509918976,
      14638.222521541202,
      165803.9818870086,
      189565.45341873867
    ]
  },
  "EPSG:8338": {
    proj4: "+proj=tmerc +lat_0=41.75 +lon_0=-120.333333333333 +k=1.000215 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      56237.57061968165,
      48025.66444075197,
      543976.3185760124,
      621933.9022924496
    ]
  },
  "EPSG:8339": {
    proj4: "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-122.583333333333 +k_0=1.00015 +x_0=10000 +y_0=60000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -504.69349350837,
      -1094.9625971162386,
      61277.27067352353,
      55744.47073249709
    ]
  },
  "EPSG:8340": {
    proj4: "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-122.583333333333 +k_0=1.00015 +x_0=10000.0000152 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -1655.8184983870428,
      -3592.39697295353,
      201040.91433308244,
      182888.68350478046
    ]
  },
  "EPSG:8341": {
    proj4: "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000 +y_0=90000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2168.12060604402,
      8922.275943481072,
      58284.85472153261,
      85617.03320439883
    ]
  },
  "EPSG:8342": {
    proj4: "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000.00001512 +y_0=90000.00001488 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      7113.256631115551,
      29272.55891850746,
      191223.27669505446,
      280895.7782784738
    ]
  },
  "EPSG:8343": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k=1.000195 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8195.98273800595,
      2435.1464193332645,
      143601.09973756375,
      89500.21639871883
    ]
  },
  "EPSG:8344": {
    proj4: "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k=1.000195 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      26889.70714490142,
      7989.32552274693,
      471132.21698597027,
      293635.88057322445
    ]
  },
  "EPSG:8345": {
    proj4: "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=40000 +y_0=60000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5165.468846917211,
      -1022.3548885119599,
      97616.94721984447,
      52460.11390984823
    ]
  },
  "EPSG:8346": {
    proj4: "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=39999.99999984 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      16947.07626888849,
      -3354.1827058791246,
      320265.57486773125,
      172113.23461157555
    ]
  },
  "EPSG:8347": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-122 +k=1.000223 +x_0=20000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1208.8231567841685,
      -1078.3615069222155,
      61590.2117469554,
      131263.77238743487
    ]
  },
  "EPSG:8348": {
    proj4: "+proj=tmerc +lat_0=43 +lon_0=-122 +k=1.000223 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -3965.955239055668,
      -3537.931453156875,
      202067.6238414547,
      430655.4212186183
    ]
  },
  "EPSG:8349": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-75, 59, -10, 84.01]
  },
  "EPSG:8350": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-75, 58, -6.99, 85.01]
  },
  "EPSG:8351": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [16.84, 47.73, 22.56, 49.61]
  },
  "EPSG:8352": {
    proj4: "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3246109480407187e6,
      598456.5382383121,
      1.1443834421838645e6,
      164288.7463043341
    ]
  },
  "EPSG:8353": {
    proj4: "+proj=krovak +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -598456.5382383121,
      -1.3246109480407187e6,
      -164288.7463043341,
      -1.1443834421838645e6
    ]
  },
  "EPSG:8357": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8358": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8360": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [12.09, 47.73, 22.56, 51.06]
  },
  "EPSG:8370": {
    proj4: "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=649328 +y_0=665262 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      514655.595656322,
      522593.6536251459,
      791004.7334139675,
      746440.85331934
    ]
  },
  "EPSG:8378": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8379": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=100000 +y_0=200000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      51834.91837640316,
      159072.00396043863,
      123018.05454420665,
      220006.37084935192
    ]
  },
  "EPSG:8380": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=99999.99998984 +y_0=200000.00001016 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      170061.7280065828,
      521888.7330268724,
      403601.7339171181,
      721804.2350615822
    ]
  },
  "EPSG:8381": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=400000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      251833.23276710726,
      359070.5716238112,
      323018.86009556055,
      420007.0710023165
    ]
  },
  "EPSG:8382": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      826222.8645034179,
      1.1780507003691208e6,
      1.0597710434968518e6,
      1377973198746767e-9
    ]
  },
  "EPSG:8383": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      51834.91837640316,
      159072.00396043863,
      123018.05454420665,
      220006.37084935192
    ]
  },
  "EPSG:8384": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=99999.99998984 +y_0=200000.00001016 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      170061.7280065828,
      521888.7330268724,
      403601.7339171181,
      721804.2350615822
    ]
  },
  "EPSG:8385": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251833.23276710726,
      359070.5716238112,
      323018.86009556055,
      420007.0710023165
    ]
  },
  "EPSG:8387": {
    proj4: "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      826222.8645034179,
      1.1780507003691208e6,
      1.0597710434968518e6,
      1377973198746767e-9
    ]
  },
  "EPSG:8391": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=0.999929 +x_0=300000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      354128.510250242,
      507023.74375917204,
      464751.6348837209,
      728989.5788064813
    ]
  },
  "EPSG:8395": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      455393.3937866387,
      5914893928372301e-9,
      592481.1246360533,
      5985723554536868e-9
    ]
  },
  "EPSG:8397": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:8399": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:8401": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5151420516176975e-9,
      -1.4868811300458862e6,
      449077.1507465251,
      379230.991288599
    ]
  },
  "EPSG:8403": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:8425": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.3816112575566396e6,
      5410061708824178e-9,
      -2444360129822673e-9,
      536117894321024e-8
    ]
  },
  "EPSG:8426": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [113.76, 22.13, 114.51, 22.58]
  },
  "EPSG:8427": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [113.76, 22.13, 114.51, 22.58]
  },
  "EPSG:8428": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [113.52, 22.06, 113.68, 22.23]
  },
  "EPSG:8429": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.3600923289983724e6,
      5422663630436701e-9,
      -2.3723761196123194e6,
      5409553410801633e-9
    ]
  },
  "EPSG:8430": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [113.52, 22.06, 113.68, 22.23]
  },
  "EPSG:8431": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [113.52, 22.06, 113.68, 22.23]
  },
  "EPSG:8433": {
    proj4: "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      18299.97578720722,
      3124.539670077549,
      34797.878456422775,
      21956.258423163847
    ]
  },
  "EPSG:8434": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8441": {
    proj4: "+proj=labrd +lat_0=-18.9 +lon_0=46.4372291666667 +azi=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      72493.0613596497,
      50556.64594483131,
      849612.0449461396,
      1.5710671056345701e6
    ]
  },
  "EPSG:8455": {
    proj4: "+proj=utm +zone=53 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      544083.9620244035,
      2598364801865397e-9,
      638654.5569120701,
      2.7202412890453516e6
    ]
  },
  "EPSG:8456": {
    proj4: "+proj=utm +zone=54 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      369933.02057325846,
      2550989341605818e-9,
      545207.2354757889,
      2668582906751193e-9
    ]
  },
  "EPSG:8518": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-101.6 +k=1.000156 +x_0=457200.914401829 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1368675528822556e-9,
      433755.724757556,
      1.5616365111252028e6,
      914381.0172006339
    ]
  },
  "EPSG:8519": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-100.95 +k=1.000134 +x_0=762001.524003048 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3458397430706266e6,
      433870.77369018603,
      2.5672383567883293e6,
      914375.3650652412
    ]
  },
  "EPSG:8520": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-100.35 +k=1.000116 +x_0=1066802.13360427 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.3658260013525593e6,
      433752.8605001545,
      3.5588324962460096e6,
      914337.6887955779
    ]
  },
  "EPSG:8521": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-99.45 +k=1.000082 +x_0=1371602.74320549 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.2887537288431395e6,
      434246.89203443646,
      461766113113636e-8,
      914514.5526826985
    ]
  },
  "EPSG:8522": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-98.6666666666667 +k=1.000078 +x_0=1676403.35280671 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      538417627449945e-8,
      277030.69752598146,
      5555095003548436e-9,
      914294.4255106845
    ]
  },
  "EPSG:8523": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-98.15 +k=1.000068 +x_0=1981203.96240793 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      6396465537209262e-9,
      236914.58057540722,
      6564432503632469e-9,
      914307.6371215513
    ]
  },
  "EPSG:8524": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-97.3333333333333 +k=1.000049 +x_0=2286004.57200914 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      7.3253614466398535e6,
      211786.39259880607,
      7649406173933119e-9,
      914654.1963387878
    ]
  },
  "EPSG:8525": {
    proj4: "+proj=lcc +lat_1=39.1666666666667 +lat_0=39.1666666666667 +lon_0=-96.5 +k_0=1.000044 +x_0=2590805.18161036 +y_0=182880.365760732 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      8365907461026005e-9,
      441296.0697444055,
      8657880798457097e-9,
      747407.6797589078
    ]
  },
  "EPSG:8526": {
    proj4: "+proj=lcc +lat_1=38.5 +lat_0=38.5 +lon_0=-96.5 +k_0=1.00005 +x_0=2895605.79121158 +y_0=91440.1828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9373336616791755e-9,
      147338.5839138413,
      9659434774845982e-9,
      438890.4484528881
    ]
  },
  "EPSG:8527": {
    proj4: "+proj=lcc +lat_1=39.6333333333333 +lat_0=39.6333333333333 +lon_0=-95.75 +k_0=1.00004 +x_0=3200406.4008128 +y_0=213360.426720853 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      10199620152695997e-9,
      547565.7865169086,
      10752121228080148e-9,
      838479.779052791
    ]
  },
  "EPSG:8528": {
    proj4: "+proj=lcc +lat_1=39.1 +lat_0=39.1 +lon_0=-95.25 +k_0=1.000033 +x_0=3505207.01041402 +y_0=182880.365760732 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      11274616557976697e-9,
      466213.92416334886,
      1168926828927677e-8,
      720901.7202710784
    ]
  },
  "EPSG:8529": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-101.416666666667 +k=1.00014 +x_0=3810007.62001524 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      12314994943746112e-9,
      88009.33987628602,
      12601793966001293e-9,
      714020.874096548
    ]
  },
  "EPSG:8531": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-100.4 +k=1.000109 +x_0=4114808.22961646 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      13286763541883934e-9,
      88208.75244546046,
      13591326309607953e-9,
      713960.0979326817
    ]
  },
  "EPSG:8533": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-99.6666666666667 +k=1.000097 +x_0=4419608.83921768 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      143296080788924e-7,
      87912.2510221557,
      1453615456417499e-8,
      710174.6269583994
    ]
  },
  "EPSG:8534": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-99.2 +k=1.000087 +x_0=4724409.4488189 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      15386082272288889e-9,
      87622.75666336091,
      15582774158676103e-9,
      710273.5144333562
    ]
  },
  "EPSG:8535": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-98.55 +k=1.000069 +x_0=5029210.05842012 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      16359795934055753e-9,
      87741.26812318563,
      16560296019767324e-9,
      553585.2096072446
    ]
  },
  "EPSG:8536": {
    proj4: "+proj=lcc +lat_1=37.7666666666667 +lat_0=37.7666666666667 +lon_0=-97.5 +k_0=1.000059 +x_0=5334010.66802134 +y_0=121920.243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      17215220649430588e-9,
      260683.5617182834,
      17781727519879345e-9,
      552004.9783805964
    ]
  },
  "EPSG:8538": {
    proj4: "+proj=lcc +lat_1=37.1833333333333 +lat_0=37.1833333333333 +lon_0=-97.5 +k_0=1.000055 +x_0=5638811.27762256 +y_0=60960.1219202439 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1825172817184134e-8,
      130715.4689988331,
      18784397150825266e-9,
      309498.51731633785
    ]
  },
  "EPSG:8539": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-95.9666666666667 +k=1.000034 +x_0=5943611.88722378 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1933546050664626e-8,
      87871.54081650032,
      19632858406208463e-9,
      776004.5824894641
    ]
  },
  "EPSG:8540": {
    proj4: "+proj=tmerc +lat_0=36.75 +lon_0=-95.0833333333333 +k=1.000031 +x_0=6248412.49682499 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      20369537341974203e-9,
      87690.56160373104,
      20637872560326762e-9,
      725035.3758353585
    ]
  },
  "EPSG:8541": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.0311657558557065e6,
      3578107219585675e-9,
      1.7904637662862274e6,
      -3.7554720303821065e6
    ]
  },
  "EPSG:8542": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.58, -14.59, -64.51, 49.38]
  },
  "EPSG:8543": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2280849152290077e-9,
      -563680047549516e-8,
      2.6028276518129967e6,
      -5459393610943489e-9
    ]
  },
  "EPSG:8544": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-67.97, 17.62, -64.51, 18.57]
  },
  "EPSG:8545": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-67.97, 17.62, -64.51, 18.57]
  },
  "EPSG:8675": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8677": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5367824451206262e-9,
      4757482988432213e-9,
      5614313027344652e-9,
      5193951263890062e-9
    ]
  },
  "EPSG:8678": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      6375341953097626e-9,
      4628470821612979e-9,
      6615778887764648e-9,
      515728985138931e-8
    ]
  },
  "EPSG:8679": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      8374033052896003e-9,
      4552960779326098e-9,
      842392985641309e-8,
      4951057479396235e-9
    ]
  },
  "EPSG:8682": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      319279.6730486496,
      4677635306341518e-9,
      655104.0881352831,
      5117121845187718e-9
    ]
  },
  "EPSG:8683": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4477258406224048e-9,
      1.5250551299677242e6,
      4.0711869992756867e6,
      1.7289549987965042e6
    ]
  },
  "EPSG:8684": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [18.81, 42.23, 23.01, 46.19]
  },
  "EPSG:8685": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [18.81, 42.23, 23.01, 46.19]
  },
  "EPSG:8686": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      373233.0062728352,
      5031884691833679e-9,
      622695.8455677517,
      5.1941173688241765e6
    ]
  },
  "EPSG:8687": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373255.6927522201,
      5030885220477742e-9,
      622673.919121838,
      5193087311330544e-9
    ]
  },
  "EPSG:8690": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8691": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8692": {
    proj4: "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      520759.8558732728,
      1210457457427086e-9,
      806481.7882646527,
      2.6464188093505795e6
    ]
  },
  "EPSG:8693": {
    proj4: "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      172184.08781981783,
      1.2231539953703182e6,
      759621.2331675382,
      2645496904287211e-9
    ]
  },
  "EPSG:8694": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [8.2, -18.02, 24.09, -4.38]
  },
  "EPSG:8697": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6005194231344367e-9,
      865361.7081969839,
      5805744073336934e-9,
      2.5958188726568855e6
    ]
  },
  "EPSG:8698": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [8.2, -18.02, 24.09, -4.38]
  },
  "EPSG:8699": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [8.2, -18.02, 24.09, -4.38]
  },
  "EPSG:8700": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "EPSG:8701": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "EPSG:8702": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2229279364,
      383550.2956986203,
      1.0591843756185349e6,
      2185694073289227e-9
    ]
  },
  "EPSG:8703": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      25363418888951235e-9,
      127241.77155271676,
      2711310000589763e-8,
      1.3093914233873296e6
    ]
  },
  "EPSG:8704": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901533205e-9,
      188024.34626186846,
      20218635176379602e-9,
      956036.5511824941
    ]
  },
  "EPSG:8705": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498039389e-9,
      82266.70251847472,
      13709781320390796e-9,
      999144.9583176089
    ]
  },
  "EPSG:8706": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497126905,
      108545.02663791207,
      3.2779430675884755e6,
      1781155686491397e-9
    ]
  },
  "EPSG:8707": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592824906e6,
      75307.10902631191,
      2849091059938587e-9,
      754225.2387347483
    ]
  },
  "EPSG:8708": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      106540706736943e-8,
      116445.58968075218,
      2938446300794301e-9,
      813394.0983347377
    ]
  },
  "EPSG:8709": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      7235769706659908e-9,
      125253.26098378398,
      9221150299306909e-9,
      970945.5571090211
    ]
  },
  "EPSG:8710": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      3806773909499544e-9,
      141484.8083939462,
      5859511520076955e-9,
      1.0747459475655379e6
    ]
  },
  "EPSG:8711": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "EPSG:8712": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927636474,
      133024.73214629912,
      2.0059940206973983e6,
      796985.532192222
    ]
  },
  "EPSG:8713": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372184801,
      1.4464815951354958e6,
      1.7909758841421446e6,
      2201588044669436e-9
    ]
  },
  "EPSG:8714": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061538175e-9,
      1743578655997185e-9,
      7107948036431532e-9,
      2621858229560954e-9
    ]
  },
  "EPSG:8715": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695585834e-9,
      1.7758289912692206e6,
      7249234998005839e-9,
      2557837815660115e-9
    ]
  },
  "EPSG:8716": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5823176279241634e-9,
      1.7341078745824352e6,
      7323536053585911e-9,
      2456022576740115e-9
    ]
  },
  "EPSG:8717": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532745296e-9,
      1.8170183934613287e6,
      7541064059406428e-9,
      2.4755949233672824e6
    ]
  },
  "EPSG:8718": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907499317929e-9,
      1.3889622129240783e6,
      7711985335332574e-9,
      2.5033539392974693e6
    ]
  },
  "EPSG:8719": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324927474e-9,
      1.7779544793630175e6,
      711581051154454e-8,
      2.3414823256298574e6
    ]
  },
  "EPSG:8720": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881830670196e6,
      1.1027147224423632e6,
      3.9547319487911398e6,
      1.6294292262439965e6
    ]
  },
  "EPSG:8721": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755545300983e6,
      1.1317506265283525e6,
      3.9679384194670366e6,
      1.8403627655659935e6
    ]
  },
  "EPSG:8722": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9602860992269719e6,
      1.1339074161224284e6,
      3.9875972708977414e6,
      1.7514299533442387e6
    ]
  },
  "EPSG:8723": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113992947,
      554973.7807348338,
      1.2634591601046422e6,
      944805.9744306704
    ]
  },
  "EPSG:8724": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.5484832405,
      160464.3815257733,
      781579.1360700305,
      674114.4099112981
    ]
  },
  "EPSG:8725": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "EPSG:8726": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.61022244688,
      29981.8801461913,
      979460.662179514,
      2363281056551985e-9
    ]
  },
  "EPSG:8727": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.82954406223,
      706098.4749466283,
      932656.8409836462,
      1.9155034706385157e6
    ]
  },
  "EPSG:8728": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.36742384572,
      133281.58971744485,
      1.0760648463948576e6,
      1705427168185772e-9
    ]
  },
  "EPSG:8729": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772960456433e6,
      228387.93674624796,
      2648926914067581e-9,
      1.8246882200295548e6
    ]
  },
  "EPSG:8730": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.5530599571,
      119645.62784245881,
      948865.9582228954,
      1.1258115973909926e6
    ]
  },
  "EPSG:8731": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1287011305489751e-9,
      120499.55212947368,
      1.9776769335287954e6,
      1472936186843373e-9
    ]
  },
  "EPSG:8732": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2219614274047403e-9,
      121339.35700592819,
      2.9678622998676198e6,
      2.6806285919257025e6
    ]
  },
  "EPSG:8733": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "EPSG:8734": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755813382592e6,
      116882.92627991362,
      2630018690092871e-9,
      2.1308039414543803e6
    ]
  },
  "EPSG:8735": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70301124523,
      985386.9914261225,
      569955.6489073292,
      2.3768082459365875e6
    ]
  },
  "EPSG:8736": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393956718077e6,
      919996.2275684634,
      3.1828013881560857e6,
      2.3766893559950874e6
    ]
  },
  "EPSG:8737": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117312116e-9,
      5809817005680569e-9,
      403097617772355e-8
    ]
  },
  "EPSG:8738": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900591759,
      145967.54284040575,
      2.5529819520691475e6,
      760907.3065924722
    ]
  },
  "EPSG:8739": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78379384667,
      94022.9501781637,
      2.2701660783420214e6,
      628784.4164646415
    ]
  },
  "EPSG:8740": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.5643921482,
      1.4498073184572435e6,
      2.4223713754788456e6,
      2.1415323393213493e6
    ]
  },
  "EPSG:8741": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269712995207e6,
      81066.64574521924,
      2145220122962096e-9,
      605776.6721386266
    ]
  },
  "EPSG:8742": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83662030625,
      1.7201585409581168e6,
      2.7326679393377476e6,
      2331135994555516e-9
    ]
  },
  "EPSG:8743": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820868968125e6,
      130801.94638079239,
      3.7835269611517936e6,
      924186.3271600471
    ]
  },
  "EPSG:8744": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2446298884424555e-9,
      136782.5696471812,
      4.0896985619561956e6,
      943782.5429849147
    ]
  },
  "EPSG:8745": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "EPSG:8746": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490075164e-9,
      76679.40227344376,
      3180746481484039e-9,
      1.3672472204547669e6
    ]
  },
  "EPSG:8747": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6544428327,
      120261.76452802098,
      1.8832856601052207e6,
      757830.009017196
    ]
  },
  "EPSG:8748": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86729421368,
      2.6346779313810905e6,
      1095674268683903e-9,
      3.1535976510802875e6
    ]
  },
  "EPSG:8749": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5275684954588155e6,
      69495.24782569606,
      1.8074913108940115e6,
      186415.18831819796
    ]
  },
  "EPSG:8750": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432546007e6,
      406726.88329058146,
      3.4846058823118517e6,
      1.3987812844641001e6
    ]
  },
  "EPSG:8751": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774561575e6,
      441259.17602739297,
      3.1093523403728413e6,
      1.2384987154614236e6
    ]
  },
  "EPSG:8752": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8684100191496245e6,
      519898.6810854104,
      3.3388826902731457e6,
      1.2844950057572832e6
    ]
  },
  "EPSG:8753": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "EPSG:8754": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1884030919468199e-9,
      547967.9321047692,
      2585058044938464e-9,
      2005923102561951e-9
    ]
  },
  "EPSG:8755": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.8323418051,
      83779.09479688275,
      289695436853239e-8,
      1.1914174172197795e6
    ]
  },
  "EPSG:8756": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69716530634,
      26337061736499824e-9,
      1.0783563036380236e6,
      2889057681970665e-8
    ]
  },
  "EPSG:8757": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845731328e-9,
      20143476014967892e-9,
      2103195915755876e-9,
      21965178587309487e-9
    ]
  },
  "EPSG:8758": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128692019363e6,
      13927193731228566e-9,
      3057728434156613e-9,
      15767443303813899e-9
    ]
  },
  "EPSG:8759": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6667333606,
      70512.94210885341,
      1.2509593531533373e6,
      1.0260237739002687e6
    ]
  },
  "EPSG:8760": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "EPSG:8761": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84118137152,
      366496.4069528699,
      933608.7763713576,
      2.1860840758552696e6
    ]
  },
  "EPSG:8762": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234895707152e6,
      286838.0024767893,
      2.0521528247102818e6,
      2.1863457693688734e6
    ]
  },
  "EPSG:8763": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2340084161100859e-9,
      122160.72241634964,
      3.1650115939820465e6,
      2186845615586309e-9
    ]
  },
  "EPSG:8764": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "EPSG:8765": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37071982364,
      727169.7435368465,
      1223494718072112e-9,
      1610820417709873e-9
    ]
  },
  "EPSG:8766": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6801707726,
      727244.453797864,
      1.4721244650838003e6,
      1328725000767546e-9
    ]
  },
  "EPSG:8767": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.870781804,
      1.5887138859583358e6,
      420506.5270969149
    ]
  },
  "EPSG:8768": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "EPSG:8769": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999187e6,
      166436.6359612313,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "EPSG:8770": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "EPSG:8771": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.48223499593,
      3.0136582731721397e6,
      750989.2504948481
    ]
  },
  "EPSG:8772": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3033092255522582e-9,
      832905.3202086495
    ]
  },
  "EPSG:8773": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2.7905844426662596e6,
      875632.1554836772
    ]
  },
  "EPSG:8774": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.847010236,
      2802472178387044e-9,
      687058.9427278236
    ]
  },
  "EPSG:8775": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19502980247,
      17196.895288001127,
      442211.17936438107,
      341584.60257313045
    ]
  },
  "EPSG:8776": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392498,
      2871291092665175e-9,
      791529.090946073
    ]
  },
  "EPSG:8777": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848209,
      2.9816539445174607e6,
      919283.4783585763
    ]
  },
  "EPSG:8778": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3.2437979306370523e6,
      882581.6584900919
    ]
  },
  "EPSG:8779": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.14716290752,
      3.3936042030115686e6,
      1.1000285612285445e6,
      4.1941994715287737e6
    ]
  },
  "EPSG:8780": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980025016344e-9,
      3323001743114402e-9,
      7650725432965473e-9
    ]
  },
  "EPSG:8781": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5689827447,
      9940788826055452e-9,
      4407735767408789e-9,
      10854275232265161e-9
    ]
  },
  "EPSG:8782": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.767031274747,
      13153708000668947e-9,
      3.6156651831929674e6,
      14191752320645498e-9
    ]
  },
  "EPSG:8783": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062632026e-9,
      1.5157309066701222e6,
      17332185274254806e-9
    ]
  },
  "EPSG:8784": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497758587,
      3.3700884313268475e6,
      2308928589168566e-9,
      3.9012032387521933e6
    ]
  },
  "EPSG:8785": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2675122725,
      662913986591458e-8,
      2318643783407357e-9,
      7.5715126886745235e6
    ]
  },
  "EPSG:8786": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837381719,
      9970386894164445e-9,
      2343632289009411e-9,
      10548467588471211e-9
    ]
  },
  "EPSG:8787": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1387814935292786e-9,
      81582.35551710967,
      1.8989557383527043e6,
      923813.4297733185
    ]
  },
  "EPSG:8788": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703824143e-8,
      660312897188164e-8,
      1204479558507679e-8,
      7220874862534711e-9
    ]
  },
  "EPSG:8789": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002990512e-9,
      3397821737396317e-9,
      12398544508659353e-9,
      4.0051171085510924e6
    ]
  },
  "EPSG:8790": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9679273608,
      54521.95757222446,
      2554640134365972e-9,
      770489.672684708
    ]
  },
  "EPSG:8791": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9196607294,
      100068.83787833528,
      2525733221089436e-9,
      850434.0872122366
    ]
  },
  "EPSG:8792": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1324061584813105e-9,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "EPSG:8793": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.70342088
    ]
  },
  "EPSG:8794": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "EPSG:8795": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205946,
      2.9246965143188736e6,
      739108.438997525
    ]
  },
  "EPSG:8796": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.67995732513,
      2766498039939692e-9,
      863858.9966404126
    ]
  },
  "EPSG:8797": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.0906098829,
      180650.80451728083,
      944961.4340576739,
      1645607992340148e-9
    ]
  },
  "EPSG:8798": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243001354,
      509252.5304234326,
      1.6571629173663934e6,
      1.9745387466693572e6
    ]
  },
  "EPSG:8799": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "EPSG:8800": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3550481894877497e6,
      508102.8230517286,
      2.8960875715645896e6,
      1.8494839069219697e6
    ]
  },
  "EPSG:8801": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "EPSG:8802": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      505580.44594500464,
      15923.948440411992,
      709514.5981036696,
      557319.3872848145
    ]
  },
  "EPSG:8803": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      345065.0006292928,
      334042.20469821244,
      1.0216737568623158e6,
      954041.2679213481
    ]
  },
  "EPSG:8804": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      386918.31041990273,
      638611.495563188,
      538646.0751082397,
      1.8010582813575123e6
    ]
  },
  "EPSG:8805": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      387480.7933152069,
      638594.4905497337,
      574961.5237298968,
      1.8265091488610085e6
    ]
  },
  "EPSG:8806": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      384866.0062102319,
      570683.0524052249,
      574413.9786087219,
      1.8543974615086422e6
    ]
  },
  "EPSG:8807": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      374335.66296567384,
      193265.41672186597,
      576665.1462954525,
      1927037849194219e-9
    ]
  },
  "EPSG:8808": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      371683.47061143327,
      100891.27017918504,
      571564.5392518891,
      1.9402596195834302e6
    ]
  },
  "EPSG:8809": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      369227.2759588344,
      37478.56021629183,
      573639.6586334868,
      1866650932337704e-9
    ]
  },
  "EPSG:8810": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      353035.9059764714,
      40196.47731406788,
      579818.6224001455,
      1678220016121422e-9
    ]
  },
  "EPSG:8811": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      305398.63289577013,
      281655.18765712064,
      591427.5708482452,
      1.3181762713116712e6
    ]
  },
  "EPSG:8812": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      195687.98647669028,
      98297.39874279598,
      1.7230791763698556e6,
      427904.9014095053
    ]
  },
  "EPSG:8813": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      117430.21416727672,
      17271.89955836394,
      368474.73767414974,
      531120.8788109587
    ]
  },
  "EPSG:8814": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      384402.582974351,
      72524.35270280449,
      592240.4863549052,
      530749.7674890533
    ]
  },
  "EPSG:8815": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857344828,
      35516.95357112248,
      936343.0942781423,
      491477.91794944176
    ]
  },
  "EPSG:8816": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5050326786085115e-9,
      3.4632122026999425e6,
      3.0479901217954187e6,
      4.4631647209247155e6
    ]
  },
  "EPSG:8817": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.44, 16.29, 55.67, 32.16]
  },
  "EPSG:8818": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.44, 16.29, 55.67, 32.16]
  },
  "EPSG:8826": {
    proj4: "+proj=tmerc +lat_0=42 +lon_0=-114 +k=0.9996 +x_0=2500000 +y_0=1200000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.2316136681717495e6,
      1.2039692574793622e6,
      2.7164451720705717e6,
      1.9830131620980236e6
    ]
  },
  "EPSG:8836": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      645413.8724885897,
      2756859564963156e-9,
      792165.2841309032,
      3.2538548004879253e6
    ]
  },
  "EPSG:8837": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      179368.03724460263,
      1.8033700911296927e6,
      782929.2897820894,
      3562115601191214e-9
    ]
  },
  "EPSG:8838": {
    proj4: "+proj=utm +zone=38 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      178396.6154929783,
      1810030676805358e-9,
      786010.0952524476,
      3450101353730284e-9
    ]
  },
  "EPSG:8839": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181126.26121374598,
      1.9861290463882815e6,
      793415.2133757307,
      3205069819296655e-9
    ]
  },
  "EPSG:8840": {
    proj4: "+proj=utm +zone=40 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      185404.07380352775,
      2176630340980283e-9,
      363461.08657840727,
      2.5186726165752816e6
    ]
  },
  "EPSG:8841": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8857": {
    proj4: "+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10216474793457054e-9,
      -839292759846645e-8,
      10216474793457044e-9,
      8392927598466456e-9
    ]
  },
  "EPSG:8858": {
    proj4: "+proj=eqearth +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10215907211524084e-9,
      -839292759846645e-8,
      10215907211524075e-9,
      8392927598466456e-9
    ]
  },
  "EPSG:8859": {
    proj4: "+proj=eqearth +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10215907211524084e-9,
      -839292759846645e-8,
      10215907211524075e-9,
      8392927598466456e-9
    ]
  },
  "EPSG:8860": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [144.58, -14.59, -64.51, 49.38]
  },
  "EPSG:8881": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8888": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8897": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "EPSG:8898": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6134202284685066e-9,
      54603.07578695161,
      -6253518518975202e-9,
      -627491.2580357555
    ]
  },
  "EPSG:8899": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [179.49, -15.94, -174.27, -9.84]
  },
  "EPSG:8900": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [179.49, -15.94, -174.27, -9.84]
  },
  "EPSG:8901": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [179.49, -15.94, -174.27, -9.84]
  },
  "EPSG:8902": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [179.49, -15.94, -174.27, -9.84]
  },
  "EPSG:8903": {
    proj4: "+proj=utm +zone=1 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      124146.7077507219,
      8234536902578415e-9,
      799448.3676897713,
      8911057719639111e-9
    ]
  },
  "EPSG:8904": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8905": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -50058.22780592597,
      -6373480465513657e-9,
      930600.4089156577,
      -6175175007133024e-9
    ]
  },
  "EPSG:8906": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-90.45, 2.15, -81.43, 11.77]
  },
  "EPSG:8907": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-90.45, 2.15, -81.43, 11.77]
  },
  "EPSG:8908": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282790.4483010995,
      882870.1101888847,
      660532.7353043477,
      1.2410781186655697e6
    ]
  },
  "EPSG:8909": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      116136.88139845262,
      238074.68571687423,
      945900.1250829585,
      1.2312053005338553e6
    ]
  },
  "EPSG:8910": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214616.95896910137,
      1.0622680105396623e6,
      453150.87598511786,
      1.3011567542456845e6
    ]
  },
  "EPSG:8911": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:8912": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      282790.4483010995,
      882870.1101888847,
      660532.7353043477,
      1.2410781186655697e6
    ]
  },
  "EPSG:8915": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8916": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8917": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8918": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8919": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8920": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8921": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8922": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8923": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8924": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8925": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8926": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8927": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8928": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8929": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8930": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8931": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8932": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8933": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8934": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8935": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8936": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8937": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8938": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8939": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8940": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8941": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8942": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8943": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8944": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8945": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.7098666376379034e6,
      -2.7162733949840413e6,
      4856920837349741e-9,
      -2293782096441749e-9
    ]
  },
  "EPSG:8946": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8947": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      2502038091084371e-9,
      -5546561512064938e-9
    ]
  },
  "EPSG:8948": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:8949": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:8950": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      818130.0801922004,
      7968458629497271e-9
    ]
  },
  "EPSG:8951": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      818590.9266396924,
      8062621368716022e-9
    ]
  },
  "EPSG:8972": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8973": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8974": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8975": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8976": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8977": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8978": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8979": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8980": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8981": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8982": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8983": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8984": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8985": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8986": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8987": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-122.19, -59.87, -25.28, 32.72]
  },
  "EPSG:8988": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8989": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8990": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8991": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8992": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8993": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8994": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8995": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8996": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8997": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8998": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:8999": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9000": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9001": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9002": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9003": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9004": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9005": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9006": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9007": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9008": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9009": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9010": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9011": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9012": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9013": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9014": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9015": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9016": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9017": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9018": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9019": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9039": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.1800270871075992e6,
      4739806760715886e-9,
      3714401461962507e-9,
      523094047948676e-8
    ]
  },
  "EPSG:9040": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8770578841124293e6,
      4262719705874953e-9,
      3380297711154961e-9,
      4800189871621847e-9
    ]
  },
  "EPSG:9053": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9054": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9055": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9056": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9057": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9059": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9060": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9061": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9062": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9063": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9064": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9065": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9066": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9067": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9068": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9069": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-16.1, 32.88, 40.18, 84.73]
  },
  "EPSG:9070": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4053625832510513e-9,
      4920940111341359e-9,
      -5029708742622028e-9,
      2.9568157006459604e6
    ]
  },
  "EPSG:9071": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [129.48, 1.64, 149.55, 23.9]
  },
  "EPSG:9072": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [129.48, 1.64, 149.55, 23.9]
  },
  "EPSG:9073": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5618535567829044e-9,
      2330720982291132e-9,
      -4757834895202337e-9,
      -2.6080773519419767e6
    ]
  },
  "EPSG:9074": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [157.47, -17.56, -151.27, 31.8]
  },
  "EPSG:9075": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [157.47, -17.56, -151.27, 31.8]
  },
  "EPSG:9130": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9138": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4472032052329368e-9,
      162503531290358e-8,
      4320214259247371e-9,
      1.7279624223878803e6
    ]
  },
  "EPSG:9139": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.97, 41.85, 21.8, 43.25]
  },
  "EPSG:9140": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.97, 41.85, 21.8, 43.25]
  },
  "EPSG:9141": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7414471635337985e-9,
      4.6350255451922305e6,
      7564961316559683e-9,
      4790325379197936e-9
    ]
  },
  "EPSG:9146": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      2502038091084371e-9,
      -5546561512064938e-9
    ]
  },
  "EPSG:9147": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9148": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9149": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      818130.0801922004,
      7968458629497271e-9
    ]
  },
  "EPSG:9150": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      818590.9266396924,
      8062621368716022e-9
    ]
  },
  "EPSG:9151": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      2502038091084371e-9,
      -5546561512064938e-9
    ]
  },
  "EPSG:9152": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9153": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9154": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      818130.0801922004,
      7968458629497271e-9
    ]
  },
  "EPSG:9155": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      818590.9266396924,
      8062621368716022e-9
    ]
  },
  "EPSG:9156": {
    proj4: "+proj=utm +zone=32 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      414970.5805352813,
      8089293202887383e-9,
      833808.591289059,
      944325023675178e-8
    ]
  },
  "EPSG:9157": {
    proj4: "+proj=utm +zone=33 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181304.5198700694,
      8069266693006594e-9,
      833007.8747432997,
      951520266510535e-8
    ]
  },
  "EPSG:9158": {
    proj4: "+proj=utm +zone=34 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181270.088165242,
      8005010121856781e-9,
      841520.5271241443,
      9235091530484919e-9
    ]
  },
  "EPSG:9159": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      95831.75243517,
      8087701219687794e-9,
      705877.0034282303,
      9335340034358084e-9
    ]
  },
  "EPSG:9191": {
    proj4: "+proj=aea +lat_0=-40 +lon_0=175 +lat_1=-30 +lat_2=-50 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.1849441231629965e6,
      -2337463863020833e-9,
      1.5314088437838943e6,
      154285257078876e-8
    ]
  },
  "EPSG:9205": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      410526.5339756467,
      2310906434096569e-9,
      601624.7885331337,
      2524691957273245e-9
    ]
  },
  "EPSG:9206": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=104 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      417636.705852727,
      2.2754417070567063e6,
      606323.6699273937,
      2.4383445273800204e6
    ]
  },
  "EPSG:9207": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      378836.8395057427,
      921225.0174740962,
      613822.4594665626,
      1.1667626103406786e6
    ]
  },
  "EPSG:9208": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      366318.08055002824,
      1125903337032559e-9,
      613918.9893884866,
      252810188348729e-8
    ]
  },
  "EPSG:9209": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      371421.3273701845,
      1.0163727253298704e6,
      621633.2326691817,
      2.5890791184674245e6
    ]
  },
  "EPSG:9210": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      446240.90985289647,
      1.0781342074717428e6,
      709995.1588021604,
      2.5590467193777417e6
    ]
  },
  "EPSG:9211": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      375364.0608366956,
      1.8716369037351045e6,
      605823.5782364648,
      2511430968007565e-9
    ]
  },
  "EPSG:9212": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      517466.36325870024,
      1.2495305771336749e6,
      625500.5709825372,
      1904846816697467e-9
    ]
  },
  "EPSG:9213": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      388996.8333848205,
      2.3586480101892683e6,
      474324.9183048046,
      2516621988124664e-9
    ]
  },
  "EPSG:9214": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      380120.99628763204,
      1768682584753277e-9,
      628369.0680986547,
      2.3931040015729344e6
    ]
  },
  "EPSG:9215": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=107.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      379659.21014967427,
      2.3587140856387117e6,
      512348.9823236796,
      2485601562940332e-9
    ]
  },
  "EPSG:9216": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=107.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      481629.6990809141,
      1539347137443492e-9,
      612698.7545779716,
      1705566956301227e-9
    ]
  },
  "EPSG:9217": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      532755.1922803419,
      1.2440122444743058e6,
      637844.6763882611,
      1.6271302113448475e6
    ]
  },
  "EPSG:9218": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      357662.9492198735,
      1.1535938165320011e6,
      609891.9099710446,
      1.6159224963274172e6
    ]
  },
  "EPSG:9221": {
    proj4: "+proj=aea +lat_0=-30 +lon_0=25 +lat_1=-22 +lat_2=-38 +x_0=1400000 +y_0=1300000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      378631.7891113205,
      336238.8569907866,
      258823691958785e-8,
      2.1182102050614418e6
    ]
  },
  "EPSG:9222": {
    proj4: "+proj=aea +lat_0=-42 +lon_0=44 +lat_1=-34 +lat_2=-50 +x_0=1200000 +y_0=1300000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      397485.8986051517,
      316663.18682536925,
      1.1075243698662189e6,
      1.1580499343505427e6
    ]
  },
  "EPSG:9245": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9248": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-73.28, -52.43, -68.3, -50.33]
  },
  "EPSG:9249": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4120896671069264e6,
      4238051075070109e-9,
      1.6068085613523251e6,
      4423545331641008e-9
    ]
  },
  "EPSG:9250": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2397970995599913e-9,
      4.1899177430915604e6,
      2549844814766657e-9,
      4424387247214378e-9
    ]
  },
  "EPSG:9251": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-68.64, -55.11, -63.73, -52.59]
  },
  "EPSG:9252": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2522975888666984e-9,
      3.8926199551251396e6,
      2857040855500384e-9,
      4.1601127388774026e6
    ]
  },
  "EPSG:9253": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-68.64, -55.11, -63.73, -52.59]
  },
  "EPSG:9254": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2522975888666984e-9,
      3.8926199551251396e6,
      2857040855500384e-9,
      4.1601127388774026e6
    ]
  },
  "EPSG:9255": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9265": {
    proj4: "+proj=utm +zone=19 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      524543.1896534946,
      3.9485396365442546e6,
      707532.1550464836,
      4273625998405391e-9
    ]
  },
  "EPSG:9266": {
    proj4: "+proj=geocent +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4345419041960271e-9,
      729512.9365418354,
      4003986900771836e-9,
      1.2371439896974298e6
    ]
  },
  "EPSG:9267": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [9.53, 46.4, 17.17, 49.02]
  },
  "EPSG:9271": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -61352.44808316992,
      5181464596365577e-9,
      113265.3907466208,
      5275627386663905e-9
    ]
  },
  "EPSG:9272": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -115596.50643239536,
      5141123931136998e-9,
      110693.10098360802,
      5406816773990037e-9
    ]
  },
  "EPSG:9273": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -115258.07854602307,
      5158907347586988e-9,
      61188.13420029538,
      543163396013244e-8
    ]
  },
  "EPSG:9274": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9279": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9284": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3868069869203367e6,
      4.4222999729955755e6,
      1.6183991712015695e6,
      5022824366499748e-9
    ]
  },
  "EPSG:9285": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3903487650584877e6,
      4565908042031497e-9,
      3.5428100070800735e6,
      5174907083547544e-9
    ]
  },
  "EPSG:9286": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [2.53, 50.75, 7.22, 55.77]
  },
  "EPSG:9287": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9288": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9289": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [2.53, 51.45, 6.41, 55.77]
  },
  "EPSG:9290": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [2.53, 51.45, 6.41, 55.77]
  },
  "EPSG:9292": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.8062270670197485e6,
      4869996254702303e-9,
      2.5539639410606134e6,
      5095704582768716e-9
    ]
  },
  "EPSG:9293": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.99, 14.33, 63.38, 26.74]
  },
  "EPSG:9294": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [51.99, 14.33, 63.38, 26.74]
  },
  "EPSG:9295": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      606466.6382767549,
      1.6519268946148441e6,
      815625.7276942935,
      2177756623737552e-9
    ]
  },
  "EPSG:9296": {
    proj4: "+proj=utm +zone=40 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      176364.65321710677,
      1.5863216279581708e6,
      799403.9952776761,
      2961179095398079e-9
    ]
  },
  "EPSG:9297": {
    proj4: "+proj=utm +zone=41 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      179498.59126554977,
      1.8122298092159026e6,
      538623.4714089165,
      2.6642431284939465e6
    ]
  },
  "EPSG:9299": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-2.75, 51.45, 0, 53.3]
  },
  "EPSG:9300": {
    proj4: "+proj=tmerc +lat_0=52.3 +lon_0=-1.5 +k=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      111978.9445654309,
      281230.5064679774,
      298876.1580643944,
      487396.53810376517
    ]
  },
  "EPSG:9303": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9306": {
    proj4: "+proj=tmerc +lat_0=52.3 +lon_0=-1.5 +k=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      111978.9445654309,
      281230.5064679774,
      298876.1580643944,
      487396.53810376517
    ]
  },
  "EPSG:9307": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -187000.39268983566,
      3138322518735391e-9,
      -6.2664553650716785e6,
      731704.4997082698
    ]
  },
  "EPSG:9308": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:9309": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:9311": {
    proj4: "+proj=laea +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8057768293579097e-9,
      1.8155082825963376e6,
      993280.0412414963,
      3.5166635517226886e6
    ]
  },
  "EPSG:9331": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5050326786085115e-9,
      3.4632122026999425e6,
      3.0479901217954187e6,
      4.4631647209247155e6
    ]
  },
  "EPSG:9332": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.44, 16.29, 55.67, 32.16]
  },
  "EPSG:9333": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [34.44, 16.29, 55.67, 32.16]
  },
  "EPSG:9335": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9351": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9354": {
    proj4: "+proj=stere +lat_0=-90 +lat_ts=-65 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 5429391993330811e-25, -44334350092704e-7]
  },
  "EPSG:9356": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      645413.8724885897,
      2756859564963156e-9,
      792165.2841309032,
      3.2538548004879253e6
    ]
  },
  "EPSG:9357": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      179368.03724460263,
      1.8033700911296927e6,
      782929.2897820894,
      3562115601191214e-9
    ]
  },
  "EPSG:9358": {
    proj4: "+proj=utm +zone=38 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      178396.6154929783,
      1810030676805358e-9,
      786010.0952524476,
      3450101353730284e-9
    ]
  },
  "EPSG:9359": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181126.26121374598,
      1.9861290463882815e6,
      793415.2133757307,
      3205069819296655e-9
    ]
  },
  "EPSG:9360": {
    proj4: "+proj=utm +zone=40 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      185404.07380352775,
      2176630340980283e-9,
      363461.08657840727,
      2.5186726165752816e6
    ]
  },
  "EPSG:9364": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-3.14, 53.32, -1.35, 53.9]
  },
  "EPSG:9367": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      143943.44527295837,
      387849.2837328797,
      262410.98511975975,
      452407.9571653986
    ]
  },
  "EPSG:9368": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      143943.44527295837,
      387849.2837328797,
      262410.98511975975,
      452407.9571653986
    ]
  },
  "EPSG:9372": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-1.89, 51.46, 0.15, 53.41]
  },
  "EPSG:9373": {
    proj4: "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -22930.297608640984,
      -1242.4865172388818,
      115848.6862348119,
      215697.7215244275
    ]
  },
  "EPSG:9374": {
    proj4: "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -22930.297608640984,
      -1242.4865172388818,
      115848.6862348119,
      215697.7215244275
    ]
  },
  "EPSG:9377": {
    proj4: "+proj=tmerc +lat_0=4 +lon_0=-73 +k=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6851191445195354e6,
      1.0806163613177175e6,
      5658253749787258e-9,
      3281541164536342e-9
    ]
  },
  "EPSG:9378": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "EPSG:9379": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9380": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9384": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-4.3, 57.1, -2.1, 57.7]
  },
  "EPSG:9387": {
    proj4: "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      89160.38195399076,
      82353.76152883477,
      221416.23231690953,
      149168.8109162244
    ]
  },
  "EPSG:9388": {
    proj4: "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      89160.38195399076,
      82353.76152883477,
      221416.23231690953,
      149168.8109162244
    ]
  },
  "EPSG:9389": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9390": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9391": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      248597.583698968,
      4569740776038191e-9,
      740718.6912419953,
      4892939521879331e-9
    ]
  },
  "EPSG:9392": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9393": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9394": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9395": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9396": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9397": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9398": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9399": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9400": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9401": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9402": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9403": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-18.22, 27.58, -13.37, 29.47]
  },
  "EPSG:9404": {
    proj4: "+proj=utm +zone=27 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      774437.7312461309,
      3054913780995244e-9,
      795382.6997944242,
      3087571168710148e-9
    ]
  },
  "EPSG:9405": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197879.19326705707,
      3.0544585059697707e6,
      658056.2101392259,
      3261212707988845e-9
    ]
  },
  "EPSG:9406": {
    proj4: "+proj=utm +zone=27 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      774437.7312461309,
      3054913780995244e-9,
      795382.6997944242,
      3087571168710148e-9
    ]
  },
  "EPSG:9407": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197879.19326705707,
      3.0544585059697707e6,
      394699.14724750887,
      3.1974319249282414e6
    ]
  },
  "EPSG:9422": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9.56, 35.95, 31.59, 71.21]
  },
  "EPSG:9423": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9.56, 35.95, 31.59, 71.21]
  },
  "EPSG:9424": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.06, 49.93, 1.8, 58.71]
  },
  "EPSG:9425": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9, 49.75, 2.01, 61.01]
  },
  "EPSG:9426": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-3.48, 58.72, -2.34, 59.41]
  },
  "EPSG:9427": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-1.78, 59.83, -0.67, 60.87]
  },
  "EPSG:9428": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.72, 56.76, -6.1, 58.54]
  },
  "EPSG:9429": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-4.87, 54.02, -4.27, 54.44]
  },
  "EPSG:9430": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-6.41, 49.86, -6.23, 49.99]
  },
  "EPSG:9449": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-10.56, 51.39, -5.34, 55.43]
  },
  "EPSG:9450": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-8.18, 53.96, -5.34, 55.36]
  },
  "EPSG:9451": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9452": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9, 49.75, 2.01, 61.01]
  },
  "EPSG:9453": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-4.65, 55.55, -4.05, 55.95]
  },
  "EPSG:9456": {
    proj4: "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      74785.68773304884,
      91644.28013351266,
      112462.35214973157,
      136178.96678138847
    ]
  },
  "EPSG:9457": {
    proj4: "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      74785.68773304884,
      91644.28013351266,
      112462.35214973157,
      136178.96678138847
    ]
  },
  "EPSG:9458": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9462": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [93.41, -60.55, 173.34, -8.47]
  },
  "EPSG:9463": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [96.76, -43.7, 153.69, -9.86]
  },
  "EPSG:9464": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [96.76, -43.7, 153.69, -9.86]
  },
  "EPSG:9468": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -217150.6436071961,
      6187418404931405e-9,
      -4943073721432246e-9,
      3.9375358827488623e6
    ]
  },
  "EPSG:9469": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [92.01, -13.95, 141.46, 7.79]
  },
  "EPSG:9470": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [92.01, -13.95, 141.46, 7.79]
  },
  "EPSG:9471": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9473": {
    proj4: "+proj=aea +lat_0=0 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.5944945069731595e6,
      -4894565948680871e-9,
      2436270292794993e-9,
      -1.2404800126373384e6
    ]
  },
  "EPSG:9474": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9475": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9476": {
    proj4: "+proj=utm +zone=46 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      389832.2676831861,
      0,
      830911.1888054286,
      862257.1887873124
    ]
  },
  "EPSG:9477": {
    proj4: "+proj=utm +zone=47 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      831142.578029119,
      829048.0901737375
    ]
  },
  "EPSG:9478": {
    proj4: "+proj=utm +zone=48 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053626,
      0,
      831543.3153573318,
      768165.583029314
    ]
  },
  "EPSG:9479": {
    proj4: "+proj=utm +zone=49 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      831232.6035901699,
      815764.5430356432
    ]
  },
  "EPSG:9480": {
    proj4: "+proj=utm +zone=50 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      833012.2999687458,
      483690.46048164397
    ]
  },
  "EPSG:9481": {
    proj4: "+proj=utm +zone=51 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      832459.4947813818,
      606554.9365959951
    ]
  },
  "EPSG:9482": {
    proj4: "+proj=utm +zone=52 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      831722.1709201407,
      739385.1214865021
    ]
  },
  "EPSG:9487": {
    proj4: "+proj=utm +zone=47 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      169987.60457850288,
      9019294169273801e-9,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:9488": {
    proj4: "+proj=utm +zone=48 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171833.30950013385,
      8812273688969577e-9,
      835092.8490763598,
      1e7
    ]
  },
  "EPSG:9489": {
    proj4: "+proj=utm +zone=49 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      173370.10090469214,
      8663916571550943e-9,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:9490": {
    proj4: "+proj=utm +zone=50 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      174619.8299262626,
      8554302872872595e-9,
      835092.849076364,
      1e7
    ]
  },
  "EPSG:9491": {
    proj4: "+proj=utm +zone=51 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      175825.93248612247,
      8455756095262446e-9,
      835092.8439973067,
      10001106837769464e-9
    ]
  },
  "EPSG:9492": {
    proj4: "+proj=utm +zone=52 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      170532.23225242615,
      8953979307493195e-9,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:9493": {
    proj4: "+proj=utm +zone=53 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171131.89404413168,
      8886448714191712e-9,
      835092.8490763612,
      1e7
    ]
  },
  "EPSG:9494": {
    proj4: "+proj=utm +zone=54 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171952.74030764907,
      8800095482658522e-9,
      551187.0365818501,
      1e7
    ]
  },
  "EPSG:9498": {
    proj4: "+proj=tmerc +lat_0=-34.6292666666667 +lon_0=-58.4633083333333 +k=1 +x_0=20000 +y_0=70000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      12974.346873505458,
      61041.20751389881,
      35916.64288384793,
      84326.25597464302
    ]
  },
  "EPSG:9500": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [9.53, 46.4, 17.17, 49.02]
  },
  "EPSG:9501": {
    proj4: "+proj=longlat +ellps=bessel +vunits=m +no_defs +type=crs",
    projected_bounds: [9.53, 46.4, 17.17, 49.02]
  },
  "EPSG:9502": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=ft +no_defs +type=crs",
    projected_bounds: [-79.92, 19.66, -79.69, 19.78]
  },
  "EPSG:9503": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=ft +no_defs +type=crs",
    projected_bounds: [-81.46, 19.21, -81.04, 19.41]
  },
  "EPSG:9504": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=ft +no_defs +type=crs",
    projected_bounds: [-80.14, 19.63, -79.93, 19.74]
  },
  "EPSG:9505": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-9.37, 35.95, 3.39, 43.82]
  },
  "EPSG:9506": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.4, 35.82, -5.24, 35.97]
  },
  "EPSG:9507": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [1.12, 38.59, 1.68, 39.17]
  },
  "EPSG:9508": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [2.23, 39.07, 3.55, 40.02]
  },
  "EPSG:9509": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [3.73, 39.75, 4.39, 40.15]
  },
  "EPSG:9510": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-18.22, 27.58, -17.83, 27.9]
  },
  "EPSG:9511": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-14.58, 27.99, -13.75, 28.81]
  },
  "EPSG:9512": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-15.88, 27.68, -15.31, 28.23]
  },
  "EPSG:9513": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-17.39, 27.95, -17.03, 28.26]
  },
  "EPSG:9514": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-18.06, 28.4, -17.66, 28.9]
  },
  "EPSG:9515": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-13.95, 28.78, -13.37, 29.47]
  },
  "EPSG:9516": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-16.96, 27.93, -16.08, 28.63]
  },
  "EPSG:9517": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.85, -16.08, -5.58, -15.85]
  },
  "EPSG:9518": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9519": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [11.17, 54.42, 11.51, 54.76]
  },
  "EPSG:9520": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [34.51, 16.37, 55.67, 32.16]
  },
  "EPSG:9521": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-73.59, -55.11, -53.65, -21.78]
  },
  "EPSG:9522": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-67.97, 17.87, -65.19, 18.57]
  },
  "EPSG:9523": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-65.09, 17.62, -64.51, 18.44]
  },
  "EPSG:9524": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [144.58, 13.18, 145.01, 13.7]
  },
  "EPSG:9525": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [144.83, 14.06, 146.12, 20.61]
  },
  "EPSG:9526": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-170.88, -14.43, -170.51, -14.2]
  },
  "EPSG:9527": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [160.6, -55.95, -171.2, -25.88]
  },
  "EPSG:9528": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [160.6, -55.95, -171.2, -25.88]
  },
  "EPSG:9529": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [92.01, -13.95, 141.46, 7.79]
  },
  "EPSG:9530": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-54.61, 2.11, -51.61, 5.81]
  },
  "EPSG:9531": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.85, 15.88, -61.15, 16.55]
  },
  "EPSG:9532": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.68, 15.8, -61.52, 15.94]
  },
  "EPSG:9533": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.39, 15.8, -61.13, 16.05]
  },
  "EPSG:9534": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-62.92, 17.82, -62.73, 17.98]
  },
  "EPSG:9535": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63.21, 18.01, -62.96, 18.17]
  },
  "EPSG:9536": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.13, 16.26, -60.97, 16.38]
  },
  "EPSG:9537": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.29, 14.35, -60.76, 14.93]
  },
  "EPSG:9538": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-4.87, 42.33, 8.23, 51.14]
  },
  "EPSG:9539": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [8.5, 41.31, 9.63, 43.07]
  },
  "EPSG:9540": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [163.54, -22.73, 168.19, -19.5]
  },
  "EPSG:9541": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-56.48, 46.69, -56.07, 47.19]
  },
  "EPSG:9542": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.13, 16.26, -60.97, 16.38]
  },
  "EPSG:9543": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [16.45, -34.88, 32.95, -22.13]
  },
  "EPSG:9544": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-141.01, 38.21, -40.73, 86.46]
  },
  "EPSG:9545": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4512891646901837e-9,
      367062.654999279,
      4405114633896277e-9,
      609692.9614146806
    ]
  },
  "EPSG:9546": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [4.65, 44.87, 7.88, 45.89]
  },
  "EPSG:9547": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [4.65, 44.87, 7.88, 45.89]
  },
  "EPSG:9650": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9651": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9656": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [14.14, 49, 24.15, 54.89]
  },
  "EPSG:9657": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [14.14, 49, 24.15, 54.89]
  },
  "EPSG:9663": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9666": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9669": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9672": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9674": {
    proj4: "+proj=aea +lat_0=34 +lon_0=-120 +lat_1=43 +lat_2=48 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      202906.72691165225,
      891121.5042389324,
      858220.9825406896,
      1670980223072319e-9
    ]
  },
  "EPSG:9675": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9678": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=-2000000 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      292524.730156826,
      270104.4669028274,
      765763.4295766877,
      949093.6132309232
    ]
  },
  "EPSG:9680": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      289974.45791422186,
      2.0533048321834302e6,
      765800.8121550935,
      2.9493411941972403e6
    ]
  },
  "EPSG:9681": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9694": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.2649263432362222e6,
      -2.9498722719793003e6,
      2502038091084371e-9,
      -5546561512064938e-9
    ]
  },
  "EPSG:9695": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9696": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-113.21, -59.87, -65.72, -17.5]
  },
  "EPSG:9697": {
    proj4: "+proj=utm +zone=12 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      647512.0390098759,
      6984996108663735e-9,
      682558.3625841985,
      7011125606630531e-9
    ]
  },
  "EPSG:9698": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      818130.0801922004,
      7968458629497271e-9
    ]
  },
  "EPSG:9699": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      818590.9266396924,
      8062621368716022e-9
    ]
  },
  "EPSG:9700": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4.0654113019990344e6,
      1.0241785288095111e6,
      3.2678567784971544e6,
      1.4652066834156064e6
    ]
  },
  "EPSG:9701": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [14.14, 49, 24.15, 55.93]
  },
  "EPSG:9702": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [14.14, 49, 24.15, 55.93]
  },
  "EPSG:9705": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9707": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "EPSG:9709": {
    proj4: "+proj=utm +zone=23 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243340.25432519306,
      4415416678187952e-9,
      694398.0543714615,
      6039959486458218e-9
    ]
  },
  "EPSG:9711": {
    proj4: "+proj=utm +zone=23 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      243340.25432519306,
      4415416678187952e-9,
      694398.0543714615,
      6039959486458218e-9
    ]
  },
  "EPSG:9712": {
    proj4: "+proj=utm +zone=24 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      265745.9523897524,
      5046207860865933e-9,
      374814.4539251403,
      5487814048700972e-9
    ]
  },
  "EPSG:9713": {
    proj4: "+proj=utm +zone=24 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      265745.9523897524,
      5046207860865933e-9,
      374814.4539251403,
      5487814048700972e-9
    ]
  },
  "EPSG:9714": {
    proj4: "+proj=utm +zone=24 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      265745.9523897524,
      5046207860865933e-9,
      374814.4539251403,
      5487814048700972e-9
    ]
  },
  "EPSG:9715": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      276353.9599205883,
      532398969591123e-8,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:9716": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      224488.26420493022,
      3850556815798412e-9,
      332597.54724696174,
      4611758561637851e-9
    ]
  },
  "EPSG:9721": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9722": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "EPSG:9723": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [6.62, 36.59, 18.58, 47.1]
  },
  "EPSG:9724": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [12.36, 36.59, 15.71, 38.35]
  },
  "EPSG:9725": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [8.08, 38.82, 9.89, 41.31]
  },
  "EPSG:9739": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-3.55, 55.55, -1.95, 57.2]
  },
  "EPSG:9741": {
    proj4: "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      24504.88359464635,
      44726.30704105136,
      123352.92178486488,
      228444.57830414636
    ]
  },
  "EPSG:9742": {
    proj4: "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      24504.88359464635,
      44726.30704105136,
      123352.92178486488,
      228444.57830414636
    ]
  },
  "EPSG:9748": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      356385.0089034631,
      179509.22097966477,
      938689.3010332669,
      1.6385722924042298e6
    ]
  },
  "EPSG:9749": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1658725179737903e-9,
      52243.82084158502,
      2327799143945123e-9,
      1828472023116929e-9
    ]
  },
  "EPSG:20004": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4406948830159834e-9,
      6022583485251955e-9,
      4618709290617259e-9,
      6134555539008731e-9
    ]
  },
  "EPSG:20005": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5475472065704416e-9,
      6174225051903019e-9,
      5617425284004602e-9,
      7.7128683272320805e6
    ]
  },
  "EPSG:20006": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6286447889742024e-9,
      5583069936754964e-9,
      6614411637087304e-9,
      7774162716634687e-9
    ]
  },
  "EPSG:20007": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7256081059590332e-9,
      4787173144948495e-9,
      7.6191324312237855e6,
      7686141985427631e-9
    ]
  },
  "EPSG:20008": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8248300990867341e-9,
      4566096180558951e-9,
      855291160575285e-8,
      8988276335345622e-9
    ]
  },
  "EPSG:20009": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      924906928569681e-8,
      4588312446546785e-9,
      955008177444493e-8,
      9042922756726556e-9
    ]
  },
  "EPSG:20010": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      10287031733286502e-9,
      5597527264717192e-9,
      10547132497060755e-9,
      9099800724680038e-9
    ]
  },
  "EPSG:20011": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      11287887027647886e-9,
      5618657630227684e-9,
      11547942489828466e-9,
      9084187058666075e-9
    ]
  },
  "EPSG:20012": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      12303769183665453e-9,
      6.0013148492511045e6,
      12574935856555257e-9,
      8560068375251852e-9
    ]
  },
  "EPSG:20013": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      132994027408947e-7,
      5897847888617684e-9,
      13559824801769981e-9,
      885445301426915e-8
    ]
  },
  "EPSG:20014": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      14288022289032927e-9,
      5.6219940497905165e6,
      145522189407067e-7,
      9001659035253026e-9
    ]
  },
  "EPSG:20015": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      15280802858796783e-9,
      5.4418454210249195e6,
      15550832916727256e-9,
      902842462503835e-8
    ]
  },
  "EPSG:20016": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16284435457477678e-9,
      5533027165774099e-9,
      16550370706484398e-9,
      9037346543693524e-9
    ]
  },
  "EPSG:20017": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      17283723144953106e-9,
      5515234864293874e-9,
      17550544047046762e-9,
      9034000820986697e-9
    ]
  },
  "EPSG:20018": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      18283323214760493e-9,
      5505226852548886e-9,
      18561146886303443e-9,
      8828804348140907e-9
    ]
  },
  "EPSG:20019": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      19281111205380004e-9,
      5449628859473506e-9,
      19576415869080156e-9,
      8531078169374652e-9
    ]
  },
  "EPSG:20020": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      20282746487986702e-9,
      5490771036350928e-9,
      2058124307745921e-8,
      8436305541392285e-9
    ]
  },
  "EPSG:20021": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      21291741964205667e-9,
      5713194370626235e-9,
      2159230320326116e-8,
      8217790026561463e-9
    ]
  },
  "EPSG:20022": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2225240780383987e-8,
      4683848810351307e-9,
      2259449130315746e-8,
      8174313274365788e-9
    ]
  },
  "EPSG:20023": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      23253900845504683e-9,
      4.7260658776550945e6,
      23580165589163687e-9,
      8457489597908182e-9
    ]
  },
  "EPSG:20024": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2426694029144985e-8,
      5082770654099713e-9,
      24579484609098762e-9,
      8470869126102943e-9
    ]
  },
  "EPSG:20025": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      25257761160012648e-9,
      4833839761162132e-9,
      25576358974819794e-9,
      8532193169384241e-9
    ]
  },
  "EPSG:20026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2626664795126798e-8,
      5074990485225236e-9,
      2657954137097728e-8,
      8469754161775332e-9
    ]
  },
  "EPSG:20027": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      272861339706551e-7,
      5575285319558777e-9,
      27574195261757378e-9,
      8574563637140198e-9
    ]
  },
  "EPSG:20028": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      28305520924267735e-9,
      6042482385332407e-9,
      2861435674386257e-8,
      7775277186006402e-9
    ]
  },
  "EPSG:20029": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      29305426025921304e-9,
      6040257065872187e-9,
      29613477973776083e-9,
      7793108820650335e-9
    ]
  },
  "EPSG:20030": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      30341042216920733e-9,
      6841708934015177e-9,
      30605751281453803e-9,
      7949145415708783e-9
    ]
  },
  "EPSG:20031": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      31355082732605718e-9,
      7142417650495278e-9,
      3160541867530731e-8,
      7.9558330818749685e6
    ]
  },
  "EPSG:20032": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3235429387801237e-8,
      7.1257094232059745e6,
      3258788182514807e-8,
      7455992844597268e-9
    ]
  },
  "EPSG:20135": {
    proj4: "+proj=utm +zone=35 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      165800.98955099337,
      465941.98535777273,
      810784.3177325611,
      2.4367895822036783e6
    ]
  },
  "EPSG:20136": {
    proj4: "+proj=utm +zone=36 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      165519.636700438,
      386254.3343289489,
      809248.1580861639,
      2.4622508457004484e6
    ]
  },
  "EPSG:20137": {
    proj4: "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      166600.51548483624,
      376289.9820924951,
      809751.1270920493,
      2.4367692553656376e6
    ]
  },
  "EPSG:20138": {
    proj4: "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      166870.2209639551,
      454870.01335313683,
      824573.5531743641,
      1.4223054047415357e6
    ]
  },
  "EPSG:20249": {
    proj4: "+proj=utm +zone=49 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      344254.9467679274,
      5810446473899567e-9,
      819128.5213931636,
      8096948666681321e-9
    ]
  },
  "EPSG:20250": {
    proj4: "+proj=utm +zone=50 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      238486.9493826841,
      5731095919595268e-9,
      825961.4233490981,
      8604123196254466e-9
    ]
  },
  "EPSG:20251": {
    proj4: "+proj=utm +zone=51 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      236828.5437777972,
      5782153027541263e-9,
      829551.7159640361,
      8842150953595188e-9
    ]
  },
  "EPSG:20252": {
    proj4: "+proj=utm +zone=52 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      233487.2140740821,
      5858705011727239e-9,
      829796.2424254367,
      8992722126712244e-9
    ]
  },
  "EPSG:20253": {
    proj4: "+proj=utm +zone=53 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      246574.3867917859,
      5489089718622004e-9,
      831096.6493420552,
      9017067822972327e-9
    ]
  },
  "EPSG:20254": {
    proj4: "+proj=utm +zone=54 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      270358.58360803203,
      4831561009901632e-9,
      834769.0014973187,
      9719967759606013e-9
    ]
  },
  "EPSG:20255": {
    proj4: "+proj=utm +zone=55 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      272782.7880920393,
      4768225430568362e-9,
      835008.224626149,
      9856110415325874e-9
    ]
  },
  "EPSG:20256": {
    proj4: "+proj=utm +zone=56 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      269555.581654734,
      4852671845810608e-9,
      833707.333212682,
      9743214101048276e-9
    ]
  },
  "EPSG:20257": {
    proj4: "+proj=utm +zone=57 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      226635.1826236889,
      6108406368812558e-9,
      825073.3918696386,
      844134201474467e-8
    ]
  },
  "EPSG:20258": {
    proj4: "+proj=utm +zone=58 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      223624.98779414973,
      6.2093660267255185e6,
      321791.49415697344,
      6984582036128731e-9
    ]
  },
  "EPSG:20349": {
    proj4: "+proj=utm +zone=49 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      344254.9467679274,
      5810446473899567e-9,
      819128.5213931636,
      8096948666681321e-9
    ]
  },
  "EPSG:20350": {
    proj4: "+proj=utm +zone=50 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      238486.9493826841,
      5731095919595268e-9,
      825961.4233490981,
      8604123196254466e-9
    ]
  },
  "EPSG:20351": {
    proj4: "+proj=utm +zone=51 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      236828.5437777972,
      5782153027541263e-9,
      829551.7159640361,
      8842150953595188e-9
    ]
  },
  "EPSG:20352": {
    proj4: "+proj=utm +zone=52 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      232322.50152447494,
      5895328117655948e-9,
      830644.2898456126,
      896282268038926e-8
    ]
  },
  "EPSG:20353": {
    proj4: "+proj=utm +zone=53 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      230056.99927126383,
      599633932420168e-8,
      800344.6222341051,
      7121965888073383e-9
    ]
  },
  "EPSG:20354": {
    proj4: "+proj=utm +zone=54 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      237043.89537270222,
      5775493570048198e-9,
      830167.8523661403,
      8908576455684701e-9
    ]
  },
  "EPSG:20355": {
    proj4: "+proj=utm +zone=55 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      207756.04451157933,
      6787182774985217e-9,
      824091.1204666273,
      8449106960413009e-9
    ]
  },
  "EPSG:20356": {
    proj4: "+proj=utm +zone=56 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      208264.7175357727,
      6767225439413806e-9,
      562965.8045123076,
      7567039072673456e-9
    ]
  },
  "EPSG:20436": {
    proj4: "+proj=utm +zone=36 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      650069.4420679803,
      2967432265036727e-9,
      791206.6259329657,
      3253876770036108e-9
    ]
  },
  "EPSG:20437": {
    proj4: "+proj=utm +zone=37 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      179847.85375633748,
      1836616463505875e-9,
      782941.5619461753,
      3.5621693705831524e6
    ]
  },
  "EPSG:20438": {
    proj4: "+proj=utm +zone=38 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      179485.61463665118,
      1812251637924689e-9,
      786976.2552366982,
      3450178492387654e-9
    ]
  },
  "EPSG:20439": {
    proj4: "+proj=utm +zone=39 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      181113.28084017342,
      1986153414551911e-9,
      790270.5686666814,
      3.3270851941822395e6
    ]
  },
  "EPSG:20440": {
    proj4: "+proj=utm +zone=40 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      185391.18611309212,
      2176657626377033e-9,
      363455.4234761195,
      2.5187054727366404e6
    ]
  },
  "EPSG:20499": {
    proj4: "+proj=utm +zone=39 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      438708.4484979097,
      2823814942661574e-9,
      485031.1846876296,
      2.9133863024490126e6
    ]
  },
  "EPSG:20538": {
    proj4: "+proj=utm +zone=38 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      166015.78802212566,
      0,
      827287.7831833309,
      1.2752121903344803e6
    ]
  },
  "EPSG:20539": {
    proj4: "+proj=utm +zone=39 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      167013.25140472833,
      491447.3795454858,
      551159.500213477,
      1.3299384890440896e6
    ]
  },
  "EPSG:20790": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=1 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +pm=lisbon +units=m +no_defs +type=crs",
    projected_bounds: [
      72790.44418390574,
      -611.5531991816242,
      360495.17241202417,
      578724.2758687437
    ]
  },
  "EPSG:20791": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=1 +k=1 +x_0=0 +y_0=0 +ellps=intl +pm=lisbon +units=m +no_defs +type=crs",
    projected_bounds: [
      -127209.55581609426,
      -300611.5531991816,
      160495.17241202417,
      278724.27586874366
    ]
  },
  "EPSG:20822": {
    proj4: "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      284684.2604177229,
      6045541813326169e-9,
      803816.7774389519,
      7230531700959295e-9
    ]
  },
  "EPSG:20823": {
    proj4: "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      220352.1637693593,
      6289167167621423e-9,
      835106.0404733336,
      1e7
    ]
  },
  "EPSG:20824": {
    proj4: "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      199567.47204532556,
      7082010075752932e-9,
      833991.6993592987,
      10001106839636274e-9
    ]
  },
  "EPSG:20904": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4406950382938819e-9,
      6022477332348477e-9,
      4618707310633811e-9,
      6134447481559378e-9
    ]
  },
  "EPSG:20905": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5475472474739856e-9,
      6174116319808341e-9,
      5617423337066655e-9,
      77127336884818e-7
    ]
  },
  "EPSG:20906": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      628645146041116e-8,
      5582971288634614e-9,
      6614409740468683e-9,
      7774027054440035e-9
    ]
  },
  "EPSG:20907": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      7256085152912206e-9,
      4787088197158835e-9,
      7619130455818289e-9,
      7686007793113248e-9
    ]
  },
  "EPSG:20908": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      8248305219018457e-9,
      4566015064269312e-9,
      855291073103014e-8,
      8988120498511467e-9
    ]
  },
  "EPSG:20909": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      9249073500515662e-9,
      4588230944717676e-9,
      9550080946568727e-9,
      9042766015246818e-9
    ]
  },
  "EPSG:20910": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1028703529396015e-8,
      5597428369078731e-9,
      10547131717997152e-9,
      9099643041830169e-9
    ]
  },
  "EPSG:20911": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      11287890573682223e-9,
      5618558372910174e-9,
      11547941697360024e-9,
      9084029634211903e-9
    ]
  },
  "EPSG:20912": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      12303772458585031e-9,
      6001209059550559e-9,
      12574934616802067e-9,
      855991963556606e-8
    ]
  },
  "EPSG:20913": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      13299406090216598e-9,
      5897743861987098e-9,
      1355982381255424e-8,
      8854299393753236e-9
    ]
  },
  "EPSG:20914": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      14288025832752489e-9,
      5621894735374272e-9,
      14552218077451741e-9,
      9001502976855049e-9
    ]
  },
  "EPSG:20915": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1528080652620946e-8,
      5441749193259758e-9,
      1555083207641731e-8,
      9028268123547854e-9
    ]
  },
  "EPSG:20916": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      16284439062614696e-9,
      5532929374783393e-9,
      16550369873825561e-9,
      9037189894515758e-9
    ]
  },
  "EPSG:20917": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1728372676229574e-8,
      5515137378186269e-9,
      17550543211518597e-9,
      9033844227191066e-9
    ]
  },
  "EPSG:20918": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      18283326838957284e-9,
      5505129537967084e-9,
      18561145875183623e-9,
      8828651152567921e-9
    ]
  },
  "EPSG:20919": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1928111486750358e-8,
      5449532498194325e-9,
      19576414604765873e-9,
      8530929910787173e-9
    ]
  },
  "EPSG:20920": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2028275012206926e-8,
      5490673969565581e-9,
      2058124173300524e-8,
      843615885618905e-8
    ]
  },
  "EPSG:20921": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      21291745444309026e-9,
      5713093496404845e-9,
      21592301674997084e-9,
      8217646972911589e-9
    ]
  },
  "EPSG:20922": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2225241196077037e-8,
      4683765651882682e-9,
      22594489738494728e-9,
      8174170943944754e-9
    ]
  },
  "EPSG:20923": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      23253904976570107e-9,
      4725981987794288e-9,
      2358016426260205e-8,
      8457342560930908e-9
    ]
  },
  "EPSG:20924": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2426694419722775e-8,
      5082680600915977e-9,
      24579483293843932e-9,
      8470721866975527e-9
    ]
  },
  "EPSG:20925": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      25257765224269714e-9,
      4833754006030003e-9,
      2557635771144976e-8,
      8532044892291518e-9
    ]
  },
  "EPSG:20926": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      26266651862085097e-9,
      5074900566157227e-9,
      2657954005478003e-8,
      8469606921159754e-9
    ]
  },
  "EPSG:20927": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2728613754669937e-8,
      5575186804735429e-9,
      27574194034292866e-9,
      8574414656934628e-9
    ]
  },
  "EPSG:20928": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      28305524169366267e-9,
      6042375894796346e-9,
      28614354848160252e-9,
      7775141505208458e-9
    ]
  },
  "EPSG:20929": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2930542927263495e-8,
      6040150613210422e-9,
      29613476092741374e-9,
      7792972842222776e-9
    ]
  },
  "EPSG:20930": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      30341044860517938e-9,
      6841588908705219e-9,
      30605749529288072e-9,
      7949006834830863e-9
    ]
  },
  "EPSG:20931": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      3135508513997347e-8,
      714229256574004e-8,
      31605416928685084e-9,
      7955694389534312e-9
    ]
  },
  "EPSG:20932": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      32354296298631784e-9,
      712558461912735e-8,
      32587880366856605e-9,
      745586250106579e-8
    ]
  },
  "EPSG:20934": {
    proj4: "+proj=utm +zone=34 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      399680.53468178364,
      7026696037027197e-9,
      828031.8340075284,
      8797989641119491e-9
    ]
  },
  "EPSG:20935": {
    proj4: "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      199267.2492190483,
      7138834461158795e-9,
      830494.9272544913,
      908026323072257e-8
    ]
  },
  "EPSG:20936": {
    proj4: "+proj=utm +zone=36 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      191148.93953505816,
      7517806597757948e-9,
      822874.3594819021,
      9093602939825304e-9
    ]
  },
  "EPSG:21004": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      406950.38293881936,
      6022477332348477e-9,
      618707.3106338116,
      6134447481559378e-9
    ]
  },
  "EPSG:21005": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      475472.4747398556,
      6174116319808341e-9,
      617423.3370666552,
      77127336884818e-7
    ]
  },
  "EPSG:21006": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      286451.4604111599,
      5582971288634614e-9,
      614409.7404686825,
      7774027054440035e-9
    ]
  },
  "EPSG:21007": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      256085.15291220616,
      4787088197158835e-9,
      619130.455818289,
      7686007793113248e-9
    ]
  },
  "EPSG:21008": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      248305.219018457,
      4566015064269312e-9,
      552910.7310301396,
      8988120498511467e-9
    ]
  },
  "EPSG:21009": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      249073.50051566263,
      4588230944717676e-9,
      550080.9465687278,
      9042766015246818e-9
    ]
  },
  "EPSG:21010": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      287035.29396015045,
      5597428369078731e-9,
      547131.7179971519,
      9099643041830169e-9
    ]
  },
  "EPSG:21011": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      287890.57368222275,
      5618558372910174e-9,
      547941.6973600247,
      9084029634211903e-9
    ]
  },
  "EPSG:21012": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      303772.4585850315,
      6001209059550559e-9,
      574934.6168020662,
      855991963556606e-8
    ]
  },
  "EPSG:21013": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      299406.09021659667,
      5897743861987098e-9,
      559823.8125542405,
      8854299393753236e-9
    ]
  },
  "EPSG:21014": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      288025.83275248925,
      5621894735374272e-9,
      552218.077451742,
      9001502976855049e-9
    ]
  },
  "EPSG:21015": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      280806.5262094607,
      5441749193259758e-9,
      550832.0764173098,
      9028268123547854e-9
    ]
  },
  "EPSG:21016": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      284439.0626146961,
      5532929374783393e-9,
      550369.8738255609,
      9037189894515758e-9
    ]
  },
  "EPSG:21017": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      283726.76229574246,
      5515137378186269e-9,
      550543.211518598,
      9033844227191066e-9
    ]
  },
  "EPSG:21018": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      283326.83895728306,
      5505129537967084e-9,
      561145.8751836229,
      8828651152567921e-9
    ]
  },
  "EPSG:21019": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      281114.86750357854,
      5449532498194325e-9,
      576414.6047658719,
      8530929910787173e-9
    ]
  },
  "EPSG:21020": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      282750.12206925906,
      5490673969565581e-9,
      581241.7330052389,
      843615885618905e-8
    ]
  },
  "EPSG:21021": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      291745.44430902693,
      5713093496404845e-9,
      592301.6749970831,
      8217646972911589e-9
    ]
  },
  "EPSG:21022": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      252411.96077036773,
      4683765651882682e-9,
      594489.7384947272,
      8174170943944754e-9
    ]
  },
  "EPSG:21023": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      253904.97657010553,
      4725981987794288e-9,
      580164.26260205,
      8457342560930908e-9
    ]
  },
  "EPSG:21024": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      266944.1972277496,
      5082680600915977e-9,
      579483.2938439326,
      8470721866975527e-9
    ]
  },
  "EPSG:21025": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      257765.224269714,
      4833754006030003e-9,
      576357.7114497591,
      8532044892291518e-9
    ]
  },
  "EPSG:21026": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      266651.8620850969,
      5074900566157227e-9,
      579540.054780027,
      8469606921159754e-9
    ]
  },
  "EPSG:21027": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      286137.54669937026,
      5575186804735429e-9,
      574194.0342928665,
      8574414656934628e-9
    ]
  },
  "EPSG:21028": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      305524.16936626716,
      6042375894796346e-9,
      614354.8481602529,
      7775141505208458e-9
    ]
  },
  "EPSG:21029": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      305429.2726349505,
      6040150613210422e-9,
      613476.0927413737,
      7792972842222776e-9
    ]
  },
  "EPSG:21030": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      341044.8605179361,
      6841588908705219e-9,
      605749.5292880717,
      7949006834830863e-9
    ]
  },
  "EPSG:21031": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      355085.1399734705,
      714229256574004e-8,
      605416.9286850857,
      7955694389534312e-9
    ]
  },
  "EPSG:21032": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      354296.29863178334,
      712558461912735e-8,
      587880.3668566032,
      745586250106579e-8
    ]
  },
  "EPSG:21035": {
    proj4: "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      758633.6415150845,
      9246697265013017e-9,
      833984.4460773508,
      1e7
    ]
  },
  "EPSG:21036": {
    proj4: "+proj=utm +zone=36 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      171724.41425353184,
      8714950267568452e-9,
      833984.4410157097,
      10001106725583406e-9
    ]
  },
  "EPSG:21037": {
    proj4: "+proj=utm +zone=37 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      172980.39687394816,
      8699462914938075e-9,
      789420.0183396214,
      1e7
    ]
  },
  "EPSG:21095": {
    proj4: "+proj=utm +zone=35 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      801673.7251073434,
      0,
      833947.0108566426,
      95178.45334077138
    ]
  },
  "EPSG:21096": {
    proj4: "+proj=utm +zone=36 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      164901.24200360972,
      0,
      832899.951450259,
      512422.23259923235
    ]
  },
  "EPSG:21097": {
    proj4: "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      166015.55392264994,
      0,
      822966.8965399505,
      496886.94363547966
    ]
  },
  "EPSG:21148": {
    proj4: "+proj=utm +zone=48 +south +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      506614.5232168188,
      913900008675063e-8,
      833101.6983588525,
      9549558892429465e-9
    ]
  },
  "EPSG:21149": {
    proj4: "+proj=utm +zone=49 +south +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      169858.00765435147,
      9040419683308331e-9,
      833017.3418851285,
      9527423615473727e-9
    ]
  },
  "EPSG:21150": {
    proj4: "+proj=utm +zone=50 +south +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      170070.76644190773,
      9013853872976473e-9,
      501107.84170948586,
      9410914333562655e-9
    ]
  },
  "EPSG:21207": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      7156950382938819e-9,
      6022477332348477e-9,
      7345221890123407e-9,
      613387934212404e-8
    ]
  },
  "EPSG:21208": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      8152443184461879e-9,
      6024797927486217e-9,
      8177814195936658e-9,
      6105606086628469e-9
    ]
  },
  "EPSG:21209": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      9225698316261906e-9,
      6214198179714916e-9,
      9310602315775117e-9,
      7650361274830515e-9
    ]
  },
  "EPSG:21210": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      10148948611403292e-9,
      5858981539065238e-9,
      1030768626422165e-8,
      7752954839502483e-9
    ]
  },
  "EPSG:21211": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      11145250216847632e-9,
      5679854661533623e-9,
      11307219903272953e-9,
      7771915273339528e-9
    ]
  },
  "EPSG:21212": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      12130929976692375e-9,
      4942698729697222e-9,
      12309338486086791e-9,
      7701661522769336e-9
    ]
  },
  "EPSG:21213": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      13128344322882483e-9,
      4800473987136269e-9,
      1331055513749976e-8,
      7635853960677158e-9
    ]
  },
  "EPSG:21214": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      14127429950195832e-9,
      4749369244917299e-9,
      14310718458532684e-9,
      7629162888131198e-9
    ]
  },
  "EPSG:21215": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      15125508494863482e-9,
      4640506721252901e-9,
      15276781437136466e-9,
      8974815246047705e-9
    ]
  },
  "EPSG:21216": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1612415840141334e-8,
      456275841256506e-8,
      162764639819559e-7,
      8987094449568026e-9
    ]
  },
  "EPSG:21217": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      1712642547573144e-8,
      4692714127595092e-9,
      1727556880506461e-8,
      9021699847890947e-9
    ]
  },
  "EPSG:21218": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      18143623108839616e-9,
      5599763135752094e-9,
      1827501976984301e-8,
      9042909872396544e-9
    ]
  },
  "EPSG:21219": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      19143645592120513e-9,
      5600875454611555e-9,
      19273631499486085e-9,
      9096493954618169e-9
    ]
  },
  "EPSG:21220": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2014351074147446e-8,
      5594201568308065e-9,
      20273573617547512e-9,
      9098726650822194e-9
    ]
  },
  "EPSG:21221": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      21144773908371318e-9,
      5656493677275069e-9,
      21273978729289353e-9,
      908309782064238e-8
    ]
  },
  "EPSG:21222": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      22152372158539608e-9,
      6021458961568735e-9,
      22275482134169377e-9,
      9025048785943437e-9
    ]
  },
  "EPSG:21223": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2315365474337205e-8,
      608156272536201e-8,
      23287478866902575e-9,
      8558485301566461e-9
    ]
  },
  "EPSG:21224": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      24150300841917925e-9,
      5923522911225831e-9,
      2429737059120053e-8,
      816792774625686e-8
    ]
  },
  "EPSG:21225": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      25150394481075548e-9,
      5927974257349818e-9,
      25279921506110556e-9,
      8853143420961523e-9
    ]
  },
  "EPSG:21226": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2614581910136495e-8,
      5707666381102957e-9,
      2627611755398121e-8,
      9000490023329448e-9
    ]
  },
  "EPSG:21227": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2714402830730266e-8,
      5619785148988014e-9,
      27276117553981207e-9,
      9000490023329448e-9
    ]
  },
  "EPSG:21228": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2814152436710841e-8,
      5495213171026677e-9,
      28286081808916613e-9,
      8613171738246908e-9
    ]
  },
  "EPSG:21229": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      2914039797085683e-8,
      5438495904172489e-9,
      29287222470461622e-9,
      8568529607063133e-9
    ]
  },
  "EPSG:21230": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      30141214293695908e-9,
      547964325848642e-8,
      30275395456160504e-9,
      9028397728964217e-9
    ]
  },
  "EPSG:21231": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      31142815892723877e-9,
      5559720849884502e-9,
      31275453242288962e-9,
      902616509973248e-8
    ]
  },
  "EPSG:21232": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      3214185731318038e-8,
      5511895611681848e-9,
      32275193179944757e-9,
      9036211948574519e-9
    ]
  },
  "EPSG:21233": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      33141990700990904e-9,
      5518568701273885e-9,
      3327649284563976e-8,
      8985978155462975e-9
    ]
  },
  "EPSG:21234": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      34142838257917285e-9,
      5560833104229839e-9,
      3427992150611056e-8,
      8853143420961523e-9
    ]
  },
  "EPSG:21235": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      3514274881690244e-8,
      5556384097613645e-9,
      35281358286018595e-9,
      8797333174796809e-9
    ]
  },
  "EPSG:21236": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      361407945274821e-7,
      5458513227675825e-9,
      3628368066185017e-8,
      8706924189998943e-9
    ]
  },
  "EPSG:21237": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      371405520579672e-7,
      5446280349416068e-9,
      3728821903687124e-8,
      8529468784662092e-9
    ]
  },
  "EPSG:21238": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      38141324959126085e-9,
      5485203901018806e-9,
      3828853194552888e-8,
      8517192731296962e-9
    ]
  },
  "EPSG:21239": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      39141369248665474e-9,
      5487428170638809e-9,
      3929495527576678e-8,
      8263882923127677e-9
    ]
  },
  "EPSG:21240": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      40142168737160206e-9,
      552746625474711e-8,
      402972024265923e-7,
      8.1746220586208915e6
    ]
  },
  "EPSG:21241": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4114971671075619e-8,
      589570263165355e-8,
      4129616425554488e-8,
      8215904436154099e-9
    ]
  },
  "EPSG:21242": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4214219100659308e-8,
      5528578457019653e-9,
      4229616425554488e-8,
      8215904436154099e-9
    ]
  },
  "EPSG:21243": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4312703487075371e-8,
      47271509897209e-7,
      43297314542190924e-9,
      8170159179736845e-9
    ]
  },
  "EPSG:21244": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      441262101118492e-7,
      4680495014463615e-9,
      4430177934994978e-8,
      7991657428574655e-9
    ]
  },
  "EPSG:21245": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4512717297748118e-8,
      4734927296500646e-9,
      4529080322409105e-8,
      8427915381378751e-9
    ]
  },
  "EPSG:21246": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4613123692109518e-8,
      4959367643280181e-9,
      46289753736459345e-9,
      8469205483594492e-9
    ]
  },
  "EPSG:21247": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      47133470970093824e-9,
      5079395914651473e-9,
      47289867276688635e-9,
      846474163241022e-8
    ]
  },
  "EPSG:21248": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      481289047615921e-7,
      4831583103464909e-9,
      4829057645300286e-8,
      8436842871460965e-9
    ]
  },
  "EPSG:21249": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      4912888469576778e-8,
      4830472039058975e-9,
      4928836128591895e-8,
      8523888748130273e-9
    ]
  },
  "EPSG:21250": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      50132162659840934e-9,
      5009376841984187e-9,
      5028819058350431e-8,
      8530584794416575e-9
    ]
  },
  "EPSG:21251": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5113532215562581e-8,
      5177212427516693e-9,
      5128978212336695e-8,
      8468089519527927e-9
    ]
  },
  "EPSG:21252": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5214028800958341e-8,
      5432935640279679e-9,
      5228710848645063e-8,
      8572993763538813e-9
    ]
  },
  "EPSG:21253": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      53145523030963354e-9,
      5693204148130244e-9,
      53304190088445574e-9,
      7894608549234845e-9
    ]
  },
  "EPSG:21254": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5415244318446188e-8,
      6024797927486217e-9,
      543045768520818e-7,
      7878992273134325e-9
    ]
  },
  "EPSG:21255": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5515327381160336e-8,
      6063753678647485e-9,
      5530776850977911e-8,
      7749608916084634e-9
    ]
  },
  "EPSG:21256": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      561527038438665e-7,
      6.0370409356589755e6,
      5630708264071347e-8,
      7.7774919363770895e6
    ]
  },
  "EPSG:21257": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5716595137484414e-8,
      6639426208279893e-9,
      5730675303059049e-8,
      7.7908760473703835e6
    ]
  },
  "EPSG:21258": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      5816881818436558e-8,
      676530807720919e-8,
      5830721990327296e-8,
      7771915273339528e-9
    ]
  },
  "EPSG:21259": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      59171639613907635e-9,
      6887866980604192e-9,
      5930424536057747e-8,
      789237763914588e-8
    ]
  },
  "EPSG:21260": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      6017202664515957e-8,
      6.9045809877241915e6,
      6030272295317183e-8,
      7953729290222999e-9
    ]
  },
  "EPSG:21261": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      6117855483618896e-8,
      7183196775453184e-9,
      6130283384191307e-8,
      7949267239181723e-9
    ]
  },
  "EPSG:21262": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      621771326351261e-7,
      7123008077305441e-9,
      6231332227638375e-8,
      7522111858954733e-9
    ]
  },
  "EPSG:21263": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      6317752703802125e-8,
      7139726743170961e-9,
      63312218165234625e-9,
      7441759602306203e-9
    ]
  },
  "EPSG:21264": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      6419395909084259e-8,
      7289930777129318e-9,
      64205717515743464e-9,
      7307569717947251e-9
    ]
  },
  "EPSG:21291": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      648370.7752523513,
      1437980303164809e-9,
      684816.1462377373,
      1.4814992597005242e6
    ]
  },
  "EPSG:21292": {
    proj4: "+proj=tmerc +lat_0=13.1763888888889 +lon_0=-59.5597222222222 +k=0.9999986 +x_0=30000 +y_0=75000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      13696.82618625694,
      55492.352533682504,
      50549.78309681262,
      98638.29012881235
    ]
  },
  "EPSG:21307": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      156950.38293881936,
      6022477332348477e-9,
      345221.89012340724,
      613387934212404e-8
    ]
  },
  "EPSG:21308": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      152443.18446187867,
      6024797927486217e-9,
      177814.1959366586,
      6105606086628469e-9
    ]
  },
  "EPSG:21309": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      225698.31626190554,
      6214198179714916e-9,
      310602.31577511714,
      7650361274830515e-9
    ]
  },
  "EPSG:21310": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      148948.6114032911,
      5858981539065238e-9,
      307686.26422165014,
      7752954839502483e-9
    ]
  },
  "EPSG:21311": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      145250.216847633,
      5679854661533623e-9,
      307219.9032729529,
      7771915273339528e-9
    ]
  },
  "EPSG:21312": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      130929.97669237555,
      4942698729697222e-9,
      309338.486086792,
      7701661522769336e-9
    ]
  },
  "EPSG:21313": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      128344.32288248313,
      4800473987136269e-9,
      310555.13749976037,
      7635853960677158e-9
    ]
  },
  "EPSG:21314": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      127429.95019583251,
      4749369244917299e-9,
      310718.45853268367,
      7629162888131198e-9
    ]
  },
  "EPSG:21315": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      125508.49486348174,
      4640506721252901e-9,
      276781.4371364661,
      8974815246047705e-9
    ]
  },
  "EPSG:21316": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      124158.4014133407,
      456275841256506e-8,
      276463.98195590114,
      8987094449568026e-9
    ]
  },
  "EPSG:21317": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      126425.47573144104,
      4692714127595092e-9,
      275568.8050646116,
      9021699847890947e-9
    ]
  },
  "EPSG:21318": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      143623.10883961635,
      5599763135752094e-9,
      275019.7698430086,
      9042909872396544e-9
    ]
  },
  "EPSG:21319": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      143645.59212051364,
      5600875454611555e-9,
      273631.49948608526,
      9096493954618169e-9
    ]
  },
  "EPSG:21320": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      143510.74147445994,
      5594201568308065e-9,
      273573.6175475109,
      9098726650822194e-9
    ]
  },
  "EPSG:21321": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      144773.90837131918,
      5656493677275069e-9,
      273978.72928935126,
      908309782064238e-8
    ]
  },
  "EPSG:21322": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      152372.15853960862,
      6021458961568735e-9,
      275482.1341693772,
      9025048785943437e-9
    ]
  },
  "EPSG:21323": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      153654.74337204802,
      608156272536201e-8,
      287478.86690257577,
      8558485301566461e-9
    ]
  },
  "EPSG:21324": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      150300.8419179258,
      5923522911225831e-9,
      297370.5912005297,
      816792774625686e-8
    ]
  },
  "EPSG:21325": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      150394.4810755471,
      5927974257349818e-9,
      279921.50611055765,
      8853143420961523e-9
    ]
  },
  "EPSG:21326": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      145819.10136495007,
      5707666381102957e-9,
      276117.5539812093,
      9000490023329448e-9
    ]
  },
  "EPSG:21327": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      144028.30730266077,
      5619785148988014e-9,
      276117.55398120906,
      9000490023329448e-9
    ]
  },
  "EPSG:21328": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141524.36710840696,
      5495213171026677e-9,
      286081.8089166147,
      8613171738246908e-9
    ]
  },
  "EPSG:21329": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      140397.97085682867,
      5438495904172489e-9,
      287222.4704616219,
      8568529607063133e-9
    ]
  },
  "EPSG:21330": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141214.29369590757,
      547964325848642e-8,
      275395.45616050466,
      9028397728964217e-9
    ]
  },
  "EPSG:21331": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      142815.89272387652,
      5559720849884502e-9,
      275453.24228896375,
      902616509973248e-8
    ]
  },
  "EPSG:21332": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141857.31318038126,
      5511895611681848e-9,
      275193.17994475743,
      9036211948574519e-9
    ]
  },
  "EPSG:21333": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141990.70099090436,
      5518568701273885e-9,
      276492.8456397621,
      8985978155462975e-9
    ]
  },
  "EPSG:21334": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      142838.25791728467,
      5560833104229839e-9,
      279921.50611055765,
      8853143420961523e-9
    ]
  },
  "EPSG:21335": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      142748.81690243311,
      5556384097613645e-9,
      281358.2860185967,
      8797333174796809e-9
    ]
  },
  "EPSG:21336": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      140794.52748210018,
      5458513227675825e-9,
      283680.6618501674,
      8706924189998943e-9
    ]
  },
  "EPSG:21337": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      140552.0579671998,
      5446280349416068e-9,
      288219.03687124053,
      8529468784662092e-9
    ]
  },
  "EPSG:21338": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141324.95912608205,
      5485203901018806e-9,
      288531.9455288811,
      8517192731296962e-9
    ]
  },
  "EPSG:21339": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      141369.24866547243,
      5487428170638809e-9,
      294955.2757667837,
      8263882923127677e-9
    ]
  },
  "EPSG:21340": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      142168.737160208,
      552746625474711e-8,
      297202.4265922962,
      8.1746220586208915e6
    ]
  },
  "EPSG:21341": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      149716.71075619155,
      589570263165355e-8,
      296164.25554487936,
      8215904436154099e-9
    ]
  },
  "EPSG:21342": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      142191.00659307494,
      5528578457019653e-9,
      296164.2555448802,
      8215904436154099e-9
    ]
  },
  "EPSG:21343": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      127034.87075371348,
      47271509897209e-7,
      297314.5421909268,
      8170159179736845e-9
    ]
  },
  "EPSG:21344": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      126210.1118492066,
      4680495014463615e-9,
      301779.3499497749,
      7991657428574655e-9
    ]
  },
  "EPSG:21345": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      127172.97748118026,
      4734927296500646e-9,
      290803.2240910501,
      8427915381378751e-9
    ]
  },
  "EPSG:21346": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      131236.92109517794,
      4959367643280181e-9,
      289753.73645934544,
      8469205483594492e-9
    ]
  },
  "EPSG:21347": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      133470.97009382758,
      5079395914651473e-9,
      289867.27668863256,
      846474163241022e-8
    ]
  },
  "EPSG:21348": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      128904.7615920978,
      4831583103464909e-9,
      290576.45300286554,
      8436842871460965e-9
    ]
  },
  "EPSG:21349": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      128884.69576778507,
      4830472039058975e-9,
      288361.28591895243,
      8523888748130273e-9
    ]
  },
  "EPSG:21350": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      132162.65984093762,
      5009376841984187e-9,
      288190.5835043129,
      8530584794416575e-9
    ]
  },
  "EPSG:21351": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      135322.15562580933,
      5177212427516693e-9,
      289782.1233669507,
      8468089519527927e-9
    ]
  },
  "EPSG:21352": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      140288.0095834161,
      5432935640279679e-9,
      287108.4864506249,
      8572993763538813e-9
    ]
  },
  "EPSG:21353": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      145523.03096335632,
      5693204148130244e-9,
      304190.0884455719,
      7894608549234845e-9
    ]
  },
  "EPSG:21354": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      152443.18446187826,
      6024797927486217e-9,
      304576.8520818009,
      7878992273134325e-9
    ]
  },
  "EPSG:21355": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      153273.81160335685,
      6063753678647485e-9,
      307768.5097791128,
      7749608916084634e-9
    ]
  },
  "EPSG:21356": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      152703.8438664974,
      6.0370409356589755e6,
      307082.6407134665,
      7.7774919363770895e6
    ]
  },
  "EPSG:21357": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      165951.37484414497,
      6639426208279893e-9,
      306753.0305904879,
      7.7908760473703835e6
    ]
  },
  "EPSG:21358": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      168818.1843655805,
      676530807720919e-8,
      307219.90327295335,
      7771915273339528e-9
    ]
  },
  "EPSG:21359": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      171639.6139076366,
      6887866980604192e-9,
      304245.3605774685,
      789237763914588e-8
    ]
  },
  "EPSG:21360": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      172026.64515957225,
      6.9045809877241915e6,
      302722.95317182847,
      7953729290222999e-9
    ]
  },
  "EPSG:21361": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      178554.8361889568,
      7183196775453184e-9,
      302833.8419130672,
      7949267239181723e-9
    ]
  },
  "EPSG:21362": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      177132.63512610045,
      7123008077305441e-9,
      313322.27638375247,
      7522111858954733e-9
    ]
  },
  "EPSG:21363": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      177527.03802125054,
      7139726743170961e-9,
      312218.1652346221,
      7441759602306203e-9
    ]
  },
  "EPSG:21364": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +units=m +no_defs +type=crs",
    projected_bounds: [
      193959.0908425933,
      7289930777129318e-9,
      205717.5157434649,
      7307569717947251e-9
    ]
  },
  "EPSG:21413": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      13374663303342246e-9,
      3.9221339709725827e6,
      13752999144337732e-9,
      4.5527956832253635e6
    ]
  },
  "EPSG:21414": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1420611188957779e-8,
      3230836746379479e-9,
      14727182824370552e-9,
      5237276980529349e-9
    ]
  },
  "EPSG:21415": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      152029987260007e-7,
      3026712777844745e-9,
      15718712448935227e-9,
      5454076569551503e-9
    ]
  },
  "EPSG:21416": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16204045915334363e-9,
      3.0699642946240343e6,
      16725049448841698e-9,
      5311790155172144e-9
    ]
  },
  "EPSG:21417": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1718824826361774e-8,
      2340455898374974e-9,
      17744732051780507e-9,
      4787202353799313e-9
    ]
  },
  "EPSG:21418": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      1818909340762585e-8,
      2.3847901990150865e6,
      1874672913207768e-8,
      4708290021631301e-9
    ]
  },
  "EPSG:21419": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      191823593668821e-7,
      2005779192783834e-9,
      19736091128420427e-9,
      5001638028420056e-9
    ]
  },
  "EPSG:21420": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2019041134730298e-8,
      2.4524029803003413e6,
      20708212407232597e-9,
      5714306627329533e-9
    ]
  },
  "EPSG:21421": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      21200428115651168e-9,
      2918037170429944e-9,
      2169877258788229e-8,
      5941235826562119e-9
    ]
  },
  "EPSG:21422": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      22247154322271165e-9,
      4532772835711776e-9,
      22702366136876598e-9,
      5855574461258299e-9
    ]
  },
  "EPSG:21423": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2326353779181119e-8,
      4991635899999732e-9,
      23482968990887847e-9,
      5363025230667173e-9
    ]
  },
  "EPSG:21453": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      374663.3033422447,
      3.9221339709725827e6,
      752999.1443377327,
      4.5527956832253635e6
    ]
  },
  "EPSG:21454": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      206111.88957778917,
      3230836746379479e-9,
      727182.8243705523,
      5237276980529349e-9
    ]
  },
  "EPSG:21455": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      202998.72600069945,
      3026712777844745e-9,
      718712.4489352279,
      5454076569551503e-9
    ]
  },
  "EPSG:21456": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      204045.915334362,
      3.0699642946240343e6,
      725049.4488416981,
      5311790155172144e-9
    ]
  },
  "EPSG:21457": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      188248.26361773786,
      2340455898374974e-9,
      744732.0517805086,
      4787202353799313e-9
    ]
  },
  "EPSG:21458": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      189093.4076258511,
      2.3847901990150865e6,
      746729.1320776793,
      4708290021631301e-9
    ]
  },
  "EPSG:21459": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      182359.36688210128,
      2005779192783834e-9,
      736091.1284204279,
      5001638028420056e-9
    ]
  },
  "EPSG:21460": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      190411.34730298247,
      2.4524029803003413e6,
      708212.4072325986,
      5714306627329533e-9
    ]
  },
  "EPSG:21461": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      200428.1156511674,
      2918037170429944e-9,
      698772.5878822905,
      5941235826562119e-9
    ]
  },
  "EPSG:21462": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      247154.32227116346,
      4532772835711776e-9,
      702366.1368765975,
      5855574461258299e-9
    ]
  },
  "EPSG:21463": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      263537.79181118915,
      4991635899999732e-9,
      482968.9908878475,
      5363025230667173e-9
    ]
  },
  "EPSG:21500": {
    proj4: "+proj=lcc +lat_0=90 +lon_0=0 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150000 +y_0=5400000 +ellps=intl +pm=brussels +units=m +no_defs +type=crs",
    projected_bounds: [
      14686.822832103295,
      22454.824826407246,
      291075.57956244703,
      246277.53832758218
    ]
  },
  "EPSG:21780": {
    proj4: "+proj=somerc +lat_0=46.9524055555556 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +pm=bern +units=m +no_defs +type=crs",
    projected_bounds: [
      -114985.98821717725,
      -124785.83137967573,
      228413.9350080595,
      99782.76700885122
    ]
  },
  "EPSG:21781": {
    proj4: "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      485014.011782823,
      75214.16862032427,
      828413.9350080597,
      299782.7670088512
    ]
  },
  "EPSG:21782": {
    proj4: "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      154245.53029330348,
      12845.73274592281,
      166439.34754566618,
      38751.47402462933
    ]
  },
  "EPSG:21818": {
    proj4: "+proj=utm +zone=18 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      238682.1301455073,
      873995.6041236323,
      824561.2439148426,
      1.5143648824068212e6
    ]
  },
  "EPSG:21896": {
    proj4: "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-77.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      775181.0057712228,
      494766.49479374336,
      1.1644770850761302e6,
      1.6209244771376909e6
    ]
  },
  "EPSG:21897": {
    proj4: "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-74.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      832143.631295867,
      213804.09150838992,
      1.1635852414666042e6,
      1.7990736981238755e6
    ]
  },
  "EPSG:21898": {
    proj4: "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-71.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      832438.2684677817,
      23541.53121997416,
      1.1631573651990457e6,
      1.8765356206271453e6
    ]
  },
  "EPSG:21899": {
    proj4: "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-68.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      832112.1673617666,
      242564.22415777144,
      1.1340025024092966e6,
      1.1893624506107373e6
    ]
  },
  "EPSG:22032": {
    proj4: "+proj=utm +zone=32 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      414959.50356935925,
      8091672763433987e-9,
      832145.6110442923,
      9332626181697793e-9
    ]
  },
  "EPSG:22033": {
    proj4: "+proj=utm +zone=33 +south +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      181297.33997685474,
      8069435010783959e-9,
      832271.355440103,
      9355869261806257e-9
    ]
  },
  "EPSG:22091": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      425932.0930973793,
      9271591823341385e-9,
      518813.14209226,
      9333537342258371e-9
    ]
  },
  "EPSG:22092": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      95822.67606036371,
      8087867956185604e-9,
      705880.75038317,
      933540093649938e-8
    ]
  },
  "EPSG:22171": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3908053332563592e6,
      4237428116296898e-9,
      1.6349765358678254e6,
      5997626733675858e-9
    ]
  },
  "EPSG:22172": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2403773933421304e-9,
      3914837040704534e-9,
      2653561991105065e-9,
      7336990621502081e-9
    ]
  },
  "EPSG:22173": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.4042753684500223e6,
      3891461817056677e-9,
      3656178392633984e-9,
      7591761856133116e-9
    ]
  },
  "EPSG:22174": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4403797781713411e-9,
      391372395198254e-8,
      4654916903295546e-9,
      7568513113456698e-9
    ]
  },
  "EPSG:22175": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      536930152591688e-8,
      5675715396994588e-9,
      5653373549550106e-9,
      7415655411882124e-9
    ]
  },
  "EPSG:22176": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      636931048354909e-8,
      5727909302118985e-9,
      6652642960721401e-9,
      7252789935004793e-9
    ]
  },
  "EPSG:22177": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7352597865373549e-9,
      6890424500988269e-9,
      753519125497132e-8,
      7.1815847927097995e6
    ]
  },
  "EPSG:22181": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3908053332574747e6,
      4237428116255282e-9,
      1.6349765358670535e6,
      5997626733650266e-9
    ]
  },
  "EPSG:22182": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2403773933422364e-9,
      3.9148370406625527e6,
      2.6535619911046457e6,
      733699062150393e-8
    ]
  },
  "EPSG:22183": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3404275368451082e-9,
      3.8914618170146984e6,
      3656178392633631e-9,
      7591761856141459e-9
    ]
  },
  "EPSG:22184": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4403797781714471e-9,
      3913723951940559e-9,
      4654916903295189e-9,
      7568513113464434e-9
    ]
  },
  "EPSG:22185": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      5369301525917733e-9,
      5675715396964289e-9,
      5653373549549709e-9,
      7415655411885936e-9
    ]
  },
  "EPSG:22186": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      6.3693104835499255e6,
      5727909302089395e-9,
      6652642960720958e-9,
      7252789935004573e-9
    ]
  },
  "EPSG:22187": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      7.3525978653740855e6,
      6890424500979647e-9,
      7535191254971214e-9,
      7181584792707844e-9
    ]
  },
  "EPSG:22191": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.3908000728760678e6,
      4.2376308125209445e6,
      1.6349825140985348e6,
      5997884861907678e-9
    ]
  },
  "EPSG:22192": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2397970995599913e-9,
      4.1899177430915604e6,
      2.6535683966345578e6,
      733727776145953e-8
    ]
  },
  "EPSG:22193": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3903487650584877e6,
      4565908042031497e-9,
      3.6561848435703353e6,
      7592053411424655e-9
    ]
  },
  "EPSG:22194": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4377960066871074e-9,
      5222836512382368e-9,
      4655956302436091e-9,
      7568794116364041e-9
    ]
  },
  "EPSG:22195": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      5369295646293728e-9,
      5675964922734801e-9,
      5653379927373861e-9,
      7415943948854414e-9
    ]
  },
  "EPSG:22196": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      6369304619219026e-9,
      5728160268604565e-9,
      6652649349545521e-9,
      7253075545679096e-9
    ]
  },
  "EPSG:22197": {
    proj4: "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      7352591600763706e-9,
      6890703107433792e-9,
      7535192732172857e-9,
      7181869100849509e-9
    ]
  },
  "EPSG:22234": {
    proj4: "+proj=utm +zone=34 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      399680.53468178364,
      7026696037027197e-9,
      817731.3004981086,
      8008523074557677e-9
    ]
  },
  "EPSG:22235": {
    proj4: "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      199267.2492190483,
      7138834461158795e-9,
      752328.7820206215,
      8032724374322941e-9
    ]
  },
  "EPSG:22275": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      66568.51203206946,
      2.5610836064961194e6,
      41106.33731566659,
      2508944861227338e-9
    ]
  },
  "EPSG:22277": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      51343.26766244167,
      3.6636976581423897e6,
      -98340.33707817465,
      3.1019221534922607e6
    ]
  },
  "EPSG:22279": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      92340.39730038814,
      3861462025189832e-9,
      -98020.33688681241,
      3140711255922951e-9
    ]
  },
  "EPSG:22281": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      92340.39730038783,
      3861462025189832e-9,
      -102162.98987912339,
      2.7396204397441475e6
    ]
  },
  "EPSG:22283": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      92107.30686128397,
      3.7926735135656106e6,
      -101750.15708535822,
      2795009040475373e-9
    ]
  },
  "EPSG:22285": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      92107.30686128368,
      3.7926735135656106e6,
      -102203.84659442163,
      2.7340817808493776e6
    ]
  },
  "EPSG:22287": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      92573.41407010092,
      3.7449757520282427e6,
      -102589.16150311008,
      2.5358143084432995e6
    ]
  },
  "EPSG:22289": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      94360.98163771143,
      3656253388252535e-9,
      -103174.1598829519,
      2448328221461562e-9
    ]
  },
  "EPSG:22291": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      96080.09201033962,
      3.4732801498215715e6,
      -105170.82478845354,
      2.4583083147664834e6
    ]
  },
  "EPSG:22293": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs",
    projected_bounds: [
      102376.06075637658,
      3.2028201220268435e6,
      4971.636953794026,
      2.9652312217574385e6
    ]
  },
  "EPSG:22332": {
    proj4: "+proj=utm +zone=32 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      389104.88154495554,
      3.6760316166904843e6,
      907839.8147335335,
      4261349412055012e-9
    ]
  },
  "EPSG:22391": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=9.9 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      342337.0527401301,
      151661.13075492618,
      630148.7073050648,
      456294.2842537255
    ]
  },
  "EPSG:22392": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=9.9 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      267778.46762494533,
      -37746.17947209481,
      654896.8137459323,
      452059.7202048473
    ]
  },
  "EPSG:22521": {
    proj4: "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      390316.82621864433,
      6468900145659665e-9,
      817736.9823694777,
      8008325673951928e-9
    ]
  },
  "EPSG:22522": {
    proj4: "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222183.35609136242,
      6258132762697294e-9,
      822663.9686874538,
      8339466610008035e-9
    ]
  },
  "EPSG:22523": {
    proj4: "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      197884.3669798266,
      7199521564006133e-9,
      822663.9686874531,
      8339466610008035e-9
    ]
  },
  "EPSG:22524": {
    proj4: "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      192353.67058017355,
      7457731223299272e-9,
      833628.18317072,
      9703365394894399e-9
    ]
  },
  "EPSG:22525": {
    proj4: "+proj=utm +zone=25 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      171159.4260809964,
      888200773127092e-8,
      307073.49650004064,
      9448180162578e-6
    ]
  },
  "EPSG:22770": {
    proj4: "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      82372.78104813315,
      42994.639005959005,
      746108.4443894743,
      605160.8271455863
    ]
  },
  "EPSG:22780": {
    proj4: "+proj=sterea +lat_0=34.2 +lon_0=39.15 +k=0.9995341 +x_0=0 +y_0=0 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -387008.4179837848,
      -201914.32820011742,
      286458.550414879,
      348590.1402446541
    ]
  },
  "EPSG:22991": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=35 +k=1 +x_0=300000 +y_0=1100000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      93399.84512970818,
      211705.18222538172,
      485548.36427498254,
      1252420211069043e-9
    ]
  },
  "EPSG:22992": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      408428.8037700703,
      -76079.21600083623,
      917799.9176394044,
      1.2383991796271505e6
    ]
  },
  "EPSG:22993": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=200000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      474108.68861727306,
      415.8533287560567,
      889658.9479832354,
      387996.9562110186
    ]
  },
  "EPSG:22994": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=1200000 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      492395.64151418686,
      313934.3274091745,
      897383.9971420368,
      1.0010182078272348e6
    ]
  },
  "EPSG:23028": {
    proj4: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      418625.887066414,
      5364784639016283e-9,
      684316.3177119698,
      627369012584094e-8
    ]
  },
  "EPSG:23029": {
    proj4: "+proj=utm +zone=29 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      230011.73072823486,
      4.0026016016707164e6,
      654983.6066567954,
      6923620386328302e-9
    ]
  },
  "EPSG:23030": {
    proj4: "+proj=utm +zone=30 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      227059.8255974417,
      3.9060657959715487e6,
      555498.1776284517,
      8937982150594871e-9
    ]
  },
  "EPSG:23031": {
    proj4: "+proj=utm +zone=31 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      238584.91654546012,
      4272290766304639e-9,
      544136.1315849652,
      9156488891291458e-9
    ]
  },
  "EPSG:23032": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      230494.28934766626,
      4.0470173039590805e6,
      533078.2826810381,
      9366084803619083e-9
    ]
  },
  "EPSG:23033": {
    proj4: "+proj=utm +zone=33 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      224499.77801001846,
      3820634535695171e-9,
      532554.9297160418,
      9376119292897973e-9
    ]
  },
  "EPSG:23034": {
    proj4: "+proj=utm +zone=34 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      221570.69807890075,
      372078979161509e-8,
      531963.0934233683,
      9389504191227075e-9
    ]
  },
  "EPSG:23035": {
    proj4: "+proj=utm +zone=35 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      198934.65482236422,
      2.8470288775670063e6,
      530854.0667707842,
      9410688058060253e-9
    ]
  },
  "EPSG:23036": {
    proj4: "+proj=utm +zone=36 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      208253.30914557917,
      3.2328099008197184e6,
      530926.2051783453,
      9407337846979514e-9
    ]
  },
  "EPSG:23037": {
    proj4: "+proj=utm +zone=37 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      208224.97347332252,
      3231701130342558e-9,
      563478.0769948189,
      8779676390273018e-9
    ]
  },
  "EPSG:23038": {
    proj4: "+proj=utm +zone=38 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      232921.03034534823,
      4095818324122276e-9,
      485832.5288992191,
      4.6054612459209515e6
    ]
  },
  "EPSG:23090": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=0 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      145950.99929418572,
      5665421708599752e-9,
      677858.1276405398,
      6882350260006084e-9
    ]
  },
  "EPSG:23095": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      328366.5766410602,
      5702880089229653e-9,
      588461.2230755405,
      618151769671373e-8
    ]
  },
  "EPSG:23239": {
    proj4: "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      605612.0033490162,
      1834299214095929e-9,
      814583.8794618597,
      2.1775510999585465e6
    ]
  },
  "EPSG:23240": {
    proj4: "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      180355.25430918485,
      1869655601100105e-9,
      790266.7942752414,
      2925242047777771e-9
    ]
  },
  "EPSG:23700": {
    proj4: "+proj=somerc +lat_0=47.1443937222222 +lon_0=19.0485717777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +units=m +no_defs +type=crs",
    projected_bounds: [
      421306.5407681541,
      48182.9138340255,
      934135.5232563298,
      366630.91446790844
    ]
  },
  "EPSG:23830": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=94.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      273392.8853604273,
      1.7819568830573033e6,
      366081.7157180974,
      2.1603125020152973e6
    ]
  },
  "EPSG:23831": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=97.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      33101.05185265673,
      1.2998108900972675e6,
      366239.79946304805,
      2099476139958499e-9
    ]
  },
  "EPSG:23832": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=100.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      33340.276527502836,
      1.1051483194953643e6,
      366633.98034776957,
      1910336456604565e-9
    ]
  },
  "EPSG:23833": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=103.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      33924.31951736854,
      837475.2459679312,
      366910.41338563786,
      1.6858108065222423e6
    ]
  },
  "EPSG:23834": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34549.77124308798,
      638365.8285689178,
      366554.98065327737,
      1.9545789316636792e6
    ]
  },
  "EPSG:23835": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=109.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34760.70951581528,
      580842.5618876795,
      366525.4244786084,
      1.9700638934549107e6
    ]
  },
  "EPSG:23836": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34914.67212789279,
      541017.948879206,
      366917.8506351726,
      1.6758566070467052e6
    ]
  },
  "EPSG:23837": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      35130.035086413816,
      487917.37499973376,
      367609.5543854978,
      1.9833389820760365e6
    ]
  },
  "EPSG:23838": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=118.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      35615.64627926907,
      377286.9068016093,
      366501.50852518925,
      1.9822306857526589e6
    ]
  },
  "EPSG:23839": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      36056.53023966323,
      285458.8854034436,
      366932.2073758438,
      1.6548422120101764e6
    ]
  },
  "EPSG:23840": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=124.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      36023.51058072643,
      292097.20763277845,
      366609.19064498344,
      1924715218147085e-9
    ]
  },
  "EPSG:23841": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=127.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34764.898699091544,
      579736.3318063752,
      366449.5314981133,
      200767045036369e-8
    ]
  },
  "EPSG:23842": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=130.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34802.826540133625,
      569780.2377328321,
      366981.48977976874,
      1511060137524641e-9
    ]
  },
  "EPSG:23843": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=133.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34363.401292602706,
      692569.2436961235,
      366979.61696423683,
      1.4679255989218256e6
    ]
  },
  "EPSG:23844": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=136.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      34836.88041645268,
      560930.3408156397,
      366973.24034259963,
      1435851182476353e-9
    ]
  },
  "EPSG:23845": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=139.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      35148.50158179164,
      483492.2691192074,
      368038.73000257375,
      1.3352028446630884e6
    ]
  },
  "EPSG:23846": {
    proj4: "+proj=utm +zone=46 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      740175.4267272606,
      282055.93020935333,
      832177.1364198453,
      660795.6481762521
    ]
  },
  "EPSG:23847": {
    proj4: "+proj=utm +zone=47 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23869544483,
      0,
      832493.7525715255,
      599915.561069319
    ]
  },
  "EPSG:23848": {
    proj4: "+proj=utm +zone=48 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23869544058,
      0,
      833125.0132448786,
      454913.33482485084
    ]
  },
  "EPSG:23849": {
    proj4: "+proj=utm +zone=49 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23869544768,
      0,
      833065.8164444773,
      470409.5721340185
    ]
  },
  "EPSG:23850": {
    proj4: "+proj=utm +zone=50 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23869544483,
      0,
      833013.5010904163,
      483692.0936222578
    ]
  },
  "EPSG:23851": {
    proj4: "+proj=utm +zone=51 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23869544483,
      0,
      800995.7395800801,
      424920.1726495848
    ]
  },
  "EPSG:23852": {
    proj4: "+proj=utm +zone=52 +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      227291.67807816714,
      0,
      721886.520262118,
      507655.51323898986
    ]
  },
  "EPSG:23866": {
    proj4: "+proj=utm +zone=46 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      389832.2676831861,
      0,
      830911.1888054286,
      862257.1887873124
    ]
  },
  "EPSG:23867": {
    proj4: "+proj=utm +zone=47 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      831142.578029119,
      829048.0901737375
    ]
  },
  "EPSG:23868": {
    proj4: "+proj=utm +zone=48 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053626,
      0,
      831543.3153573318,
      768165.583029314
    ]
  },
  "EPSG:23869": {
    proj4: "+proj=utm +zone=49 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      831232.6035901699,
      815764.5430356432
    ]
  },
  "EPSG:23870": {
    proj4: "+proj=utm +zone=50 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      833012.2999687458,
      483690.46048164397
    ]
  },
  "EPSG:23871": {
    proj4: "+proj=utm +zone=51 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      832459.4947813818,
      606554.9365959951
    ]
  },
  "EPSG:23872": {
    proj4: "+proj=utm +zone=52 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      831722.1709201407,
      739385.1214865021
    ]
  },
  "EPSG:23877": {
    proj4: "+proj=utm +zone=47 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      169987.60457850288,
      9019294169273801e-9,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:23878": {
    proj4: "+proj=utm +zone=48 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171833.30950013385,
      8812273688969577e-9,
      835092.8490763598,
      1e7
    ]
  },
  "EPSG:23879": {
    proj4: "+proj=utm +zone=49 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      173370.10090469214,
      8663916571550943e-9,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:23880": {
    proj4: "+proj=utm +zone=50 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      174619.8299262626,
      8554302872872595e-9,
      835092.849076364,
      1e7
    ]
  },
  "EPSG:23881": {
    proj4: "+proj=utm +zone=51 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      175825.93248612247,
      8455756095262446e-9,
      835092.8439973067,
      10001106837769464e-9
    ]
  },
  "EPSG:23882": {
    proj4: "+proj=utm +zone=52 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      170532.23225242615,
      8953979307493195e-9,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:23883": {
    proj4: "+proj=utm +zone=53 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171131.89404413168,
      8886448714191712e-9,
      835092.8490763612,
      1e7
    ]
  },
  "EPSG:23884": {
    proj4: "+proj=utm +zone=54 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      171952.74030764907,
      8800095482658522e-9,
      551187.0365818501,
      1e7
    ]
  },
  "EPSG:23887": {
    proj4: "+proj=utm +zone=47 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      415591.2643805201,
      9605366419089401e-9,
      833979.7613045565,
      1e7
    ]
  },
  "EPSG:23888": {
    proj4: "+proj=utm +zone=48 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      169087.61717576493,
      9137739898629991e-9,
      833979.7613045523,
      1e7
    ]
  },
  "EPSG:23889": {
    proj4: "+proj=utm +zone=49 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      169818.43817763124,
      9040324204925708e-9,
      833979.7613045608,
      1e7
    ]
  },
  "EPSG:23890": {
    proj4: "+proj=utm +zone=50 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      171222.3257087143,
      8876481237440012e-9,
      833979.7613045552,
      1e7
    ]
  },
  "EPSG:23891": {
    proj4: "+proj=utm +zone=51 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      172105.30075529614,
      8784591748365724e-9,
      833979.761304558,
      1e7
    ]
  },
  "EPSG:23892": {
    proj4: "+proj=utm +zone=52 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      169594.4353079723,
      9069106437862951e-9,
      833979.7613045608,
      1e7
    ]
  },
  "EPSG:23893": {
    proj4: "+proj=utm +zone=53 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      169662.63802925468,
      9060250395872964e-9,
      833975.5040683748,
      9967901890414238e-9
    ]
  },
  "EPSG:23894": {
    proj4: "+proj=utm +zone=54 +south +a=6378160 +rf=298.247 +units=m +no_defs +type=crs",
    projected_bounds: [
      170286.7467016818,
      8982758880789874e-9,
      501112.3799199069,
      9835309300107237e-9
    ]
  },
  "EPSG:23946": {
    proj4: "+proj=utm +zone=46 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      414272.85109307204,
      1.7313499169322394e6,
      798305.6614117646,
      3005265723362811e-9
    ]
  },
  "EPSG:23947": {
    proj4: "+proj=utm +zone=47 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      166560.91481773945,
      623115.3479280383,
      794466.9970590085,
      3161562439513825e-9
    ]
  },
  "EPSG:23948": {
    proj4: "+proj=utm +zone=48 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      167899.28718919138,
      666275.7396255973,
      567573.879371353,
      2.0388209791079452e6
    ]
  },
  "EPSG:24047": {
    proj4: "+proj=utm +zone=47 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      316168.1425845681,
      622516.8134730869,
      814003.4412581372,
      2.2650867127262466e6
    ]
  },
  "EPSG:24048": {
    proj4: "+proj=utm +zone=48 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      167899.28718919138,
      666275.7396255973,
      567573.879371353,
      2.0388209791079452e6
    ]
  },
  "EPSG:24100": {
    proj4: "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=167638.49597 +y_0=121918.90616 +a=6378249.14480801 +b=6356514.96620413 +to_meter=0.3047972654 +no_defs +type=crs",
    projected_bounds: [
      52117.087286878384,
      271205.54433158087,
      837454.9686609622,
      611251.471910568
    ]
  },
  "EPSG:24200": {
    proj4: "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=250000 +y_0=150000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      98247.9094079333,
      110742.86239381517,
      337614.7463636486,
      214390.359321606
    ]
  },
  "EPSG:24305": {
    proj4: "+proj=utm +zone=45 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      604539.5311056708,
      2387590281160865e-9,
      798627.6751158563,
      2.9498233472147533e6
    ]
  },
  "EPSG:24306": {
    proj4: "+proj=utm +zone=46 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      187162.41463443573,
      2.2717138619129723e6,
      466782.92030822084,
      2796867437331925e-9
    ]
  },
  "EPSG:24311": {
    proj4: "+proj=utm +zone=41 +a=6377301.243 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      284015.13729396055,
      2764217973221923e-9,
      790712.9019626899,
      3.3079167257305104e6
    ]
  },
  "EPSG:24312": {
    proj4: "+proj=utm +zone=42 +a=6377301.243 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      193969.94045700913,
      2617379145669911e-9,
      769351.502916645,
      4049937240382354e-9
    ]
  },
  "EPSG:24313": {
    proj4: "+proj=utm +zone=43 +a=6377301.243 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      205571.74830464902,
      3.1238596037251754e6,
      751563.9024581293,
      4106035598727e-6
    ]
  },
  "EPSG:24342": {
    proj4: "+proj=utm +zone=42 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      409376.49757486605,
      2282370736680113e-9,
      795382.5256829393,
      3.1249914793954715e6
    ]
  },
  "EPSG:24343": {
    proj4: "+proj=utm +zone=43 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      169315.9616899283,
      887651.0733561005,
      772955.0942234672,
      3.9334371114283903e6
    ]
  },
  "EPSG:24344": {
    proj4: "+proj=utm +zone=44 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      169538.14491658635,
      917537.51559046,
      772988.9754418177,
      3932327669252035e-9
    ]
  },
  "EPSG:24345": {
    proj4: "+proj=utm +zone=45 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      182660.9000947083,
      2.0125387394925905e6,
      795602.7429855771,
      3.1161232414057227e6
    ]
  },
  "EPSG:24346": {
    proj4: "+proj=utm +zone=46 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      190146.54546900454,
      2.4290282267554123e6,
      792010.435073249,
      3.2580240336059346e6
    ]
  },
  "EPSG:24347": {
    proj4: "+proj=utm +zone=47 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      202578.93556920555,
      3000819116713131e-9,
      346820.51851769845,
      3260832760881394e-9
    ]
  },
  "EPSG:24370": {
    proj4: "+proj=lcc +lat_1=39.5 +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.1946281 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      2.6708427650982733e6,
      2.1201829573251326e6,
      3229613159734446e-9,
      233916575595671e-8
    ]
  },
  "EPSG:24371": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      2.2312406875156546e6,
      480352.61375436693,
      4348355916109614e-9,
      1.4608821036699412e6
    ]
  },
  "EPSG:24372": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      1587687026177202e-9,
      461533.0379998026,
      3860383510514084e-9,
      1.2696692069565994e6
    ]
  },
  "EPSG:24373": {
    proj4: "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      1.8396587128468468e6,
      548632.2835902119,
      3812105860330196e-9,
      1.2595800435092966e6
    ]
  },
  "EPSG:24374": {
    proj4: "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      2.2687175024585864e6,
      526846.7844253026,
      3.0470467191297947e6,
      1363916762223095e-9
    ]
  },
  "EPSG:24375": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.5349870207381356e6,
      308961.3552302391,
      3.0086729844615664e6,
      987923.2179918708
    ]
  },
  "EPSG:24376": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      2040243807226927e-9,
      439233.85362897586,
      3.6329074907563366e6,
      1.2979049705514554e6
    ]
  },
  "EPSG:24377": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.4795174831600122e6,
      713286.0264320491,
      2.5377990310454485e6,
      1.1385113473035814e6
    ]
  },
  "EPSG:24378": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.9747135961704226e6,
      418242.47319019533,
      3.9772625043172995e6,
      1.3270238933810312e6
    ]
  },
  "EPSG:24379": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.1316348780691912e6,
      374404.90179314034,
      3.5299288914174205e6,
      1.1609836183304253e6
    ]
  },
  "EPSG:24380": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.9099630071781343e6,
      386177.82231336716,
      3462864375601599e-9,
      1.3190945981722383e6
    ]
  },
  "EPSG:24381": {
    proj4: "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      1682181167568024e-9,
      501668.53717810527,
      3.4857838805069164e6,
      1.1517581024081802e6
    ]
  },
  "EPSG:24382": {
    proj4: "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs +type=crs",
    projected_bounds: [
      2088764370408999e-9,
      422329.8947871596,
      4183998082219837e-9,
      1.4708595578893092e6
    ]
  },
  "EPSG:24383": {
    proj4: "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0745118811901305e6,
      481747.9094205388,
      2786214949401035e-9,
      1.2471634414922763e6
    ]
  },
  "EPSG:24500": {
    proj4: "+proj=cass +lat_0=1.28764666666667 +lon_0=103.853002222222 +x_0=30000 +y_0=30000 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      732.20520298872,
      12570.865843507043,
      54145.031351887395,
      50163.391369073746
    ]
  },
  "EPSG:24547": {
    proj4: "+proj=utm +zone=47 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      565592.7412316592,
      253109.99092132942,
      832758.143894485,
      743764.5127936903
    ]
  },
  "EPSG:24548": {
    proj4: "+proj=utm +zone=48 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      166139.173105867,
      133916.39894496865,
      590395.8157072355,
      863316.9940461174
    ]
  },
  "EPSG:24600": {
    proj4: "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6509011483949963e6,
      727379.497747391,
      1835305264793072e-9,
      904723.1377442369
    ]
  },
  "EPSG:24718": {
    proj4: "+proj=utm +zone=18 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      678953.4034012235,
      776277.6525797434,
      828270.4617708044,
      1.2862872268105748e6
    ]
  },
  "EPSG:24719": {
    proj4: "+proj=utm +zone=19 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166035.2714848129,
      80799.32543884787,
      826422.9466967549,
      1.3560284222529791e6
    ]
  },
  "EPSG:24720": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166029.02998327336,
      70837.75827790194,
      849489.4961715019,
      1.2433271274150275e6
    ]
  },
  "EPSG:24817": {
    proj4: "+proj=utm +zone=17 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      591252.1967138048,
      0,
      833885.2779214613,
      160491.9979757482
    ]
  },
  "EPSG:24818": {
    proj4: "+proj=utm +zone=18 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166008.29557854048,
      0,
      828270.4617708044,
      1.2862872268105748e6
    ]
  },
  "EPSG:24819": {
    proj4: "+proj=utm +zone=19 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166035.2714848129,
      80799.32543884787,
      825884.3771663646,
      1.4036387637229774e6
    ]
  },
  "EPSG:24820": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166029.02998327336,
      70837.75827790194,
      828720.2207267606,
      1.2431077118288355e6
    ]
  },
  "EPSG:24821": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166078.77872393077,
      130607.21220409131,
      558323.1632058125,
      948469.5234915094
    ]
  },
  "EPSG:24877": {
    proj4: "+proj=utm +zone=17 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      455138.42015850387,
      8835945354477791e-9,
      833991.704421461,
      1e7
    ]
  },
  "EPSG:24878": {
    proj4: "+proj=utm +zone=18 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      257449.87820036593,
      5179198083111802e-9,
      835106.0404733343,
      1e7
    ]
  },
  "EPSG:24879": {
    proj4: "+proj=utm +zone=19 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      257449.8782003649,
      5179198083111802e-9,
      833759.9034747044,
      9763135511963485e-9
    ]
  },
  "EPSG:24880": {
    proj4: "+proj=utm +zone=20 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      192150.16884018946,
      7467703849884671e-9,
      829268.8725572133,
      8929612105787644e-9
    ]
  },
  "EPSG:24881": {
    proj4: "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      186399.74687544745,
      7766845559719665e-9,
      444436.81437241123,
      8201106135966736e-9
    ]
  },
  "EPSG:24882": {
    proj4: "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      428791.60964900453,
      988393477077829e-8,
      832405.4190838621,
      10619844614505395e-9
    ]
  },
  "EPSG:24891": {
    proj4: "+proj=tmerc +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      121767.38783985999,
      1170187509687997e-9,
      388687.9905913692,
      1.7163846339885332e6
    ]
  },
  "EPSG:24892": {
    proj4: "+proj=tmerc +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      399901.23228230287,
      255932.9447568818,
      1.0539014249810695e6,
      2.0865191901744073e6
    ]
  },
  "EPSG:24893": {
    proj4: "+proj=tmerc +lat_0=-9.5 +lon_0=-70.5 +k=0.99952992 +x_0=1324000 +y_0=1040084.558 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0598714931410842e6,
      55118.5896470584,
      1.5275205999044832e6,
      1.8535115095115947e6
    ]
  },
  "EPSG:25000": {
    proj4: "+proj=tmerc +lat_0=4.66666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.51 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      -36221.065873845015,
      -360912.14493059507,
      613002.841996145,
      719670.9309041959
    ]
  },
  "EPSG:25231": {
    proj4: "+proj=utm +zone=31 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      149749.84553290234,
      322104.74450202845,
      436666.4086456199,
      1231410220692839e-9
    ]
  },
  "EPSG:25391": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      487866.4250704751,
      856907.4730198451,
      609860.7648309832,
      1030681949046517e-9
    ]
  },
  "EPSG:25392": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      389987.0620890332,
      975379.0952018821,
      616705.0088257757,
      1.2806986337621089e6
    ]
  },
  "EPSG:25393": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      355822.82985133724,
      551859.223579065,
      627059.8954149673,
      2.1516915261183814e6
    ]
  },
  "EPSG:25394": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      360586.6230984691,
      702265.3602971913,
      636168.2528112831,
      2.0554407688485058e6
    ]
  },
  "EPSG:25395": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      359264.8524909322,
      608257.6936483578,
      678155.1153525303,
      1.5653941357821876e6
    ]
  },
  "EPSG:25828": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      399535.6294497436,
      3865832600599011e-9,
      601322.8726211493,
      8040550060403315e-9
    ]
  },
  "EPSG:25829": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      225902.0805645627,
      3.8671713718875768e6,
      591534.7303909996,
      8228847090053825e-9
    ]
  },
  "EPSG:25830": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227071.85729005415,
      3.9060037759658666e6,
      555495.2251114178,
      8937716116827e-6
    ]
  },
  "EPSG:25831": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      233037.87982875673,
      4099080693337798e-9,
      544133.7771850436,
      9156211355012117e-9
    ]
  },
  "EPSG:25832": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      239323.4449753319,
      4294418796805556e-9,
      533076.5145945294,
      9365796154998856e-9
    ]
  },
  "EPSG:25833": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      269387.69437979034,
      5142865884479615e-9,
      532553.189460577,
      9375830110660298e-9
    ]
  },
  "EPSG:25834": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      326880.8907341509,
      6526115873062309e-9,
      531961.3846213385,
      9389214296997491e-9
    ]
  },
  "EPSG:25835": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      330890.1192646407,
      6615141393451322e-9,
      530852.416986177,
      9410397036520464e-9
    ]
  },
  "EPSG:25836": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      341519.301819355,
      6847757828023774e-9,
      530924.5515790338,
      9407047003761513e-9
    ]
  },
  "EPSG:25837": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      402080.1501976735,
      8101816317119474e-9,
      478833.7855118617,
      8777967971489828e-9
    ]
  },
  "EPSG:25884": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      172829.27375109983,
      5982782301704232e-9,
      736389.3847068548,
      6658991200170544e-9
    ]
  },
  "EPSG:25932": {
    proj4: "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      669338.3551857569,
      9332128431802575e-9,
      873779.0873536201,
      9440834192817446e-9
    ]
  },
  "EPSG:26191": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      77258.7817229976,
      108347.81313878018,
      896150.5342996041,
      604512.3049631496
    ]
  },
  "EPSG:26192": {
    proj4: "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.999615596 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -273181.22739656095,
      100176.74454774617,
      671954.2608965117,
      501953.5311350896
    ]
  },
  "EPSG:26194": {
    proj4: "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      183609.21103979647,
      238670.6904359246,
      878395.6827788167,
      577928.8512770996
    ]
  },
  "EPSG:26195": {
    proj4: "+proj=lcc +lat_1=22.5 +lat_0=22.5 +lon_0=-5.4 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      276069.5909070219,
      249952.2991565121,
      830178.8817567454,
      615166.0567733737
    ]
  },
  "EPSG:26237": {
    proj4: "+proj=utm +zone=37 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      221643.70345055492,
      1.3675623946279553e6,
      956306.3626201733,
      2.0063945769338594e6
    ]
  },
  "EPSG:26331": {
    proj4: "+proj=utm +zone=31 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      462186.7208156057,
      212202.67322262283,
      832077.9725558811,
      679548.8175940844
    ]
  },
  "EPSG:26332": {
    proj4: "+proj=utm +zone=32 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      166360.30095329473,
      288856.8631087066,
      368952.8913483922,
      406805.35752907087
    ]
  },
  "EPSG:26391": {
    proj4: "+proj=tmerc +lat_0=4 +lon_0=4.5 +k=0.99975 +x_0=230738.26 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      29651.646804447897,
      -47334.955088651695,
      446888.88632212323,
      1.0955139804078294e6
    ]
  },
  "EPSG:26392": {
    proj4: "+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      448350.6658225409,
      -47291.22029191678,
      888126.4495995322,
      1.0545786062884806e6
    ]
  },
  "EPSG:26393": {
    proj4: "+proj=tmerc +lat_0=4 +lon_0=12.5 +k=0.99975 +x_0=1110369.7 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      888022.4767425242,
      269063.4820959244,
      1342916685169254e-9,
      1.0757344955986713e6
    ]
  },
  "EPSG:26632": {
    proj4: "+proj=utm +zone=32 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      527819.3189965227,
      0,
      833712.046781612,
      256761.3872981612
    ]
  },
  "EPSG:26692": {
    proj4: "+proj=utm +zone=32 +south +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      282086.57799788634,
      9295543263771815e-9,
      834825.4464812588,
      1025676375336106e-8
    ]
  },
  "EPSG:26701": {
    proj4: "+proj=utm +zone=1 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      275698.1584961375,
      5.3071015753169935e6,
      651332.7596281318,
      7012338293105879e-9
    ]
  },
  "EPSG:26702": {
    proj4: "+proj=utm +zone=2 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      279088.486534701,
      5393785824272507e-9,
      597914.1953175036,
      8.1083554643998565e6
    ]
  },
  "EPSG:26703": {
    proj4: "+proj=utm +zone=3 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      282874.26393714803,
      548937085983858e-8,
      590941.5970310683,
      8246534709957291e-9
    ]
  },
  "EPSG:26704": {
    proj4: "+proj=utm +zone=4 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      289413.56565478933,
      5.6516672502334975e6,
      588569.9584890173,
      8293340034384552e-9
    ]
  },
  "EPSG:26705": {
    proj4: "+proj=utm +zone=5 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      294753.5481621026,
      5781748440847142e-9,
      588569.9584890173,
      8293340034384552e-9
    ]
  },
  "EPSG:26706": {
    proj4: "+proj=utm +zone=6 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      303608.00445474335,
      5993032146673736e-9,
      591843.7826914727,
      8228704459304657e-9
    ]
  },
  "EPSG:26707": {
    proj4: "+proj=utm +zone=7 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      300881.53173345403,
      5928529708135334e-9,
      594693.0841331551,
      8.1685014115487235e6
    ]
  },
  "EPSG:26708": {
    proj4: "+proj=utm +zone=8 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      296864.26716060133,
      5829589296127446e-9,
      597750.1326293773,
      8107192783613835e-9
    ]
  },
  "EPSG:26709": {
    proj4: "+proj=utm +zone=9 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      281475.8255190551,
      5451597215274926e-9,
      603363.2585517059,
      7994645982789633e-9
    ]
  },
  "EPSG:26710": {
    proj4: "+proj=utm +zone=10 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      224209.61624812946,
      3.8103942949312027e6,
      574646.1939005502,
      8562969073542114e-9
    ]
  },
  "EPSG:26711": {
    proj4: "+proj=utm +zone=11 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      202169.86905496224,
      2982022817397918e-9,
      568925.9602897407,
      8674419813797636e-9
    ]
  },
  "EPSG:26712": {
    proj4: "+proj=utm +zone=12 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      183556.7716337723,
      2065663167593145e-9,
      565018.5185197144,
      8750208665555205e-9
    ]
  },
  "EPSG:26713": {
    proj4: "+proj=utm +zone=13 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      182089.47398641065,
      1.9770520486939799e6,
      561503.2405187573,
      8818198828446243e-9
    ]
  },
  "EPSG:26714": {
    proj4: "+proj=utm +zone=14 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      178285.39293018723,
      1.7256498588182114e6,
      553890.9296671426,
      8965338629858732e-9
    ]
  },
  "EPSG:26715": {
    proj4: "+proj=utm +zone=15 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      175379.07872321468,
      1.5087176467588053e6,
      546827.9623456559,
      9101340067389967e-9
    ]
  },
  "EPSG:26716": {
    proj4: "+proj=utm +zone=16 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      169257.5674931967,
      1025902471934488e-9,
      543453.6572195034,
      916599966874399e-8
    ]
  },
  "EPSG:26717": {
    proj4: "+proj=utm +zone=17 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      169222.05458850384,
      883089.8647631259,
      540596.9699989137,
      9220628653930226e-9
    ]
  },
  "EPSG:26718": {
    proj4: "+proj=utm +zone=18 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      183787.3861016936,
      2.0844962875718584e6,
      539826.7532984961,
      9235125475048272e-9
    ]
  },
  "EPSG:26719": {
    proj4: "+proj=utm +zone=19 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      221598.78150059743,
      3.7227459231479545e6,
      539753.0534670209,
      923624582197262e-8
    ]
  },
  "EPSG:26720": {
    proj4: "+proj=utm +zone=20 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      237325.83231236425,
      4233165000357214e-9,
      540910.933633835,
      921395073850588e-8
    ]
  },
  "EPSG:26721": {
    proj4: "+proj=utm +zone=21 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      245967.67858652544,
      4.4951430094654765e6,
      620245.4711339441,
      7649281700216127e-9
    ]
  },
  "EPSG:26722": {
    proj4: "+proj=utm +zone=22 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      242033.5315559283,
      4376353432212344e-9,
      678927.6338688468,
      6393500400619852e-9
    ]
  },
  "EPSG:26729": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      200208.26623236857,
      179425.43443585487,
      782508.9486392832,
      1.6384794396924998e6
    ]
  },
  "EPSG:26730": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      190230.47353072723,
      52155.4677760488,
      859300.2759978685,
      1.8283725799238186e6
    ]
  },
  "EPSG:26731": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000.001016 +y_0=-5000000.001016 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1321206041174186e6,
      1.0964834395414926e6,
      3351992803015711e-9,
      3130502365611493e-9
    ]
  },
  "EPSG:26732": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      129356.86526982463,
      2.0953803358537324e6,
      627150.2932771154,
      5909172566508532e-9
    ]
  },
  "EPSG:26733": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      131219.29379977274,
      2095346729413452e-9,
      746312.4551522603,
      5992696737075795e-9
    ]
  },
  "EPSG:26734": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      122655.73153336243,
      1.8725634719307483e6,
      744531.5610400893,
      6084218897421077e-9
    ]
  },
  "EPSG:26735": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      88120.30486005534,
      634339.8860964493,
      751930.860372421,
      6322566222563061e-9
    ]
  },
  "EPSG:26736": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      79429.99844470627,
      331298.2982565664,
      735208.2418471989,
      6365971864747225e-9
    ]
  },
  "EPSG:26737": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=213360.426720853 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      270941.25799284957,
      122962.25355864014,
      942025.996120122,
      6124501660631733e-9
    ]
  },
  "EPSG:26738": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      18266.268787323577,
      132216.37963619185,
      762305.7972445361,
      5506318461546654e-9
    ]
  },
  "EPSG:26739": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -38478.163426974614,
      924074.8596290442,
      900398.5877258232,
      4.3251000242421245e6
    ]
  },
  "EPSG:26740": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=914401.828803658 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      361852.8675401216,
      323004.33604554686,
      5372762139660789e-9,
      1.4042924374779298e6
    ]
  },
  "EPSG:26741": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3098147446743823e6,
      103210.67480273725,
      254657857979987e-8,
      981488.0283526852
    ]
  },
  "EPSG:26742": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4068441126007983e6,
      135449.9969108803,
      2.6878651669364395e6,
      917456.829441917
    ]
  },
  "EPSG:26743": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2617988586715695e6,
      93715.51871108614,
      2.7621544984781942e6,
      815628.2374784971
    ]
  },
  "EPSG:26744": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1075201609777338e6,
      176611.84288181236,
      2979670036427376e-9,
      835186.3486508995
    ]
  },
  "EPSG:26745": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      945437.9224093807,
      -251357.9761918265,
      3150582732561111e-9,
      862925.6252033612
    ]
  },
  "EPSG:26746": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4146408748267696e6,
      137510.8176420658,
      2.5543960923071858e6,
      701036.7022679828
    ]
  },
  "EPSG:26748": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      18323.012446149252,
      123349.64362300755,
      829156.1420457803,
      2.1888227527081654e6
    ]
  },
  "EPSG:26749": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      52686.67986154407,
      122888.95601810887,
      931365.5053747667,
      2.1902244513838007e6
    ]
  },
  "EPSG:26750": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      171810.27655221868,
      383503.4851504374,
      859416.3572034239,
      2185636586809777e-9
    ]
  },
  "EPSG:26751": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2122624682197198e6,
      132982.43930964678,
      2693700961015043e-9,
      796939.2706041615
    ]
  },
  "EPSG:26752": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2397716890992038e6,
      134091.5074872121,
      2478684096852441e-9,
      889193.4084162988
    ]
  },
  "EPSG:26753": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      996657.7066105925,
      102720.68064466679,
      2.9548917136411234e6,
      629432.5415341305
    ]
  },
  "EPSG:26754": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      976445.1719481122,
      131747.9642221077,
      2968098126862783e-9,
      840356.565502598
    ]
  },
  "EPSG:26755": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      960455.784453742,
      133897.1276864752,
      2987756870698072e-9,
      751416.5858643312
    ]
  },
  "EPSG:26756": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      329274.08054015134,
      54975.65960057859,
      863327.1483198911,
      444805.74206214485
    ]
  },
  "EPSG:26757": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      390094.72744252277,
      160448.37089643473,
      625304.9976550697,
      674095.5108668865
    ]
  },
  "EPSG:26758": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      57368.95280607028,
      29835.392344709693,
      823235.8043725432,
      2.3631090378623153e6
    ]
  },
  "EPSG:26759": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      60819.00635231235,
      705936.6466320031,
      776441.3665525923,
      1.9153338122418479e6
    ]
  },
  "EPSG:26760": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0014490550813406e6,
      89980.91795841375,
      2770674734763502e-9,
      739228.2201365415
    ]
  },
  "EPSG:26766": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      88900.73621007409,
      133193.70966040224,
      919850.1073657948,
      1.7053295993661378e6
    ]
  },
  "EPSG:26767": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      45969.582735703174,
      228298.80876013424,
      852314.2028135936,
      1.8245892025141243e6
    ]
  },
  "EPSG:26768": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      208437.23455807744,
      119676.6148964915,
      792919.1440718335,
      1125838274820467e-9
    ]
  },
  "EPSG:26769": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      146832.18040221883,
      120535.43298618209,
      837495.0233470583,
      1.4729665959859493e6
    ]
  },
  "EPSG:26770": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      95199.36005425183,
      121380.20726357283,
      843444.5143944627,
      2680659566078245e-9
    ]
  },
  "EPSG:26771": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      223776.04999869704,
      144550.00336617537,
      854184.1448605588,
      2.1274997249362143e6
    ]
  },
  "EPSG:26772": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      104722.37635169388,
      116857.26116956086,
      833461.1434709006,
      2.1307616020565485e6
    ]
  },
  "EPSG:26773": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      233742.48108797253,
      165153.0005927036,
      741857.3792555641,
      1556565884357171e-9
    ]
  },
  "EPSG:26774": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217690.59968410328,
      99762.52580673764,
      730049.5141895448,
      1.5564468799365584e6
    ]
  },
  "EPSG:26775": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1419823311163431e6,
      143537.35561375695,
      2.8886198039879766e6,
      750138.8634891551
    ]
  },
  "EPSG:26776": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2645136369141485e6,
      145961.41625030356,
      2.9126179424496717e6,
      760897.5723797019
    ]
  },
  "EPSG:26777": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      838815.4199510065,
      94012.76145587966,
      2.9579258493012227e6,
      628771.2261664222
    ]
  },
  "EPSG:26778": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963439.9805192592,
      137453.84806066912,
      3110134753845432e-9,
      829174.9826953599
    ]
  },
  "EPSG:26779": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1505286795936233e-9,
      81041.80415151065,
      2504773962601559e-9,
      605748.6787388171
    ]
  },
  "EPSG:26780": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      877270.2158907725,
      79709.26625781963,
      3092231988425184e-9,
      690683.0473935576
    ]
  },
  "EPSG:26781": {
    proj4: "+proj=lcc +lat_0=30.6666666666667 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1513600687375765e-9,
      70094.89773154365,
      2502739528173907e-9,
      863474.4204879493
    ]
  },
  "EPSG:26782": {
    proj4: "+proj=lcc +lat_0=28.6666666666667 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1569876203166638e6,
      -298471.94991691376,
      3118788053761124e-9,
      891385.8690294367
    ]
  },
  "EPSG:26783": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-68.5 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      96495.22160872245,
      20716.906836808503,
      893085.0349735146,
      1.3299548129576005e6
    ]
  },
  "EPSG:26784": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      253003.3622335888,
      76691.91047835279,
      727885.335138675,
      1.3672101024263406e6
    ]
  },
  "EPSG:26785": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=243840.487680975 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      82127.95076634514,
      59544.20176817616,
      1370856590500923e-9,
      697108.7939103002
    ]
  },
  "EPSG:26786": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      51674.469624845085,
      174056.80123670932,
      1.0393636293199408e6,
      692973.7585808298
    ]
  },
  "EPSG:26787": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=60960.1219202439 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      87001.93210321934,
      69501.31107562005,
      366923.29597133707,
      186420.64166780573
    ]
  },
  "EPSG:26791": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      965491.9255129892,
      78650.61053849914,
      2.8599504801258445e6,
      1.0706698535931332e6
    ]
  },
  "EPSG:26792": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      132826294400356e-8,
      113183.23263760265,
      2484747661774041e-9,
      910418.1116875102
    ]
  },
  "EPSG:26793": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1243810305377094e-9,
      191819.09049484332,
      2.7142743914937973e6,
      956410.9433469066
    ]
  },
  "EPSG:26794": {
    proj4: "+proj=tmerc +lat_0=29.6666666666667 +lon_0=-88.8333333333333 +k=0.99996 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      140238.50035693785,
      126555.48978648892,
      722609.6334705909,
      1.9446680107689807e6
    ]
  },
  "EPSG:26795": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-90.3333333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      87483.06840497776,
      184217.0862188552,
      788499.7137255482,
      1642145878318883e-9
    ]
  },
  "EPSG:26796": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      65094.03325520425,
      56635.30795634649,
      888724.3775238629,
      1.7424734514489162e6
    ]
  },
  "EPSG:26797": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      120795.36454403317,
      237909.13637613677,
      802672.8523264264,
      1741261437666324e-9
    ]
  },
  "EPSG:26798": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      126690.71204891619,
      116498.30482609819,
      783342.7440506336,
      1.6124214790766877e6
    ]
  },
  "EPSG:26799": {
    proj4: "+proj=lcc +lat_0=34.1333333333333 +lon_0=-118.333333333333 +lat_1=34.4166666666667 +lat_2=33.8666666666667 +x_0=1276106.4505969 +y_0=1268253.00685801 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3996265031748075e-9,
      3989259192023327e-9,
      4398057675750936e-9,
      441520386778972e-8
    ]
  },
  "EPSG:26847": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "EPSG:26848": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490075164e-9,
      76679.40227344376,
      3180746481484039e-9,
      1.3672472204547669e6
    ]
  },
  "EPSG:26849": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432546007e6,
      406726.88329058146,
      3.4846058823118517e6,
      1.3987812844641001e6
    ]
  },
  "EPSG:26850": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774561575e6,
      441259.17602739297,
      3.1093523403728413e6,
      1.2384987154614236e6
    ]
  },
  "EPSG:26851": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8684100191496245e6,
      519898.6810854104,
      3.3388826902731457e6,
      1.2844950057572832e6
    ]
  },
  "EPSG:26852": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.8323418051,
      83779.09479688275,
      289695436853239e-8,
      1.1914174172197795e6
    ]
  },
  "EPSG:26853": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1324061584813105e-9,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "EPSG:26854": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.70342088
    ]
  },
  "EPSG:26855": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "EPSG:26856": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490075164e-9,
      76679.40227344376,
      3180746481484039e-9,
      1.3672472204547669e6
    ]
  },
  "EPSG:26857": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432546007e6,
      406726.88329058146,
      3.4846058823118517e6,
      1.3987812844641001e6
    ]
  },
  "EPSG:26858": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774561575e6,
      441259.17602739297,
      3.1093523403728413e6,
      1.2384987154614236e6
    ]
  },
  "EPSG:26859": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8684100191496245e6,
      519898.6810854104,
      3.3388826902731457e6,
      1.2844950057572832e6
    ]
  },
  "EPSG:26860": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.8323418051,
      83779.09479688275,
      289695436853239e-8,
      1.1914174172197795e6
    ]
  },
  "EPSG:26861": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1324061584813105e-9,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "EPSG:26862": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.70342088
    ]
  },
  "EPSG:26863": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "EPSG:26864": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490075164e-9,
      76679.40227344376,
      3180746481484039e-9,
      1.3672472204547669e6
    ]
  },
  "EPSG:26865": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432546007e6,
      406726.88329058146,
      3.4846058823118517e6,
      1.3987812844641001e6
    ]
  },
  "EPSG:26866": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774561575e6,
      441259.17602739297,
      3.1093523403728413e6,
      1.2384987154614236e6
    ]
  },
  "EPSG:26867": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8684100191496245e6,
      519898.6810854104,
      3.3388826902731457e6,
      1.2844950057572832e6
    ]
  },
  "EPSG:26868": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.8323418051,
      83779.09479688275,
      289695436853239e-8,
      1.1914174172197795e6
    ]
  },
  "EPSG:26869": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1324061584813105e-9,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "EPSG:26870": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.70342088
    ]
  },
  "EPSG:26891": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213203.30702221807,
      4615106862634651e-9,
      420982.88539797766,
      509667043507393e-8
    ]
  },
  "EPSG:26892": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188617.11460202234,
      509667043507393e-8,
      400275.84726700257,
      6121023073271519e-9
    ]
  },
  "EPSG:26893": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      188617.11460202234,
      509667043507393e-8,
      399364.16796375834,
      6163319435800816e-9
    ]
  },
  "EPSG:26894": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      191090.70195746733,
      5226715431148183e-9,
      396677.17448948184,
      6286883372403416e-9
    ]
  },
  "EPSG:26895": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      192809.59554090386,
      5315649403928492e-9,
      396189.2947786454,
      6.3091493507500375e6
    ]
  },
  "EPSG:26896": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      193004.35375048738,
      5325655202289895e-9,
      400299.7816874225,
      6119910044418012e-9
    ]
  },
  "EPSG:26897": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      366638.38396239246,
      5394954535931998e-9,
      404933.2661121929,
      5901789692256556e-9
    ]
  },
  "EPSG:26898": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      189795.03082335438,
      5158911087584208e-9,
      337851.86875655863,
      5528160574820434e-9
    ]
  },
  "EPSG:26899": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      190324.464420336,
      5186698934950825e-9,
      401468.9526759774,
      6065373731464224e-9
    ]
  },
  "EPSG:26901": {
    proj4: "+proj=utm +zone=1 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      275705.2007711646,
      5307320288937037e-9,
      651326.6101829188,
      7012536575907362e-9
    ]
  },
  "EPSG:26902": {
    proj4: "+proj=utm +zone=2 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      279095.5340691147,
      5394004676025433e-9,
      597909.7820209023,
      8108518214682238e-9
    ]
  },
  "EPSG:26903": {
    proj4: "+proj=utm +zone=3 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      282881.3113258418,
      5489589711728697e-9,
      590937.4580819238,
      8246692023643711e-9
    ]
  },
  "EPSG:26904": {
    proj4: "+proj=utm +zone=4 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      178221.76642636198,
      1.7236354026379515e6,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:26905": {
    proj4: "+proj=utm +zone=5 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      178206.0575190896,
      1.7225279807824509e6,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "EPSG:26906": {
    proj4: "+proj=utm +zone=6 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      303614.943130552,
      599324839556645e-8,
      591839.6077320275,
      8228862484656331e-9
    ]
  },
  "EPSG:26907": {
    proj4: "+proj=utm +zone=7 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      294300.7479905948,
      5770847571989179e-9,
      594878.9639862768,
      8168689220963358e-9
    ]
  },
  "EPSG:26908": {
    proj4: "+proj=utm +zone=8 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      276483.89691439964,
      5327323615473784e-9,
      561466.0056721768,
      881843231451587e-8
    ]
  },
  "EPSG:26909": {
    proj4: "+proj=utm +zone=9 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      227475.2739848646,
      3919318118925639e-9,
      552774.1905777643,
      898675552561162e-8
    ]
  },
  "EPSG:26910": {
    proj4: "+proj=utm +zone=10 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      212172.22206675174,
      3382455381866777e-9,
      547908.0739169728,
      9083749435873026e-9
    ]
  },
  "EPSG:26911": {
    proj4: "+proj=utm +zone=11 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      213181.34452594037,
      3.4201591228960655e6,
      537898.6633350778,
      9273261908761378e-9
    ]
  },
  "EPSG:26912": {
    proj4: "+proj=utm +zone=12 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      214532.47558561602,
      3470063347430235e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:26913": {
    proj4: "+proj=utm +zone=13 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      207672.60560265684,
      3209479925667875e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:26914": {
    proj4: "+proj=utm +zone=14 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      199250.35388242255,
      2860290264055177e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:26915": {
    proj4: "+proj=utm +zone=15 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      198695.77588937344,
      2.8359066251671286e6,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:26916": {
    proj4: "+proj=utm +zone=16 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      194701.98624121048,
      2654154227656937e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:26917": {
    proj4: "+proj=utm +zone=17 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      194325.66756335914,
      2.6364238174826605e6,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:26918": {
    proj4: "+proj=utm +zone=18 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      205723.7692717061,
      3131872261800517e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:26919": {
    proj4: "+proj=utm +zone=19 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      177229.185878901,
      1.6516547699651534e6,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "EPSG:26920": {
    proj4: "+proj=utm +zone=20 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      178314.76024703542,
      1.7302792485121845e6,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "EPSG:26921": {
    proj4: "+proj=utm +zone=21 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      238596.64535791575,
      4272219139229722e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "EPSG:26922": {
    proj4: "+proj=utm +zone=22 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      242040.22836453855,
      4.3765623477354655e6,
      679019.5758874652,
      639370540243708e-8
    ]
  },
  "EPSG:26923": {
    proj4: "+proj=utm +zone=23 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      243340.25432519306,
      4415416678187952e-9,
      694398.0543714615,
      6039959486458218e-9
    ]
  },
  "EPSG:26929": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "EPSG:26930": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      505580.44594500464,
      15923.948440411992,
      709514.5981036696,
      557319.3872848145
    ]
  },
  "EPSG:26931": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      345065.0006292928,
      334042.20469821244,
      1.0216737568623158e6,
      954041.2679213481
    ]
  },
  "EPSG:26932": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      386918.31041990273,
      638611.495563188,
      538646.0751082397,
      1.8010582813575123e6
    ]
  },
  "EPSG:26933": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      387480.7933152069,
      638594.4905497337,
      574961.5237298968,
      1.8265091488610085e6
    ]
  },
  "EPSG:26934": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      384866.0062102319,
      570683.0524052249,
      574413.9786087219,
      1.8543974615086422e6
    ]
  },
  "EPSG:26935": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      374335.66296567384,
      193265.41672186597,
      576665.1462954525,
      1927037849194219e-9
    ]
  },
  "EPSG:26936": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      371683.47061143327,
      100891.27017918504,
      571564.5392518891,
      1.9402596195834302e6
    ]
  },
  "EPSG:26937": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      369227.2759588344,
      37478.56021629183,
      573639.6586334868,
      1866650932337704e-9
    ]
  },
  "EPSG:26938": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      353035.9059764714,
      40196.47731406788,
      579818.6224001455,
      1678220016121422e-9
    ]
  },
  "EPSG:26939": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      305398.63289577013,
      281655.18765712064,
      591427.5708482452,
      1.3181762713116712e6
    ]
  },
  "EPSG:26940": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      195687.98647669028,
      98297.39874279598,
      1.7230791763698556e6,
      427904.9014095053
    ]
  },
  "EPSG:26941": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7895395665343686e6,
      531443.8371340163,
      216650689441652e-8,
      799143.9865565519
    ]
  },
  "EPSG:26942": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8191142581414783e6,
      541273.7589847766,
      2.2095712464330723e6,
      779630.525372654
    ]
  },
  "EPSG:26943": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1774907679626609e-9,
      528557.1371854008,
      2.2322182534678923e6,
      748597.178483144
    ]
  },
  "EPSG:26944": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1727886776452719e-9,
      553828.3138820408,
      2298520922247323e-9,
      754562.841666431
    ]
  },
  "EPSG:26945": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6794231645368338e6,
      423356.5291107174,
      2350617831343431e-9,
      763023.8066438821
    ]
  },
  "EPSG:26946": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8215040867444675e6,
      541921.609051466,
      2168903381623939e-9,
      713685.2401208607
    ]
  },
  "EPSG:26948": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      66481.57726905748,
      37612.94225911591,
      313625.1177186511,
      667173.219860401
    ]
  },
  "EPSG:26949": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      76951.28315104556,
      37471.49767701424,
      344774.25509364414,
      667599.2730779602
    ]
  },
  "EPSG:26950": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      113255.82314843503,
      116906.13012893949,
      322839.39768852945,
      666199.5535385566
    ]
  },
  "EPSG:26951": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      159882.1517288231,
      40546.019450230866,
      611428.2003751276,
      242921.67605554135
    ]
  },
  "EPSG:26952": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      168267.01668838607,
      440888.471984403,
      545890.5412777681,
      671045.3781161602
    ]
  },
  "EPSG:26953": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      608530.8153568001,
      336108.1196154525,
      1.2054047088972987e6,
      496651.021459994
    ]
  },
  "EPSG:26954": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      602369.9938571034,
      344958.28088118456,
      1.2094300492099929e6,
      560943.6928306813
    ]
  },
  "EPSG:26955": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      597496.3981335191,
      345615.6716642405,
      1.2154220791101314e6,
      533836.9174519398
    ]
  },
  "EPSG:26956": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      222322.54347837297,
      169156.3466800607,
      385103.12220492034,
      287977.4369607322
    ]
  },
  "EPSG:26957": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      166533.1617424154,
      48909.64130833831,
      238225.79702413955,
      205470.4830819298
    ]
  },
  "EPSG:26958": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      65102.24329868861,
      9138.495345549798,
      298540.2068111297,
      720329.5066960583
    ]
  },
  "EPSG:26959": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      66150.82424507887,
      215219.2456022235,
      284274.37357896275,
      583846.6255438706
    ]
  },
  "EPSG:26960": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      295646.50247016025,
      27456.531402877317,
      834910.9831262925,
      225348.7609827654
    ]
  },
  "EPSG:26961": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      436777.5946342293,
      4166.093628590134,
      579364.3420613783,
      165857.5800091873
    ]
  },
  "EPSG:26962": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      427654.7031690693,
      13069.065028704172,
      576457.6239427308,
      102770.62271959611
    ]
  },
  "EPSG:26963": {
    proj4: "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      465736.4437948283,
      3726.7550627868754,
      540342.8093548855,
      64639.12092031069
    ]
  },
  "EPSG:26964": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      463811.0952607358,
      -2542.106960911035,
      527824.1130553415,
      50592.00439860022
    ]
  },
  "EPSG:26965": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      486206.39876355266,
      7019.058393578478,
      518234.63089795306,
      44671.50509398868
    ]
  },
  "EPSG:26966": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      74709.789308767,
      40624.309794496774,
      327985.22104999487,
      519815.2404935042
    ]
  },
  "EPSG:26967": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      561618.6831736781,
      69612.78234582106,
      807394.5382984749,
      556166.0817971718
    ]
  },
  "EPSG:26968": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      111063.71939851393,
      36468.06030250205,
      289214.9223945835,
      343148.0611808968
    ]
  },
  "EPSG:26969": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      392281.83037533704,
      36728.336945737465,
      602797.1348322467,
      448951.8476535554
    ]
  },
  "EPSG:26970": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      676539.7837076162,
      36984.30998402688,
      904606.2381105269,
      817057.2289334119
    ]
  },
  "EPSG:26971": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      215802.92024991306,
      44068.31688321397,
      407952.84533971857,
      648476.2402160055
    ]
  },
  "EPSG:26972": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      579509.9562219738,
      35625.98718209203,
      801631.300013067,
      649470.3402959756
    ]
  },
  "EPSG:26973": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      18848.169675766898,
      300346.5557813935,
      173722.82933421258,
      724452.6023682763
    ]
  },
  "EPSG:26974": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      813951.5557038783,
      280415.4110952896,
      970119.8033495815,
      724416.3646416317
    ]
  },
  "EPSG:26975": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2384564841177673e6,
      1043750404067701e-9,
      1.7708357650029673e6,
      1.2286439962682903e6
    ]
  },
  "EPSG:26976": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      275804.31496850675,
      44490.99603974775,
      778150.4552814267,
      231925.01089940732
    ]
  },
  "EPSG:26977": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      46038.237386999186,
      28658.252530809354,
      691948.0045848172,
      191653.8734461696
    ]
  },
  "EPSG:26978": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      84022.72728234128,
      441902.1544802367,
      738340.2719366557,
      652740.3625160322
    ]
  },
  "EPSG:26980": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      157793.0920864537,
      524305.3717931777,
      832918.8536462528,
      710531.6721022655
    ]
  },
  "EPSG:26981": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      851729.3635550354,
      39868.512993891505,
      1153221324211875e-9,
      281692.5559034941
    ]
  },
  "EPSG:26982": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      745633.3912495468,
      41691.410611282045,
      1246542614779638e-9,
      287665.49443279085
    ]
  },
  "EPSG:26983": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      177049.16196835245,
      24838.65270351215,
      419851.20673729526,
      423896.7865970171
    ]
  },
  "EPSG:26984": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      824761.6428981957,
      23371.92855680277,
      969493.4665432682,
      416737.78627018543
    ]
  },
  "EPSG:26985": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      181219.09721396962,
      36655.85913985907,
      574026.6173549057,
      230987.04872253875
    ]
  },
  "EPSG:26986": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      32912.32927433509,
      803051.4395878355,
      333962.18491762364,
      961218.4864862445
    ]
  },
  "EPSG:26987": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      465603.8085218641,
      21182.19390165996,
      550924.4533078014,
      56819.46303831281
    ]
  },
  "EPSG:26988": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      7730770077384338e-9,
      38783.29196926807,
      8264072881829599e-9,
      399102.5058484581
    ]
  },
  "EPSG:26989": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      5783269683611322e-9,
      57309.82074061751,
      6162640001784503e-9,
      291399.94080042426
    ]
  },
  "EPSG:26990": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      3764135981418406e-9,
      25074.8909276311,
      4178741346471115e-9,
      304539.3832952072
    ]
  },
  "EPSG:26991": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      484662.883379609,
      123970.60197833316,
      1.0621099971384865e6,
      426349.3882135941
    ]
  },
  "EPSG:26992": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      595233.1859048485,
      134496.0658554411,
      947732.4888004595,
      377495.16347312875
    ]
  },
  "EPSG:26993": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      569492.5128116711,
      158465.4349358629,
      1.0176934793720534e6,
      391514.8607947015
    ]
  },
  "EPSG:26994": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      190340.12052613805,
      57073.9038946292,
      367846.54652006144,
      611234.9881211288
    ]
  },
  "EPSG:26995": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      574253.7728630524,
      167020.95974745313,
      787927.2680533797,
      611406.5844740515
    ]
  },
  "EPSG:26996": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      117430.21416727672,
      17271.89955836394,
      368474.73767414974,
      531120.8788109587
    ]
  },
  "EPSG:26997": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      384402.582974351,
      72524.35270280449,
      592240.4863549052,
      530749.7674890533
    ]
  },
  "EPSG:26998": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857344828,
      35516.95357112248,
      936343.0942781423,
      491477.91794944176
    ]
  },
  "EPSG:27039": {
    proj4: "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      453800.6600327945,
      2.5168111610610057e6,
      798595.2547924741,
      2.9953009634667276e6
    ]
  },
  "EPSG:27040": {
    proj4: "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      191616.06289680692,
      2505459982955225e-9,
      512980.5863509767,
      290535555973957e-8
    ]
  },
  "EPSG:27120": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      729407.0252323993,
      1.2256472637564775e6,
      779368.042310637,
      1.2625636418003005e6
    ]
  },
  "EPSG:27200": {
    proj4: "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.0088503192670003e6,
      5299595204573557e-9,
      3.0310358146186816e6,
      6.7730982867170125e6
    ]
  },
  "EPSG:27205": {
    proj4: "+proj=tmerc +lat_0=-36.8798652777778 +lon_0=174.764339361111 +k=0.9999 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      59696.31910826493,
      459918.2570323567,
      425092.8078747994,
      1.0075722235555026e6
    ]
  },
  "EPSG:27206": {
    proj4: "+proj=tmerc +lat_0=-37.7612498055556 +lon_0=176.46619725 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      238068.9785072779,
      547813.5387985962,
      367794.5456561635,
      759799.8761365523
    ]
  },
  "EPSG:27207": {
    proj4: "+proj=tmerc +lat_0=-38.6247027777778 +lon_0=177.885636277778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      199941.8571071796,
      653260.0107425544,
      365832.8907175352,
      825692.3797940916
    ]
  },
  "EPSG:27208": {
    proj4: "+proj=tmerc +lat_0=-39.6509293055556 +lon_0=176.673680527778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      226013.28610637184,
      597579.5646121674,
      421187.1842233399,
      785774.7443444405
    ]
  },
  "EPSG:27209": {
    proj4: "+proj=tmerc +lat_0=-39.1357583055556 +lon_0=174.22801175 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      253051.07701650995,
      628327.8892797574,
      405877.6689049258,
      780983.9243071543
    ]
  },
  "EPSG:27210": {
    proj4: "+proj=tmerc +lat_0=-39.5124703888889 +lon_0=175.640036805556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      234670.18703192048,
      695557.2175627417,
      359881.2485387236,
      771102.2238312914
    ]
  },
  "EPSG:27211": {
    proj4: "+proj=tmerc +lat_0=-40.2419471388889 +lon_0=175.488099611111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      208406.09455888986,
      618579.8007034436,
      367295.8990714713,
      786531.5984175624
    ]
  },
  "EPSG:27212": {
    proj4: "+proj=tmerc +lat_0=-40.9255326388889 +lon_0=175.647349666667 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      246920.59741566997,
      617120.9883579104,
      376757.72828700126,
      770184.6055221057
    ]
  },
  "EPSG:27213": {
    proj4: "+proj=tmerc +lat_0=-41.3013196388889 +lon_0=174.776623111111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      278571.9678521473,
      677901.7812082376,
      349151.5821057089,
      743295.7768396935
    ]
  },
  "EPSG:27214": {
    proj4: "+proj=tmerc +lat_0=-40.7147590555556 +lon_0=172.6720465 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      257060.40825976385,
      643763.2631275269,
      338856.0852734937,
      730410.9794595075
    ]
  },
  "EPSG:27215": {
    proj4: "+proj=tmerc +lat_0=-41.2745447222222 +lon_0=173.299316805556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      225697.56439303205,
      599038.3449679754,
      366022.59612579446,
      767956.1132462203
    ]
  },
  "EPSG:27216": {
    proj4: "+proj=tmerc +lat_0=-41.2899115277778 +lon_0=172.109028194444 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      287554.23375852016,
      677766.5054777521,
      349911.3161118923,
      759793.2196834916
    ]
  },
  "EPSG:27217": {
    proj4: "+proj=tmerc +lat_0=-41.8108028611111 +lon_0=171.581260055556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      274287.5347874284,
      657833.1596692841,
      369285.1625419833,
      743074.6148575044
    ]
  },
  "EPSG:27218": {
    proj4: "+proj=tmerc +lat_0=-42.3336942777778 +lon_0=171.549771305556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      267263.6295097411,
      654787.1712848564,
      400219.97395343834,
      791906.9752592721
    ]
  },
  "EPSG:27219": {
    proj4: "+proj=tmerc +lat_0=-42.6891165833333 +lon_0=173.010133388889 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      207768.46763519727,
      670397.963817635,
      344667.38823105604,
      766411.3348592045
    ]
  },
  "EPSG:27220": {
    proj4: "+proj=tmerc +lat_0=-41.5444866666667 +lon_0=173.802074111111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      230124.57867775214,
      576849.1921204966,
      355482.71826199756,
      776922.00673781
    ]
  },
  "EPSG:27221": {
    proj4: "+proj=tmerc +lat_0=-42.8863223611111 +lon_0=170.9799935 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      252068.9301862589,
      661649.317988838,
      374912.5383468747,
      752513.0610954501
    ]
  },
  "EPSG:27222": {
    proj4: "+proj=tmerc +lat_0=-43.1101281388889 +lon_0=170.260925833333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      215493.07040036615,
      617259.1926470516,
      351297.7473969137,
      712042.8688562016
    ]
  },
  "EPSG:27223": {
    proj4: "+proj=tmerc +lat_0=-43.9778028888889 +lon_0=168.606267 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      253292.63722555776,
      652918.4989094104,
      413215.99953905784,
      733242.9345892312
    ]
  },
  "EPSG:27224": {
    proj4: "+proj=tmerc +lat_0=-43.5906375833333 +lon_0=172.727193583333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      170197.2976875711,
      657687.8792470687,
      353499.83577882755,
      799853.1829118404
    ]
  },
  "EPSG:27225": {
    proj4: "+proj=tmerc +lat_0=-43.7487115555556 +lon_0=171.360748472222 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      245626.99247557018,
      644073.5739413102,
      373174.63029651623,
      768349.1945643905
    ]
  },
  "EPSG:27226": {
    proj4: "+proj=tmerc +lat_0=-44.4022203611111 +lon_0=171.057250833333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      202408.20535878208,
      635046.8799813743,
      339952.3045594454,
      816797.7501370959
    ]
  },
  "EPSG:27227": {
    proj4: "+proj=tmerc +lat_0=-44.7352679722222 +lon_0=169.467755083333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      233620.8545974986,
      625774.2178150674,
      362242.67654551234,
      813638.0198503484
    ]
  },
  "EPSG:27228": {
    proj4: "+proj=tmerc +lat_0=-45.1329025833333 +lon_0=168.398641194444 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      247031.44041272887,
      650084.4895115485,
      356779.4078950107,
      793425.366589224
    ]
  },
  "EPSG:27229": {
    proj4: "+proj=tmerc +lat_0=-45.5637261666667 +lon_0=167.738861777778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      194591.11450753902,
      613914.770918213,
      337451.94045621826,
      814776.4856880631
    ]
  },
  "EPSG:27230": {
    proj4: "+proj=tmerc +lat_0=-45.8161966111111 +lon_0=170.628595166667 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      233272.00266783038,
      699218.6792610887,
      348535.5080406633,
      833874.262526855
    ]
  },
  "EPSG:27231": {
    proj4: "+proj=tmerc +lat_0=-45.8615133611111 +lon_0=170.282589111111 +k=0.99996 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      174443.4518213501,
      602151.57134759,
      346130.1113533255,
      770019.5343404323
    ]
  },
  "EPSG:27232": {
    proj4: "+proj=tmerc +lat_0=-46.6000096111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      220416.42317713692,
      618306.0154607168,
      349167.3336748611,
      840975.2405519774
    ]
  },
  "EPSG:27258": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      565338.6804292701,
      4722130522095585e-9,
      746165.5006463432,
      5280265559463758e-9
    ]
  },
  "EPSG:27259": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      274659.78935050673,
      471924745016337e-8,
      777460.5488109754,
      6245929814100167e-9
    ]
  },
  "EPSG:27260": {
    proj4: "+proj=utm +zone=60 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      259988.8843441809,
      51092213786743e-7,
      709067.579646144,
      6208842732782471e-9
    ]
  },
  "EPSG:27291": {
    proj4: "+proj=tmerc +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.524384809 +y_0=365759.365846411 +ellps=intl +to_meter=0.914398414616029 +no_defs +type=crs",
    projected_bounds: [
      -19706.0057106943,
      69240.9589213261,
      615936.1604766297,
      989827.9593011
    ]
  },
  "EPSG:27292": {
    proj4: "+proj=tmerc +lat_0=-44 +lon_0=171.5 +k=1 +x_0=457199.207308014 +y_0=457199.207308014 +ellps=intl +to_meter=0.914398414616029 +no_defs +type=crs",
    projected_bounds: [
      75967.45052498988,
      81250.98914371054,
      774678.1766114585,
      927863.570087593
    ]
  },
  "EPSG:27391": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=-4.66666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -81528.10444021235,
      -6965.79219515403,
      59346.2010561715,
      564273.0219912175
    ]
  },
  "EPSG:27392": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=-2.33333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -69247.5855768751,
      -4969.201229456433,
      57527.720850459504,
      654539.025758169
    ]
  },
  "EPSG:27393": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -67716.67686969393,
      94146.94500855058,
      57604.04493650281,
      865281.0797963571
    ]
  },
  "EPSG:27394": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=2.5 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -70155.38863133492,
      210062.73225462617,
      73284.3386386813,
      1.2338032216414106e6
    ]
  },
  "EPSG:27395": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -83016.2051653857,
      909406.8962257892,
      75672.96501007266,
      1.3599949367906672e6
    ]
  },
  "EPSG:27396": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.1666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -82824.03620672051,
      1.1526366588665536e6,
      73396.82669228342,
      1.4291270476318887e6
    ]
  },
  "EPSG:27397": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=14.1666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -81914.4561103121,
      1.1805066168710405e6,
      75158.4822958099,
      1.4738399696845275e6
    ]
  },
  "EPSG:27398": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=18.3333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -83372.6344490157,
      1.2296617756210775e6,
      77953.63244455305,
      1.4694725795605832e6
    ]
  },
  "EPSG:27429": {
    proj4: "+proj=utm +zone=29 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      450138.3558337785,
      4.0895388527946067e6,
      732153.6173546368,
      4671446675248958e-9
    ]
  },
  "EPSG:27493": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -127028.95781609436,
      -300698.5431991816,
      160675.77041202402,
      278637.28586874367
    ]
  },
  "EPSG:27500": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +no_defs +type=crs",
    projected_bounds: [
      432310.73897441535,
      69222.02530624528,
      535979.5406178972,
      252328.70102365952
    ]
  },
  "EPSG:27561": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      64323.22805854608,
      74402.5369253752,
      1.0121331252694363e6,
      398553.3017506995
    ]
  },
  "EPSG:27562": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      42230.68117568863,
      74178.43105128294,
      993611.4759779831,
      363346.0031043404
    ]
  },
  "EPSG:27563": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      259837.90399363468,
      11882.399728158693,
      1.0200108643185934e6,
      364836.7521987711
    ]
  },
  "EPSG:27564": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      515904.771963488,
      109525.98080921858,
      593562.8907930726,
      311753.1643148327
    ]
  },
  "EPSG:27571": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      64323.22805854608,
      1.0744025369253752e6,
      1.0121331252694363e6,
      1.3985533017506995e6
    ]
  },
  "EPSG:27572": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      5094.3000770156505,
      1.7301473029733542e6,
      1.0132122316130111e6,
      2.6985567123740967e6
    ]
  },
  "EPSG:27573": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      259837.90399363468,
      3.0118823997281585e6,
      1.0200108643185934e6,
      3364836752198771e-9
    ]
  },
  "EPSG:27574": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      515904.771963488,
      4.1095259808092187e6,
      593562.8907930726,
      4311753164314833e-9
    ]
  },
  "EPSG:27700": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      -104009.3571371049,
      6924.79162030491,
      616700.9248869751,
      1.2429638870186193e6
    ]
  },
  "EPSG:28191": {
    proj4: "+proj=cass +lat_0=31.7340969444444 +lon_0=35.2120805555556 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs +type=crs",
    projected_bounds: [
      68886.18756822767,
      -155818.5923884948,
      551483.0451116164,
      316899.3800733572
    ]
  },
  "EPSG:28192": {
    proj4: "+proj=tmerc +lat_0=31.7340969444444 +lon_0=35.2120805555556 +k=1 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs +type=crs",
    projected_bounds: [
      68881.9053626475,
      844181.4077639969,
      551710.5826178698,
      1.3168994219461493e6
    ]
  },
  "EPSG:28193": {
    proj4: "+proj=cass +lat_0=31.7340969444444 +lon_0=35.2120805555556 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs +type=crs",
    projected_bounds: [
      69152.69216324048,
      874109.7258279496,
      214774.77639657195,
      1.2983975750459952e6
    ]
  },
  "EPSG:28232": {
    proj4: "+proj=utm +zone=32 +south +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      482324.12400393555,
      9236267192917503e-9,
      1.5766691113125894e6,
      10417065057199728e-9
    ]
  },
  "EPSG:28348": {
    proj4: "+proj=utm +zone=48 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      237969.66973216366,
      6158719846304946e-9,
      831104.4355892052,
      901817823848433e-8
    ]
  },
  "EPSG:28349": {
    proj4: "+proj=utm +zone=49 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      236006.67164573778,
      5807695060841706e-9,
      829272.3553011138,
      8813370104420144e-9
    ]
  },
  "EPSG:28350": {
    proj4: "+proj=utm +zone=50 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      238487.90065300977,
      5731110761738591e-9,
      827731.7540110351,
      86650117986882e-7
    ]
  },
  "EPSG:28351": {
    proj4: "+proj=utm +zone=51 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      236829.50091370137,
      5782167689110662e-9,
      829550.5266798225,
      8842154943583598e-9
    ]
  },
  "EPSG:28352": {
    proj4: "+proj=utm +zone=52 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      233488.18310987734,
      5858719402739382e-9,
      829795.0524706775,
      899272559717385e-8
    ]
  },
  "EPSG:28353": {
    proj4: "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      246575.30941320778,
      5489105418000078e-9,
      831095.4547267796,
      9017071209460307e-9
    ]
  },
  "EPSG:28354": {
    proj4: "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      277047.6690437427,
      4658229252789943e-9,
      830913.7291054368,
      8994930538504545e-9
    ]
  },
  "EPSG:28355": {
    proj4: "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      289013.4663105268,
      4358119671970695e-9,
      830774.8002619529,
      8978324920725435e-9
    ]
  },
  "EPSG:28356": {
    proj4: "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      327480.12220176414,
      3460530811405612e-9,
      824285.6729657773,
      8464614441403877e-9
    ]
  },
  "EPSG:28357": {
    proj4: "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      335491.0396864221,
      3.2835824012734434e6,
      823991.365857983,
      8441361192927027e-9
    ]
  },
  "EPSG:28358": {
    proj4: "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=-0.0571908,0.0129478,0.0347518,0.0359499,0.0297869,0.029947,0.00918106 +units=m +no_defs +type=crs",
    projected_bounds: [
      329633.6227806935,
      3412679943005142e-9,
      800470.6958234934,
      7127517715836319e-9
    ]
  },
  "EPSG:28404": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      4393182015520038e-9,
      5313951562441295e-9,
      4670186233404623e-9,
      6595637757951948e-9
    ]
  },
  "EPSG:28405": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      5264197893927479e-9,
      5.0094175411680965e6,
      5617816430390117e-9,
      7712887556479445e-9
    ]
  },
  "EPSG:28406": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      6260671698178691e-9,
      4913845494223263e-9,
      6614411637087304e-9,
      7774162716634687e-9
    ]
  },
  "EPSG:28407": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      7249223313185243e-9,
      4592755767269399e-9,
      7618736913759626e-9,
      7686122571963354e-9
    ]
  },
  "EPSG:28408": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      8239506499884692e-9,
      4305097002115024e-9,
      8553087823830228e-9,
      898828546978921e-8
    ]
  },
  "EPSG:28409": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      9234121837053126e-9,
      4.1385418321746127e6,
      955008177444493e-8,
      9042922756726556e-9
    ]
  },
  "EPSG:28410": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      10233101760022527e-9,
      4106344725106357e-9,
      10547132497060755e-9,
      9099800724680038e-9
    ]
  },
  "EPSG:28411": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      11226555677248953e-9,
      3.8943163657914447e6,
      11547942489828466e-9,
      9084187058666075e-9
    ]
  },
  "EPSG:28412": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      12231775483489595e-9,
      4.0641571457690555e6,
      12574935856555257e-9,
      8560068375251852e-9
    ]
  },
  "EPSG:28413": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      13232193033135097e-9,
      4.0774793272321625e6,
      13559824801769981e-9,
      885445301426915e-8
    ]
  },
  "EPSG:28414": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      14247726789019816e-9,
      4.5494343501091665e6,
      14552392851708567e-9,
      9001668053108038e-9
    ]
  },
  "EPSG:28415": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      15271069571120145e-9,
      5191700322012202e-9,
      15550832916727256e-9,
      902842462503835e-8
    ]
  },
  "EPSG:28416": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      16284435457477678e-9,
      5533027165774099e-9,
      16550370706484398e-9,
      9037346543693524e-9
    ]
  },
  "EPSG:28417": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      17283723144953106e-9,
      5515234864293874e-9,
      17550544047046762e-9,
      9034000820986697e-9
    ]
  },
  "EPSG:28418": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      18283323214760493e-9,
      5505226852548886e-9,
      18561146886303443e-9,
      8828804348140907e-9
    ]
  },
  "EPSG:28419": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      19281111205380004e-9,
      5449628859473506e-9,
      19576415869080156e-9,
      8531078169374652e-9
    ]
  },
  "EPSG:28420": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      20282746487986702e-9,
      5490771036350928e-9,
      2058124307745921e-8,
      8436305541392285e-9
    ]
  },
  "EPSG:28421": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      21291741964205667e-9,
      5713194370626235e-9,
      2159230320326116e-8,
      8217790026561463e-9
    ]
  },
  "EPSG:28422": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2225240780383987e-8,
      4683848810351307e-9,
      2259449130315746e-8,
      8174313274365788e-9
    ]
  },
  "EPSG:28423": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      23253900845504683e-9,
      4.7260658776550945e6,
      23580165589163687e-9,
      8457489597908182e-9
    ]
  },
  "EPSG:28424": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2426694029144985e-8,
      5082770654099713e-9,
      24579484609098762e-9,
      8470869126102943e-9
    ]
  },
  "EPSG:28425": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      25257761160012648e-9,
      4833839761162132e-9,
      25576358974819794e-9,
      8532193169384241e-9
    ]
  },
  "EPSG:28426": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2626664795126798e-8,
      5074990485225236e-9,
      2657954137097728e-8,
      8469754161775332e-9
    ]
  },
  "EPSG:28427": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      272861339706551e-7,
      5575285319558777e-9,
      27574195261757378e-9,
      8574563637140198e-9
    ]
  },
  "EPSG:28428": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      28305520924267735e-9,
      6042482385332407e-9,
      2861435674386257e-8,
      7775277186006402e-9
    ]
  },
  "EPSG:28429": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      29305426025921304e-9,
      6040257065872187e-9,
      29613477973776083e-9,
      7793108820650335e-9
    ]
  },
  "EPSG:28430": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      30341042216920733e-9,
      6841708934015177e-9,
      30605751281453803e-9,
      7949145415708783e-9
    ]
  },
  "EPSG:28431": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      31355082732605718e-9,
      7142417650495278e-9,
      3160541867530731e-8,
      7.9558330818749685e6
    ]
  },
  "EPSG:28432": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3235429387801237e-8,
      7.1257094232059745e6,
      3258788182514807e-8,
      7455992844597268e-9
    ]
  },
  "EPSG:28600": {
    proj4: "+proj=tmerc +lat_0=24.45 +lon_0=51.2166666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      146638.75328730507,
      311178.5404459303,
      246310.84172649332,
      493945.5063699561
    ]
  },
  "EPSG:28991": {
    proj4: "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -154365.42672101804,
      -154115.38340260013,
      121007.32385594705,
      173324.9274066611
    ]
  },
  "EPSG:28992": {
    proj4: "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      634.5732789819594,
      308884.6165973999,
      276007.32385594706,
      636324.9274066611
    ]
  },
  "EPSG:29101": {
    proj4: "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      3201750187381406e-9,
      5862700919144396e-9,
      8171167615166185e-9,
      10875926387243846e-9
    ]
  },
  "EPSG:29168": {
    proj4: "+proj=utm +zone=18 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23870585795,
      0,
      826337.017961397,
      1.3626606091024703e6
    ]
  },
  "EPSG:29169": {
    proj4: "+proj=utm +zone=19 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      166020.23870585655,
      0,
      826075.0368153994,
      1.3859118892446614e6
    ]
  },
  "EPSG:29170": {
    proj4: "+proj=utm +zone=20 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      166040.97295406775,
      70837.22918494209,
      828708.2910157174,
      1243097763406569e-9
    ]
  },
  "EPSG:29171": {
    proj4: "+proj=utm +zone=21 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      166090.72131873143,
      130606.23613940562,
      830242.5361118754,
      951926.7684502241
    ]
  },
  "EPSG:29172": {
    proj4: "+proj=utm +zone=22 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      166163.10226443363,
      185948.05803984302,
      982034.6866594948,
      644058.8892491579
    ]
  },
  "EPSG:29187": {
    proj4: "+proj=utm +zone=17 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      455140.04485346994,
      883595455147129e-8,
      833979.7612941435,
      1e7
    ]
  },
  "EPSG:29188": {
    proj4: "+proj=utm +zone=18 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      263553.11165354843,
      501265310190476e-8,
      835094.0574695112,
      1e7
    ]
  },
  "EPSG:29189": {
    proj4: "+proj=utm +zone=19 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      263553.1116535474,
      501265310190476e-8,
      834859.3035863107,
      10237971750302069e-9
    ]
  },
  "EPSG:29190": {
    proj4: "+proj=utm +zone=20 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      263553.1116535474,
      501265310190476e-8,
      833679.0511299483,
      1058442434204458e-8
    ]
  },
  "EPSG:29191": {
    proj4: "+proj=utm +zone=21 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      239869.6889056933,
      5688916105551452e-9,
      834061.4787920921,
      10499193026788488e-9
    ]
  },
  "EPSG:29192": {
    proj4: "+proj=utm +zone=22 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      228589.85241228988,
      6044052708182522e-9,
      832579.8155508627,
      10779244851141386e-9
    ]
  },
  "EPSG:29193": {
    proj4: "+proj=utm +zone=23 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      221292.72233677725,
      6289238468774924e-9,
      832648.4187113973,
      10567815516865943e-9
    ]
  },
  "EPSG:29194": {
    proj4: "+proj=utm +zone=24 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      200577.6810514102,
      7082063449815907e-9,
      833952.0414790213,
      10081905554595917e-9
    ]
  },
  "EPSG:29195": {
    proj4: "+proj=utm +zone=25 +south +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      194301.12021194678,
      7364675214398226e-9,
      834202.7501274353,
      10463772616500929e-9
    ]
  },
  "EPSG:29220": {
    proj4: "+proj=utm +zone=20 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      598811.7771203218,
      4201146290232664e-9,
      711382.1505160977,
      4350193367924839e-9
    ]
  },
  "EPSG:29221": {
    proj4: "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      296411.2321372602,
      4.1778829912110073e6,
      458014.1492131215,
      4335431110606535e-9
    ]
  },
  "EPSG:29333": {
    proj4: "+proj=utm +zone=33 +south +ellps=bess_nam +units=m +no_defs +type=crs",
    projected_bounds: [
      -148421.09384899295,
      659103043484669e-8,
      655205.876453022,
      8093466987565374e-9
    ]
  },
  "EPSG:29371": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=11 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      -69678.58823395813,
      -383990.5662491244,
      -106392.81597843315,
      -536565.7293511863
    ]
  },
  "EPSG:29373": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=13 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      103326.07120955797,
      -10735.509107507352,
      -107571.25218356657,
      -558694.8737285697
    ]
  },
  "EPSG:29375": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=15 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      98079.27372788664,
      698222.9341353219,
      -106260.9442195158,
      -511110.4257588195
    ]
  },
  "EPSG:29377": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=17 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      98564.97801503909,
      756969.2184082355,
      -107323.64425366599,
      -511104.85716158064
    ]
  },
  "EPSG:29379": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      97458.14085307917,
      772477.4113336426,
      -106260.94421951547,
      -511110.4257588195
    ]
  },
  "EPSG:29381": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      104279.12388971767,
      1451.6694664233428,
      -105986.16689988966,
      -459091.299855434
    ]
  },
  "EPSG:29383": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      106656.67771974049,
      -388246.97093669133,
      -106179.83946859665,
      -495615.61655936437
    ]
  },
  "EPSG:29385": {
    proj4: "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs +type=crs",
    projected_bounds: [
      105788.99272633748,
      -422565.7910169069,
      -28675.283060698326,
      -501407.4834106862
    ]
  },
  "EPSG:29701": {
    proj4: "+proj=labrd +lat_0=-18.9 +lon_0=44.1 +azi=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      72493.06135965226,
      50556.64594483131,
      849612.0449461424,
      157106710563457e-8
    ]
  },
  "EPSG:29702": {
    proj4: "+proj=omerc +lat_0=-18.9 +lonc=44.1 +alpha=18.9 +gamma=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      72494.12466691766,
      50556.24758723157,
      849611.0013976712,
      1.5710685055694287e6
    ]
  },
  "EPSG:29738": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      253999.63363577647,
      705655976675038e-8,
      825471.71427285,
      8560929559097284e-9
    ]
  },
  "EPSG:29739": {
    proj4: "+proj=utm +zone=39 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      195258.19931739202,
      7319213877328603e-9,
      503269.5875608364,
      8707710204121413e-9
    ]
  },
  "EPSG:29849": {
    proj4: "+proj=utm +zone=49 +ellps=evrstSS +units=m +no_defs +type=crs",
    projected_bounds: [
      311963.14908120653,
      93984.75232640581,
      831188.8986375392,
      815703.28480399
    ]
  },
  "EPSG:29850": {
    proj4: "+proj=utm +zone=50 +ellps=evrstSS +units=m +no_defs +type=crs",
    projected_bounds: [
      166168.85740724724,
      158264.7655599969,
      787905.1207834139,
      848628.1611694815
    ]
  },
  "EPSG:29871": {
    proj4: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.87146304 +y_0=442857.653094361 +ellps=evrstSS +to_meter=20.1167651215526 +no_defs +type=crs",
    projected_bounds: [
      -2077.289056704051,
      4672.229598377126,
      54580.964318908394,
      42357.45751544564
    ]
  },
  "EPSG:29872": {
    proj4: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.872743198 +y_0=442857.654557398 +ellps=evrstSS +to_meter=0.304799471538676 +no_defs +type=crs",
    projected_bounds: [
      -137101.0735424667,
      308367.1582928885,
      3602343649247951e-9,
      2.7955922008194085e6
    ]
  },
  "EPSG:29873": {
    proj4: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.87 +y_0=442857.65 +ellps=evrstSS +units=m +no_defs +type=crs",
    projected_bounds: [
      -41788.33750632696,
      93990.14233015769,
      1097992437848283e-9,
      852095.0208900018
    ]
  },
  "EPSG:29874": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=2000000 +y_0=5000000 +ellps=evrstSS +units=m +no_defs +type=crs",
    projected_bounds: [
      1.9838076141949086e6,
      5093988319590558e-9,
      2666609074534891e-9,
      5557010878720759e-9
    ]
  },
  "EPSG:29901": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1 +x_0=200000 +y_0=250000 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      188186.2089077919,
      301208.417299364,
      368658.9435923433,
      460245.5749067642
    ]
  },
  "EPSG:29902": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +units=m +no_defs +type=crs",
    projected_bounds: [
      21835.06672282543,
      18340.056451573386,
      331024.4361112179,
      466765.28595362336
    ]
  },
  "EPSG:29903": {
    proj4: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +units=m +no_defs +type=crs",
    projected_bounds: [
      21835.06672282543,
      18340.056451573386,
      368361.0744682939,
      468035.0471324646
    ]
  },
  "EPSG:30161": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -132033.91872300944,
      -668718.8696378581,
      87895.12440944317,
      193380.95999226233
    ]
  },
  "EPSG:30162": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -119405.02812716771,
      -311967.49493306415,
      96996.18581094994,
      110278.56651897756
    ]
  },
  "EPSG:30163": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -125722.09028436581,
      -252060.38734894595,
      118718.66340649538,
      42970.33278479414
    ]
  },
  "EPSG:30164": {
    proj4: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -145332.53862383575,
      -33310.61093859756,
      120359.57919520237,
      161575.74810193558
    ]
  },
  "EPSG:30165": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -110978.77789577241,
      -206764.54656153312,
      102839.56534728216,
      -31575.23984038069
    ]
  },
  "EPSG:30166": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -106032.89112534888,
      -287791.39444127056,
      88870.50337081279,
      37064.81554837759
    ]
  },
  "EPSG:30167": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -86913.83870046136,
      -164867.61173104096,
      59463.50628253566,
      175515.36046684088
    ]
  },
  "EPSG:30168": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -108298.40320400993,
      -161314.8029330276,
      122837.80510873058,
      287219.9208294001
    ]
  },
  "EPSG:30169": {
    proj4: "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -139220.88866601876,
      -740909.0684984893,
      112140.84498587539,
      220458.9086127042
    ]
  },
  "EPSG:30170": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -118396.27564755312,
      -251097.608898054,
      108944.41391205204,
      176246.69504163603
    ]
  },
  "EPSG:30171": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -76151.85994171294,
      -295028.21039191383,
      97968.6783169276,
      -63717.17861382356
    ]
  },
  "EPSG:30172": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -112388.30616118202,
      -204585.940762442,
      106196.01761633677,
      171999.5982966178
    ]
  },
  "EPSG:30173": {
    proj4: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -136123.5023538958,
      -235274.73302137945,
      129029.79084695087,
      45713.54382359679
    ]
  },
  "EPSG:30174": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -80958.53602263333,
      -147069.06338646874,
      32512.156822464145,
      199446.98649740004
    ]
  },
  "EPSG:30175": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -87070.7527742629,
      2505.326612701362,
      89383.09919401155,
      101120.86319798998
    ]
  },
  "EPSG:30176": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -119047.6331632558,
      -223222.01099510773,
      152486.82271200366,
      -116555.68585715666
    ]
  },
  "EPSG:30177": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      12169.531980159729,
      -177200.5285542646,
      38033.39310708503,
      1162.966544729439
    ]
  },
  "EPSG:30178": {
    proj4: "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2087.5546112180646,
      40953.40350178606,
      16688.58750081702,
      53137.06028150547
    ]
  },
  "EPSG:30179": {
    proj4: "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -9140.037024124578,
      -197136.13132665906,
      5072.630496601505,
      -182741.9508942479
    ]
  },
  "EPSG:30200": {
    proj4: "+proj=cass +lat_0=10.4416666666667 +lon_0=-61.3333333333333 +x_0=86501.46392052 +y_0=65379.0134283 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.201166195164 +no_defs +type=crs",
    projected_bounds: [
      17379.54044762126,
      -10830.914904860443,
      1.1531027304902112e6,
      914083.6736202679
    ]
  },
  "EPSG:30339": {
    proj4: "+proj=utm +zone=39 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      557491.8235908385,
      2.5170880362778683e6,
      805485.0355069224,
      2.6929913614928704e6
    ]
  },
  "EPSG:30340": {
    proj4: "+proj=utm +zone=40 +ellps=helmert +units=m +no_defs +type=crs",
    projected_bounds: [
      190592.36673610762,
      2.5057179472274133e6,
      402384.7302073735,
      2.8029801295939656e6
    ]
  },
  "EPSG:30491": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      49122.746888496855,
      160541.94865968436,
      1.0273585295254983e6,
      442534.87386089267
    ]
  },
  "EPSG:30492": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -33639.34279612091,
      169220.7531926512,
      1.0853346190992384e6,
      468731.29259134916
    ]
  },
  "EPSG:30493": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      49122.746888496855,
      160541.94865968436,
      1.0273585295254983e6,
      442534.87386089267
    ]
  },
  "EPSG:30494": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -33639.34279612091,
      169220.7531926512,
      1.0853346190992384e6,
      468731.29259134916
    ]
  },
  "EPSG:30729": {
    proj4: "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      533101.7962499268,
      2845592473141346e-9,
      789853.5360185513,
      3.3056851183297914e6
    ]
  },
  "EPSG:30730": {
    proj4: "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      189837.13294954726,
      2415719645745349e-9,
      766937.1038858992,
      4099898585271391e-9
    ]
  },
  "EPSG:30731": {
    proj4: "+proj=utm +zone=31 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      184071.76359617081,
      2.1000171457189852e6,
      761519.3187120941,
      4295259572719449e-9
    ]
  },
  "EPSG:30732": {
    proj4: "+proj=utm +zone=32 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      185279.5744015306,
      2.1697975054214527e6,
      759672.353946501,
      4298532436218602e-9
    ]
  },
  "EPSG:30791": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      49257.7490529872,
      160631.9517039888,
      1027493527254038e-9,
      442624.87128697627
    ]
  },
  "EPSG:30792": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +a=6378249.145 +rf=293.465 +units=m +no_defs +type=crs",
    projected_bounds: [
      -121882.1031281664,
      118949.87085124984,
      1097362489280874e-9,
      469557.84420683136
    ]
  },
  "EPSG:31028": {
    proj4: "+proj=utm +zone=28 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -71687.13422494254,
      1.1808865025335746e6,
      888292.6957839625,
      1.8497538770428705e6
    ]
  },
  "EPSG:31121": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      379872.0468735316,
      202309.03517251558,
      977013.452162097,
      1036498534679255e-9
    ]
  },
  "EPSG:31154": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-54 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      139710.06667066365,
      591205.8231664547,
      647159.0817483994,
      1.0338388100690698e6
    ]
  },
  "EPSG:31170": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-55.6833333333333 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      233357.48275064322,
      202451.04571190223,
      691842.326276339,
      670150.9107743384
    ]
  },
  "EPSG:31171": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-55.6833333333333 +k=0.9999 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      233277.45798556233,
      202511.80532946286,
      691899.9020045132,
      670352.0364978603
    ]
  },
  "EPSG:31251": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -61352.448083172465,
      181464.5963655766,
      113265.39074661817,
      275627.38666390534
    ]
  },
  "EPSG:31252": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -115596.50643239795,
      141123.93113699835,
      110693.10098360547,
      406816.7739900369
    ]
  },
  "EPSG:31253": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -115258.07854602601,
      158907.34758698754,
      61188.134200293054,
      431633.9601324396
    ]
  },
  "EPSG:31254": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -61352.44808316992,
      181464.5963655766,
      113265.3907466208,
      275627.38666390534
    ]
  },
  "EPSG:31255": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -115596.50643239536,
      141123.93113699835,
      110693.10098360802,
      406816.7739900369
    ]
  },
  "EPSG:31256": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -115258.07854602307,
      158907.34758698754,
      61188.13420029538,
      431633.9601324396
    ]
  },
  "EPSG:31257": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=150000 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      88647.55191683008,
      181464.5963655766,
      263265.39074662083,
      275627.38666390534
    ]
  },
  "EPSG:31258": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=450000 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      334403.49356760463,
      141123.93113699835,
      560693.100983608,
      406816.7739900369
    ]
  },
  "EPSG:31259": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=750000 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      634741.9214539769,
      158907.34758698754,
      811188.1342002954,
      431633.9601324396
    ]
  },
  "EPSG:31281": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -61352.448083172465,
      5181464596365577e-9,
      113265.39074661817,
      5275627386663905e-9
    ]
  },
  "EPSG:31282": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -115596.50643239795,
      5141123931136998e-9,
      110693.10098360547,
      5406816773990037e-9
    ]
  },
  "EPSG:31283": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      -115258.07854602601,
      5158907347586988e-9,
      61188.134200293054,
      543163396013244e-8
    ]
  },
  "EPSG:31284": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      88647.55191683008,
      5181464596365577e-9,
      263265.39074662083,
      5275627386663905e-9
    ]
  },
  "EPSG:31285": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      334403.49356760463,
      5141123931136998e-9,
      560693.100983608,
      5406816773990037e-9
    ]
  },
  "EPSG:31286": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      634741.9214539769,
      5158907347586988e-9,
      811188.1342002954,
      543163396013244e-8
    ]
  },
  "EPSG:31287": {
    proj4: "+proj=lcc +lat_0=47.5 +lon_0=13.3333333333333 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      107709.54832623003,
      284915.76531914284,
      680477.8034656523,
      575885.6025930198
    ]
  },
  "EPSG:31288": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      88647.55191682754,
      5181464596365577e-9,
      263265.39074661816,
      5275627386663905e-9
    ]
  },
  "EPSG:31289": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      334403.49356760207,
      5141123931136998e-9,
      560693.1009836055,
      5406816773990037e-9
    ]
  },
  "EPSG:31290": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs +type=crs",
    projected_bounds: [
      634741.921453974,
      5158907347586988e-9,
      811188.1342002931,
      543163396013244e-8
    ]
  },
  "EPSG:31300": {
    proj4: "+proj=lcc +lat_0=90 +lon_0=4.35693972222222 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      15486.04643881679,
      22523.21180167608,
      291841.5356354942,
      246386.9996657241
    ]
  },
  "EPSG:31370": {
    proj4: "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      14722.20244943403,
      22542.41597773414,
      291109.4871510995,
      246366.94720796496
    ]
  },
  "EPSG:31466": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2489779772762066e-9,
      5441313975742755e-9,
      2.5987955103882626e6,
      5965196188600703e-9
    ]
  },
  "EPSG:31467": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3386506780049417e-9,
      5237821997001279e-9,
      3.5963990407126797e6,
      6107658748655212e-9
    ]
  },
  "EPSG:31468": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4386763613430334e-9,
      5251161408309198e-9,
      4597598293959737e-9,
      6052011414167817e-9
    ]
  },
  "EPSG:31469": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5389184701626548e-9,
      5375675134883275e-9,
      5415097871261377e-9,
      5427497276098792e-9
    ]
  },
  "EPSG:31528": {
    proj4: "+proj=utm +zone=28 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      485711.29208523344,
      995869.7447232855,
      825877.9313571809,
      1403496919346865e-9
    ]
  },
  "EPSG:31529": {
    proj4: "+proj=utm +zone=29 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      168628.94148984103,
      795766.7007880502,
      646693.0584611611,
      1.3831998508691427e6
    ]
  },
  "EPSG:31600": {
    proj4: "+proj=sterea +lat_0=45.9 +lon_0=25.3924658888889 +k=0.9996667 +x_0=500000 +y_0=500000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      85816.7080953045,
      259747.09854579714,
      822690.7880320405,
      772409.6891571537
    ]
  },
  "EPSG:31838": {
    proj4: "+proj=utm +zone=38 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      650679.3185646831,
      3.1568827797982646e6,
      789147.7888576589,
      3.3325555685076807e6
    ]
  },
  "EPSG:31839": {
    proj4: "+proj=utm +zone=39 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      206442.51291637035,
      3.1606972866608375e6,
      257010.00083297386,
      332589382435005e-8
    ]
  },
  "EPSG:31901": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      478598.58184901346,
      3.2281316688329964e6,
      515522.2314005951,
      3.2591577498151176e6
    ]
  },
  "EPSG:31965": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177364.0638281554,
      1.6616210545953047e6,
      781183.1502370356,
      3624228096601195e-9
    ]
  },
  "EPSG:31966": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177484.6212754076,
      1670480022141903e-9,
      782588.4274016112,
      3.5743159534130353e6
    ]
  },
  "EPSG:31967": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      175966.32469811483,
      1.5553168965950068e6,
      784068.1618622246,
      3521079182476001e-9
    ]
  },
  "EPSG:31968": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      172563.0511147608,
      1361560894140644e-9,
      789960.1323065503,
      3.3015080496930014e6
    ]
  },
  "EPSG:31969": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053266,
      0,
      800318.0748014629,
      2879132533539659e-9
    ]
  },
  "EPSG:31970": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      801904.915671817,
      2853663032588854e-9
    ]
  },
  "EPSG:31971": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053405,
      0,
      814829.620932301,
      2.1633375227492237e6
    ]
  },
  "EPSG:31972": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      822590.800564843,
      1.6649431621321107e6
    ]
  },
  "EPSG:31973": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053405,
      0,
      821669.5980448748,
      1.7313866614760826e6
    ]
  },
  "EPSG:31974": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166042.17725734005,
      70836.98526620852,
      820939.8420173798,
      1.8543302830506135e6
    ]
  },
  "EPSG:31975": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166091.9254506764,
      130605.78641075645,
      826483.5827200869,
      1.3493696283580842e6
    ]
  },
  "EPSG:31976": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      830765.45807146,
      1.0227821239959593e6
    ]
  },
  "EPSG:31977": {
    proj4: "+proj=utm +zone=17 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      315109.28508458706,
      3739799275683917e-9,
      833978.556919466,
      1e7
    ]
  },
  "EPSG:31978": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      835092.8490763677,
      1e7
    ]
  },
  "EPSG:31979": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      833744.5873691345,
      1023796873786637e-8
    ]
  },
  "EPSG:31980": {
    proj4: "+proj=utm +zone=20 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324640.62108894385,
      3523957436868459e-9,
      832568.2781452977,
      10584416969082829e-9
    ]
  },
  "EPSG:31981": {
    proj4: "+proj=utm +zone=21 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      262814.1438700359,
      5032666010999744e-9,
      832949.428130513,
      10499186722129581e-9
    ]
  },
  "EPSG:31982": {
    proj4: "+proj=utm +zone=22 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      304228.83610229613,
      3992293664306242e-9,
      832578.6158208756,
      1077924216697297e-8
    ]
  },
  "EPSG:31983": {
    proj4: "+proj=utm +zone=23 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221293.73426490132,
      6289251342124958e-9,
      832647.2189229012,
      10567813561306134e-9
    ]
  },
  "EPSG:31984": {
    proj4: "+proj=utm +zone=24 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      200578.76557876903,
      7082073545158768e-9,
      833950.8371998062,
      10081905272564575e-9
    ]
  },
  "EPSG:31985": {
    proj4: "+proj=utm +zone=25 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194302.2266277711,
      7.3646843242842145e6,
      834201.5448043668,
      10463771019364454e-9
    ]
  },
  "EPSG:31986": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166062.44532644347,
      99614.5399973832,
      821872.1784316807,
      1.7169903498023995e6
    ]
  },
  "EPSG:31987": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      822590.800564843,
      1.6649431621321107e6
    ]
  },
  "EPSG:31988": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053405,
      0,
      821669.5980448748,
      1.7313866614760826e6
    ]
  },
  "EPSG:31989": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053405,
      0,
      819872.7768213619,
      1.8543141392262988e6
    ]
  },
  "EPSG:31990": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.4430805369,
      0,
      828199.053507757,
      1.1844049928306255e6
    ]
  },
  "EPSG:31991": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      829665.6082578637,
      1.0227728529955739e6
    ]
  },
  "EPSG:31992": {
    proj4: "+proj=utm +zone=17 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      315109.28508458706,
      3739799275683917e-9,
      1.1451821560420063e6,
      10161095967791641e-9
    ]
  },
  "EPSG:31993": {
    proj4: "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329483.0627863826,
      341601845093101e-8,
      835092.8490763677,
      1e7
    ]
  },
  "EPSG:31994": {
    proj4: "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332048.96762109303,
      3359262289919519e-9,
      833978.5569194646,
      1e7
    ]
  },
  "EPSG:31995": {
    proj4: "+proj=utm +zone=20 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324640.62108894385,
      3523957436868459e-9,
      833978.556919466,
      1e7
    ]
  },
  "EPSG:31996": {
    proj4: "+proj=utm +zone=21 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      262814.1438700359,
      5032666010999744e-9,
      833978.5569194674,
      1e7
    ]
  },
  "EPSG:31997": {
    proj4: "+proj=utm +zone=22 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      243713.45696287169,
      5573481770961944e-9,
      833978.556919466,
      1e7
    ]
  },
  "EPSG:31998": {
    proj4: "+proj=utm +zone=23 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221293.73426490132,
      6289251342124958e-9,
      833978.5569194653,
      1e7
    ]
  },
  "EPSG:31999": {
    proj4: "+proj=utm +zone=24 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      200578.76557876903,
      7082073545158768e-9,
      833978.5569194646,
      1e7
    ]
  },
  "EPSG:32000": {
    proj4: "+proj=utm +zone=25 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      186292.67844831588,
      7773520440370405e-9,
      833978.5569194667,
      1e7
    ]
  },
  "EPSG:32001": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-109.5 +lat_1=48.7166666666667 +lat_2=47.85 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      375240.94104687654,
      219187.30552105233,
      3.3096449378927895e6,
      779889.9519883218
    ]
  },
  "EPSG:32002": {
    proj4: "+proj=lcc +lat_0=45.8333333333333 +lon_0=-109.5 +lat_1=47.8833333333333 +lat_2=46.45 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      339965.48607763083,
      192561.81188862544,
      3329307777566392e-9,
      931582.0298093953
    ]
  },
  "EPSG:32003": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-109.5 +lat_1=46.4 +lat_2=44.8666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      674609.5632921896,
      169596.11629164938,
      3.3650512828031625e6,
      1.0930531950307307e6
    ]
  },
  "EPSG:32005": {
    proj4: "+proj=lcc +lat_0=41.3333333333333 +lon_0=-100 +lat_1=41.85 +lat_2=42.8166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      891411.7227145071,
      152792.6289964796,
      3050964836018746e-9,
      635298.0740596576
    ]
  },
  "EPSG:32006": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-99.5 +lat_1=40.2833333333333 +lat_2=41.7166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      722872.0242916393,
      151149.1747661075,
      3.1412170219135536e6,
      881203.1764677381
    ]
  },
  "EPSG:32007": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      72937.47617998168,
      90391.52908744503,
      922436.9712993556,
      2643897280066194e-9
    ]
  },
  "EPSG:32008": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      49667.262327233824,
      458473.9618862136,
      963035.1634200342,
      2280170214248441e-9
    ]
  },
  "EPSG:32009": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      86320.07708422313,
      803862.4927151859,
      933332.9588587796,
      2.6441062389456895e6
    ]
  },
  "EPSG:32010": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      259683.74711351126,
      70521.9807880017,
      766611.6191426167,
      1.0259851349732837e6
    ]
  },
  "EPSG:32011": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.6666666666667 +k=0.999975 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.7341477142032443e6,
      14702.849531532029,
      2215841359666418e-9,
      921387.2022384773
    ]
  },
  "EPSG:32012": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      70288.15080922702,
      366433.4594289336,
      892423.8239807878,
      2186011689779072e-9
    ]
  },
  "EPSG:32013": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      40280.289264136576,
      286778.3443018068,
      914825.5543680387,
      2.1863200743415602e6
    ]
  },
  "EPSG:32014": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      117179.0763901496,
      122104.45825851348,
      942102.5635325643,
      2186779465933301e-9
    ]
  },
  "EPSG:32015": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-74.3333333333333 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      74952.74312664036,
      324310.14072244713,
      785231.6197995875,
      1.8313446348552245e6
    ]
  },
  "EPSG:32016": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      182750.57079750492,
      727159.3906953707,
      903232.9803865578,
      1.6107647687939282e6
    ]
  },
  "EPSG:32017": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      177331.7017804235,
      727232.063065507,
      823798.1619159481,
      1.3286696107013302e6
    ]
  },
  "EPSG:32019": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381696.78444763535,
      72522.3523581627,
      3.0626451740712696e6,
      1053024370153245e-9
    ]
  },
  "EPSG:32020": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1112068378485461e-9,
      75322.09538718358,
      2880701264614482e-9,
      754235.1122400049
    ]
  },
  "EPSG:32021": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0970306805243506e6,
      116460.33634115334,
      2.9700558289094013e6,
      813403.5917400424
    ]
  },
  "EPSG:32022": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3537533578936094e6,
      166423.36364717962,
      2.5381229368223655e6,
      976534.3293316192
    ]
  },
  "EPSG:32023": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1332222682192001e-9,
      154284.89429219565,
      2501597115769984e-9,
      864578.6365456333
    ]
  },
  "EPSG:32024": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      508095.686082296,
      136681.69632113812,
      3.0452508321396257e6,
      750953.02661138
    ]
  },
  "EPSG:32025": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3912112542592078e6,
      110312.86782438199,
      3064684661221981e-9,
      832854.6729253904
    ]
  },
  "EPSG:32026": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=44.3333333333333 +lat_2=46 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0339619708762374e6,
      125315.47694325667,
      3019332450559808e-9,
      971003.4879304809
    ]
  },
  "EPSG:32027": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=42.3333333333333 +lat_2=44 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      885806.5929577395,
      141539.91905059284,
      2.9385341558844526e6,
      1074796417132354e-9
    ]
  },
  "EPSG:32028": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2280131289914662e6,
      170268.5888573729,
      2.8219940574778686e6,
      875620.503404442
    ]
  },
  "EPSG:32030": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.9999938 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      403437.6948456607,
      17201.871520183024,
      613985.576005104,
      341587.87282510416
    ]
  },
  "EPSG:32031": {
    proj4: "+proj=lcc +lat_0=33 +lon_0=-81 +lat_1=33.7666666666667 +lat_2=34.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2801544669497083e6,
      175716.01972932855,
      2.7407657739106547e6,
      813275.9499265404
    ]
  },
  "EPSG:32033": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.3333333333333 +lat_2=33.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1680785430888322e-9,
      80325.24258256696,
      2.6216609830723978e6,
      776133.926603337
    ]
  },
  "EPSG:32034": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      932032.2972154706,
      138671.09429058712,
      290290243531894e-8,
      791537.6297194924
    ]
  },
  "EPSG:32035": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      995026.8596441835,
      76020.46391598557,
      3013267653926378e-9,
      919288.371319387
    ]
  },
  "EPSG:32037": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1537999683780678e-9,
      112734.08209652797,
      2.4439891932459255e6,
      913325.0052004158
    ]
  },
  "EPSG:32038": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-97.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      268655.1531362452,
      65254.04210828355,
      3053716567652706e-9,
      1.0775289721260974e6
    ]
  },
  "EPSG:32039": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -6145.595365390301,
      98207.65628306464,
      411125934105618e-8,
      1.0116889053835524e6
    ]
  },
  "EPSG:32040": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      60356.22174372076,
      30271.118571604868,
      3757201448389643e-9,
      1.0734033979575895e6
    ]
  },
  "EPSG:32041": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4408669731608117e6,
      63008.8164764937,
      3008225324558549e-9,
      936909.5207200467
    ]
  },
  "EPSG:32042": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2944252046061638e6,
      89278.84471072313,
      2.6687245563628706e6,
      620391.3608558236
    ]
  },
  "EPSG:32043": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2702912284543389e6,
      67486.21800538906,
      2678439743907382e-9,
      1.0098550345042654e6
    ]
  },
  "EPSG:32044": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2554959529956288e6,
      127888.65457915634,
      2703428136146992e-9,
      705966.8959306711
    ]
  },
  "EPSG:32045": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      247266.81459912163,
      81589.9881167161,
      758448.9463999838,
      923774.2736360033
    ]
  },
  "EPSG:32046": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1548984061360533e-9,
      41441.952747042924,
      2561796755010961e-9,
      659184.2646002588
    ]
  },
  "EPSG:32047": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      478827.40370613907,
      116959.09374146133,
      2.9155436642768052e6,
      724250.9365242063
    ]
  },
  "EPSG:32048": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0148030537802016e6,
      54591.063988076654,
      2.9145102074506227e6,
      770556.5267162853
    ]
  },
  "EPSG:32049": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0012744678999233e6,
      100135.00603964282,
      2879791209041619e-9,
      978056.7405827764
    ]
  },
  "EPSG:32050": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3554955136977418e6,
      102790.2695632739,
      2.4939464176232507e6,
      784387.360025793
    ]
  },
  "EPSG:32051": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5193488559193872e6,
      77080.23327101655,
      2.5528151309042154e6,
      796015.9792898285
    ]
  },
  "EPSG:32052": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2573961119319526e6,
      87662.36038186062,
      2483801087414376e-9,
      787578.5843710422
    ]
  },
  "EPSG:32053": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1239405074684505e-9,
      67009.96009405966,
      2956217051611306e-9,
      739103.7355213268
    ]
  },
  "EPSG:32054": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.6142569537451705e6,
      178256.88191990863,
      2798019522641866e-9,
      863849.4685333073
    ]
  },
  "EPSG:32055": {
    proj4: "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-105.166666666667 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      179011.66442149977,
      119946.06692808092,
      788956.1545015466,
      1.5849011800467602e6
    ]
  },
  "EPSG:32056": {
    proj4: "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-107.333333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      142221.35690088314,
      120468.70570732321,
      845009.6246724164,
      1.5857531793533422e6
    ]
  },
  "EPSG:32057": {
    proj4: "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-108.75 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -137525.23924798053,
      126249.37049326005,
      823469.9098491519,
      158541276688075e-8
    ]
  },
  "EPSG:32058": {
    proj4: "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-110.083333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      230585.50573963497,
      119325.04882893641,
      771624.4285558473,
      1.4607049763306861e6
    ]
  },
  "EPSG:32064": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      653820.7995198874,
      938347603866361e-8,
      2.3914189090116965e6,
      17825006158797484e-9
    ]
  },
  "EPSG:32065": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      648650.9815757504,
      9303544657212213e-9,
      2.3881227950026686e6,
      17959988363217387e-9
    ]
  },
  "EPSG:32066": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      635307.4763576725,
      8699971018466098e-9,
      2391912995715095e-9,
      17573009168194335e-9
    ]
  },
  "EPSG:32067": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      607393.5529570323,
      8649659104906635e-9,
      2403264140839985e-9,
      16773812414940566e-9
    ]
  },
  "EPSG:32081": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      189716.5855042385,
      5158697272569026e-9,
      337773.0782454615,
      5527945891154754e-9
    ]
  },
  "EPSG:32082": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      190253.5540234124,
      5186482191655338e-9,
      401397.4619889333,
      6065154557711318e-9
    ]
  },
  "EPSG:32083": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      230906.3876995892,
      5262554975422935e-9,
      375616.67245872493,
      5600610864085874e-9
    ]
  },
  "EPSG:32084": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      201716.9780689575,
      5763618318646697e-9,
      391142.3199790076,
      6533847127879599e-9
    ]
  },
  "EPSG:32085": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      200763.00696945377,
      5716893129176053e-9,
      387097.6510938411,
      6712059810142032e-9
    ]
  },
  "EPSG:32086": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      283471.2240400851,
      5768157960763376e-9,
      399899.60786146176,
      6135274030517294e-9
    ]
  },
  "EPSG:32098": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893309.9101174306,
      181363.65331308072,
      586918.7244936543,
      2.1127788850475326e6
    ]
  },
  "EPSG:32099": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1300324940542686e6,
      1.1665351138047883e6,
      2.7961514386471543e6,
      2689561672166306e-9
    ]
  },
  "EPSG:32100": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      76530.54027482809,
      33084.524119235604,
      999117.0470033675,
      542896.2532425779
    ]
  },
  "EPSG:32104": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      153376.2252400727,
      25535.919165928193,
      882993.4575054274,
      363144.7550580989
    ]
  },
  "EPSG:32107": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      69754.74639531817,
      802755247237993e-8,
      328683.6587060269,
      880586542636728e-8
    ]
  },
  "EPSG:32108": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      362659.33828742534,
      6139743768849751e-9,
      641055.3972230253,
      6694999823411577e-9
    ]
  },
  "EPSG:32109": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      673826.6301758505,
      4245017139322905e-9,
      931997.4907157569,
      4.8059263308652975e6
    ]
  },
  "EPSG:32110": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      226793.8024079331,
      21492.387739553997,
      381293.173427484,
      312732.6717501454
    ]
  },
  "EPSG:32111": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      54545.12015456795,
      4645.126015017602,
      201873.90102511132,
      280709.69043490384
    ]
  },
  "EPSG:32112": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      33975.77074362352,
      111708.32825589125,
      284564.5241670381,
      666319.758960204
    ]
  },
  "EPSG:32113": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      359824.2791681125,
      87428.3980117214,
      625497.4318649578,
      666399.5233026792
    ]
  },
  "EPSG:32114": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      713259.0787200994,
      37234.66266182869,
      964697.4631390541,
      666551.8767344605
    ]
  },
  "EPSG:32115": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      34535.94492432893,
      228126.12062753108,
      250090.6353354547,
      687881.3551997013
    ]
  },
  "EPSG:32116": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      153330.97415895032,
      221641.78111359302,
      372921.93601385155,
      490979.04527605977
    ]
  },
  "EPSG:32117": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      251673.76576198317,
      221664.55284669463,
      448704.434264811,
      404996.19022632844
    ]
  },
  "EPSG:32118": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      277950.22920969536,
      33716.39444708275,
      484240.9609220226,
      128170.64580043124
    ]
  },
  "EPSG:32119": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      116361.13496227108,
      22119.88887843388,
      933520.6710072559,
      320979.26197346306
    ]
  },
  "EPSG:32120": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      329319.5931117032,
      22953.606831219873,
      868402.9550716814,
      229887.8527663513
    ]
  },
  "EPSG:32121": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      324736.07413660234,
      35492.61573469327,
      895638.4324845031,
      247922.52117242807
    ]
  },
  "EPSG:32122": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      403035.4105968764,
      50729.9881009595,
      764034.121937581,
      297653.7686659716
    ]
  },
  "EPSG:32123": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      396472.80539090245,
      47032.74485349966,
      752900.9644348032,
      263532.0000815143
    ]
  },
  "EPSG:32124": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      145234.1114682252,
      41670.65752654181,
      918564.8787926256,
      228901.9813547924
    ]
  },
  "EPSG:32125": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      414409.71996951895,
      33637.59674371423,
      924488.3684600198,
      253870.04933969502
    ]
  },
  "EPSG:32126": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      220546260644754e-8,
      38177.19394785736,
      2.8106066110863457e6,
      295944.2058068297
    ]
  },
  "EPSG:32127": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      1160304687469061e-9,
      43124.56959847481,
      1785979111173056e-9,
      327582.564817976
    ]
  },
  "EPSG:32128": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      364722.69794594496,
      51900.29667448759,
      850571.8392683543,
      266893.21477785433
    ]
  },
  "EPSG:32129": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      361633.13518682023,
      45575.569319858565,
      854195.2283628277,
      209415.98457540976
    ]
  },
  "EPSG:32130": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      70610.77827680032,
      5241.624167031077,
      134786.23705289746,
      104115.19509468034
    ]
  },
  "EPSG:32133": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      386694.5942843487,
      26576.309440707257,
      835428.2312511974,
      377206.79542095796
    ]
  },
  "EPSG:32134": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      274445.55115673057,
      42263.33611194055,
      875171.275386896,
      241258.5494374619
    ]
  },
  "EPSG:32135": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      293645.5414990948,
      23168.18099115532,
      908809.9399088017,
      280198.16460002324
    ]
  },
  "EPSG:32136": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      206556.4167882325,
      80414.01570951591,
      988711.5866813468,
      269011.42753063503
    ]
  },
  "EPSG:32137": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      59141.726237106894,
      1.0343726299247856e6,
      335289.3759396124,
      1.2783945558126816e6
    ]
  },
  "EPSG:32138": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      166935.12352544628,
      2015335542194466e-9,
      1.0128529570071837e6,
      2.3319457757578273e6
    ]
  },
  "EPSG:32139": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      88485.92409938853,
      302995849409869e-8,
      1.3434805489688965e6,
      3308389707573836e-9
    ]
  },
  "EPSG:32140": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      8759.288909710362,
      4.0092582172219283e6,
      1.1020569519511203e6,
      4.3256547587438645e6
    ]
  },
  "EPSG:32141": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      129543.46292791484,
      5019245231079103e-9,
      461995.7043444619,
      5282860637212539e-9
    ]
  },
  "EPSG:32142": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      284873.76674905524,
      1.0272050082885996e6,
      703762.8414941019,
      1189089125360079e-9
    ]
  },
  "EPSG:32143": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      277517.6837629482,
      2.0205658722523483e6,
      706724.0386204798,
      2307801683101201e-9
    ]
  },
  "EPSG:32144": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      273008.07224937936,
      3038980003301329e-9,
      714340.5503610092,
      3.2151793513247273e6
    ]
  },
  "EPSG:32145": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      423006.8382807577,
      24866.35169431841,
      578802.8666454776,
      281578.89655270055
    ]
  },
  "EPSG:32146": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3625533262610403e6,
      2.0126377358033953e6,
      3671261036751879e-9,
      2.2009270598530993e6
    ]
  },
  "EPSG:32147": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0363669807438697e6,
      1035658136976271e-9,
      3779083924305619e-9,
      1.2207621363122454e6
    ]
  },
  "EPSG:32148": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      199622.13896693767,
      16618.325904665824,
      778655.8701648887,
      234845.72192574284
    ]
  },
  "EPSG:32149": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      195499.3912097729,
      30501.042787402166,
      769845.025376511,
      259212.8282079461
    ]
  },
  "EPSG:32150": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      403574.77820059075,
      31335.654182597726,
      750577.3343822454,
      239088.0765441185
    ]
  },
  "EPSG:32151": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      453513.4977037739,
      23502.170616556796,
      768516.5072083795,
      242635.52047372516
    ]
  },
  "EPSG:32152": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      373644.5392621008,
      26717.932057823346,
      747455.7457836679,
      240055.50940082088
    ]
  },
  "EPSG:32153": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      368160.8288686152,
      20423.476917061555,
      891449.2804629535,
      225280.70276785115
    ]
  },
  "EPSG:32154": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      482416.58582546015,
      54333.04951709173,
      843230.2890341961,
      263304.7487854953
    ]
  },
  "EPSG:32155": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      102113.10863394958,
      55062.47534181787,
      288024.8211402613,
      501582.3192299155
    ]
  },
  "EPSG:32156": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      290893.7234442881,
      155220.4817241857,
      505104.26743197144,
      601840.6136762074
    ]
  },
  "EPSG:32157": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      405623.04948556976,
      56981.50934947065,
      698535.2494466461,
      501735.86149144557
    ]
  },
  "EPSG:32158": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      717820.1237859536,
      154870.05021642725,
      882729.2572612413,
      563723.8222876207
    ]
  },
  "EPSG:32161": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -21637.43967722953,
      -121352.98424694478,
      464440.7222639215,
      647872.530276581
    ]
  },
  "EPSG:32164": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      653707.2060292478,
      9384135641321028e-9,
      2391315661609903e-9,
      17825713903231665e-9
    ]
  },
  "EPSG:32165": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      648590.722679033,
      9304211798441099e-9,
      2388111914508246e-9,
      17960732599222504e-9
    ]
  },
  "EPSG:32166": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      635288.6537215632,
      870063750377192e-8,
      2.3919187495693793e6,
      17573728479022656e-9
    ]
  },
  "EPSG:32167": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      607444.6217853187,
      8650313672959328e-9,
      2.4032784231566144e6,
      16774561762056189e-9
    ]
  },
  "EPSG:32181": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      189795.03082335438,
      5158911087584208e-9,
      337851.86875655863,
      5528160574820434e-9
    ]
  },
  "EPSG:32182": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      190324.464420336,
      5186698934950825e-9,
      401468.9526759774,
      6065373731464224e-9
    ]
  },
  "EPSG:32183": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      191797.0588894946,
      5263399287544292e-9,
      393531.0745527109,
      6139812811649809e-9
    ]
  },
  "EPSG:32184": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      191069.35639250712,
      5225603830010193e-9,
      391199.5989891613,
      6534072854250059e-9
    ]
  },
  "EPSG:32185": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      192766.35373007116,
      5313425913117096e-9,
      387169.92260410154,
      6712276997392e-6
    ]
  },
  "EPSG:32186": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      191389.90588198055,
      5242278037802561e-9,
      390999.70872502594,
      6542982088926093e-9
    ]
  },
  "EPSG:32187": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      186562.1302475625,
      4986651818248523e-9,
      383899.1959539077,
      6854869249580907e-9
    ]
  },
  "EPSG:32188": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      186500.4094665522,
      4983318199325804e-9,
      382015.8443033126,
      6.9362026173374085e6
    ]
  },
  "EPSG:32189": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      183757.00091203628,
      4833322301442292e-9,
      381705.0283408768,
      6949573253538423e-9
    ]
  },
  "EPSG:32190": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      181042.0392854039,
      4681138104747794e-9,
      382222.86432708433,
      6927288979642742e-9
    ]
  },
  "EPSG:32191": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      213203.30702221807,
      4615106862634651e-9,
      420982.88539797766,
      509667043507393e-8
    ]
  },
  "EPSG:32192": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      188617.11460202234,
      509667043507393e-8,
      400275.84726700257,
      6121023073271519e-9
    ]
  },
  "EPSG:32193": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      188617.11460202234,
      509667043507393e-8,
      399364.16796375834,
      6163319435800816e-9
    ]
  },
  "EPSG:32194": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      191090.70195746733,
      5226715431148183e-9,
      396677.17448948184,
      6286883372403416e-9
    ]
  },
  "EPSG:32195": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      192809.59554090386,
      5315649403928492e-9,
      396189.2947786454,
      6.3091493507500375e6
    ]
  },
  "EPSG:32196": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      193004.35375048738,
      5325655202289895e-9,
      400299.7816874225,
      6119910044418012e-9
    ]
  },
  "EPSG:32197": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      366638.38396239246,
      5394954535931998e-9,
      404933.2661121929,
      5901789692256556e-9
    ]
  },
  "EPSG:32198": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -893275.4794730864,
      181371.95473245814,
      586959.5989478156,
      211279411729137e-8
    ]
  },
  "EPSG:32199": {
    proj4: "+proj=lcc +lat_0=25.5 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      734819.9564908226,
      374071.3263928497,
      1.2426572982707794e6,
      838295.2619586219
    ]
  },
  "EPSG:32201": {
    proj4: "+proj=utm +zone=1 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32202": {
    proj4: "+proj=utm +zone=2 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32203": {
    proj4: "+proj=utm +zone=3 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32204": {
    proj4: "+proj=utm +zone=4 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32205": {
    proj4: "+proj=utm +zone=5 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32206": {
    proj4: "+proj=utm +zone=6 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32207": {
    proj4: "+proj=utm +zone=7 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32208": {
    proj4: "+proj=utm +zone=8 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32209": {
    proj4: "+proj=utm +zone=9 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32210": {
    proj4: "+proj=utm +zone=10 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32211": {
    proj4: "+proj=utm +zone=11 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32212": {
    proj4: "+proj=utm +zone=12 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32213": {
    proj4: "+proj=utm +zone=13 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32214": {
    proj4: "+proj=utm +zone=14 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32215": {
    proj4: "+proj=utm +zone=15 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32216": {
    proj4: "+proj=utm +zone=16 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32217": {
    proj4: "+proj=utm +zone=17 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32218": {
    proj4: "+proj=utm +zone=18 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32219": {
    proj4: "+proj=utm +zone=19 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32220": {
    proj4: "+proj=utm +zone=20 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32221": {
    proj4: "+proj=utm +zone=21 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623144,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32222": {
    proj4: "+proj=utm +zone=22 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32223": {
    proj4: "+proj=utm +zone=23 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32224": {
    proj4: "+proj=utm +zone=24 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32225": {
    proj4: "+proj=utm +zone=25 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32226": {
    proj4: "+proj=utm +zone=26 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32227": {
    proj4: "+proj=utm +zone=27 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32228": {
    proj4: "+proj=utm +zone=28 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039966,
      9329002434009941e-9
    ]
  },
  "EPSG:32229": {
    proj4: "+proj=utm +zone=29 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.547816229,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32230": {
    proj4: "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622812,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32231": {
    proj4: "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32232": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162291,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32233": {
    proj4: "+proj=utm +zone=33 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162311,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32234": {
    proj4: "+proj=utm +zone=34 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32235": {
    proj4: "+proj=utm +zone=35 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32236": {
    proj4: "+proj=utm +zone=36 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32237": {
    proj4: "+proj=utm +zone=37 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32238": {
    proj4: "+proj=utm +zone=38 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32239": {
    proj4: "+proj=utm +zone=39 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623144,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32240": {
    proj4: "+proj=utm +zone=40 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039965,
      9329002434009941e-9
    ]
  },
  "EPSG:32241": {
    proj4: "+proj=utm +zone=41 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32242": {
    proj4: "+proj=utm +zone=42 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32243": {
    proj4: "+proj=utm +zone=43 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039965,
      9329002434009941e-9
    ]
  },
  "EPSG:32244": {
    proj4: "+proj=utm +zone=44 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32245": {
    proj4: "+proj=utm +zone=45 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32246": {
    proj4: "+proj=utm +zone=46 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32247": {
    proj4: "+proj=utm +zone=47 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32248": {
    proj4: "+proj=utm +zone=48 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32249": {
    proj4: "+proj=utm +zone=49 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32250": {
    proj4: "+proj=utm +zone=50 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32251": {
    proj4: "+proj=utm +zone=51 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32252": {
    proj4: "+proj=utm +zone=52 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32253": {
    proj4: "+proj=utm +zone=53 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32254": {
    proj4: "+proj=utm +zone=54 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32255": {
    proj4: "+proj=utm +zone=55 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32256": {
    proj4: "+proj=utm +zone=56 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32257": {
    proj4: "+proj=utm +zone=57 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32258": {
    proj4: "+proj=utm +zone=58 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32259": {
    proj4: "+proj=utm +zone=59 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32260": {
    proj4: "+proj=utm +zone=60 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32301": {
    proj4: "+proj=utm +zone=1 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32302": {
    proj4: "+proj=utm +zone=2 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32303": {
    proj4: "+proj=utm +zone=3 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32304": {
    proj4: "+proj=utm +zone=4 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32305": {
    proj4: "+proj=utm +zone=5 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32306": {
    proj4: "+proj=utm +zone=6 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32307": {
    proj4: "+proj=utm +zone=7 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32308": {
    proj4: "+proj=utm +zone=8 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32309": {
    proj4: "+proj=utm +zone=9 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32310": {
    proj4: "+proj=utm +zone=10 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32311": {
    proj4: "+proj=utm +zone=11 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32312": {
    proj4: "+proj=utm +zone=12 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32313": {
    proj4: "+proj=utm +zone=13 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32314": {
    proj4: "+proj=utm +zone=14 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32315": {
    proj4: "+proj=utm +zone=15 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32316": {
    proj4: "+proj=utm +zone=16 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32317": {
    proj4: "+proj=utm +zone=17 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32318": {
    proj4: "+proj=utm +zone=18 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32319": {
    proj4: "+proj=utm +zone=19 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32320": {
    proj4: "+proj=utm +zone=20 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32321": {
    proj4: "+proj=utm +zone=21 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098194,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32322": {
    proj4: "+proj=utm +zone=22 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32323": {
    proj4: "+proj=utm +zone=23 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32324": {
    proj4: "+proj=utm +zone=24 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32325": {
    proj4: "+proj=utm +zone=25 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32326": {
    proj4: "+proj=utm +zone=26 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32327": {
    proj4: "+proj=utm +zone=27 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32328": {
    proj4: "+proj=utm +zone=28 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837689,
      1e7
    ]
  },
  "EPSG:32329": {
    proj4: "+proj=utm +zone=29 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098153,
      1116917639530424e-9,
      833978.452183771,
      1e7
    ]
  },
  "EPSG:32330": {
    proj4: "+proj=utm +zone=30 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098136,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32331": {
    proj4: "+proj=utm +zone=31 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837719,
      1e7
    ]
  },
  "EPSG:32332": {
    proj4: "+proj=utm +zone=32 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098153,
      1116917639530424e-9,
      833978.452183771,
      1e7
    ]
  },
  "EPSG:32333": {
    proj4: "+proj=utm +zone=33 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609819,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32334": {
    proj4: "+proj=utm +zone=34 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32335": {
    proj4: "+proj=utm +zone=35 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32336": {
    proj4: "+proj=utm +zone=36 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32337": {
    proj4: "+proj=utm +zone=37 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32338": {
    proj4: "+proj=utm +zone=38 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32339": {
    proj4: "+proj=utm +zone=39 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098194,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32340": {
    proj4: "+proj=utm +zone=40 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837686,
      1e7
    ]
  },
  "EPSG:32341": {
    proj4: "+proj=utm +zone=41 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32342": {
    proj4: "+proj=utm +zone=42 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32343": {
    proj4: "+proj=utm +zone=43 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837686,
      1e7
    ]
  },
  "EPSG:32344": {
    proj4: "+proj=utm +zone=44 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32345": {
    proj4: "+proj=utm +zone=45 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32346": {
    proj4: "+proj=utm +zone=46 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32347": {
    proj4: "+proj=utm +zone=47 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32348": {
    proj4: "+proj=utm +zone=48 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32349": {
    proj4: "+proj=utm +zone=49 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32350": {
    proj4: "+proj=utm +zone=50 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32351": {
    proj4: "+proj=utm +zone=51 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32352": {
    proj4: "+proj=utm +zone=52 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32353": {
    proj4: "+proj=utm +zone=53 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32354": {
    proj4: "+proj=utm +zone=54 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32355": {
    proj4: "+proj=utm +zone=55 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32356": {
    proj4: "+proj=utm +zone=56 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32357": {
    proj4: "+proj=utm +zone=57 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32358": {
    proj4: "+proj=utm +zone=58 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32359": {
    proj4: "+proj=utm +zone=59 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32360": {
    proj4: "+proj=utm +zone=60 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32401": {
    proj4: "+proj=utm +zone=1 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32402": {
    proj4: "+proj=utm +zone=2 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      -8883082360469576e-9,
      833978.45218377,
      0
    ]
  },
  "EPSG:32403": {
    proj4: "+proj=utm +zone=3 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32404": {
    proj4: "+proj=utm +zone=4 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32405": {
    proj4: "+proj=utm +zone=5 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32406": {
    proj4: "+proj=utm +zone=6 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32407": {
    proj4: "+proj=utm +zone=7 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32408": {
    proj4: "+proj=utm +zone=8 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32409": {
    proj4: "+proj=utm +zone=9 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32410": {
    proj4: "+proj=utm +zone=10 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32411": {
    proj4: "+proj=utm +zone=11 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32412": {
    proj4: "+proj=utm +zone=12 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32413": {
    proj4: "+proj=utm +zone=13 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32414": {
    proj4: "+proj=utm +zone=14 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32415": {
    proj4: "+proj=utm +zone=15 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32416": {
    proj4: "+proj=utm +zone=16 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32417": {
    proj4: "+proj=utm +zone=17 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32418": {
    proj4: "+proj=utm +zone=18 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32419": {
    proj4: "+proj=utm +zone=19 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32420": {
    proj4: "+proj=utm +zone=20 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32421": {
    proj4: "+proj=utm +zone=21 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623144,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32422": {
    proj4: "+proj=utm +zone=22 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32423": {
    proj4: "+proj=utm +zone=23 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32424": {
    proj4: "+proj=utm +zone=24 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32425": {
    proj4: "+proj=utm +zone=25 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32426": {
    proj4: "+proj=utm +zone=26 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32427": {
    proj4: "+proj=utm +zone=27 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32428": {
    proj4: "+proj=utm +zone=28 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039966,
      9329002434009941e-9
    ]
  },
  "EPSG:32429": {
    proj4: "+proj=utm +zone=29 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.547816229,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32430": {
    proj4: "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622812,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32431": {
    proj4: "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32432": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162291,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32433": {
    proj4: "+proj=utm +zone=33 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162311,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32434": {
    proj4: "+proj=utm +zone=34 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32435": {
    proj4: "+proj=utm +zone=35 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32436": {
    proj4: "+proj=utm +zone=36 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622795,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32437": {
    proj4: "+proj=utm +zone=37 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32438": {
    proj4: "+proj=utm +zone=38 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622934,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32439": {
    proj4: "+proj=utm +zone=39 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623144,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32440": {
    proj4: "+proj=utm +zone=40 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039965,
      9329002434009941e-9
    ]
  },
  "EPSG:32441": {
    proj4: "+proj=utm +zone=41 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32442": {
    proj4: "+proj=utm +zone=42 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32443": {
    proj4: "+proj=utm +zone=43 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039965,
      9329002434009941e-9
    ]
  },
  "EPSG:32444": {
    proj4: "+proj=utm +zone=44 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622865,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32445": {
    proj4: "+proj=utm +zone=45 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32446": {
    proj4: "+proj=utm +zone=46 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32447": {
    proj4: "+proj=utm +zone=47 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039968,
      9329002434009941e-9
    ]
  },
  "EPSG:32448": {
    proj4: "+proj=utm +zone=48 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622574,
      0,
      534994.6430039963,
      9329002434009941e-9
    ]
  },
  "EPSG:32449": {
    proj4: "+proj=utm +zone=49 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32450": {
    proj4: "+proj=utm +zone=50 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32451": {
    proj4: "+proj=utm +zone=51 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32452": {
    proj4: "+proj=utm +zone=52 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32453": {
    proj4: "+proj=utm +zone=53 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32454": {
    proj4: "+proj=utm +zone=54 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32455": {
    proj4: "+proj=utm +zone=55 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162329,
      0,
      534994.6430039973,
      9329002434009941e-9
    ]
  },
  "EPSG:32456": {
    proj4: "+proj=utm +zone=56 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32457": {
    proj4: "+proj=utm +zone=57 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32458": {
    proj4: "+proj=utm +zone=58 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162272,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32459": {
    proj4: "+proj=utm +zone=59 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039967,
      9329002434009941e-9
    ]
  },
  "EPSG:32460": {
    proj4: "+proj=utm +zone=60 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      534994.6430039969,
      9329002434009941e-9
    ]
  },
  "EPSG:32501": {
    proj4: "+proj=utm +zone=1 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32502": {
    proj4: "+proj=utm +zone=2 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32503": {
    proj4: "+proj=utm +zone=3 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32504": {
    proj4: "+proj=utm +zone=4 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32505": {
    proj4: "+proj=utm +zone=5 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32506": {
    proj4: "+proj=utm +zone=6 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32507": {
    proj4: "+proj=utm +zone=7 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32508": {
    proj4: "+proj=utm +zone=8 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32509": {
    proj4: "+proj=utm +zone=9 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32510": {
    proj4: "+proj=utm +zone=10 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32511": {
    proj4: "+proj=utm +zone=11 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32512": {
    proj4: "+proj=utm +zone=12 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32513": {
    proj4: "+proj=utm +zone=13 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32514": {
    proj4: "+proj=utm +zone=14 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32515": {
    proj4: "+proj=utm +zone=15 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32516": {
    proj4: "+proj=utm +zone=16 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32517": {
    proj4: "+proj=utm +zone=17 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32518": {
    proj4: "+proj=utm +zone=18 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32519": {
    proj4: "+proj=utm +zone=19 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32520": {
    proj4: "+proj=utm +zone=20 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32521": {
    proj4: "+proj=utm +zone=21 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098194,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32522": {
    proj4: "+proj=utm +zone=22 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32523": {
    proj4: "+proj=utm +zone=23 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32524": {
    proj4: "+proj=utm +zone=24 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32525": {
    proj4: "+proj=utm +zone=25 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32526": {
    proj4: "+proj=utm +zone=26 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32527": {
    proj4: "+proj=utm +zone=27 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32528": {
    proj4: "+proj=utm +zone=28 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837689,
      1e7
    ]
  },
  "EPSG:32529": {
    proj4: "+proj=utm +zone=29 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098153,
      1116917639530424e-9,
      833978.452183771,
      1e7
    ]
  },
  "EPSG:32530": {
    proj4: "+proj=utm +zone=30 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098136,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32531": {
    proj4: "+proj=utm +zone=31 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837719,
      1e7
    ]
  },
  "EPSG:32532": {
    proj4: "+proj=utm +zone=32 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098153,
      1116917639530424e-9,
      833978.452183771,
      1e7
    ]
  },
  "EPSG:32533": {
    proj4: "+proj=utm +zone=33 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609819,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32534": {
    proj4: "+proj=utm +zone=34 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32535": {
    proj4: "+proj=utm +zone=35 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837707,
      1e7
    ]
  },
  "EPSG:32536": {
    proj4: "+proj=utm +zone=36 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609813,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32537": {
    proj4: "+proj=utm +zone=37 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837721,
      1e7
    ]
  },
  "EPSG:32538": {
    proj4: "+proj=utm +zone=38 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609816,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32539": {
    proj4: "+proj=utm +zone=39 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098194,
      1116917639530426e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32540": {
    proj4: "+proj=utm +zone=40 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837686,
      1e7
    ]
  },
  "EPSG:32541": {
    proj4: "+proj=utm +zone=41 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32542": {
    proj4: "+proj=utm +zone=42 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32543": {
    proj4: "+proj=utm +zone=43 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.4521837686,
      1e7
    ]
  },
  "EPSG:32544": {
    proj4: "+proj=utm +zone=44 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609815,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32545": {
    proj4: "+proj=utm +zone=45 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32546": {
    proj4: "+proj=utm +zone=46 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32547": {
    proj4: "+proj=utm +zone=47 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837714,
      1e7
    ]
  },
  "EPSG:32548": {
    proj4: "+proj=utm +zone=48 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098095,
      1116917639530424e-9,
      833978.4521837671,
      1e7
    ]
  },
  "EPSG:32549": {
    proj4: "+proj=utm +zone=49 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32550": {
    proj4: "+proj=utm +zone=50 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32551": {
    proj4: "+proj=utm +zone=51 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32552": {
    proj4: "+proj=utm +zone=52 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32553": {
    proj4: "+proj=utm +zone=53 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32554": {
    proj4: "+proj=utm +zone=54 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32555": {
    proj4: "+proj=utm +zone=55 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.80486098217,
      1116917639530426e-9,
      833978.4521837756,
      1e7
    ]
  },
  "EPSG:32556": {
    proj4: "+proj=utm +zone=56 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32557": {
    proj4: "+proj=utm +zone=57 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32558": {
    proj4: "+proj=utm +zone=58 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609812,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32559": {
    proj4: "+proj=utm +zone=59 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.45218377,
      1e7
    ]
  },
  "EPSG:32560": {
    proj4: "+proj=utm +zone=60 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "EPSG:32601": {
    proj4: "+proj=utm +zone=1 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32602": {
    proj4: "+proj=utm +zone=2 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32603": {
    proj4: "+proj=utm +zone=3 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32604": {
    proj4: "+proj=utm +zone=4 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32605": {
    proj4: "+proj=utm +zone=5 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32606": {
    proj4: "+proj=utm +zone=6 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32607": {
    proj4: "+proj=utm +zone=7 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32608": {
    proj4: "+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32609": {
    proj4: "+proj=utm +zone=9 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32610": {
    proj4: "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32611": {
    proj4: "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32612": {
    proj4: "+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32613": {
    proj4: "+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32614": {
    proj4: "+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32615": {
    proj4: "+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32616": {
    proj4: "+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32617": {
    proj4: "+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32618": {
    proj4: "+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32619": {
    proj4: "+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32620": {
    proj4: "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32621": {
    proj4: "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054197,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32622": {
    proj4: "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32623": {
    proj4: "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32624": {
    proj4: "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053842,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32625": {
    proj4: "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611363,
      9329005182447437e-9
    ]
  },
  "EPSG:32626": {
    proj4: "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053987,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32627": {
    proj4: "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053842,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32628": {
    proj4: "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.655061136,
      9329005182447437e-9
    ]
  },
  "EPSG:32629": {
    proj4: "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053952,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32630": {
    proj4: "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.4430805386,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32631": {
    proj4: "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611363,
      9329005182447437e-9
    ]
  },
  "EPSG:32632": {
    proj4: "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053964,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32633": {
    proj4: "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054162,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32634": {
    proj4: "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611363,
      9329005182447437e-9
    ]
  },
  "EPSG:32635": {
    proj4: "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053987,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32636": {
    proj4: "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053842,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32637": {
    proj4: "+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611363,
      9329005182447437e-9
    ]
  },
  "EPSG:32638": {
    proj4: "+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053987,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32639": {
    proj4: "+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054197,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32640": {
    proj4: "+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.655061136,
      9329005182447437e-9
    ]
  },
  "EPSG:32641": {
    proj4: "+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32642": {
    proj4: "+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053626,
      0,
      534994.6550611359,
      9329005182447437e-9
    ]
  },
  "EPSG:32643": {
    proj4: "+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.655061136,
      9329005182447437e-9
    ]
  },
  "EPSG:32644": {
    proj4: "+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32645": {
    proj4: "+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053626,
      0,
      534994.6550611359,
      9329005182447437e-9
    ]
  },
  "EPSG:32646": {
    proj4: "+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32647": {
    proj4: "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "EPSG:32648": {
    proj4: "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053626,
      0,
      534994.6550611359,
      9329005182447437e-9
    ]
  },
  "EPSG:32649": {
    proj4: "+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      534994.6550611367,
      9329005182447437e-9
    ]
  },
  "EPSG:32650": {
    proj4: "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32651": {
    proj4: "+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32652": {
    proj4: "+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      534994.6550611367,
      9329005182447437e-9
    ]
  },
  "EPSG:32653": {
    proj4: "+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32654": {
    proj4: "+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32655": {
    proj4: "+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054337,
      0,
      534994.6550611367,
      9329005182447437e-9
    ]
  },
  "EPSG:32656": {
    proj4: "+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32657": {
    proj4: "+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32658": {
    proj4: "+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32659": {
    proj4: "+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "EPSG:32660": {
    proj4: "+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "EPSG:32661": {
    proj4: "+proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.9999999999999995e6,
      540588071737131e-8,
      2e6,
      2e6
    ]
  },
  "EPSG:32664": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2250653259136938e6,
      9427717154175516e-9,
      2.6463305758092385e6,
      10330775868748138e-9
    ]
  },
  "EPSG:32665": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      651887.7280667626,
      9304136986346347e-9,
      2.6369369450079678e6,
      10803777203605533e-9
    ]
  },
  "EPSG:32666": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      635288.6537242901,
      8700637504034445e-9,
      2.6159560864712126e6,
      1099252931736726e-8
    ]
  },
  "EPSG:32667": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      607523.8751446039,
      8653949511017106e-9,
      1.5865914069734449e6,
      10866608988916442e-9
    ]
  },
  "EPSG:32701": {
    proj4: "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32702": {
    proj4: "+proj=utm +zone=2 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32703": {
    proj4: "+proj=utm +zone=3 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32704": {
    proj4: "+proj=utm +zone=4 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32705": {
    proj4: "+proj=utm +zone=5 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32706": {
    proj4: "+proj=utm +zone=6 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32707": {
    proj4: "+proj=utm +zone=7 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32708": {
    proj4: "+proj=utm +zone=8 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32709": {
    proj4: "+proj=utm +zone=9 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32710": {
    proj4: "+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32711": {
    proj4: "+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32712": {
    proj4: "+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32713": {
    proj4: "+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32714": {
    proj4: "+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32715": {
    proj4: "+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32716": {
    proj4: "+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32717": {
    proj4: "+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32718": {
    proj4: "+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32719": {
    proj4: "+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32720": {
    proj4: "+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32721": {
    proj4: "+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672013,
      1.1169150440516975e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32722": {
    proj4: "+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32723": {
    proj4: "+proj=utm +zone=23 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194602,
      1e7
    ]
  },
  "EPSG:32724": {
    proj4: "+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672007,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32725": {
    proj4: "+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194616,
      1e7
    ]
  },
  "EPSG:32726": {
    proj4: "+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720094,
      1.1169150440516956e6,
      833978.5569194602,
      1e7
    ]
  },
  "EPSG:32727": {
    proj4: "+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672007,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32728": {
    proj4: "+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194583,
      1e7
    ]
  },
  "EPSG:32729": {
    proj4: "+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672009,
      1.1169150440516956e6,
      833978.5569194604,
      1e7
    ]
  },
  "EPSG:32730": {
    proj4: "+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672007,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32731": {
    proj4: "+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194613,
      1e7
    ]
  },
  "EPSG:32732": {
    proj4: "+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672009,
      1.1169150440516956e6,
      833978.5569194604,
      1e7
    ]
  },
  "EPSG:32733": {
    proj4: "+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720123,
      1.1169150440516975e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32734": {
    proj4: "+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194616,
      1e7
    ]
  },
  "EPSG:32735": {
    proj4: "+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720094,
      1.1169150440516956e6,
      833978.5569194602,
      1e7
    ]
  },
  "EPSG:32736": {
    proj4: "+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672007,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32737": {
    proj4: "+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194616,
      1e7
    ]
  },
  "EPSG:32738": {
    proj4: "+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720094,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32739": {
    proj4: "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672013,
      1.1169150440516975e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32740": {
    proj4: "+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194581,
      1e7
    ]
  },
  "EPSG:32741": {
    proj4: "+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32742": {
    proj4: "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672003,
      1.1169150440516956e6,
      833978.5569194567,
      1e7
    ]
  },
  "EPSG:32743": {
    proj4: "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194581,
      1e7
    ]
  },
  "EPSG:32744": {
    proj4: "+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672008,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32745": {
    proj4: "+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672003,
      1.1169150440516956e6,
      833978.5569194567,
      1e7
    ]
  },
  "EPSG:32746": {
    proj4: "+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32747": {
    proj4: "+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194609,
      1e7
    ]
  },
  "EPSG:32748": {
    proj4: "+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672003,
      1.1169150440516956e6,
      833978.5569194567,
      1e7
    ]
  },
  "EPSG:32749": {
    proj4: "+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672015,
      1.1169150440516975e6,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:32750": {
    proj4: "+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32751": {
    proj4: "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32752": {
    proj4: "+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672015,
      1.1169150440516975e6,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:32753": {
    proj4: "+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32754": {
    proj4: "+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32755": {
    proj4: "+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672015,
      1.1169150440516975e6,
      833978.5569194651,
      1e7
    ]
  },
  "EPSG:32756": {
    proj4: "+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32757": {
    proj4: "+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32758": {
    proj4: "+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32759": {
    proj4: "+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194595,
      1e7
    ]
  },
  "EPSG:32760": {
    proj4: "+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "EPSG:32761": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2e6,
      2e6,
      2.0000000000000005e6,
      -140588071737131e-8
    ]
  },
  "EPSG:32766": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      168647.57494822092,
      6930400578401649e-9,
      1.2720758590648535e6,
      8876307345602734e-9
    ]
  },
  "ESRI:20002": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      2566386743850723e-9,
      5564717406865079e-9,
      2.6958527579978895e6,
      6010215781407069e-9
    ]
  },
  "ESRI:20003": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      3266689692727278e-9,
      5076101933661515e-9,
      3692480710285709e-9,
      6089215337300765e-9
    ]
  },
  "ESRI:20062": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      566386.7438507229,
      5564717406865079e-9,
      695852.7579978894,
      6010215781407069e-9
    ]
  },
  "ESRI:20063": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      266689.6927272779,
      5076101933661515e-9,
      692480.7102857087,
      6089215337300765e-9
    ]
  },
  "ESRI:24721": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      58418.17927888181,
      842128.106009614,
      390394.86743734736,
      1.1055910866594706e6
    ]
  },
  "ESRI:26788": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1167056844547591e6,
      127245.80782200808,
      2.8663726649883804e6,
      1.3093814062431008e6
    ]
  },
  "ESRI:26789": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3333333333333 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2801256333777022e6,
      188315.6769680581,
      2.5250845275186496e6,
      955810.1866040124
    ]
  },
  "ESRI:26790": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3333333333333 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1217048036232265e-9,
      82568.3267298871,
      2.5776539259723467e6,
      998900.6686790393
    ]
  },
  "ESRI:31491": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      1521625238487588e-9,
      6.1233667172220275e6,
      1593766887447702e-9,
      6200029128679838e-9
    ]
  },
  "ESRI:31492": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      2489779772762066e-9,
      5441313975742755e-9,
      2.5987955103882626e6,
      5965196188600703e-9
    ]
  },
  "ESRI:31493": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      3386506780049417e-9,
      5237821997001279e-9,
      3.5963990407126797e6,
      6107658748655212e-9
    ]
  },
  "ESRI:31494": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      4386763613430334e-9,
      5251161408309198e-9,
      4597598293959737e-9,
      6052011414167817e-9
    ]
  },
  "ESRI:31495": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      5389184701626548e-9,
      5375675134883275e-9,
      5415097871261377e-9,
      5427497276098792e-9
    ]
  },
  "ESRI:32059": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -227330.47550317115,
      -1.0545513404754947e6,
      973266.2413962432,
      1.4648932767753138e6
    ]
  },
  "ESRI:32060": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      634367.3360031528,
      -486034.15887517796,
      1.3675578245894292e6,
      155822203640733e-8
    ]
  },
  "ESRI:37002": {
    proj4: "+proj=longlat +ellps=fschr60 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37003": {
    proj4: "+proj=longlat +ellps=fschr68 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37004": {
    proj4: "+proj=longlat +ellps=fschr60m +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37005": {
    proj4: "+proj=longlat +ellps=hough +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37006": {
    proj4: "+proj=longlat +ellps=evrst69 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37007": {
    proj4: "+proj=longlat +ellps=walbeck +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37008": {
    proj4: "+proj=longlat +ellps=sphere +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:37202": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [88.01, 18.56, 92.67, 26.64]
  },
  "ESRI:37203": {
    proj4: "+proj=longlat +a=6377301.243 +rf=300.8017255 +no_defs +type=crs",
    projected_bounds: [65.6, 3.87, 97.42, 35.51]
  },
  "ESRI:37206": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [51.99, 14.33, 63.38, 26.74]
  },
  "ESRI:37207": {
    proj4: "+proj=longlat +ellps=fschr60m +no_defs +type=crs",
    projected_bounds: [103.59, 1.13, 104.07, 1.47]
  },
  "ESRI:37218": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [156.44, -8.86, 158.2, -7.52]
  },
  "ESRI:37221": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [159.55, -9.98, 160.88, -9.2]
  },
  "ESRI:37225": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [7.49, 30.23, 13.67, 38.41]
  },
  "ESRI:37240": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-63.63, 16.34, -62.2, 17.67]
  },
  "ESRI:37241": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-28.9, 38.32, -26.97, 39.14]
  },
  "ESRI:37243": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-80.14, 19.63, -79.69, 19.78]
  },
  "ESRI:37245": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-31.34, 39.3, -31.02, 39.77]
  },
  "ESRI:37249": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-25.92, 36.87, -24.62, 37.96]
  },
  "ESRI:37257": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [16.11, 45.74, 22.9, 48.58]
  },
  "ESRI:37260": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [172.42, 51.3, -129.99, 71.4]
  },
  "ESRI:53001": {
    proj4: "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2001508679602057e-8,
      -10007543398010286e-9,
      2001508679602057e-8,
      10007543398010286e-9
    ]
  },
  "ESRI:53002": {
    proj4: "+proj=eqc +lat_ts=60 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1000754339801029e-8,
      -10007543398010286e-9,
      1000754339801029e-8,
      10007543398010286e-9
    ]
  },
  "ESRI:53003": {
    proj4: "+proj=mill +R_A +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2001508679602057e-8,
      -14675041313850988e-9,
      2001508679602057e-8,
      14675041313850986e-9
    ]
  },
  "ESRI:53004": {
    proj4: "+proj=merc +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2001508679602057e-8,
      -24225729649466372e-8,
      2001508679602057e-8,
      24225729649466372e-8
    ]
  },
  "ESRI:53008": {
    proj4: "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12255705989701522e-25,
      -10007543398010286e-9,
      12255705989701522e-25,
      10007543398010286e-9
    ]
  },
  "ESRI:53009": {
    proj4: "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -11034012068552656e-25,
      -9009954605878988e-9,
      11034012068552656e-25,
      9009954605878988e-9
    ]
  },
  "ESRI:53010": {
    proj4: "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8826908904220507e-9,
      -8826908904220507e-9,
      8826908904220507e-9,
      8826908904220507e-9
    ]
  },
  "ESRI:53011": {
    proj4: "+proj=eck5 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8826908904220507e-9,
      -8826908904220507e-9,
      8826908904220507e-9,
      8826908904220507e-9
    ]
  },
  "ESRI:53012": {
    proj4: "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8451134227915682e-9,
      -8451134227915682e-9,
      8451134227915682e-9,
      8451134227915682e-9
    ]
  },
  "ESRI:53013": {
    proj4: "+proj=eck3 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8451134227915682e-9,
      -8451134227915682e-9,
      8451134227915682e-9,
      8451134227915682e-9
    ]
  },
  "ESRI:53014": {
    proj4: "+proj=eck2 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9220127185581446e-9,
      -9220127185581446e-9,
      9220127185581446e-9,
      9220127185581446e-9
    ]
  },
  "ESRI:53015": {
    proj4: "+proj=eck1 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9220127185581446e-9,
      -9220127185581446e-9,
      9220127185581446e-9,
      9220127185581446e-9
    ]
  },
  "ESRI:53016": {
    proj4: "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -14152803599503474e-9,
      -10875977302939493e-9,
      14152803599503474e-9,
      10875977302939493e-9
    ]
  },
  "ESRI:53017": {
    proj4: "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17333573624304306e-9,
      -7356597130014211e-9,
      17333573624304306e-9,
      7356597130014211e-9
    ]
  },
  "ESRI:53018": {
    proj4: "+proj=wink1 +lon_0=0 +lat_ts=50.4597762521898 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6371000000000003e-9,
      -10007543398010286e-9,
      6371000000000003e-9,
      10007543398010286e-9
    ]
  },
  "ESRI:53019": {
    proj4: "+proj=wink2 +lon_0=0 +lat_1=50.4597762521898 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6371000000000003e-9,
      -10007543398010286e-9,
      6371000000000003e-9,
      10007543398010286e-9
    ]
  },
  "ESRI:53021": {
    proj4: "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -47774847876693476e-42,
      -10007543398010287e-9,
      47774847876693476e-42,
      10007543398010287e-9
    ]
  },
  "ESRI:53022": {
    proj4: "+proj=qua_aut +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17332185627093066e-25,
      -9009954605878988e-9,
      17332185627093066e-25,
      9009954605878988e-9
    ]
  },
  "ESRI:53023": {
    proj4: "+proj=loxim +lat_1=40 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [0, -14455340463792635e-9, 0, 5559746332227937e-9]
  },
  "ESRI:53024": {
    proj4: "+proj=bonne +lat_1=60 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12255705989701522e-25,
      -16679238996683808e-9,
      12255705989701522e-25,
      3.3358477993367626e6
    ]
  },
  "ESRI:53025": {
    proj4: "+proj=omerc +lat_0=40 +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +k=1 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs"
  },
  "ESRI:53026": {
    proj4: "+proj=stere +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9554969575338696e-41,
      -12742000000000004e-9,
      9554969575338696e-41,
      12742000000000004e-9
    ]
  },
  "ESRI:53027": {
    proj4: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8317606010766038e-9,
      28930811310009945e-9,
      139917.24383656256,
      10662557264166573e-9
    ]
  },
  "ESRI:53028": {
    proj4: "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -47774847876693476e-42,
      -10007543398010286e-9,
      47774847876693476e-42,
      10007543398010286e-9
    ]
  },
  "ESRI:53029": {
    proj4: "+proj=vandg +R_A +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [0, -20015086796020567e-9, 0, 20015086796020567e-9]
  },
  "ESRI:53030": {
    proj4: "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9040376816327821e-9,
      -86155033e-1,
      9040376816327821e-9,
      86155033e-1
    ]
  },
  "ESRI:53031": {
    proj4: "+proj=tpeqd +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10600862008304609e-9,
      -7691896976409792e-9,
      5300431004152304e-9,
      3148717056351691e-9
    ]
  },
  "ESRI:53032": {
    proj4: "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -7504455555789507e-41,
      -10007543398010286e-9,
      7504455555789507e-41,
      10007543398010286e-9
    ]
  },
  "ESRI:53034": {
    proj4: "+proj=cea +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2001508679602057e-8,
      -6371e3,
      2001508679602057e-8,
      6371e3
    ]
  },
  "ESRI:53035": {
    proj4: "+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10216477343935162e-9,
      -8392929693707585e-9,
      10216477343935162e-9,
      8392929693707585e-9
    ]
  },
  "ESRI:53036": {
    proj4: "+proj=eqearth +lon_0=-90 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5108238671967581e-9,
      -8392929693707585e-9,
      -5108238671967581e-9,
      8392929693707585e-9
    ]
  },
  "ESRI:53037": {
    proj4: "+proj=eqearth +lon_0=150 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7027462239891917e6,
      -8392929693707585e-9,
      1702746223989193e-9,
      8392929693707585e-9
    ]
  },
  "ESRI:53042": {
    proj4: "+proj=wintri +lon_0=0 +lat_1=50.467 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6370026928915143e-9,
      -10007543398010286e-9,
      6370026928915143e-9,
      10007543398010286e-9
    ]
  },
  "ESRI:53043": {
    proj4: "+proj=aitoff +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12255705989701522e-25,
      -10007543398010286e-9,
      12255705989701522e-25,
      10007543398010286e-9
    ]
  },
  "ESRI:53045": {
    proj4: "+proj=mbtfpq +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6253908298046981e-9,
      -844574352072302e-8,
      6253908298046981e-9,
      844574352072302e-8
    ]
  },
  "ESRI:53046": {
    proj4: "+proj=crast +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4342935648656007e-24,
      -9779421684490616e-9,
      4342935648656007e-24,
      9779421684490616e-9
    ]
  },
  "ESRI:53048": {
    proj4: "+proj=times +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs +type=crs",
    projected_bounds: [
      -11446227836908245e-9,
      -10875997809999999e-9,
      11446227836908245e-9,
      10875997809999999e-9
    ]
  },
  "ESRI:53049": {
    proj4: "+proj=nsper +lat_0=0 +lon_0=0 +h=35800000 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [1 / 0, 1 / 0, 1 / 0, 1 / 0]
  },
  "ESRI:53074": {
    proj4: "+proj=wag4 +lon_0=0 +x_0=0 +y_0=0 +R=6371007 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8637471559250213e-9,
      -8637471559250211e-9,
      8637471559250213e-9,
      8637471559250211e-9
    ]
  },
  "ESRI:53075": {
    proj4: "+proj=wag5 +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8250447294297368e-9,
      -9372000949026883e-9,
      8250447294297368e-9,
      9372000949026883e-9
    ]
  },
  "ESRI:53076": {
    proj4: "+proj=wag7 +lon_0=0 +x_0=0 +y_0=0 +R=6371007 +units=m +no_defs +type=crs",
    projected_bounds: [
      -7991622169719479e-9,
      -9207825400598489e-9,
      7991622169719479e-9,
      9207825400598489e-9
    ]
  },
  "ESRI:53077": {
    proj4: "+proj=natearth +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9591912979377454e-9,
      -9062062394736718e-9,
      9591912979377454e-9,
      9062062394736718e-9
    ]
  },
  "ESRI:53078": {
    proj4: "+proj=natearth2 +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.8318934813693967e6,
      -9073776526628098e-9,
      3.8318934813693967e6,
      9073776526628098e-9
    ]
  },
  "ESRI:53079": {
    proj4: "+proj=patterson +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20015114352186374e-9,
      -11409566822831295e-9,
      20015114352186374e-9,
      11409566822831295e-9
    ]
  },
  "ESRI:53080": {
    proj4: "+proj=comill +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20015114352186374e-9,
      -12009484264916677e-9,
      20015114352186374e-9,
      12009484264916677e-9
    ]
  },
  "ESRI:54001": {
    proj4: "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -10018754171394622e-9,
      20037508342789244e-9,
      10018754171394622e-9
    ]
  },
  "ESRI:54002": {
    proj4: "+proj=eqc +lat_ts=60 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10018754171394624e-9,
      -10018754171394622e-9,
      10018754171394624e-9,
      10018754171394622e-9
    ]
  },
  "ESRI:54003": {
    proj4: "+proj=mill +R_A +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20015109356056377e-9,
      -14675057854846332e-9,
      20015109356056377e-9,
      14675057854846328e-9
    ]
  },
  "ESRI:54004": {
    proj4: "+proj=merc +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -24248588760835055e-8,
      20037508342789244e-9,
      24248588760835055e-8
    ]
  },
  "ESRI:54008": {
    proj4: "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12310710709600384e-25,
      -10001965729313632e-9,
      12310710709600384e-25,
      10001965729313632e-9
    ]
  },
  "ESRI:54009": {
    proj4: "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -11046372725299363e-25,
      -9020047848073646e-9,
      11046372725299363e-25,
      9020047848073646e-9
    ]
  },
  "ESRI:54010": {
    proj4: "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -883679709270731e-8,
      -883679709270731e-8,
      883679709270731e-8,
      883679709270731e-8
    ]
  },
  "ESRI:54011": {
    proj4: "+proj=eck5 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -883679709270731e-8,
      -883679709270731e-8,
      883679709270731e-8,
      883679709270731e-8
    ]
  },
  "ESRI:54012": {
    proj4: "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8460601461471582e-9,
      -8460601461471582e-9,
      8460601461471582e-9,
      8460601461471582e-9
    ]
  },
  "ESRI:54013": {
    proj4: "+proj=eck3 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8460601461471582e-9,
      -8460601461471582e-9,
      8460601461471582e-9,
      8460601461471582e-9
    ]
  },
  "ESRI:54014": {
    proj4: "+proj=eck2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9230455869889012e-9,
      -9230455869889012e-9,
      9230455869889012e-9,
      9230455869889012e-9
    ]
  },
  "ESRI:54015": {
    proj4: "+proj=eck1 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9230455869889012e-9,
      -9230455869889012e-9,
      9230455869889012e-9,
      9230455869889012e-9
    ]
  },
  "ESRI:54016": {
    proj4: "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -14168658027268294e-9,
      -10888160924036821e-9,
      14168658027268294e-9,
      10888160924036821e-9
    ]
  },
  "ESRI:54017": {
    proj4: "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17367530445161372e-9,
      -7342230136498678e-9,
      17367530445161372e-9,
      734223013649868e-8
    ]
  },
  "ESRI:54018": {
    proj4: "+proj=wink1 +lon_0=0 +lat_ts=50.4597762521898 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6378137000000003e-9,
      -10018754171394622e-9,
      6378137000000003e-9,
      10018754171394622e-9
    ]
  },
  "ESRI:54019": {
    proj4: "+proj=wink2 +lon_0=0 +lat_1=50.4597762521898 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6378137000000003e-9,
      -10018754171394622e-9,
      6378137000000003e-9,
      10018754171394622e-9
    ]
  },
  "ESRI:54021": {
    proj4: "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, -10001965729313632e-9, 0, 10001965729313632e-9]
  },
  "ESRI:54022": {
    proj4: "+proj=qua_aut +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17351601701307563e-25,
      -9020047848073645e-9,
      17351601701307563e-25,
      9020047848073645e-9
    ]
  },
  "ESRI:54023": {
    proj4: "+proj=loxim +lat_1=40 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, -14471533803125564e-9, 0, 5565974539663678e-9]
  },
  "ESRI:54024": {
    proj4: "+proj=bonne +lat_1=60 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12310710709600384e-25,
      -16656038548807444e-9,
      12310710709600384e-25,
      3347892909819821e-9
    ]
  },
  "ESRI:54025": {
    proj4: "+proj=omerc +lat_0=40 +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:54026": {
    proj4: "+proj=stere +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9565673360907554e-41,
      -12756274000000004e-9,
      9565673360907554e-41,
      12756274000000004e-9
    ]
  },
  "ESRI:54027": {
    proj4: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8313601708278208e-9,
      28917643085906733e-9,
      140470.74707909298,
      10659570786440229e-9
    ]
  },
  "ESRI:54028": {
    proj4: "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1793272289210736e-24,
      -10001965729313632e-9,
      -1793272289210736e-24,
      10001965729313632e-9
    ]
  },
  "ESRI:54029": {
    proj4: "+proj=vandg +R_A +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, -20015109356056374e-9, 0, 20015109356056374e-9]
  },
  "ESRI:54030": {
    proj4: "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -905050413846534e-8,
      -86251546651e-4,
      905050413846534e-8,
      86251546651e-4
    ]
  },
  "ESRI:54031": {
    proj4: "+proj=tpeqd +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1061273743636194e-8,
      -7700513687871201e-9,
      530636871818097e-8,
      3152244350910031e-9
    ]
  },
  "ESRI:54032": {
    proj4: "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      12248875315584348e-25,
      -10001965729312724e-9,
      0,
      10001965729312724e-9
    ]
  },
  "ESRI:54034": {
    proj4: "+proj=cea +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -636388533192604e-8,
      20037508342789244e-9,
      6363885331926043e-9
    ]
  },
  "ESRI:54042": {
    proj4: "+proj=wintri +lon_0=0 +lat_1=50.467 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6377162838849481e-9,
      -10018754171394622e-9,
      6377162838849481e-9,
      10018754171394622e-9
    ]
  },
  "ESRI:54043": {
    proj4: "+proj=aitoff +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12269435227442615e-25,
      -10018754171394622e-9,
      12269435227442615e-25,
      10018754171394622e-9
    ]
  },
  "ESRI:54045": {
    proj4: "+proj=mbtfpq +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6260914128140084e-9,
      -8455204715434588e-9,
      6260914128140084e-9,
      8455204715434588e-9
    ]
  },
  "ESRI:54046": {
    proj4: "+proj=crast +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4347800745457837e-24,
      -9790376908562537e-9,
      4347800745457837e-24,
      9790376908562537e-9
    ]
  },
  "ESRI:54048": {
    proj4: "+proj=times +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -11459050271074312e-9,
      -10888181454069998e-9,
      11459050271074312e-9,
      10888181454069998e-9
    ]
  },
  "ESRI:54049": {
    proj4: "+proj=nsper +lat_0=0 +lon_0=0 +h=35800000 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [1 / 0, 1 / 0, 1 / 0, 1 / 0]
  },
  "ESRI:54052": {
    proj4: "+proj=igh +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -17811118526923772e-9,
      -8683259716434667e-9,
      3.3395847237982075e6,
      8683259716434667e-9
    ]
  },
  "ESRI:54053": {
    proj4: "+proj=igh_o +lon_0=-160 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2226389815865471e-9,
      -8683259716434667e-9,
      -1.1131949079327357e6,
      8683259716434667e-9
    ]
  },
  "ESRI:54074": {
    proj4: "+proj=wag4 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8647138033045871e-9,
      -864713803304587e-8,
      8647138033045871e-9,
      864713803304587e-8
    ]
  },
  "ESRI:54075": {
    proj4: "+proj=wag5 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8259678340192331e-9,
      -938248684970622e-8,
      8259678340192331e-9,
      938248684970622e-8
    ]
  },
  "ESRI:54076": {
    proj4: "+proj=wag7 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8000565852573712e-9,
      -9218130175825745e-9,
      8000565852573712e-9,
      9218130175825745e-9
    ]
  },
  "ESRI:54077": {
    proj4: "+proj=natearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9602644929509943e-9,
      -9072201519427164e-9,
      9602644929509943e-9,
      9072201519427164e-9
    ]
  },
  "ESRI:54078": {
    proj4: "+proj=natearth2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.8361808106897813e6,
      -9083928757721778e-9,
      3.8361808106897813e6,
      9083928757721778e-9
    ]
  },
  "ESRI:54079": {
    proj4: "+proj=patterson +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -11422332462223476e-9,
      20037508342789244e-9,
      11422332462223476e-9
    ]
  },
  "ESRI:54080": {
    proj4: "+proj=comill +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -12022921124334095e-9,
      20037508342789244e-9,
      12022921124334095e-9
    ]
  },
  "ESRI:54098": {
    proj4: "+proj=adams_ws2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1100.9885915848579,
      -16722741481063392e-9,
      1101.083633541227,
      16722741576105349e-9
    ]
  },
  "ESRI:65061": {
    proj4: "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1112164118791482e-9,
      -743878.0837100082,
      1369466179746442e-9,
      1058736891268766e-9
    ]
  },
  "ESRI:65062": {
    proj4: "+proj=lcc +lat_1=-14.2666666666667 +lat_0=-14.2666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480061 +y_0=95169.3116586233 +ellps=clrk66 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -808275.1499770577,
      -894553.9573251652,
      2231085671847903e-9,
      1.8369500676117707e6
    ]
  },
  "ESRI:65161": {
    proj4: "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -338983.5474974763,
      -226750.95613393816,
      417409.10275670723,
      322718.9048254572
    ]
  },
  "ESRI:102001": {
    proj4: "+proj=aea +lat_0=40 +lon_0=-96 +lat_1=50 +lat_2=70 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3790835319835042e-9,
      1.1275681157314163e6,
      724392.7162438437,
      5239914952349427e-9
    ]
  },
  "ESRI:102002": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-96 +lat_1=50 +lat_2=70 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3827665833864937e-9,
      1154616367979866e-9,
      410925.44910267176,
      5481591531060015e-9
    ]
  },
  "ESRI:102003": {
    proj4: "+proj=aea +lat_0=37.5 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      -1.0080164376580744e6,
      2.1091213560858895e6,
      1648488533406492e-9
    ]
  },
  "ESRI:102004": {
    proj4: "+proj=lcc +lat_0=39 +lon_0=-96 +lat_1=33 +lat_2=45 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.9456415906145573e6,
      -1.1554665809574444e6,
      2.1006486149692074e6,
      1.4926105206736452e6
    ]
  },
  "ESRI:102005": {
    proj4: "+proj=eqdc +lat_0=39 +lon_0=-96 +lat_1=33 +lat_2=45 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.9416147373695234e6,
      -1.1496381829273845e6,
      2.1022745456844256e6,
      1.4915127448196374e6
    ]
  },
  "ESRI:102007": {
    proj4: "+proj=aea +lat_0=13 +lon_0=-157 +lat_1=8 +lat_2=18 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -348234.07724234933,
      653157.0743159243,
      235162.49150216987,
      1.0285997923857332e6
    ]
  },
  "ESRI:102008": {
    proj4: "+proj=aea +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6859872434879387e-9,
      1.0553359195528494e6,
      155002965717395e-8,
      484278255475602e-8
    ]
  },
  "ESRI:102009": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6698991384831333e-9,
      1.4320542261887903e6,
      619069.085378222,
      5993772956096382e-9
    ]
  },
  "ESRI:102010": {
    proj4: "+proj=eqdc +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6782155240436587e-9,
      1.2405144001172138e6,
      1.0737999878814835e6,
      5468878258791638e-9
    ]
  },
  "ESRI:102011": {
    proj4: "+proj=sinu +lon_0=15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.6515267858471824e6,
      -3.8745929016950694e6,
      346505615651455e-8,
      431850398480429e-8
    ]
  },
  "ESRI:102012": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=105 +lat_1=30 +lat_2=62 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10910377008338219e-9,
      4561181857996657e-9,
      983873.38692706,
      1068081800758169e-8
    ]
  },
  "ESRI:102013": {
    proj4: "+proj=aea +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -3614338125951295e-9,
      14404939928015e-7,
      882243.151769968,
      5933689329061475e-9
    ]
  },
  "ESRI:102014": {
    proj4: "+proj=lcc +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.6321470299320817e6,
      1.5017391952592605e6,
      496428.2013875971,
      6542536683400344e-9
    ]
  },
  "ESRI:102015": {
    proj4: "+proj=lcc +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.0081864470376982e6,
      -3.4704739935801993e6,
      3806194274173132e-9,
      4856384175412747e-9
    ]
  },
  "ESRI:102016": {
    proj4: "+proj=aeqd +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-12248875315585463e-25, 10001965729313632e-9, 0, 0]
  },
  "ESRI:102017": {
    proj4: "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-11034024505272343e-25, 9009964761231286e-9, 0, 0]
  },
  "ESRI:102018": {
    proj4: "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-15569669666696745e-25, 12713600098850505e-9, 0, 0]
  },
  "ESRI:102019": {
    proj4: "+proj=aeqd +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 12248875315585463e-25, -10001965729313632e-9]
  },
  "ESRI:102020": {
    proj4: "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 11034024505272343e-25, -9009964761231286e-9]
  },
  "ESRI:102021": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 15569669666696745e-25, -12713600098850505e-9]
  },
  "ESRI:102022": {
    proj4: "+proj=aea +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5098821136070512e-9,
      -3994191093091728e-9,
      316403137712382e-8,
      4231857613547249e-9
    ]
  },
  "ESRI:102023": {
    proj4: "+proj=eqdc +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5096001444019856e-9,
      -3.9314952619760637e6,
      3167537401637377e-9,
      4297283163437529e-9
    ]
  },
  "ESRI:102024": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5092887945820004e-9,
      -3.8807248955812026e6,
      3171663048112126e-9,
      4392812030725227e-9
    ]
  },
  "ESRI:102025": {
    proj4: "+proj=aea +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -7263808972186519e-9,
      432278.23894077307,
      2363066669354768e-9,
      7027664450927549e-9
    ]
  },
  "ESRI:102026": {
    proj4: "+proj=eqdc +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -720386984984611e-8,
      667920.1771846543,
      1.7476787315307772e6,
      7054060843637949e-9
    ]
  },
  "ESRI:102027": {
    proj4: "+proj=lcc +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -7134709010307442e-9,
      921807.6760778612,
      1190655406589745e-9,
      6974220227201404e-9
    ]
  },
  "ESRI:102028": {
    proj4: "+proj=aea +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10137478943115598e-9,
      -1.2396701971626817e6,
      4735845248634552e-9,
      4525239425753403e-9
    ]
  },
  "ESRI:102029": {
    proj4: "+proj=eqdc +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1011693962779898e-8,
      -1.3441770846825491e6,
      4.7798415306543065e6,
      4624007943393149e-9
    ]
  },
  "ESRI:102030": {
    proj4: "+proj=lcc +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -10095682052824179e-9,
      -1.4490920270078357e6,
      4834921351111086e-9,
      4777796276520459e-9
    ]
  },
  "ESRI:102031": {
    proj4: "+proj=eqdc +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.6223892296337127e6,
      1468286607027442e-9,
      646858.635837002,
      6306629329049123e-9
    ]
  },
  "ESRI:102032": {
    proj4: "+proj=eqdc +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      -2059907144019287e-9,
      -3.3244178187690126e6,
      375455107850404e-8,
      481411230071977e-8
    ]
  },
  "ESRI:102033": {
    proj4: "+proj=aea +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      -2110694809898623e-9,
      -3170562342487148e-9,
      3713277555297869e-9,
      48112331328555e-7
    ]
  },
  "ESRI:102034": {
    proj4: "+proj=gnom +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      1 / 0,
      1 / 0,
      4782836680453776e-41,
      3905482530786651e-25
    ]
  },
  "ESRI:102035": {
    proj4: "+proj=ortho +f=0 +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -7810965061573302e-25,
      6378137,
      4782836680453776e-41,
      3905482530786651e-25
    ]
  },
  "ESRI:102036": {
    proj4: "+proj=gnom +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4782836680453776e-41,
      -3905482530786651e-25,
      1 / 0,
      1 / 0
    ]
  },
  "ESRI:102037": {
    proj4: "+proj=ortho +f=0 +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4782836680453776e-41,
      -3905482530786651e-25,
      7810965061573302e-25,
      -6378137
    ]
  },
  "ESRI:102038": {
    proj4: "+proj=ortho +lat_0=42.5333333333 +lon_0=-72.5333333334 +x_0=0 +y_0=0 +ellps=sphere +units=m +no_defs +type=crs",
    projected_bounds: [
      1 / 0,
      1 / 0,
      -3721237094799853e-25,
      4694686833940939e-9
    ]
  },
  "ESRI:102039": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2916311100313346e-9,
      598769.8229192615,
      2.1091213560858895e6,
      3.2552747939838283e6
    ]
  },
  "ESRI:102041": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000.070104141 +y_0=0.0731521463042926 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2877798095039243e6,
      185654.3071410418,
      1.3383150483570627e6,
      254098.6746669873
    ]
  },
  "ESRI:102042": {
    proj4: "+proj=aea +lat_0=35 +lon_0=-82.25 +lat_1=38.25 +lat_2=47.25 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.3564879612977565e6,
      220285.53968143166,
      1117779989425633e-9,
      1.7135699247551584e6
    ]
  },
  "ESRI:102043": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -91225.24479560019,
      1.6567868352564864e6,
      409074.16863798467,
      2.4175910564304264e6
    ]
  },
  "ESRI:102044": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -91225.24479560019,
      1.6567868352564864e6,
      409074.16863798467,
      2.4175910564304264e6
    ]
  },
  "ESRI:102045": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -91225.24479560019,
      1.6567868352564864e6,
      409074.16863798467,
      2.4175910564304264e6
    ]
  },
  "ESRI:102060": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      373233.0062728352,
      31884.691833678633,
      622695.8455677517,
      194117.3688241765
    ]
  },
  "ESRI:102061": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=-36.974209437118 +gamma=-36.869897645844 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +units=m +no_defs +type=crs",
    projected_bounds: [
      176038.97445837094,
      134630.4717822058,
      733360.1812039949,
      743344.0468589091
    ]
  },
  "ESRI:102062": {
    proj4: "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=-36.974209437118 +gamma=-36.869897645844 +k=0.99984 +x_0=804671.299775 +y_0=0 +ellps=evrst48 +units=m +no_defs +type=crs",
    projected_bounds: [
      176039.20631597808,
      134630.64909268223,
      733361.1470625113,
      743345.0258548626
    ]
  },
  "ESRI:102063": {
    proj4: "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=1 +x_0=160933.56048 +y_0=160933.56048 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      -256527.37649377098,
      -327240.11502479226,
      648898.7953691469,
      656808.698983194
    ]
  },
  "ESRI:102064": {
    proj4: "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=1 +x_0=160933.56048 +y_0=160933.56048 +ellps=evrst30 +units=ind-yd +no_defs +type=crs",
    projected_bounds: [
      -280543.21378488705,
      -357876.0084135525,
      709648.0537952356,
      718298.4747013542
    ]
  },
  "ESRI:102068": {
    proj4: "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-32 +x_0=400000 +y_0=5500000 +R=6370000 +to_meter=50000 +no_defs +type=crs",
    projected_bounds: [
      12.411441331296801,
      -16.327151305737402,
      18.27857397511884,
      108.55544063398652
    ]
  },
  "ESRI:102069": {
    proj4: "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-32 +x_0=450000 +y_0=5550000 +R=6370000 +to_meter=150000 +no_defs +type=crs",
    projected_bounds: [
      4.4704804437656005,
      -5.109050435245801,
      6.426191325039613,
      36.51848021132884
    ]
  },
  "ESRI:102070": {
    proj4: "+proj=tmerc +lat_0=49.5 +lon_0=-2.41666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -48885.67292237081,
      7456.864617057407,
      75344.69515920352,
      123484.13562421834
    ]
  },
  "ESRI:102071": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=149.009294833333 +k=1.000086 +x_0=200000 +y_0=4510193.4939 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      177500.77232015668,
      532033.2828663671,
      235617.89736297374,
      621869.8694497589
    ]
  },
  "ESRI:102072": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=141 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      76971.02059599423,
      -343606.3418830093,
      631027.4791900988,
      3994585214108363e-9
    ]
  },
  "ESRI:102073": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=143 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      -71681.3143631944,
      -351354.94982542936,
      411032.2824038001,
      3.9958039212587937e6
    ]
  },
  "ESRI:102074": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=145 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      229641.15941230766,
      -640006.3072922667,
      851177.0968747546,
      3.9754963325017393e6
    ]
  },
  "ESRI:102075": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=147 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      88940.9307663113,
      -643819.0768258944,
      630888.5026124467,
      3.9779738908592556e6
    ]
  },
  "ESRI:102076": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=149 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      -51706.60666648985,
      -651451.0978182815,
      410985.74241075787,
      3.9792120371253383e6
    ]
  },
  "ESRI:102077": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=151 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      242462.66225374566,
      -1538274193533604e-9,
      841053.8936500358,
      3460454309472612e-9
    ]
  },
  "ESRI:102078": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=153 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      127420.80933802327,
      -1.5417164778525736e6,
      624397.1455398495,
      3.4640869055302823e6
    ]
  },
  "ESRI:102079": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=155 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +units=m +no_defs +type=crs",
    projected_bounds: [
      12477.649600483943,
      -1.5486035511467531e6,
      408093.2401600552,
      3465897993079363e-9
    ]
  },
  "ESRI:102093": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      224539180762884e-8,
      3.8505900508226375e6,
      2822772077317902e-9,
      5224106003023173e-9
    ]
  },
  "ESRI:102094": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1226016210788518e-9,
      4047158633340355e-9,
      1727909853789162e-9,
      5214077882908902e-9
    ]
  },
  "ESRI:102096": {
    proj4: "+proj=aeqd +lat_0=7.35122211111111 +lon_0=134.450444861111 +x_0=50000 +y_0=150000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -503994.70922381827,
      -479235.02169412444,
      326256.1281531305,
      604239.7919657219
    ]
  },
  "ESRI:102097": {
    proj4: "+proj=utm +zone=26 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197427.2404352778,
      2.7793829586619935e6,
      637183.5491341683,
      7300894610729776e-9
    ]
  },
  "ESRI:102098": {
    proj4: "+proj=utm +zone=27 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203872.6488228481,
      3.0564874887848445e6,
      633447.0615678701,
      7378848118166465e-9
    ]
  },
  "ESRI:102099": {
    proj4: "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      229578.6299881093,
      3.9881119622351583e6,
      586637.038273285,
      8325798246917715e-9
    ]
  },
  "ESRI:102101": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.05625 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -81528.10444021254,
      -6965.79219515403,
      59346.201056171354,
      564273.0219912175
    ]
  },
  "ESRI:102102": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=8.38958333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -69247.58557687479,
      -4969.201229456433,
      57527.72085045978,
      654539.025758169
    ]
  },
  "ESRI:102103": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -67716.67686969585,
      94146.94500855058,
      57604.04493650128,
      865281.0797963571
    ]
  },
  "ESRI:102104": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=13.2229166666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -70155.38863133681,
      210062.73225462617,
      73284.33863867997,
      1.2338032216414106e6
    ]
  },
  "ESRI:102105": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=16.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -83016.20516538399,
      909406.8962257892,
      75672.96501007408,
      1.3599949367906672e6
    ]
  },
  "ESRI:102106": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=20.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -82824.03620671769,
      1.1526366588665522e6,
      73396.82669228595,
      1.4291270476318887e6
    ]
  },
  "ESRI:102107": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=24.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -81914.45611030937,
      1.1805066168710405e6,
      75158.48229581231,
      1.4738399696845275e6
    ]
  },
  "ESRI:102108": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=29.05625 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -83372.63444901699,
      1.2296617756210775e6,
      77953.63244455191,
      1.4694725795605832e6
    ]
  },
  "ESRI:102109": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373217.6542446415,
      32395.089991691522,
      622710.7360243343,
      194645.86094378773
    ]
  },
  "ESRI:102114": {
    proj4: "+proj=utm +zone=4 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      363586.17420580646,
      2157647534400419e-9,
      809135.3075346367,
      2467854024559769e-9
    ]
  },
  "ESRI:102115": {
    proj4: "+proj=utm +zone=5 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      183886.2457831386,
      2.0889965684756788e6,
      318972.0410340738,
      2307496272669136e-9
    ]
  },
  "ESRI:102116": {
    proj4: "+proj=utm +zone=2 +south +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      208067.86045975197,
      8056495800514426e-9,
      1136651842358558e-9,
      8886824733732767e-9
    ]
  },
  "ESRI:102117": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.2571976882391474e6,
      726803.4959613117,
      858336.7083960685,
      253468973788795e-8
    ]
  },
  "ESRI:102118": {
    proj4: "+proj=aea +lat_0=23 +lon_0=-83.5 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -664278.922828913,
      2662492963477256e-9,
      810478.3852983594,
      4368121696431021e-9
    ]
  },
  "ESRI:102120": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.49596139 +y_0=-4354009.81600203 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      432260.20657863724,
      446190.2862797738,
      2.5814159163757525e6,
      2855956030310071e-9
    ]
  },
  "ESRI:102121": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.49596139 +y_0=-4354009.81600203 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      432263.3940505372,
      446176.5638228215,
      2581432194152051e-9,
      2.8559614135039626e6
    ]
  },
  "ESRI:102122": {
    proj4: "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      131753.1745101274,
      135999.07125824783,
      786817.144984229,
      870497.1390348179
    ]
  },
  "ESRI:102132": {
    proj4: "+proj=utm +zone=32 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      166055.21938888275,
      0,
      534990.7677408743,
      9328118673670318e-9
    ]
  },
  "ESRI:102133": {
    proj4: "+proj=utm +zone=33 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      166055.21938888478,
      0,
      534990.7677408744,
      9328118673670318e-9
    ]
  },
  "ESRI:102134": {
    proj4: "+proj=utm +zone=34 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      166055.21938888368,
      0,
      534990.7677408744,
      9328118673670318e-9
    ]
  },
  "ESRI:102135": {
    proj4: "+proj=utm +zone=35 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      166055.21938888298,
      0,
      534990.7677408742,
      9328118673670318e-9
    ]
  },
  "ESRI:102136": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=19999.32 +y_0=-202977.79 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1640.1572049362476,
      402.05319511002745,
      17189.483454060395,
      23867.728673969978
    ]
  },
  "ESRI:102137": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=6.05625 +k=1 +x_0=100000 +y_0=-200000 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      48990.49794872197,
      41514.482411607256,
      80412.1084629142,
      83391.37768866937
    ]
  },
  "ESRI:102138": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=0 +y_0=-212979.18 +a=6377492.018 +rf=299.1528128 +units=m +no_defs +type=crs",
    projected_bounds: [
      -13630.897030678289,
      -11352.870066170057,
      13727.44293210578,
      25409.92904438777
    ]
  },
  "ESRI:102141": {
    proj4: "+proj=utm +zone=49 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      784720.3243730188,
      2.4498325846408545e6,
      860988.681396378,
      2501308917190984e-9
    ]
  },
  "ESRI:102142": {
    proj4: "+proj=utm +zone=50 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      165727.8427881928,
      2450810885094861e-9,
      243970.5163372818,
      2499196679881254e-9
    ]
  },
  "ESRI:102143": {
    proj4: "+proj=utm +zone=39 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      454424.42557965807,
      2715232072567749e-9,
      702343.1924578515,
      2993653394455692e-9
    ]
  },
  "ESRI:102144": {
    proj4: "+proj=utm +zone=28 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -98683.38555237313,
      2108107093497239e-9,
      1.1260029481939268e6,
      3.0765287604928566e6
    ]
  },
  "ESRI:102150": {
    proj4: "+proj=utm +zone=56 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "ESRI:102156": {
    proj4: "+proj=utm +zone=56 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      166060.18670262297,
      0,
      534990.2472652404,
      932797992111379e-8
    ]
  },
  "ESRI:102157": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      731814458122962e-8,
      4636832003638881e-9,
      7655150637981662e-9,
      5118657596041616e-9
    ]
  },
  "ESRI:102158": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      293795.98374013766,
      230481.05102648493,
      714936.3252875668,
      696595.4539879942
    ]
  },
  "ESRI:102159": {
    proj4: "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      18299.97578720722,
      3124.539670077549,
      34797.878456422775,
      21956.258423163847
    ]
  },
  "ESRI:102160": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=200180.598 +y_0=299913.01 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.5213898607295845e6,
      -521834.56951464084,
      358354.99411498726,
      679732.8546969534
    ]
  },
  "ESRI:102161": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.7213898607295845e6,
      -821834.5695146408,
      158354.99411498726,
      379732.85469695344
    ]
  },
  "ESRI:102162": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      333898.0006933059,
      4.2430993868726175e6,
      502592.74225173006,
      4332386361786783e-9
    ]
  },
  "ESRI:102163": {
    proj4: "+proj=bonne +lat_1=39.6666666666667 +lon_0=-8.13190611111111 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs +type=crs",
    projected_bounds: [
      -262783526291549e-8,
      -757747.1127005129,
      158133.65497639615,
      379644.18687968596
    ]
  },
  "ESRI:102164": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.5215704587295847e6,
      -521747.57951464085,
      358174.39611498726,
      679819.8446969534
    ]
  },
  "ESRI:102165": {
    proj4: "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.7215704587295847e6,
      -821747.5795146408,
      158174.39611498726,
      379819.8446969534
    ]
  },
  "ESRI:102166": {
    proj4: "+proj=utm +zone=25 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      643143.7876827708,
      4351456063496282e-9,
      669591.7477979186,
      4404180117411035e-9
    ]
  },
  "ESRI:102168": {
    proj4: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      596263.3900096521,
      4081062012849771e-9,
      709095.2114175938,
      4204118742699012e-9
    ]
  },
  "ESRI:102173": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      144693.2803694181,
      137212.44215662032,
      821516.4770167258,
      908411.1932242764
    ]
  },
  "ESRI:102174": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5438679954042289e-9,
      5569692263086982e-9,
      5595142645542588e-9,
      6136746812857672e-9
    ]
  },
  "ESRI:102175": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6391112088834764e-9,
      5473661653540782e-9,
      6593747046274156e-9,
      6201308275430432e-9
    ]
  },
  "ESRI:102176": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7390450406876147e-9,
      5440301581136983e-9,
      7597051412098972e-9,
      6047705957969969e-9
    ]
  },
  "ESRI:102177": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8390252491822466e-9,
      5430293875972978e-9,
      850973870368214e-8,
      6031098580414013e-9
    ]
  },
  "ESRI:102178": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      134500.84033836157,
      5436019474645312e-9,
      779775.3606400313,
      6659151301168667e-9
    ]
  },
  "ESRI:102179": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs +type=crs",
    projected_bounds: [
      -365499.15966163843,
      5436019474645312e-9,
      279775.36064003134,
      6659151301168667e-9
    ]
  },
  "ESRI:102191": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      77258.7817229976,
      108347.81313878018,
      896150.5342996041,
      604512.3049631496
    ]
  },
  "ESRI:102192": {
    proj4: "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.999615596 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -273181.22739656095,
      100176.74454774617,
      671954.2608965117,
      501953.5311350896
    ]
  },
  "ESRI:102193": {
    proj4: "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.9996 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -8108.00633537746,
      -104804.31618778949,
      878054.505478792,
      603429.7195900653
    ]
  },
  "ESRI:102194": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      144693.2803694181,
      137212.44215662032,
      821516.4770167258,
      908411.1932242764
    ]
  },
  "ESRI:102195": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5438679954042289e-9,
      5569692263086982e-9,
      5595142645542588e-9,
      6136746812857672e-9
    ]
  },
  "ESRI:102196": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      6391112088834764e-9,
      5473661653540782e-9,
      6593747046274156e-9,
      6201308275430432e-9
    ]
  },
  "ESRI:102197": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7390450406876147e-9,
      5440301581136983e-9,
      7597051412098972e-9,
      6047705957969969e-9
    ]
  },
  "ESRI:102198": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8390252491822466e-9,
      5430293875972978e-9,
      850973870368214e-8,
      6031098580414013e-9
    ]
  },
  "ESRI:102204": {
    proj4: "+proj=lcc +lat_0=24 +lon_0=45 +lat_1=21 +lat_2=27 +x_0=1000000 +y_0=3000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -127952.71283472073,
      2196009116016022e-9,
      2.0146142119743838e6,
      3944644677465817e-9
    ]
  },
  "ESRI:102212": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-107.5 +lat_1=41 +lat_2=45 +x_0=500000 +y_0=200000 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      200521.35415134445,
      205236.93502634537,
      771899.466125052,
      650887.3617289878
    ]
  },
  "ESRI:102213": {
    proj4: "+proj=utm +zone=58 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      833978.5569194646,
      0,
      604608.8374339284,
      93362819911462e-7
    ]
  },
  "ESRI:102215": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=-8000000 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -3.8944813792947084e6,
      -1171128340235333e-9,
      371689.59336957894,
      2.9148444240584467e6
    ]
  },
  "ESRI:102216": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=115.816666666667 +k=0.99999906 +x_0=50000 +y_0=3800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      15120.628229840506,
      100980.83420608984,
      75378.80291093678,
      332040.77969689714
    ]
  },
  "ESRI:102217": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      926688.4431870921,
      745142.7185288663,
      2.6359087245902866e6,
      2514550203810799e-9
    ]
  },
  "ESRI:102219": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      926688.4431870921,
      745142.7185288663,
      2.6359087245902866e6,
      2514550203810799e-9
    ]
  },
  "ESRI:102220": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      926688.4431870921,
      745142.7185288663,
      2.6359087245902866e6,
      2514550203810799e-9
    ]
  },
  "ESRI:102221": {
    proj4: "+proj=lcc +lat_0=10.4666666666667 +lon_0=-84.3333333333333 +lat_1=9.93333333333333 +lat_2=11 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -187482.22094174335,
      -644355.7439807155,
      816513.5088377701,
      417443.93767210934
    ]
  },
  "ESRI:102222": {
    proj4: "+proj=lcc +lat_0=9 +lon_0=-83.6666666666667 +lat_1=8.46666666666667 +lat_2=9.53333333333333 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -259876.25056214246,
      -424200.19981755083,
      744058.5058382754,
      635211.124365133
    ]
  },
  "ESRI:102223": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -218747.2981735482,
      239163.35984322816,
      780089.5011941935,
      1302402893515359e-9
    ]
  },
  "ESRI:102224": {
    proj4: "+proj=utm +zone=46 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      72923.75984682492,
      4775266011927152e-9,
      710986.533689475,
      5641880328029306e-9
    ]
  },
  "ESRI:102225": {
    proj4: "+proj=utm +zone=47 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      252080.99849398347,
      4669677326634623e-9,
      705239.4449553548,
      5781966310022121e-9
    ]
  },
  "ESRI:102226": {
    proj4: "+proj=utm +zone=48 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      249906.26920316683,
      4.6074932431454975e6,
      708581.467303173,
      5700802701383291e-9
    ]
  },
  "ESRI:102227": {
    proj4: "+proj=utm +zone=49 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      252902.66241975283,
      4692997498502492e-9,
      713956.0872704254,
      5568510768104485e-9
    ]
  },
  "ESRI:102228": {
    proj4: "+proj=utm +zone=50 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      263142.66725616215,
      4976220828020757e-9,
      709282.4640830864,
      557834483335144e-8
    ]
  },
  "ESRI:102231": {
    proj4: "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-80.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1091798132456136e6,
      627475.2675294002,
      1.1669515609506299e6,
      765770.7047797568
    ]
  },
  "ESRI:102232": {
    proj4: "+proj=tmerc +lat_0=4.68333333333333 +lon_0=-74.15 +k=1.00039978753252 +x_0=92334.879 +y_0=109320.965 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      64568.031159281316,
      -876693.8088877276,
      899042.1630718827,
      383041.0996143286
    ]
  },
  "ESRI:102233": {
    proj4: "+proj=tmerc +lat_0=4.68048611111111 +lon_0=-74.1465916666667 +k=1.00039980326544 +x_0=92334.879 +y_0=109320.965 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      64190.583319260564,
      -876368.1662661405,
      898630.5356762911,
      383346.8048169095
    ]
  },
  "ESRI:102237": {
    proj4: "+proj=aeqd +lat_0=6.96507569444444 +lon_0=158.209299222222 +x_0=80122.82 +y_0=80747.24 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.4813294048348446e6,
      -782588.9004335749,
      890807.5353954006,
      804187.7375996907
    ]
  },
  "ESRI:102238": {
    proj4: "+proj=aeqd +lat_0=15.1675572222222 +lon_0=145.711286944444 +x_0=50000 +y_0=50000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -426621.4409257619,
      -253905.62525788572,
      442378.95469120744,
      1.0207199936396925e6
    ]
  },
  "ESRI:102239": {
    proj4: "+proj=aeqd +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      -339110.9896794145,
      -226385.50387598632,
      417526.6371733461,
      322404.28679095366
    ]
  },
  "ESRI:102240": {
    proj4: "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -289363.20353853126,
      -79791.91367494612,
      467479.62659015553,
      469674.74680545373
    ]
  },
  "ESRI:102247": {
    proj4: "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -2257390058712074e-9,
      726720.2472649922,
      858192.2020793316,
      2534628449266282e-9
    ]
  },
  "ESRI:102306": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=evrst30 +units=m +no_defs +type=crs",
    projected_bounds: [
      106583.96862128034,
      2.9199758700847197e6,
      904525.0925631839,
      3.3746924153766325e6
    ]
  },
  "ESRI:102319": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      126609.87774520974,
      329208.22487068037,
      349256.0290086116,
      457751.64988159714
    ]
  },
  "ESRI:102328": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2.2352668111091256e6,
      5241112021255831e-9,
      2.6875544687391687e6,
      6199017378985492e-9
    ]
  },
  "ESRI:102329": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32693696980614353e-9,
      5259486119610154e-9,
      3288583564742981e-8,
      6114820676797406e-9
    ]
  },
  "ESRI:102359": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=3500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2781673767152794e-9,
      5279107385139612e-9,
      3.3124455312608313e6,
      6199017378985492e-9
    ]
  },
  "ESRI:102360": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      332414919039561e-7,
      5261988811040167e-9,
      3350255683170643e-8,
      6.0981305305440705e6
    ]
  },
  "ESRI:102364": {
    proj4: "+proj=utm +zone=59 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      255040.97594940502,
      5433975758357479e-9,
      686334.7381179817,
      6241316103447333e-9
    ]
  },
  "ESRI:102365": {
    proj4: "+proj=utm +zone=60 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275878.0522029962,
      5311765433025767e-9,
      683820.3879196523,
      6284675176375143e-9
    ]
  },
  "ESRI:102366": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      345064.999811003,
      334042.2043816056,
      1.0216737560440707e6,
      954041.2676046817
    ]
  },
  "ESRI:102367": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386918.31041990273,
      638611.495563188,
      538646.0751082397,
      1.8010582813575123e6
    ]
  },
  "ESRI:102368": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      387480.7933152069,
      638594.4905497337,
      574961.5237298968,
      1.8265091488610085e6
    ]
  },
  "ESRI:102369": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384866.0062102319,
      570683.0524052249,
      574413.9786087219,
      1.8543974615086422e6
    ]
  },
  "ESRI:102370": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      374335.66296567384,
      193265.41672186597,
      576665.1462954525,
      1927037849194219e-9
    ]
  },
  "ESRI:102371": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      371683.47061143327,
      100891.27017918504,
      571564.5392518891,
      1.9402596195834302e6
    ]
  },
  "ESRI:102372": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      369227.2759588344,
      37478.56021629183,
      573639.6586334868,
      1866650932337704e-9
    ]
  },
  "ESRI:102373": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      353035.9059764714,
      40196.47731406788,
      579818.6224001455,
      1678220016121422e-9
    ]
  },
  "ESRI:102374": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      305398.63289577013,
      281655.18765712064,
      591427.5708482452,
      1.3181762713116712e6
    ]
  },
  "ESRI:102375": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195688.3999031469,
      98298.29792074177,
      1.7230791763698556e6,
      427904.9014095053
    ]
  },
  "ESRI:102389": {
    proj4: "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2863921547093693e-9,
      397181.3722948599,
      2.9038183578230315e6,
      508581.74633465835
    ]
  },
  "ESRI:102390": {
    proj4: "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2863921547093693e-9,
      397181.3722948599,
      2.9038183578230315e6,
      508581.74633465835
    ]
  },
  "ESRI:102391": {
    proj4: "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2863921547093693e-9,
      397181.3722948599,
      2.9038183578230315e6,
      508581.74633465835
    ]
  },
  "ESRI:102392": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2626812220414057e6,
      1.8723159810994754e6,
      1.8845565281521187e6,
      6083969004966271e-9
    ]
  },
  "ESRI:102393": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2281329209132183e6,
      634071.6213616553,
      1.8919422341376673e6,
      6322290010231368e-9
    ]
  },
  "ESRI:102394": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2194315198310143e6,
      331007.44224620966,
      1.8752079925289094e6,
      6365668435249971e-9
    ]
  },
  "ESRI:102395": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2113731545416126e6,
      122960.90964295079,
      1.8820161133667014e6,
      6124170600511285e-9
    ]
  },
  "ESRI:102396": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1582519681911431e6,
      131877.94265457106,
      1.9022882636578141e6,
      5505960169558366e-9
    ]
  },
  "ESRI:102397": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0019620147588761e6,
      924063.7281717367,
      1.9403752886912876e6,
      4324716650128375e-9
    ]
  },
  "ESRI:102398": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      642021.0253489078,
      322500.3324283003,
      5.6531355978067685e6,
      1.4038846640410188e6
    ]
  },
  "ESRI:102399": {
    proj4: "+proj=aea +lat_0=42.5 +lon_0=-106 +lat_1=43.5 +lat_2=48 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs +type=crs",
    projected_bounds: [
      -803500.791973373,
      250717.31329258875,
      707316.5766600823,
      776638.2928610736
    ]
  },
  "ESRI:102400": {
    proj4: "+proj=tmerc +lat_0=51.1666666666667 +lon_0=-0.158333333333333 +k=0.9999999 +x_0=78250 +y_0=-2800 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      40390.084745142914,
      1047.8656636741675,
      130562.2409085767,
      67935.14517664416
    ]
  },
  "ESRI:102401": {
    proj4: "+proj=utm +zone=1 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275705.2007711646,
      5307320288937037e-9,
      651326.6101829188,
      7012536575907362e-9
    ]
  },
  "ESRI:102402": {
    proj4: "+proj=utm +zone=2 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      279095.5340691147,
      5394004676025433e-9,
      597909.7820209023,
      8108518214682238e-9
    ]
  },
  "ESRI:102403": {
    proj4: "+proj=utm +zone=3 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      282881.3113258418,
      5489589711728697e-9,
      590937.4580819238,
      8246692023643711e-9
    ]
  },
  "ESRI:102404": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -150974.3007255057,
      5524302056898751e-9,
      409666.30766011134,
      8246661563622341e-9
    ]
  },
  "ESRI:102405": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      294760.555044646,
      5781966310022121e-9,
      588565.914905008,
      8293495466051285e-9
    ]
  },
  "ESRI:102406": {
    proj4: "+proj=utm +zone=6 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      303614.943130552,
      599324839556645e-8,
      591839.6077320275,
      8228862484656331e-9
    ]
  },
  "ESRI:102407": {
    proj4: "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      300888.49477118085,
      5928746531703682e-9,
      594878.9639862768,
      8168689220963358e-9
    ]
  },
  "ESRI:102408": {
    proj4: "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      301497.8173291563,
      5943203448548857e-9,
      597965.8260328542,
      8107403958493016e-9
    ]
  },
  "ESRI:102409": {
    proj4: "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      227475.2739848646,
      3919318118925639e-9,
      682991.4437860795,
      6303587686966957e-9
    ]
  },
  "ESRI:102410": {
    proj4: "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      212172.22206675174,
      3382455381866777e-9,
      719747.7478332217,
      5441824852507818e-9
    ]
  },
  "ESRI:102411": {
    proj4: "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      213181.34452594037,
      3.4201591228960655e6,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "ESRI:102412": {
    proj4: "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      214532.47558561602,
      3470063347430235e-9,
      719369.7373790785,
      5432904306382319e-9
    ]
  },
  "ESRI:102413": {
    proj4: "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      207672.60560265684,
      3209479925667875e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "ESRI:102414": {
    proj4: "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199250.35388242255,
      2860290264055177e-9,
      719369.7373790776,
      5432904306382319e-9
    ]
  },
  "ESRI:102415": {
    proj4: "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      197690.84663826128,
      2835929428023703e-9,
      717738.3550121312,
      5474028648072391e-9
    ]
  },
  "ESRI:102416": {
    proj4: "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194701.98624121048,
      2654154227656937e-9,
      722387.4042487555,
      5356218117683916e-9
    ]
  },
  "ESRI:102417": {
    proj4: "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      194325.66756335914,
      2.6364238174826605e6,
      731748.2606832965,
      5112867417055887e-9
    ]
  },
  "ESRI:102418": {
    proj4: "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      205723.7692717061,
      3131872261800517e-9,
      736322.492924318,
      4990662135233918e-9
    ]
  },
  "ESRI:102419": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      221647.2089282641,
      3.7229509105618917e6,
      726813.6466742919,
      5261788015335406e-9
    ]
  },
  "ESRI:102421": {
    proj4: "+proj=eqc +lat_ts=22.94791772 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1845173293013797e-8,
      0,
      1845173293013797e-8,
      3562223705384754e-9
    ]
  },
  "ESRI:102422": {
    proj4: "+proj=eqc +lat_ts=41.12682127 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -15093364960370367e-9,
      3562223705384754e-9,
      15093364960370367e-9,
      5343335558077131e-9
    ]
  },
  "ESRI:102423": {
    proj4: "+proj=eqc +lat_ts=52.28859923 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12256632600801028e-9,
      5343335558077131e-9,
      12256632600801028e-9,
      623389148442332e-8
    ]
  },
  "ESRI:102424": {
    proj4: "+proj=eqc +lat_ts=60.32378942 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9920529638482202e-9,
      623389148442332e-8,
      9920529638482202e-9,
      7124447410769508e-9
    ]
  },
  "ESRI:102425": {
    proj4: "+proj=eqc +lat_ts=66.09421768 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8119876684285576e-9,
      7124447410769508e-9,
      8119876684285576e-9,
      7569725373942603e-9
    ]
  },
  "ESRI:102426": {
    proj4: "+proj=eqc +lat_ts=70.10896259 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6817410753248211e-9,
      7569725373942603e-9,
      6817410753248211e-9,
      8015003337115697e-9
    ]
  },
  "ESRI:102427": {
    proj4: "+proj=eqc +lat_ts=74.13230145 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5478594967773253e-9,
      8015003337115697e-9,
      5478594967773253e-9,
      8460281300288793e-9
    ]
  },
  "ESRI:102428": {
    proj4: "+proj=eqc +lat_ts=78.1728375 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.1068894223160488e6,
      8460281300288793e-9,
      4.1068894223160488e6,
      8905559263461886e-9
    ]
  },
  "ESRI:102429": {
    proj4: "+proj=aeqd +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [-13677172114364422e-26, 1.1168258573726728e6, 0, 0]
  },
  "ESRI:102430": {
    proj4: "+proj=eqc +lat_ts=-22.94791772 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -1845173293013797e-8,
      -3562223705384754e-9,
      1845173293013797e-8,
      0
    ]
  },
  "ESRI:102431": {
    proj4: "+proj=eqc +lat_ts=-41.12682127 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -15093364960370367e-9,
      -5343335558077131e-9,
      15093364960370367e-9,
      -3562223705384754e-9
    ]
  },
  "ESRI:102432": {
    proj4: "+proj=eqc +lat_ts=-52.28859923 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -12256632600801028e-9,
      -623389148442332e-8,
      12256632600801028e-9,
      -5343335558077131e-9
    ]
  },
  "ESRI:102433": {
    proj4: "+proj=eqc +lat_ts=-60.32378942 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -9920529638482202e-9,
      -7124447410769508e-9,
      9920529638482202e-9,
      -623389148442332e-8
    ]
  },
  "ESRI:102434": {
    proj4: "+proj=eqc +lat_ts=-66.09421768 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8119876684285576e-9,
      -7569725373942603e-9,
      8119876684285576e-9,
      -7124447410769508e-9
    ]
  },
  "ESRI:102435": {
    proj4: "+proj=eqc +lat_ts=-70.10896259 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6817410753248211e-9,
      -8015003337115697e-9,
      6817410753248211e-9,
      -7569725373942603e-9
    ]
  },
  "ESRI:102436": {
    proj4: "+proj=eqc +lat_ts=-74.13230145 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5478594967773253e-9,
      -8460281300288793e-9,
      5478594967773253e-9,
      -8015003337115697e-9
    ]
  },
  "ESRI:102437": {
    proj4: "+proj=eqc +lat_ts=-78.1728375 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.1068894223160488e6,
      -8905559263461886e-9,
      4.1068894223160488e6,
      -8460281300288793e-9
    ]
  },
  "ESRI:102438": {
    proj4: "+proj=aeqd +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [0, 0, 13677172114364422e-26, -1.1168258573726728e6]
  },
  "ESRI:102440": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      189423.14348479116,
      6180420277938851e-9,
      749893.1876944554,
      6446584797039657e-9
    ]
  },
  "ESRI:102445": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000.00000001 +y_0=-5000000.00000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1321007535466326e6,
      1.0959367988752841e6,
      3.3519413146212893e6,
      3.1300503921329933e6
    ]
  },
  "ESRI:102446": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2694144901026343e6,
      2.0951778816935595e6,
      1.7672079980842862e6,
      5908972044753772e-9
    ]
  },
  "ESRI:102447": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1271259902734978e-9,
      2095122091078585e-9,
      1.8863529324371733e6,
      5992472099221492e-9
    ]
  },
  "ESRI:102448": {
    proj4: "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18300.52466726637,
      7554.079194960537,
      26550.135794062695,
      20843.25321008832
    ]
  },
  "ESRI:102450": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=19999.32 +y_0=-202977.79 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -1640.1572049343777,
      402.05319511002745,
      17189.483454062254,
      23867.728673969978
    ]
  },
  "ESRI:102451": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=-4.66666666666667 +k=1 +x_0=100000 +y_0=-200000 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      48990.49794872214,
      41514.482411607256,
      80412.10846291437,
      83391.37768866937
    ]
  },
  "ESRI:102452": {
    proj4: "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=-212979.18 +a=6377492.018 +rf=299.1528128 +pm=oslo +units=m +no_defs +type=crs",
    projected_bounds: [
      -13630.897030676413,
      -11352.870066170057,
      13727.442932107637,
      25409.92904438777
    ]
  },
  "ESRI:102453": {
    proj4: "+proj=utm +zone=50 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166473.25859805953,
      332029.32527767634,
      809770.0444317085,
      2435724332257584e-9
    ]
  },
  "ESRI:102454": {
    proj4: "+proj=utm +zone=51 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166473.25859805953,
      332029.32527767634,
      805232.3952393059,
      2.6573258808565615e6
    ]
  },
  "ESRI:102455": {
    proj4: "+proj=utm +zone=52 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166827.3685123268,
      442708.0881888528,
      813931.1095911756,
      2214162532777211e-9
    ]
  },
  "ESRI:102456": {
    proj4: "+proj=utm +zone=50 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166473.25859805953,
      332029.32527767634,
      809770.0444317085,
      2435724332257584e-9
    ]
  },
  "ESRI:102457": {
    proj4: "+proj=utm +zone=51 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166473.25859805953,
      332029.32527767634,
      805232.3952393059,
      2.6573258808565615e6
    ]
  },
  "ESRI:102458": {
    proj4: "+proj=utm +zone=52 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      166827.3685123268,
      442708.0881888528,
      813931.1095911756,
      2214162532777211e-9
    ]
  },
  "ESRI:102459": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=1.00011328 +x_0=800143.966400001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3977186632184507e6,
      487117.8308914298,
      2575010326321477e-9,
      795888.3325155156
    ]
  },
  "ESRI:102461": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4329928156947168e6,
      13666.559770084383,
      1.9007962855239566e6,
      544149.5102007154
    ]
  },
  "ESRI:102462": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1403062033599321e-9,
      42875.85651558047,
      1.8912597372241411e6,
      337171.790423518
    ]
  },
  "ESRI:102464": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5216849484829784e6,
      -8341.706848124524,
      1731701042635238e-9,
      165982.49993149476
    ]
  },
  "ESRI:102465": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5951601757974455e6,
      23026.867562442345,
      1.7002394930937402e6,
      146558.30015981727
    ]
  },
  "ESRI:102470": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102471": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102472": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102473": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102474": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102475": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102476": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102477": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=29 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102478": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102479": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs +type=crs"
  },
  "ESRI:102480": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=15 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102481": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=17 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102482": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102483": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102484": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102485": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102486": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102487": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=29 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102488": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102489": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs"
  },
  "ESRI:102491": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -745148.5644626438,
      -1540512740617861e-9,
      1306498972404465e-9,
      649217.1577376176
    ]
  },
  "ESRI:102492": {
    proj4: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      -730806.5073378927,
      -1.2359342113107245e6,
      1.3094768390592253e6,
      947034.8429130843
    ]
  },
  "ESRI:102498": {
    proj4: "+proj=geos +lon_0=-75 +h=35786023 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [1 / 0, 1 / 0, 1 / 0, 1 / 0]
  },
  "ESRI:102499": {
    proj4: "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=49.8333339 +lat_2=51.1666672333333 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      14722.202009434055,
      22542.415777729824,
      291109.4867110994,
      246366.94700796064
    ]
  },
  "ESRI:102525": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4329928156947168e6,
      13666.559770084383,
      1.9007962855239566e6,
      544149.5102007154
    ]
  },
  "ESRI:102526": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1403062033599321e-9,
      42875.85651558047,
      1.8912597372241411e6,
      337171.790423518
    ]
  },
  "ESRI:102528": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5216849484829784e6,
      -8341.706848124524,
      1731701042635238e-9,
      165982.49993149476
    ]
  },
  "ESRI:102529": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5951601757974455e6,
      23026.867562442345,
      1.7002394930937402e6,
      146558.30015981727
    ]
  },
  "ESRI:102550": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=0.9996 +x_0=9500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      9376404725227272e-9,
      4040358875945567e-9,
      9624019379841173e-9,
      4663160980253888e-9
    ]
  },
  "ESRI:102551": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=10500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      10364900285744157e-9,
      3991708554302941e-9,
      10625278662164634e-9,
      4590989969611894e-9
    ]
  },
  "ESRI:102552": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.9996 +x_0=11500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      11364746564589227e-9,
      3.9817248934327797e6,
      1162409733895567e-8,
      4658719465754718e-9
    ]
  },
  "ESRI:102553": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=12500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      12364474108722312e-9,
      3.9639765096455654e6,
      12623941359979834e-9,
      4667602523833993e-9
    ]
  },
  "ESRI:102554": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=39 +k=0.9996 +x_0=13500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      13365933614807758e-9,
      405826989292367e-8,
      1362579699570518e-8,
      4561013494568535e-9
    ]
  },
  "ESRI:102555": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=42 +k=0.9996 +x_0=14500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      14366560694908561e-9,
      4098209712537052e-9,
      1462500879551467e-8,
      4606533847140622e-9
    ]
  },
  "ESRI:102556": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=45 +k=0.9996 +x_0=15500000 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      15366473284001596e-9,
      4.0926623796420237e6,
      15485706409577737e-9,
      454107033511379e-8
    ]
  },
  "ESRI:102562": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92337.12260687677,
      -3.8617456017202716e6,
      98017.40326536167,
      -3.1409609017624347e6
    ]
  },
  "ESRI:102563": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92337.12260687648,
      -3.8617456017202716e6,
      102160.21451244314,
      -2739846247483812e-9
    ]
  },
  "ESRI:102564": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92104.09145680397,
      -3.7929543771656463e6,
      101747.35573579097,
      -2795238335653293e-9
    ]
  },
  "ESRI:102565": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92104.09145680367,
      -3.7929543771656463e6,
      102201.07382381843,
      -273430723652643e-8
    ]
  },
  "ESRI:102566": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92570.2176986904,
      -3745254667120244e-9,
      102586.50769540344,
      -2536026772435321e-9
    ]
  },
  "ESRI:102567": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -94357.7898872217,
      -3656528533778404e-9,
      103171.5459594391,
      -2.4485347182507594e6
    ]
  },
  "ESRI:102568": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -96076.97872142438,
      -3.4735469380844003e6,
      105168.1539512989,
      -2458515498024216e-9
    ]
  },
  "ESRI:102569": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs +type=crs",
    projected_bounds: [
      376541.0673042309,
      46994626215635e-7,
      610021.2746465626,
      5417462952309373e-9
    ]
  },
  "ESRI:102570": {
    proj4: "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "ESRI:102571": {
    proj4: "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054197,
      0,
      534994.6550611365,
      9329005182447437e-9
    ]
  },
  "ESRI:102572": {
    proj4: "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "ESRI:102573": {
    proj4: "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053917,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "ESRI:102574": {
    proj4: "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053842,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "ESRI:102575": {
    proj4: "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      534994.6550611363,
      9329005182447437e-9
    ]
  },
  "ESRI:102576": {
    proj4: "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053987,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "ESRI:102577": {
    proj4: "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053842,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "ESRI:102578": {
    proj4: "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053772,
      0,
      534994.655061136,
      9329005182447437e-9
    ]
  },
  "ESRI:102579": {
    proj4: "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053952,
      0,
      534994.6550611362,
      9329005182447437e-9
    ]
  },
  "ESRI:102580": {
    proj4: "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.4430805386,
      0,
      534994.6550611361,
      9329005182447437e-9
    ]
  },
  "ESRI:102581": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=2.33722916666667 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      64323.228058545734,
      1.0744025369253752e6,
      1012133125269436e-9,
      1.3985533017506995e6
    ]
  },
  "ESRI:102582": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.33722916666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      5094.300077015301,
      1.7301473029733542e6,
      1.0132122316130111e6,
      2.6985567123740967e6
    ]
  },
  "ESRI:102583": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=2.33722916666667 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      259837.90399363433,
      3.0118823997281585e6,
      1.0200108643185932e6,
      3364836752198771e-9
    ]
  },
  "ESRI:102584": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=2.33722916666667 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      515904.7719634877,
      4.1095259808092187e6,
      593562.8907930725,
      4311753164314833e-9
    ]
  },
  "ESRI:102585": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=2.33722916666667 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      64323.228058545734,
      1.0744025369253752e6,
      1012133125269436e-9,
      1.3985533017506995e6
    ]
  },
  "ESRI:102586": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.33722916666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      5094.300077015301,
      1.7301473029733542e6,
      1.0132122316130111e6,
      2.6985567123740967e6
    ]
  },
  "ESRI:102587": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=2.33722916666667 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      259837.90399363433,
      3.0118823997281585e6,
      1.0200108643185932e6,
      3364836752198771e-9
    ]
  },
  "ESRI:102588": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=2.33722916666667 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      515904.7719634877,
      4.1095259808092187e6,
      593562.8907930725,
      4311753164314833e-9
    ]
  },
  "ESRI:102589": {
    proj4: "+proj=aea +lat_0=25 +lon_0=-86 +lat_1=31 +lat_2=41 +x_0=0 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -13431309383211242e-9,
      933736.8082124646,
      506231717507771e-8,
      9603656385096047e-9
    ]
  },
  "ESRI:102598": {
    proj4: "+proj=utm +zone=56 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053545,
      0,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "ESRI:102599": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219202.43840488 +datum=WGS84 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.3733729378337765e6,
      7157297499701717e-9,
      1600162449321735e-9,
      1062814285582016e-8
    ]
  },
  "ESRI:102600": {
    proj4: "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219202.43840488 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.3733729378402433e6,
      7157297499408111e-9,
      1.6001624493334477e6,
      10628142855475314e-9
    ]
  },
  "ESRI:102604": {
    proj4: "+proj=lcc +lat_0=0 +lon_0=-83.5 +lat_1=31.4166666666667 +lat_2=34.2833333333333 +x_0=0 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -665878.263948777,
      11672946290133506e-9,
      817774.4158078324,
      1336866924600574e-8
    ]
  },
  "ESRI:102629": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      356385.00857013045,
      179509.22097966477,
      938689.3006999342,
      1.6385722924042298e6
    ]
  },
  "ESRI:102630": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1658725179634638e-9,
      52243.82085900211,
      2327799144064897e-9,
      1.8284720237264603e6
    ]
  },
  "ESRI:102631": {
    proj4: "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000.00000001 +y_0=-5000000.00000001 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1321007535466326e6,
      1.0959367988752841e6,
      3.3519413146212893e6,
      3.1300503921329933e6
    ]
  },
  "ESRI:102632": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2694144901026343e6,
      2.0951778816935595e6,
      1.7672079980842862e6,
      5908972044753772e-9
    ]
  },
  "ESRI:102633": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1271259902734978e-9,
      2095122091078585e-9,
      1.8863529324371733e6,
      5992472099221492e-9
    ]
  },
  "ESRI:102634": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2626812220414057e6,
      1.8723159810994754e6,
      1.8845565281521187e6,
      6083969004966271e-9
    ]
  },
  "ESRI:102635": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2281329209132183e6,
      634071.6213616553,
      1.8919422341376673e6,
      6322290010231368e-9
    ]
  },
  "ESRI:102636": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2194315198310143e6,
      331007.44224620966,
      1.8752079925289094e6,
      6365668435249971e-9
    ]
  },
  "ESRI:102637": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2113731545416126e6,
      122960.90964295079,
      1.8820161133667014e6,
      6124170600511285e-9
    ]
  },
  "ESRI:102638": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1582519681911431e6,
      131877.94265457106,
      1.9022882636578141e6,
      5505960169558366e-9
    ]
  },
  "ESRI:102639": {
    proj4: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0019620147588761e6,
      924063.7281717367,
      1.9403752886912876e6,
      4324716650128375e-9
    ]
  },
  "ESRI:102640": {
    proj4: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      642019.6689656085,
      322497.38237532554,
      5.6531355978067685e6,
      1.4038846640410188e6
    ]
  },
  "ESRI:102648": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      218114.97475689944,
      123401.79472844946,
      1.0289517403819412e6,
      2.1888841388253327e6
    ]
  },
  "ESRI:102649": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      252464.334804722,
      122937.7386286709,
      1.1311468685863977e6,
      2190281948423275e-9
    ]
  },
  "ESRI:102650": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      371573.47967000835,
      383549.52872588683,
      1.0591822573695194e6,
      2.1856897026296905e6
    ]
  },
  "ESRI:102661": {
    proj4: "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4329944917982805e6,
      13668.25884190916,
      1900797845492912e-9,
      544151.0768987518
    ]
  },
  "ESRI:102662": {
    proj4: "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4030638053929785e6,
      42877.42416738123,
      1.8912613878018283e6,
      337173.28459348046
    ]
  },
  "ESRI:102664": {
    proj4: "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5216869017012673e6,
      -8340.229254255622,
      173170294424907e-8,
      165983.93443107425
    ]
  },
  "ESRI:102665": {
    proj4: "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5951621599434258e6,
      23028.360746265393,
      1.7002414515377043e6,
      146559.76296252786
    ]
  },
  "ESRI:102688": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000.00000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      25363368162218485e-9,
      127241.51706917831,
      27113045779802643e-9,
      1.3093888046044877e6
    ]
  },
  "ESRI:102689": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=6000000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1897394395364815e-8,
      188023.9702131806,
      20218594739187993e-9,
      956034.6391093921
    ]
  },
  "ESRI:102690": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=3999999.99999999 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      12349502799036857e-9,
      82266.53798507435,
      1370975390088062e-8,
      999142.960027688
    ]
  },
  "ESRI:102696": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333333333 +x_0=250000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      385268.96083548444,
      56666.22381995804,
      1.2089042019821804e6,
      1742519083813166e-9
    ]
  },
  "ESRI:102697": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333333333 +x_0=500000.000000001 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2611608075152596e6,
      237940.31390510342,
      1.9430423290836033e6,
      1.7413015294174773e6
    ]
  },
  "ESRI:102698": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941176470588 +x_0=850000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.4153297683948986e6,
      116525.20511289821,
      3.0719856349942265e6,
      1.6124571349520911e6
    ]
  },
  "ESRI:102699": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=124358.648717297 +y_0=-81076.9621539243 +datum=NAD27 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -646562.07759062,
      -517357.9761918311,
      1.5585827325611108e6,
      596925.6252033658
    ]
  },
  "ESRI:102700": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      251083.94755166615,
      108544.80954786348,
      3277936511710215e-9,
      1.7811521241800245e6
    ]
  },
  "ESRI:102701": {
    proj4: "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      363588.224686614,
      2157776289271998e-9,
      809130.2828161139,
      2467998025444025e-9
    ]
  },
  "ESRI:102702": {
    proj4: "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      183890.92296712555,
      2.0891216193225265e6,
      318974.86555910145,
      2.3076325822246308e6
    ]
  },
  "ESRI:102703": {
    proj4: "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      512925.15731334634,
      8387017607775072e-9,
      814222.9665084919,
      8438161672488501e-9
    ]
  },
  "ESRI:102705": {
    proj4: "+proj=tmerc +lat_0=40.25 +lon_0=-96.6880555555556 +k=1.000054615 +x_0=50000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      96751.05575257898,
      91174.69374776888,
      235202.15471636492,
      298870.41914583714
    ]
  },
  "ESRI:102720": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1080442698400646e-9,
      75306.95841208924,
      2.8490853617643416e6,
      754223.7302842663
    ]
  },
  "ESRI:102721": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.0654049365631694e6,
      116445.35678956819,
      2.9384404239095743e6,
      813392.4715465342
    ]
  },
  "ESRI:102726": {
    proj4: "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=44.3333333333333 +lat_2=46 +x_0=2500000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      7235755234653304e-9,
      125253.01047725738,
      922113185653912e-8,
      970943.6152179048
    ]
  },
  "ESRI:102727": {
    proj4: "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=42.3333333333333 +lat_2=44 +x_0=1500000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3806766295471411e-9,
      141484.5254243248,
      5859499800573602e-9,
      1074743798073643e-9
    ]
  },
  "ESRI:102733": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1268680514747901e-9,
      87192.44189005374,
      2740900788696637e-9,
      1.2375526279769263e6
    ]
  },
  "ESRI:102761": {
    proj4: "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=200000 +y_0=200000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -70988.83334104331,
      -398138.9158168605,
      1.5237526029608834e6,
      2125561793082416e-9
    ]
  },
  "ESRI:102766": {
    proj4: "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD83 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.1121485220813036e6,
      -743932.0952494289,
      1.3694496979609637e6,
      1.0587869402481876e6
    ]
  },
  "ESRI:102799": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99926 +x_0=261910.5587 +y_0=70975.76209 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8324.765059414494,
      200000.6910098695,
      20592.835287928174,
      234847.4869465791
    ]
  },
  "ESRI:102800": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999314 +x_0=252927.2844 +y_0=70979.59363 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8386.51342047294,
      200011.3545954096,
      20537.28517544645,
      234870.38687386847
    ]
  },
  "ESRI:102801": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999365 +x_0=243942.3084 +y_0=70983.21269 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8446.042948443326,
      200014.57266288318,
      20479.546336150728,
      234885.50710278394
    ]
  },
  "ESRI:102802": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99939 +x_0=243948.4072 +y_0=70984.98734 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8446.250600928324,
      200019.5751465569,
      20480.05501737367,
      234891.38191374647
    ]
  },
  "ESRI:102803": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999415 +x_0=234956.1813 +y_0=70986.76115 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8500.250144763122,
      210019.27801024547,
      20422.832057183055,
      244900.74571119572
    ]
  },
  "ESRI:102804": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999465 +x_0=225969.1556 +y_0=70990.30995 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8561.061107296555,
      210029.92901555554,
      21359.46424714601,
      244917.52243160267
    ]
  },
  "ESRI:102805": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99949 +x_0=225974.8051 +y_0=70992.08478 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8561.272495544516,
      210035.181696683,
      21359.99576674268,
      244923.6477694365
    ]
  },
  "ESRI:102806": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999516 +x_0=215981.5338 +y_0=70993.93011 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8626.903093986359,
      210028.00073929713,
      21294.198758494895,
      244931.08128272067
    ]
  },
  "ESRI:102807": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999541 +x_0=215986.9336 +y_0=70995.70502 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8627.116518012743,
      210033.25318418953,
      21294.729018261365,
      244937.20672715886
    ]
  },
  "ESRI:102808": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999564 +x_0=205992.2754 +y_0=70997.33764 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      9440.771494225715,
      230007.30279214215,
      20532.996303223685,
      244976.00893906527
    ]
  },
  "ESRI:102809": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999589 +x_0=205997.4254 +y_0=70999.11264 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      9441.005563282204,
      230013.05477523542,
      20533.507798858365,
      244982.13530304274
    ]
  },
  "ESRI:102810": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999613 +x_0=196002.254 +y_0=71000.81651 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7719.13784334212,
      210072.31065117102,
      23118.66614239168,
      273939.6902477188
    ]
  },
  "ESRI:102811": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999638 +x_0=196007.1543 +y_0=71002.5916 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7719.329243093787,
      210077.56387456186,
      23119.242679398973,
      273946.5407737559
    ]
  },
  "ESRI:102812": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999662 +x_0=185011.1931 +y_0=71004.29572 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7857.778347610292,
      210078.01294060244,
      23974.96724711632,
      273962.4484982599
    ]
  },
  "ESRI:102813": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999687 +x_0=185015.8185 +y_0=71006.07089 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7857.973414788983,
      210083.2661291034,
      23975.56538025383,
      273969.2993376553
    ]
  },
  "ESRI:102814": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999713 +x_0=173019.2914 +y_0=71007.91729 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8000.582157731755,
      210076.14848588896,
      25810.45717059585,
      273989.743867141
    ]
  },
  "ESRI:102815": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999738 +x_0=173023.6171 +y_0=71009.69256 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8000.781205651583,
      210081.40145976993,
      25811.101593213534,
      273996.59513961815
    ]
  },
  "ESRI:102816": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999767 +x_0=159026.3186 +y_0=71011.75231 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8175.167042444664,
      210077.9191100899,
      26629.752374089992,
      274007.19668459194
    ]
  },
  "ESRI:102817": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999792 +x_0=159030.2944 +y_0=71013.52767 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8175.370684743015,
      210083.17193450918,
      26630.417488544626,
      274014.0481134256
    ]
  },
  "ESRI:102818": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999817 +x_0=159034.2704 +y_0=71015.30312 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8175.574527041317,
      210088.42484892847,
      26631.08280299927,
      274020.8996322585
    ]
  },
  "ESRI:102819": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999817 +x_0=144031.0383 +y_0=71015.30362 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8360.092151918827,
      210079.57872429374,
      27432.972216016817,
      274032.41921782936
    ]
  },
  "ESRI:102820": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999842 +x_0=144034.6392 +y_0=71017.07907 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8360.300657456944,
      210084.831417507,
      27433.65763083093,
      274039.2710246928
    ]
  },
  "ESRI:102821": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999867 +x_0=144038.2403 +y_0=71018.8546 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8360.509362995042,
      210090.08419072028,
      27434.34324564504,
      274046.1229115562
    ]
  },
  "ESRI:102822": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999865 +x_0=128033.7365 +y_0=71018.71321 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8799.071285962607,
      230077.85452529974,
      28026.49359799421,
      283056.92741378426
    ]
  },
  "ESRI:102823": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99989 +x_0=128036.9375 +y_0=71020.48874 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8799.291016860938,
      230083.60707072905,
      28027.194079351655,
      283064.0046148647
    ]
  },
  "ESRI:102824": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999914 +x_0=111034.6979 +y_0=71022.19417 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      -62210.75125349482,
      250142.0940130271,
      34001.39632604495,
      316087.5208706873
    ]
  },
  "ESRI:102825": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999939 +x_0=111037.4739 +y_0=71023.96979 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      -62212.30676223345,
      250148.34801566452,
      34002.24632786974,
      316095.4236507904
    ]
  },
  "ESRI:102826": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999967 +x_0=88032.17537 +y_0=71025.95967 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7517.5769045645575,
      250127.62780994183,
      45378.972208524356,
      410146.5613639732
    ]
  },
  "ESRI:102827": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999992 +x_0=88034.37626 +y_0=71027.73539 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7517.764863176199,
      250133.8812194093,
      45380.10673325527,
      410156.8153787994
    ]
  },
  "ESRI:102828": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000012 +x_0=54022.17583 +y_0=71029.15712 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8602.257266669425,
      250107.06565575494,
      88040.15823814113,
      410176.47430794395
    ]
  },
  "ESRI:102829": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000037 +x_0=54023.52644 +y_0=71030.93291 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8602.472392331154,
      250113.3183397454,
      88042.35928749607,
      410186.728679131
    ]
  },
  "ESRI:102830": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999981 +x_0=-24009.11135 +y_0=71026.9544 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10005.230672131445,
      268767.12561023695,
      44017.26665225803,
      410511.91571320023
    ]
  },
  "ESRI:102831": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000006 +x_0=-24009.7116 +y_0=71028.73014 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10005.480796839121,
      268773.8449484459,
      44018.36709402125,
      410522.1787384919
    ]
  },
  "ESRI:102832": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999928 +x_0=-58018.94296 +y_0=71023.18879 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10004.840596052047,
      268607.24333917454,
      40004.87252797537,
      410633.8786419395
    ]
  },
  "ESRI:102833": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999953 +x_0=-58020.39349 +y_0=71024.96444 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10005.090783092557,
      268613.9589462153,
      40005.87276981812,
      410644.14517052943
    ]
  },
  "ESRI:102834": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999874 +x_0=-88023.98625 +y_0=71019.35254 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10002.393166857553,
      268725.5153508986,
      27001.935155074738,
      410485.5856490868
    ]
  },
  "ESRI:102835": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999899 +x_0=-88026.18693 +y_0=71021.12809 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10002.643455164987,
      268732.2341778213,
      27002.610485487166,
      410495.8489243682
    ]
  },
  "ESRI:102836": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999826 +x_0=-105023.5775 +y_0=71015.94289 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10009.723765717587,
      268648.4349472212,
      26996.121284726556,
      410519.9599356113
    ]
  },
  "ESRI:102837": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999851 +x_0=-105026.2032 +y_0=71017.71836 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10009.974398731181,
      268655.15208937356,
      26996.79665158184,
      410530.22448313696
    ]
  },
  "ESRI:102838": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999771 +x_0=-122020.6823 +y_0=71012.0364 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.333816446175,
      268580.2979317029,
      26993.685648059865,
      410553.8320738213
    ]
  },
  "ESRI:102839": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999796 +x_0=-122023.7329 +y_0=71013.81177 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.584822916979,
      268587.0136395792,
      26994.361260561243,
      410564.0979330351
    ]
  },
  "ESRI:102840": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999708 +x_0=-139014.8049 +y_0=71007.56222 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.904925986746,
      268509.6659521003,
      26988.2329679346,
      410586.585007516
    ]
  },
  "ESRI:102841": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999733 +x_0=-139018.2804 +y_0=71009.33748 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10014.156231959729,
      268516.3802068796,
      26988.90875605744,
      410596.85222273617
    ]
  },
  "ESRI:102842": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999656 +x_0=-156008.5024 +y_0=71003.86967 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.262854354893,
      268719.5373439822,
      18996.49072473988,
      410339.1767027153
    ]
  },
  "ESRI:102843": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999681 +x_0=-156012.4027 +y_0=71005.64484 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.514276678732,
      268726.25710661453,
      18996.96705512886,
      410349.4381746794
    ]
  },
  "ESRI:102844": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999613 +x_0=-165001.8975 +y_0=71000.81651 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.169325402792,
      268612.85911000153,
      20988.47839631539,
      410407.97360220784
    ]
  },
  "ESRI:102845": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999638 +x_0=-165006.0227 +y_0=71002.5916 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.421045941679,
      268619.5764137038,
      20989.004755866365,
      410418.23715617124
    ]
  },
  "ESRI:102846": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999565 +x_0=-175993.5763 +y_0=70997.40864 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.348236059304,
      268613.4125106776,
      19990.18238958795,
      410370.80056075595
    ]
  },
  "ESRI:102847": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99959 +x_0=-175997.9763 +y_0=70999.18364 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.600282813015,
      268620.1300607837,
      19990.68411580607,
      410381.0635878458
    ]
  },
  "ESRI:102848": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999517 +x_0=-185984.2846 +y_0=70994.00109 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.676598813676,
      268588.31086755346,
      19985.415961603518,
      410375.6453299895
    ]
  },
  "ESRI:102849": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999542 +x_0=-185988.9343 +y_0=70995.77601 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.92906559023,
      268595.0280324022,
      19985.917992403527,
      410385.90889110963
    ]
  },
  "ESRI:102850": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999467 +x_0=-195973.6419 +y_0=70990.45191 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10010.282440577255,
      289543.6980818977,
      19982.764624733303,
      410377.47650871007
    ]
  },
  "ESRI:102851": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999492 +x_0=-195978.5414 +y_0=70992.22674 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10010.535284885293,
      289550.9396568273,
      19983.266914050182,
      410387.7405390686
    ]
  },
  "ESRI:102852": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999416 +x_0=-205961.7946 +y_0=70986.83212 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.99761077328,
      289557.55655466625,
      18980.905018215533,
      410331.4014803991
    ]
  },
  "ESRI:102853": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999441 +x_0=-205966.9438 +y_0=70988.60686 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10008.250810580095,
      289564.7987557739,
      18981.38267178848,
      410341.66479195876
    ]
  },
  "ESRI:102854": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999366 +x_0=-214949.3801 +y_0=70983.28366 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10010.219402668707,
      289525.34490107355,
      18979.123271050747,
      410324.2006464949
    ]
  },
  "ESRI:102855": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999314 +x_0=-223935.6193 +y_0=70979.59363 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10014.078810947773,
      289497.0707210917,
      18978.99009373691,
      410321.29969053244
    ]
  },
  "ESRI:102856": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999967 +x_0=88032.17537 +y_0=111040.5848 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      6519.939954454094,
      450211.25351511023,
      45899.123147730614,
      660229.641293122
    ]
  },
  "ESRI:102857": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999992 +x_0=88034.37626 +y_0=111043.361 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      6520.102971318891,
      450222.50926165306,
      45900.27067666414,
      660246.1476726303
    ]
  },
  "ESRI:102858": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000017 +x_0=88036.57726 +y_0=111046.1372 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      6520.266098183711,
      450233.76500819577,
      45901.41831559768,
      660262.6540521384
    ]
  },
  "ESRI:102859": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000012 +x_0=54022.17583 +y_0=111045.5837 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8039.913940232065,
      450199.90280840994,
      88039.52983172816,
      660281.9903440325
    ]
  },
  "ESRI:102860": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000037 +x_0=54023.52644 +y_0=111048.3599 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8040.115007479333,
      450211.1577646423,
      88041.73086537313,
      660298.49728943
    ]
  },
  "ESRI:102861": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000062 +x_0=54024.87711 +y_0=111051.1363 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8040.316134726607,
      450222.4129208754,
      88043.93195901808,
      660315.0044348274
    ]
  },
  "ESRI:102862": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000087 +x_0=54026.22785 +y_0=111053.9128 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8040.517331973875,
      450233.66817710776,
      88046.13312266304,
      660331.5116802241
    ]
  },
  "ESRI:102863": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999981 +x_0=-24009.11135 +y_0=111042.14 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.462082046826,
      449811.7544816266,
      44016.06985471822,
      660634.3375641899
    ]
  },
  "ESRI:102864": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000006 +x_0=-24009.7116 +y_0=111044.9161 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.712162538908,
      449822.99998290685,
      44017.17026656092,
      660650.8537301903
    ]
  },
  "ESRI:102865": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999928 +x_0=-58018.94296 +y_0=111036.2529 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10008.66087340076,
      449646.5308843983,
      40004.26206698036,
      660756.0872462655
    ]
  },
  "ESRI:102866": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999953 +x_0=-58020.39349 +y_0=111039.0289 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10008.911155955095,
      449657.7727508901,
      40005.26229356049,
      660772.6072316909
    ]
  },
  "ESRI:102867": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999874 +x_0=-88023.98625 +y_0=111030.2554 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10004.74077275557,
      449754.83000953624,
      26999.68577633967,
      660575.3064552947
    ]
  },
  "ESRI:102868": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999826 +x_0=-105023.5775 +y_0=111024.9248 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10008.445009193005,
      449673.8664180683,
      26998.596276842916,
      660605.2615459143
    ]
  },
  "ESRI:102869": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999771 +x_0=-122020.6823 +y_0=111018.8175 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10009.052631205574,
      449591.99357191153,
      26991.568538363077,
      536589.7726418842
    ]
  },
  "ESRI:102870": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999709 +x_0=-139014.9439 +y_0=111011.9337 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.914606258768,
      449509.36957125744,
      26988.707267033926,
      536619.1870036712
    ]
  },
  "ESRI:102871": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999656 +x_0=-156008.5024 +y_0=111006.0498 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.562475646788,
      449710.97386899806,
      18990.446885886893,
      536350.815979479
    ]
  },
  "ESRI:102872": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999614 +x_0=-165002.0625 +y_0=111001.3875 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10014.097504643607,
      449599.47275753226,
      20987.647637685615,
      536426.1232559418
    ]
  },
  "ESRI:102873": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999565 +x_0=-175993.5763 +y_0=110995.9487 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10010.469830601243,
      449597.1786673921,
      19985.363581180456,
      536381.8380019956
    ]
  },
  "ESRI:102874": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999517 +x_0=-185984.2846 +y_0=110990.6214 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10014.244876876357,
      449558.13521463494,
      19983.982071279665,
      536369.8263504354
    ]
  },
  "ESRI:102875": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999467 +x_0=-195973.6419 +y_0=110985.0727 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.354817113664,
      449515.7449407622,
      19984.33454478692,
      536366.2449621406
    ]
  },
  "ESRI:102876": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999416 +x_0=-205961.7946 +y_0=110979.4136 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10012.860514396278,
      449515.18225769175,
      18982.708558605635,
      536313.7950885372
    ]
  },
  "ESRI:102877": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999367 +x_0=-214949.595 +y_0=110973.9769 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10012.343236834655,
      449479.139802898,
      18981.19235418964,
      536301.3436816381
    ]
  },
  "ESRI:102878": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999315 +x_0=-223935.8432 +y_0=110968.208 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10014.035244192462,
      449435.75605265715,
      18974.61903068787,
      536292.5253184581
    ]
  },
  "ESRI:102879": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999261 +x_0=-232920.6915 +y_0=110962.2179 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10016.576543167786,
      488372.9346673596,
      18970.373912933195,
      536277.0818564986
    ]
  },
  "ESRI:102880": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999206 +x_0=-241904.3281 +y_0=110956.1174 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10013.576162768004,
      488330.3822050729,
      18967.98782197191,
      536266.669723887
    ]
  },
  "ESRI:102881": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999866 +x_0=128033.8646 +y_0=126033.3354 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8826.533158166028,
      724212.1180298676,
      28005.38166990255,
      769187.3668291023
    ]
  },
  "ESRI:102882": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999914 +x_0=111034.6979 +y_0=126039.3868 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8103.453644264315,
      684251.5581525008,
      34447.832335851024,
      769221.8458403614
    ]
  },
  "ESRI:102883": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999939 +x_0=111037.4739 +y_0=126042.5379 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8103.656141836691,
      684268.6657570436,
      34448.69349953598,
      769241.0778847986
    ]
  },
  "ESRI:102884": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999964 +x_0=111040.25 +y_0=126045.6892 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8103.858739409101,
      684285.7735615865,
      34449.554763220964,
      769260.310129235
    ]
  },
  "ESRI:102885": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999989 +x_0=111043.0263 +y_0=126048.8406 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      8104.061536981491,
      684302.88146613,
      34450.416226905916,
      769279.5424736722
    ]
  },
  "ESRI:102886": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999967 +x_0=88032.17537 +y_0=126046.0693 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7666.838044392061,
      675281.8793404305,
      45298.068665586834,
      809289.678652974
    ]
  },
  "ESRI:102887": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999992 +x_0=88034.37626 +y_0=126049.2206 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7667.029734655327,
      675298.7619888162,
      45299.20116766243,
      809309.911606902
    ]
  },
  "ESRI:102888": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000017 +x_0=88036.57726 +y_0=126052.372 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7667.221534918601,
      675315.6447372017,
      45300.33377973802,
      809330.1446608307
    ]
  },
  "ESRI:102889": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000042 +x_0=88038.77836 +y_0=126055.5236 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7667.41343518185,
      675332.5276855873,
      45301.4664918136,
      809350.3779147594
    ]
  },
  "ESRI:102890": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000067 +x_0=88040.97958 +y_0=126058.6753 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7667.605455445126,
      675349.410733973,
      45302.59932388919,
      809370.6112686874
    ]
  },
  "ESRI:102891": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000012 +x_0=54022.17583 +y_0=126051.7436 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7881.20370237335,
      675292.3719484359,
      88038.79858881628,
      886368.2927004368
    ]
  },
  "ESRI:102892": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000037 +x_0=54023.52644 +y_0=126054.895 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7881.4008019122775,
      675309.2541993748,
      88040.9996041804,
      886390.4517860723
    ]
  },
  "ESRI:102893": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000062 +x_0=54024.87711 +y_0=126058.0466 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7881.597961451211,
      675326.1366503129,
      88043.2006795445,
      886412.6110717073
    ]
  },
  "ESRI:102894": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000087 +x_0=54026.22785 +y_0=126061.1983 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      7881.795190990146,
      675343.0192012519,
      88045.40182490862,
      886434.770457343
    ]
  },
  "ESRI:102895": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999981 +x_0=-24009.11135 +y_0=126047.8346 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.467460581196,
      674877.6510156423,
      44013.09893941008,
      851723.1748339036
    ]
  },
  "ESRI:102896": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000006 +x_0=-24009.7116 +y_0=126050.9859 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10003.717541207745,
      674894.5233217522,
      44014.1992769785,
      851744.4683621114
    ]
  },
  "ESRI:102897": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999928 +x_0=-58018.94296 +y_0=126041.1519 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10009.564904697967,
      674680.4988770629,
      40004.95780075969,
      726782.7425135337
    ]
  },
  "ESRI:102898": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999953 +x_0=-58020.39349 +y_0=126044.3031 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10009.8152098547,
      674697.3670483596,
      40005.95804473439,
      726800.9133347125
    ]
  },
  "ESRI:102899": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999874 +x_0=-88023.98625 +y_0=126034.3439 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.04394365799,
      674789.7005735805,
      27002.321858113894,
      726593.8763521044
    ]
  },
  "ESRI:102900": {
    proj4: "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999899 +x_0=-88026.18693 +y_0=126037.4949 +ellps=airy +units=m +no_defs +type=crs",
    projected_bounds: [
      10007.294348249474,
      674806.5721862947,
      27002.997198195124,
      726612.0432324164
    ]
  },
  "ESRI:102974": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      926688.4431870921,
      745142.7185288663,
      2.6359087245902866e6,
      2514550203810799e-9
    ]
  },
  "ESRI:103166": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      934625.2189929633,
      3370095171550523e-9,
      2.3089332070016465e6,
      3.9012110412076083e6
    ]
  },
  "ESRI:103167": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      910491.0884611161,
      6629153124187484e-9,
      2318648420670865e-9,
      7571527831696848e-9
    ]
  },
  "ESRI:103168": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      895695.7750963889,
      9970406834978113e-9,
      2.3436369762500296e6,
      1054848868544858e-8
    ]
  },
  "ESRI:103220": {
    proj4: "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      108626.36786491147,
      54714.51998364178,
      286113.0710794821,
      499437.8336004764
    ]
  },
  "ESRI:103221": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      505580.4459135294,
      15923.948445720733,
      709514.5981401769,
      557319.3874706
    ]
  },
  "ESRI:103222": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66481.57726905748,
      37612.94225911591,
      313625.1177186511,
      667173.219860401
    ]
  },
  "ESRI:103223": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76951.28315104556,
      37471.49767701424,
      344774.25509364414,
      667599.2730779602
    ]
  },
  "ESRI:103224": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113255.82311506476,
      116906.13016791063,
      322839.39772502496,
      666199.5537606371
    ]
  },
  "ESRI:103225": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      218115.41098772138,
      123402.0415325325,
      1.0289537982895375e6,
      2.1888885166023653e6
    ]
  },
  "ESRI:103226": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      252464.8397344014,
      122937.98450463987,
      1.1311491308846592e6,
      2.1902863289959324e6
    ]
  },
  "ESRI:103227": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      371574.2228184539,
      383550.2958264784,
      1.0591843757382708e6,
      2185694074017838e-9
    ]
  },
  "ESRI:103228": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=34.9333333333333 +lat_2=36.2333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      159882.1517288231,
      40546.019450230866,
      611428.2003751277,
      242921.67605553995
    ]
  },
  "ESRI:103229": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=33.3 +lat_2=34.7666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      168267.016688386,
      440888.4719844016,
      545890.5412777682,
      671045.3781161588
    ]
  },
  "ESRI:103230": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=34.9333333333333 +lat_2=36.2333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      524546.6927969805,
      133024.73214629912,
      2.0059940207307318e6,
      796985.5321922174
    ]
  },
  "ESRI:103231": {
    proj4: "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=33.3 +lat_2=34.7666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      552056.0372518131,
      1.4464815951688243e6,
      1790975884175478e-9,
      2.2015880447027646e6
    ]
  },
  "ESRI:103232": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7895395665343686e6,
      531443.8371340149,
      216650689441652e-8,
      799143.9865565505
    ]
  },
  "ESRI:103233": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8191142581414785e6,
      541273.7589847766,
      2.2095712464330723e6,
      779630.525372654
    ]
  },
  "ESRI:103234": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1774907679626609e-9,
      528557.1371853993,
      2.2322182534678923e6,
      748597.1784831426
    ]
  },
  "ESRI:103235": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.7278867764527192e6,
      553828.3138820408,
      2298520922247323e-9,
      754562.841666431
    ]
  },
  "ESRI:103236": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.6794231645368338e6,
      423356.529110716,
      2350617831343431e-9,
      763023.8066438792
    ]
  },
  "ESRI:103237": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=32.7833333333333 +lat_2=33.8833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.8215040867444675e6,
      541921.6090514631,
      2168903381623939e-9,
      713685.2401208594
    ]
  },
  "ESRI:103238": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5871181061204841e-9,
      1743578655663851e-9,
      71079480360982e-7,
      2.6218582292276197e6
    ]
  },
  "ESRI:103239": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5968210695252501e-9,
      1775828990935891e-9,
      7249234997672506e-9,
      2.5578378153267857e6
    ]
  },
  "ESRI:103240": {
    proj4: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      58231762789083e-7,
      1.7341078742491012e6,
      7323536053252578e-9,
      2.4560225764067806e6
    ]
  },
  "ESRI:103241": {
    proj4: "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5668908532411964e-9,
      1817018393127999e-9,
      7541064059073093e-9,
      2.4755949230339527e6
    ]
  },
  "ESRI:103242": {
    proj4: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5509907498984596e-9,
      1.3889622125907443e6,
      7711985334999241e-9,
      2503353938964131e-9
    ]
  },
  "ESRI:103243": {
    proj4: "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=32.7833333333333 +lat_2=33.8833333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      5976051324594141e-9,
      1.7779544790296787e6,
      7115810511211208e-9,
      2.3414823252965226e6
    ]
  },
  "ESRI:103244": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      608530.8153568001,
      336108.1196154525,
      1.2054047088972987e6,
      496651.0214599926
    ]
  },
  "ESRI:103245": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=38.45 +lat_2=39.75 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      602369.9938571033,
      344958.2808811831,
      1.2094300492099926e6,
      560943.6928306813
    ]
  },
  "ESRI:103246": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=37.2333333333333 +lat_2=38.4333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      597496.3981335191,
      345615.6716642405,
      1.2154220791101316e6,
      533836.9174519412
    ]
  },
  "ESRI:103247": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9964881833830988e6,
      1.1027147224383638e6,
      3954731949107218e-9,
      1.6294292262399928e6
    ]
  },
  "ESRI:103248": {
    proj4: "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=38.45 +lat_2=39.75 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9762755548461769e6,
      1.1317506265243483e6,
      3967938419783115e-9,
      1840362765561994e-9
    ]
  },
  "ESRI:103249": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=37.2333333333333 +lat_2=38.4333333333333 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1960286099543051e-9,
      1133907416118429e-9,
      3.9875972712138207e6,
      1.7514299533402438e6
    ]
  },
  "ESRI:103250": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.2 +lat_2=41.8666666666667 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      222322.54347837294,
      169156.34668005927,
      385103.12220492034,
      287977.4369607322
    ]
  },
  "ESRI:103251": {
    proj4: "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.2 +lat_2=41.8666666666667 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      729403.2113952953,
      554973.7807328278,
      1263459160100643e-9,
      944805.9744286691
    ]
  },
  "ESRI:103252": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166533.1617424154,
      48909.64130833831,
      238225.79702413955,
      205470.4830819298
    ]
  },
  "ESRI:103253": {
    proj4: "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      546367.548149908,
      160464.3815257733,
      781579.1357366979,
      674114.4099112981
    ]
  },
  "ESRI:103254": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      65102.243370109296,
      9138.495340711599,
      298540.20675895823,
      720329.5063146846
    ]
  },
  "ESRI:103255": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      66150.82431594437,
      215219.24548827673,
      284274.37353434425,
      583846.6252347573
    ]
  },
  "ESRI:103256": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=29.5833333333333 +lat_2=30.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      295646.50247016025,
      27456.531402877317,
      834910.9831262925,
      225348.7609827654
    ]
  },
  "ESRI:103257": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      213589.6101234336,
      29981.880130317975,
      979460.6616750156,
      2.3632810553007615e6
    ]
  },
  "ESRI:103258": {
    proj4: "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      217029.8294432275,
      706098.474572788,
      932656.8405039279,
      1.9155034696243666e6
    ]
  },
  "ESRI:103259": {
    proj4: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=29.5833333333333 +lat_2=30.75 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      969966.9001875175,
      90080.30344427335,
      2739203783806845e-9,
      739331.726657623
    ]
  },
  "ESRI:103260": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      74709.789308767,
      40624.309794496774,
      327985.22104999487,
      519815.2404935042
    ]
  },
  "ESRI:103261": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      561618.6831736781,
      69612.78234582106,
      807394.5382984749,
      556166.0817971718
    ]
  },
  "ESRI:103262": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      245110.3670905131,
      133281.58971744485,
      1076064846061525e-9,
      1705427168185772e-9
    ]
  },
  "ESRI:103263": {
    proj4: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8425772963789757e6,
      228387.93674624796,
      2.6489269144009133e6,
      1.8246882200295548e6
    ]
  },
  "ESRI:103264": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368421053 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      111063.71936106507,
      36468.06031785753,
      289214.9224321497,
      343148.0613253885
    ]
  },
  "ESRI:103265": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368421053 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      392281.8303299796,
      36728.33696120271,
      602797.134875532,
      448951.84784259746
    ]
  },
  "ESRI:103266": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333333333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      676539.78366646,
      36984.30999635588,
      904606.238145398,
      817057.2292057828
    ]
  },
  "ESRI:103267": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368421053 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      364381.552603761,
      119645.6278928376,
      948865.9580128113,
      1.1258115978650455e6
    ]
  },
  "ESRI:103268": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368421053 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2870113050076114e6,
      120499.55218021257,
      1977676933337478e-9,
      1.4729361874635888e6
    ]
  },
  "ESRI:103269": {
    proj4: "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333333333 +x_0=800000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2196142735790475e6,
      121339.35704637758,
      2.9678622996486966e6,
      2680628592819306e-9
    ]
  },
  "ESRI:103270": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      215802.92024991306,
      44068.31688321397,
      407952.84533971857,
      648476.2402160055
    ]
  },
  "ESRI:103271": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941176470588 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      579509.9562857663,
      35625.98716323067,
      801631.2999592589,
      649470.3399521182
    ]
  },
  "ESRI:103272": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      708013.4141865899,
      144580.80297434452,
      1338425293418727e-9,
      2127542464775345e-9
    ]
  },
  "ESRI:103273": {
    proj4: "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941176470588 +x_0=700000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9012755815808852e6,
      116882.92621803263,
      2630018689949669e-9,
      2.1308039403262413e6
    ]
  },
  "ESRI:103274": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966666666667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      18848.1697028184,
      300346.5557646111,
      173722.82930963754,
      724452.6022101209
    ]
  },
  "ESRI:103275": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966666666667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      813951.5557325621,
      280415.4110851508,
      970119.8033262074,
      724416.3644834876
    ]
  },
  "ESRI:103276": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966666666667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      61837.70343333004,
      985386.991704395,
      569955.6491600359,
      2.3768082457510387e6
    ]
  },
  "ESRI:103277": {
    proj4: "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966666666667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.6704393957659146e6,
      919996.2278685323,
      3.1828013880793992e6,
      2376689355809576e-9
    ]
  },
  "ESRI:103278": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=42.0666666666667 +lat_2=43.2666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.2384564841177673e6,
      1.0437504040677039e6,
      1770835765002967e-9,
      1.2286439962682931e6
    ]
  },
  "ESRI:103279": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=40.6166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      275804.31496850675,
      44490.99603974775,
      778150.4552814265,
      231925.01089940875
    ]
  },
  "ESRI:103280": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=42.0666666666667 +lat_2=43.2666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      4.0631693149763756e6,
      3424371117345459e-9,
      5.8098170056805685e6,
      4030976177756892e-9
    ]
  },
  "ESRI:103281": {
    proj4: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=40.6166666666667 +lat_2=41.7833333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      904867.9900258459,
      145967.54284040575,
      2.5529819520358173e6,
      760907.3065924769
    ]
  },
  "ESRI:103282": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=38.7166666666667 +lat_2=39.7833333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      46038.23738699913,
      28658.252530809354,
      691948.004584817,
      191653.873446171
    ]
  },
  "ESRI:103283": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=37.2666666666667 +lat_2=38.5666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      84022.72728234128,
      441902.1544802367,
      738340.2719366559,
      652740.3625160322
    ]
  },
  "ESRI:103284": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=38.7166666666667 +lat_2=39.7833333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      151043.78382717966,
      94022.9501781637,
      2270166078375354e-9,
      628784.4164646461
    ]
  },
  "ESRI:103285": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=37.2666666666667 +lat_2=38.5666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      275664.56442548137,
      1.4498073184905767e6,
      2.4223713755121785e6,
      2.1415323393546827e6
    ]
  },
  "ESRI:103286": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      349218.2791870525,
      24709.163041468903,
      653864.4011060491,
      184641.09895005127
    ]
  },
  "ESRI:103287": {
    proj4: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1457269709661913e6,
      81066.64574521924,
      2.1452201226287666e6,
      605776.6721386266
    ]
  },
  "ESRI:103288": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.1577469491398442e6,
      1.0243945737160366e6,
      1.8284434576961924e6,
      1.3193168596829686e6
    ]
  },
  "ESRI:103289": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.7983747823029724e6,
      3360867863933364e-9,
      5998818244124926e-9,
      432845873047654e-8
    ]
  },
  "ESRI:103290": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      157793.0920864537,
      524305.3717931777,
      832918.853646253,
      710531.6721022641
    ]
  },
  "ESRI:103291": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=500000.000000001 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      517692.83628697676,
      1.7201585406247873e6,
      2.7326679390044184e6,
      2.3311359942221814e6
    ]
  },
  "ESRI:103292": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      851729.3635550353,
      39868.512993891505,
      1153221324211875e-9,
      281692.5559034941
    ]
  },
  "ESRI:103293": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      745633.3912495468,
      41691.410611282045,
      1.2465426147796377e6,
      287665.49443279224
    ]
  },
  "ESRI:103294": {
    proj4: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.7943820869301455e6,
      130801.94638079239,
      3783526961185127e-9,
      924186.3271600471
    ]
  },
  "ESRI:103295": {
    proj4: "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.4462988844578885e6,
      136782.5696471812,
      4.0896985619895286e6,
      943782.5429849193
    ]
  },
  "ESRI:103296": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      177049.16196835245,
      24838.65270351215,
      419851.20673729526,
      423896.7865970171
    ]
  },
  "ESRI:103297": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966666666667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      824761.6429232759,
      23371.928549012086,
      969493.4665201029,
      416737.7861312688
    ]
  },
  "ESRI:103298": {
    proj4: "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      580868.792224503,
      81491.47974477279,
      1377461834103943e-9,
      1.3907347073603803e6
    ]
  },
  "ESRI:103299": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966666666667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2705905490157448e-9,
      76679.40224788383,
      3180746481408038e-9,
      1.3672472199990044e6
    ]
  },
  "ESRI:103300": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -90429.83997497888,
      -94455.08752419111,
      430769.0536001022,
      445096.91384529456
    ]
  },
  "ESRI:103307": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116255.53639300572,
      -17249.759354219557,
      414889.9884051585,
      512628.6212777673
    ]
  },
  "ESRI:103313": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -75046.62893762364,
      120154.53294462961,
      454277.24380147073,
      651809.1309670577
    ]
  },
  "ESRI:103319": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116255.53639300572,
      -17249.759354219557,
      414889.9884051585,
      512628.6212777673
    ]
  },
  "ESRI:103322": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -80755.82959446977,
      32851.291343532146,
      442307.35935976077,
      571466.5102165593
    ]
  },
  "ESRI:103323": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -149101.4134260425,
      -61658.84593798395,
      377480.28986571997,
      472858.3935228549
    ]
  },
  "ESRI:103327": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -75046.62893762364,
      120154.53294462961,
      454277.24380147073,
      651809.1309670577
    ]
  },
  "ESRI:103328": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -90429.83997497888,
      -94455.08752419111,
      430769.0536001022,
      445096.91384529456
    ]
  },
  "ESRI:103329": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -224889.10391830612,
      41362.74864101286,
      310274.88673686655,
      567334.2377241693
    ]
  },
  "ESRI:103330": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -359291.417832243,
      -73551.65951140199,
      178158.85843278086,
      450195.8729914839
    ]
  },
  "ESRI:103332": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -80755.82959446977,
      32851.291343532146,
      442307.35935976077,
      571466.5102165593
    ]
  },
  "ESRI:103335": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -359291.417832243,
      -73551.65951140199,
      178158.85843278086,
      450195.8729914839
    ]
  },
  "ESRI:103338": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -149101.4134260425,
      -61658.84593798395,
      377480.28986571997,
      472858.3935228549
    ]
  },
  "ESRI:103340": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -224889.10391830612,
      41362.74864101286,
      310274.88673686655,
      567334.2377241693
    ]
  },
  "ESRI:103344": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116255.53639300572,
      -17249.759354219557,
      414889.9884051585,
      512628.6212777673
    ]
  },
  "ESRI:103345": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -224889.10391830612,
      41362.74864101286,
      310274.88673686655,
      567334.2377241693
    ]
  },
  "ESRI:103346": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113149.62251167277,
      -153366.157857446,
      619760.0215483082,
      399931.8853904067
    ]
  },
  "ESRI:103347": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      113149.62251167277,
      -153366.157857446,
      619760.0215483082,
      399931.8853904067
    ]
  },
  "ESRI:103351": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -224889.10391830612,
      41362.74864101286,
      310274.88673686655,
      567334.2377241693
    ]
  },
  "ESRI:103358": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -359291.417832243,
      -73551.65951140199,
      178158.85843278086,
      450195.8729914839
    ]
  },
  "ESRI:103370": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -116255.53639300572,
      -17249.759354219557,
      414889.9884051585,
      512628.6212777673
    ]
  },
  "ESRI:103372": {
    proj4: "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      643626.9498361305,
      38759.89775611995,
      772884.0925903314,
      393521.3588579671
    ]
  },
  "ESRI:103373": {
    proj4: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      427110.6227171908,
      28173.763208158933,
      559930.8874513158,
      441528.35357238876
    ]
  },
  "ESRI:103374": {
    proj4: "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      241765.49550198903,
      26539.33912282469,
      358635.93205308926,
      416628.2804443663
    ]
  },
  "ESRI:103375": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      181219.09721396962,
      36655.85913986049,
      574026.6173549057,
      230987.04872253875
    ]
  },
  "ESRI:103376": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=400000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      594549.6547761654,
      120261.76452802564,
      1.8832856604385534e6,
      757830.009017196
    ]
  },
  "ESRI:103377": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      32912.32927433509,
      803051.4395878369,
      333962.18491762364,
      961218.4864862445
    ]
  },
  "ESRI:103378": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      465603.8085218641,
      21182.19390165996,
      550924.4533078014,
      56819.46303831281
    ]
  },
  "ESRI:103379": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      107979.86696088106,
      2634677931381095e-9,
      1.0956742683505705e6,
      3.1535976510802875e6
    ]
  },
  "ESRI:103380": {
    proj4: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1527568495125486e-9,
      69495.24782569606,
      1807491310560682e-9,
      186415.18831819796
    ]
  },
  "ESRI:103381": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      7730770077384338e-9,
      38783.291969269485,
      8264072881829599e-9,
      399102.5058484595
    ]
  },
  "ESRI:103382": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5783269683611322e-9,
      57309.820740618925,
      6162640001784503e-9,
      291399.94080042426
    ]
  },
  "ESRI:103383": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.7641359814184066e6,
      25074.890927632514,
      4178741346471115e-9,
      304539.38329520583
    ]
  },
  "ESRI:103384": {
    proj4: "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      25363418889056224e-9,
      127241.77155272139,
      2711310000600262e-8,
      1.3093914233873342e6
    ]
  },
  "ESRI:103385": {
    proj4: "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=5999999.99999999 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      18973981901611913e-9,
      188024.34626187308,
      2021863517645831e-8,
      956036.5511824941
    ]
  },
  "ESRI:103386": {
    proj4: "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      12349527498091884e-9,
      82266.70251847937,
      1370978132044329e-8,
      999144.9583176043
    ]
  },
  "ESRI:103387": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      484662.8833796089,
      123970.60197833316,
      1.0621099971384867e6,
      426349.3882135941
    ]
  },
  "ESRI:103388": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      595233.1859048485,
      134496.0658554411,
      947732.4888004595,
      377495.16347312875
    ]
  },
  "ESRI:103389": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      569492.5128116712,
      158465.4349358629,
      1.0176934793720534e6,
      391514.8607947001
    ]
  },
  "ESRI:103390": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5900981432212705e6,
      406726.8833239147,
      3484605882278522e-9,
      1.3987812844974333e6
    ]
  },
  "ESRI:103391": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.9528608774228275e6,
      441259.17606072634,
      3.1093523403395116e6,
      1.2384987154947568e6
    ]
  },
  "ESRI:103392": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1868410019116295e-9,
      519898.68111874355,
      3.3388826902398155e6,
      1284495005790612e-9
    ]
  },
  "ESRI:103393": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      190340.12052613805,
      57073.9038946292,
      367846.54652006144,
      611234.9881211288
    ]
  },
  "ESRI:103394": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      574253.7728630524,
      167020.95974745313,
      787927.2680533797,
      611406.5844740515
    ]
  },
  "ESRI:103395": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      624474.212092838,
      187249.96636096266,
      1.2068432113745683e6,
      2.0053601235274035e6
    ]
  },
  "ESRI:103396": {
    proj4: "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.8840309198015314e6,
      547967.9321047692,
      2585058045271797e-9,
      2005923102561951e-9
    ]
  },
  "ESRI:103397": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333333333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      117430.21412308389,
      17271.899564122337,
      368474.73771364393,
      531120.8789880109
    ]
  },
  "ESRI:103398": {
    proj4: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      384402.58293581597,
      72524.35272698097,
      592240.486385654,
      530749.7676659824
    ]
  },
  "ESRI:103399": {
    proj4: "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941176470588 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      736193.9857947365,
      35516.953552318475,
      936343.0942324286,
      491477.9176892327
    ]
  },
  "ESRI:103400": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -296685.23353907745,
      -309891.39979136706,
      1413281469798501e-9,
      1460288791368354e-9
    ]
  },
  "ESRI:103407": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -381415.039294471,
      -56593.58555738533,
      1.3611849033141732e6,
      1.6818490682327251e6
    ]
  },
  "ESRI:103413": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -246215.48147543613,
      394206.9969015057,
      1.4904079243360762e6,
      2138477123913422e-9
    ]
  },
  "ESRI:103419": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -381415.039294471,
      -56593.58555738533,
      1.3611849033141732e6,
      1.6818490682327251e6
    ]
  },
  "ESRI:103422": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -264946.41806210735,
      107779.6121546551,
      1.4511367276985643e6,
      1.8748863760739118e6
    ]
  },
  "ESRI:103423": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -489176.8873707761,
      -202292.39745778553,
      1.2384499175122816e6,
      155136957900665e-8
    ]
  },
  "ESRI:103427": {
    proj4: "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -246215.48147543613,
      394206.9969015057,
      1.4904079243360762e6,
      2138477123913422e-9
    ]
  },
  "ESRI:103428": {
    proj4: "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -296685.23353907745,
      -309891.39979136706,
      1413281469798501e-9,
      1460288791368354e-9
    ]
  },
  "ESRI:103429": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -737823.668533308,
      135704.28454697304,
      1.0179601908078713e6,
      1.8613290783139623e6
    ]
  },
  "ESRI:103430": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.1787752595311175e6,
      -241310.73618399136,
      584509.521848382,
      147701762670256e-8
    ]
  },
  "ESRI:103432": {
    proj4: "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -264946.41806210735,
      107779.6121546551,
      1.4511367276985643e6,
      1.8748863760739118e6
    ]
  },
  "ESRI:103435": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.1787752595311175e6,
      -241310.73618399136,
      584509.521848382,
      147701762670256e-8
    ]
  },
  "ESRI:103438": {
    proj4: "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -489176.8873707761,
      -202292.39745778553,
      1.2384499175122816e6,
      155136957900665e-8
    ]
  },
  "ESRI:103440": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -737823.668533308,
      135704.28454697304,
      1.0179601908078713e6,
      1.8613290783139623e6
    ]
  },
  "ESRI:103444": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -381415.039294471,
      -56593.58555738533,
      1.3611849033141732e6,
      1.6818490682327251e6
    ]
  },
  "ESRI:103445": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -737823.668533308,
      135704.28454697304,
      1.0179601908078713e6,
      1.8613290783139623e6
    ]
  },
  "ESRI:103446": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      371225.05279888114,
      -503168.8024716373,
      2.0333293369715763e6,
      1312109861084026e-9
    ]
  },
  "ESRI:103447": {
    proj4: "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      371225.05279888114,
      -503168.8024716373,
      2.0333293369715763e6,
      1312109861084026e-9
    ]
  },
  "ESRI:103451": {
    proj4: "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -737823.668533308,
      135704.28454697304,
      1.0179601908078713e6,
      1.8613290783139623e6
    ]
  },
  "ESRI:103458": {
    proj4: "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.1787752595311175e6,
      -241310.73618399136,
      584509.521848382,
      147701762670256e-8
    ]
  },
  "ESRI:103470": {
    proj4: "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -381415.039294471,
      -56593.58555738533,
      1.3611849033141732e6,
      1.6818490682327251e6
    ]
  },
  "ESRI:103472": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      76530.54027482838,
      33084.52411923702,
      999117.0470033675,
      542896.2532425779
    ]
  },
  "ESRI:103473": {
    proj4: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      251084.4497205621,
      108545.02663791673,
      3.2779430675963457e6,
      1781155686491397e-9
    ]
  },
  "ESRI:103474": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=40 +lat_2=43 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153376.22524007282,
      25535.91916592961,
      882993.4575054273,
      363144.7550580989
    ]
  },
  "ESRI:103475": {
    proj4: "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=40 +lat_2=43 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503201.83230847557,
      83779.0947968874,
      2.8969543684990597e6,
      1.1914174172197795e6
    ]
  },
  "ESRI:103476": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      69754.74639531817,
      802755247237993e-8,
      328683.6587060269,
      880586542636728e-8
    ]
  },
  "ESRI:103477": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      362659.33828742534,
      6139743768849751e-9,
      641055.3972230253,
      6694999823411577e-9
    ]
  },
  "ESRI:103478": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      673826.6301758505,
      4245017139322905e-9,
      931997.4907157569,
      4.8059263308652975e6
    ]
  },
  "ESRI:103479": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000.00000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      228853.69713197305,
      26337061736466523e-9,
      1.0783563036046901e6,
      28890576819673356e-9
    ]
  },
  "ESRI:103480": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.000000001 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1189824845697998e-9,
      20143476014967892e-9,
      2103195915722546e-9,
      21965178587309487e-9
    ]
  },
  "ESRI:103481": {
    proj4: "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.000000001 +y_0=3999999.99999999 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.2107128691686066e6,
      13927193731261864e-9,
      3057728434123283e-9,
      15767443303847197e-9
    ]
  },
  "ESRI:103482": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      226793.80243233597,
      21492.3877323907,
      381293.17340038536,
      312732.671645898
    ]
  },
  "ESRI:103483": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      744072.6668134223,
      70512.94208535182,
      1250959353064431e-9,
      1.0260237735582505e6
    ]
  },
  "ESRI:103484": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      54545.12015456795,
      4645.126015017602,
      201873.90102511132,
      280709.69043490384
    ]
  },
  "ESRI:103485": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      178953.44837377837,
      15239.884267603586,
      662314.6236132195,
      920961.7093685138
    ]
  },
  "ESRI:103486": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909090909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      33975.77075553588,
      111708.32824573474,
      284564.52415616764,
      666319.758899624
    ]
  },
  "ESRI:103487": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      359824.2791681125,
      87428.3980117214,
      625497.4318649578,
      666399.5233026792
    ]
  },
  "ESRI:103488": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916666666667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      713259.0787590162,
      37234.662649415426,
      964697.4630941513,
      666551.8765122581
    ]
  },
  "ESRI:103489": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909090909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      111468.84122045398,
      366496.4069195481,
      933608.7763356934,
      2.1860840756565165e6
    ]
  },
  "ESRI:103490": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1805234892373858e6,
      286838.0024767893,
      2.0521528243769524e6,
      2.1863457693688734e6
    ]
  },
  "ESRI:103491": {
    proj4: "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916666666667 +x_0=830000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      2.3400841608952093e6,
      122160.7223756238,
      3165011593501399e-9,
      21868456148573e-7
    ]
  },
  "ESRI:103492": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      34535.94492432893,
      228126.12062753108,
      250090.6353354547,
      687881.3551997013
    ]
  },
  "ESRI:103493": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      153330.97415895032,
      221641.78111359302,
      372921.93601385155,
      490979.04527605977
    ]
  },
  "ESRI:103494": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      251673.76576198317,
      221664.55284669463,
      448704.434264811,
      404996.19022632844
    ]
  },
  "ESRI:103495": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=40.6666666666667 +lat_2=41.0333333333333 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277950.22920969536,
      33716.39444708133,
      484240.9609220226,
      128170.64580042983
    ]
  },
  "ESRI:103496": {
    proj4: "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      113306.67930590251,
      748443.780758825,
      820505.692763071,
      2.2568240795176867e6
    ]
  },
  "ESRI:103497": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      503053.37105315627,
      727169.7435368465,
      1.2234947184054449e6,
      1610820417709873e-9
    ]
  },
  "ESRI:103498": {
    proj4: "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      825699.6798374399,
      727244.453797864,
      1.4721244647504676e6,
      1328725000767546e-9
    ]
  },
  "ESRI:103499": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=40.6666666666667 +lat_2=41.0333333333333 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      911908.3769988089,
      110617.87078179934,
      1.5887138859583358e6,
      420506.5270969103
    ]
  },
  "ESRI:103500": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      116361.13416470913,
      22119.88887843388,
      933520.670209694,
      320979.26197346306
    ]
  },
  "ESRI:103501": {
    proj4: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      381761.4876720499,
      72571.66876199517,
      3062725732179638e-9,
      105307946199127e-8
    ]
  },
  "ESRI:103502": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      329319.59311170306,
      22953.606831218458,
      868402.9550716814,
      229887.85276634988
    ]
  },
  "ESRI:103503": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      324736.0741366023,
      35492.61573469185,
      895638.4324845031,
      247922.52117242594
    ]
  },
  "ESRI:103504": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0804448592903607e6,
      75307.10902630727,
      2.8490910599464574e6,
      754225.2387347437
    ]
  },
  "ESRI:103505": {
    proj4: "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.0654070673773005e6,
      116445.58968074752,
      2938446300802172e-9,
      813394.0983347307
    ]
  },
  "ESRI:103506": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403035.4105968763,
      50729.98810095808,
      764034.1219375811,
      297653.7686659716
    ]
  },
  "ESRI:103507": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      396472.80539090245,
      47032.74485349966,
      752900.9644348032,
      263532.0000815143
    ]
  },
  "ESRI:103508": {
    proj4: "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3222920095999185e6,
      166436.63596122665,
      2.5066686150568807e6,
      976552.4060316086
    ]
  },
  "ESRI:103509": {
    proj4: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3007611956866526e6,
      154306.59707352347,
      2470142580816517e-9,
      864604.5702674349
    ]
  },
  "ESRI:103510": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      145234.1114682252,
      41670.657526540395,
      918564.8787926255,
      228901.9813547924
    ]
  },
  "ESRI:103511": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      414409.71996951895,
      33637.59674371423,
      924488.3684600197,
      253870.04933969644
    ]
  },
  "ESRI:103512": {
    proj4: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      476488.91404200223,
      136714.4822349913,
      3013658273172139e-9,
      750989.2504948481
    ]
  },
  "ESRI:103513": {
    proj4: "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3596092229333303e6,
      110359.34865000246,
      3.0330922555225817e6,
      832905.3202086542
    ]
  },
  "ESRI:103514": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      364722.69794594496,
      51900.29667448759,
      850571.8392683542,
      266893.21477785433
    ]
  },
  "ESRI:103515": {
    proj4: "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1965943848443213e6,
      170276.22333954804,
      2790584442666259e-9,
      875632.1554836772
    ]
  },
  "ESRI:103516": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=39.9333333333333 +lat_2=40.9666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      361633.13518682023,
      45575.569319859984,
      854195.2283628278,
      209415.98457540837
    ]
  },
  "ESRI:103517": {
    proj4: "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=39.9333333333333 +lat_2=40.9666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.1864580443587594e6,
      149525.84701024066,
      2.8024721783870445e6,
      687058.942727819
    ]
  },
  "ESRI:103518": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70610.77827680032,
      5241.624167031077,
      134786.23705289746,
      104115.19509468034
    ]
  },
  "ESRI:103519": {
    proj4: "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      231662.19506313576,
      17196.895288001127,
      442211.17939771444,
      341584.60257313045
    ]
  },
  "ESRI:103520": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      386694.5942843487,
      26576.309440707257,
      835428.2312511974,
      377206.79542095796
    ]
  },
  "ESRI:103521": {
    proj4: "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      1.2686830521140047e6,
      87192.61627528627,
      2.7409062705091774e6,
      1.2375551030871323e6
    ]
  },
  "ESRI:103522": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      274445.55115673057,
      42263.33611194197,
      875171.275386896,
      241258.54943746259
    ]
  },
  "ESRI:103523": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      293645.5414990948,
      23168.180991156736,
      908809.9399088016,
      280198.1646000247
    ]
  },
  "ESRI:103524": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      900410.1124200403,
      138658.96189392963,
      2871291092665175e-9,
      791529.0909460753
    ]
  },
  "ESRI:103525": {
    proj4: "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      963402.080734947,
      76010.94046848673,
      298165394451746e-8,
      919283.4783585811
    ]
  },
  "ESRI:103526": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      206556.4167882325,
      80414.01570951591,
      988711.5866813466,
      269011.42753063503
    ]
  },
  "ESRI:103527": {
    proj4: "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      677677.1774127262,
      263824.98320697015,
      3243797930637052e-9,
      882581.6584900919
    ]
  },
  "ESRI:103539": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      59141.726237106894,
      1.0343726299247856e6,
      335289.37593961245,
      1.2783945558126816e6
    ]
  },
  "ESRI:103540": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166935.12352544628,
      2015335542194466e-9,
      1.0128529570071835e6,
      2.3319457757578273e6
    ]
  },
  "ESRI:103541": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      88485.92409938842,
      302995849409869e-8,
      1.3434805489688963e6,
      3.3083897075738376e6
    ]
  },
  "ESRI:103542": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      8759.288909710478,
      4.0092582172219297e6,
      1.1020569519511203e6,
      4325654758743864e-9
    ]
  },
  "ESRI:103543": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      129543.46292791484,
      5019245231079103e-9,
      461995.7043444619,
      5282860637212539e-9
    ]
  },
  "ESRI:103544": {
    proj4: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      194034.1468295749,
      3393604203344901e-9,
      1100028560895212e-9,
      4.1941994718621066e6
    ]
  },
  "ESRI:103545": {
    proj4: "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      547686.3177664017,
      6611980024683012e-9,
      3.3230017431144016e6,
      7650725432632139e-9
    ]
  },
  "ESRI:103546": {
    proj4: "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      290307.5693160769,
      9940788826055452e-9,
      4407735767742121e-9,
      10854275232265167e-9
    ]
  },
  "ESRI:103547": {
    proj4: "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=600000 +y_0=3999999.99999999 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      28737.76703127513,
      1315370800100225e-8,
      3.6156651831929674e6,
      14191752320978794e-9
    ]
  },
  "ESRI:103548": {
    proj4: "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=300000 +y_0=5000000.00000001 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      425010.511289334,
      16467307062298728e-9,
      1.5157309066701222e6,
      1733218527392151e-8
    ]
  },
  "ESRI:103549": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      284873.76674905524,
      1.0272050082885996e6,
      703762.8414941019,
      1189089125360079e-9
    ]
  },
  "ESRI:103550": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      277517.6837629482,
      2.0205658722523456e6,
      706724.0386204798,
      2.3078016831011996e6
    ]
  },
  "ESRI:103551": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      273008.07224937936,
      3038980003301329e-9,
      714340.5503610091,
      3.2151793513247273e6
    ]
  },
  "ESRI:103552": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      934625.2189929633,
      3370095171550523e-9,
      2.3089332070016465e6,
      3.9012110412076083e6
    ]
  },
  "ESRI:103553": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      910491.0884611161,
      6629153124187484e-9,
      2318648420670865e-9,
      7571527831696848e-9
    ]
  },
  "ESRI:103554": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      895695.7750963889,
      9970406834978113e-9,
      2.3436369762500296e6,
      1054848868544858e-8
    ]
  },
  "ESRI:103555": {
    proj4: "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000.000000001 +y_0=1000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      934623.3497425287,
      3370088431360181e-9,
      2.3089285891352366e6,
      3.9012032387855267e6
    ]
  },
  "ESRI:103556": {
    proj4: "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000.000000001 +y_0=2000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      910489.2674789426,
      6629139865881238e-9,
      2.3186437833740273e6,
      7571512688641187e-9
    ]
  },
  "ESRI:103557": {
    proj4: "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000.000000001 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      895693.9837048422,
      9970386894164445e-9,
      2.3436322889760807e6,
      10548467588471211e-9
    ]
  },
  "ESRI:103558": {
    proj4: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964285714286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      423006.83830275654,
      24866.35168721318,
      578802.8666229617,
      281578.89647224586
    ]
  },
  "ESRI:103559": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3625533262610403e6,
      2.0126377358033939e6,
      3671261036751879e-9,
      2.2009270598530993e6
    ]
  },
  "ESRI:103560": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.0363669807438697e6,
      1.0356581369762697e6,
      3779083924305619e-9,
      1220762136312244e-9
    ]
  },
  "ESRI:103561": {
    proj4: "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=3500000.00000001 +y_0=2000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1103197703790813e-8,
      6603128971548302e-9,
      1204479558474349e-8,
      7220874862201378e-9
    ]
  },
  "ESRI:103562": {
    proj4: "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=3500000.00000001 +y_0=1000000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      9961814002657212e-9,
      3397821737729645e-9,
      12398544508326052e-9,
      4005117108884421e-9
    ]
  },
  "ESRI:103563": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      199622.13896693767,
      16618.325904666533,
      778655.8701648887,
      234845.72192574354
    ]
  },
  "ESRI:103564": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      195499.39120977296,
      30501.042787402166,
      769845.0253765109,
      259212.8282079461
    ]
  },
  "ESRI:103565": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      654926.9675940314,
      54521.95757222679,
      2.5546401340326425e6,
      770489.6726847104
    ]
  },
  "ESRI:103566": {
    proj4: "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      641400.9193274002,
      100068.83787833528,
      2.5257332207561065e6,
      850434.0872122366
    ]
  },
  "ESRI:103567": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      403574.7782005908,
      31335.654182597726,
      750577.3343822454,
      239088.0765441185
    ]
  },
  "ESRI:103568": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      453513.4977037739,
      23502.170616556796,
      768516.5072083793,
      242635.5204737266
    ]
  },
  "ESRI:103569": {
    proj4: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3240615848131052e6,
      102807.05876407272,
      2.4625191378857507e6,
      784408.1311284956
    ]
  },
  "ESRI:103570": {
    proj4: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.4879022003831316e6,
      77106.70476448676,
      2.5213745740661584e6,
      796046.7034208848
    ]
  },
  "ESRI:103571": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      373644.5392621008,
      26717.932057823346,
      747455.7457836679,
      240055.50940082088
    ]
  },
  "ESRI:103572": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      368160.8288686152,
      20423.47691706014,
      891449.2804629533,
      225280.70276785045
    ]
  },
  "ESRI:103573": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      482416.58582546015,
      54333.049517090316,
      843230.2890341962,
      263304.7487854939
    ]
  },
  "ESRI:103574": {
    proj4: "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2258654592290758e6,
      87657.0820930421,
      2452277725958584e-9,
      787582.1170925266
    ]
  },
  "ESRI:103575": {
    proj4: "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.2078743193797818e6,
      67006.02385205482,
      2.9246965143188727e6,
      739108.4389975228
    ]
  },
  "ESRI:103576": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.5827284153290307e6,
      178257.6799573205,
      2.7664980399396922e6,
      863858.996640408
    ]
  },
  "ESRI:103577": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      102113.10863394958,
      55062.47534181787,
      288024.8211402613,
      501582.3192299155
    ]
  },
  "ESRI:103578": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      290893.7234442881,
      155220.4817241857,
      505104.26743197144,
      601840.6136762074
    ]
  },
  "ESRI:103579": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      405623.04948556976,
      56981.50934947065,
      698535.2494466461,
      501735.86149144557
    ]
  },
  "ESRI:103580": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      717820.1237859536,
      154870.05021642725,
      882729.2572612413,
      563723.8222876207
    ]
  },
  "ESRI:103581": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      335016.09057654964,
      180650.80451728083,
      944961.4340243407,
      1645607992340148e-9
    ]
  },
  "ESRI:103582": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      954373.8243334686,
      509252.53045676596,
      1.6571629173997266e6,
      1.9745387467026906e6
    ]
  },
  "ESRI:103583": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      1.3307816215205735e6,
      186946.83525738833,
      2.2917777308928715e6,
      1.6461117389098513e6
    ]
  },
  "ESRI:103585": {
    proj4: "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      235504818945442e-8,
      508102.8230850618,
      2.8960875715312595e6,
      1.8494839069553027e6
    ]
  },
  "ESRI:103586": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -125828.51278307039,
      254679.40546847117,
      593620.0117654144,
      799297.5159398062
    ]
  },
  "ESRI:103587": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -412822.3790224568,
      835560.6827744759,
      1.9475683219336972e6,
      2622361933545848e-9
    ]
  },
  "ESRI:103588": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -412823.20466886606,
      835562.3538991801,
      1947572217078131e-9,
      2.6223671782802003e6
    ]
  },
  "ESRI:103589": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -125828.51278307039,
      254679.40546847117,
      593620.0117654144,
      799297.5159398062
    ]
  },
  "ESRI:103590": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -412822.3790224568,
      835560.6827744759,
      1.9475683219336972e6,
      2622361933545848e-9
    ]
  },
  "ESRI:103591": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -412823.20466886606,
      835562.3538991801,
      1947572217078131e-9,
      2.6223671782802003e6
    ]
  },
  "ESRI:103592": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -125828.51278307039,
      254679.40546847117,
      593620.0117654144,
      799297.5159398062
    ]
  },
  "ESRI:103593": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -412822.3790224568,
      835560.6827744759,
      1.9475683219336972e6,
      2622361933545848e-9
    ]
  },
  "ESRI:103594": {
    proj4: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +units=ft +no_defs +type=crs",
    projected_bounds: [
      -412823.20466886606,
      835562.3538991801,
      1947572217078131e-9,
      2.6223671782802003e6
    ]
  },
  "ESRI:103598": {
    proj4: "+proj=tmerc +lat_0=0 +lon_0=-90.5 +k=0.9998 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      54347.88968759269,
      1.1749015756597833e6,
      748060.8375908197,
      1.9733236365011102e6
    ]
  },
  "ESRI:103599": {
    proj4: "+proj=tmerc +lat_0=4 +lon_0=-73 +k=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6851191445195354e6,
      1.0806163613177175e6,
      5658253749787258e-9,
      3281541164536342e-9
    ]
  },
  "ESRI:103600": {
    proj4: "+proj=tmerc +lat_0=46.1541666666667 +lon_0=-93.4325 +k=1.000059152669 +x_0=152409.319685395 +y_0=30481.863937079 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -153991.80331483774,
      -258624.88618407652,
      438670.7612953202,
      396650.95224674785
    ]
  },
  "ESRI:103601": {
    proj4: "+proj=tmerc +lat_0=46.63 +lon_0=-96.7 +k=1.000045317862 +x_0=152407.211256591 +y_0=30481.4422513183 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      110342.46053832382,
      -318360.46673254477,
      675762.1561722264,
      361324.84729511925
    ]
  },
  "ESRI:103602": {
    proj4: "+proj=tmerc +lat_0=47.1516666666667 +lon_0=-95.3758333333333 +k=1.000072505661 +x_0=152411.354685446 +y_0=30482.2709370892 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3224.4495023966883,
      -374845.03765100345,
      579718.5841665178,
      294967.5821471105
    ]
  },
  "ESRI:103603": {
    proj4: "+proj=tmerc +lat_0=46.8036111111111 +lon_0=-94.9205555555556 +k=1.000071553661 +x_0=152411.209600356 +y_0=30482.2419200711 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -33606.930510054895,
      -335231.4347898371,
      546681.1353075148,
      331179.02074173454
    ]
  },
  "ESRI:103604": {
    proj4: "+proj=tmerc +lat_0=47.0666666666667 +lon_0=-91.4091666666667 +k=1.000075844621 +x_0=152411.863543968 +y_0=30482.3727087935 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -317704.98816810997,
      -350612.6480095482,
      291775.94283302856,
      289504.12869946245
    ]
  },
  "ESRI:103605": {
    proj4: "+proj=tmerc +lat_0=45.5588888888889 +lon_0=-93.6205555555556 +k=1.000054146138 +x_0=152408.556688545 +y_0=30481.7113377089 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -138776.6974925158,
      -193131.7004310815,
      452319.5148126491,
      463547.99239118374
    ]
  },
  "ESRI:103606": {
    proj4: "+proj=tmerc +lat_0=44.7458333333333 +lon_0=-92.8333333333333 +k=1.000039836799 +x_0=152406.37594092 +y_0=30481.2751881839 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -202463.95104852683,
      -99706.78498753769,
      395166.36616849445,
      551070.4940291635
    ]
  },
  "ESRI:103607": {
    proj4: "+proj=tmerc +lat_0=46.0216666666667 +lon_0=-96.5244444444444 +k=1.000048901066 +x_0=152407.757337973 +y_0=30481.5514675946 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      96141.42431727378,
      -250633.69518011724,
      663031.535642619,
      427742.70986979676
    ]
  },
  "ESRI:103608": {
    proj4: "+proj=lcc +lat_0=45.0352777777778 +lon_0=-93.2666666666667 +lat_1=45.0666666666667 +lat_2=45.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -167413.44002075534,
      -133430.06362418848,
      427290.4100958749,
      520369.68969898054
    ]
  },
  "ESRI:103609": {
    proj4: "+proj=lcc +lat_0=46.7177777777778 +lon_0=-95.6833333333333 +lat_1=46.7833333333333 +lat_2=47.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      27879.45553071375,
      -327265.46462873,
      602098.0782765888,
      344364.627667802
    ]
  },
  "ESRI:103610": {
    proj4: "+proj=lcc +lat_0=48.02 +lon_0=-95.0166666666667 +lat_1=48.1166666666667 +lat_2=48.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378505.809 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -26419.553521653404,
      -471083.12507494906,
      553458.2657075748,
      196179.2514311561
    ]
  },
  "ESRI:103611": {
    proj4: "+proj=lcc +lat_0=47.4125 +lon_0=-94.85 +lat_1=47.5 +lat_2=47.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378544.823 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39795.86581473748,
      -402967.63367272273,
      541487.4100751695,
      262769.4457184573
    ]
  },
  "ESRI:103612": {
    proj4: "+proj=lcc +lat_0=45.5591666666667 +lon_0=-94.05 +lat_1=45.5833333333333 +lat_2=45.7833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378490.569 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -104152.86655747757,
      -194443.45492562655,
      484060.83862651384,
      465038.1578811032
    ]
  },
  "ESRI:103613": {
    proj4: "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      57707.20005571896,
      -153581.73989864672,
      629431.4782017006,
      520345.81580208155
    ]
  },
  "ESRI:103614": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -86467.60621294071,
      -5016.264943966544,
      500558.77575310593,
      656387.7516991383
    ]
  },
  "ESRI:103615": {
    proj4: "+proj=lcc +lat_0=44.1080555555556 +lon_0=-94.7333333333333 +lat_1=44.1666666666667 +lat_2=44.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -48744.85769317244,
      -35147.47230558671,
      534426.2795261552,
      629530.3120788058
    ]
  },
  "ESRI:103616": {
    proj4: "+proj=lcc +lat_0=46.4172222222222 +lon_0=-92.6833333333333 +lat_1=46.4666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378454.907 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -214914.92706428538,
      -284438.1678326052,
      384504.2310442125,
      364744.7125757439
    ]
  },
  "ESRI:103617": {
    proj4: "+proj=lcc +lat_0=44.6397222222222 +lon_0=-93.7666666666667 +lat_1=44.6833333333333 +lat_2=44.9 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378400.653 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -126938.32505332504,
      -91355.2306406306,
      463836.4417099601,
      566228.9498949533
    ]
  },
  "ESRI:103618": {
    proj4: "+proj=lcc +lat_0=46.8036111111111 +lon_0=-94.2166666666667 +lat_1=46.9166666666667 +lat_2=47.3166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378567.378 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -90969.83875625292,
      -333389.130863851,
      495703.2162616643,
      327417.07319458347
    ]
  },
  "ESRI:103619": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -70585.45226435468,
      -262112.262090138,
      514018.49557935767,
      400452.2275224579
    ]
  },
  "ESRI:103620": {
    proj4: "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      41542.03666492732,
      -108922.06923504813,
      615143.3563331536,
      563575.7288109264
    ]
  },
  "ESRI:103621": {
    proj4: "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -182282.72108872014,
      -161679.48344784384,
      413859.9467590053,
      490686.8044755868
    ]
  },
  "ESRI:103622": {
    proj4: "+proj=lcc +lat_0=47.8833333333333 +lon_0=-90.25 +lat_1=47.9333333333333 +lat_2=48.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -412410.7254662095,
      -432810.8232543433,
      207604.9485930157,
      197211.9096063856
    ]
  },
  "ESRI:103623": {
    proj4: "+proj=lcc +lat_0=47.4388888888889 +lon_0=-90.25 +lat_1=47.55 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -412154.87653907173,
      -383435.3563712799,
      207614.36820172373,
      246643.5418579763
    ]
  },
  "ESRI:103624": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -33911.00186707082,
      -6701.912091905029,
      547958.5628730278,
      659371.6465918571
    ]
  },
  "ESRI:103625": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -70585.45226435468,
      -262112.262090138,
      514018.49557935767,
      400452.2275224579
    ]
  },
  "ESRI:103626": {
    proj4: "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -163303.32699524955,
      -71072.21558106752,
      431122.6927613432,
      583260.4663172595
    ]
  },
  "ESRI:103627": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -195570.59740450373,
      1350.2818785988238,
      402293.4560431732,
      653122.6360688306
    ]
  },
  "ESRI:103628": {
    proj4: "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      57672.90733801077,
      -221048.86806825278,
      629118.0143828384,
      452958.77731000906
    ]
  },
  "ESRI:103629": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112058.45898092072,
      34581.89216787062,
      477776.11989018164,
      693956.1335721478
    ]
  },
  "ESRI:103630": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-92.0833333333333 +lat_1=43.55 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378464.661 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -262861.911450368,
      42227.6464081324,
      341656.407280916,
      688164.1535746957
    ]
  },
  "ESRI:103631": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112058.45898092072,
      34581.89216787062,
      477776.11989018164,
      693956.1335721478
    ]
  },
  "ESRI:103632": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -178095.59988298576,
      -39569.125817345295,
      417873.83080769936,
      613525.9365951337
    ]
  },
  "ESRI:103633": {
    proj4: "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      57672.90733801077,
      -221048.86806825278,
      629118.0143828384,
      452958.77731000906
    ]
  },
  "ESRI:103634": {
    proj4: "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333333 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -157952.40131727565,
      -106768.44141157351,
      435856.3790470487,
      547952.1059855144
    ]
  },
  "ESRI:103635": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-91.4666666666667 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378436.619 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -312637.50292759715,
      45501.47480759171,
      296660.4095422791,
      686917.5290315237
    ]
  },
  "ESRI:103636": {
    proj4: "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -182282.72108872014,
      -161679.48344784384,
      413859.9467590053,
      490686.8044755868
    ]
  },
  "ESRI:103637": {
    proj4: "+proj=lcc +lat_0=47.5 +lon_0=-93.7333333333333 +lat_1=47.5666666666667 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -130297.78254185518,
      -409273.99640638434,
      460524.8887214687,
      248015.22286977764
    ]
  },
  "ESRI:103638": {
    proj4: "+proj=lcc +lat_0=47.0263888888889 +lon_0=-93.7333333333333 +lat_1=47.0833333333333 +lat_2=47.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -130153.07792903803,
      -356548.15359511884,
      460606.88519352156,
      300642.81674661144
    ]
  },
  "ESRI:103639": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112058.45898092072,
      34581.89216787062,
      477776.11989018164,
      693956.1335721478
    ]
  },
  "ESRI:103640": {
    proj4: "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -197236.9623427309,
      -209048.49971052952,
      400366.8379400538,
      441832.46770442603
    ]
  },
  "ESRI:103641": {
    proj4: "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -47460.04756092717,
      -122215.69984363475,
      535164.2210099533,
      542415.6438587833
    ]
  },
  "ESRI:103642": {
    proj4: "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      65491.79599575052,
      -531490.2417385419,
      635440.0118988252,
      144594.69262554467
    ]
  },
  "ESRI:103643": {
    proj4: "+proj=lcc +lat_0=47.8458333333333 +lon_0=-93.75 +lat_1=48 +lat_2=48.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -129168.12870582112,
      -447918.40524808865,
      461643.67346944107,
      209685.17775298774
    ]
  },
  "ESRI:103644": {
    proj4: "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      41542.03666492732,
      -108922.06923504813,
      615143.3563331536,
      563575.7288109264
    ]
  },
  "ESRI:103645": {
    proj4: "+proj=lcc +lat_0=49.15 +lon_0=-94.9833333333333 +lat_1=49.1833333333333 +lat_2=49.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378466.185 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -29391.089908969792,
      -597067.4494825016,
      550960.9913933375,
      70543.28702016667
    ]
  },
  "ESRI:103646": {
    proj4: "+proj=lcc +lat_0=48.3661111111111 +lon_0=-94.8833333333333 +lat_1=48.45 +lat_2=48.8833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378496.665 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -37339.311300956324,
      -509383.1714275053,
      543752.8780920862,
      157076.10679877273
    ]
  },
  "ESRI:103647": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -178095.59988298576,
      -39569.125817345295,
      417873.83080769936,
      613525.9365951337
    ]
  },
  "ESRI:103648": {
    proj4: "+proj=lcc +lat_0=44.1966666666667 +lon_0=-96.2666666666667 +lat_1=44.2833333333333 +lat_2=44.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378643.579 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      75270.36117697906,
      -47598.50248341226,
      645827.0811566813,
      627874.1716859522
    ]
  },
  "ESRI:103649": {
    proj4: "+proj=lcc +lat_0=44.1955555555556 +lon_0=-95.85 +lat_1=44.25 +lat_2=44.5833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378559.758 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      41564.892990717155,
      -46995.47800944072,
      615570.3656113693,
      625558.5165145452
    ]
  },
  "ESRI:103650": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -56856.07166976086,
      -73556.44567252923,
      526908.4100290232,
      590299.2053095831
    ]
  },
  "ESRI:103651": {
    proj4: "+proj=lcc +lat_0=47.1516666666667 +lon_0=-95.8166666666667 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      38634.98157391764,
      -375785.7722770103,
      611627.0548648981,
      296977.8228673626
    ]
  },
  "ESRI:103652": {
    proj4: "+proj=lcc +lat_0=48.1730555555555 +lon_0=-96.3833333333333 +lat_1=48.2333333333333 +lat_2=48.4833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378441.801 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      84483.64767157866,
      -490320.6218972621,
      652377.880012936,
      187202.75483630775
    ]
  },
  "ESRI:103653": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112058.45898092072,
      34581.89216787062,
      477776.11989018164,
      693956.1335721478
    ]
  },
  "ESRI:103654": {
    proj4: "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -47460.04756092717,
      -122215.69984363475,
      535164.2210099533,
      542415.6438587833
    ]
  },
  "ESRI:103655": {
    proj4: "+proj=lcc +lat_0=45.7738888888889 +lon_0=-94.2 +lat_1=45.85 +lat_2=46.2666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -92082.42415249557,
      -218783.1592750237,
      494813.2219742674,
      441781.9985989155
    ]
  },
  "ESRI:103656": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -112058.45898092072,
      34581.89216787062,
      477776.11989018164,
      693956.1335721478
    ]
  },
  "ESRI:103657": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-95.7666666666667 +lat_1=43.9166666666667 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378617.061 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      34832.2437240211,
      -8269.181413721071,
      609805.5908811722,
      663777.9932774724
    ]
  },
  "ESRI:103658": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -86467.60621294071,
      -5016.264943966544,
      500558.77575310593,
      656387.7516991383
    ]
  },
  "ESRI:103659": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      49665.76102788128,
      30155.35710136435,
      623442.923867086,
      703567.8760600358
    ]
  },
  "ESRI:103660": {
    proj4: "+proj=lcc +lat_0=47.1505555555556 +lon_0=-96.45 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378468.623 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      89976.79798404456,
      -376370.65077759523,
      657472.0727616125,
      301014.7647480235
    ]
  },
  "ESRI:103661": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -195570.59740450373,
      1350.2818785988238,
      402293.4560431732,
      653122.6360688306
    ]
  },
  "ESRI:103662": {
    proj4: "+proj=lcc +lat_0=46.1063888888889 +lon_0=-95.7166666666667 +lat_1=46.1833333333333 +lat_2=46.65 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      30640.98895043852,
      -259270.82266885877,
      604711.7921129137,
      412438.06888927304
    ]
  },
  "ESRI:103663": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      83179.15727455718,
      -415163.72524502175,
      651281.5461294153,
      261894.13225805038
    ]
  },
  "ESRI:103664": {
    proj4: "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -197236.9623427309,
      -209048.49971052952,
      400366.8379400538,
      441832.46770442603
    ]
  },
  "ESRI:103665": {
    proj4: "+proj=lcc +lat_0=43.8491666666667 +lon_0=-96.25 +lat_1=43.8833333333333 +lat_2=44.15 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378670.401 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      73929.14584603148,
      -8967.890092148937,
      644977.2507962547,
      666449.3410104143
    ]
  },
  "ESRI:103666": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      83179.15727455718,
      -415163.72524502175,
      651281.5461294153,
      261894.13225805038
    ]
  },
  "ESRI:103667": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -15136.393352244253,
      -166630.79399129143,
      564025.1060504697,
      500864.2559534695
    ]
  },
  "ESRI:103668": {
    proj4: "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333333 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -157952.40131727565,
      -106768.44141157351,
      435856.3790470487,
      547952.1059855144
    ]
  },
  "ESRI:103669": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      83179.15727455718,
      -415163.72524502175,
      651281.5461294153,
      261894.13225805038
    ]
  },
  "ESRI:103670": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-95.2333333333333 +lat_1=44.2666666666667 +lat_2=44.5666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378438.753 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -8313.331736844615,
      -45878.73288037152,
      570731.3961901946,
      622320.31428988
    ]
  },
  "ESRI:103671": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -56856.07166976086,
      -73556.44567252923,
      526908.4100290232,
      590299.2053095831
    ]
  },
  "ESRI:103672": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -178095.59988298576,
      -39569.125817345295,
      417873.83080769936,
      613525.9365951337
    ]
  },
  "ESRI:103673": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      49665.76102788128,
      30155.35710136435,
      623442.923867086,
      703567.8760600358
    ]
  },
  "ESRI:103674": {
    proj4: "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      65491.79599575052,
      -531490.2417385419,
      635440.0118988252,
      144594.69262554467
    ]
  },
  "ESRI:103675": {
    proj4: "+proj=lcc +lat_0=47.8333333333333 +lon_0=-92.45 +lat_1=47.9833333333333 +lat_2=48.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378543.909 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -234513.14090447396,
      -440859.3219878779,
      367335.69989637495,
      206633.2145680482
    ]
  },
  "ESRI:103676": {
    proj4: "+proj=lcc +lat_0=47.25 +lon_0=-92.45 +lat_1=47.3333333333333 +lat_2=47.75 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378605.783 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -234167.83174355497,
      -375922.5890030363,
      367410.31816097547,
      271477.73347945284
    ]
  },
  "ESRI:103677": {
    proj4: "+proj=lcc +lat_0=46.65 +lon_0=-92.45 +lat_1=46.7833333333333 +lat_2=47.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378540.861 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -233920.38945831207,
      -309195.7049294378,
      367492.37777838344,
      338190.40452883625
    ]
  },
  "ESRI:103678": {
    proj4: "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -163303.32699524955,
      -71072.21558106752,
      431122.6927613432,
      583260.4663172595
    ]
  },
  "ESRI:103679": {
    proj4: "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -117562.49605462683,
      -129259.86858189302,
      472120.0428362996,
      529056.978616281
    ]
  },
  "ESRI:103680": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -56856.07166976086,
      -73556.44567252923,
      526908.4100290232,
      590299.2053095831
    ]
  },
  "ESRI:103681": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -15136.393352244253,
      -166630.79399129143,
      564025.1060504697,
      500864.2559534695
    ]
  },
  "ESRI:103682": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -195570.59740450373,
      1350.2818785988238,
      402293.4560431732,
      653122.6360688306
    ]
  },
  "ESRI:103683": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -15136.393352244253,
      -166630.79399129143,
      564025.1060504697,
      500864.2559534695
    ]
  },
  "ESRI:103684": {
    proj4: "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      57707.20005571896,
      -153581.73989864672,
      629431.4782017006,
      520345.81580208155
    ]
  },
  "ESRI:103685": {
    proj4: "+proj=lcc +lat_0=45.7733333333333 +lon_0=-94.9 +lat_1=45.8666666666667 +lat_2=46.2833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378548.481 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -35436.449766500475,
      -220625.78380566093,
      545625.1078018942,
      445082.8639678598
    ]
  },
  "ESRI:103686": {
    proj4: "+proj=lcc +lat_0=45.5855555555556 +lon_0=-96.55 +lat_1=45.6333333333333 +lat_2=45.9666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378463.746 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      98158.73450600411,
      -202235.99597674995,
      665429.9227223413,
      475304.69666754093
    ]
  },
  "ESRI:103687": {
    proj4: "+proj=lcc +lat_0=44.1069444444444 +lon_0=-92.2666666666667 +lat_1=44.15 +lat_2=44.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378426.561 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -248086.87521842966,
      -25982.625062863484,
      354816.56251405017,
      620877.0496966558
    ]
  },
  "ESRI:103688": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -70585.45226435468,
      -262112.262090138,
      514018.49557935767,
      400452.2275224579
    ]
  },
  "ESRI:103689": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -195570.59740450373,
      1350.2818785988238,
      402293.4560431732,
      653122.6360688306
    ]
  },
  "ESRI:103690": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -33911.00186707082,
      -6701.912091905029,
      547958.5628730278,
      659371.6465918571
    ]
  },
  "ESRI:103691": {
    proj4: "+proj=lcc +lat_0=43.8472222222222 +lon_0=-91.6166666666667 +lat_1=43.9 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378453.688 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -300545.26331711566,
      6183.981036019366,
      307514.2343873894,
      648442.3951346886
    ]
  },
  "ESRI:103692": {
    proj4: "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      -117562.49605462683,
      -129259.86858189302,
      472120.0428362996,
      529056.978616281
    ]
  },
  "ESRI:103693": {
    proj4: "+proj=lcc +lat_0=44.5416666666667 +lon_0=-95.9 +lat_1=44.6666666666667 +lat_2=44.95 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378530.193 +rf=298.257222100883 +units=m +no_defs +type=crs",
    projected_bounds: [
      45595.94178040381,
      -85525.80269201196,
      618919.5200563233,
      587339.6373498193
    ]
  },
  "ESRI:103694": {
    proj4: "+proj=tmerc +lat_0=46.6166666666667 +lon_0=-92.45 +k=0.99998529 +x_0=1450000 +y_0=1000000 +a=6378523 +rf=298.2752724 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0641130785357235e6,
      663576.9490672299,
      1664931360755608e-9,
      1311485724661014e-9
    ]
  },
  "ESRI:103695": {
    proj4: "+proj=tmerc +lat_0=46.6166666666667 +lon_0=-92.45 +k=0.99998529 +x_0=1449999.9999999 +y_0=999999.999999899 +a=6378523 +rf=298.2752724 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      3.4911776584956255e6,
      2177085373731072e-9,
      5462362306078697e-9,
      4302766081658346e-9
    ]
  },
  "ESRI:103696": {
    proj4: "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      246917.18544612406,
      4520887054048674e-9,
      534994.6550617069,
      9329005182354301e-9
    ]
  },
  "ESRI:103697": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      244050.00895109907,
      4436509744106726e-9,
      534994.655061707,
      9329005182354301e-9
    ]
  },
  "ESRI:103698": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      238596.64535791575,
      4272219139229722e-9,
      534994.6550617071,
      9329005182354301e-9
    ]
  },
  "ESRI:103699": {
    proj4: "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=169529.584 +y_0=126907.39 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      70942.8237358746,
      69224.70783105094,
      204797.07108768664,
      217412.2015902349
    ]
  },
  "ESRI:103700": {
    proj4: "+proj=tmerc +lat_0=46.1541666666667 +lon_0=-93.4325 +k=1.000059152669 +x_0=152409.319685395 +y_0=30481.863937079 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -505221.4413754302,
      -848505.1474222578,
      1.4392056560163964e6,
      1.3013456658295388e6
    ]
  },
  "ESRI:103701": {
    proj4: "+proj=tmerc +lat_0=46.63 +lon_0=-96.7 +k=1.000045317862 +x_0=152407.211256591 +y_0=30481.4422513183 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      362015.2226161508,
      -1.0444876312716907e6,
      2.2170630073750466e6,
      1185446603167404e-9
    ]
  },
  "ESRI:103702": {
    proj4: "+proj=tmerc +lat_0=47.1516666666667 +lon_0=-95.3758333333333 +k=1.000072505661 +x_0=152411.354685446 +y_0=30482.2709370892 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      10578.881409113135,
      -1.2298040943600007e6,
      1.9019600548863176e6,
      967739.4757609784
    ]
  },
  "ESRI:103703": {
    proj4: "+proj=tmerc +lat_0=46.8036111111111 +lon_0=-94.9205555555556 +k=1.000071553661 +x_0=152411.209600356 +y_0=30482.2419200711 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -110258.73784840512,
      -1.0998384656396573e6,
      1793569691421405e-9,
      1086543170550174e-9
    ]
  },
  "ESRI:103704": {
    proj4: "+proj=tmerc +lat_0=47.0666666666667 +lon_0=-91.4091666666667 +k=1.000075844621 +x_0=152411.863543968 +y_0=30482.3727087935 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.0423371153482075e6,
      -1.1503016626779928e6,
      957268.2391113613,
      949814.7955748198
    ]
  },
  "ESRI:103705": {
    proj4: "+proj=tmerc +lat_0=45.5588888888889 +lon_0=-93.6205555555556 +k=1.000054146138 +x_0=152408.556688545 +y_0=30481.7113377089 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -455303.21502336237,
      -633632.9204976399,
      1.4839849415144997e6,
      1.5208237050367421e6
    ]
  },
  "ESRI:103706": {
    proj4: "+proj=tmerc +lat_0=44.7458333333333 +lon_0=-92.8333333333333 +k=1.000039836799 +x_0=152406.37594092 +y_0=30481.2751881839 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -664250.4793983751,
      -327121.34374661325,
      1.2964749863378024e6,
      1.8079704458273475e6
    ]
  },
  "ESRI:103707": {
    proj4: "+proj=tmerc +lat_0=46.0216666666667 +lon_0=-96.5244444444444 +k=1.000048901066 +x_0=152407.757337973 +y_0=30481.5514675946 +ellps=GRS80 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      315423.9896142557,
      -822287.3816034347,
      2175295963187493e-9,
      1.4033525406311583e6
    ]
  },
  "ESRI:103708": {
    proj4: "+proj=lcc +lat_0=45.0352777777778 +lon_0=-93.2666666666667 +lat_1=45.0666666666667 +lat_2=45.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -549255.5944680949,
      -437761.8004070251,
      1.4018686204562164e6,
      1.7072462236207388e6
    ]
  },
  "ESRI:103709": {
    proj4: "+proj=lcc +lat_0=46.7177777777778 +lon_0=-95.6833333333333 +lat_1=46.7833333333333 +lat_2=47.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      91467.84702035003,
      -1.0737034452027585e6,
      1.9753834451457753e6,
      1129802949273447e-9
    ]
  },
  "ESRI:103710": {
    proj4: "+proj=lcc +lat_0=48.02 +lon_0=-95.0166666666667 +lat_1=48.1166666666667 +lat_2=48.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378505.809 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -86678.15184562455,
      -1.5455452195167288e6,
      1.8158043267422684e6,
      643631.427403718
    ]
  },
  "ESRI:103711": {
    proj4: "+proj=lcc +lat_0=47.4125 +lon_0=-94.85 +lat_1=47.5 +lat_2=47.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378544.823 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -130563.60309385123,
      -1.3220696448079247e6,
      1.7765299445549522e6,
      862102.7564946387
    ]
  },
  "ESRI:103712": {
    proj4: "+proj=lcc +lat_0=45.5591666666667 +lon_0=-94.05 +lat_1=45.5833333333333 +lat_2=45.7833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378490.569 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -341708.196363991,
      -637936.5683684931,
      1.5881229347271544e6,
      1525712689648253e-9
    ]
  },
  "ESRI:103713": {
    proj4: "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      189327.70551613797,
      -503876.09165081015,
      2065059774733413e-9,
      1707167897343996e-9
    ]
  },
  "ESRI:103714": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -283685.80471695634,
      -16457.529236996903,
      1.6422499167833151e6,
      2.1534988153662565e6
    ]
  },
  "ESRI:103715": {
    proj4: "+proj=lcc +lat_0=44.1080555555556 +lon_0=-94.7333333333333 +lat_1=44.1666666666667 +lat_2=44.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -159923.7539483499,
      -115312.99872257907,
      1.7533635520787279e6,
      2065384032211882e-9
    ]
  },
  "ESRI:103716": {
    proj4: "+proj=lcc +lat_0=46.4172222222222 +lon_0=-92.6833333333333 +lat_1=46.4666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378454.907 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -705100.0565434097,
      -933194.2222974723,
      1261494298017554e-9,
      1.1966666111755867e6
    ]
  },
  "ESRI:103717": {
    proj4: "+proj=lcc +lat_0=44.6397222222222 +lon_0=-93.7666666666667 +lat_1=44.6833333333333 +lat_2=44.9 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378400.653 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -416463.48811245064,
      -299721.2858601356,
      1521770059176761e-9,
      1.8577028131136927e6
    ]
  },
  "ESRI:103718": {
    proj4: "+proj=lcc +lat_0=46.8036111111111 +lon_0=-94.2166666666667 +lat_1=46.9166666666667 +lat_2=47.3166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378567.378 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -298456.87931947317,
      -1.0937941735091512e6,
      1.6263196353518104e6,
      1.0742008476392294e6
    ]
  },
  "ESRI:103719": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -231579.10463730368,
      -859946.6465407279,
      1.6864090142466095e6,
      1.3138170164632641e6
    ]
  },
  "ESRI:103720": {
    proj4: "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      136292.49862484907,
      -357355.1554819871,
      2.0181828282363547e6,
      1.8489980369405146e6
    ]
  },
  "ESRI:103721": {
    proj4: "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -598039.227438576,
      -530443.438611801,
      1.3578055086585034e6,
      1.6098616243503212e6
    ]
  },
  "ESRI:103722": {
    proj4: "+proj=lcc +lat_0=47.8833333333333 +lon_0=-90.25 +lat_1=47.9333333333333 +lat_2=48.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.3530508551337225e6,
      -1.4199801759602914e6,
      681117.2355089191,
      647019.4067669502
    ]
  },
  "ESRI:103723": {
    proj4: "+proj=lcc +lat_0=47.4388888888889 +lon_0=-90.25 +lat_1=47.55 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.3522114574452713e6,
      -1257987498361441e-9,
      681148.1396751554,
      809196.353579044
    ]
  },
  "ESRI:103724": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -111256.34529221487,
      -21987.856588191753,
      1.7977607183592587e6,
      2.1632884771934515e6
    ]
  },
  "ESRI:103725": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -231579.10463730368,
      -859946.6465407279,
      1.6864090142466095e6,
      1.3138170164632641e6
    ]
  },
  "ESRI:103726": {
    proj4: "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -535770.9986502479,
      -233176.09395221903,
      1.4144417011678403e6,
      1913580379909209e-9
    ]
  },
  "ESRI:103727": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -641634.5349846093,
      4430.049796702975,
      1.3198577803683109e6,
      2.1427865151691553e6
    ]
  },
  "ESRI:103728": {
    proj4: "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      189215.19682479036,
      -725224.4946539261,
      2064031352187696e-9,
      1.4860822552245883e6
    ]
  },
  "ESRI:103729": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -367645.1275065708,
      113457.42455408887,
      1567503820006371e-9,
      2276754414894622e-9
    ]
  },
  "ESRI:103730": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-92.0833333333333 +lat_1=43.55 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378464.661 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -862406.1211500824,
      138541.8699240144,
      1.1209177295541386e6,
      2.2577518938529813e6
    ]
  },
  "ESRI:103731": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -367645.1275065708,
      113457.42455408887,
      1567503820006371e-9,
      2276754414894622e-9
    ]
  },
  "ESRI:103732": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -584301.9806160958,
      -129819.70695240704,
      1.3709743932415938e6,
      2.0128763436458681e6
    ]
  },
  "ESRI:103733": {
    proj4: "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      189215.19682479036,
      -725224.4946539261,
      2064031352187696e-9,
      1.4860822552245883e6
    ]
  },
  "ESRI:103734": {
    proj4: "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333333 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -518215.5033217619,
      -350289.46153113747,
      1.4299721369235257e6,
      1797739534387475e-9
    ]
  },
  "ESRI:103735": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-91.4666666666667 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378436.619 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -1.0257115408549585e6,
      149282.75526457382,
      973293.3603066275,
      2253661926497591e-9
    ]
  },
  "ESRI:103736": {
    proj4: "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -598039.227438576,
      -530443.438611801,
      1.3578055086585034e6,
      1.6098616243503212e6
    ]
  },
  "ESRI:103737": {
    proj4: "+proj=lcc +lat_0=47.5 +lon_0=-93.7333333333333 +lat_1=47.5666666666667 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -427485.3082227366,
      -1.3427597698766128e6,
      1.5109054057470188e6,
      813696.6103652623
    ]
  },
  "ESRI:103738": {
    proj4: "+proj=lcc +lat_0=47.0263888888889 +lon_0=-93.7333333333333 +lat_1=47.0833333333333 +lat_2=47.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -427010.55650551897,
      -1.1697750672533193e6,
      1.5111744225057454e6,
      986358.9746095078
    ]
  },
  "ESRI:103739": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -367645.1275065708,
      113457.42455408887,
      1567503820006371e-9,
      2276754414894622e-9
    ]
  },
  "ESRI:103740": {
    proj4: "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -647101.600619443,
      -685853.286133629,
      1.3135368674749932e6,
      1.4495786877936046e6
    ]
  },
  "ESRI:103741": {
    proj4: "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -155708.50603947524,
      -400969.3419036584,
      1755784615096822e-9,
      1.7795753248933584e6
    ]
  },
  "ESRI:103742": {
    proj4: "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      214867.66736272487,
      -1.7437309014371997e6,
      2084772772371396e-9,
      474391.08738897456
    ]
  },
  "ESRI:103743": {
    proj4: "+proj=lcc +lat_0=47.8458333333333 +lon_0=-93.75 +lat_1=48 +lat_2=48.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -423779.10226234817,
      -1.4695456345514376e6,
      1.5145759520409915e6,
      687942.1206779274
    ]
  },
  "ESRI:103744": {
    proj4: "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      136292.49862484907,
      -357355.1554819871,
      2.0181828282363547e6,
      1.8489980369405146e6
    ]
  },
  "ESRI:103745": {
    proj4: "+proj=lcc +lat_0=49.15 +lon_0=-94.9833333333333 +lat_1=49.1833333333333 +lat_2=49.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378466.185 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -96427.26747634508,
      -1.9588787905105075e6,
      1.8076111859296416e6,
      231440.7674986635
    ]
  },
  "ESRI:103746": {
    proj4: "+proj=lcc +lat_0=48.3661111111111 +lon_0=-94.8833333333333 +lat_1=48.45 +lat_2=48.8833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378496.665 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -122504.05715988755,
      -1.6712012882584073e6,
      1783962567540453e-9,
      515340.52705564024
    ]
  },
  "ESRI:103747": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -584301.9806160958,
      -129819.70695240704,
      1.3709743932415938e6,
      2.0128763436458681e6
    ]
  },
  "ESRI:103748": {
    proj4: "+proj=lcc +lat_0=44.1966666666667 +lon_0=-96.2666666666667 +lat_1=44.2833333333333 +lat_2=44.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378643.579 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      246949.50996147215,
      -156162.75356432842,
      2118851015428212e-9,
      2.0599505116063284e6
    ]
  },
  "ESRI:103749": {
    proj4: "+proj=lcc +lat_0=44.1955555555556 +lon_0=-95.85 +lat_1=44.25 +lat_2=44.5833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378559.758 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      136367.48642037789,
      -154184.33076930678,
      2.0195837745099675e6,
      2.0523532329314705e6
    ]
  },
  "ESRI:103750": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -186535.29513654043,
      -241326.43884395633,
      1728698675236887e-9,
      1.9366733094198576e6
    ]
  },
  "ESRI:103751": {
    proj4: "+proj=lcc +lat_0=47.1516666666667 +lon_0=-95.8166666666667 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      126754.93538042814,
      -1.2328904878788248e6,
      2.0066464291692534e6,
      974334.7405240055
    ]
  },
  "ESRI:103752": {
    proj4: "+proj=lcc +lat_0=48.1730555555555 +lon_0=-96.3833333333333 +lat_1=48.2333333333333 +lat_2=48.4833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378441.801 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      277176.76740250434,
      -1.6086602403412675e6,
      2140343094675774e-9,
      614181.0381587864
    ]
  },
  "ESRI:103753": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -367645.1275065708,
      113457.42455408887,
      1567503820006371e-9,
      2276754414894622e-9
    ]
  },
  "ESRI:103754": {
    proj4: "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -155708.50603947524,
      -400969.3419036584,
      1755784615096822e-9,
      1.7795753248933584e6
    ]
  },
  "ESRI:103755": {
    proj4: "+proj=lcc +lat_0=45.7738888888889 +lon_0=-94.2 +lat_1=45.85 +lat_2=46.2666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -302107.08657364594,
      -717791.0817214737,
      1.6233997124272424e6,
      1.4494131070699422e6
    ]
  },
  "ESRI:103756": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -367645.1275065708,
      113457.42455408887,
      1567503820006371e-9,
      2276754414894622e-9
    ]
  },
  "ESRI:103757": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-95.7666666666667 +lat_1=43.9166666666667 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378617.061 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      114278.78628455925,
      -27129.80602151655,
      2.0006705094159795e6,
      2177744966277841e-9
    ]
  },
  "ESRI:103758": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -283685.80471695634,
      -16457.529236996903,
      1.6422499167833151e6,
      2.1534988153662565e6
    ]
  },
  "ESRI:103759": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      162945.0843056405,
      98934.70075672622,
      2.0454123260539314e6,
      2308288940040301e-9
    ]
  },
  "ESRI:103760": {
    proj4: "+proj=lcc +lat_0=47.1505555555556 +lon_0=-96.45 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378468.623 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      295198.87805265293,
      -1.2348093767594937e6,
      2157056292052057e-9,
      987579.2740108072
    ]
  },
  "ESRI:103761": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -641634.5349846093,
      4430.049796702975,
      1.3198577803683109e6,
      2.1427865151691553e6
    ]
  },
  "ESRI:103762": {
    proj4: "+proj=lcc +lat_0=46.1063888888889 +lon_0=-95.7166666666667 +lat_1=46.1833333333333 +lat_2=46.65 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      100527.97791489706,
      -850624.3573727476,
      1.9839586046237845e6,
      1.3531405643475568e6
    ]
  },
  "ESRI:103763": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      272896.951824943,
      -1362082988574709e-9,
      2.1367462059262567e6,
      859230.9989166204
    ]
  },
  "ESRI:103764": {
    proj4: "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -647101.600619443,
      -685853.286133629,
      1.3135368674749932e6,
      1.4495786877936046e6
    ]
  },
  "ESRI:103765": {
    proj4: "+proj=lcc +lat_0=43.8491666666667 +lon_0=-96.25 +lat_1=43.8833333333333 +lat_2=44.15 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378670.401 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      242549.20599652163,
      -29422.152743991974,
      2116062863654046e-9,
      2.1865092129650014e6
    ]
  },
  "ESRI:103766": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      272896.951824943,
      -1362082988574709e-9,
      2.1367462059262567e6,
      859230.9989166204
    ]
  },
  "ESRI:103767": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -49659.98385648803,
      -546687.8632864287,
      1.8504723687672494e6,
      1.6432521464073414e6
    ]
  },
  "ESRI:103768": {
    proj4: "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333333 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -518215.5033217619,
      -350289.46153113747,
      1.4299721369235257e6,
      1797739534387475e-9
    ]
  },
  "ESRI:103769": {
    proj4: "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      272896.951824943,
      -1362082988574709e-9,
      2.1367462059262567e6,
      859230.9989166204
    ]
  },
  "ESRI:103770": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-95.2333333333333 +lat_1=44.2666666666667 +lat_2=44.5666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378438.753 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -27274.65587329771,
      -150520.4761250189,
      1.8724745890006637e6,
      2.0417292311327148e6
    ]
  },
  "ESRI:103771": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -186535.29513654043,
      -241326.43884395633,
      1728698675236887e-9,
      1.9366733094198576e6
    ]
  },
  "ESRI:103772": {
    proj4: "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -584301.9806160958,
      -129819.70695240704,
      1.3709743932415938e6,
      2.0128763436458681e6
    ]
  },
  "ESRI:103773": {
    proj4: "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      162945.0843056405,
      98934.70075672622,
      2.0454123260539314e6,
      2308288940040301e-9
    ]
  },
  "ESRI:103774": {
    proj4: "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      214867.66736272487,
      -1.7437309014371997e6,
      2084772772371396e-9,
      474391.08738897456
    ]
  },
  "ESRI:103775": {
    proj4: "+proj=lcc +lat_0=47.8333333333333 +lon_0=-92.45 +lat_1=47.9833333333333 +lat_2=48.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378543.909 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -769398.529784095,
      -1.4463859588885629e6,
      1.2051672087433569e6,
      677929.1381286716
    ]
  },
  "ESRI:103776": {
    proj4: "+proj=lcc +lat_0=47.25 +lon_0=-92.45 +lat_1=47.3333333333333 +lat_2=47.75 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378605.783 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -768265.6279786467,
      -1.2333393607541285e6,
      1.2054120188331339e6,
      890673.1972571716
    ]
  },
  "ESRI:103777": {
    proj4: "+proj=lcc +lat_0=46.65 +lon_0=-92.45 +lat_1=46.7833333333333 +lat_2=47.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378540.861 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -767453.8110811457,
      -1.0144195752559972e6,
      1.2056812427612464e6,
      1.1095463521916904e6
    ]
  },
  "ESRI:103778": {
    proj4: "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -535770.9986502479,
      -233176.09395221903,
      1.4144417011678403e6,
      1913580379909209e-9
    ]
  },
  "ESRI:103779": {
    proj4: "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -385702.9558058882,
      -424080.08550576074,
      1548947173872093e-9,
      1.7357477706769153e6
    ]
  },
  "ESRI:103780": {
    proj4: "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333333 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -186535.29513654043,
      -241326.43884395633,
      1728698675236887e-9,
      1.9366733094198576e6
    ]
  },
  "ESRI:103781": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -49659.98385648803,
      -546687.8632864287,
      1.8504723687672494e6,
      1.6432521464073414e6
    ]
  },
  "ESRI:103782": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -641634.5349846093,
      4430.049796702975,
      1.3198577803683109e6,
      2.1427865151691553e6
    ]
  },
  "ESRI:103783": {
    proj4: "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -49659.98385648803,
      -546687.8632864287,
      1.8504723687672494e6,
      1.6432521464073414e6
    ]
  },
  "ESRI:103784": {
    proj4: "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      189327.70551613797,
      -503876.09165081015,
      2065059774733413e-9,
      1707167897343996e-9
    ]
  },
  "ESRI:103785": {
    proj4: "+proj=lcc +lat_0=45.7733333333333 +lon_0=-94.9 +lat_1=45.8666666666667 +lat_2=46.2833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378548.481 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -116261.085608927,
      -723836.425702406,
      1.7901050411800481e6,
      1.4602426962012204e6
    ]
  },
  "ESRI:103786": {
    proj4: "+proj=lcc +lat_0=45.5855555555556 +lon_0=-96.55 +lat_1=45.6333333333333 +lat_2=45.9666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378463.746 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      322042.4481251152,
      -663502.5968003873,
      2.1831646714648814e6,
      1.5593954923167573e6
    ]
  },
  "ESRI:103787": {
    proj4: "+proj=lcc +lat_0=44.1069444444444 +lon_0=-92.2666666666667 +lat_1=44.15 +lat_2=44.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378426.561 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -813931.6897791314,
      -85244.66239374463,
      1.1640940055148464e6,
      2.0369941205464453e6
    ]
  },
  "ESRI:103788": {
    proj4: "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -231579.10463730368,
      -859946.6465407279,
      1.6864090142466095e6,
      1.3138170164632641e6
    ]
  },
  "ESRI:103789": {
    proj4: "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -641634.5349846093,
      4430.049796702975,
      1.3198577803683109e6,
      2.1427865151691553e6
    ]
  },
  "ESRI:103790": {
    proj4: "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -111256.34529221487,
      -21987.856588191753,
      1.7977607183592587e6,
      2.1632884771934515e6
    ]
  },
  "ESRI:103791": {
    proj4: "+proj=lcc +lat_0=43.8472222222222 +lon_0=-91.6166666666667 +lat_1=43.9 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378453.688 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -986038.9180662371,
      20288.61111567354,
      1.0089029506526268e6,
      2127431424704391e-9
    ]
  },
  "ESRI:103792": {
    proj4: "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -385702.9558058882,
      -424080.08550576074,
      1548947173872093e-9,
      1.7357477706769153e6
    ]
  },
  "ESRI:103793": {
    proj4: "+proj=lcc +lat_0=44.5416666666667 +lon_0=-95.9 +lat_1=44.6666666666667 +lat_2=44.95 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378530.193 +rf=298.257222100883 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      149592.68565787486,
      -280595.9043320426,
      2030571792051454e-9,
      1926963460205199e-9
    ]
  },
  "ESRI:103846": {
    proj4: "+proj=lcc +lat_0=44.5811111111111 +lon_0=-91.2944444444444 +lat_1=44.8138888888889 +lat_2=45.1416666666667 +x_0=60045.7200914402 +y_0=0 +a=6378412.542 +rf=298.270107115315 +units=m +no_defs +type=crs",
    projected_bounds: [
      -71268.38719529653,
      -232243.02738672003,
      441569.40356642357,
      315276.213620641
    ]
  },
  "ESRI:103872": {
    proj4: "+proj=lcc +lat_0=-20.2755163 +lon_0=57.5645566222222 +lat_1=-20.0611111111111 +lat_2=-20.4444444444444 +x_0=250000 +y_0=350000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -134317.33113478217,
      -45999.125036592886,
      1.3159316977535181e6,
      1639249146296708e-9
    ]
  },
  "ESRI:103946": {
    proj4: "+proj=lcc +lat_0=44.5811111111111 +lon_0=-91.2944444444444 +lat_1=44.8138888888889 +lat_2=45.1416666666667 +x_0=60045.7200914402 +y_0=0 +a=6378412.542 +rf=298.270107115315 +units=us-ft +no_defs +type=crs",
    projected_bounds: [
      -233819.7003232354,
      -761950.6656845973,
      1.4487156182008416e6,
      1.0343687108537197e6
    ]
  },
  "ESRI:104009": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [69.24, 39.19, 80.29, 43.22]
  },
  "ESRI:104017": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:104018": {
    proj4: "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:104022": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39.99, 41.04, 46.72, 43.59]
  },
  "ESRI:104024": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-124.44, 32.25, -113.6, 42.53]
  },
  "ESRI:104028": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [53.8, -23.81, 67.05, -8.43]
  },
  "ESRI:104047": {
    proj4: "+proj=longlat +R=6371008.7714 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "ESRI:104050": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-0.7, 51.2, 0.6, 51.8]
  },
  "ESRI:104101": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [20.37, 57.52, 28.2, 60]
  },
  "ESRI:104102": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [9.53, 40.85, 23.04, 49.02]
  },
  "ESRI:104103": {
    proj4: "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs +type=crs",
    projected_bounds: [-16.57, 4.22, -10.26, 10]
  },
  "ESRI:104105": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [-35.58, 29.24, -6.19, 43.07]
  },
  "ESRI:104106": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-35.58, 29.24, -6.19, 43.07]
  },
  "ESRI:104109": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [135.27, -1.19, 165.68, 13.43]
  },
  "ESRI:104112": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [129.48, 1.64, 136.98, 11.45]
  },
  "ESRI:104113": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [157.47, 1.77, 175.52, 17.88]
  },
  "ESRI:104126": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [113.52, 22.06, 113.68, 22.23]
  },
  "ESRI:104127": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [5.93, 34.76, 18.99, 47.1]
  },
  "ESRI:104128": {
    proj4: "+proj=longlat +R=6370000 +no_defs +type=crs",
    projected_bounds: [-35.58, 24.6, 44.83, 84.73]
  },
  "ESRI:104129": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.08, 58.84, 31.59, 70.09]
  },
  "ESRI:104130": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [34.88, 29.18, 39.31, 33.38]
  },
  "ESRI:104131": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [13.38, 45.42, 16.61, 46.88]
  },
  "ESRI:104134": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [87.76, 41.58, 119.94, 52.15]
  },
  "ESRI:104135": {
    proj4: "+proj=longlat +ellps=krass +no_defs +type=crs",
    projected_bounds: [87.76, 41.58, 119.94, 52.15]
  },
  "ESRI:104138": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-160.3, 18.87, -154.74, 22.29]
  },
  "ESRI:104139": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-2.95, 31.99, 9.09, 37.14]
  },
  "ESRI:104140": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-2.95, 31.99, 9.09, 37.14]
  },
  "ESRI:104261": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-13.24, 27.66, -1.01, 35.97]
  },
  "ESRI:104602": {
    proj4: "+proj=longlat +datum=NAD83 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -47.74, 86.46]
  },
  "ESRI:104613": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [19.08, 58.84, 31.59, 70.09]
  },
  "ESRI:104644": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-124.44, 32.25, -113.6, 42.53]
  },
  "ESRI:104645": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39.99, 41.04, 46.72, 43.59]
  },
  "ESRI:104648": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [16.84, 47.73, 22.56, 49.61]
  },
  "ESRI:104653": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [87.76, 41.58, 119.94, 52.15]
  },
  "ESRI:104664": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [80.06, 26.34, 88.21, 30.43]
  },
  "ESRI:104693": {
    proj4: "+proj=longlat +ellps=evrst30 +no_defs +type=crs",
    projected_bounds: [79.64, 5.86, 81.95, 9.88]
  },
  "ESRI:104696": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [12.09, 48.58, 18.86, 51.06]
  },
  "ESRI:104697": {
    proj4: "+proj=longlat +ellps=bessel +no_defs +type=crs",
    projected_bounds: [12.09, 48.58, 18.86, 51.06]
  },
  "ESRI:104700": {
    proj4: "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104701": {
    proj4: "+proj=longlat +a=6378586.581 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104702": {
    proj4: "+proj=longlat +a=6378505.809 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104703": {
    proj4: "+proj=longlat +a=6378544.823 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104704": {
    proj4: "+proj=longlat +a=6378490.569 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104705": {
    proj4: "+proj=longlat +a=6378470.757 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104706": {
    proj4: "+proj=longlat +a=6378403.701 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104707": {
    proj4: "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104708": {
    proj4: "+proj=longlat +a=6378454.907 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104709": {
    proj4: "+proj=longlat +a=6378400.653 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104710": {
    proj4: "+proj=longlat +a=6378567.378 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104711": {
    proj4: "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104712": {
    proj4: "+proj=longlat +a=6378476.853 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104713": {
    proj4: "+proj=longlat +a=6378411.321 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104714": {
    proj4: "+proj=longlat +a=6378647.541 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104715": {
    proj4: "+proj=longlat +a=6378647.541 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104716": {
    proj4: "+proj=longlat +a=6378514.953 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104717": {
    proj4: "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104718": {
    proj4: "+proj=longlat +a=6378421.989 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104719": {
    proj4: "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104720": {
    proj4: "+proj=longlat +a=6378518.001 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104721": {
    proj4: "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104722": {
    proj4: "+proj=longlat +a=6378464.661 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104723": {
    proj4: "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104724": {
    proj4: "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104725": {
    proj4: "+proj=longlat +a=6378518.001 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104726": {
    proj4: "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104727": {
    proj4: "+proj=longlat +a=6378436.619 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104728": {
    proj4: "+proj=longlat +a=6378411.321 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104729": {
    proj4: "+proj=longlat +a=6378574.389 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104730": {
    proj4: "+proj=longlat +a=6378574.389 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104731": {
    proj4: "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104732": {
    proj4: "+proj=longlat +a=6378472.281 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104733": {
    proj4: "+proj=longlat +a=6378498.189 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104734": {
    proj4: "+proj=longlat +a=6378449.421 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104735": {
    proj4: "+proj=longlat +a=6378525.621 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104736": {
    proj4: "+proj=longlat +a=6378476.853 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104737": {
    proj4: "+proj=longlat +a=6378466.185 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104738": {
    proj4: "+proj=longlat +a=6378496.665 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104739": {
    proj4: "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104740": {
    proj4: "+proj=longlat +a=6378643.579 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104741": {
    proj4: "+proj=longlat +a=6378559.758 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104742": {
    proj4: "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104743": {
    proj4: "+proj=longlat +a=6378586.581 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104744": {
    proj4: "+proj=longlat +a=6378441.801 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104745": {
    proj4: "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104746": {
    proj4: "+proj=longlat +a=6378498.189 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104747": {
    proj4: "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104748": {
    proj4: "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104749": {
    proj4: "+proj=longlat +a=6378617.061 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104750": {
    proj4: "+proj=longlat +a=6378403.701 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104751": {
    proj4: "+proj=longlat +a=6378624.681 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104752": {
    proj4: "+proj=longlat +a=6378468.623 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104753": {
    proj4: "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104754": {
    proj4: "+proj=longlat +a=6378525.621 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104755": {
    proj4: "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104756": {
    proj4: "+proj=longlat +a=6378472.281 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104757": {
    proj4: "+proj=longlat +a=6378670.401 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104758": {
    proj4: "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104759": {
    proj4: "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104760": {
    proj4: "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104761": {
    proj4: "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104762": {
    proj4: "+proj=longlat +a=6378438.753 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104763": {
    proj4: "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104764": {
    proj4: "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104765": {
    proj4: "+proj=longlat +a=6378624.681 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104766": {
    proj4: "+proj=longlat +a=6378449.421 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104767": {
    proj4: "+proj=longlat +a=6378543.909 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104768": {
    proj4: "+proj=longlat +a=6378605.783 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104769": {
    proj4: "+proj=longlat +a=6378540.861 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104770": {
    proj4: "+proj=longlat +a=6378421.989 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104771": {
    proj4: "+proj=longlat +a=6378443.325 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104772": {
    proj4: "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104773": {
    proj4: "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104774": {
    proj4: "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104775": {
    proj4: "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104776": {
    proj4: "+proj=longlat +a=6378470.757 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104777": {
    proj4: "+proj=longlat +a=6378548.481 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104778": {
    proj4: "+proj=longlat +a=6378463.746 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104779": {
    proj4: "+proj=longlat +a=6378426.561 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104780": {
    proj4: "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104781": {
    proj4: "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104782": {
    proj4: "+proj=longlat +a=6378514.953 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104783": {
    proj4: "+proj=longlat +a=6378453.688 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104784": {
    proj4: "+proj=longlat +a=6378443.325 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104785": {
    proj4: "+proj=longlat +a=6378530.193 +rf=298.257222100883 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104786": {
    proj4: "+proj=longlat +a=6378523 +rf=298.2752724 +no_defs +type=crs",
    projected_bounds: [-97.22, 43.49, -89.49, 49.38]
  },
  "ESRI:104808": {
    proj4: "+proj=longlat +a=6378412.542 +rf=298.270107115315 +no_defs +type=crs",
    projected_bounds: [-92.89, 42.48, -86.25, 47.31]
  },
  "ESRI:104900": {
    proj4: "+proj=longlat +R=2439700 +no_defs +type=crs"
  },
  "ESRI:104901": {
    proj4: "+proj=longlat +R=6051000 +no_defs +type=crs"
  },
  "ESRI:104902": {
    proj4: "+proj=longlat +R=6051800 +no_defs +type=crs"
  },
  "ESRI:104903": {
    proj4: "+proj=longlat +R=1737400 +no_defs +type=crs"
  },
  "ESRI:104904": {
    proj4: "+proj=longlat +a=3393400 +rf=192.043010752688 +no_defs +type=crs"
  },
  "ESRI:104905": {
    proj4: "+proj=longlat +a=3396190 +rf=169.894447223612 +no_defs +type=crs"
  },
  "ESRI:104906": {
    proj4: "+proj=longlat +R=6200 +no_defs +type=crs"
  },
  "ESRI:104907": {
    proj4: "+proj=longlat +R=11100 +no_defs +type=crs"
  },
  "ESRI:104908": {
    proj4: "+proj=longlat +a=71492000 +rf=15.4144027598103 +no_defs +type=crs"
  },
  "ESRI:104909": {
    proj4: "+proj=longlat +R=8200 +no_defs +type=crs"
  },
  "ESRI:104910": {
    proj4: "+proj=longlat +R=83500 +no_defs +type=crs"
  },
  "ESRI:104911": {
    proj4: "+proj=longlat +R=10000 +no_defs +type=crs"
  },
  "ESRI:104912": {
    proj4: "+proj=longlat +R=2409300 +no_defs +type=crs"
  },
  "ESRI:104913": {
    proj4: "+proj=longlat +R=15000 +no_defs +type=crs"
  },
  "ESRI:104914": {
    proj4: "+proj=longlat +R=40000 +no_defs +type=crs"
  },
  "ESRI:104915": {
    proj4: "+proj=longlat +R=1562090 +no_defs +type=crs"
  },
  "ESRI:104916": {
    proj4: "+proj=longlat +R=2632345 +no_defs +type=crs"
  },
  "ESRI:104917": {
    proj4: "+proj=longlat +R=85000 +no_defs +type=crs"
  },
  "ESRI:104918": {
    proj4: "+proj=longlat +R=1821460 +no_defs +type=crs"
  },
  "ESRI:104919": {
    proj4: "+proj=longlat +R=5000 +no_defs +type=crs"
  },
  "ESRI:104920": {
    proj4: "+proj=longlat +R=12000 +no_defs +type=crs"
  },
  "ESRI:104921": {
    proj4: "+proj=longlat +a=30000 +rf=3 +no_defs +type=crs"
  },
  "ESRI:104922": {
    proj4: "+proj=longlat +R=18000 +no_defs +type=crs"
  },
  "ESRI:104923": {
    proj4: "+proj=longlat +R=14000 +no_defs +type=crs"
  },
  "ESRI:104924": {
    proj4: "+proj=longlat +R=49300 +no_defs +type=crs"
  },
  "ESRI:104925": {
    proj4: "+proj=longlat +a=60268000 +rf=10.2079945799458 +no_defs +type=crs"
  },
  "ESRI:104926": {
    proj4: "+proj=longlat +R=16000 +no_defs +type=crs"
  },
  "ESRI:104927": {
    proj4: "+proj=longlat +R=9500 +no_defs +type=crs"
  },
  "ESRI:104928": {
    proj4: "+proj=longlat +R=560000 +no_defs +type=crs"
  },
  "ESRI:104929": {
    proj4: "+proj=longlat +R=249400 +no_defs +type=crs"
  },
  "ESRI:104930": {
    proj4: "+proj=longlat +R=59500 +no_defs +type=crs"
  },
  "ESRI:104931": {
    proj4: "+proj=longlat +R=16000 +no_defs +type=crs"
  },
  "ESRI:104932": {
    proj4: "+proj=longlat +R=133000 +no_defs +type=crs"
  },
  "ESRI:104933": {
    proj4: "+proj=longlat +R=718000 +no_defs +type=crs"
  },
  "ESRI:104934": {
    proj4: "+proj=longlat +R=88800 +no_defs +type=crs"
  },
  "ESRI:104935": {
    proj4: "+proj=longlat +R=198630 +no_defs +type=crs"
  },
  "ESRI:104936": {
    proj4: "+proj=longlat +R=10000 +no_defs +type=crs"
  },
  "ESRI:104937": {
    proj4: "+proj=longlat +R=41900 +no_defs +type=crs"
  },
  "ESRI:104938": {
    proj4: "+proj=longlat +R=110000 +no_defs +type=crs"
  },
  "ESRI:104939": {
    proj4: "+proj=longlat +R=50100 +no_defs +type=crs"
  },
  "ESRI:104940": {
    proj4: "+proj=longlat +R=764000 +no_defs +type=crs"
  },
  "ESRI:104941": {
    proj4: "+proj=longlat +R=11000 +no_defs +type=crs"
  },
  "ESRI:104942": {
    proj4: "+proj=longlat +R=529800 +no_defs +type=crs"
  },
  "ESRI:104943": {
    proj4: "+proj=longlat +R=2575000 +no_defs +type=crs"
  },
  "ESRI:104944": {
    proj4: "+proj=longlat +a=25559000 +rf=43.6160409556314 +no_defs +type=crs"
  },
  "ESRI:104945": {
    proj4: "+proj=longlat +R=578900 +no_defs +type=crs"
  },
  "ESRI:104946": {
    proj4: "+proj=longlat +R=33000 +no_defs +type=crs"
  },
  "ESRI:104947": {
    proj4: "+proj=longlat +R=21000 +no_defs +type=crs"
  },
  "ESRI:104948": {
    proj4: "+proj=longlat +R=13000 +no_defs +type=crs"
  },
  "ESRI:104949": {
    proj4: "+proj=longlat +R=31000 +no_defs +type=crs"
  },
  "ESRI:104950": {
    proj4: "+proj=longlat +R=27000 +no_defs +type=crs"
  },
  "ESRI:104951": {
    proj4: "+proj=longlat +R=42000 +no_defs +type=crs"
  },
  "ESRI:104952": {
    proj4: "+proj=longlat +R=235800 +no_defs +type=crs"
  },
  "ESRI:104953": {
    proj4: "+proj=longlat +R=761400 +no_defs +type=crs"
  },
  "ESRI:104954": {
    proj4: "+proj=longlat +R=15000 +no_defs +type=crs"
  },
  "ESRI:104955": {
    proj4: "+proj=longlat +R=54000 +no_defs +type=crs"
  },
  "ESRI:104956": {
    proj4: "+proj=longlat +R=77000 +no_defs +type=crs"
  },
  "ESRI:104957": {
    proj4: "+proj=longlat +R=27000 +no_defs +type=crs"
  },
  "ESRI:104958": {
    proj4: "+proj=longlat +R=788900 +no_defs +type=crs"
  },
  "ESRI:104959": {
    proj4: "+proj=longlat +R=584700 +no_defs +type=crs"
  },
  "ESRI:104960": {
    proj4: "+proj=longlat +a=24764000 +rf=58.5437352245863 +no_defs +type=crs"
  },
  "ESRI:104961": {
    proj4: "+proj=longlat +R=74000 +no_defs +type=crs"
  },
  "ESRI:104962": {
    proj4: "+proj=longlat +R=79000 +no_defs +type=crs"
  },
  "ESRI:104963": {
    proj4: "+proj=longlat +a=104000 +rf=6.93333333333333 +no_defs +type=crs"
  },
  "ESRI:104964": {
    proj4: "+proj=longlat +R=29000 +no_defs +type=crs"
  },
  "ESRI:104965": {
    proj4: "+proj=longlat +R=170000 +no_defs +type=crs"
  },
  "ESRI:104966": {
    proj4: "+proj=longlat +R=208000 +no_defs +type=crs"
  },
  "ESRI:104967": {
    proj4: "+proj=longlat +R=40000 +no_defs +type=crs"
  },
  "ESRI:104968": {
    proj4: "+proj=longlat +R=1352600 +no_defs +type=crs"
  },
  "ESRI:104969": {
    proj4: "+proj=longlat +R=1195000 +no_defs +type=crs"
  },
  "ESRI:104970": {
    proj4: "+proj=longlat +R=593000 +no_defs +type=crs"
  },
  "ESRI:104971": {
    proj4: "+proj=longlat +R=3396190 +no_defs +type=crs"
  },
  "ESRI:104972": {
    proj4: "+proj=longlat +R=470000 +no_defs +type=crs"
  },
  "ESRI:104973": {
    proj4: "+proj=longlat +R=255000 +no_defs +type=crs"
  },
  "ESRI:104974": {
    proj4: "+proj=longlat +R=2439400 +no_defs +type=crs"
  },
  "ESRI:104975": {
    proj4: "+proj=longlat +R=695700000 +no_defs +type=crs"
  },
  "ESRI:105603": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:105700": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:105704": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115700": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115701": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115702": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115703": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115704": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115705": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115706": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115707": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115708": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115709": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115710": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115711": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115712": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115713": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115714": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115715": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115716": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115717": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115718": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115719": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115720": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115721": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115722": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115723": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115724": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115725": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115726": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115727": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115728": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115729": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115730": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115731": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115732": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115733": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115734": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115735": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115736": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115737": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115738": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115739": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115740": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115741": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115742": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115743": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115744": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115745": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115746": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115747": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115748": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115749": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115750": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115751": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115752": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115753": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115754": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115755": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115756": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115757": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115758": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115759": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115760": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115761": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115762": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115763": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115764": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115765": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115766": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115767": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115768": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115769": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115770": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115771": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115772": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115773": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115774": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115775": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115776": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115777": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115778": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115779": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115780": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115781": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115782": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115783": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115784": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115785": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115786": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115787": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115788": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115789": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115790": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115791": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115792": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115793": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115794": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115795": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115796": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115797": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115798": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115799": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115800": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115801": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115802": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115803": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115804": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115805": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115806": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115807": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115808": {
    proj4: "+vunits=us-ft +no_defs +type=crs"
  },
  "ESRI:115809": {
    proj4: "+vunits=ft +no_defs +type=crs"
  },
  "ESRI:115810": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115811": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115812": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115813": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115814": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115815": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115816": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115817": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115818": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115819": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115820": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115821": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115822": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115823": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115824": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115825": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115826": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115827": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115828": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115829": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115830": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115831": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115832": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115833": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115834": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115835": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115836": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115837": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115838": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115839": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115840": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115841": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115842": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115843": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115844": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115845": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115846": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115847": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115848": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115849": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115850": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115851": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115852": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115853": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115854": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115855": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115856": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115857": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115858": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115859": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115860": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115861": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115862": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115863": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115864": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115865": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115866": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115867": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115868": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115869": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115870": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115871": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115872": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115873": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "ESRI:115874": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:AMANU49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4715650616685004e-9,
      -3.8186585755177047e6,
      -4698503480135871e-9,
      -3862141732645285e-9
    ]
  },
  "IGNF:AMANU49G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141, -18, -140.58, -17.58]
  },
  "IGNF:AMANU63": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4715650616685004e-9,
      -3.8186585755177047e6,
      -4698503480135871e-9,
      -3862141732645285e-9
    ]
  },
  "IGNF:AMANU63G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141, -18, -140.58, -17.58]
  },
  "IGNF:AMANU63UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      499999.9999999973,
      800979009598843e-8,
      544568.50816021,
      8056207616127925e-9
    ]
  },
  "IGNF:AMST63": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0946910093687887e6,
      4917519732843258e-9,
      1081716208957707e-9,
      4932239804203646e-9
    ]
  },
  "IGNF:AMST63G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [77.45, -37.92, 77.63, -37.75]
  },
  "IGNF:AMST63GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [77.45, -37.92, 77.63, -37.75]
  },
  "IGNF:AMST63UTM43S": {
    proj4: "+proj=utm +zone=43 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      715362.7579944888,
      5800160849104083e-9,
      731719.5646291001,
      5818596209616313e-9
    ]
  },
  "IGNF:ANAA47": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5020633540349264e-9,
      -3.4376995316457255e6,
      -5011697920261778e-9,
      -3.4612131462439313e6
    ]
  },
  "IGNF:ANAA47G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-145.6, -17.5, -145.37, -17.32]
  },
  "IGNF:ANAA47UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      648637.9724885155,
      8064561413829805e-9,
      673231.7285785124,
      8084287428111445e-9
    ]
  },
  "IGNF:ANAA92": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5020633540349264e-9,
      -3.4376995316457255e6,
      -5011697920261778e-9,
      -3.4612131462439313e6
    ]
  },
  "IGNF:ANAA92G": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-145.6, -17.5, -145.37, -17.32]
  },
  "IGNF:ANAA92GEO": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-145.6, -17.5, -145.37, -17.32]
  },
  "IGNF:ANAA92UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      648631.9327673032,
      8064584978245534e-9,
      673224.6937733211,
      8084310707952639e-9
    ]
  },
  "IGNF:APAT48": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5120839785633256e-9,
      -3.3945535031913533e6,
      -511252156626137e-8,
      -3.4251198668908537e6
    ]
  },
  "IGNF:APAT48G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.46, -15.63, -146.18, -15.29]
  },
  "IGNF:APAT49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5120839785633256e-9,
      -3.3945535031913533e6,
      -511252156626137e-8,
      -3.4251198668908537e6
    ]
  },
  "IGNF:APAT49G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.46, -15.63, -146.18, -15.29]
  },
  "IGNF:APAT80": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5120839785633256e-9,
      -3.3945535031913533e6,
      -511252156626137e-8,
      -3.4251198668908537e6
    ]
  },
  "IGNF:APAT80G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.46, -15.63, -146.18, -15.29]
  },
  "IGNF:APAT80UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      557883.6456245707,
      8271897191383811e-9,
      588042.3459489879,
      8309412106286668e-9
    ]
  },
  "IGNF:APAT86": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4708410186640331e-9,
      -3.1206376048363764e6,
      -4754045840901789e-9,
      -3907338420394432e-9
    ]
  },
  "IGNF:APAT86G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.4644, -27.75, -140.5833, -15.293]
  },
  "IGNF:APAT86UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      552785.2573425442,
      693033292808678e-8,
      822219.6534699944,
      8307019992895553e-9
    ]
  },
  "IGNF:APAT86UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      204264.86167014245,
      6926840726178654e-9,
      544738.924870628,
      8309203516279376e-9
    ]
  },
  "IGNF:ATI": {
    proj4: "+proj=geocent +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +no_defs +type=crs",
    projected_bounds: [
      4798397970799496e-9,
      -462033.1734812842,
      3.8751795753784813e6,
      683298.714229599
    ]
  },
  "IGNF:ATIG": {
    proj4: "+proj=geocent +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +no_defs +type=crs",
    projected_bounds: [
      4798397970799496e-9,
      -462033.1734812842,
      3.8751795753784813e6,
      683298.714229599
    ]
  },
  "IGNF:ATIGBONNE": {
    proj4: "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +no_defs +type=crs",
    projected_bounds: [
      -658163.5819604866,
      -412509.1804604915,
      525324.1324997798,
      802886.6453591344
    ]
  },
  "IGNF:ATIGBONNE.BOURD": {
    proj4: "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -648112.642252371,
      -301918.91475889634,
      427402.9452092043,
      738760.530242398
    ]
  },
  "IGNF:ATIGBONNE.NGF84": {
    proj4: "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -648112.642252371,
      -301918.91475889634,
      427402.9452092043,
      738760.530242398
    ]
  },
  "IGNF:ATIGG": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +no_defs +type=crs",
    projected_bounds: [-7.83720833333333, 41, 7.66279166666667, 52]
  },
  "IGNF:ATIGG.BOURD": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.83720833333333, 42, 6.162791666666671, 51.5]
  },
  "IGNF:ATIGG.NGF84": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.83720833333333, 42, 6.162791666666671, 51.5]
  },
  "IGNF:ATUO63": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4757081040517723e-9,
      -4.1062022050444274e6,
      -4727928591088272e-9,
      -4146282093094922e-9
    ]
  },
  "IGNF:ATUO63G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.2, -9.88, -138.75, -9.65]
  },
  "IGNF:ATUO63UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      697382.4775819653,
      8907310627276365e-9,
      746919.3220135762,
      8932459297447395e-9
    ]
  },
  "IGNF:BIEN55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9237459286073842e6,
      1.5954238391338864e6,
      -1972806923547857e-9,
      1.6164494630446937e6
    ]
  },
  "IGNF:BIEN55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [140.33, -67, 140.67, -66.5]
  },
  "IGNF:BORA01": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:BOURD": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:C67I95": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6605784617348243e6,
      -5.2181500235037375e6,
      3.9881074253902514e6,
      -4933699608717654e-9
    ]
  },
  "IGNF:C67IG95G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:C67IG95G.GUYA77": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:C67IG95UTM21": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      728026.4919026721,
      226736.0034866947,
      832201.1127885012,
      658586.8735448826
    ]
  },
  "IGNF:C67IG95UTM21.GUYA77": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      728026.4919026721,
      226736.0034866947,
      832201.1127885012,
      658586.8735448826
    ]
  },
  "IGNF:C67IG95UTM22": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166221.011186225,
      226902.8338648935,
      494465.8068779068,
      657684.9639920696
    ]
  },
  "IGNF:C67IG95UTM22.GUYA77": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      166221.011186225,
      226902.8338648935,
      494465.8068779068,
      657684.9639920696
    ]
  },
  "IGNF:CAD97": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      439812835053325e-8,
      4390458859415753e-9,
      4.3729574786741715e6,
      4434445751599657e-9
    ]
  },
  "IGNF:CAD97G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:CAD97G.MAYO53": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:CAD97GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:CAD97UTM38S": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      494578.8015281211,
      8557317689557958e-9,
      543463.7976058227,
      861810756275263e-8
    ]
  },
  "IGNF:CAD97UTM38S.MAYO53": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      494578.8015281211,
      8557317689557958e-9,
      543463.7976058227,
      861810756275263e-8
    ]
  },
  "IGNF:CADA80": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5120839785633256e-9,
      -3.3945535031913533e6,
      -511252156626137e-8,
      -3.4251198668908537e6
    ]
  },
  "IGNF:CADA80G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.46, -15.63, -146.18, -15.29]
  },
  "IGNF:CAPBP55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9237459286073842e6,
      1.5954238391338864e6,
      -1972806923547857e-9,
      1.6164494630446937e6
    ]
  },
  "IGNF:CAPBP55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [140.33, -67, 140.67, -66.5]
  },
  "IGNF:CAPJP55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9353892058880515e6,
      1.5812793067773362e6,
      -1.9820842309198342e6,
      1.6050601626464871e6
    ]
  },
  "IGNF:CAPJP55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [140.75, -67, 141, -66.5]
  },
  "IGNF:CLIP57UTM12": {
    proj4: "+proj=utm +zone=12 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      664331.355574731,
      1.1246009877966547e6,
      718898.1358467357,
      1.1614047004967178e6
    ]
  },
  "IGNF:CLIP67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -2.0958331315810073e6,
      -5918450186340683e-9,
      -2.0419737985549036e6,
      -5930322517692171e-9
    ]
  },
  "IGNF:CLIP67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-109.5, 10.17, -109, 10.5]
  },
  "IGNF:CLIP67UTM12": {
    proj4: "+proj=utm +zone=12 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      664331.355574731,
      1.1246009877966547e6,
      718898.1358467357,
      1.1614047004967178e6
    ]
  },
  "IGNF:CROZ63": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.8141062531261076e6,
      3.3537212371048694e6,
      2714020614513185e-9,
      3.5369805272476636e6
    ]
  },
  "IGNF:CROZ63G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [50, -46.75, 52.5, -45.75]
  },
  "IGNF:CROZ63GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [50, -46.75, 52.5, -45.75]
  },
  "IGNF:CROZ63UTM39S": {
    proj4: "+proj=utm +zone=39 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      423617.1855683554,
      4822032240562853e-9,
      616675.56628458,
      493253906975834e-8
    ]
  },
  "IGNF:CSG67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6605784617348243e6,
      -5.2181500235037375e6,
      3.9881074253902514e6,
      -4933699608717654e-9
    ]
  },
  "IGNF:CSG67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:CSG67G.GUYA77": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:CSG67GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:CSG67UTM21": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      728026.4919026721,
      226736.0034866947,
      832201.1127885012,
      658586.8735448826
    ]
  },
  "IGNF:CSG67UTM21.GUYA77": {
    proj4: "+proj=utm +zone=21 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      728026.4919026721,
      226736.0034866947,
      832201.1127885012,
      658586.8735448826
    ]
  },
  "IGNF:CSG67UTM22": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      166221.011186225,
      226902.8338648935,
      494465.8068779068,
      657684.9639920696
    ]
  },
  "IGNF:CSG67UTM22.GUYA77": {
    proj4: "+proj=utm +zone=22 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      166221.011186225,
      226902.8338648935,
      494465.8068779068,
      657684.9639920696
    ]
  },
  "IGNF:ED50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      5212841847061847e-9,
      -919164.6638031531,
      1.6765462609082197e6,
      1.0476223754997255e6
    ]
  },
  "IGNF:ED50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-10, 34, 32, 72]
  },
  "IGNF:ED50G.IGN69": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:ED50G.IGN78C": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:ED50G.NGC48": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:ED50G.NGF84": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:ED50GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-10, 34, 32, 72]
  },
  "IGNF:ED50UTM30": {
    proj4: "+proj=utm +zone=30 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843707,
      3766273293864319e-9,
      603438.4562997073,
      7.9917262305144165e6
    ]
  },
  "IGNF:ED50UTM30.IGN69": {
    proj4: "+proj=utm +zone=30 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      292939.4978291595,
      4652882323859954e-9,
      708226.87798439,
      5709814890701179e-9
    ]
  },
  "IGNF:ED50UTM30.NGF84": {
    proj4: "+proj=utm +zone=30 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      292939.4978291595,
      4652882323859954e-9,
      708226.87798439,
      5709814890701179e-9
    ]
  },
  "IGNF:ED50UTM31": {
    proj4: "+proj=utm +zone=31 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843864,
      3766273293864319e-9,
      603438.456299708,
      7.9917262305144165e6
    ]
  },
  "IGNF:ED50UTM31.IGN69": {
    proj4: "+proj=utm +zone=31 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251523.72201822812,
      4654213469486553e-9,
      708226.8779843912,
      5709814890701179e-9
    ]
  },
  "IGNF:ED50UTM31.NGF84": {
    proj4: "+proj=utm +zone=31 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251523.72201822812,
      4654213469486553e-9,
      708226.8779843912,
      5709814890701179e-9
    ]
  },
  "IGNF:ED50UTM32": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843794,
      3766273293864319e-9,
      603438.4562997076,
      7.9917262305144165e6
    ]
  },
  "IGNF:ED50UTM32.IGN69": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251523.72201822745,
      4654213469486553e-9,
      465292.0607005689,
      5705665389828591e-9
    ]
  },
  "IGNF:ED50UTM32.IGN78C": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416148.8158580589,
      4561521108369963e-9,
      580848.275115093,
      4816914521201906e-9
    ]
  },
  "IGNF:ED50UTM32.NGC48": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416148.8158580589,
      4561521108369963e-9,
      580848.275115093,
      4816914521201906e-9
    ]
  },
  "IGNF:ED50UTM32.NGF84": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251523.72201822745,
      4654213469486553e-9,
      465292.0607005689,
      5705665389828591e-9
    ]
  },
  "IGNF:EFAT57UTM59S": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      252251.71337161926,
      8091270825528874e-9
    ]
  },
  "IGNF:EFATE57": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5935310180293228e-9,
      1.2615891243682073e6,
      -5974300100273862e-9,
      1.1970363363591766e6
    ]
  },
  "IGNF:EFATE57G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [168, -18, 168.67, -17.25]
  },
  "IGNF:EFATE57GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [168, -18, 168.67, -17.25]
  },
  "IGNF:EFATE57UT59S": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      252251.71337161926,
      8091270825528874e-9
    ]
  },
  "IGNF:ETRS89": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5131078265359862e-9,
      -239266108972997e-8,
      1.4227983342563012e6,
      1.4478501036476372e6
    ]
  },
  "IGNF:ETRS89G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-25, 27.5, 45.5, 71.5]
  },
  "IGNF:ETRS89G.EVRF2000": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-10, 36, 32, 71.2]
  },
  "IGNF:ETRS89GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-25, 27.5, 45.5, 71.5]
  },
  "IGNF:ETRS89LAEA": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      909971.7069497043,
      1.2821228168704668e6,
      5528944233214812e-9,
      5.6966685475801155e6
    ]
  },
  "IGNF:ETRS89LAEA.EVRF2000": {
    proj4: "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      252343703226471e-8,
      1.6730345771868078e6,
      5107518975786216e-9,
      5467299976835687e-9
    ]
  },
  "IGNF:ETRS89LCC": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      536680.7426697467,
      944657.2731789474,
      5268671911897747e-9,
      5267025458179825e-9
    ]
  },
  "IGNF:ETRS89LCC.EVRF2000": {
    proj4: "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      2.2260486962997727e6,
      1308064247471401e-9,
      4815558490252753e-9,
      5043538807470478e-9
    ]
  },
  "IGNF:ETRS89UTM26": {
    proj4: "+proj=utm +zone=26 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      697568.4037129752,
      3.0434094473345717e6,
      606205.718039366,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM27": {
    proj4: "+proj=utm +zone=27 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112227,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM28": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122207,
      3045401946983414e-9,
      606205.7180393654,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM29": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122364,
      3045401946983414e-9,
      606205.7180393661,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM29.EVRF2000": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      409870.95058922993,
      3984410787968245e-9,
      607865.3981873,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM30": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112229,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM30.EVRF2000": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810655,
      3988111962235159e-9,
      607865.3981872997,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM31": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM31.EVRF2000": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810812,
      3988111962235159e-9,
      607865.3981873003,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM32": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122382,
      3045401946983414e-9,
      606205.7180393662,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM32.EVRF2000": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810742,
      3988111962235159e-9,
      607865.3981873001,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM33": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112255,
      3045401946983414e-9,
      606205.7180393666,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM33.EVRF2000": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810905,
      3.9881119622351583e6,
      607865.3981873007,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM34": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM34.EVRF2000": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810812,
      3988111962235159e-9,
      607865.3981873004,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM35": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.934711224,
      3045401946983414e-9,
      606205.718039366,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM35.EVRF2000": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810754,
      3988111962235159e-9,
      607865.3981873,
      7902376952661947e-9
    ]
  },
  "IGNF:ETRS89UTM36": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112227,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM36.EVRF2000": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      229578.62998810638,
      3988111962235159e-9,
      464033.2921822539,
      7900000095432311e-9
    ]
  },
  "IGNF:ETRS89UTM37": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:ETRS89UTM38": {
    proj4: "+proj=utm +zone=38 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.934711224,
      3045401946983414e-9,
      517707.23557758785,
      7933236425749246e-9
    ]
  },
  "IGNF:EURO54UTM37S": {
    proj4: "+proj=utm +zone=37 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      628738.0497090842,
      7530080320410613e-9,
      654850.4801471978,
      7566382220895741e-9
    ]
  },
  "IGNF:EUROPA54": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4505131594155083e-9,
      3813875417617047e-9,
      4498930750078535e-9,
      3.8424498588797427e6
    ]
  },
  "IGNF:EUROPA54G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [40.25, -22.33, 40.5, -22]
  },
  "IGNF:EUROPA54MD": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      24480785830680266e-9,
      7465004584755147e-9,
      2450861679857269e-8,
      7504444037737565e-9
    ]
  },
  "IGNF:EVRF2000": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:EVRF2007": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:FAKA50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.0692456787295835e6,
      -3.4192493842697726e6,
      -5038847252569034e-9,
      -3495572719317792e-9
    ]
  },
  "IGNF:FAKA50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146, -16.58, -145.25, -16]
  },
  "IGNF:FAKA50UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      606686.3646783119,
      8166618757508089e-9,
      687267.681599175,
      8230255003595289e-9
    ]
  },
  "IGNF:FANG651G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANG651UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANG652G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANG652UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANGA50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA64": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA64G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA64UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANGA651": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA651G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA651U7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANGA652": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA652G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA652U7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANGA66": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA66G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA66UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FANGA84": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4443313954561146e-9,
      -3885719686616641e-9,
      -443197416760567e-8,
      -3910061171712911e-9
    ]
  },
  "IGNF:FANGA84G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.83, -22.33, -138.58, -22.15]
  },
  "IGNF:FANGA84UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      723514.8281841455,
      7529005246981241e-9,
      749594.6981433677,
      7548550158667967e-9
    ]
  },
  "IGNF:FATU55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4744556317425434e-9,
      -4.1331108070380106e6,
      -4743249972077501e-9,
      -4.1348858599620108e6
    ]
  },
  "IGNF:FATU55FG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.94, -9.44, -138.92, -9.43]
  },
  "IGNF:FUTUNA1997": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GEOPORTALANF": {
    proj4: "+proj=eqc +lat_ts=15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6795666655199293e-9,
      1.5863027438041484e6,
      -6530076518516663e-9,
      2026014732437579e-9
    ]
  },
  "IGNF:GEOPORTALASP": {
    proj4: "+proj=eqc +lat_ts=-38 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      6793988029120558e-9,
      -4315856658055217e-9,
      6809777801170159e-9,
      -4202310777446077e-9
    ]
  },
  "IGNF:GEOPORTALCRZ": {
    proj4: "+proj=eqc +lat_ts=-46 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.8664508037390388e6,
      -5204186194585539e-9,
      4059773343925991e-9,
      -5092866703792266e-9
    ]
  },
  "IGNF:GEOPORTALFXX": {
    proj4: "+proj=eqc +lat_ts=46.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -421450.0446829672,
      4564099122524217e-9,
      766272.8085144858,
      5788613521250226e-9
    ]
  },
  "IGNF:GEOPORTALGUF": {
    proj4: "+proj=eqc +lat_ts=4 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6102105299867526e-9,
      228204.95612621077,
      -5.6690168436439885e6,
      662350.9702199778
    ]
  },
  "IGNF:GEOPORTALKER": {
    proj4: "+proj=eqc +lat_ts=-49.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4843847144465692e-9,
      -5621634285060315e-9,
      5133032048612897e-9,
      -5343335558077131e-9
    ]
  },
  "IGNF:GEOPORTALMYT": {
    proj4: "+proj=eqc +lat_ts=-12 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4894465832904011e-9,
      -1.4527193548522203e6,
      4943464934679468e-9,
      -1.3914936349159195e6
    ]
  },
  "IGNF:GEOPORTALNCL": {
    proj4: "+proj=eqc +lat_ts=-22 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      16112282399811782e-9,
      -2.9667811773324003e6,
      18011488012601897e-9,
      -1625328524917563e-9
    ]
  },
  "IGNF:GEOPORTALPYF": {
    proj4: "+proj=eqc +lat_ts=-15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -16774113895745091e-9,
      -311694574221166e-8,
      -1440853373096053e-8,
      -779236.435552915
    ]
  },
  "IGNF:GEOPORTALREU": {
    proj4: "+proj=eqc +lat_ts=-21 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5733580741680642e-9,
      -2.3844634927919204e6,
      5811525014949818e-9,
      -2.3098794339604266e6
    ]
  },
  "IGNF:GEOPORTALSPM": {
    proj4: "+proj=eqc +lat_ts=47 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4288704427164641e-9,
      5198620220045876e-9,
      -425909574020068e-8,
      5254279965442513e-9
    ]
  },
  "IGNF:GEOPORTALWLF": {
    proj4: "+proj=eqc +lat_ts=-14 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -19440148453704666e-9,
      -1.6018874725152068e6,
      -19042661253406677e-9,
      -146496449883948e-8
    ]
  },
  "IGNF:GLOR77": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GLOR77CAR": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4.2413273667677445e6,
      4588242095783016e-9,
      4226517123109801e-9,
      4.6075882548862165e6
    ]
  },
  "IGNF:GLOR77G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [47.25, -11.62, 47.47, -11.43]
  },
  "IGNF:GLOR77G.GLOR77": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [47.25, -11.62, 47.47, -11.43]
  },
  "IGNF:GLOR77MD": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2526005293166814e-8,
      8706094269262433e-9,
      25284544183413472e-9,
      8727541691202441e-9
    ]
  },
  "IGNF:GLOR77MD.GLOR77": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      2526005293166814e-8,
      8706094269262433e-9,
      25284544183413472e-9,
      8727541691202441e-9
    ]
  },
  "IGNF:GLOR77MHG": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4.2413273667677445e6,
      4588242095783016e-9,
      4226517123109801e-9,
      4.6075882548862165e6
    ]
  },
  "IGNF:GLOR77UTM38S": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      745338.8019525553,
      871448009764371e-8,
      769521.8527762147,
      8735308344029034e-9
    ]
  },
  "IGNF:GLOR77UTM38S.GLOR77": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      745338.8019525553,
      871448009764371e-8,
      769521.8527762147,
      8735308344029034e-9
    ]
  },
  "IGNF:GTN51": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.6425300571246995e6,
      1.6713935486494934e6,
      -5875808220210716e-9,
      1.2843565678136689e6
    ]
  },
  "IGNF:GTN51G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:GTN51UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      345977.269916116,
      7483342146210205e-9,
      780258.0532662198,
      7841639364538117e-9
    ]
  },
  "IGNF:GUAD2008LD": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD48": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2897720983301738e-9,
      -5411027949068217e-9,
      2985559804034303e-9,
      -5335468393892857e-9
    ]
  },
  "IGNF:GUAD48G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.83, 15.82, -60.77, 16.6]
  },
  "IGNF:GUAD48GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.83, 15.82, -60.77, 16.6]
  },
  "IGNF:GUAD48UTM20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      625304.119940819,
      1.7493946320858304e6,
      737926.4359742857,
      1.8366512583439522e6
    ]
  },
  "IGNF:GUAD88": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD88LS": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD88MG": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD88SB": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD88SM": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUAD92LD": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:GUADANN": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2897720983301738e-9,
      -5411027949068217e-9,
      2985559804034303e-9,
      -5335468393892857e-9
    ]
  },
  "IGNF:GUADANNG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.83, 15.82, -60.77, 16.6]
  },
  "IGNF:GUADANNG.GUAD88": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.85, 15.88, -61.08, 16.63]
  },
  "IGNF:GUADANNG.GUAD88LS": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.7, 15.8, -61.48, 15.93]
  },
  "IGNF:GUADANNG.GUAD88MG": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.4, 15.8, -61.08, 16.13]
  },
  "IGNF:GUADANNG.GUAD92LD": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:GUADANNUTM20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      625304.119940819,
      1.7493946320858304e6,
      737926.4359742857,
      1.8366512583439522e6
    ]
  },
  "IGNF:GUADANNUTM20.GUAD88": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      623125.5267933898,
      1.7560208187833638e6,
      704808.359216262,
      1.8396290248906773e6
    ]
  },
  "IGNF:GUADANNUTM20.GUAD88LS": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      639242.4265942234,
      1747263699834327e-9,
      662706.5842636563,
      1.7618058870327466e6
    ]
  },
  "IGNF:GUADANNUTM20.GUAD88MG": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      671381.7864346784,
      1.7474852106520068e6,
      705331.4919153186,
      1.7842927458326735e6
    ]
  },
  "IGNF:GUADANNUTM20.GUAD92LD": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      692378.1958093358,
      17974566563609e-7,
      740308.2728151057,
      1.8145364596566278e6
    ]
  },
  "IGNF:GUADFM": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7405383324918253e6,
      -5420641286739274e-9,
      2.8224259437113334e6,
      -536454934028993e-8
    ]
  },
  "IGNF:GUADFM49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.7405383324918253e6,
      -5420641286739274e-9,
      2.8224259437113334e6,
      -536454934028993e-8
    ]
  },
  "IGNF:GUADFM49GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-63.18, 17.82, -62.25, 18.18]
  },
  "IGNF:GUADFM49U20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      480924.68722874916,
      1.9703044604648193e6,
      579321.088235318,
      2.0102868730333478e6
    ]
  },
  "IGNF:GUADFMG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-63.18, 17.82, -62.25, 18.18]
  },
  "IGNF:GUADFMG.GUAD88SB": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-63, 17.8, -62.73, 18.03]
  },
  "IGNF:GUADFMG.GUAD88SM": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-63.2, 18, -62.5, 18.2]
  },
  "IGNF:GUADFMUTM20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      480924.68722874916,
      1.9703044604648193e6,
      579321.088235318,
      2.0102868730333478e6
    ]
  },
  "IGNF:GUADFMUTM20.GUAD88SB": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      1.9680825787698238e6,
      528579.3199074867,
      1.9935498845626228e6
    ]
  },
  "IGNF:GUADFMUTM20.GUAD88SM": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      478826.57900176616,
      1.9902213236412425e6,
      552874.016791398,
      2012409746334624e-9
    ]
  },
  "IGNF:GUAFM48G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-63.18, 17.82, -62.25, 18.18]
  },
  "IGNF:GUYA77": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:HAO49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4713459057200424e-9,
      -3793783464775736e-9,
      -4687531941984833e-9,
      -3.8531231939672604e6
    ]
  },
  "IGNF:HAO49G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141.17, -18.5, -140.58, -18]
  },
  "IGNF:HAO58": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4713459057200424e-9,
      -3793783464775736e-9,
      -4687531941984833e-9,
      -3.8531231939672604e6
    ]
  },
  "IGNF:HAO58G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141.17, -18.5, -140.58, -18]
  },
  "IGNF:HAO58UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      482054.0028968238,
      7954461321265927e-9,
      544464.4349104381,
      8009739734640891e-9
    ]
  },
  "IGNF:HAO67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4713459057200424e-9,
      -3793783464775736e-9,
      -4698503480135871e-9,
      -3862141732645285e-9
    ]
  },
  "IGNF:HAO67UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      482054.0028968238,
      7954461321265927e-9,
      544568.50816021,
      8056207616127925e-9
    ]
  },
  "IGNF:HAOAM67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4713459057200424e-9,
      -3793783464775736e-9,
      -4698503480135871e-9,
      -3862141732645285e-9
    ]
  },
  "IGNF:HAOAM67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141.17, -18.5, -140.58, -17.58]
  },
  "IGNF:HAOAM67UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      482054.0028968238,
      7954461321265927e-9,
      544568.50816021,
      8056207616127925e-9
    ]
  },
  "IGNF:HAOAMA67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-141.17, -18.5, -140.58, -17.58]
  },
  "IGNF:HARA49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4894193225134604e-9,
      -3610948129084073e-9,
      -488266198102625e-8,
      -3.6354486833823305e6
    ]
  },
  "IGNF:HARA49G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-143.58, -17.58, -143.33, -17.42]
  },
  "IGNF:HARA49UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      226147.85726772033,
      805439378163917e-8,
      252479.8799953836,
      8072450795663698e-9
    ]
  },
  "IGNF:HIKU50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -483980288235125e-8,
      -3669617791922357e-9,
      -4824308586848702e-9,
      -3.7125357653931617e6
    ]
  },
  "IGNF:HIKU50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-142.83, -17.83, -142.42, -17.42]
  },
  "IGNF:HIKU50UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      306051.75515670894,
      8027649745178608e-9,
      349172.42805661313,
      8073398472068544e-9
    ]
  },
  "IGNF:HIVA60": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4760806268669619e-9,
      -4.1021731277436116e6,
      -4716298911729098e-9,
      -4160903595452674e-9
    ]
  },
  "IGNF:HIVA60G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.25, -9.87, -138.58, -9.6]
  },
  "IGNF:HIVA60UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      691903.7879123059,
      8908445919570776e-9,
      765624.7211725519,
      8937864517786e-6
    ]
  },
  "IGNF:HIVA67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4760806268669619e-9,
      -4.1021731277436116e6,
      -4716298911729098e-9,
      -4160903595452674e-9
    ]
  },
  "IGNF:HIVA67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.25, -9.87, -138.58, -9.6]
  },
  "IGNF:HIVA67UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      691903.7879123059,
      8908445919570776e-9,
      765624.7211725519,
      8937864517786e-6
    ]
  },
  "IGNF:HUAH01": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:IGN63": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4757081040517723e-9,
      -4.1062022050444274e6,
      -4727928591088272e-9,
      -4146282093094922e-9
    ]
  },
  "IGNF:IGN63G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.2, -9.88, -138.75, -9.65]
  },
  "IGNF:IGN63GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.2, -9.88, -138.75, -9.65]
  },
  "IGNF:IGN63UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      697382.4775819653,
      8907310627276365e-9,
      746919.3220135762,
      8932459297447395e-9
    ]
  },
  "IGNF:IGN69": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:IGN72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.6425300571246995e6,
      1.6713935486494934e6,
      -5875808220210716e-9,
      1.2843565678136689e6
    ]
  },
  "IGNF:IGN72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:IGN72G.NCAL69": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:IGN72GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:IGN72LAM": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      143190.52016571347,
      159532.78288643624,
      575397.0192912852,
      520509.37134659267
    ]
  },
  "IGNF:IGN72LAMBNC": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      143190.52016571347,
      159532.78288643624,
      575397.0192912852,
      520509.37134659267
    ]
  },
  "IGNF:IGN72UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      345977.269916116,
      7483342146210205e-9,
      780258.0532662198,
      7841639364538117e-9
    ]
  },
  "IGNF:IGN72UTM58S.NCAL69": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      345977.269916116,
      7483342146210205e-9,
      780258.0532662198,
      7841639364538117e-9
    ]
  },
  "IGNF:IGN78C": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:JULES55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9353892058880515e6,
      1.5812793067773362e6,
      -1.9820842309198342e6,
      1.6050601626464871e6
    ]
  },
  "IGNF:JULES55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [140.75, -67, 141, -66.5]
  },
  "IGNF:KAUE70": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -504372307949348e-8,
      -3488533756199886e-9,
      -5031709261493166e-9,
      -3523240754977125e-9
    ]
  },
  "IGNF:KAUE70G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-145.33, -16, -145, -15.67]
  },
  "IGNF:KAUE70UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      678704.7534151461,
      8230325467256732e-9,
      714376.9166104347,
      8266535302463391e-9
    ]
  },
  "IGNF:KERG62": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:KERG62CAR": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.5883625153224887e6,
      3.7419475895082527e6,
      1.3920375543620896e6,
      4042770607511629e-9
    ]
  },
  "IGNF:KERG62G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [67, -50.5, 71, -48]
  },
  "IGNF:KERG62G.KERG62": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [67, -50.5, 71, -48]
  },
  "IGNF:KERG62GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [67, -50.5, 71, -48]
  },
  "IGNF:KERG62K0": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.5883625153224887e6,
      3.7419475895082527e6,
      1.3920375543620896e6,
      4042770607511629e-9
    ]
  },
  "IGNF:KERG62UTM42S": {
    proj4: "+proj=utm +zone=42 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      358156.56404083717,
      4403750360454914e-9,
      649194.9159610741,
      4681660479360506e-9
    ]
  },
  "IGNF:KERG62UTM42S.KERG62": {
    proj4: "+proj=utm +zone=42 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      358156.56404083717,
      4403750360454914e-9,
      649194.9159610741,
      4681660479360506e-9
    ]
  },
  "IGNF:LAMB1": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      70023.39182748231,
      1.1337399208881143e6,
      427394.4651791132
    ]
  },
  "IGNF:LAMB1C": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      1.0700233918274823e6,
      1.1337399208881143e6,
      1.4273944651791132e6
    ]
  },
  "IGNF:LAMB2": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      70258.10556222494,
      116939132293542e-8,
      377862.31307534676
    ]
  },
  "IGNF:LAMB2C": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      2070258105562225e-9,
      116939132293542e-8,
      2377862313075347e-9
    ]
  },
  "IGNF:LAMB3": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      20471.70429981529,
      1.1986929065188458e6,
      377896.4596132201
    ]
  },
  "IGNF:LAMB3C": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      3.0204717042998155e6,
      1.1986929065188458e6,
      3.3778964596132203e6
    ]
  },
  "IGNF:LAMB4": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      452132.7114419251,
      105209.15805234498,
      624084.1203493377,
      308862.89926242875
    ]
  },
  "IGNF:LAMB4C": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      452132.7114419251,
      4105209158052345e-9,
      624084.1203493377,
      4308862899262428e-9
    ]
  },
  "IGNF:LAMB93": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -16296.157783713657,
      6027156199039219e-9,
      1.1819381775746632e6,
      7233428222339219e-9
    ]
  },
  "IGNF:LAMBE": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      63074.42833299341,
      1.6110039824486375e6,
      1.1401291685447132e6,
      2.6770579322090885e6
    ]
  },
  "IGNF:LAMBGC": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=0 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=600000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      63153.329740198446,
      -10956.044494243688,
      1.1348188470977098e6,
      1.1045553023457837e6
    ]
  },
  "IGNF:LIFOU56": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.7949024853519695e6,
      1342120578529843e-9,
      -5829534104510215e-9,
      1.2913091863647026e6
    ]
  },
  "IGNF:LIFOU56G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.96, -21.22, 167.51, -20.65]
  },
  "IGNF:LIFOU56G.LIFOU91": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [166.96, -21.22, 167.51, -20.65]
  },
  "IGNF:LIFOU56UT58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      703438.356224279,
      7652214298274282e-9,
      761538.6158247647,
      7714536934557309e-9
    ]
  },
  "IGNF:LIFOU56UT58S.LIFOU91": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      703438.356224279,
      7652214298274282e-9,
      761538.6158247647,
      7714536934557309e-9
    ]
  },
  "IGNF:LIFOU91": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:LNGLNG": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [1 / 0, 1 / 0, 5e5, 5753601530612312e-9]
  },
  "IGNF:LNGPGG": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=paris +no_defs +type=crs",
    projected_bounds: [177.66277083333338, -90, 177.66277083333335, 90]
  },
  "IGNF:LUREF": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      413377750524893e-8,
      414791.9670083018,
      4.0659561533247815e6,
      465413.88250171166
    ]
  },
  "IGNF:LURES": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      413377750524893e-8,
      414791.9670083018,
      4.0659561533247815e6,
      465413.88250171166
    ]
  },
  "IGNF:LURESG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [5.73, 49.45, 6.53, 50.18]
  },
  "IGNF:LURESGKL": {
    proj4: "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      48335.6969026959,
      57455.00817241952,
      105953.27677820726,
      138624.04031903067
    ]
  },
  "IGNF:LURESGKL.NNLUX": {
    proj4: "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      48335.6969026959,
      57455.00817241952,
      105953.27677820726,
      138624.04031903067
    ]
  },
  "IGNF:LUXGAUSSK": {
    proj4: "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      48335.6969026959,
      57455.00817241952,
      105953.27677820726,
      138624.04031903067
    ]
  },
  "IGNF:LUXGEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [5.73, 49.45, 6.53, 50.18]
  },
  "IGNF:MAKE50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4940393782636087e-9,
      -3589406188178391e-9,
      -4910747882123292e-9,
      -3.6563604017362986e6
    ]
  },
  "IGNF:MAKE50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-144, -16.83, -143.33, -16.33]
  },
  "IGNF:MAKE50UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      180248.3890583375,
      8136803298805437e-9,
      251054.67903637668,
      8193115835434963e-9
    ]
  },
  "IGNF:MANGA51": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.1634999173299563e6,
      -4115813965306849e-9,
      -4.1282082334332527e6,
      -4.1891789580091843e6
    ]
  },
  "IGNF:MANGA51G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-135.33, -23.45, -134.58, -22.83]
  },
  "IGNF:MANGA51U8S": {
    proj4: "+proj=utm +zone=8 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      466292.7109850417,
      7406591173770012e-9,
      543098.0131096297,
      7475204750749176e-9
    ]
  },
  "IGNF:MANGA51UTM8S": {
    proj4: "+proj=utm +zone=8 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      466292.7109850417,
      7406591173770012e-9,
      543098.0131096297,
      7475204750749176e-9
    ]
  },
  "IGNF:MARE53": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -579293458014226e-8,
      1.2641231630320263e6,
      -5819414386360518e-9,
      1.2178591754799455e6
    ]
  },
  "IGNF:MARE53G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [167.69, -21.69, 168.18, -21.29]
  },
  "IGNF:MARE53G.MARE91": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [167.69, -21.69, 168.18, -21.29]
  },
  "IGNF:MARE53UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      778349.8179059895,
      7599038091146896e-9,
      811298.5124198725,
      7642765681607533e-9
    ]
  },
  "IGNF:MARE53UTM58S.MARE91": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      778349.8179059895,
      7599038091146896e-9,
      811298.5124198725,
      7642765681607533e-9
    ]
  },
  "IGNF:MARE91": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:MARQUI72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4863196925467766e-9,
      -3974814143346222e-9,
      -4752422133615405e-9,
      -4.1633622420696747e6
    ]
  },
  "IGNF:MARQUI72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-140.74, -10.05, -138.78, -7.89]
  },
  "IGNF:MART38": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.9737595239642267e6,
      -5420447852778064e-9,
      3.0109764825362815e6,
      -537648537414101e-8
    ]
  },
  "IGNF:MART38G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:MART38GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:MART38UTM20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      688794.6865519574,
      1.5783166651019377e6,
      741955.7788332207,
      1.6595756631355397e6
    ]
  },
  "IGNF:MART87": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:MARTFD": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      2.9737595239642267e6,
      -5420447852778064e-9,
      3.0109764825362815e6,
      -537648537414101e-8
    ]
  },
  "IGNF:MARTFDG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:MARTFDG.MART87": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:MARTFDUTM20": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      688794.6865519574,
      1.5783166651019377e6,
      741955.7788332207,
      1.6595756631355397e6
    ]
  },
  "IGNF:MARTFDUTM20.MART87": {
    proj4: "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      688794.6865519574,
      1.5783166651019377e6,
      741955.7788332207,
      1.6595756631355397e6
    ]
  },
  "IGNF:MAUPITI": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5418944299025064e-9,
      -2820923850847678e-9,
      -5407996658535213e-9,
      -2875482829736934e-9
    ]
  },
  "IGNF:MAUPITI01": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:MAUPITIG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-152.5, -16.75, -152, -16.25]
  },
  "IGNF:MAUPITIG.MAUPITI01": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-152.5, -16.75, -152, -16.25]
  },
  "IGNF:MAUPITIUTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      553294.4041979474,
      8.1480115207940815e6,
      606866.4537014486,
      8203128167411621e-9
    ]
  },
  "IGNF:MAUPITIUTM5S.MAUPITI01": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      553294.4041979474,
      8.1480115207940815e6,
      606866.4537014486,
      8203128167411621e-9
    ]
  },
  "IGNF:MAYO50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      439812835053325e-8,
      4390458859415753e-9,
      4.3729574786741715e6,
      4434445751599657e-9
    ]
  },
  "IGNF:MAYO50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:MAYO50G.MAYO53": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:MAYO50GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:MAYO50UTM38S": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      494578.8015281211,
      8557317689557958e-9,
      543463.7976058227,
      861810756275263e-8
    ]
  },
  "IGNF:MAYO50UTM38S.MAYO53": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      494578.8015281211,
      8557317689557958e-9,
      543463.7976058227,
      861810756275263e-8
    ]
  },
  "IGNF:MAYO53": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:MHEFO55F": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4744556317425434e-9,
      -4.1331108070380106e6,
      -4743249972077501e-9,
      -4.1348858599620108e6
    ]
  },
  "IGNF:MHEFO55FG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.94, -9.44, -138.92, -9.43]
  },
  "IGNF:MHEFO55M": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.7340677688502325e6,
      -4126881356191129e-9,
      -4719605462276302e-9,
      -4150655161307347e-9
    ]
  },
  "IGNF:MHEFO55MG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.92, -10.08, -138.67, -9.83]
  },
  "IGNF:MHPF67": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4150988984564249e-9,
      -4145197153084883e-9,
      -4.1434992175132604e6,
      -4159439735553708e-9
    ]
  },
  "IGNF:MHPF67G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-135.04, -23.18, -134.89, -23.07]
  },
  "IGNF:MHPF67UTM8S": {
    proj4: "+proj=utm +zone=8 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      495906.02421317773,
      7436519881249454e-9,
      511267.6193902038,
      7448693578347148e-9
    ]
  },
  "IGNF:MILLER": {
    proj4: "+proj=mill +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20015109356056377e-9,
      -14675057854846332e-9,
      20015109356056377e-9,
      14675057854846328e-9
    ]
  },
  "IGNF:MOHO55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.7340677688502325e6,
      -4126881356191129e-9,
      -4719605462276302e-9,
      -4150655161307347e-9
    ]
  },
  "IGNF:MOHO55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-138.92, -10.08, -138.67, -9.83]
  },
  "IGNF:MOORE87UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      181835.51831270888,
      8.0349081494364645e6,
      207566.93084181385,
      8090682998726968e-9
    ]
  },
  "IGNF:MOORE87UTM6S.MOOREA81": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      181835.51831270888,
      8.0349081494364645e6,
      207566.93084181385,
      8090682998726968e-9
    ]
  },
  "IGNF:MOOREA81": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:MOOREA87": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5262318082224979e-9,
      -3038200761334026e-9,
      -5263385792065918e-9,
      -3.0695158710414087e6
    ]
  },
  "IGNF:MOOREA87G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -17.75, -149.75, -17.25]
  },
  "IGNF:MOOREA87G.MOOREA81": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-150, -17.75, -149.75, -17.25]
  },
  "IGNF:MOOREA87GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -17.75, -149.75, -17.25]
  },
  "IGNF:MOOREA87U6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      181835.51831270888,
      8.0349081494364645e6,
      207566.93084181385,
      8090682998726968e-9
    ]
  },
  "IGNF:MOP90": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5259559859660432e-9,
      -3.0857654416662934e6,
      -5258024651231139e-9,
      -3.0935060122396327e6
    ]
  },
  "IGNF:MOP90G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-149.6, -17.1, -149.53, -17.02]
  },
  "IGNF:MOP90UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      223304.46889845526,
      8107512615621586e-9,
      230643.23512042372,
      8116468173189378e-9
    ]
  },
  "IGNF:MURU51": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4476725329038457e-9,
      -3868297964267059e-9,
      -4446846416187175e-9,
      -3.9231820518253553e6
    ]
  },
  "IGNF:MURU51G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.17, -22, -138.58, -21.67]
  },
  "IGNF:MURU59": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4476725329038457e-9,
      -3868297964267059e-9,
      -4446846416187175e-9,
      -3.9231820518253553e6
    ]
  },
  "IGNF:MURU59G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.17, -22, -138.58, -21.67]
  },
  "IGNF:MURU59UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      688925.2209983619,
      7566011176574107e-9,
      750433.1048270797,
      760171418343564e-8
    ]
  },
  "IGNF:MURU62": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4476725329038457e-9,
      -3868297964267059e-9,
      -4446846416187175e-9,
      -3.9231820518253553e6
    ]
  },
  "IGNF:MURU62G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.17, -22, -138.58, -21.67]
  },
  "IGNF:MURU62UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      688925.2209983619,
      7566011176574107e-9,
      750433.1048270797,
      760171418343564e-8
    ]
  },
  "IGNF:MURU78": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4476725329038457e-9,
      -3868297964267059e-9,
      -4446846416187175e-9,
      -3.9231820518253553e6
    ]
  },
  "IGNF:MURU78G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.17, -22, -138.58, -21.67]
  },
  "IGNF:MURU78UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      688925.2209983619,
      7566011176574107e-9,
      750433.1048270797,
      760171418343564e-8
    ]
  },
  "IGNF:NC51": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.6425300571246995e6,
      1.6713935486494934e6,
      -5875808220210716e-9,
      1.2843565678136689e6
    ]
  },
  "IGNF:NC51G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:NC51UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      345977.269916116,
      7483342146210205e-9,
      780258.0532662198,
      7841639364538117e-9
    ]
  },
  "IGNF:NCAL69": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:NEA74": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -57349955489728e-7,
      1.3916802736885927e6,
      -5748310370469398e-9,
      1.3758035484200036e6
    ]
  },
  "IGNF:NEA74G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.36, -22.36, 166.54, -22.14]
  },
  "IGNF:NEA74G.NCAL69": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [166.36, -22.36, 166.54, -22.14]
  },
  "IGNF:NEA74LBTNM2": {
    proj4: "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -8489.506034834267,
      -10001.714319341378,
      10066.900470966893,
      14359.193870027832
    ]
  },
  "IGNF:NEA74LBTNM2.NCAL69": {
    proj4: "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -8489.506034834267,
      -10001.714319341378,
      10066.900470966893,
      14359.193870027832
    ]
  },
  "IGNF:NGC48": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:NGF84": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:NNLUX": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:NOVA53": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      4481954337996554e-9,
      4.1314854999358943e6,
      4474453204200895e-9,
      4.1477429813466696e6
    ]
  },
  "IGNF:NOVA53G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [42.67, -17.17, 42.83, -17]
  },
  "IGNF:NOVA53UTM38S": {
    proj4: "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      252145.09265397085,
      8100127217834439e-9,
      268962.70206228865,
      8119142632111523e-9
    ]
  },
  "IGNF:NTF": {
    proj4: "+proj=geocent +ellps=clrk80ign +units=m +no_defs +type=crs",
    projected_bounds: [
      4798397970799496e-9,
      -462033.1734812842,
      3.8751795753784813e6,
      683298.714229599
    ]
  },
  "IGNF:NTFG": {
    proj4: "+proj=longlat +ellps=clrk80ign +no_defs +type=crs",
    projected_bounds: [-5.5, 41, 10, 52]
  },
  "IGNF:NTFLAMB1": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      70023.39182748231,
      1.1337399208881143e6,
      427394.4651791132
    ]
  },
  "IGNF:NTFLAMB1.BOURD": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      70023.39182748231,
      1.0295210899884515e6,
      417805.17540027143
    ]
  },
  "IGNF:NTFLAMB1.IGN69": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      70023.39182748231,
      1.0295210899884515e6,
      417805.17540027143
    ]
  },
  "IGNF:NTFLAMB1.NGF84": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      70023.39182748231,
      1.0295210899884515e6,
      417805.17540027143
    ]
  },
  "IGNF:NTFLAMB1C": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      1.0700233918274823e6,
      1.1337399208881143e6,
      1.4273944651791132e6
    ]
  },
  "IGNF:NTFLAMB1C.IGN69": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      124925.58169113449,
      1.0700233918274823e6,
      1.0295210899884515e6,
      1.4178051754002713e6
    ]
  },
  "IGNF:NTFLAMB2": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      70258.10556222494,
      116939132293542e-8,
      377862.31307534676
    ]
  },
  "IGNF:NTFLAMB2.BOURD": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      70258.10556222494,
      1.0581885226458693e6,
      368055.7399349045
    ]
  },
  "IGNF:NTFLAMB2.IGN69": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      70258.10556222494,
      1.0581885226458693e6,
      368055.7399349045
    ]
  },
  "IGNF:NTFLAMB2.NGF84": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      70258.10556222494,
      1.0581885226458693e6,
      368055.7399349045
    ]
  },
  "IGNF:NTFLAMB2C": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      2070258105562225e-9,
      116939132293542e-8,
      2377862313075347e-9
    ]
  },
  "IGNF:NTFLAMB2C.IGN69": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      100504.24013906298,
      2070258105562225e-9,
      1.0581885226458693e6,
      2.3680557399349045e6
    ]
  },
  "IGNF:NTFLAMB2E": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      63074.42833299341,
      1.6110039824486375e6,
      1.1401291685447132e6,
      2.6770579322090885e6
    ]
  },
  "IGNF:NTFLAMB2E.BOURD": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      69322.35382483469,
      1.6876731849174923e6,
      1.0346413086053279e6,
      266775525042311e-8
    ]
  },
  "IGNF:NTFLAMB2E.IGN69": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      69322.35382483469,
      1.6876731849174923e6,
      1.0346413086053279e6,
      266775525042311e-8
    ]
  },
  "IGNF:NTFLAMB2E.IGN78C": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0758558997816453e6,
      1.6063186572206947e6,
      1.2197132657142638e6,
      1.8633374894857944e6
    ]
  },
  "IGNF:NTFLAMB2E.NGC48": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0758558997816453e6,
      1.6063186572206947e6,
      1.2197132657142638e6,
      1.8633374894857944e6
    ]
  },
  "IGNF:NTFLAMB2E.NGF84": {
    proj4: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      69322.35382483469,
      1.6876731849174923e6,
      1.0346413086053279e6,
      266775525042311e-8
    ]
  },
  "IGNF:NTFLAMB3": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      20471.70429981529,
      1.1986929065188458e6,
      377896.4596132201
    ]
  },
  "IGNF:NTFLAMB3.BOURD": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      20471.70429981529,
      1081743547531103e-9,
      368053.08920628484
    ]
  },
  "IGNF:NTFLAMB3.IGN69": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      20471.70429981529,
      1081743547531103e-9,
      368053.08920628484
    ]
  },
  "IGNF:NTFLAMB3.NGF84": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      20471.70429981529,
      1081743547531103e-9,
      368053.08920628484
    ]
  },
  "IGNF:NTFLAMB3C": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      3.0204717042998155e6,
      1.1986929065188458e6,
      3.3778964596132203e6
    ]
  },
  "IGNF:NTFLAMB3C.IGN69": {
    proj4: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      73316.79275287571,
      3.0204717042998155e6,
      1081743547531103e-9,
      3368053089206285e-9
    ]
  },
  "IGNF:NTFLAMB4": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      452132.7114419251,
      105209.15805234498,
      624084.1203493377,
      308862.89926242875
    ]
  },
  "IGNF:NTFLAMB4.IGN78C": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      474130.7331420935,
      106636.76703418561,
      624084.1203493377,
      308862.89926242875
    ]
  },
  "IGNF:NTFLAMB4.NGC48": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      474130.7331420935,
      106636.76703418561,
      624084.1203493377,
      308862.89926242875
    ]
  },
  "IGNF:NTFLAMB4C": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      452132.7114419251,
      4105209158052345e-9,
      624084.1203493377,
      4308862899262428e-9
    ]
  },
  "IGNF:NTFLAMB4C.IGN78C": {
    proj4: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      474130.7331420935,
      4.1066367670341856e6,
      624084.1203493377,
      4308862899262428e-9
    ]
  },
  "IGNF:NTFLAMBGC": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=0 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=600000 +ellps=clrk80ign +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [
      63153.329740198446,
      -10956.044494243688,
      1.1348188470977098e6,
      1.1045553023457837e6
    ]
  },
  "IGNF:NTFP": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [-7.837229166666666, 41, 7.662770833333334, 52]
  },
  "IGNF:NTFPGRAD": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs +type=crs",
    projected_bounds: [-7.837229166666666, 41, 7.662770833333334, 52]
  },
  "IGNF:NTFPGRAD.BOURD": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.837229166666666, 42, 6.162770833333334, 51.5]
  },
  "IGNF:NTFPGRAD.IGN69": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.837229166666666, 42, 6.162770833333334, 51.5]
  },
  "IGNF:NTFPGRAD.IGN78C": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [5.662770833333333, 41.2, 7.662770833333334, 43.5]
  },
  "IGNF:NTFPGRAD.NGC48": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [5.662770833333333, 41.2, 7.662770833333334, 43.5]
  },
  "IGNF:NTFPGRAD.NGF84": {
    proj4: "+proj=longlat +ellps=clrk80ign +pm=paris +vunits=m +no_defs +type=crs",
    projected_bounds: [-7.837229166666666, 42, 6.162770833333334, 51.5]
  },
  "IGNF:NUKU72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -483837116691811e-8,
      -4021174505331748e-9,
      -4.7922128176297005e6,
      -409583029765617e-8
    ]
  },
  "IGNF:NUKU72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-140.27, -9.5, -139.48, -8.77]
  },
  "IGNF:NUKU72GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-140.27, -9.5, -139.48, -8.77]
  },
  "IGNF:NUKU72U7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      580129.2462283028,
      8949772378282296e-9,
      667198.9120274235,
      9030226760324448e-9
    ]
  },
  "IGNF:NUKU72UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      580129.2462283028,
      8949772378282296e-9,
      667198.9120274235,
      9030226760324448e-9
    ]
  },
  "IGNF:OUVE72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5791302308505265e-9,
      1432129796372665e-9,
      -5825994352636802e-9,
      1.3761331018359552e6
    ]
  },
  "IGNF:OUVE72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.11, -20.78, 166.71, -20.25]
  },
  "IGNF:OUVE72UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      615539.3734258382,
      7.7017738047871925e6,
      678618.4826105378,
      7759902347199159e-9
    ]
  },
  "IGNF:OUVEA72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5791302308505265e-9,
      1432129796372665e-9,
      -5825994352636802e-9,
      1.3761331018359552e6
    ]
  },
  "IGNF:OUVEA72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [166.11, -20.78, 166.71, -20.25]
  },
  "IGNF:OUVEA72U58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      615539.3734258382,
      7.7017738047871925e6,
      678618.4826105378,
      7759902347199159e-9
    ]
  },
  "IGNF:PDN08G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:PDN08GAUSSL": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:PDN08GAUSSL.REUN89": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:PDN92G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:PDN92GAUSSL": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:PDN92GAUSSL.REUN89": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:PETRELS52": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:PETRELS72": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.8266919189051143e6,
      1.5507924785067162e6,
      -1984509118334939e-9,
      1.6551918200514696e6
    ]
  },
  "IGNF:PETRELS72G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [139.67, -68, 140.17, -66.17]
  },
  "IGNF:PGP50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9271297733454728e6,
      1636060425231317e-9,
      -194934868855064e-8,
      1.6287526691272145e6
    ]
  },
  "IGNF:PGP50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [139.67, -66.72, 140.12, -66.6]
  },
  "IGNF:PGP50STEREPS": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=140 +k=0.960272946 +x_0=300000 +y_0=-2299363.482 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      285424.8359031242,
      231200.62187904632,
      305328.1477502985,
      244635.95420158515
    ]
  },
  "IGNF:PINS78": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:PMAR55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9422703930587526e6,
      1.5728195524463682e6,
      -2.0051267253888086e6,
      1576179824546486e-9
    ]
  },
  "IGNF:PMAR55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [141, -67, 141.83, -66.5]
  },
  "IGNF:PMARP55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9422703930587526e6,
      1.5728195524463682e6,
      -2.0051267253888086e6,
      1576179824546486e-9
    ]
  },
  "IGNF:PMARP55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [141, -67, 141.83, -66.5]
  },
  "IGNF:RAIA01": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:RAIA53": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5370443216115719e-9,
      -2.8953139688764103e6,
      -5367159301229432e-9,
      -2934782357818335e-9
    ]
  },
  "IGNF:RAIA53G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.67, -17, -151.33, -16.5]
  },
  "IGNF:RAIA53UTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      641585.8605531721,
      8119941711411175e-9,
      678253.3496631279,
      8174996218373708e-9
    ]
  },
  "IGNF:RAIV54": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.9335917665011445e6,
      -3112864582014717e-9,
      -4930756797143377e-9,
      -3131568291175318e-9
    ]
  },
  "IGNF:RAIV54G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-147.75, -23.92, -147.58, -23.75]
  },
  "IGNF:RAIV54UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      423664.95671399724,
      7354392883905532e-9,
      440891.02678063384,
      737329626623641e-8
    ]
  },
  "IGNF:RAIV66": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4.9335917665011445e6,
      -3112864582014717e-9,
      -4930756797143377e-9,
      -3131568291175318e-9
    ]
  },
  "IGNF:RAIV66G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-147.75, -23.92, -147.58, -23.75]
  },
  "IGNF:RAIV66UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      423664.95671399724,
      7354392883905532e-9,
      440891.02678063384,
      737329626623641e-8
    ]
  },
  "IGNF:RANGI47": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.2299385156437745e6,
      -3.2680282907959553e6,
      -519050515029438e-8,
      -3351466722624333e-9
    ]
  },
  "IGNF:RANGI47G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148, -14.83, -147.15, -14.42]
  },
  "IGNF:RANGI47GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148, -14.83, -147.15, -14.42]
  },
  "IGNF:RANGI47U6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RANGI47UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RANGI59": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.2299385156437745e6,
      -3.2680282907959553e6,
      -519050515029438e-8,
      -3351466722624333e-9
    ]
  },
  "IGNF:RANGI59G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148, -14.83, -147.15, -14.42]
  },
  "IGNF:RANGI59U6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RANGI59UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RANGI68": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5.2299385156437745e6,
      -3.2680282907959553e6,
      -519050515029438e-8,
      -3351466722624333e-9
    ]
  },
  "IGNF:RANGI68G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148, -14.83, -147.15, -14.42]
  },
  "IGNF:RANGI68U6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RANGI68UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      392398.9525657524,
      8360216907810719e-9,
      483830.5682616851,
      8405798955227204e-9
    ]
  },
  "IGNF:RAPA55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4598672267102914e-9,
      -3.2802010496547157e6,
      -4594741079306024e-9,
      -3307740266359179e-9
    ]
  },
  "IGNF:RAPA55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-144.5, -27.75, -144.25, -27.5]
  },
  "IGNF:RAPA80": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4598672267102914e-9,
      -3.2802010496547157e6,
      -4594741079306024e-9,
      -3307740266359179e-9
    ]
  },
  "IGNF:RAPA80G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-144.5, -27.75, -144.25, -27.5]
  },
  "IGNF:REUN47": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3927298508216175e6,
      4876048666898573e-9,
      3.3435675798242353e6,
      4942143815543878e-9
    ]
  },
  "IGNF:REUN47G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:REUN47GAUSSL": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:REUN47GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:REUN49": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3927298508216175e6,
      4876048666898573e-9,
      3.3435675798242353e6,
      4942143815543878e-9
    ]
  },
  "IGNF:REUN49G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:REUN49G.REUN89": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:REUN49GAUSSL": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:REUN49GAUSSL.REUN89": {
    proj4: "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      122329.03410048355,
      16370.597306418233,
      200267.68757270146,
      89441.26995609095
    ]
  },
  "IGNF:REUN89": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:RGAF09": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2787839706989161e-9,
      -5518984562352111e-9,
      2963394404437388e-9,
      -5287191523502894e-9
    ]
  },
  "IGNF:RGAF09G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RGAF09G.GUAD2008LD": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:RGAF09G.GUAD88": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.85, 15.88, -61.08, 16.63]
  },
  "IGNF:RGAF09G.GUAD88LS": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.7, 15.8, -61.48, 15.93]
  },
  "IGNF:RGAF09G.GUAD88MG": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.4, 15.8, -61.08, 16.13]
  },
  "IGNF:RGAF09G.GUAD88SB": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63, 17.8, -62.73, 18.03]
  },
  "IGNF:RGAF09G.GUAD88SM": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63.2, 18, -62.5, 18.2]
  },
  "IGNF:RGAF09G.GUAD92LD": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:RGAF09G.MART87": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:RGAF09GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RGAF09GDD.GUAD2008LD": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:RGAF09GDD.GUAD88": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.85, 15.88, -61.08, 16.63]
  },
  "IGNF:RGAF09GDD.GUAD88LS": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.7, 15.8, -61.48, 15.93]
  },
  "IGNF:RGAF09GDD.GUAD88MG": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.4, 15.8, -61.08, 16.13]
  },
  "IGNF:RGAF09GDD.GUAD88SB": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63, 17.8, -62.73, 18.03]
  },
  "IGNF:RGAF09GDD.GUAD88SM": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63.2, 18, -62.5, 18.2]
  },
  "IGNF:RGAF09GDD.GUAD92LD": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:RGAF09GDD.MART87": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:RGAF09GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RGAF09GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RGAF09UTM20": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      478425.35850062495,
      1.5753846205684685e6,
      740086.6906576597,
      2013799009971738e-9
    ]
  },
  "IGNF:RGAF09UTM20.GUAD2008LD": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      692370.41145741,
      1.7974350780776488e6,
      740298.54368705,
      1.8145146255774212e6
    ]
  },
  "IGNF:RGAF09UTM20.GUAD88": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      623120.5509452582,
      1.7559998390833512e6,
      704800.0613454229,
      1.8396068410907916e6
    ]
  },
  "IGNF:RGAF09UTM20.GUAD88LS": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      639236.8007983444,
      1747242840610321e-9,
      662700.007574365,
      176178481928567e-8
    ]
  },
  "IGNF:RGAF09UTM20.GUAD88MG": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      671374.8619297829,
      1747464342473474e-9,
      705323.1865690728,
      178427135122081e-8
    ]
  },
  "IGNF:RGAF09UTM20.GUAD88SB": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      1.9680585461112757e6,
      528578.1565113004,
      1993525472181072e-9
    ]
  },
  "IGNF:RGAF09UTM20.GUAD88SM": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      478827.44082822604,
      1.9901969612065325e6,
      552871.8630915796,
      2.0123850501823218e6
    ]
  },
  "IGNF:RGAF09UTM20.GUAD92LD": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      692370.41145741,
      1.7974350780776488e6,
      740298.54368705,
      1.8145146255774212e6
    ]
  },
  "IGNF:RGAF09UTM20.MART87": {
    proj4: "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      688787.0941152538,
      1.5782981182141018e6,
      741946.0265690677,
      1659555998642186e-9
    ]
  },
  "IGNF:RGF93": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4798397970799496e-9,
      -462033.1734812842,
      3.8751795753784813e6,
      683298.714229599
    ]
  },
  "IGNF:RGF93CC42": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      985977.7779897924,
      1.1244100405789989e6,
      2.2701892464121524e6,
      1334399211360232e-9
    ]
  },
  "IGNF:RGF93CC42.IGN69": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      996984.6229555479,
      1.2349229932738352e6,
      2.1481969029555926e6,
      1.3254787831035883e6
    ]
  },
  "IGNF:RGF93CC42.IGN78C": {
    proj4: "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      2.1191683389195963e6,
      1123394291884652e-9,
      2.2701892464121524e6,
      1334399211360232e-9
    ]
  },
  "IGNF:RGF93CC43": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      996923.0501310119,
      2.1245196915646344e6,
      2.2608313469093633e6,
      233447756781277e-8
    ]
  },
  "IGNF:RGF93CC43.IGN69": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      996923.0501310119,
      2.1245196915646344e6,
      2140848433733586e-9,
      2.3255347375284364e6
    ]
  },
  "IGNF:RGF93CC43.IGN78C": {
    proj4: "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      2.1140366243697307e6,
      210124566733632e-8,
      2.2654549749670466e6,
      2.2791164503770783e6
    ]
  },
  "IGNF:RGF93CC44": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0080823176561352e6,
      3124586663225709e-9,
      2.2513023088927856e6,
      3.3345269791965624e6
    ]
  },
  "IGNF:RGF93CC44.IGN69": {
    proj4: "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0080823176561352e6,
      3124586663225709e-9,
      2.1333652109224964e6,
      3325572835422501e-9
    ]
  },
  "IGNF:RGF93CC45": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0194521763965063e6,
      4124610870580383e-9,
      2.2416050205986425e6,
      4334547382123977e-9
    ]
  },
  "IGNF:RGF93CC45.IGN69": {
    proj4: "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0194521763965063e6,
      4124610870580383e-9,
      2.1257494886933584e6,
      4325593027965088e-9
    ]
  },
  "IGNF:RGF93CC46": {
    proj4: "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0310291585263149e6,
      5124592280727496e-9,
      2.2317424223734722e6,
      5334538748527376e-9
    ]
  },
  "IGNF:RGF93CC46.IGN69": {
    proj4: "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0310291585263149e6,
      5124592280727496e-9,
      2.1180035629148665e6,
      5325595288126864e-9
    ]
  },
  "IGNF:RGF93CC47": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1042809733630215e-9,
      6124530912903255e-9,
      2.2217175058167526e6,
      6334501085708954e-9
    ]
  },
  "IGNF:RGF93CC47.IGN69": {
    proj4: "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1042809733630215e-9,
      6124530912903255e-9,
      2.1101297705207784e6,
      6325579610714624e-9
    ]
  },
  "IGNF:RGF93CC48": {
    proj4: "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0547903097885253e6,
      7124426838474415e-9,
      2211533312905538e-9,
      7334434436347502e-9
    ]
  },
  "IGNF:RGF93CC48.IGN69": {
    proj4: "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0547903097885253e6,
      7124426838474415e-9,
      2102130488861046e-9,
      7325546012389484e-9
    ]
  },
  "IGNF:RGF93CC49": {
    proj4: "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0669672346796594e6,
      8124280180867916e-9,
      2.2011929351012753e6,
      8334338878462048e-9
    ]
  },
  "IGNF:RGF93CC49.IGN69": {
    proj4: "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.0669672346796594e6,
      8124280180867916e-9,
      2.0940081350366909e6,
      8325494531658468e-9
    ]
  },
  "IGNF:RGF93CC50": {
    proj4: "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      1079336796699437e-9,
      9124091115436964e-9,
      2.1906995124389585e6,
      9334214525332326e-9
    ]
  },
  "IGNF:RGF93CC50.IGN69": {
    proj4: "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1079336796699437e-9,
      9124091115436964e-9,
      2.0857651652184534e6,
      9325425228839424e-9
    ]
  },
  "IGNF:RGF93EQGPFR": {
    proj4: "+proj=eqc +lat_ts=46.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -421450.0446829672,
      4564099122524217e-9,
      766272.8085144858,
      5788613521250226e-9
    ]
  },
  "IGNF:RGF93G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.5, 41, 10, 52]
  },
  "IGNF:RGF93G.IGN69": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:RGF93G.IGN78C": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:RGF93GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.5, 41, 10, 52]
  },
  "IGNF:RGF93GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.5, 41, 10, 52]
  },
  "IGNF:RGF93GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-5.5, 41, 10, 52]
  },
  "IGNF:RGF93LAMB93": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -16296.157783713657,
      6027156199039219e-9,
      1.1819381775746632e6,
      7233428222339219e-9
    ]
  },
  "IGNF:RGF93LAMB93.IGN69": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      -4330.451902633766,
      6137884355675212e-9,
      1.0827404291832543e6,
      7169568823238193e-9
    ]
  },
  "IGNF:RGF93LAMB93.IGN78C": {
    proj4: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      1.1204732153720446e6,
      6024168867920118e-9,
      1.2656276143942734e6,
      6291856186808479e-9
    ]
  },
  "IGNF:RGF93UTM30": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      289736.7583029455,
      4541767586072582e-9,
      705928.9189491667,
      5.7652882547329655e6
    ]
  },
  "IGNF:RGF93UTM30.IGN69": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      292948.9618270959,
      465279980645914e-8,
      708216.8721780765,
      5709696983449663e-9
    ]
  },
  "IGNF:RGF93UTM31": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247679.1521022452,
      4543092954316025e-9,
      705928.9189491678,
      5.7652882547329655e6
    ]
  },
  "IGNF:RGF93UTM31.IGN69": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.07928578832,
      4.6541308912068475e6,
      708216.8721780778,
      5709696983449663e-9
    ]
  },
  "IGNF:RGF93UTM32": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247679.15210224452,
      4543092954316025e-9,
      568649.7048958713,
      5761510316431475e-9
    ]
  },
  "IGNF:RGF93UTM32.IGN69": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.0792857876,
      4.6541308912068475e6,
      465293.72843508545,
      5705547682000316e-9
    ]
  },
  "IGNF:RGF93UTM32.IGN78C": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416152.6316632011,
      4561441339142957e-9,
      580844.5499921828,
      4.8168270418395605e6
    ]
  },
  "IGNF:RGFG95": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.6605784617348243e6,
      -5.2181500235037375e6,
      3.9881074253902514e6,
      -4933699608717654e-9
    ]
  },
  "IGNF:RGFG95EQGPGU": {
    proj4: "+proj=eqc +lat_ts=4 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6102105299867526e-9,
      228204.95612621077,
      -5.6690168436439885e6,
      662350.9702199778
    ]
  },
  "IGNF:RGFG95G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:RGFG95G.GUYA77": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:RGFG95GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:RGFG95GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:RGFG95GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-54.95, 2.05, -51.05, 5.95]
  },
  "IGNF:RGFG95UTM21": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      728017.5131677594,
      226733.5303089308,
      832187.9853716737,
      658579.5878606287
    ]
  },
  "IGNF:RGFG95UTM21.GUYA77": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      728017.5131677594,
      226733.5303089308,
      832187.9853716737,
      658579.5878606287
    ]
  },
  "IGNF:RGFG95UTM22": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166234.15634470497,
      226900.35410456266,
      494466.0254986756,
      657677.713988964
    ]
  },
  "IGNF:RGFG95UTM22.GUYA77": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      166234.15634470497,
      226900.35410456266,
      494466.0254986756,
      657677.713988964
    ]
  },
  "IGNF:RGM04": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      439812835053325e-8,
      4390458859415753e-9,
      4.3729574786741715e6,
      4434445751599657e-9
    ]
  },
  "IGNF:RGM04EQGPMYT": {
    proj4: "+proj=eqc +lat_ts=-12 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4894465832904011e-9,
      -1.4527193548522203e6,
      4943464934679468e-9,
      -1.3914936349159195e6
    ]
  },
  "IGNF:RGM04G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04G.MAYO53": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04GDD.MAYO53": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [44.95, -13.05, 45.4, -12.5]
  },
  "IGNF:RGM04UTM38S": {
    proj4: "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      494579.01877211593,
      8557334421444304e-9,
      543462.0584164207,
      8618123508460067e-9
    ]
  },
  "IGNF:RGM04UTM38S.MAYO53": {
    proj4: "+proj=utm +zone=38 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      494579.01877211593,
      8557334421444304e-9,
      543462.0584164207,
      8618123508460067e-9
    ]
  },
  "IGNF:RGNC": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -521525795135039e-8,
      2.3110842121924334e6,
      -6145073220054085e-9,
      591703.2514631911
    ]
  },
  "IGNF:RGNC91EQGPNC": {
    proj4: "+proj=eqc +lat_ts=-22 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      16112282399811782e-9,
      -2.9667811773324003e6,
      18011488012601897e-9,
      -1625328524917563e-9
    ]
  },
  "IGNF:RGNCG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [156.1, -26.65, 174.5, -14.6]
  },
  "IGNF:RGNCG.LIFOU91": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [166.96, -21.22, 167.51, -20.65]
  },
  "IGNF:RGNCG.MARE91": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [167.69, -21.69, 168.18, -21.29]
  },
  "IGNF:RGNCG.NCAL69": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [163.5, -22.75, 167.67, -19.5]
  },
  "IGNF:RGNCG.PINS78": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [167.29, -22.8, 167.62, -22.44]
  },
  "IGNF:RGNCGEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [156.1, -26.65, 174.5, -14.6]
  },
  "IGNF:RGNCGEODD": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [156.1, -26.65, 174.5, -14.6]
  },
  "IGNF:RGNCLAM": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -588943.6534238436,
      -302460.1789516732,
      1.3218816918835943e6,
      1040388335620638e-9
    ]
  },
  "IGNF:RGNCLAMBNC": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -588943.6534238436,
      -302460.1789516732,
      1.3218816918835943e6,
      1040388335620638e-9
    ]
  },
  "IGNF:RGNCLAMBNC.LIFOU91": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      499658.7851292891,
      330693.4589047519,
      557363.06110866,
      393345.3822861137
    ]
  },
  "IGNF:RGNCLAMBNC.MARE91": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      574876.1422120564,
      278018.82431889157,
      626194.5095100766,
      321672.46349859366
    ]
  },
  "IGNF:RGNCLAMBNC.NCAL69": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      143190.52016571347,
      159532.78288643624,
      575397.0192912852,
      520509.37134659267
    ]
  },
  "IGNF:RGNCLAMBNC.PINS78": {
    proj4: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      532472.1378832987,
      155501.7976673798,
      566772.4340314672,
      195054.32847456695
    ]
  },
  "IGNF:RGNCUTM57S": {
    proj4: "+proj=utm +zone=57 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      211304.1771274365,
      7049009907402096e-9,
      823256.9662024796,
      838376135405167e-8
    ]
  },
  "IGNF:RGNCUTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      201343.7644742864,
      7048779675073143e-9,
      823256.9662024769,
      838376135405167e-8
    ]
  },
  "IGNF:RGNCUTM59S": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      201343.76447428897,
      7048779675073143e-9,
      823256.9662024769,
      838376135405167e-8
    ]
  },
  "IGNF:RGPF": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -514848631505146e-8,
      -2292253793379353e-9,
      -4397819672654964e-9,
      -4554075585618734e-9
    ]
  },
  "IGNF:RGPFEQGPPF": {
    proj4: "+proj=eqc +lat_ts=-15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -16774113895745091e-9,
      -311694574221166e-8,
      -1440853373096053e-8,
      -779236.435552915
    ]
  },
  "IGNF:RGPFG": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-156, -28, -134, -7]
  },
  "IGNF:RGPFG.BORA01": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.83, -16.58, -151.67, -16.42]
  },
  "IGNF:RGPFG.HUAH01": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.5, -17, -150.75, -16.5]
  },
  "IGNF:RGPFG.MAUPITI01": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-152.5, -16.75, -152, -16.25]
  },
  "IGNF:RGPFG.MOOREA81": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-150, -17.75, -149.75, -17.25]
  },
  "IGNF:RGPFG.RAIA01": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.67, -17, -151.33, -16.5]
  },
  "IGNF:RGPFG.TAHAA01": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.58, -16.7, -151.38, -16.53]
  },
  "IGNF:RGPFGDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-156, -28, -134, -7]
  },
  "IGNF:RGPFGEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-156, -28, -134, -7]
  },
  "IGNF:RGPFUTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204956.51142152905,
      6899169181940673e-9,
      831501.0757581048,
      9225192739949586e-9
    ]
  },
  "IGNF:RGPFUTM5S.BORA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      624819.9611431445,
      816654280912131e-8,
      642008.5213805588,
      8184139680784716e-9
    ]
  },
  "IGNF:RGPFUTM5S.HUAH01": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      659680.07983215,
      8119833746751794e-9,
      740175.3862769192,
      8174416250205356e-9
    ]
  },
  "IGNF:RGPFUTM5S.MAUPITI01": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      553292.2443147335,
      8148033858295733e-9,
      606862.1297752805,
      8203149722019145e-9
    ]
  },
  "IGNF:RGPFUTM5S.RAIA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      641580.1173256909,
      8119964465300987e-9,
      678246.1310010166,
      8.1750181862829225e6
    ]
  },
  "IGNF:RGPFUTM5S.TAHAA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      651400.8376593281,
      8153092769177911e-9,
      672881.5117228165,
      8171742011607597e-9
    ]
  },
  "IGNF:RGPFUTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204956.51142152905,
      6899169181940673e-9,
      831501.0757581076,
      9225192739949586e-9
    ]
  },
  "IGNF:RGPFUTM6S.MOOREA81": {
    proj4: "+proj=utm +zone=6 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      181848.46056198212,
      8034932203527855e-9,
      207578.80518904398,
      8090706220224754e-9
    ]
  },
  "IGNF:RGPFUTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204956.5114215265,
      6899169181940673e-9,
      831501.0757581048,
      9225192739949586e-9
    ]
  },
  "IGNF:RGPFUTM8S": {
    proj4: "+proj=utm +zone=8 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      204956.51142152905,
      6899169181940673e-9,
      610456.5053367098,
      9226133653590135e-9
    ]
  },
  "IGNF:RGR92": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.3927298508216175e6,
      4876048666898573e-9,
      3.3435675798242353e6,
      4942143815543878e-9
    ]
  },
  "IGNF:RGR92EQGPREU": {
    proj4: "+proj=eqc +lat_ts=-21 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5733580741680642e-9,
      -2.3844634927919204e6,
      5811525014949818e-9,
      -2.3098794339604266e6
    ]
  },
  "IGNF:RGR92G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:RGR92G.REUN89": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:RGR92GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:RGR92GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:RGR92GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [55.17, -21.42, 55.92, -20.75]
  },
  "IGNF:RGR92UTM40S": {
    proj4: "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      310323.59476890136,
      7630262170291599e-9,
      387566.02580817335,
      7705144681395082e-9
    ]
  },
  "IGNF:RGR92UTM40S.REUN89": {
    proj4: "+proj=utm +zone=40 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      310323.59476890136,
      7630262170291599e-9,
      387566.02580817335,
      7705144681395082e-9
    ]
  },
  "IGNF:RGSPM06": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      2419236065695576e-9,
      -3.6536813123536184e6,
      2.4213945879916656e6,
      -3.6034152926470623e6
    ]
  },
  "IGNF:RGSPM06EQGP": {
    proj4: "+proj=eqc +lat_ts=47 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -4288704427164641e-9,
      5198620220045876e-9,
      -425909574020068e-8,
      5254279965442513e-9
    ]
  },
  "IGNF:RGSPM06G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:RGSPM06G.STPM50": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:RGSPM06GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:RGSPM06GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:RGSPM06GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:RGSPM06U21": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      538989.5042379599,
      5171953365008607e-9,
      568167.0619726533,
      5227782616575465e-9
    ]
  },
  "IGNF:RGSPM06U21.STPM50": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      538989.5042379599,
      5171953365008607e-9,
      568167.0619726533,
      5227782616575465e-9
    ]
  },
  "IGNF:RGTAAF07": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3045340426200347e-25,
      24660680527803187e-26,
      -4934299376816502e-9,
      3855097179987787e-9
    ]
  },
  "IGNF:RGTAAF07G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39, -90, 142, -11]
  },
  "IGNF:RGTAAF07G.KERG62": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [67, -50.5, 71, -48]
  },
  "IGNF:RGTAAF07GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39, -90, 142, -11]
  },
  "IGNF:RGTAAF07GDD.KERG62": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [67, -50.5, 71, -48]
  },
  "IGNF:RGTAAFGEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39, -90, 142, -11]
  },
  "IGNF:RGTAAFGEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [39, -90, 142, -11]
  },
  "IGNF:RGTAAFUTM37S": {
    proj4: "+proj=utm +zone=37 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      2035.0570612289011,
      12641336008088078e-9,
      -5360996089411549e-9
    ]
  },
  "IGNF:RGTAAFUTM39S": {
    proj4: "+proj=utm +zone=39 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848662718,
      1.1169150441517476e6,
      827871.392811014,
      8782381615656687e-9
    ]
  },
  "IGNF:RGTAAFUTM42S": {
    proj4: "+proj=utm +zone=42 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486627084,
      1.1169150441517476e6,
      827871.3928110084,
      8782381615656687e-9
    ]
  },
  "IGNF:RGTAAFUTM42S.KERG62": {
    proj4: "+proj=utm +zone=42 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      358163.34529037436,
      4.4038640833304515e6,
      649187.8749623755,
      4681764386239842e-9
    ]
  },
  "IGNF:RGTAAFUTM43S": {
    proj4: "+proj=utm +zone=43 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848662711,
      1.1169150441517476e6,
      827871.3928110098,
      8782381615656687e-9
    ]
  },
  "IGNF:RGTAAFUTM53S": {
    proj4: "+proj=utm +zone=53 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      499999.9999999996,
      2035.0570612289011,
      1.2664884640495614e6,
      877505330120935e-8
    ]
  },
  "IGNF:RGWF96": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6179310055493656e-9,
      -2156.9862070071895,
      -6.1987651428468255e6,
      -400856.1602417727
    ]
  },
  "IGNF:RGWF96G": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.98, -14.39, -176.3, -13.16]
  },
  "IGNF:RGWF96GDD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.98, -14.39, -176.3, -13.16]
  },
  "IGNF:RGWF96GEO": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.98, -14.39, -176.3, -13.16]
  },
  "IGNF:RGWF96GEO.FUTUNA1997": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-179.98, -14.39, -178.2, -14.23]
  },
  "IGNF:RGWF96GEO.WALLIS96": {
    proj4: "+proj=longlat +ellps=GRS80 +vunits=m +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:RGWF96GEODD": {
    proj4: "+proj=longlat +ellps=GRS80 +no_defs +type=crs",
    projected_bounds: [-179.98, -14.39, -176.3, -13.16]
  },
  "IGNF:RGWF96UTM1S": {
    proj4: "+proj=utm +zone=1 +south +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      178609.7279157908,
      8407062455115324e-9,
      575861.7343148082,
      854506486163808e-8
    ]
  },
  "IGNF:RGWF96UTM1S.FUTUNA1997": {
    proj4: "+proj=utm +zone=1 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      178609.7279157908,
      8407062455115324e-9,
      370532.6101644533,
      8426503286660273e-9
    ]
  },
  "IGNF:RGWF96UTM1S.WALLIS96": {
    proj4: "+proj=utm +zone=1 +south +ellps=GRS80 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      575780.9715083599,
      8516309860756025e-9,
      597533.9884242461,
      854388995112203e-8
    ]
  },
  "IGNF:RRAF": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2787839706989161e-9,
      -5518984562352111e-9,
      2963394404437388e-9,
      -5287191523502894e-9
    ]
  },
  "IGNF:RRAF91": {
    proj4: "+proj=geocent +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "IGNF:RRAFG": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RRAFG.GUAD88": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.85, 15.88, -61.08, 16.63]
  },
  "IGNF:RRAFG.GUAD88LS": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.7, 15.8, -61.48, 15.93]
  },
  "IGNF:RRAFG.GUAD88MG": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.4, 15.8, -61.08, 16.13]
  },
  "IGNF:RRAFG.GUAD88SB": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63, 17.8, -62.73, 18.03]
  },
  "IGNF:RRAFG.GUAD88SM": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-63.2, 18, -62.5, 18.2]
  },
  "IGNF:RRAFG.GUAD92LD": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.2, 16.25, -60.75, 16.4]
  },
  "IGNF:RRAFG.MART87": {
    proj4: "+proj=longlat +ellps=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-61.25, 14.27, -60.75, 15]
  },
  "IGNF:RRAFGDD": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RRAFGEO": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RRAFGEODD": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:RRAFUTM20": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      478425.35850064637,
      1.5753846206188477e6,
      740086.6906572741,
      2013799010034841e-9
    ]
  },
  "IGNF:RRAFUTM20.GUAD88": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      623120.550945107,
      1.7559998391390766e6,
      704800.0613451467,
      1.8396068411489325e6
    ]
  },
  "IGNF:RRAFUTM20.GUAD88LS": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      639236.8007981749,
      1747242840665787e-9,
      662700.0075741636,
      1761784819341557e-9
    ]
  },
  "IGNF:RRAFUTM20.GUAD88MG": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      671374.8619295742,
      1.7474643425289397e6,
      705323.186568812,
      1.7842713512773437e6
    ]
  },
  "IGNF:RRAFUTM20.GUAD88SB": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      5e5,
      1.9680585461731292e6,
      528578.1565112555,
      1993525472243646e-9
    ]
  },
  "IGNF:RRAFUTM20.GUAD88SM": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      478827.44082825916,
      1.9901969612690131e6,
      552871.863091495,
      2.0123850502454268e6
    ]
  },
  "IGNF:RRAFUTM20.GUAD92LD": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      692370.4114571622,
      1.7974350781345686e6,
      740298.5436867343,
      1.8145146256348237e6
    ]
  },
  "IGNF:RRAFUTM20.MART87": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      688787.094115065,
      1.5782981182645466e6,
      741946.0265688002,
      1.6595559986950401e6
    ]
  },
  "IGNF:RUSAT84": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5178100212061911e-9,
      -2811479023438015e-9,
      -5181961459204037e-9,
      -2833515499695145e-9
    ]
  },
  "IGNF:RUSAT84G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.5, -22.58, -151.33, -22.25]
  },
  "IGNF:RUSAT84UTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      654212.6655109195,
      7502165195402047e-9,
      672099.6617659659,
      753851940664996e-8
    ]
  },
  "IGNF:SAT84": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5178100212061911e-9,
      -2811479023438015e-9,
      -5181961459204037e-9,
      -2833515499695145e-9
    ]
  },
  "IGNF:SAT84G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.5, -22.58, -151.33, -22.25]
  },
  "IGNF:SAT84UTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      654212.6655109195,
      7502165195402047e-9,
      672099.6617659659,
      753851940664996e-8
    ]
  },
  "IGNF:SHOM1984WF": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:ST84": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5738577712951854e-9,
      1.2942968201179132e6,
      -5760913683807308e-9,
      1.2645110347633106e6
    ]
  },
  "IGNF:ST84G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [167.29, -22.8, 167.62, -22.44]
  },
  "IGNF:ST84G.PINS78": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [167.29, -22.8, 167.62, -22.44]
  },
  "IGNF:ST84UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      735080.8676769093,
      7476765854882775e-9,
      769674.6355967587,
      7516082988940713e-9
    ]
  },
  "IGNF:ST84UTM58S.PINS78": {
    proj4: "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      735080.8676769093,
      7476765854882775e-9,
      769674.6355967587,
      7516082988940713e-9
    ]
  },
  "IGNF:ST87": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -5791302308505265e-9,
      1432129796372665e-9,
      -5825994352636802e-9,
      1.3761331018359552e6
    ]
  },
  "IGNF:ST87G": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [166.11, -20.78, 166.71, -20.25]
  },
  "IGNF:ST87GEO": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [166.11, -20.78, 166.71, -20.25]
  },
  "IGNF:ST87UTM58S": {
    proj4: "+proj=utm +zone=58 +south +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      615534.6207296363,
      7701802969114272e-9,
      678611.1501862095,
      7759930589483198e-9
    ]
  },
  "IGNF:STPL69": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      1.0794267345867956e6,
      4860948828783446e-9,
      1.0724345959100134e6,
      4869606724730391e-9
    ]
  },
  "IGNF:STPL69G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [77.48, -38.77, 77.58, -38.67]
  },
  "IGNF:STPL69GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [77.48, -38.77, 77.58, -38.67]
  },
  "IGNF:STPL69UTM43S": {
    proj4: "+proj=utm +zone=43 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      715465.4006878085,
      570575314000332e-8,
      724467.6200640477,
      5716612063851182e-9
    ]
  },
  "IGNF:STPM50": {
    proj4: "+proj=geocent +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      2419236065695576e-9,
      -3.6536813123536184e6,
      2.4213945879916656e6,
      -3.6034152926470623e6
    ]
  },
  "IGNF:STPM50G": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:STPM50G.STPM50": {
    proj4: "+proj=longlat +ellps=clrk66 +vunits=m +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:STPM50GEO": {
    proj4: "+proj=longlat +ellps=clrk66 +no_defs +type=crs",
    projected_bounds: [-56.49, 46.7, -56.1, 47.2]
  },
  "IGNF:STPM50UTM21": {
    proj4: "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs +type=crs",
    projected_bounds: [
      538990.6982025271,
      5171734980519562e-9,
      568169.1716647253,
      5227564007660349e-9
    ]
  },
  "IGNF:STPM50UTM21.STPM50": {
    proj4: "+proj=utm +zone=21 +ellps=clrk66 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      538990.6982025271,
      5171734980519562e-9,
      568169.1716647253,
      5227564007660349e-9
    ]
  },
  "IGNF:STPM50_V": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:SYSLN": {
    proj4: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=paris +units=m +no_defs +type=crs",
    projected_bounds: [1 / 0, 1 / 0, 5e5, 5753601530612312e-9]
  },
  "IGNF:SYSLNG": {
    proj4: "+proj=longlat +a=6376523 +rf=308.64 +pm=paris +no_defs +type=crs",
    projected_bounds: [177.66277083333338, -90, 177.66277083333335, 90]
  },
  "IGNF:TAHAA": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5374352485966944e-9,
      -2.9083264671588317e6,
      -5368889906278437e-9,
      -2929645460024113e-9
    ]
  },
  "IGNF:TAHAA01": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:TAHAA53": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5370443216115719e-9,
      -2.8953139688764103e6,
      -5367159301229432e-9,
      -2934782357818335e-9
    ]
  },
  "IGNF:TAHAA53G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.67, -17, -151.33, -16.5]
  },
  "IGNF:TAHAA53G.BORA01": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.83, -16.58, -151.67, -16.42]
  },
  "IGNF:TAHAA53G.HUAH01": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.67, -17, -151.33, -16.5]
  },
  "IGNF:TAHAA53G.RAIA01": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.67, -17, -151.33, -16.5]
  },
  "IGNF:TAHAA53UTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      641585.8605531721,
      8119941711411175e-9,
      678253.3496631279,
      8174996218373708e-9
    ]
  },
  "IGNF:TAHAA53UTM5S.BORA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      624825.0172657012,
      8166520729711336e-9,
      642014.270777989,
      818411785027321e-8
    ]
  },
  "IGNF:TAHAA53UTM5S.HUAH01": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      641585.8605531721,
      8119941711411175e-9,
      678253.3496631279,
      8174996218373708e-9
    ]
  },
  "IGNF:TAHAA53UTM5S.RAIA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      641585.8605531721,
      8119941711411175e-9,
      678253.3496631279,
      8174996218373708e-9
    ]
  },
  "IGNF:TAHAAG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.58, -16.7, -151.38, -16.53]
  },
  "IGNF:TAHAAG.TAHAA01": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-151.58, -16.7, -151.38, -16.53]
  },
  "IGNF:TAHAAGEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-151.58, -16.7, -151.38, -16.53]
  },
  "IGNF:TAHAAUTM05S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      651406.9730855874,
      8153070492116645e-9,
      672888.5137904189,
      8171719997950884e-9
    ]
  },
  "IGNF:TAHAAUTM5S": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      651406.9730855874,
      8153070492116645e-9,
      672888.5137904189,
      8171719997950884e-9
    ]
  },
  "IGNF:TAHAAUTM5S.TAHAA01": {
    proj4: "+proj=utm +zone=5 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      651406.9730855874,
      8153070492116645e-9,
      672888.5137904189,
      8171719997950884e-9
    ]
  },
  "IGNF:TAHI51": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5254962943852452e-9,
      -3.0339542702147206e6,
      -5229739432396973e-9,
      -3142344472702889e-9
    ]
  },
  "IGNF:TAHI51G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -18, -149, -17]
  },
  "IGNF:TAHI51UTM06S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      287068.796720956,
      8119335357610261e-9
    ]
  },
  "IGNF:TAHI51UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      287068.796720956,
      8119335357610261e-9
    ]
  },
  "IGNF:TAHI51UTM6S.TAHITI66": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      287068.796720956,
      8119335357610261e-9
    ]
  },
  "IGNF:TAHI79": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5254962943852452e-9,
      -3.0339542702147206e6,
      -5229739432396973e-9,
      -3142344472702889e-9
    ]
  },
  "IGNF:TAHI79G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -18, -149, -17]
  },
  "IGNF:TAHI79G.TAHITI66": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-150, -18, -149, -17]
  },
  "IGNF:TAHI79GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-150, -18, -149, -17]
  },
  "IGNF:TAHI79UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      287068.796720956,
      8119335357610261e-9
    ]
  },
  "IGNF:TAHI79UTM6S.TAHITI66": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      182280.95077043102,
      8.0072180604424095e6,
      287068.796720956,
      8119335357610261e-9
    ]
  },
  "IGNF:TAHITI66": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:TAKA69": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5073883379210941e-9,
      -3509394382765457e-9,
      -5049410423894455e-9,
      -3.5685704704282293e6
    ]
  },
  "IGNF:TAKA69G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-145.33, -14.75, -144.75, -14.25]
  },
  "IGNF:TAKA69UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      679773.9098304688,
      8368638399163181e-9,
      742779.2548235416,
      8423432316334758e-9
    ]
  },
  "IGNF:TANNA": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5901219446669428e-9,
      1.1289204451677934e6,
      -5935158248027147e-9,
      1.0646955758733146e6
    ]
  },
  "IGNF:TANNAG": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [169.17, -19.67, 169.83, -19.08]
  },
  "IGNF:TANNAUTM59S": {
    proj4: "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      308143.4219945763,
      7823977065733325e-9,
      376904.79182499484,
      7889883631370478e-9
    ]
  },
  "IGNF:TERA50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -1.9271297733454728e6,
      1636060425231317e-9,
      -194934868855064e-8,
      1.6287526691272145e6
    ]
  },
  "IGNF:TERA50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [139.67, -66.72, 140.12, -66.6]
  },
  "IGNF:TERA50GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [139.67, -66.72, 140.12, -66.6]
  },
  "IGNF:TERA50STEREO": {
    proj4: "+proj=stere +lat_0=-90 +lon_0=140 +k=0.960272946 +x_0=300000 +y_0=-2299363.482 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      285424.8359031242,
      231200.62187904632,
      305328.1477502985,
      244635.95420158515
    ]
  },
  "IGNF:TETIA90": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5259559859660432e-9,
      -3.0857654416662934e6,
      -5258024651231139e-9,
      -3.0935060122396327e6
    ]
  },
  "IGNF:TETIA90G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-149.6, -17.1, -149.53, -17.02]
  },
  "IGNF:TETIA90UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      223304.46889845526,
      8107512615621586e-9,
      230643.23512042372,
      8116468173189378e-9
    ]
  },
  "IGNF:TIKE50": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -524921449334791e-8,
      -3.2167227786391536e6,
      -5.2299385156437745e6,
      -3.2680282907959553e6
    ]
  },
  "IGNF:TIKE50G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148.5, -15.2, -148, -14.83]
  },
  "IGNF:TIKE50UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      338867.1814942876,
      8318979897972078e-9,
      392398.9525657524,
      8360216907810719e-9
    ]
  },
  "IGNF:TIKE60": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -524921449334791e-8,
      -3.2167227786391536e6,
      -5.2299385156437745e6,
      -3.2680282907959553e6
    ]
  },
  "IGNF:TIKE60G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-148.5, -15.2, -148, -14.83]
  },
  "IGNF:TIKE60UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      338867.1814942876,
      8318979897972078e-9,
      392398.9525657524,
      8360216907810719e-9
    ]
  },
  "IGNF:TIKE88G": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-148.5, -15.2, -148, -14.83]
  },
  "IGNF:TIKE88GEO": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-148.5, -15.2, -148, -14.83]
  },
  "IGNF:TIKE88UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      338873.7304095781,
      8319000264832558e-9,
      392403.3206880741,
      8360236689904965e-9
    ]
  },
  "IGNF:TROM56": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      3562123689244868e-9,
      4995757331298578e-9,
      3560906882720448e-9,
      4997740451419997e-9
    ]
  },
  "IGNF:TROM56G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [54.51, -15.9, 54.53, -15.87]
  },
  "IGNF:TROM56MD": {
    proj4: "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      26068264239264134e-9,
      8218533629376242e-9,
      2607049071669553e-8,
      8221984337480919e-9
    ]
  },
  "IGNF:TUAM86": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4708410186640331e-9,
      -3.1206376048363764e6,
      -4754045840901789e-9,
      -3907338420394432e-9
    ]
  },
  "IGNF:TUAM86G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-146.4644, -27.75, -140.5833, -15.293]
  },
  "IGNF:TUAM86UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      552785.2573425442,
      693033292808678e-8,
      822219.6534699944,
      8307019992895553e-9
    ]
  },
  "IGNF:TUAM86UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      204264.86167014245,
      6926840726178654e-9,
      544738.924870628,
      8309203516279376e-9
    ]
  },
  "IGNF:TUBU55": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5048513973492709e-9,
      -2964314898601413e-9,
      -5043082675885467e-9,
      -2.9907930082773427e6
    ]
  },
  "IGNF:TUBU55G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-149.58, -23.45, -149.33, -23.25]
  },
  "IGNF:TUBU69": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -5048513973492709e-9,
      -2964314898601413e-9,
      -5043082675885467e-9,
      -2.9907930082773427e6
    ]
  },
  "IGNF:TUBU69G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-149.58, -23.45, -149.33, -23.25]
  },
  "IGNF:TUBU69UTM6S": {
    proj4: "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      236410.00008526025,
      7404267027372055e-9,
      261604.5999598626,
      7426856951892678e-9
    ]
  },
  "IGNF:TURI69": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -4551995360991369e-9,
      -3842650627011235e-9,
      -4.4940206830935655e6,
      -3.9300631958345952e6
    ]
  },
  "IGNF:TURI69G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-139.83, -21, -138.83, -20.67]
  },
  "IGNF:TURI69UTM7S": {
    proj4: "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      621608.0417763409,
      7677377810691172e-9,
      726067.6467890826,
      7712833077419529e-9
    ]
  },
  "IGNF:UTM01SW84": {
    proj4: "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "IGNF:UTM20W84MART": {
    proj4: "+proj=utm +zone=20 +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      478425.35850064637,
      1.5753846206188477e6,
      740086.6906572741,
      2013799010034841e-9
    ]
  },
  "IGNF:UTM21RGFG95": {
    proj4: "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      728017.5131677594,
      226733.5303089308,
      832187.9853716737,
      658579.5878606287
    ]
  },
  "IGNF:UTM22RGFG95": {
    proj4: "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      166234.15634470497,
      226900.35410456266,
      494466.0254986756,
      657677.713988964
    ]
  },
  "IGNF:UTM26ETRS89": {
    proj4: "+proj=utm +zone=26 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      697568.4037129752,
      3.0434094473345717e6,
      606205.718039366,
      793580065484354e-8
    ]
  },
  "IGNF:UTM27ETRS89": {
    proj4: "+proj=utm +zone=27 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112227,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:UTM28ETRS89": {
    proj4: "+proj=utm +zone=28 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122207,
      3045401946983414e-9,
      606205.7180393654,
      793580065484354e-8
    ]
  },
  "IGNF:UTM29ETRS89": {
    proj4: "+proj=utm +zone=29 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122364,
      3045401946983414e-9,
      606205.7180393661,
      793580065484354e-8
    ]
  },
  "IGNF:UTM30": {
    proj4: "+proj=utm +zone=30 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843707,
      3766273293864319e-9,
      603438.4562997073,
      7.9917262305144165e6
    ]
  },
  "IGNF:UTM30ETRS89": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112229,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:UTM30RGF93": {
    proj4: "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      289736.7583029455,
      4541767586072582e-9,
      705928.9189491667,
      5.7652882547329655e6
    ]
  },
  "IGNF:UTM30W72": {
    proj4: "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622812,
      0,
      558132.1951390184,
      8883082360469576e-9
    ]
  },
  "IGNF:UTM30W84": {
    proj4: "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.4430805386,
      0,
      558132.215132799,
      8883084955948304e-9
    ]
  },
  "IGNF:UTM31": {
    proj4: "+proj=utm +zone=31 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843864,
      3766273293864319e-9,
      603438.456299708,
      7.9917262305144165e6
    ]
  },
  "IGNF:UTM31ETRS89": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:UTM31RGF93": {
    proj4: "+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247679.1521022452,
      4543092954316025e-9,
      705928.9189491678,
      5.7652882547329655e6
    ]
  },
  "IGNF:UTM31W72": {
    proj4: "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      558132.1951390187,
      8883082360469576e-9
    ]
  },
  "IGNF:UTM31W84": {
    proj4: "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      558132.2151327992,
      8883084955948304e-9
    ]
  },
  "IGNF:UTM32": {
    proj4: "+proj=utm +zone=32 +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      222896.57015843794,
      3766273293864319e-9,
      603438.4562997076,
      7.9917262305144165e6
    ]
  },
  "IGNF:UTM32ETRS89": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122382,
      3045401946983414e-9,
      606205.7180393662,
      793580065484354e-8
    ]
  },
  "IGNF:UTM32RGF93": {
    proj4: "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      247679.15210224452,
      4543092954316025e-9,
      568649.7048958713,
      5761510316431475e-9
    ]
  },
  "IGNF:UTM32W72": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162291,
      0,
      558132.1951390185,
      8883082360469576e-9
    ]
  },
  "IGNF:UTM32W84": {
    proj4: "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053964,
      0,
      558132.2151327991,
      8883084955948304e-9
    ]
  },
  "IGNF:UTM33ETRS89": {
    proj4: "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112255,
      3045401946983414e-9,
      606205.7180393666,
      793580065484354e-8
    ]
  },
  "IGNF:UTM34ETRS89": {
    proj4: "+proj=utm +zone=34 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:UTM35ETRS89": {
    proj4: "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.934711224,
      3045401946983414e-9,
      606205.718039366,
      793580065484354e-8
    ]
  },
  "IGNF:UTM36ETRS89": {
    proj4: "+proj=utm +zone=36 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.9347112227,
      3045401946983414e-9,
      606205.7180393657,
      793580065484354e-8
    ]
  },
  "IGNF:UTM37ETRS89": {
    proj4: "+proj=utm +zone=37 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.93471122457,
      3045401946983414e-9,
      606205.7180393664,
      793580065484354e-8
    ]
  },
  "IGNF:UTM38ETRS89": {
    proj4: "+proj=utm +zone=38 +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      203603.934711224,
      3045401946983414e-9,
      517707.23557758785,
      7933236425749246e-9
    ]
  },
  "IGNF:UTM39SW84": {
    proj4: "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672013,
      1.1169150440516975e6,
      833978.5569194623,
      1e7
    ]
  },
  "IGNF:UTM42SW84": {
    proj4: "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672003,
      1.1169150440516956e6,
      833978.5569194567,
      1e7
    ]
  },
  "IGNF:UTM43SW84": {
    proj4: "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194581,
      1e7
    ]
  },
  "IGNF:UVEA84": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:W84MARTGEODD": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:WALL76": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -6192166534047329e-9,
      -400429.44735213276,
      -6197076741323017e-9,
      -422474.30853362026
    ]
  },
  "IGNF:WALL76G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:WALL76G.WALLIS96": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:WALL76UTM1S": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      575784.0115410725,
      8516292588697711e-9,
      597537.8984465686,
      8543873039008161e-9
    ]
  },
  "IGNF:WALL76UTM1S.WALLIS96": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      575784.0115410725,
      8516292588697711e-9,
      597537.8984465686,
      8543873039008161e-9
    ]
  },
  "IGNF:WALL78": {
    proj4: "+proj=geocent +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      -6192166534047329e-9,
      -400429.44735213276,
      -6197076741323017e-9,
      -422474.30853362026
    ]
  },
  "IGNF:WALL78G": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:WALL78G.WALLIS96": {
    proj4: "+proj=longlat +ellps=intl +vunits=m +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:WALL78GEO": {
    proj4: "+proj=longlat +ellps=intl +no_defs +type=crs",
    projected_bounds: [-176.3, -13.42, -176.1, -13.17]
  },
  "IGNF:WALL78UTM1S": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +no_defs +type=crs",
    projected_bounds: [
      575784.0115410725,
      8516292588697711e-9,
      597537.8984465686,
      8543873039008161e-9
    ]
  },
  "IGNF:WALL78UTM1S.WALLIS96": {
    proj4: "+proj=utm +zone=1 +south +ellps=intl +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      575784.0115410725,
      8516292588697711e-9,
      597537.8984465686,
      8543873039008161e-9
    ]
  },
  "IGNF:WALLIS96": {
    proj4: "+vunits=m +no_defs +type=crs"
  },
  "IGNF:WGS72": {
    proj4: "+proj=geocent +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "IGNF:WGS72G": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS72G.IGN69": {
    proj4: "+proj=longlat +ellps=WGS72 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:WGS72G.IGN78C": {
    proj4: "+proj=longlat +ellps=WGS72 +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:WGS72G.NGC48": {
    proj4: "+proj=longlat +ellps=WGS72 +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:WGS72GEO": {
    proj4: "+proj=longlat +ellps=WGS72 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS72UTM1S": {
    proj4: "+proj=utm +zone=1 +south +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.8048609817,
      1116917639530424e-9,
      833978.4521837728,
      1e7
    ]
  },
  "IGNF:WGS72UTM30": {
    proj4: "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781622812,
      0,
      558132.1951390184,
      8883082360469576e-9
    ]
  },
  "IGNF:WGS72UTM30.IGN69": {
    proj4: "+proj=utm +zone=30 +ellps=WGS72 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      292949.0296474388,
      4652798568775873e-9,
      708216.8029010692,
      5709695427999626e-9
    ]
  },
  "IGNF:WGS72UTM31": {
    proj4: "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.54781623004,
      0,
      558132.1951390187,
      8883082360469576e-9
    ]
  },
  "IGNF:WGS72UTM31.IGN69": {
    proj4: "+proj=utm +zone=31 +ellps=WGS72 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.16067206807,
      4654129653087497e-9,
      708216.8029010704,
      5709695427999626e-9
    ]
  },
  "IGNF:WGS72UTM32": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.5478162291,
      0,
      558132.1951390185,
      8883082360469576e-9
    ]
  },
  "IGNF:WGS72UTM32.IGN69": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.16067206746,
      4654129653087497e-9,
      465293.73998225894,
      5705546127930882e-9
    ]
  },
  "IGNF:WGS72UTM32.IGN78C": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416152.6590909028,
      4561440128243434e-9,
      580844.5234456018,
      4816825756006881e-9
    ]
  },
  "IGNF:WGS72UTM32.NGC48": {
    proj4: "+proj=utm +zone=32 +ellps=WGS72 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416152.6590909028,
      4561440128243434e-9,
      580844.5234456018,
      4816825756006881e-9
    ]
  },
  "IGNF:WGS84": {
    proj4: "+proj=geocent +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -39186209248144716e-26,
      -4798926572645884e-41,
      -39186209248144716e-26,
      4798926572645884e-41
    ]
  },
  "IGNF:WGS84EQGPASP": {
    proj4: "+proj=eqc +lat_ts=-38 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      6793988029120558e-9,
      -4315856658055217e-9,
      6809777801170159e-9,
      -4202310777446077e-9
    ]
  },
  "IGNF:WGS84EQGPCRZ": {
    proj4: "+proj=eqc +lat_ts=-46 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      3.8664508037390388e6,
      -5204186194585539e-9,
      4059773343925991e-9,
      -5092866703792266e-9
    ]
  },
  "IGNF:WGS84EQGPKER": {
    proj4: "+proj=eqc +lat_ts=-49.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      4843847144465692e-9,
      -5621634285060315e-9,
      5133032048612897e-9,
      -5343335558077131e-9
    ]
  },
  "IGNF:WGS84EQGPWF": {
    proj4: "+proj=eqc +lat_ts=-14 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -19440148453704666e-9,
      -1.6018874725152068e6,
      -19042661253406677e-9,
      -146496449883948e-8
    ]
  },
  "IGNF:WGS84G": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS84G.IGN69": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:WGS84G.IGN78C": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:WGS84GDD": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS84GDD.IGN69": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [-5.5, 42, 8.5, 51.5]
  },
  "IGNF:WGS84GDD.IGN78C": {
    proj4: "+proj=longlat +datum=WGS84 +vunits=m +no_defs +type=crs",
    projected_bounds: [8, 41.2, 10, 43.5]
  },
  "IGNF:WGS84GEO": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS84GEODD": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS84GPAF": {
    proj4: "+proj=eqc +lat_ts=15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -6795666655199293e-9,
      1.5863027438041484e6,
      -6530076518516663e-9,
      2026014732437579e-9
    ]
  },
  "IGNF:WGS84GUAD": {
    proj4: "+proj=geocent +ellps=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      2787839706989161e-9,
      -5518984562352111e-9,
      2963394404437388e-9,
      -5287191523502894e-9
    ]
  },
  "IGNF:WGS84GUADGEO": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:WGS84MARTG": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:WGS84MARTGDD": {
    proj4: "+proj=longlat +ellps=WGS84 +no_defs +type=crs",
    projected_bounds: [-63.2, 14.25, -60.73, 18.2]
  },
  "IGNF:WGS84MILLGP": {
    proj4: "+proj=mill +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      -20015109356056377e-9,
      -14675057854846332e-9,
      20015109356056377e-9,
      14675057854846328e-9
    ]
  },
  "IGNF:WGS84RRAFGEO": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  },
  "IGNF:WGS84UTM1S": {
    proj4: "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720106,
      1.1169150440516956e6,
      833978.5569194623,
      1e7
    ]
  },
  "IGNF:WGS84UTM30": {
    proj4: "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.4430805386,
      0,
      558132.215132799,
      8883084955948304e-9
    ]
  },
  "IGNF:WGS84UTM30.IGN69": {
    proj4: "+proj=utm +zone=30 +datum=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      292948.9618286196,
      4652799806575611e-9,
      708216.8721759786,
      5709696983573317e-9
    ]
  },
  "IGNF:WGS84UTM31": {
    proj4: "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308054057,
      0,
      558132.2151327992,
      8883084955948304e-9
    ]
  },
  "IGNF:WGS84UTM31.IGN69": {
    proj4: "+proj=utm +zone=31 +datum=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.07928761706,
      4.6541308913233075e6,
      708216.8721759799,
      5709696983573317e-9
    ]
  },
  "IGNF:WGS84UTM32": {
    proj4: "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      166021.44308053964,
      0,
      558132.2151327991,
      8883084955948304e-9
    ]
  },
  "IGNF:WGS84UTM32.IGN69": {
    proj4: "+proj=utm +zone=32 +datum=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      251535.07928761645,
      4.6541308913233075e6,
      465293.72843543504,
      570554768212401e-8
    ]
  },
  "IGNF:WGS84UTM32.IGN78C": {
    proj4: "+proj=utm +zone=32 +datum=WGS84 +units=m +vunits=m +no_defs +type=crs",
    projected_bounds: [
      416152.6316637987,
      4561441339258447e-9,
      580844.5499915533,
      481682704195776e-8
    ]
  },
  "IGNF:WGS84UTM39S": {
    proj4: "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672013,
      1.1169150440516975e6,
      833978.5569194623,
      1e7
    ]
  },
  "IGNF:WGS84UTM42S": {
    proj4: "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.7848672003,
      1.1169150440516956e6,
      833978.5569194567,
      1e7
    ]
  },
  "IGNF:WGS84UTM43S": {
    proj4: "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs +type=crs",
    projected_bounds: [
      441867.78486720053,
      1.1169150440516956e6,
      833978.5569194581,
      1e7
    ]
  },
  "IGNF:WGS84WMSV": {
    proj4: "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs",
    projected_bounds: [
      -20037508342789244e-9,
      -1997186888040857e-8,
      20037508342789244e-9,
      1997186888040857e-8
    ]
  },
  "NKG:ETRF00": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      3841407988102449e-9,
      201319.66197658455,
      1.4329025023389014e6,
      1.2023479612255734e6
    ]
  },
  "NKG:ETRF14": {
    proj4: "+proj=geocent +ellps=GRS80 +units=m +no_defs +type=crs",
    projected_bounds: [
      4.1078640912067834e6,
      0,
      1.0864094465725108e6,
      1.2497711046434774e6
    ]
  },
  "OGC:CRS27": {
    proj4: "+proj=longlat +datum=NAD27 +no_defs +type=crs",
    projected_bounds: [167.65, 7.15, -47.74744119646247, 83.16920616678068]
  },
  "OGC:CRS83": {
    proj4: "+proj=longlat +datum=NAD83 +no_defs +type=crs",
    projected_bounds: [167.65, 14.92, -47.74, 86.46]
  },
  "OGC:CRS84": {
    proj4: "+proj=longlat +datum=WGS84 +no_defs +type=crs",
    projected_bounds: [-180, -90, 180, 90]
  }
};
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "156";
function clamp(r, e, s) {
  return Math.max(e, Math.min(s, r));
}
class Matrix3 {
  constructor(e, s, o, a, l, u, c, E, d) {
    Matrix3.prototype.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], e !== void 0 && this.set(e, s, o, a, l, u, c, E, d);
  }
  set(e, s, o, a, l, u, c, E, d) {
    const f = this.elements;
    return f[0] = e, f[1] = a, f[2] = c, f[3] = s, f[4] = l, f[5] = E, f[6] = o, f[7] = u, f[8] = d, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(e) {
    const s = this.elements, o = e.elements;
    return s[0] = o[0], s[1] = o[1], s[2] = o[2], s[3] = o[3], s[4] = o[4], s[5] = o[5], s[6] = o[6], s[7] = o[7], s[8] = o[8], this;
  }
  extractBasis(e, s, o) {
    return e.setFromMatrix3Column(this, 0), s.setFromMatrix3Column(this, 1), o.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(e) {
    const s = e.elements;
    return this.set(
      s[0],
      s[4],
      s[8],
      s[1],
      s[5],
      s[9],
      s[2],
      s[6],
      s[10]
    ), this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, s) {
    const o = e.elements, a = s.elements, l = this.elements, u = o[0], c = o[3], E = o[6], d = o[1], f = o[4], h = o[7], S = o[2], R = o[5], _ = o[8], m = a[0], L = a[3], F = a[6], W = a[1], G = a[4], q = a[7], fe = a[2], _e = a[5], Le = a[8];
    return l[0] = u * m + c * W + E * fe, l[3] = u * L + c * G + E * _e, l[6] = u * F + c * q + E * Le, l[1] = d * m + f * W + h * fe, l[4] = d * L + f * G + h * _e, l[7] = d * F + f * q + h * Le, l[2] = S * m + R * W + _ * fe, l[5] = S * L + R * G + _ * _e, l[8] = S * F + R * q + _ * Le, this;
  }
  multiplyScalar(e) {
    const s = this.elements;
    return s[0] *= e, s[3] *= e, s[6] *= e, s[1] *= e, s[4] *= e, s[7] *= e, s[2] *= e, s[5] *= e, s[8] *= e, this;
  }
  determinant() {
    const e = this.elements, s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], E = e[6], d = e[7], f = e[8];
    return s * u * f - s * c * d - o * l * f + o * c * E + a * l * d - a * u * E;
  }
  invert() {
    const e = this.elements, s = e[0], o = e[1], a = e[2], l = e[3], u = e[4], c = e[5], E = e[6], d = e[7], f = e[8], h = f * u - c * d, S = c * E - f * l, R = d * l - u * E, _ = s * h + o * S + a * R;
    if (_ === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const m = 1 / _;
    return e[0] = h * m, e[1] = (a * d - f * o) * m, e[2] = (c * o - a * u) * m, e[3] = S * m, e[4] = (f * s - a * E) * m, e[5] = (a * l - c * s) * m, e[6] = R * m, e[7] = (o * E - d * s) * m, e[8] = (u * s - o * l) * m, this;
  }
  transpose() {
    let e;
    const s = this.elements;
    return e = s[1], s[1] = s[3], s[3] = e, e = s[2], s[2] = s[6], s[6] = e, e = s[5], s[5] = s[7], s[7] = e, this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    const s = this.elements;
    return e[0] = s[0], e[1] = s[3], e[2] = s[6], e[3] = s[1], e[4] = s[4], e[5] = s[7], e[6] = s[2], e[7] = s[5], e[8] = s[8], this;
  }
  setUvTransform(e, s, o, a, l, u, c) {
    const E = Math.cos(l), d = Math.sin(l);
    return this.set(
      o * E,
      o * d,
      -o * (E * u + d * c) + u + e,
      -a * d,
      a * E,
      -a * (-d * u + E * c) + c + s,
      0,
      0,
      1
    ), this;
  }
  //
  scale(e, s) {
    return this.premultiply(_m3.makeScale(e, s)), this;
  }
  rotate(e) {
    return this.premultiply(_m3.makeRotation(-e)), this;
  }
  translate(e, s) {
    return this.premultiply(_m3.makeTranslation(e, s)), this;
  }
  // for 2D Transforms
  makeTranslation(e, s) {
    return e.isVector2 ? this.set(
      1,
      0,
      e.x,
      0,
      1,
      e.y,
      0,
      0,
      1
    ) : this.set(
      1,
      0,
      e,
      0,
      1,
      s,
      0,
      0,
      1
    ), this;
  }
  makeRotation(e) {
    const s = Math.cos(e), o = Math.sin(e);
    return this.set(
      s,
      -o,
      0,
      o,
      s,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, s) {
    return this.set(
      e,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      1
    ), this;
  }
  //
  equals(e) {
    const s = this.elements, o = e.elements;
    for (let a = 0; a < 9; a++)
      if (s[a] !== o[a])
        return !1;
    return !0;
  }
  fromArray(e, s = 0) {
    for (let o = 0; o < 9; o++)
      this.elements[o] = e[o + s];
    return this;
  }
  toArray(e = [], s = 0) {
    const o = this.elements;
    return e[s] = o[0], e[s + 1] = o[1], e[s + 2] = o[2], e[s + 3] = o[3], e[s + 4] = o[4], e[s + 5] = o[5], e[s + 6] = o[6], e[s + 7] = o[7], e[s + 8] = o[8], e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
const _m3 = /* @__PURE__ */ new Matrix3();
class Quaternion {
  constructor(e = 0, s = 0, o = 0, a = 1) {
    this.isQuaternion = !0, this._x = e, this._y = s, this._z = o, this._w = a;
  }
  static slerpFlat(e, s, o, a, l, u, c) {
    let E = o[a + 0], d = o[a + 1], f = o[a + 2], h = o[a + 3];
    const S = l[u + 0], R = l[u + 1], _ = l[u + 2], m = l[u + 3];
    if (c === 0) {
      e[s + 0] = E, e[s + 1] = d, e[s + 2] = f, e[s + 3] = h;
      return;
    }
    if (c === 1) {
      e[s + 0] = S, e[s + 1] = R, e[s + 2] = _, e[s + 3] = m;
      return;
    }
    if (h !== m || E !== S || d !== R || f !== _) {
      let L = 1 - c;
      const F = E * S + d * R + f * _ + h * m, W = F >= 0 ? 1 : -1, G = 1 - F * F;
      if (G > Number.EPSILON) {
        const fe = Math.sqrt(G), _e = Math.atan2(fe, F * W);
        L = Math.sin(L * _e) / fe, c = Math.sin(c * _e) / fe;
      }
      const q = c * W;
      if (E = E * L + S * q, d = d * L + R * q, f = f * L + _ * q, h = h * L + m * q, L === 1 - c) {
        const fe = 1 / Math.sqrt(E * E + d * d + f * f + h * h);
        E *= fe, d *= fe, f *= fe, h *= fe;
      }
    }
    e[s] = E, e[s + 1] = d, e[s + 2] = f, e[s + 3] = h;
  }
  static multiplyQuaternionsFlat(e, s, o, a, l, u) {
    const c = o[a], E = o[a + 1], d = o[a + 2], f = o[a + 3], h = l[u], S = l[u + 1], R = l[u + 2], _ = l[u + 3];
    return e[s] = c * _ + f * h + E * R - d * S, e[s + 1] = E * _ + f * S + d * h - c * R, e[s + 2] = d * _ + f * R + c * S - E * h, e[s + 3] = f * _ - c * h - E * S - d * R, e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  set(e, s, o, a) {
    return this._x = e, this._y = s, this._z = o, this._w = a, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  setFromEuler(e, s) {
    const o = e._x, a = e._y, l = e._z, u = e._order, c = Math.cos, E = Math.sin, d = c(o / 2), f = c(a / 2), h = c(l / 2), S = E(o / 2), R = E(a / 2), _ = E(l / 2);
    switch (u) {
      case "XYZ":
        this._x = S * f * h + d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "YXZ":
        this._x = S * f * h + d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h + S * R * _;
        break;
      case "ZXY":
        this._x = S * f * h - d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "ZYX":
        this._x = S * f * h - d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h + S * R * _;
        break;
      case "YZX":
        this._x = S * f * h + d * R * _, this._y = d * R * h + S * f * _, this._z = d * f * _ - S * R * h, this._w = d * f * h - S * R * _;
        break;
      case "XZY":
        this._x = S * f * h - d * R * _, this._y = d * R * h - S * f * _, this._z = d * f * _ + S * R * h, this._w = d * f * h + S * R * _;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + u);
    }
    return s !== !1 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(e, s) {
    const o = s / 2, a = Math.sin(o);
    return this._x = e.x * a, this._y = e.y * a, this._z = e.z * a, this._w = Math.cos(o), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e) {
    const s = e.elements, o = s[0], a = s[4], l = s[8], u = s[1], c = s[5], E = s[9], d = s[2], f = s[6], h = s[10], S = o + c + h;
    if (S > 0) {
      const R = 0.5 / Math.sqrt(S + 1);
      this._w = 0.25 / R, this._x = (f - E) * R, this._y = (l - d) * R, this._z = (u - a) * R;
    } else if (o > c && o > h) {
      const R = 2 * Math.sqrt(1 + o - c - h);
      this._w = (f - E) / R, this._x = 0.25 * R, this._y = (a + u) / R, this._z = (l + d) / R;
    } else if (c > h) {
      const R = 2 * Math.sqrt(1 + c - o - h);
      this._w = (l - d) / R, this._x = (a + u) / R, this._y = 0.25 * R, this._z = (E + f) / R;
    } else {
      const R = 2 * Math.sqrt(1 + h - o - c);
      this._w = (u - a) / R, this._x = (l + d) / R, this._y = (E + f) / R, this._z = 0.25 * R;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(e, s) {
    let o = e.dot(s) + 1;
    return o < Number.EPSILON ? (o = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = o) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = o)) : (this._x = e.y * s.z - e.z * s.y, this._y = e.z * s.x - e.x * s.z, this._z = e.x * s.y - e.y * s.x, this._w = o), this.normalize();
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(clamp(this.dot(e), -1, 1)));
  }
  rotateTowards(e, s) {
    const o = this.angleTo(e);
    if (o === 0)
      return this;
    const a = Math.min(1, s / o);
    return this.slerp(e, a), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, s) {
    const o = e._x, a = e._y, l = e._z, u = e._w, c = s._x, E = s._y, d = s._z, f = s._w;
    return this._x = o * f + u * c + a * d - l * E, this._y = a * f + u * E + l * c - o * d, this._z = l * f + u * d + o * E - a * c, this._w = u * f - o * c - a * E - l * d, this._onChangeCallback(), this;
  }
  slerp(e, s) {
    if (s === 0)
      return this;
    if (s === 1)
      return this.copy(e);
    const o = this._x, a = this._y, l = this._z, u = this._w;
    let c = u * e._w + o * e._x + a * e._y + l * e._z;
    if (c < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, c = -c) : this.copy(e), c >= 1)
      return this._w = u, this._x = o, this._y = a, this._z = l, this;
    const E = 1 - c * c;
    if (E <= Number.EPSILON) {
      const R = 1 - s;
      return this._w = R * u + s * this._w, this._x = R * o + s * this._x, this._y = R * a + s * this._y, this._z = R * l + s * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    const d = Math.sqrt(E), f = Math.atan2(d, c), h = Math.sin((1 - s) * f) / d, S = Math.sin(s * f) / d;
    return this._w = u * h + this._w * S, this._x = o * h + this._x * S, this._y = a * h + this._y * S, this._z = l * h + this._z * S, this._onChangeCallback(), this;
  }
  slerpQuaternions(e, s, o) {
    return this.copy(e).slerp(s, o);
  }
  random() {
    const e = Math.random(), s = Math.sqrt(1 - e), o = Math.sqrt(e), a = 2 * Math.PI * Math.random(), l = 2 * Math.PI * Math.random();
    return this.set(
      s * Math.cos(a),
      o * Math.sin(l),
      o * Math.cos(l),
      s * Math.sin(a)
    );
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, s = 0) {
    return this._x = e[s], this._y = e[s + 1], this._z = e[s + 2], this._w = e[s + 3], this._onChangeCallback(), this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this._x, e[s + 1] = this._y, e[s + 2] = this._z, e[s + 3] = this._w, e;
  }
  fromBufferAttribute(e, s) {
    return this._x = e.getX(s), this._y = e.getY(s), this._z = e.getZ(s), this._w = e.getW(s), this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class Vector3 {
  constructor(e = 0, s = 0, o = 0) {
    Vector3.prototype.isVector3 = !0, this.x = e, this.y = s, this.z = o;
  }
  set(e, s, o) {
    return o === void 0 && (o = this.z), this.x = e, this.y = s, this.z = o, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setComponent(e, s) {
    switch (e) {
      case 0:
        this.x = s;
        break;
      case 1:
        this.y = s;
        break;
      case 2:
        this.z = s;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  add(e) {
    return this.x += e.x, this.y += e.y, this.z += e.z, this;
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  addVectors(e, s) {
    return this.x = e.x + s.x, this.y = e.y + s.y, this.z = e.z + s.z, this;
  }
  addScaledVector(e, s) {
    return this.x += e.x * s, this.y += e.y * s, this.z += e.z * s, this;
  }
  sub(e) {
    return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  subVectors(e, s) {
    return this.x = e.x - s.x, this.y = e.y - s.y, this.z = e.z - s.z, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  multiplyVectors(e, s) {
    return this.x = e.x * s.x, this.y = e.y * s.y, this.z = e.z * s.z, this;
  }
  applyEuler(e) {
    return this.applyQuaternion(_quaternion$4.setFromEuler(e));
  }
  applyAxisAngle(e, s) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(e, s));
  }
  applyMatrix3(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements;
    return this.x = l[0] * s + l[3] * o + l[6] * a, this.y = l[1] * s + l[4] * o + l[7] * a, this.z = l[2] * s + l[5] * o + l[8] * a, this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements, u = 1 / (l[3] * s + l[7] * o + l[11] * a + l[15]);
    return this.x = (l[0] * s + l[4] * o + l[8] * a + l[12]) * u, this.y = (l[1] * s + l[5] * o + l[9] * a + l[13]) * u, this.z = (l[2] * s + l[6] * o + l[10] * a + l[14]) * u, this;
  }
  applyQuaternion(e) {
    const s = this.x, o = this.y, a = this.z, l = e.x, u = e.y, c = e.z, E = e.w, d = E * s + u * a - c * o, f = E * o + c * s - l * a, h = E * a + l * o - u * s, S = -l * s - u * o - c * a;
    return this.x = d * E + S * -l + f * -c - h * -u, this.y = f * E + S * -u + h * -l - d * -c, this.z = h * E + S * -c + d * -u - f * -l, this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    const s = this.x, o = this.y, a = this.z, l = e.elements;
    return this.x = l[0] * s + l[4] * o + l[8] * a, this.y = l[1] * s + l[5] * o + l[9] * a, this.z = l[2] * s + l[6] * o + l[10] * a, this.normalize();
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  clamp(e, s) {
    return this.x = Math.max(e.x, Math.min(s.x, this.x)), this.y = Math.max(e.y, Math.min(s.y, this.y)), this.z = Math.max(e.z, Math.min(s.z, this.z)), this;
  }
  clampScalar(e, s) {
    return this.x = Math.max(e, Math.min(s, this.x)), this.y = Math.max(e, Math.min(s, this.y)), this.z = Math.max(e, Math.min(s, this.z)), this;
  }
  clampLength(e, s) {
    const o = this.length();
    return this.divideScalar(o || 1).multiplyScalar(Math.max(e, Math.min(s, o)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, s) {
    return this.x += (e.x - this.x) * s, this.y += (e.y - this.y) * s, this.z += (e.z - this.z) * s, this;
  }
  lerpVectors(e, s, o) {
    return this.x = e.x + (s.x - e.x) * o, this.y = e.y + (s.y - e.y) * o, this.z = e.z + (s.z - e.z) * o, this;
  }
  cross(e) {
    return this.crossVectors(this, e);
  }
  crossVectors(e, s) {
    const o = e.x, a = e.y, l = e.z, u = s.x, c = s.y, E = s.z;
    return this.x = a * E - l * c, this.y = l * u - o * E, this.z = o * c - a * u, this;
  }
  projectOnVector(e) {
    const s = e.lengthSq();
    if (s === 0)
      return this.set(0, 0, 0);
    const o = e.dot(this) / s;
    return this.copy(e).multiplyScalar(o);
  }
  projectOnPlane(e) {
    return _vector$b.copy(this).projectOnVector(e), this.sub(_vector$b);
  }
  reflect(e) {
    return this.sub(_vector$b.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  angleTo(e) {
    const s = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (s === 0)
      return Math.PI / 2;
    const o = this.dot(e) / s;
    return Math.acos(clamp(o, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const s = this.x - e.x, o = this.y - e.y, a = this.z - e.z;
    return s * s + o * o + a * a;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, s, o) {
    const a = Math.sin(s) * e;
    return this.x = a * Math.sin(o), this.y = Math.cos(s) * e, this.z = a * Math.cos(o), this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, s, o) {
    return this.x = e * Math.sin(s), this.y = o, this.z = e * Math.cos(s), this;
  }
  setFromMatrixPosition(e) {
    const s = e.elements;
    return this.x = s[12], this.y = s[13], this.z = s[14], this;
  }
  setFromMatrixScale(e) {
    const s = this.setFromMatrixColumn(e, 0).length(), o = this.setFromMatrixColumn(e, 1).length(), a = this.setFromMatrixColumn(e, 2).length();
    return this.x = s, this.y = o, this.z = a, this;
  }
  setFromMatrixColumn(e, s) {
    return this.fromArray(e.elements, s * 4);
  }
  setFromMatrix3Column(e, s) {
    return this.fromArray(e.elements, s * 3);
  }
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  setFromColor(e) {
    return this.x = e.r, this.y = e.g, this.z = e.b, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, s = 0) {
    return this.x = e[s], this.y = e[s + 1], this.z = e[s + 2], this;
  }
  toArray(e = [], s = 0) {
    return e[s] = this.x, e[s + 1] = this.y, e[s + 2] = this.z, e;
  }
  fromBufferAttribute(e, s) {
    return this.x = e.getX(s), this.y = e.getY(s), this.z = e.getZ(s), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const e = (Math.random() - 0.5) * 2, s = Math.random() * Math.PI * 2, o = Math.sqrt(1 - e ** 2);
    return this.x = o * Math.cos(s), this.y = o * Math.sin(s), this.z = e, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const _vector$b = /* @__PURE__ */ new Vector3(), _quaternion$4 = /* @__PURE__ */ new Quaternion();
class Box3 {
  constructor(e = new Vector3(1 / 0, 1 / 0, 1 / 0), s = new Vector3(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = s;
  }
  set(e, s) {
    return this.min.copy(e), this.max.copy(s), this;
  }
  setFromArray(e) {
    this.makeEmpty();
    for (let s = 0, o = e.length; s < o; s += 3)
      this.expandByPoint(_vector$a.fromArray(e, s));
    return this;
  }
  setFromBufferAttribute(e) {
    this.makeEmpty();
    for (let s = 0, o = e.count; s < o; s++)
      this.expandByPoint(_vector$a.fromBufferAttribute(e, s));
    return this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let s = 0, o = e.length; s < o; s++)
      this.expandByPoint(e[s]);
    return this;
  }
  setFromCenterAndSize(e, s) {
    const o = _vector$a.copy(s).multiplyScalar(0.5);
    return this.min.copy(e).sub(o), this.max.copy(e).add(o), this;
  }
  setFromObject(e, s = !1) {
    return this.makeEmpty(), this.expandByObject(e, s);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  expandByObject(e, s = !1) {
    if (e.updateWorldMatrix(!1, !1), e.boundingBox !== void 0)
      e.boundingBox === null && e.computeBoundingBox(), _box$3.copy(e.boundingBox), _box$3.applyMatrix4(e.matrixWorld), this.union(_box$3);
    else {
      const a = e.geometry;
      if (a !== void 0)
        if (s && a.attributes !== void 0 && a.attributes.position !== void 0) {
          const l = a.attributes.position;
          for (let u = 0, c = l.count; u < c; u++)
            _vector$a.fromBufferAttribute(l, u).applyMatrix4(e.matrixWorld), this.expandByPoint(_vector$a);
        } else
          a.boundingBox === null && a.computeBoundingBox(), _box$3.copy(a.boundingBox), _box$3.applyMatrix4(e.matrixWorld), this.union(_box$3);
    }
    const o = e.children;
    for (let a = 0, l = o.length; a < l; a++)
      this.expandByObject(o[a], s);
    return this;
  }
  containsPoint(e) {
    return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, s) {
    return s.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(e) {
    return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
  }
  intersectsSphere(e) {
    return this.clampPoint(e.center, _vector$a), _vector$a.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let s, o;
    return e.normal.x > 0 ? (s = e.normal.x * this.min.x, o = e.normal.x * this.max.x) : (s = e.normal.x * this.max.x, o = e.normal.x * this.min.x), e.normal.y > 0 ? (s += e.normal.y * this.min.y, o += e.normal.y * this.max.y) : (s += e.normal.y * this.max.y, o += e.normal.y * this.min.y), e.normal.z > 0 ? (s += e.normal.z * this.min.z, o += e.normal.z * this.max.z) : (s += e.normal.z * this.max.z, o += e.normal.z * this.min.z), s <= -e.constant && o >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(_center), _extents.subVectors(this.max, _center), _v0$2.subVectors(e.a, _center), _v1$7.subVectors(e.b, _center), _v2$4.subVectors(e.c, _center), _f0.subVectors(_v1$7, _v0$2), _f1.subVectors(_v2$4, _v1$7), _f2.subVectors(_v0$2, _v2$4);
    let s = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    return !satForAxes(s, _v0$2, _v1$7, _v2$4, _extents) || (s = [1, 0, 0, 0, 1, 0, 0, 0, 1], !satForAxes(s, _v0$2, _v1$7, _v2$4, _extents)) ? !1 : (_triangleNormal.crossVectors(_f0, _f1), s = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z], satForAxes(s, _v0$2, _v1$7, _v2$4, _extents));
  }
  clampPoint(e, s) {
    return s.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return this.clampPoint(e, _vector$a).distanceTo(e);
  }
  getBoundingSphere(e) {
    return this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), e.radius = this.getSize(_vector$a).length() * 0.5), e;
  }
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  applyMatrix4(e) {
    return this.isEmpty() ? this : (_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(_points), this);
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const _points = [
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3(),
  /* @__PURE__ */ new Vector3()
], _vector$a = /* @__PURE__ */ new Vector3(), _box$3 = /* @__PURE__ */ new Box3(), _v0$2 = /* @__PURE__ */ new Vector3(), _v1$7 = /* @__PURE__ */ new Vector3(), _v2$4 = /* @__PURE__ */ new Vector3(), _f0 = /* @__PURE__ */ new Vector3(), _f1 = /* @__PURE__ */ new Vector3(), _f2 = /* @__PURE__ */ new Vector3(), _center = /* @__PURE__ */ new Vector3(), _extents = /* @__PURE__ */ new Vector3(), _triangleNormal = /* @__PURE__ */ new Vector3(), _testAxis = /* @__PURE__ */ new Vector3();
function satForAxes(r, e, s, o, a) {
  for (let l = 0, u = r.length - 3; l <= u; l += 3) {
    _testAxis.fromArray(r, l);
    const c = a.x * Math.abs(_testAxis.x) + a.y * Math.abs(_testAxis.y) + a.z * Math.abs(_testAxis.z), E = e.dot(_testAxis), d = s.dot(_testAxis), f = o.dot(_testAxis);
    if (Math.max(-Math.max(E, d, f), Math.min(E, d, f)) > c)
      return !1;
  }
  return !0;
}
const _box$2 = /* @__PURE__ */ new Box3(), _v1$6 = /* @__PURE__ */ new Vector3(), _v2$3 = /* @__PURE__ */ new Vector3();
class Sphere {
  constructor(e = new Vector3(), s = -1) {
    this.center = e, this.radius = s;
  }
  set(e, s) {
    return this.center.copy(e), this.radius = s, this;
  }
  setFromPoints(e, s) {
    const o = this.center;
    s !== void 0 ? o.copy(s) : _box$2.setFromPoints(e).getCenter(o);
    let a = 0;
    for (let l = 0, u = e.length; l < u; l++)
      a = Math.max(a, o.distanceToSquared(e[l]));
    return this.radius = Math.sqrt(a), this;
  }
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    const s = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= s * s;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, s) {
    const o = this.center.distanceToSquared(e);
    return s.copy(e), o > this.radius * this.radius && (s.sub(this.center).normalize(), s.multiplyScalar(this.radius).add(this.center)), s;
  }
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  translate(e) {
    return this.center.add(e), this;
  }
  expandByPoint(e) {
    if (this.isEmpty())
      return this.center.copy(e), this.radius = 0, this;
    _v1$6.subVectors(e, this.center);
    const s = _v1$6.lengthSq();
    if (s > this.radius * this.radius) {
      const o = Math.sqrt(s), a = (o - this.radius) * 0.5;
      this.center.addScaledVector(_v1$6, a / o), this.radius += a;
    }
    return this;
  }
  union(e) {
    return e.isEmpty() ? this : this.isEmpty() ? (this.copy(e), this) : (this.center.equals(e.center) === !0 ? this.radius = Math.max(this.radius, e.radius) : (_v2$3.subVectors(e.center, this.center).setLength(e.radius), this.expandByPoint(_v1$6.copy(e.center).add(_v2$3)), this.expandByPoint(_v1$6.copy(e.center).sub(_v2$3))), this);
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: REVISION
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = REVISION);
class Cartographic {
  /**
   * Constructs a new Cartographic coordinate.
   *
   * @param longitude Longitude, defaults to 0
   * @param latitude Latitude, defaults to 0
   * @param height Height, defaults to 0
   */
  constructor(e = 0, s = 0, o = 0) {
    this.longitude = 0, this.latitude = 0, this.height = 0, this.longitude = e, this.latitude = s, this.height = o;
  }
  /**
   * Sets all the fields of the cartographic position and returns a reference to this.
   *
   * @param longitude
   * @param latitude
   * @param height
   */
  set(e = 0, s = 0, o = 0) {
    return this.longitude = e, this.latitude = s, this.height = o, this;
  }
  /**
   * Sets the longitude of this to the provided value, returning this for chaining.
   *
   * @param longitude Longitude in radians
   * @returns
   */
  setLongitude(e) {
    return this.longitude = e, this;
  }
  /**
   * Sets the latitude of this to the provided value, returning this for chaining.
   *
   * @param latitude Geodetic latitude in radians
   * @returns
   */
  setLatitude(e) {
    return this.latitude = e, this;
  }
  /**
   * Sets the height of this to the provided value, returning this for chaining.
   *
   * @param height Height in meters
   * @returns
   */
  setHeight(e) {
    return this.height = e, this;
  }
  /**
   * Returns true if 'this' position exactly equals the 'other' position. This uses direct floating point equals
   * comparison without any epsilon.
   *
   * @param other
   * @returns
   */
  equals(e) {
    return this.longitude === e.longitude && this.latitude === e.latitude && this.height === e.height;
  }
  /**
   * Returns true if 'this' position exactly equals the 'other' position, within the given range 'epsilon'.
   *
   * Sometimes an 'epsilon' is needed in floating point comparisons as numerical error and limited precision means
   * that some operations will produce slightly incorrect results. e.g. Using strict equality for '1.1 - 0.9 == 0.2'
   * will return false under IEE754 FP64. An epsilon adds an 'allowed error' to catch these kinds of errors.
   *
   * @param other
   * @param epsilon
   * @returns
   */
  equalsEpsilon(e, s) {
    return Math.abs(this.longitude - e.longitude) <= s && Math.abs(this.latitude - e.latitude) <= s && Math.abs(this.height - e.height) <= s;
  }
  /**
   * Get a new Cartographic instance with longitude, latitude and height copied from this.
   *
   * @returns
   */
  clone() {
    return new Cartographic().copy(this);
  }
  /**
   * Copies the longitude, latitude and height from the other Cartographic into this.
   *
   * Returns a reference to this for chaining.
   *
   * @param other
   * @returns
   */
  copy(e) {
    return this.set(e.longitude, e.latitude, e.height);
  }
}
class Ellipsoid {
  /**
   * Constructs a new ellipsoid instance with the provided radii parameters.
   *
   * @param x The radius along the X-axis
   * @param y The radius along the Y-axis
   * @param z The radius along the Z-axis
   */
  constructor(e, s, o) {
    this._radii = new Vector3(e, s, o), this._radiiSquared = this._radii.clone().multiply(this._radii), this._oneOverRadii = new Vector3(1 / e, 1 / s, 1 / o), this._oneOverRadiiSquared = new Vector3(1 / (e * e), 1 / (s * s), 1 / (o * o)), this._radiiToTheFourth = this._radiiSquared.clone().multiply(this._radiiSquared), this._minimumRadius = Math.min(e, s, o), this._maximumRadius = Math.max(e, s, o);
  }
  /**
   * Computes the geocentric normal, given a WGS 84 position on the surface of the ellipsoid.
   *
   * @param position WGS 84 position on the surface of the ellipsoid
   * @param result Vector to write the result into
   * @returns
   */
  geocentricSurfaceNormalForPosition(e, s = new Vector3()) {
    return s.copy(e).normalize();
  }
  /**
   * Computes the geodetic normal, given a WGS 84 position on the surface of the ellipsoid.
   *
   * @param position WGS 84 position on the surface of the ellipsoid
   * @param result Vector to write the result into
   * @returns
   */
  geodeticSurfaceNormalForPosition(e, s = new Vector3()) {
    return s.copy(e).multiply(this._oneOverRadiiSquared).normalize();
  }
  /**
   * Computes the geodetic surface normal for the provided cartographic position.
   *
   * @param position Cartographic position to sample the normal for
   * @param result Vector to write the result into
   * @returns
   */
  geodeticSurfaceNormalForCartographic(e, s = new Vector3()) {
    const o = Math.cos(e.latitude);
    return s.set(o * Math.cos(e.longitude), o * Math.sin(e.longitude), Math.sin(e.latitude));
  }
  /**
   * Computes the cartographic position that corresponds to the provided position on the surface of the ellipsoid.
   *
   * Will not return useful results of 'position' does not lie on the surface of the ellipsoid.
   *
   * @param position Cartesian position on surface of ellipsoid to compute the cartographic position of
   * @param result Value to write the result into
   * @returns
   */
  cartographicForPositionOnSurface(e, s = new Cartographic()) {
    const o = this.geodeticSurfaceNormalForPosition(e);
    return s.longitude = Math.atan2(o.y, o.x), s.latitude = Math.asin(o.z / o.length()), s;
  }
  /**
   * Computes the cartographic position and height for the provided cartesian position.
   *
   * This uses an iterative root finding process that behaves poorly if the point is too close to the center of the ellipsoid.
   *
   * @param position
   * @param result The object onto which to store the result.
   * @returns
   */
  cartographicForPosition(e, s = new Cartographic()) {
    const o = this.scaleToGeodeticSurface(e), a = e.clone().sub(o);
    return this.cartographicForPositionOnSurface(o, s), s.height = Math.sign(a.dot(e)) * a.length(), s;
  }
  /**
   * Produces a cartesian position around the ellipsoid for the provided cartographic position.
   *
   * @param cartographic
   * @param result The object onto which to store the result.
   * @returns
   */
  cartesianForCartographic(e, s = new Vector3()) {
    const o = this.geodeticSurfaceNormalForCartographic(e), a = o.clone().multiply(this._radiiSquared), l = Math.sqrt(o.dot(a));
    return a.divideScalar(l), o.multiplyScalar(e.height), s.copy(a).add(o);
  }
  /**
   * Scales the provided Cartesian position along the geodetic surface normal so that it is on the surface of this
   * ellipsoid.
   *
   * This uses an iterative root finding process that behaves poorly if the point is too close to the center of the ellipsoid.
   *
   * @param position The position position to scale.
   * @param result The object onto which to store the result.
   * @returns
   */
  scaleToGeodeticSurface(e, s = new Vector3()) {
    const o = 1 / Math.sqrt(e.x * e.x * this._oneOverRadiiSquared.x + e.y * e.y * this._oneOverRadiiSquared.y + e.z * e.z * this._oneOverRadiiSquared.z), a = new Vector3(o * e.x * this._oneOverRadiiSquared.x, o * e.y * this._oneOverRadiiSquared.y, o * e.z * this._oneOverRadiiSquared.z).length();
    let l = (1 - o) * (e.length() / a);
    const u = e.x * e.x, c = e.y * e.y, E = e.z * e.z;
    let d = 0, f = 0, h = 0, S = 0, R = 1, _ = 32;
    do {
      l -= S / R, d = 1 + l * this._oneOverRadiiSquared.x, f = 1 + l * this._oneOverRadiiSquared.y, h = 1 + l * this._oneOverRadiiSquared.z;
      const m = d * d, L = f * f, F = h * h, W = d * m, G = f * L, q = h * F;
      S = u / (this._radiiSquared.x * m) + c / (this._radiiSquared.y * L) + E / (this._radiiSquared.z * F) - 1, R = -2 * (u / (this._radiiToTheFourth.x * W) + c / (this._radiiToTheFourth.y * G) + E / (this._radiiToTheFourth.z * q));
    } while (Math.abs(S) > 1e-10 && _-- >= 0);
    return s.set(e.x / d, e.y / f, e.z / h);
  }
  /**
   * Scales the cartesian position along the geocentric normal to produce a point on the surface of the ellipsoid.
   *
   * @param position The position to scale
   * @param result The value to write the result into
   * @returns
   */
  scaleToGeocentricSurface(e, s = new Vector3()) {
    const o = 1 / Math.sqrt(e.x * e.x * this._oneOverRadiiSquared.x + e.y * e.y * this._oneOverRadiiSquared.y + e.z * e.z * this._oneOverRadiiSquared.z);
    return s.copy(e).multiplyScalar(o);
  }
  /**
   * Constructs a rotational matrix from the basis vectors sampled from the surface of the ellipsoid at the provided
   * cartographic position.
   *
   * Constructs a TBN (tangent, bitangent, normal) matrix by sampling the normal and tangent analytically and
   * reconstructing the bi-tangent as the cross product of the tangent and normal to produce the full basis.
   *
   * The x axis is the tangent.
   * The y axis is the normal.
   * The z axis is the bitangent.
   *
   * @param position
   * @param result
   * @param normal
   * @param tangent
   * @param bitangent
   * @returns
   */
  rotationBasisForCartographic(e, s = new Matrix3(), o = new Vector3(), a = new Vector3(), l = new Vector3()) {
    this.geodeticSurfaceNormalForCartographic(e, o);
    const u = this.geodeticSurfaceNormalForCartographic(e.clone().setLatitude(e.latitude - 0.01));
    return l.copy(o).cross(u).normalize(), a.copy(o).cross(l).normalize(), s !== null && (s.elements[0] = a.x, s.elements[1] = a.y, s.elements[2] = a.z, s.elements[3] = o.x, s.elements[4] = o.y, s.elements[5] = o.z, s.elements[6] = l.x, s.elements[7] = l.y, s.elements[8] = l.z), s;
  }
  /**
   * Calculates an approximate bounding sphere for the given spheroid patch.
   *
   * The resulting bounding sphere is not guaranteed to contain the entire surface of the ellipsoid. This is only
   * because I have not yet proven that it contains the whole surface patch. Until I have this will be marked as
   * approximate.
   *
   * @param min The minimum long/lat pair of the patch to get the bounding sphere of
   * @param max The maximum long/lat pair of the patch to get the bounding sphere of
   * @returns
   */
  approximateBoundingSphereForRegion(e, s) {
    const o = (e.longitude + s.longitude) / 2, a = (e.latitude + s.latitude) / 2, l = new Cartographic(), u = [
      this.cartesianForCartographic(l.set(e.longitude, e.latitude)),
      this.cartesianForCartographic(l.set(s.longitude, s.latitude)),
      this.cartesianForCartographic(l.set(s.longitude, e.latitude)),
      this.cartesianForCartographic(l.set(e.longitude, s.latitude)),
      this.cartesianForCartographic(l.set(o, a)),
      this.cartesianForCartographic(l.set(e.longitude, a)),
      this.cartesianForCartographic(l.set(s.longitude, a)),
      this.cartesianForCartographic(l.set(o, e.latitude)),
      this.cartesianForCartographic(l.set(o, s.latitude))
    ], c = new Vector3();
    for (const f of u)
      c.add(f);
    c.divideScalar(u.length);
    const E = new Vector3();
    let d = 0;
    for (const f of u) {
      const h = E.copy(c).sub(f).length();
      d = Math.max(d, h);
    }
    return new Sphere(c, d);
  }
  /**
   * Get a new Vector3 instance that contains the radii of the ellipsoid along each axis.
   *
   * @returns
   */
  get radii() {
    return this._radii.clone();
  }
  /**
   * Get a new Vector3 instance that contains the radii^2 of the ellipsoid along each axis.
   *
   * @returns
   */
  get radiiSquared() {
    return this._radiiSquared.clone();
  }
  /**
   * Get a new Vector3 instance that contains the 1/radii of the ellipsoid along each axis.
   *
   * @returns
   */
  get oneOverRadii() {
    return this._oneOverRadii.clone();
  }
  /**
   * Get a new Vector3 instance that contains the 1/radii^2 of the ellipsoid along each axis.
   *
   * @returns
   */
  get oneOverRadiiSquared() {
    return this._oneOverRadiiSquared.clone();
  }
  /**
   * Get a new Vector3 instance that contains the radii^4 of the ellipsoid along each axis.
   *
   * @returns
   */
  get radiiToTheFourth() {
    return this._radiiToTheFourth.clone();
  }
  /**
   * Get the minimum of the ellipsoid.
   *
   * @returns
   */
  get minimumRadius() {
    return this._minimumRadius;
  }
  /**
   * Get the maximum of the ellipsoid.
   *
   * @returns
   */
  get maximumRadius() {
    return this._maximumRadius;
  }
}
Ellipsoid.WGS_84 = new Ellipsoid(6378137, 6378137, 6356752314245e-6);
Ellipsoid.SCALED_WGS_84 = new Ellipsoid(1, 1, 6356752314245e-6 / 6378137);
function globals(r) {
  r("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), r("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), r("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
  for (var e = 1; e <= 60; ++e)
    r("EPSG:" + (32600 + e), "+proj=utm +zone=" + e + " +datum=WGS84 +units=m"), r("EPSG:" + (32700 + e), "+proj=utm +zone=" + e + " +south +datum=WGS84 +units=m");
  r.WGS84 = r["EPSG:4326"], r["EPSG:3785"] = r["EPSG:3857"], r.GOOGLE = r["EPSG:3857"], r["EPSG:900913"] = r["EPSG:3857"], r["EPSG:102113"] = r["EPSG:3857"];
}
var PJD_3PARAM = 1, PJD_7PARAM = 2, PJD_GRIDSHIFT = 3, PJD_WGS84 = 4, PJD_NODATUM = 5, SRS_WGS84_SEMIMAJOR = 6378137, SRS_WGS84_SEMIMINOR = 6356752314e-3, SRS_WGS84_ESQUARED = 0.0066943799901413165, SEC_TO_RAD = 484813681109536e-20, HALF_PI = Math.PI / 2, SIXTH = 0.16666666666666666, RA4 = 0.04722222222222222, RA6 = 0.022156084656084655, EPSLN = 1e-10, D2R$1 = 0.017453292519943295, R2D = 57.29577951308232, FORTPI = Math.PI / 4, TWO_PI = Math.PI * 2, SPI = 3.14159265359, primeMeridian = {};
primeMeridian.greenwich = 0;
primeMeridian.lisbon = -9.131906111111;
primeMeridian.paris = 2.337229166667;
primeMeridian.bogota = -74.080916666667;
primeMeridian.madrid = -3.687938888889;
primeMeridian.rome = 12.452333333333;
primeMeridian.bern = 7.439583333333;
primeMeridian.jakarta = 106.807719444444;
primeMeridian.ferro = -17.666666666667;
primeMeridian.brussels = 4.367975;
primeMeridian.stockholm = 18.058277777778;
primeMeridian.athens = 23.7163375;
primeMeridian.oslo = 10.722916666667;
const units = {
  mm: { to_meter: 1e-3 },
  cm: { to_meter: 0.01 },
  ft: { to_meter: 0.3048 },
  "us-ft": { to_meter: 1200 / 3937 },
  fath: { to_meter: 1.8288 },
  kmi: { to_meter: 1852 },
  "us-ch": { to_meter: 20.1168402336805 },
  "us-mi": { to_meter: 1609.34721869444 },
  km: { to_meter: 1e3 },
  "ind-ft": { to_meter: 0.30479841 },
  "ind-yd": { to_meter: 0.91439523 },
  mi: { to_meter: 1609.344 },
  yd: { to_meter: 0.9144 },
  ch: { to_meter: 20.1168 },
  link: { to_meter: 0.201168 },
  dm: { to_meter: 0.1 },
  in: { to_meter: 0.0254 },
  "ind-ch": { to_meter: 20.11669506 },
  "us-in": { to_meter: 0.025400050800101 },
  "us-yd": { to_meter: 0.914401828803658 }
};
var ignoredChar = /[\s_\-\/\(\)]/g;
function match(r, e) {
  if (r[e])
    return r[e];
  for (var s = Object.keys(r), o = e.toLowerCase().replace(ignoredChar, ""), a = -1, l, u; ++a < s.length; )
    if (l = s[a], u = l.toLowerCase().replace(ignoredChar, ""), u === o)
      return r[l];
}
function projStr(r) {
  var e = {}, s = r.split("+").map(function(c) {
    return c.trim();
  }).filter(function(c) {
    return c;
  }).reduce(function(c, E) {
    var d = E.split("=");
    return d.push(!0), c[d[0].toLowerCase()] = d[1], c;
  }, {}), o, a, l, u = {
    proj: "projName",
    datum: "datumCode",
    rf: function(c) {
      e.rf = parseFloat(c);
    },
    lat_0: function(c) {
      e.lat0 = c * D2R$1;
    },
    lat_1: function(c) {
      e.lat1 = c * D2R$1;
    },
    lat_2: function(c) {
      e.lat2 = c * D2R$1;
    },
    lat_ts: function(c) {
      e.lat_ts = c * D2R$1;
    },
    lon_0: function(c) {
      e.long0 = c * D2R$1;
    },
    lon_1: function(c) {
      e.long1 = c * D2R$1;
    },
    lon_2: function(c) {
      e.long2 = c * D2R$1;
    },
    alpha: function(c) {
      e.alpha = parseFloat(c) * D2R$1;
    },
    gamma: function(c) {
      e.rectified_grid_angle = parseFloat(c) * D2R$1;
    },
    lonc: function(c) {
      e.longc = c * D2R$1;
    },
    x_0: function(c) {
      e.x0 = parseFloat(c);
    },
    y_0: function(c) {
      e.y0 = parseFloat(c);
    },
    k_0: function(c) {
      e.k0 = parseFloat(c);
    },
    k: function(c) {
      e.k0 = parseFloat(c);
    },
    a: function(c) {
      e.a = parseFloat(c);
    },
    b: function(c) {
      e.b = parseFloat(c);
    },
    r: function(c) {
      e.a = e.b = parseFloat(c);
    },
    r_a: function() {
      e.R_A = !0;
    },
    zone: function(c) {
      e.zone = parseInt(c, 10);
    },
    south: function() {
      e.utmSouth = !0;
    },
    towgs84: function(c) {
      e.datum_params = c.split(",").map(function(E) {
        return parseFloat(E);
      });
    },
    to_meter: function(c) {
      e.to_meter = parseFloat(c);
    },
    units: function(c) {
      e.units = c;
      var E = match(units, c);
      E && (e.to_meter = E.to_meter);
    },
    from_greenwich: function(c) {
      e.from_greenwich = c * D2R$1;
    },
    pm: function(c) {
      var E = match(primeMeridian, c);
      e.from_greenwich = (E || parseFloat(c)) * D2R$1;
    },
    nadgrids: function(c) {
      c === "@null" ? e.datumCode = "none" : e.nadgrids = c;
    },
    axis: function(c) {
      var E = "ewnsud";
      c.length === 3 && E.indexOf(c.substr(0, 1)) !== -1 && E.indexOf(c.substr(1, 1)) !== -1 && E.indexOf(c.substr(2, 1)) !== -1 && (e.axis = c);
    },
    approx: function() {
      e.approx = !0;
    }
  };
  for (o in s)
    a = s[o], o in u ? (l = u[o], typeof l == "function" ? l(a) : e[l] = a) : e[o] = a;
  return typeof e.datumCode == "string" && e.datumCode !== "WGS84" && (e.datumCode = e.datumCode.toLowerCase()), e;
}
class PROJJSONBuilderBase {
  static getId(e) {
    const s = e.find((o) => Array.isArray(o) && o[0] === "ID");
    return s && s.length >= 3 ? {
      authority: s[1],
      code: parseInt(s[2], 10)
    } : null;
  }
  static convertUnit(e, s = "unit") {
    if (!e || e.length < 3)
      return { type: s, name: "unknown", conversion_factor: null };
    const o = e[1], a = parseFloat(e[2]) || null, l = e.find((c) => Array.isArray(c) && c[0] === "ID"), u = l ? {
      authority: l[1],
      code: parseInt(l[2], 10)
    } : null;
    return {
      type: s,
      name: o,
      conversion_factor: a,
      id: u
    };
  }
  static convertAxis(e) {
    const s = e[1] || "Unknown";
    let o;
    const a = s.match(/^\((.)\)$/);
    if (a) {
      const d = a[1].toUpperCase();
      if (d === "E")
        o = "east";
      else if (d === "N")
        o = "north";
      else if (d === "U")
        o = "up";
      else
        throw new Error(`Unknown axis abbreviation: ${d}`);
    } else
      o = e[2] ? e[2].toLowerCase() : "unknown";
    const l = e.find((d) => Array.isArray(d) && d[0] === "ORDER"), u = l ? parseInt(l[1], 10) : null, c = e.find(
      (d) => Array.isArray(d) && (d[0] === "LENGTHUNIT" || d[0] === "ANGLEUNIT" || d[0] === "SCALEUNIT")
    ), E = this.convertUnit(c);
    return {
      name: s,
      direction: o,
      // Use the valid PROJJSON direction value
      unit: E,
      order: u
    };
  }
  static extractAxes(e) {
    return e.filter((s) => Array.isArray(s) && s[0] === "AXIS").map((s) => this.convertAxis(s)).sort((s, o) => (s.order || 0) - (o.order || 0));
  }
  static convert(e, s = {}) {
    switch (e[0]) {
      case "PROJCRS":
        s.type = "ProjectedCRS", s.name = e[1], s.base_crs = e.find((S) => Array.isArray(S) && S[0] === "BASEGEOGCRS") ? this.convert(e.find((S) => Array.isArray(S) && S[0] === "BASEGEOGCRS")) : null, s.conversion = e.find((S) => Array.isArray(S) && S[0] === "CONVERSION") ? this.convert(e.find((S) => Array.isArray(S) && S[0] === "CONVERSION")) : null;
        const o = e.find((S) => Array.isArray(S) && S[0] === "CS");
        o && (s.coordinate_system = {
          type: o[1],
          axis: this.extractAxes(e)
        });
        const a = e.find((S) => Array.isArray(S) && S[0] === "LENGTHUNIT");
        if (a) {
          const S = this.convertUnit(a);
          s.coordinate_system.unit = S;
        }
        s.id = this.getId(e);
        break;
      case "BASEGEOGCRS":
      case "GEOGCRS":
        s.type = "GeographicCRS", s.name = e[1];
        const l = e.find(
          (S) => Array.isArray(S) && (S[0] === "DATUM" || S[0] === "ENSEMBLE")
        );
        if (l) {
          const S = this.convert(l);
          l[0] === "ENSEMBLE" ? s.datum_ensemble = S : s.datum = S;
          const R = e.find((_) => Array.isArray(_) && _[0] === "PRIMEM");
          R && R[1] !== "Greenwich" && (S.prime_meridian = {
            name: R[1],
            longitude: parseFloat(R[2])
          });
        }
        s.coordinate_system = {
          type: "ellipsoidal",
          axis: this.extractAxes(e)
        }, s.id = this.getId(e);
        break;
      case "DATUM":
        s.type = "GeodeticReferenceFrame", s.name = e[1], s.ellipsoid = e.find((S) => Array.isArray(S) && S[0] === "ELLIPSOID") ? this.convert(e.find((S) => Array.isArray(S) && S[0] === "ELLIPSOID")) : null;
        break;
      case "ENSEMBLE":
        s.type = "DatumEnsemble", s.name = e[1], s.members = e.filter((S) => Array.isArray(S) && S[0] === "MEMBER").map((S) => ({
          type: "DatumEnsembleMember",
          name: S[1],
          id: this.getId(S)
          // Extract ID as { authority, code }
        }));
        const u = e.find((S) => Array.isArray(S) && S[0] === "ENSEMBLEACCURACY");
        u && (s.accuracy = parseFloat(u[1]));
        const c = e.find((S) => Array.isArray(S) && S[0] === "ELLIPSOID");
        c && (s.ellipsoid = this.convert(c)), s.id = this.getId(e);
        break;
      case "ELLIPSOID":
        s.type = "Ellipsoid", s.name = e[1], s.semi_major_axis = parseFloat(e[2]), s.inverse_flattening = parseFloat(e[3]), e.find((S) => Array.isArray(S) && S[0] === "LENGTHUNIT") && this.convert(e.find((S) => Array.isArray(S) && S[0] === "LENGTHUNIT"), s);
        break;
      case "CONVERSION":
        s.type = "Conversion", s.name = e[1], s.method = e.find((S) => Array.isArray(S) && S[0] === "METHOD") ? this.convert(e.find((S) => Array.isArray(S) && S[0] === "METHOD")) : null, s.parameters = e.filter((S) => Array.isArray(S) && S[0] === "PARAMETER").map((S) => this.convert(S));
        break;
      case "METHOD":
        s.type = "Method", s.name = e[1], s.id = this.getId(e);
        break;
      case "PARAMETER":
        s.type = "Parameter", s.name = e[1], s.value = parseFloat(e[2]), s.unit = this.convertUnit(
          e.find(
            (S) => Array.isArray(S) && (S[0] === "LENGTHUNIT" || S[0] === "ANGLEUNIT" || S[0] === "SCALEUNIT")
          )
        ), s.id = this.getId(e);
        break;
      case "BOUNDCRS":
        s.type = "BoundCRS";
        const E = e.find((S) => Array.isArray(S) && S[0] === "SOURCECRS");
        if (E) {
          const S = E.find((R) => Array.isArray(R));
          s.source_crs = S ? this.convert(S) : null;
        }
        const d = e.find((S) => Array.isArray(S) && S[0] === "TARGETCRS");
        if (d) {
          const S = d.find((R) => Array.isArray(R));
          s.target_crs = S ? this.convert(S) : null;
        }
        const f = e.find((S) => Array.isArray(S) && S[0] === "ABRIDGEDTRANSFORMATION");
        f ? s.transformation = this.convert(f) : s.transformation = null;
        break;
      case "ABRIDGEDTRANSFORMATION":
        if (s.type = "Transformation", s.name = e[1], s.method = e.find((S) => Array.isArray(S) && S[0] === "METHOD") ? this.convert(e.find((S) => Array.isArray(S) && S[0] === "METHOD")) : null, s.parameters = e.filter((S) => Array.isArray(S) && (S[0] === "PARAMETER" || S[0] === "PARAMETERFILE")).map((S) => {
          if (S[0] === "PARAMETER")
            return this.convert(S);
          if (S[0] === "PARAMETERFILE")
            return {
              name: S[1],
              value: S[2],
              id: {
                authority: "EPSG",
                code: 8656
              }
            };
        }), s.parameters.length === 7) {
          const S = s.parameters[6];
          S.name === "Scale difference" && (S.value = Math.round((S.value - 1) * 1e12) / 1e6);
        }
        s.id = this.getId(e);
        break;
      case "AXIS":
        s.coordinate_system || (s.coordinate_system = { type: "unspecified", axis: [] }), s.coordinate_system.axis.push(this.convertAxis(e));
        break;
      case "LENGTHUNIT":
        const h = this.convertUnit(e, "LinearUnit");
        s.coordinate_system && s.coordinate_system.axis && s.coordinate_system.axis.forEach((S) => {
          S.unit || (S.unit = h);
        }), h.conversion_factor && h.conversion_factor !== 1 && s.semi_major_axis && (s.semi_major_axis = {
          value: s.semi_major_axis,
          unit: h
        });
        break;
      default:
        s.keyword = e[0];
        break;
    }
    return s;
  }
}
class PROJJSONBuilder2015 extends PROJJSONBuilderBase {
  static convert(e, s = {}) {
    return super.convert(e, s), s.coordinate_system && s.coordinate_system.subtype === "Cartesian" && delete s.coordinate_system, s.usage && delete s.usage, s;
  }
}
class PROJJSONBuilder2019 extends PROJJSONBuilderBase {
  static convert(e, s = {}) {
    super.convert(e, s);
    const o = e.find((l) => Array.isArray(l) && l[0] === "CS");
    o && (s.coordinate_system = {
      subtype: o[1],
      axis: this.extractAxes(e)
    });
    const a = e.find((l) => Array.isArray(l) && l[0] === "USAGE");
    if (a) {
      const l = a.find((E) => Array.isArray(E) && E[0] === "SCOPE"), u = a.find((E) => Array.isArray(E) && E[0] === "AREA"), c = a.find((E) => Array.isArray(E) && E[0] === "BBOX");
      s.usage = {}, l && (s.usage.scope = l[1]), u && (s.usage.area = u[1]), c && (s.usage.bbox = c.slice(1));
    }
    return s;
  }
}
function detectWKT2Version(r) {
  return r.find((e) => Array.isArray(e) && e[0] === "USAGE") ? "2019" : (r.find((e) => Array.isArray(e) && e[0] === "CS") || r[0] === "BOUNDCRS" || r[0] === "PROJCRS" || r[0] === "GEOGCRS", "2015");
}
function buildPROJJSON(r) {
  return (detectWKT2Version(r) === "2019" ? PROJJSONBuilder2019 : PROJJSONBuilder2015).convert(r);
}
function detectWKTVersion(r) {
  const e = r.toUpperCase();
  return e.includes("PROJCRS") || e.includes("GEOGCRS") || e.includes("BOUNDCRS") || e.includes("VERTCRS") || e.includes("LENGTHUNIT") || e.includes("ANGLEUNIT") || e.includes("SCALEUNIT") ? "WKT2" : (e.includes("PROJCS") || e.includes("GEOGCS") || e.includes("LOCAL_CS") || e.includes("VERT_CS") || e.includes("UNIT"), "WKT1");
}
var NEUTRAL = 1, KEYWORD = 2, NUMBER = 3, QUOTED = 4, AFTERQUOTE = 5, ENDED = -1, whitespace = /\s/, latin = /[A-Za-z]/, keyword = /[A-Za-z84_]/, endThings = /[,\]]/, digets = /[\d\.E\-\+]/;
function Parser(r) {
  if (typeof r != "string")
    throw new Error("not a string");
  this.text = r.trim(), this.level = 0, this.place = 0, this.root = null, this.stack = [], this.currentObject = null, this.state = NEUTRAL;
}
Parser.prototype.readCharicter = function() {
  var r = this.text[this.place++];
  if (this.state !== QUOTED)
    for (; whitespace.test(r); ) {
      if (this.place >= this.text.length)
        return;
      r = this.text[this.place++];
    }
  switch (this.state) {
    case NEUTRAL:
      return this.neutral(r);
    case KEYWORD:
      return this.keyword(r);
    case QUOTED:
      return this.quoted(r);
    case AFTERQUOTE:
      return this.afterquote(r);
    case NUMBER:
      return this.number(r);
    case ENDED:
      return;
  }
};
Parser.prototype.afterquote = function(r) {
  if (r === '"') {
    this.word += '"', this.state = QUOTED;
    return;
  }
  if (endThings.test(r)) {
    this.word = this.word.trim(), this.afterItem(r);
    return;
  }
  throw new Error(`havn't handled "` + r + '" in afterquote yet, index ' + this.place);
};
Parser.prototype.afterItem = function(r) {
  if (r === ",") {
    this.word !== null && this.currentObject.push(this.word), this.word = null, this.state = NEUTRAL;
    return;
  }
  if (r === "]") {
    this.level--, this.word !== null && (this.currentObject.push(this.word), this.word = null), this.state = NEUTRAL, this.currentObject = this.stack.pop(), this.currentObject || (this.state = ENDED);
    return;
  }
};
Parser.prototype.number = function(r) {
  if (digets.test(r)) {
    this.word += r;
    return;
  }
  if (endThings.test(r)) {
    this.word = parseFloat(this.word), this.afterItem(r);
    return;
  }
  throw new Error(`havn't handled "` + r + '" in number yet, index ' + this.place);
};
Parser.prototype.quoted = function(r) {
  if (r === '"') {
    this.state = AFTERQUOTE;
    return;
  }
  this.word += r;
};
Parser.prototype.keyword = function(r) {
  if (keyword.test(r)) {
    this.word += r;
    return;
  }
  if (r === "[") {
    var e = [];
    e.push(this.word), this.level++, this.root === null ? this.root = e : this.currentObject.push(e), this.stack.push(this.currentObject), this.currentObject = e, this.state = NEUTRAL;
    return;
  }
  if (endThings.test(r)) {
    this.afterItem(r);
    return;
  }
  throw new Error(`havn't handled "` + r + '" in keyword yet, index ' + this.place);
};
Parser.prototype.neutral = function(r) {
  if (latin.test(r)) {
    this.word = r, this.state = KEYWORD;
    return;
  }
  if (r === '"') {
    this.word = "", this.state = QUOTED;
    return;
  }
  if (digets.test(r)) {
    this.word = r, this.state = NUMBER;
    return;
  }
  if (endThings.test(r)) {
    this.afterItem(r);
    return;
  }
  throw new Error(`havn't handled "` + r + '" in neutral yet, index ' + this.place);
};
Parser.prototype.output = function() {
  for (; this.place < this.text.length; )
    this.readCharicter();
  if (this.state === ENDED)
    return this.root;
  throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function parseString(r) {
  var e = new Parser(r);
  return e.output();
}
function mapit(r, e, s) {
  Array.isArray(e) && (s.unshift(e), e = null);
  var o = e ? {} : r, a = s.reduce(function(l, u) {
    return sExpr(u, l), l;
  }, o);
  e && (r[e] = a);
}
function sExpr(r, e) {
  if (!Array.isArray(r)) {
    e[r] = !0;
    return;
  }
  var s = r.shift();
  if (s === "PARAMETER" && (s = r.shift()), r.length === 1) {
    if (Array.isArray(r[0])) {
      e[s] = {}, sExpr(r[0], e[s]);
      return;
    }
    e[s] = r[0];
    return;
  }
  if (!r.length) {
    e[s] = !0;
    return;
  }
  if (s === "TOWGS84") {
    e[s] = r;
    return;
  }
  if (s === "AXIS") {
    s in e || (e[s] = []), e[s].push(r);
    return;
  }
  Array.isArray(s) || (e[s] = {});
  var o;
  switch (s) {
    case "UNIT":
    case "PRIMEM":
    case "VERT_DATUM":
      e[s] = {
        name: r[0].toLowerCase(),
        convert: r[1]
      }, r.length === 3 && sExpr(r[2], e[s]);
      return;
    case "SPHEROID":
    case "ELLIPSOID":
      e[s] = {
        name: r[0],
        a: r[1],
        rf: r[2]
      }, r.length === 4 && sExpr(r[3], e[s]);
      return;
    case "EDATUM":
    case "ENGINEERINGDATUM":
    case "LOCAL_DATUM":
    case "DATUM":
    case "VERT_CS":
    case "VERTCRS":
    case "VERTICALCRS":
      r[0] = ["name", r[0]], mapit(e, s, r);
      return;
    case "COMPD_CS":
    case "COMPOUNDCRS":
    case "FITTED_CS":
    case "PROJECTEDCRS":
    case "PROJCRS":
    case "GEOGCS":
    case "GEOCCS":
    case "PROJCS":
    case "LOCAL_CS":
    case "GEODCRS":
    case "GEODETICCRS":
    case "GEODETICDATUM":
    case "ENGCRS":
    case "ENGINEERINGCRS":
      r[0] = ["name", r[0]], mapit(e, s, r), e[s].type = s;
      return;
    default:
      for (o = -1; ++o < r.length; )
        if (!Array.isArray(r[o]))
          return sExpr(r, e[s]);
      return mapit(e, s, r);
  }
}
var D2R = 0.017453292519943295;
function d2r(r) {
  return r * D2R;
}
function applyProjectionDefaults(r) {
  const e = (r.projName || "").toLowerCase().replace(/_/g, " ");
  !r.long0 && r.longc && (e === "albers conic equal area" || e === "lambert azimuthal equal area") && (r.long0 = r.longc), !r.lat_ts && r.lat1 && (e === "stereographic south pole" || e === "polar stereographic (variant b)") ? (r.lat0 = d2r(r.lat1 > 0 ? 90 : -90), r.lat_ts = r.lat1, delete r.lat1) : !r.lat_ts && r.lat0 && (e === "polar stereographic" || e === "polar stereographic (variant a)") && (r.lat_ts = r.lat0, r.lat0 = d2r(r.lat0 > 0 ? 90 : -90), delete r.lat1);
}
function processUnit(r) {
  let e = { units: null, to_meter: void 0 };
  return typeof r == "string" ? (e.units = r.toLowerCase(), e.units === "metre" && (e.units = "meter"), e.units === "meter" && (e.to_meter = 1)) : r && r.name && (e.units = r.name.toLowerCase(), e.units === "metre" && (e.units = "meter"), e.to_meter = r.conversion_factor), e;
}
function toValue(r) {
  return typeof r == "object" ? r.value * r.unit.conversion_factor : r;
}
function calculateEllipsoid(r, e) {
  r.ellipsoid.radius ? (e.a = r.ellipsoid.radius, e.rf = 0) : (e.a = toValue(r.ellipsoid.semi_major_axis), r.ellipsoid.inverse_flattening !== void 0 ? e.rf = r.ellipsoid.inverse_flattening : r.ellipsoid.semi_major_axis !== void 0 && r.ellipsoid.semi_minor_axis !== void 0 && (e.rf = e.a / (e.a - toValue(r.ellipsoid.semi_minor_axis))));
}
function transformPROJJSON(r, e = {}) {
  return !r || typeof r != "object" ? r : r.type === "BoundCRS" ? (transformPROJJSON(r.source_crs, e), r.transformation && (r.transformation.method && r.transformation.method.name === "NTv2" ? e.nadgrids = r.transformation.parameters[0].value : e.datum_params = r.transformation.parameters.map((s) => s.value)), e) : (Object.keys(r).forEach((s) => {
    const o = r[s];
    if (o !== null)
      switch (s) {
        case "name":
          if (e.srsCode)
            break;
          e.name = o, e.srsCode = o;
          break;
        case "type":
          o === "GeographicCRS" ? e.projName = "longlat" : o === "ProjectedCRS" && r.conversion && r.conversion.method && (e.projName = r.conversion.method.name);
          break;
        case "datum":
        case "datum_ensemble":
          o.ellipsoid && (e.ellps = o.ellipsoid.name, calculateEllipsoid(o, e)), o.prime_meridian && (e.from_greenwich = o.prime_meridian.longitude * Math.PI / 180);
          break;
        case "ellipsoid":
          e.ellps = o.name, calculateEllipsoid(o, e);
          break;
        case "prime_meridian":
          e.long0 = (o.longitude || 0) * Math.PI / 180;
          break;
        case "coordinate_system":
          if (o.axis) {
            if (e.axis = o.axis.map((a) => {
              const l = a.direction;
              if (l === "east")
                return "e";
              if (l === "north")
                return "n";
              if (l === "west")
                return "w";
              if (l === "south")
                return "s";
              throw new Error(`Unknown axis direction: ${l}`);
            }).join("") + "u", o.unit) {
              const { units: a, to_meter: l } = processUnit(o.unit);
              e.units = a, e.to_meter = l;
            } else if (o.axis[0] && o.axis[0].unit) {
              const { units: a, to_meter: l } = processUnit(o.axis[0].unit);
              e.units = a, e.to_meter = l;
            }
          }
          break;
        case "id":
          o.authority && o.code && (e.title = o.authority + ":" + o.code);
          break;
        case "conversion":
          o.method && o.method.name && (e.projName = o.method.name), o.parameters && o.parameters.forEach((a) => {
            const l = a.name.toLowerCase().replace(/\s+/g, "_"), u = a.value;
            a.unit && a.unit.conversion_factor ? e[l] = u * a.unit.conversion_factor : a.unit === "degree" ? e[l] = u * Math.PI / 180 : e[l] = u;
          });
          break;
        case "unit":
          o.name && (e.units = o.name.toLowerCase(), e.units === "metre" && (e.units = "meter")), o.conversion_factor && (e.to_meter = o.conversion_factor);
          break;
        case "base_crs":
          transformPROJJSON(o, e), e.datumCode = o.id ? o.id.authority + "_" + o.id.code : o.name;
          break;
      }
  }), e.latitude_of_false_origin !== void 0 && (e.lat0 = e.latitude_of_false_origin), e.longitude_of_false_origin !== void 0 && (e.long0 = e.longitude_of_false_origin), e.latitude_of_standard_parallel !== void 0 && (e.lat0 = e.latitude_of_standard_parallel, e.lat1 = e.latitude_of_standard_parallel), e.latitude_of_1st_standard_parallel !== void 0 && (e.lat1 = e.latitude_of_1st_standard_parallel), e.latitude_of_2nd_standard_parallel !== void 0 && (e.lat2 = e.latitude_of_2nd_standard_parallel), e.latitude_of_projection_centre !== void 0 && (e.lat0 = e.latitude_of_projection_centre), e.longitude_of_projection_centre !== void 0 && (e.longc = e.longitude_of_projection_centre), e.easting_at_false_origin !== void 0 && (e.x0 = e.easting_at_false_origin), e.northing_at_false_origin !== void 0 && (e.y0 = e.northing_at_false_origin), e.latitude_of_natural_origin !== void 0 && (e.lat0 = e.latitude_of_natural_origin), e.longitude_of_natural_origin !== void 0 && (e.long0 = e.longitude_of_natural_origin), e.longitude_of_origin !== void 0 && (e.long0 = e.longitude_of_origin), e.false_easting !== void 0 && (e.x0 = e.false_easting), e.easting_at_projection_centre && (e.x0 = e.easting_at_projection_centre), e.false_northing !== void 0 && (e.y0 = e.false_northing), e.northing_at_projection_centre && (e.y0 = e.northing_at_projection_centre), e.standard_parallel_1 !== void 0 && (e.lat1 = e.standard_parallel_1), e.standard_parallel_2 !== void 0 && (e.lat2 = e.standard_parallel_2), e.scale_factor_at_natural_origin !== void 0 && (e.k0 = e.scale_factor_at_natural_origin), e.scale_factor_at_projection_centre !== void 0 && (e.k0 = e.scale_factor_at_projection_centre), e.scale_factor_on_pseudo_standard_parallel !== void 0 && (e.k0 = e.scale_factor_on_pseudo_standard_parallel), e.azimuth !== void 0 && (e.alpha = e.azimuth), e.azimuth_at_projection_centre !== void 0 && (e.alpha = e.azimuth_at_projection_centre), e.angle_from_rectified_to_skew_grid && (e.rectified_grid_angle = e.angle_from_rectified_to_skew_grid), applyProjectionDefaults(e), e);
}
var knownTypes = [
  "PROJECTEDCRS",
  "PROJCRS",
  "GEOGCS",
  "GEOCCS",
  "PROJCS",
  "LOCAL_CS",
  "GEODCRS",
  "GEODETICCRS",
  "GEODETICDATUM",
  "ENGCRS",
  "ENGINEERINGCRS"
];
function rename(r, e) {
  var s = e[0], o = e[1];
  !(s in r) && o in r && (r[s] = r[o], e.length === 3 && (r[s] = e[2](r[s])));
}
function cleanWKT(r) {
  for (var e = Object.keys(r), s = 0, o = e.length; s < o; ++s) {
    var a = e[s];
    knownTypes.indexOf(a) !== -1 && setPropertiesFromWkt(r[a]), typeof r[a] == "object" && cleanWKT(r[a]);
  }
}
function setPropertiesFromWkt(r) {
  if (r.AUTHORITY) {
    var e = Object.keys(r.AUTHORITY)[0];
    e && e in r.AUTHORITY && (r.title = e + ":" + r.AUTHORITY[e]);
  }
  if (r.type === "GEOGCS" ? r.projName = "longlat" : r.type === "LOCAL_CS" ? (r.projName = "identity", r.local = !0) : typeof r.PROJECTION == "object" ? r.projName = Object.keys(r.PROJECTION)[0] : r.projName = r.PROJECTION, r.AXIS) {
    for (var s = "", o = 0, a = r.AXIS.length; o < a; ++o) {
      var l = [r.AXIS[o][0].toLowerCase(), r.AXIS[o][1].toLowerCase()];
      l[0].indexOf("north") !== -1 || (l[0] === "y" || l[0] === "lat") && l[1] === "north" ? s += "n" : l[0].indexOf("south") !== -1 || (l[0] === "y" || l[0] === "lat") && l[1] === "south" ? s += "s" : l[0].indexOf("east") !== -1 || (l[0] === "x" || l[0] === "lon") && l[1] === "east" ? s += "e" : (l[0].indexOf("west") !== -1 || (l[0] === "x" || l[0] === "lon") && l[1] === "west") && (s += "w");
    }
    s.length === 2 && (s += "u"), s.length === 3 && (r.axis = s);
  }
  r.UNIT && (r.units = r.UNIT.name.toLowerCase(), r.units === "metre" && (r.units = "meter"), r.UNIT.convert && (r.type === "GEOGCS" ? r.DATUM && r.DATUM.SPHEROID && (r.to_meter = r.UNIT.convert * r.DATUM.SPHEROID.a) : r.to_meter = r.UNIT.convert));
  var u = r.GEOGCS;
  r.type === "GEOGCS" && (u = r), u && (u.DATUM ? r.datumCode = u.DATUM.name.toLowerCase() : r.datumCode = u.name.toLowerCase(), r.datumCode.slice(0, 2) === "d_" && (r.datumCode = r.datumCode.slice(2)), r.datumCode === "new_zealand_1949" && (r.datumCode = "nzgd49"), (r.datumCode === "wgs_1984" || r.datumCode === "world_geodetic_system_1984") && (r.PROJECTION === "Mercator_Auxiliary_Sphere" && (r.sphere = !0), r.datumCode = "wgs84"), r.datumCode === "belge_1972" && (r.datumCode = "rnb72"), u.DATUM && u.DATUM.SPHEROID && (r.ellps = u.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), r.ellps.toLowerCase().slice(0, 13) === "international" && (r.ellps = "intl"), r.a = u.DATUM.SPHEROID.a, r.rf = parseFloat(u.DATUM.SPHEROID.rf, 10)), u.DATUM && u.DATUM.TOWGS84 && (r.datum_params = u.DATUM.TOWGS84), ~r.datumCode.indexOf("osgb_1936") && (r.datumCode = "osgb36"), ~r.datumCode.indexOf("osni_1952") && (r.datumCode = "osni52"), (~r.datumCode.indexOf("tm65") || ~r.datumCode.indexOf("geodetic_datum_of_1965")) && (r.datumCode = "ire65"), r.datumCode === "ch1903+" && (r.datumCode = "ch1903"), ~r.datumCode.indexOf("israel") && (r.datumCode = "isr93")), r.b && !isFinite(r.b) && (r.b = r.a), r.rectified_grid_angle && (r.rectified_grid_angle = d2r(r.rectified_grid_angle));
  function c(f) {
    var h = r.to_meter || 1;
    return f * h;
  }
  var E = function(f) {
    return rename(r, f);
  }, d = [
    ["standard_parallel_1", "Standard_Parallel_1"],
    ["standard_parallel_1", "Latitude of 1st standard parallel"],
    ["standard_parallel_2", "Standard_Parallel_2"],
    ["standard_parallel_2", "Latitude of 2nd standard parallel"],
    ["false_easting", "False_Easting"],
    ["false_easting", "False easting"],
    ["false-easting", "Easting at false origin"],
    ["false_northing", "False_Northing"],
    ["false_northing", "False northing"],
    ["false_northing", "Northing at false origin"],
    ["central_meridian", "Central_Meridian"],
    ["central_meridian", "Longitude of natural origin"],
    ["central_meridian", "Longitude of false origin"],
    ["latitude_of_origin", "Latitude_Of_Origin"],
    ["latitude_of_origin", "Central_Parallel"],
    ["latitude_of_origin", "Latitude of natural origin"],
    ["latitude_of_origin", "Latitude of false origin"],
    ["scale_factor", "Scale_Factor"],
    ["k0", "scale_factor"],
    ["latitude_of_center", "Latitude_Of_Center"],
    ["latitude_of_center", "Latitude_of_center"],
    ["lat0", "latitude_of_center", d2r],
    ["longitude_of_center", "Longitude_Of_Center"],
    ["longitude_of_center", "Longitude_of_center"],
    ["longc", "longitude_of_center", d2r],
    ["x0", "false_easting", c],
    ["y0", "false_northing", c],
    ["long0", "central_meridian", d2r],
    ["lat0", "latitude_of_origin", d2r],
    ["lat0", "standard_parallel_1", d2r],
    ["lat1", "standard_parallel_1", d2r],
    ["lat2", "standard_parallel_2", d2r],
    ["azimuth", "Azimuth"],
    ["alpha", "azimuth", d2r],
    ["srsCode", "name"]
  ];
  d.forEach(E), applyProjectionDefaults(r);
}
function wkt(r) {
  if (typeof r == "object")
    return transformPROJJSON(r);
  const e = detectWKTVersion(r);
  var s = parseString(r);
  if (e === "WKT2") {
    const l = buildPROJJSON(s);
    return transformPROJJSON(l);
  }
  var o = s[0], a = {};
  return sExpr(s, a), cleanWKT(a), a[o];
}
function defs(r) {
  var e = this;
  if (arguments.length === 2) {
    var s = arguments[1];
    typeof s == "string" ? s.charAt(0) === "+" ? defs[
      /** @type {string} */
      r
    ] = projStr(arguments[1]) : defs[
      /** @type {string} */
      r
    ] = wkt(arguments[1]) : defs[
      /** @type {string} */
      r
    ] = s;
  } else if (arguments.length === 1) {
    if (Array.isArray(r))
      return r.map(function(o) {
        return Array.isArray(o) ? defs.apply(e, o) : defs(o);
      });
    if (typeof r == "string") {
      if (r in defs)
        return defs[r];
    } else
      "EPSG" in r ? defs["EPSG:" + r.EPSG] = r : "ESRI" in r ? defs["ESRI:" + r.ESRI] = r : "IAU2000" in r ? defs["IAU2000:" + r.IAU2000] = r : console.log(r);
    return;
  }
}
globals(defs);
function testObj(r) {
  return typeof r == "string";
}
function testDef(r) {
  return r in defs;
}
function testWKT(r) {
  return r.indexOf("+") !== 0 && r.indexOf("[") !== -1 || typeof r == "object" && !("srsCode" in r);
}
var codes = ["3857", "900913", "3785", "102113"];
function checkMercator(r) {
  var e = match(r, "authority");
  if (e) {
    var s = match(e, "epsg");
    return s && codes.indexOf(s) > -1;
  }
}
function checkProjStr(r) {
  var e = match(r, "extension");
  if (e)
    return match(e, "proj4");
}
function testProj(r) {
  return r[0] === "+";
}
function parse$1(r) {
  if (testObj(r)) {
    if (testDef(r))
      return defs[r];
    if (testWKT(r)) {
      var e = wkt(r);
      if (checkMercator(e))
        return defs["EPSG:3857"];
      var s = checkProjStr(e);
      return s ? projStr(s) : e;
    }
    if (testProj(r))
      return projStr(r);
  } else
    return "projName" in r ? r : wkt(r);
}
function extend(r, e) {
  r = r || {};
  var s, o;
  if (!e)
    return r;
  for (o in e)
    s = e[o], s !== void 0 && (r[o] = s);
  return r;
}
function msfnz(r, e, s) {
  var o = r * e;
  return s / Math.sqrt(1 - o * o);
}
function sign(r) {
  return r < 0 ? -1 : 1;
}
function adjust_lon(r) {
  return Math.abs(r) <= SPI ? r : r - sign(r) * TWO_PI;
}
function tsfnz(r, e, s) {
  var o = r * s, a = 0.5 * r;
  return o = Math.pow((1 - o) / (1 + o), a), Math.tan(0.5 * (HALF_PI - e)) / o;
}
function phi2z(r, e) {
  for (var s = 0.5 * r, o, a, l = HALF_PI - 2 * Math.atan(e), u = 0; u <= 15; u++)
    if (o = r * Math.sin(l), a = HALF_PI - 2 * Math.atan(e * Math.pow((1 - o) / (1 + o), s)) - l, l += a, Math.abs(a) <= 1e-10)
      return l;
  return -9999;
}
function init$x() {
  var r = this.b / this.a;
  this.es = 1 - r * r, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
}
function forward$v(r) {
  var e = r.x, s = r.y;
  if (s * R2D > 90 && s * R2D < -90 && e * R2D > 180 && e * R2D < -180)
    return null;
  var o, a;
  if (Math.abs(Math.abs(s) - HALF_PI) <= EPSLN)
    return null;
  if (this.sphere)
    o = this.x0 + this.a * this.k0 * adjust_lon(e - this.long0), a = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * s));
  else {
    var l = Math.sin(s), u = tsfnz(this.e, s, l);
    o = this.x0 + this.a * this.k0 * adjust_lon(e - this.long0), a = this.y0 - this.a * this.k0 * Math.log(u);
  }
  return r.x = o, r.y = a, r;
}
function inverse$v(r) {
  var e = r.x - this.x0, s = r.y - this.y0, o, a;
  if (this.sphere)
    a = HALF_PI - 2 * Math.atan(Math.exp(-s / (this.a * this.k0)));
  else {
    var l = Math.exp(-s / (this.a * this.k0));
    if (a = phi2z(this.e, l), a === -9999)
      return null;
  }
  return o = adjust_lon(this.long0 + e / (this.a * this.k0)), r.x = o, r.y = a, r;
}
var names$y = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "Mercator_Variant_A", "merc"];
const merc = {
  init: init$x,
  forward: forward$v,
  inverse: inverse$v,
  names: names$y
};
function init$w() {
}
function identity(r) {
  return r;
}
var names$x = ["longlat", "identity"];
const longlat = {
  init: init$w,
  forward: identity,
  inverse: identity,
  names: names$x
};
var projs = [merc, longlat], names$w = {}, projStore = [];
function add(r, e) {
  var s = projStore.length;
  return r.names ? (projStore[s] = r, r.names.forEach(function(o) {
    names$w[o.toLowerCase()] = s;
  }), this) : (console.log(e), !0);
}
function getNormalizedProjName(r) {
  return r.replace(/[-\(\)\s]+/g, " ").trim().replace(/ /g, "_");
}
function get(r) {
  if (!r)
    return !1;
  var e = r.toLowerCase();
  if (typeof names$w[e] < "u" && projStore[names$w[e]] || (e = getNormalizedProjName(e), e in names$w && projStore[names$w[e]]))
    return projStore[names$w[e]];
}
function start() {
  projs.forEach(add);
}
const projections = {
  start,
  add,
  get
};
var ellipsoids = {
  MERIT: {
    a: 6378137,
    rf: 298.257,
    ellipseName: "MERIT 1983"
  },
  SGS85: {
    a: 6378136,
    rf: 298.257,
    ellipseName: "Soviet Geodetic System 85"
  },
  GRS80: {
    a: 6378137,
    rf: 298.257222101,
    ellipseName: "GRS 1980(IUGG, 1980)"
  },
  IAU76: {
    a: 6378140,
    rf: 298.257,
    ellipseName: "IAU 1976"
  },
  airy: {
    a: 6377563396e-3,
    b: 635625691e-2,
    ellipseName: "Airy 1830"
  },
  APL4: {
    a: 6378137,
    rf: 298.25,
    ellipseName: "Appl. Physics. 1965"
  },
  NWL9D: {
    a: 6378145,
    rf: 298.25,
    ellipseName: "Naval Weapons Lab., 1965"
  },
  mod_airy: {
    a: 6377340189e-3,
    b: 6356034446e-3,
    ellipseName: "Modified Airy"
  },
  andrae: {
    a: 637710443e-2,
    rf: 300,
    ellipseName: "Andrae 1876 (Den., Iclnd.)"
  },
  aust_SA: {
    a: 6378160,
    rf: 298.25,
    ellipseName: "Australian Natl & S. Amer. 1969"
  },
  GRS67: {
    a: 6378160,
    rf: 298.247167427,
    ellipseName: "GRS 67(IUGG 1967)"
  },
  bessel: {
    a: 6377397155e-3,
    rf: 299.1528128,
    ellipseName: "Bessel 1841"
  },
  bess_nam: {
    a: 6377483865e-3,
    rf: 299.1528128,
    ellipseName: "Bessel 1841 (Namibia)"
  },
  clrk66: {
    a: 63782064e-1,
    b: 63565838e-1,
    ellipseName: "Clarke 1866"
  },
  clrk80: {
    a: 6378249145e-3,
    rf: 293.4663,
    ellipseName: "Clarke 1880 mod."
  },
  clrk80ign: {
    a: 63782492e-1,
    b: 6356515,
    rf: 293.4660213,
    ellipseName: "Clarke 1880 (IGN)"
  },
  clrk58: {
    a: 6378293645208759e-9,
    rf: 294.2606763692654,
    ellipseName: "Clarke 1858"
  },
  CPM: {
    a: 63757387e-1,
    rf: 334.29,
    ellipseName: "Comm. des Poids et Mesures 1799"
  },
  delmbr: {
    a: 6376428,
    rf: 311.5,
    ellipseName: "Delambre 1810 (Belgium)"
  },
  engelis: {
    a: 637813605e-2,
    rf: 298.2566,
    ellipseName: "Engelis 1985"
  },
  evrst30: {
    a: 6377276345e-3,
    rf: 300.8017,
    ellipseName: "Everest 1830"
  },
  evrst48: {
    a: 6377304063e-3,
    rf: 300.8017,
    ellipseName: "Everest 1948"
  },
  evrst56: {
    a: 6377301243e-3,
    rf: 300.8017,
    ellipseName: "Everest 1956"
  },
  evrst69: {
    a: 6377295664e-3,
    rf: 300.8017,
    ellipseName: "Everest 1969"
  },
  evrstSS: {
    a: 6377298556e-3,
    rf: 300.8017,
    ellipseName: "Everest (Sabah & Sarawak)"
  },
  fschr60: {
    a: 6378166,
    rf: 298.3,
    ellipseName: "Fischer (Mercury Datum) 1960"
  },
  fschr60m: {
    a: 6378155,
    rf: 298.3,
    ellipseName: "Fischer 1960"
  },
  fschr68: {
    a: 6378150,
    rf: 298.3,
    ellipseName: "Fischer 1968"
  },
  helmert: {
    a: 6378200,
    rf: 298.3,
    ellipseName: "Helmert 1906"
  },
  hough: {
    a: 6378270,
    rf: 297,
    ellipseName: "Hough"
  },
  intl: {
    a: 6378388,
    rf: 297,
    ellipseName: "International 1909 (Hayford)"
  },
  kaula: {
    a: 6378163,
    rf: 298.24,
    ellipseName: "Kaula 1961"
  },
  lerch: {
    a: 6378139,
    rf: 298.257,
    ellipseName: "Lerch 1979"
  },
  mprts: {
    a: 6397300,
    rf: 191,
    ellipseName: "Maupertius 1738"
  },
  new_intl: {
    a: 63781575e-1,
    b: 63567722e-1,
    ellipseName: "New International 1967"
  },
  plessis: {
    a: 6376523,
    rf: 6355863,
    ellipseName: "Plessis 1817 (France)"
  },
  krass: {
    a: 6378245,
    rf: 298.3,
    ellipseName: "Krassovsky, 1942"
  },
  SEasia: {
    a: 6378155,
    b: 63567733205e-4,
    ellipseName: "Southeast Asia"
  },
  walbeck: {
    a: 6376896,
    b: 63558348467e-4,
    ellipseName: "Walbeck"
  },
  WGS60: {
    a: 6378165,
    rf: 298.3,
    ellipseName: "WGS 60"
  },
  WGS66: {
    a: 6378145,
    rf: 298.25,
    ellipseName: "WGS 66"
  },
  WGS7: {
    a: 6378135,
    rf: 298.26,
    ellipseName: "WGS 72"
  },
  WGS84: {
    a: 6378137,
    rf: 298.257223563,
    ellipseName: "WGS 84"
  },
  sphere: {
    a: 6370997,
    b: 6370997,
    ellipseName: "Normal Sphere (r=6370997)"
  }
};
const WGS84 = ellipsoids.WGS84;
function eccentricity(r, e, s, o) {
  var a = r * r, l = e * e, u = (a - l) / a, c = 0;
  o ? (r *= 1 - u * (SIXTH + u * (RA4 + u * RA6)), a = r * r, u = 0) : c = Math.sqrt(u);
  var E = (a - l) / l;
  return {
    es: u,
    e: c,
    ep2: E
  };
}
function sphere(r, e, s, o, a) {
  if (!r) {
    var l = match(ellipsoids, o);
    l || (l = WGS84), r = l.a, e = l.b, s = l.rf;
  }
  return s && !e && (e = (1 - 1 / s) * r), (s === 0 || Math.abs(r - e) < EPSLN) && (a = !0, e = r), {
    a: r,
    b: e,
    rf: s,
    sphere: a
  };
}
var datums = {
  wgs84: {
    towgs84: "0,0,0",
    ellipse: "WGS84",
    datumName: "WGS84"
  },
  ch1903: {
    towgs84: "674.374,15.056,405.346",
    ellipse: "bessel",
    datumName: "swiss"
  },
  ggrs87: {
    towgs84: "-199.87,74.79,246.62",
    ellipse: "GRS80",
    datumName: "Greek_Geodetic_Reference_System_1987"
  },
  nad83: {
    towgs84: "0,0,0",
    ellipse: "GRS80",
    datumName: "North_American_Datum_1983"
  },
  nad27: {
    nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
    ellipse: "clrk66",
    datumName: "North_American_Datum_1927"
  },
  potsdam: {
    towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
    ellipse: "bessel",
    datumName: "Potsdam Rauenberg 1950 DHDN"
  },
  carthage: {
    towgs84: "-263.0,6.0,431.0",
    ellipse: "clark80",
    datumName: "Carthage 1934 Tunisia"
  },
  hermannskogel: {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Hermannskogel"
  },
  mgi: {
    towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
    ellipse: "bessel",
    datumName: "Militar-Geographische Institut"
  },
  osni52: {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "airy",
    datumName: "Irish National"
  },
  ire65: {
    towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
    ellipse: "mod_airy",
    datumName: "Ireland 1965"
  },
  rassadiran: {
    towgs84: "-133.63,-157.5,-158.62",
    ellipse: "intl",
    datumName: "Rassadiran"
  },
  nzgd49: {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
    ellipse: "intl",
    datumName: "New Zealand Geodetic Datum 1949"
  },
  osgb36: {
    towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
    ellipse: "airy",
    datumName: "Ordnance Survey of Great Britain 1936"
  },
  s_jtsk: {
    towgs84: "589,76,480",
    ellipse: "bessel",
    datumName: "S-JTSK (Ferro)"
  },
  beduaram: {
    towgs84: "-106,-87,188",
    ellipse: "clrk80",
    datumName: "Beduaram"
  },
  gunung_segara: {
    towgs84: "-403,684,41",
    ellipse: "bessel",
    datumName: "Gunung Segara Jakarta"
  },
  rnb72: {
    towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
    ellipse: "intl",
    datumName: "Reseau National Belge 1972"
  },
  EPSG_5451: {
    towgs84: "6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649"
  },
  IGNF_LURESG: {
    towgs84: "-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43"
  },
  EPSG_4614: {
    towgs84: "-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065"
  },
  EPSG_4615: {
    towgs84: "-494.088,-312.129,279.877,-1.423,-1.013,1.59,-0.748"
  },
  ESRI_37241: {
    towgs84: "-76.822,257.457,-12.817,2.136,-0.033,-2.392,-0.031"
  },
  ESRI_37249: {
    towgs84: "-440.296,58.548,296.265,1.128,10.202,4.559,-0.438"
  },
  ESRI_37245: {
    towgs84: "-511.151,-181.269,139.609,1.05,2.703,1.798,3.071"
  },
  EPSG_4178: {
    towgs84: "24.9,-126.4,-93.2,-0.063,-0.247,-0.041,1.01"
  },
  EPSG_4622: {
    towgs84: "-472.29,-5.63,-304.12,0.4362,-0.8374,0.2563,1.8984"
  },
  EPSG_4625: {
    towgs84: "126.93,547.94,130.41,-2.7867,5.1612,-0.8584,13.8227"
  },
  EPSG_5252: {
    towgs84: "0.023,0.036,-0.068,0.00176,0.00912,-0.01136,0.00439"
  },
  EPSG_4314: {
    towgs84: "597.1,71.4,412.1,0.894,0.068,-1.563,7.58"
  },
  EPSG_4282: {
    towgs84: "-178.3,-316.7,-131.5,5.278,6.077,10.979,19.166"
  },
  EPSG_4231: {
    towgs84: "-83.11,-97.38,-117.22,0.0276,-0.2167,0.2147,0.1218"
  },
  EPSG_4274: {
    towgs84: "-230.994,102.591,25.199,0.633,-0.239,0.9,1.95"
  },
  EPSG_4134: {
    towgs84: "-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006"
  },
  EPSG_4254: {
    towgs84: "18.38,192.45,96.82,0.056,-0.142,-0.2,-0.0013"
  },
  EPSG_4159: {
    towgs84: "-194.513,-63.978,-25.759,-3.4027,3.756,-3.352,-0.9175"
  },
  EPSG_4687: {
    towgs84: "0.072,-0.507,-0.245,0.0183,-0.0003,0.007,-0.0093"
  },
  EPSG_4227: {
    towgs84: "-83.58,-397.54,458.78,-17.595,-2.847,4.256,3.225"
  },
  EPSG_4746: {
    towgs84: "599.4,72.4,419.2,-0.062,-0.022,-2.723,6.46"
  },
  EPSG_4745: {
    towgs84: "612.4,77,440.2,-0.054,0.057,-2.797,2.55"
  },
  EPSG_6311: {
    towgs84: "8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926"
  },
  EPSG_4289: {
    towgs84: "565.7381,50.4018,465.2904,-1.91514,1.60363,-9.09546,4.07244"
  },
  EPSG_4230: {
    towgs84: "-68.863,-134.888,-111.49,-0.53,-0.14,0.57,-3.4"
  },
  EPSG_4154: {
    towgs84: "-123.02,-158.95,-168.47"
  },
  EPSG_4156: {
    towgs84: "570.8,85.7,462.8,4.998,1.587,5.261,3.56"
  },
  EPSG_4299: {
    towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
  },
  EPSG_4179: {
    towgs84: "33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84"
  },
  EPSG_4313: {
    towgs84: "-106.8686,52.2978,-103.7239,0.3366,-0.457,1.8422,-1.2747"
  },
  EPSG_4194: {
    towgs84: "163.511,127.533,-159.789"
  },
  EPSG_4195: {
    towgs84: "105,326,-102.5"
  },
  EPSG_4196: {
    towgs84: "-45,417,-3.5"
  },
  EPSG_4611: {
    towgs84: "-162.619,-276.959,-161.764,0.067753,-2.243649,-1.158827,-1.094246"
  },
  EPSG_4633: {
    towgs84: "137.092,131.66,91.475,-1.9436,-11.5993,-4.3321,-7.4824"
  },
  EPSG_4641: {
    towgs84: "-408.809,366.856,-412.987,1.8842,-0.5308,2.1655,-121.0993"
  },
  EPSG_4643: {
    towgs84: "-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002"
  },
  EPSG_4300: {
    towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
  },
  EPSG_4188: {
    towgs84: "482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15"
  },
  EPSG_4660: {
    towgs84: "982.6087,552.753,-540.873,32.39344,-153.25684,-96.2266,16.805"
  },
  EPSG_4662: {
    towgs84: "97.295,-263.247,310.882,-1.5999,0.8386,3.1409,13.3259"
  },
  EPSG_3906: {
    towgs84: "577.88891,165.22205,391.18289,4.9145,-0.94729,-13.05098,7.78664"
  },
  EPSG_4307: {
    towgs84: "-209.3622,-87.8162,404.6198,0.0046,3.4784,0.5805,-1.4547"
  },
  EPSG_6892: {
    towgs84: "-76.269,-16.683,68.562,-6.275,10.536,-4.286,-13.686"
  },
  EPSG_4690: {
    towgs84: "221.597,152.441,176.523,2.403,1.3893,0.884,11.4648"
  },
  EPSG_4691: {
    towgs84: "218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817"
  },
  EPSG_4629: {
    towgs84: "72.51,345.411,79.241,-1.5862,-0.8826,-0.5495,1.3653"
  },
  EPSG_4630: {
    towgs84: "165.804,216.213,180.26,-0.6251,-0.4515,-0.0721,7.4111"
  },
  EPSG_4692: {
    towgs84: "217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093"
  },
  EPSG_9333: {
    towgs84: "0,0,0,-8.393,0.749,-10.276,0"
  },
  EPSG_9059: {
    towgs84: "0,0,0"
  },
  EPSG_4312: {
    towgs84: "601.705,84.263,485.227,4.7354,1.3145,5.393,-2.3887"
  },
  EPSG_4123: {
    towgs84: "-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496"
  },
  EPSG_4309: {
    towgs84: "-124.45,183.74,44.64,-0.4384,0.5446,-0.9706,-2.1365"
  },
  ESRI_104106: {
    towgs84: "-283.088,-70.693,117.445,-1.157,0.059,-0.652,-4.058"
  },
  EPSG_4281: {
    towgs84: "-219.247,-73.802,269.529"
  },
  EPSG_4322: {
    towgs84: "0,0,4.5"
  },
  EPSG_4324: {
    towgs84: "0,0,1.9"
  },
  EPSG_4284: {
    towgs84: "43.822,-108.842,-119.585,1.455,-0.761,0.737,0.549"
  },
  EPSG_4277: {
    towgs84: "446.448,-125.157,542.06,0.15,0.247,0.842,-20.489"
  },
  EPSG_4207: {
    towgs84: "-282.1,-72.2,120,-1.529,0.145,-0.89,-4.46"
  },
  EPSG_4688: {
    towgs84: "347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647"
  },
  EPSG_4689: {
    towgs84: "410.793,54.542,80.501,-2.5596,-2.3517,-0.6594,17.3218"
  },
  EPSG_4720: {
    towgs84: "0,0,4.5"
  },
  EPSG_4273: {
    towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21"
  },
  EPSG_4240: {
    towgs84: "204.64,834.74,293.8"
  },
  EPSG_4817: {
    towgs84: "278.3,93,474.5,7.889,0.05,-6.61,6.21"
  },
  ESRI_104131: {
    towgs84: "426.62,142.62,460.09,4.98,4.49,-12.42,-17.1"
  },
  EPSG_4265: {
    towgs84: "-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68"
  },
  EPSG_4263: {
    towgs84: "-111.92,-87.85,114.5,1.875,0.202,0.219,0.032"
  },
  EPSG_4298: {
    towgs84: "-689.5937,623.84046,-65.93566,-0.02331,1.17094,-0.80054,5.88536"
  },
  EPSG_4270: {
    towgs84: "-253.4392,-148.452,386.5267,0.15605,0.43,-0.1013,-0.0424"
  },
  EPSG_4229: {
    towgs84: "-121.8,98.1,-10.7"
  },
  EPSG_4220: {
    towgs84: "-55.5,-348,-229.2"
  },
  EPSG_4214: {
    towgs84: "12.646,-155.176,-80.863"
  },
  EPSG_4232: {
    towgs84: "-345,3,223"
  },
  EPSG_4238: {
    towgs84: "-1.977,-13.06,-9.993,0.364,0.254,0.689,-1.037"
  },
  EPSG_4168: {
    towgs84: "-170,33,326"
  },
  EPSG_4131: {
    towgs84: "199,931,318.9"
  },
  EPSG_4152: {
    towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
  },
  EPSG_5228: {
    towgs84: "572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378"
  },
  EPSG_8351: {
    towgs84: "485.021,169.465,483.839,7.786342,4.397554,4.102655,0"
  },
  EPSG_4683: {
    towgs84: "-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06"
  },
  EPSG_4133: {
    towgs84: "0,0,0"
  },
  EPSG_7373: {
    towgs84: "0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693"
  },
  EPSG_9075: {
    towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
  },
  EPSG_9072: {
    towgs84: "-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0"
  },
  EPSG_9294: {
    towgs84: "1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388"
  },
  EPSG_4212: {
    towgs84: "-267.434,173.496,181.814,-13.4704,8.7154,7.3926,14.7492"
  },
  EPSG_4191: {
    towgs84: "-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703"
  },
  EPSG_4237: {
    towgs84: "52.684,-71.194,-13.975,-0.312,-0.1063,-0.3729,1.0191"
  },
  EPSG_4740: {
    towgs84: "-1.08,-0.27,-0.9"
  },
  EPSG_4124: {
    towgs84: "419.3836,99.3335,591.3451,0.850389,1.817277,-7.862238,-0.99496"
  },
  EPSG_5681: {
    towgs84: "584.9636,107.7175,413.8067,1.1155,0.2824,-3.1384,7.9922"
  },
  EPSG_4141: {
    towgs84: "23.772,17.49,17.859,-0.3132,-1.85274,1.67299,-5.4262"
  },
  EPSG_4204: {
    towgs84: "-85.645,-273.077,-79.708,2.289,-1.421,2.532,3.194"
  },
  EPSG_4319: {
    towgs84: "226.702,-193.337,-35.371,-2.229,-4.391,9.238,0.9798"
  },
  EPSG_4200: {
    towgs84: "24.82,-131.21,-82.66"
  },
  EPSG_4130: {
    towgs84: "0,0,0"
  },
  EPSG_4127: {
    towgs84: "-82.875,-57.097,-156.768,-2.158,1.524,-0.982,-0.359"
  },
  EPSG_4149: {
    towgs84: "674.374,15.056,405.346"
  },
  EPSG_4617: {
    towgs84: "-0.991,1.9072,0.5129,1.25033e-7,4.6785e-8,5.6529e-8,0"
  },
  EPSG_4663: {
    towgs84: "-210.502,-66.902,-48.476,2.094,-15.067,-5.817,0.485"
  },
  EPSG_4664: {
    towgs84: "-211.939,137.626,58.3,-0.089,0.251,0.079,0.384"
  },
  EPSG_4665: {
    towgs84: "-105.854,165.589,-38.312,-0.003,-0.026,0.024,-0.048"
  },
  EPSG_4666: {
    towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43"
  },
  EPSG_4756: {
    towgs84: "-192.873,-39.382,-111.202,-0.00205,-0.0005,0.00335,0.0188"
  },
  EPSG_4723: {
    towgs84: "-179.483,-69.379,-27.584,-7.862,8.163,6.042,-13.925"
  },
  EPSG_4726: {
    towgs84: "8.853,-52.644,180.304,-0.393,-2.323,2.96,-24.081"
  },
  EPSG_4267: {
    towgs84: "-8.0,160.0,176.0"
  },
  EPSG_5365: {
    towgs84: "-0.16959,0.35312,0.51846,0.03385,-0.16325,0.03446,0.03693"
  },
  EPSG_4218: {
    towgs84: "304.5,306.5,-318.1"
  },
  EPSG_4242: {
    towgs84: "-33.722,153.789,94.959,-8.581,-4.478,4.54,8.95"
  },
  EPSG_4216: {
    towgs84: "-292.295,248.758,429.447,4.9971,2.99,6.6906,1.0289"
  },
  ESRI_104105: {
    towgs84: "631.392,-66.551,481.442,1.09,-4.445,-4.487,-4.43"
  },
  ESRI_104129: {
    towgs84: "0,0,0"
  },
  EPSG_4673: {
    towgs84: "174.05,-25.49,112.57"
  },
  EPSG_4202: {
    towgs84: "-124,-60,154"
  },
  EPSG_4203: {
    towgs84: "-117.763,-51.51,139.061,0.292,0.443,0.277,-0.191"
  },
  EPSG_3819: {
    towgs84: "595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408"
  },
  EPSG_8694: {
    towgs84: "-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169"
  },
  EPSG_4145: {
    towgs84: "275.57,676.78,229.6"
  },
  EPSG_4283: {
    towgs84: "61.55,-10.87,-40.19,39.4924,32.7221,32.8979,-9.994"
  },
  EPSG_4317: {
    towgs84: "2.3287,-147.0425,-92.0802,-0.3092483,0.32482185,0.49729934,5.68906266"
  },
  EPSG_4272: {
    towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993"
  },
  EPSG_4248: {
    towgs84: "-307.7,265.3,-363.5"
  },
  EPSG_5561: {
    towgs84: "24,-121,-76"
  },
  EPSG_5233: {
    towgs84: "-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338"
  },
  ESRI_104130: {
    towgs84: "-86,-98,-119"
  },
  ESRI_104102: {
    towgs84: "682,-203,480"
  },
  ESRI_37207: {
    towgs84: "7,-10,-26"
  },
  EPSG_4675: {
    towgs84: "59.935,118.4,-10.871"
  },
  ESRI_104109: {
    towgs84: "-89.121,-348.182,260.871"
  },
  ESRI_104112: {
    towgs84: "-185.583,-230.096,281.361"
  },
  ESRI_104113: {
    towgs84: "25.1,-275.6,222.6"
  },
  IGNF_WGS72G: {
    towgs84: "0,12,6"
  },
  IGNF_NTFG: {
    towgs84: "-168,-60,320"
  },
  IGNF_EFATE57G: {
    towgs84: "-127,-769,472"
  },
  IGNF_PGP50G: {
    towgs84: "324.8,153.6,172.1"
  },
  IGNF_REUN47G: {
    towgs84: "94,-948,-1262"
  },
  IGNF_CSG67G: {
    towgs84: "-186,230,110"
  },
  IGNF_GUAD48G: {
    towgs84: "-467,-16,-300"
  },
  IGNF_TAHI51G: {
    towgs84: "162,117,154"
  },
  IGNF_TAHAAG: {
    towgs84: "65,342,77"
  },
  IGNF_NUKU72G: {
    towgs84: "84,274,65"
  },
  IGNF_PETRELS72G: {
    towgs84: "365,194,166"
  },
  IGNF_WALL78G: {
    towgs84: "253,-133,-127"
  },
  IGNF_MAYO50G: {
    towgs84: "-382,-59,-262"
  },
  IGNF_TANNAG: {
    towgs84: "-139,-967,436"
  },
  IGNF_IGN72G: {
    towgs84: "-13,-348,292"
  },
  IGNF_ATIGG: {
    towgs84: "1118,23,66"
  },
  IGNF_FANGA84G: {
    towgs84: "150.57,158.33,118.32"
  },
  IGNF_RUSAT84G: {
    towgs84: "202.13,174.6,-15.74"
  },
  IGNF_KAUE70G: {
    towgs84: "126.74,300.1,-75.49"
  },
  IGNF_MOP90G: {
    towgs84: "-10.8,-1.8,12.77"
  },
  IGNF_MHPF67G: {
    towgs84: "338.08,212.58,-296.17"
  },
  IGNF_TAHI79G: {
    towgs84: "160.61,116.05,153.69"
  },
  IGNF_ANAA92G: {
    towgs84: "1.5,3.84,4.81"
  },
  IGNF_MARQUI72G: {
    towgs84: "330.91,-13.92,58.56"
  },
  IGNF_APAT86G: {
    towgs84: "143.6,197.82,74.05"
  },
  IGNF_TUBU69G: {
    towgs84: "237.17,171.61,-77.84"
  },
  IGNF_STPM50G: {
    towgs84: "11.363,424.148,373.13"
  },
  EPSG_4150: {
    towgs84: "674.374,15.056,405.346"
  },
  EPSG_4754: {
    towgs84: "-208.4058,-109.8777,-2.5764"
  },
  ESRI_104101: {
    towgs84: "374,150,588"
  },
  EPSG_4693: {
    towgs84: "0,-0.15,0.68"
  },
  EPSG_6207: {
    towgs84: "293.17,726.18,245.36"
  },
  EPSG_4153: {
    towgs84: "-133.63,-157.5,-158.62"
  },
  EPSG_4132: {
    towgs84: "-241.54,-163.64,396.06"
  },
  EPSG_4221: {
    towgs84: "-154.5,150.7,100.4"
  },
  EPSG_4266: {
    towgs84: "-80.7,-132.5,41.1"
  },
  EPSG_4193: {
    towgs84: "-70.9,-151.8,-41.4"
  },
  EPSG_5340: {
    towgs84: "-0.41,0.46,-0.35"
  },
  EPSG_4246: {
    towgs84: "-294.7,-200.1,525.5"
  },
  EPSG_4318: {
    towgs84: "-3.2,-5.7,2.8"
  },
  EPSG_4121: {
    towgs84: "-199.87,74.79,246.62"
  },
  EPSG_4223: {
    towgs84: "-260.1,5.5,432.2"
  },
  EPSG_4158: {
    towgs84: "-0.465,372.095,171.736"
  },
  EPSG_4285: {
    towgs84: "-128.16,-282.42,21.93"
  },
  EPSG_4613: {
    towgs84: "-404.78,685.68,45.47"
  },
  EPSG_4607: {
    towgs84: "195.671,332.517,274.607"
  },
  EPSG_4475: {
    towgs84: "-381.788,-57.501,-256.673"
  },
  EPSG_4208: {
    towgs84: "-157.84,308.54,-146.6"
  },
  EPSG_4743: {
    towgs84: "70.995,-335.916,262.898"
  },
  EPSG_4710: {
    towgs84: "-323.65,551.39,-491.22"
  },
  EPSG_7881: {
    towgs84: "-0.077,0.079,0.086"
  },
  EPSG_4682: {
    towgs84: "283.729,735.942,261.143"
  },
  EPSG_4739: {
    towgs84: "-156,-271,-189"
  },
  EPSG_4679: {
    towgs84: "-80.01,253.26,291.19"
  },
  EPSG_4750: {
    towgs84: "-56.263,16.136,-22.856"
  },
  EPSG_4644: {
    towgs84: "-10.18,-350.43,291.37"
  },
  EPSG_4695: {
    towgs84: "-103.746,-9.614,-255.95"
  },
  EPSG_4292: {
    towgs84: "-355,21,72"
  },
  EPSG_4302: {
    towgs84: "-61.702,284.488,472.052"
  },
  EPSG_4143: {
    towgs84: "-124.76,53,466.79"
  },
  EPSG_4606: {
    towgs84: "-153,153,307"
  },
  EPSG_4699: {
    towgs84: "-770.1,158.4,-498.2"
  },
  EPSG_4247: {
    towgs84: "-273.5,110.6,-357.9"
  },
  EPSG_4160: {
    towgs84: "8.88,184.86,106.69"
  },
  EPSG_4161: {
    towgs84: "-233.43,6.65,173.64"
  },
  EPSG_9251: {
    towgs84: "-9.5,122.9,138.2"
  },
  EPSG_9253: {
    towgs84: "-78.1,101.6,133.3"
  },
  EPSG_4297: {
    towgs84: "-198.383,-240.517,-107.909"
  },
  EPSG_4269: {
    towgs84: "0,0,0"
  },
  EPSG_4301: {
    towgs84: "-147,506,687"
  },
  EPSG_4618: {
    towgs84: "-59,-11,-52"
  },
  EPSG_4612: {
    towgs84: "0,0,0"
  },
  EPSG_4678: {
    towgs84: "44.585,-131.212,-39.544"
  },
  EPSG_4250: {
    towgs84: "-130,29,364"
  },
  EPSG_4144: {
    towgs84: "214,804,268"
  },
  EPSG_4147: {
    towgs84: "-17.51,-108.32,-62.39"
  },
  EPSG_4259: {
    towgs84: "-254.1,-5.36,-100.29"
  },
  EPSG_4164: {
    towgs84: "-76,-138,67"
  },
  EPSG_4211: {
    towgs84: "-378.873,676.002,-46.255"
  },
  EPSG_4182: {
    towgs84: "-422.651,-172.995,84.02"
  },
  EPSG_4224: {
    towgs84: "-143.87,243.37,-33.52"
  },
  EPSG_4225: {
    towgs84: "-205.57,168.77,-4.12"
  },
  EPSG_5527: {
    towgs84: "-67.35,3.88,-38.22"
  },
  EPSG_4752: {
    towgs84: "98,390,-22"
  },
  EPSG_4310: {
    towgs84: "-30,190,89"
  },
  EPSG_9248: {
    towgs84: "-192.26,65.72,132.08"
  },
  EPSG_4680: {
    towgs84: "124.5,-63.5,-281"
  },
  EPSG_4701: {
    towgs84: "-79.9,-158,-168.9"
  },
  EPSG_4706: {
    towgs84: "-146.21,112.63,4.05"
  },
  EPSG_4805: {
    towgs84: "682,-203,480"
  },
  EPSG_4201: {
    towgs84: "-165,-11,206"
  },
  EPSG_4210: {
    towgs84: "-157,-2,-299"
  },
  EPSG_4183: {
    towgs84: "-104,167,-38"
  },
  EPSG_4139: {
    towgs84: "11,72,-101"
  },
  EPSG_4668: {
    towgs84: "-86,-98,-119"
  },
  EPSG_4717: {
    towgs84: "-2,151,181"
  },
  EPSG_4732: {
    towgs84: "102,52,-38"
  },
  EPSG_4280: {
    towgs84: "-377,681,-50"
  },
  EPSG_4209: {
    towgs84: "-138,-105,-289"
  },
  EPSG_4261: {
    towgs84: "31,146,47"
  },
  EPSG_4658: {
    towgs84: "-73,46,-86"
  },
  EPSG_4721: {
    towgs84: "265.025,384.929,-194.046"
  },
  EPSG_4222: {
    towgs84: "-136,-108,-292"
  },
  EPSG_4601: {
    towgs84: "-255,-15,71"
  },
  EPSG_4602: {
    towgs84: "725,685,536"
  },
  EPSG_4603: {
    towgs84: "72,213.7,93"
  },
  EPSG_4605: {
    towgs84: "9,183,236"
  },
  EPSG_4621: {
    towgs84: "137,248,-430"
  },
  EPSG_4657: {
    towgs84: "-28,199,5"
  },
  EPSG_4316: {
    towgs84: "103.25,-100.4,-307.19"
  },
  EPSG_4642: {
    towgs84: "-13,-348,292"
  },
  EPSG_4698: {
    towgs84: "145,-187,103"
  },
  EPSG_4192: {
    towgs84: "-206.1,-174.7,-87.7"
  },
  EPSG_4311: {
    towgs84: "-265,120,-358"
  },
  EPSG_4135: {
    towgs84: "58,-283,-182"
  },
  ESRI_104138: {
    towgs84: "198,-226,-347"
  },
  EPSG_4245: {
    towgs84: "-11,851,5"
  },
  EPSG_4142: {
    towgs84: "-125,53,467"
  },
  EPSG_4213: {
    towgs84: "-106,-87,188"
  },
  EPSG_4253: {
    towgs84: "-133,-77,-51"
  },
  EPSG_4129: {
    towgs84: "-132,-110,-335"
  },
  EPSG_4713: {
    towgs84: "-77,-128,142"
  },
  EPSG_4239: {
    towgs84: "217,823,299"
  },
  EPSG_4146: {
    towgs84: "295,736,257"
  },
  EPSG_4155: {
    towgs84: "-83,37,124"
  },
  EPSG_4165: {
    towgs84: "-173,253,27"
  },
  EPSG_4672: {
    towgs84: "175,-38,113"
  },
  EPSG_4236: {
    towgs84: "-637,-549,-203"
  },
  EPSG_4251: {
    towgs84: "-90,40,88"
  },
  EPSG_4271: {
    towgs84: "-2,374,172"
  },
  EPSG_4175: {
    towgs84: "-88,4,101"
  },
  EPSG_4716: {
    towgs84: "298,-304,-375"
  },
  EPSG_4315: {
    towgs84: "-23,259,-9"
  },
  EPSG_4744: {
    towgs84: "-242.2,-144.9,370.3"
  },
  EPSG_4244: {
    towgs84: "-97,787,86"
  },
  EPSG_4293: {
    towgs84: "616,97,-251"
  },
  EPSG_4714: {
    towgs84: "-127,-769,472"
  },
  EPSG_4736: {
    towgs84: "260,12,-147"
  },
  EPSG_6883: {
    towgs84: "-235,-110,393"
  },
  EPSG_6894: {
    towgs84: "-63,176,185"
  },
  EPSG_4205: {
    towgs84: "-43,-163,45"
  },
  EPSG_4256: {
    towgs84: "41,-220,-134"
  },
  EPSG_4262: {
    towgs84: "639,405,60"
  },
  EPSG_4604: {
    towgs84: "174,359,365"
  },
  EPSG_4169: {
    towgs84: "-115,118,426"
  },
  EPSG_4620: {
    towgs84: "-106,-129,165"
  },
  EPSG_4184: {
    towgs84: "-203,141,53"
  },
  EPSG_4616: {
    towgs84: "-289,-124,60"
  },
  EPSG_9403: {
    towgs84: "-307,-92,127"
  },
  EPSG_4684: {
    towgs84: "-133,-321,50"
  },
  EPSG_4708: {
    towgs84: "-491,-22,435"
  },
  EPSG_4707: {
    towgs84: "114,-116,-333"
  },
  EPSG_4709: {
    towgs84: "145,75,-272"
  },
  EPSG_4712: {
    towgs84: "-205,107,53"
  },
  EPSG_4711: {
    towgs84: "124,-234,-25"
  },
  EPSG_4718: {
    towgs84: "230,-199,-752"
  },
  EPSG_4719: {
    towgs84: "211,147,111"
  },
  EPSG_4724: {
    towgs84: "208,-435,-229"
  },
  EPSG_4725: {
    towgs84: "189,-79,-202"
  },
  EPSG_4735: {
    towgs84: "647,1777,-1124"
  },
  EPSG_4722: {
    towgs84: "-794,119,-298"
  },
  EPSG_4728: {
    towgs84: "-307,-92,127"
  },
  EPSG_4734: {
    towgs84: "-632,438,-609"
  },
  EPSG_4727: {
    towgs84: "912,-58,1227"
  },
  EPSG_4729: {
    towgs84: "185,165,42"
  },
  EPSG_4730: {
    towgs84: "170,42,84"
  },
  EPSG_4733: {
    towgs84: "276,-57,149"
  },
  ESRI_37218: {
    towgs84: "230,-199,-752"
  },
  ESRI_37240: {
    towgs84: "-7,215,225"
  },
  ESRI_37221: {
    towgs84: "252,-209,-751"
  },
  ESRI_4305: {
    towgs84: "-123,-206,219"
  },
  ESRI_104139: {
    towgs84: "-73,-247,227"
  },
  EPSG_4748: {
    towgs84: "51,391,-36"
  },
  EPSG_4219: {
    towgs84: "-384,664,-48"
  },
  EPSG_4255: {
    towgs84: "-333,-222,114"
  },
  EPSG_4257: {
    towgs84: "-587.8,519.75,145.76"
  },
  EPSG_4646: {
    towgs84: "-963,510,-359"
  },
  EPSG_6881: {
    towgs84: "-24,-203,268"
  },
  EPSG_6882: {
    towgs84: "-183,-15,273"
  },
  EPSG_4715: {
    towgs84: "-104,-129,239"
  },
  IGNF_RGF93GDD: {
    towgs84: "0,0,0"
  },
  IGNF_RGM04GDD: {
    towgs84: "0,0,0"
  },
  IGNF_RGSPM06GDD: {
    towgs84: "0,0,0"
  },
  IGNF_RGTAAF07GDD: {
    towgs84: "0,0,0"
  },
  IGNF_RGFG95GDD: {
    towgs84: "0,0,0"
  },
  IGNF_RGNCG: {
    towgs84: "0,0,0"
  },
  IGNF_RGPFGDD: {
    towgs84: "0,0,0"
  },
  IGNF_ETRS89G: {
    towgs84: "0,0,0"
  },
  IGNF_RGR92GDD: {
    towgs84: "0,0,0"
  },
  EPSG_4173: {
    towgs84: "0,0,0"
  },
  EPSG_4180: {
    towgs84: "0,0,0"
  },
  EPSG_4619: {
    towgs84: "0,0,0"
  },
  EPSG_4667: {
    towgs84: "0,0,0"
  },
  EPSG_4075: {
    towgs84: "0,0,0"
  },
  EPSG_6706: {
    towgs84: "0,0,0"
  },
  EPSG_7798: {
    towgs84: "0,0,0"
  },
  EPSG_4661: {
    towgs84: "0,0,0"
  },
  EPSG_4669: {
    towgs84: "0,0,0"
  },
  EPSG_8685: {
    towgs84: "0,0,0"
  },
  EPSG_4151: {
    towgs84: "0,0,0"
  },
  EPSG_9702: {
    towgs84: "0,0,0"
  },
  EPSG_4758: {
    towgs84: "0,0,0"
  },
  EPSG_4761: {
    towgs84: "0,0,0"
  },
  EPSG_4765: {
    towgs84: "0,0,0"
  },
  EPSG_8997: {
    towgs84: "0,0,0"
  },
  EPSG_4023: {
    towgs84: "0,0,0"
  },
  EPSG_4670: {
    towgs84: "0,0,0"
  },
  EPSG_4694: {
    towgs84: "0,0,0"
  },
  EPSG_4148: {
    towgs84: "0,0,0"
  },
  EPSG_4163: {
    towgs84: "0,0,0"
  },
  EPSG_4167: {
    towgs84: "0,0,0"
  },
  EPSG_4189: {
    towgs84: "0,0,0"
  },
  EPSG_4190: {
    towgs84: "0,0,0"
  },
  EPSG_4176: {
    towgs84: "0,0,0"
  },
  EPSG_4659: {
    towgs84: "0,0,0"
  },
  EPSG_3824: {
    towgs84: "0,0,0"
  },
  EPSG_3889: {
    towgs84: "0,0,0"
  },
  EPSG_4046: {
    towgs84: "0,0,0"
  },
  EPSG_4081: {
    towgs84: "0,0,0"
  },
  EPSG_4558: {
    towgs84: "0,0,0"
  },
  EPSG_4483: {
    towgs84: "0,0,0"
  },
  EPSG_5013: {
    towgs84: "0,0,0"
  },
  EPSG_5264: {
    towgs84: "0,0,0"
  },
  EPSG_5324: {
    towgs84: "0,0,0"
  },
  EPSG_5354: {
    towgs84: "0,0,0"
  },
  EPSG_5371: {
    towgs84: "0,0,0"
  },
  EPSG_5373: {
    towgs84: "0,0,0"
  },
  EPSG_5381: {
    towgs84: "0,0,0"
  },
  EPSG_5393: {
    towgs84: "0,0,0"
  },
  EPSG_5489: {
    towgs84: "0,0,0"
  },
  EPSG_5593: {
    towgs84: "0,0,0"
  },
  EPSG_6135: {
    towgs84: "0,0,0"
  },
  EPSG_6365: {
    towgs84: "0,0,0"
  },
  EPSG_5246: {
    towgs84: "0,0,0"
  },
  EPSG_7886: {
    towgs84: "0,0,0"
  },
  EPSG_8431: {
    towgs84: "0,0,0"
  },
  EPSG_8427: {
    towgs84: "0,0,0"
  },
  EPSG_8699: {
    towgs84: "0,0,0"
  },
  EPSG_8818: {
    towgs84: "0,0,0"
  },
  EPSG_4757: {
    towgs84: "0,0,0"
  },
  EPSG_9140: {
    towgs84: "0,0,0"
  },
  EPSG_8086: {
    towgs84: "0,0,0"
  },
  EPSG_4686: {
    towgs84: "0,0,0"
  },
  EPSG_4737: {
    towgs84: "0,0,0"
  },
  EPSG_4702: {
    towgs84: "0,0,0"
  },
  EPSG_4747: {
    towgs84: "0,0,0"
  },
  EPSG_4749: {
    towgs84: "0,0,0"
  },
  EPSG_4674: {
    towgs84: "0,0,0"
  },
  EPSG_4755: {
    towgs84: "0,0,0"
  },
  EPSG_4759: {
    towgs84: "0,0,0"
  },
  EPSG_4762: {
    towgs84: "0,0,0"
  },
  EPSG_4763: {
    towgs84: "0,0,0"
  },
  EPSG_4764: {
    towgs84: "0,0,0"
  },
  EPSG_4166: {
    towgs84: "0,0,0"
  },
  EPSG_4170: {
    towgs84: "0,0,0"
  },
  EPSG_5546: {
    towgs84: "0,0,0"
  },
  EPSG_7844: {
    towgs84: "0,0,0"
  },
  EPSG_4818: {
    towgs84: "589,76,480"
  }
};
for (var key in datums) {
  var datum$1 = datums[key];
  datum$1.datumName && (datums[datum$1.datumName] = datum$1);
}
function datum(r, e, s, o, a, l, u) {
  var c = {};
  return r === void 0 || r === "none" ? c.datum_type = PJD_NODATUM : c.datum_type = PJD_WGS84, e && (c.datum_params = e.map(parseFloat), (c.datum_params[0] !== 0 || c.datum_params[1] !== 0 || c.datum_params[2] !== 0) && (c.datum_type = PJD_3PARAM), c.datum_params.length > 3 && (c.datum_params[3] !== 0 || c.datum_params[4] !== 0 || c.datum_params[5] !== 0 || c.datum_params[6] !== 0) && (c.datum_type = PJD_7PARAM, c.datum_params[3] *= SEC_TO_RAD, c.datum_params[4] *= SEC_TO_RAD, c.datum_params[5] *= SEC_TO_RAD, c.datum_params[6] = c.datum_params[6] / 1e6 + 1)), u && (c.datum_type = PJD_GRIDSHIFT, c.grids = u), c.a = s, c.b = o, c.es = a, c.ep2 = l, c;
}
var loadedNadgrids = {};
function nadgrid(r, e, s) {
  return e instanceof ArrayBuffer ? readNTV2Grid(r, e, s) : { ready: readGeotiffGrid(r, e) };
}
function readNTV2Grid(r, e, s) {
  var o = !0;
  s !== void 0 && s.includeErrorFields === !1 && (o = !1);
  var a = new DataView(e), l = detectLittleEndian(a), u = readHeader(a, l), c = readSubgrids(a, u, l, o), E = { header: u, subgrids: c };
  return loadedNadgrids[r] = E, E;
}
async function readGeotiffGrid(r, e) {
  for (var s = [], o = await e.getImageCount(), a = o - 1; a >= 0; a--) {
    var l = await e.getImage(a), u = await l.readRasters(), c = u, E = [l.getWidth(), l.getHeight()], d = l.getBoundingBox().map(degreesToRadians), f = [l.fileDirectory.ModelPixelScale[0], l.fileDirectory.ModelPixelScale[1]].map(degreesToRadians), h = d[0] + (E[0] - 1) * f[0], S = d[3] - (E[1] - 1) * f[1], R = c[0], _ = c[1], m = [];
    for (let W = E[1] - 1; W >= 0; W--)
      for (let G = E[0] - 1; G >= 0; G--) {
        var L = W * E[0] + G;
        m.push([-secondsToRadians(_[L]), secondsToRadians(R[L])]);
      }
    s.push({
      del: f,
      lim: E,
      ll: [-h, S],
      cvs: m
    });
  }
  var F = {
    header: {
      nSubgrids: o
    },
    subgrids: s
  };
  return loadedNadgrids[r] = F, F;
}
function getNadgrids(r) {
  if (r === void 0)
    return null;
  var e = r.split(",");
  return e.map(parseNadgridString);
}
function parseNadgridString(r) {
  if (r.length === 0)
    return null;
  var e = r[0] === "@";
  return e && (r = r.slice(1)), r === "null" ? { name: "null", mandatory: !e, grid: null, isNull: !0 } : {
    name: r,
    mandatory: !e,
    grid: loadedNadgrids[r] || null,
    isNull: !1
  };
}
function degreesToRadians(r) {
  return r * Math.PI / 180;
}
function secondsToRadians(r) {
  return r / 3600 * Math.PI / 180;
}
function detectLittleEndian(r) {
  var e = r.getInt32(8, !1);
  return e === 11 ? !1 : (e = r.getInt32(8, !0), e !== 11 && console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian"), !0);
}
function readHeader(r, e) {
  return {
    nFields: r.getInt32(8, e),
    nSubgridFields: r.getInt32(24, e),
    nSubgrids: r.getInt32(40, e),
    shiftType: decodeString(r, 56, 56 + 8).trim(),
    fromSemiMajorAxis: r.getFloat64(120, e),
    fromSemiMinorAxis: r.getFloat64(136, e),
    toSemiMajorAxis: r.getFloat64(152, e),
    toSemiMinorAxis: r.getFloat64(168, e)
  };
}
function decodeString(r, e, s) {
  return String.fromCharCode.apply(null, new Uint8Array(r.buffer.slice(e, s)));
}
function readSubgrids(r, e, s, o) {
  for (var a = 176, l = [], u = 0; u < e.nSubgrids; u++) {
    var c = readGridHeader(r, a, s), E = readGridNodes(r, a, c, s, o), d = Math.round(
      1 + (c.upperLongitude - c.lowerLongitude) / c.longitudeInterval
    ), f = Math.round(
      1 + (c.upperLatitude - c.lowerLatitude) / c.latitudeInterval
    );
    l.push({
      ll: [secondsToRadians(c.lowerLongitude), secondsToRadians(c.lowerLatitude)],
      del: [secondsToRadians(c.longitudeInterval), secondsToRadians(c.latitudeInterval)],
      lim: [d, f],
      count: c.gridNodeCount,
      cvs: mapNodes(E)
    });
    var h = 16;
    o === !1 && (h = 8), a += 176 + c.gridNodeCount * h;
  }
  return l;
}
function mapNodes(r) {
  return r.map(function(e) {
    return [secondsToRadians(e.longitudeShift), secondsToRadians(e.latitudeShift)];
  });
}
function readGridHeader(r, e, s) {
  return {
    name: decodeString(r, e + 8, e + 16).trim(),
    parent: decodeString(r, e + 24, e + 24 + 8).trim(),
    lowerLatitude: r.getFloat64(e + 72, s),
    upperLatitude: r.getFloat64(e + 88, s),
    lowerLongitude: r.getFloat64(e + 104, s),
    upperLongitude: r.getFloat64(e + 120, s),
    latitudeInterval: r.getFloat64(e + 136, s),
    longitudeInterval: r.getFloat64(e + 152, s),
    gridNodeCount: r.getInt32(e + 168, s)
  };
}
function readGridNodes(r, e, s, o, a) {
  var l = e + 176, u = 16;
  a === !1 && (u = 8);
  for (var c = [], E = 0; E < s.gridNodeCount; E++) {
    var d = {
      latitudeShift: r.getFloat32(l + E * u, o),
      longitudeShift: r.getFloat32(l + E * u + 4, o)
    };
    a !== !1 && (d.latitudeAccuracy = r.getFloat32(l + E * u + 8, o), d.longitudeAccuracy = r.getFloat32(l + E * u + 12, o)), c.push(d);
  }
  return c;
}
function Projection(r, e) {
  if (!(this instanceof Projection))
    return new Projection(r);
  this.forward = null, this.inverse = null, this.name, this.title, e = e || function(d) {
    if (d)
      throw d;
  };
  var s = parse$1(r);
  if (typeof s != "object") {
    e("Could not parse to valid json: " + r);
    return;
  }
  var o = Projection.projections.get(s.projName);
  if (!o) {
    e("Could not get projection name from: " + r);
    return;
  }
  if (s.datumCode && s.datumCode !== "none") {
    var a = match(datums, s.datumCode);
    a && (s.datum_params = s.datum_params || (a.towgs84 ? a.towgs84.split(",") : null), s.ellps = a.ellipse, s.datumName = a.datumName ? a.datumName : s.datumCode);
  }
  s.k0 = s.k0 || 1, s.axis = s.axis || "enu", s.ellps = s.ellps || "wgs84", s.lat1 = s.lat1 || s.lat0;
  var l = sphere(s.a, s.b, s.rf, s.ellps, s.sphere), u = eccentricity(l.a, l.b, l.rf, s.R_A), c = getNadgrids(s.nadgrids), E = s.datum || datum(
    s.datumCode,
    s.datum_params,
    l.a,
    l.b,
    u.es,
    u.ep2,
    c
  );
  extend(this, s), extend(this, o), this.a = l.a, this.b = l.b, this.rf = l.rf, this.sphere = l.sphere, this.es = u.es, this.e = u.e, this.ep2 = u.ep2, this.datum = E, "init" in this && typeof this.init == "function" && this.init(), e(null, this);
}
Projection.projections = projections;
Projection.projections.start();
function compareDatums(r, e) {
  return r.datum_type !== e.datum_type || r.a !== e.a || Math.abs(r.es - e.es) > 5e-11 ? !1 : r.datum_type === PJD_3PARAM ? r.datum_params[0] === e.datum_params[0] && r.datum_params[1] === e.datum_params[1] && r.datum_params[2] === e.datum_params[2] : r.datum_type === PJD_7PARAM ? r.datum_params[0] === e.datum_params[0] && r.datum_params[1] === e.datum_params[1] && r.datum_params[2] === e.datum_params[2] && r.datum_params[3] === e.datum_params[3] && r.datum_params[4] === e.datum_params[4] && r.datum_params[5] === e.datum_params[5] && r.datum_params[6] === e.datum_params[6] : !0;
}
function geodeticToGeocentric(r, e, s) {
  var o = r.x, a = r.y, l = r.z ? r.z : 0, u, c, E, d;
  if (a < -HALF_PI && a > -1.001 * HALF_PI)
    a = -HALF_PI;
  else if (a > HALF_PI && a < 1.001 * HALF_PI)
    a = HALF_PI;
  else {
    if (a < -HALF_PI)
      return { x: -1 / 0, y: -1 / 0, z: r.z };
    if (a > HALF_PI)
      return { x: 1 / 0, y: 1 / 0, z: r.z };
  }
  return o > Math.PI && (o -= 2 * Math.PI), c = Math.sin(a), d = Math.cos(a), E = c * c, u = s / Math.sqrt(1 - e * E), {
    x: (u + l) * d * Math.cos(o),
    y: (u + l) * d * Math.sin(o),
    z: (u * (1 - e) + l) * c
  };
}
function geocentricToGeodetic(r, e, s, o) {
  var a = 1e-12, l = a * a, u = 30, c, E, d, f, h, S, R, _, m, L, F, W, G, q = r.x, fe = r.y, _e = r.z ? r.z : 0, Le, Fe, Ee;
  if (c = Math.sqrt(q * q + fe * fe), E = Math.sqrt(q * q + fe * fe + _e * _e), c / s < a) {
    if (Le = 0, E / s < a)
      return Fe = HALF_PI, Ee = -o, {
        x: r.x,
        y: r.y,
        z: r.z
      };
  } else
    Le = Math.atan2(fe, q);
  d = _e / E, f = c / E, h = 1 / Math.sqrt(1 - e * (2 - e) * f * f), _ = f * (1 - e) * h, m = d * h, G = 0;
  do
    G++, R = s / Math.sqrt(1 - e * m * m), Ee = c * _ + _e * m - R * (1 - e * m * m), S = e * R / (R + Ee), h = 1 / Math.sqrt(1 - S * (2 - S) * f * f), L = f * (1 - S) * h, F = d * h, W = F * _ - L * m, _ = L, m = F;
  while (W * W > l && G < u);
  return Fe = Math.atan(F / Math.abs(L)), {
    x: Le,
    y: Fe,
    z: Ee
  };
}
function geocentricToWgs84(r, e, s) {
  if (e === PJD_3PARAM)
    return {
      x: r.x + s[0],
      y: r.y + s[1],
      z: r.z + s[2]
    };
  if (e === PJD_7PARAM) {
    var o = s[0], a = s[1], l = s[2], u = s[3], c = s[4], E = s[5], d = s[6];
    return {
      x: d * (r.x - E * r.y + c * r.z) + o,
      y: d * (E * r.x + r.y - u * r.z) + a,
      z: d * (-c * r.x + u * r.y + r.z) + l
    };
  }
}
function geocentricFromWgs84(r, e, s) {
  if (e === PJD_3PARAM)
    return {
      x: r.x - s[0],
      y: r.y - s[1],
      z: r.z - s[2]
    };
  if (e === PJD_7PARAM) {
    var o = s[0], a = s[1], l = s[2], u = s[3], c = s[4], E = s[5], d = s[6], f = (r.x - o) / d, h = (r.y - a) / d, S = (r.z - l) / d;
    return {
      x: f + E * h - c * S,
      y: -E * f + h + u * S,
      z: c * f - u * h + S
    };
  }
}
function checkParams(r) {
  return r === PJD_3PARAM || r === PJD_7PARAM;
}
function datum_transform(r, e, s) {
  if (compareDatums(r, e) || r.datum_type === PJD_NODATUM || e.datum_type === PJD_NODATUM)
    return s;
  var o = r.a, a = r.es;
  if (r.datum_type === PJD_GRIDSHIFT) {
    var l = applyGridShift(r, !1, s);
    if (l !== 0)
      return;
    o = SRS_WGS84_SEMIMAJOR, a = SRS_WGS84_ESQUARED;
  }
  var u = e.a, c = e.b, E = e.es;
  if (e.datum_type === PJD_GRIDSHIFT && (u = SRS_WGS84_SEMIMAJOR, c = SRS_WGS84_SEMIMINOR, E = SRS_WGS84_ESQUARED), a === E && o === u && !checkParams(r.datum_type) && !checkParams(e.datum_type))
    return s;
  if (s = geodeticToGeocentric(s, a, o), checkParams(r.datum_type) && (s = geocentricToWgs84(s, r.datum_type, r.datum_params)), checkParams(e.datum_type) && (s = geocentricFromWgs84(s, e.datum_type, e.datum_params)), s = geocentricToGeodetic(s, E, u, c), e.datum_type === PJD_GRIDSHIFT) {
    var d = applyGridShift(e, !0, s);
    if (d !== 0)
      return;
  }
  return s;
}
function applyGridShift(r, e, s) {
  if (r.grids === null || r.grids.length === 0)
    return console.log("Grid shift grids not found"), -1;
  var o = { x: -s.x, y: s.y }, a = { x: Number.NaN, y: Number.NaN }, l = [];
  e:
    for (var u = 0; u < r.grids.length; u++) {
      var c = r.grids[u];
      if (l.push(c.name), c.isNull) {
        a = o;
        break;
      }
      if (c.grid === null) {
        if (c.mandatory)
          return console.log("Unable to find mandatory grid '" + c.name + "'"), -1;
        continue;
      }
      for (var E = c.grid.subgrids, d = 0, f = E.length; d < f; d++) {
        var h = E[d], S = (Math.abs(h.del[1]) + Math.abs(h.del[0])) / 1e4, R = h.ll[0] - S, _ = h.ll[1] - S, m = h.ll[0] + (h.lim[0] - 1) * h.del[0] + S, L = h.ll[1] + (h.lim[1] - 1) * h.del[1] + S;
        if (!(_ > o.y || R > o.x || L < o.y || m < o.x) && (a = applySubgridShift(o, e, h), !isNaN(a.x)))
          break e;
      }
    }
  return isNaN(a.x) ? (console.log("Failed to find a grid shift table for location '" + -o.x * R2D + " " + o.y * R2D + " tried: '" + l + "'"), -1) : (s.x = -a.x, s.y = a.y, 0);
}
function applySubgridShift(r, e, s) {
  var o = { x: Number.NaN, y: Number.NaN };
  if (isNaN(r.x))
    return o;
  var a = { x: r.x, y: r.y };
  a.x -= s.ll[0], a.y -= s.ll[1], a.x = adjust_lon(a.x - Math.PI) + Math.PI;
  var l = nadInterpolate(a, s);
  if (e) {
    if (isNaN(l.x))
      return o;
    l.x = a.x - l.x, l.y = a.y - l.y;
    var u = 9, c = 1e-12, E, d;
    do {
      if (d = nadInterpolate(l, s), isNaN(d.x)) {
        console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
        break;
      }
      E = { x: a.x - (d.x + l.x), y: a.y - (d.y + l.y) }, l.x += E.x, l.y += E.y;
    } while (u-- && Math.abs(E.x) > c && Math.abs(E.y) > c);
    if (u < 0)
      return console.log("Inverse grid shift iterator failed to converge."), o;
    o.x = adjust_lon(l.x + s.ll[0]), o.y = l.y + s.ll[1];
  } else
    isNaN(l.x) || (o.x = r.x + l.x, o.y = r.y + l.y);
  return o;
}
function nadInterpolate(r, e) {
  var s = { x: r.x / e.del[0], y: r.y / e.del[1] }, o = { x: Math.floor(s.x), y: Math.floor(s.y) }, a = { x: s.x - 1 * o.x, y: s.y - 1 * o.y }, l = { x: Number.NaN, y: Number.NaN }, u;
  if (o.x < 0 || o.x >= e.lim[0] || o.y < 0 || o.y >= e.lim[1])
    return l;
  u = o.y * e.lim[0] + o.x;
  var c = { x: e.cvs[u][0], y: e.cvs[u][1] };
  u++;
  var E = { x: e.cvs[u][0], y: e.cvs[u][1] };
  u += e.lim[0];
  var d = { x: e.cvs[u][0], y: e.cvs[u][1] };
  u--;
  var f = { x: e.cvs[u][0], y: e.cvs[u][1] }, h = a.x * a.y, S = a.x * (1 - a.y), R = (1 - a.x) * (1 - a.y), _ = (1 - a.x) * a.y;
  return l.x = R * c.x + S * E.x + _ * f.x + h * d.x, l.y = R * c.y + S * E.y + _ * f.y + h * d.y, l;
}
function adjust_axis(r, e, s) {
  var o = s.x, a = s.y, l = s.z || 0, u, c, E, d = {};
  for (E = 0; E < 3; E++)
    if (!(e && E === 2 && s.z === void 0))
      switch (E === 0 ? (u = o, "ew".indexOf(r.axis[E]) !== -1 ? c = "x" : c = "y") : E === 1 ? (u = a, "ns".indexOf(r.axis[E]) !== -1 ? c = "y" : c = "x") : (u = l, c = "z"), r.axis[E]) {
        case "e":
          d[c] = u;
          break;
        case "w":
          d[c] = -u;
          break;
        case "n":
          d[c] = u;
          break;
        case "s":
          d[c] = -u;
          break;
        case "u":
          s[c] !== void 0 && (d.z = u);
          break;
        case "d":
          s[c] !== void 0 && (d.z = -u);
          break;
        default:
          return null;
      }
  return d;
}
function common(r) {
  var e = {
    x: r[0],
    y: r[1]
  };
  return r.length > 2 && (e.z = r[2]), r.length > 3 && (e.m = r[3]), e;
}
function checkSanity(r) {
  checkCoord(r.x), checkCoord(r.y);
}
function checkCoord(r) {
  if (typeof Number.isFinite == "function") {
    if (Number.isFinite(r))
      return;
    throw new TypeError("coordinates must be finite numbers");
  }
  if (typeof r != "number" || r !== r || !isFinite(r))
    throw new TypeError("coordinates must be finite numbers");
}
function checkNotWGS(r, e) {
  return (r.datum.datum_type === PJD_3PARAM || r.datum.datum_type === PJD_7PARAM || r.datum.datum_type === PJD_GRIDSHIFT) && e.datumCode !== "WGS84" || (e.datum.datum_type === PJD_3PARAM || e.datum.datum_type === PJD_7PARAM || e.datum.datum_type === PJD_GRIDSHIFT) && r.datumCode !== "WGS84";
}
function transform(r, e, s, o) {
  var a;
  Array.isArray(s) ? s = common(s) : s = {
    x: s.x,
    y: s.y,
    z: s.z,
    m: s.m
  };
  var l = s.z !== void 0;
  if (checkSanity(s), r.datum && e.datum && checkNotWGS(r, e) && (a = new Projection("WGS84"), s = transform(r, a, s, o), r = a), o && r.axis !== "enu" && (s = adjust_axis(r, !1, s)), r.projName === "longlat")
    s = {
      x: s.x * D2R$1,
      y: s.y * D2R$1,
      z: s.z || 0
    };
  else if (r.to_meter && (s = {
    x: s.x * r.to_meter,
    y: s.y * r.to_meter,
    z: s.z || 0
  }), s = r.inverse(s), !s)
    return;
  if (r.from_greenwich && (s.x += r.from_greenwich), s = datum_transform(r.datum, e.datum, s), !!s)
    return s = /** @type {import('./core').InterfaceCoordinates} */
    s, e.from_greenwich && (s = {
      x: s.x - e.from_greenwich,
      y: s.y,
      z: s.z || 0
    }), e.projName === "longlat" ? s = {
      x: s.x * R2D,
      y: s.y * R2D,
      z: s.z || 0
    } : (s = e.forward(s), e.to_meter && (s = {
      x: s.x / e.to_meter,
      y: s.y / e.to_meter,
      z: s.z || 0
    })), o && e.axis !== "enu" ? adjust_axis(e, !0, s) : (s && !l && delete s.z, s);
}
var wgs84 = Projection("WGS84");
function transformer(r, e, s, o) {
  var a, l, u;
  return Array.isArray(s) ? (a = transform(r, e, s, o) || { x: NaN, y: NaN }, s.length > 2 ? typeof r.name < "u" && r.name === "geocent" || typeof e.name < "u" && e.name === "geocent" ? typeof a.z == "number" ? (
    /** @type {T} */
    [a.x, a.y, a.z].concat(s.slice(3))
  ) : (
    /** @type {T} */
    [a.x, a.y, s[2]].concat(s.slice(3))
  ) : (
    /** @type {T} */
    [a.x, a.y].concat(s.slice(2))
  ) : (
    /** @type {T} */
    [a.x, a.y]
  )) : (l = transform(r, e, s, o), u = Object.keys(s), u.length === 2 || u.forEach(function(c) {
    if (typeof r.name < "u" && r.name === "geocent" || typeof e.name < "u" && e.name === "geocent") {
      if (c === "x" || c === "y" || c === "z")
        return;
    } else if (c === "x" || c === "y")
      return;
    l[c] = s[c];
  }), /** @type {T} */
  l);
}
function checkProj(r) {
  return r instanceof Projection ? r : typeof r == "object" && "oProj" in r ? r.oProj : Projection(
    /** @type {string | PROJJSONDefinition} */
    r
  );
}
function proj4$1(r, e, s) {
  var o, a, l = !1, u;
  return typeof e > "u" ? (a = checkProj(r), o = wgs84, l = !0) : (typeof /** @type {?} */
  e.x < "u" || Array.isArray(e)) && (s = /** @type {T} */
  /** @type {?} */
  e, a = checkProj(r), o = wgs84, l = !0), o || (o = checkProj(r)), a || (a = checkProj(
    /** @type {string | PROJJSONDefinition | proj } */
    e
  )), s ? transformer(o, a, s) : (u = {
    /**
     * @template {TemplateCoordinates} T
     * @param {T} coords
     * @param {boolean=} enforceAxis
     * @returns {T}
     */
    forward: function(c, E) {
      return transformer(o, a, c, E);
    },
    /**
     * @template {TemplateCoordinates} T
     * @param {T} coords
     * @param {boolean=} enforceAxis
     * @returns {T}
     */
    inverse: function(c, E) {
      return transformer(a, o, c, E);
    }
  }, l && (u.oProj = a), u);
}
var NUM_100K_SETS = 6, SET_ORIGIN_COLUMN_LETTERS = "AJSAJS", SET_ORIGIN_ROW_LETTERS = "AFAFAF", A = 65, I = 73, O = 79, V = 86, Z = 90;
const mgrs = {
  forward: forward$u,
  inverse: inverse$u,
  toPoint
};
function forward$u(r, e) {
  return e = e || 5, encode$1(LLtoUTM({
    lat: r[1],
    lon: r[0]
  }), e);
}
function inverse$u(r) {
  var e = UTMtoLL(decode$2(r.toUpperCase()));
  return e.lat && e.lon ? [e.lon, e.lat, e.lon, e.lat] : [e.left, e.bottom, e.right, e.top];
}
function toPoint(r) {
  var e = UTMtoLL(decode$2(r.toUpperCase()));
  return e.lat && e.lon ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
}
function degToRad(r) {
  return r * (Math.PI / 180);
}
function radToDeg(r) {
  return 180 * (r / Math.PI);
}
function LLtoUTM(r) {
  var e = r.lat, s = r.lon, o = 6378137, a = 669438e-8, l = 0.9996, u, c, E, d, f, h, S, R = degToRad(e), _ = degToRad(s), m, L;
  L = Math.floor((s + 180) / 6) + 1, s === 180 && (L = 60), e >= 56 && e < 64 && s >= 3 && s < 12 && (L = 32), e >= 72 && e < 84 && (s >= 0 && s < 9 ? L = 31 : s >= 9 && s < 21 ? L = 33 : s >= 21 && s < 33 ? L = 35 : s >= 33 && s < 42 && (L = 37)), u = (L - 1) * 6 - 180 + 3, m = degToRad(u), c = a / (1 - a), E = o / Math.sqrt(1 - a * Math.sin(R) * Math.sin(R)), d = Math.tan(R) * Math.tan(R), f = c * Math.cos(R) * Math.cos(R), h = Math.cos(R) * (_ - m), S = o * ((1 - a / 4 - 3 * a * a / 64 - 5 * a * a * a / 256) * R - (3 * a / 8 + 3 * a * a / 32 + 45 * a * a * a / 1024) * Math.sin(2 * R) + (15 * a * a / 256 + 45 * a * a * a / 1024) * Math.sin(4 * R) - 35 * a * a * a / 3072 * Math.sin(6 * R));
  var F = l * E * (h + (1 - d + f) * h * h * h / 6 + (5 - 18 * d + d * d + 72 * f - 58 * c) * h * h * h * h * h / 120) + 5e5, W = l * (S + E * Math.tan(R) * (h * h / 2 + (5 - d + 9 * f + 4 * f * f) * h * h * h * h / 24 + (61 - 58 * d + d * d + 600 * f - 330 * c) * h * h * h * h * h * h / 720));
  return e < 0 && (W += 1e7), {
    northing: Math.round(W),
    easting: Math.round(F),
    zoneNumber: L,
    zoneLetter: getLetterDesignator(e)
  };
}
function UTMtoLL(r) {
  var e = r.northing, s = r.easting, o = r.zoneLetter, a = r.zoneNumber;
  if (a < 0 || a > 60)
    return null;
  var l = 0.9996, u = 6378137, c = 669438e-8, E, d = (1 - Math.sqrt(1 - c)) / (1 + Math.sqrt(1 - c)), f, h, S, R, _, m, L, F, W, G = s - 5e5, q = e;
  o < "N" && (q -= 1e7), L = (a - 1) * 6 - 180 + 3, E = c / (1 - c), m = q / l, F = m / (u * (1 - c / 4 - 3 * c * c / 64 - 5 * c * c * c / 256)), W = F + (3 * d / 2 - 27 * d * d * d / 32) * Math.sin(2 * F) + (21 * d * d / 16 - 55 * d * d * d * d / 32) * Math.sin(4 * F) + 151 * d * d * d / 96 * Math.sin(6 * F), f = u / Math.sqrt(1 - c * Math.sin(W) * Math.sin(W)), h = Math.tan(W) * Math.tan(W), S = E * Math.cos(W) * Math.cos(W), R = u * (1 - c) / Math.pow(1 - c * Math.sin(W) * Math.sin(W), 1.5), _ = G / (f * l);
  var fe = W - f * Math.tan(W) / R * (_ * _ / 2 - (5 + 3 * h + 10 * S - 4 * S * S - 9 * E) * _ * _ * _ * _ / 24 + (61 + 90 * h + 298 * S + 45 * h * h - 252 * E - 3 * S * S) * _ * _ * _ * _ * _ * _ / 720);
  fe = radToDeg(fe);
  var _e = (_ - (1 + 2 * h + S) * _ * _ * _ / 6 + (5 - 2 * S + 28 * h - 3 * S * S + 8 * E + 24 * h * h) * _ * _ * _ * _ * _ / 120) / Math.cos(W);
  _e = L + radToDeg(_e);
  var Le;
  if (r.accuracy) {
    var Fe = UTMtoLL({
      northing: r.northing + r.accuracy,
      easting: r.easting + r.accuracy,
      zoneLetter: r.zoneLetter,
      zoneNumber: r.zoneNumber
    });
    Le = {
      top: Fe.lat,
      right: Fe.lon,
      bottom: fe,
      left: _e
    };
  } else
    Le = {
      lat: fe,
      lon: _e
    };
  return Le;
}
function getLetterDesignator(r) {
  var e = "Z";
  return 84 >= r && r >= 72 ? e = "X" : 72 > r && r >= 64 ? e = "W" : 64 > r && r >= 56 ? e = "V" : 56 > r && r >= 48 ? e = "U" : 48 > r && r >= 40 ? e = "T" : 40 > r && r >= 32 ? e = "S" : 32 > r && r >= 24 ? e = "R" : 24 > r && r >= 16 ? e = "Q" : 16 > r && r >= 8 ? e = "P" : 8 > r && r >= 0 ? e = "N" : 0 > r && r >= -8 ? e = "M" : -8 > r && r >= -16 ? e = "L" : -16 > r && r >= -24 ? e = "K" : -24 > r && r >= -32 ? e = "J" : -32 > r && r >= -40 ? e = "H" : -40 > r && r >= -48 ? e = "G" : -48 > r && r >= -56 ? e = "F" : -56 > r && r >= -64 ? e = "E" : -64 > r && r >= -72 ? e = "D" : -72 > r && r >= -80 && (e = "C"), e;
}
function encode$1(r, e) {
  var s = "00000" + r.easting, o = "00000" + r.northing;
  return r.zoneNumber + r.zoneLetter + get100kID(r.easting, r.northing, r.zoneNumber) + s.substr(s.length - 5, e) + o.substr(o.length - 5, e);
}
function get100kID(r, e, s) {
  var o = get100kSetForZone(s), a = Math.floor(r / 1e5), l = Math.floor(e / 1e5) % 20;
  return getLetter100kID(a, l, o);
}
function get100kSetForZone(r) {
  var e = r % NUM_100K_SETS;
  return e === 0 && (e = NUM_100K_SETS), e;
}
function getLetter100kID(r, e, s) {
  var o = s - 1, a = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(o), l = SET_ORIGIN_ROW_LETTERS.charCodeAt(o), u = a + r - 1, c = l + e, E = !1;
  u > Z && (u = u - Z + A - 1, E = !0), (u === I || a < I && u > I || (u > I || a < I) && E) && u++, (u === O || a < O && u > O || (u > O || a < O) && E) && (u++, u === I && u++), u > Z && (u = u - Z + A - 1), c > V ? (c = c - V + A - 1, E = !0) : E = !1, (c === I || l < I && c > I || (c > I || l < I) && E) && c++, (c === O || l < O && c > O || (c > O || l < O) && E) && (c++, c === I && c++), c > V && (c = c - V + A - 1);
  var d = String.fromCharCode(u) + String.fromCharCode(c);
  return d;
}
function decode$2(r) {
  if (r && r.length === 0)
    throw "MGRSPoint coverting from nothing";
  for (var e = r.length, s = null, o = "", a, l = 0; !/[A-Z]/.test(a = r.charAt(l)); ) {
    if (l >= 2)
      throw "MGRSPoint bad conversion from: " + r;
    o += a, l++;
  }
  var u = parseInt(o, 10);
  if (l === 0 || l + 3 > e)
    throw "MGRSPoint bad conversion from: " + r;
  var c = r.charAt(l++);
  if (c <= "A" || c === "B" || c === "Y" || c >= "Z" || c === "I" || c === "O")
    throw "MGRSPoint zone letter " + c + " not handled: " + r;
  s = r.substring(l, l += 2);
  for (var E = get100kSetForZone(u), d = getEastingFromChar(s.charAt(0), E), f = getNorthingFromChar(s.charAt(1), E); f < getMinNorthing(c); )
    f += 2e6;
  var h = e - l;
  if (h % 2 !== 0)
    throw `MGRSPoint has to have an even number 
of digits after the zone letter and two 100km letters - front 
half for easting meters, second half for 
northing meters` + r;
  var S = h / 2, R = 0, _ = 0, m, L, F, W, G;
  return S > 0 && (m = 1e5 / Math.pow(10, S), L = r.substring(l, l + S), R = parseFloat(L) * m, F = r.substring(l + S), _ = parseFloat(F) * m), W = R + d, G = _ + f, {
    easting: W,
    northing: G,
    zoneLetter: c,
    zoneNumber: u,
    accuracy: m
  };
}
function getEastingFromChar(r, e) {
  for (var s = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(e - 1), o = 1e5, a = !1; s !== r.charCodeAt(0); ) {
    if (s++, s === I && s++, s === O && s++, s > Z) {
      if (a)
        throw "Bad character: " + r;
      s = A, a = !0;
    }
    o += 1e5;
  }
  return o;
}
function getNorthingFromChar(r, e) {
  if (r > "V")
    throw "MGRSPoint given invalid Northing " + r;
  for (var s = SET_ORIGIN_ROW_LETTERS.charCodeAt(e - 1), o = 0, a = !1; s !== r.charCodeAt(0); ) {
    if (s++, s === I && s++, s === O && s++, s > V) {
      if (a)
        throw "Bad character: " + r;
      s = A, a = !0;
    }
    o += 1e5;
  }
  return o;
}
function getMinNorthing(r) {
  var e;
  switch (r) {
    case "C":
      e = 11e5;
      break;
    case "D":
      e = 2e6;
      break;
    case "E":
      e = 28e5;
      break;
    case "F":
      e = 37e5;
      break;
    case "G":
      e = 46e5;
      break;
    case "H":
      e = 55e5;
      break;
    case "J":
      e = 64e5;
      break;
    case "K":
      e = 73e5;
      break;
    case "L":
      e = 82e5;
      break;
    case "M":
      e = 91e5;
      break;
    case "N":
      e = 0;
      break;
    case "P":
      e = 8e5;
      break;
    case "Q":
      e = 17e5;
      break;
    case "R":
      e = 26e5;
      break;
    case "S":
      e = 35e5;
      break;
    case "T":
      e = 44e5;
      break;
    case "U":
      e = 53e5;
      break;
    case "V":
      e = 62e5;
      break;
    case "W":
      e = 7e6;
      break;
    case "X":
      e = 79e5;
      break;
    default:
      e = -1;
  }
  if (e >= 0)
    return e;
  throw "Invalid zone letter: " + r;
}
function Point(r, e, s) {
  if (!(this instanceof Point))
    return new Point(r, e, s);
  if (Array.isArray(r))
    this.x = r[0], this.y = r[1], this.z = r[2] || 0;
  else if (typeof r == "object")
    this.x = r.x, this.y = r.y, this.z = r.z || 0;
  else if (typeof r == "string" && typeof e > "u") {
    var o = r.split(",");
    this.x = parseFloat(o[0]), this.y = parseFloat(o[1]), this.z = parseFloat(o[2]) || 0;
  } else
    this.x = r, this.y = e, this.z = s || 0;
  console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
Point.fromMGRS = function(r) {
  return new Point(toPoint(r));
};
Point.prototype.toMGRS = function(r) {
  return forward$u([this.x, this.y], r);
};
var C00 = 1, C02 = 0.25, C04 = 0.046875, C06 = 0.01953125, C08 = 0.01068115234375, C22 = 0.75, C44 = 0.46875, C46 = 0.013020833333333334, C48 = 0.007120768229166667, C66 = 0.3645833333333333, C68 = 0.005696614583333333, C88 = 0.3076171875;
function pj_enfn(r) {
  var e = [];
  e[0] = C00 - r * (C02 + r * (C04 + r * (C06 + r * C08))), e[1] = r * (C22 - r * (C04 + r * (C06 + r * C08)));
  var s = r * r;
  return e[2] = s * (C44 - r * (C46 + r * C48)), s *= r, e[3] = s * (C66 - r * C68), e[4] = s * r * C88, e;
}
function pj_mlfn(r, e, s, o) {
  return s *= e, e *= e, o[0] * r - s * (o[1] + e * (o[2] + e * (o[3] + e * o[4])));
}
var MAX_ITER$3 = 20;
function pj_inv_mlfn(r, e, s) {
  for (var o = 1 / (1 - e), a = r, l = MAX_ITER$3; l; --l) {
    var u = Math.sin(a), c = 1 - e * u * u;
    if (c = (pj_mlfn(a, u, Math.cos(a), s) - r) * (c * Math.sqrt(c)) * o, a -= c, Math.abs(c) < EPSLN)
      return a;
  }
  return a;
}
function init$v() {
  this.x0 = this.x0 !== void 0 ? this.x0 : 0, this.y0 = this.y0 !== void 0 ? this.y0 : 0, this.long0 = this.long0 !== void 0 ? this.long0 : 0, this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0, this.es && (this.en = pj_enfn(this.es), this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en));
}
function forward$t(r) {
  var e = r.x, s = r.y, o = adjust_lon(e - this.long0), a, l, u, c = Math.sin(s), E = Math.cos(s);
  if (this.es) {
    var f = E * o, h = Math.pow(f, 2), S = this.ep2 * Math.pow(E, 2), R = Math.pow(S, 2), _ = Math.abs(E) > EPSLN ? Math.tan(s) : 0, m = Math.pow(_, 2), L = Math.pow(m, 2);
    a = 1 - this.es * Math.pow(c, 2), f = f / Math.sqrt(a);
    var F = pj_mlfn(s, c, E, this.en);
    l = this.a * (this.k0 * f * (1 + h / 6 * (1 - m + S + h / 20 * (5 - 18 * m + L + 14 * S - 58 * m * S + h / 42 * (61 + 179 * L - L * m - 479 * m))))) + this.x0, u = this.a * (this.k0 * (F - this.ml0 + c * o * f / 2 * (1 + h / 12 * (5 - m + 9 * S + 4 * R + h / 30 * (61 + L - 58 * m + 270 * S - 330 * m * S + h / 56 * (1385 + 543 * L - L * m - 3111 * m)))))) + this.y0;
  } else {
    var d = E * Math.sin(o);
    if (Math.abs(Math.abs(d) - 1) < EPSLN)
      return 93;
    if (l = 0.5 * this.a * this.k0 * Math.log((1 + d) / (1 - d)) + this.x0, u = E * Math.cos(o) / Math.sqrt(1 - Math.pow(d, 2)), d = Math.abs(u), d >= 1) {
      if (d - 1 > EPSLN)
        return 93;
      u = 0;
    } else
      u = Math.acos(u);
    s < 0 && (u = -u), u = this.a * this.k0 * (u - this.lat0) + this.y0;
  }
  return r.x = l, r.y = u, r;
}
function inverse$t(r) {
  var e, s, o, a, l = (r.x - this.x0) * (1 / this.a), u = (r.y - this.y0) * (1 / this.a);
  if (this.es)
    if (e = this.ml0 + u / this.k0, s = pj_inv_mlfn(e, this.es, this.en), Math.abs(s) < HALF_PI) {
      var h = Math.sin(s), S = Math.cos(s), R = Math.abs(S) > EPSLN ? Math.tan(s) : 0, _ = this.ep2 * Math.pow(S, 2), m = Math.pow(_, 2), L = Math.pow(R, 2), F = Math.pow(L, 2);
      e = 1 - this.es * Math.pow(h, 2);
      var W = l * Math.sqrt(e) / this.k0, G = Math.pow(W, 2);
      e = e * R, o = s - e * G / (1 - this.es) * 0.5 * (1 - G / 12 * (5 + 3 * L - 9 * _ * L + _ - 4 * m - G / 30 * (61 + 90 * L - 252 * _ * L + 45 * F + 46 * _ - G / 56 * (1385 + 3633 * L + 4095 * F + 1574 * F * L)))), a = adjust_lon(this.long0 + W * (1 - G / 6 * (1 + 2 * L + _ - G / 20 * (5 + 28 * L + 24 * F + 8 * _ * L + 6 * _ - G / 42 * (61 + 662 * L + 1320 * F + 720 * F * L)))) / S);
    } else
      o = HALF_PI * sign(u), a = 0;
  else {
    var c = Math.exp(l / this.k0), E = 0.5 * (c - 1 / c), d = this.lat0 + u / this.k0, f = Math.cos(d);
    e = Math.sqrt((1 - Math.pow(f, 2)) / (1 + Math.pow(E, 2))), o = Math.asin(e), u < 0 && (o = -o), E === 0 && f === 0 ? a = 0 : a = adjust_lon(Math.atan2(E, f) + this.long0);
  }
  return r.x = a, r.y = o, r;
}
var names$v = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
const tmerc = {
  init: init$v,
  forward: forward$t,
  inverse: inverse$t,
  names: names$v
};
function sinh(r) {
  var e = Math.exp(r);
  return e = (e - 1 / e) / 2, e;
}
function hypot(r, e) {
  r = Math.abs(r), e = Math.abs(e);
  var s = Math.max(r, e), o = Math.min(r, e) / (s || 1);
  return s * Math.sqrt(1 + Math.pow(o, 2));
}
function log1py(r) {
  var e = 1 + r, s = e - 1;
  return s === 0 ? r : r * Math.log(e) / s;
}
function asinhy(r) {
  var e = Math.abs(r);
  return e = log1py(e * (1 + e / (hypot(1, e) + 1))), r < 0 ? -e : e;
}
function gatg(r, e) {
  for (var s = 2 * Math.cos(2 * e), o = r.length - 1, a = r[o], l = 0, u; --o >= 0; )
    u = -l + s * a + r[o], l = a, a = u;
  return e + u * Math.sin(2 * e);
}
function clens(r, e) {
  for (var s = 2 * Math.cos(e), o = r.length - 1, a = r[o], l = 0, u; --o >= 0; )
    u = -l + s * a + r[o], l = a, a = u;
  return Math.sin(e) * u;
}
function cosh(r) {
  var e = Math.exp(r);
  return e = (e + 1 / e) / 2, e;
}
function clens_cmplx(r, e, s) {
  for (var o = Math.sin(e), a = Math.cos(e), l = sinh(s), u = cosh(s), c = 2 * a * u, E = -2 * o * l, d = r.length - 1, f = r[d], h = 0, S = 0, R = 0, _, m; --d >= 0; )
    _ = S, m = h, S = f, h = R, f = -_ + c * S - E * h + r[d], R = -m + E * S + c * h;
  return c = o * u, E = a * l, [c * f - E * R, c * R + E * f];
}
function init$u() {
  if (!this.approx && (isNaN(this.es) || this.es <= 0))
    throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
  this.approx && (tmerc.init.apply(this), this.forward = tmerc.forward, this.inverse = tmerc.inverse), this.x0 = this.x0 !== void 0 ? this.x0 : 0, this.y0 = this.y0 !== void 0 ? this.y0 : 0, this.long0 = this.long0 !== void 0 ? this.long0 : 0, this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0, this.cgb = [], this.cbg = [], this.utg = [], this.gtu = [];
  var r = this.es / (1 + Math.sqrt(1 - this.es)), e = r / (2 - r), s = e;
  this.cgb[0] = e * (2 + e * (-2 / 3 + e * (-2 + e * (116 / 45 + e * (26 / 45 + e * (-2854 / 675)))))), this.cbg[0] = e * (-2 + e * (2 / 3 + e * (4 / 3 + e * (-82 / 45 + e * (32 / 45 + e * (4642 / 4725)))))), s = s * e, this.cgb[1] = s * (7 / 3 + e * (-8 / 5 + e * (-227 / 45 + e * (2704 / 315 + e * (2323 / 945))))), this.cbg[1] = s * (5 / 3 + e * (-16 / 15 + e * (-13 / 9 + e * (904 / 315 + e * (-1522 / 945))))), s = s * e, this.cgb[2] = s * (56 / 15 + e * (-136 / 35 + e * (-1262 / 105 + e * (73814 / 2835)))), this.cbg[2] = s * (-26 / 15 + e * (34 / 21 + e * (8 / 5 + e * (-12686 / 2835)))), s = s * e, this.cgb[3] = s * (4279 / 630 + e * (-332 / 35 + e * (-399572 / 14175))), this.cbg[3] = s * (1237 / 630 + e * (-12 / 5 + e * (-24832 / 14175))), s = s * e, this.cgb[4] = s * (4174 / 315 + e * (-144838 / 6237)), this.cbg[4] = s * (-734 / 315 + e * (109598 / 31185)), s = s * e, this.cgb[5] = s * (601676 / 22275), this.cbg[5] = s * (444337 / 155925), s = Math.pow(e, 2), this.Qn = this.k0 / (1 + e) * (1 + s * (1 / 4 + s * (1 / 64 + s / 256))), this.utg[0] = e * (-0.5 + e * (2 / 3 + e * (-37 / 96 + e * (1 / 360 + e * (81 / 512 + e * (-96199 / 604800)))))), this.gtu[0] = e * (0.5 + e * (-2 / 3 + e * (5 / 16 + e * (41 / 180 + e * (-127 / 288 + e * (7891 / 37800)))))), this.utg[1] = s * (-1 / 48 + e * (-1 / 15 + e * (437 / 1440 + e * (-46 / 105 + e * (1118711 / 3870720))))), this.gtu[1] = s * (13 / 48 + e * (-3 / 5 + e * (557 / 1440 + e * (281 / 630 + e * (-1983433 / 1935360))))), s = s * e, this.utg[2] = s * (-17 / 480 + e * (37 / 840 + e * (209 / 4480 + e * (-5569 / 90720)))), this.gtu[2] = s * (61 / 240 + e * (-103 / 140 + e * (15061 / 26880 + e * (167603 / 181440)))), s = s * e, this.utg[3] = s * (-4397 / 161280 + e * (11 / 504 + e * (830251 / 7257600))), this.gtu[3] = s * (49561 / 161280 + e * (-179 / 168 + e * (6601661 / 7257600))), s = s * e, this.utg[4] = s * (-4583 / 161280 + e * (108847 / 3991680)), this.gtu[4] = s * (34729 / 80640 + e * (-3418889 / 1995840)), s = s * e, this.utg[5] = s * (-20648693 / 638668800), this.gtu[5] = s * (212378941 / 319334400);
  var o = gatg(this.cbg, this.lat0);
  this.Zb = -this.Qn * (o + clens(this.gtu, 2 * o));
}
function forward$s(r) {
  var e = adjust_lon(r.x - this.long0), s = r.y;
  s = gatg(this.cbg, s);
  var o = Math.sin(s), a = Math.cos(s), l = Math.sin(e), u = Math.cos(e);
  s = Math.atan2(o, u * a), e = Math.atan2(l * a, hypot(o, a * u)), e = asinhy(Math.tan(e));
  var c = clens_cmplx(this.gtu, 2 * s, 2 * e);
  s = s + c[0], e = e + c[1];
  var E, d;
  return Math.abs(e) <= 2.623395162778 ? (E = this.a * (this.Qn * e) + this.x0, d = this.a * (this.Qn * s + this.Zb) + this.y0) : (E = 1 / 0, d = 1 / 0), r.x = E, r.y = d, r;
}
function inverse$s(r) {
  var e = (r.x - this.x0) * (1 / this.a), s = (r.y - this.y0) * (1 / this.a);
  s = (s - this.Zb) / this.Qn, e = e / this.Qn;
  var o, a;
  if (Math.abs(e) <= 2.623395162778) {
    var l = clens_cmplx(this.utg, 2 * s, 2 * e);
    s = s + l[0], e = e + l[1], e = Math.atan(sinh(e));
    var u = Math.sin(s), c = Math.cos(s), E = Math.sin(e), d = Math.cos(e);
    s = Math.atan2(u * d, hypot(E, d * c)), e = Math.atan2(E, d * c), o = adjust_lon(e + this.long0), a = gatg(this.cgb, s);
  } else
    o = 1 / 0, a = 1 / 0;
  return r.x = o, r.y = a, r;
}
var names$u = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "Gauss Kruger", "Gauss_Kruger", "tmerc"];
const etmerc = {
  init: init$u,
  forward: forward$s,
  inverse: inverse$s,
  names: names$u
};
function adjust_zone(r, e) {
  if (r === void 0) {
    if (r = Math.floor((adjust_lon(e) + Math.PI) * 30 / Math.PI) + 1, r < 0)
      return 0;
    if (r > 60)
      return 60;
  }
  return r;
}
var dependsOn = "etmerc";
function init$t() {
  var r = adjust_zone(this.zone, this.long0);
  if (r === void 0)
    throw new Error("unknown utm zone");
  this.lat0 = 0, this.long0 = (6 * Math.abs(r) - 183) * D2R$1, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = 0.9996, etmerc.init.apply(this), this.forward = etmerc.forward, this.inverse = etmerc.inverse;
}
var names$t = ["Universal Transverse Mercator System", "utm"];
const utm = {
  init: init$t,
  names: names$t,
  dependsOn
};
function srat(r, e) {
  return Math.pow((1 - r) / (1 + r), e);
}
var MAX_ITER$2 = 20;
function init$s() {
  var r = Math.sin(this.lat0), e = Math.cos(this.lat0);
  e *= e, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * r * r), this.C = Math.sqrt(1 + this.es * e * e / (1 - this.es)), this.phic0 = Math.asin(r / this.C), this.ratexp = 0.5 * this.C * this.e, this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * r, this.ratexp));
}
function forward$r(r) {
  var e = r.x, s = r.y;
  return r.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * s + FORTPI), this.C) * srat(this.e * Math.sin(s), this.ratexp)) - HALF_PI, r.x = this.C * e, r;
}
function inverse$r(r) {
  for (var e = 1e-14, s = r.x / this.C, o = r.y, a = Math.pow(Math.tan(0.5 * o + FORTPI) / this.K, 1 / this.C), l = MAX_ITER$2; l > 0 && (o = 2 * Math.atan(a * srat(this.e * Math.sin(r.y), -0.5 * this.e)) - HALF_PI, !(Math.abs(o - r.y) < e)); --l)
    r.y = o;
  return l ? (r.x = s, r.y = o, r) : null;
}
var names$s = ["gauss"];
const gauss = {
  init: init$s,
  forward: forward$r,
  inverse: inverse$r,
  names: names$s
};
function init$r() {
  gauss.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
}
function forward$q(r) {
  var e, s, o, a;
  return r.x = adjust_lon(r.x - this.long0), gauss.forward.apply(this, [r]), e = Math.sin(r.y), s = Math.cos(r.y), o = Math.cos(r.x), a = this.k0 * this.R2 / (1 + this.sinc0 * e + this.cosc0 * s * o), r.x = a * s * Math.sin(r.x), r.y = a * (this.cosc0 * e - this.sinc0 * s * o), r.x = this.a * r.x + this.x0, r.y = this.a * r.y + this.y0, r;
}
function inverse$q(r) {
  var e, s, o, a, l;
  if (r.x = (r.x - this.x0) / this.a, r.y = (r.y - this.y0) / this.a, r.x /= this.k0, r.y /= this.k0, l = hypot(r.x, r.y)) {
    var u = 2 * Math.atan2(l, this.R2);
    e = Math.sin(u), s = Math.cos(u), a = Math.asin(s * this.sinc0 + r.y * e * this.cosc0 / l), o = Math.atan2(r.x * e, l * this.cosc0 * s - r.y * this.sinc0 * e);
  } else
    a = this.phic0, o = 0;
  return r.x = o, r.y = a, gauss.inverse.apply(this, [r]), r.x = adjust_lon(r.x + this.long0), r;
}
var names$r = ["Stereographic_North_Pole", "Oblique_Stereographic", "sterea", "Oblique Stereographic Alternative", "Double_Stereographic"];
const sterea = {
  init: init$r,
  forward: forward$q,
  inverse: inverse$q,
  names: names$r
};
function ssfn_(r, e, s) {
  return e *= s, Math.tan(0.5 * (HALF_PI + r)) * Math.pow((1 - e) / (1 + e), 0.5 * s);
}
function init$q() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN && (this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= EPSLN && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN && Math.abs(Math.cos(this.lat_ts)) > EPSLN && (this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
}
function forward$p(r) {
  var e = r.x, s = r.y, o = Math.sin(s), a = Math.cos(s), l, u, c, E, d, f, h = adjust_lon(e - this.long0);
  return Math.abs(Math.abs(e - this.long0) - Math.PI) <= EPSLN && Math.abs(s + this.lat0) <= EPSLN ? (r.x = NaN, r.y = NaN, r) : this.sphere ? (l = 2 * this.k0 / (1 + this.sinlat0 * o + this.coslat0 * a * Math.cos(h)), r.x = this.a * l * a * Math.sin(h) + this.x0, r.y = this.a * l * (this.coslat0 * o - this.sinlat0 * a * Math.cos(h)) + this.y0, r) : (u = 2 * Math.atan(ssfn_(s, o, this.e)) - HALF_PI, E = Math.cos(u), c = Math.sin(u), Math.abs(this.coslat0) <= EPSLN ? (d = tsfnz(this.e, s * this.con, this.con * o), f = 2 * this.a * this.k0 * d / this.cons, r.x = this.x0 + f * Math.sin(e - this.long0), r.y = this.y0 - this.con * f * Math.cos(e - this.long0), r) : (Math.abs(this.sinlat0) < EPSLN ? (l = 2 * this.a * this.k0 / (1 + E * Math.cos(h)), r.y = l * c) : (l = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * c + this.cosX0 * E * Math.cos(h))), r.y = l * (this.cosX0 * c - this.sinX0 * E * Math.cos(h)) + this.y0), r.x = l * E * Math.sin(h) + this.x0, r));
}
function inverse$p(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e, s, o, a, l, u = Math.sqrt(r.x * r.x + r.y * r.y);
  if (this.sphere) {
    var c = 2 * Math.atan(u / (2 * this.a * this.k0));
    return e = this.long0, s = this.lat0, u <= EPSLN ? (r.x = e, r.y = s, r) : (s = Math.asin(Math.cos(c) * this.sinlat0 + r.y * Math.sin(c) * this.coslat0 / u), Math.abs(this.coslat0) < EPSLN ? this.lat0 > 0 ? e = adjust_lon(this.long0 + Math.atan2(r.x, -1 * r.y)) : e = adjust_lon(this.long0 + Math.atan2(r.x, r.y)) : e = adjust_lon(this.long0 + Math.atan2(r.x * Math.sin(c), u * this.coslat0 * Math.cos(c) - r.y * this.sinlat0 * Math.sin(c))), r.x = e, r.y = s, r);
  } else if (Math.abs(this.coslat0) <= EPSLN) {
    if (u <= EPSLN)
      return s = this.lat0, e = this.long0, r.x = e, r.y = s, r;
    r.x *= this.con, r.y *= this.con, o = u * this.cons / (2 * this.a * this.k0), s = this.con * phi2z(this.e, o), e = this.con * adjust_lon(this.con * this.long0 + Math.atan2(r.x, -1 * r.y));
  } else
    a = 2 * Math.atan(u * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), e = this.long0, u <= EPSLN ? l = this.X0 : (l = Math.asin(Math.cos(a) * this.sinX0 + r.y * Math.sin(a) * this.cosX0 / u), e = adjust_lon(this.long0 + Math.atan2(r.x * Math.sin(a), u * this.cosX0 * Math.cos(a) - r.y * this.sinX0 * Math.sin(a)))), s = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + l)));
  return r.x = e, r.y = s, r;
}
var names$q = ["stere", "Stereographic_South_Pole", "Polar_Stereographic_variant_A", "Polar_Stereographic_variant_B", "Polar_Stereographic"];
const stere = {
  init: init$q,
  forward: forward$p,
  inverse: inverse$p,
  names: names$q,
  ssfn_
};
function init$p() {
  var r = this.lat0;
  this.lambda0 = this.long0;
  var e = Math.sin(r), s = this.a, o = this.rf, a = 1 / o, l = 2 * a - Math.pow(a, 2), u = this.e = Math.sqrt(l);
  this.R = this.k0 * s * Math.sqrt(1 - l) / (1 - l * Math.pow(e, 2)), this.alpha = Math.sqrt(1 + l / (1 - l) * Math.pow(Math.cos(r), 4)), this.b0 = Math.asin(e / this.alpha);
  var c = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)), E = Math.log(Math.tan(Math.PI / 4 + r / 2)), d = Math.log((1 + u * e) / (1 - u * e));
  this.K = c - this.alpha * E + this.alpha * u / 2 * d;
}
function forward$o(r) {
  var e = Math.log(Math.tan(Math.PI / 4 - r.y / 2)), s = this.e / 2 * Math.log((1 + this.e * Math.sin(r.y)) / (1 - this.e * Math.sin(r.y))), o = -this.alpha * (e + s) + this.K, a = 2 * (Math.atan(Math.exp(o)) - Math.PI / 4), l = this.alpha * (r.x - this.lambda0), u = Math.atan(Math.sin(l) / (Math.sin(this.b0) * Math.tan(a) + Math.cos(this.b0) * Math.cos(l))), c = Math.asin(Math.cos(this.b0) * Math.sin(a) - Math.sin(this.b0) * Math.cos(a) * Math.cos(l));
  return r.y = this.R / 2 * Math.log((1 + Math.sin(c)) / (1 - Math.sin(c))) + this.y0, r.x = this.R * u + this.x0, r;
}
function inverse$o(r) {
  for (var e = r.x - this.x0, s = r.y - this.y0, o = e / this.R, a = 2 * (Math.atan(Math.exp(s / this.R)) - Math.PI / 4), l = Math.asin(Math.cos(this.b0) * Math.sin(a) + Math.sin(this.b0) * Math.cos(a) * Math.cos(o)), u = Math.atan(Math.sin(o) / (Math.cos(this.b0) * Math.cos(o) - Math.sin(this.b0) * Math.tan(a))), c = this.lambda0 + u / this.alpha, E = 0, d = l, f = -1e3, h = 0; Math.abs(d - f) > 1e-7; ) {
    if (++h > 20)
      return;
    E = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + l / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(d)) / 2)), f = d, d = 2 * Math.atan(Math.exp(E)) - Math.PI / 2;
  }
  return r.x = c, r.y = d, r;
}
var names$p = ["somerc"];
const somerc = {
  init: init$p,
  forward: forward$o,
  inverse: inverse$o,
  names: names$p
};
var TOL = 1e-7;
function isTypeA(r) {
  var e = ["Hotine_Oblique_Mercator", "Hotine_Oblique_Mercator_variant_A", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"], s = typeof r.projName == "object" ? Object.keys(r.projName)[0] : r.projName;
  return "no_uoff" in r || "no_off" in r || e.indexOf(s) !== -1 || e.indexOf(getNormalizedProjName(s)) !== -1;
}
function init$o() {
  var r, e, s, o, a, l, u, c, E, d, f = 0, h, S = 0, R = 0, _ = 0, m = 0, L = 0, F = 0;
  this.no_off = isTypeA(this), this.no_rot = "no_rot" in this;
  var W = !1;
  "alpha" in this && (W = !0);
  var G = !1;
  if ("rectified_grid_angle" in this && (G = !0), W && (F = this.alpha), G && (f = this.rectified_grid_angle), W || G)
    S = this.longc;
  else if (R = this.long1, m = this.lat1, _ = this.long2, L = this.lat2, Math.abs(m - L) <= TOL || (r = Math.abs(m)) <= TOL || Math.abs(r - HALF_PI) <= TOL || Math.abs(Math.abs(this.lat0) - HALF_PI) <= TOL || Math.abs(Math.abs(L) - HALF_PI) <= TOL)
    throw new Error();
  var q = 1 - this.es;
  e = Math.sqrt(q), Math.abs(this.lat0) > EPSLN ? (c = Math.sin(this.lat0), s = Math.cos(this.lat0), r = 1 - this.es * c * c, this.B = s * s, this.B = Math.sqrt(1 + this.es * this.B * this.B / q), this.A = this.B * this.k0 * e / r, o = this.B * e / (s * Math.sqrt(r)), a = o * o - 1, a <= 0 ? a = 0 : (a = Math.sqrt(a), this.lat0 < 0 && (a = -a)), this.E = a += o, this.E *= Math.pow(tsfnz(this.e, this.lat0, c), this.B)) : (this.B = 1 / e, this.A = this.k0, this.E = o = a = 1), W || G ? (W ? (h = Math.asin(Math.sin(F) / o), G || (f = F)) : (h = f, F = Math.asin(o * Math.sin(h))), this.lam0 = S - Math.asin(0.5 * (a - 1 / a) * Math.tan(h)) / this.B) : (l = Math.pow(tsfnz(this.e, m, Math.sin(m)), this.B), u = Math.pow(tsfnz(this.e, L, Math.sin(L)), this.B), a = this.E / l, E = (u - l) / (u + l), d = this.E * this.E, d = (d - u * l) / (d + u * l), r = R - _, r < -Math.PI ? _ -= TWO_PI : r > Math.PI && (_ += TWO_PI), this.lam0 = adjust_lon(0.5 * (R + _) - Math.atan(d * Math.tan(0.5 * this.B * (R - _)) / E) / this.B), h = Math.atan(2 * Math.sin(this.B * adjust_lon(R - this.lam0)) / (a - 1 / a)), f = F = Math.asin(o * Math.sin(h))), this.singam = Math.sin(h), this.cosgam = Math.cos(h), this.sinrot = Math.sin(f), this.cosrot = Math.cos(f), this.rB = 1 / this.B, this.ArB = this.A * this.rB, this.BrA = 1 / this.ArB, this.no_off ? this.u_0 = 0 : (this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(o * o - 1) / Math.cos(F))), this.lat0 < 0 && (this.u_0 = -this.u_0)), a = 0.5 * h, this.v_pole_n = this.ArB * Math.log(Math.tan(FORTPI - a)), this.v_pole_s = this.ArB * Math.log(Math.tan(FORTPI + a));
}
function forward$n(r) {
  var e = {}, s, o, a, l, u, c, E, d;
  if (r.x = r.x - this.lam0, Math.abs(Math.abs(r.y) - HALF_PI) > EPSLN) {
    if (u = this.E / Math.pow(tsfnz(this.e, r.y, Math.sin(r.y)), this.B), c = 1 / u, s = 0.5 * (u - c), o = 0.5 * (u + c), l = Math.sin(this.B * r.x), a = (s * this.singam - l * this.cosgam) / o, Math.abs(Math.abs(a) - 1) < EPSLN)
      throw new Error();
    d = 0.5 * this.ArB * Math.log((1 - a) / (1 + a)), c = Math.cos(this.B * r.x), Math.abs(c) < TOL ? E = this.A * r.x : E = this.ArB * Math.atan2(s * this.cosgam + l * this.singam, c);
  } else
    d = r.y > 0 ? this.v_pole_n : this.v_pole_s, E = this.ArB * r.y;
  return this.no_rot ? (e.x = E, e.y = d) : (E -= this.u_0, e.x = d * this.cosrot + E * this.sinrot, e.y = E * this.cosrot - d * this.sinrot), e.x = this.a * e.x + this.x0, e.y = this.a * e.y + this.y0, e;
}
function inverse$n(r) {
  var e, s, o, a, l, u, c, E = {};
  if (r.x = (r.x - this.x0) * (1 / this.a), r.y = (r.y - this.y0) * (1 / this.a), this.no_rot ? (s = r.y, e = r.x) : (s = r.x * this.cosrot - r.y * this.sinrot, e = r.y * this.cosrot + r.x * this.sinrot + this.u_0), o = Math.exp(-this.BrA * s), a = 0.5 * (o - 1 / o), l = 0.5 * (o + 1 / o), u = Math.sin(this.BrA * e), c = (u * this.cosgam + a * this.singam) / l, Math.abs(Math.abs(c) - 1) < EPSLN)
    E.x = 0, E.y = c < 0 ? -HALF_PI : HALF_PI;
  else {
    if (E.y = this.E / Math.sqrt((1 + c) / (1 - c)), E.y = phi2z(this.e, Math.pow(E.y, 1 / this.B)), E.y === 1 / 0)
      throw new Error();
    E.x = -this.rB * Math.atan2(a * this.cosgam - u * this.singam, Math.cos(this.BrA * e));
  }
  return E.x += this.lam0, E;
}
var names$o = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_variant_A", "Hotine_Oblique_Mercator_Variant_B", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
const omerc = {
  init: init$o,
  forward: forward$n,
  inverse: inverse$n,
  names: names$o
};
function init$n() {
  if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < EPSLN)) {
    var r = this.b / this.a;
    this.e = Math.sqrt(1 - r * r);
    var e = Math.sin(this.lat1), s = Math.cos(this.lat1), o = msfnz(this.e, e, s), a = tsfnz(this.e, this.lat1, e), l = Math.sin(this.lat2), u = Math.cos(this.lat2), c = msfnz(this.e, l, u), E = tsfnz(this.e, this.lat2, l), d = Math.abs(Math.abs(this.lat0) - HALF_PI) < EPSLN ? 0 : tsfnz(this.e, this.lat0, Math.sin(this.lat0));
    Math.abs(this.lat1 - this.lat2) > EPSLN ? this.ns = Math.log(o / c) / Math.log(a / E) : this.ns = e, isNaN(this.ns) && (this.ns = e), this.f0 = o / (this.ns * Math.pow(a, this.ns)), this.rh = this.a * this.f0 * Math.pow(d, this.ns), this.title || (this.title = "Lambert Conformal Conic");
  }
}
function forward$m(r) {
  var e = r.x, s = r.y;
  Math.abs(2 * Math.abs(s) - Math.PI) <= EPSLN && (s = sign(s) * (HALF_PI - 2 * EPSLN));
  var o = Math.abs(Math.abs(s) - HALF_PI), a, l;
  if (o > EPSLN)
    a = tsfnz(this.e, s, Math.sin(s)), l = this.a * this.f0 * Math.pow(a, this.ns);
  else {
    if (o = s * this.ns, o <= 0)
      return null;
    l = 0;
  }
  var u = this.ns * adjust_lon(e - this.long0);
  return r.x = this.k0 * (l * Math.sin(u)) + this.x0, r.y = this.k0 * (this.rh - l * Math.cos(u)) + this.y0, r;
}
function inverse$m(r) {
  var e, s, o, a, l, u = (r.x - this.x0) / this.k0, c = this.rh - (r.y - this.y0) / this.k0;
  this.ns > 0 ? (e = Math.sqrt(u * u + c * c), s = 1) : (e = -Math.sqrt(u * u + c * c), s = -1);
  var E = 0;
  if (e !== 0 && (E = Math.atan2(s * u, s * c)), e !== 0 || this.ns > 0) {
    if (s = 1 / this.ns, o = Math.pow(e / (this.a * this.f0), s), a = phi2z(this.e, o), a === -9999)
      return null;
  } else
    a = -HALF_PI;
  return l = adjust_lon(E / this.ns + this.long0), r.x = l, r.y = a, r;
}
var names$n = [
  "Lambert Tangential Conformal Conic Projection",
  "Lambert_Conformal_Conic",
  "Lambert_Conformal_Conic_1SP",
  "Lambert_Conformal_Conic_2SP",
  "lcc",
  "Lambert Conic Conformal (1SP)",
  "Lambert Conic Conformal (2SP)"
];
const lcc = {
  init: init$n,
  forward: forward$m,
  inverse: inverse$m,
  names: names$n
};
function init$m() {
  this.a = 6377397155e-3, this.es = 0.006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = 0.863937979737193), this.long0 || (this.long0 = 0.7417649320975901 - 0.308341501185665), this.k0 || (this.k0 = 0.9999), this.s45 = 0.785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
}
function forward$l(r) {
  var e, s, o, a, l, u, c, E = r.x, d = r.y, f = adjust_lon(E - this.long0);
  return e = Math.pow((1 + this.e * Math.sin(d)) / (1 - this.e * Math.sin(d)), this.alfa * this.e / 2), s = 2 * (Math.atan(this.k * Math.pow(Math.tan(d / 2 + this.s45), this.alfa) / e) - this.s45), o = -f * this.alfa, a = Math.asin(Math.cos(this.ad) * Math.sin(s) + Math.sin(this.ad) * Math.cos(s) * Math.cos(o)), l = Math.asin(Math.cos(s) * Math.sin(o) / Math.cos(a)), u = this.n * l, c = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(a / 2 + this.s45), this.n), r.y = c * Math.cos(u) / 1, r.x = c * Math.sin(u) / 1, this.czech || (r.y *= -1, r.x *= -1), r;
}
function inverse$l(r) {
  var e, s, o, a, l, u, c, E, d = r.x;
  r.x = r.y, r.y = d, this.czech || (r.y *= -1, r.x *= -1), u = Math.sqrt(r.x * r.x + r.y * r.y), l = Math.atan2(r.y, r.x), a = l / Math.sin(this.s0), o = 2 * (Math.atan(Math.pow(this.ro0 / u, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), e = Math.asin(Math.cos(this.ad) * Math.sin(o) - Math.sin(this.ad) * Math.cos(o) * Math.cos(a)), s = Math.asin(Math.cos(o) * Math.sin(a) / Math.cos(e)), r.x = this.long0 - s / this.alfa, c = e, E = 0;
  var f = 0;
  do
    r.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(c)) / (1 - this.e * Math.sin(c)), this.e / 2)) - this.s45), Math.abs(c - r.y) < 1e-10 && (E = 1), c = r.y, f += 1;
  while (E === 0 && f < 15);
  return f >= 15 ? null : r;
}
var names$m = ["Krovak", "krovak"];
const krovak = {
  init: init$m,
  forward: forward$l,
  inverse: inverse$l,
  names: names$m
};
function mlfn(r, e, s, o, a) {
  return r * a - e * Math.sin(2 * a) + s * Math.sin(4 * a) - o * Math.sin(6 * a);
}
function e0fn(r) {
  return 1 - 0.25 * r * (1 + r / 16 * (3 + 1.25 * r));
}
function e1fn(r) {
  return 0.375 * r * (1 + 0.25 * r * (1 + 0.46875 * r));
}
function e2fn(r) {
  return 0.05859375 * r * r * (1 + 0.75 * r);
}
function e3fn(r) {
  return r * r * r * (35 / 3072);
}
function gN(r, e, s) {
  var o = e * s;
  return r / Math.sqrt(1 - o * o);
}
function adjust_lat(r) {
  return Math.abs(r) < HALF_PI ? r : r - sign(r) * Math.PI;
}
function imlfn(r, e, s, o, a) {
  var l, u;
  l = r / e;
  for (var c = 0; c < 15; c++)
    if (u = (r - (e * l - s * Math.sin(2 * l) + o * Math.sin(4 * l) - a * Math.sin(6 * l))) / (e - 2 * s * Math.cos(2 * l) + 4 * o * Math.cos(4 * l) - 6 * a * Math.cos(6 * l)), l += u, Math.abs(u) <= 1e-10)
      return l;
  return NaN;
}
function init$l() {
  this.sphere || (this.e0 = e0fn(this.es), this.e1 = e1fn(this.es), this.e2 = e2fn(this.es), this.e3 = e3fn(this.es), this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0));
}
function forward$k(r) {
  var e, s, o = r.x, a = r.y;
  if (o = adjust_lon(o - this.long0), this.sphere)
    e = this.a * Math.asin(Math.cos(a) * Math.sin(o)), s = this.a * (Math.atan2(Math.tan(a), Math.cos(o)) - this.lat0);
  else {
    var l = Math.sin(a), u = Math.cos(a), c = gN(this.a, this.e, l), E = Math.tan(a) * Math.tan(a), d = o * Math.cos(a), f = d * d, h = this.es * u * u / (1 - this.es), S = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, a);
    e = c * d * (1 - f * E * (1 / 6 - (8 - E + 8 * h) * f / 120)), s = S - this.ml0 + c * l / u * f * (0.5 + (5 - E + 6 * h) * f / 24);
  }
  return r.x = e + this.x0, r.y = s + this.y0, r;
}
function inverse$k(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e = r.x / this.a, s = r.y / this.a, o, a;
  if (this.sphere) {
    var l = s + this.lat0;
    o = Math.asin(Math.sin(l) * Math.cos(e)), a = Math.atan2(Math.tan(e), Math.cos(l));
  } else {
    var u = this.ml0 / this.a + s, c = imlfn(u, this.e0, this.e1, this.e2, this.e3);
    if (Math.abs(Math.abs(c) - HALF_PI) <= EPSLN)
      return r.x = this.long0, r.y = HALF_PI, s < 0 && (r.y *= -1), r;
    var E = gN(this.a, this.e, Math.sin(c)), d = E * E * E / this.a / this.a * (1 - this.es), f = Math.pow(Math.tan(c), 2), h = e * this.a / E, S = h * h;
    o = c - E * Math.tan(c) / d * h * h * (0.5 - (1 + 3 * f) * h * h / 24), a = h * (1 - S * (f / 3 + (1 + 3 * f) * f * S / 15)) / Math.cos(c);
  }
  return r.x = adjust_lon(a + this.long0), r.y = adjust_lat(o), r;
}
var names$l = ["Cassini", "Cassini_Soldner", "cass"];
const cass = {
  init: init$l,
  forward: forward$k,
  inverse: inverse$k,
  names: names$l
};
function qsfnz(r, e) {
  var s;
  return r > 1e-7 ? (s = r * e, (1 - r * r) * (e / (1 - s * s) - 0.5 / r * Math.log((1 - s) / (1 + s)))) : 2 * e;
}
var S_POLE = 1, N_POLE = 2, EQUIT = 3, OBLIQ = 4;
function init$k() {
  var r = Math.abs(this.lat0);
  if (Math.abs(r - HALF_PI) < EPSLN ? this.mode = this.lat0 < 0 ? S_POLE : N_POLE : Math.abs(r) < EPSLN ? this.mode = EQUIT : this.mode = OBLIQ, this.es > 0) {
    var e;
    switch (this.qp = qsfnz(this.e, 1), this.mmf = 0.5 / (1 - this.es), this.apa = authset(this.es), this.mode) {
      case N_POLE:
        this.dd = 1;
        break;
      case S_POLE:
        this.dd = 1;
        break;
      case EQUIT:
        this.rq = Math.sqrt(0.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = 0.5 * this.qp;
        break;
      case OBLIQ:
        this.rq = Math.sqrt(0.5 * this.qp), e = Math.sin(this.lat0), this.sinb1 = qsfnz(this.e, e) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * e * e) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
        break;
    }
  } else
    this.mode === OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
}
function forward$j(r) {
  var e, s, o, a, l, u, c, E, d, f, h = r.x, S = r.y;
  if (h = adjust_lon(h - this.long0), this.sphere) {
    if (l = Math.sin(S), f = Math.cos(S), o = Math.cos(h), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      if (s = this.mode === this.EQUIT ? 1 + f * o : 1 + this.sinph0 * l + this.cosph0 * f * o, s <= EPSLN)
        return null;
      s = Math.sqrt(2 / s), e = s * f * Math.sin(h), s *= this.mode === this.EQUIT ? l : this.cosph0 * l - this.sinph0 * f * o;
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE && (o = -o), Math.abs(S + this.lat0) < EPSLN)
        return null;
      s = FORTPI - S * 0.5, s = 2 * (this.mode === this.S_POLE ? Math.cos(s) : Math.sin(s)), e = s * Math.sin(h), s *= o;
    }
  } else {
    switch (c = 0, E = 0, d = 0, o = Math.cos(h), a = Math.sin(h), l = Math.sin(S), u = qsfnz(this.e, l), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (c = u / this.qp, E = Math.sqrt(1 - c * c)), this.mode) {
      case this.OBLIQ:
        d = 1 + this.sinb1 * c + this.cosb1 * E * o;
        break;
      case this.EQUIT:
        d = 1 + E * o;
        break;
      case this.N_POLE:
        d = HALF_PI + S, u = this.qp - u;
        break;
      case this.S_POLE:
        d = S - HALF_PI, u = this.qp + u;
        break;
    }
    if (Math.abs(d) < EPSLN)
      return null;
    switch (this.mode) {
      case this.OBLIQ:
      case this.EQUIT:
        d = Math.sqrt(2 / d), this.mode === this.OBLIQ ? s = this.ymf * d * (this.cosb1 * c - this.sinb1 * E * o) : s = (d = Math.sqrt(2 / (1 + E * o))) * c * this.ymf, e = this.xmf * d * E * a;
        break;
      case this.N_POLE:
      case this.S_POLE:
        u >= 0 ? (e = (d = Math.sqrt(u)) * a, s = o * (this.mode === this.S_POLE ? d : -d)) : e = s = 0;
        break;
    }
  }
  return r.x = this.a * e + this.x0, r.y = this.a * s + this.y0, r;
}
function inverse$j(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e = r.x / this.a, s = r.y / this.a, o, a, l, u, c, E, d;
  if (this.sphere) {
    var f = 0, h, S = 0;
    if (h = Math.sqrt(e * e + s * s), a = h * 0.5, a > 1)
      return null;
    switch (a = 2 * Math.asin(a), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (S = Math.sin(a), f = Math.cos(a)), this.mode) {
      case this.EQUIT:
        a = Math.abs(h) <= EPSLN ? 0 : Math.asin(s * S / h), e *= S, s = f * h;
        break;
      case this.OBLIQ:
        a = Math.abs(h) <= EPSLN ? this.lat0 : Math.asin(f * this.sinph0 + s * S * this.cosph0 / h), e *= S * this.cosph0, s = (f - Math.sin(a) * this.sinph0) * h;
        break;
      case this.N_POLE:
        s = -s, a = HALF_PI - a;
        break;
      case this.S_POLE:
        a -= HALF_PI;
        break;
    }
    o = s === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(e, s);
  } else {
    if (d = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      if (e /= this.dd, s *= this.dd, E = Math.sqrt(e * e + s * s), E < EPSLN)
        return r.x = this.long0, r.y = this.lat0, r;
      u = 2 * Math.asin(0.5 * E / this.rq), l = Math.cos(u), e *= u = Math.sin(u), this.mode === this.OBLIQ ? (d = l * this.sinb1 + s * u * this.cosb1 / E, c = this.qp * d, s = E * this.cosb1 * l - s * this.sinb1 * u) : (d = s * u / E, c = this.qp * d, s = E * l);
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE && (s = -s), c = e * e + s * s, !c)
        return r.x = this.long0, r.y = this.lat0, r;
      d = 1 - c / this.qp, this.mode === this.S_POLE && (d = -d);
    }
    o = Math.atan2(e, s), a = authlat(Math.asin(d), this.apa);
  }
  return r.x = adjust_lon(this.long0 + o), r.y = a, r;
}
var P00 = 0.3333333333333333, P01 = 0.17222222222222222, P02 = 0.10257936507936508, P10 = 0.06388888888888888, P11 = 0.0664021164021164, P20 = 0.016415012942191543;
function authset(r) {
  var e, s = [];
  return s[0] = r * P00, e = r * r, s[0] += e * P01, s[1] = e * P10, e *= r, s[0] += e * P02, s[1] += e * P11, s[2] = e * P20, s;
}
function authlat(r, e) {
  var s = r + r;
  return r + e[0] * Math.sin(s) + e[1] * Math.sin(s + s) + e[2] * Math.sin(s + s + s);
}
var names$k = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
const laea = {
  init: init$k,
  forward: forward$j,
  inverse: inverse$j,
  names: names$k,
  S_POLE,
  N_POLE,
  EQUIT,
  OBLIQ
};
function asinz(r) {
  return Math.abs(r) > 1 && (r = r > 1 ? 1 : -1), Math.asin(r);
}
function init$j() {
  Math.abs(this.lat1 + this.lat2) < EPSLN || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po), this.qs1 = qsfnz(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po), this.qs2 = qsfnz(this.e3, this.sin_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = qsfnz(this.e3, this.sin_po), Math.abs(this.lat1 - this.lat2) > EPSLN ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
}
function forward$i(r) {
  var e = r.x, s = r.y;
  this.sin_phi = Math.sin(s), this.cos_phi = Math.cos(s);
  var o = qsfnz(this.e3, this.sin_phi), a = this.a * Math.sqrt(this.c - this.ns0 * o) / this.ns0, l = this.ns0 * adjust_lon(e - this.long0), u = a * Math.sin(l) + this.x0, c = this.rh - a * Math.cos(l) + this.y0;
  return r.x = u, r.y = c, r;
}
function inverse$i(r) {
  var e, s, o, a, l, u;
  return r.x -= this.x0, r.y = this.rh - r.y + this.y0, this.ns0 >= 0 ? (e = Math.sqrt(r.x * r.x + r.y * r.y), o = 1) : (e = -Math.sqrt(r.x * r.x + r.y * r.y), o = -1), a = 0, e !== 0 && (a = Math.atan2(o * r.x, o * r.y)), o = e * this.ns0 / this.a, this.sphere ? u = Math.asin((this.c - o * o) / (2 * this.ns0)) : (s = (this.c - o * o) / this.ns0, u = this.phi1z(this.e3, s)), l = adjust_lon(a / this.ns0 + this.long0), r.x = l, r.y = u, r;
}
function phi1z(r, e) {
  var s, o, a, l, u, c = asinz(0.5 * e);
  if (r < EPSLN)
    return c;
  for (var E = r * r, d = 1; d <= 25; d++)
    if (s = Math.sin(c), o = Math.cos(c), a = r * s, l = 1 - a * a, u = 0.5 * l * l / o * (e / (1 - E) - s / l + 0.5 / r * Math.log((1 - a) / (1 + a))), c = c + u, Math.abs(u) <= 1e-7)
      return c;
  return null;
}
var names$j = ["Albers_Conic_Equal_Area", "Albers_Equal_Area", "Albers", "aea"];
const aea = {
  init: init$j,
  forward: forward$i,
  inverse: inverse$i,
  names: names$j,
  phi1z
};
function init$i() {
  this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
}
function forward$h(r) {
  var e, s, o, a, l, u, c, E, d = r.x, f = r.y;
  return o = adjust_lon(d - this.long0), e = Math.sin(f), s = Math.cos(f), a = Math.cos(o), u = this.sin_p14 * e + this.cos_p14 * s * a, l = 1, u > 0 || Math.abs(u) <= EPSLN ? (c = this.x0 + this.a * l * s * Math.sin(o) / u, E = this.y0 + this.a * l * (this.cos_p14 * e - this.sin_p14 * s * a) / u) : (c = this.x0 + this.infinity_dist * s * Math.sin(o), E = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * s * a)), r.x = c, r.y = E, r;
}
function inverse$h(r) {
  var e, s, o, a, l, u;
  return r.x = (r.x - this.x0) / this.a, r.y = (r.y - this.y0) / this.a, r.x /= this.k0, r.y /= this.k0, (e = Math.sqrt(r.x * r.x + r.y * r.y)) ? (a = Math.atan2(e, this.rc), s = Math.sin(a), o = Math.cos(a), u = asinz(o * this.sin_p14 + r.y * s * this.cos_p14 / e), l = Math.atan2(r.x * s, e * this.cos_p14 * o - r.y * this.sin_p14 * s), l = adjust_lon(this.long0 + l)) : (u = this.phic0, l = 0), r.x = l, r.y = u, r;
}
var names$i = ["gnom"];
const gnom = {
  init: init$i,
  forward: forward$h,
  inverse: inverse$h,
  names: names$i
};
function iqsfnz(r, e) {
  var s = 1 - (1 - r * r) / (2 * r) * Math.log((1 - r) / (1 + r));
  if (Math.abs(Math.abs(e) - s) < 1e-6)
    return e < 0 ? -1 * HALF_PI : HALF_PI;
  for (var o = Math.asin(0.5 * e), a, l, u, c, E = 0; E < 30; E++)
    if (l = Math.sin(o), u = Math.cos(o), c = r * l, a = Math.pow(1 - c * c, 2) / (2 * u) * (e / (1 - r * r) - l / (1 - c * c) + 0.5 / r * Math.log((1 - c) / (1 + c))), o += a, Math.abs(a) <= 1e-10)
      return o;
  return NaN;
}
function init$h() {
  this.sphere || (this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
}
function forward$g(r) {
  var e = r.x, s = r.y, o, a, l = adjust_lon(e - this.long0);
  if (this.sphere)
    o = this.x0 + this.a * l * Math.cos(this.lat_ts), a = this.y0 + this.a * Math.sin(s) / Math.cos(this.lat_ts);
  else {
    var u = qsfnz(this.e, Math.sin(s));
    o = this.x0 + this.a * this.k0 * l, a = this.y0 + this.a * u * 0.5 / this.k0;
  }
  return r.x = o, r.y = a, r;
}
function inverse$g(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e, s;
  return this.sphere ? (e = adjust_lon(this.long0 + r.x / this.a / Math.cos(this.lat_ts)), s = Math.asin(r.y / this.a * Math.cos(this.lat_ts))) : (s = iqsfnz(this.e, 2 * r.y * this.k0 / this.a), e = adjust_lon(this.long0 + r.x / (this.a * this.k0))), r.x = e, r.y = s, r;
}
var names$h = ["cea"];
const cea = {
  init: init$h,
  forward: forward$g,
  inverse: inverse$g,
  names: names$h
};
function init$g() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
}
function forward$f(r) {
  var e = r.x, s = r.y, o = adjust_lon(e - this.long0), a = adjust_lat(s - this.lat0);
  return r.x = this.x0 + this.a * o * this.rc, r.y = this.y0 + this.a * a, r;
}
function inverse$f(r) {
  var e = r.x, s = r.y;
  return r.x = adjust_lon(this.long0 + (e - this.x0) / (this.a * this.rc)), r.y = adjust_lat(this.lat0 + (s - this.y0) / this.a), r;
}
var names$g = ["Equirectangular", "Equidistant_Cylindrical", "Equidistant_Cylindrical_Spherical", "eqc"];
const eqc = {
  init: init$g,
  forward: forward$f,
  inverse: inverse$f,
  names: names$g
};
var MAX_ITER$1 = 20;
function init$f() {
  this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = e0fn(this.es), this.e1 = e1fn(this.es), this.e2 = e2fn(this.es), this.e3 = e3fn(this.es), this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
}
function forward$e(r) {
  var e = r.x, s = r.y, o, a, l, u = adjust_lon(e - this.long0);
  if (l = u * Math.sin(s), this.sphere)
    Math.abs(s) <= EPSLN ? (o = this.a * u, a = -1 * this.a * this.lat0) : (o = this.a * Math.sin(l) / Math.tan(s), a = this.a * (adjust_lat(s - this.lat0) + (1 - Math.cos(l)) / Math.tan(s)));
  else if (Math.abs(s) <= EPSLN)
    o = this.a * u, a = -1 * this.ml0;
  else {
    var c = gN(this.a, this.e, Math.sin(s)) / Math.tan(s);
    o = c * Math.sin(l), a = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, s) - this.ml0 + c * (1 - Math.cos(l));
  }
  return r.x = o + this.x0, r.y = a + this.y0, r;
}
function inverse$e(r) {
  var e, s, o, a, l, u, c, E, d;
  if (o = r.x - this.x0, a = r.y - this.y0, this.sphere)
    if (Math.abs(a + this.a * this.lat0) <= EPSLN)
      e = adjust_lon(o / this.a + this.long0), s = 0;
    else {
      u = this.lat0 + a / this.a, c = o * o / this.a / this.a + u * u, E = u;
      var f;
      for (l = MAX_ITER$1; l; --l)
        if (f = Math.tan(E), d = -1 * (u * (E * f + 1) - E - 0.5 * (E * E + c) * f) / ((E - u) / f - 1), E += d, Math.abs(d) <= EPSLN) {
          s = E;
          break;
        }
      e = adjust_lon(this.long0 + Math.asin(o * Math.tan(E) / this.a) / Math.sin(s));
    }
  else if (Math.abs(a + this.ml0) <= EPSLN)
    s = 0, e = adjust_lon(this.long0 + o / this.a);
  else {
    u = (this.ml0 + a) / this.a, c = o * o / this.a / this.a + u * u, E = u;
    var h, S, R, _, m;
    for (l = MAX_ITER$1; l; --l)
      if (m = this.e * Math.sin(E), h = Math.sqrt(1 - m * m) * Math.tan(E), S = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, E), R = this.e0 - 2 * this.e1 * Math.cos(2 * E) + 4 * this.e2 * Math.cos(4 * E) - 6 * this.e3 * Math.cos(6 * E), _ = S / this.a, d = (u * (h * _ + 1) - _ - 0.5 * h * (_ * _ + c)) / (this.es * Math.sin(2 * E) * (_ * _ + c - 2 * u * _) / (4 * h) + (u - _) * (h * R - 2 / Math.sin(2 * E)) - R), E -= d, Math.abs(d) <= EPSLN) {
        s = E;
        break;
      }
    h = Math.sqrt(1 - this.es * Math.pow(Math.sin(s), 2)) * Math.tan(s), e = adjust_lon(this.long0 + Math.asin(o * h / this.a) / Math.sin(s));
  }
  return r.x = e, r.y = s, r;
}
var names$f = ["Polyconic", "American_Polyconic", "poly"];
const poly = {
  init: init$f,
  forward: forward$e,
  inverse: inverse$e,
  names: names$f
};
function init$e() {
  this.A = [], this.A[1] = 0.6399175073, this.A[2] = -0.1358797613, this.A[3] = 0.063294409, this.A[4] = -0.02526853, this.A[5] = 0.0117879, this.A[6] = -55161e-7, this.A[7] = 26906e-7, this.A[8] = -1333e-6, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = 0.7557853228, this.B_im[1] = 0, this.B_re[2] = 0.249204646, this.B_im[2] = 3371507e-9, this.B_re[3] = -1541739e-9, this.B_im[3] = 0.04105856, this.B_re[4] = -0.10162907, this.B_im[4] = 0.01727609, this.B_re[5] = -0.26623489, this.B_im[5] = -0.36249218, this.B_re[6] = -0.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -0.577245789, this.C_im[2] = -7809598e-9, this.C_re[3] = 0.508307513, this.C_im[3] = -0.112208952, this.C_re[4] = -0.15094762, this.C_im[4] = 0.18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = 0.5185406398, this.D[3] = -0.03333098, this.D[4] = -0.1052906, this.D[5] = -0.0368594, this.D[6] = 7317e-6, this.D[7] = 0.0122, this.D[8] = 394e-5, this.D[9] = -13e-4;
}
function forward$d(r) {
  var e, s = r.x, o = r.y, a = o - this.lat0, l = s - this.long0, u = a / SEC_TO_RAD * 1e-5, c = l, E = 1, d = 0;
  for (e = 1; e <= 10; e++)
    E = E * u, d = d + this.A[e] * E;
  var f = d, h = c, S = 1, R = 0, _, m, L = 0, F = 0;
  for (e = 1; e <= 6; e++)
    _ = S * f - R * h, m = R * f + S * h, S = _, R = m, L = L + this.B_re[e] * S - this.B_im[e] * R, F = F + this.B_im[e] * S + this.B_re[e] * R;
  return r.x = F * this.a + this.x0, r.y = L * this.a + this.y0, r;
}
function inverse$d(r) {
  var e, s = r.x, o = r.y, a = s - this.x0, l = o - this.y0, u = l / this.a, c = a / this.a, E = 1, d = 0, f, h, S = 0, R = 0;
  for (e = 1; e <= 6; e++)
    f = E * u - d * c, h = d * u + E * c, E = f, d = h, S = S + this.C_re[e] * E - this.C_im[e] * d, R = R + this.C_im[e] * E + this.C_re[e] * d;
  for (var _ = 0; _ < this.iterations; _++) {
    var m = S, L = R, F, W, G = u, q = c;
    for (e = 2; e <= 6; e++)
      F = m * S - L * R, W = L * S + m * R, m = F, L = W, G = G + (e - 1) * (this.B_re[e] * m - this.B_im[e] * L), q = q + (e - 1) * (this.B_im[e] * m + this.B_re[e] * L);
    m = 1, L = 0;
    var fe = this.B_re[1], _e = this.B_im[1];
    for (e = 2; e <= 6; e++)
      F = m * S - L * R, W = L * S + m * R, m = F, L = W, fe = fe + e * (this.B_re[e] * m - this.B_im[e] * L), _e = _e + e * (this.B_im[e] * m + this.B_re[e] * L);
    var Le = fe * fe + _e * _e;
    S = (G * fe + q * _e) / Le, R = (q * fe - G * _e) / Le;
  }
  var Fe = S, Ee = R, Ge = 1, ve = 0;
  for (e = 1; e <= 9; e++)
    Ge = Ge * Fe, ve = ve + this.D[e] * Ge;
  var te = this.lat0 + ve * SEC_TO_RAD * 1e5, ae = this.long0 + Ee;
  return r.x = ae, r.y = te, r;
}
var names$e = ["New_Zealand_Map_Grid", "nzmg"];
const nzmg = {
  init: init$e,
  forward: forward$d,
  inverse: inverse$d,
  names: names$e
};
function init$d() {
}
function forward$c(r) {
  var e = r.x, s = r.y, o = adjust_lon(e - this.long0), a = this.x0 + this.a * o, l = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + s / 2.5)) * 1.25;
  return r.x = a, r.y = l, r;
}
function inverse$c(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e = adjust_lon(this.long0 + r.x / this.a), s = 2.5 * (Math.atan(Math.exp(0.8 * r.y / this.a)) - Math.PI / 4);
  return r.x = e, r.y = s, r;
}
var names$d = ["Miller_Cylindrical", "mill"];
const mill = {
  init: init$d,
  forward: forward$c,
  inverse: inverse$c,
  names: names$d
};
var MAX_ITER = 20;
function init$c() {
  this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = pj_enfn(this.es);
}
function forward$b(r) {
  var e, s, o = r.x, a = r.y;
  if (o = adjust_lon(o - this.long0), this.sphere) {
    if (!this.m)
      a = this.n !== 1 ? Math.asin(this.n * Math.sin(a)) : a;
    else
      for (var l = this.n * Math.sin(a), u = MAX_ITER; u; --u) {
        var c = (this.m * a + Math.sin(a) - l) / (this.m + Math.cos(a));
        if (a -= c, Math.abs(c) < EPSLN)
          break;
      }
    e = this.a * this.C_x * o * (this.m + Math.cos(a)), s = this.a * this.C_y * a;
  } else {
    var E = Math.sin(a), d = Math.cos(a);
    s = this.a * pj_mlfn(a, E, d, this.en), e = this.a * o * d / Math.sqrt(1 - this.es * E * E);
  }
  return r.x = e, r.y = s, r;
}
function inverse$b(r) {
  var e, s, o, a;
  return r.x -= this.x0, o = r.x / this.a, r.y -= this.y0, e = r.y / this.a, this.sphere ? (e /= this.C_y, o = o / (this.C_x * (this.m + Math.cos(e))), this.m ? e = asinz((this.m * e + Math.sin(e)) / this.n) : this.n !== 1 && (e = asinz(Math.sin(e) / this.n)), o = adjust_lon(o + this.long0), e = adjust_lat(e)) : (e = pj_inv_mlfn(r.y / this.a, this.es, this.en), a = Math.abs(e), a < HALF_PI ? (a = Math.sin(e), s = this.long0 + r.x * Math.sqrt(1 - this.es * a * a) / (this.a * Math.cos(e)), o = adjust_lon(s)) : a - EPSLN < HALF_PI && (o = this.long0)), r.x = o, r.y = e, r;
}
var names$c = ["Sinusoidal", "sinu"];
const sinu = {
  init: init$c,
  forward: forward$b,
  inverse: inverse$b,
  names: names$c
};
function init$b() {
}
function forward$a(r) {
  for (var e = r.x, s = r.y, o = adjust_lon(e - this.long0), a = s, l = Math.PI * Math.sin(s); ; ) {
    var u = -(a + Math.sin(a) - l) / (1 + Math.cos(a));
    if (a += u, Math.abs(u) < EPSLN)
      break;
  }
  a /= 2, Math.PI / 2 - Math.abs(s) < EPSLN && (o = 0);
  var c = 0.900316316158 * this.a * o * Math.cos(a) + this.x0, E = 1.4142135623731 * this.a * Math.sin(a) + this.y0;
  return r.x = c, r.y = E, r;
}
function inverse$a(r) {
  var e, s;
  r.x -= this.x0, r.y -= this.y0, s = r.y / (1.4142135623731 * this.a), Math.abs(s) > 0.999999999999 && (s = 0.999999999999), e = Math.asin(s);
  var o = adjust_lon(this.long0 + r.x / (0.900316316158 * this.a * Math.cos(e)));
  o < -Math.PI && (o = -Math.PI), o > Math.PI && (o = Math.PI), s = (2 * e + Math.sin(2 * e)) / Math.PI, Math.abs(s) > 1 && (s = 1);
  var a = Math.asin(s);
  return r.x = o, r.y = a, r;
}
var names$b = ["Mollweide", "moll"];
const moll = {
  init: init$b,
  forward: forward$a,
  inverse: inverse$a,
  names: names$b
};
function init$a() {
  Math.abs(this.lat1 + this.lat2) < EPSLN || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = e0fn(this.es), this.e1 = e1fn(this.es), this.e2 = e2fn(this.es), this.e3 = e3fn(this.es), this.sin_phi = Math.sin(this.lat1), this.cos_phi = Math.cos(this.lat1), this.ms1 = msfnz(this.e, this.sin_phi, this.cos_phi), this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < EPSLN ? this.ns = this.sin_phi : (this.sin_phi = Math.sin(this.lat2), this.cos_phi = Math.cos(this.lat2), this.ms2 = msfnz(this.e, this.sin_phi, this.cos_phi), this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
}
function forward$9(r) {
  var e = r.x, s = r.y, o;
  if (this.sphere)
    o = this.a * (this.g - s);
  else {
    var a = mlfn(this.e0, this.e1, this.e2, this.e3, s);
    o = this.a * (this.g - a);
  }
  var l = this.ns * adjust_lon(e - this.long0), u = this.x0 + o * Math.sin(l), c = this.y0 + this.rh - o * Math.cos(l);
  return r.x = u, r.y = c, r;
}
function inverse$9(r) {
  r.x -= this.x0, r.y = this.rh - r.y + this.y0;
  var e, s, o, a;
  this.ns >= 0 ? (s = Math.sqrt(r.x * r.x + r.y * r.y), e = 1) : (s = -Math.sqrt(r.x * r.x + r.y * r.y), e = -1);
  var l = 0;
  if (s !== 0 && (l = Math.atan2(e * r.x, e * r.y)), this.sphere)
    return a = adjust_lon(this.long0 + l / this.ns), o = adjust_lat(this.g - s / this.a), r.x = a, r.y = o, r;
  var u = this.g - s / this.a;
  return o = imlfn(u, this.e0, this.e1, this.e2, this.e3), a = adjust_lon(this.long0 + l / this.ns), r.x = a, r.y = o, r;
}
var names$a = ["Equidistant_Conic", "eqdc"];
const eqdc = {
  init: init$a,
  forward: forward$9,
  inverse: inverse$9,
  names: names$a
};
function init$9() {
  this.R = this.a;
}
function forward$8(r) {
  var e = r.x, s = r.y, o = adjust_lon(e - this.long0), a, l;
  Math.abs(s) <= EPSLN && (a = this.x0 + this.R * o, l = this.y0);
  var u = asinz(2 * Math.abs(s / Math.PI));
  (Math.abs(o) <= EPSLN || Math.abs(Math.abs(s) - HALF_PI) <= EPSLN) && (a = this.x0, s >= 0 ? l = this.y0 + Math.PI * this.R * Math.tan(0.5 * u) : l = this.y0 + Math.PI * this.R * -Math.tan(0.5 * u));
  var c = 0.5 * Math.abs(Math.PI / o - o / Math.PI), E = c * c, d = Math.sin(u), f = Math.cos(u), h = f / (d + f - 1), S = h * h, R = h * (2 / d - 1), _ = R * R, m = Math.PI * this.R * (c * (h - _) + Math.sqrt(E * (h - _) * (h - _) - (_ + E) * (S - _))) / (_ + E);
  o < 0 && (m = -m), a = this.x0 + m;
  var L = E + h;
  return m = Math.PI * this.R * (R * L - c * Math.sqrt((_ + E) * (E + 1) - L * L)) / (_ + E), s >= 0 ? l = this.y0 + m : l = this.y0 - m, r.x = a, r.y = l, r;
}
function inverse$8(r) {
  var e, s, o, a, l, u, c, E, d, f, h, S, R;
  return r.x -= this.x0, r.y -= this.y0, h = Math.PI * this.R, o = r.x / h, a = r.y / h, l = o * o + a * a, u = -Math.abs(a) * (1 + l), c = u - 2 * a * a + o * o, E = -2 * u + 1 + 2 * a * a + l * l, R = a * a / E + (2 * c * c * c / E / E / E - 9 * u * c / E / E) / 27, d = (u - c * c / 3 / E) / E, f = 2 * Math.sqrt(-d / 3), h = 3 * R / d / f, Math.abs(h) > 1 && (h >= 0 ? h = 1 : h = -1), S = Math.acos(h) / 3, r.y >= 0 ? s = (-f * Math.cos(S + Math.PI / 3) - c / 3 / E) * Math.PI : s = -(-f * Math.cos(S + Math.PI / 3) - c / 3 / E) * Math.PI, Math.abs(o) < EPSLN ? e = this.long0 : e = adjust_lon(this.long0 + Math.PI * (l - 1 + Math.sqrt(1 + 2 * (o * o - a * a) + l * l)) / 2 / o), r.x = e, r.y = s, r;
}
var names$9 = ["Van_der_Grinten_I", "VanDerGrinten", "Van_der_Grinten", "vandg"];
const vandg = {
  init: init$9,
  forward: forward$8,
  inverse: inverse$8,
  names: names$9
};
function vincentyInverse(r, e, s, o, a, l) {
  const u = o - e, c = Math.atan((1 - l) * Math.tan(r)), E = Math.atan((1 - l) * Math.tan(s)), d = Math.sin(c), f = Math.cos(c), h = Math.sin(E), S = Math.cos(E);
  let R = u, _, m = 100, L, F, W, G, q, fe, _e, Le, Fe, Ee, Ge, ve, te, ae;
  do {
    if (L = Math.sin(R), F = Math.cos(R), W = Math.sqrt(
      S * L * (S * L) + (f * h - d * S * F) * (f * h - d * S * F)
    ), W === 0)
      return { azi1: 0, s12: 0 };
    G = d * h + f * S * F, q = Math.atan2(W, G), fe = f * S * L / W, _e = 1 - fe * fe, Le = _e !== 0 ? G - 2 * d * h / _e : 0, Fe = l / 16 * _e * (4 + l * (4 - 3 * _e)), _ = R, R = u + (1 - Fe) * l * fe * (q + Fe * W * (Le + Fe * G * (-1 + 2 * Le * Le)));
  } while (Math.abs(R - _) > 1e-12 && --m > 0);
  return m === 0 ? { azi1: NaN, s12: NaN } : (Ee = _e * (a * a - a * (1 - l) * (a * (1 - l))) / (a * (1 - l) * (a * (1 - l))), Ge = 1 + Ee / 16384 * (4096 + Ee * (-768 + Ee * (320 - 175 * Ee))), ve = Ee / 1024 * (256 + Ee * (-128 + Ee * (74 - 47 * Ee))), te = ve * W * (Le + ve / 4 * (G * (-1 + 2 * Le * Le) - ve / 6 * Le * (-3 + 4 * W * W) * (-3 + 4 * Le * Le))), ae = a * (1 - l) * Ge * (q - te), { azi1: Math.atan2(S * L, f * h - d * S * F), s12: ae });
}
function vincentyDirect(r, e, s, o, a, l) {
  const u = Math.atan((1 - l) * Math.tan(r)), c = Math.sin(u), E = Math.cos(u), d = Math.sin(s), f = Math.cos(s), h = Math.atan2(c, E * f), S = E * d, R = 1 - S * S, _ = R * (a * a - a * (1 - l) * (a * (1 - l))) / (a * (1 - l) * (a * (1 - l))), m = 1 + _ / 16384 * (4096 + _ * (-768 + _ * (320 - 175 * _))), L = _ / 1024 * (256 + _ * (-128 + _ * (74 - 47 * _)));
  let F = o / (a * (1 - l) * m), W, G = 100, q, fe, _e, Le;
  do
    q = Math.cos(2 * h + F), fe = Math.sin(F), _e = Math.cos(F), Le = L * fe * (q + L / 4 * (_e * (-1 + 2 * q * q) - L / 6 * q * (-3 + 4 * fe * fe) * (-3 + 4 * q * q))), W = F, F = o / (a * (1 - l) * m) + Le;
  while (Math.abs(F - W) > 1e-12 && --G > 0);
  if (G === 0)
    return { lat2: NaN, lon2: NaN };
  const Fe = c * fe - E * _e * f, Ee = Math.atan2(
    c * _e + E * fe * f,
    (1 - l) * Math.sqrt(S * S + Fe * Fe)
  ), Ge = Math.atan2(
    fe * d,
    E * _e - c * fe * f
  ), ve = l / 16 * R * (4 + l * (4 - 3 * R)), te = Ge - (1 - ve) * l * S * (F + ve * fe * (q + ve * _e * (-1 + 2 * q * q))), ae = e + te;
  return { lat2: Ee, lon2: ae };
}
function init$8() {
  this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0), this.f = this.es / (1 + Math.sqrt(1 - this.es));
}
function forward$7(r) {
  var e = r.x, s = r.y, o = Math.sin(r.y), a = Math.cos(r.y), l = adjust_lon(e - this.long0), u, c, E, d, f, h, S, R, _, m, L;
  return this.sphere ? Math.abs(this.sin_p12 - 1) <= EPSLN ? (r.x = this.x0 + this.a * (HALF_PI - s) * Math.sin(l), r.y = this.y0 - this.a * (HALF_PI - s) * Math.cos(l), r) : Math.abs(this.sin_p12 + 1) <= EPSLN ? (r.x = this.x0 + this.a * (HALF_PI + s) * Math.sin(l), r.y = this.y0 + this.a * (HALF_PI + s) * Math.cos(l), r) : (_ = this.sin_p12 * o + this.cos_p12 * a * Math.cos(l), S = Math.acos(_), R = S ? S / Math.sin(S) : 1, r.x = this.x0 + this.a * R * a * Math.sin(l), r.y = this.y0 + this.a * R * (this.cos_p12 * o - this.sin_p12 * a * Math.cos(l)), r) : (u = e0fn(this.es), c = e1fn(this.es), E = e2fn(this.es), d = e3fn(this.es), Math.abs(this.sin_p12 - 1) <= EPSLN ? (f = this.a * mlfn(u, c, E, d, HALF_PI), h = this.a * mlfn(u, c, E, d, s), r.x = this.x0 + (f - h) * Math.sin(l), r.y = this.y0 - (f - h) * Math.cos(l), r) : Math.abs(this.sin_p12 + 1) <= EPSLN ? (f = this.a * mlfn(u, c, E, d, HALF_PI), h = this.a * mlfn(u, c, E, d, s), r.x = this.x0 + (f + h) * Math.sin(l), r.y = this.y0 + (f + h) * Math.cos(l), r) : Math.abs(e) < EPSLN && Math.abs(s - this.lat0) < EPSLN ? (r.x = r.y = 0, r) : (m = vincentyInverse(this.lat0, this.long0, s, e, this.a, this.f), L = m.azi1, r.x = m.s12 * Math.sin(L), r.y = m.s12 * Math.cos(L), r));
}
function inverse$7(r) {
  r.x -= this.x0, r.y -= this.y0;
  var e, s, o, a, l, u, c, E, d, f, h, S, R, _, m, L;
  return this.sphere ? (e = Math.sqrt(r.x * r.x + r.y * r.y), e > 2 * HALF_PI * this.a ? void 0 : (s = e / this.a, o = Math.sin(s), a = Math.cos(s), l = this.long0, Math.abs(e) <= EPSLN ? u = this.lat0 : (u = asinz(a * this.sin_p12 + r.y * o * this.cos_p12 / e), c = Math.abs(this.lat0) - HALF_PI, Math.abs(c) <= EPSLN ? this.lat0 >= 0 ? l = adjust_lon(this.long0 + Math.atan2(r.x, -r.y)) : l = adjust_lon(this.long0 - Math.atan2(-r.x, r.y)) : l = adjust_lon(this.long0 + Math.atan2(r.x * o, e * this.cos_p12 * a - r.y * this.sin_p12 * o))), r.x = l, r.y = u, r)) : (E = e0fn(this.es), d = e1fn(this.es), f = e2fn(this.es), h = e3fn(this.es), Math.abs(this.sin_p12 - 1) <= EPSLN ? (S = this.a * mlfn(E, d, f, h, HALF_PI), e = Math.sqrt(r.x * r.x + r.y * r.y), R = S - e, u = imlfn(R / this.a, E, d, f, h), l = adjust_lon(this.long0 + Math.atan2(r.x, -1 * r.y)), r.x = l, r.y = u, r) : Math.abs(this.sin_p12 + 1) <= EPSLN ? (S = this.a * mlfn(E, d, f, h, HALF_PI), e = Math.sqrt(r.x * r.x + r.y * r.y), R = e - S, u = imlfn(R / this.a, E, d, f, h), l = adjust_lon(this.long0 + Math.atan2(r.x, r.y)), r.x = l, r.y = u, r) : (_ = Math.atan2(r.x, r.y), m = Math.sqrt(r.x * r.x + r.y * r.y), L = vincentyDirect(this.lat0, this.long0, _, m, this.a, this.f), r.x = L.lon2, r.y = L.lat2, r));
}
var names$8 = ["Azimuthal_Equidistant", "aeqd"];
const aeqd = {
  init: init$8,
  forward: forward$7,
  inverse: inverse$7,
  names: names$8
};
function init$7() {
  this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0);
}
function forward$6(r) {
  var e, s, o, a, l, u, c, E, d = r.x, f = r.y;
  return o = adjust_lon(d - this.long0), e = Math.sin(f), s = Math.cos(f), a = Math.cos(o), u = this.sin_p14 * e + this.cos_p14 * s * a, l = 1, (u > 0 || Math.abs(u) <= EPSLN) && (c = this.a * l * s * Math.sin(o), E = this.y0 + this.a * l * (this.cos_p14 * e - this.sin_p14 * s * a)), r.x = c, r.y = E, r;
}
function inverse$6(r) {
  var e, s, o, a, l, u, c;
  return r.x -= this.x0, r.y -= this.y0, e = Math.sqrt(r.x * r.x + r.y * r.y), s = asinz(e / this.a), o = Math.sin(s), a = Math.cos(s), u = this.long0, Math.abs(e) <= EPSLN ? (c = this.lat0, r.x = u, r.y = c, r) : (c = asinz(a * this.sin_p14 + r.y * o * this.cos_p14 / e), l = Math.abs(this.lat0) - HALF_PI, Math.abs(l) <= EPSLN ? (this.lat0 >= 0 ? u = adjust_lon(this.long0 + Math.atan2(r.x, -r.y)) : u = adjust_lon(this.long0 - Math.atan2(-r.x, r.y)), r.x = u, r.y = c, r) : (u = adjust_lon(this.long0 + Math.atan2(r.x * o, e * this.cos_p14 * a - r.y * this.sin_p14 * o)), r.x = u, r.y = c, r));
}
var names$7 = ["ortho"];
const ortho = {
  init: init$7,
  forward: forward$6,
  inverse: inverse$6,
  names: names$7
};
var FACE_ENUM = {
  FRONT: 1,
  RIGHT: 2,
  BACK: 3,
  LEFT: 4,
  TOP: 5,
  BOTTOM: 6
}, AREA_ENUM = {
  AREA_0: 1,
  AREA_1: 2,
  AREA_2: 3,
  AREA_3: 4
};
function init$6() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Quadrilateralized Spherical Cube", this.lat0 >= HALF_PI - FORTPI / 2 ? this.face = FACE_ENUM.TOP : this.lat0 <= -(HALF_PI - FORTPI / 2) ? this.face = FACE_ENUM.BOTTOM : Math.abs(this.long0) <= FORTPI ? this.face = FACE_ENUM.FRONT : Math.abs(this.long0) <= HALF_PI + FORTPI ? this.face = this.long0 > 0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT : this.face = FACE_ENUM.BACK, this.es !== 0 && (this.one_minus_f = 1 - (this.a - this.b) / this.a, this.one_minus_f_squared = this.one_minus_f * this.one_minus_f);
}
function forward$5(r) {
  var e = { x: 0, y: 0 }, s, o, a, l, u, c, E = { value: 0 };
  if (r.x -= this.long0, this.es !== 0 ? s = Math.atan(this.one_minus_f_squared * Math.tan(r.y)) : s = r.y, o = r.x, this.face === FACE_ENUM.TOP)
    l = HALF_PI - s, o >= FORTPI && o <= HALF_PI + FORTPI ? (E.value = AREA_ENUM.AREA_0, a = o - HALF_PI) : o > HALF_PI + FORTPI || o <= -(HALF_PI + FORTPI) ? (E.value = AREA_ENUM.AREA_1, a = o > 0 ? o - SPI : o + SPI) : o > -(HALF_PI + FORTPI) && o <= -FORTPI ? (E.value = AREA_ENUM.AREA_2, a = o + HALF_PI) : (E.value = AREA_ENUM.AREA_3, a = o);
  else if (this.face === FACE_ENUM.BOTTOM)
    l = HALF_PI + s, o >= FORTPI && o <= HALF_PI + FORTPI ? (E.value = AREA_ENUM.AREA_0, a = -o + HALF_PI) : o < FORTPI && o >= -FORTPI ? (E.value = AREA_ENUM.AREA_1, a = -o) : o < -FORTPI && o >= -(HALF_PI + FORTPI) ? (E.value = AREA_ENUM.AREA_2, a = -o - HALF_PI) : (E.value = AREA_ENUM.AREA_3, a = o > 0 ? -o + SPI : -o - SPI);
  else {
    var d, f, h, S, R, _, m;
    this.face === FACE_ENUM.RIGHT ? o = qsc_shift_lon_origin(o, +HALF_PI) : this.face === FACE_ENUM.BACK ? o = qsc_shift_lon_origin(o, +SPI) : this.face === FACE_ENUM.LEFT && (o = qsc_shift_lon_origin(o, -HALF_PI)), S = Math.sin(s), R = Math.cos(s), _ = Math.sin(o), m = Math.cos(o), d = R * m, f = R * _, h = S, this.face === FACE_ENUM.FRONT ? (l = Math.acos(d), a = qsc_fwd_equat_face_theta(l, h, f, E)) : this.face === FACE_ENUM.RIGHT ? (l = Math.acos(f), a = qsc_fwd_equat_face_theta(l, h, -d, E)) : this.face === FACE_ENUM.BACK ? (l = Math.acos(-d), a = qsc_fwd_equat_face_theta(l, h, -f, E)) : this.face === FACE_ENUM.LEFT ? (l = Math.acos(-f), a = qsc_fwd_equat_face_theta(l, h, d, E)) : (l = a = 0, E.value = AREA_ENUM.AREA_0);
  }
  return c = Math.atan(12 / SPI * (a + Math.acos(Math.sin(a) * Math.cos(FORTPI)) - HALF_PI)), u = Math.sqrt((1 - Math.cos(l)) / (Math.cos(c) * Math.cos(c)) / (1 - Math.cos(Math.atan(1 / Math.cos(a))))), E.value === AREA_ENUM.AREA_1 ? c += HALF_PI : E.value === AREA_ENUM.AREA_2 ? c += SPI : E.value === AREA_ENUM.AREA_3 && (c += 1.5 * SPI), e.x = u * Math.cos(c), e.y = u * Math.sin(c), e.x = e.x * this.a + this.x0, e.y = e.y * this.a + this.y0, r.x = e.x, r.y = e.y, r;
}
function inverse$5(r) {
  var e = { lam: 0, phi: 0 }, s, o, a, l, u, c, E, d, f, h = { value: 0 };
  if (r.x = (r.x - this.x0) / this.a, r.y = (r.y - this.y0) / this.a, o = Math.atan(Math.sqrt(r.x * r.x + r.y * r.y)), s = Math.atan2(r.y, r.x), r.x >= 0 && r.x >= Math.abs(r.y) ? h.value = AREA_ENUM.AREA_0 : r.y >= 0 && r.y >= Math.abs(r.x) ? (h.value = AREA_ENUM.AREA_1, s -= HALF_PI) : r.x < 0 && -r.x >= Math.abs(r.y) ? (h.value = AREA_ENUM.AREA_2, s = s < 0 ? s + SPI : s - SPI) : (h.value = AREA_ENUM.AREA_3, s += HALF_PI), f = SPI / 12 * Math.tan(s), u = Math.sin(f) / (Math.cos(f) - 1 / Math.sqrt(2)), c = Math.atan(u), a = Math.cos(s), l = Math.tan(o), E = 1 - a * a * l * l * (1 - Math.cos(Math.atan(1 / Math.cos(c)))), E < -1 ? E = -1 : E > 1 && (E = 1), this.face === FACE_ENUM.TOP)
    d = Math.acos(E), e.phi = HALF_PI - d, h.value === AREA_ENUM.AREA_0 ? e.lam = c + HALF_PI : h.value === AREA_ENUM.AREA_1 ? e.lam = c < 0 ? c + SPI : c - SPI : h.value === AREA_ENUM.AREA_2 ? e.lam = c - HALF_PI : e.lam = c;
  else if (this.face === FACE_ENUM.BOTTOM)
    d = Math.acos(E), e.phi = d - HALF_PI, h.value === AREA_ENUM.AREA_0 ? e.lam = -c + HALF_PI : h.value === AREA_ENUM.AREA_1 ? e.lam = -c : h.value === AREA_ENUM.AREA_2 ? e.lam = -c - HALF_PI : e.lam = c < 0 ? -c - SPI : -c + SPI;
  else {
    var S, R, _;
    S = E, f = S * S, f >= 1 ? _ = 0 : _ = Math.sqrt(1 - f) * Math.sin(c), f += _ * _, f >= 1 ? R = 0 : R = Math.sqrt(1 - f), h.value === AREA_ENUM.AREA_1 ? (f = R, R = -_, _ = f) : h.value === AREA_ENUM.AREA_2 ? (R = -R, _ = -_) : h.value === AREA_ENUM.AREA_3 && (f = R, R = _, _ = -f), this.face === FACE_ENUM.RIGHT ? (f = S, S = -R, R = f) : this.face === FACE_ENUM.BACK ? (S = -S, R = -R) : this.face === FACE_ENUM.LEFT && (f = S, S = R, R = -f), e.phi = Math.acos(-_) - HALF_PI, e.lam = Math.atan2(R, S), this.face === FACE_ENUM.RIGHT ? e.lam = qsc_shift_lon_origin(e.lam, -HALF_PI) : this.face === FACE_ENUM.BACK ? e.lam = qsc_shift_lon_origin(e.lam, -SPI) : this.face === FACE_ENUM.LEFT && (e.lam = qsc_shift_lon_origin(e.lam, +HALF_PI));
  }
  if (this.es !== 0) {
    var m, L, F;
    m = e.phi < 0 ? 1 : 0, L = Math.tan(e.phi), F = this.b / Math.sqrt(L * L + this.one_minus_f_squared), e.phi = Math.atan(Math.sqrt(this.a * this.a - F * F) / (this.one_minus_f * F)), m && (e.phi = -e.phi);
  }
  return e.lam += this.long0, r.x = e.lam, r.y = e.phi, r;
}
function qsc_fwd_equat_face_theta(r, e, s, o) {
  var a;
  return r < EPSLN ? (o.value = AREA_ENUM.AREA_0, a = 0) : (a = Math.atan2(e, s), Math.abs(a) <= FORTPI ? o.value = AREA_ENUM.AREA_0 : a > FORTPI && a <= HALF_PI + FORTPI ? (o.value = AREA_ENUM.AREA_1, a -= HALF_PI) : a > HALF_PI + FORTPI || a <= -(HALF_PI + FORTPI) ? (o.value = AREA_ENUM.AREA_2, a = a >= 0 ? a - SPI : a + SPI) : (o.value = AREA_ENUM.AREA_3, a += HALF_PI)), a;
}
function qsc_shift_lon_origin(r, e) {
  var s = r + e;
  return s < -SPI ? s += TWO_PI : s > +SPI && (s -= TWO_PI), s;
}
var names$6 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
const qsc = {
  init: init$6,
  forward: forward$5,
  inverse: inverse$5,
  names: names$6
};
var COEFS_X = [
  [1, 22199e-21, -715515e-10, 31103e-10],
  [0.9986, -482243e-9, -24897e-9, -13309e-10],
  [0.9954, -83103e-8, -448605e-10, -986701e-12],
  [0.99, -135364e-8, -59661e-9, 36777e-10],
  [0.9822, -167442e-8, -449547e-11, -572411e-11],
  [0.973, -214868e-8, -903571e-10, 18736e-12],
  [0.96, -305085e-8, -900761e-10, 164917e-11],
  [0.9427, -382792e-8, -653386e-10, -26154e-10],
  [0.9216, -467746e-8, -10457e-8, 481243e-11],
  [0.8962, -536223e-8, -323831e-10, -543432e-11],
  [0.8679, -609363e-8, -113898e-9, 332484e-11],
  [0.835, -698325e-8, -640253e-10, 934959e-12],
  [0.7986, -755338e-8, -500009e-10, 935324e-12],
  [0.7597, -798324e-8, -35971e-9, -227626e-11],
  [0.7186, -851367e-8, -701149e-10, -86303e-10],
  [0.6732, -986209e-8, -199569e-9, 191974e-10],
  [0.6213, -0.010418, 883923e-10, 624051e-11],
  [0.5722, -906601e-8, 182e-6, 624051e-11],
  [0.5322, -677797e-8, 275608e-9, 624051e-11]
], COEFS_Y = [
  [-520417e-23, 0.0124, 121431e-23, -845284e-16],
  [0.062, 0.0124, -126793e-14, 422642e-15],
  [0.124, 0.0124, 507171e-14, -160604e-14],
  [0.186, 0.0123999, -190189e-13, 600152e-14],
  [0.248, 0.0124002, 710039e-13, -224e-10],
  [0.31, 0.0123992, -264997e-12, 835986e-13],
  [0.372, 0.0124029, 988983e-12, -311994e-12],
  [0.434, 0.0123893, -369093e-11, -435621e-12],
  [0.4958, 0.0123198, -102252e-10, -345523e-12],
  [0.5571, 0.0121916, -154081e-10, -582288e-12],
  [0.6176, 0.0119938, -241424e-10, -525327e-12],
  [0.6769, 0.011713, -320223e-10, -516405e-12],
  [0.7346, 0.0113541, -397684e-10, -609052e-12],
  [0.7903, 0.0109107, -489042e-10, -104739e-11],
  [0.8435, 0.0103431, -64615e-9, -140374e-14],
  [0.8936, 969686e-8, -64636e-9, -8547e-9],
  [0.9394, 840947e-8, -192841e-9, -42106e-10],
  [0.9761, 616527e-8, -256e-6, -42106e-10],
  [1, 328947e-8, -319159e-9, -42106e-10]
], FXC = 0.8487, FYC = 1.3523, C1 = R2D / 5, RC1 = 1 / C1, NODES = 18, poly3_val = function(r, e) {
  return r[0] + e * (r[1] + e * (r[2] + e * r[3]));
}, poly3_der = function(r, e) {
  return r[1] + e * (2 * r[2] + e * 3 * r[3]);
};
function newton_rapshon(r, e, s, o) {
  for (var a = e; o; --o) {
    var l = r(a);
    if (a -= l, Math.abs(l) < s)
      break;
  }
  return a;
}
function init$5() {
  this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.long0 = this.long0 || 0, this.es = 0, this.title = this.title || "Robinson";
}
function forward$4(r) {
  var e = adjust_lon(r.x - this.long0), s = Math.abs(r.y), o = Math.floor(s * C1);
  o < 0 ? o = 0 : o >= NODES && (o = NODES - 1), s = R2D * (s - RC1 * o);
  var a = {
    x: poly3_val(COEFS_X[o], s) * e,
    y: poly3_val(COEFS_Y[o], s)
  };
  return r.y < 0 && (a.y = -a.y), a.x = a.x * this.a * FXC + this.x0, a.y = a.y * this.a * FYC + this.y0, a;
}
function inverse$4(r) {
  var e = {
    x: (r.x - this.x0) / (this.a * FXC),
    y: Math.abs(r.y - this.y0) / (this.a * FYC)
  };
  if (e.y >= 1)
    e.x /= COEFS_X[NODES][0], e.y = r.y < 0 ? -HALF_PI : HALF_PI;
  else {
    var s = Math.floor(e.y * NODES);
    for (s < 0 ? s = 0 : s >= NODES && (s = NODES - 1); ; )
      if (COEFS_Y[s][0] > e.y)
        --s;
      else if (COEFS_Y[s + 1][0] <= e.y)
        ++s;
      else
        break;
    var o = COEFS_Y[s], a = 5 * (e.y - o[0]) / (COEFS_Y[s + 1][0] - o[0]);
    a = newton_rapshon(function(l) {
      return (poly3_val(o, l) - e.y) / poly3_der(o, l);
    }, a, EPSLN, 100), e.x /= poly3_val(COEFS_X[s], a), e.y = (5 * s + a) * D2R$1, r.y < 0 && (e.y = -e.y);
  }
  return e.x = adjust_lon(e.x + this.long0), e;
}
var names$5 = ["Robinson", "robin"];
const robin = {
  init: init$5,
  forward: forward$4,
  inverse: inverse$4,
  names: names$5
};
function init$4() {
  this.name = "geocent";
}
function forward$3(r) {
  var e = geodeticToGeocentric(r, this.es, this.a);
  return e;
}
function inverse$3(r) {
  var e = geocentricToGeodetic(r, this.es, this.a, this.b);
  return e;
}
var names$4 = ["Geocentric", "geocentric", "geocent", "Geocent"];
const geocent = {
  init: init$4,
  forward: forward$3,
  inverse: inverse$3,
  names: names$4
};
var mode = {
  N_POLE: 0,
  S_POLE: 1,
  EQUIT: 2,
  OBLIQ: 3
}, params = {
  h: { def: 1e5, num: !0 },
  // default is Karman line, no default in PROJ.7
  azi: { def: 0, num: !0, degrees: !0 },
  // default is North
  tilt: { def: 0, num: !0, degrees: !0 },
  // default is Nadir
  long0: { def: 0, num: !0 },
  // default is Greenwich, conversion to rad is automatic
  lat0: { def: 0, num: !0 }
  // default is Equator, conversion to rad is automatic
};
function init$3() {
  if (Object.keys(params).forEach((function(s) {
    if (typeof this[s] > "u")
      this[s] = params[s].def;
    else {
      if (params[s].num && isNaN(this[s]))
        throw new Error("Invalid parameter value, must be numeric " + s + " = " + this[s]);
      params[s].num && (this[s] = parseFloat(this[s]));
    }
    params[s].degrees && (this[s] = this[s] * D2R$1);
  }).bind(this)), Math.abs(Math.abs(this.lat0) - HALF_PI) < EPSLN ? this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE : Math.abs(this.lat0) < EPSLN ? this.mode = mode.EQUIT : (this.mode = mode.OBLIQ, this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0)), this.pn1 = this.h / this.a, this.pn1 <= 0 || this.pn1 > 1e10)
    throw new Error("Invalid height");
  this.p = 1 + this.pn1, this.rp = 1 / this.p, this.h1 = 1 / this.pn1, this.pfact = (this.p + 1) * this.h1, this.es = 0;
  var r = this.tilt, e = this.azi;
  this.cg = Math.cos(e), this.sg = Math.sin(e), this.cw = Math.cos(r), this.sw = Math.sin(r);
}
function forward$2(r) {
  r.x -= this.long0;
  var e = Math.sin(r.y), s = Math.cos(r.y), o = Math.cos(r.x), a, l;
  switch (this.mode) {
    case mode.OBLIQ:
      l = this.sinph0 * e + this.cosph0 * s * o;
      break;
    case mode.EQUIT:
      l = s * o;
      break;
    case mode.S_POLE:
      l = -e;
      break;
    case mode.N_POLE:
      l = e;
      break;
  }
  switch (l = this.pn1 / (this.p - l), a = l * s * Math.sin(r.x), this.mode) {
    case mode.OBLIQ:
      l *= this.cosph0 * e - this.sinph0 * s * o;
      break;
    case mode.EQUIT:
      l *= e;
      break;
    case mode.N_POLE:
      l *= -(s * o);
      break;
    case mode.S_POLE:
      l *= s * o;
      break;
  }
  var u, c;
  return u = l * this.cg + a * this.sg, c = 1 / (u * this.sw * this.h1 + this.cw), a = (a * this.cg - l * this.sg) * this.cw * c, l = u * c, r.x = a * this.a, r.y = l * this.a, r;
}
function inverse$2(r) {
  r.x /= this.a, r.y /= this.a;
  var e = { x: r.x, y: r.y }, s, o, a;
  a = 1 / (this.pn1 - r.y * this.sw), s = this.pn1 * r.x * a, o = this.pn1 * r.y * this.cw * a, r.x = s * this.cg + o * this.sg, r.y = o * this.cg - s * this.sg;
  var l = hypot(r.x, r.y);
  if (Math.abs(l) < EPSLN)
    e.x = 0, e.y = r.y;
  else {
    var u, c;
    switch (c = 1 - l * l * this.pfact, c = (this.p - Math.sqrt(c)) / (this.pn1 / l + l / this.pn1), u = Math.sqrt(1 - c * c), this.mode) {
      case mode.OBLIQ:
        e.y = Math.asin(u * this.sinph0 + r.y * c * this.cosph0 / l), r.y = (u - this.sinph0 * Math.sin(e.y)) * l, r.x *= c * this.cosph0;
        break;
      case mode.EQUIT:
        e.y = Math.asin(r.y * c / l), r.y = u * l, r.x *= c;
        break;
      case mode.N_POLE:
        e.y = Math.asin(u), r.y = -r.y;
        break;
      case mode.S_POLE:
        e.y = -Math.asin(u);
        break;
    }
    e.x = Math.atan2(r.x, r.y);
  }
  return r.x = e.x + this.long0, r.y = e.y, r;
}
var names$3 = ["Tilted_Perspective", "tpers"];
const tpers = {
  init: init$3,
  forward: forward$2,
  inverse: inverse$2,
  names: names$3
};
function init$2() {
  if (this.flip_axis = this.sweep === "x" ? 1 : 0, this.h = Number(this.h), this.radius_g_1 = this.h / this.a, this.radius_g_1 <= 0 || this.radius_g_1 > 1e10)
    throw new Error();
  if (this.radius_g = 1 + this.radius_g_1, this.C = this.radius_g * this.radius_g - 1, this.es !== 0) {
    var r = 1 - this.es, e = 1 / r;
    this.radius_p = Math.sqrt(r), this.radius_p2 = r, this.radius_p_inv2 = e, this.shape = "ellipse";
  } else
    this.radius_p = 1, this.radius_p2 = 1, this.radius_p_inv2 = 1, this.shape = "sphere";
  this.title || (this.title = "Geostationary Satellite View");
}
function forward$1(r) {
  var e = r.x, s = r.y, o, a, l, u;
  if (e = e - this.long0, this.shape === "ellipse") {
    s = Math.atan(this.radius_p2 * Math.tan(s));
    var c = this.radius_p / hypot(this.radius_p * Math.cos(s), Math.sin(s));
    if (a = c * Math.cos(e) * Math.cos(s), l = c * Math.sin(e) * Math.cos(s), u = c * Math.sin(s), (this.radius_g - a) * a - l * l - u * u * this.radius_p_inv2 < 0)
      return r.x = Number.NaN, r.y = Number.NaN, r;
    o = this.radius_g - a, this.flip_axis ? (r.x = this.radius_g_1 * Math.atan(l / hypot(u, o)), r.y = this.radius_g_1 * Math.atan(u / o)) : (r.x = this.radius_g_1 * Math.atan(l / o), r.y = this.radius_g_1 * Math.atan(u / hypot(l, o)));
  } else
    this.shape === "sphere" && (o = Math.cos(s), a = Math.cos(e) * o, l = Math.sin(e) * o, u = Math.sin(s), o = this.radius_g - a, this.flip_axis ? (r.x = this.radius_g_1 * Math.atan(l / hypot(u, o)), r.y = this.radius_g_1 * Math.atan(u / o)) : (r.x = this.radius_g_1 * Math.atan(l / o), r.y = this.radius_g_1 * Math.atan(u / hypot(l, o))));
  return r.x = r.x * this.a, r.y = r.y * this.a, r;
}
function inverse$1(r) {
  var e = -1, s = 0, o = 0, a, l, u, c;
  if (r.x = r.x / this.a, r.y = r.y / this.a, this.shape === "ellipse") {
    this.flip_axis ? (o = Math.tan(r.y / this.radius_g_1), s = Math.tan(r.x / this.radius_g_1) * hypot(1, o)) : (s = Math.tan(r.x / this.radius_g_1), o = Math.tan(r.y / this.radius_g_1) * hypot(1, s));
    var E = o / this.radius_p;
    if (a = s * s + E * E + e * e, l = 2 * this.radius_g * e, u = l * l - 4 * a * this.C, u < 0)
      return r.x = Number.NaN, r.y = Number.NaN, r;
    c = (-l - Math.sqrt(u)) / (2 * a), e = this.radius_g + c * e, s *= c, o *= c, r.x = Math.atan2(s, e), r.y = Math.atan(o * Math.cos(r.x) / e), r.y = Math.atan(this.radius_p_inv2 * Math.tan(r.y));
  } else if (this.shape === "sphere") {
    if (this.flip_axis ? (o = Math.tan(r.y / this.radius_g_1), s = Math.tan(r.x / this.radius_g_1) * Math.sqrt(1 + o * o)) : (s = Math.tan(r.x / this.radius_g_1), o = Math.tan(r.y / this.radius_g_1) * Math.sqrt(1 + s * s)), a = s * s + o * o + e * e, l = 2 * this.radius_g * e, u = l * l - 4 * a * this.C, u < 0)
      return r.x = Number.NaN, r.y = Number.NaN, r;
    c = (-l - Math.sqrt(u)) / (2 * a), e = this.radius_g + c * e, s *= c, o *= c, r.x = Math.atan2(s, e), r.y = Math.atan(o * Math.cos(r.x) / e);
  }
  return r.x = r.x + this.long0, r;
}
var names$2 = ["Geostationary Satellite View", "Geostationary_Satellite", "geos"];
const geos = {
  init: init$2,
  forward: forward$1,
  inverse: inverse$1,
  names: names$2
};
var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = Math.sqrt(3) / 2;
function init$1() {
  this.es = 0, this.long0 = this.long0 !== void 0 ? this.long0 : 0;
}
function forward(r) {
  var e = adjust_lon(r.x - this.long0), s = r.y, o = Math.asin(M * Math.sin(s)), a = o * o, l = a * a * a;
  return r.x = e * Math.cos(o) / (M * (A1 + 3 * A2 * a + l * (7 * A3 + 9 * A4 * a))), r.y = o * (A1 + A2 * a + l * (A3 + A4 * a)), r.x = this.a * r.x + this.x0, r.y = this.a * r.y + this.y0, r;
}
function inverse(r) {
  r.x = (r.x - this.x0) / this.a, r.y = (r.y - this.y0) / this.a;
  var e = 1e-9, s = 12, o = r.y, a, l, u, c, E, d;
  for (d = 0; d < s && (a = o * o, l = a * a * a, u = o * (A1 + A2 * a + l * (A3 + A4 * a)) - r.y, c = A1 + 3 * A2 * a + l * (7 * A3 + 9 * A4 * a), o -= E = u / c, !(Math.abs(E) < e)); ++d)
    ;
  return a = o * o, l = a * a * a, r.x = M * r.x * (A1 + 3 * A2 * a + l * (7 * A3 + 9 * A4 * a)) / Math.cos(o), r.y = Math.asin(Math.sin(o) / M), r.x = adjust_lon(r.x + this.long0), r;
}
var names$1 = ["eqearth", "Equal Earth", "Equal_Earth"];
const eqearth = {
  init: init$1,
  forward,
  inverse,
  names: names$1
};
var EPS10 = 1e-10;
function init() {
  var r;
  if (this.phi1 = this.lat1, Math.abs(this.phi1) < EPS10)
    throw new Error();
  this.es ? (this.en = pj_enfn(this.es), this.m1 = pj_mlfn(
    this.phi1,
    this.am1 = Math.sin(this.phi1),
    r = Math.cos(this.phi1),
    this.en
  ), this.am1 = r / (Math.sqrt(1 - this.es * this.am1 * this.am1) * this.am1), this.inverse = e_inv, this.forward = e_fwd) : (Math.abs(this.phi1) + EPS10 >= HALF_PI ? this.cphi1 = 0 : this.cphi1 = 1 / Math.tan(this.phi1), this.inverse = s_inv, this.forward = s_fwd);
}
function e_fwd(r) {
  var e = adjust_lon(r.x - (this.long0 || 0)), s = r.y, o, a, l;
  return o = this.am1 + this.m1 - pj_mlfn(s, a = Math.sin(s), l = Math.cos(s), this.en), a = l * e / (o * Math.sqrt(1 - this.es * a * a)), r.x = o * Math.sin(a), r.y = this.am1 - o * Math.cos(a), r.x = this.a * r.x + (this.x0 || 0), r.y = this.a * r.y + (this.y0 || 0), r;
}
function e_inv(r) {
  r.x = (r.x - (this.x0 || 0)) / this.a, r.y = (r.y - (this.y0 || 0)) / this.a;
  var e, s, o, a;
  if (s = hypot(r.x, r.y = this.am1 - r.y), a = pj_inv_mlfn(this.am1 + this.m1 - s, this.es, this.en), (e = Math.abs(a)) < HALF_PI)
    e = Math.sin(a), o = s * Math.atan2(r.x, r.y) * Math.sqrt(1 - this.es * e * e) / Math.cos(a);
  else if (Math.abs(e - HALF_PI) <= EPS10)
    o = 0;
  else
    throw new Error();
  return r.x = adjust_lon(o + (this.long0 || 0)), r.y = adjust_lat(a), r;
}
function s_fwd(r) {
  var e = adjust_lon(r.x - (this.long0 || 0)), s = r.y, o, a;
  return a = this.cphi1 + this.phi1 - s, Math.abs(a) > EPS10 ? (r.x = a * Math.sin(o = e * Math.cos(s) / a), r.y = this.cphi1 - a * Math.cos(o)) : r.x = r.y = 0, r.x = this.a * r.x + (this.x0 || 0), r.y = this.a * r.y + (this.y0 || 0), r;
}
function s_inv(r) {
  r.x = (r.x - (this.x0 || 0)) / this.a, r.y = (r.y - (this.y0 || 0)) / this.a;
  var e, s, o = hypot(r.x, r.y = this.cphi1 - r.y);
  if (s = this.cphi1 + this.phi1 - o, Math.abs(s) > HALF_PI)
    throw new Error();
  return Math.abs(Math.abs(s) - HALF_PI) <= EPS10 ? e = 0 : e = o * Math.atan2(r.x, r.y) / Math.cos(s), r.x = adjust_lon(e + (this.long0 || 0)), r.y = adjust_lat(s), r;
}
var names = ["bonne", "Bonne (Werner lat_1=90)"];
const bonne = {
  init,
  names
};
function includedProjections(r) {
  r.Proj.projections.add(tmerc), r.Proj.projections.add(etmerc), r.Proj.projections.add(utm), r.Proj.projections.add(sterea), r.Proj.projections.add(stere), r.Proj.projections.add(somerc), r.Proj.projections.add(omerc), r.Proj.projections.add(lcc), r.Proj.projections.add(krovak), r.Proj.projections.add(cass), r.Proj.projections.add(laea), r.Proj.projections.add(aea), r.Proj.projections.add(gnom), r.Proj.projections.add(cea), r.Proj.projections.add(eqc), r.Proj.projections.add(poly), r.Proj.projections.add(nzmg), r.Proj.projections.add(mill), r.Proj.projections.add(sinu), r.Proj.projections.add(moll), r.Proj.projections.add(eqdc), r.Proj.projections.add(vandg), r.Proj.projections.add(aeqd), r.Proj.projections.add(ortho), r.Proj.projections.add(qsc), r.Proj.projections.add(robin), r.Proj.projections.add(geocent), r.Proj.projections.add(tpers), r.Proj.projections.add(geos), r.Proj.projections.add(eqearth), r.Proj.projections.add(bonne);
}
const proj4 = Object.assign(proj4$1, {
  defaultDatum: "WGS84",
  Proj: Projection,
  WGS84: new Projection("WGS84"),
  Point,
  toPoint: common,
  defs,
  nadgrid,
  transform,
  mgrs,
  version: "__VERSION__"
});
includedProjections(proj4);
var validator = {}, util$1 = {};
(function(r) {
  const e = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", s = e + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", o = "[" + e + "][" + s + "]*", a = new RegExp("^" + o + "$"), l = function(c, E) {
    const d = [];
    let f = E.exec(c);
    for (; f; ) {
      const h = [];
      h.startIndex = E.lastIndex - f[0].length;
      const S = f.length;
      for (let R = 0; R < S; R++)
        h.push(f[R]);
      d.push(h), f = E.exec(c);
    }
    return d;
  }, u = function(c) {
    const E = a.exec(c);
    return !(E === null || typeof E > "u");
  };
  r.isExist = function(c) {
    return typeof c < "u";
  }, r.isEmptyObject = function(c) {
    return Object.keys(c).length === 0;
  }, r.merge = function(c, E, d) {
    if (E) {
      const f = Object.keys(E), h = f.length;
      for (let S = 0; S < h; S++)
        d === "strict" ? c[f[S]] = [E[f[S]]] : c[f[S]] = E[f[S]];
    }
  }, r.getValue = function(c) {
    return r.isExist(c) ? c : "";
  }, r.isName = u, r.getAllMatches = l, r.nameRegexp = o;
})(util$1);
const util = util$1, defaultOptions$1 = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
validator.validate = function(r, e) {
  e = Object.assign({}, defaultOptions$1, e);
  const s = [];
  let o = !1, a = !1;
  r[0] === "\uFEFF" && (r = r.substr(1));
  for (let l = 0; l < r.length; l++)
    if (r[l] === "<" && r[l + 1] === "?") {
      if (l += 2, l = readPI(r, l), l.err)
        return l;
    } else if (r[l] === "<") {
      let u = l;
      if (l++, r[l] === "!") {
        l = readCommentAndCDATA(r, l);
        continue;
      } else {
        let c = !1;
        r[l] === "/" && (c = !0, l++);
        let E = "";
        for (; l < r.length && r[l] !== ">" && r[l] !== " " && r[l] !== "	" && r[l] !== `
` && r[l] !== "\r"; l++)
          E += r[l];
        if (E = E.trim(), E[E.length - 1] === "/" && (E = E.substring(0, E.length - 1), l--), !validateTagName(E)) {
          let h;
          return E.trim().length === 0 ? h = "Invalid space after '<'." : h = "Tag '" + E + "' is an invalid name.", getErrorObject("InvalidTag", h, getLineNumberForPosition(r, l));
        }
        const d = readAttributeStr(r, l);
        if (d === !1)
          return getErrorObject("InvalidAttr", "Attributes for '" + E + "' have open quote.", getLineNumberForPosition(r, l));
        let f = d.value;
        if (l = d.index, f[f.length - 1] === "/") {
          const h = l - f.length;
          f = f.substring(0, f.length - 1);
          const S = validateAttributeString(f, e);
          if (S === !0)
            o = !0;
          else
            return getErrorObject(S.err.code, S.err.msg, getLineNumberForPosition(r, h + S.err.line));
        } else if (c)
          if (d.tagClosed) {
            if (f.trim().length > 0)
              return getErrorObject("InvalidTag", "Closing tag '" + E + "' can't have attributes or invalid starting.", getLineNumberForPosition(r, u));
            if (s.length === 0)
              return getErrorObject("InvalidTag", "Closing tag '" + E + "' has not been opened.", getLineNumberForPosition(r, u));
            {
              const h = s.pop();
              if (E !== h.tagName) {
                let S = getLineNumberForPosition(r, h.tagStartPos);
                return getErrorObject(
                  "InvalidTag",
                  "Expected closing tag '" + h.tagName + "' (opened in line " + S.line + ", col " + S.col + ") instead of closing tag '" + E + "'.",
                  getLineNumberForPosition(r, u)
                );
              }
              s.length == 0 && (a = !0);
            }
          } else
            return getErrorObject("InvalidTag", "Closing tag '" + E + "' doesn't have proper closing.", getLineNumberForPosition(r, l));
        else {
          const h = validateAttributeString(f, e);
          if (h !== !0)
            return getErrorObject(h.err.code, h.err.msg, getLineNumberForPosition(r, l - f.length + h.err.line));
          if (a === !0)
            return getErrorObject("InvalidXml", "Multiple possible root nodes found.", getLineNumberForPosition(r, l));
          e.unpairedTags.indexOf(E) !== -1 || s.push({ tagName: E, tagStartPos: u }), o = !0;
        }
        for (l++; l < r.length; l++)
          if (r[l] === "<")
            if (r[l + 1] === "!") {
              l++, l = readCommentAndCDATA(r, l);
              continue;
            } else if (r[l + 1] === "?") {
              if (l = readPI(r, ++l), l.err)
                return l;
            } else
              break;
          else if (r[l] === "&") {
            const h = validateAmpersand(r, l);
            if (h == -1)
              return getErrorObject("InvalidChar", "char '&' is not expected.", getLineNumberForPosition(r, l));
            l = h;
          } else if (a === !0 && !isWhiteSpace(r[l]))
            return getErrorObject("InvalidXml", "Extra text at the end", getLineNumberForPosition(r, l));
        r[l] === "<" && l--;
      }
    } else {
      if (isWhiteSpace(r[l]))
        continue;
      return getErrorObject("InvalidChar", "char '" + r[l] + "' is not expected.", getLineNumberForPosition(r, l));
    }
  if (o) {
    if (s.length == 1)
      return getErrorObject("InvalidTag", "Unclosed tag '" + s[0].tagName + "'.", getLineNumberForPosition(r, s[0].tagStartPos));
    if (s.length > 0)
      return getErrorObject("InvalidXml", "Invalid '" + JSON.stringify(s.map((l) => l.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return getErrorObject("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function isWhiteSpace(r) {
  return r === " " || r === "	" || r === `
` || r === "\r";
}
function readPI(r, e) {
  const s = e;
  for (; e < r.length; e++)
    if (r[e] == "?" || r[e] == " ") {
      const o = r.substr(s, e - s);
      if (e > 5 && o === "xml")
        return getErrorObject("InvalidXml", "XML declaration allowed only at the start of the document.", getLineNumberForPosition(r, e));
      if (r[e] == "?" && r[e + 1] == ">") {
        e++;
        break;
      } else
        continue;
    }
  return e;
}
function readCommentAndCDATA(r, e) {
  if (r.length > e + 5 && r[e + 1] === "-" && r[e + 2] === "-") {
    for (e += 3; e < r.length; e++)
      if (r[e] === "-" && r[e + 1] === "-" && r[e + 2] === ">") {
        e += 2;
        break;
      }
  } else if (r.length > e + 8 && r[e + 1] === "D" && r[e + 2] === "O" && r[e + 3] === "C" && r[e + 4] === "T" && r[e + 5] === "Y" && r[e + 6] === "P" && r[e + 7] === "E") {
    let s = 1;
    for (e += 8; e < r.length; e++)
      if (r[e] === "<")
        s++;
      else if (r[e] === ">" && (s--, s === 0))
        break;
  } else if (r.length > e + 9 && r[e + 1] === "[" && r[e + 2] === "C" && r[e + 3] === "D" && r[e + 4] === "A" && r[e + 5] === "T" && r[e + 6] === "A" && r[e + 7] === "[") {
    for (e += 8; e < r.length; e++)
      if (r[e] === "]" && r[e + 1] === "]" && r[e + 2] === ">") {
        e += 2;
        break;
      }
  }
  return e;
}
const doubleQuote = '"', singleQuote = "'";
function readAttributeStr(r, e) {
  let s = "", o = "", a = !1;
  for (; e < r.length; e++) {
    if (r[e] === doubleQuote || r[e] === singleQuote)
      o === "" ? o = r[e] : o !== r[e] || (o = "");
    else if (r[e] === ">" && o === "") {
      a = !0;
      break;
    }
    s += r[e];
  }
  return o !== "" ? !1 : {
    value: s,
    index: e,
    tagClosed: a
  };
}
const validAttrStrRegxp = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function validateAttributeString(r, e) {
  const s = util.getAllMatches(r, validAttrStrRegxp), o = {};
  for (let a = 0; a < s.length; a++) {
    if (s[a][1].length === 0)
      return getErrorObject("InvalidAttr", "Attribute '" + s[a][2] + "' has no space in starting.", getPositionFromMatch(s[a]));
    if (s[a][3] !== void 0 && s[a][4] === void 0)
      return getErrorObject("InvalidAttr", "Attribute '" + s[a][2] + "' is without value.", getPositionFromMatch(s[a]));
    if (s[a][3] === void 0 && !e.allowBooleanAttributes)
      return getErrorObject("InvalidAttr", "boolean attribute '" + s[a][2] + "' is not allowed.", getPositionFromMatch(s[a]));
    const l = s[a][2];
    if (!validateAttrName(l))
      return getErrorObject("InvalidAttr", "Attribute '" + l + "' is an invalid name.", getPositionFromMatch(s[a]));
    if (!o.hasOwnProperty(l))
      o[l] = 1;
    else
      return getErrorObject("InvalidAttr", "Attribute '" + l + "' is repeated.", getPositionFromMatch(s[a]));
  }
  return !0;
}
function validateNumberAmpersand(r, e) {
  let s = /\d/;
  for (r[e] === "x" && (e++, s = /[\da-fA-F]/); e < r.length; e++) {
    if (r[e] === ";")
      return e;
    if (!r[e].match(s))
      break;
  }
  return -1;
}
function validateAmpersand(r, e) {
  if (e++, r[e] === ";")
    return -1;
  if (r[e] === "#")
    return e++, validateNumberAmpersand(r, e);
  let s = 0;
  for (; e < r.length; e++, s++)
    if (!(r[e].match(/\w/) && s < 20)) {
      if (r[e] === ";")
        break;
      return -1;
    }
  return e;
}
function getErrorObject(r, e, s) {
  return {
    err: {
      code: r,
      msg: e,
      line: s.line || s,
      col: s.col
    }
  };
}
function validateAttrName(r) {
  return util.isName(r);
}
function validateTagName(r) {
  return util.isName(r);
}
function getLineNumberForPosition(r, e) {
  const s = r.substring(0, e).split(/\r?\n/);
  return {
    line: s.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: s[s.length - 1].length + 1
  };
}
function getPositionFromMatch(r) {
  return r.startIndex + r[1].length;
}
function getIgnoreAttributesFn$1(r) {
  return typeof r == "function" ? r : Array.isArray(r) ? (e) => {
    for (const s of r)
      if (typeof s == "string" && e === s || s instanceof RegExp && s.test(e))
        return !0;
  } : () => !1;
}
var ignoreAttributes = getIgnoreAttributesFn$1;
const EOL = `
`;
function toXml(r, e) {
  let s = "";
  return e.format && e.indentBy.length > 0 && (s = EOL), arrToStr(r, e, "", s);
}
function arrToStr(r, e, s, o) {
  let a = "", l = !1;
  for (let u = 0; u < r.length; u++) {
    const c = r[u], E = propName(c);
    if (E === void 0)
      continue;
    let d = "";
    if (s.length === 0 ? d = E : d = `${s}.${E}`, E === e.textNodeName) {
      let _ = c[E];
      isStopNode(d, e) || (_ = e.tagValueProcessor(E, _), _ = replaceEntitiesValue(_, e)), l && (a += o), a += _, l = !1;
      continue;
    } else if (E === e.cdataPropName) {
      l && (a += o), a += `<![CDATA[${c[E][0][e.textNodeName]}]]>`, l = !1;
      continue;
    } else if (E === e.commentPropName) {
      a += o + `<!--${c[E][0][e.textNodeName]}-->`, l = !0;
      continue;
    } else if (E[0] === "?") {
      const _ = attr_to_str(c[":@"], e), m = E === "?xml" ? "" : o;
      let L = c[E][0][e.textNodeName];
      L = L.length !== 0 ? " " + L : "", a += m + `<${E}${L}${_}?>`, l = !0;
      continue;
    }
    let f = o;
    f !== "" && (f += e.indentBy);
    const h = attr_to_str(c[":@"], e), S = o + `<${E}${h}`, R = arrToStr(c[E], e, d, f);
    e.unpairedTags.indexOf(E) !== -1 ? e.suppressUnpairedNode ? a += S + ">" : a += S + "/>" : (!R || R.length === 0) && e.suppressEmptyNode ? a += S + "/>" : R && R.endsWith(">") ? a += S + `>${R}${o}</${E}>` : (a += S + ">", R && o !== "" && (R.includes("/>") || R.includes("</")) ? a += o + e.indentBy + R + o : a += R, a += `</${E}>`), l = !0;
  }
  return a;
}
function propName(r) {
  const e = Object.keys(r);
  for (let s = 0; s < e.length; s++) {
    const o = e[s];
    if (r.hasOwnProperty(o) && o !== ":@")
      return o;
  }
}
function attr_to_str(r, e) {
  let s = "";
  if (r && !e.ignoreAttributes)
    for (let o in r) {
      if (!r.hasOwnProperty(o))
        continue;
      let a = e.attributeValueProcessor(o, r[o]);
      a = replaceEntitiesValue(a, e), a === !0 && e.suppressBooleanAttributes ? s += ` ${o.substr(e.attributeNamePrefix.length)}` : s += ` ${o.substr(e.attributeNamePrefix.length)}="${a}"`;
    }
  return s;
}
function isStopNode(r, e) {
  r = r.substr(0, r.length - e.textNodeName.length - 1);
  let s = r.substr(r.lastIndexOf(".") + 1);
  for (let o in e.stopNodes)
    if (e.stopNodes[o] === r || e.stopNodes[o] === "*." + s)
      return !0;
  return !1;
}
function replaceEntitiesValue(r, e) {
  if (r && r.length > 0 && e.processEntities)
    for (let s = 0; s < e.entities.length; s++) {
      const o = e.entities[s];
      r = r.replace(o.regex, o.val);
    }
  return r;
}
var orderedJs2Xml = toXml;
const buildFromOrderedJs = orderedJs2Xml, getIgnoreAttributesFn = ignoreAttributes, defaultOptions = {
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  cdataPropName: !1,
  format: !1,
  indentBy: "  ",
  suppressEmptyNode: !1,
  suppressUnpairedNode: !0,
  suppressBooleanAttributes: !0,
  tagValueProcessor: function(r, e) {
    return e;
  },
  attributeValueProcessor: function(r, e) {
    return e;
  },
  preserveOrder: !1,
  commentPropName: !1,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: !0,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: !1
};
function Builder(r) {
  this.options = Object.assign({}, defaultOptions, r), this.options.ignoreAttributes === !0 || this.options.attributesGroupName ? this.isAttribute = function() {
    return !1;
  } : (this.ignoreAttributesFn = getIgnoreAttributesFn(this.options.ignoreAttributes), this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = isAttribute), this.processTextOrObjNode = processTextOrObjNode, this.options.format ? (this.indentate = indentate, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
Builder.prototype.build = function(r) {
  return this.options.preserveOrder ? buildFromOrderedJs(r, this.options) : (Array.isArray(r) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (r = {
    [this.options.arrayNodeName]: r
  }), this.j2x(r, 0, []).val);
};
Builder.prototype.j2x = function(r, e, s) {
  let o = "", a = "";
  const l = s.join(".");
  for (let u in r)
    if (Object.prototype.hasOwnProperty.call(r, u))
      if (typeof r[u] > "u")
        this.isAttribute(u) && (a += "");
      else if (r[u] === null)
        this.isAttribute(u) || u === this.options.cdataPropName ? a += "" : u[0] === "?" ? a += this.indentate(e) + "<" + u + "?" + this.tagEndChar : a += this.indentate(e) + "<" + u + "/" + this.tagEndChar;
      else if (r[u] instanceof Date)
        a += this.buildTextValNode(r[u], u, "", e);
      else if (typeof r[u] != "object") {
        const c = this.isAttribute(u);
        if (c && !this.ignoreAttributesFn(c, l))
          o += this.buildAttrPairStr(c, "" + r[u]);
        else if (!c)
          if (u === this.options.textNodeName) {
            let E = this.options.tagValueProcessor(u, "" + r[u]);
            a += this.replaceEntitiesValue(E);
          } else
            a += this.buildTextValNode(r[u], u, "", e);
      } else if (Array.isArray(r[u])) {
        const c = r[u].length;
        let E = "", d = "";
        for (let f = 0; f < c; f++) {
          const h = r[u][f];
          if (!(typeof h > "u"))
            if (h === null)
              u[0] === "?" ? a += this.indentate(e) + "<" + u + "?" + this.tagEndChar : a += this.indentate(e) + "<" + u + "/" + this.tagEndChar;
            else if (typeof h == "object")
              if (this.options.oneListGroup) {
                const S = this.j2x(h, e + 1, s.concat(u));
                E += S.val, this.options.attributesGroupName && h.hasOwnProperty(this.options.attributesGroupName) && (d += S.attrStr);
              } else
                E += this.processTextOrObjNode(h, u, e, s);
            else if (this.options.oneListGroup) {
              let S = this.options.tagValueProcessor(u, h);
              S = this.replaceEntitiesValue(S), E += S;
            } else
              E += this.buildTextValNode(h, u, "", e);
        }
        this.options.oneListGroup && (E = this.buildObjectNode(E, u, d, e)), a += E;
      } else if (this.options.attributesGroupName && u === this.options.attributesGroupName) {
        const c = Object.keys(r[u]), E = c.length;
        for (let d = 0; d < E; d++)
          o += this.buildAttrPairStr(c[d], "" + r[u][c[d]]);
      } else
        a += this.processTextOrObjNode(r[u], u, e, s);
  return { attrStr: o, val: a };
};
Builder.prototype.buildAttrPairStr = function(r, e) {
  return e = this.options.attributeValueProcessor(r, "" + e), e = this.replaceEntitiesValue(e), this.options.suppressBooleanAttributes && e === "true" ? " " + r : " " + r + '="' + e + '"';
};
function processTextOrObjNode(r, e, s, o) {
  const a = this.j2x(r, s + 1, o.concat(e));
  return r[this.options.textNodeName] !== void 0 && Object.keys(r).length === 1 ? this.buildTextValNode(r[this.options.textNodeName], e, a.attrStr, s) : this.buildObjectNode(a.val, e, a.attrStr, s);
}
Builder.prototype.buildObjectNode = function(r, e, s, o) {
  if (r === "")
    return e[0] === "?" ? this.indentate(o) + "<" + e + s + "?" + this.tagEndChar : this.indentate(o) + "<" + e + s + this.closeTag(e) + this.tagEndChar;
  {
    let a = "</" + e + this.tagEndChar, l = "";
    return e[0] === "?" && (l = "?", a = ""), (s || s === "") && r.indexOf("<") === -1 ? this.indentate(o) + "<" + e + s + l + ">" + r + a : this.options.commentPropName !== !1 && e === this.options.commentPropName && l.length === 0 ? this.indentate(o) + `<!--${r}-->` + this.newLine : this.indentate(o) + "<" + e + s + l + this.tagEndChar + r + this.indentate(o) + a;
  }
};
Builder.prototype.closeTag = function(r) {
  let e = "";
  return this.options.unpairedTags.indexOf(r) !== -1 ? this.options.suppressUnpairedNode || (e = "/") : this.options.suppressEmptyNode ? e = "/" : e = `></${r}`, e;
};
Builder.prototype.buildTextValNode = function(r, e, s, o) {
  if (this.options.cdataPropName !== !1 && e === this.options.cdataPropName)
    return this.indentate(o) + `<![CDATA[${r}]]>` + this.newLine;
  if (this.options.commentPropName !== !1 && e === this.options.commentPropName)
    return this.indentate(o) + `<!--${r}-->` + this.newLine;
  if (e[0] === "?")
    return this.indentate(o) + "<" + e + s + "?" + this.tagEndChar;
  {
    let a = this.options.tagValueProcessor(e, r);
    return a = this.replaceEntitiesValue(a), a === "" ? this.indentate(o) + "<" + e + s + this.closeTag(e) + this.tagEndChar : this.indentate(o) + "<" + e + s + ">" + a + "</" + e + this.tagEndChar;
  }
};
Builder.prototype.replaceEntitiesValue = function(r) {
  if (r && r.length > 0 && this.options.processEntities)
    for (let e = 0; e < this.options.entities.length; e++) {
      const s = this.options.entities[e];
      r = r.replace(s.regex, s.val);
    }
  return r;
};
function indentate(r) {
  return this.options.indentBy.repeat(r);
}
function isAttribute(r) {
  return r.startsWith(this.options.attributeNamePrefix) && r !== this.options.textNodeName ? r.substr(this.attrPrefixLen) : !1;
}
function assertPath(r) {
  if (typeof r != "string")
    throw new TypeError("Path must be a string. Received " + JSON.stringify(r));
}
function normalizeStringPosix(r, e) {
  for (var s = "", o = 0, a = -1, l = 0, u, c = 0; c <= r.length; ++c) {
    if (c < r.length)
      u = r.charCodeAt(c);
    else {
      if (u === 47)
        break;
      u = 47;
    }
    if (u === 47) {
      if (!(a === c - 1 || l === 1))
        if (a !== c - 1 && l === 2) {
          if (s.length < 2 || o !== 2 || s.charCodeAt(s.length - 1) !== 46 || s.charCodeAt(s.length - 2) !== 46) {
            if (s.length > 2) {
              var E = s.lastIndexOf("/");
              if (E !== s.length - 1) {
                E === -1 ? (s = "", o = 0) : (s = s.slice(0, E), o = s.length - 1 - s.lastIndexOf("/")), a = c, l = 0;
                continue;
              }
            } else if (s.length === 2 || s.length === 1) {
              s = "", o = 0, a = c, l = 0;
              continue;
            }
          }
          e && (s.length > 0 ? s += "/.." : s = "..", o = 2);
        } else
          s.length > 0 ? s += "/" + r.slice(a + 1, c) : s = r.slice(a + 1, c), o = c - a - 1;
      a = c, l = 0;
    } else
      u === 46 && l !== -1 ? ++l : l = -1;
  }
  return s;
}
function _format(r, e) {
  var s = e.dir || e.root, o = e.base || (e.name || "") + (e.ext || "");
  return s ? s === e.root ? s + o : s + r + o : o;
}
var posix = {
  // path.resolve([from ...], to)
  resolve: function r() {
    for (var e = "", s = !1, o, a = arguments.length - 1; a >= -1 && !s; a--) {
      var l;
      a >= 0 ? l = arguments[a] : (o === void 0 && (o = api$1.cwd()), l = o), assertPath(l), l.length !== 0 && (e = l + "/" + e, s = l.charCodeAt(0) === 47);
    }
    return e = normalizeStringPosix(e, !s), s ? e.length > 0 ? "/" + e : "/" : e.length > 0 ? e : ".";
  },
  normalize: function r(e) {
    if (assertPath(e), e.length === 0)
      return ".";
    var s = e.charCodeAt(0) === 47, o = e.charCodeAt(e.length - 1) === 47;
    return e = normalizeStringPosix(e, !s), e.length === 0 && !s && (e = "."), e.length > 0 && o && (e += "/"), s ? "/" + e : e;
  },
  isAbsolute: function r(e) {
    return assertPath(e), e.length > 0 && e.charCodeAt(0) === 47;
  },
  join: function r() {
    if (arguments.length === 0)
      return ".";
    for (var e, s = 0; s < arguments.length; ++s) {
      var o = arguments[s];
      assertPath(o), o.length > 0 && (e === void 0 ? e = o : e += "/" + o);
    }
    return e === void 0 ? "." : posix.normalize(e);
  },
  relative: function r(e, s) {
    if (assertPath(e), assertPath(s), e === s || (e = posix.resolve(e), s = posix.resolve(s), e === s))
      return "";
    for (var o = 1; o < e.length && e.charCodeAt(o) === 47; ++o)
      ;
    for (var a = e.length, l = a - o, u = 1; u < s.length && s.charCodeAt(u) === 47; ++u)
      ;
    for (var c = s.length, E = c - u, d = l < E ? l : E, f = -1, h = 0; h <= d; ++h) {
      if (h === d) {
        if (E > d) {
          if (s.charCodeAt(u + h) === 47)
            return s.slice(u + h + 1);
          if (h === 0)
            return s.slice(u + h);
        } else
          l > d && (e.charCodeAt(o + h) === 47 ? f = h : h === 0 && (f = 0));
        break;
      }
      var S = e.charCodeAt(o + h), R = s.charCodeAt(u + h);
      if (S !== R)
        break;
      S === 47 && (f = h);
    }
    var _ = "";
    for (h = o + f + 1; h <= a; ++h)
      (h === a || e.charCodeAt(h) === 47) && (_.length === 0 ? _ += ".." : _ += "/..");
    return _.length > 0 ? _ + s.slice(u + f) : (u += f, s.charCodeAt(u) === 47 && ++u, s.slice(u));
  },
  _makeLong: function r(e) {
    return e;
  },
  dirname: function r(e) {
    if (assertPath(e), e.length === 0)
      return ".";
    for (var s = e.charCodeAt(0), o = s === 47, a = -1, l = !0, u = e.length - 1; u >= 1; --u)
      if (s = e.charCodeAt(u), s === 47) {
        if (!l) {
          a = u;
          break;
        }
      } else
        l = !1;
    return a === -1 ? o ? "/" : "." : o && a === 1 ? "//" : e.slice(0, a);
  },
  basename: function r(e, s) {
    if (s !== void 0 && typeof s != "string")
      throw new TypeError('"ext" argument must be a string');
    assertPath(e);
    var o = 0, a = -1, l = !0, u;
    if (s !== void 0 && s.length > 0 && s.length <= e.length) {
      if (s.length === e.length && s === e)
        return "";
      var c = s.length - 1, E = -1;
      for (u = e.length - 1; u >= 0; --u) {
        var d = e.charCodeAt(u);
        if (d === 47) {
          if (!l) {
            o = u + 1;
            break;
          }
        } else
          E === -1 && (l = !1, E = u + 1), c >= 0 && (d === s.charCodeAt(c) ? --c === -1 && (a = u) : (c = -1, a = E));
      }
      return o === a ? a = E : a === -1 && (a = e.length), e.slice(o, a);
    } else {
      for (u = e.length - 1; u >= 0; --u)
        if (e.charCodeAt(u) === 47) {
          if (!l) {
            o = u + 1;
            break;
          }
        } else
          a === -1 && (l = !1, a = u + 1);
      return a === -1 ? "" : e.slice(o, a);
    }
  },
  extname: function r(e) {
    assertPath(e);
    for (var s = -1, o = 0, a = -1, l = !0, u = 0, c = e.length - 1; c >= 0; --c) {
      var E = e.charCodeAt(c);
      if (E === 47) {
        if (!l) {
          o = c + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = c + 1), E === 46 ? s === -1 ? s = c : u !== 1 && (u = 1) : s !== -1 && (u = -1);
    }
    return s === -1 || a === -1 || // We saw a non-dot character immediately before the dot
    u === 0 || // The (right-most) trimmed path component is exactly '..'
    u === 1 && s === a - 1 && s === o + 1 ? "" : e.slice(s, a);
  },
  format: function r(e) {
    if (e === null || typeof e != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
    return _format("/", e);
  },
  parse: function r(e) {
    assertPath(e);
    var s = { root: "", dir: "", base: "", ext: "", name: "" };
    if (e.length === 0)
      return s;
    var o = e.charCodeAt(0), a = o === 47, l;
    a ? (s.root = "/", l = 1) : l = 0;
    for (var u = -1, c = 0, E = -1, d = !0, f = e.length - 1, h = 0; f >= l; --f) {
      if (o = e.charCodeAt(f), o === 47) {
        if (!d) {
          c = f + 1;
          break;
        }
        continue;
      }
      E === -1 && (d = !1, E = f + 1), o === 46 ? u === -1 ? u = f : h !== 1 && (h = 1) : u !== -1 && (h = -1);
    }
    return u === -1 || E === -1 || // We saw a non-dot character immediately before the dot
    h === 0 || // The (right-most) trimmed path component is exactly '..'
    h === 1 && u === E - 1 && u === c + 1 ? E !== -1 && (c === 0 && a ? s.base = s.name = e.slice(1, E) : s.base = s.name = e.slice(c, E)) : (c === 0 && a ? (s.name = e.slice(1, u), s.base = e.slice(1, E)) : (s.name = e.slice(c, u), s.base = e.slice(c, E)), s.ext = e.slice(u, E)), c > 0 ? s.dir = e.slice(0, c - 1) : a && (s.dir = "/"), s;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
posix.posix = posix;
var pathBrowserify = posix, gdal3_node = { exports: {} }, empty$1 = null;
const empty$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: empty$1
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(empty$2);
(function(r, e) {
  (function(s, o) {
    r.exports = o(require$$0, pathBrowserify, requireString_decoder());
  })(commonjsGlobal, function(s, o, a) {
    function l(wt, _t) {
      var Ve, Ze = Object.keys(wt);
      return Object.getOwnPropertySymbols && (Ve = Object.getOwnPropertySymbols(wt), _t && (Ve = Ve.filter(function(bt) {
        return Object.getOwnPropertyDescriptor(wt, bt).enumerable;
      })), Ze.push.apply(Ze, Ve)), Ze;
    }
    function u(wt) {
      for (var _t = 1; _t < arguments.length; _t++) {
        var Ve = arguments[_t] != null ? arguments[_t] : {};
        _t % 2 ? l(Object(Ve), !0).forEach(function(Ze) {
          var bt, Ut;
          bt = wt, Ut = Ve[Ze = Ze], (Ze = R(Ze)) in bt ? Object.defineProperty(bt, Ze, { value: Ut, enumerable: !0, configurable: !0, writable: !0 }) : bt[Ze] = Ut;
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(wt, Object.getOwnPropertyDescriptors(Ve)) : l(Object(Ve)).forEach(function(Ze) {
          Object.defineProperty(wt, Ze, Object.getOwnPropertyDescriptor(Ve, Ze));
        });
      }
      return wt;
    }
    function c(wt) {
      return (c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_t) {
        return typeof _t;
      } : function(_t) {
        return _t && typeof Symbol == "function" && _t.constructor === Symbol && _t !== Symbol.prototype ? "symbol" : typeof _t;
      })(wt);
    }
    function E(wt, _t) {
      for (var Ve = 0; Ve < _t.length; Ve++) {
        var Ze = _t[Ve];
        Ze.enumerable = Ze.enumerable || !1, Ze.configurable = !0, "value" in Ze && (Ze.writable = !0), Object.defineProperty(wt, R(Ze.key), Ze);
      }
    }
    function d(wt, _t) {
      return function(Ve) {
        if (Array.isArray(Ve))
          return Ve;
      }(wt) || function(Ve, Ze) {
        var bt = Ve == null ? null : typeof Symbol < "u" && Ve[Symbol.iterator] || Ve["@@iterator"];
        if (bt != null) {
          var Ut, mn, nn, Sn, Mn = [], yn = !0, Pt = !1;
          try {
            if (nn = (bt = bt.call(Ve)).next, Ze === 0) {
              if (Object(bt) !== bt)
                return;
              yn = !1;
            } else
              for (; !(yn = (Ut = nn.call(bt)).done) && (Mn.push(Ut.value), Mn.length !== Ze); yn = !0)
                ;
          } catch (tr) {
            Pt = !0, mn = tr;
          } finally {
            try {
              if (!yn && bt.return != null && (Sn = bt.return(), Object(Sn) !== Sn))
                return;
            } finally {
              if (Pt)
                throw mn;
            }
          }
          return Mn;
        }
      }(wt, _t) || h(wt, _t) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function f(wt) {
      return function(_t) {
        if (Array.isArray(_t))
          return S(_t);
      }(wt) || function(_t) {
        if (typeof Symbol < "u" && _t[Symbol.iterator] != null || _t["@@iterator"] != null)
          return Array.from(_t);
      }(wt) || h(wt) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function h(wt, _t) {
      var Ve;
      if (wt)
        return typeof wt == "string" ? S(wt, _t) : (Ve = (Ve = Object.prototype.toString.call(wt).slice(8, -1)) === "Object" && wt.constructor ? wt.constructor.name : Ve) === "Map" || Ve === "Set" ? Array.from(wt) : Ve === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ve) ? S(wt, _t) : void 0;
    }
    function S(wt, _t) {
      (_t == null || _t > wt.length) && (_t = wt.length);
      for (var Ve = 0, Ze = new Array(_t); Ve < _t; Ve++)
        Ze[Ve] = wt[Ve];
      return Ze;
    }
    function R(wt) {
      return wt = function(_t, Ve) {
        if (typeof _t != "object" || _t === null)
          return _t;
        var Ze = _t[Symbol.toPrimitive];
        if (Ze === void 0)
          return (Ve === "string" ? String : Number)(_t);
        if (typeof (Ze = Ze.call(_t, Ve || "default")) != "object")
          return Ze;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(wt, "string"), typeof wt == "symbol" ? wt : String(wt);
    }
    var _ = Object.prototype.toString.call(typeof api$1 < "u" ? api$1 : 0) === "[object process]";
    function m(wt) {
      return wt && wt.__esModule && Object.prototype.hasOwnProperty.call(wt, "default") ? wt.default : wt;
    }
    var L, Rn = { exports: {} }, Ci = Rn;
    function F() {
      var wt, _t, Ve, Ze, bt, Ut, mn, nn, Sn, Mn, yn = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {}, Pt = yn;
      function tr() {
        function k(b, X) {
          if (!b)
            throw X + new Error().stack;
        }
        function ne(b, X, J) {
          this.start = b, this.end = X, this.audio = J;
        }
        Pt.FS_createPath("/", "usr", !0, !0), Pt.FS_createPath("/usr", "share", !0, !0), Pt.FS_createPath("/usr/share", "gdal", !0, !0), Pt.FS_createPath("/usr/share", "proj", !0, !0), ne.prototype = { requests: {}, open: function(b, X) {
          this.name = X, this.requests[X] = this, Pt.addRunDependency("fp ".concat(this.name));
        }, send: function() {
        }, onload: function() {
          var b = this.byteArray.subarray(this.start, this.end);
          this.finish(b);
        }, finish: function(b) {
          Pt.FS_createDataFile(this.name, null, b, !0, !0, !0), Pt.removeRunDependency("fp ".concat(this.name)), this.requests[this.name] = null;
        } };
        for (var T = Ve.files, y = 0; y < T.length; ++y)
          new ne(T[y].start, T[y].end, T[y].audio || 0).open("GET", T[y].filename);
        function N(b) {
          k(b, "Loading data file failed."), k(b.constructor.name === ArrayBuffer.name, "bad input to processPackageData");
          for (var b = new Uint8Array(b), X = (ne.prototype.byteArray = b, Ve.files), J = 0; J < X.length; ++J)
            ne.prototype.requests[X[J].filename].onload();
          Pt.removeRunDependency("datafile_/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data");
        }
        Pt.addRunDependency("datafile_/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data"), Pt.preloadResults || (Pt.preloadResults = {}), Pt.preloadResults["/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data"] = { fromCache: !1 }, Mn ? (N(Mn), Mn = null) : Sn = N;
      }
      Pt.ready = new Promise(function(k, ne) {
        wt = k, _t = ne;
      }), Pt.expectedDataFileDownloads || (Pt.expectedDataFileDownloads = 0), Pt.expectedDataFileDownloads++, Pt.ENVIRONMENT_IS_PTHREAD || Pt.$ww || (Ve = { files: [{ filename: "/usr/share/gdal/GDALLogoBW.svg", start: 0, end: 13022 }, { filename: "/usr/share/gdal/GDALLogoColor.svg", start: 13022, end: 25327 }, { filename: "/usr/share/gdal/GDALLogoGS.svg", start: 25327, end: 37632 }, { filename: "/usr/share/gdal/LICENSE.TXT", start: 37632, end: 59473 }, { filename: "/usr/share/gdal/bag_template.xml", start: 59473, end: 68493 }, { filename: "/usr/share/gdal/cubewerx_extra.wkt", start: 68493, end: 80470 }, { filename: "/usr/share/gdal/default.rsc", start: 80470, end: 544102 }, { filename: "/usr/share/gdal/ecw_cs.wkt", start: 544102, end: 908134 }, { filename: "/usr/share/gdal/eedaconf.json", start: 908134, end: 908545 }, { filename: "/usr/share/gdal/epsg.wkt", start: 908545, end: 908572 }, { filename: "/usr/share/gdal/esri_StatePlane_extra.wkt", start: 908572, end: 1241118 }, { filename: "/usr/share/gdal/gdalicon.png", start: 1241118, end: 1243139 }, { filename: "/usr/share/gdal/gdalinfo_output.schema.json", start: 1243139, end: 1251130 }, { filename: "/usr/share/gdal/gdalmdiminfo_output.schema.json", start: 1251130, end: 1257673 }, { filename: "/usr/share/gdal/gdalvrt.xsd", start: 1257673, end: 1291600 }, { filename: "/usr/share/gdal/gfs.xsd", start: 1291600, end: 1308069 }, { filename: "/usr/share/gdal/gml_registry.xml", start: 1308069, end: 1314712 }, { filename: "/usr/share/gdal/gml_registry.xsd", start: 1314712, end: 1321174 }, { filename: "/usr/share/gdal/gmlasconf.xml", start: 1321174, end: 1328606 }, { filename: "/usr/share/gdal/gmlasconf.xsd", start: 1328606, end: 1377260 }, { filename: "/usr/share/gdal/grib2_center.csv", start: 1377260, end: 1381431 }, { filename: "/usr/share/gdal/grib2_process.csv", start: 1381431, end: 1386357 }, { filename: "/usr/share/gdal/grib2_subcenter.csv", start: 1386357, end: 1388685 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_0.csv", start: 1388685, end: 1399048 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_1.csv", start: 1399048, end: 1415553 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_13.csv", start: 1415553, end: 1425149 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_14.csv", start: 1425149, end: 1434700 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_15.csv", start: 1434700, end: 1444546 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_16.csv", start: 1444546, end: 1454217 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_17.csv", start: 1454217, end: 1455140 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_18.csv", start: 1455140, end: 1465364 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_19.csv", start: 1465364, end: 1477238 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_190.csv", start: 1477238, end: 1486745 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_191.csv", start: 1486745, end: 1496365 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_2.csv", start: 1496365, end: 1507257 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_20.csv", start: 1507257, end: 1519548 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_21.csv", start: 1519548, end: 1529810 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_3.csv", start: 1529810, end: 1540368 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_4.csv", start: 1540368, end: 1550679 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_5.csv", start: 1550679, end: 1560505 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_6.csv", start: 1560505, end: 1572147 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_7.csv", start: 1572147, end: 1582639 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_0.csv", start: 1582639, end: 1594461 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_1.csv", start: 1594461, end: 1604086 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_191.csv", start: 1604086, end: 1613720 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_2.csv", start: 1613720, end: 1623832 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_3.csv", start: 1623832, end: 1633821 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_4.csv", start: 1633821, end: 1644637 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_0.csv", start: 1644637, end: 1654779 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_1.csv", start: 1654779, end: 1664434 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_2.csv", start: 1664434, end: 1674232 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_0.csv", start: 1674232, end: 1683875 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_1.csv", start: 1683875, end: 1693726 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_2.csv", start: 1693726, end: 1703232 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_0.csv", start: 1703232, end: 1715898 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_3.csv", start: 1715898, end: 1726532 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_4.csv", start: 1726532, end: 1737760 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_5.csv", start: 1737760, end: 1747273 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_6.csv", start: 1747273, end: 1756872 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_0.csv", start: 1756872, end: 1767823 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_1.csv", start: 1767823, end: 1778486 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_2.csv", start: 1778486, end: 1782319 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_3.csv", start: 1782319, end: 1783103 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_4.csv", start: 1783103, end: 1784154 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_5.csv", start: 1784154, end: 1785074 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_6.csv", start: 1785074, end: 1785893 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_0.csv", start: 1785893, end: 1795446 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_1.csv", start: 1795446, end: 1805132 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_10.csv", start: 1805132, end: 1814833 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_2.csv", start: 1814833, end: 1824493 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_3.csv", start: 1824493, end: 1834215 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_4.csv", start: 1834215, end: 1843905 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_5.csv", start: 1843905, end: 1853400 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_6.csv", start: 1853400, end: 1863033 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_7.csv", start: 1863033, end: 1872589 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_8.csv", start: 1872589, end: 1882275 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_9.csv", start: 1882275, end: 1891811 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_Canada.csv", start: 1891811, end: 1892144 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_HPC.csv", start: 1892144, end: 1892231 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_MRMS.csv", start: 1892231, end: 1907818 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_NCEP.csv", start: 1907818, end: 1935795 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_NDFD.csv", start: 1935795, end: 1938454 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_index.csv", start: 1938454, end: 1938705 }, { filename: "/usr/share/gdal/grib2_table_4_5.csv", start: 1938705, end: 1948718 }, { filename: "/usr/share/gdal/grib2_table_versions.csv", start: 1948718, end: 1948756 }, { filename: "/usr/share/gdal/gt_datum.csv", start: 1948756, end: 1964560 }, { filename: "/usr/share/gdal/gt_ellips.csv", start: 1964560, end: 1966279 }, { filename: "/usr/share/gdal/header.dxf", start: 1966279, end: 1972851 }, { filename: "/usr/share/gdal/inspire_cp_BasicPropertyUnit.gfs", start: 1972851, end: 1974591 }, { filename: "/usr/share/gdal/inspire_cp_CadastralBoundary.gfs", start: 1974591, end: 1976241 }, { filename: "/usr/share/gdal/inspire_cp_CadastralParcel.gfs", start: 1976241, end: 1978691 }, { filename: "/usr/share/gdal/inspire_cp_CadastralZoning.gfs", start: 1978691, end: 1983503 }, { filename: "/usr/share/gdal/jpfgdgml_AdmArea.gfs", start: 1983503, end: 1985143 }, { filename: "/usr/share/gdal/jpfgdgml_AdmBdry.gfs", start: 1985143, end: 1986525 }, { filename: "/usr/share/gdal/jpfgdgml_AdmPt.gfs", start: 1986525, end: 1988158 }, { filename: "/usr/share/gdal/jpfgdgml_BldA.gfs", start: 1988158, end: 1989659 }, { filename: "/usr/share/gdal/jpfgdgml_BldL.gfs", start: 1989659, end: 1991162 }, { filename: "/usr/share/gdal/jpfgdgml_Cntr.gfs", start: 1991162, end: 1992663 }, { filename: "/usr/share/gdal/jpfgdgml_CommBdry.gfs", start: 1992663, end: 1994047 }, { filename: "/usr/share/gdal/jpfgdgml_CommPt.gfs", start: 1994047, end: 1995682 }, { filename: "/usr/share/gdal/jpfgdgml_Cstline.gfs", start: 1995682, end: 1997191 }, { filename: "/usr/share/gdal/jpfgdgml_ElevPt.gfs", start: 1997191, end: 1998691 }, { filename: "/usr/share/gdal/jpfgdgml_GCP.gfs", start: 1998691, end: 2001214 }, { filename: "/usr/share/gdal/jpfgdgml_LeveeEdge.gfs", start: 2001214, end: 2002600 }, { filename: "/usr/share/gdal/jpfgdgml_RailCL.gfs", start: 2002600, end: 2004107 }, { filename: "/usr/share/gdal/jpfgdgml_RdASL.gfs", start: 2004107, end: 2005358 }, { filename: "/usr/share/gdal/jpfgdgml_RdArea.gfs", start: 2005358, end: 2006873 }, { filename: "/usr/share/gdal/jpfgdgml_RdCompt.gfs", start: 2006873, end: 2008519 }, { filename: "/usr/share/gdal/jpfgdgml_RdEdg.gfs", start: 2008519, end: 2010161 }, { filename: "/usr/share/gdal/jpfgdgml_RdMgtBdry.gfs", start: 2010161, end: 2011547 }, { filename: "/usr/share/gdal/jpfgdgml_RdSgmtA.gfs", start: 2011547, end: 2013191 }, { filename: "/usr/share/gdal/jpfgdgml_RvrMgtBdry.gfs", start: 2013191, end: 2014579 }, { filename: "/usr/share/gdal/jpfgdgml_SBAPt.gfs", start: 2014579, end: 2015954 }, { filename: "/usr/share/gdal/jpfgdgml_SBArea.gfs", start: 2015954, end: 2017461 }, { filename: "/usr/share/gdal/jpfgdgml_SBBdry.gfs", start: 2017461, end: 2018714 }, { filename: "/usr/share/gdal/jpfgdgml_WA.gfs", start: 2018714, end: 2020211 }, { filename: "/usr/share/gdal/jpfgdgml_WL.gfs", start: 2020211, end: 2021710 }, { filename: "/usr/share/gdal/jpfgdgml_WStrA.gfs", start: 2021710, end: 2023213 }, { filename: "/usr/share/gdal/jpfgdgml_WStrL.gfs", start: 2023213, end: 2024718 }, { filename: "/usr/share/gdal/netcdf_config.xsd", start: 2024718, end: 2032209 }, { filename: "/usr/share/gdal/nitf_spec.xml", start: 2032209, end: 2219654 }, { filename: "/usr/share/gdal/nitf_spec.xsd", start: 2219654, end: 2228162 }, { filename: "/usr/share/gdal/ogrinfo_output.schema.json", start: 2228162, end: 2239289 }, { filename: "/usr/share/gdal/ogrvrt.xsd", start: 2239289, end: 2265210 }, { filename: "/usr/share/gdal/osmconf.ini", start: 2265210, end: 2270610 }, { filename: "/usr/share/gdal/ozi_datum.csv", start: 2270610, end: 2279092 }, { filename: "/usr/share/gdal/ozi_ellips.csv", start: 2279092, end: 2280441 }, { filename: "/usr/share/gdal/pci_datum.txt", start: 2280441, end: 2315535 }, { filename: "/usr/share/gdal/pci_ellips.txt", start: 2315535, end: 2319050 }, { filename: "/usr/share/gdal/pdfcomposition.xsd", start: 2319050, end: 2353384 }, { filename: "/usr/share/gdal/pds4_template.xml", start: 2353384, end: 2356817 }, { filename: "/usr/share/gdal/plscenesconf.json", start: 2356817, end: 2398189 }, { filename: "/usr/share/gdal/ruian_vf_ob_v1.gfs", start: 2398189, end: 2444924 }, { filename: "/usr/share/gdal/ruian_vf_st_uvoh_v1.gfs", start: 2444924, end: 2447520 }, { filename: "/usr/share/gdal/ruian_vf_st_v1.gfs", start: 2447520, end: 2493420 }, { filename: "/usr/share/gdal/ruian_vf_v1.gfs", start: 2493420, end: 2560672 }, { filename: "/usr/share/gdal/s57agencies.csv", start: 2560672, end: 2573976 }, { filename: "/usr/share/gdal/s57attributes.csv", start: 2573976, end: 2593977 }, { filename: "/usr/share/gdal/s57expectedinput.csv", start: 2593977, end: 2614862 }, { filename: "/usr/share/gdal/s57objectclasses.csv", start: 2614862, end: 2668287 }, { filename: "/usr/share/gdal/seed_2d.dgn", start: 2668287, end: 2677503 }, { filename: "/usr/share/gdal/seed_3d.dgn", start: 2677503, end: 2679551 }, { filename: "/usr/share/gdal/stateplane.csv", start: 2679551, end: 2689911 }, { filename: "/usr/share/gdal/template_tiles.mapml", start: 2689911, end: 2691858 }, { filename: "/usr/share/gdal/tms_LINZAntarticaMapTileGrid.json", start: 2691858, end: 2695973 }, { filename: "/usr/share/gdal/tms_MapML_APSTILE.json", start: 2695973, end: 2702246 }, { filename: "/usr/share/gdal/tms_MapML_CBMTILE.json", start: 2702246, end: 2710038 }, { filename: "/usr/share/gdal/tms_NZTM2000.json", start: 2710038, end: 2715303 }, { filename: "/usr/share/gdal/trailer.dxf", start: 2715303, end: 2717578 }, { filename: "/usr/share/gdal/vdv452.xml", start: 2717578, end: 2743394 }, { filename: "/usr/share/gdal/vdv452.xsd", start: 2743394, end: 2746248 }, { filename: "/usr/share/gdal/vicar.json", start: 2746248, end: 2749858 }, { filename: "/usr/share/proj/CH", start: 2749858, end: 2750955 }, { filename: "/usr/share/proj/GL27", start: 2750955, end: 2751683 }, { filename: "/usr/share/proj/ITRF2000", start: 2751683, end: 2753782 }, { filename: "/usr/share/proj/ITRF2008", start: 2753782, end: 2759464 }, { filename: "/usr/share/proj/ITRF2014", start: 2759464, end: 2762953 }, { filename: "/usr/share/proj/deformation_model.schema.json", start: 2762953, end: 2780624 }, { filename: "/usr/share/proj/nad.lst", start: 2780624, end: 2787009 }, { filename: "/usr/share/proj/nad27", start: 2787009, end: 2806544 }, { filename: "/usr/share/proj/nad83", start: 2806544, end: 2823137 }, { filename: "/usr/share/proj/other.extra", start: 2823137, end: 2827052 }, { filename: "/usr/share/proj/proj.db", start: 2827052, end: 11539244 }, { filename: "/usr/share/proj/proj.ini", start: 11539244, end: 11541351 }, { filename: "/usr/share/proj/projjson.schema.json", start: 11541351, end: 11579663 }, { filename: "/usr/share/proj/triangulation.schema.json", start: 11579663, end: 11588066 }, { filename: "/usr/share/proj/world", start: 11588066, end: 11595145 }], remote_package_size: 11595145 }, (typeof window > "u" ? "undefined" : c(window)) === "object" ? window.encodeURIComponent(window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/") : typeof api$1 > "u" && typeof location < "u" && encodeURIComponent(location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/"), as = "gdal3WebAssembly.data", typeof Pt.locateFilePackage != "function" || Pt.locateFile || (Pt.locateFile = Pt.locateFilePackage, ii("warning: you defined Module.locateFilePackage, that has been renamed to Module.locateFile (using your locateFilePackage for now)")), as = Pt.locateFile ? Pt.locateFile(as, "") : as, Eo = Ve.remote_package_size, Sn = null, (Mn = Pt.getPreloadedPackage ? Pt.getPreloadedPackage(as, Eo) : null) || (Ze = as, bt = Eo, Ut = function(k) {
        Sn ? (Sn(k), Sn = null) : Mn = k;
      }, mn = function(k) {
        console.error("package error:", k);
      }, (typeof api$1 > "u" ? "undefined" : c(api$1)) === "object" && c(api$1.versions) === "object" && typeof api$1.versions.node == "string" ? s.readFile(Ze, function(k, ne) {
        k ? mn(k) : Ut(ne.buffer);
      }) : ((nn = new XMLHttpRequest()).open("GET", Ze, !0), nn.responseType = "arraybuffer", nn.onprogress = function(k) {
        var ne = Ze, T = bt;
        if (k.total && (T = k.total), k.loaded) {
          nn.addedTotal ? Pt.dataFileDownloads[ne].loaded = k.loaded : (nn.addedTotal = !0, Pt.dataFileDownloads || (Pt.dataFileDownloads = {}), Pt.dataFileDownloads[ne] = { loaded: k.loaded, total: T });
          var y, N = 0, b = 0, X = 0;
          for (y in Pt.dataFileDownloads) {
            var J = Pt.dataFileDownloads[y];
            N += J.total, b += J.loaded, X++;
          }
          N = Math.ceil(N * Pt.expectedDataFileDownloads / X), Pt.setStatus && Pt.setStatus("Downloading data... (".concat(b, "/").concat(N, ")"));
        } else
          Pt.dataFileDownloads || Pt.setStatus && Pt.setStatus("Downloading data...");
      }, nn.onerror = function(k) {
        throw new Error("NetworkError for: " + Ze);
      }, nn.onload = function(k) {
        if (!(nn.status == 200 || nn.status == 304 || nn.status == 206 || nn.status == 0 && nn.response))
          throw new Error(nn.statusText + " : " + nn.responseURL);
        var ne = nn.response;
        Ut(ne);
      }, nn.send(null))), Pt.calledRun ? tr() : (Pt.preRun || (Pt.preRun = []), Pt.preRun.push(tr)));
      var Lt, dr, ur, gr, Rr, as = Object.assign({}, Pt), hs = "./this.program", Os = function(k, ne) {
        throw ne;
      }, jo = (typeof window > "u" ? "undefined" : c(window)) == "object", po = typeof importScripts == "function", So = (typeof api$1 > "u" ? "undefined" : c(api$1)) == "object" && c(api$1.versions) == "object" && typeof api$1.versions.node == "string", Eo = "";
      So ? (Lt = s, dr = o, Eo = po ? dr.dirname(Eo) + "/" : __dirname + "/", ur = function(k, ne) {
        return k = Us(k) ? new URL(k) : dr.normalize(k), Lt.readFileSync(k, ne ? void 0 : "utf8");
      }, gr = function(k) {
        return k = ur(k, !0), k = k.buffer ? k : new Uint8Array(k);
      }, Rr = function(k, ne, T) {
        var y = !(3 < arguments.length && arguments[3] !== void 0) || arguments[3];
        k = Us(k) ? new URL(k) : dr.normalize(k), Lt.readFile(k, y ? void 0 : "utf8", function(N, b) {
          N ? T(N) : ne(y ? b.buffer : b);
        });
      }, !Pt.thisProgram && 1 < api$1.argv.length && (hs = api$1.argv[1].replace(/\\/g, "/")), api$1.argv.slice(2), Os = function(k, ne) {
        throw api$1.exitCode = k, ne;
      }, Pt.inspect = function() {
        return "[Emscripten Module object]";
      }) : (jo || po) && (po ? Eo = self.location.href : typeof document < "u" && document.currentScript && (Eo = document.currentScript.src), Eo = (Eo = L || Eo).indexOf("blob:") !== 0 ? Eo.substr(0, Eo.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", ur = function(k) {
        var ne = new XMLHttpRequest();
        return ne.open("GET", k, !1), ne.send(null), ne.responseText;
      }, po && (gr = function(k) {
        var ne = new XMLHttpRequest();
        return ne.open("GET", k, !1), ne.responseType = "arraybuffer", ne.send(null), new Uint8Array(ne.response);
      }), Rr = function(k, ne, T) {
        var y = new XMLHttpRequest();
        y.open("GET", k, !0), y.responseType = "arraybuffer", y.onload = function() {
          y.status == 200 || y.status == 0 && y.response ? ne(y.response) : T();
        }, y.onerror = T, y.send(null);
      });
      var Ps, no, gs, fo, xs, Ir, ws, fr, Mr, Nr = Pt.print || console.log.bind(console), ii = Pt.printErr || console.error.bind(console), Ro = (Object.assign(Pt, as), Pt.arguments && Pt.arguments, Pt.thisProgram && (hs = Pt.thisProgram), Pt.quit && (Os = Pt.quit), Pt.wasmBinary && (Ps = Pt.wasmBinary), (typeof WebAssembly > "u" ? "undefined" : c(WebAssembly)) != "object" && ro("no native wasm support detected"), !1);
      function Bo(k, ne) {
        k || ro(ne);
      }
      function Rs() {
        var k = no.buffer;
        Pt.HEAP8 = gs = new Int8Array(k), Pt.HEAP16 = xs = new Int16Array(k), Pt.HEAPU8 = fo = new Uint8Array(k), Pt.HEAPU16 = new Uint16Array(k), Pt.HEAP32 = Ir = new Int32Array(k), Pt.HEAPU32 = ws = new Uint32Array(k), Pt.HEAPF32 = fr = new Float32Array(k), Pt.HEAPF64 = Mr = new Float64Array(k);
      }
      var Uo = [], xi = [], Vo = [];
      function oa() {
        if (Pt.preRun)
          for (typeof Pt.preRun == "function" && (Pt.preRun = [Pt.preRun]); Pt.preRun.length; )
            k = Pt.preRun.shift(), Uo.unshift(k);
        var k;
        ia(Uo);
      }
      function ti() {
        if (Pt.postRun)
          for (typeof Pt.postRun == "function" && (Pt.postRun = [Pt.postRun]); Pt.postRun.length; )
            k = Pt.postRun.shift(), Vo.unshift(k);
        var k;
        ia(Vo);
      }
      var Po = 0, ai = null;
      function Wo(k) {
        var ne;
        Po++, (ne = Pt.monitorRunDependencies) != null && ne.call(Pt, Po);
      }
      function As(k) {
        var ne;
        Po--, (ne = Pt.monitorRunDependencies) != null && ne.call(Pt, Po), Po == 0 && ai && (ne = ai, ai = null, ne());
      }
      function ro(k) {
        (ne = Pt.onAbort) != null && ne.call(Pt, k), ii(k = "Aborted(" + k + ")"), Ro = !0, k += ". Build with -sASSERTIONS for more info.";
        var ne = new WebAssembly.RuntimeError(k);
        throw _t(ne), ne;
      }
      var Mo, vr, ts, kr = function(k) {
        return k.startsWith("data:application/octet-stream;base64,");
      }, Us = function(k) {
        return k.startsWith("file://");
      };
      function ri(k) {
        if (k == Mo && Ps)
          return new Uint8Array(Ps);
        if (gr)
          return gr(k);
        throw "both async and sync fetching of the wasm failed";
      }
      function Wi(k, ne, T) {
        return function(y) {
          if (!Ps && (jo || po)) {
            if (typeof fetch == "function" && !Us(y))
              return fetch(y, { credentials: "same-origin" }).then(function(N) {
                if (N.ok)
                  return N.arrayBuffer();
                throw "failed to load wasm binary file at '" + y + "'";
              }).catch(function() {
                return ri(y);
              });
            if (Rr)
              return new Promise(function(N, b) {
                Rr(y, function(X) {
                  return N(new Uint8Array(X));
                }, b);
              });
          }
          return Promise.resolve().then(function() {
            return ri(y);
          });
        }(k).then(function(y) {
          return WebAssembly.instantiate(y, ne);
        }).then(function(y) {
          return y;
        }).then(T, function(y) {
          ii("failed to asynchronously prepare wasm: ".concat(y)), ro(y);
        });
      }
      function To(k) {
        this.name = "ExitStatus", this.message = "Program terminated with exit(".concat(k, ")"), this.status = k;
      }
      function ia(k) {
        for (; 0 < k.length; )
          k.shift()(Pt);
      }
      kr(Mo = "gdal3WebAssembly.wasm") || (zt = Mo, Mo = Pt.locateFile ? Pt.locateFile(zt, Eo) : Eo + zt);
      var bo = Pt.noExitRuntime || !0;
      function Ys(k, ne, T) {
        for (var y = ne + T, N = ne; k[N] && !(y <= N); )
          ++N;
        if (16 < N - ne && k.buffer && Un)
          return Un.decode(k.subarray(ne, N));
        for (var b = ""; ne < N; ) {
          var X, J, Ie = k[ne++];
          128 & Ie ? (J = 63 & k[ne++], (224 & Ie) == 192 ? b += String.fromCharCode((31 & Ie) << 6 | J) : (X = 63 & k[ne++], (Ie = (240 & Ie) == 224 ? (15 & Ie) << 12 | J << 6 | X : (7 & Ie) << 18 | J << 12 | X << 6 | 63 & k[ne++]) < 65536 ? b += String.fromCharCode(Ie) : (J = Ie - 65536, b += String.fromCharCode(55296 | J >> 10, 56320 | 1023 & J)))) : b += String.fromCharCode(Ie);
        }
        return b;
      }
      function Di(k, ne) {
        return k ? Ys(fo, k, ne) : "";
      }
      function Yn(k) {
        var ne = so[k];
        return ne || (k >= so.length && (so.length = k + 1), so[k] = ne = Lo.get(k)), ne;
      }
      var Lo, Un = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, so = [], rs = [], hi = 0, Zo = 0;
      function li(k) {
        this.excPtr = k, this.ptr = k - 24, this.set_type = function(ne) {
          ws[this.ptr + 4 >> 2] = ne;
        }, this.get_type = function() {
          return ws[this.ptr + 4 >> 2];
        }, this.set_destructor = function(ne) {
          ws[this.ptr + 8 >> 2] = ne;
        }, this.get_destructor = function() {
          return ws[this.ptr + 8 >> 2];
        }, this.set_caught = function(ne) {
          gs[this.ptr + 12 >> 0] = ne = ne ? 1 : 0;
        }, this.get_caught = function() {
          return gs[this.ptr + 12 >> 0] != 0;
        }, this.set_rethrown = function(ne) {
          gs[this.ptr + 13 >> 0] = ne = ne ? 1 : 0;
        }, this.get_rethrown = function() {
          return gs[this.ptr + 13 >> 0] != 0;
        }, this.init = function(ne, T) {
          this.set_adjusted_ptr(0), this.set_type(ne), this.set_destructor(T);
        }, this.set_adjusted_ptr = function(ne) {
          ws[this.ptr + 16 >> 2] = ne;
        }, this.get_adjusted_ptr = function() {
          return ws[this.ptr + 16 >> 2];
        }, this.get_exception_ptr = function() {
          var ne;
          return Pr(this.get_type()) ? ws[this.excPtr >> 2] : (ne = this.get_adjusted_ptr()) !== 0 ? ne : this.excPtr;
        };
      }
      function ei(k) {
        var ne = Zo;
        if (!ne)
          return Ln(0), 0;
        var T = new li(ne), y = (T.set_adjusted_ptr(ne), T.get_type());
        if (y) {
          for (var N in k) {
            if (N = k[N], N === 0 || N === y)
              break;
            var b = T.ptr + 16;
            if (yr(N, y, b))
              return Ln(N), ne;
          }
          Ln(y);
        } else
          Ln(0);
        return ne;
      }
      var Or = { isAbs: function(k) {
        return k.charAt(0) === "/";
      }, splitPath: function(k) {
        return /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(k).slice(1);
      }, normalizeArray: function(k, ne) {
        for (var T = 0, y = k.length - 1; 0 <= y; y--) {
          var N = k[y];
          N === "." ? k.splice(y, 1) : N === ".." ? (k.splice(y, 1), T++) : T && (k.splice(y, 1), T--);
        }
        if (ne)
          for (; T; T--)
            k.unshift("..");
        return k;
      }, normalize: function(k) {
        var ne = Or.isAbs(k), T = k.substr(-1) === "/";
        return (k = (k = Or.normalizeArray(k.split("/").filter(function(y) {
          return !!y;
        }), !ne).join("/")) || ne ? k : ".") && T && (k += "/"), (ne ? "/" : "") + k;
      }, dirname: function(T) {
        var T = Or.splitPath(T), ne = T[0], T = T[1];
        return ne || T ? ne + (T = T && T.substr(0, T.length - 1)) : ".";
      }, basename: function(k) {
        var ne;
        return k === "/" ? "/" : (ne = (k = (k = Or.normalize(k)).replace(/\/$/, "")).lastIndexOf("/")) === -1 ? k : k.substr(ne + 1);
      }, join: function() {
        var k = Array.prototype.slice.call(arguments);
        return Or.normalize(k.join("/"));
      }, join2: function(k, ne) {
        return Or.normalize(k + "/" + ne);
      } }, ui = function() {
        if ((typeof crypto > "u" ? "undefined" : c(crypto)) == "object" && typeof crypto.getRandomValues == "function")
          return function(T) {
            return crypto.getRandomValues(T);
          };
        if (So)
          try {
            var k, ne = requireCryptoBrowserify();
            return ne.randomFillSync ? function(T) {
              return ne.randomFillSync(T);
            } : (k = ne.randomBytes, function(T) {
              return T.set(k(T.byteLength)), T;
            });
          } catch {
          }
        ro("initRandomDevice");
      }, _s = function(k) {
        return (_s = ui())(k);
      }, xo = { resolve: function() {
        for (var k = "", ne = !1, T = arguments.length - 1; -1 <= T && !ne; T--) {
          var y = 0 <= T ? arguments[T] : Gt.cwd();
          if (typeof y != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          if (!y)
            return "";
          k = y + "/" + k, ne = Or.isAbs(y);
        }
        return (ne ? "/" : "") + (k = Or.normalizeArray(k.split("/").filter(function(N) {
          return !!N;
        }), !ne).join("/")) || ".";
      }, relative: function(k, ne) {
        function T(Pe) {
          for (var We = 0; We < Pe.length && Pe[We] === ""; We++)
            ;
          for (var it = Pe.length - 1; 0 <= it && Pe[it] === ""; it--)
            ;
          return it < We ? [] : Pe.slice(We, it - We + 1);
        }
        k = xo.resolve(k).substr(1), ne = xo.resolve(ne).substr(1);
        for (var y = T(k.split("/")), N = T(ne.split("/")), b = Math.min(y.length, N.length), X = b, J = 0; J < b; J++)
          if (y[J] !== N[J]) {
            X = J;
            break;
          }
        for (var Ie = [], J = X; J < y.length; J++)
          Ie.push("..");
        return (Ie = Ie.concat(N.slice(X))).join("/");
      } }, aa = [], oo = function(k) {
        for (var ne = 0, T = 0; T < k.length; ++T) {
          var y = k.charCodeAt(T);
          y <= 127 ? ne++ : y <= 2047 ? ne += 2 : 55296 <= y && y <= 57343 ? (ne += 4, ++T) : ne += 3;
        }
        return ne;
      }, vs = function(k, ne, T, y) {
        if (!(0 < y))
          return 0;
        for (var N = T, b = T + y - 1, X = 0; X < k.length; ++X) {
          var J = k.charCodeAt(X);
          if ((J = 55296 <= J && J <= 57343 ? 65536 + ((1023 & J) << 10) | 1023 & k.charCodeAt(++X) : J) <= 127) {
            if (b <= T)
              break;
            ne[T++] = J;
          } else {
            if (J <= 2047) {
              if (b <= T + 1)
                break;
              ne[T++] = 192 | J >> 6;
            } else {
              if (J <= 65535) {
                if (b <= T + 2)
                  break;
                ne[T++] = 224 | J >> 12;
              } else {
                if (b <= T + 3)
                  break;
                ne[T++] = 240 | J >> 18, ne[T++] = 128 | J >> 12 & 63;
              }
              ne[T++] = 128 | J >> 6 & 63;
            }
            ne[T++] = 128 | 63 & J;
          }
        }
        return ne[T] = 0, T - N;
      };
      function yi(k, ne, T) {
        return T = 0 < T ? T : oo(k) + 1, T = new Array(T), k = vs(k, T, 0, T.length), ne && (T.length = k), T;
      }
      function $r(k) {
        T = k, ne = 65536, k = Math.ceil(T / ne) * ne;
        var ne, T = pn(65536, k);
        return T ? (ne = T, T = k, fo.fill(0, ne, ne + T), ne) : 0;
      }
      function ki(k, ne) {
        var T = 0;
        return k && (T |= 365), ne && (T |= 146), T;
      }
      var ds = { ttys: [], init: function() {
      }, shutdown: function() {
      }, register: function(k, ne) {
        ds.ttys[k] = { input: [], output: [], ops: ne }, Gt.registerDevice(k, ds.stream_ops);
      }, stream_ops: { open: function(k) {
        var ne = ds.ttys[k.node.rdev];
        if (!ne)
          throw new Gt.ErrnoError(43);
        k.tty = ne, k.seekable = !1;
      }, close: function(k) {
        k.tty.ops.fsync(k.tty);
      }, fsync: function(k) {
        k.tty.ops.fsync(k.tty);
      }, read: function(k, ne, T, y, N) {
        if (!k.tty || !k.tty.ops.get_char)
          throw new Gt.ErrnoError(60);
        for (var b, X = 0, J = 0; J < y; J++) {
          try {
            b = k.tty.ops.get_char(k.tty);
          } catch {
            throw new Gt.ErrnoError(29);
          }
          if (b === void 0 && X === 0)
            throw new Gt.ErrnoError(6);
          if (b == null)
            break;
          X++, ne[T + J] = b;
        }
        return X && (k.node.timestamp = Date.now()), X;
      }, write: function(k, ne, T, y, N) {
        if (!k.tty || !k.tty.ops.put_char)
          throw new Gt.ErrnoError(60);
        try {
          for (var b = 0; b < y; b++)
            k.tty.ops.put_char(k.tty, ne[T + b]);
        } catch {
          throw new Gt.ErrnoError(29);
        }
        return y && (k.node.timestamp = Date.now()), b;
      } }, default_tty_ops: { get_char: function(k) {
        if (!aa.length) {
          var ne = null;
          if (So) {
            var T = buffer$1.Buffer.alloc(256), y = 0, N = api$1.stdin.fd;
            try {
              y = Lt.readSync(N, T);
            } catch (b) {
              if (!b.toString().includes("EOF"))
                throw b;
              y = 0;
            }
            ne = 0 < y ? T.slice(0, y).toString("utf-8") : null;
          } else
            typeof window < "u" && typeof window.prompt == "function" ? (ne = window.prompt("Input: ")) !== null && (ne += `
`) : typeof readline == "function" && (ne = readline()) !== null && (ne += `
`);
          if (!ne)
            return null;
          aa = yi(ne, !0);
        }
        return aa.shift();
      }, put_char: function(k, ne) {
        ne === null || ne === 10 ? (Nr(Ys(k.output, 0)), k.output = []) : ne != 0 && k.output.push(ne);
      }, fsync: function(k) {
        k.output && 0 < k.output.length && (Nr(Ys(k.output, 0)), k.output = []);
      }, ioctl_tcgets: function(k) {
        return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
      }, ioctl_tcsets: function(k, ne, T) {
        return 0;
      }, ioctl_tiocgwinsz: function(k) {
        return [24, 80];
      } }, default_tty1_ops: { put_char: function(k, ne) {
        ne === null || ne === 10 ? (ii(Ys(k.output, 0)), k.output = []) : ne != 0 && k.output.push(ne);
      }, fsync: function(k) {
        k.output && 0 < k.output.length && (ii(Ys(k.output, 0)), k.output = []);
      } } }, Ls = { ops_table: null, mount: function(k) {
        return Ls.createNode(null, "/", 16895, 0);
      }, createNode: function(k, ne, T, y) {
        if (Gt.isBlkdev(T) || Gt.isFIFO(T))
          throw new Gt.ErrnoError(63);
        return Ls.ops_table || (Ls.ops_table = { dir: { node: { getattr: Ls.node_ops.getattr, setattr: Ls.node_ops.setattr, lookup: Ls.node_ops.lookup, mknod: Ls.node_ops.mknod, rename: Ls.node_ops.rename, unlink: Ls.node_ops.unlink, rmdir: Ls.node_ops.rmdir, readdir: Ls.node_ops.readdir, symlink: Ls.node_ops.symlink }, stream: { llseek: Ls.stream_ops.llseek } }, file: { node: { getattr: Ls.node_ops.getattr, setattr: Ls.node_ops.setattr }, stream: { llseek: Ls.stream_ops.llseek, read: Ls.stream_ops.read, write: Ls.stream_ops.write, allocate: Ls.stream_ops.allocate, mmap: Ls.stream_ops.mmap, msync: Ls.stream_ops.msync } }, link: { node: { getattr: Ls.node_ops.getattr, setattr: Ls.node_ops.setattr, readlink: Ls.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: Ls.node_ops.getattr, setattr: Ls.node_ops.setattr }, stream: Gt.chrdev_stream_ops } }), T = Gt.createNode(k, ne, T, y), Gt.isDir(T.mode) ? (T.node_ops = Ls.ops_table.dir.node, T.stream_ops = Ls.ops_table.dir.stream, T.contents = {}) : Gt.isFile(T.mode) ? (T.node_ops = Ls.ops_table.file.node, T.stream_ops = Ls.ops_table.file.stream, T.usedBytes = 0, T.contents = null) : Gt.isLink(T.mode) ? (T.node_ops = Ls.ops_table.link.node, T.stream_ops = Ls.ops_table.link.stream) : Gt.isChrdev(T.mode) && (T.node_ops = Ls.ops_table.chrdev.node, T.stream_ops = Ls.ops_table.chrdev.stream), T.timestamp = Date.now(), k && (k.contents[ne] = T, k.timestamp = T.timestamp), T;
      }, getFileDataAsTypedArray: function(k) {
        return k.contents ? k.contents.subarray ? k.contents.subarray(0, k.usedBytes) : new Uint8Array(k.contents) : new Uint8Array(0);
      }, expandFileStorage: function(k, ne) {
        var T = k.contents ? k.contents.length : 0;
        ne <= T || (ne = Math.max(ne, T * (T < 1048576 ? 2 : 1.125) >>> 0), T != 0 && (ne = Math.max(ne, 256)), T = k.contents, k.contents = new Uint8Array(ne), 0 < k.usedBytes && k.contents.set(T.subarray(0, k.usedBytes), 0));
      }, resizeFileStorage: function(k, ne) {
        var T;
        k.usedBytes != ne && (ne == 0 ? (k.contents = null, k.usedBytes = 0) : (T = k.contents, k.contents = new Uint8Array(ne), T && k.contents.set(T.subarray(0, Math.min(ne, k.usedBytes))), k.usedBytes = ne));
      }, node_ops: { getattr: function(k) {
        var ne = {};
        return ne.dev = Gt.isChrdev(k.mode) ? k.id : 1, ne.ino = k.id, ne.mode = k.mode, ne.nlink = 1, ne.uid = 0, ne.gid = 0, ne.rdev = k.rdev, Gt.isDir(k.mode) ? ne.size = 4096 : Gt.isFile(k.mode) ? ne.size = k.usedBytes : Gt.isLink(k.mode) ? ne.size = k.link.length : ne.size = 0, ne.atime = new Date(k.timestamp), ne.mtime = new Date(k.timestamp), ne.ctime = new Date(k.timestamp), ne.blksize = 4096, ne.blocks = Math.ceil(ne.size / ne.blksize), ne;
      }, setattr: function(k, ne) {
        ne.mode !== void 0 && (k.mode = ne.mode), ne.timestamp !== void 0 && (k.timestamp = ne.timestamp), ne.size !== void 0 && Ls.resizeFileStorage(k, ne.size);
      }, lookup: function(k, ne) {
        throw Gt.genericErrors[44];
      }, mknod: function(k, ne, T, y) {
        return Ls.createNode(k, ne, T, y);
      }, rename: function(k, ne, T) {
        if (Gt.isDir(k.mode)) {
          var y;
          try {
            y = Gt.lookupNode(ne, T);
          } catch {
          }
          if (y)
            for (var N in y.contents)
              throw new Gt.ErrnoError(55);
        }
        delete k.parent.contents[k.name], k.parent.timestamp = Date.now(), k.name = T, ne.contents[T] = k, ne.timestamp = k.parent.timestamp, k.parent = ne;
      }, unlink: function(k, ne) {
        delete k.contents[ne], k.timestamp = Date.now();
      }, rmdir: function(k, ne) {
        for (var T in Gt.lookupNode(k, ne).contents)
          throw new Gt.ErrnoError(55);
        delete k.contents[ne], k.timestamp = Date.now();
      }, readdir: function(k) {
        for (var ne = [".", ".."], T = 0, y = Object.keys(k.contents); T < y.length; T++) {
          var N = y[T];
          ne.push(N);
        }
        return ne;
      }, symlink: function(k, ne, T) {
        return k = Ls.createNode(k, ne, 41471, 0), k.link = T, k;
      }, readlink: function(k) {
        if (Gt.isLink(k.mode))
          return k.link;
        throw new Gt.ErrnoError(28);
      } }, stream_ops: { read: function(k, ne, T, y, N) {
        var b = k.node.contents;
        if (N >= k.node.usedBytes)
          return 0;
        var X = Math.min(k.node.usedBytes - N, y);
        if (8 < X && b.subarray)
          ne.set(b.subarray(N, N + X), T);
        else
          for (var J = 0; J < X; J++)
            ne[T + J] = b[N + J];
        return X;
      }, write: function(k, ne, T, y, N, b) {
        if (ne.buffer === gs.buffer && (b = !1), !y)
          return 0;
        var X = k.node;
        if (X.timestamp = Date.now(), ne.subarray && (!X.contents || X.contents.subarray)) {
          if (b)
            return X.contents = ne.subarray(T, T + y), X.usedBytes = y;
          if (X.usedBytes === 0 && N === 0)
            return X.contents = ne.slice(T, T + y), X.usedBytes = y;
          if (N + y <= X.usedBytes)
            return X.contents.set(ne.subarray(T, T + y), N), y;
        }
        if (Ls.expandFileStorage(X, N + y), X.contents.subarray && ne.subarray)
          X.contents.set(ne.subarray(T, T + y), N);
        else
          for (var J = 0; J < y; J++)
            X.contents[N + J] = ne[T + J];
        return X.usedBytes = Math.max(X.usedBytes, N + y), y;
      }, llseek: function(k, ne, T) {
        if (T === 1 ? ne += k.position : T === 2 && Gt.isFile(k.node.mode) && (ne += k.node.usedBytes), ne < 0)
          throw new Gt.ErrnoError(28);
        return ne;
      }, allocate: function(k, ne, T) {
        Ls.expandFileStorage(k.node, ne + T), k.node.usedBytes = Math.max(k.node.usedBytes, ne + T);
      }, mmap: function(J, ne, T, y, N) {
        if (!Gt.isFile(J.node.mode))
          throw new Gt.ErrnoError(43);
        var b, X, J = J.node.contents;
        if (2 & N || J.buffer !== gs.buffer) {
          if ((0 < T || T + ne < J.length) && (J = J.subarray ? J.subarray(T, T + ne) : Array.prototype.slice.call(J, T, T + ne)), X = !0, !(b = $r(ne)))
            throw new Gt.ErrnoError(48);
          gs.set(J, b);
        } else
          X = !1, b = J.byteOffset;
        return { ptr: b, allocated: X };
      }, msync: function(k, ne, T, y, N) {
        return Ls.stream_ops.write(k, ne, 0, y, T, !1), 0;
      } } }, Co = Pt.preloadPlugins || [], ps = { EPERM: 63, ENOENT: 44, ESRCH: 71, EINTR: 27, EIO: 29, ENXIO: 60, E2BIG: 1, ENOEXEC: 45, EBADF: 8, ECHILD: 12, EAGAIN: 6, EWOULDBLOCK: 6, ENOMEM: 48, EACCES: 2, EFAULT: 21, ENOTBLK: 105, EBUSY: 10, EEXIST: 20, EXDEV: 75, ENODEV: 43, ENOTDIR: 54, EISDIR: 31, EINVAL: 28, ENFILE: 41, EMFILE: 33, ENOTTY: 59, ETXTBSY: 74, EFBIG: 22, ENOSPC: 51, ESPIPE: 70, EROFS: 69, EMLINK: 34, EPIPE: 64, EDOM: 18, ERANGE: 68, ENOMSG: 49, EIDRM: 24, ECHRNG: 106, EL2NSYNC: 156, EL3HLT: 107, EL3RST: 108, ELNRNG: 109, EUNATCH: 110, ENOCSI: 111, EL2HLT: 112, EDEADLK: 16, ENOLCK: 46, EBADE: 113, EBADR: 114, EXFULL: 115, ENOANO: 104, EBADRQC: 103, EBADSLT: 102, EDEADLOCK: 16, EBFONT: 101, ENOSTR: 100, ENODATA: 116, ETIME: 117, ENOSR: 118, ENONET: 119, ENOPKG: 120, EREMOTE: 121, ENOLINK: 47, EADV: 122, ESRMNT: 123, ECOMM: 124, EPROTO: 65, EMULTIHOP: 36, EDOTDOT: 125, EBADMSG: 9, ENOTUNIQ: 126, EBADFD: 127, EREMCHG: 128, ELIBACC: 129, ELIBBAD: 130, ELIBSCN: 131, ELIBMAX: 132, ELIBEXEC: 133, ENOSYS: 52, ENOTEMPTY: 55, ENAMETOOLONG: 37, ELOOP: 32, EOPNOTSUPP: 138, EPFNOSUPPORT: 139, ECONNRESET: 15, ENOBUFS: 42, EAFNOSUPPORT: 5, EPROTOTYPE: 67, ENOTSOCK: 57, ENOPROTOOPT: 50, ESHUTDOWN: 140, ECONNREFUSED: 14, EADDRINUSE: 3, ECONNABORTED: 13, ENETUNREACH: 40, ENETDOWN: 38, ETIMEDOUT: 73, EHOSTDOWN: 142, EHOSTUNREACH: 23, EINPROGRESS: 26, EALREADY: 7, EDESTADDRREQ: 17, EMSGSIZE: 35, EPROTONOSUPPORT: 66, ESOCKTNOSUPPORT: 137, EADDRNOTAVAIL: 4, ENETRESET: 39, EISCONN: 30, ENOTCONN: 53, ETOOMANYREFS: 141, EUSERS: 136, EDQUOT: 19, ESTALE: 72, ENOTSUP: 138, ENOMEDIUM: 148, EILSEQ: 25, EOVERFLOW: 61, ECANCELED: 11, ENOTRECOVERABLE: 56, EOWNERDEAD: 62, ESTRPIPE: 135 }, Tr = { isWindows: !1, staticInit: function() {
        Tr.isWindows = !!api$1.platform.match(/^win/);
        var k = api$1.binding("constants");
        k.fs && (k = k.fs), Tr.flagsForNodeMap = { 1024: k.O_APPEND, 64: k.O_CREAT, 128: k.O_EXCL, 256: k.O_NOCTTY, 0: k.O_RDONLY, 2: k.O_RDWR, 4096: k.O_SYNC, 512: k.O_TRUNC, 1: k.O_WRONLY, 131072: k.O_NOFOLLOW };
      }, convertNodeCode: function(k) {
        return k = k.code, ps[k];
      }, mount: function(k) {
        return Tr.createNode(null, "/", Tr.getMode(k.opts.root), 0);
      }, createNode: function(k, ne, T, y) {
        if (Gt.isDir(T) || Gt.isFile(T) || Gt.isLink(T))
          return (k = Gt.createNode(k, ne, T)).node_ops = Tr.node_ops, k.stream_ops = Tr.stream_ops, k;
        throw new Gt.ErrnoError(28);
      }, getMode: function(k) {
        var ne;
        try {
          ne = Lt.lstatSync(k), Tr.isWindows && (ne.mode = ne.mode | (292 & ne.mode) >> 2);
        } catch (T) {
          throw T.code ? new Gt.ErrnoError(Tr.convertNodeCode(T)) : T;
        }
        return ne.mode;
      }, realPath: function(k) {
        for (var ne = []; k.parent !== k; )
          ne.push(k.name), k = k.parent;
        return ne.push(k.mount.opts.root), ne.reverse(), Or.join.apply(null, ne);
      }, flagsForNode: function(k) {
        k = -2097153 & k & -2049 & -32769 & -524289 & -65537;
        var ne, T = 0;
        for (ne in Tr.flagsForNodeMap)
          k & ne && (T |= Tr.flagsForNodeMap[ne], k ^= ne);
        if (k)
          throw new Gt.ErrnoError(28);
        return T;
      }, node_ops: { getattr: function(T) {
        var ne, T = Tr.realPath(T);
        try {
          ne = Lt.lstatSync(T);
        } catch (y) {
          throw y.code ? new Gt.ErrnoError(Tr.convertNodeCode(y)) : y;
        }
        return Tr.isWindows && !ne.blksize && (ne.blksize = 4096), Tr.isWindows && !ne.blocks && (ne.blocks = (ne.size + ne.blksize - 1) / ne.blksize | 0), { dev: ne.dev, ino: ne.ino, mode: ne.mode, nlink: ne.nlink, uid: ne.uid, gid: ne.gid, rdev: ne.rdev, size: ne.size, atime: ne.atime, mtime: ne.mtime, ctime: ne.ctime, blksize: ne.blksize, blocks: ne.blocks };
      }, setattr: function(k, ne) {
        var T, y = Tr.realPath(k);
        try {
          ne.mode !== void 0 && (Lt.chmodSync(y, ne.mode), k.mode = ne.mode), ne.timestamp !== void 0 && (T = new Date(ne.timestamp), Lt.utimesSync(y, T, T)), ne.size !== void 0 && Lt.truncateSync(y, ne.size);
        } catch (N) {
          throw N.code ? new Gt.ErrnoError(Tr.convertNodeCode(N)) : N;
        }
      }, lookup: function(k, ne) {
        var T = Or.join2(Tr.realPath(k), ne), T = Tr.getMode(T);
        return Tr.createNode(k, ne, T);
      }, mknod: function(k, ne, T, y) {
        k = Tr.createNode(k, ne, T, y), ne = Tr.realPath(k);
        try {
          Gt.isDir(k.mode) ? Lt.mkdirSync(ne, k.mode) : Lt.writeFileSync(ne, "", { mode: k.mode });
        } catch (N) {
          throw N.code ? new Gt.ErrnoError(Tr.convertNodeCode(N)) : N;
        }
        return k;
      }, rename: function(k, N, T) {
        var y = Tr.realPath(k), N = Or.join2(Tr.realPath(N), T);
        try {
          Lt.renameSync(y, N);
        } catch (b) {
          throw b.code ? new Gt.ErrnoError(Tr.convertNodeCode(b)) : b;
        }
        k.name = T;
      }, unlink: function(k, ne) {
        k = Or.join2(Tr.realPath(k), ne);
        try {
          Lt.unlinkSync(k);
        } catch (T) {
          throw T.code ? new Gt.ErrnoError(Tr.convertNodeCode(T)) : T;
        }
      }, rmdir: function(k, ne) {
        k = Or.join2(Tr.realPath(k), ne);
        try {
          Lt.rmdirSync(k);
        } catch (T) {
          throw T.code ? new Gt.ErrnoError(Tr.convertNodeCode(T)) : T;
        }
      }, readdir: function(k) {
        k = Tr.realPath(k);
        try {
          return Lt.readdirSync(k);
        } catch (ne) {
          throw ne.code ? new Gt.ErrnoError(Tr.convertNodeCode(ne)) : ne;
        }
      }, symlink: function(k, ne, T) {
        k = Or.join2(Tr.realPath(k), ne);
        try {
          Lt.symlinkSync(T, k);
        } catch (y) {
          throw y.code ? new Gt.ErrnoError(Tr.convertNodeCode(y)) : y;
        }
      }, readlink: function(k) {
        var ne = Tr.realPath(k);
        try {
          return ne = Lt.readlinkSync(ne), dr.relative(dr.resolve(k.mount.opts.root), ne);
        } catch (T) {
          throw T.code ? T.code === "UNKNOWN" ? new Gt.ErrnoError(28) : new Gt.ErrnoError(Tr.convertNodeCode(T)) : T;
        }
      } }, stream_ops: { open: function(k) {
        var ne = Tr.realPath(k.node);
        try {
          Gt.isFile(k.node.mode) && (k.nfd = Lt.openSync(ne, Tr.flagsForNode(k.flags)));
        } catch (T) {
          throw T.code ? new Gt.ErrnoError(Tr.convertNodeCode(T)) : T;
        }
      }, close: function(k) {
        try {
          Gt.isFile(k.node.mode) && k.nfd && Lt.closeSync(k.nfd);
        } catch (ne) {
          throw ne.code ? new Gt.ErrnoError(Tr.convertNodeCode(ne)) : ne;
        }
      }, read: function(k, ne, T, y, N) {
        if (y === 0)
          return 0;
        try {
          return Lt.readSync(k.nfd, new Int8Array(ne.buffer, T, y), { position: N });
        } catch (b) {
          throw new Gt.ErrnoError(Tr.convertNodeCode(b));
        }
      }, write: function(k, ne, T, y, N) {
        try {
          return Lt.writeSync(k.nfd, new Int8Array(ne.buffer, T, y), { position: N });
        } catch (b) {
          throw new Gt.ErrnoError(Tr.convertNodeCode(b));
        }
      }, llseek: function(k, ne, T) {
        if (T === 1)
          ne += k.position;
        else if (T === 2 && Gt.isFile(k.node.mode))
          try {
            ne += Lt.fstatSync(k.nfd).size;
          } catch (y) {
            throw new Gt.ErrnoError(Tr.convertNodeCode(y));
          }
        if (ne < 0)
          throw new Gt.ErrnoError(28);
        return ne;
      }, mmap: function(k, ne, T, y, N) {
        var b;
        if (Gt.isFile(k.node.mode))
          return b = $r(ne), Tr.stream_ops.read(k, gs, b, ne, T), { ptr: b, allocated: !0 };
        throw new Gt.ErrnoError(43);
      }, msync: function(k, ne, T, y, N) {
        return Tr.stream_ops.write(k, ne, 0, y, T, !1), 0;
      } } }, ao = { DIR_MODE: 16895, FILE_MODE: 33279, reader: null, mount: function(k) {
        Bo(po), ao.reader || (ao.reader = new FileReaderSync());
        var ne = ao.createNode(null, "/", ao.DIR_MODE, 0), T = {};
        function y(b) {
          for (var X = b.split("/"), J = ne, Ie = 0; Ie < X.length - 1; Ie++) {
            var Pe, We = X.slice(0, Ie + 1).join("/");
            T[Pe = We] || (T[Pe] = ao.createNode(J, X[Ie], ao.DIR_MODE, 0)), J = T[We];
          }
          return J;
        }
        function N(b) {
          return b = b.split("/"), b[b.length - 1];
        }
        return Array.prototype.forEach.call(k.opts.files || [], function(b) {
          ao.createNode(y(b.name), N(b.name), ao.FILE_MODE, 0, b, b.lastModifiedDate);
        }), (k.opts.blobs || []).forEach(function(b) {
          ao.createNode(y(b.name), N(b.name), ao.FILE_MODE, 0, b.data);
        }), (k.opts.packages || []).forEach(function(b) {
          b.metadata.files.forEach(function(X) {
            var J = X.filename.substr(1);
            ao.createNode(y(J), N(J), ao.FILE_MODE, 0, b.blob.slice(X.start, X.end));
          });
        }), ne;
      }, createNode: function(k, ne, T, y, N, b) {
        var X = Gt.createNode(k, ne, T);
        return X.mode = T, X.node_ops = ao.node_ops, X.stream_ops = ao.stream_ops, X.timestamp = (b || /* @__PURE__ */ new Date()).getTime(), Bo(ao.FILE_MODE !== ao.DIR_MODE), T === ao.FILE_MODE ? (X.size = N.size, X.contents = N) : (X.size = 4096, X.contents = {}), k && (k.contents[ne] = X), X;
      }, node_ops: { getattr: function(k) {
        return { dev: 1, ino: k.id, mode: k.mode, nlink: 1, uid: 0, gid: 0, rdev: 0, size: k.size, atime: new Date(k.timestamp), mtime: new Date(k.timestamp), ctime: new Date(k.timestamp), blksize: 4096, blocks: Math.ceil(k.size / 4096) };
      }, setattr: function(k, ne) {
        ne.mode !== void 0 && (k.mode = ne.mode), ne.timestamp !== void 0 && (k.timestamp = ne.timestamp);
      }, lookup: function(k, ne) {
        throw new Gt.ErrnoError(44);
      }, mknod: function(k, ne, T, y) {
        throw new Gt.ErrnoError(63);
      }, rename: function(k, ne, T) {
        throw new Gt.ErrnoError(63);
      }, unlink: function(k, ne) {
        throw new Gt.ErrnoError(63);
      }, rmdir: function(k, ne) {
        throw new Gt.ErrnoError(63);
      }, readdir: function(k) {
        for (var ne = [".", ".."], T = 0, y = Object.keys(k.contents); T < y.length; T++) {
          var N = y[T];
          ne.push(N);
        }
        return ne;
      }, symlink: function(k, ne, T) {
        throw new Gt.ErrnoError(63);
      } }, stream_ops: { read: function(k, ne, T, y, N) {
        return N >= k.node.size ? 0 : (k = k.node.contents.slice(N, N + y), N = ao.reader.readAsArrayBuffer(k), ne.set(new Uint8Array(N), T), k.size);
      }, write: function(k, ne, T, y, N) {
        throw new Gt.ErrnoError(29);
      }, llseek: function(k, ne, T) {
        if (T === 1 ? ne += k.position : T === 2 && Gt.isFile(k.node.mode) && (ne += k.node.size), ne < 0)
          throw new Gt.ErrnoError(28);
        return ne;
      } } }, Gt = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: function(k) {
        var ne = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        if (!(k = xo.resolve(k)))
          return { path: "", node: null };
        if (8 < (ne = Object.assign({ follow_mount: !0, recurse_count: 0 }, ne)).recurse_count)
          throw new Gt.ErrnoError(32);
        for (var T = k.split("/").filter(function(Pe) {
          return !!Pe;
        }), y = Gt.root, N = "/", b = 0; b < T.length; b++) {
          var X = b === T.length - 1;
          if (X && ne.parent)
            break;
          if (y = Gt.lookupNode(y, T[b]), N = Or.join2(N, T[b]), !Gt.isMountpoint(y) || X && !ne.follow_mount || (y = y.mounted.root), !X || ne.follow)
            for (var J = 0; Gt.isLink(y.mode); ) {
              var Ie = Gt.readlink(N), N = xo.resolve(Or.dirname(N), Ie), y = Gt.lookupPath(N, { recurse_count: ne.recurse_count + 1 }).node;
              if (40 < J++)
                throw new Gt.ErrnoError(32);
            }
        }
        return { path: N, node: y };
      }, getPath: function(k) {
        for (var ne, T; ; ) {
          if (Gt.isRoot(k))
            return T = k.mount.mountpoint, ne ? T[T.length - 1] !== "/" ? "".concat(T, "/").concat(ne) : T + ne : T;
          ne = ne ? "".concat(k.name, "/").concat(ne) : k.name, k = k.parent;
        }
      }, hashName: function(k, ne) {
        for (var T = 0, y = 0; y < ne.length; y++)
          T = (T << 5) - T + ne.charCodeAt(y) | 0;
        return (k + T >>> 0) % Gt.nameTable.length;
      }, hashAddNode: function(k) {
        var ne = Gt.hashName(k.parent.id, k.name);
        k.name_next = Gt.nameTable[ne], Gt.nameTable[ne] = k;
      }, hashRemoveNode: function(k) {
        var ne = Gt.hashName(k.parent.id, k.name);
        if (Gt.nameTable[ne] === k)
          Gt.nameTable[ne] = k.name_next;
        else
          for (var T = Gt.nameTable[ne]; T; ) {
            if (T.name_next === k) {
              T.name_next = k.name_next;
              break;
            }
            T = T.name_next;
          }
      }, lookupNode: function(k, ne) {
        var T = Gt.mayLookup(k);
        if (T)
          throw new Gt.ErrnoError(T, k);
        for (var T = Gt.hashName(k.id, ne), y = Gt.nameTable[T]; y; y = y.name_next) {
          var N = y.name;
          if (y.parent.id === k.id && N === ne)
            return y;
        }
        return Gt.lookup(k, ne);
      }, createNode: function(k, ne, T, y) {
        return k = new Gt.FSNode(k, ne, T, y), Gt.hashAddNode(k), k;
      }, destroyNode: function(k) {
        Gt.hashRemoveNode(k);
      }, isRoot: function(k) {
        return k === k.parent;
      }, isMountpoint: function(k) {
        return !!k.mounted;
      }, isFile: function(k) {
        return (61440 & k) == 32768;
      }, isDir: function(k) {
        return (61440 & k) == 16384;
      }, isLink: function(k) {
        return (61440 & k) == 40960;
      }, isChrdev: function(k) {
        return (61440 & k) == 8192;
      }, isBlkdev: function(k) {
        return (61440 & k) == 24576;
      }, isFIFO: function(k) {
        return (61440 & k) == 4096;
      }, isSocket: function(k) {
        return (49152 & k) == 49152;
      }, flagsToPermissionString: function(k) {
        var ne = ["r", "w", "rw"][3 & k];
        return 512 & k && (ne += "w"), ne;
      }, nodePermissions: function(k, ne) {
        return Gt.ignorePermissions || (!ne.includes("r") || 292 & k.mode) && (!ne.includes("w") || 146 & k.mode) && (!ne.includes("x") || 73 & k.mode) ? 0 : 2;
      }, mayLookup: function(k) {
        var ne = Gt.nodePermissions(k, "x");
        return ne || (k.node_ops.lookup ? 0 : 2);
      }, mayCreate: function(k, ne) {
        try {
          return Gt.lookupNode(k, ne), 20;
        } catch {
        }
        return Gt.nodePermissions(k, "wx");
      }, mayDelete: function(k, ne, T) {
        var y;
        try {
          y = Gt.lookupNode(k, ne);
        } catch (N) {
          return N.errno;
        }
        if (ne = Gt.nodePermissions(k, "wx"), ne)
          return ne;
        if (T) {
          if (!Gt.isDir(y.mode))
            return 54;
          if (Gt.isRoot(y) || Gt.getPath(y) === Gt.cwd())
            return 10;
        } else if (Gt.isDir(y.mode))
          return 31;
        return 0;
      }, mayOpen: function(k, ne) {
        return k ? Gt.isLink(k.mode) ? 32 : Gt.isDir(k.mode) && (Gt.flagsToPermissionString(ne) !== "r" || 512 & ne) ? 31 : Gt.nodePermissions(k, Gt.flagsToPermissionString(ne)) : 44;
      }, MAX_OPEN_FDS: 4096, nextfd: function() {
        for (var k = 0; k <= Gt.MAX_OPEN_FDS; k++)
          if (!Gt.streams[k])
            return k;
        throw new Gt.ErrnoError(33);
      }, getStreamChecked: function(k) {
        if (k = Gt.getStream(k), k)
          return k;
        throw new Gt.ErrnoError(8);
      }, getStream: function(k) {
        return Gt.streams[k];
      }, createStream: function(k) {
        var ne = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : -1;
        return Gt.FSStream || (Gt.FSStream = function() {
          this.shared = {};
        }, Gt.FSStream.prototype = {}, Object.defineProperties(Gt.FSStream.prototype, { object: { get: function() {
          return this.node;
        }, set: function(T) {
          this.node = T;
        } }, isRead: { get: function() {
          return (2097155 & this.flags) != 1;
        } }, isWrite: { get: function() {
          return (2097155 & this.flags) != 0;
        } }, isAppend: { get: function() {
          return 1024 & this.flags;
        } }, flags: { get: function() {
          return this.shared.flags;
        }, set: function(T) {
          this.shared.flags = T;
        } }, position: { get: function() {
          return this.shared.position;
        }, set: function(T) {
          this.shared.position = T;
        } } })), k = Object.assign(new Gt.FSStream(), k), ne == -1 && (ne = Gt.nextfd()), k.fd = ne, Gt.streams[ne] = k;
      }, closeStream: function(k) {
        Gt.streams[k] = null;
      }, chrdev_stream_ops: { open: function(k) {
        var ne, T = Gt.getDevice(k.node.rdev);
        k.stream_ops = T.stream_ops, (ne = (T = k.stream_ops).open) != null && ne.call(T, k);
      }, llseek: function() {
        throw new Gt.ErrnoError(70);
      } }, major: function(k) {
        return k >> 8;
      }, minor: function(k) {
        return 255 & k;
      }, makedev: function(k, ne) {
        return k << 8 | ne;
      }, registerDevice: function(k, ne) {
        Gt.devices[k] = { stream_ops: ne };
      }, getDevice: function(k) {
        return Gt.devices[k];
      }, getMounts: function(k) {
        for (var ne = [], T = [k]; T.length; ) {
          var y = T.pop();
          ne.push(y), T.push.apply(T, y.mounts);
        }
        return ne;
      }, syncfs: function(k, ne) {
        typeof k == "function" && (ne = k, k = !1), Gt.syncFSRequests++, 1 < Gt.syncFSRequests && ii("warning: ".concat(Gt.syncFSRequests, " FS.syncfs operations in flight at once, probably just doing extra work"));
        var T = Gt.getMounts(Gt.root.mount), y = 0;
        function N(X) {
          return Gt.syncFSRequests--, ne(X);
        }
        function b(X) {
          if (X)
            return b.errored ? void 0 : (b.errored = !0, N(X));
          ++y >= T.length && N(null);
        }
        T.forEach(function(X) {
          if (!X.type.syncfs)
            return b(null);
          X.type.syncfs(X, k, b);
        });
      }, mount: function(k, ne, T) {
        var y, N = T === "/", b = !T;
        if (N && Gt.root)
          throw new Gt.ErrnoError(10);
        if (!N && !b) {
          if (b = Gt.lookupPath(T, { follow_mount: !1 }), T = b.path, y = b.node, Gt.isMountpoint(y))
            throw new Gt.ErrnoError(10);
          if (!Gt.isDir(y.mode))
            throw new Gt.ErrnoError(54);
        }
        return b = { type: k, opts: ne, mountpoint: T, mounts: [] }, ne = k.mount(b), (ne.mount = b).root = ne, N ? Gt.root = ne : y && (y.mounted = b, y.mount) && y.mount.mounts.push(b), ne;
      }, unmount: function(ne) {
        if (ne = Gt.lookupPath(ne, { follow_mount: !1 }), !Gt.isMountpoint(ne.node))
          throw new Gt.ErrnoError(28);
        var ne = ne.node, y = ne.mounted, T = Gt.getMounts(y), y = (Object.keys(Gt.nameTable).forEach(function(N) {
          for (var b = Gt.nameTable[N]; b; ) {
            var X = b.name_next;
            T.includes(b.mount) && Gt.destroyNode(b), b = X;
          }
        }), ne.mounted = null, ne.mount.mounts.indexOf(y));
        ne.mount.mounts.splice(y, 1);
      }, lookup: function(k, ne) {
        return k.node_ops.lookup(k, ne);
      }, mknod: function(N, ne, T) {
        var y = Gt.lookupPath(N, { parent: !0 }).node, N = Or.basename(N);
        if (!N || N === "." || N === "..")
          throw new Gt.ErrnoError(28);
        var b = Gt.mayCreate(y, N);
        if (b)
          throw new Gt.ErrnoError(b);
        if (y.node_ops.mknod)
          return y.node_ops.mknod(y, N, ne, T);
        throw new Gt.ErrnoError(63);
      }, create: function(k, ne) {
        return Gt.mknod(k, ne = (ne = ne !== void 0 ? ne : 438) & 4095 | 32768, 0);
      }, mkdir: function(k, ne) {
        return Gt.mknod(k, ne = (ne = ne !== void 0 ? ne : 511) & 1023 | 16384, 0);
      }, mkdirTree: function(k, ne) {
        for (var T = k.split("/"), y = "", N = 0; N < T.length; ++N)
          if (T[N]) {
            y += "/" + T[N];
            try {
              Gt.mkdir(y, ne);
            } catch (b) {
              if (b.errno != 20)
                throw b;
            }
          }
      }, mkdev: function(k, ne, T) {
        return T === void 0 && (T = ne, ne = 438), Gt.mknod(k, ne |= 8192, T);
      }, symlink: function(k, y) {
        if (!xo.resolve(k))
          throw new Gt.ErrnoError(44);
        var T = Gt.lookupPath(y, { parent: !0 }).node;
        if (!T)
          throw new Gt.ErrnoError(44);
        var y = Or.basename(y), N = Gt.mayCreate(T, y);
        if (N)
          throw new Gt.ErrnoError(N);
        if (T.node_ops.symlink)
          return T.node_ops.symlink(T, y, k);
        throw new Gt.ErrnoError(63);
      }, rename: function(We, ne) {
        var T = Or.dirname(We), y = Or.dirname(ne), N = Or.basename(We), b = Or.basename(ne), X = Gt.lookupPath(We, { parent: !0 }), X = X.node, J = Gt.lookupPath(ne, { parent: !0 }).node;
        if (!X || !J)
          throw new Gt.ErrnoError(44);
        if (X.mount !== J.mount)
          throw new Gt.ErrnoError(75);
        var Ie, Pe = Gt.lookupNode(X, N), We = xo.relative(We, y);
        if (We.charAt(0) !== ".")
          throw new Gt.ErrnoError(28);
        if ((We = xo.relative(ne, T)).charAt(0) !== ".")
          throw new Gt.ErrnoError(55);
        try {
          Ie = Gt.lookupNode(J, b);
        } catch {
        }
        if (Pe !== Ie) {
          if (y = Gt.isDir(Pe.mode), ne = Gt.mayDelete(X, N, y), ne)
            throw new Gt.ErrnoError(ne);
          if (ne = Ie ? Gt.mayDelete(J, b, y) : Gt.mayCreate(J, b))
            throw new Gt.ErrnoError(ne);
          if (!X.node_ops.rename)
            throw new Gt.ErrnoError(63);
          if (Gt.isMountpoint(Pe) || Ie && Gt.isMountpoint(Ie))
            throw new Gt.ErrnoError(10);
          if (J !== X && (ne = Gt.nodePermissions(X, "w")))
            throw new Gt.ErrnoError(ne);
          Gt.hashRemoveNode(Pe);
          try {
            X.node_ops.rename(Pe, J, b);
          } catch (it) {
            throw it;
          } finally {
            Gt.hashAddNode(Pe);
          }
        }
      }, rmdir: function(T) {
        var ne = Gt.lookupPath(T, { parent: !0 }).node, T = Or.basename(T), y = Gt.lookupNode(ne, T), N = Gt.mayDelete(ne, T, !0);
        if (N)
          throw new Gt.ErrnoError(N);
        if (!ne.node_ops.rmdir)
          throw new Gt.ErrnoError(63);
        if (Gt.isMountpoint(y))
          throw new Gt.ErrnoError(10);
        ne.node_ops.rmdir(ne, T), Gt.destroyNode(y);
      }, readdir: function(k) {
        if (k = Gt.lookupPath(k, { follow: !0 }).node, k.node_ops.readdir)
          return k.node_ops.readdir(k);
        throw new Gt.ErrnoError(54);
      }, unlink: function(T) {
        var ne = Gt.lookupPath(T, { parent: !0 }).node;
        if (!ne)
          throw new Gt.ErrnoError(44);
        var T = Or.basename(T), y = Gt.lookupNode(ne, T), N = Gt.mayDelete(ne, T, !1);
        if (N)
          throw new Gt.ErrnoError(N);
        if (!ne.node_ops.unlink)
          throw new Gt.ErrnoError(63);
        if (Gt.isMountpoint(y))
          throw new Gt.ErrnoError(10);
        ne.node_ops.unlink(ne, T), Gt.destroyNode(y);
      }, readlink: function(k) {
        if (k = Gt.lookupPath(k).node, !k)
          throw new Gt.ErrnoError(44);
        if (k.node_ops.readlink)
          return xo.resolve(Gt.getPath(k.parent), k.node_ops.readlink(k));
        throw new Gt.ErrnoError(28);
      }, stat: function(k, ne) {
        if (k = Gt.lookupPath(k, { follow: !ne }).node, !k)
          throw new Gt.ErrnoError(44);
        if (k.node_ops.getattr)
          return k.node_ops.getattr(k);
        throw new Gt.ErrnoError(63);
      }, lstat: function(k) {
        return Gt.stat(k, !0);
      }, chmod: function(k, ne, T) {
        if (!(T = typeof k == "string" ? Gt.lookupPath(k, { follow: !T }).node : k).node_ops.setattr)
          throw new Gt.ErrnoError(63);
        T.node_ops.setattr(T, { mode: 4095 & ne | -4096 & T.mode, timestamp: Date.now() });
      }, lchmod: function(k, ne) {
        Gt.chmod(k, ne, !0);
      }, fchmod: function(k, ne) {
        k = Gt.getStreamChecked(k), Gt.chmod(k.node, ne);
      }, chown: function(k, ne, T, y) {
        if (!(y = typeof k == "string" ? Gt.lookupPath(k, { follow: !y }).node : k).node_ops.setattr)
          throw new Gt.ErrnoError(63);
        y.node_ops.setattr(y, { timestamp: Date.now() });
      }, lchown: function(k, ne, T) {
        Gt.chown(k, ne, T, !0);
      }, fchown: function(k, ne, T) {
        k = Gt.getStreamChecked(k), Gt.chown(k.node, ne, T);
      }, truncate: function(k, ne) {
        if (ne < 0)
          throw new Gt.ErrnoError(28);
        if (!(k = typeof k == "string" ? Gt.lookupPath(k, { follow: !0 }).node : k).node_ops.setattr)
          throw new Gt.ErrnoError(63);
        if (Gt.isDir(k.mode))
          throw new Gt.ErrnoError(31);
        if (!Gt.isFile(k.mode))
          throw new Gt.ErrnoError(28);
        var T = Gt.nodePermissions(k, "w");
        if (T)
          throw new Gt.ErrnoError(T);
        k.node_ops.setattr(k, { size: ne, timestamp: Date.now() });
      }, ftruncate: function(k, ne) {
        if (k = Gt.getStreamChecked(k), !(2097155 & k.flags))
          throw new Gt.ErrnoError(28);
        Gt.truncate(k.node, ne);
      }, utime: function(k, ne, T) {
        k = Gt.lookupPath(k, { follow: !0 }).node, k.node_ops.setattr(k, { timestamp: Math.max(ne, T) });
      }, open: function(k, ne, T) {
        if (k === "")
          throw new Gt.ErrnoError(44);
        if (T = T === void 0 ? 438 : T, T = 64 & (ne = typeof ne == "string" ? function(b) {
          var X = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }[b];
          if (X === void 0)
            throw new Error("Unknown file open mode: ".concat(b));
          return X;
        }(ne) : ne) ? 4095 & T | 32768 : 0, c(k) == "object")
          y = k;
        else {
          k = Or.normalize(k);
          try {
            var y = Gt.lookupPath(k, { follow: !(131072 & ne) }).node;
          } catch {
          }
        }
        var N = !1;
        if (64 & ne)
          if (y) {
            if (128 & ne)
              throw new Gt.ErrnoError(20);
          } else
            y = Gt.mknod(k, T, 0), N = !0;
        if (!y)
          throw new Gt.ErrnoError(44);
        if (Gt.isChrdev(y.mode) && (ne &= -513), 65536 & ne && !Gt.isDir(y.mode))
          throw new Gt.ErrnoError(54);
        if (!N && (T = Gt.mayOpen(y, ne), T))
          throw new Gt.ErrnoError(T);
        return 512 & ne && !N && Gt.truncate(y, 0), ne &= -131713, T = Gt.createStream({ node: y, path: Gt.getPath(y), flags: ne, seekable: !0, position: 0, stream_ops: y.stream_ops, ungotten: [], error: !1 }), T.stream_ops.open && T.stream_ops.open(T), !Pt.logReadFiles || 1 & ne || (Gt.readFiles || (Gt.readFiles = {}), k in Gt.readFiles) || (Gt.readFiles[k] = 1), T;
      }, close: function(k) {
        if (Gt.isClosed(k))
          throw new Gt.ErrnoError(8);
        k.getdents && (k.getdents = null);
        try {
          k.stream_ops.close && k.stream_ops.close(k);
        } catch (ne) {
          throw ne;
        } finally {
          Gt.closeStream(k.fd);
        }
        k.fd = null;
      }, isClosed: function(k) {
        return k.fd === null;
      }, llseek: function(k, ne, T) {
        if (Gt.isClosed(k))
          throw new Gt.ErrnoError(8);
        if (!k.seekable || !k.stream_ops.llseek)
          throw new Gt.ErrnoError(70);
        if (T != 0 && T != 1 && T != 2)
          throw new Gt.ErrnoError(28);
        return k.position = k.stream_ops.llseek(k, ne, T), k.ungotten = [], k.position;
      }, read: function(k, ne, T, y, N) {
        if (y < 0 || N < 0)
          throw new Gt.ErrnoError(28);
        if (Gt.isClosed(k))
          throw new Gt.ErrnoError(8);
        if ((2097155 & k.flags) == 1)
          throw new Gt.ErrnoError(8);
        if (Gt.isDir(k.node.mode))
          throw new Gt.ErrnoError(31);
        if (!k.stream_ops.read)
          throw new Gt.ErrnoError(28);
        var b = N !== void 0;
        if (b) {
          if (!k.seekable)
            throw new Gt.ErrnoError(70);
        } else
          N = k.position;
        return ne = k.stream_ops.read(k, ne, T, y, N), b || (k.position += ne), ne;
      }, write: function(k, ne, T, y, N, b) {
        if (y < 0 || N < 0)
          throw new Gt.ErrnoError(28);
        if (Gt.isClosed(k))
          throw new Gt.ErrnoError(8);
        if (!(2097155 & k.flags))
          throw new Gt.ErrnoError(8);
        if (Gt.isDir(k.node.mode))
          throw new Gt.ErrnoError(31);
        if (!k.stream_ops.write)
          throw new Gt.ErrnoError(28);
        k.seekable && 1024 & k.flags && Gt.llseek(k, 0, 2);
        var X = N !== void 0;
        if (X) {
          if (!k.seekable)
            throw new Gt.ErrnoError(70);
        } else
          N = k.position;
        return ne = k.stream_ops.write(k, ne, T, y, N, b), X || (k.position += ne), ne;
      }, allocate: function(k, ne, T) {
        if (Gt.isClosed(k))
          throw new Gt.ErrnoError(8);
        if (ne < 0 || T <= 0)
          throw new Gt.ErrnoError(28);
        if (!(2097155 & k.flags))
          throw new Gt.ErrnoError(8);
        if (!Gt.isFile(k.node.mode) && !Gt.isDir(k.node.mode))
          throw new Gt.ErrnoError(43);
        if (!k.stream_ops.allocate)
          throw new Gt.ErrnoError(138);
        k.stream_ops.allocate(k, ne, T);
      }, mmap: function(k, ne, T, y, N) {
        if (2 & y && !(2 & N) && (2097155 & k.flags) != 2)
          throw new Gt.ErrnoError(2);
        if ((2097155 & k.flags) == 1)
          throw new Gt.ErrnoError(2);
        if (k.stream_ops.mmap)
          return k.stream_ops.mmap(k, ne, T, y, N);
        throw new Gt.ErrnoError(43);
      }, msync: function(k, ne, T, y, N) {
        return k.stream_ops.msync ? k.stream_ops.msync(k, ne, T, y, N) : 0;
      }, munmap: function(k) {
        return 0;
      }, ioctl: function(k, ne, T) {
        if (k.stream_ops.ioctl)
          return k.stream_ops.ioctl(k, ne, T);
        throw new Gt.ErrnoError(59);
      }, readFile: function(N) {
        var ne, T = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        if (T.flags = T.flags || 0, T.encoding = T.encoding || "binary", T.encoding !== "utf8" && T.encoding !== "binary")
          throw new Error('Invalid encoding type "'.concat(T.encoding, '"'));
        var y = Gt.open(N, T.flags), N = Gt.stat(N).size, b = new Uint8Array(N);
        return Gt.read(y, b, 0, N, 0), T.encoding === "utf8" ? ne = Ys(b, 0) : T.encoding === "binary" && (ne = b), Gt.close(y), ne;
      }, writeFile: function(y, ne) {
        var T = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {}, y = (T.flags = T.flags || 577, Gt.open(y, T.flags, T.mode));
        if (typeof ne == "string") {
          var N = new Uint8Array(oo(ne) + 1), b = vs(ne, N, 0, N.length);
          Gt.write(y, N, 0, b, void 0, T.canOwn);
        } else {
          if (!ArrayBuffer.isView(ne))
            throw new Error("Unsupported data type");
          Gt.write(y, ne, 0, ne.byteLength, void 0, T.canOwn);
        }
        Gt.close(y);
      }, cwd: function() {
        return Gt.currentPath;
      }, chdir: function(k) {
        if (k = Gt.lookupPath(k, { follow: !0 }), k.node === null)
          throw new Gt.ErrnoError(44);
        if (!Gt.isDir(k.node.mode))
          throw new Gt.ErrnoError(54);
        var ne = Gt.nodePermissions(k.node, "x");
        if (ne)
          throw new Gt.ErrnoError(ne);
        Gt.currentPath = k.path;
      }, createDefaultDirectories: function() {
        Gt.mkdir("/tmp"), Gt.mkdir("/home"), Gt.mkdir("/home/web_user");
      }, createDefaultDevices: function() {
        Gt.mkdir("/dev"), Gt.registerDevice(Gt.makedev(1, 3), { read: function() {
          return 0;
        }, write: function(y, N, b, X, J) {
          return X;
        } }), Gt.mkdev("/dev/null", Gt.makedev(1, 3)), ds.register(Gt.makedev(5, 0), ds.default_tty_ops), ds.register(Gt.makedev(6, 0), ds.default_tty1_ops), Gt.mkdev("/dev/tty", Gt.makedev(5, 0)), Gt.mkdev("/dev/tty1", Gt.makedev(6, 0));
        function k() {
          return T === 0 && (T = _s(ne).byteLength), ne[--T];
        }
        var ne = new Uint8Array(1024), T = 0;
        Gt.createDevice("/dev", "random", k), Gt.createDevice("/dev", "urandom", k), Gt.mkdir("/dev/shm"), Gt.mkdir("/dev/shm/tmp");
      }, createSpecialDirectories: function() {
        Gt.mkdir("/proc");
        var k = Gt.mkdir("/proc/self");
        Gt.mkdir("/proc/self/fd"), Gt.mount({ mount: function() {
          var ne = Gt.createNode(k, "fd", 16895, 73);
          return ne.node_ops = { lookup: function(T, b) {
            var N = Gt.getStreamChecked(+b), b = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: function() {
              return N.path;
            } } };
            return b.parent = b;
          } }, ne;
        } }, {}, "/proc/self/fd");
      }, createStandardStreams: function() {
        Pt.stdin ? Gt.createDevice("/dev", "stdin", Pt.stdin) : Gt.symlink("/dev/tty", "/dev/stdin"), Pt.stdout ? Gt.createDevice("/dev", "stdout", null, Pt.stdout) : Gt.symlink("/dev/tty", "/dev/stdout"), Pt.stderr ? Gt.createDevice("/dev", "stderr", null, Pt.stderr) : Gt.symlink("/dev/tty1", "/dev/stderr"), Gt.open("/dev/stdin", 0), Gt.open("/dev/stdout", 1), Gt.open("/dev/stderr", 1);
      }, ensureErrnoError: function() {
        Gt.ErrnoError || (Gt.ErrnoError = function(k, ne) {
          this.name = "ErrnoError", this.node = ne, this.setErrno = function(T) {
            this.errno = T;
          }, this.setErrno(k), this.message = "FS error";
        }, Gt.ErrnoError.prototype = new Error(), Gt.ErrnoError.prototype.constructor = Gt.ErrnoError, [44].forEach(function(k) {
          Gt.genericErrors[k] = new Gt.ErrnoError(k), Gt.genericErrors[k].stack = "<generic error, no stack>";
        }));
      }, staticInit: function() {
        Gt.ensureErrnoError(), Gt.nameTable = new Array(4096), Gt.mount(Ls, {}, "/"), Gt.createDefaultDirectories(), Gt.createDefaultDevices(), Gt.createSpecialDirectories(), Gt.filesystems = { MEMFS: Ls, NODEFS: Tr, WORKERFS: ao };
      }, init: function(k, ne, T) {
        Gt.init.initialized = !0, Gt.ensureErrnoError(), Pt.stdin = k || Pt.stdin, Pt.stdout = ne || Pt.stdout, Pt.stderr = T || Pt.stderr, Gt.createStandardStreams();
      }, quit: function() {
        Gt.init.initialized = !1;
        for (var k = 0; k < Gt.streams.length; k++) {
          var ne = Gt.streams[k];
          ne && Gt.close(ne);
        }
      }, findObject: function(k, ne) {
        return k = Gt.analyzePath(k, ne), k.exists ? k.object : null;
      }, analyzePath: function(k, ne) {
        try {
          k = (y = Gt.lookupPath(k, { follow: !ne })).path;
        } catch {
        }
        var T = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
        try {
          var y = Gt.lookupPath(k, { parent: !0 });
          T.parentExists = !0, T.parentPath = y.path, T.parentObject = y.node, T.name = Or.basename(k), y = Gt.lookupPath(k, { follow: !ne }), T.exists = !0, T.path = y.path, T.object = y.node, T.name = y.node.name, T.isRoot = y.path === "/";
        } catch (N) {
          T.error = N.errno;
        }
        return T;
      }, createPath: function(k, ne, T, y) {
        k = typeof k == "string" ? k : Gt.getPath(k);
        for (var N = ne.split("/").reverse(); N.length; ) {
          var b = N.pop();
          if (b) {
            var X = Or.join2(k, b);
            try {
              Gt.mkdir(X);
            } catch {
            }
            k = X;
          }
        }
        return X;
      }, createFile: function(k, ne, T, y, N) {
        return k = Or.join2(typeof k == "string" ? k : Gt.getPath(k), ne), ne = ki(y, N), Gt.create(k, ne);
      }, createDataFile: function(Ie, J, T, y, N, b) {
        var X = J, J = (Ie && (Ie = typeof Ie == "string" ? Ie : Gt.getPath(Ie), X = J ? Or.join2(Ie, J) : Ie), ki(y, N)), Ie = Gt.create(X, J);
        if (T) {
          if (typeof T == "string") {
            for (var Pe = new Array(T.length), We = 0, it = T.length; We < it; ++We)
              Pe[We] = T.charCodeAt(We);
            T = Pe;
          }
          Gt.chmod(Ie, 146 | J), y = Gt.open(Ie, 577), Gt.write(y, T, 0, T.length, 0, b), Gt.close(y), Gt.chmod(Ie, J);
        }
      }, createDevice: function(N, b, T, y) {
        var N = Or.join2(typeof N == "string" ? N : Gt.getPath(N), b), b = ki(!!T, !!y), X = (Gt.createDevice.major || (Gt.createDevice.major = 64), Gt.makedev(Gt.createDevice.major++, 0));
        return Gt.registerDevice(X, { open: function(J) {
          J.seekable = !1;
        }, close: function(J) {
          var Ie;
          y != null && (Ie = y.buffer) != null && Ie.length && y(10);
        }, read: function(J, Ie, Pe, We, it) {
          for (var Rt, Dt = 0, Kt = 0; Kt < We; Kt++) {
            try {
              Rt = T();
            } catch {
              throw new Gt.ErrnoError(29);
            }
            if (Rt === void 0 && Dt === 0)
              throw new Gt.ErrnoError(6);
            if (Rt == null)
              break;
            Dt++, Ie[Pe + Kt] = Rt;
          }
          return Dt && (J.node.timestamp = Date.now()), Dt;
        }, write: function(J, Ie, Pe, We, it) {
          for (var Rt = 0; Rt < We; Rt++)
            try {
              y(Ie[Pe + Rt]);
            } catch {
              throw new Gt.ErrnoError(29);
            }
          return We && (J.node.timestamp = Date.now()), Rt;
        } }), Gt.mkdev(N, b, X);
      }, forceLoadFile: function(k) {
        if (k.isDevice || k.isFolder || k.link || k.contents)
          return !0;
        if (typeof XMLHttpRequest < "u")
          throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        if (!ur)
          throw new Error("Cannot load without read() or XMLHttpRequest.");
        try {
          k.contents = yi(ur(k.url), !0), k.usedBytes = k.contents.length;
        } catch {
          throw new Gt.ErrnoError(29);
        }
      }, createLazyFile: function(k, ne, T, y, N) {
        function b() {
          this.lengthKnown = !1, this.chunks = [];
        }
        if (b.prototype.get = function(We) {
          var it;
          if (!(We > this.length - 1 || We < 0))
            return it = We % this.chunkSize, We = We / this.chunkSize | 0, this.getter(We)[it];
        }, b.prototype.setDataGetter = function(We) {
          this.getter = We;
        }, b.prototype.cacheLength = function() {
          var Dt = new XMLHttpRequest();
          if (Dt.open("HEAD", T, !1), Dt.send(null), !(200 <= Dt.status && Dt.status < 300 || Dt.status === 304))
            throw new Error("Couldn't load " + T + ". Status: " + Dt.status);
          var We, it = Number(Dt.getResponseHeader("Content-length")), Rt = (We = Dt.getResponseHeader("Accept-Ranges")) && We === "bytes", Dt = (We = Dt.getResponseHeader("Content-Encoding")) && We === "gzip", Kt = 1048576, _n = (Rt || (Kt = it), this);
          _n.setDataGetter(function(gn) {
            var Pn = gn * Kt, Vn = (gn + 1) * Kt - 1, Vn = Math.min(Vn, it - 1);
            if (_n.chunks[gn] === void 0 && (_n.chunks[gn] = function(vn, Zn) {
              if (Zn < vn)
                throw new Error("invalid range (" + vn + ", " + Zn + ") or no bytes requested!");
              if (it - 1 < Zn)
                throw new Error("only " + it + " bytes available! programmer error!");
              var cr = new XMLHttpRequest();
              if (cr.open("GET", T, !1), it !== Kt && cr.setRequestHeader("Range", "bytes=" + vn + "-" + Zn), cr.responseType = "arraybuffer", cr.overrideMimeType && cr.overrideMimeType("text/plain; charset=x-user-defined"), cr.send(null), 200 <= cr.status && cr.status < 300 || cr.status === 304)
                return cr.response !== void 0 ? new Uint8Array(cr.response || []) : yi(cr.responseText || "", !0);
              throw new Error("Couldn't load " + T + ". Status: " + cr.status);
            }(Pn, Vn)), _n.chunks[gn] === void 0)
              throw new Error("doXHR failed!");
            return _n.chunks[gn];
          }), !Dt && it || (Kt = it = 1, it = this.getter(0).length, Kt = it, Nr("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = it, this._chunkSize = Kt, this.lengthKnown = !0;
        }, typeof XMLHttpRequest < "u") {
          if (!po)
            throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
          var X = new b(), X = (Object.defineProperties(X, { length: { get: function() {
            return this.lengthKnown || this.cacheLength(), this._length;
          } }, chunkSize: { get: function() {
            return this.lengthKnown || this.cacheLength(), this._chunkSize;
          } } }), { isDevice: !1, contents: X });
        } else
          X = { isDevice: !1, url: T };
        var J = Gt.createFile(k, ne, X, y, N), Ie = (X.contents ? J.contents = X.contents : X.url && (J.contents = null, J.url = X.url), Object.defineProperties(J, { usedBytes: { get: function() {
          return this.contents.length;
        } } }), {});
        function Pe(We, it, Rt, Dt, Kt) {
          var _n = We.node.contents;
          if (Kt >= _n.length)
            return 0;
          var gn = Math.min(_n.length - Kt, Dt);
          if (_n.slice)
            for (var Pn = 0; Pn < gn; Pn++)
              it[Rt + Pn] = _n[Kt + Pn];
          else
            for (Pn = 0; Pn < gn; Pn++)
              it[Rt + Pn] = _n.get(Kt + Pn);
          return gn;
        }
        return Object.keys(J.stream_ops).forEach(function(We) {
          var it = J.stream_ops[We];
          Ie[We] = function() {
            return Gt.forceLoadFile(J), it.apply(null, arguments);
          };
        }), Ie.read = function(We, it, Rt, Dt, Kt) {
          return Gt.forceLoadFile(J), Pe(We, it, Rt, Dt, Kt);
        }, Ie.mmap = function(We, it, Rt, Dt, Kt) {
          Gt.forceLoadFile(J);
          var _n = $r(it);
          if (_n)
            return Pe(We, gs, _n, it, Rt), { ptr: _n, allocated: !0 };
          throw new Gt.ErrnoError(48);
        }, J.stream_ops = Ie, J;
      } }, sr = { DEFAULT_POLLMASK: 5, calculateAt: function(k, ne, T) {
        if (Or.isAbs(ne))
          return ne;
        if (k = k === -100 ? Gt.cwd() : sr.getStreamFromFD(k).path, ne.length != 0)
          return Or.join2(k, ne);
        if (T)
          return k;
        throw new Gt.ErrnoError(44);
      }, doStat: function(N, b, T) {
        try {
          var y = N(b);
        } catch (J) {
          if (J && J.node && Or.normalize(b) !== Or.normalize(Gt.getPath(J.node)))
            return -54;
          throw J;
        }
        Ir[T >> 2] = y.dev, Ir[T + 4 >> 2] = y.mode, ws[T + 8 >> 2] = y.nlink, Ir[T + 12 >> 2] = y.uid, Ir[T + 16 >> 2] = y.gid, Ir[T + 20 >> 2] = y.rdev, ts = [y.size >>> 0, (vr = y.size, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[T + 24 >> 2] = ts[0], Ir[T + 28 >> 2] = ts[1], Ir[T + 32 >> 2] = 4096, Ir[T + 36 >> 2] = y.blocks;
        var N = y.atime.getTime(), b = y.mtime.getTime(), X = y.ctime.getTime();
        return ts = [Math.floor(N / 1e3) >>> 0, (vr = Math.floor(N / 1e3), 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[T + 40 >> 2] = ts[0], Ir[T + 44 >> 2] = ts[1], ws[T + 48 >> 2] = N % 1e3 * 1e3, ts = [Math.floor(b / 1e3) >>> 0, (vr = Math.floor(b / 1e3), 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[T + 56 >> 2] = ts[0], Ir[T + 60 >> 2] = ts[1], ws[T + 64 >> 2] = b % 1e3 * 1e3, ts = [Math.floor(X / 1e3) >>> 0, (vr = Math.floor(X / 1e3), 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[T + 72 >> 2] = ts[0], Ir[T + 76 >> 2] = ts[1], ws[T + 80 >> 2] = X % 1e3 * 1e3, ts = [y.ino >>> 0, (vr = y.ino, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[T + 88 >> 2] = ts[0], Ir[T + 92 >> 2] = ts[1], 0;
      }, doMsync: function(k, ne, T, y, N) {
        if (!Gt.isFile(ne.node.mode))
          throw new Gt.ErrnoError(43);
        if (2 & y)
          return 0;
        k = fo.slice(k, k + T), Gt.msync(ne, k, N, T, y);
      }, varargs: void 0, get: function() {
        var k = Ir[+sr.varargs >> 2];
        return sr.varargs += 4, k;
      }, getp: function() {
        return sr.get();
      }, getStr: function(k) {
        return Di(k);
      }, getStreamFromFD: function(k) {
        return Gt.getStreamChecked(k);
      } };
      function vt(k, ne) {
        return ne + 2097152 >>> 0 < 4194305 - !!k ? (k >>> 0) + 4294967296 * ne : NaN;
      }
      function Jr(k) {
        Ir[Nt() >> 2] = k;
      }
      var Qs = function(k, ne, T) {
        return vs(k, fo, ne, T);
      }, Ds = { BUCKET_BUFFER_SIZE: 8192, mount: function(k) {
        return Gt.createNode(null, "/", 16895, 0);
      }, createPipe: function() {
        var y = { buckets: [], refcnt: 2 }, N = (y.buckets.push({ buffer: new Uint8Array(Ds.BUCKET_BUFFER_SIZE), offset: 0, roffset: 0 }), Ds.nextname()), k = Ds.nextname(), ne = Gt.createNode(Ds.root, N, 4096, 0), T = Gt.createNode(Ds.root, k, 4096, 0), y = (ne.pipe = y, T.pipe = y, Gt.createStream({ path: N, node: ne, flags: 0, seekable: !1, stream_ops: Ds.stream_ops })), N = (ne.stream = y, Gt.createStream({ path: k, node: T, flags: 1, seekable: !1, stream_ops: Ds.stream_ops }));
        return T.stream = N, { readable_fd: y.fd, writable_fd: N.fd };
      }, stream_ops: { poll: function(k) {
        var ne = k.node.pipe;
        if ((2097155 & k.flags) == 1)
          return 260;
        if (0 < ne.buckets.length)
          for (var T = 0; T < ne.buckets.length; T++) {
            var y = ne.buckets[T];
            if (0 < y.offset - y.roffset)
              return 65;
          }
        return 0;
      }, ioctl: function(k, ne, T) {
        return 28;
      }, fsync: function(k) {
        return 28;
      }, read: function(k, ne, T, y, N) {
        for (var b = k.node.pipe, X = 0, J = 0; J < b.buckets.length; J++) {
          var Ie = b.buckets[J];
          X += Ie.offset - Ie.roffset;
        }
        var Pe = ne.subarray(T, T + y);
        if (y <= 0)
          return 0;
        if (X == 0)
          throw new Gt.ErrnoError(6);
        for (var We = Math.min(X, y), k = We, it = 0, J = 0; J < b.buckets.length; J++) {
          var Rt = b.buckets[J], Dt = Rt.offset - Rt.roffset;
          if (We <= Dt) {
            var Kt = Rt.buffer.subarray(Rt.roffset, Rt.offset);
            We < Dt ? (Kt = Kt.subarray(0, We), Rt.roffset += We) : it++, Pe.set(Kt);
            break;
          }
          Kt = Rt.buffer.subarray(Rt.roffset, Rt.offset), Pe.set(Kt), Pe = Pe.subarray(Kt.byteLength), We -= Kt.byteLength, it++;
        }
        return it && it == b.buckets.length && (b.buckets[--it].offset = 0, b.buckets[it].roffset = 0), b.buckets.splice(0, it), k;
      }, write: function(J, ne, T, y, N) {
        var b = J.node.pipe, X = ne.subarray(T, T + y), J = X.byteLength;
        if (J <= 0)
          return 0;
        if (ne = null, b.buckets.length == 0 ? (ne = { buffer: new Uint8Array(Ds.BUCKET_BUFFER_SIZE), offset: 0, roffset: 0 }, b.buckets.push(ne)) : ne = b.buckets[b.buckets.length - 1], Bo(ne.offset <= Ds.BUCKET_BUFFER_SIZE), T = Ds.BUCKET_BUFFER_SIZE - ne.offset, J <= T)
          ne.buffer.set(X, ne.offset), ne.offset += J;
        else {
          0 < T && (ne.buffer.set(X.subarray(0, T), ne.offset), ne.offset += T, X = X.subarray(T, X.byteLength));
          for (var Ie = X.byteLength / Ds.BUCKET_BUFFER_SIZE | 0, y = X.byteLength % Ds.BUCKET_BUFFER_SIZE, Pe = 0; Pe < Ie; Pe++) {
            var We = { buffer: new Uint8Array(Ds.BUCKET_BUFFER_SIZE), offset: Ds.BUCKET_BUFFER_SIZE, roffset: 0 };
            b.buckets.push(We), We.buffer.set(X.subarray(0, Ds.BUCKET_BUFFER_SIZE)), X = X.subarray(Ds.BUCKET_BUFFER_SIZE, X.byteLength);
          }
          0 < y && (We = { buffer: new Uint8Array(Ds.BUCKET_BUFFER_SIZE), offset: X.byteLength, roffset: 0 }, b.buckets.push(We), We.buffer.set(X));
        }
        return J;
      }, close: function(k) {
        k = k.node.pipe, k.refcnt--, k.refcnt === 0 && (k.buckets = null);
      } }, nextname: function() {
        return Ds.nextname.current || (Ds.nextname.current = 0), "pipe[" + Ds.nextname.current++ + "]";
      } };
      function Hs(k) {
        return ws[k >> 2] + 4294967296 * Ir[k + 4 >> 2];
      }
      function Xr(k) {
        return (bi(k.getFullYear()) ? rn : mo)[k.getMonth()] + k.getDate() - 1;
      }
      var bi = function(k) {
        return k % 4 == 0 && (k % 100 != 0 || k % 400 == 0);
      }, rn = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], mo = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      function Gi(k) {
        var ne = oo(k) + 1, T = mt(ne);
        return T && Qs(k, T, ne), T;
      }
      function yo() {
        return 2147483648;
      }
      function ci() {
        if (!ci.strings) {
          var k = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: ((typeof navigator > "u" ? "undefined" : c(navigator)) == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: or() };
          for (ne in Bn)
            Bn[ne] === void 0 ? delete k[ne] : k[ne] = Bn[ne];
          var ne, T = [];
          for (ne in k)
            T.push("".concat(ne, "=").concat(k[ne]));
          ci.strings = T;
        }
        return ci.strings;
      }
      function Ri(k) {
        var ne;
        Xs() || ((ne = Pt.onExit) != null && ne.call(Pt, k), Ro = !0), Os(k, new To(k));
      }
      function ms(k, ne) {
        Ri(k);
      }
      var zt = yo, fn = function() {
        return performance.now();
      }, Bn = {}, or = function() {
        return hs || "./this.program";
      }, ss = 0, Xs = function() {
        return bo || 0 < ss;
      };
      function Fo(k, ne, T, y) {
        for (var N = 0, b = 0; b < T; b++) {
          var J = ws[ne >> 2], X = ws[ne + 4 >> 2], J = (ne += 8, Gt.read(k, gs, J, X, y));
          if (J < 0)
            return -1;
          if (N += J, J < X)
            break;
          y !== void 0 && (y += J);
        }
        return N;
      }
      function ji(k, ne) {
        gs.set(k, ne);
      }
      function zo(k, ne, T, y) {
        var N = ws[y + 40 >> 2], b = { tm_sec: Ir[y >> 2], tm_min: Ir[y + 4 >> 2], tm_hour: Ir[y + 8 >> 2], tm_mday: Ir[y + 12 >> 2], tm_mon: Ir[y + 16 >> 2], tm_year: Ir[y + 20 >> 2], tm_wday: Ir[y + 24 >> 2], tm_yday: Ir[y + 28 >> 2], tm_isdst: Ir[y + 32 >> 2], tm_gmtoff: Ir[y + 36 >> 2], tm_zone: N ? Di(N) : "" }, gn = Di(T), X = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
        for (Kt in X)
          gn = gn.replace(new RegExp(Kt, "g"), X[Kt]);
        var J = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Ie = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        function Pe(Pn, Vn, vn) {
          for (var Zn = typeof Pn == "number" ? Pn.toString() : Pn || ""; Zn.length < Vn; )
            Zn = vn[0] + Zn;
          return Zn;
        }
        function We(Pn, Vn) {
          return Pe(Pn, Vn, "0");
        }
        function it(Pn, Vn) {
          function vn(cr) {
            return cr < 0 ? -1 : 0 < cr ? 1 : 0;
          }
          var Zn;
          return Zn = (Zn = vn(Pn.getFullYear() - Vn.getFullYear())) === 0 && (Zn = vn(Pn.getMonth() - Vn.getMonth())) === 0 ? vn(Pn.getDate() - Vn.getDate()) : Zn;
        }
        function Rt(Pn) {
          switch (Pn.getDay()) {
            case 0:
              return new Date(Pn.getFullYear() - 1, 11, 29);
            case 1:
              return Pn;
            case 2:
              return new Date(Pn.getFullYear(), 0, 3);
            case 3:
              return new Date(Pn.getFullYear(), 0, 2);
            case 4:
              return new Date(Pn.getFullYear(), 0, 1);
            case 5:
              return new Date(Pn.getFullYear() - 1, 11, 31);
            case 6:
              return new Date(Pn.getFullYear() - 1, 11, 30);
          }
        }
        function Dt(Vn) {
          var Vn = function(cr, Cs) {
            for (var Br = new Date(cr.getTime()); 0 < Cs; ) {
              var _o = bi(Br.getFullYear()), Do = Br.getMonth(), _o = (_o ? Ks : Qo)[Do];
              if (!(Cs > _o - Br.getDate()))
                return Br.setDate(Br.getDate() + Cs), Br;
              Cs -= _o - Br.getDate() + 1, Br.setDate(1), Do < 11 ? Br.setMonth(Do + 1) : (Br.setMonth(0), Br.setFullYear(Br.getFullYear() + 1));
            }
            return Br;
          }(new Date(Vn.tm_year + 1900, 0, 1), Vn.tm_yday), vn = new Date(Vn.getFullYear(), 0, 4), Zn = new Date(Vn.getFullYear() + 1, 0, 4), vn = Rt(vn), Zn = Rt(Zn);
          return it(vn, Vn) <= 0 ? it(Zn, Vn) <= 0 ? Vn.getFullYear() + 1 : Vn.getFullYear() : Vn.getFullYear() - 1;
        }
        var Kt, _n = { "%a": function(Pn) {
          return J[Pn.tm_wday].substring(0, 3);
        }, "%A": function(Pn) {
          return J[Pn.tm_wday];
        }, "%b": function(Pn) {
          return Ie[Pn.tm_mon].substring(0, 3);
        }, "%B": function(Pn) {
          return Ie[Pn.tm_mon];
        }, "%C": function(Pn) {
          return We((Pn.tm_year + 1900) / 100 | 0, 2);
        }, "%d": function(Pn) {
          return We(Pn.tm_mday, 2);
        }, "%e": function(Pn) {
          return Pe(Pn.tm_mday, 2, " ");
        }, "%g": function(Pn) {
          return Dt(Pn).toString().substring(2);
        }, "%G": Dt, "%H": function(Pn) {
          return We(Pn.tm_hour, 2);
        }, "%I": function(Pn) {
          return Pn = Pn.tm_hour, Pn == 0 ? Pn = 12 : 12 < Pn && (Pn -= 12), We(Pn, 2);
        }, "%j": function(Pn) {
          return We(Pn.tm_mday + function(Vn, vn) {
            for (var Zn = 0, cr = 0; cr <= vn; Zn += Vn[cr++])
              ;
            return Zn;
          }(bi(Pn.tm_year + 1900) ? Ks : Qo, Pn.tm_mon - 1), 3);
        }, "%m": function(Pn) {
          return We(Pn.tm_mon + 1, 2);
        }, "%M": function(Pn) {
          return We(Pn.tm_min, 2);
        }, "%n": function() {
          return `
`;
        }, "%p": function(Pn) {
          return 0 <= Pn.tm_hour && Pn.tm_hour < 12 ? "AM" : "PM";
        }, "%S": function(Pn) {
          return We(Pn.tm_sec, 2);
        }, "%t": function() {
          return "	";
        }, "%u": function(Pn) {
          return Pn.tm_wday || 7;
        }, "%U": function(Pn) {
          return Pn = Pn.tm_yday + 7 - Pn.tm_wday, We(Math.floor(Pn / 7), 2);
        }, "%V": function(Pn) {
          var Vn, vn = Math.floor((Pn.tm_yday + 7 - (Pn.tm_wday + 6) % 7) / 7);
          return (Pn.tm_wday + 371 - Pn.tm_yday - 2) % 7 <= 2 && vn++, vn ? vn != 53 || (Vn = (Pn.tm_wday + 371 - Pn.tm_yday) % 7) == 4 || Vn == 3 && bi(Pn.tm_year) || (vn = 1) : (vn = 52, ((Vn = (Pn.tm_wday + 7 - Pn.tm_yday - 1) % 7) == 4 || Vn == 5 && bi(Pn.tm_year % 400 - 1)) && vn++), We(vn, 2);
        }, "%w": function(Pn) {
          return Pn.tm_wday;
        }, "%W": function(Pn) {
          return Pn = Pn.tm_yday + 7 - (Pn.tm_wday + 6) % 7, We(Math.floor(Pn / 7), 2);
        }, "%y": function(Pn) {
          return (Pn.tm_year + 1900).toString().substring(2);
        }, "%Y": function(Pn) {
          return Pn.tm_year + 1900;
        }, "%z": function(vn) {
          var Vn = 0 <= (vn = vn.tm_gmtoff), vn = Math.abs(vn) / 60;
          return (Vn ? "+" : "-") + ("0000" + (vn / 60 * 100 + vn % 60)).slice(-4);
        }, "%Z": function(Pn) {
          return Pn.tm_zone;
        }, "%%": function() {
          return "%";
        } }, gn = gn.replace(/%%/g, "\0\0");
        for (Kt in _n)
          gn.includes(Kt) && (gn = gn.replace(new RegExp(Kt, "g"), _n[Kt](b)));
        return (y = yi(gn = gn.replace(/\0\0/g, "%"), !1)).length > ne ? 0 : (ji(y, k), y.length - 1);
      }
      function Yi(k) {
        return Pt["_" + k];
      }
      function Li(X, ne, T, y, N) {
        var b = { string: function(it) {
          var Rt, Dt, Kt = 0;
          return it != null && it !== 0 && (Rt = oo(it = it) + 1, Dt = sn(Rt), Qs(it, Dt, Rt), Kt = Dt), Kt;
        }, array: function(it) {
          var Rt = sn(it.length);
          return ji(it, Rt), Rt;
        } }, X = Yi(X), J = [], Ie = 0;
        if (y)
          for (var Pe = 0; Pe < y.length; Pe++) {
            var We = b[T[Pe]];
            We ? (Ie === 0 && (Ie = ot()), J[Pe] = We(y[Pe])) : J[Pe] = y[Pe];
          }
        return X = X = X.apply(null, J), Ie !== 0 && Xt(Ie), X = X, ne === "string" ? Di(X) : ne === "boolean" ? !!X : X;
      }
      function _i(k, ne) {
        Lo.set(k, ne), so[k] = Lo.get(k);
      }
      function pa(k, ne, T, y) {
        this.parent = k = k || this, this.mount = k.mount, this.mounted = null, this.id = Gt.nextInode++, this.name = ne, this.mode = T, this.node_ops = {}, this.stream_ops = {}, this.rdev = y;
      }
      var $o, wo, Ks = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Qo = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], pi = function(k, ne) {
        k < 128 ? ne.push(k) : ne.push(k % 128 | 128, k >> 7);
      }, Ns = function(k) {
        for (var ne = { i: "i32", j: "i64", f: "f32", d: "f64", e: "externref", p: "i32" }, T = { parameters: [], results: k[0] == "v" ? [] : [ne[k[0]]] }, y = 1; y < k.length; ++y)
          T.parameters.push(ne[k[y]]);
        return T;
      }, Fi = function(k, ne) {
        var T = k.slice(0, 1), y = k.slice(1), N = { i: 127, p: 127, j: 126, f: 125, d: 124, e: 111 };
        ne.push(96), pi(y.length, ne);
        for (var b = 0; b < y.length; ++b)
          ne.push(N[y[b]]);
        T == "v" ? ne.push(0) : ne.push(1, N[T]);
      }, la = function(k, ne) {
        if ($o)
          for (var T = k; T < k + ne; T++) {
            var y = Yn(T);
            y && $o.set(y, T);
          }
      }, Ho = [], Ye = (Object.defineProperties(pa.prototype, { read: { get: function() {
        return (365 & this.mode) == 365;
      }, set: function(k) {
        k ? this.mode |= 365 : this.mode &= -366;
      } }, write: { get: function() {
        return (146 & this.mode) == 146;
      }, set: function(k) {
        k ? this.mode |= 146 : this.mode &= -147;
      } }, isFolder: { get: function() {
        return Gt.isDir(this.mode);
      } }, isDevice: { get: function() {
        return Gt.isChrdev(this.mode);
      } } }), Gt.FSNode = pa, Gt.createPreloadedFile = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We, it, Rt, Dt, Kt = ne ? xo.resolve(Or.join2(k, ne)) : k;
        function _n(gn) {
          function Pn(Br) {
            Pe != null && Pe(), J || Gt.createDataFile(k, ne, Br, y, N, Ie), b != null && b(), As();
          }
          var Vn, vn, Zn, cr, Cs;
          Vn = gn, vn = Kt, Zn = Pn, cr = function() {
            X != null && X(), As();
          }, typeof Browser < "u" && Browser.init(), Cs = !1, Co.forEach(function(Br) {
            Cs || Br.canHandle(vn) && (Br.handle(Vn, vn, Zn, cr), Cs = !0);
          }), Cs || Pn(gn);
        }
        Wo(), typeof T == "string" ? (We = T, it = function(gn) {
          _n(gn);
        }, Rt = X, Dt = "al ".concat(We), Rr(We, function(gn) {
          Bo(gn, 'Loading data file "'.concat(We, '" failed (no arrayBuffer).')), it(new Uint8Array(gn)), Dt && As();
        }, function(gn) {
          if (!Rt)
            throw 'Loading data file "'.concat(We, '" failed.');
          Rt();
        }), Dt && Wo()) : _n(T);
      }, Gt.staticInit(), Pt.FS_createPath = Gt.createPath, Pt.FS_createDataFile = Gt.createDataFile, Pt.FS_createPreloadedFile = Gt.createPreloadedFile, Pt.FS_unlink = Gt.unlink, Pt.FS_createLazyFile = Gt.createLazyFile, Pt.FS_createDevice = Gt.createDevice, So && Tr.staticInit(), { y: function(k, ne, T, y) {
        ro("Assertion failed: ".concat(Di(k), ", at: ") + [ne ? Di(ne) : "unknown filename", T, y ? Di(y) : "unknown function"]);
      }, Ke: function(k, ne) {
        return Yn(k)(ne);
      }, p: function(k) {
        return k = new li(k), k.get_caught() || (k.set_caught(!0), hi--), k.set_rethrown(!1), rs.push(k), dn(k.excPtr), k.get_exception_ptr();
      }, v: function() {
        Mt(0, 0);
        var k = rs.pop();
        Ar(k.excPtr), Zo = 0;
      }, a: function() {
        return ei([]);
      }, i: function(k) {
        return ei([k]);
      }, x: function(k, ne) {
        return ei([k, ne]);
      }, Ab: function() {
        var k = rs.pop(), ne = (k || ro("no exception to throw"), k.excPtr);
        throw k.get_rethrown() || (rs.push(k), k.set_rethrown(!0), k.set_caught(!1), hi++), Zo = ne;
      }, B: function(k, ne, T) {
        throw new li(k).init(ne, T), hi++, Zo = k;
      }, xc: function() {
        return hi;
      }, e: function(k) {
        throw Zo = Zo || k;
      }, ic: function(k, ne) {
        try {
          return k = sr.getStr(k), Gt.chmod(k, ne), 0;
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return -T.errno;
        }
      }, af: function(k, ne, T) {
        try {
          var y, N = sr.getStreamFromFD(k);
          return N.fd === ne ? -28 : ((y = Gt.getStream(ne)) && Gt.close(y), Gt.createStream(N, ne).fd);
        } catch (b) {
          if (Gt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, qc: function(k, ne, T, y) {
        try {
          var N, b;
          return ne = sr.getStr(ne), ne = sr.calculateAt(k, ne), -8 & T ? -28 : (N = Gt.lookupPath(ne, { follow: !0 }).node) ? (b = "", 4 & T && (b += "r"), 2 & T && (b += "w"), 1 & T && (b += "x"), b && Gt.nodePermissions(N, b) ? -2 : 0) : -44;
        } catch (X) {
          if (Gt === void 0 || X.name !== "ErrnoError")
            throw X;
          return -X.errno;
        }
      }, Rd: function(k, ne, J, Ie, N, b) {
        var X, J = vt(J, Ie), Ie = vt(N, b);
        try {
          return isNaN(J) ? 61 : (X = sr.getStreamFromFD(k), Gt.allocate(X, J, Ie), 0);
        } catch (Pe) {
          if (Gt === void 0 || Pe.name !== "ErrnoError")
            throw Pe;
          return -Pe.errno;
        }
      }, jc: function(k, ne) {
        try {
          return Gt.fchmod(k, ne), 0;
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return -T.errno;
        }
      }, hc: function(k, ne, T) {
        try {
          return Gt.fchown(k, ne, T), 0;
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, ua: function(k, ne, T) {
        sr.varargs = T;
        try {
          var y = sr.getStreamFromFD(k);
          switch (ne) {
            case 0:
              if ((N = sr.get()) < 0)
                return -28;
              for (; Gt.streams[N]; )
                N++;
              return Gt.createStream(y, N).fd;
            case 1:
            case 2:
              return 0;
            case 3:
              return y.flags;
            case 4:
              var N = sr.get();
              return y.flags |= N, 0;
            case 5:
              return N = sr.getp(), xs[N + 0 >> 1] = 2, 0;
            case 6:
            case 7:
              return 0;
            case 16:
            case 8:
              return -28;
            case 9:
              return Jr(28), -1;
            default:
              return -28;
          }
        } catch (b) {
          if (Gt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, lc: function(k) {
        try {
          return sr.getStreamFromFD(k), 0;
        } catch (ne) {
          if (Gt === void 0 || ne.name !== "ErrnoError")
            throw ne;
          return -ne.errno;
        }
      }, je: function(k, ne) {
        try {
          var T = sr.getStreamFromFD(k);
          return sr.doStat(Gt.stat, T.path, ne);
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, be: function(k, ne, T) {
        ne = vt(ne, T);
        try {
          return isNaN(ne) ? 61 : (Gt.ftruncate(k, ne), 0);
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, yc: function(k, ne) {
        try {
          var T, y;
          return ne === 0 ? -28 : (T = Gt.cwd(), ne < (y = oo(T) + 1) ? -68 : (Qs(T, k, ne), y));
        } catch (N) {
          if (Gt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, sc: function(k, ne, T) {
        try {
          for (var y = sr.getStreamFromFD(k), N = (y.getdents || (y.getdents = Gt.readdir(y.path)), 0), b = Gt.llseek(y, 0, 1), X = Math.floor(b / 280); X < y.getdents.length && N + 280 <= T; ) {
            var J, Ie, Pe, We = y.getdents[X];
            Ie = We === "." ? (J = y.node.id, 4) : We === ".." ? (J = Gt.lookupPath(y.path, { parent: !0 }).node.id, 4) : (J = (Pe = Gt.lookupNode(y.node, We)).id, Gt.isChrdev(Pe.mode) ? 2 : Gt.isDir(Pe.mode) ? 4 : Gt.isLink(Pe.mode) ? 10 : 8), ts = [J >>> 0, (vr = J, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[ne + N >> 2] = ts[0], Ir[ne + N + 4 >> 2] = ts[1], ts = [280 * (X + 1) >>> 0, (vr = 280 * (X + 1), 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[ne + N + 8 >> 2] = ts[0], Ir[ne + N + 12 >> 2] = ts[1], xs[ne + N + 16 >> 1] = 280, gs[ne + N + 18 >> 0] = Ie, Qs(We, ne + N + 19, 256), N += 280, X += 1;
          }
          return Gt.llseek(y, 280 * X, 0), N;
        } catch (it) {
          if (Gt === void 0 || it.name !== "ErrnoError")
            throw it;
          return -it.errno;
        }
      }, ue: function(k, ne, T) {
        sr.varargs = T;
        try {
          var y, N = sr.getStreamFromFD(k);
          switch (ne) {
            case 21509:
              return N.tty ? 0 : -59;
            case 21505:
              if (!N.tty)
                return -59;
              if (N.tty.ops.ioctl_tcgets) {
                var b = N.tty.ops.ioctl_tcgets(N), X = sr.getp();
                Ir[X >> 2] = b.c_iflag || 0, Ir[X + 4 >> 2] = b.c_oflag || 0, Ir[X + 8 >> 2] = b.c_cflag || 0, Ir[X + 12 >> 2] = b.c_lflag || 0;
                for (var J = 0; J < 32; J++)
                  gs[X + J + 17 >> 0] = b.c_cc[J] || 0;
              }
              return 0;
            case 21510:
            case 21511:
            case 21512:
              return N.tty ? 0 : -59;
            case 21506:
            case 21507:
            case 21508:
              if (!N.tty)
                return -59;
              if (N.tty.ops.ioctl_tcsets) {
                for (var X = sr.getp(), Ie = Ir[X >> 2], Pe = Ir[X + 4 >> 2], We = Ir[X + 8 >> 2], it = Ir[X + 12 >> 2], Rt = [], J = 0; J < 32; J++)
                  Rt.push(gs[X + J + 17 >> 0]);
                return N.tty.ops.ioctl_tcsets(N.tty, ne, { c_iflag: Ie, c_oflag: Pe, c_cflag: We, c_lflag: it, c_cc: Rt });
              }
              return 0;
            case 21519:
              return N.tty ? (X = sr.getp(), Ir[X >> 2] = 0) : -59;
            case 21520:
              return N.tty ? -28 : -59;
            case 21531:
              return X = sr.getp(), Gt.ioctl(N, ne, X);
            case 21523:
              return N.tty ? (N.tty.ops.ioctl_tiocgwinsz && (y = N.tty.ops.ioctl_tiocgwinsz(N.tty), X = sr.getp(), xs[X >> 1] = y[0], xs[X + 2 >> 1] = y[1]), 0) : -59;
            case 21524:
            case 21515:
              return N.tty ? 0 : -59;
            default:
              return -28;
          }
        } catch (Dt) {
          if (Gt === void 0 || Dt.name !== "ErrnoError")
            throw Dt;
          return -Dt.errno;
        }
      }, Fd: function(k, ne) {
        try {
          return k = sr.getStr(k), sr.doStat(Gt.lstat, k, ne);
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return -T.errno;
        }
      }, uc: function(k, ne, T) {
        try {
          return ne = sr.getStr(ne), ne = sr.calculateAt(k, ne), (ne = Or.normalize(ne))[ne.length - 1] === "/" && (ne = ne.substr(0, ne.length - 1)), Gt.mkdir(ne, T, 0), 0;
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, Qd: function(k, ne, T, y) {
        try {
          ne = sr.getStr(ne);
          var N = 256 & y, b = 4096 & y;
          return y &= -6401, ne = sr.calculateAt(k, ne, b), sr.doStat(N ? Gt.lstat : Gt.stat, ne, T);
        } catch (X) {
          if (Gt === void 0 || X.name !== "ErrnoError")
            throw X;
          return -X.errno;
        }
      }, Sb: function(k, ne, T, y) {
        sr.varargs = y;
        try {
          ne = sr.getStr(ne), ne = sr.calculateAt(k, ne);
          var N = y ? sr.get() : 0;
          return Gt.open(ne, T, N).fd;
        } catch (b) {
          if (Gt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, bf: function(k) {
        try {
          if (k == 0)
            throw new Gt.ErrnoError(21);
          var ne = Ds.createPipe();
          return Ir[k >> 2] = ne.readable_fd, Ir[k + 4 >> 2] = ne.writable_fd, 0;
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return -T.errno;
        }
      }, gc: function(k, ne, T, y) {
        try {
          var N, b, X;
          return ne = sr.getStr(ne), ne = sr.calculateAt(k, ne), y <= 0 ? -28 : (N = Gt.readlink(ne), b = Math.min(y, oo(N)), X = gs[T + b], Qs(N, T, y + 1), gs[T + b] = X, b);
        } catch (J) {
          if (Gt === void 0 || J.name !== "ErrnoError")
            throw J;
          return -J.errno;
        }
      }, vc: function(k, ne, T, y) {
        try {
          return ne = sr.getStr(ne), y = sr.getStr(y), ne = sr.calculateAt(k, ne), y = sr.calculateAt(T, y), Gt.rename(ne, y), 0;
        } catch (N) {
          if (Gt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, tc: function(k) {
        try {
          return k = sr.getStr(k), Gt.rmdir(k), 0;
        } catch (ne) {
          if (Gt === void 0 || ne.name !== "ErrnoError")
            throw ne;
          return -ne.errno;
        }
      }, $d: function(k, ne) {
        try {
          return k = sr.getStr(k), sr.doStat(Gt.stat, k, ne);
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return -T.errno;
        }
      }, rc: function(k, ne, T) {
        try {
          return k = sr.getStr(k), Ir[T + 4 >> 2] = 4096, Ir[T + 40 >> 2] = 4096, Ir[T + 8 >> 2] = 1e6, Ir[T + 12 >> 2] = 5e5, Ir[T + 16 >> 2] = 5e5, Ir[T + 20 >> 2] = Gt.nextInode, Ir[T + 24 >> 2] = 1e6, Ir[T + 28 >> 2] = 42, Ir[T + 44 >> 2] = 2, Ir[T + 36 >> 2] = 255, 0;
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, wc: function(k, ne, T) {
        try {
          return ne = sr.getStr(ne), ne = sr.calculateAt(k, ne), T === 0 ? Gt.unlink(ne) : T === 512 ? Gt.rmdir(ne) : ro("Invalid flags passed to unlinkat"), 0;
        } catch (y) {
          if (Gt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, kc: function(k, ne, T, y) {
        try {
          var N, b;
          return ne = sr.getStr(ne), ne = sr.calculateAt(k, ne, !0), b = T ? (N = 1e3 * Hs(T) + Ir[T + 8 >> 2] / 1e6, 1e3 * Hs(T += 16) + Ir[T + 8 >> 2] / 1e6) : N = Date.now(), Gt.utime(ne, N, b), 0;
        } catch (X) {
          if (Gt === void 0 || X.name !== "ErrnoError")
            throw X;
          return -X.errno;
        }
      }, Ie: function() {
        return 1;
      }, Le: function() {
        bo = !1, ss = 0;
      }, Ue: function() {
        throw 1 / 0;
      }, ge: function(N, b, T) {
        var N = vt(N, b), b = new Date(1e3 * N), N = (Ir[T >> 2] = b.getSeconds(), Ir[T + 4 >> 2] = b.getMinutes(), Ir[T + 8 >> 2] = b.getHours(), Ir[T + 12 >> 2] = b.getDate(), Ir[T + 16 >> 2] = b.getMonth(), Ir[T + 20 >> 2] = b.getFullYear() - 1900, Ir[T + 24 >> 2] = b.getDay(), 0 | Xr(b)), N = (Ir[T + 28 >> 2] = N, Ir[T + 36 >> 2] = -60 * b.getTimezoneOffset(), new Date(b.getFullYear(), 0, 1)), y = new Date(b.getFullYear(), 6, 1).getTimezoneOffset(), N = N.getTimezoneOffset(), b = 0 | (y != N && b.getTimezoneOffset() == Math.min(N, y));
        Ir[T + 32 >> 2] = b;
      }, he: function(k) {
        ne = new Date(Ir[k + 20 >> 2] + 1900, Ir[k + 16 >> 2], Ir[k + 12 >> 2], Ir[k + 8 >> 2], Ir[k + 4 >> 2], Ir[k >> 2], 0), T = Ir[k + 32 >> 2], y = ne.getTimezoneOffset(), X = new Date(ne.getFullYear(), 0, 1), N = new Date(ne.getFullYear(), 6, 1).getTimezoneOffset(), X = X.getTimezoneOffset(), b = Math.min(X, N), T < 0 ? Ir[k + 32 >> 2] = +(N != X && b == y) : 0 < T != (b == y) && (X = Math.max(X, N), N = 0 < T ? b : X, ne.setTime(ne.getTime() + 6e4 * (N - y))), Ir[k + 24 >> 2] = ne.getDay(), T = 0 | Xr(ne), Ir[k + 28 >> 2] = T, Ir[k >> 2] = ne.getSeconds(), Ir[k + 4 >> 2] = ne.getMinutes(), Ir[k + 8 >> 2] = ne.getHours(), Ir[k + 12 >> 2] = ne.getDate(), Ir[k + 16 >> 2] = ne.getMonth(), Ir[k + 20 >> 2] = ne.getYear(), b = ne.getTime();
        var ne, T, y, N, b, X = isNaN(b) ? (Jr(61), -1) : b / 1e3;
        return Ln((vr = X, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)), X >>> 0;
      }, Od: function(k, ne, T, y, it, b, X, J) {
        var Ie, Pe, We, it = vt(it, b);
        try {
          return isNaN(it) ? 61 : (Ie = sr.getStreamFromFD(y), We = (Pe = Gt.mmap(Ie, k, it, ne, T)).ptr, Ir[X >> 2] = Pe.allocated, ws[J >> 2] = We, 0);
        } catch (Rt) {
          if (Gt === void 0 || Rt.name !== "ErrnoError")
            throw Rt;
          return -Rt.errno;
        }
      }, Pd: function(k, ne, T, y, N, b, X) {
        b = vt(b, X);
        try {
          if (isNaN(b))
            return 61;
          var J = sr.getStreamFromFD(N);
          2 & T && sr.doMsync(k, J, ne, y, b), Gt.munmap(J);
        } catch (Ie) {
          if (Gt === void 0 || Ie.name !== "ErrnoError")
            throw Ie;
          return -Ie.errno;
        }
      }, ud: function(k, ne, T) {
        var N = (/* @__PURE__ */ new Date()).getFullYear(), y = new Date(N, 0, 1), N = new Date(N, 6, 1), b = y.getTimezoneOffset(), X = N.getTimezoneOffset(), J = Math.max(b, X);
        function Ie(Pe) {
          return Pe = Pe.toTimeString().match(/\(([A-Za-z ]+)\)$/), Pe ? Pe[1] : "GMT";
        }
        ws[k >> 2] = 60 * J, Ir[ne >> 2] = +(b != X), k = Ie(y), J = Ie(N), ne = Gi(k), y = Gi(J), X < b ? (ws[T >> 2] = ne, ws[T + 4 >> 2] = y) : (ws[T >> 2] = y, ws[T + 4 >> 2] = ne);
      }, _: function() {
        ro("");
      }, $a: function() {
        return Date.now();
      }, Oe: zt, ob: fn, De: function(k, ne, T) {
        return fo.copyWithin(k, ne, ne + T);
      }, ff: function(k) {
        var ne = fo.length, T = (k >>>= 0, yo());
        if (!(T < k))
          for (var y, N = 1; N <= 4; N *= 2) {
            var b = ne * (1 + 0.2 / N), b = Math.min(b, k + 100663296);
            if (function(X) {
              X = (X - no.buffer.byteLength + 65535) / 65536;
              try {
                return no.grow(X), Rs(), 1;
              } catch {
              }
            }(Math.min(T, (b = Math.max(k, b)) + ((y = 65536) - b % y) % y)))
              return !0;
          }
        return !1;
      }, nc: function(k, ne) {
        var T = 0;
        return ci().forEach(function(y, N) {
          for (var b = ne + T, X = (ws[k + 4 * N >> 2] = b, y), J = b, Ie = 0; Ie < X.length; ++Ie)
            gs[J++ >> 0] = X.charCodeAt(Ie);
          gs[J >> 0] = 0, T += y.length + 1;
        }), 0;
      }, oc: function(k, ne) {
        var T = ci(), y = (ws[k >> 2] = T.length, 0);
        return T.forEach(function(N) {
          return y += N.length + 1;
        }), ws[ne >> 2] = y, 0;
      }, wa: ms, Sa: function(k) {
        try {
          var ne = sr.getStreamFromFD(k);
          return Gt.close(ne), 0;
        } catch (T) {
          if (Gt === void 0 || T.name !== "ErrnoError")
            throw T;
          return T.errno;
        }
      }, Yb: function(k, ne) {
        try {
          var T = sr.getStreamFromFD(k), y = T.tty ? 2 : Gt.isDir(T.mode) ? 3 : Gt.isLink(T.mode) ? 7 : 4;
          return gs[ne >> 0] = y, xs[ne + 2 >> 1] = 0, ts = [0, (vr = 0, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[ne + 8 >> 2] = ts[0], Ir[ne + 12 >> 2] = ts[1], ts = [0, (vr = 0, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[ne + 16 >> 2] = ts[0], Ir[ne + 20 >> 2] = ts[1], 0;
        } catch (N) {
          if (Gt === void 0 || N.name !== "ErrnoError")
            throw N;
          return N.errno;
        }
      }, ae: function(k, ne, T, Ie, N, b) {
        var X, J, Ie = vt(Ie, N);
        try {
          return isNaN(Ie) ? 61 : (X = sr.getStreamFromFD(k), J = Fo(X, ne, T, Ie), ws[b >> 2] = J, 0);
        } catch (Pe) {
          if (Gt === void 0 || Pe.name !== "ErrnoError")
            throw Pe;
          return Pe.errno;
        }
      }, Gb: function(k, ne, T, y) {
        try {
          var N = sr.getStreamFromFD(k), b = Fo(N, ne, T);
          return ws[y >> 2] = b, 0;
        } catch (X) {
          if (Gt === void 0 || X.name !== "ErrnoError")
            throw X;
          return X.errno;
        }
      }, ie: function(k, X, T, y, N) {
        var b, X = vt(X, T);
        try {
          return isNaN(X) ? 61 : (b = sr.getStreamFromFD(k), Gt.llseek(b, X, y), ts = [b.position >>> 0, (vr = b.position, 1 <= +Math.abs(vr) ? 0 < vr ? +Math.floor(vr / 4294967296) >>> 0 : ~~+Math.ceil((vr - (~~vr >>> 0)) / 4294967296) >>> 0 : 0)], Ir[N >> 2] = ts[0], Ir[N + 4 >> 2] = ts[1], b.getdents && X === 0 && y === 0 && (b.getdents = null), 0);
        } catch (J) {
          if (Gt === void 0 || J.name !== "ErrnoError")
            throw J;
          return J.errno;
        }
      }, sb: function(k, ne, T, y) {
        try {
          var N = function(b, X, J, Ie) {
            for (var Pe = 0, We = 0; We < J; We++) {
              var Rt = ws[X >> 2], it = ws[X + 4 >> 2], Rt = (X += 8, Gt.write(b, gs, Rt, it, Ie));
              if (Rt < 0)
                return -1;
              Pe += Rt, Ie !== void 0 && (Ie += Rt);
            }
            return Pe;
          }(sr.getStreamFromFD(k), ne, T);
          return ws[y >> 2] = N, 0;
        } catch (b) {
          if (Gt === void 0 || b.name !== "ErrnoError")
            throw b;
          return b.errno;
        }
      }, df: function(k, ne) {
        return _s(fo.subarray(k, k + ne)), 0;
      }, ac: function(k, ne) {
        var T = ot();
        try {
          return Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, cb: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, rb: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, We: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, m: function(k, ne) {
        var T = ot();
        try {
          return Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, X: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, u: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Aa: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, A: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, D: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Ja: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, qa: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Zb: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Hb: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Ua: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, ma: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, t: function(k) {
        var ne = ot();
        try {
          return Yn(k)();
        } catch (T) {
          if (Xt(ne), T !== T + 0)
            throw T;
          Mt(1, 0);
        }
      }, ia: function(k, ne) {
        var T = ot();
        try {
          return Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, xe: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Ha: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Ma: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Ve: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do) {
        var _o = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do);
        } catch (Ca) {
          if (Xt(_o), Ca !== Ca + 0)
            throw Ca;
          Mt(1, 0);
        }
      }, ha: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, L: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, T: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, b: function(k, ne) {
        var T = ot();
        try {
          return Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, z: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Q: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, S: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, O: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Z: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, ca: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, ra: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Ya: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Ge: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, tb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Te: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Me: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn) {
        var cr = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn);
        } catch (Cs) {
          if (Xt(cr), Cs !== Cs + 0)
            throw Cs;
          Mt(1, 0);
        }
      }, $b: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, _a: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Da: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, ya: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Wb: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, w: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Ee: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, c: function(k, ne, T) {
        var y = ot();
        try {
          return Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, E: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Vb: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, fa: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Ea: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, La: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, jb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, Ze: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Xb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, hb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (Xt(Vn), vn !== vn + 0)
            throw vn;
          Mt(1, 0);
        }
      }, Ob: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Rb: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, ub: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, md: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return oi(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Xe: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Tb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Ce: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, pa: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Qa: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, V: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, ab: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Pb: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, _b: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, d: function(k, ne, T, y) {
        var N = ot();
        try {
          return Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Y: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, re: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, mb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Za: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (Xt(gn), Pn !== Pn + 0)
            throw Pn;
          Mt(1, 0);
        }
      }, Ia: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, Mb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Nb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Ne: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Fa: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, pb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, k: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Ba: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Se: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Ib: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, pe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Lb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, aa: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, ef: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Ub: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, n: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Wa: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Fb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Ae: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (Xt(Vn), vn !== vn + 0)
            throw vn;
          Mt(1, 0);
        }
      }, Be: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (Xt(gn), Pn !== Pn + 0)
            throw Pn;
          Mt(1, 0);
        }
      }, _e: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, se: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Ka: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Pa: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, s: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Fe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, ze: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, le: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, Re: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (Xt(Pn), Vn !== Vn + 0)
            throw Vn;
          Mt(1, 0);
        }
      }, te: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, ve: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, F: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, oe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Va: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, Cb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (Xt(Pn), Vn !== Vn + 0)
            throw Vn;
          Mt(1, 0);
        }
      }, we: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, H: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Pe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Je: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Kb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, M: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, ba: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, za: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, ea: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, va: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, la: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, ke: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, Ca: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, gb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Oa: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (Xt(gn), Pn !== Pn + 0)
            throw Pn;
          Mt(1, 0);
        }
      }, pc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        var vn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
        } catch (Zn) {
          if (Xt(vn), Zn !== Zn + 0)
            throw Zn;
          Mt(1, 0);
        }
      }, qe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = ot();
        try {
          return Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (Xt(Zn), cr !== cr + 0)
            throw cr;
          Mt(1, 0);
        }
      }, zc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = ot();
        try {
          return Ha(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (Xt(Vn), vn !== vn + 0)
            throw vn;
          Mt(1, 0);
        }
      }, hd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        var vn = ot();
        try {
          return Ba(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
        } catch (Zn) {
          if (Xt(vn), Zn !== Zn + 0)
            throw Zn;
          Mt(1, 0);
        }
      }, yd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = ot();
        try {
          return Ya(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (Xt(Zn), cr !== cr + 0)
            throw cr;
          Mt(1, 0);
        }
      }, zd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = ot();
        try {
          return Ui(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (Xt(gn), Pn !== Pn + 0)
            throw Pn;
          Mt(1, 0);
        }
      }, Fc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = ot();
        try {
          return Ua(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (Xt(Pn), Vn !== Vn + 0)
            throw Vn;
          Mt(1, 0);
        }
      }, Oc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Hi(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Xc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          return xr(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, Yc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          return hr(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Qc: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Jo(k, ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, wd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return fi(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Uc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return co(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, sd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return si(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, vd: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Na(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Gc: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return ua(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Cd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return ca(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Sd: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return eo(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Kd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return Ao(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Nc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return zs(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Bd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Aa(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Rc: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Yo(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Vc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return fs(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, qd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return lo(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, ld: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return ni(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, gd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return je(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, td: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return fa(k, ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Xd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Ko(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Yd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return Gs(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Wd: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Ni(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, rd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return uo(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Dc: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return mi(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, pd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return za(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, ad: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return wn(k, ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Hd: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          return Er(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Jd: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Ga(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Ad: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          return La(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, _c: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Hn(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, cd: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          return An(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Wc: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          return Is(k, ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, id: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Ki(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Zd: function(k, ne, T, y) {
        var N = ot();
        try {
          return Sr(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Pc: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return js(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, _d: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Ws(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, nd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Mi(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Vd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return zi(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Bb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return Je(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Ac: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Wr(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Jc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          return ga(k, ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Dd: function(k, ne, T) {
        var y = ot();
        try {
          return da(k, ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Ud: function(k, ne, T, y) {
        var N = ot();
        try {
          return Vs(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Td: function(k) {
        var ne = ot();
        try {
          return di(k);
        } catch (T) {
          if (Xt(ne), T !== T + 0)
            throw T;
          Mt(1, 0);
        }
      }, de: function(k, ne) {
        var T = ot();
        try {
          return Bs(k, ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, ce: function(k, ne, T) {
        var y = ot();
        try {
          return qs(k, ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, Md: function(k, ne, T, y) {
        var N = ot();
        try {
          return Xi(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Kc: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Sa(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, fe: function(k, ne, T, y, N) {
        var b = ot();
        try {
          return Zr(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, od: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o) {
        var Ca = ot();
        try {
          return Ta(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o);
        } catch (ma) {
          if (Xt(Ca), ma !== ma + 0)
            throw ma;
          Mt(1, 0);
        }
      }, bd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Cr(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, $c: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          return zr(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Ic: function(k, ne, T, y) {
        var N = ot();
        try {
          return Go(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Mc: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          return Ea(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Cc: function(k, ne, T, y) {
        var N = ot();
        try {
          return $a(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, l: function(k) {
        var ne = ot();
        try {
          Yn(k)();
        } catch (T) {
          if (Xt(ne), T !== T + 0)
            throw T;
          Mt(1, 0);
        }
      }, ja: function(k, ne) {
        var T = ot();
        try {
          Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, ne: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Db: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, g: function(k, ne) {
        var T = ot();
        try {
          Yn(k)(ne);
        } catch (y) {
          if (Xt(T), y !== y + 0)
            throw y;
          Mt(1, 0);
        }
      }, R: function(k, ne, T) {
        var y = ot();
        try {
          Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, I: function(k, ne, T, y) {
        var N = ot();
        try {
          Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, W: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, da: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, vb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, ye: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, fb: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, kb: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, sa: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, N: function(k, ne, T, y) {
        var N = ot();
        try {
          Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, lb: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, $: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Eb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, h: function(k, ne, T) {
        var y = ot();
        try {
          Yn(k)(ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, C: function(k, ne, T, y) {
        var N = ot();
        try {
          Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, J: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, ga: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Ta: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Xa: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Ye: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, nb: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, bc: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, K: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, eb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, f: function(k, ne, T, y) {
        var N = ot();
        try {
          Yn(k)(ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, ka: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, bb: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, cf: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, j: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Yn(k)(ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Ra: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, xa: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, db: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, ec: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, ib: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, wb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, ta: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, Na: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Qb: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, o: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Yn(k)(ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, fc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr) {
        var Cs = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr);
        } catch (Br) {
          if (Xt(Cs), Br !== Br + 0)
            throw Br;
          Mt(1, 0);
        }
      }, zb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (Xt(Kt), _n !== _n + 0)
            throw _n;
          Mt(1, 0);
        }
      }, yb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, Jb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, q: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Yn(k)(ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, G: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, me: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, U: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, He: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Qe: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, P: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, na: function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        var it = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (Xt(it), Rt !== Rt + 0)
            throw Rt;
          Mt(1, 0);
        }
      }, qb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (Xt(Rt), Dt !== Dt + 0)
            throw Dt;
          Mt(1, 0);
        }
      }, dc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (Xt(Dt), Kt !== Kt + 0)
            throw Kt;
          Mt(1, 0);
        }
      }, xb: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (Xt(_n), gn !== gn + 0)
            throw gn;
          Mt(1, 0);
        }
      }, Ga: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (Xt(gn), Pn !== Pn + 0)
            throw Pn;
          Mt(1, 0);
        }
      }, cc: function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = ot();
        try {
          Yn(k)(ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (Xt(Vn), vn !== vn + 0)
            throw vn;
          Mt(1, 0);
        }
      }, xd: function(k, ne, T, y, N, b, X, J, Ie) {
        var Pe = ot();
        try {
          Qi(k, ne, T, y, N, b, X, J, Ie);
        } catch (We) {
          if (Xt(Pe), We !== We + 0)
            throw We;
          Mt(1, 0);
        }
      }, Ld: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          gi(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, Bc: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          Oa(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Id: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Bi(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, dd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          Fn(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Gd: function(k, ne, T, y, N) {
        var b = ot();
        try {
          vo(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Ec: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          vi(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, ee: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          At(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, jd: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          ja(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Zc: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          un(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Nd: function(k, ne, T, y) {
        var N = ot();
        try {
          ko(k, ne, T, y);
        } catch (b) {
          if (Xt(N), b !== b + 0)
            throw b;
          Mt(1, 0);
        }
      }, Hc: function(k, ne, T, y, N) {
        var b = ot();
        try {
          Ji(k, ne, T, y, N);
        } catch (X) {
          if (Xt(b), X !== X + 0)
            throw X;
          Mt(1, 0);
        }
      }, Sc: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          es(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, fd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          qo(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, Lc: function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        var We = ot();
        try {
          sa(k, ne, T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (Xt(We), it !== it + 0)
            throw it;
          Mt(1, 0);
        }
      }, Tc: function(k, ne, T, y, N, b, X) {
        var J = ot();
        try {
          Qn(k, ne, T, y, N, b, X);
        } catch (Ie) {
          if (Xt(J), Ie !== Ie + 0)
            throw Ie;
          Mt(1, 0);
        }
      }, kd: function(k, ne, T, y, N, b) {
        var X = ot();
        try {
          ha(k, ne, T, y, N, b);
        } catch (J) {
          if (Xt(X), J !== J + 0)
            throw J;
          Mt(1, 0);
        }
      }, ed: function(k, ne, T, y, N, b, X, J) {
        var Ie = ot();
        try {
          qt(k, ne, T, y, N, b, X, J);
        } catch (Pe) {
          if (Xt(Ie), Pe !== Pe + 0)
            throw Pe;
          Mt(1, 0);
        }
      }, Ed: function(k, ne, T) {
        var y = ot();
        try {
          $i(k, ne, T);
        } catch (N) {
          if (Xt(y), N !== N + 0)
            throw N;
          Mt(1, 0);
        }
      }, r: function(k) {
        return k;
      }, $e: Ri, oa: zo, mc: function(k, ne, T, y, N) {
        return zo(k, ne, T, y);
      } }), qe = function() {
        var k, ne, T, y = { a: Ye };
        function N(b, X) {
          return qe = b.exports, no = qe.gf, Rs(), Lo = qe.hh, b = qe.hf, xi.unshift(b), As(), qe;
        }
        if (Wo(), Pt.instantiateWasm)
          try {
            return Pt.instantiateWasm(y, N);
          } catch (b) {
            ii("Module.instantiateWasm callback failed with error: ".concat(b)), _t(b);
          }
        return k = Mo, ne = y, T = function(b) {
          N(b.instance);
        }, (Ps || typeof WebAssembly.instantiateStreaming != "function" || kr(k) || Us(k) || So || typeof fetch != "function" ? Wi(k, ne, T) : fetch(k, { credentials: "same-origin" }).then(function(b) {
          return WebAssembly.instantiateStreaming(b, ne).then(T, function(X) {
            return ii("wasm streaming compile failed: ".concat(X)), ii("falling back to ArrayBuffer instantiation"), Wi(k, ne, T);
          });
        })).catch(_t), {};
      }(), Nt = (Pt._CPLSetConfigOption = function(k, ne) {
        return (Pt._CPLSetConfigOption = qe.jf)(k, ne);
      }, Pt._CPLSetThreadLocalConfigOption = function(k, ne) {
        return (Pt._CPLSetThreadLocalConfigOption = qe.kf)(k, ne);
      }, Pt._CPLError = function(k, ne, T, y) {
        return (Pt._CPLError = qe.lf)(k, ne, T, y);
      }, Pt._CPLErrorReset = function() {
        return (Pt._CPLErrorReset = qe.mf)();
      }, Pt._CPLGetLastErrorNo = function() {
        return (Pt._CPLGetLastErrorNo = qe.nf)();
      }, Pt._CPLGetLastErrorType = function() {
        return (Pt._CPLGetLastErrorType = qe.of)();
      }, Pt._CPLGetLastErrorMsg = function() {
        return (Pt._CPLGetLastErrorMsg = qe.pf)();
      }, Pt._CPLQuietErrorHandler = function(k, ne, T) {
        return (Pt._CPLQuietErrorHandler = qe.qf)(k, ne, T);
      }, Pt._CPLSetErrorHandler = function(k) {
        return (Pt._CPLSetErrorHandler = qe.rf)(k);
      }, Pt._CSLCount = function(k) {
        return (Pt._CSLCount = qe.sf)(k);
      }, Pt._CPLAtof = function(k) {
        return (Pt._CPLAtof = qe.tf)(k);
      }, Pt._GDALSuggestedWarpOutput = function(k, ne, T, y, N, b) {
        return (Pt._GDALSuggestedWarpOutput = qe.uf)(k, ne, T, y, N, b);
      }, Pt._GDALGenImgProjTransform = function(k, ne, T, y, N, b, X) {
        return (Pt._GDALGenImgProjTransform = qe.vf)(k, ne, T, y, N, b, X);
      }, Pt._GDALCreateGenImgProjTransformer = function(k, ne, T, y, N, b, X) {
        return (Pt._GDALCreateGenImgProjTransformer = qe.wf)(k, ne, T, y, N, b, X);
      }, Pt._GDALCreateGenImgProjTransformer2 = function(k, ne, T) {
        return (Pt._GDALCreateGenImgProjTransformer2 = qe.xf)(k, ne, T);
      }, Pt._GDALDestroyGenImgProjTransformer = function(k) {
        return (Pt._GDALDestroyGenImgProjTransformer = qe.yf)(k);
      }, Pt._GDALInvGeoTransform = function(k, ne) {
        return (Pt._GDALInvGeoTransform = qe.zf)(k, ne);
      }, Pt._GDALReprojectImage = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (Pt._GDALReprojectImage = qe.Af)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Pt._OSRNewSpatialReference = function(k) {
        return (Pt._OSRNewSpatialReference = qe.Bf)(k);
      }, Pt._OSRDestroySpatialReference = function(k) {
        return (Pt._OSRDestroySpatialReference = qe.Cf)(k);
      }, Pt._OSRExportToWkt = function(k, ne) {
        return (Pt._OSRExportToWkt = qe.Df)(k, ne);
      }, Pt._OSRSetFromUserInput = function(k, ne) {
        return (Pt._OSRSetFromUserInput = qe.Ef)(k, ne);
      }, Pt._OSRImportFromEPSG = function(k, ne) {
        return (Pt._OSRImportFromEPSG = qe.Ff)(k, ne);
      }, Pt._OSRSetAxisMappingStrategy = function(k, ne) {
        return (Pt._OSRSetAxisMappingStrategy = qe.Gf)(k, ne);
      }, Pt._OCTDestroyCoordinateTransformation = function(k) {
        return (Pt._OCTDestroyCoordinateTransformation = qe.Hf)(k);
      }, Pt._OCTNewCoordinateTransformation = function(k, ne) {
        return (Pt._OCTNewCoordinateTransformation = qe.If)(k, ne);
      }, Pt._OCTTransform = function(k, ne, T, y, N) {
        return (Pt._OCTTransform = qe.Jf)(k, ne, T, y, N);
      }, Pt._GDALAllRegister = function() {
        return (Pt._GDALAllRegister = qe.Kf)();
      }, Pt._OGRGetDriverCount = function() {
        return (Pt._OGRGetDriverCount = qe.Lf)();
      }, Pt._OGRGetDriver = function(k) {
        return (Pt._OGRGetDriver = qe.Mf)(k);
      }, Pt._OGR_L_GetFeatureCount = function(k, ne) {
        return (Pt._OGR_L_GetFeatureCount = qe.Nf)(k, ne);
      }, Pt._OGR_L_GetName = function(k) {
        return (Pt._OGR_L_GetName = qe.Of)(k);
      }, Pt._OGR_DS_GetLayerCount = function(k) {
        return (Pt._OGR_DS_GetLayerCount = qe.Pf)(k);
      }, Pt._OGR_DS_GetLayer = function(k, ne) {
        return (Pt._OGR_DS_GetLayer = qe.Qf)(k, ne);
      }, Pt._OGR_DS_GetName = function(k) {
        return (Pt._OGR_DS_GetName = qe.Rf)(k);
      }, Pt._OGR_DS_GetDriver = function(k) {
        return (Pt._OGR_DS_GetDriver = qe.Sf)(k);
      }, Pt._OGR_Dr_GetName = function(k) {
        return (Pt._OGR_Dr_GetName = qe.Tf)(k);
      }, Pt._GDALCreate = function(k, ne, T, y, N, b, X) {
        return (Pt._GDALCreate = qe.Uf)(k, ne, T, y, N, b, X);
      }, Pt._GDALCreateCopy = function(k, ne, T, y, N, b, X) {
        return (Pt._GDALCreateCopy = qe.Vf)(k, ne, T, y, N, b, X);
      }, Pt._GDALGetDriverShortName = function(k) {
        return (Pt._GDALGetDriverShortName = qe.Wf)(k);
      }, Pt._GDALGetDriverLongName = function(k) {
        return (Pt._GDALGetDriverLongName = qe.Xf)(k);
      }, Pt._GDALGetDriverCount = function() {
        return (Pt._GDALGetDriverCount = qe.Yf)();
      }, Pt._GDALGetDriver = function(k) {
        return (Pt._GDALGetDriver = qe.Zf)(k);
      }, Pt._GDALGetDriverByName = function(k) {
        return (Pt._GDALGetDriverByName = qe._f)(k);
      }, Pt._GDALGetRasterXSize = function(k) {
        return (Pt._GDALGetRasterXSize = qe.$f)(k);
      }, Pt._GDALGetRasterYSize = function(k) {
        return (Pt._GDALGetRasterYSize = qe.ag)(k);
      }, Pt._GDALGetRasterBand = function(k, ne) {
        return (Pt._GDALGetRasterBand = qe.bg)(k, ne);
      }, Pt._GDALGetRasterCount = function(k) {
        return (Pt._GDALGetRasterCount = qe.cg)(k);
      }, Pt._GDALGetSpatialRef = function(k) {
        return (Pt._GDALGetSpatialRef = qe.dg)(k);
      }, Pt._GDALGetProjectionRef = function(k) {
        return (Pt._GDALGetProjectionRef = qe.eg)(k);
      }, Pt._GDALSetProjection = function(k, ne) {
        return (Pt._GDALSetProjection = qe.fg)(k, ne);
      }, Pt._GDALGetGeoTransform = function(k, ne) {
        return (Pt._GDALGetGeoTransform = qe.gg)(k, ne);
      }, Pt._GDALSetGeoTransform = function(k, ne) {
        return (Pt._GDALSetGeoTransform = qe.hg)(k, ne);
      }, Pt._GDALGetDatasetDriver = function(k) {
        return (Pt._GDALGetDatasetDriver = qe.ig)(k);
      }, Pt._GDALGetFileList = function(k) {
        return (Pt._GDALGetFileList = qe.jg)(k);
      }, Pt._GDALOpen = function(k, ne) {
        return (Pt._GDALOpen = qe.kg)(k, ne);
      }, Pt._GDALOpenEx = function(k, ne, T, y, N) {
        return (Pt._GDALOpenEx = qe.lg)(k, ne, T, y, N);
      }, Pt._GDALClose = function(k) {
        return (Pt._GDALClose = qe.mg)(k);
      }, Pt._GDALDatasetGetLayerCount = function(k) {
        return (Pt._GDALDatasetGetLayerCount = qe.ng)(k);
      }, Pt._GDALDatasetGetLayer = function(k, ne) {
        return (Pt._GDALDatasetGetLayer = qe.og)(k, ne);
      }, Pt._GDALGetRasterDataType = function(k) {
        return (Pt._GDALGetRasterDataType = qe.pg)(k);
      }, Pt._GDALGetRasterNoDataValue = function(k, ne) {
        return (Pt._GDALGetRasterNoDataValue = qe.qg)(k, ne);
      }, Pt._GDALGetRasterMaximum = function(k, ne) {
        return (Pt._GDALGetRasterMaximum = qe.rg)(k, ne);
      }, Pt._GDALGetRasterMinimum = function(k, ne) {
        return (Pt._GDALGetRasterMinimum = qe.sg)(k, ne);
      }, Pt._GDALGetRasterStatistics = function(k, ne, T, y, N, b, X) {
        return (Pt._GDALGetRasterStatistics = qe.tg)(k, ne, T, y, N, b, X);
      }, Pt._GDALSetCacheMax = function(k) {
        return (Pt._GDALSetCacheMax = qe.ug)(k);
      }, Pt._GDALGetDescription = function(k) {
        return (Pt._GDALGetDescription = qe.vg)(k);
      }, Pt._GDALGetMetadataItem = function(k, ne, T) {
        return (Pt._GDALGetMetadataItem = qe.wg)(k, ne, T);
      }, Pt._GDALInfo = function(k, ne) {
        return (Pt._GDALInfo = qe.xg)(k, ne);
      }, Pt._GDALInfoOptionsNew = function(k, ne) {
        return (Pt._GDALInfoOptionsNew = qe.yg)(k, ne);
      }, Pt._GDALInfoOptionsFree = function(k) {
        return (Pt._GDALInfoOptionsFree = qe.zg)(k);
      }, Pt._GDALBuildVRT = function(k, ne, T, y, N, b) {
        return (Pt._GDALBuildVRT = qe.Ag)(k, ne, T, y, N, b);
      }, Pt._GDALBuildVRTOptionsFree = function(k) {
        return (Pt._GDALBuildVRTOptionsFree = qe.Bg)(k);
      }, Pt._GDALBuildVRTOptionsNew = function(k, ne) {
        return (Pt._GDALBuildVRTOptionsNew = qe.Cg)(k, ne);
      }, Pt._GDALTranslate = function(k, ne, T, y) {
        return (Pt._GDALTranslate = qe.Dg)(k, ne, T, y);
      }, Pt._GDALTranslateOptionsNew = function(k, ne) {
        return (Pt._GDALTranslateOptionsNew = qe.Eg)(k, ne);
      }, Pt._GDALTranslateOptionsFree = function(k) {
        return (Pt._GDALTranslateOptionsFree = qe.Fg)(k);
      }, Pt._GDALRasterize = function(k, ne, T, y, N) {
        return (Pt._GDALRasterize = qe.Gg)(k, ne, T, y, N);
      }, Pt._GDALRasterizeOptionsNew = function(k, ne) {
        return (Pt._GDALRasterizeOptionsNew = qe.Hg)(k, ne);
      }, Pt._GDALRasterizeOptionsFree = function(k) {
        return (Pt._GDALRasterizeOptionsFree = qe.Ig)(k);
      }, Pt._GDALWarp = function(k, ne, T, y, N, b) {
        return (Pt._GDALWarp = qe.Jg)(k, ne, T, y, N, b);
      }, Pt._GDALWarpAppOptionsNew = function(k, ne) {
        return (Pt._GDALWarpAppOptionsNew = qe.Kg)(k, ne);
      }, Pt._GDALWarpAppOptionsFree = function(k) {
        return (Pt._GDALWarpAppOptionsFree = qe.Lg)(k);
      }, Pt._GDALWarpAppOptionsSetProgress = function(k, ne, T) {
        return (Pt._GDALWarpAppOptionsSetProgress = qe.Mg)(k, ne, T);
      }, Pt._GDALVectorInfoOptionsFree = function(k) {
        return (Pt._GDALVectorInfoOptionsFree = qe.Ng)(k);
      }, Pt._GDALVectorInfo = function(k, ne) {
        return (Pt._GDALVectorInfo = qe.Og)(k, ne);
      }, Pt._GDALVectorInfoOptionsNew = function(k, ne) {
        return (Pt._GDALVectorInfoOptionsNew = qe.Pg)(k, ne);
      }, Pt._GDALVectorTranslate = function(k, ne, T, y, N, b) {
        return (Pt._GDALVectorTranslate = qe.Qg)(k, ne, T, y, N, b);
      }, Pt._GDALVectorTranslateOptionsNew = function(k, ne) {
        return (Pt._GDALVectorTranslateOptionsNew = qe.Rg)(k, ne);
      }, Pt._GDALVectorTranslateOptionsFree = function(k) {
        return (Pt._GDALVectorTranslateOptionsFree = qe.Sg)(k);
      }, Pt._GDALDEMProcessing = function(k, ne, T, y, N, b) {
        return (Pt._GDALDEMProcessing = qe.Tg)(k, ne, T, y, N, b);
      }, Pt._GDALDEMProcessingOptionsNew = function(k, ne) {
        return (Pt._GDALDEMProcessingOptionsNew = qe.Ug)(k, ne);
      }, Pt._GDALDEMProcessingOptionsFree = function(k) {
        return (Pt._GDALDEMProcessingOptionsFree = qe.Vg)(k);
      }, function() {
        return (Nt = qe.Wg)();
      }), mt = Pt._malloc = function(k) {
        return (mt = Pt._malloc = qe.Xg)(k);
      }, pn = (Pt._free = function(k) {
        return (Pt._free = qe.Yg)(k);
      }, function(k, ne) {
        return (pn = qe.Zg)(k, ne);
      }), Mt = function(k, ne) {
        return (Mt = qe._g)(k, ne);
      }, Ln = function(k) {
        return (Ln = qe.$g)(k);
      }, ot = function() {
        return (ot = qe.ah)();
      }, Xt = function(k) {
        return (Xt = qe.bh)(k);
      }, sn = function(k) {
        return (sn = qe.ch)(k);
      }, dn = function(k) {
        return (dn = qe.dh)(k);
      }, Ar = function(k) {
        return (Ar = qe.eh)(k);
      }, yr = function(k, ne, T) {
        return (yr = qe.fh)(k, ne, T);
      }, Pr = function(k) {
        return (Pr = qe.gh)(k);
      }, Zr = Pt.dynCall_jiiii = function(k, ne, T, y, N) {
        return (Zr = Pt.dynCall_jiiii = qe.ih)(k, ne, T, y, N);
      }, qs = Pt.dynCall_jii = function(k, ne, T) {
        return (qs = Pt.dynCall_jii = qe.jh)(k, ne, T);
      }, Ws = Pt.dynCall_iiji = function(k, ne, T, y, N) {
        return (Ws = Pt.dynCall_iiji = qe.kh)(k, ne, T, y, N);
      }, Bs = Pt.dynCall_ji = function(k, ne) {
        return (Bs = Pt.dynCall_ji = qe.lh)(k, ne);
      }, Sr = Pt.dynCall_iij = function(k, ne, T, y) {
        return (Sr = Pt.dynCall_iij = qe.mh)(k, ne, T, y);
      }, Wr = Pt.dynCall_iijj = function(k, ne, T, y, N, b) {
        return (Wr = Pt.dynCall_iijj = qe.nh)(k, ne, T, y, N, b);
      }, lo = Pt.dynCall_iiiij = function(k, ne, T, y, N, b) {
        return (lo = Pt.dynCall_iiiij = qe.oh)(k, ne, T, y, N, b);
      }, uo = Pt.dynCall_iiiji = function(k, ne, T, y, N, b) {
        return (uo = Pt.dynCall_iiiji = qe.ph)(k, ne, T, y, N, b);
      }, Vs = Pt.dynCall_iji = function(k, ne, T, y) {
        return (Vs = Pt.dynCall_iji = qe.qh)(k, ne, T, y);
      }, Gs = Pt.dynCall_iiiijjjii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Gs = Pt.dynCall_iiiijjjii = qe.rh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, Ni = Pt.dynCall_iiij = function(k, ne, T, y, N) {
        return (Ni = Pt.dynCall_iiij = qe.sh)(k, ne, T, y, N);
      }, zi = Pt.dynCall_iijiiii = function(k, ne, T, y, N, b, X, J) {
        return (zi = Pt.dynCall_iijiiii = qe.th)(k, ne, T, y, N, b, X, J);
      }, Ko = Pt.dynCall_iiiijjji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (Ko = Pt.dynCall_iiiijjji = qe.uh)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, di = Pt.dynCall_j = function(k) {
        return (di = Pt.dynCall_j = qe.vh)(k);
      }, eo = Pt.dynCall_iiiiij = function(k, ne, T, y, N, b, X) {
        return (eo = Pt.dynCall_iiiiij = qe.wh)(k, ne, T, y, N, b, X);
      }, ua = Pt.dynCall_iiiiiijj = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (ua = Pt.dynCall_iiiiiijj = qe.xh)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, qo = Pt.dynCall_vijii = function(k, ne, T, y, N, b) {
        return (qo = Pt.dynCall_vijii = qe.yh)(k, ne, T, y, N, b);
      }, Mi = Pt.dynCall_iijii = function(k, ne, T, y, N, b) {
        return (Mi = Pt.dynCall_iijii = qe.zh)(k, ne, T, y, N, b);
      }, si = Pt.dynCall_iiiiiij = function(k, ne, T, y, N, b, X, J) {
        return (si = Pt.dynCall_iiiiiij = qe.Ah)(k, ne, T, y, N, b, X, J);
      }, ko = Pt.dynCall_vij = function(k, ne, T, y) {
        return (ko = Pt.dynCall_vij = qe.Bh)(k, ne, T, y);
      }, ni = Pt.dynCall_iiiiji = function(k, ne, T, y, N, b, X) {
        return (ni = Pt.dynCall_iiiiji = qe.Ch)(k, ne, T, y, N, b, X);
      }, da = Pt.dynCall_ij = function(k, ne, T) {
        return (da = Pt.dynCall_ij = qe.Dh)(k, ne, T);
      }, vi = Pt.dynCall_viiji = function(k, ne, T, y, N, b) {
        return (vi = Pt.dynCall_viiji = qe.Eh)(k, ne, T, y, N, b);
      }, fa = Pt.dynCall_iiiijji = function(k, ne, T, y, N, b, X, J, Ie) {
        return (fa = Pt.dynCall_iiiijji = qe.Fh)(k, ne, T, y, N, b, X, J, Ie);
      }, vo = Pt.dynCall_viij = function(k, ne, T, y, N) {
        return (vo = Pt.dynCall_viij = qe.Gh)(k, ne, T, y, N);
      }, Xi = Pt.dynCall_jiii = function(k, ne, T, y) {
        return (Xi = Pt.dynCall_jiii = qe.Hh)(k, ne, T, y);
      }, gi = Pt.dynCall_viiiij = function(k, ne, T, y, N, b, X) {
        return (gi = Pt.dynCall_viiiij = qe.Ih)(k, ne, T, y, N, b, X);
      }, Ao = Pt.dynCall_iiiiiji = function(k, ne, T, y, N, b, X, J) {
        return (Ao = Pt.dynCall_iiiiiji = qe.Jh)(k, ne, T, y, N, b, X, J);
      }, Bi = Pt.dynCall_viiiji = function(k, ne, T, y, N, b, X) {
        return (Bi = Pt.dynCall_viiiji = qe.Kh)(k, ne, T, y, N, b, X);
      }, Ga = Pt.dynCall_iiijiiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (Ga = Pt.dynCall_iiijiiiiii = qe.Lh)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, Go = Pt.dynCall_jij = function(k, ne, T, y) {
        return (Go = Pt.dynCall_jij = qe.Mh)(k, ne, T, y);
      }, $i = Pt.dynCall_vj = function(k, ne, T) {
        return ($i = Pt.dynCall_vj = qe.Nh)(k, ne, T);
      }, Ya = Pt.dynCall_iiiiiiiiiiiiijjji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        return (Ya = Pt.dynCall_iiiiiiiiiiiiijjji = qe.Oh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
      }, Ui = Pt.dynCall_iiiiiiiiiiijji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        return (Ui = Pt.dynCall_iiiiiiiiiiijji = qe.Ph)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
      }, Aa = Pt.dynCall_iiiiijiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Aa = Pt.dynCall_iiiiijiiiii = qe.Qh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, La = Pt.dynCall_iiijiiiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (La = Pt.dynCall_iiijiiiiiii = qe.Rh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, za = Pt.dynCall_iiijiii = function(k, ne, T, y, N, b, X, J) {
        return (za = Pt.dynCall_iiijiii = qe.Sh)(k, ne, T, y, N, b, X, J);
      }, Ta = Pt.dynCall_jiiiiiiiiiiiiiiiiiiiiiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o) {
        return (Ta = Pt.dynCall_jiiiiiiiiiiiiiiiiiiiiiiiii = qe.Th)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o);
      }, oi = Pt.dynCall_iiiddddji = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (oi = Pt.dynCall_iiiddddji = qe.Uh)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Na = Pt.dynCall_iiiiiijii = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (Na = Pt.dynCall_iiiiiijii = qe.Vh)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Qi = Pt.dynCall_viiiiiji = function(k, ne, T, y, N, b, X, J, Ie) {
        return (Qi = Pt.dynCall_viiiiiji = qe.Wh)(k, ne, T, y, N, b, X, J, Ie);
      }, fi = Pt.dynCall_iiiiiiijiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (fi = Pt.dynCall_iiiiiiijiii = qe.Xh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, ha = Pt.dynCall_vijj = function(k, ne, T, y, N, b) {
        return (ha = Pt.dynCall_vijj = qe.Yh)(k, ne, T, y, N, b);
      }, ca = Pt.dynCall_iiiiiijjii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (ca = Pt.dynCall_iiiiiijjii = qe.Zh)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, Ki = Pt.dynCall_iiijjiji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (Ki = Pt.dynCall_iiijjiji = qe._h)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, Ba = Pt.dynCall_iiiiiiiiiiiiijjii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        return (Ba = Pt.dynCall_iiiiiiiiiiiiijjii = qe.$h)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
      }, je = Pt.dynCall_iiiijiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (je = Pt.dynCall_iiiijiiiii = qe.ai)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, Je = Pt.dynCall_iijiiiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (Je = Pt.dynCall_iijiiiiiii = qe.bi)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, At = Pt.dynCall_viijj = function(k, ne, T, y, N, b, X) {
        return (At = Pt.dynCall_viijj = qe.ci)(k, ne, T, y, N, b, X);
      }, qt = Pt.dynCall_vijjj = function(k, ne, T, y, N, b, X, J) {
        return (qt = Pt.dynCall_vijjj = qe.di)(k, ne, T, y, N, b, X, J);
      }, un = Pt.dynCall_viijjji = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (un = Pt.dynCall_viijjji = qe.ei)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, An = Pt.dynCall_iiijj = function(k, ne, T, y, N, b, X) {
        return (An = Pt.dynCall_iiijj = qe.fi)(k, ne, T, y, N, b, X);
      }, Fn = Pt.dynCall_viiijj = function(k, ne, T, y, N, b, X, J) {
        return (Fn = Pt.dynCall_viiijj = qe.gi)(k, ne, T, y, N, b, X, J);
      }, wn = Pt.dynCall_iiijiiii = function(k, ne, T, y, N, b, X, J, Ie) {
        return (wn = Pt.dynCall_iiijiiii = qe.hi)(k, ne, T, y, N, b, X, J, Ie);
      }, Hn = Pt.dynCall_iiijiiiji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (Hn = Pt.dynCall_iiijiiiji = qe.ii)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, Er = Pt.dynCall_iiijiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (Er = Pt.dynCall_iiijiiiii = qe.ji)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Cr = Pt.dynCall_jiiji = function(k, ne, T, y, N, b) {
        return (Cr = Pt.dynCall_jiiji = qe.ki)(k, ne, T, y, N, b);
      }, zr = Pt.dynCall_jiijji = function(k, ne, T, y, N, b, X, J) {
        return (zr = Pt.dynCall_jiijji = qe.li)(k, ne, T, y, N, b, X, J);
      }, hr = Pt.dynCall_iiiiiiiijjji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        return (hr = Pt.dynCall_iiiiiiiijjji = qe.mi)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
      }, xr = Pt.dynCall_iiiiiiiijiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (xr = Pt.dynCall_iiiiiiiijiii = qe.ni)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Is = Pt.dynCall_iiijjii = function(k, ne, T, y, N, b, X, J, Ie) {
        return (Is = Pt.dynCall_iiijjii = qe.oi)(k, ne, T, y, N, b, X, J, Ie);
      }, fs = Pt.dynCall_iiiiijjii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (fs = Pt.dynCall_iiiiijjii = qe.pi)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, co = Pt.dynCall_iiiiiiijji = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (co = Pt.dynCall_iiiiiiijji = qe.qi)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, Yo = Pt.dynCall_iiiiijji = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (Yo = Pt.dynCall_iiiiijji = qe.ri)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Qn = Pt.dynCall_vijiii = function(k, ne, T, y, N, b, X) {
        return (Qn = Pt.dynCall_vijiii = qe.si)(k, ne, T, y, N, b, X);
      }, es = Pt.dynCall_vijid = function(k, ne, T, y, N, b) {
        return (es = Pt.dynCall_vijid = qe.ti)(k, ne, T, y, N, b);
      }, Jo = Pt.dynCall_iiiiiiij = function(k, ne, T, y, N, b, X, J, Ie) {
        return (Jo = Pt.dynCall_iiiiiiij = qe.ui)(k, ne, T, y, N, b, X, J, Ie);
      }, js = Pt.dynCall_iijdddd = function(k, ne, T, y, N, b, X, J) {
        return (js = Pt.dynCall_iijdddd = qe.vi)(k, ne, T, y, N, b, X, J);
      }, Hi = Pt.dynCall_iiiiiiiijii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Hi = Pt.dynCall_iiiiiiiijii = qe.wi)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it);
      }, zs = Pt.dynCall_iiiiijiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (zs = Pt.dynCall_iiiiijiiii = qe.xi)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, Ji = Pt.dynCall_viji = function(k, ne, T, y, N) {
        return (Ji = Pt.dynCall_viji = qe.yi)(k, ne, T, y, N);
      }, ja = Pt.dynCall_viijji = function(k, ne, T, y, N, b, X, J) {
        return (ja = Pt.dynCall_viijji = qe.zi)(k, ne, T, y, N, b, X, J);
      }, Ea = Pt.dynCall_jijj = function(k, ne, T, y, N, b) {
        return (Ea = Pt.dynCall_jijj = qe.Ai)(k, ne, T, y, N, b);
      }, ga = Pt.dynCall_iijjjddi = function(k, ne, T, y, N, b, X, J, Ie, Pe, We) {
        return (ga = Pt.dynCall_iijjjddi = qe.Bi)(k, ne, T, y, N, b, X, J, Ie, Pe, We);
      }, sa = Pt.dynCall_vijiidddi = function(k, ne, T, y, N, b, X, J, Ie, Pe) {
        return (sa = Pt.dynCall_vijiidddi = qe.Ci)(k, ne, T, y, N, b, X, J, Ie, Pe);
      }, Sa = Pt.dynCall_jiiid = function(k, ne, T, y, N) {
        return (Sa = Pt.dynCall_jiiid = qe.Di)(k, ne, T, y, N);
      }, Ua = Pt.dynCall_iiiiiiiiiijiiiii = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        return (Ua = Pt.dynCall_iiiiiiiiiijiiiii = qe.Ei)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
      }, mi = Pt.dynCall_iiijii = function(k, ne, T, y, N, b, X) {
        return (mi = Pt.dynCall_iiijii = qe.Fi)(k, ne, T, y, N, b, X);
      }, $a = Pt.dynCall_jji = function(k, ne, T, y) {
        return ($a = Pt.dynCall_jji = qe.Gi)(k, ne, T, y);
      }, Oa = Pt.dynCall_viiij = function(k, ne, T, y, N, b) {
        return (Oa = Pt.dynCall_viiij = qe.Hi)(k, ne, T, y, N, b);
      }, Ha = Pt.dynCall_iiiiiiiiiiiiiijj = function(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        return (Ha = Pt.dynCall_iiiiiiiiiiiiiijj = qe.Ii)(k, ne, T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
      };
      function p0() {
        function k() {
          wo || (wo = !0, Pt.calledRun = !0, Ro) || (Pt.noFSInit || Gt.init.initialized || Gt.init(), Gt.ignorePermissions = !1, Ds.root = Gt.mount(Ds, {}, null), ia(xi), wt(Pt), Pt.onRuntimeInitialized && Pt.onRuntimeInitialized(), ti());
        }
        0 < Po || (oa(), 0 < Po) || (Pt.setStatus ? (Pt.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            Pt.setStatus("");
          }, 1), k();
        }, 1)) : k());
      }
      if (Pt.addRunDependency = Wo, Pt.removeRunDependency = As, Pt.FS_createPath = Gt.createPath, Pt.FS_createLazyFile = Gt.createLazyFile, Pt.FS_createDevice = Gt.createDevice, Pt.ENV = Bn, Pt.ccall = Li, Pt.cwrap = function(k, ne, T, y) {
        var N = !T || T.every(function(b) {
          return b === "number" || b === "boolean";
        });
        return ne !== "string" && N && !y ? Yi(k) : function() {
          return Li(k, ne, T, arguments);
        };
      }, Pt.addFunction = function(k, ne) {
        y = k, $o || ($o = /* @__PURE__ */ new WeakMap(), la(0, Lo.length));
        var y = $o.get(y) || 0;
        if (y)
          return y;
        var T, y = function() {
          if (Ho.length)
            return Ho.pop();
          try {
            Lo.grow(1);
          } catch (b) {
            throw b instanceof RangeError ? "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH." : b;
          }
          return Lo.length - 1;
        }();
        try {
          _i(y, k);
        } catch (b) {
          if (!(b instanceof TypeError))
            throw b;
          T = k, ne = ne;
          var N = typeof WebAssembly.Function == "function" ? new WebAssembly.Function(Ns(ne), T) : (Fi(ne, ne = [1]), pi(ne.length, N = [0, 97, 115, 109, 1, 0, 0, 0, 1]), N.push.apply(N, ne), N.push(2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0), ne = new WebAssembly.Module(new Uint8Array(N)), new WebAssembly.Instance(ne, { e: { f: T } }).exports.f);
          _i(y, N);
        }
        return $o.set(k, y), y;
      }, Pt.setValue = function(k, ne) {
        var T = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : "i8";
        switch (T = T.endsWith("*") ? "*" : T) {
          case "i1":
          case "i8":
            gs[k >> 0] = ne;
            break;
          case "i16":
            xs[k >> 1] = ne;
            break;
          case "i32":
            Ir[k >> 2] = ne;
            break;
          case "i64":
            ro("to do setValue(i64) use WASM_BIGINT");
          case "float":
            fr[k >> 2] = ne;
            break;
          case "double":
            Mr[k >> 3] = ne;
            break;
          case "*":
            ws[k >> 2] = ne;
            break;
          default:
            ro("invalid type for setValue: ".concat(T));
        }
      }, Pt.getValue = function(k) {
        var ne = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "i8";
        switch (ne = ne.endsWith("*") ? "*" : ne) {
          case "i1":
          case "i8":
            return gs[k >> 0];
          case "i16":
            return xs[k >> 1];
          case "i32":
            return Ir[k >> 2];
          case "i64":
            ro("to do getValue(i64) use WASM_BIGINT");
          case "float":
            return fr[k >> 2];
          case "double":
            return Mr[k >> 3];
          case "*":
            return ws[k >> 2];
          default:
            ro("invalid type for getValue: ".concat(ne));
        }
      }, Pt.UTF8ToString = Di, Pt.stringToUTF8 = Qs, Pt.lengthBytesUTF8 = oo, Pt.FS_createPreloadedFile = Gt.createPreloadedFile, Pt.FS = Gt, Pt.FS_createDataFile = Gt.createDataFile, Pt.FS_unlink = Gt.unlink, Pt.MEMFS = Ls, Pt.WORKERFS = ao, Pt.NODEFS = Tr, ai = function k() {
        wo || p0(), wo || (ai = k);
      }, Pt.preInit)
        for (typeof Pt.preInit == "function" && (Pt.preInit = [Pt.preInit]); 0 < Pt.preInit.length; )
          Pt.preInit.pop()();
      return p0(), yn.ready;
    }
    L = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0, typeof __filename < "u" && (L = L || __filename), Ci.exports = F;
    var W = m(Rn.exports), G = { Module: {} };
    function q() {
      var wt = G.CPLGetLastErrorMsg(), _t = G.CPLGetLastErrorNo();
      return G.CPLErrorReset(), { no: _t, message: wt };
    }
    function fe(wt) {
      for (var _t = [], Ve = {}, Ze = 0; Ze < wt.length; Ze += 1) {
        var bt = wt[Ze];
        bt === "--config" ? (Ve[wt[Ze + 1]] = wt[Ze + 2], Ze += 2) : _t.push(bt);
      }
      var Ut = _t.map(function(Sn) {
        return G.Module._malloc(G.Module.lengthBytesUTF8(Sn) + 1);
      }), mn = (Ut.push(0), Uint32Array.from(Ut)), nn = (_t.forEach(function(Sn, Mn) {
        G.Module.stringToUTF8(Sn, mn[Mn], G.Module.lengthBytesUTF8(Sn) + 1);
      }), G.Module._malloc(mn.length * mn.BYTES_PER_ELEMENT));
      return G.Module.HEAPU32.set(mn, nn / mn.BYTES_PER_ELEMENT), { ptr: nn, ptrArray: Ut, config: Ve };
    }
    function _e(wt) {
      G.Module._free(wt.ptr), wt.ptrArray.forEach(function(_t) {
        G.Module._free(_t);
      });
    }
    var Le = "/input", Fe = "/output", Ee = Fe, Ci = {}, Ge = Ci, ve = (Ge.parser = function(wt, _t) {
      return new te(wt, _t);
    }, Ge.SAXParser = te, Ge.SAXStream = Te, Ge.createStream = function(wt, _t) {
      return new Te(wt, _t);
    }, Ge.MAX_BUFFER_LENGTH = 65536, ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"]);
    function te(wt, _t) {
      if (!(this instanceof te))
        return new te(wt, _t);
      for (var Ve = this, Ze = Ve, bt = 0, Ut = ve.length; bt < Ut; bt++)
        Ze[ve[bt]] = "";
      Ve.q = Ve.c = "", Ve.bufferCheckPosition = Ge.MAX_BUFFER_LENGTH, Ve.opt = _t || {}, Ve.opt.lowercase = Ve.opt.lowercase || Ve.opt.lowercasetags, Ve.looseCase = Ve.opt.lowercase ? "toLowerCase" : "toUpperCase", Ve.tags = [], Ve.closed = Ve.closedRoot = Ve.sawRoot = !1, Ve.tag = Ve.error = null, Ve.strict = !!wt, Ve.noscript = !(!wt && !Ve.opt.noscript), Ve.state = Ct.BEGIN, Ve.strictEntities = Ve.opt.strictEntities, Ve.ENTITIES = Ve.strictEntities ? Object.create(Ge.XML_ENTITIES) : Object.create(Ge.ENTITIES), Ve.attribList = [], Ve.opt.xmlns && (Ve.ns = Object.create(Be)), Ve.trackPosition = Ve.opt.position !== !1, Ve.trackPosition && (Ve.position = Ve.line = Ve.column = 0), st(Ve, "onready");
    }
    Ge.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function(wt) {
      function _t() {
      }
      return _t.prototype = wt, new _t();
    }), Object.keys || (Object.keys = function(wt) {
      var _t, Ve = [];
      for (_t in wt)
        wt.hasOwnProperty(_t) && Ve.push(_t);
      return Ve;
    }), te.prototype = { end: function() {
      Ke(this);
    }, write: function(wt) {
      var _t = this;
      if (this.error)
        throw this.error;
      if (_t.closed)
        return Et(_t, "Cannot write after close. Assign an onready handler.");
      if (wt === null)
        return Ke(_t);
      typeof wt == "object" && (wt = wt.toString());
      for (var Ve, Ze, bt = 0, Ut = ""; Ut = Wt(wt, bt++), !!(_t.c = Ut); )
        switch (_t.trackPosition && (_t.position++, Ut === `
` ? (_t.line++, _t.column = 0) : _t.column++), _t.state) {
          case Ct.BEGIN:
            if (_t.state = Ct.BEGIN_WHITESPACE, Ut === "\uFEFF")
              continue;
            ht(_t, Ut);
            continue;
          case Ct.BEGIN_WHITESPACE:
            ht(_t, Ut);
            continue;
          case Ct.TEXT:
            if (_t.sawRoot && !_t.closedRoot) {
              for (var mn = bt - 1; Ut && Ut !== "<" && Ut !== "&"; )
                (Ut = Wt(wt, bt++)) && _t.trackPosition && (_t.position++, Ut === `
` ? (_t.line++, _t.column = 0) : _t.column++);
              _t.textNode += wt.substring(mn, bt - 1);
            }
            Ut !== "<" || _t.sawRoot && _t.closedRoot && !_t.strict ? (Ht(Ut) || _t.sawRoot && !_t.closedRoot || $e(_t, "Text data outside of root node."), Ut === "&" ? _t.state = Ct.TEXT_ENTITY : _t.textNode += Ut) : (_t.state = Ct.OPEN_WAKA, _t.startTagPosition = _t.position);
            continue;
          case Ct.SCRIPT:
            Ut === "<" ? _t.state = Ct.SCRIPT_ENDING : _t.script += Ut;
            continue;
          case Ct.SCRIPT_ENDING:
            Ut === "/" ? _t.state = Ct.CLOSE_TAG : (_t.script += "<" + Ut, _t.state = Ct.SCRIPT);
            continue;
          case Ct.OPEN_WAKA:
            Ut === "!" ? (_t.state = Ct.SGML_DECL, _t.sgmlDecl = "") : Ht(Ut) || (ut(Me, Ut) ? (_t.state = Ct.OPEN_TAG, _t.tagName = Ut) : Ut === "/" ? (_t.state = Ct.CLOSE_TAG, _t.tagName = "") : Ut === "?" ? (_t.state = Ct.PROC_INST, _t.procInstName = _t.procInstBody = "") : ($e(_t, "Unencoded <"), _t.startTagPosition + 1 < _t.position && (mn = _t.position - _t.startTagPosition, Ut = new Array(mn).join(" ") + Ut), _t.textNode += "<" + Ut, _t.state = Ct.TEXT));
            continue;
          case Ct.SGML_DECL:
            (_t.sgmlDecl + Ut).toUpperCase() === De ? (jt(_t, "onopencdata"), _t.state = Ct.CDATA, _t.sgmlDecl = "", _t.cdata = "") : _t.sgmlDecl + Ut === "--" ? (_t.state = Ct.COMMENT, _t.comment = "", _t.sgmlDecl = "") : (_t.sgmlDecl + Ut).toUpperCase() === be ? (_t.state = Ct.DOCTYPE, (_t.doctype || _t.sawRoot) && $e(_t, "Inappropriately located doctype declaration"), _t.doctype = "", _t.sgmlDecl = "") : Ut === ">" ? (jt(_t, "onsgmldeclaration", _t.sgmlDecl), _t.sgmlDecl = "", _t.state = Ct.TEXT) : (Bt(Ut) && (_t.state = Ct.SGML_DECL_QUOTED), _t.sgmlDecl += Ut);
            continue;
          case Ct.SGML_DECL_QUOTED:
            Ut === _t.q && (_t.state = Ct.SGML_DECL, _t.q = ""), _t.sgmlDecl += Ut;
            continue;
          case Ct.DOCTYPE:
            Ut === ">" ? (_t.state = Ct.TEXT, jt(_t, "ondoctype", _t.doctype), _t.doctype = !0) : (_t.doctype += Ut, Ut === "[" ? _t.state = Ct.DOCTYPE_DTD : Bt(Ut) && (_t.state = Ct.DOCTYPE_QUOTED, _t.q = Ut));
            continue;
          case Ct.DOCTYPE_QUOTED:
            _t.doctype += Ut, Ut === _t.q && (_t.q = "", _t.state = Ct.DOCTYPE);
            continue;
          case Ct.DOCTYPE_DTD:
            _t.doctype += Ut, Ut === "]" ? _t.state = Ct.DOCTYPE : Bt(Ut) && (_t.state = Ct.DOCTYPE_DTD_QUOTED, _t.q = Ut);
            continue;
          case Ct.DOCTYPE_DTD_QUOTED:
            _t.doctype += Ut, Ut === _t.q && (_t.state = Ct.DOCTYPE_DTD, _t.q = "");
            continue;
          case Ct.COMMENT:
            Ut === "-" ? _t.state = Ct.COMMENT_ENDING : _t.comment += Ut;
            continue;
          case Ct.COMMENT_ENDING:
            Ut === "-" ? (_t.state = Ct.COMMENT_ENDED, _t.comment = Zt(_t.opt, _t.comment), _t.comment && jt(_t, "oncomment", _t.comment), _t.comment = "") : (_t.comment += "-" + Ut, _t.state = Ct.COMMENT);
            continue;
          case Ct.COMMENT_ENDED:
            Ut !== ">" ? ($e(_t, "Malformed comment"), _t.comment += "--" + Ut, _t.state = Ct.COMMENT) : _t.state = Ct.TEXT;
            continue;
          case Ct.CDATA:
            Ut === "]" ? _t.state = Ct.CDATA_ENDING : _t.cdata += Ut;
            continue;
          case Ct.CDATA_ENDING:
            Ut === "]" ? _t.state = Ct.CDATA_ENDING_2 : (_t.cdata += "]" + Ut, _t.state = Ct.CDATA);
            continue;
          case Ct.CDATA_ENDING_2:
            Ut === ">" ? (_t.cdata && jt(_t, "oncdata", _t.cdata), jt(_t, "onclosecdata"), _t.cdata = "", _t.state = Ct.TEXT) : Ut === "]" ? _t.cdata += "]" : (_t.cdata += "]]" + Ut, _t.state = Ct.CDATA);
            continue;
          case Ct.PROC_INST:
            Ut === "?" ? _t.state = Ct.PROC_INST_ENDING : Ht(Ut) ? _t.state = Ct.PROC_INST_BODY : _t.procInstName += Ut;
            continue;
          case Ct.PROC_INST_BODY:
            if (!_t.procInstBody && Ht(Ut))
              continue;
            Ut === "?" ? _t.state = Ct.PROC_INST_ENDING : _t.procInstBody += Ut;
            continue;
          case Ct.PROC_INST_ENDING:
            Ut === ">" ? (jt(_t, "onprocessinginstruction", { name: _t.procInstName, body: _t.procInstBody }), _t.procInstName = _t.procInstBody = "", _t.state = Ct.TEXT) : (_t.procInstBody += "?" + Ut, _t.state = Ct.PROC_INST_BODY);
            continue;
          case Ct.OPEN_TAG:
            ut(me, Ut) ? _t.tagName += Ut : (function(Sn) {
              Sn.strict || (Sn.tagName = Sn.tagName[Sn.looseCase]());
              var Mn = Sn.tags[Sn.tags.length - 1] || Sn, yn = Sn.tag = { name: Sn.tagName, attributes: {} };
              Sn.opt.xmlns && (yn.ns = Mn.ns), Sn.attribList.length = 0, jt(Sn, "onopentagstart", yn);
            }(_t), Ut === ">" ? In(_t) : Ut === "/" ? _t.state = Ct.OPEN_TAG_SLASH : (Ht(Ut) || $e(_t, "Invalid character in tag name"), _t.state = Ct.ATTRIB));
            continue;
          case Ct.OPEN_TAG_SLASH:
            Ut === ">" ? (In(_t, !0), Cn(_t)) : ($e(_t, "Forward-slash in opening tag not followed by >"), _t.state = Ct.ATTRIB);
            continue;
          case Ct.ATTRIB:
            if (Ht(Ut))
              continue;
            Ut === ">" ? In(_t) : Ut === "/" ? _t.state = Ct.OPEN_TAG_SLASH : ut(Me, Ut) ? (_t.attribName = Ut, _t.attribValue = "", _t.state = Ct.ATTRIB_NAME) : $e(_t, "Invalid attribute name");
            continue;
          case Ct.ATTRIB_NAME:
            Ut === "=" ? _t.state = Ct.ATTRIB_VALUE : Ut === ">" ? ($e(_t, "Attribute without value"), _t.attribValue = _t.attribName, Jt(_t), In(_t)) : Ht(Ut) ? _t.state = Ct.ATTRIB_NAME_SAW_WHITE : ut(me, Ut) ? _t.attribName += Ut : $e(_t, "Invalid attribute name");
            continue;
          case Ct.ATTRIB_NAME_SAW_WHITE:
            if (Ut === "=")
              _t.state = Ct.ATTRIB_VALUE;
            else {
              if (Ht(Ut))
                continue;
              $e(_t, "Attribute without value"), _t.tag.attributes[_t.attribName] = "", _t.attribValue = "", jt(_t, "onattribute", { name: _t.attribName, value: "" }), _t.attribName = "", Ut === ">" ? In(_t) : ut(Me, Ut) ? (_t.attribName = Ut, _t.state = Ct.ATTRIB_NAME) : ($e(_t, "Invalid attribute name"), _t.state = Ct.ATTRIB);
            }
            continue;
          case Ct.ATTRIB_VALUE:
            if (Ht(Ut))
              continue;
            Bt(Ut) ? (_t.q = Ut, _t.state = Ct.ATTRIB_VALUE_QUOTED) : ($e(_t, "Unquoted attribute value"), _t.state = Ct.ATTRIB_VALUE_UNQUOTED, _t.attribValue = Ut);
            continue;
          case Ct.ATTRIB_VALUE_QUOTED:
            if (Ut !== _t.q) {
              Ut === "&" ? _t.state = Ct.ATTRIB_VALUE_ENTITY_Q : _t.attribValue += Ut;
              continue;
            }
            Jt(_t), _t.q = "", _t.state = Ct.ATTRIB_VALUE_CLOSED;
            continue;
          case Ct.ATTRIB_VALUE_CLOSED:
            Ht(Ut) ? _t.state = Ct.ATTRIB : Ut === ">" ? In(_t) : Ut === "/" ? _t.state = Ct.OPEN_TAG_SLASH : ut(Me, Ut) ? ($e(_t, "No whitespace between attributes"), _t.attribName = Ut, _t.attribValue = "", _t.state = Ct.ATTRIB_NAME) : $e(_t, "Invalid attribute name");
            continue;
          case Ct.ATTRIB_VALUE_UNQUOTED:
            if (!function(Sn) {
              return Sn === ">" || Ht(Sn);
            }(Ut)) {
              Ut === "&" ? _t.state = Ct.ATTRIB_VALUE_ENTITY_U : _t.attribValue += Ut;
              continue;
            }
            Jt(_t), Ut === ">" ? In(_t) : _t.state = Ct.ATTRIB;
            continue;
          case Ct.CLOSE_TAG:
            if (_t.tagName)
              Ut === ">" ? Cn(_t) : ut(me, Ut) ? _t.tagName += Ut : _t.script ? (_t.script += "</" + _t.tagName, _t.tagName = "", _t.state = Ct.SCRIPT) : (Ht(Ut) || $e(_t, "Invalid tagname in closing tag"), _t.state = Ct.CLOSE_TAG_SAW_WHITE);
            else {
              if (Ht(Ut))
                continue;
              (function(Sn, Mn) {
                return !ut(Sn, Mn);
              })(Me, Ut) ? _t.script ? (_t.script += "</" + Ut, _t.state = Ct.SCRIPT) : $e(_t, "Invalid tagname in closing tag.") : _t.tagName = Ut;
            }
            continue;
          case Ct.CLOSE_TAG_SAW_WHITE:
            if (Ht(Ut))
              continue;
            Ut === ">" ? Cn(_t) : $e(_t, "Invalid characters in closing tag");
            continue;
          case Ct.TEXT_ENTITY:
          case Ct.ATTRIB_VALUE_ENTITY_Q:
          case Ct.ATTRIB_VALUE_ENTITY_U:
            switch (_t.state) {
              case Ct.TEXT_ENTITY:
                Ve = Ct.TEXT, Ze = "textNode";
                break;
              case Ct.ATTRIB_VALUE_ENTITY_Q:
                Ve = Ct.ATTRIB_VALUE_QUOTED, Ze = "attribValue";
                break;
              case Ct.ATTRIB_VALUE_ENTITY_U:
                Ve = Ct.ATTRIB_VALUE_UNQUOTED, Ze = "attribValue";
            }
            var nn;
            Ut === ";" ? _t.opt.unparsedEntities ? (nn = It(_t), _t.entity = "", _t.state = Ve, _t.write(nn)) : (_t[Ze] += It(_t), _t.entity = "", _t.state = Ve) : ut(_t.entity.length ? xt : Se, Ut) ? _t.entity += Ut : ($e(_t, "Invalid character in entity name"), _t[Ze] += "&" + _t.entity + Ut, _t.entity = "", _t.state = Ve);
            continue;
          default:
            throw new Error(_t, "Unknown state: " + _t.state);
        }
      return _t.position >= _t.bufferCheckPosition && function(Sn) {
        for (var Mn = Math.max(Ge.MAX_BUFFER_LENGTH, 10), yn = 0, Pt = 0, tr = ve.length; Pt < tr; Pt++) {
          var Lt = Sn[ve[Pt]].length;
          if (Mn < Lt)
            switch (ve[Pt]) {
              case "textNode":
                lt(Sn);
                break;
              case "cdata":
                jt(Sn, "oncdata", Sn.cdata), Sn.cdata = "";
                break;
              case "script":
                jt(Sn, "onscript", Sn.script), Sn.script = "";
                break;
              default:
                Et(Sn, "Max buffer length exceeded: " + ve[Pt]);
            }
          yn = Math.max(yn, Lt);
        }
        var dr = Ge.MAX_BUFFER_LENGTH - yn;
        Sn.bufferCheckPosition = dr + Sn.position;
      }(_t), _t;
    }, resume: function() {
      return this.error = null, this;
    }, close: function() {
      return this.write(null);
    }, flush: function() {
      var wt;
      lt(wt = this), wt.cdata !== "" && (jt(wt, "oncdata", wt.cdata), wt.cdata = ""), wt.script !== "" && (jt(wt, "onscript", wt.script), wt.script = "");
    } };
    try {
      ae = requireStreamBrowserify().Stream;
    } catch {
      ae = function() {
      };
    }
    var ae = ae || function() {
    }, v = Ge.EVENTS.filter(function(wt) {
      return wt !== "error" && wt !== "end";
    });
    function Te(wt, _t) {
      if (!(this instanceof Te))
        return new Te(wt, _t);
      ae.apply(this), this._parser = new te(wt, _t), this.writable = !0, this.readable = !0;
      var Ve = this;
      this._parser.onend = function() {
        Ve.emit("end");
      }, this._parser.onerror = function(Ze) {
        Ve.emit("error", Ze), Ve._parser.error = null;
      }, this._decoder = null, v.forEach(function(Ze) {
        Object.defineProperty(Ve, "on" + Ze, { get: function() {
          return Ve._parser["on" + Ze];
        }, set: function(bt) {
          if (!bt)
            return Ve.removeAllListeners(Ze), Ve._parser["on" + Ze] = bt;
          Ve.on(Ze, bt);
        }, enumerable: !0, configurable: !1 });
      });
    }
    (Te.prototype = Object.create(ae.prototype, { constructor: { value: Te } })).write = function(wt) {
      var _t;
      return typeof buffer$1.Buffer == "function" && typeof buffer$1.Buffer.isBuffer == "function" && buffer$1.Buffer.isBuffer(wt) && (this._decoder || (_t = a.StringDecoder, this._decoder = new _t("utf8")), wt = this._decoder.write(wt)), this._parser.write(wt.toString()), this.emit("data", wt), !0;
    }, Te.prototype.end = function(wt) {
      return wt && wt.length && this.write(wt), this._parser.end(), !0;
    }, Te.prototype.on = function(wt, _t) {
      var Ve = this;
      return Ve._parser["on" + wt] || v.indexOf(wt) === -1 || (Ve._parser["on" + wt] = function() {
        var Ze = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        Ze.splice(0, 0, wt), Ve.emit.apply(Ve, Ze);
      }), ae.prototype.on.call(Ve, wt, _t);
    };
    var De = "[CDATA[", be = "DOCTYPE", ze = "http://www.w3.org/XML/1998/namespace", ke = "http://www.w3.org/2000/xmlns/", Be = { xml: ze, xmlns: ke }, Me = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, me = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, Se = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, xt = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function Ht(wt) {
      return wt === " " || wt === `
` || wt === "\r" || wt === "	";
    }
    function Bt(wt) {
      return wt === '"' || wt === "'";
    }
    function ut(wt, _t) {
      return wt.test(_t);
    }
    var Tt, Yt, an, Ct = 0;
    for (Tt in Ge.STATE = { BEGIN: Ct++, BEGIN_WHITESPACE: Ct++, TEXT: Ct++, TEXT_ENTITY: Ct++, OPEN_WAKA: Ct++, SGML_DECL: Ct++, SGML_DECL_QUOTED: Ct++, DOCTYPE: Ct++, DOCTYPE_QUOTED: Ct++, DOCTYPE_DTD: Ct++, DOCTYPE_DTD_QUOTED: Ct++, COMMENT_STARTING: Ct++, COMMENT: Ct++, COMMENT_ENDING: Ct++, COMMENT_ENDED: Ct++, CDATA: Ct++, CDATA_ENDING: Ct++, CDATA_ENDING_2: Ct++, PROC_INST: Ct++, PROC_INST_BODY: Ct++, PROC_INST_ENDING: Ct++, OPEN_TAG: Ct++, OPEN_TAG_SLASH: Ct++, ATTRIB: Ct++, ATTRIB_NAME: Ct++, ATTRIB_NAME_SAW_WHITE: Ct++, ATTRIB_VALUE: Ct++, ATTRIB_VALUE_QUOTED: Ct++, ATTRIB_VALUE_CLOSED: Ct++, ATTRIB_VALUE_UNQUOTED: Ct++, ATTRIB_VALUE_ENTITY_Q: Ct++, ATTRIB_VALUE_ENTITY_U: Ct++, CLOSE_TAG: Ct++, CLOSE_TAG_SAW_WHITE: Ct++, SCRIPT: Ct++, SCRIPT_ENDING: Ct++ }, Ge.XML_ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'" }, Ge.ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'", AElig: 198, Aacute: 193, Acirc: 194, Agrave: 192, Aring: 197, Atilde: 195, Auml: 196, Ccedil: 199, ETH: 208, Eacute: 201, Ecirc: 202, Egrave: 200, Euml: 203, Iacute: 205, Icirc: 206, Igrave: 204, Iuml: 207, Ntilde: 209, Oacute: 211, Ocirc: 212, Ograve: 210, Oslash: 216, Otilde: 213, Ouml: 214, THORN: 222, Uacute: 218, Ucirc: 219, Ugrave: 217, Uuml: 220, Yacute: 221, aacute: 225, acirc: 226, aelig: 230, agrave: 224, aring: 229, atilde: 227, auml: 228, ccedil: 231, eacute: 233, ecirc: 234, egrave: 232, eth: 240, euml: 235, iacute: 237, icirc: 238, igrave: 236, iuml: 239, ntilde: 241, oacute: 243, ocirc: 244, ograve: 242, oslash: 248, otilde: 245, ouml: 246, szlig: 223, thorn: 254, uacute: 250, ucirc: 251, ugrave: 249, uuml: 252, yacute: 253, yuml: 255, copy: 169, reg: 174, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, deg: 176, plusmn: 177, sup1: 185, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, times: 215, divide: 247, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 }, Object.keys(Ge.ENTITIES).forEach(function(wt) {
      var _t = Ge.ENTITIES[wt], _t = typeof _t == "number" ? String.fromCharCode(_t) : _t;
      Ge.ENTITIES[wt] = _t;
    }), Ge.STATE)
      Ge.STATE[Ge.STATE[Tt]] = Tt;
    function st(wt, _t, Ve) {
      wt[_t] && wt[_t](Ve);
    }
    function jt(wt, _t, Ve) {
      wt.textNode && lt(wt), st(wt, _t, Ve);
    }
    function lt(wt) {
      wt.textNode = Zt(wt.opt, wt.textNode), wt.textNode && st(wt, "ontext", wt.textNode), wt.textNode = "";
    }
    function Zt(wt, _t) {
      return wt.trim && (_t = _t.trim()), _t = wt.normalize ? _t.replace(/\s+/g, " ") : _t;
    }
    function Et(wt, _t) {
      return lt(wt), wt.trackPosition && (_t += `
Line: ` + wt.line + `
Column: ` + wt.column + `
Char: ` + wt.c), _t = new Error(_t), wt.error = _t, st(wt, "onerror", _t), wt;
    }
    function Ke(wt) {
      return wt.sawRoot && !wt.closedRoot && $e(wt, "Unclosed root tag"), wt.state !== Ct.BEGIN && wt.state !== Ct.BEGIN_WHITESPACE && wt.state !== Ct.TEXT && Et(wt, "Unexpected end"), lt(wt), wt.c = "", wt.closed = !0, st(wt, "onend"), te.call(wt, wt.strict, wt.opt), wt;
    }
    function $e(wt, _t) {
      if (typeof wt != "object" || !(wt instanceof te))
        throw new Error("bad call to strictFail");
      wt.strict && Et(wt, _t);
    }
    function pt(wt, _t) {
      var Ze = wt.indexOf(":") < 0 ? ["", wt] : wt.split(":"), Ve = Ze[0], Ze = Ze[1];
      return _t && wt === "xmlns" && (Ve = "xmlns", Ze = ""), { prefix: Ve, local: Ze };
    }
    function Jt(wt) {
      var _t, Ve, Ze;
      wt.strict || (wt.attribName = wt.attribName[wt.looseCase]()), wt.attribList.indexOf(wt.attribName) !== -1 || wt.tag.attributes.hasOwnProperty(wt.attribName) || (wt.opt.xmlns ? (Ve = (_t = pt(wt.attribName, !0)).prefix, _t = _t.local, Ve === "xmlns" && (_t === "xml" && wt.attribValue !== ze ? $e(wt, "xml: prefix must be bound to " + ze + `
Actual: ` + wt.attribValue) : _t === "xmlns" && wt.attribValue !== ke ? $e(wt, "xmlns: prefix must be bound to " + ke + `
Actual: ` + wt.attribValue) : (Ve = wt.tag, Ze = wt.tags[wt.tags.length - 1] || wt, Ve.ns === Ze.ns && (Ve.ns = Object.create(Ze.ns)), Ve.ns[_t] = wt.attribValue)), wt.attribList.push([wt.attribName, wt.attribValue])) : (wt.tag.attributes[wt.attribName] = wt.attribValue, jt(wt, "onattribute", { name: wt.attribName, value: wt.attribValue }))), wt.attribName = wt.attribValue = "";
    }
    function In(wt, _t) {
      if (wt.opt.xmlns) {
        var Ve = wt.tag, Ze = pt(wt.tagName), Ze = (Ve.prefix = Ze.prefix, Ve.local = Ze.local, Ve.uri = Ve.ns[Ze.prefix] || "", Ve.prefix && !Ve.uri && ($e(wt, "Unbound namespace prefix: " + JSON.stringify(wt.tagName)), Ve.uri = Ze.prefix), wt.tags[wt.tags.length - 1] || wt);
        Ve.ns && Ze.ns !== Ve.ns && Object.keys(Ve.ns).forEach(function(Pt) {
          jt(wt, "onopennamespace", { prefix: Pt, uri: Ve.ns[Pt] });
        });
        for (var bt = 0, Ut = wt.attribList.length; bt < Ut; bt++) {
          var yn = wt.attribList[bt], mn = yn[0], yn = yn[1], Sn = pt(mn, !0), nn = Sn.prefix, Sn = Sn.local, Mn = nn !== "" && Ve.ns[nn] || "", yn = { name: mn, value: yn, prefix: nn, local: Sn, uri: Mn };
          nn && nn !== "xmlns" && !Mn && ($e(wt, "Unbound namespace prefix: " + JSON.stringify(nn)), yn.uri = nn), wt.tag.attributes[mn] = yn, jt(wt, "onattribute", yn);
        }
        wt.attribList.length = 0;
      }
      wt.tag.isSelfClosing = !!_t, wt.sawRoot = !0, wt.tags.push(wt.tag), jt(wt, "onopentag", wt.tag), _t || (wt.noscript || wt.tagName.toLowerCase() !== "script" ? wt.state = Ct.TEXT : wt.state = Ct.SCRIPT, wt.tag = null, wt.tagName = ""), wt.attribName = wt.attribValue = "", wt.attribList.length = 0;
    }
    function Cn(wt) {
      if (wt.tagName) {
        if (wt.script) {
          if (wt.tagName !== "script")
            return wt.script += "</" + wt.tagName + ">", wt.tagName = "", void (wt.state = Ct.SCRIPT);
          jt(wt, "onscript", wt.script), wt.script = "";
        }
        for (var _t = wt.tags.length, Ve = wt.tagName, Ze = Ve = wt.strict ? Ve : Ve[wt.looseCase](); _t-- && wt.tags[_t].name !== Ze; )
          $e(wt, "Unexpected close tag");
        if (_t < 0)
          $e(wt, "Unmatched closing tag: " + wt.tagName), wt.textNode += "</" + wt.tagName + ">";
        else {
          wt.tagName = Ve;
          for (var bt = wt.tags.length; bt-- > _t; ) {
            var Ut, mn = wt.tag = wt.tags.pop();
            wt.tagName = wt.tag.name, jt(wt, "onclosetag", wt.tagName);
            for (Ut in mn.ns)
              mn.ns[Ut];
            var nn = wt.tags[wt.tags.length - 1] || wt;
            wt.opt.xmlns && mn.ns !== nn.ns && Object.keys(mn.ns).forEach(function(Sn) {
              var Mn = mn.ns[Sn];
              jt(wt, "onclosenamespace", { prefix: Sn, uri: Mn });
            });
          }
          _t === 0 && (wt.closedRoot = !0), wt.tagName = wt.attribValue = wt.attribName = "", wt.attribList.length = 0;
        }
      } else
        $e(wt, "Weird empty close tag."), wt.textNode += "</>";
      wt.state = Ct.TEXT;
    }
    function It(wt) {
      var _t, Ve = wt.entity, Ze = Ve.toLowerCase(), bt = "";
      return wt.ENTITIES[Ve] || wt.ENTITIES[Ze] || ((Ve = Ze).charAt(0) === "#" && (bt = Ve.charAt(1) === "x" ? (Ve = Ve.slice(2), (_t = parseInt(Ve, 16)).toString(16)) : (Ve = Ve.slice(1), (_t = parseInt(Ve, 10)).toString(10))), Ve = Ve.replace(/^0+/, ""), isNaN(_t) || bt.toLowerCase() !== Ve ? ($e(wt, "Invalid character entity"), "&" + wt.entity + ";") : String.fromCodePoint(_t));
    }
    function ht(wt, _t) {
      _t === "<" ? (wt.state = Ct.OPEN_WAKA, wt.startTagPosition = wt.position) : Ht(_t) || ($e(wt, "Non-whitespace before first tag."), wt.textNode = _t, wt.state = Ct.TEXT);
    }
    function Wt(wt, _t) {
      var Ve = "";
      return Ve = _t < wt.length ? wt.charAt(_t) : Ve;
    }
    function hn() {
      var wt = [], _t = -1, Ve = arguments.length;
      if (!Ve)
        return "";
      for (var Ze = ""; ++_t < Ve; ) {
        var bt = Number(arguments[_t]);
        if (!isFinite(bt) || bt < 0 || 1114111 < bt || an(bt) !== bt)
          throw RangeError("Invalid code point: " + bt);
        bt <= 65535 ? wt.push(bt) : wt.push(55296 + ((bt -= 65536) >> 10), bt % 1024 + 56320), (_t + 1 === Ve || 16384 < wt.length) && (Ze += Yt.apply(null, wt), wt.length = 0);
      }
      return Ze;
    }
    Ct = Ge.STATE, String.fromCodePoint || (Yt = String.fromCharCode, an = Math.floor, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", { value: hn, configurable: !0, writable: !0 }) : String.fromCodePoint = hn);
    var Vt, Tn, Rn = function(wt) {
      return Array.isArray ? Array.isArray(wt) : Object.prototype.toString.call(wt) === "[object Array]";
    }, Nn = Rn, Io = { copyOptions: function(wt) {
      var _t, Ve = {};
      for (_t in wt)
        wt.hasOwnProperty(_t) && (Ve[_t] = wt[_t]);
      return Ve;
    }, ensureFlagExists: function(wt, _t) {
      wt in _t && typeof _t[wt] == "boolean" || (_t[wt] = !1);
    }, ensureSpacesExists: function(wt) {
      "spaces" in wt && (typeof wt.spaces == "number" || typeof wt.spaces == "string") || (wt.spaces = 0);
    }, ensureAlwaysArrayExists: function(wt) {
      "alwaysArray" in wt && (typeof wt.alwaysArray == "boolean" || Nn(wt.alwaysArray)) || (wt.alwaysArray = !1);
    }, ensureKeyExists: function(wt, _t) {
      wt + "Key" in _t && typeof _t[wt + "Key"] == "string" || (_t[wt + "Key"] = _t.compact ? "_" + wt : wt);
    }, checkFnExists: function(wt, _t) {
      return wt + "Fn" in _t;
    } }, Dn = Ci, xn = Io, $n = Rn;
    function Kn(wt) {
      var _t, Ve = Number(wt);
      return isNaN(Ve) ? (_t = wt.toLowerCase()) === "true" || _t !== "false" && wt : Ve;
    }
    function ir(wt, _t) {
      var Ve, Ze;
      if (Vt.compact) {
        if (!Tn[Vt[wt + "Key"]] && ($n(Vt.alwaysArray) ? Vt.alwaysArray.indexOf(Vt[wt + "Key"]) !== -1 : Vt.alwaysArray) && (Tn[Vt[wt + "Key"]] = []), Tn[Vt[wt + "Key"]] && !$n(Tn[Vt[wt + "Key"]]) && (Tn[Vt[wt + "Key"]] = [Tn[Vt[wt + "Key"]]]), wt + "Fn" in Vt && typeof _t == "string" && (_t = Vt[wt + "Fn"](_t, Tn)), wt === "instruction" && ("instructionFn" in Vt || "instructionNameFn" in Vt))
          for (Ve in _t)
            _t.hasOwnProperty(Ve) && ("instructionFn" in Vt ? _t[Ve] = Vt.instructionFn(_t[Ve], Ve, Tn) : (Ze = _t[Ve], delete _t[Ve], _t[Vt.instructionNameFn(Ve, Ze, Tn)] = Ze));
        $n(Tn[Vt[wt + "Key"]]) ? Tn[Vt[wt + "Key"]].push(_t) : Tn[Vt[wt + "Key"]] = _t;
      } else {
        Tn[Vt.elementsKey] || (Tn[Vt.elementsKey] = []);
        var bt = {};
        if ((bt[Vt.typeKey] = wt) === "instruction") {
          for (Ve in _t)
            if (_t.hasOwnProperty(Ve))
              break;
          bt[Vt.nameKey] = "instructionNameFn" in Vt ? Vt.instructionNameFn(Ve, _t, Tn) : Ve, Vt.instructionHasAttributes ? (bt[Vt.attributesKey] = _t[Ve][Vt.attributesKey], "instructionFn" in Vt && (bt[Vt.attributesKey] = Vt.instructionFn(bt[Vt.attributesKey], Ve, Tn))) : ("instructionFn" in Vt && (_t[Ve] = Vt.instructionFn(_t[Ve], Ve, Tn)), bt[Vt.instructionKey] = _t[Ve]);
        } else
          wt + "Fn" in Vt && (_t = Vt[wt + "Fn"](_t, Tn)), bt[Vt[wt + "Key"]] = _t;
        Vt.addParent && (bt[Vt.parentKey] = Tn), Tn[Vt.elementsKey].push(bt);
      }
    }
    function er(wt) {
      var _t, Ve;
      if ("attributesFn" in Vt && (wt = wt && Vt.attributesFn(wt, Tn)), (Vt.trim || "attributeValueFn" in Vt || "attributeNameFn" in Vt || Vt.nativeTypeAttributes) && wt)
        for (_t in wt)
          wt.hasOwnProperty(_t) && (Vt.trim && (wt[_t] = wt[_t].trim()), Vt.nativeTypeAttributes && (wt[_t] = Kn(wt[_t])), "attributeValueFn" in Vt && (wt[_t] = Vt.attributeValueFn(wt[_t], _t, Tn)), "attributeNameFn" in Vt) && (Ve = wt[_t], delete wt[_t], wt[Vt.attributeNameFn(_t, wt[_t], Tn)] = Ve);
      return wt;
    }
    function br(wt) {
      var _t, Ve = {};
      if (wt.body && (wt.name.toLowerCase() === "xml" || Vt.instructionHasAttributes)) {
        for (var Ze, bt = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g; (Ze = bt.exec(wt.body)) !== null; )
          Ve[Ze[1]] = Ze[2] || Ze[3] || Ze[4];
        Ve = er(Ve);
      }
      wt.name.toLowerCase() === "xml" ? Vt.ignoreDeclaration || (Tn[Vt.declarationKey] = {}, Object.keys(Ve).length && (Tn[Vt.declarationKey][Vt.attributesKey] = Ve), Vt.addParent && (Tn[Vt.declarationKey][Vt.parentKey] = Tn)) : Vt.ignoreInstruction || (Vt.trim && (wt.body = wt.body.trim()), _t = {}, Vt.instructionHasAttributes && Object.keys(Ve).length ? (_t[wt.name] = {}, _t[wt.name][Vt.attributesKey] = Ve) : _t[wt.name] = wt.body, ir("instruction", _t));
    }
    function cs(wt, _t) {
      if (typeof wt == "object" && (_t = wt.attributes, wt = wt.name), _t = er(_t), "elementNameFn" in Vt && (wt = Vt.elementNameFn(wt, Tn)), Vt.compact) {
        var Ve, Ze = {};
        if (!Vt.ignoreAttributes && _t && Object.keys(_t).length)
          for (Ve in Ze[Vt.attributesKey] = {}, _t)
            _t.hasOwnProperty(Ve) && (Ze[Vt.attributesKey][Ve] = _t[Ve]);
        wt in Tn || ($n(Vt.alwaysArray) ? Vt.alwaysArray.indexOf(wt) === -1 : !Vt.alwaysArray) || (Tn[wt] = []), Tn[wt] && !$n(Tn[wt]) && (Tn[wt] = [Tn[wt]]), $n(Tn[wt]) ? Tn[wt].push(Ze) : Tn[wt] = Ze;
      } else
        Tn[Vt.elementsKey] || (Tn[Vt.elementsKey] = []), (Ze = {})[Vt.typeKey] = "element", Ze[Vt.nameKey] = wt, !Vt.ignoreAttributes && _t && Object.keys(_t).length && (Ze[Vt.attributesKey] = _t), Vt.alwaysChildren && (Ze[Vt.elementsKey] = []), Tn[Vt.elementsKey].push(Ze);
      Ze[Vt.parentKey] = Tn, Tn = Ze;
    }
    function Gn(wt) {
      Vt.ignoreText || (wt.trim() || Vt.captureSpacesBetweenElements) && (Vt.trim && (wt = wt.trim()), Vt.nativeType && (wt = Kn(wt)), ir("text", wt = Vt.sanitize ? wt.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : wt));
    }
    function Jn(wt) {
      Vt.ignoreComment || ir("comment", wt = Vt.trim ? wt.trim() : wt);
    }
    function Xn(wt) {
      var _t = Tn[Vt.parentKey];
      Vt.addParent || delete Tn[Vt.parentKey], Tn = _t;
    }
    function rr(wt) {
      Vt.ignoreCdata || ir("cdata", wt = Vt.trim ? wt.trim() : wt);
    }
    function _r(wt) {
      Vt.ignoreDoctype || (wt = wt.replace(/^ /, ""), ir("doctype", wt = Vt.trim ? wt.trim() : wt));
    }
    function Ss(wt) {
      wt.note = wt;
    }
    function is(wt, _t) {
      var Ve = Dn.parser(!0, {}), Ze = {};
      return Tn = Ze, Vt = xn.copyOptions(_t), xn.ensureFlagExists("ignoreDeclaration", Vt), xn.ensureFlagExists("ignoreInstruction", Vt), xn.ensureFlagExists("ignoreAttributes", Vt), xn.ensureFlagExists("ignoreText", Vt), xn.ensureFlagExists("ignoreComment", Vt), xn.ensureFlagExists("ignoreCdata", Vt), xn.ensureFlagExists("ignoreDoctype", Vt), xn.ensureFlagExists("compact", Vt), xn.ensureFlagExists("alwaysChildren", Vt), xn.ensureFlagExists("addParent", Vt), xn.ensureFlagExists("trim", Vt), xn.ensureFlagExists("nativeType", Vt), xn.ensureFlagExists("nativeTypeAttributes", Vt), xn.ensureFlagExists("sanitize", Vt), xn.ensureFlagExists("instructionHasAttributes", Vt), xn.ensureFlagExists("captureSpacesBetweenElements", Vt), xn.ensureAlwaysArrayExists(Vt), xn.ensureKeyExists("declaration", Vt), xn.ensureKeyExists("instruction", Vt), xn.ensureKeyExists("attributes", Vt), xn.ensureKeyExists("text", Vt), xn.ensureKeyExists("comment", Vt), xn.ensureKeyExists("cdata", Vt), xn.ensureKeyExists("doctype", Vt), xn.ensureKeyExists("type", Vt), xn.ensureKeyExists("name", Vt), xn.ensureKeyExists("elements", Vt), xn.ensureKeyExists("parent", Vt), xn.checkFnExists("doctype", Vt), xn.checkFnExists("instruction", Vt), xn.checkFnExists("cdata", Vt), xn.checkFnExists("comment", Vt), xn.checkFnExists("text", Vt), xn.checkFnExists("instructionName", Vt), xn.checkFnExists("elementName", Vt), xn.checkFnExists("attributeName", Vt), xn.checkFnExists("attributeValue", Vt), xn.checkFnExists("attributes", Vt), Ve.opt = { strictEntities: !0 }, Ve.onopentag = cs, Ve.ontext = Gn, Ve.oncomment = Jn, Ve.onclosetag = Xn, Ve.onerror = Ss, Ve.oncdata = rr, Ve.ondoctype = _r, Ve.onprocessinginstruction = br, Ve.write(wt).close(), Ze[Vt.elementsKey] && (_t = Ze[Vt.elementsKey], delete Ze[Vt.elementsKey], Ze[Vt.elementsKey] = _t, delete Ze.text), Ze;
    }
    var Ms = Io, ls = is, Ur, Qr, Fr = Io, Lr = Rn;
    function Hr(wt, _t, Ve) {
      return (!Ve && wt.spaces ? `
` : "") + Array(_t + 1).join(wt.spaces);
    }
    function ns(wt, _t, Ve) {
      if (_t.ignoreAttributes)
        return "";
      var Ze, bt, Ut, mn, nn = [];
      for (Ze in wt = "attributesFn" in _t ? _t.attributesFn(wt, Qr, Ur) : wt)
        wt.hasOwnProperty(Ze) && wt[Ze] !== null && wt[Ze] !== void 0 && (mn = _t.noQuotesForNativeAttributes && typeof wt[Ze] != "string" ? "" : '"', bt = (bt = "" + wt[Ze]).replace(/"/g, "&quot;"), Ut = "attributeNameFn" in _t ? _t.attributeNameFn(Ze, bt, Qr, Ur) : Ze, nn.push(_t.spaces && _t.indentAttributes ? Hr(_t, Ve + 1, !1) : " "), nn.push(Ut + "=" + mn + ("attributeValueFn" in _t ? _t.attributeValueFn(bt, Ze, Qr, Ur) : bt) + mn));
      return wt && Object.keys(wt).length && _t.spaces && _t.indentAttributes && nn.push(Hr(_t, Ve, !1)), nn.join("");
    }
    function Ts(wt, _t, Ve) {
      return Ur = wt, Qr = "xml", _t.ignoreDeclaration ? "" : "<?xml" + ns(wt[_t.attributesKey], _t, Ve) + "?>";
    }
    function en(wt, _t, Ve) {
      if (_t.ignoreInstruction)
        return "";
      for (var Ze in wt)
        if (wt.hasOwnProperty(Ze))
          break;
      var bt = "instructionNameFn" in _t ? _t.instructionNameFn(Ze, wt[Ze], Qr, Ur) : Ze;
      return typeof wt[Ze] == "object" ? "<?" + (Qr = bt) + ns((Ur = wt)[Ze][_t.attributesKey], _t, Ve) + "?>" : (Ve = wt[Ze] || "", "<?" + bt + ((Ve = "instructionFn" in _t ? _t.instructionFn(Ve, Ze, Qr, Ur) : Ve) ? " " + Ve : "") + "?>");
    }
    function to(wt, _t) {
      return _t.ignoreComment ? "" : "<!--" + ("commentFn" in _t ? _t.commentFn(wt, Qr, Ur) : wt) + "-->";
    }
    function bs(wt, _t) {
      return _t.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in _t ? _t.cdataFn(wt, Qr, Ur) : wt.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
    }
    function jn(wt, _t) {
      return _t.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in _t ? _t.doctypeFn(wt, Qr, Ur) : wt) + ">";
    }
    function lr(wt, _t) {
      return _t.ignoreText ? "" : (wt = (wt = (wt = "" + wt).replace(/&amp;/g, "&")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "textFn" in _t ? _t.textFn(wt, Qr, Ur) : wt);
    }
    function pr(wt, _t, Ve) {
      Qr = (Ur = wt).name;
      var Ze = [], bt = "elementNameFn" in _t ? _t.elementNameFn(wt.name, wt) : wt.name, Ut = (Ze.push("<" + bt), wt[_t.attributesKey] && Ze.push(ns(wt[_t.attributesKey], _t, Ve)), wt[_t.elementsKey] && wt[_t.elementsKey].length || wt[_t.attributesKey] && wt[_t.attributesKey]["xml:space"] === "preserve");
      return (Ut = Ut || ("fullTagEmptyElementFn" in _t ? _t.fullTagEmptyElementFn(wt.name, wt) : _t.fullTagEmptyElement)) ? (Ze.push(">"), wt[_t.elementsKey] && wt[_t.elementsKey].length && (Ze.push(En(wt[_t.elementsKey], _t, Ve + 1)), Qr = (Ur = wt).name), Ze.push(_t.spaces && function(mn, nn) {
        var Sn;
        if (mn.elements && mn.elements.length)
          for (Sn = 0; Sn < mn.elements.length; ++Sn)
            switch (mn.elements[Sn][nn.typeKey]) {
              case "text":
                if (nn.indentText)
                  return 1;
                break;
              case "cdata":
                if (nn.indentCdata)
                  return 1;
                break;
              case "instruction":
                if (nn.indentInstruction)
                  return 1;
                break;
              default:
                return 1;
            }
      }(wt, _t) ? `
` + Array(Ve + 1).join(_t.spaces) : ""), Ze.push("</" + bt + ">")) : Ze.push("/>"), Ze.join("");
    }
    function En(wt, _t, Ve, Ze) {
      return wt.reduce(function(bt, Ut) {
        var mn = Hr(_t, Ve, Ze && !bt);
        switch (Ut.type) {
          case "element":
            return bt + mn + pr(Ut, _t, Ve);
          case "comment":
            return bt + mn + to(Ut[_t.commentKey], _t);
          case "doctype":
            return bt + mn + jn(Ut[_t.doctypeKey], _t);
          case "cdata":
            return bt + (_t.indentCdata ? mn : "") + bs(Ut[_t.cdataKey], _t);
          case "text":
            return bt + (_t.indentText ? mn : "") + lr(Ut[_t.textKey], _t);
          case "instruction":
            var nn = {};
            return nn[Ut[_t.nameKey]] = Ut[_t.attributesKey] ? Ut : Ut[_t.instructionKey], bt + (_t.indentInstruction ? mn : "") + en(nn, _t, Ve);
        }
      }, "");
    }
    function qn(wt, _t, Ve) {
      for (var Ze in wt)
        if (wt.hasOwnProperty(Ze))
          switch (Ze) {
            case _t.parentKey:
            case _t.attributesKey:
              break;
            case _t.textKey:
              if (_t.indentText || Ve)
                return !0;
              break;
            case _t.cdataKey:
              if (_t.indentCdata || Ve)
                return !0;
              break;
            case _t.instructionKey:
              if (_t.indentInstruction || Ve)
                return !0;
              break;
            case _t.doctypeKey:
            case _t.commentKey:
            default:
              return !0;
          }
      return !1;
    }
    function Wn(wt, _t, Ve, Ze) {
      var bt, Ut, mn, nn = [];
      for (Ut in wt)
        if (wt.hasOwnProperty(Ut))
          for (mn = Lr(wt[Ut]) ? wt[Ut] : [wt[Ut]], bt = 0; bt < mn.length; ++bt) {
            switch (Ut) {
              case _t.declarationKey:
                nn.push(Ts(mn[bt], _t, Ve));
                break;
              case _t.instructionKey:
                nn.push((_t.indentInstruction ? Hr(_t, Ve, Ze) : "") + en(mn[bt], _t, Ve));
                break;
              case _t.attributesKey:
              case _t.parentKey:
                break;
              case _t.textKey:
                nn.push((_t.indentText ? Hr(_t, Ve, Ze) : "") + lr(mn[bt], _t));
                break;
              case _t.cdataKey:
                nn.push((_t.indentCdata ? Hr(_t, Ve, Ze) : "") + bs(mn[bt], _t));
                break;
              case _t.doctypeKey:
                nn.push(Hr(_t, Ve, Ze) + jn(mn[bt], _t));
                break;
              case _t.commentKey:
                nn.push(Hr(_t, Ve, Ze) + to(mn[bt], _t));
                break;
              default:
                nn.push(Hr(_t, Ve, Ze) + function(Sn, Mn, yn, Pt, tr) {
                  Ur = Sn, Qr = Mn;
                  var Lt = "elementNameFn" in yn ? yn.elementNameFn(Mn, Sn) : Mn;
                  if (Sn == null || Sn === "")
                    return "fullTagEmptyElementFn" in yn && yn.fullTagEmptyElementFn(Mn, Sn) || yn.fullTagEmptyElement ? "<" + Lt + "></" + Lt + ">" : "<" + Lt + "/>";
                  var dr = [];
                  if (Mn) {
                    if (dr.push("<" + Lt), typeof Sn != "object")
                      return dr.push(">" + lr(Sn, yn) + "</" + Lt + ">"), dr.join("");
                    Sn[yn.attributesKey] && dr.push(ns(Sn[yn.attributesKey], yn, Pt));
                    var ur = qn(Sn, yn, !0) || Sn[yn.attributesKey] && Sn[yn.attributesKey]["xml:space"] === "preserve";
                    if (!(ur = ur || ("fullTagEmptyElementFn" in yn ? yn.fullTagEmptyElementFn(Mn, Sn) : yn.fullTagEmptyElement)))
                      return dr.push("/>"), dr.join("");
                    dr.push(">");
                  }
                  return dr.push(Wn(Sn, yn, Pt + 1, !1)), Ur = Sn, (Qr = Mn) && dr.push((tr ? Hr(yn, Pt, !1) : "") + "</" + Lt + ">"), dr.join("");
                }(mn[bt], Ut, _t, Ve, qn(mn[bt], _t)));
            }
            Ze = Ze && !nn.length;
          }
      return nn.join("");
    }
    function kn(wt, _t) {
      Ve = _t, Ve = Fr.copyOptions(Ve), Fr.ensureFlagExists("ignoreDeclaration", Ve), Fr.ensureFlagExists("ignoreInstruction", Ve), Fr.ensureFlagExists("ignoreAttributes", Ve), Fr.ensureFlagExists("ignoreText", Ve), Fr.ensureFlagExists("ignoreComment", Ve), Fr.ensureFlagExists("ignoreCdata", Ve), Fr.ensureFlagExists("ignoreDoctype", Ve), Fr.ensureFlagExists("compact", Ve), Fr.ensureFlagExists("indentText", Ve), Fr.ensureFlagExists("indentCdata", Ve), Fr.ensureFlagExists("indentAttributes", Ve), Fr.ensureFlagExists("indentInstruction", Ve), Fr.ensureFlagExists("fullTagEmptyElement", Ve), Fr.ensureFlagExists("noQuotesForNativeAttributes", Ve), Fr.ensureSpacesExists(Ve), typeof Ve.spaces == "number" && (Ve.spaces = Array(Ve.spaces + 1).join(" ")), Fr.ensureKeyExists("declaration", Ve), Fr.ensureKeyExists("instruction", Ve), Fr.ensureKeyExists("attributes", Ve), Fr.ensureKeyExists("text", Ve), Fr.ensureKeyExists("comment", Ve), Fr.ensureKeyExists("cdata", Ve), Fr.ensureKeyExists("doctype", Ve), Fr.ensureKeyExists("type", Ve), Fr.ensureKeyExists("name", Ve), Fr.ensureKeyExists("elements", Ve), Fr.checkFnExists("doctype", Ve), Fr.checkFnExists("instruction", Ve), Fr.checkFnExists("cdata", Ve), Fr.checkFnExists("comment", Ve), Fr.checkFnExists("text", Ve), Fr.checkFnExists("instructionName", Ve), Fr.checkFnExists("elementName", Ve), Fr.checkFnExists("attributeName", Ve), Fr.checkFnExists("attributeValue", Ve), Fr.checkFnExists("attributes", Ve), Fr.checkFnExists("fullTagEmptyElement", Ve);
      var Ve, Ze = [];
      return Ur = wt, Qr = "_root_", (_t = Ve).compact ? Ze.push(Wn(wt, _t, 0, !0)) : (wt[_t.declarationKey] && Ze.push(Ts(wt[_t.declarationKey], _t, 0)), wt[_t.elementsKey] && wt[_t.elementsKey].length && Ze.push(En(wt[_t.elementsKey], _t, 0, !Ze.length))), Ze.join("");
    }
    var zn, wr = kn, jr = m({ xml2js: is, xml2json: function(wt, _t) {
      var Ve;
      return _t = _t, _t = Ms.copyOptions(_t), Ms.ensureSpacesExists(_t), _t = ls(wt, wt = _t), Ve = "compact" in wt && wt.compact ? "_parent" : "parent", ("addParent" in wt && wt.addParent ? JSON.stringify(_t, function(Ze, bt) {
        return Ze === Ve ? "_" : bt;
      }, wt.spaces) : JSON.stringify(_t, null, wt.spaces)).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }, js2xml: kn, json2xml: function(wt, _t) {
      var Ve = null;
      if (typeof (wt = wt instanceof buffer$1.Buffer ? wt.toString() : wt) == "string")
        try {
          Ve = JSON.parse(wt);
        } catch {
          throw new Error("The JSON structure is invalid");
        }
      else
        Ve = wt;
      return wr(Ve, _t);
    } }), Vr = { raster: {}, vector: {} };
    function us(wt) {
      return wt && (wt = jr.xml2js(wt), wt.elements && 0 < wt.elements.length && (wt.elements.length !== 1 && console.warn("invalid xml!"), wt.elements[0]) && wt.elements[0].elements) ? wt.elements[0].elements.map(function(_t) {
        var Ve = _t.attributes;
        return _t.elements && 0 < _t.elements.length && (Ve.options = _t.elements.map(function(Ze) {
          return Ze.elements[0].text;
        })), Ve;
      }) : null;
    }
    function Es() {
      for (var wt, _t, Ve, Ze = G.GDALGetDriverCount(), bt = 0; bt < Ze; bt += 1) {
        var Ut = G.GDALGetDriver(bt), mn = (Ut = Ut, Ve = _t = mn = wt = void 0, wt = G.GDALGetMetadataItem(Ut, "DMD_EXTENSIONS", null), (mn = (mn = G.GDALGetMetadataItem(Ut, "DMD_EXTENSION", null)) === "" && wt !== "" ? wt.split(" ")[0] : mn) !== "" && (mn = mn.replace(".", "").replace("/", "")), (_t = G.GDALGetDescription(Ut)) === "GeoJSON" && (mn = "geojson"), Ve = G.GDALGetMetadataItem(Ut, "DMD_LONGNAME", null), { extension: mn, extensions: wt, shortName: _t, longName: Ve, isReadable: G.GDALGetMetadataItem(Ut, "DCAP_OPEN", null) === "YES", isWritable: G.GDALGetMetadataItem(Ut, "DCAP_CREATE", null) === "YES" || G.GDALGetMetadataItem(Ut, "DCAP_CREATECOPY", null) === "YES", isRaster: G.GDALGetMetadataItem(Ut, "DCAP_RASTER", null) === "YES", isVector: G.GDALGetMetadataItem(Ut, "DCAP_VECTOR", null) === "YES", openOptionsList: us(G.GDALGetMetadataItem(Ut, "DMD_OPENOPTIONLIST", null)), creationOptionList: us(G.GDALGetMetadataItem(Ut, "DMD_CREATIONOPTIONLIST", null)), layerCreationOptionList: us(G.GDALGetMetadataItem(Ut, "DS_LAYER_CREATIONOPTIONLIST", null)), helpUrl: G.GDALGetMetadataItem(Ut, "DMD_HELPTOPIC", null) });
        mn.isRaster && (Vr.raster[mn.shortName] = u(u({ index: bt }, mn), {}, { type: "raster" })), mn.isVector && (Vr.vector[mn.shortName] = u(u({ index: bt }, mn), {}, { type: "vector" }));
      }
    }
    function Dr(wt) {
      var _t = G.GDALGetFileList(wt);
      if (!_t)
        return [];
      for (var Ve = [], Ze = 0; Ze < 100; Ze += 1) {
        var bt = G.Module.HEAP32[_t + 4 * Ze >> 2];
        if (bt === 0)
          break;
        bt = G.Module.UTF8ToString(bt), Ve.push(bt);
      }
      return Ve;
    }
    function Kr(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [];
      return new Promise(function(Ve, Ze) {
        var bt = fe(["-json"].concat(f(_t))), Ut = bt.config, Ut = (Object.entries(Ut).forEach(function(Mn) {
          var Mn = d(Mn, 2), Sn = Mn[0], Mn = Mn[1];
          G.CPLSetConfigOption(Sn, Mn);
        }), G.GDALInfoOptionsNew(bt.ptr, null)), mn = G.GDALInfo(wt.pointer, Ut);
        G.GDALInfoOptionsFree(Ut), _e(bt), 3 <= G.CPLGetLastErrorNo() ? Ze(q()) : Ve(JSON.parse(mn));
      });
    }
    function Js(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [];
      return new Promise(function(Ve, Ze) {
        var bt = fe(["-json"].concat(f(_t))), Ut = bt.config, Ut = (Object.entries(Ut).forEach(function(Mn) {
          var Mn = d(Mn, 2), Sn = Mn[0], Mn = Mn[1];
          G.CPLSetConfigOption(Sn, Mn);
        }), G.GDALVectorInfoOptionsNew(bt.ptr, null)), mn = G.GDALVectorInfo(wt.pointer, Ut);
        G.GDALVectorInfoOptionsFree(Ut), _e(bt), 3 <= G.CPLGetLastErrorNo() ? Ze(q()) : Ve(JSON.parse(mn));
      });
    }
    function io() {
      !_ && typeof importScripts != "function" || G.Module.FS.unmount(Le);
    }
    var No = { ogr2ogr: function(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], Ve = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ze, bt) {
        var Ut = fe(_t), mn = Ut.config, mn = (Object.entries(mn).forEach(function(dr) {
          var dr = d(dr, 2), Lt = dr[0], dr = dr[1];
          G.CPLSetConfigOption(Lt, dr);
        }), G.GDALVectorTranslateOptionsNew(Ut.ptr, null)), yn = G.Module._malloc(4), Sn = (G.Module.setValue(yn, wt.pointer, "*"), _t.indexOf("-f") + 1), nn = "unknown", Sn = (Sn !== 0 && (Sn = _t[Sn], Mn = Vr.vector[Sn]) && (nn = Sn === "MapInfo File" && _t.indexOf("FORMAT=MIF") !== -1 ? "mif" : Mn.extension), Ve || wt.path.split(".", 1)[0]), Mn = "".concat(Fe, "/").concat(Sn, ".").concat(nn), yn = G.GDALVectorTranslate(Mn, null, 1, yn, mn, null), Pt = Dr(yn);
        G.GDALVectorTranslateOptionsFree(mn), _e(Ut), G.GDALClose(yn), 3 <= G.CPLGetLastErrorNo() ? bt(q()) : Ze({ local: Mn, real: "".concat(Ee, "/").concat(Sn, ".").concat(nn), all: Pt.map(function(tr) {
          return { local: tr, real: tr.replace("".concat(Fe, "/"), "".concat(Ee, "/")) };
        }) });
      });
    }, gdal_translate: function(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], Ve = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ze, bt) {
        var Ut = fe(_t), mn = Ut.config, mn = (Object.entries(mn).forEach(function(dr) {
          var dr = d(dr, 2), Lt = dr[0], dr = dr[1];
          G.CPLSetConfigOption(Lt, dr);
        }), G.GDALTranslateOptionsNew(Ut.ptr, null)), Sn = _t.indexOf("-of") + 1, nn = "unknown", Sn = (Sn !== 0 && (Sn = _t[Sn], Sn = Vr.raster[Sn]) && (nn = Sn.extension), Ve || wt.path.split(".", 1)[0]), Mn = "".concat(Fe, "/").concat(Sn, ".").concat(nn), yn = G.GDALTranslate(Mn, wt.pointer, mn, null), Pt = Dr(yn);
        G.GDALTranslateOptionsFree(mn), _e(Ut), G.GDALClose(yn), 3 <= G.CPLGetLastErrorNo() ? bt(q()) : Ze({ local: Mn, real: "".concat(Ee, "/").concat(Sn, ".").concat(nn), all: Pt.map(function(tr) {
          return { local: tr, real: tr.replace("".concat(Fe, "/"), "".concat(Ee, "/")) };
        }) });
      });
    }, gdal_rasterize: function(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], Ve = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ze, bt) {
        var Ut = fe(_t), mn = Ut.config, mn = (Object.entries(mn).forEach(function(dr) {
          var dr = d(dr, 2), Lt = dr[0], dr = dr[1];
          G.CPLSetConfigOption(Lt, dr);
        }), G.GDALRasterizeOptionsNew(Ut.ptr, null)), Sn = _t.indexOf("-of") + 1, nn = "tif", Sn = (Sn !== 0 && (Sn = _t[Sn], Sn = Vr.raster[Sn]) && (nn = Sn.extension), Ve || wt.path.split(".", 1)[0]), Mn = "".concat(Fe, "/").concat(Sn, ".").concat(nn), yn = G.GDALRasterize(Mn, null, wt.pointer, mn, null), Pt = Dr(yn);
        G.GDALRasterizeOptionsFree(mn), _e(Ut), G.GDALClose(yn), 3 <= G.CPLGetLastErrorNo() ? bt(q()) : Ze({ local: Mn, real: "".concat(Ee, "/").concat(Sn, ".").concat(nn), all: Pt.map(function(tr) {
          return { local: tr, real: tr.replace("".concat(Fe, "/"), "".concat(Ee, "/")) };
        }) });
      });
    }, gdalwarp: function(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], Ve = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ze, bt) {
        var Ut = fe(_t), mn = Ut.config, mn = (Object.entries(mn).forEach(function(dr) {
          var dr = d(dr, 2), Lt = dr[0], dr = dr[1];
          G.CPLSetConfigOption(Lt, dr);
        }), G.GDALWarpAppOptionsNew(Ut.ptr, null)), yn = G.Module._malloc(4), Sn = (G.Module.setValue(yn, wt.pointer, "*"), _t.indexOf("-of") + 1), nn = "unknown", Sn = (Sn !== 0 && (Sn = _t[Sn], Sn = Vr.raster[Sn]) && (nn = Sn.extension), Ve || wt.path.split(".", 1)[0]), Mn = "".concat(Fe, "/").concat(Sn, ".").concat(nn), yn = G.GDALWarp(Mn, null, 1, yn, mn, null), Pt = Dr(yn);
        G.GDALWarpAppOptionsFree(mn), _e(Ut), G.GDALClose(yn), 3 <= G.CPLGetLastErrorNo() ? bt(q()) : Ze({ local: Mn, real: "".concat(Ee, "/").concat(Sn, ".").concat(nn), all: Pt.map(function(tr) {
          return { local: tr, real: tr.replace("".concat(Fe, "/"), "".concat(Ee, "/")) };
        }) });
      });
    }, gdaltransform: function(wt, _t) {
      return new Promise(function(Ve) {
        for (var Ze = new Float64Array(wt.map(function(as) {
          return as[0];
        })), bt = new Float64Array(wt.map(function(as) {
          return as[1];
        })), Ut = new Float64Array(wt.map(function(as) {
          return as[2] || 0;
        })), mn = G.Module._malloc(Ze.length * Ze.BYTES_PER_ELEMENT), nn = G.Module._malloc(bt.length * bt.BYTES_PER_ELEMENT), Sn = G.Module._malloc(Ut.length * Ut.BYTES_PER_ELEMENT), Mn = (G.Module.HEAPF64.set(Ze, mn / Ze.BYTES_PER_ELEMENT), G.Module.HEAPF64.set(bt, nn / bt.BYTES_PER_ELEMENT), G.Module.HEAPF64.set(Ut, Sn / Ut.BYTES_PER_ELEMENT), !1), yn = !1, Pt = [], tr = 0; tr < _t.length; tr += 1)
          switch (_t[tr]) {
            case "-s_srs":
              Pt.push("SRC_SRS=".concat(_t[tr += 1]));
              break;
            case "-t_srs":
              Pt.push("DST_SRS=".concat(_t[tr += 1]));
              break;
            case "-ct":
              Pt.push("COORDINATE_OPERATION=".concat(_t[tr += 1]));
              break;
            case "-order":
              Pt.push("MAX_GCP_ORDER=".concat(_t[tr += 1]));
              break;
            case "-tps":
              Pt.push("METHOD=GCP_TPS");
              break;
            case "-rpc":
              Pt.push("METHOD=RPC");
              break;
            case "-geoloc":
              Pt.push("METHOD=GEOLOC_ARRAY");
              break;
            case "-i":
              Mn = !0;
              break;
            case "-to":
              Pt.push("".concat(_t[tr += 1]));
              break;
            case "-output_xy":
              yn = !0;
          }
        for (var Lt = fe(Pt), dr = G.GDALCreateGenImgProjTransformer2(null, null, Lt.ptr), ur = (G.GDALGenImgProjTransform(dr, Mn, wt.length, mn, nn, Sn, null), [Array.from(G.Module.HEAPF64.subarray(mn / Ze.BYTES_PER_ELEMENT, mn / Ze.BYTES_PER_ELEMENT + Ze.length)), Array.from(G.Module.HEAPF64.subarray(nn / bt.BYTES_PER_ELEMENT, nn / bt.BYTES_PER_ELEMENT + bt.length)), Array.from(G.Module.HEAPF64.subarray(Sn / Ut.BYTES_PER_ELEMENT, Sn / Ut.BYTES_PER_ELEMENT + Ut.length))]), gr = [], Rr = 0; Rr < ur[0].length; Rr += 1)
          gr.push(yn ? [ur[0][Rr], ur[1][Rr]] : [ur[0][Rr], ur[1][Rr], ur[2][Rr]]);
        G.Module._free(mn), G.Module._free(nn), G.Module._free(Sn), _e(Lt), G.GDALDestroyGenImgProjTransformer(dr), Ve(gr);
      });
    }, gdal_location_info: function(wt, _t) {
      return new Promise(function(Ve, Ze) {
        var bt = G.OSRNewSpatialReference('GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]'), nn = (G.OSRSetAxisMappingStrategy(bt, 0), G.GDALGetSpatialRef(wt.pointer)), bt = G.OCTNewCoordinateTransformation(bt, nn), nn = G.CPLAtof(String(_t[0])), Ut = G.CPLAtof(String(_t[1])), mn = G.Module._malloc(8), nn = (G.Module.setValue(mn, nn, "double"), G.Module._malloc(8));
        G.Module.setValue(nn, Ut, "double"), G.OCTTransform(bt, 1, nn, mn, null) || Ze(new Error("Failed to perform OCTTransform")), Ut = G.Module.getValue(nn, "double"), bt = G.Module.getValue(mn, "double"), nn = G.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), G.GDALGetGeoTransform(wt.pointer, nn), mn = G.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), G.GDALInvGeoTransform(nn, mn) || Ze(new Error("Failed to invert transform")), nn = G.Module.HEAPF64.subarray(mn / Float64Array.BYTES_PER_ELEMENT, mn / Float64Array.BYTES_PER_ELEMENT + 6), Ve({ pixel: Math.floor(nn[0] + nn[1] * Ut + nn[2] * bt), line: Math.floor(nn[3] + nn[4] * Ut + nn[5] * bt) });
      });
    }, gdalinfo: Kr, ogrinfo: Js, open: function(wt) {
      var _t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], Ve = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : [], Ze = wt, bt = fe(_t);
      return Array.isArray(Ze) || typeof FileList == "function" && Ze instanceof FileList || (Ze = [Ze]), new Promise(function(Ut, mn) {
        var nn, Sn = [], Mn = [];
        f(Ze).forEach(function(yn) {
          !(typeof yn == "string" || yn instanceof String) || yn.substring(0, Le.length + 1) !== "".concat(Le, "/") && yn.substring(0, Fe.length + 1) !== "".concat(Fe, "/") ? Mn.push(yn) : Sn.push({ name: yn.substring(yn.indexOf("/", 1) + 1), internal: !0, prefix: yn.substring(0, yn.indexOf("/", 1)) });
        }), nn = Mn, new Promise(function(yn) {
          var Pt, tr;
          nn.length === 0 ? yn([]) : _ ? (Pt = [], nn.forEach(function(ur) {
            var ur = ur.split("/"), dr = ur.pop(), ur = ur.join("/") || ".";
            zn !== ur && (zn && io(), zn = ur, G.Module.FS.mount(G.Module.NODEFS, { root: ur }, Le)), Pt.push({ name: dr });
          }), yn(Pt)) : typeof importScripts == "function" ? (zn && io(), G.Module.FS.mount(G.Module.WORKERFS, { files: nn }, Le), zn = !0, yn(nn)) : (tr = [], nn.forEach(function(Lt) {
            tr.push(Lt.arrayBuffer());
          }), Promise.all(tr).then(function(Lt) {
            Lt.forEach(function(dr, ur) {
              dr = new Uint8Array(dr), G.Module.FS.writeFile("".concat(Le, "/").concat(nn[ur].name), dr);
            }), yn(nn);
          }));
        }).then(function(yn) {
          for (var Pt = [].concat(f(yn), Sn), tr = [], Lt = (G.CPLErrorReset(), {}), dr = [], ur = function() {
            var Rr = Pt[gr].name, as = Rr.split(".", 1)[0];
            if (Lt[as] || (Lt[as] = {}), Lt[as].pointer)
              return 0;
            Lt[as].path = Rr;
            var hs = Ve && Ve.length ? "/".concat(Ve.join("/"), "/") : "", Os = "".concat(hs).concat(Le, "/").concat(Rr), jo = (Pt[gr].internal && (Os = "".concat(hs).concat(Pt[gr].prefix, "/").concat(Rr)), G.GDALOpenEx(Os, null, null, bt.ptr, null));
            if (jo === 0)
              return hs = q(), tr.push(hs), delete Lt[as], 0;
            Lt[as].pointer = jo;
            function po() {
              var So = G.GDALGetRasterCount(jo), Eo = G.GDALDatasetGetLayerCount(jo);
              Lt[as].type = 0 < So && Eo === 0 ? "raster" : "vector";
            }
            Rr = Kr(Lt[as]).then(function(So) {
              if (So && So.bands) {
                var Eo = So.size && 2 <= So.size.length && (0 < So.size[0] || 0 < So.size[1]);
                if (Lt[as].type = 0 < So.bands.length && Eo ? "raster" : "vector", Lt[as].type === "vector")
                  return Js(Lt[as]).then(function(Ps) {
                    Lt[as].info = Ps;
                  });
                Lt[as].info = So;
              } else
                po();
              return !0;
            }).catch(po), dr.push(Rr);
          }, gr = 0; gr < Pt.length; gr += 1)
            ur();
          _e(bt), Promise.allSettled(dr).then(function() {
            var Rr = Object.values(Lt);
            0 < Rr.length || tr.length === 0 ? Ut({ datasets: Rr, errors: tr }) : mn(tr);
          });
        });
      });
    }, close: function(wt) {
      return new Promise(function(_t) {
        G.GDALClose(wt.pointer), _t();
      });
    }, getInfo: function(wt) {
      return new Promise(function(_t) {
        var Ve = G.GDALGetRasterCount(wt.pointer), Ze = G.GDALDatasetGetLayerCount(wt.pointer);
        if (0 < Ve && Ze === 0) {
          var bt = G.GDALGetRasterXSize(wt.pointer), Ut = G.GDALGetRasterYSize(wt.pointer), mn = G.GDALGetProjectionRef(wt.pointer), Sn = G.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), nn = (G.GDALGetGeoTransform(wt.pointer, Sn), G.Module.HEAPF64.subarray(Sn / Float64Array.BYTES_PER_ELEMENT, Sn / Float64Array.BYTES_PER_ELEMENT + 6)), Sn = [[0, 0], [bt, 0], [bt, Ut], [0, Ut]].map(function(Rr) {
            var gr = Rr[0], Rr = Rr[1];
            return [nn[0] + nn[1] * gr + nn[2] * Rr, nn[3] + nn[4] * gr + nn[5] * Rr];
          }), Mn = G.GDALGetDatasetDriver(wt.pointer), Mn = G.GDALGetDriverLongName(Mn), yn = G.OGR_DS_GetName(wt.pointer);
          _t(JSON.parse(JSON.stringify({ type: "raster", bandCount: Ve, width: bt, height: Ut, projectionWkt: mn, coordinateTransform: nn, corners: Sn, driverName: Mn, dsName: yn })));
        } else {
          for (var Pt = [], tr = 0; tr < Ze; tr += 1) {
            var dr = G.OGR_DS_GetLayer(wt.pointer, tr), Lt = G.OGR_L_GetName(dr), dr = G.OGR_L_GetFeatureCount(dr, 1);
            Pt.push({ name: Lt, featureCount: dr });
          }
          Ve = Pt.reduce(function(ur, gr) {
            return ur + gr.featureCount;
          }, 0), bt = G.OGR_DS_GetName(wt.pointer), Ut = G.GDALGetDatasetDriver(wt.pointer), _t({ type: "vector", layerCount: Ze, featureCount: Ve, layers: Pt, dsName: bt, driverName: G.GDALGetDriverLongName(Ut) });
        }
      });
    }, getOutputFiles: function() {
      return new Promise(function(wt) {
        wt(function _t(Ve) {
          var Ze = 0 < arguments.length && Ve !== void 0 ? Ve : Fe.substr(1), bt = Ze.split("/").reduce(function(mn, nn) {
            return mn.contents[nn];
          }, G.Module.FS.root).contents, Ut = [];
          return Object.keys(bt).forEach(function(mn) {
            var nn = bt[mn];
            nn.usedBytes ? Ut.push({ path: "/".concat(Ze, "/").concat(mn), size: nn.usedBytes }) : nn.contents && Ut.push.apply(Ut, f(_t("".concat(Ze, "/").concat(mn))));
          }), Ut;
        }());
      });
    }, getFileBytes: function(wt) {
      return new Promise(function(_t) {
        var Ve;
        wt ? (Ve = wt.local || wt, _t(G.Module.FS.readFile(Ve, { encoding: "binary" }))) : _t(new Uint8Array());
      });
    }, drivers: Vr, Module: G.Module };
    function Ai(wt) {
      var _t;
      onmessage = function(Ve) {
        var Ze;
        return Ve.data && Ve.data.func === "constructor" ? (Ze = { useWorker: !1 }, Ve.data.params && Ve.data.params.config && (Ze = u(u({}, Ve.data.params.config), Ze)), (_t = wt(Ze)).then(function(bt) {
          return bt = bt.drivers, postMessage({ success: !0, id: "onload", data: bt });
        }).catch(function(bt) {
          return postMessage({ success: !1, id: "onload", data: bt });
        }), null) : _t.then((function(bt) {
          var Ut = this;
          this.data && this.data.func && bt[this.data.func] ? bt[this.data.func].apply(bt, f(this.data.params)).then(function(mn) {
            postMessage({ success: !0, id: Ut.data.id, data: mn });
          }).catch(function(mn) {
            postMessage({ success: !1, id: Ut.data.id, data: { message: mn.message } });
          }) : console.error("undefined function", this.data);
        }).bind(Ve)).catch((function(bt) {
          postMessage({ success: !1, id: this.id, data: { no: -1, message: bt.message } });
        }).bind(Ve));
      };
    }
    var go, ks = { gdalWorkerWrapper: null, drivers: null }, Ci = function() {
      function wt(Ze, bt, Ut) {
        var mn = this;
        if (!(this instanceof wt))
          throw new TypeError("Cannot call a class as a function");
        this.promises = { onload: { resolve: Ut, reject: console.error } }, this.gdalWorker = new Worker(Ze), this.gdalWorker.onmessage = function(nn) {
          nn.data && nn.data.id && mn.promises[nn.data.id] && (nn.data.success ? mn.promises[nn.data.id].resolve(nn.data.data) : mn.promises[nn.data.id].reject(nn.data.data));
        }, this.gdalWorker.postMessage({ func: "constructor", params: { config: bt } });
      }
      var _t, Ve;
      return _t = wt, (Ve = [{ key: "call", value: function(Ze) {
        var bt = this;
        return new Promise(function(Ut, mn) {
          Ze.id = Math.floor(1e5 * Math.random()), bt.promises[Ze.id] = { resolve: Ut, reject: mn }, bt.gdalWorker.postMessage(Ze);
        });
      } }, { key: "terminate", value: function() {
        this.gdalWorker.terminate(), delete this.gdalWorker, delete this.promises;
      } }]) && E(_t.prototype, Ve), Object.defineProperty(_t, "prototype", { writable: !1 }), wt;
    }(), Io = new Proxy({}, { get: function(wt, _t) {
      return _t === "then" || _t === "catch" ? wt : _t === "drivers" ? ks.drivers : function() {
        for (var Ve = arguments.length, Ze = new Array(Ve), bt = 0; bt < Ve; bt++)
          Ze[bt] = arguments[bt];
        return new Promise(function(Ut, mn) {
          ks.gdalWorkerWrapper.call({ func: _t, params: Ze }).then(function(nn) {
            Ut(nn);
          }).catch(function(nn) {
            return mn(nn);
          });
        });
      };
    } }), Oo = { variables: ks, WorkerWrapper: Ci, gdalProxy: Io };
    function Zs() {
      var wt, _t, Ve = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
      return go = go || (_ || Ve.useWorker === !1 ? new Promise(function(Ze, bt) {
        var Ut = G.Module, mn = Ut.onAbort;
        Ut.onAbort = function(nn) {
          bt(new Error(nn)), mn && mn(nn);
        }, Ut.print = function(nn) {
          Ve.logHandler ? Ve.logHandler(nn, "stdout") : console.debug("gdal stdout: ".concat(nn));
        }, Ut.printErr = function(nn) {
          Ve.errorHandler ? Ve.errorHandler(nn, "stderr") : console.error("gdal stderr: ".concat(nn));
        }, Ut.preRun = [function(nn) {
          var Sn = nn.ENV;
          Sn.PROJ_LIB = "/usr/share/proj", Sn.GDAL_DATA = "/usr/share/gdal", Sn.DXF_FEATURE_LIMIT_PER_BLOCK = "-1", Sn.GDAL_NUM_THREADS = "0", Sn.GDAL_ENABLE_DEPRECATED_DRIVER_GTM = "YES", Sn.CPL_LOG_ERRORS = "ON", Ve.env && Object.entries(Ve.env).forEach(function(Pt) {
            var Pt = d(Pt, 2), yn = Pt[0], Pt = Pt[1];
            Sn[yn] = Pt;
          });
        }], Ut.onRuntimeInitialized = function() {
          var nn, Sn;
          G.GDALOpen || ((Sn = G.Module).ccall("GDALAllRegister", null, [], []), G.GDALOpen = Sn.cwrap("GDALOpen", "number", ["string"]), G.GDALOpenEx = Sn.cwrap("GDALOpenEx", "number", ["string", "number", "number", "number", "number"]), G.GDALClose = Sn.cwrap("GDALClose", null, ["number"]), G.CPLErrorReset = Sn.cwrap("CPLErrorReset", null, []), G.CPLSetErrorHandler = Sn.cwrap("CPLSetErrorHandler", "number", ["number"]), G.CPLQuietErrorHandler = Sn.cwrap("CPLQuietErrorHandler", null, ["number", "number", "string"]), G.CPLGetLastErrorNo = Sn.cwrap("CPLGetLastErrorNo", "number", []), G.CPLGetLastErrorMsg = Sn.cwrap("CPLGetLastErrorMsg", "string", []), G.CPLGetLastErrorType = Sn.cwrap("CPLGetLastErrorType", "number", []), G.CPLSetConfigOption = Sn.cwrap("CPLSetConfigOption", null, ["string", "string"]), G.CPLSetThreadLocalConfigOption = Sn.cwrap("CPLSetThreadLocalConfigOption", null, ["string", "string"]), G.GDALGetRasterCount = Sn.cwrap("GDALGetRasterCount", "number", ["number"]), G.GDALGetRasterXSize = Sn.cwrap("GDALGetRasterXSize", "number", ["number"]), G.GDALGetRasterYSize = Sn.cwrap("GDALGetRasterYSize", "number", ["number"]), G.GDALGetProjectionRef = Sn.cwrap("GDALGetProjectionRef", "string", ["number"]), G.GDALGetGeoTransform = Sn.cwrap("GDALGetGeoTransform", "number", ["number", "number"]), G.GDALInvGeoTransform = Sn.cwrap("GDALInvGeoTransform", "number", ["number", "number"]), G.GDALVectorTranslate = Sn.cwrap("GDALVectorTranslate", "number", ["string", "number", "number", "number", "number", "number"]), G.GDALVectorTranslateOptionsNew = Sn.cwrap("GDALVectorTranslateOptionsNew", "number", ["number", "number"]), G.GDALVectorTranslateOptionsFree = Sn.cwrap("GDALVectorTranslateOptionsFree", "number", ["number"]), G.GDALDatasetGetLayerCount = Sn.cwrap("GDALDatasetGetLayerCount", "number", ["number"]), G.GDALDatasetGetLayer = Sn.cwrap("GDALDatasetGetLayer", "number", ["number", "number"]), G.OGR_DS_GetLayerCount = Sn.cwrap("OGR_DS_GetLayerCount", "number", ["number"]), G.OGR_DS_GetName = Sn.cwrap("OGR_DS_GetName", "string", ["number"]), G.OGR_DS_GetLayer = Sn.cwrap("OGR_DS_GetLayer", "number", ["number", "number"]), G.OGR_L_GetName = Sn.cwrap("OGR_L_GetName", "string", ["number"]), G.OGR_DS_GetDriver = Sn.cwrap("OGR_DS_GetDriver", "number", ["number"]), G.OGR_Dr_GetName = Sn.cwrap("OGR_Dr_GetName", "string", ["number"]), G.GDALGetDatasetDriver = Sn.cwrap("GDALGetDatasetDriver", "number", ["number"]), G.GDALGetDriverLongName = Sn.cwrap("GDALGetDriverLongName", "string", ["number"]), G.GDALGetDriverShortName = Sn.cwrap("GDALGetDriverShortName", "string", ["number"]), G.GDALTranslate = Sn.cwrap("GDALTranslate", "number", ["string", "number", "number", "number"]), G.GDALTranslateOptionsNew = Sn.cwrap("GDALTranslateOptionsNew", "number", ["number", "number"]), G.GDALTranslateOptionsFree = Sn.cwrap("GDALTranslateOptionsFree", "number", ["number"]), G.GDALRasterize = Sn.cwrap("GDALRasterize", "number", ["string", "number", "number", "number", "number"]), G.GDALRasterizeOptionsNew = Sn.cwrap("GDALRasterizeOptionsNew", "number", ["number", "number"]), G.GDALRasterizeOptionsFree = Sn.cwrap("GDALRasterizeOptionsFree", "number", ["number"]), G.GDALWarp = Sn.cwrap("GDALWarp", "number", ["string", "number", "number", "number", "number", "number"]), G.GDALWarpAppOptionsNew = Sn.cwrap("GDALWarpAppOptionsNew", "number", ["number", "number"]), G.GDALWarpAppOptionsSetProgress = Sn.cwrap("GDALWarpAppOptionsSetProgress", "number", ["number", "number", "number"]), G.GDALWarpAppOptionsFree = Sn.cwrap("GDALWarpAppOptionsFree", "number", ["number"]), G.OSRNewSpatialReference = Sn.cwrap("OSRNewSpatialReference", "number", ["string"]), G.OSRDestroySpatialReference = Sn.cwrap("OSRDestroySpatialReference", "number", ["number"]), G.OCTNewCoordinateTransformation = Sn.cwrap("OCTNewCoordinateTransformation", "number", ["number", "number"]), G.OCTDestroyCoordinateTransformation = Sn.cwrap("OCTDestroyCoordinateTransformation", "number", ["number"]), G.OCTTransform = Sn.cwrap("OCTTransform", "number", ["number", "number", "number", "number", "number"]), G.GDALGetDriverCount = Sn.cwrap("GDALGetDriverCount", "number", []), G.OGRGetDriverCount = Sn.cwrap("OGRGetDriverCount", "number", []), G.GDALGetDriver = Sn.cwrap("GDALGetDriver", "number", ["number"]), G.OGRGetDriver = Sn.cwrap("OGRGetDriver", "number", ["number"]), G.GDALGetMetadataItem = Sn.cwrap("GDALGetMetadataItem", "string", ["number", "string", "string"]), G.GDALGetDescription = Sn.cwrap("GDALGetDescription", "string", ["number"]), G.OGR_L_GetFeatureCount = Sn.cwrap("OGR_L_GetFeatureCount", "number", ["number", "number"]), G.GDALGenImgProjTransform = Sn.cwrap("GDALGenImgProjTransform", "number", ["number", "number", "number", "number", "number", "number", "number"]), G.GDALCreateGenImgProjTransformer2 = Sn.cwrap("GDALCreateGenImgProjTransformer2", "number", ["number", "number", "number"]), G.GDALDestroyGenImgProjTransformer = Sn.cwrap("GDALDestroyGenImgProjTransformer", null, ["number"]), G.OSRSetFromUserInput = Sn.cwrap("OSRSetFromUserInput", "number", ["number", "string"]), G.OSRExportToWkt = Sn.cwrap("OSRExportToWkt", "number", ["number", "number"]), G.GDALGetSpatialRef = Sn.cwrap("GDALGetSpatialRef", "number", ["number"]), G.CPLAtof = Sn.cwrap("CPLAtof", "number", ["string"]), G.OSRSetAxisMappingStrategy = Sn.cwrap("OSRSetAxisMappingStrategy", null, ["number", "number"]), G.GDALInfo = Sn.cwrap("GDALInfo", "string", ["number", "number"]), G.GDALInfoOptionsNew = Sn.cwrap("GDALInfoOptionsNew", "number", ["number", "number"]), G.GDALInfoOptionsFree = Sn.cwrap("GDALInfoOptionsFree", null, ["number"]), G.GDALVectorInfo = Sn.cwrap("GDALVectorInfo", "string", ["number", "number"]), G.GDALVectorInfoOptionsNew = Sn.cwrap("GDALVectorInfoOptionsNew", "number", ["number", "number"]), G.GDALVectorInfoOptionsFree = Sn.cwrap("GDALVectorInfoOptionsFree", null, ["number"]), G.GDALGetFileList = Sn.cwrap("GDALGetFileList", "number", ["number"])), Ut.FS.mkdir(Le), Ut.FS.mkdir(Fe), Ve.dest && (Sn = Ve.dest, Ee = Sn, nn = Ve.dest, _) && G.Module.FS.mount(G.Module.NODEFS, { root: nn }, Fe), Es();
        }, Ut.locateFile = function(Mn) {
          var Sn = Mn, Mn = (Ve.paths && Ve.paths.wasm && Mn.split(".").pop() === "wasm" ? Sn = Ve.paths.wasm : Ve.paths && Ve.paths.data && Mn.split(".").pop() === "data" && (Sn = Ve.paths.data), ""), Mn = (Ve.path ? (Mn = Ve.path).slice(-1) !== "/" && (Mn += "/") : _ && (Mn = "node_modules/gdal3.js/dist/package/"), Mn + Sn);
          return Mn = _ || Mn.substring(0, 4) === "http" || Mn[0] === "/" ? Mn : "/".concat(Mn);
        }, _ && (Ut.getPreloadedPackage = function(nn) {
          return require$$0.readFileSync("./".concat(nn), { flag: "r" }).buffer;
        }), W(G.Module).then(function() {
          Ze(No);
        });
      }) : (wt = Ve.paths && Ve.paths.js || "gdal3.js", _t = "", Ve.path && (_t = Ve.path).slice(-1) !== "/" && (_t += "/"), new Promise(function(Ze) {
        Oo.variables.gdalWorkerWrapper = new Oo.WorkerWrapper("".concat(_t).concat(wt), Ve, function(bt) {
          Oo.variables.drivers = bt, Ze(Oo.gdalProxy);
        });
      })));
    }
    return _ && (commonjsGlobal.location = { pathname: "./" }), typeof window < "u" && (window.initGdalJs = Zs), typeof importScripts == "function" && Ai(Zs), Zs;
  });
})(gdal3_node);
var gdal3_nodeExports = gdal3_node.exports, node = gdal3_nodeExports;
const initGdalJsNode = /* @__PURE__ */ getDefaultExportFromCjs(node);
var gdal3 = { exports: {} };
(function(r, e) {
  (function(s, o) {
    r.exports = o();
  })(commonjsGlobal, function() {
    function s(Ve, Ze) {
      var bt, Ut = Object.keys(Ve);
      return Object.getOwnPropertySymbols && (bt = Object.getOwnPropertySymbols(Ve), Ze && (bt = bt.filter(function(mn) {
        return Object.getOwnPropertyDescriptor(Ve, mn).enumerable;
      })), Ut.push.apply(Ut, bt)), Ut;
    }
    function o(Ve) {
      for (var Ze = 1; Ze < arguments.length; Ze++) {
        var bt = arguments[Ze] != null ? arguments[Ze] : {};
        Ze % 2 ? s(Object(bt), !0).forEach(function(Ut) {
          var mn, nn;
          mn = Ve, nn = bt[Ut = Ut], (Ut = f(Ut)) in mn ? Object.defineProperty(mn, Ut, { value: nn, enumerable: !0, configurable: !0, writable: !0 }) : mn[Ut] = nn;
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ve, Object.getOwnPropertyDescriptors(bt)) : s(Object(bt)).forEach(function(Ut) {
          Object.defineProperty(Ve, Ut, Object.getOwnPropertyDescriptor(bt, Ut));
        });
      }
      return Ve;
    }
    function a(Ve) {
      return (a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ze) {
        return typeof Ze;
      } : function(Ze) {
        return Ze && typeof Symbol == "function" && Ze.constructor === Symbol && Ze !== Symbol.prototype ? "symbol" : typeof Ze;
      })(Ve);
    }
    function l(Ve, Ze) {
      for (var bt = 0; bt < Ze.length; bt++) {
        var Ut = Ze[bt];
        Ut.enumerable = Ut.enumerable || !1, Ut.configurable = !0, "value" in Ut && (Ut.writable = !0), Object.defineProperty(Ve, f(Ut.key), Ut);
      }
    }
    function u(Ve, Ze) {
      return function(bt) {
        if (Array.isArray(bt))
          return bt;
      }(Ve) || function(bt, Ut) {
        var mn = bt == null ? null : typeof Symbol < "u" && bt[Symbol.iterator] || bt["@@iterator"];
        if (mn != null) {
          var nn, Sn, Mn, yn, Pt = [], tr = !0, Lt = !1;
          try {
            if (Mn = (mn = mn.call(bt)).next, Ut === 0) {
              if (Object(mn) !== mn)
                return;
              tr = !1;
            } else
              for (; !(tr = (nn = Mn.call(mn)).done) && (Pt.push(nn.value), Pt.length !== Ut); tr = !0)
                ;
          } catch (dr) {
            Lt = !0, Sn = dr;
          } finally {
            try {
              if (!tr && mn.return != null && (yn = mn.return(), Object(yn) !== yn))
                return;
            } finally {
              if (Lt)
                throw Sn;
            }
          }
          return Pt;
        }
      }(Ve, Ze) || E(Ve, Ze) || function() {
        throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function c(Ve) {
      return function(Ze) {
        if (Array.isArray(Ze))
          return d(Ze);
      }(Ve) || function(Ze) {
        if (typeof Symbol < "u" && Ze[Symbol.iterator] != null || Ze["@@iterator"] != null)
          return Array.from(Ze);
      }(Ve) || E(Ve) || function() {
        throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }();
    }
    function E(Ve, Ze) {
      var bt;
      if (Ve)
        return typeof Ve == "string" ? d(Ve, Ze) : (bt = (bt = Object.prototype.toString.call(Ve).slice(8, -1)) === "Object" && Ve.constructor ? Ve.constructor.name : bt) === "Map" || bt === "Set" ? Array.from(Ve) : bt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(bt) ? d(Ve, Ze) : void 0;
    }
    function d(Ve, Ze) {
      (Ze == null || Ze > Ve.length) && (Ze = Ve.length);
      for (var bt = 0, Ut = new Array(Ze); bt < Ze; bt++)
        Ut[bt] = Ve[bt];
      return Ut;
    }
    function f(Ve) {
      return Ve = function(Ze, bt) {
        if (typeof Ze != "object" || Ze === null)
          return Ze;
        var Ut = Ze[Symbol.toPrimitive];
        if (Ut === void 0)
          return (bt === "string" ? String : Number)(Ze);
        if (typeof (Ut = Ut.call(Ze, bt || "default")) != "object")
          return Ut;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }(Ve, "string"), typeof Ve == "symbol" ? Ve : String(Ve);
    }
    function h(Ve) {
      return Ve && Ve.__esModule && Object.prototype.hasOwnProperty.call(Ve, "default") ? Ve.default : Ve;
    }
    function S(Ve) {
      var Ze, bt;
      return Ve.__esModule ? Ve : (typeof (Ze = Ve.default) == "function" ? (bt = function Ut() {
        return this instanceof Ut ? Reflect.construct(Ze, arguments, this.constructor) : Ze.apply(this, arguments);
      }).prototype = Ze.prototype : bt = {}, Object.defineProperty(bt, "__esModule", { value: !0 }), Object.keys(Ve).forEach(function(Ut) {
        var mn = Object.getOwnPropertyDescriptor(Ve, Ut);
        Object.defineProperty(bt, Ut, mn.get ? mn : { enumerable: !0, get: function() {
          return Ve[Ut];
        } });
      }), bt);
    }
    var R, _ = S(Object.freeze({ __proto__: null, default: {} })), m = Object.prototype.toString.call(typeof api$1 < "u" ? api$1 : 0) === "[object process]", Dn = { exports: {} }, L = S(Object.freeze({ __proto__: null, default: {} })), F = S(Object.freeze({ __proto__: null, default: {} })), Oo = Dn;
    function W() {
      var Ve, Ze, bt, Ut, mn, nn, Sn, Mn, yn, Pt, tr = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {}, Lt = tr;
      function dr() {
        function T(J, Ie) {
          if (!J)
            throw Ie + new Error().stack;
        }
        function y(J, Ie, Pe) {
          this.start = J, this.end = Ie, this.audio = Pe;
        }
        Lt.FS_createPath("/", "usr", !0, !0), Lt.FS_createPath("/usr", "share", !0, !0), Lt.FS_createPath("/usr/share", "gdal", !0, !0), Lt.FS_createPath("/usr/share", "proj", !0, !0), y.prototype = { requests: {}, open: function(J, Ie) {
          this.name = Ie, this.requests[Ie] = this, Lt.addRunDependency("fp ".concat(this.name));
        }, send: function() {
        }, onload: function() {
          var J = this.byteArray.subarray(this.start, this.end);
          this.finish(J);
        }, finish: function(J) {
          Lt.FS_createDataFile(this.name, null, J, !0, !0, !0), Lt.removeRunDependency("fp ".concat(this.name)), this.requests[this.name] = null;
        } };
        for (var N = bt.files, b = 0; b < N.length; ++b)
          new y(N[b].start, N[b].end, N[b].audio || 0).open("GET", N[b].filename);
        function X(J) {
          T(J, "Loading data file failed."), T(J.constructor.name === ArrayBuffer.name, "bad input to processPackageData");
          for (var J = new Uint8Array(J), Ie = (y.prototype.byteArray = J, bt.files), Pe = 0; Pe < Ie.length; ++Pe)
            y.prototype.requests[Ie[Pe].filename].onload();
          Lt.removeRunDependency("datafile_/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data");
        }
        Lt.addRunDependency("datafile_/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data"), Lt.preloadResults || (Lt.preloadResults = {}), Lt.preloadResults["/home/bugra/Documents/MiniProject/gdal3.js/build/package/gdal3WebAssembly.data"] = { fromCache: !1 }, Pt ? (X(Pt), Pt = null) : yn = X;
      }
      Lt.ready = new Promise(function(T, y) {
        Ve = T, Ze = y;
      }), Lt.expectedDataFileDownloads || (Lt.expectedDataFileDownloads = 0), Lt.expectedDataFileDownloads++, Lt.ENVIRONMENT_IS_PTHREAD || Lt.$ww || (bt = { files: [{ filename: "/usr/share/gdal/GDALLogoBW.svg", start: 0, end: 13022 }, { filename: "/usr/share/gdal/GDALLogoColor.svg", start: 13022, end: 25327 }, { filename: "/usr/share/gdal/GDALLogoGS.svg", start: 25327, end: 37632 }, { filename: "/usr/share/gdal/LICENSE.TXT", start: 37632, end: 59473 }, { filename: "/usr/share/gdal/bag_template.xml", start: 59473, end: 68493 }, { filename: "/usr/share/gdal/cubewerx_extra.wkt", start: 68493, end: 80470 }, { filename: "/usr/share/gdal/default.rsc", start: 80470, end: 544102 }, { filename: "/usr/share/gdal/ecw_cs.wkt", start: 544102, end: 908134 }, { filename: "/usr/share/gdal/eedaconf.json", start: 908134, end: 908545 }, { filename: "/usr/share/gdal/epsg.wkt", start: 908545, end: 908572 }, { filename: "/usr/share/gdal/esri_StatePlane_extra.wkt", start: 908572, end: 1241118 }, { filename: "/usr/share/gdal/gdalicon.png", start: 1241118, end: 1243139 }, { filename: "/usr/share/gdal/gdalinfo_output.schema.json", start: 1243139, end: 1251130 }, { filename: "/usr/share/gdal/gdalmdiminfo_output.schema.json", start: 1251130, end: 1257673 }, { filename: "/usr/share/gdal/gdalvrt.xsd", start: 1257673, end: 1291600 }, { filename: "/usr/share/gdal/gfs.xsd", start: 1291600, end: 1308069 }, { filename: "/usr/share/gdal/gml_registry.xml", start: 1308069, end: 1314712 }, { filename: "/usr/share/gdal/gml_registry.xsd", start: 1314712, end: 1321174 }, { filename: "/usr/share/gdal/gmlasconf.xml", start: 1321174, end: 1328606 }, { filename: "/usr/share/gdal/gmlasconf.xsd", start: 1328606, end: 1377260 }, { filename: "/usr/share/gdal/grib2_center.csv", start: 1377260, end: 1381431 }, { filename: "/usr/share/gdal/grib2_process.csv", start: 1381431, end: 1386357 }, { filename: "/usr/share/gdal/grib2_subcenter.csv", start: 1386357, end: 1388685 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_0.csv", start: 1388685, end: 1399048 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_1.csv", start: 1399048, end: 1415553 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_13.csv", start: 1415553, end: 1425149 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_14.csv", start: 1425149, end: 1434700 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_15.csv", start: 1434700, end: 1444546 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_16.csv", start: 1444546, end: 1454217 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_17.csv", start: 1454217, end: 1455140 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_18.csv", start: 1455140, end: 1465364 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_19.csv", start: 1465364, end: 1477238 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_190.csv", start: 1477238, end: 1486745 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_191.csv", start: 1486745, end: 1496365 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_2.csv", start: 1496365, end: 1507257 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_20.csv", start: 1507257, end: 1519548 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_21.csv", start: 1519548, end: 1529810 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_3.csv", start: 1529810, end: 1540368 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_4.csv", start: 1540368, end: 1550679 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_5.csv", start: 1550679, end: 1560505 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_6.csv", start: 1560505, end: 1572147 }, { filename: "/usr/share/gdal/grib2_table_4_2_0_7.csv", start: 1572147, end: 1582639 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_0.csv", start: 1582639, end: 1594461 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_1.csv", start: 1594461, end: 1604086 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_191.csv", start: 1604086, end: 1613720 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_2.csv", start: 1613720, end: 1623832 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_3.csv", start: 1623832, end: 1633821 }, { filename: "/usr/share/gdal/grib2_table_4_2_10_4.csv", start: 1633821, end: 1644637 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_0.csv", start: 1644637, end: 1654779 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_1.csv", start: 1654779, end: 1664434 }, { filename: "/usr/share/gdal/grib2_table_4_2_1_2.csv", start: 1664434, end: 1674232 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_0.csv", start: 1674232, end: 1683875 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_1.csv", start: 1683875, end: 1693726 }, { filename: "/usr/share/gdal/grib2_table_4_2_20_2.csv", start: 1693726, end: 1703232 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_0.csv", start: 1703232, end: 1715898 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_3.csv", start: 1715898, end: 1726532 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_4.csv", start: 1726532, end: 1737760 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_5.csv", start: 1737760, end: 1747273 }, { filename: "/usr/share/gdal/grib2_table_4_2_2_6.csv", start: 1747273, end: 1756872 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_0.csv", start: 1756872, end: 1767823 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_1.csv", start: 1767823, end: 1778486 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_2.csv", start: 1778486, end: 1782319 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_3.csv", start: 1782319, end: 1783103 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_4.csv", start: 1783103, end: 1784154 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_5.csv", start: 1784154, end: 1785074 }, { filename: "/usr/share/gdal/grib2_table_4_2_3_6.csv", start: 1785074, end: 1785893 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_0.csv", start: 1785893, end: 1795446 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_1.csv", start: 1795446, end: 1805132 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_10.csv", start: 1805132, end: 1814833 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_2.csv", start: 1814833, end: 1824493 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_3.csv", start: 1824493, end: 1834215 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_4.csv", start: 1834215, end: 1843905 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_5.csv", start: 1843905, end: 1853400 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_6.csv", start: 1853400, end: 1863033 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_7.csv", start: 1863033, end: 1872589 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_8.csv", start: 1872589, end: 1882275 }, { filename: "/usr/share/gdal/grib2_table_4_2_4_9.csv", start: 1882275, end: 1891811 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_Canada.csv", start: 1891811, end: 1892144 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_HPC.csv", start: 1892144, end: 1892231 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_MRMS.csv", start: 1892231, end: 1907818 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_NCEP.csv", start: 1907818, end: 1935795 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_NDFD.csv", start: 1935795, end: 1938454 }, { filename: "/usr/share/gdal/grib2_table_4_2_local_index.csv", start: 1938454, end: 1938705 }, { filename: "/usr/share/gdal/grib2_table_4_5.csv", start: 1938705, end: 1948718 }, { filename: "/usr/share/gdal/grib2_table_versions.csv", start: 1948718, end: 1948756 }, { filename: "/usr/share/gdal/gt_datum.csv", start: 1948756, end: 1964560 }, { filename: "/usr/share/gdal/gt_ellips.csv", start: 1964560, end: 1966279 }, { filename: "/usr/share/gdal/header.dxf", start: 1966279, end: 1972851 }, { filename: "/usr/share/gdal/inspire_cp_BasicPropertyUnit.gfs", start: 1972851, end: 1974591 }, { filename: "/usr/share/gdal/inspire_cp_CadastralBoundary.gfs", start: 1974591, end: 1976241 }, { filename: "/usr/share/gdal/inspire_cp_CadastralParcel.gfs", start: 1976241, end: 1978691 }, { filename: "/usr/share/gdal/inspire_cp_CadastralZoning.gfs", start: 1978691, end: 1983503 }, { filename: "/usr/share/gdal/jpfgdgml_AdmArea.gfs", start: 1983503, end: 1985143 }, { filename: "/usr/share/gdal/jpfgdgml_AdmBdry.gfs", start: 1985143, end: 1986525 }, { filename: "/usr/share/gdal/jpfgdgml_AdmPt.gfs", start: 1986525, end: 1988158 }, { filename: "/usr/share/gdal/jpfgdgml_BldA.gfs", start: 1988158, end: 1989659 }, { filename: "/usr/share/gdal/jpfgdgml_BldL.gfs", start: 1989659, end: 1991162 }, { filename: "/usr/share/gdal/jpfgdgml_Cntr.gfs", start: 1991162, end: 1992663 }, { filename: "/usr/share/gdal/jpfgdgml_CommBdry.gfs", start: 1992663, end: 1994047 }, { filename: "/usr/share/gdal/jpfgdgml_CommPt.gfs", start: 1994047, end: 1995682 }, { filename: "/usr/share/gdal/jpfgdgml_Cstline.gfs", start: 1995682, end: 1997191 }, { filename: "/usr/share/gdal/jpfgdgml_ElevPt.gfs", start: 1997191, end: 1998691 }, { filename: "/usr/share/gdal/jpfgdgml_GCP.gfs", start: 1998691, end: 2001214 }, { filename: "/usr/share/gdal/jpfgdgml_LeveeEdge.gfs", start: 2001214, end: 2002600 }, { filename: "/usr/share/gdal/jpfgdgml_RailCL.gfs", start: 2002600, end: 2004107 }, { filename: "/usr/share/gdal/jpfgdgml_RdASL.gfs", start: 2004107, end: 2005358 }, { filename: "/usr/share/gdal/jpfgdgml_RdArea.gfs", start: 2005358, end: 2006873 }, { filename: "/usr/share/gdal/jpfgdgml_RdCompt.gfs", start: 2006873, end: 2008519 }, { filename: "/usr/share/gdal/jpfgdgml_RdEdg.gfs", start: 2008519, end: 2010161 }, { filename: "/usr/share/gdal/jpfgdgml_RdMgtBdry.gfs", start: 2010161, end: 2011547 }, { filename: "/usr/share/gdal/jpfgdgml_RdSgmtA.gfs", start: 2011547, end: 2013191 }, { filename: "/usr/share/gdal/jpfgdgml_RvrMgtBdry.gfs", start: 2013191, end: 2014579 }, { filename: "/usr/share/gdal/jpfgdgml_SBAPt.gfs", start: 2014579, end: 2015954 }, { filename: "/usr/share/gdal/jpfgdgml_SBArea.gfs", start: 2015954, end: 2017461 }, { filename: "/usr/share/gdal/jpfgdgml_SBBdry.gfs", start: 2017461, end: 2018714 }, { filename: "/usr/share/gdal/jpfgdgml_WA.gfs", start: 2018714, end: 2020211 }, { filename: "/usr/share/gdal/jpfgdgml_WL.gfs", start: 2020211, end: 2021710 }, { filename: "/usr/share/gdal/jpfgdgml_WStrA.gfs", start: 2021710, end: 2023213 }, { filename: "/usr/share/gdal/jpfgdgml_WStrL.gfs", start: 2023213, end: 2024718 }, { filename: "/usr/share/gdal/netcdf_config.xsd", start: 2024718, end: 2032209 }, { filename: "/usr/share/gdal/nitf_spec.xml", start: 2032209, end: 2219654 }, { filename: "/usr/share/gdal/nitf_spec.xsd", start: 2219654, end: 2228162 }, { filename: "/usr/share/gdal/ogrinfo_output.schema.json", start: 2228162, end: 2239289 }, { filename: "/usr/share/gdal/ogrvrt.xsd", start: 2239289, end: 2265210 }, { filename: "/usr/share/gdal/osmconf.ini", start: 2265210, end: 2270610 }, { filename: "/usr/share/gdal/ozi_datum.csv", start: 2270610, end: 2279092 }, { filename: "/usr/share/gdal/ozi_ellips.csv", start: 2279092, end: 2280441 }, { filename: "/usr/share/gdal/pci_datum.txt", start: 2280441, end: 2315535 }, { filename: "/usr/share/gdal/pci_ellips.txt", start: 2315535, end: 2319050 }, { filename: "/usr/share/gdal/pdfcomposition.xsd", start: 2319050, end: 2353384 }, { filename: "/usr/share/gdal/pds4_template.xml", start: 2353384, end: 2356817 }, { filename: "/usr/share/gdal/plscenesconf.json", start: 2356817, end: 2398189 }, { filename: "/usr/share/gdal/ruian_vf_ob_v1.gfs", start: 2398189, end: 2444924 }, { filename: "/usr/share/gdal/ruian_vf_st_uvoh_v1.gfs", start: 2444924, end: 2447520 }, { filename: "/usr/share/gdal/ruian_vf_st_v1.gfs", start: 2447520, end: 2493420 }, { filename: "/usr/share/gdal/ruian_vf_v1.gfs", start: 2493420, end: 2560672 }, { filename: "/usr/share/gdal/s57agencies.csv", start: 2560672, end: 2573976 }, { filename: "/usr/share/gdal/s57attributes.csv", start: 2573976, end: 2593977 }, { filename: "/usr/share/gdal/s57expectedinput.csv", start: 2593977, end: 2614862 }, { filename: "/usr/share/gdal/s57objectclasses.csv", start: 2614862, end: 2668287 }, { filename: "/usr/share/gdal/seed_2d.dgn", start: 2668287, end: 2677503 }, { filename: "/usr/share/gdal/seed_3d.dgn", start: 2677503, end: 2679551 }, { filename: "/usr/share/gdal/stateplane.csv", start: 2679551, end: 2689911 }, { filename: "/usr/share/gdal/template_tiles.mapml", start: 2689911, end: 2691858 }, { filename: "/usr/share/gdal/tms_LINZAntarticaMapTileGrid.json", start: 2691858, end: 2695973 }, { filename: "/usr/share/gdal/tms_MapML_APSTILE.json", start: 2695973, end: 2702246 }, { filename: "/usr/share/gdal/tms_MapML_CBMTILE.json", start: 2702246, end: 2710038 }, { filename: "/usr/share/gdal/tms_NZTM2000.json", start: 2710038, end: 2715303 }, { filename: "/usr/share/gdal/trailer.dxf", start: 2715303, end: 2717578 }, { filename: "/usr/share/gdal/vdv452.xml", start: 2717578, end: 2743394 }, { filename: "/usr/share/gdal/vdv452.xsd", start: 2743394, end: 2746248 }, { filename: "/usr/share/gdal/vicar.json", start: 2746248, end: 2749858 }, { filename: "/usr/share/proj/CH", start: 2749858, end: 2750955 }, { filename: "/usr/share/proj/GL27", start: 2750955, end: 2751683 }, { filename: "/usr/share/proj/ITRF2000", start: 2751683, end: 2753782 }, { filename: "/usr/share/proj/ITRF2008", start: 2753782, end: 2759464 }, { filename: "/usr/share/proj/ITRF2014", start: 2759464, end: 2762953 }, { filename: "/usr/share/proj/deformation_model.schema.json", start: 2762953, end: 2780624 }, { filename: "/usr/share/proj/nad.lst", start: 2780624, end: 2787009 }, { filename: "/usr/share/proj/nad27", start: 2787009, end: 2806544 }, { filename: "/usr/share/proj/nad83", start: 2806544, end: 2823137 }, { filename: "/usr/share/proj/other.extra", start: 2823137, end: 2827052 }, { filename: "/usr/share/proj/proj.db", start: 2827052, end: 11539244 }, { filename: "/usr/share/proj/proj.ini", start: 11539244, end: 11541351 }, { filename: "/usr/share/proj/projjson.schema.json", start: 11541351, end: 11579663 }, { filename: "/usr/share/proj/triangulation.schema.json", start: 11579663, end: 11588066 }, { filename: "/usr/share/proj/world", start: 11588066, end: 11595145 }], remote_package_size: 11595145 }, (typeof window > "u" ? "undefined" : a(window)) === "object" ? window.encodeURIComponent(window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/") : typeof api$1 > "u" && typeof location < "u" && encodeURIComponent(location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/"), Os = "gdal3WebAssembly.data", typeof Lt.locateFilePackage != "function" || Lt.locateFile || (Lt.locateFile = Lt.locateFilePackage, Bo("warning: you defined Module.locateFilePackage, that has been renamed to Module.locateFile (using your locateFilePackage for now)")), Os = Lt.locateFile ? Lt.locateFile(Os, "") : Os, no = bt.remote_package_size, yn = null, (Pt = Lt.getPreloadedPackage ? Lt.getPreloadedPackage(Os, no) : null) || (Ut = Os, mn = no, nn = function(T) {
        yn ? (yn(T), yn = null) : Pt = T;
      }, Sn = function(T) {
        console.error("package error:", T);
      }, (typeof api$1 > "u" ? "undefined" : a(api$1)) === "object" && a(api$1.versions) === "object" && typeof api$1.versions.node == "string" ? _.readFile(Ut, function(T, y) {
        T ? Sn(T) : nn(y.buffer);
      }) : ((Mn = new XMLHttpRequest()).open("GET", Ut, !0), Mn.responseType = "arraybuffer", Mn.onprogress = function(T) {
        var y = Ut, N = mn;
        if (T.total && (N = T.total), T.loaded) {
          Mn.addedTotal ? Lt.dataFileDownloads[y].loaded = T.loaded : (Mn.addedTotal = !0, Lt.dataFileDownloads || (Lt.dataFileDownloads = {}), Lt.dataFileDownloads[y] = { loaded: T.loaded, total: N });
          var b, X = 0, J = 0, Ie = 0;
          for (b in Lt.dataFileDownloads) {
            var Pe = Lt.dataFileDownloads[b];
            X += Pe.total, J += Pe.loaded, Ie++;
          }
          X = Math.ceil(X * Lt.expectedDataFileDownloads / Ie), Lt.setStatus && Lt.setStatus("Downloading data... (".concat(J, "/").concat(X, ")"));
        } else
          Lt.dataFileDownloads || Lt.setStatus && Lt.setStatus("Downloading data...");
      }, Mn.onerror = function(T) {
        throw new Error("NetworkError for: " + Ut);
      }, Mn.onload = function(T) {
        if (!(Mn.status == 200 || Mn.status == 304 || Mn.status == 206 || Mn.status == 0 && Mn.response))
          throw new Error(Mn.statusText + " : " + Mn.responseURL);
        var y = Mn.response;
        nn(y);
      }, Mn.send(null))), Lt.calledRun ? dr() : (Lt.preRun || (Lt.preRun = []), Lt.preRun.push(dr)));
      var ur, gr, Rr, as, hs, Os = Object.assign({}, Lt), jo = "./this.program", po = function(T, y) {
        throw y;
      }, So = (typeof window > "u" ? "undefined" : a(window)) == "object", Eo = typeof importScripts == "function", Ps = (typeof api$1 > "u" ? "undefined" : a(api$1)) == "object" && a(api$1.versions) == "object" && typeof api$1.versions.node == "string", no = "";
      Ps ? (ur = _, gr = L, no = Eo ? gr.dirname(no) + "/" : __dirname + "/", Rr = function(T, y) {
        return T = Wi(T) ? new URL(T) : gr.normalize(T), ur.readFileSync(T, y ? void 0 : "utf8");
      }, as = function(T) {
        return T = Rr(T, !0), T = T.buffer ? T : new Uint8Array(T);
      }, hs = function(T, y, N) {
        var b = !(3 < arguments.length && arguments[3] !== void 0) || arguments[3];
        T = Wi(T) ? new URL(T) : gr.normalize(T), ur.readFile(T, b ? void 0 : "utf8", function(X, J) {
          X ? N(X) : y(b ? J.buffer : J);
        });
      }, !Lt.thisProgram && 1 < api$1.argv.length && (jo = api$1.argv[1].replace(/\\/g, "/")), api$1.argv.slice(2), po = function(T, y) {
        throw api$1.exitCode = T, y;
      }, Lt.inspect = function() {
        return "[Emscripten Module object]";
      }) : (So || Eo) && (Eo ? no = self.location.href : typeof document < "u" && document.currentScript && (no = document.currentScript.src), no = (no = R || no).indexOf("blob:") !== 0 ? no.substr(0, no.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", Rr = function(T) {
        var y = new XMLHttpRequest();
        return y.open("GET", T, !1), y.send(null), y.responseText;
      }, Eo && (as = function(T) {
        var y = new XMLHttpRequest();
        return y.open("GET", T, !1), y.responseType = "arraybuffer", y.send(null), new Uint8Array(y.response);
      }), hs = function(T, y, N) {
        var b = new XMLHttpRequest();
        b.open("GET", T, !0), b.responseType = "arraybuffer", b.onload = function() {
          b.status == 200 || b.status == 0 && b.response ? y(b.response) : N();
        }, b.onerror = N, b.send(null);
      });
      var gs, fo, xs, Ir, ws, fr, Mr, Nr, ii, Ro = Lt.print || console.log.bind(console), Bo = Lt.printErr || console.error.bind(console), Rs = (Object.assign(Lt, Os), Lt.arguments && Lt.arguments, Lt.thisProgram && (jo = Lt.thisProgram), Lt.quit && (po = Lt.quit), Lt.wasmBinary && (gs = Lt.wasmBinary), (typeof WebAssembly > "u" ? "undefined" : a(WebAssembly)) != "object" && vr("no native wasm support detected"), !1);
      function Uo(T, y) {
        T || vr(y);
      }
      function xi() {
        var T = fo.buffer;
        Lt.HEAP8 = xs = new Int8Array(T), Lt.HEAP16 = ws = new Int16Array(T), Lt.HEAPU8 = Ir = new Uint8Array(T), Lt.HEAPU16 = new Uint16Array(T), Lt.HEAP32 = fr = new Int32Array(T), Lt.HEAPU32 = Mr = new Uint32Array(T), Lt.HEAPF32 = Nr = new Float32Array(T), Lt.HEAPF64 = ii = new Float64Array(T);
      }
      var Vo = [], oa = [], ti = [];
      function Po() {
        if (Lt.preRun)
          for (typeof Lt.preRun == "function" && (Lt.preRun = [Lt.preRun]); Lt.preRun.length; )
            T = Lt.preRun.shift(), Vo.unshift(T);
        var T;
        Ys(Vo);
      }
      function ai() {
        if (Lt.postRun)
          for (typeof Lt.postRun == "function" && (Lt.postRun = [Lt.postRun]); Lt.postRun.length; )
            T = Lt.postRun.shift(), ti.unshift(T);
        var T;
        Ys(ti);
      }
      var Wo = 0, As = null;
      function ro(T) {
        var y;
        Wo++, (y = Lt.monitorRunDependencies) != null && y.call(Lt, Wo);
      }
      function Mo(T) {
        var y;
        Wo--, (y = Lt.monitorRunDependencies) != null && y.call(Lt, Wo), Wo == 0 && As && (y = As, As = null, y());
      }
      function vr(T) {
        (y = Lt.onAbort) != null && y.call(Lt, T), Bo(T = "Aborted(" + T + ")"), Rs = !0, T += ". Build with -sASSERTIONS for more info.";
        var y = new WebAssembly.RuntimeError(T);
        throw Ze(y), y;
      }
      var ts, kr, Us, ri = function(T) {
        return T.startsWith("data:application/octet-stream;base64,");
      }, Wi = function(T) {
        return T.startsWith("file://");
      };
      function To(T) {
        if (T == ts && gs)
          return new Uint8Array(gs);
        if (as)
          return as(T);
        throw "both async and sync fetching of the wasm failed";
      }
      function ia(T, y, N) {
        return function(b) {
          if (!gs && (So || Eo)) {
            if (typeof fetch == "function" && !Wi(b))
              return fetch(b, { credentials: "same-origin" }).then(function(X) {
                if (X.ok)
                  return X.arrayBuffer();
                throw "failed to load wasm binary file at '" + b + "'";
              }).catch(function() {
                return To(b);
              });
            if (hs)
              return new Promise(function(X, J) {
                hs(b, function(Ie) {
                  return X(new Uint8Array(Ie));
                }, J);
              });
          }
          return Promise.resolve().then(function() {
            return To(b);
          });
        }(T).then(function(b) {
          return WebAssembly.instantiate(b, y);
        }).then(function(b) {
          return b;
        }).then(N, function(b) {
          Bo("failed to asynchronously prepare wasm: ".concat(b)), vr(b);
        });
      }
      function bo(T) {
        this.name = "ExitStatus", this.message = "Program terminated with exit(".concat(T, ")"), this.status = T;
      }
      function Ys(T) {
        for (; 0 < T.length; )
          T.shift()(Lt);
      }
      ri(ts = "gdal3WebAssembly.wasm") || (Bn = ts, ts = Lt.locateFile ? Lt.locateFile(Bn, no) : no + Bn);
      var Di = Lt.noExitRuntime || !0;
      function Yn(T, y, N) {
        for (var b = y + N, X = y; T[X] && !(b <= X); )
          ++X;
        if (16 < X - y && T.buffer && rs)
          return rs.decode(T.subarray(y, X));
        for (var J = ""; y < X; ) {
          var Ie, Pe, We = T[y++];
          128 & We ? (Pe = 63 & T[y++], (224 & We) == 192 ? J += String.fromCharCode((31 & We) << 6 | Pe) : (Ie = 63 & T[y++], (We = (240 & We) == 224 ? (15 & We) << 12 | Pe << 6 | Ie : (7 & We) << 18 | Pe << 12 | Ie << 6 | 63 & T[y++]) < 65536 ? J += String.fromCharCode(We) : (Pe = We - 65536, J += String.fromCharCode(55296 | Pe >> 10, 56320 | 1023 & Pe)))) : J += String.fromCharCode(We);
        }
        return J;
      }
      function Lo(T, y) {
        return T ? Yn(Ir, T, y) : "";
      }
      function Un(T) {
        var y = hi[T];
        return y || (T >= hi.length && (hi.length = T + 1), hi[T] = y = so.get(T)), y;
      }
      var so, rs = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0, hi = [], Zo = [], li = 0, ei = 0;
      function Or(T) {
        this.excPtr = T, this.ptr = T - 24, this.set_type = function(y) {
          Mr[this.ptr + 4 >> 2] = y;
        }, this.get_type = function() {
          return Mr[this.ptr + 4 >> 2];
        }, this.set_destructor = function(y) {
          Mr[this.ptr + 8 >> 2] = y;
        }, this.get_destructor = function() {
          return Mr[this.ptr + 8 >> 2];
        }, this.set_caught = function(y) {
          xs[this.ptr + 12 >> 0] = y = y ? 1 : 0;
        }, this.get_caught = function() {
          return xs[this.ptr + 12 >> 0] != 0;
        }, this.set_rethrown = function(y) {
          xs[this.ptr + 13 >> 0] = y = y ? 1 : 0;
        }, this.get_rethrown = function() {
          return xs[this.ptr + 13 >> 0] != 0;
        }, this.init = function(y, N) {
          this.set_adjusted_ptr(0), this.set_type(y), this.set_destructor(N);
        }, this.set_adjusted_ptr = function(y) {
          Mr[this.ptr + 16 >> 2] = y;
        }, this.get_adjusted_ptr = function() {
          return Mr[this.ptr + 16 >> 2];
        }, this.get_exception_ptr = function() {
          var y;
          return qs(this.get_type()) ? Mr[this.excPtr >> 2] : (y = this.get_adjusted_ptr()) !== 0 ? y : this.excPtr;
        };
      }
      function ui(T) {
        var y = ei;
        if (!y)
          return Xt(0), 0;
        var N = new Or(y), b = (N.set_adjusted_ptr(y), N.get_type());
        if (b) {
          for (var X in T) {
            if (X = T[X], X === 0 || X === b)
              break;
            var J = N.ptr + 16;
            if (Zr(X, b, J))
              return Xt(X), y;
          }
          Xt(b);
        } else
          Xt(0);
        return y;
      }
      var _s = { isAbs: function(T) {
        return T.charAt(0) === "/";
      }, splitPath: function(T) {
        return /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(T).slice(1);
      }, normalizeArray: function(T, y) {
        for (var N = 0, b = T.length - 1; 0 <= b; b--) {
          var X = T[b];
          X === "." ? T.splice(b, 1) : X === ".." ? (T.splice(b, 1), N++) : N && (T.splice(b, 1), N--);
        }
        if (y)
          for (; N; N--)
            T.unshift("..");
        return T;
      }, normalize: function(T) {
        var y = _s.isAbs(T), N = T.substr(-1) === "/";
        return (T = (T = _s.normalizeArray(T.split("/").filter(function(b) {
          return !!b;
        }), !y).join("/")) || y ? T : ".") && N && (T += "/"), (y ? "/" : "") + T;
      }, dirname: function(N) {
        var N = _s.splitPath(N), y = N[0], N = N[1];
        return y || N ? y + (N = N && N.substr(0, N.length - 1)) : ".";
      }, basename: function(T) {
        var y;
        return T === "/" ? "/" : (y = (T = (T = _s.normalize(T)).replace(/\/$/, "")).lastIndexOf("/")) === -1 ? T : T.substr(y + 1);
      }, join: function() {
        var T = Array.prototype.slice.call(arguments);
        return _s.normalize(T.join("/"));
      }, join2: function(T, y) {
        return _s.normalize(T + "/" + y);
      } }, xo = function() {
        if ((typeof crypto > "u" ? "undefined" : a(crypto)) == "object" && typeof crypto.getRandomValues == "function")
          return function(N) {
            return crypto.getRandomValues(N);
          };
        if (Ps)
          try {
            var T, y = F;
            return y.randomFillSync ? function(N) {
              return y.randomFillSync(N);
            } : (T = y.randomBytes, function(N) {
              return N.set(T(N.byteLength)), N;
            });
          } catch {
          }
        vr("initRandomDevice");
      }, aa = function(T) {
        return (aa = xo())(T);
      }, oo = { resolve: function() {
        for (var T = "", y = !1, N = arguments.length - 1; -1 <= N && !y; N--) {
          var b = 0 <= N ? arguments[N] : vt.cwd();
          if (typeof b != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          if (!b)
            return "";
          T = b + "/" + T, y = _s.isAbs(b);
        }
        return (y ? "/" : "") + (T = _s.normalizeArray(T.split("/").filter(function(X) {
          return !!X;
        }), !y).join("/")) || ".";
      }, relative: function(T, y) {
        function N(it) {
          for (var Rt = 0; Rt < it.length && it[Rt] === ""; Rt++)
            ;
          for (var Dt = it.length - 1; 0 <= Dt && it[Dt] === ""; Dt--)
            ;
          return Dt < Rt ? [] : it.slice(Rt, Dt - Rt + 1);
        }
        T = oo.resolve(T).substr(1), y = oo.resolve(y).substr(1);
        for (var b = N(T.split("/")), X = N(y.split("/")), J = Math.min(b.length, X.length), Ie = J, Pe = 0; Pe < J; Pe++)
          if (b[Pe] !== X[Pe]) {
            Ie = Pe;
            break;
          }
        for (var We = [], Pe = Ie; Pe < b.length; Pe++)
          We.push("..");
        return (We = We.concat(X.slice(Ie))).join("/");
      } }, vs = [], yi = function(T) {
        for (var y = 0, N = 0; N < T.length; ++N) {
          var b = T.charCodeAt(N);
          b <= 127 ? y++ : b <= 2047 ? y += 2 : 55296 <= b && b <= 57343 ? (y += 4, ++N) : y += 3;
        }
        return y;
      }, $r = function(T, y, N, b) {
        if (!(0 < b))
          return 0;
        for (var X = N, J = N + b - 1, Ie = 0; Ie < T.length; ++Ie) {
          var Pe = T.charCodeAt(Ie);
          if ((Pe = 55296 <= Pe && Pe <= 57343 ? 65536 + ((1023 & Pe) << 10) | 1023 & T.charCodeAt(++Ie) : Pe) <= 127) {
            if (J <= N)
              break;
            y[N++] = Pe;
          } else {
            if (Pe <= 2047) {
              if (J <= N + 1)
                break;
              y[N++] = 192 | Pe >> 6;
            } else {
              if (Pe <= 65535) {
                if (J <= N + 2)
                  break;
                y[N++] = 224 | Pe >> 12;
              } else {
                if (J <= N + 3)
                  break;
                y[N++] = 240 | Pe >> 18, y[N++] = 128 | Pe >> 12 & 63;
              }
              y[N++] = 128 | Pe >> 6 & 63;
            }
            y[N++] = 128 | 63 & Pe;
          }
        }
        return y[N] = 0, N - X;
      };
      function ki(T, y, N) {
        return N = 0 < N ? N : yi(T) + 1, N = new Array(N), T = $r(T, N, 0, N.length), y && (N.length = T), N;
      }
      function ds(T) {
        N = T, y = 65536, T = Math.ceil(N / y) * y;
        var y, N = Ln(65536, T);
        return N ? (y = N, N = T, Ir.fill(0, y, y + N), y) : 0;
      }
      function Ls(T, y) {
        var N = 0;
        return T && (N |= 365), y && (N |= 146), N;
      }
      var Co = { ttys: [], init: function() {
      }, shutdown: function() {
      }, register: function(T, y) {
        Co.ttys[T] = { input: [], output: [], ops: y }, vt.registerDevice(T, Co.stream_ops);
      }, stream_ops: { open: function(T) {
        var y = Co.ttys[T.node.rdev];
        if (!y)
          throw new vt.ErrnoError(43);
        T.tty = y, T.seekable = !1;
      }, close: function(T) {
        T.tty.ops.fsync(T.tty);
      }, fsync: function(T) {
        T.tty.ops.fsync(T.tty);
      }, read: function(T, y, N, b, X) {
        if (!T.tty || !T.tty.ops.get_char)
          throw new vt.ErrnoError(60);
        for (var J, Ie = 0, Pe = 0; Pe < b; Pe++) {
          try {
            J = T.tty.ops.get_char(T.tty);
          } catch {
            throw new vt.ErrnoError(29);
          }
          if (J === void 0 && Ie === 0)
            throw new vt.ErrnoError(6);
          if (J == null)
            break;
          Ie++, y[N + Pe] = J;
        }
        return Ie && (T.node.timestamp = Date.now()), Ie;
      }, write: function(T, y, N, b, X) {
        if (!T.tty || !T.tty.ops.put_char)
          throw new vt.ErrnoError(60);
        try {
          for (var J = 0; J < b; J++)
            T.tty.ops.put_char(T.tty, y[N + J]);
        } catch {
          throw new vt.ErrnoError(29);
        }
        return b && (T.node.timestamp = Date.now()), J;
      } }, default_tty_ops: { get_char: function(T) {
        if (!vs.length) {
          var y = null;
          if (Ps) {
            var N = buffer$1.Buffer.alloc(256), b = 0, X = api$1.stdin.fd;
            try {
              b = ur.readSync(X, N);
            } catch (J) {
              if (!J.toString().includes("EOF"))
                throw J;
              b = 0;
            }
            y = 0 < b ? N.slice(0, b).toString("utf-8") : null;
          } else
            typeof window < "u" && typeof window.prompt == "function" ? (y = window.prompt("Input: ")) !== null && (y += `
`) : typeof readline == "function" && (y = readline()) !== null && (y += `
`);
          if (!y)
            return null;
          vs = ki(y, !0);
        }
        return vs.shift();
      }, put_char: function(T, y) {
        y === null || y === 10 ? (Ro(Yn(T.output, 0)), T.output = []) : y != 0 && T.output.push(y);
      }, fsync: function(T) {
        T.output && 0 < T.output.length && (Ro(Yn(T.output, 0)), T.output = []);
      }, ioctl_tcgets: function(T) {
        return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
      }, ioctl_tcsets: function(T, y, N) {
        return 0;
      }, ioctl_tiocgwinsz: function(T) {
        return [24, 80];
      } }, default_tty1_ops: { put_char: function(T, y) {
        y === null || y === 10 ? (Bo(Yn(T.output, 0)), T.output = []) : y != 0 && T.output.push(y);
      }, fsync: function(T) {
        T.output && 0 < T.output.length && (Bo(Yn(T.output, 0)), T.output = []);
      } } }, ps = { ops_table: null, mount: function(T) {
        return ps.createNode(null, "/", 16895, 0);
      }, createNode: function(T, y, N, b) {
        if (vt.isBlkdev(N) || vt.isFIFO(N))
          throw new vt.ErrnoError(63);
        return ps.ops_table || (ps.ops_table = { dir: { node: { getattr: ps.node_ops.getattr, setattr: ps.node_ops.setattr, lookup: ps.node_ops.lookup, mknod: ps.node_ops.mknod, rename: ps.node_ops.rename, unlink: ps.node_ops.unlink, rmdir: ps.node_ops.rmdir, readdir: ps.node_ops.readdir, symlink: ps.node_ops.symlink }, stream: { llseek: ps.stream_ops.llseek } }, file: { node: { getattr: ps.node_ops.getattr, setattr: ps.node_ops.setattr }, stream: { llseek: ps.stream_ops.llseek, read: ps.stream_ops.read, write: ps.stream_ops.write, allocate: ps.stream_ops.allocate, mmap: ps.stream_ops.mmap, msync: ps.stream_ops.msync } }, link: { node: { getattr: ps.node_ops.getattr, setattr: ps.node_ops.setattr, readlink: ps.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: ps.node_ops.getattr, setattr: ps.node_ops.setattr }, stream: vt.chrdev_stream_ops } }), N = vt.createNode(T, y, N, b), vt.isDir(N.mode) ? (N.node_ops = ps.ops_table.dir.node, N.stream_ops = ps.ops_table.dir.stream, N.contents = {}) : vt.isFile(N.mode) ? (N.node_ops = ps.ops_table.file.node, N.stream_ops = ps.ops_table.file.stream, N.usedBytes = 0, N.contents = null) : vt.isLink(N.mode) ? (N.node_ops = ps.ops_table.link.node, N.stream_ops = ps.ops_table.link.stream) : vt.isChrdev(N.mode) && (N.node_ops = ps.ops_table.chrdev.node, N.stream_ops = ps.ops_table.chrdev.stream), N.timestamp = Date.now(), T && (T.contents[y] = N, T.timestamp = N.timestamp), N;
      }, getFileDataAsTypedArray: function(T) {
        return T.contents ? T.contents.subarray ? T.contents.subarray(0, T.usedBytes) : new Uint8Array(T.contents) : new Uint8Array(0);
      }, expandFileStorage: function(T, y) {
        var N = T.contents ? T.contents.length : 0;
        y <= N || (y = Math.max(y, N * (N < 1048576 ? 2 : 1.125) >>> 0), N != 0 && (y = Math.max(y, 256)), N = T.contents, T.contents = new Uint8Array(y), 0 < T.usedBytes && T.contents.set(N.subarray(0, T.usedBytes), 0));
      }, resizeFileStorage: function(T, y) {
        var N;
        T.usedBytes != y && (y == 0 ? (T.contents = null, T.usedBytes = 0) : (N = T.contents, T.contents = new Uint8Array(y), N && T.contents.set(N.subarray(0, Math.min(y, T.usedBytes))), T.usedBytes = y));
      }, node_ops: { getattr: function(T) {
        var y = {};
        return y.dev = vt.isChrdev(T.mode) ? T.id : 1, y.ino = T.id, y.mode = T.mode, y.nlink = 1, y.uid = 0, y.gid = 0, y.rdev = T.rdev, vt.isDir(T.mode) ? y.size = 4096 : vt.isFile(T.mode) ? y.size = T.usedBytes : vt.isLink(T.mode) ? y.size = T.link.length : y.size = 0, y.atime = new Date(T.timestamp), y.mtime = new Date(T.timestamp), y.ctime = new Date(T.timestamp), y.blksize = 4096, y.blocks = Math.ceil(y.size / y.blksize), y;
      }, setattr: function(T, y) {
        y.mode !== void 0 && (T.mode = y.mode), y.timestamp !== void 0 && (T.timestamp = y.timestamp), y.size !== void 0 && ps.resizeFileStorage(T, y.size);
      }, lookup: function(T, y) {
        throw vt.genericErrors[44];
      }, mknod: function(T, y, N, b) {
        return ps.createNode(T, y, N, b);
      }, rename: function(T, y, N) {
        if (vt.isDir(T.mode)) {
          var b;
          try {
            b = vt.lookupNode(y, N);
          } catch {
          }
          if (b)
            for (var X in b.contents)
              throw new vt.ErrnoError(55);
        }
        delete T.parent.contents[T.name], T.parent.timestamp = Date.now(), T.name = N, y.contents[N] = T, y.timestamp = T.parent.timestamp, T.parent = y;
      }, unlink: function(T, y) {
        delete T.contents[y], T.timestamp = Date.now();
      }, rmdir: function(T, y) {
        for (var N in vt.lookupNode(T, y).contents)
          throw new vt.ErrnoError(55);
        delete T.contents[y], T.timestamp = Date.now();
      }, readdir: function(T) {
        for (var y = [".", ".."], N = 0, b = Object.keys(T.contents); N < b.length; N++) {
          var X = b[N];
          y.push(X);
        }
        return y;
      }, symlink: function(T, y, N) {
        return T = ps.createNode(T, y, 41471, 0), T.link = N, T;
      }, readlink: function(T) {
        if (vt.isLink(T.mode))
          return T.link;
        throw new vt.ErrnoError(28);
      } }, stream_ops: { read: function(T, y, N, b, X) {
        var J = T.node.contents;
        if (X >= T.node.usedBytes)
          return 0;
        var Ie = Math.min(T.node.usedBytes - X, b);
        if (8 < Ie && J.subarray)
          y.set(J.subarray(X, X + Ie), N);
        else
          for (var Pe = 0; Pe < Ie; Pe++)
            y[N + Pe] = J[X + Pe];
        return Ie;
      }, write: function(T, y, N, b, X, J) {
        if (y.buffer === xs.buffer && (J = !1), !b)
          return 0;
        var Ie = T.node;
        if (Ie.timestamp = Date.now(), y.subarray && (!Ie.contents || Ie.contents.subarray)) {
          if (J)
            return Ie.contents = y.subarray(N, N + b), Ie.usedBytes = b;
          if (Ie.usedBytes === 0 && X === 0)
            return Ie.contents = y.slice(N, N + b), Ie.usedBytes = b;
          if (X + b <= Ie.usedBytes)
            return Ie.contents.set(y.subarray(N, N + b), X), b;
        }
        if (ps.expandFileStorage(Ie, X + b), Ie.contents.subarray && y.subarray)
          Ie.contents.set(y.subarray(N, N + b), X);
        else
          for (var Pe = 0; Pe < b; Pe++)
            Ie.contents[X + Pe] = y[N + Pe];
        return Ie.usedBytes = Math.max(Ie.usedBytes, X + b), b;
      }, llseek: function(T, y, N) {
        if (N === 1 ? y += T.position : N === 2 && vt.isFile(T.node.mode) && (y += T.node.usedBytes), y < 0)
          throw new vt.ErrnoError(28);
        return y;
      }, allocate: function(T, y, N) {
        ps.expandFileStorage(T.node, y + N), T.node.usedBytes = Math.max(T.node.usedBytes, y + N);
      }, mmap: function(Pe, y, N, b, X) {
        if (!vt.isFile(Pe.node.mode))
          throw new vt.ErrnoError(43);
        var J, Ie, Pe = Pe.node.contents;
        if (2 & X || Pe.buffer !== xs.buffer) {
          if ((0 < N || N + y < Pe.length) && (Pe = Pe.subarray ? Pe.subarray(N, N + y) : Array.prototype.slice.call(Pe, N, N + y)), Ie = !0, !(J = ds(y)))
            throw new vt.ErrnoError(48);
          xs.set(Pe, J);
        } else
          Ie = !1, J = Pe.byteOffset;
        return { ptr: J, allocated: Ie };
      }, msync: function(T, y, N, b, X) {
        return ps.stream_ops.write(T, y, 0, b, N, !1), 0;
      } } }, Tr = Lt.preloadPlugins || [], ao = { EPERM: 63, ENOENT: 44, ESRCH: 71, EINTR: 27, EIO: 29, ENXIO: 60, E2BIG: 1, ENOEXEC: 45, EBADF: 8, ECHILD: 12, EAGAIN: 6, EWOULDBLOCK: 6, ENOMEM: 48, EACCES: 2, EFAULT: 21, ENOTBLK: 105, EBUSY: 10, EEXIST: 20, EXDEV: 75, ENODEV: 43, ENOTDIR: 54, EISDIR: 31, EINVAL: 28, ENFILE: 41, EMFILE: 33, ENOTTY: 59, ETXTBSY: 74, EFBIG: 22, ENOSPC: 51, ESPIPE: 70, EROFS: 69, EMLINK: 34, EPIPE: 64, EDOM: 18, ERANGE: 68, ENOMSG: 49, EIDRM: 24, ECHRNG: 106, EL2NSYNC: 156, EL3HLT: 107, EL3RST: 108, ELNRNG: 109, EUNATCH: 110, ENOCSI: 111, EL2HLT: 112, EDEADLK: 16, ENOLCK: 46, EBADE: 113, EBADR: 114, EXFULL: 115, ENOANO: 104, EBADRQC: 103, EBADSLT: 102, EDEADLOCK: 16, EBFONT: 101, ENOSTR: 100, ENODATA: 116, ETIME: 117, ENOSR: 118, ENONET: 119, ENOPKG: 120, EREMOTE: 121, ENOLINK: 47, EADV: 122, ESRMNT: 123, ECOMM: 124, EPROTO: 65, EMULTIHOP: 36, EDOTDOT: 125, EBADMSG: 9, ENOTUNIQ: 126, EBADFD: 127, EREMCHG: 128, ELIBACC: 129, ELIBBAD: 130, ELIBSCN: 131, ELIBMAX: 132, ELIBEXEC: 133, ENOSYS: 52, ENOTEMPTY: 55, ENAMETOOLONG: 37, ELOOP: 32, EOPNOTSUPP: 138, EPFNOSUPPORT: 139, ECONNRESET: 15, ENOBUFS: 42, EAFNOSUPPORT: 5, EPROTOTYPE: 67, ENOTSOCK: 57, ENOPROTOOPT: 50, ESHUTDOWN: 140, ECONNREFUSED: 14, EADDRINUSE: 3, ECONNABORTED: 13, ENETUNREACH: 40, ENETDOWN: 38, ETIMEDOUT: 73, EHOSTDOWN: 142, EHOSTUNREACH: 23, EINPROGRESS: 26, EALREADY: 7, EDESTADDRREQ: 17, EMSGSIZE: 35, EPROTONOSUPPORT: 66, ESOCKTNOSUPPORT: 137, EADDRNOTAVAIL: 4, ENETRESET: 39, EISCONN: 30, ENOTCONN: 53, ETOOMANYREFS: 141, EUSERS: 136, EDQUOT: 19, ESTALE: 72, ENOTSUP: 138, ENOMEDIUM: 148, EILSEQ: 25, EOVERFLOW: 61, ECANCELED: 11, ENOTRECOVERABLE: 56, EOWNERDEAD: 62, ESTRPIPE: 135 }, Gt = { isWindows: !1, staticInit: function() {
        Gt.isWindows = !!api$1.platform.match(/^win/);
        var T = api$1.binding("constants");
        T.fs && (T = T.fs), Gt.flagsForNodeMap = { 1024: T.O_APPEND, 64: T.O_CREAT, 128: T.O_EXCL, 256: T.O_NOCTTY, 0: T.O_RDONLY, 2: T.O_RDWR, 4096: T.O_SYNC, 512: T.O_TRUNC, 1: T.O_WRONLY, 131072: T.O_NOFOLLOW };
      }, convertNodeCode: function(T) {
        return T = T.code, ao[T];
      }, mount: function(T) {
        return Gt.createNode(null, "/", Gt.getMode(T.opts.root), 0);
      }, createNode: function(T, y, N, b) {
        if (vt.isDir(N) || vt.isFile(N) || vt.isLink(N))
          return (T = vt.createNode(T, y, N)).node_ops = Gt.node_ops, T.stream_ops = Gt.stream_ops, T;
        throw new vt.ErrnoError(28);
      }, getMode: function(T) {
        var y;
        try {
          y = ur.lstatSync(T), Gt.isWindows && (y.mode = y.mode | (292 & y.mode) >> 2);
        } catch (N) {
          throw N.code ? new vt.ErrnoError(Gt.convertNodeCode(N)) : N;
        }
        return y.mode;
      }, realPath: function(T) {
        for (var y = []; T.parent !== T; )
          y.push(T.name), T = T.parent;
        return y.push(T.mount.opts.root), y.reverse(), _s.join.apply(null, y);
      }, flagsForNode: function(T) {
        T = -2097153 & T & -2049 & -32769 & -524289 & -65537;
        var y, N = 0;
        for (y in Gt.flagsForNodeMap)
          T & y && (N |= Gt.flagsForNodeMap[y], T ^= y);
        if (T)
          throw new vt.ErrnoError(28);
        return N;
      }, node_ops: { getattr: function(N) {
        var y, N = Gt.realPath(N);
        try {
          y = ur.lstatSync(N);
        } catch (b) {
          throw b.code ? new vt.ErrnoError(Gt.convertNodeCode(b)) : b;
        }
        return Gt.isWindows && !y.blksize && (y.blksize = 4096), Gt.isWindows && !y.blocks && (y.blocks = (y.size + y.blksize - 1) / y.blksize | 0), { dev: y.dev, ino: y.ino, mode: y.mode, nlink: y.nlink, uid: y.uid, gid: y.gid, rdev: y.rdev, size: y.size, atime: y.atime, mtime: y.mtime, ctime: y.ctime, blksize: y.blksize, blocks: y.blocks };
      }, setattr: function(T, y) {
        var N, b = Gt.realPath(T);
        try {
          y.mode !== void 0 && (ur.chmodSync(b, y.mode), T.mode = y.mode), y.timestamp !== void 0 && (N = new Date(y.timestamp), ur.utimesSync(b, N, N)), y.size !== void 0 && ur.truncateSync(b, y.size);
        } catch (X) {
          throw X.code ? new vt.ErrnoError(Gt.convertNodeCode(X)) : X;
        }
      }, lookup: function(T, y) {
        var N = _s.join2(Gt.realPath(T), y), N = Gt.getMode(N);
        return Gt.createNode(T, y, N);
      }, mknod: function(T, y, N, b) {
        T = Gt.createNode(T, y, N, b), y = Gt.realPath(T);
        try {
          vt.isDir(T.mode) ? ur.mkdirSync(y, T.mode) : ur.writeFileSync(y, "", { mode: T.mode });
        } catch (X) {
          throw X.code ? new vt.ErrnoError(Gt.convertNodeCode(X)) : X;
        }
        return T;
      }, rename: function(T, X, N) {
        var b = Gt.realPath(T), X = _s.join2(Gt.realPath(X), N);
        try {
          ur.renameSync(b, X);
        } catch (J) {
          throw J.code ? new vt.ErrnoError(Gt.convertNodeCode(J)) : J;
        }
        T.name = N;
      }, unlink: function(T, y) {
        T = _s.join2(Gt.realPath(T), y);
        try {
          ur.unlinkSync(T);
        } catch (N) {
          throw N.code ? new vt.ErrnoError(Gt.convertNodeCode(N)) : N;
        }
      }, rmdir: function(T, y) {
        T = _s.join2(Gt.realPath(T), y);
        try {
          ur.rmdirSync(T);
        } catch (N) {
          throw N.code ? new vt.ErrnoError(Gt.convertNodeCode(N)) : N;
        }
      }, readdir: function(T) {
        T = Gt.realPath(T);
        try {
          return ur.readdirSync(T);
        } catch (y) {
          throw y.code ? new vt.ErrnoError(Gt.convertNodeCode(y)) : y;
        }
      }, symlink: function(T, y, N) {
        T = _s.join2(Gt.realPath(T), y);
        try {
          ur.symlinkSync(N, T);
        } catch (b) {
          throw b.code ? new vt.ErrnoError(Gt.convertNodeCode(b)) : b;
        }
      }, readlink: function(T) {
        var y = Gt.realPath(T);
        try {
          return y = ur.readlinkSync(y), gr.relative(gr.resolve(T.mount.opts.root), y);
        } catch (N) {
          throw N.code ? N.code === "UNKNOWN" ? new vt.ErrnoError(28) : new vt.ErrnoError(Gt.convertNodeCode(N)) : N;
        }
      } }, stream_ops: { open: function(T) {
        var y = Gt.realPath(T.node);
        try {
          vt.isFile(T.node.mode) && (T.nfd = ur.openSync(y, Gt.flagsForNode(T.flags)));
        } catch (N) {
          throw N.code ? new vt.ErrnoError(Gt.convertNodeCode(N)) : N;
        }
      }, close: function(T) {
        try {
          vt.isFile(T.node.mode) && T.nfd && ur.closeSync(T.nfd);
        } catch (y) {
          throw y.code ? new vt.ErrnoError(Gt.convertNodeCode(y)) : y;
        }
      }, read: function(T, y, N, b, X) {
        if (b === 0)
          return 0;
        try {
          return ur.readSync(T.nfd, new Int8Array(y.buffer, N, b), { position: X });
        } catch (J) {
          throw new vt.ErrnoError(Gt.convertNodeCode(J));
        }
      }, write: function(T, y, N, b, X) {
        try {
          return ur.writeSync(T.nfd, new Int8Array(y.buffer, N, b), { position: X });
        } catch (J) {
          throw new vt.ErrnoError(Gt.convertNodeCode(J));
        }
      }, llseek: function(T, y, N) {
        if (N === 1)
          y += T.position;
        else if (N === 2 && vt.isFile(T.node.mode))
          try {
            y += ur.fstatSync(T.nfd).size;
          } catch (b) {
            throw new vt.ErrnoError(Gt.convertNodeCode(b));
          }
        if (y < 0)
          throw new vt.ErrnoError(28);
        return y;
      }, mmap: function(T, y, N, b, X) {
        var J;
        if (vt.isFile(T.node.mode))
          return J = ds(y), Gt.stream_ops.read(T, xs, J, y, N), { ptr: J, allocated: !0 };
        throw new vt.ErrnoError(43);
      }, msync: function(T, y, N, b, X) {
        return Gt.stream_ops.write(T, y, 0, b, N, !1), 0;
      } } }, sr = { DIR_MODE: 16895, FILE_MODE: 33279, reader: null, mount: function(T) {
        Uo(Eo), sr.reader || (sr.reader = new FileReaderSync());
        var y = sr.createNode(null, "/", sr.DIR_MODE, 0), N = {};
        function b(J) {
          for (var Ie = J.split("/"), Pe = y, We = 0; We < Ie.length - 1; We++) {
            var it, Rt = Ie.slice(0, We + 1).join("/");
            N[it = Rt] || (N[it] = sr.createNode(Pe, Ie[We], sr.DIR_MODE, 0)), Pe = N[Rt];
          }
          return Pe;
        }
        function X(J) {
          return J = J.split("/"), J[J.length - 1];
        }
        return Array.prototype.forEach.call(T.opts.files || [], function(J) {
          sr.createNode(b(J.name), X(J.name), sr.FILE_MODE, 0, J, J.lastModifiedDate);
        }), (T.opts.blobs || []).forEach(function(J) {
          sr.createNode(b(J.name), X(J.name), sr.FILE_MODE, 0, J.data);
        }), (T.opts.packages || []).forEach(function(J) {
          J.metadata.files.forEach(function(Ie) {
            var Pe = Ie.filename.substr(1);
            sr.createNode(b(Pe), X(Pe), sr.FILE_MODE, 0, J.blob.slice(Ie.start, Ie.end));
          });
        }), y;
      }, createNode: function(T, y, N, b, X, J) {
        var Ie = vt.createNode(T, y, N);
        return Ie.mode = N, Ie.node_ops = sr.node_ops, Ie.stream_ops = sr.stream_ops, Ie.timestamp = (J || /* @__PURE__ */ new Date()).getTime(), Uo(sr.FILE_MODE !== sr.DIR_MODE), N === sr.FILE_MODE ? (Ie.size = X.size, Ie.contents = X) : (Ie.size = 4096, Ie.contents = {}), T && (T.contents[y] = Ie), Ie;
      }, node_ops: { getattr: function(T) {
        return { dev: 1, ino: T.id, mode: T.mode, nlink: 1, uid: 0, gid: 0, rdev: 0, size: T.size, atime: new Date(T.timestamp), mtime: new Date(T.timestamp), ctime: new Date(T.timestamp), blksize: 4096, blocks: Math.ceil(T.size / 4096) };
      }, setattr: function(T, y) {
        y.mode !== void 0 && (T.mode = y.mode), y.timestamp !== void 0 && (T.timestamp = y.timestamp);
      }, lookup: function(T, y) {
        throw new vt.ErrnoError(44);
      }, mknod: function(T, y, N, b) {
        throw new vt.ErrnoError(63);
      }, rename: function(T, y, N) {
        throw new vt.ErrnoError(63);
      }, unlink: function(T, y) {
        throw new vt.ErrnoError(63);
      }, rmdir: function(T, y) {
        throw new vt.ErrnoError(63);
      }, readdir: function(T) {
        for (var y = [".", ".."], N = 0, b = Object.keys(T.contents); N < b.length; N++) {
          var X = b[N];
          y.push(X);
        }
        return y;
      }, symlink: function(T, y, N) {
        throw new vt.ErrnoError(63);
      } }, stream_ops: { read: function(T, y, N, b, X) {
        return X >= T.node.size ? 0 : (T = T.node.contents.slice(X, X + b), X = sr.reader.readAsArrayBuffer(T), y.set(new Uint8Array(X), N), T.size);
      }, write: function(T, y, N, b, X) {
        throw new vt.ErrnoError(29);
      }, llseek: function(T, y, N) {
        if (N === 1 ? y += T.position : N === 2 && vt.isFile(T.node.mode) && (y += T.node.size), y < 0)
          throw new vt.ErrnoError(28);
        return y;
      } } }, vt = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath: function(T) {
        var y = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        if (!(T = oo.resolve(T)))
          return { path: "", node: null };
        if (8 < (y = Object.assign({ follow_mount: !0, recurse_count: 0 }, y)).recurse_count)
          throw new vt.ErrnoError(32);
        for (var N = T.split("/").filter(function(it) {
          return !!it;
        }), b = vt.root, X = "/", J = 0; J < N.length; J++) {
          var Ie = J === N.length - 1;
          if (Ie && y.parent)
            break;
          if (b = vt.lookupNode(b, N[J]), X = _s.join2(X, N[J]), !vt.isMountpoint(b) || Ie && !y.follow_mount || (b = b.mounted.root), !Ie || y.follow)
            for (var Pe = 0; vt.isLink(b.mode); ) {
              var We = vt.readlink(X), X = oo.resolve(_s.dirname(X), We), b = vt.lookupPath(X, { recurse_count: y.recurse_count + 1 }).node;
              if (40 < Pe++)
                throw new vt.ErrnoError(32);
            }
        }
        return { path: X, node: b };
      }, getPath: function(T) {
        for (var y, N; ; ) {
          if (vt.isRoot(T))
            return N = T.mount.mountpoint, y ? N[N.length - 1] !== "/" ? "".concat(N, "/").concat(y) : N + y : N;
          y = y ? "".concat(T.name, "/").concat(y) : T.name, T = T.parent;
        }
      }, hashName: function(T, y) {
        for (var N = 0, b = 0; b < y.length; b++)
          N = (N << 5) - N + y.charCodeAt(b) | 0;
        return (T + N >>> 0) % vt.nameTable.length;
      }, hashAddNode: function(T) {
        var y = vt.hashName(T.parent.id, T.name);
        T.name_next = vt.nameTable[y], vt.nameTable[y] = T;
      }, hashRemoveNode: function(T) {
        var y = vt.hashName(T.parent.id, T.name);
        if (vt.nameTable[y] === T)
          vt.nameTable[y] = T.name_next;
        else
          for (var N = vt.nameTable[y]; N; ) {
            if (N.name_next === T) {
              N.name_next = T.name_next;
              break;
            }
            N = N.name_next;
          }
      }, lookupNode: function(T, y) {
        var N = vt.mayLookup(T);
        if (N)
          throw new vt.ErrnoError(N, T);
        for (var N = vt.hashName(T.id, y), b = vt.nameTable[N]; b; b = b.name_next) {
          var X = b.name;
          if (b.parent.id === T.id && X === y)
            return b;
        }
        return vt.lookup(T, y);
      }, createNode: function(T, y, N, b) {
        return T = new vt.FSNode(T, y, N, b), vt.hashAddNode(T), T;
      }, destroyNode: function(T) {
        vt.hashRemoveNode(T);
      }, isRoot: function(T) {
        return T === T.parent;
      }, isMountpoint: function(T) {
        return !!T.mounted;
      }, isFile: function(T) {
        return (61440 & T) == 32768;
      }, isDir: function(T) {
        return (61440 & T) == 16384;
      }, isLink: function(T) {
        return (61440 & T) == 40960;
      }, isChrdev: function(T) {
        return (61440 & T) == 8192;
      }, isBlkdev: function(T) {
        return (61440 & T) == 24576;
      }, isFIFO: function(T) {
        return (61440 & T) == 4096;
      }, isSocket: function(T) {
        return (49152 & T) == 49152;
      }, flagsToPermissionString: function(T) {
        var y = ["r", "w", "rw"][3 & T];
        return 512 & T && (y += "w"), y;
      }, nodePermissions: function(T, y) {
        return vt.ignorePermissions || (!y.includes("r") || 292 & T.mode) && (!y.includes("w") || 146 & T.mode) && (!y.includes("x") || 73 & T.mode) ? 0 : 2;
      }, mayLookup: function(T) {
        var y = vt.nodePermissions(T, "x");
        return y || (T.node_ops.lookup ? 0 : 2);
      }, mayCreate: function(T, y) {
        try {
          return vt.lookupNode(T, y), 20;
        } catch {
        }
        return vt.nodePermissions(T, "wx");
      }, mayDelete: function(T, y, N) {
        var b;
        try {
          b = vt.lookupNode(T, y);
        } catch (X) {
          return X.errno;
        }
        if (y = vt.nodePermissions(T, "wx"), y)
          return y;
        if (N) {
          if (!vt.isDir(b.mode))
            return 54;
          if (vt.isRoot(b) || vt.getPath(b) === vt.cwd())
            return 10;
        } else if (vt.isDir(b.mode))
          return 31;
        return 0;
      }, mayOpen: function(T, y) {
        return T ? vt.isLink(T.mode) ? 32 : vt.isDir(T.mode) && (vt.flagsToPermissionString(y) !== "r" || 512 & y) ? 31 : vt.nodePermissions(T, vt.flagsToPermissionString(y)) : 44;
      }, MAX_OPEN_FDS: 4096, nextfd: function() {
        for (var T = 0; T <= vt.MAX_OPEN_FDS; T++)
          if (!vt.streams[T])
            return T;
        throw new vt.ErrnoError(33);
      }, getStreamChecked: function(T) {
        if (T = vt.getStream(T), T)
          return T;
        throw new vt.ErrnoError(8);
      }, getStream: function(T) {
        return vt.streams[T];
      }, createStream: function(T) {
        var y = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : -1;
        return vt.FSStream || (vt.FSStream = function() {
          this.shared = {};
        }, vt.FSStream.prototype = {}, Object.defineProperties(vt.FSStream.prototype, { object: { get: function() {
          return this.node;
        }, set: function(N) {
          this.node = N;
        } }, isRead: { get: function() {
          return (2097155 & this.flags) != 1;
        } }, isWrite: { get: function() {
          return (2097155 & this.flags) != 0;
        } }, isAppend: { get: function() {
          return 1024 & this.flags;
        } }, flags: { get: function() {
          return this.shared.flags;
        }, set: function(N) {
          this.shared.flags = N;
        } }, position: { get: function() {
          return this.shared.position;
        }, set: function(N) {
          this.shared.position = N;
        } } })), T = Object.assign(new vt.FSStream(), T), y == -1 && (y = vt.nextfd()), T.fd = y, vt.streams[y] = T;
      }, closeStream: function(T) {
        vt.streams[T] = null;
      }, chrdev_stream_ops: { open: function(T) {
        var y, N = vt.getDevice(T.node.rdev);
        T.stream_ops = N.stream_ops, (y = (N = T.stream_ops).open) != null && y.call(N, T);
      }, llseek: function() {
        throw new vt.ErrnoError(70);
      } }, major: function(T) {
        return T >> 8;
      }, minor: function(T) {
        return 255 & T;
      }, makedev: function(T, y) {
        return T << 8 | y;
      }, registerDevice: function(T, y) {
        vt.devices[T] = { stream_ops: y };
      }, getDevice: function(T) {
        return vt.devices[T];
      }, getMounts: function(T) {
        for (var y = [], N = [T]; N.length; ) {
          var b = N.pop();
          y.push(b), N.push.apply(N, b.mounts);
        }
        return y;
      }, syncfs: function(T, y) {
        typeof T == "function" && (y = T, T = !1), vt.syncFSRequests++, 1 < vt.syncFSRequests && Bo("warning: ".concat(vt.syncFSRequests, " FS.syncfs operations in flight at once, probably just doing extra work"));
        var N = vt.getMounts(vt.root.mount), b = 0;
        function X(Ie) {
          return vt.syncFSRequests--, y(Ie);
        }
        function J(Ie) {
          if (Ie)
            return J.errored ? void 0 : (J.errored = !0, X(Ie));
          ++b >= N.length && X(null);
        }
        N.forEach(function(Ie) {
          if (!Ie.type.syncfs)
            return J(null);
          Ie.type.syncfs(Ie, T, J);
        });
      }, mount: function(T, y, N) {
        var b, X = N === "/", J = !N;
        if (X && vt.root)
          throw new vt.ErrnoError(10);
        if (!X && !J) {
          if (J = vt.lookupPath(N, { follow_mount: !1 }), N = J.path, b = J.node, vt.isMountpoint(b))
            throw new vt.ErrnoError(10);
          if (!vt.isDir(b.mode))
            throw new vt.ErrnoError(54);
        }
        return J = { type: T, opts: y, mountpoint: N, mounts: [] }, y = T.mount(J), (y.mount = J).root = y, X ? vt.root = y : b && (b.mounted = J, b.mount) && b.mount.mounts.push(J), y;
      }, unmount: function(y) {
        if (y = vt.lookupPath(y, { follow_mount: !1 }), !vt.isMountpoint(y.node))
          throw new vt.ErrnoError(28);
        var y = y.node, b = y.mounted, N = vt.getMounts(b), b = (Object.keys(vt.nameTable).forEach(function(X) {
          for (var J = vt.nameTable[X]; J; ) {
            var Ie = J.name_next;
            N.includes(J.mount) && vt.destroyNode(J), J = Ie;
          }
        }), y.mounted = null, y.mount.mounts.indexOf(b));
        y.mount.mounts.splice(b, 1);
      }, lookup: function(T, y) {
        return T.node_ops.lookup(T, y);
      }, mknod: function(X, y, N) {
        var b = vt.lookupPath(X, { parent: !0 }).node, X = _s.basename(X);
        if (!X || X === "." || X === "..")
          throw new vt.ErrnoError(28);
        var J = vt.mayCreate(b, X);
        if (J)
          throw new vt.ErrnoError(J);
        if (b.node_ops.mknod)
          return b.node_ops.mknod(b, X, y, N);
        throw new vt.ErrnoError(63);
      }, create: function(T, y) {
        return vt.mknod(T, y = (y = y !== void 0 ? y : 438) & 4095 | 32768, 0);
      }, mkdir: function(T, y) {
        return vt.mknod(T, y = (y = y !== void 0 ? y : 511) & 1023 | 16384, 0);
      }, mkdirTree: function(T, y) {
        for (var N = T.split("/"), b = "", X = 0; X < N.length; ++X)
          if (N[X]) {
            b += "/" + N[X];
            try {
              vt.mkdir(b, y);
            } catch (J) {
              if (J.errno != 20)
                throw J;
            }
          }
      }, mkdev: function(T, y, N) {
        return N === void 0 && (N = y, y = 438), vt.mknod(T, y |= 8192, N);
      }, symlink: function(T, b) {
        if (!oo.resolve(T))
          throw new vt.ErrnoError(44);
        var N = vt.lookupPath(b, { parent: !0 }).node;
        if (!N)
          throw new vt.ErrnoError(44);
        var b = _s.basename(b), X = vt.mayCreate(N, b);
        if (X)
          throw new vt.ErrnoError(X);
        if (N.node_ops.symlink)
          return N.node_ops.symlink(N, b, T);
        throw new vt.ErrnoError(63);
      }, rename: function(Rt, y) {
        var N = _s.dirname(Rt), b = _s.dirname(y), X = _s.basename(Rt), J = _s.basename(y), Ie = vt.lookupPath(Rt, { parent: !0 }), Ie = Ie.node, Pe = vt.lookupPath(y, { parent: !0 }).node;
        if (!Ie || !Pe)
          throw new vt.ErrnoError(44);
        if (Ie.mount !== Pe.mount)
          throw new vt.ErrnoError(75);
        var We, it = vt.lookupNode(Ie, X), Rt = oo.relative(Rt, b);
        if (Rt.charAt(0) !== ".")
          throw new vt.ErrnoError(28);
        if ((Rt = oo.relative(y, N)).charAt(0) !== ".")
          throw new vt.ErrnoError(55);
        try {
          We = vt.lookupNode(Pe, J);
        } catch {
        }
        if (it !== We) {
          if (b = vt.isDir(it.mode), y = vt.mayDelete(Ie, X, b), y)
            throw new vt.ErrnoError(y);
          if (y = We ? vt.mayDelete(Pe, J, b) : vt.mayCreate(Pe, J))
            throw new vt.ErrnoError(y);
          if (!Ie.node_ops.rename)
            throw new vt.ErrnoError(63);
          if (vt.isMountpoint(it) || We && vt.isMountpoint(We))
            throw new vt.ErrnoError(10);
          if (Pe !== Ie && (y = vt.nodePermissions(Ie, "w")))
            throw new vt.ErrnoError(y);
          vt.hashRemoveNode(it);
          try {
            Ie.node_ops.rename(it, Pe, J);
          } catch (Dt) {
            throw Dt;
          } finally {
            vt.hashAddNode(it);
          }
        }
      }, rmdir: function(N) {
        var y = vt.lookupPath(N, { parent: !0 }).node, N = _s.basename(N), b = vt.lookupNode(y, N), X = vt.mayDelete(y, N, !0);
        if (X)
          throw new vt.ErrnoError(X);
        if (!y.node_ops.rmdir)
          throw new vt.ErrnoError(63);
        if (vt.isMountpoint(b))
          throw new vt.ErrnoError(10);
        y.node_ops.rmdir(y, N), vt.destroyNode(b);
      }, readdir: function(T) {
        if (T = vt.lookupPath(T, { follow: !0 }).node, T.node_ops.readdir)
          return T.node_ops.readdir(T);
        throw new vt.ErrnoError(54);
      }, unlink: function(N) {
        var y = vt.lookupPath(N, { parent: !0 }).node;
        if (!y)
          throw new vt.ErrnoError(44);
        var N = _s.basename(N), b = vt.lookupNode(y, N), X = vt.mayDelete(y, N, !1);
        if (X)
          throw new vt.ErrnoError(X);
        if (!y.node_ops.unlink)
          throw new vt.ErrnoError(63);
        if (vt.isMountpoint(b))
          throw new vt.ErrnoError(10);
        y.node_ops.unlink(y, N), vt.destroyNode(b);
      }, readlink: function(T) {
        if (T = vt.lookupPath(T).node, !T)
          throw new vt.ErrnoError(44);
        if (T.node_ops.readlink)
          return oo.resolve(vt.getPath(T.parent), T.node_ops.readlink(T));
        throw new vt.ErrnoError(28);
      }, stat: function(T, y) {
        if (T = vt.lookupPath(T, { follow: !y }).node, !T)
          throw new vt.ErrnoError(44);
        if (T.node_ops.getattr)
          return T.node_ops.getattr(T);
        throw new vt.ErrnoError(63);
      }, lstat: function(T) {
        return vt.stat(T, !0);
      }, chmod: function(T, y, N) {
        if (!(N = typeof T == "string" ? vt.lookupPath(T, { follow: !N }).node : T).node_ops.setattr)
          throw new vt.ErrnoError(63);
        N.node_ops.setattr(N, { mode: 4095 & y | -4096 & N.mode, timestamp: Date.now() });
      }, lchmod: function(T, y) {
        vt.chmod(T, y, !0);
      }, fchmod: function(T, y) {
        T = vt.getStreamChecked(T), vt.chmod(T.node, y);
      }, chown: function(T, y, N, b) {
        if (!(b = typeof T == "string" ? vt.lookupPath(T, { follow: !b }).node : T).node_ops.setattr)
          throw new vt.ErrnoError(63);
        b.node_ops.setattr(b, { timestamp: Date.now() });
      }, lchown: function(T, y, N) {
        vt.chown(T, y, N, !0);
      }, fchown: function(T, y, N) {
        T = vt.getStreamChecked(T), vt.chown(T.node, y, N);
      }, truncate: function(T, y) {
        if (y < 0)
          throw new vt.ErrnoError(28);
        if (!(T = typeof T == "string" ? vt.lookupPath(T, { follow: !0 }).node : T).node_ops.setattr)
          throw new vt.ErrnoError(63);
        if (vt.isDir(T.mode))
          throw new vt.ErrnoError(31);
        if (!vt.isFile(T.mode))
          throw new vt.ErrnoError(28);
        var N = vt.nodePermissions(T, "w");
        if (N)
          throw new vt.ErrnoError(N);
        T.node_ops.setattr(T, { size: y, timestamp: Date.now() });
      }, ftruncate: function(T, y) {
        if (T = vt.getStreamChecked(T), !(2097155 & T.flags))
          throw new vt.ErrnoError(28);
        vt.truncate(T.node, y);
      }, utime: function(T, y, N) {
        T = vt.lookupPath(T, { follow: !0 }).node, T.node_ops.setattr(T, { timestamp: Math.max(y, N) });
      }, open: function(T, y, N) {
        if (T === "")
          throw new vt.ErrnoError(44);
        if (N = N === void 0 ? 438 : N, N = 64 & (y = typeof y == "string" ? function(J) {
          var Ie = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }[J];
          if (Ie === void 0)
            throw new Error("Unknown file open mode: ".concat(J));
          return Ie;
        }(y) : y) ? 4095 & N | 32768 : 0, a(T) == "object")
          b = T;
        else {
          T = _s.normalize(T);
          try {
            var b = vt.lookupPath(T, { follow: !(131072 & y) }).node;
          } catch {
          }
        }
        var X = !1;
        if (64 & y)
          if (b) {
            if (128 & y)
              throw new vt.ErrnoError(20);
          } else
            b = vt.mknod(T, N, 0), X = !0;
        if (!b)
          throw new vt.ErrnoError(44);
        if (vt.isChrdev(b.mode) && (y &= -513), 65536 & y && !vt.isDir(b.mode))
          throw new vt.ErrnoError(54);
        if (!X && (N = vt.mayOpen(b, y), N))
          throw new vt.ErrnoError(N);
        return 512 & y && !X && vt.truncate(b, 0), y &= -131713, N = vt.createStream({ node: b, path: vt.getPath(b), flags: y, seekable: !0, position: 0, stream_ops: b.stream_ops, ungotten: [], error: !1 }), N.stream_ops.open && N.stream_ops.open(N), !Lt.logReadFiles || 1 & y || (vt.readFiles || (vt.readFiles = {}), T in vt.readFiles) || (vt.readFiles[T] = 1), N;
      }, close: function(T) {
        if (vt.isClosed(T))
          throw new vt.ErrnoError(8);
        T.getdents && (T.getdents = null);
        try {
          T.stream_ops.close && T.stream_ops.close(T);
        } catch (y) {
          throw y;
        } finally {
          vt.closeStream(T.fd);
        }
        T.fd = null;
      }, isClosed: function(T) {
        return T.fd === null;
      }, llseek: function(T, y, N) {
        if (vt.isClosed(T))
          throw new vt.ErrnoError(8);
        if (!T.seekable || !T.stream_ops.llseek)
          throw new vt.ErrnoError(70);
        if (N != 0 && N != 1 && N != 2)
          throw new vt.ErrnoError(28);
        return T.position = T.stream_ops.llseek(T, y, N), T.ungotten = [], T.position;
      }, read: function(T, y, N, b, X) {
        if (b < 0 || X < 0)
          throw new vt.ErrnoError(28);
        if (vt.isClosed(T))
          throw new vt.ErrnoError(8);
        if ((2097155 & T.flags) == 1)
          throw new vt.ErrnoError(8);
        if (vt.isDir(T.node.mode))
          throw new vt.ErrnoError(31);
        if (!T.stream_ops.read)
          throw new vt.ErrnoError(28);
        var J = X !== void 0;
        if (J) {
          if (!T.seekable)
            throw new vt.ErrnoError(70);
        } else
          X = T.position;
        return y = T.stream_ops.read(T, y, N, b, X), J || (T.position += y), y;
      }, write: function(T, y, N, b, X, J) {
        if (b < 0 || X < 0)
          throw new vt.ErrnoError(28);
        if (vt.isClosed(T))
          throw new vt.ErrnoError(8);
        if (!(2097155 & T.flags))
          throw new vt.ErrnoError(8);
        if (vt.isDir(T.node.mode))
          throw new vt.ErrnoError(31);
        if (!T.stream_ops.write)
          throw new vt.ErrnoError(28);
        T.seekable && 1024 & T.flags && vt.llseek(T, 0, 2);
        var Ie = X !== void 0;
        if (Ie) {
          if (!T.seekable)
            throw new vt.ErrnoError(70);
        } else
          X = T.position;
        return y = T.stream_ops.write(T, y, N, b, X, J), Ie || (T.position += y), y;
      }, allocate: function(T, y, N) {
        if (vt.isClosed(T))
          throw new vt.ErrnoError(8);
        if (y < 0 || N <= 0)
          throw new vt.ErrnoError(28);
        if (!(2097155 & T.flags))
          throw new vt.ErrnoError(8);
        if (!vt.isFile(T.node.mode) && !vt.isDir(T.node.mode))
          throw new vt.ErrnoError(43);
        if (!T.stream_ops.allocate)
          throw new vt.ErrnoError(138);
        T.stream_ops.allocate(T, y, N);
      }, mmap: function(T, y, N, b, X) {
        if (2 & b && !(2 & X) && (2097155 & T.flags) != 2)
          throw new vt.ErrnoError(2);
        if ((2097155 & T.flags) == 1)
          throw new vt.ErrnoError(2);
        if (T.stream_ops.mmap)
          return T.stream_ops.mmap(T, y, N, b, X);
        throw new vt.ErrnoError(43);
      }, msync: function(T, y, N, b, X) {
        return T.stream_ops.msync ? T.stream_ops.msync(T, y, N, b, X) : 0;
      }, munmap: function(T) {
        return 0;
      }, ioctl: function(T, y, N) {
        if (T.stream_ops.ioctl)
          return T.stream_ops.ioctl(T, y, N);
        throw new vt.ErrnoError(59);
      }, readFile: function(X) {
        var y, N = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
        if (N.flags = N.flags || 0, N.encoding = N.encoding || "binary", N.encoding !== "utf8" && N.encoding !== "binary")
          throw new Error('Invalid encoding type "'.concat(N.encoding, '"'));
        var b = vt.open(X, N.flags), X = vt.stat(X).size, J = new Uint8Array(X);
        return vt.read(b, J, 0, X, 0), N.encoding === "utf8" ? y = Yn(J, 0) : N.encoding === "binary" && (y = J), vt.close(b), y;
      }, writeFile: function(b, y) {
        var N = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {}, b = (N.flags = N.flags || 577, vt.open(b, N.flags, N.mode));
        if (typeof y == "string") {
          var X = new Uint8Array(yi(y) + 1), J = $r(y, X, 0, X.length);
          vt.write(b, X, 0, J, void 0, N.canOwn);
        } else {
          if (!ArrayBuffer.isView(y))
            throw new Error("Unsupported data type");
          vt.write(b, y, 0, y.byteLength, void 0, N.canOwn);
        }
        vt.close(b);
      }, cwd: function() {
        return vt.currentPath;
      }, chdir: function(T) {
        if (T = vt.lookupPath(T, { follow: !0 }), T.node === null)
          throw new vt.ErrnoError(44);
        if (!vt.isDir(T.node.mode))
          throw new vt.ErrnoError(54);
        var y = vt.nodePermissions(T.node, "x");
        if (y)
          throw new vt.ErrnoError(y);
        vt.currentPath = T.path;
      }, createDefaultDirectories: function() {
        vt.mkdir("/tmp"), vt.mkdir("/home"), vt.mkdir("/home/web_user");
      }, createDefaultDevices: function() {
        vt.mkdir("/dev"), vt.registerDevice(vt.makedev(1, 3), { read: function() {
          return 0;
        }, write: function(b, X, J, Ie, Pe) {
          return Ie;
        } }), vt.mkdev("/dev/null", vt.makedev(1, 3)), Co.register(vt.makedev(5, 0), Co.default_tty_ops), Co.register(vt.makedev(6, 0), Co.default_tty1_ops), vt.mkdev("/dev/tty", vt.makedev(5, 0)), vt.mkdev("/dev/tty1", vt.makedev(6, 0));
        function T() {
          return N === 0 && (N = aa(y).byteLength), y[--N];
        }
        var y = new Uint8Array(1024), N = 0;
        vt.createDevice("/dev", "random", T), vt.createDevice("/dev", "urandom", T), vt.mkdir("/dev/shm"), vt.mkdir("/dev/shm/tmp");
      }, createSpecialDirectories: function() {
        vt.mkdir("/proc");
        var T = vt.mkdir("/proc/self");
        vt.mkdir("/proc/self/fd"), vt.mount({ mount: function() {
          var y = vt.createNode(T, "fd", 16895, 73);
          return y.node_ops = { lookup: function(N, J) {
            var X = vt.getStreamChecked(+J), J = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: function() {
              return X.path;
            } } };
            return J.parent = J;
          } }, y;
        } }, {}, "/proc/self/fd");
      }, createStandardStreams: function() {
        Lt.stdin ? vt.createDevice("/dev", "stdin", Lt.stdin) : vt.symlink("/dev/tty", "/dev/stdin"), Lt.stdout ? vt.createDevice("/dev", "stdout", null, Lt.stdout) : vt.symlink("/dev/tty", "/dev/stdout"), Lt.stderr ? vt.createDevice("/dev", "stderr", null, Lt.stderr) : vt.symlink("/dev/tty1", "/dev/stderr"), vt.open("/dev/stdin", 0), vt.open("/dev/stdout", 1), vt.open("/dev/stderr", 1);
      }, ensureErrnoError: function() {
        vt.ErrnoError || (vt.ErrnoError = function(T, y) {
          this.name = "ErrnoError", this.node = y, this.setErrno = function(N) {
            this.errno = N;
          }, this.setErrno(T), this.message = "FS error";
        }, vt.ErrnoError.prototype = new Error(), vt.ErrnoError.prototype.constructor = vt.ErrnoError, [44].forEach(function(T) {
          vt.genericErrors[T] = new vt.ErrnoError(T), vt.genericErrors[T].stack = "<generic error, no stack>";
        }));
      }, staticInit: function() {
        vt.ensureErrnoError(), vt.nameTable = new Array(4096), vt.mount(ps, {}, "/"), vt.createDefaultDirectories(), vt.createDefaultDevices(), vt.createSpecialDirectories(), vt.filesystems = { MEMFS: ps, NODEFS: Gt, WORKERFS: sr };
      }, init: function(T, y, N) {
        vt.init.initialized = !0, vt.ensureErrnoError(), Lt.stdin = T || Lt.stdin, Lt.stdout = y || Lt.stdout, Lt.stderr = N || Lt.stderr, vt.createStandardStreams();
      }, quit: function() {
        vt.init.initialized = !1;
        for (var T = 0; T < vt.streams.length; T++) {
          var y = vt.streams[T];
          y && vt.close(y);
        }
      }, findObject: function(T, y) {
        return T = vt.analyzePath(T, y), T.exists ? T.object : null;
      }, analyzePath: function(T, y) {
        try {
          T = (b = vt.lookupPath(T, { follow: !y })).path;
        } catch {
        }
        var N = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
        try {
          var b = vt.lookupPath(T, { parent: !0 });
          N.parentExists = !0, N.parentPath = b.path, N.parentObject = b.node, N.name = _s.basename(T), b = vt.lookupPath(T, { follow: !y }), N.exists = !0, N.path = b.path, N.object = b.node, N.name = b.node.name, N.isRoot = b.path === "/";
        } catch (X) {
          N.error = X.errno;
        }
        return N;
      }, createPath: function(T, y, N, b) {
        T = typeof T == "string" ? T : vt.getPath(T);
        for (var X = y.split("/").reverse(); X.length; ) {
          var J = X.pop();
          if (J) {
            var Ie = _s.join2(T, J);
            try {
              vt.mkdir(Ie);
            } catch {
            }
            T = Ie;
          }
        }
        return Ie;
      }, createFile: function(T, y, N, b, X) {
        return T = _s.join2(typeof T == "string" ? T : vt.getPath(T), y), y = Ls(b, X), vt.create(T, y);
      }, createDataFile: function(We, Pe, N, b, X, J) {
        var Ie = Pe, Pe = (We && (We = typeof We == "string" ? We : vt.getPath(We), Ie = Pe ? _s.join2(We, Pe) : We), Ls(b, X)), We = vt.create(Ie, Pe);
        if (N) {
          if (typeof N == "string") {
            for (var it = new Array(N.length), Rt = 0, Dt = N.length; Rt < Dt; ++Rt)
              it[Rt] = N.charCodeAt(Rt);
            N = it;
          }
          vt.chmod(We, 146 | Pe), b = vt.open(We, 577), vt.write(b, N, 0, N.length, 0, J), vt.close(b), vt.chmod(We, Pe);
        }
      }, createDevice: function(X, J, N, b) {
        var X = _s.join2(typeof X == "string" ? X : vt.getPath(X), J), J = Ls(!!N, !!b), Ie = (vt.createDevice.major || (vt.createDevice.major = 64), vt.makedev(vt.createDevice.major++, 0));
        return vt.registerDevice(Ie, { open: function(Pe) {
          Pe.seekable = !1;
        }, close: function(Pe) {
          var We;
          b != null && (We = b.buffer) != null && We.length && b(10);
        }, read: function(Pe, We, it, Rt, Dt) {
          for (var Kt, _n = 0, gn = 0; gn < Rt; gn++) {
            try {
              Kt = N();
            } catch {
              throw new vt.ErrnoError(29);
            }
            if (Kt === void 0 && _n === 0)
              throw new vt.ErrnoError(6);
            if (Kt == null)
              break;
            _n++, We[it + gn] = Kt;
          }
          return _n && (Pe.node.timestamp = Date.now()), _n;
        }, write: function(Pe, We, it, Rt, Dt) {
          for (var Kt = 0; Kt < Rt; Kt++)
            try {
              b(We[it + Kt]);
            } catch {
              throw new vt.ErrnoError(29);
            }
          return Rt && (Pe.node.timestamp = Date.now()), Kt;
        } }), vt.mkdev(X, J, Ie);
      }, forceLoadFile: function(T) {
        if (T.isDevice || T.isFolder || T.link || T.contents)
          return !0;
        if (typeof XMLHttpRequest < "u")
          throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        if (!Rr)
          throw new Error("Cannot load without read() or XMLHttpRequest.");
        try {
          T.contents = ki(Rr(T.url), !0), T.usedBytes = T.contents.length;
        } catch {
          throw new vt.ErrnoError(29);
        }
      }, createLazyFile: function(T, y, N, b, X) {
        function J() {
          this.lengthKnown = !1, this.chunks = [];
        }
        if (J.prototype.get = function(Rt) {
          var Dt;
          if (!(Rt > this.length - 1 || Rt < 0))
            return Dt = Rt % this.chunkSize, Rt = Rt / this.chunkSize | 0, this.getter(Rt)[Dt];
        }, J.prototype.setDataGetter = function(Rt) {
          this.getter = Rt;
        }, J.prototype.cacheLength = function() {
          var _n = new XMLHttpRequest();
          if (_n.open("HEAD", N, !1), _n.send(null), !(200 <= _n.status && _n.status < 300 || _n.status === 304))
            throw new Error("Couldn't load " + N + ". Status: " + _n.status);
          var Rt, Dt = Number(_n.getResponseHeader("Content-length")), Kt = (Rt = _n.getResponseHeader("Accept-Ranges")) && Rt === "bytes", _n = (Rt = _n.getResponseHeader("Content-Encoding")) && Rt === "gzip", gn = 1048576, Pn = (Kt || (gn = Dt), this);
          Pn.setDataGetter(function(Vn) {
            var vn = Vn * gn, Zn = (Vn + 1) * gn - 1, Zn = Math.min(Zn, Dt - 1);
            if (Pn.chunks[Vn] === void 0 && (Pn.chunks[Vn] = function(cr, Cs) {
              if (Cs < cr)
                throw new Error("invalid range (" + cr + ", " + Cs + ") or no bytes requested!");
              if (Dt - 1 < Cs)
                throw new Error("only " + Dt + " bytes available! programmer error!");
              var Br = new XMLHttpRequest();
              if (Br.open("GET", N, !1), Dt !== gn && Br.setRequestHeader("Range", "bytes=" + cr + "-" + Cs), Br.responseType = "arraybuffer", Br.overrideMimeType && Br.overrideMimeType("text/plain; charset=x-user-defined"), Br.send(null), 200 <= Br.status && Br.status < 300 || Br.status === 304)
                return Br.response !== void 0 ? new Uint8Array(Br.response || []) : ki(Br.responseText || "", !0);
              throw new Error("Couldn't load " + N + ". Status: " + Br.status);
            }(vn, Zn)), Pn.chunks[Vn] === void 0)
              throw new Error("doXHR failed!");
            return Pn.chunks[Vn];
          }), !_n && Dt || (gn = Dt = 1, Dt = this.getter(0).length, gn = Dt, Ro("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Dt, this._chunkSize = gn, this.lengthKnown = !0;
        }, typeof XMLHttpRequest < "u") {
          if (!Eo)
            throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
          var Ie = new J(), Ie = (Object.defineProperties(Ie, { length: { get: function() {
            return this.lengthKnown || this.cacheLength(), this._length;
          } }, chunkSize: { get: function() {
            return this.lengthKnown || this.cacheLength(), this._chunkSize;
          } } }), { isDevice: !1, contents: Ie });
        } else
          Ie = { isDevice: !1, url: N };
        var Pe = vt.createFile(T, y, Ie, b, X), We = (Ie.contents ? Pe.contents = Ie.contents : Ie.url && (Pe.contents = null, Pe.url = Ie.url), Object.defineProperties(Pe, { usedBytes: { get: function() {
          return this.contents.length;
        } } }), {});
        function it(Rt, Dt, Kt, _n, gn) {
          var Pn = Rt.node.contents;
          if (gn >= Pn.length)
            return 0;
          var Vn = Math.min(Pn.length - gn, _n);
          if (Pn.slice)
            for (var vn = 0; vn < Vn; vn++)
              Dt[Kt + vn] = Pn[gn + vn];
          else
            for (vn = 0; vn < Vn; vn++)
              Dt[Kt + vn] = Pn.get(gn + vn);
          return Vn;
        }
        return Object.keys(Pe.stream_ops).forEach(function(Rt) {
          var Dt = Pe.stream_ops[Rt];
          We[Rt] = function() {
            return vt.forceLoadFile(Pe), Dt.apply(null, arguments);
          };
        }), We.read = function(Rt, Dt, Kt, _n, gn) {
          return vt.forceLoadFile(Pe), it(Rt, Dt, Kt, _n, gn);
        }, We.mmap = function(Rt, Dt, Kt, _n, gn) {
          vt.forceLoadFile(Pe);
          var Pn = ds(Dt);
          if (Pn)
            return it(Rt, xs, Pn, Dt, Kt), { ptr: Pn, allocated: !0 };
          throw new vt.ErrnoError(48);
        }, Pe.stream_ops = We, Pe;
      } }, Jr = { DEFAULT_POLLMASK: 5, calculateAt: function(T, y, N) {
        if (_s.isAbs(y))
          return y;
        if (T = T === -100 ? vt.cwd() : Jr.getStreamFromFD(T).path, y.length != 0)
          return _s.join2(T, y);
        if (N)
          return T;
        throw new vt.ErrnoError(44);
      }, doStat: function(X, J, N) {
        try {
          var b = X(J);
        } catch (Pe) {
          if (Pe && Pe.node && _s.normalize(J) !== _s.normalize(vt.getPath(Pe.node)))
            return -54;
          throw Pe;
        }
        fr[N >> 2] = b.dev, fr[N + 4 >> 2] = b.mode, Mr[N + 8 >> 2] = b.nlink, fr[N + 12 >> 2] = b.uid, fr[N + 16 >> 2] = b.gid, fr[N + 20 >> 2] = b.rdev, Us = [b.size >>> 0, (kr = b.size, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[N + 24 >> 2] = Us[0], fr[N + 28 >> 2] = Us[1], fr[N + 32 >> 2] = 4096, fr[N + 36 >> 2] = b.blocks;
        var X = b.atime.getTime(), J = b.mtime.getTime(), Ie = b.ctime.getTime();
        return Us = [Math.floor(X / 1e3) >>> 0, (kr = Math.floor(X / 1e3), 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[N + 40 >> 2] = Us[0], fr[N + 44 >> 2] = Us[1], Mr[N + 48 >> 2] = X % 1e3 * 1e3, Us = [Math.floor(J / 1e3) >>> 0, (kr = Math.floor(J / 1e3), 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[N + 56 >> 2] = Us[0], fr[N + 60 >> 2] = Us[1], Mr[N + 64 >> 2] = J % 1e3 * 1e3, Us = [Math.floor(Ie / 1e3) >>> 0, (kr = Math.floor(Ie / 1e3), 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[N + 72 >> 2] = Us[0], fr[N + 76 >> 2] = Us[1], Mr[N + 80 >> 2] = Ie % 1e3 * 1e3, Us = [b.ino >>> 0, (kr = b.ino, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[N + 88 >> 2] = Us[0], fr[N + 92 >> 2] = Us[1], 0;
      }, doMsync: function(T, y, N, b, X) {
        if (!vt.isFile(y.node.mode))
          throw new vt.ErrnoError(43);
        if (2 & b)
          return 0;
        T = Ir.slice(T, T + N), vt.msync(y, T, X, N, b);
      }, varargs: void 0, get: function() {
        var T = fr[+Jr.varargs >> 2];
        return Jr.varargs += 4, T;
      }, getp: function() {
        return Jr.get();
      }, getStr: function(T) {
        return Lo(T);
      }, getStreamFromFD: function(T) {
        return vt.getStreamChecked(T);
      } };
      function Qs(T, y) {
        return y + 2097152 >>> 0 < 4194305 - !!T ? (T >>> 0) + 4294967296 * y : NaN;
      }
      function Ds(T) {
        fr[pn() >> 2] = T;
      }
      var Hs = function(T, y, N) {
        return $r(T, Ir, y, N);
      }, Xr = { BUCKET_BUFFER_SIZE: 8192, mount: function(T) {
        return vt.createNode(null, "/", 16895, 0);
      }, createPipe: function() {
        var b = { buckets: [], refcnt: 2 }, X = (b.buckets.push({ buffer: new Uint8Array(Xr.BUCKET_BUFFER_SIZE), offset: 0, roffset: 0 }), Xr.nextname()), T = Xr.nextname(), y = vt.createNode(Xr.root, X, 4096, 0), N = vt.createNode(Xr.root, T, 4096, 0), b = (y.pipe = b, N.pipe = b, vt.createStream({ path: X, node: y, flags: 0, seekable: !1, stream_ops: Xr.stream_ops })), X = (y.stream = b, vt.createStream({ path: T, node: N, flags: 1, seekable: !1, stream_ops: Xr.stream_ops }));
        return N.stream = X, { readable_fd: b.fd, writable_fd: X.fd };
      }, stream_ops: { poll: function(T) {
        var y = T.node.pipe;
        if ((2097155 & T.flags) == 1)
          return 260;
        if (0 < y.buckets.length)
          for (var N = 0; N < y.buckets.length; N++) {
            var b = y.buckets[N];
            if (0 < b.offset - b.roffset)
              return 65;
          }
        return 0;
      }, ioctl: function(T, y, N) {
        return 28;
      }, fsync: function(T) {
        return 28;
      }, read: function(T, y, N, b, X) {
        for (var J = T.node.pipe, Ie = 0, Pe = 0; Pe < J.buckets.length; Pe++) {
          var We = J.buckets[Pe];
          Ie += We.offset - We.roffset;
        }
        var it = y.subarray(N, N + b);
        if (b <= 0)
          return 0;
        if (Ie == 0)
          throw new vt.ErrnoError(6);
        for (var Rt = Math.min(Ie, b), T = Rt, Dt = 0, Pe = 0; Pe < J.buckets.length; Pe++) {
          var Kt = J.buckets[Pe], _n = Kt.offset - Kt.roffset;
          if (Rt <= _n) {
            var gn = Kt.buffer.subarray(Kt.roffset, Kt.offset);
            Rt < _n ? (gn = gn.subarray(0, Rt), Kt.roffset += Rt) : Dt++, it.set(gn);
            break;
          }
          gn = Kt.buffer.subarray(Kt.roffset, Kt.offset), it.set(gn), it = it.subarray(gn.byteLength), Rt -= gn.byteLength, Dt++;
        }
        return Dt && Dt == J.buckets.length && (J.buckets[--Dt].offset = 0, J.buckets[Dt].roffset = 0), J.buckets.splice(0, Dt), T;
      }, write: function(Pe, y, N, b, X) {
        var J = Pe.node.pipe, Ie = y.subarray(N, N + b), Pe = Ie.byteLength;
        if (Pe <= 0)
          return 0;
        if (y = null, J.buckets.length == 0 ? (y = { buffer: new Uint8Array(Xr.BUCKET_BUFFER_SIZE), offset: 0, roffset: 0 }, J.buckets.push(y)) : y = J.buckets[J.buckets.length - 1], Uo(y.offset <= Xr.BUCKET_BUFFER_SIZE), N = Xr.BUCKET_BUFFER_SIZE - y.offset, Pe <= N)
          y.buffer.set(Ie, y.offset), y.offset += Pe;
        else {
          0 < N && (y.buffer.set(Ie.subarray(0, N), y.offset), y.offset += N, Ie = Ie.subarray(N, Ie.byteLength));
          for (var We = Ie.byteLength / Xr.BUCKET_BUFFER_SIZE | 0, b = Ie.byteLength % Xr.BUCKET_BUFFER_SIZE, it = 0; it < We; it++) {
            var Rt = { buffer: new Uint8Array(Xr.BUCKET_BUFFER_SIZE), offset: Xr.BUCKET_BUFFER_SIZE, roffset: 0 };
            J.buckets.push(Rt), Rt.buffer.set(Ie.subarray(0, Xr.BUCKET_BUFFER_SIZE)), Ie = Ie.subarray(Xr.BUCKET_BUFFER_SIZE, Ie.byteLength);
          }
          0 < b && (Rt = { buffer: new Uint8Array(Xr.BUCKET_BUFFER_SIZE), offset: Ie.byteLength, roffset: 0 }, J.buckets.push(Rt), Rt.buffer.set(Ie));
        }
        return Pe;
      }, close: function(T) {
        T = T.node.pipe, T.refcnt--, T.refcnt === 0 && (T.buckets = null);
      } }, nextname: function() {
        return Xr.nextname.current || (Xr.nextname.current = 0), "pipe[" + Xr.nextname.current++ + "]";
      } };
      function bi(T) {
        return Mr[T >> 2] + 4294967296 * fr[T + 4 >> 2];
      }
      function rn(T) {
        return (mo(T.getFullYear()) ? Gi : yo)[T.getMonth()] + T.getDate() - 1;
      }
      var mo = function(T) {
        return T % 4 == 0 && (T % 100 != 0 || T % 400 == 0);
      }, Gi = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], yo = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
      function ci(T) {
        var y = yi(T) + 1, N = Mt(y);
        return N && Hs(T, N, y), N;
      }
      function Ri() {
        return 2147483648;
      }
      function ms() {
        if (!ms.strings) {
          var T = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: ((typeof navigator > "u" ? "undefined" : a(navigator)) == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: Xs() };
          for (y in ss)
            ss[y] === void 0 ? delete T[y] : T[y] = ss[y];
          var y, N = [];
          for (y in T)
            N.push("".concat(y, "=").concat(T[y]));
          ms.strings = N;
        }
        return ms.strings;
      }
      function zt(T) {
        var y;
        ji() || ((y = Lt.onExit) != null && y.call(Lt, T), Rs = !0), po(T, new bo(T));
      }
      function fn(T, y) {
        zt(T);
      }
      var Bn = Ri, or = function() {
        return performance.now();
      }, ss = {}, Xs = function() {
        return jo || "./this.program";
      }, Fo = 0, ji = function() {
        return Di || 0 < Fo;
      };
      function zo(T, y, N, b) {
        for (var X = 0, J = 0; J < N; J++) {
          var Pe = Mr[y >> 2], Ie = Mr[y + 4 >> 2], Pe = (y += 8, vt.read(T, xs, Pe, Ie, b));
          if (Pe < 0)
            return -1;
          if (X += Pe, Pe < Ie)
            break;
          b !== void 0 && (b += Pe);
        }
        return X;
      }
      function Yi(T, y) {
        xs.set(T, y);
      }
      function Li(T, y, N, b) {
        var X = Mr[b + 40 >> 2], J = { tm_sec: fr[b >> 2], tm_min: fr[b + 4 >> 2], tm_hour: fr[b + 8 >> 2], tm_mday: fr[b + 12 >> 2], tm_mon: fr[b + 16 >> 2], tm_year: fr[b + 20 >> 2], tm_wday: fr[b + 24 >> 2], tm_yday: fr[b + 28 >> 2], tm_isdst: fr[b + 32 >> 2], tm_gmtoff: fr[b + 36 >> 2], tm_zone: X ? Lo(X) : "" }, Vn = Lo(N), Ie = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
        for (gn in Ie)
          Vn = Vn.replace(new RegExp(gn, "g"), Ie[gn]);
        var Pe = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], We = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        function it(vn, Zn, cr) {
          for (var Cs = typeof vn == "number" ? vn.toString() : vn || ""; Cs.length < Zn; )
            Cs = cr[0] + Cs;
          return Cs;
        }
        function Rt(vn, Zn) {
          return it(vn, Zn, "0");
        }
        function Dt(vn, Zn) {
          function cr(Br) {
            return Br < 0 ? -1 : 0 < Br ? 1 : 0;
          }
          var Cs;
          return Cs = (Cs = cr(vn.getFullYear() - Zn.getFullYear())) === 0 && (Cs = cr(vn.getMonth() - Zn.getMonth())) === 0 ? cr(vn.getDate() - Zn.getDate()) : Cs;
        }
        function Kt(vn) {
          switch (vn.getDay()) {
            case 0:
              return new Date(vn.getFullYear() - 1, 11, 29);
            case 1:
              return vn;
            case 2:
              return new Date(vn.getFullYear(), 0, 3);
            case 3:
              return new Date(vn.getFullYear(), 0, 2);
            case 4:
              return new Date(vn.getFullYear(), 0, 1);
            case 5:
              return new Date(vn.getFullYear() - 1, 11, 31);
            case 6:
              return new Date(vn.getFullYear() - 1, 11, 30);
          }
        }
        function _n(Zn) {
          var Zn = function(Br, Do) {
            for (var _o = new Date(Br.getTime()); 0 < Do; ) {
              var ma = mo(_o.getFullYear()), Ca = _o.getMonth(), ma = (ma ? pi : Ns)[Ca];
              if (!(Do > ma - _o.getDate()))
                return _o.setDate(_o.getDate() + Do), _o;
              Do -= ma - _o.getDate() + 1, _o.setDate(1), Ca < 11 ? _o.setMonth(Ca + 1) : (_o.setMonth(0), _o.setFullYear(_o.getFullYear() + 1));
            }
            return _o;
          }(new Date(Zn.tm_year + 1900, 0, 1), Zn.tm_yday), cr = new Date(Zn.getFullYear(), 0, 4), Cs = new Date(Zn.getFullYear() + 1, 0, 4), cr = Kt(cr), Cs = Kt(Cs);
          return Dt(cr, Zn) <= 0 ? Dt(Cs, Zn) <= 0 ? Zn.getFullYear() + 1 : Zn.getFullYear() : Zn.getFullYear() - 1;
        }
        var gn, Pn = { "%a": function(vn) {
          return Pe[vn.tm_wday].substring(0, 3);
        }, "%A": function(vn) {
          return Pe[vn.tm_wday];
        }, "%b": function(vn) {
          return We[vn.tm_mon].substring(0, 3);
        }, "%B": function(vn) {
          return We[vn.tm_mon];
        }, "%C": function(vn) {
          return Rt((vn.tm_year + 1900) / 100 | 0, 2);
        }, "%d": function(vn) {
          return Rt(vn.tm_mday, 2);
        }, "%e": function(vn) {
          return it(vn.tm_mday, 2, " ");
        }, "%g": function(vn) {
          return _n(vn).toString().substring(2);
        }, "%G": _n, "%H": function(vn) {
          return Rt(vn.tm_hour, 2);
        }, "%I": function(vn) {
          return vn = vn.tm_hour, vn == 0 ? vn = 12 : 12 < vn && (vn -= 12), Rt(vn, 2);
        }, "%j": function(vn) {
          return Rt(vn.tm_mday + function(Zn, cr) {
            for (var Cs = 0, Br = 0; Br <= cr; Cs += Zn[Br++])
              ;
            return Cs;
          }(mo(vn.tm_year + 1900) ? pi : Ns, vn.tm_mon - 1), 3);
        }, "%m": function(vn) {
          return Rt(vn.tm_mon + 1, 2);
        }, "%M": function(vn) {
          return Rt(vn.tm_min, 2);
        }, "%n": function() {
          return `
`;
        }, "%p": function(vn) {
          return 0 <= vn.tm_hour && vn.tm_hour < 12 ? "AM" : "PM";
        }, "%S": function(vn) {
          return Rt(vn.tm_sec, 2);
        }, "%t": function() {
          return "	";
        }, "%u": function(vn) {
          return vn.tm_wday || 7;
        }, "%U": function(vn) {
          return vn = vn.tm_yday + 7 - vn.tm_wday, Rt(Math.floor(vn / 7), 2);
        }, "%V": function(vn) {
          var Zn, cr = Math.floor((vn.tm_yday + 7 - (vn.tm_wday + 6) % 7) / 7);
          return (vn.tm_wday + 371 - vn.tm_yday - 2) % 7 <= 2 && cr++, cr ? cr != 53 || (Zn = (vn.tm_wday + 371 - vn.tm_yday) % 7) == 4 || Zn == 3 && mo(vn.tm_year) || (cr = 1) : (cr = 52, ((Zn = (vn.tm_wday + 7 - vn.tm_yday - 1) % 7) == 4 || Zn == 5 && mo(vn.tm_year % 400 - 1)) && cr++), Rt(cr, 2);
        }, "%w": function(vn) {
          return vn.tm_wday;
        }, "%W": function(vn) {
          return vn = vn.tm_yday + 7 - (vn.tm_wday + 6) % 7, Rt(Math.floor(vn / 7), 2);
        }, "%y": function(vn) {
          return (vn.tm_year + 1900).toString().substring(2);
        }, "%Y": function(vn) {
          return vn.tm_year + 1900;
        }, "%z": function(cr) {
          var Zn = 0 <= (cr = cr.tm_gmtoff), cr = Math.abs(cr) / 60;
          return (Zn ? "+" : "-") + ("0000" + (cr / 60 * 100 + cr % 60)).slice(-4);
        }, "%Z": function(vn) {
          return vn.tm_zone;
        }, "%%": function() {
          return "%";
        } }, Vn = Vn.replace(/%%/g, "\0\0");
        for (gn in Pn)
          Vn.includes(gn) && (Vn = Vn.replace(new RegExp(gn, "g"), Pn[gn](J)));
        return (b = ki(Vn = Vn.replace(/\0\0/g, "%"), !1)).length > y ? 0 : (Yi(b, T), b.length - 1);
      }
      function _i(T) {
        return Lt["_" + T];
      }
      function pa(Ie, y, N, b, X) {
        var J = { string: function(Dt) {
          var Kt, _n, gn = 0;
          return Dt != null && Dt !== 0 && (Kt = yi(Dt = Dt) + 1, _n = Ar(Kt), Hs(Dt, _n, Kt), gn = _n), gn;
        }, array: function(Dt) {
          var Kt = Ar(Dt.length);
          return Yi(Dt, Kt), Kt;
        } }, Ie = _i(Ie), Pe = [], We = 0;
        if (b)
          for (var it = 0; it < b.length; it++) {
            var Rt = J[N[it]];
            Rt ? (We === 0 && (We = sn()), Pe[it] = Rt(b[it])) : Pe[it] = b[it];
          }
        return Ie = Ie = Ie.apply(null, Pe), We !== 0 && dn(We), Ie = Ie, y === "string" ? Lo(Ie) : y === "boolean" ? !!Ie : Ie;
      }
      function $o(T, y) {
        so.set(T, y), hi[T] = so.get(T);
      }
      function wo(T, y, N, b) {
        this.parent = T = T || this, this.mount = T.mount, this.mounted = null, this.id = vt.nextInode++, this.name = y, this.mode = N, this.node_ops = {}, this.stream_ops = {}, this.rdev = b;
      }
      var Ks, Qo, pi = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ns = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Fi = function(T, y) {
        T < 128 ? y.push(T) : y.push(T % 128 | 128, T >> 7);
      }, la = function(T) {
        for (var y = { i: "i32", j: "i64", f: "f32", d: "f64", e: "externref", p: "i32" }, N = { parameters: [], results: T[0] == "v" ? [] : [y[T[0]]] }, b = 1; b < T.length; ++b)
          N.parameters.push(y[T[b]]);
        return N;
      }, Ho = function(T, y) {
        var N = T.slice(0, 1), b = T.slice(1), X = { i: 127, p: 127, j: 126, f: 125, d: 124, e: 111 };
        y.push(96), Fi(b.length, y);
        for (var J = 0; J < b.length; ++J)
          y.push(X[b[J]]);
        N == "v" ? y.push(0) : y.push(1, X[N]);
      }, Ye = function(T, y) {
        if (Ks)
          for (var N = T; N < T + y; N++) {
            var b = Un(N);
            b && Ks.set(b, N);
          }
      }, qe = [], Nt = (Object.defineProperties(wo.prototype, { read: { get: function() {
        return (365 & this.mode) == 365;
      }, set: function(T) {
        T ? this.mode |= 365 : this.mode &= -366;
      } }, write: { get: function() {
        return (146 & this.mode) == 146;
      }, set: function(T) {
        T ? this.mode |= 146 : this.mode &= -147;
      } }, isFolder: { get: function() {
        return vt.isDir(this.mode);
      } }, isDevice: { get: function() {
        return vt.isChrdev(this.mode);
      } } }), vt.FSNode = wo, vt.createPreloadedFile = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt, Dt, Kt, _n, gn = y ? oo.resolve(_s.join2(T, y)) : T;
        function Pn(Vn) {
          function vn(_o) {
            it != null && it(), Pe || vt.createDataFile(T, y, _o, b, X, We), J != null && J(), Mo();
          }
          var Zn, cr, Cs, Br, Do;
          Zn = Vn, cr = gn, Cs = vn, Br = function() {
            Ie != null && Ie(), Mo();
          }, typeof Browser < "u" && Browser.init(), Do = !1, Tr.forEach(function(_o) {
            Do || _o.canHandle(cr) && (_o.handle(Zn, cr, Cs, Br), Do = !0);
          }), Do || vn(Vn);
        }
        ro(), typeof N == "string" ? (Rt = N, Dt = function(Vn) {
          Pn(Vn);
        }, Kt = Ie, _n = "al ".concat(Rt), hs(Rt, function(Vn) {
          Uo(Vn, 'Loading data file "'.concat(Rt, '" failed (no arrayBuffer).')), Dt(new Uint8Array(Vn)), _n && Mo();
        }, function(Vn) {
          if (!Kt)
            throw 'Loading data file "'.concat(Rt, '" failed.');
          Kt();
        }), _n && ro()) : Pn(N);
      }, vt.staticInit(), Lt.FS_createPath = vt.createPath, Lt.FS_createDataFile = vt.createDataFile, Lt.FS_createPreloadedFile = vt.createPreloadedFile, Lt.FS_unlink = vt.unlink, Lt.FS_createLazyFile = vt.createLazyFile, Lt.FS_createDevice = vt.createDevice, Ps && Gt.staticInit(), { y: function(T, y, N, b) {
        vr("Assertion failed: ".concat(Lo(T), ", at: ") + [y ? Lo(y) : "unknown filename", N, b ? Lo(b) : "unknown function"]);
      }, Ke: function(T, y) {
        return Un(T)(y);
      }, p: function(T) {
        return T = new Or(T), T.get_caught() || (T.set_caught(!0), li--), T.set_rethrown(!1), Zo.push(T), yr(T.excPtr), T.get_exception_ptr();
      }, v: function() {
        ot(0, 0);
        var T = Zo.pop();
        Pr(T.excPtr), ei = 0;
      }, a: function() {
        return ui([]);
      }, i: function(T) {
        return ui([T]);
      }, x: function(T, y) {
        return ui([T, y]);
      }, Ab: function() {
        var T = Zo.pop(), y = (T || vr("no exception to throw"), T.excPtr);
        throw T.get_rethrown() || (Zo.push(T), T.set_rethrown(!0), T.set_caught(!1), li++), ei = y;
      }, B: function(T, y, N) {
        throw new Or(T).init(y, N), li++, ei = T;
      }, xc: function() {
        return li;
      }, e: function(T) {
        throw ei = ei || T;
      }, ic: function(T, y) {
        try {
          return T = Jr.getStr(T), vt.chmod(T, y), 0;
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, af: function(T, y, N) {
        try {
          var b, X = Jr.getStreamFromFD(T);
          return X.fd === y ? -28 : ((b = vt.getStream(y)) && vt.close(b), vt.createStream(X, y).fd);
        } catch (J) {
          if (vt === void 0 || J.name !== "ErrnoError")
            throw J;
          return -J.errno;
        }
      }, qc: function(T, y, N, b) {
        try {
          var X, J;
          return y = Jr.getStr(y), y = Jr.calculateAt(T, y), -8 & N ? -28 : (X = vt.lookupPath(y, { follow: !0 }).node) ? (J = "", 4 & N && (J += "r"), 2 & N && (J += "w"), 1 & N && (J += "x"), J && vt.nodePermissions(X, J) ? -2 : 0) : -44;
        } catch (Ie) {
          if (vt === void 0 || Ie.name !== "ErrnoError")
            throw Ie;
          return -Ie.errno;
        }
      }, Rd: function(T, y, Pe, We, X, J) {
        var Ie, Pe = Qs(Pe, We), We = Qs(X, J);
        try {
          return isNaN(Pe) ? 61 : (Ie = Jr.getStreamFromFD(T), vt.allocate(Ie, Pe, We), 0);
        } catch (it) {
          if (vt === void 0 || it.name !== "ErrnoError")
            throw it;
          return -it.errno;
        }
      }, jc: function(T, y) {
        try {
          return vt.fchmod(T, y), 0;
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, hc: function(T, y, N) {
        try {
          return vt.fchown(T, y, N), 0;
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, ua: function(T, y, N) {
        Jr.varargs = N;
        try {
          var b = Jr.getStreamFromFD(T);
          switch (y) {
            case 0:
              if ((X = Jr.get()) < 0)
                return -28;
              for (; vt.streams[X]; )
                X++;
              return vt.createStream(b, X).fd;
            case 1:
            case 2:
              return 0;
            case 3:
              return b.flags;
            case 4:
              var X = Jr.get();
              return b.flags |= X, 0;
            case 5:
              return X = Jr.getp(), ws[X + 0 >> 1] = 2, 0;
            case 6:
            case 7:
              return 0;
            case 16:
            case 8:
              return -28;
            case 9:
              return Ds(28), -1;
            default:
              return -28;
          }
        } catch (J) {
          if (vt === void 0 || J.name !== "ErrnoError")
            throw J;
          return -J.errno;
        }
      }, lc: function(T) {
        try {
          return Jr.getStreamFromFD(T), 0;
        } catch (y) {
          if (vt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, je: function(T, y) {
        try {
          var N = Jr.getStreamFromFD(T);
          return Jr.doStat(vt.stat, N.path, y);
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, be: function(T, y, N) {
        y = Qs(y, N);
        try {
          return isNaN(y) ? 61 : (vt.ftruncate(T, y), 0);
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, yc: function(T, y) {
        try {
          var N, b;
          return y === 0 ? -28 : (N = vt.cwd(), y < (b = yi(N) + 1) ? -68 : (Hs(N, T, y), b));
        } catch (X) {
          if (vt === void 0 || X.name !== "ErrnoError")
            throw X;
          return -X.errno;
        }
      }, sc: function(T, y, N) {
        try {
          for (var b = Jr.getStreamFromFD(T), X = (b.getdents || (b.getdents = vt.readdir(b.path)), 0), J = vt.llseek(b, 0, 1), Ie = Math.floor(J / 280); Ie < b.getdents.length && X + 280 <= N; ) {
            var Pe, We, it, Rt = b.getdents[Ie];
            We = Rt === "." ? (Pe = b.node.id, 4) : Rt === ".." ? (Pe = vt.lookupPath(b.path, { parent: !0 }).node.id, 4) : (Pe = (it = vt.lookupNode(b.node, Rt)).id, vt.isChrdev(it.mode) ? 2 : vt.isDir(it.mode) ? 4 : vt.isLink(it.mode) ? 10 : 8), Us = [Pe >>> 0, (kr = Pe, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[y + X >> 2] = Us[0], fr[y + X + 4 >> 2] = Us[1], Us = [280 * (Ie + 1) >>> 0, (kr = 280 * (Ie + 1), 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[y + X + 8 >> 2] = Us[0], fr[y + X + 12 >> 2] = Us[1], ws[y + X + 16 >> 1] = 280, xs[y + X + 18 >> 0] = We, Hs(Rt, y + X + 19, 256), X += 280, Ie += 1;
          }
          return vt.llseek(b, 280 * Ie, 0), X;
        } catch (Dt) {
          if (vt === void 0 || Dt.name !== "ErrnoError")
            throw Dt;
          return -Dt.errno;
        }
      }, ue: function(T, y, N) {
        Jr.varargs = N;
        try {
          var b, X = Jr.getStreamFromFD(T);
          switch (y) {
            case 21509:
              return X.tty ? 0 : -59;
            case 21505:
              if (!X.tty)
                return -59;
              if (X.tty.ops.ioctl_tcgets) {
                var J = X.tty.ops.ioctl_tcgets(X), Ie = Jr.getp();
                fr[Ie >> 2] = J.c_iflag || 0, fr[Ie + 4 >> 2] = J.c_oflag || 0, fr[Ie + 8 >> 2] = J.c_cflag || 0, fr[Ie + 12 >> 2] = J.c_lflag || 0;
                for (var Pe = 0; Pe < 32; Pe++)
                  xs[Ie + Pe + 17 >> 0] = J.c_cc[Pe] || 0;
              }
              return 0;
            case 21510:
            case 21511:
            case 21512:
              return X.tty ? 0 : -59;
            case 21506:
            case 21507:
            case 21508:
              if (!X.tty)
                return -59;
              if (X.tty.ops.ioctl_tcsets) {
                for (var Ie = Jr.getp(), We = fr[Ie >> 2], it = fr[Ie + 4 >> 2], Rt = fr[Ie + 8 >> 2], Dt = fr[Ie + 12 >> 2], Kt = [], Pe = 0; Pe < 32; Pe++)
                  Kt.push(xs[Ie + Pe + 17 >> 0]);
                return X.tty.ops.ioctl_tcsets(X.tty, y, { c_iflag: We, c_oflag: it, c_cflag: Rt, c_lflag: Dt, c_cc: Kt });
              }
              return 0;
            case 21519:
              return X.tty ? (Ie = Jr.getp(), fr[Ie >> 2] = 0) : -59;
            case 21520:
              return X.tty ? -28 : -59;
            case 21531:
              return Ie = Jr.getp(), vt.ioctl(X, y, Ie);
            case 21523:
              return X.tty ? (X.tty.ops.ioctl_tiocgwinsz && (b = X.tty.ops.ioctl_tiocgwinsz(X.tty), Ie = Jr.getp(), ws[Ie >> 1] = b[0], ws[Ie + 2 >> 1] = b[1]), 0) : -59;
            case 21524:
            case 21515:
              return X.tty ? 0 : -59;
            default:
              return -28;
          }
        } catch (_n) {
          if (vt === void 0 || _n.name !== "ErrnoError")
            throw _n;
          return -_n.errno;
        }
      }, Fd: function(T, y) {
        try {
          return T = Jr.getStr(T), Jr.doStat(vt.lstat, T, y);
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, uc: function(T, y, N) {
        try {
          return y = Jr.getStr(y), y = Jr.calculateAt(T, y), (y = _s.normalize(y))[y.length - 1] === "/" && (y = y.substr(0, y.length - 1)), vt.mkdir(y, N, 0), 0;
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, Qd: function(T, y, N, b) {
        try {
          y = Jr.getStr(y);
          var X = 256 & b, J = 4096 & b;
          return b &= -6401, y = Jr.calculateAt(T, y, J), Jr.doStat(X ? vt.lstat : vt.stat, y, N);
        } catch (Ie) {
          if (vt === void 0 || Ie.name !== "ErrnoError")
            throw Ie;
          return -Ie.errno;
        }
      }, Sb: function(T, y, N, b) {
        Jr.varargs = b;
        try {
          y = Jr.getStr(y), y = Jr.calculateAt(T, y);
          var X = b ? Jr.get() : 0;
          return vt.open(y, N, X).fd;
        } catch (J) {
          if (vt === void 0 || J.name !== "ErrnoError")
            throw J;
          return -J.errno;
        }
      }, bf: function(T) {
        try {
          if (T == 0)
            throw new vt.ErrnoError(21);
          var y = Xr.createPipe();
          return fr[T >> 2] = y.readable_fd, fr[T + 4 >> 2] = y.writable_fd, 0;
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, gc: function(T, y, N, b) {
        try {
          var X, J, Ie;
          return y = Jr.getStr(y), y = Jr.calculateAt(T, y), b <= 0 ? -28 : (X = vt.readlink(y), J = Math.min(b, yi(X)), Ie = xs[N + J], Hs(X, N, b + 1), xs[N + J] = Ie, J);
        } catch (Pe) {
          if (vt === void 0 || Pe.name !== "ErrnoError")
            throw Pe;
          return -Pe.errno;
        }
      }, vc: function(T, y, N, b) {
        try {
          return y = Jr.getStr(y), b = Jr.getStr(b), y = Jr.calculateAt(T, y), b = Jr.calculateAt(N, b), vt.rename(y, b), 0;
        } catch (X) {
          if (vt === void 0 || X.name !== "ErrnoError")
            throw X;
          return -X.errno;
        }
      }, tc: function(T) {
        try {
          return T = Jr.getStr(T), vt.rmdir(T), 0;
        } catch (y) {
          if (vt === void 0 || y.name !== "ErrnoError")
            throw y;
          return -y.errno;
        }
      }, $d: function(T, y) {
        try {
          return T = Jr.getStr(T), Jr.doStat(vt.stat, T, y);
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return -N.errno;
        }
      }, rc: function(T, y, N) {
        try {
          return T = Jr.getStr(T), fr[N + 4 >> 2] = 4096, fr[N + 40 >> 2] = 4096, fr[N + 8 >> 2] = 1e6, fr[N + 12 >> 2] = 5e5, fr[N + 16 >> 2] = 5e5, fr[N + 20 >> 2] = vt.nextInode, fr[N + 24 >> 2] = 1e6, fr[N + 28 >> 2] = 42, fr[N + 44 >> 2] = 2, fr[N + 36 >> 2] = 255, 0;
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, wc: function(T, y, N) {
        try {
          return y = Jr.getStr(y), y = Jr.calculateAt(T, y), N === 0 ? vt.unlink(y) : N === 512 ? vt.rmdir(y) : vr("Invalid flags passed to unlinkat"), 0;
        } catch (b) {
          if (vt === void 0 || b.name !== "ErrnoError")
            throw b;
          return -b.errno;
        }
      }, kc: function(T, y, N, b) {
        try {
          var X, J;
          return y = Jr.getStr(y), y = Jr.calculateAt(T, y, !0), J = N ? (X = 1e3 * bi(N) + fr[N + 8 >> 2] / 1e6, 1e3 * bi(N += 16) + fr[N + 8 >> 2] / 1e6) : X = Date.now(), vt.utime(y, X, J), 0;
        } catch (Ie) {
          if (vt === void 0 || Ie.name !== "ErrnoError")
            throw Ie;
          return -Ie.errno;
        }
      }, Ie: function() {
        return 1;
      }, Le: function() {
        Di = !1, Fo = 0;
      }, Ue: function() {
        throw 1 / 0;
      }, ge: function(X, J, N) {
        var X = Qs(X, J), J = new Date(1e3 * X), X = (fr[N >> 2] = J.getSeconds(), fr[N + 4 >> 2] = J.getMinutes(), fr[N + 8 >> 2] = J.getHours(), fr[N + 12 >> 2] = J.getDate(), fr[N + 16 >> 2] = J.getMonth(), fr[N + 20 >> 2] = J.getFullYear() - 1900, fr[N + 24 >> 2] = J.getDay(), 0 | rn(J)), X = (fr[N + 28 >> 2] = X, fr[N + 36 >> 2] = -60 * J.getTimezoneOffset(), new Date(J.getFullYear(), 0, 1)), b = new Date(J.getFullYear(), 6, 1).getTimezoneOffset(), X = X.getTimezoneOffset(), J = 0 | (b != X && J.getTimezoneOffset() == Math.min(X, b));
        fr[N + 32 >> 2] = J;
      }, he: function(T) {
        y = new Date(fr[T + 20 >> 2] + 1900, fr[T + 16 >> 2], fr[T + 12 >> 2], fr[T + 8 >> 2], fr[T + 4 >> 2], fr[T >> 2], 0), N = fr[T + 32 >> 2], b = y.getTimezoneOffset(), Ie = new Date(y.getFullYear(), 0, 1), X = new Date(y.getFullYear(), 6, 1).getTimezoneOffset(), Ie = Ie.getTimezoneOffset(), J = Math.min(Ie, X), N < 0 ? fr[T + 32 >> 2] = +(X != Ie && J == b) : 0 < N != (J == b) && (Ie = Math.max(Ie, X), X = 0 < N ? J : Ie, y.setTime(y.getTime() + 6e4 * (X - b))), fr[T + 24 >> 2] = y.getDay(), N = 0 | rn(y), fr[T + 28 >> 2] = N, fr[T >> 2] = y.getSeconds(), fr[T + 4 >> 2] = y.getMinutes(), fr[T + 8 >> 2] = y.getHours(), fr[T + 12 >> 2] = y.getDate(), fr[T + 16 >> 2] = y.getMonth(), fr[T + 20 >> 2] = y.getYear(), J = y.getTime();
        var y, N, b, X, J, Ie = isNaN(J) ? (Ds(61), -1) : J / 1e3;
        return Xt((kr = Ie, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)), Ie >>> 0;
      }, Od: function(T, y, N, b, Dt, J, Ie, Pe) {
        var We, it, Rt, Dt = Qs(Dt, J);
        try {
          return isNaN(Dt) ? 61 : (We = Jr.getStreamFromFD(b), Rt = (it = vt.mmap(We, T, Dt, y, N)).ptr, fr[Ie >> 2] = it.allocated, Mr[Pe >> 2] = Rt, 0);
        } catch (Kt) {
          if (vt === void 0 || Kt.name !== "ErrnoError")
            throw Kt;
          return -Kt.errno;
        }
      }, Pd: function(T, y, N, b, X, J, Ie) {
        J = Qs(J, Ie);
        try {
          if (isNaN(J))
            return 61;
          var Pe = Jr.getStreamFromFD(X);
          2 & N && Jr.doMsync(T, Pe, y, b, J), vt.munmap(Pe);
        } catch (We) {
          if (vt === void 0 || We.name !== "ErrnoError")
            throw We;
          return -We.errno;
        }
      }, ud: function(T, y, N) {
        var X = (/* @__PURE__ */ new Date()).getFullYear(), b = new Date(X, 0, 1), X = new Date(X, 6, 1), J = b.getTimezoneOffset(), Ie = X.getTimezoneOffset(), Pe = Math.max(J, Ie);
        function We(it) {
          return it = it.toTimeString().match(/\(([A-Za-z ]+)\)$/), it ? it[1] : "GMT";
        }
        Mr[T >> 2] = 60 * Pe, fr[y >> 2] = +(J != Ie), T = We(b), Pe = We(X), y = ci(T), b = ci(Pe), Ie < J ? (Mr[N >> 2] = y, Mr[N + 4 >> 2] = b) : (Mr[N >> 2] = b, Mr[N + 4 >> 2] = y);
      }, _: function() {
        vr("");
      }, $a: function() {
        return Date.now();
      }, Oe: Bn, ob: or, De: function(T, y, N) {
        return Ir.copyWithin(T, y, y + N);
      }, ff: function(T) {
        var y = Ir.length, N = (T >>>= 0, Ri());
        if (!(N < T))
          for (var b, X = 1; X <= 4; X *= 2) {
            var J = y * (1 + 0.2 / X), J = Math.min(J, T + 100663296);
            if (function(Ie) {
              Ie = (Ie - fo.buffer.byteLength + 65535) / 65536;
              try {
                return fo.grow(Ie), xi(), 1;
              } catch {
              }
            }(Math.min(N, (J = Math.max(T, J)) + ((b = 65536) - J % b) % b)))
              return !0;
          }
        return !1;
      }, nc: function(T, y) {
        var N = 0;
        return ms().forEach(function(b, X) {
          for (var J = y + N, Ie = (Mr[T + 4 * X >> 2] = J, b), Pe = J, We = 0; We < Ie.length; ++We)
            xs[Pe++ >> 0] = Ie.charCodeAt(We);
          xs[Pe >> 0] = 0, N += b.length + 1;
        }), 0;
      }, oc: function(T, y) {
        var N = ms(), b = (Mr[T >> 2] = N.length, 0);
        return N.forEach(function(X) {
          return b += X.length + 1;
        }), Mr[y >> 2] = b, 0;
      }, wa: fn, Sa: function(T) {
        try {
          var y = Jr.getStreamFromFD(T);
          return vt.close(y), 0;
        } catch (N) {
          if (vt === void 0 || N.name !== "ErrnoError")
            throw N;
          return N.errno;
        }
      }, Yb: function(T, y) {
        try {
          var N = Jr.getStreamFromFD(T), b = N.tty ? 2 : vt.isDir(N.mode) ? 3 : vt.isLink(N.mode) ? 7 : 4;
          return xs[y >> 0] = b, ws[y + 2 >> 1] = 0, Us = [0, (kr = 0, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[y + 8 >> 2] = Us[0], fr[y + 12 >> 2] = Us[1], Us = [0, (kr = 0, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[y + 16 >> 2] = Us[0], fr[y + 20 >> 2] = Us[1], 0;
        } catch (X) {
          if (vt === void 0 || X.name !== "ErrnoError")
            throw X;
          return X.errno;
        }
      }, ae: function(T, y, N, We, X, J) {
        var Ie, Pe, We = Qs(We, X);
        try {
          return isNaN(We) ? 61 : (Ie = Jr.getStreamFromFD(T), Pe = zo(Ie, y, N, We), Mr[J >> 2] = Pe, 0);
        } catch (it) {
          if (vt === void 0 || it.name !== "ErrnoError")
            throw it;
          return it.errno;
        }
      }, Gb: function(T, y, N, b) {
        try {
          var X = Jr.getStreamFromFD(T), J = zo(X, y, N);
          return Mr[b >> 2] = J, 0;
        } catch (Ie) {
          if (vt === void 0 || Ie.name !== "ErrnoError")
            throw Ie;
          return Ie.errno;
        }
      }, ie: function(T, Ie, N, b, X) {
        var J, Ie = Qs(Ie, N);
        try {
          return isNaN(Ie) ? 61 : (J = Jr.getStreamFromFD(T), vt.llseek(J, Ie, b), Us = [J.position >>> 0, (kr = J.position, 1 <= +Math.abs(kr) ? 0 < kr ? +Math.floor(kr / 4294967296) >>> 0 : ~~+Math.ceil((kr - (~~kr >>> 0)) / 4294967296) >>> 0 : 0)], fr[X >> 2] = Us[0], fr[X + 4 >> 2] = Us[1], J.getdents && Ie === 0 && b === 0 && (J.getdents = null), 0);
        } catch (Pe) {
          if (vt === void 0 || Pe.name !== "ErrnoError")
            throw Pe;
          return Pe.errno;
        }
      }, sb: function(T, y, N, b) {
        try {
          var X = function(J, Ie, Pe, We) {
            for (var it = 0, Rt = 0; Rt < Pe; Rt++) {
              var Kt = Mr[Ie >> 2], Dt = Mr[Ie + 4 >> 2], Kt = (Ie += 8, vt.write(J, xs, Kt, Dt, We));
              if (Kt < 0)
                return -1;
              it += Kt, We !== void 0 && (We += Kt);
            }
            return it;
          }(Jr.getStreamFromFD(T), y, N);
          return Mr[b >> 2] = X, 0;
        } catch (J) {
          if (vt === void 0 || J.name !== "ErrnoError")
            throw J;
          return J.errno;
        }
      }, df: function(T, y) {
        return aa(Ir.subarray(T, T + y)), 0;
      }, ac: function(T, y) {
        var N = sn();
        try {
          return Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, cb: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, rb: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, We: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, m: function(T, y) {
        var N = sn();
        try {
          return Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, X: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, u: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Aa: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, A: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, D: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Ja: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, qa: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Zb: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Hb: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Ua: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, ma: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, t: function(T) {
        var y = sn();
        try {
          return Un(T)();
        } catch (N) {
          if (dn(y), N !== N + 0)
            throw N;
          ot(1, 0);
        }
      }, ia: function(T, y) {
        var N = sn();
        try {
          return Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, xe: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Ha: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Ma: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Ve: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca) {
        var ma = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca);
        } catch (s0) {
          if (dn(ma), s0 !== s0 + 0)
            throw s0;
          ot(1, 0);
        }
      }, ha: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, L: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, T: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, b: function(T, y) {
        var N = sn();
        try {
          return Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, z: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Q: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, S: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, O: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Z: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, ca: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, ra: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Ya: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Ge: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, tb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Te: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Me: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs) {
        var Br = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs);
        } catch (Do) {
          if (dn(Br), Do !== Do + 0)
            throw Do;
          ot(1, 0);
        }
      }, $b: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, _a: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Da: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, ya: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Wb: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, w: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Ee: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, c: function(T, y, N) {
        var b = sn();
        try {
          return Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, E: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Vb: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, fa: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Ea: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, La: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, jb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, Ze: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Xb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, hb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (dn(Zn), cr !== cr + 0)
            throw cr;
          ot(1, 0);
        }
      }, Ob: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Rb: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, ub: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, md: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Qi(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Xe: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Tb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Ce: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, pa: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Qa: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, V: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, ab: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Pb: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, _b: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, d: function(T, y, N, b) {
        var X = sn();
        try {
          return Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Y: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, re: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, mb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Za: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (dn(Vn), vn !== vn + 0)
            throw vn;
          ot(1, 0);
        }
      }, Ia: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, Mb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Nb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Ne: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Fa: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, pb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, k: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Ba: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Se: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Ib: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, pe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Lb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, aa: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, ef: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Ub: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, n: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Wa: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Fb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Ae: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (dn(Zn), cr !== cr + 0)
            throw cr;
          ot(1, 0);
        }
      }, Be: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (dn(Vn), vn !== vn + 0)
            throw vn;
          ot(1, 0);
        }
      }, _e: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, se: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Ka: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Pa: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, s: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Fe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, ze: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, le: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, Re: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        var vn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
        } catch (Zn) {
          if (dn(vn), Zn !== Zn + 0)
            throw Zn;
          ot(1, 0);
        }
      }, te: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, ve: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, F: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, oe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Va: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, Cb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        var vn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
        } catch (Zn) {
          if (dn(vn), Zn !== Zn + 0)
            throw Zn;
          ot(1, 0);
        }
      }, we: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, H: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Pe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Je: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Kb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, M: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, ba: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, za: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, ea: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, va: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, la: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, ke: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, Ca: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, gb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Oa: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (dn(Vn), vn !== vn + 0)
            throw vn;
          ot(1, 0);
        }
      }, pc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn) {
        var cr = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn);
        } catch (Cs) {
          if (dn(cr), Cs !== Cs + 0)
            throw Cs;
          ot(1, 0);
        }
      }, qe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr) {
        var Cs = sn();
        try {
          return Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr);
        } catch (Br) {
          if (dn(Cs), Br !== Br + 0)
            throw Br;
          ot(1, 0);
        }
      }, zc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = sn();
        try {
          return k(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (dn(Zn), cr !== cr + 0)
            throw cr;
          ot(1, 0);
        }
      }, hd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn) {
        var cr = sn();
        try {
          return Je(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn);
        } catch (Cs) {
          if (dn(cr), Cs !== Cs + 0)
            throw Cs;
          ot(1, 0);
        }
      }, yd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr) {
        var Cs = sn();
        try {
          return Aa(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr);
        } catch (Br) {
          if (dn(Cs), Br !== Br + 0)
            throw Br;
          ot(1, 0);
        }
      }, zd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = sn();
        try {
          return La(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (dn(Vn), vn !== vn + 0)
            throw vn;
          ot(1, 0);
        }
      }, Fc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        var vn = sn();
        try {
          return $a(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
        } catch (Zn) {
          if (dn(vn), Zn !== Zn + 0)
            throw Zn;
          ot(1, 0);
        }
      }, Oc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Ji(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Xc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          return fs(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, Yc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          return Is(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Qc: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Hi(T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, wd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return ca(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Uc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Qn(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, sd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return ni(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, vd: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return fi(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Gc: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return Mi(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Cd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Ba(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Sd: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return qo(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Kd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return Ga(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Nc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return ja(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Bd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return za(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Rc: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return es(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Vc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Yo(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, qd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Vs(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, ld: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return vi(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, gd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return At(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, td: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Xi(T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Xd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return eo(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Yd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return zi(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Wd: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Ko(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, rd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return Gs(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Dc: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return Oa(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, pd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return oi(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, ad: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return Er(T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Hd: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          return zr(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Jd: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return $i(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Ad: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          return Ta(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, _c: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Cr(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, cd: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          return wn(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Wc: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          return co(T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, id: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return je(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Zd: function(T, y, N, b) {
        var X = sn();
        try {
          return lo(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Pc: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return zs(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, _d: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Sr(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, nd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return ko(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Vd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return di(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Bb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return qt(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Ac: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return uo(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Jc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          return Sa(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Dd: function(T, y, N) {
        var b = sn();
        try {
          return fa(T, y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Ud: function(T, y, N, b) {
        var X = sn();
        try {
          return Ni(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Td: function(T) {
        var y = sn();
        try {
          return ua(T);
        } catch (N) {
          if (dn(y), N !== N + 0)
            throw N;
          ot(1, 0);
        }
      }, de: function(T, y) {
        var N = sn();
        try {
          return Wr(T, y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, ce: function(T, y, N) {
        var b = sn();
        try {
          return Bs(T, y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, Md: function(T, y, N, b) {
        var X = sn();
        try {
          return Ao(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Kc: function(T, y, N, b, X) {
        var J = sn();
        try {
          return mi(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, fe: function(T, y, N, b, X) {
        var J = sn();
        try {
          return Ws(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, od: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca, ma) {
        var s0 = sn();
        try {
          return Na(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca, ma);
        } catch (Ra) {
          if (dn(s0), Ra !== Ra + 0)
            throw Ra;
          ot(1, 0);
        }
      }, bd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return hr(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, $c: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          return xr(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Ic: function(T, y, N, b) {
        var X = sn();
        try {
          return Ya(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Mc: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          return sa(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Cc: function(T, y, N, b) {
        var X = sn();
        try {
          return Ha(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, l: function(T) {
        var y = sn();
        try {
          Un(T)();
        } catch (N) {
          if (dn(y), N !== N + 0)
            throw N;
          ot(1, 0);
        }
      }, ja: function(T, y) {
        var N = sn();
        try {
          Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, ne: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Db: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, g: function(T, y) {
        var N = sn();
        try {
          Un(T)(y);
        } catch (b) {
          if (dn(N), b !== b + 0)
            throw b;
          ot(1, 0);
        }
      }, R: function(T, y, N) {
        var b = sn();
        try {
          Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, I: function(T, y, N, b) {
        var X = sn();
        try {
          Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, W: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, da: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, vb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, ye: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, fb: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, kb: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, sa: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, N: function(T, y, N, b) {
        var X = sn();
        try {
          Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, lb: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, $: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Eb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, h: function(T, y, N) {
        var b = sn();
        try {
          Un(T)(y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, C: function(T, y, N, b) {
        var X = sn();
        try {
          Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, J: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, ga: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Ta: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Xa: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Ye: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, nb: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, bc: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, K: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, eb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, f: function(T, y, N, b) {
        var X = sn();
        try {
          Un(T)(y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, ka: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, bb: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, cf: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, j: function(T, y, N, b, X) {
        var J = sn();
        try {
          Un(T)(y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Ra: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, xa: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, db: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, ec: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, ib: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, wb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, ta: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, Na: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Qb: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, o: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Un(T)(y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, fc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br) {
        var Do = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br);
        } catch (_o) {
          if (dn(Do), _o !== _o + 0)
            throw _o;
          ot(1, 0);
        }
      }, zb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n) {
        var gn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n);
        } catch (Pn) {
          if (dn(gn), Pn !== Pn + 0)
            throw Pn;
          ot(1, 0);
        }
      }, yb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, Jb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, q: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Un(T)(y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, G: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, me: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, U: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, He: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Qe: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, P: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, na: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        var Dt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt);
        } catch (Kt) {
          if (dn(Dt), Kt !== Kt + 0)
            throw Kt;
          ot(1, 0);
        }
      }, qb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        var Kt = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
        } catch (_n) {
          if (dn(Kt), _n !== _n + 0)
            throw _n;
          ot(1, 0);
        }
      }, dc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        var _n = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
        } catch (gn) {
          if (dn(_n), gn !== gn + 0)
            throw gn;
          ot(1, 0);
        }
      }, xb: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        var Pn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
        } catch (Vn) {
          if (dn(Pn), Vn !== Vn + 0)
            throw Vn;
          ot(1, 0);
        }
      }, Ga: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        var Vn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
        } catch (vn) {
          if (dn(Vn), vn !== vn + 0)
            throw vn;
          ot(1, 0);
        }
      }, cc: function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        var Zn = sn();
        try {
          Un(T)(y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
        } catch (cr) {
          if (dn(Zn), cr !== cr + 0)
            throw cr;
          ot(1, 0);
        }
      }, xd: function(T, y, N, b, X, J, Ie, Pe, We) {
        var it = sn();
        try {
          ha(T, y, N, b, X, J, Ie, Pe, We);
        } catch (Rt) {
          if (dn(it), Rt !== Rt + 0)
            throw Rt;
          ot(1, 0);
        }
      }, Ld: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Bi(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, Bc: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          p0(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Id: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Go(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, dd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          Hn(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Gd: function(T, y, N, b, X) {
        var J = sn();
        try {
          gi(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Ec: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          vo(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, ee: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          un(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, jd: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          ga(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Zc: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Fn(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Nd: function(T, y, N, b) {
        var X = sn();
        try {
          da(T, y, N, b);
        } catch (J) {
          if (dn(X), J !== J + 0)
            throw J;
          ot(1, 0);
        }
      }, Hc: function(T, y, N, b, X) {
        var J = sn();
        try {
          Ea(T, y, N, b, X);
        } catch (Ie) {
          if (dn(J), Ie !== Ie + 0)
            throw Ie;
          ot(1, 0);
        }
      }, Sc: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          js(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, fd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          si(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, Lc: function(T, y, N, b, X, J, Ie, Pe, We, it) {
        var Rt = sn();
        try {
          Ua(T, y, N, b, X, J, Ie, Pe, We, it);
        } catch (Dt) {
          if (dn(Rt), Dt !== Dt + 0)
            throw Dt;
          ot(1, 0);
        }
      }, Tc: function(T, y, N, b, X, J, Ie) {
        var Pe = sn();
        try {
          Jo(T, y, N, b, X, J, Ie);
        } catch (We) {
          if (dn(Pe), We !== We + 0)
            throw We;
          ot(1, 0);
        }
      }, kd: function(T, y, N, b, X, J) {
        var Ie = sn();
        try {
          Ki(T, y, N, b, X, J);
        } catch (Pe) {
          if (dn(Ie), Pe !== Pe + 0)
            throw Pe;
          ot(1, 0);
        }
      }, ed: function(T, y, N, b, X, J, Ie, Pe) {
        var We = sn();
        try {
          An(T, y, N, b, X, J, Ie, Pe);
        } catch (it) {
          if (dn(We), it !== it + 0)
            throw it;
          ot(1, 0);
        }
      }, Ed: function(T, y, N) {
        var b = sn();
        try {
          Ui(T, y, N);
        } catch (X) {
          if (dn(b), X !== X + 0)
            throw X;
          ot(1, 0);
        }
      }, r: function(T) {
        return T;
      }, $e: zt, oa: Li, mc: function(T, y, N, b, X) {
        return Li(T, y, N, b);
      } }), mt = function() {
        var T, y, N, b = { a: Nt };
        function X(J, Ie) {
          return mt = J.exports, fo = mt.gf, xi(), so = mt.hh, J = mt.hf, oa.unshift(J), Mo(), mt;
        }
        if (ro(), Lt.instantiateWasm)
          try {
            return Lt.instantiateWasm(b, X);
          } catch (J) {
            Bo("Module.instantiateWasm callback failed with error: ".concat(J)), Ze(J);
          }
        return T = ts, y = b, N = function(J) {
          X(J.instance);
        }, (gs || typeof WebAssembly.instantiateStreaming != "function" || ri(T) || Wi(T) || Ps || typeof fetch != "function" ? ia(T, y, N) : fetch(T, { credentials: "same-origin" }).then(function(J) {
          return WebAssembly.instantiateStreaming(J, y).then(N, function(Ie) {
            return Bo("wasm streaming compile failed: ".concat(Ie)), Bo("falling back to ArrayBuffer instantiation"), ia(T, y, N);
          });
        })).catch(Ze), {};
      }(), pn = (Lt._CPLSetConfigOption = function(T, y) {
        return (Lt._CPLSetConfigOption = mt.jf)(T, y);
      }, Lt._CPLSetThreadLocalConfigOption = function(T, y) {
        return (Lt._CPLSetThreadLocalConfigOption = mt.kf)(T, y);
      }, Lt._CPLError = function(T, y, N, b) {
        return (Lt._CPLError = mt.lf)(T, y, N, b);
      }, Lt._CPLErrorReset = function() {
        return (Lt._CPLErrorReset = mt.mf)();
      }, Lt._CPLGetLastErrorNo = function() {
        return (Lt._CPLGetLastErrorNo = mt.nf)();
      }, Lt._CPLGetLastErrorType = function() {
        return (Lt._CPLGetLastErrorType = mt.of)();
      }, Lt._CPLGetLastErrorMsg = function() {
        return (Lt._CPLGetLastErrorMsg = mt.pf)();
      }, Lt._CPLQuietErrorHandler = function(T, y, N) {
        return (Lt._CPLQuietErrorHandler = mt.qf)(T, y, N);
      }, Lt._CPLSetErrorHandler = function(T) {
        return (Lt._CPLSetErrorHandler = mt.rf)(T);
      }, Lt._CSLCount = function(T) {
        return (Lt._CSLCount = mt.sf)(T);
      }, Lt._CPLAtof = function(T) {
        return (Lt._CPLAtof = mt.tf)(T);
      }, Lt._GDALSuggestedWarpOutput = function(T, y, N, b, X, J) {
        return (Lt._GDALSuggestedWarpOutput = mt.uf)(T, y, N, b, X, J);
      }, Lt._GDALGenImgProjTransform = function(T, y, N, b, X, J, Ie) {
        return (Lt._GDALGenImgProjTransform = mt.vf)(T, y, N, b, X, J, Ie);
      }, Lt._GDALCreateGenImgProjTransformer = function(T, y, N, b, X, J, Ie) {
        return (Lt._GDALCreateGenImgProjTransformer = mt.wf)(T, y, N, b, X, J, Ie);
      }, Lt._GDALCreateGenImgProjTransformer2 = function(T, y, N) {
        return (Lt._GDALCreateGenImgProjTransformer2 = mt.xf)(T, y, N);
      }, Lt._GDALDestroyGenImgProjTransformer = function(T) {
        return (Lt._GDALDestroyGenImgProjTransformer = mt.yf)(T);
      }, Lt._GDALInvGeoTransform = function(T, y) {
        return (Lt._GDALInvGeoTransform = mt.zf)(T, y);
      }, Lt._GDALReprojectImage = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Lt._GDALReprojectImage = mt.Af)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, Lt._OSRNewSpatialReference = function(T) {
        return (Lt._OSRNewSpatialReference = mt.Bf)(T);
      }, Lt._OSRDestroySpatialReference = function(T) {
        return (Lt._OSRDestroySpatialReference = mt.Cf)(T);
      }, Lt._OSRExportToWkt = function(T, y) {
        return (Lt._OSRExportToWkt = mt.Df)(T, y);
      }, Lt._OSRSetFromUserInput = function(T, y) {
        return (Lt._OSRSetFromUserInput = mt.Ef)(T, y);
      }, Lt._OSRImportFromEPSG = function(T, y) {
        return (Lt._OSRImportFromEPSG = mt.Ff)(T, y);
      }, Lt._OSRSetAxisMappingStrategy = function(T, y) {
        return (Lt._OSRSetAxisMappingStrategy = mt.Gf)(T, y);
      }, Lt._OCTDestroyCoordinateTransformation = function(T) {
        return (Lt._OCTDestroyCoordinateTransformation = mt.Hf)(T);
      }, Lt._OCTNewCoordinateTransformation = function(T, y) {
        return (Lt._OCTNewCoordinateTransformation = mt.If)(T, y);
      }, Lt._OCTTransform = function(T, y, N, b, X) {
        return (Lt._OCTTransform = mt.Jf)(T, y, N, b, X);
      }, Lt._GDALAllRegister = function() {
        return (Lt._GDALAllRegister = mt.Kf)();
      }, Lt._OGRGetDriverCount = function() {
        return (Lt._OGRGetDriverCount = mt.Lf)();
      }, Lt._OGRGetDriver = function(T) {
        return (Lt._OGRGetDriver = mt.Mf)(T);
      }, Lt._OGR_L_GetFeatureCount = function(T, y) {
        return (Lt._OGR_L_GetFeatureCount = mt.Nf)(T, y);
      }, Lt._OGR_L_GetName = function(T) {
        return (Lt._OGR_L_GetName = mt.Of)(T);
      }, Lt._OGR_DS_GetLayerCount = function(T) {
        return (Lt._OGR_DS_GetLayerCount = mt.Pf)(T);
      }, Lt._OGR_DS_GetLayer = function(T, y) {
        return (Lt._OGR_DS_GetLayer = mt.Qf)(T, y);
      }, Lt._OGR_DS_GetName = function(T) {
        return (Lt._OGR_DS_GetName = mt.Rf)(T);
      }, Lt._OGR_DS_GetDriver = function(T) {
        return (Lt._OGR_DS_GetDriver = mt.Sf)(T);
      }, Lt._OGR_Dr_GetName = function(T) {
        return (Lt._OGR_Dr_GetName = mt.Tf)(T);
      }, Lt._GDALCreate = function(T, y, N, b, X, J, Ie) {
        return (Lt._GDALCreate = mt.Uf)(T, y, N, b, X, J, Ie);
      }, Lt._GDALCreateCopy = function(T, y, N, b, X, J, Ie) {
        return (Lt._GDALCreateCopy = mt.Vf)(T, y, N, b, X, J, Ie);
      }, Lt._GDALGetDriverShortName = function(T) {
        return (Lt._GDALGetDriverShortName = mt.Wf)(T);
      }, Lt._GDALGetDriverLongName = function(T) {
        return (Lt._GDALGetDriverLongName = mt.Xf)(T);
      }, Lt._GDALGetDriverCount = function() {
        return (Lt._GDALGetDriverCount = mt.Yf)();
      }, Lt._GDALGetDriver = function(T) {
        return (Lt._GDALGetDriver = mt.Zf)(T);
      }, Lt._GDALGetDriverByName = function(T) {
        return (Lt._GDALGetDriverByName = mt._f)(T);
      }, Lt._GDALGetRasterXSize = function(T) {
        return (Lt._GDALGetRasterXSize = mt.$f)(T);
      }, Lt._GDALGetRasterYSize = function(T) {
        return (Lt._GDALGetRasterYSize = mt.ag)(T);
      }, Lt._GDALGetRasterBand = function(T, y) {
        return (Lt._GDALGetRasterBand = mt.bg)(T, y);
      }, Lt._GDALGetRasterCount = function(T) {
        return (Lt._GDALGetRasterCount = mt.cg)(T);
      }, Lt._GDALGetSpatialRef = function(T) {
        return (Lt._GDALGetSpatialRef = mt.dg)(T);
      }, Lt._GDALGetProjectionRef = function(T) {
        return (Lt._GDALGetProjectionRef = mt.eg)(T);
      }, Lt._GDALSetProjection = function(T, y) {
        return (Lt._GDALSetProjection = mt.fg)(T, y);
      }, Lt._GDALGetGeoTransform = function(T, y) {
        return (Lt._GDALGetGeoTransform = mt.gg)(T, y);
      }, Lt._GDALSetGeoTransform = function(T, y) {
        return (Lt._GDALSetGeoTransform = mt.hg)(T, y);
      }, Lt._GDALGetDatasetDriver = function(T) {
        return (Lt._GDALGetDatasetDriver = mt.ig)(T);
      }, Lt._GDALGetFileList = function(T) {
        return (Lt._GDALGetFileList = mt.jg)(T);
      }, Lt._GDALOpen = function(T, y) {
        return (Lt._GDALOpen = mt.kg)(T, y);
      }, Lt._GDALOpenEx = function(T, y, N, b, X) {
        return (Lt._GDALOpenEx = mt.lg)(T, y, N, b, X);
      }, Lt._GDALClose = function(T) {
        return (Lt._GDALClose = mt.mg)(T);
      }, Lt._GDALDatasetGetLayerCount = function(T) {
        return (Lt._GDALDatasetGetLayerCount = mt.ng)(T);
      }, Lt._GDALDatasetGetLayer = function(T, y) {
        return (Lt._GDALDatasetGetLayer = mt.og)(T, y);
      }, Lt._GDALGetRasterDataType = function(T) {
        return (Lt._GDALGetRasterDataType = mt.pg)(T);
      }, Lt._GDALGetRasterNoDataValue = function(T, y) {
        return (Lt._GDALGetRasterNoDataValue = mt.qg)(T, y);
      }, Lt._GDALGetRasterMaximum = function(T, y) {
        return (Lt._GDALGetRasterMaximum = mt.rg)(T, y);
      }, Lt._GDALGetRasterMinimum = function(T, y) {
        return (Lt._GDALGetRasterMinimum = mt.sg)(T, y);
      }, Lt._GDALGetRasterStatistics = function(T, y, N, b, X, J, Ie) {
        return (Lt._GDALGetRasterStatistics = mt.tg)(T, y, N, b, X, J, Ie);
      }, Lt._GDALSetCacheMax = function(T) {
        return (Lt._GDALSetCacheMax = mt.ug)(T);
      }, Lt._GDALGetDescription = function(T) {
        return (Lt._GDALGetDescription = mt.vg)(T);
      }, Lt._GDALGetMetadataItem = function(T, y, N) {
        return (Lt._GDALGetMetadataItem = mt.wg)(T, y, N);
      }, Lt._GDALInfo = function(T, y) {
        return (Lt._GDALInfo = mt.xg)(T, y);
      }, Lt._GDALInfoOptionsNew = function(T, y) {
        return (Lt._GDALInfoOptionsNew = mt.yg)(T, y);
      }, Lt._GDALInfoOptionsFree = function(T) {
        return (Lt._GDALInfoOptionsFree = mt.zg)(T);
      }, Lt._GDALBuildVRT = function(T, y, N, b, X, J) {
        return (Lt._GDALBuildVRT = mt.Ag)(T, y, N, b, X, J);
      }, Lt._GDALBuildVRTOptionsFree = function(T) {
        return (Lt._GDALBuildVRTOptionsFree = mt.Bg)(T);
      }, Lt._GDALBuildVRTOptionsNew = function(T, y) {
        return (Lt._GDALBuildVRTOptionsNew = mt.Cg)(T, y);
      }, Lt._GDALTranslate = function(T, y, N, b) {
        return (Lt._GDALTranslate = mt.Dg)(T, y, N, b);
      }, Lt._GDALTranslateOptionsNew = function(T, y) {
        return (Lt._GDALTranslateOptionsNew = mt.Eg)(T, y);
      }, Lt._GDALTranslateOptionsFree = function(T) {
        return (Lt._GDALTranslateOptionsFree = mt.Fg)(T);
      }, Lt._GDALRasterize = function(T, y, N, b, X) {
        return (Lt._GDALRasterize = mt.Gg)(T, y, N, b, X);
      }, Lt._GDALRasterizeOptionsNew = function(T, y) {
        return (Lt._GDALRasterizeOptionsNew = mt.Hg)(T, y);
      }, Lt._GDALRasterizeOptionsFree = function(T) {
        return (Lt._GDALRasterizeOptionsFree = mt.Ig)(T);
      }, Lt._GDALWarp = function(T, y, N, b, X, J) {
        return (Lt._GDALWarp = mt.Jg)(T, y, N, b, X, J);
      }, Lt._GDALWarpAppOptionsNew = function(T, y) {
        return (Lt._GDALWarpAppOptionsNew = mt.Kg)(T, y);
      }, Lt._GDALWarpAppOptionsFree = function(T) {
        return (Lt._GDALWarpAppOptionsFree = mt.Lg)(T);
      }, Lt._GDALWarpAppOptionsSetProgress = function(T, y, N) {
        return (Lt._GDALWarpAppOptionsSetProgress = mt.Mg)(T, y, N);
      }, Lt._GDALVectorInfoOptionsFree = function(T) {
        return (Lt._GDALVectorInfoOptionsFree = mt.Ng)(T);
      }, Lt._GDALVectorInfo = function(T, y) {
        return (Lt._GDALVectorInfo = mt.Og)(T, y);
      }, Lt._GDALVectorInfoOptionsNew = function(T, y) {
        return (Lt._GDALVectorInfoOptionsNew = mt.Pg)(T, y);
      }, Lt._GDALVectorTranslate = function(T, y, N, b, X, J) {
        return (Lt._GDALVectorTranslate = mt.Qg)(T, y, N, b, X, J);
      }, Lt._GDALVectorTranslateOptionsNew = function(T, y) {
        return (Lt._GDALVectorTranslateOptionsNew = mt.Rg)(T, y);
      }, Lt._GDALVectorTranslateOptionsFree = function(T) {
        return (Lt._GDALVectorTranslateOptionsFree = mt.Sg)(T);
      }, Lt._GDALDEMProcessing = function(T, y, N, b, X, J) {
        return (Lt._GDALDEMProcessing = mt.Tg)(T, y, N, b, X, J);
      }, Lt._GDALDEMProcessingOptionsNew = function(T, y) {
        return (Lt._GDALDEMProcessingOptionsNew = mt.Ug)(T, y);
      }, Lt._GDALDEMProcessingOptionsFree = function(T) {
        return (Lt._GDALDEMProcessingOptionsFree = mt.Vg)(T);
      }, function() {
        return (pn = mt.Wg)();
      }), Mt = Lt._malloc = function(T) {
        return (Mt = Lt._malloc = mt.Xg)(T);
      }, Ln = (Lt._free = function(T) {
        return (Lt._free = mt.Yg)(T);
      }, function(T, y) {
        return (Ln = mt.Zg)(T, y);
      }), ot = function(T, y) {
        return (ot = mt._g)(T, y);
      }, Xt = function(T) {
        return (Xt = mt.$g)(T);
      }, sn = function() {
        return (sn = mt.ah)();
      }, dn = function(T) {
        return (dn = mt.bh)(T);
      }, Ar = function(T) {
        return (Ar = mt.ch)(T);
      }, yr = function(T) {
        return (yr = mt.dh)(T);
      }, Pr = function(T) {
        return (Pr = mt.eh)(T);
      }, Zr = function(T, y, N) {
        return (Zr = mt.fh)(T, y, N);
      }, qs = function(T) {
        return (qs = mt.gh)(T);
      }, Ws = Lt.dynCall_jiiii = function(T, y, N, b, X) {
        return (Ws = Lt.dynCall_jiiii = mt.ih)(T, y, N, b, X);
      }, Bs = Lt.dynCall_jii = function(T, y, N) {
        return (Bs = Lt.dynCall_jii = mt.jh)(T, y, N);
      }, Sr = Lt.dynCall_iiji = function(T, y, N, b, X) {
        return (Sr = Lt.dynCall_iiji = mt.kh)(T, y, N, b, X);
      }, Wr = Lt.dynCall_ji = function(T, y) {
        return (Wr = Lt.dynCall_ji = mt.lh)(T, y);
      }, lo = Lt.dynCall_iij = function(T, y, N, b) {
        return (lo = Lt.dynCall_iij = mt.mh)(T, y, N, b);
      }, uo = Lt.dynCall_iijj = function(T, y, N, b, X, J) {
        return (uo = Lt.dynCall_iijj = mt.nh)(T, y, N, b, X, J);
      }, Vs = Lt.dynCall_iiiij = function(T, y, N, b, X, J) {
        return (Vs = Lt.dynCall_iiiij = mt.oh)(T, y, N, b, X, J);
      }, Gs = Lt.dynCall_iiiji = function(T, y, N, b, X, J) {
        return (Gs = Lt.dynCall_iiiji = mt.ph)(T, y, N, b, X, J);
      }, Ni = Lt.dynCall_iji = function(T, y, N, b) {
        return (Ni = Lt.dynCall_iji = mt.qh)(T, y, N, b);
      }, zi = Lt.dynCall_iiiijjjii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (zi = Lt.dynCall_iiiijjjii = mt.rh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, Ko = Lt.dynCall_iiij = function(T, y, N, b, X) {
        return (Ko = Lt.dynCall_iiij = mt.sh)(T, y, N, b, X);
      }, di = Lt.dynCall_iijiiii = function(T, y, N, b, X, J, Ie, Pe) {
        return (di = Lt.dynCall_iijiiii = mt.th)(T, y, N, b, X, J, Ie, Pe);
      }, eo = Lt.dynCall_iiiijjji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (eo = Lt.dynCall_iiiijjji = mt.uh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, ua = Lt.dynCall_j = function(T) {
        return (ua = Lt.dynCall_j = mt.vh)(T);
      }, qo = Lt.dynCall_iiiiij = function(T, y, N, b, X, J, Ie) {
        return (qo = Lt.dynCall_iiiiij = mt.wh)(T, y, N, b, X, J, Ie);
      }, Mi = Lt.dynCall_iiiiiijj = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Mi = Lt.dynCall_iiiiiijj = mt.xh)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, si = Lt.dynCall_vijii = function(T, y, N, b, X, J) {
        return (si = Lt.dynCall_vijii = mt.yh)(T, y, N, b, X, J);
      }, ko = Lt.dynCall_iijii = function(T, y, N, b, X, J) {
        return (ko = Lt.dynCall_iijii = mt.zh)(T, y, N, b, X, J);
      }, ni = Lt.dynCall_iiiiiij = function(T, y, N, b, X, J, Ie, Pe) {
        return (ni = Lt.dynCall_iiiiiij = mt.Ah)(T, y, N, b, X, J, Ie, Pe);
      }, da = Lt.dynCall_vij = function(T, y, N, b) {
        return (da = Lt.dynCall_vij = mt.Bh)(T, y, N, b);
      }, vi = Lt.dynCall_iiiiji = function(T, y, N, b, X, J, Ie) {
        return (vi = Lt.dynCall_iiiiji = mt.Ch)(T, y, N, b, X, J, Ie);
      }, fa = Lt.dynCall_ij = function(T, y, N) {
        return (fa = Lt.dynCall_ij = mt.Dh)(T, y, N);
      }, vo = Lt.dynCall_viiji = function(T, y, N, b, X, J) {
        return (vo = Lt.dynCall_viiji = mt.Eh)(T, y, N, b, X, J);
      }, Xi = Lt.dynCall_iiiijji = function(T, y, N, b, X, J, Ie, Pe, We) {
        return (Xi = Lt.dynCall_iiiijji = mt.Fh)(T, y, N, b, X, J, Ie, Pe, We);
      }, gi = Lt.dynCall_viij = function(T, y, N, b, X) {
        return (gi = Lt.dynCall_viij = mt.Gh)(T, y, N, b, X);
      }, Ao = Lt.dynCall_jiii = function(T, y, N, b) {
        return (Ao = Lt.dynCall_jiii = mt.Hh)(T, y, N, b);
      }, Bi = Lt.dynCall_viiiij = function(T, y, N, b, X, J, Ie) {
        return (Bi = Lt.dynCall_viiiij = mt.Ih)(T, y, N, b, X, J, Ie);
      }, Ga = Lt.dynCall_iiiiiji = function(T, y, N, b, X, J, Ie, Pe) {
        return (Ga = Lt.dynCall_iiiiiji = mt.Jh)(T, y, N, b, X, J, Ie, Pe);
      }, Go = Lt.dynCall_viiiji = function(T, y, N, b, X, J, Ie) {
        return (Go = Lt.dynCall_viiiji = mt.Kh)(T, y, N, b, X, J, Ie);
      }, $i = Lt.dynCall_iiijiiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return ($i = Lt.dynCall_iiijiiiiii = mt.Lh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Ya = Lt.dynCall_jij = function(T, y, N, b) {
        return (Ya = Lt.dynCall_jij = mt.Mh)(T, y, N, b);
      }, Ui = Lt.dynCall_vj = function(T, y, N) {
        return (Ui = Lt.dynCall_vj = mt.Nh)(T, y, N);
      }, Aa = Lt.dynCall_iiiiiiiiiiiiijjji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr) {
        return (Aa = Lt.dynCall_iiiiiiiiiiiiijjji = mt.Oh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr);
      }, La = Lt.dynCall_iiiiiiiiiiijji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn) {
        return (La = Lt.dynCall_iiiiiiiiiiijji = mt.Ph)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn);
      }, za = Lt.dynCall_iiiiijiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (za = Lt.dynCall_iiiiijiiiii = mt.Qh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, Ta = Lt.dynCall_iiijiiiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (Ta = Lt.dynCall_iiijiiiiiii = mt.Rh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, oi = Lt.dynCall_iiijiii = function(T, y, N, b, X, J, Ie, Pe) {
        return (oi = Lt.dynCall_iiijiii = mt.Sh)(T, y, N, b, X, J, Ie, Pe);
      }, Na = Lt.dynCall_jiiiiiiiiiiiiiiiiiiiiiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca, ma) {
        return (Na = Lt.dynCall_jiiiiiiiiiiiiiiiiiiiiiiiii = mt.Th)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn, cr, Cs, Br, Do, _o, Ca, ma);
      }, Qi = Lt.dynCall_iiiddddji = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Qi = Lt.dynCall_iiiddddji = mt.Uh)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, fi = Lt.dynCall_iiiiiijii = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (fi = Lt.dynCall_iiiiiijii = mt.Vh)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, ha = Lt.dynCall_viiiiiji = function(T, y, N, b, X, J, Ie, Pe, We) {
        return (ha = Lt.dynCall_viiiiiji = mt.Wh)(T, y, N, b, X, J, Ie, Pe, We);
      }, ca = Lt.dynCall_iiiiiiijiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (ca = Lt.dynCall_iiiiiiijiii = mt.Xh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, Ki = Lt.dynCall_vijj = function(T, y, N, b, X, J) {
        return (Ki = Lt.dynCall_vijj = mt.Yh)(T, y, N, b, X, J);
      }, Ba = Lt.dynCall_iiiiiijjii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (Ba = Lt.dynCall_iiiiiijjii = mt.Zh)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, je = Lt.dynCall_iiijjiji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (je = Lt.dynCall_iiijjiji = mt._h)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Je = Lt.dynCall_iiiiiiiiiiiiijjii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn) {
        return (Je = Lt.dynCall_iiiiiiiiiiiiijjii = mt.$h)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn, Zn);
      }, At = Lt.dynCall_iiiijiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (At = Lt.dynCall_iiiijiiiii = mt.ai)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, qt = Lt.dynCall_iijiiiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (qt = Lt.dynCall_iijiiiiiii = mt.bi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, un = Lt.dynCall_viijj = function(T, y, N, b, X, J, Ie) {
        return (un = Lt.dynCall_viijj = mt.ci)(T, y, N, b, X, J, Ie);
      }, An = Lt.dynCall_vijjj = function(T, y, N, b, X, J, Ie, Pe) {
        return (An = Lt.dynCall_vijjj = mt.di)(T, y, N, b, X, J, Ie, Pe);
      }, Fn = Lt.dynCall_viijjji = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Fn = Lt.dynCall_viijjji = mt.ei)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, wn = Lt.dynCall_iiijj = function(T, y, N, b, X, J, Ie) {
        return (wn = Lt.dynCall_iiijj = mt.fi)(T, y, N, b, X, J, Ie);
      }, Hn = Lt.dynCall_viiijj = function(T, y, N, b, X, J, Ie, Pe) {
        return (Hn = Lt.dynCall_viiijj = mt.gi)(T, y, N, b, X, J, Ie, Pe);
      }, Er = Lt.dynCall_iiijiiii = function(T, y, N, b, X, J, Ie, Pe, We) {
        return (Er = Lt.dynCall_iiijiiii = mt.hi)(T, y, N, b, X, J, Ie, Pe, We);
      }, Cr = Lt.dynCall_iiijiiiji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (Cr = Lt.dynCall_iiijiiiji = mt.ii)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, zr = Lt.dynCall_iiijiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (zr = Lt.dynCall_iiijiiiii = mt.ji)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, hr = Lt.dynCall_jiiji = function(T, y, N, b, X, J) {
        return (hr = Lt.dynCall_jiiji = mt.ki)(T, y, N, b, X, J);
      }, xr = Lt.dynCall_jiijji = function(T, y, N, b, X, J, Ie, Pe) {
        return (xr = Lt.dynCall_jiijji = mt.li)(T, y, N, b, X, J, Ie, Pe);
      }, Is = Lt.dynCall_iiiiiiiijjji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn) {
        return (Is = Lt.dynCall_iiiiiiiijjji = mt.mi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn);
      }, fs = Lt.dynCall_iiiiiiiijiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt) {
        return (fs = Lt.dynCall_iiiiiiiijiii = mt.ni)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt);
      }, co = Lt.dynCall_iiijjii = function(T, y, N, b, X, J, Ie, Pe, We) {
        return (co = Lt.dynCall_iiijjii = mt.oi)(T, y, N, b, X, J, Ie, Pe, We);
      }, Yo = Lt.dynCall_iiiiijjii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (Yo = Lt.dynCall_iiiiijjii = mt.pi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Qn = Lt.dynCall_iiiiiiijji = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (Qn = Lt.dynCall_iiiiiiijji = mt.qi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, es = Lt.dynCall_iiiiijji = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (es = Lt.dynCall_iiiiijji = mt.ri)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, Jo = Lt.dynCall_vijiii = function(T, y, N, b, X, J, Ie) {
        return (Jo = Lt.dynCall_vijiii = mt.si)(T, y, N, b, X, J, Ie);
      }, js = Lt.dynCall_vijid = function(T, y, N, b, X, J) {
        return (js = Lt.dynCall_vijid = mt.ti)(T, y, N, b, X, J);
      }, Hi = Lt.dynCall_iiiiiiij = function(T, y, N, b, X, J, Ie, Pe, We) {
        return (Hi = Lt.dynCall_iiiiiiij = mt.ui)(T, y, N, b, X, J, Ie, Pe, We);
      }, zs = Lt.dynCall_iijdddd = function(T, y, N, b, X, J, Ie, Pe) {
        return (zs = Lt.dynCall_iijdddd = mt.vi)(T, y, N, b, X, J, Ie, Pe);
      }, Ji = Lt.dynCall_iiiiiiiijii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt) {
        return (Ji = Lt.dynCall_iiiiiiiijii = mt.wi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt);
      }, ja = Lt.dynCall_iiiiijiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (ja = Lt.dynCall_iiiiijiiii = mt.xi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Ea = Lt.dynCall_viji = function(T, y, N, b, X) {
        return (Ea = Lt.dynCall_viji = mt.yi)(T, y, N, b, X);
      }, ga = Lt.dynCall_viijji = function(T, y, N, b, X, J, Ie, Pe) {
        return (ga = Lt.dynCall_viijji = mt.zi)(T, y, N, b, X, J, Ie, Pe);
      }, sa = Lt.dynCall_jijj = function(T, y, N, b, X, J) {
        return (sa = Lt.dynCall_jijj = mt.Ai)(T, y, N, b, X, J);
      }, Sa = Lt.dynCall_iijjjddi = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt) {
        return (Sa = Lt.dynCall_iijjjddi = mt.Bi)(T, y, N, b, X, J, Ie, Pe, We, it, Rt);
      }, Ua = Lt.dynCall_vijiidddi = function(T, y, N, b, X, J, Ie, Pe, We, it) {
        return (Ua = Lt.dynCall_vijiidddi = mt.Ci)(T, y, N, b, X, J, Ie, Pe, We, it);
      }, mi = Lt.dynCall_jiiid = function(T, y, N, b, X) {
        return (mi = Lt.dynCall_jiiid = mt.Di)(T, y, N, b, X);
      }, $a = Lt.dynCall_iiiiiiiiiijiiiii = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn) {
        return ($a = Lt.dynCall_iiiiiiiiiijiiiii = mt.Ei)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn);
      }, Oa = Lt.dynCall_iiijii = function(T, y, N, b, X, J, Ie) {
        return (Oa = Lt.dynCall_iiijii = mt.Fi)(T, y, N, b, X, J, Ie);
      }, Ha = Lt.dynCall_jji = function(T, y, N, b) {
        return (Ha = Lt.dynCall_jji = mt.Gi)(T, y, N, b);
      }, p0 = Lt.dynCall_viiij = function(T, y, N, b, X, J) {
        return (p0 = Lt.dynCall_viiij = mt.Hi)(T, y, N, b, X, J);
      }, k = Lt.dynCall_iiiiiiiiiiiiiijj = function(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn) {
        return (k = Lt.dynCall_iiiiiiiiiiiiiijj = mt.Ii)(T, y, N, b, X, J, Ie, Pe, We, it, Rt, Dt, Kt, _n, gn, Pn, Vn, vn);
      };
      function ne() {
        function T() {
          Qo || (Qo = !0, Lt.calledRun = !0, Rs) || (Lt.noFSInit || vt.init.initialized || vt.init(), vt.ignorePermissions = !1, Xr.root = vt.mount(Xr, {}, null), Ys(oa), Ve(Lt), Lt.onRuntimeInitialized && Lt.onRuntimeInitialized(), ai());
        }
        0 < Wo || (Po(), 0 < Wo) || (Lt.setStatus ? (Lt.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            Lt.setStatus("");
          }, 1), T();
        }, 1)) : T());
      }
      if (Lt.addRunDependency = ro, Lt.removeRunDependency = Mo, Lt.FS_createPath = vt.createPath, Lt.FS_createLazyFile = vt.createLazyFile, Lt.FS_createDevice = vt.createDevice, Lt.ENV = ss, Lt.ccall = pa, Lt.cwrap = function(T, y, N, b) {
        var X = !N || N.every(function(J) {
          return J === "number" || J === "boolean";
        });
        return y !== "string" && X && !b ? _i(T) : function() {
          return pa(T, y, N, arguments);
        };
      }, Lt.addFunction = function(T, y) {
        b = T, Ks || (Ks = /* @__PURE__ */ new WeakMap(), Ye(0, so.length));
        var b = Ks.get(b) || 0;
        if (b)
          return b;
        var N, b = function() {
          if (qe.length)
            return qe.pop();
          try {
            so.grow(1);
          } catch (J) {
            throw J instanceof RangeError ? "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH." : J;
          }
          return so.length - 1;
        }();
        try {
          $o(b, T);
        } catch (J) {
          if (!(J instanceof TypeError))
            throw J;
          N = T, y = y;
          var X = typeof WebAssembly.Function == "function" ? new WebAssembly.Function(la(y), N) : (Ho(y, y = [1]), Fi(y.length, X = [0, 97, 115, 109, 1, 0, 0, 0, 1]), X.push.apply(X, y), X.push(2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0), y = new WebAssembly.Module(new Uint8Array(X)), new WebAssembly.Instance(y, { e: { f: N } }).exports.f);
          $o(b, X);
        }
        return Ks.set(T, b), b;
      }, Lt.setValue = function(T, y) {
        var N = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : "i8";
        switch (N = N.endsWith("*") ? "*" : N) {
          case "i1":
          case "i8":
            xs[T >> 0] = y;
            break;
          case "i16":
            ws[T >> 1] = y;
            break;
          case "i32":
            fr[T >> 2] = y;
            break;
          case "i64":
            vr("to do setValue(i64) use WASM_BIGINT");
          case "float":
            Nr[T >> 2] = y;
            break;
          case "double":
            ii[T >> 3] = y;
            break;
          case "*":
            Mr[T >> 2] = y;
            break;
          default:
            vr("invalid type for setValue: ".concat(N));
        }
      }, Lt.getValue = function(T) {
        var y = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "i8";
        switch (y = y.endsWith("*") ? "*" : y) {
          case "i1":
          case "i8":
            return xs[T >> 0];
          case "i16":
            return ws[T >> 1];
          case "i32":
            return fr[T >> 2];
          case "i64":
            vr("to do getValue(i64) use WASM_BIGINT");
          case "float":
            return Nr[T >> 2];
          case "double":
            return ii[T >> 3];
          case "*":
            return Mr[T >> 2];
          default:
            vr("invalid type for getValue: ".concat(y));
        }
      }, Lt.UTF8ToString = Lo, Lt.stringToUTF8 = Hs, Lt.lengthBytesUTF8 = yi, Lt.FS_createPreloadedFile = vt.createPreloadedFile, Lt.FS = vt, Lt.FS_createDataFile = vt.createDataFile, Lt.FS_unlink = vt.unlink, Lt.MEMFS = ps, Lt.WORKERFS = sr, Lt.NODEFS = Gt, As = function T() {
        Qo || ne(), Qo || (As = T);
      }, Lt.preInit)
        for (typeof Lt.preInit == "function" && (Lt.preInit = [Lt.preInit]); 0 < Lt.preInit.length; )
          Lt.preInit.pop()();
      return ne(), tr.ready;
    }
    R = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0, typeof __filename < "u" && (R = R || __filename), Oo.exports = W;
    var G = h(Dn.exports), q = { Module: {} };
    function fe() {
      var Ve = q.CPLGetLastErrorMsg(), Ze = q.CPLGetLastErrorNo();
      return q.CPLErrorReset(), { no: Ze, message: Ve };
    }
    function _e(Ve) {
      for (var Ze = [], bt = {}, Ut = 0; Ut < Ve.length; Ut += 1) {
        var mn = Ve[Ut];
        mn === "--config" ? (bt[Ve[Ut + 1]] = Ve[Ut + 2], Ut += 2) : Ze.push(mn);
      }
      var nn = Ze.map(function(yn) {
        return q.Module._malloc(q.Module.lengthBytesUTF8(yn) + 1);
      }), Sn = (nn.push(0), Uint32Array.from(nn)), Mn = (Ze.forEach(function(yn, Pt) {
        q.Module.stringToUTF8(yn, Sn[Pt], q.Module.lengthBytesUTF8(yn) + 1);
      }), q.Module._malloc(Sn.length * Sn.BYTES_PER_ELEMENT));
      return q.Module.HEAPU32.set(Sn, Mn / Sn.BYTES_PER_ELEMENT), { ptr: Mn, ptrArray: nn, config: bt };
    }
    function Le(Ve) {
      q.Module._free(Ve.ptr), Ve.ptrArray.forEach(function(Ze) {
        q.Module._free(Ze);
      });
    }
    var Fe = "/input", Ee = "/output", Ge = Ee, Oo = {}, Dn = S(Object.freeze({ __proto__: null, default: {} })), ve = S(Object.freeze({ __proto__: null, default: {} })), te = Oo, ae = (te.parser = function(Ve, Ze) {
      return new v(Ve, Ze);
    }, te.SAXParser = v, te.SAXStream = be, te.createStream = function(Ve, Ze) {
      return new be(Ve, Ze);
    }, te.MAX_BUFFER_LENGTH = 65536, ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"]);
    function v(Ve, Ze) {
      if (!(this instanceof v))
        return new v(Ve, Ze);
      for (var bt = this, Ut = bt, mn = 0, nn = ae.length; mn < nn; mn++)
        Ut[ae[mn]] = "";
      bt.q = bt.c = "", bt.bufferCheckPosition = te.MAX_BUFFER_LENGTH, bt.opt = Ze || {}, bt.opt.lowercase = bt.opt.lowercase || bt.opt.lowercasetags, bt.looseCase = bt.opt.lowercase ? "toLowerCase" : "toUpperCase", bt.tags = [], bt.closed = bt.closedRoot = bt.sawRoot = !1, bt.tag = bt.error = null, bt.strict = !!Ve, bt.noscript = !(!Ve && !bt.opt.noscript), bt.state = jt.BEGIN, bt.strictEntities = bt.opt.strictEntities, bt.ENTITIES = bt.strictEntities ? Object.create(te.XML_ENTITIES) : Object.create(te.ENTITIES), bt.attribList = [], bt.opt.xmlns && (bt.ns = Object.create(me)), bt.trackPosition = bt.opt.position !== !1, bt.trackPosition && (bt.position = bt.line = bt.column = 0), lt(bt, "onready");
    }
    te.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function(Ve) {
      function Ze() {
      }
      return Ze.prototype = Ve, new Ze();
    }), Object.keys || (Object.keys = function(Ve) {
      var Ze, bt = [];
      for (Ze in Ve)
        Ve.hasOwnProperty(Ze) && bt.push(Ze);
      return bt;
    }), v.prototype = { end: function() {
      pt(this);
    }, write: function(Ve) {
      var Ze = this;
      if (this.error)
        throw this.error;
      if (Ze.closed)
        return $e(Ze, "Cannot write after close. Assign an onready handler.");
      if (Ve === null)
        return pt(Ze);
      typeof Ve == "object" && (Ve = Ve.toString());
      for (var bt, Ut, mn = 0, nn = ""; nn = Vt(Ve, mn++), !!(Ze.c = nn); )
        switch (Ze.trackPosition && (Ze.position++, nn === `
` ? (Ze.line++, Ze.column = 0) : Ze.column++), Ze.state) {
          case jt.BEGIN:
            if (Ze.state = jt.BEGIN_WHITESPACE, nn === "\uFEFF")
              continue;
            hn(Ze, nn);
            continue;
          case jt.BEGIN_WHITESPACE:
            hn(Ze, nn);
            continue;
          case jt.TEXT:
            if (Ze.sawRoot && !Ze.closedRoot) {
              for (var Sn = mn - 1; nn && nn !== "<" && nn !== "&"; )
                (nn = Vt(Ve, mn++)) && Ze.trackPosition && (Ze.position++, nn === `
` ? (Ze.line++, Ze.column = 0) : Ze.column++);
              Ze.textNode += Ve.substring(Sn, mn - 1);
            }
            nn !== "<" || Ze.sawRoot && Ze.closedRoot && !Ze.strict ? (ut(nn) || Ze.sawRoot && !Ze.closedRoot || Jt(Ze, "Text data outside of root node."), nn === "&" ? Ze.state = jt.TEXT_ENTITY : Ze.textNode += nn) : (Ze.state = jt.OPEN_WAKA, Ze.startTagPosition = Ze.position);
            continue;
          case jt.SCRIPT:
            nn === "<" ? Ze.state = jt.SCRIPT_ENDING : Ze.script += nn;
            continue;
          case jt.SCRIPT_ENDING:
            nn === "/" ? Ze.state = jt.CLOSE_TAG : (Ze.script += "<" + nn, Ze.state = jt.SCRIPT);
            continue;
          case jt.OPEN_WAKA:
            nn === "!" ? (Ze.state = jt.SGML_DECL, Ze.sgmlDecl = "") : ut(nn) || (Yt(Se, nn) ? (Ze.state = jt.OPEN_TAG, Ze.tagName = nn) : nn === "/" ? (Ze.state = jt.CLOSE_TAG, Ze.tagName = "") : nn === "?" ? (Ze.state = jt.PROC_INST, Ze.procInstName = Ze.procInstBody = "") : (Jt(Ze, "Unencoded <"), Ze.startTagPosition + 1 < Ze.position && (Sn = Ze.position - Ze.startTagPosition, nn = new Array(Sn).join(" ") + nn), Ze.textNode += "<" + nn, Ze.state = jt.TEXT));
            continue;
          case jt.SGML_DECL:
            (Ze.sgmlDecl + nn).toUpperCase() === ze ? (Zt(Ze, "onopencdata"), Ze.state = jt.CDATA, Ze.sgmlDecl = "", Ze.cdata = "") : Ze.sgmlDecl + nn === "--" ? (Ze.state = jt.COMMENT, Ze.comment = "", Ze.sgmlDecl = "") : (Ze.sgmlDecl + nn).toUpperCase() === ke ? (Ze.state = jt.DOCTYPE, (Ze.doctype || Ze.sawRoot) && Jt(Ze, "Inappropriately located doctype declaration"), Ze.doctype = "", Ze.sgmlDecl = "") : nn === ">" ? (Zt(Ze, "onsgmldeclaration", Ze.sgmlDecl), Ze.sgmlDecl = "", Ze.state = jt.TEXT) : (Tt(nn) && (Ze.state = jt.SGML_DECL_QUOTED), Ze.sgmlDecl += nn);
            continue;
          case jt.SGML_DECL_QUOTED:
            nn === Ze.q && (Ze.state = jt.SGML_DECL, Ze.q = ""), Ze.sgmlDecl += nn;
            continue;
          case jt.DOCTYPE:
            nn === ">" ? (Ze.state = jt.TEXT, Zt(Ze, "ondoctype", Ze.doctype), Ze.doctype = !0) : (Ze.doctype += nn, nn === "[" ? Ze.state = jt.DOCTYPE_DTD : Tt(nn) && (Ze.state = jt.DOCTYPE_QUOTED, Ze.q = nn));
            continue;
          case jt.DOCTYPE_QUOTED:
            Ze.doctype += nn, nn === Ze.q && (Ze.q = "", Ze.state = jt.DOCTYPE);
            continue;
          case jt.DOCTYPE_DTD:
            Ze.doctype += nn, nn === "]" ? Ze.state = jt.DOCTYPE : Tt(nn) && (Ze.state = jt.DOCTYPE_DTD_QUOTED, Ze.q = nn);
            continue;
          case jt.DOCTYPE_DTD_QUOTED:
            Ze.doctype += nn, nn === Ze.q && (Ze.state = jt.DOCTYPE_DTD, Ze.q = "");
            continue;
          case jt.COMMENT:
            nn === "-" ? Ze.state = jt.COMMENT_ENDING : Ze.comment += nn;
            continue;
          case jt.COMMENT_ENDING:
            nn === "-" ? (Ze.state = jt.COMMENT_ENDED, Ze.comment = Ke(Ze.opt, Ze.comment), Ze.comment && Zt(Ze, "oncomment", Ze.comment), Ze.comment = "") : (Ze.comment += "-" + nn, Ze.state = jt.COMMENT);
            continue;
          case jt.COMMENT_ENDED:
            nn !== ">" ? (Jt(Ze, "Malformed comment"), Ze.comment += "--" + nn, Ze.state = jt.COMMENT) : Ze.state = jt.TEXT;
            continue;
          case jt.CDATA:
            nn === "]" ? Ze.state = jt.CDATA_ENDING : Ze.cdata += nn;
            continue;
          case jt.CDATA_ENDING:
            nn === "]" ? Ze.state = jt.CDATA_ENDING_2 : (Ze.cdata += "]" + nn, Ze.state = jt.CDATA);
            continue;
          case jt.CDATA_ENDING_2:
            nn === ">" ? (Ze.cdata && Zt(Ze, "oncdata", Ze.cdata), Zt(Ze, "onclosecdata"), Ze.cdata = "", Ze.state = jt.TEXT) : nn === "]" ? Ze.cdata += "]" : (Ze.cdata += "]]" + nn, Ze.state = jt.CDATA);
            continue;
          case jt.PROC_INST:
            nn === "?" ? Ze.state = jt.PROC_INST_ENDING : ut(nn) ? Ze.state = jt.PROC_INST_BODY : Ze.procInstName += nn;
            continue;
          case jt.PROC_INST_BODY:
            if (!Ze.procInstBody && ut(nn))
              continue;
            nn === "?" ? Ze.state = jt.PROC_INST_ENDING : Ze.procInstBody += nn;
            continue;
          case jt.PROC_INST_ENDING:
            nn === ">" ? (Zt(Ze, "onprocessinginstruction", { name: Ze.procInstName, body: Ze.procInstBody }), Ze.procInstName = Ze.procInstBody = "", Ze.state = jt.TEXT) : (Ze.procInstBody += "?" + nn, Ze.state = jt.PROC_INST_BODY);
            continue;
          case jt.OPEN_TAG:
            Yt(xt, nn) ? Ze.tagName += nn : (function(yn) {
              yn.strict || (yn.tagName = yn.tagName[yn.looseCase]());
              var Pt = yn.tags[yn.tags.length - 1] || yn, tr = yn.tag = { name: yn.tagName, attributes: {} };
              yn.opt.xmlns && (tr.ns = Pt.ns), yn.attribList.length = 0, Zt(yn, "onopentagstart", tr);
            }(Ze), nn === ">" ? It(Ze) : nn === "/" ? Ze.state = jt.OPEN_TAG_SLASH : (ut(nn) || Jt(Ze, "Invalid character in tag name"), Ze.state = jt.ATTRIB));
            continue;
          case jt.OPEN_TAG_SLASH:
            nn === ">" ? (It(Ze, !0), ht(Ze)) : (Jt(Ze, "Forward-slash in opening tag not followed by >"), Ze.state = jt.ATTRIB);
            continue;
          case jt.ATTRIB:
            if (ut(nn))
              continue;
            nn === ">" ? It(Ze) : nn === "/" ? Ze.state = jt.OPEN_TAG_SLASH : Yt(Se, nn) ? (Ze.attribName = nn, Ze.attribValue = "", Ze.state = jt.ATTRIB_NAME) : Jt(Ze, "Invalid attribute name");
            continue;
          case jt.ATTRIB_NAME:
            nn === "=" ? Ze.state = jt.ATTRIB_VALUE : nn === ">" ? (Jt(Ze, "Attribute without value"), Ze.attribValue = Ze.attribName, Cn(Ze), It(Ze)) : ut(nn) ? Ze.state = jt.ATTRIB_NAME_SAW_WHITE : Yt(xt, nn) ? Ze.attribName += nn : Jt(Ze, "Invalid attribute name");
            continue;
          case jt.ATTRIB_NAME_SAW_WHITE:
            if (nn === "=")
              Ze.state = jt.ATTRIB_VALUE;
            else {
              if (ut(nn))
                continue;
              Jt(Ze, "Attribute without value"), Ze.tag.attributes[Ze.attribName] = "", Ze.attribValue = "", Zt(Ze, "onattribute", { name: Ze.attribName, value: "" }), Ze.attribName = "", nn === ">" ? It(Ze) : Yt(Se, nn) ? (Ze.attribName = nn, Ze.state = jt.ATTRIB_NAME) : (Jt(Ze, "Invalid attribute name"), Ze.state = jt.ATTRIB);
            }
            continue;
          case jt.ATTRIB_VALUE:
            if (ut(nn))
              continue;
            Tt(nn) ? (Ze.q = nn, Ze.state = jt.ATTRIB_VALUE_QUOTED) : (Jt(Ze, "Unquoted attribute value"), Ze.state = jt.ATTRIB_VALUE_UNQUOTED, Ze.attribValue = nn);
            continue;
          case jt.ATTRIB_VALUE_QUOTED:
            if (nn !== Ze.q) {
              nn === "&" ? Ze.state = jt.ATTRIB_VALUE_ENTITY_Q : Ze.attribValue += nn;
              continue;
            }
            Cn(Ze), Ze.q = "", Ze.state = jt.ATTRIB_VALUE_CLOSED;
            continue;
          case jt.ATTRIB_VALUE_CLOSED:
            ut(nn) ? Ze.state = jt.ATTRIB : nn === ">" ? It(Ze) : nn === "/" ? Ze.state = jt.OPEN_TAG_SLASH : Yt(Se, nn) ? (Jt(Ze, "No whitespace between attributes"), Ze.attribName = nn, Ze.attribValue = "", Ze.state = jt.ATTRIB_NAME) : Jt(Ze, "Invalid attribute name");
            continue;
          case jt.ATTRIB_VALUE_UNQUOTED:
            if (!function(yn) {
              return yn === ">" || ut(yn);
            }(nn)) {
              nn === "&" ? Ze.state = jt.ATTRIB_VALUE_ENTITY_U : Ze.attribValue += nn;
              continue;
            }
            Cn(Ze), nn === ">" ? It(Ze) : Ze.state = jt.ATTRIB;
            continue;
          case jt.CLOSE_TAG:
            if (Ze.tagName)
              nn === ">" ? ht(Ze) : Yt(xt, nn) ? Ze.tagName += nn : Ze.script ? (Ze.script += "</" + Ze.tagName, Ze.tagName = "", Ze.state = jt.SCRIPT) : (ut(nn) || Jt(Ze, "Invalid tagname in closing tag"), Ze.state = jt.CLOSE_TAG_SAW_WHITE);
            else {
              if (ut(nn))
                continue;
              (function(yn, Pt) {
                return !Yt(yn, Pt);
              })(Se, nn) ? Ze.script ? (Ze.script += "</" + nn, Ze.state = jt.SCRIPT) : Jt(Ze, "Invalid tagname in closing tag.") : Ze.tagName = nn;
            }
            continue;
          case jt.CLOSE_TAG_SAW_WHITE:
            if (ut(nn))
              continue;
            nn === ">" ? ht(Ze) : Jt(Ze, "Invalid characters in closing tag");
            continue;
          case jt.TEXT_ENTITY:
          case jt.ATTRIB_VALUE_ENTITY_Q:
          case jt.ATTRIB_VALUE_ENTITY_U:
            switch (Ze.state) {
              case jt.TEXT_ENTITY:
                bt = jt.TEXT, Ut = "textNode";
                break;
              case jt.ATTRIB_VALUE_ENTITY_Q:
                bt = jt.ATTRIB_VALUE_QUOTED, Ut = "attribValue";
                break;
              case jt.ATTRIB_VALUE_ENTITY_U:
                bt = jt.ATTRIB_VALUE_UNQUOTED, Ut = "attribValue";
            }
            var Mn;
            nn === ";" ? Ze.opt.unparsedEntities ? (Mn = Wt(Ze), Ze.entity = "", Ze.state = bt, Ze.write(Mn)) : (Ze[Ut] += Wt(Ze), Ze.entity = "", Ze.state = bt) : Yt(Ze.entity.length ? Bt : Ht, nn) ? Ze.entity += nn : (Jt(Ze, "Invalid character in entity name"), Ze[Ut] += "&" + Ze.entity + nn, Ze.entity = "", Ze.state = bt);
            continue;
          default:
            throw new Error(Ze, "Unknown state: " + Ze.state);
        }
      return Ze.position >= Ze.bufferCheckPosition && function(yn) {
        for (var Pt = Math.max(te.MAX_BUFFER_LENGTH, 10), tr = 0, Lt = 0, dr = ae.length; Lt < dr; Lt++) {
          var ur = yn[ae[Lt]].length;
          if (Pt < ur)
            switch (ae[Lt]) {
              case "textNode":
                Et(yn);
                break;
              case "cdata":
                Zt(yn, "oncdata", yn.cdata), yn.cdata = "";
                break;
              case "script":
                Zt(yn, "onscript", yn.script), yn.script = "";
                break;
              default:
                $e(yn, "Max buffer length exceeded: " + ae[Lt]);
            }
          tr = Math.max(tr, ur);
        }
        var gr = te.MAX_BUFFER_LENGTH - tr;
        yn.bufferCheckPosition = gr + yn.position;
      }(Ze), Ze;
    }, resume: function() {
      return this.error = null, this;
    }, close: function() {
      return this.write(null);
    }, flush: function() {
      var Ve;
      Et(Ve = this), Ve.cdata !== "" && (Zt(Ve, "oncdata", Ve.cdata), Ve.cdata = ""), Ve.script !== "" && (Zt(Ve, "onscript", Ve.script), Ve.script = "");
    } };
    try {
      Te = Dn.Stream;
    } catch {
      Te = function() {
      };
    }
    var Te = Te || function() {
    }, De = te.EVENTS.filter(function(Ve) {
      return Ve !== "error" && Ve !== "end";
    });
    function be(Ve, Ze) {
      if (!(this instanceof be))
        return new be(Ve, Ze);
      Te.apply(this), this._parser = new v(Ve, Ze), this.writable = !0, this.readable = !0;
      var bt = this;
      this._parser.onend = function() {
        bt.emit("end");
      }, this._parser.onerror = function(Ut) {
        bt.emit("error", Ut), bt._parser.error = null;
      }, this._decoder = null, De.forEach(function(Ut) {
        Object.defineProperty(bt, "on" + Ut, { get: function() {
          return bt._parser["on" + Ut];
        }, set: function(mn) {
          if (!mn)
            return bt.removeAllListeners(Ut), bt._parser["on" + Ut] = mn;
          bt.on(Ut, mn);
        }, enumerable: !0, configurable: !1 });
      });
    }
    (be.prototype = Object.create(Te.prototype, { constructor: { value: be } })).write = function(Ve) {
      var Ze;
      return typeof buffer$1.Buffer == "function" && typeof buffer$1.Buffer.isBuffer == "function" && buffer$1.Buffer.isBuffer(Ve) && (this._decoder || (Ze = ve.StringDecoder, this._decoder = new Ze("utf8")), Ve = this._decoder.write(Ve)), this._parser.write(Ve.toString()), this.emit("data", Ve), !0;
    }, be.prototype.end = function(Ve) {
      return Ve && Ve.length && this.write(Ve), this._parser.end(), !0;
    }, be.prototype.on = function(Ve, Ze) {
      var bt = this;
      return bt._parser["on" + Ve] || De.indexOf(Ve) === -1 || (bt._parser["on" + Ve] = function() {
        var Ut = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        Ut.splice(0, 0, Ve), bt.emit.apply(bt, Ut);
      }), Te.prototype.on.call(bt, Ve, Ze);
    };
    var ze = "[CDATA[", ke = "DOCTYPE", Be = "http://www.w3.org/XML/1998/namespace", Me = "http://www.w3.org/2000/xmlns/", me = { xml: Be, xmlns: Me }, Se = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, xt = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/, Ht = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, Bt = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;
    function ut(Ve) {
      return Ve === " " || Ve === `
` || Ve === "\r" || Ve === "	";
    }
    function Tt(Ve) {
      return Ve === '"' || Ve === "'";
    }
    function Yt(Ve, Ze) {
      return Ve.test(Ze);
    }
    var an, Ct, st, jt = 0;
    for (an in te.STATE = { BEGIN: jt++, BEGIN_WHITESPACE: jt++, TEXT: jt++, TEXT_ENTITY: jt++, OPEN_WAKA: jt++, SGML_DECL: jt++, SGML_DECL_QUOTED: jt++, DOCTYPE: jt++, DOCTYPE_QUOTED: jt++, DOCTYPE_DTD: jt++, DOCTYPE_DTD_QUOTED: jt++, COMMENT_STARTING: jt++, COMMENT: jt++, COMMENT_ENDING: jt++, COMMENT_ENDED: jt++, CDATA: jt++, CDATA_ENDING: jt++, CDATA_ENDING_2: jt++, PROC_INST: jt++, PROC_INST_BODY: jt++, PROC_INST_ENDING: jt++, OPEN_TAG: jt++, OPEN_TAG_SLASH: jt++, ATTRIB: jt++, ATTRIB_NAME: jt++, ATTRIB_NAME_SAW_WHITE: jt++, ATTRIB_VALUE: jt++, ATTRIB_VALUE_QUOTED: jt++, ATTRIB_VALUE_CLOSED: jt++, ATTRIB_VALUE_UNQUOTED: jt++, ATTRIB_VALUE_ENTITY_Q: jt++, ATTRIB_VALUE_ENTITY_U: jt++, CLOSE_TAG: jt++, CLOSE_TAG_SAW_WHITE: jt++, SCRIPT: jt++, SCRIPT_ENDING: jt++ }, te.XML_ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'" }, te.ENTITIES = { amp: "&", gt: ">", lt: "<", quot: '"', apos: "'", AElig: 198, Aacute: 193, Acirc: 194, Agrave: 192, Aring: 197, Atilde: 195, Auml: 196, Ccedil: 199, ETH: 208, Eacute: 201, Ecirc: 202, Egrave: 200, Euml: 203, Iacute: 205, Icirc: 206, Igrave: 204, Iuml: 207, Ntilde: 209, Oacute: 211, Ocirc: 212, Ograve: 210, Oslash: 216, Otilde: 213, Ouml: 214, THORN: 222, Uacute: 218, Ucirc: 219, Ugrave: 217, Uuml: 220, Yacute: 221, aacute: 225, acirc: 226, aelig: 230, agrave: 224, aring: 229, atilde: 227, auml: 228, ccedil: 231, eacute: 233, ecirc: 234, egrave: 232, eth: 240, euml: 235, iacute: 237, icirc: 238, igrave: 236, iuml: 239, ntilde: 241, oacute: 243, ocirc: 244, ograve: 242, oslash: 248, otilde: 245, ouml: 246, szlig: 223, thorn: 254, uacute: 250, ucirc: 251, ugrave: 249, uuml: 252, yacute: 253, yuml: 255, copy: 169, reg: 174, nbsp: 160, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, sect: 167, uml: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, deg: 176, plusmn: 177, sup1: 185, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, times: 215, divide: 247, OElig: 338, oelig: 339, Scaron: 352, scaron: 353, Yuml: 376, fnof: 402, circ: 710, tilde: 732, Alpha: 913, Beta: 914, Gamma: 915, Delta: 916, Epsilon: 917, Zeta: 918, Eta: 919, Theta: 920, Iota: 921, Kappa: 922, Lambda: 923, Mu: 924, Nu: 925, Xi: 926, Omicron: 927, Pi: 928, Rho: 929, Sigma: 931, Tau: 932, Upsilon: 933, Phi: 934, Chi: 935, Psi: 936, Omega: 937, alpha: 945, beta: 946, gamma: 947, delta: 948, epsilon: 949, zeta: 950, eta: 951, theta: 952, iota: 953, kappa: 954, lambda: 955, mu: 956, nu: 957, xi: 958, omicron: 959, pi: 960, rho: 961, sigmaf: 962, sigma: 963, tau: 964, upsilon: 965, phi: 966, chi: 967, psi: 968, omega: 969, thetasym: 977, upsih: 978, piv: 982, ensp: 8194, emsp: 8195, thinsp: 8201, zwnj: 8204, zwj: 8205, lrm: 8206, rlm: 8207, ndash: 8211, mdash: 8212, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, bull: 8226, hellip: 8230, permil: 8240, prime: 8242, Prime: 8243, lsaquo: 8249, rsaquo: 8250, oline: 8254, frasl: 8260, euro: 8364, image: 8465, weierp: 8472, real: 8476, trade: 8482, alefsym: 8501, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, harr: 8596, crarr: 8629, lArr: 8656, uArr: 8657, rArr: 8658, dArr: 8659, hArr: 8660, forall: 8704, part: 8706, exist: 8707, empty: 8709, nabla: 8711, isin: 8712, notin: 8713, ni: 8715, prod: 8719, sum: 8721, minus: 8722, lowast: 8727, radic: 8730, prop: 8733, infin: 8734, ang: 8736, and: 8743, or: 8744, cap: 8745, cup: 8746, int: 8747, there4: 8756, sim: 8764, cong: 8773, asymp: 8776, ne: 8800, equiv: 8801, le: 8804, ge: 8805, sub: 8834, sup: 8835, nsub: 8836, sube: 8838, supe: 8839, oplus: 8853, otimes: 8855, perp: 8869, sdot: 8901, lceil: 8968, rceil: 8969, lfloor: 8970, rfloor: 8971, lang: 9001, rang: 9002, loz: 9674, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830 }, Object.keys(te.ENTITIES).forEach(function(Ve) {
      var Ze = te.ENTITIES[Ve], Ze = typeof Ze == "number" ? String.fromCharCode(Ze) : Ze;
      te.ENTITIES[Ve] = Ze;
    }), te.STATE)
      te.STATE[te.STATE[an]] = an;
    function lt(Ve, Ze, bt) {
      Ve[Ze] && Ve[Ze](bt);
    }
    function Zt(Ve, Ze, bt) {
      Ve.textNode && Et(Ve), lt(Ve, Ze, bt);
    }
    function Et(Ve) {
      Ve.textNode = Ke(Ve.opt, Ve.textNode), Ve.textNode && lt(Ve, "ontext", Ve.textNode), Ve.textNode = "";
    }
    function Ke(Ve, Ze) {
      return Ve.trim && (Ze = Ze.trim()), Ze = Ve.normalize ? Ze.replace(/\s+/g, " ") : Ze;
    }
    function $e(Ve, Ze) {
      return Et(Ve), Ve.trackPosition && (Ze += `
Line: ` + Ve.line + `
Column: ` + Ve.column + `
Char: ` + Ve.c), Ze = new Error(Ze), Ve.error = Ze, lt(Ve, "onerror", Ze), Ve;
    }
    function pt(Ve) {
      return Ve.sawRoot && !Ve.closedRoot && Jt(Ve, "Unclosed root tag"), Ve.state !== jt.BEGIN && Ve.state !== jt.BEGIN_WHITESPACE && Ve.state !== jt.TEXT && $e(Ve, "Unexpected end"), Et(Ve), Ve.c = "", Ve.closed = !0, lt(Ve, "onend"), v.call(Ve, Ve.strict, Ve.opt), Ve;
    }
    function Jt(Ve, Ze) {
      if (typeof Ve != "object" || !(Ve instanceof v))
        throw new Error("bad call to strictFail");
      Ve.strict && $e(Ve, Ze);
    }
    function In(Ve, Ze) {
      var Ut = Ve.indexOf(":") < 0 ? ["", Ve] : Ve.split(":"), bt = Ut[0], Ut = Ut[1];
      return Ze && Ve === "xmlns" && (bt = "xmlns", Ut = ""), { prefix: bt, local: Ut };
    }
    function Cn(Ve) {
      var Ze, bt, Ut;
      Ve.strict || (Ve.attribName = Ve.attribName[Ve.looseCase]()), Ve.attribList.indexOf(Ve.attribName) !== -1 || Ve.tag.attributes.hasOwnProperty(Ve.attribName) || (Ve.opt.xmlns ? (bt = (Ze = In(Ve.attribName, !0)).prefix, Ze = Ze.local, bt === "xmlns" && (Ze === "xml" && Ve.attribValue !== Be ? Jt(Ve, "xml: prefix must be bound to " + Be + `
Actual: ` + Ve.attribValue) : Ze === "xmlns" && Ve.attribValue !== Me ? Jt(Ve, "xmlns: prefix must be bound to " + Me + `
Actual: ` + Ve.attribValue) : (bt = Ve.tag, Ut = Ve.tags[Ve.tags.length - 1] || Ve, bt.ns === Ut.ns && (bt.ns = Object.create(Ut.ns)), bt.ns[Ze] = Ve.attribValue)), Ve.attribList.push([Ve.attribName, Ve.attribValue])) : (Ve.tag.attributes[Ve.attribName] = Ve.attribValue, Zt(Ve, "onattribute", { name: Ve.attribName, value: Ve.attribValue }))), Ve.attribName = Ve.attribValue = "";
    }
    function It(Ve, Ze) {
      if (Ve.opt.xmlns) {
        var bt = Ve.tag, Ut = In(Ve.tagName), Ut = (bt.prefix = Ut.prefix, bt.local = Ut.local, bt.uri = bt.ns[Ut.prefix] || "", bt.prefix && !bt.uri && (Jt(Ve, "Unbound namespace prefix: " + JSON.stringify(Ve.tagName)), bt.uri = Ut.prefix), Ve.tags[Ve.tags.length - 1] || Ve);
        bt.ns && Ut.ns !== bt.ns && Object.keys(bt.ns).forEach(function(Lt) {
          Zt(Ve, "onopennamespace", { prefix: Lt, uri: bt.ns[Lt] });
        });
        for (var mn = 0, nn = Ve.attribList.length; mn < nn; mn++) {
          var tr = Ve.attribList[mn], Sn = tr[0], tr = tr[1], yn = In(Sn, !0), Mn = yn.prefix, yn = yn.local, Pt = Mn !== "" && bt.ns[Mn] || "", tr = { name: Sn, value: tr, prefix: Mn, local: yn, uri: Pt };
          Mn && Mn !== "xmlns" && !Pt && (Jt(Ve, "Unbound namespace prefix: " + JSON.stringify(Mn)), tr.uri = Mn), Ve.tag.attributes[Sn] = tr, Zt(Ve, "onattribute", tr);
        }
        Ve.attribList.length = 0;
      }
      Ve.tag.isSelfClosing = !!Ze, Ve.sawRoot = !0, Ve.tags.push(Ve.tag), Zt(Ve, "onopentag", Ve.tag), Ze || (Ve.noscript || Ve.tagName.toLowerCase() !== "script" ? Ve.state = jt.TEXT : Ve.state = jt.SCRIPT, Ve.tag = null, Ve.tagName = ""), Ve.attribName = Ve.attribValue = "", Ve.attribList.length = 0;
    }
    function ht(Ve) {
      if (Ve.tagName) {
        if (Ve.script) {
          if (Ve.tagName !== "script")
            return Ve.script += "</" + Ve.tagName + ">", Ve.tagName = "", void (Ve.state = jt.SCRIPT);
          Zt(Ve, "onscript", Ve.script), Ve.script = "";
        }
        for (var Ze = Ve.tags.length, bt = Ve.tagName, Ut = bt = Ve.strict ? bt : bt[Ve.looseCase](); Ze-- && Ve.tags[Ze].name !== Ut; )
          Jt(Ve, "Unexpected close tag");
        if (Ze < 0)
          Jt(Ve, "Unmatched closing tag: " + Ve.tagName), Ve.textNode += "</" + Ve.tagName + ">";
        else {
          Ve.tagName = bt;
          for (var mn = Ve.tags.length; mn-- > Ze; ) {
            var nn, Sn = Ve.tag = Ve.tags.pop();
            Ve.tagName = Ve.tag.name, Zt(Ve, "onclosetag", Ve.tagName);
            for (nn in Sn.ns)
              Sn.ns[nn];
            var Mn = Ve.tags[Ve.tags.length - 1] || Ve;
            Ve.opt.xmlns && Sn.ns !== Mn.ns && Object.keys(Sn.ns).forEach(function(yn) {
              var Pt = Sn.ns[yn];
              Zt(Ve, "onclosenamespace", { prefix: yn, uri: Pt });
            });
          }
          Ze === 0 && (Ve.closedRoot = !0), Ve.tagName = Ve.attribValue = Ve.attribName = "", Ve.attribList.length = 0;
        }
      } else
        Jt(Ve, "Weird empty close tag."), Ve.textNode += "</>";
      Ve.state = jt.TEXT;
    }
    function Wt(Ve) {
      var Ze, bt = Ve.entity, Ut = bt.toLowerCase(), mn = "";
      return Ve.ENTITIES[bt] || Ve.ENTITIES[Ut] || ((bt = Ut).charAt(0) === "#" && (mn = bt.charAt(1) === "x" ? (bt = bt.slice(2), (Ze = parseInt(bt, 16)).toString(16)) : (bt = bt.slice(1), (Ze = parseInt(bt, 10)).toString(10))), bt = bt.replace(/^0+/, ""), isNaN(Ze) || mn.toLowerCase() !== bt ? (Jt(Ve, "Invalid character entity"), "&" + Ve.entity + ";") : String.fromCodePoint(Ze));
    }
    function hn(Ve, Ze) {
      Ze === "<" ? (Ve.state = jt.OPEN_WAKA, Ve.startTagPosition = Ve.position) : ut(Ze) || (Jt(Ve, "Non-whitespace before first tag."), Ve.textNode = Ze, Ve.state = jt.TEXT);
    }
    function Vt(Ve, Ze) {
      var bt = "";
      return bt = Ze < Ve.length ? Ve.charAt(Ze) : bt;
    }
    function Tn() {
      var Ve = [], Ze = -1, bt = arguments.length;
      if (!bt)
        return "";
      for (var Ut = ""; ++Ze < bt; ) {
        var mn = Number(arguments[Ze]);
        if (!isFinite(mn) || mn < 0 || 1114111 < mn || st(mn) !== mn)
          throw RangeError("Invalid code point: " + mn);
        mn <= 65535 ? Ve.push(mn) : Ve.push(55296 + ((mn -= 65536) >> 10), mn % 1024 + 56320), (Ze + 1 === bt || 16384 < Ve.length) && (Ut += Ct.apply(null, Ve), Ve.length = 0);
      }
      return Ut;
    }
    jt = te.STATE, String.fromCodePoint || (Ct = String.fromCharCode, st = Math.floor, Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", { value: Tn, configurable: !0, writable: !0 }) : String.fromCodePoint = Tn);
    var Rn, Nn, Dn = function(Ve) {
      return Array.isArray ? Array.isArray(Ve) : Object.prototype.toString.call(Ve) === "[object Array]";
    }, xn = Dn, Zs = { copyOptions: function(Ve) {
      var Ze, bt = {};
      for (Ze in Ve)
        Ve.hasOwnProperty(Ze) && (bt[Ze] = Ve[Ze]);
      return bt;
    }, ensureFlagExists: function(Ve, Ze) {
      Ve in Ze && typeof Ze[Ve] == "boolean" || (Ze[Ve] = !1);
    }, ensureSpacesExists: function(Ve) {
      "spaces" in Ve && (typeof Ve.spaces == "number" || typeof Ve.spaces == "string") || (Ve.spaces = 0);
    }, ensureAlwaysArrayExists: function(Ve) {
      "alwaysArray" in Ve && (typeof Ve.alwaysArray == "boolean" || xn(Ve.alwaysArray)) || (Ve.alwaysArray = !1);
    }, ensureKeyExists: function(Ve, Ze) {
      Ve + "Key" in Ze && typeof Ze[Ve + "Key"] == "string" || (Ze[Ve + "Key"] = Ze.compact ? "_" + Ve : Ve);
    }, checkFnExists: function(Ve, Ze) {
      return Ve + "Fn" in Ze;
    } }, $n = Oo, Kn = Zs, ir = Dn;
    function er(Ve) {
      var Ze, bt = Number(Ve);
      return isNaN(bt) ? (Ze = Ve.toLowerCase()) === "true" || Ze !== "false" && Ve : bt;
    }
    function br(Ve, Ze) {
      var bt, Ut;
      if (Rn.compact) {
        if (!Nn[Rn[Ve + "Key"]] && (ir(Rn.alwaysArray) ? Rn.alwaysArray.indexOf(Rn[Ve + "Key"]) !== -1 : Rn.alwaysArray) && (Nn[Rn[Ve + "Key"]] = []), Nn[Rn[Ve + "Key"]] && !ir(Nn[Rn[Ve + "Key"]]) && (Nn[Rn[Ve + "Key"]] = [Nn[Rn[Ve + "Key"]]]), Ve + "Fn" in Rn && typeof Ze == "string" && (Ze = Rn[Ve + "Fn"](Ze, Nn)), Ve === "instruction" && ("instructionFn" in Rn || "instructionNameFn" in Rn))
          for (bt in Ze)
            Ze.hasOwnProperty(bt) && ("instructionFn" in Rn ? Ze[bt] = Rn.instructionFn(Ze[bt], bt, Nn) : (Ut = Ze[bt], delete Ze[bt], Ze[Rn.instructionNameFn(bt, Ut, Nn)] = Ut));
        ir(Nn[Rn[Ve + "Key"]]) ? Nn[Rn[Ve + "Key"]].push(Ze) : Nn[Rn[Ve + "Key"]] = Ze;
      } else {
        Nn[Rn.elementsKey] || (Nn[Rn.elementsKey] = []);
        var mn = {};
        if ((mn[Rn.typeKey] = Ve) === "instruction") {
          for (bt in Ze)
            if (Ze.hasOwnProperty(bt))
              break;
          mn[Rn.nameKey] = "instructionNameFn" in Rn ? Rn.instructionNameFn(bt, Ze, Nn) : bt, Rn.instructionHasAttributes ? (mn[Rn.attributesKey] = Ze[bt][Rn.attributesKey], "instructionFn" in Rn && (mn[Rn.attributesKey] = Rn.instructionFn(mn[Rn.attributesKey], bt, Nn))) : ("instructionFn" in Rn && (Ze[bt] = Rn.instructionFn(Ze[bt], bt, Nn)), mn[Rn.instructionKey] = Ze[bt]);
        } else
          Ve + "Fn" in Rn && (Ze = Rn[Ve + "Fn"](Ze, Nn)), mn[Rn[Ve + "Key"]] = Ze;
        Rn.addParent && (mn[Rn.parentKey] = Nn), Nn[Rn.elementsKey].push(mn);
      }
    }
    function cs(Ve) {
      var Ze, bt;
      if ("attributesFn" in Rn && (Ve = Ve && Rn.attributesFn(Ve, Nn)), (Rn.trim || "attributeValueFn" in Rn || "attributeNameFn" in Rn || Rn.nativeTypeAttributes) && Ve)
        for (Ze in Ve)
          Ve.hasOwnProperty(Ze) && (Rn.trim && (Ve[Ze] = Ve[Ze].trim()), Rn.nativeTypeAttributes && (Ve[Ze] = er(Ve[Ze])), "attributeValueFn" in Rn && (Ve[Ze] = Rn.attributeValueFn(Ve[Ze], Ze, Nn)), "attributeNameFn" in Rn) && (bt = Ve[Ze], delete Ve[Ze], Ve[Rn.attributeNameFn(Ze, Ve[Ze], Nn)] = bt);
      return Ve;
    }
    function Gn(Ve) {
      var Ze, bt = {};
      if (Ve.body && (Ve.name.toLowerCase() === "xml" || Rn.instructionHasAttributes)) {
        for (var Ut, mn = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g; (Ut = mn.exec(Ve.body)) !== null; )
          bt[Ut[1]] = Ut[2] || Ut[3] || Ut[4];
        bt = cs(bt);
      }
      Ve.name.toLowerCase() === "xml" ? Rn.ignoreDeclaration || (Nn[Rn.declarationKey] = {}, Object.keys(bt).length && (Nn[Rn.declarationKey][Rn.attributesKey] = bt), Rn.addParent && (Nn[Rn.declarationKey][Rn.parentKey] = Nn)) : Rn.ignoreInstruction || (Rn.trim && (Ve.body = Ve.body.trim()), Ze = {}, Rn.instructionHasAttributes && Object.keys(bt).length ? (Ze[Ve.name] = {}, Ze[Ve.name][Rn.attributesKey] = bt) : Ze[Ve.name] = Ve.body, br("instruction", Ze));
    }
    function Jn(Ve, Ze) {
      if (typeof Ve == "object" && (Ze = Ve.attributes, Ve = Ve.name), Ze = cs(Ze), "elementNameFn" in Rn && (Ve = Rn.elementNameFn(Ve, Nn)), Rn.compact) {
        var bt, Ut = {};
        if (!Rn.ignoreAttributes && Ze && Object.keys(Ze).length)
          for (bt in Ut[Rn.attributesKey] = {}, Ze)
            Ze.hasOwnProperty(bt) && (Ut[Rn.attributesKey][bt] = Ze[bt]);
        Ve in Nn || (ir(Rn.alwaysArray) ? Rn.alwaysArray.indexOf(Ve) === -1 : !Rn.alwaysArray) || (Nn[Ve] = []), Nn[Ve] && !ir(Nn[Ve]) && (Nn[Ve] = [Nn[Ve]]), ir(Nn[Ve]) ? Nn[Ve].push(Ut) : Nn[Ve] = Ut;
      } else
        Nn[Rn.elementsKey] || (Nn[Rn.elementsKey] = []), (Ut = {})[Rn.typeKey] = "element", Ut[Rn.nameKey] = Ve, !Rn.ignoreAttributes && Ze && Object.keys(Ze).length && (Ut[Rn.attributesKey] = Ze), Rn.alwaysChildren && (Ut[Rn.elementsKey] = []), Nn[Rn.elementsKey].push(Ut);
      Ut[Rn.parentKey] = Nn, Nn = Ut;
    }
    function Xn(Ve) {
      Rn.ignoreText || (Ve.trim() || Rn.captureSpacesBetweenElements) && (Rn.trim && (Ve = Ve.trim()), Rn.nativeType && (Ve = er(Ve)), br("text", Ve = Rn.sanitize ? Ve.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : Ve));
    }
    function rr(Ve) {
      Rn.ignoreComment || br("comment", Ve = Rn.trim ? Ve.trim() : Ve);
    }
    function _r(Ve) {
      var Ze = Nn[Rn.parentKey];
      Rn.addParent || delete Nn[Rn.parentKey], Nn = Ze;
    }
    function Ss(Ve) {
      Rn.ignoreCdata || br("cdata", Ve = Rn.trim ? Ve.trim() : Ve);
    }
    function is(Ve) {
      Rn.ignoreDoctype || (Ve = Ve.replace(/^ /, ""), br("doctype", Ve = Rn.trim ? Ve.trim() : Ve));
    }
    function Ms(Ve) {
      Ve.note = Ve;
    }
    function ls(Ve, Ze) {
      var bt = $n.parser(!0, {}), Ut = {};
      return Nn = Ut, Rn = Kn.copyOptions(Ze), Kn.ensureFlagExists("ignoreDeclaration", Rn), Kn.ensureFlagExists("ignoreInstruction", Rn), Kn.ensureFlagExists("ignoreAttributes", Rn), Kn.ensureFlagExists("ignoreText", Rn), Kn.ensureFlagExists("ignoreComment", Rn), Kn.ensureFlagExists("ignoreCdata", Rn), Kn.ensureFlagExists("ignoreDoctype", Rn), Kn.ensureFlagExists("compact", Rn), Kn.ensureFlagExists("alwaysChildren", Rn), Kn.ensureFlagExists("addParent", Rn), Kn.ensureFlagExists("trim", Rn), Kn.ensureFlagExists("nativeType", Rn), Kn.ensureFlagExists("nativeTypeAttributes", Rn), Kn.ensureFlagExists("sanitize", Rn), Kn.ensureFlagExists("instructionHasAttributes", Rn), Kn.ensureFlagExists("captureSpacesBetweenElements", Rn), Kn.ensureAlwaysArrayExists(Rn), Kn.ensureKeyExists("declaration", Rn), Kn.ensureKeyExists("instruction", Rn), Kn.ensureKeyExists("attributes", Rn), Kn.ensureKeyExists("text", Rn), Kn.ensureKeyExists("comment", Rn), Kn.ensureKeyExists("cdata", Rn), Kn.ensureKeyExists("doctype", Rn), Kn.ensureKeyExists("type", Rn), Kn.ensureKeyExists("name", Rn), Kn.ensureKeyExists("elements", Rn), Kn.ensureKeyExists("parent", Rn), Kn.checkFnExists("doctype", Rn), Kn.checkFnExists("instruction", Rn), Kn.checkFnExists("cdata", Rn), Kn.checkFnExists("comment", Rn), Kn.checkFnExists("text", Rn), Kn.checkFnExists("instructionName", Rn), Kn.checkFnExists("elementName", Rn), Kn.checkFnExists("attributeName", Rn), Kn.checkFnExists("attributeValue", Rn), Kn.checkFnExists("attributes", Rn), bt.opt = { strictEntities: !0 }, bt.onopentag = Jn, bt.ontext = Xn, bt.oncomment = rr, bt.onclosetag = _r, bt.onerror = Ms, bt.oncdata = Ss, bt.ondoctype = is, bt.onprocessinginstruction = Gn, bt.write(Ve).close(), Ut[Rn.elementsKey] && (Ze = Ut[Rn.elementsKey], delete Ut[Rn.elementsKey], Ut[Rn.elementsKey] = Ze, delete Ut.text), Ut;
    }
    var Ur = Zs, Qr = ls, Fr, Lr, Hr = Zs, ns = Dn;
    function Ts(Ve, Ze, bt) {
      return (!bt && Ve.spaces ? `
` : "") + Array(Ze + 1).join(Ve.spaces);
    }
    function en(Ve, Ze, bt) {
      if (Ze.ignoreAttributes)
        return "";
      var Ut, mn, nn, Sn, Mn = [];
      for (Ut in Ve = "attributesFn" in Ze ? Ze.attributesFn(Ve, Lr, Fr) : Ve)
        Ve.hasOwnProperty(Ut) && Ve[Ut] !== null && Ve[Ut] !== void 0 && (Sn = Ze.noQuotesForNativeAttributes && typeof Ve[Ut] != "string" ? "" : '"', mn = (mn = "" + Ve[Ut]).replace(/"/g, "&quot;"), nn = "attributeNameFn" in Ze ? Ze.attributeNameFn(Ut, mn, Lr, Fr) : Ut, Mn.push(Ze.spaces && Ze.indentAttributes ? Ts(Ze, bt + 1, !1) : " "), Mn.push(nn + "=" + Sn + ("attributeValueFn" in Ze ? Ze.attributeValueFn(mn, Ut, Lr, Fr) : mn) + Sn));
      return Ve && Object.keys(Ve).length && Ze.spaces && Ze.indentAttributes && Mn.push(Ts(Ze, bt, !1)), Mn.join("");
    }
    function to(Ve, Ze, bt) {
      return Fr = Ve, Lr = "xml", Ze.ignoreDeclaration ? "" : "<?xml" + en(Ve[Ze.attributesKey], Ze, bt) + "?>";
    }
    function bs(Ve, Ze, bt) {
      if (Ze.ignoreInstruction)
        return "";
      for (var Ut in Ve)
        if (Ve.hasOwnProperty(Ut))
          break;
      var mn = "instructionNameFn" in Ze ? Ze.instructionNameFn(Ut, Ve[Ut], Lr, Fr) : Ut;
      return typeof Ve[Ut] == "object" ? "<?" + (Lr = mn) + en((Fr = Ve)[Ut][Ze.attributesKey], Ze, bt) + "?>" : (bt = Ve[Ut] || "", "<?" + mn + ((bt = "instructionFn" in Ze ? Ze.instructionFn(bt, Ut, Lr, Fr) : bt) ? " " + bt : "") + "?>");
    }
    function jn(Ve, Ze) {
      return Ze.ignoreComment ? "" : "<!--" + ("commentFn" in Ze ? Ze.commentFn(Ve, Lr, Fr) : Ve) + "-->";
    }
    function lr(Ve, Ze) {
      return Ze.ignoreCdata ? "" : "<![CDATA[" + ("cdataFn" in Ze ? Ze.cdataFn(Ve, Lr, Fr) : Ve.replace("]]>", "]]]]><![CDATA[>")) + "]]>";
    }
    function pr(Ve, Ze) {
      return Ze.ignoreDoctype ? "" : "<!DOCTYPE " + ("doctypeFn" in Ze ? Ze.doctypeFn(Ve, Lr, Fr) : Ve) + ">";
    }
    function En(Ve, Ze) {
      return Ze.ignoreText ? "" : (Ve = (Ve = (Ve = "" + Ve).replace(/&amp;/g, "&")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "textFn" in Ze ? Ze.textFn(Ve, Lr, Fr) : Ve);
    }
    function qn(Ve, Ze, bt) {
      Lr = (Fr = Ve).name;
      var Ut = [], mn = "elementNameFn" in Ze ? Ze.elementNameFn(Ve.name, Ve) : Ve.name, nn = (Ut.push("<" + mn), Ve[Ze.attributesKey] && Ut.push(en(Ve[Ze.attributesKey], Ze, bt)), Ve[Ze.elementsKey] && Ve[Ze.elementsKey].length || Ve[Ze.attributesKey] && Ve[Ze.attributesKey]["xml:space"] === "preserve");
      return (nn = nn || ("fullTagEmptyElementFn" in Ze ? Ze.fullTagEmptyElementFn(Ve.name, Ve) : Ze.fullTagEmptyElement)) ? (Ut.push(">"), Ve[Ze.elementsKey] && Ve[Ze.elementsKey].length && (Ut.push(Wn(Ve[Ze.elementsKey], Ze, bt + 1)), Lr = (Fr = Ve).name), Ut.push(Ze.spaces && function(Sn, Mn) {
        var yn;
        if (Sn.elements && Sn.elements.length)
          for (yn = 0; yn < Sn.elements.length; ++yn)
            switch (Sn.elements[yn][Mn.typeKey]) {
              case "text":
                if (Mn.indentText)
                  return 1;
                break;
              case "cdata":
                if (Mn.indentCdata)
                  return 1;
                break;
              case "instruction":
                if (Mn.indentInstruction)
                  return 1;
                break;
              default:
                return 1;
            }
      }(Ve, Ze) ? `
` + Array(bt + 1).join(Ze.spaces) : ""), Ut.push("</" + mn + ">")) : Ut.push("/>"), Ut.join("");
    }
    function Wn(Ve, Ze, bt, Ut) {
      return Ve.reduce(function(mn, nn) {
        var Sn = Ts(Ze, bt, Ut && !mn);
        switch (nn.type) {
          case "element":
            return mn + Sn + qn(nn, Ze, bt);
          case "comment":
            return mn + Sn + jn(nn[Ze.commentKey], Ze);
          case "doctype":
            return mn + Sn + pr(nn[Ze.doctypeKey], Ze);
          case "cdata":
            return mn + (Ze.indentCdata ? Sn : "") + lr(nn[Ze.cdataKey], Ze);
          case "text":
            return mn + (Ze.indentText ? Sn : "") + En(nn[Ze.textKey], Ze);
          case "instruction":
            var Mn = {};
            return Mn[nn[Ze.nameKey]] = nn[Ze.attributesKey] ? nn : nn[Ze.instructionKey], mn + (Ze.indentInstruction ? Sn : "") + bs(Mn, Ze, bt);
        }
      }, "");
    }
    function kn(Ve, Ze, bt) {
      for (var Ut in Ve)
        if (Ve.hasOwnProperty(Ut))
          switch (Ut) {
            case Ze.parentKey:
            case Ze.attributesKey:
              break;
            case Ze.textKey:
              if (Ze.indentText || bt)
                return !0;
              break;
            case Ze.cdataKey:
              if (Ze.indentCdata || bt)
                return !0;
              break;
            case Ze.instructionKey:
              if (Ze.indentInstruction || bt)
                return !0;
              break;
            case Ze.doctypeKey:
            case Ze.commentKey:
            default:
              return !0;
          }
      return !1;
    }
    function zn(Ve, Ze, bt, Ut) {
      var mn, nn, Sn, Mn = [];
      for (nn in Ve)
        if (Ve.hasOwnProperty(nn))
          for (Sn = ns(Ve[nn]) ? Ve[nn] : [Ve[nn]], mn = 0; mn < Sn.length; ++mn) {
            switch (nn) {
              case Ze.declarationKey:
                Mn.push(to(Sn[mn], Ze, bt));
                break;
              case Ze.instructionKey:
                Mn.push((Ze.indentInstruction ? Ts(Ze, bt, Ut) : "") + bs(Sn[mn], Ze, bt));
                break;
              case Ze.attributesKey:
              case Ze.parentKey:
                break;
              case Ze.textKey:
                Mn.push((Ze.indentText ? Ts(Ze, bt, Ut) : "") + En(Sn[mn], Ze));
                break;
              case Ze.cdataKey:
                Mn.push((Ze.indentCdata ? Ts(Ze, bt, Ut) : "") + lr(Sn[mn], Ze));
                break;
              case Ze.doctypeKey:
                Mn.push(Ts(Ze, bt, Ut) + pr(Sn[mn], Ze));
                break;
              case Ze.commentKey:
                Mn.push(Ts(Ze, bt, Ut) + jn(Sn[mn], Ze));
                break;
              default:
                Mn.push(Ts(Ze, bt, Ut) + function(yn, Pt, tr, Lt, dr) {
                  Fr = yn, Lr = Pt;
                  var ur = "elementNameFn" in tr ? tr.elementNameFn(Pt, yn) : Pt;
                  if (yn == null || yn === "")
                    return "fullTagEmptyElementFn" in tr && tr.fullTagEmptyElementFn(Pt, yn) || tr.fullTagEmptyElement ? "<" + ur + "></" + ur + ">" : "<" + ur + "/>";
                  var gr = [];
                  if (Pt) {
                    if (gr.push("<" + ur), typeof yn != "object")
                      return gr.push(">" + En(yn, tr) + "</" + ur + ">"), gr.join("");
                    yn[tr.attributesKey] && gr.push(en(yn[tr.attributesKey], tr, Lt));
                    var Rr = kn(yn, tr, !0) || yn[tr.attributesKey] && yn[tr.attributesKey]["xml:space"] === "preserve";
                    if (!(Rr = Rr || ("fullTagEmptyElementFn" in tr ? tr.fullTagEmptyElementFn(Pt, yn) : tr.fullTagEmptyElement)))
                      return gr.push("/>"), gr.join("");
                    gr.push(">");
                  }
                  return gr.push(zn(yn, tr, Lt + 1, !1)), Fr = yn, (Lr = Pt) && gr.push((dr ? Ts(tr, Lt, !1) : "") + "</" + ur + ">"), gr.join("");
                }(Sn[mn], nn, Ze, bt, kn(Sn[mn], Ze)));
            }
            Ut = Ut && !Mn.length;
          }
      return Mn.join("");
    }
    function wr(Ve, Ze) {
      bt = Ze, bt = Hr.copyOptions(bt), Hr.ensureFlagExists("ignoreDeclaration", bt), Hr.ensureFlagExists("ignoreInstruction", bt), Hr.ensureFlagExists("ignoreAttributes", bt), Hr.ensureFlagExists("ignoreText", bt), Hr.ensureFlagExists("ignoreComment", bt), Hr.ensureFlagExists("ignoreCdata", bt), Hr.ensureFlagExists("ignoreDoctype", bt), Hr.ensureFlagExists("compact", bt), Hr.ensureFlagExists("indentText", bt), Hr.ensureFlagExists("indentCdata", bt), Hr.ensureFlagExists("indentAttributes", bt), Hr.ensureFlagExists("indentInstruction", bt), Hr.ensureFlagExists("fullTagEmptyElement", bt), Hr.ensureFlagExists("noQuotesForNativeAttributes", bt), Hr.ensureSpacesExists(bt), typeof bt.spaces == "number" && (bt.spaces = Array(bt.spaces + 1).join(" ")), Hr.ensureKeyExists("declaration", bt), Hr.ensureKeyExists("instruction", bt), Hr.ensureKeyExists("attributes", bt), Hr.ensureKeyExists("text", bt), Hr.ensureKeyExists("comment", bt), Hr.ensureKeyExists("cdata", bt), Hr.ensureKeyExists("doctype", bt), Hr.ensureKeyExists("type", bt), Hr.ensureKeyExists("name", bt), Hr.ensureKeyExists("elements", bt), Hr.checkFnExists("doctype", bt), Hr.checkFnExists("instruction", bt), Hr.checkFnExists("cdata", bt), Hr.checkFnExists("comment", bt), Hr.checkFnExists("text", bt), Hr.checkFnExists("instructionName", bt), Hr.checkFnExists("elementName", bt), Hr.checkFnExists("attributeName", bt), Hr.checkFnExists("attributeValue", bt), Hr.checkFnExists("attributes", bt), Hr.checkFnExists("fullTagEmptyElement", bt);
      var bt, Ut = [];
      return Fr = Ve, Lr = "_root_", (Ze = bt).compact ? Ut.push(zn(Ve, Ze, 0, !0)) : (Ve[Ze.declarationKey] && Ut.push(to(Ve[Ze.declarationKey], Ze, 0)), Ve[Ze.elementsKey] && Ve[Ze.elementsKey].length && Ut.push(Wn(Ve[Ze.elementsKey], Ze, 0, !Ut.length))), Ut.join("");
    }
    var jr, Vr = wr, us = h({ xml2js: ls, xml2json: function(Ve, Ze) {
      var bt;
      return Ze = Ze, Ze = Ur.copyOptions(Ze), Ur.ensureSpacesExists(Ze), Ze = Qr(Ve, Ve = Ze), bt = "compact" in Ve && Ve.compact ? "_parent" : "parent", ("addParent" in Ve && Ve.addParent ? JSON.stringify(Ze, function(Ut, mn) {
        return Ut === bt ? "_" : mn;
      }, Ve.spaces) : JSON.stringify(Ze, null, Ve.spaces)).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }, js2xml: wr, json2xml: function(Ve, Ze) {
      var bt = null;
      if (typeof (Ve = Ve instanceof buffer$1.Buffer ? Ve.toString() : Ve) == "string")
        try {
          bt = JSON.parse(Ve);
        } catch {
          throw new Error("The JSON structure is invalid");
        }
      else
        bt = Ve;
      return Vr(bt, Ze);
    } }), Es = { raster: {}, vector: {} };
    function Dr(Ve) {
      return Ve && (Ve = us.xml2js(Ve), Ve.elements && 0 < Ve.elements.length && (Ve.elements.length !== 1 && console.warn("invalid xml!"), Ve.elements[0]) && Ve.elements[0].elements) ? Ve.elements[0].elements.map(function(Ze) {
        var bt = Ze.attributes;
        return Ze.elements && 0 < Ze.elements.length && (bt.options = Ze.elements.map(function(Ut) {
          return Ut.elements[0].text;
        })), bt;
      }) : null;
    }
    function Kr() {
      for (var Ve, Ze, bt, Ut = q.GDALGetDriverCount(), mn = 0; mn < Ut; mn += 1) {
        var nn = q.GDALGetDriver(mn), Sn = (nn = nn, bt = Ze = Sn = Ve = void 0, Ve = q.GDALGetMetadataItem(nn, "DMD_EXTENSIONS", null), (Sn = (Sn = q.GDALGetMetadataItem(nn, "DMD_EXTENSION", null)) === "" && Ve !== "" ? Ve.split(" ")[0] : Sn) !== "" && (Sn = Sn.replace(".", "").replace("/", "")), (Ze = q.GDALGetDescription(nn)) === "GeoJSON" && (Sn = "geojson"), bt = q.GDALGetMetadataItem(nn, "DMD_LONGNAME", null), { extension: Sn, extensions: Ve, shortName: Ze, longName: bt, isReadable: q.GDALGetMetadataItem(nn, "DCAP_OPEN", null) === "YES", isWritable: q.GDALGetMetadataItem(nn, "DCAP_CREATE", null) === "YES" || q.GDALGetMetadataItem(nn, "DCAP_CREATECOPY", null) === "YES", isRaster: q.GDALGetMetadataItem(nn, "DCAP_RASTER", null) === "YES", isVector: q.GDALGetMetadataItem(nn, "DCAP_VECTOR", null) === "YES", openOptionsList: Dr(q.GDALGetMetadataItem(nn, "DMD_OPENOPTIONLIST", null)), creationOptionList: Dr(q.GDALGetMetadataItem(nn, "DMD_CREATIONOPTIONLIST", null)), layerCreationOptionList: Dr(q.GDALGetMetadataItem(nn, "DS_LAYER_CREATIONOPTIONLIST", null)), helpUrl: q.GDALGetMetadataItem(nn, "DMD_HELPTOPIC", null) });
        Sn.isRaster && (Es.raster[Sn.shortName] = o(o({ index: mn }, Sn), {}, { type: "raster" })), Sn.isVector && (Es.vector[Sn.shortName] = o(o({ index: mn }, Sn), {}, { type: "vector" }));
      }
    }
    function Js(Ve) {
      var Ze = q.GDALGetFileList(Ve);
      if (!Ze)
        return [];
      for (var bt = [], Ut = 0; Ut < 100; Ut += 1) {
        var mn = q.Module.HEAP32[Ze + 4 * Ut >> 2];
        if (mn === 0)
          break;
        mn = q.Module.UTF8ToString(mn), bt.push(mn);
      }
      return bt;
    }
    function io(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [];
      return new Promise(function(bt, Ut) {
        var mn = _e(["-json"].concat(c(Ze))), nn = mn.config, nn = (Object.entries(nn).forEach(function(Pt) {
          var Pt = u(Pt, 2), yn = Pt[0], Pt = Pt[1];
          q.CPLSetConfigOption(yn, Pt);
        }), q.GDALInfoOptionsNew(mn.ptr, null)), Sn = q.GDALInfo(Ve.pointer, nn);
        q.GDALInfoOptionsFree(nn), Le(mn), 3 <= q.CPLGetLastErrorNo() ? Ut(fe()) : bt(JSON.parse(Sn));
      });
    }
    function No(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [];
      return new Promise(function(bt, Ut) {
        var mn = _e(["-json"].concat(c(Ze))), nn = mn.config, nn = (Object.entries(nn).forEach(function(Pt) {
          var Pt = u(Pt, 2), yn = Pt[0], Pt = Pt[1];
          q.CPLSetConfigOption(yn, Pt);
        }), q.GDALVectorInfoOptionsNew(mn.ptr, null)), Sn = q.GDALVectorInfo(Ve.pointer, nn);
        q.GDALVectorInfoOptionsFree(nn), Le(mn), 3 <= q.CPLGetLastErrorNo() ? Ut(fe()) : bt(JSON.parse(Sn));
      });
    }
    function Ai() {
      !m && typeof importScripts != "function" || q.Module.FS.unmount(Fe);
    }
    var go = { ogr2ogr: function(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], bt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ut, mn) {
        var nn = _e(Ze), Sn = nn.config, Sn = (Object.entries(Sn).forEach(function(gr) {
          var gr = u(gr, 2), ur = gr[0], gr = gr[1];
          q.CPLSetConfigOption(ur, gr);
        }), q.GDALVectorTranslateOptionsNew(nn.ptr, null)), tr = q.Module._malloc(4), yn = (q.Module.setValue(tr, Ve.pointer, "*"), Ze.indexOf("-f") + 1), Mn = "unknown", yn = (yn !== 0 && (yn = Ze[yn], Pt = Es.vector[yn]) && (Mn = yn === "MapInfo File" && Ze.indexOf("FORMAT=MIF") !== -1 ? "mif" : Pt.extension), bt || Ve.path.split(".", 1)[0]), Pt = "".concat(Ee, "/").concat(yn, ".").concat(Mn), tr = q.GDALVectorTranslate(Pt, null, 1, tr, Sn, null), Lt = Js(tr);
        q.GDALVectorTranslateOptionsFree(Sn), Le(nn), q.GDALClose(tr), 3 <= q.CPLGetLastErrorNo() ? mn(fe()) : Ut({ local: Pt, real: "".concat(Ge, "/").concat(yn, ".").concat(Mn), all: Lt.map(function(dr) {
          return { local: dr, real: dr.replace("".concat(Ee, "/"), "".concat(Ge, "/")) };
        }) });
      });
    }, gdal_translate: function(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], bt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ut, mn) {
        var nn = _e(Ze), Sn = nn.config, Sn = (Object.entries(Sn).forEach(function(gr) {
          var gr = u(gr, 2), ur = gr[0], gr = gr[1];
          q.CPLSetConfigOption(ur, gr);
        }), q.GDALTranslateOptionsNew(nn.ptr, null)), yn = Ze.indexOf("-of") + 1, Mn = "unknown", yn = (yn !== 0 && (yn = Ze[yn], yn = Es.raster[yn]) && (Mn = yn.extension), bt || Ve.path.split(".", 1)[0]), Pt = "".concat(Ee, "/").concat(yn, ".").concat(Mn), tr = q.GDALTranslate(Pt, Ve.pointer, Sn, null), Lt = Js(tr);
        q.GDALTranslateOptionsFree(Sn), Le(nn), q.GDALClose(tr), 3 <= q.CPLGetLastErrorNo() ? mn(fe()) : Ut({ local: Pt, real: "".concat(Ge, "/").concat(yn, ".").concat(Mn), all: Lt.map(function(dr) {
          return { local: dr, real: dr.replace("".concat(Ee, "/"), "".concat(Ge, "/")) };
        }) });
      });
    }, gdal_rasterize: function(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], bt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ut, mn) {
        var nn = _e(Ze), Sn = nn.config, Sn = (Object.entries(Sn).forEach(function(gr) {
          var gr = u(gr, 2), ur = gr[0], gr = gr[1];
          q.CPLSetConfigOption(ur, gr);
        }), q.GDALRasterizeOptionsNew(nn.ptr, null)), yn = Ze.indexOf("-of") + 1, Mn = "tif", yn = (yn !== 0 && (yn = Ze[yn], yn = Es.raster[yn]) && (Mn = yn.extension), bt || Ve.path.split(".", 1)[0]), Pt = "".concat(Ee, "/").concat(yn, ".").concat(Mn), tr = q.GDALRasterize(Pt, null, Ve.pointer, Sn, null), Lt = Js(tr);
        q.GDALRasterizeOptionsFree(Sn), Le(nn), q.GDALClose(tr), 3 <= q.CPLGetLastErrorNo() ? mn(fe()) : Ut({ local: Pt, real: "".concat(Ge, "/").concat(yn, ".").concat(Mn), all: Lt.map(function(dr) {
          return { local: dr, real: dr.replace("".concat(Ee, "/"), "".concat(Ge, "/")) };
        }) });
      });
    }, gdalwarp: function(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], bt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      return new Promise(function(Ut, mn) {
        var nn = _e(Ze), Sn = nn.config, Sn = (Object.entries(Sn).forEach(function(gr) {
          var gr = u(gr, 2), ur = gr[0], gr = gr[1];
          q.CPLSetConfigOption(ur, gr);
        }), q.GDALWarpAppOptionsNew(nn.ptr, null)), tr = q.Module._malloc(4), yn = (q.Module.setValue(tr, Ve.pointer, "*"), Ze.indexOf("-of") + 1), Mn = "unknown", yn = (yn !== 0 && (yn = Ze[yn], yn = Es.raster[yn]) && (Mn = yn.extension), bt || Ve.path.split(".", 1)[0]), Pt = "".concat(Ee, "/").concat(yn, ".").concat(Mn), tr = q.GDALWarp(Pt, null, 1, tr, Sn, null), Lt = Js(tr);
        q.GDALWarpAppOptionsFree(Sn), Le(nn), q.GDALClose(tr), 3 <= q.CPLGetLastErrorNo() ? mn(fe()) : Ut({ local: Pt, real: "".concat(Ge, "/").concat(yn, ".").concat(Mn), all: Lt.map(function(dr) {
          return { local: dr, real: dr.replace("".concat(Ee, "/"), "".concat(Ge, "/")) };
        }) });
      });
    }, gdaltransform: function(Ve, Ze) {
      return new Promise(function(bt) {
        for (var Ut = new Float64Array(Ve.map(function(Os) {
          return Os[0];
        })), mn = new Float64Array(Ve.map(function(Os) {
          return Os[1];
        })), nn = new Float64Array(Ve.map(function(Os) {
          return Os[2] || 0;
        })), Sn = q.Module._malloc(Ut.length * Ut.BYTES_PER_ELEMENT), Mn = q.Module._malloc(mn.length * mn.BYTES_PER_ELEMENT), yn = q.Module._malloc(nn.length * nn.BYTES_PER_ELEMENT), Pt = (q.Module.HEAPF64.set(Ut, Sn / Ut.BYTES_PER_ELEMENT), q.Module.HEAPF64.set(mn, Mn / mn.BYTES_PER_ELEMENT), q.Module.HEAPF64.set(nn, yn / nn.BYTES_PER_ELEMENT), !1), tr = !1, Lt = [], dr = 0; dr < Ze.length; dr += 1)
          switch (Ze[dr]) {
            case "-s_srs":
              Lt.push("SRC_SRS=".concat(Ze[dr += 1]));
              break;
            case "-t_srs":
              Lt.push("DST_SRS=".concat(Ze[dr += 1]));
              break;
            case "-ct":
              Lt.push("COORDINATE_OPERATION=".concat(Ze[dr += 1]));
              break;
            case "-order":
              Lt.push("MAX_GCP_ORDER=".concat(Ze[dr += 1]));
              break;
            case "-tps":
              Lt.push("METHOD=GCP_TPS");
              break;
            case "-rpc":
              Lt.push("METHOD=RPC");
              break;
            case "-geoloc":
              Lt.push("METHOD=GEOLOC_ARRAY");
              break;
            case "-i":
              Pt = !0;
              break;
            case "-to":
              Lt.push("".concat(Ze[dr += 1]));
              break;
            case "-output_xy":
              tr = !0;
          }
        for (var ur = _e(Lt), gr = q.GDALCreateGenImgProjTransformer2(null, null, ur.ptr), Rr = (q.GDALGenImgProjTransform(gr, Pt, Ve.length, Sn, Mn, yn, null), [Array.from(q.Module.HEAPF64.subarray(Sn / Ut.BYTES_PER_ELEMENT, Sn / Ut.BYTES_PER_ELEMENT + Ut.length)), Array.from(q.Module.HEAPF64.subarray(Mn / mn.BYTES_PER_ELEMENT, Mn / mn.BYTES_PER_ELEMENT + mn.length)), Array.from(q.Module.HEAPF64.subarray(yn / nn.BYTES_PER_ELEMENT, yn / nn.BYTES_PER_ELEMENT + nn.length))]), as = [], hs = 0; hs < Rr[0].length; hs += 1)
          as.push(tr ? [Rr[0][hs], Rr[1][hs]] : [Rr[0][hs], Rr[1][hs], Rr[2][hs]]);
        q.Module._free(Sn), q.Module._free(Mn), q.Module._free(yn), Le(ur), q.GDALDestroyGenImgProjTransformer(gr), bt(as);
      });
    }, gdal_location_info: function(Ve, Ze) {
      return new Promise(function(bt, Ut) {
        var mn = q.OSRNewSpatialReference('GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]'), Mn = (q.OSRSetAxisMappingStrategy(mn, 0), q.GDALGetSpatialRef(Ve.pointer)), mn = q.OCTNewCoordinateTransformation(mn, Mn), Mn = q.CPLAtof(String(Ze[0])), nn = q.CPLAtof(String(Ze[1])), Sn = q.Module._malloc(8), Mn = (q.Module.setValue(Sn, Mn, "double"), q.Module._malloc(8));
        q.Module.setValue(Mn, nn, "double"), q.OCTTransform(mn, 1, Mn, Sn, null) || Ut(new Error("Failed to perform OCTTransform")), nn = q.Module.getValue(Mn, "double"), mn = q.Module.getValue(Sn, "double"), Mn = q.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), q.GDALGetGeoTransform(Ve.pointer, Mn), Sn = q.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), q.GDALInvGeoTransform(Mn, Sn) || Ut(new Error("Failed to invert transform")), Mn = q.Module.HEAPF64.subarray(Sn / Float64Array.BYTES_PER_ELEMENT, Sn / Float64Array.BYTES_PER_ELEMENT + 6), bt({ pixel: Math.floor(Mn[0] + Mn[1] * nn + Mn[2] * mn), line: Math.floor(Mn[3] + Mn[4] * nn + Mn[5] * mn) });
      });
    }, gdalinfo: io, ogrinfo: No, open: function(Ve) {
      var Ze = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], bt = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : [], Ut = Ve, mn = _e(Ze);
      return Array.isArray(Ut) || typeof FileList == "function" && Ut instanceof FileList || (Ut = [Ut]), new Promise(function(nn, Sn) {
        var Mn, yn = [], Pt = [];
        c(Ut).forEach(function(tr) {
          !(typeof tr == "string" || tr instanceof String) || tr.substring(0, Fe.length + 1) !== "".concat(Fe, "/") && tr.substring(0, Ee.length + 1) !== "".concat(Ee, "/") ? Pt.push(tr) : yn.push({ name: tr.substring(tr.indexOf("/", 1) + 1), internal: !0, prefix: tr.substring(0, tr.indexOf("/", 1)) });
        }), Mn = Pt, new Promise(function(tr) {
          var Lt, dr;
          Mn.length === 0 ? tr([]) : m ? (Lt = [], Mn.forEach(function(Rr) {
            var Rr = Rr.split("/"), gr = Rr.pop(), Rr = Rr.join("/") || ".";
            jr !== Rr && (jr && Ai(), jr = Rr, q.Module.FS.mount(q.Module.NODEFS, { root: Rr }, Fe)), Lt.push({ name: gr });
          }), tr(Lt)) : typeof importScripts == "function" ? (jr && Ai(), q.Module.FS.mount(q.Module.WORKERFS, { files: Mn }, Fe), jr = !0, tr(Mn)) : (dr = [], Mn.forEach(function(ur) {
            dr.push(ur.arrayBuffer());
          }), Promise.all(dr).then(function(ur) {
            ur.forEach(function(gr, Rr) {
              gr = new Uint8Array(gr), q.Module.FS.writeFile("".concat(Fe, "/").concat(Mn[Rr].name), gr);
            }), tr(Mn);
          }));
        }).then(function(tr) {
          for (var Lt = [].concat(c(tr), yn), dr = [], ur = (q.CPLErrorReset(), {}), gr = [], Rr = function() {
            var hs = Lt[as].name, Os = hs.split(".", 1)[0];
            if (ur[Os] || (ur[Os] = {}), ur[Os].pointer)
              return 0;
            ur[Os].path = hs;
            var jo = bt && bt.length ? "/".concat(bt.join("/"), "/") : "", po = "".concat(jo).concat(Fe, "/").concat(hs), So = (Lt[as].internal && (po = "".concat(jo).concat(Lt[as].prefix, "/").concat(hs)), q.GDALOpenEx(po, null, null, mn.ptr, null));
            if (So === 0)
              return jo = fe(), dr.push(jo), delete ur[Os], 0;
            ur[Os].pointer = So;
            function Eo() {
              var Ps = q.GDALGetRasterCount(So), no = q.GDALDatasetGetLayerCount(So);
              ur[Os].type = 0 < Ps && no === 0 ? "raster" : "vector";
            }
            hs = io(ur[Os]).then(function(Ps) {
              if (Ps && Ps.bands) {
                var no = Ps.size && 2 <= Ps.size.length && (0 < Ps.size[0] || 0 < Ps.size[1]);
                if (ur[Os].type = 0 < Ps.bands.length && no ? "raster" : "vector", ur[Os].type === "vector")
                  return No(ur[Os]).then(function(gs) {
                    ur[Os].info = gs;
                  });
                ur[Os].info = Ps;
              } else
                Eo();
              return !0;
            }).catch(Eo), gr.push(hs);
          }, as = 0; as < Lt.length; as += 1)
            Rr();
          Le(mn), Promise.allSettled(gr).then(function() {
            var hs = Object.values(ur);
            0 < hs.length || dr.length === 0 ? nn({ datasets: hs, errors: dr }) : Sn(dr);
          });
        });
      });
    }, close: function(Ve) {
      return new Promise(function(Ze) {
        q.GDALClose(Ve.pointer), Ze();
      });
    }, getInfo: function(Ve) {
      return new Promise(function(Ze) {
        var bt = q.GDALGetRasterCount(Ve.pointer), Ut = q.GDALDatasetGetLayerCount(Ve.pointer);
        if (0 < bt && Ut === 0) {
          var mn = q.GDALGetRasterXSize(Ve.pointer), nn = q.GDALGetRasterYSize(Ve.pointer), Sn = q.GDALGetProjectionRef(Ve.pointer), yn = q.Module._malloc(6 * Float64Array.BYTES_PER_ELEMENT), Mn = (q.GDALGetGeoTransform(Ve.pointer, yn), q.Module.HEAPF64.subarray(yn / Float64Array.BYTES_PER_ELEMENT, yn / Float64Array.BYTES_PER_ELEMENT + 6)), yn = [[0, 0], [mn, 0], [mn, nn], [0, nn]].map(function(hs) {
            var as = hs[0], hs = hs[1];
            return [Mn[0] + Mn[1] * as + Mn[2] * hs, Mn[3] + Mn[4] * as + Mn[5] * hs];
          }), Pt = q.GDALGetDatasetDriver(Ve.pointer), Pt = q.GDALGetDriverLongName(Pt), tr = q.OGR_DS_GetName(Ve.pointer);
          Ze(JSON.parse(JSON.stringify({ type: "raster", bandCount: bt, width: mn, height: nn, projectionWkt: Sn, coordinateTransform: Mn, corners: yn, driverName: Pt, dsName: tr })));
        } else {
          for (var Lt = [], dr = 0; dr < Ut; dr += 1) {
            var gr = q.OGR_DS_GetLayer(Ve.pointer, dr), ur = q.OGR_L_GetName(gr), gr = q.OGR_L_GetFeatureCount(gr, 1);
            Lt.push({ name: ur, featureCount: gr });
          }
          bt = Lt.reduce(function(Rr, as) {
            return Rr + as.featureCount;
          }, 0), mn = q.OGR_DS_GetName(Ve.pointer), nn = q.GDALGetDatasetDriver(Ve.pointer), Ze({ type: "vector", layerCount: Ut, featureCount: bt, layers: Lt, dsName: mn, driverName: q.GDALGetDriverLongName(nn) });
        }
      });
    }, getOutputFiles: function() {
      return new Promise(function(Ve) {
        Ve(function Ze(bt) {
          var Ut = 0 < arguments.length && bt !== void 0 ? bt : Ee.substr(1), mn = Ut.split("/").reduce(function(Sn, Mn) {
            return Sn.contents[Mn];
          }, q.Module.FS.root).contents, nn = [];
          return Object.keys(mn).forEach(function(Sn) {
            var Mn = mn[Sn];
            Mn.usedBytes ? nn.push({ path: "/".concat(Ut, "/").concat(Sn), size: Mn.usedBytes }) : Mn.contents && nn.push.apply(nn, c(Ze("".concat(Ut, "/").concat(Sn))));
          }), nn;
        }());
      });
    }, getFileBytes: function(Ve) {
      return new Promise(function(Ze) {
        var bt;
        Ve ? (bt = Ve.local || Ve, Ze(q.Module.FS.readFile(bt, { encoding: "binary" }))) : Ze(new Uint8Array());
      });
    }, drivers: Es, Module: q.Module };
    function ks(Ve) {
      var Ze;
      onmessage = function(bt) {
        var Ut;
        return bt.data && bt.data.func === "constructor" ? (Ut = { useWorker: !1 }, bt.data.params && bt.data.params.config && (Ut = o(o({}, bt.data.params.config), Ut)), (Ze = Ve(Ut)).then(function(mn) {
          return mn = mn.drivers, postMessage({ success: !0, id: "onload", data: mn });
        }).catch(function(mn) {
          return postMessage({ success: !1, id: "onload", data: mn });
        }), null) : Ze.then((function(mn) {
          var nn = this;
          this.data && this.data.func && mn[this.data.func] ? mn[this.data.func].apply(mn, c(this.data.params)).then(function(Sn) {
            postMessage({ success: !0, id: nn.data.id, data: Sn });
          }).catch(function(Sn) {
            postMessage({ success: !1, id: nn.data.id, data: { message: Sn.message } });
          }) : console.error("undefined function", this.data);
        }).bind(bt)).catch((function(mn) {
          postMessage({ success: !1, id: this.id, data: { no: -1, message: mn.message } });
        }).bind(bt));
      };
    }
    var Ci, Io = { gdalWorkerWrapper: null, drivers: null }, Oo = function() {
      function Ve(Ut, mn, nn) {
        var Sn = this;
        if (!(this instanceof Ve))
          throw new TypeError("Cannot call a class as a function");
        this.promises = { onload: { resolve: nn, reject: console.error } }, this.gdalWorker = new Worker(Ut), this.gdalWorker.onmessage = function(Mn) {
          Mn.data && Mn.data.id && Sn.promises[Mn.data.id] && (Mn.data.success ? Sn.promises[Mn.data.id].resolve(Mn.data.data) : Sn.promises[Mn.data.id].reject(Mn.data.data));
        }, this.gdalWorker.postMessage({ func: "constructor", params: { config: mn } });
      }
      var Ze, bt;
      return Ze = Ve, (bt = [{ key: "call", value: function(Ut) {
        var mn = this;
        return new Promise(function(nn, Sn) {
          Ut.id = Math.floor(1e5 * Math.random()), mn.promises[Ut.id] = { resolve: nn, reject: Sn }, mn.gdalWorker.postMessage(Ut);
        });
      } }, { key: "terminate", value: function() {
        this.gdalWorker.terminate(), delete this.gdalWorker, delete this.promises;
      } }]) && l(Ze.prototype, bt), Object.defineProperty(Ze, "prototype", { writable: !1 }), Ve;
    }(), Zs = new Proxy({}, { get: function(Ve, Ze) {
      return Ze === "then" || Ze === "catch" ? Ve : Ze === "drivers" ? Io.drivers : function() {
        for (var bt = arguments.length, Ut = new Array(bt), mn = 0; mn < bt; mn++)
          Ut[mn] = arguments[mn];
        return new Promise(function(nn, Sn) {
          Io.gdalWorkerWrapper.call({ func: Ze, params: Ut }).then(function(Mn) {
            nn(Mn);
          }).catch(function(Mn) {
            return Sn(Mn);
          });
        });
      };
    } }), wt = { variables: Io, WorkerWrapper: Oo, gdalProxy: Zs };
    function _t() {
      var Ve, Ze, bt = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
      return Ci = Ci || (m || bt.useWorker === !1 ? new Promise(function(Ut, mn) {
        var nn = q.Module, Sn = nn.onAbort;
        nn.onAbort = function(Mn) {
          mn(new Error(Mn)), Sn && Sn(Mn);
        }, nn.print = function(Mn) {
          bt.logHandler ? bt.logHandler(Mn, "stdout") : console.debug("gdal stdout: ".concat(Mn));
        }, nn.printErr = function(Mn) {
          bt.errorHandler ? bt.errorHandler(Mn, "stderr") : console.error("gdal stderr: ".concat(Mn));
        }, nn.preRun = [function(Mn) {
          var yn = Mn.ENV;
          yn.PROJ_LIB = "/usr/share/proj", yn.GDAL_DATA = "/usr/share/gdal", yn.DXF_FEATURE_LIMIT_PER_BLOCK = "-1", yn.GDAL_NUM_THREADS = "0", yn.GDAL_ENABLE_DEPRECATED_DRIVER_GTM = "YES", yn.CPL_LOG_ERRORS = "ON", bt.env && Object.entries(bt.env).forEach(function(Lt) {
            var Lt = u(Lt, 2), tr = Lt[0], Lt = Lt[1];
            yn[tr] = Lt;
          });
        }], nn.onRuntimeInitialized = function() {
          var Mn, yn;
          q.GDALOpen || ((yn = q.Module).ccall("GDALAllRegister", null, [], []), q.GDALOpen = yn.cwrap("GDALOpen", "number", ["string"]), q.GDALOpenEx = yn.cwrap("GDALOpenEx", "number", ["string", "number", "number", "number", "number"]), q.GDALClose = yn.cwrap("GDALClose", null, ["number"]), q.CPLErrorReset = yn.cwrap("CPLErrorReset", null, []), q.CPLSetErrorHandler = yn.cwrap("CPLSetErrorHandler", "number", ["number"]), q.CPLQuietErrorHandler = yn.cwrap("CPLQuietErrorHandler", null, ["number", "number", "string"]), q.CPLGetLastErrorNo = yn.cwrap("CPLGetLastErrorNo", "number", []), q.CPLGetLastErrorMsg = yn.cwrap("CPLGetLastErrorMsg", "string", []), q.CPLGetLastErrorType = yn.cwrap("CPLGetLastErrorType", "number", []), q.CPLSetConfigOption = yn.cwrap("CPLSetConfigOption", null, ["string", "string"]), q.CPLSetThreadLocalConfigOption = yn.cwrap("CPLSetThreadLocalConfigOption", null, ["string", "string"]), q.GDALGetRasterCount = yn.cwrap("GDALGetRasterCount", "number", ["number"]), q.GDALGetRasterXSize = yn.cwrap("GDALGetRasterXSize", "number", ["number"]), q.GDALGetRasterYSize = yn.cwrap("GDALGetRasterYSize", "number", ["number"]), q.GDALGetProjectionRef = yn.cwrap("GDALGetProjectionRef", "string", ["number"]), q.GDALGetGeoTransform = yn.cwrap("GDALGetGeoTransform", "number", ["number", "number"]), q.GDALInvGeoTransform = yn.cwrap("GDALInvGeoTransform", "number", ["number", "number"]), q.GDALVectorTranslate = yn.cwrap("GDALVectorTranslate", "number", ["string", "number", "number", "number", "number", "number"]), q.GDALVectorTranslateOptionsNew = yn.cwrap("GDALVectorTranslateOptionsNew", "number", ["number", "number"]), q.GDALVectorTranslateOptionsFree = yn.cwrap("GDALVectorTranslateOptionsFree", "number", ["number"]), q.GDALDatasetGetLayerCount = yn.cwrap("GDALDatasetGetLayerCount", "number", ["number"]), q.GDALDatasetGetLayer = yn.cwrap("GDALDatasetGetLayer", "number", ["number", "number"]), q.OGR_DS_GetLayerCount = yn.cwrap("OGR_DS_GetLayerCount", "number", ["number"]), q.OGR_DS_GetName = yn.cwrap("OGR_DS_GetName", "string", ["number"]), q.OGR_DS_GetLayer = yn.cwrap("OGR_DS_GetLayer", "number", ["number", "number"]), q.OGR_L_GetName = yn.cwrap("OGR_L_GetName", "string", ["number"]), q.OGR_DS_GetDriver = yn.cwrap("OGR_DS_GetDriver", "number", ["number"]), q.OGR_Dr_GetName = yn.cwrap("OGR_Dr_GetName", "string", ["number"]), q.GDALGetDatasetDriver = yn.cwrap("GDALGetDatasetDriver", "number", ["number"]), q.GDALGetDriverLongName = yn.cwrap("GDALGetDriverLongName", "string", ["number"]), q.GDALGetDriverShortName = yn.cwrap("GDALGetDriverShortName", "string", ["number"]), q.GDALTranslate = yn.cwrap("GDALTranslate", "number", ["string", "number", "number", "number"]), q.GDALTranslateOptionsNew = yn.cwrap("GDALTranslateOptionsNew", "number", ["number", "number"]), q.GDALTranslateOptionsFree = yn.cwrap("GDALTranslateOptionsFree", "number", ["number"]), q.GDALRasterize = yn.cwrap("GDALRasterize", "number", ["string", "number", "number", "number", "number"]), q.GDALRasterizeOptionsNew = yn.cwrap("GDALRasterizeOptionsNew", "number", ["number", "number"]), q.GDALRasterizeOptionsFree = yn.cwrap("GDALRasterizeOptionsFree", "number", ["number"]), q.GDALWarp = yn.cwrap("GDALWarp", "number", ["string", "number", "number", "number", "number", "number"]), q.GDALWarpAppOptionsNew = yn.cwrap("GDALWarpAppOptionsNew", "number", ["number", "number"]), q.GDALWarpAppOptionsSetProgress = yn.cwrap("GDALWarpAppOptionsSetProgress", "number", ["number", "number", "number"]), q.GDALWarpAppOptionsFree = yn.cwrap("GDALWarpAppOptionsFree", "number", ["number"]), q.OSRNewSpatialReference = yn.cwrap("OSRNewSpatialReference", "number", ["string"]), q.OSRDestroySpatialReference = yn.cwrap("OSRDestroySpatialReference", "number", ["number"]), q.OCTNewCoordinateTransformation = yn.cwrap("OCTNewCoordinateTransformation", "number", ["number", "number"]), q.OCTDestroyCoordinateTransformation = yn.cwrap("OCTDestroyCoordinateTransformation", "number", ["number"]), q.OCTTransform = yn.cwrap("OCTTransform", "number", ["number", "number", "number", "number", "number"]), q.GDALGetDriverCount = yn.cwrap("GDALGetDriverCount", "number", []), q.OGRGetDriverCount = yn.cwrap("OGRGetDriverCount", "number", []), q.GDALGetDriver = yn.cwrap("GDALGetDriver", "number", ["number"]), q.OGRGetDriver = yn.cwrap("OGRGetDriver", "number", ["number"]), q.GDALGetMetadataItem = yn.cwrap("GDALGetMetadataItem", "string", ["number", "string", "string"]), q.GDALGetDescription = yn.cwrap("GDALGetDescription", "string", ["number"]), q.OGR_L_GetFeatureCount = yn.cwrap("OGR_L_GetFeatureCount", "number", ["number", "number"]), q.GDALGenImgProjTransform = yn.cwrap("GDALGenImgProjTransform", "number", ["number", "number", "number", "number", "number", "number", "number"]), q.GDALCreateGenImgProjTransformer2 = yn.cwrap("GDALCreateGenImgProjTransformer2", "number", ["number", "number", "number"]), q.GDALDestroyGenImgProjTransformer = yn.cwrap("GDALDestroyGenImgProjTransformer", null, ["number"]), q.OSRSetFromUserInput = yn.cwrap("OSRSetFromUserInput", "number", ["number", "string"]), q.OSRExportToWkt = yn.cwrap("OSRExportToWkt", "number", ["number", "number"]), q.GDALGetSpatialRef = yn.cwrap("GDALGetSpatialRef", "number", ["number"]), q.CPLAtof = yn.cwrap("CPLAtof", "number", ["string"]), q.OSRSetAxisMappingStrategy = yn.cwrap("OSRSetAxisMappingStrategy", null, ["number", "number"]), q.GDALInfo = yn.cwrap("GDALInfo", "string", ["number", "number"]), q.GDALInfoOptionsNew = yn.cwrap("GDALInfoOptionsNew", "number", ["number", "number"]), q.GDALInfoOptionsFree = yn.cwrap("GDALInfoOptionsFree", null, ["number"]), q.GDALVectorInfo = yn.cwrap("GDALVectorInfo", "string", ["number", "number"]), q.GDALVectorInfoOptionsNew = yn.cwrap("GDALVectorInfoOptionsNew", "number", ["number", "number"]), q.GDALVectorInfoOptionsFree = yn.cwrap("GDALVectorInfoOptionsFree", null, ["number"]), q.GDALGetFileList = yn.cwrap("GDALGetFileList", "number", ["number"])), nn.FS.mkdir(Fe), nn.FS.mkdir(Ee), bt.dest && (yn = bt.dest, Ge = yn, Mn = bt.dest, m) && q.Module.FS.mount(q.Module.NODEFS, { root: Mn }, Ee), Kr();
        }, nn.locateFile = function(Pt) {
          var yn = Pt, Pt = (bt.paths && bt.paths.wasm && Pt.split(".").pop() === "wasm" ? yn = bt.paths.wasm : bt.paths && bt.paths.data && Pt.split(".").pop() === "data" && (yn = bt.paths.data), ""), Pt = (bt.path ? (Pt = bt.path).slice(-1) !== "/" && (Pt += "/") : m && (Pt = "node_modules/gdal3.js/dist/package/"), Pt + yn);
          return Pt = m || Pt.substring(0, 4) === "http" || Pt[0] === "/" ? Pt : "/".concat(Pt);
        }, m && (nn.getPreloadedPackage = function(Mn) {
          return _.readFileSync("./".concat(Mn), { flag: "r" }).buffer;
        }), G(q.Module).then(function() {
          Ut(go);
        });
      }) : (Ve = bt.paths && bt.paths.js || "gdal3.js", Ze = "", bt.path && (Ze = bt.path).slice(-1) !== "/" && (Ze += "/"), new Promise(function(Ut) {
        wt.variables.gdalWorkerWrapper = new wt.WorkerWrapper("".concat(Ze).concat(Ve), bt, function(mn) {
          wt.variables.drivers = mn, Ut(wt.gdalProxy);
        });
      })));
    }
    return m && (commonjsGlobal.location = { pathname: "./" }), typeof window < "u" && (window.initGdalJs = _t), typeof importScripts == "function" && ks(_t), _t;
  });
})(gdal3);
var gdal3Exports = gdal3.exports;
const initGdalJsBrowser = /* @__PURE__ */ getDefaultExportFromCjs(gdal3Exports);
var __awaiter$K = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const isNode = Object.prototype.toString.call(typeof api$1 < "u" ? api$1 : 0) === "[object process]", GLOBAL_CONFIG$1 = {
  staticRoot: ""
};
let GDAL_PROMISE;
function getGDAL() {
  return __awaiter$K(this, void 0, void 0, function* () {
    return GDAL_PROMISE || (isNode ? GDAL_PROMISE = initGdalJsNode() : GDAL_PROMISE = initGdalJsBrowser({
      paths: {
        wasm: `${GLOBAL_CONFIG$1.staticRoot}/gdal3WebAssembly.wasm`,
        data: `${GLOBAL_CONFIG$1.staticRoot}/gdal3WebAssembly.data`,
        js: `${GLOBAL_CONFIG$1.staticRoot}/gdal3.js`
      }
    })), yield GDAL_PROMISE;
  });
}
const GDA_MAPPING = {
  "EPSG:7848": "EPSG:28348",
  "EPSG:7849": "EPSG:28349",
  "EPSG:7850": "EPSG:28350",
  "EPSG:7851": "EPSG:28351",
  "EPSG:7852": "EPSG:28352",
  "EPSG:7853": "EPSG:28353",
  "EPSG:7854": "EPSG:28354",
  "EPSG:7855": "EPSG:28355",
  "EPSG:7856": "EPSG:28356",
  "EPSG:7857": "EPSG:28357",
  "EPSG:7858": "EPSG:28358"
};
function toECEFRaw(r, e) {
  return __awaiter$K(this, arguments, void 0, function* (s, o, a = !1) {
    const l = "EPSG:4978", u = yield getGDAL();
    if ((Object.keys(GDA_MAPPING).includes(o) || Object.values(GDA_MAPPING).includes(o)) && a)
      return proj4.defs(o, spatialReferenceSystems[o].proj4), proj4.defs(l, spatialReferenceSystems[l].proj4), s.map((E) => {
        const { x: d, y: f, z: h } = proj4(o, l).forward(E);
        return new Vector3(d, f, h);
      });
    const c = s.map((E) => [E.x, E.y, E.z]);
    if (Object.keys(GDA_MAPPING).includes(o)) {
      const E = yield u.gdaltransform(c, [
        "-s_srs",
        o,
        "-t_srs",
        GDA_MAPPING[o]
      ]);
      return (yield u.gdaltransform(E, [
        "-s_srs",
        GDA_MAPPING[o],
        "-t_srs",
        l
      ])).map(([f, h, S]) => new Vector3(f, h, S));
    } else
      return (yield u.gdaltransform(c, ["-s_srs", o, "-t_srs", l])).map(([d, f, h]) => new Vector3(d, f, h));
  });
}
function batch(r, e) {
  const s = [];
  let o = [];
  for (let a = 0; a < r.length; a++)
    o.push(r[a]), (a + 1) % e === 0 && (s.push(o), o = []);
  return s.push(o), s;
}
function toECEF(r, e) {
  return __awaiter$K(this, arguments, void 0, function* (s, o, a = !1, l = 1e3) {
    const u = batch(s, l), c = [];
    for (const E of u) {
      const d = yield toECEFRaw(E, o, a);
      for (const f of d)
        c.push(f);
    }
    return c;
  });
}
globalThis && globalThis.__awaiter;
new Matrix3().set(1, 0, 0, 0, -1, 0, 0, 0, -1);
globalThis && globalThis.__awaiter;
var papaparse_min = { exports: {} };
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/
(function(r, e) {
  ((s, o) => {
    r.exports = o();
  })(commonjsGlobal, function s() {
    var o = typeof self < "u" ? self : typeof window < "u" ? window : o !== void 0 ? o : {}, a, l = !o.document && !!o.postMessage, u = o.IS_PAPA_WORKER || !1, c = {}, E = 0, d = {};
    function f(Fe) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(Ee) {
        var Ge = fe(Ee);
        Ge.chunkSize = parseInt(Ge.chunkSize), Ee.step || Ee.chunk || (Ge.chunkSize = null), this._handle = new m(Ge), (this._handle.streamer = this)._config = Ge;
      }).call(this, Fe), this.parseChunk = function(Ee, Ge) {
        var ve = parseInt(this._config.skipFirstNLines) || 0;
        if (this.isFirstChunk && 0 < ve) {
          let ae = this._config.newline;
          ae || (te = this._config.quoteChar || '"', ae = this._handle.guessLineEndings(Ee, te)), Ee = [...Ee.split(ae).slice(ve)].join(ae);
        }
        this.isFirstChunk && Le(this._config.beforeFirstChunk) && (te = this._config.beforeFirstChunk(Ee)) !== void 0 && (Ee = te), this.isFirstChunk = !1, this._halted = !1;
        var ve = this._partialLine + Ee, te = (this._partialLine = "", this._handle.parse(ve, this._baseIndex, !this._finished));
        if (!this._handle.paused() && !this._handle.aborted()) {
          if (Ee = te.meta.cursor, ve = (this._finished || (this._partialLine = ve.substring(Ee - this._baseIndex), this._baseIndex = Ee), te && te.data && (this._rowCount += te.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), u)
            o.postMessage({ results: te, workerId: d.WORKER_ID, finished: ve });
          else if (Le(this._config.chunk) && !Ge) {
            if (this._config.chunk(te, this._handle), this._handle.paused() || this._handle.aborted())
              return void (this._halted = !0);
            this._completeResults = te = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(te.data), this._completeResults.errors = this._completeResults.errors.concat(te.errors), this._completeResults.meta = te.meta), this._completed || !ve || !Le(this._config.complete) || te && te.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), ve || te && te.meta.paused || this._nextChunk(), te;
        }
        this._halted = !0;
      }, this._sendError = function(Ee) {
        Le(this._config.error) ? this._config.error(Ee) : u && this._config.error && o.postMessage({ workerId: d.WORKER_ID, error: Ee, finished: !1 });
      };
    }
    function h(Fe) {
      var Ee;
      (Fe = Fe || {}).chunkSize || (Fe.chunkSize = d.RemoteChunkSize), f.call(this, Fe), this._nextChunk = l ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(Ge) {
        this._input = Ge, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished)
          this._chunkLoaded();
        else {
          if (Ee = new XMLHttpRequest(), this._config.withCredentials && (Ee.withCredentials = this._config.withCredentials), l || (Ee.onload = _e(this._chunkLoaded, this), Ee.onerror = _e(this._chunkError, this)), Ee.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !l), this._config.downloadRequestHeaders) {
            var Ge, ve = this._config.downloadRequestHeaders;
            for (Ge in ve)
              Ee.setRequestHeader(Ge, ve[Ge]);
          }
          var te;
          this._config.chunkSize && (te = this._start + this._config.chunkSize - 1, Ee.setRequestHeader("Range", "bytes=" + this._start + "-" + te));
          try {
            Ee.send(this._config.downloadRequestBody);
          } catch (ae) {
            this._chunkError(ae.message);
          }
          l && Ee.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        Ee.readyState === 4 && (Ee.status < 200 || 400 <= Ee.status ? this._chunkError() : (this._start += this._config.chunkSize || Ee.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((Ge) => (Ge = Ge.getResponseHeader("Content-Range")) !== null ? parseInt(Ge.substring(Ge.lastIndexOf("/") + 1)) : -1)(Ee), this.parseChunk(Ee.responseText)));
      }, this._chunkError = function(Ge) {
        Ge = Ee.statusText || Ge, this._sendError(new Error(Ge));
      };
    }
    function S(Fe) {
      (Fe = Fe || {}).chunkSize || (Fe.chunkSize = d.LocalChunkSize), f.call(this, Fe);
      var Ee, Ge, ve = typeof FileReader < "u";
      this.stream = function(te) {
        this._input = te, Ge = te.slice || te.webkitSlice || te.mozSlice, ve ? ((Ee = new FileReader()).onload = _e(this._chunkLoaded, this), Ee.onerror = _e(this._chunkError, this)) : Ee = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var te = this._input, ae = (this._config.chunkSize && (ae = Math.min(this._start + this._config.chunkSize, this._input.size), te = Ge.call(te, this._start, ae)), Ee.readAsText(te, this._config.encoding));
        ve || this._chunkLoaded({ target: { result: ae } });
      }, this._chunkLoaded = function(te) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(te.target.result);
      }, this._chunkError = function() {
        this._sendError(Ee.error);
      };
    }
    function R(Fe) {
      var Ee;
      f.call(this, Fe = Fe || {}), this.stream = function(Ge) {
        return Ee = Ge, this._nextChunk();
      }, this._nextChunk = function() {
        var Ge, ve;
        if (!this._finished)
          return Ge = this._config.chunkSize, Ee = Ge ? (ve = Ee.substring(0, Ge), Ee.substring(Ge)) : (ve = Ee, ""), this._finished = !Ee, this.parseChunk(ve);
      };
    }
    function _(Fe) {
      f.call(this, Fe = Fe || {});
      var Ee = [], Ge = !0, ve = !1;
      this.pause = function() {
        f.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        f.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(te) {
        this._input = te, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        ve && Ee.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), Ee.length ? this.parseChunk(Ee.shift()) : Ge = !0;
      }, this._streamData = _e(function(te) {
        try {
          Ee.push(typeof te == "string" ? te : te.toString(this._config.encoding)), Ge && (Ge = !1, this._checkIsFinished(), this.parseChunk(Ee.shift()));
        } catch (ae) {
          this._streamError(ae);
        }
      }, this), this._streamError = _e(function(te) {
        this._streamCleanUp(), this._sendError(te);
      }, this), this._streamEnd = _e(function() {
        this._streamCleanUp(), ve = !0, this._streamData("");
      }, this), this._streamCleanUp = _e(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function m(Fe) {
      var Ee, Ge, ve, te, ae = Math.pow(2, 53), v = -ae, Te = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, De = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, be = this, ze = 0, ke = 0, Be = !1, Me = !1, me = [], Se = { data: [], errors: [], meta: {} };
      function xt(Tt) {
        return Fe.skipEmptyLines === "greedy" ? Tt.join("").trim() === "" : Tt.length === 1 && Tt[0].length === 0;
      }
      function Ht() {
        if (Se && ve && (ut("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + d.DefaultDelimiter + "'"), ve = !1), Fe.skipEmptyLines && (Se.data = Se.data.filter(function(Ct) {
          return !xt(Ct);
        })), Bt()) {
          let Ct = function(st, jt) {
            Le(Fe.transformHeader) && (st = Fe.transformHeader(st, jt)), me.push(st);
          };
          if (Se)
            if (Array.isArray(Se.data[0])) {
              for (var Tt = 0; Bt() && Tt < Se.data.length; Tt++)
                Se.data[Tt].forEach(Ct);
              Se.data.splice(0, 1);
            } else
              Se.data.forEach(Ct);
        }
        function Yt(Ct, st) {
          for (var jt = Fe.header ? {} : [], lt = 0; lt < Ct.length; lt++) {
            var Zt = lt, Et = Ct[lt], Et = ((Ke, $e) => ((pt) => (Fe.dynamicTypingFunction && Fe.dynamicTyping[pt] === void 0 && (Fe.dynamicTyping[pt] = Fe.dynamicTypingFunction(pt)), (Fe.dynamicTyping[pt] || Fe.dynamicTyping) === !0))(Ke) ? $e === "true" || $e === "TRUE" || $e !== "false" && $e !== "FALSE" && (((pt) => {
              if (Te.test(pt) && (pt = parseFloat(pt), v < pt && pt < ae))
                return 1;
            })($e) ? parseFloat($e) : De.test($e) ? new Date($e) : $e === "" ? null : $e) : $e)(Zt = Fe.header ? lt >= me.length ? "__parsed_extra" : me[lt] : Zt, Et = Fe.transform ? Fe.transform(Et, Zt) : Et);
            Zt === "__parsed_extra" ? (jt[Zt] = jt[Zt] || [], jt[Zt].push(Et)) : jt[Zt] = Et;
          }
          return Fe.header && (lt > me.length ? ut("FieldMismatch", "TooManyFields", "Too many fields: expected " + me.length + " fields but parsed " + lt, ke + st) : lt < me.length && ut("FieldMismatch", "TooFewFields", "Too few fields: expected " + me.length + " fields but parsed " + lt, ke + st)), jt;
        }
        var an;
        Se && (Fe.header || Fe.dynamicTyping || Fe.transform) && (an = 1, !Se.data.length || Array.isArray(Se.data[0]) ? (Se.data = Se.data.map(Yt), an = Se.data.length) : Se.data = Yt(Se.data, 0), Fe.header && Se.meta && (Se.meta.fields = me), ke += an);
      }
      function Bt() {
        return Fe.header && me.length === 0;
      }
      function ut(Tt, Yt, an, Ct) {
        Tt = { type: Tt, code: Yt, message: an }, Ct !== void 0 && (Tt.row = Ct), Se.errors.push(Tt);
      }
      Le(Fe.step) && (te = Fe.step, Fe.step = function(Tt) {
        Se = Tt, Bt() ? Ht() : (Ht(), Se.data.length !== 0 && (ze += Tt.data.length, Fe.preview && ze > Fe.preview ? Ge.abort() : (Se.data = Se.data[0], te(Se, be))));
      }), this.parse = function(Tt, Yt, an) {
        var Ct = Fe.quoteChar || '"', Ct = (Fe.newline || (Fe.newline = this.guessLineEndings(Tt, Ct)), ve = !1, Fe.delimiter ? Le(Fe.delimiter) && (Fe.delimiter = Fe.delimiter(Tt), Se.meta.delimiter = Fe.delimiter) : ((Ct = ((st, jt, lt, Zt, Et) => {
          var Ke, $e, pt, Jt;
          Et = Et || [",", "	", "|", ";", d.RECORD_SEP, d.UNIT_SEP];
          for (var In = 0; In < Et.length; In++) {
            for (var Cn, It = Et[In], ht = 0, Wt = 0, hn = 0, Vt = (pt = void 0, new F({ comments: Zt, delimiter: It, newline: jt, preview: 10 }).parse(st)), Tn = 0; Tn < Vt.data.length; Tn++)
              lt && xt(Vt.data[Tn]) ? hn++ : (Cn = Vt.data[Tn].length, Wt += Cn, pt === void 0 ? pt = Cn : 0 < Cn && (ht += Math.abs(Cn - pt), pt = Cn));
            0 < Vt.data.length && (Wt /= Vt.data.length - hn), ($e === void 0 || ht <= $e) && (Jt === void 0 || Jt < Wt) && 1.99 < Wt && ($e = ht, Ke = It, Jt = Wt);
          }
          return { successful: !!(Fe.delimiter = Ke), bestDelimiter: Ke };
        })(Tt, Fe.newline, Fe.skipEmptyLines, Fe.comments, Fe.delimitersToGuess)).successful ? Fe.delimiter = Ct.bestDelimiter : (ve = !0, Fe.delimiter = d.DefaultDelimiter), Se.meta.delimiter = Fe.delimiter), fe(Fe));
        return Fe.preview && Fe.header && Ct.preview++, Ee = Tt, Ge = new F(Ct), Se = Ge.parse(Ee, Yt, an), Ht(), Be ? { meta: { paused: !0 } } : Se || { meta: { paused: !1 } };
      }, this.paused = function() {
        return Be;
      }, this.pause = function() {
        Be = !0, Ge.abort(), Ee = Le(Fe.chunk) ? "" : Ee.substring(Ge.getCharIndex());
      }, this.resume = function() {
        be.streamer._halted ? (Be = !1, be.streamer.parseChunk(Ee, !0)) : setTimeout(be.resume, 3);
      }, this.aborted = function() {
        return Me;
      }, this.abort = function() {
        Me = !0, Ge.abort(), Se.meta.aborted = !0, Le(Fe.complete) && Fe.complete(Se), Ee = "";
      }, this.guessLineEndings = function(st, Ct) {
        st = st.substring(0, 1048576);
        var Ct = new RegExp(L(Ct) + "([^]*?)" + L(Ct), "gm"), an = (st = st.replace(Ct, "")).split("\r"), Ct = st.split(`
`), st = 1 < Ct.length && Ct[0].length < an[0].length;
        if (an.length === 1 || st)
          return `
`;
        for (var jt = 0, lt = 0; lt < an.length; lt++)
          an[lt][0] === `
` && jt++;
        return jt >= an.length / 2 ? `\r
` : "\r";
      };
    }
    function L(Fe) {
      return Fe.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function F(Fe) {
      var Ee = (Fe = Fe || {}).delimiter, Ge = Fe.newline, ve = Fe.comments, te = Fe.step, ae = Fe.preview, v = Fe.fastMode, Te = null, De = !1, be = Fe.quoteChar == null ? '"' : Fe.quoteChar, ze = be;
      if (Fe.escapeChar !== void 0 && (ze = Fe.escapeChar), (typeof Ee != "string" || -1 < d.BAD_DELIMITERS.indexOf(Ee)) && (Ee = ","), ve === Ee)
        throw new Error("Comment character same as delimiter");
      ve === !0 ? ve = "#" : (typeof ve != "string" || -1 < d.BAD_DELIMITERS.indexOf(ve)) && (ve = !1), Ge !== `
` && Ge !== "\r" && Ge !== `\r
` && (Ge = `
`);
      var ke = 0, Be = !1;
      this.parse = function(Me, me, Se) {
        if (typeof Me != "string")
          throw new Error("Input must be a string");
        var xt = Me.length, Ht = Ee.length, Bt = Ge.length, ut = ve.length, Tt = Le(te), Yt = [], an = [], Ct = [], st = ke = 0;
        if (!Me)
          return ht();
        if (v || v !== !1 && Me.indexOf(be) === -1) {
          for (var jt = Me.split(Ge), lt = 0; lt < jt.length; lt++) {
            if (Ct = jt[lt], ke += Ct.length, lt !== jt.length - 1)
              ke += Ge.length;
            else if (Se)
              return ht();
            if (!ve || Ct.substring(0, ut) !== ve) {
              if (Tt) {
                if (Yt = [], Jt(Ct.split(Ee)), Wt(), Be)
                  return ht();
              } else
                Jt(Ct.split(Ee));
              if (ae && ae <= lt)
                return Yt = Yt.slice(0, ae), ht(!0);
            }
          }
          return ht();
        }
        for (var Zt = Me.indexOf(Ee, ke), Et = Me.indexOf(Ge, ke), Ke = new RegExp(L(ze) + L(be), "g"), $e = Me.indexOf(be, ke); ; )
          if (Me[ke] === be)
            for ($e = ke, ke++; ; ) {
              if (($e = Me.indexOf(be, $e + 1)) === -1)
                return Se || an.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: Yt.length, index: ke }), Cn();
              if ($e === xt - 1)
                return Cn(Me.substring(ke, $e).replace(Ke, be));
              if (be === ze && Me[$e + 1] === ze)
                $e++;
              else if (be === ze || $e === 0 || Me[$e - 1] !== ze) {
                Zt !== -1 && Zt < $e + 1 && (Zt = Me.indexOf(Ee, $e + 1));
                var pt = In((Et = Et !== -1 && Et < $e + 1 ? Me.indexOf(Ge, $e + 1) : Et) === -1 ? Zt : Math.min(Zt, Et));
                if (Me.substr($e + 1 + pt, Ht) === Ee) {
                  Ct.push(Me.substring(ke, $e).replace(Ke, be)), Me[ke = $e + 1 + pt + Ht] !== be && ($e = Me.indexOf(be, ke)), Zt = Me.indexOf(Ee, ke), Et = Me.indexOf(Ge, ke);
                  break;
                }
                if (pt = In(Et), Me.substring($e + 1 + pt, $e + 1 + pt + Bt) === Ge) {
                  if (Ct.push(Me.substring(ke, $e).replace(Ke, be)), It($e + 1 + pt + Bt), Zt = Me.indexOf(Ee, ke), $e = Me.indexOf(be, ke), Tt && (Wt(), Be))
                    return ht();
                  if (ae && Yt.length >= ae)
                    return ht(!0);
                  break;
                }
                an.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: Yt.length, index: ke }), $e++;
              }
            }
          else if (ve && Ct.length === 0 && Me.substring(ke, ke + ut) === ve) {
            if (Et === -1)
              return ht();
            ke = Et + Bt, Et = Me.indexOf(Ge, ke), Zt = Me.indexOf(Ee, ke);
          } else if (Zt !== -1 && (Zt < Et || Et === -1))
            Ct.push(Me.substring(ke, Zt)), ke = Zt + Ht, Zt = Me.indexOf(Ee, ke);
          else {
            if (Et === -1)
              break;
            if (Ct.push(Me.substring(ke, Et)), It(Et + Bt), Tt && (Wt(), Be))
              return ht();
            if (ae && Yt.length >= ae)
              return ht(!0);
          }
        return Cn();
        function Jt(hn) {
          Yt.push(hn), st = ke;
        }
        function In(hn) {
          var Vt = 0;
          return Vt = hn !== -1 && (hn = Me.substring($e + 1, hn)) && hn.trim() === "" ? hn.length : Vt;
        }
        function Cn(hn) {
          return Se || (hn === void 0 && (hn = Me.substring(ke)), Ct.push(hn), ke = xt, Jt(Ct), Tt && Wt()), ht();
        }
        function It(hn) {
          ke = hn, Jt(Ct), Ct = [], Et = Me.indexOf(Ge, ke);
        }
        function ht(hn) {
          if (Fe.header && !me && Yt.length && !De) {
            var Vt = Yt[0], Tn = /* @__PURE__ */ Object.create(null), Rn = new Set(Vt);
            let Nn = !1;
            for (let Dn = 0; Dn < Vt.length; Dn++) {
              let xn = Vt[Dn];
              if (Tn[xn = Le(Fe.transformHeader) ? Fe.transformHeader(xn, Dn) : xn]) {
                let $n, Kn = Tn[xn];
                for (; $n = xn + "_" + Kn, Kn++, Rn.has($n); )
                  ;
                Rn.add($n), Vt[Dn] = $n, Tn[xn]++, Nn = !0, (Te = Te === null ? {} : Te)[$n] = xn;
              } else
                Tn[xn] = 1, Vt[Dn] = xn;
              Rn.add(xn);
            }
            Nn && console.warn("Duplicate headers found and renamed."), De = !0;
          }
          return { data: Yt, errors: an, meta: { delimiter: Ee, linebreak: Ge, aborted: Be, truncated: !!hn, cursor: st + (me || 0), renamedHeaders: Te } };
        }
        function Wt() {
          te(ht()), Yt = [], an = [];
        }
      }, this.abort = function() {
        Be = !0;
      }, this.getCharIndex = function() {
        return ke;
      };
    }
    function W(Fe) {
      var Ee = Fe.data, Ge = c[Ee.workerId], ve = !1;
      if (Ee.error)
        Ge.userError(Ee.error, Ee.file);
      else if (Ee.results && Ee.results.data) {
        var te = { abort: function() {
          ve = !0, G(Ee.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: q, resume: q };
        if (Le(Ge.userStep)) {
          for (var ae = 0; ae < Ee.results.data.length && (Ge.userStep({ data: Ee.results.data[ae], errors: Ee.results.errors, meta: Ee.results.meta }, te), !ve); ae++)
            ;
          delete Ee.results;
        } else
          Le(Ge.userChunk) && (Ge.userChunk(Ee.results, te, Ee.file), delete Ee.results);
      }
      Ee.finished && !ve && G(Ee.workerId, Ee.results);
    }
    function G(Fe, Ee) {
      var Ge = c[Fe];
      Le(Ge.userComplete) && Ge.userComplete(Ee), Ge.terminate(), delete c[Fe];
    }
    function q() {
      throw new Error("Not implemented.");
    }
    function fe(Fe) {
      if (typeof Fe != "object" || Fe === null)
        return Fe;
      var Ee, Ge = Array.isArray(Fe) ? [] : {};
      for (Ee in Fe)
        Ge[Ee] = fe(Fe[Ee]);
      return Ge;
    }
    function _e(Fe, Ee) {
      return function() {
        Fe.apply(Ee, arguments);
      };
    }
    function Le(Fe) {
      return typeof Fe == "function";
    }
    return d.parse = function(Fe, Ee) {
      var Ge = (Ee = Ee || {}).dynamicTyping || !1;
      if (Le(Ge) && (Ee.dynamicTypingFunction = Ge, Ge = {}), Ee.dynamicTyping = Ge, Ee.transform = !!Le(Ee.transform) && Ee.transform, !Ee.worker || !d.WORKERS_SUPPORTED)
        return Ge = null, d.NODE_STREAM_INPUT, typeof Fe == "string" ? (Fe = ((ve) => ve.charCodeAt(0) !== 65279 ? ve : ve.slice(1))(Fe), Ge = new (Ee.download ? h : R)(Ee)) : Fe.readable === !0 && Le(Fe.read) && Le(Fe.on) ? Ge = new _(Ee) : (o.File && Fe instanceof File || Fe instanceof Object) && (Ge = new S(Ee)), Ge.stream(Fe);
      (Ge = (() => {
        var ve;
        return !!d.WORKERS_SUPPORTED && (ve = (() => {
          var te = o.URL || o.webkitURL || null, ae = s.toString();
          return d.BLOB_URL || (d.BLOB_URL = te.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", ae, ")();"], { type: "text/javascript" })));
        })(), (ve = new o.Worker(ve)).onmessage = W, ve.id = E++, c[ve.id] = ve);
      })()).userStep = Ee.step, Ge.userChunk = Ee.chunk, Ge.userComplete = Ee.complete, Ge.userError = Ee.error, Ee.step = Le(Ee.step), Ee.chunk = Le(Ee.chunk), Ee.complete = Le(Ee.complete), Ee.error = Le(Ee.error), delete Ee.worker, Ge.postMessage({ input: Fe, config: Ee, workerId: Ge.id });
    }, d.unparse = function(Fe, Ee) {
      var Ge = !1, ve = !0, te = ",", ae = `\r
`, v = '"', Te = v + v, De = !1, be = null, ze = !1, ke = ((() => {
        if (typeof Ee == "object") {
          if (typeof Ee.delimiter != "string" || d.BAD_DELIMITERS.filter(function(me) {
            return Ee.delimiter.indexOf(me) !== -1;
          }).length || (te = Ee.delimiter), typeof Ee.quotes != "boolean" && typeof Ee.quotes != "function" && !Array.isArray(Ee.quotes) || (Ge = Ee.quotes), typeof Ee.skipEmptyLines != "boolean" && typeof Ee.skipEmptyLines != "string" || (De = Ee.skipEmptyLines), typeof Ee.newline == "string" && (ae = Ee.newline), typeof Ee.quoteChar == "string" && (v = Ee.quoteChar), typeof Ee.header == "boolean" && (ve = Ee.header), Array.isArray(Ee.columns)) {
            if (Ee.columns.length === 0)
              throw new Error("Option columns is empty");
            be = Ee.columns;
          }
          Ee.escapeChar !== void 0 && (Te = Ee.escapeChar + v), Ee.escapeFormulae instanceof RegExp ? ze = Ee.escapeFormulae : typeof Ee.escapeFormulae == "boolean" && Ee.escapeFormulae && (ze = /^[=+\-@\t\r].*$/);
        }
      })(), new RegExp(L(v), "g"));
      if (typeof Fe == "string" && (Fe = JSON.parse(Fe)), Array.isArray(Fe)) {
        if (!Fe.length || Array.isArray(Fe[0]))
          return Be(null, Fe, De);
        if (typeof Fe[0] == "object")
          return Be(be || Object.keys(Fe[0]), Fe, De);
      } else if (typeof Fe == "object")
        return typeof Fe.data == "string" && (Fe.data = JSON.parse(Fe.data)), Array.isArray(Fe.data) && (Fe.fields || (Fe.fields = Fe.meta && Fe.meta.fields || be), Fe.fields || (Fe.fields = Array.isArray(Fe.data[0]) ? Fe.fields : typeof Fe.data[0] == "object" ? Object.keys(Fe.data[0]) : []), Array.isArray(Fe.data[0]) || typeof Fe.data[0] == "object" || (Fe.data = [Fe.data])), Be(Fe.fields || [], Fe.data || [], De);
      throw new Error("Unable to serialize unrecognized input");
      function Be(me, Se, xt) {
        var Ht = "", Bt = (typeof me == "string" && (me = JSON.parse(me)), typeof Se == "string" && (Se = JSON.parse(Se)), Array.isArray(me) && 0 < me.length), ut = !Array.isArray(Se[0]);
        if (Bt && ve) {
          for (var Tt = 0; Tt < me.length; Tt++)
            0 < Tt && (Ht += te), Ht += Me(me[Tt], Tt);
          0 < Se.length && (Ht += ae);
        }
        for (var Yt = 0; Yt < Se.length; Yt++) {
          var an = (Bt ? me : Se[Yt]).length, Ct = !1, st = Bt ? Object.keys(Se[Yt]).length === 0 : Se[Yt].length === 0;
          if (xt && !Bt && (Ct = xt === "greedy" ? Se[Yt].join("").trim() === "" : Se[Yt].length === 1 && Se[Yt][0].length === 0), xt === "greedy" && Bt) {
            for (var jt = [], lt = 0; lt < an; lt++) {
              var Zt = ut ? me[lt] : lt;
              jt.push(Se[Yt][Zt]);
            }
            Ct = jt.join("").trim() === "";
          }
          if (!Ct) {
            for (var Et = 0; Et < an; Et++) {
              0 < Et && !st && (Ht += te);
              var Ke = Bt && ut ? me[Et] : Et;
              Ht += Me(Se[Yt][Ke], Et);
            }
            Yt < Se.length - 1 && (!xt || 0 < an && !st) && (Ht += ae);
          }
        }
        return Ht;
      }
      function Me(me, Se) {
        var xt, Ht;
        return me == null ? "" : me.constructor === Date ? JSON.stringify(me).slice(1, 25) : (Ht = !1, ze && typeof me == "string" && ze.test(me) && (me = "'" + me, Ht = !0), xt = me.toString().replace(ke, Te), (Ht = Ht || Ge === !0 || typeof Ge == "function" && Ge(me, Se) || Array.isArray(Ge) && Ge[Se] || ((Bt, ut) => {
          for (var Tt = 0; Tt < ut.length; Tt++)
            if (-1 < Bt.indexOf(ut[Tt]))
              return !0;
          return !1;
        })(xt, d.BAD_DELIMITERS) || -1 < xt.indexOf(te) || xt.charAt(0) === " " || xt.charAt(xt.length - 1) === " ") ? v + xt + v : xt);
      }
    }, d.RECORD_SEP = String.fromCharCode(30), d.UNIT_SEP = String.fromCharCode(31), d.BYTE_ORDER_MARK = "\uFEFF", d.BAD_DELIMITERS = ["\r", `
`, '"', d.BYTE_ORDER_MARK], d.WORKERS_SUPPORTED = !l && !!o.Worker, d.NODE_STREAM_INPUT = 1, d.LocalChunkSize = 10485760, d.RemoteChunkSize = 5242880, d.DefaultDelimiter = ",", d.Parser = F, d.ParserHandle = m, d.NetworkStreamer = h, d.FileStreamer = S, d.StringStreamer = R, d.ReadableStreamStreamer = _, o.jQuery && ((a = o.jQuery).fn.parse = function(Fe) {
      var Ee = Fe.config || {}, Ge = [];
      return this.each(function(ae) {
        if (!(a(this).prop("tagName").toUpperCase() === "INPUT" && a(this).attr("type").toLowerCase() === "file" && o.FileReader) || !this.files || this.files.length === 0)
          return !0;
        for (var v = 0; v < this.files.length; v++)
          Ge.push({ file: this.files[v], inputElem: this, instanceConfig: a.extend({}, Ee) });
      }), ve(), this;
      function ve() {
        if (Ge.length === 0)
          Le(Fe.complete) && Fe.complete();
        else {
          var ae, v, Te, De, be = Ge[0];
          if (Le(Fe.before)) {
            var ze = Fe.before(be.file, be.inputElem);
            if (typeof ze == "object") {
              if (ze.action === "abort")
                return ae = "AbortError", v = be.file, Te = be.inputElem, De = ze.reason, void (Le(Fe.error) && Fe.error({ name: ae }, v, Te, De));
              if (ze.action === "skip")
                return void te();
              typeof ze.config == "object" && (be.instanceConfig = a.extend(be.instanceConfig, ze.config));
            } else if (ze === "skip")
              return void te();
          }
          var ke = be.instanceConfig.complete;
          be.instanceConfig.complete = function(Be) {
            Le(ke) && ke(Be, be.file, be.inputElem), te();
          }, d.parse(be.file, be.instanceConfig);
        }
      }
      function te() {
        Ge.splice(0, 1), ve();
      }
    }), u && (o.onmessage = function(Fe) {
      Fe = Fe.data, d.WORKER_ID === void 0 && Fe && (d.WORKER_ID = Fe.workerId), typeof Fe.input == "string" ? o.postMessage({ workerId: d.WORKER_ID, results: d.parse(Fe.input, Fe.config), finished: !0 }) : (o.File && Fe.input instanceof File || Fe.input instanceof Object) && (Fe = d.parse(Fe.input, Fe.config)) && o.postMessage({ workerId: d.WORKER_ID, results: Fe, finished: !0 });
    }), (h.prototype = Object.create(f.prototype)).constructor = h, (S.prototype = Object.create(f.prototype)).constructor = S, (R.prototype = Object.create(R.prototype)).constructor = R, (_.prototype = Object.create(f.prototype)).constructor = _, d;
  });
})(papaparse_min);
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
var geojsonParser = {}, geojsonHelpers = {}, geojson = {};
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 });
  var e;
  (function(R) {
    R[R.Point = 0] = "Point", R[R.LineString = 1] = "LineString", R[R.Polygon = 2] = "Polygon", R[R.PolygonWithHole = 3] = "PolygonWithHole", R[R.MultiPoint = 4] = "MultiPoint", R[R.MultiLineString = 5] = "MultiLineString", R[R.MultiPolygon = 6] = "MultiPolygon";
  })(e = r.GeometryType || (r.GeometryType = {}));
  class s {
    constructor(_, m) {
      this.lat = m, this.lng = _;
    }
  }
  r.Coordinate = s;
  class o {
    constructor() {
      this.geometries = new Array(), this.metadata = new Array();
    }
  }
  r.FeatureCollection = o;
  class a {
    constructor(_, m) {
      this.key = _, this.value = m;
    }
  }
  r.FeatureProperty = a;
  class l {
    constructor(_, m) {
      this.id = "", this.featureProperties = new Array(), this.type = _, this.id = m;
    }
  }
  r.Geometry = l;
  class u extends l {
    constructor(_, m = "") {
      super(e.Point, m), this.coordinate = _;
    }
  }
  r.Point = u;
  class c extends l {
    constructor(_ = "") {
      super(e.LineString, _), this.coordinates = new Array();
    }
  }
  r.LineString = c;
  class E extends l {
    constructor(_ = "", m = e.Polygon) {
      super(m, _), this.coordinates = new Array();
    }
  }
  r.Polygon = E;
  class d extends E {
    constructor(_ = "") {
      super(_, e.PolygonWithHole), this.holes = new Array();
    }
  }
  r.PolygonWithHole = d;
  class f extends l {
    constructor(_ = "") {
      super(e.MultiPoint, _), this.points = new Array();
    }
  }
  r.MultiPoint = f;
  class h extends l {
    constructor(_ = "") {
      super(e.MultiLineString, _), this.LinesString = new Array();
    }
  }
  r.MultiLineString = h;
  class S extends l {
    constructor(_ = "") {
      super(e.MultiPolygon, _), this.polygons = new Array();
    }
  }
  r.MultiPolygon = S;
})(geojson);
Object.defineProperty(geojsonHelpers, "__esModule", { value: !0 });
const geojson_1 = geojson, geojson_2 = geojson, geojson_3 = geojson, geojson_4 = geojson;
class GeojsonHelpers {
  static isValid(e) {
    return !!(e.type && (e.type.toLowerCase() == "featurecollection" || e.type.toLowerCase() == "feature") && (e.type.toLowerCase() == "featurecollection" && e.features && e.features instanceof Array || e.type.toLowerCase() == "feature" && e.geometry && e.geometry.type && e.geometry.coordinates));
  }
  //Start of methods for creating geojson object from FeatureCollection instance
  static create(e) {
    try {
      let s = {};
      return s.type = "FeatureCollection", s.features = new Array(), e && (e.metadata && e.metadata.length > 0 && (s.metadata = {}, e.metadata.forEach((o) => {
        s.metadata[o.key] = o.value;
      })), e.geometries && e.geometries.length > 0 && e.geometries.forEach((o) => {
        let a = {};
        a.type = "Feature", o.id && o.id != "" && (a.id = o.id), a.properties = {}, o.featureProperties && o.featureProperties.length > 0 && o.featureProperties.forEach((l) => {
          a.properties[l.key] = l.value;
        }), a.geometry = {}, a.geometry.type = GeojsonHelpers.GetGeojsonFeatureType(o.type), a.geometry.coordinates = GeojsonHelpers.GetGeojsonGeometryCoordinates(o), s.features.push(a);
      })), s;
    } catch (s) {
      throw s;
    }
  }
  static GetGeojsonFeatureType(e) {
    switch (e) {
      case geojson_2.GeometryType.Point:
        return "Point";
      case geojson_2.GeometryType.LineString:
        return "LineString";
      case geojson_2.GeometryType.Polygon:
        return "Polygon";
      case geojson_2.GeometryType.PolygonWithHole:
        return "Polygon";
      case geojson_2.GeometryType.MultiPoint:
        return "MultiPoint";
      case geojson_2.GeometryType.MultiLineString:
        return "MultiLineString";
      case geojson_2.GeometryType.MultiPolygon:
        return "MultiPolygon";
    }
  }
  static GetGeojsonGeometryCoordinates(e) {
    let s = new Array();
    try {
      switch (e.type) {
        case geojson_2.GeometryType.Point:
          let o = e;
          o.coordinate && (s.push(o.coordinate.lat), s.push(o.coordinate.lng));
          break;
        case geojson_2.GeometryType.LineString:
          let a = e;
          a.coordinates && a.coordinates.forEach((f) => {
            let h = new Array();
            h.push(f.lat), h.push(f.lng), s.push(h);
          });
          break;
        case geojson_2.GeometryType.Polygon:
          let l = e;
          l.coordinates && (s = GeojsonHelpers.getPolygonCoordinate(l));
          break;
        case geojson_2.GeometryType.PolygonWithHole:
          let u = e;
          u.coordinates && (s = GeojsonHelpers.getPolygonWithHoleCoordinate(u));
          break;
        case geojson_2.GeometryType.MultiPoint:
          let c = e;
          c.points && c.points.forEach((f) => {
            let h = new Array();
            f.coordinate && (h.push(f.coordinate.lat), h.push(f.coordinate.lng)), s.push(h);
          });
          break;
        case geojson_2.GeometryType.MultiLineString:
          let E = e;
          E.LinesString && E.LinesString.length > 0 && E.LinesString.forEach((f) => {
            let h = new Array();
            f.coordinates.forEach((S) => {
              let R = new Array();
              R.push(S.lat), R.push(S.lng), h.push(R);
            }), s.push(h);
          });
          break;
        case geojson_2.GeometryType.MultiPolygon:
          let d = e;
          d.polygons && d.polygons.length > 0 && d.polygons.forEach((f) => {
            f instanceof geojson_2.PolygonWithHole ? s.push(GeojsonHelpers.getPolygonWithHoleCoordinate(f)) : s.push(GeojsonHelpers.getPolygonCoordinate(f));
          });
          break;
      }
    } catch (o) {
      throw o;
    }
    return s;
  }
  static getPolygonCoordinate(e) {
    try {
      let s = new Array();
      if (e.coordinates) {
        let o = new Array();
        return e.coordinates.forEach((a) => {
          let l = new Array();
          l.push(a.lat), l.push(a.lng), o.push(l);
        }), s.push(o), s;
      } else
        throw new SyntaxError("Coordinates can't be null for the polygon geometry.");
    } catch (s) {
      throw s;
    }
  }
  static getPolygonWithHoleCoordinate(e) {
    try {
      let s = new Array();
      if (e.coordinates) {
        let o = new Array();
        return e.coordinates.forEach((a) => {
          let l = new Array();
          l.push(a.lat), l.push(a.lng), o.push(l);
        }), s.push(o), e.holes && e.holes.length > 0 && e.holes.forEach((a) => {
          o = new Array(), a.coordinates.forEach((l) => {
            let u = new Array();
            u.push(l.lat), u.push(l.lng), o.push(u);
          }), s.push(o);
        }), s;
      } else
        throw new SyntaxError("Coordinates can't be null for the polygon geometry.");
    } catch (s) {
      throw s;
    }
  }
  //End of methods for creating geojson geojson object from FeatureCollection instance
  //Start of methods for reading geometries from geojson object
  static parse(e) {
    try {
      if (!GeojsonHelpers.isValid(e))
        throw new SyntaxError("geoJson string is not valid.");
      let s = new geojson_1.FeatureCollection(), o;
      e.features ? o = e.features : (o = new Array(), o.push(e)), o.length > 0 && o.forEach((l) => {
        let u = GeojsonHelpers.parseFeature(l);
        u && s.geometries.push(u);
      });
      let a = GeojsonHelpers.getProperties(e.metadata);
      return a && a.length > 0 && a.forEach((l) => {
        s.metadata.push(l);
      }), s;
    } catch (s) {
      throw s;
    }
  }
  static parseFeature(e) {
    let s, o;
    try {
      if (e.type.toLowerCase() == "feature" && e.geometry)
        o = e.geometry, e.geometry.id = e.id;
      else
        throw new SyntaxError("geoJson string is not valid.");
      switch (o.type.toLowerCase()) {
        case "point":
          s = GeojsonHelpers.getPoint(o);
          break;
        case "linestring":
          s = GeojsonHelpers.getLineString(o);
          break;
        case "polygon":
          s = GeojsonHelpers.getPolygon(o);
          break;
        case "multipoint":
          s = GeojsonHelpers.getMultiPoint(o);
          break;
        case "multilinestring":
          s = GeojsonHelpers.getMultiLineString(o);
          break;
        case "multipolygon":
          s = GeojsonHelpers.getMultiPolygon(o);
          break;
        default:
          throw new SyntaxError("Feature type '" + o.type + "' is not supported.");
      }
      let a = GeojsonHelpers.getProperties(e.properties);
      a && a.length > 0 && a.forEach((l) => {
        s.featureProperties.push(l);
      });
    } catch (a) {
      throw a;
    }
    return s;
  }
  static getProperties(e) {
    try {
      let s = new Array();
      if (e) {
        let o = Object.keys(e);
        o != null && o.length > 0 && o.forEach((a) => {
          s.push(new geojson_3.FeatureProperty(a, e[a]));
        });
      }
      return s;
    } catch (s) {
      throw s;
    }
  }
  static getPoint(e) {
    let s = GeojsonHelpers.getCoordinate(e.coordinates);
    return new geojson_2.Point(s, e.id);
  }
  static getMultiPoint(e) {
    let s = new geojson_2.MultiPoint(e.id), o = GeojsonHelpers.getCoordinates(e.coordinates);
    return o && o.length > 0 && o.forEach((a) => {
      s.points.push(new geojson_2.Point(a));
    }), s;
  }
  static getLineString(e) {
    let s = new geojson_2.LineString(e.id), o = GeojsonHelpers.getCoordinates(e.coordinates);
    return o && o.length > 0 && o.forEach((a) => {
      s.coordinates.push(a);
    }), s;
  }
  static getMultiLineString(e) {
    let s = new geojson_2.MultiLineString(e.id), o = e.coordinates;
    if (o && o.length > 0)
      return o.forEach((a) => {
        let l = new geojson_2.LineString(), u = GeojsonHelpers.getCoordinates(a);
        u && u.length > 0 && u.forEach((c) => {
          l.coordinates.push(c);
        }), s.LinesString.push(l);
      }), s;
    throw new SyntaxError("Coordinate value is invalid");
  }
  static getPolygon(e) {
    let s = e.coordinates;
    if (s.length > 1) {
      let o = new geojson_2.PolygonWithHole(), a = GeojsonHelpers.getCoordinates(s[0]);
      a && a.length > 0 && a.forEach((l) => {
        o.coordinates.push(l);
      });
      for (let l = 1; l < s.length; l++) {
        let u = new geojson_2.Polygon(), c = GeojsonHelpers.getCoordinates(s[l]);
        c && c.length > 0 && c.forEach((E) => {
          u.coordinates.push(E);
        }), o.holes.push(u);
      }
      return o;
    } else if (s.length == 1) {
      let o = new geojson_2.Polygon(), a = GeojsonHelpers.getCoordinates(s[0]);
      return a && a.length > 0 && a.forEach((l) => {
        o.coordinates.push(l);
      }), o;
    } else
      throw new SyntaxError("Coordinate value is invalid");
  }
  static getMultiPolygon(e) {
    let s = new geojson_2.MultiPolygon(e.id);
    return e.coordinates && e.coordinates.length > 0 && e.coordinates.forEach((a) => {
      if (a.length == 1)
        a.forEach((l) => {
          if (l.length > 1) {
            let u = GeojsonHelpers.getCoordinates(l);
            if (u && u.length > 0) {
              let c = new geojson_2.Polygon();
              u.forEach((E) => {
                c.coordinates.push(E);
              }), s.polygons.push(c);
            }
          }
        });
      else if (a.length > 1) {
        let l = new geojson_2.PolygonWithHole(), u = GeojsonHelpers.getCoordinates(a[0]);
        u && u.length > 0 && u.forEach((c) => {
          l.coordinates.push(c);
        });
        for (let c = 1; c < a.length; c++) {
          let E = GeojsonHelpers.getCoordinates(a[c]);
          if (E && E.length > 0) {
            let d = new geojson_2.Polygon();
            E.forEach((f) => {
              d.coordinates.push(f);
            }), l.holes.push(d);
          }
        }
        s.polygons.push(l);
      }
    }), s;
  }
  static getCoordinates(e) {
    let s = new Array();
    return e && e.length > 0 && e.forEach((o) => {
      s.push(GeojsonHelpers.getCoordinate(o));
    }), s;
  }
  static getCoordinate(e) {
    if (e && e.length >= 2)
      return new geojson_4.Coordinate(e[0], e[1]);
    throw new SyntaxError("Coordinate value is invalid");
  }
}
geojsonHelpers.GeojsonHelpers = GeojsonHelpers;
Object.defineProperty(geojsonParser, "__esModule", { value: !0 });
const geojson_helpers_1 = geojsonHelpers;
class Geojson extends geojson_helpers_1.GeojsonHelpers {
  /**
  * @Method: Parse geometries from the json string.
  * @Param {string}
  * @Return {FeatureCollection}
  */
  static parse(e) {
    try {
      if (!e || e == "")
        throw new SyntaxError("jsonString can't be null or empty.");
      let s = JSON.parse(e);
      return geojson_helpers_1.GeojsonHelpers.parse(s);
    } catch (s) {
      throw s;
    }
  }
  /**
  * @Method: Validate whether the geojon string is valid or not.
  * @Param {string}
  * @Return {boolean}
  */
  static isValid(e) {
    try {
      if (!e || e == "")
        return !1;
      let s = JSON.parse(e);
      return !!geojson_helpers_1.GeojsonHelpers.parse(s);
    } catch {
      return !1;
    }
  }
  /**
  * @Method: create a geojson string from the FeatureCollection instance.
  * @Param {FeatureCollection}
  * @Return {string}
  */
  static create(e) {
    try {
      if (e) {
        let s = geojson_helpers_1.GeojsonHelpers.create(e);
        return JSON.stringify(s);
      } else
        throw new SyntaxError("FeatureCollection instance can't be null.");
    } catch (s) {
      throw s;
    }
  }
}
geojsonParser.Geojson = Geojson;
globalThis && globalThis.__awaiter;
function commonjsRequire(r) {
  throw new Error('Could not dynamically require "' + r + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var jszip_min = { exports: {} };
(function(r, e) {
  (function(s) {
    r.exports = s();
  })(function() {
    return function s(o, a, l) {
      function u(d, f) {
        if (!a[d]) {
          if (!o[d]) {
            var h = typeof commonjsRequire == "function" && commonjsRequire;
            if (!f && h)
              return h(d, !0);
            if (c)
              return c(d, !0);
            var S = new Error("Cannot find module '" + d + "'");
            throw S.code = "MODULE_NOT_FOUND", S;
          }
          var R = a[d] = { exports: {} };
          o[d][0].call(R.exports, function(_) {
            var m = o[d][1][_];
            return u(m || _);
          }, R, R.exports, s, o, a, l);
        }
        return a[d].exports;
      }
      for (var c = typeof commonjsRequire == "function" && commonjsRequire, E = 0; E < l.length; E++)
        u(l[E]);
      return u;
    }({ 1: [function(s, o, a) {
      var l = s("./utils"), u = s("./support"), c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      a.encode = function(E) {
        for (var d, f, h, S, R, _, m, L = [], F = 0, W = E.length, G = W, q = l.getTypeOf(E) !== "string"; F < E.length; )
          G = W - F, h = q ? (d = E[F++], f = F < W ? E[F++] : 0, F < W ? E[F++] : 0) : (d = E.charCodeAt(F++), f = F < W ? E.charCodeAt(F++) : 0, F < W ? E.charCodeAt(F++) : 0), S = d >> 2, R = (3 & d) << 4 | f >> 4, _ = 1 < G ? (15 & f) << 2 | h >> 6 : 64, m = 2 < G ? 63 & h : 64, L.push(c.charAt(S) + c.charAt(R) + c.charAt(_) + c.charAt(m));
        return L.join("");
      }, a.decode = function(E) {
        var d, f, h, S, R, _, m = 0, L = 0, F = "data:";
        if (E.substr(0, F.length) === F)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var W, G = 3 * (E = E.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (E.charAt(E.length - 1) === c.charAt(64) && G--, E.charAt(E.length - 2) === c.charAt(64) && G--, G % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (W = u.uint8array ? new Uint8Array(0 | G) : new Array(0 | G); m < E.length; )
          d = c.indexOf(E.charAt(m++)) << 2 | (S = c.indexOf(E.charAt(m++))) >> 4, f = (15 & S) << 4 | (R = c.indexOf(E.charAt(m++))) >> 2, h = (3 & R) << 6 | (_ = c.indexOf(E.charAt(m++))), W[L++] = d, R !== 64 && (W[L++] = f), _ !== 64 && (W[L++] = h);
        return W;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(s, o, a) {
      var l = s("./external"), u = s("./stream/DataWorker"), c = s("./stream/Crc32Probe"), E = s("./stream/DataLengthProbe");
      function d(f, h, S, R, _) {
        this.compressedSize = f, this.uncompressedSize = h, this.crc32 = S, this.compression = R, this.compressedContent = _;
      }
      d.prototype = { getContentWorker: function() {
        var f = new u(l.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new E("data_length")), h = this;
        return f.on("end", function() {
          if (this.streamInfo.data_length !== h.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), f;
      }, getCompressedWorker: function() {
        return new u(l.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, d.createWorkerFrom = function(f, h, S) {
        return f.pipe(new c()).pipe(new E("uncompressedSize")).pipe(h.compressWorker(S)).pipe(new E("compressedSize")).withStreamInfo("compression", h);
      }, o.exports = d;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(s, o, a) {
      var l = s("./stream/GenericWorker");
      a.STORE = { magic: "\0\0", compressWorker: function() {
        return new l("STORE compression");
      }, uncompressWorker: function() {
        return new l("STORE decompression");
      } }, a.DEFLATE = s("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(s, o, a) {
      var l = s("./utils"), u = function() {
        for (var c, E = [], d = 0; d < 256; d++) {
          c = d;
          for (var f = 0; f < 8; f++)
            c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
          E[d] = c;
        }
        return E;
      }();
      o.exports = function(c, E) {
        return c !== void 0 && c.length ? l.getTypeOf(c) !== "string" ? function(d, f, h, S) {
          var R = u, _ = S + h;
          d ^= -1;
          for (var m = S; m < _; m++)
            d = d >>> 8 ^ R[255 & (d ^ f[m])];
          return -1 ^ d;
        }(0 | E, c, c.length, 0) : function(d, f, h, S) {
          var R = u, _ = S + h;
          d ^= -1;
          for (var m = S; m < _; m++)
            d = d >>> 8 ^ R[255 & (d ^ f.charCodeAt(m))];
          return -1 ^ d;
        }(0 | E, c, c.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(s, o, a) {
      a.base64 = !1, a.binary = !1, a.dir = !1, a.createFolders = !0, a.date = null, a.compression = null, a.compressionOptions = null, a.comment = null, a.unixPermissions = null, a.dosPermissions = null;
    }, {}], 6: [function(s, o, a) {
      var l = null;
      l = typeof Promise < "u" ? Promise : s("lie"), o.exports = { Promise: l };
    }, { lie: 37 }], 7: [function(s, o, a) {
      var l = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", u = s("pako"), c = s("./utils"), E = s("./stream/GenericWorker"), d = l ? "uint8array" : "array";
      function f(h, S) {
        E.call(this, "FlateWorker/" + h), this._pako = null, this._pakoAction = h, this._pakoOptions = S, this.meta = {};
      }
      a.magic = "\b\0", c.inherits(f, E), f.prototype.processChunk = function(h) {
        this.meta = h.meta, this._pako === null && this._createPako(), this._pako.push(c.transformTo(d, h.data), !1);
      }, f.prototype.flush = function() {
        E.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, f.prototype.cleanUp = function() {
        E.prototype.cleanUp.call(this), this._pako = null;
      }, f.prototype._createPako = function() {
        this._pako = new u[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var h = this;
        this._pako.onData = function(S) {
          h.push({ data: S, meta: h.meta });
        };
      }, a.compressWorker = function(h) {
        return new f("Deflate", h);
      }, a.uncompressWorker = function() {
        return new f("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(s, o, a) {
      function l(R, _) {
        var m, L = "";
        for (m = 0; m < _; m++)
          L += String.fromCharCode(255 & R), R >>>= 8;
        return L;
      }
      function u(R, _, m, L, F, W) {
        var G, q, fe = R.file, _e = R.compression, Le = W !== d.utf8encode, Fe = c.transformTo("string", W(fe.name)), Ee = c.transformTo("string", d.utf8encode(fe.name)), Ge = fe.comment, ve = c.transformTo("string", W(Ge)), te = c.transformTo("string", d.utf8encode(Ge)), ae = Ee.length !== fe.name.length, v = te.length !== Ge.length, Te = "", De = "", be = "", ze = fe.dir, ke = fe.date, Be = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        _ && !m || (Be.crc32 = R.crc32, Be.compressedSize = R.compressedSize, Be.uncompressedSize = R.uncompressedSize);
        var Me = 0;
        _ && (Me |= 8), Le || !ae && !v || (Me |= 2048);
        var me = 0, Se = 0;
        ze && (me |= 16), F === "UNIX" ? (Se = 798, me |= function(Ht, Bt) {
          var ut = Ht;
          return Ht || (ut = Bt ? 16893 : 33204), (65535 & ut) << 16;
        }(fe.unixPermissions, ze)) : (Se = 20, me |= function(Ht) {
          return 63 & (Ht || 0);
        }(fe.dosPermissions)), G = ke.getUTCHours(), G <<= 6, G |= ke.getUTCMinutes(), G <<= 5, G |= ke.getUTCSeconds() / 2, q = ke.getUTCFullYear() - 1980, q <<= 4, q |= ke.getUTCMonth() + 1, q <<= 5, q |= ke.getUTCDate(), ae && (De = l(1, 1) + l(f(Fe), 4) + Ee, Te += "up" + l(De.length, 2) + De), v && (be = l(1, 1) + l(f(ve), 4) + te, Te += "uc" + l(be.length, 2) + be);
        var xt = "";
        return xt += `
\0`, xt += l(Me, 2), xt += _e.magic, xt += l(G, 2), xt += l(q, 2), xt += l(Be.crc32, 4), xt += l(Be.compressedSize, 4), xt += l(Be.uncompressedSize, 4), xt += l(Fe.length, 2), xt += l(Te.length, 2), { fileRecord: h.LOCAL_FILE_HEADER + xt + Fe + Te, dirRecord: h.CENTRAL_FILE_HEADER + l(Se, 2) + xt + l(ve.length, 2) + "\0\0\0\0" + l(me, 4) + l(L, 4) + Fe + Te + ve };
      }
      var c = s("../utils"), E = s("../stream/GenericWorker"), d = s("../utf8"), f = s("../crc32"), h = s("../signature");
      function S(R, _, m, L) {
        E.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = _, this.zipPlatform = m, this.encodeFileName = L, this.streamFiles = R, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      c.inherits(S, E), S.prototype.push = function(R) {
        var _ = R.meta.percent || 0, m = this.entriesCount, L = this._sources.length;
        this.accumulate ? this.contentBuffer.push(R) : (this.bytesWritten += R.data.length, E.prototype.push.call(this, { data: R.data, meta: { currentFile: this.currentFile, percent: m ? (_ + 100 * (m - L - 1)) / m : 100 } }));
      }, S.prototype.openedSource = function(R) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = R.file.name;
        var _ = this.streamFiles && !R.file.dir;
        if (_) {
          var m = u(R, _, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: m.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, S.prototype.closedSource = function(R) {
        this.accumulate = !1;
        var _ = this.streamFiles && !R.file.dir, m = u(R, _, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(m.dirRecord), _)
          this.push({ data: function(L) {
            return h.DATA_DESCRIPTOR + l(L.crc32, 4) + l(L.compressedSize, 4) + l(L.uncompressedSize, 4);
          }(R), meta: { percent: 100 } });
        else
          for (this.push({ data: m.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, S.prototype.flush = function() {
        for (var R = this.bytesWritten, _ = 0; _ < this.dirRecords.length; _++)
          this.push({ data: this.dirRecords[_], meta: { percent: 100 } });
        var m = this.bytesWritten - R, L = function(F, W, G, q, fe) {
          var _e = c.transformTo("string", fe(q));
          return h.CENTRAL_DIRECTORY_END + "\0\0\0\0" + l(F, 2) + l(F, 2) + l(W, 4) + l(G, 4) + l(_e.length, 2) + _e;
        }(this.dirRecords.length, m, R, this.zipComment, this.encodeFileName);
        this.push({ data: L, meta: { percent: 100 } });
      }, S.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, S.prototype.registerPrevious = function(R) {
        this._sources.push(R);
        var _ = this;
        return R.on("data", function(m) {
          _.processChunk(m);
        }), R.on("end", function() {
          _.closedSource(_.previous.streamInfo), _._sources.length ? _.prepareNextSource() : _.end();
        }), R.on("error", function(m) {
          _.error(m);
        }), this;
      }, S.prototype.resume = function() {
        return !!E.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, S.prototype.error = function(R) {
        var _ = this._sources;
        if (!E.prototype.error.call(this, R))
          return !1;
        for (var m = 0; m < _.length; m++)
          try {
            _[m].error(R);
          } catch {
          }
        return !0;
      }, S.prototype.lock = function() {
        E.prototype.lock.call(this);
        for (var R = this._sources, _ = 0; _ < R.length; _++)
          R[_].lock();
      }, o.exports = S;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(s, o, a) {
      var l = s("../compressions"), u = s("./ZipFileWorker");
      a.generateWorker = function(c, E, d) {
        var f = new u(E.streamFiles, d, E.platform, E.encodeFileName), h = 0;
        try {
          c.forEach(function(S, R) {
            h++;
            var _ = function(W, G) {
              var q = W || G, fe = l[q];
              if (!fe)
                throw new Error(q + " is not a valid compression method !");
              return fe;
            }(R.options.compression, E.compression), m = R.options.compressionOptions || E.compressionOptions || {}, L = R.dir, F = R.date;
            R._compressWorker(_, m).withStreamInfo("file", { name: S, dir: L, date: F, comment: R.comment || "", unixPermissions: R.unixPermissions, dosPermissions: R.dosPermissions }).pipe(f);
          }), f.entriesCount = h;
        } catch (S) {
          f.error(S);
        }
        return f;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(s, o, a) {
      function l() {
        if (!(this instanceof l))
          return new l();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var u = new l();
          for (var c in this)
            typeof this[c] != "function" && (u[c] = this[c]);
          return u;
        };
      }
      (l.prototype = s("./object")).loadAsync = s("./load"), l.support = s("./support"), l.defaults = s("./defaults"), l.version = "3.10.1", l.loadAsync = function(u, c) {
        return new l().loadAsync(u, c);
      }, l.external = s("./external"), o.exports = l;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(s, o, a) {
      var l = s("./utils"), u = s("./external"), c = s("./utf8"), E = s("./zipEntries"), d = s("./stream/Crc32Probe"), f = s("./nodejsUtils");
      function h(S) {
        return new u.Promise(function(R, _) {
          var m = S.decompressed.getContentWorker().pipe(new d());
          m.on("error", function(L) {
            _(L);
          }).on("end", function() {
            m.streamInfo.crc32 !== S.decompressed.crc32 ? _(new Error("Corrupted zip : CRC32 mismatch")) : R();
          }).resume();
        });
      }
      o.exports = function(S, R) {
        var _ = this;
        return R = l.extend(R || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: c.utf8decode }), f.isNode && f.isStream(S) ? u.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : l.prepareContent("the loaded zip file", S, !0, R.optimizedBinaryString, R.base64).then(function(m) {
          var L = new E(R);
          return L.load(m), L;
        }).then(function(m) {
          var L = [u.Promise.resolve(m)], F = m.files;
          if (R.checkCRC32)
            for (var W = 0; W < F.length; W++)
              L.push(h(F[W]));
          return u.Promise.all(L);
        }).then(function(m) {
          for (var L = m.shift(), F = L.files, W = 0; W < F.length; W++) {
            var G = F[W], q = G.fileNameStr, fe = l.resolve(G.fileNameStr);
            _.file(fe, G.decompressed, { binary: !0, optimizedBinaryString: !0, date: G.date, dir: G.dir, comment: G.fileCommentStr.length ? G.fileCommentStr : null, unixPermissions: G.unixPermissions, dosPermissions: G.dosPermissions, createFolders: R.createFolders }), G.dir || (_.file(fe).unsafeOriginalName = q);
          }
          return L.zipComment.length && (_.comment = L.zipComment), _;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(s, o, a) {
      var l = s("../utils"), u = s("../stream/GenericWorker");
      function c(E, d) {
        u.call(this, "Nodejs stream input adapter for " + E), this._upstreamEnded = !1, this._bindStream(d);
      }
      l.inherits(c, u), c.prototype._bindStream = function(E) {
        var d = this;
        (this._stream = E).pause(), E.on("data", function(f) {
          d.push({ data: f, meta: { percent: 0 } });
        }).on("error", function(f) {
          d.isPaused ? this.generatedError = f : d.error(f);
        }).on("end", function() {
          d.isPaused ? d._upstreamEnded = !0 : d.end();
        });
      }, c.prototype.pause = function() {
        return !!u.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, c.prototype.resume = function() {
        return !!u.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, o.exports = c;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(s, o, a) {
      var l = s("readable-stream").Readable;
      function u(c, E, d) {
        l.call(this, E), this._helper = c;
        var f = this;
        c.on("data", function(h, S) {
          f.push(h) || f._helper.pause(), d && d(S);
        }).on("error", function(h) {
          f.emit("error", h);
        }).on("end", function() {
          f.push(null);
        });
      }
      s("../utils").inherits(u, l), u.prototype._read = function() {
        this._helper.resume();
      }, o.exports = u;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(s, o, a) {
      o.exports = { isNode: typeof buffer$1.Buffer < "u", newBufferFrom: function(l, u) {
        if (buffer$1.Buffer.from && buffer$1.Buffer.from !== Uint8Array.from)
          return buffer$1.Buffer.from(l, u);
        if (typeof l == "number")
          throw new Error('The "data" argument must not be a number');
        return new buffer$1.Buffer(l, u);
      }, allocBuffer: function(l) {
        if (buffer$1.Buffer.alloc)
          return buffer$1.Buffer.alloc(l);
        var u = new buffer$1.Buffer(l);
        return u.fill(0), u;
      }, isBuffer: function(l) {
        return buffer$1.Buffer.isBuffer(l);
      }, isStream: function(l) {
        return l && typeof l.on == "function" && typeof l.pause == "function" && typeof l.resume == "function";
      } };
    }, {}], 15: [function(s, o, a) {
      function l(fe, _e, Le) {
        var Fe, Ee = c.getTypeOf(_e), Ge = c.extend(Le || {}, f);
        Ge.date = Ge.date || /* @__PURE__ */ new Date(), Ge.compression !== null && (Ge.compression = Ge.compression.toUpperCase()), typeof Ge.unixPermissions == "string" && (Ge.unixPermissions = parseInt(Ge.unixPermissions, 8)), Ge.unixPermissions && 16384 & Ge.unixPermissions && (Ge.dir = !0), Ge.dosPermissions && 16 & Ge.dosPermissions && (Ge.dir = !0), Ge.dir && (fe = F(fe)), Ge.createFolders && (Fe = L(fe)) && W.call(this, Fe, !0);
        var ve = Ee === "string" && Ge.binary === !1 && Ge.base64 === !1;
        Le && Le.binary !== void 0 || (Ge.binary = !ve), (_e instanceof h && _e.uncompressedSize === 0 || Ge.dir || !_e || _e.length === 0) && (Ge.base64 = !1, Ge.binary = !0, _e = "", Ge.compression = "STORE", Ee = "string");
        var te = null;
        te = _e instanceof h || _e instanceof E ? _e : _.isNode && _.isStream(_e) ? new m(fe, _e) : c.prepareContent(fe, _e, Ge.binary, Ge.optimizedBinaryString, Ge.base64);
        var ae = new S(fe, te, Ge);
        this.files[fe] = ae;
      }
      var u = s("./utf8"), c = s("./utils"), E = s("./stream/GenericWorker"), d = s("./stream/StreamHelper"), f = s("./defaults"), h = s("./compressedObject"), S = s("./zipObject"), R = s("./generate"), _ = s("./nodejsUtils"), m = s("./nodejs/NodejsStreamInputAdapter"), L = function(fe) {
        fe.slice(-1) === "/" && (fe = fe.substring(0, fe.length - 1));
        var _e = fe.lastIndexOf("/");
        return 0 < _e ? fe.substring(0, _e) : "";
      }, F = function(fe) {
        return fe.slice(-1) !== "/" && (fe += "/"), fe;
      }, W = function(fe, _e) {
        return _e = _e !== void 0 ? _e : f.createFolders, fe = F(fe), this.files[fe] || l.call(this, fe, null, { dir: !0, createFolders: _e }), this.files[fe];
      };
      function G(fe) {
        return Object.prototype.toString.call(fe) === "[object RegExp]";
      }
      var q = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(fe) {
        var _e, Le, Fe;
        for (_e in this.files)
          Fe = this.files[_e], (Le = _e.slice(this.root.length, _e.length)) && _e.slice(0, this.root.length) === this.root && fe(Le, Fe);
      }, filter: function(fe) {
        var _e = [];
        return this.forEach(function(Le, Fe) {
          fe(Le, Fe) && _e.push(Fe);
        }), _e;
      }, file: function(fe, _e, Le) {
        if (arguments.length !== 1)
          return fe = this.root + fe, l.call(this, fe, _e, Le), this;
        if (G(fe)) {
          var Fe = fe;
          return this.filter(function(Ge, ve) {
            return !ve.dir && Fe.test(Ge);
          });
        }
        var Ee = this.files[this.root + fe];
        return Ee && !Ee.dir ? Ee : null;
      }, folder: function(fe) {
        if (!fe)
          return this;
        if (G(fe))
          return this.filter(function(Ee, Ge) {
            return Ge.dir && fe.test(Ee);
          });
        var _e = this.root + fe, Le = W.call(this, _e), Fe = this.clone();
        return Fe.root = Le.name, Fe;
      }, remove: function(fe) {
        fe = this.root + fe;
        var _e = this.files[fe];
        if (_e || (fe.slice(-1) !== "/" && (fe += "/"), _e = this.files[fe]), _e && !_e.dir)
          delete this.files[fe];
        else
          for (var Le = this.filter(function(Ee, Ge) {
            return Ge.name.slice(0, fe.length) === fe;
          }), Fe = 0; Fe < Le.length; Fe++)
            delete this.files[Le[Fe].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(fe) {
        var _e, Le = {};
        try {
          if ((Le = c.extend(fe || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: u.utf8encode })).type = Le.type.toLowerCase(), Le.compression = Le.compression.toUpperCase(), Le.type === "binarystring" && (Le.type = "string"), !Le.type)
            throw new Error("No output type specified.");
          c.checkSupport(Le.type), Le.platform !== "darwin" && Le.platform !== "freebsd" && Le.platform !== "linux" && Le.platform !== "sunos" || (Le.platform = "UNIX"), Le.platform === "win32" && (Le.platform = "DOS");
          var Fe = Le.comment || this.comment || "";
          _e = R.generateWorker(this, Le, Fe);
        } catch (Ee) {
          (_e = new E("error")).error(Ee);
        }
        return new d(_e, Le.type || "string", Le.mimeType);
      }, generateAsync: function(fe, _e) {
        return this.generateInternalStream(fe).accumulate(_e);
      }, generateNodeStream: function(fe, _e) {
        return (fe = fe || {}).type || (fe.type = "nodebuffer"), this.generateInternalStream(fe).toNodejsStream(_e);
      } };
      o.exports = q;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(s, o, a) {
      o.exports = s("stream");
    }, { stream: void 0 }], 17: [function(s, o, a) {
      var l = s("./DataReader");
      function u(c) {
        l.call(this, c);
        for (var E = 0; E < this.data.length; E++)
          c[E] = 255 & c[E];
      }
      s("../utils").inherits(u, l), u.prototype.byteAt = function(c) {
        return this.data[this.zero + c];
      }, u.prototype.lastIndexOfSignature = function(c) {
        for (var E = c.charCodeAt(0), d = c.charCodeAt(1), f = c.charCodeAt(2), h = c.charCodeAt(3), S = this.length - 4; 0 <= S; --S)
          if (this.data[S] === E && this.data[S + 1] === d && this.data[S + 2] === f && this.data[S + 3] === h)
            return S - this.zero;
        return -1;
      }, u.prototype.readAndCheckSignature = function(c) {
        var E = c.charCodeAt(0), d = c.charCodeAt(1), f = c.charCodeAt(2), h = c.charCodeAt(3), S = this.readData(4);
        return E === S[0] && d === S[1] && f === S[2] && h === S[3];
      }, u.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return [];
        var E = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, E;
      }, o.exports = u;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(s, o, a) {
      var l = s("../utils");
      function u(c) {
        this.data = c, this.length = c.length, this.index = 0, this.zero = 0;
      }
      u.prototype = { checkOffset: function(c) {
        this.checkIndex(this.index + c);
      }, checkIndex: function(c) {
        if (this.length < this.zero + c || c < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + c + "). Corrupted zip ?");
      }, setIndex: function(c) {
        this.checkIndex(c), this.index = c;
      }, skip: function(c) {
        this.setIndex(this.index + c);
      }, byteAt: function() {
      }, readInt: function(c) {
        var E, d = 0;
        for (this.checkOffset(c), E = this.index + c - 1; E >= this.index; E--)
          d = (d << 8) + this.byteAt(E);
        return this.index += c, d;
      }, readString: function(c) {
        return l.transformTo("string", this.readData(c));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var c = this.readInt(4);
        return new Date(Date.UTC(1980 + (c >> 25 & 127), (c >> 21 & 15) - 1, c >> 16 & 31, c >> 11 & 31, c >> 5 & 63, (31 & c) << 1));
      } }, o.exports = u;
    }, { "../utils": 32 }], 19: [function(s, o, a) {
      var l = s("./Uint8ArrayReader");
      function u(c) {
        l.call(this, c);
      }
      s("../utils").inherits(u, l), u.prototype.readData = function(c) {
        this.checkOffset(c);
        var E = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, E;
      }, o.exports = u;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(s, o, a) {
      var l = s("./DataReader");
      function u(c) {
        l.call(this, c);
      }
      s("../utils").inherits(u, l), u.prototype.byteAt = function(c) {
        return this.data.charCodeAt(this.zero + c);
      }, u.prototype.lastIndexOfSignature = function(c) {
        return this.data.lastIndexOf(c) - this.zero;
      }, u.prototype.readAndCheckSignature = function(c) {
        return c === this.readData(4);
      }, u.prototype.readData = function(c) {
        this.checkOffset(c);
        var E = this.data.slice(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, E;
      }, o.exports = u;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(s, o, a) {
      var l = s("./ArrayReader");
      function u(c) {
        l.call(this, c);
      }
      s("../utils").inherits(u, l), u.prototype.readData = function(c) {
        if (this.checkOffset(c), c === 0)
          return new Uint8Array(0);
        var E = this.data.subarray(this.zero + this.index, this.zero + this.index + c);
        return this.index += c, E;
      }, o.exports = u;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(s, o, a) {
      var l = s("../utils"), u = s("../support"), c = s("./ArrayReader"), E = s("./StringReader"), d = s("./NodeBufferReader"), f = s("./Uint8ArrayReader");
      o.exports = function(h) {
        var S = l.getTypeOf(h);
        return l.checkSupport(S), S !== "string" || u.uint8array ? S === "nodebuffer" ? new d(h) : u.uint8array ? new f(l.transformTo("uint8array", h)) : new c(l.transformTo("array", h)) : new E(h);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(s, o, a) {
      a.LOCAL_FILE_HEADER = "PK", a.CENTRAL_FILE_HEADER = "PK", a.CENTRAL_DIRECTORY_END = "PK", a.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", a.ZIP64_CENTRAL_DIRECTORY_END = "PK", a.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(s, o, a) {
      var l = s("./GenericWorker"), u = s("../utils");
      function c(E) {
        l.call(this, "ConvertWorker to " + E), this.destType = E;
      }
      u.inherits(c, l), c.prototype.processChunk = function(E) {
        this.push({ data: u.transformTo(this.destType, E.data), meta: E.meta });
      }, o.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(s, o, a) {
      var l = s("./GenericWorker"), u = s("../crc32");
      function c() {
        l.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      s("../utils").inherits(c, l), c.prototype.processChunk = function(E) {
        this.streamInfo.crc32 = u(E.data, this.streamInfo.crc32 || 0), this.push(E);
      }, o.exports = c;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(s, o, a) {
      var l = s("../utils"), u = s("./GenericWorker");
      function c(E) {
        u.call(this, "DataLengthProbe for " + E), this.propName = E, this.withStreamInfo(E, 0);
      }
      l.inherits(c, u), c.prototype.processChunk = function(E) {
        if (E) {
          var d = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = d + E.data.length;
        }
        u.prototype.processChunk.call(this, E);
      }, o.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(s, o, a) {
      var l = s("../utils"), u = s("./GenericWorker");
      function c(E) {
        u.call(this, "DataWorker");
        var d = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, E.then(function(f) {
          d.dataIsReady = !0, d.data = f, d.max = f && f.length || 0, d.type = l.getTypeOf(f), d.isPaused || d._tickAndRepeat();
        }, function(f) {
          d.error(f);
        });
      }
      l.inherits(c, u), c.prototype.cleanUp = function() {
        u.prototype.cleanUp.call(this), this.data = null;
      }, c.prototype.resume = function() {
        return !!u.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, l.delay(this._tickAndRepeat, [], this)), !0);
      }, c.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (l.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, c.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var E = null, d = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            E = this.data.substring(this.index, d);
            break;
          case "uint8array":
            E = this.data.subarray(this.index, d);
            break;
          case "array":
          case "nodebuffer":
            E = this.data.slice(this.index, d);
        }
        return this.index = d, this.push({ data: E, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, o.exports = c;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(s, o, a) {
      function l(u) {
        this.name = u || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      l.prototype = { push: function(u) {
        this.emit("data", u);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (u) {
          this.emit("error", u);
        }
        return !0;
      }, error: function(u) {
        return !this.isFinished && (this.isPaused ? this.generatedError = u : (this.isFinished = !0, this.emit("error", u), this.previous && this.previous.error(u), this.cleanUp()), !0);
      }, on: function(u, c) {
        return this._listeners[u].push(c), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(u, c) {
        if (this._listeners[u])
          for (var E = 0; E < this._listeners[u].length; E++)
            this._listeners[u][E].call(this, c);
      }, pipe: function(u) {
        return u.registerPrevious(this);
      }, registerPrevious: function(u) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = u.streamInfo, this.mergeStreamInfo(), this.previous = u;
        var c = this;
        return u.on("data", function(E) {
          c.processChunk(E);
        }), u.on("end", function() {
          c.end();
        }), u.on("error", function(E) {
          c.error(E);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var u = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), u = !0), this.previous && this.previous.resume(), !u;
      }, flush: function() {
      }, processChunk: function(u) {
        this.push(u);
      }, withStreamInfo: function(u, c) {
        return this.extraStreamInfo[u] = c, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var u in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, u) && (this.streamInfo[u] = this.extraStreamInfo[u]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var u = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + u : u;
      } }, o.exports = l;
    }, {}], 29: [function(s, o, a) {
      var l = s("../utils"), u = s("./ConvertWorker"), c = s("./GenericWorker"), E = s("../base64"), d = s("../support"), f = s("../external"), h = null;
      if (d.nodestream)
        try {
          h = s("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function S(_, m) {
        return new f.Promise(function(L, F) {
          var W = [], G = _._internalType, q = _._outputType, fe = _._mimeType;
          _.on("data", function(_e, Le) {
            W.push(_e), m && m(Le);
          }).on("error", function(_e) {
            W = [], F(_e);
          }).on("end", function() {
            try {
              var _e = function(Le, Fe, Ee) {
                switch (Le) {
                  case "blob":
                    return l.newBlob(l.transformTo("arraybuffer", Fe), Ee);
                  case "base64":
                    return E.encode(Fe);
                  default:
                    return l.transformTo(Le, Fe);
                }
              }(q, function(Le, Fe) {
                var Ee, Ge = 0, ve = null, te = 0;
                for (Ee = 0; Ee < Fe.length; Ee++)
                  te += Fe[Ee].length;
                switch (Le) {
                  case "string":
                    return Fe.join("");
                  case "array":
                    return Array.prototype.concat.apply([], Fe);
                  case "uint8array":
                    for (ve = new Uint8Array(te), Ee = 0; Ee < Fe.length; Ee++)
                      ve.set(Fe[Ee], Ge), Ge += Fe[Ee].length;
                    return ve;
                  case "nodebuffer":
                    return buffer$1.Buffer.concat(Fe);
                  default:
                    throw new Error("concat : unsupported type '" + Le + "'");
                }
              }(G, W), fe);
              L(_e);
            } catch (Le) {
              F(Le);
            }
            W = [];
          }).resume();
        });
      }
      function R(_, m, L) {
        var F = m;
        switch (m) {
          case "blob":
          case "arraybuffer":
            F = "uint8array";
            break;
          case "base64":
            F = "string";
        }
        try {
          this._internalType = F, this._outputType = m, this._mimeType = L, l.checkSupport(F), this._worker = _.pipe(new u(F)), _.lock();
        } catch (W) {
          this._worker = new c("error"), this._worker.error(W);
        }
      }
      R.prototype = { accumulate: function(_) {
        return S(this, _);
      }, on: function(_, m) {
        var L = this;
        return _ === "data" ? this._worker.on(_, function(F) {
          m.call(L, F.data, F.meta);
        }) : this._worker.on(_, function() {
          l.delay(m, arguments, L);
        }), this;
      }, resume: function() {
        return l.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(_) {
        if (l.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new h(this, { objectMode: this._outputType !== "nodebuffer" }, _);
      } }, o.exports = R;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(s, o, a) {
      if (a.base64 = !0, a.array = !0, a.string = !0, a.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", a.nodebuffer = typeof buffer$1.Buffer < "u", a.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        a.blob = !1;
      else {
        var l = new ArrayBuffer(0);
        try {
          a.blob = new Blob([l], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var u = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            u.append(l), a.blob = u.getBlob("application/zip").size === 0;
          } catch {
            a.blob = !1;
          }
        }
      }
      try {
        a.nodestream = !!s("readable-stream").Readable;
      } catch {
        a.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(s, o, a) {
      for (var l = s("./utils"), u = s("./support"), c = s("./nodejsUtils"), E = s("./stream/GenericWorker"), d = new Array(256), f = 0; f < 256; f++)
        d[f] = 252 <= f ? 6 : 248 <= f ? 5 : 240 <= f ? 4 : 224 <= f ? 3 : 192 <= f ? 2 : 1;
      d[254] = d[254] = 1;
      function h() {
        E.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function S() {
        E.call(this, "utf-8 encode");
      }
      a.utf8encode = function(R) {
        return u.nodebuffer ? c.newBufferFrom(R, "utf-8") : function(_) {
          var m, L, F, W, G, q = _.length, fe = 0;
          for (W = 0; W < q; W++)
            (64512 & (L = _.charCodeAt(W))) == 55296 && W + 1 < q && (64512 & (F = _.charCodeAt(W + 1))) == 56320 && (L = 65536 + (L - 55296 << 10) + (F - 56320), W++), fe += L < 128 ? 1 : L < 2048 ? 2 : L < 65536 ? 3 : 4;
          for (m = u.uint8array ? new Uint8Array(fe) : new Array(fe), W = G = 0; G < fe; W++)
            (64512 & (L = _.charCodeAt(W))) == 55296 && W + 1 < q && (64512 & (F = _.charCodeAt(W + 1))) == 56320 && (L = 65536 + (L - 55296 << 10) + (F - 56320), W++), L < 128 ? m[G++] = L : (L < 2048 ? m[G++] = 192 | L >>> 6 : (L < 65536 ? m[G++] = 224 | L >>> 12 : (m[G++] = 240 | L >>> 18, m[G++] = 128 | L >>> 12 & 63), m[G++] = 128 | L >>> 6 & 63), m[G++] = 128 | 63 & L);
          return m;
        }(R);
      }, a.utf8decode = function(R) {
        return u.nodebuffer ? l.transformTo("nodebuffer", R).toString("utf-8") : function(_) {
          var m, L, F, W, G = _.length, q = new Array(2 * G);
          for (m = L = 0; m < G; )
            if ((F = _[m++]) < 128)
              q[L++] = F;
            else if (4 < (W = d[F]))
              q[L++] = 65533, m += W - 1;
            else {
              for (F &= W === 2 ? 31 : W === 3 ? 15 : 7; 1 < W && m < G; )
                F = F << 6 | 63 & _[m++], W--;
              1 < W ? q[L++] = 65533 : F < 65536 ? q[L++] = F : (F -= 65536, q[L++] = 55296 | F >> 10 & 1023, q[L++] = 56320 | 1023 & F);
            }
          return q.length !== L && (q.subarray ? q = q.subarray(0, L) : q.length = L), l.applyFromCharCode(q);
        }(R = l.transformTo(u.uint8array ? "uint8array" : "array", R));
      }, l.inherits(h, E), h.prototype.processChunk = function(R) {
        var _ = l.transformTo(u.uint8array ? "uint8array" : "array", R.data);
        if (this.leftOver && this.leftOver.length) {
          if (u.uint8array) {
            var m = _;
            (_ = new Uint8Array(m.length + this.leftOver.length)).set(this.leftOver, 0), _.set(m, this.leftOver.length);
          } else
            _ = this.leftOver.concat(_);
          this.leftOver = null;
        }
        var L = function(W, G) {
          var q;
          for ((G = G || W.length) > W.length && (G = W.length), q = G - 1; 0 <= q && (192 & W[q]) == 128; )
            q--;
          return q < 0 || q === 0 ? G : q + d[W[q]] > G ? q : G;
        }(_), F = _;
        L !== _.length && (u.uint8array ? (F = _.subarray(0, L), this.leftOver = _.subarray(L, _.length)) : (F = _.slice(0, L), this.leftOver = _.slice(L, _.length))), this.push({ data: a.utf8decode(F), meta: R.meta });
      }, h.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: a.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, a.Utf8DecodeWorker = h, l.inherits(S, E), S.prototype.processChunk = function(R) {
        this.push({ data: a.utf8encode(R.data), meta: R.meta });
      }, a.Utf8EncodeWorker = S;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(s, o, a) {
      var l = s("./support"), u = s("./base64"), c = s("./nodejsUtils"), E = s("./external");
      function d(m) {
        return m;
      }
      function f(m, L) {
        for (var F = 0; F < m.length; ++F)
          L[F] = 255 & m.charCodeAt(F);
        return L;
      }
      s("setimmediate"), a.newBlob = function(m, L) {
        a.checkSupport("blob");
        try {
          return new Blob([m], { type: L });
        } catch {
          try {
            var F = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return F.append(m), F.getBlob(L);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var h = { stringifyByChunk: function(m, L, F) {
        var W = [], G = 0, q = m.length;
        if (q <= F)
          return String.fromCharCode.apply(null, m);
        for (; G < q; )
          L === "array" || L === "nodebuffer" ? W.push(String.fromCharCode.apply(null, m.slice(G, Math.min(G + F, q)))) : W.push(String.fromCharCode.apply(null, m.subarray(G, Math.min(G + F, q)))), G += F;
        return W.join("");
      }, stringifyByChar: function(m) {
        for (var L = "", F = 0; F < m.length; F++)
          L += String.fromCharCode(m[F]);
        return L;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return l.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return l.nodebuffer && String.fromCharCode.apply(null, c.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function S(m) {
        var L = 65536, F = a.getTypeOf(m), W = !0;
        if (F === "uint8array" ? W = h.applyCanBeUsed.uint8array : F === "nodebuffer" && (W = h.applyCanBeUsed.nodebuffer), W)
          for (; 1 < L; )
            try {
              return h.stringifyByChunk(m, F, L);
            } catch {
              L = Math.floor(L / 2);
            }
        return h.stringifyByChar(m);
      }
      function R(m, L) {
        for (var F = 0; F < m.length; F++)
          L[F] = m[F];
        return L;
      }
      a.applyFromCharCode = S;
      var _ = {};
      _.string = { string: d, array: function(m) {
        return f(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return _.string.uint8array(m).buffer;
      }, uint8array: function(m) {
        return f(m, new Uint8Array(m.length));
      }, nodebuffer: function(m) {
        return f(m, c.allocBuffer(m.length));
      } }, _.array = { string: S, array: d, arraybuffer: function(m) {
        return new Uint8Array(m).buffer;
      }, uint8array: function(m) {
        return new Uint8Array(m);
      }, nodebuffer: function(m) {
        return c.newBufferFrom(m);
      } }, _.arraybuffer = { string: function(m) {
        return S(new Uint8Array(m));
      }, array: function(m) {
        return R(new Uint8Array(m), new Array(m.byteLength));
      }, arraybuffer: d, uint8array: function(m) {
        return new Uint8Array(m);
      }, nodebuffer: function(m) {
        return c.newBufferFrom(new Uint8Array(m));
      } }, _.uint8array = { string: S, array: function(m) {
        return R(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return m.buffer;
      }, uint8array: d, nodebuffer: function(m) {
        return c.newBufferFrom(m);
      } }, _.nodebuffer = { string: S, array: function(m) {
        return R(m, new Array(m.length));
      }, arraybuffer: function(m) {
        return _.nodebuffer.uint8array(m).buffer;
      }, uint8array: function(m) {
        return R(m, new Uint8Array(m.length));
      }, nodebuffer: d }, a.transformTo = function(m, L) {
        if (L = L || "", !m)
          return L;
        a.checkSupport(m);
        var F = a.getTypeOf(L);
        return _[F][m](L);
      }, a.resolve = function(m) {
        for (var L = m.split("/"), F = [], W = 0; W < L.length; W++) {
          var G = L[W];
          G === "." || G === "" && W !== 0 && W !== L.length - 1 || (G === ".." ? F.pop() : F.push(G));
        }
        return F.join("/");
      }, a.getTypeOf = function(m) {
        return typeof m == "string" ? "string" : Object.prototype.toString.call(m) === "[object Array]" ? "array" : l.nodebuffer && c.isBuffer(m) ? "nodebuffer" : l.uint8array && m instanceof Uint8Array ? "uint8array" : l.arraybuffer && m instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, a.checkSupport = function(m) {
        if (!l[m.toLowerCase()])
          throw new Error(m + " is not supported by this platform");
      }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(m) {
        var L, F, W = "";
        for (F = 0; F < (m || "").length; F++)
          W += "\\x" + ((L = m.charCodeAt(F)) < 16 ? "0" : "") + L.toString(16).toUpperCase();
        return W;
      }, a.delay = function(m, L, F) {
        setImmediate(function() {
          m.apply(F || null, L || []);
        });
      }, a.inherits = function(m, L) {
        function F() {
        }
        F.prototype = L.prototype, m.prototype = new F();
      }, a.extend = function() {
        var m, L, F = {};
        for (m = 0; m < arguments.length; m++)
          for (L in arguments[m])
            Object.prototype.hasOwnProperty.call(arguments[m], L) && F[L] === void 0 && (F[L] = arguments[m][L]);
        return F;
      }, a.prepareContent = function(m, L, F, W, G) {
        return E.Promise.resolve(L).then(function(q) {
          return l.blob && (q instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(q)) !== -1) && typeof FileReader < "u" ? new E.Promise(function(fe, _e) {
            var Le = new FileReader();
            Le.onload = function(Fe) {
              fe(Fe.target.result);
            }, Le.onerror = function(Fe) {
              _e(Fe.target.error);
            }, Le.readAsArrayBuffer(q);
          }) : q;
        }).then(function(q) {
          var fe = a.getTypeOf(q);
          return fe ? (fe === "arraybuffer" ? q = a.transformTo("uint8array", q) : fe === "string" && (G ? q = u.decode(q) : F && W !== !0 && (q = function(_e) {
            return f(_e, l.uint8array ? new Uint8Array(_e.length) : new Array(_e.length));
          }(q))), q) : E.Promise.reject(new Error("Can't read the data of '" + m + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(s, o, a) {
      var l = s("./reader/readerFor"), u = s("./utils"), c = s("./signature"), E = s("./zipEntry"), d = s("./support");
      function f(h) {
        this.files = [], this.loadOptions = h;
      }
      f.prototype = { checkSignature: function(h) {
        if (!this.reader.readAndCheckSignature(h)) {
          this.reader.index -= 4;
          var S = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + u.pretty(S) + ", expected " + u.pretty(h) + ")");
        }
      }, isSignature: function(h, S) {
        var R = this.reader.index;
        this.reader.setIndex(h);
        var _ = this.reader.readString(4) === S;
        return this.reader.setIndex(R), _;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var h = this.reader.readData(this.zipCommentLength), S = d.uint8array ? "uint8array" : "array", R = u.transformTo(S, h);
        this.zipComment = this.loadOptions.decodeFileName(R);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var h, S, R, _ = this.zip64EndOfCentralSize - 44; 0 < _; )
          h = this.reader.readInt(2), S = this.reader.readInt(4), R = this.reader.readData(S), this.zip64ExtensibleData[h] = { id: h, length: S, value: R };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var h, S;
        for (h = 0; h < this.files.length; h++)
          S = this.files[h], this.reader.setIndex(S.localHeaderOffset), this.checkSignature(c.LOCAL_FILE_HEADER), S.readLocalPart(this.reader), S.handleUTF8(), S.processAttributes();
      }, readCentralDir: function() {
        var h;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(c.CENTRAL_FILE_HEADER); )
          (h = new E({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(h);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var h = this.reader.lastIndexOfSignature(c.CENTRAL_DIRECTORY_END);
        if (h < 0)
          throw this.isSignature(0, c.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(h);
        var S = h;
        if (this.checkSignature(c.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === u.MAX_VALUE_16BITS || this.diskWithCentralDirStart === u.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === u.MAX_VALUE_16BITS || this.centralDirRecords === u.MAX_VALUE_16BITS || this.centralDirSize === u.MAX_VALUE_32BITS || this.centralDirOffset === u.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (h = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(h), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, c.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(c.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var R = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (R += 20, R += 12 + this.zip64EndOfCentralSize);
        var _ = S - R;
        if (0 < _)
          this.isSignature(S, c.CENTRAL_FILE_HEADER) || (this.reader.zero = _);
        else if (_ < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(_) + " bytes.");
      }, prepareReader: function(h) {
        this.reader = l(h);
      }, load: function(h) {
        this.prepareReader(h), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, o.exports = f;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(s, o, a) {
      var l = s("./reader/readerFor"), u = s("./utils"), c = s("./compressedObject"), E = s("./crc32"), d = s("./utf8"), f = s("./compressions"), h = s("./support");
      function S(R, _) {
        this.options = R, this.loadOptions = _;
      }
      S.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(R) {
        var _, m;
        if (R.skip(22), this.fileNameLength = R.readInt(2), m = R.readInt(2), this.fileName = R.readData(this.fileNameLength), R.skip(m), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((_ = function(L) {
          for (var F in f)
            if (Object.prototype.hasOwnProperty.call(f, F) && f[F].magic === L)
              return f[F];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + u.pretty(this.compressionMethod) + " unknown (inner file : " + u.transformTo("string", this.fileName) + ")");
        this.decompressed = new c(this.compressedSize, this.uncompressedSize, this.crc32, _, R.readData(this.compressedSize));
      }, readCentralPart: function(R) {
        this.versionMadeBy = R.readInt(2), R.skip(2), this.bitFlag = R.readInt(2), this.compressionMethod = R.readString(2), this.date = R.readDate(), this.crc32 = R.readInt(4), this.compressedSize = R.readInt(4), this.uncompressedSize = R.readInt(4);
        var _ = R.readInt(2);
        if (this.extraFieldsLength = R.readInt(2), this.fileCommentLength = R.readInt(2), this.diskNumberStart = R.readInt(2), this.internalFileAttributes = R.readInt(2), this.externalFileAttributes = R.readInt(4), this.localHeaderOffset = R.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        R.skip(_), this.readExtraFields(R), this.parseZIP64ExtraField(R), this.fileComment = R.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var R = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), R == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), R == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var R = l(this.extraFields[1].value);
          this.uncompressedSize === u.MAX_VALUE_32BITS && (this.uncompressedSize = R.readInt(8)), this.compressedSize === u.MAX_VALUE_32BITS && (this.compressedSize = R.readInt(8)), this.localHeaderOffset === u.MAX_VALUE_32BITS && (this.localHeaderOffset = R.readInt(8)), this.diskNumberStart === u.MAX_VALUE_32BITS && (this.diskNumberStart = R.readInt(4));
        }
      }, readExtraFields: function(R) {
        var _, m, L, F = R.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); R.index + 4 < F; )
          _ = R.readInt(2), m = R.readInt(2), L = R.readData(m), this.extraFields[_] = { id: _, length: m, value: L };
        R.setIndex(F);
      }, handleUTF8: function() {
        var R = h.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = d.utf8decode(this.fileName), this.fileCommentStr = d.utf8decode(this.fileComment);
        else {
          var _ = this.findExtraFieldUnicodePath();
          if (_ !== null)
            this.fileNameStr = _;
          else {
            var m = u.transformTo(R, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(m);
          }
          var L = this.findExtraFieldUnicodeComment();
          if (L !== null)
            this.fileCommentStr = L;
          else {
            var F = u.transformTo(R, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(F);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var R = this.extraFields[28789];
        if (R) {
          var _ = l(R.value);
          return _.readInt(1) !== 1 || E(this.fileName) !== _.readInt(4) ? null : d.utf8decode(_.readData(R.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var R = this.extraFields[25461];
        if (R) {
          var _ = l(R.value);
          return _.readInt(1) !== 1 || E(this.fileComment) !== _.readInt(4) ? null : d.utf8decode(_.readData(R.length - 5));
        }
        return null;
      } }, o.exports = S;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(s, o, a) {
      function l(_, m, L) {
        this.name = _, this.dir = L.dir, this.date = L.date, this.comment = L.comment, this.unixPermissions = L.unixPermissions, this.dosPermissions = L.dosPermissions, this._data = m, this._dataBinary = L.binary, this.options = { compression: L.compression, compressionOptions: L.compressionOptions };
      }
      var u = s("./stream/StreamHelper"), c = s("./stream/DataWorker"), E = s("./utf8"), d = s("./compressedObject"), f = s("./stream/GenericWorker");
      l.prototype = { internalStream: function(_) {
        var m = null, L = "string";
        try {
          if (!_)
            throw new Error("No output type specified.");
          var F = (L = _.toLowerCase()) === "string" || L === "text";
          L !== "binarystring" && L !== "text" || (L = "string"), m = this._decompressWorker();
          var W = !this._dataBinary;
          W && !F && (m = m.pipe(new E.Utf8EncodeWorker())), !W && F && (m = m.pipe(new E.Utf8DecodeWorker()));
        } catch (G) {
          (m = new f("error")).error(G);
        }
        return new u(m, L, "");
      }, async: function(_, m) {
        return this.internalStream(_).accumulate(m);
      }, nodeStream: function(_, m) {
        return this.internalStream(_ || "nodebuffer").toNodejsStream(m);
      }, _compressWorker: function(_, m) {
        if (this._data instanceof d && this._data.compression.magic === _.magic)
          return this._data.getCompressedWorker();
        var L = this._decompressWorker();
        return this._dataBinary || (L = L.pipe(new E.Utf8EncodeWorker())), d.createWorkerFrom(L, _, m);
      }, _decompressWorker: function() {
        return this._data instanceof d ? this._data.getContentWorker() : this._data instanceof f ? this._data : new c(this._data);
      } };
      for (var h = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], S = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, R = 0; R < h.length; R++)
        l.prototype[h[R]] = S;
      o.exports = l;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(s, o, a) {
      (function(l) {
        var u, c, E = l.MutationObserver || l.WebKitMutationObserver;
        if (E) {
          var d = 0, f = new E(_), h = l.document.createTextNode("");
          f.observe(h, { characterData: !0 }), u = function() {
            h.data = d = ++d % 2;
          };
        } else if (l.setImmediate || l.MessageChannel === void 0)
          u = "document" in l && "onreadystatechange" in l.document.createElement("script") ? function() {
            var m = l.document.createElement("script");
            m.onreadystatechange = function() {
              _(), m.onreadystatechange = null, m.parentNode.removeChild(m), m = null;
            }, l.document.documentElement.appendChild(m);
          } : function() {
            setTimeout(_, 0);
          };
        else {
          var S = new l.MessageChannel();
          S.port1.onmessage = _, u = function() {
            S.port2.postMessage(0);
          };
        }
        var R = [];
        function _() {
          var m, L;
          c = !0;
          for (var F = R.length; F; ) {
            for (L = R, R = [], m = -1; ++m < F; )
              L[m]();
            F = R.length;
          }
          c = !1;
        }
        o.exports = function(m) {
          R.push(m) !== 1 || c || u();
        };
      }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(s, o, a) {
      var l = s("immediate");
      function u() {
      }
      var c = {}, E = ["REJECTED"], d = ["FULFILLED"], f = ["PENDING"];
      function h(F) {
        if (typeof F != "function")
          throw new TypeError("resolver must be a function");
        this.state = f, this.queue = [], this.outcome = void 0, F !== u && m(this, F);
      }
      function S(F, W, G) {
        this.promise = F, typeof W == "function" && (this.onFulfilled = W, this.callFulfilled = this.otherCallFulfilled), typeof G == "function" && (this.onRejected = G, this.callRejected = this.otherCallRejected);
      }
      function R(F, W, G) {
        l(function() {
          var q;
          try {
            q = W(G);
          } catch (fe) {
            return c.reject(F, fe);
          }
          q === F ? c.reject(F, new TypeError("Cannot resolve promise with itself")) : c.resolve(F, q);
        });
      }
      function _(F) {
        var W = F && F.then;
        if (F && (typeof F == "object" || typeof F == "function") && typeof W == "function")
          return function() {
            W.apply(F, arguments);
          };
      }
      function m(F, W) {
        var G = !1;
        function q(Le) {
          G || (G = !0, c.reject(F, Le));
        }
        function fe(Le) {
          G || (G = !0, c.resolve(F, Le));
        }
        var _e = L(function() {
          W(fe, q);
        });
        _e.status === "error" && q(_e.value);
      }
      function L(F, W) {
        var G = {};
        try {
          G.value = F(W), G.status = "success";
        } catch (q) {
          G.status = "error", G.value = q;
        }
        return G;
      }
      (o.exports = h).prototype.finally = function(F) {
        if (typeof F != "function")
          return this;
        var W = this.constructor;
        return this.then(function(G) {
          return W.resolve(F()).then(function() {
            return G;
          });
        }, function(G) {
          return W.resolve(F()).then(function() {
            throw G;
          });
        });
      }, h.prototype.catch = function(F) {
        return this.then(null, F);
      }, h.prototype.then = function(F, W) {
        if (typeof F != "function" && this.state === d || typeof W != "function" && this.state === E)
          return this;
        var G = new this.constructor(u);
        return this.state !== f ? R(G, this.state === d ? F : W, this.outcome) : this.queue.push(new S(G, F, W)), G;
      }, S.prototype.callFulfilled = function(F) {
        c.resolve(this.promise, F);
      }, S.prototype.otherCallFulfilled = function(F) {
        R(this.promise, this.onFulfilled, F);
      }, S.prototype.callRejected = function(F) {
        c.reject(this.promise, F);
      }, S.prototype.otherCallRejected = function(F) {
        R(this.promise, this.onRejected, F);
      }, c.resolve = function(F, W) {
        var G = L(_, W);
        if (G.status === "error")
          return c.reject(F, G.value);
        var q = G.value;
        if (q)
          m(F, q);
        else {
          F.state = d, F.outcome = W;
          for (var fe = -1, _e = F.queue.length; ++fe < _e; )
            F.queue[fe].callFulfilled(W);
        }
        return F;
      }, c.reject = function(F, W) {
        F.state = E, F.outcome = W;
        for (var G = -1, q = F.queue.length; ++G < q; )
          F.queue[G].callRejected(W);
        return F;
      }, h.resolve = function(F) {
        return F instanceof this ? F : c.resolve(new this(u), F);
      }, h.reject = function(F) {
        var W = new this(u);
        return c.reject(W, F);
      }, h.all = function(F) {
        var W = this;
        if (Object.prototype.toString.call(F) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var G = F.length, q = !1;
        if (!G)
          return this.resolve([]);
        for (var fe = new Array(G), _e = 0, Le = -1, Fe = new this(u); ++Le < G; )
          Ee(F[Le], Le);
        return Fe;
        function Ee(Ge, ve) {
          W.resolve(Ge).then(function(te) {
            fe[ve] = te, ++_e !== G || q || (q = !0, c.resolve(Fe, fe));
          }, function(te) {
            q || (q = !0, c.reject(Fe, te));
          });
        }
      }, h.race = function(F) {
        var W = this;
        if (Object.prototype.toString.call(F) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var G = F.length, q = !1;
        if (!G)
          return this.resolve([]);
        for (var fe = -1, _e = new this(u); ++fe < G; )
          Le = F[fe], W.resolve(Le).then(function(Fe) {
            q || (q = !0, c.resolve(_e, Fe));
          }, function(Fe) {
            q || (q = !0, c.reject(_e, Fe));
          });
        var Le;
        return _e;
      };
    }, { immediate: 36 }], 38: [function(s, o, a) {
      var l = {};
      (0, s("./lib/utils/common").assign)(l, s("./lib/deflate"), s("./lib/inflate"), s("./lib/zlib/constants")), o.exports = l;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(s, o, a) {
      var l = s("./zlib/deflate"), u = s("./utils/common"), c = s("./utils/strings"), E = s("./zlib/messages"), d = s("./zlib/zstream"), f = Object.prototype.toString, h = 0, S = -1, R = 0, _ = 8;
      function m(F) {
        if (!(this instanceof m))
          return new m(F);
        this.options = u.assign({ level: S, method: _, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: R, to: "" }, F || {});
        var W = this.options;
        W.raw && 0 < W.windowBits ? W.windowBits = -W.windowBits : W.gzip && 0 < W.windowBits && W.windowBits < 16 && (W.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new d(), this.strm.avail_out = 0;
        var G = l.deflateInit2(this.strm, W.level, W.method, W.windowBits, W.memLevel, W.strategy);
        if (G !== h)
          throw new Error(E[G]);
        if (W.header && l.deflateSetHeader(this.strm, W.header), W.dictionary) {
          var q;
          if (q = typeof W.dictionary == "string" ? c.string2buf(W.dictionary) : f.call(W.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(W.dictionary) : W.dictionary, (G = l.deflateSetDictionary(this.strm, q)) !== h)
            throw new Error(E[G]);
          this._dict_set = !0;
        }
      }
      function L(F, W) {
        var G = new m(W);
        if (G.push(F, !0), G.err)
          throw G.msg || E[G.err];
        return G.result;
      }
      m.prototype.push = function(F, W) {
        var G, q, fe = this.strm, _e = this.options.chunkSize;
        if (this.ended)
          return !1;
        q = W === ~~W ? W : W === !0 ? 4 : 0, typeof F == "string" ? fe.input = c.string2buf(F) : f.call(F) === "[object ArrayBuffer]" ? fe.input = new Uint8Array(F) : fe.input = F, fe.next_in = 0, fe.avail_in = fe.input.length;
        do {
          if (fe.avail_out === 0 && (fe.output = new u.Buf8(_e), fe.next_out = 0, fe.avail_out = _e), (G = l.deflate(fe, q)) !== 1 && G !== h)
            return this.onEnd(G), !(this.ended = !0);
          fe.avail_out !== 0 && (fe.avail_in !== 0 || q !== 4 && q !== 2) || (this.options.to === "string" ? this.onData(c.buf2binstring(u.shrinkBuf(fe.output, fe.next_out))) : this.onData(u.shrinkBuf(fe.output, fe.next_out)));
        } while ((0 < fe.avail_in || fe.avail_out === 0) && G !== 1);
        return q === 4 ? (G = l.deflateEnd(this.strm), this.onEnd(G), this.ended = !0, G === h) : q !== 2 || (this.onEnd(h), !(fe.avail_out = 0));
      }, m.prototype.onData = function(F) {
        this.chunks.push(F);
      }, m.prototype.onEnd = function(F) {
        F === h && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = u.flattenChunks(this.chunks)), this.chunks = [], this.err = F, this.msg = this.strm.msg;
      }, a.Deflate = m, a.deflate = L, a.deflateRaw = function(F, W) {
        return (W = W || {}).raw = !0, L(F, W);
      }, a.gzip = function(F, W) {
        return (W = W || {}).gzip = !0, L(F, W);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(s, o, a) {
      var l = s("./zlib/inflate"), u = s("./utils/common"), c = s("./utils/strings"), E = s("./zlib/constants"), d = s("./zlib/messages"), f = s("./zlib/zstream"), h = s("./zlib/gzheader"), S = Object.prototype.toString;
      function R(m) {
        if (!(this instanceof R))
          return new R(m);
        this.options = u.assign({ chunkSize: 16384, windowBits: 0, to: "" }, m || {});
        var L = this.options;
        L.raw && 0 <= L.windowBits && L.windowBits < 16 && (L.windowBits = -L.windowBits, L.windowBits === 0 && (L.windowBits = -15)), !(0 <= L.windowBits && L.windowBits < 16) || m && m.windowBits || (L.windowBits += 32), 15 < L.windowBits && L.windowBits < 48 && !(15 & L.windowBits) && (L.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new f(), this.strm.avail_out = 0;
        var F = l.inflateInit2(this.strm, L.windowBits);
        if (F !== E.Z_OK)
          throw new Error(d[F]);
        this.header = new h(), l.inflateGetHeader(this.strm, this.header);
      }
      function _(m, L) {
        var F = new R(L);
        if (F.push(m, !0), F.err)
          throw F.msg || d[F.err];
        return F.result;
      }
      R.prototype.push = function(m, L) {
        var F, W, G, q, fe, _e, Le = this.strm, Fe = this.options.chunkSize, Ee = this.options.dictionary, Ge = !1;
        if (this.ended)
          return !1;
        W = L === ~~L ? L : L === !0 ? E.Z_FINISH : E.Z_NO_FLUSH, typeof m == "string" ? Le.input = c.binstring2buf(m) : S.call(m) === "[object ArrayBuffer]" ? Le.input = new Uint8Array(m) : Le.input = m, Le.next_in = 0, Le.avail_in = Le.input.length;
        do {
          if (Le.avail_out === 0 && (Le.output = new u.Buf8(Fe), Le.next_out = 0, Le.avail_out = Fe), (F = l.inflate(Le, E.Z_NO_FLUSH)) === E.Z_NEED_DICT && Ee && (_e = typeof Ee == "string" ? c.string2buf(Ee) : S.call(Ee) === "[object ArrayBuffer]" ? new Uint8Array(Ee) : Ee, F = l.inflateSetDictionary(this.strm, _e)), F === E.Z_BUF_ERROR && Ge === !0 && (F = E.Z_OK, Ge = !1), F !== E.Z_STREAM_END && F !== E.Z_OK)
            return this.onEnd(F), !(this.ended = !0);
          Le.next_out && (Le.avail_out !== 0 && F !== E.Z_STREAM_END && (Le.avail_in !== 0 || W !== E.Z_FINISH && W !== E.Z_SYNC_FLUSH) || (this.options.to === "string" ? (G = c.utf8border(Le.output, Le.next_out), q = Le.next_out - G, fe = c.buf2string(Le.output, G), Le.next_out = q, Le.avail_out = Fe - q, q && u.arraySet(Le.output, Le.output, G, q, 0), this.onData(fe)) : this.onData(u.shrinkBuf(Le.output, Le.next_out)))), Le.avail_in === 0 && Le.avail_out === 0 && (Ge = !0);
        } while ((0 < Le.avail_in || Le.avail_out === 0) && F !== E.Z_STREAM_END);
        return F === E.Z_STREAM_END && (W = E.Z_FINISH), W === E.Z_FINISH ? (F = l.inflateEnd(this.strm), this.onEnd(F), this.ended = !0, F === E.Z_OK) : W !== E.Z_SYNC_FLUSH || (this.onEnd(E.Z_OK), !(Le.avail_out = 0));
      }, R.prototype.onData = function(m) {
        this.chunks.push(m);
      }, R.prototype.onEnd = function(m) {
        m === E.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = u.flattenChunks(this.chunks)), this.chunks = [], this.err = m, this.msg = this.strm.msg;
      }, a.Inflate = R, a.inflate = _, a.inflateRaw = function(m, L) {
        return (L = L || {}).raw = !0, _(m, L);
      }, a.ungzip = _;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(s, o, a) {
      var l = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      a.assign = function(E) {
        for (var d = Array.prototype.slice.call(arguments, 1); d.length; ) {
          var f = d.shift();
          if (f) {
            if (typeof f != "object")
              throw new TypeError(f + "must be non-object");
            for (var h in f)
              f.hasOwnProperty(h) && (E[h] = f[h]);
          }
        }
        return E;
      }, a.shrinkBuf = function(E, d) {
        return E.length === d ? E : E.subarray ? E.subarray(0, d) : (E.length = d, E);
      };
      var u = { arraySet: function(E, d, f, h, S) {
        if (d.subarray && E.subarray)
          E.set(d.subarray(f, f + h), S);
        else
          for (var R = 0; R < h; R++)
            E[S + R] = d[f + R];
      }, flattenChunks: function(E) {
        var d, f, h, S, R, _;
        for (d = h = 0, f = E.length; d < f; d++)
          h += E[d].length;
        for (_ = new Uint8Array(h), d = S = 0, f = E.length; d < f; d++)
          R = E[d], _.set(R, S), S += R.length;
        return _;
      } }, c = { arraySet: function(E, d, f, h, S) {
        for (var R = 0; R < h; R++)
          E[S + R] = d[f + R];
      }, flattenChunks: function(E) {
        return [].concat.apply([], E);
      } };
      a.setTyped = function(E) {
        E ? (a.Buf8 = Uint8Array, a.Buf16 = Uint16Array, a.Buf32 = Int32Array, a.assign(a, u)) : (a.Buf8 = Array, a.Buf16 = Array, a.Buf32 = Array, a.assign(a, c));
      }, a.setTyped(l);
    }, {}], 42: [function(s, o, a) {
      var l = s("./common"), u = !0, c = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        u = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        c = !1;
      }
      for (var E = new l.Buf8(256), d = 0; d < 256; d++)
        E[d] = 252 <= d ? 6 : 248 <= d ? 5 : 240 <= d ? 4 : 224 <= d ? 3 : 192 <= d ? 2 : 1;
      function f(h, S) {
        if (S < 65537 && (h.subarray && c || !h.subarray && u))
          return String.fromCharCode.apply(null, l.shrinkBuf(h, S));
        for (var R = "", _ = 0; _ < S; _++)
          R += String.fromCharCode(h[_]);
        return R;
      }
      E[254] = E[254] = 1, a.string2buf = function(h) {
        var S, R, _, m, L, F = h.length, W = 0;
        for (m = 0; m < F; m++)
          (64512 & (R = h.charCodeAt(m))) == 55296 && m + 1 < F && (64512 & (_ = h.charCodeAt(m + 1))) == 56320 && (R = 65536 + (R - 55296 << 10) + (_ - 56320), m++), W += R < 128 ? 1 : R < 2048 ? 2 : R < 65536 ? 3 : 4;
        for (S = new l.Buf8(W), m = L = 0; L < W; m++)
          (64512 & (R = h.charCodeAt(m))) == 55296 && m + 1 < F && (64512 & (_ = h.charCodeAt(m + 1))) == 56320 && (R = 65536 + (R - 55296 << 10) + (_ - 56320), m++), R < 128 ? S[L++] = R : (R < 2048 ? S[L++] = 192 | R >>> 6 : (R < 65536 ? S[L++] = 224 | R >>> 12 : (S[L++] = 240 | R >>> 18, S[L++] = 128 | R >>> 12 & 63), S[L++] = 128 | R >>> 6 & 63), S[L++] = 128 | 63 & R);
        return S;
      }, a.buf2binstring = function(h) {
        return f(h, h.length);
      }, a.binstring2buf = function(h) {
        for (var S = new l.Buf8(h.length), R = 0, _ = S.length; R < _; R++)
          S[R] = h.charCodeAt(R);
        return S;
      }, a.buf2string = function(h, S) {
        var R, _, m, L, F = S || h.length, W = new Array(2 * F);
        for (R = _ = 0; R < F; )
          if ((m = h[R++]) < 128)
            W[_++] = m;
          else if (4 < (L = E[m]))
            W[_++] = 65533, R += L - 1;
          else {
            for (m &= L === 2 ? 31 : L === 3 ? 15 : 7; 1 < L && R < F; )
              m = m << 6 | 63 & h[R++], L--;
            1 < L ? W[_++] = 65533 : m < 65536 ? W[_++] = m : (m -= 65536, W[_++] = 55296 | m >> 10 & 1023, W[_++] = 56320 | 1023 & m);
          }
        return f(W, _);
      }, a.utf8border = function(h, S) {
        var R;
        for ((S = S || h.length) > h.length && (S = h.length), R = S - 1; 0 <= R && (192 & h[R]) == 128; )
          R--;
        return R < 0 || R === 0 ? S : R + E[h[R]] > S ? R : S;
      };
    }, { "./common": 41 }], 43: [function(s, o, a) {
      o.exports = function(l, u, c, E) {
        for (var d = 65535 & l | 0, f = l >>> 16 & 65535 | 0, h = 0; c !== 0; ) {
          for (c -= h = 2e3 < c ? 2e3 : c; f = f + (d = d + u[E++] | 0) | 0, --h; )
            ;
          d %= 65521, f %= 65521;
        }
        return d | f << 16 | 0;
      };
    }, {}], 44: [function(s, o, a) {
      o.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(s, o, a) {
      var l = function() {
        for (var u, c = [], E = 0; E < 256; E++) {
          u = E;
          for (var d = 0; d < 8; d++)
            u = 1 & u ? 3988292384 ^ u >>> 1 : u >>> 1;
          c[E] = u;
        }
        return c;
      }();
      o.exports = function(u, c, E, d) {
        var f = l, h = d + E;
        u ^= -1;
        for (var S = d; S < h; S++)
          u = u >>> 8 ^ f[255 & (u ^ c[S])];
        return -1 ^ u;
      };
    }, {}], 46: [function(s, o, a) {
      var l, u = s("../utils/common"), c = s("./trees"), E = s("./adler32"), d = s("./crc32"), f = s("./messages"), h = 0, S = 4, R = 0, _ = -2, m = -1, L = 4, F = 2, W = 8, G = 9, q = 286, fe = 30, _e = 19, Le = 2 * q + 1, Fe = 15, Ee = 3, Ge = 258, ve = Ge + Ee + 1, te = 42, ae = 113, v = 1, Te = 2, De = 3, be = 4;
      function ze(lt, Zt) {
        return lt.msg = f[Zt], Zt;
      }
      function ke(lt) {
        return (lt << 1) - (4 < lt ? 9 : 0);
      }
      function Be(lt) {
        for (var Zt = lt.length; 0 <= --Zt; )
          lt[Zt] = 0;
      }
      function Me(lt) {
        var Zt = lt.state, Et = Zt.pending;
        Et > lt.avail_out && (Et = lt.avail_out), Et !== 0 && (u.arraySet(lt.output, Zt.pending_buf, Zt.pending_out, Et, lt.next_out), lt.next_out += Et, Zt.pending_out += Et, lt.total_out += Et, lt.avail_out -= Et, Zt.pending -= Et, Zt.pending === 0 && (Zt.pending_out = 0));
      }
      function me(lt, Zt) {
        c._tr_flush_block(lt, 0 <= lt.block_start ? lt.block_start : -1, lt.strstart - lt.block_start, Zt), lt.block_start = lt.strstart, Me(lt.strm);
      }
      function Se(lt, Zt) {
        lt.pending_buf[lt.pending++] = Zt;
      }
      function xt(lt, Zt) {
        lt.pending_buf[lt.pending++] = Zt >>> 8 & 255, lt.pending_buf[lt.pending++] = 255 & Zt;
      }
      function Ht(lt, Zt) {
        var Et, Ke, $e = lt.max_chain_length, pt = lt.strstart, Jt = lt.prev_length, In = lt.nice_match, Cn = lt.strstart > lt.w_size - ve ? lt.strstart - (lt.w_size - ve) : 0, It = lt.window, ht = lt.w_mask, Wt = lt.prev, hn = lt.strstart + Ge, Vt = It[pt + Jt - 1], Tn = It[pt + Jt];
        lt.prev_length >= lt.good_match && ($e >>= 2), In > lt.lookahead && (In = lt.lookahead);
        do
          if (It[(Et = Zt) + Jt] === Tn && It[Et + Jt - 1] === Vt && It[Et] === It[pt] && It[++Et] === It[pt + 1]) {
            pt += 2, Et++;
            do
              ;
            while (It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && It[++pt] === It[++Et] && pt < hn);
            if (Ke = Ge - (hn - pt), pt = hn - Ge, Jt < Ke) {
              if (lt.match_start = Zt, In <= (Jt = Ke))
                break;
              Vt = It[pt + Jt - 1], Tn = It[pt + Jt];
            }
          }
        while ((Zt = Wt[Zt & ht]) > Cn && --$e != 0);
        return Jt <= lt.lookahead ? Jt : lt.lookahead;
      }
      function Bt(lt) {
        var Zt, Et, Ke, $e, pt, Jt, In, Cn, It, ht, Wt = lt.w_size;
        do {
          if ($e = lt.window_size - lt.lookahead - lt.strstart, lt.strstart >= Wt + (Wt - ve)) {
            for (u.arraySet(lt.window, lt.window, Wt, Wt, 0), lt.match_start -= Wt, lt.strstart -= Wt, lt.block_start -= Wt, Zt = Et = lt.hash_size; Ke = lt.head[--Zt], lt.head[Zt] = Wt <= Ke ? Ke - Wt : 0, --Et; )
              ;
            for (Zt = Et = Wt; Ke = lt.prev[--Zt], lt.prev[Zt] = Wt <= Ke ? Ke - Wt : 0, --Et; )
              ;
            $e += Wt;
          }
          if (lt.strm.avail_in === 0)
            break;
          if (Jt = lt.strm, In = lt.window, Cn = lt.strstart + lt.lookahead, It = $e, ht = void 0, ht = Jt.avail_in, It < ht && (ht = It), Et = ht === 0 ? 0 : (Jt.avail_in -= ht, u.arraySet(In, Jt.input, Jt.next_in, ht, Cn), Jt.state.wrap === 1 ? Jt.adler = E(Jt.adler, In, ht, Cn) : Jt.state.wrap === 2 && (Jt.adler = d(Jt.adler, In, ht, Cn)), Jt.next_in += ht, Jt.total_in += ht, ht), lt.lookahead += Et, lt.lookahead + lt.insert >= Ee)
            for (pt = lt.strstart - lt.insert, lt.ins_h = lt.window[pt], lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[pt + 1]) & lt.hash_mask; lt.insert && (lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[pt + Ee - 1]) & lt.hash_mask, lt.prev[pt & lt.w_mask] = lt.head[lt.ins_h], lt.head[lt.ins_h] = pt, pt++, lt.insert--, !(lt.lookahead + lt.insert < Ee)); )
              ;
        } while (lt.lookahead < ve && lt.strm.avail_in !== 0);
      }
      function ut(lt, Zt) {
        for (var Et, Ke; ; ) {
          if (lt.lookahead < ve) {
            if (Bt(lt), lt.lookahead < ve && Zt === h)
              return v;
            if (lt.lookahead === 0)
              break;
          }
          if (Et = 0, lt.lookahead >= Ee && (lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[lt.strstart + Ee - 1]) & lt.hash_mask, Et = lt.prev[lt.strstart & lt.w_mask] = lt.head[lt.ins_h], lt.head[lt.ins_h] = lt.strstart), Et !== 0 && lt.strstart - Et <= lt.w_size - ve && (lt.match_length = Ht(lt, Et)), lt.match_length >= Ee)
            if (Ke = c._tr_tally(lt, lt.strstart - lt.match_start, lt.match_length - Ee), lt.lookahead -= lt.match_length, lt.match_length <= lt.max_lazy_match && lt.lookahead >= Ee) {
              for (lt.match_length--; lt.strstart++, lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[lt.strstart + Ee - 1]) & lt.hash_mask, Et = lt.prev[lt.strstart & lt.w_mask] = lt.head[lt.ins_h], lt.head[lt.ins_h] = lt.strstart, --lt.match_length != 0; )
                ;
              lt.strstart++;
            } else
              lt.strstart += lt.match_length, lt.match_length = 0, lt.ins_h = lt.window[lt.strstart], lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[lt.strstart + 1]) & lt.hash_mask;
          else
            Ke = c._tr_tally(lt, 0, lt.window[lt.strstart]), lt.lookahead--, lt.strstart++;
          if (Ke && (me(lt, !1), lt.strm.avail_out === 0))
            return v;
        }
        return lt.insert = lt.strstart < Ee - 1 ? lt.strstart : Ee - 1, Zt === S ? (me(lt, !0), lt.strm.avail_out === 0 ? De : be) : lt.last_lit && (me(lt, !1), lt.strm.avail_out === 0) ? v : Te;
      }
      function Tt(lt, Zt) {
        for (var Et, Ke, $e; ; ) {
          if (lt.lookahead < ve) {
            if (Bt(lt), lt.lookahead < ve && Zt === h)
              return v;
            if (lt.lookahead === 0)
              break;
          }
          if (Et = 0, lt.lookahead >= Ee && (lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[lt.strstart + Ee - 1]) & lt.hash_mask, Et = lt.prev[lt.strstart & lt.w_mask] = lt.head[lt.ins_h], lt.head[lt.ins_h] = lt.strstart), lt.prev_length = lt.match_length, lt.prev_match = lt.match_start, lt.match_length = Ee - 1, Et !== 0 && lt.prev_length < lt.max_lazy_match && lt.strstart - Et <= lt.w_size - ve && (lt.match_length = Ht(lt, Et), lt.match_length <= 5 && (lt.strategy === 1 || lt.match_length === Ee && 4096 < lt.strstart - lt.match_start) && (lt.match_length = Ee - 1)), lt.prev_length >= Ee && lt.match_length <= lt.prev_length) {
            for ($e = lt.strstart + lt.lookahead - Ee, Ke = c._tr_tally(lt, lt.strstart - 1 - lt.prev_match, lt.prev_length - Ee), lt.lookahead -= lt.prev_length - 1, lt.prev_length -= 2; ++lt.strstart <= $e && (lt.ins_h = (lt.ins_h << lt.hash_shift ^ lt.window[lt.strstart + Ee - 1]) & lt.hash_mask, Et = lt.prev[lt.strstart & lt.w_mask] = lt.head[lt.ins_h], lt.head[lt.ins_h] = lt.strstart), --lt.prev_length != 0; )
              ;
            if (lt.match_available = 0, lt.match_length = Ee - 1, lt.strstart++, Ke && (me(lt, !1), lt.strm.avail_out === 0))
              return v;
          } else if (lt.match_available) {
            if ((Ke = c._tr_tally(lt, 0, lt.window[lt.strstart - 1])) && me(lt, !1), lt.strstart++, lt.lookahead--, lt.strm.avail_out === 0)
              return v;
          } else
            lt.match_available = 1, lt.strstart++, lt.lookahead--;
        }
        return lt.match_available && (Ke = c._tr_tally(lt, 0, lt.window[lt.strstart - 1]), lt.match_available = 0), lt.insert = lt.strstart < Ee - 1 ? lt.strstart : Ee - 1, Zt === S ? (me(lt, !0), lt.strm.avail_out === 0 ? De : be) : lt.last_lit && (me(lt, !1), lt.strm.avail_out === 0) ? v : Te;
      }
      function Yt(lt, Zt, Et, Ke, $e) {
        this.good_length = lt, this.max_lazy = Zt, this.nice_length = Et, this.max_chain = Ke, this.func = $e;
      }
      function an() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = W, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new u.Buf16(2 * Le), this.dyn_dtree = new u.Buf16(2 * (2 * fe + 1)), this.bl_tree = new u.Buf16(2 * (2 * _e + 1)), Be(this.dyn_ltree), Be(this.dyn_dtree), Be(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new u.Buf16(Fe + 1), this.heap = new u.Buf16(2 * q + 1), Be(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new u.Buf16(2 * q + 1), Be(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function Ct(lt) {
        var Zt;
        return lt && lt.state ? (lt.total_in = lt.total_out = 0, lt.data_type = F, (Zt = lt.state).pending = 0, Zt.pending_out = 0, Zt.wrap < 0 && (Zt.wrap = -Zt.wrap), Zt.status = Zt.wrap ? te : ae, lt.adler = Zt.wrap === 2 ? 0 : 1, Zt.last_flush = h, c._tr_init(Zt), R) : ze(lt, _);
      }
      function st(lt) {
        var Zt = Ct(lt);
        return Zt === R && function(Et) {
          Et.window_size = 2 * Et.w_size, Be(Et.head), Et.max_lazy_match = l[Et.level].max_lazy, Et.good_match = l[Et.level].good_length, Et.nice_match = l[Et.level].nice_length, Et.max_chain_length = l[Et.level].max_chain, Et.strstart = 0, Et.block_start = 0, Et.lookahead = 0, Et.insert = 0, Et.match_length = Et.prev_length = Ee - 1, Et.match_available = 0, Et.ins_h = 0;
        }(lt.state), Zt;
      }
      function jt(lt, Zt, Et, Ke, $e, pt) {
        if (!lt)
          return _;
        var Jt = 1;
        if (Zt === m && (Zt = 6), Ke < 0 ? (Jt = 0, Ke = -Ke) : 15 < Ke && (Jt = 2, Ke -= 16), $e < 1 || G < $e || Et !== W || Ke < 8 || 15 < Ke || Zt < 0 || 9 < Zt || pt < 0 || L < pt)
          return ze(lt, _);
        Ke === 8 && (Ke = 9);
        var In = new an();
        return (lt.state = In).strm = lt, In.wrap = Jt, In.gzhead = null, In.w_bits = Ke, In.w_size = 1 << In.w_bits, In.w_mask = In.w_size - 1, In.hash_bits = $e + 7, In.hash_size = 1 << In.hash_bits, In.hash_mask = In.hash_size - 1, In.hash_shift = ~~((In.hash_bits + Ee - 1) / Ee), In.window = new u.Buf8(2 * In.w_size), In.head = new u.Buf16(In.hash_size), In.prev = new u.Buf16(In.w_size), In.lit_bufsize = 1 << $e + 6, In.pending_buf_size = 4 * In.lit_bufsize, In.pending_buf = new u.Buf8(In.pending_buf_size), In.d_buf = 1 * In.lit_bufsize, In.l_buf = 3 * In.lit_bufsize, In.level = Zt, In.strategy = pt, In.method = Et, st(lt);
      }
      l = [new Yt(0, 0, 0, 0, function(lt, Zt) {
        var Et = 65535;
        for (Et > lt.pending_buf_size - 5 && (Et = lt.pending_buf_size - 5); ; ) {
          if (lt.lookahead <= 1) {
            if (Bt(lt), lt.lookahead === 0 && Zt === h)
              return v;
            if (lt.lookahead === 0)
              break;
          }
          lt.strstart += lt.lookahead, lt.lookahead = 0;
          var Ke = lt.block_start + Et;
          if ((lt.strstart === 0 || lt.strstart >= Ke) && (lt.lookahead = lt.strstart - Ke, lt.strstart = Ke, me(lt, !1), lt.strm.avail_out === 0) || lt.strstart - lt.block_start >= lt.w_size - ve && (me(lt, !1), lt.strm.avail_out === 0))
            return v;
        }
        return lt.insert = 0, Zt === S ? (me(lt, !0), lt.strm.avail_out === 0 ? De : be) : (lt.strstart > lt.block_start && (me(lt, !1), lt.strm.avail_out), v);
      }), new Yt(4, 4, 8, 4, ut), new Yt(4, 5, 16, 8, ut), new Yt(4, 6, 32, 32, ut), new Yt(4, 4, 16, 16, Tt), new Yt(8, 16, 32, 32, Tt), new Yt(8, 16, 128, 128, Tt), new Yt(8, 32, 128, 256, Tt), new Yt(32, 128, 258, 1024, Tt), new Yt(32, 258, 258, 4096, Tt)], a.deflateInit = function(lt, Zt) {
        return jt(lt, Zt, W, 15, 8, 0);
      }, a.deflateInit2 = jt, a.deflateReset = st, a.deflateResetKeep = Ct, a.deflateSetHeader = function(lt, Zt) {
        return lt && lt.state ? lt.state.wrap !== 2 ? _ : (lt.state.gzhead = Zt, R) : _;
      }, a.deflate = function(lt, Zt) {
        var Et, Ke, $e, pt;
        if (!lt || !lt.state || 5 < Zt || Zt < 0)
          return lt ? ze(lt, _) : _;
        if (Ke = lt.state, !lt.output || !lt.input && lt.avail_in !== 0 || Ke.status === 666 && Zt !== S)
          return ze(lt, lt.avail_out === 0 ? -5 : _);
        if (Ke.strm = lt, Et = Ke.last_flush, Ke.last_flush = Zt, Ke.status === te)
          if (Ke.wrap === 2)
            lt.adler = 0, Se(Ke, 31), Se(Ke, 139), Se(Ke, 8), Ke.gzhead ? (Se(Ke, (Ke.gzhead.text ? 1 : 0) + (Ke.gzhead.hcrc ? 2 : 0) + (Ke.gzhead.extra ? 4 : 0) + (Ke.gzhead.name ? 8 : 0) + (Ke.gzhead.comment ? 16 : 0)), Se(Ke, 255 & Ke.gzhead.time), Se(Ke, Ke.gzhead.time >> 8 & 255), Se(Ke, Ke.gzhead.time >> 16 & 255), Se(Ke, Ke.gzhead.time >> 24 & 255), Se(Ke, Ke.level === 9 ? 2 : 2 <= Ke.strategy || Ke.level < 2 ? 4 : 0), Se(Ke, 255 & Ke.gzhead.os), Ke.gzhead.extra && Ke.gzhead.extra.length && (Se(Ke, 255 & Ke.gzhead.extra.length), Se(Ke, Ke.gzhead.extra.length >> 8 & 255)), Ke.gzhead.hcrc && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending, 0)), Ke.gzindex = 0, Ke.status = 69) : (Se(Ke, 0), Se(Ke, 0), Se(Ke, 0), Se(Ke, 0), Se(Ke, 0), Se(Ke, Ke.level === 9 ? 2 : 2 <= Ke.strategy || Ke.level < 2 ? 4 : 0), Se(Ke, 3), Ke.status = ae);
          else {
            var Jt = W + (Ke.w_bits - 8 << 4) << 8;
            Jt |= (2 <= Ke.strategy || Ke.level < 2 ? 0 : Ke.level < 6 ? 1 : Ke.level === 6 ? 2 : 3) << 6, Ke.strstart !== 0 && (Jt |= 32), Jt += 31 - Jt % 31, Ke.status = ae, xt(Ke, Jt), Ke.strstart !== 0 && (xt(Ke, lt.adler >>> 16), xt(Ke, 65535 & lt.adler)), lt.adler = 1;
          }
        if (Ke.status === 69)
          if (Ke.gzhead.extra) {
            for ($e = Ke.pending; Ke.gzindex < (65535 & Ke.gzhead.extra.length) && (Ke.pending !== Ke.pending_buf_size || (Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), Me(lt), $e = Ke.pending, Ke.pending !== Ke.pending_buf_size)); )
              Se(Ke, 255 & Ke.gzhead.extra[Ke.gzindex]), Ke.gzindex++;
            Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), Ke.gzindex === Ke.gzhead.extra.length && (Ke.gzindex = 0, Ke.status = 73);
          } else
            Ke.status = 73;
        if (Ke.status === 73)
          if (Ke.gzhead.name) {
            $e = Ke.pending;
            do {
              if (Ke.pending === Ke.pending_buf_size && (Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), Me(lt), $e = Ke.pending, Ke.pending === Ke.pending_buf_size)) {
                pt = 1;
                break;
              }
              pt = Ke.gzindex < Ke.gzhead.name.length ? 255 & Ke.gzhead.name.charCodeAt(Ke.gzindex++) : 0, Se(Ke, pt);
            } while (pt !== 0);
            Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), pt === 0 && (Ke.gzindex = 0, Ke.status = 91);
          } else
            Ke.status = 91;
        if (Ke.status === 91)
          if (Ke.gzhead.comment) {
            $e = Ke.pending;
            do {
              if (Ke.pending === Ke.pending_buf_size && (Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), Me(lt), $e = Ke.pending, Ke.pending === Ke.pending_buf_size)) {
                pt = 1;
                break;
              }
              pt = Ke.gzindex < Ke.gzhead.comment.length ? 255 & Ke.gzhead.comment.charCodeAt(Ke.gzindex++) : 0, Se(Ke, pt);
            } while (pt !== 0);
            Ke.gzhead.hcrc && Ke.pending > $e && (lt.adler = d(lt.adler, Ke.pending_buf, Ke.pending - $e, $e)), pt === 0 && (Ke.status = 103);
          } else
            Ke.status = 103;
        if (Ke.status === 103 && (Ke.gzhead.hcrc ? (Ke.pending + 2 > Ke.pending_buf_size && Me(lt), Ke.pending + 2 <= Ke.pending_buf_size && (Se(Ke, 255 & lt.adler), Se(Ke, lt.adler >> 8 & 255), lt.adler = 0, Ke.status = ae)) : Ke.status = ae), Ke.pending !== 0) {
          if (Me(lt), lt.avail_out === 0)
            return Ke.last_flush = -1, R;
        } else if (lt.avail_in === 0 && ke(Zt) <= ke(Et) && Zt !== S)
          return ze(lt, -5);
        if (Ke.status === 666 && lt.avail_in !== 0)
          return ze(lt, -5);
        if (lt.avail_in !== 0 || Ke.lookahead !== 0 || Zt !== h && Ke.status !== 666) {
          var In = Ke.strategy === 2 ? function(Cn, It) {
            for (var ht; ; ) {
              if (Cn.lookahead === 0 && (Bt(Cn), Cn.lookahead === 0)) {
                if (It === h)
                  return v;
                break;
              }
              if (Cn.match_length = 0, ht = c._tr_tally(Cn, 0, Cn.window[Cn.strstart]), Cn.lookahead--, Cn.strstart++, ht && (me(Cn, !1), Cn.strm.avail_out === 0))
                return v;
            }
            return Cn.insert = 0, It === S ? (me(Cn, !0), Cn.strm.avail_out === 0 ? De : be) : Cn.last_lit && (me(Cn, !1), Cn.strm.avail_out === 0) ? v : Te;
          }(Ke, Zt) : Ke.strategy === 3 ? function(Cn, It) {
            for (var ht, Wt, hn, Vt, Tn = Cn.window; ; ) {
              if (Cn.lookahead <= Ge) {
                if (Bt(Cn), Cn.lookahead <= Ge && It === h)
                  return v;
                if (Cn.lookahead === 0)
                  break;
              }
              if (Cn.match_length = 0, Cn.lookahead >= Ee && 0 < Cn.strstart && (Wt = Tn[hn = Cn.strstart - 1]) === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn]) {
                Vt = Cn.strstart + Ge;
                do
                  ;
                while (Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && Wt === Tn[++hn] && hn < Vt);
                Cn.match_length = Ge - (Vt - hn), Cn.match_length > Cn.lookahead && (Cn.match_length = Cn.lookahead);
              }
              if (Cn.match_length >= Ee ? (ht = c._tr_tally(Cn, 1, Cn.match_length - Ee), Cn.lookahead -= Cn.match_length, Cn.strstart += Cn.match_length, Cn.match_length = 0) : (ht = c._tr_tally(Cn, 0, Cn.window[Cn.strstart]), Cn.lookahead--, Cn.strstart++), ht && (me(Cn, !1), Cn.strm.avail_out === 0))
                return v;
            }
            return Cn.insert = 0, It === S ? (me(Cn, !0), Cn.strm.avail_out === 0 ? De : be) : Cn.last_lit && (me(Cn, !1), Cn.strm.avail_out === 0) ? v : Te;
          }(Ke, Zt) : l[Ke.level].func(Ke, Zt);
          if (In !== De && In !== be || (Ke.status = 666), In === v || In === De)
            return lt.avail_out === 0 && (Ke.last_flush = -1), R;
          if (In === Te && (Zt === 1 ? c._tr_align(Ke) : Zt !== 5 && (c._tr_stored_block(Ke, 0, 0, !1), Zt === 3 && (Be(Ke.head), Ke.lookahead === 0 && (Ke.strstart = 0, Ke.block_start = 0, Ke.insert = 0))), Me(lt), lt.avail_out === 0))
            return Ke.last_flush = -1, R;
        }
        return Zt !== S ? R : Ke.wrap <= 0 ? 1 : (Ke.wrap === 2 ? (Se(Ke, 255 & lt.adler), Se(Ke, lt.adler >> 8 & 255), Se(Ke, lt.adler >> 16 & 255), Se(Ke, lt.adler >> 24 & 255), Se(Ke, 255 & lt.total_in), Se(Ke, lt.total_in >> 8 & 255), Se(Ke, lt.total_in >> 16 & 255), Se(Ke, lt.total_in >> 24 & 255)) : (xt(Ke, lt.adler >>> 16), xt(Ke, 65535 & lt.adler)), Me(lt), 0 < Ke.wrap && (Ke.wrap = -Ke.wrap), Ke.pending !== 0 ? R : 1);
      }, a.deflateEnd = function(lt) {
        var Zt;
        return lt && lt.state ? (Zt = lt.state.status) !== te && Zt !== 69 && Zt !== 73 && Zt !== 91 && Zt !== 103 && Zt !== ae && Zt !== 666 ? ze(lt, _) : (lt.state = null, Zt === ae ? ze(lt, -3) : R) : _;
      }, a.deflateSetDictionary = function(lt, Zt) {
        var Et, Ke, $e, pt, Jt, In, Cn, It, ht = Zt.length;
        if (!lt || !lt.state || (pt = (Et = lt.state).wrap) === 2 || pt === 1 && Et.status !== te || Et.lookahead)
          return _;
        for (pt === 1 && (lt.adler = E(lt.adler, Zt, ht, 0)), Et.wrap = 0, ht >= Et.w_size && (pt === 0 && (Be(Et.head), Et.strstart = 0, Et.block_start = 0, Et.insert = 0), It = new u.Buf8(Et.w_size), u.arraySet(It, Zt, ht - Et.w_size, Et.w_size, 0), Zt = It, ht = Et.w_size), Jt = lt.avail_in, In = lt.next_in, Cn = lt.input, lt.avail_in = ht, lt.next_in = 0, lt.input = Zt, Bt(Et); Et.lookahead >= Ee; ) {
          for (Ke = Et.strstart, $e = Et.lookahead - (Ee - 1); Et.ins_h = (Et.ins_h << Et.hash_shift ^ Et.window[Ke + Ee - 1]) & Et.hash_mask, Et.prev[Ke & Et.w_mask] = Et.head[Et.ins_h], Et.head[Et.ins_h] = Ke, Ke++, --$e; )
            ;
          Et.strstart = Ke, Et.lookahead = Ee - 1, Bt(Et);
        }
        return Et.strstart += Et.lookahead, Et.block_start = Et.strstart, Et.insert = Et.lookahead, Et.lookahead = 0, Et.match_length = Et.prev_length = Ee - 1, Et.match_available = 0, lt.next_in = In, lt.input = Cn, lt.avail_in = Jt, Et.wrap = pt, R;
      }, a.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(s, o, a) {
      o.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(s, o, a) {
      o.exports = function(l, u) {
        var c, E, d, f, h, S, R, _, m, L, F, W, G, q, fe, _e, Le, Fe, Ee, Ge, ve, te, ae, v, Te;
        c = l.state, E = l.next_in, v = l.input, d = E + (l.avail_in - 5), f = l.next_out, Te = l.output, h = f - (u - l.avail_out), S = f + (l.avail_out - 257), R = c.dmax, _ = c.wsize, m = c.whave, L = c.wnext, F = c.window, W = c.hold, G = c.bits, q = c.lencode, fe = c.distcode, _e = (1 << c.lenbits) - 1, Le = (1 << c.distbits) - 1;
        e:
          do {
            G < 15 && (W += v[E++] << G, G += 8, W += v[E++] << G, G += 8), Fe = q[W & _e];
            t:
              for (; ; ) {
                if (W >>>= Ee = Fe >>> 24, G -= Ee, (Ee = Fe >>> 16 & 255) === 0)
                  Te[f++] = 65535 & Fe;
                else {
                  if (!(16 & Ee)) {
                    if (!(64 & Ee)) {
                      Fe = q[(65535 & Fe) + (W & (1 << Ee) - 1)];
                      continue t;
                    }
                    if (32 & Ee) {
                      c.mode = 12;
                      break e;
                    }
                    l.msg = "invalid literal/length code", c.mode = 30;
                    break e;
                  }
                  Ge = 65535 & Fe, (Ee &= 15) && (G < Ee && (W += v[E++] << G, G += 8), Ge += W & (1 << Ee) - 1, W >>>= Ee, G -= Ee), G < 15 && (W += v[E++] << G, G += 8, W += v[E++] << G, G += 8), Fe = fe[W & Le];
                  n:
                    for (; ; ) {
                      if (W >>>= Ee = Fe >>> 24, G -= Ee, !(16 & (Ee = Fe >>> 16 & 255))) {
                        if (!(64 & Ee)) {
                          Fe = fe[(65535 & Fe) + (W & (1 << Ee) - 1)];
                          continue n;
                        }
                        l.msg = "invalid distance code", c.mode = 30;
                        break e;
                      }
                      if (ve = 65535 & Fe, G < (Ee &= 15) && (W += v[E++] << G, (G += 8) < Ee && (W += v[E++] << G, G += 8)), R < (ve += W & (1 << Ee) - 1)) {
                        l.msg = "invalid distance too far back", c.mode = 30;
                        break e;
                      }
                      if (W >>>= Ee, G -= Ee, (Ee = f - h) < ve) {
                        if (m < (Ee = ve - Ee) && c.sane) {
                          l.msg = "invalid distance too far back", c.mode = 30;
                          break e;
                        }
                        if (ae = F, (te = 0) === L) {
                          if (te += _ - Ee, Ee < Ge) {
                            for (Ge -= Ee; Te[f++] = F[te++], --Ee; )
                              ;
                            te = f - ve, ae = Te;
                          }
                        } else if (L < Ee) {
                          if (te += _ + L - Ee, (Ee -= L) < Ge) {
                            for (Ge -= Ee; Te[f++] = F[te++], --Ee; )
                              ;
                            if (te = 0, L < Ge) {
                              for (Ge -= Ee = L; Te[f++] = F[te++], --Ee; )
                                ;
                              te = f - ve, ae = Te;
                            }
                          }
                        } else if (te += L - Ee, Ee < Ge) {
                          for (Ge -= Ee; Te[f++] = F[te++], --Ee; )
                            ;
                          te = f - ve, ae = Te;
                        }
                        for (; 2 < Ge; )
                          Te[f++] = ae[te++], Te[f++] = ae[te++], Te[f++] = ae[te++], Ge -= 3;
                        Ge && (Te[f++] = ae[te++], 1 < Ge && (Te[f++] = ae[te++]));
                      } else {
                        for (te = f - ve; Te[f++] = Te[te++], Te[f++] = Te[te++], Te[f++] = Te[te++], 2 < (Ge -= 3); )
                          ;
                        Ge && (Te[f++] = Te[te++], 1 < Ge && (Te[f++] = Te[te++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (E < d && f < S);
        E -= Ge = G >> 3, W &= (1 << (G -= Ge << 3)) - 1, l.next_in = E, l.next_out = f, l.avail_in = E < d ? d - E + 5 : 5 - (E - d), l.avail_out = f < S ? S - f + 257 : 257 - (f - S), c.hold = W, c.bits = G;
      };
    }, {}], 49: [function(s, o, a) {
      var l = s("../utils/common"), u = s("./adler32"), c = s("./crc32"), E = s("./inffast"), d = s("./inftrees"), f = 1, h = 2, S = 0, R = -2, _ = 1, m = 852, L = 592;
      function F(te) {
        return (te >>> 24 & 255) + (te >>> 8 & 65280) + ((65280 & te) << 8) + ((255 & te) << 24);
      }
      function W() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new l.Buf16(320), this.work = new l.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function G(te) {
        var ae;
        return te && te.state ? (ae = te.state, te.total_in = te.total_out = ae.total = 0, te.msg = "", ae.wrap && (te.adler = 1 & ae.wrap), ae.mode = _, ae.last = 0, ae.havedict = 0, ae.dmax = 32768, ae.head = null, ae.hold = 0, ae.bits = 0, ae.lencode = ae.lendyn = new l.Buf32(m), ae.distcode = ae.distdyn = new l.Buf32(L), ae.sane = 1, ae.back = -1, S) : R;
      }
      function q(te) {
        var ae;
        return te && te.state ? ((ae = te.state).wsize = 0, ae.whave = 0, ae.wnext = 0, G(te)) : R;
      }
      function fe(te, ae) {
        var v, Te;
        return te && te.state ? (Te = te.state, ae < 0 ? (v = 0, ae = -ae) : (v = 1 + (ae >> 4), ae < 48 && (ae &= 15)), ae && (ae < 8 || 15 < ae) ? R : (Te.window !== null && Te.wbits !== ae && (Te.window = null), Te.wrap = v, Te.wbits = ae, q(te))) : R;
      }
      function _e(te, ae) {
        var v, Te;
        return te ? (Te = new W(), (te.state = Te).window = null, (v = fe(te, ae)) !== S && (te.state = null), v) : R;
      }
      var Le, Fe, Ee = !0;
      function Ge(te) {
        if (Ee) {
          var ae;
          for (Le = new l.Buf32(512), Fe = new l.Buf32(32), ae = 0; ae < 144; )
            te.lens[ae++] = 8;
          for (; ae < 256; )
            te.lens[ae++] = 9;
          for (; ae < 280; )
            te.lens[ae++] = 7;
          for (; ae < 288; )
            te.lens[ae++] = 8;
          for (d(f, te.lens, 0, 288, Le, 0, te.work, { bits: 9 }), ae = 0; ae < 32; )
            te.lens[ae++] = 5;
          d(h, te.lens, 0, 32, Fe, 0, te.work, { bits: 5 }), Ee = !1;
        }
        te.lencode = Le, te.lenbits = 9, te.distcode = Fe, te.distbits = 5;
      }
      function ve(te, ae, v, Te) {
        var De, be = te.state;
        return be.window === null && (be.wsize = 1 << be.wbits, be.wnext = 0, be.whave = 0, be.window = new l.Buf8(be.wsize)), Te >= be.wsize ? (l.arraySet(be.window, ae, v - be.wsize, be.wsize, 0), be.wnext = 0, be.whave = be.wsize) : (Te < (De = be.wsize - be.wnext) && (De = Te), l.arraySet(be.window, ae, v - Te, De, be.wnext), (Te -= De) ? (l.arraySet(be.window, ae, v - Te, Te, 0), be.wnext = Te, be.whave = be.wsize) : (be.wnext += De, be.wnext === be.wsize && (be.wnext = 0), be.whave < be.wsize && (be.whave += De))), 0;
      }
      a.inflateReset = q, a.inflateReset2 = fe, a.inflateResetKeep = G, a.inflateInit = function(te) {
        return _e(te, 15);
      }, a.inflateInit2 = _e, a.inflate = function(te, ae) {
        var v, Te, De, be, ze, ke, Be, Me, me, Se, xt, Ht, Bt, ut, Tt, Yt, an, Ct, st, jt, lt, Zt, Et, Ke, $e = 0, pt = new l.Buf8(4), Jt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!te || !te.state || !te.output || !te.input && te.avail_in !== 0)
          return R;
        (v = te.state).mode === 12 && (v.mode = 13), ze = te.next_out, De = te.output, Be = te.avail_out, be = te.next_in, Te = te.input, ke = te.avail_in, Me = v.hold, me = v.bits, Se = ke, xt = Be, Zt = S;
        e:
          for (; ; )
            switch (v.mode) {
              case _:
                if (v.wrap === 0) {
                  v.mode = 13;
                  break;
                }
                for (; me < 16; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if (2 & v.wrap && Me === 35615) {
                  pt[v.check = 0] = 255 & Me, pt[1] = Me >>> 8 & 255, v.check = c(v.check, pt, 2, 0), me = Me = 0, v.mode = 2;
                  break;
                }
                if (v.flags = 0, v.head && (v.head.done = !1), !(1 & v.wrap) || (((255 & Me) << 8) + (Me >> 8)) % 31) {
                  te.msg = "incorrect header check", v.mode = 30;
                  break;
                }
                if ((15 & Me) != 8) {
                  te.msg = "unknown compression method", v.mode = 30;
                  break;
                }
                if (me -= 4, lt = 8 + (15 & (Me >>>= 4)), v.wbits === 0)
                  v.wbits = lt;
                else if (lt > v.wbits) {
                  te.msg = "invalid window size", v.mode = 30;
                  break;
                }
                v.dmax = 1 << lt, te.adler = v.check = 1, v.mode = 512 & Me ? 10 : 12, me = Me = 0;
                break;
              case 2:
                for (; me < 16; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if (v.flags = Me, (255 & v.flags) != 8) {
                  te.msg = "unknown compression method", v.mode = 30;
                  break;
                }
                if (57344 & v.flags) {
                  te.msg = "unknown header flags set", v.mode = 30;
                  break;
                }
                v.head && (v.head.text = Me >> 8 & 1), 512 & v.flags && (pt[0] = 255 & Me, pt[1] = Me >>> 8 & 255, v.check = c(v.check, pt, 2, 0)), me = Me = 0, v.mode = 3;
              case 3:
                for (; me < 32; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                v.head && (v.head.time = Me), 512 & v.flags && (pt[0] = 255 & Me, pt[1] = Me >>> 8 & 255, pt[2] = Me >>> 16 & 255, pt[3] = Me >>> 24 & 255, v.check = c(v.check, pt, 4, 0)), me = Me = 0, v.mode = 4;
              case 4:
                for (; me < 16; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                v.head && (v.head.xflags = 255 & Me, v.head.os = Me >> 8), 512 & v.flags && (pt[0] = 255 & Me, pt[1] = Me >>> 8 & 255, v.check = c(v.check, pt, 2, 0)), me = Me = 0, v.mode = 5;
              case 5:
                if (1024 & v.flags) {
                  for (; me < 16; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  v.length = Me, v.head && (v.head.extra_len = Me), 512 & v.flags && (pt[0] = 255 & Me, pt[1] = Me >>> 8 & 255, v.check = c(v.check, pt, 2, 0)), me = Me = 0;
                } else
                  v.head && (v.head.extra = null);
                v.mode = 6;
              case 6:
                if (1024 & v.flags && (ke < (Ht = v.length) && (Ht = ke), Ht && (v.head && (lt = v.head.extra_len - v.length, v.head.extra || (v.head.extra = new Array(v.head.extra_len)), l.arraySet(v.head.extra, Te, be, Ht, lt)), 512 & v.flags && (v.check = c(v.check, Te, Ht, be)), ke -= Ht, be += Ht, v.length -= Ht), v.length))
                  break e;
                v.length = 0, v.mode = 7;
              case 7:
                if (2048 & v.flags) {
                  if (ke === 0)
                    break e;
                  for (Ht = 0; lt = Te[be + Ht++], v.head && lt && v.length < 65536 && (v.head.name += String.fromCharCode(lt)), lt && Ht < ke; )
                    ;
                  if (512 & v.flags && (v.check = c(v.check, Te, Ht, be)), ke -= Ht, be += Ht, lt)
                    break e;
                } else
                  v.head && (v.head.name = null);
                v.length = 0, v.mode = 8;
              case 8:
                if (4096 & v.flags) {
                  if (ke === 0)
                    break e;
                  for (Ht = 0; lt = Te[be + Ht++], v.head && lt && v.length < 65536 && (v.head.comment += String.fromCharCode(lt)), lt && Ht < ke; )
                    ;
                  if (512 & v.flags && (v.check = c(v.check, Te, Ht, be)), ke -= Ht, be += Ht, lt)
                    break e;
                } else
                  v.head && (v.head.comment = null);
                v.mode = 9;
              case 9:
                if (512 & v.flags) {
                  for (; me < 16; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  if (Me !== (65535 & v.check)) {
                    te.msg = "header crc mismatch", v.mode = 30;
                    break;
                  }
                  me = Me = 0;
                }
                v.head && (v.head.hcrc = v.flags >> 9 & 1, v.head.done = !0), te.adler = v.check = 0, v.mode = 12;
                break;
              case 10:
                for (; me < 32; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                te.adler = v.check = F(Me), me = Me = 0, v.mode = 11;
              case 11:
                if (v.havedict === 0)
                  return te.next_out = ze, te.avail_out = Be, te.next_in = be, te.avail_in = ke, v.hold = Me, v.bits = me, 2;
                te.adler = v.check = 1, v.mode = 12;
              case 12:
                if (ae === 5 || ae === 6)
                  break e;
              case 13:
                if (v.last) {
                  Me >>>= 7 & me, me -= 7 & me, v.mode = 27;
                  break;
                }
                for (; me < 3; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                switch (v.last = 1 & Me, me -= 1, 3 & (Me >>>= 1)) {
                  case 0:
                    v.mode = 14;
                    break;
                  case 1:
                    if (Ge(v), v.mode = 20, ae !== 6)
                      break;
                    Me >>>= 2, me -= 2;
                    break e;
                  case 2:
                    v.mode = 17;
                    break;
                  case 3:
                    te.msg = "invalid block type", v.mode = 30;
                }
                Me >>>= 2, me -= 2;
                break;
              case 14:
                for (Me >>>= 7 & me, me -= 7 & me; me < 32; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if ((65535 & Me) != (Me >>> 16 ^ 65535)) {
                  te.msg = "invalid stored block lengths", v.mode = 30;
                  break;
                }
                if (v.length = 65535 & Me, me = Me = 0, v.mode = 15, ae === 6)
                  break e;
              case 15:
                v.mode = 16;
              case 16:
                if (Ht = v.length) {
                  if (ke < Ht && (Ht = ke), Be < Ht && (Ht = Be), Ht === 0)
                    break e;
                  l.arraySet(De, Te, be, Ht, ze), ke -= Ht, be += Ht, Be -= Ht, ze += Ht, v.length -= Ht;
                  break;
                }
                v.mode = 12;
                break;
              case 17:
                for (; me < 14; ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if (v.nlen = 257 + (31 & Me), Me >>>= 5, me -= 5, v.ndist = 1 + (31 & Me), Me >>>= 5, me -= 5, v.ncode = 4 + (15 & Me), Me >>>= 4, me -= 4, 286 < v.nlen || 30 < v.ndist) {
                  te.msg = "too many length or distance symbols", v.mode = 30;
                  break;
                }
                v.have = 0, v.mode = 18;
              case 18:
                for (; v.have < v.ncode; ) {
                  for (; me < 3; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  v.lens[Jt[v.have++]] = 7 & Me, Me >>>= 3, me -= 3;
                }
                for (; v.have < 19; )
                  v.lens[Jt[v.have++]] = 0;
                if (v.lencode = v.lendyn, v.lenbits = 7, Et = { bits: v.lenbits }, Zt = d(0, v.lens, 0, 19, v.lencode, 0, v.work, Et), v.lenbits = Et.bits, Zt) {
                  te.msg = "invalid code lengths set", v.mode = 30;
                  break;
                }
                v.have = 0, v.mode = 19;
              case 19:
                for (; v.have < v.nlen + v.ndist; ) {
                  for (; Yt = ($e = v.lencode[Me & (1 << v.lenbits) - 1]) >>> 16 & 255, an = 65535 & $e, !((Tt = $e >>> 24) <= me); ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  if (an < 16)
                    Me >>>= Tt, me -= Tt, v.lens[v.have++] = an;
                  else {
                    if (an === 16) {
                      for (Ke = Tt + 2; me < Ke; ) {
                        if (ke === 0)
                          break e;
                        ke--, Me += Te[be++] << me, me += 8;
                      }
                      if (Me >>>= Tt, me -= Tt, v.have === 0) {
                        te.msg = "invalid bit length repeat", v.mode = 30;
                        break;
                      }
                      lt = v.lens[v.have - 1], Ht = 3 + (3 & Me), Me >>>= 2, me -= 2;
                    } else if (an === 17) {
                      for (Ke = Tt + 3; me < Ke; ) {
                        if (ke === 0)
                          break e;
                        ke--, Me += Te[be++] << me, me += 8;
                      }
                      me -= Tt, lt = 0, Ht = 3 + (7 & (Me >>>= Tt)), Me >>>= 3, me -= 3;
                    } else {
                      for (Ke = Tt + 7; me < Ke; ) {
                        if (ke === 0)
                          break e;
                        ke--, Me += Te[be++] << me, me += 8;
                      }
                      me -= Tt, lt = 0, Ht = 11 + (127 & (Me >>>= Tt)), Me >>>= 7, me -= 7;
                    }
                    if (v.have + Ht > v.nlen + v.ndist) {
                      te.msg = "invalid bit length repeat", v.mode = 30;
                      break;
                    }
                    for (; Ht--; )
                      v.lens[v.have++] = lt;
                  }
                }
                if (v.mode === 30)
                  break;
                if (v.lens[256] === 0) {
                  te.msg = "invalid code -- missing end-of-block", v.mode = 30;
                  break;
                }
                if (v.lenbits = 9, Et = { bits: v.lenbits }, Zt = d(f, v.lens, 0, v.nlen, v.lencode, 0, v.work, Et), v.lenbits = Et.bits, Zt) {
                  te.msg = "invalid literal/lengths set", v.mode = 30;
                  break;
                }
                if (v.distbits = 6, v.distcode = v.distdyn, Et = { bits: v.distbits }, Zt = d(h, v.lens, v.nlen, v.ndist, v.distcode, 0, v.work, Et), v.distbits = Et.bits, Zt) {
                  te.msg = "invalid distances set", v.mode = 30;
                  break;
                }
                if (v.mode = 20, ae === 6)
                  break e;
              case 20:
                v.mode = 21;
              case 21:
                if (6 <= ke && 258 <= Be) {
                  te.next_out = ze, te.avail_out = Be, te.next_in = be, te.avail_in = ke, v.hold = Me, v.bits = me, E(te, xt), ze = te.next_out, De = te.output, Be = te.avail_out, be = te.next_in, Te = te.input, ke = te.avail_in, Me = v.hold, me = v.bits, v.mode === 12 && (v.back = -1);
                  break;
                }
                for (v.back = 0; Yt = ($e = v.lencode[Me & (1 << v.lenbits) - 1]) >>> 16 & 255, an = 65535 & $e, !((Tt = $e >>> 24) <= me); ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if (Yt && !(240 & Yt)) {
                  for (Ct = Tt, st = Yt, jt = an; Yt = ($e = v.lencode[jt + ((Me & (1 << Ct + st) - 1) >> Ct)]) >>> 16 & 255, an = 65535 & $e, !(Ct + (Tt = $e >>> 24) <= me); ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  Me >>>= Ct, me -= Ct, v.back += Ct;
                }
                if (Me >>>= Tt, me -= Tt, v.back += Tt, v.length = an, Yt === 0) {
                  v.mode = 26;
                  break;
                }
                if (32 & Yt) {
                  v.back = -1, v.mode = 12;
                  break;
                }
                if (64 & Yt) {
                  te.msg = "invalid literal/length code", v.mode = 30;
                  break;
                }
                v.extra = 15 & Yt, v.mode = 22;
              case 22:
                if (v.extra) {
                  for (Ke = v.extra; me < Ke; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  v.length += Me & (1 << v.extra) - 1, Me >>>= v.extra, me -= v.extra, v.back += v.extra;
                }
                v.was = v.length, v.mode = 23;
              case 23:
                for (; Yt = ($e = v.distcode[Me & (1 << v.distbits) - 1]) >>> 16 & 255, an = 65535 & $e, !((Tt = $e >>> 24) <= me); ) {
                  if (ke === 0)
                    break e;
                  ke--, Me += Te[be++] << me, me += 8;
                }
                if (!(240 & Yt)) {
                  for (Ct = Tt, st = Yt, jt = an; Yt = ($e = v.distcode[jt + ((Me & (1 << Ct + st) - 1) >> Ct)]) >>> 16 & 255, an = 65535 & $e, !(Ct + (Tt = $e >>> 24) <= me); ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  Me >>>= Ct, me -= Ct, v.back += Ct;
                }
                if (Me >>>= Tt, me -= Tt, v.back += Tt, 64 & Yt) {
                  te.msg = "invalid distance code", v.mode = 30;
                  break;
                }
                v.offset = an, v.extra = 15 & Yt, v.mode = 24;
              case 24:
                if (v.extra) {
                  for (Ke = v.extra; me < Ke; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  v.offset += Me & (1 << v.extra) - 1, Me >>>= v.extra, me -= v.extra, v.back += v.extra;
                }
                if (v.offset > v.dmax) {
                  te.msg = "invalid distance too far back", v.mode = 30;
                  break;
                }
                v.mode = 25;
              case 25:
                if (Be === 0)
                  break e;
                if (Ht = xt - Be, v.offset > Ht) {
                  if ((Ht = v.offset - Ht) > v.whave && v.sane) {
                    te.msg = "invalid distance too far back", v.mode = 30;
                    break;
                  }
                  Bt = Ht > v.wnext ? (Ht -= v.wnext, v.wsize - Ht) : v.wnext - Ht, Ht > v.length && (Ht = v.length), ut = v.window;
                } else
                  ut = De, Bt = ze - v.offset, Ht = v.length;
                for (Be < Ht && (Ht = Be), Be -= Ht, v.length -= Ht; De[ze++] = ut[Bt++], --Ht; )
                  ;
                v.length === 0 && (v.mode = 21);
                break;
              case 26:
                if (Be === 0)
                  break e;
                De[ze++] = v.length, Be--, v.mode = 21;
                break;
              case 27:
                if (v.wrap) {
                  for (; me < 32; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me |= Te[be++] << me, me += 8;
                  }
                  if (xt -= Be, te.total_out += xt, v.total += xt, xt && (te.adler = v.check = v.flags ? c(v.check, De, xt, ze - xt) : u(v.check, De, xt, ze - xt)), xt = Be, (v.flags ? Me : F(Me)) !== v.check) {
                    te.msg = "incorrect data check", v.mode = 30;
                    break;
                  }
                  me = Me = 0;
                }
                v.mode = 28;
              case 28:
                if (v.wrap && v.flags) {
                  for (; me < 32; ) {
                    if (ke === 0)
                      break e;
                    ke--, Me += Te[be++] << me, me += 8;
                  }
                  if (Me !== (4294967295 & v.total)) {
                    te.msg = "incorrect length check", v.mode = 30;
                    break;
                  }
                  me = Me = 0;
                }
                v.mode = 29;
              case 29:
                Zt = 1;
                break e;
              case 30:
                Zt = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return R;
            }
        return te.next_out = ze, te.avail_out = Be, te.next_in = be, te.avail_in = ke, v.hold = Me, v.bits = me, (v.wsize || xt !== te.avail_out && v.mode < 30 && (v.mode < 27 || ae !== 4)) && ve(te, te.output, te.next_out, xt - te.avail_out) ? (v.mode = 31, -4) : (Se -= te.avail_in, xt -= te.avail_out, te.total_in += Se, te.total_out += xt, v.total += xt, v.wrap && xt && (te.adler = v.check = v.flags ? c(v.check, De, xt, te.next_out - xt) : u(v.check, De, xt, te.next_out - xt)), te.data_type = v.bits + (v.last ? 64 : 0) + (v.mode === 12 ? 128 : 0) + (v.mode === 20 || v.mode === 15 ? 256 : 0), (Se == 0 && xt === 0 || ae === 4) && Zt === S && (Zt = -5), Zt);
      }, a.inflateEnd = function(te) {
        if (!te || !te.state)
          return R;
        var ae = te.state;
        return ae.window && (ae.window = null), te.state = null, S;
      }, a.inflateGetHeader = function(te, ae) {
        var v;
        return te && te.state && 2 & (v = te.state).wrap ? ((v.head = ae).done = !1, S) : R;
      }, a.inflateSetDictionary = function(te, ae) {
        var v, Te = ae.length;
        return te && te.state ? (v = te.state).wrap !== 0 && v.mode !== 11 ? R : v.mode === 11 && u(1, ae, Te, 0) !== v.check ? -3 : ve(te, ae, Te, Te) ? (v.mode = 31, -4) : (v.havedict = 1, S) : R;
      }, a.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(s, o, a) {
      var l = s("../utils/common"), u = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], c = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], E = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], d = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      o.exports = function(f, h, S, R, _, m, L, F) {
        var W, G, q, fe, _e, Le, Fe, Ee, Ge, ve = F.bits, te = 0, ae = 0, v = 0, Te = 0, De = 0, be = 0, ze = 0, ke = 0, Be = 0, Me = 0, me = null, Se = 0, xt = new l.Buf16(16), Ht = new l.Buf16(16), Bt = null, ut = 0;
        for (te = 0; te <= 15; te++)
          xt[te] = 0;
        for (ae = 0; ae < R; ae++)
          xt[h[S + ae]]++;
        for (De = ve, Te = 15; 1 <= Te && xt[Te] === 0; Te--)
          ;
        if (Te < De && (De = Te), Te === 0)
          return _[m++] = 20971520, _[m++] = 20971520, F.bits = 1, 0;
        for (v = 1; v < Te && xt[v] === 0; v++)
          ;
        for (De < v && (De = v), te = ke = 1; te <= 15; te++)
          if (ke <<= 1, (ke -= xt[te]) < 0)
            return -1;
        if (0 < ke && (f === 0 || Te !== 1))
          return -1;
        for (Ht[1] = 0, te = 1; te < 15; te++)
          Ht[te + 1] = Ht[te] + xt[te];
        for (ae = 0; ae < R; ae++)
          h[S + ae] !== 0 && (L[Ht[h[S + ae]]++] = ae);
        if (Le = f === 0 ? (me = Bt = L, 19) : f === 1 ? (me = u, Se -= 257, Bt = c, ut -= 257, 256) : (me = E, Bt = d, -1), te = v, _e = m, ze = ae = Me = 0, q = -1, fe = (Be = 1 << (be = De)) - 1, f === 1 && 852 < Be || f === 2 && 592 < Be)
          return 1;
        for (; ; ) {
          for (Fe = te - ze, Ge = L[ae] < Le ? (Ee = 0, L[ae]) : L[ae] > Le ? (Ee = Bt[ut + L[ae]], me[Se + L[ae]]) : (Ee = 96, 0), W = 1 << te - ze, v = G = 1 << be; _[_e + (Me >> ze) + (G -= W)] = Fe << 24 | Ee << 16 | Ge | 0, G !== 0; )
            ;
          for (W = 1 << te - 1; Me & W; )
            W >>= 1;
          if (W !== 0 ? (Me &= W - 1, Me += W) : Me = 0, ae++, --xt[te] == 0) {
            if (te === Te)
              break;
            te = h[S + L[ae]];
          }
          if (De < te && (Me & fe) !== q) {
            for (ze === 0 && (ze = De), _e += v, ke = 1 << (be = te - ze); be + ze < Te && !((ke -= xt[be + ze]) <= 0); )
              be++, ke <<= 1;
            if (Be += 1 << be, f === 1 && 852 < Be || f === 2 && 592 < Be)
              return 1;
            _[q = Me & fe] = De << 24 | be << 16 | _e - m | 0;
          }
        }
        return Me !== 0 && (_[_e + Me] = te - ze << 24 | 64 << 16 | 0), F.bits = De, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(s, o, a) {
      o.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(s, o, a) {
      var l = s("../utils/common"), u = 0, c = 1;
      function E($e) {
        for (var pt = $e.length; 0 <= --pt; )
          $e[pt] = 0;
      }
      var d = 0, f = 29, h = 256, S = h + 1 + f, R = 30, _ = 19, m = 2 * S + 1, L = 15, F = 16, W = 7, G = 256, q = 16, fe = 17, _e = 18, Le = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], Fe = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], Ee = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], Ge = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], ve = new Array(2 * (S + 2));
      E(ve);
      var te = new Array(2 * R);
      E(te);
      var ae = new Array(512);
      E(ae);
      var v = new Array(256);
      E(v);
      var Te = new Array(f);
      E(Te);
      var De, be, ze, ke = new Array(R);
      function Be($e, pt, Jt, In, Cn) {
        this.static_tree = $e, this.extra_bits = pt, this.extra_base = Jt, this.elems = In, this.max_length = Cn, this.has_stree = $e && $e.length;
      }
      function Me($e, pt) {
        this.dyn_tree = $e, this.max_code = 0, this.stat_desc = pt;
      }
      function me($e) {
        return $e < 256 ? ae[$e] : ae[256 + ($e >>> 7)];
      }
      function Se($e, pt) {
        $e.pending_buf[$e.pending++] = 255 & pt, $e.pending_buf[$e.pending++] = pt >>> 8 & 255;
      }
      function xt($e, pt, Jt) {
        $e.bi_valid > F - Jt ? ($e.bi_buf |= pt << $e.bi_valid & 65535, Se($e, $e.bi_buf), $e.bi_buf = pt >> F - $e.bi_valid, $e.bi_valid += Jt - F) : ($e.bi_buf |= pt << $e.bi_valid & 65535, $e.bi_valid += Jt);
      }
      function Ht($e, pt, Jt) {
        xt($e, Jt[2 * pt], Jt[2 * pt + 1]);
      }
      function Bt($e, pt) {
        for (var Jt = 0; Jt |= 1 & $e, $e >>>= 1, Jt <<= 1, 0 < --pt; )
          ;
        return Jt >>> 1;
      }
      function ut($e, pt, Jt) {
        var In, Cn, It = new Array(L + 1), ht = 0;
        for (In = 1; In <= L; In++)
          It[In] = ht = ht + Jt[In - 1] << 1;
        for (Cn = 0; Cn <= pt; Cn++) {
          var Wt = $e[2 * Cn + 1];
          Wt !== 0 && ($e[2 * Cn] = Bt(It[Wt]++, Wt));
        }
      }
      function Tt($e) {
        var pt;
        for (pt = 0; pt < S; pt++)
          $e.dyn_ltree[2 * pt] = 0;
        for (pt = 0; pt < R; pt++)
          $e.dyn_dtree[2 * pt] = 0;
        for (pt = 0; pt < _; pt++)
          $e.bl_tree[2 * pt] = 0;
        $e.dyn_ltree[2 * G] = 1, $e.opt_len = $e.static_len = 0, $e.last_lit = $e.matches = 0;
      }
      function Yt($e) {
        8 < $e.bi_valid ? Se($e, $e.bi_buf) : 0 < $e.bi_valid && ($e.pending_buf[$e.pending++] = $e.bi_buf), $e.bi_buf = 0, $e.bi_valid = 0;
      }
      function an($e, pt, Jt, In) {
        var Cn = 2 * pt, It = 2 * Jt;
        return $e[Cn] < $e[It] || $e[Cn] === $e[It] && In[pt] <= In[Jt];
      }
      function Ct($e, pt, Jt) {
        for (var In = $e.heap[Jt], Cn = Jt << 1; Cn <= $e.heap_len && (Cn < $e.heap_len && an(pt, $e.heap[Cn + 1], $e.heap[Cn], $e.depth) && Cn++, !an(pt, In, $e.heap[Cn], $e.depth)); )
          $e.heap[Jt] = $e.heap[Cn], Jt = Cn, Cn <<= 1;
        $e.heap[Jt] = In;
      }
      function st($e, pt, Jt) {
        var In, Cn, It, ht, Wt = 0;
        if ($e.last_lit !== 0)
          for (; In = $e.pending_buf[$e.d_buf + 2 * Wt] << 8 | $e.pending_buf[$e.d_buf + 2 * Wt + 1], Cn = $e.pending_buf[$e.l_buf + Wt], Wt++, In === 0 ? Ht($e, Cn, pt) : (Ht($e, (It = v[Cn]) + h + 1, pt), (ht = Le[It]) !== 0 && xt($e, Cn -= Te[It], ht), Ht($e, It = me(--In), Jt), (ht = Fe[It]) !== 0 && xt($e, In -= ke[It], ht)), Wt < $e.last_lit; )
            ;
        Ht($e, G, pt);
      }
      function jt($e, pt) {
        var Jt, In, Cn, It = pt.dyn_tree, ht = pt.stat_desc.static_tree, Wt = pt.stat_desc.has_stree, hn = pt.stat_desc.elems, Vt = -1;
        for ($e.heap_len = 0, $e.heap_max = m, Jt = 0; Jt < hn; Jt++)
          It[2 * Jt] !== 0 ? ($e.heap[++$e.heap_len] = Vt = Jt, $e.depth[Jt] = 0) : It[2 * Jt + 1] = 0;
        for (; $e.heap_len < 2; )
          It[2 * (Cn = $e.heap[++$e.heap_len] = Vt < 2 ? ++Vt : 0)] = 1, $e.depth[Cn] = 0, $e.opt_len--, Wt && ($e.static_len -= ht[2 * Cn + 1]);
        for (pt.max_code = Vt, Jt = $e.heap_len >> 1; 1 <= Jt; Jt--)
          Ct($e, It, Jt);
        for (Cn = hn; Jt = $e.heap[1], $e.heap[1] = $e.heap[$e.heap_len--], Ct($e, It, 1), In = $e.heap[1], $e.heap[--$e.heap_max] = Jt, $e.heap[--$e.heap_max] = In, It[2 * Cn] = It[2 * Jt] + It[2 * In], $e.depth[Cn] = ($e.depth[Jt] >= $e.depth[In] ? $e.depth[Jt] : $e.depth[In]) + 1, It[2 * Jt + 1] = It[2 * In + 1] = Cn, $e.heap[1] = Cn++, Ct($e, It, 1), 2 <= $e.heap_len; )
          ;
        $e.heap[--$e.heap_max] = $e.heap[1], function(Tn, Rn) {
          var Nn, Dn, xn, $n, Kn, ir, er = Rn.dyn_tree, br = Rn.max_code, cs = Rn.stat_desc.static_tree, Gn = Rn.stat_desc.has_stree, Jn = Rn.stat_desc.extra_bits, Xn = Rn.stat_desc.extra_base, rr = Rn.stat_desc.max_length, _r = 0;
          for ($n = 0; $n <= L; $n++)
            Tn.bl_count[$n] = 0;
          for (er[2 * Tn.heap[Tn.heap_max] + 1] = 0, Nn = Tn.heap_max + 1; Nn < m; Nn++)
            rr < ($n = er[2 * er[2 * (Dn = Tn.heap[Nn]) + 1] + 1] + 1) && ($n = rr, _r++), er[2 * Dn + 1] = $n, br < Dn || (Tn.bl_count[$n]++, Kn = 0, Xn <= Dn && (Kn = Jn[Dn - Xn]), ir = er[2 * Dn], Tn.opt_len += ir * ($n + Kn), Gn && (Tn.static_len += ir * (cs[2 * Dn + 1] + Kn)));
          if (_r !== 0) {
            do {
              for ($n = rr - 1; Tn.bl_count[$n] === 0; )
                $n--;
              Tn.bl_count[$n]--, Tn.bl_count[$n + 1] += 2, Tn.bl_count[rr]--, _r -= 2;
            } while (0 < _r);
            for ($n = rr; $n !== 0; $n--)
              for (Dn = Tn.bl_count[$n]; Dn !== 0; )
                br < (xn = Tn.heap[--Nn]) || (er[2 * xn + 1] !== $n && (Tn.opt_len += ($n - er[2 * xn + 1]) * er[2 * xn], er[2 * xn + 1] = $n), Dn--);
          }
        }($e, pt), ut(It, Vt, $e.bl_count);
      }
      function lt($e, pt, Jt) {
        var In, Cn, It = -1, ht = pt[1], Wt = 0, hn = 7, Vt = 4;
        for (ht === 0 && (hn = 138, Vt = 3), pt[2 * (Jt + 1) + 1] = 65535, In = 0; In <= Jt; In++)
          Cn = ht, ht = pt[2 * (In + 1) + 1], ++Wt < hn && Cn === ht || (Wt < Vt ? $e.bl_tree[2 * Cn] += Wt : Cn !== 0 ? (Cn !== It && $e.bl_tree[2 * Cn]++, $e.bl_tree[2 * q]++) : Wt <= 10 ? $e.bl_tree[2 * fe]++ : $e.bl_tree[2 * _e]++, It = Cn, Vt = (Wt = 0) === ht ? (hn = 138, 3) : Cn === ht ? (hn = 6, 3) : (hn = 7, 4));
      }
      function Zt($e, pt, Jt) {
        var In, Cn, It = -1, ht = pt[1], Wt = 0, hn = 7, Vt = 4;
        for (ht === 0 && (hn = 138, Vt = 3), In = 0; In <= Jt; In++)
          if (Cn = ht, ht = pt[2 * (In + 1) + 1], !(++Wt < hn && Cn === ht)) {
            if (Wt < Vt)
              for (; Ht($e, Cn, $e.bl_tree), --Wt != 0; )
                ;
            else
              Cn !== 0 ? (Cn !== It && (Ht($e, Cn, $e.bl_tree), Wt--), Ht($e, q, $e.bl_tree), xt($e, Wt - 3, 2)) : Wt <= 10 ? (Ht($e, fe, $e.bl_tree), xt($e, Wt - 3, 3)) : (Ht($e, _e, $e.bl_tree), xt($e, Wt - 11, 7));
            It = Cn, Vt = (Wt = 0) === ht ? (hn = 138, 3) : Cn === ht ? (hn = 6, 3) : (hn = 7, 4);
          }
      }
      E(ke);
      var Et = !1;
      function Ke($e, pt, Jt, In) {
        xt($e, (d << 1) + (In ? 1 : 0), 3), function(Cn, It, ht, Wt) {
          Yt(Cn), Wt && (Se(Cn, ht), Se(Cn, ~ht)), l.arraySet(Cn.pending_buf, Cn.window, It, ht, Cn.pending), Cn.pending += ht;
        }($e, pt, Jt, !0);
      }
      a._tr_init = function($e) {
        Et || (function() {
          var pt, Jt, In, Cn, It, ht = new Array(L + 1);
          for (Cn = In = 0; Cn < f - 1; Cn++)
            for (Te[Cn] = In, pt = 0; pt < 1 << Le[Cn]; pt++)
              v[In++] = Cn;
          for (v[In - 1] = Cn, Cn = It = 0; Cn < 16; Cn++)
            for (ke[Cn] = It, pt = 0; pt < 1 << Fe[Cn]; pt++)
              ae[It++] = Cn;
          for (It >>= 7; Cn < R; Cn++)
            for (ke[Cn] = It << 7, pt = 0; pt < 1 << Fe[Cn] - 7; pt++)
              ae[256 + It++] = Cn;
          for (Jt = 0; Jt <= L; Jt++)
            ht[Jt] = 0;
          for (pt = 0; pt <= 143; )
            ve[2 * pt + 1] = 8, pt++, ht[8]++;
          for (; pt <= 255; )
            ve[2 * pt + 1] = 9, pt++, ht[9]++;
          for (; pt <= 279; )
            ve[2 * pt + 1] = 7, pt++, ht[7]++;
          for (; pt <= 287; )
            ve[2 * pt + 1] = 8, pt++, ht[8]++;
          for (ut(ve, S + 1, ht), pt = 0; pt < R; pt++)
            te[2 * pt + 1] = 5, te[2 * pt] = Bt(pt, 5);
          De = new Be(ve, Le, h + 1, S, L), be = new Be(te, Fe, 0, R, L), ze = new Be(new Array(0), Ee, 0, _, W);
        }(), Et = !0), $e.l_desc = new Me($e.dyn_ltree, De), $e.d_desc = new Me($e.dyn_dtree, be), $e.bl_desc = new Me($e.bl_tree, ze), $e.bi_buf = 0, $e.bi_valid = 0, Tt($e);
      }, a._tr_stored_block = Ke, a._tr_flush_block = function($e, pt, Jt, In) {
        var Cn, It, ht = 0;
        0 < $e.level ? ($e.strm.data_type === 2 && ($e.strm.data_type = function(Wt) {
          var hn, Vt = 4093624447;
          for (hn = 0; hn <= 31; hn++, Vt >>>= 1)
            if (1 & Vt && Wt.dyn_ltree[2 * hn] !== 0)
              return u;
          if (Wt.dyn_ltree[18] !== 0 || Wt.dyn_ltree[20] !== 0 || Wt.dyn_ltree[26] !== 0)
            return c;
          for (hn = 32; hn < h; hn++)
            if (Wt.dyn_ltree[2 * hn] !== 0)
              return c;
          return u;
        }($e)), jt($e, $e.l_desc), jt($e, $e.d_desc), ht = function(Wt) {
          var hn;
          for (lt(Wt, Wt.dyn_ltree, Wt.l_desc.max_code), lt(Wt, Wt.dyn_dtree, Wt.d_desc.max_code), jt(Wt, Wt.bl_desc), hn = _ - 1; 3 <= hn && Wt.bl_tree[2 * Ge[hn] + 1] === 0; hn--)
            ;
          return Wt.opt_len += 3 * (hn + 1) + 5 + 5 + 4, hn;
        }($e), Cn = $e.opt_len + 3 + 7 >>> 3, (It = $e.static_len + 3 + 7 >>> 3) <= Cn && (Cn = It)) : Cn = It = Jt + 5, Jt + 4 <= Cn && pt !== -1 ? Ke($e, pt, Jt, In) : $e.strategy === 4 || It === Cn ? (xt($e, 2 + (In ? 1 : 0), 3), st($e, ve, te)) : (xt($e, 4 + (In ? 1 : 0), 3), function(Wt, hn, Vt, Tn) {
          var Rn;
          for (xt(Wt, hn - 257, 5), xt(Wt, Vt - 1, 5), xt(Wt, Tn - 4, 4), Rn = 0; Rn < Tn; Rn++)
            xt(Wt, Wt.bl_tree[2 * Ge[Rn] + 1], 3);
          Zt(Wt, Wt.dyn_ltree, hn - 1), Zt(Wt, Wt.dyn_dtree, Vt - 1);
        }($e, $e.l_desc.max_code + 1, $e.d_desc.max_code + 1, ht + 1), st($e, $e.dyn_ltree, $e.dyn_dtree)), Tt($e), In && Yt($e);
      }, a._tr_tally = function($e, pt, Jt) {
        return $e.pending_buf[$e.d_buf + 2 * $e.last_lit] = pt >>> 8 & 255, $e.pending_buf[$e.d_buf + 2 * $e.last_lit + 1] = 255 & pt, $e.pending_buf[$e.l_buf + $e.last_lit] = 255 & Jt, $e.last_lit++, pt === 0 ? $e.dyn_ltree[2 * Jt]++ : ($e.matches++, pt--, $e.dyn_ltree[2 * (v[Jt] + h + 1)]++, $e.dyn_dtree[2 * me(pt)]++), $e.last_lit === $e.lit_bufsize - 1;
      }, a._tr_align = function($e) {
        xt($e, 2, 3), Ht($e, G, ve), function(pt) {
          pt.bi_valid === 16 ? (Se(pt, pt.bi_buf), pt.bi_buf = 0, pt.bi_valid = 0) : 8 <= pt.bi_valid && (pt.pending_buf[pt.pending++] = 255 & pt.bi_buf, pt.bi_buf >>= 8, pt.bi_valid -= 8);
        }($e);
      };
    }, { "../utils/common": 41 }], 53: [function(s, o, a) {
      o.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(s, o, a) {
      (function(l) {
        (function(u, c) {
          if (!u.setImmediate) {
            var E, d, f, h, S = 1, R = {}, _ = !1, m = u.document, L = Object.getPrototypeOf && Object.getPrototypeOf(u);
            L = L && L.setTimeout ? L : u, E = {}.toString.call(u.process) === "[object process]" ? function(q) {
              api$1.nextTick(function() {
                W(q);
              });
            } : function() {
              if (u.postMessage && !u.importScripts) {
                var q = !0, fe = u.onmessage;
                return u.onmessage = function() {
                  q = !1;
                }, u.postMessage("", "*"), u.onmessage = fe, q;
              }
            }() ? (h = "setImmediate$" + Math.random() + "$", u.addEventListener ? u.addEventListener("message", G, !1) : u.attachEvent("onmessage", G), function(q) {
              u.postMessage(h + q, "*");
            }) : u.MessageChannel ? ((f = new MessageChannel()).port1.onmessage = function(q) {
              W(q.data);
            }, function(q) {
              f.port2.postMessage(q);
            }) : m && "onreadystatechange" in m.createElement("script") ? (d = m.documentElement, function(q) {
              var fe = m.createElement("script");
              fe.onreadystatechange = function() {
                W(q), fe.onreadystatechange = null, d.removeChild(fe), fe = null;
              }, d.appendChild(fe);
            }) : function(q) {
              setTimeout(W, 0, q);
            }, L.setImmediate = function(q) {
              typeof q != "function" && (q = new Function("" + q));
              for (var fe = new Array(arguments.length - 1), _e = 0; _e < fe.length; _e++)
                fe[_e] = arguments[_e + 1];
              var Le = { callback: q, args: fe };
              return R[S] = Le, E(S), S++;
            }, L.clearImmediate = F;
          }
          function F(q) {
            delete R[q];
          }
          function W(q) {
            if (_)
              setTimeout(W, 0, q);
            else {
              var fe = R[q];
              if (fe) {
                _ = !0;
                try {
                  (function(_e) {
                    var Le = _e.callback, Fe = _e.args;
                    switch (Fe.length) {
                      case 0:
                        Le();
                        break;
                      case 1:
                        Le(Fe[0]);
                        break;
                      case 2:
                        Le(Fe[0], Fe[1]);
                        break;
                      case 3:
                        Le(Fe[0], Fe[1], Fe[2]);
                        break;
                      default:
                        Le.apply(c, Fe);
                    }
                  })(fe);
                } finally {
                  F(q), _ = !1;
                }
              }
            }
          }
          function G(q) {
            q.source === u && typeof q.data == "string" && q.data.indexOf(h) === 0 && W(+q.data.slice(h.length));
          }
        })(typeof self > "u" ? l === void 0 ? this : l : self);
      }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(jszip_min);
var FileSaver_min = { exports: {} };
(function(r, e) {
  (function(s, o) {
    o();
  })(commonjsGlobal, function() {
    function s(d, f) {
      return typeof f > "u" ? f = { autoBom: !1 } : typeof f != "object" && (console.warn("Deprecated: Expected third argument to be a object"), f = { autoBom: !f }), f.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(d.type) ? new Blob(["\uFEFF", d], { type: d.type }) : d;
    }
    function o(d, f, h) {
      var S = new XMLHttpRequest();
      S.open("GET", d), S.responseType = "blob", S.onload = function() {
        E(S.response, f, h);
      }, S.onerror = function() {
        console.error("could not download file");
      }, S.send();
    }
    function a(d) {
      var f = new XMLHttpRequest();
      f.open("HEAD", d, !1);
      try {
        f.send();
      } catch {
      }
      return 200 <= f.status && 299 >= f.status;
    }
    function l(d) {
      try {
        d.dispatchEvent(new MouseEvent("click"));
      } catch {
        var f = document.createEvent("MouseEvents");
        f.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), d.dispatchEvent(f);
      }
    }
    var u = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof commonjsGlobal == "object" && commonjsGlobal.global === commonjsGlobal ? commonjsGlobal : void 0, c = u.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), E = u.saveAs || (typeof window != "object" || window !== u ? function() {
    } : "download" in HTMLAnchorElement.prototype && !c ? function(d, f, h) {
      var S = u.URL || u.webkitURL, R = document.createElement("a");
      f = f || d.name || "download", R.download = f, R.rel = "noopener", typeof d == "string" ? (R.href = d, R.origin === location.origin ? l(R) : a(R.href) ? o(d, f, h) : l(R, R.target = "_blank")) : (R.href = S.createObjectURL(d), setTimeout(function() {
        S.revokeObjectURL(R.href);
      }, 4e4), setTimeout(function() {
        l(R);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(d, f, h) {
      if (f = f || d.name || "download", typeof d != "string")
        navigator.msSaveOrOpenBlob(s(d, h), f);
      else if (a(d))
        o(d, f, h);
      else {
        var S = document.createElement("a");
        S.href = d, S.target = "_blank", setTimeout(function() {
          l(S);
        });
      }
    } : function(d, f, h, S) {
      if (S = S || open("", "_blank"), S && (S.document.title = S.document.body.innerText = "downloading..."), typeof d == "string")
        return o(d, f, h);
      var R = d.type === "application/octet-stream", _ = /constructor/i.test(u.HTMLElement) || u.safari, m = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((m || R && _ || c) && typeof FileReader < "u") {
        var L = new FileReader();
        L.onloadend = function() {
          var G = L.result;
          G = m ? G : G.replace(/^data:[^;]*;/, "data:attachment/file;"), S ? S.location.href = G : location = G, S = null;
        }, L.readAsDataURL(d);
      } else {
        var F = u.URL || u.webkitURL, W = F.createObjectURL(d);
        S ? S.location = W : location.href = W, S = null, setTimeout(function() {
          F.revokeObjectURL(W);
        }, 4e4);
      }
    });
    u.saveAs = E.saveAs = E, r.exports = E;
  });
})(FileSaver_min);
var FileSaver_minExports = FileSaver_min.exports;
FileSaver_minExports.saveAs;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
var __awaiter$J = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const TEXT_CURVE_SEGMENTS = 1;
class DxfLoader {
  static load(e, s) {
    return __awaiter$J(this, void 0, void 0, function* () {
      const o = yield FileLoader.loadText(e, { cacheKey: s.cacheKey, cache: !0 }), a = DxfLoader.DXF_PARSER.parseSync(o);
      if (a === null || !a.entities)
        throw new Error(`Could not parse DXF file ${e}`);
      let l;
      if (a.header) {
        const E = a.header.$EXTMIN, d = a.header.$EXTMAX;
        if (typeof E == "object" && typeof d == "object") {
          const f = new Vector3$1(E.x, E.y, E.z), h = new Vector3$1(d.x, d.y, d.z);
          f.x <= h.x && f.y <= h.y && f.z <= h.z && h.x - f.x < 1e4 && h.y - f.y < 1e4 && h.z - f.z < 1e4 && (l = new Box3$1(f, h));
        }
      }
      const u = /* @__PURE__ */ new Map();
      for (const E of a.entities) {
        if (s.removePaperSpaceEntities && E.inPaperSpace)
          continue;
        const d = DxfLoader.drawEntity(E, a);
        if (!d)
          continue;
        const f = Array.isArray(d) ? d : [d];
        for (const h of f) {
          if (l) {
            const S = new Box3$1();
            for (const R of h.points)
              S.expandByPoint(R);
            if (S.translate(h.translation), !l.containsBox(S))
              continue;
          }
          DxfLoader.addToMaterialGroup(h, u);
        }
      }
      const c = new Group();
      return c.add(yield DxfLoader.createMesh(u, s)), c;
    });
  }
  /**
   * Register a Dxf object to the material groups map.
   *
   * @param object
   * @param materialGroups
   */
  static addToMaterialGroup(e, s) {
    const o = JSON.stringify(e.material), a = s.get(o);
    a === void 0 ? s.set(o, [e]) : a.push(e);
  }
  /**
   * Merge geometries in Vector3 space before converting to BufferGeometry to preserve numerical precision.
   *
   * @param geometries
   * @param isLine
   * @param spatialReferenceSystem
   * @returns
   */
  static mergeObjects(e, s, o) {
    return __awaiter$J(this, void 0, void 0, function* () {
      let a = [];
      for (const E of e)
        for (const d of E.points)
          a.push(d.clone().add(E.translation));
      o && (a = yield toECEF(a, o.epsg, o.gda7param));
      const l = computeCentroid(a);
      for (const E of a)
        E.sub(l);
      const u = new Float32Array(a.length * 3);
      for (let E = 0; E < a.length; E++)
        u[E * 3 + 0] = a[E].x, u[E * 3 + 1] = a[E].y, u[E * 3 + 2] = a[E].z;
      let c;
      return s ? c = new LineSegmentsGeometry().setPositions(u) : (c = new BufferGeometry(), c.setAttribute("position", new BufferAttribute(u, 3))), { geometry: c, translation: l };
    });
  }
  /**
   * Construct the final mesh from the existing material groups for meshes, points, lines, and text.
   *
   * @param materialGroups
   * @param options
   * @returns
   */
  static createMesh(e, s) {
    var o, a, l, u, c, E, d, f;
    return __awaiter$J(this, void 0, void 0, function* () {
      const h = new Group();
      for (const [S, R] of e) {
        const _ = JSON.parse(S), { geometry: m, translation: L } = yield DxfLoader.mergeObjects(R, _.type === "line", s.spatialReferenceSystem);
        if (m.attributes.position.count === 0) {
          m.dispose();
          continue;
        }
        let F;
        if (_.type === "mesh") {
          m.computeVertexNormals(), m.computeBoundsTree();
          const W = new PickingMeshStandardMaterial({
            objectId: (o = s.objectId) !== null && o !== void 0 ? o : 0,
            clippingPlanes: (a = s.clippingPlanes) !== null && a !== void 0 ? a : [],
            color: _.color,
            side: DoubleSide,
            forceSinglePass: !0
          });
          F = new Mesh(m, W);
        } else if (_.type === "point") {
          const W = new PickingPointsMaterial({
            objectId: (l = s.objectId) !== null && l !== void 0 ? l : 0,
            clippingPlanes: (u = s.clippingPlanes) !== null && u !== void 0 ? u : [],
            color: _.color,
            size: _.size,
            sizeAttenuation: !1,
            forceSinglePass: !0
          });
          F = new Points(m, W);
        } else if (_.type === "line") {
          const W = new PickingLineMaterial({
            objectId: (c = s.objectId) !== null && c !== void 0 ? c : 0,
            clippingPlanes: (E = s.clippingPlanes) !== null && E !== void 0 ? E : [],
            color: _.color,
            linewidth: _.width,
            dashed: !_.solid,
            gapSize: _.solid ? void 0 : 0.1,
            dashSize: _.solid ? void 0 : 0.2,
            worldUnits: _.width !== 1,
            forceSinglePass: !0
          });
          F = new LineSegments2(m, W), F.computeLineDistances();
        } else {
          m.computeVertexNormals(), m.computeBoundsTree();
          const W = new PickingMeshBasicMaterial({
            objectId: (d = s.objectId) !== null && d !== void 0 ? d : 0,
            clippingPlanes: (f = s.clippingPlanes) !== null && f !== void 0 ? f : [],
            color: _.color,
            side: DoubleSide,
            forceSinglePass: !0
          });
          F = new Mesh(m, W);
        }
        F.position.copy(L), h.add(F);
      }
      return h;
    });
  }
  /**
   * Draw each entity.
   *
   * @param entity
   * @param dxf
   */
  static drawEntity(e, s) {
    if (e.type === "POINT")
      return DxfLoader.drawPoint(e, s);
    if (e.type === "ARC")
      return DxfLoader.drawArc(e, s);
    if (e.type === "CIRCLE")
      return DxfLoader.drawArc(e, s);
    if (e.type === "ELLIPSE")
      return DxfLoader.drawEllipse(e, s);
    if (e.type === "LINE")
      return DxfLoader.drawLine(e, s);
    if (e.type === "POLYLINE")
      return DxfLoader.drawPolyline(e, s);
    if (e.type === "LWPOLYLINE")
      return DxfLoader.drawPolyline(e, s);
    if (e.type === "SPLINE")
      return DxfLoader.drawSpline(e, s);
    if (e.type === "SOLID")
      return DxfLoader.drawSolid(e, s);
    if (e.type === "3DFACE")
      return DxfLoader.draw3DFace(e, s);
    if (e.type === "INSERT")
      return DxfLoader.drawBlock(e, s);
    if (e.type === "TEXT")
      return DxfLoader.drawText(e, s);
    if (e.type === "MTEXT")
      return DxfLoader.drawMText(e, s);
    if (e.type === "DIMENSION") {
      const o = e, a = o.dimensionType & 7;
      if (a === 0)
        return DxfLoader.drawDimension(o, s);
      console.warn(`DxfLoader - Unsupported Dimension Type: ${a}`);
    } else
      console.warn(`DxfLoader - Unsupported Entity Type: ${e.type}`);
  }
  /**
   * Get the color of an entity.
   *
   * @param entity
   * @param dxf
   */
  static getColor(e, s) {
    var o, a, l, u, c, E;
    let d = 16777215;
    return e.color !== void 0 ? d = e.color : ((l = (a = (o = s.tables) === null || o === void 0 ? void 0 : o.layer) === null || a === void 0 ? void 0 : a.layers) === null || l === void 0 ? void 0 : l[e == null ? void 0 : e.layer]) !== void 0 && (d = (E = (c = (u = s.tables) === null || u === void 0 ? void 0 : u.layer) === null || c === void 0 ? void 0 : c.layers) === null || E === void 0 ? void 0 : E[e == null ? void 0 : e.layer].color), d == null && (d = 16777215), d;
  }
  /**
   * Create a BufferGeometry from a curve.
   *
   * @param curve
   * @param samples
   * @returns
   */
  static lineGeometryFromPoints(e) {
    var s, o;
    const a = [];
    for (let l = 0; l < e.length - 1; l++) {
      const u = new Vector3$1(e[l].x, e[l].y, (s = e[l].z) !== null && s !== void 0 ? s : 0), c = new Vector3$1(e[l + 1].x, e[l + 1].y, (o = e[l + 1].z) !== null && o !== void 0 ? o : 0);
      a.push(u, c);
    }
    return a;
  }
  static drawPoint(e, s) {
    const o = [new Vector3$1()], a = new Vector3$1(e.position.x, e.position.y, e.position.z), l = DxfLoader.getColor(e, s);
    return {
      points: o,
      translation: a,
      material: {
        type: "point",
        color: l,
        size: 3
      }
    };
  }
  static drawArc(e, s) {
    let o;
    e.type === "CIRCLE" ? o = new ArcCurve(0, 0, e.radius) : o = new ArcCurve(0, 0, e.radius, e.startAngle, e.endAngle);
    const a = DxfLoader.lineGeometryFromPoints(o.getPoints(32)), l = new Vector3$1(e.center.x, e.center.y, e.center.z), u = DxfLoader.getColor(e, s);
    return {
      points: a,
      translation: l,
      material: {
        type: "line",
        color: u,
        width: 1,
        solid: !0
      }
    };
  }
  static drawEllipse(e, s) {
    const o = Math.sqrt(Math.pow(e.majorAxisEndPoint.x, 2) + Math.pow(e.majorAxisEndPoint.y, 2)), a = o * e.axisRatio, l = Math.atan2(e.majorAxisEndPoint.y, e.majorAxisEndPoint.x), u = new EllipseCurve(
      0,
      0,
      o,
      a,
      e.startAngle,
      e.endAngle,
      !1,
      // Always counterclockwise
      l
    ), c = DxfLoader.lineGeometryFromPoints(u.getPoints(50)), E = new Vector3$1(e.center.x, e.center.y, e.center.z), d = DxfLoader.getColor(e, s);
    return {
      points: c,
      translation: E,
      material: {
        type: "line",
        color: d,
        width: 1,
        solid: !0
      }
    };
  }
  static drawLine(e, s) {
    var o, a, l;
    if (!e.vertices)
      throw new Error("Entity missing vertices.");
    const u = e.vertices.map((R) => new Vector3$1(R.x, R.y, R.z)), c = new Vector3$1(), E = u, d = DxfLoader.lineGeometryFromPoints(E), f = DxfLoader.getColor(e, s), h = (l = (a = (o = s.tables) === null || o === void 0 ? void 0 : o.lineType) === null || a === void 0 ? void 0 : a.lineTypes) === null || l === void 0 ? void 0 : l[e == null ? void 0 : e.lineType], S = h && h.pattern && h.pattern.length !== 0;
    return {
      points: d,
      translation: c,
      material: {
        type: "line",
        color: f,
        width: 1,
        solid: !S
      }
    };
  }
  static drawPolyline(e, s) {
    var o, a, l, u, c, E, d;
    if (!e.vertices)
      throw new Error("Entity missing vertices.");
    let f;
    if (e.type === "LWPOLYLINE") {
      const fe = e, _e = new Vector3$1((o = fe.extrusionDirectionX) !== null && o !== void 0 ? o : 0, (a = fe.extrusionDirectionY) !== null && a !== void 0 ? a : 0, (l = fe.extrusionDirectionZ) !== null && l !== void 0 ? l : 1);
      f = computeOcsToWcsMatrix(_e);
    } else
      f = new Matrix4().identity();
    let h = 0;
    e.type === "LWPOLYLINE" && (h = e.elevation);
    const S = [], R = e.vertices.length;
    for (let fe = 0; fe < R; fe++) {
      const _e = e.vertices[fe], Le = e.vertices[(fe + 1) % R];
      _e.bulge ? S.push(...getBulgeCurvePoints(_e, Le, _e.bulge)) : S.push(new Vector3$1(_e.x, _e.y, (u = _e.z) !== null && u !== void 0 ? u : h));
    }
    e.shape && S.push(S[0]), S.forEach((fe) => fe.applyMatrix4(f));
    const _ = new Vector3$1(), m = S, L = DxfLoader.lineGeometryFromPoints(m), F = DxfLoader.getColor(e, s), W = (d = (E = (c = s.tables) === null || c === void 0 ? void 0 : c.lineType) === null || E === void 0 ? void 0 : E.lineTypes) === null || d === void 0 ? void 0 : d[e == null ? void 0 : e.lineType], G = (W == null ? void 0 : W.pattern) && W.pattern.length !== 0 || !e.hasContinuousLinetypePattern, q = e.thickness || e.width || 1;
    return {
      points: L,
      translation: _,
      material: {
        type: "line",
        color: F,
        width: q,
        solid: !G
      }
    };
  }
  static drawSpline(e, s) {
    const a = getBSplinePolyline(e.controlPoints, e.degreeOfSplineCurve, e.knotValues, 100).map((d) => new Vector3$1(d.x, d.y)), l = new Vector3$1(), u = a, c = DxfLoader.lineGeometryFromPoints(u), E = DxfLoader.getColor(e, s);
    return {
      points: c,
      translation: l,
      material: {
        type: "line",
        color: E,
        width: 1,
        solid: !0
      }
    };
  }
  static drawSolid(e, s) {
    const o = e.points.map((E) => new Vector3$1(E.x, E.y, E.z)), a = [];
    triangulatePoints(o[0], o[1], o[2], a), triangulatePoints(o[1], o[2], o[3], a);
    const l = new Vector3$1(), u = a, c = DxfLoader.getColor(e, s);
    return {
      points: u,
      translation: l,
      material: {
        type: "mesh",
        color: c
      }
    };
  }
  static draw3DFace(e, s) {
    const o = e.vertices.map((E) => new Vector3$1(E.x, E.y, E.z)), a = [];
    o.length > 4 ? (a.push(o[0], o[1], o[2]), a.push(o[0], o[2], o[3])) : a.push(o[0], o[1], o[2]);
    const l = new Vector3$1(), u = a, c = DxfLoader.getColor(e, s);
    return {
      points: u,
      translation: l,
      material: {
        type: "mesh",
        color: c
      }
    };
  }
  static drawText(e, s) {
    e.type === "ATTDEF" && e.text === "X" && console.log(e);
    const o = new TextGeometry(parseSpecialChars(e.text), {
      font: DxfLoader.DXF_FONT,
      size: e.textHeight,
      height: 0,
      curveSegments: TEXT_CURVE_SEGMENTS
    });
    e.rotation && o.rotateZ(MathUtils.degreesToRadians(e.rotation));
    const a = new Vector3$1(e.startPoint.x, e.startPoint.y, e.startPoint.z), l = o.getAttribute("position").array, u = [];
    for (let E = 0; E < l.length; E += 3)
      u.push(new Vector3$1(l[E], l[E + 1], l[E + 2]));
    const c = DxfLoader.getColor(e, s);
    return {
      points: u,
      translation: a,
      material: {
        type: "text",
        color: c
      }
    };
  }
  static drawMText(e, s) {
    var o, a;
    const l = /\\px[^;]*;/i, u = (a = (o = e.text.match(l)) === null || o === void 0 ? void 0 : o[0]) !== null && a !== void 0 ? a : "", c = e.text.replace(l, ""), E = [
      u.replace("\\px", "px"),
      ...parseDxfMTextContent(parseSpecialChars(c))
    ], d = getMTextStyling(E), f = d.text.split(`
`), h = [], S = e.height * 5 / 3, R = S - e.height;
    let _ = 0, m = 0;
    for (const Ee of f) {
      const Ge = new TextGeometry(Ee, {
        font: DxfLoader.DXF_FONT,
        size: e.height,
        height: 0,
        curveSegments: TEXT_CURVE_SEGMENTS
      });
      h.push(Ge), Ge.computeBoundingBox();
      const ve = Ge.boundingBox.max.x - Ge.boundingBox.min.x, te = Ge.boundingBox.max.y - Ge.boundingBox.min.y;
      _ = Math.max(ve, _), m = Math.max(te, m);
    }
    let L, F;
    for (let Ee = 0; Ee < h.length; Ee++) {
      const Ge = h[Ee], ve = Ge.boundingBox.max.x - Ge.boundingBox.min.x, te = _ - ve;
      L = d.alignX * (te * 0.5), F = d.alignY * (R * 0.5) + Ee * S, Ge.translate(L, -F, 0);
    }
    const W = mergeGeometries(h), G = (e.attachmentPoint - 1) % 3, q = e.attachmentPoint / 3 - 1;
    if (L = -G * (_ * 0.5), F = -q * (m * 0.5), W.translate(L, F, 0), e.rotation && W.rotateZ(MathUtils.degreesToRadians(e.rotation)), e.directionVector) {
      const Ee = new Vector3$1(e.directionVector.x, e.directionVector.y, e.directionVector.z);
      W.rotateZ(Ee.angleTo(MathUtils.X_AXIS));
    }
    const fe = new Vector3$1(e.position.x, e.position.y, e.position.z), _e = W.getAttribute("position").array, Le = [];
    for (let Ee = 0; Ee < _e.length; Ee += 3)
      Le.push(new Vector3$1(_e[Ee], _e[Ee + 1], _e[Ee + 2]));
    const Fe = DxfLoader.getColor(e, s);
    return {
      points: Le,
      translation: fe,
      material: {
        type: "text",
        color: Fe
      }
    };
  }
  // TODO: Not sure if this is correct, find a test case
  static drawBlock(e, s) {
    var o, a, l, u, c, E, d, f, h;
    const S = s.blocks[e.name];
    if (!S.entities)
      return;
    const R = new Euler();
    e.rotation && (R.z = MathUtils.degreesToRadians((o = e.rotation) !== null && o !== void 0 ? o : 0));
    const _ = new Vector3$1((l = (a = e.position) === null || a === void 0 ? void 0 : a.x) !== null && l !== void 0 ? l : 0, (c = (u = e.position) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0, (d = (E = e.position) === null || E === void 0 ? void 0 : E.z) !== null && d !== void 0 ? d : 0), m = new Vector3$1((f = e.xScale) !== null && f !== void 0 ? f : 1, (h = e.yScale) !== null && h !== void 0 ? h : 1, 1), L = new Quaternion$1().setFromEuler(R), F = new Matrix4().compose(_, L, m), W = [];
    for (const G of S.entities) {
      const q = DxfLoader.drawEntity(G, s);
      q && (Array.isArray(q) ? q : [q]).forEach((fe) => {
        fe.points.map((_e) => _e.applyMatrix4(F)), W.push(fe);
      });
    }
    return W;
  }
  static drawDimension(e, s) {
    const o = s.blocks[e.block];
    if (!o || !o.entities)
      return;
    const a = [];
    for (const l of o.entities) {
      const u = DxfLoader.drawEntity(l, s);
      Array.isArray(u) ? a.push(...u) : u !== void 0 && a.push(u);
    }
    return a;
  }
}
DxfLoader.DXF_PARSER = new DxfParser();
DxfLoader.DXF_FONT = new FontLoader$1().parse(DxfTypeface);
function computeOcsToWcsMatrix(r) {
  const e = r.clone().normalize();
  let s;
  Math.abs(e.x) < 1 / 64 && Math.abs(e.y) < 1 / 64 ? s = new Vector3$1(0, 1, 0).cross(e).normalize() : s = new Vector3$1(0, 0, 1).cross(e).normalize();
  const o = e.clone().cross(s).normalize();
  return new Matrix4().makeBasis(s, o, e);
}
function computeCentroid(r) {
  const e = new Vector3$1();
  for (const s of r)
    e.add(s);
  return e.divideScalar(r.length), e;
}
function getBulgeCurvePoints(r, e, s) {
  const o = new Vector2(r.x, r.y), a = new Vector2(e.x, e.y), l = 4 * Math.atan(s), u = o.distanceTo(a) / 2 / Math.sin(l / 2), c = MathUtils.polar(o, u, MathUtils.angle2(o, a) + (Math.PI / 2 - l / 2)), E = Math.max(Math.abs(Math.ceil(l / (Math.PI / 18))), 6), d = MathUtils.angle2(c, o), f = l / E, h = [];
  h.push(new Vector3$1(o.x, o.y, 0));
  for (let S = 1; S <= E - 1; S++) {
    const R = MathUtils.polar(c, Math.abs(u), d + f * S);
    h.push(new Vector3$1(R.x, R.y, 0));
  }
  return h;
}
function triangulatePoints(r, e, s, o = []) {
  const a = new Vector3$1().subVectors(e, r), l = new Vector3$1().subVectors(s, r);
  return a.cross(l), a.z < 0 ? o.push(s, e, r) : o.push(r, e, s), o;
}
function getBSplinePolyline(r, e, s, o) {
  const a = r.map((E) => [E.x, E.y]), l = [s[e]], u = [s[e], s[s.length - 1 - e]];
  for (let E = e + 1; E < s.length - e; ++E)
    l[l.length - 1] !== s[E] && l.push(s[E]);
  const c = [];
  for (let E = 1; E < l.length; ++E) {
    const d = l[E - 1], f = l[E];
    for (let h = 0; h <= o; ++h) {
      const S = h / o * (f - d) + d, R = Math.max(0, Math.min(1, (S - u[0]) / (u[1] - u[0])));
      try {
        const _ = bspline(R, e, a, s);
        c.push(new Vector2(_[0], _[1]));
      } catch (_) {
        console.warn(`BSpline - ${_.message}`);
      }
    }
  }
  return c;
}
function getMTextStyling(r, e) {
  var s;
  let o = 0, a = 2;
  const l = [];
  for (const u of r)
    if (typeof u == "string")
      if (u.startsWith("px") && u.endsWith(";")) {
        const E = (s = u.substring(2, u.length - 1).split(",")) !== null && s !== void 0 ? s : [];
        for (const d of E)
          d === "ql" ? o = 0 : d === "qc" ? o = 1 : d === "qr" ? o = 2 : (d === "qj" || d === "qd") && (o = 0);
      } else
        l.push(u);
    else if (Array.isArray(u)) {
      const c = getMTextStyling(u);
      l.push(c.text);
    } else if (typeof u == "object") {
      const { S: c, A: E } = u;
      c !== void 0 && l.push(c[0] + "/" + c[2]), E !== void 0 && (a = E);
    }
  return { text: l.join(""), alignX: o, alignY: a };
}
const SPECIAL_CHARS_RE = /(?:%%([dpcou%]))|(?:\\U\+([0-9a-fA-F]{4}))/g;
function parseSpecialChars(r) {
  return r.replaceAll(SPECIAL_CHARS_RE, (e, s, o) => {
    if (s !== void 0)
      switch (s) {
        case "d":
          return "°";
        case "p":
          return "±";
        case "c":
          return "∅";
        case "o":
          return "";
        case "u":
          return "";
        case "%":
          return "%";
      }
    else if (o !== void 0) {
      const a = parseInt(o, 16);
      return isNaN(a) ? e : String.fromCharCode(a);
    }
    return e;
  });
}
class ResourceSource {
  /**
   * Private constructor, forces users to use one of the static builder functions
   * @param source
   * @private
   */
  constructor(e) {
    this._source = e;
  }
  /**
   * Constructs a 'ResourceSource' from the provided URL. Has no associated authentication information, the target URL
   * must be publicly accessible.
   * @param url The URL
   */
  static fromDirectEndpoint(e, s) {
    return new ResourceSource({
      type: "direct",
      url: e,
      absolute: s ?? !1
    });
  }
  /**
   * Constructs a 'ResourceSource' from the provided Cesium Ion endpoint. The included authorization token and
   * authorization are wrapped and exposed via the created instance.
   *
   * This will also assert that 'url' and 'type' exist on the endpoint.
   *
   * @param endpoint The endpoint
   */
  static fromCesiumEndpoint(e) {
    if (e.url === void 0)
      throw new Error("'TilesetSource' missing 'url' attribute");
    if (e.type === void 0)
      throw new Error("'TilesetSource' missing 'type' attribute");
    return new ResourceSource({
      type: "cesium",
      endpoint: {
        url: e.url,
        type: e.type,
        accessToken: e.accessToken,
        attributions: e.attributions
      }
    });
  }
  /**
   * Returns an absolute URL to a resource relative to this resource based on the provided path.
   *
   * Very important for formats which refer to other files with relative paths inside the file.
   *
   * @param path Relative or absolute path
   */
  adjacentResource(e) {
    if (this._source.type === "direct" && this._source.absolute) {
      const s = new URL(this.url), o = e.split("?");
      s.pathname = o[0];
      const a = new URLSearchParams(o[1]);
      for (const [l, u] of a)
        s.searchParams.append(l, u);
      return s.toString();
    } else {
      const s = this.url.split("?");
      return s.length === 1 ? `${s[0]}/../${e}` : `${s[0]}/../${e}?${s[1]}`;
    }
  }
  /**
   * The URL of the resource being wrapped.
   */
  get url() {
    switch (this._source.type) {
      case "direct":
        return this._source.url;
      case "cesium":
        return this._source.endpoint.url;
    }
  }
  /**
   * The access token string for this resource, if present.
   */
  get accessToken() {
    switch (this._source.type) {
      case "direct":
        return;
      case "cesium":
        return this._source.endpoint.accessToken;
    }
  }
  /**
   * Returns a 'bearer token' header if the wrapped resource uses one.
   */
  get bearerToken() {
    const e = this.accessToken;
    if (e !== void 0)
      return {
        Authorization: `Bearer ${e}`
      };
  }
  /**
   * Returns the array of 'Attribution' infos associated with this resource
   */
  get attributions() {
    var e;
    switch (this._source.type) {
      case "direct":
        return [];
      case "cesium":
        return (e = this._source.endpoint.attributions) !== null && e !== void 0 ? e : [];
    }
  }
  /**
   * Constructs a new 'ResourceSource' with the given URL that inherits the remaining source state from 'this'.
   *
   * For example, for a Cesium Ion source, this function will produce a new 'ResourceSource' that will point to 'url'
   * but will use the same authorization token and attribution information.
   *
   * This is important for resources with auth tokens and multiple files to pull (like 3D Tiles). Without this tool
   * we would have to track the auth token manually. 'ResourceSource' encapsulates all the logic for particular
   * sources into a single uniform interface.
   *
   * @param url Absolute URL that will inherit from 'this'
   */
  inherit(e) {
    switch (this._source.type) {
      case "direct":
        return new ResourceSource({
          type: "direct",
          url: e,
          absolute: this._source.absolute
        });
      case "cesium":
        return new ResourceSource({
          type: "cesium",
          endpoint: {
            url: e,
            type: this._source.endpoint.type,
            accessToken: this._source.endpoint.accessToken,
            attributions: this._source.endpoint.attributions
          }
        });
    }
  }
}
function isAsset(r) {
  if (r === null || typeof r != "object" || typeof r.version != "string" || typeof r.tilesetVersion < "u" && r.tilesetVersion !== null && typeof r.tilesetVersion != "string" || typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions))
    return !1;
  if (typeof r.gltfUpAxis < "u" && r.gltfUpAxis !== null) {
    if (typeof r.gltfUpAxis != "string")
      return !1;
    switch (r.gltfUpAxis) {
      case "X":
      case "Y":
      case "Z":
        break;
      default:
        return !1;
    }
  }
  return !0;
}
function isBoundingVolume(r) {
  if (r === null || typeof r != "object")
    return !1;
  if (typeof r.box < "u" && r.box !== null) {
    if (!Array.isArray(r.box) || r.box.length !== 12)
      return !1;
    for (const e of r.box)
      if (typeof e != "number")
        return !1;
  }
  if (typeof r.region < "u" && r.region !== null) {
    if (!Array.isArray(r.region) || r.region.length !== 6)
      return !1;
    for (const e of r.region)
      if (typeof e != "number")
        return !1;
  }
  if (typeof r.sphere < "u" && r.sphere !== null) {
    if (!Array.isArray(r.sphere) || r.sphere.length !== 4)
      return !1;
    for (const e of r.sphere)
      if (typeof e != "number")
        return !1;
  }
  return !(typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions));
}
function isContent(r) {
  return !(r === null || typeof r != "object" || typeof r.boundingVolume < "u" && r.boundingVolume !== null && !isBoundingVolume(r.boundingVolume) || typeof r.uri < "u" && r.uri !== null && typeof r.uri != "string" || typeof r.url < "u" && r.url !== null && typeof r.url != "string" || typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions));
}
function isProperty(r) {
  return !(r === null || typeof r != "object" || r.maximum !== void 0 && r.maximum !== null && typeof r.maximum != "number" || r.minimum !== void 0 && r.minimum !== null && typeof r.minimum != "number" || typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions));
}
function resolveRefinementModes(r, e) {
  if (e !== void 0 && (r.refine === void 0 || r.refine === null) && (r.refine = e.refine), typeof r.refine > "u")
    throw new Error("Tried to propagate refinement mode when the root tile is missing a mode to propagate");
  let s;
  for (typeof r.children < "u" && r.children !== null ? s = r.children.map((o) => ({ refine: r.refine, tile: o })) : s = []; s.length > 0; ) {
    const o = s.pop(), a = o.refine, l = o.tile;
    (typeof l.refine > "u" || l.refine === null) && (l.refine = a), typeof l.children < "u" && l.children !== null && s.push(...l.children.map((u) => ({ refine: l.refine, tile: u })));
  }
}
function resolveBoundingSpheres(r) {
  const e = [r], s = new Sphere$1();
  for (; e.length > 0; ) {
    const o = e.pop();
    (typeof o.boundingVolume.sphere > "u" || o.boundingVolume.sphere === null) && (extractBoundingSphere(o, s.makeEmpty()), o.boundingVolume.sphere = [s.center.x, s.center.y, s.center.z, s.radius]), typeof o.children < "u" && o.children !== null && e.push(...o.children);
  }
}
function resolveTransforms(r, e) {
  const s = new Matrix4();
  if (loadTransform(r.transform, s), typeof e < "u") {
    const a = e.extras.transform;
    s.multiply(a);
  }
  r.extras.transform.copy(s);
  const o = [r];
  for (; o.length > 0; ) {
    const a = o.pop(), l = a.extras.transform;
    if (typeof a.children < "u" && a.children !== null) {
      const u = new Matrix4();
      for (const c of a.children) {
        const E = new Matrix4();
        loadTransform(c.transform, E), u.copy(l), u.multiply(E), E.copy(u), c.extras.transform.copy(E), o.push(c);
      }
    }
  }
}
function copyArray(r, e) {
  const s = Math.min(e.length, r.length);
  for (let o = 0; o < s; o += 1)
    e[o] = r[o];
}
function loadTransform(r, e) {
  typeof r < "u" && r !== null && copyArray(r, e.elements);
}
function extractBoundingSphere(r, e = new Sphere$1()) {
  const s = new Vector3$1();
  if (typeof r.boundingVolume.sphere < "u" && r.boundingVolume.sphere !== null)
    e.center.x = r.boundingVolume.sphere[0], e.center.y = r.boundingVolume.sphere[1], e.center.z = r.boundingVolume.sphere[2], e.radius = r.boundingVolume.sphere[3];
  else if (typeof r.boundingVolume.box < "u" && r.boundingVolume.box !== null) {
    e.center.x = r.boundingVolume.box[0], e.center.y = r.boundingVolume.box[1], e.center.z = r.boundingVolume.box[2], e.radius = 0, s.x = r.boundingVolume.box[3], s.y = r.boundingVolume.box[4], s.z = r.boundingVolume.box[5];
    const o = s.length();
    s.x = r.boundingVolume.box[6], s.y = r.boundingVolume.box[7], s.z = r.boundingVolume.box[8];
    const a = s.length();
    e.radius = Math.max(e.radius, s.length()), s.x = r.boundingVolume.box[9], s.y = r.boundingVolume.box[10], s.z = r.boundingVolume.box[11];
    const l = s.length();
    e.radius = Math.sqrt(o * o + a * a + l * l);
  } else if (typeof r.boundingVolume.region < "u" && r.boundingVolume.region !== null) {
    const o = new Cartographic$1(), a = r.boundingVolume.region, l = a[0], u = a[2], c = (l + u) / 2, E = a[1], d = a[3], f = (d + E) / 2, h = a[4], S = a[5], R = (S + h) / 2, _ = Ellipsoid$1.WGS_84, m = [
      _.cartesianForCartographic(o.set(l, E, h)),
      _.cartesianForCartographic(o.set(l, E, S)),
      _.cartesianForCartographic(o.set(l, E, R)),
      _.cartesianForCartographic(o.set(l, d, h)),
      _.cartesianForCartographic(o.set(l, d, S)),
      _.cartesianForCartographic(o.set(l, d, R)),
      _.cartesianForCartographic(o.set(l, f, h)),
      _.cartesianForCartographic(o.set(l, f, S)),
      _.cartesianForCartographic(o.set(l, f, R)),
      _.cartesianForCartographic(o.set(u, E, h)),
      _.cartesianForCartographic(o.set(u, E, S)),
      _.cartesianForCartographic(o.set(u, E, R)),
      _.cartesianForCartographic(o.set(u, d, h)),
      _.cartesianForCartographic(o.set(u, d, S)),
      _.cartesianForCartographic(o.set(u, d, R)),
      _.cartesianForCartographic(o.set(u, f, h)),
      _.cartesianForCartographic(o.set(u, f, S)),
      _.cartesianForCartographic(o.set(u, f, R)),
      _.cartesianForCartographic(o.set(c, E, h)),
      _.cartesianForCartographic(o.set(c, E, S)),
      _.cartesianForCartographic(o.set(c, E, R)),
      _.cartesianForCartographic(o.set(c, d, h)),
      _.cartesianForCartographic(o.set(c, d, S)),
      _.cartesianForCartographic(o.set(c, d, R)),
      _.cartesianForCartographic(o.set(c, f, h)),
      _.cartesianForCartographic(o.set(c, f, S)),
      _.cartesianForCartographic(o.set(c, f, R))
    ];
    for (const F of m)
      e.center.add(F.clone().divideScalar(m.length));
    for (const F of m)
      e.radius = Math.max(e.radius, s.copy(e.center).sub(F).length());
    const L = r.extras.transform.clone().invert();
    e.applyMatrix4(L);
  } else
    throw new Error("Invalid tile boundingVolume, no volume was defined");
  return e;
}
function readBoundingBox$1(r, e, s, o, a) {
  return typeof r.box < "u" && r.box !== null ? (e.x = r.box[0], e.y = r.box[1], e.z = r.box[2], s.x = r.box[3], s.y = r.box[4], s.z = r.box[5], o.x = r.box[6], o.y = r.box[7], o.z = r.box[8], a.x = r.box[9], a.y = r.box[10], a.z = r.box[11], !0) : !1;
}
function readBoundingSphere(r, e) {
  return typeof r.sphere < "u" && r.sphere !== null ? (e.center.x = r.sphere[0], e.center.y = r.sphere[1], e.center.z = r.sphere[2], e.radius = r.sphere[3], !0) : !1;
}
function isTile(r) {
  if (r === null || typeof r != "object" || !isBoundingVolume(r.boundingVolume) || typeof r.viewerRequestVolume < "u" && r.viewerRequestVolume !== null && !isBoundingVolume(r.boundingVolume) || typeof r.geometricError != "number" || typeof r.refine < "u" && r.refine !== null && typeof r.refine != "string")
    return !1;
  if (typeof r.transform < "u" && r.transform !== null) {
    if (!Array.isArray(r.transform))
      return !1;
    for (const e of r.transform)
      if (typeof e != "number")
        return !1;
  }
  if (typeof r.content < "u" && r.content !== null && !isContent(r.content))
    return !1;
  if (typeof r.children < "u" && r.children !== null) {
    if (!Array.isArray(r.children))
      return !1;
    for (const e of r.children)
      if (!isTile(e))
        return !1;
  }
  return !(typeof r.extensions < "u" && r.extensions !== null && !isExtensions(r.extensions) || typeof r.impl < "u" && !isImpl(r.impl));
}
var __awaiter$I = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
function isExtensions(r) {
  if (r === null || typeof r != "object")
    return !1;
  for (const e of Object.values(r))
    if (typeof e != "object")
      return !1;
  return !0;
}
function isImpl(r) {
  if (r === null || typeof r != "object")
    return !1;
  for (const e of Object.values(r))
    if (typeof e != "object")
      return !1;
  return !0;
}
function fetchTileset(r, e) {
  return __awaiter$I(this, void 0, void 0, function* () {
    const s = yield FileLoader.loadJson(r);
    if (!isTileset(s))
      throw new Error("Response does not match tileset interface");
    const o = s;
    return o.extras = {
      source: ResourceSource.fromDirectEndpoint(r, e)
    }, o;
  });
}
var _a;
class DebugDraw {
  static lineObjectInit() {
    const e = new LineSegments(DebugDraw.LINE_GEOMETRY, DebugDraw.LINE_MATERIAL);
    return e.frustumCulled = !1, e;
  }
  /**
   * Renders a wireframe section of a spheroid with the given longitude, latitude and height bounds.
   * @param ellipsoid
   * @param minLongitude
   * @param minLatitude
   * @param maxLongitude
   * @param maxLatitude
   * @param minHeight
   * @param maxHeight
   * @param globeToWorldTransform
   * @param color
   */
  static addGeographicBounds(e, s, o, a, l, u, c, E, d = [255, 0, 0]) {
    const f = s, h = o, S = a, R = l, _ = u, m = c;
    drawCartographicSegments(e, {
      longitude: f,
      latitude: h,
      height: _
    }, {
      longitude: f,
      latitude: h,
      height: m
    }, 1, E, d), drawCartographicSegments(e, {
      longitude: f,
      latitude: R,
      height: _
    }, {
      longitude: f,
      latitude: R,
      height: m
    }, 1, E, d), drawCartographicSegments(e, {
      longitude: S,
      latitude: h,
      height: _
    }, {
      longitude: S,
      latitude: h,
      height: m
    }, 1, E, d), drawCartographicSegments(e, {
      longitude: S,
      latitude: R,
      height: _
    }, {
      longitude: S,
      latitude: R,
      height: m
    }, 1, E, d), drawCartographicQuadAtHeight(e, f, h, S, R, _, 10, E, d), drawCartographicQuadAtHeight(e, f, h, S, R, m, 10, E, d);
  }
  /**
   * Renders the bounding volume encoded in the given `BoundingVolume` item as a debug item. Will apply the given
   * transformation matrix to the bounding volume before rendering
   * @param boundingVolume
   * @param volumeToGlobeTransform Matrix that transforms the volume/tile into ECEF coordinates
   * @param globeToWorldTransform Matrix that transforms from ECEF into ThreeJS world space
   * @param color Optional color to apply to the volume
   */
  static addBoundingVolume(e, s, o, a, l = [255, 0, 0]) {
    const u = new Vector3$1(), c = new Vector3$1(), E = new Vector3$1(), d = new Vector3$1(), f = new Sphere$1();
    if (s.region !== void 0 && s.region !== null && e.tileBoundingVolumesShowRegion) {
      const R = s.region;
      this.addGeographicBounds(Ellipsoid$1.WGS_84, R[0], R[1], R[2], R[3], R[4], R[5], void 0, l);
    }
    readBoundingBox$1(s, u, c, E, d) && e.tileBoundingVolumesShowBox && (applyMatrixToBox(u, c, E, d, o), applyMatrixToBox(u, c, E, d, a), DebugDraw.addBox(u, c, E, d, l));
    const h = s.region !== void 0 && s.region !== null, S = s.box !== void 0 && s.box !== null;
    h && !e.tileBoundingVolumesShowRegionSphere || S && !e.tileBoundingVolumesShowBoxSphere || readBoundingSphere(s, f) && (typeof o < "u" && f.applyMatrix4(o), typeof a < "u" && f.applyMatrix4(a), DebugDraw.addSphere(f.center, f.radius, l));
  }
  /**
   * Adds a single line segment to the list that will be rendered exactly once in the frame it is requested. The line
   * does not persist between frames.
   *
   * This function must be called every frame for the object to continue drawing. While not very efficient it keeps
   * the usage simple which is perfect for debugging utilities when you just need to get something on screen and don't
   * care how efficient it is
   * @param start The start position of the line segment
   * @param end The end position of the line segment
   * @param color Optional color to apply to the lines
   */
  static addLine(e, s, o = [255, 0, 0]) {
    const a = new Vector3$1();
    a.x = e.x, a.y = e.y, a.z = e.z;
    const l = new Vector3$1();
    l.x = s.x, l.y = s.y, l.z = s.z, this.POINTS.push(a), this.COLORS.push(o[0]), this.COLORS.push(o[1]), this.COLORS.push(o[2]), this.POINTS.push(l), this.COLORS.push(o[0]), this.COLORS.push(o[1]), this.COLORS.push(o[2]);
  }
  /**
   * Adds a single sphere to the list that will be rendered exactly once in the frame it is requested. The sphere does
   * not persist between frames.
   *
   * This function must be called every frame for the object to continue drawing. While not very efficient it keeps
   * the usage simple which is perfect for debugging utilities when you just need to get something on screen and don't
   * care how efficient it is
   * @param position The position of the sphere in world space
   * @param radius The radius of the sphere
   * @param color Optional color to apply to the sphere
   */
  static addSphere(e, s, o = [255, 0, 0]) {
    const a = new Mesh(this.SPHERE_GEOMETRY, this.MESH_MATERIAL.clone());
    a.material.color = new Color(o[0] / 255, o[1] / 255, o[2] / 255), a.frustumCulled = !1, a.scale.x = s, a.scale.y = s, a.scale.z = s, a.position.x = e.x, a.position.y = e.y, a.position.z = e.z, this.OBJECTS.add(a);
  }
  /**
   * Adds a single box to the list that will be rendered exactly once in the frame it is requested. The box does
   * not persist between frames.
   *
   * This function must be called every frame for the object to continue drawing. While not very efficient it keeps
   * the usage simple which is perfect for debugging utilities when you just need to get something on screen and don't
   * care how efficient it is
   * @param position The position of the box in world space
   * @param xAxis Encodes the half width and X axis of the box's rotation basis
   * @param yAxis Encodes the half height and X axis of the box's rotation basis
   * @param zAxis Encodes the half depth and X axis of the box's rotation basis
   * @param color Optional color to apply to the box
   */
  static addBox(e, s, o, a, l = [255, 0, 0]) {
    const u = new Vector3$1(s.x, s.y, s.z), c = new Vector3$1(o.x, o.y, o.z), E = new Vector3$1(a.x, a.y, a.z), d = new Mesh(this.BOX_GEOMETRY, this.MESH_MATERIAL.clone());
    d.material.color = new Color(l[0] / 255, l[1] / 255, l[2] / 255), d.frustumCulled = !1, d.position.x = e.x, d.position.y = e.y, d.position.z = e.z, d.scale.x = u.length(), d.scale.y = c.length(), d.scale.z = E.length(), u.normalize(), c.normalize(), E.normalize();
    const f = new Matrix4();
    f.set(u.x, u.y, u.z, 0, c.x, c.y, c.z, 0, E.x, E.y, E.z, 0, 0, 0, 0, 1), d.quaternion.setFromRotationMatrix(f.invert()), this.OBJECTS.add(d);
  }
  /**
   * Instantiates a new 'IRenderPass' instance that will handle rendering the debug shapes into the provided render
   * target.
   *
   * It is perfectly valid (and expected) to create multiple pass instances by calling this function multiple times.
   * Specifically it is intended to create one pass for each render target in the back buffer set.
   *
   * @param rt The render target to render the debug geometry into.
   */
  static getRenderPass(e) {
    return {
      render(s, o, a, l) {
        const u = new Uint8Array(DebugDraw.COLORS);
        DebugDraw.LINE_GEOMETRY.setFromPoints(DebugDraw.POINTS), DebugDraw.LINE_GEOMETRY.setAttribute("color", new Uint8BufferAttribute(u, 3, !0)), DebugDraw.OBJECTS.add(DebugDraw.LINE_OBJECT), DebugDraw.OBJECTS.updateMatrixWorld(), o.setRenderTarget(e), o.render(DebugDraw.OBJECTS, a), DebugDraw.POINTS = [], DebugDraw.COLORS = [], DebugDraw.OBJECTS.clear();
      }
    };
  }
}
_a = DebugDraw;
DebugDraw.LINE_MATERIAL = new LineBasicMaterial({ vertexColors: !0 });
DebugDraw.LINE_GEOMETRY = new BufferGeometry();
DebugDraw.LINE_OBJECT = _a.lineObjectInit();
DebugDraw.POINTS = [];
DebugDraw.COLORS = [];
DebugDraw.MESH_MATERIAL = new MeshBasicMaterial({
  color: 16711680,
  wireframe: !0
});
DebugDraw.SPHERE_GEOMETRY = new SphereGeometry(1);
DebugDraw.BOX_GEOMETRY = new BoxGeometry(2, 2, 2);
DebugDraw.OBJECTS = new Object3D();
function applyMatrixToBox(r, e, s, o, a) {
  if (typeof a < "u") {
    const l = new Vector3$1(), u = new Quaternion$1(), c = new Vector3$1();
    r.applyMatrix4(a), a.decompose(l, u, c), e.multiply(c).applyQuaternion(u), s.multiply(c).applyQuaternion(u), o.multiply(c).applyQuaternion(u);
  }
}
function drawCartographicSegments(r, e, s, o, a, l = [255, 0, 0]) {
  const u = (s.longitude - e.longitude) / o, c = (s.latitude - e.latitude) / o, E = (s.height - e.height) / o, d = new Cartographic$1(), f = new Vector3$1(), h = r.cartesianForCartographic(d.set(e.longitude, e.latitude, e.height));
  for (let S = 1; S <= o; S += 1) {
    const R = e.longitude + u * S, _ = e.latitude + c * S, m = e.height + E * S;
    r.cartesianForCartographic(d.set(R, _, m), f), typeof a < "u" && f.applyMatrix4(a), DebugDraw.addLine(h, f, l), h.copy(f);
  }
}
function drawCartographicQuadAtHeight(r, e, s, o, a, l, u, c, E = [255, 0, 0]) {
  drawCartographicSegments(r, {
    longitude: e,
    latitude: s,
    height: l
  }, {
    longitude: o,
    latitude: s,
    height: l
  }, u, c, E), drawCartographicSegments(r, {
    longitude: e,
    latitude: s,
    height: l
  }, {
    longitude: e,
    latitude: a,
    height: l
  }, u, c, E), drawCartographicSegments(r, {
    longitude: e,
    latitude: a,
    height: l
  }, {
    longitude: o,
    latitude: a,
    height: l
  }, u, c, E), drawCartographicSegments(r, {
    longitude: o,
    latitude: s,
    height: l
  }, {
    longitude: o,
    latitude: a,
    height: l
  }, u, c, E);
}
class DoublyLinkedList {
  constructor() {
    this._head = null, this._tail = null, this.len = 0;
  }
  /**
   * Returns the current head of the linked list
   */
  get head() {
    return this._head;
  }
  /**
   * Returns the current tail of the linked list
   */
  get tail() {
    return this._tail;
  }
  /**
   * Returns the current number of elements in the linked list
   */
  get length() {
    return this.len;
  }
  /**
   * Constructs a new node that will contain the payload 'data' and inserts it onto the tail of the list.
   *
   * The 'data' payload is optional. When left unspecified the returned node is created without a 'data' field.
   * @param data The node payload
   */
  add(e) {
    const s = {
      next: null,
      prev: this._tail,
      data: e
    };
    return this._tail !== null ? (this._tail.next = s, this._tail = s) : (this._head = s, this._tail = s), this.len += 1, s;
  }
  /**
   * Removes the given node from the list.
   *
   * Calling 'remove' with a node that is not in the target list is undefined behavior.
   *
   * @param node The node to remove. Must be a member of 'this' when called.
   */
  remove(e) {
    const s = e;
    s.next !== null && s.prev !== null ? (s.prev.next = s.next, s.next.prev = s.prev) : s.prev !== null ? (s.prev.next = null, this._tail = s.prev) : s.next !== null ? (s.next.prev = null, this._head = s.next) : (this._head = null, this._tail = null), this.len -= 1;
  }
  /**
   * Takes two nodes 'node' and 'nextNode' that are members of 'this' and removes 'nextNode' from it's current place
   * in the list and places it as the immediate next node for 'node'.
   *
   * Calling 'splice' with 'node' or 'nextNode' that are not in the target list is undefined behavior.
   * @param node The anchor node we're moving to
   * @param nextNode The node which will be moved to be next from 'node'
   */
  splice(e, s) {
    const o = e, a = s;
    if (o === a)
      return;
    this.remove(a), this.len += 1;
    const l = o.next;
    o.next = a, this._tail === o ? this._tail = a : l !== null && (l.prev = a), a.next = l, a.prev = o;
  }
}
class EvictionQueue {
  constructor() {
    this.list = new DoublyLinkedList(), this._shouldTrim = !1, this._sentinel = this.list.add();
  }
  /**
   * Returns the number of nodes in the queue
   */
  get length() {
    return this.list.length - 1;
  }
  /**
   * The 'sentinel' node that is used as a bisector to track live/old nodes.
   *
   * Any node after 'sentinel' is considered live. Any node previous to 'sentinel' is considered old and candidate for
   * eviction.
   */
  get sentinel() {
    return this._sentinel;
  }
  /**
   * Queue a forced 'trim' operation.
   */
  queueTrim() {
    this._shouldTrim = !0;
  }
  /**
   * Marks that a new frame has begun.
   *
   * This moves the sentinel to the tail of the list, marking all nodes as candidate for eviction.
   *
   * The intended use case is to mark and touch nodes every frame with the following sequence
   * - `this.newFrame() // Marks all nodes as eviction candidates`
   * - `this.touch(node) // Touch any nodes that must remain loaded`
   * - `this.evictNodes() // After updating the queue we trigger unloading tiles, starting from the oldest`
   */
  newFrame() {
    this.list.tail !== null && this.list.splice(this.list.tail, this._sentinel);
  }
  /**
   * Insert a new item with the given payload into the queue. The list node containing the data will be returned.
   * @param data
   */
  add(e) {
    return this.list.add(e);
  }
  /**
   * Updates the given node to mark it as 'safe' until the next call to 'newFrame'.
   *
   * This will move the node inside the queue, so it also maintains the LRU order.
   * @param node The node to 'touch'
   */
  touch(e) {
    this.list.splice(this._sentinel, e);
  }
  /**
   * Evicts an individual node from the queue, unconditionally. This will *not* check if the node is 'safe'.
   * @param node The node to evict
   * @param evictCallback A callback function that will be called with the node's data after the node has been
   *                       removed (evicted) from the queue
   */
  evictNode(e, s) {
    this.list.remove(e), s(e.data);
  }
  /**
   * Performs a node eviction cycle. Will evict nodes from the queue in order from least recently touched to most
   * recently touched while stopping once the 'evictCondition' callback returns false for the first time, or when no
   * non-safe nodes remain if a 'trim' has been queued.
   *
   * The 'evictCallback' will be called with the data of each evicted node as they are evicted.
   *
   * The 'evictCondition' callback will be called while iterating the queue every iteration to decide when enough
   * nodes have been evicted. The callback should return true for as long as nodes should continue to be evicted. Once
   * no more nodes need to be evicted it should return false, the iteration will stop and the function will return.
   *
   * If 'trim' has been queued then the callback will ignore 'evictCondition' and will loop until all evict-able nodes
   * have been removed from the queue. 'evictCondition' will still be called, but the function will just keep
   * iterating regardless of its return value.
   *
   * @param evictCondition Callback function that will be checked prior to each eviction attempt.
   * @param evictCallback A callback function that will be called with the node's data after the node has been
   *                       removed (evicted) from the queue
   */
  evictNodes(e, s) {
    const o = this._shouldTrim;
    this._shouldTrim = !1;
    const a = this._sentinel;
    let l = this.list.head;
    for (; !(l === null || l === a || !(o || e())); ) {
      const u = l;
      this.evictNode(u, s), l = l.next;
    }
  }
}
class TCache {
  /**
   * @param tilingScheme The tiling scheme this cache is storing items in.
   */
  constructor(e) {
    this.cache = [], this.tilingScheme = e;
    for (let s = 0; s < 32; s += 1)
      this.cache.push(/* @__PURE__ */ new Map());
  }
  /**
   * Writes a new entry into the cache for the specified tile. This will overwrite the old entry regardless of the
   * existing entry's reference count.
   *
   * Calling this on an already cached tile will replace the old item, leaving it dangling. The reference count will
   * no longer be managed and so it will never have 'onDestruction' called for it. Freeing dangling tiles is the
   * caller's responsibility.
   *
   * In general this function should not be called for already tiled items.
   *
   * @param x The tile x coordinate to add the item for
   * @param y The tile y coordinate to add the item for
   * @param zoomLevel The zoom level to add the item for
   * @param item The item to add to the cache
   */
  addItem(e, s, o, a) {
    const l = this.hashTileCoordinateForNode(e, s, o), u = {
      refCount: 1,
      v: a
    };
    return this.cache[o].set(l, u), u.v;
  }
  /**
   * Attempts to acquire a cached item for the specified tile. Will return 'undefined' if no item is cached for that
   * tile. If the item *is* cached then the reference count will be incremented and a reference to the item will be
   * returned.
   *
   * To correctly use the cache there should be exactly one {@link TCache.release} call for every 'acquire' call. If
   * 'acquire' is called more times than {@link TCache.release} then the item's reference count will never reach zero,
   * and the item will be left dangling.
   *
   * {@link TCache.release} being called more times than 'release' won't trigger immediate mis-behavior.
   *
   * @see TCache.release
   *
   * @param x
   * @param y
   * @param zoomLevel
   */
  acquire(e, s, o) {
    const a = this.hashTileCoordinateForNode(e, s, o), u = this.cache[o].get(a);
    return u !== void 0 && (u.refCount += 1), u == null ? void 0 : u.v;
  }
  /**
   * Attempts to release the item for the specified tile. If there is a cached item for the requested tile then the
   * reference count will be decremented. If the reference count reaches zero then 'onDestruction' will be called with
   * item in question as the parameter.
   *
   * 'onDestruction' should be some function or closure that will manage releasing the resources associated with the
   * cached item.
   *
   * If 'release' is called for an item that is not cached then it will simply do nothing.
   *
   * To correctly use the cache there should be exactly one 'release' call for every {@link TCache.acquire} call. If
   * {@link TCache.acquire} is called more times than 'release' then the item's reference count will never reach zero,
   * and the item will be left dangling.
   *
   * If a user attempts to call 'release' more times than {@link TCache.acquire} for a particular resource then no
   * immediate problems will occur. The best case is that nothing happens as 'release' is called for an uncached item
   * and does nothing. Problems can happen if a cache slot is reused though. In this case we may be trying to call
   * 'release' for a resource that has already been destroyed and replaced by a new item, releasing a resource we
   * never owned.
   *
   * @see TCache.acquire
   *
   * @param x
   * @param y
   * @param zoomLevel
   * @param onDestruction
   */
  release(e, s, o, a) {
    const l = this.hashTileCoordinateForNode(e, s, o), u = this.cache[o], c = u.get(l);
    c !== void 0 && (c.refCount -= 1, c.refCount <= 0 && (a(c.v), u.delete(l)));
  }
  /**
   * This provides a simple and efficient hash function for a zoomLevel + tileCoordinate pair that will provide a
   * unique integer for any coordinate at a given zoom level.
   *
   * All inputs *MUST* be integers. No guarantees on the output are made if *any* of the input values are not whole
   * numbers.
   *
   * This hash function is intended to be used for the node cache.
   *
   * WARNING
   *
   * There are no uniqueness guarantees *between zoom levels*. hashTileCoordinate(1, 1, 0) and
   * hashTileCoordinate(2, 1, 0) *WILL* hash to the same value. The uniqueness of the hash is only held at the same
   * zoom level.
   * @param zoomLevel The zoom level we're hashing for
   * @param x The x coordinate of the tile (horizontal)
   * @param y The y coordinate of the tile (vertical)
   */
  hashTileCoordinateForNode(e, s, o) {
    return this.tilingScheme.getNumberOfXTilesAtLevel(o) * s + e;
  }
}
class GeometryCache extends TCache {
  constructor(e) {
    super(e);
  }
  /**
   * This function will evict the cached data for the given tile. If there is no cache entry for the tile then the
   * function will just do nothing.
   * @param x The x coordinate of the tile to evict
   * @param y The y coordinate of the tile to evict
   * @param zoomLevel The zoom level we're looking up a tile to evict
   */
  release(e, s, o) {
    super.release(e, s, o, (a) => {
      a.forEach((l) => l.geometry.dispose());
    });
  }
}
class TileCache {
  constructor(e) {
    this.cache = [], this.tilingScheme = e;
    for (let s = 0; s < 32; s += 1)
      this.cache.push(/* @__PURE__ */ new Map());
  }
  addItem(e, s, o, a) {
    const l = this.hashTileCoordinateForNode(e, s, o), u = Object.assign({}, a);
    return this.cache[o].set(l, u), u;
  }
  /**
   * This function will return a ThreeJS 'Mesh' object for the requested tile, or undefined if no mesh has been
   * generated for that tile.
   *
   * This function allows getting map tiles without triggering tile generation. This allows for querying if a tile is
   * resident, or getting a tile to render only if the data is already loaded.
   *
   * @param zoomLevel The zoom level we're looking up a tile at
   * @param x The x coordinate of the tile to get
   * @param y The y coordinate of the tile to get
   */
  acquire(e, s, o) {
    const a = this.hashTileCoordinateForNode(e, s, o);
    return this.cache[o].get(a);
  }
  /**
   * This function will evict the cached data for the given tile. If there is no cache entry for the tile then the
   * function will just do nothing.
   * @param zoomLevel The zoom level we're looking up a tile to evict
   * @param x The x coordinate of the tile to evict
   * @param y The y coordinate of the tile to evict
   */
  release(e, s, o) {
    const a = this.hashTileCoordinateForNode(e, s, o), l = this.cache[o].get(a);
    l !== void 0 && (evictMaterial(l.material), this.cache[o].delete(a));
  }
  /**
   * This provides a simple and efficient hash function for a zoomLevel + tileCoordinate pair that will provide a
   * unique integer for any coordinate at a given zoom level.
   *
   * All inputs *MUST* be integers. No guarantees on the output are made if *any* of the input values are not whole
   * numbers.
   *
   * This hash function is intended to be used for the node cache.
   *
   * WARNING
   *
   * There are no uniqueness guarantees *between zoom levels*. hashTileCoordinate(1, 0, 1) and
   * hashTileCoordinate(1, 0, 2) *WILL* hash to the same value. The uniqueness of the hash is only held at the same
   * zoom level.
   * @param x The x coordinate of the tile (horizontal)
   * @param y The y coordinate of the tile (vertical)
   * @param zoomLevel The zoom level we're hashing for
   */
  hashTileCoordinateForNode(e, s, o) {
    return this.tilingScheme.getNumberOfXTilesAtLevel(o) * s + e;
  }
}
class QuadTreeNode {
  constructor(e, s, o, a, l, u) {
    this.x = e, this.y = s, this.zoomLevel = o, this.ellipsoid = l, this.tilingScheme = a, this.parent = u, this._children = [], this.lastTouchedFrame = 0, this.region = this.tilingScheme.tileXYToRectangle(e, s, o), this.boundingSphere = this.ellipsoid.approximateBoundingSphereForRegion(this.region.southwest, this.region.northeast);
  }
  /**
   * Generate this node's children
   */
  generateChildren() {
    this._children = [];
    for (let e = 0; e < 2; e += 1)
      for (let s = 0; s < 2; s += 1) {
        const o = this.x * 2 + s, a = this.y * 2 + e;
        this._children.push(new QuadTreeNode(o, a, this.zoomLevel + 1, this.tilingScheme, this.ellipsoid, this));
      }
  }
  /**
   * Get all the children of this node
   *
   * If there are no children, this will return an empty list
   */
  get children() {
    return [...this._children];
  }
}
class ImageCache extends TCache {
  constructor(e) {
    super(e);
  }
  /**
   * This function will evict the cached data for the given tile. If there is no cache entry for the tile then the
   * function will just do nothing.
   * @param x The x coordinate of the tile to evict
   * @param y The y coordinate of the tile to evict
   * @param zoomLevel The zoom level we're looking up a tile to evict
   */
  release(e, s, o) {
    super.release(e, s, o, (a) => {
      a.forEach((l) => l.texture.dispose());
    });
  }
}
class TileRegionIterator {
  constructor(e, s, o) {
    this._minTile = new Vector2(), this._maxTile = new Vector2(), this._tile = { x: 0, y: 0 }, this._state = { x: 0, y: 0 };
    const a = e.positionToTileXY(s.southwest, o), l = e.positionToTileXY(s.northeast, o);
    this._minTile.x = Math.min(a.x, l.x), this._minTile.y = Math.min(a.y, l.y), this._maxTile.x = Math.max(a.x, l.x), this._maxTile.y = Math.max(a.y, l.y), this.reset();
  }
  /**
   * Reset the iterator to its default state. Use this to allow reusing the iterator for another iteration cycle.
   */
  reset() {
    this._state.x = this._minTile.x, this._state.y = this._minTile.y;
  }
  next(...e) {
    return this._state.y > this._maxTile.y ? {
      done: !0,
      value: void 0
    } : (this._tile.x = this._state.x, this._tile.y = this._state.y, this._state.x += 1, this._state.x > this._maxTile.x && (this._state.x = this._minTile.x, this._state.y += 1), {
      done: !1,
      value: this._tile
    });
  }
  [Symbol.iterator]() {
    return this;
  }
}
class BaseTilingScheme {
  constructor(e, s) {
    this._numRootTilesX = e, this._numRootTilesY = s;
  }
  /**
   * @see TilingScheme.getNumberOfXTilesAtLevel
   */
  getNumberOfXTilesAtLevel(e) {
    return this._numRootTilesX << e;
  }
  /**
   * @see TilingScheme.getNumberOfYTilesAtLevel
   */
  getNumberOfYTilesAtLevel(e) {
    return this._numRootTilesY << e;
  }
}
class IdentityProjection {
  constructor(e) {
    this._ellipsoid = e;
  }
  /**
   * @see MapProjection.ellipsoid
   */
  get ellipsoid() {
    return this._ellipsoid;
  }
  get region() {
    return Rectangle.MAX;
  }
  /**
   * @see MapProjection.project
   */
  project(e, s = new Vector3$1()) {
    const o = e.longitude, a = e.latitude, l = e.height;
    return s.set(o, a, l);
  }
  /**
   * @see MapProjection.unproject
   */
  unproject(e, s = new Cartographic$1()) {
    const o = e.x, a = e.y, l = e.z;
    return s.set(o, a, l);
  }
}
class WebMercatorProjection {
  constructor(e = Ellipsoid$1.WGS_84) {
    this._ellipsoid = e, this._semimajorAxis = this._ellipsoid.maximumRadius, this._oneOverSemimajorAxis = 1 / this._semimajorAxis, this._region = new Rectangle(Rectangle.MAX.west, WebMercatorProjection.MIN_LATITUDE, Rectangle.MAX.east, WebMercatorProjection.MAX_LATITUDE);
  }
  /**
   * @see MapProjection.ellipsoid
   */
  get ellipsoid() {
    return this._ellipsoid;
  }
  get region() {
    return this._region;
  }
  /**
   * @see MapProjection.project
   */
  project(e, s = new Vector3$1()) {
    const o = e.longitude, a = e.latitude, l = o * this._semimajorAxis, u = WebMercatorProjection.geodeticLatitudeToMercatorAngle(a) * this._semimajorAxis, c = e.height;
    return s.set(l, u, c);
  }
  /**
   * @see MapProjection.unproject
   */
  unproject(e, s = new Cartographic$1()) {
    const o = e.x, a = e.y, l = o * this._oneOverSemimajorAxis, u = WebMercatorProjection.mercatorAngleToGeodeticLatitude(a * this._oneOverSemimajorAxis), c = e.z;
    return s.set(l, u, c);
  }
  /**
   * Converts a Mercator angle, in the range -PI to PI, to a geodetic latitude
   * in the range -PI/2 to PI/2.
   *
   * @param mercatorAngle The angle to convert.
   * @returns The geodetic latitude in radians.
   */
  static mercatorAngleToGeodeticLatitude(e) {
    return Math.PI / 2 - 2 * Math.atan(Math.exp(-e));
  }
  /**
   * Converts a geodetic latitude in radians, in the range -PI/2 to PI/2, to a Mercator
   * angle in the range -PI to PI.
   *
   * @param latitude The geodetic latitude in radians.
   * @returns The Mercator angle.
   */
  static geodeticLatitudeToMercatorAngle(e) {
    e = Math.min(Math.max(e, this.MIN_LATITUDE), this.MAX_LATITUDE);
    const s = Math.sin(e);
    return 0.5 * Math.log((1 + s) / (1 - s));
  }
}
WebMercatorProjection.MAX_LATITUDE = 1.4844217274;
WebMercatorProjection.MIN_LATITUDE = -1.4844217274;
class GeographicTilingScheme extends BaseTilingScheme {
  constructor(e) {
    var s, o, a, l, u;
    const c = (s = e == null ? void 0 : e.ellipsoid) !== null && s !== void 0 ? s : Ellipsoid$1.WGS_84, E = (o = e == null ? void 0 : e.numRootTilesX) !== null && o !== void 0 ? o : 2, d = (a = e == null ? void 0 : e.numRootTilesY) !== null && a !== void 0 ? a : 1;
    super(E, d), this._projection = new IdentityProjection(c), this._rectangle = (u = (l = e == null ? void 0 : e.region) === null || l === void 0 ? void 0 : l.clone()) !== null && u !== void 0 ? u : Rectangle.MAX.intersection(this._projection.region);
  }
  /**
   * @see TilingScheme.ellipsoid
   */
  get ellipsoid() {
    return this._projection.ellipsoid;
  }
  /**
   * @see TilingScheme.rectangle
   */
  get rectangle() {
    return this._rectangle;
  }
  /**
   * @see TilingScheme.projection
   */
  get projection() {
    return this._projection;
  }
  /**
   * @see TilingScheme.rectangleToNativeRectangle
   */
  rectangleToNativeRectangle(e, s = new Rectangle()) {
    const o = MathUtils.radiansToDegrees(e.west), a = MathUtils.radiansToDegrees(e.south), l = MathUtils.radiansToDegrees(e.east), u = MathUtils.radiansToDegrees(e.north);
    return s.set(o, a, l, u);
  }
  /**
   * @see TilingScheme.tileXYToNativeRectangle
   */
  tileXYToNativeRectangle(e, s, o, a = new Rectangle()) {
    return this.tileXYToRectangle(e, s, o, a), this.rectangleToNativeRectangle(a), a;
  }
  /**
   * @see TilingScheme.tileXYToRectangle
   */
  tileXYToRectangle(e, s, o, a = new Rectangle()) {
    const l = this.getNumberOfXTilesAtLevel(o), u = this._rectangle.width / l, c = this.getNumberOfYTilesAtLevel(o), E = this._rectangle.height / c, d = e * u + this._rectangle.west, f = (e + 1) * u + this._rectangle.west, h = this._rectangle.north - s * E, S = this._rectangle.north - (s + 1) * E;
    return a.set(d, S, f, h);
  }
  /**
   * @see TilingScheme.positionToTileXY
   */
  positionToTileXY(e, s, o = new Vector2()) {
    if (!this._rectangle.contains(e))
      throw new Error("Trying to sample tiling scheme outside of it's relevant bounds");
    const a = this.getNumberOfXTilesAtLevel(s), l = this.getNumberOfYTilesAtLevel(s), u = this._rectangle.width / a, c = this._rectangle.height / l;
    let E = (e.longitude - this._rectangle.west) / u | 0;
    E >= a && (E = a - 1);
    let d = (this._rectangle.north - e.latitude) / c | 0;
    return d >= l && (d = l - 1), o.set(E, d);
  }
}
class WebMercatorTilingScheme extends BaseTilingScheme {
  constructor(e) {
    var s, o, a, l, u, c, E, d, f, h, S;
    const R = (s = e == null ? void 0 : e.ellipsoid) !== null && s !== void 0 ? s : Ellipsoid$1.WGS_84, _ = (o = e == null ? void 0 : e.numRootTilesX) !== null && o !== void 0 ? o : 1, m = (a = e == null ? void 0 : e.numRootTilesY) !== null && a !== void 0 ? a : 1, L = (u = (l = e == null ? void 0 : e.area) === null || l === void 0 ? void 0 : l.min.x) !== null && u !== void 0 ? u : R.maximumRadius * -Math.PI, F = (E = (c = e == null ? void 0 : e.area) === null || c === void 0 ? void 0 : c.min.y) !== null && E !== void 0 ? E : R.maximumRadius * -Math.PI, W = (f = (d = e == null ? void 0 : e.area) === null || d === void 0 ? void 0 : d.max.x) !== null && f !== void 0 ? f : R.maximumRadius * Math.PI, G = (S = (h = e == null ? void 0 : e.area) === null || h === void 0 ? void 0 : h.max.y) !== null && S !== void 0 ? S : R.maximumRadius * Math.PI;
    super(_, m), this._projection = new WebMercatorProjection(R), this._nativeSouthWest = new Vector3$1(L, F, 0), this._nativeNorthEast = new Vector3$1(W, G, 0);
    const q = this._projection.unproject(this._nativeSouthWest), fe = this._projection.unproject(this._nativeNorthEast);
    this._rectangle = new Rectangle(q.longitude, q.latitude, fe.longitude, fe.latitude);
  }
  /**
   * @see TilingScheme.ellipsoid
   */
  get ellipsoid() {
    return this._projection.ellipsoid;
  }
  /**
   * @see TilingScheme.rectangle
   */
  get rectangle() {
    return this._rectangle;
  }
  /**
   * @see TilingScheme.projection
   */
  get projection() {
    return this._projection;
  }
  /**
   * @see TilingScheme.rectangleToNativeRectangle
   */
  rectangleToNativeRectangle(e, s = new Rectangle()) {
    const o = this._projection.project(e.southwest), a = this._projection.project(e.northeast);
    return s.set(o.x, o.y, a.x, a.y);
  }
  /**
   * @see TilingScheme.tileXYToNativeRectangle
   */
  tileXYToNativeRectangle(e, s, o, a = new Rectangle()) {
    const l = this.getNumberOfXTilesAtLevel(o), u = this.getNumberOfYTilesAtLevel(o), E = (this._nativeNorthEast.x - this._nativeSouthWest.x) / l, f = (this._nativeNorthEast.y - this._nativeSouthWest.y) / u, h = this._nativeSouthWest.x + e * E, S = this._nativeSouthWest.x + (e + 1) * E, R = this._nativeNorthEast.y - s * f, _ = this._nativeNorthEast.y - (s + 1) * f;
    return a.set(h, _, S, R);
  }
  /**
   * @see TilingScheme.tileXYToRectangle
   */
  tileXYToRectangle(e, s, o, a = new Rectangle()) {
    const l = this.tileXYToNativeRectangle(e, s, o, a), u = this._projection.unproject(new Vector3$1(l.west, l.south)), c = this._projection.unproject(new Vector3$1(l.east, l.north));
    return l.west = u.longitude, l.south = u.latitude, l.east = c.longitude, l.north = c.latitude, l;
  }
  /**
   * @see TilingScheme.positionToTileXY
   */
  positionToTileXY(e, s, o = new Vector2()) {
    if (!this._rectangle.contains(e))
      throw new Error("Trying to sample tiling scheme outside of it's relevant bounds");
    const a = this.getNumberOfXTilesAtLevel(s), l = this.getNumberOfYTilesAtLevel(s), c = (this._nativeNorthEast.x - this._nativeSouthWest.x) / a, d = (this._nativeNorthEast.y - this._nativeSouthWest.y) / l, f = this._projection.project(e), h = f.x - this._nativeSouthWest.x, S = this._nativeNorthEast.y - f.y;
    let R = h / c | 0;
    R >= a && (R = a - 1);
    let _ = S / d | 0;
    return _ >= l && (_ = l - 1), o.set(R, _);
  }
}
function hashVertex(r) {
  return `${r.x}|${r.y}|${r.z}`;
}
function geometryToMesh$1(r) {
  const e = r.getIndex();
  if (e === null)
    throw new Error("Geometry object does not have a list of indices.");
  const s = r.getAttribute("position"), o = [];
  for (let a = 0; a < e.count; a += 3) {
    const l = [];
    for (let u = 0; u < 3; u++) {
      const c = e.array[a + u], E = s.array[c * 3 + 0], d = s.array[c * 3 + 1], f = s.array[c * 3 + 2];
      l.push(new Vector3$1(E, d, f));
    }
    o.push(l);
  }
  return o;
}
function findEdgeIndices(r, e, s, o) {
  const a = r.length / 3, l = 1e-7, u = [], c = [], E = [], d = [], f = new Cartographic$1(), h = new Vector3$1();
  for (let S = 0; S < a; S++) {
    const R = r[S * 3 + 0], _ = r[S * 3 + 1], m = r[S * 3 + 2];
    h.set(R, _, m).add(e), o.ellipsoid.cartographicForPosition(h, f), Math.abs(f.longitude - s.east) <= l ? E.push(S) : Math.abs(f.longitude - s.west) <= l && u.push(S), Math.abs(f.latitude - s.south) <= l ? c.push(S) : Math.abs(f.latitude - s.north) <= l && d.push(S);
  }
  return [u, c, E, d];
}
function calculateSkirtGeometry(r, e, s, o, a) {
  const l = findEdgeIndices(r, s, o, a), [u, c, E, d] = l;
  u.sort((L, F) => e[L * 2 + 1] - e[F * 2 + 1]), E.sort((L, F) => e[F * 2 + 1] - e[L * 2 + 1]), c.sort((L, F) => e[F * 2] - e[L * 2]), d.sort((L, F) => e[L * 2] - e[F * 2]);
  const f = [], h = [], S = [], R = new Cartographic$1(), _ = new Vector3$1();
  for (const L of l) {
    const F = f.length / 3;
    for (const W of L) {
      const G = r[W * 3 + 0], q = r[W * 3 + 1], fe = r[W * 3 + 2];
      _.set(G, q, fe).add(s), a.ellipsoid.cartographicForPosition(_, R), R.height -= 1e4;
      const _e = a.ellipsoid.cartesianForCartographic(R, _).sub(s);
      f.push(G), f.push(q), f.push(fe), f.push(_e.x), f.push(_e.y), f.push(_e.z), h.push(e[W * 2 + 0]), h.push(e[W * 2 + 1]), h.push(e[W * 2 + 0]), h.push(e[W * 2 + 1]);
    }
    for (let W = 0; W < L.length * 2 - 3; W++) {
      const G = F + W, q = F + (W + 2), fe = G, _e = G + 1, Le = q, Fe = q + 1;
      S.push(_e), S.push(fe), S.push(Fe), S.push(Le), S.push(Fe), S.push(fe);
    }
  }
  const m = new BufferGeometry();
  return m.setAttribute("position", new Float32BufferAttribute(f, 3, !1)), m.setAttribute("uv", new Float32BufferAttribute(h, 2, !1)), m.setIndex(S), m;
}
function meshToGeometry(r, e, s, o) {
  const a = /* @__PURE__ */ new Map();
  let l = 0;
  for (const _ of r)
    for (const m of _) {
      const L = hashVertex(m);
      a.has(L) || a.set(L, [m, l++]);
    }
  const u = o.projection.project(s.southwest).setZ(0), E = o.projection.project(s.northeast).setZ(1).sub(u), d = new Float32Array(3 * l), f = new Float32Array(2 * l);
  for (const [_, m] of a.values()) {
    const L = _.clone().add(e), F = o.ellipsoid.cartographicForPosition(L), W = o.projection.project(F).sub(u).divide(E);
    d[m * 3 + 0] = _.x, d[m * 3 + 1] = _.y, d[m * 3 + 2] = _.z, f[m * 2 + 0] = W.x, f[m * 2 + 1] = W.y;
  }
  const h = [];
  for (const _ of r)
    for (const m of _) {
      const L = hashVertex(m);
      h.push(a.get(L)[1]);
    }
  const S = new BufferGeometry();
  S.setAttribute("position", new Float32BufferAttribute(d, 3, !1)), S.setAttribute("uv", new Float32BufferAttribute(f, 2, !1)), S.setIndex(h), S.computeVertexNormals(), S.computeBoundingSphere();
  const R = calculateSkirtGeometry(d, f, e, s, o);
  return [S, R];
}
function calculateQuadrant(r, e, s, o, a) {
  const l = o.tileXYToRectangle(s.x, s.y, s.zoomLevel).intersection(a), u = l.midpoint, c = r - s.x * 2, E = e - s.y * 2;
  return c === 0 ? l.east = u.longitude : l.west = u.longitude, E === 0 ? l.south = u.latitude : l.north = u.latitude, l;
}
function calculateCentroid(r) {
  const e = new Vector3$1();
  return e.add(r[0]).add(r[1]).add(r[2]), e.divideScalar(3);
}
function calculateNormal(r) {
  const e = r[0], s = r[1], o = r[2], a = s.clone().sub(e), l = o.clone().sub(e);
  return a.cross(l);
}
function triangulate(r, e) {
  if (r.length === 3)
    return [r];
  if (r.length === 0)
    return [];
  const s = [];
  r.forEach((l) => {
    s.push(l.x), s.push(l.y), s.push(l.z);
  });
  const o = earcut$1(s, [], 3), a = [];
  for (let l = 0; l < o.length - 2; l += 3) {
    const u = [r[o[l]], r[o[l + 1]], r[o[l + 2]]], c = [r[o[l + 2]], r[o[l + 1]], r[o[l]]], E = calculateCentroid(u), d = e.ellipsoid.geodeticSurfaceNormalForPosition(E), f = calculateNormal(u);
    d.dot(f) >= 0 ? a.push(u) : a.push(c);
  }
  return a;
}
function isInEdge(r, e, s) {
  const o = (s.longitude - e.longitude) * (r.latitude - e.latitude), a = (s.latitude - e.latitude) * (r.longitude - e.longitude);
  return o - a <= 0;
}
function calculateIntersection(r, e, s, o) {
  const a = new Vector3$1(r.longitude, r.latitude, r.height), l = new Vector3$1(e.longitude, e.latitude, e.height), u = new Vector3$1(s.longitude, s.latitude, s.height), c = new Vector3$1(o.longitude, o.latitude, o.height), E = new Vector3$1(), d = c.clone().sub(u);
  if (d.x === 0)
    E.x = Math.sign(d.y);
  else if (d.y === 0)
    E.y = -Math.sign(d.x);
  else
    throw new Error("Invalid edge is not parallel to the latitudinal / longitudinal axes");
  const f = l.clone().sub(a), h = (E.dot(u) - E.dot(a)) / E.dot(f), S = new Vector3$1().lerpVectors(a, l, h);
  return new Cartographic$1(S.x, S.y, S.z);
}
function clipTriangle(r, e, s) {
  const o = [e.southwest, e.northwest, e.northeast, e.southeast];
  let a = r.map((u) => s.ellipsoid.cartographicForPosition(u));
  for (let u = 0; u < o.length; u++) {
    const c = o[u], E = o[(u + 1) % o.length], d = [];
    for (let f = 0; f < a.length; f++) {
      const h = a[f], S = a[(f + 1) % a.length];
      isInEdge(S, c, E) ? (isInEdge(h, c, E) || d.push(calculateIntersection(h, S, c, E)), d.push(S)) : isInEdge(h, c, E) && d.push(calculateIntersection(h, S, c, E));
    }
    a = d;
  }
  const l = a.map((u) => s.ellipsoid.cartesianForCartographic(u));
  return triangulate(l, s);
}
function splitTile(r, e, s, o, a, l) {
  const u = calculateQuadrant(e, s, o, a, l), c = geometryToMesh$1(r.geometry), E = [];
  for (const h of c) {
    const S = h.map((_) => _.clone().add(r.midpoint)), R = clipTriangle(S, u, a);
    for (const _ of R) {
      const m = _.map((L) => L.clone().sub(r.midpoint));
      E.push(m);
    }
  }
  const [d, f] = meshToGeometry(E, r.midpoint, u, a);
  return {
    geometry: d,
    skirtGeometry: f,
    midpoint: r.midpoint
  };
}
class GlobeMaterial extends ShaderMaterial {
  constructor(e) {
    var s;
    super({
      vertexShader: `
                varying vec2 vUv;

                #include <common>
                #include <logdepthbuf_pars_vertex>

                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

                    #include <logdepthbuf_vertex>
                }
            `,
      fragmentShader: `
                varying vec2 vUv;
                uniform sampler2D map;
                uniform vec3 color;

                layout(location = 1) out highp vec4 pc_pickingBuffer1;
                layout(location = 2) out highp vec4 pc_pickingBuffer2;
                layout(location = 3) out highp vec2 pc_fragCoordBuffer;
                layout(location = 4) out highp vec2 pc_fragCoordBufferEDL;             

                #include <common>
                #include <logdepthbuf_pars_fragment>

                void main() {
                    #include <logdepthbuf_fragment>                    

                    pc_fragColor = texture(map, vUv);
                    pc_fragColor.rgb *= color;
                    
                    // Globe has no picking ID
                    pc_pickingBuffer1 = vec4(0.0);
                    pc_pickingBuffer2 = vec4(0.0);
                    pc_fragCoordBuffer = gl_FragCoord.zw;

                    // Write infinitely far depth to EDL buffer
                    pc_fragCoordBufferEDL = vec2(1.0, 1.0);
                }
            `,
      uniforms: {
        map: { value: e.map },
        color: { value: (s = e.color) !== null && s !== void 0 ? s : new Color("white") },
        logDepthBufFC: { value: 0 }
      }
    });
  }
  get color() {
    return this.uniforms.color.value;
  }
}
var __awaiter$H = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
let Globe$1 = class extends PreparingObject {
  /**
   *
   * @param terrainProvider The object that will provide tile geometry for the globe
   * @param imageryProvider The specific imagery source this globe will use
   * @param tileCompositor The render pass that handles tile composition work
   * @param requestManager The request manager instance the globe will queue all its requests with
   * @param options
   */
  constructor(e, s, o, a, l) {
    var u, c;
    if (super(), this.evictionQueue = new EvictionQueue(), this.tileTree = [], this.region = Rectangle.MAX, this.matrixAutoUpdate = !1, this.tileCompositor = o, this.terrainProvider = e, this.imageryProvider = s, this.requestManager = a, this._tileBudget = (u = l == null ? void 0 : l.tileBudget) !== null && u !== void 0 ? u : 1024, this._tileSize = (c = l == null ? void 0 : l.tileTextureSize) !== null && c !== void 0 ? c : { x: 256, y: 256 }, this.geometryCache = new GeometryCache(this.terrainProvider.tilingScheme), this.imageCache = new ImageCache(this.imageryProvider.tilingScheme), this.tileCache = new TileCache(this.terrainProvider.tilingScheme), !this.terrainProvider.region.intersects(this.imageryProvider.region))
      throw new Error("The geometry and imagery provider's regions do not intersect");
    this.region = this.region.intersection(this.terrainProvider.region), this.region = this.region.intersection(this.imageryProvider.region), this.generateRootTiles();
  }
  get attributions() {
    return this.imageryProvider.attributions;
  }
  get ellipsoid() {
    return this.terrainProvider.tilingScheme.ellipsoid;
  }
  get tileSize() {
    return this._tileSize;
  }
  get tileBudget() {
    return this._tileBudget;
  }
  set tileBudget(e) {
    this._tileBudget = e;
  }
  /**
   * This function needs to be called once per-frame before rendering is performed. This handles converting the
   * quadtree of map tiles into a render list for ThreeJS to handle.
   */
  prepare(e, s, o) {
    o.options.debug.imageryLayerBoundingVolumes && typeof this.imageryProvider.debugDraw < "u" && this.imageryProvider.debugDraw();
    const a = e.getSize();
    this.clear(), this.evictionQueue.newFrame(), this.updateMatrix();
    const l = s.getCurrentCamera(), u = l.projectionMatrix.clone().multiply(l.matrixWorldInverse), c = new Frustum().setFromProjectionMatrix(u), E = s.getWorldPosition(new Vector3$1()), d = [...this.tileTree];
    for (; d.length > 0; ) {
      const f = d.pop(), h = f.zoomLevel < this.imageryProvider.minLevel, S = f.zoomLevel === this.imageryProvider.minLevel;
      if (h) {
        f.children.length === 0 && f.generateChildren(), d.push(...f.children);
        continue;
      }
      if (S && f.loaded === void 0) {
        this.trySpawnTileLoad(f);
        continue;
      }
      if (f.loaded === void 0)
        throw new Error("'node.mesh' is not present, but should be. This is an internal bug");
      f.evictionNode !== void 0 && f.lastTouchedFrame < o.frameIndex && (this.evictionQueue.touch(f.evictionNode), f.lastTouchedFrame = o.frameIndex);
      const R = f.boundingSphere.clone();
      this.localToWorld(R.center);
      const _ = f.loaded.boundingSphere.clone();
      if (this.localToWorld(_.center), o.options.debug.globeTileFrustumCulling && !c.intersectsSphere(_))
        continue;
      const m = this.terrainProvider.canRefine(f.x, f.y, f.zoomLevel), L = this.checkSphereQualityMetPerspective(_, E, s.perspective.fov, a.y);
      if (!m || L || !this.handleChildren(f, d, o)) {
        if (o.options.debug.imageryTileBoundingVolumes && DebugDraw.addSphere(R.center, R.radius), o.options.debug.geometryTileBoundingVolumes) {
          const F = [
            f.loaded.material.color.r * 255,
            f.loaded.material.color.g * 255,
            f.loaded.material.color.b * 255
          ];
          DebugDraw.addSphere(_.center, _.radius, F);
        }
        this.add(f.loaded.object);
      }
    }
    this.evictionQueue.evictNodes(() => this.evictionQueue.length > this.tileBudget, (f) => {
      this.evict(f.x, f.y, f.zoomLevel), delete f.loaded, delete f.evictionNode;
    });
  }
  /**
   * Calculate the true terrain height at a given point
   *
   * @param position
   * @returns
   */
  getTerrainHeight(e) {
    const s = new Cartographic$1(), o = this.ellipsoid.geodeticSurfaceNormalForCartographic(e), a = this.ellipsoid.cartesianForCartographic(e).addScaledVector(o, 2e4);
    let l;
    for (const E of this.tileTree)
      if (E.region.contains(e)) {
        l = E;
        break;
      }
    if (l === void 0)
      return 0;
    for (; l.children.length > 0; ) {
      let E = !1;
      for (const d of l.children)
        if (d.region.contains(e)) {
          l = d, E = !0;
          break;
        }
      if (!E)
        break;
    }
    for (; l.loaded === void 0 && l.parent !== void 0; )
      l = l.parent;
    if (l.loaded === void 0)
      return 0;
    const u = new Raycaster(a, o.negate(), 0);
    u.firstHitOnly = !0;
    const c = u.intersectObject(l.loaded.object, !0);
    return c.length > 0 ? (this.ellipsoid.cartographicForPosition(c[0].point, s), s.height) : 0;
  }
  /**
   * Process the children of a node, spawning the request for a tile. Once all four children are
   * resident (tiles are loaded), we can push them onto the stack to be further refined.
   *
   * @param node Current node being processed
   * @param nodeStack Stack to push child nodes onto
   * @param frameData Frame data context
   * @returns True if the children have been pushed
   */
  handleChildren(e, s, o) {
    const a = e.zoomLevel + 1 >= this.imageryProvider.minLevel;
    e.children.length === 0 && e.generateChildren();
    let l = 0;
    return e.children.forEach((u) => {
      e.evictionNode !== void 0 && e.lastTouchedFrame < o.frameIndex && (this.evictionQueue.touch(e.evictionNode), e.lastTouchedFrame = o.frameIndex), u.loaded !== void 0 || !a ? l += 1 : this.trySpawnTileLoad(u);
    }), l === 4 ? (s.push(...e.children), !0) : !1;
  }
  /**
   * Test if the bounding sphere of a tile satisfies the pixel requirement for it be further refined. If the projected
   * diameter of the sphere is less than 2.25 times the size of an individual tile, then we can increase the level
   * of detail.
   *
   * This function determines to how close the camera has to be to the globe before it subdivides.
   *
   * @param sphere Relevant bounding sphere
   * @param cameraPos Camera position
   * @param fov Camera FOV
   * @param screenHeight Height of the render display target
   */
  checkSphereQualityMetPerspective(e, s, o, a) {
    const l = Math.max(this.tileSize.x, this.tileSize.y), u = s.clone().sub(e.center).length();
    return 2 * MathUtils.computeProjectedRadiusPerspective(o, u, e.radius, a / 2) <= 2.25 * l;
  }
  checkSphereQualityMetOrthographic(e, s, o) {
    const a = Math.max(this.tileSize.x, this.tileSize.y);
    return 2 * MathUtils.projectGeometricErrorOrthographic(e.radius, o.x, o.y, s.getFrustumTop(), s.getFrustumBottom(), s.getFrustumRight(), s.getFrustumLeft()) <= 2.25 * a;
  }
  /**
   * Internal function that handles queueing a network request for a tile if the data is missing. It will *not* queue
   * a request if it finds one is already in flight.
   *
   * @param node
   * @private
   */
  trySpawnTileLoad(e) {
    const s = e.loaded === void 0, o = e.request === void 0, a = e.request !== void 0 && e.request.status === "cancelled", l = e.request !== void 0 && e.request.status === "complete";
    if (s && (o || a || l)) {
      const u = () => __awaiter$H(this, void 0, void 0, function* () {
        const c = yield this.loadTile(e.x, e.y, e.zoomLevel, e.parent);
        c !== void 0 && (e.loaded = c, e.evictionNode = this.evictionQueue.add(e));
      });
      e.request = this.requestManager.queueRequest("globe", u);
    }
  }
  /**
   * Returns a ThreeJS 'Mesh' object for the requested tile.
   *
   * This will return 'undefined' if the tile was deemed superfluous. Some imagery sources may return textures below
   * the requested zoomLevel. If all textures are below 'zoomLevel' then the tile has no reason to exist as the parent
   * tile would provide identical quality while using less VRAM.
   *
   * There are multiple levels of caching used here:
   *      - Geometry and imagery tiles are cached individually
   *      - Final composited globe tiles are cached
   *
   * @param x The x coordinate of the tile to generate
   * @param y The y coordinate of the tile to generate
   * @param zoomLevel The zoom level we're generating a tile at
   * @param parent Parent tree node to subdivide if no geometry is available at the current zoom level
   * @private
   */
  loadTile(e, s, o, a) {
    return __awaiter$H(this, void 0, void 0, function* () {
      let l = this.tileCache.acquire(e, s, o);
      if (l !== void 0)
        return l;
      const u = yield this.getOrLoadTerrainTile(e, s, o, a);
      if (u.length === 0)
        return;
      let c;
      if (this.terrainProvider.tilingScheme.constructor === this.imageryProvider.tilingScheme.constructor)
        c = yield this.getOrLoadImageryTile(e, s, o);
      else {
        const d = this.terrainProvider.tilingScheme.tileXYToRectangle(e, s, o).intersection(this.region), f = new TileRegionIterator(this.imageryProvider.tilingScheme, d, o);
        c = [];
        for (const h of f) {
          const S = yield this.getOrLoadImageryTile(h.x, h.y, o);
          c.push(...S);
        }
      }
      if (c.filter((d) => d.zoomLevel < o).length !== c.length)
        return l = this.createTileFromGeometryAndTextures(e, s, o, u, c), this.tileCache.addItem(e, s, o, l);
    });
  }
  /**
   * Internal function used for getting tile imagery. Transparently handles a cache lookup + fetch if the data is
   * uncached.
   *
   * If no geometry can be found for the current zoom level, the tile's parent is subdivded and the appropriate
   * quadrant is used.
   *
   * @param x
   * @param y
   * @param zoomLevel
   * @param parent
   * @private
   */
  getOrLoadTerrainTile(e, s, o, a) {
    var l;
    return __awaiter$H(this, void 0, void 0, function* () {
      let u = this.geometryCache.acquire(e, s, o);
      if (u === void 0) {
        if (u = yield this.terrainProvider.loadTile(e, s, o), u.length === 0 && a !== void 0) {
          const c = (l = this.geometryCache.acquire(a.x, a.y, a.zoomLevel)) !== null && l !== void 0 ? l : [];
          for (const E of c) {
            const d = splitTile(E, e, s, a, this.terrainProvider.tilingScheme, this.region);
            u.push(d);
          }
        }
        u = this.geometryCache.addItem(e, s, o, u);
      }
      return u;
    });
  }
  /**
   * Internal function used for getting tile imagery. Transparently handles a cache lookup + fetch if the data is
   * uncached.
   *
   * @param x
   * @param y
   * @param zoomLevel
   * @private
   */
  getOrLoadImageryTile(e, s, o) {
    return __awaiter$H(this, void 0, void 0, function* () {
      let a = this.imageCache.acquire(e, s, o);
      return a === void 0 && (a = yield this.imageryProvider.loadTile(e, s, o), a = this.imageCache.addItem(e, s, o, a)), a;
    });
  }
  /**
   * This function will evict the cached data for the given tile. If there is no cache entry for the tile then the
   * function will just do nothing.
   *
   * @param zoomLevel The zoom level we're looking up a tile to evict
   * @param x The x coordinate of the tile to evict
   * @param y The y coordinate of the tile to evict
   */
  evict(e, s, o) {
    this.tileCache.release(e, s, o), this.geometryCache.release(e, s, o), this.imageCache.release(e, s, o);
  }
  /**
   * An internal function that handles taking a ThreeJS texture and emiting a Mesh instance into the tile cache that
   * corresponds to that tile.
   *
   * @param geometry The geometry to apply
   * @param textures The textures to apply
   * @param zoomLevel Zoom level of the tile
   * @param x Tile x coordinate
   * @param y Tile y coordinate
   * @private
   */
  createTileFromGeometryAndTextures(e, s, o, a, l) {
    let u;
    const c = this.imageryProvider.tilingScheme.constructor === this.terrainProvider.tilingScheme.constructor;
    if (l.length === 1 && l[0].zoomLevel === o && c)
      u = l[0].texture, u.wrapS = ClampToEdgeWrapping, u.wrapT = ClampToEdgeWrapping, u.anisotropy = 4, u.minFilter = LinearMipMapLinearFilter, u.magFilter = LinearFilter, u.generateMipmaps = !0;
    else {
      const S = new WebGLRenderTarget(this.tileSize.x, this.tileSize.y, {
        wrapS: ClampToEdgeWrapping,
        wrapT: ClampToEdgeWrapping,
        anisotropy: 4,
        minFilter: LinearMipMapLinearFilter,
        magFilter: LinearFilter,
        generateMipmaps: !0,
        format: RGBAFormat
      });
      for (const R of l)
        this.emitCompositorJob(e, s, o, S, R);
      u = S.texture;
    }
    const E = {
      map: u
    };
    OptionsManager.DEBUG_COLOR_IMAGERY_TILES_BY_ZOOM_LEVEL ? E.color = depthColour(o) : OptionsManager.DEBUG_COLOR_IMAGERY_TILES_RANDOMLY && (E.color = new Color().setHSL(Math.random(), 1, 0.5));
    const d = new GlobeMaterial(E), f = new Group(), h = new Sphere$1();
    return a.forEach((S) => {
      const R = new Mesh(S.geometry, d);
      R.onBeforeRender = (L, F, W, G, q, fe) => {
        W instanceof PerspectiveCamera$1 && (d.uniforms.logDepthBufFC.value = 2 / (Math.log(W.far + 1) / Math.LN2), d.uniformsNeedUpdate = !0, d.needsUpdate = !0);
      }, R.position.copy(S.midpoint), R.frustumCulled = !1;
      const _ = new Mesh(S.skirtGeometry, d);
      _.onBeforeRender = (L, F, W, G, q, fe) => {
        W instanceof PerspectiveCamera$1 && (d.uniforms.logDepthBufFC.value = 2 / (Math.log(W.far + 1) / Math.LN2), d.uniformsNeedUpdate = !0, d.needsUpdate = !0);
      }, _.position.copy(S.midpoint), R.frustumCulled = !1, f.add(R), f.add(_);
      const m = new Sphere$1();
      m.copy(R.geometry.boundingSphere).center.add(R.position), h.isEmpty() ? h.copy(m) : h.union(m);
    }), {
      object: f,
      material: d,
      boundingSphere: h
    };
  }
  /**
   * Emits a composition job to place src into dst.
   *
   * @param x Tile X coordinate we're compositing for
   * @param y Tile Y coordinate we're compositing for
   * @param zoomLevel Tile zoom level we're compositing for
   * @param dst The texture we're compositing into
   * @param src The texture we're compositing onto 'dst'
   * @private
   */
  emitCompositorJob(e, s, o, a, l) {
    l.texture.wrapS = ClampToEdgeWrapping, l.texture.wrapT = ClampToEdgeWrapping;
    const u = this.terrainProvider.tilingScheme.tileXYToRectangle(e, s, o), c = u.width, E = u.height, d = this.imageryProvider.tilingScheme.tileXYToRectangle(l.x, l.y, l.zoomLevel), f = d.width, h = d.height, S = {
      x: d.west - u.west,
      y: d.south - u.south
    }, R = {
      x: f / c,
      y: h / E
    }, _ = {
      x: S.x / c,
      y: S.y / E
    }, m = this.imageryProvider.tilingScheme instanceof WebMercatorTilingScheme && !(this.terrainProvider.tilingScheme instanceof WebMercatorTilingScheme);
    this.tileCompositor.pushJobs({
      disposeSrc: !0,
      src: l.texture,
      dst: a,
      scale: R,
      offset: _,
      rectangle: u,
      reprojectWebMercator: m
    });
  }
  /**
   * Internal function used in the constructor for initializing the 'rootTiles' array.
   *
   * @private
   */
  generateRootTiles() {
    const e = this.terrainProvider.tilingScheme.getNumberOfXTilesAtLevel(0), s = this.terrainProvider.tilingScheme.getNumberOfYTilesAtLevel(0);
    for (let o = 0; o < s; o += 1)
      for (let a = 0; a < e; a += 1) {
        const l = new QuadTreeNode(a, o, 0, this.terrainProvider.tilingScheme, this.ellipsoid);
        this.tileTree.push(l);
      }
  }
};
function depthColour(r) {
  switch (r % 6) {
    case 0:
      return new Color(1, 0, 0);
    case 1:
      return new Color(0, 1, 0);
    case 2:
      return new Color(0, 0, 1);
    case 3:
      return new Color(1, 0, 1);
    case 4:
      return new Color(0, 1, 1);
    case 5:
      return new Color(1, 1, 0);
    default:
      return new Color(1, 1, 1);
  }
}
class BaseImageryProvider {
  hasDataForTile(e, s, o) {
    let a, l, u, c;
    {
      const S = this.tilingScheme.positionToTileXY(this.region.southwest, o), R = this.tilingScheme.positionToTileXY(this.region.northeast, o);
      a = Math.min(S.x, R.x), u = Math.min(S.y, R.y), l = Math.max(S.x, R.x), c = Math.max(S.y, R.y);
    }
    const E = e < a || e > l || s < u || s > c, d = this.tilingScheme.tileXYToRectangle(e, s, o), f = this.region.intersects(d), h = o >= this.minLevel && o <= this.maxLevel;
    return !E && f && h;
  }
  canRefine(e, s, o) {
    return this.hasDataForTile(e, s, o) && o !== this.maxLevel;
  }
}
var __awaiter$G = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class HTTPImageryProvider extends BaseImageryProvider {
  /**
   * Constructs a new HTTPTileProvider with the provided parameters.
   * @param tilingScheme
   * @param options
   */
  constructor(e, s) {
    var o, a, l, u;
    if (super(), this._tilingScheme = e, this._minLevel = s.minLevel, this._maxLevel = s.maxLevel, this._origin = (a = (o = s.origin) === null || o === void 0 ? void 0 : o.clone()) !== null && a !== void 0 ? a : new Cartographic$1(), this._boundingBox = (u = (l = s.boundingBox) === null || l === void 0 ? void 0 : l.clone()) !== null && u !== void 0 ? u : Rectangle.MAX, this._tilingScheme.rectangle.intersects(this._boundingBox))
      this._boundingBox = this._tilingScheme.rectangle.intersection(this._boundingBox);
    else
      throw new Error("The requested 'region' does not intersect with 'tilingScheme.rectangle'");
  }
  get attributions() {
    return [];
  }
  get minLevel() {
    return this._minLevel;
  }
  get maxLevel() {
    return this._maxLevel;
  }
  get tilingScheme() {
    return this._tilingScheme;
  }
  get origin() {
    return this._origin;
  }
  get region() {
    return this._boundingBox;
  }
  loadTile(e, s, o) {
    return __awaiter$G(this, void 0, void 0, function* () {
      if (this.hasDataForTile(e, s, o)) {
        let a;
        try {
          a = yield TextureLoader.load(yield this.resolveTilePath(e, s, o), this.resolveRequestOptions()), a.colorSpace = SRGBColorSpace;
        } catch {
          const u = new Uint8Array(1);
          a = new DataTexture(u, 1, 1), a.colorSpace = SRGBColorSpace, a.needsUpdate = !0;
        }
        return [
          {
            texture: a,
            zoomLevel: o,
            x: e,
            y: s
          }
        ];
      } else
        throw new Error("Requested a tile that does not exist in the dataset bounds");
    });
  }
  debugDraw(e) {
    DebugDraw.addGeographicBounds(this._tilingScheme.ellipsoid, this._boundingBox.west, this._boundingBox.south, this._boundingBox.east, this._boundingBox.north, 0, 10, e);
  }
}
var __awaiter$F = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class LayeredImageryProvider extends BaseImageryProvider {
  constructor(e) {
    super(), this._tilingScheme = new WebMercatorTilingScheme(), this.layers = [...e], this.layers.forEach((a) => {
      if (!(a.tilingScheme instanceof WebMercatorTilingScheme))
        throw new Error("Currently we only support 'WebMercatorTilingScheme' for imagery");
    }), this._minLevel = Math.min(...this.layers.map((a) => a.minLevel)), this._maxLevel = Math.max(...this.layers.map((a) => a.maxLevel));
    const o = this.layers.map((a) => a.region).reduce((a, l, u) => a.union(l, a), new Rectangle()).intersection(this._tilingScheme.rectangle);
    if (!o.isLegal())
      throw new Error("Layered region is not legal, invalid layer rectangles received");
    this._origin = o.midpoint, this._region = o;
  }
  get attributions() {
    return this.layers.flatMap((e) => e.attributions);
  }
  get minLevel() {
    return this._minLevel;
  }
  get maxLevel() {
    return this._maxLevel;
  }
  get tilingScheme() {
    return this._tilingScheme;
  }
  get origin() {
    return this._origin;
  }
  get region() {
    return this._region;
  }
  splitImagery(e, s, o, a) {
    const l = a - e.zoomLevel, u = Math.pow(2, l), c = 1 / u, E = e.texture.image, d = document.createElement("canvas");
    d.width = E.width, d.height = E.height;
    const f = d.getContext("2d");
    if (!f)
      throw new Error("Unable to create HTML canvas.");
    const h = s - u * e.x, S = o - u * e.y;
    f.drawImage(E, E.width * c * h, E.height * c * S, E.width * c, E.height * c, 0, 0, d.width, d.height);
    const R = new Texture();
    return R.colorSpace = SRGBColorSpace, R.image = d, R.needsUpdate = !0, {
      texture: R,
      x: s,
      y: o,
      zoomLevel: a
    };
  }
  loadTile(e, s, o) {
    return __awaiter$F(this, void 0, void 0, function* () {
      const a = [];
      for (const c of this.layers) {
        let E = o, d = e, f = s;
        const h = c.maxLevel;
        if (o > h) {
          E = h;
          const S = o - h, R = Math.pow(2, S);
          d = Math.trunc(e / R), f = Math.trunc(s / R);
        }
        c.hasDataForTile(d, f, E) && a.push(c.loadTile(d, f, E));
      }
      const l = yield Promise.allSettled(a), u = [];
      for (const c of l)
        if (c.status === "fulfilled")
          for (const E of c.value)
            E.zoomLevel !== o ? u.push(this.splitImagery(E, e, s, o)) : u.push(E);
        else
          throw c.reason;
      return u;
    });
  }
  hasDataForTile(e, s, o) {
    for (const a of this.layers)
      if (a.hasDataForTile(e, s, o))
        return !0;
    return !1;
  }
  canRefine(e, s, o) {
    for (const a of this.layers)
      if (a.canRefine(e, s, o))
        return !0;
    return !1;
  }
  debugDraw(e) {
    for (const s of this.layers)
      typeof s.debugDraw < "u" && s.debugDraw(e);
  }
}
class CesiumIonAsset {
  constructor(e, s, o) {
    this.url = e, this.token = s, this.tokenHeaderValue = `Bearer ${s}`, typeof o > "u" ? this._attributions = [] : this._attributions = o;
  }
  /**
   * Returns a list of attributions required by this asset. Library users will need to query this and display the
   * attributions to meet the license requirements of both Cesium Ion and the data we're displaying.
   */
  get attributions() {
    return [...this._attributions];
  }
}
function readFeatureTableObject$2(r) {
  if (r.text.length === 0)
    return {
      batchLength: 0
    };
  const e = JSON.parse(r.text), s = {}, o = readSingleNum$1(r.data, 2, e.BATCH_LENGTH);
  typeof o < "u" && (s.batchLength = o);
  const a = readMultiNum$1(r.data, 3, 8, e.RTC_CENTER);
  return typeof a < "u" && (s.rtcCenter = [a[0], a[1], a[2]]), {
    batchLength: s.batchLength,
    rtcCenter: s.rtcCenter
  };
}
var __awaiter$E = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
function readBatchModel(r, e, s = {}) {
  return __awaiter$E(this, void 0, void 0, function* () {
    if (typeof r == "string")
      return yield GltfLoader.parseGlb(r, e, s);
    {
      const o = r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength);
      return yield GltfLoader.parseGlb(o, e, s);
    }
  });
}
var ObjectType;
(function(r) {
  r[r.Composite = 0] = "Composite", r[r.Primitive = 1] = "Primitive";
})(ObjectType || (ObjectType = {}));
class PickingManager {
  constructor() {
    this.nextId = 1, this.objectData = /* @__PURE__ */ new Map(), this.threeIdToOurIdMap = /* @__PURE__ */ new Map();
  }
  /**
   * Allocate a new ID and return it. This ID is guaranteed to be unique and will never be yielded a second time from
   * the same PickingManager instance.
   */
  newId() {
    const e = this.nextId;
    return this.nextId += 1, e;
  }
  /**
   * Set data for the given object ID.
   * @param id
   * @param data
   */
  setForId(e, s) {
    this.objectData.set(e, s);
  }
  /**
   * Returns the object the ID maps to. Will throw if the ID has been removed.
   * @param id
   */
  getForId(e) {
    return this.objectData.get(e);
  }
  /**
   * Remove the data for the given object ID from the manager.
   * @param id
   */
  removeForId(e) {
    return this.objectData.delete(e);
  }
  setIdForObject(e, s) {
    this.threeIdToOurIdMap.set(e, s);
  }
  getIdForThreeId(e) {
    return this.threeIdToOurIdMap.get(e);
  }
  removeForObject(e) {
    return this.threeIdToOurIdMap.delete(e);
  }
}
var __awaiter$D = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Batch3DModel extends Object3D {
  constructor(e, s, o, a, l) {
    super(), this.materialRegistry = s, this.pickingManager = o, this.objectId = a, this._featureTable = e, this._batchTable = l, this.styleCallbackFn = (u) => this.styleCallback(u), this.clippingPlaneCallbackFn = (u) => this.clippingPlaneCallback(u), this.invalidateCallbackFn = () => this.invalidateCallback(), s.styleCallbacks.add(this.styleCallbackFn), s.clippingPlaneCallbacks.add(this.clippingPlaneCallbackFn), s.invalidateCallbacks.add(this.invalidateCallbackFn);
  }
  static create(e, s, o, a, l, u) {
    return __awaiter$D(this, void 0, void 0, function* () {
      const c = s, E = l.newId();
      assert(Batch3DModel.isValidHeader(c));
      const d = c.getUint32(4, !0);
      assert(d === 1);
      const f = readFeatureTable(c);
      readBatchTable(c);
      const h = readGltfSection$1(c), S = readFeatureTableObject$2(f), R = {};
      let _;
      if (e.content.uri !== void 0 && e.content.uri !== null)
        _ = e.content.uri;
      else if (e.content.url !== void 0 && e.content.url !== null)
        _ = e.content.url;
      else
        throw new Error("Missing uri or url in content");
      const m = yield readBatchModel(h, `${_}/../`, {
        objectId: E || 0,
        clippingPlanes: a.clippingPlanes
      }), L = new Batch3DModel(S, a, l, E, R);
      return L.add(m.scene), L.styleCallback(o), L.traverse((F) => {
        var W;
        if (F instanceof Mesh) {
          const G = F.material;
          G.clippingPlanes = (W = a.clippingPlanes) !== null && W !== void 0 ? W : [], G.needsUpdate = !0;
        }
      }), Batch3DModel.resolveTransforms(L, m, S, e), l.setForId(L.objectId, {
        objectType: ObjectType.Composite,
        rootObject: u,
        subObject: L
      }), l.setIdForObject(L.id, L.objectId), L;
    });
  }
  static isValidHeader(e) {
    return !(e.getUint8(0) !== 98 || e.getUint8(1) !== 51 || e.getUint8(2) !== 100 || e.getUint8(3) !== 109);
  }
  static resolveTransforms(e, s, o, a) {
    var l;
    const u = new Matrix4();
    switch ((l = a.extras.owner.asset.gltfUpAxis) !== null && l !== void 0 ? l : "Y") {
      case "X":
        break;
      case "Y":
        u.makeRotationAxis(MathUtils.X_AXIS, Math.PI / 2);
        break;
    }
    const c = new Matrix4();
    if (typeof o.rtcCenter < "u")
      c.makeTranslation(o.rtcCenter[0], o.rtcCenter[1], o.rtcCenter[2]);
    else if (s.json !== void 0 && typeof s.json == "object" && s.json.extensionsUsed !== void 0 && s.json.extensionsUsed.indexOf("CESIUM_RTC") !== -1) {
      const S = s.json.extensions.CESIUM_RTC.center;
      c.makeTranslation(S[0], S[1], S[2]);
    }
    a.extras.transform.clone().multiply(c.multiply(u)).decompose(e.position, e.quaternion, e.scale);
  }
  evict() {
    this.materialRegistry.styleCallbacks.delete(this.styleCallbackFn), this.materialRegistry.clippingPlaneCallbacks.delete(this.clippingPlaneCallbackFn), this.materialRegistry.invalidateCallbacks.delete(this.invalidateCallbackFn), this.objectId !== 0 && this.pickingManager !== void 0 && (this.pickingManager.removeForId(this.objectId), this.pickingManager.removeForObject(this.id)), Batch3DModel.evictGltf(this);
  }
  get geometrySizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      o.geometry instanceof BufferGeometry && e.add(o.geometry);
    });
    let s = 0;
    for (const o of e)
      s += estimateBytesUsed(o);
    return s;
  }
  get textureSizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      const a = o.material;
      if (a) {
        const l = Array.isArray(a) ? a : [a];
        for (const u of l)
          for (const c of Object.values(u))
            c instanceof Texture && e.add(c);
      }
    });
    let s = 0;
    for (const o of e) {
      const a = o.format === RGBAFormat ? 4 : 3, l = o.image.width * o.image.height;
      s += a * l;
    }
    return s;
  }
  get pointCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Points && (s.geometry.index ? e += s.geometry.index.count : e += s.geometry.getAttribute("position").count);
    }), e;
  }
  get triangleCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Mesh && (s.geometry.index ? e += s.geometry.index.count / 3 : e += s.geometry.getAttribute("position").count / 3);
    }), e;
  }
  static evictGltf(e) {
    e.traverse((s) => {
      if (s instanceof Mesh)
        if (s.geometry.dispose(), Array.isArray(s.material))
          for (const o of s.material)
            evictMaterial(o);
        else
          evictMaterial(s.material);
    });
  }
  styleCallback(e) {
    this.traverse((s) => {
      var o;
      if (s instanceof Mesh) {
        const a = s.material;
        a.needsUpdate = !0, a.opacity = (o = e.opacity) !== null && o !== void 0 ? o : 1, a.side = ourCullingToThreeCulling(e.faceCulling), a.opacity < 1 ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, a.depthWrite = !0);
      }
    });
  }
  clippingPlaneCallback(e) {
    this.traverse((s) => {
      if (s instanceof Mesh) {
        const o = s.material;
        o.clippingPlanes = e, o.needsUpdate = !0;
      }
    });
  }
  invalidateCallback() {
    this.traverse((e) => {
      if (e instanceof Mesh) {
        const s = e.material;
        s.needsUpdate = !0;
      }
    });
  }
}
function readGltfSection$1(r) {
  const e = r.getUint32(12, !0), s = r.getUint32(16, !0), o = r.getUint32(20, !0), a = r.getUint32(24, !0), l = 28 + e + s + o + a;
  return new DataView(r.buffer, r.byteOffset + l, r.byteLength - l);
}
var __awaiter$C = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Composite extends Object3D {
  constructor() {
    super(...arguments), this.pointClouds = [], this.batchModels = [], this.instancedModels = [], this.composites = [];
  }
  static create(e, s, o, a, l, u) {
    return __awaiter$C(this, void 0, void 0, function* () {
      const c = s;
      assert(Composite.isValidHeader(c));
      const E = c.getUint32(4, !0);
      assert(E === 1);
      const d = c.getUint32(12, !0), f = new Composite();
      let h = new DataView(c.buffer, c.byteOffset + 16);
      for (let S = 0; S < d; S += 1) {
        let R, _;
        if (PointCloud.isValidHeader(h)) {
          R = h.getUint32(8, !0);
          const m = yield PointCloud.create(e, new DataView(h.buffer, h.byteOffset, R), o, a, l, u);
          f.pointClouds.push(m), _ = m;
        } else if (Batch3DModel.isValidHeader(h)) {
          R = h.getUint32(8, !0);
          const m = yield Batch3DModel.create(e, new DataView(h.buffer, h.byteOffset, R), o, a, l, u);
          f.batchModels.push(m), _ = m;
        } else if (Instanced3DModel.isValidHeader(h)) {
          R = h.getUint32(8, !0);
          const m = yield Instanced3DModel.create(e, new DataView(h.buffer, h.byteOffset, R), o, a, l, u);
          f.instancedModels.push(m), _ = m;
        } else if (Composite.isValidHeader(h)) {
          R = h.getUint32(8, !0);
          const m = yield Composite.create(e, new DataView(h.buffer, h.byteOffset, R), o, a, l, u);
          f.composites.push(m), _ = m;
        } else
          throw new Error("Unknown tile format");
        f.add(_), h = new DataView(h.buffer, h.byteOffset + R);
      }
      return f;
    });
  }
  static isValidHeader(e) {
    return !(e.getUint8(0) !== 99 || e.getUint8(1) !== 109 || e.getUint8(2) !== 112 || e.getUint8(3) !== 116);
  }
  evict() {
    for (const e of this.pointClouds)
      e.evict();
    for (const e of this.batchModels)
      e.evict();
    for (const e of this.instancedModels)
      e.evict();
    for (const e of this.composites)
      e.evict();
  }
  get geometrySizeInBytes() {
    let e = 0;
    for (const s of this.pointClouds)
      e += s.geometrySizeInBytes;
    for (const s of this.batchModels)
      e += s.geometrySizeInBytes;
    for (const s of this.instancedModels)
      e += s.geometrySizeInBytes;
    for (const s of this.composites)
      e += s.geometrySizeInBytes;
    return e;
  }
  get textureSizeInBytes() {
    let e = 0;
    for (const s of this.pointClouds)
      e += s.textureSizeInBytes;
    for (const s of this.batchModels)
      e += s.textureSizeInBytes;
    for (const s of this.instancedModels)
      e += s.textureSizeInBytes;
    for (const s of this.composites)
      e += s.textureSizeInBytes;
    return e;
  }
  get pointCount() {
    let e = 0;
    for (const s of this.pointClouds)
      e += s.pointCount;
    for (const s of this.batchModels)
      e += s.pointCount;
    for (const s of this.instancedModels)
      e += s.pointCount;
    for (const s of this.composites)
      e += s.pointCount;
    return e;
  }
  get triangleCount() {
    let e = 0;
    for (const s of this.pointClouds)
      e += s.triangleCount;
    for (const s of this.batchModels)
      e += s.triangleCount;
    for (const s of this.instancedModels)
      e += s.triangleCount;
    for (const s of this.composites)
      e += s.triangleCount;
    return e;
  }
}
function readFeatureTableObject$1(r) {
  const e = JSON.parse(r.text), s = readSingleNum$1(r.data, 2, e.INSTANCES_LENGTH);
  if (typeof s > "u")
    throw new Error("Missing INSTANCES_LENGTH semantic in i3dm");
  let o = readMultiNum$1(r.data, 3, 8, e.RTC_CENTER);
  typeof o < "u" && (o = [o[0], o[1], o[2]]);
  const a = e.EAST_NORTH_UP || !1, l = readMultiNum$1(r.data, s * 3, 8, e.POSITION);
  if (l === void 0)
    throw new Error("Missing POSITION semantic in i3dm");
  const u = readMultiNum$1(r.data, s * 3, 8, e.NORMAL_UP), c = readMultiNum$1(r.data, s * 3, 8, e.NORMAL_RIGHT);
  let E;
  if (u !== void 0 && c !== void 0)
    E = {
      normalUp: u,
      normalRight: c
    };
  else if (u !== void 0 || c !== void 0)
    throw new Error("Both NORMAL_UP or NORMAL_RIGHT is present alone in i3dm");
  const d = readMultiNum$1(r.data, s, 8, e.NORMAL_UP), f = readMultiNum$1(r.data, s * 3, 8, e.NORMAL_UP);
  return {
    instancesLength: s,
    rtcCenter: o,
    eastNorthUp: a,
    positions: l,
    rotation: E,
    scale: d,
    scaleNonUniform: f
  };
}
var __awaiter$B = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Instanced3DModel extends Object3D {
  constructor(e, s, o, a, l) {
    super(), this._featureTable = e, this._batchTable = l, this.materialRegistry = s, this.pickingManager = o, this.objectId = a, this.styleCallbackFn = (u) => this.styleCallback(u), this.clippingPlaneCallbackFn = (u) => this.clippingPlaneCallback(u), this.invalidateCallbackFn = () => this.invalidateCallback(), s.styleCallbacks.add(this.styleCallbackFn), s.clippingPlaneCallbacks.add(this.clippingPlaneCallbackFn), s.invalidateCallbacks.add(this.invalidateCallbackFn);
  }
  static create(e, s, o, a, l, u) {
    var c;
    return __awaiter$B(this, void 0, void 0, function* () {
      const E = s, d = l.newId();
      assert(Instanced3DModel.isValidHeader(E));
      const f = E.getUint32(4, !0);
      assert(f === 1);
      const h = E.getUint32(28, !0) === 0, { featureTableData: S, batchTableData: R, gltfSection: _ } = this.loadFileSections(E), m = readFeatureTableObject$1(S), L = {}, F = e, { baseUri: W, gltfBuffer: G } = yield this.loadGltfBuffer(h, _, F), q = yield readBatchModel(G, `${W}/../`, {
        objectId: d || 0,
        clippingPlanes: a.clippingPlanes
      }), fe = new Instanced3DModel(m, a, l, d, L), _e = (c = e.extras.owner.asset.gltfUpAxis) !== null && c !== void 0 ? c : "Y";
      for (let Le = 0; Le < m.instancesLength; Le += 1) {
        const Fe = q.scene.clone(!0);
        if (Fe.position.x = m.positions[Le * 3], Fe.position.y = m.positions[Le * 3 + 1], Fe.position.z = m.positions[Le * 3 + 2], m.rotation !== void 0) {
          const Ee = m.rotation.normalUp[Le * 3], Ge = m.rotation.normalUp[Le * 3 + 1], ve = m.rotation.normalUp[Le * 3 + 2], te = new Vector3$1(Ee, Ge, ve), ae = m.rotation.normalRight[Le * 3], v = m.rotation.normalRight[Le * 3 + 1], Te = m.rotation.normalRight[Le * 3 + 2], De = new Vector3$1(ae, v, Te), be = te.clone().cross(De), ze = new Matrix3$1();
          ze.elements[0] = De.x, ze.elements[1] = De.y, ze.elements[2] = De.z, ze.elements[3] = te.x, ze.elements[4] = te.y, ze.elements[5] = te.z, ze.elements[6] = be.x, ze.elements[7] = be.y, ze.elements[8] = be.z;
          const ke = new Matrix4().setFromMatrix3(ze);
          switch (Fe.quaternion.setFromRotationMatrix(ke), _e) {
            case "X":
              break;
            case "Y":
              const Be = new Quaternion$1().setFromAxisAngle(MathUtils.X_AXIS, Math.PI / 2);
              Fe.quaternion.multiply(Be);
              break;
          }
        } else if (m.eastNorthUp) {
          const Ee = Ellipsoid$1.WGS_84.cartographicForPosition(Fe.position), Ge = Ellipsoid$1.WGS_84.rotationBasisForCartographic(Ee, new Matrix3$1()), ve = new Matrix4().setFromMatrix3(Ge);
          Fe.quaternion.setFromRotationMatrix(ve);
        } else
          switch (_e) {
            case "X":
              break;
            case "Y":
              const Ee = new Quaternion$1().setFromAxisAngle(MathUtils.X_AXIS, Math.PI / 2);
              Fe.quaternion.multiply(Ee);
              break;
          }
        m.scale !== void 0 && Fe.scale.multiplyScalar(m.scale[Le]), m.scaleNonUniform !== void 0 && (Fe.scale.x *= m.scaleNonUniform[Le * 3], Fe.scale.y *= m.scaleNonUniform[Le * 3 + 1], Fe.scale.z *= m.scaleNonUniform[Le * 3 + 2]), fe.add(Fe);
      }
      return fe.styleCallback(o), fe.traverse((Le) => {
        var Fe;
        if (Le instanceof Mesh) {
          const Ee = Le.material;
          Ee.clippingPlanes = (Fe = a.clippingPlanes) !== null && Fe !== void 0 ? Fe : [], Ee.needsUpdate = !0;
        }
      }), Instanced3DModel.resolveTransforms(fe, q, m, e), l.setForId(fe.objectId, {
        objectType: ObjectType.Composite,
        rootObject: u,
        subObject: fe
      }), l.setIdForObject(fe.id, fe.objectId), fe;
    });
  }
  static loadGltfBuffer(e, s, o) {
    return __awaiter$B(this, void 0, void 0, function* () {
      let a, l;
      if (e) {
        const u = new TextDecoder(), c = u.decode(s), E = yield FileLoader.loadArrayBuffer(c);
        l = new DataView(E), l.getUint8(0) !== 103 && (l = u.decode(l)), a = c;
      } else if (l = s, o.content.uri !== void 0 && o.content.uri !== null)
        a = o.content.uri;
      else if (o.content.url !== void 0 && o.content.url !== null)
        a = o.content.url;
      else
        throw new Error("Missing uri or url in content");
      return { baseUri: a, gltfBuffer: l };
    });
  }
  static loadFileSections(e) {
    const s = readFeatureTable(e, 32), o = readBatchTable(e, 32), a = readGltfSection(e);
    return { featureTableData: s, batchTableData: o, gltfSection: a };
  }
  static isValidHeader(e) {
    return !(e.getUint8(0) !== 105 || e.getUint8(1) !== 51 || e.getUint8(2) !== 100 || e.getUint8(3) !== 109);
  }
  static resolveTransforms(e, s, o, a) {
    const l = new Matrix4();
    if (typeof o.rtcCenter < "u")
      l.makeTranslation(o.rtcCenter[0], o.rtcCenter[1], o.rtcCenter[2]);
    else if (s.json !== void 0 && typeof s.json == "object" && s.json.extensionsUsed !== void 0 && s.json.extensionsUsed.indexOf("CESIUM_RTC") !== -1) {
      const f = s.json.extensions.CESIUM_RTC.center;
      l.makeTranslation(f[0], f[1], f[2]);
    }
    a.extras.transform.clone().invert().decompose(e.position, e.quaternion, e.scale);
  }
  evict() {
    this.materialRegistry.styleCallbacks.delete(this.styleCallbackFn), this.materialRegistry.clippingPlaneCallbacks.delete(this.clippingPlaneCallbackFn), this.materialRegistry.invalidateCallbacks.delete(this.invalidateCallbackFn), this.objectId !== 0 && this.pickingManager !== void 0 && (this.pickingManager.removeForId(this.objectId), this.pickingManager.removeForObject(this.id)), Batch3DModel.evictGltf(this);
  }
  get geometrySizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      o.geometry instanceof BufferGeometry && e.add(o.geometry);
    });
    let s = 0;
    for (const o of e)
      s += estimateBytesUsed(o);
    return s;
  }
  get textureSizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      const a = o.material;
      if (a) {
        const l = Array.isArray(a) ? a : [a];
        for (const u of l)
          for (const c of Object.values(u))
            c instanceof Texture && e.add(c);
      }
    });
    let s = 0;
    for (const o of e) {
      const a = o.format === RGBAFormat ? 4 : 3, l = o.image.width * o.image.height;
      s += a * l;
    }
    return s;
  }
  get pointCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Points && (s.geometry.index ? e += s.geometry.index.count : e += s.geometry.getAttribute("position").count);
    }), e;
  }
  get triangleCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Mesh && (s.geometry.index ? e += s.geometry.index.count / 3 : e += s.geometry.getAttribute("position").count / 3);
    }), e;
  }
  styleCallback(e) {
    this.traverse((s) => {
      var o;
      if (s instanceof Mesh) {
        const a = s.material;
        a.needsUpdate = !0, a.opacity = (o = e.opacity) !== null && o !== void 0 ? o : 1, a.side = ourCullingToThreeCulling(e.faceCulling), a.opacity < 1 ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, a.depthWrite = !0);
      }
    });
  }
  clippingPlaneCallback(e) {
    this.traverse((s) => {
      if (s instanceof Mesh) {
        const o = s.material;
        o.clippingPlanes = e, o.needsUpdate = !0;
      }
    });
  }
  invalidateCallback() {
    this.traverse((e) => {
      if (e instanceof Mesh) {
        const s = e.material;
        s.needsUpdate = !0;
      }
    });
  }
}
function readGltfSection(r) {
  const e = r.getUint32(12, !0), s = r.getUint32(16, !0), o = r.getUint32(20, !0), a = r.getUint32(24, !0), l = 32 + e + s + o + a;
  return new DataView(r.buffer, l, r.byteLength - l);
}
function isQuantizedFeatureTableAttributes(r) {
  return typeof r.POSITION_QUANTIZED < "u";
}
function isFeatureDracoExtension(r) {
  return !(typeof r != "object" || r === null || typeof r.byteOffset != "number" || typeof r.byteLength != "number" || typeof r.properties != "object" || r.properties === null || typeof r.properties.POSITION < "u" && typeof r.properties.POSITION != "number" || typeof r.properties.RGB < "u" && typeof r.properties.RGB != "number" || typeof r.properties.RGBA < "u" && typeof r.properties.RGBA != "number" || typeof r.properties.NORMAL < "u" && typeof r.properties.NORMAL != "number" || typeof r.properties.BATCH_ID < "u" && typeof r.properties.BATCH_ID != "number");
}
function isBatchDracoExtension(r) {
  if (typeof r != "object" || r === null || typeof r.properties != "object" || r.properties === null)
    return !1;
  for (const e of Object.values(r.properties))
    if (typeof e != "number")
      return !1;
  return !0;
}
var ComponentType;
(function(r) {
  r.BYTE = "BYTE", r.UNSIGNED_BYTE = "UNSIGNED_BYTE", r.SHORT = "SHORT", r.UNSIGNED_SHORT = "UNSIGNED_SHORT", r.INT = "INT", r.UNSIGNED_INT = "UNSIGNED_INT", r.FLOAT = "FLOAT", r.DOUBLE = "DOUBLE";
})(ComponentType || (ComponentType = {}));
function componentTypeToNumType(r) {
  switch (r) {
    case ComponentType.BYTE:
      return 4;
    case ComponentType.UNSIGNED_BYTE:
      return 0;
    case ComponentType.SHORT:
      return 5;
    case ComponentType.UNSIGNED_SHORT:
      return 1;
    case ComponentType.INT:
      return 6;
    case ComponentType.UNSIGNED_INT:
      return 2;
    case ComponentType.FLOAT:
      return 8;
    case ComponentType.DOUBLE:
      return 9;
    default:
      throw new Error(`Unknown component type '${r}'`);
  }
}
var VectorType;
(function(r) {
  r.SCALAR = "SCALAR", r.VEC2 = "VEC2", r.VEC3 = "VEC3", r.VEC4 = "VEC4";
})(VectorType || (VectorType = {}));
function numComponentsForVectorType(r) {
  switch (r) {
    case VectorType.SCALAR:
      return 1;
    case VectorType.VEC2:
      return 2;
    case VectorType.VEC3:
      return 3;
    case VectorType.VEC4:
      return 4;
    default:
      throw new Error(`Unknown vector type ${r}`);
  }
}
function readFeatureTableObject(r) {
  const e = JSON.parse(r.text), s = readFeatureTableAttributes(e), a = {
    pointsLength: readSingleNum(r.data, 2, e.POINTS_LENGTH)
  };
  typeof e.extensions < "u" && (a.extensions = e.extensions), typeof e.extras < "u" && (a.extras = e.extras);
  const l = readSingleNum(r.data, 2, e.BATCH_LENGTH);
  typeof l < "u" && (a.batchLength = l);
  const u = readMultiNum(r.data, 4, 8, e.CONSTANT_RGBA);
  typeof u < "u" && (a.constantRGBA = [u[0], u[1], u[2], u[3]]);
  const c = readMultiNum(r.data, 3, 8, e.RTC_CENTER);
  if (typeof c < "u" && (a.rtcCenter = [c[0], c[1], c[2]]), isQuantizedFeatureTableAttributes(s)) {
    const E = readMultiNum(r.data, 3, 8, e.QUANTIZED_VOLUME_OFFSET), d = readMultiNum(r.data, 3, 8, e.QUANTIZED_VOLUME_SCALE);
    return Object.assign({ attributes: s, quantizedVolume: { offset: [E[0], E[1], E[2]], scale: [d[0], d[1], d[2]] } }, a);
  } else
    return Object.assign({ attributes: s }, a);
}
function readBatchTableObject(r) {
  if (typeof r > "u")
    return;
  const e = JSON.parse(r.text), s = {
    attributes: {}
  };
  for (const [o, a] of Object.entries(e).filter(([l, u]) => l !== "extensions" && l !== "extras")) {
    const l = a;
    if (typeof l.byteOffset > "u" || typeof l.byteOffset != "number")
      throw new Error("Invalid batch table attribute");
    if (typeof l.componentType > "u" || typeof l.componentType != "string")
      throw new Error("Invalid batch table attribute");
    if (typeof l.type > "u" || typeof l.type != "string")
      throw new Error("Invalid batch table attribute");
    s.attributes[o] = {
      byteOffset: l.byteOffset,
      numComponents: numComponentsForVectorType(l.type),
      componentType: componentTypeToNumType(l.componentType)
    };
  }
  return typeof e.extensions < "u" && (s.extensions = e.extensions), typeof e.extras < "u" && (s.extras = e.extras), s;
}
function readFeatureTableAttributes(r) {
  if (typeof r != "object" || r === null)
    throw new Error();
  let e;
  if (typeof r.POSITION < "u")
    e = {
      POSITION: r.POSITION
    };
  else if (typeof r.POSITION_QUANTIZED < "u")
    e = {
      POSITION_QUANTIZED: r.POSITION_QUANTIZED
    };
  else
    throw new Error();
  return typeof r.RGBA < "u" && (e.RGBA = r.RGBA), typeof r.RGB < "u" && (e.RGB = r.RGB), typeof r.RGB565 < "u" && (e.RGB565 = r.RGB565), typeof r.NORMAL < "u" && (e.NORMAL = r.NORMAL), typeof r.NORMAL_OCT16P < "u" && (e.NORMAL_OCT16P = r.NORMAL_OCT16P), typeof r.BATCH_ID < "u" && (e.BATCH_ID = r.BATCH_ID), e;
}
function readSingleNum(r, e, s) {
  return typeof s > "u" || typeof s == "number" ? s : isByteOffset(s) ? readNumFromBlob(r, e, s.byteOffset) : s[0];
}
function readMultiNum(r, e, s, o) {
  if (typeof o > "u")
    return o;
  if (typeof o == "number")
    return [o];
  if (isByteOffset(o)) {
    const a = numByteSize(s);
    for (let l = 0; l < e; l += 1) {
      const u = l * a;
      readNumFromBlob(r, s, o.byteOffset + u);
    }
    return;
  } else
    return o.length !== e ? void 0 : o;
}
function readNumFromBlob(r, e, s) {
  switch (e) {
    case 3:
      throw new Error("U64 can't be represented in a double precision floating point (number)");
    case 7:
      throw new Error("I64 can't be represented in a double precision floating point (number)");
    case 0:
      return r.getUint8(s);
    case 4:
      return r.getInt8(s);
    case 1:
      return r.getUint16(s, !0);
    case 5:
      return r.getInt16(s, !0);
    case 2:
      return r.getUint32(s, !0);
    case 6:
      return r.getInt32(s, !0);
    case 8:
      return r.getFloat32(s, !0);
    case 9:
      return r.getFloat64(s, !0);
  }
}
var __awaiter$A = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
function readPointCloud(r, e, s, o, a, l, u) {
  return __awaiter$A(this, void 0, void 0, function* () {
    const c = extractFeatureDracoExtensionObject(e), E = extractBatchDracoExtensionObject(o), d = typeof e.attributes.RGB < "u" || typeof e.attributes.RGBA < "u" || typeof e.attributes.RGB565 < "u";
    let f;
    if (c !== void 0) {
      const R = createDracoDataSlice(r.data, c), _ = createDracoDecodeOptions(e, c, o, E);
      f = yield DracoLoader.decodePointCloudBuffer(_, R);
    } else
      f = new BufferGeometry();
    const h = Object.entries(e.attributes).filter(([R, _]) => c === void 0 || typeof c.properties[R] === void 0);
    for (const [R, _] of h)
      loadUncompressedFeatureAttribute(f, e, r.data, R, _.byteOffset);
    if (typeof o < "u" && typeof s < "u") {
      const R = Object.entries(o == null ? void 0 : o.attributes).filter(([_, m]) => E === void 0 || typeof E.properties[_] === void 0);
      for (const [_, m] of R)
        loadUncompressedBatchAttribute(f, e, o, s.data, _, m);
    }
    const S = createPointCloudMaterial(e, d, a, l, u);
    return [f, S];
  });
}
function extractFeatureDracoExtensionObject(r) {
  let e;
  if (typeof r.extensions < "u" && r.extensions["3DTILES_draco_point_compression"] !== void 0) {
    const s = r.extensions["3DTILES_draco_point_compression"];
    isFeatureDracoExtension(s) && (e = s);
  }
  return e;
}
function extractBatchDracoExtensionObject(r) {
  if (typeof r > "u")
    return;
  let e;
  if (typeof r.extensions < "u" && r.extensions["3DTILES_draco_point_compression"] !== void 0) {
    const s = r.extensions["3DTILES_draco_point_compression"];
    isBatchDracoExtension(s) && (e = s);
  }
  return e;
}
function createDracoDataSlice(r, e) {
  return new DataView(r.buffer, r.byteOffset + e.byteOffset, e.byteLength);
}
function createDracoDecodeOptions(r, e, s, o) {
  const a = {};
  for (const l of Object.keys(e.properties)) {
    if (!(l in r.attributes))
      throw new Error("Draco declares data for a semantic not in the feature table");
    switch (l) {
      case "POSITION": {
        a.position = {
          attributeId: e.properties[l],
          componentType: 8,
          numComponents: 3,
          normalized: !1
        };
        break;
      }
      case "RGBA": {
        a.color = {
          attributeId: e.properties[l],
          componentType: 0,
          numComponents: 4,
          normalized: !0,
          mapperFn: (u) => {
            u[0] = srgbConv(u[0]), u[1] = srgbConv(u[1]), u[2] = srgbConv(u[2]);
          }
        };
        break;
      }
      case "RGB": {
        a.color = {
          attributeId: e.properties[l],
          componentType: 0,
          numComponents: 3,
          normalized: !0,
          mapperFn: (u) => {
            u[0] = srgbConv(u[0]), u[1] = srgbConv(u[1]), u[2] = srgbConv(u[2]);
          }
        };
        break;
      }
      case "NORMAL": {
        a.normal = {
          attributeId: e.properties[l],
          componentType: 8,
          numComponents: 3,
          normalized: !1
        };
        break;
      }
      case "BATCH_ID": {
        a.BATCH_ID = {
          attributeId: e.properties[l],
          componentType: 2,
          numComponents: 1,
          normalized: !1
        };
        break;
      }
    }
  }
  if (typeof s < "u" && typeof o < "u")
    for (const l of Object.keys(o.properties)) {
      if (!(l in s.attributes))
        throw new Error("Draco declares data for a semantic not in the batch table");
      const u = s.attributes[l];
      a[l] = {
        attributeId: o.properties[l],
        componentType: u.componentType,
        numComponents: u.numComponents,
        normalized: !1
      };
    }
  return {
    attributes: a
  };
}
function loadUncompressedFeatureAttribute(r, e, s, o, a) {
  switch (o) {
    case "POSITION": {
      const u = e.pointsLength * 3, c = s.byteOffset + a, E = new Float32Array(s.buffer, c, u);
      r.setAttribute("position", new Float32BufferAttribute(E, 3));
      break;
    }
    case "POSITION_QUANTIZED":
      throw new Error('Unsupported position format "POSITION_QUANTIZED"');
    case "RGBA": {
      const u = e.pointsLength * 4, c = s.byteOffset + a, E = new Uint8Array(s.buffer, c, u);
      for (let d = 0; d < E.length; d += 4)
        E[d + 0] = srgbConv(E[d + 0]), E[d + 1] = srgbConv(E[d + 1]), E[d + 2] = srgbConv(E[d + 2]);
      r.setAttribute("color", new Uint8BufferAttribute(E, 4, !0));
      break;
    }
    case "RGB": {
      const u = e.pointsLength * 3, c = s.byteOffset + a, E = new Uint8Array(s.buffer, c, u);
      for (let d = 0; d < E.length; d += 3)
        E[d + 0] = srgbConv(E[d + 0]), E[d + 1] = srgbConv(E[d + 1]), E[d + 2] = srgbConv(E[d + 2]);
      r.setAttribute("color", new Uint8BufferAttribute(E, 3, !0));
      break;
    }
    case "RGB565":
      throw new Error('Unsupported color format "RGB565"');
    case "NORMAL": {
      const u = e.pointsLength * 3, c = s.byteOffset + a, E = new Float32Array(s.buffer, c, u);
      r.setAttribute("normal", new Float32BufferAttribute(E, 3));
      break;
    }
    case "NORMAL_OCT16P":
      throw new Error('Unsupported normal format "NORMAL_OCT16P"');
    case "BATCH_ID": {
      const u = e.pointsLength * 3, c = s.byteOffset + a, E = new Float32Array(s.buffer, c, u);
      r.setAttribute("BATCH_ID", new Float32BufferAttribute(E, 3));
      break;
    }
    default:
      throw new Error(`Unknown feature attribute ${o}`);
  }
}
function loadUncompressedBatchAttribute(r, e, s, o, a, l) {
  const u = e.pointsLength * l.numComponents, c = o.byteOffset + l.byteOffset, E = constructBufferForNumType(l.componentType, o.buffer, c, u);
  r.setAttribute(a, createAttributeBufferFor(E, l.componentType, l.numComponents, !1));
}
function createPointCloudMaterial(r, e, s, o, a) {
  var l, u;
  const c = (l = s.opacity) !== null && l !== void 0 ? l : 1, E = c < 1, d = !E, f = {
    size: (u = s.pointSize) !== null && u !== void 0 ? u : 1,
    style: s.pointStyle,
    objectId: a || 0,
    vertexColors: e,
    clippingPlanes: o.clippingPlanes,
    sizeAttenuation: !0,
    classificationColors: s.classificationColors,
    intensityColors: s.intensityColors,
    gradientColors: s.gradientColors,
    brightness: s.brightness,
    contrast: s.contrast,
    gamma: s.gamma,
    forceSinglePass: !0,
    opacity: c,
    transparent: E,
    depthWrite: d
  };
  return r.constantRGBA !== void 0 && (f.color = new Color(r.constantRGBA[0], r.constantRGBA[1], r.constantRGBA[2])), new PickingPointsMaterial(f);
}
function srgbConv(r) {
  return Math.trunc(Math.pow(r / 255, 2.2) * 255);
}
var __awaiter$z = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class PointCloud extends Points {
  constructor(e, s, o, a, l, u, c, E) {
    super(e, s), this.tile = a, this.materialRegistry = l, this.pickingManager = u, this.objectId = c, this._featureTable = o, this._batchTable = E, this.styleCallbackFn = (d) => this.styleCallback(d), this.clippingPlaneCallbackFn = (d) => this.clippingPlaneCallback(d), this.invalidateCallbackFn = () => this.invalidateCallback(), l.styleCallbacks.add(this.styleCallbackFn), l.clippingPlaneCallbacks.add(this.clippingPlaneCallbackFn), l.invalidateCallbacks.add(this.invalidateCallbackFn), this.onBeforeRender = (d, f, h, S, R, _) => {
      if (this.material.style !== PointCloudStyle.GradientColoring)
        return;
      const m = new Vector3$1(this.material.minGradient.x, this.material.minGradient.y, this.material.minGradient.z), L = new Vector3$1(this.material.maxGradient.x, this.material.maxGradient.y, this.material.maxGradient.z);
      m.applyMatrix4(h.matrixWorldInverse), L.applyMatrix4(h.matrixWorldInverse), this.material.minGradientViewSpace = m, this.material.maxGradientViewSpace = L, this.material.needsUpdate = !0;
    };
  }
  static create(e, s, o, a, l, u) {
    return __awaiter$z(this, void 0, void 0, function* () {
      const c = s, E = l.newId();
      assert(PointCloud.isValidHeader(c));
      const d = c.getUint32(4, !0);
      assert(d === 1);
      const f = readFeatureTable(c), h = readBatchTable(c), S = readFeatureTableObject(f), R = readBatchTableObject(h), [_, m] = yield readPointCloud(f, S, h, R, o, a, E), L = new PointCloud(_, m, S, e, a, l, E, R);
      return PointCloud.resolveTransforms(L, S, e), L.updateMatrix(), L.updateWorldMatrix(!1, !1), L.updateGradientVectors(o), l.setForId(L.objectId, {
        objectType: ObjectType.Composite,
        rootObject: u,
        subObject: L
      }), l.setIdForObject(L.id, L.objectId), L;
    });
  }
  /**
   * Coerce an undefined PointCloudStyle to the default value
   * @param style
   */
  static styleOrDefault(e) {
    return e ?? PointCloudStyle.None;
  }
  static isValidHeader(e) {
    return !(e.getUint8(0) !== 112 || e.getUint8(1) !== 110 || e.getUint8(2) !== 116 || e.getUint8(3) !== 115);
  }
  static resolveTransforms(e, s, o) {
    const a = new Matrix4();
    typeof s.rtcCenter < "u" && a.makeTranslation(s.rtcCenter[0], s.rtcCenter[1], s.rtcCenter[2]), o.extras.transform.clone().multiply(a).decompose(e.position, e.quaternion, e.scale);
  }
  evict() {
    this.materialRegistry.styleCallbacks.delete(this.styleCallbackFn), this.materialRegistry.clippingPlaneCallbacks.delete(this.clippingPlaneCallbackFn), this.materialRegistry.invalidateCallbacks.delete(this.invalidateCallbackFn), this.objectId !== 0 && this.pickingManager !== void 0 && (this.pickingManager.removeForId(this.objectId), this.pickingManager.removeForObject(this.id)), this.geometry.dispose(), this.material.dispose();
  }
  get geometrySizeInBytes() {
    return estimateBytesUsed(this.geometry);
  }
  get textureSizeInBytes() {
    return 0;
  }
  get pointCount() {
    return this.geometry.index ? this.geometry.index.count : this.geometry.getAttribute("position").count;
  }
  get triangleCount() {
    return 0;
  }
  styleCallback(e) {
    e.gradient !== void 0 && this.updateGradientVectors(e), e.pointStyle !== void 0 && (this.material.style = e.pointStyle), e.pointShape !== void 0 && (this.material.shape = e.pointShape), e.classificationColors !== void 0 && (this.material.classificationColors = e.classificationColors), e.intensityColors !== void 0 && (this.material.intensityColors = e.intensityColors), e.gradientColors !== void 0 && (this.material.gradientColors = e.gradientColors), e.pointSize !== void 0 && (this.material.size = e.pointSize), e.sizeAttenuation !== void 0 && (this.material.sizeAttenuation = e.sizeAttenuation), e.brightness !== void 0 && (this.material.brightness = e.brightness), e.contrast !== void 0 && (this.material.contrast = e.contrast), e.gamma !== void 0 && (this.material.gamma = e.gamma), e.opacity !== void 0 && (this.material.opacity = e.opacity), this.material.opacity < 1 ? (this.material.transparent = !0, this.material.depthWrite = !1) : (this.material.transparent = !1, this.material.depthWrite = !0), this.material.needsUpdate = !0;
  }
  clippingPlaneCallback(e) {
    this.material.clippingPlanes = e, this.material.needsUpdate = !0;
  }
  invalidateCallback() {
    this.material.needsUpdate = !0;
  }
  // Internal function for converting gradient vectors to values sane to use
  updateGradientVectors(e) {
    var s, o, a, l, u, c;
    const E = new Vector3$1(((s = e.gradient) === null || s === void 0 ? void 0 : s.min.x) || 0, ((o = e.gradient) === null || o === void 0 ? void 0 : o.min.y) || 0, ((a = e.gradient) === null || a === void 0 ? void 0 : a.min.z) || 0), d = new Vector3$1(((l = e.gradient) === null || l === void 0 ? void 0 : l.max.x) || 0, ((u = e.gradient) === null || u === void 0 ? void 0 : u.max.y) || 0, ((c = e.gradient) === null || c === void 0 ? void 0 : c.max.z) || 0);
    this.tile.extras.owner.extras.owner, this.material.minGradient = E, this.material.maxGradient = d;
  }
  raycast(e, s) {
    var o, a, l;
    const u = e.ray.clone(), c = this.matrixWorld.clone().invert();
    u.applyMatrix4(c);
    const d = ((a = (o = e.params.Points) === null || o === void 0 ? void 0 : o.threshold) !== null && a !== void 0 ? a : 0.01) / ((this.scale.x + this.scale.y + this.scale.z) / 3), f = d * d;
    let h = 1 / 0, S = null;
    (l = this.geometry.boundsTree) === null || l === void 0 || l.shapecast({
      boundsTraverseOrder: (R) => R.distanceToPoint(u.origin),
      intersectsBounds: (R, _, m) => !m || m * m > h ? NOT_INTERSECTED : (R.expandByScalar(d), u.intersectsBox(R) ? INTERSECTED : NOT_INTERSECTED),
      intersectsTriangle: (R) => {
        if (u.distanceSqToPoint(R.a) < f) {
          const m = u.origin.distanceToSquared(R.a);
          m < h && (h = m, S = R.a.clone().applyMatrix4(this.matrixWorld));
        }
      }
    }), h < 1 / 0 && S && s.push({
      distance: Math.sqrt(h),
      point: S,
      object: this
    });
  }
}
var __awaiter$y = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class GLTFModel extends Object3D {
  constructor(e, s, o) {
    super(), this.credits = [], this.materialRegistry = e, this.pickingManager = s, this.objectId = o, this.styleCallbackFn = (a) => this.styleCallback(a), this.clippingPlaneCallbackFn = (a) => this.clippingPlaneCallback(a), this.invalidateCallbackFn = () => this.invalidateCallback(), e.styleCallbacks.add(this.styleCallbackFn), e.clippingPlaneCallbacks.add(this.clippingPlaneCallbackFn), e.invalidateCallbacks.add(this.invalidateCallbackFn);
  }
  static create(e, s, o, a, l, u) {
    return __awaiter$y(this, void 0, void 0, function* () {
      const c = s, E = l.newId();
      assert(GLTFModel.isValidHeader(c));
      let d;
      if (e.content.uri !== void 0 && e.content.uri !== null)
        d = e.content.uri;
      else if (e.content.url !== void 0 && e.content.url !== null)
        d = e.content.url;
      else
        throw new Error("Missing uri or url in content");
      const f = yield readBatchModel(s, `${d}/../`, {
        objectId: E || 0,
        clippingPlanes: a.clippingPlanes
      }), h = new GLTFModel(a, l, E);
      return h.add(f.scene), f.asset && f.asset.copyright && h.credits.push(...f.asset.copyright.split(";")), h.styleCallback(o), h.traverse((S) => {
        var R;
        if (S instanceof Mesh) {
          const _ = S.material;
          _.clippingPlanes = (R = a.clippingPlanes) !== null && R !== void 0 ? R : [], _.needsUpdate = !0;
        }
      }), GLTFModel.resolveTransforms(h, f, e), l.setForId(h.objectId, {
        objectType: ObjectType.Composite,
        rootObject: u,
        subObject: h
      }), l.setIdForObject(h.id, h.objectId), h;
    });
  }
  static isValidHeader(e) {
    return !(e.getUint8(0) !== 103 || e.getUint8(1) !== 108 || e.getUint8(2) !== 84 || e.getUint8(3) !== 70);
  }
  static resolveTransforms(e, s, o) {
    var a;
    const l = new Matrix4();
    switch ((a = o.extras.owner.asset.gltfUpAxis) !== null && a !== void 0 ? a : "Y") {
      case "X":
        break;
      case "Y":
        l.makeRotationAxis(MathUtils.X_AXIS, Math.PI / 2);
        break;
    }
    const u = new Matrix4();
    if (s.json !== void 0 && typeof s.json == "object" && s.json.extensionsUsed !== void 0 && s.json.extensionsUsed.indexOf("CESIUM_RTC") !== -1) {
      const h = s.json.extensions.CESIUM_RTC.center;
      u.makeTranslation(h[0], h[1], h[2]);
    }
    o.extras.transform.clone().multiply(u.multiply(l)).decompose(e.position, e.quaternion, e.scale);
  }
  evict() {
    this.materialRegistry.styleCallbacks.delete(this.styleCallbackFn), this.materialRegistry.clippingPlaneCallbacks.delete(this.clippingPlaneCallbackFn), this.materialRegistry.invalidateCallbacks.delete(this.invalidateCallbackFn), this.objectId !== 0 && this.pickingManager !== void 0 && (this.pickingManager.removeForId(this.objectId), this.pickingManager.removeForObject(this.id)), GLTFModel.evictGltf(this);
  }
  get geometrySizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      o.geometry instanceof BufferGeometry && e.add(o.geometry);
    });
    let s = 0;
    for (const o of e)
      s += estimateBytesUsed(o);
    return s;
  }
  get textureSizeInBytes() {
    const e = /* @__PURE__ */ new Set();
    this.traverse((o) => {
      const a = o.material;
      if (a) {
        const l = Array.isArray(a) ? a : [a];
        for (const u of l)
          for (const c of Object.values(u))
            c instanceof Texture && e.add(c);
      }
    });
    let s = 0;
    for (const o of e) {
      const a = o.format === RGBAFormat ? 4 : 3, l = o.image.width * o.image.height;
      s += a * l;
    }
    return s;
  }
  get pointCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Points && (s.geometry.index ? e += s.geometry.index.count : e += s.geometry.getAttribute("position").count);
    }), e;
  }
  get triangleCount() {
    let e = 0;
    return this.traverse((s) => {
      s instanceof Mesh && (s.geometry.index ? e += s.geometry.index.count / 3 : e += s.geometry.getAttribute("position").count / 3);
    }), e;
  }
  static evictGltf(e) {
    e.traverse((s) => {
      if (s instanceof Mesh)
        if (s.geometry.dispose(), Array.isArray(s.material))
          for (const o of s.material)
            evictMaterial(o);
        else
          evictMaterial(s.material);
    });
  }
  styleCallback(e) {
    this.traverse((s) => {
      var o;
      if (s instanceof Mesh) {
        const a = s.material;
        a.needsUpdate = !0, a.opacity = (o = e.opacity) !== null && o !== void 0 ? o : 1, a.side = ourCullingToThreeCulling(e.faceCulling), a.opacity < 1 ? (a.transparent = !0, a.depthWrite = !1) : (a.transparent = !1, a.depthWrite = !0);
      }
    });
  }
  clippingPlaneCallback(e) {
    this.traverse((s) => {
      if (s instanceof Mesh) {
        const o = s.material;
        o.clippingPlanes = e, o.needsUpdate = !0;
      }
    });
  }
  invalidateCallback() {
    this.traverse((e) => {
      if (e instanceof Mesh) {
        const s = e.material;
        s.needsUpdate = !0;
      }
    });
  }
}
var __awaiter$x = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const _MATRIX4_0$2 = new Matrix4(), _VECTOR3_0$4 = new Vector3$1(), _SET_0 = /* @__PURE__ */ new Set(), _COLOR_0 = new Color(), _COLOR_WHITE = new Color("white"), _COLOR_RED = new Color("red"), _COLOR_YELLOW = new Color("yellow"), _COLOR_GREEN = new Color("green"), _COLOR_CYAN = new Color("cyan"), _NUMBER_ARRAY_0 = [], _TILECONTENT_ARRAY_0 = [], _TILE_ARRAY_0 = [], _TILE_ARRAY_1 = [], _TILE_ARRAY_2 = [], _TILE_ARRAY_3 = [];
class Tileset3D extends PreparingObject {
  constructor(e) {
    var s, o, a, l;
    if (super(), this.currentQueryId = 0, this.statistics = {
      visitedTiles: 0,
      requestedTiles: 0,
      requestsInFlight: 0,
      renderedTiles: 0,
      loadedTiles: 0,
      geometrySizeInBytes: 0,
      textureSizeInBytes: 0,
      drawCalls: 0,
      renderedPoints: 0,
      renderedTriangles: 0,
      dynamicScreenSpaceError: 0,
      refinedToCompletion: !1
    }, this.traversalContext = {
      camera: new Camera(),
      frustum: new Frustum(),
      screenSize: new Vector2(),
      tileFrustumCulling: !0,
      requestCancelling: !0
    }, this.traversalResult = {
      rendered: [],
      requested: [],
      expectedMemoryUsage: 0,
      expectedPointCount: 0
    }, this.dynamicScreenSpaceError = (s = e.maximumScreenSpaceError) !== null && s !== void 0 ? s : 16, this.pickingManager = e.pickingManager, this.requestManager = e.requestManager, this.matrixAutoUpdate = !1, this.frustumCulled = !1, this.canEvict = !0, this.isFrozen = !1, e.parent !== void 0) {
      const u = e.parent.extras.owner.extras.owner;
      this.materialRegistry = u.materialRegistry, this.sharedSettings = u.sharedSettings, this.tileCache = u.tileCache, this.isRoot = !1;
    } else
      this.materialRegistry = {
        styleCallbacks: /* @__PURE__ */ new Set(),
        clippingPlaneCallbacks: /* @__PURE__ */ new Set(),
        invalidateCallbacks: /* @__PURE__ */ new Set(),
        clippingPlanes: []
      }, this.sharedSettings = {
        styleDesc: Object.assign({}, e.styleDesc),
        maximumScreenSpaceError: (o = e.maximumScreenSpaceError) !== null && o !== void 0 ? o : 16,
        memoryBudget: (a = e.memoryBudget) !== null && a !== void 0 ? a : 536870912,
        pointBudget: (l = e.pointBudget) !== null && l !== void 0 ? l : 5e6,
        attributions: []
      }, this.tileCache = new EvictionQueue(), this.isRoot = !0;
    this.tilesetSource = e.tileset.extras.source, this.tileset = initExtras(e.tileset, e.parent, this), resolveRefinementModes(this.tileset.root, e.parent), resolveTransforms(this.tileset.root, e.parent), resolveBoundingSpheres(this.tileset.root);
  }
  evict() {
  }
  get geometrySizeInBytes() {
    return 0;
  }
  get textureSizeInBytes() {
    return 0;
  }
  get pointCount() {
    return 0;
  }
  get triangleCount() {
    return 0;
  }
  get attributions() {
    return this.sharedSettings.attributions.concat(this.tilesetSource.attributions);
  }
  get maximumScreenSpaceError() {
    return this.sharedSettings.maximumScreenSpaceError;
  }
  set maximumScreenSpaceError(e) {
    e !== this.sharedSettings.maximumScreenSpaceError && (this.sharedSettings.maximumScreenSpaceError = e, this.dynamicScreenSpaceError = e);
  }
  get memoryBudget() {
    return this.sharedSettings.memoryBudget;
  }
  set memoryBudget(e) {
    this.sharedSettings.memoryBudget = e;
  }
  get pointBudget() {
    return this.sharedSettings.pointBudget;
  }
  set pointBudget(e) {
    this.sharedSettings.pointBudget = e;
  }
  get styledTransparent() {
    const e = this.sharedSettings.styleDesc.opacity;
    return (e ?? 1) < 1;
  }
  /**
   * Queries for all tiles colliding with the given collider. This function can only be called once at a time. Stale concurrent invokations will be aborted.
   *
   * @param collider The collider to test against (Sphere, Box3, or function)
   * @param onProgress Callback for progress updates
   */
  queryCollidingTiles(e, s = () => {
  }) {
    var o;
    return __awaiter$x(this, void 0, void 0, function* () {
      (o = this.queryAbortController) === null || o === void 0 || o.abort(new Error("QueryCollidingTiles invoked mid-query.")), this.queryAbortController = new AbortController();
      const a = ++this.currentQueryId;
      this.canEvict = !1;
      try {
        return yield this.queryCollidingTilesInternal(e, s, this.queryAbortController.signal);
      } finally {
        this.currentQueryId === a && (this.canEvict = !0);
      }
    });
  }
  updateTileInfo(e, s) {
    e.extras.boundingSphere.center.x = e.boundingVolume.sphere[0], e.extras.boundingSphere.center.y = e.boundingVolume.sphere[1], e.extras.boundingSphere.center.z = e.boundingVolume.sphere[2], e.extras.boundingSphere.radius = e.boundingVolume.sphere[3], e.extras.boundingSphere.applyMatrix4(e.extras.transform), e.extras.boundingSphere.applyMatrix4(this.matrixWorld);
    const o = s.camera, l = o.getWorldPosition(_VECTOR3_0$4).distanceTo(e.extras.boundingSphere.center), u = Math.max(l - e.extras.boundingSphere.radius, MathUtils.EPSILON7);
    e.extras.screenSpaceError = MathUtils.projectGeometricErrorPerspective(e.geometricError, s.screenSize.y, u, MathUtils.degreesToRadians(o.perspective.fov));
    const c = _VECTOR3_0$4.copy(e.extras.boundingSphere.center);
    c.project(o.getCurrentCamera()), c.z = 0, e.extras.cameraDistance = u, e.extras.screenCenterDistance = c.length();
  }
  computeTileSortKeys(e) {
    let s = 1 / 0, o = -1 / 0, a = 1 / 0, l = -1 / 0, u = 1 / 0, c = -1 / 0;
    for (const E of e)
      s = Math.min(s, E.extras.cameraDistance), o = Math.max(o, E.extras.cameraDistance), a = Math.min(a, E.extras.screenCenterDistance), l = Math.max(l, E.extras.screenCenterDistance), u = Math.min(u, E.extras.depth), c = Math.max(c, E.extras.depth);
    for (const E of e) {
      const d = MathUtils.normalize(E.extras.cameraDistance, s, o), f = MathUtils.normalize(E.extras.screenCenterDistance, a, l), h = MathUtils.normalize(E.extras.depth, u, c);
      E.extras.sortKey = 0.7 * d + 0.2 * (1 - h) + 0.1 * f;
    }
  }
  isNestedTileset(e) {
    var s, o;
    let a = (o = (s = e.uri) !== null && s !== void 0 ? s : e.url) !== null && o !== void 0 ? o : "";
    return a = a.split("?")[0], a.endsWith(".json");
  }
  isTerminal(e, s) {
    const a = !(e.extras.screenSpaceError <= this.dynamicScreenSpaceError) || !e.content, l = this.getReplaceDependencies(e), u = e.children ? e.children.length > 0 : !1, c = l.length > 0, E = e.refine === "ADD" && u || e.refine === "REPLACE" && c;
    return e.extras.terminal = !E || !a, e.extras.terminal;
  }
  getReplaceDependencies(e) {
    const s = _TILECONTENT_ARRAY_0;
    s.length = 0;
    const o = _TILE_ARRAY_0;
    for (o.length = 0, o.push(e); o.length > 0; ) {
      const a = o.pop();
      if (a.children)
        for (const l of a.children)
          if (l.content)
            if (this.isNestedTileset(l.content))
              if (l.extras.content.object) {
                const u = l.extras.content.object;
                o.push(u.tileset.root), s.push(l);
              } else
                s.push(l);
            else
              s.push(l);
          else
            o.push(l);
    }
    return s;
  }
  cancelAllRequestsInSubtree(e) {
    const s = _TILE_ARRAY_1;
    for (s.length = 0, s.push(e); s.length > 0; ) {
      const o = s.pop();
      if (o.content)
        if (this.isNestedTileset(o.content)) {
          if (o.extras.content.object) {
            const a = o.extras.content.object;
            if (!(a instanceof Tileset3D))
              throw new Error("This should never happen...");
            s.push(a.tileset.root);
          }
        } else {
          const a = o.extras.content.request;
          a && a.status === "inflight" && a.cancel();
        }
      if (o.children)
        for (const a of o.children)
          s.push(a);
    }
  }
  traverseTiles(e, s) {
    this.traversalResult.rendered.length = 0, this.traversalResult.requested.length = 0, this.traversalResult.expectedMemoryUsage = 0, this.traversalResult.expectedPointCount = 0;
    const o = _TILE_ARRAY_2;
    for (o.length = 0, o.push(e); o.length > 0; ) {
      const a = o.pop();
      if (this.updateTileInfo(a, s), s.tileFrustumCulling && !s.frustum.intersectsSphere(a.extras.boundingSphere)) {
        s.requestCancelling && this.cancelAllRequestsInSubtree(a);
        continue;
      }
      if (this.traversalResult.expectedPointCount += a.extras.cost.pointCount, a.extras.content.cacheNode !== void 0 && (this.statistics.visitedTiles++, this.tileCache.touch(a.extras.content.cacheNode)), a.content && this.isNestedTileset(a.content))
        if (a.extras.content.object) {
          const l = a.extras.content.object;
          o.push(l.tileset.root);
        } else
          this.traversalResult.requested.push(a), this.traversalResult.expectedMemoryUsage += a.extras.cost.geometrySizeInBytes, this.traversalResult.expectedMemoryUsage += a.extras.cost.textureSizeInBytes;
      else if (this.isTerminal(a, s))
        a.extras.content.object ? this.traversalResult.rendered.push(a) : a.content && this.traversalResult.requested.push(a), this.traversalResult.expectedMemoryUsage += a.extras.cost.geometrySizeInBytes, this.traversalResult.expectedMemoryUsage += a.extras.cost.textureSizeInBytes;
      else if (!a.content && a.children)
        for (const l of a.children)
          o.push(l);
      else if (a.refine === "ADD") {
        if (a.extras.content.object ? this.traversalResult.rendered.push(a) : a.content && this.traversalResult.requested.push(a), this.traversalResult.expectedMemoryUsage += a.extras.cost.geometrySizeInBytes, this.traversalResult.expectedMemoryUsage += a.extras.cost.textureSizeInBytes, a.children)
          for (const l of a.children)
            o.push(l);
      } else {
        const l = this.getReplaceDependencies(a);
        for (const c of l)
          this.updateTileInfo(c, s), c.extras.content.cacheNode !== void 0 && (this.statistics.visitedTiles++, this.tileCache.touch(c.extras.content.cacheNode)), c.extras.content.object || this.traversalResult.requested.push(c), this.traversalResult.expectedMemoryUsage += c.extras.cost.geometrySizeInBytes, this.traversalResult.expectedMemoryUsage += c.extras.cost.textureSizeInBytes;
        let u = 0;
        for (const c of l)
          c.extras.content.object && u++;
        if (u === l.length)
          for (const c of l)
            o.push(c);
        else
          a.extras.content.object ? this.traversalResult.rendered.push(a) : a.content && this.traversalResult.requested.push(a), this.traversalResult.expectedMemoryUsage += a.extras.cost.geometrySizeInBytes, this.traversalResult.expectedMemoryUsage += a.extras.cost.textureSizeInBytes;
      }
    }
  }
  queryCollidingTilesInternal(e, s, o) {
    return __awaiter$x(this, void 0, void 0, function* () {
      const a = _TILE_ARRAY_3;
      a.length = 0, a.push(this.tileset.root);
      const l = [];
      for (; a.length > 0; ) {
        o == null || o.throwIfAborted();
        const d = a.pop();
        if (d.extras.boundingSphere.center.x = d.boundingVolume.sphere[0], d.extras.boundingSphere.center.y = d.boundingVolume.sphere[1], d.extras.boundingSphere.center.z = d.boundingVolume.sphere[2], d.extras.boundingSphere.radius = d.boundingVolume.sphere[3], d.extras.boundingSphere.applyMatrix4(d.extras.transform), d.extras.boundingSphere.applyMatrix4(this.matrixWorld), !(e instanceof Sphere$1 && !d.extras.boundingSphere.intersectsSphere(e) || e instanceof Box3$1 && !d.extras.boundingSphere.intersectsBox(e) || e instanceof Function && !e(d.extras.boundingSphere))) {
          if (d.children)
            for (const f of d.children)
              a.push(f);
          if (d.content)
            if (this.isNestedTileset(d.content)) {
              d.extras.content.object || (yield this.loadTile(d, o));
              const f = d.extras.content.object;
              a.push(f.tileset.root);
            } else
              (d.refine === "ADD" || !d.children || d.children.length === 0) && l.push(d);
        }
      }
      const u = [], c = [], E = 128;
      for (const d of l)
        if (o == null || o.throwIfAborted(), c.length >= E && (yield Promise.all(c), c.length = 0), d.extras.content.object)
          u.push(d.extras.content.object), s(u.length, l.length);
        else {
          const f = this.loadTile(d, o);
          f.then((h) => {
            o == null || o.throwIfAborted(), this.add(h), h.updateMatrixWorld(!0), this.remove(h), u.push(h), s(u.length, l.length);
          }), c.push(f);
        }
      return yield Promise.all(c), u;
    });
  }
  /**
   * This function needs to be called once per-frame before rendering is performed. This handles converting the
   * tileset node tree into a render list for ThreeJS to handle.
   */
  prepare(e, s, o) {
    var a;
    if (!this.isRoot)
      return;
    this.tileCache.newFrame(), this.updateMatrix(), this.updateMatrixWorld(), this.statistics.requestsInFlight = 0;
    for (const E of this.traversalResult.requested) {
      const d = E.extras.content.request;
      d && d.status === "inflight" && (this.statistics.requestsInFlight += 1);
    }
    const l = s.getCurrentCamera(), u = _MATRIX4_0$2.copy(l.projectionMatrix).multiply(l.matrixWorldInverse);
    if (this.traversalContext.camera = s, this.traversalContext.frustum.setFromProjectionMatrix(u), this.traversalContext.screenSize = e.getSize(this.traversalContext.screenSize), this.traversalContext.requestCancelling = o.options.debug.requestCancelling, this.traversalContext.tileFrustumCulling = o.options.debug.tileFrustumCulling, this.statistics.visitedTiles = 0, this.traverseTiles(this.tileset.root, this.traversalContext), !(this.updateDynamicScreenSpaceError() || this.isFrozen)) {
      this.computeTileSortKeys(this.traversalResult.requested), this.statistics.requestedTiles = this.traversalResult.requested.length, this.statistics.refinedToCompletion = this.statistics.requestedTiles === 0, this.statistics.dynamicScreenSpaceError = this.dynamicScreenSpaceError;
      for (const E of this.traversalResult.requested)
        this.trySpawnTileLoad(E);
      if (o.options.debug.showQueuedRequests || o.options.debug.showRequestsInFlight) {
        let E = -1 / 0, d = 1 / 0;
        for (const f of this.traversalResult.requested)
          ((a = f.extras.content.request) === null || a === void 0 ? void 0 : a.status) !== "inflight" && (E = Math.max(E, f.extras.sortKey), d = Math.min(d, f.extras.sortKey));
        for (const f of this.traversalResult.requested)
          this.handleDrawRequestBoundingVolume(f, o.options.debug, d, E);
      }
      this.clear(), this.statistics.drawCalls = 0, this.statistics.renderedPoints = 0, this.statistics.renderedTriangles = 0, this.statistics.renderedTiles = this.traversalResult.rendered.length;
      for (const E of this.traversalResult.rendered)
        E.extras.content.object && (this.add(E.extras.content.object), this.statistics.renderedPoints += E.extras.cost.pointCount, this.statistics.renderedTriangles += E.extras.cost.triangleCount, E.extras.content.object.traverse((d) => {
          (d instanceof Points || d instanceof Mesh) && (this.statistics.drawCalls += 1);
        }), o.options.debug.tileDebugColoring !== TileDebugColorMode.None && this.handleDrawColorTile(E, o.options.debug.tileDebugColoring), o.options.debug.tileBoundingVolumes && this.handleDrawBoundingVolume(E, o.options.debug, _COLOR_RED));
      this.evictTiles(), this.updateAttribution();
    }
  }
  updateDynamicScreenSpaceError() {
    const e = this.traversalResult.expectedMemoryUsage < this.memoryBudget, s = this.traversalResult.expectedPointCount < this.pointBudget, o = !e || !s;
    return o ? this.dynamicScreenSpaceError *= 1.02 : this.dynamicScreenSpaceError /= 1.02, this.dynamicScreenSpaceError = Math.max(this.dynamicScreenSpaceError, this.maximumScreenSpaceError), o;
  }
  handleDrawRequestBoundingVolume(e, s, o, a) {
    var l;
    if (s.showRequestsInFlight && ((l = e.extras.content.request) === null || l === void 0 ? void 0 : l.status) === "inflight")
      this.handleDrawBoundingVolume(e, s, _COLOR_WHITE);
    else if (s.showQueuedRequests) {
      const u = _COLOR_0, c = MathUtils.clamp(MathUtils.normalize(e.extras.sortKey, o, a), 0, 1);
      c < 0.5 ? u.lerpColors(_COLOR_GREEN, _COLOR_YELLOW, c * 2) : u.lerpColors(_COLOR_YELLOW, _COLOR_RED, (c - 0.5) * 2), e.extras.sortKey === o && u.copy(_COLOR_CYAN), this.handleDrawBoundingVolume(e, s, u);
    }
  }
  handleDrawBoundingVolume(e, s, o) {
    _NUMBER_ARRAY_0.length = 0;
    const a = o.toArray(_NUMBER_ARRAY_0);
    a[0] *= 255, a[1] *= 255, a[2] *= 255, DebugDraw.addBoundingVolume(s, e.boundingVolume, e.extras.transform, this.matrixWorld, a);
  }
  handleDrawColorTile(e, s) {
    e.extras.content.object.traverse((o) => {
      if (o instanceof Points || o instanceof Mesh) {
        const a = o.material;
        s === TileDebugColorMode.Refinement && (e.extras.terminal ? a.color = _COLOR_GREEN : a.color = _COLOR_RED);
      }
    });
  }
  updateAttribution() {
    this.sharedSettings.attributions.length = 0;
    for (const e of this.children)
      if (e instanceof GLTFModel) {
        const s = _SET_0;
        s.clear();
        for (const o of this.sharedSettings.attributions)
          o.html && s.add(o.html);
        for (const o of e.credits)
          s.add(o);
        this.sharedSettings.attributions.length = 0;
        for (const o of s)
          this.sharedSettings.attributions.push({
            html: o
          });
      }
  }
  evictTiles() {
    this.tileCache.evictNodes(() => this.statistics.geometrySizeInBytes + this.statistics.textureSizeInBytes > this.memoryBudget && this.canEvict, (e) => {
      const s = e.extras.content.object;
      s !== void 0 && (this.statistics.geometrySizeInBytes -= s.geometrySizeInBytes, this.statistics.textureSizeInBytes -= s.textureSizeInBytes, this.statistics.loadedTiles -= 1, s.evict(), e.extras.content.cacheNode = void 0, e.extras.content.object = void 0, e.extras.content.request = void 0);
    });
  }
  applyStyle(e) {
    this.updateMatrix(), this.updateMatrixWorld(), this.sharedSettings.styleDesc = Object.assign(Object.assign({}, this.sharedSettings.styleDesc), e);
    for (const s of this.materialRegistry.styleCallbacks)
      s(this.sharedSettings.styleDesc);
  }
  setClippingPlanes(e) {
    for (const s of this.materialRegistry.clippingPlaneCallbacks)
      s(e);
    this.materialRegistry.clippingPlanes = e;
  }
  invalidateMaterials() {
    for (const e of this.materialRegistry.invalidateCallbacks)
      e();
  }
  trySpawnTileLoad(e) {
    const s = e.extras.content, o = s.object === void 0, a = s.request === void 0, l = s.request !== void 0 && s.request.status === "cancelled";
    if (o && (a || l)) {
      const c = new AbortController(), E = () => __awaiter$x(this, void 0, void 0, function* () {
        try {
          yield this.loadTile(e, c.signal);
        } catch (f) {
          console.warn(f);
        }
      }), d = () => {
        c.abort(), s.request = void 0;
      };
      s.request = this.requestManager.queueRequest("tileset", E, e.extras.sortKey, d);
    }
  }
  loadTile(e, s) {
    var o;
    return __awaiter$x(this, void 0, void 0, function* () {
      const a = (o = e.content.uri) !== null && o !== void 0 ? o : e.content.url;
      if (a == null)
        throw new Error("Content missing URI or URL field");
      const l = e.extras.owner.extras.owner.tilesetSource.adjacentResource(a), u = yield FileLoader.loadArrayBuffer(l, {
        headers: this.tilesetSource.bearerToken,
        signal: s
      }), c = new DataView(u);
      if (this.owner === void 0)
        throw new Error("Someone forgot to set the owner for a Tileset3D");
      let E;
      if (PointCloud.isValidHeader(c))
        E = yield PointCloud.create(e, new DataView(u), this.sharedSettings.styleDesc, this.materialRegistry, this.pickingManager, this.owner);
      else if (Batch3DModel.isValidHeader(c))
        E = yield Batch3DModel.create(e, new DataView(u), this.sharedSettings.styleDesc, this.materialRegistry, this.pickingManager, this.owner);
      else if (Instanced3DModel.isValidHeader(c))
        E = yield Instanced3DModel.create(e, new DataView(u), this.sharedSettings.styleDesc, this.materialRegistry, this.pickingManager, this.owner);
      else if (Composite.isValidHeader(c))
        E = yield Composite.create(e, new DataView(u), this.sharedSettings.styleDesc, this.materialRegistry, this.pickingManager, this.owner);
      else if (GLTFModel.isValidHeader(c))
        E = yield GLTFModel.create(e, new DataView(u), this.sharedSettings.styleDesc, this.materialRegistry, this.pickingManager, this.owner);
      else {
        const d = tryParseTileset(u);
        if (d !== null) {
          const f = d;
          f.extras = {
            owner: e.extras.owner.extras.owner,
            source: this.tilesetSource.inherit(l)
          };
          const h = new Tileset3D({
            tileset: f,
            styleDesc: {},
            parent: e,
            pickingManager: this.pickingManager,
            requestManager: this.requestManager
          });
          h.owner = this.owner, E = h;
        } else
          throw new Error("Unsupported tile format");
      }
      return this.applyStyle(this.sharedSettings.styleDesc), E.frustumCulled = !1, E.traverse((d) => d.frustumCulled = !1), e.extras.content.object = E, e.extras.cost.geometrySizeInBytes = E.geometrySizeInBytes, e.extras.cost.textureSizeInBytes = E.textureSizeInBytes, e.extras.cost.triangleCount = E.triangleCount, e.extras.cost.pointCount = E.pointCount, this.statistics.geometrySizeInBytes += E.geometrySizeInBytes, this.statistics.textureSizeInBytes += E.textureSizeInBytes, this.statistics.loadedTiles += 1, E instanceof Tileset3D || (e.extras.content.cacheNode = this.tileCache.add(e)), E;
    });
  }
}
function tryParseTileset(r) {
  try {
    const e = JSON.parse(new TextDecoder().decode(r));
    if (!isTileset(e))
      throw new Error("Response does not match tileset interface");
    return e;
  } catch {
    return null;
  }
}
var __awaiter$w = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIon3DTilesAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   * @param loader
   */
  static fromEndpoint(e, s) {
    return __awaiter$w(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      if (e.type !== "3DTILES")
        throw new Error(`Attempted to create CesiumIon3DTilesAsset from an endpoint of type '${e.type}'`);
      const o = yield FileLoader.loadJson(e.url, {
        headers: {
          Authorization: `Bearer ${e.accessToken}`
        }
      });
      if (!isTileset(o))
        throw new Error("3DTiles asset endpoint gave us invalid data");
      const a = o;
      return a.extras = {
        source: ResourceSource.fromCesiumEndpoint(e)
      }, new CesiumIon3DTilesAsset(a, e.url, e.accessToken, e.attributions);
    });
  }
  createTileset3D(e, s, o, a, l) {
    if (this.tileset !== void 0) {
      const u = this.tileset;
      return this.tileset = void 0, new Tileset3D({
        tileset: u,
        styleDesc: e,
        pickingManager: s,
        requestManager: o,
        maximumScreenSpaceError: a,
        memoryBudget: l
      });
    } else
      throw new Error("Tried to create multiple tileset objects from a single endpoint");
  }
  constructor(e, s, o, a) {
    super(s, o, a);
    const l = new URL(".", s);
    this.urlBase = l.href, this.tileset = e;
  }
}
var __awaiter$v = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonGLTFAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$v(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      return new CesiumIonGLTFAsset(e.url, e.accessToken, e.attributions);
    });
  }
}
function extractTileMapInfo(r, e) {
  const s = findChildElementByName(e, "TileMap");
  if (s === null)
    throw new Error("Missing <TileMap/>");
  verifyTilemapVersion(s), verifySRS(s);
  const o = readOrigin(s), a = readBoundingBox(s), l = readTileFormat(s), u = readTileSets(s);
  return {
    origin: o,
    boundingBox: a,
    tileFormat: l,
    tileSets: u
  };
}
function verifyTilemapVersion(r) {
  const e = r.attributes.getNamedItem("version");
  if (e === null)
    throw new Error("<TileMap/> missing version");
  if (e.textContent === null)
    throw new Error("<TileMap/> missing version");
  if (e.textContent !== "1.0.0")
    throw new Error("Unsupported TMS version");
}
function verifySRS(r) {
  const e = findChildElementByName(r, "SRS");
  if (e === null)
    throw new Error("Missing <SRS/>");
  if (e.textContent === null)
    throw new Error("<SRS/> missing content");
  if (e.textContent !== "EPSG:3857")
    throw new Error(`Unsupported SRS ${e.textContent}`);
}
function readOrigin(r) {
  const e = findChildElementByName(r, "Origin");
  if (e === null)
    throw new Error("Missing <Origin/>");
  const s = e.attributes.getNamedItem("x"), o = e.attributes.getNamedItem("y");
  if (s === null)
    throw new Error("x attribute missing");
  if (o === null)
    throw new Error("y attribute missing");
  if (s.textContent === null)
    throw new Error("x attribute missing content");
  if (o.textContent === null)
    throw new Error("y attribute missing content");
  let a = Number(s.textContent), l = Number(s.textContent);
  if (isNaN(a))
    throw new Error("Failed to parse x");
  if (isNaN(l))
    throw new Error("Failed to parse y");
  return a = MathUtils.degreesToRadians(a), l = MathUtils.degreesToRadians(l), new Cartographic$1(a, l);
}
function readBoundingBox(r) {
  const e = findChildElementByName(r, "BoundingBox");
  if (e === null)
    throw new Error("Missing <BoundingBox/>");
  const s = e.attributes.getNamedItem("minx"), o = e.attributes.getNamedItem("miny"), a = e.attributes.getNamedItem("maxx"), l = e.attributes.getNamedItem("maxy");
  if (s === null)
    throw new Error("minx attribute missing");
  if (o === null)
    throw new Error("miny attribute missing");
  if (a === null)
    throw new Error("maxx attribute missing");
  if (l === null)
    throw new Error("maxy attribute missing");
  if (s.textContent === null)
    throw new Error("minx attribute missing content");
  if (o.textContent === null)
    throw new Error("miny attribute missing content");
  if (a.textContent === null)
    throw new Error("maxx attribute missing content");
  if (l.textContent === null)
    throw new Error("maxy attribute missing content");
  let u = Number(s.textContent), c = Number(o.textContent), E = Number(a.textContent), d = Number(l.textContent);
  if (isNaN(u))
    throw new Error("Failed to parse minX");
  if (isNaN(c))
    throw new Error("Failed to parse minY");
  if (isNaN(E))
    throw new Error("Failed to parse maxX");
  if (isNaN(d))
    throw new Error("Failed to parse maxY");
  return u = MathUtils.degreesToRadians(u), c = MathUtils.degreesToRadians(c), E = MathUtils.degreesToRadians(E), d = MathUtils.degreesToRadians(d), new Rectangle(u, c, E, d);
}
function readTileFormat(r) {
  const e = findChildElementByName(r, "TileFormat");
  if (e === null)
    throw new Error("Missing <TileFormat/>");
  const s = e.attributes.getNamedItem("width"), o = e.attributes.getNamedItem("height"), a = e.attributes.getNamedItem("mime-type"), l = e.attributes.getNamedItem("extension");
  if (s === null)
    throw new Error("width attribute missing");
  if (o === null)
    throw new Error("height attribute missing");
  if (a === null)
    throw new Error("mimeType attribute missing");
  if (l === null)
    throw new Error("extension attribute missing");
  if (s.textContent === null)
    throw new Error("width attribute missing content");
  if (o.textContent === null)
    throw new Error("height attribute missing content");
  if (a.textContent === null)
    throw new Error("mimeType attribute missing content");
  if (l.textContent === null)
    throw new Error("extension attribute missing content");
  const u = Number(s.textContent), c = Number(o.textContent);
  if (isNaN(u))
    throw new Error("Failed to parse width");
  if (isNaN(c))
    throw new Error("Failed to parse height");
  return {
    width: u,
    height: c,
    extension: l.textContent,
    mimeType: a.textContent
  };
}
function readTileSets(r) {
  const e = findChildElementByName(r, "TileSets");
  if (e === null)
    throw new Error("Missing <TileSets/>");
  const s = e.attributes.getNamedItem("profile");
  if (s === null)
    throw new Error("profile attribute missing");
  if (s.textContent === null)
    throw new Error("profile attribute missing content");
  if (s.textContent !== "mercator")
    throw new Error(`Unsupported TileSet profile ${s.textContent}`);
  const o = /* @__PURE__ */ new Map();
  let a = 512, l = 0;
  for (let u = 0; u < e.children.length; u += 1) {
    const c = e.children.item(u);
    if (c === null)
      throw new Error("Failed to get <TileSet/>");
    if (c.tagName !== "TileSet")
      continue;
    const E = c.attributes.getNamedItem("order"), d = c.attributes.getNamedItem("href");
    if (E === null)
      throw new Error("order attribute missing");
    if (d === null)
      throw new Error("href attribute missing");
    if (E.textContent === null)
      throw new Error("order attribute missing content");
    if (d.textContent === null)
      throw new Error("href attribute missing content");
    const f = Number(E.textContent);
    if (isNaN(f))
      throw new Error("Failed to parse order");
    a = Math.min(f, a), l = Math.max(f, l), o.set(f, d.textContent);
  }
  return {
    maxLevel: l,
    minLevel: a,
    zoomHrefMap: o
  };
}
function findChildElementByName(r, e) {
  for (let s = 0; s < r.children.length; s += 1) {
    const o = r.children.item(s);
    if (o !== null && o.tagName === e)
      return o;
  }
  return null;
}
var __awaiter$u = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class TMSImageryProvider extends HTTPImageryProvider {
  constructor(e, s, o) {
    const a = new WebMercatorTilingScheme();
    super(a, o), this.baseUrl = e, this.tileMap = s;
  }
  static create(e) {
    return __awaiter$u(this, void 0, void 0, function* () {
      const s = yield FileLoader.loadDocument(`${e}tilemapresource.xml`, {});
      if (!(s instanceof Document))
        throw new Error("Expected a document from the response");
      const o = extractTileMapInfo(e, s), a = TMSImageryProvider.httpOptionsFromTileMapInfo(o);
      return new TMSImageryProvider(e, o, a);
    });
  }
  resolveTilePath(e, s, o) {
    return __awaiter$u(this, void 0, void 0, function* () {
      s = this._tilingScheme.getNumberOfYTilesAtLevel(o) - 1 - s;
      const l = this.tileMap.tileSets.zoomHrefMap.get(o);
      return `${this.baseUrl}${l}/${e}/${s}.${this.tileMap.tileFormat.extension}`;
    });
  }
  resolveRequestOptions() {
  }
  /**
   * Utility function for extracting an 'HTTPImageryProviderOptions' from a 'TileMapExtraction'
   * @param info
   */
  static httpOptionsFromTileMapInfo(e) {
    return {
      minLevel: e.tileSets.minLevel,
      maxLevel: e.tileSets.maxLevel,
      origin: e.origin,
      boundingBox: e.boundingBox
    };
  }
}
class CesiumIonImageryProvider extends TMSImageryProvider {
  constructor(e, s, o) {
    const a = TMSImageryProvider.httpOptionsFromTileMapInfo(s);
    super(e, s, a), this._authHeader = o.authHeader, this._attributions = o.attributions;
  }
  get attributions() {
    return this._attributions;
  }
  resolveRequestOptions() {
    return {
      headers: {
        Authorization: this._authHeader
      }
    };
  }
}
var __awaiter$t = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonImageryAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$t(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      const s = yield FileLoader.loadDocument(`${e.url}tilemapresource.xml`, {
        headers: {
          Authorization: `Bearer ${e.accessToken}`
        }
      });
      if (!(s instanceof Document))
        throw new Error("Expected a document from the response");
      return new CesiumIonImageryAsset(s, e.url, e.accessToken, e.attributions);
    });
  }
  createImageryProvider() {
    const e = this.url, s = extractTileMapInfo(this.url, this.resource), o = this.tokenHeaderValue, a = this.attributions;
    return new CesiumIonImageryProvider(e, s, {
      authHeader: o,
      attributions: a
    });
  }
  /**
   * Internal pass-through constructor
   * @param resource
   * @param url
   * @param token
   * @param attributions
   * @private
   */
  constructor(e, s, o, a) {
    super(s, o, a), this.resource = e;
  }
}
class BaseTerrainProvider {
  hasDataForTile(e, s, o) {
    const a = this.tilingScheme.getNumberOfXTilesAtLevel(o), l = this.tilingScheme.getNumberOfYTilesAtLevel(o), u = e < 0 || e >= a || s < 0 || s >= l, c = this.tilingScheme.tileXYToRectangle(e, s, o), E = this.region.intersects(c), d = o >= this.minLevel && o <= this.maxLevel;
    return !u && E && d;
  }
  canRefine(e, s, o) {
    return this.hasDataForTile(e, s, o) && o !== this.maxLevel;
  }
}
var __awaiter$s = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class QuantizedMeshTerrainProvider extends BaseTerrainProvider {
  constructor(e, s, o) {
    var a;
    switch (super(), this._urlIndex = 0, this._layer = s, this._attributions = (a = o == null ? void 0 : o.attributions) !== null && a !== void 0 ? a : [], this._bearerToken = (o == null ? void 0 : o.bearerToken) !== void 0 ? `Bearer ${o.bearerToken}` : void 0, this._layer.scheme) {
      case "tms":
        if (this._layer.projection === "EPSG:3857")
          throw new Error("Unsupported scheme/projection pair (tms + EPSG:3857)");
        this._tilingScheme = new GeographicTilingScheme();
        break;
      case "slippyMap":
        if (this._layer.projection === "EPSG:4326")
          throw new Error("Unsupported scheme/projection pair (slippyMap + EPSG:4326)");
        this._tilingScheme = new WebMercatorTilingScheme();
        break;
    }
    if (this._region = Rectangle.MAX, this._tilingScheme.rectangle.intersects(this._region))
      this._region = this._tilingScheme.rectangle.intersection(this._region);
    else
      throw new Error("The requested 'region' does not intersect with 'tilingScheme.rectangle'");
    const l = new Rectangle().fromDegrees(this._layer.bounds[0], this._layer.bounds[1], this._layer.bounds[2], this._layer.bounds[3]).intersection(Rectangle.MAX);
    if (!l.isLegal())
      throw new Error("Terrain layer.json bounds are not legal rectangle");
    if (l.intersects(this._region))
      this._region = l.intersection(this._region);
    else
      throw new Error("The layer bounds do not intersect with the requested 'region'");
    if (!this._layer.version.startsWith("1."))
      throw new Error(`Unsupported terrain layer.json version '${this._layer.version}'`);
    if (this._layer.format !== "quantized-mesh-1.0")
      throw new Error(`Unsupported quantized-mesh format version '${this._layer.format}'`);
    this._partialUrls = this._layer.tiles.map((u) => {
      const c = u.replace("{version}", this._layer.version);
      return `${e}${c}`;
    });
  }
  get tilingScheme() {
    return this._tilingScheme;
  }
  get region() {
    return this._region;
  }
  get attributions() {
    return this._attributions;
  }
  get minLevel() {
    return this._layer.minzoom;
  }
  get maxLevel() {
    return this._layer.maxzoom;
  }
  loadTile(e, s, o) {
    return __awaiter$s(this, void 0, void 0, function* () {
      const a = {
        Accept: "application/vnd.quantized-mesh,application/octet-stream;q=0.9"
      };
      this._bearerToken !== void 0 && (a.Authorization = this._bearerToken), this._urlIndex = ((this._urlIndex | 0) + 1 | 0) % (this._layer.tiles.length | 0);
      let l;
      this._layer.scheme === "tms" ? l = this._tilingScheme.getNumberOfYTilesAtLevel(o) - s - 1 : l = s;
      let u = this._partialUrls[this._urlIndex];
      u = u.replace("{z}", o.toString()), u = u.replace("{x}", e.toString()), u = u.replace("{y}", l.toString());
      const c = yield FileLoader.loadArrayBuffer(u, {
        headers: a
      });
      return [this.loadQuantizedMesh(e, s, o, new DataView(c))];
    });
  }
  loadQuantizedMesh(e, s, o, a) {
    const l = this.readCenter(a), u = this.readHeightRange(a), c = this.readBoundingSphere(a, l);
    this.readHorizonOcclusionPoint(a);
    const [E, d, f, h] = this.calculateVertexDataOffsets(a), S = this.readVertexDataChannel(a, d, E), R = this.readVertexDataChannel(a, f, E), _ = this.readVertexDataChannel(a, h, E), m = E > 65536, L = this.calculateIndexDataOffsets(h, E, m), F = this.readIndexBuffer(a, L, m), W = this.calculateEdgeIndexDataOffsets(L, F.length, m), G = this.readEdgeIndexBuffer(a, W, m), q = this.calculateEdgeIndexDataOffsets(W, G.length, m), fe = this.readEdgeIndexBuffer(a, q, m), _e = this.calculateEdgeIndexDataOffsets(q, fe.length, m), Le = this.readEdgeIndexBuffer(a, _e, m), Fe = this.calculateEdgeIndexDataOffsets(_e, Le.length, m), Ee = this.readEdgeIndexBuffer(a, Fe, m), [Ge, ve] = this.decodeQuantizedVertexData(e, s, o, u, S, R, _, l), te = this.calculateSkirtGeometry(Ge, ve, l, G, fe, Le, Ee), ae = m ? new Uint32BufferAttribute(F, 1, !1) : new Uint16BufferAttribute(F, 1, !1), v = new BufferGeometry();
    return v.boundingSphere = c, v.setAttribute("position", new Float32BufferAttribute(Ge, 3, !1)), v.setAttribute("uv", new Float32BufferAttribute(ve, 2, !1)), v.setIndex(ae), { geometry: v, skirtGeometry: te, midpoint: l };
  }
  /**
   * Reads the tile center from the terrain tile data
   * @param data
   * @private
   */
  readCenter(e) {
    const s = new Vector3$1();
    return s.x = e.getFloat64(HEADER_OFFSET + 0, !0), s.y = e.getFloat64(HEADER_OFFSET + 8, !0), s.z = e.getFloat64(HEADER_OFFSET + 16, !0), s;
  }
  /**
   * Reads the tile height min/max from the terrain tile data
   * @param data
   * @private
   */
  readHeightRange(e) {
    const s = e.getFloat32(HEADER_OFFSET + 24, !0), o = e.getFloat32(HEADER_OFFSET + 28, !0);
    return [s, o];
  }
  /**
   * Reads the bounding sphere information from the terrain tile data
   * @param data
   * @param center
   * @private
   */
  readBoundingSphere(e, s) {
    const o = new Sphere$1();
    return o.center.x = e.getFloat64(HEADER_OFFSET + 32, !0), o.center.y = e.getFloat64(HEADER_OFFSET + 40, !0), o.center.z = e.getFloat64(HEADER_OFFSET + 48, !0), o.radius = e.getFloat64(HEADER_OFFSET + 56, !0), o.center.sub(s), o;
  }
  /**
   * Reads the horizon occlusion point from the terrain tile data
   * @param data
   * @private
   */
  readHorizonOcclusionPoint(e) {
    const s = new Vector3$1();
    return s.x = e.getFloat64(HEADER_OFFSET + 64, !0), s.y = e.getFloat64(HEADER_OFFSET + 72, !0), s.z = e.getFloat64(HEADER_OFFSET + 80, !0), s;
  }
  /**
   * Calculates the vertex count and offsets for each of the vertex data channels
   * @param data
   * @private
   */
  calculateVertexDataOffsets(e) {
    const s = e.getUint32(VTX_DATA_OFFSET + 0, !0), o = VTX_DATA_OFFSET + 4, a = o + 2 * s, l = a + 2 * s;
    return [s, o, a, l];
  }
  /**
   * Handles reading a single vertex data channel, with the given offset and length.
   *
   * Data is expected to be 'zig zag' encoded. This function will decode the encoded values.
   * @param data
   * @param offset
   * @param count
   * @private
   */
  readVertexDataChannel(e, s, o) {
    let a = 0;
    return Array.from({ length: o }, (l, u) => {
      const c = e.getUint16(s + 2 * u, !0);
      return a += zigZagDecode(c), a;
    });
  }
  /**
   * Handles calculating the index data offset.
   *
   * The index data is immediately after the 'height' data, forward aligned to 4 byte alignment.
   * @param heightOffset
   * @param vertexCount
   * @private
   */
  calculateIndexDataOffsets(e, s, o) {
    const a = o ? 4 : 2, l = e + 2 * s, u = (l | 0) % a;
    if (u === 0)
      return l;
    {
      const c = a - u;
      return l + c;
    }
  }
  /**
   * Read and decode the index buffer
   *
   * @param data
   * @param offset
   * @param areIndices32bit
   * @private
   */
  readIndexBuffer(e, s, o) {
    let a;
    o ? a = (c) => e.getUint32(s + 4 + 4 * c, !0) : a = (c) => e.getUint16(s + 4 + 2 * c, !0);
    let l = 0;
    const u = e.getUint32(s, !0);
    return Array.from({ length: u * 3 }, (c, E) => {
      const d = a(E), f = l - d;
      return d === 0 && (l += 1), f;
    });
  }
  /**
   * Calculate the offsets to the edge indices
   *
   * @param indexOffset
   * @param indexCount
   * @returns
   */
  calculateEdgeIndexDataOffsets(e, s, o) {
    const a = o ? 4 : 2, l = a, u = e + 4 + a * s, c = (u | 0) % l;
    if (c === 0)
      return u;
    {
      const E = l - c;
      return u + E;
    }
  }
  /**
   * Read edge indices, which are not zigzag encoded like the triangle indices
   *
   * @param data
   * @param offset
   * @param areIndices32bit
   * @private
   */
  readEdgeIndexBuffer(e, s, o) {
    let a;
    o ? a = (u) => e.getUint32(s + 4 + 4 * u, !0) : a = (u) => e.getUint16(s + 4 + 2 * u, !0);
    const l = e.getUint32(s, !0);
    return Array.from({ length: l }, (u, c) => a(c));
  }
  /**
   * Decodes the quantized vertex data for the given tile. The output buffers are ready to be passed directly to
   * Three.js to be used as the position/uv buffers.
   * @param x
   * @param y
   * @param zoomLevel
   * @param minHeight
   * @param maxHeight
   * @param uBuffer
   * @param vBuffer
   * @param heightBuffer
   * @param center
   * @private
   */
  decodeQuantizedVertexData(e, s, o, [a, l], u, c, E, d) {
    const f = this._tilingScheme.tileXYToRectangle(e, s, o), h = f.width, S = f.height, R = Math.min(u.length, c.length, E.length), _ = Array.from({ length: R * 3 }, () => 0), m = Array.from({ length: R * 2 }, () => 0), L = l - a, F = new Cartographic$1(), W = new Vector3$1();
    for (let G = 0; G < R; G += 1) {
      const q = u[G] / 32767, fe = c[G] / 32767, _e = E[G] / 32767, Le = f.west + h * q, Fe = f.south + S * fe, Ee = a + L * _e;
      F.set(Le, Fe, Ee);
      const Ge = this._tilingScheme.ellipsoid.cartesianForCartographic(F, W).sub(d);
      _[G * 3 + 0] = Ge.x, _[G * 3 + 1] = Ge.y, _[G * 3 + 2] = Ge.z, m[G * 2 + 0] = q, m[G * 2 + 1] = fe;
    }
    return [_, m];
  }
  /**
   * Generate the skirt geometry
   *
   * @param positions Position buffer
   * @param uvs Texel coordinates
   * @param center Center of the terrain mesh in ECEF
   * @param minHeight Lowest point on the tileset
   * @param triangleIndices Triangle index buffer
   * @param edgeIndices Buffers for each set of edge indices (west, south, east, north)
   */
  calculateSkirtGeometry(e, s, o, a, l, u, c) {
    const E = [], d = [], f = [];
    a.sort((m, L) => s[m * 2 + 1] - s[L * 2 + 1]), u.sort((m, L) => s[L * 2 + 1] - s[m * 2 + 1]), l.sort((m, L) => s[L * 2] - s[m * 2]), c.sort((m, L) => s[m * 2] - s[L * 2]);
    const h = [a, l, u, c], S = new Cartographic$1(), R = new Vector3$1();
    for (const m of h) {
      const L = E.length / 3;
      for (const F of m) {
        const W = e[F * 3 + 0], G = e[F * 3 + 1], q = e[F * 3 + 2];
        R.set(W, G, q).add(o), this._tilingScheme.ellipsoid.cartographicForPosition(R, S), S.height -= 1e4;
        const fe = this._tilingScheme.ellipsoid.cartesianForCartographic(S, R).sub(o);
        E.push(W), E.push(G), E.push(q), E.push(fe.x), E.push(fe.y), E.push(fe.z), d.push(s[F * 2 + 0]), d.push(s[F * 2 + 1]), d.push(s[F * 2 + 0]), d.push(s[F * 2 + 1]);
      }
      for (let F = 0; F < m.length * 2 - 3; F++) {
        const W = L + F, G = L + (F + 2), q = W, fe = W + 1, _e = G, Le = G + 1;
        f.push(fe), f.push(q), f.push(Le), f.push(_e), f.push(Le), f.push(q);
      }
    }
    const _ = new BufferGeometry();
    return _.setAttribute("position", new Float32BufferAttribute(E, 3, !1)), _.setAttribute("uv", new Float32BufferAttribute(d, 2, !1)), _.setIndex(f), _;
  }
}
function zigZagDecode(r) {
  return r >> 1 ^ -(r & 1);
}
const HEADER_OFFSET = 0, VTX_DATA_OFFSET = 88;
var __awaiter$r = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonTerrainAsset extends CesiumIonAsset {
  constructor(e, s, o, a) {
    super(e, s, o), this._layer = a;
  }
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$r(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      const s = yield FileLoader.loadJson(`${e.url}layer.json`, {
        headers: {
          Authorization: `Bearer ${e.accessToken}`
        }
      });
      if (!isQuantizedMeshTerrainLayer(s))
        throw new Error("Received invalid 'layer.json' for quantized-mesh terrain");
      return s.attribution === "" && delete s.attribution, s.description === "" && delete s.description, s.name === "" && delete s.name, new CesiumIonTerrainAsset(e.url, e.accessToken, e.attributions, s);
    });
  }
  /**
   * Constructs a new {@link QuantizedMeshTerrainProvider} from this asset.
   */
  createTerrainProvider() {
    return new QuantizedMeshTerrainProvider(this.url, this._layer, {
      attributions: this.attributions,
      bearerToken: this.token
    });
  }
}
function isQuantizedMeshAvailableRegion(r) {
  return !(typeof r != "object" || typeof r.startX != "number" || typeof r.startY != "number" || typeof r.endX != "number" || typeof r.endY != "number");
}
function isQuantizedMeshTerrainLayer(r) {
  if (typeof r != "object" || typeof r.bounds > "u" || !Array.isArray(r.bounds) || r.bounds.length !== 4 || r.bounds.filter((e) => typeof e == "number").length !== r.bounds.length || typeof r.tiles > "u" || !Array.isArray(r.tiles) || r.tiles.filter((e) => typeof e == "string").length !== r.tiles.length || typeof r.available < "u" && !Array.isArray(r.available))
    return !1;
  if (typeof r.available < "u")
    for (const e of r.available) {
      if (!Array.isArray(e))
        return !1;
      for (const s of e)
        if (!isQuantizedMeshAvailableRegion(s))
          return !1;
    }
  return !(typeof r.extensions > "u" || !Array.isArray(r.extensions) || r.extensions.filter((e) => typeof e == "string").length !== r.extensions.length || typeof r.format != "string" || typeof r.minzoom != "number" || typeof r.maxzoom != "number" || typeof r.projection != "string" || r.projection !== "EPSG:4326" && r.projection !== "EPSG:3857" || typeof r.scheme != "string" || r.scheme !== "tms" && r.scheme !== "slippyMap" || typeof r.version != "string" || typeof r.attribution < "u" && typeof r.attribution != "string" || typeof r.bvhlevels < "u" && typeof r.bvhlevels != "number" || typeof r.description < "u" && typeof r.description != "string" || typeof r.metadataAvailability < "u" && typeof r.metadataAvailability != "number" || typeof r.name < "u" && typeof r.name != "string");
}
var __awaiter$q = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonKMLAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$q(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      return new CesiumIonKMLAsset(e.url, e.accessToken, e.attributions);
    });
  }
  loadKml(e, s) {
    return __awaiter$q(this, void 0, void 0, function* () {
      const o = this.url;
      return yield KmlLoader.load(o, {
        glyphCache: e,
        headers: {
          Authorization: this.tokenHeaderValue
        },
        cacheKey: s
      });
    });
  }
}
var __awaiter$p = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonCZMLAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$p(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      return new CesiumIonCZMLAsset(e.url, e.accessToken, e.attributions);
    });
  }
}
var __awaiter$o = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIonGeoJSONAsset extends CesiumIonAsset {
  /**
   *
   * @param endpoint
   */
  static fromEndpoint(e) {
    return __awaiter$o(this, void 0, void 0, function* () {
      if (typeof e.type > "u" || typeof e.url > "u" || typeof e.accessToken > "u")
        throw new Error("CesiumIonAssetEndpoint does not have enough data to load an asset from");
      return new CesiumIonGeoJSONAsset(e.url, e.accessToken, e.attributions);
    });
  }
}
var __awaiter$n = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
function assetFromEndpoint(r) {
  return __awaiter$n(this, void 0, void 0, function* () {
    if (typeof r.type > "u")
      throw new Error("CesiumIonAssetEndpoint does not have enough data to determine endpoint type");
    switch (r.type) {
      case "3DTILES":
        return yield CesiumIon3DTilesAsset.fromEndpoint(r);
      case "GLTF":
        return yield CesiumIonGLTFAsset.fromEndpoint(r);
      case "IMAGERY":
        return yield CesiumIonImageryAsset.fromEndpoint(r);
      case "TERRAIN":
        return yield CesiumIonTerrainAsset.fromEndpoint(r);
      case "KML":
        return yield CesiumIonKMLAsset.fromEndpoint(r);
      case "CZML":
        return yield CesiumIonCZMLAsset.fromEndpoint(r);
      case "GEOJSON":
        return yield CesiumIonGeoJSONAsset.fromEndpoint(r);
      default:
        throw new Error("The endpoint declared an unknown asset type");
    }
  });
}
function isBingMapsAuthenticationResultCode(r) {
  if (typeof r != "string")
    return !1;
  switch (r) {
    case "ValidCredentials":
    case "InvalidCredentials":
    case "CredentialsExpired":
    case "NotAuthorized":
    case "NoCredentials":
    case "None":
      return !0;
    default:
      return !1;
  }
}
function isBingMapsResourceSet(r) {
  if (typeof r != "object" || typeof r.estimatedTotal != "number" || typeof r.resources > "u" || !Array.isArray(r.resources))
    return !1;
  for (const e of r.resources)
    if (typeof e != "object")
      return !1;
  return !0;
}
function isBingMapsCommonResponse(r) {
  if (typeof r != "object" || typeof r.statusCode != "number" || typeof r.statusDescription != "string" || !isBingMapsAuthenticationResultCode(r.authenticationResultCode) || typeof r.traceId != "string" || typeof r.copyright != "string" || typeof r.brandLogoUri != "string" || typeof r.resourceSets > "u" || !Array.isArray(r.resourceSets))
    return !1;
  for (const e of r.resourceSets)
    if (!isBingMapsResourceSet(e))
      return !1;
  if (typeof r.errorDetails < "u") {
    if (!Array.isArray(r.errorDetails))
      return !1;
    for (const e of r.errorDetails)
      if (typeof e != "string")
        return !1;
  }
  return !0;
}
function isBingMapsImageryMetadata(r) {
  if (typeof r != "object" || typeof r.imageUrl > "u" || r.imageUrl !== null && typeof r.imageUrl != "string" || typeof r.imageUrlSubdomains > "u")
    return !1;
  if (r.imageUrlSubdomains !== null) {
    if (!Array.isArray(r.imageUrlSubdomains))
      return !1;
    for (const e of r.imageUrlSubdomains)
      if (typeof e != "string")
        return !1;
  }
  return !(typeof r.imageWidth > "u" || r.imageWidth !== null && typeof r.imageWidth != "number" || typeof r.imageHeight > "u" || r.imageHeight !== null && typeof r.imageHeight != "number" || typeof r.vintageStart > "u" || r.vintageStart !== null && typeof r.vintageStart != "string" || typeof r.vintageEnd > "u" || r.vintageEnd !== null && typeof r.vintageEnd != "string" || typeof r.zoomMin > "u" || typeof r.zoomMin != "number" || typeof r.zoomMax > "u" || typeof r.zoomMax != "number");
}
var __awaiter$m = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class CesiumIon {
  /**
   * Constructs a new CesiumIon connection with the provided access token
   * @param token The cesium access token to use with all network requests
   * @param options
   */
  constructor(e, s) {
    this.token = e, this.tokenHeaderValue = `Bearer ${e}`;
  }
  /**
   * Performs a request against the v1/assets/${assetId} cesium endpoint to get metadata information about the
   * requested asset.
   *
   * This does not return info for actually using the asset.
   *
   * @param assetId The numeric ID of the asset to lookup
   */
  getAssetInfo(e) {
    return __awaiter$m(this, void 0, void 0, function* () {
      const s = yield FileLoader.loadJson(`https://api.cesium.com/v1/assets/${e}`, {
        headers: {
          Authorization: this.tokenHeaderValue
        }
      });
      if (isCesiumIonAssetInfo(s))
        return s;
      throw new Error("CesiumIonAssetInfo response does not match interface");
    });
  }
  /**
   * Performs a request against the v1/assets/${assetId}/endpoint cesium endpoint to get the asset info that is needed
   * to actually use the asset for visualization.
   *
   * This will yield an object that contains a description of the endpoints where the actual asset data will be
   * available from.
   *
   * @param assetId The numeric ID of the asset to lookup.
   */
  getAssetEndpoint(e) {
    return __awaiter$m(this, void 0, void 0, function* () {
      const s = yield FileLoader.loadJson(`https://api.cesium.com/v1/assets/${e}/endpoint`, {
        headers: {
          Authorization: this.tokenHeaderValue
        }
      });
      if (isCesiumIonExternalAssetEndpoint(s))
        return {
          endpoint: s,
          isExternal: !0
        };
      if (isCesiumIonAssetEndpoint(s))
        return {
          endpoint: s,
          isExternal: !1
        };
      throw new Error("AssetEndpoint response does not match interface");
    });
  }
}
function isCesiumIonAssetType(r) {
  if (typeof r != "string")
    return !1;
  switch (r) {
    case "3DTILES":
    case "GLTF":
    case "IMAGERY":
    case "TERRAIN":
    case "KML":
    case "CZML":
    case "GEOJSON":
      return !0;
    default:
      return !1;
  }
}
function isCesiumIonAssetEndpointAttribution(r) {
  return !(typeof r != "object" || r === null || typeof r.html < "u" && typeof r.html != "string" || typeof r.collapsible < "u" && typeof r.collapsible != "boolean");
}
function isCesiumIonAssetEndpoint(r) {
  if (typeof r != "object" || r === null || typeof r.type < "u" && !isCesiumIonAssetType(r.type) || typeof r.url < "u" && typeof r.url != "string" || typeof r.accessToken < "u" && typeof r.accessToken != "string")
    return !1;
  if (Array.isArray(r.attributions)) {
    for (const e of r.attributions)
      if (!isCesiumIonAssetEndpointAttribution(e))
        return !1;
  }
  return !0;
}
function isCesiumIonExternalAssetType(r) {
  if (typeof r != "string")
    return !1;
  switch (r) {
    case "BING":
      return !0;
    default:
      return !1;
  }
}
function isBingMapsOptions(r) {
  return !(typeof r != "object" || r === null || typeof r.url < "u" && typeof r.url != "string" || typeof r.mapStyle < "u" && typeof r.mapStyle != "string" || typeof r.key < "u" && typeof r.key != "string");
}
function isCesiumIonExternalAssetEndpoint(r) {
  if (typeof r != "object" || r === null || typeof r.type < "u" && !isCesiumIonExternalAssetType(r.externalType) || typeof r.type < "u" && !isCesiumIonAssetType(r.type))
    return !1;
  if (Array.isArray(r.attributions)) {
    for (const e of r.attributions)
      if (!isCesiumIonAssetEndpointAttribution(e))
        return !1;
  }
  return !(typeof r.options < "u" && typeof r.options != "object");
}
function isCesiumIonAssetStatus(r) {
  if (typeof r != "string")
    return !1;
  switch (r) {
    case "AWAITING_FILES":
    case "NOT_STARTED":
    case "IN_PROGRESS":
    case "COMPLETE":
    case "ERROR":
    case "DATA_ERROR":
      return !0;
    default:
      return !1;
  }
}
function isCesiumIonAssetInfo(r) {
  return !(typeof r != "object" || r === null || typeof r.id < "u" && typeof r.id != "number" || typeof r.name != "string" || typeof r.description < "u" && typeof r.description != "string" || typeof r.attribution < "u" && typeof r.attribution != "string" || !isCesiumIonAssetType(r.type) || typeof r.bytes < "u" && typeof r.bytes != "number" || typeof r.dateAdded < "u" && typeof r.dateAdded != "string" || !isCesiumIonAssetStatus(r.status) || typeof r.percentComplete < "u" && typeof r.percentComplete != "number" || typeof r.status < "u" && !isCesiumIonAssetStatus(r.status));
}
var __awaiter$l = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class BingMapsImageryProvider extends HTTPImageryProvider {
  constructor(e, s) {
    if (super(new WebMercatorTilingScheme(), {
      minLevel: e.zoomMin,
      maxLevel: e.zoomMax
    }), this._subdomainIndex = 0, e.imageUrl === null || e.imageUrl === void 0)
      throw new Error("No 'imageUrl' in bing maps metadata");
    if (e.imageUrlSubdomains === null || e.imageUrlSubdomains === void 0)
      throw new Error("No 'imageUrlSubdomains' in bing maps metadata");
    this._metadata = e, this._attributions = s, this._partiallyResolvedSubdomains = this._metadata.imageUrlSubdomains.map((o) => {
      const a = this._metadata.imageUrl.replace("{subdomain}", o);
      return a.includes("n=") ? a : `${a}&n=z`;
    });
  }
  get attributions() {
    return this._attributions;
  }
  resolveTilePath(e, s, o) {
    return __awaiter$l(this, void 0, void 0, function* () {
      const a = this._subdomainIndex;
      this._subdomainIndex = (this._subdomainIndex + 1) % this._metadata.imageUrlSubdomains.length;
      const l = tileToQuadKey(e, s, o);
      return this._partiallyResolvedSubdomains[a].replace("{quadkey}", l);
    });
  }
  loadTile(e, s, o) {
    return __awaiter$l(this, void 0, void 0, function* () {
      if (!this.hasDataForTile(e, s, o))
        throw new Error("Requested a tile that does not exist in the dataset bounds");
      let a = null;
      for (; a === null; )
        try {
          const l = yield TextureLoader.load(yield this.resolveTilePath(e, s, o), this.resolveRequestOptions());
          l.colorSpace = SRGBColorSpace, a = {
            texture: l,
            zoomLevel: o,
            x: e,
            y: s
          };
        } catch {
          if (o = o - 1, e = Math.trunc(e / 2), s = Math.trunc(s / 2), o < this.minLevel)
            throw new Error("No tiles available, wtf");
        }
      return [a];
    });
  }
  resolveRequestOptions() {
  }
}
const digits = ["0", "1", "2", "3"];
function tileToQuadKey(r, e, s) {
  let o = "";
  for (let a = s; a > 0; a -= 1) {
    let l = 0;
    const u = 1 << a - 1;
    r & u && l++, e & u && (l++, l++), o += digits[l];
  }
  return o;
}
var __awaiter$k = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class BingMapsImagerySet {
  /**
   * Async function that constructs a new BingMaps instance from the provided CesiumIonExternalAssetEndpoint endpoint
   * @param endpoint
   */
  static fromEndpoint(e) {
    var s;
    return __awaiter$k(this, void 0, void 0, function* () {
      if (typeof e.externalType > "u")
        throw new Error("Missing endpoint.externalType");
      if (typeof e.type > "u")
        throw new Error("Missing endpoint.type");
      if (typeof e.options > "u")
        throw new Error("Missing endpoint.options");
      if (!isBingMapsOptions(e.options))
        throw new Error("endpoint.options is not valid bing maps options");
      if (typeof e.options.url > "u")
        throw new Error("Missing options.url");
      if (typeof e.options.mapStyle > "u")
        throw new Error("Missing options.mapStyle");
      if (typeof e.options.key > "u")
        throw new Error("Missing options.key");
      const o = e.options, a = `${o.url}/REST/V1/Imagery/Metadata/${o.mapStyle}?output=json&include=ImageryProviders&key=${o.key}`, l = yield FileLoader.loadJson(a);
      if (!isBingMapsCommonResponse(l))
        throw new Error("Invalid API response");
      if (l.resourceSets.length === 0)
        throw new Error("No resource sets when there should be 1");
      if (l.resourceSets[0].resources.length === 0)
        throw new Error("No resources when there should be 1");
      const u = l.resourceSets[0].resources[0];
      if (!isBingMapsImageryMetadata(u))
        throw new Error("Invalid ImageryMetadata");
      if (u.imageUrlSubdomains === null)
        throw new Error("ImageryMetadata missing imageUrlSubdomains");
      if (u.imageUrl === null)
        throw new Error("ImageryMetadata missing imageUrl");
      const c = Object.assign({}, u);
      return c.imageUrl && (c.imageUrl = c.imageUrl.replace("http://", "https://")), new BingMapsImagerySet(c, e.options.url, e.options.mapStyle, e.options.key, (s = e.attributions) !== null && s !== void 0 ? s : []);
    });
  }
  /**
   *
   */
  createImageryProvider() {
    return new BingMapsImageryProvider(this.metadata, this.attributions);
  }
  constructor(e, s, o, a, l) {
    this.metadata = e, this.url = s, this.mapStyle = o, this.key = a, this.attributions = l;
  }
}
var __awaiter$j = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class OpenStreetMapImageryProvider extends HTTPImageryProvider {
  constructor() {
    super(new WebMercatorTilingScheme(), {
      minLevel: 0,
      maxLevel: 19
    }), this.urlIndex = 0, this.baseUrls = [
      "https://a.tile.openstreetmap.org/",
      "https://b.tile.openstreetmap.org/",
      "https://c.tile.openstreetmap.org/"
    ];
  }
  resolveTilePath(e, s, o) {
    return __awaiter$j(this, void 0, void 0, function* () {
      const a = this.urlIndex;
      return this.urlIndex = (this.urlIndex + 1) % this.baseUrls.length, `${this.baseUrls[a]}${o}/${e}/${s}.png`;
    });
  }
  resolveRequestOptions() {
  }
}
class EllipsoidTessellator {
  constructor(e) {
    this.tilingScheme = e;
  }
  /**
   * Will tessellate a patch of a spheroid based on the provided aspect ratio, number of subdivisions, and a set of
   * bounds in longitude/latitude.
   *
   * @param rectangle The cartographic region to produce a geometry patch for
   * @param numSubdivisions A vector that encodes the number of subdivisions to use along the longitudinal and
   *                     latitudinal axis in the x and y components respectively.
   */
  tessellateCartographicSection(e, s) {
    const o = Math.trunc(s.x), a = Math.trunc(s.y), l = EllipsoidTessellator.vertexCountFor(o, a), u = EllipsoidTessellator.indexCountFor(o, a), c = Array.from({ length: l * 3 }, () => 0), E = Array.from({ length: l * 3 }, () => 0), d = Array.from({ length: l * 2 }, () => 0), f = Array.from({ length: u }, () => 0);
    assert(o >= 2, "subdivisions.x >= 2"), assert(a >= 2, "subdivisions.y >= 2"), assert(c.length >= l * 3, "positions.length >= vertexCount * 3"), assert(d.length >= l * 2, "uvs.length >= vertexCount * 2"), assert(f.length >= u, "indices.length >= indexCount");
    const h = this.tilingScheme.projection.project(e.southwest).setZ(0), R = this.tilingScheme.projection.project(e.northeast).setZ(1).sub(h), _ = e.height / (a - 1), m = e.width / (o - 1), L = new Vector3$1(0, 0, 0), F = new Vector3$1(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE), W = new Vector3$1(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), G = new Cartographic$1(), q = new Vector3$1(), fe = new Vector3$1(), _e = new Vector3$1();
    for (let Fe = 0; Fe < a; Fe += 1) {
      G.setLatitude(e.south + _ * Fe);
      for (let Ee = 0; Ee < o; Ee += 1) {
        G.setLongitude(e.west + m * Ee);
        const Ge = Ee * a * 3, ve = Ee * a * 2;
        this.tilingScheme.ellipsoid.cartesianForCartographic(G, q), c[Fe * 3 + Ge] = q.x, c[Fe * 3 + 1 + Ge] = q.y, c[Fe * 3 + 2 + Ge] = q.z, L.x += q.x, L.y += q.y, L.z += q.z, q.x > F.x && (F.x = q.x), q.y > F.y && (F.y = q.y), q.z > F.z && (F.z = q.z), q.x < W.x && (W.x = q.x), q.y < W.y && (W.y = q.y), q.z < W.z && (W.z = q.z), this.tilingScheme.ellipsoid.geodeticSurfaceNormalForCartographic(G, fe), E[Fe * 3 + Ge] = fe.x, E[Fe * 3 + 1 + Ge] = fe.y, E[Fe * 3 + 2 + Ge] = fe.z;
        const te = this.tilingScheme.projection.project(G, _e).sub(h).divide(R);
        d[Fe * 2 + ve] = te.x, d[Fe * 2 + 1 + ve] = te.y;
      }
    }
    L.divideScalar(l);
    for (let Fe = 0; Fe < l; Fe += 1)
      c[Fe * 3] = c[Fe * 3] - L.x, c[Fe * 3 + 1] = c[Fe * 3 + 1] - L.y, c[Fe * 3 + 2] = c[Fe * 3 + 2] - L.z;
    const Le = F.sub(W).length() / 2;
    for (let Fe = 0; Fe < o - 1; Fe += 1) {
      const Ee = a * Fe;
      for (let Ge = 0; Ge < a - 1; Ge += 1) {
        const ve = Ge * 2 * 3 + a * 6 * Fe, te = ve + 0, ae = ve + 1, v = ve + 2;
        f[te] = Ee + Ge, f[ae] = Ee + Ge + a, f[v] = Ee + Ge + 1, f[te + 3] = Ee + Ge + a, f[ae + 3] = Ee + Ge + a + 1, f[v + 3] = Ee + Ge + 1;
      }
    }
    return {
      positions: c,
      normals: E,
      uvs: d,
      indices: f,
      midpoint: L,
      radius: Le
    };
  }
  /**
   * Returns the number of vertices that will be emitted by a tessellation of a spheroid given the number of
   * subdivisions along each axis.
   *
   * This allows pre-allocating buffers for the vertex attribute buffers.
   * @param nLat Number of subdivisions along the latitudinal axis
   * @param nLong Number of subdivisions along the longitudinal axis
   */
  static vertexCountFor(e, s) {
    return e * s;
  }
  /**
   * Returns the number of vertex indices that will be emitted by a tessellation of a spheroid given the number of
   * subdivisions along each axis.
   *
   * This allows pre-allocating space for the index buffer.
   * @param nLat Number of subdivisions along the latitudinal axis
   * @param nLong Number of subdivisions along the longitudinal axis
   */
  static indexCountFor(e, s) {
    return this.triangleCountFor(e, s) * 3;
  }
  /**
   * Returns the number of triangles that will be emitted by a tessellation of a spheroid given the number of
   * subdivisions along each axis.
   *
   * This is used for deducing the number of indices that will be emitted but may have other uses.
   * @param nLat Number of subdivisions along the latitudinal axis
   * @param nLong Number of subdivisions along the longitudinal axis
   */
  static triangleCountFor(e, s) {
    return (e - 1) * 2 * (s - 1);
  }
}
var __awaiter$i = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class TessellatorTerrainProvider extends BaseTerrainProvider {
  constructor(e, s) {
    var o, a, l, u, c;
    super(), this._tilingScheme = e, this._tessellator = new EllipsoidTessellator(e), this._subdivisions = new Vector2((a = (o = s == null ? void 0 : s.subdivisions) === null || o === void 0 ? void 0 : o.longitude) !== null && a !== void 0 ? a : 16, (u = (l = s == null ? void 0 : s.subdivisions) === null || l === void 0 ? void 0 : l.latitude) !== null && u !== void 0 ? u : 12);
    const E = (c = s == null ? void 0 : s.region) !== null && c !== void 0 ? c : Rectangle.MAX;
    if (this._tilingScheme.rectangle.intersects(E))
      this._region = this._tilingScheme.rectangle.intersection(E);
    else
      throw new Error("The requested 'region' does not intersect with 'tilingScheme.rectangle'");
  }
  get tilingScheme() {
    return this._tilingScheme;
  }
  get region() {
    return this._region;
  }
  get attributions() {
    return [];
  }
  get minLevel() {
    return 0;
  }
  get maxLevel() {
    return 32;
  }
  loadTile(e, s, o) {
    return __awaiter$i(this, void 0, void 0, function* () {
      const a = this.tilingScheme.tileXYToRectangle(e, s, o), l = this._tessellator.tessellateCartographicSection(a, this._subdivisions), u = new Float32Array(l.positions), c = new Float32Array(l.normals), E = new Float32Array(l.uvs), d = new Int16Array(l.indices), f = new BufferGeometry();
      f.setAttribute("position", new BufferAttribute(u, 3)), f.setAttribute("normal", new BufferAttribute(c, 3)), f.setAttribute("uv", new BufferAttribute(E, 2)), f.setIndex(new Uint16BufferAttribute(d, 1)), f.computeBoundingSphere();
      const h = new BufferGeometry();
      return [{ geometry: f, skirtGeometry: h, midpoint: l.midpoint }];
    });
  }
}
var __awaiter$h = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class LayeredTerrainProvider extends BaseTerrainProvider {
  constructor(e) {
    if (super(), this.layers = [...e], this.layers.length === 0)
      throw new Error("Created a LayeredTerrainProvider with 0 layers");
    this._tilingScheme = this.layers[0].tilingScheme, this.layers.forEach((a) => {
      if (a.tilingScheme.constructor !== this._tilingScheme.constructor)
        throw new Error("All layers in LayeredTerrainProvider must use the same tiling scheme");
    }), this._minLevel = Math.min(...this.layers.map((a) => a.minLevel)), this._maxLevel = Math.max(...this.layers.map((a) => a.maxLevel));
    const o = this.layers.map((a) => a.region).reduce((a, l, u) => a.union(l, a), new Rectangle()).intersection(this._tilingScheme.rectangle);
    if (!o.isLegal())
      throw new Error("Layered region is not legal, invalid layer rectangles received");
    this._region = o;
  }
  get tilingScheme() {
    return this._tilingScheme;
  }
  get region() {
    return this._region;
  }
  get attributions() {
    return this.layers.flatMap((e) => e.attributions);
  }
  get minLevel() {
    return this._minLevel;
  }
  get maxLevel() {
    return this._maxLevel;
  }
  loadTile(e, s, o) {
    return __awaiter$h(this, void 0, void 0, function* () {
      const a = [];
      for (const c of this.layers)
        a.push(c.loadTile(e, s, o));
      const l = yield Promise.allSettled(a), u = [];
      for (const c of l)
        c.status === "fulfilled" && u.push(...c.value);
      return u;
    });
  }
  hasDataForTile(e, s, o) {
    for (const a of this.layers)
      if (a.hasDataForTile(e, s, o))
        return !0;
    return !1;
  }
  canRefine(e, s, o) {
    for (const a of this.layers)
      if (a.canRefine(e, s, o))
        return !0;
    return !1;
  }
}
var __awaiter$g = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class GoogleImageryProvider extends HTTPImageryProvider {
  constructor(e) {
    super(new WebMercatorTilingScheme(), {
      minLevel: 0,
      maxLevel: 19
    }), this.google = e;
  }
  resolveTilePath(e, s, o) {
    return __awaiter$g(this, void 0, void 0, function* () {
      const a = yield this.google.getMapSession();
      return `https://tile.googleapis.com/v1/2dtiles/${o}/${e}/${s}?session=${a.session}&key=${this.google.token}`;
    });
  }
  resolveRequestOptions() {
  }
}
var __awaiter$f = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class AzureImageryProvider extends HTTPImageryProvider {
  constructor(e) {
    super(new WebMercatorTilingScheme(), {
      minLevel: 0,
      maxLevel: 19
    }), this.azure = e;
  }
  resolveTilePath(e, s, o) {
    return __awaiter$f(this, void 0, void 0, function* () {
      const a = "microsoft.imagery";
      return `https://atlas.microsoft.com/map/tile?subscription-key=${this.azure.token}&api-version=2024-04-01&tilesetId=${a}&zoom=${o}&x=${e}&y=${s}`;
    });
  }
  resolveRequestOptions() {
  }
}
var __awaiter$e = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class MapboxImageryProvider extends HTTPImageryProvider {
  constructor(e, s) {
    super(new WebMercatorTilingScheme(), {
      minLevel: 0,
      maxLevel: 19
    }), this.mapbox = e, this._attributions = s;
  }
  resolveTilePath(e, s, o) {
    return __awaiter$e(this, void 0, void 0, function* () {
      return `https://api.mapbox.com/v4/mapbox.satellite/${o}/${e}/${s}@2x.jpg?access_token=${this.mapbox.token}`;
    });
  }
  resolveRequestOptions() {
  }
  get attributions() {
    return this._attributions;
  }
}
var __awaiter$d = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Globe {
  constructor(e) {
    this.visible = !0, this.newLayers = null, this.imageryBounds = [], this.terrainBounds = [], this._imageryProviders = [], this._terrainProviders = [], this._tileBudget = 1024, this.renderer = e;
  }
  getImageryBounds() {
    return this.imageryBounds;
  }
  getTerrainBounds() {
    return this.terrainBounds;
  }
  getVisible() {
    return this.visible;
  }
  setVisible(e) {
    this.visible = e;
  }
  get attributions() {
    var e, s;
    return (s = (e = this.inner) === null || e === void 0 ? void 0 : e.attributions) !== null && s !== void 0 ? s : [];
  }
  get tileBudget() {
    return this._tileBudget;
  }
  set tileBudget(e) {
    this._tileBudget = e, this.inner !== void 0 && (this.inner.tileBudget = e);
  }
  setTileLayers(e, s = []) {
    const o = () => __awaiter$d(this, void 0, void 0, function* () {
      const a = [];
      for (const u of s)
        switch (u.type) {
          case "cesium": {
            const c = yield this.cesium.getAssetEndpoint(u.assetId);
            if (c.isExternal)
              throw new Error();
            const E = yield assetFromEndpoint(c.endpoint);
            if (!(E instanceof CesiumIonTerrainAsset))
              throw new Error();
            a.push(E.createTerrainProvider());
            break;
          }
          default:
            throw new Error("Unreachable");
        }
      const l = [];
      for (const u of e)
        switch (u.type) {
          case "osm": {
            l.push(new OpenStreetMapImageryProvider());
            break;
          }
          case "tms": {
            l.push(yield TMSImageryProvider.create(u.url));
            break;
          }
          case "cesium": {
            if (this.cesium !== null) {
              const c = yield this.cesium.getAssetEndpoint(u.assetId);
              if (c.isExternal)
                throw new Error();
              const E = yield assetFromEndpoint(c.endpoint);
              if (!(E instanceof CesiumIonImageryAsset))
                throw new Error();
              l.push(E.createImageryProvider());
            }
            break;
          }
          case "bing": {
            const c = bingMapsTypeToId(u.mapType), E = yield this.cesium.getAssetEndpoint(c);
            if (!E.isExternal)
              throw new Error();
            const d = yield BingMapsImagerySet.fromEndpoint(E.endpoint);
            l.push(d.createImageryProvider());
            break;
          }
          case "google": {
            l.push(new GoogleImageryProvider(this.google));
            break;
          }
          case "azure": {
            l.push(new AzureImageryProvider(this.azure));
            break;
          }
          case "mapbox": {
            const c = yield this.mapbox.fetchAttributions("mapbox.satellite");
            l.push(new MapboxImageryProvider(this.mapbox, c));
            break;
          }
          default:
            throw new Error("Unreachable");
        }
      return this._imageryProviders = [...e], this._terrainProviders = [...s], [l, a];
    });
    return new Promise((a, l) => {
      o().then(([u, c]) => {
        this.newLayers = {
          imageryLayers: u,
          terrainLayers: c,
          resolve: a
        };
      }, l);
    });
  }
  getTerrainHeight(e) {
    if (this.inner === void 0)
      return 0;
    const s = new Cartographic$1(e.longitude, e.latitude, 0);
    return this.inner.getTerrainHeight(s);
  }
  getImageryLayers() {
    return this._imageryProviders;
  }
  getTerrainLayers() {
    return this._terrainProviders;
  }
  /**
   * Function that should be called once per frame prior to rendering to check if a new set of imagery layers has
   * been provided and we should replace the old globe.
   */
  checkLayers() {
    if (this.newLayers !== null) {
      this.imageryBounds.length = 0, this.newLayers.imageryLayers.forEach((o) => {
        this.imageryBounds.push({
          min: o.region.southwest,
          max: o.region.northeast
        });
      }), this.terrainBounds.length = 0, this.newLayers.terrainLayers.forEach((o) => {
        this.terrainBounds.push({
          min: o.region.southwest,
          max: o.region.northeast
        });
      });
      const e = new LayeredImageryProvider(this.newLayers.imageryLayers);
      let s;
      this.newLayers.terrainLayers.length === 0 ? s = new TessellatorTerrainProvider(new WebMercatorTilingScheme()) : s = new LayeredTerrainProvider(this.newLayers.terrainLayers), this.inner = new Globe$1(s, e, this.renderer.tileCompositorPass, this.renderer.requestManager), this.inner.tileBudget = this._tileBudget, this.newLayers.resolve(), this.newLayers = null;
    }
  }
}
function bingMapsTypeToId(r) {
  switch (r) {
    case "aerial":
      return 2;
    case "aerialWithLabels":
      return 3;
    case "road":
      return 4;
    default:
      throw new Error("unreachable");
  }
}
function copyPositionToBufferGeometry(r, e) {
  const s = new Float32Array(3 * e.length);
  for (let o = 0; o < e.length; o += 1)
    s[o * 3 + 0] = e[o].x, s[o * 3 + 1] = e[o].y, s[o * 3 + 2] = e[o].z;
  r.setAttribute("position", new Float32BufferAttribute(s, 3));
}
function copyColorToBufferGeometry(r, e) {
  const s = new Uint8Array(3 * e.length);
  for (let o = 0; o < e.length; o += 1)
    s[o * 3 + 0] = e[o].r * 255, s[o * 3 + 1] = e[o].g * 255, s[o * 3 + 2] = e[o].b * 255;
  r.setAttribute("color", new Uint8BufferAttribute(s, 3, !0));
}
function copyUVToBufferGeometry(r, e) {
  const s = new Float32Array(2 * e.length);
  for (let o = 0; o < e.length; o += 1)
    s[o * 2 + 0] = e[o].x, s[o * 2 + 1] = e[o].y;
  r.setAttribute("uv", new Float32BufferAttribute(s, 2));
}
function copyUserIdToBufferGeometry(r, e) {
  const s = new Uint32Array(e);
  r.setAttribute("pickingUserId", new Uint32BufferAttribute(s, 1, !1));
}
function copyIndicesToBufferGeometry(r, e) {
  const s = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o += 1)
    s[o] = e[o];
  r.setIndex(new Uint32BufferAttribute(s, 1));
}
class IndexedTriangleMesh {
  constructor() {
    this.vertices = [], this.indices = [], this.geometry = new BufferGeometry();
  }
  resolve() {
    copyPositionToBufferGeometry(this.geometry, this.vertices), copyIndicesToBufferGeometry(this.geometry, this.indices), typeof this.color < "u" && copyColorToBufferGeometry(this.geometry, this.color), typeof this.uv < "u" && copyUVToBufferGeometry(this.geometry, this.uv), typeof this.pickingUserId < "u" && copyUserIdToBufferGeometry(this.geometry, this.pickingUserId), this.geometry.computeBoundingSphere();
  }
}
class LineMesh {
  constructor() {
    this.vertices = [], this.geometry = new BufferGeometry();
  }
  resolve() {
    copyPositionToBufferGeometry(this.geometry, this.vertices), typeof this.color < "u" && copyColorToBufferGeometry(this.geometry, this.color), typeof this.pickingUserId < "u" && copyUserIdToBufferGeometry(this.geometry, this.pickingUserId), this.geometry.computeBoundingSphere();
  }
}
class LineStripMesh {
  constructor() {
    this.vertices = [], this.geometry = new BufferGeometry();
  }
  resolve() {
    copyPositionToBufferGeometry(this.geometry, this.vertices), typeof this.color < "u" && copyColorToBufferGeometry(this.geometry, this.color), typeof this.pickingUserId < "u" && copyUserIdToBufferGeometry(this.geometry, this.pickingUserId), this.geometry.computeBoundingSphere();
  }
}
class FontAsset extends IFontAsset {
  constructor(e, s, o) {
    super(), this.loadedFont = e, this.cache = new GlyphCache(this.loadedFont.font, s, o);
  }
}
class InstancedMeshObject extends PrimitiveObject {
  constructor(e, s, o, a, l, u, c, E, d) {
    super(e), this.object = e, this.id = s, this.mesh = d, this.pickingManager = E, this.maxInstances = Math.min(o.length, a.length), this.objectData = c, this.positions = o, this.rotations = a, this.scales = l, this._colors = u, this.resolve();
  }
  get colors() {
    return this._colors;
  }
  set colors(e) {
    this._colors === void 0 !== (e === void 0) && (this.object.material.needsUpdate = !0), this._colors = e;
  }
  getBoundingVolume() {
    const e = new Box3$1().setFromObject(this.object), s = e.getBoundingSphere(new Sphere$1(e.getCenter(new Vector3$1())));
    return [s.center.x, s.center.y, s.center.z, s.radius];
  }
  constructMaterial(e) {
    const s = this.object.material;
    this.object.material = constructMeshThreeMaterial(e, s.clippingPlanes, this.id, !1, !0);
  }
  getObjectType() {
    return WorldObjectType.InstancedMesh;
  }
  get isTransparent() {
    return this.object.material.opacity < 1 && this.object.material.transparent;
  }
  resolve() {
    this.updateMatrices(this.positions, this.rotations, this.scales, this.colors);
  }
  /**
   * @param positions
   * @param rotations
   * @param scales
   * @param colors
   */
  updateMatrices(e, s, o, a) {
    const l = new Matrix4(), u = new Matrix4(), c = new Matrix4(), E = new Color(), d = new Quaternion$1();
    let f = Math.min(e.length, s.length, o.length);
    if (a !== void 0 && (f = Math.min(f, a.length)), f > this.maxInstances) {
      const h = this.object;
      this.object.dispose(), this.object = new InstancedMesh(h.geometry, h.material, f), this.pickingManager.setIdForObject(this.object.id, this.id), this.maxInstances = f, this.object.position.copy(h.position), this.object.quaternion.copy(h.quaternion), this.object.scale.copy(h.scale), this.object.up.copy(h.up);
    } else
      this.object.count = f, this.object.instanceMatrix.needsUpdate = !0, this.object.instanceColor && (this.object.instanceColor.needsUpdate = !0);
    for (let h = 0; h < f; h += 1)
      l.makeTranslation(e[h].x, e[h].y, e[h].z), d.fromArray([s[h].x, s[h].y, s[h].z, s[h].w]), u.makeRotationFromQuaternion(d), c.makeScale(o[h].x, o[h].y, o[h].z), l.multiply(u).multiply(c), this.object.setMatrixAt(h, l), a !== void 0 && this.object.setColorAt(h, E.setRGB(a[h].r, a[h].g, a[h].b));
    this.object.instanceMatrix.needsUpdate = !0, this.object.instanceColor && (this.object.instanceColor.needsUpdate = !0), this.object.computeBoundingSphere();
  }
}
class KmlObject extends DrawableObject {
  constructor(e, s, o) {
    super(e), this._opacity = 1, this.object = e, this.id = o, this._labelPositions = s;
  }
  get opacity() {
    return this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this._opacity < 1 ? this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof Line$1) {
        const o = s.material;
        o.opacity = e, o.transparent = !0, o.depthWrite = !1, o.needsUpdate = !0;
      }
      s instanceof LabelCollection && (s.opacity = e);
    }) : this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof Line$1) {
        const o = s.material;
        o.opacity = 1, o.transparent = !1, o.depthWrite = !0, o.needsUpdate = !0;
      }
      s instanceof LabelCollection && (s.opacity = 1);
    });
  }
  get isTransparent() {
    return this._opacity < 1;
  }
  setClippingPlanes(e) {
    this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof Line$1)
        if (Array.isArray(s.material))
          for (const o of s.material)
            o.clippingPlanes = e, o.needsUpdate = !0;
        else
          s.material.clippingPlanes = e, s.material.needsUpdate = !0;
    });
  }
  invalidateMaterials() {
    this.object.traverse((e) => {
      if (e instanceof Mesh)
        if (Array.isArray(e.material))
          for (const s of e.material)
            s.needsUpdate = !0;
        else
          e.material.needsUpdate = !0;
    });
  }
  getBoundingVolume() {
    const e = new Box3$1().setFromObject(this.object);
    for (const o of this._labelPositions)
      e.expandByPoint(o);
    const s = e.getBoundingSphere(new Sphere$1(e.getCenter(new Vector3$1())));
    return [s.center.x, s.center.y, s.center.z, s.radius];
  }
  getEstimatedCenter(e) {
    const s = this.getBoundingVolume();
    return e !== void 0 ? (e.x = s[0], e.y = s[1], e.z = s[2], e) : {
      x: s[0],
      y: s[1],
      z: s[2]
    };
  }
  asBlendableObject() {
    return this;
  }
  getObjectType() {
    return WorldObjectType.KmlObject;
  }
}
class LabelCollectionObject extends DrawableObject {
  constructor(e, s) {
    super(e), this.object = e, this.id = s;
  }
  get labels() {
    return this.object.labels;
  }
  get maxLabelNum() {
    return this.object.maxLabelNum;
  }
  get needsRebuild() {
    return this.object.needsUpdate;
  }
  invalidateCaches() {
    this.object.needsUpdate = !0;
  }
  forceRebuild() {
    this.object.prepare();
  }
  getObjectType() {
    return WorldObjectType.LabelCollection;
  }
  get isTransparent() {
    return !0;
  }
}
class SpriteObject extends PrimitiveObject {
  constructor(e, s, o) {
    super(e), this.object = e, this.id = s, this.pickingUserId = o;
  }
  getBoundingVolume() {
    if (this.object.updateMatrix(), this.object.geometry.boundingSphere === null)
      throw new Error("Mesh bounding sphere not generated. This is an internal bug.");
    const e = this.object.geometry.boundingSphere.clone().applyMatrix4(this.object.matrix);
    return [e.center.x, e.center.y, e.center.z, e.radius];
  }
  getObjectType() {
    return WorldObjectType.SpriteObject;
  }
  constructMaterial(e) {
    switch (e.type) {
      case "basicOpaque":
      case "basicAlpha":
        this.object.material.color.r = e.color.r, this.object.material.color.g = e.color.g, this.object.material.color.b = e.color.b, this.object.material.needsUpdate = !0;
        break;
      case "physicalOpaque":
      case "physicalAlpha":
        this.object.material.color.r = e.baseColor.r, this.object.material.color.g = e.baseColor.g, this.object.material.color.b = e.baseColor.b, this.object.material.needsUpdate = !0;
        break;
    }
  }
}
class PointMesh {
  constructor() {
    this.points = [], this.geometry = new BufferGeometry();
  }
  resolve() {
    copyPositionToBufferGeometry(this.geometry, this.points), typeof this.color < "u" && copyColorToBufferGeometry(this.geometry, this.color), typeof this.pickingUserId < "u" && copyUserIdToBufferGeometry(this.geometry, this.pickingUserId), this.geometry.computeBoundingSphere();
  }
}
class Ifc3D extends Group {
  constructor(e) {
    super(), this.ifcApi = e.ifcApi, this.modelId = e.modelId, this.objectId = e.objectId, this.geometry = e.mesh.geometry, this.coordinationMatrix = e.mesh.matrix, this.elementGroups = e.rangeGroups, this.defaultGroups = this.geometry.groups.map((s) => {
      const { start: o, count: a, materialIndex: l } = s, u = e.mesh.material[l];
      return { start: o, count: a, threeMaterial: u };
    }), this.pickingManager = e.pickingManager, this.groups = this.defaultGroups.map((s) => Object.assign({}, s)), this.materialSet = /* @__PURE__ */ new Map(), this.elementMaterials = /* @__PURE__ */ new Map(), this.recycledMeshes = [], this.linesById = /* @__PURE__ */ new Map(), this.elementIdsByType = /* @__PURE__ */ new Map();
  }
  findContainingGroup(e) {
    let s = 0, o = this.groups.length - 1;
    for (; s <= o; ) {
      const a = Math.floor((s + o) / 2), l = this.groups[a], u = l.start, c = l.start + l.count - 1;
      if (e < u)
        o = a - 1;
      else if (e > c)
        s = a + 1;
      else
        return a;
    }
    return s;
  }
  insertGeometryGroup(e, s) {
    const o = this.elementGroups.get(e);
    if (o === void 0)
      return;
    for (const l of o) {
      const u = this.findContainingGroup(l.start), c = this.findContainingGroup(l.start + l.count - 1), E = this.groups[u], d = this.groups[c], f = {
        start: l.start,
        count: l.count,
        threeMaterial: s
      };
      if (u === c) {
        if (E.threeMaterial !== s) {
          const h = {
            start: E.start,
            count: l.start - E.start,
            threeMaterial: E.threeMaterial
          }, S = {
            start: l.start + l.count,
            count: E.start + E.count - (l.start + l.count),
            threeMaterial: E.threeMaterial
          };
          h.count > 0 && S.count > 0 ? this.groups.splice(u, 1, h, f, S) : h.count > 0 ? this.groups.splice(u, 1, h, f) : S.count > 0 ? this.groups.splice(u, 1, f, S) : this.groups.splice(u, 1, f);
        }
      } else {
        E.count = l.start - E.start;
        const h = l.start + l.count;
        d.count = d.start + d.count - h, d.start = h, E.count > 0 && d.count > 0 ? this.groups.splice(u + 1, c - u - 1, f) : d.count > 0 ? this.groups.splice(u, c - u, f) : E.count > 0 ? this.groups.splice(u + 1, c - u, f) : this.groups.splice(u, c - u + 1, f);
      }
    }
    let a = 0;
    for (let l = this.groups.length - 1; l >= 1; l--) {
      const u = this.groups[l], c = this.groups[l - 1];
      u.threeMaterial === c.threeMaterial ? (a++, c.count += u.count) : (this.groups.splice(l + 1, a), a = 0);
    }
    this.groups.splice(1, a);
  }
  getThreeMaterial(e) {
    const s = JSON.stringify(e);
    let o = this.materialSet.get(s);
    return o === void 0 && (o = constructMeshThreeMaterial(e, [], this.objectId, !0, !1), o.transparent = o.opacity < 1, o.depthWrite = !o.transparent, o.forceSinglePass = !0, o.side = DoubleSide, this.materialSet.set(s, o)), o;
  }
  clear() {
    this.pickingManager.removeForId(this.objectId);
    for (const e of this.children)
      this.pickingManager.removeForObject(e.id), this.recycledMeshes.push(e);
    return super.clear();
  }
  buildMeshes() {
    if (this.owner === void 0)
      throw new Error("Someone forgot to set the owner for a Tileset3D");
    this.clear();
    for (const e of this.groups) {
      if (!e.threeMaterial)
        continue;
      let s = this.recycledMeshes.pop();
      s === void 0 && (s = new Mesh(void 0, e.threeMaterial), s.geometry.attributes = this.geometry.attributes, s.geometry.index = this.geometry.index, s.geometry.boundsTree = this.geometry.boundsTree, s.geometry.boundingSphere = this.geometry.boundingSphere, this.coordinationMatrix.decompose(s.position, s.quaternion, s.scale), s.updateMatrix()), s.geometry.setDrawRange(e.start, e.count), s.material = e.threeMaterial, this.pickingManager.setForId(this.objectId, {
        objectType: ObjectType.Composite,
        rootObject: this.owner,
        subObject: s
      }), this.pickingManager.setIdForObject(s.id, this.objectId), this.add(s);
    }
  }
  refreshGroups() {
    this.groups = this.defaultGroups.map((e) => Object.assign({}, e));
    for (const [e, s] of this.elementMaterials)
      if (s) {
        const o = this.getThreeMaterial(s);
        this.insertGeometryGroup(e, o);
      } else
        this.insertGeometryGroup(e, null);
    this.buildMeshes();
  }
  setGlobalMaterial(e) {
    const s = this.getThreeMaterial(e);
    this.groups = [
      {
        start: 0,
        count: this.geometry.index.count,
        threeMaterial: s
      }
    ], this.buildMeshes();
  }
  getBoundingSphere() {
    this.updateWorldMatrix(!0, !1);
    const e = new Matrix4().multiplyMatrices(this.matrixWorld, this.coordinationMatrix);
    return this.geometry.boundingSphere.clone().applyMatrix4(e);
  }
  getPhysicalElementIds() {
    return [...this.elementGroups.keys()];
  }
  getLine(e) {
    var s;
    const o = this.linesById.get(e);
    if (o !== void 0)
      return o;
    try {
      const a = (s = this.ifcApi.GetLine(this.modelId, e)) !== null && s !== void 0 ? s : null;
      return this.linesById.set(e, a), a;
    } catch {
      return console.error(`IFC error: failed to get line ${e}`), null;
    }
  }
  getElementIdsOfType(e) {
    const s = this.elementIdsByType.get(e);
    if (s)
      return s;
    const o = [], a = this.ifcApi.GetTypeCodeFromName(e), l = this.ifcApi.GetLineIDsWithType(this.modelId, a);
    for (let u = 0; u < l.size(); u++)
      o.push(l.get(u));
    return this.elementIdsByType.set(e, o), o;
  }
  getRootElementId() {
    return this.getElementIdsOfType("IFCPROJECT")[0];
  }
  getChildren(e) {
    const s = this.getElementIdsOfType("IFCRELCONTAINEDINSPATIALSTRUCTURE"), o = this.getElementIdsOfType("IFCRELAGGREGATES"), a = [];
    for (const l of s) {
      const u = this.getLine(l);
      if (u !== null && u.RelatingStructure.value === e)
        if (Array.isArray(u.RelatedElements)) {
          const c = u.RelatedElements.map((E) => E.value);
          a.push(...c);
        } else
          a.push(u.RelatedElements.value);
    }
    for (const l of o) {
      const u = this.getLine(l);
      if (u !== null && u.RelatingObject.value === e)
        if (Array.isArray(u.RelatedObjects)) {
          const c = u.RelatedObjects.map((E) => E.value);
          a.push(...c);
        } else
          a.push(u.RelatedObjects.value);
    }
    return a;
  }
  processElementProperty(e) {
    var s, o;
    const a = this.getLine(e);
    if (a === null)
      return null;
    const l = a.Name.value;
    let u;
    switch (a.type) {
      case IFCPROPERTYSINGLEVALUE:
        u = (o = (s = a.NominalValue) === null || s === void 0 ? void 0 : s.value) !== null && o !== void 0 ? o : null;
        break;
      default:
        return null;
    }
    return { key: l, value: u };
  }
  processElementQuantity(e) {
    const s = this.getLine(e);
    if (s === null)
      return null;
    const o = s.Name.value;
    let a;
    switch (s.type) {
      case IFCQUANTITYCOUNT:
        a = s.CountValue.value;
        break;
      case IFCQUANTITYLENGTH:
        a = s.LengthValue.value;
        break;
      case IFCQUANTITYAREA:
        a = s.AreaValue.value;
        break;
      case IFCQUANTITYVOLUME:
        a = s.VolumeValue.value;
        break;
      case IFCQUANTITYWEIGHT:
        a = s.WeightValue.value;
        break;
      case IFCQUANTITYTIME:
        a = s.TimeValue.value;
        break;
      default:
        return null;
    }
    return { key: o, value: a };
  }
  getPropertySets(e) {
    const s = this.getElementIdsOfType("IFCRELDEFINESBYPROPERTIES"), o = [];
    for (const l of s) {
      const u = this.getLine(l);
      if (u === null)
        continue;
      let c = !1;
      Array.isArray(u.RelatedObjects) ? c = u.RelatedObjects.map((d) => d.value).includes(e) : c = u.RelatedObjects.value === e, c && o.push(u.RelatingPropertyDefinition.value);
    }
    const a = [];
    for (const l of o) {
      const u = this.getLine(l);
      if (u === null)
        continue;
      const c = u.Name.value, E = [];
      u.type === IFCPROPERTYSET ? u.HasProperties.forEach((d) => {
        const f = this.processElementProperty(d.value);
        f !== null && E.push(f);
      }) : u.type, E.length > 0 && a.push({ name: c, fields: E });
    }
    return a;
  }
  getMaterialSets(e) {
    const s = this.getElementIdsOfType("IFCRELASSOCIATESMATERIAL"), o = [];
    for (const l of s) {
      const u = this.getLine(l);
      if (u === null)
        continue;
      let c = !1;
      Array.isArray(u.RelatedObjects) ? c = u.RelatedObjects.map((d) => d.value).includes(e) : c = u.RelatedObjects.value === e, c && o.push(u.RelatingMaterial.value);
    }
    const a = [];
    for (const l of o) {
      const u = this.getLine(l);
      u !== null && (u.type === IFCMATERIAL ? a.push(u.Name.value) : u.type === IFCMATERIALLIST ? u.Materials.forEach((c) => {
        const E = this.getLine(c.value);
        E && a.push(E.Name.value);
      }) : u.type === IFCMATERIALLAYERSETUSAGE || u.type === IFCMATERIALLAYERSET || u.type);
    }
    return a;
  }
  getElementProperties(e) {
    var s, o, a, l, u, c, E, d, f, h;
    try {
      const S = this.getLine(e);
      if (S === null)
        return null;
      const R = S.expressID, _ = (o = (s = S.GlobalId) === null || s === void 0 ? void 0 : s.value) !== null && o !== void 0 ? o : "", m = this.ifcApi.GetNameFromTypeCode(S.type), L = (l = (a = S.Name) === null || a === void 0 ? void 0 : a.value) !== null && l !== void 0 ? l : "", F = (c = (u = S.Description) === null || u === void 0 ? void 0 : u.value) !== null && c !== void 0 ? c : "", W = (d = (E = S.ObjectType) === null || E === void 0 ? void 0 : E.value) !== null && d !== void 0 ? d : null, G = (h = (f = S.Tag) === null || f === void 0 ? void 0 : f.value) !== null && h !== void 0 ? h : null, q = this.getPropertySets(e), fe = this.getMaterialSets(e), _e = this.elementGroups.has(e), Le = this.getChildren(e);
      return {
        id: R,
        guid: _,
        type: m,
        name: L,
        description: F,
        objectType: W,
        tag: G,
        properties: q,
        materials: fe,
        isPhysicalMesh: _e,
        children: Le
      };
    } catch (S) {
      return console.error(S), null;
    }
  }
}
class DxfObject extends DrawableObject {
  constructor(e, s) {
    super(e), this._opacity = 1, this.object = e, this.id = s;
  }
  get opacity() {
    return this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this._opacity < 1 ? this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof LineSegments || s instanceof Points) {
        const o = s.material;
        o.opacity = e, o.transparent = !0, o.depthWrite = !1, o.needsUpdate = !0;
      }
    }) : this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof LineSegments || s instanceof Points) {
        const o = s.material;
        o.opacity = 1, o.transparent = !1, o.depthWrite = !0, o.needsUpdate = !0;
      }
    });
  }
  get isTransparent() {
    return this._opacity < 1;
  }
  getScale(e) {
    return typeof e > "u" ? {
      x: this.object.scale.x,
      y: this.object.scale.y,
      z: this.object.scale.z
    } : (e.x = this.object.scale.x, e.y = this.object.scale.y, e.z = this.object.scale.z, e);
  }
  setScale(e) {
    this.object.scale.x = e.x, this.object.scale.y = e.y, this.object.scale.z = e.z;
  }
  setClippingPlanes(e) {
    this.object.traverse((s) => {
      if (s instanceof Mesh || s instanceof LineSegments || s instanceof Points)
        if (Array.isArray(s.material))
          for (const o of s.material)
            o.clippingPlanes = e, o.needsUpdate = !0;
        else
          s.material.clippingPlanes = e, s.material.needsUpdate = !0;
    });
  }
  invalidateMaterials() {
    this.object.traverse((e) => {
      if (e instanceof Mesh || e instanceof LineSegments || e instanceof Points)
        if (Array.isArray(e.material))
          for (const s of e.material)
            s.needsUpdate = !0;
        else
          e.material.needsUpdate = !0;
    });
  }
  getEstimatedCenter(e) {
    const s = this.getBoundingVolume();
    return e !== void 0 ? (e.x = s[0], e.y = s[1], e.z = s[2], e) : {
      x: s[0],
      y: s[1],
      z: s[2]
    };
  }
  getBoundingVolume() {
    const e = new Box3$1().setFromObject(this.object), s = new Sphere$1();
    return e.getBoundingSphere(s), [s.center.x, s.center.y, s.center.z, s.radius];
  }
  asBlendableObject() {
    return this;
  }
  getObjectType() {
    return WorldObjectType.ObjObject;
  }
  asScalableObject() {
    return this;
  }
}
class PanoramaMaterial extends ShaderMaterial {
  constructor(e) {
    super({
      vertexShader: `
                varying vec2 vUv;

                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }
            `,
      fragmentShader: `
                varying vec2 vUv;
                uniform sampler2D map;
                uniform float opacity;

                layout(location = 1) out highp vec2 pc_fragCoordBufferEDL;                

                void main() {
                    pc_fragColor = texture(map, vUv);
                    pc_fragColor.a = opacity;

                    // Write infinitely far depth to EDL buffer
                    pc_fragCoordBufferEDL = vec2(1.0, 1.0);
                }
            `,
      uniforms: {
        map: { value: e },
        opacity: { value: 1 }
      },
      depthTest: !1,
      depthWrite: !1
    });
  }
}
var __awaiter$c = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const SPHERE_RADIUS = 500, MIN_WIDTH_SEGMENTS = 60, MIN_HEIGHT_SEGMENTS = 40;
class TiledPanoramaObject extends BaseObject {
  createBoundingSphereForTile(e, s) {
    const o = e * (Math.PI / this.rows), a = (e + 1) * (Math.PI / this.rows), l = s * (2 * Math.PI / this.cols), u = (s + 1) * (2 * Math.PI / this.cols), c = new Sphere$1(), E = [
      [o, l],
      [o, u],
      [a, l],
      [a, u]
    ];
    for (const [d, f] of E) {
      const h = new Spherical(SPHERE_RADIUS, d, f), S = new Vector3$1().setFromSpherical(h);
      c.expandByPoint(S);
    }
    return c;
  }
  createGeometryForTile(e, s) {
    let o = this.cols;
    for (; o < MIN_WIDTH_SEGMENTS; )
      o += this.cols;
    let a = this.rows;
    for (; a < MIN_HEIGHT_SEGMENTS; )
      a += this.rows;
    const l = o / this.cols, u = a / this.rows, c = SPHERE_RADIUS, E = Math.PI / a, d = 2 * Math.PI / o, f = [], h = [], S = [], R = e * u, _ = (e + 1) * u, m = s * l, L = (s + 1) * l;
    for (let G = R; G <= _; ++G) {
      const q = G * E;
      for (let fe = m; fe <= L; ++fe) {
        const _e = fe * d, Le = new Spherical(c, q, _e), Fe = new Vector3$1().setFromSpherical(Le);
        f.push(Fe.x, Fe.y, Fe.z), h.push(1 - fe / o, 1 - G / a), S.push(1 - (fe - m) / (L - m), 1 - (G - R) / (_ - R));
      }
    }
    const F = [];
    for (let G = 0; G < u; ++G)
      for (let q = 0; q < l; ++q) {
        const fe = (G + 0) * (l + 1) + (q + 0), _e = (G + 0) * (l + 1) + (q + 1), Le = (G + 1) * (l + 1) + (q + 1), Fe = (G + 1) * (l + 1) + (q + 0);
        e * (Math.PI / this.rows), (e + 1) * (Math.PI / this.rows), s * (2 * Math.PI / this.cols), (s + 1) * (2 * Math.PI / this.cols), F.push(fe, _e, Le), F.push(fe, Le, Fe);
      }
    const W = new BufferGeometry();
    return W.setAttribute("position", new BufferAttribute(new Float32Array(f), 3)), W.setAttribute("lowResUv", new BufferAttribute(new Float32Array(h), 2)), W.setAttribute("highResUv", new BufferAttribute(new Float32Array(S), 2)), W.setIndex(F), W.computeBoundingSphere(), W;
  }
  createMaterialForTile(e, s) {
    return new ShaderMaterial({
      vertexShader: `
                attribute vec2 lowResUv;
                attribute vec2 highResUv;

                varying vec2 vLowResUv;
                varying vec2 vHighResUv;

                void main() {
                    vLowResUv = lowResUv;
                    vHighResUv = highResUv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }
            `,
      fragmentShader: `
                varying vec2 vLowResUv;
                varying vec2 vHighResUv;
                uniform sampler2D uLowResMap;
                uniform sampler2D uHighResMap;
                uniform bool uHighResMapLoaded;
                uniform float uOpacity;

                layout(location = 1) out highp vec2 pc_fragCoordBufferEDL;                

                void main() {
                    pc_fragColor.rgb = vec3(1.0);
                    pc_fragColor.a = uOpacity;

                    if (uHighResMapLoaded) {
                        pc_fragColor.rgb *= texture(uHighResMap, vHighResUv).rgb;
                    } else {
                        pc_fragColor.rgb *= texture(uLowResMap, vLowResUv).rgb;
                    }

                    // Write infinitely far depth to EDL buffer
                    pc_fragCoordBufferEDL = vec2(1.0, 1.0);
                }
            `,
      uniforms: {
        uHighResMap: { value: null },
        uHighResMapLoaded: { value: !1 },
        uLowResMap: { value: null },
        uOpacity: { value: this.opacity }
      },
      depthTest: !1,
      depthWrite: !1,
      side: DoubleSide,
      opacity: this.opacity,
      transparent: this.opacity !== 1
    });
  }
  createMeshForTile(e, s) {
    this.createBoundingSphereForTile(e, s);
    const o = this.createMaterialForTile(e, s), a = this.createGeometryForTile(e, s), l = new Mesh(a, o);
    return l.frustumCulled = !1, l;
  }
  getLowResURL() {
    return this.thumbnailURL;
  }
  getHighResURL(e, s) {
    return this.getTileURL(e, this.cols - 1 - s);
  }
  constructor(e, s, o) {
    super(new Group()), this.tiles = [], this.opacity = 1, this.rows = e.rows, this.cols = e.cols, this.thumbnailURL = e.thumbnailURL, this.getTileURL = e.getTileURL, o && (this.thumbnail = o), this.rotated = new Group(), this.rotated.setRotationFromAxisAngle(new Vector3$1(0, 1, 0), Math.PI / 2), this.object.add(this.rotated), this.object.frustumCulled = !1, this.rotated.frustumCulled = !1;
    for (let a = 0; a < this.rows; ++a)
      for (let l = 0; l < this.cols; ++l) {
        const u = this.createBoundingSphereForTile(a, l);
        this.tiles.push({
          row: a,
          col: l,
          boundingSphere: u
        });
      }
    this.requestManager = s;
  }
  evictAll() {
    var e;
    for (const s of this.tiles)
      s.mesh && (s.request || ((e = s.texture) === null || e === void 0 || e.dispose(), s.texture = void 0, s.mesh.material.dispose(), s.mesh.geometry.dispose(), this.rotated.remove(s.mesh), s.mesh = void 0));
  }
  prepare(e, s, o) {
    if (s.updateMatrixWorld(), this.rotated.updateMatrixWorld(), !this.thumbnail && (!this.thumbnailRequest || this.thumbnailRequest.status === "cancelled") && (this.thumbnailRequest = this.requestManager.queueRequest("priority", () => __awaiter$c(this, void 0, void 0, function* () {
      this.thumbnail = yield TextureLoader.load(this.getLowResURL()), this.thumbnail.colorSpace = SRGBColorSpace, this.thumbnailRequest = void 0;
    }))), this.getVisible()) {
      this.updateOpacity();
      const a = s.getCurrentCamera(), l = a.projectionMatrix.clone().multiply(a.matrixWorldInverse), u = new Frustum().setFromProjectionMatrix(l);
      for (const c of this.tiles) {
        const E = c.boundingSphere.clone().applyMatrix4(this.rotated.matrixWorld);
        if (!u.intersectsSphere(E)) {
          c.mesh && (c.mesh.visible = !1);
          continue;
        }
        c.mesh || (c.mesh = this.createMeshForTile(c.row, c.col), this.rotated.add(c.mesh)), c.mesh.visible = !0;
        const f = c.mesh.material;
        this.thumbnail && (f.uniforms.uLowResMap.value = this.thumbnail), f.uniforms.uOpacity.value = this.opacity, !c.texture && (!c.request || c.request.status === "cancelled") && (c.request = this.requestManager.queueRequest("priority", () => __awaiter$c(this, void 0, void 0, function* () {
          c.texture = yield TextureLoader.load(this.getHighResURL(c.row, c.col)), c.texture.colorSpace = SRGBColorSpace, c.request = void 0;
        }))), c.texture && (f.uniforms.uHighResMapLoaded.value = !0, f.uniforms.uHighResMap.value = c.texture);
      }
    } else
      this.evictAll();
  }
  /*
      Implement IPanorama
  */
  setVisible(e) {
    this.object.visible = e;
  }
  getVisible() {
    return this.object.visible;
  }
  setOpacity(e) {
    this.opacity = e;
  }
  getOpacity() {
    return this.opacity;
  }
  updateOpacity() {
    for (const e of this.tiles) {
      if (!e.mesh)
        continue;
      const s = e.mesh.material;
      s.opacity = this.opacity, s.transparent = this.opacity !== 1;
    }
  }
  setPriority(e) {
    this.object.renderOrder = e;
  }
  getPriority() {
    return this.object.renderOrder;
  }
  dispose() {
  }
}
var __awaiter$b = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Task {
  run(e) {
    return __awaiter$b(this, void 0, void 0, function* () {
      e ? yield e.queueTask(this) : yield this.do();
    });
  }
}
function saveThreeObjectToWire(r, e) {
  const s = [], o = /* @__PURE__ */ new Set();
  return r.traverse((a) => {
    var l, u;
    if (a instanceof Mesh) {
      a.updateMatrix(), a.updateMatrixWorld();
      const c = Array.isArray(a.material) ? a.material : [a.material], E = [];
      for (const R of c) {
        let _, m = [1, 1, 1], L = 1, F = !1;
        (R instanceof MeshBasicMaterial || R instanceof MeshPhongMaterial || R instanceof MeshPhysicalMaterial) && (((l = R.map) === null || l === void 0 ? void 0 : l.source.data) instanceof ImageBitmap && (_ = R.map.source.data, o.add(_)), m = R.color.toArray(), L = R.opacity, F = R.transparent), E.push({
          map: _,
          color: m,
          opacity: L,
          transparent: F
        });
      }
      const d = a.geometry, f = {};
      for (const R of Object.keys(d.attributes))
        f[R] = {
          array: d.getAttribute(R).array,
          itemSize: d.getAttribute(R).itemSize,
          normalized: d.getAttribute(R).normalized
        }, o.add(d.getAttribute(R).array.buffer);
      const h = d.getIndex();
      !((u = h == null ? void 0 : h.array) === null || u === void 0) && u.buffer && o.add(h.array.buffer);
      const S = {
        attributes: f,
        index: h == null ? void 0 : h.array,
        groups: d.groups
      };
      if (d.boundsTree) {
        S.bvh = MeshBVH.serialize(d.boundsTree);
        for (const R of S.bvh.roots)
          o.add(R);
        o.add(S.bvh.index.buffer);
      }
      s.push({
        matrixWorld: a.matrixWorld.transpose().elements,
        geometry: S,
        materials: E
      });
    }
  }), e.push(...o.values()), {
    meshes: s
  };
}
function loadThreeObjectFromWire(r, e) {
  const s = new Object3D();
  for (const o of r.meshes) {
    const a = new BufferGeometry();
    for (const c of Object.keys(o.geometry.attributes))
      a.setAttribute(c, new BufferAttribute(o.geometry.attributes[c].array, o.geometry.attributes[c].itemSize, o.geometry.attributes[c].normalized));
    o.geometry.index && a.setIndex(new BufferAttribute(o.geometry.index, 1));
    for (const c of o.geometry.groups)
      a.addGroup(c.start, c.count, c.materialIndex);
    o.geometry.bvh && (a.boundsTree = MeshBVH.deserialize(o.geometry.bvh, a));
    const l = [];
    for (const c of o.materials) {
      const E = new PickingMeshPhongMaterial({
        objectId: e
      });
      c.map && (E.map = new Texture(c.map), E.map.magFilter = LinearFilter, E.map.minFilter = LinearFilter, E.map.generateMipmaps = !1, E.map.colorSpace = SRGBColorSpace, E.map.needsUpdate = !0), E.transparent = c.transparent, E.opacity = c.opacity, E.color = new Color(...c.color), l.push(E);
    }
    const u = new Mesh(a, l.length === 1 ? l[0] : l);
    u.matrixWorld = new Matrix4(...o.matrixWorld), s.add(u);
  }
  return s;
}
var __awaiter$a = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class ObjTask extends Task {
  constructor(e, s) {
    super(), this.url = "", this.options = {}, this.object = new Group(), e && (this.url = e), s && (this.options = s);
  }
  do() {
    return __awaiter$a(this, void 0, void 0, function* () {
      this.object = yield ObjLoader.load(this.url, this.options);
    });
  }
  save(e) {
    return {
      url: this.url,
      options: {
        headers: this.options.headers,
        cacheKey: this.options.cacheKey,
        objectId: this.options.objectId
      },
      object: saveThreeObjectToWire(this.object, e)
    };
  }
  load(e) {
    var s;
    this.url = e.url, this.options.headers = e.options.headers, this.options.cacheKey = e.options.cacheKey, this.options.objectId = e.options.objectId, this.object = new Group(), this.object.add(loadThreeObjectFromWire(e.object, (s = e.options.objectId) !== null && s !== void 0 ? s : 0));
  }
  className() {
    return "ObjTask";
  }
}
class GaussianSplatObject extends DrawableObject {
  constructor(e) {
    super(e), this.object = e, this.object.frustumCulled = !1;
  }
  getScale(e) {
    return this.object.scale;
  }
  setScale(e) {
    const { x: s, y: o, z: a } = e;
    this.object.scale.set(s, o, a);
  }
  prepare(e, s, o) {
    this.object.update(s.getCurrentCamera(), e.renderer), this.object.material.initialize(s.getCurrentCamera(), e.renderer);
  }
  getObjectType() {
    return WorldObjectType.GaussianSplat;
  }
  setClippingPlanes(e) {
    this.object.clippingPlanes = e;
  }
  getBoundingVolume() {
    const e = new Box3$1().setFromObject(this.object), s = new Sphere$1();
    return e.getBoundingSphere(s), [s.center.x, s.center.y, s.center.z, s.radius];
  }
  asScalableObject() {
    return this;
  }
  get maxSplats() {
    return this.object.maxSplats;
  }
  set maxSplats(e) {
    this.object.maxSplats = e;
  }
}
new MeshBasicMaterial({
  wireframe: !0,
  color: 8421504,
  transparent: !0,
  opacity: 0.4
});
class SplatLoader extends Loader {
  constructor(e, s) {
    super(s), this.processDataCallback = e;
  }
  load(e, s, o, a) {
    const l = this.path === "" ? e : this.path + e;
    fetch(l, {
      mode: "cors",
      credentials: this.withCredentials ? "include" : "omit"
    }).then((u) => {
      if (u.status !== 200) {
        a && a(new ErrorEvent("NetworkError", { message: `${u.status} Unable to load ${u.url}` })), this.manager.itemError(e);
        return;
      }
      return u.arrayBuffer();
    }).then((u) => {
      if (!u)
        return;
      const c = new Uint8Array(u);
      this._processData(c, c.length, !0), s && s(c), this.manager.itemEnd(e);
    }).catch((u) => {
      a && a(new ErrorEvent("NetworkError", { message: u.message })), this.manager.itemError(e);
    }), this.manager.itemStart(e);
  }
  loadAsync(e, s) {
    return new Promise((o, a) => {
      this.load(e, (l) => {
        o({ data: l, bytesRead: l.length });
      }, s, a);
    });
  }
  _processData(e, s, o = !1) {
    var a;
    (a = this.processDataCallback) === null || a === void 0 || a.call(this, e, s, o);
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const proxyMarker = Symbol("Comlink.proxy"), createEndpoint = Symbol("Comlink.endpoint"), releaseProxy = Symbol("Comlink.releaseProxy"), finalizer = Symbol("Comlink.finalizer"), throwMarker = Symbol("Comlink.thrown"), isObject$1 = (r) => typeof r == "object" && r !== null || typeof r == "function", proxyTransferHandler = {
  canHandle: (r) => isObject$1(r) && r[proxyMarker],
  serialize(r) {
    const { port1: e, port2: s } = new MessageChannel();
    return expose(r, e), [s, [s]];
  },
  deserialize(r) {
    return r.start(), wrap(r);
  }
}, throwTransferHandler = {
  canHandle: (r) => isObject$1(r) && throwMarker in r,
  serialize({ value: r }) {
    let e;
    return r instanceof Error ? e = {
      isError: !0,
      value: {
        message: r.message,
        name: r.name,
        stack: r.stack
      }
    } : e = { isError: !1, value: r }, [e, []];
  },
  deserialize(r) {
    throw r.isError ? Object.assign(new Error(r.value.message), r.value) : r.value;
  }
}, transferHandlers = /* @__PURE__ */ new Map([
  ["proxy", proxyTransferHandler],
  ["throw", throwTransferHandler]
]);
function isAllowedOrigin(r, e) {
  for (const s of r)
    if (e === s || s === "*" || s instanceof RegExp && s.test(e))
      return !0;
  return !1;
}
function expose(r, e = globalThis, s = ["*"]) {
  e.addEventListener("message", function o(a) {
    if (!a || !a.data)
      return;
    if (!isAllowedOrigin(s, a.origin)) {
      console.warn(`Invalid origin '${a.origin}' for comlink proxy`);
      return;
    }
    const { id: l, type: u, path: c } = Object.assign({ path: [] }, a.data), E = (a.data.argumentList || []).map(fromWireValue);
    let d;
    try {
      const f = c.slice(0, -1).reduce((S, R) => S[R], r), h = c.reduce((S, R) => S[R], r);
      switch (u) {
        case "GET":
          d = h;
          break;
        case "SET":
          f[c.slice(-1)[0]] = fromWireValue(a.data.value), d = !0;
          break;
        case "APPLY":
          d = h.apply(f, E);
          break;
        case "CONSTRUCT":
          {
            const S = new h(...E);
            d = proxy(S);
          }
          break;
        case "ENDPOINT":
          {
            const { port1: S, port2: R } = new MessageChannel();
            expose(r, R), d = transfer(S, [S]);
          }
          break;
        case "RELEASE":
          d = void 0;
          break;
        default:
          return;
      }
    } catch (f) {
      d = { value: f, [throwMarker]: 0 };
    }
    Promise.resolve(d).catch((f) => ({ value: f, [throwMarker]: 0 })).then((f) => {
      const [h, S] = toWireValue(f);
      e.postMessage(Object.assign(Object.assign({}, h), { id: l }), S), u === "RELEASE" && (e.removeEventListener("message", o), closeEndPoint(e), finalizer in r && typeof r[finalizer] == "function" && r[finalizer]());
    }).catch((f) => {
      const [h, S] = toWireValue({
        value: new TypeError("Unserializable return value"),
        [throwMarker]: 0
      });
      e.postMessage(Object.assign(Object.assign({}, h), { id: l }), S);
    });
  }), e.start && e.start();
}
function isMessagePort(r) {
  return r.constructor.name === "MessagePort";
}
function closeEndPoint(r) {
  isMessagePort(r) && r.close();
}
function wrap(r, e) {
  const s = /* @__PURE__ */ new Map();
  return r.addEventListener("message", function(a) {
    const { data: l } = a;
    if (!l || !l.id)
      return;
    const u = s.get(l.id);
    if (u)
      try {
        u(l);
      } finally {
        s.delete(l.id);
      }
  }), createProxy(r, s, [], e);
}
function throwIfProxyReleased(r) {
  if (r)
    throw new Error("Proxy has been released and is not useable");
}
function releaseEndpoint(r) {
  return requestResponseMessage(r, /* @__PURE__ */ new Map(), {
    type: "RELEASE"
  }).then(() => {
    closeEndPoint(r);
  });
}
const proxyCounter = /* @__PURE__ */ new WeakMap(), proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((r) => {
  const e = (proxyCounter.get(r) || 0) - 1;
  proxyCounter.set(r, e), e === 0 && releaseEndpoint(r);
});
function registerProxy(r, e) {
  const s = (proxyCounter.get(e) || 0) + 1;
  proxyCounter.set(e, s), proxyFinalizers && proxyFinalizers.register(r, e, r);
}
function unregisterProxy(r) {
  proxyFinalizers && proxyFinalizers.unregister(r);
}
function createProxy(r, e, s = [], o = function() {
}) {
  let a = !1;
  const l = new Proxy(o, {
    get(u, c) {
      if (throwIfProxyReleased(a), c === releaseProxy)
        return () => {
          unregisterProxy(l), releaseEndpoint(r), e.clear(), a = !0;
        };
      if (c === "then") {
        if (s.length === 0)
          return { then: () => l };
        const E = requestResponseMessage(r, e, {
          type: "GET",
          path: s.map((d) => d.toString())
        }).then(fromWireValue);
        return E.then.bind(E);
      }
      return createProxy(r, e, [...s, c]);
    },
    set(u, c, E) {
      throwIfProxyReleased(a);
      const [d, f] = toWireValue(E);
      return requestResponseMessage(r, e, {
        type: "SET",
        path: [...s, c].map((h) => h.toString()),
        value: d
      }, f).then(fromWireValue);
    },
    apply(u, c, E) {
      throwIfProxyReleased(a);
      const d = s[s.length - 1];
      if (d === createEndpoint)
        return requestResponseMessage(r, e, {
          type: "ENDPOINT"
        }).then(fromWireValue);
      if (d === "bind")
        return createProxy(r, e, s.slice(0, -1));
      const [f, h] = processArguments(E);
      return requestResponseMessage(r, e, {
        type: "APPLY",
        path: s.map((S) => S.toString()),
        argumentList: f
      }, h).then(fromWireValue);
    },
    construct(u, c) {
      throwIfProxyReleased(a);
      const [E, d] = processArguments(c);
      return requestResponseMessage(r, e, {
        type: "CONSTRUCT",
        path: s.map((f) => f.toString()),
        argumentList: E
      }, d).then(fromWireValue);
    }
  });
  return registerProxy(l, r), l;
}
function myFlat(r) {
  return Array.prototype.concat.apply([], r);
}
function processArguments(r) {
  const e = r.map(toWireValue);
  return [e.map((s) => s[0]), myFlat(e.map((s) => s[1]))];
}
const transferCache = /* @__PURE__ */ new WeakMap();
function transfer(r, e) {
  return transferCache.set(r, e), r;
}
function proxy(r) {
  return Object.assign(r, { [proxyMarker]: !0 });
}
function toWireValue(r) {
  for (const [e, s] of transferHandlers)
    if (s.canHandle(r)) {
      const [o, a] = s.serialize(r);
      return [
        {
          type: "HANDLER",
          name: e,
          value: o
        },
        a
      ];
    }
  return [
    {
      type: "RAW",
      value: r
    },
    transferCache.get(r) || []
  ];
}
function fromWireValue(r) {
  switch (r.type) {
    case "HANDLER":
      return transferHandlers.get(r.name).deserialize(r.value);
    case "RAW":
      return r.value;
  }
}
function requestResponseMessage(r, e, s, o) {
  return new Promise((a) => {
    const l = generateUUID();
    e.set(l, a), r.start && r.start(), r.postMessage(Object.assign({ id: l }, s), o);
  });
}
function generateUUID() {
  return new Array(4).fill(0).map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}
var __awaiter$9 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
function createSortWorker(r) {
  const e = new Worker(r, { type: "module" });
  return wrap(e);
}
let SortWorker = null;
function initSortWorker(r) {
  SortWorker || (SortWorker = createSortWorker(r + "worker.es.js"));
}
class GaussianSplatGeometry extends InstancedBufferGeometry {
  constructor(e) {
    super(), this._maxSplats = e, this.viewProj = [], this._sortRunning = !1, this.loading = !1, this._initialized = !1, this.loadedGeometry = {
      data: new Uint8Array(),
      bytesRead: 0
    }, this.vertexCount = 0;
  }
  get maxSplats() {
    return this._maxSplats;
  }
  set maxSplats(e) {
    this._maxSplats = e, this.buildGeometry();
  }
  update(e, s) {
    return __awaiter$9(this, void 0, void 0, function* () {
      if (this._sortRunning || !this._initialized || !this.worker)
        return;
      e.updateMatrixWorld(!0), this.viewProj = new Matrix4().multiply(e.projectionMatrix).multiply(e.matrixWorldInverse).multiply(s).elements, this._sortRunning = !0;
      const o = new Float32Array(this.viewProj), a = yield this.worker.runSort(o), { quat: l, scale: u, center: c, color: E } = this.extractViews(a);
      this.attributes.color.array = E, this.attributes.quat.array = l, this.attributes.scale.array = u, this.attributes.center.array = c, this.attributes.color.needsUpdate = !0, this.attributes.quat.needsUpdate = !0, this.attributes.scale.needsUpdate = !0, this.attributes.center.needsUpdate = !0, yield Promise.all([
        new Promise((d) => this.attributes.color.onUpload(d)),
        new Promise((d) => this.attributes.quat.onUpload(d)),
        new Promise((d) => this.attributes.scale.onUpload(d)),
        new Promise((d) => this.attributes.center.onUpload(d))
      ]), yield this.worker.returnBuffer(transfer(a, [a])), this._sortRunning = !1;
    });
  }
  load(e, s) {
    return __awaiter$9(this, void 0, void 0, function* () {
      if (this.loading) {
        console.warn("Geometry is already loading or loaded");
        return;
      }
      this.loading = !0;
      try {
        const o = new SplatLoader(void 0, s), { data: a, bytesRead: l } = yield o.loadAsync(e);
        this.loadedGeometry.data = a, this.loadedGeometry.bytesRead = l, yield this.buildGeometry();
      } catch (o) {
        console.error("Error loading geometry:", o);
      }
    });
  }
  buildGeometry() {
    return __awaiter$9(this, void 0, void 0, function* () {
      this._initialized = !1, this.loading = !0;
      try {
        const e = Math.floor(this.loadedGeometry.bytesRead / ROW_LENGTH), s = trimBuffer(this.loadedGeometry.data, this.maxSplats, e);
        if (!SortWorker)
          throw new Error("Sort worker not initialized");
        this.worker && this.worker.dispose(), this.worker = yield new SortWorker(s.vertexCount, transfer(s.buffer, [s.buffer.buffer])), yield this.worker.load(), this.vertexCount = s.vertexCount, this.initAttributes();
      } catch (e) {
        console.error("Error building geometry:", e);
      }
    });
  }
  initAttributes() {
    return __awaiter$9(this, void 0, void 0, function* () {
      const e = new Float32Array(this.viewProj);
      if (!this.worker)
        throw new Error("Worker not initialized.");
      const s = yield this.worker.runSort(e), { quat: o, scale: a, center: l, color: u } = this.extractViews(s);
      this.setAttribute("color", new InstancedBufferAttribute(u, 4, !0)), this.setAttribute("quat", new InstancedBufferAttribute(o, 4, !0)), this.setAttribute("scale", new InstancedBufferAttribute(a, 3, !0)), this.setAttribute("center", new InstancedBufferAttribute(l, 3, !0)), this.setAttribute("position", new BufferAttribute(new Float32Array([1, -1, 0, 1, 1, 0, -1, -1, 0, -1, 1, 0]), 3, !0)), this.boundingBox = new Box3$1(), this.boundingBox.setFromArray(l), this.boundingSphere = new Sphere$1(), this.boundingBox.getBoundingSphere(this.boundingSphere), this.attributes.position.needsUpdate = !0, this.setIndex(new BufferAttribute(new Uint16Array([0, 1, 2, 2, 3, 0]), 1, !0)), this.instanceCount = Math.min(o.length / 4, this.maxSplats), this.loading = !1, this._initialized = !0;
    });
  }
  extractViews(e) {
    const s = new Float32Array(e), o = 4 * this.vertexCount, a = 3 * this.vertexCount, l = 3 * this.vertexCount, u = 4 * this.vertexCount, c = 0, E = c + o, d = E + a, f = d + l, h = s.subarray(c, c + o), S = s.subarray(E, E + a), R = s.subarray(d, d + l), _ = s.subarray(f, f + u);
    return { quat: h, scale: S, center: R, color: _ };
  }
  dispose() {
    var e;
    return (e = this.worker) === null || e === void 0 || e.dispose(), super.dispose();
  }
}
const ROW_LENGTH = 3 * 4 + 3 * 4 + 4 + 4;
function trimBuffer(r, e, s) {
  const o = Math.min(s, e), a = ROW_LENGTH * o;
  return { buffer: r.slice(0, a), vertexCount: o };
}
const vertexShaderSource = `
precision mediump float;

attribute vec4 color;
attribute vec4 quat;
attribute vec3 scale;
attribute vec3 center;

uniform vec2 focal;
uniform vec2 viewport;

varying vec4 vColor;
varying vec3 vConic;
varying vec2 vCenter;
varying vec2 vPosition;
varying float vFragDepth;
varying float vIsPerspective;
varying vec3 vWorldSpaceCenter;

bool isPerspectiveMatrix( mat4 m ) {
    return m[ 2 ][ 3 ] == - 1.0;
}

mat3 compute_cov3d(vec3 scale, vec4 rot) {
    mat3 S = mat3(
        scale.x, 0.0, 0.0,
        0.0, scale.y, 0.0,
        0.0, 0.0, scale.z
    );
    mat3 R = mat3(
        1.0 - 2.0 * (rot.z * rot.z + rot.w * rot.w), 2.0 * (rot.y * rot.z - rot.x * rot.w), 2.0 * (rot.y * rot.w + rot.x * rot.z),
        2.0 * (rot.y * rot.z + rot.x * rot.w), 1.0 - 2.0 * (rot.y * rot.y + rot.w * rot.w), 2.0 * (rot.z * rot.w - rot.x * rot.y),
        2.0 * (rot.y * rot.w - rot.x * rot.z), 2.0 * (rot.z * rot.w + rot.x * rot.y), 1.0 - 2.0 * (rot.y * rot.y + rot.z * rot.z)
    );
    mat3 M = S * R;
    return transpose(M) * M;
}

vec3 compute_cov2d(vec3 center, vec3 scale, vec4 rot){
    mat3 Vrk = compute_cov3d(scale, rot);
    vec4 t = modelViewMatrix * vec4(center, 1.0);
    vec2 lims = 1.3 * 0.5 * viewport / focal;
    t.xy = min(lims, max(-lims, t.xy / t.z)) * t.z;
    mat3 J = mat3(
        focal.x / t.z, 0., -(focal.x * t.x) / (t.z * t.z),
        0., focal.y / t.z, -(focal.y * t.y) / (t.z * t.z),
        0., 0., 0.
    );
    mat3 W = transpose(mat3(modelViewMatrix));
    mat3 T = W * J;
    mat3 cov = transpose(T) * transpose(Vrk) * T;
    return vec3(cov[0][0] + 0.3, cov[0][1], cov[1][1] + 0.3);
}

void main () {
    vWorldSpaceCenter = vec3(modelMatrix * vec4(center, 1.0));

    vec4 camspace = modelViewMatrix * vec4(center, 1);

    vec4 pos2d = projectionMatrix  * camspace;

    vec3 cov2d = compute_cov2d(center, scale, quat);
    float det = cov2d.x * cov2d.z - cov2d.y * cov2d.y;
    vec3 conic = vec3(cov2d.z, cov2d.y, cov2d.x) / det;
    float mid = 0.5 * (cov2d.x + cov2d.z);
    float lambda1 = mid + sqrt(max(0.1, mid * mid - det));
    float lambda2 = mid - sqrt(max(0.1, mid * mid - det));
    vec2 v1 = 7.0 * sqrt(lambda1) * normalize(vec2(cov2d.y, lambda1 - cov2d.x));
    vec2 v2 = 7.0 * sqrt(lambda2) * normalize(vec2(-(lambda1 - cov2d.x),cov2d.y));

    vColor = color;
    vConic = conic;
    vCenter = vec2(pos2d) / pos2d.w;

    vPosition = vec2(vCenter + position.x * (position.y < 0.0 ? v1 : v2) / viewport);
    gl_Position = vec4(vPosition, pos2d.z / pos2d.w, 1);

    vFragDepth = 1.0 + pos2d.w;
    vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
}
`, fragmentShaderSource = `
#define LN2 0.6931471805599453

precision mediump float;

varying vec4 vColor;
varying vec3 vConic;
varying vec2 vCenter;
varying float vFragDepth;
varying float vIsPerspective;
varying vec3 vWorldSpaceCenter;

uniform vec2 viewport;
uniform vec2 focal;
uniform float minAlpha;
uniform float cameraFar;

#if NUM_CUSTOM_CLIPPING_PLANES > 0
    uniform vec3 planeNormal[NUM_CUSTOM_CLIPPING_PLANES];
    uniform float planeDistance[NUM_CUSTOM_CLIPPING_PLANES];
#endif

void main () {
    #if NUM_CUSTOM_CLIPPING_PLANES > 0
    for (int i = 0; i < NUM_CUSTOM_CLIPPING_PLANES; ++i) {
        float planeSide = dot(vWorldSpaceCenter, planeNormal[i]) + planeDistance[i];

        if(planeSide < 0.0) {
            discard;
        }
    }
    #endif

	vec2 d = (vCenter - 2.0 * (gl_FragCoord.xy/viewport - vec2(0.5, 0.5))) * viewport * 0.5;

	float power = -0.5 * (vConic.x * d.x * d.x + vConic.z * d.y * d.y) + vConic.y * d.x * d.y;

	if (power > 0.0) discard;
	float alpha = min(0.99, vColor.a * exp(power));
	if(alpha < minAlpha) discard;

    float logDepthBufFC = 2.0 / ( log( cameraFar + 1.0 ) / LN2 );
    gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
    gl_FragColor = vec4(vColor.rgb, alpha);
}
`, computeFocalLengths = (r, e, s, o, a) => {
  const l = MathUtils$1.degToRad(s), u = 2 * Math.atan(Math.tan(l / 2) * o), c = a * e / (2 * Math.tan(l / 2)), E = a * r / (2 * Math.tan(u / 2));
  return new Vector2(E, c);
};
class GaussianSplatMaterial extends ShaderMaterial {
  set customClippingPlanes(e) {
    this.defines.NUM_CUSTOM_CLIPPING_PLANES = e.length, this.uniforms.planeNormal.value = e.map((s) => s.normal), this.uniforms.planeDistance.value = e.map((s) => s.constant);
  }
  set minAlpha(e) {
    this.uniforms.minAlpha.value = e, this.needsUpdate = !0;
  }
  constructor() {
    const e = {
      viewport: {
        value: new Vector2()
      },
      focal: {
        value: new Vector2()
      },
      minAlpha: {
        value: 0.02
      },
      planeNormal: {
        value: []
      },
      planeDistance: {
        value: []
      },
      cameraFar: {
        value: 0
      }
    };
    super({
      uniforms: e,
      fragmentShader: fragmentShaderSource,
      vertexShader: vertexShaderSource,
      depthTest: !0,
      depthWrite: !1,
      transparent: !0,
      defines: {
        NUM_CUSTOM_CLIPPING_PLANES: 0
      }
    }), this.onResize = () => {
      var s, o;
      if (!this.currentCamera)
        return;
      const a = new Vector2();
      (s = this.renderer) === null || s === void 0 || s.getSize(a);
      const l = a.x, u = a.y, c = ((o = this.renderer) === null || o === void 0 ? void 0 : o.getPixelRatio()) || 1;
      let E = 75, d = l / u;
      this.currentCamera instanceof PerspectiveCamera$1 && (E = this.currentCamera.fov, d = this.currentCamera.aspect), this.uniforms.focal.value = computeFocalLengths(l, u, E, d, c), this.uniforms.viewport.value = new Vector2(l * c, u * c);
    }, window.addEventListener("resize", this.onResize);
  }
  dispose() {
    return window.removeEventListener("resize", this.onResize), super.dispose();
  }
  initialize(e, s) {
    this.renderer = s, this.currentCamera = e;
    const o = new Vector2();
    s.getSize(o);
    const a = s.getPixelRatio();
    let l = 75, u = o.x / o.y;
    this.currentCamera instanceof PerspectiveCamera$1 && (l = this.currentCamera.fov, u = this.currentCamera.aspect, this.uniforms.cameraFar.value = this.currentCamera.far), this.uniforms.focal.value = computeFocalLengths(o.x, o.y, l, u, a), this.uniforms.viewport.value = new Vector2(o.x * a, o.y * a);
  }
}
class GaussianSplatMesh extends Mesh {
  constructor(e, s = 1 / 0) {
    const o = new GaussianSplatMaterial(), a = new GaussianSplatGeometry(s);
    super(a, o), this.url = e, this._desiredMaxSplats = s, this._actualMaxSplats = 0, this._rebuildInProgress = !1, this.rotation.x = Math.PI, this._actualMaxSplats = s;
  }
  load(e) {
    return this.geometry.load(this.url, e);
  }
  update(e, s) {
    if ((this.currentCamera !== e || this.renderer !== s) && this.material.initialize(e, s), this.currentCamera = e, this.renderer = s, this.updateMatrixWorld(!0), this._actualMaxSplats !== this._desiredMaxSplats && !this._rebuildInProgress) {
      this._rebuildInProgress = !0;
      const o = new GaussianSplatGeometry(this._desiredMaxSplats);
      o.load(this.url).then(() => {
        this.updateMatrixWorld(!0), o.update(this.currentCamera, this.matrixWorld).then(() => {
          this.geometry.dispose(), this.geometry = o, this._rebuildInProgress = !1, this._actualMaxSplats = this._desiredMaxSplats;
        });
      });
    }
    this.geometry.update(e, this.matrixWorld), this.clippingPlanes && (this.material.customClippingPlanes = this.clippingPlanes);
  }
  get maxSplats() {
    return this._desiredMaxSplats;
  }
  set maxSplats(e) {
    this._desiredMaxSplats = e;
  }
}
var __awaiter$8 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class ObjectFactory {
  constructor(e) {
    this.renderer = e;
  }
  createGaussianSplat(e) {
    var s;
    return __awaiter$8(this, void 0, void 0, function* () {
      const o = new GaussianSplatMesh(e.url, (s = e.maxSplats) !== null && s !== void 0 ? s : 1 / 0);
      return yield o.load(), new GaussianSplatObject(o);
    });
  }
  createTiledPanorama(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      const o = yield this.renderer.requestManager.queueRequest("priority", () => __awaiter$8(this, void 0, void 0, function* () {
        const l = yield TextureLoader.load(e.thumbnailURL, {
          headers: {
            "Cache-Control": "no-cache, no-store"
          }
        });
        return l.colorSpace = SRGBColorSpace, l;
      })).promise, a = new TiledPanoramaObject(e, this.renderer.requestManager, o);
      return applyDescRotation(e, a), a;
    });
  }
  createPanorama(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      return this.renderer.requestManager.queueRequest("priority", () => __awaiter$8(this, void 0, void 0, function* () {
        const o = yield TextureLoader.load(e.url, {
          headers: {
            "Cache-Control": "no-cache, no-store"
          }
        });
        o.colorSpace = SRGBColorSpace;
        const a = new PanoramaMaterial(o), l = new Mesh(PanoramaObject.GEOMETRY, a), u = new PanoramaObject(l);
        return applyDescRotation(e, u), u;
      })).promise;
    });
  }
  createBox(e) {
    const s = new BoxGeometry(e.size.x, e.size.y, e.size.z);
    s.computeBoundingSphere(), s.computeBoundsTree();
    const o = this.renderer.pickingManager.newId(), a = new Mesh(s, constructMeshThreeMaterial(e.material, [], o, !1, !1)), l = new MeshObject(a, WorldObjectType.BoxObject, o);
    return this.renderer.pickingManager.setForId(o, {
      objectType: ObjectType.Primitive,
      rootObject: l
    }), this.renderer.pickingManager.setIdForObject(a.id, o), applyDescPosition(e, l), applyDescRotation(e, l), applyDescScale(e, l), l;
  }
  createSphere(e) {
    const s = new SphereGeometry(e.radius, e.widthSegments, e.heightSegments);
    s.computeBoundingSphere(), s.computeBoundsTree();
    const o = this.renderer.pickingManager.newId(), a = new Mesh(s, constructMeshThreeMaterial(e.material, [], o, !1, !1)), l = new MeshObject(a, WorldObjectType.SphereObject, o);
    return this.renderer.pickingManager.setForId(o, {
      objectType: ObjectType.Primitive,
      rootObject: l
    }), this.renderer.pickingManager.setIdForObject(a.id, o), applyDescPosition(e, l), applyDescRotation(e, l), applyDescScale(e, l), l;
  }
  createRawMeshObject(e) {
    const s = this.renderer.pickingManager.newId();
    let o, a;
    if (e.mesh instanceof PointMesh) {
      const u = e.mesh.pickingUserId !== void 0;
      o = new Points(e.mesh.geometry, constructPointsThreeMaterial(e.material, [], s, u)), a = WorldObjectType.PointObject;
    } else if (e.mesh instanceof LineMesh) {
      const u = e.mesh.pickingUserId !== void 0;
      o = new LineSegments(e.mesh.geometry, constructLineMaterial(e.material, [], s, u)), a = WorldObjectType.LineSegmentObject;
    } else if (e.mesh instanceof LineStripMesh) {
      const u = e.mesh.pickingUserId !== void 0;
      o = new Line$1(e.mesh.geometry, constructLineMaterial(e.material, [], s, u)), a = WorldObjectType.LineObject;
    } else if (e.mesh instanceof IndexedTriangleMesh) {
      const u = e.mesh.pickingUserId !== void 0;
      o = new Mesh(e.mesh.geometry, constructMeshThreeMaterial(e.material, [], s, u, !1)), a = WorldObjectType.MeshObject;
    } else
      throw new Error("Unknown mesh type");
    const l = new MeshObject(o, a, s, e.mesh);
    return this.renderer.pickingManager.setForId(s, {
      objectType: ObjectType.Primitive,
      rootObject: l
    }), this.renderer.pickingManager.setIdForObject(o.id, s), applyDescPosition(e, l), applyDescRotation(e, l), applyDescScale(e, l), l;
  }
  createRawInstancedMeshObject(e) {
    const s = this.renderer.pickingManager.newId(), o = Math.min(e.positions.length, e.rotations.length, e.scales.length);
    let a;
    if (e.mesh instanceof IndexedTriangleMesh) {
      const c = constructMeshThreeMaterial(e.material, [], s, !1, !0);
      a = new InstancedMesh(e.mesh.geometry, c, o);
    } else
      throw new Error("Unknown/unsupported mesh type");
    const l = {
      objectType: ObjectType.Primitive,
      // @ts-ignore
      rootObject: void 0
    }, u = new InstancedMeshObject(a, s, e.positions, e.rotations, e.scales, e.colors, l, this.renderer.pickingManager, e.mesh);
    return l.rootObject = u, this.renderer.pickingManager.setForId(s, l), this.renderer.pickingManager.setIdForObject(a.id, s), applyDescPosition(e, u), applyDescRotation(e, u), applyDescScale(e, u), u;
  }
  createRawTexturedMeshObject(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      const s = this.renderer.pickingManager.newId();
      if (!(e.mesh instanceof IndexedTriangleMesh))
        throw new Error("Unknown/unsupported mesh type");
      const o = e.mesh.pickingUserId !== void 0;
      let a;
      switch (e.texture.type) {
        case "url":
          a = yield this.renderer.textureCache.load(e.texture.url);
          break;
        case "canvas":
          a = yield this.renderer.textureCache.load(e.texture.canvas);
          break;
      }
      const l = constructMeshThreeMaterial(e.material, [], s, o, !1, a), u = new Mesh(e.mesh.geometry, l), c = new MeshObject(u, WorldObjectType.MeshObject, s, e.mesh, a);
      return this.renderer.pickingManager.setForId(s, {
        objectType: ObjectType.Primitive,
        rootObject: c
      }), this.renderer.pickingManager.setIdForObject(u.id, s), applyDescPosition(e, c), applyDescRotation(e, c), applyDescScale(e, c), c;
    });
  }
  createTileset(e) {
    var s, o, a;
    return __awaiter$8(this, void 0, void 0, function* () {
      let l;
      switch (e.type) {
        case "cesium":
          if (this.cesium !== void 0) {
            const u = yield this.cesium.getAssetEndpoint(e.assetId);
            if (u.isExternal)
              throw new Error(`Cesium Ion asset '${e.assetId}' is an external asset`);
            {
              const c = yield assetFromEndpoint(u.endpoint);
              if (c instanceof CesiumIon3DTilesAsset) {
                l = new TilesetObject(c.createTileset3D((s = e.style) !== null && s !== void 0 ? s : {}, this.renderer.pickingManager, this.renderer.requestManager, e.maximumScreenSpaceError, e.memoryBudget)), l.object.owner = l;
                break;
              } else
                throw new Error(`Cesium Ion asset '${e.assetId}' is not a 3D tiles asset`);
            }
          } else
            throw new Error("Cesium Ion not available");
        case "google":
          if (this.google !== void 0) {
            const u = yield fetchTileset(`https://tile.googleapis.com/v1/3dtiles/root.json?key=${this.google.token}`, !0);
            l = new TilesetObject(new Tileset3D({
              tileset: u,
              styleDesc: (o = e.style) !== null && o !== void 0 ? o : {},
              pickingManager: this.renderer.pickingManager,
              requestManager: this.renderer.requestManager,
              maximumScreenSpaceError: e.maximumScreenSpaceError,
              memoryBudget: e.memoryBudget
            })), l.object.owner = l;
            break;
          } else
            throw new Error("Google not available");
        case "direct": {
          const u = yield fetchTileset(e.url, e.absolute);
          l = new TilesetObject(new Tileset3D({
            tileset: u,
            styleDesc: (a = e.style) !== null && a !== void 0 ? a : {},
            pickingManager: this.renderer.pickingManager,
            requestManager: this.renderer.requestManager,
            maximumScreenSpaceError: e.maximumScreenSpaceError,
            memoryBudget: e.memoryBudget
          })), l.object.owner = l;
          break;
        }
      }
      return l;
    });
  }
  createKml(e) {
    var s;
    return __awaiter$8(this, void 0, void 0, function* () {
      if (!(e.labelFont instanceof FontAsset))
        throw new Error("Unknown IFontAsset implementation");
      let o;
      switch ((s = e.type) !== null && s !== void 0 ? s : "direct") {
        case "cesium":
          const l = e;
          if (this.cesium === void 0)
            throw new Error("Cesium Ion not available");
          const u = yield this.cesium.getAssetEndpoint(l.assetId);
          if (u.isExternal)
            throw new Error(`Cesium Ion asset '${l.assetId}' is an external asset`);
          const c = yield assetFromEndpoint(u.endpoint);
          if (!(c instanceof CesiumIonKMLAsset))
            throw new Error(`Cesium Ion asset '${l.assetId}' is not a 3D tiles asset`);
          o = yield c.loadKml(e.labelFont.cache, e.cacheKey);
          break;
        case "direct":
          const E = e;
          o = yield KmlLoader.load(E.url, { glyphCache: e.labelFont.cache, cacheKey: e.cacheKey });
          break;
      }
      return o === void 0 ? new KmlObject(new Object3D(), [], 0) : new KmlObject(o.object, o.labelPositions, 0);
    });
  }
  createDxf(e) {
    var s;
    return __awaiter$8(this, void 0, void 0, function* () {
      const o = this.renderer.pickingManager.newId(), a = yield DxfLoader.load(e.url, {
        objectId: o,
        cacheKey: e.cacheKey,
        spatialReferenceSystem: e.spatialReferenceSystem,
        removePaperSpaceEntities: (s = e.removePaperSpaceEntities) !== null && s !== void 0 ? s : !0
      }), l = new DxfObject(a, o);
      return this.renderer.pickingManager.setForId(o, {
        objectType: ObjectType.Primitive,
        rootObject: l
      }), this.renderer.pickingManager.setIdForObject(a.id, o), l;
    });
  }
  createObj(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      const s = this.renderer.pickingManager.newId(), o = new ObjTask(e.url, {
        objectId: s,
        cacheKey: e.cacheKey
      });
      this.renderer.config.debug.multithreadedObj ? yield o.run(this.renderer.getTaskPool()) : yield o.run();
      const a = o.object, l = new ObjObject(a, s);
      return this.renderer.pickingManager.setForId(s, {
        objectType: ObjectType.Primitive,
        rootObject: l
      }), this.renderer.pickingManager.setIdForObject(a.id, s), l.applyMaterial(e.material), l;
    });
  }
  createIfc(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      const s = this.renderer.pickingManager.newId(), { ifcApi: o, modelId: a, mesh: l, rangeGroups: u } = yield IfcLoader.load(e.url, {
        objectId: s,
        cacheKey: e.cacheKey
      }), c = this.renderer.pickingManager, E = new IfcObject(new Ifc3D({
        ifcApi: o,
        mesh: l,
        rangeGroups: u,
        modelId: a,
        pickingManager: c,
        objectId: s
      }), s);
      return E.object.owner = E, E.object.refreshGroups(), E;
    });
  }
  createSprite(e) {
    return __awaiter$8(this, void 0, void 0, function* () {
      const s = this.renderer.pickingManager.newId(), o = yield this.renderer.textureCache.load(e.url), a = new Sprite(new PickingSpriteMaterial({
        map: o,
        sizeAttenuation: e.sizeAttenuation === void 0 ? !0 : e.sizeAttenuation,
        alphaTest: 0.5,
        objectId: s,
        extraId: 0,
        transparent: !1
      })), l = new SpriteObject(a, s, e.pickingUserId);
      return this.renderer.pickingManager.setForId(s, {
        objectType: ObjectType.Primitive,
        rootObject: l
      }), this.renderer.pickingManager.setIdForObject(a.id, s), applyDescPosition(e, l), applyDescScale(e, l), e.material !== void 0 && l.applyMaterial(e.material), l;
    });
  }
  createLabelCollection(e) {
    const s = this.renderer.pickingManager.newId();
    if (e.font instanceof FontAsset) {
      const o = new LabelCollection(e.font.cache), a = new LabelCollectionObject(o, s);
      return applyDescPosition(e, a), a;
    } else
      throw new Error("Unknown IFontAsset implementation");
  }
}
function applyDescPosition(r, e) {
  "ecef" in r.position ? e.setPositionECEF(r.position.ecef) : e.setPositionCartographic(r.position.cartographic);
}
function applyDescRotation(r, e) {
  if (r.rotation !== void 0)
    switch (r.rotation.type) {
      case "explicit":
        e.setRotation(r.rotation.quaternion);
        break;
      case "cartographic":
        e.setRotationCartographic(r.rotation.cartographic, r.rotation.heading);
    }
}
function applyDescScale(r, e) {
  typeof r.scale < "u" && e.setScale(r.scale);
}
BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
Mesh.prototype.raycast = acceleratedRaycast;
class ThreeRenderer {
  constructor(e, s, o) {
    this.frameData = {
      frameIndex: 0,
      options: {
        eyeDomeLighting: {
          enabled: !1,
          density: 2,
          strength: 0.75
        },
        globeClipping: !1,
        lighting: !0,
        gammaCorrectionFactor: 2.2,
        useLocalCache: !0,
        globeNetworkRequests: {
          requestSorting: !0,
          maxInFlight: 128
        },
        tilesetNetworkRequests: {
          requestSorting: !0,
          maxInFlight: 16
        },
        debug: {
          sunLightDirection: !1,
          tileDebugColoring: TileDebugColorMode.None,
          tileBoundingVolumes: !1,
          tileBoundingVolumesShowRegion: !0,
          tileBoundingVolumesShowBox: !0,
          tileBoundingVolumesShowRegionSphere: !1,
          tileBoundingVolumesShowBoxSphere: !1,
          tileFrustumCulling: !0,
          globeTileFrustumCulling: !0,
          imageryBackfaceCulling: !0,
          imageryTileBoundingVolumes: !1,
          imageryLayerBoundingVolumes: !1,
          geometryTileBoundingVolumes: !1,
          showQueuedRequests: !1,
          showRequestsInFlight: !1,
          multithreadedObj: !0,
          requestCancelling: !1
        }
      }
    }, this.resizeListeners = [], Object3D.DEFAULT_UP.set(0, 0, 1), this.renderer = new WebGLRenderer({
      logarithmicDepthBuffer: !0,
      preserveDrawingBuffer: !0
    }), this.renderer.userData = e, this.renderer.outputColorSpace = SRGBColorSpace, this.renderer.debug.checkShaderErrors = !0, this.renderer.autoClear = !1, this.renderer.localClippingEnabled = !0, assert(this.renderer.capabilities.isWebGL2, "We require WebGL2 support"), this.renderer.setSize(s, o), this.gl = this.renderer.getContext();
  }
  get config() {
    return this.frameData.options;
  }
  /**
   * Internal function for incrementing the frame index
   */
  nextFrame() {
    this.frameData.frameIndex += 1;
  }
  getFrameIndex() {
    return this.frameData.frameIndex;
  }
  /**
   * Add a resize listener
   * @param listener
   */
  addResizeListener(e) {
    this.resizeListeners.push(e);
  }
  /**
   * Removes the given listener for the set of listeners, if it exists in the set. Otherwise does nothing.
   * @param listener
   */
  removeResizeListener(e) {
    const s = this.resizeListeners.findIndex((o) => o === e);
    s >= 0 && this.resizeListeners.splice(s, 1);
  }
  /**
   * Returns the DOM element being used as a rendering target by the renderer
   *
   * Will never change between calls
   */
  getDomElement() {
    return this.renderer.domElement;
  }
  /**
   * Resize the drawing buffers to match the requested size.
   *
   * Use this when the canvas changes size to update the drawing buffers
   *
   * @param width Width in pixels
   * @param height Height in pixels
   */
  setSize(e, s) {
    for (const o of this.resizeListeners)
      o(this, this.renderer, e, s);
    this.renderer.setSize(e, s);
  }
  /**
   * Returns the current size of the drawing surfaces
   *
   * @param target Vector2 instance to write the results into
   */
  getSize(e = new Vector2()) {
    return this.renderer.getSize(e);
  }
  /**
   * Performs a full rendering cycle with the given scene and camera.
   *
   * This will call 'prepare' on each 'PreparingObject' in all the provided scenes, then will execute the list of
   * passes in the provided order.
   *
   * @param scenes The scenes to render
   * @param passes The render passes to use
   * @param camera The camera to render the scene from
   */
  render(e, s, o) {
    for (const a of Object.values(e)) {
      const l = [a];
      for (; l.length > 0; ) {
        const u = l.pop();
        u instanceof PreparingObject ? u.prepare(this, o, this.frameData) : l.push(...u.children);
      }
    }
    o.updateMatrixWorld();
    for (const a of s)
      a.render(this, this.renderer, o.getCurrentCamera(), e);
  }
}
function generateQuad(r, e) {
  const s = new Float32Array(r * e * 3), o = new Float32Array(r * e * 2);
  let a = 0, l = 0;
  for (let d = 0; d < e; ++d) {
    const f = d / (e - 1);
    s[a++] = 0, s[a++] = f, s[a++] = 0, o[l++] = 0, o[l++] = f, s[a++] = 1, s[a++] = f, s[a++] = 0, o[l++] = 1, o[l++] = f;
  }
  const u = new Float32Array((r - 1) * (e - 1) * 6);
  let c = 0, E = 0;
  for (let d = 0; d < e - 1; ++d) {
    for (let f = 0; f < r - 1; ++f) {
      const h = c, S = h + r, R = S + 1, _ = h + 1;
      u[E++] = S, u[E++] = h, u[E++] = R, u[E++] = _, u[E++] = R, u[E++] = h, ++c;
    }
    ++c;
  }
  return new BufferGeometry().setAttribute("position", new Float32BufferAttribute(s, 3, !1)).setAttribute("uv", new Float32BufferAttribute(o, 2, !1)).setIndex(Array.from(u));
}
class RendererUtils {
}
RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES = 64;
RendererUtils.FULLSCREEN_QUAD = generateQuad(2, 2);
RendererUtils.GEOGRAPHIC_QUAD = generateQuad(2, RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES);
RendererUtils.UNIT_ORTHOGRAPHIC = new OrthographicCamera$1(0, 1, 1, 0, -1, 1);
class ScenePass {
  constructor(e, s = {}) {
    var o, a, l;
    this.rt = e, this.clearColor = (o = s.clearColor) !== null && o !== void 0 ? o : () => !1, this.clearDepth = (a = s.clearDepth) !== null && a !== void 0 ? a : () => !1, this.clearStencil = (l = s.clearStencil) !== null && l !== void 0 ? l : () => !1, this.sceneName = s.sceneName || "background";
  }
  render(e, s, o, a) {
    typeof a < "u" && (s.setRenderTarget(this.rt), (this.clearColor() || this.clearDepth() || this.clearStencil()) && (s.setClearAlpha(0), s.clear(this.clearColor(), this.clearDepth(), this.clearStencil())), s.render(a[this.sceneName], o));
  }
}
class FilteredScenePass {
  constructor(e, s = {}, o) {
    var a, l, u;
    this.rt = e, this.clearColor = (a = s.clearColor) !== null && a !== void 0 ? a : () => !1, this.clearDepth = (l = s.clearDepth) !== null && l !== void 0 ? l : () => !1, this.clearStencil = (u = s.clearStencil) !== null && u !== void 0 ? u : () => !1, this.sceneName = s.sceneName || "background", this.filter = o;
  }
  render(e, s, o, a) {
    if (typeof a < "u") {
      s.setRenderTarget(this.rt), (this.clearColor() || this.clearDepth() || this.clearStencil()) && (s.setClearAlpha(0), s.clear(this.clearColor(), this.clearDepth(), this.clearStencil()));
      const l = /* @__PURE__ */ new Set();
      a[this.sceneName].traverseVisible((u) => {
        if (u instanceof Mesh || u instanceof Line$1 || u instanceof Points)
          if (Array.isArray(u.material))
            for (const c of u.material)
              this.filter(c, u) || l.add(c);
          else
            this.filter(u.material, u) || l.add(u.material);
      });
      for (const u of l)
        u.visible = !1;
      s.render(a[this.sceneName], o);
      for (const u of l)
        u.visible = !0;
    }
  }
}
class EDLPass {
  constructor(e, s, o) {
    this.material = new ShaderMaterial({
      vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
      fragmentShader: `
                varying vec2 vUv;

                uniform sampler2D uColor;
                uniform sampler2D uFragCoord;

                uniform float uInvWidth;
                uniform float uInvHeight;

                uniform bool uOrthoCamera;
                uniform float uZNear;
                uniform float uZFar;

                uniform bool uEnabled;
                uniform float uGammaCorrectionFactor;
                uniform float uDensity;
                uniform float uStrength;

                float cameraSpaceZ(float d, float zNear, float zFar) {
                    float z = 2.0 * d - 1.0;
                    if (uOrthoCamera) 
                        return ((z + (zFar + zNear)/(zFar - zNear)) * (zFar - zNear))/-2.0;
                    else
                        return 2.0 * zNear * zFar / (zFar + zNear - z * (zFar - zNear));
                }                    

                float getDepth(vec2 pixelOffset) {
                    vec2 offset = pixelOffset * vec2(uInvWidth, uInvHeight);
                    float d = texture(uFragCoord, vUv + offset).r;
                    return cameraSpaceZ(d, uZNear, uZFar);
                }

                float calculateOcclusion(float depth, float neighbourDepth, float distance) {
                    return max(0.0, neighbourDepth - depth) / distance;
                }

                void main() {
                    float light = 1.0;
                    if (uEnabled) {
                        float occlusion = 0.0;
                        float depth = getDepth(vec2(0.0,0.0));

                        occlusion += calculateOcclusion(depth, getDepth(vec2(-1.0, -1.0)), length(vec2(-1.0, -1.0)));
                        occlusion += calculateOcclusion(depth, getDepth(vec2(-1.0, 0.0)), length(vec2(-1.0, 0.0)));
                        occlusion += calculateOcclusion(depth, getDepth(vec2(-1.0, 1.0)), length(vec2(-1.0, 1.0)));

                        occlusion += calculateOcclusion(depth, getDepth(vec2(0.0, -1.0)), length(vec2(0.0, -1.0)));
                        occlusion += calculateOcclusion(depth, getDepth(vec2(0.0, 1.0)), length(vec2(0.0, 1.0)));

                        occlusion += calculateOcclusion(depth, getDepth(vec2(1.0, -1.0)), length(vec2(1.0, -1.0)));
                        occlusion += calculateOcclusion(depth, getDepth(vec2(1.0, 0.0)), length(vec2(1.0, 0.0)));
                        occlusion += calculateOcclusion(depth, getDepth(vec2(1.0, 1.0)), length(vec2(1.0, 1.0)));

                        light = exp(-uDensity * occlusion);
                        light = clamp(light, 0.0, 1.0);
                        light = light * uStrength + (1.0 - uStrength);
                    }

                    gl_FragColor.rgb = texture(uColor, vUv).rgb * light;

                    float gamma = uGammaCorrectionFactor;
                    gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.0 / gamma));
                    
                    gl_FragColor.a = 1.0;
                }
            `,
      uniforms: {
        uColor: { value: e },
        uFragCoord: { value: s },
        uInvWidth: { value: 1 / e.image.width },
        uInvHeight: { value: 1 / e.image.height },
        uZNear: { value: 0 },
        uZFar: { value: 0 },
        uOrthoCamera: { value: !1 },
        uEnabled: { value: !1 },
        uDensity: { value: 2 },
        uStrength: { value: 0.75 },
        uGammaCorrectionFactor: { value: 2.2 }
      }
    }), this.mesh = new Mesh(RendererUtils.FULLSCREEN_QUAD, this.material), this.dst = o;
  }
  render(e, s, o, a) {
    if (this.material) {
      const l = this.material.uniforms.uColor.value;
      this.material.uniforms.uInvWidth.value = 1 / l.image.width, this.material.uniforms.uInvHeight.value = 1 / l.image.height, this.material.uniforms.uEnabled.value = e.config.eyeDomeLighting.enabled, this.material.uniforms.uDensity.value = e.config.eyeDomeLighting.density, this.material.uniforms.uStrength.value = e.config.eyeDomeLighting.strength, this.material.uniforms.uGammaCorrectionFactor.value = e.config.gammaCorrectionFactor, o instanceof PerspectiveCamera$1 ? (this.material.uniforms.uZNear.value = o.near, this.material.uniforms.uZFar.value = o.far, this.material.uniforms.uOrthoCamera.value = !1) : (this.material.uniforms.uZNear.value = o.near, this.material.uniforms.uZFar.value = o.far, this.material.uniforms.uOrthoCamera.value = !0), this.material.uniformsNeedUpdate = !0;
    }
    s.setRenderTarget(this.dst), s.render(this.mesh, RendererUtils.UNIT_ORTHOGRAPHIC);
  }
}
class TileCompositorPass {
  constructor() {
    this.jobs = [], this.material = new MeshBasicMaterial({
      map: null,
      transparent: !0
    });
  }
  /**
   * Adds the given jobs to the job queue.
   * @param jobs
   */
  pushJobs(...e) {
    this.jobs.push(...e);
  }
  render(e, s, o, a) {
    for (const l of this.jobs) {
      this.material.map = l.src;
      let u;
      if (l.reprojectWebMercator) {
        const c = WebMercatorProjection.geodeticLatitudeToMercatorAngle(l.rectangle.north), E = WebMercatorProjection.geodeticLatitudeToMercatorAngle(l.rectangle.south), d = 1 / (c - E), f = new Float32Array(2 * RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES * 2);
        let h = 0;
        for (let S = 0; S < RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES; ++S) {
          const R = S / (RendererUtils.GEOGRAHPIC_QUAD_Y_SAMPLES - 1), _ = (1 - R) * l.rectangle.south + R * l.rectangle.north, L = (WebMercatorProjection.geodeticLatitudeToMercatorAngle(_) - E) * d;
          f[h++] = 0, f[h++] = L, f[h++] = 1, f[h++] = L;
        }
        RendererUtils.GEOGRAPHIC_QUAD.setAttribute("uv", new Float32BufferAttribute(f, 2, !1)), u = new Mesh(RendererUtils.GEOGRAPHIC_QUAD, this.material);
      } else
        u = new Mesh(RendererUtils.FULLSCREEN_QUAD, this.material);
      u.position.set(l.offset.x, l.offset.y, 0), u.scale.set(l.scale.x, l.scale.y, 1), u.updateMatrixWorld(!0), s.setRenderTarget(l.dst), s.render(u, RendererUtils.UNIT_ORTHOGRAPHIC), l.disposeSrc && l.src.dispose();
    }
    this.jobs = [];
  }
}
class ClearColorPass {
  constructor(e, s, o, a, l) {
    this.dst = e, this.r = s, this.g = o, this.b = a, this.a = l;
  }
  render(e, s, o, a) {
    s.setRenderTarget(this.dst), s.setClearColor(new Color(this.r, this.g, this.b)), s.setClearAlpha(this.a), s.clearColor();
  }
}
class World {
  constructor(e) {
    this.objects = /* @__PURE__ */ new Set(), this.panos = /* @__PURE__ */ new Set(), this.scenes = {
      background: new Scene(),
      globe: new Scene(),
      beforePano: new Scene(),
      beforePanoKml: new Scene(),
      beforePanoSplat: new Scene(),
      pano: new Scene(),
      afterPano: new Scene(),
      afterPanoKml: new Scene(),
      afterPanoSplat: new Scene(),
      uiOverlay: new Scene()
    }, this.raycastScene = new Scene(), this.background = new Color(0), this.renderer = e, this.globe = new Globe(e);
  }
  addPanorama(e) {
    if (e instanceof BaseObject)
      this.panos.add(e);
    else
      throw new Error("Unsupported IPanorama implementation");
  }
  removePanorama(e) {
    if (e instanceof BaseObject)
      this.panos.delete(e);
    else
      throw new Error("Unsupported IPanorama implementation");
  }
  addObject(e) {
    this.objects.add(e);
  }
  removeObject(e) {
    this.objects.delete(e);
  }
  getGlobe() {
    return this.globe;
  }
  getCamera() {
    return this.renderer.camera;
  }
  getObjects() {
    return this.objects;
  }
  setBackgroundColor(e) {
    (this.background instanceof Texture || this.background instanceof CubeTexture) && this.background.dispose(), this.background = new Color(e.r, e.g, e.b);
  }
  prepareMaterial(e) {
    const s = this.renderer.threeRenderer.renderer.properties, { x: o, y: a } = this.renderer.getSize(), l = (u, c) => {
      const E = s.get(e).uniforms;
      E && E[u] && (E[u].value = c);
    };
    e instanceof LineMaterial ? e.resolution.set(o, a) : e instanceof PickingPointsMaterial ? this.renderer.camera.getProjectionMode() === CameraProjection.Orthographic && (e.needsUpdate = !0) : (e instanceof PickingMeshPhongMaterial || e instanceof PickingMeshStandardMaterial || e instanceof PickingMeshPhysicalMaterial) && l("unlit", !this.renderer.config.lighting);
  }
  prepareObject(e) {
    e.prepare(this.renderer.threeRenderer, this.renderer.camera.object, this.renderer.threeRenderer.frameData), e.object.traverse((s) => {
      if (s.userData = e, s instanceof Mesh || s instanceof Line$1 || s instanceof Points) {
        const o = s.material;
        if (Array.isArray(o))
          for (const a of o)
            this.prepareMaterial(a);
        else
          this.prepareMaterial(o);
      }
    });
  }
  /**
   * Transient scene that should be built every frame and used once for rendering
   */
  buildScene() {
    for (const e of Object.values(this.scenes))
      e.clear();
    this.raycastScene.clear(), this.globe.checkLayers(), this.globe.inner !== void 0 && this.globe.visible && this.scenes.globe.add(this.globe.inner), this.scenes.background.background = this.background;
    for (const e of this.objects)
      if (e instanceof DrawableObject && e.visible) {
        this.prepareObject(e);
        const s = e.getObjectType();
        switch (e.getRenderLayer()) {
          case RenderLayer.Main:
            s === WorldObjectType.KmlObject ? this.scenes.beforePanoKml.add(e.object) : s === WorldObjectType.GaussianSplat ? this.scenes.beforePanoSplat.add(e.object) : this.scenes.beforePano.add(e.object);
            break;
          case RenderLayer.AfterPanorama:
            s === WorldObjectType.KmlObject ? this.scenes.afterPanoKml.add(e.object) : s === WorldObjectType.GaussianSplat ? this.scenes.afterPanoSplat.add(e.object) : this.scenes.afterPano.add(e.object);
            break;
          case RenderLayer.UIOverlay:
            this.scenes.uiOverlay.add(e.object);
            break;
        }
      }
    for (const e of this.panos)
      this.prepareObject(e), e.getVisible() && this.scenes.pano.add(e.object);
    return this.raycastScene.add(this.scenes.globe, this.scenes.beforePano, this.scenes.afterPano, this.scenes.uiOverlay), this.scenes;
  }
}
const SCRATCH = new Vector3$1();
class CameraAwareSunLight extends PreparingObject {
  constructor() {
    super(), this.direction = new Vector3$1(), this.light = new DirectionalLight(4294967295, 0.8), this.add(this.light), this.add(this.light.target);
  }
  prepare(e, s, o) {
    super.prepare(e, s, o), s.matrixWorld.extractBasis(SCRATCH, SCRATCH, this.direction);
    const a = this.direction.negate().multiplyScalar(1e3).add(s.position);
    this.light.position.set(s.position.x, s.position.y, s.position.z), this.light.target.position.set(a.x, a.y, a.z), o.options.debug.sunLightDirection && DebugDraw.addLine(this.light.position, this.light.target.position);
  }
}
class ClippingGroup {
  constructor() {
    this.enabled = !1, this.objects = /* @__PURE__ */ new Set(), this.threePlanes = [], this.disabledThreePlanes = [], this.planes = [];
  }
  addObject(e) {
    e instanceof BaseObject && e.setClippingPlanes(this.threePlanes), this.objects.add(e);
  }
  removeObject(e) {
    e instanceof BaseObject && e.setClippingPlanes([]), this.objects.delete(e);
  }
  clear() {
    for (const e of this.objects)
      this.removeObject(e);
  }
  getEnabled() {
    return this.enabled;
  }
  setEnabled(e) {
    if (e && !this.enabled) {
      for (const s of this.disabledThreePlanes)
        this.threePlanes.push(s);
      this.disabledThreePlanes.length = 0;
      for (const s of this.objects)
        s instanceof BaseObject && s.invalidateMaterials();
    } else if (!e && this.enabled) {
      for (const s of this.threePlanes)
        this.disabledThreePlanes.push(s);
      this.threePlanes.length = 0;
      for (const s of this.objects)
        s instanceof BaseObject && s.invalidateMaterials();
    }
    this.enabled = e;
  }
  resolvePlanes() {
    const e = this.enabled ? this.threePlanes : this.disabledThreePlanes;
    e.length = 0;
    for (const s of this.planes) {
      const o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = new Vector3$1(s.normal.x, s.normal.y, s.normal.z), l = new Plane().setFromNormalAndCoplanarPoint(a, o);
      e.push(l);
    }
    for (const s of this.objects)
      s instanceof BaseObject && s.invalidateMaterials();
  }
}
var __awaiter$7 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class FontLoader {
  static load(e, s) {
    return __awaiter$7(this, void 0, void 0, function* () {
      const o = yield FileLoader.loadArrayBuffer(e, s), a = HarfBuzz.module.createBlob(o), l = HarfBuzz.module.createFace(a, 0), u = HarfBuzz.module.createFont(l);
      return {
        data: o,
        blob: a,
        face: l,
        font: u,
        destroy() {
          this.font.destroy(), this.face.destroy(), this.blob.destroy();
        }
      };
    });
  }
}
class RequestManager {
  constructor(e, s) {
    this.queue = [], this.inFlight = [], this.errors = [], this.globeTileOptions = e, this.tilesetTileOptions = s;
  }
  /**
   * Count the number of requests for each type in flight.
   *
   * @param type
   * @returns
   */
  countInFlight(e) {
    if (!e)
      return this.inFlight.length;
    let s = 0;
    for (const o of this.inFlight)
      o.type === e && s++;
    return s;
  }
  /**
   * Count the number of requests in queue.
   */
  countQueued(e) {
    if (!e)
      return this.queue.length;
    let s = 0;
    for (const o of this.queue)
      o.handle.type === e && s++;
    return s;
  }
  /**
   * Test to see if a request handle can be promoted to in-flight.
   *
   * @param handle
   * @returns
   */
  canStartRequest(e) {
    const s = this.countInFlight("globe"), o = this.countInFlight("tileset"), a = this.countInFlight("priority") + this.countQueued("priority");
    return !(e.type !== "priority" && a > 0 || e.type === "globe" && s >= this.globeTileOptions.maxInFlight || e.type === "tileset" && o >= this.tilesetTileOptions.maxInFlight);
  }
  /**
   * Remove a handle in flight.
   *
   * @param handle
   */
  removeInFlight(e) {
    const s = this.inFlight.findIndex((o) => o === e);
    if (s < 0)
      throw new Error("Could not remove completed in-flight request... Wtf???");
    this.inFlight.splice(s, 1);
  }
  /**
   * Update the request manager.
   */
  update() {
    if (this.errors.length > 0)
      throw this.errors.pop();
    this.queue = this.queue.sort((s, o) => s.sortKey - o.sortKey);
    for (const s of this.queue)
      this.canStartRequest(s.handle) ? (this.inFlight.push(s.handle), s.handle.status = "inflight", s.start()) : (s.handle.status = "cancelled", s.abort("Request Cancelled"));
    this.queue.length = 0, this.countInFlight("priority") > 0 && (this.cancelInFlight("globe"), this.cancelInFlight("tileset"));
  }
  cancelInFlight(e) {
    for (const s of this.inFlight)
      (!e || s.type === e) && s.cancel();
  }
  /**
   * Enqueue a network request.
   *
   * @param type
   * @param sortKey
   * @param callback
   * @paran onCancelInFlight
   * @returns
   */
  queueRequest(e, s, o = 0, a = () => {
  }) {
    let l = () => {
    }, u = () => {
    };
    const E = new Promise((f, h) => {
      l = f, u = h;
    }).then(s).then((f) => (d.status = "complete", this.removeInFlight(d), f), (f) => {
      f instanceof DOMException && f.name === "AbortError" ? (d.status = "cancelled", this.removeInFlight(d)) : f === "Request Cancelled" || (this.errors.push(f), d.status = "complete", this.removeInFlight(d));
    }), d = {
      type: e,
      status: "queued",
      promise: E,
      cancel: a
    };
    return this.queue.push({
      sortKey: o,
      start: l,
      abort: u,
      handle: d
    }), d;
  }
}
class RenderTargets {
  /**
   * Constructs a new 'RenderTargets' object.
   *
   * This will also register
   * @param width
   * @param height
   */
  constructor(e, s) {
    this.main = new WebGLMultipleRenderTargets(e, s, 5), this.main.texture[0].minFilter = NearestFilter, this.main.texture[0].magFilter = NearestFilter, this.main.texture[0].format = RGBAFormat, this.main.texture[0].type = UnsignedByteType, this.main.texture[0].colorSpace = SRGBColorSpace, this.main.texture[0].generateMipmaps = !1, this.main.texture[0].name = "pc_fragColor", this.main.texture[1].minFilter = NearestFilter, this.main.texture[1].magFilter = NearestFilter, this.main.texture[1].format = RGBAFormat, this.main.texture[1].type = UnsignedByteType, this.main.texture[1].generateMipmaps = !1, this.main.texture[1].name = "pc_pickingBuffer1", this.main.texture[2].minFilter = NearestFilter, this.main.texture[2].magFilter = NearestFilter, this.main.texture[2].format = RGBAFormat, this.main.texture[2].type = UnsignedByteType, this.main.texture[2].generateMipmaps = !1, this.main.texture[2].name = "pc_pickingBuffer2", this.main.texture[3].minFilter = NearestFilter, this.main.texture[3].magFilter = NearestFilter, this.main.texture[3].format = RGFormat, this.main.texture[3].type = FloatType, this.main.texture[3].generateMipmaps = !1, this.main.texture[3].name = "pc_fragCoordBuffer", this.main.texture[4].minFilter = NearestFilter, this.main.texture[4].magFilter = NearestFilter, this.main.texture[4].format = RGFormat, this.main.texture[4].type = FloatType, this.main.texture[4].generateMipmaps = !1, this.main.texture[4].name = "pc_fragCoordBufferEDL", this.main.depthBuffer = !0, this.main.depthTexture = new DepthTexture(e, s), this.main.texture.format = RGBAFormat, this.main.texture.type = UnsignedByteType, this.opaquePanos = new WebGLMultipleRenderTargets(e, s, 2), this.opaquePanos.texture[0] = this.main.texture[0], this.opaquePanos.texture[1] = this.main.texture[4], this.opaquePanos.depthBuffer = !1, this.fragCoord = new WebGLRenderTarget(e, s, {
      depthBuffer: !1
    }), this.fragCoord.texture = this.main.texture[3], this.noPicking = new WebGLRenderTarget(e, s, {
      // @ts-ignore
      depthTexture: this.main.depthTexture,
      depthBuffer: !0,
      minFilter: NearestFilter,
      magFilter: NearestFilter,
      format: RGBAFormat,
      type: UnsignedByteType,
      generateMipmaps: !1
    }), this.noPicking.texture = this.main.texture[0], this.kml = new WebGLRenderTarget(e, s, {
      depthBuffer: !0,
      minFilter: NearestFilter,
      magFilter: NearestFilter,
      format: RGBAFormat,
      type: UnsignedByteType,
      generateMipmaps: !1
    }), this.kml.texture = this.main.texture[0], this.splat = new WebGLRenderTarget(e, s, {
      depthBuffer: !0,
      minFilter: NearestFilter,
      magFilter: NearestFilter,
      format: RGBAFormat,
      type: UnsignedByteType,
      generateMipmaps: !1
    }), this.splat.texture = this.main.texture[0], this.edl = new WebGLRenderTarget(e, s, {
      depthBuffer: !1,
      minFilter: LinearFilter,
      magFilter: LinearFilter,
      format: RGBAFormat,
      type: UnsignedByteType,
      generateMipmaps: !1
    });
  }
  /**
   * Unregister all resize listeners and dispose all resources owned by the 'RenderTargets' instance.
   */
  dispose() {
    this.main.texture.forEach((e) => e.dispose()), this.main.dispose(), this.opaquePanos.texture.forEach((e) => e.dispose()), this.opaquePanos.dispose(), this.fragCoord.texture.dispose(), this.fragCoord.dispose(), this.splat.texture.dispose(), this.splat.dispose(), this.kml.texture.dispose(), this.kml.dispose(), this.noPicking.texture.dispose(), this.noPicking.dispose(), this.edl.dispose();
  }
  /**
   * Resize the render targets
   */
  resize(e, s) {
    e = Math.max(1, e), s = Math.max(1, s), this.main.setSize(e, s), this.opaquePanos.setSize(e, s), this.fragCoord.setSize(e, s), this.noPicking.setSize(e, s), this.splat.setSize(e, s), this.kml.setSize(e, s), this.edl.setSize(e, s);
  }
}
class PickingCache {
  constructor(e) {
    this.wsCache = /* @__PURE__ */ new Map(), this.vsCache = /* @__PURE__ */ new Map(), this.wssCache = /* @__PURE__ */ new Map(), this.vssCache = /* @__PURE__ */ new Map(), this.wsrCache = /* @__PURE__ */ new Map(), this.vsrCache = /* @__PURE__ */ new Map(), this.renderer = e;
  }
  /**
   * Should be called at the beginning of every frame. Invalidates the pick cache (removes all the entries) so we can
   * get new values.
   */
  newFrame() {
    this.wsCache.clear(), this.vsCache.clear(), this.wssCache.clear(), this.vssCache.clear(), this.wsrCache.clear(), this.vsrCache.clear();
  }
  /**
   * @see Renderer.pickScreenWorldSpace
   * @param point
   */
  pickScreenWorldSpace(e) {
    return this.getWithDefaultInitializer(e, this.wsCache, (s) => this.renderer.pickScreenWorldSpaceImpl(s));
  }
  /**
   * @see Renderer.pickScreenViewSpace
   * @param point
   */
  pickScreenViewSpace(e) {
    return this.getWithDefaultInitializer(e, this.vsCache, (s) => this.renderer.pickScreenViewSpaceImpl(s));
  }
  /**
   * @see Renderer.pickScreenWorldSpaceSnapping
   * @param point
   */
  pickScreenWorldSpaceSnapping(e) {
    return this.getWithDefaultInitializer(e, this.wssCache, (s) => this.renderer.pickScreenWorldSpaceSnappingImpl(s));
  }
  /**
   * @see Renderer.pickScreenViewSpaceSnapping
   * @param point
   */
  pickScreenViewSpaceSnapping(e) {
    return this.getWithDefaultInitializer(e, this.vssCache, (s) => this.renderer.pickScreenViewSpaceSnappingImpl(s));
  }
  /**
   * @see Renderer.pickScreenWorldSpaceRect
   * @param point
   */
  pickScreenWorldSpaceRect(e) {
    return this.getWithDefaultInitializer(e, this.wsrCache, (s) => this.renderer.pickScreenWorldSpaceRectImpl(s));
  }
  /**
   * @see Renderer.pickScreenViewSpaceRect
   * @param point
   */
  pickScreenViewSpaceRect(e) {
    return this.getWithDefaultInitializer(e, this.wsrCache, (s) => this.renderer.pickScreenViewSpaceRectImpl(s));
  }
  /**
   * Internal function that implements the caching layer for any arbitrary picking function. Gets used by the public
   * interface to implement each picking variant without duplicating code.
   * @param point
   * @param cache
   * @param initializer
   * @private
   */
  getWithDefaultInitializer(e, s, o) {
    const a = this.hashPoint(e), l = s.get(a);
    if (l !== void 0)
      return l;
    {
      const u = o(e);
      return s.set(a, u), u;
    }
  }
  /**
   * Returns the spatial hash of the given screen coordinate. Will produce a unique hash for all integer points within
   * the range (0,0) (65535, 65535). Points outside this range may produce hash collisions.
   * @param point
   * @private
   */
  hashPoint(e) {
    return 65536 * e.y + e.x;
  }
}
var __awaiter$6 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Google {
  /**
   * Constructs a new Google connection with the provided access token
   * @param token The Google Maps API key to use with all network requests
   * @param options
   */
  constructor(e, s) {
    this.token = e;
  }
  /**
   * Create a new map session.
   *
   * @returns
   */
  createMapSession() {
    return __awaiter$6(this, void 0, void 0, function* () {
      return (yield fetch(`https://tile.googleapis.com/v1/createSession?key=${this.token}`, {
        method: "POST",
        body: JSON.stringify({
          mapType: "satellite",
          language: "en-US",
          region: "US"
        })
      })).json();
    });
  }
  /**
   * Get the map session.
   */
  getMapSession() {
    return __awaiter$6(this, void 0, void 0, function* () {
      const e = Date.now() / 1e3, s = 10;
      return (!this.sessionCache || Number(this.sessionCache.expiry) < e + s) && (this.sessionCache = yield this.createMapSession()), this.sessionCache;
    });
  }
}
var __awaiter$5 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class WorkerPool {
  constructor(e) {
    this.workers = [];
    for (const s of e) {
      const o = {
        object: s,
        tasks: [],
        free: !0
      };
      o.object.onmessage = (a) => {
        const { resolve: l } = o.tasks[0];
        l(a.data), o.tasks.shift(), o.free = !0, this.nextTask(o);
      }, o.object.onerror = (a) => {
        var l;
        if (o.tasks.length === 0)
          throw new Error(`Worker Pool has encountered an error: ${(l = a.message) !== null && l !== void 0 ? l : ""}`);
        const { reject: u } = o.tasks[0];
        u("Worker encountered an error while processing this task."), o.tasks.shift(), o.free = !0, this.nextTask(o);
      }, this.workers.push(o);
    }
  }
  nextTask(e) {
    e.free && e.tasks.length > 0 && (e.object.postMessage(e.tasks[0].data, e.tasks[0].transfer), e.free = !1);
  }
  queueTask(e, s = []) {
    const o = this.workers.slice().sort((a, l) => a.tasks.length - l.tasks.length)[0];
    return this.queueTaskOnWorker(o, e, s);
  }
  // We can't use transfer here, since transfer implies a destructive MOVE, and we're
  // dispatching to multiple workers
  queueTaskOnAllWorkers(e) {
    return Promise.allSettled(this.workers.map((s) => this.queueTaskOnWorker(s, e, [])));
  }
  queueTaskOnWorker(e, s, o = []) {
    let a = () => {
    }, l = () => {
    };
    const u = new Promise((c, E) => {
      a = c, l = E;
    });
    return e.tasks.push({ data: s, transfer: o, resolve: a, reject: l, promise: u }), this.nextTask(e), u;
  }
  waitForTasksToComplete() {
    return __awaiter$5(this, void 0, void 0, function* () {
      yield Promise.allSettled(this.workers.map((e) => e.tasks).flat().map((e) => e.promise));
    });
  }
  terminate() {
    for (const e of this.workers) {
      for (const { reject: s } of e.tasks)
        s("Pool was terminated before task could be completed.");
      e.object.terminate();
    }
    this.workers = [];
  }
}
var __awaiter$4 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
const workerURL = "TaskWorker.es.js";
class TaskPool {
  constructor(e) {
    const s = [
      new Worker(e + workerURL, { type: "module" }),
      new Worker(e + workerURL, { type: "module" }),
      new Worker(e + workerURL, { type: "module" }),
      new Worker(e + workerURL, { type: "module" })
    ];
    this.pool = new WorkerPool(s);
  }
  queueTask(e) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const s = [], o = e.save(s), a = e.className(), l = yield this.pool.queueTask({ type: a, data: o }, s);
      e.load(l);
    });
  }
  // To be used for initialization and configuration tasks, that should run on all workers and don't give result values.
  queueTaskOnAllWorkers(e) {
    return __awaiter$4(this, void 0, void 0, function* () {
      const s = [], o = e.save(s), a = e.className();
      yield this.pool.queueTaskOnAllWorkers({ type: a, data: o });
    });
  }
  waitForTasksToComplete() {
    return __awaiter$4(this, void 0, void 0, function* () {
      return this.pool.waitForTasksToComplete();
    });
  }
  terminate() {
    this.pool.terminate();
  }
}
var __awaiter$3 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class ConfigFileLoaderTask extends Task {
  constructor(e) {
    super(), this.config = e;
  }
  do() {
    return __awaiter$3(this, void 0, void 0, function* () {
      this.config && (FileLoader.CONFIGURATION = this.config);
    });
  }
  save(e) {
    if (!this.config)
      throw new Error("Missing config");
    return JSON.stringify(this.config);
  }
  load(e) {
    this.config = JSON.parse(e);
  }
  className() {
    return "ConfigFileLoaderTask";
  }
}
class FXAAPass {
  constructor(e, s) {
    this.material = new ShaderMaterial({
      vertexShader: `
                varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
            `,
      fragmentShader: `
                #define EDGE_THRESHOLD_MIN 0.0312
                #define EDGE_THRESHOLD_MAX 0.125
                #define SUBPIXEL_QUALITY 0.75
                #define ITERATIONS 12

                varying vec2 vUv;

                uniform sampler2D uColor;

                uniform float uInvWidth;
                uniform float uInvHeight;

                float rgb2luma(vec3 rgb){
                    return sqrt(dot(rgb, vec3(0.299, 0.587, 0.114)));
                }

                float getLuma(vec2 pixelOffset) {
                    vec2 offset = pixelOffset * vec2(uInvWidth, uInvHeight);
                    vec3 color = texture(uColor, vUv + offset).rgb;
                    return rgb2luma(color);
                }

                void main() {  
                    vec3 colorCenter = texture(uColor, vUv).rgb;

                    // Luma at the current fragment
                    float lumaCenter = rgb2luma(colorCenter);

                    // Luma at the four direct neighbours of the current fragment.
                    float lumaDown = getLuma(vec2(0.0, -1.0));
                    float lumaUp = getLuma(vec2(0.0, 1.0));
                    float lumaLeft = getLuma(vec2(-1.0, 0.0));
                    float lumaRight = getLuma(vec2(1.0, 0.0));

                    // Find the maximum and minimum luma around the current fragment.
                    float lumaMin = min(lumaCenter,min(min(lumaDown,lumaUp),min(lumaLeft,lumaRight)));
                    float lumaMax = max(lumaCenter,max(max(lumaDown,lumaUp),max(lumaLeft,lumaRight)));

                    // Compute the delta.
                    float lumaRange = lumaMax - lumaMin;

                    // If the luma variation is lower that a threshold (or if we are in a really dark area), we are not on an edge, don't perform any AA.
                    if(lumaRange < max(EDGE_THRESHOLD_MIN,lumaMax*EDGE_THRESHOLD_MAX)){
                        gl_FragColor = vec4(colorCenter, 1.0);
                        return;
                    }       

                    // Query the 4 remaining corners lumas.
                    float lumaDownLeft = getLuma(vec2(-1.0, -1.0)); 
                    float lumaUpRight = getLuma(vec2(1.0, 1.0)); 
                    float lumaUpLeft = getLuma(vec2(-1.0, 1.0)); 
                    float lumaDownRight = getLuma(vec2(1.0, -1.0)); 

                    // Combine the four edges lumas (using intermediary variables for future computations with the same values).
                    float lumaDownUp = lumaDown + lumaUp;
                    float lumaLeftRight = lumaLeft + lumaRight;

                    // Same for corners
                    float lumaLeftCorners = lumaDownLeft + lumaUpLeft;
                    float lumaDownCorners = lumaDownLeft + lumaDownRight;
                    float lumaRightCorners = lumaDownRight + lumaUpRight;
                    float lumaUpCorners = lumaUpRight + lumaUpLeft;

                    // Compute an estimation of the gradient along the horizontal and vertical axis.
                    float edgeHorizontal =  abs(-2.0 * lumaLeft + lumaLeftCorners)  + abs(-2.0 * lumaCenter + lumaDownUp ) * 2.0    + abs(-2.0 * lumaRight + lumaRightCorners);
                    float edgeVertical =    abs(-2.0 * lumaUp + lumaUpCorners)      + abs(-2.0 * lumaCenter + lumaLeftRight) * 2.0  + abs(-2.0 * lumaDown + lumaDownCorners);

                    // Is the local edge horizontal or vertical ?
                    bool isHorizontal = (edgeHorizontal >= edgeVertical);

                    // Select the two neighboring texels lumas in the opposite direction to the local edge.
                    float luma1 = isHorizontal ? lumaDown : lumaLeft;
                    float luma2 = isHorizontal ? lumaUp : lumaRight;
                    // Compute gradients in this direction.
                    float gradient1 = luma1 - lumaCenter;
                    float gradient2 = luma2 - lumaCenter;

                    // Which direction is the steepest ?
                    bool is1Steepest = abs(gradient1) >= abs(gradient2);

                    // Gradient in the corresponding direction, normalized.
                    float gradientScaled = 0.25*max(abs(gradient1),abs(gradient2));                    

                    // Choose the step size (one pixel) according to the edge direction.
                    float stepLength = isHorizontal ? uInvHeight : uInvWidth;

                    // Average luma in the correct direction.
                    float lumaLocalAverage = 0.0;

                    if(is1Steepest){
                        // Switch the direction
                        stepLength = - stepLength;
                        lumaLocalAverage = 0.5*(luma1 + lumaCenter);
                    } else {
                        lumaLocalAverage = 0.5*(luma2 + lumaCenter);
                    }

                    // Shift UV in the correct direction by half a pixel.
                    vec2 currentUv = vUv;
                    if(isHorizontal){
                        currentUv.y += stepLength * 0.5;
                    } else {
                        currentUv.x += stepLength * 0.5;
                    }                    

                    // Compute offset (for each iteration step) in the right direction.
                    vec2 offset = isHorizontal ? vec2(uInvWidth,0.0) : vec2(0.0,uInvHeight);
                    // Compute UVs to explore on each side of the edge, orthogonally. The QUALITY allows us to step faster.
                    vec2 uv1 = currentUv - offset;
                    vec2 uv2 = currentUv + offset;

                    // Read the lumas at both current extremities of the exploration segment, and compute the delta wrt to the local average luma.
                    float lumaEnd1 = rgb2luma(texture(uColor,uv1).rgb);
                    float lumaEnd2 = rgb2luma(texture(uColor,uv2).rgb);
                    lumaEnd1 -= lumaLocalAverage;
                    lumaEnd2 -= lumaLocalAverage;

                    // If the luma deltas at the current extremities are larger than the local gradient, we have reached the side of the edge.
                    bool reached1 = abs(lumaEnd1) >= gradientScaled;
                    bool reached2 = abs(lumaEnd2) >= gradientScaled;
                    bool reachedBoth = reached1 && reached2;

                    // If the side is not reached, we continue to explore in this direction.
                    if(!reached1){
                        uv1 -= offset;
                    }
                    if(!reached2){
                        uv2 += offset;
                    }

                    // If both sides have not been reached, continue to explore.
                    if(!reachedBoth){

                        for(int i = 2; i < ITERATIONS; i++){
                            // If needed, read luma in 1st direction, compute delta.
                            if(!reached1){
                                lumaEnd1 = rgb2luma(texture(uColor, uv1).rgb);
                                lumaEnd1 = lumaEnd1 - lumaLocalAverage;
                            }
                            // If needed, read luma in opposite direction, compute delta.
                            if(!reached2){
                                lumaEnd2 = rgb2luma(texture(uColor, uv2).rgb);
                                lumaEnd2 = lumaEnd2 - lumaLocalAverage;
                            }
                            // If the luma deltas at the current extremities is larger than the local gradient, we have reached the side of the edge.
                            reached1 = abs(lumaEnd1) >= gradientScaled;
                            reached2 = abs(lumaEnd2) >= gradientScaled;
                            reachedBoth = reached1 && reached2;

                            // If the side is not reached, we continue to explore in this direction, with a variable quality.
                            if(!reached1){
                                uv1 -= offset ; // * QUALITY(i);
                            }
                            if(!reached2){
                                uv2 += offset ; // * QUALITY(i);
                            }

                            // If both sides have been reached, stop the exploration.
                            if(reachedBoth){ break;}
                        }
                    }

                    // Compute the distances to each extremity of the edge.
                    float distance1 = isHorizontal ? (vUv.x - uv1.x) : (vUv.y - uv1.y);
                    float distance2 = isHorizontal ? (uv2.x - vUv.x) : (uv2.y - vUv.y);

                    // In which direction is the extremity of the edge closer ?
                    bool isDirection1 = distance1 < distance2;
                    float distanceFinal = min(distance1, distance2);

                    // Length of the edge.
                    float edgeThickness = (distance1 + distance2);

                    // UV offset: read in the direction of the closest side of the edge.
                    float pixelOffset = - distanceFinal / edgeThickness + 0.5;

                    // Is the luma at center smaller than the local average ?
                    bool isLumaCenterSmaller = lumaCenter < lumaLocalAverage;

                    // If the luma at center is smaller than at its neighbour, the delta luma at each end should be positive (same variation).
                    // (in the direction of the closer side of the edge.)
                    bool correctVariation = ((isDirection1 ? lumaEnd1 : lumaEnd2) < 0.0) != isLumaCenterSmaller;

                    // If the luma variation is incorrect, do not offset.
                    float finalOffset = correctVariation ? pixelOffset : 0.0;

                    // Sub-pixel shifting
                    // Full weighted average of the luma over the 3x3 neighborhood.
                    float lumaAverage = (1.0/12.0) * (2.0 * (lumaDownUp + lumaLeftRight) + lumaLeftCorners + lumaRightCorners);
                    // Ratio of the delta between the global average and the center luma, over the luma range in the 3x3 neighborhood.
                    float subPixelOffset1 = clamp(abs(lumaAverage - lumaCenter)/lumaRange,0.0,1.0);
                    float subPixelOffset2 = (-2.0 * subPixelOffset1 + 3.0) * subPixelOffset1 * subPixelOffset1;
                    // Compute a sub-pixel offset based on this delta.
                    float subPixelOffsetFinal = subPixelOffset2 * subPixelOffset2 * SUBPIXEL_QUALITY;

                    // Pick the biggest of the two offsets.
                    finalOffset = max(finalOffset,subPixelOffsetFinal); 

                    // Compute the final UV coordinates.
                    vec2 finalUv = vUv;
                    if(isHorizontal){
                        finalUv.y += finalOffset * stepLength;
                    } else {
                        finalUv.x += finalOffset * stepLength;
                    }

                    // Read the color at the new UV coordinates, and use it.
                    vec3 finalColor = texture(uColor,finalUv).rgb;
                    gl_FragColor = vec4(finalColor, 1.0);                              
                }
            `,
      uniforms: {
        uColor: { value: e },
        uInvWidth: { value: 1 / e.image.width },
        uInvHeight: { value: 1 / e.image.height }
      }
    }), this.mesh = new Mesh(RendererUtils.FULLSCREEN_QUAD, this.material), this.dst = s;
  }
  render(e, s, o, a) {
    if (this.material) {
      const l = this.material.uniforms.uColor.value;
      this.material.uniforms.uInvWidth.value = 1 / l.image.width, this.material.uniforms.uInvHeight.value = 1 / l.image.height, this.material.uniformsNeedUpdate = !0;
    }
    s.setRenderTarget(this.dst), s.render(this.mesh, RendererUtils.UNIT_ORTHOGRAPHIC);
  }
}
var __awaiter$2 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class TextureCache {
  constructor(e) {
    this.cache = /* @__PURE__ */ new Map(), this.requestManager = e;
  }
  load(e) {
    return __awaiter$2(this, void 0, void 0, function* () {
      let s = this.cache.get(e);
      if (s === void 0 && (s = {}, this.cache.set(e, s)), s.texture === void 0) {
        if (e instanceof HTMLCanvasElement)
          s.texture = new CanvasTexture(e);
        else {
          if (s.inFlight === void 0) {
            const o = this.requestManager.queueRequest("priority", () => TextureLoader.load(e));
            s.inFlight = o.promise;
          }
          s.texture = yield s.inFlight;
        }
        s.texture.colorSpace = SRGBColorSpace;
      }
      return s.texture;
    });
  }
}
class Azure {
  /**
   * Constructs a new Azure connection with the provided access token
   * @param token The Azure Maps API key to use with all network requests
   * @param options
   */
  constructor(e, s) {
    this.token = e;
  }
}
var __awaiter$1 = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Mapbox {
  /**
   * Constructs a new Mapbox connection with the provided access token
   * @param token The Mapbox Maps API key to use with all network requests
   * @param options
   */
  constructor(e, s) {
    this.token = e;
  }
  fetchAttributions(e) {
    return __awaiter$1(this, void 0, void 0, function* () {
      return [{ html: (yield FileLoader.loadJson(`https://api.mapbox.com/v4/${e}.json?access_token=${this.token}`)).attribution }];
    });
  }
}
var __awaiter = globalThis && globalThis.__awaiter || function(r, e, s, o) {
  function a(l) {
    return l instanceof s ? l : new s(function(u) {
      u(l);
    });
  }
  return new (s || (s = Promise))(function(l, u) {
    function c(f) {
      try {
        d(o.next(f));
      } catch (h) {
        u(h);
      }
    }
    function E(f) {
      try {
        d(o.throw(f));
      } catch (h) {
        u(h);
      }
    }
    function d(f) {
      f.done ? l(f.value) : a(f.value).then(c, E);
    }
    d((o = o.apply(r, e || [])).next());
  });
};
class Renderer {
  constructor(e) {
    var s, o;
    this.disposables = [], this.pickingManager = new PickingManager(), this.raycastCache = /* @__PURE__ */ new Map(), this.objectFactory = new ObjectFactory(this), this.world = new World(this), this.taskPool = new TaskPool((o = (s = e.workers) === null || s === void 0 ? void 0 : s.moduleBaseUrl) !== null && o !== void 0 ? o : "./");
    const { width: a, height: l } = e.container.getBoundingClientRect(), { threeRenderer: u, targets: c, passes: E, tileCompositorPass: d } = createRenderer$1(this, a, l);
    this.camera = new CameraObject(75, a / l, 0.1, Ellipsoid$1.WGS_84.radii.length() * 30, this), this.lastFrameCamera = this.camera.object.getCurrentCamera().clone(), this.lastSize = { x: a, y: l }, FileLoader.CONFIGURATION = u.config, this.taskPool.queueTaskOnAllWorkers(new ConfigFileLoaderTask(u.config)), this.requestManager = new RequestManager(u.config.globeNetworkRequests, u.config.tilesetNetworkRequests), e.container.appendChild(u.getDomElement());
    let f;
    e.cesium !== void 0 && (f = new CesiumIon(e.cesium.token, {}));
    let h;
    e.google !== void 0 && (h = new Google(e.google.token, {}));
    let S;
    e.azure !== void 0 && (S = new Azure(e.azure.token, {}));
    let R;
    e.mapbox !== void 0 && (R = new Mapbox(e.mapbox.token, {})), this.world.globe.cesium = f, this.world.globe.google = h, this.world.globe.azure = S, this.world.globe.mapbox = R, this.objectFactory.cesium = f, this.objectFactory.google = h, this.threeRenderer = u, this.targets = c, this.passes = E, this.tileCompositorPass = d, this.pickingCache = new PickingCache(this), this.textureCache = new TextureCache(this.requestManager), this.render();
  }
  get config() {
    return this.threeRenderer.config;
  }
  static create(e) {
    var s, o, a, l, u, c, E, d;
    return __awaiter(this, void 0, void 0, function* () {
      GLOBAL_CONFIG$1.staticRoot = (o = (s = e.gdal) === null || s === void 0 ? void 0 : s.moduleBaseUrl) !== null && o !== void 0 ? o : ".", yield HarfBuzz.init((a = e.hb) === null || a === void 0 ? void 0 : a.moduleUrl), yield IfcLoader.init((l = e.ifc) === null || l === void 0 ? void 0 : l.moduleBaseUrl), yield DracoLoader.get((u = e.draco) === null || u === void 0 ? void 0 : u.moduleBaseUrl), initSortWorker((c = e.cppSorter) === null || c === void 0 ? void 0 : c.moduleBaseUrl);
      const f = new Renderer(e);
      return GltfLoader.configureLoaders((E = e.draco) === null || E === void 0 ? void 0 : E.moduleBaseUrl, (d = e.ktx2) === null || d === void 0 ? void 0 : d.moduleBaseUrl, f.threeRenderer.renderer), f;
    });
  }
  getObjectFactory() {
    return this.objectFactory;
  }
  getTaskPool() {
    return this.taskPool;
  }
  getWorld() {
    return this.world;
  }
  render() {
    {
      const o = this.world.getCamera(), a = new Cartographic$1();
      this.camera.getPositionCartographic(a);
      const l = o.object.orthographic, u = l.getFrustumRight() - l.getFrustumLeft(), c = l.getFrustumTop() - l.getFrustumBottom(), E = l.getNearPlaneClipping();
      window.isNaN(a.height) || (l.far = Math.max(100 * Math.max(u, c), 100 * Math.abs(a.height)), E ? l.near = -l.far : l.near = o.object.perspective.near);
    }
    this.requestManager.update(), this.pickingCache.newFrame(), this.raycastCache.clear();
    const e = this.world.buildScene();
    e.pano.position.copy(this.camera.object.position);
    for (const o of Object.values(e))
      o.add(new AmbientLight(4294967295, 0.2)), o.add(new CameraAwareSunLight());
    const s = this.getSize();
    this.targets.resize(s.x, s.y), this.lastSize = { x: s.x, y: s.y }, this.threeRenderer.render(e, this.passes, this.camera.object), this.lastFrameCamera = this.camera.object.getCurrentCamera().clone(), this.threeRenderer.nextFrame();
  }
  dispose() {
    for (const e of this.disposables)
      e.dispose();
    this.threeRenderer.renderer.dispose(), this.threeRenderer.renderer.forceContextLoss(), this.threeRenderer.renderer.domElement.remove();
  }
  pickScreenWorldSpace(e) {
    return this.pickingCache.pickScreenWorldSpace(e);
  }
  pickScreenViewSpace(e) {
    return this.pickingCache.pickScreenViewSpace(e);
  }
  pickScreenWorldSpaceSnapping(e) {
    return this.pickingCache.pickScreenWorldSpaceSnapping(e);
  }
  pickScreenViewSpaceSnapping(e) {
    return this.pickingCache.pickScreenViewSpaceSnapping(e);
  }
  pickScreenWorldSpaceRect(e) {
    return this.pickingCache.pickScreenWorldSpaceRect(e);
  }
  pickScreenViewSpaceRect(e) {
    return this.pickingCache.pickScreenViewSpaceRect(e);
  }
  raycastScreenBoundingVolumes(e) {
    const s = this.lastSize, o = e.x / s.x * 2 - 1, a = -(e.y / s.y) * 2 + 1, l = new Raycaster();
    l.setFromCamera(new Vector2(o, a), this.lastFrameCamera);
    const u = l.ray, c = u.origin.clone();
    let E = 0, d = !1;
    return this.world.raycastScene.traverse((f) => {
      if (f instanceof Mesh || f instanceof Points || f instanceof Line$1) {
        const h = f.geometry;
        (!h.boundingBox || h.boundingBox.isEmpty()) && h.computeBoundingBox(), f.updateMatrixWorld();
        const S = h.boundingBox.clone().applyMatrix4(f.matrixWorld), R = u.intersectBox(S, new Vector3$1());
        if (R) {
          const _ = u.origin.distanceTo(R);
          (_ < E || !d) && (E = _, c.copy(R), d = !0);
        }
      }
    }), d ? c : null;
  }
  raycastScreen(e, s) {
    const o = JSON.stringify(Object.assign(Object.assign({}, e), s)), a = this.raycastCache.get(o);
    if (a !== void 0)
      return a;
    {
      const l = this.raycastScreenImpl(e, s);
      return this.raycastCache.set(o, l), l;
    }
  }
  static handlePickResult(e) {
    if (e.object === null)
      return {
        position: e.position,
        object: null,
        isVoid: e.isVoid,
        directHit: e.directHit
      };
    {
      let s;
      switch (e.object.rootObject.getObjectType()) {
        case WorldObjectType.PointObject:
        case WorldObjectType.LineObject:
        case WorldObjectType.LineSegmentObject:
        case WorldObjectType.MeshObject:
        case WorldObjectType.InstancedMesh:
        case WorldObjectType.IfcObject:
          s = e.extraId;
          break;
        case WorldObjectType.SpriteObject:
          s = e.object.rootObject.pickingUserId;
          break;
        case WorldObjectType.TilesetObject:
        case WorldObjectType.CameraObject:
        case WorldObjectType.ObjObject:
        case WorldObjectType.KmlObject:
        case WorldObjectType.BoxObject:
        case WorldObjectType.SphereObject:
        case WorldObjectType.LabelCollection:
          break;
      }
      switch (e.object.objectType) {
        case ObjectType.Primitive:
          return {
            position: e.position,
            object: e.object.rootObject,
            userData: s,
            isVoid: !1,
            directHit: e.directHit
          };
        case ObjectType.Composite:
          return {
            position: e.position,
            object: e.object.rootObject,
            userData: s,
            isVoid: !1,
            directHit: e.directHit
          };
      }
    }
  }
  raycastScreenImpl(e, s) {
    var o, a, l;
    const u = s ?? {}, c = this.lastSize, E = e.x / c.x * 2 - 1, d = -(e.y / c.y) * 2 + 1, f = new Raycaster();
    f.firstHitOnly = (o = u.firstHitOnly) !== null && o !== void 0 ? o : !0, f.params.Points = { threshold: (a = u.pointThreshold) !== null && a !== void 0 ? a : 0.01 }, f.params.Line = { threshold: (l = u.lineThreshold) !== null && l !== void 0 ? l : 0.01 }, f.setFromCamera(new Vector2(E, d), this.lastFrameCamera);
    const h = f.intersectObjects(this.world.raycastScene.children, !0);
    return this.mapRaycastIntersections(h);
  }
  raycastScene(e, s, o) {
    var a, l, u;
    const c = o ?? {}, E = new Vector3$1(e.x, e.y, e.z), d = new Vector3$1(s.x, s.y, s.z).sub(E), f = new Raycaster(E, d.clone().normalize(), 0, d.length());
    f.firstHitOnly = (a = c.firstHitOnly) !== null && a !== void 0 ? a : !0, f.params.Points = { threshold: (l = c.pointThreshold) !== null && l !== void 0 ? l : 0.01 }, f.params.Line = { threshold: (u = c.lineThreshold) !== null && u !== void 0 ? u : 0.01 }, f.camera = this.lastFrameCamera;
    const h = f.intersectObjects(this.world.raycastScene.children, !0);
    return this.mapRaycastIntersections(h);
  }
  mapRaycastIntersections(e) {
    var s, o, a;
    const l = e.flatMap((c) => {
      let E = c.object, d;
      for (; E && d === void 0; )
        d = this.pickingManager.getIdForThreeId(E.id), E = E.parent;
      return [[c, d]];
    }), u = [];
    for (const [c, E] of l) {
      const d = {
        position: c.point.clone(),
        object: null,
        faceIndex: c.faceIndex
      };
      if (E !== void 0 && (d.object = (o = (s = this.pickingManager.getForId(E)) === null || s === void 0 ? void 0 : s.rootObject) !== null && o !== void 0 ? o : null), d.object instanceof MeshObject && d.object.mesh !== void 0 && d.object.mesh.pickingUserId !== void 0) {
        let f;
        if (d.object.mesh instanceof IndexedTriangleMesh && c.faceIndex !== void 0 ? f = d.object.mesh.indices[c.faceIndex * 3] : (d.object.mesh instanceof PointMesh || d.object.mesh instanceof LineStripMesh || d.object.mesh instanceof LineMesh) && (f = c.index), f === void 0)
          throw new Error("No raycast->data mapping");
        d.userData = d.object.mesh.pickingUserId[f];
      }
      if (d.object instanceof SpriteObject && (d.userData = d.object.pickingUserId), d.object instanceof InstancedMeshObject && (d.userData = c.instanceId), d.object instanceof IfcObject) {
        const f = c.object, h = f.geometry.index.array, S = f.geometry.getAttribute("pickingUserId");
        d.userData = S.getX(h[3 * ((a = c.faceIndex) !== null && a !== void 0 ? a : -1)]);
      }
      u.push(d);
    }
    return u;
  }
  getCanvas() {
    return this.threeRenderer.getDomElement();
  }
  setSize(e) {
    this.threeRenderer.setSize(e.x, e.y), this.camera.setAspectRatio(e.x / e.y);
  }
  getSize() {
    return this.threeRenderer.getSize();
  }
  createClippingGroup() {
    return new ClippingGroup();
  }
  createIndexedTriangleMesh() {
    return new IndexedTriangleMesh();
  }
  createLineMesh() {
    return new LineMesh();
  }
  createLineStripMesh() {
    throw new LineStripMesh();
  }
  createPointMesh() {
    return new PointMesh();
  }
  // Returns closest point and logarithmic depth of it
  pickClosestNearScreenCenter() {
    const e = this.lastSize, s = e.x / 2;
    let o = e.y / 2;
    o = e.y / 2 - (o - e.y / 2);
    const [a, l, u, c] = this.calculateReadPixelsArgs(s, o, CLOSEST_POINT_SPIRAL_W, CLOSEST_POINT_SPIRAL_H), [E, d, f] = this.readBackPickingBufferRect(a, l, u, c);
    let h = 1 / 0, S = new Vector3$1();
    for (let R = 0; R < CLOSEST_POINT_SPIRAL_SEQUENCE.length; R += 2) {
      const _ = CLOSEST_POINT_SPIRAL_SEQUENCE[R + 0], m = CLOSEST_POINT_SPIRAL_SEQUENCE[R + 1], L = s + _, F = o + m, W = L - a, G = F - l;
      if (L >= a && L < a + u && F >= l && F < l + c) {
        const q = W + G * u;
        E[q], d[q];
        const fe = new Vector4(L, F, f[q].x, f[q].y);
        fe.z < h && (h = fe.z, S = this.decodeFragCoordToPosition(fe, !0));
      }
    }
    return [S, h];
  }
  /**
   * Performs a combined depth read-back, depth decode and unproject operation to get the world space position of what
   * ever is below the point x/y in screen coordinates.
   *
   * This can be used to get the position of the point below the mouse cursor
   * @param x Screen x coordinate to unproject
   * @param y Screen y coordinate to unproject
   * @param worldSpace Should the position be transformed into world space or be kept in view space. Default is world
   */
  pickScreen(e, s, o = !0) {
    var a;
    const l = this.lastSize;
    s = l.y / 2 - (s - l.y / 2);
    const [u, c, E, d] = this.calculateReadPixelsArgs(e, s, 1, 1), [f, h, S] = this.readBackPickingBufferRect(u, c, E, d), R = f[0], _ = (a = this.pickingManager.getForId(R)) !== null && a !== void 0 ? a : null, m = new Vector4(e, s, S[0].x, S[0].y), L = this.decodeFragCoordToPosition(m, o), F = h[0];
    return {
      position: L,
      object: _,
      extraId: F,
      isVoid: m.z === 1 && m.w === 1,
      directHit: !0
    };
  }
  pickScreenSpiral(e, s, o = !0, a = !0) {
    var l, u;
    const c = this.lastSize;
    s = c.y / 2 - (s - c.y / 2);
    const [E, d, f, h] = this.calculateReadPixelsArgs(e, s, SPIRAL_W, SPIRAL_H), [S, R, _] = this.readBackPickingBufferRect(E, d, f, h), m = [], L = /* @__PURE__ */ new Set();
    for (let F = 0; F < SPIRAL_SEQUENCE.length; F += 2) {
      const W = SPIRAL_SEQUENCE[F + 0], G = SPIRAL_SEQUENCE[F + 1], q = e + W, fe = s + G, _e = q - E, Le = fe - d;
      if (q >= E && q < E + f && fe >= d && fe < d + h) {
        const Fe = _e + Le * f, Ee = S[Fe], Ge = R[Fe];
        if (Ee > 0) {
          const ve = (l = this.pickingManager.getForId(Ee)) !== null && l !== void 0 ? l : null, te = new Vector4(q, fe, _[Fe].x, _[Fe].y);
          if (ve && !L.has(ve.rootObject) && (m.push({
            position: this.decodeFragCoordToPosition(te, o),
            object: ve,
            extraId: Ge,
            isVoid: te.z === 1 && te.w === 1,
            directHit: F === 0
          }), L.add(ve.rootObject), a))
            return m;
        }
      }
    }
    if (m.length === 0) {
      const F = e - E, W = s - d, G = F + W * f, q = S[G], fe = (u = this.pickingManager.getForId(q)) !== null && u !== void 0 ? u : null, _e = new Vector4(e, s, _[G].x, _[G].y), Le = this.decodeFragCoordToPosition(_e, o), Fe = R[G];
      m.push({
        position: Le,
        object: fe,
        extraId: Fe,
        isVoid: _e.z === 1 && _e.w === 1,
        directHit: !0
      });
    }
    return m;
  }
  /**
   * Decode gl_FragCoord from glsl into world space position.
   *
   * @param fragCoord Contents of gl_FragCoord
   * @private
   */
  decodeFragCoordToPosition(e, s = !0) {
    const o = this.lastSize, a = this.lastFrameCamera.projectionMatrix.clone().invert(), l = this.lastFrameCamera.matrixWorld.clone(), u = new Vector4(e.x, e.y, e.z, 1);
    return u.x = u.x / o.x * 2 - 1, u.y = u.y / o.y * 2 - 1, u.z = u.z * 2 - 1, u.w = 1, u.multiplyScalar(1 / e.w), u.applyMatrix4(a), u.divideScalar(u.w), s && u.applyMatrix4(l), new Vector3$1(u.x, u.y, u.z);
  }
  readBackPickingBufferRect(e, s, o, a) {
    const l = this.threeRenderer.renderer.properties, u = this.threeRenderer.gl, c = (F) => {
      const W = new Uint8Array(4 * o * a), G = this.targets.main, q = l.get(G).__webglFramebuffer;
      u.bindFramebuffer(u.READ_FRAMEBUFFER, q), this.threeRenderer.renderer.state.bindFramebuffer(u.READ_FRAMEBUFFER, q);
      const fe = u.getParameter(u.READ_BUFFER);
      return u.readBuffer(F), u.readPixels(e, s, o, a, u.RGBA, u.UNSIGNED_BYTE, W), u.readBuffer(fe), W;
    }, E = (F) => {
      const W = new Float32Array(2 * o * a), G = this.targets.main, q = l.get(G).__webglFramebuffer;
      u.bindFramebuffer(u.READ_FRAMEBUFFER, q), this.threeRenderer.renderer.state.bindFramebuffer(u.READ_FRAMEBUFFER, q);
      const fe = u.getParameter(u.READ_BUFFER);
      return u.readBuffer(F), u.readPixels(e, s, o, a, u.RG, u.FLOAT, W), u.readBuffer(fe), W;
    }, d = c(u.COLOR_ATTACHMENT1), f = c(u.COLOR_ATTACHMENT2), h = E(u.COLOR_ATTACHMENT3), S = (F) => {
      const W = new Array(F.length / 4);
      for (let G = 0; G < W.length; G += 1) {
        const q = G * 4;
        W[G] = F[q + 0] << 0 | F[q + 1] << 8 | F[q + 2] << 16 | F[q + 3] << 24;
      }
      return W;
    }, R = S(d), _ = S(f), L = ((F) => {
      const W = new Array(F.length / 2);
      for (let G = 0; G < W.length; G += 1) {
        const q = G * 2;
        W[G] = new Vector2(...F.slice(q, q + 2));
      }
      return W;
    })(h);
    return [R, _, L];
  }
  /**
   * Internal function for performing a read-back of a rectangular region of the depth buffer.
   * @param x Center x of the rectangle
   * @param y Center y of the rectangle
   * @param w Width of the rectangle
   * @param h Height of the rectangle
   * @private
   */
  calculateReadPixelsArgs(e, s, o, a) {
    const l = this.lastSize;
    e -= Math.trunc(o / 2), s -= Math.trunc(a / 2);
    const u = Math.min(Math.max(e, 0), l.x - 1), c = Math.min(Math.max(s, 0), l.y - 1), E = u - e, d = c - s;
    return [u, c, o - E, a - d];
  }
  createFontAsset(e) {
    return __awaiter(this, void 0, void 0, function* () {
      const s = yield FontLoader.load(e.url), o = this.threeRenderer.renderer.capabilities.maxTextureSize;
      return this.disposables.push({ dispose: () => s.destroy() }), new FontAsset(s, Math.min(2048, o / 2), 32);
    });
  }
  clearNetworkCache() {
    FileLoader.clearCache();
  }
  submitPriorityRequest(e, s = 0) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.requestManager.queueRequest("priority", e, s).promise;
    });
  }
  pickScreenWorldSpaceImpl(e) {
    const s = this.pickScreen(e.x, e.y, !0);
    return Renderer.handlePickResult(s);
  }
  pickScreenViewSpaceImpl(e) {
    const s = this.pickScreen(e.x, e.y, !1);
    return Renderer.handlePickResult(s);
  }
  pickScreenWorldSpaceSnappingImpl(e) {
    const s = this.pickScreenSpiral(e.x, e.y, !0, !0)[0];
    return Renderer.handlePickResult(s);
  }
  pickScreenViewSpaceSnappingImpl(e) {
    const s = this.pickScreenSpiral(e.x, e.y, !1, !0)[0];
    return Renderer.handlePickResult(s);
  }
  pickScreenWorldSpaceRectImpl(e) {
    return this.pickScreenSpiral(e.x, e.y, !0, !1).map(Renderer.handlePickResult);
  }
  pickScreenViewSpaceRectImpl(e) {
    return this.pickScreenSpiral(e.x, e.y, !1, !1).map(Renderer.handlePickResult);
  }
}
function createRenderer$1(r, e, s) {
  const o = new ThreeRenderer(r, e, s), a = new RenderTargets(e, s), l = new TileCompositorPass(), u = [], c = new ClearColorPass(a.main, 0, 0, 0, 1), E = new ScenePass(a.noPicking, {
    clearColor: () => !1,
    clearDepth: () => !0,
    clearStencil: () => !0,
    sceneName: "background"
  }), d = new ClearColorPass(a.fragCoord, 1, 1, 1, 1), f = new FilteredScenePass(a.main, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "globe"
  }, (Ge, ve) => !0), h = (Ge) => Ge.userData instanceof DrawableObject ? Ge.userData.getPickable() : !0, S = new FilteredScenePass(a.main, {
    clearColor: () => !1,
    clearDepth: () => !o.config.globeClipping,
    clearStencil: () => !1,
    sceneName: "beforePano"
  }, (Ge, ve) => !Ge.transparent && h(ve)), R = new FilteredScenePass(a.splat, {
    clearColor: () => !1,
    clearDepth: () => !0,
    clearStencil: () => !1,
    sceneName: "beforePanoSplat"
  }, (Ge, ve) => Ge.transparent || !h(ve)), _ = new FilteredScenePass(a.noPicking, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "beforePano"
  }, (Ge, ve) => Ge.transparent || !h(ve)), m = new ScenePass(a.kml, {
    clearColor: () => !1,
    clearDepth: () => !0,
    clearStencil: () => !0,
    sceneName: "beforePanoKml"
  }), L = DebugDraw.getRenderPass(a.noPicking), F = new FilteredScenePass(a.opaquePanos, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "pano"
  }, (Ge, ve) => !Ge.transparent), W = new FilteredScenePass(a.noPicking, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "pano"
  }, (Ge, ve) => Ge.transparent), G = new FilteredScenePass(a.main, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "afterPano"
  }, (Ge, ve) => !Ge.transparent && h(ve)), q = new FilteredScenePass(a.splat, {
    clearColor: () => !1,
    clearDepth: () => !0,
    clearStencil: () => !1,
    sceneName: "afterPanoSplat"
  }, (Ge, ve) => Ge.transparent || !h(ve)), fe = new FilteredScenePass(a.noPicking, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "afterPano"
  }, (Ge, ve) => Ge.transparent || !h(ve)), _e = new ScenePass(a.kml, {
    clearColor: () => !1,
    clearDepth: () => !1,
    clearStencil: () => !1,
    sceneName: "afterPanoKml"
  }), Le = new ScenePass(a.main, {
    clearColor: () => !1,
    clearDepth: () => !0,
    clearStencil: () => !1,
    sceneName: "uiOverlay"
  }), Fe = new EDLPass(a.main.texture[0], a.main.texture[4], a.edl), Ee = new FXAAPass(a.edl.texture, null);
  return u.push(l, c, E, d, f, S, R, _, m, L, F, W, G, q, fe, _e, Le, Fe, Ee), {
    threeRenderer: o,
    targets: a,
    passes: u,
    tileCompositorPass: l
  };
}
function spiralSequence(r, e) {
  const s = new Array();
  for (let o = r; o < e; o += 1)
    s.push(...ringSequence(o));
  return s;
}
function ringSequence(r) {
  if (r === 0)
    return [0, 0];
  const e = 1 + r * 2, s = new Array();
  s.push(...starSequence(0, r));
  const o = e - 3;
  for (let a = 1; a <= o / 2; a += 1)
    s.push(...starSequence(a, r)), s.push(...starSequence(-a, r));
  return s.push(...starSequence(r, r)), s;
}
function starSequence(r, e) {
  const s = new Array();
  return s.push(r, e), s.push(e, -r), s.push(-r, -e), s.push(-e, r), s;
}
const SPIRAL_LAYERS = 25, SPIRAL_W = SPIRAL_LAYERS * 2 + 1, SPIRAL_H = SPIRAL_LAYERS * 2 + 1, SPIRAL_SEQUENCE = spiralSequence(0, SPIRAL_LAYERS), CLOSEST_POINT_SPIRAL_LAYERS = 25, CLOSEST_POINT_SPIRAL_W = CLOSEST_POINT_SPIRAL_LAYERS * 2 + 1, CLOSEST_POINT_SPIRAL_H = CLOSEST_POINT_SPIRAL_LAYERS * 2 + 1, CLOSEST_POINT_SPIRAL_SEQUENCE = spiralSequence(0, CLOSEST_POINT_SPIRAL_LAYERS), COLOR_WHITE = new Color(1, 1, 1);
function allEqual(r, e, s) {
  if (r.length !== e.length)
    return !1;
  for (let o = 0; o < r.length; o++)
    if (!s(r[o], e[o]))
      return !1;
  return !0;
}
function isInInstance(r, e) {
  return allEqual(
    r.vertices,
    e.vertices,
    (s, o) => s.x === o.x && s.y === o.y && s.z === o.z
  ) && allEqual(r.indices, e.indices, (s, o) => s === o) && r.material.type === e.material.type && r.material.pointSize === e.material.pointSize && r.material.faceCulling === e.material.faceCulling && r.material.wireframe === e.material.wireframe && r.material.vertexColors === e.material.vertexColors && r.pixelSize === e.pixelSize && r.renderLayer === e.renderLayer;
}
function createInstanceKey(r) {
  return {
    vertices: r.vertices.map((e) => e.clone()),
    indices: [...r.indices],
    material: r.material,
    pixelSize: r.pixelSize,
    renderLayer: r.renderLayer
  };
}
function createInstanceObject(r, e) {
  const s = r.createIndexedTriangleMesh();
  s.vertices = e.vertices.map((a) => a.clone()), s.indices = [...e.indices], s.resolve();
  const o = r.getObjectFactory().createRawInstancedMeshObject({
    mesh: s,
    positions: [],
    rotations: [],
    scales: [],
    position: { ecef: new Vector3$1() },
    scale: new Vector3$1(1, 1, 1),
    material: e.material
  });
  return o.setRenderLayer(e.renderLayer), o;
}
function computeScale(r, e) {
  const s = r.getWorld().getCamera(), o = r.getSize();
  if (e.pixelSize === void 0)
    return e.scale.clone();
  let a = e.pixelSize / Math.max(o.x, o.y);
  if (s.getProjectionMode() === CameraProjection.Perspective) {
    const l = new Vector3$1();
    s.getPositionECEF(l);
    const u = e.position.distanceTo(l);
    a *= u * 3;
  } else {
    const l = s.getOrthographic(), u = new Vector2(
      l.getFrustumRight() - l.getFrustumLeft(),
      l.getFrustumTop() - l.getFrustumBottom()
    ), c = l.getZoom();
    a *= u.length() / c;
  }
  return e.scale.clone().multiplyScalar(a);
}
class MeshInstance {
  constructor(e) {
    Qt(this, "renderer");
    Qt(this, "instances");
    Qt(this, "batchables");
    this.renderer = e, this.instances = /* @__PURE__ */ new Map(), this.batchables = /* @__PURE__ */ new Map();
  }
  /**
   * Mark an instance as dirty so it is resolved in the next frame
   */
  refreshByKey(e) {
    const s = this.instances.get(e);
    s && (s.dirty = !0);
  }
  /**
   * Signal the instance that an instance has been changed
   */
  refresh(e) {
    const s = this.batchables.get(e);
    s && this.refreshByKey(s);
  }
  /**
   * Add a mesh object to be instanced. If the mesh already exists, nothing will change.
   */
  addMesh(e) {
    if (this.batchables.has(e))
      return;
    let s = null;
    for (const [a, l] of this.instances)
      isInInstance(e, a) && (s = a);
    if (s === null) {
      s = createInstanceKey(e);
      const a = createInstanceObject(this.renderer, e);
      this.instances.set(s, {
        object: a,
        batchables: /* @__PURE__ */ new Map(),
        dirty: !1
      }), this.renderer.getWorld().addObject(a);
    }
    const o = this.instances.get(s);
    o && (this.batchables.set(e, s), o.batchables.set(e, o.batchables.size), this.refreshByKey(s));
  }
  /**
   * Remove an instanced mesh object
   */
  removeMesh(e) {
    const s = this.batchables.get(e);
    if (!s)
      return;
    const o = this.instances.get(s);
    o && (this.batchables.delete(e), o.batchables.delete(e), this.refreshByKey(s));
  }
  /**
   * Get the instance world object containing the batchable.
   *
   * @param batchable
   * @returns
   */
  getInstanceObject(e) {
    const s = this.batchables.get(e);
    if (!s)
      return;
    const o = this.instances.get(s);
    if (o)
      return o.object;
  }
  /**
   * Get the picking id of a batchable.
   */
  getPickingId(e) {
    const s = this.batchables.get(e);
    if (!s)
      return;
    const o = this.instances.get(s);
    if (!o)
      return;
    const { batchables: a } = o, l = a.get(e);
    if (l !== void 0)
      return l;
  }
  /**
   * Main update loop for handling size attenuation and
   * reuploading instance data to the GPU, if needed
   */
  update() {
    var e;
    for (const [s, o] of this.instances) {
      const { dirty: a, object: l, batchables: u } = o;
      if (!a)
        continue;
      l.positions = [], l.rotations = [], l.scales = [], l.colors = [];
      const c = [];
      for (const d of u.keys())
        c.push(d.position);
      const E = calculateCentroid$1(c);
      for (const d of u.keys())
        l.positions.push(d.position.clone().sub(E)), l.rotations.push(d.rotation), l.scales.push(computeScale(this.renderer, d)), d.colors.length ? l.colors.push(d.colors[0]) : l.colors.push(COLOR_WHITE);
      l.setPositionECEF(E), l.resolve(), (u.size === 0 || ((e = u.keys().next().value) == null ? void 0 : e.pixelSize) === void 0) && (o.dirty = !1);
    }
  }
}
const DEFAULT_ENTITY_POSITION = new Cartographic$1(
  toRadians(150.898042),
  toRadians(-34.464009),
  1e3
);
class Entity {
  constructor(e, s = 1) {
    Qt(this, "position");
    Qt(this, "velocity");
    Qt(this, "onGround");
    Qt(this, "radius");
    Qt(this, "gravity");
    this.position = toCartesian(DEFAULT_ENTITY_POSITION), this.velocity = new Vector3$1(), this.onGround = !1, this.radius = e, this.gravity = s;
  }
}
const _VECTOR3_0$3 = new Vector3$1(), _VECTOR3_1$2 = new Vector3$1(), _VECTOR3_2$2 = new Vector3$1(), _VECTOR3_3$2 = new Vector3$1(), _VECTOR3_4$2 = new Vector3$1(), _PLANE_0 = new Plane(), _SPHERE_0 = new Sphere$1(), _SPHERE_1 = new Sphere$1(), _SPHERICAL_AXES = new Array(18).fill(0).map(() => new Vector3$1());
class Simulation {
  constructor(e) {
    Qt(this, "renderer");
    Qt(this, "entities");
    Qt(this, "collisionFilter");
    Qt(this, "onCollide");
    this.renderer = e, this.entities = /* @__PURE__ */ new Set(), this.collisionFilter = [], this.onCollide = () => {
    };
  }
  /**
   * Generate spherical axes from basis vectors.
   *
   * @param x
   * @param y
   * @param z
   */
  updateSphericalAxes(e, s, o) {
    _SPHERICAL_AXES[0].copy(e), _SPHERICAL_AXES[1].copy(e).negate(), _SPHERICAL_AXES[2].copy(s), _SPHERICAL_AXES[3].copy(s).negate(), _SPHERICAL_AXES[4].copy(o), _SPHERICAL_AXES[5].copy(o).negate(), _SPHERICAL_AXES[6].copy(e).add(s).normalize(), _SPHERICAL_AXES[7].copy(e).add(_SPHERICAL_AXES[3]).normalize(), _SPHERICAL_AXES[8].copy(_SPHERICAL_AXES[1]).add(s).normalize(), _SPHERICAL_AXES[9].copy(_SPHERICAL_AXES[1]).add(_SPHERICAL_AXES[3]).normalize(), _SPHERICAL_AXES[10].copy(e).add(o).normalize(), _SPHERICAL_AXES[11].copy(e).add(_SPHERICAL_AXES[5]).normalize(), _SPHERICAL_AXES[12].copy(_SPHERICAL_AXES[1]).add(o).normalize(), _SPHERICAL_AXES[13].copy(_SPHERICAL_AXES[1]).add(_SPHERICAL_AXES[5]).normalize(), _SPHERICAL_AXES[14].copy(s).add(o).normalize(), _SPHERICAL_AXES[15].copy(s).add(_SPHERICAL_AXES[5]).normalize(), _SPHERICAL_AXES[16].copy(_SPHERICAL_AXES[3]).add(o).normalize(), _SPHERICAL_AXES[17].copy(_SPHERICAL_AXES[3]).add(_SPHERICAL_AXES[5]).normalize();
  }
  /**
   * Test if the entity is colliding with geometry in the world from a given direction.
   *
   * @param entity
   * @param direction
   */
  resolveCollision(e, s) {
    const o = Math.max(e.velocity.length(), e.radius * 2), a = _VECTOR3_0$3.copy(e.position).addScaledVector(s, o), l = this.renderer.raycastScene(e.position, a).filter((d) => !d.object || !this.collisionFilter.includes(d.object));
    if (!l.length)
      return;
    const u = _VECTOR3_0$3.set(
      l[0].position.x,
      l[0].position.y,
      l[0].position.z
    );
    if (_PLANE_0.setFromNormalAndCoplanarPoint(s, u).negate().distanceToPoint(e.position) <= e.radius)
      return u.addScaledVector(s, -e.radius);
  }
  /**
   * Remove an entity from the scene.
   *
   * @param entity
   */
  add(e) {
    this.entities.add(e);
  }
  /**
   * Add an entity to the scene.
   *
   * @param entity
   */
  remove(e) {
    this.entities.delete(e);
  }
  /**
   * Set the collision callback.
   * @param handler
   */
  setOnCollide(e) {
    this.onCollide = e;
  }
  /**
   * Set the collision filter to ignore certain objects.
   *
   * @param ignore
   */
  setCollisionFilter(e) {
    this.collisionFilter = e;
  }
  /**
   * Step the simulation.
   *
   * @param deltaTime
   */
  step(e) {
    for (const o of this.entities) {
      const a = _VECTOR3_1$2, l = _VECTOR3_2$2, u = _VECTOR3_3$2, c = toCartographic(o.position);
      Ellipsoid$1.WGS_84.rotationBasisForCartographic(c, null, u, a, l), a.normalize(), l.normalize(), u.normalize();
      const E = _VECTOR3_4$2.copy(u).multiplyScalar(-9.8);
      o.velocity.addScaledVector(E, e * o.gravity).clampLength(0, 100), o.position.addScaledVector(o.velocity, e), o.onGround = !1, this.updateSphericalAxes(a, l, u);
      for (const d of _SPHERICAL_AXES) {
        const f = o.velocity.dot(d);
        if (f <= 0)
          continue;
        const h = this.resolveCollision(o, d);
        h && (o.velocity.dot(u) < 0 && (o.onGround = !0), o.position.copy(h), o.velocity.addScaledVector(d, -f));
      }
    }
    const s = Array.from(this.entities);
    for (let o = 0; o < s.length - 1; o++)
      for (let a = o + 1; a < s.length; a++) {
        const l = s[o], u = s[a], c = _SPHERE_0.set(l.position, l.radius), E = _SPHERE_1.set(u.position, u.radius);
        c.intersectsSphere(E) && this.onCollide(l, u);
      }
  }
}
var PathType = /* @__PURE__ */ ((r) => (r[r.Fixed = 0] = "Fixed", r[r.Line = 1] = "Line", r[r.Circle = 2] = "Circle", r))(PathType || {});
class CirclePathObject {
  constructor(e, s, o, a, l) {
    Qt(this, "renderer");
    Qt(this, "origin");
    Qt(this, "center");
    Qt(this, "normal");
    Qt(this, "radius");
    Qt(this, "basis");
    Qt(this, "inverseBasis");
    Qt(this, "pivotCenter");
    Qt(this, "currentPosition");
    Qt(this, "draggingPlane");
    this.origin = s, this.center = o, this.normal = a, this.radius = this.center.distanceTo(this.origin), this.basis = this.calculateBasis(), this.inverseBasis = this.basis.clone().invert(), this.pivotCenter = l, this.pivotCenter ? this.currentPosition = this.center.clone() : this.currentPosition = this.origin.clone(), this.draggingPlane = new Plane(), this.renderer = e;
  }
  /**
   * Calculate the basis vector matrix to transform between
   * world space and the local space of this circle
   */
  calculateBasis() {
    const e = this.normal.clone(), s = this.origin.clone().sub(this.center).normalize(), o = this.normal.clone().cross(s).normalize();
    return new Matrix3$1().set(
      s.x,
      o.x,
      e.x,
      s.y,
      o.y,
      e.y,
      s.z,
      o.z,
      e.z
    );
  }
  /**
   * Calculate the angle formed by the given position on the circle
   * from the origin
   */
  calculateAngle(e) {
    const s = this.center.clone().applyMatrix3(this.inverseBasis), o = e.clone().applyMatrix3(this.inverseBasis);
    let a = Math.atan2(
      o.y - s.y,
      o.x - s.x
    );
    return a < 0 && (a += 2 * Math.PI), a;
  }
  /**
   * Calculate the dragging plane on which the widget moves relative
   * to the camera
   */
  onGrab() {
    this.draggingPlane.setFromNormalAndCoplanarPoint(this.normal, this.center);
  }
  /**
   * Do nothing on release
   */
  onRelease() {
  }
  /**
   * Move the object along the circumference of the circle by calculating the
   * widget position's change in angle from the origin using the
   * projected 2D motion
   */
  mapMotion(e, s) {
    const o = this.renderer.getWorld().getCamera(), a = new Vector3$1();
    o.getPositionECEF(a);
    const l = new Quaternion$1();
    o.getRotation(l);
    const u = this.renderer.getSize(), c = MathUtils.screenCoordsToNDC(
      s.prevPosition.x,
      s.prevPosition.y,
      u.x,
      u.y,
      new Vector4(0, 0, 0, 1)
    );
    c.y *= -1;
    const E = MathUtils.screenCoordsToNDC(
      s.position.x,
      s.position.y,
      u.x,
      u.y,
      new Vector4(0, 0, 0, 1)
    );
    E.y *= -1;
    const d = new Matrix4();
    o.getPerspective().getInverseProjectionMatrix(d), c.applyMatrix4(d), c.divideScalar(c.w), E.applyMatrix4(d), E.divideScalar(E.w);
    const f = e.length() * 2, h = new Line3(a);
    h.end.x = c.x, h.end.y = c.y, h.end.z = c.z, h.end.normalize().multiplyScalar(f).applyQuaternion(l).add(a);
    const S = new Vector3$1();
    this.draggingPlane.intersectLine(h, S), h.end.x = E.x, h.end.y = E.y, h.end.z = E.z, h.end.normalize().multiplyScalar(f).applyQuaternion(l).add(a);
    const R = new Vector3$1();
    this.draggingPlane.intersectLine(h, R);
    const _ = this.calculateAngle(S), m = this.calculateAngle(R), F = this.calculateAngle(this.currentPosition) + (m - _), W = new Vector3$1(
      Math.cos(F) * this.radius,
      Math.sin(F) * this.radius,
      0
    );
    this.currentPosition.copy(W.applyMatrix3(this.basis).add(this.center));
  }
  /**
   * Get the target position for rendering
   */
  getWidgetPosition() {
    return this.pivotCenter ? this.center : this.currentPosition;
  }
  /**
   * Calculate the clockwise angular difference between the current
   * position and the origin (mapped to [0, 1] range)
   */
  getProgress() {
    return this.calculateAngle(this.currentPosition) / (2 * Math.PI);
  }
  /**
   * Set the current position based on the progress value [0, 1]
   */
  setFromProgress(e) {
    const s = Math.PI * 2 * e;
    this.currentPosition = this.origin.clone().applyAxisAngle(this.normal, s);
  }
}
class FixedPathObject {
  constructor(e) {
    Qt(this, "origin");
    this.origin = e;
  }
  onGrab() {
  }
  onRelease() {
  }
  mapMotion(e, s) {
  }
  getWidgetPosition() {
    return this.origin;
  }
  getProgress() {
    return 1;
  }
  setFromProgress(e) {
  }
}
class LinePathObject {
  constructor(e, s, o) {
    Qt(this, "renderer");
    Qt(this, "origin");
    Qt(this, "direction");
    Qt(this, "currentPosition");
    Qt(this, "draggingPlane");
    this.origin = s, this.direction = o, this.currentPosition = s.clone(), this.draggingPlane = new Plane(), this.renderer = e;
  }
  /**
   * Calculate the dragging plane on which the widget moves relative
   * to the camera
   */
  onGrab() {
    const e = this.renderer.getWorld().getCamera(), s = new Vector3$1(0, 0, -1), o = new Quaternion$1();
    e.getRotation(o), s.applyQuaternion(o);
    const a = this.direction.clone().cross(s);
    a.crossVectors(this.direction, a).normalize(), this.draggingPlane.setFromNormalAndCoplanarPoint(a, this.origin);
  }
  /**
   * Do nothing on release
   */
  onRelease() {
  }
  /**
   * Move the object along the line based on the 2D motion gesture
   */
  mapMotion(e, s) {
    const o = this.renderer.getWorld().getCamera(), a = new Vector3$1();
    o.getPositionECEF(a);
    const l = new Quaternion$1();
    o.getRotation(l);
    const u = this.renderer.getSize(), c = MathUtils.screenCoordsToNDC(
      s.prevPosition.x,
      s.prevPosition.y,
      u.x,
      u.y,
      new Vector4(0, 0, 0, 1)
    );
    c.y *= -1;
    const E = MathUtils.screenCoordsToNDC(
      s.position.x,
      s.position.y,
      u.x,
      u.y,
      new Vector4(0, 0, 0, 1)
    );
    E.y *= -1;
    const d = new Matrix4();
    o.getPerspective().getInverseProjectionMatrix(d), c.applyMatrix4(d), c.divideScalar(c.w), E.applyMatrix4(d), E.divideScalar(E.w);
    const f = e.length() * 2, h = new Line3(a);
    h.end.x = c.x, h.end.y = c.y, h.end.z = c.z, h.end.normalize().multiplyScalar(f).applyQuaternion(l).add(a);
    const S = new Vector3$1();
    this.draggingPlane.intersectLine(h, S), h.end.x = E.x, h.end.y = E.y, h.end.z = E.z, h.end.normalize().multiplyScalar(f).applyQuaternion(l).add(a);
    const R = new Vector3$1();
    this.draggingPlane.intersectLine(h, R);
    const _ = R.sub(S).projectOnVector(this.direction);
    return this.currentPosition = e.add(_), this.currentPosition;
  }
  /**
   * Get the target position for rendering
   */
  getWidgetPosition() {
    return this.currentPosition;
  }
  /**
   * The progress value is just how far along the widget is on the line
   */
  getProgress() {
    const e = this.currentPosition.clone().sub(this.origin);
    return e.dot(this.direction) < 0 ? -e.length() : e.length();
  }
  /**
   * Set how far long the widget is on the line based on progress value
   */
  setFromProgress(e) {
    this.currentPosition = this.direction.clone().multiplyScalar(e).add(this.origin);
  }
}
class Widget extends EventRegister {
  constructor(s, o, a, l, u) {
    super();
    Qt(this, "renderer");
    Qt(this, "meshInstance");
    Qt(this, "gestures");
    Qt(this, "objects");
    Qt(this, "visible");
    Qt(this, "grabbed");
    Qt(this, "progress");
    Qt(this, "pathBehavior");
    Qt(this, "gestureCallbacks");
    this.renderer = s, this.meshInstance = o, this.gestures = a, this.objects = l, this.visible = !1, this.grabbed = !1, this.progress = 0, this.pathBehavior = null, u && this.setPath(u), this.gestureCallbacks = {
      tap: [],
      doubletap: [],
      release: [],
      swipe: [],
      hover: [],
      keytap: [],
      keyrelease: [],
      zoom: []
    }, this.handleGrab(), this.handleRelease(), this.handleMove(), this.handleHover(), this.handleLeave();
  }
  /**
   * Test if the widget is picked.
   *
   * @returns
   */
  isPicked(s, o) {
    const a = this.meshInstance.getPickingId(o), l = this.meshInstance.getInstanceObject(o), u = this.renderer.pickScreenWorldSpaceSnapping(s);
    return u.object === l && u.userData === a;
  }
  /**
   * Create a corresponding path object to a definition.
   */
  getPathObject(s) {
    switch (s.type) {
      case PathType.Line: {
        const { origin: o, direction: a } = s;
        return new LinePathObject(
          this.renderer,
          new Vector3$1(o.x, o.y, o.z),
          new Vector3$1(a.x, a.y, a.z)
        );
      }
      case PathType.Circle: {
        const { origin: o, center: a, normal: l, pivotCenter: u } = s;
        return new CirclePathObject(
          this.renderer,
          new Vector3$1(o.x, o.y, o.z),
          new Vector3$1(a.x, a.y, a.z),
          new Vector3$1(l.x, l.y, l.z),
          u
        );
      }
      case PathType.Fixed: {
        const { origin: o } = s;
        return new FixedPathObject(new Vector3$1(o.x, o.y, o.z));
      }
    }
  }
  /**
   * Handle grabbing the widget.
   */
  handleGrab() {
    const s = (o) => {
      if (this.pathBehavior === null || !this.objects.find((l) => this.isPicked(o.position, l)))
        return;
      this.grabbed = !0;
      const a = this.getPosition();
      this.pathBehavior.onGrab(), this.emit("grab", { position: a });
    };
    this.gestures.register("tap", s), this.gestureCallbacks.tap.push(s);
  }
  /**
   * Handle releasing the widget, only when it is already grabbed.
   */
  handleRelease() {
    const s = () => {
      if (!this.grabbed || this.pathBehavior === null)
        return;
      this.grabbed = !1;
      const o = this.getPosition();
      this.pathBehavior.onRelease(), this.emit("release", { position: o });
    };
    this.gestures.register("release", s), this.gestureCallbacks.release.push(s);
  }
  /**
   * Handle moving the widget along the path.
   */
  handleMove() {
    const s = (o) => {
      if (!this.grabbed || this.pathBehavior === null)
        return;
      const a = this.getPosition();
      this.pathBehavior.mapMotion(a.clone(), o);
      const l = this.pathBehavior.getWidgetPosition().clone();
      for (const E of this.objects)
        E.position = l, this.meshInstance.refresh(E);
      const u = this.pathBehavior.getProgress(), c = u - this.progress;
      this.progress = u, this.emit("move", { position: l, prevPosition: a, progress: u, deltaProgress: c });
    };
    this.gestures.register("swipe", s), this.gestureCallbacks.swipe.push(s);
  }
  /**
   * Handle hovering over a widget.
   */
  handleHover() {
    const s = (o) => {
      if (!this.objects.find((l) => this.isPicked(o.position, l)))
        return;
      const a = this.getPosition();
      this.emit("hover", { position: a });
    };
    this.gestures.register("hover", s), this.gestureCallbacks.hover.push(s);
  }
  /**
   * Handle pointer leaving a widget.
   */
  handleLeave() {
    const s = (o) => {
      if (this.objects.find((l) => this.isPicked(o.position, l)))
        return;
      const a = this.getPosition();
      this.emit("leave", { position: a });
    };
    this.gestures.register("hover", s), this.gestureCallbacks.hover.push(s);
  }
  /**
   * Check if the widget is currently grabbed.
   */
  isGrabbed() {
    return this.grabbed;
  }
  /**
   * Hide the widget.
   */
  hide() {
    this.visible = !1;
    for (const s of this.objects)
      this.meshInstance.removeMesh(s);
  }
  /**
   * Show the widget.
   */
  show() {
    this.visible = !0;
    for (const s of this.objects)
      this.meshInstance.addMesh(s);
  }
  /**
   * Check if the widget is shown.
   */
  isShown() {
    return this.visible;
  }
  /**
   * Get the world position of the widget.
   */
  getPosition() {
    const { x: s, y: o, z: a } = this.objects[0].position;
    return new Vector3$1(s, o, a);
  }
  /**
   * Set the color of the widget.
   */
  setColor(s) {
    for (const o of this.objects)
      o.colors = [s], this.meshInstance.refresh(o);
  }
  /**
   * Set the rotation of the widget.
   */
  setRotation(s) {
    for (const o of this.objects)
      o.rotation = s, this.meshInstance.refresh(o);
  }
  /**
   * Set the path of the widget.
   *
   * This will also move the widget to the origin of the path,
   * effectively resetting it.
   */
  setPath(s) {
    this.pathBehavior = this.getPathObject(s), this.pathBehavior.setFromProgress(this.progress);
    const o = this.pathBehavior.getWidgetPosition();
    for (const a of this.objects)
      a.position = o, this.meshInstance.refresh(a);
  }
  /**
   * Reset the progress value for this widget (= 0).
   */
  resetProgress() {
    if (this.progress = 0, this.pathBehavior) {
      this.pathBehavior.setFromProgress(this.progress);
      const s = this.pathBehavior.getWidgetPosition();
      for (const o of this.objects)
        o.position = s, this.meshInstance.refresh(o);
    }
  }
  /**
   * Completely destroy this widget if it is no longer being used.
   */
  destroy() {
    this.unregisterAll(), this.hide();
    for (const s in this.gestureCallbacks) {
      const o = s;
      for (const a of this.gestureCallbacks[o])
        this.gestures.unregister(
          o,
          a
        );
    }
  }
}
function geometryToMesh(r, e) {
  const s = r.createIndexedTriangleMesh(), o = e.getAttribute("position");
  for (let a = 0; a < o.count; a++) {
    const l = o.getX(a), u = o.getY(a), c = o.getZ(a);
    s.vertices.push(new Vector3$1(l, u, c));
  }
  if (e.index)
    for (let a = 0; a < e.index.array.length; a++)
      s.indices.push(e.index.array[a]);
  return s.resolve(), s;
}
function generateArrowMesh(r, e, s) {
  const o = new ConeGeometry(s * 3, s * 10, 10), a = new CylinderGeometry(s, s, e, 10, 10);
  a.rotateX(-Math.PI / 2), a.translate(0, 0, e / 2), o.rotateX(Math.PI / 2), o.translate(0, 0, e);
  const l = geometryToMesh(r, o), u = geometryToMesh(r, a), c = r.createIndexedTriangleMesh();
  return c.vertices = l.vertices.concat(u.vertices), c.indices = l.indices.concat(
    u.indices.map((E) => E + l.vertices.length)
  ), c;
}
class WidgetManager {
  constructor(e, s, o) {
    Qt(this, "renderer");
    Qt(this, "meshInstance");
    Qt(this, "gestures");
    this.renderer = e, this.meshInstance = s, this.gestures = o;
  }
  /**
   * Helper method to create a new widget within this command
   */
  createWidget(e, s = null) {
    return new Widget(this.renderer, this.meshInstance, this.gestures, [e], s);
  }
  /**
   * Create a sphere-shaped widget
   */
  createSphereWidget(e, s, o = null) {
    const a = geometryToMesh(this.renderer, new SphereGeometry(1)), l = {
      type: "polygon",
      vertices: a.vertices,
      indices: a.indices,
      position: new Vector3$1(),
      rotation: new Quaternion$1(),
      colors: [s],
      scale: new Vector3$1(1, 1, 1),
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1)
      },
      renderLayer: RenderLayer.UIOverlay,
      pixelSize: e
    };
    return this.createWidget(l, o);
  }
  /**
   * Create an arrow widget
   */
  createArrowWidget(e, s, o = null) {
    const a = generateArrowMesh(this.renderer, 1, 0.01), l = {
      type: "polygon",
      vertices: a.vertices,
      indices: a.indices,
      position: new Vector3$1(),
      rotation: new Quaternion$1(),
      colors: [s],
      scale: new Vector3$1(1, 1, 1),
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1)
      },
      renderLayer: RenderLayer.UIOverlay,
      pixelSize: e
    };
    return this.createWidget(l, o);
  }
  /**
   * Create a ring widget
   */
  createRingWidget(e, s, o = null) {
    const a = geometryToMesh(this.renderer, new TorusGeometry(1, 0.01, 20, 36)), l = {
      type: "polygon",
      vertices: a.vertices,
      indices: a.indices,
      position: new Vector3$1(),
      rotation: new Quaternion$1(),
      colors: [s],
      scale: new Vector3$1(1, 1, 1),
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1)
      },
      renderLayer: RenderLayer.UIOverlay,
      pixelSize: e
    };
    return this.createWidget(l, o);
  }
}
class Service {
  /**
   * Construct a new Service.
   *
   * @param modules Core modules accessible by each command
   */
  constructor(e) {
    /**
     * Three-JS Renderer
     */
    Qt(this, "renderer");
    /**
     * Interface for handling 2D draw calls
     */
    Qt(this, "draw2D");
    /**
     * Framework for batching raw mesh objects for efficient rendering
     */
    Qt(this, "meshBatch");
    /**
     * Framework for mesh instancing
     */
    Qt(this, "meshInstance");
    /**
     * Framework for drawing labels
     */
    Qt(this, "labelManager");
    /**
     * Physics simulation framework
     */
    Qt(this, "simulation");
    /**
     * Manages the callbacks for each gesture type
     */
    Qt(this, "gestures");
    /**
     * Manages the creation of 3D world-space widgets
     */
    Qt(this, "widgetManager");
    this.renderer = e.renderer, this.draw2D = e.draw2D, this.meshBatch = e.meshBatch, this.meshInstance = e.meshInstance, this.labelManager = e.labelManager, this.simulation = e.simulation, this.gestures = new GestureControl(this.renderer.getCanvas()), this.widgetManager = new WidgetManager(this.renderer, this.meshInstance, this.gestures);
  }
}
const IDLE_COLORS$1 = [new Color(16742296), new Color(4124798), new Color(5815549)], HOVER_COLORS$1 = [new Color(16462947), new Color(1890144), new Color(1614075)];
class ClippingBoxTool {
  constructor(e, s, o) {
    Qt(this, "renderer");
    Qt(this, "widgetManager");
    Qt(this, "navigationService");
    Qt(this, "onClip");
    Qt(this, "targets");
    Qt(this, "clippingGroup");
    Qt(this, "obb");
    Qt(this, "boundingOutlineMesh");
    Qt(this, "boundingContainerMesh");
    Qt(this, "boundingOutlinePrimitive");
    Qt(this, "boundingContainerPrimitive");
    Qt(this, "translationButtons");
    Qt(this, "rotationButtons");
    Qt(this, "translationButtonMap");
    Qt(this, "rotationButtonMap");
    Qt(this, "rotationEnabled");
    Qt(this, "running");
    Qt(this, "visible");
    this.renderer = e, this.widgetManager = s, this.navigationService = o, this.onClip = () => {
    }, this.targets = /* @__PURE__ */ new Set(), this.clippingGroup = e.createClippingGroup(), this.clippingGroup.setEnabled(!0);
    for (let u = 0; u < 6; u++)
      this.clippingGroup.planes.push({
        position: new Vector3$1(),
        normal: new Vector3$1()
      });
    this.obb = new OBB(), this.boundingOutlineMesh = this.renderer.createLineMesh(), this.boundingContainerMesh = this.renderer.createIndexedTriangleMesh();
    const { outline: a, container: l } = this.createBoundingVolumePrimitives();
    this.boundingOutlinePrimitive = a, this.boundingContainerPrimitive = l, this.translationButtons = this.createTranslationButtons(), this.rotationButtons = this.createRotationButtons(), this.translationButtonMap = /* @__PURE__ */ new Map(), this.rotationButtonMap = /* @__PURE__ */ new Map(), this.rotationEnabled = !1, this.running = !1, this.visible = !1;
  }
  /**
   * Create the bounding volume mesh.
   *
   * @returns
   */
  createBoundingVolumePrimitives() {
    const e = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.boundingOutlineMesh,
      material: {
        type: "basicOpaque",
        color: { r: 1, g: 1, b: 1 }
      },
      position: {
        ecef: { x: 0, y: 0, z: 0 }
      }
    }), s = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.boundingContainerMesh,
      material: {
        type: "basicAlpha",
        color: { r: 1, g: 1, b: 1 },
        alpha: 0.1,
        faceCulling: FaceCullingMode.None
      },
      position: {
        ecef: { x: 0, y: 0, z: 0 }
      }
    });
    return { outline: e, container: s };
  }
  /**
   * Create translation buttons.
   *
   * @returns
   */
  createTranslationButtons() {
    const e = [];
    let s = 0;
    for (let o = 0; o < 6; o++) {
      o && o % 2 === 0 && s++;
      const a = this.widgetManager.createSphereWidget(5, IDLE_COLORS$1[s]);
      e.push(a);
    }
    return e;
  }
  /**
   * Create the rotation buttons.
   *
   * @returns
   */
  createRotationButtons() {
    return IDLE_COLORS$1.map((e) => this.widgetManager.createRingWidget(75, e));
  }
  /**
   * Update the bounding volume primitives.
   */
  updateBoundingPrimitive() {
    const { vertices: e, indices: s } = this.obb.getTriangleMeshVertexArray(), o = calculateCentroid$1(e);
    for (const a of e)
      a.sub(o);
    this.boundingContainerMesh.vertices = e, this.boundingContainerMesh.indices = s, this.boundingOutlineMesh.vertices = [
      e[0],
      e[1],
      e[1],
      e[5],
      e[0],
      e[2],
      e[2],
      e[3],
      e[1],
      e[3],
      e[4],
      e[5],
      e[4],
      e[0],
      e[4],
      e[6],
      e[6],
      e[7],
      e[7],
      e[5],
      e[7],
      e[3],
      e[6],
      e[2]
    ], this.boundingContainerMesh.resolve(), this.boundingOutlineMesh.resolve(), this.boundingContainerPrimitive.setPositionECEF(o), this.boundingOutlinePrimitive.setPositionECEF(o);
  }
  /**
   * Update the clipping group of a target model.
   */
  updateClippingGroupFromOBB() {
    const e = this.obb.getInwardPlanes();
    for (let s = 0; s < 6; s++) {
      const o = e[s];
      this.clippingGroup.planes[s].position = o.position, this.clippingGroup.planes[s].normal = o.normal;
    }
    this.clippingGroup.resolvePlanes(), this.onClip();
  }
  /**
   * Update the translation buttons paths.
   */
  updateTranslationButtons() {
    const e = this.obb.getInwardPlanes();
    for (let s = 0; s < 6; s++) {
      const o = e[s], a = this.translationButtons[s];
      a.setPath({
        type: PathType.Line,
        origin: o.position,
        direction: o.normal
      }), a.resetProgress(), this.translationButtonMap.set(a, o);
    }
  }
  /**
   * Update the rotation buttons paths.
   */
  updateRotationButtons() {
    const e = this.obb.getInwardPlanes();
    for (let s = 0; s < 3; s++) {
      const o = e[s * 2], a = e[(s * 2 + 2) % 6], l = this.rotationButtons[s], u = this.obb.center.clone(), c = this.obb.center.clone().add(a.normal.clone().multiplyScalar(500)), E = o.normal;
      l.setPath({
        type: PathType.Circle,
        center: u,
        origin: c,
        normal: E,
        pivotCenter: !0
      });
      const d = new Matrix4();
      d.lookAt(u, u.clone().add(E), new Vector3$1(0, 1, 0));
      const f = new Quaternion$1();
      f.setFromRotationMatrix(d), l.setRotation(f), this.rotationButtonMap.set(l, o.normal);
    }
  }
  /**
   * Register the control handlers for the bounding
   * volume scaling translationButtons
   *
   * This will modify the clipping planes directly, then update the OBB
   */
  handleTranslationButtonControls() {
    for (let e = 0; e < 6; e++) {
      const s = this.translationButtons[e];
      s.unregisterAll(), s.register("hover", () => {
        s.setColor(HOVER_COLORS$1[Math.floor(e / 2)]);
      }), s.register("leave", () => {
        s.isGrabbed() || s.setColor(IDLE_COLORS$1[Math.floor(e / 2)]);
      }), s.register("grab", () => {
        if (this.navigationService.disable(), this.rotationEnabled)
          for (const o of this.rotationButtons)
            o.hide();
      }), s.register("release", () => {
        if (this.navigationService.enable(), this.rotationEnabled)
          for (const o of this.rotationButtons)
            o.show();
      }), s.register("move", (o) => {
        const a = this.translationButtonMap.get(s);
        if (!a)
          return;
        const l = new Vector3$1(
          a.normal.x,
          a.normal.y,
          a.normal.z
        ), u = o.position.clone().sub(o.prevPosition).divideScalar(2);
        for (const E of this.translationButtons) {
          const d = this.translationButtonMap.get(E);
          if (E === s || !d)
            continue;
          const f = new Vector3$1(d.normal.x, d.normal.y, d.normal.z);
          f.clone().cross(l).length() >= 1e-3 && (E.setPath({
            type: PathType.Line,
            origin: E.getPosition().add(u),
            direction: f
          }), E.resetProgress());
        }
        const c = this.translationButtons.map((E) => E.getPosition());
        this.obb.setFromFaceCenters(c), this.updateClippingGroupFromOBB(), this.updateBoundingPrimitive(), this.updateRotationButtons();
      });
    }
  }
  /**
   * Register control handlers for the bounding volume
   * rotation buttons
   *
   * This will modify the OBB to update the clipping group
   */
  handleRotationButtonControls() {
    for (let e = 0; e < 3; e++) {
      const s = this.rotationButtons[e];
      s.unregisterAll(), s.register("hover", () => {
        s.setColor(HOVER_COLORS$1[e]);
      }), s.register("leave", () => {
        s.isGrabbed() || s.setColor(IDLE_COLORS$1[e]);
      }), s.register("grab", () => {
        this.navigationService.disable();
        for (const o of this.rotationButtons)
          s !== o && o.hide();
      }), s.register("release", () => {
        this.navigationService.enable();
        for (const o of this.rotationButtons)
          o.show();
      }), s.register("move", (o) => {
        const a = this.rotationButtonMap.get(s);
        if (!a)
          return;
        const { deltaProgress: l } = o, u = l * Math.PI * 2, c = new Quaternion$1();
        c.setFromAxisAngle(a, u), this.obb.rotate(c), this.updateClippingGroupFromOBB(), this.updateBoundingPrimitive(), this.updateTranslationButtons();
      });
    }
  }
  start(e) {
    this.running = !0;
    for (const s of this.targets)
      this.clippingGroup.addObject(s.getWorldObject());
    this.onClip = e;
  }
  stop() {
    this.running = !1, this.clippingGroup.clear();
  }
  show() {
    this.visible = !0, this.handleTranslationButtonControls();
    for (const e of this.translationButtons)
      e.show();
    if (this.rotationEnabled) {
      this.handleRotationButtonControls();
      for (const e of this.rotationButtons)
        e.show();
    }
    this.renderer.getWorld().addObject(this.boundingContainerPrimitive), this.renderer.getWorld().addObject(this.boundingOutlinePrimitive);
  }
  hide() {
    this.visible = !1;
    for (const e of this.translationButtons)
      e.unregisterAll(), e.hide();
    for (const e of this.rotationButtons)
      e.unregisterAll(), e.hide();
    this.renderer.getWorld().removeObject(this.boundingContainerPrimitive), this.renderer.getWorld().removeObject(this.boundingOutlinePrimitive);
  }
  isActive() {
    return this.running;
  }
  isVisible() {
    return this.visible;
  }
  addTarget(e) {
    this.targets.add(e), this.running && this.clippingGroup.addObject(e.getWorldObject());
  }
  removeTarget(e) {
    this.targets.delete(e), this.clippingGroup.removeObject(e.getWorldObject());
  }
  getTargets() {
    return Array.from(this.targets);
  }
  clear() {
    this.targets.clear(), this.clippingGroup.clear();
  }
  /**
   * Reset the clipping box.
   */
  reset() {
    const e = [];
    for (const s of this.targets) {
      const o = new Sphere$1(s.getPosition(), s.getBoundingRadius());
      e.push(o);
    }
    this.obb.setFromGeoSphere(calculateContainerSphere(e)), this.updateClippingGroupFromOBB(), this.updateBoundingPrimitive(), this.updateTranslationButtons(), this.updateRotationButtons();
  }
  /**
   * Enable clipping box rotation controls.
   */
  enableRotate() {
    if (this.rotationEnabled = !0, this.visible) {
      this.handleRotationButtonControls();
      for (const e of this.rotationButtons)
        e.show();
    }
  }
  /**
   * Disable clipping box rotation controls.
   */
  disableRotate() {
    this.rotationEnabled = !1;
    for (const e of this.rotationButtons)
      e.unregisterAll(), e.hide();
  }
  /**
   * Get the OBB of the clipping box.
   *
   * @returns
   */
  getOBB() {
    return this.obb.clone();
  }
  /**
   * Set the OBB of the clipping box.
   *
   * @param obb
   * @returns
   */
  setOBB(e) {
    this.obb = e.clone(), this.updateClippingGroupFromOBB(), this.updateBoundingPrimitive(), this.updateTranslationButtons(), this.updateRotationButtons();
  }
}
class ClippingService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "navigationService");
    this.navigationService = o;
  }
  /**
   * Create a clipping box tool to apply on a set of dynamic models.
   */
  createBoxTool() {
    return new ClippingBoxTool(this.renderer, this.widgetManager, this.navigationService);
  }
  updateFrame(s) {
  }
}
class DeprojectService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "navigationService");
    Qt(this, "camera");
    Qt(this, "canvas");
    Qt(this, "context");
    Qt(this, "overlay");
    Qt(this, "outline");
    Qt(this, "overlayMesh");
    Qt(this, "outlineMesh");
    Qt(this, "depth");
    Qt(this, "locked");
    Qt(this, "currentNavigationMode");
    Qt(this, "currentProjectionMode");
    this.navigationService = o, this.camera = this.renderer.getWorld().getCamera(), this.canvas = document.createElement("canvas"), this.context = this.canvas.getContext("2d"), this.overlay = null, this.outline = null, this.overlayMesh = this.renderer.createIndexedTriangleMesh(), this.outlineMesh = this.renderer.createLineMesh(), this.depth = 0.25, this.locked = !1, this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode();
  }
  /**
   * Generate the geometry of the image plane.
   *
   * @param cameraModel
   * @returns
   */
  buildGeometry(s) {
    const a = new PlaneGeometry(1, 1, 100, 100), l = a.getAttribute("position").array, u = new Vector2();
    for (let S = 0; S < l.length; S += 3) {
      const R = S + 1;
      u.set(l[S], l[R]).multiply(s.imageSize), undistortImagePoint(u, s), l[S] = u.x / s.imageSize.x, l[R] = u.y / s.imageSize.y;
    }
    const c = s.imageSize.width / s.imageSize.height, E = c <= 1 ? s.sensorSize : s.sensorSize / c, d = 2 * Math.atan(E / (2 * s.focalLength)), f = 2 * this.depth * Math.tan(d / 2), h = f * c;
    return a.scale(h, f, 1), a;
  }
  /**
   * Build mesh objects.
   *
   * @param cameraModel
   */
  buildMeshes(s) {
    const o = this.buildGeometry(s), a = o.getAttribute("position"), l = o.getAttribute("uv"), u = o.index;
    this.overlayMesh.vertices = [], this.overlayMesh.uv = [];
    for (let d = 0; d < a.count; d++) {
      const f = new Vector3$1().fromBufferAttribute(a, d), h = new Vector2().fromBufferAttribute(l, d);
      this.overlayMesh.vertices.push(f), this.overlayMesh.uv.push(h);
    }
    this.overlayMesh.indices = [...u.array], this.overlayMesh.resolve();
    const c = new EdgesGeometry(o), E = c.getAttribute("position");
    this.outlineMesh.vertices = [];
    for (let d = 0; d < E.count; d++) {
      const f = new Vector3$1().fromBufferAttribute(E, d);
      this.outlineMesh.vertices.push(f);
    }
    this.outlineMesh.resolve(), c.dispose(), o.dispose();
  }
  /**
   * Load an HTMLImageElement
   *
   * @param url
   * @returns
   */
  async loadImage(s) {
    return new Promise((o, a) => {
      const l = new Image();
      l.src = s, l.crossOrigin = "anonymous", l.onload = () => {
        o(l);
      }, l.onerror = () => {
        a();
      };
    });
  }
  /**
   * Build tiled image overlay objects.
   *
   * @param photo
   * @param rows
   * @param cols
   * @param thumbnailUrl
   * @param getTileURL
   */
  async buildTiledObjects(s, o, a, l, u) {
    var f, h;
    const c = new Vector3$1(0, 0, -1).applyQuaternion(s.rotation).normalize(), E = await this.renderer.submitPriorityRequest(() => this.loadImage(u(0, 0))), d = await this.renderer.submitPriorityRequest(() => this.loadImage(l));
    this.canvas.width = a * E.width, this.canvas.height = o * E.height, this.context.drawImage(d, 0, 0, this.canvas.width, this.canvas.height), (f = this.overlay) == null || f.dispose(), this.overlay = await this.renderer.getObjectFactory().createRawTexturedMeshObject({
      mesh: this.overlayMesh,
      texture: {
        type: "canvas",
        canvas: this.canvas
      },
      material: {
        type: "basicAlpha",
        color: new Color(1, 1, 1),
        faceCulling: FaceCullingMode.None,
        alpha: 1
      },
      position: {
        ecef: s.position.clone().add(c.multiplyScalar(this.depth))
      },
      rotation: {
        type: "explicit",
        quaternion: s.rotation
      }
    }), (h = this.outline) == null || h.dispose(), this.outline = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.outlineMesh,
      material: {
        type: "basicOpaque",
        color: new Color(16639),
        faceCulling: FaceCullingMode.None
      },
      position: {
        ecef: s.position.clone().add(c.multiplyScalar(0.9999))
      },
      rotation: {
        type: "explicit",
        quaternion: s.rotation
      }
    });
    for (let S = 0; S < o; S++)
      for (let R = 0; R < a; R++)
        this.loadImage(u(S, R)).then((_) => {
          var m;
          this.context.drawImage(_, R * E.width, S * E.height), (m = this.overlay) == null || m.invalidateMaterials();
        });
  }
  /**
   * Build overlayo objects.
   *
   * @param url
   * @param photo
   */
  async buildObjects(s, o) {
    var l, u;
    const a = new Vector3$1(0, 0, -1).applyQuaternion(o.rotation).normalize();
    (l = this.overlay) == null || l.dispose(), this.overlay = await this.renderer.getObjectFactory().createRawTexturedMeshObject({
      mesh: this.overlayMesh,
      texture: {
        type: "url",
        url: s
      },
      material: {
        type: "basicAlpha",
        color: new Color(1, 1, 1),
        faceCulling: FaceCullingMode.None,
        alpha: 1
      },
      position: {
        ecef: o.position.clone().add(a.multiplyScalar(this.depth))
      },
      rotation: {
        type: "explicit",
        quaternion: o.rotation
      }
    }), (u = this.outline) == null || u.dispose(), this.outline = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.outlineMesh,
      material: {
        type: "basicOpaque",
        color: new Color(16639),
        faceCulling: FaceCullingMode.None
      },
      position: {
        ecef: o.position.clone().add(a.multiplyScalar(0.9999))
      },
      rotation: {
        type: "explicit",
        quaternion: o.rotation
      }
    });
  }
  /**
   * Preserve look-at point.
   */
  computeFoVZoom(s) {
    const { x: o, y: a } = this.renderer.getSize(), u = new Vector2(o, a).clone().multiplyScalar(0.5), c = this.renderer.pickScreenWorldSpaceSnapping(u), E = new Vector3$1(
      c.position.x,
      c.position.y,
      c.position.z
    ), d = new Vector3$1();
    this.camera.getPositionECEF(d);
    const f = d.distanceTo(E), h = s.position.distanceTo(E), S = f / h, R = toRadians(this.camera.getPerspective().getFieldOfView()), _ = toDegrees(2 * Math.atan(Math.tan(R / 2) * S)), m = calculateLookAtRotation(s.position, E);
    return [_, m];
  }
  /**
   * Convert FoV to translation zoom
   */
  computeTranslationZoom() {
    const { x: s, y: o } = this.renderer.getSize(), l = new Vector2(s, o).clone().multiplyScalar(0.5), u = this.renderer.pickScreenWorldSpaceSnapping(l), c = new Vector3$1(
      u.position.x,
      u.position.y,
      u.position.z
    ), E = new Vector3$1();
    this.camera.getPositionECEF(E);
    const d = new Vector3$1();
    this.camera.getForwardVector(d);
    const f = toRadians(this.camera.getPerspective().getFieldOfView()), h = toRadians(75), S = c.distanceTo(E), R = Math.tan(f / 2) / Math.tan(h / 2);
    if (S > 1e3)
      return E;
    const _ = d.multiplyScalar(S * R);
    return c.clone().sub(_);
  }
  /**
   * Lock the camera.
   *
   * @param textureSource
   * @param photo
   * @param cameraModel
   * @param preserveView
   */
  async lock(s, o, a, l = !1) {
    if (!this.locked) {
      if (this.locked = !0, this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode(), this.navigationService.setProjectionMode("perspective"), this.navigationService.setNavigationMode("panorama"), l) {
        const [u, c] = this.computeFoVZoom(o);
        this.navigationService.moveTo(o.position, c), this.camera.getPerspective().setFieldOfView(u);
      } else
        this.navigationService.moveTo(o.position, o.rotation);
      this.buildMeshes(a), typeof s == "string" ? await this.buildObjects(s, o) : await this.buildTiledObjects(
        o,
        s.rows,
        s.cols,
        s.thumbnailUrl,
        s.getTileURL
      ), this.overlay && this.renderer.getWorld().addObject(this.overlay), this.outline && this.renderer.getWorld().addObject(this.outline);
    }
  }
  /**
   * Unlock the camera.
   */
  unlock() {
    if (this.locked) {
      this.locked = !1;
      const s = this.computeTranslationZoom(), o = new Quaternion$1();
      this.camera.getRotation(o), this.navigationService.setNavigationMode(this.currentNavigationMode), this.navigationService.setProjectionMode(this.currentProjectionMode), this.navigationService.moveTo(s, o), this.overlay && this.renderer.getWorld().removeObject(this.overlay), this.outline && this.renderer.getWorld().removeObject(this.outline);
    }
  }
  /**
   * Project a 3D point onto pixel space.
   *
   * Requires that the camera is viewing the point queried.
   *
   * @param point
   */
  project(s, o, a) {
    const { k1: l, k2: u, k3: c, p1: E, p2: d } = a.distortion, f = new Matrix4().makeRotationFromQuaternion(o.rotation).invert(), h = s.clone().sub(o.position).applyMatrix4(f), S = h.x / -h.z, R = h.y / h.z, _ = S * S, m = R * R, L = S * R, F = _ + m, W = F * F, G = W * F, q = 1 + l * F + u * W + c * G, fe = S * q, _e = R * q, Le = 2 * E * L + d * (F + 2 * _), Fe = 2 * d * L + E * (F + 2 * m), Ee = fe + Le, Ge = _e + Fe, ve = Math.max(a.imageSize.x, a.imageSize.y), te = a.focalLength * ve / a.sensorSize, ae = a.skew;
    return new Vector2(te * Ee + ae * Ge, te * Ge).add(a.principalPoint);
  }
  /**
   * Deproject a pixel on the photo to the 3D scene.
   *
   * Requires that the camera is viewing the point queried.
   *
   * @param point
   * @param photo
   * @param cameraModel
   */
  deproject(s, o, a) {
    const l = s.clone().divide(a.imageSize);
    l.y = 1 - l.y, l.sub(new Vector2(0.5, 0.5)).multiply(a.imageSize), undistortImagePoint(l, a);
    const u = a.imageSize.width / a.imageSize.height, c = u <= 1 ? a.sensorSize : a.sensorSize / u, E = 2 * Math.atan(c / (2 * a.focalLength)), d = 2 * this.depth * Math.tan(E / 2), f = d * u, h = new Vector3$1(
      l.x * f / a.imageSize.x,
      l.y * d / a.imageSize.y,
      0
    ), S = new Vector3$1(0, 0, -1).applyQuaternion(o.rotation).normalize().multiplyScalar(this.depth).add(o.position);
    h.applyQuaternion(o.rotation), h.add(S);
    const R = this.renderer.getWorld().getCamera(), _ = new Matrix4(), m = new Matrix4();
    R.getWorldMatrix(_), R.getProjectionMatrix(m);
    const L = this.renderer.getSize(), F = h.applyMatrix4(_.invert()).applyMatrix4(m), W = new Vector2(
      (F.x + 1) / 2 * L.x,
      -(F.y - 1) / 2 * L.y
    );
    return computePick(this.renderer, W);
  }
  /**
   * Check if a point is visible to a photo by raycasting.
   *
   * Returns the collision point if occluded.
   *
   * @param photo
   * @param point
   */
  isPhotoOccluded(s, o) {
    const a = this.renderer.raycastScene(s.position, o, {
      firstHitOnly: !0
    });
    return a.length === 0 ? null : new Vector3$1(
      a[0].position.x,
      a[0].position.y,
      a[0].position.z
    );
  }
  /**
   * Check if the camera is currently locked to a photo.
   *
   * @returns
   */
  isLocked() {
    return this.locked;
  }
  /**
   * Set the opacity of the overlay.
   *
   * @param opacity
   */
  setOpacity(s) {
    var o;
    (o = this.overlay) == null || o.applyMaterial({
      type: "basicAlpha",
      color: new Color(1, 1, 1),
      faceCulling: FaceCullingMode.None,
      alpha: s
    });
  }
  /**
   * Set the color of the overlay outline.
   *
   * @param color
   */
  setColor(s) {
    var o;
    (o = this.outline) == null || o.applyMaterial({
      type: "basicOpaque",
      color: s,
      faceCulling: FaceCullingMode.None
    });
  }
  updateFrame(s) {
  }
}
const PenIcon = "data:image/svg+xml;base64,PHN2ZyB4PScwcHgnIHk9JzBweCcgd2lkdGg9JzE2cHgnIGhlaWdodD0nMTZweCcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTIuODQgMTguNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+LmNscy0xe3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MC41cHg7fTwvc3R5bGU+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iOS45NCIgeT0iMTMuNzMiIHdpZHRoPSI2Ljg3IiBoZWlnaHQ9IjQuMDEiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOC40MyAyMi4yKSByb3RhdGUoMTUwKSIvPgogIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTUuNTIsMTAuNzhsMS4zNC43MWE4LjI3LDguMjcsMCwwLDEsMi4yMSwxLjg3bDEuMSwxLjQyLjExLjE0LjE0LS4wOCwzLjY2LTIuMTEuMTQtLjA4LS4wNy0uMTctLjY4LTEuNjZBOC40LDguNCwwLDAsMSwxMyw4TDEzLDYuNDYsNC44My43Miw4LjQ4LDcuMDVhLjc4Ljc4LDAsMCwxLDEsLjMzLjc3Ljc3LDAsMCwxLTEuMzMuNzcuNzguNzgsMCwwLDEsLjE5LTFMNC42NC44MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00LjM5IC0wLjQ3KSIvPgo8L3N2Zz4K", PointIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHdpZHRoPSIyMCIgZmlsbD0id2hpdGUiPjxwYXRoIGQ9Ik0xMCAxNC4yMjlRMTEuNzcxIDE0LjIyOSAxMyAxM1ExNC4yMjkgMTEuNzcxIDE0LjIyOSAxMFExNC4yMjkgOC4yMjkgMTMgN1ExMS43NzEgNS43NzEgMTAgNS43NzFROC4yMjkgNS43NzEgNyA3UTUuNzcxIDguMjI5IDUuNzcxIDEwUTUuNzcxIDExLjc3MSA3IDEzUTguMjI5IDE0LjIyOSAxMCAxNC4yMjlaTTEwIDE5LjA0MlE4LjEwNCAxOS4wNDIgNi40NTggMTguMzMzUTQuODEyIDE3LjYyNSAzLjU5NCAxNi40MDZRMi4zNzUgMTUuMTg4IDEuNjY3IDEzLjU0MlEwLjk1OCAxMS44OTYgMC45NTggMTBRMC45NTggOC4xMDQgMS42NjcgNi40NThRMi4zNzUgNC44MTIgMy41OTQgMy41OTRRNC44MTIgMi4zNzUgNi40NTggMS42NjdROC4xMDQgMC45NTggMTAgMC45NThRMTEuODk2IDAuOTU4IDEzLjU0MiAxLjY2N1ExNS4xODggMi4zNzUgMTYuNDA2IDMuNTk0UTE3LjYyNSA0LjgxMiAxOC4zMzMgNi40NThRMTkuMDQyIDguMTA0IDE5LjA0MiAxMFExOS4wNDIgMTEuODk2IDE4LjMzMyAxMy41NDJRMTcuNjI1IDE1LjE4OCAxNi40MDYgMTYuNDA2UTE1LjE4OCAxNy42MjUgMTMuNTQyIDE4LjMzM1ExMS44OTYgMTkuMDQyIDEwIDE5LjA0MlpNMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBRMTAgMTAgMTAgMTBaTTEwIDE2LjMzM1ExMi42MjUgMTYuMzMzIDE0LjQ3OSAxNC40OVExNi4zMzMgMTIuNjQ2IDE2LjMzMyAxMFExNi4zMzMgNy4zNTQgMTQuNDc5IDUuNTFRMTIuNjI1IDMuNjY3IDEwIDMuNjY3UTcuMzc1IDMuNjY3IDUuNTIxIDUuNTFRMy42NjcgNy4zNTQgMy42NjcgMTBRMy42NjcgMTIuNjQ2IDUuNTIxIDE0LjQ5UTcuMzc1IDE2LjMzMyAxMCAxNi4zMzNaIi8+PC9zdmc+", HIGHLIGHT_COLOR$1 = new Color(16639);
class Editor {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "labelManager");
    Qt(this, "vertices");
    Qt(this, "closed");
    Qt(this, "color");
    Qt(this, "measurementUnit");
    Qt(this, "vertexCursor");
    Qt(this, "vertexHighlight");
    Qt(this, "lineMesh");
    Qt(this, "lineObject");
    Qt(this, "polygonMesh");
    Qt(this, "polygonObject");
    Qt(this, "labels");
    Qt(this, "visible");
    var o;
    this.renderer = e, this.labelManager = s, this.vertices = [], this.closed = !1, this.color = new Color(1, 1, 1), this.measurementUnit = "metric", this.vertexCursor = null, this.vertexHighlight = null, this.lineMesh = this.renderer.createLineMesh(), this.lineMesh.resolve(), this.lineObject = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.lineMesh,
      position: {
        ecef: new Vector3$1()
      },
      material: {
        type: "basicOpaque",
        color: this.color
      }
    }), (o = this.lineObject.asDrawableObject()) == null || o.setPickable(!1), this.lineObject.setRenderLayer(RenderLayer.AfterPanorama), this.polygonMesh = this.renderer.createIndexedTriangleMesh(), this.polygonMesh.resolve(), this.polygonObject = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.polygonMesh,
      position: {
        ecef: new Vector3$1()
      },
      material: {
        type: "basicAlpha",
        color: this.color,
        alpha: 0.5,
        faceCulling: FaceCullingMode.None
      }
    }), this.polygonObject.setRenderLayer(RenderLayer.AfterPanorama), this.polygonObject.setVisible(!1), this.renderer.getWorld().addObject(this.lineObject), this.renderer.getWorld().addObject(this.polygonObject), this.labels = [], this.visible = !0;
  }
  /**
   * Update the colors of the vertices and geometry.
   */
  updateColors() {
    for (const e of this.vertices)
      e.applyMaterial({
        type: "basicOpaque",
        color: this.color
      });
    this.lineObject.applyMaterial({
      type: "basicOpaque",
      color: this.color
    }), this.polygonObject.applyMaterial({
      type: "basicAlpha",
      color: this.color,
      alpha: 0.5,
      faceCulling: FaceCullingMode.None
    });
  }
  /**
   * Update the measurement and point name labels.
   *
   * @param withCursor Whether to include the cursor in the mesh
   */
  updateLabels() {
    for (; this.labels.length > 0; )
      this.labelManager.remove(this.labels[this.labels.length - 1]), this.labels.pop();
    const e = this.vertices.map((o) => {
      const a = new Vector3$1();
      return o.getPositionECEF(a), a;
    });
    this.closed ? e.push(e[0].clone()) : this.vertexCursor !== null && e.push(this.vertexCursor.clone());
    for (let o = 0; o < e.length - 1; o++) {
      const a = e[o], l = e[o + 1], u = a.distanceTo(l), c = lengthToString(u, this.measurementUnit, 2), E = a.clone().add(l).multiplyScalar(0.5);
      this.labels.push(this.labelManager.add(c, E, !0));
    }
    const s = this.vertices.map((o) => {
      const a = new Vector3$1();
      return o.getPositionECEF(a), a;
    });
    for (let o = 0; o < s.length; o++) {
      const a = s[o];
      let l = new Color(0, 0, 0);
      this.vertices[o] === this.vertexHighlight && (l = HIGHLIGHT_COLOR$1), this.labels.push(
        this.labelManager.add(`P${o + 1}`, a, !0, new Vector2(0, -20), l)
      );
    }
  }
  /**
   * Update the meshes for the polyline and polygon.
   */
  updateMeshes() {
    const e = this.vertices.map((o) => {
      const a = new Vector3$1();
      return o.getPositionECEF(a), a;
    });
    this.closed ? e.push(e[0].clone()) : this.vertexCursor !== null && e.push(this.vertexCursor.clone());
    const s = calculateCentroid$1(e);
    for (const o of e)
      o.sub(s);
    this.lineMesh.vertices = [];
    for (let o = 0; o < e.length - 1; o++)
      this.lineMesh.vertices.push(e[o], e[o + 1]);
    this.lineMesh.resolve(), this.polygonMesh.vertices = e.slice(), this.polygonMesh.indices = triangulate$1(e), this.polygonMesh.resolve(), this.lineObject.setPositionECEF(s), this.polygonObject.setPositionECEF(s), this.updateLabels();
  }
  /**
   * Add a new vertex to the current sketch.
   *
   * @param position
   */
  async addVertex(e) {
    const s = await this.renderer.getObjectFactory().createSprite({
      position: {
        ecef: e
      },
      url: PointIcon,
      material: {
        type: "basicOpaque",
        color: this.color
      },
      sizeAttenuation: !1,
      scale: new Vector3$1(0.02, 0.02, 0.02)
    });
    return s.setRenderLayer(RenderLayer.AfterPanorama), s.setVisible(this.visible), this.renderer.getWorld().addObject(s), this.vertices.push(s), this.highlightVertex(s), this.updateMeshes(), s;
  }
  /**
   * Remove a vertex from the current sketch.
   *
   * @param vertex
   * @returns
   */
  removeVertex(e) {
    const s = this.vertices.findIndex((o) => o === e);
    if (!(s < 0)) {
      if (this.closed) {
        let o = s - 1;
        o < 0 && (o = this.vertices.length - 1);
        for (let a = 0; a < this.vertices.length - o - 1; a++) {
          const l = this.vertices[this.vertices.length - 1];
          this.vertices.pop(), this.vertices.unshift(l);
        }
        this.openPolygon();
      } else
        this.vertices.splice(s, 1), this.renderer.getWorld().removeObject(e);
      this.highlightVertex(null), this.updateMeshes();
    }
  }
  /**
   * Clear the sketch.
   */
  clear() {
    for (; this.vertices.length > 0; )
      this.removeVertex(this.vertices[0]);
    this.setCursor(null);
  }
  /**
   * Close the polyline to convert it into a polygon.
   */
  closePolygon() {
    this.vertices.length >= 3 && (this.closed = !0, this.polygonObject.setVisible(this.visible), this.updateMeshes());
  }
  /**
   * Open the polygon, converting into a polyline by disconnecting the start and end vertices.
   */
  openPolygon() {
    this.vertices.length >= 3 && (this.closed = !1, this.polygonObject.setVisible(!1), this.updateMeshes());
  }
  /**
   * Set the draw color.
   *
   * @param color
   */
  setColor(e) {
    this.color = e, this.updateColors();
  }
  /**
   * Set the units of the measurement labels.
   *
   * @param measurementUnit
   */
  setMeasurementUnit(e) {
    this.measurementUnit = e, this.updateLabels();
  }
  /**
   * Set the position of the cursor.
   *
   * @param position
   */
  setCursor(e) {
    this.vertexCursor = e, this.updateMeshes();
  }
  /**
   * Set the currently selected vertex.
   */
  highlightVertex(e) {
    this.vertexHighlight = e;
    for (const s of this.vertices) {
      const o = s === e ? HIGHLIGHT_COLOR$1 : this.color;
      s.applyMaterial({
        type: "basicOpaque",
        color: o
      });
    }
    this.updateLabels();
  }
  /**
   * Get the list of vertices.
   *
   * @returns
   */
  getVertices() {
    return this.vertices;
  }
  /**
   * Check if the polygon is closed.
   *
   * @returns
   */
  isPolygonClosed() {
    return this.closed;
  }
  /**
   * Get the color of the polygon.
   *
   * @returns
   */
  getColor() {
    return this.color;
  }
  /**
   * Check if the polygon can be closed.
   *
   * @returns
   */
  canClosePolygon() {
    return !this.closed && this.vertices.length >= 3;
  }
  /**
   * Hide the current sketch
   */
  hide() {
    var e;
    this.visible = !1, this.vertices.forEach((s) => s.setVisible(this.visible)), (e = this.vertexHighlight) == null || e.setVisible(this.visible), this.lineObject.setVisible(this.visible), this.polygonObject.setVisible(this.visible);
  }
  /**
   * Show the current sketch
   */
  show() {
    var e;
    this.visible = !0, this.vertices.forEach((s) => s.setVisible(this.visible)), (e = this.vertexHighlight) == null || e.setVisible(this.visible), this.lineObject.setVisible(this.visible), this.polygonObject.setVisible(this.closed && this.visible);
  }
}
class FreeDrawController {
  constructor(e, s, o, a, l) {
    Qt(this, "renderer");
    Qt(this, "labelManager");
    Qt(this, "gestures");
    Qt(this, "navigationService");
    Qt(this, "utilityService");
    Qt(this, "editor");
    Qt(this, "dragging");
    Qt(this, "modifier");
    Qt(this, "snapped");
    Qt(this, "selectedVertex");
    Qt(this, "hoveringVertex");
    Qt(this, "contextMenuHandler");
    Qt(this, "onSubmitCallback");
    this.renderer = e, this.labelManager = s, this.gestures = o, this.navigationService = a, this.utilityService = l, this.editor = new Editor(this.renderer, this.labelManager), this.dragging = !1, this.modifier = !1, this.snapped = !1, this.selectedVertex = null, this.hoveringVertex = null, this.contextMenuHandler = () => {
    }, this.onSubmitCallback = () => {
    };
  }
  /**
   * Update the context menu.
   */
  updateContextMenu() {
    const e = this.editor.getVertices();
    if (e.length && this.selectedVertex) {
      const s = this.selectedVertex, o = new Vector3$1();
      s.getPositionECEF(o), this.contextMenuHandler(this.utilityService.projectToScreen(o), () => {
        this.editor.removeVertex(s), this.selectedVertex = e[e.length - 1] ?? null, this.editor.highlightVertex(this.selectedVertex), this.updateContextMenu(), this.gestures.focus();
      });
    } else
      this.contextMenuHandler(null, () => {
      });
  }
  /**
   * Start a new sketch.
   *
   * @param vertices
   * @param closed
   */
  async start(e = [], s = !1) {
    this.stop(), this.gestures.setCursor(`url(${PenIcon}), pointer`);
    for (const o of e)
      await this.editor.addVertex(o);
    e.length > 0 && (this.editor.setCursor(e[e.length - 1]), s ? this.editor.closePolygon() : this.editor.openPolygon()), this.gestures.register("keytap", (o) => {
      const { key: a } = o;
      (a === "Meta" || a === "Control" || a === "Shift") && (this.modifier = !0, this.gestures.setCursor("crosshair")), (a === "C" || a === "c" || a === "Escape") && this.clear(), (a === "U" || a === "u") && this.undo(), this.updateContextMenu();
    }), this.gestures.register("keyrelease", (o) => {
      const { key: a } = o;
      (a === "Meta" || a === "Control" || a === "Shift") && (this.modifier = !1, this.gestures.setCursor(`url(${PenIcon}), pointer`));
    }), this.gestures.register("tap", (o) => {
      const a = computePick(this.renderer, o.position), l = this.utilityService.projectToScreen(a), u = this.editor.getVertices();
      if (o.button === 0) {
        this.hoveringVertex = null;
        for (const c of u) {
          const E = new Vector3$1();
          c.getPositionECEF(E);
          const d = this.utilityService.projectToScreen(E);
          l && d && l.distanceTo(d) < 25 && (this.hoveringVertex = c);
        }
        this.hoveringVertex && !this.modifier ? (this.selectedVertex = this.hoveringVertex, this.editor.highlightVertex(this.selectedVertex), this.updateContextMenu(), this.dragging = !0, this.navigationService.disable(), this.gestures.setCursor("grabbing")) : this.modifier && this.snapped ? (this.editor.closePolygon(), this.updateContextMenu()) : this.editor.isPolygonClosed() || this.editor.addVertex(a).then((c) => {
          this.selectedVertex = c, this.hoveringVertex = c, this.editor.highlightVertex(this.selectedVertex), this.updateContextMenu();
        });
      } else if (o.button === 2 && this.hoveringVertex) {
        if (this.editor.removeVertex(this.hoveringVertex), this.hoveringVertex === this.selectedVertex) {
          const c = this.editor.getVertices();
          this.selectedVertex = c[c.length - 1] ?? null;
        }
        this.hoveringVertex = null, this.editor.highlightVertex(this.selectedVertex), this.updateContextMenu();
      }
    }), this.gestures.register("release", () => {
      this.dragging && (this.dragging = !1, this.navigationService.enable(), this.gestures.setCursor("grab"));
    }), this.gestures.register("hover", (o) => {
      const a = this.renderer.pickScreenWorldSpaceSnapping(o.position), l = new Vector3$1(a.position.x, a.position.y, a.position.z), u = this.utilityService.projectToScreen(l), c = this.editor.getVertices();
      if (this.dragging && this.selectedVertex)
        this.selectedVertex.setPositionECEF(l), this.gestures.setCursor("grabbing");
      else {
        this.hoveringVertex = null;
        for (const E of c) {
          const d = new Vector3$1();
          E.getPositionECEF(d);
          const f = this.utilityService.projectToScreen(d);
          u && f && u.distanceTo(f) < 25 && (this.hoveringVertex = E);
        }
        this.hoveringVertex ? this.gestures.setCursor("grab") : this.gestures.setCursor(`url(${PenIcon}), pointer`);
      }
      if (this.modifier && c.length >= 3) {
        const E = new Vector3$1();
        c[0].getPositionECEF(E);
        const d = this.utilityService.projectToScreen(E);
        u && d && u.distanceTo(d) < 50 ? (l.copy(E), this.snapped = !0) : this.snapped = !1, this.gestures.setCursor("crosshair");
      } else
        this.snapped = !1;
      this.editor.setCursor(l);
    }), this.gestures.register("zoom", () => {
      this.updateContextMenu();
    });
  }
  /**
   * Undo the placement of the last vertex.
   */
  undo() {
    const e = this.editor.getVertices(), s = e.length - 1;
    s >= 0 && (this.editor.removeVertex(e[s]), this.selectedVertex = e[s - 1] ?? null, this.hoveringVertex = this.selectedVertex, this.editor.highlightVertex(this.selectedVertex), this.updateContextMenu());
  }
  /**
   * Clear the current sketch, reset all state
   */
  clear() {
    this.editor.clear(), this.updateContextMenu(), this.dragging = !1, this.modifier = !1, this.snapped = !1;
  }
  /**
   * Submit the current sketch.
   */
  submit() {
    this.editor.highlightVertex(null), this.editor.setCursor(null), this.gestures.unregisterAll(), this.gestures.setCursor("default"), this.contextMenuHandler(null, () => {
    });
    const s = this.editor.getVertices().map((o) => {
      const a = new Vector3$1();
      return o.getPositionECEF(a), a;
    });
    this.onSubmitCallback(s, this.editor.isPolygonClosed(), this.editor.getColor());
  }
  /**
   * Stop sketching.
   */
  stop() {
    this.clear(), this.gestures.unregisterAll(), this.gestures.setCursor("default"), this.updateContextMenu();
  }
  /**
   * Get the color of the sketch.
   *
   * @returns
   */
  getColor() {
    return this.editor.getColor();
  }
  /**
   * Check if the polygon can be closed.
   *
   * @returns
   */
  canClosePolygon() {
    return this.editor.canClosePolygon();
  }
  /**
   * Set the context menu handler.
   *
   * @param handler
   */
  setContextMenuHandler(e) {
    this.contextMenuHandler = e;
  }
  /**
   * Set the callback for when the drawing is submitted.
   *
   * @param callback
   */
  setSubmitCallback(e) {
    this.onSubmitCallback = e;
  }
  /**
   * Set the sketch color.
   *
   * @param color
   */
  setColor(e) {
    this.editor.setColor(e);
  }
  /**
   * Set the measurement unit.
   *
   * @param unit
   */
  setMeasurementUnit(e) {
    this.editor.setMeasurementUnit(e);
  }
  /**
   * Close the polygon.
   */
  closePolygon() {
    this.editor.closePolygon();
  }
  /**
   * Open the polygon.
   */
  openPolygon() {
    this.editor.openPolygon();
  }
  /**
   * Hide the current sketch.
   */
  hide() {
    this.editor.hide();
  }
  show() {
    this.editor.show();
  }
  updateFrame(e) {
  }
}
const HIGHLIGHT_COLOR = new Color(16639);
class RectDrawController {
  constructor(e, s, o, a, l) {
    Qt(this, "renderer");
    Qt(this, "labelManager");
    Qt(this, "gestures");
    Qt(this, "navigationService");
    Qt(this, "utilityService");
    Qt(this, "vertices");
    Qt(this, "cursor");
    Qt(this, "color");
    Qt(this, "dragging");
    Qt(this, "visible");
    Qt(this, "spriteObjects");
    Qt(this, "lineMesh");
    Qt(this, "lineObject");
    Qt(this, "polygonMesh");
    Qt(this, "polygonObject");
    Qt(this, "selectedSprite");
    Qt(this, "hoveringSprite");
    Qt(this, "measurementUnit");
    Qt(this, "labels");
    Qt(this, "contextMenuHandler");
    Qt(this, "onSubmitCallback");
    this.renderer = e, this.labelManager = s, this.gestures = o, this.navigationService = a, this.utilityService = l, this.vertices = [], this.cursor = new Vector3$1(), this.color = new Color(1, 1, 1), this.dragging = !1, this.visible = !0, this.spriteObjects = [], this.lineMesh = this.renderer.createLineMesh(), this.lineMesh.resolve(), this.lineObject = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.lineMesh,
      position: {
        ecef: new Vector3$1()
      },
      material: {
        type: "basicOpaque",
        color: this.color
      }
    }), this.lineObject.setPickable(!1), this.lineObject.setRenderLayer(RenderLayer.AfterPanorama), this.polygonMesh = this.renderer.createIndexedTriangleMesh(), this.polygonMesh.resolve(), this.polygonObject = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.polygonMesh,
      position: {
        ecef: new Vector3$1()
      },
      material: {
        type: "basicAlpha",
        color: this.color,
        alpha: 0.5,
        faceCulling: FaceCullingMode.None
      }
    }), this.polygonObject.setRenderLayer(RenderLayer.AfterPanorama), this.renderer.getWorld().addObject(this.lineObject), this.renderer.getWorld().addObject(this.polygonObject), this.selectedSprite = null, this.hoveringSprite = null, this.measurementUnit = "metric", this.labels = [], this.contextMenuHandler = () => {
    }, this.onSubmitCallback = () => {
    };
  }
  /**
   * Update the measurement and point name labels.
   */
  updateLabels() {
    for (; this.labels.length > 0; )
      this.labelManager.remove(this.labels[this.labels.length - 1]), this.labels.pop();
    for (let e = 0; e < this.vertices.length; e++) {
      const s = (e + 1) % this.vertices.length, o = this.vertices[e], a = this.vertices[s], l = o.distanceTo(a), u = lengthToString(l, this.measurementUnit, 2), c = o.clone().add(a).multiplyScalar(0.5), E = this.labelManager.add(u, c, !0);
      this.labels.push(E);
    }
    for (let e = 0; e < this.vertices.length; e++) {
      const s = new Color(0, 0, 0);
      if (this.selectedSprite) {
        const a = new Vector3$1();
        this.selectedSprite.getPositionECEF(a), a.equals(this.vertices[e]) && s.copy(HIGHLIGHT_COLOR);
      }
      const o = this.labelManager.add(
        `P${e + 1}`,
        this.vertices[e],
        !0,
        new Vector2(0, -20),
        s
      );
      this.labels.push(o);
    }
  }
  /**
   * Update the meshes.
   */
  updateMeshes() {
    const e = this.vertices.map((o) => o.clone()), s = calculateCentroid$1(this.vertices);
    for (const o of e)
      o.sub(s);
    this.lineMesh.vertices = [];
    for (let o = 0; o < e.length; o++) {
      const a = (o + 1) % e.length;
      this.lineMesh.vertices.push(e[o], e[a]);
    }
    this.lineMesh.resolve(), this.polygonMesh.vertices = e.slice(), this.polygonMesh.indices = triangulate$1(e), this.polygonMesh.resolve(), this.lineObject.setPositionECEF(s), this.polygonObject.setPositionECEF(s);
    for (const o of this.spriteObjects)
      o.applyMaterial({
        type: "basicOpaque",
        color: this.selectedSprite === o ? HIGHLIGHT_COLOR : this.color
      });
    this.lineObject.applyMaterial({
      type: "basicOpaque",
      color: this.color
    }), this.polygonObject.applyMaterial({
      type: "basicAlpha",
      color: this.color,
      alpha: 0.5,
      faceCulling: FaceCullingMode.None
    }), this.updateLabels();
  }
  /**
   * Update the vertex list.
   */
  updateVertices() {
    if (!this.spriteObjects.length)
      this.vertices = [];
    else {
      const [e, s] = this.spriteObjects, o = new Vector3$1();
      e.getPositionECEF(o);
      const a = this.cursor.clone();
      s == null || s.getPositionECEF(a);
      const l = this.renderer.getWorld().getCamera(), { x: u, y: c } = this.renderer.getSize(), E = new Vector2(u, c), d = projectToScreen(l, E, o), f = projectToScreen(l, E, a), h = computePick(this.renderer, new Vector2(f.x, d.y)), S = computePick(this.renderer, new Vector2(d.x, f.y));
      this.vertices = [o, h, a, S];
    }
    this.updateMeshes();
  }
  /**
   * Update the context menu.
   */
  updateContextMenu() {
    if (this.spriteObjects.length && this.selectedSprite) {
      const e = this.selectedSprite, s = new Vector3$1();
      e.getPositionECEF(s);
      const o = this.utilityService.projectToScreen(s);
      this.contextMenuHandler(o, () => {
        const a = this.spriteObjects.findIndex((l) => l === e);
        this.selectedSprite = this.spriteObjects[a - 1] ?? null, this.removeSprite(e);
      });
    } else
      this.contextMenuHandler(null, () => {
      });
  }
  /**
   * Add a new sprite at a position.
   *
   * @param position
   */
  async addSprite(e) {
    const s = await this.renderer.getObjectFactory().createSprite({
      position: {
        ecef: e
      },
      url: PointIcon,
      material: {
        type: "basicOpaque",
        color: this.color
      },
      sizeAttenuation: !1,
      scale: new Vector3$1(0.02, 0.02, 0.02)
    });
    s.setRenderLayer(RenderLayer.AfterPanorama), s.setVisible(this.visible), this.renderer.getWorld().addObject(s), this.spriteObjects.push(s), this.hoveringSprite = s, this.selectedSprite = s, this.updateVertices(), this.updateContextMenu();
  }
  /**
   * Remove a sprite.
   *
   * @param sprite
   */
  removeSprite(e) {
    const s = this.spriteObjects.findIndex((o) => o === e);
    s >= 0 && (e === this.hoveringSprite && (this.hoveringSprite = null), e === this.selectedSprite && (this.selectedSprite = null), this.spriteObjects.splice(s, 1), this.renderer.getWorld().removeObject(e), e.dispose(), this.updateVertices(), this.updateContextMenu());
  }
  /**
   * Start a new sketch.
   */
  async start() {
    this.stop(), this.gestures.register("keytap", (e) => {
      const { key: s } = e;
      (s === "C" || s === "c" || s === "Escape") && this.clear(), (s === "U" || s === "u") && this.undo();
    }), this.gestures.register("tap", (e) => {
      this.cursor = computePick(this.renderer, e.position), e.button === 0 ? this.hoveringSprite ? (this.selectedSprite = this.hoveringSprite, this.updateVertices(), this.updateContextMenu(), this.dragging = !0, this.navigationService.disable(), this.gestures.setCursor("grabbing")) : this.spriteObjects.length < 2 && this.addSprite(this.cursor) : e.button === 2 && this.hoveringSprite && this.removeSprite(this.hoveringSprite);
    }), this.gestures.register("release", () => {
      this.dragging && (this.dragging = !1, this.navigationService.enable(), this.gestures.setCursor("grab"));
    }), this.gestures.register("hover", (e) => {
      const s = this.renderer.pickScreenWorldSpaceSnapping(e.position);
      this.cursor.set(s.position.x, s.position.y, s.position.z);
      const o = this.utilityService.projectToScreen(this.cursor);
      if (this.dragging && this.selectedSprite)
        this.selectedSprite.setPositionECEF(this.cursor), this.gestures.setCursor("grabbing"), this.updateVertices();
      else {
        this.hoveringSprite = null;
        for (const a of this.spriteObjects) {
          const l = new Vector3$1();
          a.getPositionECEF(l);
          const u = this.utilityService.projectToScreen(l);
          u && o && o.distanceTo(u) < 25 && (this.hoveringSprite = a);
        }
        this.hoveringSprite ? this.gestures.setCursor("grab") : this.gestures.setCursor(`url(${PenIcon}), pointer`), this.spriteObjects.length < 2 ? this.updateVertices() : this.updateMeshes();
      }
    }), this.gestures.register("zoom", () => {
      this.updateContextMenu();
    });
  }
  /**
   * Undo the placement of the last vertex.
   */
  undo() {
    const e = this.spriteObjects.length - 1;
    e >= 0 && (this.selectedSprite = this.spriteObjects[e - 1] ?? null, this.removeSprite(this.spriteObjects[e]));
  }
  /**
   * Clear the current sketch, reset all state
   */
  clear() {
    for (const e of this.spriteObjects)
      this.renderer.getWorld().removeObject(e), e.dispose();
    this.spriteObjects.length = 0, this.hoveringSprite = null, this.selectedSprite = null, this.dragging = !1, this.updateVertices(), this.updateContextMenu();
  }
  /**
   * Submit the current sketch.
   */
  submit() {
    this.selectedSprite = null, this.hoveringSprite = null, this.updateMeshes(), this.gestures.unregisterAll(), this.gestures.setCursor("default"), this.contextMenuHandler(null, () => {
    }), this.onSubmitCallback(this.vertices, !0, this.color);
  }
  /**
   * Stop sketching.
   */
  stop() {
    this.clear(), this.gestures.unregisterAll(), this.gestures.setCursor("default");
  }
  /**
   * Check if the drawing can be submitted.
   *
   * @returns
   */
  canSubmit() {
    return this.spriteObjects.length === 2;
  }
  /**
   * Get the current color setting.
   *
   * @returns
   */
  getColor() {
    return this.color;
  }
  /**
   * Set the context menu handler.
   *
   * @param handler
   */
  setContextMenuHandler(e) {
    this.contextMenuHandler = e;
  }
  /**
   * Set the callback for when the drawing is submitted.
   *
   * @param callback
   */
  setSubmitCallback(e) {
    this.onSubmitCallback = e;
  }
  /**
   * Set the sketch color.
   *
   * @param color
   */
  setColor(e) {
    this.color.copy(e), this.updateMeshes();
  }
  /**
   * Set the measurement unit.
   *
   * @param unit
   */
  setMeasurementUnit(e) {
    this.measurementUnit = e, this.updateLabels();
  }
  /**
   * Hide the current sketch.
   */
  hide() {
    this.visible = !1, this.lineObject.setVisible(this.visible), this.polygonObject.setVisible(this.visible), this.spriteObjects.forEach((e) => e.setVisible(this.visible));
  }
  /**
   * Show the current sketch.
   */
  show() {
    this.visible = !0, this.lineObject.setVisible(this.visible), this.polygonObject.setVisible(this.visible), this.spriteObjects.forEach((e) => e.setVisible(this.visible));
  }
}
class DrawService extends Service {
  constructor(s, o, a) {
    super(s);
    Qt(this, "freeDrawController");
    Qt(this, "rectDrawController");
    this.freeDrawController = new FreeDrawController(
      this.renderer,
      this.labelManager,
      this.gestures,
      o,
      a
    ), this.rectDrawController = new RectDrawController(
      this.renderer,
      this.labelManager,
      this.gestures,
      o,
      a
    );
  }
  /**
   * Get the free draw controller.
   *
   * @returns
   */
  getFreeDrawController() {
    return this.freeDrawController;
  }
  /**
   * Get the rect draw controller.
   *
   * @returns
   */
  getRectDrawController() {
    return this.rectDrawController;
  }
  updateFrame(s) {
  }
}
const PACKET_TYPES = /* @__PURE__ */ Object.create(null);
PACKET_TYPES.open = "0";
PACKET_TYPES.close = "1";
PACKET_TYPES.ping = "2";
PACKET_TYPES.pong = "3";
PACKET_TYPES.message = "4";
PACKET_TYPES.upgrade = "5";
PACKET_TYPES.noop = "6";
const PACKET_TYPES_REVERSE = /* @__PURE__ */ Object.create(null);
Object.keys(PACKET_TYPES).forEach((r) => {
  PACKET_TYPES_REVERSE[PACKET_TYPES[r]] = r;
});
const ERROR_PACKET = { type: "error", data: "parser error" }, withNativeBlob$1 = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", withNativeArrayBuffer$2 = typeof ArrayBuffer == "function", isView$1 = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r && r.buffer instanceof ArrayBuffer, encodePacket = ({ type: r, data: e }, s, o) => withNativeBlob$1 && e instanceof Blob ? s ? o(e) : encodeBlobAsBase64(e, o) : withNativeArrayBuffer$2 && (e instanceof ArrayBuffer || isView$1(e)) ? s ? o(e) : encodeBlobAsBase64(new Blob([e]), o) : o(PACKET_TYPES[r] + (e || "")), encodeBlobAsBase64 = (r, e) => {
  const s = new FileReader();
  return s.onload = function() {
    const o = s.result.split(",")[1];
    e("b" + (o || ""));
  }, s.readAsDataURL(r);
};
function toArray(r) {
  return r instanceof Uint8Array ? r : r instanceof ArrayBuffer ? new Uint8Array(r) : new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
}
let TEXT_ENCODER;
function encodePacketToBinary(r, e) {
  if (withNativeBlob$1 && r.data instanceof Blob)
    return r.data.arrayBuffer().then(toArray).then(e);
  if (withNativeArrayBuffer$2 && (r.data instanceof ArrayBuffer || isView$1(r.data)))
    return e(toArray(r.data));
  encodePacket(r, !1, (s) => {
    TEXT_ENCODER || (TEXT_ENCODER = new TextEncoder()), e(TEXT_ENCODER.encode(s));
  });
}
const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", lookup$1 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let r = 0; r < chars.length; r++)
  lookup$1[chars.charCodeAt(r)] = r;
const decode$1 = (r) => {
  let e = r.length * 0.75, s = r.length, o, a = 0, l, u, c, E;
  r[r.length - 1] === "=" && (e--, r[r.length - 2] === "=" && e--);
  const d = new ArrayBuffer(e), f = new Uint8Array(d);
  for (o = 0; o < s; o += 4)
    l = lookup$1[r.charCodeAt(o)], u = lookup$1[r.charCodeAt(o + 1)], c = lookup$1[r.charCodeAt(o + 2)], E = lookup$1[r.charCodeAt(o + 3)], f[a++] = l << 2 | u >> 4, f[a++] = (u & 15) << 4 | c >> 2, f[a++] = (c & 3) << 6 | E & 63;
  return d;
}, withNativeArrayBuffer$1 = typeof ArrayBuffer == "function", decodePacket = (r, e) => {
  if (typeof r != "string")
    return {
      type: "message",
      data: mapBinary(r, e)
    };
  const s = r.charAt(0);
  return s === "b" ? {
    type: "message",
    data: decodeBase64Packet(r.substring(1), e)
  } : PACKET_TYPES_REVERSE[s] ? r.length > 1 ? {
    type: PACKET_TYPES_REVERSE[s],
    data: r.substring(1)
  } : {
    type: PACKET_TYPES_REVERSE[s]
  } : ERROR_PACKET;
}, decodeBase64Packet = (r, e) => {
  if (withNativeArrayBuffer$1) {
    const s = decode$1(r);
    return mapBinary(s, e);
  } else
    return { base64: !0, data: r };
}, mapBinary = (r, e) => {
  switch (e) {
    case "blob":
      return r instanceof Blob ? r : new Blob([r]);
    case "arraybuffer":
    default:
      return r instanceof ArrayBuffer ? r : r.buffer;
  }
}, SEPARATOR = String.fromCharCode(30), encodePayload = (r, e) => {
  const s = r.length, o = new Array(s);
  let a = 0;
  r.forEach((l, u) => {
    encodePacket(l, !1, (c) => {
      o[u] = c, ++a === s && e(o.join(SEPARATOR));
    });
  });
}, decodePayload = (r, e) => {
  const s = r.split(SEPARATOR), o = [];
  for (let a = 0; a < s.length; a++) {
    const l = decodePacket(s[a], e);
    if (o.push(l), l.type === "error")
      break;
  }
  return o;
};
function createPacketEncoderStream() {
  return new TransformStream({
    transform(r, e) {
      encodePacketToBinary(r, (s) => {
        const o = s.length;
        let a;
        if (o < 126)
          a = new Uint8Array(1), new DataView(a.buffer).setUint8(0, o);
        else if (o < 65536) {
          a = new Uint8Array(3);
          const l = new DataView(a.buffer);
          l.setUint8(0, 126), l.setUint16(1, o);
        } else {
          a = new Uint8Array(9);
          const l = new DataView(a.buffer);
          l.setUint8(0, 127), l.setBigUint64(1, BigInt(o));
        }
        r.data && typeof r.data != "string" && (a[0] |= 128), e.enqueue(a), e.enqueue(s);
      });
    }
  });
}
let TEXT_DECODER;
function totalLength(r) {
  return r.reduce((e, s) => e + s.length, 0);
}
function concatChunks(r, e) {
  if (r[0].length === e)
    return r.shift();
  const s = new Uint8Array(e);
  let o = 0;
  for (let a = 0; a < e; a++)
    s[a] = r[0][o++], o === r[0].length && (r.shift(), o = 0);
  return r.length && o < r[0].length && (r[0] = r[0].slice(o)), s;
}
function createPacketDecoderStream(r, e) {
  TEXT_DECODER || (TEXT_DECODER = new TextDecoder());
  const s = [];
  let o = 0, a = -1, l = !1;
  return new TransformStream({
    transform(u, c) {
      for (s.push(u); ; ) {
        if (o === 0) {
          if (totalLength(s) < 1)
            break;
          const E = concatChunks(s, 1);
          l = (E[0] & 128) === 128, a = E[0] & 127, a < 126 ? o = 3 : a === 126 ? o = 1 : o = 2;
        } else if (o === 1) {
          if (totalLength(s) < 2)
            break;
          const E = concatChunks(s, 2);
          a = new DataView(E.buffer, E.byteOffset, E.length).getUint16(0), o = 3;
        } else if (o === 2) {
          if (totalLength(s) < 8)
            break;
          const E = concatChunks(s, 8), d = new DataView(E.buffer, E.byteOffset, E.length), f = d.getUint32(0);
          if (f > Math.pow(2, 53 - 32) - 1) {
            c.enqueue(ERROR_PACKET);
            break;
          }
          a = f * Math.pow(2, 32) + d.getUint32(4), o = 3;
        } else {
          if (totalLength(s) < a)
            break;
          const E = concatChunks(s, a);
          c.enqueue(decodePacket(l ? E : TEXT_DECODER.decode(E), e)), o = 0;
        }
        if (a === 0 || a > r) {
          c.enqueue(ERROR_PACKET);
          break;
        }
      }
    }
  });
}
const protocol$1 = 4;
function Emitter(r) {
  if (r)
    return mixin(r);
}
function mixin(r) {
  for (var e in Emitter.prototype)
    r[e] = Emitter.prototype[e];
  return r;
}
Emitter.prototype.on = Emitter.prototype.addEventListener = function(r, e) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + r] = this._callbacks["$" + r] || []).push(e), this;
};
Emitter.prototype.once = function(r, e) {
  function s() {
    this.off(r, s), e.apply(this, arguments);
  }
  return s.fn = e, this.on(r, s), this;
};
Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function(r, e) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var s = this._callbacks["$" + r];
  if (!s)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + r], this;
  for (var o, a = 0; a < s.length; a++)
    if (o = s[a], o === e || o.fn === e) {
      s.splice(a, 1);
      break;
    }
  return s.length === 0 && delete this._callbacks["$" + r], this;
};
Emitter.prototype.emit = function(r) {
  this._callbacks = this._callbacks || {};
  for (var e = new Array(arguments.length - 1), s = this._callbacks["$" + r], o = 1; o < arguments.length; o++)
    e[o - 1] = arguments[o];
  if (s) {
    s = s.slice(0);
    for (var o = 0, a = s.length; o < a; ++o)
      s[o].apply(this, e);
  }
  return this;
};
Emitter.prototype.emitReserved = Emitter.prototype.emit;
Emitter.prototype.listeners = function(r) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + r] || [];
};
Emitter.prototype.hasListeners = function(r) {
  return !!this.listeners(r).length;
};
const nextTick = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, s) => s(e, 0))(), globalThisShim = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())(), defaultBinaryType = "arraybuffer";
function createCookieJar() {
}
function pick(r, ...e) {
  return e.reduce((s, o) => (r.hasOwnProperty(o) && (s[o] = r[o]), s), {});
}
const NATIVE_SET_TIMEOUT = globalThisShim.setTimeout, NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
function installTimerFunctions(r, e) {
  e.useNativeTimers ? (r.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim), r.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim)) : (r.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim), r.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim));
}
const BASE64_OVERHEAD = 1.33;
function byteLength(r) {
  return typeof r == "string" ? utf8Length(r) : Math.ceil((r.byteLength || r.size) * BASE64_OVERHEAD);
}
function utf8Length(r) {
  let e = 0, s = 0;
  for (let o = 0, a = r.length; o < a; o++)
    e = r.charCodeAt(o), e < 128 ? s += 1 : e < 2048 ? s += 2 : e < 55296 || e >= 57344 ? s += 3 : (o++, s += 4);
  return s;
}
function randomString() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function encode(r) {
  let e = "";
  for (let s in r)
    r.hasOwnProperty(s) && (e.length && (e += "&"), e += encodeURIComponent(s) + "=" + encodeURIComponent(r[s]));
  return e;
}
function decode(r) {
  let e = {}, s = r.split("&");
  for (let o = 0, a = s.length; o < a; o++) {
    let l = s[o].split("=");
    e[decodeURIComponent(l[0])] = decodeURIComponent(l[1]);
  }
  return e;
}
class TransportError extends Error {
  constructor(e, s, o) {
    super(e), this.description = s, this.context = o, this.type = "TransportError";
  }
}
class Transport extends Emitter {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(e) {
    super(), this.writable = !1, installTimerFunctions(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(e, s, o) {
    return super.emitReserved("error", new TransportError(e, s, o)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(e) {
    this.readyState === "open" && this.write(e);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(e) {
    const s = decodePacket(e, this.socket.binaryType);
    this.onPacket(s);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(e) {
    super.emitReserved("packet", e);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(e) {
    this.readyState = "closed", super.emitReserved("close", e);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(e) {
  }
  createUri(e, s = {}) {
    return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(s);
  }
  _hostname() {
    const e = this.opts.hostname;
    return e.indexOf(":") === -1 ? e : "[" + e + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(e) {
    const s = encode(e);
    return s.length ? "?" + s : "";
  }
}
class Polling extends Transport {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(e) {
    this.readyState = "pausing";
    const s = () => {
      this.readyState = "paused", e();
    };
    if (this._polling || !this.writable) {
      let o = 0;
      this._polling && (o++, this.once("pollComplete", function() {
        --o || s();
      })), this.writable || (o++, this.once("drain", function() {
        --o || s();
      }));
    } else
      s();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(e) {
    const s = (o) => {
      if (this.readyState === "opening" && o.type === "open" && this.onOpen(), o.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(o);
    };
    decodePayload(e, this.socket.binaryType).forEach(s), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const e = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? e() : this.once("open", e);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(e) {
    this.writable = !1, encodePayload(e, (s) => {
      this.doWrite(s, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "https" : "http", s = this.query || {};
    return this.opts.timestampRequests !== !1 && (s[this.opts.timestampParam] = randomString()), !this.supportsBinary && !s.sid && (s.b64 = 1), this.createUri(e, s);
  }
}
let value = !1;
try {
  value = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch (r) {
}
const hasCORS = value;
function empty() {
}
class BaseXHR extends Polling {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(e) {
    if (super(e), typeof location < "u") {
      const s = location.protocol === "https:";
      let o = location.port;
      o || (o = s ? "443" : "80"), this.xd = typeof location < "u" && e.hostname !== location.hostname || o !== e.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(e, s) {
    const o = this.request({
      method: "POST",
      data: e
    });
    o.on("success", s), o.on("error", (a, l) => {
      this.onError("xhr post error", a, l);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const e = this.request();
    e.on("data", this.onData.bind(this)), e.on("error", (s, o) => {
      this.onError("xhr poll error", s, o);
    }), this.pollXhr = e;
  }
}
let Request$1 = class mp extends Emitter {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(e, s, o) {
    super(), this.createRequest = e, installTimerFunctions(this, o), this._opts = o, this._method = o.method || "GET", this._uri = s, this._data = o.data !== void 0 ? o.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var e;
    const s = pick(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    s.xdomain = !!this._opts.xd;
    const o = this._xhr = this.createRequest(s);
    try {
      o.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          o.setDisableHeaderCheck && o.setDisableHeaderCheck(!0);
          for (let a in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(a) && o.setRequestHeader(a, this._opts.extraHeaders[a]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          o.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        o.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (e = this._opts.cookieJar) === null || e === void 0 || e.addCookies(o), "withCredentials" in o && (o.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (o.timeout = this._opts.requestTimeout), o.onreadystatechange = () => {
        var a;
        o.readyState === 3 && ((a = this._opts.cookieJar) === null || a === void 0 || a.parseCookies(
          // @ts-ignore
          o.getResponseHeader("set-cookie")
        )), o.readyState === 4 && (o.status === 200 || o.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof o.status == "number" ? o.status : 0);
        }, 0));
      }, o.send(this._data);
    } catch (a) {
      this.setTimeoutFn(() => {
        this._onError(a);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = mp.requestsCount++, mp.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(e) {
    this.emitReserved("error", e, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(e) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = empty, e)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete mp.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const e = this._xhr.responseText;
    e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
};
Request$1.requestsCount = 0;
Request$1.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", unloadHandler);
  else if (typeof addEventListener == "function") {
    const r = "onpagehide" in globalThisShim ? "pagehide" : "unload";
    addEventListener(r, unloadHandler, !1);
  }
}
function unloadHandler() {
  for (let r in Request$1.requests)
    Request$1.requests.hasOwnProperty(r) && Request$1.requests[r].abort();
}
const hasXHR2 = function() {
  const r = newRequest({
    xdomain: !1
  });
  return r && r.responseType !== null;
}();
class XHR extends BaseXHR {
  constructor(e) {
    super(e);
    const s = e && e.forceBase64;
    this.supportsBinary = hasXHR2 && !s;
  }
  request(e = {}) {
    return Object.assign(e, { xd: this.xd }, this.opts), new Request$1(newRequest, this.uri(), e);
  }
}
function newRequest(r) {
  const e = r.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!e || hasCORS))
      return new XMLHttpRequest();
  } catch {
  }
  if (!e)
    try {
      return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class BaseWS extends Transport {
  get name() {
    return "websocket";
  }
  doOpen() {
    const e = this.uri(), s = this.opts.protocols, o = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (o.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(e, s, o);
    } catch (a) {
      return this.emitReserved("error", a);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (e) => this.onClose({
      description: "websocket connection closed",
      context: e
    }), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
  }
  write(e) {
    this.writable = !1;
    for (let s = 0; s < e.length; s++) {
      const o = e[s], a = s === e.length - 1;
      encodePacket(o, this.supportsBinary, (l) => {
        try {
          this.doWrite(o, l);
        } catch {
        }
        a && nextTick(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const e = this.opts.secure ? "wss" : "ws", s = this.query || {};
    return this.opts.timestampRequests && (s[this.opts.timestampParam] = randomString()), this.supportsBinary || (s.b64 = 1), this.createUri(e, s);
  }
}
const WebSocketCtor = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
class WS extends BaseWS {
  createSocket(e, s, o) {
    return isReactNative ? new WebSocketCtor(e, s, o) : s ? new WebSocketCtor(e, s) : new WebSocketCtor(e);
  }
  doWrite(e, s) {
    this.ws.send(s);
  }
}
class WT extends Transport {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (e) {
      return this.emitReserved("error", e);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((e) => {
      this.onError("webtransport error", e);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((e) => {
        const s = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, this.socket.binaryType), o = e.readable.pipeThrough(s).getReader(), a = createPacketEncoderStream();
        a.readable.pipeTo(e.writable), this._writer = a.writable.getWriter();
        const l = () => {
          o.read().then(({ done: c, value: E }) => {
            c || (this.onPacket(E), l());
          }).catch((c) => {
          });
        };
        l();
        const u = { type: "open" };
        this.query.sid && (u.data = `{"sid":"${this.query.sid}"}`), this._writer.write(u).then(() => this.onOpen());
      });
    });
  }
  write(e) {
    this.writable = !1;
    for (let s = 0; s < e.length; s++) {
      const o = e[s], a = s === e.length - 1;
      this._writer.write(o).then(() => {
        a && nextTick(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var e;
    (e = this._transport) === null || e === void 0 || e.close();
  }
}
const transports = {
  websocket: WS,
  webtransport: WT,
  polling: XHR
}, re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, parts = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function parse(r) {
  if (r.length > 8e3)
    throw "URI too long";
  const e = r, s = r.indexOf("["), o = r.indexOf("]");
  s != -1 && o != -1 && (r = r.substring(0, s) + r.substring(s, o).replace(/:/g, ";") + r.substring(o, r.length));
  let a = re.exec(r || ""), l = {}, u = 14;
  for (; u--; )
    l[parts[u]] = a[u] || "";
  return s != -1 && o != -1 && (l.source = e, l.host = l.host.substring(1, l.host.length - 1).replace(/;/g, ":"), l.authority = l.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), l.ipv6uri = !0), l.pathNames = pathNames(l, l.path), l.queryKey = queryKey(l, l.query), l;
}
function pathNames(r, e) {
  const s = /\/{2,9}/g, o = e.replace(s, "/").split("/");
  return (e.slice(0, 1) == "/" || e.length === 0) && o.splice(0, 1), e.slice(-1) == "/" && o.splice(o.length - 1, 1), o;
}
function queryKey(r, e) {
  const s = {};
  return e.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(o, a, l) {
    a && (s[a] = l);
  }), s;
}
const withEventListeners = typeof addEventListener == "function" && typeof removeEventListener == "function", OFFLINE_EVENT_LISTENERS = [];
withEventListeners && addEventListener("offline", () => {
  OFFLINE_EVENT_LISTENERS.forEach((r) => r());
}, !1);
class SocketWithoutUpgrade extends Emitter {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(e, s) {
    if (super(), this.binaryType = defaultBinaryType, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, e && typeof e == "object" && (s = e, e = null), e) {
      const o = parse(e);
      s.hostname = o.host, s.secure = o.protocol === "https" || o.protocol === "wss", s.port = o.port, o.query && (s.query = o.query);
    } else
      s.host && (s.hostname = parse(s.host).host);
    installTimerFunctions(this, s), this.secure = s.secure != null ? s.secure : typeof location < "u" && location.protocol === "https:", s.hostname && !s.port && (s.port = this.secure ? "443" : "80"), this.hostname = s.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = s.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, s.transports.forEach((o) => {
      const a = o.prototype.name;
      this.transports.push(a), this._transportsByName[a] = o;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, s), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = decode(this.opts.query)), withEventListeners && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(e) {
    const s = Object.assign({}, this.opts.query);
    s.EIO = protocol$1, s.transport = e, this.id && (s.sid = this.id);
    const o = Object.assign({}, this.opts, {
      query: s,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[e]);
    return new this._transportsByName[e](o);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const e = this.opts.rememberUpgrade && SocketWithoutUpgrade.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const s = this.createTransport(e);
    s.open(), this.setTransport(s);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(e) {
    this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (s) => this._onClose("transport close", s));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", SocketWithoutUpgrade.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(e) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
        case "open":
          this.onHandshake(JSON.parse(e.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const s = new Error("server error");
          s.code = e.data, this._onError(s);
          break;
        case "message":
          this.emitReserved("data", e.data), this.emitReserved("message", e.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(e) {
    this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const e = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const e = this._getWritablePackets();
      this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let s = 1;
    for (let o = 0; o < this.writeBuffer.length; o++) {
      const a = this.writeBuffer[o].data;
      if (a && (s += byteLength(a)), o > 0 && s > this._maxPayload)
        return this.writeBuffer.slice(0, o);
      s += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const e = Date.now() > this._pingTimeoutTime;
    return e && (this._pingTimeoutTime = 0, nextTick(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), e;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(e, s, o) {
    return this._sendPacket("message", e, s, o), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(e, s, o) {
    return this._sendPacket("message", e, s, o), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(e, s, o, a) {
    if (typeof s == "function" && (a = s, s = void 0), typeof o == "function" && (a = o, o = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    o = o || {}, o.compress = o.compress !== !1;
    const l = {
      type: e,
      data: s,
      options: o
    };
    this.emitReserved("packetCreate", l), this.writeBuffer.push(l), a && this.once("flush", a), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const e = () => {
      this._onClose("forced close"), this.transport.close();
    }, s = () => {
      this.off("upgrade", s), this.off("upgradeError", s), e();
    }, o = () => {
      this.once("upgrade", s), this.once("upgradeError", s);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? o() : e();
    }) : this.upgrading ? o() : e()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(e) {
    if (SocketWithoutUpgrade.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", e), this._onClose("transport error", e);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(e, s) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), withEventListeners && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const o = OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
        o !== -1 && OFFLINE_EVENT_LISTENERS.splice(o, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", e, s), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
SocketWithoutUpgrade.protocol = protocol$1;
class SocketWithUpgrade extends SocketWithoutUpgrade {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let e = 0; e < this._upgrades.length; e++)
        this._probe(this._upgrades[e]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(e) {
    let s = this.createTransport(e), o = !1;
    SocketWithoutUpgrade.priorWebsocketSuccess = !1;
    const a = () => {
      o || (s.send([{ type: "ping", data: "probe" }]), s.once("packet", (h) => {
        if (!o)
          if (h.type === "pong" && h.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", s), !s)
              return;
            SocketWithoutUpgrade.priorWebsocketSuccess = s.name === "websocket", this.transport.pause(() => {
              o || this.readyState !== "closed" && (f(), this.setTransport(s), s.send([{ type: "upgrade" }]), this.emitReserved("upgrade", s), s = null, this.upgrading = !1, this.flush());
            });
          } else {
            const S = new Error("probe error");
            S.transport = s.name, this.emitReserved("upgradeError", S);
          }
      }));
    };
    function l() {
      o || (o = !0, f(), s.close(), s = null);
    }
    const u = (h) => {
      const S = new Error("probe error: " + h);
      S.transport = s.name, l(), this.emitReserved("upgradeError", S);
    };
    function c() {
      u("transport closed");
    }
    function E() {
      u("socket closed");
    }
    function d(h) {
      s && h.name !== s.name && l();
    }
    const f = () => {
      s.removeListener("open", a), s.removeListener("error", u), s.removeListener("close", c), this.off("close", E), this.off("upgrading", d);
    };
    s.once("open", a), s.once("error", u), s.once("close", c), this.once("close", E), this.once("upgrading", d), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(() => {
      o || s.open();
    }, 200) : s.open();
  }
  onHandshake(e) {
    this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(e) {
    const s = [];
    for (let o = 0; o < e.length; o++)
      ~this.transports.indexOf(e[o]) && s.push(e[o]);
    return s;
  }
}
let Socket$1 = class extends SocketWithUpgrade {
  constructor(e, s = {}) {
    const o = typeof e == "object" ? e : s;
    (!o.transports || o.transports && typeof o.transports[0] == "string") && (o.transports = (o.transports || ["polling", "websocket", "webtransport"]).map((a) => transports[a]).filter((a) => !!a)), super(e, o);
  }
};
function url(r, e = "", s) {
  let o = r;
  s = s || typeof location < "u" && location, r == null && (r = s.protocol + "//" + s.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = s.protocol + r : r = s.host + r), /^(https?|wss?):\/\//.test(r) || (typeof s < "u" ? r = s.protocol + "//" + r : r = "https://" + r), o = parse(r)), o.port || (/^(http|ws)$/.test(o.protocol) ? o.port = "80" : /^(http|ws)s$/.test(o.protocol) && (o.port = "443")), o.path = o.path || "/";
  const l = o.host.indexOf(":") !== -1 ? "[" + o.host + "]" : o.host;
  return o.id = o.protocol + "://" + l + ":" + o.port + e, o.href = o.protocol + "://" + l + (s && s.port === o.port ? "" : ":" + o.port), o;
}
const withNativeArrayBuffer = typeof ArrayBuffer == "function", isView = (r) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r.buffer instanceof ArrayBuffer, toString = Object.prototype.toString, withNativeBlob = typeof Blob == "function" || typeof Blob < "u" && toString.call(Blob) === "[object BlobConstructor]", withNativeFile = typeof File == "function" || typeof File < "u" && toString.call(File) === "[object FileConstructor]";
function isBinary(r) {
  return withNativeArrayBuffer && (r instanceof ArrayBuffer || isView(r)) || withNativeBlob && r instanceof Blob || withNativeFile && r instanceof File;
}
function hasBinary(r, e) {
  if (!r || typeof r != "object")
    return !1;
  if (Array.isArray(r)) {
    for (let s = 0, o = r.length; s < o; s++)
      if (hasBinary(r[s]))
        return !0;
    return !1;
  }
  if (isBinary(r))
    return !0;
  if (r.toJSON && typeof r.toJSON == "function" && arguments.length === 1)
    return hasBinary(r.toJSON(), !0);
  for (const s in r)
    if (Object.prototype.hasOwnProperty.call(r, s) && hasBinary(r[s]))
      return !0;
  return !1;
}
function deconstructPacket(r) {
  const e = [], s = r.data, o = r;
  return o.data = _deconstructPacket(s, e), o.attachments = e.length, { packet: o, buffers: e };
}
function _deconstructPacket(r, e) {
  if (!r)
    return r;
  if (isBinary(r)) {
    const s = { _placeholder: !0, num: e.length };
    return e.push(r), s;
  } else if (Array.isArray(r)) {
    const s = new Array(r.length);
    for (let o = 0; o < r.length; o++)
      s[o] = _deconstructPacket(r[o], e);
    return s;
  } else if (typeof r == "object" && !(r instanceof Date)) {
    const s = {};
    for (const o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (s[o] = _deconstructPacket(r[o], e));
    return s;
  }
  return r;
}
function reconstructPacket(r, e) {
  return r.data = _reconstructPacket(r.data, e), delete r.attachments, r;
}
function _reconstructPacket(r, e) {
  if (!r)
    return r;
  if (r && r._placeholder === !0) {
    if (typeof r.num == "number" && r.num >= 0 && r.num < e.length)
      return e[r.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(r))
    for (let s = 0; s < r.length; s++)
      r[s] = _reconstructPacket(r[s], e);
  else if (typeof r == "object")
    for (const s in r)
      Object.prototype.hasOwnProperty.call(r, s) && (r[s] = _reconstructPacket(r[s], e));
  return r;
}
const RESERVED_EVENTS$1 = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], protocol = 5;
var PacketType;
(function(r) {
  r[r.CONNECT = 0] = "CONNECT", r[r.DISCONNECT = 1] = "DISCONNECT", r[r.EVENT = 2] = "EVENT", r[r.ACK = 3] = "ACK", r[r.CONNECT_ERROR = 4] = "CONNECT_ERROR", r[r.BINARY_EVENT = 5] = "BINARY_EVENT", r[r.BINARY_ACK = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
class Encoder {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(e) {
    this.replacer = e;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(e) {
    return (e.type === PacketType.EVENT || e.type === PacketType.ACK) && hasBinary(e) ? this.encodeAsBinary({
      type: e.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
      nsp: e.nsp,
      data: e.data,
      id: e.id
    }) : [this.encodeAsString(e)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(e) {
    let s = "" + e.type;
    return (e.type === PacketType.BINARY_EVENT || e.type === PacketType.BINARY_ACK) && (s += e.attachments + "-"), e.nsp && e.nsp !== "/" && (s += e.nsp + ","), e.id != null && (s += e.id), e.data != null && (s += JSON.stringify(e.data, this.replacer)), s;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(e) {
    const s = deconstructPacket(e), o = this.encodeAsString(s.packet), a = s.buffers;
    return a.unshift(o), a;
  }
}
function isObject(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
class Decoder extends Emitter {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(e) {
    super(), this.reviver = e;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(e) {
    let s;
    if (typeof e == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      s = this.decodeString(e);
      const o = s.type === PacketType.BINARY_EVENT;
      o || s.type === PacketType.BINARY_ACK ? (s.type = o ? PacketType.EVENT : PacketType.ACK, this.reconstructor = new BinaryReconstructor(s), s.attachments === 0 && super.emitReserved("decoded", s)) : super.emitReserved("decoded", s);
    } else if (isBinary(e) || e.base64)
      if (this.reconstructor)
        s = this.reconstructor.takeBinaryData(e), s && (this.reconstructor = null, super.emitReserved("decoded", s));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + e);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(e) {
    let s = 0;
    const o = {
      type: Number(e.charAt(0))
    };
    if (PacketType[o.type] === void 0)
      throw new Error("unknown packet type " + o.type);
    if (o.type === PacketType.BINARY_EVENT || o.type === PacketType.BINARY_ACK) {
      const l = s + 1;
      for (; e.charAt(++s) !== "-" && s != e.length; )
        ;
      const u = e.substring(l, s);
      if (u != Number(u) || e.charAt(s) !== "-")
        throw new Error("Illegal attachments");
      o.attachments = Number(u);
    }
    if (e.charAt(s + 1) === "/") {
      const l = s + 1;
      for (; ++s && !(e.charAt(s) === "," || s === e.length); )
        ;
      o.nsp = e.substring(l, s);
    } else
      o.nsp = "/";
    const a = e.charAt(s + 1);
    if (a !== "" && Number(a) == a) {
      const l = s + 1;
      for (; ++s; ) {
        const u = e.charAt(s);
        if (u == null || Number(u) != u) {
          --s;
          break;
        }
        if (s === e.length)
          break;
      }
      o.id = Number(e.substring(l, s + 1));
    }
    if (e.charAt(++s)) {
      const l = this.tryParse(e.substr(s));
      if (Decoder.isPayloadValid(o.type, l))
        o.data = l;
      else
        throw new Error("invalid payload");
    }
    return o;
  }
  tryParse(e) {
    try {
      return JSON.parse(e, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(e, s) {
    switch (e) {
      case PacketType.CONNECT:
        return isObject(s);
      case PacketType.DISCONNECT:
        return s === void 0;
      case PacketType.CONNECT_ERROR:
        return typeof s == "string" || isObject(s);
      case PacketType.EVENT:
      case PacketType.BINARY_EVENT:
        return Array.isArray(s) && (typeof s[0] == "number" || typeof s[0] == "string" && RESERVED_EVENTS$1.indexOf(s[0]) === -1);
      case PacketType.ACK:
      case PacketType.BINARY_ACK:
        return Array.isArray(s);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class BinaryReconstructor {
  constructor(e) {
    this.packet = e, this.buffers = [], this.reconPack = e;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(e) {
    if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
      const s = reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), s;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const parser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder,
  Encoder,
  get PacketType() {
    return PacketType;
  },
  protocol
}, Symbol.toStringTag, { value: "Module" }));
function on(r, e, s) {
  return r.on(e, s), function() {
    r.off(e, s);
  };
}
const RESERVED_EVENTS = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class Socket extends Emitter {
  /**
   * `Socket` constructor.
   */
  constructor(e, s, o) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = s, o && o.auth && (this.auth = o.auth), this._opts = Object.assign({}, o), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const e = this.io;
    this.subs = [
      on(e, "open", this.onopen.bind(this)),
      on(e, "packet", this.onpacket.bind(this)),
      on(e, "error", this.onerror.bind(this)),
      on(e, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...e) {
    return e.unshift("message"), this.emit.apply(this, e), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(e, ...s) {
    var o, a, l;
    if (RESERVED_EVENTS.hasOwnProperty(e))
      throw new Error('"' + e.toString() + '" is a reserved event name');
    if (s.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(s), this;
    const u = {
      type: PacketType.EVENT,
      data: s
    };
    if (u.options = {}, u.options.compress = this.flags.compress !== !1, typeof s[s.length - 1] == "function") {
      const f = this.ids++, h = s.pop();
      this._registerAckCallback(f, h), u.id = f;
    }
    const c = (a = (o = this.io.engine) === null || o === void 0 ? void 0 : o.transport) === null || a === void 0 ? void 0 : a.writable, E = this.connected && !(!((l = this.io.engine) === null || l === void 0) && l._hasPingExpired());
    return this.flags.volatile && !c || (E ? (this.notifyOutgoingListeners(u), this.packet(u)) : this.sendBuffer.push(u)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(e, s) {
    var o;
    const a = (o = this.flags.timeout) !== null && o !== void 0 ? o : this._opts.ackTimeout;
    if (a === void 0) {
      this.acks[e] = s;
      return;
    }
    const l = this.io.setTimeoutFn(() => {
      delete this.acks[e];
      for (let c = 0; c < this.sendBuffer.length; c++)
        this.sendBuffer[c].id === e && this.sendBuffer.splice(c, 1);
      s.call(this, new Error("operation has timed out"));
    }, a), u = (...c) => {
      this.io.clearTimeoutFn(l), s.apply(this, c);
    };
    u.withError = !0, this.acks[e] = u;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(e, ...s) {
    return new Promise((o, a) => {
      const l = (u, c) => u ? a(u) : o(c);
      l.withError = !0, s.push(l), this.emit(e, ...s);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(e) {
    let s;
    typeof e[e.length - 1] == "function" && (s = e.pop());
    const o = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: e,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    e.push((a, ...l) => o !== this._queue[0] ? void 0 : (a !== null ? o.tryCount > this._opts.retries && (this._queue.shift(), s && s(a)) : (this._queue.shift(), s && s(null, ...l)), o.pending = !1, this._drainQueue())), this._queue.push(o), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(e = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const s = this._queue[0];
    s.pending && !e || (s.pending = !0, s.tryCount++, this.flags = s.flags, this.emit.apply(this, s.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(e) {
    e.nsp = this.nsp, this.io._packet(e);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((e) => {
      this._sendConnectPacket(e);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(e) {
    this.packet({
      type: PacketType.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, e) : e
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(e) {
    this.connected || this.emitReserved("connect_error", e);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(e, s) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", e, s), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((e) => {
      if (!this.sendBuffer.some((o) => String(o.id) === e)) {
        const o = this.acks[e];
        delete this.acks[e], o.withError && o.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(e) {
    if (e.nsp === this.nsp)
      switch (e.type) {
        case PacketType.CONNECT:
          e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case PacketType.EVENT:
        case PacketType.BINARY_EVENT:
          this.onevent(e);
          break;
        case PacketType.ACK:
        case PacketType.BINARY_ACK:
          this.onack(e);
          break;
        case PacketType.DISCONNECT:
          this.ondisconnect();
          break;
        case PacketType.CONNECT_ERROR:
          this.destroy();
          const o = new Error(e.data.message);
          o.data = e.data.data, this.emitReserved("connect_error", o);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(e) {
    const s = e.data || [];
    e.id != null && s.push(this.ack(e.id)), this.connected ? this.emitEvent(s) : this.receiveBuffer.push(Object.freeze(s));
  }
  emitEvent(e) {
    if (this._anyListeners && this._anyListeners.length) {
      const s = this._anyListeners.slice();
      for (const o of s)
        o.apply(this, e);
    }
    super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(e) {
    const s = this;
    let o = !1;
    return function(...a) {
      o || (o = !0, s.packet({
        type: PacketType.ACK,
        id: e,
        data: a
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(e) {
    const s = this.acks[e.id];
    typeof s == "function" && (delete this.acks[e.id], s.withError && e.data.unshift(null), s.apply(this, e.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(e, s) {
    this.id = e, this.recovered = s && this._pid === s, this._pid = s, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
      this.notifyOutgoingListeners(e), this.packet(e);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((e) => e()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: PacketType.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(e) {
    return this.flags.compress = e, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(e) {
    return this.flags.timeout = e, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(e) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(e) {
    if (!this._anyListeners)
      return this;
    if (e) {
      const s = this._anyListeners;
      for (let o = 0; o < s.length; o++)
        if (e === s[o])
          return s.splice(o, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(e) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(e) {
    if (!this._anyOutgoingListeners)
      return this;
    if (e) {
      const s = this._anyOutgoingListeners;
      for (let o = 0; o < s.length; o++)
        if (e === s[o])
          return s.splice(o, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(e) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const s = this._anyOutgoingListeners.slice();
      for (const o of s)
        o.apply(this, e.data);
    }
  }
}
function Backoff(r) {
  r = r || {}, this.ms = r.min || 100, this.max = r.max || 1e4, this.factor = r.factor || 2, this.jitter = r.jitter > 0 && r.jitter <= 1 ? r.jitter : 0, this.attempts = 0;
}
Backoff.prototype.duration = function() {
  var r = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var e = Math.random(), s = Math.floor(e * this.jitter * r);
    r = Math.floor(e * 10) & 1 ? r + s : r - s;
  }
  return Math.min(r, this.max) | 0;
};
Backoff.prototype.reset = function() {
  this.attempts = 0;
};
Backoff.prototype.setMin = function(r) {
  this.ms = r;
};
Backoff.prototype.setMax = function(r) {
  this.max = r;
};
Backoff.prototype.setJitter = function(r) {
  this.jitter = r;
};
class Manager extends Emitter {
  constructor(e, s) {
    var o;
    super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (s = e, e = void 0), s = s || {}, s.path = s.path || "/socket.io", this.opts = s, installTimerFunctions(this, s), this.reconnection(s.reconnection !== !1), this.reconnectionAttempts(s.reconnectionAttempts || 1 / 0), this.reconnectionDelay(s.reconnectionDelay || 1e3), this.reconnectionDelayMax(s.reconnectionDelayMax || 5e3), this.randomizationFactor((o = s.randomizationFactor) !== null && o !== void 0 ? o : 0.5), this.backoff = new Backoff({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(s.timeout == null ? 2e4 : s.timeout), this._readyState = "closed", this.uri = e;
    const a = s.parser || parser;
    this.encoder = new a.Encoder(), this.decoder = new a.Decoder(), this._autoConnect = s.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(e) {
    return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(e) {
    return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
  }
  reconnectionDelay(e) {
    var s;
    return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (s = this.backoff) === null || s === void 0 || s.setMin(e), this);
  }
  randomizationFactor(e) {
    var s;
    return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (s = this.backoff) === null || s === void 0 || s.setJitter(e), this);
  }
  reconnectionDelayMax(e) {
    var s;
    return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (s = this.backoff) === null || s === void 0 || s.setMax(e), this);
  }
  timeout(e) {
    return arguments.length ? (this._timeout = e, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(e) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new Socket$1(this.uri, this.opts);
    const s = this.engine, o = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const a = on(s, "open", function() {
      o.onopen(), e && e();
    }), l = (c) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", c), e ? e(c) : this.maybeReconnectOnOpen();
    }, u = on(s, "error", l);
    if (this._timeout !== !1) {
      const c = this._timeout, E = this.setTimeoutFn(() => {
        a(), l(new Error("timeout")), s.close();
      }, c);
      this.opts.autoUnref && E.unref(), this.subs.push(() => {
        this.clearTimeoutFn(E);
      });
    }
    return this.subs.push(a), this.subs.push(u), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(e) {
    return this.open(e);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const e = this.engine;
    this.subs.push(
      on(e, "ping", this.onping.bind(this)),
      on(e, "data", this.ondata.bind(this)),
      on(e, "error", this.onerror.bind(this)),
      on(e, "close", this.onclose.bind(this)),
      // @ts-ignore
      on(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(e) {
    try {
      this.decoder.add(e);
    } catch (s) {
      this.onclose("parse error", s);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(e) {
    nextTick(() => {
      this.emitReserved("packet", e);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(e) {
    this.emitReserved("error", e);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(e, s) {
    let o = this.nsps[e];
    return o ? this._autoConnect && !o.active && o.connect() : (o = new Socket(this, e, s), this.nsps[e] = o), o;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(e) {
    const s = Object.keys(this.nsps);
    for (const o of s)
      if (this.nsps[o].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(e) {
    const s = this.encoder.encode(e);
    for (let o = 0; o < s.length; o++)
      this.engine.write(s[o], e.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(e, s) {
    var o;
    this.cleanup(), (o = this.engine) === null || o === void 0 || o.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, s), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const e = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const s = this.backoff.duration();
      this._reconnecting = !0;
      const o = this.setTimeoutFn(() => {
        e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((a) => {
          a ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", a)) : e.onreconnect();
        }));
      }, s);
      this.opts.autoUnref && o.unref(), this.subs.push(() => {
        this.clearTimeoutFn(o);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const e = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
  }
}
const cache = {};
function lookup(r, e) {
  typeof r == "object" && (e = r, r = void 0), e = e || {};
  const s = url(r, e.path || "/socket.io"), o = s.source, a = s.id, l = s.path, u = cache[a] && l in cache[a].nsps, c = e.forceNew || e["force new connection"] || e.multiplex === !1 || u;
  let E;
  return c ? E = new Manager(o, e) : (cache[a] || (cache[a] = new Manager(o, e)), E = cache[a]), s.query && !e.query && (e.query = s.queryKey), E.socket(s.path, e);
}
Object.assign(lookup, {
  Manager,
  Socket,
  io: lookup,
  connect: lookup
});
const MAX_LIVES = 10;
class Actor {
  constructor(e, s, o) {
    Qt(this, "id");
    Qt(this, "name");
    Qt(this, "color");
    Qt(this, "entity");
    Qt(this, "rotation");
    Qt(this, "score");
    Qt(this, "lives");
    this.id = e, this.name = s, this.color = o, this.entity = new Entity(1), this.rotation = new Quaternion$1(), this.score = 0, this.lives = MAX_LIVES;
  }
}
const _MATRIX4_0$1 = new Matrix4(), _VECTOR3_0$2 = new Vector3$1();
let _BULLET_ID = 0;
class Bullet {
  constructor(e) {
    Qt(this, "id");
    Qt(this, "owner");
    Qt(this, "entity");
    Qt(this, "life");
    this.id = _BULLET_ID++, this.owner = e, this.entity = new Entity(0.1, 0.01), this.life = 3;
    const s = 10, o = _MATRIX4_0$1.makeRotationFromQuaternion(e.rotation), a = _VECTOR3_0$2.setFromMatrixColumn(o, 2).normalize().negate();
    this.entity.position.copy(a).add(e.entity.position), this.entity.velocity.copy(a).multiplyScalar(s);
  }
  update(e) {
    this.life -= e;
  }
}
const _VECTOR3_0$1 = new Vector3$1(), _VECTOR3_1$1 = new Vector3$1(), _VECTOR3_2$1 = new Vector3$1(), _VECTOR3_3$1 = new Vector3$1(), _VECTOR3_4$1 = new Vector3$1(), _VECTOR3_5$1 = new Vector3$1(), _QUATERNION_0 = new Quaternion$1(), _CARTOGRAPHIC_0 = new Cartographic$1(), _MATRIX4_0 = new Matrix4(), SPEED_XY = 5, SPEED_Z = 5;
class CameraControl {
  constructor(e, s) {
    Qt(this, "camera");
    Qt(this, "actor");
    Qt(this, "pitch");
    Qt(this, "yaw");
    Qt(this, "moveStates");
    this.camera = e, this.actor = s, this.pitch = 0, this.yaw = 0, this.moveStates = {
      forward: !1,
      backward: !1,
      left: !1,
      right: !1
    };
  }
  /**
   * Update the rotation of the camera from pitch and yaw
   */
  updateRotation() {
    const e = _VECTOR3_0$1, s = _VECTOR3_1$1, o = _VECTOR3_2$1, a = _CARTOGRAPHIC_0;
    this.camera.getPositionCartographic(a), Ellipsoid$1.WGS_84.rotationBasisForCartographic(a, null, e, s, o), this.camera.setUpVector(e);
    const l = Math.PI - 0.05, u = -(l / 2), c = u + l;
    this.pitch = Math.max(Math.min(this.pitch, c), u);
    const E = _VECTOR3_3$1;
    this.camera.getPositionECEF(E);
    const d = s.clone().applyAxisAngle(o, this.pitch).applyAxisAngle(e, this.yaw).add(E);
    this.camera.lookAt(d), this.camera.getRotation(this.actor.rotation);
  }
  /**
   * Update pitch and yaw given the current configuration of the camera
   */
  initPitchYaw() {
    const e = _VECTOR3_0$1, s = _VECTOR3_1$1, o = _VECTOR3_2$1, a = _QUATERNION_0;
    this.camera.getRotation(a), new Matrix4().makeRotationFromQuaternion(a).extractBasis(e, s, o);
    const l = _VECTOR3_3$1, u = _VECTOR3_4$1, c = _CARTOGRAPHIC_0;
    this.camera.getPositionCartographic(c), Ellipsoid$1.WGS_84.rotationBasisForCartographic(c, null, l, void 0, u);
    const E = e.projectOnPlane(l), d = Math.sign(u.clone().cross(E).dot(l)), f = Math.sign(l.clone().cross(s).dot(e));
    this.yaw = d * E.angleTo(u), this.pitch = f * s.angleTo(l);
  }
  /**
   * Handle keyboard tap
   */
  onKeyTap(e) {
    (e === "w" || e === "W") && (this.moveStates.forward = !0), (e === "s" || e === "S") && (this.moveStates.backward = !0), (e === "a" || e === "A") && (this.moveStates.left = !0), (e === "d" || e === "D") && (this.moveStates.right = !0), e === " " && this.jump();
  }
  /**
   * Handle keyboard release
   */
  onKeyRelease(e) {
    (e === "w" || e === "W") && (this.moveStates.forward = !1), (e === "s" || e === "S") && (this.moveStates.backward = !1), (e === "a" || e === "A") && (this.moveStates.left = !1), (e === "d" || e === "D") && (this.moveStates.right = !1);
  }
  /**
   * Handle look around.
   *
   * @param velocity
   */
  lookAround(e) {
    this.pitch -= 5e-3 * e.y, this.yaw -= 5e-3 * e.x, this.updateRotation();
  }
  /**
   * Handle jump.
   */
  jump() {
    const e = _VECTOR3_5$1, s = _CARTOGRAPHIC_0;
    this.camera.getPositionCartographic(s), Ellipsoid$1.WGS_84.rotationBasisForCartographic(s, null, e), this.actor.entity.onGround && this.actor.entity.velocity.addScaledVector(e, SPEED_Z);
  }
  /**
   * Update the camera.
   */
  update() {
    this.camera.getPerspective().setFieldOfView(75), this.camera.setPositionECEF(this.actor.entity.position);
    const e = _VECTOR3_0$1, s = _VECTOR3_1$1, o = _VECTOR3_2$1;
    this.camera.getWorldMatrix(_MATRIX4_0), _MATRIX4_0.extractBasis(s, e, o);
    const a = _CARTOGRAPHIC_0;
    this.camera.getPositionCartographic(a), Ellipsoid$1.WGS_84.rotationBasisForCartographic(a, null, e), o.crossVectors(e, s).normalize(), s.crossVectors(o, e).normalize(), e.normalize();
    const l = this.actor.entity.velocity.dot(o);
    this.moveStates.forward ? this.actor.entity.velocity.addScaledVector(o, SPEED_XY - l) : this.moveStates.backward ? this.actor.entity.velocity.addScaledVector(o, -SPEED_XY - l) : this.actor.entity.velocity.addScaledVector(o, -l);
    const u = this.actor.entity.velocity.dot(s);
    this.moveStates.right ? this.actor.entity.velocity.addScaledVector(s, SPEED_XY - u) : this.moveStates.left ? this.actor.entity.velocity.addScaledVector(s, -SPEED_XY - u) : this.actor.entity.velocity.addScaledVector(s, -u);
  }
}
const _VECTOR2_0 = new Vector2();
class Joystick {
  constructor(e) {
    Qt(this, "draw2D");
    Qt(this, "joystickPointerId");
    Qt(this, "joystickBase");
    Qt(this, "joystickHandle");
    Qt(this, "buttonA");
    Qt(this, "buttonB");
    this.draw2D = e, this.joystickPointerId = null, this.joystickBase = {
      type: "circle",
      radius: 0,
      position: new Vector2(),
      color: new Color(0.7, 0.7, 0.7),
      opacity: 0.5,
      fill: !0
    }, this.joystickHandle = {
      type: "circle",
      radius: 0,
      position: new Vector2(),
      color: new Color(0.1, 0.1, 0.1),
      opacity: 0.5,
      fill: !0
    }, this.buttonA = {
      type: "circle",
      radius: 0,
      position: new Vector2(),
      color: new Color(1, 1, 0),
      opacity: 0.5,
      fill: !0
    }, this.buttonB = {
      type: "circle",
      radius: 0,
      position: new Vector2(),
      color: new Color(1, 0, 0),
      opacity: 0.5,
      fill: !0
    };
  }
  updateDrawables() {
    const { width: e, height: s } = this.draw2D.getCanvas(), o = s / 5, a = s / 10;
    this.joystickBase.radius = o, this.joystickBase.position.set(o * 1.5, s - o * 1.5), this.joystickHandle.radius = o / 2, this.joystickHandle.position.set(o * 1.5, s - o * 1.5), this.buttonA.radius = a, this.buttonA.position.set(e - a * 2, s - a * 4), this.buttonB.radius = a, this.buttonB.position.set(e - a * 4, s - a * 2);
  }
  /**
   * Enable the controls.
   *
   * @param onJoyMove
   * @param onFreeMove
   * @param onPressA
   * @param onPressB
   */
  enable(e, s, o, a) {
    document.onpointerdown = (l) => {
      const u = _VECTOR2_0.set(l.clientX, l.clientY);
      isPointInCircle(u, this.joystickBase.position, this.joystickBase.radius) ? this.joystickPointerId = l.pointerId : isPointInCircle(u, this.buttonA.position, this.buttonA.radius) ? o() : isPointInCircle(u, this.buttonB.position, this.buttonB.radius) && a();
    }, document.onpointermove = (l) => {
      const u = _VECTOR2_0.set(l.clientX, l.clientY);
      if (l.pointerId === this.joystickPointerId) {
        const c = this.joystickBase.radius / 4, E = u.x - this.joystickBase.position.x, d = u.y - this.joystickBase.position.y;
        this.joystickHandle.position.copy(u);
        let f;
        E < -c ? f = -1 : E > c ? f = 1 : f = 0;
        let h;
        d < -c ? h = -1 : d > c ? h = 1 : h = 0, e(f, h);
      } else
        s(l.movementX, l.movementY);
    }, document.onpointerup = (l) => {
      l.pointerId === this.joystickPointerId && (this.joystickPointerId = null, this.joystickHandle.position.copy(this.joystickBase.position), e(0, 0));
    }, this.updateDrawables(), this.draw2D.addDrawable(this.joystickBase), this.draw2D.addDrawable(this.joystickHandle), this.draw2D.addDrawable(this.buttonA), this.draw2D.addDrawable(this.buttonB);
  }
  /**
   * Disable the controls.
   */
  disable() {
    document.onpointerdown = null, document.onpointermove = null, document.onpointerup = null, this.draw2D.removeDrawable(this.joystickBase), this.draw2D.removeDrawable(this.joystickHandle), this.draw2D.removeDrawable(this.buttonA), this.draw2D.removeDrawable(this.buttonB);
  }
}
const AUDIO_CONTEXT = new AudioContext(), AUDIO_CACHE = /* @__PURE__ */ new Map();
async function playPositionalSound(r, e, s) {
  let o = AUDIO_CACHE.get(r);
  if (!o) {
    const S = await (await fetch(r)).arrayBuffer();
    o = await AUDIO_CONTEXT.decodeAudioData(S), AUDIO_CACHE.set(r, o);
  }
  const a = e.distanceTo(s), c = 100 - 20 * Math.log10(a / 1), E = Math.pow(10, (c - 120) / 20), d = AUDIO_CONTEXT.createBufferSource(), f = AUDIO_CONTEXT.createGain();
  d.buffer = o, d.connect(f), f.gain.setValueAtTime(Math.max(0, Math.min(1, E)), 0), f.connect(AUDIO_CONTEXT.destination), d.start();
}
const SHOOT_SOUND_URL = "https://s3.ap-southeast-2.amazonaws.com/skand.development.keith.test-files/audio/riffle.ogg", IMPACT_SOUND_URL = "https://s3.ap-southeast-2.amazonaws.com/skand.development.keith.test-files/audio/assault.ogg";
class GameService extends Service {
  constructor(s, o, a) {
    super(s);
    Qt(this, "navigationService");
    Qt(this, "socket");
    Qt(this, "gameId");
    Qt(this, "actors");
    Qt(this, "bullets");
    Qt(this, "actorModels");
    Qt(this, "bulletModels");
    Qt(this, "player");
    Qt(this, "cameraControl");
    Qt(this, "joystick");
    Qt(this, "updateInterval");
    Qt(this, "respawnTimer");
    Qt(this, "onConnectionChange");
    Qt(this, "onScoreUpdate");
    Qt(this, "onRespawn");
    Qt(this, "onKill");
    this.navigationService = o, this.socket = lookup(a), this.gameId = null, this.actors = {}, this.bullets = {}, this.actorModels = {}, this.bulletModels = {}, this.player = new Actor("", "", new Color()), this.cameraControl = new CameraControl(this.renderer.getWorld().getCamera(), this.player), this.joystick = new Joystick(this.draw2D), this.updateInterval = null, this.respawnTimer = 0, this.onConnectionChange = () => {
    }, this.onScoreUpdate = () => {
    }, this.onRespawn = () => {
    }, this.onKill = () => {
    }, this.socket.on("connect", () => {
      this.player.id = this.socket.id;
    }), this.socket.on("join", (l) => this.onJoin(l)), this.socket.on("disconnect", () => this.onDisconnect()), this.socket.on("leave", () => this.onDisconnect()), this.socket.on("invalid", () => this.onConnectionChange(null)), this.socket.on("listen", (l) => this.onListen(l)), this.socket.on(
      "kill",
      (l, u) => this.onKill(this.actors[l], this.actors[u])
    ), this.simulation.setOnCollide((l, u) => {
      const c = Object.values(this.actors).find((d) => d.entity === l), E = Object.values(this.bullets).flatMap((d) => Array.from(d)).find((d) => d.entity === u);
      c && E && this.player !== c && E.owner === this.player && c.lives > 0 && (this.socket.emit("hit", this.gameId, c.id), this.destroyBullet(E));
    });
  }
  serializePlayer() {
    return {
      n: this.player.name,
      p: [
        this.player.entity.position.x,
        this.player.entity.position.y,
        this.player.entity.position.z
      ],
      r: [
        this.player.rotation.x,
        this.player.rotation.y,
        this.player.rotation.z,
        this.player.rotation.w
      ],
      v: [
        this.player.entity.velocity.x,
        this.player.entity.velocity.y,
        this.player.entity.velocity.z
      ],
      c: this.player.color.getHex(),
      b: Array.from(this.bullets[this.player.id]).map(this.serializeBullet)
    };
  }
  serializeBullet(s) {
    return [
      s.entity.position.x,
      s.entity.position.y,
      s.entity.position.z,
      s.life
    ];
  }
  onListen(s) {
    for (const a in this.actors)
      a !== this.socket.id && !s.find(([l, u]) => l === a) && this.destroyActor(this.actors[a]);
    let o = !1;
    for (const [a, l] of s) {
      const u = this.actors[a] ?? this.createActor(a, l.n, l.c);
      if ((u.score !== l.s || u.lives !== l.l) && (o = !0), u.score = l.s, u.lives = l.l, u.id === this.socket.id)
        continue;
      u.name = l.n, u.entity.position.set(...l.p), u.entity.velocity.set(...l.v), u.rotation.set(...l.r), u.color.set(l.c);
      const c = Array.from(this.bullets[a]);
      let E = 0;
      for (E; E < l.b.length; E++) {
        const [d, f, h, S] = l.b[E], R = c[E] ?? this.createBullet(a);
        R.entity.position.set(d, f, h), R.life = S;
      }
      for (E; E < c.length; E++)
        this.destroyBullet(c[E]);
    }
    o && this.onScoreUpdate();
  }
  onJoin(s) {
    this.actors[this.player.id] = this.player, this.bullets[this.player.id] = /* @__PURE__ */ new Set(), this.simulation.add(this.player.entity), this.renderer.getWorld().getCamera().getPositionECEF(this.player.entity.position), this.renderer.getWorld().getCamera().getRotation(this.player.rotation), this.updateInterval = setInterval(
      () => this.socket.emit("update", s, this.serializePlayer()),
      50
    ), this.gameId = s, this.setupControls(), this.onConnectionChange(s);
  }
  onDisconnect() {
    this.updateInterval && clearInterval(this.updateInterval), this.gameId = null, this.updateInterval = null, this.releaseControls(), this.clear(), this.onConnectionChange(null);
  }
  setupMobileControls() {
    const s = (u, c) => {
      this.cameraControl.moveStates.left = u < 0, this.cameraControl.moveStates.right = u > 0, this.cameraControl.moveStates.forward = c < 0, this.cameraControl.moveStates.backward = c > 0;
    }, o = (u, c) => {
      this.cameraControl.lookAround(new Vector2(u, c));
    }, a = () => {
      this.cameraControl.jump();
    }, l = () => {
      this.createBullet(this.socket.id);
    };
    this.joystick.enable(s, o, a, l);
  }
  setupDesktopControls() {
    this.gestures.register("keytap", (s) => {
      this.cameraControl.onKeyTap(s.key), s.key === "Escape" && this.gestures.unlockCursor();
    }), this.gestures.register("keyrelease", (s) => {
      this.cameraControl.onKeyRelease(s.key);
    }), this.gestures.register("hover", (s) => this.cameraControl.lookAround(s.velocity)), this.gestures.register("tap", (s) => {
      s.button === 0 ? (this.gestures.lockCursor(), this.createBullet(this.socket.id)) : this.gestures.unlockCursor();
    });
  }
  setupControls() {
    this.navigationService.disable(), this.cameraControl.initPitchYaw(), /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? this.setupMobileControls() : this.setupDesktopControls();
  }
  releaseControls() {
    this.gestures.unregisterAll(), this.gestures.unlockCursor(), this.joystick.disable(), this.navigationService.enable();
  }
  createActor(s, o, a) {
    const l = new Actor(s, o, new Color(a));
    return this.simulation.add(l.entity), this.renderer.getObjectFactory().createObj({
      url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.keith.test-files/obj/multiplayer/player.obj",
      material: { type: "basicOpaque", color: l.color }
    }).then((u) => {
      this.actors[s] && (u.setVisible(s !== this.socket.id), this.renderer.getWorld().addObject(u), this.actorModels[s] = u);
    }), this.actors[s] = l, this.bullets[s] = /* @__PURE__ */ new Set(), this.onScoreUpdate(), l;
  }
  destroyActor(s) {
    this.simulation.remove(s.entity);
    const o = this.actorModels[s.id];
    o && this.renderer.getWorld().removeObject(o);
    for (const a of this.bullets[s.id])
      this.destroyBullet(a);
    delete this.actors[s.id], delete this.actorModels[s.id], delete this.bullets[s.id];
  }
  createBullet(s) {
    if (this.actors[s].lives === 0)
      return;
    const o = new Bullet(this.actors[s]);
    this.simulation.add(o.entity), playPositionalSound(SHOOT_SOUND_URL, o.entity.position, this.player.entity.position);
    const a = this.renderer.getObjectFactory().createSphere({
      radius: o.entity.radius,
      position: { ecef: o.entity.position },
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 0)
      }
    });
    return a.setVisible(!0), this.renderer.getWorld().addObject(a), this.bullets[s].add(o), this.bulletModels[o.id] = a, o;
  }
  destroyBullet(s) {
    const o = this.bulletModels[s.id];
    this.simulation.remove(s.entity), playPositionalSound(IMPACT_SOUND_URL, s.entity.position, this.player.entity.position), this.renderer.getWorld().removeObject(o), o.dispose(), this.bullets[s.owner.id].delete(s), delete this.bulletModels[s.id];
  }
  clear() {
    this.player.score = 0, this.player.lives = MAX_LIVES;
    for (const s in this.actors)
      this.destroyActor(this.actors[s]);
  }
  /**
   * Get the score board.
   *
   * @returns
   */
  getActors() {
    const s = /* @__PURE__ */ new Map();
    for (const o in this.actors) {
      const a = this.actors[o];
      s.set(a.id, this.actors[o]);
    }
    return s;
  }
  /**
   * Set the name of the avatar.
   *
   * @param name
   */
  setName(s) {
    this.player.name = s;
  }
  /**
   * Set the color of the avatar.
   *
   * @param color
   */
  setColor(s) {
    this.player.color.copy(s);
  }
  /**
   * Host a game.
   *
   * @param gameId
   */
  host() {
    this.socket.emit("host");
  }
  /**
   * Join a game.
   *
   * @param gameId
   */
  join(s) {
    this.socket.emit("join", s);
  }
  /**
   * Leave the current game.
   */
  leave() {
    this.gameId && this.socket.emit("leave");
  }
  /**
   * Get the current game ID.
   *
   * @returns
   */
  getGameId() {
    return this.gameId;
  }
  /**
   * Get the player ID.
   *
   * @returns
   */
  getPlayerId() {
    return this.player.id;
  }
  /**
   * Set the connection state update handler.
   *
   * @param handler
   */
  setConnectionChangeHandler(s) {
    this.onConnectionChange = s;
  }
  /**
   * Set the score update handler.
   *
   * @param handler
   */
  setScoreUpdateHandler(s) {
    this.onScoreUpdate = s;
  }
  /**
   * Set the handler when the player is respawned.
   *
   * @param handler
   */
  setRespawnHandler(s) {
    this.onRespawn = s;
  }
  /**
   * Set the handler when a kill is made.
   *
   * @param handler
   */
  setKillHandler(s) {
    this.onKill = s;
  }
  updateFrame(s) {
    if (this.gameId) {
      this.cameraControl.update();
      for (const o in this.actors) {
        const a = this.actors[o], l = this.actorModels[o];
        l && (l.setVisible(a.lives > 0), l.setPositionECEF(a.entity.position), l.setRotation(a.rotation));
        const u = Array.from(this.bullets[o]);
        for (const c of u) {
          const E = this.bulletModels[c.id];
          c.update(s), E.setPositionECEF(c.entity.position), c.life <= 0 && this.destroyBullet(c);
        }
      }
      this.player.lives === 0 && this.respawnTimer === 0 && (this.respawnTimer = 10), this.respawnTimer > 0 && (this.respawnTimer -= s, this.respawnTimer <= 0 && (this.player.lives = 1 / 0, this.respawnTimer = 0, this.socket.emit("respawn", this.gameId), this.onRespawn())), this.simulation.setCollisionFilter(
        Object.values(this.actorModels).concat(Object.values(this.bulletModels))
      );
    }
  }
}
class GlobeService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "globe");
    Qt(this, "navigationService");
    Qt(this, "imageryLayers");
    Qt(this, "terrainLayers");
    Qt(this, "imageryBaseMap");
    Qt(this, "googleGlobe");
    Qt(this, "googleGlobeEnabled");
    Qt(this, "showImagery");
    Qt(this, "showTerrain");
    this.globe = this.renderer.getWorld().getGlobe(), this.navigationService = o, this.imageryLayers = [], this.terrainLayers = [], this.imageryBaseMap = "street", this.googleGlobe = null, this.googleGlobeEnabled = !1, this.renderer.getObjectFactory().createTileset({ type: "google" }).then((a) => {
      const l = a;
      this.renderer.getWorld().addObject(l), l.setVisible(this.googleGlobeEnabled), l.maximumScreenSpaceError = 2, this.googleGlobe = l;
    }), this.showImagery = !1, this.showTerrain = !1, this.refreshGlobe();
  }
  /**
   * Get the imagery provider descriptor for the current base map.
   *
   * @returns
   */
  getBaseMap() {
    switch (this.imageryBaseMap) {
      case "street":
        return { type: "osm" };
      case "satellite":
      default:
        return { type: "bing", mapType: "aerial" };
    }
  }
  /**
   * Refresh the globe with the current configuration state.
   *
   * @param onLoad Optional callback on globe load.
   */
  refreshGlobe(s = () => {
  }, o = () => {
  }) {
    const a = [], l = [];
    a.push(this.getBaseMap()), a.push(...this.imageryLayers), this.showTerrain && (this.terrainLayers.length === 0 ? l.push({ type: "cesium", assetId: 1 }) : l.push(...this.terrainLayers)), !this.showImagery && !this.showTerrain ? (this.navigationService.setUnderground(!0), this.globe.setTileLayers(a, l).then(s).catch(o), this.globe.setVisible(!1)) : (this.navigationService.setUnderground(!1), this.globe.setTileLayers(a, l).then(s).catch(o), this.globe.setVisible(!0));
  }
  /**
   * Set the globe visibility mode.
   *
   * This will refresh the globe.
   *
   * @param mode
   * @returns
   */
  async setGlobeMode(s) {
    var o;
    return this.showImagery = s !== "default" && s !== "google", this.showTerrain = s === "terrain", this.googleGlobeEnabled = s === "google", (o = this.googleGlobe) == null || o.setVisible(this.googleGlobeEnabled), new Promise((a, l) => this.refreshGlobe(a, l));
  }
  /**
   * Set the base imagery map.
   *
   * This will refresh the globe.
   *
   * @param map
   * @returns
   */
  async setImageryBaseMap(s) {
    return this.imageryBaseMap = s, new Promise((o, a) => this.refreshGlobe(o, a));
  }
  /**
   * Get the current globe visibility mode.
   *
   * @returns
   */
  getGlobeMode() {
    return this.googleGlobeEnabled ? "google" : !this.showImagery && !this.showTerrain ? "default" : this.showTerrain ? "terrain" : "imagery";
  }
  /**
   * Get the currently set imagery base map.
   *
   * @returns
   */
  getImageryBaseMap() {
    return this.imageryBaseMap;
  }
  /**
   * Get the list of bounds for the currently active imagery.
   *
   * @returns
   */
  getImageryBounds() {
    return this.globe.getImageryBounds();
  }
  /**
   * Get the imagery layers currently displayed.
   *
   * @returns
   */
  getImageryLayers() {
    return [...this.imageryLayers];
  }
  /**
   * Get the terrain layers currently displayed.
   *
   * @returns
   */
  getTerrainLayers() {
    return [...this.terrainLayers];
  }
  /**
   * Get the attributions of the globe.
   *
   * @returns
   */
  getAttributions() {
    var o;
    return (((o = this.googleGlobe) == null ? void 0 : o.attributions) ?? []).concat(this.globe.attributions);
  }
  /**
   * Get the globe clipping state.
   *
   * @returns
   */
  getGlobeClipping() {
    return this.renderer.config.globeClipping;
  }
  /**
   * Allow always rendering objects on top of the globe.
   *
   * @param globeClipping
   */
  setGlobeClipping(s) {
    this.renderer.config.globeClipping = s;
  }
  /**
   * Set the imagery layers to be displayed.
   *
   * This will refresh the globe.
   *
   * WARNING: This is for internal use only. Use the ModelService to add new Imagery layers.
   *
   * @param imageryLayers New set of imagery layers on top of the base map
   * @returns
   */
  _setImageryLayers(s) {
    return this.imageryLayers = s, new Promise((o, a) => this.refreshGlobe(o, a));
  }
  /**
   * Set the terrain layers to be displayed.
   *
   * This will refresh the globe.
   *
   * WARNING: This is for internal use only. Use the ModelService to add new Terrain layers.
   *
   * @param terrainLayers New set of terrain layers
   * @returns
   */
  _setTerrainLayers(s) {
    return this.terrainLayers = s, new Promise((o, a) => this.refreshGlobe(o, a));
  }
  updateFrame(s) {
  }
}
class Model3D {
  /**
   * Create a new 3D model.
   *
   * @param object
   */
  constructor(e) {
    Qt(this, "object");
    Qt(this, "position");
    Qt(this, "rotation");
    Qt(this, "scale");
    Qt(this, "positionDefault");
    this.object = e, this.position = new Vector3$1(), this.rotation = new Quaternion$1(), this.scale = new Vector3$1(1, 1, 1), this.positionDefault = new Vector3$1(), this.object.getEstimatedCenter(this.positionDefault), this.position.copy(this.positionDefault);
  }
  getWorldObject() {
    return this.object;
  }
  async hide() {
    return this.object.setVisible(!1), this;
  }
  async show() {
    return this.object.setVisible(!0), this;
  }
  async destroy() {
    await this.hide(), this.object.dispose();
  }
  isVisible() {
    return this.object.getVisible() && this.getOpacity() > 0;
  }
  isPicked(e) {
    return e.object === this.object;
  }
  getBoundingRadius() {
    return this.object.getBoundingVolume()[3];
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.position);
  }
  getRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.rotation);
  }
  getScale(e) {
    return e || (e = new Vector3$1(1, 1, 1)), e.copy(this.scale);
  }
  setPosition(e) {
    this.position.copy(e), this.updateTransform();
  }
  setRotation(e) {
    this.rotation.copy(e), this.updateTransform();
  }
  setScale(e) {
    this.scale.copy(e), this.updateTransform();
  }
  /**
   * Get the default position of the Model3D.
   *
   * This is useful if the position is geolocated.
   *
   * @param position
   * @returns
   */
  getPositionDefault(e) {
    return e || (e = new Vector3$1()), e.copy(this.positionDefault);
  }
  /**
   * Set the opacity of the model.
   *
   * @param opacity
   */
  setOpacity(e) {
    const s = this.object.asBlendableObject(), o = this.object.asMaterialObject();
    s ? s.opacity = e : o && o.applyMaterial({
      type: "basicAlpha",
      alpha: e,
      color: new Color(1, 1, 1)
    });
  }
  /**
   * Get the opacity of the model.
   *
   * @returns
   */
  getOpacity() {
    const e = this.object.asBlendableObject();
    return (e == null ? void 0 : e.opacity) ?? 1;
  }
  /**
   * Update the transform of the underlying 3D world object.
   *
   * This is tricky to do because the origin can be the center of the globe.
   *
   * This assumes that the world object is in its default, initial position.
   */
  updateTransform() {
    var f;
    const e = new Matrix4();
    e.makeTranslation(
      -this.positionDefault.x,
      -this.positionDefault.y,
      -this.positionDefault.z
    );
    const s = new Matrix4();
    s.makeScale(this.scale.x, this.scale.y, this.scale.z);
    const o = new Matrix4(), a = new Quaternion$1(
      this.rotation.x,
      this.rotation.y,
      this.rotation.z,
      this.rotation.w
    );
    o.makeRotationFromQuaternion(a);
    const l = new Matrix4();
    l.makeTranslation(this.position.x, this.position.y, this.position.z);
    const u = l.multiply(o).multiply(s).multiply(e), c = new Vector3$1(), E = new Quaternion$1(), d = new Vector3$1();
    u.decompose(c, E, d), this.object.setPositionECEF(c), this.object.setRotation(E), (f = this.object.asScalableObject()) == null || f.setScale(d);
  }
}
class GaussianSplat extends Model3D {
  constructor(s) {
    super(s);
    Qt(this, "splat");
    this.splat = s;
  }
  /**
   * Set the maximum splats rendered.
   *
   * @param splats
   */
  setMaxSplats(s) {
    this.splat.maxSplats = s;
  }
  /**
   * Get the maximum splats rendered.
   *
   * @returns
   */
  getMaxSplats() {
    return this.splat.maxSplats;
  }
}
class IFC extends Model3D {
  /**
   * Create a new IFC model.
   *
   * @param object
   * @param toggleListeners
   */
  constructor(s) {
    super(s);
    Qt(this, "ifc");
    Qt(this, "elementTree");
    this.ifc = s, this.elementTree = null;
  }
  /**
   * Build the element tree.
   */
  buildElementTree() {
    let s = null;
    const o = [[this.ifc.getRootElementId(), null]];
    for (; o.length > 0; ) {
      const a = o.pop();
      if (!a)
        continue;
      const [l, u] = a, c = this.ifc.getElementProperties(l);
      if (!c)
        continue;
      const E = c.children, d = c;
      d.children = [], u ? u.children.push(d) : s = d;
      for (const f of E)
        o.push([f, d]);
    }
    if (s === null)
      throw new ViewerError(ViewerErrorCode.MissingIFCRoot, "Missing IFC root.");
    return s;
  }
  /**
   * Generate the IFC element tree.
   *
   * @returns
   */
  getElementTree() {
    return this.elementTree === null && (this.elementTree = this.buildElementTree()), this.elementTree;
  }
  /**
   * Get the ids of all the physical descendants of an element.
   *
   * @param elementId
   * @param exclude
   * @returns
   */
  getPhysicalDescendants(s, o) {
    const a = this.getElementTree(), l = [], u = [[a, a.id === s]], c = new Set(o);
    for (; u.length > 0; ) {
      const E = u.pop();
      if (!E)
        continue;
      const [d, f] = E, h = f || d.id === s;
      h && d.isPhysicalMesh && !c.has(d.id) && l.push(d.id);
      for (const S of d.children)
        u.push([S, h]);
    }
    return l;
  }
  /**
   * Set the style of the IFC by hiding and highlighting groups of elements.
   *
   * @param hiddenElementIds
   * @param selectedElementIds
   */
  setStyle(s, o) {
    this.ifc.resetMaterials(), this.ifc.hideGroup(s), this.ifc.applyGroupMaterial(o, {
      type: "basicAlpha",
      color: new Color(1, 0, 1),
      alpha: 0.5
    });
  }
}
class Imagery {
  /**
   * Create a new Imagery layer model.
   *
   * @param descriptor
   * @param globeService
   */
  constructor(e, s) {
    Qt(this, "descriptor");
    Qt(this, "position");
    Qt(this, "size");
    Qt(this, "visible");
    Qt(this, "globeService");
    this.descriptor = e, this.position = new Vector3$1(), this.size = Ellipsoid$1.WGS_84.maximumRadius * 2, this.visible = !1, this.globeService = s;
  }
  async show() {
    if (!this.visible) {
      this.visible = !0;
      const e = this.globeService.getImageryLayers();
      e.push(this.descriptor), this.globeService.getGlobeMode() === "default" && await this.globeService.setGlobeMode("imagery"), await this.globeService._setImageryLayers(e), this.computeBounds();
    }
    return this;
  }
  async hide() {
    if (this.visible) {
      this.visible = !1;
      const e = this.globeService.getImageryLayers(), s = e.findIndex((o) => o === this.descriptor);
      s > -1 && (e.splice(s, 1), await this.globeService._setImageryLayers(e));
    }
    return this;
  }
  async destroy() {
    await this.hide();
  }
  isVisible() {
    return this.visible;
  }
  isPicked(e) {
    return !1;
  }
  getBoundingRadius() {
    return this.size;
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.position);
  }
  /**
   * Compute the position and size of the imagery on the globe.
   */
  computeBounds() {
    const e = this.globeService.getImageryLayers(), s = this.globeService.getImageryBounds(), o = 1 + e.findIndex((a) => a === this.descriptor);
    if (o) {
      const a = toCartesian(
        new Cartographic$1(s[o].min.longitude, s[o].min.latitude, 0)
      ), l = toCartesian(
        new Cartographic$1(s[o].max.longitude, s[o].max.latitude, 0)
      );
      this.position = a.add(l).multiplyScalar(0.5), this.size = l.distanceTo(a);
    }
  }
}
class SceneNode {
  constructor() {
    Qt(this, "parent");
    Qt(this, "children");
    Qt(this, "localPosition");
    Qt(this, "localRotation");
    Qt(this, "localScale");
    Qt(this, "worldPosition");
    Qt(this, "worldRotation");
    Qt(this, "worldScale");
    this.parent = null, this.children = /* @__PURE__ */ new Set(), this.localPosition = new Vector3$1(), this.localRotation = new Quaternion$1(), this.localScale = new Vector3$1(1, 1, 1), this.worldPosition = new Vector3$1(), this.worldRotation = new Quaternion$1(), this.worldScale = new Vector3$1(1, 1, 1);
  }
  /**
   * Add a child node to the graph.
   *
   * If the child already has a parent, it will be removed from it.
   *
   * @param child
   */
  add(e) {
    e.parent !== null && e.parent.remove(e), this.children.add(e), e.parent = this, e.updateLocalTransform();
  }
  /**
   * Remove an existing child node.
   *
   * @param child
   */
  remove(e) {
    this.children.has(e) && (this.children.delete(e), e.parent = null, e.localPosition.set(0, 0, 0), e.localRotation.set(0, 0, 0, 1), e.localScale.set(1, 1, 1));
  }
  /**
   * Get the parent of this node.
   *
   * @returns
   */
  getParent() {
    return this.parent;
  }
  /**
   * Get the children of this node.
   *
   * @returns
   */
  getChildren() {
    return [...this.children];
  }
  /**
   * Get the world position of the model.
   *
   * @param position
   * @returns
   */
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.worldPosition);
  }
  /**
   * Get the world rotation of the model.
   *
   * @param rotation
   * @returns
   */
  getRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.worldRotation);
  }
  /**
   * Get the world scale of the model.
   *
   * @param scale
   * @returns
   */
  getScale(e) {
    return e || (e = new Vector3$1(1, 1, 1)), e.copy(this.worldScale);
  }
  /**
   * Set the world position of the model.
   *
   * @param position
   */
  setPosition(e) {
    this.worldPosition.copy(e), this.updateLocalTransform();
  }
  /**
   * Set the world rotation of the model.
   *
   * @param rotation
   */
  setRotation(e) {
    this.worldRotation.copy(e), this.updateLocalTransform();
  }
  /**
   * Set the world scale of the model.
   *
   * @param scale
   */
  setScale(e) {
    this.worldScale.copy(e), this.updateLocalTransform();
  }
  /**
   * Get the position of the model relative to its parent.
   *
   * @param position
   * @returns
   */
  getLocalPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.localPosition);
  }
  /**
   * Get the rotation of the model relative to its parent.
   *
   * @param rotation
   * @returns
   */
  getLocalRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.localRotation);
  }
  /**
   * Get the scale of the model relative to its parent.
   *
   * @param scale
   * @returns
   */
  getLocalScale(e) {
    return e || (e = new Vector3$1()), e.copy(this.localScale);
  }
  /**
   * Set the position of the model relative to its parent.
   *
   * @param position
   */
  setLocalPosition(e) {
    this.localPosition.copy(e), this.updateWorldTransform();
  }
  /**
   * Set the rotation of the model relative to its parent.
   *
   * @param rotation
   */
  setLocalRotation(e) {
    this.localRotation.copy(e), this.updateWorldTransform();
  }
  /**
   * Set the scale of the model relative to its parent.
   *
   * @param scale
   */
  setLocalScale(e) {
    this.localScale.copy(e), this.updateWorldTransform();
  }
  /**
   * Recursively compute the world matrix from the current local position.
   *
   * @returns
   */
  computeWorldMatrix() {
    const e = new Matrix4().compose(
      this.localPosition,
      this.localRotation,
      this.localScale
    );
    if (this.parent) {
      const s = this.parent.computeWorldMatrix();
      e.premultiply(s);
    }
    return e;
  }
  /**
   * Update the local transform of the model from the current world transform.
   */
  updateLocalTransform() {
    var c, E, d;
    this.onTransformChange(this.worldPosition, this.worldRotation, this.worldScale);
    const e = new Matrix4().compose(
      this.worldPosition,
      this.worldRotation,
      this.worldScale
    ), s = new Vector3$1(), o = new Quaternion$1(), a = new Vector3$1(1, 1, 1);
    (c = this.parent) == null || c.getPosition(s), (E = this.parent) == null || E.getRotation(o), (d = this.parent) == null || d.getScale(a), new Matrix4().compose(s, o, a).invert().multiply(e).decompose(this.localPosition, this.localRotation, this.localScale);
    for (const f of this.children)
      f.updateWorldTransform();
  }
  /**
   * Update the world transforms of the model and its children from the current local transform.
   */
  updateWorldTransform() {
    this.computeWorldMatrix().decompose(this.worldPosition, this.worldRotation, this.worldScale), this.onTransformChange(this.worldPosition, this.worldRotation, this.worldScale);
    for (const s of this.children)
      s.updateWorldTransform();
  }
  /**
   * Callback invoked when the world transform is changed.
   *
   * @param worldPosition
   * @param worldRotation
   * @param worldScale
   */
  onTransformChange(e, s, o) {
  }
}
class ModelNode extends SceneNode {
  constructor(s) {
    super();
    Qt(this, "model");
    this.model = s;
    const o = s.getPosition(), a = s.getRotation(), l = s.getScale();
    this.setPosition(o), this.setRotation(a), this.setScale(l);
  }
  /**
   * Get the contained model.
   *
   * @returns
   */
  getModel() {
    return this.model;
  }
  async show() {
    return await this.model.show();
  }
  async hide() {
    return await this.model.hide();
  }
  async destroy() {
    await this.model.destroy();
  }
  isVisible() {
    return this.model.isVisible();
  }
  isPicked(s) {
    return this.model.isPicked(s);
  }
  getBoundingRadius() {
    return this.model.getBoundingRadius();
  }
  onTransformChange(s, o, a) {
    this.model.setPosition(s), this.model.setRotation(o), this.model.setScale(a);
  }
}
const RING_VERTICES = [], RING_INDICES = [], DISC_VERTICES = [], DISC_INDICES = [], ringShape = new Shape().absarc(0, 0, 0.5, 0, Math.PI * 2, !1), holePath = new Path().absarc(0, 0, 0.35, 0, Math.PI * 2, !0);
ringShape.holes.push(holePath);
const ring = new ShapeGeometry(ringShape, 32);
for (let r = 0; r < ring.attributes.position.count; r++) {
  const e = ring.attributes.position.getX(r), s = ring.attributes.position.getY(r), o = ring.attributes.position.getZ(r);
  RING_VERTICES.push(new Vector3$1(e, o + 1e-4, s));
}
for (let r = 0; r < ring.attributes.position.count; r++) {
  const e = ring.attributes.position.getX(r), s = ring.attributes.position.getY(r), o = ring.attributes.position.getZ(r);
  RING_VERTICES.push(new Vector3$1(e, o - 1e-4, s));
}
if (ring.index) {
  for (let r = 0; r < ring.index.array.length; r++)
    RING_INDICES.push(ring.index.array[r]);
  for (let r = 0; r < ring.index.array.length; r++) {
    const e = ring.attributes.position.count;
    RING_INDICES.push(ring.index.array[r] + e);
  }
}
const disc = new CircleGeometry(0.5, 32);
for (let r = 0; r < disc.attributes.position.count; r++) {
  const e = disc.attributes.position.getX(r), s = disc.attributes.position.getY(r), o = disc.attributes.position.getZ(r);
  DISC_VERTICES.push(new Vector3$1(e, o, s));
}
if (disc.index)
  for (let r = 0; r < disc.index.array.length; r++)
    DISC_INDICES.push(disc.index.array[r]);
class Panorama {
  /**
   * Create a new panorama model.
   *
   * @param name
   * @param url
   * @param thumbnailUrl
   * @param object
   * @param labelManager
   */
  constructor(e, s, o, a, l) {
    Qt(this, "batchables");
    Qt(this, "name");
    Qt(this, "content");
    Qt(this, "position");
    Qt(this, "rotation");
    Qt(this, "scale");
    Qt(this, "meshInstance");
    Qt(this, "world");
    Qt(this, "objectFactory");
    Qt(this, "object360");
    Qt(this, "labelManager");
    Qt(this, "label");
    Qt(this, "visible");
    Qt(this, "loading");
    Qt(this, "visible360");
    Qt(this, "opacity360");
    Qt(this, "cameraHeight");
    this.batchables = [
      {
        type: "polygon",
        vertices: RING_VERTICES,
        indices: RING_INDICES,
        position: new Vector3$1(),
        rotation: new Quaternion$1(),
        scale: new Vector3$1(1, 1, 1),
        colors: [new Color(1, 1, 1)],
        material: {
          type: "basicOpaque",
          color: new Color(1, 1, 1),
          wireframe: !1,
          faceCulling: FaceCullingMode.None
        },
        renderLayer: RenderLayer.AfterPanorama
      },
      {
        type: "polygon",
        vertices: DISC_VERTICES,
        indices: DISC_INDICES,
        position: new Vector3$1(),
        rotation: new Quaternion$1(),
        scale: new Vector3$1(1, 1, 1),
        colors: [new Color(1, 1, 1)],
        material: {
          type: "basicOpaque",
          color: new Color(0.2, 0.2, 0.2),
          wireframe: !1,
          faceCulling: FaceCullingMode.None
        },
        renderLayer: RenderLayer.AfterPanorama
      }
    ], this.name = e.name, this.content = e.content ?? null, this.position = new Vector3$1(), this.rotation = new Quaternion$1(), this.scale = new Vector3$1(1, 1, 1), this.meshInstance = s, this.objectFactory = o, this.world = a, this.object360 = null, this.labelManager = l, this.label = null, this.visible = !1, this.loading = !1, this.visible360 = !1, this.opacity360 = 1, this.cameraHeight = 0;
  }
  async load360(e) {
    this.loading = !0;
    try {
      switch (e.type) {
        case "full":
          return await this.objectFactory.createPanorama({
            url: e.url
          });
        case "tiled":
          return await this.objectFactory.createTiledPanorama({
            getTileURL: e.url,
            thumbnailURL: e.thumbnailUrl,
            rows: e.rows,
            cols: e.cols
          });
      }
    } finally {
      this.loading = !1;
    }
  }
  updateIconVisibility() {
    for (const e of this.batchables)
      !this.visible || this.visible360 ? this.meshInstance.removeMesh(e) : this.visible && this.meshInstance.addMesh(e);
  }
  updateBatchableTransform() {
    const e = toCartographic(this.position);
    e.height -= this.cameraHeight;
    const s = toCartesian(e), o = calculateCartographicQuaternion(e);
    for (const a of this.batchables)
      a.position.copy(s), a.rotation.copy(o), a.scale.copy(this.scale), this.meshInstance.refresh(a);
  }
  async show() {
    return this.visible = !0, this.updateIconVisibility(), this;
  }
  async hide() {
    return this.visible = !1, this.updateIconVisibility(), this;
  }
  async destroy() {
    await this.hide(), await this.hide360();
  }
  isVisible() {
    return this.visible;
  }
  isPicked(e) {
    for (const s of this.batchables) {
      const o = this.meshInstance.getPickingId(s), a = this.meshInstance.getInstanceObject(s);
      if (e.object === a && e.userData === o)
        return !0;
    }
    return !1;
  }
  getBoundingRadius() {
    return Math.max(...this.getScale().toArray());
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.position), e;
  }
  getRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.rotation), e;
  }
  getScale(e) {
    return e || (e = new Vector3$1(1, 1, 1)), e.copy(this.scale), e;
  }
  setPosition(e) {
    this.position.copy(e), this.updateBatchableTransform();
  }
  setRotation(e) {
    var s;
    this.rotation.copy(e), (s = this.object360) == null || s.setRotation(e);
  }
  setScale(e) {
    this.scale.copy(e), this.updateBatchableTransform();
  }
  /**
   * Get the icon position.
   *
   * @returns
   */
  getIconPosition() {
    const e = toCartographic(this.position);
    return e.height -= this.cameraHeight, toCartesian(e);
  }
  /**
   * Get the name of the panorama.
   *
   * @returns
   */
  getName() {
    return this.name;
  }
  /**
   * Show the name label.
   */
  showName() {
    this.label === null && (this.label = this.labelManager.add(this.name, this.getPosition(), !0, new Vector2(0, -20)));
  }
  /**
   * Hide the name label.
   */
  hideName() {
    this.label != null && (this.labelManager.remove(this.label), this.label = null);
  }
  /**
   * Set the content of the panorama image.
   *
   * Note: This will only take effect if the 360 sphere has not been loaded yet.
   *
   * @param url
   */
  setContent(e) {
    this.content = e;
  }
  /**
   * Show the 360 sphere.
   */
  async show360() {
    var e, s, o;
    return this.visible360 = !0, this.updateIconVisibility(), !this.object360 && this.content && !this.loading && (this.object360 = await this.load360(this.content), this.world.addPanorama(this.object360)), (e = this.object360) == null || e.setVisible(this.visible360), (s = this.object360) == null || s.setOpacity(this.opacity360), (o = this.object360) == null || o.setRotation(this.getRotation()), this;
  }
  /**
   * Hide the 360 sphere.
   */
  async hide360() {
    var e;
    return this.visible360 = !1, this.updateIconVisibility(), (e = this.object360) == null || e.setVisible(this.visible360), this;
  }
  /**
   * Set the opacity of the 360 sphere.
   *
   * @param opacity
   */
  setOpacity360(e) {
    var s;
    this.opacity360 = e, (s = this.object360) == null || s.setOpacity(e);
  }
  /**
   * Get the opacity of the 360 sphere.
   *
   * @returns
   */
  getOpacity360() {
    return this.opacity360;
  }
  /**
   * Height of the camera to approximate distance to floor.
   *
   * @returns
   */
  getCameraHeight() {
    return this.cameraHeight;
  }
  /**
   * Set the height of the camera, updating the batchable.
   * @param height
   */
  setCameraHeight(e) {
    this.cameraHeight = e, this.updateBatchableTransform();
  }
  /**
   * Set the render priority of the panoramic sphere
   *
   * @param rank
   */
  setPriority(e) {
    var s;
    (s = this.object360) == null || s.setPriority(e);
  }
  /**
   * Check if the name label is visible.
   *
   * @returns
   */
  isNameVisible() {
    return this.label !== null;
  }
  /**
   * Set the color of the widget.
   *
   * @param color
   */
  setColor(e) {
    this.batchables[0].colors[0].copy(e), this.meshInstance.refresh(this.batchables[0]);
  }
}
const FRUSTUM_VERTICES = [
  new Vector3$1(-1, -0.75, -1),
  new Vector3$1(1, -0.75, -1),
  new Vector3$1(1, 0.75, -1),
  new Vector3$1(-1, 0.75, -1),
  new Vector3$1(0, 0, 1),
  new Vector3$1(0.75, 0.75, -1),
  new Vector3$1(-0.75, 0.75, -1),
  new Vector3$1(0, 1.5, -1)
], FRUSTUM_INDICES = [0, 4, 3, 4, 2, 3, 1, 2, 4, 1, 4, 0, 5, 6, 7];
function createFrustumBatchable(r, e) {
  return {
    type: "polygon",
    vertices: FRUSTUM_VERTICES,
    indices: FRUSTUM_INDICES,
    position: new Vector3$1(),
    rotation: new Quaternion$1(),
    scale: new Vector3$1(1, 1, 1),
    colors: [r],
    material: {
      type: "basicOpaque",
      color: new Color(1, 1, 1),
      wireframe: !0
    },
    renderLayer: RenderLayer.AfterPanorama,
    pixelSize: e
  };
}
class PhotoCamera {
  constructor(e, s, o) {
    Qt(this, "batchables");
    Qt(this, "meshInstance");
    Qt(this, "visible");
    this.batchables = [createFrustumBatchable(e, s)], this.meshInstance = o, this.visible = !1;
  }
  async show() {
    this.visible = !0;
    for (const e of this.batchables)
      this.meshInstance.addMesh(e);
    return this;
  }
  async hide() {
    this.visible = !1;
    for (const e of this.batchables)
      this.meshInstance.removeMesh(e);
    return this;
  }
  async destroy() {
    await this.hide();
  }
  isVisible() {
    return this.visible;
  }
  isPicked(e) {
    for (const s of this.batchables) {
      const o = this.meshInstance.getPickingId(s), a = this.meshInstance.getInstanceObject(s);
      if (e.object === a && e.userData === o)
        return !0;
    }
    return !1;
  }
  getBoundingRadius() {
    return 1;
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.batchables[0].position), e;
  }
  getRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.batchables[0].rotation), e;
  }
  getScale(e) {
    return e || (e = new Vector3$1(1, 1, 1)), e.copy(this.batchables[0].scale), e;
  }
  setPosition(e) {
    for (const s of this.batchables)
      s.position.copy(e), this.meshInstance.refresh(s);
  }
  setRotation(e) {
    for (const s of this.batchables)
      s.rotation.copy(e), this.meshInstance.refresh(s);
  }
  setScale(e) {
    for (const s of this.batchables)
      s.scale.copy(e), this.meshInstance.refresh(s);
  }
  /**
   * Set the color of the camera.
   *
   * @param color
   */
  setColor(e) {
    for (const s of this.batchables)
      s.colors[0].copy(e), this.meshInstance.refresh(s);
  }
}
function createLineBatchables(r, e, s, o, a) {
  const l = [];
  for (let c = 0; c < r.length - 1; c++)
    l.push(r[c]), l.push(r[c + 1]);
  return [
    {
      type: "lines",
      vertices: l,
      colors: l.map(() => e),
      position: s,
      rotation: o,
      scale: a,
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1),
        vertexColors: !0
      },
      renderLayer: RenderLayer.AfterPanorama
    }
  ];
}
function createPolygonBatchables(r, e, s, o, a) {
  const l = [], u = [];
  for (let c = 0; c < r.length - 1; c++)
    u.push(r[c]), u.push(r[c + 1]);
  return u.push(u[u.length - 1]), u.push(u[0]), l.push({
    type: "lines",
    vertices: u,
    colors: u.map(() => e),
    position: s,
    rotation: o,
    scale: a,
    material: {
      type: "basicOpaque",
      color: new Color(1, 1, 1),
      vertexColors: !0
    },
    renderLayer: RenderLayer.AfterPanorama
  }), l.push({
    type: "polygon",
    vertices: r,
    colors: r.map(() => e),
    indices: triangulate$1(r),
    position: s,
    rotation: o,
    scale: a,
    material: {
      type: "basicAlpha",
      color: new Color(1, 1, 1),
      alpha: 0.5,
      vertexColors: !0,
      faceCulling: FaceCullingMode.None
    },
    renderLayer: RenderLayer.AfterPanorama
  }), l;
}
class Sketch {
  constructor(e, s, o, a, l, u, c, E, d) {
    Qt(this, "name");
    Qt(this, "type");
    Qt(this, "color");
    Qt(this, "vertices");
    Qt(this, "position");
    Qt(this, "rotation");
    Qt(this, "scale");
    Qt(this, "sprites");
    Qt(this, "batchables");
    Qt(this, "measurementUnit");
    Qt(this, "labels");
    Qt(this, "visible");
    Qt(this, "visibleName");
    Qt(this, "visibleMeasurements");
    Qt(this, "meshBatch");
    Qt(this, "labelManager");
    Qt(this, "signalDirty");
    this.name = e, this.type = s, this.color = o.clone(), this.vertices = a, this.position = l, this.rotation = new Quaternion$1(), this.scale = new Vector3$1(1, 1, 1), this.sprites = u, this.batchables = [], this.measurementUnit = "metric", this.labels = [], this.visible = !1, this.visibleName = !1, this.visibleMeasurements = !1, this.meshBatch = c, this.labelManager = E, this.signalDirty = d, this.type === "lines" ? this.batchables = createLineBatchables(
      this.vertices,
      o,
      this.position,
      this.rotation,
      this.scale
    ) : this.type === "polygon" && (this.batchables = createPolygonBatchables(
      this.vertices,
      o,
      this.position,
      this.rotation,
      this.scale
    ));
  }
  async show() {
    if (!this.visible) {
      this.visible = !0;
      for (const e of this.batchables)
        this.meshBatch.addMesh(e);
      for (const e of this.sprites)
        e.setVisible(this.type !== "polygon");
      this.refreshLabels(), this.signalDirty();
    }
    return this;
  }
  async hide() {
    if (this.visible) {
      this.visible = !1;
      for (const e of this.batchables)
        this.meshBatch.removeMesh(e);
      for (const e of this.sprites)
        e.setVisible(!1);
      this.refreshLabels(), this.signalDirty();
    }
    return this;
  }
  async destroy() {
    await this.hide(), await this.hideMeasurements(), await this.hideName();
    for (const e of this.sprites)
      e.dispose();
  }
  isVisible() {
    return this.visible;
  }
  isPicked(e) {
    for (const s of this.batchables)
      if (e.userData !== void 0 && e.userData === this.meshBatch.getPickingId(s))
        return !0;
    for (const s of this.sprites)
      if (s === e.object)
        return !0;
    return !1;
  }
  getBoundingRadius() {
    const e = new Matrix4().compose(this.position, this.rotation, this.scale), s = this.vertices.map((a) => a.clone().applyMatrix4(e));
    if (s.length === 1)
      return 1;
    let o = 0;
    for (let a = 0; a < s.length - 1; a++)
      for (let l = a + 1; l < s.length; l++) {
        const u = s[a], c = s[l];
        o = Math.max(o, u.distanceTo(c));
      }
    return o;
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.position);
  }
  getRotation(e) {
    return e || (e = new Quaternion$1()), e.copy(this.rotation);
  }
  getScale(e) {
    return e || (e = new Vector3$1()), e.copy(this.scale);
  }
  setPosition(e) {
    this.position.copy(e), this.refreshPoints(), this.refreshLabels(), this.signalDirty();
  }
  setRotation(e) {
    this.rotation.copy(e), this.refreshPoints(), this.refreshLabels(), this.signalDirty();
  }
  setScale(e) {
    this.scale.copy(e), this.refreshPoints(), this.refreshLabels(), this.signalDirty();
  }
  /**
   * Get the model-space vertices of the sketch.
   *
   * @returns
   */
  getVertices() {
    return this.vertices.map((e) => e.clone());
  }
  /**
   * Get the geometry type of the sketch.
   *
   * @returns
   */
  getType() {
    return this.type;
  }
  /**
   * Get the current color of the sketch.
   *
   * @returns
   */
  getColor() {
    return this.color.clone();
  }
  /**
   * Set the color of the sketch.
   *
   * @param color
   */
  setColor(e) {
    this.color = e.clone();
    for (const s of this.batchables)
      s.colors = s.colors.map(() => this.color);
    for (const s of this.sprites)
      s.applyMaterial({
        type: "basicOpaque",
        color: this.color
      });
    this.signalDirty();
  }
  /**
   * Get the name of the sketch.
   * @returns
   */
  getName() {
    return this.name;
  }
  /**
   * Set the name of the sketch.
   *
   * @param name
   */
  setName(e) {
    this.name = e;
  }
  /**
   * Show measurements.
   */
  showMeasurements() {
    this.visibleMeasurements || (this.visibleMeasurements = !0, this.refreshLabels());
  }
  /**
   * Hide measurements.
   */
  hideMeasurements() {
    this.visibleMeasurements && (this.visibleMeasurements = !1, this.refreshLabels());
  }
  /**
   * Show name.
   */
  showName() {
    this.visibleName || (this.visibleName = !0, this.refreshLabels());
  }
  /**
   * Hide name.
   */
  hideName() {
    this.visibleName && (this.visibleName = !1, this.refreshLabels());
  }
  /**
   * Set the measurement unit.
   *
   * @param unit
   */
  setMeasurementUnit(e) {
    this.measurementUnit = e, this.refreshLabels();
  }
  /**
   * Check if the name label is visible.
   *
   * @returns
   */
  isNameVisible() {
    return this.visibleName;
  }
  /**
   * Check if the measurement labels are visible.
   *
   * @returns
   */
  isMeasurementsVisible() {
    return this.visibleMeasurements;
  }
  /**
   * Refresh the point sprites.
   */
  refreshPoints() {
    const e = new Matrix4().compose(this.position, this.rotation, this.scale);
    for (let s = 0; s < this.sprites.length; s++) {
      const o = this.vertices[s];
      this.sprites[s].setPositionECEF(o.clone().applyMatrix4(e));
    }
  }
  /**
   * Refresh the label list.
   */
  refreshLabels() {
    for (const a of this.labels)
      this.labelManager.remove(a);
    this.labels.length = 0;
    const e = new Matrix4().compose(this.position, this.rotation, this.scale), s = this.vertices.map((a) => a.clone().applyMatrix4(e)), o = new Vector2(0, -20);
    if (this.isNameVisible() && this.labels.push(this.labelManager.add(this.name, this.position, !0, o)), this.isMeasurementsVisible()) {
      const a = [...s];
      this.type === "polygon" && a.push(a[0]);
      for (let l = 0; l < a.length - 1; l++) {
        const u = a[l], c = a[l + 1], E = u.distanceTo(c), d = lengthToString(E, this.measurementUnit, 2), f = u.clone().add(c).multiplyScalar(0.5);
        this.labels.push(this.labelManager.add(d, f, !0));
      }
      for (let l = 0; l < s.length; l++) {
        const u = `P${l + 1}`;
        this.labels.push(this.labelManager.add(u, s[l], !0, o));
      }
    }
  }
}
const DEFAULT_TERRAIN_POSITION = new Cartographic$1(toRadians(144.925696), toRadians(-37.823541));
class Terrain {
  /**
   * Create a new Terrain layer model.
   *
   * @param descriptor
   * @param globeService
   */
  constructor(e, s) {
    Qt(this, "descriptor");
    Qt(this, "position");
    Qt(this, "size");
    Qt(this, "visible");
    Qt(this, "globeService");
    this.descriptor = e, this.position = toCartesian(DEFAULT_TERRAIN_POSITION), this.size = Ellipsoid$1.WGS_84.minimumRadius / 3, this.visible = !1, this.globeService = s;
  }
  async show() {
    if (!this.visible) {
      this.visible = !0;
      const e = this.globeService.getTerrainLayers();
      e.push(this.descriptor), this.globeService.getGlobeMode() !== "terrain" && await this.globeService.setGlobeMode("terrain"), await this.globeService._setTerrainLayers(e);
    }
    return this;
  }
  async hide() {
    if (this.visible) {
      this.visible = !1;
      const e = this.globeService.getTerrainLayers(), s = e.findIndex((o) => o === this.descriptor);
      s > -1 && (e.splice(s, 1), await this.globeService._setTerrainLayers(e));
    }
    return this;
  }
  async destroy() {
    await this.hide();
  }
  isVisible() {
    return this.visible;
  }
  getPosition(e) {
    return e || (e = new Vector3$1()), e.copy(this.position);
  }
  getBoundingRadius() {
    return this.size;
  }
  isPicked(e) {
    return !1;
  }
}
const ELEVATION_GRADIENT_COLORS = [
  new Color(0, 0.1, 1),
  new Color(0, 0.7, 1),
  new Color(0, 1, 0.98),
  new Color(0, 1, 0.42),
  new Color(0.02, 1, 0.01),
  new Color(0.65, 1, 0),
  new Color(0.98, 1, 0),
  new Color(1, 0.67, 0),
  new Color(1, 0.09, 0)
];
class Tileset extends Model3D {
  /**
   * Create a new tileset model.
   *
   * @param object
   */
  constructor(s) {
    super(s);
    Qt(this, "tileset");
    Qt(this, "defaultStyle");
    Qt(this, "style");
    this.tileset = s;
    const o = toCartographic(this.getPosition()).height;
    this.defaultStyle = {
      type: "rgb",
      intensityColors: [new Color(0, 0, 0), new Color(1, 1, 1)],
      classificationColors: {
        0: { base: new Color(1, 1, 1), show: !0 },
        1: { base: new Color(1, 1, 1), show: !0 },
        2: { base: new Color(0.5, 0.25, 0), show: !0 },
        3: { base: new Color(0.68, 1, 0.184), show: !0 },
        4: { base: new Color(0, 1, 0), show: !0 },
        5: { base: new Color(0, 0.5, 0), show: !0 },
        6: { base: new Color(0.7, 0.7, 0.7), show: !0 },
        7: { base: new Color(1, 0.65, 0), show: !0 },
        8: { base: new Color(1, 1, 1), show: !0 },
        9: { base: new Color(0, 0, 1), show: !0 },
        10: { base: new Color(0.7, 0.7, 0.7), show: !0 },
        11: { base: new Color(0, 0.5, 0), show: !0 },
        12: { base: new Color(1, 1, 1), show: !0 },
        13: { base: new Color(0, 0.5, 0), show: !0 },
        14: { base: new Color(0, 0.5, 0), show: !0 },
        15: { base: new Color(0, 0.5, 0), show: !0 },
        16: { base: new Color(0, 0.5, 0), show: !0 },
        17: { base: new Color(0, 0.5, 0), show: !0 },
        18: { base: new Color(0, 0.5, 0), show: !0 }
      },
      contrast: 1,
      brightness: 0,
      gamma: 1,
      alpha: 1,
      pointSize: 3,
      pointShape: "circle",
      pointSizeAttenuation: !0,
      minHeight: o - this.getBoundingRadius(),
      maxHeight: o + this.getBoundingRadius(),
      backfaceCulling: !0
    }, this.style = {
      ...this.defaultStyle
    }, this.applyRendererStyle(this.style);
  }
  /**
   * Get the list of classification ids available to this tileset.
   *
   * If the tileset is not a point cloud, this will return an empty list.
   *
   * @returns
   */
  getClassificationIds() {
    return this.tileset.pointChannels.Classification.integersPresent ?? [];
  }
  /**
   * Get the list of point channels availalbe in this tileset.
   *
   * @returns
   */
  getPointChannels() {
    return Object.keys(this.tileset.pointChannels);
  }
  /**
   * Get the current style.
   *
   * @returns
   */
  getStyle() {
    return structuredClone(this.style);
  }
  /**
   * Get the default style.
   *
   * @returns
   */
  getDefaultStyle() {
    return structuredClone(this.defaultStyle);
  }
  /**
   * Get the maximum screen space error of the tileset.
   *
   * @returns
   */
  getMSSE() {
    return this.tileset.maximumScreenSpaceError;
  }
  /**
   * Get the tile memory budget.
   *
   * @returns
   */
  getMemoryBudget() {
    return this.tileset.memoryBudget;
  }
  /**
   * Get the point budget.
   *
   * @returns
   */
  getPointBudget() {
    return this.tileset.pointBudget;
  }
  /**
   * Get the attributions of the tileset.
   *
   * @returns
   */
  getAttributions() {
    return this.tileset.attributions;
  }
  /**
   * Set the style of the tileset.
   *
   * @param style
   */
  setStyle(s) {
    JSON.stringify(s) !== JSON.stringify(this.style) && (this.applyRendererStyle(s), this.style = structuredClone(s));
  }
  /**
   * Set the maximum screen space error of the tileset.
   *
   * @param maximumScreenSpaceError
   */
  setMSSE(s) {
    this.tileset.maximumScreenSpaceError = s;
  }
  /**
   * Set the tile memory budget to determine how many tiles can be kept in cache at any time.
   *
   * @param budget
   */
  setMemoryBudget(s) {
    this.tileset.memoryBudget = s;
  }
  /**
   * Set the point budget for point cloud tiles.
   *
   * @param budget
   */
  setPointBudget(s) {
    this.tileset.pointBudget = s;
  }
  /**
   * Get the tileset rendering statistics.
   */
  getStatistics() {
    return this.tileset.statistics;
  }
  /**
   * Convert a tileset style to the format expected by the renderer.
   *
   * @param style
   */
  applyRendererStyle(s) {
    const o = toCartographic(this.getPosition());
    o.height = s.minHeight;
    const a = toCartesian(o);
    o.height = s.maxHeight;
    const l = toCartesian(o), u = {
      pointSize: s.pointSize,
      classificationColors: s.classificationColors,
      intensityColors: s.intensityColors,
      gradientColors: ELEVATION_GRADIENT_COLORS,
      gradient: { min: a, max: l },
      brightness: s.brightness,
      contrast: s.contrast,
      gamma: s.gamma,
      opacity: s.alpha,
      sizeAttenuation: s.pointSizeAttenuation,
      faceCulling: s.backfaceCulling ? FaceCullingMode.BackFace : FaceCullingMode.None
    };
    switch (s.type) {
      case "rgb":
        u.pointStyle = PointCloudStyle.None;
        break;
      case "intensity":
        u.pointStyle = PointCloudStyle.IntensityColoring;
        break;
      case "classification":
        u.pointStyle = PointCloudStyle.ClassificationColoring;
        break;
      case "elevation":
        u.pointStyle = PointCloudStyle.GradientColoring;
        break;
    }
    switch (s.pointShape) {
      case "circle":
        u.pointShape = PointShape.Circle;
        break;
      case "square":
        u.pointShape = PointShape.Square;
        break;
    }
    this.tileset.applyStyle(u);
  }
}
class ModelFactory {
  constructor(e, s, o, a, l, u) {
    Qt(this, "renderer");
    Qt(this, "meshBatch");
    Qt(this, "meshInstance");
    Qt(this, "labelManager");
    Qt(this, "globeService");
    Qt(this, "signalDirty");
    this.renderer = e, this.meshBatch = s, this.meshInstance = o, this.labelManager = a, this.globeService = l, this.signalDirty = u;
  }
  /**
   * Create a model from a configuration structure.
   *
   * @param config
   * @returns
   */
  async create(e) {
    switch (e.type) {
      case "tileset":
        return this.createTileset(e);
      case "obj":
        return this.createObj(e);
      case "ifc":
        return this.createIFC(e);
      case "dxf":
        return this.createDXF(e);
      case "kml":
        return this.createKML(e);
      case "imagery":
        return this.createImagery(e);
      case "terrain":
        return this.createTerrain(e);
      case "panorama":
        return this.createPanorama(e);
      case "sketch":
        return this.createSketch(e);
      case "photo-camera":
        return this.createPhotoCamera(e);
      case "gaussian-splat":
        return this.createGaussianSplat(e);
    }
  }
  /**
   * Geolocate a Model3D.
   *
   * @param model
   * @param spatialReferenceSystem
   */
  async geolocateModel(e, s) {
    const o = e.getPositionDefault(), a = (await toECEF([o], s))[0], l = toCartographic(a), u = new Matrix3$1(), c = new Vector3$1(), E = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(l, u, c, E);
    const d = new Matrix4().setFromMatrix3(u), h = new Quaternion$1().setFromRotationMatrix(d).premultiply(new Quaternion$1().setFromAxisAngle(E, -Math.PI / 2)).premultiply(new Quaternion$1().setFromAxisAngle(c, -Math.PI / 2));
    e.setPosition(a), e.setRotation(h);
  }
  /**
   * Create a new Gaussian Splat model.
   *
   * @param config
   * @returns
   */
  async createGaussianSplat(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = await s.createGaussianSplat({
        url: e.url,
        maxSplats: e.maxSplats
      });
      return this.renderer.getWorld().addObject(o), new GaussianSplat(o);
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new Tileset model.
   *
   * @param config
   * @returns
   */
  async createTileset(e) {
    const s = this.renderer.getObjectFactory();
    try {
      let o;
      e.source == "cesium" ? o = {
        type: "cesium",
        assetId: e.assetId
      } : o = {
        type: "direct",
        url: e.url
      };
      const a = await s.createTileset(o);
      return this.renderer.getWorld().addObject(a), new Tileset(a);
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new Obj model.
   *
   * @param config
   * @returns
   */
  async createObj(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = {
        ...e,
        material: {
          type: "basicAlpha",
          color: new Color(),
          alpha: 1
        }
      }, a = await s.createObj(o);
      this.renderer.getWorld().addObject(a);
      const l = new Model3D(a);
      return e.spatialReferenceSystem && await this.geolocateModel(l, e.spatialReferenceSystem), l;
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new IFC model.
   *
   * @param config
   * @returns
   */
  async createIFC(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = await s.createIfc(e);
      this.renderer.getWorld().addObject(o);
      const a = new IFC(o);
      if (e.spatialReferenceSystem) {
        const l = a.getPositionDefault();
        [l.y, l.z] = [-l.z, l.y];
        const u = (await toECEF([l], e.spatialReferenceSystem))[0], c = toCartographic(u), E = new Matrix3$1(), d = new Vector3$1();
        Ellipsoid$1.WGS_84.rotationBasisForCartographic(c, E, d);
        const f = new Matrix4().setFromMatrix3(E), S = new Quaternion$1().setFromRotationMatrix(f).premultiply(
          new Quaternion$1().setFromAxisAngle(d, -Math.PI / 2)
        );
        a.setPosition(u), a.setRotation(S);
      }
      return a;
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new DXF model.
   *
   * @param config
   * @returns
   */
  async createDXF(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = {
        url: e.url,
        cacheKey: e.cacheKey,
        spatialReferenceSystem: e.spatialReferenceSystem
      }, a = await s.createDxf(o);
      return this.renderer.getWorld().addObject(a), new Model3D(a);
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new KML model.
   *
   * @param config
   * @returns
   */
  async createKML(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = await this.renderer.createFontAsset({
        url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/fonts/Roboto/Roboto-Black.ttf"
      });
      let a;
      e.source === "cesium" ? a = {
        type: "cesium",
        assetId: e.assetId,
        cacheKey: e.cacheKey,
        labelFont: o
      } : a = {
        type: "direct",
        url: e.url,
        cacheKey: e.cacheKey,
        labelFont: o
      };
      const l = await s.createKml(a);
      return this.renderer.getWorld().addObject(l), new Model3D(l);
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  /**
   * Create a new Imagery model.
   *
   * @param config
   * @returns
   */
  async createImagery(e) {
    try {
      let s;
      e.source === "cesium" ? s = {
        type: "cesium",
        assetId: e.assetId
      } : s = {
        type: "tms",
        url: e.url
      };
      const o = new Imagery(s, this.globeService);
      return await o.show(), o;
    } catch (s) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, s.message);
    }
  }
  /**
   * Create a new Terrain model.
   *
   * @param config
   * @returns
   */
  async createTerrain(e) {
    try {
      const s = {
        type: "cesium",
        assetId: e.assetId
      }, o = new Terrain(s, this.globeService);
      return await o.show(), o;
    } catch (s) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, s.message);
    }
  }
  /**
   * Create a new Panorama model.
   *
   * @param config
   * @returns
   */
  async createPanorama(e) {
    const s = this.renderer.getObjectFactory(), o = this.renderer.getWorld();
    try {
      return new Panorama(e, this.meshInstance, s, o, this.labelManager);
    } catch (a) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, a.message);
    }
  }
  /**
   * Create a new sketch model.
   *
   * @param config
   */
  async createSketch(e) {
    const s = this.renderer.getObjectFactory();
    try {
      const o = calculateCentroid$1(e.points), a = e.points.map((u) => u.clone().sub(o)), l = [];
      for (const u of a) {
        const c = {
          url: PointIcon,
          position: {
            ecef: u
          },
          material: {
            type: "basicOpaque",
            color: e.color
          },
          sizeAttenuation: !1,
          scale: new Vector3$1(0.02, 0.02, 0.02)
        }, E = await s.createSprite(c);
        E.setRenderLayer(RenderLayer.AfterPanorama), E.setVisible(!1), this.renderer.getWorld().addObject(E), l.push(E);
      }
      return new Sketch(
        e.name,
        e.geometry,
        e.color,
        a,
        o,
        l,
        this.meshBatch,
        this.labelManager,
        this.signalDirty
      );
    } catch (o) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, o.message);
    }
  }
  async createPhotoCamera(e) {
    try {
      return new PhotoCamera(e.color, e.pixelSize, this.meshInstance);
    } catch (s) {
      throw new ViewerError(ViewerErrorCode.FailedLoad, s.message);
    }
  }
}
class ModelService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "factory");
    Qt(this, "dirty");
    this.factory = new ModelFactory(
      this.renderer,
      this.meshBatch,
      this.meshInstance,
      this.labelManager,
      o,
      () => this.signalDirty()
    ), this.dirty = !1;
  }
  /**
   * Build a model from a configuration object.
   *
   * @param config
   */
  async create(s) {
    return await this.factory.create(s);
  }
  /**
   * Signal a refresh of the batchable meshes.
   */
  signalDirty() {
    this.dirty = !0;
  }
  /**
   * Refresh the batchable meshes if any models have changed.
   *
   * @param deltaTime
   */
  updateFrame(s) {
    this.dirty && (this.dirty = !1, this.meshBatch.refresh());
  }
}
class BaseCameraMode {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "gestures");
    Qt(this, "camera");
    Qt(this, "globe");
    Qt(this, "underground");
    Qt(this, "isRotating");
    Qt(this, "cameraRotationPivot");
    Qt(this, "pitchRange");
    Qt(this, "pitch");
    Qt(this, "yaw");
    Qt(this, "targetPosition");
    Qt(this, "targetRotation");
    Qt(this, "lastTargetPosition");
    Qt(this, "lastTargetRotation");
    Qt(this, "prevPosition");
    Qt(this, "prevRotation");
    Qt(this, "moveStates");
    Qt(this, "cameraMotionCallback");
    Qt(this, "cameraStopCallback");
    Qt(this, "stopped");
    this.renderer = e, this.gestures = s, this.camera = e.getWorld().getCamera(), this.globe = e.getWorld().getGlobe(), this.underground = !1, this.isRotating = !1, this.cameraRotationPivot = new Vector3$1(), this.pitchRange = Math.PI - 0.05, this.pitch = 0, this.yaw = 0, this.targetPosition = null, this.targetRotation = null, this.lastTargetPosition = new Vector3$1(), this.lastTargetRotation = new Quaternion$1(), this.camera.getPositionECEF(this.lastTargetPosition), this.camera.getRotation(this.lastTargetRotation), this.prevPosition = new Vector3$1(), this.prevRotation = new Quaternion$1(), this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation), this.moveStates = {
      forward: !1,
      backward: !1,
      up: !1,
      down: !1,
      strafeLeft: !1,
      strafeRight: !1,
      speedUp: !1
    }, this.stopped = !1, this.cameraMotionCallback = () => {
    }, this.cameraStopCallback = () => {
    };
  }
  /**
   * Apply transformation matrix
   */
  clampHeight() {
    const e = this.camera.getPositionCartographic(), s = Math.min(this.globe.getTerrainHeight(e), 2e4);
    e.height <= s + 1 && (e.height = s + 1, this.camera.setPositionCartographic(e));
  }
  /**
   * Clamp the pitch angle value
   */
  clampPitch() {
    const e = -(this.pitchRange / 2), s = e + this.pitchRange;
    this.pitch = Math.max(Math.min(this.pitch, s), e);
  }
  /**
   * Handle camera rotation
   */
  applyTransforms() {
    this.underground || this.clampHeight(), this.clampPitch();
    const e = new Vector3$1();
    this.camera.getPositionECEF(e);
    const s = new Quaternion$1();
    this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(
      toCartographic(e),
      null,
      o,
      a,
      l
    ), this.camera.setUpVector(o);
    const u = a.clone().applyAxisAngle(l, this.pitch).applyAxisAngle(o, this.yaw).add(e);
    this.camera.lookAt(u);
    const c = this.camera.save(), E = [
      c.left,
      c.right,
      c.top,
      c.bottom,
      c.zoom
    ];
    this.cameraMotionCallback(e, s, E);
  }
  /**
   * Update pitch and yaw given the current configuration of the camera
   */
  updateRotationFromCamera() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    new Matrix4().makeRotationFromQuaternion(s).extractBasis(o, a, l);
    const u = new Vector3$1(), c = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(
      toCartographic(e),
      null,
      u,
      void 0,
      c
    );
    const E = o.projectOnPlane(u), d = Math.sign(c.clone().cross(E).dot(u)), f = Math.sign(u.clone().cross(a).dot(o));
    this.yaw = d * E.angleTo(c), this.pitch = f * a.angleTo(u), this.applyTransforms();
  }
  /**
   * Calculate the target distance from the camera to a point picked from world space
   */
  calculateTargetDistance(e) {
    const s = new Vector3$1();
    this.camera.getPositionECEF(s);
    const o = 250, a = this.camera.getFarPlane(), l = e.clone().sub(s), u = l.length(), c = l.clone().divideScalar(u), { x: E, y: d, z: f } = Ellipsoid$1.WGS_84.radii, h = s.x, S = s.y, R = s.z, _ = l.x, m = l.y, L = l.z, F = Math.pow(_ / E, 2) + Math.pow(m / d, 2) + Math.pow(L / f, 2), W = 2 * (h * _ / (E * E) + S * m / (d * d) + R * L / (f * f)), G = Math.pow(h / E, 2) + Math.pow(S / d, 2) + Math.pow(R / f, 2) - 1, q = W * W - 4 * F * G;
    if (q < 0)
      return Math.min(o, u);
    if (this.underground && toCartographic(s).height < 1e3)
      return u >= a ? o : u;
    const fe = (-W - Math.sqrt(q)) / (2 * F), _e = (-W + Math.sqrt(q)) / (2 * F), Le = l.clone().multiplyScalar(fe), Fe = l.clone().multiplyScalar(_e);
    let Ee = u;
    return c.dot(Le) >= 0 && (Ee = Math.min(Ee, Le.length())), c.dot(Fe) >= 0 && (Ee = Math.min(Ee, Fe.length())), Ee >= a ? o : Ee;
  }
  /**
   * Handle keyboard press
   */
  onKeyDown(e) {
    (e === "w" || e === "W") && (this.moveStates.forward = !0), (e === "s" || e === "S") && (this.moveStates.backward = !0), (e === "a" || e === "A") && (this.moveStates.strafeLeft = !0), (e === "d" || e === "D") && (this.moveStates.strafeRight = !0), (e === "q" || e === "Q") && (this.moveStates.down = !0), (e === "e" || e === "E") && (this.moveStates.up = !0), e === " " && (this.moveStates.speedUp = !0);
  }
  /**
   * Handle keyboard release
   */
  onKeyRelease(e) {
    (e === "w" || e === "W") && (this.moveStates.forward = !1), (e === "s" || e === "S") && (this.moveStates.backward = !1), (e === "a" || e === "A") && (this.moveStates.strafeLeft = !1), (e === "d" || e === "D") && (this.moveStates.strafeRight = !1), (e === "q" || e === "Q") && (this.moveStates.down = !1), (e === "e" || e === "E") && (this.moveStates.up = !1), e === " " && (this.moveStates.speedUp = !1);
  }
  /**
   * Implements the camera pivot behavior on right-click drag
   */
  pivotCamera(e, s) {
    const o = s.x - e.x, a = s.y - e.y, l = 5e-3;
    this.pitch += l * a, this.yaw += l * o;
    const u = this.cameraRotationPivot.clone(), c = new Vector3$1();
    this.camera.getPositionECEF(c);
    const E = c.sub(u), d = new Vector3$1();
    Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(u, d);
    const f = new Matrix4();
    this.camera.getWorldMatrix(f);
    const h = new Vector3$1();
    f.extractBasis(h, new Vector3$1(), new Vector3$1()), Math.abs(this.pitch) <= this.pitchRange / 2 && E.applyAxisAngle(h, l * a), E.applyAxisAngle(d, l * o);
    const S = E.add(u);
    this.camera.setPositionECEF(S);
  }
  /**
   * Handle screen press event (either click or tap)
   */
  onPress(e) {
    const s = this.renderer.pickScreenWorldSpaceSnapping(e), o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = new Vector3$1();
    this.camera.getPositionECEF(a);
    const l = o.clone().sub(a).normalize(), u = this.calculateTargetDistance(o), c = a.add(l.multiplyScalar(u));
    this.cameraRotationPivot.x = c.x, this.cameraRotationPivot.y = c.y, this.cameraRotationPivot.z = c.z, this.handleCameraActivate(e);
  }
  /**
   * Handle screen drag event
   */
  onDrag(e, s) {
    this.isRotating && this.pivotCamera(e, s), this.handleCameraDrag(e, s), this.applyTransforms();
  }
  /**
   * Handle screen release event
   */
  onRelease(e) {
    this.isRotating = !1, this.handleCameraRelease(e);
  }
  /**
   * Handle zoom event
   *
   * This will be used to control zoom
   */
  onZoom(e, s) {
    if (this.camera.getProjectionMode() === CameraProjection.Orthographic) {
      const h = this.camera.getOrthographic(), S = Math.sign(s), R = Math.log(h.getZoom()) - S * 0.05, _ = Math.max(0, Math.exp(R));
      h.setZoom(_);
      return;
    }
    const o = this.renderer.pickScreenWorldSpaceSnapping(e), a = new Vector3$1(o.position.x, o.position.y, o.position.z), l = new Vector3$1();
    this.camera.getPositionECEF(l);
    const u = new Vector3$1(a.x, a.y, a.z).sub(l).normalize(), c = u.clone().negate(), E = this.calculateTargetDistance(a), d = Math.max(0.15, E * 0.05), f = this.moveStates.speedUp ? d * 2 : d;
    if (s > 0) {
      const h = l.add(c.multiplyScalar(f));
      this.camera.setPositionECEF(h);
    } else if (s < 0 && E > 0.25) {
      const h = l.add(u.multiplyScalar(f));
      this.camera.setPositionECEF(h);
    }
    this.applyTransforms(), this.handleCameraZoom(e, s);
  }
  /**
   * Update the camera position based on keyboard press state.
   */
  updateKeyboardControl() {
    if (!(this.moveStates.forward || this.moveStates.backward || this.moveStates.up || this.moveStates.down || this.moveStates.strafeLeft || this.moveStates.strafeRight || this.moveStates.speedUp))
      return;
    const s = new Matrix4();
    this.camera.getWorldMatrix(s);
    const o = new Vector3$1(), a = new Vector3$1();
    s.extractBasis(o, new Vector3$1(), a);
    const l = new Vector3$1();
    this.camera.getUpVector(l);
    const u = new Vector3$1();
    this.camera.getPositionECEF(u);
    const c = this.renderer.getSize(), E = this.renderer.pickScreenWorldSpaceSnapping({
      x: c.x / 2,
      y: c.y / 2
    }), d = new Vector3$1(E.position.x, E.position.y, E.position.z), f = this.calculateTargetDistance(d), h = Math.max(0.15, f * 0.05), S = this.moveStates.speedUp ? h * 2 : h, R = S, _ = Math.min(
      1.5,
      Math.abs(this.camera.getPositionCartographic().height * 0.05)
    ), m = this.moveStates.speedUp ? _ * 2 : _;
    if (this.moveStates.forward) {
      const L = u.sub(a.multiplyScalar(S));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
    if (this.moveStates.backward) {
      const L = u.add(a.multiplyScalar(S));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
    if (this.moveStates.up) {
      const L = u.add(l.multiplyScalar(m));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
    if (this.moveStates.down) {
      const L = u.sub(l.multiplyScalar(m));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
    if (this.moveStates.strafeLeft) {
      const L = u.sub(o.multiplyScalar(R));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
    if (this.moveStates.strafeRight) {
      const L = u.add(o.multiplyScalar(R));
      this.camera.setPositionECEF(L), this.applyTransforms();
    }
  }
  /**
   * Smoothly fly to the target position
   */
  updateFlyTo() {
    if (this.targetPosition) {
      const e = new Vector3$1();
      this.camera.getPositionECEF(e);
      const s = this.targetPosition.clone().sub(e), o = s.length(), a = s.multiplyScalar(1 / o);
      if (o > 0.5) {
        const l = a.clone().multiplyScalar(Math.max(1, o / 10));
        this.camera.setPositionECEF(e.add(l));
      } else
        this.camera.setPositionECEF(this.targetPosition), this.lastTargetPosition = this.targetPosition.clone(), this.targetPosition = null;
      this.applyTransforms();
    }
    if (this.targetRotation) {
      const e = new Quaternion$1();
      this.camera.getRotation(e);
      const s = e.angleTo(this.targetRotation);
      Math.abs(s) > 0.05 ? this.camera.setRotation(e.slerp(this.targetRotation, 0.1)) : (this.camera.setRotation(this.targetRotation), this.targetRotation = null), this.updateRotationFromCamera();
    }
  }
  /**
   * Handle camera stop event
   */
  updateCameraStop() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = this.camera.save(), a = [
      o.left,
      o.right,
      o.top,
      o.bottom,
      o.zoom
    ];
    e.distanceTo(this.prevPosition) === 0 && s.angleTo(this.prevRotation) === 0 ? this.stopped || (this.cameraStopCallback(e, s, a), this.stopped = !0) : this.stopped = !1, this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation);
  }
  start() {
    this.stop(), this.camera.getPerspective().setFieldOfView(75), this.gestures.register("keytap", (e) => {
      this.targetPosition = null, this.targetRotation = null, this.onKeyDown(e.key);
    }), this.gestures.register("keyrelease", (e) => this.onKeyRelease(e.key)), this.gestures.register("tap", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, this.isRotating = e.ctrlKey || e.button === 2, this.onPress(e.position);
    }), this.gestures.register("release", (e) => {
      this.onRelease(e.position);
    }), this.gestures.register("swipe", (e) => {
      this.onDrag(e.position, e.prevPosition);
    }), this.gestures.register("zoom", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, this.onZoom(e.position, e.direction.y);
    });
  }
  stop() {
    this.gestures.unregisterAll();
  }
  flyTo(e, s) {
    this.targetPosition = e, this.targetRotation = s;
  }
  moveTo(e, s) {
    this.camera.setPositionECEF(e), this.camera.setRotation(s), this.updateRotationFromCamera(), this.applyTransforms();
  }
  setUnderground(e) {
    this.underground = e;
  }
  setCameraMotionCallback(e) {
    this.cameraMotionCallback = e;
  }
  setCameraStopCallback(e) {
    this.cameraStopCallback = e;
  }
  updateFrame(e) {
    this.updateKeyboardControl(), this.updateFlyTo(), this.updateCameraStop();
  }
}
class CameraOrbit extends BaseCameraMode {
  constructor(s, o) {
    super(s, o);
    Qt(this, "startTranslationPosition");
    Qt(this, "startTranslationPlane");
    this.startTranslationPosition = new Vector3$1(), this.startTranslationPlane = new Plane();
  }
  /**
   * Implement controls when camera is activated (onclick)
   */
  handleCameraActivate(s) {
    const { position: o } = this.renderer.pickScreenWorldSpaceSnapping(s), a = new Vector3$1(o.x, o.y, o.z), l = new Vector3$1();
    this.camera.getPositionECEF(l);
    const u = a.clone().sub(l).normalize(), c = this.calculateTargetDistance(a), E = l.add(u.multiplyScalar(c)), d = new Matrix4();
    this.camera.getWorldMatrix(d), E.applyMatrix4(d.invert()), this.startTranslationPosition.x = E.x, this.startTranslationPosition.y = E.y, this.startTranslationPosition.z = E.z, this.startTranslationPlane.setFromNormalAndCoplanarPoint(
      MathUtils.Z_AXIS,
      this.startTranslationPosition
    );
  }
  /**
   * Do nothing on camera release
   */
  handleCameraRelease() {
  }
  /**
   * Do nothing on camera zoom
   */
  handleCameraZoom() {
  }
  /**
   * Implement controls for gliding the camera over the globe
   */
  handleCameraDrag(s, o) {
    if (this.isRotating)
      return;
    const a = this.renderer.getSize(), l = MathUtils.screenCoordsToNDC(
      o.x,
      o.y,
      a.x,
      a.y,
      new Vector4(0, 0, 0, 1)
    );
    l.y *= -1;
    const u = MathUtils.screenCoordsToNDC(
      s.x,
      s.y,
      a.x,
      a.y,
      new Vector4(0, 0, 0, 1)
    );
    u.y *= -1;
    const c = new Matrix4();
    this.camera.getPerspective().getInverseProjectionMatrix(c), l.applyMatrix4(c), l.divideScalar(l.w), u.applyMatrix4(c), u.divideScalar(u.w);
    const E = this.startTranslationPlane, d = this.startTranslationPosition.length() * 2, f = new Line3(MathUtils.ZERO_3.clone());
    f.end.x = l.x, f.end.y = l.y, f.end.z = l.z, f.end.normalize().multiplyScalar(d);
    const h = new Vector3$1();
    E.intersectLine(f, h), f.end.x = u.x, f.end.y = u.y, f.end.z = u.z, f.end.normalize().multiplyScalar(d);
    const S = new Vector3$1();
    E.intersectLine(f, S);
    const R = h.sub(S);
    if (this.camera.getProjectionMode() === CameraProjection.Orthographic) {
      const L = this.camera.getOrthographic().getZoom(), F = Math.max(0.5, Math.min(R.length() / L, 5));
      R.normalize().multiplyScalar(F);
    }
    const _ = new Quaternion$1();
    this.camera.getRotation(_), R.applyQuaternion(_);
    const m = new Vector3$1();
    this.camera.getPositionECEF(m), m.add(R), this.camera.setPositionECEF(m);
  }
}
class CameraOrbitOrthographic {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "camera");
    Qt(this, "orthographic");
    Qt(this, "gestures");
    Qt(this, "isRotating", !1);
    Qt(this, "underground", !1);
    Qt(this, "cameraRotationPivot", new Vector3$1());
    Qt(this, "pitchRange", Math.PI - 0.05);
    Qt(this, "pitch", 0);
    Qt(this, "yaw", 0);
    Qt(this, "globe");
    Qt(this, "cameraStopCallback", () => {
    });
    Qt(this, "cameraMotionCallback", () => {
    });
    Qt(this, "targetPosition", null);
    Qt(this, "targetRotation", null);
    Qt(this, "lastTargetPosition");
    Qt(this, "lastTargetRotation");
    Qt(this, "prevPosition");
    Qt(this, "prevRotation");
    Qt(this, "stopped");
    this.renderer = e, this.camera = this.renderer.camera, this.globe = this.renderer.world.globe, this.orthographic = this.camera.object.orthographic, this.gestures = s, this.lastTargetPosition = new Vector3$1(), this.lastTargetRotation = new Quaternion$1(), this.camera.getPositionECEF(this.lastTargetPosition), this.camera.getRotation(this.lastTargetRotation), this.prevPosition = new Vector3$1(), this.prevRotation = new Quaternion$1(), this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation), this.stopped = !1;
  }
  /**
   * Calculate the target distance from the camera to a point picked from world space
   */
  calculateTargetDistance(e) {
    const s = new Vector3$1();
    this.camera.getPositionECEF(s);
    const o = 250, a = this.camera.getFarPlane(), l = e.clone().sub(s), u = l.length(), c = l.clone().divideScalar(u), { x: E, y: d, z: f } = Ellipsoid$1.WGS_84.radii, h = s.x, S = s.y, R = s.z, _ = l.x, m = l.y, L = l.z, F = Math.pow(_ / E, 2) + Math.pow(m / d, 2) + Math.pow(L / f, 2), W = 2 * (h * _ / (E * E) + S * m / (d * d) + R * L / (f * f)), G = Math.pow(h / E, 2) + Math.pow(S / d, 2) + Math.pow(R / f, 2) - 1, q = W * W - 4 * F * G;
    if (q < 0)
      return Math.min(o, u);
    if (this.underground && toCartographic(s).height < 1e3)
      return u >= a ? o : u;
    const fe = (-W - Math.sqrt(q)) / (2 * F), _e = (-W + Math.sqrt(q)) / (2 * F), Le = l.clone().multiplyScalar(fe), Fe = l.clone().multiplyScalar(_e);
    let Ee = u;
    return c.dot(Le) >= 0 && (Ee = Math.min(Ee, Le.length())), c.dot(Fe) >= 0 && (Ee = Math.min(Ee, Fe.length())), Ee >= a ? o : Ee;
  }
  start() {
    this.camera.setProjectionMode(CameraProjection.Orthographic), this.camera.getPerspective().setFieldOfView(75), this.updateRotationFromCamera(), this.gestures.register("keytap", (e) => {
    }), this.gestures.register("keyrelease", (e) => {
    }), this.gestures.register("tap", (e) => {
      if (this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, e.ctrlKey || e.button === 2) {
        this.isRotating = !0;
        const s = this.renderer.pickScreenWorldSpaceSnapping(e.position), o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = new Vector3$1();
        this.camera.getPositionECEF(a);
        const l = o.clone().sub(a).normalize(), u = this.calculateTargetDistance(o), c = a.add(l.multiplyScalar(u));
        this.cameraRotationPivot.x = c.x, this.cameraRotationPivot.y = c.y, this.cameraRotationPivot.z = c.z;
      }
    }), this.gestures.register("release", (e) => {
      this.isRotating = !1;
    }), this.gestures.register("swipe", (e) => {
      this.isRotating ? this.onRotate(e.position, e.prevPosition) : this.onPan(e.position, e.prevPosition);
    }), this.gestures.register("zoom", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, this.onZoom(e.position, e.direction.y);
    });
  }
  stop() {
    this.camera.setProjectionMode(CameraProjection.Perspective), this.gestures.unregisterAll();
  }
  /**
   * Smoothly fly to the target position
   */
  updateFlyTo() {
    if (this.targetPosition) {
      const e = new Vector3$1();
      this.camera.getPositionECEF(e);
      const s = this.targetPosition.clone().sub(e), o = s.length(), a = s.multiplyScalar(1 / o);
      if (o > 0.5) {
        const l = a.clone().multiplyScalar(Math.max(1, o / 10));
        this.camera.setPositionECEF(e.add(l));
      } else
        this.camera.setPositionECEF(this.targetPosition), this.lastTargetPosition = this.targetPosition.clone(), this.targetPosition = null;
      this.applyTransforms();
    }
    if (this.targetRotation) {
      const e = new Quaternion$1();
      this.camera.getRotation(e);
      const s = e.angleTo(this.targetRotation);
      Math.abs(s) > 0.05 ? this.camera.setRotation(e.slerp(this.targetRotation, 0.1)) : (this.camera.setRotation(this.targetRotation), this.targetRotation = null), this.updateRotationFromCamera();
    }
  }
  /**
   * Handle camera stop event
   */
  updateCameraStop() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = this.camera.save(), a = [
      o.left,
      o.right,
      o.top,
      o.bottom,
      o.zoom
    ];
    e.distanceTo(this.prevPosition) === 0 && s.angleTo(this.prevRotation) === 0 ? this.stopped || (this.cameraStopCallback(e, s, a), this.stopped = !0) : this.stopped = !1, this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation);
  }
  flyTo(e, s) {
    this.targetPosition = e, this.targetRotation = s;
  }
  moveTo(e, s) {
    this.camera.object.position.copy(e), this.camera.object.rotation.setFromQuaternion(s), this.updateRotationFromCamera(), this.applyTransforms();
  }
  setUnderground(e) {
    this.underground = e;
  }
  setCameraMotionCallback(e) {
    this.cameraMotionCallback = e;
  }
  setCameraStopCallback(e) {
    this.cameraStopCallback = e;
  }
  updateFrame(e) {
    this.updateFlyTo(), this.updateCameraStop(), this.targetPosition || this.targetRotation ? this.camera.object.recalculateZoomBasedOnPosition() : this.camera.object.recalculatePositionBasedOnZoom();
  }
  /**
   * Apply transformation matrix
   */
  clampHeight() {
    const e = this.camera.getPositionCartographic(), s = Math.min(this.globe.getTerrainHeight(e), 2e4);
    e.height < s + 0.5 && (e.height = s + 0.5, this.camera.setPositionCartographic(e));
  }
  clampPitch() {
    const e = -(this.pitchRange / 2), s = this.underground ? this.pitchRange / 2 : 0;
    this.pitch = Math.max(Math.min(this.pitch, s), e);
  }
  updateRotationFromCamera() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    new Matrix4().makeRotationFromQuaternion(s).extractBasis(o, a, l);
    const u = new Vector3$1(), c = new Vector3$1(), E = new Cartographic$1();
    Ellipsoid$1.WGS_84.cartographicForPosition(e, E), Ellipsoid$1.WGS_84.rotationBasisForCartographic(E, null, u, void 0, c);
    const d = o.projectOnPlane(u), f = new Vector3$1().crossVectors(c, d);
    this.yaw = d.angleTo(c) * Math.sign(u.dot(f)), this.pitch = -a.angleTo(u), this.applyTransforms();
  }
  applyTransforms() {
    this.underground || this.clampHeight(), this.clampPitch();
    const e = new Vector3$1();
    this.camera.getPositionECEF(e);
    const s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1(), l = new Cartographic$1();
    Ellipsoid$1.WGS_84.cartographicForPosition(e, l), Ellipsoid$1.WGS_84.rotationBasisForCartographic(l, null, s, o, a), this.camera.setUpVector(s);
    const u = o.clone().applyAxisAngle(a, this.pitch).applyAxisAngle(s, this.yaw).add(e);
    this.camera.lookAt(u);
    const c = this.camera.save(), E = [
      c.left,
      c.right,
      c.top,
      c.bottom,
      c.zoom
    ], d = new Quaternion$1();
    this.camera.getRotation(d), this.cameraMotionCallback(e, d, E);
  }
  onRotate(e, s) {
    const o = s.x - e.x, a = s.y - e.y, l = 5e-3, u = this.pitch + l * a, c = this.underground ? !1 : u > 0 || u < -this.pitchRange / 2;
    c || (this.pitch += l * a), this.yaw += l * o;
    const E = this.cameraRotationPivot.clone(), d = new Vector3$1();
    this.camera.getPositionECEF(d);
    const f = d.sub(E), h = new Vector3$1();
    Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(E, h);
    const S = new Matrix4();
    this.camera.getLocalMatrix(S);
    const R = new Vector3$1();
    S.extractBasis(R, new Vector3$1(), new Vector3$1()), c || f.applyAxisAngle(R, l * a), f.applyAxisAngle(h, l * o);
    const _ = f.add(E);
    this.camera.setPositionECEF(_), this.applyTransforms();
  }
  onPan(e, s) {
    const o = this.camera.getOrthographic(), a = e.clone().sub(s), l = this.renderer.getSize();
    a.x = a.x / l.x * (o.getFrustumRight() - o.getFrustumLeft()), a.x *= -1, a.y = a.y / l.y * (o.getFrustumTop() - o.getFrustumBottom());
    const u = new Vector3$1(), c = this.camera.object;
    c.getWorldDirection(u);
    const E = u.clone().cross(c.up).normalize(), d = E.clone().cross(u).normalize();
    c.position.length(), c.position.add(E.clone().multiplyScalar(a.x)), c.position.add(d.clone().multiplyScalar(a.y)), this.applyTransforms();
  }
  onZoom(e, s) {
    const o = this.camera.getOrthographic(), a = this.renderer.getSize(), l = new Vector2(a.x / 2, a.y / 2), u = e.clone().sub(l);
    u.x = u.x / a.x * (o.getFrustumRight() - o.getFrustumLeft()), u.x *= -1, u.y = u.y / a.y * (o.getFrustumTop() - o.getFrustumBottom());
    const c = o.getFrustumLeft(), E = o.getFrustumRight(), d = o.getFrustumTop(), f = o.getFrustumBottom(), h = new Vector2(c / 2 + E / 2, d / 2 + f / 2);
    let S = 1;
    s > 0 ? S = 1 / 1.075 : S = 1.075;
    const R = (c - u.x) * S + u.x, _ = (E - u.x) * S + u.x, m = (d - u.y) * S + u.y, L = (f - u.y) * S + u.y, F = new Vector2(R / 2 + _ / 2, m / 2 + L / 2), W = (_ - R) / (E - c);
    o.setZoom(W);
    const G = F.clone().sub(h).multiplyScalar(1 / S), q = new Vector3$1(), fe = this.camera.object;
    fe.getWorldDirection(q);
    const _e = q.clone().cross(fe.up).normalize(), Le = _e.clone().cross(q).normalize(), Fe = fe.position.length();
    fe.position.add(_e.clone().multiplyScalar(G.x)), fe.position.add(Le.clone().multiplyScalar(G.y));
    const Ee = fe.position, Ge = q, ve = Fe, te = Ge.dot(Ge), ae = 2 * Ee.dot(Ge), v = Ee.dot(Ee) - ve * ve, Te = ae * ae - 4 * te * v;
    if (Te >= 0) {
      const De = (-ae + Math.sqrt(Te)) / 2 * te, be = (-ae - Math.sqrt(Te)) / 2 * te, ze = Math.abs(De) < Math.abs(be) ? De : be;
      fe.position.add(q.clone().multiplyScalar(ze));
    }
    this.applyTransforms();
  }
}
const MIN_FOV = 1, MAX_FOV = 125;
class CameraPanorama {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "gestures");
    Qt(this, "camera");
    Qt(this, "pitchRange");
    Qt(this, "pitch");
    Qt(this, "yaw");
    Qt(this, "targetPosition");
    Qt(this, "targetRotation");
    Qt(this, "targetFov");
    Qt(this, "prevPosition");
    Qt(this, "prevRotation");
    Qt(this, "cameraMotionCallback");
    Qt(this, "cameraStopCallback");
    Qt(this, "stopped");
    this.renderer = e, this.gestures = s, this.camera = this.renderer.getWorld().getCamera(), this.pitchRange = Math.PI - 0.05, this.pitch = 0, this.yaw = 0, this.targetPosition = null, this.targetRotation = null, this.targetFov = null, this.prevPosition = new Vector3$1(), this.prevRotation = new Quaternion$1(), this.cameraMotionCallback = () => {
    }, this.cameraStopCallback = () => {
    }, this.stopped = !1;
  }
  /**
   * Clamp the pitch angle value
   */
  clampPitch() {
    const e = -(this.pitchRange / 2), s = e + this.pitchRange;
    this.pitch = Math.max(Math.min(this.pitch, s), e);
  }
  /**
   * Handle camera rotation
   */
  applyTransforms() {
    this.clampPitch();
    const e = new Vector3$1();
    this.camera.getPositionECEF(e);
    const s = new Quaternion$1();
    this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(
      toCartographic(e),
      null,
      o,
      a,
      l
    ), this.camera.setUpVector(o);
    const u = a.clone().applyAxisAngle(l, this.pitch).applyAxisAngle(o, this.yaw).add(e);
    this.camera.lookAt(u);
    const c = this.camera.save(), E = [
      c.left,
      c.right,
      c.top,
      c.bottom,
      c.zoom
    ];
    this.cameraMotionCallback(e, s, E);
  }
  /**
   * Update pitch and yaw given the current configuration of the camera
   */
  updateRotationFromCamera() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    new Matrix4().makeRotationFromQuaternion(s).extractBasis(o, a, l);
    const u = new Vector3$1(), c = new Vector3$1();
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(
      toCartographic(e),
      null,
      u,
      void 0,
      c
    );
    const E = o.projectOnPlane(u), d = Math.sign(c.clone().cross(E).dot(u)), f = Math.sign(u.clone().cross(a).dot(o));
    this.yaw = d * E.angleTo(c), this.pitch = f * a.angleTo(u), this.applyTransforms();
  }
  /**
   * Implement controls for zooming without moving the camera
   *
   * @param screenPosition
   * @param direction
   */
  handleCameraZoom(e, s) {
    const o = this.camera.getPerspective().getFieldOfView(), a = o * 1e-3, l = o + s * a;
    this.camera.getPerspective().setFieldOfView(Math.min(Math.max(l, MIN_FOV), MAX_FOV));
  }
  /**
   * Implement controls first person camera
   */
  handleCameraDrag(e, s) {
    const o = e.x - s.x, a = e.y - s.y, u = 5e-3 * this.camera.getPerspective().getFieldOfView() / 75;
    this.pitch += a * u, this.yaw += o * u, this.applyTransforms();
  }
  /**
   * Handle camera stop event
   */
  updateCameraStop() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = this.camera.save(), a = [
      o.left,
      o.right,
      o.top,
      o.bottom,
      o.zoom
    ];
    e.distanceTo(this.prevPosition) === 0 && s.angleTo(this.prevRotation) === 0 ? this.stopped || (this.cameraStopCallback(e, s, a), this.stopped = !0) : this.stopped = !1, this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation);
  }
  start() {
    this.stop(), this.gestures.register("tap", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null;
    }), this.gestures.register("swipe", (e) => {
      this.handleCameraDrag(e.position, e.prevPosition);
    }), this.gestures.register("zoom", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, this.handleCameraZoom(e.position, e.direction.y);
    });
  }
  stop() {
    this.gestures.unregisterAll();
  }
  flyTo(e, s, o) {
    this.targetPosition = e, this.targetRotation = s, o !== void 0 && (this.targetFov = Math.min(MAX_FOV, Math.max(MIN_FOV, o)));
  }
  moveTo(e, s, o) {
    if (this.camera.setPositionECEF(e), this.camera.setRotation(s), o !== void 0) {
      const a = Math.min(MAX_FOV, Math.max(MIN_FOV, o));
      this.camera.getPerspective().setFieldOfView(a);
    }
    this.updateRotationFromCamera(), this.applyTransforms();
  }
  setUnderground(e) {
  }
  setCameraMotionCallback(e) {
    this.cameraMotionCallback = e;
  }
  setCameraStopCallback(e) {
    this.cameraStopCallback = e;
  }
  updateFrame(e) {
    if (this.updateCameraStop(), this.targetPosition) {
      const s = new Vector3$1();
      this.camera.getPositionECEF(s);
      const o = this.targetPosition.clone().sub(s), a = o.length(), l = o.multiplyScalar(1 / a);
      if (a > 0.5) {
        const u = l.clone().multiplyScalar(Math.max(1, a / 10));
        this.camera.setPositionECEF(s.add(u));
      } else
        this.camera.setPositionECEF(this.targetPosition), this.targetPosition = null;
    }
    if (this.targetRotation) {
      const s = new Quaternion$1();
      this.camera.getRotation(s);
      const o = s.angleTo(this.targetRotation);
      Math.abs(o) > 0.05 ? this.camera.setRotation(s.slerp(this.targetRotation, 0.1)) : (this.camera.setRotation(this.targetRotation), this.targetRotation = null), this.updateRotationFromCamera();
    }
    if (this.targetFov) {
      const s = this.camera.getPerspective().getFieldOfView(), o = this.targetFov - s;
      Math.abs(o) > 0.05 ? this.camera.getPerspective().setFieldOfView(s + o * 0.1) : (this.camera.getPerspective().setFieldOfView(this.targetFov), this.targetFov = null);
    }
  }
}
class CameraSuperman extends BaseCameraMode {
  constructor(s, o) {
    super(s, o);
    Qt(this, "flyToClicked");
    this.flyToClicked = !1;
  }
  /**
   * Calculate the flyTo point given the clicked position
   */
  calculateTarget(s) {
    const o = this.renderer.pickScreenWorldSpaceSnapping(s), a = new Vector3$1(o.position.x, o.position.y, o.position.z), l = toCartographic(a);
    return l.height += 1.8, toCartesian(l);
  }
  /**
   * Begin flying
   */
  handleCameraActivate() {
    this.isRotating || (this.flyToClicked = !0);
  }
  /**
   * Fly to view the clicked point
   */
  handleCameraRelease(s) {
    if (!this.flyToClicked)
      return;
    this.targetPosition = this.calculateTarget(s);
    const o = new Vector3$1();
    this.camera.getPositionECEF(o);
    const a = this.targetPosition.clone().sub(o);
    a.length() >= Ellipsoid$1.WGS_84.radii.length() && (a.normalize().multiplyScalar(100), this.targetPosition = o.add(a)), this.flyToClicked = !1;
  }
  /**
   * Implement controls first person camera
   */
  handleCameraDrag(s, o) {
    if (this.isRotating) {
      this.flyToClicked = !1;
      return;
    }
    const a = s.x - o.x, l = s.y - o.y, u = 5e-3;
    this.pitch += u * l, this.yaw += u * a;
    const c = 0.5;
    a * a + l * l > c * c && (this.flyToClicked = !1);
  }
  /**
   * Do not enable flyToClicked if coming from zoom
   */
  handleCameraZoom() {
    this.flyToClicked = !1;
  }
}
class CameraSupermanOrthographic {
  constructor(e, s) {
    Qt(this, "renderer");
    Qt(this, "camera");
    Qt(this, "orthographic");
    Qt(this, "gestures");
    Qt(this, "isRotating", !1);
    Qt(this, "underground", !1);
    Qt(this, "cameraRotationPivot", new Vector3$1());
    Qt(this, "pitchRange", Math.PI - 0.05);
    Qt(this, "pitch", 0);
    Qt(this, "yaw", 0);
    Qt(this, "globe");
    Qt(this, "cameraStopCallback", () => {
    });
    Qt(this, "cameraMotionCallback", () => {
    });
    Qt(this, "targetPosition", null);
    Qt(this, "targetRotation", null);
    Qt(this, "lastTargetPosition");
    Qt(this, "lastTargetRotation");
    Qt(this, "prevPosition");
    Qt(this, "prevRotation");
    Qt(this, "stopped");
    Qt(this, "flyToClicked", !1);
    this.renderer = e, this.camera = this.renderer.camera, this.globe = this.renderer.world.globe, this.orthographic = this.camera.object.orthographic, this.gestures = s, this.lastTargetPosition = new Vector3$1(), this.lastTargetRotation = new Quaternion$1(), this.camera.getPositionECEF(this.lastTargetPosition), this.camera.getRotation(this.lastTargetRotation), this.prevPosition = new Vector3$1(), this.prevRotation = new Quaternion$1(), this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation), this.stopped = !1;
  }
  /**
   * Calculate the flyTo point given the clicked position
   */
  calculateTarget(e) {
    const s = this.renderer.pickScreenWorldSpaceSnapping(e), o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = toCartographic(o);
    return a.height += 1.8, toCartesian(a);
  }
  /**
   * Calculate the target distance from the camera to a point picked from world space
   */
  calculateTargetDistance(e) {
    const s = new Vector3$1();
    this.camera.getPositionECEF(s);
    const o = 250, a = this.camera.getFarPlane(), l = e.clone().sub(s), u = l.length(), c = l.clone().divideScalar(u), { x: E, y: d, z: f } = Ellipsoid$1.WGS_84.radii, h = s.x, S = s.y, R = s.z, _ = l.x, m = l.y, L = l.z, F = Math.pow(_ / E, 2) + Math.pow(m / d, 2) + Math.pow(L / f, 2), W = 2 * (h * _ / (E * E) + S * m / (d * d) + R * L / (f * f)), G = Math.pow(h / E, 2) + Math.pow(S / d, 2) + Math.pow(R / f, 2) - 1, q = W * W - 4 * F * G;
    if (q < 0)
      return Math.min(o, u);
    if (this.underground && toCartographic(s).height < 1e3)
      return u >= a ? o : u;
    const fe = (-W - Math.sqrt(q)) / (2 * F), _e = (-W + Math.sqrt(q)) / (2 * F), Le = l.clone().multiplyScalar(fe), Fe = l.clone().multiplyScalar(_e);
    let Ee = u;
    return c.dot(Le) >= 0 && (Ee = Math.min(Ee, Le.length())), c.dot(Fe) >= 0 && (Ee = Math.min(Ee, Fe.length())), Ee >= a ? o : Ee;
  }
  start() {
    this.camera.setProjectionMode(CameraProjection.Orthographic), this.camera.getPerspective().setFieldOfView(75), this.updateRotationFromCamera(), this.gestures.register("keytap", (e) => {
    }), this.gestures.register("keyrelease", (e) => {
    }), this.gestures.register("tap", (e) => {
      if (this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, e.ctrlKey || e.button === 2) {
        this.isRotating = !0;
        const s = this.renderer.pickScreenWorldSpaceSnapping(e.position), o = new Vector3$1(s.position.x, s.position.y, s.position.z), a = new Vector3$1();
        this.camera.getPositionECEF(a);
        const l = o.clone().sub(a).normalize(), u = this.calculateTargetDistance(o), c = a.add(l.multiplyScalar(u));
        this.cameraRotationPivot.x = c.x, this.cameraRotationPivot.y = c.y, this.cameraRotationPivot.z = c.z;
      } else
        this.flyToClicked = !0;
    }), this.gestures.register("release", (e) => {
      if (this.isRotating = !1, this.flyToClicked) {
        this.targetPosition = this.calculateTarget(e.position);
        const s = new Vector3$1();
        this.camera.getPositionECEF(s);
        const o = this.targetPosition.clone().sub(s);
        o.length() >= Ellipsoid$1.WGS_84.radii.length() && (o.normalize().multiplyScalar(100), this.targetPosition = s.add(o)), this.flyToClicked = !1;
      }
    }), this.gestures.register("swipe", (e) => {
      this.isRotating ? this.onRotate(e.position, e.prevPosition) : this.onPan(e.position, e.prevPosition);
    }), this.gestures.register("zoom", (e) => {
      this.camera.object.setFocusPointUsingGPUPicking(e.position), this.targetPosition = null, this.targetRotation = null, this.onZoom(e.position, e.direction.y);
    });
  }
  stop() {
    this.camera.setProjectionMode(CameraProjection.Perspective), this.gestures.unregisterAll();
  }
  /**
   * Smoothly fly to the target position
   */
  updateFlyTo() {
    if (this.targetPosition) {
      const e = new Vector3$1();
      this.camera.getPositionECEF(e);
      const s = this.targetPosition.clone().sub(e), o = s.length(), a = s.multiplyScalar(1 / o);
      if (o > 0.5) {
        const l = a.clone().multiplyScalar(Math.max(1, o / 10));
        this.camera.setPositionECEF(e.add(l));
      } else
        this.camera.setPositionECEF(this.targetPosition), this.lastTargetPosition = this.targetPosition.clone(), this.targetPosition = null;
      this.applyTransforms();
    }
    if (this.targetRotation) {
      const e = new Quaternion$1();
      this.camera.getRotation(e);
      const s = e.angleTo(this.targetRotation);
      Math.abs(s) > 0.05 ? this.camera.setRotation(e.slerp(this.targetRotation, 0.1)) : (this.camera.setRotation(this.targetRotation), this.targetRotation = null), this.updateRotationFromCamera();
    }
  }
  /**
   * Handle camera stop event
   */
  updateCameraStop() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = this.camera.save(), a = [
      o.left,
      o.right,
      o.top,
      o.bottom,
      o.zoom
    ];
    e.distanceTo(this.prevPosition) === 0 && s.angleTo(this.prevRotation) === 0 ? this.stopped || (this.cameraStopCallback(e, s, a), this.stopped = !0) : this.stopped = !1, this.camera.getPositionECEF(this.prevPosition), this.camera.getRotation(this.prevRotation);
  }
  flyTo(e, s) {
    this.targetPosition = e, this.targetRotation = s;
  }
  moveTo(e, s) {
    this.camera.object.position.copy(e), this.camera.object.rotation.setFromQuaternion(s), this.updateRotationFromCamera(), this.applyTransforms();
  }
  setUnderground(e) {
    this.underground = e;
  }
  setCameraMotionCallback(e) {
    this.cameraMotionCallback = e;
  }
  setCameraStopCallback(e) {
    this.cameraStopCallback = e;
  }
  updateFrame(e) {
    this.updateFlyTo(), this.updateCameraStop(), this.targetPosition || this.targetRotation ? this.camera.object.recalculateZoomBasedOnPosition() : this.camera.object.recalculatePositionBasedOnZoom();
  }
  /**
   * Apply transformation matrix
   */
  clampHeight() {
    const e = this.camera.getPositionCartographic(), s = Math.min(this.globe.getTerrainHeight(e), 2e4);
    e.height < s + 0.5 && (e.height = s + 0.5, this.camera.setPositionCartographic(e));
  }
  clampPitch() {
    const e = -(this.pitchRange / 2), s = this.underground ? this.pitchRange / 2 : 0;
    this.pitch = Math.max(Math.min(this.pitch, s), e);
  }
  updateRotationFromCamera() {
    const e = new Vector3$1(), s = new Quaternion$1();
    this.camera.getPositionECEF(e), this.camera.getRotation(s);
    const o = new Vector3$1(), a = new Vector3$1(), l = new Vector3$1();
    new Matrix4().makeRotationFromQuaternion(s).extractBasis(o, a, l);
    const u = new Vector3$1(), c = new Vector3$1(), E = new Cartographic$1();
    Ellipsoid$1.WGS_84.cartographicForPosition(e, E), Ellipsoid$1.WGS_84.rotationBasisForCartographic(E, null, u, void 0, c);
    const d = o.projectOnPlane(u), f = new Vector3$1().crossVectors(c, d);
    this.yaw = d.angleTo(c) * Math.sign(u.dot(f)), this.pitch = -a.angleTo(u), this.applyTransforms();
  }
  applyTransforms() {
    this.underground || this.clampHeight(), this.clampPitch();
    const e = new Vector3$1();
    this.camera.getPositionECEF(e);
    const s = new Vector3$1(), o = new Vector3$1(), a = new Vector3$1(), l = new Cartographic$1();
    Ellipsoid$1.WGS_84.cartographicForPosition(e, l), Ellipsoid$1.WGS_84.rotationBasisForCartographic(l, null, s, o, a), this.camera.setUpVector(s);
    const u = o.clone().applyAxisAngle(a, this.pitch).applyAxisAngle(s, this.yaw).add(e);
    this.camera.lookAt(u);
    const c = this.camera.save(), E = [
      c.left,
      c.right,
      c.top,
      c.bottom,
      c.zoom
    ], d = new Quaternion$1();
    this.camera.getRotation(d), this.cameraMotionCallback(e, d, E);
  }
  onRotate(e, s) {
    const o = s.x - e.x, a = s.y - e.y, l = 5e-3, u = this.pitch + l * a, c = this.underground ? !1 : u > 0 || u < -this.pitchRange / 2;
    c || (this.pitch += l * a), this.yaw += l * o;
    const E = this.cameraRotationPivot.clone(), d = new Vector3$1();
    this.camera.getPositionECEF(d);
    const f = d.sub(E), h = new Vector3$1();
    Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(E, h);
    const S = new Matrix4();
    this.camera.getLocalMatrix(S);
    const R = new Vector3$1();
    S.extractBasis(R, new Vector3$1(), new Vector3$1()), c || f.applyAxisAngle(R, l * a), f.applyAxisAngle(h, l * o);
    const _ = f.add(E);
    this.camera.setPositionECEF(_), this.applyTransforms();
  }
  onPan(e, s) {
    const o = e.x - s.x, a = e.y - s.y, l = 5e-3;
    this.pitch += l * a, this.yaw += l * o;
    const u = 0.5;
    o * o + a * a > u * u && (this.flyToClicked = !1), this.applyTransforms();
  }
  onZoom(e, s) {
    const o = this.camera.getOrthographic(), a = this.renderer.getSize(), l = new Vector2(a.x / 2, a.y / 2), u = e.clone().sub(l);
    u.x = u.x / a.x * (o.getFrustumRight() - o.getFrustumLeft()), u.x *= -1, u.y = u.y / a.y * (o.getFrustumTop() - o.getFrustumBottom());
    const c = o.getFrustumLeft(), E = o.getFrustumRight(), d = o.getFrustumTop(), f = o.getFrustumBottom(), h = new Vector2(c / 2 + E / 2, d / 2 + f / 2);
    let S = 1;
    s > 0 ? S = 1 / 1.075 : S = 1.075;
    const R = (c - u.x) * S + u.x, _ = (E - u.x) * S + u.x, m = (d - u.y) * S + u.y, L = (f - u.y) * S + u.y, F = new Vector2(R / 2 + _ / 2, m / 2 + L / 2), W = (_ - R) / (E - c);
    o.setZoom(W);
    const G = F.clone().sub(h).multiplyScalar(1 / S), q = new Vector3$1(), fe = this.camera.object;
    fe.getWorldDirection(q);
    const _e = q.clone().cross(fe.up).normalize(), Le = _e.clone().cross(q).normalize(), Fe = fe.position.length();
    fe.position.add(_e.clone().multiplyScalar(G.x)), fe.position.add(Le.clone().multiplyScalar(G.y));
    const Ee = fe.position, Ge = q, ve = Fe, te = Ge.dot(Ge), ae = 2 * Ee.dot(Ge), v = Ee.dot(Ee) - ve * ve, Te = ae * ae - 4 * te * v;
    if (Te >= 0) {
      const De = (-ae + Math.sqrt(Te)) / 2 * te, be = (-ae - Math.sqrt(Te)) / 2 * te, ze = Math.abs(De) < Math.abs(be) ? De : be;
      fe.position.add(q.clone().multiplyScalar(ze));
    }
    this.applyTransforms(), this.flyToClicked = !1;
  }
}
const DEFAULT_CAMERA_POSITION = toCartesian(
  new Cartographic$1(toRadians(150.898042), toRadians(-34.464009), 25e5)
), DEFAULT_CAMERA_ROTATION = calculateNadirOrientation(DEFAULT_CAMERA_POSITION);
class NavigationService extends Service {
  constructor(s) {
    super(s);
    Qt(this, "camera");
    Qt(this, "underground");
    Qt(this, "cameraMotionCallback");
    Qt(this, "cameraStopCallback");
    Qt(this, "navigationMode", "orbit");
    Qt(this, "projectionMode", "perspective");
    Qt(this, "currentMode");
    this.camera = this.renderer.getWorld().getCamera(), this.underground = !0, this.cameraMotionCallback = () => {
    }, this.cameraStopCallback = () => {
    }, this.currentMode = new CameraOrbit(this.renderer, this.gestures), this.currentMode.start(), this.moveTo(DEFAULT_CAMERA_POSITION, DEFAULT_CAMERA_ROTATION);
  }
  /**
   * Start a camera mode.
   */
  start(s) {
    this.currentMode.stop(), this.currentMode = s, this.currentMode.start(), this.currentMode.setUnderground(this.underground), this.currentMode.moveTo(this.getPosition(), this.getRotation()), this.currentMode.setCameraMotionCallback(this.cameraMotionCallback), this.currentMode.setCameraStopCallback(this.cameraStopCallback);
  }
  /**
   * Enable camera controls.
   */
  enable() {
    this.currentMode.start();
  }
  /**
   * Disable camera controls.
   */
  disable() {
    this.currentMode.stop();
  }
  /**
   * Update navigation mode based on the requested mode and the projection mode.
   */
  updateNavigationMode() {
    switch (this.navigationMode) {
      case "orbit":
        switch (this.projectionMode) {
          case "perspective":
            this.start(new CameraOrbit(this.renderer, this.gestures));
            break;
          case "orthographic":
            this.start(new CameraOrbitOrthographic(this.renderer, this.gestures));
            break;
        }
        break;
      case "superman":
        switch (this.projectionMode) {
          case "perspective":
            this.start(new CameraSuperman(this.renderer, this.gestures));
            break;
          case "orthographic":
            this.start(new CameraSupermanOrthographic(this.renderer, this.gestures));
            break;
        }
        break;
      case "panorama":
        this.start(new CameraPanorama(this.renderer, this.gestures));
        break;
    }
  }
  /**
   * Set the current navigation mode.
   *
   * @param mode
   */
  setNavigationMode(s) {
    this.navigationMode !== s && (this.navigationMode = s, this.updateNavigationMode());
  }
  /**
   * Get the current navigation mode.
   *
   * @returns
   */
  getNavigationMode() {
    return this.navigationMode;
  }
  /**
   * Set the projection mode of the camera.
   *
   * @param projectionMode
   */
  setProjectionMode(s) {
    this.projectionMode !== s && (this.projectionMode = s, this.updateNavigationMode());
  }
  /**
   * Get the projection mode of the camera.
   *
   * @returns
   */
  getProjectionMode() {
    return this.projectionMode;
  }
  /**
   * Reset the camera to the default position and orientation.
   */
  resetCamera() {
    this.flyTo(DEFAULT_CAMERA_POSITION, DEFAULT_CAMERA_ROTATION);
  }
  /**
   * Toggle allowing the camera to go underground (globe surface).
   *
   * @param underground
   */
  setUnderground(s) {
    this.underground = s, this.currentMode.setUnderground(s);
  }
  /**
   * Set the camera motion callback.
   *
   * @param underground
   */
  setCameraMotionCallback(s) {
    this.cameraMotionCallback = s, this.currentMode.setCameraMotionCallback(s);
  }
  /**
   * Set the camera stop callback.
   *
   * @param callback
   */
  setCameraStopCallback(s) {
    this.cameraStopCallback = s, this.currentMode.setCameraStopCallback(s);
  }
  /**
   * Smoothly fly the camera to a position and orientation configuration.
   *
   * @param position
   * @param rotation
   */
  flyTo(s, o) {
    o || (o = calculateNadirOrientation(s)), this.currentMode.flyTo(s, o);
  }
  /**
   * Teleport the camera to a position and orientation configuration.
   *
   * @param position
   * @param rotation
   */
  moveTo(s, o) {
    o || (o = calculateNadirOrientation(s)), this.currentMode.moveTo(s, o);
  }
  /**
   * Get the position of the camera in ECEF.
   *
   * @param position
   * @returns
   */
  getPosition(s) {
    return s || (s = new Vector3$1()), this.camera.getPositionECEF(s), s;
  }
  /**
   * Get the rotation of the camera.
   *
   * @param rotation
   * @returns
   */
  getRotation(s) {
    return s || (s = new Quaternion$1()), this.camera.getRotation(s), s;
  }
  /**
   * Get the forward direction of the camera.
   *
   * @param forward
   * @returns
   */
  getForward(s) {
    return s || (s = new Vector3$1()), this.camera.getForwardVector(s), s;
  }
  /**
   * Get the camera matrix parameters.
   *
   * @returns
   */
  getOrthoMatrixParams() {
    const s = this.camera.save();
    return [
      s.left,
      s.right,
      s.top,
      s.bottom,
      s.zoom
    ];
  }
  /**
   * Set the camera projection parameters from a given state.
   *
   * @param params
   */
  setOrthoMatrixParams(s) {
    const o = {
      position: this.getPosition(),
      rotation: this.getRotation(),
      mode: this.camera.getProjectionMode(),
      left: s[0],
      right: s[1],
      top: s[2],
      bottom: s[3],
      zoom: s[4]
    };
    this.camera.load(o);
  }
  /**
   * Check if near plane clipping is enabled for the orthographic camera.
   *
   * @returns
   */
  getOrthoNearPlaneClipping() {
    return this.camera.getOrthographic().getNearPlaneClipping();
  }
  /**
   * Toggle near plane clipping for the orthographic camera.
   *
   * @param value
   * @returns
   */
  setOrthoNearPlaneClipping(s) {
    return this.camera.getOrthographic().setNearPlaneClipping(s);
  }
  /**
   * Look at a model.
   *
   * @param model
   * @param flyTo
   */
  lookAt(s, o = !0) {
    const a = s.getPosition(), l = s.getBoundingRadius();
    if (this.currentMode instanceof CameraPanorama) {
      const u = this.getPosition(), c = calculateLookAtRotation(u, a), E = calculateLookAtFov(u, a, l);
      o ? this.currentMode.flyTo(u, c, E) : this.currentMode.moveTo(u, c, E);
    } else {
      const u = this.camera.getPerspective().getFieldOfView(), c = calculateCameraTargetPosition(a, l, toRadians(u)), E = calculateNadirOrientation(c);
      o ? this.flyTo(c, E) : this.moveTo(c, E);
    }
  }
  /**
   * Per-frame updates.
   *
   * @param deltaTime
   */
  updateFrame(s) {
    this.currentMode.updateFrame(s);
  }
}
class PanoramaEditor {
  constructor(e, s, o) {
    Qt(this, "target");
    Qt(this, "renderer");
    Qt(this, "gestures");
    Qt(this, "navigationService");
    Qt(this, "pointer");
    Qt(this, "grabbing");
    Qt(this, "running");
    Qt(this, "currentNavigationMode");
    Qt(this, "currentProjectionMode");
    this.target = null, this.renderer = e, this.gestures = s, this.navigationService = o, this.pointer = this.renderer.getObjectFactory().createSphere({
      radius: 0.15,
      material: {
        type: "basicAlpha",
        color: { r: 1, g: 1, b: 1 },
        alpha: 0.4
      },
      position: {
        ecef: { x: 0, y: 0, z: 0 }
      }
    }), this.pointer.setRenderLayer(RenderLayer.AfterPanorama), this.grabbing = !1, this.running = !1, this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode();
  }
  /**
   * Start the editor.
   *
   * @param panorama
   * @param onEdit
   * @param onTransitionStart
   * @param onTransitionFinish
   * @param onTransitionError
   */
  async start(e, s, o, a, l) {
    this.stop(), this.target = e, this.running = !0;
    try {
      await o(this.target), await this.target.show360(), await a(this.target);
    } catch (c) {
      await l(c), this.stop();
      return;
    }
    this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode(), this.navigationService.setProjectionMode("perspective"), this.navigationService.setNavigationMode("panorama"), this.navigationService.moveTo(this.target.getPosition(), this.navigationService.getRotation()), this.renderer.getWorld().addObject(this.pointer), this.gestures.register("keytap", (c) => {
      if (this.target === null)
        return;
      const E = this.renderer.getWorld().getCamera(), d = new Matrix4();
      E.getWorldMatrix(d);
      const f = new Vector3$1(), h = new Vector3$1(), S = new Vector3$1();
      d.extractBasis(f, h, S);
      const R = this.navigationService.getPosition(), _ = this.navigationService.getRotation(), m = 0.01;
      c.key === "w" && R.sub(S.multiplyScalar(m)), c.key === "a" && R.sub(f.multiplyScalar(m)), c.key === "s" && R.add(S.multiplyScalar(m)), c.key === "d" && R.add(f.multiplyScalar(m)), c.key === "q" && R.sub(h.multiplyScalar(m)), c.key === "e" && R.add(h.multiplyScalar(m)), this.navigationService.moveTo(R, _), this.target.setPosition(R), this.target && s(this.target.getPosition(), this.target.getRotation());
    }), this.gestures.register("tap", (c) => {
      c.button === 2 && (this.grabbing = !0);
    }), this.gestures.register("release", () => {
      this.target && this.grabbing && s(this.target.getPosition(), this.target.getRotation()), this.grabbing = !1;
    });
    let u = this.navigationService.getRotation();
    this.gestures.register("hover", (c) => {
      const E = this.renderer.pickScreenWorldSpaceSnapping(c.position);
      if (this.pointer.setPositionECEF(E.position), this.target === null)
        return;
      const d = this.navigationService.getRotation(), f = new Quaternion$1().multiplyQuaternions(
        d,
        u.invert()
      );
      if (u = d, this.grabbing) {
        const h = this.target.getRotation(), S = f.multiply(h).normalize();
        this.target.setRotation(S);
      }
    });
  }
  /**
   * Stop the editor.
   */
  stop() {
    var e;
    this.running = !1, this.gestures.unregisterAll(), this.navigationService.setNavigationMode(this.currentNavigationMode), this.navigationService.setProjectionMode(this.currentProjectionMode), this.renderer.getWorld().removeObject(this.pointer), (e = this.target) == null || e.hide360();
  }
  /**
   * Check if the editor is active.
   *
   * @returns
   */
  isActive() {
    return this.running;
  }
}
const _VECTOR3_0 = new Vector3$1(), _VECTOR3_1 = new Vector3$1(), _VECTOR3_2 = new Vector3$1(), _VECTOR3_3 = new Vector3$1(), _VECTOR3_4 = new Vector3$1(), _VECTOR3_5 = new Vector3$1(), MAX_ELEVATION_RANGE = 1.7, MAX_DIRECTION_COST = 0.3, COST_WEIGHTS = {
  DISTANCE: 1,
  DIRECTION: 1.5,
  ELEVATION: 100,
  OCCLUSION: 100
};
class PanoramaWalkthrough {
  constructor(e, s, o, a) {
    Qt(this, "renderer");
    Qt(this, "gestures");
    Qt(this, "utilityService");
    Qt(this, "navigationService");
    Qt(this, "panoramas");
    Qt(this, "current");
    Qt(this, "next");
    Qt(this, "baseColor");
    Qt(this, "selectColor");
    Qt(this, "pointer");
    Qt(this, "blendFactor");
    Qt(this, "targetOpacity");
    Qt(this, "state");
    Qt(this, "canTransition");
    Qt(this, "running");
    Qt(this, "currentNavigationMode");
    Qt(this, "currentProjectionMode");
    Qt(this, "ignoreModels");
    Qt(this, "onTransitionStart");
    Qt(this, "onTransitionFinish");
    Qt(this, "onTransitionError");
    this.renderer = e, this.gestures = s, this.utilityService = o, this.navigationService = a, this.panoramas = [], this.current = null, this.next = null, this.pointer = this.renderer.getObjectFactory().createSphere({
      radius: 0.15,
      material: {
        type: "basicAlpha",
        color: { r: 1, g: 1, b: 1 },
        alpha: 0.4
      },
      position: {
        ecef: { x: 0, y: 0, z: 0 }
      }
    }), this.pointer.setRenderLayer(RenderLayer.AfterPanorama), this.baseColor = new Color(1, 1, 1), this.selectColor = new Color(0, 0, 1), this.blendFactor = 0, this.targetOpacity = 1, this.state = "waiting", this.canTransition = !0, this.running = !1, this.ignoreModels = [], this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode(), this.onTransitionStart = async () => {
    }, this.onTransitionFinish = async () => {
    }, this.onTransitionError = async () => {
    };
  }
  /**
   * Select the next panorama
   *
   * @param pick
   * @returns
   */
  selectPanorama(e) {
    for (const f of this.panoramas)
      if (f.isPicked(e))
        return f;
    const s = this.navigationService.getPosition(_VECTOR3_0), o = toCartographic(s).height, a = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(s);
    let l = 1 / 0, u = -1 / 0;
    for (const f of this.panoramas) {
      const h = f.getPosition(_VECTOR3_5).distanceTo(s);
      l = Math.min(h, l), u = Math.max(h, u);
    }
    const c = _VECTOR3_1.copy(e.position).sub(s).projectOnPlane(a).normalize();
    let E = null, d = 1 / 0;
    for (const f of this.panoramas) {
      if (f === this.current)
        continue;
      const h = f.getPosition(_VECTOR3_2), _ = (1 - _VECTOR3_3.copy(h).sub(s).projectOnPlane(a).normalize().dot(c)) / MAX_DIRECTION_COST;
      if (_ > 1)
        continue;
      const m = h.distanceTo(s);
      let L = 0;
      u > l && (L = (m - l) / (u - l));
      const F = toCartographic(h).height, W = Math.abs(F - o), G = Math.max(0, W - MAX_ELEVATION_RANGE);
      let q = 0;
      const fe = this.utilityService.projectToScreen(h);
      if (fe) {
        const Le = this.renderer.pickScreenWorldSpace(fe), Ee = _VECTOR3_4.copy(Le.position).distanceTo(s);
        if (q = Math.max(0, m - Ee), m > Ee) {
          const Ge = f.getIconPosition(), ve = this.utilityService.projectToScreen(Ge);
          if (ve) {
            const te = this.renderer.pickScreenWorldSpace(ve), v = _VECTOR3_5.copy(te.position).distanceTo(s);
            m <= v && (q = 0);
          }
        }
      } else
        q = 100;
      const _e = COST_WEIGHTS.DISTANCE * L + COST_WEIGHTS.DIRECTION * _ + COST_WEIGHTS.ELEVATION * G + COST_WEIGHTS.OCCLUSION * q;
      _e < d && (E = f, d = _e);
    }
    return E;
  }
  /**
   * Attach the gesture controls
   */
  attachControls() {
    this.gestures.register("tap", (e) => {
      let o = this.renderer.raycastScreen(e.position).filter((l) => l.object !== this.pointer)[0];
      o || (o = this.renderer.pickScreenWorldSpaceSnapping(e.position));
      const a = !!this.ignoreModels.find((l) => l.isPicked(o));
      this.state === "waiting" && this.canTransition && !a && (this.state = "ready");
    }), this.gestures.register("release", async (e) => {
      const s = this.renderer.pickScreenWorldSpaceSnapping(e.position);
      if (this.state === "ready" && this.current) {
        const o = this.selectPanorama(s);
        o ? await this.transitionTo(o) : this.state = "waiting";
      }
    }), this.gestures.register("hover", (e) => {
      const s = this.renderer.pickScreenWorldSpaceSnapping(e.position);
      this.pointer.setPositionECEF(s.position);
      const o = this.selectPanorama(s);
      for (const u of this.panoramas)
        o === u ? u.setColor(this.selectColor) : u.setColor(this.baseColor);
      const a = 0.5;
      e.position.distanceToSquared(e.prevPosition) > a * a && this.state === "ready" && (this.state = "waiting");
    });
  }
  /**
   * Start a walkthrough session.
   *
   * @param panoramas
   * @param start
   * @param onTransitionStart
   * @param onTransitionFinish
   * @param onTransitionError
   * @returns
   */
  async start(e, s, o, a, l) {
    this.stop(), this.running = !0, this.setPanoramas(e), this.onTransitionStart = o, this.onTransitionFinish = a, this.onTransitionError = l, await this.transitionTo(s), this.renderer.getWorld().addObject(this.pointer), this.currentNavigationMode = this.navigationService.getNavigationMode(), this.currentProjectionMode = this.navigationService.getProjectionMode(), this.navigationService.setProjectionMode("perspective"), this.navigationService.setNavigationMode("panorama"), this.navigationService.moveTo(s.getPosition(), this.navigationService.getRotation()), this.attachControls();
  }
  /**
   * Stop the walkthrough.
   */
  stop() {
    var e, s;
    this.running = !1, this.state = "waiting", (e = this.current) == null || e.hide360(), (s = this.next) == null || s.hide360(), this.current = null, this.next = null, this.blendFactor = 0, this.gestures.unregisterAll(), this.renderer.getWorld().removeObject(this.pointer), this.navigationService.setNavigationMode(this.currentNavigationMode), this.navigationService.setProjectionMode(this.currentProjectionMode);
  }
  /**
   * Check if the walkthrough is active.
   *
   * @returns
   */
  isActive() {
    return this.running;
  }
  /**
   * Get the list of panoramas in the walkthrough.
   *
   * @returns
   */
  getPanoramas() {
    return [...this.panoramas];
  }
  /**
   * Set the target opacity for the walkthrough.
   *
   * @param opacity
   */
  setOpacity(e) {
    this.targetOpacity = e;
  }
  /**
   * Set the list of panoramas in the walkthrough.
   *
   * @param panoramas
   */
  setPanoramas(e) {
    this.panoramas = e;
  }
  /**
   * Disable transitioning between panoramas.
   */
  disableTransitions() {
    this.canTransition = !1;
  }
  /**
   * Enable transitioning between panoramas.
   */
  enableTransitions() {
    this.canTransition = !0;
  }
  /**
   * Set the base color for a panorama disc.
   *
   * @param color
   */
  setBaseColor(e) {
    this.baseColor = e;
  }
  /**
   * Set the color when a panorama is highlighted for selection.
   *
   * @param color
   */
  setSelectColor(e) {
    this.selectColor = e;
  }
  /**
   * Set the list of models to ignore transition when clicked.
   *
   * @param models
   */
  setIgnoreModels(e) {
    this.ignoreModels = e;
  }
  /**
   * Manually transition to a panorama while in walkthrough mode.
   *
   * @param target
   * @returns True if it was able to transition to the selected panorama.
   */
  async transitionTo(e) {
    if (!this.running || this.state === "inflight" || this.current === e)
      return !1;
    this.state = "inflight", await this.onTransitionStart(e);
    try {
      return await e.show360(), this.next = e, this.blendFactor = 0, this.navigationService.moveTo(e.getPosition(), this.navigationService.getRotation()), !0;
    } catch (s) {
      return await this.onTransitionError(s), this.stop(), !1;
    } finally {
      await this.onTransitionFinish(e), this.running || this.stop();
    }
  }
  /**
   * Per-frame updates
   *
   * Handles the smooth cross-fade between panoramic images
   *
   * @param deltaTime
   */
  update(e) {
    var s, o, a;
    this.state === "inflight" && this.next !== null ? ((s = this.current) == null || s.setPriority(1), this.next.setPriority(2), this.blendFactor += Math.min(0.125, e), this.next.setOpacity360(Math.min(this.blendFactor, this.targetOpacity)), this.blendFactor >= this.targetOpacity && ((o = this.current) == null || o.hide360(), this.current = this.next, this.next = null, this.blendFactor = 0, this.state = "waiting")) : (a = this.current) == null || a.setOpacity360(this.targetOpacity);
  }
}
class PanoramaService extends Service {
  constructor(s, o, a) {
    super(s);
    Qt(this, "utilityService");
    Qt(this, "navigationService");
    Qt(this, "walkthrough");
    Qt(this, "editor");
    this.utilityService = o, this.navigationService = a, this.walkthrough = new PanoramaWalkthrough(
      this.renderer,
      this.gestures,
      this.utilityService,
      this.navigationService
    ), this.editor = new PanoramaEditor(this.renderer, this.gestures, this.navigationService);
  }
  /**
   * Get the walkthrough controller.
   *
   * @returns
   */
  getWalkthrough() {
    return this.walkthrough;
  }
  /**
   * Get the panorama editor controller.
   *
   * @returns
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Update walkthrough per-frame state.
   *
   * @param deltaTime
   */
  updateFrame(s) {
    this.walkthrough.update(s);
  }
}
function WorkerWrapper$1() {
  return new Worker("" + new URL("assets/SectioningWorker-a39a2b7b.js", import.meta.url).href);
}
const PROGRESS_SEGMENTS$1 = {
  refine: [0, 0.8],
  compute: [0.8, 1]
};
class SectioningService extends Service {
  constructor(s) {
    super(s);
    Qt(this, "worker");
    Qt(this, "invokeId");
    Qt(this, "pendingReject");
    Qt(this, "pointMesh");
    Qt(this, "pointOverlay");
    Qt(this, "lineMesh");
    Qt(this, "lineOverlay");
    this.invokeId = 0, this.pendingReject = null, this.pointMesh = this.renderer.createPointMesh(), this.pointMesh.resolve(), this.pointOverlay = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.pointMesh,
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1),
        pointSize: 10
      },
      position: {
        ecef: new Vector3$1()
      }
    }), this.renderer.getWorld().addObject(this.pointOverlay), this.lineMesh = this.renderer.createLineMesh(), this.lineMesh.resolve(), this.lineOverlay = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.lineMesh,
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1)
      },
      position: {
        ecef: new Vector3$1()
      }
    }), this.renderer.getWorld().addObject(this.lineOverlay), this.hide();
  }
  /**
   * Update the section mesh.
   *
   * @param points
   * @param centroid
   */
  buildMesh(s, o) {
    this.pointMesh.points = s, this.pointMesh.resolve(), this.lineMesh.vertices.length = 0;
    for (let l = 0; l < s.length - 1; l++)
      this.lineMesh.vertices.push(s[l], s[l + 1]);
    this.lineMesh.resolve();
    const a = toCartographic(o);
    a.height += 0.25, this.pointOverlay.setPositionCartographic(a), this.lineOverlay.setPositionCartographic(a);
  }
  /**
   * Internal computation of segment altitudes.
   *
   * @param vertices
   * @param threeObjects
   * @param invokeId
   * @param onProgress
   * @returns
   */
  async computeInternal(s, o, a, l) {
    const u = new Sphere$1().setFromPoints(s), c = s.map(serializeVector3), E = [];
    for (const d of o)
      d.traverse((f) => {
        if ("isMesh" in f && new Box3$1().setFromObject(f).intersectsSphere(u)) {
          const R = f.geometry;
          E.push([serializeGeometry(R), serializeMatrix4(f.matrixWorld)]);
        }
      });
    return new Promise((d, f) => {
      var S, R;
      (S = this.pendingReject) == null || S.call(this), this.pendingReject = () => f(
        new Error(`Sectioning (${a}): Superseded by a new computation (${this.invokeId})`)
      ), (R = this.worker) == null || R.terminate(), this.worker = new WorkerWrapper$1(), this.worker.addEventListener("message", (_) => {
        if (!_.data.source || _.data.source !== "sectioning")
          return;
        if (_.data.invokeId !== this.invokeId) {
          f(
            new Error(
              `Sectioning (${a}): Superseded by a new computation (${this.invokeId}).`
            )
          );
          return;
        }
        const m = _.data.sampleGroups.map(
          (L) => L.map(deserializeCartographic)
        );
        this.buildMesh(
          _.data.vertices.map(deserializeVector3),
          deserializeVector3(_.data.centroid)
        ), l("compute", PROGRESS_SEGMENTS$1.compute[1]), d(m), this.pendingReject = null;
      });
      const h = {
        source: "sectioning",
        invokeId: a,
        points: c,
        geometries: E
      };
      l("compute", PROGRESS_SEGMENTS$1.compute[0]), this.worker.postMessage(h);
    });
  }
  /**
   * Test if spheres projected to elevation 0 collide.
   *
   * @param a
   * @param vertices
   * @returns
   */
  isCollidingProjected(s, o) {
    const a = toCartographic(s.center);
    a.height = 0;
    const l = new Sphere$1(toCartesian(a), s.radius), u = new Vector3$1();
    for (let c = 0; c < o.length - 1; c++) {
      const E = toCartographic(o[c]);
      E.height = 0;
      const d = toCartographic(o[c + 1]);
      d.height = 0;
      const f = toCartesian(E), h = toCartesian(d);
      if (new Line3(f, h).closestPointToPoint(l.center, !0, u), u.distanceToSquared(l.center) <= l.radius * l.radius)
        return !0;
    }
    return !1;
  }
  /**
   * Compute the altitudes for a polyline against a model.
   *
   * @param vertices
   * @param model
   * @param onProgress
   * @returns
   */
  async compute(s, o, a = () => {
  }) {
    const l = ++this.invokeId, u = o.getWorldObject(), c = (E, d) => {
      const f = PROGRESS_SEGMENTS$1.refine[1], h = d === 0 ? f : E / d * f;
      a("refine", h);
    };
    if (u instanceof TilesetObject) {
      const E = await u.object.queryCollidingTiles(
        (d) => this.isCollidingProjected(d, s),
        c
      );
      return this.computeInternal(s, E, l, a);
    } else {
      const E = u.object;
      return this.computeInternal(s, [E], l, a);
    }
  }
  /**
   * Show the overlay mesh.
   */
  show() {
    this.pointOverlay.setVisible(!0), this.lineOverlay.setVisible(!0);
  }
  /**
   * Hide the overlay mesh.
   */
  hide() {
    this.pointOverlay.setVisible(!1), this.lineOverlay.setVisible(!1);
  }
  /**
   * Clear the overlay mesh.
   */
  clear() {
    this.pointMesh.points.length = 0, this.lineMesh.vertices.length = 0, this.pointMesh.resolve(), this.lineMesh.resolve();
  }
  /**
   * Set the color of the section line.
   *
   * @param color
   */
  setColor(s) {
    this.pointOverlay.applyMaterial({
      type: "basicOpaque",
      color: s,
      pointSize: 10
    }), this.lineOverlay.applyMaterial({
      type: "basicOpaque",
      color: s
    });
  }
  updateFrame(s) {
  }
}
class StatisticsService extends Service {
  constructor(s) {
    super(s);
    Qt(this, "eventRegister");
    Qt(this, "frameStatistics");
    /**
     * Tileset target.
     */
    Qt(this, "tilesetTarget", null);
    // FPS accumulators
    Qt(this, "fpsAccFrames");
    Qt(this, "fpsAccSeconds");
    this.eventRegister = new EventRegister(), this.frameStatistics = {
      deltaTime: 0,
      totalTime: 0,
      totalFrames: 0,
      fps: 0
    }, this.fpsAccFrames = 0, this.fpsAccSeconds = 0;
  }
  /**
   * Update listeners.
   *
   * @param deltaTime
   */
  updateFrame(s) {
    this.frameStatistics.deltaTime = s, this.frameStatistics.totalTime += s, this.frameStatistics.totalFrames++, this.fpsAccFrames++, this.fpsAccSeconds += s, this.fpsAccSeconds >= 1 && (this.frameStatistics.fps = this.fpsAccFrames / this.fpsAccSeconds, this.fpsAccFrames = 0, this.fpsAccSeconds = 0), this.eventRegister.emit("updateFrame", this.frameStatistics), this.tilesetTarget && this.eventRegister.emit("updateTileset", this.tilesetTarget.getStatistics());
  }
}
class PointTool {
  constructor(e, s, o, a) {
    Qt(this, "target");
    Qt(this, "pointer");
    Qt(this, "renderer");
    Qt(this, "gestures");
    Qt(this, "running");
    this.target = e, this.pointer = s, this.renderer = o, this.gestures = a, this.running = !1;
  }
  /**
   * Start the tool.
   *
   * @param onTransform
   */
  start(e) {
    this.stop(), this.running = !0, this.renderer.getWorld().addObject(this.pointer), this.gestures.register("hover", (s) => {
      const o = this.renderer.pickScreenWorldSpaceSnapping(s.position), a = new Vector3$1(o.position.x, o.position.y, o.position.z);
      this.pointer.setPositionECEF(a);
    }), this.gestures.register("zoom", (s) => {
      const o = this.renderer.pickScreenWorldSpaceSnapping(s.position), a = new Vector3$1(o.position.x, o.position.y, o.position.z);
      this.pointer.setPositionECEF(a);
    }), this.gestures.register("release", (s) => {
      const o = this.renderer.pickScreenWorldSpace(s.position), a = new Vector3$1(o.position.x, o.position.y, o.position.z), l = calculateCartographicQuaternion(toCartographic(a));
      this.target.setPosition(a), this.target.setRotation(l), e(a, l);
    });
  }
  /**
   * Stop the tool.
   */
  stop() {
    this.running = !1, this.renderer.getWorld().removeObject(this.pointer), this.gestures.unregisterAll();
  }
  /**
   * Check if the tool is active.
   *
   * @returns
   */
  isActive() {
    return this.running;
  }
  /**
   * Get the target model.
   */
  getTarget() {
    return this.target;
  }
}
const IDLE_COLORS = [new Color(16742296), new Color(4124798), new Color(5815549)], HOVER_COLORS = [new Color(16462947), new Color(1890144), new Color(1614075)];
class TransformWidgetTool {
  constructor(e, s, o) {
    Qt(this, "widgetManager");
    Qt(this, "navigationService");
    Qt(this, "translationButtons");
    Qt(this, "rotationButtons");
    Qt(this, "buttonAxisMap");
    Qt(this, "translationStep");
    Qt(this, "rotationStep");
    Qt(this, "target");
    Qt(this, "running");
    Qt(this, "onTargetMove");
    this.widgetManager = s, this.navigationService = o, this.translationButtons = [], this.rotationButtons = [], this.buttonAxisMap = /* @__PURE__ */ new Map(), this.translationStep = 1e-3, this.rotationStep = 17453293e-12, this.target = e, this.running = !1, this.onTargetMove = () => this.updateButtons();
  }
  /**
   * Update the control widget positions.
   */
  updateButtons() {
    const e = this.target.getPosition(), s = toCartographic(e), o = [new Vector3$1(), new Vector3$1(), new Vector3$1()];
    Ellipsoid$1.WGS_84.rotationBasisForCartographic(s, null, o[1], o[0], o[2]);
    for (let a = 0; a < o.length; a++) {
      const l = this.translationButtons[a], u = this.rotationButtons[a], c = o[a].clone().negate(), E = o[(a + 1) % o.length].clone();
      l.setPath({
        type: PathType.Line,
        origin: e,
        direction: c
      }), u.setPath({
        type: PathType.Circle,
        center: e,
        origin: e.clone().add(E.multiplyScalar(100)),
        normal: c,
        pivotCenter: !0
      }), l.resetProgress(), u.resetProgress();
      const d = new Matrix4();
      d.lookAt(e, e.clone().add(c), new Vector3$1(0, 1, 0));
      const f = new Quaternion$1();
      f.setFromRotationMatrix(d), l.setRotation(f), u.setRotation(f), this.buttonAxisMap.set(l, c), this.buttonAxisMap.set(u, c);
    }
  }
  /**
   * Handle widget controls translating the target model.
   */
  handleTranslationControls(e) {
    for (let s = 0; s < 3; s++) {
      const o = this.translationButtons[s];
      o.unregisterAll(), o.register("hover", () => {
        o.setColor(HOVER_COLORS[s]);
      }), o.register("leave", () => {
        o.isGrabbed() || o.setColor(IDLE_COLORS[s]);
      }), o.register("grab", () => {
        this.navigationService.disable();
        for (const a of this.translationButtons)
          o !== a && a.hide();
        for (const a of this.rotationButtons)
          a.hide();
      }), o.register("release", () => {
        this.navigationService.enable();
        for (const a of this.translationButtons)
          a.show();
        for (const a of this.rotationButtons)
          a.show();
        e(this.target.getPosition(), this.target.getRotation()), this.updateButtons();
      }), o.register("move", (a) => {
        const { position: l } = a, u = this.target.getPosition(), c = l.clone().sub(u), E = c.length(), d = Math.floor(E / this.translationStep) * this.translationStep, f = c.normalize().multiplyScalar(d);
        this.target.setPosition(u.add(f));
      });
    }
  }
  /**
   * Handle widget controls for rotating the target model.
   */
  handleRotationControls(e) {
    for (let s = 0; s < 3; s++) {
      const o = this.rotationButtons[s], a = new Quaternion$1();
      o.unregisterAll(), o.register("hover", () => {
        o.setColor(HOVER_COLORS[s]);
      }), o.register("leave", () => {
        o.isGrabbed() || o.setColor(IDLE_COLORS[s]);
      }), o.register("grab", () => {
        this.navigationService.disable(), this.target.getRotation(a);
        for (const l of this.rotationButtons)
          o !== l && l.hide();
        for (const l of this.translationButtons)
          l.hide();
      }), o.register("release", () => {
        this.navigationService.enable();
        for (const l of this.rotationButtons)
          l.show();
        for (const l of this.translationButtons)
          l.show();
        e(this.target.getPosition(), this.target.getRotation()), this.updateButtons();
      }), o.register("move", (l) => {
        const u = this.buttonAxisMap.get(o);
        if (u) {
          const c = Math.floor(l.progress * Math.PI * 2 / this.rotationStep) * this.rotationStep, E = new Quaternion$1().setFromAxisAngle(u, c);
          this.target.setRotation(E.multiply(a));
        }
      });
    }
  }
  /**
   * Start the tool.
   *
   * @param onTransform
   */
  start(e) {
    this.stop(), this.running = !0, this.translationButtons = IDLE_COLORS.map(
      (s) => this.widgetManager.createArrowWidget(100, s)
    ), this.rotationButtons = IDLE_COLORS.map((s) => this.widgetManager.createRingWidget(75, s)), this.updateButtons(), this.handleTranslationControls(e), this.handleRotationControls(e);
    for (const s of this.translationButtons)
      s.show();
    for (const s of this.rotationButtons)
      s.show();
  }
  /**
   * Stop the tool.
   */
  stop() {
    this.running = !1;
    for (const e of this.translationButtons)
      e.destroy();
    for (const e of this.rotationButtons)
      e.destroy();
  }
  /**
   * Check if the tool is active.
   *
   * @returns
   */
  isActive() {
    return this.running;
  }
  /**
   * Get the target model.
   *
   * @returns
   */
  getTarget() {
    return this.target;
  }
  /**
   * Set the translation widget step.
   *
   * @param step
   */
  setTranslationStep(e) {
    this.translationStep = e;
  }
  /**
   * Set the rotation widget step.
   * @param step
   */
  setRotationStep(e) {
    this.rotationStep = e;
  }
}
class TransformService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "navigationService");
    this.navigationService = o;
  }
  /**
   * Start the transform widget tool on a 3D target.
   *
   * @param target
   */
  createWidgetTool(s) {
    return new TransformWidgetTool(s, this.widgetManager, this.navigationService);
  }
  /**
   * Start the point placement tool on a 3D target.
   *
   * @param target
   */
  async createPointTool(s) {
    const o = {
      position: {
        ecef: { x: 0, y: 0, z: 0 }
      },
      url: PointIcon,
      material: {
        type: "basicAlpha",
        color: { r: 1, g: 1, b: 1 },
        alpha: 0.4
      },
      sizeAttenuation: !1,
      scale: { x: 0.02, y: 0.02, z: 0.02 }
    }, a = await this.renderer.getObjectFactory().createSprite(o);
    return new PointTool(s, a, this.renderer, this.gestures);
  }
  updateFrame(s) {
  }
}
class UtilityService extends Service {
  constructor(s, o) {
    super(s);
    Qt(this, "frameResolvers");
    Qt(this, "cursorHoverListener");
    Qt(this, "cursorTapListener");
    Qt(this, "cursorDoubleTapListener");
    this.frameResolvers = o, this.cursorHoverListener = () => {
    }, this.cursorTapListener = () => {
    }, this.cursorDoubleTapListener = () => {
    }, this.renderer.config.debug.multithreadedObj = !1;
  }
  /**
   * Get the current size of the renderer viewport.
   *
   * @returns
   */
  getViewportSize() {
    const { x: s, y: o } = this.renderer.getSize();
    return new Vector2(s, o);
  }
  /**
   * Set the background color of the renderer.
   *
   * @param color
   */
  setBackgroundColor(s) {
    this.renderer.getWorld().setBackgroundColor(s);
  }
  /**
   * Check if global EDL is enabled.
   *
   * @returns
   */
  isEyeDomeLightingEnabled() {
    return this.renderer.config.eyeDomeLighting.enabled;
  }
  /**
   * Get the global EDL density.
   *
   * @returns
   */
  getEyeDomeLightingDensity() {
    return this.renderer.config.eyeDomeLighting.density;
  }
  /**
   * Get the global EDL strength.
   *
   * @returns
   */
  getEyeDomeLightingStrength() {
    return this.renderer.config.eyeDomeLighting.strength;
  }
  /**
   * Check if use of multithreaded OBJ loading is enabled.
   *
   * @returns
   */
  isMultithreadedOBJEnabled() {
    return this.renderer.config.debug.multithreadedObj;
  }
  /**
   * Check if use of request cancelling is enabled.
   *
   * @returns
   */
  isRequestCancellingEnabled() {
    return this.renderer.config.debug.requestCancelling;
  }
  /**
   * Get global gamma.
   *
   * @returns
   */
  getGamma() {
    return this.renderer.config.gammaCorrectionFactor;
  }
  /**
   * Get the maximum number of simultaneous in-flight network requests.
   *
   * @returns
   */
  getMaxNetworkRequestsInFlight() {
    return this.renderer.config.tilesetNetworkRequests.maxInFlight;
  }
  /**
   * Check if the renderer is sorting tileset network requests.
   *
   * @returns
   */
  isNetworkRequestSortingEnabled() {
    return this.renderer.config.tilesetNetworkRequests.requestSorting;
  }
  /**
   * Check if tile priority bounding volumes are visible.
   *
   * @returns
   */
  isShowTilePrioritiesEnabled() {
    return this.renderer.config.debug.showRequestsInFlight && this.renderer.config.debug.showQueuedRequests;
  }
  /**
   * Check if the renderer local file cache is enabled.
   *
   * @returns
   */
  isCacheEnabled() {
    return this.renderer.config.useLocalCache;
  }
  /**
   * Toggle global EDL.
   *
   * @param enabled
   */
  setEyeDomeLightingEnabled(s) {
    this.renderer.config.eyeDomeLighting.enabled = s;
  }
  /**
   * Set global EDL density.
   *
   * @param density
   */
  setEyeDomeLightingDensity(s) {
    this.renderer.config.eyeDomeLighting.density = s;
  }
  /**
   * Set global EDL strength.
   *
   * @param strength
   */
  setEyeDomeLightingStrength(s) {
    this.renderer.config.eyeDomeLighting.strength = s;
  }
  /**
   * Toggle the use of multithreaded OBJ loading.
   *
   * @param enabled
   */
  setMultithreadedOBJEnabled(s) {
    this.renderer.config.debug.multithreadedObj = s;
  }
  /**
   * Toggle the use of request cancelling.
   *
   * @param enabled
   */
  setRequestCancellingEnabled(s) {
    this.renderer.config.debug.requestCancelling = s;
  }
  /**
   * Set global gamma.
   *
   * @param gamma
   * @returns
   */
  setGamma(s) {
    this.renderer.config.gammaCorrectionFactor = s;
  }
  /**
   * Set the maximum number of simultaneous in-flight network requests.
   *
   * @param max
   */
  setMaxNetworkRequestsInFlight(s) {
    this.renderer.config.tilesetNetworkRequests.maxInFlight = s;
  }
  /**
   * Toggle the sorting of tileset network reqeusts.
   *
   * @param enabled
   */
  setNetworkRequestSortingEnabled(s) {
    this.renderer.config.tilesetNetworkRequests.requestSorting = s;
  }
  /**
   * Toggle viewing tile priorities.
   *
   * @param enabled
   */
  setShowTilePrioritiesEnabled(s) {
    this.renderer.config.debug.showRequestsInFlight = s, this.renderer.config.debug.showQueuedRequests = s;
  }
  /**
   * Toggle the renderer's network cache.
   *
   * @param enabled
   */
  setCacheEnabled(s) {
    this.renderer.config.useLocalCache = s;
  }
  /**
   * Clear the renderer's network cache.
   */
  clearCache() {
    this.renderer.clearNetworkCache();
  }
  /**
   * Await the next frame.
   */
  nextFrame() {
    return new Promise((s) => {
      this.frameResolvers.push(s);
    });
  }
  /**
   * Take a screenshot of the viewer.
   *
   * @returns
   */
  captureScene() {
    const s = document.createElement("canvas"), o = s.getContext("2d");
    if (this.renderer === null || this.draw2D === null || o === null)
      return "data:,";
    const { width: a, height: l } = this.renderer.getCanvas();
    s.width = a, s.height = l, o.beginPath(), o.drawImage(this.renderer.getCanvas(), 0, 0, a, l), o.beginPath(), o.drawImage(this.draw2D.getCanvas(), 0, 0, a, l);
    const u = 1;
    return s.toDataURL("image/png", u);
  }
  /**
   * Set the listener for cursor hover in 3D space.
   *
   * @param listener
   * @param models
   */
  setCursorHoverCallback(s, o) {
    this.gestures.unregister("hover", this.cursorHoverListener), this.cursorHoverListener = (a) => {
      const l = this.renderer.pickScreenWorldSpaceRect(a.position), u = new Vector3$1(
        l[0].position.x,
        l[0].position.y,
        l[0].position.z
      ), c = computePickNormal(this.renderer, a.position), E = [];
      for (const d of l) {
        const { userData: f, directHit: h } = d;
        for (const S of o)
          S.isPicked(d) && E.push({ model: S, userData: f, directHit: h });
      }
      s({ position: u, normal: c, models: E });
    }, this.gestures.register("hover", this.cursorHoverListener);
  }
  /**
   * Set the listener for cursor taps in 3D space.
   *
   * @param listener
   * @param models
   */
  setCursorTapCallback(s, o) {
    this.gestures.unregister("tap", this.cursorTapListener), this.cursorTapListener = (a) => {
      const l = [], u = this.renderer.raycastScreen(a.position);
      for (const f of u) {
        const h = f.userData;
        for (const S of o)
          S.isPicked(f) && l.push({ model: S, userData: h, directHit: !0 });
      }
      const c = this.renderer.pickScreenWorldSpaceRect(a.position), E = new Vector3$1(
        c[0].position.x,
        c[0].position.y,
        c[0].position.z
      ), d = computePickNormal(this.renderer, a.position);
      for (const f of c) {
        const { userData: h, directHit: S } = f;
        for (const R of o)
          R.isPicked(f) && !l.find((_) => _.model === R) && l.push({ model: R, userData: h, directHit: S });
      }
      s({ position: E, normal: d, models: l });
    }, this.gestures.register("tap", this.cursorTapListener);
  }
  /**
   * Set the listener for cursor double-taps in 3D space.
   *
   * @param listener
   * @param models
   */
  setCursorDoubleTapCallback(s, o) {
    this.gestures.unregister("doubletap", this.cursorDoubleTapListener), this.cursorDoubleTapListener = (a) => {
      const l = [], u = this.renderer.raycastScreen(a.position);
      for (const f of u) {
        const h = f.userData;
        for (const S of o)
          S.isPicked(f) && l.push({ model: S, userData: h, directHit: !0 });
      }
      const c = this.renderer.pickScreenWorldSpaceRect(a.position), E = new Vector3$1(
        c[0].position.x,
        c[0].position.y,
        c[0].position.z
      ), d = computePickNormal(this.renderer, a.position);
      for (const f of c) {
        const { userData: h, directHit: S } = f;
        for (const R of o)
          R.isPicked(f) && !l.find((_) => _.model === R) && l.push({ model: R, userData: h, directHit: S });
      }
      s({ position: E, normal: d, models: l });
    }, this.gestures.register("doubletap", this.cursorDoubleTapListener);
  }
  /**
   * Project a point in 3D space to screen space.
   *
   * Returns null if point is not visible from the current perspective.
   *
   * @param position
   * @returns
   */
  projectToScreen(s) {
    const o = this.renderer.getWorld().getCamera(), a = this.getViewportSize(), l = projectToScreen(o, a, s), u = l.x >= 0 && l.x <= a.x, c = l.y >= 0 && l.y <= a.y;
    return isCameraVisible(o, s) && u && c ? l : null;
  }
  updateFrame(s) {
  }
}
function computeVolumetrics(r, e, s) {
  const o = new Vector3$1(), a = {
    cut: 0,
    fill: 0,
    surfaceArea: 0,
    projectedArea: e.projectedArea,
    minElevation: 1 / 0,
    maxElevation: -1 / 0
  };
  for (const l of r) {
    a.surfaceArea += l.getArea(), a.minElevation = Math.min(
      a.minElevation,
      l.cartA.height,
      l.cartB.height,
      l.cartC.height
    ), a.maxElevation = Math.max(
      a.maxElevation,
      l.cartA.height,
      l.cartB.height,
      l.cartC.height
    ), l.getMidpoint(o);
    const u = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(o);
    if (l.isFrontFacing(u))
      continue;
    const [E, d] = computeTriangleVolume(l, e, s);
    a.cut += E, a.fill += d;
  }
  return a;
}
function computeTriangleVolume(r, e, s) {
  switch (s) {
    case "triangulated":
      return computeTriangulatedTriangleVolume(r, e);
    case "smart":
      return computeSmartTriangleVolume(r, e);
    case "average":
      return computeLevelTriangleVolume(r, e.averageHeight);
    case "min":
      return computeLevelTriangleVolume(r, e.minHeight);
    case "max":
      return computeLevelTriangleVolume(r, e.maxHeight);
    default:
      return computeLevelTriangleVolume(r, s);
  }
}
function computeLevelTriangleVolume(r, e) {
  const s = new Vector3$1();
  r.getMidpoint(s);
  const o = toCartographic(s);
  o.height = e;
  const a = toCartesian(o), l = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(a), u = new Plane().setFromNormalAndCoplanarPoint(l, a), c = new Plane().setFromNormalAndCoplanarPoint(l.negate(), a), E = clipTriangle$1(r, u).map((S) => new CartographicTriangle(S.a, S.b, S.c)), d = clipTriangle$1(r, c).map((S) => new CartographicTriangle(S.a, S.b, S.c));
  let f = 0;
  for (const S of E) {
    const R = S.cartA.height - e, _ = S.cartB.height - e, m = S.cartC.height - e, L = S.getProjectedArea(), F = (R + _ + m) / 3;
    f += L * F;
  }
  let h = 0;
  for (const S of d) {
    const R = S.cartA.height - e, _ = S.cartB.height - e, m = S.cartC.height - e, L = S.getProjectedArea(), F = (R + _ + m) / 3;
    h += L * F;
  }
  return [f, h];
}
function computeSmartTriangleVolume(r, e) {
  const s = e.bestFitPlane, o = e.bestFitPlane.clone().negate(), a = clipTriangle$1(r, s).map((E) => new CartographicTriangle(E.a, E.b, E.c)), l = clipTriangle$1(r, o).map((E) => new CartographicTriangle(E.a, E.b, E.c));
  let u = 0;
  for (const E of a) {
    const d = computeSmartRefHeight(E.a, s), f = computeSmartRefHeight(E.b, s), h = computeSmartRefHeight(E.c, s), S = E.cartA.height - d, R = E.cartB.height - f, _ = E.cartC.height - h, m = E.getProjectedArea(), L = (S + R + _) / 3;
    u += m * L;
  }
  let c = 0;
  for (const E of l) {
    const d = computeSmartRefHeight(E.a, o), f = computeSmartRefHeight(E.b, o), h = computeSmartRefHeight(E.c, o), S = E.cartA.height - d, R = E.cartB.height - f, _ = E.cartC.height - h, m = E.getProjectedArea(), L = (S + R + _) / 3;
    c += m * L;
  }
  return [u, c];
}
function computeTriangulatedTriangleVolume(r, e) {
  const s = computeTriangulatedRefHeight(r.a, e.triangles), o = computeTriangulatedRefHeight(r.b, e.triangles), a = computeTriangulatedRefHeight(r.c, e.triangles), l = r.cartA.height - s, u = r.cartB.height - o, c = r.cartC.height - a, E = r.getProjectedArea(), d = (l + u + c) / 3, f = E * d;
  return d > 0 ? [f, 0] : [0, f];
}
function computeSmartRefHeight(r, e) {
  const o = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(r), a = new Line3(
    r.clone().addScaledVector(o, 1e5),
    r.clone().addScaledVector(o, -1e5)
  ), l = new Vector3$1();
  return e.intersectLine(a, l), toCartographic(l).height;
}
function computeTriangulatedRefHeight(r, e) {
  const s = toCartographic(r), o = toCartesian(new Cartographic$1(s.longitude, s.latitude)), a = new Vector3$1(), l = 1e-8;
  for (const u of e)
    if (u.getProjectedBarycoord(o, a), a.x >= -l && a.y >= -l && a.z >= -l)
      return a.x * u.cartA.height + a.y * u.cartB.height + a.z * u.cartC.height;
  return console.error("computeTriangulatedRefHeight: No containing triangle found for projected point."), 0;
}
class Extent {
  constructor(e) {
    Qt(this, "vertices");
    Qt(this, "cartographic");
    Qt(this, "indices");
    Qt(this, "triangles");
    Qt(this, "centroid");
    Qt(this, "bounds");
    Qt(this, "planes");
    Qt(this, "bestFitPlane");
    Qt(this, "minHeight");
    Qt(this, "maxHeight");
    Qt(this, "averageHeight");
    Qt(this, "projectedArea");
    this.vertices = e, this.cartographic = e.map(toCartographic), this.indices = triangulate$1(e), this.triangles = [], this.centroid = calculateCentroid$1(e), this.bounds = new Sphere$1().setFromPoints(e), this.planes = [], this.bestFitPlane = calculateBestFitPlane(e), this.minHeight = Math.min(...this.cartographic.map((o) => o.height)), this.maxHeight = Math.max(...this.cartographic.map((o) => o.height)), this.averageHeight = this.cartographic.map((o) => o.height).reduce((o, a) => o + a, 0), this.averageHeight /= this.cartographic.length, this.projectedArea = 0, Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(e[0]).dot(this.bestFitPlane.normal) < 0 && this.bestFitPlane.negate();
    for (let o = 0; o < this.indices.length; o += 3) {
      const a = new CartographicTriangle(
        this.vertices[this.indices[o]],
        this.vertices[this.indices[o + 1]],
        this.vertices[this.indices[o + 2]]
      );
      this.projectedArea += a.getProjectedArea();
    }
    this.buildClippingPlanes(), this.buildTriangles();
  }
  /**
   * Build a set of clipping planes from a given extent.
   *
   * Assumes adjacent positions form polygon edges.
   *
   * The polygon is split into triangles to guarantee convexity. Each triangle
   * then represents a clipping group with its own set of clipping planes.
   *
   * @param extent
   * @param indices
   * @returns
   */
  buildClippingPlanes() {
    const e = calculateCentroid$1(this.vertices), s = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(e), o = new Vector3$1();
    for (let a = 0; a < this.indices.length; a += 3) {
      new Triangle(
        this.vertices[this.indices[a]],
        this.vertices[this.indices[a + 1]],
        this.vertices[this.indices[a + 2]]
      ).getNormal(o), o.dot(s) < 0 && ([this.indices[a], this.indices[a + 2]] = [this.indices[a + 2], this.indices[a]]);
      const u = [];
      for (let c = 0; c < 3; c++) {
        const E = this.vertices[this.indices[a + c]], d = this.vertices[this.indices[a + (c + 1) % 3]], f = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(E), h = d.clone().sub(E), S = f.cross(h).normalize();
        u.push(new Plane().setFromNormalAndCoplanarPoint(S, E));
      }
      this.planes.push(u);
    }
  }
  /**
   * Build the triangulation of this extent.
   */
  buildTriangles() {
    for (let e = 0; e < this.indices.length; e += 3) {
      const s = new CartographicTriangle(
        this.vertices[this.indices[e]],
        this.vertices[this.indices[e + 1]],
        this.vertices[this.indices[e + 2]]
      );
      this.triangles.push(s);
    }
  }
  /**
   * Compute the level plane at a height.
   *
   * @param height
   * @returns
   */
  calculateLevelPlane(e) {
    const s = toCartographic(this.centroid);
    s.height = e;
    const o = toCartesian(s), a = Ellipsoid$1.WGS_84.geodeticSurfaceNormalForPosition(o);
    return new Plane().setFromNormalAndCoplanarPoint(a, o);
  }
  /**
   * Clip a triangle against this extent. This supports concave extent geometry.
   *
   * @param triangle
   * @param groups
   * @returns
   */
  clipTriangle(e) {
    const s = [];
    for (const o of this.planes) {
      let a = [e];
      for (const l of o) {
        const u = [];
        for (const c of a) {
          const E = clipTriangle$1(c, l);
          for (const d of E)
            u.push(new CartographicTriangle(d.a, d.b, d.c));
        }
        a = u;
      }
      s.push(...a);
    }
    return s;
  }
}
function WorkerWrapper() {
  return new Worker("" + new URL("assets/VolumetricWorker-8d280e92.js", import.meta.url).href);
}
const PROGRESS_SEGMENTS = {
  refine: [0, 0.8],
  compute: [0.8, 1]
};
class VolumetricService extends Service {
  constructor(s) {
    super(s);
    Qt(this, "worker");
    Qt(this, "invokeId");
    Qt(this, "pendingReject");
    Qt(this, "overlayMesh");
    Qt(this, "overlay");
    Qt(this, "baseMesh");
    Qt(this, "base");
    Qt(this, "visibleBase");
    this.invokeId = 0, this.pendingReject = null, this.overlayMesh = this.renderer.createIndexedTriangleMesh(), this.overlayMesh.resolve(), this.overlay = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.overlayMesh,
      material: {
        type: "basicAlpha",
        color: new Color(1, 1, 1),
        alpha: 0.5
      },
      position: {
        ecef: new Vector3$1()
      },
      scale: new Vector3$1(1.01, 1.01, 1.01)
    }), this.baseMesh = this.renderer.createLineMesh(), this.baseMesh.resolve(), this.base = this.renderer.getObjectFactory().createRawMeshObject({
      mesh: this.baseMesh,
      material: {
        type: "basicOpaque",
        color: new Color(1, 1, 1)
      },
      position: {
        ecef: new Vector3$1()
      },
      scale: new Vector3$1(1, 1, 1)
    }), this.visibleBase = !0, this.renderer.getWorld().addObject(this.overlay), this.renderer.getWorld().addObject(this.base), this.hide();
  }
  /**
   * Build the overlay mesh out of a triangle set.
   *
   * @param vertices
   * @param indices
   * @param centroid
   */
  buildOverlayMesh(s, o, a) {
    this.overlayMesh.vertices = s, this.overlayMesh.indices = o, this.overlayMesh.resolve(), this.overlay.setPositionECEF(a);
  }
  /**
   * Get the ref plane based on the base mode.
   *
   * @param extent
   * @param baseMode
   * @returns
   */
  buildBaseMesh(s, o) {
    switch (o) {
      case "average":
        return this.buildBasePlaneMesh(s, s.calculateLevelPlane(s.averageHeight));
      case "max":
        return this.buildBasePlaneMesh(s, s.calculateLevelPlane(s.maxHeight));
      case "min":
        return this.buildBasePlaneMesh(s, s.calculateLevelPlane(s.minHeight));
      case "smart":
        return this.buildBasePlaneMesh(s, s.bestFitPlane);
      case "triangulated":
        return this.buildBaseTriangulatedMesh(s);
      default:
        return this.buildBasePlaneMesh(s, s.calculateLevelPlane(o));
    }
  }
  /**
   * Build the planar base mesh.
   *
   * @param extent
   * @param basePlane
   */
  buildBasePlaneMesh(s, o) {
    this.baseMesh.vertices.length = 0;
    const a = s.vertices.map(
      (l) => o.projectPoint(l, new Vector3$1()).sub(s.centroid)
    );
    for (let l = 0; l < s.indices.length; l += 3) {
      const u = a[s.indices[l]], c = a[s.indices[l + 1]], E = a[s.indices[l + 2]], d = subdivideTriangleRecursively(
        new Triangle(u, c, E),
        subdivideTriangleBisection,
        (f) => f.getArea() <= 0.1
      );
      for (const f of d)
        this.baseMesh.vertices.push(f.a, f.b), this.baseMesh.vertices.push(f.b, f.c), this.baseMesh.vertices.push(f.c, f.a);
    }
    this.baseMesh.resolve(), this.base.setPositionECEF(s.centroid);
  }
  /**
   * Build the triangulated base mesh.
   *
   * @param extent
   */
  buildBaseTriangulatedMesh(s) {
    this.baseMesh.vertices.length = 0;
    const o = s.vertices.map((a) => a.clone().sub(s.centroid));
    for (let a = 0; a < s.indices.length; a += 3) {
      const l = o[s.indices[a]], u = o[s.indices[a + 1]], c = o[s.indices[a + 2]], E = subdivideTriangleRecursively(
        new Triangle(l, u, c),
        subdivideTriangleBisection,
        (d) => d.getArea() <= 0.1
      );
      for (const d of E)
        this.baseMesh.vertices.push(d.a, d.b), this.baseMesh.vertices.push(d.b, d.c), this.baseMesh.vertices.push(d.c, d.a);
    }
    this.baseMesh.resolve(), this.base.setPositionECEF(s.centroid);
  }
  /**
   * Compute a model's volume bounded by an extent.
   *
   * @param extent
   * @param baseMode
   * @param threeObject
   * @param invokeId
   * @param onProgress
   * @returns
   */
  computeInternal(s, o, a, l, u) {
    const c = s.vertices.map(serializeVector3), E = [];
    for (const d of a)
      d.traverse((f) => {
        if ("isMesh" in f && new Box3$1().setFromObject(f).intersectsSphere(s.bounds)) {
          const R = f.geometry;
          E.push([serializeGeometry(R), serializeMatrix4(f.matrixWorld)]);
        }
      });
    return new Promise((d, f) => {
      var S, R;
      (S = this.pendingReject) == null || S.call(this), this.pendingReject = () => f(
        new Error(
          `Volumetrics (${l}): Superseded by a new computation (${this.invokeId}).`
        )
      ), (R = this.worker) == null || R.terminate(), this.worker = new WorkerWrapper(), this.worker.addEventListener("message", (_) => {
        if (!(!_.data.source || _.data.source !== "volumetrics")) {
          if (_.data.invokeId !== this.invokeId) {
            f(
              new Error(
                `Volumetrics (${l}): Superseded by a new computation (${this.invokeId}).`
              )
            );
            return;
          }
          this.buildOverlayMesh(
            _.data.vertices.map(deserializeVector3),
            _.data.indices,
            deserializeVector3(_.data.centroid)
          ), this.buildBaseMesh(s, o), u("compute", PROGRESS_SEGMENTS.compute[1]), d(_.data.volumetrics), this.pendingReject = null;
        }
      });
      const h = {
        source: "volumetrics",
        invokeId: l,
        extentVertices: c,
        geometries: E,
        baseMode: o
      };
      u("compute", PROGRESS_SEGMENTS.compute[0]), this.worker.postMessage(h);
    });
  }
  isCollidingProjected(s, o) {
    const a = toCartographic(s.center);
    a.height = 0;
    const l = toCartographic(o.center);
    l.height = 0;
    const u = new Sphere$1(toCartesian(a), s.radius), c = new Sphere$1(toCartesian(l), o.radius);
    return u.intersectsSphere(c);
  }
  /**
   * Compute the volume for a model, or terrain if no model is provided.
   *
   * @param vertices
   * @param baseMode
   * @param model
   * @param onProgress
   * @returns
   */
  async compute(s, o, a, l = () => {
  }) {
    const u = ++this.invokeId, c = new Extent(s), E = a.getWorldObject(), d = (f, h) => {
      const S = PROGRESS_SEGMENTS.refine[1], R = h === 0 ? S : f / h * S;
      l("refine", R);
    };
    if (E instanceof TilesetObject) {
      const f = await E.object.queryCollidingTiles(
        (h) => this.isCollidingProjected(h, c.bounds),
        d
      );
      return this.computeInternal(c, o, f, u, l);
    } else {
      const f = E.object;
      return this.computeInternal(c, o, [f], u, l);
    }
  }
  /**
   * Show the volume mesh.
   */
  show() {
    this.overlay.setVisible(!0), this.base.setVisible(this.visibleBase);
  }
  /**
   * Hide the volume mesh.
   */
  hide() {
    this.overlay.setVisible(!1), this.base.setVisible(!1);
  }
  /**
   * Show the base plane.
   */
  showBase() {
    this.visibleBase = !0, this.base.setVisible(this.visibleBase);
  }
  /**
   * Hide the base plane.
   */
  hideBase() {
    this.visibleBase = !1, this.base.setVisible(this.visibleBase);
  }
  /**
   * Clear the current mesh.
   */
  clear() {
    this.overlayMesh.vertices.length = 0, this.overlayMesh.indices.length = 0, this.overlayMesh.resolve(), this.baseMesh.vertices.length = 0, this.baseMesh.resolve();
  }
  /**
   * Set the color of the volume mesh.
   *
   * @param color
   */
  setColor(s) {
    this.overlay.applyMaterial({
      type: "basicAlpha",
      color: s,
      alpha: 0.5
    });
  }
  updateFrame(s) {
  }
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var r = require$$0$3, e = Symbol.for("react.element"), s = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(c, E, d) {
    var f, h = {}, S = null, R = null;
    d !== void 0 && (S = "" + d), E.key !== void 0 && (S = "" + E.key), E.ref !== void 0 && (R = E.ref);
    for (f in E)
      o.call(E, f) && !l.hasOwnProperty(f) && (h[f] = E[f]);
    if (c && c.defaultProps)
      for (f in E = c.defaultProps, E)
        h[f] === void 0 && (h[f] = E[f]);
    return { $$typeof: e, type: c, key: S, ref: R, props: h, _owner: a.current };
  }
  return reactJsxRuntime_production_min.Fragment = s, reactJsxRuntime_production_min.jsx = u, reactJsxRuntime_production_min.jsxs = u, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, api$1.env.NODE_ENV !== "production" && function() {
    var r = require$$0$3, e = Symbol.for("react.element"), s = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), c = Symbol.for("react.context"), E = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function L(jn) {
      if (jn === null || typeof jn != "object")
        return null;
      var lr = _ && jn[_] || jn[m];
      return typeof lr == "function" ? lr : null;
    }
    var F = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function W(jn) {
      {
        for (var lr = arguments.length, pr = new Array(lr > 1 ? lr - 1 : 0), En = 1; En < lr; En++)
          pr[En - 1] = arguments[En];
        G("error", jn, pr);
      }
    }
    function G(jn, lr, pr) {
      {
        var En = F.ReactDebugCurrentFrame, qn = En.getStackAddendum();
        qn !== "" && (lr += "%s", pr = pr.concat([qn]));
        var Wn = pr.map(function(kn) {
          return String(kn);
        });
        Wn.unshift("Warning: " + lr), Function.prototype.apply.call(console[jn], console, Wn);
      }
    }
    var q = !1, fe = !1, _e = !1, Le = !1, Fe = !1, Ee;
    Ee = Symbol.for("react.module.reference");
    function Ge(jn) {
      return !!(typeof jn == "string" || typeof jn == "function" || jn === o || jn === l || Fe || jn === a || jn === d || jn === f || Le || jn === R || q || fe || _e || typeof jn == "object" && jn !== null && (jn.$$typeof === S || jn.$$typeof === h || jn.$$typeof === u || jn.$$typeof === c || jn.$$typeof === E || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      jn.$$typeof === Ee || jn.getModuleId !== void 0));
    }
    function ve(jn, lr, pr) {
      var En = jn.displayName;
      if (En)
        return En;
      var qn = lr.displayName || lr.name || "";
      return qn !== "" ? pr + "(" + qn + ")" : pr;
    }
    function te(jn) {
      return jn.displayName || "Context";
    }
    function ae(jn) {
      if (jn == null)
        return null;
      if (typeof jn.tag == "number" && W("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof jn == "function")
        return jn.displayName || jn.name || null;
      if (typeof jn == "string")
        return jn;
      switch (jn) {
        case o:
          return "Fragment";
        case s:
          return "Portal";
        case l:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof jn == "object")
        switch (jn.$$typeof) {
          case c:
            var lr = jn;
            return te(lr) + ".Consumer";
          case u:
            var pr = jn;
            return te(pr._context) + ".Provider";
          case E:
            return ve(jn, jn.render, "ForwardRef");
          case h:
            var En = jn.displayName || null;
            return En !== null ? En : ae(jn.type) || "Memo";
          case S: {
            var qn = jn, Wn = qn._payload, kn = qn._init;
            try {
              return ae(kn(Wn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v = Object.assign, Te = 0, De, be, ze, ke, Be, Me, me;
    function Se() {
    }
    Se.__reactDisabledLog = !0;
    function xt() {
      {
        if (Te === 0) {
          De = console.log, be = console.info, ze = console.warn, ke = console.error, Be = console.group, Me = console.groupCollapsed, me = console.groupEnd;
          var jn = {
            configurable: !0,
            enumerable: !0,
            value: Se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: jn,
            log: jn,
            warn: jn,
            error: jn,
            group: jn,
            groupCollapsed: jn,
            groupEnd: jn
          });
        }
        Te++;
      }
    }
    function Ht() {
      {
        if (Te--, Te === 0) {
          var jn = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: v({}, jn, {
              value: De
            }),
            info: v({}, jn, {
              value: be
            }),
            warn: v({}, jn, {
              value: ze
            }),
            error: v({}, jn, {
              value: ke
            }),
            group: v({}, jn, {
              value: Be
            }),
            groupCollapsed: v({}, jn, {
              value: Me
            }),
            groupEnd: v({}, jn, {
              value: me
            })
          });
        }
        Te < 0 && W("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Bt = F.ReactCurrentDispatcher, ut;
    function Tt(jn, lr, pr) {
      {
        if (ut === void 0)
          try {
            throw Error();
          } catch (qn) {
            var En = qn.stack.trim().match(/\n( *(at )?)/);
            ut = En && En[1] || "";
          }
        return `
` + ut + jn;
      }
    }
    var Yt = !1, an;
    {
      var Ct = typeof WeakMap == "function" ? WeakMap : Map;
      an = new Ct();
    }
    function st(jn, lr) {
      if (!jn || Yt)
        return "";
      {
        var pr = an.get(jn);
        if (pr !== void 0)
          return pr;
      }
      var En;
      Yt = !0;
      var qn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Wn;
      Wn = Bt.current, Bt.current = null, xt();
      try {
        if (lr) {
          var kn = function() {
            throw Error();
          };
          if (Object.defineProperty(kn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(kn, []);
            } catch (Kr) {
              En = Kr;
            }
            Reflect.construct(jn, [], kn);
          } else {
            try {
              kn.call();
            } catch (Kr) {
              En = Kr;
            }
            jn.call(kn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Kr) {
            En = Kr;
          }
          jn();
        }
      } catch (Kr) {
        if (Kr && En && typeof Kr.stack == "string") {
          for (var zn = Kr.stack.split(`
`), wr = En.stack.split(`
`), jr = zn.length - 1, Vr = wr.length - 1; jr >= 1 && Vr >= 0 && zn[jr] !== wr[Vr]; )
            Vr--;
          for (; jr >= 1 && Vr >= 0; jr--, Vr--)
            if (zn[jr] !== wr[Vr]) {
              if (jr !== 1 || Vr !== 1)
                do
                  if (jr--, Vr--, Vr < 0 || zn[jr] !== wr[Vr]) {
                    var us = `
` + zn[jr].replace(" at new ", " at ");
                    return jn.displayName && us.includes("<anonymous>") && (us = us.replace("<anonymous>", jn.displayName)), typeof jn == "function" && an.set(jn, us), us;
                  }
                while (jr >= 1 && Vr >= 0);
              break;
            }
        }
      } finally {
        Yt = !1, Bt.current = Wn, Ht(), Error.prepareStackTrace = qn;
      }
      var Es = jn ? jn.displayName || jn.name : "", Dr = Es ? Tt(Es) : "";
      return typeof jn == "function" && an.set(jn, Dr), Dr;
    }
    function jt(jn, lr, pr) {
      return st(jn, !1);
    }
    function lt(jn) {
      var lr = jn.prototype;
      return !!(lr && lr.isReactComponent);
    }
    function Zt(jn, lr, pr) {
      if (jn == null)
        return "";
      if (typeof jn == "function")
        return st(jn, lt(jn));
      if (typeof jn == "string")
        return Tt(jn);
      switch (jn) {
        case d:
          return Tt("Suspense");
        case f:
          return Tt("SuspenseList");
      }
      if (typeof jn == "object")
        switch (jn.$$typeof) {
          case E:
            return jt(jn.render);
          case h:
            return Zt(jn.type, lr, pr);
          case S: {
            var En = jn, qn = En._payload, Wn = En._init;
            try {
              return Zt(Wn(qn), lr, pr);
            } catch {
            }
          }
        }
      return "";
    }
    var Et = Object.prototype.hasOwnProperty, Ke = {}, $e = F.ReactDebugCurrentFrame;
    function pt(jn) {
      if (jn) {
        var lr = jn._owner, pr = Zt(jn.type, jn._source, lr ? lr.type : null);
        $e.setExtraStackFrame(pr);
      } else
        $e.setExtraStackFrame(null);
    }
    function Jt(jn, lr, pr, En, qn) {
      {
        var Wn = Function.call.bind(Et);
        for (var kn in jn)
          if (Wn(jn, kn)) {
            var zn = void 0;
            try {
              if (typeof jn[kn] != "function") {
                var wr = Error((En || "React class") + ": " + pr + " type `" + kn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof jn[kn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw wr.name = "Invariant Violation", wr;
              }
              zn = jn[kn](lr, kn, En, pr, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (jr) {
              zn = jr;
            }
            zn && !(zn instanceof Error) && (pt(qn), W("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", En || "React class", pr, kn, typeof zn), pt(null)), zn instanceof Error && !(zn.message in Ke) && (Ke[zn.message] = !0, pt(qn), W("Failed %s type: %s", pr, zn.message), pt(null));
          }
      }
    }
    var In = Array.isArray;
    function Cn(jn) {
      return In(jn);
    }
    function It(jn) {
      {
        var lr = typeof Symbol == "function" && Symbol.toStringTag, pr = lr && jn[Symbol.toStringTag] || jn.constructor.name || "Object";
        return pr;
      }
    }
    function ht(jn) {
      try {
        return Wt(jn), !1;
      } catch {
        return !0;
      }
    }
    function Wt(jn) {
      return "" + jn;
    }
    function hn(jn) {
      if (ht(jn))
        return W("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", It(jn)), Wt(jn);
    }
    var Vt = F.ReactCurrentOwner, Tn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rn, Nn, Dn;
    Dn = {};
    function xn(jn) {
      if (Et.call(jn, "ref")) {
        var lr = Object.getOwnPropertyDescriptor(jn, "ref").get;
        if (lr && lr.isReactWarning)
          return !1;
      }
      return jn.ref !== void 0;
    }
    function $n(jn) {
      if (Et.call(jn, "key")) {
        var lr = Object.getOwnPropertyDescriptor(jn, "key").get;
        if (lr && lr.isReactWarning)
          return !1;
      }
      return jn.key !== void 0;
    }
    function Kn(jn, lr) {
      if (typeof jn.ref == "string" && Vt.current && lr && Vt.current.stateNode !== lr) {
        var pr = ae(Vt.current.type);
        Dn[pr] || (W('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ae(Vt.current.type), jn.ref), Dn[pr] = !0);
      }
    }
    function ir(jn, lr) {
      {
        var pr = function() {
          Rn || (Rn = !0, W("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", lr));
        };
        pr.isReactWarning = !0, Object.defineProperty(jn, "key", {
          get: pr,
          configurable: !0
        });
      }
    }
    function er(jn, lr) {
      {
        var pr = function() {
          Nn || (Nn = !0, W("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", lr));
        };
        pr.isReactWarning = !0, Object.defineProperty(jn, "ref", {
          get: pr,
          configurable: !0
        });
      }
    }
    var br = function(jn, lr, pr, En, qn, Wn, kn) {
      var zn = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: jn,
        key: lr,
        ref: pr,
        props: kn,
        // Record the component responsible for creating this element.
        _owner: Wn
      };
      return zn._store = {}, Object.defineProperty(zn._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(zn, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: En
      }), Object.defineProperty(zn, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qn
      }), Object.freeze && (Object.freeze(zn.props), Object.freeze(zn)), zn;
    };
    function cs(jn, lr, pr, En, qn) {
      {
        var Wn, kn = {}, zn = null, wr = null;
        pr !== void 0 && (hn(pr), zn = "" + pr), $n(lr) && (hn(lr.key), zn = "" + lr.key), xn(lr) && (wr = lr.ref, Kn(lr, qn));
        for (Wn in lr)
          Et.call(lr, Wn) && !Tn.hasOwnProperty(Wn) && (kn[Wn] = lr[Wn]);
        if (jn && jn.defaultProps) {
          var jr = jn.defaultProps;
          for (Wn in jr)
            kn[Wn] === void 0 && (kn[Wn] = jr[Wn]);
        }
        if (zn || wr) {
          var Vr = typeof jn == "function" ? jn.displayName || jn.name || "Unknown" : jn;
          zn && ir(kn, Vr), wr && er(kn, Vr);
        }
        return br(jn, zn, wr, qn, En, Vt.current, kn);
      }
    }
    var Gn = F.ReactCurrentOwner, Jn = F.ReactDebugCurrentFrame;
    function Xn(jn) {
      if (jn) {
        var lr = jn._owner, pr = Zt(jn.type, jn._source, lr ? lr.type : null);
        Jn.setExtraStackFrame(pr);
      } else
        Jn.setExtraStackFrame(null);
    }
    var rr;
    rr = !1;
    function _r(jn) {
      return typeof jn == "object" && jn !== null && jn.$$typeof === e;
    }
    function Ss() {
      {
        if (Gn.current) {
          var jn = ae(Gn.current.type);
          if (jn)
            return `

Check the render method of \`` + jn + "`.";
        }
        return "";
      }
    }
    function is(jn) {
      {
        if (jn !== void 0) {
          var lr = jn.fileName.replace(/^.*[\\\/]/, ""), pr = jn.lineNumber;
          return `

Check your code at ` + lr + ":" + pr + ".";
        }
        return "";
      }
    }
    var Ms = {};
    function ls(jn) {
      {
        var lr = Ss();
        if (!lr) {
          var pr = typeof jn == "string" ? jn : jn.displayName || jn.name;
          pr && (lr = `

Check the top-level render call using <` + pr + ">.");
        }
        return lr;
      }
    }
    function Ur(jn, lr) {
      {
        if (!jn._store || jn._store.validated || jn.key != null)
          return;
        jn._store.validated = !0;
        var pr = ls(lr);
        if (Ms[pr])
          return;
        Ms[pr] = !0;
        var En = "";
        jn && jn._owner && jn._owner !== Gn.current && (En = " It was passed a child from " + ae(jn._owner.type) + "."), Xn(jn), W('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', pr, En), Xn(null);
      }
    }
    function Qr(jn, lr) {
      {
        if (typeof jn != "object")
          return;
        if (Cn(jn))
          for (var pr = 0; pr < jn.length; pr++) {
            var En = jn[pr];
            _r(En) && Ur(En, lr);
          }
        else if (_r(jn))
          jn._store && (jn._store.validated = !0);
        else if (jn) {
          var qn = L(jn);
          if (typeof qn == "function" && qn !== jn.entries)
            for (var Wn = qn.call(jn), kn; !(kn = Wn.next()).done; )
              _r(kn.value) && Ur(kn.value, lr);
        }
      }
    }
    function Fr(jn) {
      {
        var lr = jn.type;
        if (lr == null || typeof lr == "string")
          return;
        var pr;
        if (typeof lr == "function")
          pr = lr.propTypes;
        else if (typeof lr == "object" && (lr.$$typeof === E || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        lr.$$typeof === h))
          pr = lr.propTypes;
        else
          return;
        if (pr) {
          var En = ae(lr);
          Jt(pr, jn.props, "prop", En, jn);
        } else if (lr.PropTypes !== void 0 && !rr) {
          rr = !0;
          var qn = ae(lr);
          W("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", qn || "Unknown");
        }
        typeof lr.getDefaultProps == "function" && !lr.getDefaultProps.isReactClassApproved && W("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Lr(jn) {
      {
        for (var lr = Object.keys(jn.props), pr = 0; pr < lr.length; pr++) {
          var En = lr[pr];
          if (En !== "children" && En !== "key") {
            Xn(jn), W("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", En), Xn(null);
            break;
          }
        }
        jn.ref !== null && (Xn(jn), W("Invalid attribute `ref` supplied to `React.Fragment`."), Xn(null));
      }
    }
    var Hr = {};
    function ns(jn, lr, pr, En, qn, Wn) {
      {
        var kn = Ge(jn);
        if (!kn) {
          var zn = "";
          (jn === void 0 || typeof jn == "object" && jn !== null && Object.keys(jn).length === 0) && (zn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var wr = is(qn);
          wr ? zn += wr : zn += Ss();
          var jr;
          jn === null ? jr = "null" : Cn(jn) ? jr = "array" : jn !== void 0 && jn.$$typeof === e ? (jr = "<" + (ae(jn.type) || "Unknown") + " />", zn = " Did you accidentally export a JSX literal instead of a component?") : jr = typeof jn, W("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", jr, zn);
        }
        var Vr = cs(jn, lr, pr, qn, Wn);
        if (Vr == null)
          return Vr;
        if (kn) {
          var us = lr.children;
          if (us !== void 0)
            if (En)
              if (Cn(us)) {
                for (var Es = 0; Es < us.length; Es++)
                  Qr(us[Es], jn);
                Object.freeze && Object.freeze(us);
              } else
                W("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Qr(us, jn);
        }
        if (Et.call(lr, "key")) {
          var Dr = ae(jn), Kr = Object.keys(lr).filter(function(No) {
            return No !== "key";
          }), Js = Kr.length > 0 ? "{key: someKey, " + Kr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Hr[Dr + Js]) {
            var io = Kr.length > 0 ? "{" + Kr.join(": ..., ") + ": ...}" : "{}";
            W(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Js, Dr, io, Dr), Hr[Dr + Js] = !0;
          }
        }
        return jn === o ? Lr(Vr) : Fr(Vr), Vr;
      }
    }
    function Ts(jn, lr, pr) {
      return ns(jn, lr, pr, !0);
    }
    function en(jn, lr, pr) {
      return ns(jn, lr, pr, !1);
    }
    var to = en, bs = Ts;
    reactJsxRuntime_development.Fragment = o, reactJsxRuntime_development.jsx = to, reactJsxRuntime_development.jsxs = bs;
  }()), reactJsxRuntime_development;
}
api$1.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const GLOBAL_CONFIG = {
  /**
   * Root folder containing static files (e.g., wasm)
   */
  staticRoot: `${window.location.origin}/webapp-explore`
};
GLOBAL_CONFIG$1.staticRoot = GLOBAL_CONFIG.staticRoot;
async function createRenderer(r, e, s) {
  return await Renderer.create({
    container: r,
    cesium: {
      token: e
    },
    google: {
      token: s
    },
    draco: {
      moduleBaseUrl: "https://www.gstatic.com/draco/versioned/decoders/1.5.0/"
    },
    hb: {
      moduleUrl: `${GLOBAL_CONFIG.staticRoot}/hb.wasm`
    },
    ifc: {
      moduleBaseUrl: `${GLOBAL_CONFIG.staticRoot}/`
    },
    ktx2: {
      moduleBaseUrl: `${GLOBAL_CONFIG.staticRoot}/basis/`
    },
    workers: {
      moduleBaseUrl: `${GLOBAL_CONFIG.staticRoot}/`
    },
    cppSorter: {
      moduleBaseUrl: `${GLOBAL_CONFIG.staticRoot}/cpp-sorter/`
    },
    gdal: {
      moduleBaseUrl: GLOBAL_CONFIG.staticRoot
    }
  });
}
function ViewerCore({
  cesiumToken: r,
  googleToken: e,
  gameServerUrl: s = "https://explore-game-server.onrender.com"
}, o) {
  const a = require$$0$3.useRef(), l = require$$0$3.useRef([]), [u, c] = useState(null), [E, d] = useState(null), [f, h] = useState(null);
  return useEffect(() => (u && E && f === null && createRenderer(u, r, e).then((S) => {
    const R = new Draw2D(E), _ = new MeshBatch(S), m = new MeshInstance(S), L = new LabelManager(S, R), F = new Simulation(S);
    h({
      renderer: S,
      draw2D: R,
      meshBatch: _,
      meshInstance: m,
      labelManager: L,
      simulation: F
    }), new ResizeObserver(() => {
      const { offsetWidth: G, offsetHeight: q } = u, fe = new Vector2(G, q);
      S.setSize(fe), R.setSize(fe);
    }).observe(u);
  }), () => {
    f && a.current && (f.renderer.dispose(), cancelAnimationFrame(a.current));
  }), [f, r, u, E, e]), useImperativeHandle(
    o,
    () => {
      if (f === null)
        return null;
      const S = new UtilityService(f, l.current), R = new NavigationService(f), _ = new GlobeService(f, R), m = new DrawService(f, R, S), L = new ModelService(f, _), F = new TransformService(f, R), W = new ClippingService(f, R), G = new PanoramaService(f, S, R), q = new DeprojectService(f, R), fe = new VolumetricService(f), _e = new SectioningService(f), Le = new StatisticsService(f), Fe = new GameService(f, R, s), Ee = {
        utility: S,
        navigation: R,
        globe: _,
        draw: m,
        model: L,
        transform: F,
        clipping: W,
        panorama: G,
        deproject: q,
        volumetric: fe,
        sectioning: _e,
        statistics: Le,
        game: Fe
      };
      let Ge = performance.now();
      const ve = (te) => {
        const v = Math.min(Math.max(te - Ge, 0), 250) / 1e3;
        Ge = te;
        const Te = Object.values(Ee);
        for (const De of Te)
          De.updateFrame(v);
        f.renderer.render(), f.draw2D.render(), f.meshInstance.update(), f.labelManager.update(), f.simulation.step(v);
        for (const De of l.current)
          De();
        l.current.length = 0, a.current = window.requestAnimationFrame(ve);
      };
      return a.current = window.requestAnimationFrame(ve), Ee;
    },
    [s, f]
  ), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: c, className: "relative h-100% w-100%", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: `
          canvas {
            touch-action: none;
            position: absolute;
            top: 0;
            bottom: 0;
          }
        ` }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { ref: d, className: "pointer-events-none z-1 h-100% w-100%" })
  ] });
}
const Viewer = forwardRef(ViewerCore);
class ViewerHandle {
  constructor(e) {
    Qt(this, "api");
    Qt(this, "cesiumToken");
    Qt(this, "container2D");
    Qt(this, "container3D");
    Qt(this, "gameServerUrl");
    Qt(this, "googleToken");
    Qt(this, "modules");
    Qt(this, "resizeObserver");
    Qt(this, "animationRequest", null);
    Qt(this, "frameResolvers", []);
    Qt(this, "hasStarted", !1);
    this.cesiumToken = e.cesiumToken, this.container2D = e.container2D, this.container3D = e.container3D, this.gameServerUrl = e.gameServerUrl, this.googleToken = e.googleToken, this.modules = e.coreModules, this.api = this._createViewerApi(this.modules), this.resizeObserver = this._createResizeObserver(this.modules), this.resizeObserver.observe(this.container3D);
  }
  // kills the renderer, makes the viewer not functional anymore.
  stop() {
    this.resizeObserver.disconnect(), this.modules.renderer.dispose(), this.animationRequest !== null && cancelAnimationFrame(this.animationRequest);
  }
  start() {
    if (this.hasStarted) {
      console.warn("viewer has already started, skip starting");
      return;
    }
    this.hasStarted = !0;
    let e = performance.now();
    const s = (o) => {
      const l = Math.min(Math.max(o - e, 0), 250) / 1e3;
      e = o;
      const u = Object.values(this.api);
      for (const c of u)
        c.updateFrame(l);
      this.modules.renderer.render(), this.modules.draw2D.render(), this.modules.meshInstance.update(), this.modules.labelManager.update(), this.modules.simulation.step(l);
      for (const c of this.frameResolvers)
        c();
      this.frameResolvers.length = 0, this.animationRequest = window.requestAnimationFrame(s);
    };
    this.animationRequest = window.requestAnimationFrame(s);
  }
  _createViewerApi(e) {
    const s = new UtilityService(e, this.frameResolvers), o = new NavigationService(e), a = new GlobeService(e, o), l = new DrawService(e, o, s), u = new ModelService(e, a), c = new TransformService(e, o), E = new ClippingService(e, o), d = new PanoramaService(e, s, o), f = new DeprojectService(e, o), h = new VolumetricService(e), S = new SectioningService(e), R = new StatisticsService(e), _ = new GameService(e, o, this.gameServerUrl);
    return {
      utility: s,
      navigation: o,
      globe: a,
      draw: l,
      model: u,
      transform: c,
      clipping: E,
      panorama: d,
      deproject: f,
      volumetric: h,
      sectioning: S,
      statistics: R,
      game: _
    };
  }
  _createResizeObserver(e) {
    return new ResizeObserver(() => {
      const { offsetWidth: s, offsetHeight: o } = this.container3D, a = new Vector2(s, o);
      e.renderer.setSize(a), e.draw2D.setSize(a);
    });
  }
}
class ViewerHandleBuilder {
  constructor(e) {
    Qt(this, "cesiumToken");
    Qt(this, "gameServerUrl");
    Qt(this, "googleToken");
    this.cesiumToken = e.cesiumToken, this.gameServerUrl = e.gameServerUrl, this.googleToken = e.googleToken;
  }
  async build() {
    return await this._createViewerHandle(this._createContainers());
  }
  async _createViewerHandle(e) {
    const s = await createRenderer(e.container3D, this.cesiumToken, this.googleToken), o = new Draw2D(e.container2D), a = new MeshBatch(s), l = new MeshInstance(s), u = new LabelManager(s, o), c = new Simulation(s), E = {
      renderer: s,
      draw2D: o,
      meshBatch: a,
      meshInstance: l,
      labelManager: u,
      simulation: c
    };
    return new ViewerHandle({
      cesiumToken: this.cesiumToken,
      container2D: e.container2D,
      container3D: e.container3D,
      gameServerUrl: this.gameServerUrl,
      googleToken: this.googleToken,
      coreModules: E
    });
  }
  _createContainers() {
    const e = document.createElement("div");
    e.style.position = "relative", e.style.height = "100%", e.style.width = "100%";
    const s = document.createElement("canvas");
    return s.style.pointerEvents = "none", s.style.zIndex = "1", s.style.height = "100%", s.style.width = "100%", e.appendChild(s), { container2D: s, container3D: e };
  }
}
const ViewerV2 = ({ viewerHandle: r }) => {
  const e = useRef(null);
  return useEffect(() => {
    const s = e.current;
    return s && s.appendChild(r.container3D), () => {
      s && s.removeChild(r.container3D);
    };
  }, [r.container3D]), /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { display: "contents" }, ref: e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: `
          canvas {
            touch-action: none;
            position: absolute;
            top: 0;
            bottom: 0;
          }
        ` }) });
};
export {
  Cartographic$1 as Cartographic,
  CartographicTriangle,
  ClippingBoxTool,
  ClippingService,
  Clustering,
  DISC_INDICES,
  DISC_VERTICES,
  DeprojectService,
  Draw2D,
  DrawService,
  Ellipsoid$1 as Ellipsoid,
  Entity,
  EventRegister,
  FreeDrawController,
  GameService,
  GaussianSplat,
  GestureControl,
  GlobeService,
  IFC,
  Imagery,
  LabelManager,
  MeshBatch,
  MeshInstance,
  Model3D,
  ModelNode,
  ModelService,
  NavigationService,
  OBB,
  Panorama,
  PanoramaEditor,
  PanoramaService,
  PanoramaWalkthrough,
  PathType,
  PhotoCamera,
  PointTool,
  RING_INDICES,
  RING_VERTICES,
  RectDrawController,
  SceneNode,
  SectioningService,
  Service,
  Simulation,
  Sketch,
  StatisticsService,
  Terrain,
  Tileset,
  TransformService,
  TransformWidgetTool,
  UtilityService,
  Viewer,
  ViewerError,
  ViewerErrorCode,
  ViewerHandle,
  ViewerHandleBuilder,
  ViewerV2,
  VolumetricService,
  Widget,
  WidgetManager,
  areaToString,
  buildIndexedTriangles,
  buildTriangles,
  calculateAngle,
  calculateBestFitPlane,
  calculateCameraTargetPosition,
  calculateCartographicBasis,
  calculateCartographicQuaternion,
  calculateCentroid$1 as calculateCentroid,
  calculateContainerSphere,
  calculateCornerAngles,
  calculateEdgeHVLengths,
  calculateEdgeLengths,
  calculateElevation,
  calculateHVLengths,
  calculateLookAtFov,
  calculateLookAtRotation,
  calculateNadirOrientation,
  calculatePolygonArea,
  calculateVertexElevations,
  clipTriangle$1 as clipTriangle,
  computeLevelTriangleVolume,
  computePick,
  computePickNormal,
  computeSmartRefHeight,
  computeSmartTriangleVolume,
  computeTriangleVolume,
  computeTriangulatedRefHeight,
  computeTriangulatedTriangleVolume,
  computeVolumetrics,
  createRenderer,
  deserializeBufferAttribute,
  deserializeCartographic,
  deserializeGeometry,
  deserializeInterleavedAttribute,
  deserializeMatrix4,
  deserializeTriangle,
  deserializeVector3,
  isCameraVisible,
  isIntersectingSegments,
  isPointInCircle,
  isTriangleValid,
  lengthToString,
  projectToScreen,
  serializeBufferAttribute,
  serializeCartographic,
  serializeGeometry,
  serializeInterleavedAttribute,
  serializeMatrix4,
  serializeTriangle,
  serializeVector3,
  subdivideTriangleBisection,
  subdivideTriangleMidpoint,
  subdivideTriangleRecursively,
  toCartesian,
  toCartographic,
  toDegrees,
  toDigits,
  toEuler,
  toQuaternion,
  toRadians,
  triangulate$1 as triangulate,
  undistortImagePoint,
  volumeToString
};
//# sourceMappingURL=index.es.js.map
